(function () {
  'use strict';

  angular
    .module('app.controlpanel.central-reports-define-details-wizard', []);

})();

(function () {
  'use strict';

  /** @ngInject*/
  function WizardGroupingController($rootScope, $scope, DefineDetailsWizardService) {

    var vm = this;
    vm.selected_columns = [];
    vm.break_page = false;
    vm.has_break = false;
    vm.data = {
      "selected": null,
      "lists": {
        "available": [],
        "selected": []
      }
    };

    var ltn = $rootScope.$on('GO_TO_NEXT_STEP', function (ev, data) {
      vm.submit(data.current_step, null);
    });

    vm.init = function () {
      var available = DefineDetailsWizardService.getCopyColumns();
      var breaks = DefineDetailsWizardService.getBreak();
      vm.data.lists.available = DefineDetailsWizardService.array_diff(available, breaks);
      if (breaks.length > 0) {
        vm.data.lists.selected = breaks;
      }
    };

    /**
     * Evento de inicio do arrastar do item
     * @param list
     * @param event
     */
    $scope.onDragstart = function (list, event) {
      list.dragging = true;
      if (event.dataTransfer.setDragImage) {
        var img = new Image();
        img.src = ' ';
        event.dataTransfer.setDragImage(img, 0, 0);
      }
    };

    /**
     * Evento de clique do DragList
     */
    $scope.onItemDragSelected = function () {
      return false;
    };

    /**
     */
    $scope.onDragend = function () {
      vm.data.lists.available.forEach(function (item) {
        item.choice = false;
      });
      vm.data.lists.selected.forEach(function (item) {
        item.choice = true;
      })
    };


    vm.submit = function (step) {
      DefineDetailsWizardService.setBreak(vm.data.lists.selected);
      DefineDetailsWizardService.setStepSelected($scope.details.data.stepSelected);
      DefineDetailsWizardService.submitCurrentStep(step, 'filter');
      $scope.$emit('UPDATE_WIZARD_DATA');
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.controlpanel.central-reports-define-details-wizard')
    .controller('WizardGroupingController', WizardGroupingController)
})();
(function () {
  'use strict';

  /** @ngInject*/
  function WizardFilterController($rootScope, Restangular, $scope, $timeout, Common, DefineDetailsWizardService, Utils) {

    var vm = this;
    /** Para trocar as númerações deve também verificar o backend para modificação */
    var AND_CONDITION_ID = 999;
    var OR_CONDITION_ID = 99;
    /** END */
    vm.data_list = [];
    vm.data = {
      "selected": null,
      "lists": {
        "available": [],
        "selected": []
      }
    };

    vm.months = Utils.months();

    vm.models = {
      selected: null,
      templates: [
        {type: "container", label: 'Condição E', id: AND_CONDITION_ID, columns: [[]]},
        {type: "container", label: 'Condição OU', id: OR_CONDITION_ID, columns: [[]]},
        {type: "item", id: 3}
      ],
      dropzones: {
        "general": []
      }
    };

    vm.operators_numeric_string_time = [
      {"name": "igual a", "value": "="},
      {"name": "diferente de", "value": "<>"},
      {"name": "Na faixa entre", "value": "between"},
      {"name": "maior que", "value": ">"},
      {"name": "menor que", "value": "<"},
      {"name": "maior ou igual que", "value": ">="},
      {"name": "menor ou igual que", "value": "<="},
      {"name": "está preenchido", "value": "=NN"},
      {"name": "não está preenchido", "value": "=N"}
    ];


    vm.operators_list = [
      {"name": "igual a", "value": "="},
      {"name": "está preenchido", "value": "=NN"},
      {"name": "não está preenchido", "value": "=N"}
    ];

    vm.operators_boolean = [
      {"name": "Sim", "value": "1"},
      {"name": "Não", "value": "0"}
    ];

    vm.operators_date_datetime = [
      {"name": "igual a", "value": "="},
      {"name": "diferente de", "value": "<>"},
      {"name": "Na faixa entre", "value": "between"},
      {"name": "A partir de ", "value": ">="},
      {"name": "Até", "value": "<="},
      {"name": "Depois de", "value": ">"},
      {"name": "Antes de", "value": "<"},
      {"name": "Número do dia", "value": "=D"},
      {"name": "Número do mês", "value": "=M"},
      {"name": "Número do ano", "value": "=Y"},
      {"name": "está preenchido", "value": "=NN"},
      {"name": "não está preenchido", "value": "=N"}
    ];

    vm.report_on_print = false;
    vm.operator = null;
    vm.filter_value_start = '';
    vm.filter_value_end = '';
    vm.filters = [];

    var ltn = $rootScope.$on('GO_TO_FINISH', function () {
      vm.submit();
    });

    vm.init = function () {
      vm.data.lists.available = DefineDetailsWizardService.getCopyColumns();
      var filters = DefineDetailsWizardService.getFilters();
      if (angular.isDefined(filters.general) && filters.general.length > 0) {
        vm.models.dropzones = filters;
      }
    };


    /**
     * Busca dados de select box pela url passada
     * @param item
     */
    vm.getDataFromRequestRoute = function (item) {
      var url = item.request_route;
      Restangular.one(url).get()
        .then(function (response) {
          item.data_list = response.plain();
        })
    };

    /**
     * Adiciona um novo item as condições de filtragem
     */
    vm.addFilter = function () {

      if (vm.data.selected == null || vm.operator == null) {
        return;
      }

      var obj = {
        type: "item",
        column: vm.data.selected, report_on_print: vm.report_on_print,
        operator: vm.operator, filter_value_start: vm.filter_value_start === 0 ? '0' : vm.filter_value_start,
        filter_value_end: vm.filter_value_end === 0 ? '0' : vm.filter_value_end
      };

      vm.models.dropzones.general.push(obj);
      DefineDetailsWizardService.setFilters(vm.models.dropzones);
      vm.filters.push(obj);
      vm.cleanFilter();
    };

    /**
     * Limpa os item preenchidos no filtro
     */
    vm.cleanFilter = function () {
      vm.data.selected = null;
      vm.report_on_print = false;
      vm.operator = null;
      vm.filter_value_start = '';
      vm.filter_value_end = '';
    };


    /**
     * Evento de clique do DragList
     */
    $scope.onItemDragSelected = function () {
      return false;
    };

    /**
     * Evento de clique do DragList
     */
    vm.onItemSelectedFilter = function (event, item) {
      vm.cleanFilter();
      vm.data.selected = item;
      vm.setOperators(item.type);

      return true;
    };

    /**
     * define os operadores do filtro
     */
    vm.setOperators = function (type) {
      switch (type) {
        case ('integer' || 'smallint' || 'bigint' || 'serial' || 'bigserial' || 'numeric' || 'decimal' || 'varchar' || 'char' || 'text' || 'time' || 'double'):
          vm.operators = vm.operators_numeric_string_time;
          break;
        case 'boolean':
          vm.operators = vm.operators_boolean;
          break;
        case 'date' || 'datetime':
          vm.operators = vm.operators_date_datetime;
          break;
        case 'list':
          vm.operators = vm.operators_list;
          vm.operator = vm.operators_list[0];
          break;
        default:
          vm.operators = vm.operators_numeric_string_time;
      }
    };

    /**
     * Evento de clique do DragList
     */
    vm.onDropFilterItem = function (list, item) {
      DefineDetailsWizardService.setFilters(vm.models.dropzones);
      return item;
    };

    /**
     * Ao jogar um item na lixeira altera attributos do icone
     */
    vm.onTrashItem = function () {
      var icon = angular.element('.icon-trash-filter');
      icon.css({"color": 'red'});

      $timeout(function () {
        icon.css({"color": 'gray'});
      }, 500);

      return true;
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.controlpanel.central-reports-define-details-wizard')
    .controller('WizardFilterController', WizardFilterController)
})();
(function () {
  'use strict';

  /** @ngInject*/
  function WizardDescriptionController($rootScope, $scope, Common, DefineDetailsWizardService) {

    var vm = this;
    vm.type = 1; //inicializa o tipo como detalhado
    vm.master = ''; //inicializa a master como todos
    vm.name = '';

    var ltn = $rootScope.$on('GO_TO_NEXT_STEP', function (ev, data) {
      vm.submit(data.current_step, null);
    });

    vm.init = function () {
      vm.name = DefineDetailsWizardService.getName();
      vm.master = DefineDetailsWizardService.getMaster();
      DefineDetailsWizardService.setMaster(vm.master);
      vm.is_detailed = DefineDetailsWizardService.getType();
    };

    vm.masters = [
      {"id": 'allresources', "name": "Todos"},
      {"id": 'bill_incomes', "name": "Títulos a receber"},
      {"id": 'bill_expenses', "name": "Títulos a pagar"},
      {"id": 'students', "name": "Alunos"},
      {"id": 'collaborators', "name": "Colaboradores"},
      {"id": 'teacher', "name": "Professores"},
      {"id": 'responsables', "name": "Responsáveis"}
    ];

    vm.setColumns = function () {
      DefineDetailsWizardService.clear();
      DefineDetailsWizardService.setMaster(vm.master);
    };

    vm.setName = function (name) {
      if (angular.isDefined(name) && name !== '' && name !== null) {
        DefineDetailsWizardService.setName(name);
      }
    };

    vm.setType = function (val) {
      DefineDetailsWizardService.setType(val)
    };

    vm.submit = function (step, form) {
      if (form == null || (form != null && form.$valid)) {

        if (vm.name == null || vm.name === '') {
          Common.$q.warning('Defina um nome para o relatório');
          return;
        }

        if (vm.name == null || vm.master === '') {
          Common.$q.warning('Defina uma tabela principal para o relatório');
          return;
        }
        DefineDetailsWizardService.setName(vm.name);
        DefineDetailsWizardService.setStepSelected($scope.details.data.stepSelected);
        DefineDetailsWizardService.submitCurrentStep(step, 'columns');
        $scope.$emit('UPDATE_WIZARD_DATA');
      }
    };


    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.controlpanel.central-reports-define-details-wizard')
    .controller('WizardDescriptionController', WizardDescriptionController)
})();
(function () {
  'use strict';

  /** @ngInject*/
  function WizardColumnsController($rootScope, $scope, DefineDetailsWizardService) {

    var vm = this;

    vm.data = {
      "selected": null,
      "lists": {
        "available": [],
        "selected": []
      }
    };


    var ltn = $rootScope.$on('GO_TO_NEXT_STEP', function (ev, data) {
      vm.submit(data.current_step, null);
    });

    vm.init = function () {
      var available = DefineDetailsWizardService.getCopyColumns();
      var columns = DefineDetailsWizardService.getColumns();
      vm.data.lists.available = DefineDetailsWizardService.array_diff(available, columns);
      if (columns.length > 0) {
        vm.data.lists.selected = columns;
      }
    };

    vm.submit = function (step) {
      DefineDetailsWizardService.setColumns(vm.data.lists.selected);
      DefineDetailsWizardService.setStepSelected($scope.details.data.stepSelected);
      DefineDetailsWizardService.submitCurrentStep(step, 'classification');
      $scope.$emit('UPDATE_WIZARD_DATA');
    };

    /**
     * Função disparada no evento de inicio do arrastar do item;
     * @param list
     * @param event
     */
    $scope.onDragstart = function (list, event) {
      list.dragging = true;
      if (event.dataTransfer.setDragImage) {
        var img = new Image();
        img.src = ' ';
        event.dataTransfer.setDragImage(img, 0, 0);
      }
      DefineDetailsWizardService.setColumns(vm.data.lists.selected);
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.controlpanel.central-reports-define-details-wizard')
    .controller('WizardColumnsController', WizardColumnsController)
})();
(function () {
  'use strict';

  /** @ngInject*/
  function WizardClassificationController($rootScope, $scope, Common, DefineDetailsWizardService) {

    var vm = this;
    vm.data = {
      "selected": null,
      "lists": {
        "available": [],
        "selected": []
      }
    };
    vm.selected_columns = [];
    vm.buttonStates = [
      {textButton: 'Crescente', background: '#7cb342', color: 'white', value: 'asc'},
      {textButton: 'Decrescente', background: '#ed4003', color: 'white', value: 'desc'}
    ];

    var ltn = $rootScope.$on('GO_TO_NEXT_STEP', function (ev, data) {
      vm.submit(data.current_step, null);
    });

    vm.init = function () {
      var available = DefineDetailsWizardService.getCopyColumns();
      var order = DefineDetailsWizardService.getOrder();
      vm.data.lists.available = DefineDetailsWizardService.array_diff(available, order);
      if (order.length > 0) {
        vm.data.lists.selected = order;
      }
    };

    /**
     * Evento de inicio do arrastar do item
     * @param list
     * @param event
     */
    $scope.onDragstart = function (list, event) {
      list.dragging = true;
      if (event.dataTransfer.setDragImage) {
        var img = new Image();
        img.src = ' ';
        event.dataTransfer.setDragImage(img, 0, 0);
      }
    };

    /**
     * Evento de clique do DragList
     */
    $scope.onItemDragSelected = function () {
      return false;
    };

    /**
     * Ao soltar o item são iniciados os valores de definição das colunas
     */
    $scope.onDragend = function () {
      vm.data.lists.available.forEach(function (item) {
        item.choice = false;
      });
      vm.data.lists.selected.forEach(function (item) {
        item.choice = true;
        item.direction = 'asc';
      })
    };

    /**
     * Criação de JSON
     * @param step
     */
    vm.submit = function (step) {
      DefineDetailsWizardService.setOrder(vm.data.lists.selected);
      DefineDetailsWizardService.setStepSelected($scope.details.data.stepSelected);
      DefineDetailsWizardService.submitCurrentStep(step, 'grouping');
      $scope.$emit('UPDATE_WIZARD_DATA');
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.controlpanel.central-reports-define-details-wizard')
    .controller('WizardClassificationController', WizardClassificationController)
})();
(function () {
  'use strict';

  angular
    .module('app.finance.guest-check-pad', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function GuestCheckPad($translateProvider) {

    $translateProvider.translations('pt', {
      "GUEST_CHECK_PAD": {
        'NEW' : 'Nova Comanda para     ',
        'SELECT_PERSON': 'Selecione o cliente'
      }
    })

  }

  angular
    .module('app.finance.guest-check-pad')
    .config(GuestCheckPad);
})();

(function() {
  'use strict';
  angular
    .module('app.educational.finance-enrolment', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  /** @ngInject */
  function FinanceEnrolmentPaymentPlanController($state, $stateParams, $filter, $rootScope, a4Moment, $scope, Common,
                                                 EnrolmentService, StudentsService, BillReceiptService) {

    var vm = this;

    vm.hasPaymentPlan = true;
    vm.frequency_options = BillReceiptService.getFrequencyOptions();
    vm.preferencial_due_day_list = BillReceiptService.range();
    vm.student_contracts = [];
    vm.list = {
      contract: {
        payment_plan_id: [],
        discounts_rule_id: null,
        fines_rule_id: null
      }
    };

    var ltn = $rootScope.$on('ENROLMENT.HAS_PAYMENT_PLAN', function (ev, has_payment_plan) {
      vm.hasPaymentPlan = has_payment_plan;
      $scope.enrolment.steps.end.disabled = !has_payment_plan;
    });

    /**
     *
     */
    vm.init = function () {
      vm.group_id = $stateParams.group_id;
      vm.course_id = $stateParams.course_id;
      vm.person_id = $stateParams.id;
      vm.contract_type = $stateParams.contract_type;
      vm.matrix_period = $stateParams.matrix_period;
    };


    /**
     * Volta para a lista de alunos aguardando matrícula financeira
     */
    vm.backToList = function () {
      $state.go('private.educational.finance-enrolment.list');
    };

    /**
     * Devolve a próxima data de vencimento para as parcelas
     * @param payment_plan
     * @returns {*}
     */
    vm.getNextDate = function (payment_plan) {
      var copy_plan = angular.copy(payment_plan);
      var len = $scope.enrolment.contract.payment_installments.length;
      var last_date = len > 0 ? $scope.enrolment.contract.payment_installments[len - 1].due_date : copy_plan.date_first;
      var frequency_value = $filter('filter')(vm.frequency_options, {id: copy_plan.frequency})[0].value;
      var date = a4Moment(last_date);

      if (len > 0) {
        date.add(copy_plan.frequency_qty, frequency_value)
      }

      return date;
    };

    vm.changeDueDay = function (new_day) {
      $scope.enrolment.contract.payment_installments.forEach(function (item) {
        item.due_date.set('date', new_day);
      })
    };

    vm.init();

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });
  }

  angular.module('app.educational.finance-enrolment')
    .controller('FinanceEnrolmentPaymentPlanController', FinanceEnrolmentPaymentPlanController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function FinanceEnrolmentEndController($state, $stateParams, $document, $filter, $rootScope, $scope, Common, CONFIG, EnrolmentService, SettingsService,
                                         Session, ReportsService, StudentsService) {

    var vm = this;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.WEB_CONST = CONFIG.webApiUri;
    vm.bill_serie_id = null;

    vm.init = function () {
      SettingsService.getEnrolmentConfiguration()
        .then(function (response) {
          vm.enrolment_config = response.plain();
        });
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      $scope.enrolment.contract.person_id_beneficiary = $scope.enrolment.student.id;
      $scope.enrolment.contract.debit_credit = 'C';
      $scope.enrolment.contract.status = 1;
      $scope.enrolment.contract.end_of_recurrence = 0;
      $scope.enrolment.contract.type = 1;
      $scope.enrolment.contract.due_date = $scope.enrolment.contract.date_first;
      $scope.enrolment.contract.course_id = $scope.enrolment.student.course_id;
      $scope.enrolment.contract.group_id = $scope.enrolment.student.group_id;
      $scope.enrolment.contract.name = $scope.enrolment.student.name;
      $scope.enrolment.contract.dob = $scope.enrolment.student.dob;
      $scope.enrolment.contract.national_id_number = $scope.enrolment.student.national_id_number;
      $scope.enrolment.contract.enrolment_wizard_step = null;
    };

    /**
     * Altera o status da matrícula para aguardando pagamento e finaliza, redirecionando para a tela de alunos.
     */
    vm.finishFinanceEnrolment = function () {
      $rootScope.show_loader = true;
      $scope.enrolment.contract.matrix_period = $stateParams.matrix_period;
      EnrolmentService.setStatusForWaitingForPayment($scope.enrolment.contract).then(function (response) {
        if (response) {
          Common.Toast.success("Matrícula financeira finalizada com sucesso!");
          $state.go('private.educational.students.list');
        }
      })
    };

    /**
     * Altera o status para "aguardando confirmação online"
     */
    vm.finishOnline = function(){
      $rootScope.show_loader = true;
      $scope.enrolment.contract.matrix_period = $stateParams.matrix_period;
      EnrolmentService.setStatusForWaitingOnlineEnrolment($scope.enrolment.contract)
        .then(function () {
          Common.Toast.success("Matrícula financeira finalizada com sucesso!");
          $state.go('private.educational.students.list');
        })
    };

    vm.printBankSlip = function () {
      $rootScope.show_loader = true;
      EnrolmentService.printBankSlip($scope.enrolment.student.person_id_payee, $scope.enrolment.student.id, $scope.enrolment.contract.name)
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.warning('Erro ao gerar boletos');
        })
    };

    vm.printPaymentBook = function () {
      $rootScope.show_loader = true;
      StudentsService.getStudentContracts({
        id: $scope.enrolment.student.id,
        withSchoolPeriod: true
      })
        .then(function (response) {
          vm.student_contracts = response.plain();
          for (var i = vm.student_contracts.length; i--;) {
            if (vm.student_contracts[i].external_id !== null) {
              vm.bill_serie_id = vm.student_contracts[i].bill_serie_id;
            }
          }
          if (vm.bill_serie_id !== null) {
            var href = vm.WEB_CONST + 'api/contract/printpaymentbookcontract?token=' + vm.conf.token +
              '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
              '&bill_serie_id=' + vm.bill_serie_id + '&school_period_id=' + $scope.enrolment.student.school_period_id;
            var element = document.createElement('a');
            element.setAttribute('href', href);
            element.setAttribute('target', '_blank');
            $rootScope.show_loader = false;
            return element.click();
          }
          $rootScope.show_loader = false;
        })
    };

    vm.printContract = function () {
      $rootScope.show_loader = true;
      EnrolmentService.printEnrolmentContract({
        person_id: $scope.enrolment.student.id,
        group_id: $scope.enrolment.contract.group_id
      })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    vm.init();

  }

  angular.module('app.educational.finance-enrolment')
    .controller('FinanceEnrolmentEndController', FinanceEnrolmentEndController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function FinanceEnrolmentDiscountsController($state, $rootScope, $scope, Common, StudentsService, ModalFactory) {

    var vm = this;
    /**
     * Criação de desconto individual
     */
    vm.createNewIndivialDiscount = function () {
      ModalFactory.customClean(
        'app/finance/individual-discounts/views/individual-discounts.html',
        'IndividualDiscountsController',
        'vm',
        true,
        {theme: 'educational'}
      ).then(function (discount) {
        if (discount !== 'canceled') {
          $scope.enrolment.contract.individual_discounts.push(discount);
        }

      })
    };

    /**
     * Remove um desconto da lista
     */
    vm.removeItemDesconto = function (index) {
      $scope.enrolment.contract.individual_discounts.splice(index, 1);
    };

  }

  angular.module('app.educational.finance-enrolment')
    .controller('FinanceEnrolmentDiscountsController', FinanceEnrolmentDiscountsController)
})();
(function () {
  'use strict';

  angular
    .module('app.educational.enrolment', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function SubjectStepController($rootScope, $scope, $filter, $timeout, Common, SubjectService, EnrolmentService, StudentsService,
                                 Session) {
    var vm = this;
    vm.blockNext = true;
    vm.show_grid = false;
    vm.init = function () {
      StudentsService.getById($scope.enrolment.form.student.id, false, $scope.enrolment.form.timetable.matrix_period, $scope.enrolment.form.timetable.group_id)
        .then(function (response) {
          vm.show_grid = true;
          vm.person_id = response.person.id;
          vm.course_id = response.person.course_id;
          vm.group_id = response.person.group_id;
          vm.school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
          vm.course_equivalence_id = response.person.course_equivalence_id;
          vm.course_enrolment_system_id = response.person.course_enrolment_system_id;
          vm.enrolment_period_id = response.person.enrolment_period_id;
          vm.matrix_period = $scope.enrolment.form.timetable.matrix_period;
        });
      if ($scope.enrolment.list.subject && !$scope.enrolment.steps.subject.disabled) {
        vm.timetable();
      }
    };


    /**
     * Resgata todos as disciplinas disponiveis para matricula
     */
    vm.getSubjects = function () {
      SubjectService.getSubjectsForEnrolment({group_id: $scope.enrolment.form.timetable.group_id})
        .then(function (response) {
          $scope.enrolment.list.subject.search = [];
          var list = response.plain();
          angular.forEach(list, function (value) {
            $scope.enrolment.list.subject.search.push(value);
          });
          $rootScope.show_loader = false;
        })
        .catch(function (error) {
          Common.Toast.error(error.message);
          $rootScope.show_loader = false;
        })
    };


    /**
     * Ajusta tabela de horario para montagem de disciplinas
     */
    vm.timetable = function () {
      $rootScope.show_loader = true;
      $timeout(function () {
      var course_id = $scope.enrolment.form.timetable.course_id;
      var group_id = $scope.enrolment.form.timetable.group_id;

      if (course_id != null && group_id != null) {
        EnrolmentService.getSubjectScheduleGrade(course_id, group_id)
          .then(function (schedules) {
            if (angular.isUndefined($scope.enrolment.form.subject.id)) {
              $scope.enrolment.form.subject.id = schedules.plain();
            }
            vm.getSubjects();
            $rootScope.show_loader = false;
          })
          .catch(function (error) {
            Common.Toast.error(error.message);
            $rootScope.show_loader = false;
          });
      }
      }, 3000);
    };


    /**
     * Verifica de existe matricula em pelo menos uma materia
     */
    vm.verifyEnrolment = function () {
      vm.blockNext = true;
      if (angular.isDefined($scope.enrolment.form.subject.id)) {
        vm.blockNext = findEnrolment($scope.enrolment.form.subject.id).length === 0;
      }
      return vm.blockNext;
    };

    /**
     * Busca o item de matricula
     * @param list
     * @return {Array}
     */
    var findEnrolment = function (list) {
      var listItem = [];
      list.forEach(function (item) {
        vm.blockNext = item.schedule_subject.find(function (item2) {
          return angular.isDefined(item2.subject_id) ? item2 : false;
        });
        if (angular.isDefined(vm.blockNext)) {
          listItem.push(vm.blockNext);
        }
      });

      return listItem;
    };

    vm.enableNextStep = function () {
      $scope.enrolment.steps.documents.disabled = false;
    };
    vm.init();

  }


  angular.module('app.educational.enrolment')
    .controller('SubjectStepController', SubjectStepController)

})();
(function () {
  'use strict';

  /** @ngInject */
  function StudentStepController($rootScope, $scope, EnrolmentService, $timeout, ResponsiblesService, PersonService,
                                 StudentsService, a4Moment, $q, $window) {
    var vm = this;
    $rootScope.show_loader = false;
    vm.person = {};
    vm.blockFormEmail = false;
    vm.enrolment = {};
    vm.searchText_place_of_birth = '';
    vm.searchText_state_of_birth = '';
    vm.waiting_city = false;

    vm.enableNextStep = function () {
      if ($scope.enrolment.form.student.person_profession_id === null && vm.searchTextProfession !== null) {
        $scope.enrolment.form.student.new_profession_name = vm.searchTextProfession;
      }
      if ((angular.isUndefined($scope.enrolment.form.student.state_of_birth) || $scope.enrolment.form.student.state_of_birth === null)
        && vm.searchText_state_of_birth !== '') {
        $scope.enrolment.form.student.state_of_birth = vm.searchText_state_of_birth;
      }
      if ((angular.isUndefined($scope.enrolment.form.student.place_of_birth) || $scope.enrolment.form.student.place_of_birth === null)
        && vm.searchText_place_of_birth !== '') {
        $scope.enrolment.form.student.place_of_birth = vm.searchText_place_of_birth;
      }
      if ($scope.enrolment.form.timetable.course_enrolment_system_id === 2) {
        $scope.enrolment.steps.subject.disabled = false;
      } else {
        $scope.enrolment.steps.documents.disabled = false;
      }
    };

    vm.init = function () {
      vm.getFormInfo();
    };

    vm.getProfessions = function (query) {
      return ResponsiblesService.getProfessionsByQuery({query: query});
    };

    vm.changeProfession = function (item) {
      $scope.enrolment.form.student.person_profession_id = item === null ? null : item.id;
    };

    /**
     * Busca informações necessarias para o form
     */
    vm.getFormInfo = function () {
      if ($scope.enrolment.form.student == null) {
        $scope.enrolment.form.student = {};
      }
      $scope.enrolment.form.student.name = $scope.enrolment.form.search_text;
      if ($scope.enrolment.form.student !== null && angular.isDefined($scope.enrolment.student_id)) {
        vm.getById($scope.enrolment.student_id);
      }

      /*EnrolmentService.getEnrolmentFormInfo()
        .then(function (response) {
          var resp = response.plain();
          vm.person = resp.person;
          vm.person_student = resp.person_student;
          $rootScope.show_loader = false;
        });*/
    };

    vm.getById = function (student_id) {
      $rootScope.show_loader = true;
      StudentsService.getById(student_id, true)
        .then(function (person) {
          $scope.enrolment.form.student = person.person;
          $scope.enrolment.form.student = angular.extend($scope.enrolment.form.student, person.person_student);
          $scope.enrolment.form.student.is_independent = angular.isUndefined(person.person_student) ? false : person.person_student.is_independent;
          $scope.enrolment.form.student.dob = a4Moment($scope.enrolment.form.student.dob, 'YYYY-MM-DD');
          $scope.enrolment.personSelected = person;
          $scope.enrolment.student.idOfDocuments = person.person.documents;
          var person_id = (angular.isDefined($scope.enrolment.form.student.id)) ? $scope.enrolment.form.student.id : null;
          $scope.enrolment.getPersonResponsableLegal(person_id, null, true);
          $scope.$applyAsync();
          $rootScope.show_loader = false;
          $timeout(function () {
            if ($scope.enrolment.form.student.person_profession_id) {
              for (var i = vm.person.person_profession_id.length; i--;) {
                if (vm.person.person_profession_id[i].id === $scope.enrolment.form.student.person_profession_id) {
                  vm.selected_profession = vm.person.person_profession_id[i];
                }
              }
            }
            $rootScope.show_loader = false;
          }, 1000);
        });
    };

    /**
     * Busca de estado de nascimento
     * @param filterText
     * @returns {*}
     */
    vm.getStateBirth = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        filteredItems = vm.person.state_of_birth.filter(function (item) {
          return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
        });
      } else {
        filteredItems = vm.person.state_of_birth;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Busca de cidade de nascimento
     * @param filterText
     * @returns {*}
     */
    vm.getPlaceBirth = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        filteredItems = vm.person.place_of_birth.filter(function (item) {
          return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
        });
      } else {
        filteredItems = vm.person.place_of_birth;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Define a cidade de nascimento
     * @param item
     */
    vm.setPlaceBirth = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.name)) {
        $scope.enrolment.form.student.place_of_birth = item.name;
      }
    };

    /**
     * Realiza a troca dos dados do select de cidade baseada no estado selecionado
     * @param state_of_birth - estado item selecionado
     */
    vm.changeStateBirth = function (state_of_birth) {
      vm.waiting_city = true;

      if (angular.isDefined(state_of_birth) && angular.isDefined(state_of_birth.id)) {
        $scope.enrolment.form.student.state_of_birth = state_of_birth.id;
      } else if (vm.searchText_state_of_birth !== null && vm.searchText_state_of_birth !== '' && vm.searchText_state_of_birth.length === 2) {
        $scope.enrolment.form.student.state_of_birth = vm.searchText_state_of_birth;
      }
      var state = $scope.enrolment.form.student.state_of_birth;
      PersonService.getCities(state)
        .then(function (response) {
          vm.waiting_city = false;
          vm.person.place_of_birth = response.plain();
          var city = $window.document.getElementById('autocomplete_place_of_birth');
          if (city !== null && angular.isDefined(city)) {
            city.focus();
          }
        })
        .catch(function () {
          vm.waiting_city = false;
        })
    };

    /**
     * escuta se houve erro na informação do cpf
     * */
    $rootScope.$on('cpfErrorChanged', function(event, param) {
      $scope.enrolment.form.student.cpf_error = param;
    });

    vm.init();
  }

  angular.module('app.educational.enrolment')
    .controller('StudentStepController', StudentStepController)

})();

(function () {
  'use strict';

  /** @ngInject */
  function ResponsiblesStepController($rootScope, $scope, Common, EnrolmentService, ModalFactory, ResponsiblesService,
                                      $timeout, $filter) {
    var vm = this;
    vm.payee_id = null;
    vm.responsible_id = null;
    vm.has_father = false;
    vm.has_mother = false;

    vm.list = {
      person_relation: {
        search: [],
        person_relation_type_id: []
      }
    };

    $scope.$watch('enrolment.form.person_relation.person_id_relation', function () {
      vm.verifyFatherAndMother();
    }, true);

    vm.hasPayee = false;
    vm.hasResponsible = false;
    /**
     * Executa a criação dos responsáveis
     * @param name
     * @param data - Objeto já editado, em caso de cancelar o cancelamento do processo de matricula
     * ele deve restaurar o assistente com os dados já imputados
     */
    vm.createResponsibles = function (name, data) {
      $rootScope.$broadcast('ModalFactory.close');
      ModalFactory.customClean(
        'app/educational/students/parents/views/responsibles-wizard.html',
        'ParentsAssistantController',
        'vm', false, {
          student_id: data.student.id,
          group_id: data.timetable.group_id,
          name: name,
          enrolment: true
        }
      ).then(function () {
        vm.getPersonResponsableLegal(data.student.id, null);
      });
    };

    vm.editResponsible = function (item) {
      $rootScope.show_loader = true;
      ResponsiblesService.getById(item.id).then(function (response) {
        $rootScope.show_loader = false;
        ModalFactory.customClean(
          'app/educational/students/parents/views/responsibles-wizard.html',
          'ParentsAssistantController',
          'vm', false, {
            is_edit: 1,
            responsible: response.person
          });
      });
    };

    vm.verifyFatherAndMother = function () {
      var has_father = false;
      var has_mother = false;
      for (var i = 0; i < $scope.enrolment.form.person_relation.person_id_relation.length; i++) {
        if ($scope.enrolment.form.person_relation.person_id_relation[i].person_relation_type_id === 1 &&
          $scope.enrolment.form.person_relation.person_id_relation[i].person_sex_id === 'F') {
          has_mother = true;
        }
        if ($scope.enrolment.form.person_relation.person_id_relation[i].person_relation_type_id === 1 &&
          $scope.enrolment.form.person_relation.person_id_relation[i].person_sex_id === 'M') {
          has_father = true;
        }
      }
      vm.has_mother = has_mother;
      vm.has_father = has_father;
    };


    /** Evento para realizar a busca dos responsáveis disponíveis para vincular o estudante */
    var ltn = $rootScope.$on('person_relation_person_id_relation_change', function (ev, text) {
      var person_id = (angular.isDefined($scope.enrolment.form.person.id)) ? $scope.enrolment.form.person.id : null;
      vm.getPersonResponsableLegal(person_id, text, false);
    });

    vm.enableNextStep = function () {
      $scope.enrolment.steps.address.disabled = false;
    };

    vm.noCheckCPF = function () {
      EnrolmentService.isCheckCpf({
        group_id: $scope.enrolment.form.timetable.group_id
      }).then(function (resp) {
        $scope.enrolment.form.student.no_cpf_check = resp.no_cpf_check
      })
    }

    vm.init = function () {
      $scope.enrolment.form.student.matrix_period = $scope.enrolment.form.timetable.matrix_period;
      vm.person_id = (angular.isDefined($scope.enrolment.form.person.id)) ? $scope.enrolment.form.person.id : $scope.enrolment.form.student.id;
      vm.group_id = (angular.isDefined($scope.enrolment.form.timetable.group_id)) ? $scope.enrolment.form.timetable.group_id : $scope.enrolment.form.person.group_id;
      vm.matrix_period = (angular.isDefined($scope.enrolment.form.timetable.matrix_period)) ? $scope.enrolment.form.timetable.matrix_period : $scope.enrolment.form.person.matrix_period;
      $timeout(function () {
        vm.getPersonRelationLegal();
        vm.noCheckCPF();
        vm.getPersonResponsableLegal($scope.enrolment.form.student.id, null);
      }, 3000);
    };

    /**
     * Resgata possiveis responsáveis pelo aluno
     */
    vm.getPersonResponsableLegal = function (id, query) {
      $rootScope.show_loader = true;
      EnrolmentService.getPersonResponsableLegal({
        id: id,
        query: query,
        group_id: angular.isDefined($scope.enrolment.new_item) ? $scope.enrolment.new_item.timetable.group_id : $scope.enrolment.form.student.group_id
      })
        .then(function (response) {
          vm.list.person_relation.search = response.list;
          if ($scope.enrolment.form.person_relation.person_id_relation.length === 0) {
            $scope.enrolment.form.person_relation.person_id_relation = response.data;
          } else {
            response.data.forEach(function (item) {
              if ($filter('filter')($scope.enrolment.form.person_relation.person_id_relation, {id: item.id}).length <= 0) {
                $scope.enrolment.form.person_relation.person_id_relation.push(item);
              }
            });
            // angular.extend($scope.enrolment.form.person_relation.person_id_relation, response.data)
          }

          /**
           * Realiza os tratamentos para quando o checkbox já vem com o responsável marcado.
           */
          for (var i = 0; i < $scope.enrolment.form.person_relation.person_id_relation.length; i++) {
            if ($scope.enrolment.form.person_relation.person_id_relation[i].is_responsible === true) {
              vm.hasResponsible = true;
              vm.responsible_id = $scope.enrolment.form.person_relation.person_id_relation[i].id;
              $scope.enrolment.form.person_relation.person_id_relation[i].id = vm.responsible_id;
            }
            if ($scope.enrolment.form.person_relation.person_id_relation[i].is_payee === true) {
              vm.hasPayee = true;
              vm.payee_id = $scope.enrolment.form.person_relation.person_id_relation[i].id;
              $scope.enrolment.form.person_relation.person_id_relation[i].id = vm.payee_id;
            }
          }
          $rootScope.show_loader = false;
        });
    };

    /**
     * Resgata possiveis relações de responsáveis ao aluno
     */
    vm.getPersonRelationLegal = function () {
      EnrolmentService.getPersonRelationLegal()
        .then(function (list) {
          vm.list.person_relation.person_relation_type_id = list.plain();
          $rootScope.show_loader = false;
        });
    };

    /**
     * Função chamada quando um responsável é removido da lista.
     * Verifica se ele estava selecionado como responsável financeiro ou pedagógico,
     * e atualiza a lista.
     * @param item
     */
    vm.reset = function (item) {
      if (item.id === vm.payee_id) {
        vm.payee_id = null;
        vm.hasPayee = false;
      }
      if (item.id === vm.responsible_id) {
        vm.responsible_id = null;
        vm.hasResponsible = false;
      }
    };

    /**
     * Define o responsável financeiro e bloqueia a seleção de outro
     * @param item
     */
    vm.setPayee = function (item) {

      /** Se o responsável financeiro selecionado não tiver CPF, abre o modal de preenchimento */
      if ((item.national_id_number === null || angular.isUndefined(item.national_id_number)) && vm.payee_id !== item.id) {
        ModalFactory.custom('app/educational/enrolment/enrolment-steps/responsibles/responsible-cpf.html', null, false, null)
          .then(function (object) {
            $rootScope.show_loader = true;
            /**
             * Salva o novo CPF do responsável.
             */
            ResponsiblesService.saveResponsibleCPF({cpf: object, person_id: item.id})
              .then(function () {
                $rootScope.show_loader = false;
                Common.Toast.success('CPF atualizado com sucesso!');
                item.national_id_number = object;
                if (vm.payee_id === item.id) {
                  vm.hasPayee = false;
                  vm.payee_id = null;
                } else if (vm.hasPayee === false && vm.payee_id !== item.id) {
                  vm.payee_id = item.id;
                  vm.hasPayee = true;
                }
              }).catch(function () {
              $rootScope.show_loader = false;
              vm.reset(item);
              item.is_payee = false;
              Common.Toast.error('Erro ao cadastrar o CPF. Contate o suporte.');
            })
          }).catch(function () {
          vm.reset(item);
          item.is_payee = false;

        })
      } else {
        if (vm.payee_id === item.id) {
          vm.hasPayee = false;
          vm.payee_id = null;
        } else if (vm.hasPayee === false && vm.payee_id !== item.id) {
          vm.payee_id = item.id;
          vm.hasPayee = true;
        }
      }
    };
    /**
     * Verificação para o checkbox do responsável financeiro
     * @param item
     * @returns {boolean}
     */
    vm.verifyPayee = function (item) {
      if (vm.payee_id === item.id || vm.hasPayee === false) {
        return false;
      } else if (vm.hasPayee === true && vm.payee_id !== item.id) {
        return true;
      }
    };

    /**
     * Define o responsável pedagógico e bloqueia a seleção de outro
     * @param item
     */
    vm.setResponsible = function (item) {
      if (vm.responsible_id === item.id) {
        vm.hasResponsible = false;
        vm.responsible_id = null;
      } else if (vm.hasResponsible === false && vm.responsible_id !== item.id) {
        vm.responsible_id = item.id;
        vm.hasResponsible = true;
      }
    };

    /**
     * Verificação para o checkbox do responsável pedagógico
     * @param item
     * @returns {boolean}
     */
    vm.verifyResponsible = function (item) {
      if (vm.responsible_id === item.id || vm.hasResponsible === false) {
        return false;
      } else if (vm.hasResponsible === true && vm.responsible_id !== item.id) {
        return true;
      }
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular.module('app.educational.enrolment')
    .controller('ResponsiblesStepController', ResponsiblesStepController)

})();
(function () {
  'use strict';

  /** @ngInject */
  function MedicalDataStepController(EnrolmentService, $rootScope, $scope, StudentsService) {
    var vm = this;
    vm.person_id = angular.isDefined($scope.enrolment.form.person.id) ? $scope.enrolment.form.person.id : $scope.enrolment.form.student.id;

    vm.list = {
      person_relation: {
        search: [],
        person_relation_type_id: []
      }
    };

    vm.enableNextStep = function () {
      $scope.enrolment.steps.responsibles.disabled = false;
    };

    vm.init = function () {
      vm.getPersonRelationLegal();
      vm.getPersonMedicalData()
    };

    vm.getPersonMedicalData = function()
    {
      $rootScope.show_loader = true;
      StudentsService.getPersonMedicalData({person_id: vm.person_id}).then(function (response) {
        $scope.enrolment.form.person_medical_data = response.plain();
        $rootScope.show_loader = false;
      });
    };


    vm.getPersonRelationLegal = function () {
      EnrolmentService.getPersonRelationLegal()
        .then(function (list) {
          vm.list.person_relation.person_relation_type_id = list.plain();
          $rootScope.show_loader = false;
        });
    };

    vm.init();

  }


  angular.module('app.educational.enrolment')
    .controller('MedicalDataStepController', MedicalDataStepController)

})();
(function () {
  'use strict';

  /** @ngInject */
  function InitStepController($rootScope, $state, $scope, $window, EnrolmentService, Session, ModalFactory) {
    var vm = this;
    vm.current_school_period = Session.getCurrentSchoolPeriod().id;
    vm.current_choice = null;
    vm.has_pendences = false;
    vm.block_next_button = false;
    vm.searchText = '';
    vm.only_available = true;
    vm.different_course = false;
    vm.person_info = null;
    vm.CANCELADO = 32;

    vm.enableNextStep = function () {
      $scope.enrolment.steps.course.disabled = false;
    };
    /**
     * Busca os alunos pelo nome
     * @param text - Nome do aluno
     */
    vm.getStudents = function (text) {
      vm.isLoading = true
      return EnrolmentService.getEnrolmentStudent({
        query: text
      }).then(function (result) {
        vm.isLoading = false;
        return result;
      })
    };


    /**
     * Retorna o progresso da matricula, caso haja
     * @param person - Item da pessoa escolhida
     */

    vm.getEnrolmentProgress = function (person) {
      console.log(person);
      if (angular.isDefined(person) &&
          person.enrolment_status != null &&
          person.school_period_student == vm.current_school_period && 
          person.school_period_student != 0 &&
          (person.pre_enrol_status !== null && person.pre_enrol_status !== 0 && person.pre_enrol_status !== 2)) {
        ModalFactory.alert("Atenção!",
          "O(a) aluno(a) " + person.name + " já possui uma pré-matrícula ou uma matricula realizada para este período letivo! Em caso de matrícula será possivel apenas trocar de turma nas opções em Alunos e matrículas.",
          "modal",
          "Ok",
          "educational"
        ).then (
          function () {
            $state.go('private.educational.students.list');
          }
        )
      } else {
        vm.enrolmentProgress(person);
      }
    }

    vm.enrolmentProgress = function (person) {
      console.log(person)
      vm.has_progress = false;
      var person_id = angular.isDefined(person) ? person.id : null;
      if (person_id !== null) {
        vm.person_info = person;
        $scope.enrolment.student_id = person_id;
        EnrolmentService.getEnrolmentProgress(person_id)
          .then(function (enrolment) {
            if (angular.isDefined(enrolment) && enrolment !== null) {
              vm.has_progress = true;
              $scope.enrolment.form.timetable = {};
              $scope.enrolment.form.timetable.course_id = enrolment.course_id;
              $scope.enrolment.form.timetable.group_id = enrolment.group_id;
              $scope.enrolment.form.timetable.matrix_period = enrolment.matrix_period;
              $scope.enrolment.form.student.group_id = enrolment.group_id;
              $scope.enrolment.form.student.course_id = enrolment.course_id;
              $scope.enrolment.form.student.matrix_period = enrolment.matrix_period;
              $scope.enrolment.stepSelected = enrolment.enrolment_wizard_step;
              $scope.enrolment.form.pre_enrol_status = enrolment.pre_enrol_status;
              $scope.enrolment.form.subject.id = enrolment.subject;
              $scope.enrolment.student.idOfDocuments = enrolment.documents;
              $scope.enrolment.student.group_id = enrolment.group_id;
              $scope.enrolment.student.matrix_period = enrolment.matrix_period;

              if (enrolment.course_equivalence_id >= 300) {
                $scope.enrolment.steps.subject.disabled = false;
              }
              $rootScope.$broadcast('student-search-autocomplete-item-change', $scope.enrolment.form.student);
              if (angular.isDefined(enrolment.enrolment_wizard_step) && enrolment.enrolment_wizard_step !== null) {
                vm.setCompletedStep(enrolment.enrolment_wizard_step);
              } else {
                /**caso tenha progresso mas não tenha registrado
                 * um setp, leva o assistente para o cadastro de 
                 * dados para prosseguir
                 */
                $scope.enrolment.stepSelected = 2;
                vm.setCompletedStep(2);
              }
            }
            if ($scope.enrolment.form.enrolment_status_id == 5 && $scope.enrolment.form.pre_enrol_status == null){
              ModalFactory.alert(
                "Atenção", "Este aluno passou pelo processo de pré matricula mas ainda está pendente de aprovação," +
                "para concluir a matricula desse aluno, ele deve ser aprovado na aba de pré-matricula, em 'Alunos e matrículas'",
                "modal", "Ok", "false", "educational"
              );
              $scope.enrolment.form.student = null;
            }
          });
        if (!vm.has_progress) {
          $scope.enrolment.form.course_id = person.course_id;
          $scope.enrolment.form.group_id = person.group_id;
          $scope.enrolment.form.course_equivalence_id = person.course_equivalence_id;
          $scope.enrolment.form.enrolment_status_id = person.enrolment_status;
          $scope.enrolment.form.academic_status_id = person.academic_status_id;
          $scope.enrolment.form.school_period_student = person.school_period_student;
          if ($scope.enrolment.form.school_period_student === vm.current_school_period &&
            $scope.enrolment.form.enrolment_status_id === vm.CANCELADO) {
            ModalFactory.alert(
              "Atenção", "Esta matrícula está cancelada. Caso você deseje reativar uma matrícula cancelada, " +
              "realize o processo de descancelamento de matrícula. Para isso, acesse a lista de aluno, vá na lista de ações do aluno e selecione " +
              "a opção 'Desfazer cancelamento'.",
              "modal", "Ok", "false", "educational"
            );
          }
        }
      }
    };

    /**
     * Redireciona para a ficha do aluno
     * @param student
     */
    vm.goToStudent = function (student) {
      var obj = {
        id: student.id,
        course_id: student.course_id,
        group_id: student.group_id,
        course_equivalence_id: student.course_equivalence_id,
        matrix_period: student.enrolment_matrix_period
      };
      if (vm.current_school_period !== student.school_period_student) {
        obj.change_school_period = student.school_period_student;
      }
      var url = $state.href('private.educational.students.edit', obj);
      $window.open(url, '_blank');
    };

    /**
     * Coloca para itens do wizard ficarem em estado de completos
     * @param maxStep - Numero maximo para completar os items
     */
    vm.setCompletedStep = function (maxStep) {
      angular.forEach($scope.enrolment.steps, function (item) {
        if (item.id <= maxStep) {
          item.completed = true;
          item.disabled = false;
        } else {
          item.completed = false;
          item.disabled = true;
        }
      })

    };

    /**
     * Retorna pendencias de pagamento para um aluno
     */
    vm.getPaymentPendences = function (person) {
      if (angular.isDefined(person) && angular.isDefined(person.id)) {
        vm.block_next_button = true;
        EnrolmentService.getPaymentPendences(person.id)
          .then(function (response) {
            var obj = response.plain();
            var pendences = obj.pendences;
            vm.has_pendences = pendences.length;
            var block_by_payment_default = obj.block_payment_default;
            if (vm.has_pendences && block_by_payment_default) {
              vm.block_next_button = true;
            } else {
              vm.block_next_button = false;
            }
            vm.current_choice = person;
          })
          .catch(function () {
            vm.block_next_button = false;
          });
      }
    };

    $scope.$watch('vm.searchText', function (newer) {
      $scope.enrolment.form.search_text = newer;
    });


  }

  angular.module('app.educational.enrolment')
    .controller('InitStepController', InitStepController)

})();

(function () {
  'use strict';

  /** @ngInject */
  function FinanceStepController($rootScope, $scope, a4Moment, EnrolmentService, BillReceiptService, $filter, ModalFactory) {
    var vm = this;
    $rootScope.show_loader = false;
    vm.hasPaymentPlan = true;
    vm.frequency_options = BillReceiptService.getFrequencyOptions();

    vm.list = {
      contract: {
        payment_plan_id: [],
        discounts_rule_id: null,
        fines_rule_id: null
      }
    };

    vm.init = function () {
      vm.getPaymentPlansForGroup();
    };

    /**
     * Retorna os planos de pagamento para a turma selecionada na matrícula
     */
    vm.getPaymentPlansForGroup = function () {
      EnrolmentService.getPaymentPlansForGroup({group_id: $scope.enrolment.form.timetable.group_id})
        .then(function (response) {
          vm.payment_plans = response.plain();
          vm.list.contract.payment_plan_id = response.plain();
          /** Caso a turma só tenha um plano de pagamento associado, seleciona este plano */
          if (vm.list.contract.payment_plan_id.length === 1) {
            $scope.enrolment.form.contract = vm.list.contract.payment_plan_id[0];
            $scope.enrolment.form.contract.amount = $scope.enrolment.form.contract.recurrence_on_value === 2 ?
              (vm.list.contract.payment_plan_id[0].price / vm.list.contract.payment_plan_id[0].quantity) : vm.list.contract.payment_plan_id[0].price;
            $scope.enrolment.form.contract.date_first = a4Moment(vm.list.contract.payment_plan_id[0].date_first).format('DD/MM/YYYY');
            $scope.enrolment.form.contract.individual_discounts = [];
            vm.generateInstalmentsByPaymentPlan($scope.enrolment.form.contract);
          } else if (vm.list.contract.payment_plan_id.length <= 0) {
            /** Caso a tuema não tenha nenhum plano de pagamento associado,
             * seta essa variável como false e mostra uma mensagem na tela */
            vm.hasPaymentPlan = false;
          }
        })
    };

    /**
     * Seta as informações relacionadas ao plano de pagamento escolhido
     * @param payment_plan_id
     */
    vm.setPaymentPlan = function (payment_plan_id) {
      var selected = $filter('filter')(vm.list.contract.payment_plan_id, {payment_plan_id: payment_plan_id}, true)[0];
      $scope.enrolment.form.contract = [];
      $scope.enrolment.form.contract = selected;
      $scope.enrolment.form.contract.payment_plan_id = payment_plan_id;
      $scope.enrolment.form.contract.amount = selected.recurrence_on_value === 2 ? (selected.price / selected.quantity) : selected.price;
      $scope.enrolment.form.contract.date_first = selected.date_first === null || selected.date_first === '' ?
        '' : a4Moment(selected.date_first).format('YYYY-MM-DD');
      $scope.enrolment.form.contract.individual_discounts = [];
      vm.generateInstalmentsByPaymentPlan($scope.enrolment.form.contract);
    };

    /**
     * Gera as parcelas da recorrência no caso da seleção de um plano de pagamento
     * @param payment_plan
     */
    vm.generateInstalmentsByPaymentPlan = function (payment_plan) {
      $scope.enrolment.form.contract.payment_installments = [];
      var copy_plan = angular.copy(payment_plan);
      var obj = {};
      if (copy_plan.frequency > 0) {
        for (var i = 1; i <= copy_plan.quantity; i++) {
          obj = {
            portion_name: i + '/' + copy_plan.quantity,
            due_date: vm.getNextDate(copy_plan),
            amount: payment_plan.recurrence_on_value === 2 ? (copy_plan.amount / copy_plan.quantity) : copy_plan.amount
          };
          $scope.enrolment.form.contract.payment_installments.push(obj);
        }
      } else {
        obj = {
          portion_name: '1/1',
          due_date: copy_plan.date_first,
          amount: copy_plan.amount
        };
        $scope.enrolment.form.contract.payment_installments.push(obj);
      }
    };

    /**
     * Devolve a próxima data de vencimento para as parcelas
     * @param payment_plan
     * @returns {*}
     */
    vm.getNextDate = function (payment_plan) {
      var copy_plan = angular.copy(payment_plan);
      var len = $scope.enrolment.form.contract.payment_installments.length;
      var last_date = len > 0 ? $scope.enrolment.form.contract.payment_installments[len - 1].due_date : copy_plan.date_first;
      var frequency_value = $filter('filter')(vm.frequency_options, {id: copy_plan.frequency})[0].value;
      var date = a4Moment(last_date);

      if (len > 0) {
        date.add(copy_plan.frequency_qty, frequency_value)
      }

      return date;
    };

    /**
     * Criação de desconto individual
     */
    vm.createNewIndivialDiscount = function () {
      ModalFactory.customClean(
        'app/finance/individual-discounts/views/individual-discounts.html',
        'IndividualDiscountsController',
        'vm',
        true,
        {theme: 'educational'}
      ).then(function (discount) {
        if (discount !== 'canceled') {
          $scope.enrolment.form.contract.individual_discounts.push(discount);
        }
      })
    };

    /**
     * Remove um desconto da lista
     */
    vm.removeItemDesconto = function (index) {
      $scope.enrolment.form.contract.individual_discounts.splice(index, 1);
    };

    vm.init();

  }

  angular.module('app.educational.enrolment')
    .controller('FinanceStepController', FinanceStepController)

})();
(function () {
  'use strict';

  /** @ngInject */
  function EndStepController(CONFIG, Common, EnrolmentService, CourseDocumentsService, ReportsService, LocalStorage, Session, $document,
                             $scope, $rootScope, $state, $timeout) {

    var vm = this;
    vm.documentsForCourse = [];
    vm.WEB_CONST = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.selected_student = null;
    vm.has_finance = LocalStorage.get('has_app_finance');
    vm.person_id = angular.isDefined($scope.enrolment.form.person.id) ? $scope.enrolment.form.person.id : $scope.enrolment.form.student.id;


    /**
     * Busca o período letivo corrente.
     */
    vm.getSchoolPeriod = function () {
      vm.school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    };

    /**
     * Imprime ficha de matrícula
     */
    vm.impressRegistrationForm = function () {
      ReportsService.reportFactory('GET', 'api/reports/printenrolmentform',
        {
          student_id: vm.selected_student.id,
          school_period_id: vm.school_period_id,
          option: 1,
          group_id: vm.selected_student.group_id
        });
      // var href = vm.WEB_CONST + 'api/reports/printenrolmentform?token=' + vm.conf.token + '&company=' + vm.conf.current_company +
        // '&connection=' + vm.conf.current_connection + '&option=1' +
        // '&student_id=' + vm.selected_student.id + '&user_id=' + vm.conf.user_id + '&school_period_id=' + vm.school_period_id;
      // var element = document.createElement('a');
      // element.setAttribute('href', href);
      // element.setAttribute('target', '_blank');
      // return element.click();
    };

    // vm.impressEnrolmentCertificate = function () {
    //   var href = vm.WEB_CONST + 'api/reports/enrolmentcertificate?token=' + vm.conf.token + '&company=' + vm.conf.current_company +
    //     '&connection=' + vm.conf.current_connection + '&option=1&show_warning=true' +
    //     '&student_id=' + vm.selected_student.id + '&user_id=' + vm.conf.user_id + '&current_school_period=' + vm.school_period_id
    //     + '&group_id=' + vm.selected_student.group_id + '&matrix_period=' + vm.selected_student.matrix_period;
    //   var element = document.createElement('a');
    //   element.setAttribute('href', href);
    //   element.setAttribute('target', '_blank');
    //   return element.click();
    // };

    vm.impressEnrolmentCertificate = function () {
          ReportsService.reportFactory('GET', 'api/reports/enrolmentcertificate', {
            student_id: vm.selected_student.id,
            group_id: vm.selected_student.group_id,
            show_warning: vm.showWarningLEDForm,
            option: 1,
            matrix_period: vm.selected_student.matrix_period
          });
    };

    /**
     * Vai para o assistente de matrícula financeira do aluno
     */
    vm.goToFinanceEnrolment = function () {
      vm.selected_student.isFinalOfAcademicEnrolment = true;
      EnrolmentService.getContractType({
        person_id: vm.person_id, group_id: vm.selected_student.group_id,
        matrix_period: vm.selected_student.matrix_period
      }).then(function (contract_type) {
        EnrolmentService.storeStudent(vm.selected_student).then(function () {
          $rootScope.show_loader = true;
          $state.go('private.educational.finance-enrolment.enrolment', {
            id: vm.person_id, group_id: vm.selected_student.group_id,
            contract_type: contract_type,
            course_id: vm.selected_student.course_id, matrix_period: vm.selected_student.matrix_period
          });
        });
      });

    };

    /**
     * Vai para a lista de alunos
     */
    vm.end = function () {
      vm.selected_student.isFinalOfAcademicEnrolment = true;
      EnrolmentService.storeStudent(vm.selected_student).then(function () {
        $rootScope.show_loader = true;
        $state.go('private.educational.students.list', {
          tab_selected: angular.isDefined(vm.selected_student.is_pre_enrolment) ?
            vm.selected_student.is_pre_enrolment : 0
        });
      });

    };


    vm.init = function () {
      $rootScope.show_loader = true;
      $timeout(function () {
        vm.selected_student = $scope.enrolment.form.student;
        vm.selected_student.group_id = $scope.enrolment.form.group_id;
        if (angular.isUndefined(vm.selected_student.group_id)) {
          vm.selected_student.group_id = $scope.enrolment.student.group_id;
        }
        vm.selected_student.id = vm.person_id;
        // vm.selected_student.id = $scope.enrolment.form.person.id;
        if (angular.isDefined($scope.enrolment.new_item)) {
          vm.selected_student.is_pre_enrolment = $scope.enrolment.new_item.pre_enrolment;
          vm.selected_student.group_id = $scope.enrolment.new_item.timetable.group_id;
          vm.selected_student.course_id = $scope.enrolment.new_item.timetable.course_id;
          vm.selected_student.subject = $scope.enrolment.new_item.subject.id;
          vm.selected_student.matrix_period = $scope.enrolment.new_item.timetable.matrix_period;
        } else {
          vm.selected_student.group_id = $scope.enrolment.form.student.group_id;
          vm.selected_student.course_id = $scope.enrolment.form.student.course_id;
        }
        CourseDocumentsService.getAllDocumentsForCourse(vm.selected_student.course_id, {})
          .then(function (response) {
            vm.documentsForCourse = response.plain();
          });

        vm.getSchoolPeriod();

        /** Garantia para que o Person_Student seja criado, independente do step que usuário percorrer.
         */
        if (angular.isUndefined(vm.selected_student.matrix_period) || vm.selected_student.matrix_period === null || angular.isUndefined(vm.selected_student.matrix_period)) {
          vm.selected_student.matrix_period = $scope.enrolment.student.matrix_period;
        }
        vm.selected_student.isUpdateOfEndStep = true;
        EnrolmentService.storeStudent(vm.selected_student).then(function (response) {
          if (angular.isDefined(response) && response !== null) {
            vm.selected_student.id = response;
          }
        });
        vm.conf.current_company = Session.get('current_company', "sessionStorage");
        vm.conf.current_connection = $document[0].domain.split('.')[0];
        vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
        vm.conf.user_id = Session.user.id;
        ReportsService.getToken()
          .then(function (token) {
            vm.conf.token = token;
            $rootScope.show_loader = false;
          });
      }, 4000);
    };

    vm.init();
  }


  angular.module('app.educational.enrolment')
    .controller('EndStepController', EndStepController)

})();

(function () {
  'use strict';

  /** @ngInject */
  function DocumentsStepController($rootScope, EnrolmentService, $scope, CourseDocumentsService, Session) {
    var vm = this;
    $rootScope.show_loader = false;
    vm.person_student = angular.copy($scope.enrolment.new_item.student);
    vm.school_period_id = Session.getCurrentSchoolPeriod().id;
    vm.company_id = Session.get('current_company', "sessionStorage");
    vm.enableNextStep = function () {
      $scope.enrolment.steps.medical_data.disabled = false;
    };

    vm.init = function () {
      if (angular.isUndefined($scope.enrolment.student.idOfDocuments)) {
        $scope.enrolment.student.idOfDocuments = [];
      }
      vm.getFormInfo();
      vm.getDocumentsForStudent();
    };

    $scope.$on('refresh-student-documents', function () {
      vm.getDocumentsForStudent();
    });

    /**
     * Busca os documentos associados ao curso no qual o aluno está sendo matriculado
     */
    vm.getDocumentsForCourse = function () {
      $rootScope.show_loader = true;
      CourseDocumentsService.getDocumentsForCourse({course_id: $scope.enrolment.form.timetable.course_id})
        .then(function (response) {
          vm.documentsForCourse = response.plain();
          $rootScope.show_loader = false;
        });
    };

    vm.getDocumentsForStudent = function () {
      CourseDocumentsService.getDocumentsForStudent({
        person_id: vm.person_student.person_id,
        group_id: vm.person_student.group_id,
        course_id: vm.person_student.course_id
      }).then(function (response) {
        vm.documentsForCourse = response.plain().filter(function (doc) {
          if (vm.company_id == 117 || vm.company_id == 118 || vm.company_id == 74) {
            return doc
          } else {
            return doc.school_period_id === null || doc.school_period_id === vm.school_period_id;
          }
        });
        $scope.$applyAsync();
      })
    };

    /**
     * Busca informações necessarias para o form
     */
    vm.getFormInfo = function () {
      $rootScope.show_loader = true;
      EnrolmentService.getEnrolmentFormInfo()
        .then(function (response) {
          var resp = response.plain();
          vm.person = resp.person;
          $rootScope.show_loader = false;
        });
    };

    vm.init();

  }

  angular.module('app.educational.enrolment')
    .controller('DocumentsStepController', DocumentsStepController)

})();
(function () {
  'use strict';

  /** @ngInject */
  function CourseStepController($rootScope, $scope, $filter, $timeout, EnrolmentService, Session, ModalFactory, EducationalService) {
    var vm = this;
    vm.courses = [];
    vm.groups = [];
    vm.allGroups = [];
    vm.school_period_course = null;
    vm.IN_COURSE = 0;
    vm.PRE_ENROLMENT_ONLINE = 5;
    vm.CANCELED = 32;
    vm.PRE_ENROLMENT = 0;
    vm.disabled = false;
    vm.is_capacity_limit = false;
    vm.current_school_period = Session.getCurrentSchoolPeriod().id;
    vm.student_atual_school_period = $scope.enrolment.form.school_period_student;
    vm.academic_type= '';
    vm.companies = Session.getCompanies()[0]

    vm.enableNextStep = function () {
      console.log($scope.enrolment.form.enrolment_status_id)
      if((vm.current_school_period == vm.student_atual_school_period && vm.academic_type == 1) && vm.current_school_period != 0
        && (vm.companies.id !== 122 && vm.companies.id !== 245) && 
        ($scope.enrolment.form.enrolment_status_id !== 5 && $scope.enrolment.form.enrolment_status_id !== 6)) {
          ModalFactory.alert(
            "Atenção", "O aluno(a)  " + $scope.enrolment.form.search_text + "  já está matriculado " +
            "nesse periodo letivo, sendo possivel apenas trocar de turma nas opções em Alunos e matrículas",
            "modal", "Ok", "false", "educational"
          ).then(function () {
            vm.getFormInfo();
          });

        vm.has_student_selected = angular.isUndefined($scope.enrolment.form.course_equivalence_id);
      } else if(vm.is_capacity_limit && vm.group.vagas <= 0) {
        ModalFactory.alert(
          "Atenção", "A turma execeu a quantidade de vagas",
          "modal", "Ok", "false", "educational");
      }
      else {
        $scope.enrolment.steps.students.disabled = false;
      }
    };

    vm.init = function () {
      EducationalService.isCapacityLimit().then(function (res) {
        if(angular.isDefined(res[0])) {
          vm.is_capacity_limit = res[0].is_capacity_limit;
        }
      });
      EducationalService.getAcademicTypeOfCompany().then(function (response) {
        vm.academic_type = response;
      });
      vm.getFormInfo();
      vm.has_student_selected = angular.isUndefined($scope.enrolment.form.course_equivalence_id);
    };

    /**
     * Busca informações necessarias para o form
     */
    vm.getFormInfo = function () {
      $rootScope.show_loader = true;
      EnrolmentService.getEnrolmentFormInfo({get_limits: true})
        .then(function (response) {
          var resp = response.plain();
          var enrolment = resp.enrolment;
          vm.allGroups = resp.enrolment.group_id;
          var courses = [];
          enrolment.group_id.map(function (item) {
            var filter = $filter('filter')(courses, {course_id: item.course_id}, true);

            if (filter.length === 0) {
              courses.push(item);
            }
          });
          vm.courses = courses;

          if (angular.isUndefined($scope.enrolment.form.timetable.course_id) || $scope.enrolment.form.timetable.course_id == null) {
            $scope.enrolment.form.timetable = {};
            vm.course_suggestion = vm.getSuggestion();
            if (vm.course_suggestion !== null) {
              $scope.enrolment.form.timetable.course_id = vm.course_suggestion.course_id;
              vm.setGroups(vm.course_suggestion.course_id);
            }
          } else {
            vm.setGroups($scope.enrolment.form.timetable.course_id);
          }
        });
      $rootScope.show_loader = false;
    };

    /**
     *
     */
    vm.getSuggestion = function () {
      var course_suggestion = null;
      if ($scope.enrolment.form.course_id !== null) {
        for (var i = 0; i < vm.courses.length; i++) {
          if ((vm.courses[i].course_equivalence_id === $scope.enrolment.form.course_equivalence_id && $scope.enrolment.form.enrolment_status_id === vm.PRE_ENROLMENT_ONLINE) ||
            vm.courses[i].course_equivalence_id > $scope.enrolment.form.course_equivalence_id && $scope.enrolment.form.enrolment_status_id !== vm.PRE_ENROLMENT_ONLINE) {
            course_suggestion = vm.courses[i];
            break;
          }
        }
      }

      return course_suggestion;
    };

    vm.setGroupAndMatrix = function (item) {
      vm.group_id = item.id;
      vm.matrix_period = item.matrix_period;
    };

    vm.defineGroupAndMatrix = function () {
        $scope.enrolment.form.timetable.group_id = vm.group.id;
        $scope.enrolment.form.timetable.matrix_period = vm.group.matrix_period;
        $scope.enrolment.form.timetable.course_enrolment_system_id = vm.group.course_enrolment_system_id;
        if($scope.enrolment.form.matrix_period || $scope.enrolment.form.group_id) {
          $scope.enrolment.form.matrix_period = vm.group.matrix_period;
          $scope.enrolment.form.group_id = vm.group.matrix_period;
        }
    };

    /**
     * Define a lista de turmas do curso
     */
    vm.setGroups = function (course_id) {
      vm.groups = $filter('filter')(vm.allGroups, {course_id: course_id}, true);
      var course = $filter('filter')(vm.courses, {course_id: course_id}, true)[0];
      vm.school_period_course = course.school_period_id;
      $scope.enrolment.form.timetable.course_equivalence_id = course.course_equivalence_id;
      if (course.course_enrolment_system_id === 2 || course.is_subject_enrolment){
        $scope.enrolment.steps.subject.disabled = false;
      }
      /** Libera a aba de disciplinas caso seja uma matricula em curso superior e o
       * sistema de matrículas do curso for em disciplinas */
      // if (vm.groups.length > 0 && vm.groups[0].course_equivalence_id >= 300 && vm.groups[0].course_enrolment_system_id === 2) {
      //   $scope.enrolment.steps.subject.disabled = false;
      // } else {
      //   $scope.enrolment.steps.subject.disabled = true;
      // }
      $rootScope.show_loader = false;
      if (angular.isDefined($scope.enrolment.form.group_id) && $scope.enrolment.form.group_id !== null) {
        vm.groups.forEach(function (group) {
          if (group.id === $scope.enrolment.form.group_id) {
            vm.group = group;
            vm.defineGroupAndMatrix();
          }
        });
      }
    };

    vm.init();

  }

  angular.module('app.educational.enrolment')
    .controller('CourseStepController', CourseStepController)

})();

(function () {
  'use strict';

  /** @ngInject */
  function AddressStepController($rootScope, $scope) {
    var vm = this;
    $rootScope.show_loader = false;
    vm.person = {};
    vm.searchText_address_state = '';
    vm.searchText_address_city = '';
    vm.waiting_city = false;

    vm.enableNextStep = function () {
      if ((angular.isUndefined($scope.enrolment.form.student.address_state) || $scope.enrolment.form.student.address_state === null)
        && vm.searchText_address_state !== '') {
        $scope.enrolment.form.student.address_state = vm.searchText_address_state;
      }
      if ((angular.isUndefined($scope.enrolment.form.student.address_city) || $scope.enrolment.form.student.address_city === null)
        && vm.searchText_address_city !== '') {
        $scope.enrolment.form.student.address_city = vm.searchText_address_city;
      }
      $scope.enrolment.steps.end.disabled = false;
    };

    vm.init = function () {
      console.log($scope.enrolment);
    };

    vm.init();

  }

  angular.module('app.educational.enrolment')
    .controller('AddressStepController', AddressStepController)

})();
(function () {
  'use strict';

  angular
    .module('app.stock.stocklist', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function StockTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "STOCK": {
        "ADD_PRODUCT": "Adicionar novo produto",
        "CATEGORY": "Categorização do Produto",
        "DETAILS": "Detalhes do Produto",
        "FORM_BAR_CODE": "Código de Barras",
        "FORM_CREATE": "Criar produto",
        "FORM_EDIT": "Editar produto",
        "FORM_INITIAL_STOCK": "Estoque",
        "FORM_INITIAL_STOCK_REQUIRED": "O estoque é requerido.",
        "FORM_MINIMUM_STOCK": "Qtd. Mínima",
        "FORM_MINIMUM_STOCK_REQUIRED": "O mínimo é requerido.",
        "FORM_NAME": "Nome do produto",
        "FORM_NAME_REQUIRED": "O nome é requerido.",
        "FORM_ONLY_NUMBER_REQUIRED": "Somente números são permitidos.",
        "FORM_PRICE": "Valor",
        "FORM_PRICE_REQUIRED": "O valor é requerido.",
        "FORM_SUBMIT_CREATE": "Adicionar",
        "FORM_SUBMIT_EDIT": "Atualizar",
        "FORM_TYPE": "Tipo de produto",
        "FORM_TYPE_REQUIRED": "Tipo é requerido",
        "FORM_UNIT": "Unidade de medida",
        "FORM_UNIT_REQUIRED": "A unidade é requerido.",
        "FORM_UNIT_MAX_LENGTH": "Máximo de 20 caracteres.",
        "NAME": "O produto",
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "TITLE": "Estoque de produtos"
      }
    });

  }

  angular
    .module('app.stock.stocklist')
    .config(StockTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function StockTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "STOCK": {
        "ADD_PRODUCT": "Adicionar novo produto",
        "CATEGORY": "Categorização do Produto",
        "DETAILS": "Detalhes do Produto",
        "FORM_BAR_CODE": "Código de Barras",
        "FORM_CREATE": "Criar produto",
        "FORM_EDIT": "Editar produto",
        "FORM_INITIAL_STOCK": "Estoque",
        "FORM_INITIAL_STOCK_REQUIRED": "O estoque é requerido.",
        "FORM_MINIMUM_STOCK": "Qtd. Mínima",
        "FORM_MINIMUM_STOCK_REQUIRED": "O mínimo é requerido.",
        "FORM_NAME": "Nome do produto",
        "FORM_NAME_REQUIRED": "O nome é requerido.",
        "FORM_ONLY_NUMBER_REQUIRED": "Somente números são permitidos.",
        "FORM_PRICE": "Valor",
        "FORM_PRICE_REQUIRED": "O valor é requerido.",
        "FORM_SUBMIT_CREATE": "Adicionar",
        "FORM_SUBMIT_EDIT": "Atualizar",
        "FORM_TYPE": "Tipo de produto",
        "FORM_TYPE_REQUIRED": "Tipo é requerido",
        "FORM_UNIT": "Unidade de medida",
        "FORM_UNIT_REQUIRED": "A unidade é requerido.",
        "FORM_UNIT_MAX_LENGTH": "Máximo de 20 caracteres.",
        "NAME": "O produto",
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "TITLE": "Estoque de produtos"
      }
    });

  }

  angular
    .module('app.stock.stocklist')
    .config(StockTranslate);
})();

(function () {
  'use strict';

  angular.module('app.process.process-crud', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ProcessCardDialogController($document, $mdDialog, ModalExtra, Common, CONFIG, DropzoneService, $filter,
                                       ProcessCrudService, ClassReleaseService, Session, GroupsService, a4Moment,
                                       CollaboratorsService, $mdEditDialog, PoliciesService, $scope, $timeout,
                                       ModalFactory, $rootScope, LocationService, ReportsService) {
    /**
     * Tipos de processos
     * 1 'Arte Gráfica',
     * 2, 'Foto e vídeo',
     * 3, 'Impressão',
     * 4, 'Compras',
     * 5, 'Reparo',
     * 6, 'Material escolar',
     * 7, 'Música',
     * 8, 'Recursos tecnológicos'
     */

    var vm = this;
    // Data
    vm.CONFIG = CONFIG;
    vm.card = ModalExtra.card;
    vm.card_type = ModalExtra.card_type;
    vm.can_edit = false;
    vm.do_edit = false;
    vm.disabled_comment = false;
    vm.user_id = Session.user.id;
    vm.newCommentText = null;
    vm.product_id = null;
    vm.product_qty = null;
    vm.process_type = null;
    vm.process_types = [];
    vm.process_type_types = [];
    vm.locations = [];
    vm.groups = [];
    vm.colors = [{id: 1, name: 'Preto e branco'}, {id: 2, name: 'Colorido'}];
    vm.save_process = false;
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/process/uploadartifact?connection=' + $document[0].domain.split('.')[0] + '&company=' + Session.getCurrentCompany() +
        '&process_id=' + vm.card.id + '&person_id=' + vm.user_id,
      paramName: 'file',
      maxFilesize: '50',
      acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'GIF', 'XLS', 'MP3', 'MP4', 'WMV', 'AVI']),
      uploadMultiple: true,
      parallelUploads: 5,
      maxFiles: 20,
      autoProcessQueue: true,
    };
    vm.profile = Session.getCurrentProfile();

    vm.dzCallbacks = {
      'addedfile': function (file) {
        DropzoneService.getBase64(file)
          .then(function (base64) {
            file.base64 = base64;
            vm.card.artifacts.push({name: file.name, base64: file.base64, size: file.size});
          });
      },
      'successmultiple': function () {
      },
      'dragenter': function (file) {

      }, 'success': function (file, xhr) {
        if (xhr) {
          if( vm.card.id !== null) {
            ProcessCrudService.getArtifacts({process_id: vm.card.id})
              .then(function (resp) {
                vm.card.artifacts = resp.plain();
              })
          }
        }
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.init = function () {
      if (angular.isDefined(vm.card.id) && vm.card.id !== null) {
        vm.getProcessData();
      } else {
        vm.can_edit = true;
        vm.do_edit = true;
        vm.card.products = [];
        vm.card.artifacts = [];
      }
      vm.getProcessType();
      vm.getListOfLocations();
      if (vm.profile === 7) {
        /** Se for um professor */
        vm.getGroupsByTeacher();
      }
    }

    vm.getProcessData = function () {
      ProcessCrudService.getProcessData(vm.card)
        .then(function (resp) {
          vm.card = resp.plain();
          /** Se está pendente, não for do tipo 6 (material escolar, pois precisa de aprovação, e depois de aprovado
           *  não pode modificar), a pessoa que está editando é a criadora da solicitação e o modal foi aberto a
           *  partir da lista de "Minhas solicitações"
           *  Ou está "Em análise" */
          if (((vm.card.process_flow_item_id === 2 && vm.card.process_type_id !== 6) && vm.card.person_id_owner === vm.user_id && vm.card_type === 'crud')
            || vm.card.process_flow_item_id === 1) {
            vm.can_edit = true;
          }
          vm.getHoursUnavailable();
          vm.getProcessTypeTypes(vm.card.process_type_id);
          vm.card.products = angular.isDefined(vm.card.products) ? vm.card.products : [];
          vm.card.artifacts = angular.isDefined(vm.card.artifacts) ? vm.card.artifacts : [];
          vm.card.date_time = a4Moment(vm.card.date_time).format('DD/MM/YYYY [às] HH:mm');
          vm.card.time = vm.card.time !== null ? vm.card.time.substring(0, 5) : null;
        })
    }

    vm.getProcessType = function () {
      vm.show_loader = true;
      ProcessCrudService.getProcessType()
        .then(function (resp) {
          vm.show_loader = false;
          var process_types = resp.plain();
          vm.date_now = process_types[0]['date_now']
          vm.process_types = process_types.filter(function (type) {
            return !vm.checkPolicies("process_type_" + type.id);
          })
        })
    }

    vm.getProcessTypeTypes = function (process_type_id) {
      vm.process_type = null;
      $timeout(function () {
        vm.process_type = $filter('filter')(vm.process_types, {id: process_type_id})[0];
        var moment_date = moment();
        var date_now = new Date(vm.date_now + 'T00:00:00');
        //var date_now = new Date(vm.process_type_types[0].date_now + 'T00:00:00');

        if (date_now.getDate() !== moment_date.date()) {
          var date_limit = new Date(date_now);
          date_limit.setDate(date_now.getDate() + 3);
          vm.date_limit = date_limit;
        } else {
          vm.date_limit = a4Moment().add(vm.process_type.min_anticipation !== null ? vm.process_type.min_anticipation : 0, 'days');
        }
      }, 1000);
      // $scope.$applyAsync();
      ProcessCrudService.getProcessTypeTypes(process_type_id)
        .then(function (resp) {
          vm.process_type_types = resp.plain();

        })
      if (process_type_id === 6 || process_type_id === 8) {
        vm.getProductsByProcessType(process_type_id);
      }
    }

    vm.getProductsByProcessType = function (process_type_id) {
      ProcessCrudService.getProductsByProcessType({process_type_id: process_type_id})
        .then(function (resp) {
          vm.products = resp.plain();
        })
    }

    vm.getHoursUnavailable = function () {
      if ((vm.card.process_type_id === 2) || (vm.card.process_type_id === 8)) {
        vm.hours = ProcessCrudService.getHours();
        ProcessCrudService.getHoursUnavailable(vm.card.date, vm.card.process_type_id)
          .then(function (resp) {
            vm.unavaiable = resp.plain();
            vm.unavaiable = vm.unavaiable.map(function (item) {
              return item.substring(0, 5);
            });
            vm.hours.forEach(function (item) {
              item.is_available = !vm.unavaiable.includes(item.hour);
            })
          })
      }
    }

    /**
     * Retorna a lista de locais de aula
     */
    vm.getListOfLocations = function () {
      LocationService.getLocations()
        .then(function (response) {
          vm.locations = response.plain();
        })
    };

    /**
     * Retorna as turmas do professor logado
     */
    vm.getGroupsByTeacher = function () {
      GroupsService.getGroupsByTeacher({user_id: vm.user_id})
        .then(function (resp) {
          vm.groups = resp.plain();
        })
    }

    vm.justifyChangeStatus = function (item) {
      ModalFactory.prompt(
        null, 'Justificativa do cancelamento', 'Digite o motivo para essa ação:',
        '', '', 'Confirmar', 'Cancelar', 'process')
        .then(function (resp) {
          if (resp !== null) {
            item.notes_done = resp;
            vm.changeStatus(item);
          } else {
            Common.Toast.warning('Por favor, digite uma justificativa.')
          }
        })
    }

    vm.changeStatus = function (item) {
      $rootScope.show_loader = true;
      vm.show_loader = true;
      item.process_flow_item_origin = vm.card.process_flow_item_id;
      item.process_id = vm.card.id;
      item.person_id = vm.user_id;
      ProcessCrudService.changeStatus(item)
        .then(function () {
          $rootScope.show_loader = false;
          vm.show_loader = false;
          Common.Toast.success('Solicitação atualizada com sucesso!');
          vm.card.process_flow_item_id = item.process_flow_item_id_target;
          if (vm.card.id !== null && vm.do_edit) {
            vm.submit(vm.card);
          }
          $rootScope.$broadcast('UPDATE.list');
          $mdDialog.hide();
        })
        .catch(function () {
          $rootScope.show_loader = false;
          vm.show_loader = false;
          Common.Toast.error('Erro ao atualizar solicitação');
        });
    }

    vm.addProduct = function (product_id, qty, product_name) {
      if (angular.isUndefined(product_name) || product_name === null) {
        var product = $filter('filter')(vm.products, {id: product_id})[0];
        vm.card.products.push({
          product_id: product.id,
          qty: qty, product_name: product.name
        });
      } else {
        vm.card.products.push({
          product_id: null, qty: qty, product_name: product_name
        });
      }
      vm.product_id = null;
      vm.product_name = null;
      vm.product_qty = null;
    }

    vm.removeProduct = function (product) {
      product.to_delete = true;
    }

    vm.addNewComment = function (comment) {
      vm.disabled_comment = true;
      ProcessCrudService.addComment({comment: comment, person_id: vm.user_id, process_id: vm.card.id})
        .then(function (resp) {
          vm.card.comments.push(resp.plain());
          vm.newCommentText = null;
          vm.disabled_comment = false;
        })
        .catch(function () {
          vm.newCommentText = null;
          vm.disabled_comment = false;
        })
    }

    /**
     * Adiciona um novo link
     */
    vm.addNewLink = function () {
      vm.artefacts.splice(0, 0, {type: 'link', form_view: true});
      vm.selectedItem = 0;
      $timeout(function () {
        angular.element('.autofocus').trigger('focus');
      }, 300);
    };

    /**
     *Calcula a data restante para o praso de entrega
     * */

    vm.calculateTimeRamaining = function () {
      vm.currentDate = new Date();
      vm.cardDate = new Date(vm.card.date)
      vm.timeDifference = vm.cardDate - vm.currentDate;

      if(vm.timeDifference < 24 * 60 * 60 * 1000) {
        return true;
      } else {
        return false;
      }
    };

    /**
     * Salva a solicitação
     * @param card
     */
    vm.submit = function (card) {
      vm.show_loader = true;
      if (card.id !== null) {
        if(card.process_type_id !== 8  && card.process_type_id !== 6) {
          card.person_id_owner = vm.user_id;
        }
        ProcessCrudService.updateProcess({card: card, id: card.id})
          .then(function () {
            vm.show_loader = false;
            Common.Toast.success('Solicitação atualizada com sucesso!');
            $rootScope.$broadcast('UPDATE.list');
            $mdDialog.hide();
          })
          .catch(function (resp) {
            vm.show_loader = false;
            if (resp.data.message === 'TIME_SHOCK') {
              Common.Toast.warning('Existe outra solicitação neste horário.');
              vm.card.time = null;
              vm.getHoursUnavailable();
            } else if (resp.data.message === 'TIMEOUT_EXPIRED') {
              Common.Toast.warning('Tempo limite para edição expirado');
              vm.get.card.time = null;
              vm.getHoursUnavailable();
            } else {
              Common.Toast.error(resp.data.message);
            }
          })
      } else {
        card.person_id_owner = vm.user_id;
        ProcessCrudService.createProcess({card: card})
          .then(function () {
            vm.show_loader = false;
            Common.Toast.success('Solicitação criada com sucesso!');
            $rootScope.$broadcast('UPDATE.list');
            if (vm.save_process === false) {
              $mdDialog.hide();
            }
          })
          .catch(function (resp) {
            vm.show_loader = false;
            if (resp.data.message === 'TIME_SHOCK') {
              Common.Toast.warning('Existe outra solicitação neste horário.');
              vm.card.time = null;
              vm.getHoursUnavailable();
            } else if (resp.data.message === 'DUPLICATED_PROCESS') {
              Common.Toast.warning('Solicitação já existente.');

            } else if (resp.data.message === 'HAS_BLOCK_DATE') {
              Common.Toast.warning('Esse tipo de solicitação possui um bloqueio nessa data');

            } else {
              Common.Toast.error(resp.data.message);
            }
          })
      }
    }

    /**
     * Abre o input para edição do item
     * @param event
     * @param item
     */
    vm.editComment = function (event, item) {
      event.stopPropagation();
      var promise = $mdEditDialog.small({
        modelValue: item.qty,
        placeholder: 'Quantidade',
        save: function (input) {
          item.qty = input.$modelValue;
        },
        targetEvent: event
      });
      promise.then(function (ctrl) {
        var input = ctrl.getInput();
        input.$viewChangeListeners.push(function () {
          input.$setValidity('test', input.$modelValue !== 'test');
        });
      });
    };

    vm.deleteFile = function (file) {
      ModalFactory.confirm(null,
        "Excluir anexo",
        "Confirma a exclusão desse anexo? Esta ação não é reversível",
        "Confirmar", "Cancelar", "process")
        .then(function () {
          $rootScope.show_loader = true;
          ProcessCrudService.deleteArtifact({
            artifact_id: file.id,
            process_id: vm.card.id
          })
            .then(function () {
              $rootScope.show_loader = false;
              $rootScope.$broadcast('ARTIFACT.delete');
              Common.Toast.success('Anexo excluído com sucesso!');
            }).catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.error('Erro ao excluir anexo');
          });
        });
    }


    vm.downloadFile = function (file) {
      console.log(file);
      var deffered = Common.$q.defer();
      const link = document.createElement('a');
      try {
        var blob = new Blob([file], {type: file.extension});
        var url = window.URL.createObjectURL(blob);
        console.log(url);

        link.setAttribute('href', url);
        link.setAttribute("download", file.name);

        var clickEvent = new MouseEvent("click", {
          "view": window,
          "bubbles": true,
          "cancelable": true
        });
        link.dispatchEvent(clickEvent);
        deffered.resolve(true);
      } catch (ex) {
        deffered.reject(ex);
      }
    }

    vm.getTimeSinceComment = function (comment) {
      if (angular.isUndefined(comment.date_done) || angular.isUndefined(comment.time_done)) {
        return '';
      }
      var date_time = a4Moment(comment.date_done + ' ' + comment.time_done);
      return date_time.fromNow();
    }

    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    // Methods
    // vm.palettes = fuseTheming.getRegisteredPalettes();
    // vm.rgba = fuseGenerator.rgba;
    // vm.toggleInArray = msUtils.toggleInArray;
    // vm.exists = msUtils.exists;
    vm.closeDialog = closeDialog;
    vm.getCardList = getCardList;
    vm.removeCard = removeCard;
    /* Attachment */
    vm.toggleCoverImage = toggleCoverImage;
    vm.removeAttachment = removeAttachment;
    /* Labels */
    vm.labelQuerySearch = labelQuerySearch;
    vm.filterLabel = filterLabel;
    vm.addNewLabel = addNewLabel;
    vm.removeLabel = removeLabel;
    /* Members */
    vm.memberQuerySearch = memberQuerySearch;
    vm.filterMember = filterMember;
    /* Checklist */
    vm.updateCheckedCount = updateCheckedCount;
    vm.addCheckItem = addCheckItem;
    vm.removeChecklist = removeChecklist;
    vm.removeChecklistItem = removeChecklistItem;
    vm.createCheckList = createCheckList;

    //////////

    /**
     * Close Dialog
     */
    function closeDialog() {
      $rootScope.$broadcast('UPDATE.list');
      $mdDialog.cancel();
    }

    /**
     * Get Card List
     */
    function getCardList() {
      var response;
      for (var i = 0, len = vm.board.lists.length; i < len; i++) {
        if (vm.board.lists[i].idCards.indexOf(vm.card.id) > -1) {
          response = vm.board.lists[i];
          break;
        }
      }
      return response;
    }

    /**
     * Remove card
     *
     * @param ev
     */
    function removeCard(ev) {
      var confirm = $mdDialog.confirm({
        title: 'Remove Card',
        parent: $document.find('#scrumboard'),
        textContent: 'Are you sure want to remove card?',
        ariaLabel: 'remove card',
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        ok: 'Remove',
        cancel: 'Cancel'
      });

      $mdDialog.show(confirm).then(function () {
        var cardList = getCardList();

        cardList.idCards.splice(cardList.idCards.indexOf(vm.card.id), 1);

        vm.board.cards.splice(vm.board.cards.indexOf(vm.card), 1);

      }, function () {
        // Canceled
      });
    }

    /**
     * Toggle cover image
     *
     * @param attachmentId
     */
    function toggleCoverImage(attachmentId) {
      if (attachmentId === vm.card.idAttachmentCover) {
        vm.card.idAttachmentCover = null;
      } else {
        vm.card.idAttachmentCover = attachmentId;
      }
    }

    /**
     * Remove attachment
     *
     * @param item
     */
    function removeAttachment(item) {
      if (vm.card.idAttachmentCover === item.id) {
        vm.card.idAttachmentCover = '';
      }
      vm.card.artifacts.splice(vm.card.artifacts.indexOf(item), 1);
    }

    /**
     * Add label chips
     *
     * @param query
     * @returns {filterFn}
     */
    function labelQuerySearch(query) {
      return query ? vm.labels.filter(createFilterFor(query)) : [];
    }

    /**
     * Label filter
     *
     * @param label
     * @returns {boolean}
     */
    function filterLabel(label) {
      if (!vm.labelSearchText || vm.labelSearchText === '') {
        return true;
      }

      return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
    }

    /**
     * Add new label
     */
    function addNewLabel() {
      vm.board.labels.push({
        id: msUtils.guidGenerator(),
        name: vm.newLabelName,
        color: vm.newLabelColor
      });

      vm.newLabelName = '';
    }

    /**
     * Remove label
     */
    function removeLabel() {
      var arr = vm.board.labels;
      arr.splice(arr.indexOf(arr.getById(vm.editLabelId)), 1);

      angular.forEach(vm.board.cards, function (card) {
        if (card.idLabels && card.idLabels.indexOf(vm.editLabelId) > -1) {
          card.idLabels.splice(card.idLabels.indexOf(vm.editLabelId), 1);
        }
      });

      vm.newLabelName = '';
    }

    /**
     * Add member chips
     *
     * @param query
     * @returns {Array}
     */
    function memberQuerySearch(query) {
      return query ? vm.members.filter(createFilterFor(query)) : [];
    }

    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Member filter
     *
     * @param member
     * @returns {boolean}
     */
    function filterMember(member) {
      if (!vm.memberSearchText || vm.memberSearchText === '') {
        return true;
      }

      return angular.lowercase(member.name).indexOf(angular.lowercase(vm.memberSearchText)) >= 0;
    }

    /**
     * Update check list stats
     * @param list
     */
    function updateCheckedCount(list) {
      var checkItems = list.checkItems;
      var checkedItems = 0;
      var allCheckedItems = 0;
      var allCheckItems = 0;

      angular.forEach(checkItems, function (checkItem) {
        if (checkItem.checked) {
          checkedItems++;
        }
      });

      list.checkItemsChecked = checkedItems;

      angular.forEach(vm.card.checklists, function (item) {
        allCheckItems += item.checkItems.length;
        allCheckedItems += item.checkItemsChecked;
      });

      vm.card.checkItems = allCheckItems;
      vm.card.checkItemsChecked = allCheckedItems;
    }

    /**
     * Add checklist item
     *
     * @param text
     * @param checkList
     */
    function addCheckItem(text, checkList) {
      if (!text || text === '') {
        return;
      }

      var newCheckItem = {
        'name': text,
        'checked': false
      };

      checkList.checkItems.push(newCheckItem);

      updateCheckedCount(checkList);
    }

    /**
     * Remove checklist
     *
     * @param item
     */
    function removeChecklist(item) {
      vm.card.checklists.splice(vm.card.checklists.indexOf(item), 1);

      angular.forEach(vm.card.checklists, function (list) {
        updateCheckedCount(list);
      });
    }

    /**
     * Remove checklist Item
     *
     * @param item
     */
    function removeChecklistItem(item, list) {
      list.splice(list.indexOf(item), 1);

      angular.forEach(vm.card.checklists, function (list) {
        updateCheckedCount(list);
      });
    }

    /**
     * Create checklist
     */
    function createCheckList() {
      vm.card.checklists.push({
        id: msUtils.guidGenerator(),
        name: vm.newCheckListTitle,
        checkItemsChecked: 0,
        checkItems: []
      });

      vm.newCheckListTitle = '';
    }

    /**
     * Add new comment
     *
     * @param newCommentText
     */
    // function addNewComment(newCommentText) {
    //   var newComment = {
    //     idMember: '36027j1930450d8bf7b10158',
    //     message: newCommentText,
    //     time: 'now'
    //   };
    //
    //   vm.card.comments.unshift(newComment);
    // }
    vm.printList = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET', 'api/process/reports/printList',
        {
          process_id: vm.card.id,
          person_owner_name: vm.card.person_owner_name
        }).then(function () {
        $rootScope.show_loader = false;
      })
    };


    /**
     * Filter for chips
     *
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
      };
    }

    vm.init();
  }

  angular
    .module('app.process.process-crud')
    .controller('ProcessCardDialogController', ProcessCardDialogController);
})();

(function () {
  'use strict';

  angular
    .module('app.finance.settings', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function SettingsTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "SETTINGS": {
        "TITLE": "Configurações"
      }
    })

  }

  angular
    .module('app.finance.settings')
    .config(SettingsTranslate);
})();

(function () {
    'use strict';
    angular.module('app.finance.finance-reports.undo-movements-report', []);
  })();
(function () {
    'use strict';
  
    /** @ngInject */
    function UndoMovementsReportController($rootScope, BankSlipService, ReportsService, a4Moment, Common) {
      var vm = this;
      vm.all_accounts = null
      vm.current_account = null
      vm.filter_date = null
  
      vm.init = function () {
        vm.getAllCurrentAccount();
      };

      vm.getAllCurrentAccount = function () {
        vm.all_accounts = [];
        BankSlipService.getAllCurrentAccounts()
          .then(function (response) {
            vm.all_accounts = response.plain();
          });
      };

      vm.generateReport = function () {
        $rootScope.show_loader = true;
        ReportsService.reportFactory('GET',
          'api/reports/undomovementsreport',
          {
            current_account: vm.current_account,
            start_date: vm.filter_date.startDate !== null ? a4Moment(vm.filter_date.startDate).format('YYYY-MM-DD') : null,
            end_date: vm.filter_date.endDate !== null ? a4Moment(vm.filter_date.endDate).format('YYYY-MM-DD') : null
          }
        ).then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Relatório impresso com sucesso!');
        }).catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.error("Houve um erro ao imprimir o relatório.");
        })
      }
  
      vm.init();
    }
  
  
    angular.module('app.finance.finance-reports.undo-movements-report')
      .controller('UndoMovementsReportController', UndoMovementsReportController)
  })();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports.undo-check-pad-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function UndoCheckPadReportController($scope, $stateParams,$document, $rootScope, CONFIG, FinanceReportsService, ReportsService, Session) {
    var vm = this;
    vm.disable = true;
    vm.webLink = CONFIG.webApiUri;
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    vm.generateReport = function () {
      var href = vm.webLink + 'api/reports/undocheckpadreport?token=' +
        vm.conf.token + '&company=' + vm.conf.current_company
        + '&connection=' + vm.conf.current_connection +
        '&start_date=' + vm.filter_date.startDate + '&final_date='
        + vm.filter_date.endDate + '&user_id=' + vm.conf.user_id;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };

    vm.init();
  }

  angular.module('app.finance.finance-reports.undo-check-pad-report')
    .controller('UndoCheckPadReportController', UndoCheckPadReportController);
})();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports', [
    'app.finance.finance-reports.defaults',
    'app.finance.finance-reports.designed-realized-report',
    'app.finance.finance-reports.payments-report',
    'app.finance.finance-reports.deleted-bills-report',
    'app.finance.finance-reports.negotiations-report',
    'app.finance.finance-reports.current-account-movements'
  ]);
})();
(function () {
  'use strict';

  /** @ngInject */
  function FinanceReportsTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "REPORTS": {
        "PRINT": "Imprimir relatório"
      }
    })

  }

  angular
    .module('app.finance.finance-reports')
    .config(FinanceReportsTranslate);
})();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports.reverse-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ReverseReportController($scope, $stateParams,$document, $rootScope, CONFIG, FinanceReportsService, ReportsService, Session) {
    var vm = this;
    vm.disable = true;
    vm.webLink = CONFIG.webApiUri;
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    vm.generateReport = function () {
      var href = vm.webLink + 'api/reports/reversereport?token=' + vm.conf.token + "&current_school_period=" + $stateParams.school_period_id +  '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        '&start_date=' + vm.filter_date.startDate + '&final_date=' + vm.filter_date.endDate + '&user_id=' + vm.conf.user_id;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };

    vm.init();

  }

  angular.module('app.finance.finance-reports.reverse-report')
    .controller('ReverseReportController', ReverseReportController)

})();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports.products-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ProductsReportController($filter, $scope, $stateParams, $document, $rootScope, CONFIG, FinanceReportsService,
                                    ReportsService, Session, ProductService, EducationalService, Common) {
    var vm = this;
    vm.product_selected = null;
    vm.disable = true;
    vm.webLink = CONFIG.webApiUri;
    vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.product_groups = [];
    vm.products_report = {product_ids: []};

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.getProducts();
      vm.getSchoolPeriod();
    };

    vm.getProducts = function () {
      ProductService.getOnlyProducts().then(function (response) {
        vm.products = response;
      })
    };

    vm.generateReport = function (isCsv) {
      if (isCsv) {
        ReportsService.reportFactory('GET', 'api/reports/productsreportcsv',
          {
            startDate: vm.filter_date.startDate,
            finalDate: vm.filter_date.endDate,
            product_id: vm.product_selected,
            groups: vm.products_report.product_ids.join(','),
            is_csv: true
          },
          "RELATORIO_PRODUTOS_AVULSOS.csv"
        );
      } else {
        ReportsService.reportFactory('GET', 'api/reports/productsreport',
          {
            startDate: vm.filter_date.startDate,
            finalDate: vm.filter_date.endDate,
            product_id: vm.product_selected,
            groups: vm.products_report.product_ids.join(',')
          }
        );
        // var href = vm.webLink + 'api/reports/productsreport?token=' + vm.conf.token + "&current_school_period=" + $stateParams.school_period_id
        //   + '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        //   '&startDate=' + vm.filter_date.startDate + '&finalDate=' + vm.filter_date.endDate
        //   + '&user_id=' + vm.conf.user_id + '&product_id=' + vm.product_selected;
        // var element = document.createElement('a');
        // element.setAttribute('href', href);
        // element.setAttribute('target', '_blank');
        // return element.click();
      }
    };

    /**
     * Retorna todos agrupamentos
     */
    vm.allProductGroups = function () {
      if (vm.product_groups.length === 0) {
        return ProductService.getProductGroupsUsedByPeriod()
          .then(function (response) {
            vm.product_groups = response.plain();
            vm.product_groups.unshift({id: null, name: 'Nenhum'});
            $rootScope.show_loader = false;
          })
          .catch(function (error) {
            $rootScope.show_loader = false;
            Common.Toast.error(error)
          });
      } else {
        var deffered = Common.$q.defer();
        deffered.resolve(vm.product_groups);
        return deffered.promise;
      }
    };

    /**
     * Retorna os serviços associados a um grupo de serviço
     * @param group_id
     */
    vm.getProductsByGroup = function (group_id) {
      vm.products_report.product_ids = [];
      if (group_id === null) {
        vm.products_report.product_group_id = undefined;
      } else {
        ProductService.getProductsByGroup({group_id: group_id, show_group_completed: true})
          .then(function (resp) {
            vm.products = resp.plain();
          });
      }
    };

    vm.setProducts = function (products) {
      if (angular.isUndefined(products)) {
        vm.products_report.product_ids = [];
      } else if (products[0] === null) {
        vm.products.forEach(function (item) {
          vm.products_report.product_ids.push(item.id);
        })
      }
    };

    /**
     *  Retorna o periodo letívo selecionado
     */
    vm.getSchoolPeriod = function () {
      EducationalService.getSchoolsPeriod()
        .then(function (periods) {
          vm.school_period = periods.plain();
          vm.current_school_period_name = $filter('filter')(vm.school_period.list, {id: vm.current_school_period_id})[0].name;
          $rootScope.show_loader = false;
        })
    };


    vm.init();
  }

  angular.module('app.finance.finance-reports.products-report')
    .controller('ProductsReportController', ProductsReportController);
})();

(function () {
  'use strict';

  angular.module('app.finance.finance-reports.payments-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function PaymentsReportController($scope, $stateParams,Common, $http, $document, $rootScope, CONFIG, FinanceReportsService, ReportsService, Session) {
    var vm = this;
    vm.type = 'manual';
    vm.disable = true;
    vm.webLink = CONFIG.webApiUri;
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.status = "PAIDS";
    vm.type_bill = "receive";


    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };

    vm.generateReportPDF = function () {
      ReportsService.reportFactory('GET', 'api/reports/paymentsreport', {
        startDate: vm.filter_date.startDate,
        finalDate:  vm.filter_date.endDate,
        type: vm.type,
        status: vm.status,
        typeBill: vm.type_bill
      });
    };

    vm.init();

  }

  angular.module('app.finance.finance-reports.payments-report')
    .controller('PaymentsReportController', PaymentsReportController);
})();
(function () {
  'use strict';

  angular.module('app.finance.finance-reports.negotiations-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function NegotiationsReportController($scope, $stateParams, $document, $rootScope, a4Moment,
                                        CONFIG, FinanceReportsService, ReportsService, Session) {
    var vm = this;
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.filter_date =
      {
        startDate: a4Moment(),
        endDate: a4Moment().startOf('day')
      };

      vm.generateReport = function () {
        ReportsService.reportFactory('GET',
          'api/reports/negotiationsreport',
          {
            current_school_period: $stateParams.school_period_id,
            company: vm.conf.current_company,
            start_date: a4Moment(vm.filter_date.startDate).format('YYYY-MM-DD'),
            final_date: a4Moment(vm.filter_date.endDate).format('YYYY-MM-DD'),
            user_id: vm.conf.user_id
          }).catch(function () {
            Common.Toast.error('Mão foi possível imprimir o relatório');
        })
        //var href = vm.webLink + 'api/reports/negotiationsreport?token=' + vm.conf.token + "&current_school_period=" +
        //  $stateParams.school_period_id + '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        //  '&start_date=' + a4Moment(vm.filter_date.startDate).format('YYYY-MM-DD') + '&final_date=' + a4Moment(vm.filter_date.endDate).format('YYYY-MM-DD')
        //  + '&user_id=' + vm.conf.user_id;
        //var element = document.createElement('a');
        //element.setAttribute('href', href);
        //element.setAttribute('target', '_blank');
        //return element.click();
      };


    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };
    vm.init();
  }

  angular.module('app.finance.finance-reports.negotiations-report')
    .controller('NegotiationsReportController', NegotiationsReportController);
})();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports.monthly-receive-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function MonthlyReceiveReportController($scope, $stateParams,Common, $http, $document, $rootScope, CONFIG, FinanceReportsService, ReportsService, Session) {
    var vm = this;
    vm.disable = true;
    vm.webLink = CONFIG.webApiUri;
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };


    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };

    vm.generateReportPDF = function () {
      var href = vm.webLink + 'api/reports/monthlyreceivereport?token=' + vm.conf.token + "&current_school_period=" + $stateParams.school_period_id +'&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        '&startDate=' + vm.filter_date.startDate + '&finalDate=' + vm.filter_date.endDate + '&user_id=' + vm.conf.user_id;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.generateReportCSV = function () {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/monthlyreceivereport?startDate=' + vm.filter_date.startDate + '&finalDate='
          + vm.filter_date.endDate + '&user_id=' + vm.conf.user_id + '&is_csv=' + true + '&token=' + vm.conf.token,
        data: {variables: ''},
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;
        
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          // linkElement.setAttribute('target', '_blank');
          var filename = 'RELATORIO_MENSALIDADES.csv';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      });
      return deffered.promise;
    };

    vm.init();
  }


  angular.module('app.finance.finance-reports.monthly-receive-report')
    .controller('MonthlyReceiveReportController', MonthlyReceiveReportController)
})();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports.monthly-financial-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function MonthlyFinancialReportController($document,$scope, $stateParams, $rootScope, a4Moment, CONFIG,
                                            ReportsService, Session, ngTreetableParams, FinanceReportsService, Common) {

    var vm = this;
    vm.visualization = 2;
    vm.accumulated = 0;
    vm.accumulated_balance = [];
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };


    vm.dateComponent = {
      current_date: a4Moment().format('MMM/YY'),
      range: {
        start_date: a4Moment().subtract(12, 'month'),
        end_date: a4Moment().subtract(1, 'month').endOf('month')
      }
    };

    vm.init = function () {
      vm.buildTreeTable();
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };

    vm.print = function () {
      ReportsService.reportFactory('GET',
        'api/reports/monthlyfinancialflow/print',
        {
          start_date:a4Moment(vm.dateComponent.range.start_date).format('YYYY-MM-DD'),
          end_date: a4Moment(vm.dateComponent.range.end_date).format('YYYY-MM-DD'),
          visualization: vm.visualization
        });

    };

    vm.buildTreeTable = function () {
      var deferred = Common.$q.defer();
      $rootScope.show_loader = true;
      $scope.dynamic_params = new ngTreetableParams({
        getNodes: function (parent) {
          vm.data = FinanceReportsService.getDataMonthlyFinancialReport({
            start_date: vm.dateComponent.range.start_date.format('YYYY-MM-DD'),
            end_date: vm.dateComponent.range.end_date.format('YYYY-MM-DD')
          });
          vm.accumulated = 0;
          vm.data
        .then(function (records) {
          vm.columns = Object.keys(records[0].columns);
          vm.incomes = records[0];
          vm.expenses = angular.isDefined(records[1]) ? records[1] : 0;
          if(vm.accumulated_balance.length == 0) {
          vm.calcAccumulatedBalance();
          }
          $rootScope.show_loader = false;
        })
            .catch(function () {
              $rootScope.show_loader = false;
            });

          return parent ? parent.children : vm.data;
        },
        getTemplate: function () {
          return 'tree_node';
        },
        options: {
          onNodeExpand: function () {
          }
        }
      });
      return deferred.promise;
    };

    /**
     * Data Anterior
     */
    vm.previousDate = function () {
      vm.accumulated = 0;
      vm.accumulated_balance = [];
      vm.dateComponent.range.start_date = vm.dateComponent.range.start_date.subtract(1, 'month');
      vm.dateComponent.range.end_date = vm.dateComponent.range.end_date.subtract(1, 'month');
      $scope.dynamic_params.refresh();
      $rootScope.show_loader = true;
    };


    /**
     * Proxima data
     */
    vm.nextDate = function () {
      vm.accumulated = 0;
      vm.accumulated_balance = [];
      vm.dateComponent.range.start_date = vm.dateComponent.range.start_date.add(1, 'month');
      vm.dateComponent.range.end_date = vm.dateComponent.range.end_date.add(1, 'month');
      $scope.dynamic_params.refresh();
      $rootScope.show_loader = true;
    };

    /**
     * Monta a lista de saldo acumulado
     */
    vm.calcAccumulatedBalance = function () {
      var obj = {};
      angular.forEach(vm.columns, function (value, key) {
        if(vm.expenses == 0) {
          obj.accumulated = parseInt(vm.incomes[value]);
        } else {
          obj.accumulated = vm.incomes[value] - vm.expenses[value];
        }
        vm.accumulated = obj.accumulated + parseInt(vm.accumulated);
        obj.column = key;
        vm.accumulated_balance.push(vm.accumulated);
      });
    };

    vm.init();

  }

  angular
    .module('app.finance.finance-reports.monthly-financial-report')
    .controller('MonthlyFinancialReportController', MonthlyFinancialReportController)
})();

(function () {
  'use strict';
  angular.module('app.finance.finance-reports.income-tax-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function IncomeTaxReportController($scope, $stateParams,$document, CONFIG, $rootScope, FinanceReportsService, Session, ReportsService,
                                     a4Moment) {

    var vm = this;
    vm.webLink = CONFIG.webApiUri;
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.year = a4Moment().format('YYYY');

    /**
     * Busca os responsáveis financeiros para o autocomplete
     * @param text
     * @returns {*}
     */
    vm.getPersonPayeeByName = function (text) {
      return FinanceReportsService.getPersonPayeeByName({query: text, year: vm.year});
    };

    vm.generateReport = function () {
      ReportsService.reportFactory( 'GET', 'api/reports/incometax',
        {
          school_period_id: $stateParams.school_period_id,
          company: vm.conf.current_company,
          person_id: vm.selectedPerson.id,
          year: vm.year
        });
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.years = [];
      for (var i2 = 0; i2 <= 15; i2++) {
        var momentVar = a4Moment().subtract(i2,'year');
        vm.years.push({id: momentVar.year(), name: momentVar.format('YYYY')});
      }
    };

    vm.init();
  }

  angular
    .module('app.finance.finance-reports.income-tax-report')
    .controller('IncomeTaxReportController', IncomeTaxReportController)
})();

(function () {
  'use strict';
  angular.module('app.finance.finance-reports.finance-movement-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function FinanceMovementReportController(a4Moment, ReportsService, $document, CONFIG, Session, CashierManagementService,
                                           $stateParams, Common, $http, $rootScope) {
    var vm = this;
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.form = {
      period_type: 0,
      period: a4Moment().format('YYYY-MM-DD'),
      filter: 0,
      cashier_session: null,
      finance_movement: true,
      detail_finance_movement: false,
      totalization_type: 'C',
      received_bills: true,
      products_sold: true,
      money_details: true,
      check_details: true,
      card_details: true,
      transference_details: true,
      enrolment_number: false
    };

    vm.getCashierSessions = function () {
      CashierManagementService.getAllCashierSession({no_paginate: true}).then(function (response) {
        vm.cashier_sessions = response.plain()
      })
    };

    vm.generateReport = function () {
      var deffered = Common.$q.defer();
      $rootScope.show_loader = true;
      $http({
        method: 'GET',
        url: vm.webLink + 'api/reports/financemovementreport?token=' + vm.conf.token + "&current_school_period=" + $stateParams.school_period_id + '&company=' + vm.conf.current_company
          + '&connection=' + vm.conf.current_connection + '&enrolment_number=' + vm.form.enrolment_number + "&reverse_movements=" + true +
          '&period_type=' + vm.form.period_type + '&period=' + a4Moment(vm.form.period).format('YYYY-MM-DD') + '&filter=' + vm.form.filter + '&start_date=' + vm.form.period.startDate +
          '&final_date=' + vm.form.period.endDate + '&cashier_session=' + vm.form.cashier_session + '&finance_movement=' + vm.form.finance_movement +
          '&detail_finance_movement=' + vm.form.detail_finance_movement + '&totalization_type=' + vm.form.totalization_type
          + '&received_bills=' + vm.form.received_bills + '&products_sold=' + vm.form.products_sold + '&money_details=' + vm.form.money_details + '&check_details='
          + vm.form.check_details + '&card_details=' + vm.form.card_details + '&transference_details=' + vm.form.transference_details + '&user_id=' + vm.conf.user_id,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
          $rootScope.show_loader = false;
        } catch (ex) {
          deffered.reject(ex);
          $rootScope.show_loader = false;
        }
      });
      return deffered.promise;
    };

    vm.verifyDate = function () {
      if (vm.form.period_type === 0) {
        vm.form.period = a4Moment();
      } else {
        vm.form.period = null;
      }
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.getCashierSessions();
    };

    vm.init();

  }

  angular.module('app.finance.finance-reports.finance-movement-report')
    .controller('FinanceMovementReportController', FinanceMovementReportController);
})();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports.differences-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function DifferencesReportController($scope, $stateParams,$document, $rootScope, CONFIG, FinanceReportsService, ReportsService, Session) {
    var vm = this;
    vm.webLink = CONFIG.webApiUri;
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.difference_option = 0;
    vm.disable = true;

    vm.generateReport = function () {
      var href = vm.webLink + 'api/reports/differencesreport?token=' + vm.conf.token + "&current_school_period=" + $stateParams.school_period_id +'&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        '&option=' + vm.difference_option + '&user_id=' + vm.conf.user_id +
        '&start_date=' + vm.filter_date.startDate + '&final_date=' + vm.filter_date.endDate;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };

    vm.init();
  }

  angular.module('app.finance.finance-reports.differences-report')
    .controller('DifferencesReportController', DifferencesReportController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DesignedRealizedReportController(a4Moment, ReportsService, $document, CONFIG, Session, CashierManagementService,
                                            FinanceReportsService, GroupService, Restangular, $rootScope, CourseService,
                                            $http, Common, $stateParams, LocalStorage, CoordinatorsService) {
    var vm = this;
    vm.webLink = CONFIG.webApiUri;
    vm.courses = [];
    vm.course_selected_id = 0;
    vm.group_selected_id = 0;
    vm.report_vision = angular.isUndefined(LocalStorage.get('report_vision')) || LocalStorage.get('report_vision') === null ? 0 : LocalStorage.get('report_vision');
    vm.groups = [];
    vm.selectedCoursesAndGroups = [];
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.filter_date = {
      startDate: a4Moment().startOf('year').format('YYYY-MM-DD'),
      endDate:a4Moment().endOf('year').format('YYYY-MM-DD')
    };

    //Busca informações para a treeview de curso e turma
    vm.setTree = function () {
      CoordinatorsService.getTree()
        .then(function (response) {
          vm.coursesAndGroups = response.plain();
        });
    };


    vm.filter_settlement_date = {
      startDate: null,
      endDate: null
    };

    vm.ranges = {
      'Ano anterior': [a4Moment().subtract(1, 'year').startOf('year'), a4Moment().subtract(1, 'year').endOf('year')] ||
                      [a4Moment().subtract(1, 'year').startOf('year'), a4Moment().endOf('year')],

      'Este ano':     [a4Moment().startOf('year'), a4Moment().endOf('year')],

      'Ano seguinte': [a4Moment().add(1, 'year').startOf('year'), a4Moment().add(1, 'year').endOf('year')] ||
                      [a4Moment().startOf('year'), a4Moment().add(1, 'year').endOf('year')]
    };

    vm.tree_data = [
      {name: '---'}
    ];

    vm.col_defs_1 = [
      {
        field: "amount",
        displayName: "Valor Principal",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "amount_qty",
        displayName: "Qtd",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field]}}</span></div>"
      },
      {
        field: "discount_fixed_value",
        displayName: "Desconto Fixo",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "discount_fixed_perc",
        displayName: "% Desconto Fixo",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | number:2}}%</span></div>"
      },
      {
        field: "amount_net",
        displayName: "Líquido",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "discount_cond_value",
        displayName: "Desconto Cond",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "discount_cond_perc",
        displayName: "% Desconto Cond",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | number:2}}%</span></div>"
      },
      {
        field: "amount_tot_net",
        displayName: "Líquido",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      }
    ];
    vm.col_defs_2 = [
      {
        field: "amount_total_received",
        displayName: "Valor Recebido",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "qty_received",
        displayName: "Qtd",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field]}}</span></div>"
      },
      {
        field: "amount_received",
        displayName: "Valor Principal",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "allowance_received",
        displayName: "Abono",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field]*-1 | currency:\"\"}}</span></div>"
      },
      {
        field: "discount_received",
        displayName: "Desconto",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "fine_received",
        displayName: "Multa",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "interest_received",
        displayName: "Juros",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "difference_received",
        displayName: "Diferença",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "missed_discount",
        displayName: "Desc. vencido",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      }
    ];
    vm.col_defs_3 = [
      {
        field: "final_amount_open",
        displayName: "Valor a Receber",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "amount_open_perc",
        displayName: "% Valor",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | number:2}}%</span></div>"
      },
      {
        field: "qty_open",
        displayName: "Qtd",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field]}}</span></div>"
      },
      {
        field: "qty_open_perc",
        displayName: "% Qtd",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | number:2}}%</span></div>"
      },
      {
        field: "amount_open",
        displayName: "Valor Principal",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "discount_open",
        displayName: "Desconto",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "fine_open",
        displayName: "Multa",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "interest_open",
        displayName: "Juros",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      },
      {
        field: "missed_open",
        displayName: "Desc. perdido",
        headTemplate: "<div style='text-align: right;'><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div style='text-align: right'><span>{{row.branch[col.field] | currency:\"\"}}</span></div>"
      }
    ];

    vm.expanding_property = {
      field: "name",
      displayName: "Nome",
      cellTemplate: "<i>{{row.branch[expandingProperty.field]}}</i>"
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.getDesignedRealizedReport(vm.filter_date, vm.filter_settlement_date);
      vm.getCourses();
      vm.setTree();
    };

    /**
     * Define o tipo de visão do relatório
     */
    vm.defineReportVision = function () {
      LocalStorage.add('report_vision', vm.report_vision);
    }

    vm.getCourses = function () {
      $rootScope.show_loader = true;
      CourseService.getAll({only_active: true})
        .then(function (response) {
          vm.courses = response.plain();
        });
      $rootScope.show_loader = false;
    };

    vm.getGroups = function (course_selected) {
      GroupService.getGroupsByCourse(course_selected)
        .then(function (response) {
          vm.groups = response.plain().data;
        });
    };

    /**filtra o array de turmas selecionadas para evitar duplicações */
    vm.onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };

    /**Filtro para remover o periodo da string **/
    vm.removePeriodOfString =  function (value) {
      return value.slice(0,-2);
    };

    vm.printReport = function () {
      vm.filterSelectedCoursesAndGroups=[];
      vm.filterSelectedCoursesAndGroups = vm.selectedCoursesAndGroups.filter(vm.onlyUnique)
      vm.filterSelectedCoursesAndGroups = vm.filterSelectedCoursesAndGroups.map(vm.removePeriodOfString)
      var deffered = Common.$q.defer();
      $rootScope.show_loader = true;
      $http({
        method: 'GET',
        url: vm.webLink + 'api/reports/printdesignedrealized?token=' + vm.conf.token + "&current_school_period=" + $stateParams.school_period_id + '&company='
          + vm.conf.current_company + '&connection=' + vm.conf.current_connection + '&user_id=' + vm.conf.user_id
          + '&course_id=' + vm.course_selected_id + '&group_id=' + vm.group_selected_id
          + (vm.filter_date.startDate !== null ? '&startDate=' + vm.filter_date.startDate : '')
          + (vm.filter_date.endDate !== null ? '&endDate=' + vm.filter_date.endDate : '')
          + (vm.filter_settlement_date.startDate !== null ? '&startSettlementDate=' + vm.filter_settlement_date.startDate : '')
          + (vm.filter_settlement_date.endDate !== null ? '&endSettlementDate=' + vm.filter_settlement_date.endDate : '')
          + '&selectedTab=' + vm.selected_tab
          + '&reportVision=' + vm.report_vision
          + '&selectedCoursesAndGroups=' + vm.filterSelectedCoursesAndGroups,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
          $rootScope.show_loader = false;
        } catch (ex) {
          deffered.reject(ex);
          $rootScope.show_loader = false;
        }
      });
      return deffered.promise;
    };

    vm.getDesignedRealizedReport = function (filter_date, filter_settlement_date) {
      $rootScope.show_loader = true;
      vm.filterSelectedCoursesAndGroups = [];
      vm.filterSelectedCoursesAndGroups = vm.selectedCoursesAndGroups.filter(vm.onlyUnique)
      vm.filterSelectedCoursesAndGroups = vm.filterSelectedCoursesAndGroups.map(vm.removePeriodOfString)
      .join(", ");

      var obj = {};
      if (angular.isDefined(filter_date)) {
        obj = {
          endDate: filter_date.endDate,
          startDate: filter_date.startDate,
          course_id: vm.course_selected_id,
          group_id: vm.group_selected_id,
          startSettlementDate: filter_settlement_date.startDate,
          endSettlementDate: filter_settlement_date.endDate,
          report_vision: vm.report_vision,
          filterSelectedCoursesAndGroups: vm.filterSelectedCoursesAndGroups
        };
      } else {
        obj = {
          course_id: vm.course_selected_id,
          group_id: vm.group_selected_id
        }
      }
      Restangular.one('reports').one('designedrealizedreport').get(obj)
        .then(function (response) {
          vm.tree_data = response.plain();
          $rootScope.show_loader = false;
        });
    };

    vm.init();

  }

  angular.module('app.finance.finance-reports.finance-movement-report')
    .controller('DesignedRealizedReportController', DesignedRealizedReportController);
})();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports.deleted-bills-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function DeletedBillsReportController($scope, $stateParams, $document, $rootScope, a4Moment,
                                        CONFIG, FinanceReportsService, ReportsService, Session, CashierSessionService,
                                        PersonService) {
    var vm = this;
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.bank_number = null;
    vm.selectedPerson = null;
    vm.filter_date =
      {
        startDate: a4Moment(),
        endDate: a4Moment().startOf('day')
      };

    vm.getPersonByName = function (query) {
      return PersonService.getPersonWithFilter({query: query});
    };

    vm.generateReport = function () {
      var person_id = null;
      if (vm.selectedPerson !== null) {
        person_id = vm.selectedPerson.id;
      }
      var href = vm.webLink + 'api/reports/deletedbillsreport?token=' + vm.conf.token + "&current_school_period=" +
        $stateParams.school_period_id + '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        '&person_id=' + person_id + '&bank_number=' + vm.bank_number +
        '&start_date=' + a4Moment(vm.filter_date.startDate).format('YYYY-MM-DD') + '&final_date=' + a4Moment(vm.filter_date.endDate).format('YYYY-MM-DD') + '&user_id=' + vm.conf.user_id;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };
    vm.init();
  }

  angular.module('app.finance.finance-reports.deleted-bills-report')
    .controller('DeletedBillsReportController', DeletedBillsReportController);
})();
(function () {
  'use strict';
  angular
    .module('app.finance.finance-reports.defaults', [])
})();
(function () {
  'use strict';

  /** @ngInject */
  function DefaultsReportController($rootScope, a4Moment, FinanceReportsService, Common, $http, CONFIG, ProductService,
                                    EducationalService, Session, $filter, CourseService, GroupService) {

    var vm = this;
    vm.financial_default = [];
    vm.filter_date = {
      start_date: null,
      end_date: null
    };
    vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.qty_bills = null;
    vm.filter_school_period = true;
    vm.group_type = 1;
    vm.service_filter = 1;
    vm.product_groups = [];
    vm.allProductGroups = [];
    vm.default_report = {product_ids: []};
    vm.course_id = 0;
    vm.group_id = 0;

    vm.init = function () {
      vm.getFinancialDefaultReport(1, 10);
      vm.getSchoolPeriod();
      vm.getCourses();
    };

    /**
     *  Retorna o periodo letívo selecionado
     */
    vm.getSchoolPeriod = function () {
      EducationalService.getSchoolsPeriod()
        .then(function (periods) {
          vm.school_period = periods.plain();
          vm.current_school_period_name = $filter('filter')(vm.school_period.list, {id: vm.current_school_period_id})[0].name;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Retorna todos os cursos ativos.
     */
    vm.getCourses = function () {
      CourseService.getAll({only_active: true})
        .then(function (response) {
          vm.courses = response.plain();
        });
      $rootScope.show_loader = false;
    };

    /**
     * Retorna as turmas de um curso selecionado
     * @param course_id
     */
    vm.getGroups = function (course_id) {
      GroupService.getGroupsByCourse(course_id)
        .then(function (response) {
          vm.groups = response.plain().data;
          if (vm.groups.length > 0) {
            vm.groups.push({id: 0, name: 'Todas as turmas'});
            vm.print.group_selected = 0;
          } else {
            vm.groups.push({id: 0, name: 'Todas as turmas'});
            vm.print.group_selected = null;
          }
        });
    };

    /**
     * Retorna os dados do relatório
     * @param page - Pagina corrente
     * @param qtd - Quantidade de registros
     */
    vm.getFinancialDefaultReport = function (page, qtd) {
      $rootScope.show_loader = true;
      qtd = angular.isUndefined(qtd) ? 10 : vm.financial_default.per_page;
      page = angular.isUndefined(page) ? 1 : vm.financial_default.current_page;

      vm.promise = FinanceReportsService.getDefaultsReport(
        {
          page: page, qtd: qtd, qty_bills: vm.qty_bills,
          start_date: vm.filter_date.startDate,
          end_date: vm.filter_date.endDate,
          product_group_id: vm.default_report.product_group_id,
          products: vm.default_report.product_ids.join(','),
          group_type: vm.group_type,
          service_filter: vm.service_filter,
          filter_school_period: vm.filter_school_period
        })
        .then(function (records) {
          vm.financial_default = records;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Retorna todos agrupamentos
     */
    vm.allProductGroups = function () {
      if (vm.product_groups.length === 0) {
        return ProductService.getProductGroupsUsedByPeriod()
          .then(function (response) {
            vm.product_groups = response.plain();
            vm.product_groups.unshift({id: null, name: 'Nenhum'});
            $rootScope.show_loader = false;
          })
          .catch(function (error) {
            $rootScope.show_loader = false;
            Common.Toast.error(error)
          });
      } else {
        var deffered = Common.$q.defer();
        deffered.resolve(vm.product_groups);
        return deffered.promise;
      }
    };

    /**
     * Retorna os serviços associados a um grupo de serviço
     * @param group_id
     */
    vm.getProductsByGroup = function (group_id) {
      vm.default_report.product_ids = [];
      if (group_id === null) {
        vm.default_report.product_group_id = undefined;
      } else {
        ProductService.getProductsByGroup({group_id: group_id, show_group_completed: true})
          .then(function (resp) {
            vm.products = resp.plain();
          });
      }
    };

    vm.setProducts = function (products) {
      if (angular.isUndefined(products)) {
        vm.default_report.product_ids = [];
      } else if (products[0] === null) {
        vm.products.forEach(function (item) {
          vm.default_report.product_ids.push(item.id);
        })
      }
    };

    vm.printDefaultsReport = function () {
      $rootScope.show_loader = true;
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/printdefaultreport?qty_bills=' + vm.qty_bills +
          (angular.isDefined(vm.filter_date.startDate) ? "&start_date=" + vm.filter_date.startDate : '') +
          (angular.isDefined(vm.filter_date.endDate) ? "&end_date=" + vm.filter_date.endDate : '') +
          (angular.isDefined(vm.default_report.product_group_id) ? "&product_group_id=" + vm.default_report.product_group_id : '') +
          (angular.isDefined(vm.default_report.product_ids) ? "&products=" + vm.default_report.product_ids : '') +
          (angular.isDefined(vm.group_type) ? "&group_type=" + vm.group_type : '') +
          (angular.isDefined(vm.service_filter) ? "&service_filter=" + vm.service_filter : '') +
          (angular.isDefined(vm.course_id) ? "&course_id=" + vm.course_id : '') +
          (angular.isDefined(vm.group_id) ? "&group_id=" + vm.group_id : '') +
          '&filter_school_period=' + vm.filter_school_period,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');


          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
          $rootScope.show_loader = false;
        } catch (ex) {
          deffered.reject(ex);
          $rootScope.show_loader = false;
        }
      });
      return deffered.promise;
    };

    vm.calcAmountBase = function (item) {
      var sum = 0;
      item.foreach(function (i) {
        if (item.level === 3) {
          sum += i.amount_base;
        }
      })
      return sum;
    };
    vm.init();
  }

  angular
    .module('app.finance.finance-reports.defaults')
    .controller('DefaultsReportController', DefaultsReportController)
})();

(function () {
  'use strict';

  angular.module('app.finance.finance-reports.current-account-movements', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountMovementsController($scope, $stateParams, $document, $rootScope, a4Moment, BankSlipService,
                                             CONFIG, FinanceReportsService, ReportsService, Session) {
    var vm = this;
    vm.selectedCurrentAccount = null;
    vm.currentAccounts = [];
    vm.filterDate =
      {
        startDate: a4Moment().startOf('month'),
        endDate: a4Moment().endOf('month')
      };

    vm.getAllCurrentAccount = function () {
      $rootScope.show_loader = true;
      BankSlipService.getAllCurrentAccounts()
        .then(function (response) {
          vm.currentAccounts = response.plain();
          $rootScope.show_loader = false;
        });
    };

    vm.generateReport = function () {
      ReportsService.reportFactory('GET', 'api/reports/currentaccountmovements', {
        current_account_id: vm.selectedCurrentAccount,
        start_date: a4Moment(vm.filterDate.startDate).format('YYYY-MM-DD'),
        end_date: a4Moment(vm.filterDate.endDate).format('YYYY-MM-DD')
      });
    };


    vm.init = function () {
      vm.getAllCurrentAccount();
    };
    vm.init();
  }

  angular.module('app.finance.finance-reports.current-account-movements')
    .controller('CurrentAccountMovementsController', CurrentAccountMovementsController);
})();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports.collaborators-protocol', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function CollaboratorsProtocolController($scope, $stateParams,$document, $rootScope, CONFIG, FinanceReportsService, ReportsService, Session,CoordinatorsService,PoliciesService) {

    var vm = this;
    vm.report_name = null;
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.only_teachers = false;
    vm.all_companies = false;
    vm.companyQty=0;
    vm.selectedCoursesAndGroups = [];
    //A criação dessa variável é para evitar sobrescrição da variável retorno do componente treeview
    vm.filterSelectedCoursesAndGroups=[];
    vm.generateReport = function () {
      vm.filterSelectedCoursesAndGroups = vm.selectedCoursesAndGroups.filter(vm.onlyUnique);
      //Group id está concatenado com a matrix curricular no dois últimos dígitos, então estão com a length de até 4 dígitos
      //vm.filterSelectedCoursesAndGroups = vm.filterSelectedCoursesAndGroups.filter(vm.onlyGroupsIdsWithPeriod);
      //Filtro para remover o periodo da string
      vm.filterSelectedCoursesAndGroups = vm.filterSelectedCoursesAndGroups.map(vm.removePeriodOfString);
      ReportsService.reportFactory('GET',
        'api/reports/collaboratorsprotocol',
        {
          token:vm.conf.token,
          current_school_period:$stateParams.school_period_id,
          company:vm.conf.current_company,
          title:vm.report_name,
          user_id:vm.conf.user_id,
          only_teachers: vm.only_teachers,
          all_companies:vm.all_companies,
          groups:vm.filterSelectedCoursesAndGroups
        })
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
          vm.conf.current_school_period_id = $scope.educational.school_period.selected.id;
        });
      vm.setTree();
      vm.getCompanyQty();
    };

    vm.onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };

    vm.onlyGroupsIdsWithPeriod = function (value) {
      return value.length>0 && value.length<=4;
    }
    vm.removePeriodOfString =  function (value) {
      return value.slice(0,-2);
    }

    vm.setTree = function () {
      CoordinatorsService.getTree()
        .then(function (response) {
          vm.coursesAndGroups = response.plain();
        });
    };

    vm.getCompanyQty = function (){
      PoliciesService.companyQty().then(function (response) {
        vm.companyQty = response;
      });
    }

    vm.init();

  }

  angular
    .module('app.finance.finance-reports.collaborators-protocol')
    .controller('CollaboratorsProtocolController', CollaboratorsProtocolController)
})();

(function () {
  'use strict';
  angular.module('app.finance.finance-reports.cashier-session-resume', []);
})();
(function () {
  'use strict';

  /** @ngInject */
    function CashierSessionResumeController($scope, $stateParams,$document, $rootScope, a4Moment, CONFIG, FinanceReportsService, ReportsService, Session, CashierSessionService) {
    var vm = this;
    vm.disable = true;
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.filter_date =
      {
        startDate: a4Moment(),
        endDate: a4Moment().startOf('day')
      };
    vm.user_report = null;
    vm.persons = [];

    vm.generateReport = function () {
      var href = vm.webLink + 'api/reports/cashiersessionresume?token=' + vm.conf.token + "&current_school_period=" + $stateParams.school_period_id +'&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        '&start_date=' + vm.filter_date.startDate + '&final_date=' + vm.filter_date.endDate + '&user_id=' + vm.conf.user_id + "&person_id=" + vm.user_report;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.getCashierSessionPersons = function () {
      CashierSessionService.getCashierSessionPersons().then(function (response) {
        vm.persons = response.plain();
      })
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.getCashierSessionPersons();
    };


    vm.init();
  }

  angular
    .module('app.finance.finance-reports.cashier-session-resume')
    .controller('CashierSessionResumeController', CashierSessionResumeController)

})();
(function () {
  'use strict';
  angular.module('app.finance.finance-reports.bill-charge-report', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BillChargeReportController($scope, $stateParams, Common, $http, $document, $rootScope, CONFIG, FinanceReportsService, ReportsService, Session, BillGridService) {
    var vm = this;
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null,
      current_school_period: null
    };
    vm.charge_selected = null;

    vm.getBillChargeStatus = function () {
      $rootScope.show_loader = true;
      BillGridService.getBillChargeStatus().then(function (response) {
        vm.bill_charge_status = response.plain();
        $rootScope.show_loader = false;
      })
    };

    vm.generateReportPDF = function () {
      var href = vm.webLink + 'api/reports/billchargestatusreport?token=' + vm.conf.token + "&current_school_period="
        + $stateParams.school_period_id + '&company=' + vm.conf.current_company
        + '&connection=' + vm.conf.current_connection + '&user_id=' + vm.conf.user_id
        + '&bill_charge_status=' + vm.charge_selected + '&school_period_id=' + vm.conf.current_school_period;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.generateReportCSV = function () {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/billchargestatusreport?&bill_charge_status=' + vm.charge_selected + '&user_id='
          + vm.conf.user_id + '&is_csv=' + true + '&school_period_id=' + vm.conf.current_school_period + '&token=' + vm.conf.token,
        data: {variables: ''},
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          // linkElement.setAttribute('target', '_blank');
          var filename = 'RELATORIO_STATUS_COBRANCAS.csv';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      });
      return deffered.promise;
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.getBillChargeStatus();
    };

    vm.init();
  }

  angular.module('app.finance.finance-reports.bill-charge-report')
    .controller('BillChargeReportController', BillChargeReportController);
})();
(function () {
  'use strict';

  angular
    .module('app.finance.person', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function PersonTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "PERSON": {
              "A_TO_Z": "de A à Z",
              "ADD_PERSON": "Adicionar pessoa",
              "ALL_PERSONS": "Todas as pessoas",
              "BACK": "Voltar",
              "CHANGE_AVATAR": "Alterar imagem",
              "CLOSE_SIDENAV_EDIT": "Fechar Edição",
              "CLOSE_SIDENAV_CREATE": "Fechar Criação",
              "COMPANY": "Empresa",
              "DELETE_PERSON": "Excluir pessoa",
              "DELETE_SELECTED": "Excluir o selecionado",
              "EDITABLE": "Editar",
              "EDIT_AVATAR": "Editar imagem",
              "FORM": "Perfil do Usuário",
              "FORM_ADDRESS_CITY": "Cidade",           
              "FORM_ADDRESS_CITY_REQUIRED": "A cidade é necessária.",
              "FORM_ADDRESS_DISTRICT": "Bairro",
              "FORM_ADDRESS_DISTRICT_REQUIRED": "O bairro é necessário.",
              "FORM_ADDRESS_LINE2": "Complemento",
              "FORM_ADDRESS_LINE2_REQUIRED": "O complemento é necessário.",
              "FORM_ADDRESS_HOUSE_NUMBER": "Número",
              "FORM_ADDRESS_HOUSE_NUMBER_REQUIRED": "O número é necessário.",
              "FORM_ADDRESS_POSTAL_CODE": "CEP",
              "FORM_ADDRESS_POSTAL_CODE_REQUIRED": "O CEP é necessário.",
              "FORM_ADDRESS_STREET": "Rua",
              "FORM_ADDRESS_STREET_REQUIRED": "A rua é necessária.",
              "FORM_ADDRESS_STATE": "Estado",
              "FORM_ADDRESS_STATE_REQUIRED": "O estado é necessário.",
              "FORM_CATEGORY": "Categoria",
              "FORM_CATEGORY_REQUIRED": "A categoria é necessária.",
              "FORM_CLIENT": "Cliente",
              "FORM_CORPORATE_NAME": "Razão Social",
              "FIRM_CORPORATE_NAME_REQUIRED": "A razão social é necessária.",
              "FORM_CPF": "CPF",
              "FORM_CPF_REQUIRED": "O CPF é necessária.",
              "FORM_CNPJ": "CNPJ",
              "FORM_CNPJ_REQUIRED": "O CNPJ é necessária.",
              "FORM_CREATE_SUBMIT": "Criar pessoa",
              "FORM_DOB": "Nasc.",
              "FORM_DOB_REQUIRED": "O nascimento é necessário.",
              "FORM_EMAIL": "E-mail",
              "FORM_EMAIL_REQUIRED": "O e-mail é necessário.",
              "FORM_EMPLOYEE": "Funcionário",
              "FORM_PHONE_LANDLINE": "Telefone",
              "FORM_PHONE_LANDLINE_REQUIRED": "O telefone é necessário.",
              "FORM_PHONE_LANDLINE_2": "Telefone 2",
              "FORM_PHONE_MOBILE": "Celular",
              "FORM_PHONE_MOBILE_REQUIRED": "O celular é necessário.",
              "FORM_MAIN_CONTACT_NAME": "Contato principal",
              "FORM_MAIN_CONTACT_NAME_REQUIRED": "O contato principal é necessário.",
              "FORM_NAME_BUSINESS": "Nome fantasia",
              "FORM_NAME_BUSINESS_REQUIRED": "O nome fantasia é necessário.",
              "FORM_NAME": "Nome completo",
              "FORM_NAME_REQUIRED": "O nome completo é necessário.",
              "FORM_NATIONAL_ID": "Identificação",
              "FORM_NATIONAL_ID_REQUIRED": "A identificação é necessária.",
              "FORM_PASSWORD": "Senha.",
              "FORM_PASSWORD_REQUIRED": "A senha é necessária.",
              "FORM_PASSWORD_CONFIRM": "Confirmar senha.",
              "FORM_PASSWORD_CONFIRM_REQUIRED": "A confirmação de senha é necessária.",
              "FORM_SEX": "Sexo",
              "FORM_SEX_REQUIRED": "O sexo é necessário.",
              "FORM_STATE_REGISTRATION_NUMBER": "Inscrição estadual",
              "FORM_STATE_REGISTRATION_NUMBER_REQUIRED": "A inscrição estadual é necessário.",
              "FORM_SUPPLIER": "Fornecedor",
              "FORM_UPDATE_SUBMIT": "Atualizar pessoa",
              "FORM_USER": "Usuário",
              "FIRST_NAME": "Nome",
              "FREQUENTLY": "Frequentes",
              "GROUPS": "Grupos",
              "LAST_NAME": "Sobrenome",
              "NEW_GROUP": "Novo grupo",
              "NO_RESULTS": "Nenhum resultado",
              "SEARCH": "Buscar pessoa",
              "SELECTED": "Selecionado",
              "STARRED_PERSONS": "Votados",
              "SELECT_ALL": "Selecionar todas",
              "SELECT_TYPE_PERSON": "Escolha o tipo pessoa",
              "TITLE_PERSON": "Pessoa",
              "TITLE_COMPANY": "Empresa",
              "DATA_USER": "Dados dos usuário",
              "FORM_USERNAME": "Nome de usuário",
              "FORM_USERNAME_REQUIRED": "O nome de usuário é necessário",
              "PERSON": "Pessoa",
              "SELECT_AVATAR": "Selecione a imagem",
              "Z_TO_A": "de Z à A"
            }
        })

    }

    angular
        .module('app.finance.person')
        .config(PersonTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.finance.person.receipt', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function PersonReceiptController($scope, $a4FloatButton, a4Moment, $rootScope, $stateParams, PersonService, $a4Sidenav,
                                   ModalFactory, $document, CONFIG, $mdDialog, BillExpenseService,
                                   Common, $filter, BillReceiptService, Session, ReportsService) {

    var vm = this;
    vm.has_pending_differences = false;
    vm.has_credit = false;
    vm.has_debit = false;
    vm.show_only_student = false;
    vm.show_all_school_periods = false;
    vm.history = 0;
    vm.credit_balance = 0;
    vm.show_button_more = true;
    vm.school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.cnpjParams = [];
    vm.hasDataToLoad = true;
    vm.bills = {expenses: [], receipts: [], checks: []};
    vm.filter_date = null;
    vm.date = vm.filter_date;
    vm.show = false;
    vm.qtd = 20;
    vm.hasDebts = false;
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.current_page = 0;
    var updateList = $rootScope.$on('bill-receipt.UPDATE', function () {
      vm.getListOfReceiptFromPerson(vm.current_page, 20, vm.filter_date, $stateParams.id)
    });

    $scope.$on('change-show-only-student', function (event, change_show_only_student) {
      vm.show_only_student = change_show_only_student;
    });
    $scope.$on('change-show-all-periods', function (event, show_all_school_periods) {
      vm.show_all_school_periods = show_all_school_periods;
    });

    vm.resize = function () {
      if (vm.pendencies_message !== '' && vm.pendencies_message !== null) {
        vm.windowHeight = (angular.element("#content").height() - (angular.element("#toolbar").height())) * 0.51;
      } else {
        vm.windowHeight = (angular.element("#content").height() - (angular.element("#toolbar").height())) * 0.55;
      }
      if (vm.windowHeight < 100) {
        vm.windowHeight = 400;
      }
      if (vm.windowHeight < 415) {
        vm.windowHeight = vm.windowHeight * 0.95;
        if (vm.windowHeight < 380) {
          vm.windowHeight = vm.windowHeight * 0.93;
        }
        if (vm.windowHeight < 350) {
          vm.windowHeight = vm.windowHeight * 0.91;
          if (vm.windowHeight < 270) {
            vm.windowHeight = vm.windowHeight * 0.85;
          }
        }
      }
    };

    $(window).resize(function () {
      vm.resize();
    });

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      vm.person_id = $stateParams.id;
      vm.getListOfReceiptFromPerson(1, vm.qtd, vm.filter_date, vm.person_id);
      vm.getPendenciesMessage();
      vm.getPendingDifferences();
      vm.resize();
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.status_filter = BillReceiptService.getFilterStatus();
    };

    /**
     * Criação de um contrato
     */
    vm.openCreateModal = function () {
      ModalFactory.customClean('app/components/a4-contract-grid/create-contract-modal.html',
        'CreateContractController', 'vm', true, {})
        .then(function () {
          vm.getAllContracts(1, 15);
        });
    };

    vm.getPendenciesMessage = function () {
      PersonService.getPendenciesMessage(vm.person_id)
        .then(function (response) {
          vm.pendencies_message = response;
        });
    };

    /**
     * Retona os
     * @param page
     * @param qtd
     * @param search_name
     */
    vm.getAllContracts = function (page, qtd, search_name) {
      $rootScope.show_loader = true;
      vm.promise = BillReceiptService.getAllContracts({
        debit_credit: 'C',
        page: page,
        qtd: qtd,
        person_id: angular.isUndefined(vm.person_id) ? undefined : vm.person_id,
        search_name: search_name
      })
        .then(function (response) {
          vm.allContracts = response.plain();
          /**
           * Verificação da data final, para verificar se o contrato está cancelado
           */
          for (var i = vm.allContracts.data.length; i--;) {
            if (vm.allContracts.data[i].date_end !== null && a4Moment(vm.allContracts.data[i].date_end).isBefore(a4Moment().format('YYYY-MM-DD'))) {
              vm.allContracts.data[i].is_date_end_before_today = true;
            } else {
              vm.allContracts.data[i].is_date_end_before_today = false;
            }
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.printBillsResponsible = function (date, status, all_bills) {
      $rootScope.show_loader = true;
      var startDate = date === null ? null : date.startDate;
      var endDate = date === null ? null : date.endDate;
      if (angular.isDefined(status) && status.length > 0) {
        status = status.map(function (item) {
          return item.id;
        }).toString();
      }
      var obj = {
        startDate: startDate,
        endDate: endDate,
        status: status,
        person_id: vm.person_id,
        user_id: vm.conf.user_id,
        is_student: false,
        show_only_student: vm.show_only_student,
        show_all_school_periods: vm.show_all_school_periods,
        debit_credit: 'C',
        all_bills: all_bills,
      };
      BillReceiptService.printReport(obj)
        .then(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Busca o saldo de diferenças pendentes nos títulos
     */
    vm.getPendingDifferences = function () {
      BillReceiptService.getPendingDifferences({person_id: vm.person_id})
        .then(function (response) {
          var data = response.plain();
          vm.pending_differences = Math.abs(angular.copy(data.amount));
            vm.history = data.counter;
          if (data.amount > 0) {
            vm.has_credit = true;
          } else if (data.amount < 0) {
            vm.has_debit = true;
          }
        });
    };

    /**
     * Retorna as obrigações a receber
     * @param page
     * @param qtd
     * @param date
     * @param person_id
     * @param status
     * @param flag
     * @param order
     * @param show_only_student
     */
    vm.getListOfReceiptFromPerson = function (page, qtd, date, person_id, status, flag, order, show_only_student) {
      vm.show_button_more = true;
      vm.current_page++;
      person_id = (angular.isUndefined(person_id) || person_id === null) ? vm.person_id : person_id;
      date = date == null || angular.isUndefined(date) ? {startDate: null, endDate: null} : date;
      if (angular.isDefined(status) && status.length > 0) {
        status = status.map(function (item) {
          return item.id;
        }).toString();
      }

      if (angular.isDefined(date) && date.startDate !== null) {
        vm.date = date;
      }

      var obj = {
        startDate: vm.date === null || angular.isUndefined(vm.date) ? date.startDate : vm.date.startDate,
        endDate: vm.date === null || angular.isUndefined(vm.date) ? date.endDate : vm.date.endDate,
        debit_credit: 'C', person_id: person_id, status: status,
        page: page === 1 ? page : vm.current_page,
        qtd: page === 1 && vm.current_page !== page ? vm.current_page * 20 : 20,
        direction: angular.isUndefined(order) ? 'asc' : (order.substring(0, 1) === '-' ? 'asc' : 'desc'),
        only_selected_school_period: (vm.date === null || angular.isUndefined(vm.date)) && date.startDate === null ?
          true : null,
        show_only_student: vm.show_only_student,
        show_all_school_periods: vm.show_all_school_periods

      };

      vm.show_loader = true;
      vm.promise = PersonService.getBillsFromPerson(obj)
        .then(function (bills) {
          var bills_data = bills.plain();
          if (obj.page === 1) {
            vm.bills.receipts = bills_data;
          } else {
            vm.bills.receipts.data = vm.bills.receipts.data.concat(bills_data.data);
          }
          if (bills_data.data.length === 0) {
            vm.show_button_more = false;
          }
          vm.bills.receipts.order = order;
          vm.show = vm.bills.receipts.data.length > 0;
          vm.show_loader = false;
        })
        .catch(function () {
          vm.show_loader = false;
        });
    };

    vm.init();

    $scope.$on('$destroy', function () {
      [updateList].forEach(function (fn) {
        fn();
      })
    })

  }

  angular
    .module('app.finance.person.receipt')
    .controller('PersonReceiptController', PersonReceiptController)
    .filter('makeUppercase', function () {
      return function (item) {
        return item.toUpperCase();
      };
    });
})
();

(function () {
  'use strict';

  angular
    .module('app.finance.person.profile', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function PersonProfileController($stateParams, ModalFactory, PersonService, $mdDialog, Common,
                                   $rootScope, a4Moment, PoliciesService) {

    var vm = this;

    vm.cnpjParams = [];
    vm.sexList = [
      {value: 'm', name: 'Masculino'},
      {value: 'f', name: 'Feminino'}
    ];

    vm.init = function () {
      vm.getProfile($stateParams.id);
    };

    /**
     * Resgata o perfil da pessoa
     * @param id
     */
    vm.getProfile = function (id) {
      $rootScope.show_loader = true;
      PersonService.getProfile(id)
        .then(function (response) {
          vm.person = response;
          vm.person.dob = a4Moment(response.dob);
          vm.company_mother_selected = vm.person.company_mother;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Função chamada ao modificar o item do autocomplete
     * @param item
     */
    vm.onAutoCompleteItemChange = function (item) {
      vm.person.person_id_company_mother = item.id
    };

    /**
     * Remove uma pessoa empresa filha de uma mãe
     * @param child_id - Identificador da pessoa empresa filha
     */
    vm.removeChildCompany = function (child_id) {

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm().title('Deseja realmente remover esta pessoa empresa filha?')
        .ariaLabel('remover empresa filha').ok('Sim, remova!').cancel('Ainda não');

      $mdDialog.show(confirm)
        .then(function () {
          PersonService.removeChildCompany(child_id)
            .then(function (list) {
              Common.Toast.success("Empresa filha removida com sucesso");
              vm.person.children = list;
            })
            .catch(function (error) {
              Common.Toast.error(error.message)
            });
        });

    };


    /**
     * Retona as empresas possiveis de serem Empresa mãe
     */
    vm.getPossibleMatrixCompany = function (search) {
      var current_company_id = $stateParams.id;
      return PersonService.getPossibleMatrixCompany({search: search, current_company_id: current_company_id});
    };

    /**
     * Retorna o captcha para ser preenchido
     * @param ev
     * @param cnpj
     * @param person
     */
    vm.getCnpjCaptcha = function (ev, cnpj, person) {
      vm.cnpjParams.captchaBase64 = null;
      PersonService.getCnpjCaptcha()
        .then(function (response) {
          ModalFactory.open("validate-cnpj/validate-cnpj", ev, "PersonController", {
            cnpj: cnpj,
            person: person,
            getCnpjCaptcha: vm.getCnpjCaptcha,
            cnpjParams: response,
            postCnpjInfo: vm.postCnpjInfo
          }, 'finance');
        })
        .catch(function (error) {
          Common.Toast.error(JSON.stringify(error));
        });
    };

    /**
     * Retorna os dados da empresa
     * @param cnpj
     * @param captcha
     * @param cnpjParams
     * @param person
     */
    vm.postCnpjInfo = function (cnpj, captcha, cnpjParams, person) {
      PersonService.postCnpjInfo(cnpj, captcha, cnpjParams)
        .then(function (response) {
          if (response != null) {
            $mdDialog.cancel();
            person.name = response.nome_fantasia;
            person.corporate_name = response.razao_social;
            person.address_postal_code = response.cep;
            person.address_street = response.logradouro;
            person.address_line2 = response.complemento;
            person.address_state = response.uf;
            person.address_city = response.cidade;
            person.phone_landline = response.telefone;
            person.address_house_number = response.numero;
            person.address_district = response.bairro;
          }
        })
        .catch(function (error) {
          if (error.data === "CAPTCHA_ERROR") {
            Common.Toast.error('Erro ao digitar captcha');
          }
        });
    };

    /**
     * Retorna o endereço do usuário pelo CEP
     * @param cep
     * @param person
     */
    vm.getAddressByCep = function (cep, person) {

      PersonService.getAddressByCep(cep)
        .then(function (response) {
          if (response != null && angular.isDefined(response.logradouro)) {
            person.address_street = response.logradouro;
            person.address_line2 = response.complemento;
            person.address_district = response.bairro;
            person.address_city = response.localidade;
            person.address_state = response.uf;
          }
        })
        .catch(function () {

        });
    };

    /**
     * Submit do formulario de acordo com o tipo
     * edit ou create.
     * @param {JSON} person
     * @returns {void}
     */
    vm.submitPerson = function (person) {

      $rootScope.show_loader = true;

      // if (person.hasOwnProperty('is_supplier') && person.is_supplier === true ||
      //   person.hasOwnProperty('is_client') && person.is_client === true ||
      //   person.hasOwnProperty('is_employee') && person.is_employee === true ||
      //   person.hasOwnProperty('is_user') && person.is_user === true) {
      //   selectedCategory = true;
      // } else {
      //   Common.Toast.error('Selecione uma categoria.');
      //   return;
      // }

      // if (selectedCategory) {

      delete person['person_id'];

      if (person.id == null) {

        PersonService.createPerson(person)
          .then(function () {
            $rootScope.show_loader = false;
            $rootScope.$broadcast('a4.table.close.sidenav');
            Common.Toast.success('Pessoa criada com sucesso.');
          }).catch(function (error) {
          $rootScope.show_loader = false;

          if (error.messages != null) {
            var erros = Object.keys(error.messages);
            for (var i = 0; i < erros.length; i++) {
              angular.element('[name="' + erros[i] + '"]').css('border', '1px solid red');
            }
          } else {
            Common.Toast.error('Erro, não foi possível inserir pessoa. Erro: ' + error);
          }


        });

      } else {
        PersonService.updatePerson(person)
          .then(function () {
            $rootScope.show_loader = false;
            $rootScope.$broadcast('a4.table.close.sidenav');
            Common.Toast.success('Pessoa atualizada com sucesso.');
            vm.getProfile($stateParams.id);
          })
          .catch(function (error) {
            $rootScope.show_loader = false;
            if (angular.isDefined(error.data.national_id_number)) {
              Common.Toast.error('CPF inválido ou não preenchido.');
            } else {
              Common.Toast.error('Erro, não foi possível atualizar pessoa.');
            }
          });
        // }
      }


      /**
       * Verifica Politicas de acesso
       * @param policy - Identificador da politica de acesso
       * @returns {boolean}
       */
      vm.checkPolicies = function (policy) {
        return !PoliciesService.checkPolicyFromMenu(policy);
      };

    };

    vm.init();

  }

  angular
    .module('app.finance.person.profile')
    .controller('PersonProfileController', PersonProfileController)
    .filter('makeUppercase', function () {
      return function (item) {
        return item.toUpperCase();
      };
    });
})();
(function () {
  'use strict';

  /** @ngInject */
  function PersonProfileCreateController($rootScope, $mdDialog, Common, ModalFactory, PersonService, $state, $stateParams, ModalExtra) {

    var vm = this;
    vm.items = [];
    vm.captcha = null;
    vm.cnpjParams = [];
    vm.searchText = '';
    vm.company_mother_selected = null;
    vm.waiting_cnpj = false;
    vm.form = {editable: true};
    vm.sex = [
      {value: 'm', name: 'Masculino'},
      {value: 'f', name: 'Feminino'}
    ];
    vm.currentItem = {};

    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      vm.createTypePerson = angular.copy(ModalExtra.type);
      vm.currentItem.createTypePerson = ModalExtra.type;
    };

    /**
     * Retona as empresas possiveis de serem Empresa mãe
     */
    vm.getPossibleMatrixCompany = function (search) {
      return PersonService.getPossibleMatrixCompany({search: search});
    };

    /**
     * Função chamada ao modificar o item do autocomplete
     * @param item
     */
    vm.onAutoCompleteItemChange = function (item) {
      vm.currentItem.person_id_company_mother = item.id
    };

    /**
     * Valida para seja selecionado ao menos uma categoria.
     * @param target
     */
    vm.validateCheckbox = function (target) {
      if ((!vm.person.is_supplier || vm.person.is_supplier === null || angular.isUndefined(vm.person.is_supplier))
        && (!vm.person.is_client || vm.person.is_client === null || angular.isUndefined(vm.person.is_client))
        && (!vm.person.is_employee || vm.person.is_employee === null || angular.isUndefined(vm.person.is_employee))
        && (!vm.person.is_user || vm.person.is_user === null || angular.isUndefined(vm.person.is_user))) {
        switch (target) {
          case 'is_supplier':
            vm.person.is_supplier = true;
            break;
          case 'is_client':
            vm.person.is_client = true;
            break;
          case 'is_employee':
            vm.person.is_employee = true;
            break;
          case 'is_user':
            vm.person.is_user = true;
            break;
        }
      }
    };

    vm.getCnpjCaptcha = function (ev, cnpj, person) {
      vm.waiting_cnpj = true;
      vm.cnpjParams.captchaBase64 = null;
      PersonService.getCnpjCaptcha(cnpj)
        .then(function (response) {
          vm.waiting_cnpj = false;
          if (angular.isDefined(response.status) && response.status === 'ERROR') {
            Common.Toast.warning(response.message);
            return;
          }
          person.name = response.fantasia === '' ? response.nome : response.fantasia;
          person.corporate_name = response.nome;
          person.address_postal_code = response.cep.replace(/[^\w\s]/gi, '');
          person.address_street = response.logradouro;
          person.address_line2 = response.complemento;
          person.address_state = response.uf;
          person.address_city = response.municipio;
          person.phone_landline = response.telefone.replace(/[^\w\s]/gi, '');
          person.address_house_number = response.numero;
          person.address_district = response.bairro;
          person.email = response.email;
        })
        .catch(function () {
          vm.waiting_cnpj = false;
        });
    };

    /**
     * Retorna o endereço do usuário pelo CEP
     * @param cep
     * @param person
     */
    vm.getAddressByCep = function (cep, person) {
      if (angular.isDefined(cep) && cep.length) {
        PersonService.getAddressByCep(cep)
          .then(function (response) {
            if (response !== null) {
              person.address_street = response.logradouro;
              person.address_line2 = response.complemento;
              person.address_district = response.bairro;
              person.address_city = response.localidade;
              person.address_state = response.uf;
            }
          })
          .catch(function () {
          });
      }
    };

    vm.postCnpjInfo = function (cnpj, captcha, cnpjParams, person) {
      PersonService.postCnpjInfo(cnpj, captcha, cnpjParams)
        .then(function (response) {
          if (response !== null) {
            $mdDialog.cancel();
            person.name = response.nome_fantasia;
            person.corporate_name = response.razao_social;
            person.address_postal_code = response.cep;
            person.address_street = response.logradouro;
            person.address_line2 = response.complemento;
            person.address_state = response.uf;
            person.address_city = response.cidade;
            person.phone_landline = response.telefone;
            person.address_house_number = response.numero;
            person.address_district = response.bairro;
          }
        })
        .catch(function (response) {
          if (response === "CAPTCHA_ERROR") {
            Common.Toast.warning("Captcha não confere");
          }
        });
    };

    /**
     * Submit do formulario de acordo com o tipo
     * edit ou create.
     * @param {JSON} person
     * @returns {void}
     */
    vm.submitPerson = function (person) {
      person.create_type = 2;
      PersonService.createPerson(person)
        .then(function () {
          $mdDialog.hide(true);
          Common.Toast.success('Pessoa criada com sucesso.');
        })
        .catch(function (error) {
          if (error.data.error === 'CPF_DUPLICATED') {
            Common.Toast.error("Erro ao criar pessoa, esse CPF já está cadastrado no sistema");
          } else if(error.data.error === 'CNPJ_DUPLICATED') {
            Common.Toast.error("Erro ao criar pessoa, esse CNPJ já está cadastrado no sistema");
          }
          if (error.messages !== null) {
            var erros = Object.keys(error.messages);
            for (var i = 0; i < erros.length; i++) {
              angular.element('[name="' + erros[i] + '"]').css('border', '1px solid red');
            }
          } else {
            Common.Toast.error('Erro, não foi possível inserir pessoa. Erro: ' + error);
          }
        });
    };

    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular
    .module('app.finance.person')
    .controller('PersonProfileCreateController', PersonProfileCreateController)
    .filter('makeUppercase', function () {
      return function (item) {
        return item.toUpperCase();
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('app.finance.person.expense', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function PersonExpenseController(a4Moment, $rootScope, $stateParams, PersonService,
                                   $a4Sidenav, ModalFactory, $mdDialog, BillExpenseService,
                                   Common, $filter, BillReceiptService, Session, $scope) {

    var vm = this;
    
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    vm.cnpjParams = [];
    vm.bills = {expenses: [], receipts: [], checks: []};
    vm.filter_date = {
      startDate: a4Moment().startOf('year').format('YYYY-MM-DD'),
      endDate: a4Moment().endOf('year').format('YYYY-MM-DD')
    };
    vm.show = false;
    /** Contador da página, para ser utilizado no infinite scroll */
    vm.page = 1;
    vm.qtd = 20;

    vm.init = function () {
      vm.person_id = $stateParams.id;
      vm.getListOfExpenseFromPerson(vm.page, vm.qtd, vm.filter_date, vm.person_id, null);
      vm.status_filter = BillReceiptService.getFilterStatus();
      vm.conf.user_id = Session.user.id;
      vm.show_only_student = false;
      vm.show_all_school_periods = false;
    };
    $scope.$on('change-show-only-student', function (event, change_show_only_student) {
      vm.show_only_student = change_show_only_student;
    });
    $scope.$on('change-show-all-periods', function (event, show_all_school_periods) {
      vm.show_all_school_periods = show_all_school_periods;
    });
    vm.printBillsResponsible = function (date, status, all_bills) {
      $rootScope.show_loader = true;
      var startDate = date === null ? null : date.startDate;
      var endDate = date === null ? null : date.endDate;
      if (angular.isDefined(status) && status.length > 0) {
        status = status.map(function (item) {
          return item.id;
        }).toString();
      }
      var obj = {
        startDate: startDate,
        endDate: endDate,
        status: status,
        person_id: vm.person_id,
        user_id: vm.conf.user_id,
        is_student: false,
        show_only_student: vm.show_only_student,
        show_all_school_periods: vm.show_all_school_periods,
        debit_credit: 'D',
        all_bills: all_bills,
      };
      BillReceiptService.printReport(obj)
        .then(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna as obrigações a pagar
     * @param page
     * @param qtd
     * @param date
     * @param person_id
     * @param status
     */
    vm.getListOfExpenseFromPerson = function (page, qtd, date, person_id, status) {
      page = angular.isUndefined(page) ? 1 : page;
      qtd = angular.isUndefined(qtd) ? 20 : qtd;
      person_id = (angular.isUndefined(person_id) || person_id == null) ? vm.person_id : person_id;
      date = date == null ? {startDate: null, endDate: null} : date;
      status = angular.isUndefined(status) ? null : vm.getStatusIds(status);
      vm.show_loader = true;
      var obj = {
        startDate: date.startDate, endDate: date.endDate, debit_credit: 'D',
        person_id: person_id, page: page, qtd: qtd,
        status: vm.statusDefined.length === 0 ? null : vm.statusDefined.toString(),
      };
      vm.promise = PersonService.getBillsFromPerson(obj)
        .then(function (bills) {
          vm.bills.expenses = bills.plain();
          vm.show = vm.bills.expenses.data.length > 0;
          vm.show_loader = false;
        })
        .catch(function () {
          vm.show_loader = false;
        });
    };

    vm.getStatusIds = function (status) {
      vm.statusDefined = [];
      if (status) {
        if (status.length === 0) {
          status = null;
        } else {
          for (var i = 0; i < status.length; i++)
            vm.statusDefined.push(status[i].id);
        }
      }
      return vm.statusDefined;
    };

    vm.init();

  }

  angular
    .module('app.finance.person.expense')
    .controller('PersonExpenseController', PersonExpenseController)
    .filter('makeUppercase', function () {
      return function (item) {
        return item.toUpperCase();
      };
    });
})();
(function () {
  'use strict';

  angular
    .module('app.finance.person.check', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function PersonCheckController($stateParams, PersonService) {

    var vm = this;

    vm.cnpjParams = [];
    vm.items = {
      expenses: [],
      receipts: [],
      checks: []
    };

    vm.count = 0;

    vm.init = function () {
      vm.getListOfChecksFromPerson($stateParams.id);
    };


    vm.getListOfChecksFromPerson = function (person_id) {
      PersonService.getChecksFromPerson({person_id: person_id})
        .then(function (response) {
          vm.items.checks = response.checks;
          vm.count = response.count;
        })
    };

    /*vm.init();*/

  }

  angular
    .module('app.finance.person.check')
    .controller('PersonCheckController', PersonCheckController)
    .filter('makeUppercase', function () {
      return function (item) {
        return item.toUpperCase();
      };
    });
})();
(function () {
  'use strict';

  angular
    .module('app.finance.paymentplan', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function PaymentPlanTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "PAYMENT_PLAN": {
        "ADD_PLAN": "Adicionar Plano",
        "TITLE": "Plano de Pagamento",
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "FORM_CREATE": "Criar Plano de Pagamento",
        "SUBMIT_CREATE": "Criar Plano",
        "FORM_EDIT": "Editar Plano de Pagamento",
        "SUBMIT_EDIT": "Salvar Plano"
      }
    })

  }

  angular
    .module('app.finance.paymentplan')
    .config(PaymentPlanTranslate);
})();

(function () {
  'use strict';
  angular.module('app.finance.edit-document', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.edit-document', {
        url: '/{id}/edit-document',
        public: false,
        templateUrl: 'app/finance/payment-plan/edit-document/edit-document.html',
        controller: 'EditDocumentController',
        controllerAs: 'vm',
        params: {
          document: {id: null}
        }
      })
  }

  angular
    .module('app.finance.edit-document')
    .config(routerConfig);

})();

(function () {
  'use strict';

  /** @ngInject */
  function EditDocumentController($scope, $rootScope, $document, $stateParams, Common, CONFIG, Documents, DocumentsService, DropzoneService, LocalStorage, ProductService) {
    var vm = this;
    vm.profile = '';
    vm.is_wysiwyg = true;
    vm.form = {};
    vm.variables = [];
    vm.form.document = {
      date: null,
      final_date: null,
      content: ""
    };

    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");

    /** Define as configurações para o upload */
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/document/uploadfiles?company=' + company + '&connection=' + connection,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['JPG', 'PNG', 'GIF']),
      uploadMultiple: false,
      parallelUploads: 1,
      maxFiles: 1,
      autoProcessQueue: true
    };


    vm.options = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'strikeThrough', 'underline', 'ul', 'ol'],
      ['undo', 'redo', 'clear', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'clear', 'insertImage', 'insertLink', 'insertVideo'],
      ['html'],
    ];

    vm.tinymceOptions = {
      setup: function (editor) {
        vm.editor = editor;
        // editor.execCommand('mceInsertContent', false, text);
      },
      inline: false,
      entity_encoding: "raw",
      plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks ' +
        'visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc ' +
        'insertdatetime advlist lists wordcount imagetools textpattern noneditable charmap emoticons textcolor',
      skin: 'lightgray',
      theme: 'modern',
      fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
      menubar: 'file edit view insert format tools table help forecolor backcolor',
      toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | ' +
        'alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | removeformat | ' +
        'pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ' +
        'ltr rtl | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | ' +
        'tableinsertcolbefore tableinsertcolafter tabledeletecol | forecolor backcolor',
      toolbar_sticky: true,
      color_cols: 5,
      file_picker_callback: function (cb, value, meta) {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.onchange = function () {
          var file = this.files[0];
          var reader = new FileReader();
          reader.onload = function (event) {
            DocumentsService.uploadFile({
              file: {
                photo: event.target.result,
                format: file.type.split('/')[1]
              }
            }).then(function (response) {
              cb(response.upload, {title: file.name});
            });
          };
          reader.readAsDataURL(file);
        };

        input.click();
      },
      color_map: [
        '#BFEDD2', 'Light Green',
        '#FBEEB8', 'Light Yellow',
        '#F8CAC6', 'Light Red',
        '#ECCAFA', 'Light Purple',
        '#C2E0F4', 'Light Blue',

        '#2DC26B', 'Green',
        '#F1C40F', 'Yellow',
        '#E03E2D', 'Red',
        '#B96AD9', 'Purple',
        '#3598DB', 'Blue',

        '#169179', 'Dark Turquoise',
        '#E67E23', 'Orange',
        '#BA372A', 'Dark Red',
        '#843FA1', 'Dark Purple',
        '#236FA1', 'Dark Blue',

        '#ECF0F1', 'Light Gray',
        '#CED4D9', 'Medium Gray',
        '#95A5A6', 'Gray',
        '#7E8C8D', 'Dark Gray',
        '#34495E', 'Navy Blue',

        '#000000', 'Black',
        '#ffffff', 'White'
      ],
      height: 400
    };

    /** Define o comportamento após o upload */
    vm.dzCallbacks = {
      'success': function (file, xhr) {
        vm.form.document.file_reference = xhr.file_reference;
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.init = function () {
      ProductService.getProductById($stateParams.id)
        .then(function (response) {
          vm.service = response.plain();
        });
      Documents.getResources()
        .then(function () {
          vm.profile = 'Todos';
          vm.variables = Documents.getAll();
        });
    };

    vm.setVariable = function (item) {
      vm.editor.insertContent(item.name);
    };

    /**
     * Inverte string
     * @param string
     * @returns {*}
     */
    vm.reverseString = function (string) {
      return string.split('').reverse().join('');
    };
    /**
     * Retorna os dados da mensagem em caso de edição
     * @param id
     */
    vm.getById = function (id) {
      $rootScope.show_loader = true;
      DocumentsService.getById(id)
        .then(function (response) {
          vm.form.document = response;
          vm.is_wysiwyg = vm.form.document.is_wysiwyg;
          $rootScope.show_loader = false;
        })
    };

    vm.submit = function (form, item) {
      $rootScope.show_loader = true;
      if (form.$valid) {
        DocumentsService.updateDocument(item)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Serviço atualizado com sucesso!');
          })
          .catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Erro ao atualizar serviço');
        })
      }
    };

    vm.init();

  }

  angular
    .module('app.finance.edit-document')
    .controller('EditDocumentController', EditDocumentController)
})();
(function () {
  'use strict';

  angular
    .module('app.finance.discounts', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function DiscountsTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "DISCOUNTS": {
              "ADD_RULE": "Adicionar regra",
              "FORM_CREATE_SUBMIT": "Criar regra",
              "FORM_UPDATE_SUBMIT": "Atualizar regra",
              "TITLE": "Regras de descontos",
              "TITLE_CREATE": "Criar regra de descontos",
              "TITLE_EDIT": "Editar regra de descontos",
              "SEARCH_FOR_ANYONE": "Pesquisar",
              "FORM_NAME": "Nome da regra",
              "FORM_NAME_REQUIRED": "O nome da regra é necessária"
            }
        })

    }

    angular
        .module('app.finance.discounts')
        .config(DiscountsTranslate);
})();

(function() {
  'use strict';
  angular
    .module('app.finance.difference-analysis',[])
})();

(function () {
  'use strict';

  /** @ngInject */
  function DifferenceAnalysisTranslate($translateProvider) {
    $translateProvider.translations('pt', {
      'DIFFERENCE_ANALYSIS': {
        'CATEGORY': 'Categoria',
        'AMOUNT': 'Valor',
        'MONTH': 'Mês',
        'YEAR': 'Ano',
        'TAGS': 'Tags',
        'ISSUE_DATE': 'Data do recebimento',
        'ACCRUAL': 'Competência',
        'INSTALLMENT': 'Parcelamento',
        'COMPLEMENTS_NOTES': 'Notas Complementares',
        'ACCRUAL_DATE': 'Data da competência',
        'FORM_REQUIRED': 'Este campo é requerido',
        'DESCRIPTION': 'Descrição',
        'TITLE': 'Análise de Diferenças',
        'PERSON': 'Pessoa'
      }
    });
  }

  angular
    .module('app.finance.difference-analysis')
    .config(DifferenceAnalysisTranslate);
})();
(function () {
  'use strict';

  angular
    .module('app.finance.daily-balance', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function DailyBalanceTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "DAILY-BALANCE": {
        "REOPENING_DAY": "Reabertura",
        "CLOSING_DAY": "Encerramento",
        "CLOSE": "Encerrar",
        "REOPEN": "Reabrir",
        "DAILY_BALANCE": "Saldos diários"
      }
    })

  }

  angular
    .module('app.finance.daily-balance')
    .config(DailyBalanceTranslate);
})();

(function() {
  'use strict';
  angular
    .module('app.finance.currentaccount', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountTranslate($translateProvider) {


    $translateProvider.translations('pt', {
      "CURRENT_ACCOUNT": {
        "ACCOUNT": "Conta",
        "ACCOUNT_CD": "DV",
        "ACCOUNT_ENABLE": "Ativar conta",
        "ACCOUNT_DISABLE": "Desativar conta",
        "ADD_ACCOUNT": "Adicionar nova conta corrente",
        "CLOSING_DAY": "Dia de fechamento",
        "DUE_DAY": 'Dia de vencimento',
        "DUE_DAY_REQUIRED": 'Dia de vencimento é requerido.',
        "DUE_DATE": 'Data de vencimento',
        "DUE_DATE_REQUIRED": 'Data de vencimento é requerido.',
        "FORM_CREATE": "Criar conta corrente",
        "FORM_EDIT": "Editar conta corrente",
        "FORM_INITIAL_BALANCE": "Saldo inicial",
        "FORM_INITIAL_BALANCE_REQUIRED": "O saldo inicial é requerido.",
        "FORM_INITIAL_BALANCE_DATE": "Data do saldo inicial",
        "FORM_INITIAL_BALANCE_DATE_REQUIRED": "A data do saldo inicial é requerido.",
        "FORM_CREDIT_LIMIT": "Limite de crédito",
        "FORM_CREDIT_LIMIT_REQUIRED": "O limite de crédito é requerido.",
        "FORM_SUBMIT": "Salvar",
        "FORM_NAME": "Nome",
        "FORM_NAME_REQUIRED": "O nome da conta é requerido.",
        "FORM_TYPE": "Tipo",
        "FORM_TYPE_REQUIRED": "O tipo da conta é requerido.",
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "TITLE": "Contas correntes",
        "AGENCY_CODE": "Agência",
        "AGENCY_CODE_CD": "DV",
        "FORM_BANKS": "Bancos",
        "IS_MAIN": "Conta principal"
      },
      "CONTA_CORRENTE": 'Conta corrente',
      "CONTA_CAIXA": 'Conta caixa',
      "CONTA_INVESTIMENTO": 'Conta investimento',
      "CONTA_CARTAO_DE_CREDITO": 'Conta cartão de credito',
      "CONTA_CARTAO_DE_CREDITO_RECEBIVEL": 'Conta c. de crédito (recebível)',
      "CONTA_CARTAO_DE_CREDITO_PAGAMENTO": 'Conta c. de crédito (pagamento)',
      "CONTA_CARTAO_DE_DEBITO_RECEBIVEL": 'Conta c. de débito (recebível)',
      "CONTA_CARTAO_DE_DEBITO_PAGAMENTO": 'Conta c. de débito (pagamento)',
      "CONTA_A4_PAG": 'Conta A4 Pag',
      "CONTA_RECEBIVEIS": 'Conta recebíveis',
      "OUTROS": 'Outros',
      "CONTA_BANCO": 'Conta banco',
      "COMPLEMENTS_NOTES": 'Notas complementares',
      "MORE_THEN_ONE_ACTIVE_CONTRACT": "Duas carteiras inativas para essa configuração de cobrança.",
      "FAILED_TO_BANK_COLLECTION_OPTIONS_ID": "Selecione uma configuração de cobrança válida",
      "NO_DESCRIPTION": "Sem descrição",
      "CHECK_COMPENSATION": "Compensação de cheque"
    });

  }

  angular
    .module('app.finance.currentaccount')
    .config(CurrentAccountTranslate);
})();

(function() {
  'use strict';
  angular
    .module('app.finance.bill-receipt', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function BillReceiptTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      'CATEGORY': 'Categoria',
      'AMOUNT': 'Valor',
      'MONTH': 'Mês',
      'YEAR': 'Ano',
      'TAGS': 'Tags',
      'ISSUE_DATE': 'Data do recebimento',
      'ACCRUAL': 'Competência',
      'INSTALLMENT': 'Parcelamento',
      'COMPLEMENTS_NOTES': 'Notas Complementares',
      'ACCRUAL_DATE': 'Data da competência',
      'CONTRACT': {
        'ADD': 'Adicionar',
        'SELECT': 'Selecione',
        'ADD_INCOMES': 'Adicionar Receita',
        'ACCOUNT': 'Conta',
        'TITLE': 'Contratos',
        'INCOME': 'Receita',
        'INCOME_RECEIVABLES': 'Receita Recebida',
        'INCOME_TO_RECEIVE': 'Receita a Receber',
        'INCOME_FREE_PORTION': 'Parcelas Livres',
        'INCOME_RECURRENCE': 'Receita Recorrente',
        'RECEITA': 'Receitas',
        'RECEIVED': 'Recebido de',
        'RECEIVEDOF': 'A receber de',
        'REFERENCE': 'Referência',
        'PRODUCT_SERVICES': 'Produtos/Serviços',
        'PAYMENT_PLAN': 'Plano de Pagamento',
        'PERSON': 'Pessoa',
        'DESCRIPTION': 'Descrição',
        'FORM_EDIT': 'Atualizar recebimento',
        'FORM_CREATE': 'Criar recebimento',
        "FORM_REQUIRED": "Este campo é requerido."
      }
    });

  }

  angular
    .module('app.finance.bill-receipt')
    .config(BillReceiptTranslate);
})();

(function() {
  'use strict';
  angular
    .module('app.finance.check-received', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "CHECK-RECEIVED": {
        "TITLE": "Cheques recebidos"
      }
    });

  }

  angular
    .module('app.finance.check-received')
    .config(CheckReceivedTranslate);
})();

(function() {
  'use strict';
  angular
    .module('app.finance.check-received.bordero', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function BorderoService(Restangular) {
    var vm = this;

    vm.getCheckBatch = function () {
      return Restangular.one('bordero').get();
    };

    vm.confirm = function (check_action_id) {
      return Restangular.one('bordero').all('confirm').post(check_action_id);
    };

    vm.confirmDiscount = function (check_action_id) {
      return Restangular.one('bordero').all('confirmDiscount').post(check_action_id);
    };

    vm.delete = function (check_action_id) {
      return Restangular.one('bordero', check_action_id).remove();
    };

    return {
      getCheckBatch: vm.getCheckBatch,
      confirm: vm.confirm,
      confirmDiscount: vm.confirmDiscount,
      delete: vm.delete
    };

  }

  angular
    .module('app.finance.check-received.bordero')
    .factory('BorderoService', BorderoService);

})();





(function () {
  'use strict';

  /** @ngInject */
  function BorderoDiscountController(ModalExtra, $mdDialog, Common, $rootScope) {
    var vm = this;
    vm.data = ModalExtra;
    vm.discount = {};
    vm.discount.id = vm.data.id;
    vm.discount.account_id = vm.data.account_id;
    vm.discount.date = vm.data.date;
    vm.verifyValue = false;

    vm.answer = function (answer, form) {
      if (form.$valid) {
        $mdDialog.hide(answer);
        $rootScope.show_loader = false;
      }
    };

    vm.verifyDiscount = function (value, total) {
      vm.verifyValue = (value > 0 && value <= total) ? true : false;
      if(value > total){
        Common.Toast.error('O valor está acima do total dos cheques');
      }
    };

    vm.closeModal = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

  }

  angular
    .module('app.finance.check-received.bordero')
    .controller('BorderoDiscountController', BorderoDiscountController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function BorderoController(BorderoService, Common, ModalFactory, a4Moment, $scope, $rootScope) {
    var vm = this;

    vm.checkBatch = {
      data: []
    };

    var ltn = $rootScope.$on('update.BORDERO', function () {
      vm.getBatch();
    });


    vm.init = function () {
      vm.getBatch();
    };

    vm.getBatch = function () {
      BorderoService.getCheckBatch()
        .then(function (list) {
          vm.checkBatch = list;
          $rootScope.show_loader = false;
        })
    };


    /**
     * Confirma lote
     */
    vm.confirmBordero = function (lote) {

      if(lote.check_action_type_id == 4){
        var discount = {};
        discount.id = lote.id;
        discount.account_id = lote.current_account_id_destination;
        discount.date = lote.date;
        discount.totalChecks = lote.totalAmount;

        ModalFactory.customClean('app/finance/check-received/views/dialogs/bordero_discount.html',
          'BorderoDiscountController', 'vm', false, discount)
          .then(function (anwser) {
            vm.confirmBorderoDiscount(anwser);
          });
      }else{
        ModalFactory.confirm(null,
          'Confirmação de lote',
          'Deseja realmente confirmar este lote?',
          'Confirmar', 'Cancelar')
          .then(function () {
            vm.confirmBorderoDefault(lote.id);
          });
      }

    };

    /**
     * Confirma lote sem desconto
     */
    vm.confirmBorderoDefault = function (id) {
      BorderoService.confirm(id)
        .then(function (resp) {
          vm.checkBatch = resp;
          Common.Toast.success('Lote confirmado com sucesso');
          vm.getBatch();
        })
        .catch(function (resp) {
          Common.Toast.warning(resp.data.message);
          $rootScope.show_loader = false;
        })
    };

    /**
     * Confirma lote de desconto
     */
    vm.confirmBorderoDiscount = function (lote) {
      BorderoService.confirmDiscount(lote)
        .then(function (resp) {
          vm.checkBatch = resp;
          Common.Toast.success('Lote confirmado com sucesso');
          vm.getBatch();
        })
        .catch(function (resp) {
          Common.Toast.warning(resp.data.message);
          $rootScope.show_loader = false;
        })
    };

    /**
     * Deleta lote
     */
    vm.deleteBordero = function (check_action_id) {

      ModalFactory.confirm(null,
        'Exclução de lote',
        'Ao executar a exclusão de um lote, esta ação pode ser mais desfeita. Deseja realmente excluir este lote?',
        'Excluir', 'Cancelar')
        .then(function () {

          BorderoService.delete(check_action_id)
            .then(function (resp) {
              vm.checkBatch = resp;
              Common.Toast.success('Exclusão de lote realizada com sucesso');
              $rootScope.show_loader = false;
            })
            .catch(function (resp) {
              Common.Toast.warning(resp.data.message);
              $rootScope.show_loader = false;
            })
        });


    };

    vm.getDate = function (date) {
      return a4Moment(date).format('DD/MM/YYYY');
    };

    vm.checkStatus = function (status) {
      if (status) {
        return 'Realizado';
      }
      return 'Pendente';
    };

    vm.init();

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    })

  }

  angular
    .module('app.finance.check-received.bordero')
    .controller('BorderoController', BorderoController);

})();





(function () {
  'use strict';

  angular
    .module('app.finance.cashier-session', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function CashierSession($translateProvider) {

    $translateProvider.translations('pt', {
      "CASHIER_SESSION": {
        "CASHIER": "Caixa",
        "ACCOUNT": "Conta",
        "SELECT_ACCOUNT": "Selecione uma conta",
        "OPEN": "Abrir",
        "CLOSE": "Encerrar Sessão",
        "CLOSE_SESSION_ERROR": "Erro ao encerrar sessão!",
        "CLOSE_SESSION_SUCCESS": "Sessão encerrada com sucesso!",
        "OPEN_NEW_GUEST_PAD" : 'Abrir nova comanda'
      }
    })

  }

  angular
    .module('app.finance.cashier-session')
    .config(CashierSession);
})();

(function () {
  'use strict';

  /** @ngInject */
  function GuestCheckPadService(Restangular) {
    return {
      getDebitsFromPerson: function (obj) {
        return Restangular.one('guestcheckpad').one('getbills').get(obj);
      },
      getChecksFromPerson: function (obj) {
        return Restangular.one('guestcheckpad').one('getchecksreceived').get(obj);
      },

      getLastBillOpened: function (obj) {
        return Restangular.one('guestcheckpad').one('getlastbillopened').get(obj);
      },

      getAllBillOpened: function (obj) {
        return Restangular.one('guestcheckpad').one('getallbillopened').get(obj);
      },

      getGuestCheckPadReport: function (obj) {
        return Restangular.one('guestcheckpad').one('getguestcheckpadreport').get(obj);
      },

      undoGuestCheckPad: function (obj) {
        return Restangular.one('guestcheckpad').all('undoguestcheckpad').post(obj);
      }
    }

  }

  angular
    .module('app.finance.guest-check-pad')
    .factory('GuestCheckPadService', GuestCheckPadService);

})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.guest-check-pad', {
        url: '/cashier-session/guest-check-pad/:cashier_session_id',
        public: false,
        templateUrl: 'app/finance/cashier-session/guest-check-pad/view/index.html',
        controller: 'GuestCheckPadController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Nova Comanda'
        },
        params: {
          cashier_session_id: null
        }
      });
  }

  angular
    .module('app.finance.guest-check-pad')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function GuestCheckPadController($rootScope, $filter, $state, BillReceiptService, $a4Sidenav, Common, $stateParams, a4Moment, CONFIG,
                                   GuestCheckPadService, PersonService, PoliciesService, ProductService, ModalFactory, Session
  ) {

    var vm = this;
    vm.blockOutOfStockSale = false;
    vm.currentPerson = {};
    vm.imp = false;
    vm.imp2 = false;
    vm.billsselected = [];
    vm.checkpad = [];
    vm.state_name = angular.copy($state.current.name);
    vm.items = {
      bills: [],
      products: [],
      checks: []
    };
    vm.has_pending_differences = false;
    vm.searchProduct = null;


    vm.init = function () {
      vm.cashier_session_id = $stateParams.cashier_session_id;
      vm.current_school_period = Session.getCurrentSchoolPeriod().id;
      $rootScope.show_loader = false;

      ModalFactory.customClean('app/finance/cashier-session/view/searchClient.html',
        /** @ngInject */
        function (PersonService, $mdDialog, $state) {
          var vm = this;
          vm.querySearch = function (query) {
            var person = PersonService.getAllPersons({query: query, paginate: false, is_cashier: true});
            $rootScope.show_loader = false;
            return person;
          };

          vm.submit = function (selectedPerson) {
            $mdDialog.hide(selectedPerson);
          };

          vm.closeModal = function () {
            $mdDialog.cancel();
            $state.go('private.finance.cashier-session');
          };
        }, 'vm', false, {})
        .then(function (person) {
          vm.currentPerson = person;
          vm.getPendingDifferences(vm.currentPerson.id);
        });
      vm.getblockOutStockSales();
    };

    /**
     *
     */
    vm.checkoutPay = function () {
      if (vm.checkpad.length > 0) {

        $a4Sidenav({width: '805px'}).open(
          'app/finance/bill-payment/views/form-payment.html',
          'BillPaymentController',
          'vm', {
            bills: vm.checkpad, cashier_session_id: vm.cashier_session_id, person_id: vm.currentPerson.id,
            person_name: vm.currentPerson.name
          }
        );
      } else {
        Common.Toast.warning('Selecione pelo menos um titulo para pagar.');
      }
    };

    vm.getPendingDifferences = function (person_id) {
      $rootScope.show_loader = true;
      BillReceiptService.getPendingDifferences({person_id: person_id})
        .then(function (response) {
          $rootScope.show_loader = false;
          var data = response.plain();
          vm.pending_differences = parseFloat(data.amount);
          if (vm.pending_differences > 0) {
            vm.has_credit = true;
          } else if (vm.pending_differences < 0) {
            vm.has_debit = true;
          }
        })
        .catch(function () {
          Common.Toast.error('Erro ao buscar diferenças');
          $rootScope.show_loader = false;
        });
    };

    /**
     * Abre modal para confirmar se o usuário quer transformar
     * as diferenças pendentes em um título
     */
    vm.openAddDifferencesModal = function () {
      if (vm.has_debit) {
        ModalFactory.customClean('app/finance/difference-analysis/views/confirm-modal.html',
          'DifferenceAnalysisCreateController', 'vm',
          false, {
            due_date_start: null,
            due_date_end: null,
            settlement_date_start: null,
            settlement_date_end: null,
            person_id_filter: vm.currentPerson.id,
            final_difference_value: vm.pending_differences,
            is_responsible: vm.currentPerson.is_responsible
          }).then(function (response) {
          vm.addDifferenceBill(response);
        });

      }
    };

    /**
     * Cria título de diferença e adiciona à comanda
     */
    vm.addDifferenceBill = function (response) {
      $rootScope.show_loader = true;
      BillReceiptService.createDifferenceBill({
        amount: response.final_difference_value,
        person_id: vm.currentPerson.id,
        associate_to_bank_slip: response.associate_to_bank_slip,
        difference_due_date: response.difference_due_date,
        due_date_bank_slip: response.due_date_bank_slip,
        bank_slip_rule_id: response.bank_slip_rule_id,
        fines_rule_id: response.fines_rule_id
      }).then(function (bill) {
        if (bill.type === 3) {
          bill.final_value = -(bill.final_value);
          bill.amount = -(bill.amount);
        }
        vm.checkpad = vm.checkpad.concat([bill]);
        vm.has_credit = false;
        vm.has_debit = false;
        $rootScope.show_loader = false;
      })
        .catch(function () {
          Common.Toast.error('Erro ao criar título de diferença');
          $rootScope.show_loader = false;
        })
    };

    /**
     * Busca todos os titulos em aberto para a pessoa da comanda
     */
    vm.getAllBillOpened = function () {

      if (vm.checkpad.length > 0) {
        ModalFactory.confirm(null,
          "Existem titulos na comanda",
          "Está opção irá sobrescrever sua comanda, deseja realmente continuar?",
          "Confirmar", "Cancelar", "finance")
          .then(function () {
            vm.requestAllBillOpened();
          })
      } else {
        vm.requestAllBillOpened();
      }
    };

    /**
     ** Busca todos os titulos em aberto para a pessoa da comanda
     */
    vm.requestAllBillOpened = function () {
      vm.checkpad = [];
      $rootScope.show_loader = true;
      var person_id = vm.currentPerson.id;
      GuestCheckPadService.getAllBillOpened({qtd: 50, person_id: person_id, endDate: a4Moment().format('YYYY-MM-DD')})
        .then(function (response) {
          vm.checkpad = response.plain().data;
          for (var i = 0; i < vm.checkpad.length; i++) {
            vm.checkpad[i].quantity = null;
          }
          $rootScope.show_loader = false;
        })
    };

    /**
     * Abre modal com a ficha financeira do cliente
     */
    vm.openFinancialStatement = function () {
      var except = vm.checkpad.map(function (item) {
        if (angular.isUndefined(item.price)) {
          return item.id;
        }
      });

      ModalFactory.customClean('app/finance/cashier-session/guest-check-pad/view/financial-statement.html',
        /** @ngInject */
        function (GuestCheckPadService, ModalExtra, $mdDialog, Common) {
          var vm = this;
          vm.bills = [];
          vm.tableItemsSelected = [];
          vm.init = function (page, qty) {
            page = (angular.isUndefined(page) || page === null) ? 1 : page;
            qty = (angular.isUndefined(qty) || qty === null) ? 12 : qty;
            var order = vm.bills.order;
            GuestCheckPadService.getAllBillOpened({
              page: page, qtd: qty, person_id: ModalExtra.person_id,
              except: ModalExtra.except.toString()
            })
              .then(function (response) {
                vm.bills = response.plain();
                vm.bills.data = vm.bills.data.filter(function(item) {
                  return except.indexOf(item.id) === -1
                })
                vm.bills.data.forEach(function (item) {
                  if (item.partial_payment_msg !== null){
                    item.status_name = 'PARCIALMENTE_PAGO';
                  }
                });
                vm.bills.order = order;

                if (vm.bills.length === 0) {
                  Common.Toast.warning("Não há títulos em aberto para este cliente, ou já estão na comanda");
                  vm.closeModal();
                }
              });
          };
          vm.order = function (order) {
            var page = (angular.isUndefined(page) || page === null) ? 1 : page;
            var qty = (angular.isUndefined(qty) || qty === null) ? 12 : qty;
            var direction = angular.isUndefined(order) ? 'desc' : (order.substring(0, 1) === '-' ? 'desc' : 'asc');
            GuestCheckPadService.getAllBillOpened({
              page: page, qtd: qty, person_id: ModalExtra.person_id,
              except: ModalExtra.except.toString(),
              direction: direction
            })
              .then(function (response) {
                vm.bills = response.plain();
                vm.bills.data.forEach(function (item) {
                  if (item.partial_payment_msg !== null){
                    item.status_name = 'PARCIALMENTE_PAGO';
                  }
                });
                vm.bills.order = order;
              });
          };
          vm.submit = function (selectedBills) {
            for (var i = 0; i < selectedBills.length; i++) {
              selectedBills[i].quantity = null;
              if (selectedBills[i].type === 3) {
                selectedBills[i].final_value = -(selectedBills[i].final_value);
                selectedBills[i].amount = -(selectedBills[i].amount);
              }
            }
            $mdDialog.hide(selectedBills);
          };
          vm.closeModal = function () {
            $mdDialog.cancel();
          };
          vm.init();
        }, 'vm', false, {person_id: vm.currentPerson.id, except: except})
        .then(function (bills) {
          vm.checkpad = vm.checkpad.concat(bills);
        });
    };

    /**
     * Abre a lista de cheques do cliente
     */
    vm.openChecksList = function () {
      ModalFactory.customClean('app/finance/cashier-session/guest-check-pad/view/checks.html',
        /** @ngInject */
        function (GuestCheckPadService, ModalExtra, $mdDialog, Common) {
          var vm = this;
          vm.checks = [];
          vm.tableItemsSelected = [];
          GuestCheckPadService.getChecksFromPerson({person_id: ModalExtra.person_id})
            .then(function (checks) {
              if (checks.length === 0) {
                Common.Toast.warning("Não há cheques para este cliente");
                vm.closeModal();
              }
              vm.checks = checks;
              $rootScope.show_loader = false;
            });
          vm.submit = function (selectedChecks) {
            $mdDialog.hide(selectedChecks);
          };
          vm.closeModal = function () {
            $mdDialog.cancel();
          };
        }, 'vm', false, {person_id: vm.currentPerson.id})
        .then(function (checks) {
          vm.checkpad = vm.checkpad.concat(checks);
        });
    };

    /**
     * Remove um item da comanda
     */
    vm.removeItemFromGuestPad = function (item) {
      var index = vm.checkpad.indexOf(item);
      vm.checkpad.splice(index, 1);
    };

    /**
     * Checa política de acesso
     * @param policy
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Busca ultimo titulo em aberto para a pessoa da comanda
     */
    vm.getLastBillOpened = function () {
      $rootScope.show_loader = true;

      var except = vm.checkpad.map(function (item) {
        if (angular.isUndefined(item.price)) {
          return item.id;
        }
      });

      var person_id = vm.currentPerson.id;
      GuestCheckPadService.getLastBillOpened({person_id: person_id, except: except.toString()})
        .then(function (response) {
          var newer = response.plain();
          if (newer.length === 0) {
            Common.Toast.warning("Todos os titulos em aberto estão na comanda")
          } else {
            for (var i = 0; i < newer.length; i++) {
              newer[i].quantity = null;
            }
          }
          vm.checkpad = vm.checkpad.concat(newer);
          $rootScope.show_loader = false;
        })
    };

    vm.getListOfDebitsFromPerson = function (person_id) {
      GuestCheckPadService.getDebitsFromPerson({person_id: person_id})
        .then(function (bills) {
          vm.items.bills = bills;
          $rootScope.show_loader = false;
        })
    };

    vm.getListOfProducts = function () {
      ProductService.allValuableProducts()
        .then(function (bills) {
          vm.items.products = bills;
          $rootScope.show_loader = false;
        })
    };

    vm.getblockOutStockSales = function () {
      ProductService.BlockOutOfStockSales()
        .then(function (response) {
          vm.BlockOutOfStockSales = response;
        })
    };
    /**
     * Incrementa a quantidade do produto selecionado
     * e atualiza o preço
     * @param item
     */
    vm.addProduct = function (item) {
      item.quantity++;
      item.final_value = item.price * item.quantity;
    };

    /**
     * Remove um produto e decrementa o preço
     * @param item
     */
    vm.removeProduct = function (item) {
      item.quantity--;
      /** Se a quantidade for 0, remove o produto da comanda.
       * Se não, decrementa o preço */
      if (item.quantity == 0) {
        vm.removeItemFromGuestPad(item);
      } else {
        item.final_value = item.price * item.quantity;
      }
    };

    /**
     * Seleciona produtos na lista de produtos com valor, e adiciona na comanda
     *
     */
    vm.selectProductToCheckPad = function () {
      var currentPerson = vm.currentPerson;
      ModalFactory.customClean('app/finance/cashier-session/guest-check-pad/view/selectProduct.html',
        /** @ngInject */
        function (ProductService, $rootScope, $filter, $mdDialog, ModalExtra, ResponsiblesService) {
          var vm = this;
          vm.blockOutOfStockSales = ModalExtra.blockStockoutSales;
          vm.products = {};
          vm.productSelected = [];
          vm.currentPerson = currentPerson;
          vm.selected_student = null;
//Naiky Daiane Rodrigues Lopes
          /** Retorna todos os dependentes do cliente, caso tenha */
            ResponsiblesService.getStudentsForResponsible({id: vm.currentPerson.id})
              .then( function (response) {
                vm.students = response.plain();

                /** Faz a checkbox do dependente já aparecer marcada caso só haja um dependente */
                if (vm.students.length === 1) {
                  vm.students[0].selected_student = true;
                  vm.selected_student = vm.students[0];
                }

                return vm.students
              })

          ProductService.allValuableProducts().then(function (bills) {
            vm.products = bills.plain();
            /** Faz tratamento dos produtos, inicializando-os com 0 de desconto e com 1 de quantidade. */
            for (var i = 0; i < vm.products.length; i++) {
              vm.products[i].quantity = 1;
              vm.products[i].productDiscount = 0;
            }
            $rootScope.show_loader = false;
            vm.productsData = angular.copy(vm.products);
          });
          vm.filter_items = function (array) {
            return vm.productsData.filter(function (item) {
              return array.includes(item.id);
            })
          };
          vm.submit = function (productSelected) {
            productSelected = vm.filter_items(productSelected);

            if (vm.selected_student !== null) {
              productSelected.forEach(function (item) {
                item.beneficiary_id = vm.selected_student.id;
                item.beneficiary_name = vm.selected_student.name;
              })
            } else {
              productSelected.forEach(function (item) {
                item.person_id = vm.currentPerson.id
              })
            }
            $mdDialog.hide(productSelected);
          };
          /**
           * Procura produto de acordo com nome
           * @param name
           */
          vm.filterProducts = function (name) {
            vm.products = angular.copy(vm.productsData).filter(function (item) {
              var query = name.toLowerCase();
              return item.name.toLowerCase().indexOf(query) >= 0;
            })
          };
          vm.closeModal = function () {
            $mdDialog.cancel();
          };
        }, 'vm', false, {blockStockoutSales: vm.BlockOutOfStockSales}).then(function (productSelected) {
        angular.forEach(productSelected, function (product) {
          var sum = false;
          angular.forEach(vm.checkpad, function (item) {
            if (product.id === item.id && angular.isUndefined(item.bill_serie_id) && product.beneficiary_id === item.beneficiary_id) {
              item.quantity += 1;
              item.final_value = item.price * item.quantity;
              sum = true;
            }
          });
          if (!sum) {
            vm.checkpad = vm.checkpad.concat(product);
          }
        });
      });
    };

    /**
     * Atualiza valor final do produto de acordo com seu desconto
     * @param item
     */
    vm.changeProductFinalValue = function (item) {
      item.final_value = (item.price * item.quantity) - item.productDiscount;
    };

    vm.getListOfChecksFromPerson = function (person_id) {
      GuestCheckPadService.getChecksFromPerson({person_id: person_id})
        .then(function (checks) {
          vm.items.checks = checks;
          $rootScope.show_loader = false;
        })
    };


    /**
     * Executa a somatória do valor total da lista.
     * @param list - lista do carrinho
     * @returns {number}
     */
    vm.getTotal = function (list) {
      var total = 0;
      angular.forEach(list, function (value) {
        total += parseFloat(value.final_value);
      });
      return total;
    };

    /**
     * Escuta modificação do autocomplete
     * @param item
     */
    vm.selectedItemChange = function () {
      vm.items = {
        bills: [],
        products: [],
        checks: []
      };
    };

    vm.querySearch = function (query) {
      var person = PersonService.getAllPersons({query: query, paginate: false});
      $rootScope.show_loader = false;
      return person;
    };

    vm.init();
  }

  angular
    .module('app.finance.guest-check-pad')
    .controller('GuestCheckPadController', GuestCheckPadController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function CashierSession($translateProvider) {

    $translateProvider.translations('pt', {
      "CASHIER_MANAGEMENT": {
        "NAME": "Gerenciamento de Caixas",
        "ACCOUNT": "Conta",
        "CONFIG": "Configurações de caixa",
        "SELECT_ACCOUNT": "Selecione uma conta",
        "OPEN": "Abrir",
        "CLOSE": "Encerrar Sessão",
        "CLOSE_SESSION_ERROR": "Erro ao encerrar sessão!",
        "CLOSE_SESSION_SUCCESS": "Sessão encerrada com sucesso!",
        "OPEN_NEW_GUEST_PAD": 'Abrir nova comanda'
      }
    })

  }

  angular
    .module('app.finance.cashier-session')
    .config(CashierSession);
})();

(function(){
  'use strict';

  angular
    .module('app.finance.bill-reverse', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BillReverseTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "BILL_REVERSE": {
        "TITLE": "Realizar desfazer"
      }
    });

  }

  angular
    .module('app.finance.bill-reverse')
    .config(BillReverseTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function BillReceiptTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      'CATEGORY': 'Categoria',
      'AMOUNT': 'Valor',
      'MONTH': 'Mês',
      'YEAR': 'Ano',
      'TAGS': 'Tags',
      'ISSUE_DATE': 'Data do recebimento',
      'ACCRUAL': 'Competência',
      'INSTALLMENT': 'Parcelamento',
      'COMPLEMENTS_NOTES': 'Notas Complementares',
      'ACCRUAL_DATE': 'Data da competência',
      'BILL_RECEIPT': {
        'ADD': 'Adicionar',
        'SELECT': 'Selecione',
        'ADD_INCOMES': 'Adicionar Receita',
        'ACCOUNT': 'Conta',
        'TITLE': 'A Receber',
        'INCOME': 'Receita',
        'INCOME_RECEIVABLES': 'Receita Recebida',
        'INCOME_TO_RECEIVE': 'Receita a Receber',
        'INCOME_FREE_PORTION': 'Parcelas Livres',
        'INCOME_RECURRENCE': 'Receita Recorrente',
        'RECEITA': 'Receitas',
        'RECEIVED': 'Recebido de',
        'RECEIVEDOF': 'A receber de',
        'REFERENCE': 'Referência',
        'PRODUCT_SERVICES': 'Produtos',
        'PAYMENT_PLAN': 'Plano de Pagamento',
        'PERSON': 'Pessoa',
        'DESCRIPTION': 'Descrição',
        'FORM_EDIT': 'Atualizar recebimento',
        'FORM_CREATE': 'Criar recebimento',
        "FORM_REQUIRED": "Este campo é requerido."
      }
    });

  }

  angular
    .module('app.finance.bill-receipt')
    .config(BillReceiptTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.finance.bill-payment', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BillPaymentTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "BILL_PAYMENT": {
        "BANK": "Banco",
        "BANK_PAYMENT":"Pagamento via Banco",
        "BANK_RECEIVEMENT": "Recebimento via Banco",
        "MONEY_PAYMENT": "Pagamento com Dinheiro",
        "MONEY_RECEIVEMENT": "Recebimento com Dinheiro",
        "CREDIT_PAYMENT": "Pagamento com Crédito",
        "CREDIT_RECEIVEMENT": "Recebimento com Crédito",
        "CHECK": "Cheque",
        "CLOSE_SIDENAV": "Fechar",
        "DEBIT_ACCOUNT": "C. Débito",
        "FORM_CREATE_SUBMIT": "Pagar",
        "MONEY": "Dinheiro",
        "TITLE": "Pagamento",
        "EDIT_VALUES": "Editar valores",
        "ACCOUNT_CASHIER": "Conta caixa de recebimento"
      }
    })

  }

  angular
    .module('app.finance.bill-payment')
    .config(BillPaymentTranslate);
})();

(function(){
  'use strict';

  angular
    .module('app.finance.bill-negotiate', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function BillNegotiateTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "BILL_NEGOTIATE": {
        "CLOSE_SIDENAV": "Fechar",
        "CREATE_NEGOTIATE": "Criar parcelas",
        "TITLE": "Negociação",
        "FORM_CREATE_SUBMIT": "Negociar",
        "INSTALLMENT": "Parcela",
        "DUE_DATE": "Data de Vencimento",
        "AMOUNT": "Valor"
      }
    })

  }

  angular
    .module('app.finance.bill-negotiate')
    .config(BillNegotiateTranslate);
})();

(function() {
  'use strict';
  angular
    .module('app.finance.bill-expense', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function BillExpenseTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "BILL_EXPENSE": {
        "ADD": "Adicionar",
        "ACCOUNT": "Conta",
        "DESCRIPTION": "Descrição",
        "FORM_CREATE": "Nova saída financeira",
        "FORM_EDIT": "Editar saída financeira",
        "FORM_REQUIRED": "Este campo é requerido.",
        "PAID": "Pago a",
        "PAY_TO": "Pagar a",
        'PRODUCT_SERVICES': 'Produtos/Serviços',
        'PAYMENT_PLAN': 'Plano de Pagamento',
        'PERSON': 'Pessoa',
        "REFERENCE": "Referência",
        "TITLE": "A Pagar",
        "FREQUENCY_QTY": "Qt. da frequência",
        "FREQUENCY_OPTIONS": "Opções de frequência"
      },
      "EXPENSE": 'Despesa',
      "PAYMENT_METHOD": "Forma de Pagamento",
      "PAYMENT_METHOD_REQUIRED": "Necessário forma de pagamento",
      "PAY": "Pagar",
      "PAID_OUT": "PAGO",
      "PAYMENT_DATE": 'Data do pagamento',
      "PARCIALY_PAID": "PARCIALMENTE PAGO",
      "PENDING": "pendente",
      "RECURRING_EXPENSE": 'Despesa Recorrente',
      "REQUIRED_PAYMENT_DATE": "Necessário data de pagamento",
      "REQUIRED_BILL_CATEGORY": "Necessário categoria do título",
      "REQUIRED_BILL_DESCRIPTION": "Necessária descrição do título",
      "REQUIRED_BILL_AMOUNT": "Necessário valor do título",
      "REQUIRED_RECURRENCE_DATE_FIRST": "Necessário data inicial da recorrência",
      "REQUIRED_ISSUE_DATE": "Nessário data da movimentação",
      "REQUIRED_INSTALLMENTS": "Necessário ao menos a criação de uma parcela",
      "REQUIRED_PERSON": "Necessário informar beneficiário",
      "REQUIRED_RECURRENCE": "Necessário haver recorrência",
      "REQUIRED_INSTALLMENT_AMOUNT": "Necessário valor em um das parcelas",
      "REQUIRED_INSTALLMENT_DATE": "Necessário data em uma das parcelas",
      "RESOURCES": 'Recursos',

      //STATUS BILL//
      "VENCIDO": 'VENCIDO',
      "A_VENCER": 'A VENCER',
      "VENCE_HOJE": 'VENCE HOJE',
      "STATUS_4": 'NEGOCIADO',
      "STATUS_5": 'DUVIDOSO',
      "STATUS_6": 'PREJUIZO',
      "STATUS_9": 'EXCLUIDO',
      "STATUS_10": 'PAGO',

      //ACTION BILL//
      "ACTION_10": "Pagar",
      "ACTION_9": "Excluir",
      "ACTION_6": "Marcar como prejuízo",
      "ACTION_5": "Marcar como duvidosas",
      "ACTION_4": "Negociar"
    });

  }

  angular
    .module('app.finance.bill-expense')
    .config(BillExpenseTranslate);
})();

(function() {
  'use strict';
  angular
    .module('app.finance.bill-expense.contract-expense.modal-edit-expense', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ModalEditExpenseController(ModalExtra, ProductService, BillReceiptService, BillExpenseService, $mdDialog,
                               Toast, $filter, a4Moment, Common, $timeout) {

    var vm = this;

    vm.payment_method = [
      {id: 1, name: "Dinheiro"},
      {id: 2, name: "Cheque pré-datado"},
      {id: 3, name: "Cheque"},
      {id: 4, name: "Boleto bancário"},
      {id: 5, name: "Cartão de crédito"},
      {id: 6, name: "Tranferência bancária"},
      {id: 7, name: "Promissória"},
      {id: 8, name: "Cartão de débito"},
      {id: 9, name: "Débito automático"},
      {id: 10, name: "Débito automático no cartão"},
      {id: 11, name: "Parcelado no cartão"}
    ];

    vm.months = [
      {id: 1, label: '01 - Janeiro'},
      {id: 2, label: '02 - Fevereiro'},
      {id: 3, label: '03 - Março'},
      {id: 4, label: '04 - Abril'},
      {id: 5, label: '05 - Maio'},
      {id: 6, label: '06 - Junho'},
      {id: 7, label: '07 - Julho'},
      {id: 8, label: '08 - Agosto'},
      {id: 9, label: '09 - Setembro'},
      {id: 10, label: '10 - Outubro'},
      {id: 11, label: '11 - Novembro'},
      {id: 12, label: '12 - Dezembro'}
    ];

    vm.frequency_options = [
      {id: 1, name: 'Dia(s)'},
      {id: 2, name: 'Mês(es)'},
      {id: 3, name: 'Ano(s)'}
    ];

    vm.debit_credit = 'D';

    vm.init = function () {
      vm.currentItem = ModalExtra.item;
      vm.getBillById(vm.currentItem.id, vm.currentItem.edit_expense);
      vm.categories = ModalExtra.categories;
    //  vm.formatDate();
      vm.getYears();
      vm.getAllPersons();
      vm.getAllPersons();
    };

    /**
     * Faz o request para a API e retorna a despesa por id
     * @param {Int} id - identificador do titulo
     * @param {Int} edit_expense - identificador do titulo
     */
    vm.getBillById = function (id, edit_expense) {

      vm.currentItem = null;

      BillReceiptService.getBillById(id, {'edit_expense': edit_expense})
        .then(function (response) {

          vm.currentItem = response;
          vm.currentItems = response;

          if (vm.currentItem.amount != null) {
            vm.currentItem.amount = parseFloat(vm.currentItem.amount);
          }

          if (vm.currentItem.issue_date != null) {
            vm.currentItem.issue_date = a4Moment(response.issue_date);
          }

          if (vm.currentItem.due_date != null) {
            vm.currentItem.due_date = a4Moment(response.due_date);
            vm.currentItem.issue_date = a4Moment(response.due_date);
          }

          if (vm.currentItem.payment_installments != undefined) {
            vm.currentItem.hasPaid = vm.getIfInstallmentHasOnePaid(vm.currentItem.payment_installments);
          }

          if (vm.currentItem != undefined) {

            if (vm.currentItem.next_adjustment_date) {
              vm.currentItem.next_adjustment_date = a4Moment(vm.currentItem.next_adjustment_date);
            }

            if (vm.currentItem.date_end) {
              vm.currentItem.end_of_recurrence = 1;
              vm.currentItem.date_end = a4Moment(vm.currentItem.date_end);
            }

            if (vm.currentItem.date_first) {
              vm.currentItem.date_first = a4Moment(vm.currentItem.date_first);
            }

            if (vm.currentItem.quantity > 0) {
              vm.currentItem.end_of_recurrence = 0;
            }

            if(vm.currentItem.discounts_rules.length > 0){
              vm.currentItem.discounts_rules.forEach(function (value) {
                value.end_date =  a4Moment(value.end_date);
                value.start_date =  a4Moment(value.start_date);
              })
            }

            if (vm.currentItem.tags != null && vm.currentItem.tags.length > 0) {
              vm.currentItem.tags = vm.currentItem.tags.filter(function (item, i, ar) {
                return ar.indexOf(item) === i;
              });
            }

            vm.currentItem.frequency = response.frequency;
            vm.currentItem.frequency_qty = response.frequency_qty;
            vm.currentItem.frequency_type = response.frequency_type;

          }

        })
        .catch(function () {

        });
    };

    vm.formatDate = function () {
      if (vm.currentItem.issue_date != null) {
        vm.currentItem.issue_date = a4Moment(vm.currentItem.issue_date);
      }
    };

    /**
     * Retorna o range de anos
     */
    vm.getYears = function () {
      vm.years = [];
      for (var i = 2013; i < 2035; i++) {
        vm.years.push({id: i, label: i});
      }
    };



    /**
     * Escuta as trocas de produto.
     * @param product_id - Identificador do produto.
     */
    vm.changeProduct = function (product_id) {
      ProductService.getProductById(product_id)
        .then(function (response) {
          var prod = response;
          vm.currentItem.bill_details = [];
          vm.currentItem.issue_date = a4Moment();
          vm.payment_plans = prod.plans;
          vm.currentItem.payment_plan_id = vm.payment_plans[0].id;
          vm.prodName = prod.name;
          vm.prodPrice = prod.price;

          vm.getFromPaymentPlan(prod.plans[0].id);

          for (var i = 0, len = prod.bill_category.length; i < len; i++) {
            prod.bill_category[i].amount = prod.price;
            vm.currentItem.amount = prod.price;
            vm.currentItem.description = prod.name;
            prod.bill_category[i].description = prod.name;
            prod.bill_category[i].bill_category_id = prod.bill_category[i];
            vm.currentItem.bill_details.push(prod.bill_category[i]);
          }

        })
        .catch(function () {

        })
    };

    /**
     * Escuta as trocas de plano de pagamento.
     * @param id - Identificador do plano de pagamento.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.getFromPaymentPlan = function (id) {
      BillReceiptService.getInfoFromPaymentPlan(id)
        .then(function (response) {
          var plan = response;
          vm.currentItem.issue_date = plan.date_first == null ? a4Moment() : a4Moment(plan.date_first);
          vm.currentItem.was_paid = plan.was_paid;
          angular.element('input[name=expenses]').attr('disabled', true);
          if (plan.was_paid == 2) {
            if (plan.quantity > 0) {

              vm.currentItem.index_id = plan.index_id;
              vm.currentItem.end_of_recurrence = 0;
              vm.currentItem.quantity = plan.quantity;
              vm.currentItem.date_first = a4Moment(plan.date_first);
              vm.currentItem.frequency_type = 0;
              vm.currentItem.frequency_qty = plan.frequency_qty;
              vm.currentItem.frequency = plan.frequency;

            } else if (vm.currentItem.end_of_recurrence == 1 && plan.date_first != null) {

              vm.currentItem.date_first = a4Moment(plan.date_first);
              vm.currentItem.date_end = a4Moment(plan.date_end);

            }
          }

          var date_first = a4Moment(vm.currentItem.date_first);
          vm.currentItem.next_adjustment_date = a4Moment(date_first).add(1, 'y');


          vm.currentItem.fines_rule_id = plan.fines_rule_id;
          vm.currentItem.collection_type = plan.collection_type;
          vm.currentItem.bank_slip_rule_id = plan.bank_slip_rule_id;

          var amount = vm.getAmountOfPlanOrProduct(plan.price);

          if (plan.bill_category.length >= 1) {

            vm.currentItem.bill_details = [];
            vm.currentItem.description = vm.prodName;

            for (var i = 0, len = plan.bill_category.length; i < len; i++) {
              //plan.bill_category[i].bill_category_id = plan.bill_category[i];
              plan.bill_category[i].category = angular.copy(plan.bill_category[i]);
              plan.bill_category[i].amount = amount;
              plan.bill_category[i].description = vm.prodName;
              vm.currentItem.bill_details.push(plan.bill_category[i]);
            }
          }

          vm.currentItem.amount = amount;
          vm.currentItem.bill_details[0].amount = amount;

          if (plan.quantity > 0) {
            // $rootScope.$broadcast('installment.addqty', plan.quantity);
          }

          $timeout(function () {
            vm.disableRecurrenceFields();
          }, 10);

          vm.planinfo = true;

        })
        .catch(function () {

        });
    };

    /**
     * getAmountOfPlanOrProduct
     * Retorna o valor do produto, se o valor do plano for zero
     * Se os dois forem zero, mantem o valor para edição
     * @param amount
     * @returns {number}
     */
    vm.getAmountOfPlanOrProduct = function (amount) {
      var result = 0;
      if (amount > 0) {
        result = amount;
        // $rootScope.$broadcast('advanceTable.disableFields', ['value']);
      } else if (amount == 0 && vm.prodPrice != 0) {
        result = vm.prodPrice;
        // $rootScope.$broadcast('advanceTable.disableFields', ['value']);
      } else {
        // $rootScope.$broadcast('advanceTable.enableFields', ['value']);
      }
      return result;
    };

    /**
     * Retorna todas as pessoas do banco de dados para a interface.
     * @returns {$q@call;defer.promise}
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.getAllPersons = function () {
      BillReceiptService.getAllPersons()
        .then(function (response) {
          vm.persons = response;
        })
        .catch(function () {
          Common.Toast.error($filter('translate')('LIST_ERROR') + ": " + $filter('translate')("PERSON"));
        });
    };

    /**
     * Faz a submissão de formulario para novo titulo
     * @param {type} bill_form - Formulário do submit para validações Angular.
     * @param {type} item - Item do formulário.
     * @param {type} files - Arquivos .
     * @param {type} event - Evento.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.submit = function (bill_form, item, files, event) {
      // cancelar uso do Enter.
      if (event != undefined && event.keyCode == '13') {
        return false;
      }

      var bill_copy = angular.copy(item);

      if (!bill_copy.amount) {
        Toast.warning('Valor não pode ficar em branco.');
        return false;
      }

      if (bill_copy.bill_details.length === 1) {
        bill_copy.is_inaccurate_amount = bill_copy.bill_details[0].is_inaccurate_amount;

        if (bill_copy.bill_details[0].bill_category_id != undefined) {
          bill_copy.bill_category_id = bill_copy.bill_details[0].bill_category_id;
        }
      }

      bill_copy.issue_date = a4Moment(bill_copy.issue_date).format('YYYY-MM-DD');

      if (bill_copy.id != null) {
        if (vm.installmentsIsValid(bill_copy)) {
          if (parseInt(bill_copy.edit_expense) == 3) {
            vm.updateAllSerie(bill_copy);
          }

        } else {
          Toast.warning('O valor total das parcelas é diferente do valor da despesa.');
        }
      }
     };

    /**
     * updateAllSerie
     * @param currentItem
     */
    vm.updateAllSerie = function (currentItem) {

      // se houver diferença entre o valor atual do titulo e a referência ao mesmo ID no grid de parcelas
      currentItem.payment_installments = vm.updateAmountOfList(currentItem);

      BillExpenseService.updateAllSerie(currentItem)
        .then(function (response) {
          if (response && response.result) {
            Toast.success($filter('translate')('UPDATE_SUCCESS'));
            $mdDialog.hide(response);
          } else {
            Common.Toast.error('Erro ao editar esse parcelamento.');
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * updateAmountOfList
     * se houver diferença entre o valor atual do titulo e a referência ao mesmo ID no grid de parcelas
     * @param currentItem
     * @returns {Array}
     */
    vm.updateAmountOfList = function (currentItem) {
      var arr = [];
      angular.forEach(currentItem.payment_installments, function (item) {
        if (currentItem.id == item.bill_id && currentItem.amount != item.amount) {
          item.amount = currentItem.amount;
        }
        arr.push(item);
      });
      return arr;
    };

    vm.verifyIfExistsDuplicatedCheck = function (list_checks) {
      var exists = false;
      angular.forEach(list_checks, function (value) {
        if (value.duplicated) {
          exists = true;
        }
      });
      return exists;
    };

    /**
     * Valida se o valor total das parcelas é igual ao valor da despesa
     * Só executa essa validacao em caso de despesa parcelada e recorrencia com vencimentos variaveis
     * @param bill
     * @returns {boolean}
     */
    vm.installmentsIsValid = function (bill) {
      if (bill.was_paid == 3 || (bill.was_paid == 2 && bill.frequency_type == 1)) {
        var sum = 0;
        angular.forEach(bill.payment_installments, function (item) {
          if (item.amount != '') {
            item.amount = item.amount == null ? 0 : parseFloat(item.amount);
            sum = (sum + parseFloat(item.amount.toFixed(2)));
          }
        });
        return (bill.amount == sum.toFixed(2));
      } else {
        return true;
      }
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.init();


  }

  angular
    .module('app.finance.bill-expense.contract-expense.modal-edit-expense')
    .controller('ModalEditExpenseController', ModalEditExpenseController);

})();

(function() {
  'use strict';
  angular
    .module('app.finance.bill-expense.contract-expense', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ContractExpenseController($rootScope, Common, BillReceiptService, BillExpenseService, ModalFactory, a4Moment) {

    var vm = this;

    vm.debit_credit = 'D';
    vm.filter_date = null;
    vm.bills = [];
    vm.includeScope = {};
    vm.bills = [];
    vm.all_bills = [];
    vm.selected_status = [];
    vm.edit_expense = null;


    vm.init = function () {
      vm.getAllContracts(1, 20);
      vm.getCategories();
    };

    vm.getAllContracts = function (page, qtd) {
      $rootScope.show_loader = true;
      vm.promise = BillReceiptService.getAllContracts({'debit_credit': vm.debit_credit, page: page, qtd: qtd})
        .then(function (response) {
          if (response) {
            vm.allContracts = response.plain();
            /**
             * Verificação da data final, para verificar se o contrato está cancelado
             */
            for (var i = vm.allContracts.data.length; i--;) {
              if (vm.allContracts.data[i].date_end !== null && a4Moment(vm.allContracts.data[i].date_end).isBefore(a4Moment().format('YYYY-MM-DD'))) {
                vm.allContracts.data[i].is_date_end_before_today = true;
              } else {
                vm.allContracts.data[i].is_date_end_before_today = false;
              }
            }
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.defineType = function (item) {
      if (item.portion_amount == null) {
        return "Recorrência";
      } else {
        return "Parcelamento";
      }
    };

    vm.defineAmount = function (item) {
      if (item.portion_amount == null) {
        return item.recurrence_amount;
      } else {
        return item.portion_amount;
      }
    };

    vm.defineFrequency = function (item) {
      switch (item.frequency) {
        case 0:
          return "Título parcelado";
        case 1:
          if (item.frequency_qty == 1) {
            return "A cada " + item.frequency_qty + " dia"
          }
          return "A cada " + item.frequency_qty + " dias";
        case 2:
          if (item.frequency_qty == 1) {
            return "A cada " + item.frequency_qty + " mês"
          }
          return "A cada " + item.frequency_qty + " meses";
        case 3:
          if (item.frequency_qty == 1) {
            return "A cada " + item.frequency_qty + " ano"
          }
          return "A cada " + item.frequency_qty + "anos";
        case 20:
          return "Datas irregulares";
        case 30:
          return "Sob demanda";
      }
    };

    vm.getCategories = function () {
      BillExpenseService.getCategories(vm.debit_credit)
        .then(function (response) {
          if (response) {
            vm.categories = response;
            $rootScope.show_loader = false;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });
    };

    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista.');
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor.');
          break;
      }
    };

    vm.openEdit = function (item) {
      item.edit_expense = 3;
      ModalFactory.customClean('app/finance/bill-expense/contract/modal-edit.html',
        'ModalEditExpenseController', 'vm', true, {'item': item, 'categories': vm.categories})
        .then(function () {
          vm.getAllContracts();
        });
    };


    vm.init();


  }

  angular
    .module('app.finance.bill-expense.contract-expense')
    .controller('ContractExpenseController', ContractExpenseController);

})();

(function(){
  'use strict';

  angular
    .module('app.finance.bill-chargeback', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BillChargeBackTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "BILL_CHARGEBACK": {
        "TITLE": "Realizar reembolso"
      }
    });

  }

  angular
    .module('app.finance.bill-chargeback')
    .config(BillChargeBackTranslate);
})();

(function () {
    'use strict';

    angular
      .module('app.finance.banksliprule', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BankSlipRuleTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "BANKSLIPRULE": {
        "ADD_RULE": "Adicionar regra",
        "FORM_CREATE_SUBMIT": "Criar regra",
        "FORM_UPDATE_SUBMIT": "Atualizar regra",
        "TITLE": "Regras de boleto",
        "TITLE_CREATE": "Criar regra de boleto",
        "TITLE_EDIT": "Editar regra de boleto",
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "FORM_NAME": "Nome da regra",
        "FORM_NAME_REQUIRED": "O nome da regra é necessária",
        "CURRENT_ACCOUNT": "Conta Corrente",
        "BILLING_INSTRUCTIONS": "Instruções de Cobrança",
        "MESSAGE_DRAWEE": "Mensagem para o sacado"
      }
    })

  }

  angular
    .module('app.finance.banksliprule')
    .config(BankSlipRuleTranslate);
})();
(function () {
    'use strict';

   angular
     .module('app.finance.bankslip', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BankSlipTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "BANK_SLIP": {
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "TITLE": "Boleto Bancário",
        "FORM_ACCOUNT": "Conta",
        "FORM_ACCOUNT_REQUIRED": "A conta é necessária"
      }
    });

  }

  angular
    .module('app.finance.bankslip')
    .config(BankSlipTranslate);
})();

(function(){
  'use strict';

  angular
    .module('app.finance.bank-file-send', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function BankFilSendTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "BANK_FILE_SEND": {
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "TITLE": "Arquivo remessa",
        "NEW_TITLE": "Novo Arquivo remessa",
        "ACCOUNT": "Conta corrente",
        "DESCRIPTION": "Descrição",
        "FILE_NAME": "Nome do arquivo",
        "SEQUENTIAL": "Sequencial",
        "GENERATE_FILE": "Gerar arquivo",
        "SERVICE": "Serviço",
        "SERVICE_GROUP": "Grupo de serviços"
      }
    });
  }

  angular
    .module('app.finance.bank-file-send')
    .config(BankFilSendTranslate)
})();

(function(){
  'use strict';

  angular
    .module('app.finance.bank-file-receive', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function BankFileReceiveTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "BANK_FILE_RECEIVE": {
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "TITLE": "Arquivo retorno"
      }
    });
  }

  angular
    .module('app.finance.bank-file-receive')
    .config(BankFileReceiveTranslate)
})();

(function () {
  'use strict';

  angular
    .module('app.finance.additions', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function AdditionsTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "ADDITIONS": {
        "ADD_RULE": "Adicionar regra",
        "FORM_CREATE_SUBMIT": "Criar regra",
        "FORM_UPDATE_SUBMIT": "Atualizar regra",
        "TITLE": "Regras de acréscimos",
        "TITLE_CREATE": "Criar regra de acréscimos",
        "TITLE_EDIT": "Editar regra de acréscimos",
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "FORM_NAME": "Nome da regra",
        "FORM_NAME_REQUIRED": "O nome da regra é necessária"
      }
    })

  }

  angular
    .module('app.finance.additions')
    .config(AdditionsTranslate);
})();
(function () {
  'use strict';

  angular
    .module('app.educational.typing-date', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function TypingDateTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "TYPING_DATE": {
        "TITLE": "Datas limite para lançamento de nota",
        "NAME": "Nome",
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "OPENING": "Abertura",
        "CLOSURE": "Fechamento"
      }
    })

  }

  angular
    .module('app.educational.typing-date')
    .config(TypingDateTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.timetable-template', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function TimetableTemplateTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "TIMETABLETEMPLATE": {
        "TITLE": "Grade de Horário"
      }
    });

  }

  angular
    .module('app.educational.timetable-template')
    .config(TimetableTemplateTranslate);
})();

(function () {
  'use strict';
  angular
    .module('app.educational.course', [
      'app.educational.course.matrix',
      'app.educational.course.group',
      'app.educational.course.students',
      'app.educational.course.documents'
    ]);
})();


(function () {
    'use strict';

    /** @ngInject */
    function CourseTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "SUBJECT": {
                "ADD_GROUP": "Adicionar disciplina",
                "TITLE": "Disciplinas",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Criar disciplinas",
                "FORM_EDIT": "Editar disciplina"
            }
        })

    }

    angular
        .module('app.educational.course')
        .config(CourseTranslate);
})();

(function(){
  'use strict';

  angular
    .module('app.educational.students.wall', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function WallStudentsController(CONFIG, InformativeReportService, Session, ModalFactory, $filter, Common, $rootScope,
                                  EnrolmentService, LocalStorage, $stateParams, a4Moment, $window, $timeout) {
    var vm = this;
    vm.url = CONFIG.webApiUri + 'uploads/';
    vm.documents = [];
    vm.companies = LocalStorage.get(CONFIG.storage.companies);
    vm.config = $filter('filter')(vm.companies, {id: Session.getCurrentCompany()})[0].config;
    vm.MATRICULA_CONDICIONAL = 1;
    vm.CONFIRMADA_ONLINE = 4;
    vm.AGUARDANDO_ASSINATURA_ONLINE = 7;
    vm.date = {
      initial_date: null,
      final_date: null
    };
    vm.today = a4Moment();
    vm.student = $stateParams;

    vm.init = function () {
      vm.getPaymentPendences();
      $timeout(function () {
        vm.getInformativeReport();
      }, 10000);
    };

    /**
     * Retorna pendencias de pagamento para um responsável
     */
    vm.getPaymentPendences = function () {
      $rootScope.show_loader = true;
      EnrolmentService.getPaymentPendences('responsible')
        .then(function (response) {
          var pendences = response.pendences;
          $rootScope.show_loader = false;
          vm.has_pendences = angular.isUndefined(pendences) ? 0 : pendences;
          vm.getDatesForEnrolmentOnline();
        });
    };

    /**
     * Retorna as datas para re-matrícula online
     */
    vm.getDatesForEnrolmentOnline = function () {
      $rootScope.show_loader = true;
      EnrolmentService.getDatesForEnrolmentOnline()
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.date.initial_date = a4Moment(response.initial_date);
          vm.date.final_date = a4Moment(response.final_date);
          var initial_and_final_date_is_null = (vm.date.initial_date === null && vm.date.final_date === null);
          if (!initial_and_final_date_is_null &&
            !(vm.date.initial_date.isAfter(vm.today)) && !(vm.date.final_date.isBefore(vm.today))) {
            vm.allow_enrolment = true;
          }
          vm.student = $stateParams;
        })
    };
    /**
     * Retorna todos os boletins informativo disponíveis para o aluno
     */
    vm.getInformativeReport = function () {
      var limit = false;
      InformativeReportService.getAll({
        limit: limit, for: Session.getCurrentProfile(), type: 1,
        group_id: $stateParams.group_id, is_dashboard: true
      })
        .then(function (response) {
          vm.documents = response;
        });
    };

    /**
     * Abre o modal de confirmação da matrícula
     */
    vm.confirmEnrolment = function () {
      ModalFactory.custom(
        'app/educational/re-enrollment/confirm-enrolment.html',
        vm.config,
        false
      ).then(function () {
        vm.printEnrolmentContract(vm.student);
      })
    };

    /**
     * Realiza a impressão do formulário de matrícula do aluno
     */
    vm.printEnrolmentContract = function (student) {
      $rootScope.show_loader = true;
      ModalFactory.customClean(
        'app/educational/re-enrollment/contract.html',
        'SignContractEnrolmentResponsiblesController',
        'vm',
        false,
        student
      ).then(function () {
        $rootScope.show_loader = true;
        EnrolmentService.confirmEnrolmentOnline(student)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Matrícula confirmada com sucesso');
            ModalFactory.custom(
              'app/educational/re-enrollment/confirm-message.html', vm.config)
              .then(function () {
                vm.openModal(student)
              });
            vm.getStudentsForReEnrolment();
          }).catch(function () {
          $rootScope.show_loader = false;
        })
      });
    };

    /**
     * Abre o modal para impressão de documentos
     * @param student
     */
    vm.openModal = function (student) {
      ModalFactory.customClean(
        'app/educational/re-enrollment/print-documents.html',
        'PrintDocumentsEnrolmentResponsiblesController',
        'vm',
        false,
        student
      ).then(function () {
        $window.location.reload();
      })
    };

    vm.init();
  }

  angular
    .module('app.educational.students.wall')
    .controller('WallStudentsController', WallStudentsController)
})();

(function () {
  'use strict';

  angular
    .module('app.educational.students', [
      'app.educational.students.timetable',
      'app.educational.students.classes',
      'app.educational.students.classrooms',
      'app.educational.students.school-reports',
      'app.educational.students.occurrences',
      'app.educational.students.financial',
      'app.educational.students.school-records',
      'app.educational.students.wall',
      'app.educational.students.parents',
      'app.educational.students.complementary-activities',
      'app.educational.students.questionnaires-students',
      'app.educational.students.evaluations-student',
      'app.educational.students.extra-subjects',
      'app.educational.students.subjects'
    ]);
})();

(function () {
    'use strict';

    /** @ngInject */
    function StudentsTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "STUDENTS": {
                "ADD_STUDENTS": "Adicionar Alunos",
                "TITLE": "Alunos e Matrículas",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Cadastrar Alunos",
                "FORM_EDIT": "Editar Alunos",
                "DELETE": "Remover Alunos"
            }
        })

    }

    angular
        .module('app.educational.students')
        .config(StudentsTranslate);
})();

(function(){
  'use strict';

  angular
    .module('app.educational.students.timetable', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function TimetableStudentsController($rootScope, $state, StudentsService,
                                       moment, Session, PoliciesService, $scope, CONFIG) {
    var vm = this;

    vm.new = {};
    vm.reserve = {};
    vm.lessons = [];

    /**
     * Inicializador de controlador
     */
    var ltn = $rootScope.$on('$viewContentLoaded', function () {
      var user = Session.getUser();
      if ((PoliciesService.isStudent() && PoliciesService.currentProfile() === CONFIG.profile.is_student)) {
        vm.studentId = user.person.id;
      } else if (PoliciesService.isParent() && PoliciesService.currentProfile() === CONFIG.profile.is_parent) {
        vm.studentId = $state.params.id;
      } else {
        vm.studentId = $state.params.id;
      }
    });


    /**
     * Retorna as aulas do professor
     */
    vm.getLessons = function (id, start, end) {
      start = angular.isDefined(start) ? start : moment().startOf('week');
      end = angular.isDefined(end) ? end : moment().endOf('week');


      return StudentsService.getLessons({id: id, start: start, end: end});
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

  }

  angular
    .module('app.educational.students.timetable')
    .controller('TimetableStudentsController', TimetableStudentsController)
})();

(function(){
  'use strict';

  angular
    .module('app.educational.students.subjects', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function SubjectsStudentsController($document, StudentsService, CONFIG, $rootScope, $scope, $state, EnrolmentService, Common, ModalFactory,
                                      EducationalService, Session, ReportsService) {

    var vm = this;
    vm.person_id = $state.params.id;
    vm.course_id = $state.params.course_id;
    vm.group_id = $state.params.group_id;
    vm.school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.course_equivalence_id = $state.params.course_equivalence_id;
    vm.course_enrolment_system_id = $state.params.course_enrolment_system_id;
    vm.enrolment_period_id = $state.params.enrolment_period_id;
    vm.matrix_period = $state.params.matrix_period;
    vm.data = [];
    vm.WEB_CONST = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    vm.init = function () {
      vm.profile = Session.getProfile();
      vm.getEnrolmentMatrix();
      vm.getSchoolPeriod();
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
          vm.conf.current_school_period_id = $scope.educational.school_period.selected.id;
        });
    };

    /**
     * Resgata os períodos letivos
     */
    vm.getSchoolPeriod = function () {
      EducationalService.getSchoolsPeriod()
        .then(function (periods) {
          vm.school_periods = periods.list;
          vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
          vm.school_period_default_enrolment_id = periods.default_enrolment[0].id;
          vm.school_period_default_enrolment_name = periods.default_enrolment[0].name;
        })
    };

    /**
     * Retorna todas as classes do aluno
     */
    vm.getEnrolmentMatrix = function () {
      $rootScope.show_loader = true;
      StudentsService.getEnrolmentMatrix({person_id: vm.person_id, course_id: vm.course_id, enrolment_period_id: vm.enrolment_period_id})
        .then(function (response) {
          vm.data = response.plain();
          $rootScope.show_loader = false;
        }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao buscar disciplinas.');
      });
    };

    vm.modalDetailsStatus = function (item, status, title) {
      ModalFactory.custom(
        'app/educational/students/subjects/views/modal-details-item.html',
        {
          item: angular.copy(item),
          title: title,
          school_periods: vm.school_periods
        },
        true
      ).then(function (data) {
        vm.changeStatus(data.item, status);
      });
    };

    /**
     * Modifica o status de uma matrícula em disciplina
     * @param item
     * @param status
     */
    vm.changeStatus = function (item, status) {
      $rootScope.show_loader = true;
      EnrolmentService.changeStatusEnrolmentSubject({
        enrolment_period_id: item.enrolment_period_id,
        enrolment_status_id: item.enrolment_status_id,
        subject_id: item.subject_id,
        group_id: item.group_id,
        matrix_period: item.matrix_period,
        person_id: vm.person_id,
        status: status,
        external_school_period: angular.isDefined(item.external_school_period) ? item.external_school_period : null,
        final_grade: angular.isDefined(item.final_grade) ? item.final_grade : null
      }).then(function () {
        vm.getEnrolmentMatrix();
        Common.Toast.success('Situação atualizada com sucesso!');
      }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao atualizar situação.');
      });
    };

    vm.getGroupsEnrolment = function (item) {
      EnrolmentService.getGroupsEnrolment({
        subject_id: item.subject_id,
        course_id: vm.course_id,
        group_id: vm.group_id,
        person_id: vm.person_id
      })
        .then(function (response) {
          $rootScope.show_loader = false;
          ModalFactory.customClean(
            'app/educational/students/subjects/views/select-group-enrolment.html',
            /** @ngInject */
            function ($rootScope, $mdDialog, ModalExtra, $filter) {
              var vm = this;
              vm.groups = ModalExtra.groups;
              if (ModalExtra.group_enrolled === null) {
                vm.filtered = $filter('filter')(vm.groups, {'group_order': 1, 'subject_id': ModalExtra.subject_id})[0];
              } else {
                vm.filtered = $filter('filter')(vm.groups, {
                  'group_order': 1,
                  'subj_group_id': ModalExtra.subject_id + '_' + ModalExtra.group_enrolled + '_' + ModalExtra.matrix_period
                })[0];
              }
              vm.group_id = angular.isDefined(vm.filtered) ? vm.filtered.subj_group_id : null;
              vm.subject_name = ModalExtra.subject_name;
              vm.submit = function (group_id) {
                $mdDialog.hide($filter('filter')(vm.groups, {'subj_group_id': group_id})[0]);
              };
              vm.closeModal = function () {
                $mdDialog.cancel();
              };
            }, 'vm', false, {
              groups: response.plain(), subject_name: item.subject_name, group_enrolled: item.group_id,
              subject_id: item.subject_id, group_id: vm.group_id, matrix_period: item.matrix_period
            }
          ).then(function (group) {
            vm.doEnrolment(group);
          })
        }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao atualizar situação.');
      });
    };

    /**
     * Adiciona uma dependência para aluno de ensino básico
     */
    vm.addDependency = function () {
      ModalFactory.customClean(
        'app/educational/students/subjects/views/add-dependency.html',
        'SubjectsStudentsDependencyController',
        'vm', false, {}
      )
        .then(function () {
          vm.getEnrolmentMatrix();
        });
    };

    vm.printHistory = function () {
      var href = vm.WEB_CONST + 'api/superiorschoolrecords/report/' + vm.person_id
        + '?token=' + vm.conf.token
        + '&history_superior_option=' + 3
        + '&current_school_period=' + vm.school_period
        + '&user_id=' + vm.conf.user_id
        + '&student_group_id=' + vm.group_id
        + '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    /**
     * Realiza a matrícula em disciplina
     * @param item
     */
    vm.doEnrolment = function (item) {
      $rootScope.show_loader = true;
      EnrolmentService.doEnrolmentSubject({
        person_id: vm.person_id,
        enrolment_period_id: vm.enrolment_period_id,
        subject_id: item.subj_group_id.split('_')[0],
        group_id: item.subj_group_id.split('_')[1],
        matrix_period: item.matrix_period
      }).then(function () {
        vm.getEnrolmentMatrix();
        Common.Toast.success('Matrícula realizada com sucesso!');
      }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao realizar matrícula.');
      });
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    vm.getBackgroundColor = function (subject_item) {
      if (subject_item.school_period_id !== null
        && (subject_item.enrolment_status_id === 10 && subject_item.academic_status_id < 10)
        && subject_item.school_period_id < vm.school_period_default_enrolment_id) {
        return 'rgb(255, 254, 236)';
      }
      if (subject_item.enrolment_status_id >= 30 && subject_item.enrolment_status_id <= 32) {
        return 'rgb(245, 243, 243)'
      }
      if ((subject_item.school_period_id !== null
        && (subject_item.enrolment_status_id === 10
          && (subject_item.academic_status_id >= 10 && subject_item.academic_status_id <= 19)))
        || (subject_item.enrolment_status_id >= 40 && subject_item.enrolment_status_id <= 42)) {
        return 'rgb(229, 242, 255)';
      }
    };

    vm.init();
  }

  angular
    .module('app.educational.students.subjects')
    .controller('SubjectsStudentsController', SubjectsStudentsController)
    .filter('dayOfWeek', function () {
      /** day - número do dia da semana de 1 a 7 (dom a sab)*/
      return function (day) {
        day = parseInt(day);
        // Ensure that we are working with a number
        if (isNaN(day)) {
          return '';
        } else {
          switch (day) {
            case 1:
              return 'Dom';
            case 2:
              return 'Seg';
            case 3:
              return 'Ter';
            case 4:
              return 'Qua';
            case 5:
              return 'Qui';
            case 6:
              return 'Sex';
            case 7:
              return 'Sab';
          }
        }
      }
    });
})();
(function () {
  'use strict';

  /** @ngInject */
  function SubjectsStudentsDependencyController($document, StudentsService, CONFIG, $rootScope, $scope, $state, EnrolmentService, Common, ModalFactory,
                                                EducationalService, Session, CoordinatorsService, a4Moment, SubjectService) {

    var vm = this;
    vm.person_id = $state.params.id;
    vm.course_id = $state.params.course_id;
    vm.group_id = $state.params.group_id;
    vm.course_equivalence_id = $state.params.course_equivalence_id;
    vm.enrolment_period_id = $state.params.enrolment_period_id;
    vm.data = [];
    vm.years = [];
    vm.group = {name: null};
    vm.dependency_year = null;
    vm.selected_subjects = [];
    vm.WEB_CONST = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.coursesAndGroups = [];
    vm.show_loader = false;

    vm.col_defs_services = [
      {}
    ];
    vm.expanding_property = {
      field: "text",
      displayName: "Cursos e turmas",
      cellTemplate: "<span>{{row.branch[expandingProperty.field]}}</span>"
    };

    vm.init = function () {
      vm.show_loader = true;
      for (var i2 = 1; i2 <= 10; i2++) {
        var momentVar3 = a4Moment().subtract('year', i2);
        vm.years.push({id: momentVar3.year(), name: momentVar3.format('YYYY')});
      }
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      CoordinatorsService.getTree({course_equivalence_id: vm.course_equivalence_id})
        .then(function (response) {
          vm.show_loader = false;
          vm.coursesAndGroups = response.plain();
        });
    };

    vm.selectGroup = function (item) {
      vm.show_loader = true;
      vm.group = item;
      SubjectService.getSubjectsGroup({group_id: item.group_id})
        .then(function (resp) {
          vm.show_loader = false;
          vm.subjects_list = resp.plain();
        })
    };

    /**
     * Realiza a matrícula nas dependências
     */
    vm.enrolmentDependency = function () {
      EnrolmentService.enrolmentDependency({
        subjects: vm.selected_subjects,
        group_id: vm.group.group_id,
        year: vm.dependency_year,
        enrolment_period_id: vm.enrolment_period_id
      })
        .then(function (resp) {
          vm.closeModal(resp);
          Common.Toast.success('Matrícula em dependência realizada com sucesso.');
        })
        .catch(function () {
          Common.Toast.error('Erro ao realizar matrícula em dependência.');
        })
    };

    vm.closeModal = function (response) {
      $rootScope.$broadcast('ModalFactory.close', response);
    };

    vm.init();
  }

  angular
    .module('app.educational.students.subjects')
    .controller('SubjectsStudentsDependencyController', SubjectsStudentsDependencyController);
})();
(function(){
  'use strict';

  angular
    .module('app.educational.students.school-records', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function SchoolRecordsService(Restangular) {

    /**
     * Retorna o histórico do estudante
     * @returns array
     */
    var getByStudentId = function (id) {
      return Restangular.one('schoolrecords', id).get();
    };

    /**
     * Retorna as disciplinas que fazem parte da grade
     * @returns array
     */
    var getSubjectSchoolRecords = function (obj) {
      return Restangular.one('schoolrecords').one('getsubjectschoolrecords').get(obj);
    };

    /**
     * Retorna as disciplinas que fazem parte da grade
     * @returns array
     */
    var getSubjectSchoolRecordsConfig = function (obj) {
      return Restangular.one('schoolrecords').one('getsubjectschoolrecordsconfig').get(obj);
    };

    /**
     * Retorna o histórico do aluno de acordo com tipo de ensino
     * @returns array
     */
    var getSchoolRecordsType = function (obj) {
      return Restangular.one('schoolrecords').one('getschoolrecordstype').get(obj);
    };

    /**
     * Atualiza o histórico escolar
     */
    var updateSchoolRecords = function (obj) {
      return Restangular.one('schoolrecords', obj.id).customPUT(obj);
    };

    /**
     * Atualiza o configuração da ordem das disciciplinas no histórico escolar
     */
    var updateSchoolRecordsSubjectConfig = function (obj) {
      return Restangular.all('schoolrecords/updateschoolrecordssubjectconfig').post(obj);
    };

    /**
     * Retorna a todas as escolas do histórico
     * @returns array
     */
    var searchSchoolRecordsSchool = function (query) {
      return Restangular.one('schoolrecords').one('searchschoolrecordsschool').get(query);
    };

    var saveSchoolRecordsConfig = function (obj) {
      return Restangular.one('schoolrecords').all('saveschoolrecordsconfig').post(obj);
    };

    var updatePrimaryType = function (obj) {
      return Restangular.one('schoolrecords').all('updateprimarytype').post(obj);
    };

    return {
      getByStudentId: getByStudentId,
      getSubjectSchoolRecords: getSubjectSchoolRecords,
      getSubjectSchoolRecordsConfig: getSubjectSchoolRecordsConfig,
      getSchoolRecordsType: getSchoolRecordsType,
      updateSchoolRecords: updateSchoolRecords,
      updatePrimaryType: updatePrimaryType,
      saveSchoolRecordsConfig: saveSchoolRecordsConfig,
      searchSchoolRecordsSchool: searchSchoolRecordsSchool,
      updateSchoolRecordsSubjectConfig: updateSchoolRecordsSubjectConfig
    };

  }

  angular
    .module('app.educational.students.school-records')
    .factory('SchoolRecordsService', SchoolRecordsService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function SchoolRecordsController($a4FloatButton, $rootScope, $scope, $document, $stateParams, $filter, ReportsService, StudentsService, a4Moment,
                                   SchoolRecordsService, SubjectService, BillReceiptService, Session, Common, ModalFactory, CONFIG) {

    var vm = this;
    vm.WEB_CONST = CONFIG.webApiUri;
    vm.student = null;
    vm.print_date = a4Moment();
    vm.company = Session.getCurrentCompany();
    

    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null,
      user_id: null
    };

    vm.form = {
      school_records: {pre: [], primary: [], high: [], columns: []},
      school_records_school: {pre: [], primary: [], high: []},
      school_records_notes: {pre: null, primary: null, high: null}
    };

    vm.school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();

    vm.subject_tmp = {};
    vm.school_records_selected = null;
    vm.printTotalCourseLoadBySubject = false;

    /** Evento para realizar a busca das disciplinas para vincular ao histórico */
    var ltn = $rootScope.$on('search_subject_for_school_records', function (ev, text, obj) {
      vm.searchSubjects(text, obj);
    });

    /** Evento para criação de uma nova disciplina para o histórico */
    var ltn1 = $rootScope.$on('add_new_subject_in_school_records', function (ev, text, index, type) {
      vm.subject_tmp = {
        index: index,
        type: type
      };

      vm.createAndAddSubject(text);
    });

    /** Função de inicialização do controlador */
    vm.init = function () {
      vm.floatButton = $a4FloatButton({
        scope: $scope, label: 'Salvar', onClick: 'vm.submitRecordsSchool()',
        theme: 'educational', icon: 'save'
      });
      vm.getByStudentId($stateParams.id);
      vm.student_id = $stateParams.id;
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.user_id = Session.user.id;
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        })
      vm.getStudentById();
    };

    vm.checkCompany = function () {
      if (vm.company != 18 && vm.company != 20) {
        vm.print_date = a4Moment();
      }
    }

    /**
     * Pega as informações do aluno
     */
    vm.getStudentById = function () {
      StudentsService.getById(vm.student_id)
      .then(function (response) {
        return vm.student = response.person
      })
    }

    vm.print_school_record = function (type) {
      $rootScope.show_loader = true;
      BillReceiptService.getConfig().then(function (response) {
        var config = response.plain();
        if (config.sr_certificate_option === 2) {
          ModalFactory.confirm(null, "Impressão de certificado",
            "Deseja imprimir o certificado deste aluno?",
            'Imprimir', 'Não imprimir', 'educational').then(function () {
            vm.execute_print(true, type);
          }).catch(function () {
            vm.execute_print(false, type);
          })
        } else {
          vm.execute_print(true, type);
        }
        $rootScope.show_loader = false;
      });
    };

    vm.execute_print = function (print_certificate, type) {
      /** Antes de da ação de imprimir, salva as informações da tela */
      SchoolRecordsService.updateSchoolRecords({
        id: $stateParams.id,
        schoolrecords: vm.form,
        definitions: vm.equivalences,
        type: vm.school_records_selected,
        print_date: a4Moment(vm.print_date).format('DD-MM-YYYY')
      }).then(function() {
        if (type !== 'all') {
          type = vm.school_records_selected;
        }
        ReportsService.reportFactory('GET',
          'api/schoolrecords/report/' + vm.student_id,
          {
            type: type,
            user_id: vm.conf.user_id,
            company: vm.conf.current_company,
            connection: vm.conf.current_connection,
            print_certificate: print_certificate,
            current_school_period: vm.school_period_id,
            print_total_course_load_by_subject: vm.printTotalCourseLoadBySubject,
            print_date: a4Moment(vm.print_date).format('DD-MM-YYYY')
          });
      })
    };

    vm.changePrimaryType = function () {
      $rootScope.show_loader = true;
      SchoolRecordsService.updatePrimaryType({id: $stateParams.id, type: vm.primary_type}).then(function () {
        if (vm.primary_type === 8) {
          vm.NUMBERS = {
            'pre': [1, 2, 3, 4, 5],
            'primary': [1, 2, 3, 4, 5, 6, 7, 8],
            'high': [1, 2, 3, 4]
          };
          vm.EQUIVALENCES = {
            'pre': [1, 2, 3, 4, 5],
            'primary': [112, 113, 114, 115, 116, 117, 118, 119],
            'high': [201, 202, 203, 204]
          };
        } else {
          vm.NUMBERS = {
            'pre': [1, 2, 3, 4, 5],
            'primary': [1, 2, 3, 4, 5, 6, 7, 8, 9],
            'high': [1, 2, 3, 4]
          };
          vm.EQUIVALENCES = {
            'pre': [1, 2, 3, 4, 5],
            'primary': [111, 112, 113, 114, 115, 116, 117, 118, 119],
            'high': [201, 202, 203, 204]
          };
        }
        vm.getSchoolRecordsType(vm.school_records_selected);
      });

    };

    /** Adição de nova linha para a grade */
    vm.addNewRow = function (subject, type, index) {
      index = angular.isUndefined(index) ? 0 : index;
      var last_row = vm.form.school_records[type][vm.length];
      var value = parseInt(index) + 1;
      vm.form.school_records[type][value] = {};
      vm.form.school_records[type][value + 1] = angular.copy(last_row);
      vm.length += 1;

      for (var i = 0; i < vm.num_columns; i++) {
        vm.form.school_records[type][value]['subject_id'] = 'temp';
        vm.form.school_records[type][value]['grade_' + vm.equivalences[i]] = null;
        vm.form.school_records[type][value]['course_load_' + vm.equivalences[i]] = null;
      }
    };

    /** Remoção de linha da grade */
    vm.removeRow = function (obj, index, type) {
      vm.form.school_records[type].splice(index, 1);
    };

    /** Limpeza das colunas */
    vm.clearSchool = function (index, type) {
      delete vm.form.school_records_school[type][index]['id'];
      delete vm.form.school_records_school[type][index]['name'];
      delete vm.form.school_records_school[type][index]['city'];
      delete vm.form.school_records_school[type][index]['school_origin'];
      delete vm.form.school_records_school[type][index]['school_origin_id'];
      delete vm.form.school_records_school[type][index]['search_school_name'];
      delete vm.form.school_records_school[type][index]['state_id'];
      delete vm.form.school_records_school[type][index]['year'];
    };

    /**
     * Pesquisa as disciplinas já existentes
     */
    vm.searchSubjects = function (query, row) {
      SubjectService.searchSubjects({query: query, show_inactive: true, is_school_record: true})
        .then(function (response) {
          row.searchSubject = response;
        });
    };

    /**
     * Realiza a abertura do modal para a criação de uma nova disciplina para adição no histórico
     */
    vm.createAndAddSubject = function (text) {
      var sugestions = {name: text, special_type: 9};

      ModalFactory.customClean(
        'app/educational/subject/views/form.html',
        'SubjectCreateController',
        'vm', false, sugestions
      ).then(function (data){
        data = data.plain();
        vm.form.school_records[vm.subject_tmp.type][vm.subject_tmp.index].subject_id = data.id;
        vm.form.school_records[vm.subject_tmp.type][vm.subject_tmp.index].subject_name = data.name;
        vm.form.school_records[vm.subject_tmp.type][vm.subject_tmp.index].person_id = $stateParams.id;
      });
    };

    /**
     * Resgata as definições da grade para montagem do histórico do aluno
     */
    vm.getByStudentId = function (id) {
      SchoolRecordsService.getByStudentId(id)
        .then(function (response) {
          vm.school_records = response.plain();
          vm.primary_type = vm.school_records.definitions.primary_type;
          if (vm.primary_type === 9) {
            vm.EQUIVALENCES = {
              'pre': [1, 2, 3, 4, 5],
              'primary': [111, 112, 113, 114, 115, 116, 117, 118, 119],
              'high': [201, 202, 203, 204]
            };
            vm.NUMBERS = {
              'pre': [1, 2, 3, 4, 5],
              'primary': [1, 2, 3, 4, 5, 6, 7, 8, 9],
              'high': [1, 2, 3, 4]
            };
          } else {
            vm.EQUIVALENCES = {
              'pre': [1, 2, 3, 4, 5],
              'primary': [112, 113, 114, 115, 116, 117, 118, 119],
              'high': [201, 202, 203, 204]
            };
            vm.NUMBERS = {
              'pre': [1, 2, 3, 4, 5],
              'primary': [1, 2, 3, 4, 5, 6, 7, 8],
              'high': [1, 2, 3, 4]
            };
          }
        })
        .catch(function () {
          Common.Toast.error('Não foi possível recuperar a definição do histórico.');
        });
    };

    /**
     * Inicializa as células de carga horária
     * @param grades
     */
    vm.initBlockCourseLoad = function (grades) {
      vm.equivalences.forEach(function (eq) {
        grades.forEach(function (item, key) {
          vm.calculateCourseLoad(item['course_load_' + eq], vm.school_records_selected, key, eq, true);
        })
      })
    };

    $scope.$watch('vm.EQUIVALENCES[vm.school_records_selected]', function(newVal) {
      vm.ch_equivalences = [];
      if (newVal) {
        newVal.forEach(function (ch) {
          vm.ch_equivalences.push('course_load_' + ch)
        });
      }
    });

    /**
     * Verifica se existe CH de alguma disciplina preenchida para aquele ano
     * @param course_load
     */
    vm.verifySubjectsLoad = function(course_load) {
      for (var i = 0; i < vm.form.school_records[vm.school_records_selected].length-1; i++){
        if (vm.form.school_records[vm.school_records_selected][i][course_load] !== null &&
          vm.form.school_records[vm.school_records_selected][i][course_load] !== '' &&
          vm.form.school_records[vm.school_records_selected][i][course_load] !== '0' &&
          vm.form.school_records[vm.school_records_selected][i][course_load] !== 0) {return true}
      }
      return false
    };

    /**
     * Verifica se as CH das disciplinas estão zeradas e se existe algum valor na CHT do ano
     * @param course_load
     */
    vm.verifyCourseLoad = function(course_load) {
        return !vm.verifySubjectsLoad(course_load) &&
          vm.form.school_records[vm.school_records_selected][vm.form.school_records[vm.school_records_selected].length-1][course_load] !== ''  &&
          vm.form.school_records[vm.school_records_selected][vm.form.school_records[vm.school_records_selected].length-1][course_load] !== '0' &&
          vm.form.school_records[vm.school_records_selected][vm.form.school_records[vm.school_records_selected].length-1][course_load] !==  0  &&
          vm.form.school_records[vm.school_records_selected][vm.form.school_records[vm.school_records_selected].length-1][course_load] !== null
    };

    /**
     * Calcula a carga horária total do ano
     * @param course_load
     * @param type
     * @param row_index
     * @param equivalence
     * @param init - se for a inicialização do grid
     */
    vm.calculateCourseLoad = function (course_load, type, row_index, equivalence, init) {


      /** Array auxiliar para guardar os valores das células */
      vm.form.school_records.columns[equivalence] =
        angular.isUndefined(vm.form.school_records.columns[equivalence]) ? {total_column: 0} : vm.form.school_records.columns[equivalence];

      vm.form.school_records.columns[equivalence][row_index] = {
        value: course_load
      };


      /* bloco que controla qual o formato digitado na coluna */
      var hasColon = false;
      var hasComma = false;
      angular.forEach(vm.form.school_records.columns[equivalence], function (cell, index) {
        if (index < vm.length && angular.isString(cell.value)) {
          if (angular.isString(cell.value) && cell.value.search(':') > 0) {
            hasColon = true;
          } else if(angular.isString(cell.value) && !cell.value.includes("-") &&
            (cell.value.search('.') > 0) || (cell.value.search(',') > 0)) {
            hasComma = true;
          }

        }
      });
      if (hasColon && hasComma) {
        Common.Toast.warning("O formato das datas precisam estar no mesmo padrão")
      }
      if (course_load !== null && angular.isString(course_load)) {

        /** Tratamento dos tipos de dados variádos*/
        if (course_load.search(',') >= 0) {
          course_load = course_load.replace(',','.');
        }
        if(course_load.search(':') >= 0) {
          var hour   =  course_load.split(':')[0];
          var minute = parseFloat(course_load.split(':')[1]);

            course_load =  hour + ":" + String(minute);


        }

      }


      /** Variável auxiliar para o cálculo da carga horária total */
      var total_column = 0;
      /** Se a carga horária for digitada diretamente na linha de carga horária total */
      if (angular.isUndefined(init) && row_index === vm.length) {
        vm.form.school_records[type][vm.length]['course_load_' + equivalence] = course_load;
      }else if (hasColon && hasComma) {
        vm.form.school_records[type][vm.length]['course_load_' + equivalence] = 0;
      }else if(!hasColon) {

        /** Se for digitada na célula e tiver o fomato de "," ou "."*/
        angular.forEach(vm.form.school_records.columns[equivalence], function (cell, index) {
          if (index < vm.length && (angular.isObject(cell) && angular.isDefined(cell.value))) {
            cell.value = (cell.value === "" || isNaN(parseFloat(cell.value))) ? 0 : cell.value;
            total_column += parseFloat(cell.value);
          }
        });

        /** Se não for a inicialização do grid */
        if (angular.isUndefined(init)) {
          if (!hasColon) {
            vm.form.school_records[type][vm.length]['course_load_' + equivalence] = total_column;
          }
          /** Se for a inicialização, e for a última linha de disciplina(CH Total), sempre priorizando
           * o calculo, para nao ter chance de ter nota lan'cada e calculada ao mesmo tempo
           */
        } else if ((init && row_index === vm.length - 1) && total_column > 0 ) {
          vm.form.school_records[type][vm.length]['course_load_' + equivalence] = total_column;
        }

        /* se for digitada na celula e tiver o fomato de ":" */
      } else if(hasColon && !hasComma) {
        /* Converte o valor em minutos e depois separa o valor de horas e de minutos totais, concatenando com um ":" no meio */
        angular.forEach(vm.form.school_records.columns[equivalence], function (cell, index) {
          if (index < vm.length && angular.isString(cell.value) && !isNaN(parseFloat(cell.value))) {
            var cellHours = parseFloat(cell.value.split(':')[0]) * 60;
            /** precisa ter essa verificacao a mais nos minutos para caso seja um numero sem :, para ele ser convertido corretamente */
            var cellMinutes = angular.isDefined(cell.value.split(':')[1]) ? parseFloat(cell.value.split(':')[1]) : 0;
            total_column += cellHours + cellMinutes;

          }
        });
      }

      if(hasColon && !hasComma) {
        total_column = String(total_column);
        if (angular.isDefined(total_column.split('.')[1]) && total_column.split('.')[1].length === 1 ) {
          total_column = total_column + '0';
        }

        var hours = (total_column / 60);
        var rhours = Math.trunc(hours);
        var minutes = total_column - (rhours * 60);
        var rminutes = Math.trunc(minutes);

        vm.form.school_records[type][vm.length]['course_load_' + equivalence] = rhours + ":" + rminutes;
      }
    };

    /**
     * Calcula as notas por disciplina ano/série e permite ou não
     * a exclusão da disciplina
     */
    vm.calculateGrade = function (row) {
      var total_column = 0;
      angular.forEach(row, function (item) {
        if (angular.isObject(item) && angular.isDefined(item.grade)) {
          item.grade = (item.grade === "" || isNaN(parseInt(item.grade))) ? 0 : parseInt(item.grade);
          if (angular.isNumber(item.grade)) {
            total_column = (parseInt(total_column) + parseInt(item.grade));
            row.grade_total_editable = (total_column > 0);
          }
        }
      });
    };

    /**
     * Ordena as informações do histórico para a exibição correta no grid
     * de acordo com as definições do histórico do aluno e os dados que
     * o mesmo possui.
     */
    vm.orderSchoolRecords = function (type, item, index, quantity) {
      var new_item = [];
      var result_index = null;
      new_item.subject_block = true;
      var num_columns = vm.num_columns;

      /** Cria posições e os objetos com os valores necessários */
      for (var i = 0; i < num_columns; i++) {
        new_item.push({
          course_equivalence_id: quantity[i],
          subject_id: angular.isDefined(item.subject_id) ? item.subject_id : item[0].subject_id,
          subject_name: angular.isDefined(item.subject_name) ? item.subject_name : item[0].subject_name,
          sequence: angular.isDefined(item.sequence) ? item.sequence : item[0].sequence
        });
      }

      /** Aloca as informações na posição correta */
      angular.forEach(item, function (info) {
        result_index = new_item.indexOf(new_item.filter(function (i) {
            return i.course_equivalence_id === info.course_equivalence_id
          })[0]
        );

        if (result_index >= 0) {
          new_item[result_index] = info;
        }
      });

      vm.form.school_records[type][index] = new_item;

      if (angular.isArray(vm.form.school_records[type])) {
        vm.form.school_records[type] = vm.form.school_records[type].filter(function (n) {
          return n != undefined
        });
      }
    };

    /**
     * Cria e limita a quantidade de registros
     * das escolas do histório do aluno
     */
    vm.completeRows = function (array, quantity) {
      /** Cria posições necessárias */
      for (var i = array.length; i < quantity.length; i++) {
        array.push({course_equivalence_id: quantity[i]});
      }
    };

    /**
     * Resgata o histórico do aluno
     */
    vm.getSchoolRecordsType = function (type) {
      $rootScope.show_loader = true;
      SchoolRecordsService.getSchoolRecordsType({id: $stateParams.id, type: type})
        .then(function (response) {
          vm.form = {
            school_records: {pre: [], primary: [], high: [], columns: []},
            school_records_school: {pre: [], primary: [], high: []},
            school_records_notes: {pre: null, primary: null, high: null}
          };
          var data = response.plain();
          vm.num_columns = 0;

          switch (type) {
            case 'pre':
              vm.num_columns = 5;
              vm.equivalences = vm.EQUIVALENCES['pre'];
              break;
            case 'primary':
              vm.num_columns = 9;
              vm.equivalences = vm.EQUIVALENCES['primary'];
              break;
            case 'high':
              vm.num_columns = 4;
              vm.equivalences = vm.EQUIVALENCES['high'];
              break;
          }

          /** Insere os dados do histórico das disciplinas no grid do mesmo */
          vm.form.school_records[type] = data.school_records;

          /** Insere os dados de observação do histórico no grid do mesmo */
          vm.form.school_records_notes = data.school_records_notes;

          /** Disponibiliza os estados do pais para o select do histórico das escolas */
          vm.states = data.states;


          /** Verifica se já existe a linha de totalização da carga horária, se não, cria */
          var total_course_load = $filter('filter')(vm.form.school_records[type], {'subject_id': null});
          if (total_course_load.length === 0) {
            vm.length = vm.form.school_records[type].length;
            vm.form.school_records[type][vm.length] = [];
            var array = {};
            angular.forEach(vm.equivalences, function (item) {
              array['grade_' + item] = null;
              array['course_load_' + item] = null;
            });
            array['subject_id'] = null;
            array['person_id'] = $stateParams.id;
            vm.form.school_records[type][vm.length] = array;
          } else {
            vm.length = vm.form.school_records[type].length - 1;
          }

          vm.initBlockCourseLoad(vm.form.school_records[type]);
          vm.completeRows(vm.form.school_records_school[type], vm.equivalences);
          vm.insertHistorySchoolRows(vm.form.school_records_school[type], data.school_records_school);

          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Não foi possivel recuperar os dados do histórico.');
        });
    };

    /**
     * Insere as escolas anteriores do aluno nas posições corretas
     * @param array
     * @param school_records_school
     */
    vm.insertHistorySchoolRows = function (array, school_records_school) {
      for (var i = 0; i < array.length; i++) {
        for (var z = 0; z < school_records_school.length; z++) {
          if (array[i].course_equivalence_id === school_records_school[z].course_equivalence_id) {
            array[i] = school_records_school[z];
          }
        }
      }

    };

    /** Submeter a grade de histórico */
    vm.submitRecordsSchool = function () {
      var definitions = vm.equivalences;
      $rootScope.show_loader = true;
      SchoolRecordsService.updateSchoolRecords({
        id: $stateParams.id,
        schoolrecords: vm.form,
        definitions: definitions,
        type: vm.school_records_selected
      })
        .then(function () {
          $rootScope.show_loader = false;
          vm.form = {
            school_records: {pre: [], primary: [], high: [], columns: []},
            school_records_school: {pre: [], primary: [], high: []},
            school_records_notes: {pre: null, primary: null, high: null}
          };
          vm.getSchoolRecordsType(vm.school_records_selected);
          Common.Toast.success('Histórico atualizado com sucesso.');
        })
        .catch(function (response) {
          $rootScope.show_loader = false;
          if(angular.isDefined(response.data) && angular.isDefined(response.data.message)){
            Common.Toast.error(response.data.message);
          } else{
            Common.Toast.error('Não foi possivel atualizar os dados do histórico.');
          }
        });
    };

    /** Submeter a grade de histórico */
    vm.submitSchoolRecordsSchool = function (obj) {
      $rootScope.show_loader = true;
      var new_obj = angular.copy(obj);
      var status = true;
      /** Realiza a validação das escolas estudadas */
      angular.forEach(new_obj, function (item, index) {
        if (angular.isDefined(item.school_origin_id) &&
          (angular.isUndefined(item.state_id) || angular.isUndefined(item.city) || angular.isUndefined(item.year))) {
          status = false;
          delete new_obj[index];
        }
      });

      if (!status) {
        Common.Toast.warning('É necessário informar todos os dados da escola.');
      }

      new_obj = new_obj.filter(function (n) {
        return n !== undefined
      });

      SchoolRecordsService.updateSchoolRecordsSchool({id: $stateParams.id, schoolrecordsschool: new_obj})
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Histórico atualizado com sucesso.');
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Não foi possivel atualizar os dados do histórico.');
        });
    };

    /** Submeter as observações do histórico */
    vm.submitSchoolRecordsNotes = function (obj, type) {
      $rootScope.show_loader = true;
      obj.type = type;
      SchoolRecordsService.updateSchoolRecordsNotes({id: $stateParams.id, schoolrecordsnotes: obj})
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Observações atualizado com sucesso.');
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Não foi possivel atualizar os dados de observações.');
        });
    };

    /**
     * Realiza a busca das escolas
     */
    vm.querySearchSchool = function (query) {
      return SchoolRecordsService.searchSchoolRecordsSchool({query: query})
        .then(function (response) {
          return response;
        });
    };

    /**
     * Reliza o auto complete da cidade e estado da escola encontrada na busca
     */
    vm.autoCompleteField = function (value, obj) {
      obj.school_origin_id = value.id;
      obj.city = value.city;
      obj.state_id = value.state_id;
    };


    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      });
      vm.floatButton.destroy();
    });

    vm.init();

  }

  angular
    .module('app.educational.students.school-records')
    .controller('SchoolRecordsController', SchoolRecordsController)
})();

(function(){
  'use strict';

  angular
    .module('app.educational.students.school-reports', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function SchoolReportsController($stateParams, NoteReleaseService, $rootScope, $scope,
                                   ReportsService, $document, CONFIG, Session, StudentsService) {
    var vm = this;

    /** Definição de variáveis */
    vm.grid = {rows: [], info: {}};
    vm.students = null;
    vm.subject_children = [];
    vm.subject_children_position = [];
    vm.is_detailed = false;
    vm.isNumber = angular.isNumber;
    vm.show_school_periods = $stateParams.course_equivalence_id >= 300;
    vm.matrix_period = $stateParams.matrix_period;
    vm.group_id = $stateParams.group_id;
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.special_characters = ['F', 'D', 'S', 'FN', 'DP', 'SR'];
    vm.dont_print_footer = false;

    /** Função de inicialização do controlador */
    vm.init = function () {
      vm.student_id = $stateParams.id;
      vm.course_id = $stateParams.course_id;
      vm.school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });

      vm.getStudentsSubjects(vm.student_id, vm.school_period_id);
      vm.getStudentById()
    };

    vm.getStudentById = function () {
      StudentsService.getById(vm.student_id)
      .then(function (response) {
        return vm.students = response.person
      })
    }

    /**
     * Formata nota para exibição
     * @param value
     * @returns {*}
     */
    vm.formatValue = function (value) {
      if (value >= 0 || isNaN(value)) {
        return value;
      } else {
        switch (value) {
          case -1:
            return 'FN';
          case -3:
            return 'SR';
          case -5:
            return 'DP';
        }
      }
    };

    /**
     * Retorna as disciplinas da turma que o aluno está matriculado
     * @param person - aluno
     * @param school_period_id
     */
    vm.getStudentsSubjects = function (person, school_period_id) {
      $rootScope.show_loader = true;
      NoteReleaseService.getStudentsSubjects({
        person_id: person, getCalculated: true,
        school_period_id: school_period_id, course_id: vm.course_id,
        is_school_report: true,
        group_id: vm.group_id
      })
        .then(function (response) {
          response = response.plain();
          vm.subjects = response.subjects;
          vm.school_periods = response.school_periods;
          /** Verifica as disciplinas filhas e move o seu posicionamento */
          angular.forEach(vm.subjects, function (subject) {
            if (subject.subject_parent.length > 0) {
              var i = 0;
              angular.forEach(subject.subject_parent, function (subject_child) {
                var index = vm.subjects.indexOf(subject);
                var subject_c = vm.getObject(subject_child.id);
                /** Remove o objeto original da posição */
                vm.removeObject(subject_child.id);
                /** Clona o objeto que deverá ser filho e aloca atrás do pai */
                vm.subjects.splice(index, 0, subject_c);
                i++;
                vm.subjects.sort(function(a, b) {
                  return a.ord - b.ord;
                });
              });
            }
          });

          vm.grid.grade_json = response.grade_json;
          vm.grid.steps = response.steps;
          vm.grid.academic_status = response.academic_status;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.setSchoolPeriod = function (school_period_id) {
      vm.getStudentsSubjects(vm.student_id, school_period_id);
    };

    vm.printNotes = function () {
      ReportsService.reportFactory(
        'GET',
        'api/reports/schoolreport',
        {
            dont_print_footer: vm.dont_print_footer,
            student_id: vm.student_id,
            getCalculated: true,
            is_detailed: vm.is_detailed,
            matrix_period: vm.matrix_period,
            student_group_id: vm.group_id
        });
    };

    /**
     * Retorna o valor desejado das definições da grade
     * @param id
     * @param field - campo desejado
     */
    vm.getValue = function (id, field) {
      var index = vm.grid.grade_json.indexOf(vm.grid.grade_json.filter(function (i) {
          return i.name === id
        })[0]
      );

      if (index >= 0) {
        return vm.grid.grade_json[index][field];
      }
    };

    /**
     * Retorna o objeto desejado e define como filho
     * @param id
     */
    vm.getObject = function (id) {
      var index = vm.subjects.indexOf(vm.subjects.filter(function (i) {
          return i.subject_id === id
        })[0]
      );

      if (index >= 0) {
        vm.subjects[index].is_child = true;
        return vm.subjects[index];
      }
    };

    /**
     * Remove o objeto original do array
     * @param id
     */
    vm.removeObject = function (id) {
      /** Pega a posição */
      var del = vm.subjects.indexOf(vm.subjects.filter(function (i) {
          return i.subject_id === id
        })[0]
      );
      /** Remove o objeto */
      vm.subjects.splice(vm.subjects.indexOf(vm.subjects[del]), 1);
    };

    vm.init();

  }

  angular
    .module('app.educational.students.school-reports')
    .controller('SchoolReportsController', SchoolReportsController)
})();

(function () {
  'use strict';

  angular.module('app.educational.students.questionnaires-students', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function QuestionnairesStudentsController($stateParams, $rootScope, QuestionnairesService, ReportsService) {
    var vm = this;
    vm.group_id = $stateParams.group_id;
    vm.person_id = $stateParams.id;
    vm.matrix_period = $stateParams.matrix_period;

    vm.getAnswer = function(options, answer){
      var item = null;
      options.forEach(function (option) {
        if (option.ord === answer) item = option.name;
      });
      return item;
    };

    vm.printQuestionnaire = function (item) {

      return ReportsService.reportFactory('GET',
        "api/reports/printquestionnaire",
        {
          questionnaire_id: item.questionnaire_id,
          group_id: item.group_id,
          matrix_period: item.matrix_period,
          event: null,
          person_id: item.person_id_object === null ? null : item.person_id_object,
          respondent: item.person_id,
          filter_selected: null
        });
    };

    vm.init = function () {
      $rootScope.show_loader = true;
      QuestionnairesService.getStudentQuestionnaires({
        person_id: vm.person_id,
        group_id: vm.group_id,
        matrix_period: vm.matrix_period
      }).then(function (response) {
        vm.student_questionnaires = response.plain();
        if (vm.student_questionnaires.length >= 1) {
          vm.questionnaire_selected = vm.student_questionnaires[0];
        }
        $rootScope.show_loader = false;
      })
    };

    vm.init();

  }

  angular.module('app.educational.students.questionnaires-students')
    .controller('QuestionnairesStudentsController', QuestionnairesStudentsController);
})();

(function(){
  'use strict';

  angular
    .module('app.educational.students.parents', []);

})();
(function () {
    'use strict';

    /** @ngInject */
    function ParentsStudentsController($a4FloatButton, $scope, a4Moment, StudentsService,
                                       $state, $rootScope, Common, ModalFactory, ResponsiblesService) {
      var vm = this;
      vm.has_father = true;
      vm.has_mother = true;
      vm.grid = {
        rows: [],
        info: {}
      };
      vm.group_id = $state.params.group_id;
      vm.matrix_period = $state.params.matrix_period;

      vm.init = function () {
        $rootScope.show_loader = true;
        vm.student = StudentsService.getPersonData();
        // vm.getStudentParents($state.params.id);
      };

      vm.verifyFatherAndMother = function()
      {
        var has_father = false;
        var has_mother = false;
        for (var i = 0; i < vm.grid.rows.length; i++) {
          if (vm.grid.rows[i].prt_id === 1 &&
            vm.grid.rows[i].person_sex_id === 'F') {
            has_mother = true;
          }
          if (vm.grid.rows[i].prt_id === 1 &&
            vm.grid.rows[i].person_sex_id === 'M') {
            has_father = true;
          }
        }
        vm.has_mother = has_mother;
        vm.has_father = has_father;
      };

      /**
       * Executa uma função desejada na lista de opções do grid
       * @param responsible
       * @param option
       */
      vm.clickActions = function (responsible, option) {
        switch (option) {
          case 'change-responsible':
            vm.changeResponsible(responsible);
            break;
          case 'edit-relationship':
            vm.changeRelationship(responsible);
            break;
          case 'change-payee':
            vm.changePayee(responsible);
            break;
          default:
        }
      };

      /***
       * Vai para a página do responsável
       * @param item
       */
      vm.seeParent = function (item) {
        $state.go('private.educational.responsibles.edit', {id: item.id});
      };

      /**
       * Adiciona um novo responsável ao aluno
       */
      vm.addParent = function () {
        var parents_ids = [];
        for (var i = 0; i < vm.grid.rows.length; i++) {
          parents_ids.push(vm.grid.rows[i].id);
        }
        ModalFactory.customClean(
          'app/educational/students/parents/views/responsibles-wizard.html',
          'ParentsAssistantController',
          'vm', false, {
            student_id: $state.params.id,
            responsibles_ids: parents_ids,
            group_id: $state.params.group_id,
            matrix_period: $state.params.matrix_period
          }
        ).then(function () {
          vm.getStudentParents($state.params.id);
        });
      };

      /**
       * Retorna a lista de responsáveis pelo aluno
       * @param student_id
       */
      vm.getStudentParents = function (student_id) {
        StudentsService.getStudentParents({student_id: student_id, matrix_period: vm.student.matrix_period})
          .then(function (response) {
            var data = response.plain();
            /**
             * Filtra os registros, formatando no grid os dados para apresentar os responsáveis financeiros e pedagógicos
             */
            for (var i = 0; i < data.length; i++) {
              if (angular.isDefined(data[i].person_id_payee) && data[i].person_id_payee === data[i].id) {
                data[i].is_payee = true;
                vm.payee = data[i].id;
              } else {
                data[i].is_payee = false;
              }
              if (angular.isDefined(data[i].person_id_responsible) && data[i].person_id_responsible === data[i].id) {
                data[i].is_responsible = true;
                vm.responsible = data[i].id;
              } else {
                data[i].is_responsible = false;
              }
            }
            vm.grid.rows = data;
            vm.verifyFatherAndMother();
            $rootScope.show_loader = false;
          })
      };

      $scope.$on('$destroy', function () {
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      });

      /**
       * Abre o modal de alteração do responsável pedagógico do aluno
       * @param responsible - id do novo responsável
       */
      vm.changeResponsible = function (responsible) {
        var obj = [];
        obj.push({responsible_id: responsible.id, student_id: $state.params.id, group_id: $state.params.group_id});
        ModalFactory.confirm(
          null,
          'Confirmação',
          'Você deseja definir esta pessoa como responsável pedagógica do aluno?',
          'Confirmar',
          'Cancelar',
          'educational',
          vm.changePedagogicResponsibleProcess,
          obj
        ).then(function () {
          Common.Toast.success('Responsável pedagógico alterado com sucesso!');
          vm.getStudentParents($state.params.id);
        })
      };

      /**
       * Realiza o processo de alteração do responsável pedagógico
       * @returns {void|*}
       * @param obj
       */
      vm.changePedagogicResponsibleProcess = function (obj) {
        return StudentsService.changeResponsible(
          {
            data: obj
          })
      };

      /**
       * Altera o relacionamento de parentesco entre o aluno e o responsável
       * @param responsible
       */
      vm.changeRelationship = function (responsible) {
        ModalFactory.customClean('app/educational/students/parents/views/modal_change_relationship.html',
          /** @ngInject */
          function (StudentsService, EnrolmentService, $mdDialog) {
            var vm = this;
            vm.previous_relation = angular.copy(responsible.prt_id);
            vm.responsible = angular.copy(responsible);
            vm.getPersonRelationLegal = function () {
              EnrolmentService.getPersonRelationLegal()
                .then(function (list) {
                  vm.person_relations = list.plain();
                  $rootScope.show_loader = false;
                });
            };
            /**
             * Altera o relacionamento de parentesco entre o aluno e o responsável
             */
            vm.saveRelationship = function () {
              StudentsService.changeRelationship({
                student_id: $state.params.id,
                responsible_id: vm.responsible.id,
                person_relation_type_id: vm.responsible.prt_id
              }).then(function () {
                $rootScope.show_loader = true;
                $mdDialog.hide(true);
                Common.Toast.success('Relacionamento alterado com sucesso!');
              })
            };
            vm.close = function () {
              $mdDialog.cancel();
            };
            vm.getPersonRelationLegal();
          }, 'vm', false, {responsible: responsible})
          .then(function () {
            vm.getStudentParents($state.params.id);
          });
      };

      /**
       * Abre o modal de confirmação para a deleção de responsável.
       * @param responsible
       */
      vm.delete = function (responsible) {
        ModalFactory.confirm(
          null,
          'Confirmação',
          'Você deseja deletar esse responsável?',
          'Deletar',
          'Cancelar',
          'educational'
        ).then(function () {
            $rootScope.show_loader = true;
            vm.deleteResponsibleProcess(responsible).then(function () {
              Common.Toast.success('Responsável deletado com sucesso!');
              vm.getStudentParents($state.params.id);
            });
          }
        ).catch(function () {
          Common.Toast.error('Erro na remoção do responsável!');
          $rootScope.show_loader = false;
        });
      };

      /**
       * Deleta o responsável
       * @param responsible
       * @returns {void|*}
       */
      vm.deleteResponsibleProcess = function (responsible) {
        return StudentsService.deleteResponsible(
          {
            student_id: $state.params.id,
            responsible: responsible
          })
      };


      /**
       * Inicia o processo de alteração do responsável financeiro.
       * @param responsible
       */
      vm.changePayee = function (responsible) {
        if (responsible.cpf === null || angular.isUndefined(responsible.cpf)) {
          vm.saveCPF(responsible);
        } else {
          /**
           * Verifica se o responsável financeiro também é o responsável pedagógico.
           * Se for, mostra modal de confirmação
           */
          if (vm.responsible === vm.payee) {
            ModalFactory.confirm(null, 'Alteração de responsável financeiro e pedagógico',
              'O responsável financeiro deste aluno também é seu responsável pedagógico, ' +
              'deseja tornar a pessoa selecionada responsável financeira e pedagógica?',
              'Tornar ambos', 'Tornar financeiro', 'educational').then(function () {
                vm.checkDependents(responsible, 1);
              }
            ).catch(function () {
              vm.checkDependents(responsible, 0);
            })
          } else {
            vm.checkDependents(responsible, 0);
          }
        }
      };
      /**
       * Verifica se o responsável possui mais dependentes
       * @param responsible
       * @param change_educational 0 - Alterar apenas financeiro  1 - Alterar responsável pedagógico e financeiro
       */
      vm.checkDependents = function (responsible, change_educational) {
        StudentsService.getAnotherDependents({
          student_id: $state.params.id,
          responsible_id: responsible.id
        }).then(function (data) {
          vm.dependents = data.plain();
          vm.names = '';
          for (var i = 0; i < vm.dependents.length; i++) {
            vm.names += " - " + vm.dependents[i].person_name + "\n";
          }
          if (vm.dependents.length > 0) {
            ModalFactory.confirm(null, 'Responsável possui outros dependentes', 'Esta pessoa é responsável também pelo(s) seguinte(s) aluno(s): \n' +
              '\n ' + vm.names + '. Deseja efetuar a alteração de responsável também para esses alunos?', 'Sim',
              'Não, apenas para o selecionado', 'educational').then(function () {
              /** Muda responsável de todos os dependentes */
              vm.dependents.push({person_id: $state.params.id});
              vm.changePayeeProcess(responsible, vm.dependents, change_educational)

            }).catch(function () {
              /** Muda responsável do aluno selecionado */
              vm.changePayeeProcess(responsible, [{
                person_id: $state.params.id
              }], change_educational)
            })
          } else {
            /** Muda responsável do aluno selecionado */
            vm.changePayeeProcess(responsible, [{
              person_id: $state.params.id
            }], change_educational)
          }
        });
      };

      /**
       * Processo de alteração do responsável financeiro
       * @param responsible
       * @param students
       * @param change_educational
       */
      vm.changePayeeProcess = function (responsible, students, change_educational) {
        ModalFactory.custom('app/educational/students/parents/views/modal-change-payee.html', null, false, null).then(function (object) {
          $rootScope.show_loader = true;
          object.date = a4Moment(object.date).format('YYYY-MM-DD');
          StudentsService.verifyBankSlipsForPayee({
            person_id_payee: vm.payee,
            date: object.option === 2 ? object.date : null,
            students: students
          }).then(function (active_bank_slips) {
            $rootScope.show_loader = false;
            if (active_bank_slips > 0) {
              var text = 'Encontramos ' + active_bank_slips + ' boletos bancários gerados para o responsável financeiro anterior. Ao confirmar' +
                ' a troca, estes boletos serão cancelados. Para cobrança bancária, você deverá gerar novos boletos para o novo' +
                ' responsável. O registro desses boletos implicará na cobrança de novas tarifas bancárias. ';
              vm.confirmPayeeChange(object, students, responsible, change_educational, text, 'ATENÇÃO aos boletos bancários')
            } else {
              vm.confirmPayeeChange(object, students, responsible, change_educational, null, null)
            }
          })
        })
      };

      /**
       * Abre modal de confirmação de senha
       * @param object
       * @param students
       * @param responsible
       * @param change_educational
       * @param text
       * @param subtitle
       */
      vm.confirmPayeeChange = function (object, students, responsible, change_educational, text, subtitle) {
        ModalFactory.open('require_password', null, null, {
            password: '',
            responsible: responsible,
            students: students,
            option: object.option,
            date: object.date,
            change_educational: change_educational
          }, null, 'educational', vm.executePayeeChange,
          'Alteração de responsável financeiro', text === null ? 'Confirme a senha para alterar o responsável' : text, subtitle)
          .then(function (answer) {
            if (answer) {
              Common.Toast.success('Responsável alterado com sucesso!');
              vm.getStudentParents($state.params.id);
            }
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });

      };

      /**
       * Salva CPF de responsável
       * @param responsible
       */
      vm.saveCPF = function (responsible) {
        ModalFactory.custom('app/educational/enrolment/enrolment-steps/responsibles/responsible-cpf.html', null, false, null)
          .then(function (object) {
            $rootScope.show_loader = true;
            /**
             * Salva o novo CPF do responsável.
             */
            ResponsiblesService.saveResponsibleCPF({cpf: object, person_id: responsible.id})
              .then(function () {
                $rootScope.show_loader = false;
                Common.Toast.success('CPF atualizado com sucesso!');
                responsible.cpf = object;
                vm.changePayee(responsible);
              }).catch(function () {
              $rootScope.show_loader = false;
              vm.getStudentParents($state.params.id);
              Common.Toast.error('Erro ao cadastrar o CPF. Contate o suporte.');
            })
          }).catch(function () {
          vm.getStudentParents($state.params.id);
        })
      };

      /**
       * Executa alteração do responsável
       * @param data
       * @returns {void|*}
       */
      vm.executePayeeChange = function (data) {
        return StudentsService.changePayee({
          responsible_id: data.responsible.id, students: data.students,
          option: data.option, date: data.date,
          change_educational: data.change_educational
        })
      };

      vm.init();
    }

    angular
      .module('app.educational.students.parents')
      .controller('ParentsStudentsController', ParentsStudentsController)
  }

)
();

(function () {
  'use strict';

  /** @ngInject */
  function ParentsAssistantController($scope, $mdDialog, $rootScope, StudentsService, $q, $timeout, $window,
                                      ModalExtra, Common, PersonService, ResponsiblesService) {
    var vm = this;

    /** Inicialização de variáveis */
    vm.is_edit = ModalExtra.is_edit;
    vm.waiting_address = false;
    vm.blockFormEmail = false;
    vm.waiting_city = false;
    vm.searchTextProfession = null;
    vm.group_id = ModalExtra.group_id;
    vm.is_pedagogic = false;
    vm.searchText_place_of_birth = '';
    vm.searchText_state_of_birth = '';
    vm.waiting_city_place_of_birth = false;
    vm.searchText_address_state = '';
    vm.searchText_address_city = '';
    vm.waiting_city_address_city = false;
    vm.first_selection = true;
    vm.form = {
      mode_edit: true,
      person: {search: '', type: 1},
      person_parent: {},
      responsible_selected: null
    };
    vm.start_size = '140px';
    vm.steps = {
      search: {id: 0, completed: false, disabled: false},
      informations: {id: 1, completed: false, disabled: true},
      contact: {id: 2, completed: false, disabled: true},
      end: {id: 3, completed: false, disabled: true}
    };

    vm.size = {
      0: vm.start_size,
      1: '500px',
      2: '500px',
      3: '300px'
    };

    vm.resize = function () {
      vm.windowSize = (angular.element("#content").height() - (angular.element("#page-material-table").height() + angular.element("#toolbar").height()));
      if (vm.windowSize < 350) {
        vm.size[0] = '300px';
        vm.size[1] = '300px';
        vm.size[2] = '300px';
        vm.size[3] = '300px';

      } else {
        vm.size[0] = '170px';
      }
    };

    var ln = $(window).resize(function () {
      vm.resize();
    });

    if (vm.is_edit === 1) {
      vm.step_selected = 1;
      vm.steps.search.completed = true;
      vm.steps.search.disabled = true;
      vm.steps.end.disabled = true;
    } else {
      vm.step_selected = 0;
    }

    vm.list = {
      person: {},
      person_parent: {}
    };
    vm.relationship = 1;

    vm.init = function () {
      vm.resize();
      vm.getFormInfos();
      vm.responsibles_ids = ModalExtra.responsibles_ids;
      vm.matrix_period = ModalExtra.matrix_period;
      vm.form.person.name = ModalExtra.name;
      if (vm.is_edit === 1) {
        vm.form.person = ModalExtra.responsible;
      }
      vm.is_enrolment = angular.isDefined(ModalExtra.enrolment);
      if (vm.is_enrolment) {
        vm.step_selected = 1;
      }
    };

    /**
     * Salva novo responsável
     */
    vm.save = function () {
       vm.disable = true;
      /**
       * Caso o auto-complete esteja preenchido com um nome de profissão que não existe, dá início ao processo
       * de criação de nova profissão
       */
      if (angular.isUndefined(vm.form.person.person_profession_id) && vm.searchTextProfession !== null) {
        vm.form.person.new_profession_name = vm.searchTextProfession;
      }
      if ((angular.isUndefined(vm.form.person.state_of_birth) || vm.form.person.state_of_birth === null) && vm.searchText_state_of_birth !== '') {
        vm.form.person.state_of_birth = vm.searchText_state_of_birth;
      }
      if ((angular.isUndefined(vm.form.person.place_of_birth) || vm.form.person.place_of_birth === null) && vm.searchText_place_of_birth !== '') {
        vm.form.person.place_of_birth = vm.searchText_place_of_birth;
      }
      if ((angular.isUndefined(vm.form.person.address_state) || vm.form.person.address_state === null) && vm.searchText_address_state !== '') {
        vm.form.person.address_state = vm.searchText_address_state;
      }
      if ((angular.isUndefined(vm.form.person.address_city) || vm.form.person.address_city === null) && vm.searchText_address_city !== '') {
        vm.form.person.address_city = vm.searchText_address_city;
      }
      if (vm.is_edit !== 1 && vm.form.responsible_selected === null) {
        ResponsiblesService.createResponsible(vm.form.person)
          .then(function (response) {
          var person = response.plain();
          vm.form.person.id = person.result.id;
          vm.addResponsible();
        })
      } else {
        ResponsiblesService.updateResponsible(vm.form.person)
          .then(function () {
          if (vm.form.responsible_selected !== null && vm.is_edit !== 1) {
            vm.addResponsible();
          } else {
            vm.closeModal(true);
            Common.Toast.success('Responsável atualizado com sucesso!');
          }
        })
          .catch(function (error){
            vm.disable = false;
            if(angular.isDefined(error.data)) {
              Common.Toast.error(error.data.message);
            } else{
              Common.Toast.error("Erro ao adicionar responsável");
            }
          })
      }
    };

    /**
     * Adiciona novo responsável
     */
    vm.addResponsible = function () {
      var data = {
        student_id: ModalExtra.student_id,
        responsible_id: vm.form.responsible_selected !== null ? vm.form.responsible_selected.id : vm.form.person.id,
        person_relation_type_id: vm.relationship,
        matrix_period: vm.matrix_period
      };
      $rootScope.show_loader = true;
      StudentsService.addResponsible(data)
        .then(function (response) {
          /** Verifica se é para tornar responsável pedagógico */
          if (vm.is_pedagogic) {
            var obj = [];
            obj.push({
              responsible_id: data.responsible_id,
              student_id: data.student_id,
              matrix_period: data.matrix_period,
              group_id: vm.group_id
            });
            StudentsService.changeResponsible({data: obj});
          }
          Common.Toast.success('Responsável salvo com sucesso');
          vm.closeModal(response);
        })
        .catch(function () {
          Common.Toast.error('Erro ao salvar responsável');
        });
      $rootScope.show_loader = false;
    };

    vm.getPerson = function (query) {
      return PersonService.searchPerson({search: query, hasCompany: false});
    };

    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      $rootScope.show_loader = true;
      ResponsiblesService.getPersonInfo()
        .then(function (response) {
          vm.list.person = response.person;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.closeModal = function (answer) {
      $mdDialog.hide(answer);
    };

    /**
     * Recebe as submissões de todas as etapas do assitente
     */
    vm.submit = function () {
      vm.disable = true;
      $timeout(function () {
        vm.disable = false;
      }, 3000);
      $rootScope.show_loader = true;
      if (vm.form.responsible_selected !== null && vm.first_selection) {
        ResponsiblesService.getById(vm.form.responsible_selected.id).then(function (response) {
          vm.form.person = response.person;
          vm.first_selection = false;
        });
        vm.step_selected = 3;
      } else {
        if (vm.step_selected === 1 && vm.form.person.is_deceased) {
          // Pula o passo "Contato" e vai direto para "Final" caso a pessoa seja falecida
          vm.step_selected = 4; 
        } else {
            vm.step_selected++;
        }
        vm.form.person.name = angular.isUndefined(vm.form.person.name) || vm.form.person.name == null ? angular.copy(vm.searchText) : vm.form.person.name;
      }
      if ((angular.isUndefined(vm.form.person.state_of_birth) || vm.form.person.state_of_birth === null)
        && vm.searchText_state_of_birth !== '') {
        vm.form.person.state_of_birth = vm.searchText_state_of_birth;
      }
      if ((angular.isUndefined(vm.form.person.place_of_birth) || vm.form.person.place_of_birth === null)
        && vm.searchText_place_of_birth !== '') {
        vm.form.person.place_of_birth = vm.searchText_place_of_birth;
      }
      $rootScope.show_loader = false;
    };

    /**
     * Volta para etapa anterior
     */
    vm.moveToPreviousStep = function () {

      if (vm.step_selected === 4 && vm.form.person.is_deceased) {
        // Pula os passos "Contato" e "Inf. funcionais" e vai direto para "Dados pessoais" caso a pessoa seja falecida
        vm.step_selected = 1;
      } else {
        vm.step_selected = vm.step_selected - 1;
      }
    };

    vm.init();
  }

  angular
    .module('app.educational.students.parents')
    .controller('ParentsAssistantController', ParentsAssistantController)
})();

(function(){
  'use strict';

  angular
    .module('app.educational.students.occurrences', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function OccurrencesUpdateStudentsController(a4Moment, PoliciesService, EventsService, moment, ModalExtra, $rootScope, Common, StudentsService) {

    var vm = this;

    vm.form = {
      event: {},
      mode_edit: true
    };

    vm.list = {
      event: {}
    };

    vm.init = function () {
      vm.getListValuesForEvents();
      vm.form.occurrence = {};
      vm.form.occurrence.id = ModalExtra.form.id;
      vm.is_lesson_student = ModalExtra.form.is_lesson_student;
      vm.today = a4Moment();

    };

    /**
     * Pega as listas de valores para a criação da ocorrência
     */
    vm.getListValuesForEvents = function () {
      EventsService.getListValuesForEvents()
        .then(function (resp) {
          vm.list.event = resp;
          vm.form.event.id = ModalExtra.form.id;
          vm.form.event.date_done = moment(angular.copy(ModalExtra.form.occurrence_date));
          vm.form.event.event_type_id = ModalExtra.form.event_type_id;
          vm.form.event.notes_done = ModalExtra.form.notes_done;
          vm.form.event.is_confidencial = ModalExtra.form.is_confidencial;
          vm.form.event.is_to_publish = ModalExtra.form.is_to_publish;
        })
    };

    /**
     * Edição da ocorrência
     * @param item - dados da ocorrência
     * @param form - dados do form
     */
    vm.submit = function (item, form) {

      item.person_id = ModalExtra.person_id;
      if (form.$valid) {
        if (vm.is_lesson_student) {
          StudentsService.updateLessonStudentNotes(item).then(function () {
            $rootScope.$broadcast('student.occurrences.list.update');
            Common.Toast.success('Ocorrência editada com sucesso');
            vm.close();
          })
        } else {
          item.id = ModalExtra.form.id;
          item.is_to_publish = vm.form.event.is_to_publish;
          item.is_confidencial = vm.form.event.is_confidencial;
          EventsService.updateEvent(item).then(function () {
            $rootScope.$broadcast('student.occurrences.list.update');
            Common.Toast.success('Ocorrência editada com sucesso');
            vm.close();
          })
        }
      }
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /**
     * Desmarca o botão de Publicar, caso o checkbox de 'Confidencial' esteja marcado
     */
    vm.disableToPublish = function () {
      if (vm.form.event.is_confidencial){
        vm.form.event.is_to_publish = 0;
      }
    };


    /* Verifica Politicas de acesso
      * @param policy - Identificador da politica de acesso
      * @returns {boolean}
    */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular
    .module('app.educational.students.occurrences')
    .controller('OccurrencesUpdateStudentsController', OccurrencesUpdateStudentsController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function OccurrencesCreateStudentsController(PoliciesService, EventsService, a4Moment, ModalExtra, $rootScope, Common) {

    var vm = this;

    vm.form = {
      event: {
        is_confidencial: false,
        is_to_publish: false
      },
      mode_edit: true
    };

    vm.list = {
      event: {}
    };

    vm.init = function () {
      vm.getListValuesForEvents();
      vm.today = a4Moment();
      vm.form.event.date_done = a4Moment()._d;
    };

    /**
     * Pega as listas de valores para a criação da ocorrência
     */
    vm.getListValuesForEvents = function () {
      EventsService.getListValuesForEvents()
        .then(function (resp) {
          vm.list.event = resp;
          vm.form.event.show_type = true;
        })
    };

    /**
     * Desmarca o botão de Publicar, caso o checkbox de 'Confidencial' esteja marcado
     */
    vm.disableToPublish = function () {
      if (vm.form.event.is_confidencial) {
        vm.form.event.is_to_publish = 0;
      }
    };

    /**
     * Salvamento da ocorrência
     * @param item - dados da ocorrência
     * @param form - dados do form
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        vm.loading = true;
        item.person_id = parseInt(ModalExtra.person_id);
        EventsService.saveEvents(item)
          .then(function () {
            vm.loading = false;
            $rootScope.$broadcast('student.occurrences.list.update');
            Common.Toast.success('Ocorrência adicionada com sucesso');
            vm.close();
          })
          .catch(function () {
            vm.loading = false;
          })
      }
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /* Verifica Politicas de acesso
      * @param policy - Identificador da politica de acesso
      * @returns {boolean}
    */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular
    .module('app.educational.students.occurrences')
    .controller('OccurrencesCreateStudentsController', OccurrencesCreateStudentsController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function OccurrencesStudentsController(PoliciesService, $state, Common, StudentsService, a4Moment, $a4FloatButton, $scope, ModalFactory,
                                         $rootScope) {

    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.occurrence_types = [];
    vm.occurrence_type = null;

    /** Atualiza a lista de ocorrências */
    var ltn = $rootScope.$on('student.occurrences.list.update', function () {
      vm.getStudentOccurrences();
    });

    vm.init = function () {
      vm.student_id = $state.params.id;
      vm.getStudentOccurrences();
      vm.getOccurrenceTypes();
      if (!vm.checkPolicies('aluno_ocor_alt')) {
        vm.floatButton = $a4FloatButton({
          scope: $scope,
          onClick: 'vm.createOccurrence()',
          label: 'Adicionar ocorrência'
        });
      }
    };

    /** Resgata as ocorrências do aluno*/
    vm.getStudentOccurrences = function (page, limit) {
      page = angular.isDefined(page) ? page : 1;
      limit = angular.isDefined(limit) ? limit : 20;
      vm.promise = StudentsService.getStudentOccurrences({
        id: vm.student_id, page: page, limit: limit,
        occurrence_type_id: vm.occurrence_type
      })
        .then(function (response) {
          vm.grid.data = response[0].data;
          vm.grid.last_page = response[0].last_page;
          vm.grid.current_page = response[0].current_page;
          vm.grid.total = response[0].total;
          vm.grid.per_page = response[0].per_page;
          vm.grid.data.forEach(function (item) {
            item.type = "Em aula";
            item.ocurrence_date = a4Moment(item.ocurrence_date).format('DD/MM/YYYY');
          })
          vm.grid.name = response[1][0].name;
        });
    };

    vm.checkProfile = function (profile) {
      return PoliciesService.currentProfile() === profile;
    };

    vm.getOccurrenceTypes = function () {
      StudentsService.getOccurrenceTypes().then(function (response) {
        vm.occurrence_types = response.plain();
      })
    };

    /**
     * Exclui ocorrência
     * @param item
     */
    vm.delete = function (item) {
      ModalFactory.confirm(null, 'Excluir ocorrência', 'Deseja realmente excluir esta ocorrência?',
        'Excluir', 'Cancelar', 'educational').then(function () {
        StudentsService.deleteStudentOccurrence(item).then(function () {
          vm.getStudentOccurrences();
          Common.Toast.success('Ocorrência excluída com sucesso!');
        })
      })
    };

    /** Abre o modal de criação de ocorrência */
    vm.createOccurrence = function () {
      ModalFactory.customClean(
        'app/educational/students/occurrences/views/create.html',
        'OccurrencesCreateStudentsController',
        'vm', false, {person_id: $state.params.id}
      ).then((function () {
        vm.getStudentOccurrences();
      }));
    };

    /**
     * Abre o modal para edição de ocorrência
     * @param item
     */
    vm.editOccurrence = function (item) {
      if (item.is_confidencial) {
        $rootScope.show_loader = true;
        StudentsService.decryptOccurrence(item.id).then(function (occurrence) {
          item.notes_done = occurrence;
          $rootScope.show_loader = false;
          vm.openEditModal(item);
        }).catch(function (error) {
          Common.Toast.error(error.message || error.data.message);
          $rootScope.show_loader = false;
        })
      } else {
        item.notes_done = item.occurrence;
        vm.openEditModal(item);
      }

    };

    vm.openEditModal = function (item) {
      ModalFactory.customClean(
        'app/educational/students/occurrences/views/create.html',
        'OccurrencesUpdateStudentsController',
        'vm', false, {form: item, person_id: $state.params.id}
      );
    };

    /* Verifica Politicas de acesso
      * @param policy - Identificador da politica de acesso
      * @returns {boolean}
    */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.students.occurrences')
    .controller('OccurrencesStudentsController', OccurrencesStudentsController)
})();

(function(){
  'use strict';

  angular
    .module('app.educational.students.medical-records', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function MedicalRecordsController($rootScope, $a4FloatButton, $state, $scope, Common, EnrolmentService, StudentsService) {
    var vm = this;
    vm.person_id = $state.params.id;
    vm.person_relation = {};
    vm.init = function () {
      vm.getPersonRelationLegal();
      vm.getPersonMedicalData();
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        theme: 'educational',
        onClick: 'vm.saveMedicalData()',
        icon: 'save',
        label: 'Salvar'
      });

    };

    /**
     * Busca dados médicos do aluno
     */
    vm.getPersonMedicalData = function () {
      $rootScope.show_loader = true;
      StudentsService.getPersonMedicalData({person_id: vm.person_id}).then(function (response) {
        vm.medical_data = response.plain();
      });
      $rootScope.show_loader = false;
    };

    /**
     * Busca graus de parentesco existentes
     */
    vm.getPersonRelationLegal = function () {
      EnrolmentService.getPersonRelationLegal()
        .then(function (list) {
          vm.person_relation.person_relation_type_id = list.plain();
          $rootScope.show_loader = false;
        });
    };

    /**
     * Salva os dados médicos
     */
    vm.saveMedicalData = function () {
      $rootScope.show_loader = true;
      StudentsService.updatePersonMedicalData({
        medical_data: vm.medical_data,
        person_id: vm.person_id
      }).then(function () {
        $rootScope.show_loader = false;
        Common.Toast.success('Dados médicos salvos com sucesso!');
        vm.getPersonMedicalData();
      })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao salvar Dados médicos.');
        })
    };

    vm.init();

  }

  angular
    .module('app.educational.students.medical-records')
    .controller('MedicalRecordsController', MedicalRecordsController)
})();
(function(){
  'use strict';

  angular
    .module('app.educational.students.financial', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function FinancialStudentsController($a4FloatButton, $scope, $document, a4Moment, CONFIG, StudentsService,
                                       PersonService, $state, Session, ReportsService, PoliciesService, $rootScope,
                                       BillReceiptService, ModalFactory, $timeout) {
    var vm = this;
    vm.list = {
      rows: [],
      info: {}
    };
    /** Variável para avisar quando não existem mais dados para serem carregados em tela */
    vm.hasDataToLoad = true;
    vm.bills = {expenses: [], receipts: [], checks: []};
    vm.selected = [];
    vm.date = null;
    vm.show_only_student = false;
    vm.show_only_group = false;
    vm.history = 0;
    vm.credit_balance = 0;
    vm.student = {
      id: $state.params.id,
      person_id: $state.params.id,
      course_id: $state.params.course_id,
      group_id: $state.params.group_id,
      matrix_period: $state.params.matrix_period
    };
    vm.contract =
      {};
    vm.school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.frequency_options = BillReceiptService.getFrequencyOptions();
    vm.preferencial_due_day_list = BillReceiptService.range();
    vm.webLink = CONFIG.webApiUri;
    vm.subdomain = null;
    vm.page = 1;
    vm.qtd = 15;
    vm.statusDefined = [];
    vm.person_id = $state.params.id;
    vm.group_id = $state.params.group_id;
    vm.course_id = $state.params.course_id;
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.current_page = 0;
    vm.show_button_more = true;

    /**
     * Listener para saber quando a opção de mostrar apenas o aluno foi alterada
     */
    $scope.$on('change-show-only-student', function (event, change_show_only_student) {
      vm.show_only_student = change_show_only_student;
    });
    $scope.$on('change-show-only-group', function (event, show_only_group) {
      vm.show_only_group = show_only_group;
    });
    $rootScope.$on('UPDATE_CREDITS_LIST', function () {
      vm.getPendingDifferences();
    });

    /**
     * Busca o saldo de diferenças pendentes nos títulos
     */
    vm.getPendingDifferences = function () {
      BillReceiptService.getPendingDifferences({person_id: vm.person_id})
        .then(function (response) {
          var data = response.plain();
          vm.pending_differences = Math.abs(angular.copy(data.amount));
          if (data.amount > 0) {
            vm.has_credit = true;
          } else if (data.amount < 0) {
            vm.has_debit = true;
          }
          vm.history = data.counter;
        });
    };

    vm.resize = function () {
      vm.windowHeight = (angular.element("#content").height() - (angular.element("#toolbar").height())) * 0.54;
      if (vm.windowHeight < 400) {
        vm.windowHeight = vm.windowHeight * 0.97;
        if (vm.windowHeight < 380) {
          vm.windowHeight = vm.windowHeight * 0.93;
        }
        if (vm.windowHeight < 350) {
          vm.windowHeight = vm.windowHeight * 0.91;
          if (vm.windowHeight < 270) {
            vm.windowHeight = vm.windowHeight * 0.85;
          }
        }
      }
    };

    var ln = $(window).resize(function () {
      vm.resize();
    });


    vm.init = function () {
      vm.getPendencies(vm.current_page, 20, null);
      vm.getPendingDifferences();
      vm.resize();
      vm.getStudentParents();
      vm.subdomain = $document[0].domain.split('.')[0];
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
          vm.conf.current_school_period_id = $scope.educational.school_period.selected.id;
        });
      StudentsService.getById(vm.person_id, false, vm.student.matrix_period, vm.group_id)
        .then(function (person) {
          vm.student.name = person.person.name;
          vm.contract.name = person.person.name;
          vm.student.national_id_number = person.national_id_number;
          vm.contract.national_id_number = person.national_id_number;
          vm.student.dob = a4Moment(person.person.dob, 'YYYY-MM-DD');
          vm.contract.dob = a4Moment(person.person.dob, 'YYYY-MM-DD');
          vm.student.person_id_payee = person.person.person_id_payee;
          vm.contract.person_id = person.person.person_id_payee;
          vm.conf.school_period_id = person.person.school_period_id;
        });
    };

    /**
     * Retorna todos os grupos de curso disponíveis
     * @param page - pagina corrente da paginação
     * @param qtd
     * @param date
     * @param person_id
     * @param status
     * @param flag
     * @param order
     * @param show_only_student
     */
    vm.getPendencies = function (page, qtd, date, person_id, status, flag, order, show_only_student) {
      vm.show_button_more = true;
      vm.show_loader = true;
      vm.current_page++;
      if (angular.isDefined(status) && status.length > 0) {
        status = status.map(function (item) {
          return item.id;
        }).toString();
      }
      page = angular.isDefined(page) ? page : 1;
      person_id = (angular.isUndefined(person_id) || person_id === null) ? vm.person_id : person_id;
      date = date == null ? {startDate: null, endDate: null} : date;
      var product_id = null;
      if (vm.show_only_group) {
        product_id = vm.group_id;
      }

      var obj = {
        startDate: date === null ? null : date.startDate,
        endDate: date === null ? null : date.endDate,
        debit_credit: 'C',
        person_id: person_id,
        page: page === 1 ? page : vm.current_page,
        qtd: page === 1 && vm.current_page !== page ? vm.current_page * 20 : 20,
        status: status,
        show_only_student: angular.isDefined(show_only_student) ? show_only_student : false,
        is_student: true,
        direction: angular.isUndefined(order) ? 'asc' : (order.substring(0, 1) === '-' ? 'asc' : 'desc'),
        only_selected_school_period: (angular.isUndefined(status) || status.length === 0) &&
        (date.startDate === null || angular.isUndefined(date)) ? true : null,
        group_id: product_id
      };

      return vm.promise = PersonService.getBillsFromPerson(obj)
        .then(function (bills) {
          if (obj.page === 1) {
            vm.bills = bills;
            vm.show_loader = false;
          } else {
            vm.bills.data = vm.bills.data.concat(bills.data);
            vm.show_loader = false;
          }
          if (bills.data.length === 0) {
            vm.show_button_more = false;
          }
          vm.bills.order = order;
          vm.show_loader = false;
        })
        .catch(function () {
          vm.show_loader = false;
        });
    };


    /**
     * Retorna a lista de responsáveis pelo aluno
     */
    vm.getStudentParents = function () {
      StudentsService.getStudentParents({
        student_id: vm.student.person_id,
        matrix_period: vm.student.matrix_period,
        group_id: vm.group_id
      })
        .then(function (response) {
          var data = response.plain();
          /**
           * Filtra os registros, formatando no grid os dados para apresentar os responsáveis financeiros e pedagógicos
           */
          for (var i = 0; i < data.length; i++) {
            if (angular.isDefined(data[i].person_id_payee) && data[i].person_id_payee === data[i].id) {
              data[i].is_payee = true;
              vm.payee = data[i].id;
            } else {
              data[i].is_payee = false;
            }
            if (angular.isDefined(data[i].person_id_responsible) && data[i].person_id_responsible === data[i].id) {
              data[i].is_responsible = true;
              vm.responsible = data[i].id;
            } else {
              data[i].is_responsible = false;
            }
          }
          vm.studentsResponsibles = data;
          $rootScope.show_loader = false;
        })
    };

    vm.openContractModal = function (data) {
      data.enrolment = {
        payment_plans: data.enrolment.payment_plans,
        last_enrolment_data: data.enrolment.last_enrolment_data,
        payee_has_dependents: data.enrolment.payee_has_dependents,
        student: data.enrolment.student
      };
      data.enrolment.student.person_id_payee = vm.student.person_id_payee;
      data.studentsResponsibles = vm.studentsResponsibles;
      $timeout(function () {
        ModalFactory.customClean(
          'app/components/a4-contract/contract-modal.html',
          'A4ContractModalController',
          'vm', false, data
        )
          .then(function () {
            vm.current_page = 1;
            vm.getAllContracts();
          });
      }, 1000);
    };

    vm.getAllContracts = function (page, qtd, search_name) {
      $rootScope.show_loader = true;
      vm.promise = BillReceiptService.getAllContracts({
        debit_credit: 'C',
        page: page,
        qtd: qtd,
        person_id: angular.isUndefined(vm.person_id) ? undefined : vm.person_id,
        search_name: search_name,
        group_id: vm.group_id
      })
        .then(function (response) {
          vm.allContracts = response.plain();
          /**
           * Verificação da data final, para verificar se o contrato está cancelado
           */
          for (var i = vm.allContracts.data.length; i--;) {
            if (vm.allContracts.data[i].date_end !== null && a4Moment(vm.allContracts.data[i].date_end).isBefore(a4Moment().format('YYYY-MM-DD'))) {
              vm.allContracts.data[i].is_date_end_before_today = true;
            } else {
              vm.allContracts.data[i].is_date_end_before_today = false;
            }
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };


    /**
     * Imprime relatório da ficha financeira
     */
    vm.printBillsStudent = function (date, status, all_bills) {
      $rootScope.show_loader = true;
      var startDate = date === null ? null : date.startDate;
      var endDate = date === null ? null : date.endDate;
      if (angular.isDefined(status) && status.length > 0) {
        status = status.map(function (item) {
          return item.id;
        }).toString();
      }
      var product_id = null;
      if (vm.show_only_group) {
        product_id = vm.group_id;
      }
      var obj = {
        startDate: startDate,
        endDate: endDate,
        status: status,
        all_bills: all_bills,
        group_id: vm.group_id,
        product_id: product_id,
        person_id: vm.person_id,
        user_id: vm.conf.user_id,
        is_student: true,
        show_only_student: vm.show_only_student
      };
      BillReceiptService.printReport(obj)
        .then(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular
    .module('app.educational.students.financial')
    .controller('FinancialStudentsController', FinancialStudentsController)
})();

(function(){
  'use strict';

  angular
    .module('app.educational.students.extra-subjects', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ExtraSubjectsController($rootScope, $a4FloatButton, $state, $scope, Common, ExtraGradeService, ModalFactory) {
    var vm = this;
    vm.person_id = $state.params.id;
    var EXTRA_SUBJECTS = 2;
    vm.items = {};

    vm.init = function () {
      vm.getExtraSubjects();
    };

    /**
     * Retorna as disciplinas extras
     */
    vm.getExtraSubjects = function () {
      ExtraGradeService.getAllByType({type: EXTRA_SUBJECTS,
        person_id: vm.person_id, course_id: $state.params.course_id})
        .then(function (list) {
          vm.items.data = list.plain();
        });
    };

    /**
     * Abre o modal para edição de uma disciplina extra
     * @param item
     */
    vm.editItem = function (item) {
      ModalFactory.custom(
        'app/educational/students/extra-subjects/views/modal-edit-item.html',
        angular.copy(item),
        true
      ).then(function (data) {
        $rootScope.show_loader = true;
        ExtraGradeService.update(data)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Atividade editada com sucesso!');
            vm.getExtraSubjects();
          })
          .catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.error('Erro ao editar atividade.');
          })
      });
    };

    /**
     * Abre o modal para criação de uma disciplina extra
     */
    vm.addItem = function () {
      ModalFactory.custom(
        'app/educational/students/extra-subjects/views/modal-edit-item.html',
        {},
        true
      ).then(function (data) {
        data.type = EXTRA_SUBJECTS;
        data.person_id = $state.params.id;
        data.course_id = $state.params.course_id;
        $rootScope.show_loader = true;
        ExtraGradeService.create(data)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Disciplina extra adicionada com sucesso!');
            vm.getExtraSubjects();
          })
          .catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.error('Erro ao adicionar disciplina extra.');
          })
      });
    };

    /**
     * Exclui uma disciplina extra
     * @param id
     * @param name
     */
    vm.delete = function (id, name) {
      ModalFactory.confirm(null, 'Excluir disciplina extra', 'Confirma a exclusão da disciplina extra ' + name + '?',
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          $rootScope.show_loader = true;
          ExtraGradeService.deleteItem({id: id})
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Disciplina extra excluída com sucesso!');
              vm.getExtraSubjects();
            })
            .catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Não foi possível excluir a disciplina extra.');
            })
        })
    };

    vm.init();
  }

  angular
    .module('app.educational.students.extra-subjects')
    .controller('ExtraSubjectsController', ExtraSubjectsController)
})();
(function () {
  'use strict';

  angular.module('app.educational.students.evaluations-student', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function EvaluationsStudentController($stateParams, $state, $rootScope, QuestionnairesService, a4Moment, moment, ModalFactory, Common) {
    var vm = this;
    vm.group_id = $stateParams.group_id;
    vm.person_id = $stateParams.id;
    vm.matrix_period = $stateParams.matrix_period;
    vm.cookie = document.cookie.split('=')[1];
    vm.selected_tab = 0;
    vm.ACTION_STATUS = {
      0: 'Realizar',
      1: 'Continuar',
      10: 'Em correção',
      11: 'Ver correção',
      12: 'Fora da data',
      13: 'Fora do horário',
      14: 'Fora do horário',
      20: 'Concluído'
    };


    vm.obj = {
      person_id: vm.person_id,
      group_id: vm.group_id,
      matrix_period: vm.matrix_period,
      cookie: vm.cookie
    }

    vm.getAnswer = function (options, answer) {
      var item = null;
      options.forEach(function (option) {
        if (option.limit === answer) item = option.name;
      });
      return item;
    };

      vm.goToEvaluation = function (evaluation) {
        $rootScope.show_loader = true;
        if(evaluation.qp_status >= 10) {
          vm.cookie = "is_allowed";
        }
        QuestionnairesService.getEvaluationLink({
          person_id: vm.person_id,
          questionnaire_id: evaluation.id,
          group_id: vm.group_id,
          matrix_period: vm.matrix_period,
          cookie: vm.cookie
        }).then(function (link) {
          $rootScope.show_loader = false;
          var token = link.split('answer-questionnaire\/')[1];
          $state.go('public.answer-questionnaire', {
            token: token
          });
        }).catch(function (err) {
          $rootScope.show_loader = false;
          Common.Toast.error(err.data);
        })
      };

      vm.init = function () {
        $rootScope.show_loader = true;
        QuestionnairesService.getStudentEvaluations({
          person_id: vm.person_id,
          group_id: vm.group_id,
          matrix_period: vm.matrix_period
        }).then(function (response) {
          vm.student_evaluations = response.plain()[0];
          vm.today = response.plain()[1];
          if (vm.student_evaluations.length >= 1) {
            vm.evaluations_selected = vm.student_evaluations[0];
          }
          vm.student_evaluations.forEach(function (item, index) {
            if(item.qp_status < 10) {
              if (item.application_date !== null && (item.qp_status === 0 || item.qp_status === 1)) {
                vm.student_evaluations[index].qp_status = item.application_date === vm.today ? 0 : 12;
              }

              if(vm.student_evaluations[index].is_in_time) {
                vm.student_evaluations[index].qp_status = 14;
              }
              if(vm.student_evaluations[index].is_out_time) {
                vm.student_evaluations[index].qp_status = 13;
              }

              if(item.application_date !== null) {
                vm.student_evaluations[index].application_date = a4Moment(item.application_date).format('DD/MM/YYYY');
              }
            }
          });
          $rootScope.show_loader = false;
        })
      };

      vm.evaluationAction = function (evaluation) {
        switch (evaluation.qp_status) {
          case 0:
          case 1:
            vm.goToEvaluation(evaluation);
            break;
          case 10:
          case 11:
            // TODO
            break;
          case 12 && evaluation.application_date !== null:
            ModalFactory.alert(
              "Ainda não é o dia da avaliação",
              "A avaliação estará disponível no dia   " + evaluation.application_date,
              'modal', "Ok", 'false',
              'educational'
            );
            break;
          case 13:
            ModalFactory.alert(
              "Está fora do Horário!",
              "Esta avaliação tem o horário de término as: " + evaluation.execution_time,
              'modal', "Ok", 'false',
              'educational'
            );
            break;
          case 14:
            ModalFactory.alert(
              "Está fora do Horário!",
              "Esta avaliação tem o horário de inicio as: " + evaluation.answer_max_time_minutes + " e termino as: " +
              evaluation.execution_time,
              'modal', "Ok", 'false',
              'educational'
            );
            break;
          case 20:
            vm.goToEvaluation(evaluation);
            break;
        }
      };

      vm.init();
    }

    angular.module('app.educational.students.evaluations-student')
      .controller('EvaluationsStudentController', EvaluationsStudentController);
  })();

(function () {
  'use strict';
  angular.module('app.educational.enrolmentsstudent', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function EnrolmentsStudentController($scope, $state, $stateParams, $rootScope, StudentsService, Session) {
    var vm = this;
    vm.person_id = $stateParams.id;
    vm.course_equivalence_id = $stateParams.course_equivalence_id;
    vm.current_school_period_id = Session.getCurrentSchoolPeriod().name;
    vm.enrolments = [];

    vm.goToStudent = function (student) {
      $state.go('private.educational.students.edit', {
        id: student.person_id,
        course_id: student.course_id,
        group_id: student.group_id,
        course_equivalence_id: student.course_equivalence_id,
        matrix_period: student.matrix_period,
        change_school_period: student.school_period_id,
        enrolment_period_id: student.enrolment_period_id
      });
    };

    vm.init = function () {
      $rootScope.show_loader = true;
      StudentsService.getStudentEnrolments({
        person_id: vm.person_id,
        course_equivalence_id: vm.course_equivalence_id
      })
        .then(function (response) {
          vm.enrolments = response.plain();
          for (var i = 0; i < vm.enrolments.length; i++) {
            if (vm.enrolments[i].enrolment_period_changes !== null && vm.enrolments[i].enrolment_period_changes !== '{}') {
              vm.enrolments[i].enrolment_period_changes = angular.fromJson(vm.enrolments[i].enrolment_period_changes.replace('{', '[').replace('}', ']'));
            } else {
              vm.enrolments[i].enrolment_period_changes = null;
            }
          }
          $rootScope.show_loader = false;
        });
    };

    vm.init();
  }

  angular.module('app.educational.enrolmentsstudent')
    .controller('EnrolmentsStudentController', EnrolmentsStudentController);
})();

(function(){
  'use strict';

  angular
    .module('app.educational.students.documents', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DocumentsStudentController($rootScope, $a4FloatButton, $state, $scope, Common, CourseDocumentsService) {
    var vm = this;
    vm.grid = {
      rows: [],
      info: {}
    };
    vm.selected_documents = [];
    vm.student = {
      person_id: $state.params.id,
      course_id: $state.params.course_id
    };

    $scope.$on('refresh-student-documents', function () {
      vm.selected_documents = [];
      vm.paginate(1, 50);
    });

    /**
     * Busca e e retorna todos os documentos associados ao estudante, os entregues e que podem ser entregues, de acordo
     * com o curso e a turma.
     */
    vm.paginate = function (limit, page) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      if (vm.selected_documents.length > 0) {
        vm.selected_documents = [];
      }

      vm.grid.rows = [];
      vm.grid.promise = CourseDocumentsService.getDocumentsForStudent({
        person_id: $state.params.id,
        course_id: $state.params.course_id,
        group_id: $state.params.group_id
      })
        .then(function (response) {
          vm.grid.rows = response.plain();

          if (vm.grid.rows && typeof vm.grid.rows === 'object') {
            vm.grid.rows = Object.values(vm.grid.rows);
          }

          for (var i = 0; i < vm.grid.rows.length; i++) {
            if (vm.grid.rows[i].enrolment_id !== null) {
              vm.selected_documents.push(vm.grid.rows[i]);
            }
          }
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        });
    };


    /**
     * Atualiza os documentos do aluno.
     */
    vm.saveDocuments = function () {
      CourseDocumentsService.saveDocumentsForStudent({
        documents: vm.selected_documents, person_id: $state.params.id,
        group_id: $state.params.group_id
      }).then(function () {
        vm.paginate();
        Common.Toast.success("Documentos do aluno atualizados com sucesso.");
      });
    };

    vm.init = function () {
      vm.paginate();
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        theme: 'educational',
        onClick: 'vm.saveDocuments()',
        icon: 'save',
        label: 'Salvar'
      });

    };

    vm.init();

  }

  angular
    .module('app.educational.students.documents')
    .controller('DocumentsStudentController', DocumentsStudentController)
})();
(function(){
  'use strict';

  angular
    .module('app.educational.students.complementary-activities', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ExtraGradeService(Restangular) {

    var getAllByType = function (obj) {
      return Restangular.one('extra_grade').get(obj);
    };

    var update = function (obj) {
      return Restangular.one('extra_grade', obj.id).customPUT(obj);
    };

    var create = function (obj) {
      return Restangular.all('extra_grade').post(obj);
    };

    var deleteItem = function (obj) {
      return Restangular.one('extra_grade', obj.id).remove(obj);
    };

    return {
      getAllByType: getAllByType,
      update: update,
      create: create,
      deleteItem: deleteItem
    }
  }

  angular
    .module('app.educational.students.complementary-activities')
    .factory('ExtraGradeService', ExtraGradeService);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ComplementaryActivitiesController($rootScope, $a4FloatButton, $state, $scope, Common, ModalFactory,
                                             StudentsService, ExtraGradeService) {
    var vm = this;
    vm.person_id = $state.params.id;
    var COMPLEMENTARY_ACTIVITIES = 1;
    vm.items = {};

    vm.init = function () {
      vm.getComplementaryActivities();
    };

    /**
     * Retorna as atividades complementares
     */
    vm.getComplementaryActivities = function () {
      ExtraGradeService.getAllByType({
        type: COMPLEMENTARY_ACTIVITIES,
        person_id: vm.person_id, course_id: $state.params.course_id
      })
        .then(function (list) {
          vm.items.data = list.plain();
        });
    };

    /**
     * Abre o modal para edição de uma atividade
     * @param item
     */
    vm.editItem = function (item) {
      ModalFactory.custom(
        'app/educational/students/complementary-activities/views/modal-edit-item.html',
        angular.copy(item),
        true
      ).then(function (data) {
        $rootScope.show_loader = true;
        ExtraGradeService.update(data)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Atividade editada com sucesso!');
            vm.getComplementaryActivities();
          })
          .catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.error('Erro ao editar atividade.');
          })
      });
    };

    /**
     * Abre o modal para criação de uma atividade
     */
    vm.addItem = function () {
      ModalFactory.custom(
        'app/educational/students/complementary-activities/views/modal-edit-item.html',
        {},
        true
      ).then(function (data) {
        data.type = COMPLEMENTARY_ACTIVITIES;
        data.person_id = $state.params.id;
        data.course_id = $state.params.course_id;
        $rootScope.show_loader = true;
        ExtraGradeService.create(data)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Atividade adicionada com sucesso!');
            vm.getComplementaryActivities();
          })
          .catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.error('Erro ao adicionar atividade.');
          })
      });
    };

    /**
     * Exclui uma atividade
     * @param id
     * @param name
     */
    vm.delete = function (id, name) {
      ModalFactory.confirm(null, 'Excluir atividade', 'Confirma a exclusão da atividade ' + name + '?',
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          $rootScope.show_loader = true;
          ExtraGradeService.deleteItem({id: id})
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Atividade excluída com sucesso!');
              vm.getComplementaryActivities();
            })
            .catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Não foi possível excluir a atividade.');
            })
        })
    };

    vm.init();
  }

  angular
    .module('app.educational.students.complementary-activities')
    .controller('ComplementaryActivitiesController', ComplementaryActivitiesController)
})();
(function(){
  'use strict';

  angular
    .module('app.educational.students.classes', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ModalAttachmentsController(Common, $mdDialog, ModalExtra) {
    var vm = this;

    vm.files = ModalExtra.files;
    vm.uri = ModalExtra.webApiUri;

    vm.closeModal = function () {
      $mdDialog.cancel();
    };

    vm.downloadFile = function (file) {
      var deffered = Common.$q.defer();
      const link = document.createElement('a');
      try {
        var blob = new Blob([file], {type: file.extension});
        var url = window.URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute("download", file.name);
        var clickEvent = new MouseEvent("click", {
          "view": window,
          "bubbles": true,
          "cancelable": true
        });
        link.dispatchEvent(clickEvent);
        deffered.resolve(true);
      } catch (ex) {
        deffered.reject(ex);
      }
    }
  }

  angular
    .module('app.educational.students.classes')
    .controller('ModalAttachmentsController', ModalAttachmentsController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassroomsStudentsController($scope, $rootScope, a4Moment, $filter, ClassReleaseService,
                                        ModalFactory, $state, PoliciesService, Session, CONFIG) {
    var vm = this;

    /** Grid padrão */
    vm.grid = {
      rows: [], info: {}, promise: {}, selected: [], selected_column: 'date_hour',
      title: {
        name: 'Aulas disponíveis',
        show: false
      }
    };
    vm.has_date = false;
    /** Disciplinas disponíveis */
    vm.subjects = [];
    /** Formulário padrão */
    vm.form = {
      subject: null, date: {startDate: null, endDate: null},
      status: 0
    };

    vm.filter_lesson_status = 0;
    vm.filter_lesson_status_pressed = 0;

    /** Função de inicio do controlador */
    vm.init = function () {
      var context = Session.get(CONFIG.storage.context);
      var user = Session.get(CONFIG.storage.user);
      vm.student_id = context.is_student ? user.person.id : $state.params.id;
      vm.paginate();
    };

    /**
     * Retorna todos as classes disponíveis
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     */
    vm.paginate = function (page, limit) {

      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      ClassReleaseService.getClassesByStudent({
        limit: limit,
        page: page,
        start_date: vm.form.date.startDate,
        end_date: vm.form.date.endDate,
        at_today: false,
        subject_id: vm.form.subject,
        student_id: vm.student_id,
        filter_lesson_status: vm.filter_lesson_status
      }).then(function (response) {
        vm.grid = response.plain();
        vm.grid.data = vm.formatGrid(response.data);
        $rootScope.show_loader = false;
        vm.has_date = false;
        vm.filter_lesson_status_pressed = vm.filter_lesson_status;
      }).catch(function () {
        $rootScope.show_loader = false;
      });
      
    };

    /**
     * Realiza a formatação necessária para a exibição do grid
     * @param array
     * @returns {*}
     */
    vm.formatGrid = function (array) {
      /** Filtro para data e horários */
      angular.forEach(array, function (item) {

        /** Splita a initial e final time*/
        item.initial_time = item.initial_time !== null ? item.initial_time.substr(0, 5) : '';
        item.final_time = item.final_time !== null ? item.final_time.substr(0, 5)  : '';

        /** Filtro para horário */
        item.time = $filter('date')(item.initial_time, "h:mma") + ' - '
          + $filter('date')(item.final_time, "h:mma");

        /** Filtro para data */
        item.show_date = $filter('date')(item.date, "dd/MM/yyyy (EEE)");

        /** Definição de Data e Hora */
        item.date_hour = (item.show_date !== null ? item.show_date : '') + ' | ' + item.time;

        /** Definição do nome da classe */
        item.class = item.course_name + ' | ' + item.group_name + ' | ' + item.subject_name;

        /** Verifica se já há a disciplina */
        var index = vm.subjects.indexOf(vm.subjects.filter(function (i) {
            return i.subject_id === item.subject_id
          })[0]
        );
        /** Adiciona as disciplina nova */
        if (index < 0) {
          vm.subjects.push({subject_id: item.subject_id, subject_name: item.subject_name});
        }

        /** Define o estatus da presença */
        if (item.attendance_id == null) {
          item.attendance_name = 'Presente';
        } else {
          switch (item.attendance_id) {
            case 2:
              item.attendance_name = 'Ausente';
              break;
            case 3:
              item.attendance_name = 'Atrasado';
              break;
            case 4:
              item.attendance_name = 'Saiu Antes';
              break;
          }
        }

        item.lesson_status_name = (item.lesson_status_name === null) ? 'Pendente' : item.lesson_status_name;
      });console.log(array);
      return array;
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /** Exibe o modal para adição de anexos */
    vm.openAttachments = function (lesson) {
      ModalFactory.customClean('app/educational/students/classrooms/views/attachments-modal.html',
        'ModalAttachmentsController',
        'vm',
        true,
        {
          files: JSON.parse(lesson.files),
          webApiUri: CONFIG.webApiUri
        });
    };

    vm.init();

  }

  angular
    .module('app.educational.students.classes')
    .controller('ClassroomsStudentsController', ClassroomsStudentsController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function ClassesStudentsController(ClassesService, $rootScope, $scope, $state) {

    var vm = this;

    vm.grid = {
      rows: []
    };

    /**
     * Evento de inicialização da tela
     * @type {*}
     */
    var ltn = $rootScope.$on('a4-form-dic-data.form.loaded', function () {
      $rootScope.show_loader = true;
      vm.enrolment_period_id = $state.params.enrolment_period_id;
      vm.getClasses();
      $rootScope.show_loader = false;
    });

    /**
     * Evento de seleção da tab
     * @type {*}
     */
    var ltn1 = $rootScope.$on('student.tab.reload', function () {
      vm.enrolment_period_id = $state.params.enrolment_period_id;
      vm.getClasses();
    });

    vm.init = function () {
      $rootScope.show_loader = true;
      $rootScope.$broadcast('a4-form-dic-data.form.loaded');
      $rootScope.show_loader = false;
    };

    /**
     * Retorna todas as classes do aluno
     */
    vm.getClasses = function () {
      $rootScope.show_loader = true;
      ClassesService.getClassesForStudent({id: vm.enrolment_period_id})
        .then(function (response) {
          vm.grid.rows = response.plain();
        });
      $rootScope.show_loader = false;
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.students.classes')
    .controller('ClassesStudentsController', ClassesStudentsController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function SettingsTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "SETTINGS": {
        "TITLE": "Configurações"
      }
    })

  }

  angular
    .module('app.finance.settings')
    .config(SettingsTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.school-records-config', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function SchoolRecords($translateProvider) {

        $translateProvider.translations('pt', {
            "SCHOOL_RECORDS_CONFIG": {
                "TITLE": "Configuração de Histórico Escolar"
            }
        })

    }

    angular
        .module('app.educational.school-records-config')
        .config(SchoolRecords);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.school-period-config', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function SchoolPeriodConfig($translateProvider) {

        $translateProvider.translations('pt', {
            "SCHOOL_PERIOD_CONFIG": {
                "TITLE": "Configuração de Período Letivo"
            }
        })

    }

    angular
        .module('app.educational.school-period-config')
        .config(SchoolPeriodConfig);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.school-period', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function SchoolPeriod($translateProvider) {

        $translateProvider.translations('pt', {
            "SCHOOL_PERIOD": {
              "ADD_PLAN": "Adicionar Período",
              "TITLE": "Períodos Letivos",
              "SEARCH_FOR_ANYONE": "Pesquisar",
              "FORM_CREATE": "Criar Período",
              "FORM_EDIT": "Editar Período"
            }
        })

    }

    angular
        .module('app.educational.school-period')
        .config(SchoolPeriod);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.rounding-criteria', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function EvaluationCriteriaTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "ROUNDING_CRITERIA": {
                "ADD_GROUP": "Adicionar critério",
                "TITLE": "Critérios de Arredondamento",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Criar critérios",
                "FORM_EDIT": "Editar critério"
            }
        })
    }

    angular
        .module('app.educational.rounding-criteria')
        .config(EvaluationCriteriaTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.responsibles', [
      'app.educational.responsibles.financial-situation',
      'app.educational.responsibles.dependents',
      'app.educational.responsibles.school-reports'
    ]);

})();

(function () {
    'use strict';

    /** @ngInject */
    function ResponsiblesTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "RESPONSIBLES": {
                "ADD_RESPONSIBLES": "Adicionar novo",
                "TITLE": "Pais, Responsáveis e Fiadores",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Cadastrar novo",
                "FORM_EDIT": "Editar turma"
            }
        })

    }

    angular
        .module('app.educational.responsibles')
        .config(ResponsiblesTranslate);
})();

(function () {
  'use strict';


  angular
    .module('app.educational.responsibles.school-reports', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.school-reports', {
        public: false,
        url: '/school-reports',
        templateUrl: 'app/educational/responsibles/school-reports/views/school-reports.html',
        controller: 'SchoolReportsResponsibleController',
        controllerAs: 'vm'
      })
    // .state('private.educational.financial-situation.edit', {
    //   url: '/view',
    //   public: false,
    //   views: {
    //     'financial': {
    //       templateUrl: 'app/educational/responsibles/financial-situation/views/financial-situation.html',
    //       controller: 'FinancialSituationController',
    //       controllerAs: 'vm'
    //     }
    //   }
    // });
  }

  angular
    .module('app.educational.responsibles.school-reports')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'aluno_boletim';
    var path = 'educational.school-reports';
    msNavigationService.saveItem('educational.school-reports', {
      title: 'Boletins',
      icon: 'icon-library-books',
      state: 'private.educational.school-reports',
      weight: 6,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path) || !PoliciesService.isParent();
      }
    });
  }

  angular
    .module('app.educational.responsibles.school-reports')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function SchoolReportsResponsibleController(Session, $rootScope, ResponsiblesService, ReportsService, NoteReleaseService, $document, CONFIG,
                                              $scope, $timeout) {
    var vm = this;
    vm.user = Session.getUser();
    vm.students = [];
    vm.tabSelected = 0;
    vm.grid = {rows: [], info: {}};
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.webLink = CONFIG.webApiUri;
    vm.special_characters = ['F', 'D', 'S', 'FN', 'DP', 'SR'];
    vm.isNumber = angular.isNumber;
    vm.school_period_id = Session.getCurrentSchoolPeriod().id;

    vm.init = function () {
      $rootScope.show_loader = true;
      vm.school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      ResponsiblesService.getStudentsForResponsible({id: vm.user.id})
        .then(function (response) {
          vm.students = response.plain();
          if (angular.isDefined(vm.students[0])) {
            vm.getStudentReport();
          }
        })
    };

    /**
     * Formata nota para exibição
     * @param value
     * @returns {*}
     */
    vm.formatValue = function (value) {
      if (value >= 0 || isNaN(value)) {
        return value;
      } else {
        switch (value) {
          case -1:
            return 'FN';
          case -3:
            return 'SR';
          case -5:
            return 'DP';
        }
      }
    };

    vm.getStudentReport = function () {
      vm.student = vm.students[vm.tabSelected];
      $rootScope.show_loader = true;
      console.log(vm.students)
      console.log(vm.school_period_id)
      NoteReleaseService.getStudentsSubjects({
        person_id: vm.student.id, getCalculated: true,
        school_period_id: vm.school_period_id, course_id: vm.student.course_id,
        is_school_report: true, group_id: vm.student.group_id
      })
        .then(function (response) {
          response = response.plain();
          vm.subjects = response.subjects;
          vm.school_periods = response.school_periods;
          /** Verifica as disciplinas filhas e move o seu posicionamento */
          angular.forEach(vm.subjects, function (subject) {
            if (subject.subject_parent.length > 0) {
              var i = 0;
              angular.forEach(subject.subject_parent, function (subject_child) {
                var index = vm.subjects.indexOf(subject);
                var subject_c = vm.getObject(subject_child.id);
                /** Remove o objeto original da posição */
                vm.removeObject(subject_child.id);
                /** Clona o objeto que deverá ser filho e aloca atrás do pai */
                vm.subjects.splice(index, 0, subject_c);
                i++;
              });
            }
          });
          vm.grid.grade_json = response.grade_json;
          vm.grid.steps = response.steps;
          vm.grid.academic_status = response.academic_status;
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna o objeto desejado e define como filho
     * @param id
     */
    vm.getObject = function (id) {
      var index = vm.subjects.indexOf(vm.subjects.filter(function (i) {
          return i.subject_id === id
        })[0]
      );

      if (index >= 0) {
        vm.subjects[index].is_child = true;
        return vm.subjects[index];
      }
    };

    /**
     * Remove o objeto original do array
     * @param id
     */
    vm.removeObject = function (id) {
      /** Pega a posição */
      var del = vm.subjects.indexOf(vm.subjects.filter(function (i) {
          return i.subject_id === id
        })[0]
      );
      /** Remove o objeto */
      vm.subjects.splice(vm.subjects.indexOf(vm.subjects[del]), 1);
    };

    vm.printNotes = function () {
      ReportsService.reportFactory('GET',
                      'api/reports/schoolreport',
        {
          // school_period_id: vm.school_period_id,
          student_id: vm.student.id,
          getCalculated: true,
          is_detailed: vm.is_detailed,
          matrix_period: vm.student.matrix_period,
          student_group_id: vm.student.group_id

        });

      // $rootScope.show_loader = true;
      // $timeout(function () {
      //   var href = vm.webLink + 'api/reports/schoolreport?token=' + vm.conf.token + '&company=' + vm.conf.current_company
      //     + '&connection=' + vm.conf.current_connection + '&user_id=' + vm.conf.user_id +
      //     '&school_period_id=' + vm.school_period_id + '&student_id=' + vm.student.id + '&getCalculated=' + true
      //     + '&is_detailed=' + vm.is_detailed + '&matrix_period=' + vm.student.matrix_period + '&student_group_id=' + vm.student.group_id;
      //   var element = document.createElement('a');
      //   element.setAttribute('href', href);
      //   element.setAttribute('target', '_blank');
      //   $rootScope.show_loader = false;
      //   return element.click();
      // }, 1000);

    };


    /**
     * Retorna o valor desejado das definições da grade
     * @param id
     * @param field - campo desejado
     */
    vm.getValue = function (id, field) {
      var index = vm.grid.grade_json.indexOf(vm.grid.grade_json.filter(function (i) {
          return i.name === id
        })[0]
      );

      if (index >= 0) {
        return vm.grid.grade_json[index][field];
      }
    };

    vm.init();
  }

  angular.module('app.educational.responsibles.school-reports')
    .controller('SchoolReportsResponsibleController', SchoolReportsResponsibleController);

})();

(function () {
  'use strict';

  angular
    .module('app.educational.responsibles.financial-situation', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.financial-situation', {
        public: false,
        url: '/financial',
        templateUrl: 'app/educational/responsibles/financial-situation/views/financial-situation.html',
        controller: 'FinancialSituationController',
        controllerAs: 'vm'
      })
      // .state('private.educational.financial-situation.edit', {
      //   url: '/view',
      //   public: false,
      //   views: {
      //     'financial': {
      //       templateUrl: 'app/educational/responsibles/financial-situation/views/financial-situation.html',
      //       controller: 'FinancialSituationController',
      //       controllerAs: 'vm'
      //     }
      //   }
      // });
  }

  angular
    .module('app.educational.responsibles.financial-situation')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'resp_financial';
    var path = 'educational.financial-situation';
    msNavigationService.saveItem('educational.financial-situation', {
      title: 'Financeiro',
      icon: 'icon-document',
      state: 'private.educational.financial-situation',
      weight: 5,
      hidden: function () {
        return !PoliciesService.isParent() || !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.responsibles.financial-situation')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function FinancialSituationController($a4FloatButton, Session, BillReceiptService, $document, a4Moment, CONFIG, StudentsService,
                                        PersonService, $state, ReportsService, $scope, $rootScope, PoliciesService,
                                        ModalFactory) {
    var vm = this;
    vm.list = {
      rows: [],
      info: {}
    };
    /** Variável para avisar quando não existem mais dados para serem carregados em tela */
    vm.hasDataToLoad = true;
    vm.bills = {expenses: [], receipts: [], checks: []};
    vm.selected = [];
    vm.date = null;
    vm.webLink = CONFIG.webApiUri;
    vm.subdomain = null;
    vm.page = 1;
    vm.school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.current_page = 0;
    vm.show_button_more = true;
    vm.qtd = 15;
    vm.statusDefined = [];
    vm.person_id = angular.isDefined($state.params.id) ? $state.params.id : Session.user.id;
    vm.group_id = $state.params.group_id;
    vm.course_id = $state.params.course_id;
    vm.filter_date = {
      startDate: a4Moment().startOf('year').format('YYYY-MM-DD'),
      endDate: a4Moment().endOf('year').format('YYYY-MM-DD')
    };
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.resize = function () {
      vm.windowHeight = (angular.element("#content").height() - (angular.element("#toolbar").height())) * 0.53;
      if (vm.windowHeight < 400) {
        vm.windowHeight = vm.windowHeight * 0.97;
        if (vm.windowHeight < 380) {
          vm.windowHeight = vm.windowHeight * 0.93;
        }
        if (vm.windowHeight < 350) {
          vm.windowHeight = vm.windowHeight * 0.91;
          if (vm.windowHeight < 270) {
            vm.windowHeight = vm.windowHeight * 0.85;
          }
        }
      }
    };

    var ln = $(window).resize(function () {
      vm.resize();
    });


    vm.init = function () {
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        theme: 'educational',
        onClick: 'vm.printBillsResponsible()',
        icon: 'print',
        label: 'Imprimir ficha financeira'
      });

      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
          vm.conf.current_school_period_id = $scope.educational.school_period.selected.id;
        });
      PersonService.getPayeeByResponsible({person_id: vm.person_id})
        .then(function(response) {
          vm.person_id = response;
          vm.can_print_contract = vm.returnCanPrintContract();
          vm.getPendencies(vm.windowHeight, 15, vm.filter_date, vm.person_id);
          vm.subdomain = $document[0].domain.split('.')[0];
        })
    };

    vm.returnCanPrintContract = function () {
      return PoliciesService.checkPolicyFromMenu('resp_print_contract');
    };

    vm.getAllContracts = function (page, qtd, search_name) {
      $rootScope.show_loader = true;
      
      vm.promise = BillReceiptService.getAllContracts({
        debit_credit: 'C',
        page: page,
        qtd: qtd,
        person_id: angular.isUndefined(vm.person_id) ? undefined : vm.person_id,
        search_name: search_name,
        group_id: vm.group_id
      })
        .then(function (response) {
          vm.allContracts = response.plain();
          /**
           * Verificação da data final, para verificar se o contrato está cancelado
           */
          for (var i = vm.allContracts.data.length; i--;) {
            if (vm.allContracts.data[i].date_end !== null && a4Moment(vm.allContracts.data[i].date_end).isBefore(a4Moment().format('YYYY-MM-DD'))) {
              vm.allContracts.data[i].is_date_end_before_today = true;
            } else {
              vm.allContracts.data[i].is_date_end_before_today = false;
            }
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.openContractModal = function (data) {
      ModalFactory.customClean(
        'app/components/a4-contract/contract-modal.html',
        'A4ContractModalController',
        'vm', false, data
      )
        .then(function () {
          vm.current_page = 1;
          vm.getAllContracts();
        });
    };


    /**
     * Retorna todos os grupos de curso disponíveis
     * @param page - pagina corrente da paginação
     * @param qtd - limite de registros por pagina
     * @param date
     * @param person_id
     * @param status
     * @param flag
     */
    vm.getPendencies = function (page, qtd, date, person_id, status, flag, order) {
      vm.show_button_more = true;
      vm.show_loader = true;
      vm.current_page++;
      qtd = angular.isDefined(qtd) ? qtd : 50;
      status = angular.isUndefined(status) ? null : status;
      page = angular.isDefined(page) ? page : 1;
      person_id = (angular.isUndefined(person_id) || person_id === null) ? vm.person_id : person_id;
      date = date == null ? {startDate: null, endDate: null} : date;
      flag = angular.isDefined(flag);
      vm.infiniteScrollFormat(flag, status, date);

      var obj = {
        startDate: vm.date === null ? date.startDate : vm.date.startDate,
        endDate: vm.date === null ? date.endDate : date.endDate,
        debit_credit: 'C', person_id: person_id,
        page: page === 1 ? page : vm.current_page,
        qtd: page === 1 && vm.current_page !== page ? vm.current_page * 20 : 20,
        status: vm.statusDefined.length === 0 ? null : vm.statusDefined.toString(),
        direction: angular.isUndefined(order) ? 'asc' : (order.substring(0, 1) === '-' ? 'desc' : 'asc'),
        only_selected_school_period: vm.statusDefined.length === 0 && (date === null ||
          date.startDate === null) ? true : null

      };

      vm.promise = PersonService.getBillsFromPerson(obj)
        .then(function (bills) {
          if (obj.page === 1) {
            vm.bills = bills;
          } else {
            vm.bills.data = vm.bills.data.concat(bills.data);
          }
          if (bills.data.length === 0) {
            vm.show_button_more = false;
          }
          vm.bills.order = order;
          vm.show_loader = false;
        })
        .catch(function () {
          vm.show_loader = false;
        });
    };

    /**
     * Imprime relatório da ficha financeira
     */
    vm.printBillsResponsible = function (date) {
      var startDate = date === null ? null : date.startDate;
      var endDate = date === null ? null : date.endDate;
      var href = vm.webLink + 'api/reports/billsstudent?token=' + vm.conf.token + '&company=' + vm.conf.current_company
        + '&connection=' + vm.conf.current_connection + '&current_school_period=' + vm.school_period_id +
        '&person_id=' + vm.person_id + '&user_id=' + vm.conf.user_id
        + (startDate != null ? ("&startDate=" + startDate) : '') + (endDate != null ? ("&endDate=" + endDate) : '');
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.infiniteScrollFormat = function (flag, status, date) {
      /** Variável para verificar se o botão de pesquisa foi clicado. Caso tenha sido, reajusta os filtros da página. */
      if (flag) {
        vm.statusDefined = [];
        flag = false;
        if (status) {
          for (var i = 0; i < status.length; i++)
            vm.statusDefined.push(status[i].id);
        }
      }

      /** Adiciona os Ids dos status selecionados em um Array */
      if (status) {
        /** Quando o filtro é desselecionado, o status vira null, e uma busca normal é realizada (sem filtros) */
        if (status.length === 0) {
          status = null;
        } else {
          for (var u = 0; u < status.length; u++)
            vm.statusDefined.push(status[u].id);
        }
      }

      if (!status) {
        status = [];
      }

      /** Persiste o filtro da data selecionado, para não perder a referência quando for chamado o infinite scroll. */
      if (date.startDate !== null) {
        vm.date = date;
      }
    };

    vm.init();
  }

  angular
    .module('app.educational.responsibles.financial-situation')
    .controller('FinancialSituationController', FinancialSituationController)
})();
(function () {
  'use strict';

  angular
    .module('app.educational.responsibles.dependents', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ResponsiblesDependentsController(ResponsiblesService, $state) {

    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    /**
     * Vai para a página do aluno
     * @param item
     */
    vm.goToDependent = function (item) {
      $state.go('private.educational.students.edit', {
        id: item.id,
        course_id: item.course_id,
        group_id: item.group_id,
        course_equivalence_id: item.course_equivalence_id,
        matrix_period: item.matrix_period,
        enrolment_period_id: item.enrolment_period_id
      });
    };

    /**
     * Busca todos os estudantes associados ao responsável
     */
    vm.getStudents = function () {
      ResponsiblesService.getStudentsForResponsible({id: $state.params.id}).then(function (response) {
        vm.grid.rows = response.plain();

      });
    };

    vm.init = function () {
      vm.getStudents();

    };

    vm.init();

  }

  angular
    .module('app.educational.responsibles.dependents')
    .controller('ResponsiblesDependentsController', ResponsiblesDependentsController);

})();

(function () {
  'use strict';

  angular
    .module('app.educational.responsible-changes', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.responsible-changes', {
        public: false,
        url: '/responsible-changes',
        templateUrl: 'app/educational/responsible-changes/views/responsible-changes.html',
        abstract: true
      })
      .state('private.educational.responsible-changes.list', {
        url: '/list',
        public: false,
        views: {
          'responsible-changes': {
            templateUrl: 'app/educational/responsible-changes/list/views/list.html',
            controller: 'ResponsibleChangesListController',
            controllerAs: 'vm'
          }
        }
      });

  }

  angular
    .module('app.educational.responsible-changes')
    .config(routerConfig);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ResponsibleChangesListController($rootScope, $scope, $state, $a4FloatButton,
                                          ResponsiblesService, ModalFactory, Common, PoliciesService) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.form = {};
    vm.sys_log_status_id = 1; // Valor padrão: Pendente

    // Status disponíveis para filtro
    vm.status_options = [
      { id: 0, name: 'Todos os status' },
      { id: 1, name: 'Pendente' },
      { id: 2, name: 'Sem alterações' },
      { id: 4, name: 'Recusado' },
      { id: 5, name: 'Aceito' }
    ];

    vm.init = function () {
      vm.paginate();
    };

    /**
     * Retorna todos os responsáveis com alterações pendentes
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     */
    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      var params = {
        limit: limit, 
        page: page, 
        sys_log_status_id: vm.sys_log_status_id
      };

      vm.grid.promise = ResponsiblesService.getAll(params)
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
          $rootScope.show_loader = false;
        });
    };

    /**
     * Filtra por status
     */
    vm.filterByStatus = function () {
      vm.paginate(1, vm.grid.info.limit);
    };

    /**
     * Abre modal de confirmação
     * @param item - item selecionado
     */
    vm.viewDetails = function (item) {
      ModalFactory.customClean(
        'app/educational/responsible-changes/detail/views/detail-modal.html',
        'ResponsibleChangesDetailController',
        'vm', false, {
          responsible: item
        }
      ).then(function (result) {
        // Só atualiza a lista se houve ação (aceitar/recusar)
        if (result === 'updated') {
          vm.paginate(); // Recarrega a lista após ação
        }
      });
    };

    /**
     * Retorna a classe CSS do badge baseada no status
     * @param status_id
     * @returns {string}
     */
    vm.getStatusClass = function (status_id) {
      switch (status_id) {
        case 1: return 'pendente'; // Abóbora
        case 2: return 'confirmado'; // Azul escuro
        case 4: return 'recusado'; // Cinza
        case 5: return 'aceito'; // Azul
        default: return 'pendente';
      }
    };

    /**
     * Retorna o texto do status
     * @param status_id
     * @returns {string}
     */
    vm.getStatusText = function (status_id) {
      switch (status_id) {
        case 1: return 'Pendente';
        case 2: return 'Sem alterações';
        case 4: return 'Recusado';
        case 5: return 'Aceito';
        default: return 'Pendente';
      }
    };

    vm.init();
  }

  angular
    .module('app.educational.responsible-changes')
    .controller('ResponsibleChangesListController', ResponsibleChangesListController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ResponsibleChangesDetailController($rootScope, $scope, $mdDialog, ResponsiblesService, Common, ModalExtra) {
    var vm = this;

    vm.responsible = ModalExtra.responsible;
    vm.status_id = vm.responsible.sys_log_status_id;

    // Processa as propriedades de alteração se existirem
    vm.processProperties = function() {
      if (vm.responsible.properties) {
        try {
          vm.properties = angular.isString(vm.responsible.properties) ? 
            angular.fromJson(vm.responsible.properties) : vm.responsible.properties;
        } catch (e) {
          console.error('Erro ao processar properties:', e);
          vm.properties = null;
        }
      }
    };

    /**
     * Retorna o valor a ser exibido para um campo
     * @param fieldName
     * @returns {object} {original: valor, new: valor}
     */
    vm.getFieldValues = function(fieldName) {
      var originalValue = vm.properties.origin ? vm.properties.origin[fieldName] : null;
      var newValue = vm.properties.changes ? vm.properties.changes[fieldName] : null;
      
      // Se existe entrada em 'show' para este campo, usar o valor de 'show'
      if (vm.properties.show && vm.properties.show[fieldName] !== undefined) {
        newValue = vm.properties.show[fieldName];
      }
      
      return {
        original: originalValue,
        new: newValue
      };
    };

    /**
     * Retorna se há alterações para mostrar
     * @returns {boolean}
     */
    vm.hasChanges = function() {
      var hasChanges = vm.properties && 
                      vm.properties.changes && 
                      Object.keys(vm.properties.changes).length > 0;
      
      if (vm.properties && vm.properties.changes) {
        
        // Verificar cada campo
        angular.forEach(vm.properties.changes, function(newValue, fieldName) {
          var values = vm.getFieldValues(fieldName);
          console.log('Campo:', fieldName, 'Original:', values.original, 'Novo:', values.new, 'Diferente:', vm.valuesAreDifferent(values.original, values.new));
        });
      }
      
      return hasChanges;
    };

    /**
     * Retorna o valor formatado para exibição
     * @param value
     * @returns {string}
     */
    vm.formatValue = function(value) {
      if (value === null || value === undefined) {
        return 'Não informado';
      }
      if (typeof value === 'boolean') {
        return value ? 'Sim' : 'Não';
      }
      if (typeof value === 'string' && value.trim() === '') {
        return 'Não informado';
      }
      if (typeof value === 'number' && value === 0) {
        return value.toString();
      }
      return value;
    };

    /**
     * Retorna o nome amigável do campo
     * @param fieldName
     * @returns {string}
     */
    vm.getFieldDisplayName = function(fieldName) {
      var fieldNames = {
        'name': 'Nome',
        'alias_name': 'Apelido',
        'corporate_name': 'Razão Social',
        'national_id_number': 'CPF/CNPJ',
        'state_registration_number': 'Inscrição Estadual',
        'municipal_registration_number': 'Inscrição Municipal',
        'main_contact_name': 'Nome do Contato Principal',
        'person_sex_id': 'Sexo',
        'birth_date': 'Data de Nascimento',
        'place_of_birth': 'Local de Nascimento',
        'state_of_birth': 'Estado de Nascimento',
        'city_of_birth': 'Cidade de Nascimento',
        'id_number': 'RG',
        'id_issuer': 'Órgão Expedidor',
        'id_date_issue': 'Data de Expedição',
        'id_state': 'Estado do RG',
        'id_complement': 'Complemento do RG',
        'email': 'E-mail',
        'phone_landline': 'Telefone Residencial',
        'phone_landline_2': 'Telefone Residencial 2',
        'phone_mobile': 'Celular',
        'address_postal_code': 'CEP',
        'address_street': 'Endereço',
        'address_line2': 'Complemento',
        'address_house_number': 'Número',
        'address_state': 'Estado',
        'address_city': 'Cidade',
        'address_district': 'Bairro',
        'notes': 'Observações',
        'father_name': 'Nome do Pai',
        'mother_name': 'Nome da Mãe',
        'is_deceased': 'Falecido',
        'is_alumni': 'Ex-aluno',
        'company_work': 'Empresa',
        'position_held': 'Cargo',
        'job_role': 'Função',
        'years_in_employment': 'Anos de Emprego',
        'work_phone_1': 'Telefone Comercial 1',
        'work_phone_2': 'Telefone Comercial 2',
        'phone_extension': 'Ramal',
        'work_address_postal_code': 'CEP Comercial',
        'work_address_street': 'Endereço Comercial',
        'work_address_line2': 'Complemento Comercial',
        'work_address_house_number': 'Número Comercial',
        'work_address_state': 'Estado Comercial',
        'work_address_city': 'Cidade Comercial',
        'work_address_district': 'Bairro Comercial',
        'person_profession_id': 'Profissão',
        'person_marital_status_id': 'Estado Civil',
        'person_educational_level_id': 'Nível Educacional'
      };
      
      return fieldNames[fieldName] || fieldName;
    };

    /**
     * Retorna a classe CSS para destacar alterações
     * @param oldValue
     * @param newValue
     * @returns {string}
     */
    vm.getChangeClass = function(oldValue, newValue) {
      if (oldValue !== newValue) {
        return 'change-highlight';
      }
      return '';
    };

    /**
     * Compara dois valores de forma robusta
     * @param oldValue
     * @param newValue
     * @returns {boolean}
     */
    vm.valuesAreDifferent = function(oldValue, newValue) {
      // Se ambos são null/undefined, são iguais
      if ((oldValue === null || oldValue === undefined) && 
          (newValue === null || newValue === undefined)) {
        return false;
      }
      
      // Se um é null/undefined e o outro não, são diferentes
      if ((oldValue === null || oldValue === undefined) !== 
          (newValue === null || newValue === undefined)) {
        return true;
      }
      
      // Converter para string para comparação
      var oldStr = String(oldValue).trim();
      var newStr = String(newValue).trim();
      
      return oldStr !== newStr;
    };

    // Processa as propriedades na inicialização
    vm.processProperties();

    /**
     * Retorna a classe CSS do badge baseada no status
     * @param status_id
     * @returns {string}
     */
    vm.getStatusClass = function (status_id) {
      switch (status_id) {
        case 1: return 'pendente'; // Abóbora
        case 2: return 'confirmado'; // Azul escuro
        case 4: return 'recusado'; // Cinza
        case 5: return 'aceito'; // Azul
        default: return 'pendente';
      }
    };

    /**
     * Retorna o texto do status
     * @param status_id
     * @returns {string}
     */
    vm.getStatusText = function (status_id) {
      switch (status_id) {
        case 1: return 'Pendente';
        case 2: return 'Sem alteração';
        case 4: return 'Recusado';
        case 5: return 'Aceito';
        default: return 'Pendente';
      }
    };

    /**
     * Verifica se deve mostrar botão Aceitar
     * @returns {boolean}
     */
    vm.showAcceptButton = function () {
      return vm.status_id === 1 || vm.status_id === 4; // Pendente ou Recusado
    };

    /**
     * Verifica se deve mostrar botão Recusar
     * @returns {boolean}
     */
    vm.showRejectButton = function () {
      return vm.status_id === 1; // Apenas Pendente
    };

    /**
     * Aceita a alteração
     */
    vm.accept = function () {
      $rootScope.show_loader = true;
      
      var params = {
        responsible_id: vm.responsible.responsible_id,
        action: 'accept',
        sys_log_status_id: 5 // Aceito
      };

      ResponsiblesService.updateResponsibleStatus(params)
        .then(function () {
          Common.Toast.success('Alteração aceita com sucesso');
          $rootScope.show_loader = false;
          $mdDialog.hide('updated'); // Retorna 'updated' para indicar que houve mudança
        })
        .catch(function () {
          Common.Toast.error('Erro ao aceitar alteração');
          $rootScope.show_loader = false;
        });
    };

    /**
     * Recusa a alteração
     */
    vm.reject = function () {
      $rootScope.show_loader = true;
      
      var params = {
        responsible_id: vm.responsible.responsible_id,
        action: 'reject',
        sys_log_status_id: 4 // Recusado
      };

      ResponsiblesService.updateResponsibleStatus(params)
        .then(function () {
          Common.Toast.success('Alteração recusada com sucesso');
          $rootScope.show_loader = false;
          $mdDialog.hide('updated'); // Retorna 'updated' para indicar que houve mudança
        })
        .catch(function () {
          Common.Toast.error('Erro ao recusar alteração');
          $rootScope.show_loader = false;
        });
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $mdDialog.hide(); // Não retorna nada, indicando que não houve mudança
    };

  }

  angular
    .module('app.educational.responsible-changes')
    .controller('ResponsibleChangesDetailController', ResponsibleChangesDetailController);

})();

(function() {
  'use strict';
  angular.module('app.external-reports-locked', []);
})();

(function () {
  'use strict'

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('public.externalschoolrecordslocked', {
        public: true,
        url: '/externalschoolrecordslocked',
        templateUrl: 'app/educational/reports/locked/locked.html'
      })
  }


  angular.module('app.external-reports-locked')
    .config(routerConfig);
})();

(function(){
  'use strict';

  angular
    .module('app.educational.note-release', [
      'app.educational.note-release.students',
      'app.educational.note-release.groups',
      'app.educational.note-release.grouping',
      'app.educational.note-release.council',
      'app.educational.note-release.subjects'
    ]);

})();

(function () {
    'use strict';

    /** @ngInject */
    function NoteReleaseTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "NOTE_RELEASE": {
                "TITLE": "Lançamento de notas",
                "SEARCH_FOR_ANYONE": "Pesquisar"
            }
        })

    }

    angular
        .module('app.educational.note-release')
        .config(NoteReleaseTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.note-release.subjects', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseSubjectsController($rootScope, $scope, $a4FloatButton, Common, NoteReleaseService, ModalFactory, PoliciesService) {
    var vm = this;

    /** DEFINIÇÃO DE VARIAVEIS */
    vm.grid = {rows: [], info: {}};
    vm.floatButton = null;
    vm.subjects = [];
    vm.event_selected = [];
    vm.selectAllEvent = false;
    vm.listStudents = [];
    vm.listStudentsSelected = null;
    vm.buttons = {
      submit: true,
      group: false,
      allowGroup: false
    };

    /**
     * Metódo de iniciação do controlador
     */
    vm.init = function () {
      vm.getAllEnrolmentSubjects();
      vm.current_profile = PoliciesService.currentProfile();

    };

    /**
     * Esculta a alteração da lista
     * de estudantes selecionados
     */
    $scope.$watch('vm.listStudentsSelected', function () {
      if (vm.listStudentsSelected !== null && vm.listStudentsSelected.length > 1) {
        if (vm.buttons.submit && vm.buttons.allowGroup) {
          vm.openMultimpleNotesForStudents();
        }
      } else {
        if (vm.buttons.group) {
          vm.showSubmitForStudents();
        }
      }
    }, true);

    /**
     * Esculta a alteração da lista de eventos selecionados
     */
    $scope.$watch('vm.event_selected', function () {
      if (angular.isArray(vm.event_selected)) {
        vm.buttons.allowGroup = (vm.event_selected.length === 1);
      }
      if (!vm.buttons.allowGroup) {
        vm.listStudentsSelected = [];
        vm.showSubmitForStudents();
      }
    }, true);

    /**
     * Realiza o limpeza dos objetos
     */
    vm.clear = function () {
      vm.subject_selected = null;
      vm.student_selected = null;
      vm.group_selected = null;
      vm.event_selected = null;
      vm.students = null;
      vm.subjects = null;
      vm.grid.grades = [];
      vm.grid.students = [];
    };

    /**
     * Seleciona ou não todos os eventos
     */
    vm.selectAllEvents = function () {
      if (vm.selectAllEvent) {
        vm.event_selected = [];
        vm.selectAllEvent = false;
      } else {
        vm.event_selected = [];
        angular.forEach(vm.grid.grades, function (event) {
          vm.event_selected.push(event.name)
        });
        vm.selectAllEvent = true;
      }
    };

    /**
     * Filtra os eventos de acordo com o selecionado pelo usuário
     */
    vm.filterEvents = function () {
      var filtered =
        vm.grid.grades.filter(function (grade) {
          if (vm.event_selected !== null) {
            return vm.event_selected.indexOf(grade.name) !== -1;
          }
        });

      vm.alignSteps(filtered);

      return filtered;
    };


    /**
     * Reajusta as Etapas de acordo com os eventos.
     */
    vm.alignSteps = function (filteredList) {
      vm.grid.steps =
        /** Iteração na lista das ETAPAS */
        vm.grid.steps.filter(function (value) {
          var count = 0;
          /** Iteração na lista dos items escolhidos pelo usuário */
          filteredList.forEach(function (item) {
            /**
             * Executa uma verificação em cada item escolhido pelo usuário, e realiza um contador,
             * se o ID do filho for igual a o id de uma ETAPA, então o contador é incrementado.
             */
            if (value.id == item.grade_rule_item_id_parent) {
              count++;
            }

          });
          /** Caso não exista filhos de uma ETAPA, então a ETAPA deve ser escondida */
          value.show = count != 0;
          value.siblingsqtd = count;
          return value;
        })

    };

    /**
     * Exibe a coluna da tabela disponibilizada no filtro de eventos
     * @param id
     */
    vm.showColum = function (id) {
      if (vm.event_selected !== null) {
        return vm.event_selected.indexOf(id) !== -1;
      }
    };

    /**
     * Retorna o valor desejado das definições da grade
     * @param id
     * @param field - campo desejado
     */
    vm.getValue = function (id, field) {
      var index = vm.grid.grades.indexOf(vm.grid.grades.filter(function (i) {
          return i.name === id
        })[0]
      );

      if (index >= 0) {
        return vm.grid.grades[index][field];
      }
    };

    /**
     * Formata o valor não conceitual da nota para que seja decimal
     * @param value
     * @param maxValue
     * @returns {string}
     */
    vm.formatNote = function (value, maxValue) {
      var new_value = parseFloat(parseFloat(value).toFixed(2));
      var new_maxValue = parseFloat(parseFloat(maxValue).toFixed(2));
      if (!angular.isString(new_value)) {
        if (parseFloat(parseFloat(new_value).toFixed(2)) > parseFloat(parseFloat(new_maxValue).toFixed(2))) {
          Common.Toast.warning('Valor máximo permitido: ' + maxValue);
          //$scope.formNoteRelease[input].$setValidity('pattern', true); //forçar mensagem de erro
        }
      }
    };


    /**
     * Retorna as disciplinas que possuem matrícula
     */
    vm.getAllEnrolmentSubjects = function () {
      NoteReleaseService.getAllEnrolmentSubjects()
        .then(function (response) {
          vm.subjects = response.data;
        });
    };

    /**
     * Realiza o filtro pela disciplina
     * @param query - string escrita
     */
    vm.filterSubjectsList = function (query) {
      NoteReleaseService.getAllEnrolmentSubjects({query: query})
        .then(function (response) {
          if (angular.isDefined(response.data)) {
            vm.subjects = response.data;
          }
        })
    };

    /**
     * Retorna as turmas que possuem matrícula
     */
    vm.getAllEnrolmentGroups = function () {
      NoteReleaseService.getAllEnrolmentGroups()
        .then(function (response) {
          vm.groups = response.data;
        });
    };

    /**
     * Realiza o filtro pela turma
     * @param query - string escrita
     */
    vm.filterGroupsList = function (query) {
      NoteReleaseService.getAllEnrolmentGroups({query: query})
        .then(function (response) {
          if (angular.isDefined(response.data)) {
            vm.groups = response.data;
          }
        })
    };

    /**
     * Retorna as turmas vinculados a disciplina
     * @param subject - disciplina
     */
    vm.selectSubject = function (subject) {
      NoteReleaseService.getAllEnrolmentGroups({subject_id: subject.subject_id})
        .then(function (response) {
          response = response.plain();
          vm.groups = response.data;
        });
    };

    /**
     * Traz os textos de bloqueio.
     * @param code - Codigo do bloqueio.
     * @returns {*}
     */
    vm.getBlocks = function (code) {
      return NoteReleaseService.getReasons(code);
    };

    /**
     * Retorna os alunos vinculados a turma
     * @param group - turma
     */
    vm.selectStudents = function (group, subject) {
      $rootScope.show_loader = true;
      NoteReleaseService.getStudentsBySubjectGroup({group_id: group.id, subject_id: subject.id})
        .then(function (response) {
          $rootScope.show_loader = false;
          response = response.plain();
          vm.grid.grades = response.grades;
          vm.grid.students = response.students;
          vm.grid.steps = response.steps;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Adiciona os ids dos alunos a lista
     * @param id
     */
    vm.addListStudent = function (id) {
      if (vm.listStudents.indexOf(id) === -1) {
        vm.listStudents.push(id)
      }
    };

    /**
     * Realiza a seleção da lista de alunos
     * @param item
     * @param list
     */
    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    };

    /**
     * Seleciona ou remove todos os itens da lista
     */
    vm.toggleAll = function () {
      if (vm.listStudentsSelected.length === vm.listStudents.length) {
        vm.listStudentsSelected = [];
      } else if (vm.listStudentsSelected.length === 0 || vm.listStudentsSelected.length > 0) {
        vm.listStudentsSelected = vm.listStudents.slice(0);
      }
    };

    /**
     * Verifica se o item existe na lista
     * @param item
     * @param list
     * @returns {boolean}
     */
    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    /**
     * Verifica se está selecionado o selecionar todos
     * @returns {boolean}
     */
    vm.isIndeterminate = function () {
      return (vm.listStudentsSelected.length !== 0 &&
        vm.listStudentsSelected.length !== vm.listStudents.length);
    };

    /**
     * Verifica se todos os itens estão selecionados
     * @returns {boolean}
     */
    vm.isChecked = function () {
      return vm.listStudentsSelected.length === vm.listStudents.length;
    };

    /**
     * Disponibiliza o botão de submit
     * para as alterações das notas dos
     * estudantes
     */
    vm.showSubmitForStudents = function () {
      if (vm.floatButton !== null) {
        vm.buttons.group = false;
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.submitNoteReleaseForStudents()',
        icon: 'save',
        label: 'Salvar'
      });
      vm.buttons.submit = true;
    };

    /**
     * Disponibiliza o botão de abertura
     * do modal para lançamento de nota
     * em grupo
     */
    vm.openMultimpleNotesForStudents = function () {
      if (vm.floatButton !== null) {
        vm.buttons.submit = false;
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.openGroupRelease()',
        icon: 'mode_edit',
        position: 'left',
        label: 'Salvar'
      });
      vm.buttons.group = true;
    };

    /**
     * Submete os dados dos alunos
     */
    vm.submitNoteReleaseForStudents = function () {
      $rootScope.show_loader = true;
      NoteReleaseService.saveNotes({
        notes: vm.grid.students,
        type: 'subject',
        subject_id: vm.subject_selected.id,
        group_id: vm.group_selected.id
      })
        .then(function () {
          vm.selectStudents(vm.subject_selected.id, vm.group_selected.id);
          $rootScope.show_loader = false;
          Common.Toast.success('Notas atualizadas com sucesso!');
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao atualizar!');
        });
    };

    /**
     * Abre modal para lançamento de Nota em grupo
     */
    vm.openGroupRelease = function () {
      ModalFactory.customClean(
        'app/educational/note-release/views/notes-for-group.html',
        'NoteReleaseGroupController',
        'vm', true, {
          'event': vm.event_selected,
          'grades': vm.grid.grades,
          'students': vm.listStudentsSelected,
          'all_students': vm.grid.students
        });
    };

    vm.init();
  }

  angular
    .module('app.educational.note-release.subjects')
    .controller('NoteReleaseSubjectsController', NoteReleaseSubjectsController)
})();
(function () {
  'use strict';

  angular
    .module('app.educational.note-release.students', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseStudentsController($rootScope, $scope, $timeout, $a4FloatButton, Common, StudentsService,
                                         NoteReleaseService, ModalFactory, PoliciesService, Session, a4Moment) {
    var vm = this;

    /** DEFINIÇÃO DE VARIAVEIS */
    vm.grid = {rows: [], info: {}};
    vm.floatButton = null;
    vm.subjects = [];
    vm.event_selected = [];
    vm.selectAllEvent = false;
    vm.listStudents = [];
    vm.listStudentsSelected = null;
    vm.buttons = {
      submit: true,
      group: false,
      allowGroup: false
    };
    vm.isNumber = angular.isNumber;
    vm.logChanges = [];

    /**
     * Metódo de iniciação do controlador
     */
    vm.init = function () {
      vm.getStudents();
      vm.current_profile = PoliciesService.currentProfile();

      //simula a ação de click para que o md-select de alunos esteja aberto quando a pagina for carregada
      vm.openMdSelect('#selectStudent', '#studentInput')
    };

    //função para simular a ação de click para os demais md-selects abrirem automaticamente quando se tornarem visíveis.
    vm.openMdSelect = function (selectId, inputId) {
      $timeout(function () {
        const selectElement = document.querySelector(selectId);
        if (selectElement) {
          angular.element(selectElement).triggerHandler('focus');
          angular.element(selectElement).triggerHandler('click');

          //Aguardar a abertura do md-select e foca no input
          const waitForInput = function () {
            const inputElement = document.querySelector(inputId);
            if (inputElement) {
              inputElement.focus();
              if (document.activeElement !== inputElement) {
                $timeout(waitForInput, 100); // Tenta novamente se o foco não foi aplicado
              }
            }
          };
          $timeout(waitForInput, 200);
        }
      }, 0);
    }
  
    // Observa quando o md-select de evento vai estar visível
    $scope.$watch('vm.student_selected', function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        vm.openMdSelect('#selectEvent', '#eventInput');
      }
    });

    var ltn = $rootScope.$on('students.list.update', function () {
      vm.paginate();
    });

    /**
     * Esculta a alteração da lista
     * de estudantes selecionados
     */
    $scope.$watch('vm.listStudentsSelected', function () {
      if (vm.listStudentsSelected != null && vm.listStudentsSelected.length) {
        if (vm.buttons.submit && vm.buttons.allowGroup) {
          vm.openMultimpleNotesForStudents();
        }
      } else {
        vm.showSubmitForStudents();
      }
    }, true);

    /**
     * Esculta a alteração da lista
     * de eventos selecionados
     */
    $scope.$watch('vm.event_selected', function () {
      if (angular.isArray(vm.event_selected)) {
        vm.buttons.allowGroup = (vm.event_selected.length === 1);
      }
      if (!vm.buttons.allowGroup) {
        vm.listStudentsSelected = [];
        vm.showSubmitForStudents();
      }
    }, true);

    /**
     * Realiza o limpeza dos objetos
     */
    vm.clear = function () {
      vm.subject_selected = null;
      vm.student_selected = null;
      vm.group_selected = null;
      vm.event_selected = null;
      vm.students = null;
      vm.subjects = null;
      vm.grid.grade_json = [];
      vm.grid.students = [];
    };

    /**
     * Seleciona ou não todos os eventos
     */
    vm.selectAllEvents = function () {
      if (vm.selectAllEvent) {
        vm.event_selected = [];
        vm.selectAllEvent = false;
      } else {
        vm.event_selected = [];
        angular.forEach(vm.grid.grade_json, function (event) {
          vm.event_selected.push(event.name)
        });
        vm.selectAllEvent = true;
      }
    };

    /**
     * Filtra os eventos de acordo com o selecionado pelo usuário
     */
    vm.filterEvents = function () {
      if (angular.isDefined(vm.grid.grade_json)) {
        var filtered = vm.grid.grade_json.filter(function (grade) {
          if (vm.event_selected !== null) {
            return vm.event_selected.indexOf(grade.name) !== -1;
          }
        });

        /** Reajusta as Etapas de acordo com os eventos. */
        vm.alignSteps(filtered);

        /** Verifica se um $digest já está em progresso, caso não esteja, então é lançado um $apply(); */
        if (!$scope.$$phase) {
          $scope.$apply();
        }

        return filtered;
      }
    };

    vm.addLog = function (new_grade, old_grade, subject, item) {
      var profile = '';
      switch (Session.profile) {
        case 0:
          profile = 'Colaborador';
          break;
        case 4:
          profile = 'Coordenador de curso';
          break;
        case 7:
          profile = 'Professor';
          break;
        default:
          profile = 'Colaborador';
      }
      if ((angular.isDefined(new_grade) && angular.isDefined(old_grade)) &&
        ((new_grade !== null && old_grade !== null) || (new_grade === null && old_grade !== null) || (new_grade !== null && old_grade === null)) &&
        parseFloat(parseFloat(new_grade).toFixed(2)) !== parseFloat(parseFloat(old_grade).toFixed(2))) {
        var log = {
          'new_grade': parseFloat(parseFloat(new_grade).toFixed(2)),
          'old_grade': old_grade,
          'subject': subject.subject_name,
          'event': item.name,
          'user_id': Session.user.person.id,
          'user_name': Session.user.person.name,
          'date_time': a4Moment().format('DD/MM/YYYY HH:mm'),
          'profile': profile,
          'group_name': vm.student_selected.group_name,
          'student_name': vm.student_selected.name,
          'course_alias': vm.student_selected.course_alias
        };
        vm.logChanges.unshift(log);
      }
    };


    /**
     * Reajusta as Etapas de acordo com os eventos.
     */
    vm.alignSteps = function (filteredList) {
      vm.grid.steps =
        /** Iteração na lista das ETAPAS */
        vm.grid.steps.filter(function (value) {
          var count = 0;
          /** Iteração na lista dos items escolhidos pelo usuário */
          filteredList.forEach(function (item) {
            /**
             * Executa uma verificação em cada item escolhido pelo usuário, e realiza um contador,
             * se o ID do filho for igual a o id de uma ETAPA, então o contador é incrementado.
             */
            if (value.id === item.grade_rule_item_id_parent) {
              count++;
            }

          });
          /** Caso não exista filhos de uma ETAPA, então a ETAPA deve ser escondida */
          value.show = count !== 0;
          value.siblingsqtd = count;
          return value;
        })

    };

    /**
     * Exibe a coluna da tabela disponibilizada no filtro de eventos
     * @param id
     */
    vm.showColum = function (id) {
      if (vm.event_selected !== null) {
        return vm.event_selected.indexOf(id) !== -1;
      }
    };

    /**
     * Envia o foco para o primeiro campo
     */
    vm.goToFirstField = function () {
      $timeout(function () {
        angular.element('tbody tr:first-child td:nth-child(2) input').trigger('focus');
      }, 300);
    };

    /**
     * Retorna o valor desejado das definições da grade
     * @param id
     * @param field - campo desejado
     */
    vm.getValue = function (id, field) {
      var index = vm.grid.grade_json.indexOf(vm.grid.grade_json.filter(function (i) {
          return i.name === id
        })[0]
      );
      if (field === 'conditional') {
        return false;
      } else if (index >= 0) {
        return parseFloat(parseFloat(vm.grid.grade_json[index][field]).toFixed(2));
      }
    };

    /**
     * Formata o valor não conceitual da nota para que seja decimal
     * @param value
     * @param maxValue
     * @returns {string}
     */
    vm.formatNote = function (value, maxValue) {
      var new_value = parseFloat(parseFloat(value).toFixed(2));
      var new_maxValue = parseFloat(parseFloat(maxValue).toFixed(2));
      if (!angular.isString(new_value)) {
        if (parseFloat(parseFloat(new_value).toFixed(2)) > parseFloat(parseFloat(new_maxValue).toFixed(2))) {
          Common.Toast.warning('Valor máximo permitido: ' + maxValue);
        }
      }
    };

    /**
     * Retorna todos os estudantes disponíveis
     */
    vm.getStudents = function () {
      StudentsService.getAll({inactives_too: false, is_regular_students: true})
        .then(function (response) {
          vm.students = response;
          console.log(vm.students)
        });
    };

    /**
     * Realiza o filtro pelo estudante
     * @param query - string escrita
     */
    vm.filterStudentsList = function (query) {
      StudentsService.getAll({query: query, inactives_too: true, show_inactive: true, is_regular_students: true})
        .then(function (response) {
          vm.students = response;
        })
    };

    /**
     * Retorna as disciplinas que possuem matrícula
     */
    vm.getAllEnrolmentSubjects = function () {
      NoteReleaseService.getAllEnrolmentSubjects()
        .then(function (response) {
          vm.subjects = response.data;
        });
    };

    /**
     * Realiza o filtro pela disciplina
     * @param query - string escrita
     */
    vm.filterSubjectsList = function (query) {
      NoteReleaseService.getAllEnrolmentSubjects({query: query})
        .then(function (response) {
          if (angular.isDefined(response.data)) {
            vm.subjects = response.data;
          }
        })
    };

    /**
     * Retorna as turmas que possuem matrícula
     */
    vm.getAllEnrolmentGroups = function () {
      NoteReleaseService.getAllEnrolmentGroups()
        .then(function (response) {
          vm.groups = response.data;
        });
    };

    /**
     * Realiza o filtro pela turma
     * @param query - string escrita
     */
    vm.filterGroupsList = function (query) {
      NoteReleaseService.getAllEnrolmentGroups({query: query})
        .then(function (response) {
          if (angular.isDefined(response.data)) {
            vm.groups = response.data;
          }
        })
    };

    /**
     * Retorna as disciplinas da turma que o aluno está matriculado
     * @param person - aluno
     */
    vm.getStudentsSubjects = function (person) {
      $rootScope.show_loader = true;
      NoteReleaseService.getStudentsSubjects({
        person_id: person.id, getCalculated: true,
        course_id: person.course_id,
        group_id: person.group_id
      })
        .then(function (response) {
          $rootScope.show_loader = false;
          response = response.plain();
          vm.subjects = response.subjects;
          /** Verifica as disciplinas filhas e move o seu posicionamento */
          angular.forEach(vm.subjects, function (subject) {
            if (subject.subject_parent.length > 0) {
              var i = 0;
              angular.forEach(subject.subject_parent, function (subject_child) {
                var index = vm.subjects.indexOf(subject);
                var subject_c = vm.getObject(subject_child.id);
                /** Remove o objeto original da posição */
                vm.removeObject(subject_child.id);
                /** Clona o objeto que deverá ser filho e aloca atrás do pai */
                vm.subjects.splice(index, 0, subject_c);
                i++;
              });
            }
          });
          vm.logChanges = [];
          vm.grid.grade_json = response.grade_json;
          vm.grid.steps = response.steps;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna o objeto desejado e define como filho
     * @param id
     */
    vm.getObject = function (id) {
      var index = vm.subjects.indexOf(vm.subjects.filter(function (i) {
          return i.subject_id === id
        })[0]
      );

      if (index >= 0) {
        vm.subjects[index].is_child = true;
        return vm.subjects[index];
      }
    };

    /**
     * Remove o objeto original do array
     * @param id
     */
    vm.removeObject = function (id) {
      /** Pega a posição */
      var del = vm.subjects.indexOf(vm.subjects.filter(function (i) {
          return i.subject_id === id
        })[0]
      );
      /** Remove o objeto */
      vm.subjects.splice(vm.subjects.indexOf(vm.subjects[del]), 1);
    };

    /**
     * Retorna as turmas vinculados a disciplina
     * @param subject - disciplina
     */
    vm.selectSubject = function (subject) {
      NoteReleaseService.getAllEnrolmentGroups({subject_id: subject.subject_id})
        .then(function (response) {
          response = response.plain();
          vm.groups = response.data;
        });
    };

    /**
     * Adiciona os ids dos alunos a lista
     * @param id
     */
    vm.addListStudent = function (id) {
      if (vm.listStudents.indexOf(id) === -1) {
        vm.listStudents.push(id)
      }
    };

    /**
     * Realiza a seleção da lista de alunos
     * @param item
     * @param list
     */
    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    };

    /**
     * Seleciona ou remove todos os itens da lista
     */
    vm.toggleAll = function () {
      if (vm.listStudentsSelected.length === vm.listStudents.length) {
        vm.listStudentsSelected = [];
      } else if (vm.listStudentsSelected.length === 0 || vm.listStudentsSelected.length > 0) {
        vm.listStudentsSelected = vm.listStudents.slice(0);
      }
    };

    /**
     * Verifica se o item existe na lista
     * @param item
     * @param list
     * @returns {boolean}
     */
    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    /**
     * Verifica se está selecionado o selecionar todos
     * @returns {boolean}
     */
    vm.isIndeterminate = function () {
      return (vm.listStudentsSelected.length !== 0 &&
        vm.listStudentsSelected.length !== vm.listStudents.length);
    };

    /**
     * Verifica se todos os itens estão selecionados
     * @returns {boolean}
     */
    vm.isChecked = function () {
      return vm.listStudentsSelected.length === vm.listStudents.length;
    };

    /**
     * Disponibiliza o botão de submit
     * para as alterações das notas dos
     * estudantes
     */
    vm.showSubmitForStudents = function () {
      if (vm.floatButton !== null) {
        vm.buttons.group = false;
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.submitNoteReleaseForStudent()',
        icon: 'save',
        label: 'Salvar'
      });
      vm.buttons.submit = true;
    };

    /**
     * Traz os textos de bloqueio.
     * @param code - Codigo do bloqueio.
     * @returns {*}
     */
    vm.getBlocks = function (code) {
      return NoteReleaseService.getReasons(code);
    };

    /**
     * Disponibiliza o botão de abertura
     * do modal para lançamento de nota
     * em grupo
     */
    vm.openMultimpleNotesForStudents = function () {
      if (vm.floatButton !== null) {
        vm.buttons.submit = false;
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.openGroupRelease()',
        icon: 'mode_edit',
        position: 'left',
        label: 'Salvar'
      });
      vm.buttons.group = true;
    };

    /**
     * Submete os dados dos alunos
     */
    vm.submitNoteReleaseForStudent = function () {
      $rootScope.show_loader = true;
      NoteReleaseService.saveNotes({notes: vm.subjects, type: 'student', log: vm.logChanges})
        .then(function () {
          vm.getStudentsSubjects(vm.student_selected);
          $rootScope.show_loader = false;
          Common.Toast.success('Notas atualizadas com sucesso!');
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao atualizar!');
        });
    };

    /**
     * Abre modal para lançamento de Nota em grupo
     */
    vm.openGroupRelease = function () {
      ModalFactory.customClean(
        'app/educational/note-release/views/notes-for-group.html',
        'NoteReleaseGroupController',
        'vm', true, {
          'event': vm.event_selected,
          'grades': vm.grid.grade_json,
          'students': vm.listStudentsSelected,
          'all_students': vm.grid.students
        })
        .then(function () {
        });
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.note-release.students')
    .controller('NoteReleaseStudentsController', NoteReleaseStudentsController)
})();
(function () {
  'use strict';

  angular
    .module('app.educational.note-release.groups', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseGroupsController($rootScope, $scope, $timeout, $a4FloatButton, Common, StudentsService,
                                       NoteReleaseService, ModalFactory, PoliciesService, Session, a4Moment,
                                       ReportsService, $document, CONFIG) {
    var vm = this;

    /** DEFINIÇÃO DE VARIAVEIS */
    vm.grid = {rows: [], info: {}};
    vm.floatButton = null;
    vm.subjects = [];
    vm.groups = [];
    vm.event_selected = false;
    vm.selectAllEvent = false;
    vm.listStudents = [];
    vm.listStudentsSelected = null;
    vm.buttons = {
      submit: true,
      group: false,
      allowGroup: false
    };
    vm.logChanges = [];
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    /**
     * Metódo de iniciação do controlador
     */
    vm.init = function () {
      vm.getGroups();
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.current_profile = PoliciesService.currentProfile();

/*      $timeout(function () {
        const selectElement = document.querySelector('#selectGroup');
        if (selectElement) {
        angular.element(selectElement).triggerHandler('focus');
        angular.element(selectElement).triggerHandler('click');
        }
        }, 0);*/

        vm.openMdSelect('#selectGroup', '#groupInput')
    };

    //função para simular a ação de click para os demais md-selects abrirem automaticamente quando se tornarem visíveis.
    vm.openMdSelect = function (selectId, inputId) {
      $timeout(function () {
        const selectElement = document.querySelector(selectId);
        if (selectElement) {
          angular.element(selectElement).triggerHandler('focus');
          angular.element(selectElement).triggerHandler('click');
    
          // Aguardar a abertura do md-select e foca no input, tudo em um único timeout
          $timeout(function () {
            const inputElement = document.querySelector(inputId);
            if (inputElement) {
              inputElement.focus();
            }
          }, 300);
        }
      }, 100);
    };

    // Observa quando o md-select de disciplina vai estar visível
    $scope.$watch('vm.group_selected', function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        vm.openMdSelect('#selectSubject', '#subjectInput');
      }
    });

    // Observa quando o md-select de evento vai estar visível
    $scope.$watch('vm.subject_selected', function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        vm.openMdSelect('#selectEvent', '#eventInput');
      }
    });

    var ltn = $rootScope.$on('students.list.update', function () {
      vm.paginate();
    });

    vm.printNotes = function () {
      vm.printNotes = function () {
        ReportsService.reportFactory('GET',
          'api/reports/printclassnotes',
          {
            company: vm.conf.current_company,
            connection: vm.conf.current_connection,
            user_id: vm.conf.user_id,
            group_id: vm.group_selected.id,
            subject_id: vm.subject_selected.id,
            matrix_period: vm.group_selected.matrix_period,
            events: vm.event_selected.toString(),
            getCalculated: true,
            is_detailed: true,
            current_school_period: (angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod())
          });
/*        var href = vm.webLink + 'api/reports/printclassnotes?token=' + vm.conf.token + '&company=' + vm.conf.current_company
          + '&connection=' + vm.conf.current_connection + '&user_id=' + vm.conf.user_id + '&group_id=' + vm.group_selected.id +
          '&subject_id=' + vm.subject_selected.id + '&matrix_period=' + vm.group_selected.matrix_period + '&events=' + vm.event_selected.toString() +
          '&getCalculated=' + true + '&is_detailed=' + true + '&current_school_period=' + (angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod());
        var element = document.createElement('a');
        element.setAttribute('href', href);
        element.setAttribute('target', '_blank');
        return element.click();*/
      };

    };

    var ltn2 = $rootScope.$on('note-release.group.log', function (ev, item) {
      vm.addLog(item.new_grade, item.old_grade, item.student, {name: item.item[0]});
    });

    /**
     * Esculta a alteração da lista
     * de estudantes selecionados
     */
    $scope.$watch('vm.listStudentsSelected', function () {
      if (vm.listStudentsSelected !== null && vm.listStudentsSelected.length > 1) {
        if (vm.buttons.submit && vm.buttons.allowGroup) {
          vm.openMultimpleNotesForStudents();
        }
      } else {
        if (vm.buttons.group) {
          vm.showSubmitForStudents();
        }
      }
    }, true);

    /**
     * Esculta a alteração da lista
     * de eventos selecionados
     */
    $scope.$watch('vm.event_selected', function () {
      if (angular.isArray(vm.event_selected)) {
        vm.buttons.allowGroup = (vm.event_selected.length === 1);
      }
      if (!vm.buttons.allowGroup) {
        vm.listStudentsSelected = [];
        vm.showSubmitForStudents();
      }
    }, true);

    /**
     * Realiza o limpeza dos objetos
     */
    vm.clear = function () {
      vm.subject_selected = null;
      vm.student_selected = null;
      vm.group_selected = null;
      vm.event_selected = null;
      vm.students = null;
      vm.subjects = null;
      vm.grid.grades = [];
      vm.grid.students = [];
    };

    /**
     * Seleciona ou não todos os eventos
     */
    vm.selectAllEvents = function () {
      if (vm.selectAllEvent) {
        vm.event_selected = [];
        vm.selectAllEvent = false;
      } else {
        vm.event_selected = [];
        angular.forEach(vm.grid.grades, function (event) {
          if(event.badge !== 'grouped' && event.type !== 'A') {
            vm.event_selected.push(event.name)
          }
        });
        vm.selectAllEvent = true;
      }
    };

    /**
     * Filtra os eventos de acordo com o selecionado pelo usuário
     */
    vm.filterEvents = function () {
      if (angular.isDefined(vm.grid.grades)) {
        var filtered = vm.grid.grades.filter(function (grade) {
          if (vm.event_selected !== null) {
            return vm.event_selected.indexOf(grade.name) !== -1;
          }
        });
        if (filtered.length) {
          vm.alignSteps(filtered);
        }
        return filtered;
      }
    };


    /**
     * Reajusta as Etapas de acordo com os eventos.
     */
    vm.alignSteps = function (filteredList) {
      vm.grid.steps =
        /** Iteração na lista das ETAPAS */
        vm.grid.steps.filter(function (value) {
          var count = 0;
          /** Iteração na lista dos items escolhidos pelo usuário */
          filteredList.forEach(function (item) {
            /**
             * Executa uma verificação em cada item escolhido pelo usuário, e realiza um contador,
             * se o ID do filho for igual a o id de uma ETAPA, então o contador é incrementado.
             */
            if (value.id === item.grade_rule_item_id_parent) {
              count++;
            }

          });
          /** Caso não exista filhos de uma ETAPA, então a ETAPA deve ser escondida */
          value.show = count !== 0;
          value.siblingsqtd = count;
          return value;
        })

    };

    /**
     * Traz os textos de bloqueio.
     * @param code - Codigo do bloqueio.
     * @returns {*}
     */
    vm.getBlocks = function (code) {
      return NoteReleaseService.getReasons(code);
    };


    /**
     * Exibe a coluna da tabela disponibilizada no filtro de eventos
     * @param id
     */
    vm.showColum = function (id) {
      if (vm.event_selected !== null) {
        return vm.event_selected.indexOf(id) !== -1;
      }
    };

    /**
     * Retorna o valor desejado das definições da grade
     * @param id
     * @param field - campo desejado
     */
    vm.getValue = function (id, field) {
      var index = vm.grid.grades.indexOf(vm.grid.grades.filter(function (i) {
          return i.name === id
        })[0]
      );

      if (field === 'conditional') {
        return false;
      } else if (index >= 0) {
        return vm.grid.grades[index][field];
      }
    };

    /**
     * Envia o foco para o primeiro campo
     */
    vm.goToFirstField = function () {
      $timeout(function () {
        angular.element('tbody tr:first-child td:nth-child(3) input').trigger('focus');
      }, 300);
    };

    /**
     * Formata o valor não conceitual da nota para que seja decimal
     * @param value
     * @param maxValue
     * @returns {string}
     */
    vm.formatNote = function (value, maxValue) {
      var new_value = parseFloat(parseFloat(value).toFixed(2));
      var new_maxValue = parseFloat(parseFloat(maxValue).toFixed(2));
      if (!angular.isString(new_value)) {
        if (parseFloat(parseFloat(new_value).toFixed(2)) > parseFloat(parseFloat(new_maxValue).toFixed(2))) {
          Common.Toast.warning('Valor máximo permitido: ' + maxValue);
        }
      }
    };

    vm.addLog = function (new_grade, old_grade, student, item) {
      var profile = '';
      switch (Session.profile) {
        case 0:
          profile = 'Colaborador';
          break;
        case 4:
          profile = 'Coordenador de curso';
          break;
        case 7:
          profile = 'Professor';
          break;
        default:
          profile = 'Colaborador';
      }
      if ((angular.isDefined(new_grade) && angular.isDefined(old_grade)) &&
        ((new_grade !== null && old_grade !== null) || (new_grade === null && old_grade !== null) || (new_grade !== null && old_grade === null)) &&
        parseFloat(parseFloat(new_grade).toFixed(2)) !== parseFloat(parseFloat(old_grade).toFixed(2))) {
        var log = {
          'new_grade': parseFloat(parseFloat(new_grade).toFixed(2)),
          'old_grade': old_grade,
          'subject': vm.subject_selected.name,
          'event': item.name,
          'user_id': Session.user.person.id,
          'user_name': Session.user.person.name,
          'date_time': a4Moment().format('DD/MM/YYYY HH:mm'),
          'profile': profile,
          'group_name': vm.group_selected.name,
          'student_name': student.name,
          'course_alias': vm.group_selected.course_alias
        };
        vm.logChanges.unshift(log);
      }
    };

    /**
     * Retorna todos as turmas que possuem matrícula
     */
    vm.getGroups = function () {
      NoteReleaseService.getAllEnrolmentGroups()
        .then(function (response) {
          vm.groups = response;
        });
    };

    /**
     * Realiza o filtro pela turma
     * @param query - string escrita
     */
    vm.filterGroupsList = function (query) {
      StudentsService.getAllEnrolmentGroups({query: query})
        .then(function (response) {
          vm.groups = response;
        })
    };

    /**
     * Retorna as disciplinas que possuem matrícula
     */
    vm.getAllEnrolmentSubjectsByGroup = function (group) {
      NoteReleaseService.getAllEnrolmentSubjects({group_id: group.id})
        .then(function (response) {
          vm.subjects = response.data;
        });
    };

    /**
     * Realiza o filtro pela disciplina
     * @param query - string escrita
     */
    vm.filterSubjectsList = function (query) {
      NoteReleaseService.getAllEnrolmentSubjects({query: query, group_id: vm.group_selected.id})
        .then(function (response) {
          if (angular.isDefined(response.data)) {
            vm.subjects = response.data;
          }
        })
    };

    /**
     * Retorna as turmas que possuem matrícula
     */
    vm.getAllEnrolmentGroups = function () {
      NoteReleaseService.getAllEnrolmentGroups()
        .then(function (response) {
          vm.groups = response.data;
        });
    };

    /**
     * Realiza o filtro pela turma
     * @param query - string escrita
     */
    vm.filterGroupsList = function (query) {
      NoteReleaseService.getAllEnrolmentGroups({query: query})
        .then(function (response) {
          if (angular.isDefined(response.data)) {
            vm.groups = response.data;
          }
        })
    };

    /**
     * Retorna os estudantes pela turma e disciplina
     * @returns array
     */
    vm.getStudentsBySubjectGroup = function (subject, group) {
      $rootScope.show_loader = true;
      NoteReleaseService.getStudentsBySubjectGroup({subject_id: subject.id, group_id: group.id, getCalculated: true})
        .then(function (response) {
          $rootScope.show_loader = false;
          response = response.plain();
          vm.grid.students = response.students;
          vm.grid.grades = response.grades;
          vm.grid.steps = response.steps;
          vm.grid.is_canceled = response.is_canceled;
          vm.logChanges = [];
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Adiciona os ids dos alunos a lista
     * @param id
     */
    vm.addListStudent = function (id) {
      if (vm.listStudents.indexOf(id) === -1) {
        vm.listStudents.push(id)
      }
    };

    /**
     * Realiza a seleção da lista de alunos
     * @param item
     * @param list
     */
    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    };

    /**
     * Seleciona ou remove todos os itens da lista
     */
    vm.toggleAll = function () {
      if (vm.listStudentsSelected.length === vm.listStudents.length) {
        vm.listStudentsSelected = [];
      } else if (vm.listStudentsSelected.length === 0 || vm.listStudentsSelected.length > 0) {
        vm.listStudentsSelected = vm.listStudents.slice(0);
      }
    };

    /**
     * Verifica se o item existe na lista
     * @param item
     * @param list
     * @returns {boolean}
     */
    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    /**
     * Verifica se está selecionado o selecionar todos
     * @returns {boolean}
     */
    vm.isIndeterminate = function () {
      return (vm.listStudentsSelected.length !== 0 &&
        vm.listStudentsSelected.length !== vm.listStudents.length);
    };

    /**
     * Verifica se todos os itens estão selecionados
     * @returns {boolean}
     */
    vm.isChecked = function () {
      return vm.listStudentsSelected.length === vm.listStudents.length;
    };

    /**
     * Disponibiliza o botão de submit
     * para as alterações das notas dos
     * estudantes
     */
    vm.showSubmitForStudents = function () {
      if (vm.floatButton !== null) {
        vm.buttons.group = false;
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.submitNoteReleaseForStudent()',
        icon: 'save',
        label: 'Salvar'
      });
      vm.buttons.submit = true;
    };

    /**
     * Disponibiliza o botão de abertura
     * do modal para lançamento de nota
     * em grupo
     */
    vm.openMultimpleNotesForStudents = function () {
      if (vm.floatButton !== null) {
        vm.buttons.submit = false;
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.openGroupRelease()',
        icon: 'mode_edit',
        position: 'left',
        label: 'Salvar'
      });
      vm.buttons.group = true;
    };

    /**
     * Submete os dados dos alunos
     */
    vm.submitNoteReleaseForStudent = function () {
      $rootScope.show_loader = true;
      NoteReleaseService.saveNotes({
        notes: vm.grid.students,
        type: 'subject',
        subject_id: vm.subject_selected.id,
        group_id: vm.group_selected.id,
        log: vm.logChanges
      })
        .then(function () {
          vm.getStudentsBySubjectGroup(vm.subject_selected, vm.group_selected);
          $rootScope.show_loader = false;
          Common.Toast.success('Notas atualizadas com sucesso!');
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao atualizar!');
        });
    };

    /**
     * Abre modal para lançamento de Nota em grupo
     */
    vm.openGroupRelease = function () {
      ModalFactory.customClean(
        'app/educational/note-release/views/notes-for-group.html',
        'NoteReleaseGroupController',
        'vm', true, {
          'event': vm.event_selected,
          'grades': vm.grid.grades,
          'students': vm.listStudentsSelected,
          'all_students': vm.grid.students,
          'is_grouping_release': false
        })
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn2].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.note-release.groups')
    .controller('NoteReleaseGroupsController', NoteReleaseGroupsController)
})();

(function () {
  'use strict';

  angular
    .module('app.educational.note-release.grouping', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseGroupingController($rootScope, $scope, $timeout, $a4FloatButton, Common, ClassGroupingService,
                                         StudentsService, NoteReleaseService, ModalFactory, PoliciesService,
                                         Session, a4Moment) {
    var vm = this;

    /** DEFINIÇÃO DE VARIAVEIS */
    vm.grid = {rows: [], info: {}};
    vm.floatButton = null;
    vm.subjects = [];
    vm.groupings = [];
    vm.groups = [];
    vm.listStudentsSelected = null;
    vm.logChanges = [];
    vm.events = [];
    vm.event_selected = false;
    vm.grouping_selected = false;
    vm.selectAllEvent = false;
    vm.listStudents = [];
    vm.listStudentsSelected = null;
    vm.buttons = {
      submit: true,
      group: false,
      allowGroup: false
    };


    /**
     * Esculta a alteração da lista
     * de estudantes selecionados
     */
    $scope.$watch('vm.listStudentsSelected', function () {
      if (vm.listStudentsSelected !== null && vm.listStudentsSelected.length > 1) {
        if (vm.buttons.submit && vm.buttons.allowGroup) {
          vm.openMultimpleNotesForStudents();
        }
      } else {
        if (vm.buttons.group) {
          vm.showSubmitForStudents();
        }
      }
    }, true);

    var ltn2 = $rootScope.$on('note-release.group.log', function (ev, item) {
      vm.addLog(item.new_grade, item.old_grade, item.student, {name: item.item[0]});
    });

    vm.addLog = function (new_grade, old_grade, student, item) {
      var profile = '';
      switch (Session.profile) {
        case 0:
          profile = 'Colaborador';
          break;
        case 4:
          profile = 'Coordenador de curso';
          break;
        case 7:
          profile = 'Professor';
          break;
        default:
          profile = 'Colaborador';
      }
      if ((angular.isDefined(new_grade) && angular.isDefined(old_grade)) &&
        ((new_grade !== null && old_grade !== null) || (new_grade === null && old_grade !== null) || (new_grade !== null && old_grade === null)) &&
        parseFloat(parseFloat(new_grade).toFixed(2)) !== parseFloat(parseFloat(old_grade).toFixed(2))) {
        var log = {
          'new_grade': parseFloat(parseFloat(new_grade).toFixed(2)),
          'old_grade': old_grade,
          'subject': vm.subject_selected.name,
          'event': item.name,
          'user_id': Session.user.person.id,
          'user_name': Session.user.person.name,
          'date_time': a4Moment().format('DD/MM/YYYY HH:mm'),
          'profile': profile,
          'group_name': vm.group_selected.name,
          'student_name': student.name,
          'course_alias': vm.group_selected.course_alias
        };
        vm.logChanges.unshift(log);
      }
    };


    /**
     * Disponibiliza o botão de abertura
     * do modal para lançamento de nota
     * em grupo
     */
    vm.openMultimpleNotesForStudents = function () {
      if (vm.floatButton !== null) {
        vm.buttons.submit = false;
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.openGroupRelease()',
        icon: 'mode_edit',
        position: 'left',
        label: 'Salvar'
      });
      vm.buttons.group = true;
    };

    /**
     * Metódo de iniciação do controlador
     */
    vm.init = function () {
      vm.getGroups();
      vm.current_profile = PoliciesService.currentProfile();

      vm.openMdSelect('#selectGroup', '#groupInput')
    };

    //função para simular a ação de click para os demais md-selects abrirem automaticamente quando se tornarem visíveis.
    vm.openMdSelect = function (selectId, inputId) {
      $timeout(function () {
        const selectElement = document.querySelector(selectId);
        if (selectElement) {
          angular.element(selectElement).triggerHandler('focus');
          angular.element(selectElement).triggerHandler('click');
    
          // Aguardar a abertura do md-select e foca no input, tudo em um único timeout
          $timeout(function () {
            const inputElement = document.querySelector(inputId);
            if (inputElement) {
              inputElement.focus();
            }
          }, 300);
        }
      }, 100);
    };
  
    // Observa quando o md-select de agrupamento vai estar visível
    $scope.$watch('vm.group_selected', function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        vm.openMdSelect('#selectGrouping', '#groupingInput');
      }
    });
  
    // Observa quando o md-select de evento vai estar visível
    $scope.$watch('vm.grouping_selected', function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        vm.openMdSelect('#selectEvent', '#eventInput');
      }
    });

    /**
     * Retorna todos os agrupamentos da turma
     */
    vm.getAllGroupingByGroup = function (group) {
      ClassGroupingService.getAll({group_id: group.id, matrix_period: group.matrix_period, grouping_type: 2})
        .then(function (response) {
          vm.groupings = response.plain();
        })
    };

    var ltn = $rootScope.$on('students.list.update', function () {
      vm.paginate();
    });

    /**
     * Esculta a alteração da lista
     * de eventos selecionados
     */
    $scope.$watch('vm.event_selected', function () {
      if (angular.isArray(vm.event_selected) && vm.event_selected.length) {
        vm.showSubmitForStudents();
        vm.buttons.allowGroup = (vm.event_selected.length === 1);
      } else {
        if (vm.floatButton !== null) {
          vm.floatButton.destroy();
        }
      }
      if (!vm.buttons.allowGroup) {
        vm.listStudentsSelected = [];
        vm.showSubmitForStudents();
      }
    }, true);

    /**
     * Realiza o limpeza dos objetos
     */
    vm.clear = function () {
      vm.student_selected = null;
      vm.group_selected = null;
      vm.grouping_selected = null;
      vm.event_selected = null;
      vm.students = null;
      vm.subjects = null;
      vm.groupings = null;
      vm.grid.grades = [];
      vm.grid.students = [];
    };

    /**
     * Seleciona ou não todos os eventos
     */
    vm.selectAllEvents = function () {
      if (vm.selectAllEvent) {
        vm.event_selected = [];
        vm.selectAllEvent = false;
      } else {
        vm.event_selected = [];
        angular.forEach(vm.grid.grades, function (event) {
          vm.event_selected.push(event.name)
        });
        vm.selectAllEvent = true;
      }
    };

    /**
     * Disponibiliza o botão de submit
     * para as alterações das notas dos
     * estudantes
     */
    vm.showSubmitForStudents = function () {
      if (vm.floatButton !== null) {
        vm.buttons.group = false;
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.submitNoteReleaseForStudent()',
        icon: 'save',
        label: 'Salvar'
      });
      vm.buttons.submit = true;
    };

    /**
     * Filtra os eventos de acordo com o selecionado pelo usuário
     */
    vm.filterEvents = function () {
      if (angular.isDefined(vm.grid.grades)) {
        var filtered = vm.grid.grades.filter(function (grade) {
          if (vm.event_selected !== null) {
            return vm.event_selected.indexOf(grade.name) !== -1;
          }
        });
        if (filtered.length) {
          vm.alignSteps(filtered);
        }
        return filtered;
      }
    };

    /**
     * Reajusta as Etapas de acordo com os eventos.
     */
    vm.alignSteps = function (filteredList) {
      vm.grid.steps =
        /** Iteração na lista das ETAPAS */
        vm.grid.steps.filter(function (value) {
          var count = 0;
          /** Iteração na lista dos items escolhidos pelo usuário */
          filteredList.forEach(function (item) {
            /**
             * Executa uma verificação em cada item escolhido pelo usuário, e realiza um contador,
             * se o ID do filho for igual a o id de uma ETAPA, então o contador é incrementado.
             */
            if (value.id == item.grade_rule_item_id_parent) {
              count++;
            }

          });
          /** Caso não exista filhos de uma ETAPA, então a ETAPA deve ser escondida */
          value.show = count != 0;
          value.siblingsqtd = count;
          return value;
        })

    };


    /**
     * Exibe a coluna da tabela disponibilizada no filtro de eventos
     * @param id
     */
    vm.showColum = function (id) {
      if (vm.event_selected !== null) {
        return vm.event_selected.indexOf(id) !== -1;
      }
    };

    /**
     * Retorna o valor desejado das definições da grade
     * @param id
     * @param field - campo desejado
     */
    vm.getValue = function (id, field) {
      var index = vm.grid.grades.indexOf(vm.grid.grades.filter(function (i) {
          return i.name === id
        })[0]
      );

      if (index >= 0) {
        return vm.grid.grades[index][field];
      }
    };

    /**
     * Traz os textos de bloqueio.
     * @param code - Codigo do bloqueio.
     * @returns {*}
     */
    vm.getBlocks = function (code) {
      return NoteReleaseService.getReasons(code);
    };

    /**
     * Formata o valor não conceitual da nota para que seja decimal
     * @param value
     * @param maxValue
     * @returns {string}
     */
    vm.formatNote = function (value, maxValue) {
      var new_value = parseFloat(parseFloat(value).toFixed(2));
      var new_maxValue = parseFloat(parseFloat(maxValue).toFixed(2));
      if (!angular.isString(new_value)) {
        if (parseFloat(parseFloat(new_value).toFixed(2)) > parseFloat(parseFloat(new_maxValue).toFixed(2))) {
          Common.Toast.warning('Valor máximo permitido: ' + maxValue);
        }
      }
    };

    /**
     * Verifica se o item existe na lista
     * @param item
     * @param list
     * @returns {boolean}
     */
    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    /**
     * Realiza a seleção da lista de alunos
     * @param item
     * @param list
     */
    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    };


    /**
     * Retorna todos as turmas que possuem matrícula
     */
    vm.getGroups = function () {
      NoteReleaseService.getAllEnrolmentGroups({onlyGrouping: true})
        .then(function (response) {
          vm.groups = response;
        });
    };

    /**
     * Envia o foco para o primeiro campo
     */
    vm.goToFirstField = function () {
      $timeout(function () {
        angular.element('tbody tr:first-child td:nth-child(2) input').trigger('focus');
      }, 300);
    };

    /**
     * Realiza o filtro pela turma
     * @param query - string escrita
     */
    vm.filterGroupsList = function (query) {
      StudentsService.getAllEnrolmentGroups({query: query, onlyGrouping: true})
        .then(function (response) {
          vm.groups = response;
        })
    };

    /**
     * Retorna as disciplinas que possuem matrícula
     */
    vm.getAllEnrolmentSubjectsByGroup = function (group) {
      NoteReleaseService.getAllEnrolmentSubjects({group_id: group.id})
        .then(function (response) {
          vm.subjects = response.data;
        });
    };

    /**
     * Retorna os estudantes pela turma e disciplina
     * @returns array
     */
    vm.getEventsByGrouping = function (group, grouping) {
      ClassGroupingService.getEventsByGrouping({
        group_id: group.id,
        matrix_period: group.matrix_period,
        grouping_id: grouping.id
      })
        .then(function (response) {
          vm.subjects = response.subjects;
          vm.grid.students = response.students;
          vm.grid.grades = response.items;
          vm.grid.grades = NoteReleaseService.formatEventNameDescription(vm.grid.grades);
          vm.grid.steps = response.steps;
          $timeout(function () {
            for (var i = 0; i < vm.grid.students.length; i++) {
              var notes = angular.fromJson(vm.grid.students[i].grade_json);
              vm.grid.students[i].grade_json = notes;
            }
          }, 1000);
        });
    };


    /**
     * Retorna as turmas que possuem matrícula
     */
    vm.getAllEnrolmentGroups = function () {
      NoteReleaseService.getAllEnrolmentGroups()
        .then(function (response) {
          vm.groups = response;
        });
    };

    /**
     * Realiza o filtro pela turma
     * @param query - string escrita
     */
    vm.filterGroupsList = function (query) {
      NoteReleaseService.getAllEnrolmentGroups({query: query})
        .then(function (response) {
          if (angular.isDefined(response)) {
            vm.groups = response;
          }
        })
    };


    /**
     * Adiciona os ids dos alunos a lista
     * @param id
     */
    vm.addListStudent = function (id) {
      if (vm.listStudents.indexOf(id) === -1) {
        vm.listStudents.push(id)
      }
    };

    /**
     * Realiza a seleção da lista de alunos
     * @param item
     * @param list
     */
    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    };

    /**
     * Seleciona ou remove todos os itens da lista
     */
    vm.toggleAll = function () {
      if (vm.listStudentsSelected.length === vm.listStudents.length) {
        vm.listStudentsSelected = [];
      } else if (vm.listStudentsSelected.length === 0 || vm.listStudentsSelected.length > 0) {
        vm.listStudentsSelected = vm.listStudents.slice(0);
      }
    };

    /**
     * Verifica se todos os itens estão selecionados
     * @returns {boolean}
     */
    vm.isChecked = function () {
      return vm.listStudentsSelected.length === vm.listStudents.length;
    };

    /**
     * Seleciona ou remove todos os itens da lista
     */
    vm.toggleAll = function () {
      if (vm.listStudentsSelected.length === vm.listStudents.length) {
        vm.listStudentsSelected = [];
      } else if (vm.listStudentsSelected.length === 0 || vm.listStudentsSelected.length > 0) {
        vm.listStudentsSelected = vm.listStudents.slice(0);
      }
    };

    /**
     * Verifica se está selecionado o selecionar todos
     * @returns {boolean}
     */
    vm.isIndeterminate = function () {
      return (vm.listStudentsSelected.length !== 0 &&
        vm.listStudentsSelected.length !== vm.listStudents.length);
    };

    /**
     * Verifica se o item existe na lista
     * @param item
     * @param list
     * @returns {boolean}
     */
    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    /**
     * Verifica se está selecionado o selecionar todos
     * @returns {boolean}
     */
    vm.isIndeterminate = function () {
      return (vm.listStudentsSelected.length !== 0 &&
        vm.listStudentsSelected.length !== vm.listStudents.length);
    };

    /**
     * Verifica se todos os itens estão selecionados
     * @returns {boolean}
     */
    vm.isChecked = function () {
      return vm.listStudentsSelected.length === vm.listStudents.length;
    };


    /**
     * Submete os dados dos alunos
     */
    vm.submitNoteReleaseForStudent = function () {
      $rootScope.show_loader = true;

      NoteReleaseService.saveNotes({
        notes: vm.grid.students,
        grades: vm.grid.grades,
        type: 'grouping',
        group_id: vm.group_selected.id,
        subjects: vm.subjects,
        enrolment_period_id: vm.grid.students[0].enrolment_period_id
      })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Notas atualizadas com sucesso!');
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao atualizar!');
        });
    };

    /**
     * Abre modal para lançamento de Nota em grupo
     */
    vm.openGroupRelease = function () {
      ModalFactory.customClean(
        'app/educational/note-release/views/notes-for-group.html',
        'NoteReleaseGroupController',
        'vm', true, {
          'event': vm.event_selected,
          'grades': vm.grid.grades,
          'students': vm.listStudentsSelected,
          'all_students': vm.grid.students,
          'is_grouping_release': true
        })
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn2].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.note-release.grouping')
    .controller('NoteReleaseGroupingController', NoteReleaseGroupingController);

})();
(function () {
  'use strict';

  angular
    .module('app.educational.note-release.council', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseCouncilController($scope, $rootScope, $timeout, $a4FloatButton, Common, StudentsService,
                                        NoteReleaseService, PoliciesService, Session, a4Moment) {
    var vm = this;

    /** DEFINIÇÃO DE VARIAVEIS */
    vm.grid = {rows: [], info: {}};
    vm.floatButton = null;
    vm.subjects = [];
    vm.event_selected = [];
    vm.selectAllEvent = false;
    vm.listStudents = [];
    vm.toggled = false;
    vm.listStudentsSelected = null;
    vm.buttons = {
      submit: true,
      group: false,
      allowGroup: false
    };
    vm.logChanges = [];

    /**
     * Metódo de iniciação do controlador
     */
    vm.init = function () {
      vm.getStudents();
      vm.current_profile = PoliciesService.currentProfile();
      vm.showSubmitForStudents();

      /** abre o md-select para escolher o aluno assim que a pagina é carregada */
      $timeout(function () {
        const selectElement = document.querySelector('#selectCouncil input');
        if (selectElement) {
          angular.element(selectElement).triggerHandler('focus');
          angular.element(selectElement).triggerHandler('click');

          selectElement.focus();
        }
      }, 0);
    };

    /**
     * Realiza o limpeza dos objetos
     */
    vm.clear = function () {
      vm.subject_selected = null;
      vm.student_selected = null;
      vm.group_selected = null;
      vm.event_selected = null;
      vm.students = null;
      vm.subjects = null;
      vm.grid.grade_json = [];
      vm.grid.students = [];
    };

    /**
     * Seleciona ou não todos os eventos
     */
    vm.selectAllEvents = function () {
      if (vm.selectAllEvent) {
        vm.event_selected = [];
        vm.selectAllEvent = false;
      } else {
        vm.event_selected = [];
        angular.forEach(vm.grid.grade_json, function (event) {
          vm.event_selected.push(event.name)
        });
        vm.selectAllEvent = true;
      }
    };

    /**
     * Filtra os eventos de acordo com o selecionado pelo usuário
     */
    vm.filterEvents = function () {
      if (angular.isDefined(vm.grid.grade_json)) {
        var filtered = vm.grid.grade_json.filter(function (grade) {
          if (vm.event_selected !== null) {
            return vm.event_selected.indexOf(grade.name) !== -1;
          }
        });

        return filtered;
      }
    };

    /**
     * Traz os textos de bloqueio.
     * @param code - Codigo do bloqueio.
     * @returns {*}
     */
    vm.getBlocks = function (code) {
      return NoteReleaseService.getReasons(code);
    };

    /**
     * Exibe a coluna da tabela disponibilizada no filtro de eventos
     * @param id
     */
    vm.showColum = function (id) {
      if (vm.event_selected !== null) {
        return vm.event_selected.indexOf(id) !== -1;
      }
    };

    /**
     * Envia o foco para o primeiro campo
     */
    vm.goToFirstField = function () {
      $timeout(function () {
        angular.element('tbody tr:first-child td:nth-child(2) input').trigger('focus');
      }, 300);
    };

    /**
     * Retorna o valor desejado das definições da grade
     * @param alias - alias das notas
     * @param field - campo desejado
     */
    vm.getValue = function (alias, field) {
      var index = vm.grid.grade_json.indexOf(
        vm.grid.grade_json.filter(function (i) {
          return i.name === alias
        })[0]
      );
      if (field === 'conditional') {
        return false;
      } else if (index >= 0) {
        return vm.grid.grade_json[index][field];
      }

      if (index != -1) {
        if (angular.isNumber(vm.grid.grade_json[index][field])) {
          return parseFloat(vm.grid.grade_json[index][field]);
        }

        return vm.grid.grade_json[index][field];
      }
    };

    /**
     * Verifica se o evento permite concelho de classe;
     * @param alias - Apelido do evento
     */
    vm.hasClassCouncil = function (alias) {
      if (angular.isDefined(vm.getValue(alias, 'has_class_council')))
        return vm.getValue(alias, 'has_class_council');
    };

    /**
     * Formata o valor não conceitual da nota para que seja decimal
     * @param value
     * @param maxValue
     * @returns {string}
     */
    vm.formatNote = function (value, maxValue) {
      var new_value = parseFloat(parseFloat(value).toFixed(2));
      var new_maxValue = parseFloat(parseFloat(maxValue).toFixed(2));
      if (!angular.isString(new_value)) {
        if (parseFloat(parseFloat(new_value).toFixed(2)) > parseFloat(parseFloat(new_maxValue).toFixed(2))) {
          Common.Toast.warning('Valor máximo permitido: ' + maxValue);
        }
      }
    };


    vm.addLog = function (new_grade, old_grade, subject, item) {
      var profile = '';
      switch (Session.profile) {
        case 0:
          profile = 'Colaborador';
          break;
        case 4:
          profile = 'Coordenador de curso';
          break;
        case 7:
          profile = 'Professor';
          break;
        default:
          profile = 'Colaborador';
      }
      if ((angular.isDefined(new_grade) && angular.isDefined(old_grade)) &&
        ((new_grade !== null && old_grade !== null) || (new_grade === null && old_grade !== null) || (new_grade !== null && old_grade === null)) &&
        parseFloat(parseFloat(new_grade).toFixed(2)) !== parseFloat(parseFloat(old_grade).toFixed(2))) {
        var log = {
          'new_grade': parseFloat(parseFloat(new_grade).toFixed(2)),
          'old_grade': old_grade,
          'subject': subject.subject_name,
          'event': item.name,
          'user_id': Session.user.person.id,
          'user_name': Session.user.person.name,
          'date_time': a4Moment().format('DD/MM/YYYY HH:mm'),
          'profile': profile,
          'group_name': vm.selectedItem.group_name,
          'student_name': vm.selectedItem.name,
          'course_alias': vm.selectedItem.course_alias
        };
        vm.logChanges.unshift(log);
      }
    };


    /**
     * Retorna todos os estudantes disponíveis
     */
    vm.getStudents = function () {
      StudentsService.getAll({inactives_too: false, is_regular_students: true})
        .then(function (response) {
          vm.students = response;
        });
    };

    /**
     * Realiza o filtro pelo estudante
     * @param query - string escrita
     */
    vm.filterStudentsList = function (query) {
      return StudentsService.getAll({query: query, inactives_too: false, is_regular_students: true});
    };

    /**
     * Retorna as disciplinas da turma que o aluno está matriculado
     * @param person - aluno
     */
    vm.getStudentsSubjects = function (person) {
      if (angular.isDefined(person) && angular.isDefined(person.name)) {
        $rootScope.show_loader = true;
        vm.personNameSelected = person.name + " | " + person.course_name + " | " + person.group_name;
        NoteReleaseService.getStudentsSubjects({person_id: person.id, getCalculated: true})
          .then(function (response) {
            $rootScope.show_loader = false;
            response = response.plain();
            vm.subjects = response.subjects;
            vm.grid.grade_json = response.grade_json;
            vm.grid.steps = response.steps;
            vm.logChanges = [];
            /** Verifica se um $digest já está em progresso, caso não esteja, então é lançado um $apply(); */
            if (!$scope.$$phase) {
              $scope.$apply();
            }
            /** Recolhe o menu lateral */
            if (!vm.toggled) {
              $rootScope.$broadcast('$toggleNavigationMenu');
              vm.toggled = true;
            }
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Disponibiliza o botão de submit
     * para as alterações das notas dos
     * estudantes
     */
    vm.showSubmitForStudents = function () {
      if (vm.floatButton !== null) {
        vm.buttons.group = false;
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.submitNoteReleaseCouncil()',
        icon: 'save',
        label: 'Salvar'
      });
      vm.buttons.submit = true;
    };

    /**
     * Submete os dados dos alunos
     */
    vm.submitNoteReleaseCouncil = function () {
      $rootScope.show_loader = true;
      NoteReleaseService.saveNotes({
        notes: vm.subjects,
        person_id: vm.selectedItem.id,
        type: 'council',
        log: vm.logChanges
      }).then(function () {
        vm.getStudentsSubjects(vm.selectedItem);
        $rootScope.show_loader = false;
        Common.Toast.success('Notas atualizadas com sucesso!');
      }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao atualizar!');
      });

    };

    vm.convertGradeValue = function (value, precision) {
      return NoteReleaseService.setPrecision(value, precision);
    };


    vm.init();
  }

  angular
    .module('app.educational.note-release.council')
    .controller('NoteReleaseCouncilController', NoteReleaseCouncilController);

})();
(function() {
    'use strict';
    angular
        .module('app.educational.informative-report', [])
        .value('froalaConfig', {
            toolbarInline: false,
            placeholderText: 'Enter Text Here'
        });
})();


(function () {
    'use strict';

    /** @ngInject */
    function InformativeReportTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "INFORMATIVE_REPORT": {
                "TITLE": "Boletim Informativo",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Criar Boletim",
                "FORM_EDIT": "Editar Boletim",
                "FOR_STUDENT": "Alunos",
                "FOR_PARENTS": "Responsáveis",
                "FOR_TEACHER": "Professores",
                "FOR_EMPLOYEE": "Colaboradores"
            }
        })

    }

    angular
        .module('app.educational.informative-report')
        .config(InformativeReportTranslate);
})();

(function() {
    'use strict';
    angular
        .module('app.educational.groups', [
          'app.educational.groups.timetable'
        ]);
})();


(function () {
    'use strict';

    /** @ngInject */
    function GroupsTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "GROUPS": {
                "ADD_GROUP": "Adicionar Turma",
                "TITLE": "Turmas",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Criar turma",
                "FORM_EDIT": "Editar turma"
            },
            "TIMETABLE": {
            "ATTENTION": "Atenção",
            "DUPLICATE": "Duplicar grade de horário"
          },
          "TIMETABLE_ITEM": {
            "FORM_CREATE": "Criar horário",
            "FORM_EDIT": "Editar horário"
          }
        })

    }

    angular
        .module('app.educational.groups')
        .config(GroupsTranslate);
})();

(function(){
  'use strict';

  angular
    .module('app.educational.groups.timetable', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function TimetableService(Restangular) {

    /**
     * Realiza a criação da grade de horário.
     */
    var create = function (item) {
      return Restangular.all('timetable').post(item);
    };

    /**
     * Retorna a grade de horário vinculado a turma.
     * @returns array
     */
    var getTimetableByGroupId = function (obj) {
      return Restangular.one('timetable').one('gettimetablebygroupid').get(obj);
    };

    /**
     * Retorna a grade de horário vinculado ao curso.
     * @returns array
     */
    var getTimetableByCourseId = function (obj) {
      return Restangular.one('timetable').one('gettimetablebycourseid').get(obj);
    };

    /**
     * Retorna todos os templates de grade horário.
     * @returns array
     */
    var getAllTimetableTemplate = function () {
      return Restangular.one('timetabletemplate').one('getall').get();
    };

    /**
     * Retorna todas celulas da grade de horário.
     * @returns array
     */
    var getTimetableItemsById = function (obj) {
      return Restangular.one('timetable').one('gettimetableitemsbyid').get(obj);
    };

    /**
     * Retorna todas as listas necessária para edição de uma celula do horário
     */
    var getInfoForTimetableItem = function (obj) {
      return Restangular.one('timetable').one('getinfofortimetableitem').get(obj);
    };

    /**
     * Realiza a remoção dos dados do item da grade
     * @param obj
     */
    var deleteItem = function (obj) {
      return Restangular.one('timetable').all('deleteitem').post(obj);
    };

    /**
     * Realiza a edição dos dados do item da grade
     * @param obj
     */
    var editItem = function (obj) {
      return Restangular.one('timetable').all('edititem').post(obj);
    };

    /**
     * Realiza a criação da grade de horário.
     */
    var duplicateTimetable = function (obj) {
      return Restangular.one('timetable').all('duplicatetimetable').post(obj);
    };

    /**
     * Retorna todas as listas necessária para edição de uma celula do horário
     */
    var getSugestionForSubject = function (obj) {
      return Restangular.one('timetable').one('getsugestionforsubject').get(obj);
    };

    var deleteTimetable = function (obj) {
      return Restangular.one('timetable').all('deletetimetable').post(obj);
    };

    var refreshView = function () {
      return Restangular.one('timetable').one('refreshview').get();
    };

    return {
      create: create,
      getTimetableByGroupId: getTimetableByGroupId,
      getTimetableByCourseId: getTimetableByCourseId,
      getAllTimetableTemplate: getAllTimetableTemplate,
      getTimetableItemsById: getTimetableItemsById,
      getInfoForTimetableItem: getInfoForTimetableItem,
      deleteItem: deleteItem,
      deleteTimetable: deleteTimetable,
      editItem: editItem,
      duplicateTimetable: duplicateTimetable,
      getSugestionForSubject: getSugestionForSubject,
      refreshView : refreshView
    };

  }

  angular
    .module('app.educational.groups.timetable')
    .factory('TimetableService', TimetableService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function TimetableCreateController($rootScope, $state, moment, a4Moment,
                                     TimetableService, Common, ModalFactory, $scope, ModalExtra) {
    var vm = this;

    vm.form = {
      timetable: {
        timetable_id: ModalExtra.is_edit
          ? ModalExtra.selected_timetable.id
          : null,
        initial_date: ModalExtra.is_edit
          ? a4Moment(ModalExtra.selected_timetable.initial_date)
          : null,
        final_date: ModalExtra.is_edit
          ? angular.isDefined(ModalExtra.selected_timetable.final_date)
            ? a4Moment(ModalExtra.selected_timetable.final_date)
            : null
          : null,
        group_id: $state.params.id,
        matrix_period: $state.params.matrix_period
      },
      open_input: ModalExtra.is_edit ? (ModalExtra.selected_timetable.final_date == null ? false : true) : false,
      initial_date_error: false
    };

    vm.list = {
      timetable: {}
    };



    vm.init = function () {
      vm.getAllTimetableTemplate();
      vm.timetable = ModalExtra;console.log(ModalExtra);
      vm.matrix_period = angular.isDefined(ModalExtra.selected_timetable.matrix_period) ?
        ModalExtra.selected_timetable.matrix_period : ModalExtra.matrix_period;
    };

    /**
     * Verifica a cada mudança de valor para a data inicial em duplicação de grade
     */
    $scope.$watch('vm.form.timetable.initial_date', function (newer) {
      var initial_date = moment(newer).format('YYYY-MM-DD');
      angular.forEach(vm.timetable, function (value) {
        if(initial_date === value.initial_date){
          vm.form.initial_date_error = true;
          // Common.Toast.error('Já existe grade de horário iniciando nesta data.');
        }else{
          vm.form.initial_date_error = false;
        }
      });
    });


    /**
     * Resgata todos os templates de grades de horário.
     */
    vm.getAllTimetableTemplate = function () {
      TimetableService.getAllTimetableTemplate()
        .then(function (response) {
          vm.list.timetable.timetable_template_id = response.plain();
          $rootScope.show_loader = false;
        })
    };

    vm.submit = function (item, form) {
      console.log(vm.matrix_period);
      if (form.$valid) {
        if (vm.timetable.length === 0){
          item.initial_date = null;
        }

        TimetableService.create(
          {
          initial_date: a4Moment(vm.form.timetable.initial_date).format('YYYY-MM-DD'),
          final_date: vm.form.open_input === true ? a4Moment(vm.form.timetable.final_date).format('YYYY-MM-DD') : null,
          timetable_id: vm.form.timetable.timetable_id,
          matrix_period: vm.matrix_period,
          group_id: item.group_id,
          timetable_template_id: vm.form.timetable.timetable_template_id
          })
          .then(function () {
            Common.Toast.success('Grade salva com sucesso');
            $rootScope.$broadcast('update.timetable.list');
            vm.close();
          })
          .catch(function (response) {
            switch (response.data.message) {
              case "NOT_POSSIBLE_CREATE_TIMETABLE_HAS_SAME_DATE":
                Common.Toast.warning('Existe uma grade com essa mesma data para a turma.');
                break;
              case "DUPLICATED_NAME":
                Common.Toast.warning('Existe uma grade com esse nome no sistema.');
                break;
              case "EMPTY_NAME":
                Common.Toast.warning('Nome da grade não pode ficar em branco.');
                break;
              case "SHOCK_BETWEEN_SCHEDULES":
                Common.Toast.warning('Não foi possível salvar, está ocorrendo choque entre horários.');
                break;
              case "INITIAL_DATE_GREATER_THAN_FINAL":
                Common.Toast.warning('Não é possivel utilizar uma data final que antecede a data inicial');
                break;
              default:
                Common.Toast.error('Não foi possivel salvar a grade de horário.');
                break;
            }
          })
      }
    };

    /**
     * Realiza fechamento do serviço do modal
     */
      vm.close = function () {
        $rootScope.$broadcast('ModalFactory.close');
      };

    vm.init();
  }

  angular
    .module('app.educational.groups.timetable')
    .controller('TimetableCreateController', TimetableCreateController);

})();

(function () {
  'use strict';

  function TimetableController($rootScope, $scope, $stateParams, moment, a4Moment, ReportsService, EducationalService,
                               ModalFactory, Common, GroupsService, TimetableService, PoliciesService) {

    var vm = this;

    var ltn1 = $rootScope.$on('update.timetable.list', function () {
      vm.getTimetableByGroupId($stateParams.id, $stateParams.matrix_period);
    });

    var ltn2 = $rootScope.$on('update.timetable', function () {
      vm.getTimetableItems(vm.timetable_id, $stateParams.matrix_period);
    });

    vm.form = {
      timetable: {},
      mode_edit: false
    };

    vm.timetable = {};
    vm.timetable_id = {};
    vm.selected_timetable = {};
    vm.timetableGrid = {exceptions: []};
    vm.initial_date_view = null;
    vm.timetable_duplicate = {};
    vm.matrix_period = null;
    vm.has_saturday = false;
    vm.has_sunday = false;

    vm.col_defs_services = [
      {
        field: "subject_name",
        displayName: "Disciplina",
        headTemplate: "<div ><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div ><span>{{row.branch[col.field]}}</span></div>"
      },
      {
        field: "inclusion_status",
        displayName: "Tipo",
        headTemplate: "<div ><span>{{col.displayName}}</span></div>",
        cellTemplate: "<div ><span>{{row.branch[col.field]}}</span></div>"
      }
    ];
    vm.expanding_property = {
      field: "matrix_period_subject",
      displayName: "Periodo",
      cellTemplate: "<span>{{row.branch[expandingProperty.field]}}</span>"
    };


    vm.init = function () {
      vm.getTimetableByGroupId($stateParams.id, $stateParams.matrix_period);
      vm.getGroupById();
      vm.getAcademicType();
    };



    vm.getAcademicType = function () {
      EducationalService.getAcademicTypeOfCompany()
        .then(function (response) {
          vm.academic_type = response;
        })
    };

    /**
     * Resgata o objeto referente a turma
     * @param group_id - identificador da turma
     */
    vm.getGroupById = function () {
      GroupsService.getById($stateParams.id, $stateParams.matrix_period)
        .then(function (response) {
          vm.group = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel recuperar os dados da turma.');
        });
    };

    /**
     * Altera a grade de acordo com a mesma selecionada na lista
     * @param timetable
     */
    vm.changeTimetable = function (timetable) {
      vm.form.mode_edit = false;
      vm.timetable_id = timetable.id;
      vm.getTimetableItems(timetable.id, $stateParams.matrix_period);
      vm.initial_date_view = (timetable.initial_date) ? new Date(timetable.initial_date.replace(/-/g, '/')) : null;
    };

    vm.getTimetableItems = function (id, matrix_period) {
      $rootScope.show_loader = true;
      TimetableService.getTimetableItemsById({id: id, matrix_period: matrix_period, group_id: $stateParams.id})
        .then(function (response) {
          vm.timetableGrid = response.plain();
          angular.forEach(vm.timetableGrid.timetable_items, function (value) {
            var initial_time = value.initial_time.split(":");
            var final_time = value.final_time.split(":");

            if (value.day_of_week === 7 && value.subject_id !== null) vm.has_saturday = true;

            if (value.day_of_week === 1 && value.subject_id !== null) vm.has_sunday = true;

            value.initial_time = new Date(2017, 0, 1, +parseInt(initial_time[0]), +parseInt(initial_time[1]), +parseInt(initial_time[2]));
            value.final_time = new Date(2017, 0, 1, +parseInt(final_time[0]), +parseInt(final_time[1]), +parseInt(final_time[2]));

          });
          $rootScope.show_loader = false;
        });
    };


    /**
     * Abre o modal de criação uma grade de horários
     */

    vm.createOrUpdateTimetable = function (is_edit) {
      if(vm.group.school_period_id === 0 && vm.group.final_date == null) {
          ModalFactory.alert(
            "Atenção", "Para criar grade de horário é necessário informar a data inicial e a final das aulas da turma.",
            "modal", "Ok", "false", "educational");
      } else {
        ModalFactory.customClean(
          'app/educational/groups/timetable/views/forms/form-timetable.html',
          'TimetableCreateController',
          'vm', false, {
            selected_timetable: vm.selected_timetable,
            is_edit: is_edit,
            academic_type: vm.academic_type,
            matrix_period: vm.matrix_period
          }
        )
      }

    };


    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Verifica a cada mudança de valor para a data inicial em duplicação de grade
     */
    $scope.$watch('vm.timetable_duplicate.initial_date', function (newer) {
      var initial_date = moment(newer).format('YYYY-MM-DD');
      angular.forEach(vm.timetable, function (value) {
        if (initial_date === value.initial_date) {
          vm.timetable_duplicate.initial_date_error = true;
          Common.Toast.error('Já existe grade de horário iniciando nesta data.');
        } else {
          vm.timetable_duplicate.initial_date_error = false;
        }
      });
    });

    vm.deleteTimetable = function (timetable) {
      ModalFactory.confirm(null,
        'Deseja remover esta grade de horários?',
        'Esta grade será removida caso não tenham disciplinas associadas.',
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          $rootScope.show_loader = true;
          TimetableService.deleteTimetable(timetable).then(function () {
            Common.Toast.success('Grade de horário excluída com sucesso!');
            vm.init();

          }).catch(function (response) {
            $rootScope.show_loader = false;
            if (response.data.message === 'TIMETABLE_WITH_SUBJECTS') {
              ModalFactory.alert(
                "Exclusão não permitida", "Só podem ser excluídas grades de horário que não possuam disciplinas associadas.",
                "modal", "Ok", "false", "educational"
              );
            }
          });
        })
    };

    vm.form.mode_edit = !vm.form.mode_edit;

    /**
     * Permite a edição da grade
     */
    vm.allowEditing = function () {
      vm.form.mode_edit = true;
      $rootScope.$broadcast('ModalFactory.close');
    };

    /**
     * Realiza a duplicação da grade
     */
    vm.duplicateTimetable = function () {
      vm.form.mode_edit = false;
      $rootScope.$broadcast('ModalFactory.close');

      vm.timetable_duplicate.initial_date = new Date();
      ModalFactory.custom('app/educational/groups/timetable/views/dialogs/timetable-duplicate.html', vm);
    };

    vm.submitDuplicateTimetable = function () {

      vm.duplicate = {
        'id': vm.selected_timetable.id,
        'course_id': vm.selected_timetable.course_id,
        'group_id': vm.selected_timetable.group_id,
        'matrix_period': vm.selected_timetable.matrix_period,
        'initial_date': moment(vm.timetable_duplicate.initial_date).format('YYYY-MM-DD')
      };

      TimetableService.duplicateTimetable(vm.duplicate)
        .then(function () {
          Common.Toast.success('Grade duplicada com sucesso');
          $rootScope.$broadcast('update.timetable.list');
          $rootScope.$broadcast('ModalFactory.close');
        })
        .catch(function (response) {
          switch (response.data.message) {
            case "NOT_POSSIBLE_CREATE_TIMETABLE_HAS_SAME_DATE":
              Common.Toast.warning('Existe uma grade com essa mesma data para a turma.');
              $rootScope.show_loader = true;
              vm.paginate();
              $rootScope.show_loader = false;
              break;
            case "NOT_POSSIBLE_CREATE_TIMETABLE":
              Common.Toast.warning('Não foi possível duplicar a grade de horário.');
              $rootScope.show_loader = true;
              vm.paginate();
              $rootScope.show_loader = false;
              break;
          }
        });

    };

    /**
     * Edita a grade
     */
    vm.editTimetableCurrent = function (mode_edit) {
      if (!mode_edit) {
        var today = moment();
        var initial_date = moment(vm.selected_timetable.initial_date);
        if (vm.selected_timetable.initial_date == null || initial_date <= today) {
          ModalFactory.custom('app/educational/groups/timetable/views/dialogs/timetable-alert.html', vm);
        } else {
          vm.allowEditing();
        }
      } else {
        vm.form.mode_edit = false;
      }

    };


    // /**
    //  * Conclui a edição e faz refresh na view
    //  */
    vm.refreshView = function () {
      $rootScope.show_loader = true;
      TimetableService.refreshView().then(function () {
        vm.form.mode_edit = false;
        $rootScope.show_loader = false;
      })
    };

    /**
     * Abre o modal de edição de uma celula da grade de horários
     * @param item
     */
    vm.editItem = function (item) {

      var timetable_item = {
        id: item.id,
        timetable_id: vm.timetable_id,
        subject_id: item.subject_id,
        person_id_teacher: item.person_id_teacher,
        location_id: item.location_id
      };

      ModalFactory.customClean(
        'app/educational/groups/timetable/views/forms/form-timetable-cell.html',
        'TimetableCellEditController',
        'vm', false, timetable_item
      );
    };


    /**
     * Resgata todos as grades de horário da turma.
     * @param group_id - identificador de uma turma.
     * @param matrix_period - Periodo da turma
     */
    vm.getTimetableByGroupId = function (group_id, matrix_period) {
      vm.matrix_period = matrix_period;
      var obj = {group_id: group_id, matrix_period: matrix_period};
      TimetableService.getTimetableByGroupId(obj)
        .then(function (response) {
          vm.timetable = response.plain();

          /** Inclui initial_date_formated que é montado da seguinte forma:
           * - Quando não possui data inicial mostra: Horário inicial
           * - Quando possui data inicial mostra: Ativo a partir de dd/mm/aaaa
           * - Quando possui data final concatena com: e interrompido em dd/mm/aaaa
           * Lembrando que em todas as turmas, o primeiro horário não deve ter data inicial,
           * pois é um horário ativo desde o primeiro dia da turma
           * */
          angular.forEach(response, function (value) {
             value['initial_date_formated'] =
               ( value['initial_date'] == null ?
                  'Horário inicial' :
                  'Ativo a partir de ' + a4Moment(value['initial_date']).format('DD/MM/YYYY')
               ) +
               ( value['final_date'] != null ?
                  ' e interrompido em ' + a4Moment(value['final_date']).format('DD/MM/YYYY') :
                  ''
               );
          });

        })
    };


    /**
     * Realiza a remoção dos dados do item da grade
     *
     * @param timetable_item
     */
    vm.deleteItem = function (timetable_item) {

      ModalFactory.confirm(null,
        'Deseja remover esta aula?',
        'Esta aula será removida e o horário ficará disponível.',
        'Confirmar', 'Cancelar', 'educational')
        .then(function (response) {
          if (response) {
            TimetableService.deleteItem({item: timetable_item})
              .then(function () {
                Common.Toast.success('Aula removida com sucesso');
                $rootScope.$broadcast('update.timetable');
              });
          }
        });
    };

    vm.printTimetable = function () {
      ReportsService.reportFactory('GET', 'api/reports/printtimetable', {
        timetable_id: vm.timetable_id,
        matrix_period: $stateParams.matrix_period
      });
    };

    $scope.$on('$destroy', function () {
      [ltn1, ltn2].forEach(function (fn) {
        fn();
      })
    });

    vm.init();


  }

  angular
    .module('app.educational.groups.timetable')
    .controller('TimetableController', TimetableController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function TimetableCellEditController($rootScope, $state, moment,
                                       TimetableService, ModalFactory, ModalExtra, Common, $scope) {
    var vm = this;
    vm.disable = false;
    vm.form = {
      mode_edit: true,
      timetable: {
        initial_date: moment()._d,
        group_id: $state.params.id
      }
    };

    vm.list = {
      timetable_item: {
        subject_id: [],
        person_id_teacher: [],
        location_id: []
      }
    };

    vm.replicate = false;

    vm.select_default = {
      name: "A definir", id: null
    };

    /** Evento para realizar a sugestão de professor e horário a partir da disciplina */
    var ltn1 = $scope.$watch('vm.form.timetable_item.subject_id', function (subjectId) {
      if (subjectId !== null) {
        vm.getSugestionForSubject(subjectId);
      }
    });

    vm.init = function () {
      vm.form.timetable_item = ModalExtra;
      vm.getInfoForTimetableItem(vm.form.timetable.group_id);
    };

    /**
     * Define os campos padrão para os selects não obrigatoríos
     */
    vm.addSelectDefault = function () {
      vm.list.timetable_item.location_id.splice(0, 0, vm.select_default);
      vm.list.timetable_item.person_id_teacher.splice(0, 0, vm.select_default);
    };

    /**
     * Valida o fomulário e submete os dados
     * @param item
     * @param form
     */
    vm.submit = function (item, form) {

      item['replicate'] = (vm.replicate) ? true : false;
      vm.disable = true;
      if (form.$valid) {
        item.group_id = vm.form.timetable.group_id;
        $rootScope.show_loader = true;
        TimetableService.editItem(item)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Horário atualizado com sucesso');
            $rootScope.$broadcast('update.timetable');
            vm.close();
          })
          .catch(function (response) {
            vm.disable = false;
            switch (response.data.message) {
              case "NOT_POSSIBLE_CREATE_TIMETABLE_NOT_FOUND_SUBJECT":
                Common.Toast.warning('Não foi possível criar a grade, o curso informado não foi encontrado.');
                $rootScope.show_loader = true;
                vm.paginate();
                $rootScope.show_loader = false;
                break;
              case "VERIFICATION_SHOCK":
                ModalFactory.confirm(
                  null,
                  'Confirmação',
                  'Existe um choque de horário com esse professor ou esta sala. Deseja continuar?',
                  'Confirmar',
                  'Cancelar',
                  'educational'
                ).then(function () {
                  item.confirmShock = true;
                  $rootScope.show_loader = false;
                  vm.submit(item, form);
                })
                  .catch(function () {
                    $rootScope.show_loader = false;
                  });
                break;
            }
          });
      }
      vm.replicate = false;
    };

    /**
     * Informa ao submit se haverá replicação
     * @param info
     */
    vm.onSaveAndReplicate = function (info) {
      vm.replicate = info;
    };

    vm.getSugestionForSubject = function (subjectId) {
      TimetableService.getSugestionForSubject({subject_id: subjectId, group_id: $state.params.id})
        .then(function (response) {
          var sugestion = response.plain();
          vm.form.timetable_item.person_id_teacher = sugestion.person_id_teacher;
          vm.form.timetable_item.location_id = sugestion.location_id;
          $rootScope.show_loader = false;
        });
    };


    /**
     * Retorna todas as listas necessária para edição de uma célula do horário
     */
    vm.getInfoForTimetableItem = function (group_id) {
      TimetableService.getInfoForTimetableItem({group_id: group_id})
        .then(function (response) {
          vm.list.timetable_item = response.plain();
          vm.addSelectDefault();
          $rootScope.show_loader = false;
        });
    };

    /**
     * Realiza fechamento do serviço do modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };


    /**
     * Realiza a remoção dos dados do item da grade
     *
     * @param item
     */
    vm.deleteItem = function (item) {
      ModalFactory.confirm(null,
        'Deseja remover esta aula?',
        'Esta aula será removida e o horário ficará disponível.',
        'Confirmar', 'Cancelar', 'educational')
        .then(function (response) {

          if (response) {
            TimetableService.deleteItem({item: item})
              .then(function () {
                Common.Toast.success('Aula removida com sucesso');
                $rootScope.$broadcast('update.timetable');
              });
          }

        });
    };

    $scope.$on('$destroy', function () {
      [ltn1].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.groups.timetable')
    .controller('TimetableCellEditController', TimetableCellEditController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function StudentsGroupController($rootScope, $state, Common, $stateParams, $a4FloatButton, GroupsService,
                                   EnrolmentService, PoliciesService) {
    var vm = this;

    vm.attendance_type = null;
    vm.grid = {
      rows: [],
      info: {}
    };
    vm.grades = [];
    vm.show_absences = false;

    vm.tableItemsSelected = [];

    vm.verifyDisableButton = function () {

    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.getFrequency = function () {
      $rootScope.show_loader = true;
      GroupsService.getStudentsAbsences({
        matrix_period: $stateParams.matrix_period,
        group_id: $stateParams.id
      }).then(function (response) {
        var data = response.plain();
        var absences = data.absences;
        vm.grades = data.grades;
        for (var i = 0; i < absences.length; i++) {
          for (var z = 0; z < vm.grid.rows.length; z++) {
            if (absences[i].person_id === vm.grid.rows[z].person_id) {
              vm.grid.rows[z][absences[i].event] = absences[i].absences;
            }
          }
        }
        vm.show_absences = true;
        $rootScope.show_loader = false;
      })
    };


    vm.getAttendanceType = function () {
      GroupsService.getAttendanceType({
        matrix_period: $stateParams.matrix_period,
        group_id: $stateParams.id
      }).then(function (response) {
        vm.attendance_type = response;
      })
    };

    vm.paginate = function () {
      $rootScope.show_loader = true;
      GroupsService.getStudentsByGroup(
        {group_id: $stateParams.id, matrix_period: $stateParams.matrix_period,
        canceled: true})
        .then(function (response) {
          vm.grid.rows = response.plain();
          for (var i = 0; i < vm.grid.rows.length; i++) {
            if (vm.grid.rows[i].group_status_id === 4 && vm.grid.rows[i].enrolment_status_id === 10) {
              vm.grid.rows[i].enrolment_status = 'Turma concluída';
            } else if (vm.grid.rows[i].conclusion_date !== null){
              vm.grid.rows[i].enrolment_status = 'Concluído';
            }
          }
          $rootScope.show_loader = false;
          vm.getAttendanceType();
        });
    };

    vm.confirmConditional = function (student) {
      $rootScope.show_loader = true;
      EnrolmentService.confirmEnrolment(student).then(function () {
        Common.Toast.success('Matrícula confirmada com sucesso.');
        vm.paginate();
      }).catch(function () {
        Common.Toast.error('Problemas na confirmação da matrícula.');
      })
    };

    /**
     * Confirma a matrícula condicional de múltiplos alunos;
     */
    vm.confirmStudentsInGroup = function () {
      if (vm.verifySelectedStudentsToConfirm()) {
        $rootScope.show_loader = true;
        EnrolmentService.confirmMultipleEnrolments({
          students: vm.tableItemsSelected,
          group_id: $stateParams.id,
          matrix_period: $stateParams.matrix_period
        }).then(function () {
          Common.Toast.success('Matrículas confirmada com sucesso.');
          vm.paginate();
          vm.tableItemsSelected = [];
        }).catch(function () {
          Common.Toast.error('Problemas na confirmação das matrículas.');
        })
      } else {
        Common.Toast.warning('Você não pode realizar esta operação tendo selecionado alunos ' +
          'que não estão em matrícula condicional.');
      }
    };

    /**
     * Verifica se todos os alunos selecionados para terem a matrícula condicional
     * confirmada estão com o status de matrícula adequado.
     * @returns {boolean}
     */
    vm.verifySelectedStudentsToConfirm = function () {
      var can_confirm = true;
      vm.tableItemsSelected.forEach(function (item) {
        if (item.enrolment_status_id !== 1) {
          can_confirm = false;
        }
      });
      return can_confirm;
    };

    vm.goToStudent = function (item) {
      if (!vm.show_absences) {
        $state.go('private.educational.students.edit',
          {
            id: item.person_id,
            enrolment_period_id: item.id,
            course_id: item.course_id,
            group_id: item.group_id,
            matrix_period: item.matrix_period,
            course_equivalence_id: item.course_equivalence_id
          });
      }
    };

    vm.saveFrequency = function () {
      $rootScope.show_loader = true;
      GroupsService.saveFrequency({
        students: vm.grid.rows,
        group_id: $stateParams.id,
        matrix_period: $stateParams.matrix_period
      }).then(function (response) {
        if (response) {
          Common.Toast.success('Frequência salva com sucesso!');
          vm.show_absences = false;
        }
        $rootScope.show_loader = false;
      });
    };

    vm.init = function () {
      vm.paginate();
    };


    vm.init();
  }

  angular
    .module('app.educational.groups')
    .controller('StudentsGroupController', StudentsGroupController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function NotesPendingGroupController($scope, $stateParams, $rootScope, GroupsService) {
    var vm = this;
    vm.groupId = $stateParams.group_id != null ? $stateParams.group_id : $stateParams.id;
    vm.matrixPeriod = $stateParams.matrix_period;
    vm.pendentGrades = {};

    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      page = angular.isDefined(page) ? page : 1;
      limit = angular.isDefined(limit) ? limit : 15;
      GroupsService.getPendingGradesByGroup({
        group_id: vm.groupId,
        matrix_period: vm.matrixPeriod,
        page: page,
        limit: limit
      }).then(function (response) {
        vm.pendentGrades = response;
        vm.pendentGrades.data = response.data;
        vm.pendentGrades.info = {
          limit_options: [15, 30, 60, {
            label: 'Todos',
            value: function () {
              return response.total;
            }
          }],
          limit: limit,
          page: page,
          total: response.total
        };
        $rootScope.show_loader = false;
      })
    };

    vm.init = function () {
      vm.paginate();
      console.log($stateParams)
      console.log(vm.groupId)
    };

    vm.init();

  }

  angular.module('app.educational.groups')
    .controller('NotesPendingGroupController', NotesPendingGroupController);
})();
(function () {
  'use strict';

  angular
    .module('app.educational.evaluation-criteria', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function EvaluationCriteriaTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "EVALUATION_CRITERIA": {
                "ADD_GROUP": "Adicionar critério",
                "TITLE": "Critérios de avaliação",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Criar critérios",
                "FORM_EDIT": "Editar critério"
            }
        })

    }

    angular
        .module('app.educational.evaluation-criteria')
        .config(EvaluationCriteriaTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function EnrolmentTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "ENROLMENT": {
        "CEP_NOT_FOUND": "CEP não encontrado"
      }
    })

  }

  angular
    .module('app.educational.enrolment')
    .config(EnrolmentTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.documents', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DocumentsTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "DOCUMENTS": {
        "TITLE": "Mensagens",
        "CREATE_NEW_FOR": "Criar nova mensagem para ",
        "EDIT": "Editar mensagem para ",
        "SEARCH_FOR_ANYONE": "Pesquisar"
      }
    })

  }

  angular
    .module('app.educational.documents')
    .config(DocumentsTranslate);
})();


(function () {
    'use strict';

    /** @ngInject */
    function CourseTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "COURSE_GROUP": {
                "ADD_GROUP": "Adicionar Grupo",
                "TITLE": "Grupos de Curso",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Criar grupo",
                "FORM_EDIT": "Editar grupo"
            }
        })

    }

    angular
        .module('app.educational.course')
        .config(CourseTranslate);
})();


(function () {
    'use strict';

    /** @ngInject */
    function CourseTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "COURSE": {
                "ADD_PLAN": "Adicionar Curso",
                "TITLE": "Cursos",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Criar Curso",
                "FORM_EDIT": "Editar Curso"
            },
            "MATRIX": {
              "FORM_CREATE": "Criar Grade Curricular",
              "FORM_EDIT": "Editar Grade Curricular",
              "FORM_DUPLICATE": "Duplicar Grade Curricular",
              "SUBJECT": {
                "INSERT": 'Adicionar disciplina',
                "EDIT": 'Editar disciplina',
                "INSERT_SUB": 'Adicionar sub-disciplina'
              },
              "EDIT_PERIOD": 'Editar período'
            },
            "TIMETABLE": {
              "ADD_PLAN": "Adicionar Grade de horários",
              "TITLE": "Cursos",
              "SEARCH_FOR_ANYONE": "Pesquisar",
              "FORM_CREATE": "Criar Grade de horários",
              "FORM_EDIT": "Editar Grade de horários"
            }
        })

    }

    angular
        .module('app.educational.course')
        .config(CourseTranslate);
})();

(function () {
  'use strict';
  angular
    .module('app.educational.course.students', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function CourseStudentsController($stateParams, $state, $rootScope, Common, CourseService, GroupsService, StudentsService, ModalFactory) {
    var vm = this;
    vm.group_selected = [];
    vm.course_id = $stateParams.id;
    vm.groups_ids = [];
    vm.selected_students = [];
    vm.index = 0;

    /**
     * Busca os alunos de acordo com filtro
     * @param group_id
     * @param matrix_period
     * @param filter
     */
    vm.getStudents = function (group_id, matrix_period, filter) {
      if (group_id === null) {
        if (vm.group_selected.length <= 0) {
          group_id = vm.groups_ids.toString();
          matrix_period = 1;
          filter = 2;
        } else {
          group_id = vm.group_selected.toString();
          matrix_period = 1;
          filter = 2;
        }
      }
      $rootScope.show_loader = true;
      GroupsService.getStudentsByGroup(
        {group_id: group_id, matrix_period: matrix_period, filter: filter})
        .then(function (response) {
          vm.students = response.plain();
          $rootScope.show_loader = false;
        })
    };


    /**
     * Função chamada após seleção de um aluno na lista.
     * Ou remove aluno do array (caso exista) ou inclui.
     * @param student
     * @returns {*}
     */
    vm.selectStudent = function (student) {
      if (vm.isChecked(student.person_id)) {
        return vm.selected_students.splice(vm.index, 1);
      }
      vm.selected_students.push(student);
    };

    /**
     * Função que verifica se o aluno está na lista
     * @param person_id
     * @returns {boolean}
     */
    vm.isChecked = function (person_id) {
      for (vm.index = vm.selected_students.length; vm.index--;) {
        if (vm.selected_students[vm.index].person_id === person_id) {
          return true;
        }
      }
      return false;
    };

    /**
     * Função de alteração de turma
     */
    vm.changeGroup = function () {
      if (vm.selected_students.length === 0) {
        ModalFactory.alert(
          "Troca de turma não permitida", "Para realizar uma troca de turma é necessário que você selecione " +
          "ao menos um aluno da lista.",
          "modal", "Ok", "false", "educational"
        );
      } else if (vm.groups.length === 1) {
        ModalFactory.alert(
          "Troca de turma não permitida", "Para realizar uma troca de turma é necessário que existam ao menos" +
          " duas turmas neste curso no período letivo selecionado.",
          "modal", "Ok", "false", "educational"
        );
      } else {
        /** Loop para definir uma turma para aparecer primeiro no select (turma diferente da dos alunos que terão
         * a turma trocada) */
        for (var i = vm.groups.length; i--;) {
          if (vm.groups[i].id !== vm.selected_students[0].group_id) {
            var selected_group = vm.groups[i];
            break;
          }
        }
        ModalFactory.custom('app/educational/course/students/views/change-group-modal.html', {
          groups: vm.groups,
          group_id_selected: vm.selected_students[0].group_id,
          selected_group: selected_group
        }, true).then(function (group) {
          if (group.group_shift_id !== vm.selected_students[0].group_shift_id) {
            ModalFactory.confirm(null, "Confirmar troca de turma",
              "A turma destino possui um turno diferente da turma de origem, deseja continuar?",
              'Confirmar', 'Cancelar', 'educational')
              .then(function () {
                vm.doGroupChange(
                  group.id,
                  group.matrix_period,
                  vm.selected_students[0].group_id,
                  vm.selected_students[0].matrix_period,
                  vm.selected_students
                );
              });
          } else {
            vm.doGroupChange(
              group.id,
              group.matrix_period,
              vm.selected_students[0].group_id,
              vm.selected_students[0].matrix_period,
              vm.selected_students
            );
          }
        })
      }
    };

    vm.doGroupChange = function (
      group_destiny,
      matrix_period_destiny,
      group_origin,
      matrix_period_origin,
      students
    ) {
      $rootScope.show_loader = true;
      StudentsService.changeGroupOfMultipleStudents({
        group_id_destiny: group_destiny,
        matrix_period_destiny: matrix_period_destiny,
        group_id_origin: group_origin,
        matrix_period_origin: matrix_period_origin,
        students: students
      }).then(function () {
        vm.selected_students = [];
        vm.getStudents(null, null, null);
        Common.Toast.success("Troca de turma realizada com sucesso!");
      })
    };


    vm.goToStudent = function (item) {
      $state.go('private.educational.students.edit',
        {id: item.person_id, course_id: item.course_id, group_id: item.group_id});
    };

    vm.init = function () {
      $rootScope.show_loader = true;
      CourseService.getGroupsInfosByCourse({course_id: vm.course_id}).then(function (response) {
        var data = response.plain();
        vm.groups = data.groups;
        vm.groups_ids = data.groups_ids;
        $rootScope.show_loader = false;
        vm.getStudents(vm.groups_ids.toString(), 1, 2);
      });
    };
    vm.init();
  }

  angular.module('app.educational.course.students')
    .controller('CourseStudentsController', CourseStudentsController);
})();

(function () {
  'use strict';
  angular
    .module('app.educational.course.matrix', [])
})();
(function () {
  'use strict';

  /** @ngInject */
  function MatrixSubjectRequirementController(ModalExtra, $mdDialog, Common) {
    var vm = this;
    vm.data = ModalExtra;
    vm.obj = {};
    vm.obj.subjectList = [];
    vm.query = {
      limit: 1000,
      page: 1
    };

    vm.init = function () {
      angular.forEach(vm.data.subjectSelected, function (value) {
          var selected = value.id;
          angular.forEach(vm.data.subjectAvailable, function (value2) {
              if(selected == value2.id){
                value2.requirement_type = value.requirement_type;
                vm.obj.subjectList.push(value2);
              }
          });
      });

      for (var key1 in vm.data.subjectAvailable) {
        if(vm.data.subjectAvailable[key1].requirement_type !== null && vm.data.type !== vm.data.subjectAvailable[key1].requirement_type){
          delete vm.data.subjectAvailable[key1];
        }
      }

      for (var key2 in vm.obj.subjectList) {
        if(vm.obj.subjectList[key2].requirement_type !== null && vm.data.type !== vm.obj.subjectList[key2].requirement_type){
          delete vm.obj.subjectList[key2];
        }
      }

      if(angular.isUndefined(vm.data.subjectAvailable[0])){
        vm.closeModal();
        Common.Toast.warning('Não há disciplinas dispóniveis');
        return false;
      }

    };

    vm.
      answer = function (answer, form) {
      if (form.$valid) {
          $mdDialog.hide(answer);
      }
    };

    vm.closeModal = function () {
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular.module('app.educational.course.matrix')
    .controller('MatrixSubjectRequirementController', MatrixSubjectRequirementController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function MatrixSubjectController($scope, $rootScope, $a4Sidenav,
                                   ConceptCriteriaService, $timeout, ModalFactory, SideExtra, SubjectService, Common) {

    var vm = this;

    vm.continue = false;
    vm.add = false;
    vm.subject = null;

    /** Atualiza a lista após criação de nova disciplina */
    var ltn1 = $rootScope.$on('CUSTOM_CLEAN.closed', function () {
      vm.getAllSubjects();
    });

    /** Evento para criação de disciplinas de outros modulos */
    var ltn2 = $rootScope.$on('matrix.subject.created', function (ev, obj) {
      vm.subject_created = true;
      vm.subject_created_object = obj;
    });


    vm.list = {};
    vm.list.subject_period = {
      subject_id: {},
      how_required: {},
      evaluation_mode: {}
    };
    vm.form = {};
    vm.form.subject_period = {
      subject_id: '',
      how_required: 1,
      evaluation_mode: 1,
      dont_fail: false,
      dont_calc: false,
      dont_grade_recovery: false,
      show_on_documents: true,
      show_on_report: true
    };

    vm.subject_created = false;

    vm.form.subject_requirement = {};

    vm.subject_requirement_text = function (type) {
      switch (type) {
        case 'P':
          return 'Pré-requisito';
        case 'C':
          return 'Co-requisito';
      }
    };

    vm.form.mode_edit = true;

    vm.init = function () {
      ConceptCriteriaService.getAll()
        .then(function (response) {
          vm.grade_code_rules = response.data;
        });
      vm.is_superior_course = SideExtra.is_superior_course;
      vm.is_edit = SideExtra.is_edit;
      vm.objperiod = SideExtra.period.matrix_period;
      vm.objmatrix = SideExtra.matrix;
      if (SideExtra.hasOwnProperty('subject')) {
        vm.getSubjectPeriodById();
      }
      vm.list.subject_period.how_required = [
        {id: 1, name: 'Obrigatória'},
        {id: 2, name: 'Optativa'},
        {id: 3, name: 'Eletiva'}
      ];

      vm.list.subject_period.evaluation_mode = [
        {id: 0, name: 'Não avalia'},
        {id: 1, name: 'Notas'},
        {id: 2, name: 'Conceito'}
      ];

      vm.form.subject_period.matrix_period = vm.objperiod;
      vm.form.subject_period.old_matrix_period = vm.objperiod;
      vm.form.subject_period.matrix_id = vm.objmatrix.id;

      vm.getAllSubjects();

      if (angular.isDefined(SideExtra.subject)) vm.getSubjectsRequirements();
    };

    /**
     * Resgata todas as disciplinas para uso no slide de adição de
     * novas disciplinas em uma grade
     */
    vm.getAllSubjects = function () {

      var subjects_used = {
        not_available: []
      };
      /**
       * Remove disciplinas já utilizadas do array.
       */
      angular.forEach(SideExtra.matrix.matrix_period, function (item) {
        if (angular.isDefined(item.subjects)) {
          angular.forEach(item.subjects, function (son) {
            if (angular.isDefined(son.subjects)) {
              angular.forEach(son.subjects, function (grandson) {
                subjects_used.not_available.push(grandson.id);
              });
            }
            if (angular.isDefined(son)) {
              subjects_used.not_available.push(son.id);
            }
          });
        }
      });

      SubjectService.getAll({subjects_used: subjects_used, without_grouped: true})
        .then(function (allSubjects) {
          vm.list.subject_period.subject_id = allSubjects.plain();
          if (vm.subject_created) {
            angular.forEach(vm.list.subject_period.subject_id, function (value) {
              $rootScope.show_loader = false;
              if (vm.subject_created_object.id === value.id) {
                vm.form.subject_period.subject_id = value;
              }
            });
          }
        })
    };


    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearch = function (query) {
      return query !== '' ? vm.list.subject_period.subject_id.filter(vm.createFilterFor(query.toLowerCase())) : vm.list.subject_period.subject_id;
    };
    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.toLowerCase().indexOf(query) === 0);
      };
    };


    vm.getSubjectPeriodById = function () {
      var obj = {
        subject_id: SideExtra.subject.id,
        matrix_id: SideExtra.matrix.id,
        matrix_period: SideExtra.period.matrix_period
      };

      SubjectService.getSubjectPeriodById(obj)
        .then(function (response) {
          vm.form.subject_period = response.plain();
          $rootScope.show_loader = false;
        });
    };

    /**
     * Busca as pré-requisitos e co-requisitos da disciplina
     */
    vm.getSubjectsRequirements = function () {

      var obj = {
        subject_id: SideExtra.subject.id,
        matrix_id: SideExtra.matrix.id,
        period: SideExtra.period.matrix_period
      };

      SubjectService.getSubjectsRequirements(obj)
        .then(function (response) {
          vm.list.subject_requirement = response.plain();
          $rootScope.show_loader = false;
        })
    };

    /**
     * Vincula uma disciplina como pré-requisito.
     *
     * @param parent
     */
    vm.addPreRequisite = function () {

      var subjects_used = {
        not_available: []
      };

      angular.forEach(vm.form.subject_requirement.list, function (value) {
        if (value.requirement_type == 'C') {
          subjects_used.not_available.push(value.id);
        }
      });

      var obj = {
        subject_id: SideExtra.subject.id,
        matrix_id: SideExtra.matrix.id,
        period: SideExtra.period.matrix_period,
        type: 'P',
        subjects_used: subjects_used
      };

      SubjectService.getPreviousSubjectsRequirements(obj)
        .then(function (response) {

          var retrieve = {
            title: 'Vincular Pré-requisitos',
            type: obj.type,
            subjectAvailable: response.plain(),
            subjectSelected: (angular.isDefined(vm.list.subject_requirement)) ? vm.list.subject_requirement : null
          };

          if (!retrieve.subjectAvailable.length) {
            Common.Toast.warning('Não há disciplinas dispóniveis');
            return false;
          }

          ModalFactory.customClean('app/educational/course/matrix/views/dialogs/add-subject-requirement.html',
            'MatrixSubjectRequirementController', 'vm', false, retrieve)
            .then(function (answer) {
              var data = {
                subject: obj,
                subjects_requirements: answer
              };
              SubjectService.createSubjectsRequirements(data)
                .then(function () {
                  vm.getSubjectsRequirements(vm.objperiod);
                  $rootScope.show_loader = false;
                });
            });


        });

    };


    /**
     * Vincula uma disciplina como co-requisito.
     */
    vm.addCoRequisite = function () {

      var subjects_used = {
        not_available: []
      };

      angular.forEach(vm.list.subject_requirement, function (value) {
        if (value.requirement_type == 'P') {
          subjects_used.not_available.push(value.id);
        }
      });

      var obj = {
        subject_id: SideExtra.subject.id,
        matrix_id: SideExtra.matrix.id,
        period: SideExtra.period.matrix_period,
        type: 'C',
        subjects_used: subjects_used
      };

      SubjectService.getPreviousSubjectsRequirements(obj)
        .then(function (response) {

          var retrieve = {
            title: 'Vincular Co-requisitos',
            type: obj.type,
            subjectAvailable: response.plain(),
            subjectSelected: (angular.isDefined(vm.list.subject_requirement)) ? vm.list.subject_requirement : null
          };

          if (retrieve.subjectAvailable.length == 0) {
            Common.Toast.warning('Não há disciplinas dispóniveis');
            return false;
          }
          $rootScope.show_loader = false;
          ModalFactory.customClean('app/educational/course/matrix/views/dialogs/add-subject-requirement.html',
            'MatrixSubjectRequirementController', 'vm', false, retrieve)
            .then(function (answer) {
              var data = {
                subject: obj,
                subjects_requirements: answer
              };
              SubjectService.createSubjectsRequirements(data)
                .then(function () {
                  vm.getSubjectsRequirements(vm.objperiod);
                  $rootScope.show_loader = false;
                });
            });
        });
    };

    /**
     * Informa ao submit se haverá replicação
     * @param info
     */
    vm.onSaveAndContinue = function (info) {
      vm.continue = info;
    };

    /**
     * Informa ao submit se haverá replicação
     * @param info
     */
    vm.onSaveAndAddMore = function (info) {
      vm.add = info;
    };

    vm.setSubject = function () {
      vm.form.subject_period.subject_id = vm.subject.id;
    };

    /**
     * Executa salvamento de uma nova disciplina na grade.
     * @param item - objeto de adição
     * @param form - objeto do form para validação
     */
    vm.submit = function (item, form) {
      if (vm.is_edit) {
        vm.editSubjectPeriod(item, form);
      } else {

        item['continue'] = (vm.continue) ? true : false;
        item['add'] = (vm.add) ? true : false;

        item.subject_id_parent = angular.isDefined(SideExtra.parent) ? SideExtra.parent : null;
        if (form.$valid) {
          item['old_matrix_period'] = vm.objperiod;
          SideExtra.subject = {
            alias: item.alias,
            course_load: item.course_load,
            how_required: item.how_required,
            matrix_id: item.matrix_id,
            matrix_period: item.matrix_period,
            old_matrix_period: item.old_matrix_period,
            name: item.name,
            ord: item.ord
          };
          SubjectService.associateSubjectToPeriod(angular.copy(item))
            .then(function (response) {
              SideExtra.subject.id = response.subject_id;

              vm.close();
              if (item.continue) {
                $timeout(function () {
                  $rootScope.$broadcast('matrix.subject.create.edit', SideExtra);
                  Common.Toast.success('Continue a edição da disciplina vinculada ao ' + SideExtra.subject.matrix_period + 'º período.');
                }, 600);
              } else {
                Common.Toast.success('Disciplina vinculada ao ' + SideExtra.subject.matrix_period + 'º período com sucesso.');
                if (item.add) {
                  $timeout(function () {
                    $rootScope.$broadcast('matrix.subject.create.add', SideExtra);
                    Common.Toast.success('Adicione mais disciplinas ao ' + SideExtra.subject.matrix_period + 'º período.');
                  }, 900);
                } else {
                  $rootScope.$broadcast('matrix.subject.create.edit', false);
                }

              }


            })
            .catch(function (warning) {
              if (angular.isObject(warning.data)) {
                angular.forEach(warning.data, function (value) {
                  switch (value[0]) {
                    case 'SUBJECT_ID_IS_REQUIRED':
                      Common.Toast.warning('Campo disciplina é obrigatório ');
                      break;
                    case 'HOW_REQUIRED_IS_REQUIRED':
                      Common.Toast.warning('Quantidade de caracteres excedido ');
                      break;
                    case 'EVALUATION_MODE_IS_REQUIRED':
                      Common.Toast.warning('Campo Apelido é obrigatório ');
                      break;
                    case 'SHOW_ON_REPORT_IS_REQUIRED':
                      Common.Toast.warning('Campo Apelido é obrigatório ');
                      break;
                  }
                });
              }
            });
        }
      }
      vm.continue = false;
      vm.add = false;
    };

    /**
     * Executa a edição de uma disciplina na grade.
     * @param item - objeto de adição
     * @param form - objeto do form para validação
     */
    vm.editSubjectPeriod = function (item, form) {
      item.old_matrix_period = vm.objperiod;
      var update = angular.copy(item);
      update.subject_id_parent = angular.isDefined(SideExtra.parent) ? SideExtra.parent : null;
      update.subject_id = SideExtra.subject.id;
      delete update.name;
      if (form.$valid) {
        SubjectService.editAssociatedSubjectPeriod(update)
          .then(function () {
            Common.Toast.success('Disciplina atualizada no periodo');
            vm.close();
            $rootScope.$broadcast('matrix.update.period.list', update.matrix_id);
          })
          .catch(function (warning) {
            if (angular.isObject(warning.data)) {
              angular.forEach(warning.data, function (value) {
                switch (value[0]) {
                  case 'SUBJECT_ID_IS_REQUIRED':
                    Common.Toast.warning('Campo disciplina é obrigatório ');
                    break;
                  case 'HOW_REQUIRED_IS_REQUIRED':
                    Common.Toast.warning('Quantidade de caracteres excedido ');
                    break;
                  case 'EVALUATION_MODE_IS_REQUIRED':
                    Common.Toast.warning('Campo Apelido é obrigatório ');
                    break;
                  case 'SHOW_ON_REPORT_IS_REQUIRED':
                    Common.Toast.warning('Campo Apelido é obrigatório ');
                    break;
                }
              });
            }
          });
      }
    };

    /**
     * Fechamento do slide
     */
    vm.close = function () {
      $a4Sidenav().close()
    };


    $scope.$on('$destroy', function () {
      [ltn1, ltn2].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.course.matrix')
    .controller('MatrixSubjectController', MatrixSubjectController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function MatrixService(Restangular) {

    /**
     * Retorna os grades do curso
     */
    var getMatrixOfCourse = function (idCourse) {
      return Restangular.one('matrix').one('getmatrixofcourse').get(idCourse);
    };

    /**
     * Cria uma nova grade
     */
    var getMatrix = function (matrix_id) {
      return Restangular.one('matrix', matrix_id).get();
    };

    /**
     * Cria uma nova grade
     */
    var createMatrix = function (matrix) {
      return Restangular.all('matrix').post({matrix: matrix});
    };

    /**
     * Duplica uma grade
     */
    var duplicateMatrix = function (matrix) {
      return Restangular.one('matrix').all('duplicate').post(matrix);
    };

    /**
     * Atualiza uma grade
     */
    var updateMatrix = function (matrix) {
      return Restangular.one('matrix', matrix.id).customPUT({matrix: matrix});
    };

    /**
     * Remove uma grade
     */
    var deleteMatrix = function (id) {
      return Restangular.one('matrix', id).remove();
    };

    /**
     * Cria uma novo período para a grade
     */
    var createMatrixPeriod = function (idMatrix) {
      return Restangular.all('matrix/creatematrixperiod').post({matrix_id: idMatrix});
    };

    /**
     * Salva a edição de um período
     */
    var editPeriod = function (period) {
      return Restangular.all('matrix/editperiod').post(period);
    };

    /**
     * Retorna os períodos da grade
     */
    var getMatrixPeriod = function (idMatrix) {
      return Restangular.one('matrix').one('getmatrixperiod').get(idMatrix);
    };

    /**
     * Retorna a grade do curso
     */
    var getCourseFields = function (idCourse) {
      return Restangular.one('matrix').one('getcoursefields').get({course_id: idCourse});
    };

    /**
     * Retorna a quantidade de periodos da grade
     */
    var getPeriodsQty = function (matrix_id) {
      return Restangular.one('matrix', matrix_id).one('getperiodsqty').get();
    };

    return {
      getMatrixOfCourse: getMatrixOfCourse,
      createMatrix: createMatrix,
      getMatrix: getMatrix,
      getCourseFields: getCourseFields,
      updateMatrix: updateMatrix,
      deleteMatrix: deleteMatrix,
      createMatrixPeriod: createMatrixPeriod,
      getMatrixPeriod: getMatrixPeriod,
      getPeriodsQty: getPeriodsQty,
      editPeriod: editPeriod,
      duplicateMatrix: duplicateMatrix
    };

  }

  angular
    .module('app.educational.course.matrix')
    .factory('MatrixService', MatrixService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function MatrixPeriodController($a4Sidenav, MatrixService, Common, SideExtra) {

    var vm = this;

    vm.form = {};
    vm.form.matrix_period = {};
    vm.form.mode_edit = false;

    vm.init = function () {
      vm.form.matrix_period = SideExtra.period;
      vm.form.mode_edit = SideExtra.edit;
    };

    /**
     * Realiza fechamento do serviço da sidenav
     */
    vm.close = function () {
      $a4Sidenav().close()
    };

    vm.submit = function (item) {
      MatrixService.editPeriod({period: item})
        .then(function () {
          Common.Toast.success('Período atualizado com sucesso!');
          vm.close();
        })
        .catch(function () {
          Common.Toast.error('Erro ao editar período');
        });
    };

    vm.init();
  }

  angular
    .module('app.educational.course.matrix')
    .controller('MatrixPeriodController', MatrixPeriodController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function MatrixEditController($stateParams, $rootScope, $a4Sidenav, MatrixService, Common, SideExtra, a4Moment) {

    var vm = this;
    vm.disabled_duplicate = false;

    vm.init = function () {
      if (angular.isDefined(SideExtra.duplicate)) {
        vm.disabled_duplicate = true;
      }
      vm.form = {};
      vm.form.matrix = {
        period_qty: 1,
        course_id: $stateParams.id,
        course_equivalence_id: $stateParams.course_equivalence_id
      };
      vm.form.course = {};
      vm.school_period_serie_id = SideExtra.form.matrix.course.school_period_serie_id;
      vm.form.mode_edit = true;
      vm.get();
    };

    /**
     * Realiza fechamento do serviço da sidenav
     */
    vm.close = function () {
      $a4Sidenav().close()
    };

    /**
     * Retorna o objeto da matrix selecionada para edição
     */
    vm.get = function () {
      var matrix_id = SideExtra.matrix_id;
      MatrixService.getMatrix(matrix_id)
        .then(function (response) {
          var matrix = response.plain();
          if (angular.isDefined(SideExtra.form.name) && SideExtra.form.name !== null && matrix.name !== SideExtra.form.name) {
            matrix.name = SideExtra.form.name;
          }
          vm.form.matrix = matrix;

          vm.form.course = {
            course_id: response.plain().course_id,
            course_equivalence_id: response.plain().course_equivalence_id
          };
          vm.has_matrix_period = vm.form.matrix.contract_type === 'U' ? 0 : 1;
          vm.form.matrix.creation_date = vm.form.matrix.creation_date === null ? a4Moment() : vm.form.matrix.creation_date;
        });
      $rootScope.show_loader = false;
    };

    /**
     * Submete a criação e edição da grade
     *
     * @param item
     * @param form
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        vm.form.matrix.contract_type = vm.has_matrix_period === 0 ? 'U' : 'M';
        if (vm.disabled_duplicate) {
          MatrixService.duplicateMatrix(vm.form.matrix)
            .then(function () {
              Common.Toast.success('Grade duplicada com sucesso!');
              $rootScope.$broadcast('update.matrix.list');
              vm.close();
            })
            .catch(function (response) {
              if (angular.isDefined(response.data.message)) {
                Common.Toast.error(response.data.message);
              } else {
                Common.Toast.error('Erro ao duplicar grade');
              }
            })
        } else {
          MatrixService.updateMatrix(vm.form.matrix)
            .then(function () {
              Common.Toast.success('Grade atualizada com sucesso!');
              $rootScope.$broadcast('update.matrix.list');
              vm.close();
            })
            .catch(function (response) {
              if (response.data.message === 'SUBJECT_ALREADY_EXISTS_MATRIX') {
                Common.Toast.error('Existem disciplinas vinculadas a períodos maiores');
              } else {
                Common.Toast.error('Erro ao atualizar grade');
              }
            })
        }
      }
    };


    vm.init();

  }

  angular
    .module('app.educational.course.matrix')
    .controller('MatrixEditController', MatrixEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function MatrixCreateController($stateParams, $scope, $rootScope, $a4Sidenav, SideExtra, MatrixService, Common, moment) {

    var vm = this;
    vm.init = function () {
      vm.form = {};
      vm.has_matrix_period = 0;
      vm.form.matrix = {
        period_qty: 1,
        creation_date: moment()._d,
        course_id: $stateParams.id
      };
      vm.form.mode_edit = true;
      vm.school_period_serie_id = angular.isDefined(SideExtra.form.matrix.course) ? SideExtra.form.matrix.course.school_period_serie_id : 0;
      vm.getCourseField($stateParams.id);
      $rootScope.show_loader = false;
    };

    /**
     * Realiza fechamento do serviço da sidenav
     */
    vm.close = function () {
      $a4Sidenav().close()
    };

    /**
     * Retorna o curso para a criação de uma nova grade
     *
     * @param course_id
     */
    vm.getCourseField = function (course_id) {
      MatrixService.getCourseFields(course_id)
        .then(function (response) {
          vm.form.course = response.plain();
          $rootScope.show_loader = false;
        })
    };

    /**
     * Submete a criação e edição da grade
     *
     * @param item
     * @param form
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        item.contract_type = vm.has_matrix_period === 0 ? 'U' : 'M';
        MatrixService.createMatrix(item, form)
          .then(function () {
            Common.Toast.success('Grade criada com sucesso!');
            $rootScope.$broadcast('update.matrix.list');
            $rootScope.show_loader = false;
            vm.close();
          })
          .catch(function () {
            Common.Toast.error('Erro ao criar grade');
          });
      }
    };


    vm.init();

  }

  angular
    .module('app.educational.course.matrix')
    .controller('MatrixCreateController', MatrixCreateController)
})();
(function () {
    'use strict';

    /** @ngInject */
    function MatrixController($rootScope, $scope, $stateParams, $timeout, $a4Sidenav, MatrixService, ModalFactory,
                              SubjectService, CourseService, Common,ReportsService) {

      var vm = this;

      var ltn1 = $rootScope.$on('update.matrix.list', function () {
        vm.getMatrixOfCourse(vm.course_id);
      });

      var ltn2 = $rootScope.$on('matrix.update.period.list', function (ev, matrix_id) {
        vm.getMatrixPeriod(matrix_id);
      });

      /** Evento para criação de disciplinas de outros modulos */
      var ltn3 = $rootScope.$on('matrix.subject.create', function (ev, subjectName) {
        var sugestions = {name: subjectName};
        vm.createSubject(sugestions);
      });

      /** Evento para continuar a edição da disciplina criada na grade */
      var ltn4 = $rootScope.$on('matrix.subject.create.edit', function (ev, obj) {
        if (obj) vm.editSubject(obj.period, obj.subject, null);
        vm.getMatrixPeriod(vm.form.matrix.id);
      });

      /** Evento para continuar a edição da disciplina criada na grade */
      var ltn5 = $rootScope.$on('matrix.subject.create.add', function (ev, obj) {
        vm.getMatrixPeriod(vm.form.matrix.id);
        $timeout(function () {
          vm.addSubject(obj.period, undefined);
        }, 1000);

      });

      /**
       * Abre o modal de criação de disciplinas
       */
      vm.createSubject = function (sugestions) {

        sugestions = angular.isDefined(sugestions) ? sugestions : {};
        $rootScope.show_loader = false;
        ModalFactory.customClean(
          'app/educational/subject/views/form.html',
          'SubjectCreateController',
          'vm', false, sugestions
        );
      };


      vm.matrix = {};
      vm.course_id = 0;
      vm.selected_matrix = {};

      vm.toggle = false;

      vm.form = {};
      vm.form.matrix = {};
      vm.form.course = {};
      vm.form.mode_edit = false;

      vm.init = function () {
        vm.course_id = parseInt($stateParams.id);
        if (angular.isNumber(vm.course_id)) {
          vm.getMatrixOfCourse(vm.course_id);
          vm.getCourse(vm.course_id);
          $rootScope.show_loader = false;
        }
      };

      /**
       * Retorna a legenda de acordo com o valor passado.
       * @param required
       * @returns {*}
       */
      vm.how_required_text = function (required) {
        switch (required) {
          case 1:
            return 'Obrigatória';
          case 2:
            return 'Optativa';
          case 3:
            return 'Eletiva';
        }
      };

      /**
       * Vincula uma disciplina ao período.
       *
       * @param period
       * @param parent
       */
      vm.addSubject = function (period, parent) {
        CourseService.getById($stateParams.id)
          .then(function (response) {
            vm.form.course = response.plain();
            $rootScope.show_loader = false;
            var is_superior_course = false;
            if (vm.form.course.course_equivalence_id >= 300) {
              is_superior_course = true;
            }
            var item = {
              period: period,
              matrix: vm.form.matrix,
              parent: parent,
              is_superior_course: is_superior_course,
              is_edit: false
            };
            var template;
            if (angular.isDefined(parent)) {
              template = 'app/educational/course/matrix/views/forms/add-sub-subject.html';
            } else {
              template = 'app/educational/course/matrix/views/forms/add-subject.html';
            }
            $a4Sidenav()
              .open(
                template,
                'MatrixSubjectController',
                'vm', item
              );
          });
      };

      /**
       * Retorna o curso para um crição de uma nova grade
       */
      vm.getCourse = function (course_id) {
        CourseService.getById(course_id)
          .then(function (response) {
            vm.form.course = response.plain();
            $rootScope.show_loader = false;
          })
      };

      /**
       * Cria um período da grade.
       */
      vm.createMatrixPeriod = function () {
        ModalFactory.customClean(
          'app/educational/course/matrix/views/forms/create-decision.html',
          'MatrixController',
          'vm', false, {}
        )
          .then(function (response) {
            if (response) {
              vm.form.name = "Cópia de: " + vm.form.matrix.name;
              $a4Sidenav({width: '700px'}).open(
                'app/educational/course/matrix/views/forms/form-matrix.html',
                'MatrixEditController',
                'vm',
                {matrix_id: vm.form.matrix.id, form: vm.form, duplicate: true}
              );
            } else {
              $a4Sidenav({width: '700px'}).open(
                'app/educational/course/matrix/views/forms/form-matrix.html',
                'MatrixCreateController',
                'vm',
                {form: vm.form, course_id: vm.course_id}
              );
            }
          })
      };

      vm.closeModal = function (duplicate) {
        $rootScope.$broadcast('ModalFactory.close', duplicate);
      };

      /**
       * Edita um período da grade.
       */
      vm.editMatrixPeriod = function () {
        $a4Sidenav({width: '700px'}).open(
          'app/educational/course/matrix/views/forms/form-matrix.html',
          'MatrixEditController',
          'vm',
          {matrix_id: vm.form.matrix.id, form: vm.form}
        );
      };

      /**
       * Altera a grade curricular de acordo com a mesma selecionada na lista
       * @param matrix
       */
      vm.changeMatrix = function (matrix) {
        vm.getMatrixPeriod(matrix.id);
        vm.form.matrix = matrix;
      };

      /**
       * Retorna todas as grades de um curso.
       * @param course_id - identificador de um curso.
       */
      vm.getMatrixOfCourse = function (course_id) {
        MatrixService.getMatrixOfCourse({course_id: course_id})
          .then(function (response) {
            vm.matrix = response;
            $rootScope.show_loader = false;
            vm.form.course = response.course;

            angular.forEach(vm.matrix, function (item, index) {
              vm.matrix[index].creation_date = new Date(vm.matrix[index].creation_date);
            });
          })
      };

      /**
       * Resgata todos os periodos de uma grade específica.
       * @param matrix_id - identificador de uma grade.
       */
      vm.getMatrixPeriod = function (matrix_id) {
        MatrixService.getMatrixPeriod({matrix_id: matrix_id, without_groupings: false})
          .then(function (response) {
            vm.selected_matrix.matrix_period = response;

            $rootScope.show_loader = false;
          })
      };

      /**
       * Edita um período específico da grade.
       * @param period
       */
      vm.editPeriod = function (period) {
        $a4Sidenav({width: '700px'}).open(
          'app/educational/course/matrix/views/forms/edit-period.html',
          'MatrixPeriodController',
          'vm',
          {form: vm.form, edit: true, period: period}
        );
      };

      /**
       * Edita uma disciplina no período.
       *
       * @param period
       * @param subject
       * @param parent
       */
      vm.editSubject = function (period, subject, parent) {
        CourseService.getById($stateParams.id)
          .then(function (response) {
            vm.form.course = response.plain();
            $rootScope.show_loader = false;
            var is_superior_course = false;
            if (vm.form.course.course_equivalence_id >= 300) {
              is_superior_course = true;
            }
            var item = {
              period: period,
              subject: subject,
              matrix: vm.form.matrix,
              parent: parent,
              is_superior_course: is_superior_course,
              is_edit: true
            };
            var template;

            if (angular.isDefined(parent) && parent == null) {
              template = 'app/educational/course/matrix/views/forms/add-subject.html';
            } else {
              template = 'app/educational/course/matrix/views/forms/add-sub-subject.html';
            }
            $a4Sidenav()
              .open(
                template,
                'MatrixSubjectController',
                'vm', item
              );
          });
      };

      vm.deleteMatrix = function (matrix_id) {
        ModalFactory.confirm(null,
          'Confirmar exclusão',
          "Deseja realmente excluir a grade?",
          "Confirmar", "Cancelar", "educational")
          .then(function () {
            $rootScope.show_loader = true;
            MatrixService.deleteMatrix(matrix_id)
              .then(function () {
                Common.Toast.success('Grade removida com sucesso!');
                vm.init();
                $rootScope.show_loader = false;
              }).catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.error(error.data.message);
            })
          });
      };

      vm.deleteSubject = function (period, subject, parent, event) {
        event.stopPropagation();
        ModalFactory.confirm(null,
          'Confirmar exclusão',
          "Deseja realmente excluir a disciplina do período?",
          "Confirmar", "Cancelar", "educational")
          .then(function () {
            var obj = {
              subject_id: subject.id,
              matrix_id: period.matrix_id,
              matrix_period: period.matrix_period,
              subject_id_parent: parent == null ? null : parent.id
            };

            SubjectService.deleteSubjectPeriod(obj)
              .then(function () {
                Common.Toast.success('Disciplina removida com sucesso!');
                vm.getMatrixPeriod(vm.selected_matrix.id);
                $rootScope.show_loader = false;
              })
              .catch(function (response) {
                switch (response.data.message) {
                  case 'SUBJECT_HAS_SUB_SUBJECT':
                    Common.Toast.warning('Não é possível excluir uma disciplina agrupadora que contenha sub disciplinas');
                    break;
                  case 'SUBJECT_HAS_ENROLMENT':
                    Common.Toast.warning('Não é possível excluir uma disciplina que tenha alunos matriculados');
                    break;
                  case 'DELETE_ERROR':
                    Common.Toast.error('Erro ao deletar a disciplina');
                    break;
                }
              })
          });
      };

      /**
       * Imprime uma grade de disciplinas
       * @param matrix_id
       */
      vm.printMatrix = function (matrix_id) {
        ReportsService.reportFactory('GET', 'api/reports/printmatrix', {matrix_id: matrix_id,without_groupings: true});
      }

      vm.close = function () {
        $a4Sidenav().close();
      };

      $scope.$on('$destroy', function () {
        [ltn1, ltn2, ltn3, ltn4, ltn5].forEach(function (fn) {
          fn();
        })
      });

      vm.init();
    }

    angular
      .module('app.educational.course.matrix')
      .controller('MatrixController', MatrixController)
  }

)();

(function () {
  'use strict';
  angular
    .module('app.educational.course.group', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function GroupService(Restangular) {

    /**
     * Busca todos as turmas de um curso, com paginação.
     * @param id - Identificador do curso
     * @param obj - Objeto de paginação
     */
    var all = function (id, obj) {
      return Restangular.one('course', id).one('groups').get(obj);
    };

    var getGroupsByCourse =  function (id, obj) {
      return Restangular.one('course', id).one('groups').get(obj);
    };

    var getShiftAndGrade = function (course_id) {
      return Restangular.one('course', course_id).one('shifts').one('grades').one('rules').get();
    };

    var create = function (item) {
      return Restangular.all('groups').post(item);
    };

    var changeMatrix = function (item) {
      return Restangular.one('groups').all('changematrix').post(item);
    };

    var getAllGroups = function (show_inactive) {
      return Restangular.one('groups').one('getall').get(show_inactive);
    };

    return {
      all: all,
      getGroupsByCourse: getGroupsByCourse,
      create: create,
      getShiftAndGrade: getShiftAndGrade,
      getAllGroups: getAllGroups,
      changeMatrix: changeMatrix
    };

  }

  angular
    .module('app.educational.course.group')
    .factory('GroupService', GroupService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function GroupCreateController($stateParams, $rootScope, $scope, $a4Sidenav, Common, GroupService, MatrixService) {
    var vm = this;
    vm.list = {};
    vm.form = {
      group: {
        is_without_school_period: true
      },
      group_period: [{initial_date: null, final_date: null}]
    };
    /** Paramentro para definição de formulário em modo de edição */
    vm.form.mode_edit = true;

    /**
     * Escuta do input select de seleção de grades.
     */
    var ltn = $rootScope.$on('group.change.matrix_id', function (ev, matrix_id) {
      vm.getGroupSchedules(matrix_id);
    });


    vm.init = function () {
      vm.getShiftAndGradeForGroup();
    };

    /**
     * Realiza a chamada para buscar os periodos da matriz
     * @param matrix - identificador da matriz
     */
    vm.getGroupSchedules = function (matrix) {
      $scope.show_loader = true;
      vm.form.group.contract_type = vm.form.group.matrix.contract_type;
      vm.form.group.matrix_id = vm.form.group.matrix.id;
      MatrixService.getPeriodsQty(matrix.id)
        .then(function (qty) {
          $scope.show_loader = false;
          var i = 0;
          vm.form.group.group_period = [{initial_date: null, final_date: null}];
          while (i < (qty - 1)) {
            vm.form.group.group_period.push({initial_date: null, final_date: null});
            i++;
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $scope.show_loader = false;
        })
    };

    /**
     * Executa a requisição para trazer os turnos e as grades para definição da turma.
     */
    vm.getShiftAndGradeForGroup = function () {
      var course_id = $stateParams.id;
      GroupService.getShiftAndGrade(course_id)
        .then(function (response) {
          vm.list.group = {
            matrix_id: response.matrices,
            group_shift_id: response.group_shift,
            grade_rule_id: response.grade_rules
          };
          vm.form.group.is_without_school_period = response.has_school_period_serie;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Criação de nova turma
     * @param item - modelo do formulário
     * @param form - objeto do formulário
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        item.course_id = $stateParams.id;
        GroupService.create(item)
          .then(function () {
            Common.Toast.success('Turma criada com sucesso');
            vm.close();
            $rootScope.$broadcast('group.update.list');
          })
          .catch(function (warning) {
            if (angular.isObject(warning.data)) {
              angular.forEach(warning.data, function (value) {
                switch (value[0]) {
                  case 'NAME_IS_REQUIRED':
                    Common.Toast.warning('Campo nome é obrigatório.');
                    break;
                  case 'MATRIX_ID_IS_REQUIRED':
                    Common.Toast.warning('Por favor selecione uma grade.');
                    break;
                  case 'GROUP_SHIFT_IS_REQUIRED':
                    Common.Toast.warning('Por favor selecione um turno.');
                    break;
                }
              });
            }
          });
      }
    };


    /**
     * Executa o fechamento do slide
     */
    vm.close = function () {
      $a4Sidenav().close();
    };

    /**
     * Evento de destruição do controlador
     */
    $scope.$on("$destroy", function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.course.group')
    .controller('GroupCreateController', GroupCreateController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function GroupController($stateParams, $state, GroupService, GroupsService, $a4FloatButton, $a4Sidenav, $scope,
                           $rootScope) {
    var vm = this;
    vm.grid = {};
    vm.check_show = false;
    vm.is_continuous_group = false;
    vm.is_without_school_period = false;
    vm.show_group_completed = false;
    vm.course_id = $stateParams.id;
    //
    // var ltn = $rootScope.$on('group.update.list', function () {
    //   vm.getAllGroup(1, 20);
    // });

    vm.init = function () {
      /*vm.getAllGroup(1, 20);*/
      vm.course_equivalence_id = $stateParams.course_equivalence_id;
      vm.float_button = $a4FloatButton({
        scope: $scope,
        theme: 'educational',
        onClick: 'vm.create()',
        label: 'Criar nova turma'
      });
    };


    /**
     * Abre o side nav de criação de turmas
     */
    vm.create = function () {
      $a4Sidenav()
        .open(
          'app/educational/course/group/views/add-group.html',
          'GroupCreateController',
          'vm', []
        );
    };


    /**
     * Executa request para trazer todas as turmas do curso
     * @param page - (Opcional) Pagina corrente da paginação
     * @param limit - (Opcional) limite total de registro por paginas
     * @param show_inactive_groups - (Opcional) Mostrar turmas inativas
     */
    vm.getAllGroup = function (page, limit, show_inactive_groups) {
      $rootScope.show_loader = true;
      show_inactive_groups = angular.isDefined(show_inactive_groups) ? show_inactive_groups : false;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;
      /** Recupera todas as turmas de um curso */
      vm.grid.promise = GroupsService.getAll({
        limit: limit,
        page: page,
        course_id: $stateParams.id,
        show_group_completed: vm.show_group_completed
      }).then(function (response) {
        $rootScope.show_loader = false;
        vm.grid = response;
        var ENROLMENT_SYSTEM_EM_TURMA_CONTINUA = 3;
        if (vm.grid.data.length > 0) {
          /** Caso o curso for de turma continua, ele deve chavear os grids */
          if (vm.grid.data[0].school_period_id === 0) {
            vm.check_show = true;
            vm.is_without_school_period = true;
          }
        }
      });
    };

    /**
     * Edição de turmas
     * @param item - item a ser editado
     */
    vm.editGroup = function (item) {
      $state.go('private.educational.groups.edit', {id: item.group_id, matrix_period: item.matrix_period_current});
    };

    vm.init();

    $scope.$on("$destroy", function () {
      if (vm.floatButton !== null) {
        vm.floatButton.destroy();
      }
    })

  }

  angular
    .module('app.educational.course.group')
    .controller('GroupController', GroupController)
})();
(function () {
  'use strict';
  angular
    .module('app.educational.course.documents', []);
    /*.factory('beforeUnload', function ($rootScope, $window) {
      $window.onbeforeunload = function(){
        var confirmation = {};
        var event = $rootScope.$broadcast('onBeforeUnload', confirmation);
        confirmation.message = "Tem certeza que deseja sair da tela sem salvar suas alterações?";
        if (event.defaultPrevented){
          return confirmation.message;
        }
      };
      
      $window.onunload = function () {
        $rootScope.$broadcast('onUnload');
      };
      
      return {};
      
    })
    .run(function (beforeUnload) {

    });*/
})();

(function () {
  'use strict';

  /** @ngInject */
  function CourseDocumentsService(Restangular) {

    /**
     * Busca todos os documentos obrigatórios de um curso, com paginação.
     * @param id - Identificador do documento
     * @param obj - Objeto de paginação
     */
    var getAllDocumentsForCourse = function (id, obj) {
      return Restangular.one('coursedocuments', id).one('coursedocuments').get(obj);
    };

    var getDocumentsForCourse = function (obj) {
      return Restangular.one('coursedocuments').one('getDocumentsForCourse').get(obj);

    }

    var create = function (item) {
      return Restangular.all('coursedocuments').post(item);
    };

    var deleteDocument = function (id, obj) {
      return Restangular.one('coursedocuments', id).remove(obj);
    };

    var updateDocument = function (id, obj) {
      return Restangular.one('coursedocuments', id).customPUT(obj);
    };

    var getDocumentsForStudent = function (obj) {
      return Restangular.one('coursedocuments').one('getdocumentsforstudent').get(obj);
    };

    var saveDocuments = function (obj) {
      return Restangular.one('coursedocuments').all('savedocuments').post(obj);
    };

    var saveDocumentsForStudent = function (obj) {
      return Restangular.one('coursedocuments').all('savedocumentsforstudent').post(obj);
    };

    var saveDocumentFile = function (obj) {
      return Restangular.one('coursedocuments').all('savedocumentfile').post(obj);
    };

    var deleteDocumentFile = function (obj) {
      return Restangular.one('coursedocuments').all('deletedocumentfile').post(obj);
    };

    return {
      create: create,
      deleteDocument: deleteDocument,
      deleteDocumentFile: deleteDocumentFile,
      getDocumentsForCourse: getDocumentsForCourse,
      getDocumentsForStudent: getDocumentsForStudent,
      saveDocuments: saveDocuments,
      saveDocumentsForStudent: saveDocumentsForStudent,
      saveDocumentFile: saveDocumentFile,
      getAllDocumentsForCourse: getAllDocumentsForCourse,
      updateDocument: updateDocument
    };

  }

  angular
    .module('app.educational.course.documents')
    .factory('CourseDocumentsService', CourseDocumentsService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CourseDocumentsController($stateParams, $mdDialog, $window, $interval, $rootScope, $a4FloatButton,
                                     $scope, CourseDocumentsService, Common, ModalFactory) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };
    vm.selected_documents = [];

    vm.buttonIsMandatory = [
      {textButton: 'Exigido', background: '#7cb342', color: 'white', value: 1, height: '25px'},
      {textButton: 'Não exigido', background: '#9e9e9e', color: 'white', value: 2, height: '25px'}
    ];
/*



    $scope.$on('onBeforeUnload', function (e, confirmation) {
      confirmation.message = "Todos os dados serão perdidos";
      e.preventDefault();

    });

    $scope.$on('onUnload', function (e) {

    });


*/


    /**
     * Busca e retorna todos os documentos que podem ser associados a um curso, e os que são associados.
     */
    vm.paginate = function (limit, page) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;
      vm.grid.rows = [];
      vm.grid.promise = CourseDocumentsService.getAllDocumentsForCourse($stateParams.id, {limit: limit, page: page})
        .then(function (response) {
          vm.grid.rows = response.plain();
          vm.selected_documents = [];
          /**
           * Adiciona todos os registros com o campo de course_id preenchido (documentos já associados ao curso)
           * na lista de documentos marcados no checkbox.
           */
          for (var i = 0; i < vm.grid.rows.length; i++) {
            if (vm.grid.rows[i].course_id !== null) {
              vm.selected_documents.push(vm.grid.rows[i]);
              vm.grid.rows[i].enrolment_item_course = true;
            } else {
              vm.grid.rows[i].is_mandatory = false;
              vm.grid.rows[i].enrolment_item_course = false;
            }

            /**
             * Formata campo de is_mandatory para ser utilizado corretamente pelo botão
             */
            if (vm.grid.rows[i].is_mandatory) {
              vm.grid.rows[i].is_mandatory = 1;
            } else {
              vm.grid.rows[i].is_mandatory = 2;
            }
          }

          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        });
    };

    vm.format_selected = function () {
      /**
       * Constantemente percorre a lista de documentos, verificando se algum deles está na lista de documentos marcados.
       * Caso esteja, atualiza o status para que o botão de exigido apareça e possa ser realizada uma atualização
       * nos registros.
       */
      for (var i = 0; i < vm.grid.rows.length; i++) {
        for (var z = 0; z < vm.selected_documents.length; z++) {
          if (vm.selected_documents[z].id === vm.grid.rows[i].id) {
            vm.grid.rows[i].course_id = $stateParams.id;
            vm.grid.rows[i].enrolment_item_course = true;
          }
        }

        if (vm.grid.rows[i].special_type === 1) {
          if (vm.selected_documents.indexOf(vm.grid.rows[i]) === -1) {
            vm.selected_documents.push(vm.grid.rows[i]);
          }
        }

        if (vm.grid.rows[i].special_type !== 1 && (vm.selected_documents.indexOf(vm.grid.rows[i]) === -1)) {
          vm.grid.rows[i].course_id = null;
          vm.grid.rows[i].enrolment_item_course = false;
        }
      }
    };

    /**
     * Cria um novo documento para o curso, obrigatório ou não obrigatório
     */
    vm.create = function () {
      ModalFactory.customClean('app/educational/course/documents/views/modal_create_document.html',
        /** @ngInject */
        function (CourseDocumentsService, $mdDialog, $stateParams) {
          var vm = this;
          vm.form = {};
          vm.submit = function (item) {
            /** Caso o campo de checkbox não tenha sido clicado, é definido para false. */
            if (typeof item.is_mandatory === 'undefined') {
              item.is_mandatory = false;
            }
            CourseDocumentsService.create({
              name: item.name,
              course_id: $stateParams.id,
              is_mandatory: item.is_mandatory
            }).then(function () {
              Common.Toast.success("Documento criado com sucesso");
              $mdDialog.hide(true);
            });
          };
          vm.close = function () {
            $mdDialog.cancel();
          };
        }, 'vm', false, {})
        .then(function () {
          vm.paginate();
        });
    };

    /**
     * Edita o nome e a exigência do documento selecionado.
     * @param item
     */
    vm.editDocument = function (item) {
      ModalFactory.customClean('app/educational/course/documents/views/modal_create_document.html',
        /** @ngInject */
        function (CourseDocumentsService, $mdDialog, $stateParams) {
          var vm = this;
          vm.form = angular.copy(item);
          if (item.is_mandatory === "Exigido") {
            vm.form.is_mandatory = true;
          } else {
            vm.form.is_mandatory = false;
          }
          vm.submit = function (item) {
            /** Caso o campo de checkbox não tenha sido clicado, é definido para false. */
            if (typeof item.is_mandatory === 'undefined') {
              vm.form.is_mandatory = false;
            }
            CourseDocumentsService.updateDocument($stateParams.id, {
              name: vm.form.name,
              is_mandatory: vm.form.is_mandatory,
              enrolment_item_id: item.enrolment_item_id
            }).then(function () {
              Common.Toast.success("Documento alterado com sucesso");
              $mdDialog.hide(true);
            });
          };
          vm.close = function () {
            $mdDialog.cancel();
          };
        }, 'vm', false, {form: item})
        .then(function () {
          vm.paginate();
        });
    };

    /**
     * Deleta um documento
     * @param item
     */
    vm.delete = function (item) {
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Tem certeza que deseja deletar este documento? Outros cursos podem estar utilizando-o.',
        'Confirmar',
        'Cancelar',
        'educational'
      ).then(function () {
        $rootScope.show_loader = true;
        CourseDocumentsService.deleteDocument(item.id, {course_id: $stateParams.id})
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success("Documento deletado com sucesso");
            vm.paginate();
          }).catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data);

        })
      });
    };


    /**
     * Atualiza a lista de documentos do curso, conforme as alterações feitas.
     */
    vm.saveDocuments = function () {
      /**
       * Formata o campo de obrigatório
       */
      for (var i = 0; i < vm.selected_documents.length; i++) {
        if (vm.selected_documents[i].is_mandatory === 1) {
          vm.selected_documents[i].is_mandatory = true;
        } else if (vm.selected_documents[i].is_mandatory === 2) {
          vm.selected_documents[i].is_mandatory = false;
        }
      }
      $rootScope.show_loader = true;
      CourseDocumentsService.saveDocuments({documents: vm.selected_documents, course_id: $stateParams.id})
        .then(function () {
          vm.paginate();
          Common.Toast.success("Documentos do curso atualizados.");
      })
    };


    vm.init = function () {
      /** Menu do float button */
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        theme: 'educational',
        onClick: 'vm.saveDocuments()',
        icon: 'save',
        label: 'Salvar'
      });

      vm.paginate();

    };

    vm.init();

  }

  angular
    .module('app.educational.course.documents')
    .controller('CourseDocumentsController', CourseDocumentsController)
})();

(function () {
  'use strict';

  angular
    .module('app.educational.concept-criteria', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function ConceptCriteriaTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "CONCEPT_CRITERIA": {
                "ADD_GROUP": "Adicionar critério",
                "TITLE": "Critérios de conceito",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Criar critérios",
                "FORM_EDIT": "Editar critério"
            }
        })

    }

    angular
        .module('app.educational.concept-criteria')
        .config(ConceptCriteriaTranslate);
})();

(function(){
  'use strict';

  angular
    .module('app.educational.collaborators', [
      'app.educational.collaborators.documents',
      'app.educational.collaborators.pendencies',
      'app.educational.collaborators.timetable',
      'app.educational.collaborators.classes',
      'app.educational.collaborators.occurrences'
    ]);

})();


(function () {
    'use strict';

    /** @ngInject */
    function CollaboratorsTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "COLLABORATORS": {
                "ADD_COLLABORATORS": "Adicionar Colaborador",
                "TITLE": "Professores e Colaboradores",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Cadastrar colaboradores",
                "FORM_EDIT": "Editar colaborador",
                "DELETE": "Remover colaborador"
            }
        })

    }

    angular
        .module('app.educational.collaborators')
        .config(CollaboratorsTranslate);
})();

(function(){
  'use strict';

  angular
    .module('app.educational.collaborators.timetable', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function TimetableCollaboratorsController($state, CollaboratorsService, moment) {
    var vm = this;

    vm.new = {};
    vm.reserve = {};
    vm.lessons = [];

    vm.init = function () {
      vm.teacherId = $state.params.id;
    };

    /**
     * Retorna as aulas do professor
     */
    vm.getLessons = function (id, start, end) {
      start = angular.isDefined(start) ? start : moment().startOf('week');
      end = angular.isDefined(end) ? end : moment().endOf('week');

      return CollaboratorsService.getLessons({id: id, start: start, end: end});
    };

    vm.init();
  }

  angular
    .module('app.educational.collaborators.timetable')
    .controller('TimetableCollaboratorsController', TimetableCollaboratorsController);

})();

(function(){
  'use strict';

  angular
    .module('app.educational.collaborators.pendencies', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function PendenciesCollaboratorsController($rootScope, $scope, $stateParams, a4Moment, CollaboratorsService) {
    var vm = this;
    vm.personId = $stateParams.id;
    vm.today = a4Moment();
    vm.init = function () {
      vm.getPendentGrades();
    };

    vm.getPendentGrades = function () {
      $rootScope.show_loader = true;
      CollaboratorsService.getPendentGradesByTeacher({person_id: vm.personId}).then(function (response) {
        vm.pendentGrades = response.plain();
        $scope.$applyAsync();
        $rootScope.show_loader = false;
      })
    };

    vm.init();
  }

  angular
    .module('app.educational.collaborators.pendencies')
    .controller('PendenciesCollaboratorsController', PendenciesCollaboratorsController)
})();

(function (){
  'use strict';

  angular
    .module('app.educational.collaborators.occurrences', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function OccurrencesUpdateCollaboratorsController(a4Moment, PoliciesService, EventsService, moment, ModalExtra, $rootScope, Common, StudentsService) {

    var vm = this;

    vm.form = {
      event: {},
      mode_edit: true
    };

    vm.list = {
      event: {}
    };

    vm.init = function () {
      vm.getListValuesForEvents();
      vm.form.occurrence = {};
      vm.form.occurrence.id = ModalExtra.form.id;
      vm.today = a4Moment();
      console.log(vm.form)
    };

    /**
     * Pega as listas de valores para a criação da ocorrência
     */
    vm.getListValuesForEvents = function () {
      EventsService.getListValuesForEvents()
        .then(function (resp) {
          vm.list.event = resp;
          vm.form.event.id = ModalExtra.form.id;
          vm.form.event.date_done = moment(angular.copy(ModalExtra.form.occurrence_date));
          vm.form.event.event_type_id = ModalExtra.form.event_type_id;
          vm.form.event.notes_done = ModalExtra.form.notes_done;
          vm.form.event.is_confidencial = ModalExtra.form.is_confidencial;
          vm.form.event.is_to_publish = ModalExtra.form.is_to_publish;
        })
    };

    /**
     * Edição da ocorrência
     * @param item - dados da ocorrência
     * @param form - dados do form
     */
    vm.submit = function (item, form) {

      item.person_id = ModalExtra.person_id;
      if (form.$valid) {
          item.id = ModalExtra.form.id;
          item.is_to_publish = vm.form.event.is_to_publish;
          item.is_confidencial = vm.form.event.is_confidencial;
          EventsService.updateEvent(item).then(function () {
            $rootScope.$broadcast('collaborators.occurrences.list.update');
            Common.Toast.success('Ocorrência editada com sucesso.');
            vm.close();
          })
      }
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /**
     * Desmarca o botão de Publicar, caso o checkbox de 'Confidencial' esteja marcado
     */
    vm.disableToPublish = function () {
      if (vm.form.event.is_confidencial){
        vm.form.event.is_to_publish = 0;
      }
    };

    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular
    .module('app.educational.collaborators.occurrences')
    .controller('OccurrencesUpdateCollaboratorsController', OccurrencesUpdateCollaboratorsController)
})();

(function () {
  'use strict';

  /** @ngInject*/
  function OccurrencesCreateCollaboratorsController(PoliciesService, EventsService, a4Moment, ModalExtra, $rootScope, Common) {

    var vm = this;

    vm.form = {
      event: {
        is_confidencial: false,
        is_to_publish: false
      },
      mode_edit: true
    };

    vm.list = {
      event: {}
    };

    vm.init = function () {
      vm.getListValuesForEvents();
      vm.today = a4Moment();
      vm.form.event.date_done = a4Moment()._d;
    };

    /** Pega as listas de valores para a criação da acorrência */
    vm.getListValuesForEvents = function () {
      EventsService.getListValuesForEvents()
        .then(function (resp) {
          vm.list.event = resp;
          vm.form.event.show_type = true;
        })
    };

    /** Desmarca o botão de Publicar, caso o checkbox de 'Confidencial' esteja marcado */
    vm.disableToPublish = function () {
      if (vm.form.event.is_confidencial) {
        vm.form.event.is_to_publish = 0;
      }
    };

    /**
     * Salvamento da ocorrência
     * @param item - dados da ocorrência
     * @param form - dados do form
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        vm.loading = true;
        item.person_id = parseInt(ModalExtra.person_id);
        EventsService.saveEvents(item)
          .then(function () {
            vm.loading = false;
            $rootScope.$broadcast('collaborator.occurrences.list.update');
            Common.Toast.success('Ocorrência adicionada com sucesso');
            vm.close();
          })
          .catch(function () {
            vm.loading = false;
            Common.Toast.error('Ocorreu um erro na criação da ocorrência');
          })
      }
    };

    /** Fecha o modal */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    }

    /**
     * Verifica políticas de acesso
     * @param policy - Identificador da política de acesso
     *@returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular
    .module('app.educational.collaborators.occurrences')
    .controller('OccurrencesCreateCollaboratorsController', OccurrencesCreateCollaboratorsController)
})();

(function (){
  'use strict'

  /** @ngInject */
  function OccurrencesCollaboratorsController (PoliciesService, $state, Common, CollaboratorsService, a4Moment, $a4FloatButton,
                                              $scope, ModalFactory, $rootScope) {
    var vm = this

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.occurrence_types = [];
    vm.occurrence_type = null;

    /** Atualiza a lista de ocorrências */
    var ltn = $rootScope.$on('collaborators.occurrences.list.update', function () {
      vm.getCollaboratorOccurrences();
    });

    vm.init = function () {
      vm.collaborator_id = $state.params.id
      vm.getCollaboratorOccurrences();
      vm.getOccurrenceTypes();
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.createOccurrence()',
        label: 'Adicionar ocorrência'
      });
    };

    /** Resgata as ocorrências do responsável */
    vm.getCollaboratorOccurrences = function (page, limit) {
      page = angular.isDefined(page) ? page : 1;
      limit = angular.isDefined(limit) ? limit : 20;
      vm.promise = CollaboratorsService.getCollaboratorOccurrences({
        collaborator_id: vm.collaborator_id,
        page: page,
        limit: limit,
        occurrence_type_id: vm.occurrence_type
      })
        .then(function (response) {
          vm.grid.data = response[0].data;
          vm.grid.last_page = response[0].last_page;
          vm.grid.current_page = response[0].current_page;
          vm.grid.total = response[0].total;
          vm.grid.per_page = response[0].per_page;
          vm.grid.name = response[1][0].name;
        })
    }

    /** Abre o modal de criação de ocorrências */
    vm.createOccurrence = function () {
      ModalFactory.customClean(
        'app/educational/collaborators/occurrences/views/create.html',
        'OccurrencesCreateCollaboratorsController',
        'vm', false, {person_id: $state.params.id}
      ).then((function () {
        vm.getCollaboratorOccurrences();
      }));
    }

    /**
     * Abre o modal para edição de ocorrência
     * @param item
     */
    vm.editOccurrence = function (item) {
      if (item.is_confidencial) {
        $rootScope.show_loader = true;
        CollaboratorsService.decryptOccurrence(item.occurrence_id).then(function (occurrence) {
          item.notes_done = occurrence;
          item.id = item.occurrence_id;
          item.event_type_id = item.type_id;
          if (angular.isDefined(item.is_confidencial) && item.is_confidencial === true) {
            item.is_to_publish = false;
          } else {
            item.is_to_publish = true;
          }
          $rootScope.show_loader = false
          vm.openEditModal(item);
        }).catch(function (error) {
          Common.Toast.error(error.message || error.data.message);
          $rootScope.show_loader = false;
        })
      } else {
        item.notes_done = item.occurrence_name;
        item.id = item.occurrence_id;
        item.event_type_id = item.type_id;
        if (angular.isDefined(item.is_confidencial) && item.is_confidencial === true) {
          item.is_to_publish = false;
        } else {
          item.is_to_publish = true;
        }
        vm.openEditModal(item);
      }
    };

    vm.openEditModal = function (item) {
      ModalFactory.customClean(
        'app/educational/collaborators/occurrences/views/create.html',
        'OccurrencesUpdateCollaboratorsController',
        'vm', false, {form: item, person_id: $state.params.id}
      );
    };


    vm.getOccurrenceTypes = function () {
      CollaboratorsService.getOccurrenceTypes().then(function (response) {
        vm.occurrence_types = response.plain();
      })
    }

    /**
     * Excluir ocorrência
     * @param item
     */
    vm.delete = function (item) {
      ModalFactory.confirm(null, 'Excluir ocorrência', 'Deseja realmente excluir esta ocorrência?',
        'Excluir', 'Cancelar', 'educational').then(function () {
          CollaboratorsService.deleteCollaboratorOccurrence(item).then(function () {
            vm.getCollaboratorOccurrences();
            Common.Toast.success('Ocorrência excluída com sucesso!');
          }).catch(function () {
            Common.Toast.error('Algo deu errado na exclusão da ocorrência.');
            $rootScope.show_loader = false;
          })
      })
    }

    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.collaborators.occurrences')
    .controller('OccurrencesCollaboratorsController', OccurrencesCollaboratorsController)
})();

(function(){
  'use strict';

  angular
    .module('app.educational.collaborators.documents', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DocumentsCollaboratorsController($state) {
    var vm = this;
    vm.person_id = $state.params.id;

    vm.init = function () {
    }

    vm.init();
  }

  angular
    .module('app.educational.collaborators.documents')
    .controller('DocumentsCollaboratorsController', DocumentsCollaboratorsController)
})();

(function(){
  'use strict';

  angular
    .module('app.educational.collaborators.classes', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassesCollaboratorsController($rootScope, $state, $document, a4Moment, CONFIG, ReportsService, Session, ClassesService, PoliciesService, Common) {

    var vm = this;
    vm.grid = {};
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.filter_date_lesson = {
      startDate: a4Moment().startOf('year').format('YYYY-MM-DD'),
      endDate: a4Moment().endOf('year').format('YYYY-MM-DD')
    };
    vm.school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.init = function () {
      vm.teacherID = $state.params.id;
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.getAllClasses();
    };

    vm.printHoursLessons = function () {
      return ReportsService.reportFactory('GET', 'api/reports/hourslessonsreport', {
        teacher_id: vm.teacherID
      });
    };

    vm.printLessons = function (is_detailed) {
      var href = vm.webLink + 'api/reports/lessonsreport?token=' + vm.conf.token + '&company=' + vm.conf.current_company +
        '&current_school_period=' + vm.school_period
        + '&connection=' + vm.conf.current_connection + '&teacher_id=' + vm.teacherID + '&is_detailed=' + is_detailed;
      if (vm.filter_date_lesson !== null) {
        href += '&startDate=' + vm.filter_date_lesson.startDate + '&endDate=' + vm.filter_date_lesson.endDate;
      }
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    /**
     * Listagem de classes
     */
    vm.getAllClasses = function () {
      $rootScope.show_loader = true;
      ClassesService.getClassByTeacher({teacher_id: vm.teacherID})
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.grid.rows = response.plain();
        })
        .catch(function (response) {
          $rootScope.show_loader = false;
          Common.Toast.error(response.data.message);
        })
    };

    /**
     * Vai para a página de visualização da classe
     * @param item
     */
    vm.viewClass = function (item) {
      $state.go('private.educational.classes.show', {
        group_id: item.id, matrix_period: item.matrix_period,
        subject_id: item.subject_id
      });
    };


    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };
    vm.init();
  }

  angular
    .module('app.educational.collaborators.classes')
    .controller('ClassesCollaboratorsController', ClassesCollaboratorsController)
})();
(function(){
  'use strict';

  angular
    .module('app.educational.classes.yield-graph', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function YieldGraphClassesController(ClassesService, $stateParams) {
    var vm = this;

    /** Parametros de state */
    vm.params = {
      id: $stateParams.group_id,
      subject_id: $stateParams.subject_id,
      matrix_period: $stateParams.matrix_period
    };

    vm.chart = {};

    vm.chart.series = ['Maior nota', 'Média aritmética', 'Menor nota'];
    vm.chart.colors = ["#018c03",
      "#226f9a",
      "#9a4c00"];
    vm.chart.data = [];

    vm.init = function () {
      ClassesService.getDataForYeldGraph(vm.params)
        .then(function (res) {
          var data = res.plain();
          vm.chart.data[0] = data.max;
          vm.chart.data[1] = data.avg;
          vm.chart.data[2] = data.min;
          vm.chart.labels = data.labels;
        });
    };


    vm.init();
  }

  angular
    .module('app.educational.classes.yield-graph')
    .controller('YieldGraphClassesController', YieldGraphClassesController)
})();
(function(){
  'use strict';

  angular
    .module('app.educational.classes', [
      'app.educational.classes.classrooms',
      'app.educational.classes.students',
      'app.educational.classes.grades',
      'app.educational.classes.yield-graph',
      'app.educational.classes.notes-release',
      'app.educational.classes.notes-pending'
    ]);

})();

(function () {
    'use strict';

    /** @ngInject */
    function ClassesTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "CLASSES": {
                "TITLE": "Classes",
                "SEARCH_FOR_ANYONE": "Pesquisar"
            }
        })

    }

    angular
        .module('app.educational.classes')
        .config(ClassesTranslate);
})();

(function(){
  'use strict';

  angular
    .module('app.educational.classes.students', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function StudentsClassesController($rootScope, $stateParams, ClassesService, ModalFactory) {
    var vm = this;

    vm.grid = {
      rows: []
    };
    vm.students = [];

    /** Parametros de state */
    vm.params = {
      id: $stateParams.group_id,
      subject_id: $stateParams.subject_id,
      matrix_period: $stateParams.matrix_period
    };

    vm.init = function () {
      $rootScope.show_loader = true;
      vm.getStudents(vm.params);
      $rootScope.show_loader = false;
    };

    vm.getStudents = function (classe) {
      ClassesService.getStudentsForClass({
        classe: classe
      })
        .then(function (response) {
          vm.grid.rows = response.plain();
          vm.students = response.plain();
          $rootScope.show_loader = false;
        })
    };

    /** Abre o modal de criação de ocorrência */
    vm.createOccurrence = function (person_id) {
      ModalFactory.customClean(
        'app/educational/students/occurrences/views/create.html',
        'OccurrencesCreateStudentsController',
        'vm', false, {person_id: person_id}
      ).then((function () {
        vm.getStudentOccurrences();
      }));
    };

    vm.init();
  }

  angular
    .module('app.educational.classes.students')
    .controller('StudentsClassesController', StudentsClassesController)
})();
(function(){
  'use strict';

  angular
    .module('app.educational.classes.notes-release', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function NotesReleaseClassesController() {
    var vm = this;

    vm.init = function () {

    };


    vm.init();
  }

  angular
    .module('app.educational.classes.notes-release')
    .controller('NotesReleaseClassesController', NotesReleaseClassesController)
})();
(function(){
  'use strict';

  angular
    .module('app.educational.classes.notes-pending', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function NotesPendingClassesController($stateParams, $rootScope, ClassesService) {
    var vm = this;
    vm.groupId = $stateParams.group_id;
    vm.subjectId = $stateParams.subject_id;
    vm.matrixPeriod = $stateParams.matrix_period;

    vm.getPendingGrades = function () {
      $rootScope.show_loader = true;
      ClassesService.getPendingGradesByClass({
        group_id: vm.groupId,
        subject_id: vm.subjectId,
        matrix_period: vm.matrixPeriod
      }).then(function (response) {
        vm.pendentGrades = response.plain();
        $rootScope.show_loader = false;
      })
    };

    vm.init = function () {
      vm.getPendingGrades();
    };


    vm.init();
  }

  angular
    .module('app.educational.classes.notes-pending')
    .controller('NotesPendingClassesController', NotesPendingClassesController)
})();
(function(){
  'use strict';

  angular
    .module('app.educational.classes.grades', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function GradesClassesController($state, $rootScope, $scope, $timeout, Common, NoteReleaseService,
                                   ReportsService, $document, CONFIG, Session) {
    var vm = this;

    /** DEFINIÇÃO DE VARIAVEIS */
    vm.grid = {rows: [], info: {}};
    vm.floatButton = null;
    vm.subjects = [];
    vm.groups = [];
    vm.event_selected = false;
    vm.selectAllEvent = false;
    vm.listStudents = [];
    vm.listStudentsSelected = null;
    vm.buttons = {
      submit: true,
      group: false,
      allowGroup: false
    };
    vm.is_detailed = false;
    vm.windowHeight = angular.element("#content").height() - 240;
    vm.isNumber = angular.isNumber;
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    /** Verifica a mudança do checkbox */
    var ltn = $rootScope.$on('CHANGE_IS_DETAILED', function (ev, is_detailed) {
      vm.is_detailed = is_detailed;
      /** Ajuste da altura da tabela */
      if (is_detailed) {
        vm.windowHeight = angular.element("#content").height() - 296;
      } else {
        vm.windowHeight = angular.element("#content").height() - 240;
      }
    });

    /** Verifica o botão de impressão */
    var ltn1 = $rootScope.$on('PRINT_NOTES', function () {
      vm.printNotes();
    });

    /**
     * Metódo de iniciação do controlador
     */
    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      $rootScope.show_loader = true;
      vm.getStudentsBySubjectGroup($state.params.subject_id, $state.params.group_id);
    };

    /**
     * Seleciona ou não todos os eventos
     */
    vm.selectAllEvents = function () {
      vm.event_selected = [];
      angular.forEach(vm.grid.grades, function (event) {
        vm.event_selected.push(event.name)
      });
      vm.selectAllEvent = true;
    };

    /**
     * Reajusta as Etapas de acordo com os eventos.
     */
    vm.alignSteps = function (filteredList) {
      vm.grid.steps =
        /** Iteração na lista das ETAPAS */
        vm.grid.steps.filter(function (value) {
          var count = 0;
          /** Iteração na lista dos items escolhidos pelo usuário */
          filteredList.forEach(function (item) {
            /**
             * Executa uma verificação em cada item escolhido pelo usuário, e realiza um contador,
             * se o ID do filho for igual a o id de uma ETAPA, então o contador é incrementado.
             */
            if (value.id === item.grade_rule_item_id_parent) {
              count++;
            }

          });
          /** Caso não exista filhos de uma ETAPA, então a ETAPA deve ser escondida */
          value.show = count !== 0;
          value.siblingsqtd = count;
          return value;
        })

    };

    /**
     * Traz os textos de bloqueio.
     * @param code - Codigo do bloqueio.
     * @returns {*}
     */
    vm.getBlocks = function (code) {
      return NoteReleaseService.getReasons(code);
    };


    /**
     * Exibe a coluna da tabela disponibilizada no filtro de eventos
     * @param id
     */
    vm.showColum = function (id) {
      if (vm.event_selected !== null) {
        return vm.event_selected.indexOf(id) !== -1;
      }
    };

    /**
     * Retorna o valor desejado das definições da grade
     * @param id
     * @param field - campo desejado
     */
    vm.getValue = function (id, field) {
      var index = vm.grid.grades.indexOf(vm.grid.grades.filter(function (i) {
          return (i.name === id && i.type !== 'A')
        })[0]
      );

      if (index >= 0) {
        return vm.grid.grades[index][field];
      }
    };

    /**
     * Envia o foco para o primeiro campo
     */
    vm.goToFirstField = function () {
      $timeout(function () {
        angular.element('tbody tr:first-child td:nth-child(3) input').trigger('focus');
      }, 300);
    };

    /**
     * Formata o valor não conceitual da nota para que seja decimal
     * @param value
     * @param maxValue
     * @returns {string}
     */
    vm.formatNote = function (value, maxValue) {
      var new_value = parseFloat(parseFloat(value).toFixed(2));
      var new_maxValue = parseFloat(parseFloat(maxValue).toFixed(2));
      if (!angular.isString(new_value)) {
        if (parseFloat(parseFloat(new_value).toFixed(2)) > parseFloat(parseFloat(new_maxValue).toFixed(2))) {
          Common.Toast.warning('Valor máximo permitido: ' + maxValue);
        }
      }
    };

    vm.printNotes = function () {
      ReportsService.reportFactory('GET',
        'api/reports/printclassnotes',
        {
          company: vm.conf.current_company,
          connection: vm.conf.current_connection,
          user_id: vm.conf.user_id,
          group_id: $state.params.group_id,
          subject_id: $state.params.subject_id,
          matrix_period: $state.params.matrix_period,
          getCalculated: true,
          is_detailed: true,
          current_school_period: vm.conf.current_school_period
        })

      /*var href = vm.webLink + 'api/reports/printclassnotes?token=' + vm.conf.token + '&company=' + vm.conf.current_company
        + '&connection=' + vm.conf.current_connection + '&user_id=' + vm.conf.user_id + '&group_id=' + $state.params.group_id +
        '&subject_id=' + $state.params.subject_id + '&matrix_period=' + $state.params.matrix_period + '&getCalculated=' + true
       + '&is_detailed=' + vm.is_detailed + '&current_school_period=' + vm.conf.current_school_period;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();*/
    };

    /**
     * Retorna os estudantes pela turma e disciplina
     * @returns array
     */
    vm.getStudentsBySubjectGroup = function (subject, group) {
      NoteReleaseService.getStudentsBySubjectGroup({subject_id: subject, group_id: group, getCalculated: true})
        .then(function (response) {
          response = response.plain();
          vm.grid.students = response.students;
          vm.grid.grades = response.grades;
          vm.grid.steps = response.steps;
          vm.selectAllEvents();
          $rootScope.show_loader = false;
        });
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (t) {
        t()
      })
    });


    vm.init();
  }

  angular
    .module('app.educational.classes.grades')
    .controller('GradesClassesController', GradesClassesController)
})();

(function(){
  'use strict';

  angular
    .module('app.educational.classes.classrooms', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function LessonPlanClassEditController($scope, $state, $rootScope, $document,$window, Common, LocalStorage ,
                                         ClassReleaseService, ModalExtra, DropzoneService, CONFIG) {
    var vm = this;
    vm.isEdit = true;
    vm.disable = false;
    vm.lesson = {};
    vm.lesson.files = [];
    vm.CONFIG = CONFIG;
    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");
    vm.adicionarNovoLink=false;
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/classes/uploadfiles?company=' + company + '&connection=' + connection,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'GIF', 'XLS', 'XLSX', 'PPT', 'PPTX', 'ZIP', 'MP3', 'MP4', 'WMV', 'AVI']),
      uploadMultiple: true,
      parallelUploads: 10,
      maxFiles: 5,
      autoProcessQueue: true
    };

    vm.init = function () {
      $rootScope.show_loader = false;
      vm.getInfoForm();
      vm.lesson = ModalExtra;
      /** Verifica se a Lesson possui arquivos. Se não possuir, declara o atributo */
      if (typeof vm.lesson.files == 'undefined') {
        vm.lesson.files = [];
      }
    };

    /**
     * Retorna as informações para o formulário de criação
     */
    vm.getInfoForm = function () {
      ClassReleaseService.getLessonTypes()
        .then(function (response) {
          vm.getFiles(vm.lesson.lesson_id);
          vm.types_list = response.plain();
        })
    };

    vm.getFiles = function (id) {
      ClassReleaseService.getLessonArtifact(id).then(function (files) {
        vm.lesson.files = files;
      });
    };

    /** Edição de um plano de aula */
    vm.submit = function (lesson) {
      vm.disable = true;
      if (lesson.lesson_id !== null) {
        ClassReleaseService.updateLesson(lesson)
          .then(function () {
            vm.closeModal();
            Common.Toast.success("Plano editado com sucesso!");
          })
      } else {
        lesson.is_update = true;
        ClassReleaseService.createLessonPlan(lesson)
          .then(function () {
            vm.closeModal();
            Common.Toast.success("Plano inserido com sucesso!");
          })
      }
    };

    /**
     * Mostra campo para adicionar link e cria novo objeto
     * */
    vm.addNewLink = function () {
      vm.adicionarNovoLink=true;
      vm.novoLink = {type: 'link',file_reference:"",name:"",notes:""};
    };

    /**
     * Adiciona a lista de arquivos o novo link
     * */
    vm.salvarLink=function (){
      if(vm.novoLink.name!="" && vm.novoLink.file_reference!="" ){
        vm.lesson.files.splice(0,0,vm.novoLink);
      }
      vm.adicionarNovoLink=false;
    }

    vm.openUrl = function (url, type) {
      if (type == null) {
        var pattern = /(http(s)?)/gi;
        if (!pattern.exec(url)) {
          url = 'http://' + url;
        }
        $window.open(url);
      } else {
        $window.open(CONFIG.webApiUri + url);
      }
    };

    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'successmultiple': function (file, xhr) {
        if (xhr) {
          angular.forEach(xhr, function (item) {
            vm.lesson.files.splice(0, 0, item);
          });
        }
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.submitOnlyFile = function (lesson, artefacts) {
      var files = [];
      angular.forEach(artefacts, function (item) {
        /** Verifica se há alguma atualização do arquivo */
        if (item.file) {
          item.file_reference = item.file;
        }
        files.push(item);
      });

      /** Envia os arquivos */
      lesson.files = files;
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };


    vm.init();
  }

  angular
    .module('app.educational.classes.classrooms')
    .controller('LessonPlanClassEditController', LessonPlanClassEditController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function LessonPlanClassCreateController($scope, $state, $rootScope,$window, Common, LocalStorage, $document,
                                           ClassReleaseService, ModalExtra, DropzoneService, CONFIG) {
    var vm = this;
    vm.isEdit = false;
    vm.lesson = {};
    vm.lesson.files = [];
    vm.CONFIG = CONFIG;
    vm.disable = false;
    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");
    vm.adicionarNovoLink=false;
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/classes/uploadfiles?company=' + company + '&connection=' + connection,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'GIF', 'XLS', 'XLSX', 'PPT', 'PPTX', 'ZIP', 'MP3', 'MP4', 'WMV', 'AVI']),
      uploadMultiple: true,
      parallelUploads: 10,
      maxFiles: 5,
      autoProcessQueue: true
    };

    vm.init = function () {
      $rootScope.show_loader = false;
      vm.getInfoForm();
      vm.lesson = ModalExtra;
      /** Verifica se a Lesson possui arquivos. Se não possuir, declara o atributo */
      if (typeof vm.lesson.files == 'undefined'){
        vm.lesson.files = [];
      }
    };

    /**
     * Retorna as informações para o formulário de criação
     */
    vm.getInfoForm = function () {
      ClassReleaseService.getLessonTypes()
        .then(function (response) {
          vm.types_list = response.plain();
        })
    };

    /** Criação de uma aula no plano */
    vm.submit = function (lesson) {
      vm.disable = true;
      ClassReleaseService.createLessonPlan(lesson)
        .then(function () {
          vm.closeModal();
          Common.Toast.success("Plano inserido com sucesso!");
        })
    };

    /**
     * Mostra campo para adicionar link e cria novo objeto
     * */
    vm.addNewLink = function () {
      vm.adicionarNovoLink=true;
      vm.novoLink = {type: 'link',file_reference:"",name:"",notes:""};
    };

    /**
     * Adiciona a lista de arquivos o novo link
     * */
    vm.salvarLink=function (){
      if(vm.novoLink.name!="" && vm.novoLink.file_reference!=""){
        vm.lesson.files.splice(0,0,vm.novoLink);
      }
      vm.adicionarNovoLink=false;
    }

    vm.openUrl = function (url, type) {
      if (type == null) {
        var pattern = /(http(s)?)/gi;
        if (!pattern.exec(url)) {
          url = 'http://' + url;
        }
        $window.open(url);
      } else {
        $window.open(CONFIG.webApiUri + url);
      }
    };
    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'addedfile': function (file) {
        DropzoneService.getBase64(file)
          .then(function (base64) {
            vm.lesson.files.push({name: file.name, base64: base64, size: file.size});
          });
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close', vm.addAnother);
    };


    vm.init();
  }

  angular
    .module('app.educational.classes.classrooms')
    .controller('LessonPlanClassCreateController', LessonPlanClassCreateController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function LessonArtefactController($rootScope, $document, $window, $timeout, Common, ModalFactory,
                                    ModalExtra, ClassReleaseService, DropzoneService, LocalStorage, CONFIG) {
    var vm = this;
    vm.artefacts = [];
    vm.btnMultipleFiles = false;
    vm.lesson = {};
    vm.selectedItem = {};
    vm.originalItem = {};
    vm.can_edit = true;
    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");
    vm.isArtefactSelected = false;
    /**
     * Define as configurações para o upload
     */
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/classes/uploadfiles?company=' + company + '&connection=' + connection + '&lesson=' + ModalExtra.id,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'GIF', 'XLS', 'XLSX', 'PPT', 'PPTX', 'ZIP', 'MP3', 'MP4', 'WMV', 'AVI']),
      uploadMultiple: true,
      parallelUploads: 10,
      maxFiles: 10,
      autoProcessQueue: true
    };


    /** Inicialização de variaveis */
    vm.init = function () {
      vm.lesson = ModalExtra;
      vm.artefacts = vm.lesson.artefacts;
      /** Se puder editar */
      if (angular.isDefined(vm.lesson.can_edit)) {
        vm.can_edit = vm.lesson.can_edit;
      }
    };

    /**
     * Pega os links e downloads da lição
     * @param item
     */
    vm.getLessonsArtifacts = function (item) {
      var lesson_id = (angular.isDefined(item.lesson_id)) ? item.lesson_id : item.id;
      ClassReleaseService.getLessonsArtifacts(lesson_id)
        .then(function (response) {
          item.links = response.links;
          item.files = response.files;

          angular.forEach(item.links, function (item) {
            item.type = 'link';
            vm.artefacts.push(item);
          });

          angular.forEach(item.files, function (item) {
            item.type = 'file';
            vm.artefacts.push(item);
          });

        })
    };

    /**
     * Adiciona um novo link
     */
    vm.addNewLink = function () {
      vm.artefacts.splice(0, 0, {type: 'link', form_view: true, lesson_id: vm.lesson.id});
    };

      vm.submitOnlyLink = function (index, artifact) {
      vm.artefacts[index].form_view = false
      vm.link = [];
      vm.link.push(artifact);
      ClassReleaseService.saveFiles({id: vm.lesson.id, files: vm.link})
        .then(function(response) {
          vm.artefacts[index].form_view = false

        })
    };

    /**
     * Realiza o fechamento do anexo
     * @param item
     */
    vm.closeArtefact = function (item) {
      /**verificação se o item foi criado novo e não salvo*/
      if (angular.isUndefined(item.id) && item.type === 'link' && !item.isSalved) {
        var index = vm.artefacts.indexOf(item);
        vm.artefacts.splice(index, 1);
      } else {
        item.form_view = false;
        // /** Restaura itens do objeto não salvo */
        // item.file_reference = vm.originalItem.file_reference;
        // item.name = vm.originalItem.name;
        // item.notes = vm.originalItem.notes;
      }
      vm.isArtefactSelected=false;
    };

    /**
     * Botão de upload de arquivos
     */
    vm.sendMultipleFiles = function () {
      vm.btnMultipleFiles = true;
      /** TODO - CRIAR SERVIÇO PARA DROPZONE */
      DropzoneService.forElement(".dropzone").processQueue();
    };

    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'successmultiple': function (file, xhr) {
        if (xhr) {
          angular.forEach(xhr, function (item) {
            vm.artefacts.splice(0, 0, item);
          });
        }
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };
    /** Dropzone */

    /**
     * Seleciona o anexo para edição
     * @param item
     */
    vm.selectItem = function (item) {
      if(vm.isArtefactSelected){
        vm.closeArtefact(vm.artefacts[vm.selectedItem]);
      }
      // vm.originalItem = angular.copy(item);
      vm.selectedItem = vm.artefacts.indexOf(item);
      vm.artefacts[vm.selectedItem].form_view = true;
      vm.isArtefactSelected=true;
    };

    /**
     * Remove o anexo
     * @param ev
     * @param item
     */
    vm.removeItem = function (ev, item) {
      var index = vm.artefacts.indexOf(item);
      var msg;

      if (item.type === 'link') {
        msg = 'Deseja confirmar a exclusão do link: ' + item.name;
      } else {
        msg = 'Deseja confirmar a exclusão do arquivo: ' + item.name;
      }
      /** Modal de confirmação */
      ModalFactory.confirm(ev, 'Remoção de anexos', msg, 'Confirmar', 'Cancelar')
          .then(function () {
              vm.artefacts.splice(index, 1);
              vm.submit({}, vm.lesson, vm.artefacts, false, true);
              Common.Toast.warning('Removendo anexo...');
            })
        .catch(function () {
        $rootScope.$broadcast("artefact.remove", vm.lesson);
        Common.Toast.warning('Cancelado');
      });
    };

    /**
     * Abre o anexo
     * @param url
     * @param type
     */
    vm.openUrl = function (url, type) {
      if (type == null) {
        var pattern = /(http(s)?)/gi;
        if (!pattern.exec(url)) {
          url = 'http://' + url;
        }
        $window.open(url);
      } else {
        $window.open(CONFIG.webApiUri  + url);
      }
    };

    /**
     * Submete os links da referida lição
     * @param form
     * @param lesson
     * @param artefacts
     * @param artefact
     * @param modal
     * @param file
     */
    vm.submit = function (form, lesson, artefacts, artefact, modal, file) {
      var links = [];
      var files = [];

      angular.forEach(artefacts, function (item) {
        if (item.type === 'link') {
          /** Verifica se todas URLs são válidas */
          var pattern = /(http(s)?)/gi;
          if (!pattern.exec(item.file_reference)) {
            item.file_reference = 'http://' + item.file_reference;
          }
          /** Se o nome e link estiver definido */
          if (item.name.length && item.file_reference.length) {
            links.push(item);
          }
        } else {
          /** Verifica se há alguma atualização do arquivo */
          if (item.file) {
            item.file_reference = item.file;
          }
          files.push(item);
        }
      });
      /** Envia os arquivos */
      ClassReleaseService.saveFiles({id: lesson.id, files: files})
        .then(function (response) {
          var responseFiles = response.plain();
          lesson.files = responseFiles.files;
          if (file) {
            Common.Toast.success('Arquivos vinculados com sucesso.');
          } else {
            /** Envia os links */
            ClassReleaseService.saveLinks({id: lesson.id, links: links})
              .then(function (response) {
                var responseLinks = response.plain();
                /** Define o ID no link */
                angular.forEach(responseLinks.links, function (item) {
                  if (item.name === links[0].name && item.file_reference === links[0].file_reference) {
                    links[0].id = item.id;
                  }
                });
                lesson.links = responseLinks.links;

                if (modal) {
                  $rootScope.$broadcast("artefact.remove", vm.lesson);
                }
                if (angular.isDefined(vm.artefacts[vm.artefacts.indexOf(artefact)])) {
                  vm.artefacts[vm.artefacts.indexOf(artefact)].form_view = false;
                  Common.Toast.success('Anexos vinculados com sucesso.');
                }
              });
          }
        });

    };



    /**
     * Submete somente o objeto dos arquivos, que serão mandados pro back end apenas quando
     * a formulario rodar um submit
     * @param lesson
     * @param artefacts
     */
    vm.submitOnlyFile = function (lesson, artefacts) {
      var files = [];
      angular.forEach(artefacts, function (item) {
        /** Verifica se há alguma atualização do arquivo */
        if (item.file) {
          item.file_reference = item.file;
        }
        files.push(item);
      });

       /** Envia os arquivos */
       lesson.files = files;
    };

    /**
     * Executa fechamento do dialog
     */
    vm.close = function () {
      $rootScope.$broadcast("artefact.close", vm.lesson);
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular
    .module('app.educational.classes.classrooms')
    .controller('LessonArtefactController', LessonArtefactController)

})();


(function () {
  'use strict';

  /** @ngInject */
  function ExtraLessonEditController($scope, $state, $rootScope, Common, ModalFactory,
                                           ClassReleaseService, ModalExtra, CONFIG) {
    var vm = this;
    vm.isEdit = false;
    vm.form = {
      mode_edit: true,
      lesson: {}
    };

    vm.list = {
      lesson: {
        location_id: []
      }
    };
    vm.CONFIG = CONFIG;

    vm.init = function () {
      $rootScope.show_loader = false;
      vm.form.lesson = ModalExtra;
      vm.getListOfLocations();
    };

    /**
     * Retorna a lista de locais de aula
     */
    vm.getListOfLocations = function () {
      ClassReleaseService.getListOfLocations()
        .then(function (response) {
          vm.list.lesson.location_id = response.plain();
        })
    };

    /** Criação de uma aula no plano */
    vm.submit = function (item) {
      ClassReleaseService.editExtraLesson(item)
        .then(function () {
          vm.closeModal(false);
          Common.Toast.success("Aula extra editada com sucesso!");
        })
        .catch(function (response) {
          switch (response.data.message){
            case 'TIME_SHOCK':
              ModalFactory.confirm(
                null,
                'Aula em choque',
                'Deseja editar essa aula mesmo com choque de horário?',
                'Editar',
                'Cancelar',
                'Educational')
                .then(function () {
                  item.confirm_shock = true;
                  vm.submit(item);
                })
                .catch(function () {
                  Common.Toast.warning('Edição cancelada');
                  $rootScope.$broadcast('lesson.list.update');
                });
              break;
            default:
              Common.Toast.error(response.data.message);
          }
        })
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
      $rootScope.$broadcast('lesson.list.update');
    };

    vm.init();
  }

  angular
    .module('app.educational.classes.classrooms')
    .controller('ExtraLessonEditController', ExtraLessonEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ExtraLessonCreateController($scope, ModalFactory, $rootScope, Common, a4Moment,
                                           ClassReleaseService, ModalExtra, CONFIG) {
    var vm = this;
    vm.isEdit = false;
    vm.form = {
      mode_edit: true,
      lesson: {date: a4Moment()}
    };

    vm.list = {
      lesson: {
        location_id: []
      }
    };
    vm.CONFIG = CONFIG;

    vm.init = function () {
      $rootScope.show_loader = false;
      vm.form.lesson.group_id = ModalExtra.id;
      vm.form.lesson.matrix_period = ModalExtra.matrix_period;
      vm.form.lesson.subject_id = ModalExtra.subject_id;
      vm.getListOfLocations();
    };

    /**
     * Retorna a lista de locais de aula
     */
    vm.getListOfLocations = function () {
      ClassReleaseService.getListOfLocations()
        .then(function (response) {
          vm.list.lesson.location_id = response.plain();
        })
    };

    /** Criação de uma aula no plano */
    vm.submit = function (item) {
      ClassReleaseService.createExtraLesson(item)
        .then(function () {
          vm.closeModal();
          Common.Toast.success("Aula extra criada com sucesso!");
        })
        .catch(function (response) {
          switch (response.data.message){
            case 'TIME_SHOCK':
              ModalFactory.confirm(
                null,
                'Aula em choque',
                'Deseja criar essa aula mesmo com choque de horário?',
                'Criar',
                'Cancelar',
                'Educational')
                .then(function () {
                  item.confirm_shock = true;
                  vm.submit(item);
                })
                .catch(function () {
                  Common.Toast.warning('Criação cancelada');
                  $rootScope.$broadcast('lesson.list.update');
                });
              break;
            default:
              Common.Toast.error(response.data.message);
          }
        })
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
      $rootScope.$broadcast('lesson.list.update');
    };

    vm.init();
  }

  angular
    .module('app.educational.classes.classrooms')
    .controller('ExtraLessonCreateController', ExtraLessonCreateController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassroomsClassesController($rootScope, $stateParams, $state, $filter, $document, CONFIG, Session, $a4FloatButton,
                                       $scope, a4Moment, Common, ReportsService, ClassReleaseService, ModalFactory, ClassesService) {
    var vm = this;
    vm.classes = [];
    vm.schoolrooms = [];
    vm.windowHeight = angular.element("#content").height() - 160;
    vm.lesson = {};
    vm.lessonAbove = {};
    vm.lessons_id = [];
    vm.selected_tab = 0;
    vm.filter_date_lesson = {
      startDate: a4Moment().startOf('year').format('YYYY-MM-DD'),
      endDate: a4Moment().endOf('year').format('YYYY-MM-DD')
    };
    vm.ids = [];
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.grid = {
      rows: [],
      info: {},
      promise: {},
      selected: [],
      selected_column: 'date_hour',
      title: 'Aulas disponíveis'
    };
    /** Inicialização de variaveis */

    vm.buttonStates = [
      {textButton: 'Realizada', color: '#7cb342', icon: 'add', colorIcon: '#ffffff', value: 1},
      {textButton: 'Cancelada', color: '#b91400', icon: 'icon-plus', colorIcon: '#ffffff', value: 4}
    ];

    vm.templates = {
      classroom: 'app/educational/class-diary/views/classroom.html',
      frequency: 'app/educational/class-diary/views/frequency.html'
    };

    /** Parametros de state */
    vm.params = {
      id: $stateParams.group_id,
      subject_id: $stateParams.subject_id,
      matrix_period: $stateParams.matrix_period
    };

    vm.form = {
      lesson: {date: {initDate: null, endDate: null}}
    };

    /** Eventos */
    var ltn = $rootScope.$watch(function () {
      return vm.form.lesson.date;
    }, function () {
      vm.paginate();
    });

    /** Evento para atualizar a lista de aulas apos criar/editar uma aula extra  */
    var ltn2 = $rootScope.$on('lesson.list.update', function () {
      vm.paginate();
    });

    /** Função de inicio do controlador */
    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        label: 'Adicionar aula extra',
        onClick: 'vm.addExtraLesson()',
        theme: 'educational'
      });
    };

    /**
     * Recupera as aulas para lançamento
     * @param classe - Objeto da classe
     * @param date - Data da aula
     */
    vm.getClassRooms = function (classe, date) {
      classe.date = date;
      classe.at_today = false;
      ClassReleaseService.classRooms(classe)
        .then(function (response) {
          var data = response.plain();
          //vm.grid.rows = response.plain();
          vm.grid.rows = vm.formatGrid(data.schoolrooms);
          //vm.schoolrooms = response.plain();
          vm.lessons_id = angular.copy(vm.schoolrooms);
          $rootScope.show_loader = false;
        });
    };

    /**
     * Realizar uma aula
     */
    vm.accomplishLesson = function (item) {
      $state.go('private.educational.class-release.accomplish', {
        group_id: item.group_id, subject_id: item.subject_id,
        matrix_period: item.matrix_period, lesson_date: item.lesson_date
      });
    };


    /**
     * Retorna todos os colaboradores disponíveis
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     */
    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      var classe = angular.copy(vm.params);

      classe.limit = angular.isDefined(limit) ? limit : 600;
      classe.page = angular.isDefined(page) ? page : 1;
      classe.paginate = true;

      classe.date = vm.form.lesson.date;
      classe.at_today = false;
      vm.grid.promise = ClassReleaseService.classRooms(classe)
        .then(function (response) {
          var data = response.plain();
          vm.statistics = data.statistics;
          vm.grid.rows = vm.formatGrid(data.schoolrooms.data);
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            from: response.from,
            to: response.to,
            total: response.total
          };
          $rootScope.show_loader = false;
        });
    };

    /**
     * Abre o modal para criação de aula extra
     */
    vm.addExtraLesson = function () {
      ModalFactory.customClean(
        'app/educational/classes/classrooms/views/add-extra-lesson-modal.html',
        'ExtraLessonCreateController',
        'vm', false, vm.params
      )
        .then(function () {
          vm.paginate();
        });
    };

    vm.editExtraLesson = function (extra_lesson) {
      extra_lesson.date = a4Moment(extra_lesson.lesson_date);
      ModalFactory.customClean(
        'app/educational/classes/classrooms/views/add-extra-lesson-modal.html',
        'ExtraLessonEditController',
        'vm', false, extra_lesson
      )
        .then(function () {
          vm.paginate();
        });
    };

    /**
     * Modal de edição de aulas
     * @param item
     * @returns {boolean}
     */
    vm.openLesson = function (item) {
      var data = angular.copy(item);
      $rootScope.$broadcast('ModalFactory.close');
      ModalFactory.customClean(
        'app/educational/class-release/views/class-release-assistant.html',
        'ClassReleaseAssistantController',
        'vm', false, data
      );
      return false;
    };

    vm.printLessons = function (is_detailed) {
      var href = vm.webLink + 'api/reports/lessonsreport?token=' + vm.conf.token + '&company=' + vm.conf.current_company
        + '&connection=' + vm.conf.current_connection + '&user_id=' + vm.conf.user_id + '&group_id=' + vm.params.id +
        '&subject_id=' + vm.params.subject_id + '&matrix_period=' + vm.params.matrix_period + '&is_detailed=' + is_detailed;
      if (vm.filter_date_lesson !== null) {
        href += '&startDate=' + vm.filter_date_lesson.startDate + '&endDate=' + vm.filter_date_lesson.endDate;
      }
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    /**
     * Realiza a formatação necessária para a exibição do grid
     * @param array
     * @returns {*}
     */
    vm.formatGrid = function (array) {
      /** Variável para verificar se a última aula
       * sem plano no planejamento já teve o botão de inserção
       * habilitado */
      var lastLessonWithoutPlan = true;

      /** Filtro para data e horários */
      angular.forEach(array, function (item) {

        item.edit_button = true;
        item.edit_extra_button = true;
        item.insert_button = true;
        item.delete_button = true;
        item.realize_button = true;
        item.cancel_button = true;
        item.undo_button = true;
        item.undo_cancel_button = true;
        item.insert_above_button = true;

        item.lesson_sequence_plan = item.lesson_sequence_plan === null ? item.lesson_sequence : item.lesson_sequence_plan;

        /** Splita a initial e final time para utilizar o filtro de dates do angular*/
        item.initial_time = item.initial_time === null ? null : item.initial_time.substr(0, 5);
        item.final_time = item.final_time === null ? null : item.final_time.substr(0, 5);

        /** Filtro para horário */
        item.time = (item.initial_time === null && item.final_time === null) ? '' : $filter('date')(item.initial_time, "h:mm") + ' - '
          + $filter('date')(item.final_time, "h:mm");

        /** Filtro para data */
        item.date = item.lesson_date === null ? '' : $filter('date')(item.lesson_date, "dd/MM/yyyy (EEE)");

        /** Definição de Data e Hora */
        item.date_hour = item.date + ' | ' + item.time;

        if (angular.isDefined(item.activity) && item.activity !== null) {
          item.activity_homework = item.activity;
          if (angular.isDefined(item.homework) && item.homework !== null && item.homework !== '') {
            item.activity_homework = item.activity_homework !== '' ? item.activity_homework + ' | ' : item.activity_homework;
            item.activity_homework = item.activity_homework + item.homework;
          }
        }

        /** Aulas que não podem ser realizadas */
        if (item.lesson_status_id === 4 || item.lesson_status_id === 1 || item.has_no_lesson || (item.lesson_date !== null &&
          a4Moment(item.lesson_date).isAfter(a4Moment().format('YYYY-MM-DD')))) {
          /** Desabilita botão de realizar */
          item.realize_button = false;
        }

        /** Aulas que não podem ser editadas */
        if (item.activity === null ||
          (item.lesson_date !== null && a4Moment(item.lesson_date).isAfter(a4Moment().format('YYYY-MM-DD')))
          || item.lesson_status_id === 4 || (item.lesson_plan_item_id !== null && item.activity === null)) {
          /** Desabilita botão de editar */
          item.edit_button = false;
        }

        /** Aulas extras que não podem ser editadas (hora/data/local) */
        if (item.is_extra && item.lesson_status_id !== 0) {
          item.edit_extra_button = false;
        }

        /** Aulas que não podem ser excluídas */
        if (item.lesson_status_id === 1 || item.lesson_status_id === 4 || (item.lesson_plan_item_id !== null
          && (item.lesson_date !== null && a4Moment(item.lesson_date).isAfter(a4Moment().format('YYYY-MM-DD'))))) {
          /** Desabilita botão de excluir */
          item.delete_button = false;
        }

        /** Aulas que não podem ser canceladas */
        if (item.lesson_status_id === 4 || item.lesson_status_id === 1 || (item.lesson_status_id === 0 &&
          (item.lesson_date !== null && a4Moment(item.lesson_date).isBefore(a4Moment().format('YYYY-MM-DD'))))) {
          /** Desabilitar botão de cancelar */
          item.cancel_button = false;
        }

        /** Aulas que não podem receber inserção de nova aula */

        if (item.lesson_status_id === 1 || item.lesson_status_id === 4 || item.has_no_lesson ||
          lastLessonWithoutPlan === false || (item.lesson_plan_item_id !== null || (item.activity !== null
            && item.activity !== ""))) {
          /** Fazer sumir botão de inserir */
          item.insert_button = false;
        }

        /** Aulas que não podem receber planejamento acima */
        if (item.lesson_status_id === 1 || item.lesson_status_id === 4 || item.has_no_lesson || (item.lesson_plan_item_id === null
          && item.activity === null) /*|| item.lesson_sequence === 1*/) {
          /** Fazer sumir botão de inserir acima */
          item.insert_above_button = false;
        }

        /** Aulas que não podem ser desfeitas */
        if (item.lesson_status_id !== 1) {
          /** Fazer sumir botão de desfazer */
          item.undo_button = false;
        }

        /** Aulas que não podem ter o cancelamento desfeito */
        if (item.lesson_status_id !== 4) {
          /** Fazer sumir botão de desfazer cancelamento */
          item.undo_cancel_button = false;
        }

        /** Só será habilitado o botão de inserção da primeira aula sem plano e pendente. */
        if ((item.lesson_plan_item_id === null && (item.activity === null || item.activity === "") && !item.has_no_lesson)
          && item.lesson_status_id === 0 && lastLessonWithoutPlan === true) {
          lastLessonWithoutPlan = false;
        }
      });
      return array;
    };

    /** Submissão dos dados */
    vm.submit = function () {
      ClassReleaseService.save({lessons: vm.schoolrooms})
        .then(function () {
          Common.Toast.success('Aula lançada com sucesso');
          vm.getClassRooms(vm.params, vm.form.lesson.date);
          $rootScope.show_loader = false;
        })
    };

    vm.createNewPlan = function (lesson) {
      var next_lesson_sequence = lesson.lesson_sequence + 1;
      ModalFactory.customClean('app/educational/classes/classrooms/views/lesson-plan-item-modal.html',
        'LessonPlanClassCreateController', 'vm',
        true, lesson).then(function (addAnother) {
        if (addAnother) {
          for (var i = 0; i < vm.grid.rows.length; i++) {
            if (vm.grid.rows[i].lesson_sequence === next_lesson_sequence) {
              vm.createNewPlan(vm.grid.rows[i]);
            }
          }
        }
        vm.paginate();
      });
    };

    /**
     * Desfaz uma aula já realizada
     * @param lesson
     */
    vm.undoLessonPerformed = function (lesson) {
      ModalFactory.confirm(null,
        'Confirmação',
        'Deseja realmente desfazer a aula?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          ClassReleaseService.undoLessonPerformed(lesson)
            .then(function () {
              Common.Toast.success('Aula desfeita com sucesso');
              vm.paginate();
            })
            .catch(function (response) {
              Common.Toast.error(response.data.message);
            })
        })
    };

    /***
     * Edita uma aula
     * @param lesson
     */
    vm.editLesson = function (lesson) {
      var edit = angular.copy(lesson);
      ModalFactory.customClean('app/educational/classes/classrooms/views/lesson-plan-item-modal.html',
        'LessonPlanClassEditController', 'vm',
        true, edit).then(function () {
        vm.paginate();
      });
    };
    /**
     * Cancela uma aula
     * @param lesson
     */
    vm.cancelLesson = function (lesson) {
      ModalFactory.prompt(
        null,
        'Motivo do cancelamento',
        'Digite abaixo o motivo do cancelamento da aula',
        '',
        '',
        'Salvar',
        'Cancelar',
        'educational')
        .then(function (reason) {
          var canceledLesson = angular.copy(lesson);
          /** Define a activity da aula cancelada como o motivo de seu cancelamento */
          canceledLesson.activity = reason;
          if (canceledLesson.activity == null) {
            Common.Toast.error('Você precisa informar uma razão de cancelamento.');
          } else
            ClassReleaseService.cancelLesson(canceledLesson)
              .then(function () {
                Common.Toast.success('Aula cancelada com sucesso');
                vm.paginate();
              })
              .catch(function (response) {
                Common.Toast.error(response.data.message);
              })
        })

    };

    /***
     * Deleta uma aula
     * @param id
     */
    vm.deleteLesson = function (id, item) {
      ModalFactory.confirm(null,
        'Confirmação',
        'Deseja realmente excluir a aula?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          ClassReleaseService.deleteLesson(id, {lesson_date: item.lesson_date})
            .then(function () {
              Common.Toast.success('Aula deletada com sucesso');
              vm.paginate();
            })
            .catch(function (response) {
              Common.Toast.error(response.data.message);
            })
        })

    };

    vm.deleteExtraLesson = function (extra_lesson) {
      ModalFactory.confirm(null,
        'Confirmação',
        'Deseja realmente excluir esta aula extra?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          ClassReleaseService.deleteExtraLesson(extra_lesson)
            .then(function () {
              Common.Toast.success('Aula extra excluída com sucesso');
              vm.paginate();
            })
            .catch(function (response) {
              Common.Toast.error(response.data.message);
            })
        });
    };

    /**
     * Descancela uma aula
     * @param lesson
     */
    vm.undoCancelLesson = function (lesson) {
      ModalFactory.confirm(null,
        'Confirmação',
        'Deseja realmente descancelar a aula?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          ClassReleaseService.undoCancelLesson(lesson)
            .then(function () {
              Common.Toast.success('Aula descancelada com sucesso');
              vm.paginate();
            })
            .catch(function (response) {
              Common.Toast.error(response.data.message);
            })
        })
    };

    vm.getStudents = function (classe, date) {

      vm.ids = ClassesService.getLessonsIdFromList(vm.schoolrooms);
      classe.at_today = false;
      classe.date = date;
      ClassReleaseService.getStudents({
        classe: classe,
        lessons: {ids: vm.ids}
      })
        .then(function (response) {
          vm.students = response.students;
          vm.date = vm.formatGrid(response.date);
        })
    };


    /**
     * Abre o modal de criação de notas de classe
     */
    vm.releaseClass = function () {
      $rootScope.$broadcast('ModalFactory.close');
      ModalFactory.customClean(
        'app/educational/class-diary/views/diary-assistant.html',
        'ClassroomsClassesController',
        'vm', false, vm
      );
      return false;
    };

    vm.submitFrequency = function () {
      ClassesService.saveFrequencyOfStudents({students: vm.students, ids: vm.ids})
        .then(function () {
          Common.Toast.success('Frequência salva com sucesso');
          vm.getStudents(vm.params, vm.form.lesson.date);
        })
        .catch(function () {
          Common.Toast.error('Erro ao salvar frequência');
        })
    };

    vm.insertNotes = function (item, notes) {
      ModalFactory.custom(
        'app/educational/classes/classrooms/views/notes.html',
        item[notes]
      ).then(function (note) {
        $filter('filter')(vm.students, {person_id: item.person_id})[0][notes] = note;
      });
    };


    /**
     * Fechamento do assistente de aulas
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /** Destructor da classe */
    $scope.$on('$destroy', function () {
      [ltn, ltn2].forEach(function (fn) {
        fn();
      });
      if (vm.floatButton !== null) {
        vm.floatButton.destroy();
      }
    });

    vm.init();
  }

  angular
    .module('app.educational.classes.classrooms')
    .controller('ClassroomsClassesController', ClassroomsClassesController)
})();

(function () {
  'use strict';

  angular
    .module('app.educational.class-release', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ClassReleaseTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "CLASS_RELEASE": {
        "TITLE": "Lançamento de aulas",
        "SEARCH_FOR_ANYONE": "Pesquisar"
      }
    })

  }

  angular
    .module('app.educational.class-release')
    .config(ClassReleaseTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.class-grouping', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassGroupingTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "CLASS_GROUPING": {
        "TITLE": "Agrupamentos de Classe",
        "SEARCH_FOR_ANYONE": "Pesquisar",
        "TITLE_CREATE_GRADE": "Criar novo agrupamento de notas",
        "TITLE_CREATE_CLASS": "Criar novo agrupamento de aulas",
        "TITLE_EDIT": "Editar agrupamento"
      }
    })

  }

  angular
    .module('app.educational.class-grouping')
    .config(ClassGroupingTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.academic-calendar', []);

})();


(function () {
    'use strict';

    /** @ngInject */
    function AcademicCalendarTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "ACADEMIC_CALENDAR": {
                "ADD_PLAN": "Adicionar Curso",
                "TITLE": "Calendário Academico",
                "SEARCH_FOR_ANYONE": "Pesquisar",
                "FORM_CREATE": "Criar Curso",
                "FORM_EDIT": "Editar Curso"
            }
        })

    }

    angular
        .module('app.educational.academic-calendar')
        .config(AcademicCalendarTranslate);
})();

(function () {
  'use strict';

  angular.module('app.evaluations.questionnaires', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.teachers-evaluation', {
        url: '/teachers-evaluation',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaires/teachers-evaluation/teachers-evaluation.html',
        controller: 'TeachersEvaluationController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'questionnaires';
    var path = 'questionnaire.teachers-evaluation';

    msNavigationService.saveItem(path, {
      title: 'Aval. de prof.',
      icon: 'icon-account-network',
      state: 'private.evaluations.teachers-evaluation',
      weight: 3,
      auth: role,
      badge: {
        content: 'Em breve!',
        color: 'orange'
      },
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.questionnaires')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function TeachersEvaluationController() {

  }

  angular.module('app.evaluations.questionnaires')
    .controller('TeachersEvaluationController', TeachersEvaluationController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.students-evaluation', {
        url: '/students-evaluation',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaires/students-evaluation/students-evaluation.html',
        controller: 'StudentsEvaluationController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'questionnaires';
    var path = 'questionnaire.students-evaluation';

    msNavigationService.saveItem(path, {
      title: 'Aval. de alunos',
      icon: 'icon-human-child',
      state: 'private.evaluations.students-evaluation',
      weight: 1,
      auth: role,
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.questionnaires')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function StudentsEvaluationController() {

  }

  angular.module('app.evaluations.questionnaires')
    .controller('StudentsEvaluationController', StudentsEvaluationController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.questions-repository', {
        url: '/questions-repository',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaires/questions-repository/questions-repository.html',
        controller: 'QuestionsRepositoryController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'questionnaires';
    var path = 'knowledge.questions-repository';

    msNavigationService.saveItem(path, {
      title: 'Banco de questões',
      icon: 'icon-folder-multiple',
      state: 'private.evaluations.questions-repository',
      weight: 3,
      auth: role,
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.questionnaires')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function QuestionsRepositoryController() {

  }

  angular.module('app.evaluations.questionnaires')
    .controller('QuestionsRepositoryController', QuestionsRepositoryController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.questionnaires-config', {
        url: '/questionnaires-config',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaires/questionnaires-config/questionnaires-config.html',
        controller: 'QuestionnairesConfigController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'evaluations_questionnaire_config';
    var path = 'questionnaire.questionnaires-config';

    msNavigationService.saveItem(path, {
      title: 'Configurações',
      icon: 'icon-cog',
      state: 'private.evaluations.questionnaires-config',
      weight: 5,
      auth: role,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.evaluations.questionnaires')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function QuestionnairesConfigController() {

  }

  angular.module('app.evaluations.questionnaires')
    .controller('QuestionnairesConfigController', QuestionnairesConfigController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.pedagogic-evaluation', {
        url: '/pedagogic-evaluation',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaires/pedagogic-evaluation/pedagogic-evaluation.html',
        controller: 'PedagogicEvaluationController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'questionnaires';
    var path = 'questionnaire.pedagogic-evaluation';

    msNavigationService.saveItem(path, {
      title: 'Aval. psicoped.',
      icon: 'icon-library',
      state: 'private.evaluations.pedagogic-evaluation',
      weight: 2,
      auth: role,
      badge: {
        content: 'Em breve!',
        color: 'orange'
      },
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.questionnaires')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function PedagogicEvaluationController() {

  }

  angular.module('app.evaluations.questionnaires')
    .controller('PedagogicEvaluationController', PedagogicEvaluationController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.knowledge-test', {
        url: '/knowledge-test',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaires/knowledge-test/knowledge-test.html',
        controller: 'KnowledgeTestController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'questionnaires';
    var path = 'knowledge.knowledge-test';

    msNavigationService.saveItem(path, {
      title: 'Testes e provas',
      icon: 'icon-pencil-box',
      state: 'private.evaluations.knowledge-test',
      weight: 1,
      auth: role,
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.questionnaires')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function KnowledgeTestController() {

  }

  angular.module('app.evaluations.questionnaires')
    .controller('KnowledgeTestController', KnowledgeTestController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.knowledge-config', {
        url: '/knowledge-config',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaires/knowledge-config/knowledge-config.html',
        controller: 'KnowledgeConfigController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'evaluations_knowledge_config';
    var path = 'knowledge.knowledge-config';

    msNavigationService.saveItem(path, {
      title: 'Configurações',
      icon: 'icon-cog',
      state: 'private.evaluations.knowledge-config',
      weight: 5,
      auth: role,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.evaluations.questionnaires')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function KnowledgeConfigController() {

  }

  angular.module('app.evaluations.questionnaires')
    .controller('KnowledgeConfigController', KnowledgeConfigController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.general-research', {
        url: '/general-research',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaires/general-research/general-research.html',
        controller: 'GeneralResearchController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'questionnaires';
    var path = 'questionnaire.general-research';

    msNavigationService.saveItem(path, {
      title: 'Pesquisas gerais',
      icon: 'icon-account-search',
      state: 'private.evaluations.general-research',
      weight: 4,
      auth: role,
      badge: {
        content: 'Em breve!',
        color: 'orange'
      },
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.questionnaires')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function GeneralResearchController() {

  }

  angular.module('app.evaluations.questionnaires')
    .controller('GeneralResearchController', GeneralResearchController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.exercises-list', {
        url: '/exercises-list',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaires/exercises-list/exercises-list.html',
        controller: 'ExercisesListController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'questionnaires';
    var path = 'knowledge.exercises-list';

    msNavigationService.saveItem(path, {
      title: 'Listas de exercícios',
      icon: 'icon-library-books',
      state: 'private.evaluations.exercises-list',
      weight: 2,
      auth: role,
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.questionnaires')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ExercisesListController() {
  }

  angular.module('app.evaluations.questionnaires')
    .controller('ExercisesListController', ExercisesListController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function CorrectQuestionnaireController($rootScope, $state, Session, QuestionnairesService, ModalExtra) {
    var vm = this;
    vm.current_school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ?
      Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.questionnaire_id = ModalExtra.item.id;
    vm.grid = {
      data: []
    };

    vm.init = function () {
      $rootScope.show_loader = true;
      vm.getAll();
    };

    vm.getAll = function () {
      QuestionnairesService.getStudentsByEvaluations({ id: vm.questionnaire_id})
        .then(function (response) {
          if (response) {
            vm.grid.rows = [];
            vm.grid.rows = response.plain();


            $rootScope.show_loader = false;
          }
          });

      $rootScope.show_loader = false;
    };

    vm.correctQuestionnaire = function (item) {
      console.log(vm.grid.rows);
      $rootScope.show_loader = true;
      QuestionnairesService.getEvaluationLink({
        person_id: item.id,
        questionnaire_id: vm.questionnaire_id,
        group_id: item.group_id,
        matrix_period: item.matrix_period,
        cookie: 'is_allowed'
      }).then(function (link) {
        $rootScope.show_loader = false;
        vm.closeModal();
        var token = link.split('answer-questionnaire\/')[1];
        $state.go('public.answer-questionnaire', {
          token: token
        });
      })
    };


    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular.module('app.evaluations.questionnaires')
    .controller('CorrectQuestionnaireController', CorrectQuestionnaireController);
})();
(function () {
  'use strict';

  angular.module('app.evaluations.answer-questionnaire', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('public.answer-questionnaire', {
        url: '/evaluations/answer-questionnaire/:token',
        public: true,
        controller: 'AnswerQuestionnaireController',  
        controllerAs: 'vm',
        templateUrl: 'app/evaluations/questionnaires/answer-questionnaire/views/answer-questionnaire.html'

      });

  }

  angular
    .module('app.evaluations.answer-questionnaire')
    .config(routerConfig);

})();
(function () {
  'use strict';

  /** @ngInject */
  function AnswerQuestionnaireController($scope, $document, $stateParams, $rootScope, $state, LoginService,
                                         ModalFactory, QuestionnairesService, PoliciesService, Session, Common, CONFIG) {
    var vm = this;
    vm.token = $stateParams.token;
    vm.windowHeight = angular.element("body").height();
    vm.windowWidth = angular.element("body").width();
    vm.profile = Session.getProfile();
    vm.formWidth = 40;
    vm.questionnaire = {};
    vm.person = {};
    vm.questions = {};
    vm.answering = false;
    vm.selected_question = {};
    vm.index = 0;
    vm.loading = true;
    vm.finished = false;
    vm.show_answers = false;
    vm.is_correcting = false;
    vm.teacher_notes = '';
    vm.grade_note = null;
    vm.is_questionnaire = false;
    vm.FIVE_MINUTES = 1000 * 60 * 5;
    vm.has_question_unanswered = false;
    vm.url = CONFIG.webApiUri;
    vm.cookie = document.cookie.split('=')[1];


    vm.getLogo = function () {
      var subdomain = $document[0].domain.split('.')[0];
      LoginService.getLogo(subdomain)
        .then(function (response) {
          vm.screen_image = response.image;
        })
    };

    vm.startAnswers = function () {
      vm.loading = true;
      QuestionnairesService.startAnswer({
        group_id: vm.group_id,
        person_id: vm.person.id,
        matrix_period: vm.matrix_period,
        questionnaire_id: vm.questionnaire.id
      }).then(function () {
        vm.status = 1;
        vm.loading = false;
        vm.answering = true;
        vm.selected_question = vm.questions[vm.index];
      })

    };

    /**
     * as funções abaixo são utilizadas para navegação entre as questões,
     * que alem de modificar o indice do array, também responde pontualmente cada uma das questões
     */
    vm.previousQuestion = function () {
      vm.index -= 1;
      vm.selected_question = vm.questions[vm.index];
      vm.saveQuestionnaire(vm.index + 1);
    };

    vm.nextQuestion = function () {
      vm.index += 1;
      vm.selected_question = vm.questions[vm.index];
      vm.saveQuestionnaire(vm.index - 1);
    };

    vm.correctQuestion = function () {
      $rootScope.show_loader = true;
      if(vm.questions.length === vm.index + 1) {
        vm.finishQuestionnaire(vm.index)
      } else {
        vm.index += 1;
        vm.saveQuestionnaire(vm.index - 1);
        vm.selected_question = vm.questions[vm.index];
      }
    };

    vm.selectQuestion = function (index) {
      vm.index = index;
      vm.selected_question = vm.questions[vm.index];

      if (!vm.finished) {
        vm.saveQuestionnaire(index - 1);
      }
    };

    vm.verifyIfHasQuestionUnanswered = function () {
      var count = 0;
      vm.questions.forEach(function (question) {
        if (question.question_type_id !== 'QM' && (question.right_answer === null)) {
          vm.has_question_unanswered = true;
          count += 1
        }
        if(vm.is_correcting && question.points === null) {
          vm.has_question_unanswered = true;
        }
      });
      if(count === 0) {
        vm.has_question_unanswered = false;
      }
      return vm.has_question_unanswered;
    };

    vm.finishQuestionnaire = function (index) {
      /**
       * submit final, assim que o modal é fechado é chamado pela ultima vez a função de responder
       * o questionário e é passado o is_finished como true para passar pelas verificações
       * de um questionário terminado, e depois disso utilizaa do ui-router para voltar para pagina do aluno
       */
      var message = 'Após confirmar a conclusão da avaliação as suas respostas não poderão ser modificadas e questões sem respostas não poderão mais ser respondidas. Tem certeza de que deseja concluir?';
      if (vm.verifyIfHasQuestionUnanswered() && !vm.is_correcting) {
        console.log(vm.questions);
        vm.filtered_questions = vm.questions.filter(function (question) {
          // Se o question_type_id for "TM", verificar o array items
          if (question.question_type_id === "QM") {
            // Retornar false se qualquer item em question.items tiver answer
            return !question.items.some(function(item) {
              return item.answer === true;
            });
          }
          
          // Se o question_type_id não for "TM", verificar right_answer
          return question.right_answer === null || question.right_answer === '';
        });
        vm.questions_list = vm.filtered_questions
        .map(function(question) {
          return '   ' + question.ord + '  '; 
        })
        .join(', ');
        console.log(vm.questions_list);
        message = 'ATENÇÃO: as seguintes questões não foram respondidas no questionário: ' + '(' + vm.questions_list + ')' + message;
      }
      ModalFactory.confirm(null,
        "Concluir avaliação", message,
        "Concluir", "Retornar às questões", "evaluations").then(function () {
        vm.loading = true;
        if(!vm.is_correcting) {
          vm.questions[index].points = null
        }
        QuestionnairesService.answerSingleQuestion({
          questions: vm.questions[index],
          person_id: vm.person.id,
          group_id: vm.group_id,
          matrix_period: vm.matrix_period,
          questionnaire_id: vm.questionnaire.id,
          is_finished: true,
          is_correcting : vm.is_correcting,
          has_question_unanswered: vm.has_question_unanswered,
          status: vm.status,
          cookie: vm.cookie
        }).then(function () {
          vm.finished = true;
          if(vm.is_correcting) {
            $state.go('private.evaluations.questionnaires.edit',
              {id: vm.questionnaire.id, tab_selected: 3});
          } else {
            $state.go('private.educational.dashboard.students', null, {
              notify: false,
              id: Session.getUser().id
            }).then(function () {
              $rootScope.$broadcast('$stateChangeSuccess',
                'private.educational.dashboard.students', {id: Session.getUser().id}, '/', null);
            });
          }
        }).catch(function (e) {
          console.log(e);
        })
      });
    };

    vm.saveQuestionnaire = function (index) {
      /**
       * cria um sistema de contador para quando a resposta é de multipla escolha, para que o indice fique verde caso esteja respondido
       */
      if(vm.questions[index].question_type_id === 'QM') {
        var counter = 0;
        angular.forEach(vm.questions[index].items, function (question, key) {

          if (question.answer === null || question.answer === false) {
            counter++
          }
          if(question.answer === true) {
            vm.questions[index].right_answer = true
          }
          if( counter === (key + 1) ) {
            vm.questions[index].right_answer = null

          }

        });
      }
      index = index < 0 ? 0 : index;
      /**
       * va verificação do esquema de cores começa verificando de o parametro passado é === 0
       * porque é assim que é passado na navegação, então previne qualquer troca, porem se for
       * passado com os botoes do wizard, ele tem 3 opções de mudança
       *
       * 1 - muda a questão que foi respondida para verde e torna a proxima questão selecionada cinza
       *
       * 2-  no caso de não ter selecionado nem uma questão, mantem branco
       *
       * 3 - caso a questão seja respondida e ter um bookmark, assim que for clicado no wizard ficará verde
       */

        if(angular.isDefined(vm.questions[index].right_answer) &&
                             vm.questions[index].right_answer !== '' &&
                             vm.questions[index].right_answer !== null) {
          vm.questions[index].color = 'lightgreen';

        } else if(vm.questions[index].right_answer === ''
               && vm.questions[index].color !== 'rgb(3,169,244)' ||
                  vm.questions[index].right_answer === null) {
          vm.questions[index].color = '#FFF';

        } else if(angular.isDefined(vm.questions[index].right_answer)
          && vm.questions[index].right_answer !== ''
          && (vm.questions[index].color === '#03A9F4' || vm.questions[index].color === '#778291')) {
          vm.questions[index].color = 'lightgreen';
        }
        if(!vm.is_correcting) {
          vm.questions[index].points = null
        }
      QuestionnairesService.answerSingleQuestion({
        questions: vm.questions[index],
        person_id: vm.person.id,
        group_id: vm.group_id,
        matrix_period: vm.matrix_period,
        questionnaire_id: vm.questionnaire.id,
        status: vm.status,
        is_finished: false,
        cookie: vm.cookie
      }).catch(function (e) {
        var error = e.data.message;
        if(error === 'TIME_OUT') {
          ModalFactory.confirm(null,
            "Acabou o tempo",
            "O tempo para realização da prova terminou, você será redirecionado para a pagina do aluno",
            'Concluir', null,
            'educational'
          ).then(function () {
            vm.exit();
          });
        }
      })
    };

    /**
     * função para o marcador de questão
     */
    vm.setBookmark = function () {
      vm.selected_question.bookmark = !vm.selected_question.bookmark || false;
    };

    vm.validatePoints = function () {
      if (angular.isDefined(vm.selected_question.points) && vm.selected_question.points > parseFloat(vm.selected_question.max_points)) {
        Common.Toast.warning('A nota digitada não pode ser maior que o valor maximo!');
        vm.selected_question.points = parseFloat(vm.selected_question.max_points)
      }
    };

    vm.disableCopy = function() {
      document.addEventListener('copy', function(e) {
        e.preventDefault();
        alert('Não é possível copiar itens dessa página.');
      });
    }

    vm.exit = function () {
      if(vm.is_correcting && vm.profile != 1) {
        $state.go('private.evaluations.knowledge-test');
      } else {
        $state.go('private.educational.dashboard.students', null, {
          notify: false,
          id: Session.getUser().id
        }).then(function () {
          $rootScope.$broadcast('$stateChangeSuccess',
            'private.educational.dashboard.students', {id: Session.getUser().id}, '/', null);
        });
      }
    };

    setInterval(vm.saveQuestionnaire, vm.FIVE_MINUTES);

    vm.checkProfile = function () {
      vm.is_correcting = PoliciesService.currentProfile() === 7 || PoliciesService.currentProfile() === 0;
    };

    vm.init = function () {
      /**
       * pega as informações do questionário e preenche o css para marcar as questões ja resolvidas de verde
       * e verifica qual o perfil e se a prova ja está resolvida, pois o ambiente de resposta e correção são os mesmos
       * então existem muitas verificação ao longo dos arquivos para tratar cada um dos casos
       */
      vm.getLogo();
      vm.disableCopy();
      $rootScope.show_loader = true;
      vm.checkProfile();
      QuestionnairesService.getEvaluationAnswerInfo({token: vm.token}).then(function (response) {
        var data = response.plain();
        vm.person = data.person;
        vm.questions = data.questions;
        vm.questionnaire = data.questionnaire;
        vm.subject = data.subject;
        vm.course = data.course;
        vm.group = data.group;
        vm.group_id = data.group_id;
        vm.matrix_period = data.matrix_period;
        vm.status = data.status;
        vm.selected_question = vm.questions[vm.index];
        if (vm.status === 1) {
          vm.answering = true;

        }else if (vm.status === 10) {
          vm.show_answers = true;
          vm.is_correcting = true

        }else if (vm.status === 20) {
          vm.finished = true;
          vm.show_answers = true;

        }
        vm.loading = false;
        vm.questions.forEach(function (question) {

          // if(question.is_canceled) {
          //   question.points = "Questão anulada"
          // }
          //
          // if(question.is_answer_invalid) {
          //   question.points = "Questão Inválidada"
          // }

          if(question.question_type_id === "QM") {
           angular.forEach(question.items, function (q) {
             if(q.answer === true) {
               question.color = 'lightgreen';
             }
           })
          }
          if((question.right_answer !== "" && question.right_answer !== null) ||  vm.status >= 10) {
            question.color = 'lightgreen';
            if (question.question_type_id === "QU") {
              question.right_answer = ( parseInt(question.right_answer) + 1 );
            }

          }
        });
      });
    };

    vm.init();
  }

  angular.module('app.evaluations.answer-questionnaire')
    .controller('AnswerQuestionnaireController', AnswerQuestionnaireController);
})();

(function () {
  'use strict';

  angular
    .module('app.roles', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function RolesTranslate($translateProvider) {

        $translateProvider.translations('pt', {
          "ROLES": {
            "ROLES": "Papéis",
            "USERS": "Usuários",
            "MANAGE_USERS": "Gerenciar usuários",
            "SEARCH": "Pesquisar",
            "NEW_ROLE": "Novo papel",
            "EDIT_ROLE": "Editar papel",
            "NAME": "Nome",
            "DESCRIPTION": "Descrição",
            "SAVE" :"Salvar",
            "SAVE_CLOSE" :"Salvar e fechar",
            "NEW_USER": "Novo usuário",
            "EDIT_USER": "Editar usuário",
            "PASSWORD": "Senha",
            "USER": "Usuário",
            "CONFIRM_PASSWORD": "Confirmar senha",
            "CANCEL": "Cancelar",
            "EMAIL": "Email",
            "CHANGE_PASSWORD": "Modificar senha"
          }
        })

    }

    angular
        .module('app.roles')
        .config(RolesTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.controlpanel.profile', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function ProfileTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "PROFILE": {
                "CHANGE_AVATAR": "Alterar imagem",
                "EDITABLE": "Editar",
                "EDIT_AVATAR": "Editar imagem",
                "FORM": "Perfil do Usuário",
                "PROFILE": "Perfil",
                "FORM_ADDRESS_CITY": "Cidade",
                "FORM_ADDRESS_CITY_REQUIRED": "A cidade é necessária.",
                "FORM_ADDRESS_DISTRICT": "Bairro",
                "FORM_ADDRESS_DISTRICT_REQUIRED": "O bairro é necessário.",
                "FORM_ADDRESS_LINE2": "Complemento",
                "FORM_ADDRESS_LINE2_REQUIRED": "O complemento é necessário.",
                "FORM_ADDRESS_HOUSE_NUMBER": "Número",
                "FORM_ADDRESS_HOUSE_NUMBER_REQUIRED": "O número é necessário.",
                "FORM_ADDRESS_POSTAL_CODE": "CEP",
                "FORM_ADDRESS_POSTAL_CODE_REQUIRED": "O CEP é necessário.",
                "FORM_ADDRESS_STATE": "Estado",
                "FORM_ADDRESS_STATE_REQUIRED": "O estado é necessário.",
                "FORM_CATEGORY": "Categoria",
                "FORM_CATEGORY_REQUIRED": "A categoria é necessária.",
                "FORM_DOB": "Nasc.",
                "FORM_DOB_REQUIRED": "O nascimento é necessário.",
                "FORM_EMAIL": "E-mail",
                "FORM_EMAIL_REQUIRED": "O e-mail é necessário.",
                "FORM_PHONE_LANDLINE": "Telefone.",
                "FORM_PHONE_LANDLINE_REQUIRED": "O telefone é necessário.",
                "FORM_PHONE_MOBILE": "Celular.",
                "FORM_PHONE_MOBILE_REQUIRED": "O celular é necessário.",
                "FORM_NAME": "Nome",
                "FORM_NAME_REQUIRED": "O nome é necessária.",
                "FORM_ADDRESS_STREET": "Rua",
                "FORM_ADDRESS_STREET_REQUIRED": "A rua é necessária.",
                "FORM_NATIONAL_ID": "Identificação",
                "FORM_NATIONAL_ID_REQUIRED": "A identificação é necessária.",
                "FORM_SEX": "Sexo",
                "FORM_SEX_REQUIRED": "O sexo é necessário.",
                "FORM_SUBMIT": "Atualizar perfil",
                "SELECT_AVATAR": "Selecione a imagem"
            }
        })

    }

    angular
        .module('app.controlpanel.profile')
        .config(ProfileTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.controlpanel.central-reports', [
      'app.controlpanel.central-reports-define-details-wizard'
    ]);

})();

(function () {
  'use strict';

  /** @ngInject */
  function CentralReportsTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "FM": {
        "TOOGLE_MAIN_SIDENAV": "Toggle Main Sidenav",
        "SEARCH": "Search",
        "GRID_VIEW": "Modo grade",
        "LIST_VIEW": "Modo lista",
        "ADD_FILE": "Add File",
        "DETAILS": "Detalhes",
        "NAME": "Nome",
        "TYPE": "Tipo",
        "SIZE": "Tamanho",
        "LAST_MODIFIED": "Ultima vez modificado em",
        "FILE_MANAGER": "Central de Relatórios",
        "SELECT_ACCOUNT": "Selecionar conta",
        "MY_FILES": "Meus arquivos",
        "STARRED": "Starred",
        "SHARRED_WITH_ME": "Shared with me",
        "RECENT": "Recente",
        "OFFLINE": "Offline",
        "DELETE": "Remover",
        "DOWNLOAD": "Baixar relatório",
        "GENERATE": "Visualizar relatório",
        "MORE": "More",
        "SAVE": "Salvar",
        "DEFINE": "Editar relatório",
        "EDIT": "Editar",
        "EDITED": "Editado em",
        "AVAILABLE_OFFLINE": "Available Offline",
        "TOOGLE_OFFLINE": "Toggle offline",
        "LOCATION": "Localização",
        "OWNER": "Criado por",
        "MODIFIED": "Modificado",
        "OPENED": "Aberto",
        "CREATED": "Criado",
        "INFO": "Informações"
      }
    })

  }

  angular
    .module('app.controlpanel.central-reports')
    .config(CentralReportsTranslate);
})();

(function () {
  'use strict';

  /** @ngInject*/
  function DefineDetailsWizardService($rootScope, $filter, DocumentsService, Common, Restangular) {

    var vm = this;
    vm.name = '';
    vm.stepSelected = 0;
    vm.columns = [];
    vm.resources = {};
    vm.steps = {
      description: {id: 0, completed: false, disabled: false},
      columns: {id: 1, completed: false, disabled: true},
      classification: {id: 2, completed: false, disabled: true},
      grouping: {id: 3, completed: false, disabled: true},
      filter: {id: 4, completed: false, disabled: true}
    };
    vm.steps_query = [
      {id: 0, name: 'description'},
      {id: 1, name: 'columns'},
      {id: 2, name: 'classification'},
      {id: 3, name: 'grouping'},
      {id: 4, name: 'filter'}
    ];
    vm.last_step = 4;
    /** Definição de JSON */
    vm.json = {
      master: '',
      type: 0,
      details: 0,
      cols: [],
      break: [],
      order: [],
      filter: [],
      hasAggregation: false
    };
    /** End Definição de JSON */

    vm.setName = function (name) {
      vm.name = name;
    };

    vm.getName = function () {
      return vm.name;
    };

    vm.getColumns = function () {
      return vm.json.cols;
    };

    vm.setColumns = function (columns) {
      vm.json.cols = columns;
    };

    vm.addJsonColumn = function (column) {
      vm.json.cols.push(column);
    };

    vm.getType = function () {
      return vm.json.type;
    };

    vm.setType = function (type) {
      vm.json.type = type;
    };

    vm.getBreak = function () {
      return vm.json.break;
    };

    vm.setBreak = function (vbreak) {
      vm.json.break = vbreak;
    };

    vm.addBreak = function (vbreak) {
      vm.json.break.push(vbreak);
    };

    /** ORDER */
    vm.getOrder = function () {
      return vm.json.order;
    };

    vm.addOrder = function (order) {
      vm.json.order.push(order);
    };

    vm.setOrder = function (order) {
      vm.json.order = order;
    };
    /** FILTERS */
    vm.getFilters = function () {
      return vm.json.filter;
    };

    vm.setFilters = function (filter) {
      vm.json.filter = filter;
    };

    vm.addFilter = function (filter) {
      vm.json.filter.push(filter);
    };

    /** STEP */
    vm.getStepSelected = function () {
      return vm.stepSelected;
    };

    /**
     * Retorna o passo corrente
     * @param id - Identificador do passo.
     * @return {*}
     */
    vm.getCurrentStep = function (id) {
      return $filter('filter')(vm.steps_query, {id: id})[0];
    };

    vm.setStepSelected = function (step) {
      vm.stepSelected = step;
    };

    vm.getMaster = function () {
      return vm.json.master;
    };

    vm.setMaster = function (master) {
      vm.json.master = angular.copy(master);
      vm.getResourses(master);
    };

    /** Retorna uma cópia das colunas */
    vm.getCopyColumns = function () {
      return angular.copy(vm.columns);
    };

    vm.isLastStep = function () {
      return vm.stepSelected === vm.last_step;
    };

    /**
     * Lista todos os dados da Factory
     */
    vm.clear = function () {
      vm.stepSelected = 0;
      vm.name = '';
      vm.columns = [];
      vm.steps = {
        description: {id: 0, completed: false, disabled: false}, columns: {id: 1, completed: false, disabled: true},
        classification: {id: 2, completed: false, disabled: true}, grouping: {id: 3, completed: false, disabled: true},
        filter: {id: 4, completed: false, disabled: true}
      };
      /** Definição de JSON */
      vm.json = {master: 0, type: 0, details: 0, cols: [], break: [], order: [], filter: [], hasAggregation: false};
      /** End Definição de JSON */
    };

    /**
     * Define as colunas de acordo com a master selecionada
     */
    vm.getResourses = function (master) {
      if (angular.isDefined(vm.resources[master])) {
        vm.columns = vm.resources[master];
      } else {
        DocumentsService.getResources()
          .then(function (resources) {
            vm.resources = resources.plain();
            vm.columns = resources[master];
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.warning('Erro ao recuperar colunas');
          });
      }
    };

    /**
     * retorna o JSON inteiro
     */
    vm.getJson = function () {
      return vm.json;
    };

    /**
     * Conclusão de relatório
     */
    vm.finishReport = function (report_id) {
      return Restangular.one('reports', report_id).all('savejson').post({model_json: vm.json, name: vm.name});
    };

    /**
     * Executa o submit do step corrente
     * @param step - step atual do wizard
     * @param next - proximo step do wizard
     */
    vm.submitCurrentStep = function (step, next) {
      vm.showBusyText = true;
      if (!vm.steps[step].completed) {
        /** move to next step when success */
        vm.showBusyText = false;
        vm.steps[step].completed = true;
        vm.steps[next].disabled = false;
        vm.enableNextStep(4);
        angular.element('md-step-content.md-active select:first, md-step-content.md-active input[type="text"]:first').focus();
      } else {
        vm.showBusyText = false;
        vm.enableNextStep(4);
      }
    };

    /**
     * Inicia os objetos do serviço com string de JSON do banco de dados
     */
    vm.setItemsFromModelJson = function (name, model_json) {
      var json = (angular.isUndefined(model_json) || model_json == null) ? vm.json : angular.fromJson(model_json);
      vm.setName(name);
      vm.setColumns(json.cols);
      vm.setType(json.type);
      vm.setBreak(json.break);
      vm.setFilters(json.filter);
      vm.setOrder(json.order);
      vm.setMaster(json.master);
      vm.setStepSelected(0);
    };

    /**
     * Para para o proximo passo
     * @param maxStep
     */
    vm.enableNextStep = function (maxStep) {
      /** não pode exceder o maximo de passos */
      if (vm.stepSelected >= maxStep) {
        return;
      }
      /** Selecionado recebe o proximo step */
      vm.stepSelected = vm.stepSelected + 1;
    };

    vm.getData = function () {
      return {
        stepSelected: vm.stepSelected,
        steps: vm.steps,
        showBusyText: vm.showBusyText
      };
    };

    /**
     * Faz a diferença entre dois arrays de colunas, o disponível e o selecionado
     * @param available
     * @param selected
     * @return {*}
     */
    vm.array_diff = function (available, selected) {
      var available_copy = angular.copy(available);
      return available_copy.filter(function (item1) {
        for (var i in selected) {
          if (item1.name === selected[i].name) {
            return false;
          }
        }
        return true;
      });
    };

    /**
     * Move o wizard para a etapa anterior
     */
    vm.moveToPreviousStep = function () {
      if (vm.stepSelected > 0) {
        vm.stepSelected = vm.stepSelected - 1;
      }
    };

    return vm;
  }

  angular
    .module('app.controlpanel.central-reports-define-details-wizard')
    .factory('DefineDetailsWizardService', DefineDetailsWizardService)
})();
(function () {
  'use strict';

  /** @ngInject*/
  function DefineDetailsWizardController($scope, $rootScope, Common, ModalExtra, DefineDetailsWizardService) {
    var details = this;

    details.init = function () {
      details.item = ModalExtra;
      details.data = DefineDetailsWizardService.getData();
      details.id = ModalExtra.id;
      details.json = angular.fromJson(ModalExtra.model_json);
      DefineDetailsWizardService.setItemsFromModelJson(ModalExtra.name, ModalExtra.model_json);
      details.current_step = DefineDetailsWizardService.getStepSelected();
    };

    var ltn = $rootScope.$on('UPDATE_WIZARD_DATA', function () {
      details.data = DefineDetailsWizardService.getData();
    });

    /**
     * Fecha modal
     */
    details.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    details.moveToPreviousStep = function () {
      DefineDetailsWizardService.moveToPreviousStep();
      $scope.$emit('UPDATE_WIZARD_DATA');
      details.current_step = DefineDetailsWizardService.getStepSelected();
      details.isLastStep = DefineDetailsWizardService.isLastStep();
    };

    details.moveToNextStep = function () {
      var current_step = DefineDetailsWizardService.getCurrentStep(details.current_step);
      $rootScope.$broadcast('GO_TO_NEXT_STEP', {current_step: current_step.name});
      details.current_step = DefineDetailsWizardService.getStepSelected();
      details.isLastStep = DefineDetailsWizardService.isLastStep();
    };

    details.finishWizard = function () {
      if (DefineDetailsWizardService.getColumns().length === 0) {
        Common.Toast.warning('Selecione as colunas do relatório');
        return;
      }

      $rootScope.show_loader = true;
      DefineDetailsWizardService.setStepSelected($scope.details.data.stepSelected);
      DefineDetailsWizardService.finishReport($scope.details.id)
        .then(function (response) {
          if (response) {
            $scope.$emit('UPDATE_WIZARD_DATA');
            details.close();
            Common.Toast.success('Detalhes do relatório atualizado com sucesso.');
            $rootScope.show_loader = false;
          }
        })
        .catch(function (error) {
          Common.Toast.error(error.data.message);
          $rootScope.show_loader = false;
        });
    };

    details.init();

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (t) {
        t()
      })
    })
  }

  angular
    .module('app.controlpanel.central-reports-define-details-wizard')
    .controller('DefineDetailsWizardController', DefineDetailsWizardController)
})();
(function () {
  'use strict';

  angular.module('app.crm.charge-report', []);

})();
(function () {
  'use strict';

  function ChargeReportController($scope, $document, $rootScope, CONFIG, Session, ReportsService) {
    var vm = this;
    vm.option = null;
    vm.disable = true;
    vm.webLink = CONFIG.webApiUri;
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    vm.generateReport = function () {
      var href = vm.webLink + 'api/charges/chargereport?token=' + vm.conf.token + '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        '&option=' + vm.option + '&user_id=' + vm.conf.user_id +
        '&start_date=' + vm.filter_date.startDate + '&final_date=' + vm.filter_date.endDate;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.init = function () {
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };

    vm.init();
  }

  angular.module('app.crm.charge-report')
    .controller('ChargeReportController', ChargeReportController);
})();
(function () {
  'use strict';

  angular
    .module('app.crm.leads', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.crm.lead', {
        url: '/lead/:person_id',
        params: {
          person_id: null
        },
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/crm/leads/lead/views/lead.html',
        controller: 'LeadController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.crm.leads')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function LeadController($window, $scope, $q, $a4FloatButton, $stateParams, Common, LeadsService, ModalFactory, $rootScope) {
    var vm = this;
    vm.person_id = $stateParams.person_id;
    vm.lead = null;
    vm.contacts = null;
    vm.timelineOptions = {
      scrollEl: '#content'
    };
    vm.type = 'prospects';

    vm.isEdit = false;

    vm.icons = {
      1: 'icon-account-multiple',
      2: 'icon-phone',
      5: 'icon-email',
      4: 'icon-book-open',
      6: 'icon-whatsapp',
      7: 'icon-skype'
    };

    vm.loadNextPage = function () {
      var deferred = $q.defer();
      deferred.resolve();
    };

    vm.backPage = function () {
      $window.history.back();
    };

    /**
     * Abre modal de criação de evento de cobrança
     */
    vm.openCreateModal = function () {
      ModalFactory.customClean('app/crm/charge/charge-modal.html',
        'ChargeModalController', 'vm', false, {
          type: vm.type,
          responsible: {
            id: vm.person_id,
            name: vm.lead.name
          }
        }).then(function (response) {
        if (response) {
          vm.getLead();
        }
      })
    };

    vm.getLead = function () {
      $rootScope.show_loader = true;
      LeadsService.getById(vm.person_id).then(function (response) {
        var objectResponse = response.plain();
        vm.lead = objectResponse.lead;
        vm.contacts = objectResponse.contacts;
        vm.events = objectResponse.events.map(function (item) {
          item.icons = vm.icons;
          return item;
        });
        vm.cnpjInfos = objectResponse.cnpjInfos;
        if (vm.cnpjInfos !== null) {
          vm.matrizFiliais = vm.cnpjInfos.filter(function (item) {
            return item.tipo_resultado === 2;
          });
          vm.outrasEmpresasSocios = vm.cnpjInfos.filter(function (item) {
            return item.tipo_resultado === 3;
          });
        }
        // console.log(vm.matrizFiliais);
        // console.log(vm.outrasEmpresasSocios);

        $rootScope.show_loader = false;
        // console.log(vm.lead);
        // console.log(vm.contacts);
        // console.log(vm.events);
        // console.log(vm.cnpjInfos);
      })
    };

    vm.editEvent = function (item) {
      var charge = angular.copy(item);
      charge.person_id_contacts = JSON.parse(charge.person_id_contacts);
      ModalFactory.customClean('app/crm/charge/charge-modal.html',
        'ChargeModalEditController', 'vm', false, {
          type: $scope.type,
          form: charge,
          responsible_name: angular.copy(item.responsible_name),
          person_event_name: angular.copy(item.person_event_name)
        }).then(function (response) {
        if (response) {
          vm.getLead();
        }
      })
    };

    vm.createEvent = function () {
      vm.openCreateModal();
    };

    vm.editLead = function () {
      ModalFactory.customClean("app/crm/leads/views/modal.html",
        "LeadsModalController", "vm", false, {lead: angular.copy(vm.lead), contacts: angular.copy(vm.contacts)})
        .then(function (response) {
          if (response) {
            Common.Toast.success("Lead atualizado com sucesso!");
            vm.getLead();
          }
        });
    };

    vm.init = function () {
      vm.getLead();
      // vm.floatButton = $a4FloatButton({
      //   scope: $scope, onClick: 'vm.openCreateModal()', label: 'Criar nova ocorrência', theme: 'crm'
      // });
    };

    vm.init();

  }

  angular.module('app.crm.leads')
    .controller('LeadController', LeadController);
})();

(function () {
  'use strict';
  angular.module('app.crm.emailmanagement', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('crm.individual-email-management', {
      title: 'E-mails individuais',
      icon: 'icon-email',
      state: 'private.crm.individual-email-management',
      class: "md-primary",
      weight: 6
    });
  }

  angular
    .module('app.crm.emailmanagement')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function IndividualEmailManagementController($scope, $rootScope, a4Moment, EmailManagementService) {
    var vm = this;
    vm.emails = [];
    vm.searchSubject = '';
    vm.searchDestinatary = '';
    vm.filter_date = {
      startDate: a4Moment().subtract(3, 'years').startOf('year'),
      endDate: a4Moment().endOf('year')
    };


    vm.getAll = function (page, limit, subject, destinatary) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 15;
      page = angular.isDefined(page) ? page : 1;
      EmailManagementService.getAllIndividual({
        limit: limit, page: page,
        subject: subject,
        destinatary: destinatary,
        startDate: a4Moment(vm.filter_date.startDate).format('YYYY-MM-DD'),
        endDate: a4Moment(vm.filter_date.endDate).format('YYYY-MM-DD')
      }).then(function (response) {
        vm.emails = response.plain();
        $rootScope.show_loader = false;
      })
    };

    vm.init = function () {
      vm.getAll();
    };

    vm.init();

  }

  angular.module('app.crm.emailmanagement')
    .controller('IndividualEmailManagementController', IndividualEmailManagementController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('crm.grouped-email-management', {
      title: 'E-mails agrupados',
      icon: 'icon-email',
      state: 'private.crm.grouped-email-management',
      class: "md-primary",
      weight: 7
    });
  }

  angular
    .module('app.crm.emailmanagement')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function GroupedEmailManagementController($scope, $rootScope, a4Moment, EmailManagementService) {
    var vm = this;
    vm.emails = [];
    vm.filter_date = {
      startDate: a4Moment().subtract(3, 'years').startOf('year'),
      endDate: a4Moment().endOf('year')
    };

    vm.getAll = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 15;
      page = angular.isDefined(page) ? page : 1;
      EmailManagementService.getAllGrouped({
        limit: limit, page: page,
        startDate: a4Moment(vm.filter_date.startDate).format('YYYY-MM-DD'),
        endDate: a4Moment(vm.filter_date.endDate).format('YYYY-MM-DD')
      }).then(function (response) {
        vm.emails = response.plain();
        $rootScope.show_loader = false;
      })
    };

    vm.init = function () {
      vm.getAll();
    };

    vm.init();

  }

  angular.module('app.crm.emailmanagement')
    .controller('GroupedEmailManagementController', GroupedEmailManagementController);
})();
/*
 The MIT License (MIT)

 Copyright (c) 2014 Muhammed Ashik

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */

/*jshint indent: 2 */
/*global angular: false */

(function () {
  'use strict';
  angular.module('multi-select-tree', []);
}());

/*jshint indent: 2 */
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('multi-select-tree');

  /**
   * Controller for sortable item.
   *
   * @param $scope - drag item scope
   */
  mainModule.controller('treeItemCtrl', ['$scope', function ($scope) {

    $scope.item.isExpanded = false;

    /**
     * Shows the expand option.
     *
     * @param item the item
     * @returns {*|boolean}
     */
    $scope.showExpand = function (item) {
      return item.children && item.children.length > 0;
    };

    /**
     * On expand clicked toggle the option.
     *
     * @param item the item
     * @param $event
     */
    $scope.onExpandClicked = function (item, $event) {
      $event.stopPropagation();
      item.isExpanded = !item.isExpanded;
    };

    /**
     * Event on click of select item.
     *
     * @param item the item
     * @param $event
     */
    $scope.clickSelectItem = function (item, $event) {
      $event.stopPropagation();
      if ($scope.itemSelected) {
        $scope.itemSelected({item: item});
      }
    };

    /**
     * Is leaf selected.
     *
     * @param item the item
     * @param $event
     */
    $scope.subItemSelected = function (item, $event) {
      if ($scope.itemSelected) {
        $scope.itemSelected({item: item});
      }
    };

    /**
     * Active sub item.
     *
     * @param item the item
     * @param $event
     */
    $scope.activeSubItem = function (item, $event) {
      if ($scope.onActiveItem) {
        $scope.onActiveItem({item: item});
      }
    };

    /**
     * On mouse over event.
     *
     * @param item the item
     * @param $event
     */
    $scope.onMouseOver = function (item, $event) {
      $event.stopPropagation();
      if ($scope.onActiveItem) {
        $scope.onActiveItem({item: item});
      }
    };

    /**
     * Can select item.
     *
     * @returns {*}
     */
    $scope.showCheckbox = function () {
      if (!$scope.multiSelect) {
        return false;
      }

      if ($scope.selectOnlyLeafs) {
        return false;
      }

      if ($scope.useCallback) {
        return $scope.canSelectItem($scope.item);
      }
    };

  }]);

  /**
   * sortableItem directive.
   */
  mainModule.directive('treeItem', ['$compile',
    function ($compile) {
      return {
        restrict: 'E',
        templateUrl: 'app/components/multi-select-tree/src/tree-item.tpl.html',
        scope: {
          item: '=',
          itemSelected: '&',
          onActiveItem: '&',
          multiSelect: '=?',
          selectOnlyLeafs: '=?',
          isActive: '=', // the item is active - means it is highlighted but not selected
          useCallback: '=',
          canSelectItem: '=' // reference from the parent control
        },
        controller: 'treeItemCtrl',
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        compile: function (element, attrs, link) {
          // Normalize the link parameter
          if (angular.isFunction(link)) {
            link = { post: link };
          }

          // Break the recursion loop by removing the contents
          var contents = element.contents().remove();
          var compiledContents;
          return {
            pre: (link && link.pre) ? link.pre : null,
            /**
             * Compiles and re-adds the contents
             */
            post: function (scope, element, attrs) {
              // Compile the contents
              if (!compiledContents) {
                compiledContents = $compile(contents);
              }
              // Re-add the compiled contents to the element
              compiledContents(scope, function (clone) {
                element.append(clone);
              });

              // Call the post-linking function, if any
              if (link && link.post) {
                link.post.apply(null, arguments);
              }
            }
          };
        }
      };
    }]);
}());
/*jshint indent: 2 */
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('multi-select-tree');

  /**
   * Controller for multi select tree.
   */
  mainModule.controller('multiSelectTreeCtrl', ['$scope', '$document', function ($scope, $document) {

    var activeItem;

    $scope.showTree = false;
    $scope.selectedItems = [];
    $scope.multiSelect = $scope.multiSelect || false;

    /**
     * Clicking on document will hide the tree.
     */
    function docClickHide() {
      closePopup();
      $scope.$apply();
    }

    /**
     * Closes the tree popup.
     */
    function closePopup() {
      $scope.showTree = false;
      if (activeItem) {
        activeItem.isActive = false;
        activeItem = undefined;
      }
      $document.off('click', docClickHide);
    }

    /**
     * Sets the active item.
     *
     * @param item the item element.
     */
    $scope.onActiveItem = function (item) {
      if (activeItem !== item) {
        if (activeItem) {
          activeItem.isActive = false;
        }
        activeItem = item;
        activeItem.isActive = true;
      }
    };

    /**
     * Copies the selectedItems in to output model.
     */
    $scope.refreshOutputModel = function () {
      $scope.outputModel = angular.copy($scope.selectedItems);
    };

    /**
     * Refreshes the selected Items model.
     */
    $scope.refreshSelectedItems = function () {
      $scope.selectedItems = [];
      if ($scope.inputModel) {
        setSelectedChildren($scope.inputModel);
      }
    };

    /**
     * Iterates over children and sets the selected items.
     *
     * @param children the children element.
     */
    function setSelectedChildren(children) {
      for (var i = 0, len = children.length; i < len; i++) {
        if (!isItemSelected(children[i]) && children[i].selected === true) {
          $scope.selectedItems.push(children[i]);
        } else if (isItemSelected(children[i]) && children[i].selected === false) {
          children[i].selected = true;
        }
        if (children[i] && children[i].children) {
          setSelectedChildren(children[i].children);
        }
      }
    }
    /**
     * Checks of the item is already selected.
     *
     * @param item the item to be checked.
     * @return {boolean} if the item is already selected.
     */
    function isItemSelected(item) {
      var isSelected = false;
      if ($scope.selectedItems) {
        for (var i = 0; i < $scope.selectedItems.length; i++) {
          if ($scope.selectedItems[i].id === item.id) {
            isSelected = true;
            break;
          }
        }
      }
      return isSelected;
    }

    /**
     * Deselect the item.
     *
     * @param item the item element
     * @param $event
     */
    $scope.deselectItem = function (item, $event) {
      $event.stopPropagation();
      $scope.selectedItems.splice($scope.selectedItems.indexOf(item), 1);
      item.selected = false;
      this.refreshOutputModel();
    };

    /**
     * Swap the tree popup on control click event.
     *
     * @param $event the click event.
     */
    $scope.onControlClicked = function ($event) {
      $event.stopPropagation();
      $scope.showTree = !$scope.showTree;
      if ($scope.showTree) {
        $document.on('click', docClickHide);
      }
    };

    /**
     * Stop the event on filter clicked.
     *
     * @param $event the click event
     */
    $scope.onFilterClicked = function ($event) {
      $event.stopPropagation();
    };

    /**
     * Clears the filter text.
     *
     * @param $event the click event
     */
    $scope.clearFilter = function ($event) {
      $event.stopPropagation();
      $scope.filterKeyword = '';
    };

    /**
     * Wrapper function for can select item callback.
     *
     * @param item the item
     */
    $scope.canSelectItem = function (item) {
      return $scope.callback({item: item, selectedItems: $scope.selectedItems});
    };

    /**
     * The callback is used to switch the views.
     * based on the view type.
     *
     * @param $event the event object.
     */
    $scope.switchCurrentView = function($event) {
      $event.stopPropagation();
      $scope.switchViewCallback({scopeObj:$scope});
    };

    /**
     * Handles the item select event.
     *
     * @param item the selected item.
     */
    $scope.itemSelected = function (item) {
      if (($scope.useCallback && $scope.canSelectItem(item) === false) ||
        ($scope.selectOnlyLeafs && item.children && item.children.length > 0)) {
        return;
      }

      if (!$scope.multiSelect) {
        closePopup();
        for (var i = 0; i < $scope.selectedItems.length; i++) {
          $scope.selectedItems[i].selected = false;
        }
        item.selected = true;
        $scope.selectedItems = [];
        $scope.selectedItems.push(item);
      } else {
        item.selected = true;
        var indexOfItem = $scope.selectedItems.indexOf(item);
        if (isItemSelected(item)) {
          item.selected = false;
          $scope.selectedItems.splice(indexOfItem, 1);
        } else {
          $scope.selectedItems.push(item);
        }
      }
      this.refreshOutputModel();
    };

  }]);

  /**
   * sortableItem directive.
   */
  mainModule.directive('multiSelectTree',
    function () {
      return {
        restrict: 'E',
        templateUrl: 'app/components/multi-select-tree/src/multi-select-tree.tpl.html',
        scope: {
          inputModel: '=',
          outputModel: '=?',
          multiSelect: '=?',
          switchView: '=?',
          switchViewLabel: '@',
          switchViewCallback: '&',
          selectOnlyLeafs: '=?',
          callback: '&',
          defaultLabel: '@'
        },
        link: function (scope, element, attrs) {
          if (attrs.callback) {
            scope.useCallback = true;
          }

          // watch for changes in input model as a whole
          // this on updates the multi-select when a user load a whole new input-model.
          scope.$watch('inputModel', function (newVal) {
            if (newVal) {
              scope.refreshSelectedItems();
              scope.refreshOutputModel();
            }
          });

          /**
           * Checks whether any of children match the keyword.
           *
           * @param item the parent item
           * @param keyword the filter keyword
           * @returns {boolean} false if matches.
           */
          function isChildrenFiltered(item, keyword) {
            var childNodes = getAllChildNodesFromNode(item, []);
            for (var i = 0, len = childNodes.length; i < len; i++) {
              if (childNodes[i].name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) {
                return false;
              }
            }
            return true;
          }

          /**
           * Return all childNodes of a given node (as Array of Nodes)
           */
          function getAllChildNodesFromNode(node, childNodes) {
            for (var i = 0; i < node.children.length; i++) {
              childNodes.push(node.children[i]);
              // add the childNodes from the children if available
              getAllChildNodesFromNode(node.children[i], childNodes);
            }
            return childNodes;
          }

          scope.$watch('filterKeyword', function () {
            if (scope.filterKeyword !== undefined) {
              angular.forEach(scope.inputModel, function (item) {
                if (item.name.toLowerCase().indexOf(scope.filterKeyword.toLowerCase()) !== -1) {
                  item.isFiltered = false;
                } else if (!isChildrenFiltered(item, scope.filterKeyword)) {
                  item.isFiltered = false;
                } else {
                  item.isFiltered = true;
                }
              });
            }
          });
        },
        controller: 'multiSelectTreeCtrl'
      };
    });
}());
(function () {
  'use strict';

  angular
    .module('app.a4-upload-image', []);
})();

(function () {
    'use strict';

    /** @ngInject */
    function UploadImageTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "UPLOAD_IMAGE": {
                "CHANGE": "Alterar imagem",
                "EDIT": "Editar imagem",
                "SELECT": "Selecione a imagem"
            }
        })

    }

    angular
        .module('app.a4-upload-image')
        .config(UploadImageTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.core', [])
    .provider('msNavigationService', msNavigationServiceProvider)
    .controller('MsNavigationController', MsNavigationController)
    // Vertical
    .directive('msNavigation', msNavigationDirective)
    .controller('MsNavigationNodeController', MsNavigationNodeController)
    .directive('msNavigationNode', msNavigationNodeDirective)
    .directive('msNavigationItem', msNavigationItemDirective)
    //Horizontal
    .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
    .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
    .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
    .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

  /** @ngInject */
  function msNavigationServiceProvider() {
    // Inject $log service
    var $log = angular.injector(['ng']).get('$log');

    // Navigation array
    var navigation = [];

    var service = this;

    // Methods
    service.saveItem = saveItem;
    service.deleteItem = deleteItem;
    service.sortByWeight = sortByWeight;

    //////////

    /**
     * Create or update the navigation item
     *
     * @param path
     * @param item
     */
    function saveItem(path, item) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      var parts = path.split('.');

      // Generate the object id from the parts
      var id = parts[parts.length - 1];

      // Get the parent item from the parts
      var parent = _findOrCreateParent(parts);

      // Decide if we are going to update or create
      var updateItem = false;

      for (var i = 0; i < parent.length; i++) {
        if (parent[i]._id === id) {
          updateItem = parent[i];

          break;
        }
      }

      // Update
      if (updateItem) {
        angular.extend(updateItem, item);

        // Add proper ui-sref
        updateItem.uisref = _getUiSref(updateItem);
      }
      // Create
      else {
        // Create an empty children array in the item
        item.children = [];

        // Add the default weight if not provided or if it's not a number
        if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
          item.weight = 1;
        }

        // Add the item id
        item._id = id;

        // Add the item path
        item._path = path;

        // Add proper ui-sref
        item.uisref = _getUiSref(item);

        // Push the item into the array
        parent.push(item);
      }
    }

    /**
     * Delete navigation item
     *
     * @param path
     */
    function deleteItem(path) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      // Locate the item by using given path
      var item = navigation,
        parts = path.split('.');

      for (var p = 0; p < parts.length; p++) {
        var id = parts[p];

        for (var i = 0; i < item.length; i++) {
          if (item[i]._id === id) {
            // If we have a matching path,
            // we have found our object:
            // remove it.
            if (item[i]._path === path) {
              item.splice(i, 1);
              return true;
            }

            // Otherwise grab the children of
            // the current item and continue
            item = item[i].children;
            break;
          }
        }
      }

      return false;
    }

    /**
     * Sort the navigation items by their weights
     *
     * @param parent
     */
    function sortByWeight(parent) {
      // If parent not provided, sort the root items
      if (!parent) {
        parent = navigation;
        parent.sort(_byWeight);
      }

      // Sort the children
      for (var i = 0; i < parent.length; i++) {
        var children = parent[i].children;

        if (children.length > 1) {
          children.sort(_byWeight);
        }

        if (children.length > 0) {
          sortByWeight(children);
        }
      }
    }

    /* ----------------- */
    /* Private Functions */

    /* ----------------- */

    /**
     * Find or create parent
     *
     * @param parts
     * @returns {Array|Boolean}
     * @private
     */
    function _findOrCreateParent(parts) {
      // Store the main navigation
      var parent = navigation;

      // If it's going to be a root item
      // return the navigation itself
      if (parts.length === 1) {
        return parent;
      }

      // Remove the last element from the parts as
      // we don't need that to figure out the parent
      parts.pop();

      // Find and return the parent
      for (var i = 0; i < parts.length; i++) {
        var _id = parts[i],
          createParent = true;

        for (var p = 0; p < parent.length; p++) {
          if (parent[p]._id === _id) {
            parent = parent[p].children;
            createParent = false;

            break;
          }
        }

        // If there is no parent found, create one, push
        // it into the current parent and assign it as a
        // new parent
        if (createParent) {
          var item = {
            _id: _id,
            _path: parts.join('.'),
            title: _id,
            weight: 1,
            children: []
          };

          parent.push(item);
          parent = item.children;
        }
      }

      return parent;
    }

    /**
     * Sort by weight
     *
     * @param x
     * @param y
     * @returns {number}
     * @private
     */
    function _byWeight(x, y) {
      return parseInt(x.weight) - parseInt(y.weight);
    }

    /**
     * Setup the ui-sref using state & state parameters
     *
     * @param item
     * @returns {string}
     * @private
     */
    function _getUiSref(item) {
      var uisref = '';

      if (angular.isDefined(item.state)) {
        uisref = item.state;

        if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
          uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
        }
      }

      return uisref;
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */

    this.$get = function () {
      var activeItem = null,
        navigationScope = null,
        folded = null,
        foldedOpen = null;

      var service = {
        saveItem: saveItem,
        deleteItem: deleteItem,
        sort: sortByWeight,
        clearNavigation: clearNavigation,
        setActiveItem: setActiveItem,
        getActiveItem: getActiveItem,
        getNavigation: getNavigation,
        getFlatNavigation: getFlatNavigation,
        setNavigationScope: setNavigationScope,
        setFolded: setFolded,
        getFolded: getFolded,
        setFoldedOpen: setFoldedOpen,
        getFoldedOpen: getFoldedOpen,
        toggleFolded: toggleFolded
      };

      return service;

      //////////

      /**
       * Clear the entire navigation
       */
      function clearNavigation() {
        // Clear the navigation array
        navigation = [];

        // Clear the vm.navigation from main controller
        if (navigationScope) {
          navigationScope.vm.navigation = navigation;
        }
      }

      /**
       * Set active item
       *
       * @param node
       * @param scope
       */
      function setActiveItem(node, scope) {
        activeItem = {
          node: node,
          scope: scope
        };
      }

      /**
       * Return active item
       */
      function getActiveItem() {
        return activeItem;
      }

      /**
       * Return navigation array
       *
       * @param root
       * @returns Array
       */
      function getNavigation(root) {
        if (root) {
          for (var i = 0; i < navigation.length; i++) {
            if (navigation[i]._id === root) {
              return [navigation[i]];
            }
          }

          return null;
        }

        return navigation;
      }

      /**
       * Return flat navigation array
       *
       * @param root
       * @returns Array
       */
      function getFlatNavigation(root) {
        // Get the correct navigation array
        var navigation = getNavigation(root);

        // Flatten the navigation object
        return _flattenNavigation(navigation);
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function setNavigationScope(scope) {
        navigationScope = scope;
      }

      /**
       * Set folded status
       *
       * @param status
       */
      function setFolded(status) {
        folded = status;
      }

      /**
       * Return folded status
       *
       * @returns {*}
       */
      function getFolded() {
        return folded;
      }

      /**
       * Set folded open status
       *
       * @param status
       */
      function setFoldedOpen(status) {
        foldedOpen = status;
      }

      /**
       * Return folded open status
       *
       * @returns {*}
       */
      function getFoldedOpen() {
        return foldedOpen;
      }


      /**
       * Toggle fold on stored navigation's scope
       */
      function toggleFolded() {
        navigationScope.toggleFolded();
      }

      /**
       * Flatten the given navigation
       *
       * @param navigation
       * @private
       */
      function _flattenNavigation(navigation) {
        var flatNav = [];

        for (var x = 0; x < navigation.length; x++) {
          // Copy and clear the children of the
          // navigation that we want to push
          var navToPush = angular.copy(navigation[x]);
          navToPush.children = [];

          // Push the item
          flatNav.push(navToPush);

          // If there are child items in this navigation,
          // do some nested function magic
          if (navigation[x].children.length > 0) {
            flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
          }
        }

        return flatNav;
      }
    };
  }

  /** @ngInject */
  function MsNavigationController($scope, msNavigationService) {
    var vm = this;

    // Data
    if ($scope.root) {
      vm.navigation = msNavigationService.getNavigation($scope.root);
    } else {
      vm.navigation = msNavigationService.getNavigation();
    }

    // Methods
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Sort the navigation before doing anything else
      msNavigationService.sort();
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }
  }

  /** @ngInject */
  function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        folded: '=',
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl: 'app/components/ms-navigation/templates/vertical.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation');

        return function postLink(scope, iElement) {
          var bodyEl = angular.element('body'),
            foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
            foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
            sidenav = $mdSidenav('navigation');

          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);

          // Initialize
          init();

          /**
           * Initialize
           */
          function init() {
            // Set the folded status for the first time.
            // First, we have to check if we have a folded
            // status available in the service already. This
            // will prevent navigation to act weird if we already
            // set the fold status, remove the navigation and
            // then re-initialize it, which happens if we
            // change to a view without a navigation and then
            // come back with history.back() function.

            // If the service didn't initialize before, set
            // the folded status from scope, otherwise we
            // won't touch anything because the folded status
            // already set in the service...
            if (msNavigationService.getFolded() === null) {
              msNavigationService.setFolded(scope.folded);
            }

            if (msNavigationService.getFolded()) {
              // Collapse everything.
              // This must be inside a $timeout because by the
              // time we call this, the 'msNavigation::collapse'
              // event listener is not registered yet. $timeout
              // will ensure that it will be called after it is
              // registered.
              $timeout(function () {
                $rootScope.$broadcast('msNavigation::collapse');
              });

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            }
          }

          // Sidenav locked open status watcher
          scope.$watch(function () {
            return sidenav.isLockedOpen();
          }, function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            var folded = msNavigationService.getFolded();

            if (folded) {
              if (current) {
                // Collapse everything
                $rootScope.$broadcast('msNavigation::collapse');
              } else {
                // Expand the active one and its parents
                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                  activeItem.scope.$emit('msNavigation::stateMatched');
                }
              }
            }
          });

          // Folded status watcher
          scope.$watch('folded', function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            setFolded(current);
          });

          /**
           * Set folded status
           *
           * @param folded
           */
          function setFolded(folded) {
            // Store folded status on the service for global access
            msNavigationService.setFolded(folded);

            if (folded) {
              // Collapse everything
              $rootScope.$broadcast('msNavigation::collapse');

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            } else {
              // Expand the active one and its parents
              var activeItem = msNavigationService.getActiveItem();
              if (activeItem) {
                activeItem.scope.$emit('msNavigation::stateMatched');
              }

              // Remove body class
              bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

              // Remove fold collapser
              removeFoldCollapser();
            }
          }

          /**
           * Set fold expander
           */
          function setFoldExpander() {
            iElement.parent().append(foldExpanderEl);

            // Let everything settle for a moment
            // before registering the event listener
            $timeout(function () {
              foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
            });
          }

          /**
           * Set fold collapser
           */
          function setFoldCollapser() {
            bodyEl.find('#main').append(foldCollapserEl);
            foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
          }

          /**
           * Remove fold collapser
           */
          function removeFoldCollapser() {
            foldCollapserEl.remove();
          }

          /**
           * onHover event of foldExpander
           */
          function onFoldExpanderHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(true);

            // Expand the active one and its parents
            var activeItem = msNavigationService.getActiveItem();
            if (activeItem) {
              activeItem.scope.$emit('msNavigation::stateMatched');
            }

            // Add class to the body
            bodyEl.addClass('ms-navigation-folded-open');

            // Remove the fold opener
            foldExpanderEl.remove();

            // Set fold collapser
            setFoldCollapser();
          }

          /**
           * onHover event of foldCollapser
           */
          function onFoldCollapserHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(false);

            // Collapse everything
            $rootScope.$broadcast('msNavigation::collapse');

            // Remove body class
            bodyEl.removeClass('ms-navigation-folded-open');

            // Remove the fold collapser
            foldCollapserEl.remove();

            // Set fold expander
            setFoldExpander();
          }

          /**
           * Public access for toggling folded status externally
           */
          scope.toggleFolded = function () {
            var folded = msNavigationService.getFolded();

            setFolded(!folded);
          };

          /**
           * On $stateChangeStart
           */
          scope.$on('$stateChangeStart', function () {
            // Close the sidenav
            sidenav.close();
          });

          // Cleanup
          scope.$on('$destroy', function () {
            foldCollapserEl.off('mouseenter touchstart');
            foldExpanderEl.off('mouseenter touchstart');
          });
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationNodeController($scope, $element, $timeout, $rootScope, $animate, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.collapsed = undefined;
    vm.collapsable = undefined;
    vm.group = undefined;
    vm.animateHeightClass = 'animate-height';

    // Methods
    vm.toggleCollapsed = toggleCollapsed;
    vm.collapse = collapse;
    vm.expand = expand;
    vm.getClass = getClass;
    vm.isHidden = isHidden;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values
      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Is collapsable?
      if (!vm.hasChildren || vm.group) {
        vm.collapsable = false;
      } else {
        vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
      }

      // Is collapsed?
      if (!vm.collapsable) {
        vm.collapsed = false;
      } else {
        vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
      }

      // Expand all parents if we have a matching state or
      // the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }


      $scope.$on('msNavigation::stateMatched', function () {
        // Expand if the current scope is collapsable and is collapsed
        if (vm.collapsable && vm.collapsed) {
          $scope.$evalAsync(function () {
            vm.collapsed = false;
          });
        }
      });

      // Listen for collapse event
      $scope.$on('msNavigation::collapse', function (event, path) {
        if (vm.collapsed || !vm.collapsable) {
          return;
        }

        // If there is no path defined, collapse
        if (angular.isUndefined(path)) {
          vm.collapse();
        }
        // If there is a path defined, do not collapse
        // the items that are inside that path. This will
        // prevent parent items from collapsing
        else {
          var givenPathParts = path.split('.'),
            activePathParts = [];

          var activeItem = msNavigationService.getActiveItem();
          if (activeItem) {
            activePathParts = activeItem.node._path.split('.');
          }

          // Test for given path
          if (givenPathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          // Test for active path
          if (activePathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          vm.collapse();
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Collapse everything except the one we're using
          $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
        }

        // Expand the parents if we the current
        // state is a child of the node's state
        if ($state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Emit the stateMatched
          $scope.$emit('msNavigation::stateMatched');
        }
      });

      // if (vm.node._id === "knowledge" || vm.node._id === "questionnaire" || vm.node._id === "eval-configurations") {
      //   vm.collapsed = false;
      // }
    }

    /**
     * Toggle collapsed
     */
    function toggleCollapsed() {
      if (vm.collapsed) {
        vm.expand();
      } else {
        vm.collapse();
      }
    }

    /**
     * Collapse
     */
    function collapse() {
      // Grab the element that we are going to collapse
      var collapseEl = vm.element.children('ul');

      // Grab the height
      var height = collapseEl[0].offsetHeight;

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = true;

        // Add collapsing class to the node
        vm.element.addClass('collapsing');

        // Animate the height
        $animate.animate(collapseEl,
          {
            'display': 'block',
            'height': height + 'px'
          },
          {
            'height': '0px'
          },
          vm.animateHeightClass
        ).then(
          function () {
            // Clear the inline styles after animation done
            collapseEl.css({
              'display': '',
              'height': ''
            });

            // Clear collapsing class from the node
            vm.element.removeClass('collapsing');
          }
        );

        // Broadcast the collapse event so child items can also be collapsed
        $scope.$broadcast('msNavigation::collapse');
      });
    }

    /**
     * Expand
     */
    function expand() {
      // Grab the element that we are going to expand
      var expandEl = vm.element.children('ul');

      // Move the element out of the dom flow and
      // make it block so we can get its height
      expandEl.css({
        'position': 'absolute',
        'visibility': 'hidden',
        'display': 'block',
        'height': 'auto'
      });

      // Grab the height
      var height = expandEl[0].offsetHeight;

      // Reset the style modifications
      expandEl.css({
        'position': '',
        'visibility': '',
        'display': '',
        'height': ''
      });

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = false;

        // Add expanding class to the node
        vm.element.addClass('expanding');

        // Animate the height
        $animate.animate(expandEl,
          {
            'display': 'block',
            'height': '0px'
          },
          {
            'height': height + 'px'
          },
          vm.animateHeightClass
        ).then(
          function () {
            // Clear the inline styles after animation done
            expandEl.css({
              'height': ''
            });

            // Clear expanding class from the node
            vm.element.removeClass('expanding');
          }
        );

        // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
        // can be collapsed. This is necessary for keeping only one parent expanded at any time
        $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }

    /**
     * Check if node should be hidden
     *
     * @returns {boolean}
     */
    function isHidden() {
      if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
        return vm.node.hidden();
      }

      return false;
    }
  }

  /** @ngInject */
  function msNavigationNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationNode'
      },
      controller: 'MsNavigationNodeController as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-node');

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationItemDirective() {
    return {
      restrict: 'A',
      require: '^msNavigationNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-item');

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // If the item is collapsable...
          if (MsNavigationNodeCtrl.collapsable) {
            iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalDirective(msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal');

        return function postLink(scope) {
          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationHorizontalNodeController($scope, $timeout, $element, $rootScope, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.group = undefined;

    // Methods
    vm.getClass = getClass;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Is active
      vm.isActive = false;

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Mark all parents as active if we have a matching state
      // or the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on('msNavigation::stateMatched', function () {
        // Mark as active if has children
        if (vm.hasChildren) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        }
      });

      // Listen for clearActive event
      $scope.$on('msNavigation::clearActive', function () {
        if (!vm.hasChildren) {
          return;
        }

        var activePathParts = [];

        var activeItem = msNavigationService.getActiveItem();
        if (activeItem) {
          activePathParts = activeItem.node._path.split('.');
        }

        // Test for active path
        if (activePathParts.indexOf(vm.node._id) > -1) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        } else {
          $scope.$evalAsync(function () {
            vm.isActive = false;
          });
        }

      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Clear all active states except the one we're using
          $rootScope.$broadcast('msNavigation::clearActive');
        }
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }
  }

  /** @ngInject */
  function msNavigationHorizontalNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationHorizontalNode'
      },
      controller: 'MsNavigationHorizontalNodeController as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-node');

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationHorizontalNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalItemDirective($mdMedia) {
    return {
      restrict: 'A',
      require: '^msNavigationHorizontalNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-item');

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          iElement.on('click', onClick);

          function onClick() {
            if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
              return;
            }

            iElement.toggleClass('expanded');
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }

})();


(function () {
    'use strict';

    /** @ngInject */
    function TableTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "TABLE": {
              "A_TO_Z": "de A à Z",
              "ADD_PERSON": "Adicionar",
              "ALL_ITEMS": "Todos",
              "BACK": "Voltar",
              "DELETE_ITEM": "Excluir",
              "EDIT": "Editar",
              "DELETE_SELECTED": "Excluir o selecionado",
              "FIRST_NAME": "Nome",
              "FREQUENTLY": "Frequentes",
              "GROUPS": "Grupos",
              "LAST_NAME": "Sobrenome",
              "NEW_GROUP": "Novo grupo",
              "NO_RESULTS": "Nenhum resultado",
              "SEARCH": "Buscar pessoa",
              "SEARCH_FOR_ANYONE": "Pesquisar",
              "SELECTED": "Selecionado",
              "STARRED_PERSONS": "Votados",
              "SELECT_ALL": "Selecionar todas",
              "TITLE": "Pessoas",
              "Z_TO_A": "de Z à A"
            }
        })

    }

    angular
        .module('app.core')
        .config(TableTranslate);
})();


(function () {
    'use strict';

    /** @ngInject */
    function TableTranslate($translateProvider) {

        $translateProvider.translations('pt', {
            "TABLE": {
              "A_TO_Z": "de A à Z",
              "ADD_PERSON": "Adicionar",
              "ALL_ITEMS": "Todos",
              "BACK": "Voltar",
              "DELETE_ITEM": "Excluir",
              "EDIT": "Editar",
              "DELETE_SELECTED": "Excluir o selecionado",
              "FIRST_NAME": "Nome",
              "FREQUENTLY": "Frequentes",
              "GROUPS": "Grupos",
              "LAST_NAME": "Sobrenome",
              "NEW_GROUP": "Novo grupo",
              "NO_RESULTS": "Nenhum resultado",
              "SEARCH": "Buscar pessoa",
              "SEARCH_FOR_ANYONE": "Pesquisar",
              "SELECTED": "Selecionado",
              "STARRED_PERSONS": "Votados",
              "SELECT_ALL": "Selecionar todas",
              "TITLE": "Pessoas",
              "Z_TO_A": "de Z à A"
            }
        })

    }

    angular
        .module('app.core')
        .config(TableTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.a4-contract', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4NegotiationIndividualDiscountsController($rootScope, ModalExtra, ModalFactory, Common, A4ContractService) {
    var vm = this;
    vm.discounts = [];
    vm.newdiscount = null;

    vm.init = function () {
      vm.bill_serie_id = ModalExtra.bill_serie_id;
      vm.contract_name = ModalExtra.contract_name;
      vm.theme = angular.isDefined(ModalExtra.theme) ? ModalExtra.theme : 'educational';
      vm.getIndDiscounts(vm.bill_serie_id);
    };


    /**
     * Discontos individuais do contrato;
     * @param bill_serie_id - identificador do contrato
     */
    vm.getIndDiscounts = function (bill_serie_id) {
      A4ContractService.getIndividualDiscounts(bill_serie_id)
        .then(function (discounts) {
          vm.discounts = discounts;
        });
    };


    /**
     * Criação de desconto individual
     */
    vm.createNewIndivialDiscount = function () {
      ModalFactory.customClean(
        'app/finance/individual-discounts/views/individual-discounts.html',
        'IndividualDiscountsController',
        'vm',
        true,
        {theme: 'finance'}
      ).then(function (newdiscount) {
        if (newdiscount !== 'canceled') {
          $rootScope.show_loader = true;
          A4ContractService.addIndividualDiscount(vm.bill_serie_id, newdiscount)
            .then(function () {
              $rootScope.show_loader = false;
              vm.reopenModal(vm.bill_serie_id);
              Common.Toast.success('Desconto Individual adicionado com sucesso');
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.error(error.message);
            });
        }
      })
    };


    vm.reopenModal = function (bill_serie) {
      ModalFactory.customClean(
        'app/components/a4-contract/individual-discounts/discounts.html',
        'A4ContractIndividualDiscountsController',
        'vm', false, {bill_serie_id: bill_serie.bill_serie_id, theme: vm.theme}
      )
        .then(function () {
        });
    };


    /**
     * Remove um desconto da lista
     */
    vm.removeItem = function (bill_serie_discount_id) {
      ModalFactory.confirm(
        null,
        'Deseja realmente remover este desconto individual?',
        ' ',
        'Remover',
        'Cancelar',
        vm.theme)
        .then(function () {
          $rootScope.show_loader = true;
          A4ContractService.removeIndividualDiscount(vm.bill_serie_id, bill_serie_discount_id)
            .then(function () {
              vm.reopenModal(vm.bill_serie_id);
              Common.Toast.success('Desconto Individual removido com sucesso');
              $rootScope.show_loader = false;
            })
            .catch(function (error) {
              Common.Toast.success(error.message);
              $rootScope.show_loader = false;
            })
        })
        .catch(function () {
          vm.reopenModal(vm.bill_serie_id);
        });
    };
    /**
     * Fecha modal
     * @param data
     */
    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.init();

  }

  angular.module('app.a4-contract')
    .controller('A4NegotiationIndividualDiscountsController', A4NegotiationIndividualDiscountsController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function A4ContractIndividualDiscountsController($rootScope, ModalExtra, ModalFactory, Common, A4ContractService) {
    var vm = this;
    vm.discounts = [];
    vm.newdiscount = null;

    vm.init = function () {
      vm.bill_serie_id = ModalExtra.bill_serie_id;
      vm.contract_name = ModalExtra.contract_name;
      vm.theme = angular.isDefined(ModalExtra.theme) ? ModalExtra.theme : 'educational';
      vm.getIndDiscounts(vm.bill_serie_id);
    };


    /**
     * Discontos individuais do contrato;
     * @param bill_serie_id - identificador do contrato
     */
    vm.getIndDiscounts = function (bill_serie_id) {
      A4ContractService.getIndividualDiscounts(bill_serie_id)
        .then(function (discounts) {
          vm.discounts = discounts;
        });
    };


    /**
     * Criação de desconto individual
     */
    vm.createNewDiscount = function () {
      ModalFactory.customClean(
        'app/components/a4-discounts/modal.html',
        'A4DiscountsController',
        'vm',
        true,
        {theme: 'finance'}
      ).then(function (newdiscount) {
        if (newdiscount !== 'canceled') {
          $rootScope.show_loader = true;
          A4ContractService.addIndividualDiscount(vm.bill_serie_id, newdiscount)
            .then(function () {
              $rootScope.show_loader = false;
              vm.reopenModal(vm.bill_serie_id);
              Common.Toast.success('Desconto Individual adicionado com sucesso');
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.error(error.message);
            });
        }
      })
    };

    vm.convertType = function (format) {
      switch (format) {
        case 'F':
          return 'Fixo';
        case 'C':
          return 'Condicional';
        case 'P':
          return 'Promocional';
      }
    };


    vm.reopenModal = function (bill_serie) {
      ModalFactory.customClean(
        'app/components/a4-contract/individual-discounts/discounts.html',
        'A4ContractIndividualDiscountsController',
        'vm', false, {bill_serie_id: bill_serie, theme: vm.theme}
      )
        .then(function () {
        });
    };


    /**
     * Remove um desconto da lista
     */
    vm.removeItem = function (bill_serie_discount_id) {
      ModalFactory.confirm(
        null,
        'Deseja realmente remover este desconto individual?',
        ' ',
        'Remover',
        'Cancelar',
        vm.theme)
        .then(function () {
          $rootScope.show_loader = true;
          A4ContractService.removeIndividualDiscount(vm.bill_serie_id, bill_serie_discount_id)
            .then(function () {
              vm.reopenModal(vm.bill_serie_id);
              Common.Toast.success('Desconto Individual removido com sucesso');
              $rootScope.show_loader = false;
            })
            .catch(function (error) {
              Common.Toast.success(error.message);
              $rootScope.show_loader = false;
            })
        })
        .catch(function () {
          vm.reopenModal(vm.bill_serie_id);
        });
    };
    /**
     * Fecha modal
     * @param data
     */
    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.init();

  }

  angular.module('app.a4-contract')
    .controller('A4ContractIndividualDiscountsController', A4ContractIndividualDiscountsController);

})();

(function () {
  'use strict';

  angular
    .module('app.stock.warehouse-transactions', []);

})();
(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.stock.warehouse-transactions', {
        url: '/warehouse-transactions',
        public: false,
        templateUrl: 'app/stock/warehouse-transactions/views/index.html',
        controller: 'WarehouseTransactionsController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Transactions'
        }
      });
  }

  angular
    .module('app.stock.warehouse-transactions')
    .config(routerConfig);


})();



(function() {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'transacoes_almoxarifado_menu';
    // var path = 'stock.warehouse-transactions';
    msNavigationService.saveItem('stock.warehouse-transactions', {
      title: 'Transações de almoxarifado',
      icon: 'icon-chart-histogram',
      state: 'private.stock.warehouse-transactions',
      auth: role,
      weight: 4,
      hidden: function () {
        return true;
      }
    });
  }

  angular
    .module('app.stock.warehouse-transactions')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function WarehouseTransactionsController($a4FloatButton, Common, StockService, $filter, $log, $timeout, $scope, $q, $rootScope,
                                  PoliciesService, TransactionsService, ModalFactory) {

    var vm = this;
    vm.grid = {};
    vm.paginate = function (limit, page) {
      $rootScope.show_loader = true;
      TransactionsService.getAllTransactions({
          limit: limit,
          page: page
        }
      ).then(function (response) {
        vm.grid.rows = [];
        vm.grid.rows = response.data;
        vm.grid.info = {
          limit_options: [20, 30, 50, 75, 100, {
            label: 'Todas',
            value: function () {
              return response.total;
            }
          }],
          limit: limit,
          page: page,
          total: response.total
        };
        $rootScope.show_loader = false;
      })
    };

    vm.createTransaction = function(){
      ModalFactory.customClean(
        'app/stock/transactions/views/form.html',
        'TransactionCreateEditController',
        'vm', false, {}
      ).then(function () {
        vm.getAllProducts();
      });
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init = function () {
      if(!vm.checkPolicies('estoque_alt')) {
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        theme: 'stock',
        label: 'Adicionar transação',
        icon: 'add',
        onClick: 'vm.createTransaction()'
      });
    }
      vm.paginate(20, 1);
    };

    vm.init();


  }

  angular
    .module('app.stock.warehouse-transactions')
    .controller('WarehouseTransactionsController', WarehouseTransactionsController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function StockService(Restangular) {

    var getProductById = function (id) {
      return Restangular.one('product').one('getById', id).get();
    };

    var getById = function (id) {
      return Restangular.one('product', id).get();
    };

    var getProductHistory = function (obj) {
      return Restangular.one('product', obj.id).one('getproducthistory').get(obj);
    };

    var getAllProducts = function (obj) {
      return Restangular.one('product').one('getOnlyProducts').get(obj);
    };

    var getAllPaymentPlans = function () {
      return Restangular.one('paymentplan').one('listall').getList();
    };

    var getAllCategories = function () {
      return Restangular.one('billcategory').customGET('listall', {debit_credit: 'C'});
    };

    var inactivateProduct = function (obj) {
      return Restangular.one('product').all('inactivateproduct').post(obj);
    };

    var createProduct = function (obj) {
      return Restangular.one('product').customPOST(obj);
    };

    var updateProduct = function (obj) {
      return Restangular.one('product', obj.id).customPUT(obj);
    };

    var deleteProduct = function (id) {
      return Restangular.one('product', id).remove();
    };

    return {
      getById: getById,
      deleteProduct: deleteProduct,
      getProductHistory: getProductHistory,
      updateProduct: updateProduct,
      createProduct: createProduct,
      inactivateProduct: inactivateProduct,
      getAllCategories: getAllCategories,
      getAllProducts: getAllProducts,
      getAllPaymentPlans: getAllPaymentPlans,
      getProductById: getProductById
    };
  }

  angular.module('app.stock.stocklist')
    .factory('StockService', StockService);
})();

(function () {
  'use strict';

  angular
    .module('app.stock.warehouselist', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.stock.warehouselist', {
        url: '/warehouselist',
        public: false,
        templateUrl: 'app/stock/warehouse-list/views/index.html',
        controller: 'WarehouseListController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Warehouse'
        }
      });
  }

  angular
    .module('app.stock.warehouselist')
    .config(routerConfig);


})();



(function() {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'estoque_menu';
    // var path = 'stock.stocklist';
    msNavigationService.saveItem('stock.warehouselist', {
      title: 'Almoxarifado',
      icon: 'icon-factory',
      state: 'private.stock.warehouselist',
      auth: role,
      weight: 2,
      hidden: function () {
        return false;
      }
    });
    /*msNavigationService.saveItem('stock', {
      title : 'Estoque',
      icon  : 'icon-apps',
      state : 'private.finance.stock'
    });*/
  }

  angular
    .module('app.stock.stocklist')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function WarehouseListController($a4FloatButton, Common, StockService, $filter, $log, $timeout, $scope, $q, $rootScope, ReportsService,
                                   PoliciesService, ModalFactory, a4Moment, Session, TransactionsService) {

    var vm = this;
    vm.items = [];
    vm.simulateQuery = false;
    vm.isDisabled = false;

    vm.product = {id: null};
    vm.category = null;
    vm.allCategorys = [];
    vm.selectedPaymentPlans = [];
    vm.allPaymentPlans = [];
    vm.locked = false;
    vm.show_inactive = false;
    vm.search = '';
    vm.include = {};

    vm.selected_category ='';

    vm.types = [
      {'id': 12, 'name': 'Item de almoxarifado'}
    ];

    /**
     * init
     */
    vm.init = function () {
      vm.getAllProducts();

      vm.estoque_alt = vm.checkPolicies('estoque_alt');
      if(!vm.checkPolicies('estoque_alt')) {

      vm.getCategories();

      vm.floatButton =
        $a4FloatButton({
          scope: $scope,
          theme: 'stock',
          onClick: 'vm.openSide()',
          label: 'Adicionar novo'
        });
      }
    };

    vm.filterProductsByCategory = function () {
      if (vm.selected_category === '' || vm.selected_category === null) {
        vm.products = vm.items;
      }  else {
        vm.products = vm.items.filter(function (product) {
          return product.bill_category_id === vm.selected_category;
        })
      }
    }

    /**
     * Retorna as categorias
     */
    vm.getCategories = function () {
      StockService.getAllCategories()
        .then(function (response) {
          vm.allCategories = vm.parseCategoryList(response.nodes);
          vm.include.allCategories = vm.allCategories;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
          $rootScope.show_loader = false;
        });
    };

    vm.parseCategoryList = function (list) {
      var result = [];
      if (list != null && list.length > 0) {
        angular.forEach(list, function (item) {
          if (item.nodes.length > 0) {
            angular.forEach(item.nodes, function (cat) {
              result.push(cat);
            });
          }
        });
      } else {
        result = list;
      }
      return result;
    };

    vm.showHistory = function (product) {
      $rootScope.show_loader = true;
      StockService.getProductHistory(product)
        .then(function (response) {
          $rootScope.show_loader = false;
          ModalFactory.custom('app/stock/warehouse-list/views/history.html', {movements: response.plain()});
        })
    };

    //Abre o modal de correção de estoque
    vm.adjustStock = function (product) {
      var productCopy = angular.copy(product);
      productCopy.date = a4Moment().format('YYYY/MM/DD');
      productCopy.quantity = null;
      productCopy.notes = '';
      productCopy.is_correction = true;

      ModalFactory.custom('app/stock/stock-list/views/adjust-stock.html', {product: productCopy}).then(function(modalResult) {
          vm.createAdjustment(modalResult);
        }).catch(function(error) {
          console.log('Modal cancelado ou erro:', error);
        });
    };

    //Efetiva a transação de correção
    vm.createAdjustment = function(product) {
      product.person_id_supplier = Session.user.id
      product.person_id = Session.user.id
      product.stock_transaction_type_id = 50
      product.type = 2

      product.products = [{
        product_id: product.id,
        unit_price: product.price,
        quantity: product.quantity
      }];

      TransactionsService.createTransaction(product)
        .then(function () {
          Common.Toast.success("Transação adicionada com sucesso");
          vm.getAllProducts();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro o executar essa ação.');
          $rootScope.show_loader = false;
      });
    }

    /**
     * Retorna o produto pelo ID
     * @param id
     */
    vm.getById = function (id) {
      StockService.getById(id)
        .then(function (response) {
          if (response != null) {
            vm.product = response;
            vm.selectedPaymentPlans = vm.product.selectedPaymentPlans;
            $rootScope.show_loader = false;
          }
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel resgatar este item.');
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna todos os produtos
     */
    vm.getAllProducts = function (search) {
      $rootScope.show_loader = true;
      StockService.getAllProducts({show_inactive: vm.show_inactive, search: search, type: 12})
        .then(function (response) {
          vm.items = response;
          vm.products = angular.copy(vm.items)
          angular.forEach(vm.items, function (value, key) {
            for (var i = 0; i < vm.types.length; i++) {
              if (value.type == vm.types[i].id) {
                vm.items[key].nametype = vm.types[i].name;
              }
            }
          });
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro o executar essa ação.');
          $rootScope.show_loader = false;
        });
    };

    vm.inactivate = function (item) {
      var text = item.is_inactive ? 'ativar' : 'desativar';
      ModalFactory.confirm(null,
        text + ' ' + item.name,
        'Tem certeza que deseja ' + text + ' este produto?',
        'Confirmar', 'Cancelar', 'stock')
        .then(function () {
        $rootScope.show_loader = true;
        StockService.inactivateProduct({product_id: item.id})
          .then(function () {
          Common.Toast.success('Produto desativado com sucesso!');
          vm.getAllProducts();
          $rootScope.show_loader = false;
        })
      })

    };

    /** Imprime relatório dos produtos do almoxarifado */
    vm.printProducts = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/printproducts',
        {
          name: vm.product.name,
          minimum_stock: vm.product.minimum_stock,
          maximum_stock: vm.product.maximum_stock,
          last_balance: vm.product.last_balance,
          cost: vm.product.cost,
          price: vm.product.price,
          selected_category: vm.selected_category !== null ? vm.selected_category : null,
          type: 12  
        })
        .then(function () {
          $rootScope.show_loader = false;
        })
        .catch(function (error) {
          $rootScope.show_loader = false
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Abre o modal para edição
     * @param product
     */
    vm.editItem = function (product) {
      if(!vm.checkPolicies('estoque_alt')) {
        ModalFactory.customClean(
          'app/stock/warehouse-list/views/form.html',
          'WarehouseCreateEditController',
          'vm', false, product
        ).then(function () {
          vm.getAllProducts();
        });
      }
    };

    /**
     * Abre o modal para criação
     */
    vm.openSide = function () {
      ModalFactory.customClean(
        'app/stock/warehouse-list/views/form.html',
        'WarehouseCreateEditController',
        'vm', false, []
      ).then(function () {
        vm.getAllProducts();
      });
    };

    /**
     * Remove produto
     * @param item
     */
    vm.delete = function (item) {
      ModalFactory.confirm(null, 'Exclusão do produto ' + item.name,
        'Tem certeza que deseja excluir este produto?',
        'Confirmar',
        'Cancelar', 'stock').then(function () {
        $rootScope.show_loader = true;
        StockService.deleteProduct(item.id)
          .then(function () {
            Common.Toast.success('Produto removido com sucesso.');
            vm.getAllProducts();
            $rootScope.show_loader = false;
          })
          .catch(function () {
            Common.Toast.error('Esse produto não pode ser deletado, pois já esta vinculado a um título.');
            $rootScope.show_loader = false;
          });
      });
    };

    vm.applyMask = function (value) {
      var currency = 0;
      if (value === 0 || value == null) {
        currency = $filter('currency')(0, 'R$ ', 2);
        return currency;
      } else if (value > 0) {
        currency = $filter('currency')(value, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular
    .module('app.stock.warehouselist')
    .controller('WarehouseListController', WarehouseListController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function WarehouseCreateEditController(Common, StockService, $filter, $log, $timeout, $scope, $q, $rootScope, Session,
                                     PoliciesService, ModalExtra, ProductService) {

    var vm = this;
    vm.items = [];
    vm.simulateQuery = false;
    vm.isDisabled = false;
    vm.companies_number = Session.getCompanies().length;
    vm.currentItem = {
      id: null
    };

    vm.product = {id: null};
    vm.category = null;
    vm.allCategorys = [];
    vm.selectedPaymentPlans = [];
    vm.allPaymentPlans = [];
    vm.has_validity = false;

    vm.types = [
      {'id': 12, 'name': 'Item de almoxarifado'}
    ];

    /**
     * init
     */
    vm.init = function () {
      if (ModalExtra.length !== 0) {
        vm.currentItem = ModalExtra;
        if (vm.currentItem.inactivity_date !== null && vm.currentItem.inactivity_date !== "") {
          vm.has_validity = true;
        }
      }
      vm.currentItem.withoutCompany = vm.currentItem.company_id == null;

      vm.getCategories();
      vm.include = {};
      vm.include.simulateQuery = vm.simulateQuery;
      vm.include.isDisabled = vm.isDisabled;
      vm.include.querySearch = vm.querySearch;
      vm.include.selectedItemChange = vm.selectedItemChange;
      vm.include.searchTextChange = vm.searchTextChange;
      vm.include.types = vm.types;
      vm.include.focusGroup = vm.focusGroup;
    };

    /**
     * Retorna as categorias
     */
    vm.getCategories = function () {
      $rootScope.show_loader = true;
      StockService.getAllCategories()
        .then(function (response) {
          vm.allCategories = vm.parseCategoryList(response.nodes);
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
          $rootScope.show_loader = false;
        });
    };

    vm.parseCategoryList = function (list) {
      var result = [];
      if (list != null && list.length > 0) {
        angular.forEach(list, function (item) {
          if (item.nodes.length > 0) {
            angular.forEach(item.nodes, function (cat) {
              result.push(cat);
              if (cat.id === vm.currentItem.bill_category_id) {
                vm.selectedCategory = cat;
              }
            });
          }
        });
      } else {
        result = list;
      }
      return result;
    };

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearchCategory = function (query) {
      return query != '' ? vm.allCategories.filter(vm.createFilterFor(query)) : vm.allCategories;
    };
    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };



    /**
     * Retorna o produto pelo ID
     * @param id
     */
    vm.getById = function (id) {
      StockService.getById(id)
        .then(function (response) {
          if (response != null) {
            vm.product = response;
            vm.selectedPaymentPlans = vm.product.selectedPaymentPlans;
            $rootScope.show_loader = false;
          }
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel resgatar este item.');
          $rootScope.show_loader = false;
        });
    };

    /**
     * Submit para o formulário
     * @param form
     * @param product
     */
    vm.submit = function (form, product) {
      if (form.$valid) {
        product.type = 12;
        if (angular.isUndefined(product.id) || product.id === null) {
          ProductService.createProduct(product)
            .then(function () {
              Common.Toast.success("Produto adicionado com sucesso");
              vm.cancel();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });
        } else {
          StockService.updateProduct(product)
            .then(function () {
              Common.Toast.success("Produto atualizado com sucesso");
              vm.cancel();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });
        }
      }
    };

    /**
     * Fecha o modal
     */
    vm.cancel = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular
    .module('app.stock.warehouselist')
    .controller('WarehouseCreateEditController', WarehouseCreateEditController);

})();

//--------------------


(function () {
  'use strict';

  angular
    .module('app.stock.transactions', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function TransactionsService(Restangular) {

    var getAllTransactions = function (obj) {
      return Restangular.one('product').one('getalltransactions').get(obj);
    };

    var getInfoForTransaction = function (obj) {
      return Restangular.one('product').one('getinfofortransaction').get(obj);
    };

    var createTransaction = function (obj) {
      return Restangular.one('product').all('createtransaction').post(obj);
    };

    var updateTransaction = function (obj) {
      return Restangular.one('product').all('updatetransaction').post(obj);
    };

    var getTransactionById = function (obj) {
      return Restangular.one('product', obj.id).one('gettransactionbyid').get(obj);
    };

    return {
      createTransaction: createTransaction,
      updateTransaction: updateTransaction,
      getAllTransactions: getAllTransactions,
      getInfoForTransaction: getInfoForTransaction,
      getTransactionById: getTransactionById
    };
  }

  angular.module('app.stock.transactions')
    .factory('TransactionsService', TransactionsService);
})();

(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.stock.transactions', {
        url: '/transactions',
        public: false,
        templateUrl: 'app/stock/transactions/views/index.html',
        controller: 'TransactionsController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Transactions'
        }
      });
  }

  angular
    .module('app.stock.transactions')
    .config(routerConfig);


})();



(function() {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'transacoes_menu';
    // var path = 'stock.transactions';
    msNavigationService.saveItem('stock.transactions', {
      title: 'Transações de estoque',
      icon: 'icon-swap-horizontal',
      state: 'private.stock.transactions',
      auth: role,
      weight: 3,
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.stock.transactions')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function TransactionsController() {

  }

  angular
    .module('app.stock.transactions')
    .controller('TransactionsController', TransactionsController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function TransactionCreateEditController(Common, a4Moment, StockService, $filter, $log, $timeout, $scope, $q, $rootScope, Session,
                                           PoliciesService, TransactionsService, ModalExtra, PersonService) {

    var vm = this;
    vm.items = [];
    vm.searchText = null;
    vm.today = a4Moment();
    vm.person_id = Session.getUser().person.id
    vm.disable = false;
    vm.currentItem = {
      id: null,
      date: a4Moment(),
      type: ModalExtra.type,
      products: [{}],
      deleted_movements: []
    };
    vm.supplier = null;
    vm.is_buy = ModalExtra.is_buy;

    vm.getInfoForTransaction = function () {
      TransactionsService.getInfoForTransaction().then(function (response) {
        var infos = response.plain();
        vm.stock_transaction_types = infos.stock_transaction_types;
        vm.products = infos.products;
      });
    };

    vm.addProduct = function () {
      vm.currentItem.products.push({});
    };

    vm.getSuppliers = function (query) {
      return PersonService.getPersonWithFilter({query: query, selected_tab: 5});
    };


    vm.productChange = function (item, product_id) {
      // var balance = null;
      // vm.products.forEach(function (item) {
      //   if (item.id === product_id) {
      //     balance = item.last_balance;
      //   }
      // });
      item.balance_product_selected = $filter('filter')(vm.products, {id: item.product_id})[0].last_balance;
    };

    /**
     * init
     */
    vm.init = function () {
      if (angular.isDefined(ModalExtra) && angular.isDefined(ModalExtra.id) && ModalExtra.id !== null) {
        vm.currentItem = ModalExtra;

        $scope.$applyAsync();
      }
      if (vm.is_buy){
        vm.currentItem.stock_transaction_type_id = 11;
      }
      vm.getInfoForTransaction();
    };

    vm.deleteProduct = function (index, product) {
      if (angular.isDefined(product.id)) {
        vm.currentItem.deleted_movements.push(product.id);
      }
      vm.currentItem.products.splice(index, 1);
    };

    /**
     * Lista possíveis solicitantes
     * @param query - Nome pesquisado
     */
    vm.listAllPersons = function (query) {
      return PersonService.listAll({query: query});
    };


    vm.personSelected = function (item) {
      vm.selected_person = item.id
    }
    /**
     * Submit para o formulário
     * @param form
     * @param transaction
     */
    vm.submit = function (form, transaction) {
      if (vm.supplier !== null){
        transaction.person_id_supplier = vm.supplier.id;
      }
      if (!vm.is_buy) {
        transaction.person_id_taker = vm.selected_person
      }

      transaction.person_id = vm.person_id
      if (!vm.locked && form.$valid) {
        vm.disable = true;
        if (angular.isUndefined(transaction.id) || transaction.id === null) {
          TransactionsService.createTransaction(transaction)
            .then(function () {
              Common.Toast.success("Transação adicionada com sucesso");
              vm.cancel();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });
        } else {
          TransactionsService.updateTransaction({transaction: transaction})
            .then(function () {
              Common.Toast.success("Transação atualizada com sucesso");
              vm.cancel();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });
        }
      }
    };

    /**
     * Fecha o modal
     */
    vm.cancel = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular
    .module('app.stock.transactions')
    .controller('TransactionCreateEditController', TransactionCreateEditController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function StockService(Restangular) {

    var getProductById = function (id) {
      return Restangular.one('product').one('getById', id).get();
    };

    var getById = function (id) {
      return Restangular.one('product', id).get();
    };

    var getProductHistory = function (obj) {
      return Restangular.one('product', obj.id).one('getproducthistory').get(obj);
    };

    var getAllProducts = function (obj) {
      return Restangular.one('product').one('getOnlyProducts').get(obj);
    };

    var getAllPaymentPlans = function () {
      return Restangular.one('product').one('getpaymentplans').get();
    };

    var getAllCategories = function () {
      return Restangular.one('billcategory').customGET('listall', {debit_credit: 'C'});
    };

    var inactivateProduct = function (obj) {
      return Restangular.one('product').all('inactivateproduct').post(obj);
    };

    var createProduct = function (obj) {
      return Restangular.one('product').customPOST(obj);
    };

    var updateProduct = function (obj) {
      return Restangular.one('product', obj.id).customPUT(obj);
    };

    var deleteProduct = function (id) {
      return Restangular.one('product', id).remove();
    };

    var deleteTransaction = function (id) {
      return Restangular.one('product', id).one('deletetransaction').post();
    }

    return {
      getById: getById,
      deleteProduct: deleteProduct,
      getProductHistory: getProductHistory,
      updateProduct: updateProduct,
      createProduct: createProduct,
      inactivateProduct: inactivateProduct,
      getAllCategories: getAllCategories,
      getAllProducts: getAllProducts,
      getAllPaymentPlans: getAllPaymentPlans,
      getProductById: getProductById,
      deleteTransaction: deleteTransaction
    };
  }

  angular.module('app.stock.stocklist')
    .factory('StockService', StockService);
})();

(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.stock.stocklist', {
        url: '/stocklist',
        public: false,
        templateUrl: 'app/stock/stock-list/views/index.html',
        controller: 'StockListController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Stock'
        }
      });
  }

  angular
    .module('app.stock.stocklist')
    .config(routerConfig);


})();



(function() {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    var role = 'estoque_menu';
    // var path = 'stock.stocklist';
    msNavigationService.saveItem('stock.stocklist', {
      title: 'Estoque',
      icon: 'icon-apps',
      state: 'private.stock.stocklist',
      auth: role,
      weight: 2,
      hidden: function () {
        return false;
      }
    });
    /*msNavigationService.saveItem('stock', {
      title : 'Estoque',
      icon  : 'icon-apps',
      state : 'private.finance.stock'
    });*/
  }

  angular
    .module('app.stock.stocklist')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function StockListController($a4FloatButton, Common, StockService, $filter, $log, $timeout, $scope, $q, $rootScope,
                               PoliciesService, ModalFactory,ReportsService, a4Moment, Session, TransactionsService) {

    var vm = this;
    vm.items = [];
    vm.simulateQuery = false;
    vm.isDisabled = false;

    vm.product = {id: null};
    vm.category = null;
    vm.allCategorys = [];
    vm.selectedPaymentPlans = [];
    vm.allPaymentPlans = [];
    vm.locked = false;
    vm.show_inactive = false;
    vm.search = '';
    vm.selected_category ='';

    vm.types = [
      {'id': 10, 'name': 'Produto físico'}
    ];

    var listener1 = $rootScope.$on('a4-table.toggled', function (ev, item) {
      if (item.hasOwnProperty('id')) {
        vm.getById(item.id);
      }
    });

    /**
     * Ouvinte para o caso do usuário invalidar o formulario,
     * selecionando dois planos de pagamento iguais
     */
    var listener2 = $rootScope.$on('Product.isValid', function (event, result) {
      if (result != null) {
        vm.locked = !result;
        vm.include.locked = !result;
      }
    });

    /**
     * init
     */
    vm.init = function () {
      vm.repos = vm.loadAll();

      vm.getAllProducts();
      vm.getCategories();
      vm.getAllPaymentPlans();

      vm.include = {};
      vm.include.simulateQuery = vm.simulateQuery;
      vm.include.isDisabled = vm.isDisabled;
      vm.include.querySearch = vm.querySearch;
      vm.include.selectedItemChange = vm.selectedItemChange;
      vm.include.searchTextChange = vm.searchTextChange;
      vm.include.types = vm.types;
      vm.include.focusGroup = vm.focusGroup;
      vm.estoque_alt = vm.checkPolicies('estoque_alt');

      if(!vm.checkPolicies('estoque_alt')) {
      vm.floatButton =
        $a4FloatButton({
          scope: $scope,
          theme: 'stock',
          onClick: 'vm.openSide()',
          label: 'Adicionar novo'
        });
      }
    };

    vm.showHistory = function (product) {
      $rootScope.show_loader = true;
      StockService.getProductHistory(product).then(function (response) {
        $rootScope.show_loader = false;
        ModalFactory.custom('app/stock/stock-list/views/history.html', { movements: response.plain() });
      })
    };

    //Abre o modal de correção de estoque
    vm.adjustStock = function (product) {
      var productCopy = angular.copy(product);
      productCopy.date = a4Moment().format('YYYY/MM/DD');
      productCopy.quantity = null;
      productCopy.notes = '';
      productCopy.is_correction = true;

      ModalFactory.custom('app/stock/stock-list/views/adjust-stock.html', {product: productCopy}).then(function(modalResult) {
          vm.createAdjustment(modalResult);
        }).catch(function(error) {
          console.log('Modal cancelado ou erro:', error);
        });
    };

    //Efetiva a transação de correção
    vm.createAdjustment = function(product) {
      product.person_id_supplier = Session.user.id
      product.person_id = Session.user.id
      product.stock_transaction_type_id = 50
      product.type = 2

      product.products = [{
        product_id: product.id,
        unit_price: product.price,
        quantity: product.quantity
      }];

      TransactionsService.createTransaction(product)
        .then(function () {
          Common.Toast.success("Transação adicionada com sucesso");
          vm.getAllProducts();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro o executar essa ação.');
          $rootScope.show_loader = false;
      });
    }

    /**
     * Retorna o produto pelo ID
     * @param id
     */
    vm.getById = function (id) {
      StockService.getById(id)
        .then(function (response) {
          if (response != null) {
            vm.product = response;
            vm.selectedPaymentPlans = vm.product.selectedPaymentPlans;
            vm.include.selectedPaymentPlans = vm.product.selectedPaymentPlans;
            vm.include.selectedItem = vm.product.bill_category_id;
            $rootScope.show_loader = false;
          }
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel resgatar este item.');
          $rootScope.show_loader = false;
        });
    };


    vm.focusGroup = function (event, boolean) {
      if (boolean) {
        angular.element(event.target).parents('[layout="row"]').addClass('group_selected');
      } else {
        angular.element(event.target).parents('[layout="row"]').removeClass('group_selected');
      }
    };

    /**
     * Retorna todos os produtos
     */
    vm.getAllProducts = function (search) {
      $rootScope.show_loader = true;
      vm.selected_category ='';
      StockService.getAllProducts({show_inactive: vm.show_inactive, search: search})
        .then(function (response) {
          vm.items = response;
          vm.products = angular.copy(vm.items)
          angular.forEach(vm.items, function (value, key) {
            for (var i = 0; i < vm.types.length; i++) {
              if (value.type == vm.types[i].id) {
                vm.items[key].nametype = vm.types[i].name;
              }
            }
          });
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro o executar essa ação.');
          $rootScope.show_loader = false;
        });
    };

    vm.inactivate = function (item) {
      var text = item.is_inactive ? 'ativar' : 'desativar';
      ModalFactory.confirm(null,
        text + ' ' + item.name,
        'Tem certeza que deseja ' + text + ' este produto?',
        'Confirmar',
        'Cancelar',
        'finance').then(function () {
        $rootScope.show_loader = true;
        StockService.inactivateProduct({product_id: item.id}).then(function () {
          Common.Toast.success('Produto desativado com sucesso!');
          vm.getAllProducts();
          $rootScope.show_loader = false;
        })
      })

    };

    /**
     * Abre o modal para edição
     * @param product
     */
    vm.editItem = function (product) {
      if(!vm.checkPolicies('estoque_alt')) {
      ModalFactory.customClean(
        'app/stock/stock-list/views/form.html',
        'StockCreateEditController',
        'vm', false, product
      ).then(function () {
        vm.getAllProducts();
      });
    }
    };

    /**
     * Abre o modal para criação
     */
    vm.openSide = function () {
      ModalFactory.customClean(
        'app/stock/stock-list/views/form.html',
        'StockCreateEditController',
        'vm', false, []
      ).then(function () {
        vm.getAllProducts();
      });
      // vm.include.selectedPaymentPlans = [];
      // vm.include.selectedItem = '';
      // $rootScope.$broadcast('a4.table.open.sidenav');
    };

    /**
     * Retorna as categorias
     */
    vm.getCategories = function () {
      StockService.getAllCategories()
        .then(function (response) {
          vm.allCategories = vm.parseCategoryList(response.nodes);
          vm.include.allCategories = vm.allCategories;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
          $rootScope.show_loader = false;
        });
    };

    vm.parseCategoryList = function (list) {
      var result = [];
      if (list != null && list.length > 0) {
        angular.forEach(list, function (item) {
          if (item.nodes.length > 0) {
            angular.forEach(item.nodes, function (cat) {
              result.push(cat);
            });
          }
        });
      } else {
        result = list;
      }
      return result;
    };

    /**
     * Retorna todos os planos de pagamento
     */
    vm.getAllPaymentPlans = function () {
      StockService.getAllPaymentPlans()
        .then(function (response) {
          vm.allPaymentPlans = response;
          vm.include.allPaymentPlans = vm.allPaymentPlans;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
          $rootScope.show_loader = false;
        });
    };


    /**
     * Remove produto
     * @param item
     */
    vm.delete = function (item) {
      ModalFactory.confirm(null, 'Exclusão do produto ' + item.name,
        'Tem certeza que deseja excluir este produto?',
        'Confirmar',
        'Cancelar', 'finance').then(function () {
        $rootScope.show_loader = true;
        StockService.deleteProduct(item.id)
          .then(function () {
            Common.Toast.success('Produto removido com sucesso.');
            vm.getAllProducts();
            $rootScope.show_loader = false;
          })
          .catch(function () {
            Common.Toast.error('Esse produto não pode ser deletado, pois já esta vinculado a um título.');
            $rootScope.show_loader = false;
          });
      });
    };

    /**
     * Submit para o formulário
     * @param form
     * @param product
     */
    vm.submit = function (form, product) {

      if (!vm.locked && form.$valid) {

        var product_copy = angular.copy(product);

        product_copy.selectedPaymentPlans = vm.include.selectedPaymentPlans;

        if (product.id == undefined || product.id == null) {

          StockService.createProduct(product_copy)
            .then(function () {
              Common.Toast.success("Serviço adicionado com sucesso");
              $rootScope.$broadcast('a4.table.close.sidenav');
              vm.include.selectedPaymentPlans = [];
              vm.getAllProducts();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });

        } else {

          angular.forEach(product_copy.selectedPaymentPlans, function (value, key) {
            if (value.id == null && angular.isDefined(value.id)) {
              value.id = (-key);
            }
          });

          StockService.updateProduct(product_copy)
            .then(function () {
              Common.Toast.success("Serviço atualizado com sucesso");
              $rootScope.$broadcast('a4.table.close.sidenav');
              vm.include.selectedPaymentPlans = [];
              vm.getAllProducts();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });

        }

      }
    };

    vm.applyMask = function (value) {
      var currency = 0;
      if (value == 0 || value == null) {
        currency = $filter('currency')(0, 'R$ ', 2);
        return currency;
      } else if (value > 0) {
        currency = $filter('currency')(value, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      }
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearch = function (query) {
      var results = query ? vm.include.allCategories.filter(vm.createFilterFor(query)) : vm.include.allCategories,
        deferred;
      if (vm.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () {
          deferred.resolve(results);
        }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    };


    vm.selectedItemChange = function (text) {
      $log.info('Text changed to ' + text);
    };

    vm.searchTextChange = function (item) {
      $log.info('Item changed to ' + angular.toJson(item));
    };


    /**
     * Create filter function for a query string
     */
    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    /**
     * Build `components` list of key/value pairs
     */
    vm.loadAll = function () {
      var repos = [];
      return repos.map(function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    };

    vm.filterProductsByCategory = function () {
      if (vm.selected_category === '' || vm.selected_category === null) {
        vm.products = vm.items
      }  else {
        vm.products = vm.items.filter(function (product) {
          return product.bill_category_id === vm.selected_category
        })
      }
    }

    vm.printProducts = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/printproducts',
        {
          name: vm.product.name,
          minimum_stock: vm.product.minimum_stock,
          maximum_stock: vm.product.maximum_stock,
          last_balance: vm.product.last_balance,
          cost: vm.product.cost,
          price: vm.product.price,
          selected_category: vm.selected_category
        })
        .then(function () {
          $rootScope.show_loader = false;
        })
        .catch(function (error) {
          $rootScope.show_loader = false
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    $scope.$on('$destroy', function () {
      [listener1, listener2].forEach(function (fn) {
        fn();
      });
    });


    vm.init();

  }

  angular
    .module('app.stock.stocklist')
    .controller('StockListController', StockListController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function StockCreateEditController(Common, StockService, $filter, $log, $timeout, $scope, $q, $rootScope, Session,
                                     PoliciesService, ModalExtra, ProductService) {

    var vm = this;
    vm.items = [];
    vm.simulateQuery = false;
    vm.isDisabled = false;
    vm.companies_number = Session.getCompanies().length;
    vm.currentItem = {
      id: null
    };

    vm.product = {id: null};
    vm.category = null;
    vm.allCategorys = [];
    vm.selectedPaymentPlans = [];
    vm.allPaymentPlans = [];
    vm.locked = false;
    vm.has_validity = false;

    vm.types = [
      {'id': 10, 'name': 'Produto físico'}
    ];

    var listener1 = $rootScope.$on('a4-table.toggled', function (ev, item) {
      if (item.hasOwnProperty('id')) {
        vm.getById(item.id);
      }
    });


    /**
     * init
     */
    vm.init = function () {
      if (ModalExtra.length !== 0) {
        vm.currentItem = ModalExtra;
        if (vm.currentItem.inactivity_date !== null && vm.currentItem.inactivity_date !== "") {
          vm.has_validity = true;
        }
      }
      vm.getCategories();
      vm.currentItem.withoutCompany = vm.currentItem.company_id == null;
      vm.include = {};
      vm.include.simulateQuery = vm.simulateQuery;
      vm.include.isDisabled = vm.isDisabled;
      vm.include.querySearch = vm.querySearch;
      vm.include.selectedItemChange = vm.selectedItemChange;
      vm.include.searchTextChange = vm.searchTextChange;
      vm.include.types = vm.types;
      vm.include.focusGroup = vm.focusGroup;
    };

    /**
     * Retorna o produto pelo ID
     * @param id
     */
    vm.getById = function (id) {
      StockService.getById(id)
        .then(function (response) {
          if (response != null) {
            vm.product = response;
            vm.selectedPaymentPlans = vm.product.selectedPaymentPlans;
            vm.include.selectedPaymentPlans = vm.product.selectedPaymentPlans;
            vm.include.selectedItem = vm.product.bill_category_id;
            $rootScope.show_loader = false;
          }
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel resgatar este item.');
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna as categorias
     */
    vm.getCategories = function () {
      $rootScope.show_loader = true;
      StockService.getAllCategories()
        .then(function (response) {
          vm.allCategories = vm.parseCategoryList(response.nodes);
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
          $rootScope.show_loader = false;
        });
    };

    vm.parseCategoryList = function (list) {
      var result = [];
      if (list != null && list.length > 0) {
        angular.forEach(list, function (item) {
          if (item.nodes.length > 0) {
            angular.forEach(item.nodes, function (cat) {
              result.push(cat);
              if (cat.id === vm.currentItem.bill_category_id) {
                vm.selectedCategory = cat;
              }
            });
          }
        });
      } else {
        result = list;
      }
      return result;
    };

    /**
     * Submit para o formulário
     * @param form
     * @param product
     */
    vm.submit = function (form, product) {
      if (!vm.locked && form.$valid) {
        product.type = 10;
        if (angular.isUndefined(product.id) || product.id === null) {
          ProductService.createProduct(product)
            .then(function () {
              Common.Toast.success("Serviço adicionado com sucesso");
              vm.cancel();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro ao executar essa ação.');
              $rootScope.show_loader = false;
            });
        } else {
          StockService.updateProduct(product)
            .then(function () {
              Common.Toast.success("Serviço atualizado com sucesso");
              vm.cancel();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro ao executar essa ação.');
              $rootScope.show_loader = false;
            });
        }
      }
    };

    vm.applyMask = function (value) {
      var currency = 0;
      if (value == 0 || value == null) {
        currency = $filter('currency')(0, 'R$ ', 2);
        return currency;
      } else if (value > 0) {
        currency = $filter('currency')(value, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      }
    };

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearchCategory = function (query) {
      return query != '' ? vm.allCategories.filter(vm.createFilterFor(query)) : vm.allCategories;
    };
    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };


    /**
     * Fecha o modal
     */
    vm.cancel = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.changeHasValidity = function () {
      if (!vm.has_validity) {
        vm.currentItem.inactivity_date = null;
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    $scope.$on('$destroy', function () {
      [listener1].forEach(function (fn) {
        fn();
      });
    });

    vm.init();
  }

  angular
    .module('app.stock.stocklist')
    .controller('StockCreateEditController', StockCreateEditController);

})();


(function () {
  'use strict';

  angular
    .module('app.stock.dashboard', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.stock.dashboard', {
        url: '/dashboard',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/stock/dashboard/dashboard.html',
        controller: 'DashboardStockController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.stock.dashboard')
    .config(routerConfig);

})();





(function () {
	'use strict';

	/** @ngInject */
	function run(msNavigationService) {
		msNavigationService.saveItem('stock.dashboard', {
			title: 'Dashboard',
			icon: 'icon-window-restore',
			state: 'private.stock.dashboard',
			class: "md-primary",
			weight: 1
		});
	}

	angular
		.module('app.stock.dashboard')
		.run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function DashboardController() {
    var vm = this;
    vm.init = function () {
    };

    vm.init();
  }

  angular
    .module('app.stock.dashboard')
    .controller('DashboardStockController', DashboardController);

})();
(function () {
    'use strict';
    angular.module('app.register', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function RegisterTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "REGISTER_V2": {
        "INTRO_TITLE": "Bem vindo(a) ao A4Cloud",
        "INTRO_DESCRIPTION": "",
        "TITLE": "Criar uma conta",
        "DESCRIPTION": "Bem vindo(a), para criar sua conta informe os dados abaixo",
        "EMAIL": "Email",
        "CONFIRM_EMAIL": "Email (Confirmação)",
        "TOKEN": "Código de ativação",
        "NATIONAL_ID_NUMBER": "CPF",
        "DOB": "Data de Nascimento",
        "PASSWORD": "Senha",
        "PASSWORD_CONFIRM": "Senha (Confirmação)",
        "READ_ACCEPT": "Li e aceito os",
        "TERMS_COND": "termos e condições de uso",
        "CREATE_ACCOUNT": "Criar minha conta",
        "ALREADY_HAVE": "Já possui uma conta?",
        "LOGIN": "Log in",
        "ERRORS": {
          "TOKEN_REQUIRED": "Código de ativação obrigatório",
          "EMAIL_REQUIRED": "E-mail obrigatório",
          "NATIONAL_ID_NUMBER_REQUIRED": "CPF obrigatório",
          "DOB_REQUIRED": "Data de Nascimento obrigatória",
          "CONFIRM_EMAIL_REQUIRED": "Confirmação de e-mail obrigatória",
          "ENROLMENT_REQUIRED": "Numero de mátricula obrigatório",
          "EMAIL_MUST_VALID": "É necessário um endereço de e-mail válido",
          "PASSWORD_REQUIRED": "Senha obrigatória",
          "PASSWORD_CONFIRM_REQUIRED": "Confirmação de senha obrigatória",
          "TERMS_REQUIRED": "You must accept terms and conditions before submitting the form"
        }
      }
    })
  }

  angular
    .module('app.register')
    .config(RegisterTranslate);
})();

(function () {
  'use strict';

  angular.module('app.process.location', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.process.technology-resources', {
        url: '/process/technology-resources',
        public: false,
        // auth: 'finance_dash',
        templateUrl: 'app/process/stock/views/index.html',
        controller: 'ProcessStockController',
        controllerAs: 'vm',
        params: {
          product_type_id: 32,
          name: 'Recursos Tecnológicos'
        }
      });
  }

  angular
    .module('app.process.location')
    .config(routerConfig);

})();





(function () {
  'use strict';

  angular.module('app.process.stock', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run($document, msNavigationService, PoliciesService) {
    // var hidden = false;
    var role = 'process_tecnology_resources';
    var path = 'process.technology-resources';
    msNavigationService.saveItem('process.technology-resources', {
      title: 'Recursos Tecnológicos',
      icon: 'icon-laptop',
      state: 'private.process.technology-resources',
      class: "md-primary",
      weight: 3,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.process.stock')
    .run(run);

})();





(function () {
  'use strict'

  /** @ngInject*/
  function ProcessStockService(Restangular) {
    var vm = this;

    vm.getProductsByType = function (obj){
      return Restangular.one('product').one('getbytype').get(obj);
    }

    vm.createProduct = function (obj) {
      return Restangular.all('product').post(obj);
    }

    vm.updateProduct = function (obj) {
      return Restangular.one('product', obj.id).customPUT(obj);
    }

    return vm;
  }

  angular
    .module('app.process.stock')
    .factory('ProcessStockService', ProcessStockService)
})();

(function () {
  'use strict';

  /** @ngInject */
  function ProcessStockController($scope, $rootScope, $state, ProcessStockService) {
    var vm = this;
    vm.columns = [{id: 'name', name: 'Nome'}];

    vm.init = function () {
      vm.product_type_id = $state.params.product_type_id;
      vm.name = $state.params.name;
      vm.getAll();
    }

    vm.getAll = function () {
      $rootScope.show_loader = true;
      ProcessStockService.getProductsByType({product_type_id: vm.product_type_id})
        .then(function (resp) {
          $rootScope.show_loader = false;
          vm.data = resp.plain();
        })
    }

    vm.createProduct = function (item) {
      $rootScope.show_loader = true;
      item.type = vm.product_type_id;
      item.withoutCompany = true;
      ProcessStockService.createProduct(item)
        .then(function () {
          vm.getAll();
          $rootScope.show_loader = false;
        })
        .catch(function (){
          $rootScope.show_loader = false;
        })
    }
    vm.editProduct = function (item) {
      $rootScope.show_loader = true;
      item.type = vm.product_type_id;
      ProcessStockService.updateProduct(item)
        .then(function () {
          vm.getAll();
          $rootScope.show_loader = false;
        })
        .catch(function (){
          $rootScope.show_loader = false;
        })
    }

    vm.init();
  }

  angular.module('app.process.stock')
    .controller('ProcessStockController', ProcessStockController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.process.school-supplies', {
        url: '/process/school-supplies',
        public: false,
        // auth: 'finance_dash',
        templateUrl: 'app/process/stock/views/index.html',
        controller: 'ProcessStockController',
        controllerAs: 'vm',
        params: {
          product_type_id: 12,
          name: 'Material Escolar'
        }
      });
  }

  angular
    .module('app.process.location')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run($document, msNavigationService, PoliciesService) {
    // var hidden = false;
    var role = 'process_school_supplies';
    var path = 'process.school-supplies';
    msNavigationService.saveItem('process.school-supplies', {
      title: 'Material Escolar',
      icon: 'icon-school',
      state: 'private.process.school-supplies',
      class: "md-primary",
      weight: 2,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.process.stock')
    .run(run);

})();





(function () {
  'use strict';

  angular.module('app.process.process-to-solve', []);
})();
(function () {
  'use strict'

  /** @ngInject*/
  function ProcessToSolveService(Restangular) {
    var vm = this;

    vm.getProcessToSolve = function (obj) {
      obj.to_solve = true;
      return Restangular.one('process').get(obj);
    }

    vm.getProcessType = function () {
      return Restangular.one('process').one('processtype').get();
    };

    vm.getProcessTypeTypes = function (process_type_id) {
      return Restangular.one('process').one('processtypetypes', process_type_id).get();
    };

    vm.getProcessStatus = function () {
      return [
        {id: 1, name: 'Em análise'},
        {id: 2, name: 'Pendente'},
        {id: 3, name: 'Em andamento'},
        {id: 4, name: 'Finalizado'},
        {id: 5, name: 'Cancelado'}
      ];
    };

    vm.getPersonResponsibles = function (obj) {
      return Restangular.one('process').one('getpersonresponsibles').get(obj);
    };

    vm.getProcessCollaborators = function (obj) {
      return Restangular.one('process').one('getprocesscollaborators').get(obj);
    };


    return vm;
  }

  angular
    .module('app.process.process-to-solve')
    .factory('ProcessToSolveService', ProcessToSolveService)
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.process.process-to-solve', {
        url: '/process/tosolve',
        public: false,
        // auth: 'finance_dash',
        templateUrl: 'app/process/process-to-solve/views/process-to-solve.html',
        controller: 'ProcessToSolveController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.process.process-to-solve')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run($document, msNavigationService, PoliciesService) {
    var current_connection = $document[0].domain.split('.')[0];
    // var hidden = false;
    var role = 'process_to_solve';
    var path = 'process.process-to-solve';
    msNavigationService.saveItem('process.process-to-solve', {
      title: 'Administrar Solicitações',
      icon: 'icon-trello',
      state: 'private.process.process-to-solve',
      class: "md-primary",
      weight: 2,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.process.process-to-solve')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function ProcessToSolveController($scope, $rootScope, a4Moment, ModalFactory, ProcessCrudService, ProcessToSolveService,
                                    LocalStorage, CollaboratorsService, PoliciesService, $q, sessionFilterService, $timeout) {
    var vm = this;
    vm.view_grid = angular.isDefined(LocalStorage.get('process_view_grid')) ? LocalStorage.get('process_view_grid') : false;
    vm.filter_person = null;
    vm.filter_process_type = null;
    vm.filter_date = null;
    vm.filter_status = null;
    vm.current_direction = null;
    vm.current_order_by = null;
    vm.order_by = 'desc';
    vm.saveTimeout = null; 

    var ltn = $rootScope.$on('ARTIFACT.delete', function () {
      vm.getProcess();
    });
    var ltn2 = $rootScope.$on('UPDATE.list', function () {
      vm.getProcess();
    });

    vm.init = function () {
      vm.checkSessionFilters();
      vm.setupFilterWatchers();
    };

    // Verifica se há filtros salvos na sessão
    vm.checkSessionFilters = function () {
      sessionFilterService.initializeWithFilters({
          storageKey: 'processToSolveFilters',
          onFiltersLoaded: function(filters) {
              // Aplicar todos os filtros carregados
              vm.filter_person = filters.filter_person || null;
              vm.filter_status = filters.filter_status || null;
              vm.filter_date = filters.filter_date || null;
              vm.filter_process_type = filters.filter_process_type || null;
              vm.view_grid = filters.view_grid || false;
              vm.filter_person_responsible = filters.filter_person_responsible || null;
          },
          onInitialized: function(hasSavedFilters) {
              if (hasSavedFilters) {
                      vm.getProcess(1, 15);
                      return true;
              } else {
                  vm.getProcess(1, 15);
                  return $q.resolve(false);
              }
          }
      });
    };

     // Constrói os whatchers em cada propriedade usada em filtros
     vm.setupFilterWatchers = function () {
      
      // Watch em cada propriedade individual
      var propertiesToWatch = ['filter_person', 'filter_status', 'filter_date', 'filter_process_type', 'view_grid', 'filter_person_responsible'];
      
      propertiesToWatch.forEach(function(prop) {
        $scope.$watch('vm.' + prop, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            vm.saveFiltersToSession();
          }
        });
      });
    }

    //Salva filtros na sessão.
    vm.saveFiltersToSession = function() {
      if (vm.saveTimeout) $timeout.cancel(vm.saveTimeout);
          
      vm.saveTimeout = $timeout(function() {
        var filters = {
          filter_person: vm.filter_person,
          filter_status: vm.filter_status,
          filter_date: vm.filter_date,
          filter_process_type: vm.filter_process_type,
          view_grid: vm.view_grid,
          filter_person_responsible: vm.filter_person_responsible
        };
            
        sessionFilterService.saveFilters(filters, 'processToSolveFilters');
      }, 300);
    }

    $scope.$on('orderChanged', function(event, orderData) {
      vm.current_direction = orderData.direction;
      vm.current_order_by = orderData.order_by;
    });

    vm.getProcess = function (page, limit, person, process_type, status, date, order_by, direction, view_grid, person_responsible) {

      $rootScope.show_loader = true;
      vm.process_owner = [];
      /** Importante para garantir o valor correto do filtro de data */
      vm.filter_date = angular.isDefined(date) ? date : vm.filter_date;
      var obj = {
        view_grid: angular.isDefined(view_grid) ? view_grid : vm.view_grid,
        filter_person: angular.isDefined(person) ? person : vm.filter_person,
        filter_person_responsible: angular.isDefined(person_responsible) ? person_responsible : vm.filter_person_responsible,
        filter_process_type: angular.isDefined(process_type) ? process_type :  vm.filter_process_type,
        filter_status: angular.isDefined(status) ? status :  vm.filter_status,
        filter_date_start: getDateFilter(vm.filter_date, date, 'startDate'),
        filter_date_end: getDateFilter(vm.filter_date, date, 'endDate'),
        order_by: angular.isDefined(order_by) ? order_by : vm.current_order_by,
        direction: angular.isDefined(direction) ? direction : vm.current_direction,
        page: angular.isDefined(page) ? page : null,
        limit: angular.isDefined(limit) ? limit : null
      };

      return ProcessToSolveService.getProcessToSolve(obj)
        .then(function (resp) {
          $rootScope.show_loader = false;
          vm.process_owner = resp.plain();
          vm.filter_process = obj;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    }

    /**Formata a informação de data ou retorna a informação de data a depender da necessidade */
    function getDateFilter(defaultDate, date, key) {
      if (angular.isDefined(date) && date !== null && angular.isDefined(date[key]) && date[key] !== null && date[key] !== '') {
        // Verifica se é endDate ou startDate e converte para moment se necessário
        if ((key === 'endDate' || key === 'startDate') && !moment.isMoment(date[key])) {
          date[key] = moment(date[key]);
        }
        
        return date[key].format('YYYY-MM-DD');
      }
      if (defaultDate !== null && angular.isDefined(defaultDate[key])) {
          if (angular.isObject(defaultDate[key]) && angular.isFunction(defaultDate[key].format)) {
              return defaultDate[key].format('YYYY-MM-DD');
          } else {
              return defaultDate[key];
          }
      }
      return null;
  }

    vm.openCardDialog = function (card) {
      ModalFactory.customClean('app/process/process-crud/card/card-dialog.html',
        'ProcessCardDialogController', 'vm', false, {'card': card, 'card_type': 'to_solve'})
        .then(function () {
          vm.getProcess();
        });
    }

    /**
     * Verifica se a data passou do prazo para mudar a cor do badge
     * @param date
     * @returns {boolean}
     */
    vm.isOverdue = function (date) {
      return a4Moment() > a4Moment(date);
    }

    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn2].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular.module('app.process.process-to-solve')
    .controller('ProcessToSolveController', ProcessToSolveController);
})();

(function () {
  'use strict';

  angular.module('app.process.process-person', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function SelectPersonController(CollaboratorsService, ModalExtra, ProcessCrudService, $mdDialog, Common) {
    var vm = this;
    vm.to_resolve = null;

    vm.init = function () {
      vm.process = ModalExtra;
      vm.getDetails();
      vm.process.persons = angular.isUndefined(vm.process.persons) ? [] : vm.process.persons;
    }

    vm.getDetails = function () {
      vm.show_loader = true;
      ProcessCrudService.getProcessTypeDetails({process_type_id: vm.process.id})
        .then(function (resp) {
          vm.show_loader = false;
          vm.process = resp.plain();
        })
    }

    vm.getCollaborators = function (query) {
      return CollaboratorsService.getAll({query: query, get_all_companies: true});
    }

    vm.addPerson = function (person) {
      if (!vm.process.persons) {
        vm.process.persons = [];
      }
      person.to_resolve = false;
      person.to_authorise = false;
      vm.process.persons.push(person);
      vm.person = null;
    }

    vm.removePerson = function (index) {
      vm.process.persons.splice(index, 1);
    }

    vm.submit = function () {
      vm.show_loader = true;
      ProcessCrudService.updateProcessType({process_type: vm.process})
        .then(function () {
          vm.show_loader = false;
          Common.Toast.success('Atualização realizada com sucesso!');
          $mdDialog.hide();
        })
        .catch(function (resp) {
          vm.show_loader = false;
          // if (resp.data.message === 'TIME_SHOCK') {
          //   Common.Toast.warning('Existe outra solicitação neste horário.');
          //   vm.card.time = null;
          //   vm.getHoursUnavailable();
          // } else {
          Common.Toast.error('Erro ao atualizar');
          // }
        })
    }

    /**
     * Close Dialog
     */
    vm.closeModal = function () {
      $mdDialog.cancel();
    }

    vm.init();
  }

  angular.module('app.process.process-person')
    .controller('SelectPersonController', SelectPersonController);
})();

(function () {
  'use strict'

  /** @ngInject*/
  function LocationService(Restangular) {
    var vm = this;

    vm.getLocations = function (){
      return Restangular.one('location').get();
    }

    vm.createLocation = function (obj) {
      return Restangular.all('location').post(obj);
    }

    vm.updateLocation = function (obj) {
      return Restangular.one('location', obj.id).customPUT(obj);
    }

    return vm;
  }

  angular
    .module('app.process.process-person')
    .factory('LocationService', LocationService)
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.process.process-person', {
        url: '/process/process-person',
        public: false,
        // auth: 'finance_dash',
        templateUrl: 'app/process/process-person/views/index.html',
        controller: 'ProcessPersonController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.process.process-person')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run($document, msNavigationService, PoliciesService) {
    // var hidden = false;
    var role = 'process_permissions';
    var path = 'process.process-person';
    msNavigationService.saveItem('process.process-person', {
      title: 'Configurações',
      icon: 'icon-cog',
      state: 'private.process.process-person',
      class: "md-primary",
      weight: 99,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.process.process-person')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function ProcessPersonController($scope, $rootScope, ProcessCrudService, ModalFactory, Common) {
    var vm = this;

    vm.init = function () {
      vm.getProcessType();
    };

    vm.getProcessType = function () {
      $rootScope.show_loader = true;
      ProcessCrudService.getProcessType()
        .then(function (resp) {
          $rootScope.show_loader = false;
          vm.process_types = resp.plain();
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao buscar tipos de solicitações');
        });
    };

    vm.openModal = function (item) {
      ModalFactory.customClean("app/process/process-person/views/select-person-modal.html",
        "SelectPersonController", "vm", false, item).then(function () {
      })
        .then(function () {
          vm.getProcessType();
        });
    };

    vm.openProcessBlockModal = function (item) {
      ModalFactory.customClean("app/process/process-person/views/date-block-modal.html",
        "DateBlockModalController", "vm", false, item)
    };

    vm.init();
  }

  angular.module('app.process.process-person')
    .controller('ProcessPersonController', ProcessPersonController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function ProcessOptionsController() {
    var vm = this;

    vm.init = function () {

    };

    vm.init();
  }

  angular.module('app.process.process-person')
    .controller('ProcessOptionsController', ProcessOptionsController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function DateBlockModalController(ModalExtra, ProcessCrudService, $mdDialog, Common) {
    var vm = this;
    vm.process_type = ModalExtra;
    vm.date = null;

    vm.init = function () {
      vm.getAllBlockDates();
    };

    vm.getAllBlockDates = function () {
    ProcessCrudService.getProcessTypeDateBlock({process_type_id: vm.process_type.id})
      .then(function (response) {
        vm.process = response.plain();
      });
    };

    vm.addBlockDate = function () {
      if(vm.date !== null) {
        ProcessCrudService.addBlockDate({date: vm.date, process_type_id: vm.process_type.id})
          .then(function () {
            vm.date = null;
            vm.getAllBlockDates();
          })
          .catch(function (error) {
            Common.Toast.error(error.data.message);
          });
      }
    };

    vm.deleteDate = function (index) {
      ProcessCrudService.deleteBlockDate({block_date_id: index})
        .then(function () {
          vm.getAllBlockDates();
        })
    };

    vm.closeModal = function () {
      $mdDialog.cancel();
    };


    vm.init();
  }

  angular.module('app.process.process-person')
    .controller('DateBlockModalController', DateBlockModalController);
})();

(function () {
  'use strict'

  /** @ngInject*/
  function ProcessCrudService(Restangular, a4Moment) {
    var vm = this;

    vm.getProcess = function (obj){
      return Restangular.one('process').get(obj);
    };

    vm.getProcessData = function (obj){
      return Restangular.one('process', obj.id).get();
    };

    vm.getProcessType = function () {
      return Restangular.one('process').one('processtype').get();
    };

    vm.getProductsByProcessType = function (obj) {
      return Restangular.one('process').one('getproductsbyprocesstype').get(obj);
    };

    vm.getArtifacts = function (obj) {
      return Restangular.one('process').one('getartifacts').get(obj);
    };

    vm.getProcessTypeTypes = function (process_type_id) {
      return Restangular.one('process').one('processtypetypes', process_type_id).get();
    };

    vm.getHoursUnavailable = function (date, process_type_id) {
      return Restangular.one('process').one('gethoursunavailable').get({date: date, process_type_id: process_type_id});
    };

    vm.getProcessTypeDetails = function (obj){
      return Restangular.one('process').one('getprocesstypedetails').get(obj);
    };

    vm.getProcessTypeDateBlock = function (obj) {
      return Restangular.one('process').one('getprocesstypedateblock').get(obj);
    };

    vm.createProcess = function (obj) {
      return Restangular.all('process').post(obj);
    };

    vm.changeStatus = function (obj) {
      return Restangular.one('process').all('changestatus').post(obj);
    };

    vm.updateProcess = function (obj) {
      return Restangular.one('process', obj.id).customPUT(obj);
    };

    vm.updateProcessType = function (obj) {
      return Restangular.one('process').one('updateprocesstype').customPUT(obj);
    };

    vm.addComment = function (obj) {
      return Restangular.one('process').all('addcomment').post(obj);
    };

    vm.deleteArtifact = function (obj) {
      return Restangular.one('process').all('deleteartifact').post(obj);
    };

    vm.addBlockDate = function (obj) {
      return Restangular.one('process').all('addblockdate').post(obj);
    };

    vm.deleteBlockDate = function (obj) {
      return Restangular.one('process').all('deleteblockdate').post(obj);
    };

    vm.getHours = function () {
      var hours = [];
      for(var i = 7; i <= 17; i++){
        hours.push({hour: a4Moment({hour: i, minute: 0}).format('HH:mm'), is_available: true});
        hours.push({hour: a4Moment({hour: i, minute: 15}).format('HH:mm'), is_available: true});
        hours.push({hour: a4Moment({hour: i, minute: 30}).format('HH:mm'), is_available: true});
        if(i < 17) {
          hours.push({hour: a4Moment({hour: i, minute: 45}).format('HH:mm'), is_available: true});
        }
      }
      return hours;
    };

    return vm;
  }

  angular
    .module('app.process.process-crud')
    .factory('ProcessCrudService', ProcessCrudService)
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.process.process-crud', {
        url: '/process/myprocess',
        public: false,
        // auth: 'finance_dash',
        templateUrl: 'app/process/process-crud/views/process.html',
        controller: 'ProcessCrudController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.process.process-crud')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run($document, msNavigationService) {
    var current_connection = $document[0].domain.split('.')[0];
    var hidden = false;
    msNavigationService.saveItem('process.process-crud', {
      title: 'Minhas solicitações',
      icon: 'icon-calendar-text',
      state: 'private.process.process-crud',
      class: "md-primary",
      weight: 2,
      hidden: function () {
        return hidden;
      }
    });
  }

  angular
    .module('app.process.process-crud')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function ProcessCrudController($a4FloatButton, $scope, $rootScope, a4Moment, ModalFactory, ProcessCrudService,
                                 LocalStorage, $q, sessionFilterService, $timeout) {
    var vm = this;
    vm.view_grid = angular.isDefined(LocalStorage.get('process_view_grid')) ? LocalStorage.get('process_view_grid') : false;
    vm.filter_person = null;
    vm.filter_process_type = null;
    vm.filter_date = null;
    vm.filter_status = null;
    vm.order_by = null;
    vm.saveTimeout = null;

    var ltn = $rootScope.$on('ARTIFACT.delete', function () {
      vm.getProcess();
    });
    var ltn2 = $rootScope.$on('UPDATE.list', function () {
      vm.getProcess();
    });

    vm.init = function () {
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.openCardDialog({id: null})', theme: 'process',
        label: 'Criar nova requisição',
        conditional: true
      });
      vm.getProcess();

      vm.checkSessionFilters();
      vm.setupFilterWatchers();
    }

     // Verifica se há filtros salvos na sessão
     vm.checkSessionFilters = function () {
      sessionFilterService.initializeWithFilters({
          storageKey: 'processFilters',
          onFiltersLoaded: function(filters) {
              // Aplicar todos os filtros carregados
              vm.filter_person = filters.filter_person || null;
              vm.filter_status = filters.filter_status || null;
              vm.filter_date = filters.filter_date || null;
              vm.filter_process_type = filters.filter_process_type || null;
              vm.view_grid = filters.view_grid || false;
          },
          onInitialized: function(hasSavedFilters, filters) {
              if (hasSavedFilters) {
                      vm.getProcess(1, 15);
                      return true;
              } else {
                  vm.getProcess(1, 15);
                  return $q.resolve(false);
              }
          }
      });
    };

     // Constrói os whatchers em cada propriedade usada em filtros
     vm.setupFilterWatchers = function () {
      
      // Watch em cada propriedade individual
      var propertiesToWatch = ['filter_person', 'filter_status', 'filter_date', 'filter_process_type', 'view_grid'];
      
      propertiesToWatch.forEach(function(prop) {
        $scope.$watch('vm.' + prop, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            vm.saveFiltersToSession();
          }
        });
      });
    }

    //Salva filtros na sessão.
    vm.saveFiltersToSession = function() {
      if (vm.saveTimeout) $timeout.cancel(vm.saveTimeout);
          
      vm.saveTimeout = $timeout(function() {
        var filters = {
          filter_person: vm.filter_person,
          filter_status: vm.filter_status,
          filter_date: vm.filter_date,
          filter_process_type: vm.filter_process_type,
          view_grid: vm.view_grid
        };
            
        sessionFilterService.saveFilters(filters, 'processFilters');
      }, 300);
    }

    vm.getProcess = function (page, limit, person, process_type, status, date, order_by, direction, view_grid) {
      $rootScope.show_loader = true;
      // vm.process_owner = [];
      /** Importante para garantir o valor correto do filtro de data */
      vm.filter_date = angular.isDefined(date) ? date : vm.filter_date;
      var obj = {
        view_grid: angular.isDefined(view_grid) ? view_grid : vm.view_grid,
        filter_person: angular.isDefined(person) ? person : vm.filter_person,
        filter_process_type: angular.isDefined(process_type) ? process_type : vm.filter_process_type,
        filter_status: angular.isDefined(status) ? status : vm.filter_status,
        filter_date_start: angular.isDefined(date) && date.startDate !== null && date.startDate !== '' ? angular.copy(date.startDate) :
          vm.filter_date !== null && vm.filter_date.startDate !== '' ? angular.copy(vm.filter_date.startDate) : null,
        filter_date_end: angular.isDefined(date) && date.endDate !== null && date.endDate !== '' ? angular.copy(date.endDate) :
          vm.filter_date !== null && vm.filter_date.endDate !== '' ? angular.copy(vm.filter_date.endDate) : null,
        order_by: angular.isDefined(order_by) ? order_by : null,
        direction: angular.isDefined(direction) ? direction : null,
        page: angular.isDefined(page) ? page : null,
        limit: angular.isDefined(limit) ? limit : null
      };

      ProcessCrudService.getProcess(obj)
        .then(function (resp) {
          $rootScope.show_loader = false;
          vm.process_owner = resp.plain();
          vm.filter_process = obj;
        })
    }

    vm.openCardDialog = function (card) {
      ModalFactory.customClean('app/process/process-crud/card/card-dialog.html',
        'ProcessCardDialogController', 'vm', false, {'card': card, 'card_type': 'crud'})
        .then(function () {
          vm.getProcess();
        });
    }

    /**
     * Verifica se a data passou do prazo para mudar a cor do badge
     * @param date
     * @returns {boolean}
     */
    vm.isOverdue = function (date) {
      return a4Moment() > a4Moment(date);
    }

    vm.changeView = function () {
      LocalStorage.add('process_view_grid', vm.view_grid);
      vm.getProcess();
    }

    $scope.$on('$destroy', function () {
      [ltn, ltn2, ltn3].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular.module('app.process.process-crud')
    .controller('ProcessCrudController', ProcessCrudController);
})();

(function () {
  'use strict'

  /** @ngInject*/
  function LocationService(Restangular) {
    var vm = this;

    vm.getLocations = function (){
      return Restangular.one('location').get();
    }

    vm.createLocation = function (obj) {
      return Restangular.all('location').post(obj);
    }

    vm.updateLocation = function (obj) {
      return Restangular.one('location', obj.id).customPUT(obj);
    }

    return vm;
  }

  angular
    .module('app.process.location')
    .factory('LocationService', LocationService)
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.process.location', {
        url: '/process/location',
        public: false,
        // auth: 'finance_dash',
        templateUrl: 'app/process/location/views/location.html',
        controller: 'LocationController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.process.location')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run($document, msNavigationService, PoliciesService) {
    // var hidden = false;
    var role = 'process_locations';
    var path = 'process.location';
    msNavigationService.saveItem('process.location', {
      title: 'Locais',
      icon: 'icon-map-marker',
      state: 'private.process.location',
      class: "md-primary",
      weight: 2,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.process.location')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function LocationController($scope, $rootScope, LocationService) {
    var vm = this;
    vm.columns = [{id: 'name', name: 'Nome'}];

    vm.init = function () {
      vm.getLocations();
    }

    vm.getLocations = function () {
      $rootScope.show_loader = true;
      LocationService.getLocations()
        .then(function (resp) {
          $rootScope.show_loader = false;
          vm.locations = resp.plain();
        })
    }

    vm.createLocation = function (item) {
      $rootScope.show_loader = true;
      LocationService.createLocation(item)
        .then(function () {
          vm.getLocations();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    }

    vm.editLocation = function (item) {
      $rootScope.show_loader = true;
      LocationService.updateLocation(item)
        .then(function () {
          vm.getLocations();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    }

    vm.init();
  }

  angular.module('app.process.location')
    .controller('LocationController', LocationController);
})();

(function () {
  'use strict';

  angular
    .module('app.process.dashboard', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.process.dashboard', {
        url: '/dashboard',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/process/dashboard/dashboard.html',
        controller: 'DashboardProcessController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.process.dashboard')
    .config(routerConfig);

})();





(function () {
	'use strict';

	/** @ngInject */
	function run(msNavigationService) {
		msNavigationService.saveItem('process.dashboard', {
			title: 'Dashboard',
			icon: 'icon-window-restore',
			state: 'private.process.dashboard',
			class: "md-primary",
			weight: 1
		});
	}

	angular
		.module('app.process.dashboard')
		.run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function DashboardProcessController(ModalFactory, $a4FloatButton, $scope, ProcessCrudService, a4Moment) {
    var vm = this;

    vm.board = {
      "id": "32gfhaf2",
      "name": "ACME Frontend Application",
      "uri": "acme-frontend-application",
      "settings": {
        "color": "blue-grey",
        "subscribed": false,
        "cardCoverImages": true
      },
      lists: [
        {
          id: "56027cf5a2ca3839a5d36103",
          name: "Minhas solicitações",
          idCards: [
            "5603a2a3cab0c8300f6096b3",
            "44d1.2b51ea6cc2b5d.21f4a3412e857.8ffa2d8b44ad9.ac87215ed53a1.67d4921ad8f8d.9f318bcb2"
          ]
        },
        {
          "id": "56127cf2a2ca3539g7d36103",
          "name": "Lista de solicitações",
          "idCards": [
            "2837273da9b93dd84243s0f9",
            "5787b7e4740c57bf0dffd5b6",
            "5637273da9b93bb84743a0f9",
            "7987.9740ba532b0d4.f9d12243f7362.507c0738dc561.87fba0a03df6e.75e6508cacf10.7a9835b54"
          ]
        },
        {
          "id": "faf244627326f1249525763d",
          "name": "Concluídas",
          "idCards": [
            "d9005a4b89ed2aadca48a6ad",
            "f6b9d7a9247e5d794a081927",
            "80ed.24ad3b18e2668.f28fbbceeeff9.5a834620a42f1.5909be19a2bf2.6c4a54947ce2d.da356b0c1",
            "0ad2.7862f947bc456.f42b446df54cb.d1dd9e93601a1.9deb1406d1404.0b3c278fc7001.733341b42",
            "bad3.51be8ad33acaf.9540ecb37f7e8.6bee596cfe7d3.44c68bee289c4.b96ed0b9f0af7.e14846035"
          ]
        },
        {
          "id": "faf244627326f12495257d",
          "name": "Canceladas",
          "idCards": [
            "d9005a4b89ed2aadca48a6ad",
            "f6b9d7a9247e5d794a081927",
            "80ed.24ad3b18e2668.f28fbbceeeff9.5a834620a42f1.5909be19a2bf2.6c4a54947ce2d.da356b0c1",
            "0ad2.7862f947bc456.f42b446df54cb.d1dd9e93601a1.9deb1406d1404.0b3c278fc7001.733341b42",
            "bad3.51be8ad33acaf.9540ecb37f7e8.6bee596cfe7d3.44c68bee289c4.b96ed0b9f0af7.e14846035"
          ]
        }
      ],
      cards: {
        "2837273da9b93dd84243s0f9": {
          "id": "2837273da9b93dd84243s0f9",
          "name": "Update generators",
          "description": "Current generator doesn't support Node.js 6 and above.",
          "idAttachmentCover": "",
          "idMembers": [
            "26027s1930450d8bf7b10828"
          ],
          "idLabels": [
            "26022e4129ad3a5sc28b36cd"
          ],
          "attachments": [],
          "subscribed": false,
          "checklists": [],
          "checkItems": 0,
          "checkItemsChecked": 0,
          "comments": [
            {
              "idMember": "36027j1930450d8bf7b10158",
              "message": "AngularCLI could be a nice alternative.",
              "time": "now"
            }
          ],
          "activities": [],
          "due": null
        },
      "5603a2a3cab0c8300f6096b3":  {
        "id": "5603a2a3cab0c8300f6096b3",
        "name": "Change background colors",
        "description": "Change background colors",
        "idAttachmentCover": "67027cahbe3b52ecf2dc631c",
        "idMembers": [
          "76027g1930450d8bf7b10958"
        ],
        "idLabels": [
          "56027e4119ad3a5dc28b36cd",
          "5640635e19ad3a5dc21416b2"
        ],
        "attachments": [
          {
            "id": "67027cahbe3b52ecf2dc631c",
            "name": "mail.jpg",
            "src": "assets/images/scrumboard/mail.jpg",
            "time": "Added Nov 3 at 15:22AM",
            "type": "image"
          },
          {
            "id": "56027cfcbe1b72ecf1fc452a",
            "name": "calendar.jpg",
            "src": "assets/images/scrumboard/calendar.jpg",
            "time": "Added Nov 1 at 12:34PM",
            "type": "image"
          }
        ],
        "subscribed": true,
        "checklists": [
          {
            "id": "63021cfdbe1x72wcf1fc451v",
            "name": "Checklist",
            "checkItemsChecked": 1,
            "checkItems": [
              {
                "name": "Implement a calendar library",
                "checked": false
              },
              {
                "name": "Replace event colors with Material Design colors",
                "checked": true
              },
              {
                "name": "Replace icons with Material Design icons",
                "checked": false
              },
              {
                "name": "Use moment.js",
                "checked": false
              }
            ]
          },
          {
            "name": "Checklist 2",
            "id": "74031cfdbe1x72wcz1dc166z",
            "checkItemsChecked": 1,
            "checkItems": [
              {
                "name": "Replace event colors with Material Design colors",
                "checked": true
              },
              {
                "name": "Replace icons with Material Design icons",
                "checked": false
              },
              {
                "name": "Use moment.js",
                "checked": false
              }
            ]
          }
        ],
        "checkItems": 7,
        "checkItemsChecked": 2,
        "comments": [
          {
            "idMember": "56027c1930450d8bf7b10758",
            "message": "We should be able to add moment.js without any problems",
            "time": "12 mins. ago"
          },
          {
            "idMember": "36027j1930450d8bf7b10158",
            "message": "I added a link for a page that might help us deciding the colors",
            "time": "30 mins. ago"
          }
        ],
        "activities": [
          {
            "idMember": "56027c1930450d8bf7b10758",
            "message": "added a comment",
            "time": "12 mins. ago"
          },
          {
            "idMember": "36027j1930450d8bf7b10158",
            "message": "added a comment",
            "time": "30 mins. ago"
          },
          {
            "idMember": "36027j1930450d8bf7b10158",
            "message": "attached a link",
            "time": "45 mins. ago"
          }
        ],
        "due": "1452229200000"
      },
      "5637273da9b93bb84743a0f9":  {
        "id": "5637273da9b93bb84743a0f9",
        "name": "Fix splash screen bugs",
        "description": "",
        "idAttachmentCover": "",
        "idMembers": [
          "56027c1930450d8bf7b10758"
        ],
        "idLabels": [
          "5640635e19ad3a5dc21416b2"
        ],
        "attachments": [],
        "subscribed": true,
        "checklists": [],
        "checkItems": 0,
        "checkItemsChecked": 0,
        "comments": [],
        "activities": [],
        "due": null
      },
        "d9005a4b89ed2aadca48a6ad": {
          "id": "d9005a4b89ed2aadca48a6ad",
          "name": "Add alternative authentication pages",
          "description": "",
          "idAttachmentCover": "",
          "idMembers": [
            "36027j1930450d8bf7b10158"
          ],
          "idLabels": [
            "6540635g19ad3s5dc31412b2",
            "56027e4119ad3a5dc28b36cd"
          ],
          "attachments": [],
          "subscribed": false,
          "checklists": [
            {
              "id": "dbfb.99bd0ad37dabc.e05046f0c824d.18f26bb524c96.78bebc8488634.240c0ee6a5e45.4cb872965",
              "name": "Pages",
              "checkItemsChecked": 2,
              "checkItems": [
                {
                  "name": "Login",
                  "checked": true
                },
                {
                  "name": "Register",
                  "checked": true
                },
                {
                  "name": "Lost Password",
                  "checked": false
                },
                {
                  "name": "Recover Password",
                  "checked": false
                },
                {
                  "name": "Activate Account",
                  "checked": false
                }
              ]
            }
          ],
          "checkItems": 5,
          "checkItemsChecked": 2,
          "comments": [],
          "activities": [],
          "due": null
        }
      },
      "members": {
        "56027c1930450d8bf7b10758": {
          "id": "56027c1930450d8bf7b10758",
          "name": "Alice Freeman",
          "avatar": "assets/images/avatars/alice.jpg"
        },
        "26027s1930450d8bf7b10828": {
          "id": "26027s1930450d8bf7b10828",
          "name": "Danielle Obrien",
          "avatar": "assets/images/avatars/danielle.jpg"
        },
        "76027g1930450d8bf7b10958": {
          "id": "76027g1930450d8bf7b10958",
          "name": "James Lewis",
          "avatar": "assets/images/avatars/james.jpg"
        },
        "36027j1930450d8bf7b10158": {
          "id": "36027j1930450d8bf7b10158",
          "name": "Vincent Munoz",
          "avatar": "assets/images/avatars/vincent.jpg"
        }
      },
      "labels": [
        {
          "id": "26022e4129ad3a5sc28b36cd",
          "name": "High Priority",
          "color": "red"
        },
        {
          "id": "56027e4119ad3a5dc28b36cd",
          "name": "Design",
          "color": "orange"
        },
        {
          "id": "5640635e19ad3a5dc21416b2",
          "name": "App",
          "color": "blue"
        },
        {
          "id": "6540635g19ad3s5dc31412b2",
          "name": "Feature",
          "color": "green"
        }
      ]
    }

    vm.init = function () {
    };

    vm.init();
  }

  angular
    .module('app.process.dashboard')
    .controller('DashboardProcessController', DashboardProcessController);

})();
(function () {
    'use strict';
    angular.module('app.login', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function LoginTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "invalid_credentials": 'Email ou senha invalidos',
      "invalid_enrollment": 'Você não possui matrícula ativa. Entre em contato com a secretaria',
      "LOGIN_V2": {
        "INTRO_TITLE": "Bem-vindo ao A4 Cloud",
        "INTRO_DESCRIPTION": "",
        "TITLE": "Acessar conta",
        "DESCRIPTION": "",
        "EMAIL": "Email",
        "PASSWORD": "Senha",
        "FORGOT_PASSWORD": "Esqueceu a senha?",
        "REMEMBER_ME": "Lembrar-me",
        "LOG_IN": "Entrar",
        "DONT_HAVE_ACCOUNT": "Não tem conta?",
        "CREATE_ACCOUNT": "Crie-a aqui",
        "WITH_GOOGLE": "Login com Google",
        "WITH_FACEBOOK": "Login com Facebook",
        "OR": "Ou",
        "ERRORS": {
          "EMAIL_REQUIRED": 'Por favor digite um email.',
          "PASSWORD_REQUIRED": 'Por favor digite uma senha.',
          "EMAIL_MUST_VALID": 'Deve ser um email valido.'
        }
      },
      "FORGOTPASSWORD": {
        "TITLE": 'Recupere sua senha',
        "EMAIL_ADRESS": 'Digite seu e-mail',
        "SEND_RESET_LINK": "RECUPERAR VIA EMAIL",
        "GO_BACK": "Voltar para login",
        "CHANGE_PASSWORD": "MUDAR SENHA",
        "PASSWORD": "Nova senha",
        "PASSWORD_CONFIRM": "Nova senha (Confirmação)",
        "ERRORS": {
          "EMAIL_REQUIRED": "Por favor digite um email.",
          "EMAIL_MUST_VALID": "Deve ser um email valido."
        }
      }
    })
  }

  angular
    .module('app.login')
    .config(LoginTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function LabsDatabase($rootScope, $scope, $document, $state, $window, $timeout, CONFIG, Common, ModalExtra, a4Socket, LoginService) {
    var vm = this;
    vm.database_selected = null;
    vm.alias = '';
    vm.stream_message = "";
    vm.barvalue = 0;
    vm.timerDisplay = "";
    vm.completionTime = false;
    vm.startTime = null;
    vm.timerInterval = null;
    vm.init = function () {
      vm.databases = ModalExtra;

      var subdomain = $document[0].domain.split('.')[0];
      // vm.list_channel = subdomain + CONFIG.socket.stream_a4_backup;

      // a4Socket.connect(vm.list_channel).on(vm.list_channel, function (data) {
      //   var obj = angular.fromJson(data);
      //   vm.stream_message = obj.message;
      //   vm.barvalue = obj.barvalue;
      // });
    };

    /** Realiza o fechamento do modal */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /**
     * Retorna os bancos de dados disponíveis para re-estruturação do sistema LABS
     * @param login - Usuário de acesso
     * @param password - Senha de acesso
     */
    vm.getDatabases = function (login, password) {
      vm.loading = true;
      LoginService.getAvailableDatabase({login: login, password: password})
        .then(function (response) {
          vm.databases = response.plain();
          vm.loading = false;
        })
        .catch(function (error) {
          Common.Toast.error(error.data.message);
          vm.loading = false;
        });
    };

    /**
     * Formatar tempo em mm:ss
     */
    vm.formatTime = function (seconds) {
      var minutes = Math.floor(seconds / 60);
      var remainingSeconds = seconds % 60;
      return (minutes < 10 ? '0' : '') + minutes + ':' + (remainingSeconds < 10 ? '0' : '') + remainingSeconds;
    };

    /**
     * Iniciar timer
     */
    vm.startTimer = function () {
      vm.startTime = new Date();
      vm.completionTime = false;
      vm.timerInterval = setInterval(function () {
        var elapsed = Math.floor((new Date() - vm.startTime) / 1000);
        vm.timerDisplay = vm.formatTime(elapsed);
        $scope.$apply();
      }, 1000);
    };

    /**
     * Parar timer e mostrar tempo final
     */
    vm.stopTimer = function () {
      if (vm.timerInterval) {
        clearInterval(vm.timerInterval);
        vm.timerInterval = null;
      }
      if (vm.startTime) {
        var totalTime = Math.floor((new Date() - vm.startTime) / 1000);
        vm.timerDisplay = "Finalizado em " + vm.formatTime(totalTime);
        vm.completionTime = true;
      }
    };

    /**
     * Executar processo de reestruturação
     * @param labslogin
     * @param labspassword
     * @param database_selected
     * @param is_simple_copy
     */
    vm.executeReDatabase = function (labslogin, labspassword, database_selected, is_simple_copy) {
      vm.loading = true;
      vm.startTimer();
      
      var params = {
        login: labslogin, 
        password: labspassword, 
        database: database_selected
      };
      
      if (is_simple_copy) {
        params.is_simple_copy = true;
      }
      
      LoginService.executeReDatabase(params)
        .then(function (response) {
          vm.stopTimer();
          Common.Toast.success(response.message);
          vm.loading = false;
        })
        .catch(function (error) {
          vm.stopTimer();
          Common.Toast.error(error.message || error.data.message);
          vm.loading = false;
        })
    };

    $scope.$on('$destroy', function () {
      if (vm.timerInterval) {
        clearInterval(vm.timerInterval);
      }
      a4Socket.disconnect(vm.list_channel);
    });

    vm.init();
  }

  angular
    .module('app.login')
    .controller('LabsDatabase', LabsDatabase);

})();

(function () {
  'use strict';

  angular
    .module('app.log', []);
})();


(function () {
  'use strict';

  /** @ngInject */
  function LogTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      "LOG": {
        "TITLE": "Log",
        "SEARCH": "Pesquisar"
      }
    })

  }

  angular
    .module('app.log')
    .config(LogTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.fmd', []);
})();

(function () {
    'use strict';

    /** @ngInject */
    function FMDTranslate($translateProvider) {

        $translateProvider.translations('pt', {
          "FMD": {
            "TITLE": "Assistente de migração",
            "SEND": "Enviar"
          }
        })

    }

    angular
        .module('app.fmd')
        .config(FMDTranslate);
})();

(function () {
  'use strict';
  angular
    .module('app.finance', [
      'app.finance.dashboard',
      'app.finance.billcategory',
      'app.finance.product',
      'app.finance.person',
      'app.finance.credits',
      'app.finance.person.profile',
      'app.finance.person.expense',
      'app.finance.person.receipt',
      'app.finance.person.check',
      'app.finance.communication',
      'app.finance.currentaccount',
      'app.finance.bill-expense',
      'app.finance.bill-expense.contract-expense',
      'app.finance.bill-expense.contract-expense.modal-edit-expense',
      'app.finance.bill-receipt',
      'app.finance.bill-negotiate',
      'app.finance.bill-payment',
      'app.finance.bill-reverse',
      'app.finance.bill-chargeback',
      'app.finance.settings',
      'app.finance.discounts',
      'app.finance.paymentplan',
      'app.finance.discounts',
      'app.finance.discounts-reason',
      'app.finance.additions',
      'app.finance.banksliprule',
      'app.finance.bankslip',
      'app.finance.correctionindex',
      'app.finance.daily-balance',
      'app.finance.bank-file-receive',
      'app.finance.nfse',
      'app.finance.bank-file-send',
      'app.finance.check-received',
      'app.finance.check-received.bordero',
      'app.finance.check-received.bordero',
      'app.finance.cashier-session',
      'app.finance.guest-check-pad',
      'app.finance.finance-reports',
      'app.finance.finance-reports.monthly-financial-report',
      'app.finance.finance-reports.income-tax-report',
      'app.finance.cashier-management',
      'app.individual-discounts',
      'app.finance.a4pag',
      'app.finance.contract',
      'app.finance.negotiation',
      'app.finance.difference-analysis',
      'app.finance.finance-reports-generation',
      'app.finance.finance-reports.collaborators-protocol',
      'app.finance.finance-reports.cashier-session-resume',
      'app.finance.finance-reports.reverse-report',
      'app.finance.finance-reports.undo-check-pad-report',
      'app.finance.finance-reports.differences-report',
      'app.finance.finance-reports.products-report',
      'app.finance.finance-reports.monthly-receive-report',
      'app.finance.finance-reports.bill-charge-report',
      'app.finance.finance-reports.undo-movements-report',
      'app.finance.payment-book',
      'app.finance.external-financial-statement',
      'app.finance.finance-reports.finance-movement-report',
      'app.finance.edit-document'
    ]);
})();

(function () {
  'use strict';
  
  /** @ngInject */
  function FinanceTranslate($translateProvider) {
    
    $translateProvider.translations('pt', {
      "TOOLBAR": {
        "LOG_OUT": 'Sair',
        "PREFERENCES": 'Preferências',
        "TOGGLE_NAVIGATION": "Toggle navigation",
        "TOGGLE_NAVIGATION_FOLD": "Toggle navigation fold",
        "TOGGLE_NAVIGATION_MODE": "Toggle navigation mode",
        "SEARCH": "Search",
        "USER_SETTINGS": "User settings",
        "TOGGLE_QUICK_PANEL": "Toggle quick panel",
        "ENGLISH": "English",
        "SPANISH": "Spanish",
        "TURKISH": "Turkish",
        "PORTUGUESE": "Português",
        "LOCK_SCREEN": "Bloquear",
        "CHANGE_PASSWORD": "Trocar senha",
        "PRIVILEGES": "Privilégios",
        "CHANGE_PROFILE": "Mudar Perfil",
        "is_student": "Alunos",
        "is_parents": "Responsáveis",
        "is_teacher": "Professores",
        "is_employee": "Colaboradores"
      },
      "LOCK": {
        "TITLE": "Sua sessão está bloqueada",
        "SUBTITLE": "Digite sua senha para continar.",
        "USERNAME": "User Name",
        "PASSWORD": "Digite sua senha",
        "UNLOCK": "DESBLOQUEAR",
        "ARE_YOU_NOT": "Você não é ",
        "ERRORS": {
          "PASSWORD_REQUIRED": "Digite uma senha para desbloquear a sessão."
        }
      }
    });
    
  }
  
  angular
    .module('app.finance')
    .config(FinanceTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function SettingsService(Restangular) {
    var vm = this;

    vm.saveEnrolmentConfiguration = function (obj) {
      return Restangular.all('enrolmentconfig').post(obj);
    };

    vm.getEnrolmentConfiguration = function (obj) {
      return Restangular.one('enrolmentconfig').get(obj);
    };

    vm.saveGradeReportConfiguration = function (obj) {
      return Restangular.all('gradereportconfig').post(obj);
    };

    vm.getGradeReportConfiguration = function (obj) {
      return Restangular.one('gradereportconfig').get(obj);
    };

    vm.getLimitDates = function () {
      return Restangular.one('config').one('getlimitdates').get();
    };

    vm.changeLimitDates = function (obj) {
      return Restangular.one('config').all('changelimitdates').post(obj);
    };


    return vm;
  }

  angular
    .module('app.finance.settings')
    .factory('SettingsService', SettingsService);

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.settings', {
        url: '/settings',
        public: false,
        templateUrl: 'app/finance/settings/views/index.html',
        controller: 'SettingsController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Configurações'
        }
      });
  }

  angular
    .module('app.finance.settings')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'config_fin_menu';
    var path = 'finance.settings';
    msNavigationService.saveItem('finance.settings', {
      title: 'Configurações',
      icon: 'icon-cog',
      state: 'private.finance.settings',
      weight: 999,
      auth: role,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.settings')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function SettingsController($rootScope, $scope, Common, ModalFactory, NFSEService, PoliciesService) {

    var vm = this;
    vm.product_list = [];
    vm.boardList = [];

    /**
     * Evento chamado após o carregamento completo da tela (Padrão AngularJS)
     * @type {*}
     */
    var ltn = $rootScope.$on('$viewContentLoaded', function () {
      vm.boardList = [
        {
          "name": "Plano de Pagamento",
          "state": "private.finance.paymentplan",
          "icon": 'icon-view-carousel',
          "policy": !vm.checkPolicies('config_fin')
        },
        {
          "name": "Categorias",
          "state": "private.finance.billcategory",
          "icon": 'icon-format-align-left',
          "policy": !vm.checkPolicies('config_fin')
        },
        {
          "name": "Serviços",
          "state": "private.finance.product",
          "icon": 'icon-cube-outline',
          "policy": !vm.checkPolicies('config_fin')
        },
        {
          "name": "Regras de Desconto",
          "state": "private.finance.discounts",
          "icon": 'icon-arrow-down-bold',
          "policy": !vm.checkPolicies('config_fin')
        },
        {
          "name": "Regras de Acréscimos",
          "state": "private.finance.additions",
          "icon": "icon-arrow-up-bold",
          "policy": !vm.checkPolicies('config_fin')
        },
        {
          "name": "Regras de Boleto",
          "state": "private.finance.banksliprule",
          "icon": 'icon-content-paste',
          "policy": !vm.checkPolicies('config_fin')
        },
        {
          "name": "Indices de Correção",
          "state": "private.finance.correctionindex",
          "icon": 'icon-chart-line',
          "policy": !vm.checkPolicies('config_fin')
        },
        {
          "name": "Log",
          "state": "private.finance.log",
          "icon": 'icon-data',
          "policy": !vm.checkPolicies('log')
        },
        {
          "name": "Assistente de Migração",
          "state": "private.finance.fmd",
          "icon": 'icon-server',
          "policy": !vm.checkPolicies('config_fin')
        },
        {
          "name": "Gerenciamento de Caixas",
          "state": "private.finance.cashier-management",
          "icon": 'icon-cash-multiple',
          "policy": !vm.checkPolicies('caixa_alt')
        },
        {
          "name": "Motivos de desconto",
          "state": "private.finance.discounts-reason",
          "icon": 'icon-note-text',
          "policy": !vm.checkPolicies('config_fin')
        }
      ];
    });

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Retorna todos os produtos/serviços
     */
    vm.getAllProducts = function () {
      var deffered = Common.$q.defer();
      NFSEService.getAllProducts()
        .then(function (response) {
          var nullable = [{id: null, name: 'Sem Serviço'}];
          vm.service = {id: null, name: 'Sem Serviço'};
          var list = response.plain();
          vm.product_list = nullable.concat(list);
          deffered.resolve(list);
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao carregar produtos');
          deffered.reject(false);
          $rootScope.show_loader = false;
        });
      return deffered.promise;
    };

    /**
     * Busca os dados da empresa corrente
     */
    vm.getCurrentCompany = function () {
      return NFSEService.getCurrentCompany();
    };

    /**
     * Abre modal de configurações de aliquota
     */
    vm.openRateSettings = function () {
      vm.getAllProducts({
        withoutExternalId: true,
        only_services: true
      })
        .then(function (products) {
          ModalFactory.customClean("app/finance/settings/views/rate_settings.html",
            "AliquotaSettingsController", "vm", false, {
              productList: products.data
            });
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Abre modal de configurações de empresa corrente
     */
    vm.openConfigurationForCompany = function () {
      vm.getCurrentCompany()
        .then(function (response) {
          ModalFactory.customClean("app/finance/settings/views/company-configuration.html",
            "CompanyGeneralSettingsController", "vm", false, {
              company: response.plain(),
              operacao: NFSEService.getListOfOptionsOperation(),
              tributacao: NFSEService.getListOfOptionsTribute()
            });
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao carregar companhias');
          $rootScope.show_loader = false;
        });
    };

    vm.openEmailConfig = function () {
      vm.getCurrentCompany().then(function (company) {
        ModalFactory.custom('app/educational/settings/views/email-config.html', {
          company: company.plain(),
          theme: 'finance'
        }, false)
          .then(function (response) {
            if (response) {
              $rootScope.show_loader = true;
              NFSEService.updateCompanyConfig(response).then(function () {
                Common.Toast.success('Configuração de e-mail salva com sucesso.');
                $rootScope.show_loader = false;
              })
            }
          })
      })
    };

    /**
     * Destructor do controlador
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    })

  }


  angular
    .module('app.finance.settings')
    .controller('SettingsController', SettingsController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function CompanyGeneralSettingsController($rootScope, a4Moment, Common, NFSEService, ModalExtra) {

    var vm = this;
    vm.currentCompany = null;
    vm.product_list = [];
    vm.boardList = [];

    vm.init = function () {
      vm.company = ModalExtra.company;
      vm.tributacao = ModalExtra.tributacao;
      vm.operacao = ModalExtra.operacao;
    };

    /**
     * Executa o salvamento de configurações de empresa
     * @param company
     */
    vm.saveCompanyConfig = function (company) {
      if (company != null) {
        NFSEService.updateCompanyConfig(company)
          .then(function (response) {
            if (response.result) {
              Common.Toast.success("Configuração de empresa salva com sucesso!");
              $rootScope.$broadcast('ModalFactory.close');
            }
          })
          .catch(function (reject) {
            if (angular.isDefined(reject.message)) {
              Common.Toast.error(reject.message);
            } else {
              Common.Toast.error(reject);
            }
          });
      }
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

    angular
      .module('app.finance.settings')
      .controller('CompanyGeneralSettingsController', CompanyGeneralSettingsController);

  }

)();

(function () {
  'use strict';

  /** @ngInject */
  function AliquotaSettingsController($rootScope, Common, NFSEService, ModalExtra) {

    var vm = this;
    vm.currentCompany = null;
    vm.product_list = [];
    vm.boardList = [];
    vm.page = 1;
    vm.show_loader = false;

    vm.init = function () {
      vm.product_list = ModalExtra.productList;
      vm.products = vm.product_list;
    };

    /**
     * salva as mudanças nas configuracoes de aliquota
     */
    vm.saveAliquotConfig = function (product_list) {
      if (vm.product_list != null && vm.product_list.length > 0) {
        NFSEService.updateAliquotConfig(product_list)
          .then(function (response) {
            if (response.result) {
              Common.Toast.success("Configuração de aliquota salva com sucesso!");
              $rootScope.$broadcast('ModalFactory.close');
            }
          })
          .catch(function (reject) {
            if (angular.isDefined(reject.message)) {
              Common.Toast.error(reject.message);
            } else {
              Common.Toast.error(reject);
            }
          });
      }
    };

    vm.paginate = function () {
      vm.page++;
      $rootScope.show_loader = true;
      vm.show_loader = true;
      NFSEService.getAllProducts({limit: 20, page: vm.page}).then(function (response) {
        var products = response.plain();
        vm.products = vm.products.concat(products.data);
        $rootScope.show_loader = false;
        vm.show_loader = false;
      })
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular
    .module('app.finance.settings')
    .controller('AliquotaSettingsController', AliquotaSettingsController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function FinanceReportsService(Restangular, CONFIG, Common, $http) {
    var vm = this;

    var getDataMonthlyFinancialReport = function (obj) {
      return Restangular.one('reports').one('monthlyfinancialflow').get(obj);
    };

    var getDefaultsReport = function (obj) {
      return Restangular.one('reports').one('defaults').get(obj);
    };

    var getDesignedRealizedReport = function (obj) {
      return Restangular.one('reports').one('designedrealizedreport').get(obj);
    };

    var getIncomeTaxReport = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/incometax',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          var filename = obj.name + '.pdf';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      });
      return deffered.promise;

    };

    /** relatório de inadimplência */
    var printDefaultsReportPDF = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/printdefaultreport',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          var filename = 'relatorio_de_inadimplencia.pdf';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      });
      return deffered.promise;
    };



    var getMonthlyReceiveReportCSV = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/monthlyreceivereport?company=' + obj.company + '&startDate=' + obj.startDate + '&finalDate='
          + obj.finalDate + '&user_id=' + obj.user_id + '&connection=' + obj.connection,
        data: {variables: ''},
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          // linkElement.setAttribute('target', '_blank');
          var filename = name + '.csv';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      });
      return deffered.promise;

    };

    var getPersonPayeeByName = function (query) {
      return Restangular.one('person').one('getpersonpayee').get(query);
    };

    var printDefaultsPdf = function () {
    };

    return {
      getDataMonthlyFinancialReport: getDataMonthlyFinancialReport,
      getDefaultsReport: getDefaultsReport,
      getIncomeTaxReport: getIncomeTaxReport,
      printDefaultsReportPDF: printDefaultsReportPDF,
      getPersonPayeeByName: getPersonPayeeByName,
      printDefaultsPdf: printDefaultsPdf,
      getMonthlyReceiveReportCSV: getMonthlyReceiveReportCSV,
      getDesignedRealizedReport: getDesignedRealizedReport
    };
  }

  angular.module('app.finance.finance-reports')
    .service('FinanceReportsService', FinanceReportsService)
})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.finance-reports', {
        url: '/finance-reports',
        public: false,
        abstract: true,
        templateUrl: 'app/finance/reports/views/report-page.html'
      })
      .state('private.finance.finance-reports.list', {
        url: '/list',
        public: false,
        views: {
          'reports': {
            templateUrl: 'app/finance/reports/views/index.html',
            controller: 'FinanceReportsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.finance.finance-reports.monthly-financial', {
        url: '/monthly-financial/:school_period_id',
        public: false,
        params: {school_period_id: null},
        views: {
          'reports': {
            templateUrl: 'app/finance/reports/monthly-financial-report/views/index.html',
            controller: 'MonthlyFinancialReportController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.finance.finance-reports.income-tax', {
        url: '/income-tax/:school_period_id',
        public: false,
        params: {school_period_id: null},
        views: {
          'reports': {
            templateUrl: 'app/finance/reports/income-tax-report/views/index.html',
            controller: 'IncomeTaxReportController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.finance.finance-reports.defaults', {
        url: '/defaults/:school_period_id',
        public: false,
        params: {school_period_id: null},
        views: {
          'reports': {
            templateUrl: 'app/finance/reports/defaults-report/views/index.html',
            controller: 'DefaultsReportController',
            controllerAs: 'vm'
          }
        }
      }).state('private.finance.finance-reports.collaborators-protocol', {
      url: '/collaborators-protocol/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/collaborators-protocol/views/index.html',
          controller: 'CollaboratorsProtocolController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.cashier-session-resume', {
      url: '/cashier-session-resume/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/cashier-session-resume/views/index.html',
          controller: 'CashierSessionResumeController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.reverse-report', {
      url: '/reverse-report/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/reverse-report/views/index.html',
          controller: 'ReverseReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.differences-report', {
      url: '/differences-report/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/differences-report/views/index.html',
          controller: 'DifferencesReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.products-report', {
      url: '/products-report/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/products-report/views/index.html',
          controller: 'ProductsReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.monthly-receive-report', {
      url: '/monthly-receive/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/monthly-receive-report/views/index.html',
          controller: 'MonthlyReceiveReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.undo-movements-report', {
      url: '/undo-movements/',
      public: false,
      params: {},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/undo-movements-report/views/index.html',
          controller: 'UndoMovementsReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.bill-charge-report', {
      url: '/bill-charge/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/bill-charge-report/views/index.html',
          controller: 'BillChargeReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.finance-movement-report', {
      url: '/finance-movement/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/finance-movement-report/views/index.html',
          controller: 'FinanceMovementReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.undo-check-pad-report', {
      url: '/undo-check-pad/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/undo-check-pad-report/views/index.html',
          controller: 'UndoCheckPadReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.designed-realized-report', {
      url: '/designed-realized/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/designed-realized-report/views/index.html',
          controller: 'DesignedRealizedReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.payments-report', {
      url: '/payments/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/payments-report/views/index.html',
          controller: 'PaymentsReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.deleted-bills-report', {
      url: '/deleted-bills/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/deleted-bills-report/views/index.html',
          controller: 'DeletedBillsReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.negotiations-report', {
      url: '/negotiations-report/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/negotiations-report/views/index.html',
          controller: 'NegotiationsReportController',
          controllerAs: 'vm'
        }
      }
    }).state('private.finance.finance-reports.current-account-movements-report', {
      url: '/current-account-movements/:school_period_id',
      public: false,
      params: {school_period_id: null},
      views: {
        'reports': {
          templateUrl: 'app/finance/reports/current-account-movements/views/index.html',
          controller: 'CurrentAccountMovementsController',
          controllerAs: 'vm'
        }
      }
    })
  }

  angular
    .module('app.finance.finance-reports')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {

    var role = 'fin_reports';
    var path = 'finance.reports';

    msNavigationService.saveItem('finance.finance-reports', {
      title: 'Relatórios',
      icon: 'icon-chart-line',
      state: 'private.finance.finance-reports.list',
      weight: 998,
      auth: role,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.finance-reports')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function FinanceReportsController($rootScope, PoliciesService, $window, Session) {

    var vm = this;
    vm.windowHeight = $window.innerHeight - 64;
    vm.school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    if (angular.isUndefined(vm.school_period.id)){
      var school_period = angular.copy(vm.school_period);
      vm.school_period = {
        id: school_period
      }
    }
    $rootScope.show_loader = false;
    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };


    /**
     * Lista de recursos de configurações
     */
    vm.boardList = [
      {
        "name": "Fluxo Financeiro",
        "state": "private.finance.finance-reports.monthly-financial",
        "icon": 'icon-timetable',
        "description": "Relatório de fluxo financeiro",
        "policy": !vm.checkPolicies('monthly_financial')
      }, {
        "name": "Relatório de Imposto de Renda",
        "state": "private.finance.finance-reports.income-tax",
        "icon": 'icon-cash-multiple',
        "description": "Relatório de imposto de renda",
        "policy": !vm.checkPolicies('income_tax')
      },
      {
        "name": "Relatório de Inadimplência",
        "state": "private.finance.finance-reports.defaults",
        "icon": 'icon-book-multiple-variant',
        "description": "Relatório de Inadimplência",
        "policy": !vm.checkPolicies('defaults')
      }, {
        "name": "Protocolo para colaboradores",
        "state": "private.finance.finance-reports.collaborators-protocol",
        "icon": 'icon-clipboard-text',
        "description": "Protocolo para colaboradores",
        "policy": !vm.checkPolicies('collaborators_protocol')
      }, {
        "name": "Resumo das sessões de caixa",
        "state": "private.finance.finance-reports.cashier-session-resume",
        "icon": 'icon-cash-usd',
        "description": "Resumo das sessões de caixa",
        "policy": !vm.checkPolicies('cashier_session_resume')
      }, {
        "name": "Relatório de estornos",
        "state": "private.finance.finance-reports.reverse-report",
        "icon": 'icon-outbox',
        "description": "Relatório de estornos",
        "policy": !vm.checkPolicies('reverses_report')
      }, {
        "name": "Relatório de desfazimentos",
        "state": "private.finance.finance-reports.undo-check-pad-report",
        "icon": 'icon-rotate-left',
        "description": "Relatório de desfazimentos de comandas",
        "policy": !vm.checkPolicies('undo_check_pad_report')
      }, {
        "name": "Relatório de diferenças",
        "state": "private.finance.finance-reports.differences-report",
        "icon": 'icon-cash',
        "description": "Relatório de diferenças",
        "policy": !vm.checkPolicies('differences_report')
      }, {
        "name": "Relatório de produtos avulsos",
        "state": "private.finance.finance-reports.products-report",
        "icon": 'icon-apps',
        "description": "Relatório de produtos avulsos vendidos",
        "policy": !vm.checkPolicies('products_report')
      }, {
        "name": "Relatório de mensalidades",
        "state": "private.finance.finance-reports.monthly-receive-report",
        "icon": 'icon-debug-step-into',
        "description": "Relatório de mensalidades",
        "policy": !vm.checkPolicies('monthly_receive_report')
      }, {
        "name": "Relatório de status de cobranças",
        "state": "private.finance.finance-reports.bill-charge-report",
        "icon": 'icon-receipt',
        "description": "Relatório de status de cobranças",
        "policy": !vm.checkPolicies('bill_charge_report_fin')
      }, {
        "name": "Relatório de desfazimentos em conta corrente",
        "state": "private.finance.finance-reports.undo-movements-report",
        "icon": 'icon-rotate-left',
        "description": "Relatório de desfazimentos em conta corrente",
        "policy": !vm.checkPolicies('defaults')
      }, {
        "name": "Movimento financeiro",
        "state": "private.finance.finance-reports.finance-movement-report",
        "icon": 'icon-cash-100',
        "description": "Relatório dos movimentos financeiros",
        "policy": !vm.checkPolicies('finance_movement_report')
      }, {
        "name": "Projeção x Realizados",
        "state": "private.finance.finance-reports.designed-realized-report",
        "icon": 'icon-cash-100',
        "description": "Relatório de entradas projetadas x realizadas",
        "policy": !vm.checkPolicies('designed_realized_report')
      }, {
        "name": "Títulos por tipo de baixa",
        "state": "private.finance.finance-reports.payments-report",
        "icon": 'icon-arrow-down-bold-circle',
        "description": "Relatório de títulos por tipo de baixa",
        "policy": !vm.checkPolicies('payments_report')
      }, {
        "name": "Títulos excluídos",
        "state": "private.finance.finance-reports.deleted-bills-report",
        "icon": 'icon-close-circle-outline',
        "description": "Relatório de títulos excluídos",
        "policy": !vm.checkPolicies('deleted_bills_report')
      }, {
        "name": "Relatório de negociações",
        "state": "private.finance.finance-reports.negotiations-report",
        "icon": 'icon-briefcase',
        "description": "Relatório de títulos negociados",
        "policy": !vm.checkPolicies('negotiations_report')
      }, {
        "name": "Detalhamento de conta corrente",
        "state": "private.finance.finance-reports.current-account-movements-report",
        "icon": 'icon-elevation-rise',
        "description": "Detalhamento de movimentos de conta corrente",
        "policy": !vm.checkPolicies('current_account_movements')
      }
    ];
  }

  angular
    .module('app.finance.finance-reports')
    .controller('FinanceReportsController', FinanceReportsController)
})();

(function () {
  'use strict';
  angular.module('app.finance.finance-reports-generation', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function FinanceReportsService(Restangular, CONFIG, Common, $http) {
    var vm = this;

    vm.getDataMonthlyFinancialReport = function (obj) {
      return Restangular.one('reports').one('monthlyfinancialflow').get(obj);
    };

    vm.getDefaultsReport = function (obj) {
      return Restangular.one('reports').one('defaults').get(obj);
    };

    vm.getIncomeTaxReport = function (obj){
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/incometax',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
            var blob = new Blob([data], {type: contentType});
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            var filename = obj.name + '.pdf';
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": true
            });
            linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      });
      return deffered.promise;

    };

    vm.getPersonPayeeByName = function (query) {
      return Restangular.one('person').one('getpersonpayee').get(query);

    };

    return vm;
  }
  angular.module('app.finance.finance-reports-generation')
    .service('FinanceReportsService', FinanceReportsService)
})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.finance-reports-generation', {
        url: '/finance-reports-generation',
        public: false,
        abstract: true,
        templateUrl: 'app/finance/report-generation/index.html'
      })
      .state('private.finance.finance-reports-generation.all', {
        url: '/all',
        public: false,
        views: {
          'report-generation': {
            templateUrl: 'app/finance/report-generation/all.html',
            controller: 'FinanceReportsGenerationController',
            controllerAs: 'vm'
          }
        }
      })
  }

  angular
    .module('app.finance.finance-reports-generation')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {

    var role = 'fin_reports_generate';
    var path = 'finance.reports';

    msNavigationService.saveItem('finance.finance-reports-generation', {
      title: 'Gerador de Relatórios',
      icon: 'icon-chart-line',
      state: 'private.finance.finance-reports-generation.all',
      weight: 997,
      auth: role,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.finance-reports-generation')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function FinanceReportsController($rootScope, PoliciesService, $window) {

    var vm = this;
    vm.windowHeight = $window.innerHeight - 64;
    $rootScope.show_loader = false;
    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

  }

  angular
    .module('app.finance.finance-reports-generation')
    .controller('FinanceReportsGenerationController', FinanceReportsController)
})();

(function () {
    'use strict';
    angular.module('app.finance.product', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function VinculateServiceController($rootScope, $mdDialog, a4Moment, ProductService, ModalExtra) {
    var vm = this;
    vm.show_loading = false;
    vm.products = [];
    vm.item_id = ModalExtra.id;
    vm.item_name = ModalExtra.item_name;
    vm.option = ModalExtra.option;
    vm.selected_products = [];
    vm.original_products = [];
    vm.removed_products = [];

    vm.paginate = function (page, limit) {
      vm.show_loading = true;
      ProductService.getProductsPaymentPlansToAssociate({
        item_id: vm.item_id,
        option: vm.option,
        limit: limit,
        page: page
      }).then(function (response) {
        vm.show_loading = false;
        vm.products = response.plain();
        for (var i = vm.products.data.length; i--;) {
          if (vm.include_selected(vm.products.data[i].id) !== 'not_include') {
            vm.products.data[i].is_mandatory = vm.include_selected(vm.products.data[i].id);
          } else if (vm.products.data[i].is_mandatory !== null) {
            vm.selected_products.push(vm.products.data[i]);
            vm.original_products.push(angular.copy(vm.products.data[i]));
          } else {
            vm.products.data[i].is_mandatory = false;
          }
        }
      })
    };

    vm.include_selected = function (id) {
      for (var z = vm.selected_products.length; z--;) {
        if (vm.selected_products[z].id === id) {
          return vm.selected_products[z].is_mandatory;
        }
      }
      return 'not_include';
    };


    vm.addItem = function (item) {
      if (vm.include_selected(item.id) === 'not_include') {
        vm.selected_products.push(item);
      }
    };


    /**
     * Fecha modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.submit = function () {
      vm.show_loading = true;
      for (var i = vm.original_products.length; i--;) {
        if (vm.include_selected(vm.original_products[i].id) === 'not_include') {
          vm.removed_products.push(vm.original_products[i]);
        }
      }
      ProductService.saveProductPaymentPlansBound({
        new_associations: vm.selected_products,
        removed_associations: vm.removed_products,
        option: vm.option,
        item_id: vm.item_id
      }).then(function () {
        $mdDialog.hide(true);
      })
    };

    vm.init = function () {
      vm.paginate(1, 15);

    };

    vm.init();

  }

  angular.module('app.finance.product')
    .controller('VinculateServiceController', VinculateServiceController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ProductService(Restangular) {

    var getProductById = function (id) {
      return Restangular.one('product/getById', id).get();
    };

    var getById = function (id) {
      return Restangular.one('product', id).get();
    };

    var getAllProducts = function (obj) {
      return Restangular.one('product').one('getAll').get(obj);
    };

    var getProductsTree = function (obj) {
      return Restangular.one('product').one('gettree').get(obj);
    };

    var getAllPaymentPlans = function () {
      return Restangular.one('paymentplan').all('listall').getList();
    };

    var getAllCategories = function () {
      return Restangular.one('billcategory').customGET('listall', {debit_credit: 'C'});
    };

    var createProduct = function (obj) {
      return Restangular.one('product').customPOST(obj);
    };

    var updateProduct = function (obj) {
      return Restangular.one('product', obj.id).customPUT(obj);
    };

    var deleteProduct = function (id) {
      return Restangular.one('product', id).remove();
    };

    var getOnlyServices = function (obj) {
      return Restangular.one('product').one('getonlyservices').get(obj);
    };

    var getServicesWithDocumentAttached = function (obj) {
      return Restangular.one('product').one('getserviceswithdocumentattached').get(obj);
    };

    var getOnlyProducts = function (obj) {
      return Restangular.one('product').one('getOnlyProducts').get(obj);
    };

    var getServicesByQuery = function (obj) {
      return Restangular.one('product').one('getservicesbyquery').get(obj);
    };

    var getServiceGroups = function () {
      return Restangular.one('product').one('getgroupservices').get();
    };
    var newProductGroup = function (obj) {
      return Restangular.one('productgroup').one('new').all('group').post(obj);
    };

    var allProductGroups = function (obj) {
      return Restangular.one('productgroup').one('groups').get(obj);
    };

    var getProductGroupsUsedByPeriod = function (obj) {
      return Restangular.one('productgroup').one('usedgroups').get(obj);
    };

    var allValuableProducts = function () {
      return Restangular.one('product').one('getvaluableproducts').get();
    };

    var BlockOutOfStockSales = function () {
      return Restangular.one('product').one('getblockoutofstocksales').get();
    };

    var updateProductGroup = function (obj) {
      return Restangular.one('productgroup').all('groups').post(obj);
    };

    var saveProductPaymentPlansBound = function (obj) {
      return Restangular.one('product').all('saveproductpaymentplansbound').post(obj);
    };

    var deleteProductGroup = function (id) {
      return Restangular.one('productgroup').one('groups', id).remove();
    };

    var getProductsByGroup = function (obj) {
      return Restangular.one('product').one('getproductsbygroup').get(obj);
    };

    var getProductsPaymentPlansToAssociate = function (obj) {
      return Restangular.one('product').one('getproductspaymentplanstoassociate').get(obj);
    };


    return {
      getById: getById,
      deleteProduct: deleteProduct,
      updateProduct: updateProduct,
      createProduct: createProduct,
      getAllCategories: getAllCategories,
      getAllProducts: getAllProducts,
      getProductsTree: getProductsTree,
      getAllPaymentPlans: getAllPaymentPlans,
      getProductById: getProductById,
      getProductsPaymentPlansToAssociate: getProductsPaymentPlansToAssociate,
      getOnlyServices: getOnlyServices,
      getOnlyProducts: getOnlyProducts,
      getServicesByQuery: getServicesByQuery,
      getServiceGroups: getServiceGroups,
      newProductGroup: newProductGroup,
      updateProductGroup: updateProductGroup,
      allProductGroups: allProductGroups,
      saveProductPaymentPlansBound: saveProductPaymentPlansBound,
      deleteProductGroup: deleteProductGroup,
      allValuableProducts: allValuableProducts,
      getProductsByGroup: getProductsByGroup,
      getProductGroupsUsedByPeriod: getProductGroupsUsedByPeriod,
      BlockOutOfStockSales: BlockOutOfStockSales,
      getServicesWithDocumentAttached: getServicesWithDocumentAttached
    };
  }

  angular.module('app.finance.product')
    .factory('ProductService', ProductService);
})();

(function () {
  'use strict';

  /** @ngInject */
  function listener() {



  }

  angular.module('app.finance.product')
    .run(listener);

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.product', {
        url: '/product',
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/products/views/index.html',
            controller: 'ProductController',
            controllerAs: 'vm',
          },
          'grouped@private.finance.product': {
            controller: 'ProductGroupController',
            controllerAs: 'vm',
            templateUrl: 'app/finance/products/views/grouped.html'
          },
          'courses@private.finance.product': {
            controller: 'CourseProductController',
            controllerAs: 'vm',
            templateUrl: 'app/finance/products/views/course-product.html'
          }
        }
      });
  }

  angular
    .module('app.finance.person')
    .config(routerConfig);


})();



(function () {
  'use strict';

  angular
    .module('app', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'restangular',
      'ui.router',
      'ngMaterial',
      'toastr',
      'LocalStorageModule',
      'pascalprecht.translate',
      'uiCropper',
      'ngCpfCnpj',
      'ui.mask',
      'ngMask',
      'ui.utils.masks',
      'lfNgMdFileInput',
      'chart.js',
      'md.data.table',
      'angular.filter',
      'md-steppers',
      'ui.sortable',
      'ui.tree',
      'vAccordion',
      'ui.ace',
      'thatisuday.dropzone',
      'infinite-scroll',
      'naif.base64',
      'ngTreetable',
      'webcam',
      'btford.socket-io',
      'froala',
      'infinite-scroll',
      'dndLists',
      'rt.select2',
      'textAngular',
      'fixed.table.header',
      'ui.tinymce',
      'multi-select-tree',
      'xeditable',

      'angularMoment',

      'app.core',
      'app.constants',
      'app.components',
      'app.config',
      'app.policies',
      'app.finance',
      'app.educational',
      'app.evaluations',
      'app.controlpanel',
      'app.crm',
      'app.stock',
      'app.login',
      'app.lock',
      'app.roles',
      'app.log',
      'app.fmd',
      'app.process',
      'app.services',
      'app.decorators',
      'ui.calendar',
      'app.register',
      'app.external-reports-locked'
    ])
    .value('froalaConfig', {
      toolbarInline: false,
      placeholderText: 'Enter Text Here'
    });

})();

(function () {
  'use strict';

  /** @ngInject */
  function IndexTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      TITLE: 'Serviços',
      CATEGORY_NOT_FOUND: 'Nenhuma categoria encontrada.',
      CATEGORY_NOT_EXISTS: 'Por favor escolha uma categoria existente.',
      CATEGORY_IS_REQUIRED: 'Voce deve escolher uma categoria.',
      PRODUCT_GROUP_NOT_FOUND: "Nenhum agrupamento encontrado.",
      PRODUCT_GROUP_NOT_EXISTS: "Por favor escolha um agrupamento existente.",
      PRODUCT_GROUP_IS_REQUIRED: "Voce deve escolher um agrupamento."

    });

  }

  angular
    .module('app')
    .config(IndexTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run() {
  }

  angular
    .module('app.finance.product')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function Product(a4Moment, Common, ProductService, ModalFactory, $mdMenu, $filter, $log, $timeout, $scope, $q, $rootScope, $a4Sidenav, $a4FloatButton, $state) {

    var vm = this;
    vm.allProducts = [];
    vm.simulateQuery = false;
    vm.isDisabled = false;
    vm.grid = {
      rows: [],
      info: {}
    };
    vm.product = {id: null};
    vm.category = null;
    vm.allCategorys = [];
    vm.selectedPaymentPlans = [];
    vm.allPaymentPlans = [];
    vm.locked = false;
    vm.search = null;
    vm.show_inactive_products = false;

    vm.selected = 0;

    /**
     * Ouvinte para o caso do usuário invalidar o formulario,
     * selecionando dois planos de pagamento iguais
     */
    var listener2 = $rootScope.$on('Product.isValid', function (event, result) {
      if (result !== null) {
        vm.locked = !result;
        vm.include.locked = !result;
      }
    });

    var listener3 = $rootScope.$on("PRODUCT_CONTROLLER.update", function () {
      vm.getAllProducts();
    });

    vm.init = function () {
      vm.repos = vm.loadAll();
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.openSide(null)', label: 'Criar novo serviço', theme: 'finance'
      });
      vm.getAllProducts('', false, true);
      vm.getCategories();
      vm.getAllPaymentPlans();
      vm.getProductGroups();
      vm.include = {};
      vm.include.simulateQuery = vm.simulateQuery;
      vm.include.isDisabled = vm.isDisabled;
      vm.include.querySearch = vm.querySearch;
      vm.include.selectedItemChange = vm.selectedItemChange;
      vm.include.searchTextChange = vm.searchTextChange;
      vm.include.templateSrc = 'app/finance/products/views/form.html';
      vm.include.controller = 'ProductCreateEditController';
      vm.include.controllerAs = 'vm';
      vm.include.itemName = 'product';

    };


    /**
     * Retorna todos os produtos
     */
    vm.getAllProducts = function (query) {
      $rootScope.show_loader = true;
      vm.allProducts = [];
      ProductService.getProductsTree({
        query: angular.isDefined(query) ? query : null,
        only_services: true,
        show_inactive_products: vm.show_inactive_products,
        onlyWithExternalId: vm.selected !== 0,
        withoutExternalId: vm.selected === 0
      })
        .then(function (response) {
          vm.allProducts = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro o executar essa ação.');
          $rootScope.show_loader = false;
        });
    };

    vm.col_defs_services = [
     {
        field: "product_group_id",
        displayName: "Botão",
        headTemplate: "<div style='text-align: right'>Ações</div>",
        cellTemplateScope: {
          openMenu: function ($mdMenu, item) {
            vm.openMenu($mdMenu);
          },
          editProduct: function (item) {
            vm.openSide(item);
          },
          vinculateService: function (item, option) {
            vm.vinculateService(item, option);
          },

        },
        cellTemplate: "<div style='text-align: right;'><md-menu><md-button class='md-icon-button' " +
          "ng-click='cellTemplateScope.openMenu($mdMenu, row.branch)' ng-src='{{row.branch}}'>" +
          "<md-icon md-menu-origin md-font-icon='icon-dots-vertical' ng-if='row.level !== 3'></md-icon></md-button>" +
          "<md-menu-content width='4'>" +
          "<md-menu-item ng-if='row.level == 1'>" +
          "<md-button ng-click='cellTemplateScope.editProduct(row.branch)' ng-src='{{row.branch}}'><md-icon>create</md-icon>Editar</md-button>" +
          "</md-menu-item>" +
          "<md-menu-item ng-if='row.level == 2'>" +
          "<md-button ng-click='cellTemplateScope.vinculateService(row.branch, 1)' ng-src='{{row.branch}}'>" +
          "<md-icon md-font-icon='icon-arrow-up-bold-circle'></md-icon>Vincular a turmas</md-button>" +
          "</md-menu-item>" +
          "</md-menu-content></md-menu></div>"
      }
    ];
    vm.col_defs_groups = [
      {
        field: "product_group_id",
        displayName: "Botão",
        headTemplate: "<div style='text-align: right'>Ações</div>",
        cellTemplateScope: {
          openMenu: function ($mdMenu, item) {
            vm.openMenu($mdMenu);
          },
          editProduct: function (item) {
            vm.openSide(item);
          },
          vinculateService: function (item, option) {
            vm.vinculateService(item, option);
          },

        },
        cellTemplate: "<div style='text-align: right'><md-menu><md-button class='md-icon-button' " +
          "ng-click='cellTemplateScope.openMenu($mdMenu, row.branch)' ng-src='{{row.branch}}'>" +
          "<md-icon md-menu-origin md-font-icon='icon-dots-vertical' ng-if='row.level !== 4 && row.level !== 1'></md-icon></md-button>" +
          "<md-menu-content width='4'>" +
          "<md-menu-item ng-if='row.level == 2'>" +
          "<md-button ng-click='cellTemplateScope.editProduct(row.branch)' ng-src='{{row.branch}}'><md-icon>create</md-icon>Editar</md-button>" +
          "</md-menu-item>" +
          "<md-menu-item ng-if='row.level == 3'>" +
          "<md-button ng-click='cellTemplateScope.vinculateService(row.branch, 2)' ng-src='{{row.branch}}'>" +
          "<md-icon md-font-icon='icon-arrow-down-bold-circle'></md-icon>Vincular serviço</md-button>" +
          "</md-menu-item>" +
          "</md-menu-content></md-menu></div>"
      }

    ];

    vm.expanding_property = {
      field: "name_show",
      displayName: "Nome",
      cellTemplate: "<span>{{row.branch[expandingProperty.field]}}</span>"
    };

    vm.openSide = function (item) {
      $a4Sidenav().open(
        'app/finance/products/views/form.html',
        'ProductCreateEditController',
        'vm', {item: item === null ? null : item}
      );
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    vm.vinculateService = function (item, option) {
      if (vm.selected !== 0 || option === 1) {
        ModalFactory.customClean('app/finance/products/views/vinculate-service-modal.html', 'VinculateServiceController', 'vm',
          false, {id: item.id, option: option, item_name: item.product_name}, null).then(function (response) {
          if (response === true) {
            Common.Toast.success('Vínculos criados com sucesso!');
            vm.getAllProducts();
          }
        })
      } else if (option !== 1) {
        ModalFactory.alert(
          "Vinculação de serviços não permitida",
          "Apenas é permitida a vinculação aos serviços correspondentes às turmas do sistema pedagógico.",
          "modal", "Ok", "false", "finance"
        );
      }

    };
    /**
     * Retorna as categorias
     */
    vm.getCategories = function () {
      ProductService.getAllCategories()
        .then(function (response) {
          vm.allCategories = vm.parseCategoryList(response.nodes);
          vm.include.allCategories = vm.allCategories;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
        });
    };

    vm.getProductGroups = function () {
      ProductService.allProductGroups({withoutExternalId: true})
        .then(function (response) {
          vm.allProductGroups = response.data;
          vm.include.allProductGroups = vm.allProductGroups;
        })
    };

    vm.parseCategoryList = function (list) {
      var result = [];
      if (list !== null && list.length > 0) {
        angular.forEach(list, function (item) {
          if (item.nodes.length > 0) {
            angular.forEach(item.nodes, function (cat) {
              result.push(cat);
            });
          }
        });
      } else {
        result = list;
      }
      return result;
    };

    /**
     * Retorna todos os planos de pagamento
     */
    vm.getAllPaymentPlans = function () {
      ProductService.getAllPaymentPlans()
        .then(function (response) {
          vm.allPaymentPlans = response;
          vm.include.allPaymentPlans = vm.allPaymentPlans;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
        });
    };


    /**
     * Remove produto
     * @param id
     */
    vm.delete = function (id) {
      ProductService.deleteProduct(id)
        .then(function () {
          Common.Toast.success('Produto removido com sucesso.');
          vm.getAllProducts();
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          switch (response.data) {
            case 'PRODUCT_ASSOCIATED_TO_GROUP':
              Common.Toast.error('Este produto está vinculado a uma turma do sistema pedagógico');
              break;
            default:
              Common.Toast.error('Esse produto não pode ser deletado, pois já esta vinculado a um título.');
              break;
          }
          $rootScope.show_loader = false;

        });
    };

    /**
     * Submit para o formulário
     * @param form
     * @param product
     */
    vm.submit = function (form, product) {
      if (!vm.locked && form.$valid) {

        var product_copy = angular.copy(product);

        product_copy.selectedPaymentPlans = vm.include.selectedPaymentPlans;

        if (product.id === undefined || product.id === null) {

          ProductService.createProduct(product_copy)
            .then(function () {
              Common.Toast.success("Serviço adicionado com sucesso");
              $rootScope.$broadcast('a4.table.close.sidenav');
              vm.include.selectedPaymentPlans = [];
              vm.getAllProducts();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });

        } else {

          angular.forEach(product_copy.selectedPaymentPlans, function (value, key) {
            if (value.id == null && angular.isDefined(value.id)) {
              value.id = (-key);
            }
          });

          ProductService.updateProduct(product_copy)
            .then(function () {
              Common.Toast.success("Serviço atualizado com sucesso");
              $rootScope.$broadcast('a4.table.close.sidenav');
              vm.include.selectedPaymentPlans = [];
              vm.getAllProducts();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });

        }

      }
    };

    vm.applyMask = function (value) {
      var currency = 0;
      if (value == 0 || value == null) {
        currency = $filter('currency')(0, 'R$ ', 2);
        return currency;
      } else if (value > 0) {
        currency = $filter('currency')(value, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      }
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearch = function (query) {
      var results = query ? vm.include.allCategories.filter(vm.createFilterFor(query)) : vm.include.allCategories,
        deferred;
      if (vm.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () {
          deferred.resolve(results);
        }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    };


    vm.selectedItemChange = function (text) {
      $log.info('Text changed to ' + text);
    };

    vm.searchTextChange = function (item) {
      $log.info('Item changed to ' + angular.toJson(item));
    };


    /**
     * Create filter function for a query string
     */
    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    /**
     * Build `components` list of key/value pairs
     */
    vm.loadAll = function () {
      var repos = [];
      return repos.map(function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    };





    $scope.$on('$destroy', function () {
      [listener2, listener3].forEach(function (fn) {
        fn();
      });
      if (angular.isDefined(vm.floatButton)) {
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
    });


    vm.init();

  }

  angular.module('app.finance.product')
    .controller('ProductController', Product);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ProductGroupController($rootScope, $scope, $mdDialog, $a4FloatButton, Common, ProductService) {

    var vm = this;

    vm.init = function () {
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.createNewProductGroup()', label: 'Criar novo agrupamento', theme: 'finance'
      });
      vm.all();
    };


    /**
     * Retorna todos agrupamentos
     */
    vm.all = function (page, qtd) {
      $rootScope.show_loader = true;
      page = angular.isUndefined(page) ? 1 : page;
      qtd = angular.isUndefined(qtd) ? 15 : qtd;
      ProductService.allProductGroups({qtd: qtd, page: page, withoutExternalId: true})
        .then(function (response) {

          /** Verifica os grupos de serviço associados ao sistema pedagógico */
          var $groupProductsNow = response.plain();
           for (var i=0; i < $groupProductsNow.data.length; i++){
               if ($groupProductsNow.data[i].external_id != null){
                 $groupProductsNow.data[i].disabled = true;
                 $groupProductsNow.data[i].messageRemove = "Este agrupamento está vinculado a um curso do sistema pedagógico"
                 $groupProductsNow.data[i].messageEdit = "Este agrupamento está vinculado a um curso do sistema pedagógico"

               } else {
                 $groupProductsNow.data[i].messageRemove = "Remover";
                 $groupProductsNow.data[i].messageEdit = "Editar";
               }

           }
          vm.product_group = $groupProductsNow;
          $rootScope.show_loader = false;
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error)
        })
    };

    vm.removeButton = "Remover";
      /**
     * Criação de novo agrupamento
     */
    vm.createNewProductGroup = function () {
      var confirm = $mdDialog.prompt()
        .title('Criar novo agrupamento')
        .textContent('Por favor, digite o nome do agrupamento')
        .ariaLabel('Nome do agrupamento')
        .theme('finance')
        .required(true)
        .ok('Criar')
        .cancel('Agora não!');

      $mdDialog.show(confirm)
        .then(function (name) {
          vm.newProductGroup(name);
        });
    };


    /**
     * Chama requisição para novo agrupamento
     */
    vm.newProductGroup = function (name) {
      ProductService.newProductGroup({name: name})
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success("Agrupamento criado com sucesso!")
          vm.all();
        })
        .catch(function () {
          Common.Toast.error(error);
          $rootScope.show_loader = false;
        })
    };

    /**
     * Chama requisição para edição agrupamento
     */
    vm.update = function (item) {
      ProductService.updateProductGroup(item)
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success("Agrupamento atualizado com sucesso!");
          vm.all();
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data)
        })
    };

    /**
     * Chama a remoção de um agrupamento
     */
    vm.removeGroup = function (item) {

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm()
        .title('Remoção de agrupamento')
        .textContent('Deseja realmente remover agrupamento?')
        .ariaLabel('remover agrupamento')
        .ok('Porfavor sim!')
        .cancel('Ainda não!');

      $mdDialog.show(confirm).then(function () {

        ProductService.deleteProductGroup(item.id)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success("Agrupamento removido com sucesso!");
            vm.all();
          })
          .catch(function (error) {
            $rootScope.show_loader = false;
            Common.Toast.error(error.data)
          })

      });


    };

    /**
     * Edita agrupamento
     * @param item
     */
    vm.editProductGroup = function (item) {
      var copy = angular.copy(item);
      var confirm = $mdDialog.prompt()
        .title('Editar agrupamento')
        .textContent('Por favor, digite o nome do agrupamento')
        .ariaLabel('Nome do agrupamento')
        .theme('finance')
        .initialValue(copy.name)
        .required(true)
        .ok('Atualizar')
        .cancel('Agora não!');

      $mdDialog.show(confirm).then(function (name) {
        copy.name = name;
        vm.update(copy);
      });
    };



    $scope.$on('$destroy', function () {
      if (angular.isDefined(vm.floatButton)) {
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
    });

    vm.init();
  }

  angular
    .module('app.finance.product')
    .controller('ProductGroupController', ProductGroupController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ProductCreateEditController(Common, ProductService, ModalFactory, $filter, $a4Sidenav, $scope, $rootScope,
                                       SideExtra, DocumentsService) {

    var vm = this;
    vm.allProducts = [];
    vm.simulateQuery = false;
    vm.isDisabled = false;

    vm.product = {id: null};
    vm.category = null;
    vm.allCategorys = [];
    vm.selectedPaymentPlans = [];
    vm.allPaymentPlans = [];
    vm.documents = [];
    vm.locked = false;

    vm.searchText = '';
    vm.searchProductGroup = '';
    /**
     * Tipos de produtos
     * @type {*[]}
     */
    vm.product_types = [
      {
        id: 1,
        name: "Principal"
      },
      {
        id: 11,
        name: "Extra"
      }
    ];

    // var listener1 = $rootScope.$on('a4-table.toggled', function (ev, item) {
    //   if (item.id != undefined) {
    //     vm.getById(item.id);
    //   }
    // });

    /**
     * Ouvinte para o caso do usuário invalidar o formulario,
     * selecionando dois planos de pagamento iguais
     */
    var listener2 = $rootScope.$on('Product.isValid', function (event, result) {
      if (result != null) {
        vm.locked = !result;
        //vm.include.locked = !result;
      }
    });

    /**
     * init
     */
    vm.init = function () {
      vm.repos = vm.loadAll();
      vm.currentItem = angular.copy(SideExtra.item);
      if (vm.currentItem !== null) {
        vm.currentItem.withoutCompany = !(angular.isDefined(vm.currentItem.company_id) && vm.currentItem.company_id !== null);
      }
      vm.getAllProducts();
      vm.getCategories();
      vm.getAllPaymentPlans();
      vm.getAllDocuments();
      vm.getProductGroups();
      if (vm.currentItem != null) {
        vm.getById(vm.currentItem.id);
      }
    };

    /**
     * Retorna todos os produtos
     */
    vm.getAllProducts = function () {
      vm.allProducts = [];
      ProductService.getAllProducts()
        .then(function (response) {
          vm.allProducts = response;
        })
        .catch(function () {
          Common.Toast.error('Erro o executar essa ação.');
        });
    };

    /**
     * Retorna as categorias
     */
    vm.getCategories = function () {
      ProductService.getAllCategories()
        .then(function (response) {
          vm.allCategories = vm.parseCategoryList(response.nodes);
          if (vm.currentItem != null) {
            angular.forEach(vm.allCategories, function (item) {
              if (angular.isDefined(vm.currentItem) && item.id === vm.currentItem.bill_category_id) {
                vm.selectedCategory = item;
              }
            });
          }
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
        });
    };

    vm.getProductGroups = function () {
      ProductService.allProductGroups({withoutExternalId: true})
        .then(function (response) {
          vm.allProductGroups = response.data;
          if (vm.currentItem !== null) {
            angular.forEach(vm.allProductGroups, function (item) {
              if (angular.isDefined(vm.currentItem) && item.id === vm.currentItem.product_group_id) {
                vm.selectedGroup = item;
              }
            });
          }
        })
    };

    vm.parseCategoryList = function (list) {
      var result = [];
      if (list !== null && list.length > 0) {
        angular.forEach(list, function (item) {
          if (item.nodes.length > 0) {
            angular.forEach(item.nodes, function (cat) {
              if (cat.nodes.length > 0) {
                angular.forEach(cat.nodes, function (cat2) {
                  result.push(cat2);
                })
              } else {
                result.push(cat);
              }
            });
          }
        });
      } else {
        result = list;
      }
      return result;
    };

    /**
     * Retorna todos os planos de pagamento
     */
    vm.getAllPaymentPlans = function () {
      ProductService.getAllPaymentPlans()
        .then(function (response) {
          vm.allPaymentPlans = response.plain();
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
        });
    };


    vm.getAllDocuments = function () {
      DocumentsService.getAll({ type: 2 })
        .then(function (response) {
          vm.documents = response.plain().data;
        })
    };

    /**
     * Fecha sidenav
     */
    vm.close = function () {
      $a4Sidenav().close()
    };

    /**
     * Retorna o produto pelo ID
     * @param id
     */
    vm.getById = function (id) {
      var $currentProduct;
      if (angular.isDefined(id)) {
        ProductService.getById(id)
          .then(function (response) {
            if (response !== null) {
              $currentProduct = response.plain();

              /** Se o agrupamento possuir external_id, significa que é um serviço ligado à uma turma do pedagógico.
               * Logo, os campos nome e agrupamento devem ser bloqueados. */
              $currentProduct.disabled = $currentProduct.grouping != null && $currentProduct.grouping.external_app != null;

              vm.product = $currentProduct;
              vm.selectedCategory = vm.product.bill_category;
              vm.selectedPaymentPlans = vm.product.selectedPaymentPlans;
              vm.selectedGroup = vm.product.grouping;
              $rootScope.show_loader = false;
            }
          })
          .catch(function () {
            Common.Toast.error('Não foi possivel resgatar este item.');
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Submit para o formulário
     * @param form
     * @param product
     */
    vm.submit = function (form, product) {
      var hasPaymentPlanWithoutPriceOrDateFirst = false;
      if (!vm.locked && form.$valid) {
        /** Cria cópia do produto */
        var product_copy = angular.copy(product);
        product_copy.selectedPaymentPlans = vm.selectedPaymentPlans;

        /**
         * Verifica se algum dos planos selecionados está sem a data ou o preço preenchido
         */
        for (var i = 0; i < product_copy.selectedPaymentPlans.length; i++) {
          if (product_copy.selectedPaymentPlans[i].date_first === null || product_copy.selectedPaymentPlans[i].price === null) {
            hasPaymentPlanWithoutPriceOrDateFirst = true;
          }
        }

        /**
         * Caso tenham planos sem preço ou data inicial, exibe um modal
         * com aviso para confirmação da operação. Se não, continua normalmente.
         */
        if (hasPaymentPlanWithoutPriceOrDateFirst) {
          ModalFactory.confirm(
            null,
            'Confirmação',
            'Deixando o valor ou a data inicial de um plano de pagamento em branco, ' +
            'você deverá preencher esta informação no contrato associado a esse serviço. Deseja continuar?',
            'Confirmar',
            'Cancelar',
            'finance'
          ).then(function (response) {
            if (response) {
              vm.save(form, product, product_copy);
            } else {
              Common.Toast.warning('Ação cancelada.');
              vm.close();
            }
          }).catch(function () {
          });
        } else {
          vm.save(form, product, product_copy);
        }
      }

    };

    vm.save = function (form, product, product_copy) {
      if (angular.isUndefined(product.id) || product.id === null) {
        ProductService.createProduct(product_copy)
          .then(function () {
            Common.Toast.success("Serviço adicionado com sucesso");
            vm.selectedPaymentPlans = [];
            vm.close();
          })
          .catch(function () {
            Common.Toast.error('Erro o executar essa ação.');
          });
      } else {
        angular.forEach(product_copy.selectedPaymentPlans, function (value, key) {
          if (value.id == null && angular.isDefined(value.id)) {
            value.id = (-key);
          }
        });

        ProductService.updateProduct(product_copy)
          .then(function () {
            Common.Toast.success("Serviço atualizado com sucesso");
            vm.selectedPaymentPlans = [];
            vm.close();
          })
          .catch(function () {
            Common.Toast.error('Erro o executar essa ação.');
          });
      }
    };

    vm.applyMask = function (value) {
      var currency = 0;
      if (value === 0 || value === null) {
        currency = $filter('currency')(0, 'R$ ', 2);
        return currency;
      } else if (value > 0) {
        currency = $filter('currency')(value, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      }
    };


    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearchCategory = function (query) {
      return query !== '' ? vm.allCategories.filter(vm.createFilterFor(query)) : vm.allCategories;
    };
    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };


    vm.querySearchProductGroups = function (query) {
      return query !== '' ? vm.allProductGroups.filter(vm.createFilterForProductGroups(query)) : vm.allProductGroups;
    };
    vm.createFilterForProductGroups = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    /**
     * Build `components` list of key/value pairs
     */
    vm.loadAll = function () {
      var repos = [];
      return repos.map(function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    };


    $scope.$on('$destroy', function () {
      [listener2].forEach(function (fn) {
        fn();
      });
    });

    vm.close = function () {
      $a4Sidenav().close()
        .then(function () {
          $rootScope.$broadcast("PRODUCT_CONTROLLER.update");
        })
    };

    vm.init();
  }

  angular.module('app.finance.product')
    .controller('ProductCreateEditController', ProductCreateEditController);
})();
(function () {
  /** @ngInject */
  function GroupProductController(Common, ProductService, $filter, $log, $timeout, $scope, $q, $rootScope, $a4Sidenav, $a4FloatButton) {
    var vm = this;
    vm.allProducts = [];
    vm.simulateQuery = false;
    vm.isDisabled = false;
    vm.grid = {
      rows: [],
      info: {}
    };
    vm.product = {id: null};
    vm.category = null;
    vm.allCategorys = [];
    vm.selectedPaymentPlans = [];
    vm.allPaymentPlans = [];
    vm.locked = false;
    vm.search = null;
    vm.show_inactive_products = false;

    vm.selected = 0;

    /**
     * Ouvinte para o caso do usuário invalidar o formulario,
     * selecionando dois planos de pagamento iguais
     */
    var listener2 = $rootScope.$on('Product.isValid', function (event, result) {
      if (result !== null) {
        vm.locked = !result;
        vm.include.locked = !result;
      }
    });

    var listener3 = $rootScope.$on("PRODUCT_CONTROLLER.update", function () {
      vm.getAllProducts();
    });

    vm.init = function () {
      vm.repos = vm.loadAll();
      // vm.floatButton = $a4FloatButton({
      //   scope: $scope, onClick: 'vm.openSide(null)', label: 'Criar novo serviço', theme: 'finance'
      // });
      vm.getAllProducts();
      vm.getCategories();
      vm.getAllPaymentPlans();
      vm.getProductGroups();
      vm.include = {};
      vm.include.simulateQuery = vm.simulateQuery;
      vm.include.isDisabled = vm.isDisabled;
      vm.include.querySearch = vm.querySearch;
      vm.include.selectedItemChange = vm.selectedItemChange;
      vm.include.searchTextChange = vm.searchTextChange;
      vm.include.templateSrc = 'app/finance/products/views/form.html';
      vm.include.controller = 'ProductCreateEditController';
      vm.include.controllerAs = 'vm';
      vm.include.itemName = 'product';

    };


    /**
     * Retorna todos os produtos
     */
    vm.getAllProducts = function (page, limit, query) {
      $rootScope.show_loader = true;
      page = angular.isDefined(page) ? page : 1;
      limit = angular.isDefined(limit) ? limit : 30;
      vm.allProducts = [];
      ProductService.getAllProducts({
        page: page, limit: limit,
        query: angular.isDefined(query) ? query : null,
        only_services: true,
        show_inactive_products: vm.show_inactive_products,
        onlyWithExternalId: true
      })
        .then(function (response) {
          vm.allProducts = response.data;
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [30, 60, 120, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          for (var i = 0; i < vm.grid.rows.length; i++) {
            if (vm.grid.rows[i].payment_plan_id === null) {
              vm.grid.rows[i].payment_plan_id = true;
            } else {
              vm.grid.rows[i].payment_plan_id = false;
            }
            if (vm.grid.rows[i].inactive === false) {
              vm.grid.rows[i].inactive = 'Ativo';
            } else {
              vm.grid.rows[i].inactive = 'Inativo';
            }

          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro o executar essa ação.');
        });
    };

    vm.openSide = function (item) {
      $a4Sidenav().open(
        'app/finance/products/views/form.html',
        'ProductCreateEditController',
        'vm', {item: item === null ? null : item}
      );
    };

    /**
     * Retorna as categorias
     */
    vm.getCategories = function () {
      ProductService.getAllCategories()
        .then(function (response) {
          vm.allCategories = vm.parseCategoryList(response.nodes);
          vm.include.allCategories = vm.allCategories;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
        });
    };

    vm.getProductGroups = function () {
      ProductService.allProductGroups()
        .then(function (response) {
          vm.allProductGroups = response.data;
          vm.include.allProductGroups = vm.allProductGroups;
        })
    };

    vm.parseCategoryList = function (list) {
      var result = [];
      if (list !== null && list.length > 0) {
        angular.forEach(list, function (item) {
          if (item.nodes.length > 0) {
            angular.forEach(item.nodes, function (cat) {
              result.push(cat);
            });
          }
        });
      } else {
        result = list;
      }
      return result;
    };

    /**
     * Retorna todos os planos de pagamento
     */
    vm.getAllPaymentPlans = function () {
      ProductService.getAllPaymentPlans()
        .then(function (response) {
          vm.allPaymentPlans = response;
          vm.include.allPaymentPlans = vm.allPaymentPlans;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
        });
    };


    /**
     * Remove produto
     * @param id
     */
    vm.delete = function (id) {
      ProductService.deleteProduct(id)
        .then(function () {
          Common.Toast.success('Produto removido com sucesso.');
          vm.getAllProducts();
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          switch (response.data) {
            case 'PRODUCT_ASSOCIATED_TO_GROUP':
              Common.Toast.error('Este produto está vinculado a uma turma do sistema pedagógico');
              break;
            default:
              Common.Toast.error('Esse produto não pode ser deletado, pois já esta vinculado a um título.');
              break;
          }
          $rootScope.show_loader = false;

        });
    };

    /**
     * Submit para o formulário
     * @param form
     * @param product
     */
    vm.submit = function (form, product) {
      if (!vm.locked && form.$valid) {

        var product_copy = angular.copy(product);

        product_copy.selectedPaymentPlans = vm.include.selectedPaymentPlans;

        if (product.id === undefined || product.id === null) {

          ProductService.createProduct(product_copy)
            .then(function () {
              Common.Toast.success("Serviço adicionado com sucesso");
              $rootScope.$broadcast('a4.table.close.sidenav');
              vm.include.selectedPaymentPlans = [];
              vm.getAllProducts();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });

        } else {

          angular.forEach(product_copy.selectedPaymentPlans, function (value, key) {
            if (value.id == null && angular.isDefined(value.id)) {
              value.id = (-key);
            }
          });

          ProductService.updateProduct(product_copy)
            .then(function () {
              Common.Toast.success("Serviço atualizado com sucesso");
              $rootScope.$broadcast('a4.table.close.sidenav');
              vm.include.selectedPaymentPlans = [];
              vm.getAllProducts();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro o executar essa ação.');
              $rootScope.show_loader = false;
            });

        }

      }
    };

    vm.applyMask = function (value) {
      var currency = 0;
      if (value == 0 || value == null) {
        currency = $filter('currency')(0, 'R$ ', 2);
        return currency;
      } else if (value > 0) {
        currency = $filter('currency')(value, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      }
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearch = function (query) {
      var results = query ? vm.include.allCategories.filter(vm.createFilterFor(query)) : vm.include.allCategories,
        deferred;
      if (vm.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () {
          deferred.resolve(results);
        }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    };


    vm.selectedItemChange = function (text) {
      $log.info('Text changed to ' + text);
    };

    vm.searchTextChange = function (item) {
      $log.info('Item changed to ' + angular.toJson(item));
    };


    /**
     * Create filter function for a query string
     */
    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    /**
     * Build `components` list of key/value pairs
     */
    vm.loadAll = function () {
      var repos = [];
      return repos.map(function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    };


    $scope.$on('$destroy', function () {
      [listener2, listener3].forEach(function (fn) {
        fn();
      });
      if (angular.isDefined(vm.floatButton)) {
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
    });


    vm.init();
  }

  angular.module('app.finance.product')
    .controller('GroupProductController', GroupProductController);

})();
(function () {
  /** @ngInject */
  function CourseProductController(ProductService, Common, $rootScope) {

    var vm = this;

    vm.all = function (page, qtd) {
      $rootScope.show_loader = true;
      page = angular.isUndefined(page) ? 1 : page;
      qtd = angular.isUndefined(qtd) ? 15 : qtd;
      ProductService.allProductGroups({qtd: qtd, page: page, onlyWithExternalId: true})
        .then(function (response) {
          /** Verifica os grupos de serviço associados ao sistema pedagógico */
          var $groupProductsNow = response.plain();
          for (var i = 0; i < $groupProductsNow.data.length; i++) {
            if ($groupProductsNow.data[i].external_id != null) {
              $groupProductsNow.data[i].disabled = true;
              $groupProductsNow.data[i].messageRemove = "Este agrupamento está vinculado a um curso do sistema pedagógico"
              $groupProductsNow.data[i].messageEdit = "Este agrupamento está vinculado a um curso do sistema pedagógico"

            } else {
              $groupProductsNow.data[i].messageRemove = "Remover";
              $groupProductsNow.data[i].messageEdit = "Editar";
            }

          }
          vm.product_group = $groupProductsNow;
          $rootScope.show_loader = false;
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error)
        })
    };

    vm.init = function () {
      vm.all();
    };

    vm.init();

  }

  angular.module('app.finance.product')
    .controller('CourseProductController', CourseProductController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function PersonService(Restangular) {

    var getAllPersons = function (obj) {
      return Restangular.one('person').get(obj);
    };

    var getPersonWithFilter = function (obj) {
      return Restangular.one('person').one('getpersonwithfilter').get(obj);
    };

    var getStatesAndCities = function (obj) {
      return Restangular.one('person').one('getstatesandcities').get(obj);
    };

    var getPossibleMatrixCompany = function (obj) {
      return Restangular.one('person').one('getpossiblematrixcompanies').get(obj);
    };

    var removeChildCompany = function (child_id) {
      return Restangular.one('person').one('removechildcompany', child_id)
        .remove();
    };

    var getById = function (id, obj) {
      return Restangular.one('person', id).get(obj);
    };

    var deletePerson = function (id) {
      return Restangular.one('person', id).remove();
    };

    var searchPerson = function (obj) {
      return Restangular.one('person').one('search').get(obj);
    };

    var getCnpjCaptcha = function (cnpj) {
      return Restangular.one('service').one('getCnpjCaptcha').get({cnpj: cnpj});
    };

    var postCnpjInfo = function (cnpj, captcha, cnpjParams) {
      return Restangular.one('service').all('postCnpjInfo').customPOST({
        'cnpj': cnpj,
        'captcha': captcha,
        'cookie': cnpjParams.cookie
      });
    };

    var createPerson = function (obj) {
      return Restangular.one('person').customPOST(obj);
    };

    var verifyEmailError = function (obj) {
      return Restangular.one('person').one('verifyemailerror').get(obj);
    };

    var saveResponsibleEmail = function (obj) {
      return Restangular.one('person').one('saveResponsibleEmail').get(obj);
    }

    var updatePerson = function (obj) {
      return Restangular.one('person', obj.id).customPUT(obj);
    };

    var getAddressByCep = function (cep) {
      return Restangular.one('service').one('getAddressByCep', cep).get();
    };

    var getBillsFromPerson = function (obj) {
      return Restangular.one('person').one('getbillsperson').get(obj);
    };

    var getChecksFromPerson = function (obj) {
      return Restangular.one('person').one('getchecksperson').get(obj);
    };

    var getProfile = function (id) {
      return Restangular.one('person').one('profile', id).get();
    };

    var getCities = function (UF) {
      return Restangular.one('person').one('getallcities', UF).get();
    };

    var listAll = function (obj) {
      return Restangular.one('person').one('listall').get(obj);
    };

    var getPendenciesMessage = function (id) {
      return Restangular.one('person').one('pendencies', id).get();
    };

    var setCollaborator = function (obj) {
      return Restangular.one('person').all('setcollaborator').post(obj);
    };

    var verifyCollaborator = function (obj) {
      return Restangular.one('person').one('verifycollaborator').get(obj);
    };

    var getPlaceOfBirth = function (obj) {
      return Restangular.one('person').one('getplaceofbirth').get(obj);
    };

    var verifyCPF = function (obj) {
      return Restangular.one('person').one('verifycpf').get(obj);
    };

    var preEnrolmentVerifyCPF = function (obj) {
      return Restangular.one('person').one('preenrolmentverifycpf').get(obj)
    }

    var verifyEmail = function (obj) {
      return Restangular.one('person').one('verifyemail').get(obj);
    };

    var getTeachers = function (obj) {
      return Restangular.one('person').one('getteachers').get(obj);
    };

    var getStatesByQuery = function (obj) {
      return Restangular.one('person').one('getstatesbyquery').get(obj);
    };

    var getCitiesByQuery = function (obj) {
      return Restangular.one('person').one('getcitiesbyquery').get(obj);
    };

    var getExternalFinancialStatementLink = function (obj) {
      return Restangular.one('person').one('getexternalfinancialstatementlink').get(obj);
    };

    var returnInformationsByToken = function (obj) {
      return Restangular.one('person').one('returninformationsbytoken').get(obj);
    };

    var verifyFieldsRequired = function (obj) {
      return Restangular.one('person').one('verifyfieldsrequired').get(obj);
    };

    var changePasswordForRaioDeSol = function () {
      return Restangular.one('person').one('changepasswordforraiodesol').post();
    };

    var getPayeeByResponsible = function (obj) {
      return Restangular.one('person').one('getpayeebyresponsible').get(obj);
    };

    return {
      getCities: getCities,
      getCitiesByQuery: getCitiesByQuery,
      getStatesByQuery: getStatesByQuery,
      getById: getById,
      getAddressByCep: getAddressByCep,
      getAllPersons: getAllPersons,
      getCnpjCaptcha: getCnpjCaptcha,
      getTeachers: getTeachers,
      returnInformationsByToken: returnInformationsByToken,
      getExternalFinancialStatementLink: getExternalFinancialStatementLink,
      postCnpjInfo: postCnpjInfo,
      createPerson: createPerson,
      updatePerson: updatePerson,
      searchPerson: searchPerson,
      getBillsFromPerson: getBillsFromPerson,
      getChecksFromPerson: getChecksFromPerson,
      getProfile: getProfile,
      listAll: listAll,
      getPossibleMatrixCompany: getPossibleMatrixCompany,
      getPersonWithFilter: getPersonWithFilter,
      removeChildCompany: removeChildCompany,
      getPendenciesMessage: getPendenciesMessage,
      setCollaborator: setCollaborator,
      verifyCollaborator: verifyCollaborator,
      verifyCPF: verifyCPF,
      preEnrolmentVerifyCPF: preEnrolmentVerifyCPF,
      verifyEmail: verifyEmail,
      getStatesAndCities: getStatesAndCities,
      getPlaceOfBirth: getPlaceOfBirth,
      deletePerson: deletePerson,
      verifyEmailError: verifyEmailError,
      verifyFieldsRequired: verifyFieldsRequired,
      changePasswordForRaioDeSol: changePasswordForRaioDeSol,
      saveResponsibleEmail: saveResponsibleEmail,
      getPayeeByResponsible: getPayeeByResponsible
    }

  }

  angular
    .module('app.finance.person')
    .factory('PersonService', PersonService);

})();

(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.person', {
        url: '/person',

        public: false,
        templateUrl: 'app/finance/person/views/index.html',
        controller: 'PersonController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Pessoas'
        }
      })
      .state('private.finance.person.create', {
        url: '/create',
        params: {
          type: null
        },
        public: false,
        views: {
          'person': {
            templateUrl: 'app/finance/person/person-profile/view/teste.html',
            controller: 'PersonProfileCreateController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.finance.person-profile', {
        url: '/person/:id/profile',
        params: {
          person: null
        },
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/person/person-profile/view/profile.html',
            controller: 'PersonProfileController',
            controllerAs: 'vm'
          },
          'expense@private.finance.person-profile': {
            controller: 'PersonExpenseController',
            controllerAs: 'vm',
            templateUrl: 'app/finance/person/person-expense/view/history.html'
          },
          'receipt@private.finance.person-profile': {
            controller: 'PersonReceiptController',
            controllerAs: 'vm',
            templateUrl: 'app/finance/person/person-receipt/view/history.html'
          },
          'check@private.finance.person-profile': {
            controller: 'PersonCheckController',
            controllerAs: 'vm',
            templateUrl: 'app/finance/person/person-check/view/history.html'
          }
        }
      });
  }

  angular
    .module('app.finance.person')
    .config(routerConfig);


})();



(function() {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService){
    var role = 'pessoa_menu';
    var path = 'finance.person';
    msNavigationService.saveItem('finance.person', {
      title : 'Pessoas',
      icon  : 'icon-account',
      state : 'private.finance.person',
      weight: 3,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.person')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function PersonController($stateParams, $scope, $rootScope, PoliciesService, Session,
                            $mdDialog, $mdMenu, Common, ModalFactory, PersonService, $state, $a4FloatButton) {

    var vm = this;

    vm.items = [];
    vm.captcha = null;
    vm.cnpjParams = [];
    vm.sex = [
      {value: 'm', name: 'Masculino'},
      {value: 'f', name: 'Feminino'}
    ];
    vm.grid = {};
    vm.search = '';
    vm.selected_tab = 0;
    vm.floatButton = null;

    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      vm.getAllPersons();
      vm.current_school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    };

    vm.createPerson = function () {
      ModalFactory.custom(
        'app/finance/person/views/select-type.html',
        {types: vm.types},
        true
      ).then(function (type) {
        vm.personTypeSelected(type);
      });
    };

    /**
     * Retorna todas as pessoas.
     * @param page - (Opcional) Pagina de destino
     * @param limit - limite de registros
     */
    vm.getAllPersons = function (page, limit) {
      if (vm.floatButton !== null) {
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
      if (!vm.checkPolicies('pessoa_alt') && vm.selected_tab === 1) {
        vm.floatButton = $a4FloatButton({
          scope: $scope,
          theme: 'finance',
          label: 'Adicionar Fornecedor',
          icon: 'group_add',
          onClick: 'vm.personTypeSelected(2)'
        });
      } else if (!vm.checkPolicies('pessoa_alt') && vm.selected_tab === 4) {
        vm.floatButton = $a4FloatButton({
          scope: $scope,
          theme: 'finance',
          label: 'Adicionar Cliente',
          icon: 'person_add',
          onClick: 'vm.personTypeSelected(1)'
        });
 //     } else if (!vm.checkPolicies('pessoa_alt') && vm.selected_tab === 0) {
 //       vm.floatButton = $a4FloatButton({
 //         scope: $scope,
 //         theme: 'finance',
 //         label: 'Criar pessoa',
 //         icon: 'person_add',
 //         onClick: 'vm.personTypeSelected(1)'
//        });
      }
    };

    vm.goToProfile = function (person, profile) {
      switch (profile) {
        case 'employee':
          $state.go('private.educational.collaborators.edit', {id: person.id});
          break;
        case 'student':
          if (person.last_student === vm.current_school_period) {
            $state.go('private.educational.students.edit', {
              id: person.id,
              course_id: person.course_id,
              group_id: person.group_id,
              course_equivalence_id: person.course_equivalence_id,
              matrix_period: person.matrix_period
            });
          } else {
            /**
             * Caso o aluno seja de outro período, envia parâmetro para alterar o período letivo do educacional
             */
            $state.go('private.educational.students.edit', {
              id: person.id,
              course_id: person.course_id,
              group_id: person.group_id,
              course_equivalence_id: person.course_equivalence_id,
              matrix_period: person.matrix_period,
              change_school_period: person.last_student
            });
          }
          break;
        case 'responsible':
          var last_school_period = null;
          if (person.last_payee !== null && person.last_responsible !== null) {
            last_school_period = Math.max(parseInt(person.last_payee), parseInt(person.last_responsible));
          } else {
            last_school_period = person.last_payee !== null ? person.last_payee : person.last_responsible;
          }

          if (last_school_period === vm.current_school_period) {
            $state.go('private.educational.responsibles.edit', {id: person.id});
          } else {
            $state.go('private.educational.responsibles.edit', {
              id: person.id,
              change_school_period: last_school_period
            });
          }
          break;
      }
    };

    /**
     * Consulta para realizar a filtragem da lista a partir da pesquisa por nome
     * @param query
     */
    vm.listAll = function (query) {
      $rootScope.$broadcast('query-persons', query);
    };

    /**
     * Define os tipos de pessoas disponíveis.
     */
    vm.types = [
      {value: 1, name: 'Pessoa', icon: 'person'},
      {value: 2, name: 'Empresa', icon: 'business'}
    ];

    vm.editPerson = function (item) {
      $state.go('private.finance.person-profile', {person: item, id: item.id});
    };

    /**
     * Abre o modal para criação e define um tipo de pessoa
     * selecionada para o formulário.
     */
    vm.personTypeSelected = function (value) {
      $rootScope.$broadcast('ModalFactory.close');
      $stateParams.type = value;
      ModalFactory.customClean(
        'app/finance/person/person-profile/view/create.html',
        'PersonProfileCreateController',
        'vm', false, {type: value, is_supplier: true}
      ).then(function (resp) {
        if (resp) {
          $rootScope.$broadcast('refresh-persons', {});
        }
        $rootScope.show_loader = false;
      });
    };

    /**
     * Redireciona para ficha financeira externa
     * @param person
     */
    vm.getExternalFinancialStatement = function (person) {
      $rootScope.show_loader = true;
      PersonService.getExternalFinancialStatementLink({person_id: person.id})
        .then(function (link) {
          $rootScope.show_loader = false;
          var element = document.createElement('a');
          element.setAttribute('href', link);
          element.setAttribute('target', '_blank');
          return element.click();
        })
    };

    vm.clickAction = function (item, option) {
      switch (option) {
        case "turn-collaborator":
          vm.setCollaborator(item);
          break;
        case "external-financial-statement":
          vm.getExternalFinancialStatement(item);
          break;
      }
    };

    /**
     * Torna um usuário colaborador
     * @param person
     */
    vm.setCollaborator = function (person) {
      /** Verifica se o usuário é colaborador ativo em outra empresa */
      PersonService.verifyCollaborator(person).then(function (response) {
        if (response === true) {
          ModalFactory.confirm(null, "Deseja continuar?",
            "A pessoa é colaboradora ativa em outra empresa",
            "Continuar", "Cancelar", "finance").then(function () {
            $rootScope.show_loader = true;
            PersonService.setCollaborator(person).then(function (response) {
              if (response) {
                Common.Toast.success("Colaborador criado com sucesso!");
              } else {
                Common.Toast.error("Erro");
              }
              vm.getAllPersons();
            })
          })
        } else {
          $rootScope.show_loader = true;
          PersonService.setCollaborator(person).then(function (response) {
            if (response) {
              Common.Toast.success("Colaborador criado com sucesso!");
            } else {
              Common.Toast.error("Erro");
            }
            vm.getAllPersons();
          })
        }
      })
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    vm.init();
  }

  angular
    .module('app.finance.person')
    .controller('PersonController', PersonController)
    .filter('makeUppercase', function () {
      return function (item) {
        return item.toUpperCase();
      };
    });
})();

(function () {
  'use strict';

  /** @ngInject */
  function PaymentPlanService(Restangular) {

    /**
     * Retorna todos os planos de pagamento.
     */
    var getAllPaymentPlan = function (obj) {
      return Restangular.one('paymentplan').all('listall').getList(obj);
    };

    /**
     * Retorna todos os planos de pagamento ativos.
     */
    var getAllActivePaymentPlan = function () {
      return Restangular.one('paymentplan').all('listallactive').getList();
    };

    /**
     * Retorna as categorias por tipo.
     */
    var getCategoryByType = function (type) {
      return Restangular.one('bill').one('getcategoriesbytype', type).getList();
    };

    /**
     * Retorna as categorias por tipo.
     */
    var removePaymentPlan = function (id) {
      return Restangular.one('paymentplan', id).remove();
    };

    var getDiscounts = function (obj) {
      return Restangular.one('paymentplan').one('getdiscounts').get(obj);
    };

    /**
     * Cria um novo plano de pagamento.
     */
    var createPaymentPlan = function (obj) {
      return Restangular.all('paymentplan').post(obj);
    };

    /**
     * Atualiza um novo plano de pagamento.
     */
    var updatePaymentPlan = function (obj, id) {
      return Restangular.one('paymentplan', id).customPUT(obj);
    };

    /**
     * Retorna todas as pessoas do banco de dados.
     */
    var getAllPersons = function () {
      return Restangular.all('bill/getallpersons').getList();
    };

    /**
     * Retorna todas as regras de multas.
     */
    var getAllAdditionsRules = function () {
      return Restangular.all('finesrule/getAll').getList();
    };

    /**
     * Retorna todas as regras de acrecimos.
     */
    var getAllDiscountRules = function () {
      return Restangular.all('discountRoles/getAll').getList();
    };

    /**
     * Retorna todas as regras de acrecimos.
     */
    var getAllBankSlipRules = function () {
      return Restangular.all('banksliprule/getAll').getList();
    };

    /**
     * Retorna todas as regras de índices de correções.
     */
    var getAllcorrectionIndexRoles = function () {
      return Restangular.all('correctionindex/getAll').getList();
    };

    /**
     * Retorna os dados do plano de pagamento
     * @param id
     */
    var getById = function (id) {
      return Restangular.one('paymentplan', id).get();
    };

    /**
     * Retorna produtos para associação em grupo com plano de pagamento
     * @param obj
     */
    var getProductsToAssociate = function (obj) {
      return Restangular.one('paymentplan').one('getproductstoassociate').get(obj);
    };

    /**
     * Retorna produtos para associação em grupo com plano de pagamento
     * @param obj
     */
    var associateProductstoPlan = function (obj) {
      return Restangular.one('paymentplan').all('associateproductstoplan').post(obj);
    };

    var addDiscount = function (payment_plan_id, obj) {
      return Restangular.one('paymentplan', payment_plan_id).all('creatediscount').post(obj);
    };

    var removeDiscount = function (payment_plan_id, discount_id) {
      return Restangular.one('paymentplan', payment_plan_id).all('removediscount')
        .post({discount_id: discount_id});
    };


    return {
      addDiscount: addDiscount,
      getAllPaymentPlan: getAllPaymentPlan,
      getCategoryByType: getCategoryByType,
      createPaymentPlan: createPaymentPlan,
      getById: getById,
      getAllPersons: getAllPersons,
      getAllAdditionsRules: getAllAdditionsRules,
      getAllDiscountRules: getAllDiscountRules,
      getAllBankSlipRules: getAllBankSlipRules,
      getAllcorrectionIndexRoles: getAllcorrectionIndexRoles,
      getDiscounts: getDiscounts,
      updatePaymentPlan: updatePaymentPlan,
      removeDiscount: removeDiscount,
      removePaymentPlan: removePaymentPlan,
      getAllActivePaymentPlan: getAllActivePaymentPlan,
      getProductsToAssociate: getProductsToAssociate,
      associateProductstoPlan: associateProductstoPlan
    }

  }

  angular
    .module('app.finance.paymentplan')
    .factory('PaymentPlanService', PaymentPlanService)

})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.paymentplan', {
        url: '/paymentplan',
        public: false,
        templateUrl: 'app/finance/payment-plan/views/index.html',
        controller: 'PaymentPlanController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Plano de Pagamento'
        }
      });
  }

  angular
    .module('app.finance.paymentplan')
    .config(routerConfig);


})();



(function() {
  'use strict';

  /** @ngInject */
  function menuConfig(){
  }

  angular
    .module('app.finance.paymentplan')
    .config(menuConfig);

})();



(function () {
  'use strict';

  /** @ngInject */
  function PaymentPlanCreateEditController($rootScope, $scope, $a4Sidenav, $mdConstant, Common, ModalFactory, PaymentPlanService,
                                           $timeout, SideExtra, a4Moment) {

    var vm = this;
    vm.tags = [];
    vm.selectedTab = 0;
    vm.show_form = false;
    vm.paymentPlan = {};
    vm.paymentPlan.debit_credit = 'C';
    vm.paymentPlan.payment_plan = null;
    vm.paymentPlan.has_bill = false;
    vm.paymentPlan.frequency = 2;
    vm.paymentPlan.frequency_qty = 1;
    vm.paymentPlan.quantity = 1;
    vm.paymentPlan.end_of_recurrence = 0;
    vm.paymentPlan.was_paid = 0;
    vm.paymentPlan.recurrency_on_value = 2;
    vm.show_progress = false;

    vm.frequency_options = [
      {id: 1, name: 'Dia(s)'},
      {id: 2, name: 'Mês(es)'},
      {id: 3, name: 'Ano(s)'}
    ];

    vm.colletion_types = [
      {id: 1, name: 'Carteira'},
      {id: 9, name: 'Boleto'},
      {id: 10, name: 'Depósito / transferência / Pix'},
      {id: 20, name: 'Cartão de crédito'},
      {id: 4, name: 'Cheque pré datado'},
      {id: 12, name: 'Débito automático em conta'},
      {id: 22, name: 'Débito automático em cartão'}
    ];

    vm.accrual_date_type = [
      {value: 0, name: 'No Vencimento'},
      {value: 1, name: 'No Mês Anterior'},
      {value: 2, name: 'No Mês Posterior'},
      {value: 3, name: 'Único'}
    ];

    vm.accrual_month = [
      {value: '1', name: 'Janeiro'},
      {value: '2', name: 'Fevereiro'},
      {value: '3', name: 'Março'},
      {value: '4', name: 'Abril'},
      {value: '5', name: 'Maio'},
      {value: '6', name: 'Junho'},
      {value: '7', name: 'Julho'},
      {value: '8', name: 'Agosto'},
      {value: '9', name: 'Setembro'},
      {value: '10', name: 'Outubro'},
      {value: '11', name: 'Novembro'},
      {value: '12', name: 'Dezembro'}
    ];

    vm.accrual_year = [
      {value: '2013', name: '2013'},
      {value: '2014', name: '2014'},
      {value: '2015', name: '2015'},
      {value: '2016', name: '2016'},
      {value: '2017', name: '2017'},
      {value: '2018', name: '2018'},
      {value: '2019', name: '2019'},
      {value: '2020', name: '2020'},
      {value: '2021', name: '2021'},
      {value: '2022', name: '2022'},
      {value: '2023', name: '2023'},
      {value: '2024', name: '2024'}
    ];

    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];

    vm.tags = [];

    vm.isAddItem = false;

    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      $scope.iframeHeight = angular.element('#content').height();
      vm.getBillCategories('C');
      vm.getAllAdditionsRules();
      vm.getAllDiscountRules();
      vm.getAllBankSlipRules();
      vm.getCorrectionIndex();
      if (SideExtra) {
        vm.getById(SideExtra.id);
      } else {
        vm.paymentPlan.discounts_rules = [
          {
            idx: 0,
            first_row: true,
            start_date: null,
            end_date: null
          }
        ];
      }
    };

    /**
     * Retorna os dados do plano de pagamento
     * @param id
     */
    vm.getById = function (id) {
      PaymentPlanService.getById(id)
        .then(function (resp) {
          vm.paymentPlan = resp.plain();
          $rootScope.$broadcast('UPDATE_DISCOUNTS_RULE_LIST');
        });
    };

    /**
     * Realiza fechamento do serviço da sidenav
     */
    vm.close = function () {
      $a4Sidenav().close()
    };

    vm.simulateQuery = false;

    /**
     * Realiza busca das categorias disponíveis.
     */
    vm.querySearch = function (query) {
      return query ? vm.billCategories.filter(vm.createFilterFor(query)) : vm.billCategories;
    };

    /**
     * Filtro para consulta da string
     */
    vm.createFilterFor = function (query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return (item.value.indexOf(lowercaseQuery) === 0);
      };
    };

    vm.getBillCategories = function (type) {
      PaymentPlanService.getCategoryByType(type)
        .then(function (response) {
          vm.billCategories = response;
          var repos = vm.billCategories;

          angular.forEach(response, function (item) {
            if (item.id === vm.paymentPlan.bill_category_id) {
              vm.searchText = item.name;
            }
          });

          $rootScope.show_loader = false;

          return repos.map(function (repo) {
            repo.value = repo.name.toLowerCase();
            return repo;
          });
        })
    };

    vm.getAllAdditionsRules = function () {
      PaymentPlanService.getAllAdditionsRules()
        .then(function (response) {
          vm.allAdditionRules = response;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.getAllDiscountRules = function () {
      PaymentPlanService.getAllDiscountRules()
        .then(function (response) {
          vm.allDiscountRules = response;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.getAllBankSlipRules = function () {
      PaymentPlanService.getAllBankSlipRules()
        .then(function (response) {
          vm.allBankSlipRules = response;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.getCorrectionIndex = function () {
      PaymentPlanService.getAllcorrectionIndexRoles()
        .then(function (response) {
          vm.indexCorrection = response;
          $rootScope.show_loader = false;
          vm.show_form = true;
        })
        .catch(function () {
          $rootScope.show_loader = false;
          vm.show_form = true;
        });
    };

    /** Adiciona um desconto à lista */
    vm.addDiscount = function () {
      vm.paymentPlan.discounts_rules.push({
        idx: vm.paymentPlan.discounts_rules.length,
        first_row: false,
        start_date: a4Moment(null),
        end_date: a4Moment(null)
      })
    };

    /** Remove um desconto da lista */
    vm.removeDiscount = function (index) {
      vm.paymentPlan.discounts_rules.splice(index, 1);
    };

    /**
     *
     * @param end - Moment
     * @param initial - Moment
     * @param index - int
     * @returns {boolean}
     */
    vm.verifyIfEndDateSmallerThanInitialDate = function (end, initial, index) {
      if (end.diff(initial) <= 0) {
        vm.paymentPlan.discounts_rules[index].end_date = a4Moment(null);
        return true;
      }
      vm.verifyIfHasMoreThenOneItens();
      return false;
    };

    vm.verifyIfHasMoreThenOneItens = function () {
      vm.isAddItem = vm.paymentPlan.discounts_rules[0].end_date !== null &&
        vm.paymentPlan.discounts_rules[0].start_date !== null &&
        vm.paymentPlan.discounts_rules[0].discounts_rule_id !== undefined;
    };

    //watcher para atualizar o valor de quantidade de frequencia.
    $scope.$watch('vm.paymentPlan.was_paid', function(newValue, oldValue) {
      // Só executa se realmente houve mudança e não é a inicialização
      if (newValue !== oldValue && newValue !== undefined) {
        if (newValue == 1) {
          // se foi mudado para Receita recorrente, define frequência padrão como 1
          vm.paymentPlan.frequency_qty = 1;
        }
      }
    });

    /**
     * Retorna para o plugin de tags a tags de acordo com a frase escrita.
     */
    vm.loadTags = function (query) {
      return PaymentPlanService.getTags(query);
    };

    vm.alertInfo = function ($event, title, text) {
      ModalFactory.confirm($event, title, text, 'Confirmar', 'Cancelar');
    };

    vm.setRecurrenceData = function () {
      if ((angular.isDefined(SideExtra.create) && SideExtra.create) && vm.paymentPlan.was_paid === 1) {
        vm.paymentPlan.frequency_qty = 1;
        vm.paymentPlan.frequency = 2;
        vm.paymentPlan.quantity = 1;
        vm.paymentPlan.end_of_recurrence = 0;
        vm.paymentPlan.recurrence_on_value = 0;
      }
    };

    /**
     * Cria novo ou atualiza um plano de pagamento.
     * @param form
     * @param {type} obj - Informações do formulário;
     * @returns {undefined}
     */
    vm.submitPaymentPlan = function (form, obj) {
      if (form.$valid) {
        vm.show_progress = true;
        if (obj.payment_plan === 0) {
          vm.paymentPlan.frequency_type = null;
          vm.paymentPlan.frequency_qty = null;
          vm.paymentPlan.frequency = 0;
          vm.paymentPlan.quantity = null;
          vm.paymentPlan.end_of_recurrence = null;
        }
        /**
         * Se o tipo de recorrência não for 'até determinada data', a data final do plano é nula
         */
        if (obj.end_of_recurrence !== "1" && obj.end_of_recurrence !== 1){
          obj.date_end = null;
        }

        /**
         * Se for 'sem prazo definido' ou 'até determinada data', a quantity é 0
         */
        if (obj.end_of_recurrence !== 0 && obj.end_of_recurrence !== "0"){
          obj.quantity = 0;
        }

        obj.company_id = obj.company;
        obj.tags = vm.tags;

        if (obj.id === null || angular.isUndefined(obj.id)) {
          PaymentPlanService.createPaymentPlan(obj)
            .then(function () {
              vm.close();
              Common.Toast.success('Plano de pagamento criado com sucesso.');
              $rootScope.$broadcast('update.payment-plan.list');
              $rootScope.show_loader = false;
              vm.show_progress = false;
            })
            .catch(function () {
              Common.Toast.error('Erro, não foi possível inserir plano de pagamento.');
              $rootScope.show_loader = false;
              vm.show_progress = false;
            });
        } else {
          PaymentPlanService.updatePaymentPlan(obj, obj.id)
            .then(function () {
              vm.close();
              Common.Toast.success('Plano de pagamento atualizado com sucesso.');
              $rootScope.$broadcast('update.payment-plan.list');
              $rootScope.show_loader = false;
              vm.show_progress = false;
            })
            .catch(function () {
              Common.Toast.error('Erro, não foi possível atualizar plano de pagamento.');
              $rootScope.show_loader = false;
              vm.show_progress = false;
            });
        }
      }
    };

    /**
     * @param value
     */
    vm.tabChange = function (value) {
      $timeout(function () {
        vm.selectedTab = (value === 1) ? 0 : vm.selectedTab;
        vm.selectedTab = (value === 2) ? 1 : vm.selectedTab;
      }, 300);
    };

    vm.init();

  }

  angular
    .module('app.finance.paymentplan')
    .controller('PaymentPlanCreateEditController', PaymentPlanCreateEditController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function PaymentPlanController($rootScope, $a4Sidenav, $mdConstant, $scope, ModalFactory, PaymentPlanService,
                                 $a4FloatButton, Common) {

    var vm = this;
    vm.tags = [];
    vm.selectedTab = 0;
    vm.show_inactive = false;

    vm.paymentPlan = {};
    vm.paymentPlan.debit_credit = 'C';
    vm.paymentPlan.payment_plan = null;

    vm.grid = {
      data: []
    };

    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];

    var ltn1 = $rootScope.$on('update.payment-plan.list', function () {
      vm.getAllPaymentPlan();
    });

    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      vm.getAllPaymentPlan();
      vm.getAllPaymentPlan();
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.openSide()', label: 'Criar novo plano', theme: 'finance'
      });
    };

    vm.clickOption = function (item, option) {
      switch (option) {
        case 'associate_groups':
          vm.openAssociateModal(item, 0);
          break;
        case 'associate_services':
          vm.openAssociateModal(item, 1);
          break;
        case 'individual_discounts':
          vm.openDiscountsModal(item);
          break;
        case 'contract' :
          vm.editDocument(item);

      }
    };

    /**
     * Abre modal de associação de plano de pagamento com turma/serviço
     * @param item
     * @param type
     */
    vm.openAssociateModal = function (item, type) {
      ModalFactory.customClean('app/finance/payment-plan/views/payment-plan-associate-modal.html',
        'PaymentPlanAssociateController', 'vm', true, {
          payment_plan: item,
          type: type
        }).then(function () {

      })
    };

    vm.openDiscountsModal = function (payment_plan) {
      ModalFactory.customClean('app/finance/payment-plan/views/payment-plan-discounts.html',
        'PaymentPlanDiscountsController', 'vm', false, {
          payment_plan_id: payment_plan.id
        }).then(function () {

      })
    };

    /**
     * vai para pagina de edição de contrato para assinatura externa
     */
    vm.editDocument = function (document) {
      //TODO: criar uma permissão para editar o documento para assinatura no escopo de serviços

      // if (!vm.checkPolicies('edit_educ_msgs')) {
      $state.go('private.finance.edit-document', {id: document.id})
      // }
    };
    /**
     * Realiza fechamento do serviço da sidenav
     */
    vm.close = function () {
      $a4Sidenav().close()
    };

    vm.simulateQuery = false;

    /**
     * Realiza busca das categorias disponíveis.
     */
    vm.querySearch = function (query) {
      return query ? vm.billCategories.filter(vm.createFilterFor(query)) : vm.billCategories;
    };


    /**
     * Remoção de plano de pagamento
     */
    vm.delete = function (id) {
      ModalFactory.confirm(null,
        "Excluir Plano de Pagamento",
        "Deseja realmente excluir este plano?",
        'Excluir', 'Não',
        'finance'
      ).then(function () {
        PaymentPlanService.removePaymentPlan(id)
          .then(function () {
            Common.Toast.success('Plano removido com sucesso');
            vm.getAllPaymentPlan();
          })
          .catch(function (response) {
            ModalFactory.alert("Ops!", response.data.message, 'remover', 'Okay!', false, 'finance')
          });
      });
    };

    /**
     * Filtro para consulta da string
     */
    vm.createFilterFor = function (query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return (item.value.indexOf(lowercaseQuery) === 0);
      };
    };


    /**
     * Retorna todas os planos de pagamento.
     * @returns {response}
     */
    vm.getAllPaymentPlan = function () {
      $rootScope.show_loader = true;
      vm.grid.promisse = PaymentPlanService.getAllPaymentPlan({show_inactive: vm.show_inactive})
        .then(function (response) {
          if (response) {
            vm.grid.rows = [];
            vm.grid.rows = response.plain();

            $rootScope.show_loader = false;
          }
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Abre a sidebar para criação.
     */
    vm.openSide = function () {
      $a4Sidenav({width: '700px'}).open(
        'app/finance/payment-plan/views/forms/form-paymentplan.html',
        'PaymentPlanCreateEditController',
        'vm',
        {create: true}
      );
    };

    /**
     * Abre a sidebar para edição.
     */
    vm.openSideEdit = function (item) {
      item.create = false;
      $a4Sidenav({width: '700px'}).open(
        'app/finance/payment-plan/views/forms/form-paymentplan.html',
        'PaymentPlanCreateEditController',
        'vm',
        item
      );
    };

    /**
     * Retorna para o plugin de tags a tags de acordo com a frase escrita.
     */
    vm.loadTags = function (query) {
      return PaymentPlanService.getTags(query);
    };

    vm.alertInfo = function ($event, title, text) {
      ModalFactory.confirm($event, title, text, 'Confirmar', 'Cancelar');
    };

    $scope.$on('$destroy', function () {
      [ltn1].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.finance.paymentplan')
    .controller('PaymentPlanController', PaymentPlanController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function PaymentPlanDiscountsController($rootScope, ModalExtra, ModalFactory, Common, PaymentPlanService){
    var vm = this;
    vm.discounts = [];
    vm.newdiscount = null;

    vm.init = function () {
      vm.payment_plan_id = ModalExtra.payment_plan_id;
      vm.payment_plan_name = ModalExtra.payment_plan_name;
      vm.theme = angular.isDefined(ModalExtra.theme) ? ModalExtra.theme : 'finance';
      vm.getDiscounts(vm.payment_plan_id);
    };


    /**
     * Discontos individuais do contrato;
     * @param payment_plan_id
     */
    vm.getDiscounts = function (payment_plan_id) {
      PaymentPlanService.getDiscounts({payment_plan_id: payment_plan_id})
        .then(function (discounts) {
          vm.discounts = discounts.plain();
        });
    };


    /**
     * Criação de desconto individual
     */
    vm.createNewIndivialDiscount = function () {
      ModalFactory.customClean(
        'app/components/a4-discounts/modal.html',
        'A4DiscountsController',
        'vm',
        true,
        {theme: 'finance'}
      ).then(function (newdiscount) {
        if (newdiscount !== 'canceled') {
          $rootScope.show_loader = true;
          PaymentPlanService.addDiscount(vm.payment_plan_id, newdiscount)
            .then(function () {
              $rootScope.show_loader = false;
              vm.reopenModal(vm.payment_plan_id);
              Common.Toast.success('Desconto adicionado com sucesso');
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.error(error.message);
            });
        }
      })
    };

    vm.convertType = function (format) {
      switch (format) {
        case 'F':
          return 'Fixo';
        case 'C':
          return 'Condicional';
        case 'P':
          return 'Promocional';
      }
    };


    vm.reopenModal = function (payment_plan) {
      ModalFactory.customClean(
        'app/finance/payment-plan/views/payment-plan-discounts.html',
        'PaymentPlanDiscountsController',
        'vm', false, {payment_plan_id: payment_plan, theme: vm.theme}
      )
        .then(function () {
        });
    };


    /**
     * Remove um desconto da lista
     */
    vm.removeItem = function (discount_id) {
      ModalFactory.confirm(
        null,
        'Deseja realmente remover este desconto?',
        ' ',
        'Remover',
        'Cancelar',
        vm.theme)
        .then(function () {
          $rootScope.show_loader = true;
          PaymentPlanService.removeDiscount(vm.payment_plan_id, discount_id)
            .then(function () {
              vm.reopenModal(vm.payment_plan_id);
              Common.Toast.success('Desconto removido com sucesso');
              $rootScope.show_loader = false;
            })
            .catch(function (error) {
              Common.Toast.success(error.message);
              $rootScope.show_loader = false;
            })
        })
        .catch(function () {
          vm.reopenModal(vm.payment_plan_id);
        });
    };
    /**
     * Fecha modal
     * @param data
     */
    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.init();

  }

  angular
    .module('app.finance.paymentplan')
    .controller('PaymentPlanDiscountsController', PaymentPlanDiscountsController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function PaymentPlanAssociateController(ModalExtra, $rootScope, CourseService, PaymentPlanService, Common, DocumentsService, Session) {
    var vm = this;
    vm.company = Session.getCurrentCompany();
    console.log(Session.getCurrentCompany());
    vm.payment_plan = ModalExtra.payment_plan;
    vm.type = ModalExtra.type;
    vm.show_loading = false;
    /** Array de produtos */
    vm.products = [];
    /** Produtos associados com o plano selecionado */
    vm.selected_products = [];
    /** Array auxiliar de produtos que estavam associados antes das modificações */
    vm.original_products = [];
    /** Ids dos produtos desassociados */
    vm.removed_products_ids = [];
    /** Cursos */
    vm.courses = [];
    vm.course_selected = 0;
    vm.init = function () {
      vm.getAllDocuments();
      vm.paginate(1, 5);
      vm.getCourses();
    };

    vm.getAllDocuments = function () {
      DocumentsService.getAll({ type: 2 })
        .then(function (response) {
          vm.documents = response.plain().data;
          //TODO: lembrar de adicionar a mensagem caso não tenha nem um serviço vinculado
        })
    };

    vm.getCourses = function () {
      $rootScope.show_loader = true;
      CourseService.getAll({only_active: true})
        .then(function (response) {
          vm.courses = response.plain();
        });
      $rootScope.show_loader = false;

    };

    /**
     * Busca os produtos
     * @param page
     * @param limit
     */
    vm.paginate = function (page, limit) {
      vm.show_loading = true;
      PaymentPlanService.getProductsToAssociate({
        payment_plan_id: vm.payment_plan.id,
        type: vm.type,
        limit: limit,
        page: page,
        course_id: vm.course_selected
      }).then(function (response) {
        vm.products = response.plain();
        for (var i = vm.products.data.length; i--;) {
          if (vm.products.data[i].ppp_id !== null) {
            vm.selected_products.push(vm.products.data[i]);
            vm.original_products.push(angular.copy(vm.products.data[i]));
          }
        }
        vm.show_loading = false;
      })
    };

    /**
     * Adiciona produto na lista
     * @param product
     * @returns {number}
     */
    vm.add = function (product) {
      if (vm.selected_products.includes(product)) {
        return 0;
      } else {
        vm.selected_products.push(product);
      }
    };

    vm.verify = function () {
    };

    /**
     * Fecha modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.verifyAssociation = function(id)
    {
      for (var i = vm.selected_products.length; i--;){
        if (vm.selected_products[i].id === id){
          return true;
        }
      }
      return false;
    };

    vm.submit = function () {
      vm.show_loading = true;
      /** Loop para verificar quais associações foram removidas */
      for (var z = vm.original_products.length; z--;) {
        if (!(vm.verifyAssociation(vm.original_products[z].id))) {
          vm.removed_products_ids.push(vm.original_products[z].id);
        }
      }
      PaymentPlanService.associateProductstoPlan({
          products: vm.selected_products,
          payment_plan_id: vm.payment_plan.id,
          removed_products_ids: vm.removed_products_ids
        }
      ).then(function () {
        vm.close();
        Common.Toast.success('Associação criada com sucesso!');
      }).catch(function () {
        Common.Toast.error('Erro na associação, verifique se este plano não está vinculado a outro plano.') ;

      })
    };


    vm.init();
  }

  angular
    .module('app.finance.paymentplan')
    .controller('PaymentPlanAssociateController', PaymentPlanAssociateController);
})();
(function () {
    'use strict';

   angular
     .module('app.finance.payment-book', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function PaymentBookService(Restangular, a4Moment, $http, Common, CONFIG) {

    var printPaymentBook = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/contract/printpaymentbook',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        
        var contentType = headers['content-type'];

        var linkElement = document.createElement('a');
        try {
            var blob = new Blob([data], {type: contentType});
            var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
            linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {
        
      });

      return deffered.promise;
    };

    return {
      printPaymentBook: printPaymentBook
    }
  }

  angular.module('app.finance.payment-book')
    .factory('PaymentBookService', PaymentBookService)
})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.payment-book', {
        url: '/payment-book',
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/payment-book/views/index.html',
            controller: 'PaymentBookController',
            controllerAs: 'vm'
          }
        }
      });
  };

  angular
    .module('app.finance.payment-book')
    .config(routerConfig);

})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {

    var role_cobranca = 'payment_book';
    var role_boleto = 'cobanc_bol';
    var path = 'finance.payment-book';

    msNavigationService.saveItem('finance.payment-book', {
      title: 'Carnês',
      icon: 'icon-barcode',
      auth: role_boleto,
      state: 'private.finance.payment-book',
      weight: 8,
      // title: 'Boletos',
      // icon: 'icon-bank',
      // auth: role_cobranca,
      // weight: 7,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role_cobranca, path);
      }
    });
  }

  angular
    .module('app.finance.bankslip')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function PaymentBookController($rootScope, $document, Common, PoliciesService, a4Moment,
                                 ModalFactory, CourseService, GroupService, PaymentBookService,
                                 $scope, CONFIG, ProductService, PersonService, EducationalService) {

    var vm = this;

    vm.items = [];
    vm.product_groups = [];
    vm.person = null;
    vm.filter_person = null;
    vm.filter_service = null;
    vm.filter_service_id = null;
    vm.product_group_id = null;
    vm.product_ids = [];
    vm.without_isented = false;

    /**
     * init
     */
    vm.init = function () {
      vm.getSchoolPeriod();
      vm.subdomain = $document[0].domain.split('.')[0];
      vm.setYears();
      // vm.allProductGroups();
    };


    /**
     * Define o array de meses e anos a serem selecionados
     */
    vm.setYears = function () {
      vm.years = [];
      vm.months = [];
      var initial_month = 0;
      /** os meses no moment são tratados de 0 a 11, sendo 0 - Janeiro e 11 - Dezembro */
      for (var i = 0; i <= 11; i++) {
        var momentVar = a4Moment().startOf('year');
        if (i >= initial_month) {
          momentVar.add('month', i);
          vm.months.push({id: momentVar.month() + 1, name: momentVar.format('MMMM')});
        }
        /** se for dezembro já adiciona janeiro novamente */
        if (initial_month === 11) {
          var firstMonth = a4Moment().startOf('year');
          vm.months.push({id: firstMonth.month(), name: firstMonth.format('MMMM')});
        }
      }

      for (var i2 = 0; i2 <= 5; i2++) {
        var momentVar3 = a4Moment().add('year', i2);
        vm.years.push({id: momentVar3.year(), name: momentVar3.format('YYYY')});
      }
      vm.filter_year = vm.years[0].id;
      vm.filter_month = [a4Moment().month() + 1];
    };

    /**
     *  Retorna o periodo letívo selecionado
     */
    vm.getSchoolPeriod = function () {
      EducationalService.getSchoolsPeriod()
        .then(function (periods) {
          vm.school_period = periods.plain();
          $rootScope.show_loader = false;
        })
    };

    /**
     * Item selecionado no autocomplete de pessoas
     * @param item
     */
    vm.selectedItemChange = function (item) {
      if (angular.isDefined(item)) {
        vm.filter_person = item.id;
      }
    };

    /**
     * Item selecionado no autocomplete de serviços
     * @param item
     */
    vm.selectedServiceChange = function (item) {
      if (angular.isDefined(item)) {
        vm.filter_service_id = item.id;
      } else {
        vm.filter_service_id = null;
      }
    };

    /**
     * Retorna todos agrupamentos
     */
    vm.allProductGroups = function () {
      if (vm.product_groups.length === 0) {
        return CourseService.getAll({only_active: true})
          .then(function (response) {
            vm.product_groups = response.plain();
            vm.product_groups.unshift({id: null, name: 'Nenhum'});
          }).catch(function (error) {
            Common.Toast.error(error)
          });
      } else {
        var deffered = Common.$q.defer();
        deffered.resolve(vm.product_groups);
        return deffered.promise;
      }

    };

    /**
     * Retorna os serviços associados a um grupo de serviço
     * @param course_id
     */
    vm.getProductsByGroup = function (course_id) {
      vm.product_ids = [];
      if (course_id === null) {
        vm.product_group_id = null;
      } else {
        GroupService.getGroupsByCourse(course_id)
          .then(function (response) {
            vm.products = response.data;
          });
      }
    };

    /**
     * Retorna todos os produtos
     */
    vm.getAllServices = function (query) {
      return ProductService.getAllProducts({
        query: angular.isDefined(query) ? query : null,
        only_services: true,
        show_inactive_products: false,
        withoutExternalId: true,
        autocomplete: true
      });
    };
    /**
     * Busca pessoa para impressão dos boletos;
     */
    vm.getBankSlipPerson = function (query) {
      return PersonService.listAll({query: query});
    };

    /**
     * Geração de boletos em grupo
     */
    vm.generatePaymentBooks = function () {
      if (vm.filter_service_id === null && vm.product_ids.length <= 0 && vm.filter_person === null) {
        Common.Toast.warning('Selecione um serviço, turma ou pessoa');
      } else {
        $rootScope.show_loader = true;
        PaymentBookService.printPaymentBook({
          person_id: vm.filter_person,
          service_id: vm.filter_service_id,
          groups: vm.product_ids,
          year: vm.filter_year,
          month: vm.filter_month,
          without_isented: vm.without_isented
        })
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Carnês gerados com sucesso');
          })
          .catch(function (error) {
            Common.Toast.error(error.message || error.data.message);
            $rootScope.show_loader = false;
          })
      }
    };


    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular
    .module('app.finance.payment-book')
    .controller('PaymentBookController', PaymentBookController);
})();
(function () {
  'use strict';

  angular
    .module('app.finance.nfse', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function NFSEService(Restangular, CONFIG, Common, $http) {

    /**
     * Retorna a empresa corrente
     * @returns object
     */
    var getCurrentCompany = function () {
      return Restangular.one('currentcompany').get();
    };

    /**
     * Lista de natureza de tributo
     * @returns {[*,*,*,*,*,*]}
     */
    var getListOfOptionsTribute = function () {
      return [
        {id: 1, name: 'Microempresa municipal'},
        {id: 2, name: 'Estimativa'},
        {id: 3, name: 'Sociedade de profissionais'},
        {id: 4, name: 'Cooperativa'},
        {id: 5, name: 'Microempresário individual (MEI)'},
        {id: 6, name: 'Microempresa ou Empresa de pequeno porte (ME / EPP)'}
      ];
    };

    /**
     * Lista de natureza de operação
     * @returns {[*,*,*,*,*,*]}
     */
    var getListOfOptionsOperation = function () {
      return [
        {id: 1, name: 'Tributação do município'},
        {id: 2, name: 'Tributação fora do município'},
        {id: 3, name: 'Isenção'},
        {id: 4, name: 'Imunidade'},
        {id: 5, name: 'Exigibilidade suspensa por procedimento administrativo'},
        {id: 6, name: 'Exigibilidade suspensa por decisão judicial'}
      ];
    };

    /**
     * Retorna todos os invoice_batch
     * @returns object
     */
    var getAllInvoiceBatch = function () {
      return Restangular.one('electronicinvoice').one('all').get();
    };

    /**
     * Retorna todos os produtos
     * @returns array
     */
    var getAllProducts = function (obj) {
      return Restangular.one('product').one('getAll').get(obj);
    };

    /**
     * Update das configurações da empresa
     * @param data
     * @returns boolean
     */
    var updateCompanyConfig = function (data) {
      return Restangular.all('updatecompanyconfig').post(data);
    };

    /**
     * Update das configurações de aliquota
     * @param data
     * @returns boolean
     */
    var updateAliquotConfig = function (data) {
      return Restangular.one('product').all('updatealiquotconfig').post(data);
    };

    /**
     * Retorna lista de titulos candidatos a geração de nota fiscal
     * @returns {*}
     * @param obj
     */
    var getBillstoNfse = function (obj) {
      return Restangular.one('company').one('getlistnfsecandidates').get(obj);
    };

    /**
     * Retorna lista de titulos candidatos a geração de nota fiscal
     * @returns {*}
     * @param obj
     */
    var getInvoices = function (obj) {
      return Restangular.one('electronicinvoice').one('invoices').get(obj);
    };

    /**
     * Retorno de lista de competencias relacionadas aos titulos candidatos
     * @param month
     * @param year
     * @param product
     * @returns {*}
     */
    var getListOfCompetences = function (month, year, product) {
      return Restangular.one('company').one('getlistofcompetences').get({month: month, year: year, product: product});
    };

    /**
     * Envia a lista de bills para emissão das notas fiscais
     * @param list
     * @returns {*}
     */
    var sendBillToNfse = function (list) {
      return Restangular.all('electronicinvoice').post({list: list});
    };

    var storeNfseByFilter = function (obj) {
      return Restangular.one('electronicinvoice').all('storenfsebyfilter').post(obj);
    };

    /**
     * Consultar conteudo do lote
     * @param protocol
     * @returns {*}
     */
    var consultarlote = function (protocol) {
      return Restangular.one('electronicinvoice').one('consultarlote').get({protocol: protocol});
    };

    var getProductGroupUsed = function (obj) {
      return Restangular.one('electronicinvoice').one('productgroupused').get(obj);
    };

    var printNFSeSSA = function (item, nfse_em_producao) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.nota_fiscal[nfse_em_producao ? 'producao' : 'homologacao'] +
          '?nf=' + item.nf_number + '&inscricao=' + item.municipal_registration_number + '&verificacao=' + item.nf_code,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var printNFSeSLZ = function (item) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.nota_fiscal.url_plugnotas + item.id_plugnotas,
        responseType: 'arraybuffer',
        headers: {
          "x-api-key": CONFIG.nota_fiscal.token_plugnotas
        }
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var printInvoiceReport = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/electronicinvoice/printinvoicereport?month=' + obj.month + '&year=' + obj.year,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }).catch(function (data) {
        deffered.reject(data);
      });
      return deffered.promise;
    };

    return {
      consultarlote: consultarlote,
      getAllInvoiceBatch: getAllInvoiceBatch,
      sendBillToNfse: sendBillToNfse,
      getInvoices: getInvoices,
      getListOfCompetences: getListOfCompetences,
      getBillstoNfse: getBillstoNfse,
      updateAliquotConfig: updateAliquotConfig,
      updateCompanyConfig: updateCompanyConfig,
      getCurrentCompany: getCurrentCompany,
      getAllProducts: getAllProducts,
      getListOfOptionsOperation: getListOfOptionsOperation,
      getListOfOptionsTribute: getListOfOptionsTribute,
      printNFSeSSA: printNFSeSSA,
      printNFSeSLZ: printNFSeSLZ,
      printInvoiceReport: printInvoiceReport,
      getProductGroupUsed: getProductGroupUsed,
      storeNfseByFilter: storeNfseByFilter
    };

  }

  angular
    .module('app.finance.nfse')
    .factory('NFSEService', NFSEService)

})();

(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.nfse', {
        url: '/nfse',
        public: false,
        templateUrl: 'app/finance/nfse/index.html',
        controller: 'NFSEController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'NFSE'
        }
      });
  }

  angular
    .module('app.finance.nfse')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'nf_menu';
    var path = 'finance.nfse';

    msNavigationService.saveItem('finance.nfse', {
      title: 'Nota fiscal eletrônica',
      icon: 'icon-book',
      state: 'private.finance.nfse',
      weight: 8,
      auth: role,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.nfse')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function NFSEController($filter, $mdSelect, $scope, $a4FloatButton, $rootScope, $timeout, Session, ProductService,
                          NFSEService, Common, CONFIG, ModalFactory, a4Moment, PoliciesService, EducationalService) {

    const SALVADOR = 3849;
    const SAO_LUIS = 921;
    var vm = this;
    vm.selected = [];
    vm.CONFIG = CONFIG;
    vm.currentCompany = {};
    vm.show_contents = false;
    vm.product_list = [];
    $mdSelect.disabled = true;
    vm.current_product = null;
    vm.active_first = false;
    vm.query = {order: 'due_date'};
    vm.actual_competence = {};
    vm.competence = {};
    vm.service = null;
    vm.search = '';
    vm.disabled = false;
    vm.today = a4Moment();
    vm.product_groups = [];
    vm.selected_products = null;

    vm.init = function () {
      if (vm.checkPolicies('nf_alt')) {
        vm.floatButton =
          $a4FloatButton({
            scope: $scope,
            icon: 'send',
            theme: 'finance',
            onClick: 'vm.sendData(vm.selected)',
            label: 'Enviar notas | Notas: {{vm.selected.length}} '
          });
      }
      vm.getSchoolPeriod();
      vm.getCurrentCompany()
        .then(function () {
          /** Verifica se o certificado A1 Existe */
          if (1 > 0) {
            vm.getAllProducts();
            vm.setCompetences()
              .then(function () {
                vm.getAllInvoiceBatch();
              });
          }
        });
    };
    /**
     *  Retorna o periodo letívo selecionado
     */
    vm.getSchoolPeriod = function () {
      EducationalService.getSchoolsPeriod()
        .then(function (periods) {
          vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
          vm.school_period = $filter('filter')(periods.plain().list, {id: vm.current_school_period_id})[0];
          $rootScope.show_loader = false;
        })
    };

    /**
     * Lançado quando muda paginas do grid
     * @param page - Pagina de visualização
     * @param qtd - Quantidade de registros
     */
    vm.paginateRequest = function (page, qtd) {
      $rootScope.show_loader = true;
      vm.promise = NFSEService.getBillstoNfse({
        page: page,
        qtd: qtd,
        month: vm.competence.month,
        year: vm.competence.year,
        product: vm.service == null ? (vm.selected_products == null ? undefined : vm.selected_products.join(',')) : vm.service.id,
        search: vm.search
      })
        .then(function (response) {
          vm.bill_list.data = response.data;
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Retorna todas as notas.
     * @param page - (opcional) Pagina de consulta
     * @param qtd - (opcional) Quantidade de registros
     * @param month
     * @param year
     * @param product
     * @param search
     */
    vm.getAllInvoices = function (page, qtd, month, year, product, search) {
      $rootScope.show_loader = true;
      page = (page === 101) ? 2 : page;
      month = (month === undefined) ? vm.competence.month : month;
      year = (year === undefined) ? vm.competence.year : year;
      product = (product === undefined) ? (vm.service === null ? null : vm.service.id) : product;

      vm.promiseNFSE = NFSEService.getInvoices(
        {
          search: search,
          page: page, qtd: qtd, month: month,
          year: year, product_id: product
        })
        .then(function (response) {
          vm.invoices = response;
          vm.invoices.data = response.data;
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          $rootScope.show_loader = false;
        })
    };

    vm.printInvoiceReport = function (month, year) {
      $rootScope.show_loader = true;
      NFSEService.printInvoiceReport({month: month, year: year})
        .then(function () {
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna todos os produtos/serviços
     */
    vm.getAllProducts = function (search) {
      var deferred = Common.$q.defer();
      NFSEService.getAllProducts({query: search})
        .then(function (response) {
          deferred.resolve(response.plain().data);
        })
        .catch(function (error) {
          Common.Toast.error(error.data.message || error.message);
        });

      return deferred.promise;
    };

    /**
     * Busca os dados da empresa corrente
     */
    vm.getCurrentCompany = function () {
      var deffered = Common.$q.defer();
      NFSEService.getCurrentCompany()
        .then(function (response) {
          vm.currentCompany = response;
          vm.show_contents = true;
          deffered.resolve(true);
        })
        .catch(function () {
          Common.Toast.error('Erro ao carregar companhias');
          deffered.reject(false)
        });
      return deffered.promise;
    };

    /**
     * Retorna os titulos candidatos a nota fiscal
     */
    vm.getBillstoNfse = function (month, year, product, search) {
      $rootScope.show_loader = true;
      vm.search = search;
      month = (month === undefined) ? vm.competence.month : month;
      year = (year === undefined) ? vm.competence.year : year;
      product = (product === undefined) ? (vm.service === null ? null : vm.service.id) : product;

      vm.promise = NFSEService.getBillstoNfse({month: month, year: year, product: product, qtd: 20, search: search})
        .then(function (response) {
          vm.bill_list = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao carregar títulos');
          $rootScope.show_loader = false;
        });

      return vm.promise;
    };

    /**
     * Retorna as competencias baseada nos filtros de mes / ano e produto
     */
    vm.setCompetences = function () {
      var deffered = Common.$q.defer();
      vm.competences = [];
      for (var i = 0; i <= 11; i++) {
        var date_local = a4Moment().startOf('year');
        date_local.add('month', i);
        vm.competences.push({
          competence_text: date_local.format("MMMM/YYYY"),
          month: date_local.month() + 1,
          year: date_local.year(),
          last_day: date_local.endOf('month')
        });
        /** Se for o ultimo mês do ano, aqui é adicionado o primeiro mês do proximo ano */
        if (i === 11) {
          var last_month = a4Moment().startOf('year');
          last_month.add('year', 1);
          vm.competences.push({
            competence_text: last_month.format("MMMM/YYYY"),
            month: last_month.month() + 1,
            year: last_month.year(),
            last_day: last_month.endOf('month')
          });
        }
      }
      var now = a4Moment();
      vm.competence = $filter('filter')(vm.competences, {
        month: parseInt(now.month() + 1),
        year: parseInt(now.year())
      })[0];
      vm.actual_competence = angular.copy(vm.competence);
      now = now.subtract('year', 1);
      vm.competences.unshift({
        competence_text: now.endOf('year').format("MMMM/YYYY"),
        month: now.endOf('year').month() + 1,
        year: now.year(),
        last_day: now.endOf('month')
      });
      deffered.resolve(true);
      return deffered.promise;
    };

    /**
     * Retorna todos os lotes
     */
    vm.getAllInvoiceBatch = function () {
      ModalFactory.custom('app/finance/nfse/alertTownHall.html', null, false);
      vm.promise = NFSEService.getAllInvoiceBatch()
        .then(function (response) {
          if (response != null) {
            vm.invoices_batch = response.invoices_batch;
            vm.invoices = response.invoices;
            vm.getBillstoNfse(vm.competence.month, vm.competence.year, vm.service == null ? null : vm.service.id)
              .then(function () {
                $rootScope.$broadcast('CUSTOM.close');
              });
            vm.selected = [];
            $rootScope.show_loader = false;
          }
        })
        .catch(function () {
          $timeout(function () {
            $rootScope.show_loader = false;
            $rootScope.$broadcast('CUSTOM.close');
          }, 2000);
          Common.Toast.error('Erro ao carregar lotes');
        });
    };

    /**
     * Função de envio de notas fiscais para a prefeitura.
     * @params selected - Vetor com arquivos selecionados para envio
     */
    vm.sendData = function (selected) {
      $rootScope.show_loader = true;
      var nfse_selected = angular.copy(selected);
      if (selected.length > 0) {
        vm.bill_list.data = [];
        ModalFactory.custom('app/finance/nfse/alertTownHall.html');
        vm.selected = [];
        vm.promise = NFSEService.sendBillToNfse(nfse_selected)
          .then(function (response) {
            if (response) {
              Common.Toast.success('Lote enviado com sucesso!');
              vm.getAllInvoiceBatch();
              $rootScope.show_loader = false;
              $timeout(function () {
                $rootScope.$broadcast('CUSTOM.close');
              }, 2000);
            }
          })
          .catch(function (response) {
            $timeout(function () {
              $rootScope.$broadcast('CUSTOM.close');
              $rootScope.show_loader = false;
              vm.changeListNfe(vm.competence.month, vm.competence.year, vm.products)
            }, 2000);
            Common.Toast.error(response.data.message);
          });
      } else {
        Common.Toast.warning('Selecione um lote.');
      }
    };

    /**
     * Troca a lista de titulos candidatos a nota fiscal pela data e pelo id do serviço
     */
    vm.changeListNfe = function (month, year, product_id) {
      if (angular.isDefined(product_id) && angular.isArray(product_id)) {
        var products = '';
        product_id.forEach(function (item, key) {
          products = products + (key > 0 ? (',' + item) : item);
        })
      }
      vm.getAllInvoices(1, 20, month, year, products, vm.search);
      vm.getBillstoNfse(month, year, products, vm.search);
    };

    vm.storeNfseByFilter = function (month, year, product_id) {
      $rootScope.show_loader = true;
      if (angular.isDefined(product_id) && angular.isArray(product_id)) {
        var products = '';
        product_id.forEach(function (item, key) {
          products = products + (key > 0 ? (',' + item) : item);
        })
      }
      NFSEService.storeNfseByFilter({month: month, year: year, product: products, search: vm.search})
        .then(function (response) {
          if (response) {
            Common.Toast.success('Lote enviado com sucesso!');
            vm.getAllInvoiceBatch();
            $rootScope.show_loader = false;
            $timeout(function () {
              $rootScope.$broadcast('CUSTOM.close');
            }, 2000);
          }
        })
        .catch(function (response) {
          $timeout(function () {
            $rootScope.$broadcast('CUSTOM.close');
            $rootScope.show_loader = false;
            vm.changeListNfe(vm.competence.month, vm.competence.year, vm.products)
          }, 2000);
          Common.Toast.error(response.data.message);
        });
    };

    vm.printInvoice = function (nfse) {
      if (vm.currentCompany.city_id === SAO_LUIS) {
        return NFSEService.printNFSeSLZ(nfse);
      } else {
        Common.Toast.warning('Visualização não permitida');
      }
    };


    /**
     * Retorna todos agrupamentos
     */
    vm.allProductGroups = function () {
      if (vm.product_groups.length === 0) {
        return NFSEService.getProductGroupUsed({
          month: vm.competence.month,
          year: vm.competence.year
        })
          .then(function (response) {
            vm.product_groups = response.plain();
            vm.product_groups.unshift({id: null, name: 'Nenhum'});
            $rootScope.show_loader = false;
          })
          .catch(function (error) {
            $rootScope.show_loader = false;
            Common.Toast.error(error)
          });
      } else {
        var deffered = Common.$q.defer();
        deffered.resolve(vm.product_groups);
        return deffered.promise;
      }

    };

    /**
     * Retorna os serviços associados a um grupo de serviço
     * @param group
     */
    vm.getProductsByGroup = function (group) {
      vm.products = angular.isDefined(group.children) ? group.children : [];
    };

    vm.setProducts = function (products) {
      if (angular.isUndefined(products)) {
        vm.bankslipgroup.product_ids = [];
      } else if (products[0] === null) {
        vm.products.forEach(function (item) {
          vm.bankslipgroup.product_ids.push(item.id);
        })
      }
    };


    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Destrutor de controlador;
     */
    $scope.$on('$destroy', function () {
      [].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.finance.nfse')
    .controller('NFSEController', NFSEController);

})();

(function() {
  'use strict';
  angular
    .module('app.finance.contract', [
      'app.finance.contract.modal-edit']);
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.negotiation', {
        url: '/negotiation',
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/negotiation/views/index.html',
            controller: 'NegotiationController',
            controllerAs: 'vm'
          }
        }
      })
  }

  angular
    .module('app.finance.contract')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'negotiation_menu';
    var path = 'finance.negotiation';
    msNavigationService.saveItem('finance.negotiation', {
      title: 'Negociações',
      icon: 'icon-file-document',
      state: 'private.finance.negotiation',
      weight: 20,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.check-received')
    .run(run);

})();





(function() {
  'use strict';
  angular
    .module('app.finance.negotiation', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function NegotiationController($rootScope, Common, BillReceiptService, BillExpenseService, ModalFactory, $a4FloatButton, $scope, a4Moment) {

    var vm = this;

    vm.debit_credit = 'C';
    vm.search = '';
    vm.filter_date = null;
    vm.bills = [];
    vm.includeScope = {};
    vm.bills = [];
    vm.all_bills = [];
    vm.selected_status = [];
    vm.edit_expense = null;
    vm.haveUpdate = false;
    vm.allContracts = {
      data: []
    };


    vm.init = function () {
      vm.getAllContracts(1, 15);
      vm.getCategories();
      // vm.verifyIfHaveUpdate();
    };


    /**
     * Atualiza todos os contratos
     */
    vm.updateContracts = function () {
      $rootScope.show_loader = true;
      BillReceiptService.updateContracts()
        .then(function () {
          Common.Toast.success("Contratos atualizados com sucesso");
          $rootScope.show_loader = false;
          vm.verifyIfHaveUpdate();
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Verifica se existem contratos para serem atualizados
     */
    vm.verifyIfHaveUpdate = function () {
      BillReceiptService.haveContracts()
        .then(function (response) {
          vm.haveUpdate = response;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Criação de um contrato
     */
    vm.openCreateModal = function () {
      ModalFactory.customClean('app/components/a4-contract-grid/create-contract-modal.html',
        'CreateContractController', 'vm', true, {'categories': vm.categories})
        .then(function () {
          vm.getAllContracts(1, 15);
        });
    };

    vm.getAllContracts = function (page, qtd, search_name) {
      $rootScope.show_loader = true;
      vm.promise = BillReceiptService.getAllContracts({
        'debit_credit': vm.debit_credit,
        page: page,
        qtd: qtd,
        search_name: search_name
      })
        .then(function (response) {
          if (angular.isDefined(response.data)) {
            vm.allContracts = response.plain();
          } else {
            vm.allContracts.data = response;
          }
          /**
           * Verificação da data final, para verificar se o contrato está cancelado
           */
          for (var i = vm.allContracts.data.length; i--;) {
            if (vm.allContracts.data[i].date_end !== null && a4Moment(vm.allContracts.data[i].date_end).isBefore(a4Moment())) {
              vm.allContracts.data[i].is_date_end_before_today = true;
            } else {
              vm.allContracts.data[i].is_date_end_before_today = false;
            }
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.defineType = function (item) {
      if (item.portion_amount == null) {
        return "Recorrência";
      } else {
        return "Parcelamento";
      }
    };

    vm.defineAmount = function (item) {
      if (item.portion_amount == null) {
        return item.recurrence_amount;
      } else {
        return item.portion_amount;
      }
    };

    vm.defineFrequency = function (item) {
      switch (item.frequency) {
        case 0:
          return "Título parcelado";
        case 1:
          return "A cada " + item.frequency_qty + " dia(s)";
        case 2:
          return "A cada " + item.frequency_qty + " mês(es)";
        case 3:
          return "A cada " + item.frequency_qty + "ano(s)";
        case 20:
          return "Datas irregulares";
        case 30:
          return "Sob demanda";
      }
    };

    vm.getCategories = function () {
      BillExpenseService.getCategories(vm.debit_credit)
        .then(function (response) {
          if (response) {
            vm.categories = response;
            $rootScope.show_loader = false;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista.');
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor.');
          break;
      }
    };

    vm.init();
  }

  angular
    .module('app.finance.negotiation')
    .controller('NegotiationController', NegotiationController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function ContractService(Restangular) {

    var getServices = function (obj) {
      return Restangular.one('contract').one('getservices').get(obj);
    };
    var create = function (obj) {
      return Restangular.all('contract').post(obj);
    };

    var getById = function (bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).get();
    };

    var update = function (obj, bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).put(obj);
    };

    var changePlanCheck = function (bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).one('changecheck').get();
    };

    var changePaymentPlan = function (obj, bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).all('changepaymentplan').post(obj);
    };

    var cancelContract = function (obj) {
      return Restangular.one('contract').all('cancelcontract').post(obj);
    };

    var undoCancelContract = function (obj) {
        return Restangular.one('contract').all('undocancelcontract').post(obj);
    };

    var deleteContract = function (obj) {
      return Restangular.one('contract').all('deletecontract').post(obj);
    };

    var addInstallment = function (obj) {
      return Restangular.one('contract').all('addinstallment').post(obj);
    };

    var getNextDueDate = function (bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).one('getnextduedate').get();
    };

    return {
      getServices: getServices,
      create: create,
      cancelContract: cancelContract,
      update: update,
      getNextDueDate: getNextDueDate,
      getById: getById,
      changePlanCheck: changePlanCheck,
      changePaymentPlan: changePaymentPlan,
      deleteContract: deleteContract,
      addInstallment: addInstallment,
      undoCancelContract: undoCancelContract
    }
  }

  angular.module('app.finance.contract')
    .factory('ContractService', ContractService)
})();
(function() {
  'use strict';
  angular
    .module('app.finance.main', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  function MainController() {

  }

  angular
    .module('app.finance.main')
    .controller('MainController', MainController);

})();

(function () {
  'use strict';

  angular.module('app.individual-discounts', [])

})();
(function () {
  'use strict';

  function IndividualDiscountsService(Restangular) {

    return {

      getDiscountsReasons: function (obj) {
        return Restangular.one('discountreason').get(obj);
      },
      getUsersEnteredDiscount: function (obj) {
        return Restangular.all('individualdiscount').one('getusersentereddiscount').get(obj);
      },
      getSuggestion: function (obj) {
        return Restangular.all('individualdiscount').one('getsuggestion').get(obj);
      },
      getBehaviors: function (obj) {
        return Restangular.all('individualdiscount').one('getbehaviors').get(obj);
      },
      /**
       * Criação de novo desconto individual
       */
      create: function (obj) {
        return Restangular.all("individualdiscount").post(obj);
      },
      update: function (obj) {
        return Restangular.one('individualdiscount').all('updatediscount').post(obj);

      }

    }

  }

  angular.module('app.individual-discounts')
    .factory('IndividualDiscountsService', IndividualDiscountsService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function IndividualDiscountsController($rootScope, IndividualDiscountsService, $timeout, Common, ModalExtra) {
    var vm = this;
    vm.data = {
      value_type: 1,
      start_date: null,
      end_date: null,
      amount: 0,
      is_fixed: 1
    };

    vm.init = function () {
      vm.theme = ModalExtra.theme;
      $timeout(function () {
        vm.getDiscountsReasons();
      }, 1000);
    };

    /**
     * Retorna todas as razões de desconto
     */
    vm.getDiscountsReasons = function () {
      IndividualDiscountsService.getDiscountsReasons()
        .then(function (reasons) {
          vm.reasons = reasons.plain();
        })
    };

    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    /**
     * Modifica campos ao checkar ou deschecar o checkbox de vigência
     */
    vm.changeFields = function (is_checked) {
      if (!is_checked) {
        vm.data.start_date = "";
        vm.data.end_date = "";
      }
    };

    /**
     * Criar novo desconto individual na tabela em criação de receita financeira
     */
    vm.submit = function (form) {
      if (form.$valid) {
        if (vm.data.value_type === 1) {
          if (vm.data.amount > 100) {
            Common.Toast.warning("A porcetagem máxima é de 100.00% ");
            return;
          }
        }
        if ((vm.data.start_date !== null && vm.data.start_date !== "") && (vm.data.end_date !== null && vm.data.end_date !== "")) {
          if (vm.data.end_date.diff(vm.data.start_date, 'day') <= 0) {
            Common.Toast.warning("Data final deve ser superior a inicial");
            return;
          }
        }

        if (vm.data.start_date !== null && vm.data.start_date !== "") {
          vm.data.start_date = vm.data.start_date.format('YYYY-MM-DD');
        }
        if (vm.data.end_date !== null && vm.data.end_date !== "") {
          vm.data.end_date = vm.data.end_date.format('YYYY-MM-DD');
        }
        vm.close(vm.data);
      }
    };

    vm.init();
  }

  angular.module('app.individual-discounts')
    .controller('IndividualDiscountsController', IndividualDiscountsController)

})();
(function () {
  'use strict';

  angular.module('app.finance.external-financial-statement', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('public.external-financial-statement', {
        url: '/finance/external-financial-statement/:token',
        public: true,
        controller: 'ExternalFinancialStatementController',
        controllerAs: 'vm',
        templateUrl: 'app/finance/external-financial-statement/views/index.html'

      });

  }

  angular
    .module('app.finance.external-financial-statement')
    .config(routerConfig);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ExternalFinancialStatementController(
    $document,
    $scope,
    $stateParams,
    $rootScope,
    ReportsService,
    a4Moment,
    A4BankSlipService,
    BankSlipService,
    Utils,
    CONFIG,
    Common,
    LoginService,
    Session,
    PersonService
  ) {

    var vm = this;
    vm.token = $stateParams.token;
    vm.current_page = 0;
    vm.show_paids = false;
    vm.bank_slips = [];
    vm.A4_PAG_CURRENT_ACCOUNT_TYPE = 8;
    vm.windowHeight = angular.element("body").height();
    vm.windowWidth = angular.element("body").width();
    vm.url_background = 'url(../assets/images/backgrounds/' + new Date().toLocaleString('en-US', {'month': 'long'}).toLowerCase() + '.jpg)';
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.cpfFormWidth = 30;
    vm.cpf = null;
    vm.bank_slips = [];
    vm.loading = false;
    vm.show_button = true;
    vm.data = {
      person_id: null,
      person_name: null,
      cpf: null,
      company_name: null,
      company_id: null,
      texto_reajuste: null
    };
    vm.last_year = a4Moment().subtract(1, 'year').format('YYYY');
    vm.subdomain = $document[0].domain.split('.')[0];
    vm.NOT_CANCELED = 0;
    vm.CANCELED_PENDING_SEND_FILE = 1;
    vm.CANCELED_NOT_PENDING_SEND_FILE = 2;

    vm.webLink = CONFIG.webApiUri + 'api/bankslip/generate/print';
    vm.webLink_register = CONFIG.webApiUri + 'api/bankslip/register';
    vm.cpf_verify = false;


    var ln = $(window).resize(function () {
      vm.windowHeight = angular.element("body").height();
      vm.windowWidth = angular.element("body").width();
      if (vm.windowWidth < 1000) {
        vm.cpfFormWidth = 100;
      }
      $scope.$applyAsync();
    });

    /**
     * Formata a string de beneficiarios do boleto
     * @param beneficiaries
     */
    vm.formatBeneficiaries = function (beneficiaries) {
      return angular.fromJson(beneficiaries.replace('{', '[').replace('}', ']'));
    };

    /**
     * Formata a string de beneficiarios do boleto
     * @param services
     */
    vm.formatServices = function (services) {
      return angular.fromJson(services.replace('{', '[').replace('}', ']'));
    };

    /**
     * Remove aspas das strings
     * @param name
     * @returns {*}
     */
    vm.formatName = function (name) {
      return Utils.removeDoubleQuotes(name);
    };


    vm.getBankSlips = function () {
      $rootScope.show_loader = true;
      vm.loading = true;
      vm.current_page++;
      BankSlipService.getBankSlipsForExternalFinancialStatement(
        {
          person_id: vm.data.person_id,
          company_id: vm.data.company_id,
          page: vm.current_page,
          show_paids: vm.show_paids
        }
      ).then(function (response) {
        var bank_slips = response.plain();
        var array = Array.from(bank_slips.data);
        if (array.length === 0) {
          vm.show_button = false;
        }
        vm.bank_slips = vm.bank_slips.concat(array);
        vm.cpf_verify = true;
        vm.loading = false;
        $rootScope.show_loader = false
      })
    };

    vm.verifyCpf = function () {
      if (vm.cpf === vm.data.cpf) {
        vm.loading = true;
        vm.getBankSlips();
      } else {
        Common.Toast.error('CPF incorreto');
      }
    };

    vm.allowGenerateBankSlip = function (bank_slip) {
      return ((bank_slip.bank_number == null
        && bank_slip.current_account_type_id === vm.A4_PAG_CURRENT_ACCOUNT_TYPE
        && (bank_slip.number === 1 || vm.subdomain === 'a4tecnologia')) ||
        (bank_slip.bank_number != null
          && ((bank_slip.bank_slip_cancel_status_id === vm.NOT_CANCELED)
            && bank_slip.bank_slip_status_id < 4)) && bank_slip.paid_bill_id == null);
    };

    /**
     * Registra boleto no A4 PAg
     * @param option - se é para gerar pdf ou linha digitável
     * @param due_date
     * @param bill_ids
     * @param bank_slip_id
     * @param person_id
     * @returns {*}
     */
    vm.getBankSlipA4Pag = function (option, due_date, bill_ids, bank_slip_id, person_id) {
      vm.loading = true;
      A4BankSlipService.getBankSlipA4Pag(option, due_date, bill_ids, bank_slip_id, person_id)
        .then(function () {
          vm.loading = false;
          vm.getBankSlips();
        })
        .catch(function (error) {
          vm.loading = false;
          Common.Toast.warning(error.message);
        })
    };

    vm.reload = function () {
      vm.show_button = true;
      vm.current_page = 0;
      vm.bank_slips = [];
      vm.getBankSlips();
    };

    vm.init = function () {
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      if (vm.windowWidth < 1000) {
        vm.cpfFormWidth = 100;
      }
      vm.loading = true;
      vm.getLogo();
      PersonService.returnInformationsByToken({token: vm.token})
        .then(function (response) {
          vm.data = response.plain();
          // ReportsService.getToken()
          //   .then(function (token) {
          //     vm.conf.token = token;
          //   });
          vm.loading = false;
        });
    };

    vm.getLogo = function () {
      var subdomain = $document[0].domain.split('.')[0];
      LoginService.getLogo(subdomain)
        .then(function (response) {
          vm.screen_image = response.image;
        })
    };

    vm.generateIncomeTaxReport = function () {
      var href = CONFIG.webApiUri + 'api/reports/incometaxreport?current_school_period=' +
        vm.data.school_period_id_on_last_year + '&company=' + vm.data.company_id + '&connection=' + vm.conf.current_connection +
        '&person_id=' + vm.data.person_id + '&user_id=' + vm.data.person_id + '&year=' + vm.last_year;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.init();

  }

  angular.module('app.finance.external-financial-statement')
    .controller('ExternalFinancialStatementController', ExternalFinancialStatementController);
})();

(function () {
  'use strict';

  angular
    .module('app.finance.discounts-reason', []);

})();
(function () {
  'use strict'

  /** @ngInject */
  function DiscountsReasonService(Restangular) {

    var vm = this;

    vm.getAll = function () {
      return Restangular.one('discountreason').get();
    };

    vm.create = function (obj) {
      return Restangular.all('discountreason').post(obj);
    };

    vm.deleteDiscountReason = function (id) {
      return Restangular.one('discountreason', id).remove();

    };

    vm.updateDiscountReason = function (obj) {

      return Restangular.one('discountreason', obj.id).customPUT(obj);

    }

    return vm;
  }

  angular
    .module('app.finance.discounts-reason')
    .factory('DiscountsReasonService', DiscountsReasonService)
})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.discounts-reason', {
        url: '/settings/discounts-reason',
        public: false,
        templateUrl: 'app/finance/discounts-reason/views/index.html',
        controller: 'DiscountsReasonController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Motivos de Descontos'
        }
      });
  }

  angular
    .module('app.finance.discounts')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function DiscountsReasonController($scope, $a4FloatButton, $mdDialog, ModalFactory, Common, DiscountsService, $rootScope,
                                     DiscountsReasonService) {

    var vm = this;
    var discount_validation = [];
    vm.discountRule = {};

    vm.items = [];
    vm.grid = [];

    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      $rootScope.show_loader = true;
      vm.getAllDiscountsReason();
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.createReason()', label: 'Criar novo motivo', theme: 'finance'
      });
    };

    vm.createReason = function () {
      ModalFactory.prompt(
        null,
        'Novo motivo',
        'Digite abaixo o motivo do desconto',
        '',
        '',
        'Salvar',
        'Cancelar',
        'finance')
        .then(function (reason) {
          vm.create(reason);
        });
    };

    vm.create = function (reason) {
      DiscountsReasonService.create({name: reason})
        .then(function () {
          Common.Toast.success('Motivo salvo com sucesso');
          vm.getAllDiscountsReason();

        })
        .catch(function () {
          Common.Toast.error('Erro ao salvar')
        })
    };

    vm.delete = function(id){
      var confirm = $mdDialog.confirm()
        .title('Remoção de motivo de desconto')
        .textContent('Deseja realmente remover este motivo?')
        .ariaLabel('remover motivo de desconto')
        .ok('Por favor, sim!')
        .cancel('Ainda não!');

      $mdDialog.show(confirm).then(function () {

        DiscountsReasonService.deleteDiscountReason(id)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success("Motivo de desconto removido com sucesso!");
            vm.getAllDiscountsReason();
          })
          .catch(function (error) {
            $rootScope.show_loader = false;
            Common.Toast.error(error.data)
          })

      });

    };

    vm.editReason = function(item){

      ModalFactory.prompt(
        null,
        'Editar motivo',
        'Digite o motivo do desconto',
        '',
        item.name,
        'Salvar',
        'Cancelar',
        'finance')
        .then(function (reason) {
          DiscountsReasonService.updateDiscountReason({name: reason, id: item.id})
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success("Motivo de desconto atualizado com sucesso!");
              vm.getAllDiscountsReason();
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.error(error.data);

            })

        });
    };

    /**
     * Retorna todos os motivos de desconto.
     * @returns {reason}
     */
    vm.getAllDiscountsReason = function () {
      DiscountsReasonService.getAll()
        .then(function (response) {
          if (response) {
            vm.items = response;
            vm.grid.rows = response.plain();
            $rootScope.show_loader = false;
          }
        });
    };

    vm.init();
  }


  angular
    .module('app.finance.discounts-reason')
    .controller('DiscountsReasonController', DiscountsReasonController);

})();

(function () {
  'use strict'

    /** @ngInject */
  function DiscountsService(Restangular) {

    /**
     * Retorna da API todas as regras de ajuste.
     */
    var getAllDiscountsRules = function () {
      return Restangular.all('discountRoles/getAll').getList();
    };

      /**
       * Retorna da API todas as regras de acrecimos.
       */
      var getAllAdditionsRules = function () {
        return Restangular.all('finesrule/getAll').getList();
      };

    /**
     * Retorna da API todas as regras de ajuste.
     */
    var getOne = function (id) {
      return Restangular.one('/discountRoles/' + id + '/edit').getList();
    };

    /**
     * Faz requisição para criação da regra de ajuste.
     */
    var createDiscounts = function(obj){
      return Restangular.one('discountRoles').customPOST(obj);

    };

    /**
     * Faz requisição para atualização da regra de ajuste.
     */
    var updateDiscounts = function(obj){
      return Restangular.one('discountRoles', obj.id).customPUT(obj);

    };

    return {
      getAllDiscountsRules: getAllDiscountsRules,
      getAllAdditionsRules: getAllAdditionsRules,
      getOne: getOne,
      createDiscounts: createDiscounts,
      updateDiscounts: updateDiscounts
    }

  }

  angular
    .module('app.finance.discounts')
    .factory('DiscountsService', DiscountsService)

})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.discounts', {
        url: '/settings/discounts',
        public: false,
        templateUrl: 'app/finance/discounts/views/index.html',
        controller: 'DiscountsController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Regras de Descontos'
        }
      });
  }

  angular
    .module('app.finance.discounts')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function DiscountsController($rootScope, $scope, $state, $a4Sidenav, Common, DiscountsService) {

    var vm = this;
    var discount_validation = [];
    vm.discountRule = {};

    vm.items = [];

    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      vm.getAllDiscountsRules();

      vm.includeScope = {
        item: null,
        topSmall: true,
        currentItem: vm.currentItem,
        submitDiscounts: vm.submitDiscounts,
        creatediscountRole: vm.creatediscountRole,
        checkAnticipation: vm.checkAnticipation
      };

      vm.includeScope = {};
      vm.includeScope.templateSrc = 'app/finance/discounts/views/forms/form-discounts.html';
      vm.includeScope.controller = 'DiscountsController';
      vm.includeScope.controllerAs = 'vm';
      vm.includeScope.itemName = 'discountRule';

      vm.discountRule = {
        format: 0,
        type_form: 'create',
        type: 'f',
        is_inactive: false
      };

    };

    /**
     * Realiza fechamento do serviço da sidenav
     */
    vm.close = function () {
      $a4Sidenav().close();
    };


    /**
     * Retorna todas as regras de descontos.
     * @returns {response}
     */
    vm.getAllDiscountsRules = function () {
      DiscountsService.getAllDiscountsRules()
        .then(function (response) {
          if (response) {
            vm.items = response;
            $rootScope.show_loader = false;
          }
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Abre a sidebar para criação.
     */
    vm.openAside = function () {
      $a4Sidenav({width: '700px'}).open(
        'app/finance/discounts/views/forms/form-discounts.html',
        'DiscountsController',
        'vm',
        {}
      );
    };

    /**
     * Ouvinte para mudança de validade do desconto
     */
    $scope.$watch('role', function () {
      if (vm.role != null) {
        if (vm.role.type == 'f' ||
          vm.role.type == 'p' ||
          vm.role.type && vm.role.format == 1) {

          vm.role.is_over_main_value = false;

        } else if (vm.role.type == 'c') {

          vm.role.is_over_main_value = true;

        }
      }
    }, true);

    var round = function (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    };

    /**
     * Validacao dos descontos
     * @param val1
     * @param val2
     * @param grp
     * @param id
     * @returns {boolean}
     */
    vm.validateValue = function (val1, val2, grp, id) {
      if (val1 != null && val2 != null) {
        val1 = round(parseFloat(val1).toFixed(4), 2);
        val2 = round(parseFloat(val2).toFixed(4), 2);
        var result = val1 != 0 && val2 != 0 ? val2 <= val1 : false;
        return vm.checkIsValidDiscount(result, grp, id);
      }
    };

    /**
     * Checa a validacao para os descontos
     * @param result
     * @param grp
     * @param id
     * @returns {boolean}
     */
    vm.checkIsValidDiscount = function (result, grp, id) {

      discount_validation[grp] = discount_validation[grp] == null ? [] : discount_validation[grp];

      if (result) {
        discount_validation[grp][id] = true;
      } else {
        discount_validation[grp][id] = false;
      }

      return discount_validation[grp][id];

    };


    vm.creatediscountRole = function (obj) {

      if (parseInt(obj.validity_days_1) < parseInt(obj.validity_days_2)) {
        Common.Toast.error('Valor de dias do segundo deve ser menor que o primeiro');
        return false;
      }

      if (parseInt(obj.validity_days_2) < parseInt(obj.validity_days_3)) {
        Common.Toast.error('Valor de dias do terceiro deve ser menor que o segundo');
        return false;
      }

      if ((obj.type == 'p' && vm.isValidAllDiscounts()) || obj.type == 'f' || obj.type == 'c') {
        if (obj.name != "" && obj.name != undefined) {
          if (obj.value_percent_1 != "" && obj.value_percent_1 != undefined) {
            obj.validity_days_2 == "" ? obj.validity_days_2 = null : obj.validity_days_2 = obj.validity_days_2;
            obj.validity_days_3 == "" ? obj.validity_days_3 = null : obj.validity_days_3 = obj.validity_days_3;
            obj.value_percent_2 == "" ? obj.value_percent_2 = null : obj.value_percent_2 = obj.value_percent_2;
            obj.value_percent_3 == "" ? obj.value_percent_3 = null : obj.value_percent_3 = obj.value_percent_3;
            if (obj.type == 'f' || obj.type == 'c') {


              vm.submitDiscounts(obj);
            } else {
              if (obj.validity_days_1 != "" && obj.validity_days_1 != undefined) {
                vm.submitDiscounts(obj);
              } else {
                Common.Toast.error("Adicione os dias de antecipação");
              }
            }

          } else {
            Common.Toast.error("Adicione um valor para o Desconto");
          }
        } else {
          Common.Toast.error('Nome é obrigatório');
        }
      } else {
        Common.Toast.error('O valor do desconto opcional deve ser menor que o desconto anterior');
      }
    };


    vm.updatediscountRole = function (obj) {

      if (parseInt(obj.validity_days_1) < parseInt(obj.validity_days_2)) {
        Common.Toast.error('Valor de dias do segundo deve ser menor que o primeiro');
        return false;
      }

      if (parseInt(obj.validity_days_2) < parseInt(obj.validity_days_3)) {
        Common.Toast.error('Valor de dias do terceiro deve ser menor que o segundo');
        return false;
      }

      if (obj.name != "" && obj.name != undefined) {
        if (obj.value_percent_1 != "" && obj.value_percent_1 != undefined) {
          obj.validity_days_2 == "" ? obj.validity_days_2 = null : obj.validity_days_2 = obj.validity_days_2;
          obj.validity_days_3 == "" ? obj.validity_days_3 = null : obj.validity_days_3 = obj.validity_days_3;
          obj.value_percent_2 == "" ? obj.value_percent_2 = null : obj.value_percent_2 = obj.value_percent_2;
          obj.value_percent_3 == "" ? obj.value_percent_3 = null : obj.value_percent_3 = obj.value_percent_3;
          if (obj.type == 'p' || obj.type == 'c') {
            vm.submitDiscounts(obj);
          } else {
            if (obj.validity_days_1 !== "" && angular.isDefined(obj.validity_days_1)) {
              vm.submitDiscounts(obj);
            } else {
              Common.Toast.error("Adicione os dias de antecipação");
            }
          }

        } else {
          Common.Toast.error("Adicione um valor para o Desconto");
        }
      } else {
        Common.Toast.error('Nome é obrigatório');
      }
    };

    vm.checkAnticipation = function (value1, value2, value3, form) {
      if (parseInt(value1) < parseInt(value2)) {
        Common.Toast.error('Valor de dias do segundo deve ser menor que o primeiro');
        form.$valid = false;
        return false;
      }

      if (parseInt(value2) < parseInt(value3)) {
        Common.Toast.error('Valor de dias do terceiro deve ser menor que o segundo');
        form.$valid = false;
        return false;
      }
      form.$valid = true;
      return true;
    };


    /**
     * Checa se todos os descontos são validos para o submit
     * @returns {boolean}
     */
    vm.isValidAllDiscounts = function () {
      var result = true;
      angular.forEach(discount_validation, function (item) {
        angular.forEach(item, function (subitem) {
          if (result && subitem) {
            result = false;
          }
        });
      });
      return result;
    };

    /**
     * Submit do formulario de acordo com o tipo
     * edit ou create.
     * @returns {void}
     * @param obj
     */
    vm.submitDiscount = function (obj) {
      if (obj.id == null) {
        DiscountsService.createDiscounts(obj)
          .then(function () {
            $state.go($state.current, {}, {reload: true});
            $a4Sidenav().close();
            Common.Toast.success('Regra criada com sucesso')
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });

      } else {

        DiscountsService.updateDiscounts(obj)
          .then(function () {
            $state.go($state.current, {}, {reload: true});
            $a4Sidenav().close();
            Common.Toast.success('Regra atualizada com sucesso')
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });

      }

    };

    vm.init();

  }


  angular
    .module('app.finance.discounts')
    .controller('DiscountsController', DiscountsController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function DifferenceAnalysisService(Restangular) {
    var vm = {};

    /** Status das diferenças */
    vm.getStatus = function () {
      return [
        {id: 'Todos', name: 'Todos'},
        {id: 'Pendente', name: 'Pendente'},
        {id: 'Dispensada', name: 'Dispensada'},
        {id: 'Resolvida', name: 'Resolvida'},
        {id: 'Em título', name: 'Em título'},
        {id: 'Em boleto', name: 'Em boleto'}
      ]
    };

    vm.getAllDifferences = function (obj) {
      return Restangular.one("differenceanalysis").get(obj);
    };

    vm.dismissDifference = function (obj) {
      return Restangular.one('differenceanalysis').all('dismissdifference').post(obj);
    };

    vm.createAllDifferenceBill = function (obj) {
      return Restangular.one('differenceanalysis').all('createalldifferencebill').post(obj);
    };

    vm.checkFutureBankSlipForDifference = function (obj) {
      return Restangular.one('differenceanalysis').one('checkfuturebankslipfordifference').get(obj);
    };

    vm.refreshAmount = function (obj) {
      return Restangular.one('differenceanalysis').one('refreshamount').get(obj);
    };

    return vm;
  }

  angular.module('app.finance.difference-analysis')
    .factory('DifferenceAnalysisService', DifferenceAnalysisService);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.difference-analysis', {
        url: '/difference-analysis',
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/difference-analysis/views/index.html',
            controller: 'DifferenceAnalysisController',
            controllerAs: 'vm'
          }
        }
      })
  }

  angular
    .module('app.finance.difference-analysis')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function DifferenceAnalysisController($a4FloatButton, $rootScope, $scope, Common, BillReceiptService, $filter,
                                        DifferenceAnalysisService, ModalFactory, PersonService, BillGridService) {
    var vm = this;

    vm.debit_credit = 'C';
    vm.filter_due_date = {
      startDate: null,
      endDate: null
    };
    vm.filter_settlement_date = {
      startDate: null,
      endDate: null
    };
    vm.filter_status = 'Pendente';
    vm.allDifferences = {
      data: []
    };
    vm.filter_person = null;
    vm.searchText = '';

    vm.init = function () {
      vm.getAllDifferences(1, 10);
      vm.getStatus();
    };

    /**
     * Retorna a lista das diferenças de acordo com o filtro
     * @param page
     * @param limit
     */
    vm.getAllDifferences = function (page, limit) {
      $rootScope.show_loader = true;
      var filters = {
        due_date_start: vm.filter_due_date.startDate,
        due_date_end: vm.filter_due_date.endDate,
        settlement_date_start: vm.filter_settlement_date.startDate,
        settlement_date_end: vm.filter_settlement_date.endDate,
        status: vm.filter_status,
        person_id: vm.filter_person == null ? null : vm.filter_person.id,
        page: angular.isUndefined(page) ? 1 : page,
        limit: angular.isUndefined(limit) ? 10 : limit
      };
      vm.promise = DifferenceAnalysisService.getAllDifferences(filters)
        .then(function (response) {
          vm.allDifferences = response.plain();
          $scope.$applyAsync();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Cria um título de diferença para um responsável
     * @param item
     */
    vm.createOneDifference = function (item, due_date_start, due_date_end, settlement_date_start, settlement_date_end) {
      ModalFactory.customClean('app/finance/difference-analysis/views/confirm-modal.html',
        'DifferenceAnalysisCreateController', 'vm',
        false, {
          due_date_start: due_date_start,
          due_date_end: due_date_end,
          settlement_date_start: settlement_date_start,
          settlement_date_end: settlement_date_end,
          person_id_filter: vm.filter_person == null ? item.person_id : vm.filter_person.id,
          final_difference_value: item.final_difference_value
        })
        .then(function (response) {
          $rootScope.show_loader = true;
          BillReceiptService.createDifferenceBill({
            amount: response.final_difference_value,
            person_id: item.person_id,
            difference_due_date: response.difference_due_date,
            associate_to_bank_slip: response.associate_to_bank_slip,
            bill_serie_id_bank_slip: response.bill_serie_id_bank_slip,
            due_date_bank_slip: response.due_date_bank_slip,
            bank_slip_rule_id: response.bank_slip_rule_id,
            fines_rule_id: response.fines_rule_id,
            due_date_start: vm.filter_due_date.startDate,
            due_date_end: vm.filter_due_date.endDate,
            settlement_date_start: vm.filter_settlement_date.startDate,
            settlement_date_end: vm.filter_settlement_date.endDate,
            status: vm.filter_status,
            person_id_filter: vm.filter_person == null ? null : vm.filter_person.id,
          }).then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Título criado com sucesso');
            vm.getAllDifferences();
          }).catch(function (response) {
            $rootScope.show_loader = false;
            if (response.data[1] === 'DONT_HAVE_BILLS_WITHOUT_BANK_SLIP_OR_WITH_BANK_SLIP_RULE') {
              Common.Toast.error('Não é possível agrupar essa diferença, pois todos os títulos já possuem boletos gerados. ' +
                'Você deverá definir uma data de vencimento para este título e gerar um boleto exclusivamente para essa diferença ou recebê-la via caixa.');
            } else {
              Common.Toast.error('Erro ao criar título');
            }
          })
        });
    };

    /**
     * Não irá existir a opção por enquanto
     * Cria todas as diferenças de acordo com o filtro
     */
    // vm.createAllDifferences = function(){
    //   ModalFactory.customClean('app/finance/difference-analysis/views/confirm-modal.html',
    //     /** @ngInject */
    //     function ($mdDialog) {
    //       var vm = this;
    //       vm.difference_due_date = null;
    //
    //       vm.submit = function () {
    //         $mdDialog.hide({difference_due_date: vm.difference_due_date});
    //       };
    //       vm.close = function () {
    //         $mdDialog.cancel();
    //       };
    //     }, 'vm',
    //     false, {})
    //     .then(function (response) {
    //       $rootScope.show_loader = true;
    //       DifferenceAnalysisService.createAllDifferenceBill({
    //         difference_due_date: response.difference_due_date,
    //         due_date_start: vm.filter_due_date.startDate,
    //         due_date_end: vm.filter_due_date.endDate,
    //         settlement_date_start: vm.filter_settlement_date.startDate,
    //         settlement_date_end: vm.filter_settlement_date.endDate,
    //         status: vm.filter_status,
    //       }).then(function () {
    //         $rootScope.show_loader = false;
    //         Common.Toast.success('Título criado com sucesso');
    //         vm.getAllDifferences();
    //       }).catch(function () {
    //         $rootScope.show_loader = false;
    //         Common.Toast.error('Erro ao criar título');
    //       })
    //     });
    // };

    /**
     * Dispensa ou desfaz a dispensa de uma diferença
     * @param item - item a ser dispensado
     * @param parent - todos os títulos do responsável
     */
    vm.dismissDifference = function (item, parent) {
      $rootScope.show_loader = true;
      DifferenceAnalysisService.dismissDifference({bill_id: item.bill_id})
        .then(function () {
          /** Atualiza dados do item para corresponder ao salvo no banco */
          item.status = item.is_difference_exempted ? 'Pendente' : 'Dispensada';
          item.is_difference_exempted = !item.is_difference_exempted;
          vm.updateTotals(parent, item.person_id_beneficiary, item.person_id);
          $rootScope.show_loader = false;
          Common.Toast.success('Ação realizada com sucesso');
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao realizar ação');
        });
    };

    /**
     * Atualiza os totais após a dispensa de uma diferença
     * @param items - todos os títulos do responsável
     * @param person_id_beneficiary - id do beneficiário
     * @param person_id - id do responsável
     */
    vm.updateTotals = function (items, person_id_beneficiary, person_id) {
      /** Títulos do Beneficiário*/
      var bills_beneficiary = $filter('filter')(items, {
        person_id_beneficiary: person_id_beneficiary,
        level: 3,
        is_difference_exempted: false
      });
      var total_beneficiary = {
        'difference': $filter('sumByKey')(bills_beneficiary, 'difference'),
        'final_difference_value': $filter('sumByKey')(bills_beneficiary, 'final_difference_value')
      };
      $filter('filter')(items, {
        person_id_beneficiary: person_id_beneficiary,
        level: 2
      })[0].difference = total_beneficiary.difference;
      $filter('filter')(items, {
        person_id_beneficiary: person_id_beneficiary,
        level: 2
      })[0].final_difference_value = total_beneficiary.final_difference_value;
      /** Títulos do Responsável */
      var bills_parent = $filter('filter')(items, {person_id: person_id, level: 3, is_difference_exempted: false});
      var total_parent = {
        'difference': $filter('sumByKey')(bills_parent, 'difference'),
        'final_difference_value': $filter('sumByKey')(bills_parent, 'final_difference_value')
      };
      $filter('filter')(items, {person_id: person_id, level: 1})[0].difference = total_parent.difference;
      $filter('filter')(items, {
        person_id: person_id,
        level: 1
      })[0].final_difference_value = total_parent.final_difference_value;
    };

    /**
     * Retorna o detalhamento do titulo
     * @param bill_id - Identificador do titulo
     */
    vm.getDetailsFromBill = function (bill_id) {
      BillGridService.openDetailsModal(bill_id);
    };

    /**
     * Consulta para realizar a filtragem da lista a partir da pesquisa por nome
     * @param query
     */
    vm.getPersons = function (query) {
      return PersonService.getAllPersons({query: query, role: vm.selected_tab, paginate: false});
    };

    /**
     * Limpa todos os filtros
     */
    vm.clearFilters = function () {
      vm.filter_due_date = {
        startDate: null,
        endDate: null
      };
      vm.filter_settlement_date = {
        startDate: null,
        endDate: null
      };
      vm.filter_status = 'Pendente';
      vm.filter_person = null;
    };

    /** Lista de status */
    vm.getStatus = function () {
      vm.all_status = DifferenceAnalysisService.getStatus();
    };

    vm.init();
  }

  angular
    .module('app.finance.difference-analysis')
    .controller('DifferenceAnalysisController', DifferenceAnalysisController)
    .filter('sumByKey', function () {
      /** Filtro para somar os valores de uma determinada chave de todos os itens do array */
      return function (array, key) {
        if (typeof (array) === 'undefined' || typeof (key) === 'undefined') {
          return 0;
        }
        var sum = 0;
        for (var i = array.length - 1; i >= 0; i--) {
          sum += parseFloat(array[i][key]);
        }
        return sum;
      };
    });
})();

(function () {
  /** @ngInject */
  function DifferenceAnalysisCreateController($mdDialog, a4Moment, DifferenceAnalysisService, $rootScope, ModalExtra) {
    var vm = this;
    vm.difference_due_date = a4Moment();
    vm.associate_to_bank_slip = 0;
    vm.value = ModalExtra.final_difference_value;
    vm.canAssociateToBankSlip = true;
    vm.bill_serie_id_bank_slip = null;
    vm.due_date_bank_slip = null;
    vm.bank_slip_rule_id = null;
    vm.fines_rule_id = null;
    vm.unable_button = true;

    vm.init = function () {
      vm.data = ModalExtra;
      DifferenceAnalysisService.checkFutureBankSlipForDifference({person_id: vm.data.person_id_filter})
        .then(function (response) {
          if (!response.bill || response.bill === 'false') {
            vm.canAssociateToBankSlip = false;
            vm.associate_to_bank_slip = 1;
          } else {
            var object = response.bill;
            vm.bill_serie_id_bank_slip = object.bill_serie_id;
            vm.due_date_bank_slip = object.due_date;
            vm.formated_due_date = a4Moment(vm.due_date_bank_slip).format('DD/MM/YYYY');
            vm.canAssociateToBankSlip = true;
            vm.refreshAmount(vm.due_date_bank_slip);
          }
          vm.bank_slip_rules = response.bank_slip_rules;
          vm.fines_rules = response.fines_rules;
          vm.unable_button = false;
        })
    };

    vm.clearBankSlipRule = function (validator) {
      if (validator) {
        vm.bank_slip_rule_id = null;
      }
    };

    /**
     * Atualiza valor do título de diferença a ser criado de acordo com
     * as datas de vencimento do futuro título
     * @param due_date
     */
    vm.refreshAmount = function (due_date) {
      DifferenceAnalysisService.refreshAmount({
        due_date: due_date,
        person_id: vm.data.person_id_filter,
        due_date_start: vm.data.due_date_start,
        due_date_end: vm.data.due_date_end,
        settlement_date_start: vm.data.settlement_date_start,
        settlement_date_end: vm.data.settlement_date_end,
      }).then(function (response) {
        vm.value = response;
      })
    };

    vm.submit = function () {
      $mdDialog.hide({
        difference_due_date: vm.difference_due_date,
        associate_to_bank_slip: vm.associate_to_bank_slip,
        bill_serie_id_bank_slip: vm.bill_serie_id_bank_slip,
        due_date_bank_slip: vm.due_date_bank_slip,
        bank_slip_rule_id: vm.bank_slip_rule_id,
        final_difference_value: vm.value,
        fines_rule_id: vm.fines_rule_id
      });
    };
    vm.close = function () {
      $mdDialog.cancel();
    };
    vm.init();
  }

  angular
    .module('app.finance.difference-analysis')
    .controller('DifferenceAnalysisCreateController', DifferenceAnalysisCreateController);
})();
(function () {
  'use strict';
  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'difer_menu';
    var path = 'finance.difference-analysis';
    msNavigationService.saveItem('finance.difference-analysis', {
      title: 'Análise de Diferenças',
      icon: 'icon-cash-usd',
      state: 'private.finance.difference-analysis',
      weight: 200,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      },
      badge      : {
        content: 'Novo!',
        color  : 'green'
      }
    });
  }
  angular
    .module('app.finance.difference-analysis')
    .run(run);

})();

(function () {
  'use strict';

  angular
    .module('app.finance.dashboard', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function GridService(Restangular) {

    /**
     * Retorna todos os produtos
     * @returns array
     */
    var getAllRows = function (obj) {
      return Restangular.one('company').one('getlistnfsecandidates').get(obj).then(function () {
        return [
          {name: "Curso 6", full_name: "Curso da silva", alias: "Cursinho", course_group_id: 1},
          {name: "Curso 7", full_name: "Curso da silva", alias: "Cursinho", course_group_id: 1},
          {name: "Curso 8", full_name: "Curso da silva", alias: "Cursinho", course_group_id: 1},
          {name: "Curso 9", full_name: "Curso da silva", alias: "Cursinho", course_group_id: 1},
          {name: "Curso 10", full_name: "Curso da silva", alias: "Cursinho", course_group_id: 1}
        ];
      });
    };

    var billingDefaultGraph = function (obj) {
      return Restangular.one('company').one('billingdefaultgraph').get(obj);
    };

    var receiptsPerMonth = function (obj) {
      return Restangular.one('company').one('receiptspermonth').get(obj);
    };

    var receiptsPerDay = function (obj) {
      return Restangular.one('company').one('receiptsperday').get(obj);
    };

    var getEmailsInfo = function (obj) {
      return Restangular.one('reports').one('getemailsinfo').get(obj);
    };

    var adjustEmail = function (obj) {
      return Restangular.one('reports').all('adjustemail').post(obj);
    };

    return {
      getAllRows: getAllRows,
      billingDefaultGraph: billingDefaultGraph,
      receiptsPerMonth: receiptsPerMonth,
      receiptsPerDay: receiptsPerDay,
      getEmailsInfo: getEmailsInfo,
      adjustEmail: adjustEmail
    };

  }

  angular
    .module('app.finance.dashboard')
    .factory('GridService', GridService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.dashboard', {
        url: '/dashboard',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/finance/dashboard/dashboard.html',
        controller: 'DashboardFinController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.finance.dashboard')
    .config(routerConfig);

})();





(function () {
	'use strict';

	/** @ngInject */
	function run(msNavigationService) {
		msNavigationService.saveItem('finance.dashboard', {
			title: 'Dashboard',
			icon: 'icon-window-restore',
			state: 'private.finance.dashboard',
			class: "md-primary",
			weight: 1
		});
	}

	angular
		.module('app.finance.dashboard')
		.run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function DashboardFinController($rootScope, GridService, a4Moment, Utils) {
    var vm = this;
    vm.date_range = {
      startDate: a4Moment().startOf('year'),
      endDate: a4Moment().endOf('year')
    };
    vm.months = Utils.months();
    vm.selectedMonth = parseInt(a4Moment().format("MM"));
    vm.chart_billingDefault = {};
    vm.chart_billingDefault.series = ['Recebido até o mês', 'Inadimplência recuperada', 'A vencer', 'Em negociação', 'Inadimplente'];
    vm.chart_billingDefault.colors = ["#000a9a", "#2f688c", "#009a00", "#e8e100", "#8c0000"];
    vm.chart_billingDefault.data = [];
    vm.chart_receiptsPerMonth = {};
    vm.chart_receiptsPerMonth.series = ['Adiantado', 'Do mês', 'Atrasados', 'Acéscimos', 'Venda de produtos'];
    vm.chart_receiptsPerMonth.colors = ["#009a00", "#000a9a", "#8c0000", "#E89C32", "#9D00E8"];
    vm.chart_receiptsPerMonth.data = [];
    vm.chart_receiptsPerMonth.totals = [];
    vm.chart_receiptsPerDay = {};
    vm.chart_receiptsPerDay.series = ['Adiantado', 'Do mês', 'Atrasados', 'Acéscimos', 'Venda de produtos'];
    vm.chart_receiptsPerDay.colors = ["#009a00", "#000a9a", "#8c0000", "#E89C32", "#9D00E8"];
    vm.chart_receiptsPerDay.data = [];
    vm.ranges = {
      'Este Ano': [a4Moment().startOf('year'), a4Moment().endOf('year')],
      'Últimos 3 Meses': [a4Moment().subtract(3, 'months'), a4Moment()],
      'Últimos 6 Meses': [a4Moment().subtract(6, 'months'), a4Moment()],
      'Últimos 9 Meses': [a4Moment().subtract(9, 'months'), a4Moment()],
      'Últimos 12 Meses': [a4Moment().subtract(12, 'months'), a4Moment()],
      'Ano Passado': [a4Moment().subtract(1, 'year').startOf('year'), a4Moment().subtract(1, 'year').endOf('year')],
      'Início do ano até hoje': [a4Moment().startOf('year'), a4Moment().startOf('day')]
    };

    vm.init = function () {
      vm.billingDefaultGraph();
      vm.receiptsPerMonth();
      vm.receiptsPerDay();
      // vm.getEmailsInfo();
    };

    vm.getEmailsInfo = function () {
      $rootScope.show_loader = true;
      GridService.getEmailsInfo().then(function (response) {
        var data = response.plain();
        vm.emails_errors = data.aggregation;
        vm.emails_report = data.report;
        $rootScope.show_loader = false;
      })
    };


    vm.billingDefaultGraph = function () {
      GridService.billingDefaultGraph({
        startDate: vm.date_range.startDate.format('YYYY-MM-DD'),
        endDate: vm.date_range.endDate.format('YYYY-MM-DD')
      })
        .then(function (resp) {
          var data = resp.plain();
          vm.chart_billingDefault.data[0] = data.payed_due;
          vm.chart_billingDefault.data[1] = data.payed_overdue;
          vm.chart_billingDefault.data[2] = data.future_due;
          vm.chart_billingDefault.data[3] = data.under_negociation;
          vm.chart_billingDefault.data[4] = data.overdue;
          vm.chart_billingDefault.labels = data.month;
        });
    };

    vm.receiptsPerMonth = function () {
      GridService.receiptsPerMonth({
        startDate: vm.date_range.startDate.format('YYYY-MM-DD'),
        endDate: vm.date_range.endDate.format('YYYY-MM-DD')
      })
        .then(function (resp) {
          var data = resp.plain();
          vm.chart_receiptsPerMonth.data[0] = data.early;
          vm.chart_receiptsPerMonth.data[1] = data.due;
          vm.chart_receiptsPerMonth.data[2] = data.late;
          vm.chart_receiptsPerMonth.data[3] = data.fine_interest;
          vm.chart_receiptsPerMonth.data[4] = data.products;          
          vm.chart_receiptsPerMonth.labels = data.month;

          vm.chart_receiptsPerMonth.totals = data.total;
        });
    };


    vm.receiptsPerDay = function () {
      var addZero = vm.selectedMonth > 9 ? "0" : "";
      var dateBase = a4Moment().format('YYYY') + "-" + addZero + vm.selectedMonth.toString() + "-01";
      GridService.receiptsPerDay({
        startDate: dateBase,
        endDate: a4Moment(dateBase).add(1, 'month').startOf('month').format('YYYY-MM-DD')
      })
        .then(function (resp) {
          var data = resp.plain();
          vm.chart_receiptsPerDay.data[0] = data.early;
          vm.chart_receiptsPerDay.data[1] = data.due;
          vm.chart_receiptsPerDay.data[2] = data.late;
          vm.chart_receiptsPerDay.data[3] = data.fine_interest;
          vm.chart_receiptsPerDay.data[4] = data.products;
          vm.chart_receiptsPerDay.labels = data.month;
        });
    };

    vm.init();
  }

  angular
    .module('app.finance.dashboard')
    .controller('DashboardFinController', DashboardFinController);

})();


(function () {
  'use strict';
  /** @ngInject*/
  function DailyBalanceService(Restangular) {
  var self = {};

    self.getLastDayBalance = function () {
      return Restangular.one("daily_balance/getLastDayBalance").get();
    };

    self.updateRole = function (role) {
      return Restangular.one("usergroup", role.id).customPUT(role);
    };

    self.getIsBalanceDay = function () {
      return Restangular.one("/daily_balance/closing").get();
    };

    self.setCloseDay = function (data) {
      return Restangular.one("daily_balance/closingday").customPOST(data);
    };

    self.reopening = function (data) {
      return Restangular.one("/daily_balance/reopeningperiod").customPOST(data);
    };


    return self;

  }

  angular.module('app.finance.daily-balance')
    .factory('DailyBalanceService', DailyBalanceService);

})();
(function() {
    'use strict';


    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('private.finance.daily-balance', {
                url: '/daily-balance',
                public: false,
                templateUrl: 'app/finance/daily-balance/views/index.html',
                controller: 'DailyBalanceController',
                controllerAs: 'vm'
            });
    }

    angular
        .module('app.finance.daily-balance')
        .config(routerConfig);


})();



(function () {
  'use strict';
  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'saldos_menu';
    var path = 'finance.daily-balance';

    msNavigationService.saveItem('finance.daily-balance', {
      title: 'Saldos Diários',
      icon: 'icon-calculator',
      state: 'private.finance.daily-balance',
      weight: 9,
      auth: role,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.daily-balance')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function DailyBalanceController($rootScope, DailyBalanceService, Common, ModalFactory, a4Moment, PoliciesService) {

    var vm = this;

    vm.roles = [];
    vm.role = {};
    vm.editable = false;
    vm.reopen_date = '';

    vm.selected = [];

    /**
     *
     */
    vm.catchLastDayClose = function () {
      DailyBalanceService.getLastDayBalance()
        .then(function (response) {
          if (response.last_day.date !== undefined) {
            vm.dateMax = response.last_day.date;
            vm.reopen_date = false;
            vm.first_date = a4Moment(response.first_day.date);
            vm.init_date = a4Moment(response.last_day.date);
          } else {
            vm.init_date = a4Moment();
            vm.reopen_date = true;
          }
          $rootScope.show_loader = false;
        });
    };


    vm.initDayBalance = function () {
      DailyBalanceService.getIsBalanceDay()
        .then(function (res) {
          vm.last_date = res.last_date;
          vm.is_daily_balance = res.is_daily_balance;
          vm.closing_day = vm.getLastDayClose();
          vm.minDateClose = vm.getLastDayClose();
          vm.maxDateClose = vm.getMaxDate();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.reopening = function (date, ev) {
      var data = {
        init_date: date
      };
      date = a4Moment(date).format("DD/MM/YYYY");
      ModalFactory.confirm(ev, "Confirmar reabertura", "Todas as movimentações até o dia " + date + " serão reabertas. Deseja confirmar?")
        .then(function (response) {
          if (response) {
            DailyBalanceService.reopening(data)
              .then(function () {
                Common.Toast.success('Reabertura realizada com sucesso!');
                vm.init();
              })
              .catch(function () {
                Common.Toast.error("Erro ao realizar reabertura");
              });
          }
        });

    };

    /**
     * Fechamento do dia pela data
     * @param date {string}
     * @param confirm {boolean}
     */
    vm.closingDayByDate = function (date, ev, confirm) {
      if (!vm.lock && vm.last_date != null && vm.last_date != '') {

        var data = {'date': date};

        if (confirm) {
          /** fechamento do range de datas, apos modal de confirmação */
          data['close_all'] = true;
        }

        var newDate = a4Moment(date).format("DD/MM/YYYY");

        vm.lock = true;

        DailyBalanceService.setCloseDay(data)
          .then(function (response) {
            vm.lock = false;
            if (response != null && !response.result) {
              if (vm.getMinDate() != newDate) {
                ModalFactory.confirm(ev, "Confirmar encerramento", "Todas as movimentações, do dia " + vm.getMinDate()
                  + " até o dia " + newDate + " serão fechadas. Deseja confirmar essa ação?")
                  .then(function (response) {
                    if (response) {
                      vm.closingDayByDate(date, ev, response);
                    }
                  });
              } else {
                ModalFactory.confirm(ev, "Confirmar encerramento", " Todas as movimentações, do dia " + newDate
                  + " serão fechadas. Deseja confirmar essa ação?").then(function (response) {
                  if (response) {
                    vm.closingDayByDate(date, ev, response);
                  }
                });
              }
            } else if (response != null && response.result && confirm) {
              Common.Toast.success('Dia fechado com sucesso!');
              vm.totalization = response.totalization;
              ModalFactory.open('dailybalance/totalization', ev, "DailyBalanceController", {totalization: response.totalization}, 'finance');
              vm.init();
            }
          })
          .catch(function () {
            Common.Toast.error('Erro ao tentar fazer fechamento do dia.', "A4-Web");
            vm.lock = false;
          });
      }

    };

    /**
     * Retorna o limite mínimo do range para o datepicker
     * @returns string
     */
    vm.getMinDate = function () {
      if (vm.last_date != null && vm.last_date != "") {
        var sp_date = vm.last_date.split('/');
        var date = a4Moment(new Date(parseInt(sp_date[2]), parseInt(sp_date[1]) - 1, parseInt(sp_date[0]) + 1));
        return date.format('DD/MM/YYYY');
      }

      return a4Moment().format('DD/MM/YYYY');

    };

    vm.getLastDayClose = function () {
      if (vm.last_date != null && vm.last_date != "") {
        var sp_date = vm.last_date.split('/');
        var date = new Date(parseInt(sp_date[2]), parseInt(sp_date[1]) - 1, parseInt(sp_date[0]) + 1);
        return date;
      }

      return new Date();

    };

    /**
     * Retorna o limite máximo do range para o datepicker
     * @returns string
     */
    vm.getMaxDate = function () {
      return a4Moment();
    };

    /**
     * Retorna o limite máximo do range para o datepicker
     * @returns string
     */
    vm.getMaxDateClosed = function () {
      return a4Moment(vm.dateMax);
    };

    vm.init = function () {
      vm.catchLastDayClose();
      vm.initDayBalance();
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();

  }

  angular
    .module('app.finance.daily-balance')
    .controller('DailyBalanceController', DailyBalanceController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function MovementFilesController($rootScope, $document, CONFIG, Common, DropzoneService, Session, ModalExtra,
                                   CurrentAccountService, ModalFactory) {

    var vm = this;
    vm.CONFIG = CONFIG;
    vm.isProcessing = false;
    vm.determinateValue = 0;
    vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/movement/savefiles?connection=' + $document[0].domain.split('.')[0] + '&company=' + Session.getCurrentCompany() +
        '&current_school_period=' + vm.current_school_period_id + '&movement_id=' + ModalExtra.movement_id,
      paramName: 'file',
      maxFilesize: '50',
      acceptedFiles: DropzoneService.getMimeTypes(['png', 'jpg', 'pdf', 'doc', 'docx']),
      uploadMultiple: true,
      parallelUploads: 10,
      maxFiles: 20,
      autoProcessQueue: true,
      timeout: 600000
    };

    vm.init = function () {
      CurrentAccountService.getMovementFiles({movement_id: ModalExtra.movement_id})
        .then(function (resp) {
          vm.files = resp;
        })
    }

    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'addedfile': function (file) {
        vm.isProcessing = true;
      },
      'addedfiles': function (files) {
        vm.isProcessing = true;
      },
      'uploadprogress': function (item, progress) {
        vm.determinateValue = progress;
      },
      'successmultiple': function () {
        // vm.determinateValue = 100;
        Common.Toast.success("Imagens enviadas com sucesso");
        vm.init();
        // vm.closeModal();
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.deleteFile = function (document) {
      ModalFactory.confirm(null,
        "Excluir documento",
        "Confirma a exclusão desse documento? Esta ação não é reversível",
        "Confirmar", "Cancelar", "finance")
        .then(function () {
          $rootScope.show_loader = true;
          CurrentAccountService.deleteMovementFile({
            artifact_id: document.artifact_id,
            movement_id: document.movement_id
          })
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Documento excluído com sucesso!');
            }).catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Erro ao excluir documento');
          });
        });
    }

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    }

    vm.init();

  }

  angular.module('app.finance.currentaccount')
    .controller('MovementFilesController', MovementFilesController)


})();

(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountService(Restangular) {
    var vm = {};

    /** accounts */
    vm.listAll = function (obj) {
      return Restangular.one('currentaccount').all('listallaccounts').getList(obj);
    };

    vm.getById = function (id) {
      return Restangular.one('currentaccount', id).get();
    };

    vm.getAlltypes = function () {
      return Restangular.one('currentaccount').one('listypes').get();
    };

    vm.getCurrentAccountTypes = function () {
      return {
        CONTA_CAIXA: 1,
        CONTA_BANCO: 2,
        CONTA_INVESTIMENTO: 3,
        CONTA_CARTAO_DE_CREDITO_RECEBIVEL: 4,
        CONTA_CARTAO_DE_CREDITO_PAGAMENTO: 5,
        CONTA_CARTAO_DE_DEBITO_RECEBIVEL: 6,
        CONTA_CARTAO_DE_DEBITO_PAGAMENTO: 7,
        CONTA_A4PAG: 8
      }
    };

    vm.getAccountsTypeBank = function () {
      return Restangular.one('currentaccount').one('getByType').get({types: '2'});
    };

    vm.getByTypes = function (types) {
      return Restangular.one('currentaccount').one('getByType').get(types);
    };

    vm.getCompanies = function () {
      return Restangular.one('company').one('getallsub').get();
    };

    vm.updateCurrentAccount = function (account) {
      return account.put(); //Restangular.one('currentaccount', account.id).put(account);
    };

    vm.storeCurrentAccount = function (account) {
      return Restangular.all('currentaccount').post(account);
    };

    vm.deleteCurrentAccount = function (account) {
      return Restangular.one('currentaccount', account.id).customDELETE();
    };

    vm.getCurrentAccountTypesForTransference = function () {
      return Restangular.one('currentaccount').one('gettransferencetypes').get();
    };

    vm.getMovementFiles = function (obj) {
      return Restangular.one('movement').one('getfiles').get(obj);
    };

    /** banks */
    vm.getBanks = function () {
      return Restangular.one('listbanks').get();
    };

    vm.getBankColletionByBankId = function (bank_id) {
      return Restangular.one('currentaccount').one('getBankColletionByBank', bank_id).get();
    };

    /** cards */
    vm.removeCardById = function (id) {
      return Restangular.one('card', id).customDELETE();
    };

    vm.verifyIfHasGeneratedSlipBeforeDelete = function (collectionConfigId, accountId) {
      var obj = {collectionConfigId: collectionConfigId, accountId: accountId};
      return Restangular.one('currentaccount').one('verifyIfHasGeneratedSlipBeforeDelete').get(obj);
    };

    /** movements */
    vm.getAllMovements = function (obj) {
      return Restangular.one('movement').one('getall').get(obj);
    };

    vm.reversalTransference = function (obj) {
      return Restangular.one('movement').all('reversaltransference').post(obj);
    };

    vm.createPayment = function (obj) {
      return Restangular.one('bill').all('createsinglepayment').post(obj);
    };

    vm.createTransference = function (obj) {
      return Restangular.one('movement').all('createTransference').post(obj);
    };

    vm.createMovement = function (obj) {
      return Restangular.all('movement').post(obj);
    };

    vm.getAllThirdPartyInHandChecks = function () {
      return Restangular.one('checkreceived').all('getAllThirdPartyChecksInHand').getList();
    };

    vm.verifyCompensationCheck = function (obj) {
      return Restangular.one('movement').all('verifyCompensationCheck').post(obj);
    };

    vm.updateCompensationCheck = function (obj) {
      return Restangular.one('movement').all('updateCompensationCheck').post(obj);
    };

    vm.deleteMovementAccount = function (obj) {
      return Restangular.one('movement').all('deleteMovementAccount').post(obj);
    };

    vm.getAccountBalance = function (obj) {
      return Restangular.one('accountbalance').all('getDetail').post(obj);
    };

    vm.simpleUpdateReconcile = function (obj) {
      return Restangular.one('movement').all('simpleReconcileMovement').post(obj);
    };

    vm.checkUpdateReconcile = function (obj) {
      return Restangular.one('movement').all('checkReconcileMovement').post(obj);
    };

    /**
     * Exclui uma entrada no extrato
     * @param obj
     */
    vm.deleteBill = function (id) {
      return Restangular.all('bill').one('billdeletephysically', id).customDELETE();
    };

    vm.setMainAccount = function (obj) {
      return Restangular.one('currentaccount').all('setmainaccount').post(obj);
    };

    vm.inactivateAccount = function (obj) {
      return Restangular.one('currentaccount').all('inactivateaccount').post(obj);
    };

    vm.activateAccount = function (obj) {
      return Restangular.one('currentaccount').all('activateaccount').post(obj);
    };

    vm.deleteMovementFile = function (obj) {
      return Restangular.one('movement').all('deletemovementfile').post(obj);
    };

    return vm;
  }

  angular.module('app.finance.currentaccount')
    .factory('CurrentAccountService', CurrentAccountService);


})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.current-account', {
        url: '/current-account',
        public: false,
        templateUrl: 'app/finance/current-account/views/current-account.html',
        controller: 'CurrentAccountController',
        controllerAs: 'vm'
      })
      .state('private.finance.currentaccountdetails', {
        url: '/current-account/{id:int}/details',
        params: {
          item: null
        },
        public: false,
        templateUrl: 'app/finance/current-account/views/current-account-details.html',
        controller: 'CurrentAccountDetailsController',
        controllerAs: 'vm'
      })
  }

  angular
    .module('app.finance.currentaccount')
    .config(routerConfig);

})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'conta_menu';
    var path = 'finance.current-account';
    msNavigationService.saveItem('finance.currentaccount', {
      title: 'Contas correntes',
      icon: 'icon-cash-multiple',
      state: 'private.finance.current-account',
      auth: role,
      weight: 2,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.currentaccount')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountController($scope, $state, $stateParams, $filter, $mdConstant,
                                    $rootScope, $mdDialog, $mdSidenav, ModalFactory,
                                    BillCategoryService, Common, a4Moment,
                                    CurrentAccountService, PersonService, $a4FloatButton,
                                    PoliciesService, BillReceiptService, $a4Sidenav) {

    var vm = this;

    vm.current_accounts = [];
    vm.currentItem = {};
    vm.currentItem.not_current_account = [];
    vm.show_inactive = false;
    vm.selected_account = {};
    vm.account_clicked = [];
    vm.alreadySelected = false;
    vm.items = [];
    vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    vm.verifyCheck = false;
    vm.balance = {};

    var updateList = $rootScope.$on('UPDATE_CURRENT_ACCOUNT_LIST', function () {
      vm.listAllAccounts();
    });

    vm.current_account_types = CurrentAccountService.getCurrentAccountTypes();

    /**
     * init
     */
    vm.init = function () {
      if (!vm.checkPolicies('conta_alt')) {
        $a4FloatButton({scope: $scope, onClick: 'vm.createCurrentAccount()', theme: 'finance'});
      }
      vm.listAllAccounts();
      vm.verifyRoute();
    };

    /**
     * Vai para a página de extrato
     * @param item
     */
    vm.openExtract = function (item) {
      if (!vm.checkPolicies('conta_extr')) {
        $state.go('private.finance.currentaccountdetails', {id: item.id, item: item});
      }
    };

    vm.verifyRoute = function () {

      if ($state.current.name === 'private.finance.cashier-session.account-entry') {
        if ($stateParams.account !== null) {
          vm.createReceipt();
        } else {
          $state.go('private.finance.cashier-session');
        }
      }

      if ($state.current.name === 'private.finance.current-account.account-entry') {
        if ($stateParams.account !== null) {
          vm.createReceipt();
        } else {
          $state.go('private.finance.current-account');
        }
      }

      if ($state.current.name === 'private.finance.cashier-session.account-output') {
        if ($stateParams.account !== null) {
          vm.createPayment();
        } else {
          $state.go('private.finance.cashier-session');
        }
      }

      if ($state.current.name === 'private.finance.current-account.account-output') {
        if ($stateParams.account !== null) {
          vm.createPayment();
        } else {
          $state.go('private.finance.current-account');
        }
      }

      if ($state.current.name === 'private.finance.cashier-session.account-transference') {
        if ($stateParams.account !== null) {
          vm.createTransference();
        } else {
          $state.go('private.finance.cashier-session');
        }
      }

      if ($state.current.name === 'private.finance.current-account.account-transference') {
        if ($stateParams.account !== null) {
          vm.createTransference();
        } else {
          $state.go('private.finance.current-account');
        }
      }
    };

    /**
     * getById
     * Retorna uma conta pelo id
     * @param id
     */
    vm.getAccountById = function (id) {
      CurrentAccountService.getById(id)
        .then(function (response) {
          vm.currentItem = response;
          vm.getBankColletionOptions();
          // instancia da classe Date para o datepicker
          vm.currentItem.initial_balance_date = a4Moment(vm.currentItem.initial_balance_date);
          $a4Sidenav().open(
            'app/finance/current-account/views/sidenavs/form.create.edit.html',
            'CurrentAccountCreateEditController',
            'vm',
            vm.currentItem
          );
        });
    };

    /**
     * Busca as carteiras a partir do identificador do banco;
     */
    vm.getBankColletionOptions = function () {
      if (vm.currentItem != null && vm.currentItem.bank != null) {
        var id = vm.currentItem.bank.id;
        CurrentAccountService.getBankColletionByBankId(id)
          .then(function (response) {
            if (response) {
              vm.bankColletions = response;
            }
          });
      }
    };


    /**
     * Toggle sidenav
     * @param sidenavId
     */
    vm.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).close();
    };

    vm.getPersons = function () {
      PersonService.getAllPersons({paginate: false})
        .then(function (persons) {
          vm.persons = persons;
        });
    };

    vm.getBillCategory = function (debit_credit) {
      BillCategoryService.getAll({debit_credit: debit_credit})
        .then(function (billCategories) {
          vm.categories = billCategories.nodes;
          vm.categories = billCategories.nodes;
        });
    };

    /**
     * createCurrentAccount
     * Form de criação de nova conta
     */
    vm.createCurrentAccount = function () {
      $a4Sidenav().open(
        'app/finance/current-account/views/sidenavs/form.create.edit.html',
        'CurrentAccountCreateEditController',
        'vm',
        {}
      ).then(function () {
        vm.listAllAccounts();
      });
    };

    /**
     * getBanks
     * Retorna lista de bancos
     * Retorna a lista de bancos
     */
    vm.getBanks = function () {
      CurrentAccountService.getBanks()
        .then(function (response) {
          vm.banks = response;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * listAllAccounts
     * Retorna todas as contas
     */
    vm.listAllAccounts = function () {
      $rootScope.show_loader = true;
      vm.promise = CurrentAccountService.listAll({show_inactive: vm.show_inactive}
      )
        .then(function (response) {
          if (response) {
            vm.items = response.plain();
            vm.current_accounts = response.plain();
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
      $rootScope.show_loader = false;

    };

    vm.reorder = function(order){
    };


    /**
     * Monta o objeto com os dados do cheque.
     * @param barcode - Codigo do cheque.
     */
    vm.prepareObjectCheck = function (barcode) {
      vm.checkObject = {
        bank_code: barcode.substring(0, 3),
        branch: barcode.substring(3, 7),
        compensation: barcode.substring(8, 11),
        number: barcode.substring(11, 17),
        check_type: barcode[17],
        account: barcode.substring(23, 30)
      };
      return vm.checkObject;
    };


    /**
     * Espera leitura do codigo do cheque.
     * @param barcode - String com o numero do cheque.
     * @param debit_credit
     */
    vm.readCheckNumber = function (barcode, debit_credit) {
      if (typeof barcode === 'string' && barcode.length === 30) {
        var check = vm.prepareObjectCheck(barcode);
        check.debit_credit = debit_credit.toLowerCase();
        vm.readed = true;
        BillReceiptService.verifyCheckNumber(check)
          .then(function (response) {
            if (typeof response !== 'string') {
              if (response.message === 'RECEIVABLE_CHECK') {
                vm.check = check;
                vm.check.bank = response.bank;
                vm.currentItem.bank = vm.check.bank;
                vm.currentItem.bank_branch = vm.check.branch;
                vm.currentItem.bank_account = vm.check.account;
                vm.currentItem.document = vm.check.number;
                //vm.check.idx = vm.itemIndex;
                return;
              }
              Common.Toast.warning('Cheque '
                + vm.getStatusOfCheque(response['status'])
                + '. Não vai ser possível utilizar este cheque para pagamento.');
            }
          })
          .catch(function (response) {
            switch (response) {
              case 'IS_OWN_CURRENT_ACCOUNT':
                vm.toastWarn('IS_OWN_CURRENT_ACCOUNT');
                break;
              case 'IS_ONE_CHECK_THIRD_PERSON_REGISTRADO':
                vm.toastWarn('IS_ONE_CHECK_THIRD_PERSON_REGISTRADO');
                break;
              case 'IS_OWN_CURRENT_ACCOUNT_AND_HAS_ALREADY_BEEN_USED':
                vm.toastWarn('IS_OWN_CURRENT_ACCOUNT_AND_HAS_ALREADY_BEEN_USED');
                break;
            }
          });
      }
    };

    /**
     * listAlltypes
     * Retorna array com todos os tipos de conta
     */
    vm.listAlltypes = function () {
      CurrentAccountService.getAlltypes()
        .then(function (response) {
          if (response) {
            vm.types = response;
            // vm.includeScope.types = vm.types;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * delete
     * @param index
     */
    vm.delete = function (item) {

      // var item = vm.items[index];
      var confirm = $mdDialog.confirm()
        .title('Deseja remover a conta selecionada?')
        .htmlContent('<b>A conta ' + item.name + '</b>' + ' será removida.')
        .ariaLabel('delete item')
        .ok('OK')
        .cancel('CANCELAR');

      $mdDialog.show(confirm)
        .then(function () {
          CurrentAccountService.deleteCurrentAccount(item)
            .then(function () {
              Common.Toast.success('Conta removida com sucesso.');
              vm.deleteItem(item);
              vm.listAllAccounts();
            })
            .catch(function (response) {
              switch (parseInt(response.status)) {
                case 406:
                  Common.Toast.error('Essa conta não pode ser removida.');
                  break;
                case 500:
                  Common.Toast.error('Não foi possivel comunicar com o servidor');
                  break;
              }
            });
        });
    };

    /**
     * deleteItem
     * @param item
     */
    vm.deleteItem = function (item) {
      vm.items.splice(vm.items.indexOf(item), 1);
    };

    vm.submit = function (account) {
      if (account) {
        if (account.id) {
          // edit
          CurrentAccountService.updateCurrentAccount(account)
            .then(function (response) {
              if (response !== null) {
                $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-form'});
                switch (response.message) {
                  case('ANOTHER_DATA_UPDATED_SUCCESSFULLY'):
                    Common.Toast.success('Apenas informações de cartão e cobrança foram atualizadas.');
                    break;
                  default:
                    Common.Toast.success('Informações atualizadas com sucesso.');
                    vm.listAllAccounts();
                    break;
                }
              }
            })
            .catch(function (response) {
              vm.apiErrorMessageByStatusCode(response);
            });
        } else {
          // create
          CurrentAccountService.storeCurrentAccount(account)
            .then(function (response) {
              if (response !== null) {
                $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-form'});
                Common.Toast.success('Conta criada com sucesso.');
                vm.listAllAccounts();
              }
            })
            .catch(function (response) {
              vm.apiErrorMessageByStatusCode(response);
            });
        }
      }

    };

    vm.filterMovementTypes = function (type, current_account_type_id) {

      if (current_account_type_id === 1) {
        //conta caixa apenas dinheiro
        if (type === 1 || type === 2) {
          return true;
        }
      } else if (current_account_type_id === 2) {
        //conta banco: dinheiro, cheque, transferencia, deposito, doc e ted
        if (type === 1 || type === 2 || type === 11 || type === 12 || type === 13 || type === 14) {
          return true;
        }
      } else if (current_account_type_id === 4) {
        //conta cartão de crédito: deposito
        if (type === 11) {
          return true;
        }
      }

      return false;

    };

    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    vm.createFilterForBank = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0 || item.number_bank.indexOf(query) === 0);
      };
    };

    /**
     * apiErrorMessageByStatusCode
     * Toast error com mensagens baseada no statusCode da api
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 409:
          Common.Toast.warning('Apenas informações de cartão / cobrança podem ser atualizadas para essa conta.');
          $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-form'});
          break;
        case 304:
          Common.Toast.error('Você não pode modificar os dados dessa conta.');
          break;
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista');
          break;
        case 406:
          if (response.data !== null && response.data.message !== null) {
            Common.Toast.error($filter('translate')(response.data.message));
          } else {
            Common.Toast.error('Existem erros no formulário.');
          }
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor');
          break;
      }
    };


    /**
     *
     * @param list
     * @param item
     * @returns {*}
     */
    vm.removeIndicated = function (list, item) {
      if (item !== undefined && item.id !== undefined) {
        return $filter("filter")(list, {id: "!" + item.id});
      }
    };


    vm.verifyValue = function (amount) {
      if (amount > 0) {
        vm.aCompensation.valitation = true;
      }
    };


    vm.creditForm = function (form) {
      var result = {
        'movement_type_id': 102,
        'amount': form.amount,
        'date': form.date,
        'issue_date': vm.credit.date,
        'debit_credit': "C"
      };

      if (form.hasOwnProperty('id')) {
        result.id = form.id;
        result.current_account_id = vm.credit.account_id;
        vm.verifyCompensationCheck(result);
      } else {
        result.current_account_id = vm.credit.account_selected.id;
        vm.verifyCompensationCheck(result);
      }
    };


    /**
     * verifyCompensationCheck
     * @param obj
     */
    vm.verifyCompensationCheck = function (obj) {
      CurrentAccountService.verifyCompensationCheck(obj)
        .then(function (response) {
          if (!response.length) {
            if (obj.hasOwnProperty('id')) {
              vm.updateMovementCompensationCheck(obj);
            } else {
              vm.saveMovement(obj);
            }
          } else {
            if (obj.hasOwnProperty('id')) {
              angular.forEach(response, function (item) {
                if (item.id === obj.id) {
                  vm.updateMovementCompensationCheck(obj);
                  return false;
                }
              });
            } else {
              Common.Toast.error('Já houve compensação de cheques para esta data.');
            }
          }
        });
    };

    /**
     * savePayment
     * @param obj
     */
    vm.savePayment = function (obj) {
      CurrentAccountService.createPayment(obj)
        .then(function (response) {
          if (response !== null) {
            if (response.result === true) {
              Common.Toast.success('Pagamento realizado com sucesso.');
              //vm.updateUiView();
              vm.listAllAccounts();
              vm.changeCurrentExtract();
            }
          }
        })
        .catch(function (response) {
          switch (response.status) {
            case 406:
              if (response.data.message === 'WITHOUT_AMOUNT_TO_TRANSACTION') {
                vm.confirmNegativePayment(obj);
              }
              break;
            case 502:
              Common.Toast.error(JSON.stringify(response.data));
              break;
          }
        });

    };

    /**
     * confirmNegativePayment
     * Se a conta não tem saldo para a transação, confirmar com o usuário se deseja entrar no 'limite'
     * @param payment
     */
    vm.confirmNegativePayment = function (payment) {
      var confirm = $mdDialog.confirm()
        .title('Você não tem saldo para realizar essa ação. Deseja continuar?')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm)
        .then(function () {
          payment.confirm = true;
          vm.savePayment(payment);
        })
        .catch(function () {
          //vm.preload = false;
          $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-create-output'});
          $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-entry'});
          Common.Toast.warning('Ação cancelada.');
        });
    };


    /**
     * Executa a requisição para realização de transferência.
     * @param obj
     * @param current_account
     */
    vm.saveTransference = function (obj, current_account) {
      CurrentAccountService.createTransference(obj)
        .then(function (response) {
          if (response !== null) {
            if (response.result === true) {
              Common.Toast.success('Transferência realizada com sucesso.');
              //vm.updateUiView();
              vm.listAllAccounts();
              vm.changeCurrentExtract();
            }
          }
        })
        .catch(function (response) {
          switch (response.status) {
            case 406:
              if (response.data.message === 'WITHOUT_AMOUNT_TO_TRANSACTION') {
                vm.confirmNegativeTransference(obj, current_account);
                //vm.updateUiView();
              }
              break;
            case 502:
              Common.Toast.error(JSON.stringify(response.data));
              break;
          }
        });
    };

    vm.updateUiView = function () {
      $mdSidenav('sidenav-global').close();
      $state.go('private.finance.current-account', {}, {reload: false});
    };

    /**
     * confirmNegativeTransference
     * Se a conta não tem saldo para a transação, confirmar com o usuário se deseja entrar no 'limite'
     * @param transference
     * @param current_account
     */
    vm.confirmNegativeTransference = function (transference, current_account) {
      var confirm = $mdDialog.confirm()
        .title('Você não tem saldo para realizar essa ação. Deseja continuar?')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm)
        .then(function () {
          transference.confirm = true;
          vm.saveTransference(transference, current_account);
        })
        .catch(function () {
          $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-create-transf'});
          Common.Toast.warning('Ação cancelada.');
        });
    };

    /**
     * Executa a requisição para realização de pagemento.
     * @param payment
     */
    vm.saveMovement = function (payment) {
      CurrentAccountService.createMovement(payment)
        .then(function (response) {
          if (response !== null) {
            if (response.result === true) {
              vm.changeCurrentExtract();
              Common.Toast.success('Movimento realizado com sucesso.');
              //vm.updateUiView();
            }
          }
        })
        .catch(function (response) {
          switch (response.status) {
            case 406:
              if (response.data.message === 'WITHOUT_AMOUNT_TO_TRANSACTION') {
                vm.confirmNegativeMovement(payment);
              }
              break;
            case 502:
              Common.Toast.error(JSON.stringify(response.data));
              break;
          }
        });
    };


    /**
     * Executa a atualização de compensação de cheques.
     * @param credit
     */
    vm.updateMovementCompensationCheck = function (credit) {
      CurrentAccountService.updateCompensationCheck(credit)
        .then(function () {
          vm.listAllAccounts();
          vm.changeCurrentExtract();
          Common.Toast.success('Movimento atualizado com sucesso.');
        })
        .catch(function () {
          Common.Toast.error('Ocorreu um erro ao atualizar compensação de cheques.');
        });
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Define a conta como principal
     * @param account
     */
    vm.setMainAccount = function (account) {
      ModalFactory.confirm(null,
        'Deseja definir esta conta como principal?',
        account.name,
        'Confirmar', 'Cancelar', 'finance')
        .then(function () {
          CurrentAccountService.setMainAccount(account)
            .then(function () {
              Common.Toast.success('Conta principal definida com sucesso');
              vm.listAllAccounts();
            })
            .catch(function () {
              Common.Toast.error('Erro ao atualizar');
            })
        });
    };

    vm.inactivateAccount = function (item) {
      ModalFactory.confirm(null,
        'Deseja desativar essa conta?',
        item.name,
        'Confirmar', 'Cancelar', 'finance')
        .then(function () {
          CurrentAccountService.inactivateAccount(item)
            .then(function () {
              Common.Toast.success('Conta desativada');
              vm.listAllAccounts();
            })
            .catch(function () {
              Common.Toast.error('Erro ao atualizar');
            })
        });

    };

    vm.activateAccount = function (item) {
      ModalFactory.confirm(null,
        'Confirma a reativação dessa conta?',
        item.name,
        'Confirmar', 'Cancelar', 'finance')
        .then(function () {
          CurrentAccountService.activateAccount(item)
            .then(function () {
              Common.Toast.success('Conta reativada');
              vm.listAllAccounts();
            })
            .catch(function () {
              Common.Toast.error('Erro ao reativar a conta');
            })
        });

    };

    $scope.$on('$destroy', function () {
      [updateList].forEach((function (fn) {
        fn();
      }))
    });

    vm.init();

  }

  angular
    .module('app.finance.currentaccount')
    .controller('CurrentAccountController', CurrentAccountController);

})();

(function () {
  'use strict';

  var CURRENT_ACCOUNT_TYPES = {
    CONTA_CAIXA: '1',
    CONTA_BANCO: '2',
    CONTA_INVESTIMENTO: 3,
    CONTA_CARTAO_DE_CREDITO_RECEBIVEL: 4,
    CONTA_CARTAO_DE_CREDITO_PAGAMENTO: 5,
    CONTA_CARTAO_DE_DEBITO_RECEBIVEL: 6,
    CONTA_CARTAO_DE_DEBITO_PAGAMENTO: 7
  };

  angular.module('app.finance.currentaccount')
    .constant('CURRENT_ACCOUNT_TYPES', CURRENT_ACCOUNT_TYPES);
})();
(function () {
  'use strict';

  function BalanceController($scope, $filter, $mdDialog, ModalExtra) {

    var vm = this;
    vm.data = ModalExtra;

    /**
     * Aplica mascara financeira no padrão (R$ 0,00)
     * @param value
     * @returns {string}
     */
    $scope.applyMask = function (value) {
      if (value == 0 || value == null) {
        var currency = $filter('currency')(0, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      } else if (value > 0) {
        var currency = $filter('currency')(value, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      }
    };

    $scope.hide = function() {
      $mdDialog.hide();
    };

  }

  angular
    .module('app.finance.currentaccount')
    .controller('BalanceController', BalanceController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountTransferenceCreditController(SideExtra, CurrentAccountService, BillCategoryService, PersonService,
                                               Common, $a4Sidenav, $rootScope, $mdDialog, $filter, a4Moment) {
    var vm = this;

    vm.currentItem = {};
    vm.currentItem.date = a4Moment().format('YYYY-MM-DD');
    vm.currentItem.not_current_account = [];

    vm.methods = [
      {id: 1, name: "Dinheiro"},
      {id: 2, name: "Cheque"},
      {id: 5, name: "Cheque de terceiros"},
      {id: 10, name: "Boleto"},
      {id: 11, name: "Depósito"},
      {id: 12, name: "Transferência"},
      {id: 20, name: "Cartão de débito"},
      {id: 21, name: "Cartão de crédito"}
    ];

    vm.init = function () {
      vm.selected_account = SideExtra;
      vm.getAllCategories();
      vm.getPersons();
      vm.listAllAccounts();
    };

    vm.getAllCategories = function () {
      BillCategoryService.getAll({debit_credit: 'C'})
        .then(function (billCategories) {
          vm.categories = billCategories.nodes;
        });
    };

    vm.filterMovementTypes = function (type, current_account_type_id, ngModel) {

      if (current_account_type_id == 1) {
        //conta caixa apenas dinheiro
        if (type == 1 || type == 2) {
          return true;
        }
      } else if (current_account_type_id == 2) {
        //conta banco: dinheiro, cheque, transferencia, deposito, doc e ted
        if (type == 1 || type == 2 || type == 11 || type == 12 || type == 13 || type == 14) {
          return true;
        }
      } else if (current_account_type_id == 4) {
        //conta cartão de crédito: deposito
        if (type == 11) {
          return true;
        }
      }

      return false;

    };

    vm.removeIndicated = function (list, item) {
      if (item != undefined && item.id != undefined) {
        return $filter("filter")(list, {id: "!" + item.id});
      }
    };

    /**
     * listAllAccounts
     * Retorna todas as contas
     */
    vm.listAllAccounts = function () {
      CurrentAccountService.listAll()
        .then(function (response) {
          if (response) {
            vm.items = response;
            vm.current_accounts = response;
          }
        })
        .catch(function (response) {
          Common.Toast.error("Erro ao listar contas");
        });
    };

    vm.getPersons = function () {
      PersonService.getAllPersons({paginate: false})
        .then(function (persons) {
          vm.persons = persons;
        });
    };

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearchCategory = function (query) {
      return query ? vm.categories.filter(vm.createFilterFor(query)) : vm.categories;
    };

    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    /**
     * Realiza transferencia de valores entre contas
     */
    vm.insertTransference = function (form, item, selected_account) {
      if (item.date == '' || item.date == null) {
        item.date = a4Moment().format('YYYY-MM-DD');
      }

      var result = {
        'current_account_id': selected_account.id,
        'current_account_id_transf': item.current_account.id,
        'document': item.document,
        'movement_type_id': item.method != null ? item.method : 12,
        'amount': item.amount,
        'date': item.date,
        'files': item.files
      };

      vm.saveTransference(result, selected_account);

    };

    /**
     * Executa a requisição para realização de transferência.
     * @param obj
     * @param current_account
     */
    vm.saveTransference = function (obj, current_account) {
      CurrentAccountService.createTransference(obj)
        .then(function (response) {
          if (response != null) {
            if (response.result == true) {
              Common.Toast.success('Transferência realizada com sucesso.');
              vm.close();
            }
          }
        })
        .catch(function (response) {
          switch (response.status) {
            case 406:
              if (response.data.message == 'WITHOUT_AMOUNT_TO_TRANSACTION') {
                vm.confirmNegativeTransference(obj, current_account);
                //vm.updateUiView();
              }
              break;
            case 502:
              Common.Toast.error(JSON.stringify(response.data));
              break;
          }
        });
    };

    /**
     * confirmNegativeTransference
     * Se a conta não tem saldo para a transação, confirmar com o usuário se deseja entrar no 'limite'
     * @param transference
     * @param current_account
     */
    vm.confirmNegativeTransference = function (transference, current_account) {

      var confirm = $mdDialog.confirm()
        .title('Você não tem saldo para realizar essa ação. Deseja continuar?')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm)
        .then(function () {

          transference.confirm = true;
          vm.saveTransference(transference, current_account);

        })
        .catch(function () {
          $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-create-transf'});
          Common.Toast.warning('Ação cancelada.');
        });
    };

    vm.close = function () {
      $a4Sidenav().close()
        .then(function () {
          $rootScope.$broadcast("CURRENT_ACCOUNT_CONTROLLER.update");
        })
    };

    vm.init();
  }

  angular
    .module('app.finance.currentaccount')
    .controller('CurrentAccountTransferenceCreditController', CurrentAccountTransferenceCreditController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountOutputCreditController(SideExtra, CurrentAccountService, BillCategoryService, PersonService,
                                                Common, $a4Sidenav, $rootScope,
                                                $mdDialog, BillReceiptService, $filter, CONFIG, DropzoneService,
                                                BillExpenseService, a4Moment, ModalFactory, $mdConstant) {
    var vm = this;

    vm.currentItem = {
      files: []
    };
    vm.CONFIG = CONFIG;
    vm.currentItem.not_current_account = [];
    vm.searchText = '';
    vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];

    vm.methods = [
      {id: 1, name: "Dinheiro"},
      {id: 2, name: "Cheque"},
      {id: 5, name: "Cheque de terceiros"},
      {id: 10, name: "Boleto"},
      {id: 11, name: "Depósito"},
      {id: 12, name: "Transferência"},
      {id: 13, name: "DOC"},
      {id: 14, name: "TED"},
      {id: 20, name: "Cartão de débito"},
      {id: 21, name: "Cartão de crédito"}
    ];

    vm.dzOptions = {
      url: CONFIG.webApiUri,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'GIF', 'XLS', 'XLSX', 'PPT', 'PPTX', 'ZIP', 'MP3', 'MP4', 'WMV', 'AVI']),
      uploadMultiple: true,
      parallelUploads: 10,
      maxFiles: 5,
      autoProcessQueue: false
    };

    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'addedfile': function (file) {
        DropzoneService.getBase64(file)
          .then(function (base64) {
            vm.currentItem.files.push({name: file.name, base64: base64, size: file.size});
          });
      },
      'successmultiple': function (file, xhr) {
        if (xhr) {
          angular.forEach(xhr, function (item) {
            vm.artefacts.splice(0, 0, item);
          });
          vm.btnMultipleFiles = false;
          vm.submitOnlyFile(vm.lesson, vm.artefacts);
          vm.dzMethods.removeAllFiles(true);
        }
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.init = function () {
      vm.getAllCategories();
      vm.listAllAccounts();
      if (angular.isDefined(SideExtra.bill_id) && SideExtra.bill_id !== null) {
        vm.bill_id = SideExtra.bill_id;
        vm.getBillById(vm.bill_id);
      } else {
        vm.bill_id = false;
        vm.currentItem.tags = [];
        vm.currentItem.date = a4Moment().format('YYYY-MM-DD');
        vm.currentItem.current_account = SideExtra.account;
        vm.currentItem.accrual = null;
      }
    };

    vm.getAllCategories = function () {
      BillCategoryService.getAllByType('D')
        .then(function (billCategories) {
          vm.categories = billCategories;
          if (angular.isDefined(vm.currentItem.bill_category_id) && vm.currentItem.bill_category_id !== null) {
            vm.currentItem.category = vm.categories.filter(function (item) {
              return item.id === vm.currentItem.bill_category_id;
            })[0];
          }
        });
    };

    vm.filterMovementTypes = function (type, current_account_type_id, ngModel) {

      if (current_account_type_id === 1) {
        //conta caixa apenas dinheiro
        if (type === 1 || type === 2) {
          return true;
        }
      } else if (current_account_type_id === 2) {
        //conta banco: dinheiro, cheque, transferencia, deposito, doc e ted
        if (type === 1 || type === 2 || type === 11 || type === 12 || type === 13 || type === 14) {
          return true;
        }
      } else if (current_account_type_id === 4) {
        //conta cartão de crédito: deposito
        if (type === 11) {
          return true;
        }
      }

      return false;

    };

    /**
     * listAllAccounts
     * Retorna todas as contas
     */
    vm.listAllAccounts = function () {
      CurrentAccountService.listAll()
        .then(function (response) {
          if (response) {
            vm.items = response;
            vm.current_accounts = response;
          }
        })
        .catch(function () {
          Common.Toast.error("Erro ao listar contas");
        });
    };

    vm.getPersons = function (query) {
      return PersonService.listAll({query: query});
    };

    /**
     * Recupera os dados d título
     * @param id
     */
    vm.getBillById = function (id) {
      vm.currentItem = null;
      BillReceiptService.getBillById(id, {'edit_expense': null})
        .then(function (response) {

          vm.currentItem = response.plain();
          vm.currentItem.current_account = SideExtra.account;

          if (angular.isDefined(vm.currentItem.person_id) && vm.currentItem.person_id !== null) {
            vm.currentItem.person = vm.currentItem.person_id;
          }

          vm.currentItem.tags = angular.isUndefined(vm.currentItem.tags) ? [] : vm.currentItem.tags;

          if (angular.isDefined(vm.categories) &&
            (angular.isDefined(vm.currentItem.bill_category_id) && vm.currentItem.bill_category_id !== null)) {
            vm.currentItem.category = vm.categories.filter(function (item) {
              return item.id === vm.currentItem.bill_category_id;
            })[0];
          }

          vm.currentItem.amount = vm.currentItem.amount !== null ? parseFloat(vm.currentItem.amount) : 0.00;

          if (vm.currentItem.due_date !== null) {
            vm.currentItem.date = a4Moment(vm.currentItem.due_date);
          }

          if (vm.currentItem.accrual_month !== null && vm.currentItem.accrual_year !== null) {
            vm.currentItem.accrual = new Date(vm.currentItem.accrual_year, vm.currentItem.accrual_month - 1);
          } else {
            vm.currentItem.accrual = null;
          }

          if (vm.currentItem !== undefined) {

            if (vm.currentItem.tags !== null && vm.currentItem.tags.length > 0) {
              vm.currentItem.tags = vm.currentItem.tags.filter(function (item, i, ar) {
                return ar.indexOf(item) === i;
              });
            }
          }

        })
        .catch(function () {
          Common.Toast.error('Erro ao recuperar os dados');
        });
    };

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearchCategory = function (query) {
      return query ? vm.categories.filter(vm.createFilterFor(query)) : vm.categories;
    };

    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    /**
     * Se for clicado no botão "adicionar e continuar" irá realizar a limpeza do objeto e manter apenas os dados necessários
     */
    vm.clearFields = function () {
      var temp = {};

      temp.date = vm.currentItem.date;
      temp.current_account = vm.currentItem.current_account;
      temp.method = vm.currentItem.method;
      temp.accrual = vm.currentItem.accrual;
      temp.tags = vm.currentItem.tags;

      vm.currentItem = temp;
    };

    /**
     * Insere novo pagamento
     * @param form
     * @param payment
     * @param not_categorized
     * @param debit_credit
     * @param add_continue - se true, irá fazer o submit e manter a sidenav aberta para continuar adicionando entradas
     */
    vm.insertNewPaymentAndReceipt = function (form, payment, not_categorized, debit_credit, add_continue) {
      var result = null;
      if (angular.isDefined(payment.id) && payment.id !== null) {
        payment.accrual_month = payment.accrual !== undefined && payment.accrual !== null ? payment.accrual.getMonth() + 1 : null;
        payment.accrual_year = payment.accrual !== undefined && payment.accrual !== null ? payment.accrual.getFullYear() : null;
        payment.person_id = payment.person !== undefined ? payment.person.id : null;
        payment.bill_category_id = payment.category.id;
        payment.due_date = payment.date !== a4Moment(payment.due_date) ? a4Moment(payment.date).format("YYYY-MM-DD")
          : a4Moment(payment.due_date).format("YYYY-MM-DD");
        vm.updateSingleBill(payment);
      } else if (!not_categorized && form.$valid) {
        if (payment.amount !== null) {
          result = {
            'accrual_month': payment.accrual !== undefined && payment.accrual !== null ? payment.accrual.getMonth() + 1 : null,
            'accrual_year': payment.accrual !== undefined && payment.accrual !== null ? payment.accrual.getFullYear() : null,
            'amount': payment.amount,
            'bill_category_id': payment.category.id,
            'debit_credit': debit_credit,
            'description': payment.description,
            'document_reference': payment.document_reference,
            'due_date': a4Moment(payment.date).format("YYYY-MM-DD"),
            'payment_with_difference': false,
            'payments': [{
              'amount': payment.amount,
              'current_account_id': payment.current_account.id,
              'date': a4Moment(payment.date).format("YYYY-MM-DD"),
              'debit_credit': debit_credit,
              'document': payment.document,
              'movement_type_id': payment.method,
              'notes': payment.notes
            }],
            'bill_details': [{
              'bill_category_id': payment.category.id,
              'description': payment.description,
              'amount': payment.amount
            }],
            'person_id': payment.person !== null ? payment.person.id : null,
            'tags': payment.tags,
            'was_paid': 0,
            'files': payment.files,
            'type': 6
          };

          vm.savePayment(result, add_continue);
        }
      } else if (not_categorized && form.$valid) {
        if (payment.method !== null && payment.amount !== null) {
          result = {
            'current_account_id': payment.current_account.id,
            'document': payment.document,
            'movement_type_id': payment.method,
            'amount': payment.amount,
            'date': a4Moment(payment.date).format("YYYY-MM-DD"),
            'due_date': payment.date,
            'debit_credit': debit_credit,
            'files': payment.files,
            'type': 6
          };

          vm.saveMovement(result, add_continue);
        }
      }
    };

    /**
     * Update do pagamento
     * @param bill
     */
    vm.updateSingleBill = function (bill) {
      BillExpenseService.updateSingleBill(bill)
        .then(function () {
          Common.Toast.success($filter('translate')('UPDATE_SUCCESS'));
          vm.close();
        })
        .catch(function (response) {
          if (response === "REDUCTION_PORTION_DENIED") {
            Common.Toast.error('CANT_REDUCE_PORTIONS_RECURRENCE');
          } else {
            Common.Toast.error('UPDATE_ERROR');
          }
        });
    };

    /**
     * savePayment
     * @param obj
     * @param add_continue
     */
    vm.savePayment = function (obj, add_continue) {
      CurrentAccountService.createPayment(obj)
        .then(function (response) {
          if (response !== null) {
            if (response.result === true && add_continue) {
              Common.Toast.success('Pagamento realizado com sucesso.');
              vm.clearFields();
            } else if (response.result === true) {
              Common.Toast.success('Pagamento realizado com sucesso.');
              vm.close();
            }
          }
        })
        .catch(function (response) {
          switch (response.status) {
            case 406:
              if (response.data.message === 'WITHOUT_AMOUNT_TO_TRANSACTION') {
                vm.confirmNegativePayment(obj);
              }
              break;
            case 502:
              Common.Toast.error(JSON.stringify(response.data));
              break;
          }
        });

    };

    /**
     * Executa a requisição para realização de pagemento.
     * @param payment
     * @param add_continue
     */
    vm.saveMovement = function (payment, add_continue) {
      CurrentAccountService.createMovement(payment)
        .then(function (response) {
          if (response !== null) {
            if (response.result === true && add_continue) {
              Common.Toast.success('Movimento realizado com sucesso.');
              vm.clearFields();
            } else if (response.result === true) {
              Common.Toast.success('Movimento realizado com sucesso.');
              vm.close();
            }
          }
        })
        .catch(function (response) {
          switch (response.status) {
            case 406:
              if (response.data.message === 'WITHOUT_AMOUNT_TO_TRANSACTION') {
                vm.confirmNegativeMovement(payment);
              }
              break;
            case 502:
              Common.Toast.error(JSON.stringify(response.data));
              break;
          }
        });
    };

    /**
     * confirmNegativeMovement
     * Se a conta não tem saldo para a transação, confirmar com o usuário se deseja entrar no 'limite'
     * @param payment
     */
    vm.confirmNegativeMovement = function (payment) {

      var confirm = $mdDialog.confirm()
        .title('Você não tem saldo para realizar essa ação. Deseja continuar?')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm)
        .then(function () {
          payment.confirm = true;
          vm.saveMovement(payment);
        })
        .catch(function () {
          vm.close();
          Common.Toast.warning('Ação cancelada.');
        });
    };

    /**
     * Exclui uma saída do extrato
     * @param item
     */
    vm.delete = function (item) {
      ModalFactory.confirm(null,
        'Confirmação de Exclusão',
        'Deseja realmente excluir a saída?',
        'Confirmar',
        'Cancelar',
        'finance')
        .then(function () {
          CurrentAccountService.deleteBill(item.id)
            .then(function () {
              Common.Toast.success('Saída removida com sucesso');
              vm.close();
            })
            .catch(function () {
              Common.Toast.error('Erro ao excluir');
            });
        });
    };

    /**
     * confirmNegativePayment
     * Se a conta não tem saldo para a transação, confirmar com o usuário se deseja entrar no 'limite'
     * @param payment
     */
    vm.confirmNegativePayment = function (payment) {

      var confirm = $mdDialog.confirm()
        .title('Você não tem saldo para realizar essa ação. Deseja continuar?')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm)
        .then(function () {

          payment.confirm = true;
          vm.savePayment(payment);

        })
        .catch(function () {
          vm.close();
          Common.Toast.warning('Ação cancelada.');
        });
    };

    vm.close = function () {
      $a4Sidenav().close()
        .then(function () {
          $rootScope.$broadcast("CURRENT_ACCOUNT_CONTROLLER.update");
        })
    };

    vm.init();
  }

  angular
    .module('app.finance.currentaccount')
    .controller('CurrentAccountOutputCreditController', CurrentAccountOutputCreditController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountEntryCreditController(SideExtra, CurrentAccountService, BillCategoryService, DropzoneService,
                                               PersonService, ModalFactory, Common, CONFIG,
                                               $a4Sidenav, $rootScope, $mdDialog, BillReceiptService, $filter, a4Moment,
                                               $mdConstant) {
    var vm = this;

    vm.currentItem = {files: []};
    vm.currentItem.not_current_account = [];
    vm.searchText = '';
    vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];

    vm.methods = [
      {id: 1, name: "Dinheiro"},
      {id: 2, name: "Cheque"},
      {id: 5, name: "Cheque de terceiros"},
      {id: 10, name: "Boleto"},
      {id: 11, name: "Depósito"},
      {id: 12, name: "Transferência"},
      {id: 13, name: "DOC"},
      {id: 14, name: "TED"},
      {id: 20, name: "Cartão de débito"},
      {id: 21, name: "Cartão de crédito"}
    ];

    vm.CONFIG = CONFIG

    vm.dzOptions = {
      url: CONFIG.webApiUri,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'GIF', 'XLS', 'XLSX', 'PPT', 'PPTX', 'ZIP', 'MP3', 'MP4', 'WMV', 'AVI']),
      uploadMultiple: true,
      parallelUploads: 10,
      maxFiles: 5,
      autoProcessQueue: false
    };

    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'addedfile': function (file) {
        DropzoneService.getBase64(file)
          .then(function (base64) {
            vm.currentItem.files.push({name: file.name, base64: base64, size: file.size});
          });
      },
      'successmultiple': function (file, xhr) {
        if (xhr) {
          angular.forEach(xhr, function (item) {
            vm.artefacts.splice(0, 0, item);
          });
          vm.btnMultipleFiles = false;
          vm.submitOnlyFile(vm.lesson, vm.artefacts);
          vm.dzMethods.removeAllFiles(true);
        }
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.init = function () {
      vm.getAllCategories();
      vm.listAllAccounts();
      vm.getBanks();
      if (angular.isDefined(SideExtra.bill_id) && SideExtra.bill_id !== null) {
        vm.bill_id = SideExtra.bill_id;
        vm.getBillById(vm.bill_id);
      } else {
        vm.bill_id = false;
        vm.currentItem.tags = [];
        vm.currentItem.date = a4Moment();
        vm.currentItem.current_account = SideExtra.account;
        vm.currentItem.accrual = null;
      }
    };

    vm.getAllCategories = function () {
      BillCategoryService.getAllByType('C')
        .then(function (billCategories) {
          vm.categories = billCategories;
          if (angular.isDefined(vm.currentItem.bill_category_id) && vm.currentItem.bill_category_id !== null) {
            vm.currentItem.category = vm.categories.filter(function (item) {
              return item.id === vm.currentItem.bill_category_id;
            })[0];
          }
        });
    };

    vm.filterMovementTypes = function (type, current_account_type_id) {

      if (current_account_type_id === 1) {
        //conta caixa apenas dinheiro
        if (type === 1 || type === 2) {
          return true;
        }
      } else if (current_account_type_id === 2) {
        //conta banco: dinheiro, cheque, transferencia, deposito, doc e ted
        if (type === 1 || type === 2 || type === 11 || type === 12 || type === 13 || type === 14) {
          return true;
        }
      } else if (current_account_type_id === 4) {
        //conta cartão de crédito: deposito
        if (type === 11) {
          return true;
        }
      }
      return false;
    };

    /**
     * listAllAccounts
     * Retorna todas as contas
     */
    vm.listAllAccounts = function () {
      CurrentAccountService.listAll()
        .then(function (response) {
          if (response) {
            vm.items = response;
            vm.current_accounts = response;
          }
        })
        .catch(function () {
          Common.Toast.error("Erro ao listar contas");
        });
    };

    vm.getPersons = function (query) {
      return PersonService.listAll({query: query});
    };

    /**
     * Recupera os dados d título
     * @param id
     */
    vm.getBillById = function (id) {
      vm.currentItem = null;
      BillReceiptService.getBillById(id, {'edit_expense': null})
        .then(function (response) {
          vm.currentItem = response.plain();
          vm.currentItem.current_account = SideExtra.account;

          if (angular.isDefined(vm.currentItem.person_id) && vm.currentItem.person_id !== null) {
            vm.currentItem.person = vm.currentItem.person_id;
          }

          if (angular.isDefined(vm.currentItem.files) && vm.currentItem.files.length) {
            vm.currentItem.files.forEach(function (item) {
              item.isRemote = true;
            })
          }

          vm.currentItem.tags = angular.isUndefined(vm.currentItem.tags) ? [] : vm.currentItem.tags;

          if (angular.isDefined(vm.categories) &&
            (angular.isDefined(vm.currentItem.bill_category_id) && vm.currentItem.bill_category_id !== null)) {
            vm.currentItem.category = vm.categories.filter(function (item) {
              return item.id === vm.currentItem.bill_category_id;
            })[0];
          }

          vm.currentItem.amount = vm.currentItem.amount !== null ? parseFloat(vm.currentItem.amount) : vm.currentItem.amount;

          if (vm.currentItem.due_date !== null) {
            vm.currentItem.date = a4Moment(response.due_date);
          }

          if (vm.currentItem.accrual_month !== null && vm.currentItem.accrual_year !== null) {
            vm.currentItem.accrual = a4Moment({
              year: vm.currentItem.accrual_year,
              month: vm.currentItem.accrual_month - 1
            })._d;
          } else {
            vm.currentItem.accrual = null;
          }

          if (vm.currentItem !== undefined) {
            if (vm.currentItem.tags !== null && vm.currentItem.tags.length > 0) {
              vm.currentItem.tags = vm.currentItem.tags.filter(function (item, i, ar) {
                return ar.indexOf(item) === i;
              });
            }
          }
        })
        .catch(function () {
          Common.Toast.error('Erro ao recuperar os dados');
        });
    };

    /**
     * getBanks
     * Retorna lista de bancos
     * Retorna a lista de bancos
     */
    vm.getBanks = function () {
      CurrentAccountService.getBanks()
        .then(function (response) {
          vm.banks = response;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearchCategory = function (query) {
      return query ? vm.categories.filter(vm.createFilterFor(query)) : vm.categories;
    };

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    vm.querySearchBank = function (query) {
      return query ? vm.banks.filter(vm.createFilterForBank(query)) : vm.banks;
    };

    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    /**
     * Cria um filtro para o nome dos bancos
     */
    vm.createFilterForBank = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0 || item.number_bank.indexOf(query) === 0);
      };
    };

    /**
     * Se for clicado no botão "adicionar e continuar" irá realizar a limpeza do objeto e manter apenas os dados necessários
     */
    vm.clearFields = function () {
      var temp = {};

      temp.date = vm.currentItem.date;
      temp.current_account = vm.currentItem.current_account;
      temp.method = vm.currentItem.method;
      temp.accrual = vm.currentItem.accrual;
      temp.tags = vm.currentItem.tags;

      vm.currentItem = temp;
    };

    /**
     * Transforma um objeto do tipo arquivo para base64
     * @param file
     */
    vm.transformFileToBase64 = function (file) {
      var deffered = Common.$q.defer();
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        deffered.resolve(reader.result);
      };
      reader.onerror = function (error) {
        deffered.reject(error);
      };
      return deffered.promise;
    };

    vm.addItemToObject = function (files) {
      files.forEach(function (item) {
        vm.transformFileToBase64(item.lfFile)
          .then(function (base64) {
            item.base64 = base64;
          });
      })
    };

    /**
     * Insere nova entrada
     * @param form - formulário
     * @param payment - dados da entrada
     * @param not_categorized - se é não categorizado
     * @param debit_credit - se é de crédito ou débito
     * @param add_continue - se true, irá fazer o submit e manter a sidenav aberta para continuar adicionando entradas
     */
    vm.insertNewPaymentAndReceipt = function (form, payment, not_categorized, debit_credit, add_continue) {
      var result = null;
      add_continue = angular.isUndefined(add_continue) ? false : add_continue;

      if (angular.isDefined(payment.id) && payment.id !== null) {
        payment.accrual_month = payment.accrual !== undefined && payment.accrual !== null ? payment.accrual.getMonth() + 1 : null;
        payment.accrual_year = payment.accrual !== undefined && payment.accrual !== null ? payment.accrual.getFullYear() : null;
        payment.person_id = payment.person !== undefined ? payment.person.id : null;
        payment.bill_category_id = payment.category.id;
        payment.due_date = payment.date !== a4Moment(payment.due_date) ? a4Moment(payment.date).format("YYYY-MM-DD")
          : a4Moment(payment.due_date).format("YYYY-MM-DD");
        vm.updateSingleBill(payment);
      } else if (!not_categorized && form.$valid) {
        if (payment.amount !== null) {
          result = {
            'accrual_month': payment.accrual !== undefined && payment.accrual !== null ? payment.accrual.getMonth() + 1 : null,
            'accrual_year': payment.accrual !== undefined && payment.accrual !== null ? payment.accrual.getFullYear() : null,
            'amount': payment.amount,
            'bill_category_id': payment.category.id,
            'debit_credit': debit_credit,
            'description': payment.description,
            'document_reference': payment.document_reference,
            'due_date': a4Moment(payment.date).format("YYYY-MM-DD"),
            'payment_with_difference': false,
            'payments': [{
              'amount': payment.amount,
              'bank_id': payment.bank !== undefined ? payment.bank.id : null,
              'account': payment.bank_account !== undefined ? payment.bank_account : null,
              'branch': payment.bank_branch !== undefined ? payment.bank_branch : null,
              'number': payment.document !== undefined ? payment.document : null,
              'current_account_id': payment.current_account.id,
              'date': a4Moment(payment.date).format("YYYY-MM-DD"),
              'debit_credit': debit_credit,
              'document': payment.document,
              'movement_type_id': payment.method,
              'notes': payment.notes
            }],
            'bill_details': [{
              'bill_category_id': payment.category.id,
              'description': payment.description,
              'amount': payment.amount
            }],
            'person_id': payment.person !== null ? payment.person.id : null,
            'tags': payment.tags,
            'was_paid': 0,
            'files': payment.files,
            'type': 6
          };

          vm.savePayment(result, add_continue);
        }
      } else if (not_categorized && form.$valid) {
        if (payment.method !== null && payment.amount !== null) {
          result = {
            'current_account_id': payment.current_account.id,
            'document': payment.document,
            'movement_type_id': payment.method,
            'amount': payment.amount,
            'date': a4Moment(payment.date).format("YYYY-MM-DD"),
            'due_date': a4Moment(payment.date).format("YYYY-MM-DD"),
            'debit_credit': debit_credit,
            'files': payment.files,
            'type': 6
          };

          vm.saveMovement(result, add_continue);
        }
      }
    };

    /**
     * Update do recebimento
     * @param bill
     */
    vm.updateSingleBill = function (bill) {
      BillReceiptService.updateSingleBill(bill)
        .then(function () {
          Common.Toast.success($filter('translate')('UPDATE_SUCCESS'));
          vm.close();
        })
        .catch(function (response) {
          if (response === "REDUCTION_PORTION_DENIED") {
            Common.Toast.error('CANT_REDUCE_PORTIONS_RECURRENCE');
          } else {
            Common.Toast.error('UPDATE_ERROR');
          }
        });
    };

    /**
     * savePayment
     * @param obj
     * @param add_continue
     */
    vm.savePayment = function (obj, add_continue) {
      CurrentAccountService.createPayment(obj)
        .then(function (response) {
          if (response !== null) {
            if (response.result === true && add_continue) {
              Common.Toast.success('Entrada realizada com sucesso.');
              vm.clearFields();
            } else if (response.result === true) {
              Common.Toast.success('Entrada realizada com sucesso.');
              vm.close();
            }
          }
        })
        .catch(function (response) {
          switch (response.status) {
            case 406:
              if (response.data.message === 'WITHOUT_AMOUNT_TO_TRANSACTION') {
                vm.confirmNegativePayment(obj);
              }
              break;
            case 502:
              Common.Toast.error(JSON.stringify(response.data));
              break;
          }
        });

    };

    /**
     * Executa a requisição para realização de pagemento.
     * @param payment
     * @param add_continue
     */
    vm.saveMovement = function (payment, add_continue) {
      CurrentAccountService.createMovement(payment)
        .then(function (response) {
          if (response !== null) {
            if (response.result === true && add_continue) {
              Common.Toast.success('Movimento realizado com sucesso.');
              vm.clearFields();
            } else if (response.result === true) {
              Common.Toast.success('Movimento realizado com sucesso.');
              vm.close();
            }
          }
        })
        .catch(function (response) {
          switch (response.status) {
            case 406:
              if (response.data.message === 'WITHOUT_AMOUNT_TO_TRANSACTION') {
                vm.confirmNegativeMovement(payment);
              }
              break;
            case 502:
              Common.Toast.error(JSON.stringify(response.data));
              break;
          }
        });
    };

    /**
     * Exclui uma entrada do extrato
     * @param item
     */
    vm.delete = function (item) {
      ModalFactory.confirm(null,
        'Confirmação de Exclusão',
        'Deseja realmente excluir a entrada?',
        'Confirmar',
        'Cancelar',
        'finance')
        .then(function () {
          CurrentAccountService.deleteBill(item.id)
            .then(function () {
              Common.Toast.success('Entrada removida com sucesso');
              vm.close();
            })
            .catch(function () {
              Common.Toast.error('Erro ao excluir');
            });
        });
    };

    /**
     * confirmNegativePayment
     * Se a conta não tem saldo para a transação, confirmar com o usuário se deseja entrar no 'limite'
     * @param payment
     */
    vm.confirmNegativePayment = function (payment) {

      var confirm = $mdDialog.confirm()
        .title('Você não tem saldo para realizar essa ação. Deseja continuar?')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm)
        .then(function () {

          payment.confirm = true;
          vm.savePayment(payment);

        })
        .catch(function () {
          vm.close();
          Common.Toast.warning('Ação cancelada.');
        });
    };

    vm.close = function () {
      $a4Sidenav().close()
        .then(function () {
          $rootScope.$broadcast("CURRENT_ACCOUNT_CONTROLLER.update");
        })
    };

    vm.init();
  }

  angular
    .module('app.finance.currentaccount')
    .controller('CurrentAccountEntryCreditController', CurrentAccountEntryCreditController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountDetailsController($rootScope, $scope, $state, $stateParams, $a4Sidenav,
                                           $sce, PoliciesService, Common, $mdConstant,
                                           BillExpenseActionsService, ReportsService,
                                           CurrentAccountService, $filter, $mdDialog, a4Moment,
                                           $a4FloatButton, ModalFactory, CheckReceivedService) {
    var vm = this;
    vm.current_accounts = [];
    vm.action = {};
    vm.order = "asc";
    vm.currentItem = {
      date: a4Moment()
    };
    vm.show_buttons = false;
    vm.current_account_types = CurrentAccountService.getCurrentAccountTypes();
    vm.showReconcileMovement = true;
    vm.currentItem.not_current_account = [];
    vm.selected_account = {};
    vm.account_clicked = [];
    vm.alreadySelected = false;
    vm.showGrafic = true;
    vm.methods = [{id: 1, name: "Dinheiro"}, {id: 2, name: "Cheque"}, {id: 5, name: "Cheque de terceiros"},
      {id: 10, name: "Boleto"}, {id: 11, name: "Depósito"}, {id: 12, name: "Transferência"},
      {id: 20, name: "Cartão de débito"}, {id: 21, name: "Cartão de crédito"}
    ];
    vm.filter_date = {
      startDate: a4Moment().startOf('month').format('YYYY-MM-DD'),
      endDate: a4Moment().endOf('month').format('YYYY-MM-DD')
    };

    vm.balance = {};

    /**
     *
     */
    vm.init = function () {
      vm.current_account_id = $stateParams.id;
      vm.selected_account = $stateParams.item;

      vm.getAccountById(vm.current_account_id)
        .then(function () {
          vm.getAllMovements(vm.current_account_id, vm.filter_date.startDate, vm.filter_date.endDate);
          /** Apenas coloca o botão caso não seja uma conta a4pag */
          if (vm.current_account_types.CONTA_A4PAG !== vm.selected_account.current_account_type_id) {
            vm.show_buttons = true;
          }
          vm.getCurrentAccountBalance(vm.current_account_id, vm.filter_date.startDate, vm.filter_date.endDate)
        });
    };

    vm.reorder = function (order) {
      if (vm.order === "asc") {
        vm.order = "desc";
      } else {
        vm.order = "asc";
      }
      vm.getAllMovements(vm.current_account_id, vm.filter_date.startDate, vm.filter_date.endDate);
    };

    vm.addFile = function (movement) {
      ModalFactory.customClean("app/finance/current-account/views/dialogs/file-batch.html",
        "MovementFilesController", "vm", false, movement);
    }

    vm.toggle = function (element_id) {
      angular.element(element_id).toggle();
    };

    /**
     * Visualização de total
     */
    vm.viewBalance = function () {
      ModalFactory.customClean('app/finance/current-account/views/dialogs/account_balance.html',
        'BalanceController', 'vm', true, vm.balance);
    };

    /**
     * changeCurrentAccount
     * Troca a conta corrente ativa para extrato e gráfico
     * @param idx
     */
    vm.changeCurrentAccount = function (idx) {
      if (vm.items.length && idx !== null) {
        vm.selected_account = vm.items[idx];
        var result = {account_id: vm.selected_account.id};

        vm.currentItem.current_account = vm.selected_account;
        //filtro de range de datas
        if (vm.filter_date !== null) {
          result.startDate = vm.filter_date.startDate.format('YYYY-MM-DD');
          result.endDate = vm.filter_date.endDate.format('YYYY-MM-DD');
        }
        vm.getAllMovements(result);
        vm.getCurrentAccountBalance(result);
      }
    };


    /**
     * getCurrentAccountBalance
     * Retorna o saldo do banlanço da conta
     */
    vm.getCurrentAccountBalance = function (account_id, start_date, end_date) {

      start_date = a4Moment(start_date).format('YYYY-MM-DD');
      end_date = a4Moment(end_date).format('YYYY-MM-DD');

      CurrentAccountService.getAccountBalance({account_id: account_id, startDate: start_date, endDate: end_date})
        .then(function (response) {
          vm.balance = response.plain();
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };
    /**
     * listAllAccounts
     * Retorna todas as contas
     */
    vm.listAllAccounts = function () {
      vm.promise = CurrentAccountService.listAll()
        .then(function (response) {
          if (response) {
            vm.items = response.plain();
            vm.current_accounts = response;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * Realiza estorno
     * @param item
     */
    vm.chargeback = function (item) {
      item.id = item.bill_id;
      item.status = 10;
      BillExpenseActionsService.chargeback(item);
    };


    /**
     * Fazer/Desfazer conciliação de movimento.
     * @param ev
     * @param movement
     */
    vm.reconcileMovement = function (ev, movement) {
      var answerCheck = null;

      if (movement.is_conciliated) {
        var msg = 'Deseja realmente cancelar esta conciliação?';
        ModalFactory.confirm(ev, 'Desfazer conciliação', msg, 'Confirmar', 'Cancelar')
          .then(function () {
            if (movement.movement_type_id === 2) {
              var formatDate = movement.date.split('/');
              var formatDateFinal = new Date(formatDate[2] + '/' + formatDate[1] + '/' + formatDate[0]);
              answerCheck = {
                'id': movement.movement_id,
                'date': formatDateFinal
              };
              vm.checkUpdateReconcile(answerCheck)
                .then(function () {
                  movement.is_conciliated = false;
                });
            } else {
              vm.simpleUpdateReconcile(movement.movement_id)
                .then(function () {
                  movement.is_conciliated = false;
                });
            }
          });
      } else if (movement.movement_type_id === 2) {
        vm.check = angular.copy(movement);
        ModalFactory.customClean('app/finance/current-account/views/dialogs/check_issued.html',
          'CurrentAccountCheckIssuedController', 'vm', true, vm.check)
          .then(function (answer) {
            answerCheck = {
              'id': answer.movement_id,
              'date': answer.date
            };
            vm.checkUpdateReconcile(answerCheck)
              .then(function () {
                movement.is_conciliated = true;
              });
          });
      } else {
        vm.simpleUpdateReconcile(movement.movement_id)
          .then(function () {
            movement.is_conciliated = true;
          });
      }
    };

    /**
     * SideNav de criação de entrada financeira em conta corrente
     * @param account - Conta corrente
     */
    vm.createReceipt = function (account) {
      $a4Sidenav().open(
        'app/finance/current-account/views/sidenavs/account_entry.html',
        'CurrentAccountEntryCreditController',
        'vm',
        {account: account}
      );
      vm.getAccountId(account.id);
    };

    /**
     * SideNav de edição de entrada financeira em conta corrente
     * @param bill_id - Identificador do titulo
     */
    vm.editReceipt = function (bill_id) {
      $a4Sidenav().open(
        'app/finance/current-account/views/sidenavs/account_entry.html',
        'CurrentAccountEntryCreditController',
        'vm',
        {bill_id: bill_id, account: vm.selected_account}
      );
      vm.getAccountId(vm.selected_account.id);
    };

    /**
     * SideNav de criação de saida financeira em conta corrente
     * @param account - Conta corrente selecionada
     */
    vm.createPayment = function (account) {
      $a4Sidenav().open(
        'app/finance/current-account/views/sidenavs/account_output.html',
        'CurrentAccountOutputCreditController',
        'vm',
        {account: account}
      );
      vm.getAccountId(account.id);
    };

    /**
     * SideNav de edição de saida financeira em conta corrente
     * @param bill_id - Identificador do titulo
     */
    vm.editPayment = function (bill_id) {
      $a4Sidenav().open(
        'app/finance/current-account/views/sidenavs/account_output.html',
        'CurrentAccountOutputCreditController',
        'vm',
        {bill_id: bill_id, account: vm.selected_account}
      );
      vm.getAccountId(vm.selected_account.id);
    };

    /**
     * getById
     * Retorna uma conta pelo id
     * @param id
     */
    vm.getAccountById = function (id) {
      var deffered = Common.$q.defer();
      CurrentAccountService.getById(id)
        .then(function (response) {
          deffered.resolve(true);
          vm.selected_account = response.plain();
        })
        .catch(function () {
          deffered.reject(false);
        });

      return deffered.promise;
    };


    /**
     * Retorna a conta corrente pelo identificador
     * @param id - Identificador da conta corrente
     */
    vm.getAccountId = function (id) {
      angular.forEach(vm.current_accounts, function (value) {
        if (value.id === id) {
          vm.currentItem.current_account = value;
          vm.selected_account = value;
          vm.alreadySelected = true;
        }
      });
    };

    /**
     * Desfazer transferencia
     * @param $event
     * @param movement
     */
    vm.removeTransference = function ($event, movement) {
      ModalFactory.prompt(
        $event,
        'Desfazer Transferência',
        'Escreva uma pequena justificativa para a ação de desfazer transferência',
        'Escreva a justificativa',
        '',
        'Desfazer',
        'Cancelar'
      ).then(function (resp) {
        if (resp !== '' && resp !== null) {
          movement.justification = resp;
          vm.reversalTransference(movement);
        } else {
          Common.Toast.warning('Justificativa é obrigatória.');
        }
      });
    };

    /**
     * Desfazer compensação
     * @param movement - Movimento selecionado
     */
    vm.removeCompensationCreditEdit = function (movement) {
      var obj = {
        'account_id': movement.account_id,
        'id': movement.movement_id
      };

      var confirm = $mdDialog.confirm()
        .title('Você confirma a exclusão desta compensação de cheques?')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm)
        .then(function () {
          CurrentAccountService.deleteMovementAccount(obj)
            .then(function (response) {
              if (response.result) {
                vm.listAllAccounts();
                vm.changeCurrentExtract();
                Common.Toast.success('Compensação deletada com sucesso.');
              }
            })
            .catch(function() {
              Common.Toast.error('Algo deu errado na exclusão item!')
            });
        });
    };

        /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
        vm.checkPolicies = function (policy) {
          return !PoliciesService.checkPolicyFromMenu(policy);
        };

      
    /**
     * Edição de compensação de credito
     * @param movement
     */
    vm.compensationCreditEdit = function (movement) {

      vm.credit = {};
      vm.credit.checkList = [];
      var mDate = movement.date.split('/');
      vm.credit.date = new Date(mDate[2] + '/' + mDate[1] + '/' + mDate[0]);
      vm.credit.account_id = movement.account_id;
      vm.credit.id = movement.movement_id;
      vm.credit.amount = movement.moneyIn;

      ModalFactory.customClean('app/finance/current-account/views/dialogs/compensation_credit.html',
        'CurrentAccountCompensationCreditController', 'vm', false, vm.credit)
        .then(function (answer) {
          vm.creditForm(answer);
        });
    };

    vm.createTransference = function (account) {
      $a4Sidenav().open(
        'app/finance/current-account/views/sidenavs/account_transference.html',
        'CurrentAccountTransferenceCreditController',
        'vm',
        account
      );
      vm.getAccountId(account.id);
    };

    /**
     * Soma o valor dos cheques no dia
     * @returns {number}
     */
    vm.sumChecksValue = function (list) {
      var result = 0;
      angular.forEach(list, function (item) {
        if (item.amount !== '') {
          item.amount = item.amount === null ? 0 : parseFloat(item.amount);
          result = (result + parseFloat(item.amount.toFixed(2)));
        }
      });
      return result.toFixed(2);
    };

    /**
     * Criação de credito de compensação
     * @param account_selected - Conta selecionada
     */
    vm.compensationCredit = function (account_selected) {
      CheckReceivedService.getAll({
        startDate: a4Moment().format('YYYY-MM-DD'),
        endDate: a4Moment().format('YYYY-MM-DD'),
        status: '2'
      })
        .then(function (response) {
          vm.credit = {};
          vm.credit.checkList = [];
          vm.credit.date = a4Moment().format('YYYY-MM-DD');
          vm.credit.amount = 0.00;
          vm.credit.account_selected = account_selected;
          vm.credit.checkList = response;
          vm.credit.amount = vm.sumChecksValue(vm.credit.checkList);

          if (!vm.credit.checkList) {
            Common.Toast.warning('Não há cheques dispóniveis nesta data');
            return false;
          }

          ModalFactory.customClean('app/finance/current-account/views/dialogs/compensation_credit.html',
            'CurrentAccountCompensationCreditController', 'vm', false, vm.credit)
            .then(function (answer) {
              vm.creditForm(answer);
            });
        });
    };


    /**
     * Atualiza conciliação de movimento de cheque próprio.
     * @param obj
     */
    vm.checkUpdateReconcile = function (obj) {
      var deffered = Common.$q.defer();
      CurrentAccountService
        .checkUpdateReconcile(obj)
        .then(function () {
          // vm.changeCurrentExtract();
          deffered.resolve(true);
          Common.Toast.success('Movimento atualizado com sucesso.');
        }).catch(function () {
        deffered.reject(false);
        Common.Toast.warning('Erro ao atualizar movimento.');
      });
      return deffered.promise;
    };


    /**
     * Insere novo pagamento
     * @param form
     * @param payment
     * @param not_categorized
     * @param debit_credit
     */
    vm.insertNewPaymentAndReceipt = function (form, payment, not_categorized, debit_credit) {
      var result = null;
      if (!not_categorized && form.$valid) {
        if (payment.person !== null && payment.amount !== null) {
          result = {
            'accrual_month': payment.accrual_month,
            'accrual_year': payment.accrual_year,
            'amount': payment.amount,
            'bill_category_id': payment.category.id,
            'debit_credit': debit_credit,
            'description': payment.description,
            'document_reference': payment.document_reference,
            'issue_date': payment.date,
            'notes': payment.notes,
            'payment_with_difference': false,
            'payments': [{
              'amount': payment.amount,
              'current_account_id': payment.current_account.id,
              'date': payment.date,
              'debit_credit': debit_credit,
              'document': payment.document,
              'movement_type_id': payment.method
            }],
            'bill_details': [{
              'bill_category_id': payment.category.id,
              'description': payment.description,
              'amount': payment.amount
            }],
            'person_id': payment.person.id,
            'tags': payment.tags,
            'was_paid': 0,
            'files': payment.files
          };

          vm.savePayment(result);
        }
      } else if (not_categorized && form.$valid) {
        if (payment.method !== null && payment.amount !== null) {
          result = {
            'current_account_id': payment.current_account.id,
            'document': payment.document,
            'movement_type_id': payment.method,
            'amount': payment.amount,
            'date': payment.date,
            'issue_date': payment.date,
            'debit_credit': debit_credit,
            'files': payment.files
          };
          vm.saveMovement(result);
        }
      }
    };


    /**
     * getAllMovements
     * Retorna todos os movements da conta corrente
     * @param account_id
     * @param start_date
     * @param end_date
     */
    vm.getAllMovements = function (account_id, start_date, end_date) {
      $rootScope.show_loader = true;
      start_date = a4Moment(start_date).format('YYYY-MM-DD');
      end_date = a4Moment(end_date).format('YYYY-MM-DD');
      var obj = {account_id: account_id, startDate: start_date, endDate: end_date, order: vm.order};
      CurrentAccountService.getAllMovements(obj)
        .then(function (response) {
          vm.all_movements = response;
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });
    };

    vm.printMovementAccount = function () {
      ReportsService.reportFactory('GET',
        'api/reports/printmovementaccount',
        {
          account_id: vm.all_movements.reqParams.account_id,
          start_date: vm.all_movements.reqParams.startDate,
          end_date: vm.all_movements.reqParams.endDate,
          order: vm.all_movements.reqParams.order
        }
      )
    }

    /**
     * Retorna os cheque recebidos
     * @param method
     */
    vm.getCheckReceived = function (method) {
      vm.checks_required = false;
      if (method === 2) {
        CurrentAccountService.getAllThirdPartyInHandChecks()
          .then(function (checks) {
            vm.checks_received = checks;
            vm.checks_required = true;
          });
      }
    };

    /**
     * Formata a descrição do movimento
     * @param description String - Descrição
     */
    vm.formatDescription = function (description) {
      var description_array = description.split("|");

      var final_description = "";

      description_array.forEach(function (item) {

        var getbadge = /\[\[([^)]+)\]\]/;
        var matches = getbadge.exec(item);
        var badge = "";

        item = item.split("[[", 1)[0];

        if (matches != null) {
          badge = "<span style='padding: 3px;background-color: rgb(8,204,117);color: white;border-radius: 5px;font-size: 11px;'>" + matches[1] + "</span>";
        }

        final_description += item + badge + "<br />"

      });
      return $sce.trustAsHtml("<div>" + final_description + "</div>");
    };

    /**
     * apiErrorMessageByStatusCode
     * Toast error com mensagens baseada no statusCode da api
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 409:
          Common.Toast.warning('Apenas informações de cartão / cobrança podem ser atualizadas para essa conta.');
          $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-form'});
          break;
        case 304:
          Common.Toast.error('Você não pode modificar os dados dessa conta.');
          break;
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista');
          break;
        case 406:
          if (response.data !== null && response.data.message !== null) {
            Common.Toast.error($filter('translate')(response.data.message));
          } else {
            Common.Toast.error('Existem erros no formulário.');
          }
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor');
          break;
      }
    };


    /**
     * confirmNegativeMovement
     * Se a conta não tem saldo para a transação, confirmar com o usuário se deseja entrar no 'limite'
     * @param payment
     */
    vm.confirmNegativeMovement = function (payment) {

      var confirm = $mdDialog.confirm()
        .title('Você não tem saldo para realizar essa ação. Deseja continuar?')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm)
        .then(function () {
          payment.confirm = true;
          vm.saveMovement(payment);
        })
        .catch(function () {
          $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-create-output'});
          $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-create-entry'});
          Common.Toast.warning('Ação cancelada.');
        });
    };


    /**
     * Atualiza o extrato da conta corrente selecionada.
     */
    vm.changeCurrentExtract = function () {
      var result = {account_id: vm.selected_account.id};
      //filtro de range de datas
      if (vm.filter_date !== null) {
        result.startDate = vm.filter_date.startDate;
        result.endDate = vm.filter_date.endDate;
      }
      vm.getAllMovements(result.account_id, result.startDate, result.endDate);
    };


    /**
     * Executa ação de desfazer transferência.
     * @param movement
     */
    vm.reversalTransference = function (movement) {
      CurrentAccountService.reversalTransference(movement)
        .then(function (response) {
          if (response !== null) {
            if (response.result) {
              vm.listAllAccounts();
              vm.changeCurrentExtract();
              Common.Toast.success('Transferência desfeita com sucesso')
            } else {
              Common.Toast.error("Problemas ao desfazer transferência", 'A4 Web')
            }
          }
        })
        .catch(function () {
          Common.Toast.error('Erro ao listar tipos de contas.');
        });
    };


    /**
     * Atualiza conciliação de movimento.
     * @param id
     */
    vm.simpleUpdateReconcile = function (id) {
      var deffered = Common.$q.defer();
      CurrentAccountService
        .simpleUpdateReconcile({'id': id})
        .then(function () {
          //vm.changeCurrentExtract();
          deffered.resolve(true);
          Common.Toast.success('Movimento atualizado com sucesso.');
        }).catch(function () {
        deffered.reject(false);
        Common.Toast.warning('Erro ao atualizar movimento.');
      });
      return deffered.promise;
    };

    /**
     * applyMask
     * @param value
     * @param debitCredit
     * @returns {string}
     */
    vm.applyMask = function (value, debitCredit) {
      var currency = '';
      if (value != null && value !== undefined && value !== '') {
        var currencyValue = "";
        if (value < 0) {
          //quando o saldo for menor que zero
          value = (-1 * value);
          currency = $filter('currency')(value, '', 2);
          currencyValue = currency.replace(".", ",").replace(",", ".");
          currencyValue = "- " + currencyValue;
        } else {
          currency = $filter('currency')(value, '', 2);
          currencyValue = currency.replace(".", ",").replace(",", ".");

          if (debitCredit === 'd') {
            currencyValue = "- " + currencyValue;
          }
        }
        return currencyValue;
      }
    };


    /**
     * Remove cartão da conta ativa
     */
    var listener2 = $rootScope.$on('a4-edit-table.remove-item', function (evt, params) {
      if (params && params.item !== null && params.item.id !== null && params.type === 'cards') {
        var id = params.item.id;
        CurrentAccountService.removeCardById(id)
          .then(function (response) {
            if (response) {
              Common.Toast.success('Cartão removido com sucesso.');
            }
          })
          .catch(function (response) {
            vm.apiErrorMessageByStatusCode(response);
          });
      }
    });

    /**
     * Remove configuração de cobrança da conta ativa
     */
    var listener3 = $rootScope.$on('a4-edit-table.remove-item', function (evt, params) {
      if (params && params.item !== null && params.item.id !== null && params.type === 'collectionConfigs') {
        var item_id = params.item.id;
        var current_account_id = params.current_account_id;

        CurrentAccountService.verifyIfHasGeneratedSlipBeforeDelete(item_id, current_account_id)
          .then(function (response) {
            if (response) {
              Common.Toast.success('Configuração de cobrança removida com sucesso.');
            }
          })
          .catch(function (response) {
            vm.apiErrorMessageByStatusCode(response);
          });
      }
    });


    /**
     * Realiza transferencia de valores entre contas
     */
    vm.insertTransference = function (form, item, selected_account) {
      if (item.date === '' || item.date === null) {
        item.date = a4Moment().format('YYYY-MM-DD');
      }

      var result = {
        'current_account_id': selected_account.id,
        'current_account_id_transf': item.current_account.id,
        'document': item.document,
        'movement_type_id': item.method !== null ? item.method : 12,
        'amount': item.amount,
        'date': item.date,
        'files': item.files
      };

      vm.saveTransference(result, selected_account);
    };

    var listener4 = $rootScope.$on("CURRENT_ACCOUNT_CONTROLLER.update", function () {
      vm.changeCurrentExtract();
    });

    var listener5 = $rootScope.$on("CURRENT_ACCOUNT_CONTROLLER.create_edit", function () {
      vm.listAllAccounts();
    });

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Destroy events
     */
    $scope.$on('$destroy', function () {
      [listener2, listener3, listener4, listener5].forEach(function (fn) {
        fn();
      });
    });

    vm.init();

  }

  angular
    .module('app.finance.currentaccount')
    .controller('CurrentAccountDetailsController', CurrentAccountDetailsController);

})();

(function () {
  'use strict';

  function CurrentAccountCreateEditController(SideExtra, $a4Sidenav, angularMomentConfig, Common,
                                              CurrentAccountService, $rootScope, $filter) {

    var vm = this;

    vm.CONTA_CARTAO_DE_CREDITO = 5;
    vm.CONTA_CARTAO_DE_CREDITO_RECEBIVEL = 4;
    vm.CONTA_BANCO = 2;
    vm.CONTA_INVESTIMENTO = 3;

    vm.currentItem = {};

    vm.init = function () {
      if (SideExtra.id !== undefined) {
        vm.currentItem = SideExtra;
      }
      vm.listAlltypes();
      vm.getBankAccounts();
      vm.getBanks();
      vm.getYears();
      vm.getDays();
      vm.getCompanies();

    };

    /**
     * listAlltypes
     * Retorna array com todos os tipos de conta
     */
    vm.listAlltypes = function () {
      CurrentAccountService.getAlltypes()
        .then(function (response) {
          if (response) {
            vm.types = response;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    vm.getBankAccounts = function () {
      CurrentAccountService.getAccountsTypeBank()
        .then(function (resp) {
          vm.bank_accounts = resp;
        })
    };

    vm.getCompanies = function () {
      CurrentAccountService.getCompanies()
        .then(function (resp) {
          vm.companies = resp;
        })
    };

    /**
     * getBanks
     * Retorna lista de bancos
     * Retorna a lista de bancos
     */
    vm.getBanks = function () {
      CurrentAccountService.getBanks()
        .then(function (response) {
          vm.banks = response;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    vm.submit = function (account) {

      if (!angular.isUndefined(account.id)) {

        CurrentAccountService.updateCurrentAccount(account)
          .then(function (response) {
            if (response != null) {
              $rootScope.$broadcast('a4.table.close.sidenav', {template: 'sidenav-form'});
              switch (response.message) {
                case('ANOTHER_DATA_UPDATED_SUCCESSFULLY'):
                  Common.Toast.success('Apenas informações de cartão e cobrança foram atualizadas.');
                  break;
                default:
                  Common.Toast.success('Informações atualizadas com sucesso.');
                  break;
              }
              vm.close();
            }
          })
          .catch(function (response) {
            vm.apiErrorMessageByStatusCode(response);
          });

      } else {

        CurrentAccountService.storeCurrentAccount(account)
          .then(function (response) {
            if (response != null) {
              Common.Toast.success('Conta criada com sucesso.');
              vm.close();
            }
          })
          .catch(function (response) {
            vm.apiErrorMessageByStatusCode(response);
          });
      }
    };

    /**
     * Retorna o range de anos
     */
    vm.getYears = function () {
      vm.years = [];
      for (var i = 2013; i < 2040; i++) {
        vm.years.push({id: i, label: i});
      }
    };

    /**
     * Retorna o range de anos
     */
    vm.getDays = function () {
      vm.days = [];
      for (var i = 1; i < 31; i++) {
        vm.days.push({id: i, label: i});
      }
    };

    /**
     * apiErrorMessageByStatusCode
     * Toast error com mensagens baseada no statusCode da api
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 409:
          Common.Toast.warning('Apenas informações de cartão / cobrança podem ser atualizadas para essa conta.');
          break;
        case 304:
          Common.Toast.error('Você não pode modificar os dados dessa conta.');
          break;
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista');
          break;
        case 406:
          if (response.data != null && response.data.message != null) {
            Common.Toast.error($filter('translate')(response.data.message));
          } else {
            Common.Toast.error('Existem erros no formulário.');
          }
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor');
          break;
      }
    };

    vm.close = function () {
      $a4Sidenav().close()
        .then(function () {
          $rootScope.$broadcast("UPDATE_CURRENT_ACCOUNT_LIST");
        })
    };

    vm.init();

  }

  angular
    .module('app.finance.currentaccount')
    .controller('CurrentAccountCreateEditController', CurrentAccountCreateEditController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountCompensationCreditController(ModalExtra, $mdDialog, CheckReceivedService) {
    var vm = this;
    vm.credit = ModalExtra;

    vm.query = {
      limit: 1000,
      page: 1
    };


    /**
     * changeDateCompensation
     * Filtra os cheques de compensação de acordo com a data
     */
    vm.changeDateCompensation = function (date) {
      var status = '2';
      var account = vm.credit.account_selected;
      var filter = {status: status, account: account, startDate: date.format('YYYY-MM-DD'), endDate: date.format('YYYY-MM-DD')};

      vm.CheckReceivedSugestionValue(filter);
    };

    /**
     * CheckReceivedService
     * Retorna todos os cheques de acordo com o filtro
     */
    vm.CheckReceivedSugestionValue = function (filter) {
      CheckReceivedService.getAll(filter)
        .then(function (response) {
          if (response != null) {
            vm.credit.checkList = response;
            vm.credit.amount = vm.sumChecksValue(vm.credit.checkList);
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * Soma o valor dos cheques no dia
     * @returns {number}
     */
    vm.sumChecksValue = function (list) {
      var result = 0;
      angular.forEach(list, function (item) {
        if (item.amount != '') {
          item.amount = item.amount == null ? 0 : parseFloat(item.amount);
          result = (result + parseFloat(item.amount.toFixed(2)));
        }
      });
      return result.toFixed(2);
    };

    vm.answer = function (answer, form) {
      if (form.$valid) {
        $mdDialog.hide(answer);
      } else {
        Common.Toast.error('Preencha corretamente os dados.');
      }
    };

    vm.closeModal = function () {
      $mdDialog.cancel();
    };


  }

  angular
    .module('app.finance.currentaccount')
    .controller('CurrentAccountCompensationCreditController', CurrentAccountCompensationCreditController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function CurrentAccountCheckIssuedController(ModalExtra, $mdDialog) {
    var vm = this;
    vm.check = ModalExtra;
    vm.formatDate = vm.check.date.split('/');
    vm.check.date = new Date(vm.formatDate[2]+'/'+vm.formatDate[1]+'/'+vm.formatDate[0]);

    vm.answer = function (answer, form) {
      if (form.$valid) {
        $mdDialog.hide(answer);
      } else {
        Common.Toast.error('Preencha corretamente os dados.');
      }
    };

    vm.closeModal = function () {
      $mdDialog.cancel();
    };


  }

  angular
    .module('app.finance.currentaccount')
    .controller('CurrentAccountCheckIssuedController', CurrentAccountCheckIssuedController);
})();
(function () {
  'use strict';
  angular
    .module('app.finance.credits', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function CreditsService(Restangular) {

    var getAllCredits = function (obj) {
      return Restangular.one('movement').one('getallcredits').get(obj);
    };

    var getCreditsPerson = function (obj) {
      return Restangular.one('movement').one('getcreditsperson').get(obj);
    };

    var getLastCreditFromPersons = function (obj) {
      return Restangular.one('movement').one('getlastcreditfrompersons').get(obj);
    };

    var getRefundInfo = function (obj) {
      return Restangular.one('movement').one('getrefundinfo').get(obj);
    };

    var refundCredit = function (obj) {
      return Restangular.one('movement').all('refundcredit').post(obj);
    };

    return {
      getAllCredits: getAllCredits,
      getCreditsPerson: getCreditsPerson,
      getRefundInfo: getRefundInfo,
      refundCredit: refundCredit,
      getLastCreditFromPersons: getLastCreditFromPersons
    }
  }

  angular.module('app.finance.credits')
    .factory('CreditsService', CreditsService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.credits', {
        url: '/credits',
        public: false,
        templateUrl: 'app/finance/credits/views/index.html',
        controller: 'CreditsController',
        controllerAs: 'vm'
      })
  }

  angular
    .module('app.finance.credits')
    .config(routerConfig);

})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'credits_menu';
    var path = 'finance.credits';
    msNavigationService.saveItem('finance.credits', {
      title: 'Créditos',
      icon: 'icon-poll',
      state: 'private.finance.credits',
      auth: role,
      weight: 9,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.credits')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function CreditsController($scope, $rootScope, ModalFactory, CreditsService) {
    var vm = this;
    vm.grid = {};
    vm.show_inactives = false;

    vm.init = function () {
      vm.paginate(1, 20);
    };

    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      CreditsService.getAllCredits({
        limit: limit, page: page,
        show_inactives: vm.show_inactives
      }).then(function (response) {
        vm.grid.data = [];
        vm.grid = response.plain();
        $rootScope.show_loader = false;
      })
    };

    vm.showMovements = function (item) {
      ModalFactory.custom('app/finance/credits/views/modal.html', {
        person_id: item.person_id,
        person_name: item.person_name
      })
    };

    vm.init();
  }

  angular.module('app.finance.credits')
    .controller('CreditsController', CreditsController);
})();
(function () {
    'use strict';
    angular.module('app.finance.correctionindex', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function Correction(Restangular) {

    /**
     *
     * @returns {$q@call;defer.promise}
     */
    var getAllcorrectionIndexRoles = function () {
      return Restangular.one("correctionindex").all("getAll").getList();
    };

    /**
     * Faz requisição para criação da regra de acrecimos.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    var createcorrectionIndexRole = function (obj) {
      return Restangular.all("correctionindex").post(obj)
    };

    /**
     * Faz requisição para criação de detalhes.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    var getAllDetails = function (obj) {
      return Restangular.one("correctionindex").one('getAllDetails').get(obj);
    };

    /**
     * Faz requisição para criação de detalhes.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    var createcorrectionDetailsRole = function (obj) {
      return Restangular.one("correctionindex").all('addDetails').post(obj)
    };


    /**
     * Retorna da API todas as regras de ajuste.
     * @returns {$q@call;defer.promise}
     */
    var getOne = function (id) {
      return Restangular.one('correctionindex', id).one('edit').get();
    };

    /**
     * Retorna da API um dos detalhes da regra.
     * @returns {$q@call;defer.promise}
     */
    var getOneDetail = function (id) {
      return Restangular.one('correctionindex').one('getOneDetail', id).get();
    };

    /**
     * Retorna da API todas as regras de ajuste.
     * @returns {$q@call;defer.promise}
     */
    var deleteDetail = function (id) {
      return Restangular.one('correctionindex').one('destroyIndexDetail', id).remove();
    };

    /**
     * Faz requisição para atualização da regra de ajuste.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    var updatecorrectionIndexRole = function (obj) {
      return Restangular.one('correctionindex', obj.id).customPUT(obj);
    };

    /**
     * @param id
     */
    var verifyIfHasAdjustmentRule = function (id) {
      return Restangular.one('correctionindex').one('verifyIfHasIndexDetail', id).get();
    };


    /**
     * Faz requisição para atualização da regra de ajuste.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    var updatecorrectionDetailsRole = function (obj) {
      return Restangular.one('correctionindex').one('updatedetails', obj.id).patch(obj);
    };


    /**
     * Remove indice.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    var removeIndice = function (id) {
      return Restangular.one('correctionindex', id).remove();
    };

    return {
      getAllcorrectionIndexRoles: getAllcorrectionIndexRoles,
      createcorrectionIndexRole: createcorrectionIndexRole,
      getOne: getOne,
      updatecorrectionIndexRole: updatecorrectionIndexRole,
      createcorrectionDetailsRole: createcorrectionDetailsRole,
      updatecorrectionDetailsRole: updatecorrectionDetailsRole,
      getAllDetails: getAllDetails,
      getOneDetail: getOneDetail,
      deleteDetail: deleteDetail,
      removeIndice: removeIndice,
      verifyIfHasAdjustmentRule: verifyIfHasAdjustmentRule
    };
  }

  angular.module('app.finance.correctionindex')
    .factory('CorrectionIndexService', Correction);
})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.correctionindex', {
        url: '/settings/correctionindex',
        public: false,
        templateUrl: 'app/finance/correction-index/views/index.html',
        controller: 'CorrectionIndexController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Indices de Correção'
        }
      });
  }

  angular
    .module('app.finance.correctionindex')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function FinanceTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      'CREATE_SUCCESS': 'Indice criado com sucesso',
      'UPDATE_SUCCESS': 'Indice atualizado com sucesso'
    });

  }

  angular
    .module('app.finance')
    .config(FinanceTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function CorrectionIndex($filter, $location, $rootScope, $scope, $stateParams, a4Moment,
                           CorrectionIndexService, ModalFactory, Common) {
    var vm = this;
    vm.allRoles = [];
    vm.includeScope = {};
    vm.id = null;

    vm.months = [
      {id: 1, name: "Janeiro", english: "Jan"},
      {id: 2, name: "Fevereiro", english: "Feb"},
      {id: 3, name: "Março", english: "Mar"},
      {id: 4, name: "Abril", english: "April"},
      {id: 5, name: "Maio", english: "Mai"},
      {id: 6, name: "Junho", english: "Jun"},
      {id: 7, name: "Julho", english: "Jul"},
      {id: 8, name: "Agosto", english: "Ago"},
      {id: 9, name: "Setembro", english: "Set"},
      {id: 10, name: "Outubro", english: "Oct"},
      {id: 11, name: "Novembro", english: "Nov"},
      {id: 12, name: "Dezembro", english: "Dec"}
    ];

    vm.years = [
      {id: 2013, name: "2013"},
      {id: 2014, name: "2014"},
      {id: 2015, name: "2015"},
      {id: 2016, name: "2016"},
      {id: 2017, name: "2017"},
      {id: 2018, name: "2018"},
      {id: 2019, name: "2019"},
      {id: 2020, name: "2020"},
      {id: 2021, name: "2021"},
      {id: 2022, name: "2022"},
      {id: 2023, name: "2023"},
      {id: 2024, name: "2024"},
      {id: 2025, name: "2025"},
      {id: 2026, name: "2026"},
      {id: 2027, name: "2027"},
      {id: 2028, name: "2028"},
      {id: 2029, name: "2029"}
    ];

    var listener1 = $rootScope.$on('a4-table.toggled', function (ev, item) {
      if (item.id !== undefined) {
        vm.id = item.id;
        vm.getAllDetails(item.id);
      }
    });


    vm.init = function () {
      vm.index = $stateParams.id;
      vm.includeScope.months = vm.months;
      vm.includeScope.addDetails = vm.addDetails;
      vm.includeScope.editDetail = vm.editDetail;
      vm.includeScope.indexEdit = vm.indexEdit;
      vm.getAllcorrectionIndexRoles();
      if (vm.index !== undefined) {
        vm.getAllDetails(vm.index);
      }
    };


    vm.getAllcorrectionIndexRoles = function () {
      CorrectionIndexService.getAllcorrectionIndexRoles()
        .then(function (response) {
          vm.allRoles = response;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.indexCreate = function () {
      ModalFactory.prompt(null,
        'Criar indice de correção',
        ' ',
        'Nome do indice',
        '',
        'Salvar',
        'Cancelar').then(function (name) {
        if (name != null && name != '') {
          vm.create({name: name});
        } else {
          Common.Toast.warning('Nome da regra é obrigatória');
        }
      })
    };

    vm.indexEdit = function (item) {
      ModalFactory.prompt(null,
        'Editar nome do indice',
        ' ',
        'Nome do indice',
        item.name,
        'Salvar',
        'Cancelar')
        .then(function (name) {
          if (name != null && name != '') {
            item.name = name;
            vm.update(item);
          } else {
            Common.Toast.warning('Nome da regra é obrigatória');
          }
        })
    };

    vm.addDetails = function (id, list) {
      var data = {
        month: vm.months,
        year: vm.years
      };
      var currentItem = {};

      if (list.length > 0) {
        var newer = list[0];
        var next = newer.month.id + 1 <= 12 ? newer.month.id + 1 : 1;
        var nextDate = $filter('filter')(vm.months, {id: next})[0];
        currentItem = {
          month: a4Moment().month(nextDate.english).format('M'),
          year: a4Moment().year(newer.year).format('YYYY')
        };

      } else {
        currentItem = {
          month: a4Moment().format('M'),
          year: a4Moment().format('YYYY')
        };
      }


      ModalFactory.open('correction-index/details', null, null, data, currentItem, 'finance')
        .then(function (answer) {
          answer.index_id = id;
          vm.createIndexDetail(answer);
        });
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };


    vm.create = function (role) {
      if (role.name != '' && role.name != undefined) {
        CorrectionIndexService.createcorrectionIndexRole(role)
          .then(function () {
            Common.Toast.success($filter('translate')('CREATE_SUCCESS'));
            vm.getAllcorrectionIndexRoles();
            $rootScope.show_loader = false;
          })
          .catch(function (response) {
            if (response.data == "ALREADY_EXIST") {
              Common.Toast.error("Já existe indice com este nome.");
            }
            $rootScope.show_loader = false;
          });
      } else {
        Common.Toast.error("Nome é obrigatório");
      }
    };


    vm.createIndexDetail = function (correction) {
      if (correction.month != '' && correction.year != undefined && correction.percent) {
        CorrectionIndexService.createcorrectionDetailsRole(correction)
          .then(function () {
            Common.Toast.success($filter('translate')('CREATE_SUCCESS'));
            vm.getAllDetails(vm.id);
            $rootScope.show_loader = false;
          })
          .catch(function (response) {
            if (response.data == "ALREADY_EXISTS") {
              Common.Toast.error("Já existe indice com esta data.");
            }
            $rootScope.show_loader = false;
          });
      } else {
        Common.Toast.error("Todos as informações são necessárias");
      }
    };


    vm.updateIndexDetail = function (correction) {
      if (correction.month != '' && correction.year != undefined && correction.percent) {
        CorrectionIndexService.updatecorrectionDetailsRole(correction)
          .then(function () {
            Common.Toast.success($filter('translate')('UPDATE_SUCCESS'));
            vm.getAllDetails(vm.id);
            $rootScope.show_loader = false;
          })
          .catch(function (response) {
            if (response.data == "ALREADY_EXISTS") {
              Common.Toast.error("Já existe indice neste mês e ano.");
            }
            $rootScope.show_loader = false;
          });
      } else {
        Common.Toast.error("Todos as informações são necessárias");
      }
    };

    /**
     *
     * @param {type} id
     * @returns {undefined}
     */
    vm.editDetail = function (id) {
      CorrectionIndexService.getOneDetail(id)
        .then(function (response) {
          response.percent = response.percent / 100;
          var data = {
            month: vm.months,
            year: vm.years
          };

          ModalFactory.open('correction-index/details', null, null, data, response, 'finance')
            .then(function (answer) {
              answer.index_id = id;
              answer.percent = answer.percent * 100;
              vm.updateIndexDetail(answer);
            });
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error("Não foi possivel mostrar esta regra");
          $rootScope.show_loader = false;
        });
    };

    /**
     * Remove um detalhe de uma regra.
     * @param {type} id
     * @returns {undefined}
     */
    vm.deleteDetail = function (id) {
      $rootScope.show_loader = false;
      CorrectionIndexService.deleteDetail(id)
        .then(function () {
          vm.getAllDetails(vm.id);
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error("Não foi possivel mostrar esta regra", 'A4 Web', 2000);
          $rootScope.show_loader = false;
        });
    };

    vm.getAllDetails = function (id) {
      $rootScope.show_loader = false;
      CorrectionIndexService.getAllDetails({id: id})
        .then(function (response) {
          vm.role = response;
          response.detail.forEach(function (value) {
            value.month = $filter('filter')(vm.months, {id: value.month})[0];
          });
          vm.includeScope.roles = response;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error("Não foi possivel mostrar esta regra");
          $rootScope.show_loader = false;
        });
    };


    vm.update = function (role) {
      $rootScope.show_loader = false;
      if (role.name != '' && role.name != undefined) {
        CorrectionIndexService.updatecorrectionIndexRole(role)
          .then(function () {
            Common.Toast.success($filter('translate')('UPDATE_SUCCESS'));
          })
          .catch(function () {
            Common.Toast.error($filter('translate')('UPDATE_ERROR'));
          });
      } else {
        Common.Toast.error("Nome é obrigatório");
      }
    };

    vm.delete = function (index) {
      $rootScope.show_loader = false;
      var item = vm.allRoles[index];
      CorrectionIndexService.verifyIfHasAdjustmentRule(item.id)
        .then(function (res) {
          if (res == false || res == undefined) {
            vm.requestDelete(item.id);
          } else {
            ModalFactory.confirm(
              null,
              'Excluir indice de correção',
              'Existem lançamenos para este índice. Ao apagar o índice todos os lançamentos também serão apagados. Tem certeza que deseja apagar o índice e todos os seus lançamentos?',
              'Excluir',
              'Cancelar'
            ).then(function () {
              vm.requestDelete(item.id);
            });

          }
        })
        .catch(function (response) {
          if (response == "HAS_ADJUST") {
            Common.Toast.error("Este indice esta associado a uma regra de ajuste. Não pode ser removido.");
          }
        });
    };


    vm.requestDelete = function (id) {
      $rootScope.show_loader = false;
      CorrectionIndexService.removeIndice(id)
        .then(function () {
          Common.Toast.success($filter('translate')('UPDATE_SUCCESS'), 'A4 Web', 1000);
          vm.getAllcorrectionIndexRoles();
        })
        .catch(function (response) {
          if (response.data == "HAS_ADJUST") {
            Common.Toast.error("Este indice esta associado a uma regra de ajuste. Não pode ser removido.", 'A4 Web', 2000);
          }
        });
    };

    $scope.$on('$destroy', function () {
      [listener1].forEach(function (fn) {
        fn();
      });
    });

    vm.init();
  }

  angular.module('app.finance.correctionindex')
    .controller('CorrectionIndexController', CorrectionIndex);
})();
(function() {
  'use strict';
  angular
    .module('app.finance.contract.modal-edit', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ModalEditController(ModalExtra, ProductService, BillReceiptService, ModalFactory, $mdDialog,
                               Toast, $filter, Common, a4Moment, $rootScope) {

    var vm = this;
    vm.number_of_parcels = [];
    vm.days = [];
    vm.contract = {};
    vm.payment_method = [
      {id: 1, name: "Dinheiro"},
      {id: 2, name: "Cheque pré-datado"},
      {id: 3, name: "Cheque"},
      {id: 4, name: "Boleto bancário"},
      {id: 5, name: "Cartão de crédito"},
      {id: 6, name: "Tranferência bancária"},
      {id: 7, name: "Promissória"},
      {id: 8, name: "Cartão de débito"},
      {id: 9, name: "Débito automático"},
      {id: 10, name: "Débito automático no cartão"},
      {id: 11, name: "Parcelado no cartão"}
    ];

    vm.months = [
      {id: 1, label: '01 - Janeiro'},
      {id: 2, label: '02 - Fevereiro'},
      {id: 3, label: '03 - Março'},
      {id: 4, label: '04 - Abril'},
      {id: 5, label: '05 - Maio'},
      {id: 6, label: '06 - Junho'},
      {id: 7, label: '07 - Julho'},
      {id: 8, label: '08 - Agosto'},
      {id: 9, label: '09 - Setembro'},
      {id: 10, label: '10 - Outubro'},
      {id: 11, label: '11 - Novembro'},
      {id: 12, label: '12 - Dezembro'}
    ];

    vm.debit_credit = 'C';

    vm.init = function () {
      if(angular.isDefined(ModalExtra.contract)){
        vm.contract = ModalExtra.contract;
      }
      vm.categories = ModalExtra.categories;
      vm.getAllInfos();
    };

    /**
     * Retorna todas as informações necessárias para o formulário.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.getAllInfos = function () {
      BillReceiptService.getInfoForBillForm({debit_credit: 'C'})
        .then(function (response) {
          vm.products = response.products;
          vm.categories = response.categories;
          vm.payment_plans = response.payment_plans;
          vm.allAdditionRules = response.allAdditionRules;
          vm.allBankSlipRules = response.allBankSlipRules;
          vm.indexCorrection = response.indexCorrection;
          vm.currentAccounts = response.currentAccounts;
          if(angular.isUndefined(vm.contract.bill_serie_id)) {
            vm.getContractByBillSerieId(ModalExtra.item.serie_id);
          }
        })
        .catch(function () {
          Common.Toast.error($filter('translate')('LIST_ERROR') + ": " + $filter('translate')("PERSON"));
        });
    };

    /**
     * Retorna os dados do contrato a partir do id da serie
     * @param bill_serie_id
     */
    vm.getContractByBillSerieId = function (bill_serie_id) {
      vm.show_form = false;
      BillReceiptService.getContractByBillSerieId({bill_serie_id: bill_serie_id})
        .then(function (response) {
          vm.contract = response.plain();
          vm.contract.update_type = 0;
          if(vm.contract.individual_discounts.length > 0){
            vm.contract.individual_discounts.forEach(function (item) {
              item.discount_reason = {name: item.name}
            });
          }
          vm.show_form = true;
          vm.setYears();
          vm.setDays();
          vm.setNumberOfParcels();
          $rootScope.$broadcast('UPDATE_DISCOUNTS_RULE_LIST');
        })
        .catch(function () {
          vm.show_form = true;
        });
    };

    /**
     * Retorna o range de anos
     */
    vm.setYears = function () {
      vm.years = [];
      for (var i = 2019; i < 2035; i++) {
        vm.years.push({id: i, label: i});
      }
    };

    /**
     * Número de parcelas do contrato
     */
    vm.setNumberOfParcels = function () {
      vm.number_of_parcels = [];
      for (var i = 1; i <= vm.contract.quantity; i++) {
        vm.number_of_parcels.push({id: i, label: i});
      }
    };

    /**
     * Lista de dias
     */
    vm.setDays = function () {
      vm.days = [];
      for (var i = 1; i <= 30; i++) {
        vm.days.push({id: i, label: i});
      }
    };

    /**
     * Busca todos os produtos.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.getAllProducts = function () {
      ProductService.getAllProducts()
        .then(function (response) {
          vm.products = response;
        })
        .catch(function () {
          Common.Toast.error($filter('translate')('LIST_ERROR') + ": " + $filter('translate')("PRODUCT_SERVICES"));
        });
    };

    /** Desativa campos */
    vm.disableRecurrenceFields = function () {
      vm.disableRadio = true;
    };

    /**
     * Retorna todas as pessoas do banco de dados para a interface.
     * @returns {$q@call;defer.promise}
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.getAllPersons = function () {
      BillReceiptService.getAllPersons()
        .then(function (response) {
          vm.persons = response;
        })
        .catch(function () {
          Common.Toast.error($filter('translate')('LIST_ERROR') + ": " + $filter('translate')("PERSON"));
        });
    };

    /**
     * Criação de desconto individual
     */
    vm.createNewIndividualDiscount = function () {
      var data = angular.copy(vm.contract);
      ModalFactory.customClean(
        'app/finance/individual-discounts/views/individual-discounts.html',
        'IndividualDiscountsController',
        'vm',
        true,
        {theme: 'finance'}
      ).then(function (discount) {
        if (discount !== 'canceled') {
          data.individual_discounts.push(discount);
        }
        ModalFactory.customClean('app/finance/contract/modal-edit.html',
          'ModalEditController', 'vm', true, {'contract': data})
      })
    };

    /**
     * Remove um desconto da lista
     */
    vm.removeItemDesconto = function (index) {
      vm.contract.individual_discounts.splice(index, 1);
    };

    /**
     * Faz a submissão de formulario para novo titulo
     * @param {type} bill_form - Formulário do submit para validações Angular.
     * @param {type} item - Item do formulário.
     * @param {type} files - Arquivos .
     * @param {type} event - Evento.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.submit = function (bill_form, item, files, event) {
      var bill_copy = angular.copy(item);
      vm.updateAllSerie(bill_copy);
    };

    /**
     * Verifica a existência de cheques duplicados
     * @param list_checks
     * @returns {boolean}
     */
    vm.verifyIfExistsDuplicatedCheck = function (list_checks) {
      var exists = false;
      angular.forEach(list_checks, function (value) {
        if (value.duplicated) {
          exists = true;
        }
      });
      return exists;
    };

    vm.updateAllSerie = function (bill_copy) {
      BillReceiptService.updateAllSerie(bill_copy)
        .then(function (response) {
          Common.Toast.success($filter('translate')('UPDATE_SUCCESS'));
          $mdDialog.hide(response);
        }).catch(function () {
        Common.Toast.error($filter('translate')('UPDATE_ERROR'))
      });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular
    .module('app.finance.contract.modal-edit')
    .controller('ModalEditController', ModalEditController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function ContractService(Restangular, $http, Common, CONFIG) {

    var getServices = function (obj) {
      return Restangular.one('contract').one('getservices').get(obj);
    };
    var create = function (obj) {
      return Restangular.all('contract').post(obj);
    };

    var getById = function (bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).get();
    };

    var update = function (obj, bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).put(obj);
    };

    var changePlanCheck = function (bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).one('changecheck').get();
    };

    var changePaymentPlan = function (obj, bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).all('changepaymentplan').post(obj);
    };

    var cancelContract = function (obj) {
      return Restangular.one('contract').all('cancelcontract').post(obj);
    };

    var undoCancelContract = function (obj) {
        return Restangular.one('contract').all('undocancelcontract').post(obj);
    };

    var deleteContract = function (obj) {
      return Restangular.one('contract').all('deletecontract').post(obj);
    };

    var deleteSignedContract = function (obj) {
      return Restangular.one('contract').all('deletesignedcontract').post(obj);
    };

    var addInstallment = function (obj) {
      return Restangular.one('contract').all('addinstallment').post(obj);
    };

    var updatePersonPayee = function (obj) {
      return Restangular.one('contract').all('updatepersonpayee').post(obj);
    };

    var getNextDueDate = function (bill_serie_id) {
      return Restangular.one('contract', bill_serie_id).one('getnextduedate').get();
    };

    var printDocument = function (bill_serie_id, artifact_id) {
      var deffered = Common.$q.defer();

      var url = CONFIG.webApiUri + 'api/reports/printbillseriedocument?bill_serie_id=' + bill_serie_id;
      if (artifact_id) {
        url += '&artifact_id=' + artifact_id;
      }
      $http({
        method: 'GET',
        url: url,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;
        
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }).catch(function (response) {
        var decoder = new TextDecoder("utf-8");
        var domString = decoder.decode(response.data);
        var json = angular.fromJson(domString);
        deffered.reject(json);
      });
      return deffered.promise;
    };

    var printServiceContract = function (bill_serie_id) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/printservicescontract?bill_serie_id='+bill_serie_id,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }).catch(function (response) {
        var decoder = new TextDecoder("utf-8");
        var domString = decoder.decode(response.data);
        var json = angular.fromJson(domString);
        deffered.reject(json);
      });
      return deffered.promise;
    };
    return {
      getServices: getServices,
      create: create,
      cancelContract: cancelContract,
      update: update,
      getNextDueDate: getNextDueDate,
      getById: getById,
      changePlanCheck: changePlanCheck,
      changePaymentPlan: changePaymentPlan,
      deleteContract: deleteContract,
      deleteSignedContract: deleteSignedContract,
      addInstallment: addInstallment,
      undoCancelContract: undoCancelContract,
      printDocument: printDocument,
      updatePersonPayee: updatePersonPayee,
      printServiceContract: printServiceContract
    }
  }

  angular.module('app.finance.contract')
    .factory('ContractService', ContractService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.contract', {
        url: '/contract',
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/contract/views/index.html',
            controller: 'ContractController',
            controllerAs: 'vm'
          }
        }
      })
  }

  angular
    .module('app.finance.contract')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'contrato_menu';
    var path = 'finance.contract';
    msNavigationService.saveItem('finance.contract', {
      title: 'Contratos',
      icon: 'icon-file-document',
      state: 'private.finance.contract',
      weight: 20,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.check-received')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function ContractController($rootScope, Common, BillReceiptService, BillExpenseService, ModalFactory, $a4FloatButton, $scope, a4Moment) {

    var vm = this;

    vm.debit_credit = 'C';
    vm.filter_date = null;
    vm.bills = [];
    vm.includeScope = {};
    vm.bills = [];
    vm.all_bills = [];
    vm.selected_status = [];
    vm.edit_expense = null;
    vm.haveUpdate = false;
    vm.allContracts = {
      data: []
    };


    vm.init = function () {
      vm.getAllContracts(1, 15);
      vm.getCategories();
      // vm.verifyIfHaveUpdate();
    };


    /**
     * Atualiza todos os contratos
     */
    vm.updateContracts = function () {
      $rootScope.show_loader = true;
      BillReceiptService.updateContracts()
        .then(function () {
          Common.Toast.success("Contratos atualizados com sucesso");
          $rootScope.show_loader = false;
          vm.verifyIfHaveUpdate();
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Verifica se existem contratos para serem atualizados
     */
    vm.verifyIfHaveUpdate = function () {
      BillReceiptService.haveContracts()
        .then(function (response) {
          vm.haveUpdate = response;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Criação de um contrato
     */
    vm.openCreateModal = function () {
      ModalFactory.customClean('app/components/a4-contract-grid/create-contract-modal.html',
        'CreateContractController', 'vm', true, {'categories': vm.categories})
        .then(function () {
          vm.getAllContracts(1, 15);
        });
    };

    $rootScope.$on('UPDATE_CONTRACT_LIST', function () {
      vm.getAllContracts(1, 15, null);
    });

    vm.getAllContracts = function (page, qtd, search_name) {
      $rootScope.show_loader = true;
      vm.promise = BillReceiptService.getAllContracts({
        'debit_credit': vm.debit_credit,
        page: page,
        qtd: qtd,
        search_name: search_name
      })
        .then(function (response) {
          if (angular.isDefined(response.data)) {
            vm.allContracts = response.plain();
          } else {
            vm.allContracts.data = response;
          }
          /**
           * Verificação da data final, para verificar se o contrato está cancelado
           */
          for (var i = vm.allContracts.data.length; i--;) {
            if (vm.allContracts.data[i].date_end !== null && a4Moment(vm.allContracts.data[i].date_end).isBefore(a4Moment())) {
              vm.allContracts.data[i].is_date_end_before_today = true;
            } else {
              vm.allContracts.data[i].is_date_end_before_today = false;
            }
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.defineType = function (item) {
      if (item.portion_amount == null) {
        return "Recorrência";
      } else {
        return "Parcelamento";
      }
    };

    vm.defineAmount = function (item) {
      if (item.portion_amount == null) {
        return item.recurrence_amount;
      } else {
        return item.portion_amount;
      }
    };

    vm.defineFrequency = function (item) {
      switch (item.frequency) {
        case 0:
          return "Título parcelado";
        case 1:
          return "A cada " + item.frequency_qty + " dia(s)";
        case 2:
          return "A cada " + item.frequency_qty + " mês(es)";
        case 3:
          return "A cada " + item.frequency_qty + "ano(s)";
        case 20:
          return "Datas irregulares";
        case 30:
          return "Sob demanda";
      }
    };

    vm.getCategories = function () {
      BillExpenseService.getCategories(vm.debit_credit)
        .then(function (response) {
          if (response) {
            vm.categories = response;
            $rootScope.show_loader = false;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista.');
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor.');
          break;
      }
    };

    vm.init();
  }

  angular
    .module('app.finance.contract')
    .controller('ContractController', ContractController);
})();

(function () {
  'use strict';

  angular.module('app.finance.communication', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function CommunicationService(Restangular, CONFIG, Common, $http, $rootScope)
  {
    var getReceivers = function (obj) {
      return Restangular.one('person').all('getfinancereceivers').post(obj);
    };

    var getReceiversReport = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/receiversemailreport',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("target", '_blank');

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {
        
      });
      return deffered.promise;
    };

    return {
      getReceivers: getReceivers,
      getReceiversReport: getReceiversReport
    }
  }

  angular.module('app.finance.communication')
    .factory('CommunicationService', CommunicationService);
})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.communication', {
        public: false,
        url: '/communication',
        templateUrl: 'app/finance/communication/views/communication.html',
        abstract: true
      })
      .state('private.finance.communication.list', {
        url: '/list',
        public: false,
        views: {
          'communication': {
            templateUrl: 'app/finance/communication/views/index.html',
            controller: 'CommunicationController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.finance.communication.create-edit', {
        url: '/create-edit/:id',
        public: false,
        views: {
          'communication': {
            templateUrl: 'app/finance/communication/views/create-edit.html',
            controller: 'CommunicationCreationEditController',
            controllerAs: 'vm'
          }
        }
      });
  };

  angular
    .module('app.finance.communication')
    .config(routerConfig);

})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {

    /*var role_cobranca = 'cobanc_menu';
    var role_boleto = 'cobanc_bol';*/
    var path = 'finance.person';
    var role = 'fin_email';

    msNavigationService.saveItem('finance.communication', {
      title: 'Comunicação',
      icon: 'icon-gmail',
      auth: true,
      state: 'private.finance.communication.list',
      weight: 6,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.communication')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function CommunicationController($scope, $state, $rootScope,
                                   Common, CommunicationService,
                                   DocumentsService,
                                   ModalFactory,
                                   $a4FloatButton) {
    var vm = this;
    vm.grid = {};

    vm.createDocument = function () {
      $state.go('private.finance.communication.create-edit');
    };

    vm.editDocument = function (item) {
      $state.go('private.finance.communication.create-edit', {id: item.id});
    };

    vm.sendEmail = function (item) {
      /*ModalFactory.alert('Módulo em manutenção', 'Este módulo está em manutenção e será disponibilizado em breve.'
      ,'modal', 'Ok', false, 'finance');*/
      $rootScope.show_loader = true;
      CommunicationService.getReceivers({document_id: item.id, filter: 'finance'})
        .then(function (response) {
          var data = response.plain();
          ModalFactory.customClean('app/finance/communication/views/modal-send-email.html',
            /** @ngInject */
            function ($rootScope, $mdDialog, ModalExtra) {
              var vm = this;
              vm.disabled = false;
              vm.scope = ModalExtra;
              vm.closeModal = function () {
                $mdDialog.cancel();
              };
              vm.answer = function (option) {
                switch (option) {
                  case 'report':
                    vm.disabled = true;
                    CommunicationService.getReceiversReport({persons: vm.scope.persons})
                      .then(function () {
                        vm.disabled = false;
                      });
                    break;
                  default:
                    $mdDialog.hide(option);
                    break;
                }
              }
            },
            'vm', false,
            {
              persons_total: data.persons_total,
              persons_with_email: data.persons_with_email,
              persons_without_email: data.persons_without_email,
              persons_email_sent: data.persons_email_sent,
              persons: data.persons
            }).then(function (response) {
            if (response === 'send_not_sent' || response === 'send_all') {
              DocumentsService.sendDocument({
                id: item.id,
                filter: 'finance',
                send_option: response
              })
                .then(function () {
                  $rootScope.show_loader = false;
                  Common.Toast.success('E-mail enviado com sucesso!');
                })
            }
            $rootScope.show_loader = false;
          }).catch(function () {
            $rootScope.show_loader = false;
          })
        });
    };

    vm.sendEmailToPerson = function (item) {
      ModalFactory.customClean('app/finance/communication/views/modal-individual-send.html',
        /** @ngInject */
        function ($rootScope, $mdDialog, ModalExtra, PersonService) {
          var vm = this;
          vm.filter = {};
          vm.filter.selectedPerson = null;
          vm.getPersons = function (query) {
            return PersonService.getPersonWithFilter({query: query, selected_tab: 66});
          };

          vm.close = function (data) {
            $rootScope.$broadcast('ModalFactory.close', data);
          };

          vm.submit = function (option) {
            vm.filter.option = option;
            $mdDialog.hide(vm.filter);
          };


        }, 'vm', false, {
          document_id: item.id
        }).then(function (response) {
        if (angular.isDefined(response)) {
          $rootScope.show_loader = true;
          if (response.option === 'send') {
            DocumentsService.sendDocument({id: item.id, filter: response})
              .then(function () {
                $rootScope.show_loader = false;
                Common.Toast.success('E-mail enviado com sucesso!');
              })
          } else {
            DocumentsService.downloadDocument({id: item.id, filter: response})
              .then(function () {
                $rootScope.show_loader = false;
                Common.Toast.success('Documento baixado com sucesso!');
              })
          }
        }
      })
    };

    vm.printDocument = function (item) {
      $rootScope.show_loader = true;
      DocumentsService.downloadDocument({id: item.id, filter: 'finance'})
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Documento baixado com sucesso!');
        })
    };

    vm.clickActions = function (item, option) {
      switch (option) {
        case 'send-email':
          vm.sendEmail(item);
          break;
        case 'send-email-person':
          vm.sendEmailToPerson(item);
          break;
        case 'send-print':
          vm.printDocument(item);
          break;
      }
    };

    vm.delete = function (index) {
      ModalFactory.confirm(null,
        'Confirmação da exclusão',
        'Deseja realmente excluir esse comunicado?',
        'confirmar',
        'cancelar',
        'finance')
        .then(function () {
          DocumentsService.deleteDocument(index)
            .then(function () {
              Common.Toast.success('Comunicado excluído com sucesso!');
              vm.paginate(1, 15);
            })
        })
    }

    vm.init = function () {
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        onClick: 'vm.createDocument()',
        theme: 'finance'
      });
      vm.paginate(1, 15);
    };

    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;
      var type = '6';

      DocumentsService.getAll({limit: limit, page: page, type: type})
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        });
    };

    vm.init();
  }

  angular.module('app.finance.communication')
    .controller('CommunicationController', CommunicationController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function CommunicationCreationEditController($scope, $rootScope, $document, $stateParams, Common, CONFIG, Documents, DocumentsService, DropzoneService, LocalStorage) {
    var vm = this;
    vm.profile = '';
    vm.is_wysiwyg = false;
    vm.form = {};
    vm.variables = [];
    vm.form.document = {
      date: null,
      final_date: null,
      content: ""
    };

    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");

    /** Define as configurações para o upload */
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/document/uploadfiles?company=' + company + '&connection=' + connection,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['JPG', 'PNG', 'GIF']),
      uploadMultiple: false,
      parallelUploads: 1,
      maxFiles: 1,
      autoProcessQueue: true
    };


    vm.options = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'strikeThrough', 'underline', 'ul', 'ol'],
      ['undo', 'redo', 'clear', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'clear', 'insertImage', 'insertLink', 'insertVideo'],
      ['html'],
    ];

    vm.tinymceOptions = {
      setup: function (editor) {
        vm.editor = editor;
        // editor.execCommand('mceInsertContent', false, text);
      },
      inline: false,
      plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks ' +
        'visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc ' +
        'insertdatetime advlist lists wordcount imagetools textpattern noneditable charmap emoticons',
      skin: 'lightgray',
      theme: 'modern',
      fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
      menubar: 'file edit view insert format tools table help',
      toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | ' +
        'alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | ' +
        'pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ' +
        'ltr rtl | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | ' +
        'tableinsertcolbefore tableinsertcolafter tabledeletecol',
      toolbar_sticky: true,
      height: 400
    };

    /** Define o comportamento após o upload */
    vm.dzCallbacks = {
      'success': function (file, xhr) {
        vm.form.document.file_reference = xhr.file_reference;
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.init = function () {
      if ($stateParams.id) {
        vm.getById($stateParams.id);
      }
      Documents.getResources()
        .then(function () {
          vm.defineProfile();
        });
    };

    vm.setVariable = function (item) {
      vm.editor.insertContent(item.name);
      // tinyMCE.execInstanceCommand('html_editor',"mceInsertContent",false,'balbalb');
      // vm.editor.editorUpload.uploadImages();
      // vm.editor.execCommand('mceInsertContent', false, 'fsdfsfsdfd');
      // var regex = new RegExp("<body>(.|\n)*?</body>");
      // if (vm.form.document.content.match(regex) !== null) {
      //   var string = vm.reverseString(vm.form.document.content.match(regex)[0].replace("</body>", '').replace("<body>", ''));
      //   string = "<body>" + vm.reverseString(string.replace(">p/<", '')) +
      //     " " + item.name + "</p> </body>";
      //   vm.form.document.content = vm.form.document.content.replace(regex, string);
      // } else {
      //   vm.form.document.content += ' ' + item.name;
      // }
    };


    /**
     * Define qual o perfil selecionado para a mensagem
     * @param profile
     */
    vm.defineProfile = function () {
      vm.profile = 'Financeiro';
      vm.variables = Documents.getResponsables();

    };

    /**
     * Inverte string
     * @param string
     * @returns {*}
     */
    vm.reverseString = function (string) {
      return string.split('').reverse().join('');
    };
    /**
     * Retorna os dados da mensagem em caso de edição
     * @param id
     */
    vm.getById = function (id) {
      $rootScope.show_loader = true;
      DocumentsService.getById(id)
        .then(function (response) {
          vm.form.document = response;
          vm.is_wysiwyg = vm.form.document.is_wysiwyg;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Submete o boletim a criação..
     */
    vm.submit = function (form, item) {
      $rootScope.show_loader = true;
      item.for_parents = true;
      if (form.$valid) {
        if (item.id) {
          item.is_wysiwyg = vm.is_wysiwyg;
          DocumentsService.updateDocument(item)
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Mensagem atualizada com sucesso!');
              // $state.go('private.educational.informative-report.edit', {id: response});
              // vm.form.mode_edit = false;
            })
            .catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Erro ao atualizar mensagem');
            })
        } else {
          item.type = 6;
          item.is_wysiwyg = vm.is_wysiwyg;
          item.company_id = company;
          DocumentsService.create(item)
            .then(function (id) {
              $rootScope.show_loader = false;
              item.id = id;
              Common.Toast.success('Mensagem criada com sucesso!');
              // $state.go('private.educational.informative-report.edit', {id: response});
              // vm.form.mode_edit = false;
            })
            .catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Erro ao criar mensagem');
            })
        }
      }
    };

    vm.init();

  }

  angular.module('app.finance.communication')
    .controller('CommunicationCreationEditController', CommunicationCreationEditController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedWithdrawController(ModalExtra, $mdDialog, CurrentAccountService, Common, $rootScope) {
    var vm = this;
    vm.data = ModalExtra;
    vm.withdraw = {};
    vm.withdraw.checkList = [];
    vm.withdraw.date = new Date();
    vm.query = {
      limit: 1000,
      page: 1
    };

    vm.init = function () {
      vm.getAccountsByType();
    };

    vm.convertDate = function (date) {
      var cDate = date.split('-');
      return cDate[2] + '/' + cDate[1] + '/' + cDate[0]
    };

    vm.getAccountsByType = function () {
      CurrentAccountService.listAll()
        .then(function (resp) {
          vm.current_accounts = resp;
        })
    };


    vm.answer = function (answer, form) {
      if (form.$valid) {
        if (answer.checkList.length > 0) {
          $mdDialog.hide(answer);
        } else {
          Common.Toast.warning('Por favor, selecione pelo menos um cheque da lista');
        }
      }
      $rootScope.show_loader = false;
    };

    vm.closeModal = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular.module('app.finance.check-received')
    .controller('CheckReceivedWithdrawController', CheckReceivedWithdrawController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedTransferController(ModalExtra, $mdDialog, CURRENT_ACCOUNT_TYPES, CurrentAccountService, Common, $rootScope) {
    var vm = this;
    vm.data = ModalExtra;
    vm.aTransfer = {};
    vm.aTransfer.checkList = [];
    vm.aTransfer.date = new Date();
    vm.query = {
      limit: 1000,
      page: 1
    };

    vm.init = function () {
      vm.getAccountsByType();
    };

    vm.getAccountsByType = function () {
      CurrentAccountService.getByTypes({types: CURRENT_ACCOUNT_TYPES.CONTA_CAIXA})
        .then(function (resp) {
          vm.current_accounts_bank = resp;
        })
    };

    vm.answer = function (answer, form) {
      if (form.$valid) {
        if (answer.checkList.length > 0) {
          $mdDialog.hide(answer);
        } else {
          Common.Toast.warning('Por favor, selecione pelo menos um cheque da lista');
        }
      }
      $rootScope.show_loader = false;
    };

    vm.closeModal = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular.module('app.finance.check-received')
    .controller('CheckReceivedTransferController', CheckReceivedTransferController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedService(Restangular, CURRENT_ACCOUNT_TYPES, a4Moment) {
    var vm = {};

    /**
     * getAll
     */
    vm.getAll = function (filter) {
      return Restangular.all('checkreceived').one('getAll').get(filter);
    };

    vm.sendSearch = function (search) {
      return Restangular.one("checkreceived/search").customGET('', {search: search});
    };

    /**
     * getAllCheckStatus
     */
    vm.getAllCheckStatus = function () {
      return Restangular.all('checkreceived').one('getallstatus').get();
    };

    vm.depositeInAccount = function (list) {
      return Restangular.one('checkreceived').all('deposite').post(list);
    };

    vm.custodyInAccount = function (list) {
      return Restangular.one('checkreceived').all('custody').post(list);
    };

    vm.bankDiscount = function (list) {
      return Restangular.one('checkreceived').all('bankdiscount').post(list);
    };

    vm.transferInAccount = function (list) {
      return Restangular.one('checkreceived').all('transfer').post(list);
    };

    vm.withdrawCheck = function (list) {
      return Restangular.one('checkreceived').all('withdraw').post(list);
    };

    vm.bankDevolution = function (list) {
      return Restangular.one('checkreceived').all('devolution').post(list);
    };

    vm.getAllCheckIssue = function () {
      return Restangular.all('checkreceived').one('getallcheckissue').get();
    };

    vm.is_cash_account = function (list) {
      var is_cash_account = true;
      list.forEach(function (value) {
        if (value.current_account_type_id != CURRENT_ACCOUNT_TYPES.CONTA_CAIXA) {
          is_cash_account = false;
          return null;
        }
      });
      return is_cash_account;
    };

    /**
     * Verifica se na lista, existe algum tipo de conta diferente de caixa;
     * @param list - Cheques selecionados
     * @returns {boolean}
     */
    vm.is_cash_account_and_due_date_is_before_or_today = function (list) {
      var is_cash_account_and_due_date_is_today = true;
      list.forEach(function (value) {
        var date = a4Moment([value.date.split('-')[0], value.date.split('-')[1] - 1, value.date.split('-')[2]]);
        if (value.current_account_type_id != CURRENT_ACCOUNT_TYPES.CONTA_CAIXA
          && (!vm.is_due_date_is_today(date) || vm.is_due_date_befofe_or_equals_today(date))) {
          is_cash_account_and_due_date_is_today = false;
          return null;
        }
      });
      return is_cash_account_and_due_date_is_today;
    };

    /**
     * Verifica se na lista, existe algum tipo de conta diferente de caixa, e data de vencimento
     * à vista posterior a hoje.
     * @param list
     * @returns {boolean}
     */
    vm.is_cash_account_and_due_date_is_greater_then_today = function (list) {
      var is_cash_account_and_due_date_is_greater_then_today = true;
      list.forEach(function (value) {
        var date = a4Moment([value.date.split('-')[0], value.date.split('-')[1] - 1, value.date.split('-')[2]]);
        if (value.current_account_type_id != CURRENT_ACCOUNT_TYPES.CONTA_CAIXA && vm.is_due_date_after_today(date)) {
          is_cash_account_and_due_date_is_greater_then_today = false;
          return null;
        }
      });
      return is_cash_account_and_due_date_is_greater_then_today;

    };


    /**
     * Verifica se uma data é anterior ou igual a hoje
     * @param date
     * @returns {boolean}
     */
    vm.is_due_date_befofe_or_equals_today = function (date) {
      var today = a4Moment();
      if (!date.isSameOrBefore(today)) {
        return false;
      }
      return true;
    };

    /**
     * Verifica se uma data é posterior a hoje
     * @param date
     * @returns {boolean}
     */
    vm.is_due_date_after_today = function (date) {
      var today = a4Moment();
      if (date.isAfter(today)) {
        return true;
      }
      return false;
    };

    /**
     * Verifica de a data do cheque é hoje.
     * @param {a4Moment} date
     * @returns {boolean}
     */
    vm.is_due_date_is_today = function (date) {
      var today = a4Moment();
      if (today.isSame(date, 'd')) {
        return true;
      }
      return false;
    };

    /**
     * Retorna todas as contas correntes.
     * @returns {undefined}
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {defer.promise}
     */
    vm.getAllCurrentAccount = function () {
      return Restangular.one('bill').one('getallcurrentaccounts').get();
    };

    /**
     * addCheckDescription
     */
    vm.addCheckDescription = function (obj) {
      return Restangular.all('checkreceived').one('addcheckdescription').customPOST(obj);
    };

    /**
     * changeCheckDueDate
     */
    vm.changeCheckDueDate = function (obj) {
      return Restangular.all('checkreceived').one('changeduedate').customPOST(obj);
    };


    /**
     * setRetrieveCheck
     */
    vm.setRetrieveCheck = function (obj) {
      return Restangular.one('checkreceived').all('setretrievecheck').post(obj);
    };

    return vm;
  }

  angular.module('app.finance.check-received')
    .factory('CheckReceivedService', CheckReceivedService);


})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.check-received', {
        url: '/check-received',
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/check-received/views/index.html',
            controller: 'CheckReceivedController',
            controllerAs: 'vm'
          },
          'bordero@private.finance.check-received': {
            controller: 'BorderoController',
            controllerAs: 'vm',
            templateUrl: 'app/finance/check-received/bordero/bordero.html'
          }
        }
      })
  }

  angular
    .module('app.finance.check-received')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedRetrieveController(ModalExtra, $mdDialog, CURRENT_ACCOUNT_TYPES, CurrentAccountService, Common, $rootScope) {
    var vm = this;
    vm.data = ModalExtra;
    vm.obj = {};
    vm.obj.checkList = [];
    vm.obj.date = new Date();
    vm.query = {
      limit: 1000,
      page: 1
    };

    vm.init = function () {
      vm.getAccountsByType();
    };

    vm.convertDate = function (date) {
      var cDate = date.split('-');
      return cDate[2] + '/' + cDate[1] + '/' + cDate[0]
    };

    vm.getAccountsByType = function () {
      CurrentAccountService.getByTypes({types: CURRENT_ACCOUNT_TYPES.CONTA_BANCO})
        .then(function (resp) {
          vm.current_accounts_bank = resp;
        })
    };

    vm.answer = function (answer, form) {
      if (form.$valid) {
        if (answer.checkList.length > 0) {
          $mdDialog.hide(answer);
        } else {
          Common.Toast.warning('Por favor, selecione pelo menos um cheque da lista');
        }
      }
      $rootScope.show_loader = false;
    };

    vm.closeModal = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular.module('app.finance.check-received')
    .controller('CheckReceivedRetrieveController', CheckReceivedRetrieveController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function OperationOriginController($scope, $mdDialog, CurrentCheck, $rootScope) {
    $scope.current_check = CurrentCheck;

    //cancelamento para o $mdDialog
    $scope.cancel = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };
  }

  angular
    .module('app.finance.check-received')
    .controller('OperationOriginController', OperationOriginController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'cheq_menu';
    var path = 'finance.check-received';
    msNavigationService.saveItem('finance.check-received', {
      title: 'Cheques recebidos',
      icon: 'icon-cash-multiple',
      state: 'private.finance.check-received',
      weight: 6,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.check-received')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedDiscounts(ModalExtra, $mdDialog, CURRENT_ACCOUNT_TYPES, CurrentAccountService, Common, a4Moment, $rootScope) {
    var vm = this;
    vm.data = ModalExtra;
    vm.discount = {};
    vm.discount.checkList = [];
    vm.discount.date = new Date();
    vm.discount.discount_tax = 0.00;
    vm.min_date = a4Moment();
    vm.query = {
      limit: 1000,
      page: 1
    };

    vm.init = function () {
      vm.getAccountsByType();
    };

    vm.convertDate = function (date) {
      var cDate = date.split('-');
      return cDate[2] + '/' + cDate[1] + '/' + cDate[0]
    };

    vm.getAccountsByType = function () {
      CurrentAccountService.getByTypes({types: CURRENT_ACCOUNT_TYPES.CONTA_BANCO})
        .then(function (resp) {
          vm.current_accounts_bank = resp;
        })
    };


    vm.answer = function (answer, form) {
      if (form.$valid) {
        if (answer.checkList.length > 0) {
          $mdDialog.hide(answer);
        } else {
          Common.Toast.warning('Por favor, selecione pelo menos um cheque da lista');
        }
      }
      $rootScope.show_loader = false;
    };

    vm.closeModal = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular.module('app.finance.check-received')
    .controller('CheckReceivedDiscounts', CheckReceivedDiscounts)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedDeposite(ModalExtra, $mdDialog, CURRENT_ACCOUNT_TYPES, CurrentAccountService, Common, $rootScope) {
    var vm = this;
    vm.data = ModalExtra;
    vm.aDeposite = {};
    vm.aDeposite.checkList = [];
    vm.aDeposite.date = new Date();
    vm.query = {
      limit: 1000,
      page: 1
    };

    vm.init = function () {
      vm.getAccountsByType();
    };

    vm.convertDate = function (date) {
      var cDate = date.split('-');
      return cDate[2] + '/' + cDate[1] + '/' + cDate[0]
    };

    vm.getAccountsByType = function () {
      CurrentAccountService.getByTypes({types: CURRENT_ACCOUNT_TYPES.CONTA_BANCO})
        .then(function (resp) {
          vm.current_accounts_bank = resp;
        })
    };


    vm.answer = function (answer, form) {
      if (form.$valid) {
        if (answer.checkList.length > 0) {
          $mdDialog.hide(answer);
        } else {
          Common.Toast.warning('Por favor, selecione pelo menos um cheque da lista');
        }
      }
      $rootScope.show_loader = false;
    };

    vm.closeModal = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular.module('app.finance.check-received')
    .controller('CheckReceivedDeposite', CheckReceivedDeposite)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedCustody(ModalExtra, $mdDialog, CURRENT_ACCOUNT_TYPES, CurrentAccountService, $rootScope) {
    var vm = this;
    vm.data = ModalExtra;
    vm.custody = {};
    vm.custody.checkList = [];
    vm.custody.date = new Date();
    vm.query = {
      limit: 1000,
      page: 1
    };

    vm.init = function () {
      vm.getAccountsByType();
    };

    vm.getAccountsByType = function () {
      CurrentAccountService.getByTypes({types: CURRENT_ACCOUNT_TYPES.CONTA_BANCO})
        .then(function (resp) {
          vm.current_accounts_bank = resp;
        })
    };


    vm.answer = function (answer, form) {
      if (form.$valid) {
        if (answer.checkList.length > 0) {
          $mdDialog.hide(answer);
        } else {
          Common.Toast.warning('Por favor, selecione pelo menos um cheque da lista');
        }
        $rootScope.show_loader = false;
      }
    };
    vm.closeModal = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular.module('app.finance.check-received')
    .controller('CheckReceivedCustody', CheckReceivedCustody)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedController($scope, $mdDialog, $rootScope, ModalFactory, Common, a4Moment, CheckReceivedService
    , CURRENT_ACCOUNT_TYPES, CurrentAccountService) {

    var vm = this;

    vm.search = "";

    vm.checks = [];
    vm.status = [];

    vm.status_string = [];
    vm.selected_status = [];
    vm.acounts_string = [];
    vm.selected_account = [];
    vm.filter_date = [];
    vm.filter_date['initDate'] = a4Moment().startOf('month');
    vm.filter_date['endDate'] = a4Moment().endOf('month');


    var ltn = $rootScope.$on('update.CHECK_RECEIVED', function () {
      vm.getAllChecks(vm.status_string, [], vm.filter_date['initDate'], vm.filter_date['endDate']);
    });


    /**
     * init
     */
    vm.init = function () {
      //vm.filter_date = {'initDate': a4Moment().startOf('month')._d, 'endDate':a4Moment().endOf('month')._d};
      vm.getAllChecks(vm.status_string, [], vm.filter_date['initDate'], vm.filter_date['endDate']);
      vm.getAllCheckStatus();
    };

    vm.getAccountsByType = function () {
      CurrentAccountService.getByTypes({types: CURRENT_ACCOUNT_TYPES.CONTA_CAIXA + ',' + CURRENT_ACCOUNT_TYPES.CONTA_BANCO})
        .then(function (resp) {
          vm.accounts = resp;
        })
    };

    /**
     * getAllChecks
     * Retorna todos os cheques recebidos
     */
    vm.getAllChecks = function (status, accounts, startDate, endDate) {
      $rootScope.show_loader = true;
      if (startDate === undefined) {
        startDate = a4Moment().startOf('month');
      }
      if (endDate === undefined) {
        endDate = a4Moment().endOf('month');
      }
      var filter = {status: status, accounts: accounts, startDate: startDate, endDate: endDate};
      CheckReceivedService.getAll(filter)
        .then(function (response) {
          if (response != null) {
            vm.checks = response;
          }
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });
    };

    /**
     * getAllCheckStatus
     * Retorna todos os status possíveis para um cheque
     */
    vm.getAllCheckStatus = function () {
      $rootScope.show_loader = true;
      CheckReceivedService.getAllCheckStatus()
        .then(function (response) {
          if (response != null) {
            vm.status = response;
            // filtragem inicial
            vm.selected_status = vm.getCheckStatusByArrayOfId([0, 1, 2, 5, 6]);
            var status = [];
            angular.forEach(vm.selected_status, function (item, i) {
              if (item != null) {
                status.push(item.id);
              }
            });
            status = status.toString();
            vm.getAllChecks(status, "");
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });

    };

    /**
     * changeCheckStatus
     * Modifica o status do cheque selecionado
     * @param idx
     */
    vm.addCheckDescription = function (id) {

      if (vm.isValidItem(id)) {

        var current_check = vm.getCheckById(id);

        $mdDialog.show(
          {
            controller: 'CheckStatusController',
            locals: {
              CurrentCheck: angular.copy(current_check)
            },
            templateUrl: 'app/finance/check-received/views/dialogs/check_description.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false
          }
        );

      }

    };

    vm.deposite = function (obj) {

      $rootScope.show_loader = true;
      CheckReceivedService.depositeInAccount(obj)
        .then(function (resp) {
          vm.checks = [];
          vm.checks = resp;
          Common.Toast.success('Deposito realizado com sucesso');
          $rootScope.show_loader = false;
          $rootScope.$broadcast('update.BORDERO');
        })
        .catch(function () {
          $rootScope.show_loader = false;

        })
    };

    /**
     * Executa o deposito em conta do cheque;
     * @param list
     */
    vm.accountDeposite = function () {

      $rootScope.show_loader = true;
      CheckReceivedService.getAll({startDate: a4Moment([1950, 0, 1]), endDate: a4Moment(), status: '0,5'})
        .then(function (resp) {
          $rootScope.show_loader = false;
          var deposite = {};
          deposite.checkAvailable = resp;
          if (deposite.checkAvailable.length == 0) {
            Common.Toast.warning('Não há cheques dispóniveis para depósito');
            return false;
          }

          ModalFactory.customClean('app/finance/check-received/views/dialogs/account_deposite.html',
            'CheckReceivedDeposite', 'vm', false, deposite)
            .then(function (anwser) {
              vm.deposite(anwser);
            });
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Envia cheque para custódia bancaria
     * @param list
     */
    vm.sendToBank = function () {

      $rootScope.show_loader = true;
      CheckReceivedService.getAll({startDate: a4Moment().add(1, 'days'), endDate: a4Moment([4000, 0, 1]), status: '0'})
        .then(function (resp) {
          var custody = {};
          $rootScope.show_loader = false;
          custody.checkAvailable = resp;
          if (custody.checkAvailable.length == 0) {
            Common.Toast.warning('Não há cheques dispóniveis para custódia');
            return false;
          }
          ModalFactory.customClean('app/finance/check-received/views/dialogs/account_custody.html',
            'CheckReceivedCustody', 'vm', false, custody)
            .then(function (anwser) {
              vm.custody(anwser);
            });

        });
    };


    vm.custody = function (obj) {

      $rootScope.show_loader = true;
      CheckReceivedService.custodyInAccount(obj)
        .then(function (resp) {
          vm.checks = [];
          vm.checks = resp;
          Common.Toast.success('Custódia realizada com sucesso');
          $rootScope.$broadcast('update.BORDERO');
          $rootScope.show_loader = false;
        });
    };


    /**
     * Desconta um cheque no banco
     * @param list
     */
    vm.bankDiscount = function () {

      $rootScope.show_loader = true;
      CheckReceivedService.getAll({
        startDate: a4Moment().add(1, 'days'),
        endDate: a4Moment([4000, 0, 1]),
        status: '0,5'
      })
        .then(function (resp) {
          $rootScope.show_loader = false;
          var discount = {};
          discount.checkAvailable = resp;
          if (discount.checkAvailable.length == 0) {
            Common.Toast.warning('Não há cheques dispóniveis para desconto');
            return false;
          }

          ModalFactory.customClean('app/finance/check-received/views/dialogs/bank_discount.html',
            'CheckReceivedDiscounts', 'vm', false, discount)
            .then(function (anwser) {
              vm.discount(anwser);
            });
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };


    vm.discount = function (obj) {

      $rootScope.show_loader = true;
      CheckReceivedService.bankDiscount(obj)
        .then(function (resp) {
          vm.checks = [];
          vm.checks = resp;
          $rootScope.show_loader = false;
          Common.Toast.success('Desconto realizado com sucesso');
          $rootScope.$broadcast('update.BORDERO');
        });
    };

    /**
     * Executa transferência do cheque para uma conta.
     * @param list
     */
    vm.checkTransfer = function () {

      $rootScope.show_loader = true;
      CheckReceivedService.getAll({startDate: a4Moment([1950, 0, 1]), endDate: a4Moment(), status: '0,5'})
        .then(function (resp) {
          var transfer = {};
          $rootScope.show_loader = false;
          transfer.checkAvailable = resp;
          if (transfer.checkAvailable.length == 0) {
            Common.Toast.warning('Não há cheques dispóniveis para transferência');
            return false;
          }

          ModalFactory.customClean('app/finance/check-received/views/dialogs/account_transfer.html',
            'CheckReceivedTransferController', 'vm', false, transfer)
            .then(function (anwser) {
              vm.transfer(anwser);
            });
        });
    };
    vm.transfer = function (obj) {

      $rootScope.show_loader = true;
      CheckReceivedService.transferInAccount(obj)
        .then(function (resp) {
          vm.checks = [];
          vm.checks = resp;
          $rootScope.show_loader = false;
          Common.Toast.success('Transferência realizada com sucesso');
          $rootScope.$broadcast('update.BORDERO');
        });
    };

    /**
     * Indica os cheques que foram devolvidos pelo banco e o problema
     * @param list
     */
    vm.bankDevolution = function (list) {

      $rootScope.show_loader = true;
      CheckReceivedService.getAll({startDate: a4Moment([1950, 0, 1]), endDate: a4Moment(), status: '2,6,1,13'})
        .then(function (resp) {
          $rootScope.show_loader = false;
          var devolution = {};
          devolution.checkAvailable = resp;
          if (devolution.checkAvailable.length == 0) {
            Common.Toast.warning('Não há cheques dispóniveis para saque');
            return false;
          }
          ModalFactory.customClean('app/finance/check-received/views/dialogs/bank_devolution.html',
            'CheckReceivedBankDevolution', 'vm', false, devolution)
            .then(function (anwser) {
              vm.devolution(anwser);
              $rootScope.show_loader = false;
            });

        });
    };

    vm.devolution = function (obj) {

      $rootScope.show_loader = true;
      CheckReceivedService.bankDevolution(obj)
        .then(function (resp) {
          vm.checks = [];
          vm.checks = resp;
          $rootScope.show_loader = false;
          Common.Toast.success('Desconto realizado com sucesso');
          $rootScope.$broadcast('update.BORDERO');
        });
    };

    /**
     * Executa o saque do cheque para uma conta.
     */
    vm.withdrawCheck = function () {

      $rootScope.show_loader = true;
      CheckReceivedService.getAll({startDate: a4Moment([1950, 0, 1]), endDate: a4Moment(), status: '0,5'})
        .then(function (resp) {
          $rootScope.show_loader = false;
          var withdraw = {};
          withdraw.checkAvailable = resp;
          if (withdraw.checkAvailable.length == 0) {
            Common.Toast.warning('Não há cheques dispóniveis para saque');
            return false;
          }
          ModalFactory.customClean('app/finance/check-received/views/dialogs/withdraw_check.html',
            'CheckReceivedWithdrawController', 'vm', false, withdraw)
            .then(function (anwser) {
              vm.withdraw(anwser);
            });

        });
    };

    vm.withdraw = function (obj) {

      $rootScope.show_loader = true;
      CheckReceivedService.withdrawCheck(obj)
        .then(function (resp) {
          vm.checks = [];
          vm.checks = resp;
          $rootScope.show_loader = false;
          Common.Toast.success('Desconto realizado com sucesso');
          $rootScope.$broadcast('update.BORDERO');
        });
    };

    /**
     * retrieveCheck
     * Dados dos cheques em caso de perda ou roubo
     */
    vm.retrieveCheck = function () {

      $rootScope.show_loader = true;
      CheckReceivedService.getAll({startDate: a4Moment([1950, 0, 1]), endDate: a4Moment([4000, 0, 1]), status: '0,5'})
        .then(function (resp) {
          $rootScope.show_loader = false;
          var retrieve = {};
          retrieve.checkAvailable = resp;
          if (retrieve.checkAvailable.length == 0) {
            Common.Toast.warning('Não há cheques dispóniveis para saque');
            return false;
          }
          ModalFactory.customClean('app/finance/check-received/views/dialogs/retrieve_check.html',
            'CheckReceivedRetrieveController', 'vm', false, retrieve)
            .then(function (anwser) {
              vm.setRetrieveCheck(anwser);
            });
        });
    };

    /**
     * Muda o status do cheque em caso de perda ou roubo
     * @param obj
     */
    vm.setRetrieveCheck = function (obj) {
      $rootScope.show_loader = true;
      CheckReceivedService.setRetrieveCheck(obj)
        .then(function (resp) {
          vm.checks = [];
          vm.checks = resp;
          $rootScope.show_loader = false;
          Common.Toast.success('Cheques atualizados com sucesso');
          $rootScope.$broadcast('update.BORDERO');
        })
        .catch(function (resp) {
          Common.Toast.error('Problema ao atualizar status do cheque');
        });
    };

    /**
     * changeCheckDueDate
     * Modifica a data de vencimento para o cheque selecionado
     * @param id
     */
    vm.changeCheckDueDate = function (id) {
      if (vm.isValidItem(id)) {
        var current_check = vm.getCheckById(id);
        // dialog: change status
        $mdDialog.show(
          {
            controller: 'ChangeDueDateController',
            controllerAs: 'vm',
            locals: {
              CurrentCheck: angular.copy(current_check)
            },
            templateUrl: 'app/finance/check-received/views/dialogs/change_due_date.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false
          }
        );
      }
    };

    /**
     * getCheckOperationOrigin
     * Retorna a operação de origem para o cheque selecionado
     * @param id
     */
    vm.getCheckOperationOrigin = function (id) {
      if (vm.isValidItem(id)) {
        var current_check = vm.getCheckById(id);
        // dialog: operation origin
        $mdDialog.show(
          {
            controller: 'OperationOriginController',
            locals: {
              CurrentCheck: angular.copy(current_check)
            },
            templateUrl: 'app/finance/check-received/views/dialogs/operation_origin.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false
          }
        );
      }
    };

    /**
     * getCheckStatusNameById
     * Retorna o nome do status pelo seu id
     * @param id
     * @returns {string}
     */
    vm.getCheckStatusNameById = function (id) {
      if (angular.isDefined(id) && id != null) {
        var result = '';
        angular.forEach(vm.status, function (item, i) {
          if (item != null && item.name != null && item.id == id) {
            result = item.name;
          }
        });
        return result;
      }
    };

    /**
     * Retorna um array de objetos 'status' pelo array de ids
     * @param arr
     * @returns {Array}
     */
    vm.getCheckStatusByArrayOfId = function (arr) {
      if (angular.isDefined(arr) && arr != null) {

        var result = [];

        angular.forEach(vm.status, function (status, i) {
          angular.forEach(arr, function (item, n) {
            if (status != null && status.id != null && status.id == item) {
              result.push(status);
            }
          });
        });
        return result;
      }
    };

    /**
     * getCheckById
     * Retorna o cheque pelo seu id
     * @param id
     * @returns {string}
     */
    vm.getCheckById = function (id) {
      if (angular.isDefined(id) && id != null) {
        var result = '';
        angular.forEach(vm.checks, function (item, i) {
          if (item != null && item.check_id != null && item.check_id == id) {
            result = item;
          }
        });
        return result;
      }
      $rootScope.show_loader = false;
    };

    /**
     * isValidItem
     * Validação para alterações de cheque
     * @param idx
     */
    vm.isValidItem = function (idx) {
      return angular.isDefined(idx) && idx != null && vm.checks != null && vm.checks.length > 0;
    };

    vm.getRangeOfDate = function () {
      var date = null;
      if (vm.filter_date && vm.filter_date.initDate != null && vm.filter_date.endDate != null) {
        date = {
          startDate: vm.filter_date.initDate,
          endDate: vm.filter_date.endDate
        };
      } else {
        date = {
          startDate: a4Moment().startOf('month').format('YYYY-MM-DD'),
          endDate: a4Moment().endOf('month').format('YYYY-MM-DD')
        };
      }
      return date;
    };

    /**
     * apiErrorMessageByStatusCode
     * Toast error com mensagens baseada no statusCode da api
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualização');
          break;
        case 406:
          if (response.data == 'CHECK_STATUS_NOT_PERMITTED') {
            Common.Toast.error('Status do cheque não permite modificações.');
          } else if (response.data == 'ONLY_DATES_EQUAL_OR_GREATER_THAN_TODAY') {
            Common.Toast.error('A data do cheque não pode ser modificada: Data anterior ao dia atual.');
          }
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor');
          break;
      }

      $mdDialog.hide();
      $mdDialog.cancel();
    };

    /**
     * Realiza a pesquisa de cheques
     * @param search
     */
    vm.sendSearch = function (search) {
      $rootScope.show_loader = true;
      CheckReceivedService.sendSearch(search)
        .then(function (response) {
          vm.checks = response;
          $rootScope.show_loader = false;
        })
    };

    vm.getAllAccounts = function () {
      $rootScope.show_loader = true;
      CheckReceivedService.getAllCurrentAccount()
        .then(function (response) {
          vm.accounts = response;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Escuta para mudança da string de pesquisa
     */
    $scope.$watch('vm.search', function (newer, older) {
      //noinspection JSValidateTypes
      if (newer != '' && newer != null) {
        vm.sendSearch(newer);
      } else {
        if (vm.filter_date != null && angular.isDefined(vm.filter_date['initDate']) && angular.isDefined(vm.filter_date['endDate'])) {
          vm.getAllChecks(vm.status_string, [], vm.filter_date['initDate'], vm.filter_date['endDate']);
        }
      }
    });

    /**
     * Escuta para mudança do filtro de datas
     */
    $scope.$watch('vm.filter_date', function (newer, older) {
      //noinspection JSValidateTypes
      if (newer !== '' && newer != null) {
        vm.getAllChecks(vm.status_string, [], newer['initDate'], newer['endDate']);
      }
    });

    /**
     * Escuta para mudança do filtro de status
     */
    $scope.$watch('vm.selected_status', function () {
      if (vm.selected_status != null) {
        //vm.checks_filter = vm.filterByStatus();
        vm.status_string = [];
        angular.forEach(vm.selected_status, function (item) {
          if (item != null) {
            vm.status_string.push(item.id);
          }
        });
        vm.status_string = vm.status_string.toString();
        if (vm.filter_date != undefined && vm.status_string != '') {
          vm.getAllChecks(vm.status_string, vm.accounts_string, vm.filter_date['initDate'], vm.filter_date['endDate']);
        }
      }
    });

    /**
     * Escuta para mudança do filtro de contas
     */
    $scope.$watch(function () {
      return vm.selected_account;
    }, function (newer, older) {
      if (newer != null) {
        vm.accounts_string = [];
        angular.forEach(vm.selected_account, function (item) {
          if (item != null) {
            vm.accounts_string.push(item.id);
          }
        });
        vm.accounts_string = vm.accounts_string.toString();
        if (vm.filter_date != null && angular.isDefined(vm.filter_date['initDate']) && angular.isDefined(vm.filter_date['endDate']) && vm.accounts_string != '') {
          vm.getAllChecks(vm.status_string, vm.accounts_string, vm.filter_date['initDate'], vm.filter_date['endDate']);
        }
      }
    });

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.finance.check-received')
    .controller('CheckReceivedController', CheckReceivedController);

})();


(function () {
  'use strict';

  var constants = {
    'EM_MAOS': 0,
    'EM_CUSTODIA': 1,
    'DEPOSITADO': 2,
    'DEVOLVIDO': 5,
    'REAPRESENTADO': 6,
    'COMPENSADO_SACADO': 10,
    'RESGATADO': 12,
    'COMPENSADO': 13,
    'UTILIZADO_PAGAMENTO': 14,
    'EXTRAVIADO': 90
  };

  angular.module('app.finance.check-received')
    .constant('CHECK_STATUS', constants)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CheckStatusController($scope, $mdDialog, CurrentCheck, Common, $rootScope, CheckReceivedService) {
    var vm = this;
    $scope.current_check = CurrentCheck;

    // mudanças para o select com status
    $scope.changeStatus = function () {
      var id = $scope.current_check.check_status_id;
      $scope.current_check.check_status_name = vm.getCheckStatusNameById(id);
    };

    // cancelamento para o $mdDialog
    $scope.cancel = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    // confirmação
    $scope.confirm = function (check_id, description) {

      if (check_id != null && description != null) {

        var obj = {check_id: check_id, description: description};

        CheckReceivedService.addCheckDescription(obj)
          .then(function () {

            Common.Toast.success('Observação adicionada com sucesso!');

            vm.getAllChecks(vm.status_string, [], vm.filter_date['initDate'], vm.filter_date['endDate']);
            $rootScope.show_loader = false;
            $mdDialog.hide();
            $mdDialog.cancel();
          })
          .catch(function (response) {
            vm.apiErrorMessageByStatusCode(response);
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * apiErrorMessageByStatusCode
     * Toast error com mensagens baseada no statusCode da api
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualização');
          break;
        case 406:
          if (response.data == 'CHECK_STATUS_NOT_PERMITTED') {
            Common.Toast.error('Status do cheque não permite modificações.');
          } else if (response.data == 'ONLY_DATES_EQUAL_OR_GREATER_THAN_TODAY') {
            Common.Toast.error('A data do cheque não pode ser modificada: Data anterior ao dia atual.');
          }
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor');
          break;
      }

      $mdDialog.hide();
      $mdDialog.cancel();
    };
  }

  angular
    .module('app.finance.check-received')
    .controller('CheckStatusController', CheckStatusController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ChangeDueDateController($mdDialog, $rootScope, CurrentCheck, CheckReceivedService, Common, a4Moment) {

    var vm = this;
    vm.process = false;
    vm.current_check = CurrentCheck;
    vm.due_date = a4Moment(CurrentCheck.date);
    vm.min_date = a4Moment();

    //cancelamento para o $mdDialog
    vm.cancel = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    //confirmação
    vm.confirm = function (data, due_date, form) {
      if (form.$valid) {
        vm.process = true;
        var obj = {check_id: data.check_id, due_date: due_date};
        CheckReceivedService.changeCheckDueDate(obj)
          .then(function (response) {
            Common.Toast.success('Data de vencimemento atualizada com sucesso!');
            $rootScope.$broadcast('update.CHECK_RECEIVED');
            $rootScope.show_loader = false;
            $mdDialog.hide();
            $mdDialog.cancel();
          })
          .catch(function (response) {
            vm.apiErrorMessageByStatusCode(response);
            $rootScope.show_loader = false;
          })
          .finally(function () {
            vm.process = false;
          });
      }
    };

    /**
     * apiErrorMessageByStatusCode
     * Toast error com mensagens baseada no statusCode da api
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualização');
          break;
        case 406:
          if (response.data == 'CHECK_STATUS_NOT_PERMITTED') {
            Common.Toast.error('Status do cheque não permite modificações.');
          } else if (response.data == 'ONLY_DATES_EQUAL_OR_GREATER_THAN_TODAY') {
            Common.Toast.error('A data do cheque não pode ser modificada: Data anterior ao dia atual.');
          }
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor');
          break;
      }

      $mdDialog.hide();
      $mdDialog.cancel();
    };

  }

  angular
    .module('app.finance.check-received')
    .controller('ChangeDueDateController', ChangeDueDateController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function CheckReceivedBankDevolution(ModalExtra, $filter, $mdDialog, CURRENT_ACCOUNT_TYPES,
                                       CurrentAccountService, Common, CheckReceivedService, $rootScope, $timeout) {
    var vm = this;
    vm.data = ModalExtra;
    vm.devolution = {};
    vm.devolution.checkList = [];
    vm.devolution.date = new Date();
    vm.query = {
      limit: 1000,
      page: 1
    };

    vm.init = function () {
      vm.getAccountsByType();
      vm.getAllCheckIssue();
    };

    vm.convertDate = function (date) {
      var cDate = date.split('-');
      return cDate[2] + '/' + cDate[1] + '/' + cDate[0]
    };

    vm.getAccountsByType = function () {
      CurrentAccountService.getByTypes({types: CURRENT_ACCOUNT_TYPES.CONTA_CAIXA})
        .then(function (resp) {
          vm.current_accounts = resp;
        })
    };

    vm.getAllCheckIssue = function () {
      CheckReceivedService.getAllCheckIssue()
        .then(function (response) {
          vm.check_issues = response;
        })
    };


    vm.answer = function (answer, form) {
      if (form.$valid) {
        if (answer.checkList.length > 0) {
          $mdDialog.hide(answer);
        } else {
          Common.Toast.warning('Por favor, selecione pelo menos um cheque da lista');
        }
      }
      $rootScope.show_loader = false;
    };

    // vm.clearSearchTerm = function () {
    //   vm.searchTerm = '';
    // };
    //
    // $scope.$watch('vm.searchTerm', function (newer, older) {
    //   // if (newer != '' && newer != null) {
    //   //   vm.getAllChecks(vm.status_string, vm.accounts_string, newer['initDate'], newer['endDate']);
    //   // }
    // });
    //
    // /**
    //  * Search for repos... use $timeout to simulate
    //  * remote dataservice call.
    //  */
    // vm.simulateQuery = false;
    // vm.querySearch = function(query) {
    //   var results = query ?  $filter('filter')(vm.check_issues, query) : vm.check_issues, deferred;
    //
    //   if (vm.simulateQuery) {
    //     deferred = $q.defer();
    //     $timeout(function () {
    //       deferred.resolve(results);
    //     }, Math.random() * 1000, false);
    //     return deferred.promise;
    //   } else {
    //     return results;
    //   }
    // };
    //
    // /**
    //  * Create filter function for a query string
    //  */
    // vm.createFilterFor = function(query) {
    //   return function filterFn(item) {
    //     return (item.name.indexOf(query) === 0);
    //   };
    // };



    vm.closeModal = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular.module('app.finance.check-received')
    .controller('CheckReceivedBankDevolution', CheckReceivedBankDevolution)
})();
(function () {
    'use strict';

    /** @ngInject */
    function CashierSessionService($http, CONFIG, Common, Restangular, Session, ModalFactory) {

      var openSession = function (obj) {
        return Restangular.all('cashiersession').post(obj);
      };

      var getAllMovements = function () {
        return Restangular.one('cashiersession').one('movements').one('all').get();
      };

      var getCashierSessionPersons = function (obj) {
        return Restangular.one('cashiersession').one('getcashiersessionpersons').get(obj);
      };

      var getSessionOpened = function () {
        return Restangular.one('cashiersession').one('getopened').get();
      };

      var getAllOpenedSessions = function () {
        return Restangular.one('cashiersession').one('getopenedsessions').get();
      };

      var getAccounts = function () {
        return Restangular.one('cashiersession').one('getaccounts').get();
      };

      var closeSession = function (obj) {
        return Restangular.one('cashiersession').all('closesession').post(obj);
      };

      var makeSingleMovement = function (obj) {
        return Restangular.one('cashiersession').all('makesinglemovement').post(obj);
      };

      var makeSingleMovementRetroactive = function (obj) {
        return Restangular.one('cashiersession').all('makesinglemovementretroactive').post(obj);
      };

      var tranferTo = function (obj) {
        return Restangular.one('cashiersession').all('transfer').post(obj);
      };

      var deleteSingleMovement = function (obj) {
        return Restangular.one('cashiersession').all('deletesinglemovement').post(obj);
      };

      var printGuestCheckPadReport = function (bill_action_id, is_guest_check_pad) {
        ModalFactory.customClean(
          'app/finance/cashier-session/view/cashier-session-print.html',
          /** @ngInject */
          function ($document, $rootScope, CONFIG, ModalExtra, Session, $window, CashierManagementService, ReportsService) {
            var vm = this;
            vm.is_guest_check_pad = is_guest_check_pad;
            vm.disable_buttons = true;
            vm.url_download = CONFIG.webApiUri + "api/cashiersession/guestcheckpad/report/";
            CashierManagementService.getToken().then(function (response) {
              vm.token = response;
              vm.disable_buttons = false;
            });
            vm.school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
            vm.downloadFile = function (type) {
              var subdomain = $document[0].domain.split('.')[0];
              var url = vm.url_download + '?token=' + vm.token + "&company=" + Session.get('current_company', "sessionStorage") +
                "&connection=" + subdomain + "&bill_action_id=" + ModalExtra.bill_action_id + "&type=" + type + "&school_period=" + vm.school_period_id;
              $window.open(url);
            };
            vm.close = function () {
              $rootScope.$broadcast('ModalFactory.close');
            }
          },
          'vm', false, {bill_action_id: bill_action_id}
        ).then(function () {
          return true;
        }).catch(function () {
          return false;
        });
      };

      var printSingleMovement = function (movement_id) {
        var deffered = Common.$q.defer();
        $http({
          method: 'GET',
          url: CONFIG.webApiUri + 'api/reports/printsinglemovement?movement_id=' + movement_id + '&user_id=' + Session.user.id,
          responseType: 'arraybuffer'
        }).then(function (response) {
          var headers = response.headers();
          var status = response.status;
          var data = response.data;
          var contentType = headers['content-type'];
          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], {type: contentType});
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute('target', '_blank');
            var clickEvent = new MouseEvent("click", {
              "view": window, "bubbles": true, "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
            deffered.resolve(true);
          } catch (ex) {
            deffered.reject(ex);
          }
        }, function (error) {

        });
        return deffered.promise;

      };

      return {
        openSession: openSession,
        getAccounts: getAccounts,
        getAllMovements: getAllMovements,
        closeSession: closeSession,
        deleteSingleMovement: deleteSingleMovement,
        getSessionOpened: getSessionOpened,
        makeSingleMovement: makeSingleMovement,
        tranferTo: tranferTo,
        printSingleMovement: printSingleMovement,
        getAllOpenedSessions: getAllOpenedSessions,
        getCashierSessionPersons: getCashierSessionPersons,
        printGuestCheckPadReport: printGuestCheckPadReport,
        makeSingleMovementRetroactive: makeSingleMovementRetroactive
      }

    }

    angular
      .module('app.finance.cashier-session')
      .factory('CashierSessionService', CashierSessionService);

  }

)();

(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.cashier-session', {
        url: '/cashier-session',
        public: false,
        templateUrl: 'app/finance/cashier-session/view/index.html',
        controller: 'CashierSessionController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Caixa'
        },
        params: {
          bill_action_id: null
        }
      })
      .state('private.finance.cashier-session.account-entry', {
        url: '/account-entry',
        parent: 'private.finance.cashier-session',
        views: {
          'sidenav@private.finance': {
            templateUrl: 'app/finance/current-account/views/sidenavs/account_entry.html',
            controller: 'CurrentAccountController',
            controllerAs: 'vm'
          }
        },
        params: {
          account: null
        }
      })
      .state('private.finance.cashier-session.account-output', {
        url: '/account-output',
        parent: 'private.finance.cashier-session',
        views: {
          'sidenav@private.finance': {
            templateUrl: 'app/finance/current-account/views/sidenavs/account_output.html',
            controller: 'CurrentAccountController',
            controllerAs: 'vm'
          }
        },
      params: {
          account: null
        }
      })
      .state('private.finance.cashier-session.account-transference', {
        url: '/account-transference',
        parent: 'private.finance.cashier-session',
        views: {
          'sidenav@private.finance': {
            templateUrl: 'app/finance/current-account/views/sidenavs/account_transference.html',
            controller: 'CurrentAccountController',
            controllerAs: 'vm'
          }
        },
        params: {
          account: null
        }
      });
  }

  angular
    .module('app.finance.cashier-session')
    .config(routerConfig);


})();



(function() {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'caixa_menu';
    var path = 'finance.cashier-session';
    msNavigationService.saveItem('finance.cashier-session', {
      title : 'Caixa',
      icon  : 'icon-cash-usd',
      state : 'private.finance.cashier-session',
      auth: role,
      weight: 11,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.cashier-session')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function CashierSessionController($rootScope, $scope, $state, CashierSessionService, ModalFactory, Common, a4Moment, RolesService, PoliciesService) {

    var vm = this;
    vm.accounts = [];
    vm.session = {};
    vm.includeScope = {};
    vm.sidenavOpen = false;
    vm.session_opened = false;
    vm.disable_mov_retroativo = false;
    vm.operations = [
      {title: 'Abrir nova comanda', flex: 30, icon: 'icon-file-document', action: "newGuestPad"},
      {title: 'Relatório de Sessão', flex: 30, icon: 'icon-file-find', action: "viewSessionReport"},
      {title: 'Transferir para outra sessão', flex: 30, icon: 'icon-repeat', action: "transferBetweenSessions"},
      {title: 'Entrada avulsa', flex: 30, icon: 'icon-arrow-down', action: 'makeSingleInput'},
      {title: 'Saída avulsa', flex: 30, icon: 'icon-arrow-up', action: 'makeSingleOutput'}
    ];

    vm.methods = [
      {id: 1, name: "Dinheiro"},
      {id: 2, name: "Cheque"},
      {id: 5, name: "Cheque de terceiros"},
      {id: 10, name: "Boleto"},
      {id: 11, name: "Depósito"},
      {id: 12, name: "Transferência"},
      {id: 20, name: "Cartão de débito"},
      {id: 21, name: "Cartão de crédito"}
    ];


    vm.init = function () {
      /* Verifica a permissão "Entrada/Saida retroativa" para bloquear "Data da ação" */
      if(vm.checkPolicies('mov_retroativo')){
        vm.disable_mov_retroativo = false;
      }
      // vm.getAccounts();
      if ($state.params.bill_action_id !== null) {
        CashierSessionService.printGuestCheckPadReport($state.params.bill_action_id, true);
      }
      vm.getOpenedCashierSession();
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Executa uma ação do caixa
     * @param action
     */
    vm.executeAction = function (action) {
      switch (action) {
        case 'newGuestPad':
          vm.newGuestPad();
          break;
        case 'viewSessionReport':
          vm.viewSessionReport();
          break;
        case 'makeSingleInput':
          vm.makeSingleInput();
          break;
        case 'makeSingleOutput':
          vm.makeSingleOutput();
          break;
        case 'transferBetweenSessions':
          vm.transferBetweenSessions();
          break;
      }
    };

    /**
     * Tranferir recursos entre sessões de caixa
     */
    vm.transferBetweenSessions = function () {
      ModalFactory.customClean(
        'app/finance/cashier-session/view/cashier-session-transfer.html',
        'CashierSessionTransferController',
        'vm', false, {}
      ).then(function () {

      });
    };

    /**
     * Visualiza todos os movimentos de uma sessão de caixa especifica
     */
    vm.viewSessionReport = function () {
      ModalFactory.customClean(
        'app/finance/cashier-session/view/cashier-session-report.html',
        'CashierSessionReportController',
        'vm', false, {}
      )
    };

    /**
     * Modal com os dados para uma entrada avulsa
     * @param Request $request
     */
    vm.makeSingleInput = function () {
      ModalFactory.custom('app/finance/cashier-session/view/confirmTransaction.html', {
        debit_credit: 'C',
        date: a4Moment(),
        disable: true,
        max_date: a4Moment(),
        disable_mov_retroativo: vm.disable_mov_retroativo
      }, false)
        .then(function (data) {
          vm.makeSingleMovement(data);
        });
    };

    /**
     * Modal com os dados para uma saída avulsa
     * @param Request $request
     */
    vm.makeSingleOutput = function () {
      ModalFactory.custom('app/finance/cashier-session/view/confirmTransaction.html', {
        debit_credit: 'D',
        date: a4Moment(),
        disable: true,
        max_date: a4Moment()
      }, false)
        .then(function (data) {
          data.confirm_action = false;
          vm.makeSingleMovement(data)
        });
    };

    /**
     * Realiza um movimento de entrada ou saída avulsa
     * @param data
     */
    vm.makeSingleMovement = function (data) {
      $rootScope.show_loader = true;
      CashierSessionService.makeSingleMovement(data)
        .then(function () {
          Common.Toast.success('Ação realizada com sucesso');
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          Common.Toast.error(response.data.message);
          if (response.data.message === 'Não há saldo suficiente para a transação.') {
            ModalFactory.confirm(null, 'Saída de sessão sem saldo',
              'A sessão de caixa não possui saldo atualmente. Deseja continuar com a saída?',
              'Confirmar', 'Cancelar', 'finance').then(function () {
              data.confirm_action = true;
              vm.makeSingleMovement(data);
            })
          }
          $rootScope.show_loader = false;
        })
    };

    vm.getOpenedCashierSession = function () {
      $rootScope.show_loader = true;
      CashierSessionService.getSessionOpened()
        .then(function (session) {
          if (!angular.isUndefined(session)) {
            vm.session = session.plain();
          }
          vm.session_opened = angular.isUndefined(session) ? false : session;
          vm.show_guest_pad_cashier_session = true;
          vm.cashierAccount(session);
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };


    vm.getAccounts = function () {
      $rootScope.show_loader = true;
      CashierSessionService.getAccounts()
        .then(function (resp) {
          vm.accounts = resp.result;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.cashierAccount = function (account) {
      if (!angular.isUndefined(account)) {

        vm.selected_account = account;

        var obj = {
          account_id: account.id,
          startDate: a4Moment().startOf('month').format('YYYY-MM-DD'),
          endDate: a4Moment().format('YYYY-MM-DD')
        };

        vm.getAllMovements(obj);
      }
    };

    vm.accountEntry = function () {
    };

    vm.newGuestPad = function () {
      $state.go('private.finance.guest-check-pad', {cashier_session_id: vm.session.id});
    };

    /**
     * getAllMovements
     * Retorna todos os movements da conta corrente
     * @param obj
     */
    vm.getAllMovements = function (obj) {
      $rootScope.show_loader = true;
      CashierSessionService.getAllMovements(obj)
        .then(function (response) {
          vm.all_movements = response;
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        })
    };


    /**
     * openSession
     * Abre sessão de caixa
     * @param cashier_session
     * @param form
     */
    vm.openSession = function (cashier_session, form) {
      $rootScope.show_loader = true;
      var password = '';
      ModalFactory.open('require_password', null, null, {
        password: password,
        cashier_session: cashier_session
      }, null, 'finance', vm.openCashierSession, 'Abertura de sessão de caixa', 'Para abrir a sessão, confirme sua senha')
        .then(function (answer) {
          if (answer) {
            Common.Toast.success(answer.message);
            vm.getOpenedCashierSession();
            vm.getAccounts();
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.openCashierSession = function (data) {
      return CashierSessionService.openSession({'session': data.cashier_session});
    };

    vm.closeSession = function ($event) {
      $rootScope.show_loader = true;
      ModalFactory.confirm($event, "Confirmar encerramento", "Deseja realmente encerrar a sessão de caixa?", 'Confirmar', 'Cancelar')
        .then(function () {
          CashierSessionService.closeSession()
            .then(function (response) {
              if (response.message == "CLOSE_SESSION_SUCCESS") {
                Common.Toast.success("Sessão encerrada com sucesso!");
                vm.selected_account = null;
                vm.session = null;
                vm.getOpenedCashierSession();
                vm.getAccounts();
              }
              $rootScope.show_loader = false;
            })
            .catch(function (response) {
              switch (response.data.message) {
                case "CLOSE_SESSION_ERROR":
                  Common.Toast.error("Erro ao encerrar sessão, tente mais tarde!");
                  break;
                default:
                  Common.Toast.error(response.data.message);
              }
              $rootScope.show_loader = false;
            });
        });
      $rootScope.show_loader = false;
    };


    vm.init();
  }

  angular
    .module('app.finance.cashier-session')
    .controller('CashierSessionController', CashierSessionController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function CashierSessionTransferController($rootScope, CashierSessionService, Common) {

    var vm = this;
    vm.sessions = [];
    vm.transfer = {};

    vm.init = function () {

    };

    vm.getSessions = function () {
      return CashierSessionService.getAllOpenedSessions()
        .then(function (sessions) {
          vm.sessions = sessions.plain();
        });
    };

    /**
     * Transferência entre sessões
     */
    vm.transferTo = function (obj) {
      $rootScope.show_loader = true;
      CashierSessionService.tranferTo({transf: obj})
        .then(function () {
          vm.close();
          Common.Toast.success('Ação realizada com sucesso');
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          Common.Toast.error(response.data.message);
          $rootScope.show_loader = false;
        });
    };

    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular
    .module('app.finance.cashier-session')
    .controller('CashierSessionTransferController', CashierSessionTransferController)

})();
(function () {
  'use strict';

  /** @ngInject */
  function CashierSessionReportController($rootScope, Common, CashierSessionService, ReportsService) {

    var vm = this;
    vm.show_loading = false;

    vm.records = [];

    vm.init = function () {
      vm.getCashierSessionMovements();
    };

    /**
     * Retorna todas as movimentações da sessão de caixa
     */
    vm.getCashierSessionMovements = function () {
      CashierSessionService.getAllMovements()
        .then(function (movements) {
          vm.records = movements.plain();
        })
    };

    /**
     * Total das movimentações
     */
    vm.getTotal = function () {
      var total = 0;

      vm.records.forEach(function (item) {
        if (item.debit_credit === 'C') {
          total += parseFloat(item.amount);
        } else if (item.debit_credit === 'D') {
          total -= parseFloat(item.amount);
        }
      });
      return total;
    };

    /**
     * Imprime recibo de entrada/saída avulsa
     * @param movement
     */
    vm.printSingleMovement = function (movement) {
      $rootScope.show_loader = true;
      CashierSessionService.printSingleMovement(movement.id)
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Movimento impresso com sucesso!');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    vm.deleteSingleMovement = function (movement) {
      vm.show_loading = true;
      CashierSessionService.deleteSingleMovement(movement).then(function () {
        Common.Toast.success('Movimento excluído com sucesso!');
        vm.getCashierSessionMovements();
        vm.show_loading = false;
      })
        .catch(function (error) {
          vm.show_loading = false;
          Common.Toast.warning(error.data.message);
        })
    };

    vm.printCashierSession = function () {
      ReportsService.reportFactory('GET', 'api/reports/printcashiersession',
        {
          records: 0
        });
    }

    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular
    .module('app.finance.cashier-session')
    .controller('CashierSessionReportController', CashierSessionReportController)

})();
(function () {
  'use strict';

  angular
    .module('app.finance.cashier-management', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function CashierManagementService(Restangular) {

    var deleteCashierSession = function (index) {
      return Restangular.one('cashiersession', index).remove();
    };

    var getAllCashierSession = function (obj) {
      return Restangular.one('cashiersession').get(obj);
    };

    var checkCashierSession = function (id) {
      return Restangular.one('cashiersession').one('check', id).post();
    };

    var reopenSession = function (obj) {
      return Restangular.one('cashiersession').all('reopensession').post(obj);
    };

    var getToken = function (obj) {
      return Restangular.one('cashiersession').one('gettoken').get(obj);

    }

    var hasMovements = function (id) {
      return Restangular.one('cashiersession').one('hasmovements', id).get();

    }

    return {
      getAllCashierSession: getAllCashierSession,
      deleteCashierSession: deleteCashierSession,
      reopenSession: reopenSession,
      checkCashierSession: checkCashierSession,
        getToken: getToken,
        hasMovements: hasMovements

    }
  }

  angular
    .module('app.finance.cashier-management')
    .factory('CashierManagementService', CashierManagementService);

})();
(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.cashier-management', {
        url: '/cashier-management',
        public: false,
        templateUrl: 'app/finance/cashier-management/view/index.html',
        controller: 'CashierManagementController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Gerenciamento de Caixa'
        }
      });
  }

  angular
    .module('app.finance.cashier-management')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function CashierManagementController($rootScope, CashierManagementService, a4Moment, ModalFactory, Common, $document,
                                       CONFIG, $window, Session, PoliciesService, CashierSessionService) {

    var vm = this;
    vm.grid = {};
    vm.webLink = CONFIG.webApiUri + 'api/reports/cashiersession/print';
    vm.subdomain = $document[0].domain.split('.')[0];
    vm.company = Session.getCurrentCompany();

    vm.init = function () {
      vm.getAllCashierSession();
      vm.getToken();
      vm.can_reopen_cashier_session = vm.checkPolicies('reopen_cashier_session');
    };

    vm.getToken = function () {
      CashierManagementService.getToken().then(function (response) {
        vm.token = response;
      })
    };

    vm.getAllCashierSession = function (page, limit) {
      limit = angular.isDefined(limit) ? limit : 20;
      page = angular.isDefined(page) ? page : 1;

      CashierManagementService.getAllCashierSession({page: page, limit: limit})
        .then(function (response) {
          vm.cashier_sessions = response;
          vm.cashier_sessions.data.forEach(function (item) {
            item.open_date = a4Moment(item.open_datetime).format('DD/MM/YYYY HH:mm');
            item.close_date = item.close_datetime === null ? null : a4Moment(item.close_datetime).format('DD/MM/YYYY HH:mm');
            item.total_amount = item.total_credit - item.total_debit;
            item.reopening_log = item.reopening_log !== null ? angular.fromJson(item.reopening_log) : null;
          });
          $rootScope.show_loader = false;
        })
    };

    /**
     * Modal de configuração de caixa;
     */
    vm.openCashierConfiguration = function () {
      // is_twofold_receipt
      ModalFactory.customClean(
        'app/finance/cashier-management/view/configuration.html',
        'CashierConfigurationController',
        'vm', false, {}
      );
    };


    vm.delete = function (index) {
      ModalFactory.confirm(
        null, "Exclusão de Sessão de Caixa",
        "Deseja realmente excluir essa Sessão de Caixa?",
        "Deletar", "Cancelar",
        'finance'
      ).then(function () {
        $rootScope.show_loader = true;
        CashierManagementService.deleteCashierSession(index)
          .then(function (response) {
            Common.Toast.success("Sessão de Caixa deletada com sucesso");
            vm.cashier_sessions = response;

            vm.cashier_sessions.data.forEach(function (item) {
              item.open_date = a4Moment(item.open_datetime).format('DD/MM/YYYY HH:mm');
              item.close_date = item.close_datetime === null ? null : a4Moment(item.close_datetime).format('DD/MM/YYYY HH:mm');
            });
            $rootScope.show_loader = false;
          }).catch(function (response) {
          Common.Toast.error(response.data);
          $rootScope.show_loader = false;
        })
      })
    };

    /**
     * Clique de ação
     */
    vm.cashierSessionAction = function (obj, option) {
      switch (option) {
        case 'verify':
          vm.checkCashierSession(obj);
          break;
        case 'reopen':
          vm.reopenCashierSession(obj);
          break;
        case 'report':
          vm.printReport(obj);
          break;
        case 'input':
          vm.makeSingleInput(obj);
          break;
        case 'output':
          vm.makeSingleOutput(obj);
          break;
        case 'close':
          vm.closeSession(obj.id);
          break;
      }
    };
    /**
     * Modal com os dados para uma entrada avulsa
     */
    vm.makeSingleInput = function (obj) {
      ModalFactory.custom('app/finance/cashier-session/view/confirmTransaction.html', {
        debit_credit: 'C',
        date: a4Moment(obj.open_datetime),
        cashier_session_id: obj.id,
        confirm_action: true,
        disable: false,
        max_date: a4Moment(obj.close_datetime),
        min_date: a4Moment(obj.open_datetime)
      }, false)
        .then(function (data) {
          ModalFactory.open('require_password', null, null, data, null, 'finance', vm.makeSingleMovement,
            'Confirmação de movimento retroativo', 'Insira sua senha para confirmar o movimento', null, false)
            .then(function () {
              Common.Toast.success('Ação realizada com sucesso');
              vm.getAllCashierSession();
              $rootScope.show_loader = false;
            })
            .catch(function (response) {
              Common.Toast.error(response.data.message);
              if (response.data.message === 'Não há saldo suficiente para a transação.') {
                ModalFactory.confirm(null, 'Saída de sessão sem saldo',
                  'A sessão de caixa não possui saldo atualmente. Deseja continuar com a saída?',
                  'Confirmar', 'Cancelar', 'finance').then(function () {
                  data.confirm_action = true;
                  vm.makeSingleMovement(data);
                })
              }
              $rootScope.show_loader = false;
            });
        });
    };

    /**
     * Modal com os dados para uma saída avulsa
     * @param Request $request
     */
    vm.makeSingleOutput = function (obj) {
      ModalFactory.custom('app/finance/cashier-session/view/confirmTransaction.html', {
        debit_credit: 'D',
        date: a4Moment(obj.open_datetime),
        cashier_session_id: obj.id,
        confirm_action: true,
        disable: false,
        max_date: a4Moment(obj.close_datetime),
        min_date: a4Moment(obj.open_datetime)
      }, false)
        .then(function (data) {
          ModalFactory.open('require_password', null, null, data, null, 'finance', vm.makeSingleMovement,
            'Confirmação de movimento retroativo', 'Insira sua senha para confirmar o movimento', "Atenção: mesmo sem saldo a saída será confirmada!", false)
            .then(function () {
              Common.Toast.success('Ação realizada com sucesso');
              vm.getAllCashierSession();
              $rootScope.show_loader = false;
            })
            .catch(function (response) {
              Common.Toast.error(response.data.message);
              if (response.data.message === 'Não há saldo suficiente para a transação.') {
                ModalFactory.confirm(null, 'Saída de sessão sem saldo',
                  'A sessão de caixa não possui saldo atualmente. Deseja continuar com a saída?',
                  'Confirmar', 'Cancelar', 'finance').then(function () {
                  data.confirm_action = true;
                  vm.makeSingleMovement(data);
                })
              }
              $rootScope.show_loader = false;
            });
        });
    };

    /**
     * Realiza um movimento de entrada ou saída avulsa
     * @param data
     */
    vm.makeSingleMovement = function (data) {
      $rootScope.show_loader = true;
      return CashierSessionService.makeSingleMovementRetroactive(data);
    };


    /**
     * Conferência de sessão de caixa
     */
    vm.checkCashierSession = function (item) {
      ModalFactory.confirm(
        null,
        "Conferência de sessão de caixa",
        "Deseja realmente dar como conferida a Sessão de Caixa?",
        "Sim", "Não",
        'finance'
      ).then(function () {
        $rootScope.show_loader = true;
        CashierManagementService.checkCashierSession(item.id)
          .then(function () {
            Common.Toast.success("Sessão conferida com sucesso");
            vm.getAllCashierSession(1, 15);
            $rootScope.show_loader = false;
          })
          .catch(function (error) {
            $rootScope.show_loader = false;
            Common.Toast.error("Sessão não pode ser conferida " + error.data);
          })
      });

    };

    vm.closeSession = function (cashier_session_id) {
      ModalFactory.confirm(null, "Confirmar encerramento", "Deseja realmente encerrar a sessão de caixa?", 'Confirmar', 'Cancelar', 'finance')
        .then(function () {
          $rootScope.show_loader = true;
          CashierSessionService.closeSession({cashier_session_id: cashier_session_id})
            .then(function () {
              Common.Toast.success("Sessão encerrada com sucesso!");
              vm.getAllCashierSession(1, 15);
              $rootScope.show_loader = false;
            })
        })

    };

    /**
     * Reabertura de sessão de caixa
     * @param item
     */
    vm.reopenCashierSession = function (item) {
      if (item.status === 'Conferida') {
        if (!vm.can_reopen_cashier_session) {
          return ModalFactory.alert(
            'Atenção',
            'Não é possível realizar a reabertura de uma sessão de caixa já conferida.',
            'alert',
            'Ok',
            true
          )
        } else {
          return vm.reopenSession(item);
        }
      }

      if (item.close_datetime !== null && (a4Moment(item.open_datetime).format('YYYY-MM-DD') !== a4Moment().format('YYYY-MM-DD'))) {
        if (!vm.can_reopen_cashier_session) {
          return ModalFactory.alert(
            'Atenção',
            'Só é possível realizar a reabertura de uma sessão de caixa no mesmo dia da sua abertura.',
            'alert',
            'Ok',
            true
          )
        } else {
          vm.reopenSession(item);
        }
      }

      if (item.close_datetime == null) {
        return ModalFactory.alert(
          'Atenção',
          'Sessão de caixa já aberta.',
          'alert',
          'Ok',
          true
        )
      }

      vm.reopenSession(item);
    };


    vm.reopenSession = function (item) {
      ModalFactory.prompt(
        null,
        'Justificativa',
        'Digite o motivo para a reabertura da sessão:',
        '',
        '',
        'Confirmar',
        'Cancelar',
        'finance',
        null, true).then(function (reason) {
        ModalFactory.open('require_password', null, null, {
            id: item.id,
            reason: reason,
            can_reopen: vm.can_reopen_cashier_session
          }, null,
          'finance', vm.executeReopen, 'Confirmação de reabertura de sessão', 'Confirme sua senha para reabrir a sessão', null)
          .then(function (response) {
            Common.Toast.success("Sessão reaberta com sucesso");
            vm.cashier_sessions = response;
            vm.cashier_sessions.data.forEach(function (item) {
              item.open_date = a4Moment(item.open_datetime).format('DD/MM/YYYY HH:mm');
              item.close_date = item.close_datetime === null ? null : a4Moment(item.close_datetime).format('DD/MM/YYYY HH:mm');
              item.reopening_log = item.reopening_log !== null ? angular.fromJson(item.reopening_log) : null;
            });
            $rootScope.show_loader = false;
          })
          .catch(function (response) {
            switch (response) {
              case "REOPEN_ERROR_IS_VERIFIED":
                Common.Toast.error("Não é possível reabrir uma sessão já conferida");
                break;
              case "REOPEN_ERROR_OPEN_SESSION":
                Common.Toast.error("Não é possível reabrir uma sessão já aberta");
                break;
              case "REOPEN_ERROR_NOT_TODAY":
                Common.Toast.error("Não é possível reabrir uma sessão de caixa em dia diferente da sua abertura");
                break;
              case "REOPEN_ERROR":
                Common.Toast.error("Erro ao reabrir sessão");
                break;
              default:
                Common.Toast.error("Erro ao reabrir sessão");
            }
          });
      });
    };

    vm.executeReopen = function (obj) {
      return CashierManagementService.reopenSession(obj);
    };
    /**
     * Mostrar relatório da sessão de caixa
     * @param item
     */
    vm.printReport = function (item) {

      CashierManagementService.hasMovements(item.id).then(function () {
        var element = angular.element('<a />');
        element.click(function () {
          $window.open(vm.webLink + '?token=' + vm.token + '&cashier_session_id=' + item.id + '&connection=' + vm.subdomain + '&company=' + vm.company, "_blank");
        });
        element.trigger('click');
      }).catch(function () {
        Common.Toast.warning("Sessão de caixa sem movimentação. Não é possível gerar relatório.");
      })


    };

    vm.checkPolicies = function (policy) {
      return PoliciesService.checkPolicyFromMenu(policy);
    };


    vm.init();
  }


  angular
    .module('app.finance.cashier-management')
    .controller('CashierManagementController', CashierManagementController)
})();
(function () {
  'use strict';

  function CashierConfigurationController($rootScope, Common, NFSEService) {
    var vm = this;
    vm.cashier_configuration = {
      is_twofold_receipt: false
    };

    vm.init = function () {
      vm.getCompanyConfig();
    };

    vm.getCompanyConfig = function () {
      vm.show_loader = true;
      NFSEService.getCurrentCompany()
        .then(function (response) {
          vm.cashier_configuration = response.plain();
          vm.show_loader = false;
        });
    };
    /**
     * Executa o salvamento de configurações de empresa
     * @param company
     * @param form
     */
    vm.saveCompanyConfig = function (company, form) {
      vm.show_loader = true;
      if (form.$valid && company != null) {
        NFSEService.updateCompanyConfig(company)
          .then(function (response) {
            if (response.result) {
              Common.Toast.success("Configuração de caixa salva com sucesso!");
              $rootScope.$broadcast('ModalFactory.close');
            }
            vm.show_loader = false;
          })
          .catch(function (reject) {
            vm.show_loader = false;
            if (angular.isDefined(reject.message)) {
              Common.Toast.error(reject.message);
            } else {
              Common.Toast.error(reject);
            }
          });
      }
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular.module('app.finance.cashier-management')
    .controller('CashierConfigurationController', CashierConfigurationController)
})();
(function(){
    'use strict';

    function BillReverseService(Restangular) {

      /**
       * Retorna todas as contas disponíveis.
       */
      var getAllCurrentAccounts = function () {
        return Restangular.one('bill').one('getallcurrentaccounts').get();
      };

      /**
       * Retorna todos os checque de terceiros em mãos.
       */
      var getAllMovementsType = function () {
        return Restangular.one('movement').one('getallmovementtypes').get();
      };

      /**
       * Retorna as categorias pelo tipo indicado.
       */
      var getCategoriesByType = function (obj) {
        return Restangular.all('bill').one('getcategoriesbytype', obj).get();
      };

      /**
       * Retorna as categorias pelo tipo indicado.
       */
      var getRelatedExpenses = function (obj) {
        return Restangular.one('bill').one('getReversalsBills').get(obj);
      };

      /**
       * Informa os dados para desfazer a negociação.
       */
      var doReversal = function (obj) {
        return Restangular.one('bill').all('reversal').post(obj);
      };

      return {
        getAllCurrentAccounts : getAllCurrentAccounts,
        getAllMovementsType: getAllMovementsType,
        getCategoriesByType: getCategoriesByType,
        getRelatedExpenses: getRelatedExpenses,
        doReversal: doReversal
      };

    }

    angular
      .module('app.finance.bill-reverse')
      .factory('BillReverseService', BillReverseService);

})();
(function () {
  'use strict';

  /** @ngInject */
  function BillReverseController($scope, $state, $a4Sidenav, Common, ModalFactory, BillReverseService, $filter) {

    var vm = this;
    vm.action = {};
    vm.payments = [];
    vm.bill = {};
    vm.totalAmount = 0;
    vm.hasGeneratedBillPaid = false;
    vm.toggle = {};
    vm.toggle.list = true;
    vm.notes = null;

    vm.init = function () {
      vm.undopayment(vm.item);
    };

    vm.close = function () {
      $a4Sidenav().close()
    };

    /**
     * Escuta o evento "setnegotiate" com as bills selecionadas
     * Este evento é disparado quando o a sidebar de negociação é aberta
     */
    vm.undopayment = function (item) {
      /*if (item.status === 12){
        vm.is_partial_payment = true;
      }*/
      vm.bill = item;
      vm.billList = angular.isArray(item) ? item : [item];
      vm.getRelatedExpenses(item.id, item.status, item.partial_payment_msg);
    };


    /**
     * Retorna as despesas relacionadas a negociação
     * @param id
     * @param status
     */
    vm.getRelatedExpenses = function (id, status, partial_payment_msg) {

      if (id != null && (status === 10 || status === 11 || status === 12 || status === 13 || status === 14 || partial_payment_msg !== null)) {
        vm.show_loader = true;

        BillReverseService.getRelatedExpenses({bill_id: id, status: status})
          .then(function (response) {
            vm.payments = response.payments;
            vm.action.billsSelected = response.bills;
            vm.totalAmount = response.total;
            vm.action_id = response.action_id;
            vm.hasGeneratedBillPaid = response.has_generated_bill_paid;
            vm.hasBillDifference = false;
            vm.hasBillDifferenceBlockAction = false;
            angular.forEach(vm.action.billsSelected, function (item) {
              if (item.status_bill_difference !== null) {
                vm.hasBillDifference = true;
                if (item.status_bill_difference > 1) {
                  vm.hasBillDifferenceBlockAction = true;
                }
              }
            });
            vm.show_loader = false;
          })
          .catch(function (response) {
            Common.Toast.error('Erro ao buscar as despesas relacionadas');
            vm.show_loader = false;
          });

      }
    };

    /**
     * Desfaz a negociação
     * @param id
     */
    vm.reversalConfimation = function (ev) {
      var msg = 'Esta ação irá desfazer o pagamento. Deseja realmente continuar?';

      ModalFactory.confirm(ev, 'Confirma', msg, 'Confirmar', 'Cancelar', 'finance')
        .then(function () {
          BillReverseService.doReversal({
            bill_id: vm.bill.id,
            status: vm.bill.status,
            action_id: vm.action_id,
            notes: vm.notes
          })
            .then(function (response) {
              if (response) {
                vm.close();
                Common.Toast.success('Desfazer realizado com sucesso');
                $state.go($state.current, {}, {reload: true});
              }
            })
            .catch(function (response) {
              switch (response.data) {
                case 'HAS_GENERATED_BILL_PAID': {
                  Common.Toast.error('HAS_GENERATED_BILL_PAID');
                  break;
                }
                case 'DIFFERENCE_ERROR': {
                  Common.Toast.error('Existe título de diferença resolvido associado ao título.');
                  break;
                }
              }
            });

        }).catch(function () {
        Common.Toast.error("Cancelado");
      })
    };


    /**
     * Faz a validação de todos os retornos de submit na criação de pessoa.
     * @param {type} message - Constante de messagem
     * @param {type} object - objeto criado.
     */
    vm.validateMessages = function (message) {
      switch (message) {
        case 'HAS_GENERATED_BILL_PAID': {
          Common.Toast.error('HAS_GENERATED_BILL_PAID');
          break;
        }
        case 'DIFFERENCE_ERROR': {
          Common.Toast.error('Existe título de diferença resolvido associado ao título.');
          break;
        }
      }
    };


    vm.init();
  }

  angular
    .module('app.finance.bill-reverse')
    .controller('BillReverseController', BillReverseController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function BillReceiptService(Restangular, a4Moment, CONFIG, $http, Common) {
    var vm = this;
    vm.getAll = function (obj) {
      return Restangular.all('bill').one('listall').get(obj);
    };


    vm.getInfoForBillForm = function (obj) {
      return Restangular.all('bill').one('getinfoform').get(obj);
    };
    /**
     *
     * @param obj
     * @return {*}
     */
    vm.updateContracts = function (obj) {
      return Restangular.one('bill').all('updatecontracts').post(obj);
    };
    /**
     *
     * @param obj
     * @return {*}
     */
    vm.haveContracts = function (obj) {
      return Restangular.one('bill').one('havecontracts').get(obj);
    };

    /**
     * getInfoFromPaymentPlan
     * @param id
     */
    vm.getInfoFromPaymentPlan = function (id) {
      return Restangular.one('paymentplan', id).get();
    };

    /**
     * getInfoFromPaymentPlan
     * @param id
     */
    vm.getTab = function () {
      return Restangular.all('bill').get();
    };

    /**
     * Retorna todas as contas correntes.
     * @returns {undefined}
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {defer.promise}
     */
    vm.getAllCurrentAccounts = function () {
      return Restangular.one('bill').one('getallcurrentaccounts').get();
    };

    vm.getAllContracts = function (obj) {
      return Restangular.one('bill').one('listallcontracts').get(obj);
    };

    /**
     * Retorna todos os checque de terceiros em mãos.
     * @returns {undefined}
     * @author
     * @returns {defer.promise}
     */
    vm.getAllThirdPartyInHandChecks = function () {
      return Restangular.one('checkreceived').one('getAllThirdPartyChecksInHand').get();
    };

    /**
     * Retorna todos os bancos
     * @returns {*}
     */
    vm.getBanks = function () {
      return Restangular.all('listbanks').get();
    };

    /**
     * Retorna todas as empresas e configuracoes asscoiadas
     * @returns {*}
     */
    vm.getCompanies = function () {
      return Restangular.one('currentaccount').one('listallcompanies').get();
    };

    /**
     * Retorna as categorias pelo tipo indicado.
     * @param {String} type - Tipo da categoria D para despesas C
     * para Receitas.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {defer.promise}
     */
    vm.getCategoriesByType = function (type) {
      return Restangular.one('bill').one('getcategoriesbytype', type).get();
    };

    /**
     * Remove arquivo do titulo
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {defer.promise}
     * @param obj
     */
    vm.removeArtifact = function (obj) {
      return Restangular.one('bill').all('removeArtifact').post(obj);
    };

    /**
     * Modifica o status do título
     * @param bill_id
     * @param idStatus
     * @author Naara Musse <naara.musse@simetrianet.com.br>
     */
    vm.changeStatus = function (bill_id, idStatus) {
      return Restangular.one('bill/changestatus', '').customPOST({bill_id: bill_id, idStatus: idStatus});
    };

    /**
     * Retorna todas as pessoas do banco de dados.
     * @returns {defer.promise}
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.getAllPersons = function () {
      return Restangular.one('bill').one('getallpersons').get();
    };

    /**
     * Retorna um titulo por id
     * @param id
     * @param queryString
     * @returns {defer.promise}
     */
    vm.getBillById = function (id, queryString) {
      return Restangular.one('bill', id).one('edit').get(queryString);
    };

    /**
     * Retorna uma lista de titulos por ids
     * @param ids
     * @returns {defer.promise}
     */
    vm.getBillsSelected = function (ids) {
      return Restangular.one('bill').one('getBillsSelect').get(ids);
    };

    /**
     * Salva um titulo simples
     * @param bill
     * @returns {defer.promise}
     */
    vm.storeSingleBill = function (bill) {
      return Restangular.one('bill').all('createsingle').post(bill);
    };

    /**
     * Salva uma recorrência
     * @param bill
     * @returns {defer.promise}
     */
    vm.storeRecurrence = function (bill) {
      return Restangular.one('bill').all('createrecurrence').post(bill);
    };

    /**
     * Retorna os tipos de status para filtragem
     * @returns {[*,*,*,*,*,*,*,*,*]}
     */
    vm.getFilterStatus = function () {
      return [
        {id: 90, name: 'Vencidos', status: 'VENCIDO'},
        {id: 91, name: 'A Vencer', status: 'A_VENCER'},
        {id: 92, name: 'Vencem Hoje', status: 'VENCE_HOJE'},
        {id: 2, name: 'Cancelados', status: 'CANCELADO'},
        {id: 3, name: 'Dispensados', status: 'DISPENSADO'},
        {id: 4, name: 'Negociados', status: 'NEGOCIADO'},
        {id: 5, name: 'Duvidosos', status: 'DUVIDOSO'},
        {id: 6, name: 'Prejuizos', status: 'PREJUIZO'},
        {id: 10, name: 'Pagos', status: 'PARCIALY_PAID'},
        {id: 12, name: 'Pagos Parcialmente', status: 'PAID_OUT'},
      ]
    };

    /**
     * Retorna os tipos de frequência de recorrência
     * @returns {[*,*,*,*]}
     */
    vm.getFrequencyOptions = function () {
      return [
        {id: 1, name: 'Dia(s)', value: 'day'},
        {id: 2, name: 'Mês(s)', value: 'month'},
        {id: 3, name: 'Ano(s)', value: 'year'},
        // {id: 4, name: 'Livre', value: false}
      ];
    };

    /**
     * Retorna o tipos de coleção
     * @returns {[*,*,*,*,*,*,*]}
     */
    vm.getColletionTypes = function () {
      return [
        {id: 1, name: 'Carteira'},
        {id: 4, name: 'Cheque pré datado'},
        {id: 9, name: 'Boleto'},
        {id: 10, name: 'Depósito / transferência / Pix'},
        {id: 20, name: 'Cartão de crédito'},
        {id: 12, name: 'Débito automático em conta'},
        {id: 22, name: 'Débito automático em cartão'}
      ]
    };

    /**
     * Retorna os meses para competência
     * @returns {[*,*,*,*,*,*,*,*,*,*,*,*]}
     */
    vm.getCompetenceMonths = function () {
      return [
        {id: 1, label: '01 - Janeiro'},
        {id: 2, label: '02 - Fevereiro'},
        {id: 3, label: '03 - Março'},
        {id: 4, label: '04 - Abril'},
        {id: 5, label: '05 - Maio'},
        {id: 6, label: '06 - Junho'},
        {id: 7, label: '07 - Julho'},
        {id: 8, label: '08 - Agosto'},
        {id: 9, label: '09 - Setembro'},
        {id: 10, label: '10 - Outubro'},
        {id: 11, label: '11 - Novembro'},
        {id: 12, label: '12 - Dezembro'}
      ]
    }


    /**
     * Retorna metodos de pagamento disponiveis
     * @returns {[*,*,*,*,*,*,*,*,*,*,*]}
     */
    vm.getPaymentMethod = function () {
      return [
        {id: 1, name: "Dinheiro"},
        {id: 2, name: "Cheque pré-datado"},
        {id: 3, name: "Cheque"},
        {id: 4, name: "Boleto bancário"},
        {id: 5, name: "Cartão de crédito"},
        {id: 6, name: "Tranferência bancária"},
        {id: 7, name: "Promissória"},
        {id: 8, name: "Cartão de débito"},
        {id: 9, name: "Débito automático"},
        {id: 10, name: "Débito automático no cartão"},
        {id: 11, name: "Parcelado no cartão"}
      ]
    };

    /**
     * Atualiza um titulo
     * @param bill
     * @returns {defer.promise}
     */
    vm.updateBill = function (bill) {
      return Restangular.one('bill', bill.id).customPUT(bill);
    };

    vm.updateRecurrenceBill = function (bill) {
      return Restangular.one('bill').one('updaterecurrencebill', bill.id).customPUT(bill);
    };

    vm.updateAllSerie = function (bill) {
      return Restangular.one('bill').one('updateallserie', bill.id).customPUT(bill);
    };

    /**
     * Atualiza um titulo
     * @param bill
     * @returns {defer.promise}
     */
    vm.updateSingleBill = function (bill) {
      return Restangular.one('bill').one('updatesingle', bill.id).customPUT(bill);
    };
''
    vm.getTags = function (letters) {
      return Restangular.one('getTags').get({text: letters});
    };

    vm.makepayment = function (data) {
      return Restangular.one('bill').all('makepayment').post(data);
    };

    vm.createInstallmentsNegociation = function (billsSelected) {
      return Restangular.one('bill').all('installmentsnegociation').post(billsSelected);
    };


    vm.getAllMovementTypes = function () {
      return Restangular.all('getAllMovementsType').get();
    };

    vm.setCurrentTab = function (current_tab) {
      return Restangular.one('bill').all('setCurrentTab').post(current_tab);
    };

    vm.verifyCheckNumber = function (obj) {
      return Restangular.one('checkreceived').one('verifychecknumber').get(obj);
    };

    vm.verifyDuplicatedCheck = function (obj) {
      return Restangular.one('checkreceived').one('verifyduplicatedcheck').get({
        debit_credit: obj.debit_credit,
        current_account_id: obj.current_account_id,
        movement_type_id: obj.movement_type_id,
        document: obj.document,
        branch: obj.branch,
        account: obj.account,
        number: obj.number
      });
    };

    vm.getRangeOfDate = function (filter_date) {
      var date = null;
      if (filter_date && filter_date.initDate != null && filter_date.endDate != null) {
        date = {startDate: filter_date.initDate, endDate: filter_date.endDate};
      } else {
        date = {
          startDate: a4Moment().startOf('month'),
          endDate: a4Moment().endOf('month')
        };
      }
      return date;
    };

    vm.verifyListOfCheckNumber = function (obj) {
      return Restangular.one('checkreceived').all('verifylistofchecknumber').post(obj);
    };

    vm.getLastCheckUsedForBankBranch = function (obj) {
      return Restangular.one('checkreceived').one('checkSugestion').get(obj);
    };

    vm.getLastAccountAndCheck = function (obj) {
      return Restangular.one('checkreceived').one('checkSugestionbyaccount').get(obj);
    };

    /**
     * Retorna current account por id
     * @param id
     * @returns {*}
     */
    vm.getCurrentAccountById = function (id) {
      return Restangular.one('currentaccount', id).get();
    };

    /**
     * Retorna todos os tipos de current account
     * @returns {*}
     */
    vm.getAlltypes = function () {
      return Restangular.one('currentaccount').all('listypes').get();
    };

    vm.getConfig = function () {
      return Restangular.one('config').one('getByCompany').get();
    };

    vm.getList = function (obj) {
      return Restangular.one('bill').all('listall').get(obj);
    };

    vm.getContractByBillSerieId = function (obj) {
      return Restangular.one('bill').one('getcontract').get(obj);
    };

    vm.storeFreeInstalment = function (obj) {
      return Restangular.one('bill').all('createfreeinstallment').post(obj);
    };

    vm.getPendingBankSlips = function (obj) {
      return Restangular.one('bill').all('getpendingbankslips').post(obj);
    };

    vm.getPendingDifferences = function (obj) {
      return Restangular.one('differenceanalysis').one('getpendingdifferences').get(obj);
    };

    vm.setSimpleObject = function (debit_credit) {
      return {
        debit_credit: debit_credit,
        amount: 0,
        tags: [],
        files: [],
        notes: "",
        was_paid: 1,
        description: '',
        bill_details: [{
          'idx': 1
        }],
        individual_discounts: [],
        payment_plan_id: undefined,
        accrual_month: parseInt(a4Moment().format('MM')),
        accrual_year: parseInt(a4Moment().format('YYYY')),
        date_first: a4Moment().format('YYYY-MM-DD'),
        issue_date: a4Moment().format('YYYY-MM-DD'),
        due_date: a4Moment().format('YYYY-MM-DD'),
        status: 1
      };
    };

    vm.setFreeInstalments = function (debit_credit) {
      return {
        debit_credit: debit_credit,
        tags: [],
        bill_details: [{
          'idx': 1
        }],
        payment_installments: [],
        files: [],
        notes: "Observações",
        quantity: 1,
        date_end: a4Moment().add(1, "M"),
        accrual_month: a4Moment().format('MM'),
        accrual_year: a4Moment().format('YYYY'),
        was_paid: 3,
        date_first: a4Moment(),
        issue_date: a4Moment()
      };
    };

    vm.setRecurrenceObject = function (debit_credit) {
      return {
        debit_credit: debit_credit,
        tags: [],
        end_of_recurrence: 1,
        description: '',
        document_reference: '',
        frequency_type: 0,
        frequency_qty: 1,
        frequency: 2,
        notes: "Observações",
        accrual_month: a4Moment().format('MM'),
        accrual_year: a4Moment().format('YYYY'),
        individual_discounts: [],
        discounts_rules: [
          {
            end_date: null,
            first_row: true,
            idx: 1,
            start_date: null
          }
        ],
        accrual_date_type: "3", /** default type accural in recurence (3 - Vencimento) */
        payment_installments: [],
        files: [],
        date_first: a4Moment(),
        date_end: a4Moment().add(1, 'M'),
        issue_date: a4Moment(),
        was_paid: 2,
        bill_details: [{
          'idx': 1
        }]
      };
    };

    /**
     * Fornece um array com 30 numeros para a informar o dia de vencimento e o dia de fechamento
     * no formulario
     * @param {debit_credit} n - Quantidade de posições se não passado retornará null.
     * @returns {Array} - Todas as posições
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.range = function () {
      vm.arr = [];
      for (var i = 1; i <= 30; i++) {
        vm.arr.push({id: i});
      }
      return vm.arr;
    };

    vm.createDifferenceBill = function (obj) {
      return Restangular.one('differenceanalysis').all('createdifferencebill').post(obj);
    };

    vm.printReport = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/billsstudent?group_id=' + obj.group_id + "&all_bills=" + obj.all_bills +
          '&person_id=' + obj.person_id + '&user_id=' + obj.user_id + '&status=' + obj.status
          + "&is_student=" + obj.is_student + "&show_only_student=" + obj.show_only_student+ "&product_id=" + obj.product_id
          + "&show_all_school_periods=" + obj.show_all_school_periods + (obj.startDate != null ? ("&startDate=" + obj.startDate) : '')
          + (obj.endDate != null ? ("&endDate=" + obj.endDate) : '') + (obj.debit_credit != null ? ("&debit_credit=" + obj.debit_credit) : ''),
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    return vm;

  }

  angular.module('app.finance.bill-receipt')
    .factory('BillReceiptService', BillReceiptService);


})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.bill-receipt', {
        url: '/bill-receipt',
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/bill-receipt/views/bill-receipt-index.html',
            controller: 'BillReceiptController',
            controllerAs: 'vm'
          }
        }
      });

  }

  angular
    .module('app.finance.bill-receipt')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'ctsrec_menu';
    var path = 'finance.bill-receipt';
    msNavigationService.saveItem('finance.bill-receipt', {
      title: 'A Receber',
      icon: 'icon-debug-step-into',
      state: 'private.finance.bill-receipt',
      weight: 4,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.bill-receipt')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function BillReceiptEditController(BillExpenseService, $filter, SideExtra, $rootScope, PersonService, BillReceiptService,
                                     a4Moment, Common, $a4Sidenav, $timeout, $scope, ModalFactory) {

    var vm = this;

    vm.searchText = '';

    vm.debit_credit = 'C';
    vm.filter_date = null;
    vm.persons = [];
    vm.all_bills = [];
    vm.currentItems = [];
    vm.categories = [];
    vm.selected_status = [];
    vm.currentItem = {};
    vm.currentItem.was_paid = 1;
    vm.currentItem.end_of_recurrence = 0;
    vm.frequency_options = BillReceiptService.getFrequencyOptions();
    vm.payment_method = BillReceiptService.getPaymentMethod();
    vm.colletion_types = BillReceiptService.getColletionTypes();
    vm.months = BillReceiptService.getCompetenceMonths();

    vm.status = [
      {id: 4, name: 'A vencer', status: 'a_vencer'},
      {id: 5, name: 'Vencem Hoje', status: 'vence_hoje'},
      {id: 2, name: 'Vencidos', status: 'vencido'},
      {id: 10, name: 'Pagos', status: 'pago'},
      {id: 3, name: 'Cancelados', status: 'cancelado'},
      {id: 6, name: 'Dispensados', status: 'dispensado'},
      {id: 7, name: 'Negociados', status: 'negociado'},
      {id: 8, name: 'Duvidosos', status: 'duvidoso'},
      {id: 9, name: 'Prejuizos', status: 'prejuizo'}
    ];

    /** init
     */
    vm.init = function () {
      $scope.iframeHeight = angular.element('#content').height();
      vm.original_bill = angular.copy(SideExtra.bill);
      vm.getCategories();
      vm.getRangeOfYears();
      vm.getRangeOfMonths();
      vm.getAllInfos();
    };

    /**
     * Retorna todas as informações necessárias para o formulário.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.getAllInfos = function () {
      BillReceiptService.getInfoForBillForm({debit_credit: vm.debit_credit})
        .then(function (response) {
          vm.products = response.products;
          vm.categories = response.categories;
          vm.payment_plans = response.payment_plans;
          vm.allAdditionRules = response.allAdditionRules;
          vm.allBankSlipRules = response.allBankSlipRules;
          vm.indexCorrection = response.indexCorrection;
          vm.currentAccounts = response.currentAccounts;
          $rootScope.show_loader = false;
          vm.getBillById(SideExtra.bill.id, SideExtra.bill.edit_expense);
        })
        .catch(function () {
          Common.Toast.error($filter('translate')('LIST_ERROR') + ": " + $filter('translate')("PERSON"));
          $rootScope.show_loader = false;
        });
    };


    /**
     * Faz o request para a API e retorna a despesa por id
     * @param id - identificador do titulo
     * @param edit_expense - identificador do titulo
     */
    vm.getBillById = function (id, edit_expense) {
      BillReceiptService.getBillById(id, {'edit_expense': edit_expense})
        .then(function (response) {
          vm.currentItem = response.plain();
          vm.show_form = true;
          $rootScope.show_loader = false;
          vm.currentItem.amount = vm.currentItem.amount !== null ? parseFloat(vm.currentItem.amount) : vm.currentItem.amount;
          vm.currentItem.due_date = vm.currentItem.due_date !== null ? a4Moment(response.due_date) : vm.currentItem.due_date;

          if (vm.currentItem.due_date !== null) {
            vm.currentItem.due_date = a4Moment(response.due_date);
          }

          if (vm.currentItem.payment_installments !== undefined) {
            vm.currentItem.hasPaid = vm.getIfInstallmentHasOnePaid(vm.currentItem.payment_installments);
          }

          if (vm.currentItem !== undefined) {

            if (vm.currentItem.next_adjustment_date) {
              vm.currentItem.next_adjustment_date = a4Moment(vm.currentItem.next_adjustment_date);
            }

            if (vm.currentItem.date_end) {
              vm.currentItem.end_of_recurrence = 1;
              vm.currentItem.date_end = a4Moment(vm.currentItem.date_end);
            }

            if (vm.currentItem.date_first) {
              vm.currentItem.date_first = a4Moment(vm.currentItem.date_first);
            }

            if (vm.currentItem.quantity > 0) {
              vm.currentItem.end_of_recurrence = 0;
            }

            if (angular.isArray(vm.currentItem.discounts_rules) && vm.currentItem.discounts_rules.length > 0) {
              vm.currentItem.discounts_rules.forEach(function (value) {
                value.end_date = a4Moment(value.end_date);
                value.start_date = a4Moment(value.start_date);
              })
            }

            if (vm.currentItem.tags !== null && vm.currentItem.tags.length > 0) {
              vm.currentItem.tags = vm.currentItem.tags.filter(function (item, i, ar) {
                return ar.indexOf(item) === i;
              });
            }

            vm.currentItem.frequency = response.frequency;
            vm.currentItem.frequency_qty = response.frequency_qty;
            vm.currentItem.frequency_type = response.frequency_type;
            vm.bill = vm.currentItem;
          }
        });
    };

    /**
     * Verifica se algum installments está pago.
     * @param payment_installments - Lista de parcelas.
     * @returns {boolean}
     */
    vm.getIfInstallmentHasOnePaid = function (payment_installments) {
      for (var i = 0, len = payment_installments.length; i < len; i++) {
        if (payment_installments[i].status == 1) {
          return true
        }
      }
    };

    /**
     * getCategories
     * Retorna todas as categorias possiveis para um titulo
     */
    vm.getCategories = function () {
      BillExpenseService.getCategories(vm.debit_credit)
        .then(function (response) {
          vm.categories = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna a lista de pessoas filtrada pela consulta para o auto complete
     * @param query - nome pesquisado
     * @returns {Void}
     */
    vm.listAllPersons = function (query) {
      return PersonService.listAll({query: query});
    };

    /**
     * submit
     * @param currentItem
     */
    vm.submit = function (currentItem) {
      switch (parseInt(currentItem.was_paid)) {
        case(1):
          /** update single bill */
          if (parseFloat(vm.original_bill.amount) !== parseFloat(currentItem.amount)) {
            ModalFactory.confirm(null, 'Edição de título',
              'Ao editar o valor deste título, os boletos associados a ele serão cancelados. Deseja continuar?',
              'Confirmar', 'Cancelar', 'finance').then(function () {
              vm.updateSingleBill(currentItem);
            })
          } else {
            vm.updateSingleBill(currentItem);
          }
          break;
        case(2):
          /** update recurrence */
          /** update pelo tipo de recorrencia */
          if (parseFloat(vm.original_bill.amount) !== parseFloat(currentItem.amount)) {
            ModalFactory.confirm(null, 'Edição de título',
              'Ao editar o valor deste título, os boletos associados a ele serão cancelados. Deseja continuar?',
              'Confirmar', 'Cancelar', 'finance').then(function () {
              switch (parseInt(currentItem.edit_expense)) {
                case 1 || 0:
                  vm.updateSingleBill(currentItem);
                  break;
                case 2:
                  vm.updateRecurrenceBill(currentItem);
                  break;
                case 3:
                  vm.updateAllSerie(currentItem);
                  break;
              }
            })
          } else {
            switch (parseInt(currentItem.edit_expense)) {
              case 1 || 0:
                vm.updateSingleBill(currentItem);
                break;
              case 2:
                vm.updateRecurrenceBill(currentItem);
                break;
              case 3:
                vm.updateAllSerie(currentItem);
                break;
            }
          }
          break;
        case(3):
          /** update installments */
          vm.updateAllSerie(currentItem);
          break;
      }
    };

    /**
     * updateSingleBill
     * @param currentItem
     */
    vm.updateSingleBill = function (currentItem) {
      vm.show_progress = true;
      BillExpenseService.updateSingleBill(currentItem)
        .then(function (response) {
          vm.show_progress = false;
          if (response && response.result) {
            $rootScope.$broadcast('UPDATE_BILL_GRID');
            vm.closeSideBar('Pagamento editado com sucesso!');

          } else {
            Common.Toast.error('Erro ao editar esse pagamento.');
            $rootScope.$broadcast('UPDATE_BILL_GRID');
          }
        })
        .catch(function (response) {
          vm.show_progress = false;
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * updateRecurrenceBill
     * @param currentItem
     */
    vm.updateRecurrenceBill = function (currentItem) {
      vm.show_progress = true;
      BillExpenseService.updateRecurrenceBill(currentItem)
        .then(function (response) {
          vm.show_progress = false;
          if (response && response.result) {
            vm.closeSideBar('Recorrência editada com sucesso!');
            $rootScope.$broadcast('bill-receipt.UPDATE');
          } else {
            Common.Toast.error('Erro ao editar essa recorrência.');
          }
        })
        .catch(function (response) {
          vm.show_progress = false;
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * updateAllSerie
     * @param currentItem
     */
    vm.updateAllSerie = function (currentItem) {
      vm.show_progress = true;
      /** Se houver diferença entre o valor atual do titulo e a referência ao mesmo ID no grid de parcelas */
      currentItem.payment_installments = vm.updateAmountOfList(currentItem);
      BillExpenseService.updateAllSerie(currentItem)
        .then(function (response) {
          if (response && response.result) {
            vm.show_progress = false;
            vm.closeSideBar('Parcelamento editado com sucesso!');
            $rootScope.$broadcast('bill-receipt.UPDATE');
          } else {
            Common.Toast.error('Erro ao editar esse parcelamento.');
          }
        })
        .catch(function (response) {
          vm.show_progress = false;
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * closeEditSideBar
     */
    vm.closeSideBar = function (msg) {
      vm.filter_date = null;
      if (!angular.isUndefined(msg)) {
        Common.Toast.success(msg);
        $rootScope.$broadcast('bill-receipt.UPDATE');
      }
      $a4Sidenav().close();
    };

    /**
     * getRangeOfYear
     * Range de anos para o select de 'mais detalhes'
     */
    vm.getRangeOfYears = function () {
      var result = 2010;
      var arr = [];
      while (result <= 2027) {
        arr.push(result);
        result++;
      }
      vm.range_of_year = arr;
    };

    /**
     * getRangeOfMonths
     * Range de meses para o select de 'mais detalhes'
     */
    vm.getRangeOfMonths = function () {
      var arr = [];
      var months = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
      ];

      for (var i = 0; i < 12; i++) {
        var label = (i < 9) ? '0' + (i + 1) : (i + 1);
        var name = label + '  |  ' + months[i];
        arr.push({'name': name, 'value': (i + 1)});
      }

      vm.range_of_months = arr;
    };

    /**
     *  @param id
     */
    vm.frequencyOptions = function (id) {
      angular.forEach(vm.frequency_options, function (item, i) {
        if (item.id === id) {
          vm.currentItem.frequency_option_name = item.value;
        }
        vm.disabled = (vm.currentItem.frequency !== 4);
      });
    };

    /**
     * apiErrorMessageByStatusCode
     * Toast error com mensagens baseada no statusCode da api
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista.');
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor.');
          break;
      }
    };

    /**
     * @param value
     */
    vm.tabChange = function (value) {
      $timeout(function () {
        vm.selectedTab = (value === 1) ? 0 : vm.selectedTab;
        vm.selectedTab = (value === 2) ? 2 : vm.selectedTab;
      }, 300);
    };

    vm.init();

  }

  angular
    .module('app.finance.bill-receipt')
    .controller('BillReceiptEditController', BillReceiptEditController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function BillReceiptCreateController($rootScope, $a4Sidenav, $filter, $timeout, BillReceiptService, ModalFactory,
                                       Common, a4Moment, ProductService, SideExtra, $scope, PersonService, PaymentPlanService) {

    var vm = this;
    vm.debit_credit = 'C';
    vm.persons = [];
    vm.categories = [];
    vm.products = [];
    vm.payment_plans = [];
    vm.totalAmount = 0;
    vm.bill_details = [];
    vm.years = [];
    vm.edit_expense = null;
    vm.activate_recurrence = false;
    vm.searchText = '';
    vm.frequency_options = BillReceiptService.getFrequencyOptions();
    vm.payment_method = BillReceiptService.getPaymentMethod();
    vm.colletion_types = BillReceiptService.getColletionTypes();
    vm.months = BillReceiptService.getCompetenceMonths();
    vm.show_form = false;
    vm.hasProduct = false;
    vm.hasPaymentPlan = false;
    /**
     * init
     */
    vm.init = function () {
      $scope.iframeHeight = angular.element('#content').height();
      vm.is_create = angular.isDefined(SideExtra.is_create) ? true : false;
      vm.getAllInfos();
      vm.getYears();
      vm.getDays();
      vm.bill = BillReceiptService.setSimpleObject(vm.debit_credit);
    };

    vm.frequencyOptions = function (id) {
      angular.forEach(vm.frequency_options, function (item, i) {
        if (item.id === id) {
          vm.bill.frequency_option_name = item.value;
        }
      });
    };

    /**
     * Faz o request para a API e retorna a despesa por id
     * @param {Int} id - identificador do titulo
     * @param {Int} edit_expense - identificador do titulo
     * @param sidebar_id
     */
    vm.getBillById = function (id, edit_expense) {

      BillReceiptService.getBillById(id, {'edit_expense': edit_expense})
        .then(function (response) {

          vm.bill = response;

          if (vm.bill.amount != null) {
            vm.bill.amount = parseFloat(vm.bill.amount);
          }

          if (vm.bill.issue_date != null) {
            vm.bill.issue_date = a4Moment(response.issue_date);
          }

          if (vm.bill.due_date != null) {
            vm.bill.due_date = a4Moment(response.due_date);
            vm.bill.issue_date = a4Moment(response.due_date);
          }

          if (vm.bill.payment_installments !== undefined) {
            vm.bill.hasPaid = vm.getIfInstallmentHasOnePaid(vm.bill.payment_installments);
          }

          if (vm.bill !== undefined) {

            if (vm.bill.next_adjustment_date) {
              vm.bill.next_adjustment_date = a4Moment(vm.bill.next_adjustment_date);
            }

            if (vm.bill.date_end) {
              vm.bill.end_of_recurrence = 1;
              vm.bill.date_end = a4Moment(vm.bill.date_end);
            }

            if (vm.bill.date_first) {
              vm.bill.date_first = a4Moment(vm.bill.date_first);
            }

            if (vm.bill.quantity > 0) {
              vm.bill.end_of_recurrence = 0;
            }

            if (angular.isArray(vm.bill.discounts_rules) && vm.bill.discounts_rules.length > 0) {
              vm.bill.discounts_rules.forEach(function (value) {
                value.end_date = a4Moment(value.end_date);
                value.start_date = a4Moment(value.start_date);
              })
            }

            if (vm.bill.tags != null && vm.bill.tags.length > 0) {
              vm.bill.tags = vm.bill.tags.filter(function (item, i, ar) {
                return ar.indexOf(item) === i;
              });
            }

            vm.bill.frequency = response.frequency;
            vm.bill.frequency_qty = response.frequency_qty;
            vm.bill.frequency_type = response.frequency_type;
          }
          $rootScope.show_loader = false;

        });
    };


    vm.adjustObjectToSend = function (bill_copy) {
      bill_copy.amount = bill_copy.bill_details[0].amount;

      if (bill_copy.bill_details[0].bill_category_id !== undefined) {
        bill_copy.bill_category_id = bill_copy.bill_details[0].bill_category_id;
      }
    };

    /**
     * Verifica se algum installments está pago.
     * @param payment_installments - Lista de parcelas.
     * @returns {boolean}
     */
    vm.getIfInstallmentHasOnePaid = function (payment_installments) {
      for (var i = 0, len = payment_installments.length; i < len; i++) {
        if (payment_installments[i].status === 1) {
          return true
        }
      }
    };

    /**
     * Verifica a existencia de cheques duplicados.
     * @param list_checks - lista de cheques
     * @returns {boolean}
     */
    vm.verifyIfExistsDuplicatedCheck = function (list_checks) {
      var exists = false;
      angular.forEach(list_checks, function (value) {
        if (value.duplicated) {
          exists = true;
        }
      });
      return exists;
    };


    /**
     * Faz a submissão de formulario para novo titulo
     * @param {type} bill_form - Formulário do submit para validações Angular.
     * @param {type} item - Item do formulário.
     * @param {type} files - Arquivos .
     * @param {type} event - Evento.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.submit = function (bill_form, item, files, event) {
      if (event !== undefined && event.keyCode === '13') {
        return false;
      }

      var check_duplicated = vm.verifyIfExistsDuplicatedCheck(item.payment_installments);
      if (check_duplicated) {
        Common.Toast.warning('Existe um cheque já utilizado no sistema');
        return false;
      }

      var bill_copy = angular.copy(item);
      if (!bill_copy.amount) {
        Common.Toast.warning('Valor não pode ficar em branco.');
        return false;
      }

      if (angular.isObject(bill_copy.person_id)) {
        bill_copy.person_id = bill_copy.person_id.id;
      }

      if (bill_copy.bill_details.length === 1) {
        vm.adjustObjectToSend(bill_copy);
      }

      bill_copy.issue_date = a4Moment(bill_copy.due_date).format('YYYY-MM-DD');
      bill_copy.due_date = a4Moment(bill_copy.due_date).format('YYYY-MM-DD');
      bill_copy.debit_credit = vm.debit_credit;

      if (bill_copy.id == null) {
        vm.createBill(bill_copy);
      } else {
        if (vm.installmentsIsValid(bill_copy)) {
          vm.updateBill(bill_copy);
        } else {
          Common.Toast.warning('O valor total das parcelas é diferente do valor da despesa.');
        }
      }
    };

    /**
     * Valida se o valor total das parcelas é igual ao valor da despesa
     * Só executa essa validacao em caso de despesa parcelada e recorrencia com vencimentos variaveis
     * @param bill
     * @returns {boolean}
     */
    vm.installmentsIsValid = function (bill) {
      if (bill.was_paid === 3 || (bill.was_paid === 2 && bill.frequency_type === 1)) {
        var sum = 0;
        angular.forEach(bill.payment_installments, function (item) {
          if (item.amount !== '') {
            item.amount = item.amount == null ? 0 : parseFloat(item.amount);
            sum = (sum + parseFloat(item.amount.toFixed(2)));
          }
        });
        return (bill.amount === sum.toFixed(2));
      } else {
        return true;
      }
    };

    vm.createBill = function (bill_copy) {
      switch (parseInt(bill_copy.was_paid)) {
        case 1:
          vm.singleBill(bill_copy);
          break;
        case 2:
          vm.recurrenceBill(bill_copy);
          break;
        case 3:
          vm.freeInstalment(bill_copy);
          break;
      }
    };

    vm.filterByStatus = function (bills, selected_status) {
      var result = [];
      if (angular.isArray(selected_status) && selected_status.length === 0) {
        result = angular.copy(bills);
      } else {
        var arr_bills = angular.copy(bills);
        for (var i = 0; i < arr_bills.length; i++) {
          for (var n = 0; n < selected_status.length; n++) {
            if (arr_bills[i].status_name.toLowerCase() === selected_status[n].status) {
              result.push(arr_bills[i]);
            }
          }
        }
      }
      return result;
    };

    /**
     * Criação de receita a receber ou despesa a pagar;
     * @param bill_copy
     */
    vm.singleBill = function (bill_copy) {
      vm.show_progress = true;
      //criação de titulo simples
      BillReceiptService.storeSingleBill(bill_copy)
        .then(function () {
          Common.Toast.success('Recebimento criado com sucesso');
          $rootScope.$broadcast('BILLRECEIPT.UPDATE_LIST');
          vm.show_progress = false;
          vm.close();
        })
        .catch(function (response) {
          vm.validateMessages(response.data);
          vm.show_progress = false;
        });
    };

    /**
     * Criação de despesa e receita recorrente
     * @param bill_copy
     */
    vm.recurrenceBill = function (bill_copy) {
      vm.show_progress = true;
      BillReceiptService.storeRecurrence(bill_copy)
        .then(function () {
          Common.Toast.success('Recebimento criado com sucesso');
          $rootScope.$broadcast('bill-receipt.UPDATE');
          vm.show_progress = false;
          vm.close();
        })
        .catch(function (response) {
          vm.validateMessages(response.data.message);
          vm.show_progress = false;
        });
    };

    /**
     * Faz a validação de todos os retornos de submit na criação de pessoa.
     * @param {type} message - Constante de messagem
     * @param {type} object - objeto criado.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.validateMessages = function (message) {
      switch (message) {
        case 'REQUIRED_PAYMENT_DATE': {
          Common.Toast.error('Atenção, escolha a data de recebimento');
          break;
        }
        case 'INVALID_QUANTITY_OF_PORTION': {
          Common.Toast.error('Por favor gere as parcelas da recorrência');
          break;
        }
        case 'PROBLEM_TO_DELETE_GENERATED_BILL': {
          Common.Toast.error('PROBLEM_TO_DELETE_GENERATED_BILL');
          break;
        }
        case 'PROBLEM_TO_TURN_BILL_OPEN': {
          Common.Toast.error('PROBLEM_TO_TURN_BILL_OPEN');
          break;
        }
        case 'PROBLEM_TO_DELETE_MOVEMENTS': {
          Common.Toast.error('PROBLEM_TO_DELETE_MOVEMENTS');
          break;
        }

        case 'PROBLEM_TO_DELETE_BILL_ACTION': {
          Common.Toast.error('PROBLEM_TO_DELETE_BILL_ACTION');
          break;
        }
        case 'ERROR_TO_REVERSAL_NON_PAID_BILL': {
          Common.Toast.error('ERROR_TO_REVERSAL_NON_PAID_BILL');
          break;
        }
        case 'REQUIRED_INSTALLMENTS': {
          Common.Toast.error('REQUIRED_INSTALLMENTS');
          break;
        }
        case 'INVALID_FREQUENCY_QUANTITY': {
          Common.Toast.error('Quatidade da frequência da recorrencia invalida');
          break;
        }
      }
    };

    /**
     * Criação de Receita de parcelas livres ou despesas parceladas.
     */
    vm.freeInstalment = function (bill_copy) {
      vm.show_progress = true;
      BillReceiptService.storeFreeInstalment(bill_copy)
        .then(function () {
          Common.Toast.success('Recebimento criado com sucesso');
          $rootScope.$broadcast('BILLRECEIPT.UPDATE_LIST');
          vm.show_progress = false;
          vm.close();
        })
        .catch(function (response) {
          vm.validateMessages(response.message);
          vm.show_progress = false;
        });
    };

    /**
     * Retorna a lista de pessoas filtrada pela consulta para o auto complete
     * @param query - nome pesquisado
     * @returns {Void}
     */
    vm.listAllPersons = function (query) {
      return PersonService.listAll({query: query});
    };


    /**
     * Retorna todas as informações necessárias para o formulário.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.getAllInfos = function () {
      BillReceiptService.getInfoForBillForm({debit_credit: vm.debit_credit})
        .then(function (response) {
          vm.categories = response.categories;
          vm.allAdditionRules = response.allAdditionRules;
          vm.allBankSlipRules = response.allBankSlipRules;
          vm.indexCorrection = response.indexCorrection;
          vm.currentAccounts = response.currentAccounts;
          $rootScope.show_loader = false;

          $timeout(function () {
            vm.show_form = true;
          }, 2000)
        })
        .catch(function () {
          Common.Toast.error($filter('translate')('LIST_ERROR') + ": " + $filter('translate')("PERSON"));
          $rootScope.show_loader = false;
        });
    };

    vm.getOnlyProducts = function (query) {
      return ProductService.getOnlyProducts({search: query});
    };

    /**
     * Retorna o range de anos
     */
    vm.getYears = function () {
      vm.years = [];
      for (var i = 2013; i < 2040; i++) {
        vm.years.push({id: i, label: i});
      }
    };

    /**
     * Retorna o range de anos
     */
    vm.getDays = function () {
      vm.arr = [];
      for (var i = 1; i < 31; i++) {
        vm.arr.push({id: i, label: i});
      }
    };

    /**
     * Ao modificar o plano de pagamento.
     * @param payment_plan
     * @return {*}
     */
    vm.changeFromPaymentPlan = function (payment_plan) {
      var deferred = Common.$q.defer();
      var plan = $filter('filter')(vm.payment_plans, {id: payment_plan.id})[0];
      vm.bill.issue_date = plan.date_first == null ? a4Moment() : a4Moment(plan.date_first);
      angular.element('input[name=receipt]').attr('disabled', true);
      vm.bill.quantity = plan.quantity;
      if (plan.quantity > 0) {

        vm.bill.index_id = plan.index_id;
        vm.bill.end_of_recurrence = 0;
        vm.bill.date_first = plan.date_first == null ? a4Moment() : a4Moment(plan.date_first);
        vm.bill.frequency_type = 0;
        vm.bill.frequency_qty = plan.frequency_qty;
        vm.bill.frequency = plan.frequency;

      } else if (vm.bill.end_of_recurrence == 1 && plan.date_first != null) {
        vm.bill.date_first = plan.date_first == null ? a4Moment() : a4Moment(plan.date_first);
        vm.bill.date_end = a4Moment(plan.date_end);
      }
      var date_first = a4Moment(vm.bill.date_first);
      vm.bill.next_adjustment_date = a4Moment(date_first).add(1, 'y');

      vm.bill.fines_rule_id = plan.fines_rule_id;
      vm.bill.collection_type = plan.collection_type;
      vm.bill.bank_slip_rule_id = plan.bank_slip_rule_id;
      vm.bill.recurrency_on_value = 0;

      var amount = vm.getAmountOfPlanOrProduct(plan.price);

      vm.bill.amount = amount;
      vm.bill.debit_credit = vm.debit_credit;
      vm.bill.bill_details[0].amount = amount;

      $timeout(function () {
        vm.disableRecurrenceFields();
        vm.hasPaymentPlan = true;
        deferred.resolve(true);
      });

      vm.planinfo = true;
      vm.bill.was_paid = 2;
      return deferred.promise;
    };

    vm.disableRecurrenceFields = function () {
      vm.disableRadio = true;
    };

    /**
     * getAmountOfPlanOrProduct
     * Retorna o valor do produto, se o valor do plano for zero
     * Se os dois forem zero, mantem o valor para edição
     * @param amount
     * @returns {number}
     */
    vm.getAmountOfPlanOrProduct = function (amount) {
      var result = 0;
      if (amount > 0) {
        result = amount;
      } else if (amount == 0 && vm.prodPrice != 0) {
        result = vm.prodPrice;
      }
      return result;
    };


    /**
     * Escuta as trocas de produto.
     * @param product - Objeto escolhido no autocomplete
     */
    vm.changeProduct = function (product) {
      vm.bill.product_id = product.id;
      vm.bill.amount = product.price;
      vm.product = angular.copy(product);
      vm.setBillCategories(product);
    };

    /**
     * Distribui as categorias no titulo
     * @param prod
     */
    vm.setBillCategories = function (prod) {
      var categories = [];
      var item = {};
      item.amount = prod.price;
      vm.bill.amount = prod.price;
      vm.bill.description = prod.name;
      item.description = prod.name;
      categories.push({'bill_category_id': null, 'amount': item.amount});
      vm.bill.bill_category_id = item;
      vm.bill.bill_details = categories;
    };

    vm.close = function () {
      $a4Sidenav().close()
    };


    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista.');
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor.');
          break;
      }
    };

    /** Escuta a mudança de transação */
    var ltn = $rootScope.$watch(function () {
      return vm.bill.collection_type;
    }, function (newValue) {
      var cheque = 4;
      if (newValue == cheque && vm.bill.was_paid == 2) {
        vm.bill.end_of_recurrence = 0;
      }
    });

    /**
     * Criação de desconto individual
     */
    vm.createNewIndivialDiscount = function () {
      ModalFactory.customClean(
        'app/finance/individual-discounts/views/individual-discounts.html',
        'IndividualDiscountsController',
        'vm',
        true,
        {theme: 'finance'}
      ).then(function (discount) {
        if (discount !== 'canceled') {
          vm.bill.individual_discounts.push(discount);
        }
      })
    };

    /**
     * Remove um desconto da lista
     */
    vm.removeItemDesconto = function (index) {
      vm.bill.individual_discounts.splice(index, 1);
    };


    /**
     * Template by was_paid
     */
    vm.changeWasPaid = function () {
      var tmp = vm.bill;

      if (vm.bill.was_paid == 1) {

        vm.activate_recurrence = false;
        // single bill
        vm.bill.person_id = tmp.person_id;
        vm.bill.description = tmp.description;
        vm.bill.document_reference = tmp.document_reference;
        vm.bill.debit_credit = vm.debit_credit;
        vm.bill.tags = tmp.tags;
        vm.bill.files = tmp.files;
        vm.bill.notes = tmp.notes;
        vm.bill.was_paid = tmp.was_paid;
        vm.bill.bill_details = tmp.bill_details;
        vm.bill.accrual_month = tmp.accrual_month;
        vm.bill.accrual_year = tmp.accrual_year;
        vm.bill.date_first = tmp.date_first;
        vm.bill.issue_date = tmp.issue_date
      } else if (vm.bill.was_paid == 2) {

        vm.activate_recurrence = true;
        vm.bill.person_id = tmp.person_id;
        vm.bill.description = tmp.description;
        vm.bill.document_reference = tmp.document_reference;
        vm.bill.debit_credit = vm.debit_credit;
        vm.bill.files = tmp.files;
        vm.bill.was_paid = tmp.was_paid;
        vm.bill.accrual_month = tmp.accrual_month;
        vm.bill.accrual_year = tmp.accrual_year;
        vm.bill.date_first = tmp.date_first;
        vm.bill.issue_date = tmp.issue_date;
        vm.bill.frequency_type = 0;
        vm.bill.frequency_qty = 1;
        vm.bill.end_of_recurrence = 0;
        vm.bill.frequency = 2;
        vm.bill.discounts_rules = tmp.discounts_rules;
        vm.bill.accrual_date_type = tmp.accrual_date_type;
        vm.bill.payment_installments = tmp.payment_installments;
        vm.bill.date_end = tmp.date_end;
        vm.bill.recurrency_on_value = 0;


      } else if (vm.bill.was_paid == 3) {
        vm.activate_recurrence = false;
        vm.bill.person_id = tmp.person_id;
        vm.bill.description = tmp.description;
        vm.bill.document_reference = tmp.document_reference;
        vm.bill.debit_credit = vm.debit_credit;
        vm.bill.tags = tmp.tags;
        vm.bill.files = tmp.files;
        vm.bill.was_paid = tmp.was_paid;
        vm.bill.bill_details = tmp.bill_details;
        vm.bill.accrual_month = tmp.accrual_month;
        vm.bill.accrual_year = tmp.accrual_year;
        vm.bill.date_first = tmp.date_first;
        vm.bill.issue_date = tmp.issue_date;
        vm.bill.payment_installments = tmp.payment_installments;
        vm.bill.quantity = 1;

      }
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.finance.bill-receipt')
    .controller('BillReceiptCreateController', BillReceiptCreateController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function BillReceiptController($scope, PoliciesService, $mdDialog, $a4FloatButton,
                                 Toast, Common, $a4Sidenav, $filter, ModalFactory, $rootScope,
                                 BillReceiptService, BillExpenseService, a4Moment) {

    var vm = this;
    /** Contador da página, para ser utilizado no infinite scroll */
    vm.contPag = 1;
    vm.statusDefined = [];
    vm.color = 'blue';
    vm.has_pending_differences = false;

    vm.debit_credit = 'C';
    vm.filter_date = {
      startDate: a4Moment().startOf('year'),
      endDate: a4Moment().endOf('month')
    };
    /** Variável para avisar quando não existem mais dados para serem carregados em tela */
    vm.hasDataToLoad = true;
    vm.date = null;
    vm.bills = [];
    vm.tableItemsSelected = [];
    vm.includeScope = {};
    vm.all_bills = [];
    vm.selected_status = [];
    vm.edit_expense = null;
    vm.disableRadio = false;
    vm.saveandcontinue = 0;
    vm.temp = null;
    vm.credit_debit_types = ['c', 'd'];
    vm.bills = [];
    vm.planinfo = false;
    vm.onDemand = true;
    vm.portion_named_current = 0;
    vm.dispatch = false;
    vm.current_page = 0;
    vm.artifact = 0;
    vm.has_credit = false;
    vm.has_debit = false;
    vm.block = false;
    vm.show_button_more = true;


    var updateList = $rootScope.$on('bill-receipt.UPDATE', function () {
      vm.getAll(1, 20, vm.filter_date, null)
    });

    /*var ln = angular.element('#content').bind("scroll", function () {
      var currentPositionOfScroll = angular.element(this).scrollTop();
      var maxHeightOfScreen = angular.element(this)[0].scrollHeight - angular.element(this).height();
      /!** Verificação dos filtros, a desativação do primeiro desabilita os outros. *!/

      if (currentPositionOfScroll === maxHeightOfScreen) {
        vm.getAllWithInfiniteScroll(vm.bills.current_page + 1);
      }
    });


*/
    vm.resize = function () {
      vm.windowHeight = (angular.element("#content").height()) * 0.645;
      if (vm.windowHeight < 100) {
        vm.windowHeight = 529;
      }
      if (vm.windowHeight < 530) {
        vm.windowHeight = vm.windowHeight * 0.97;
        if (vm.windowHeight < 500) {
          vm.windowHeight = vm.windowHeight * 0.95;
        }
        if (vm.windowHeight < 450) {
          vm.windowHeight = vm.windowHeight * 0.91;
          if (vm.windowHeight < 370) {
            vm.windowHeight = vm.windowHeight * 0.85;
          }
        }
      }
      $scope.$applyAsync();

    };

    var ln = $(window).resize(function () {
      vm.resize();
    });

    /**
     * Inicia chamadas
     * @returns Void
     */
    vm.init = function () {
      vm.payment_method_complete = BillReceiptService.getPaymentMethod();
      vm.payment_method = BillReceiptService.getPaymentMethod();
      vm.status_filter = BillReceiptService.getFilterStatus();
      vm.resize();
      vm.getAll(vm.current_page, 20, null, null);
      /*
            vm.getPendingDifferences();
      */
    };

    /**
     * Retorna todos os titulos
     */
    vm.getAll = function (page, qtd, date, person_id, status, flag, order) {
      /** Só faz o request caso o último não tenha retornado um array vazio ou tenha status selecionado. */
      vm.show_button_more = true;
      $rootScope.show_loader = true;
      vm.show_loader = true;
      vm.current_page++;
      qtd = angular.isUndefined(qtd) ? 30 : qtd;
      status = angular.isUndefined(status) ? null : status;
      person_id = angular.isUndefined(person_id) ? person_id : null;
      date = date == null ? {startDate: null, endDate: null} : date;
      flag = !angular.isUndefined(flag);

      vm.infiniteScrollFormat(flag, status, date);

      var obj = {
        startDate: vm.date === null ? date.startDate : vm.date.startDate,
        endDate: vm.date === null ? date.endDate : vm.date.endDate,
        debit_credit: vm.debit_credit,
        person_id: person_id,
        page: page === 1 ? page : vm.current_page,
        qtd: page === 1 && vm.current_page !== page ? vm.current_page * 20 : 20,
        status: vm.statusDefined.length === 0 ? null : vm.statusDefined.toString(),
        direction: angular.isUndefined(order) ? 'desc' : (order.substring(0, 1) === '-' ? 'desc' : 'asc')
      };

      return vm.promise = BillReceiptService.getAll(obj)
        .then(function (response) {
          var bills = response.plain();
          if (obj.page === 1) {
            vm.bills = bills;
          } else {
            vm.bills.data = vm.bills.data.concat(bills.data);
          }
          if (bills.data.length === 0) {
            vm.show_button_more = false;
          }
          vm.bills.order = order;
          $rootScope.show_loader = false;
          vm.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
          vm.show_loader = false;
        })
    };

    vm.infiniteScrollFormat = function (flag, status, date) {
      /** Variável para verificar se o botão de pesquisa foi clicado. Caso tenha sido, reajusta os filtros da página. */
      if (flag) {
        vm.statusDefined = [];
        flag = false;
        if (status) {
          for (var i = 0; i < status.length; i++)
            vm.statusDefined.push(status[i].id);
        }
      }

      /** Adiciona os Ids dos status selecionados em um Array */
      if (status) {
        /** Quando o filtro é desselecionado, o status vira null, e uma busca normal é realizada (sem filtros) */
        if (status.length === 0) {
          status = null;
        } else {
          for (var i = 0; i < status.length; i++)
            vm.statusDefined.push(status[i].id);
        }
      }

      if (!status) {
        status = [];
      }

      /** Persiste o filtro da data selecionado, para não perder a referência quando for chamado o infinite scroll. */
      if (date.startDate !== null) {
        vm.date = date;
      }
    };

    /**
     * Filtra receitas por data e status
     * @param date - date
     * @param status
     */
    vm.filterReceipts = function (date, status) {
      $rootScope.show_loader = true;
      var qtd = angular.isUndefined(vm.bills.per_page) ? 20 : vm.bills.per_page;
      var page = angular.isUndefined(vm.bills.current_page) ? 1 : vm.bills.current_page;
      var status_send = [];
      /** Filtro de status */
      if (!angular.isUndefined(status)) {
        status.forEach(function (value) {
          status_send.push(value.id);
        })
      }
      date = vm.formatDateForFilter(date);
      var obj = {
        status: status_send.toString(), startDate: date.startDate, endDate: date.endDate,
        debit_credit: vm.debit_credit, page: page, qtd: qtd
      };


      BillReceiptService.getAll(obj)
        .then(function (response) {
          if (response) {
            vm.bills = response;
          }
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });

    };

    /**
     * Busca o saldo de diferenças pendentes nos títulos
     */
    /* vm.getPendingDifferences = function () {
       BillReceiptService.getPendingDifferences().then(function (response) {
         var data = response.plain();
         vm.pending_differences = data.amount;
         vm.bill_serie_id_difference = data.bill_serie_id.id;
         if (vm.pending_differences > 0) {
           vm.has_credit = true;
         } else if (vm.pending_differences < 0) {
           vm.has_debit = true;
         }
       });
     };
 */
    /**
     * Formata a data para o filtro
     * @param date
     */
    vm.formatDateForFilter = function (date) {
      if (angular.isUndefined(date)) {
        return {
          startDate: a4Moment().startOf('month').format('YYYY-MM-DD'),
          endDate: a4Moment().endOf('month').format('YYYY-MM-DD')
        };
      } else {
        return {
          startDate: a4Moment(date.startDate).format('YYYY-MM-DD'),
          endDate: a4Moment(date.endDate).format('YYYY-MM-DD')
        };
      }
    };

    /**
     * TODO: revisar se mantem esse metodo
     * Consertar a categoria em bill detail por causa do select2
     * @param bill
     */
    vm.fixBillDetailCategory = function (bill) {

      var result = true;

      angular.forEach(bill.bill_details, function (value) {

        if (value.category != null) {
          value.bill_category_id = value.category.id;
        } else {
          Toast.warning('Selecione uma categoria.');
          result = false;
        }

      });

      return result;
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    $scope.$on('$destroy', function () {
      [updateList].forEach((function (fn) {
        fn();
      }))
    });

    vm.init();

  }

  angular
    .module('app.finance.bill-receipt')
    .controller('BillReceiptController', BillReceiptController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function BillPaymentService(Restangular) {

    /**
     * Retorna todas as contas disponíveis.
     */
    var getAllCurrentAccounts = function () {
      return Restangular.one('bill').one('getallcurrentaccounts').get();
    };

    /**
     * Retorna todos os checque de terceiros em mãos.
     */
    var getAllThirdPartyChecks = function () {
      return Restangular.one('checkreceived').one('getAllThirdPartyChecksInHand').get();
    };

    /**
     * Retorna todos os checque de terceiros em mãos.
     */
    var getAllMovementsType = function () {
      return Restangular.one('movement').one('getallmovementtypes').get();
    };

    /**
     * Retorna todos os bancos.
     */
    var getAllBanks = function () {
      return Restangular.one('listbanks').get();
    };

    /**
     * Retorna todas as empresas e configuracoes asscoiadas.
     */
    var getCompanies = function () {
      return Restangular.one('currentaccount').one('listallcompanies').get();
    };

    /**
     * Realiza Pagamento/Recebimento.
     */
    var makePayment = function (data) {
      return Restangular.one('bill').all('makepayment').post(data);
    };

    return {
      getAllCurrentAccounts: getAllCurrentAccounts,
      getAllThirdPartyChecks: getAllThirdPartyChecks,
      getAllMovementsType: getAllMovementsType,
      getAllBanks: getAllBanks,
      getCompanies: getCompanies,
      makePayment: makePayment
    };

  }

  angular
    .module('app.finance.bill-payment')
    .factory('BillPaymentService', BillPaymentService);

})();
(function () {
  'use strict';

  /** @ngInject */
  function BillPaymentTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      'BILL_PAYMENT': {
        'OWN': 'Proprío',
        'FROM_THIRD_PARTY': 'De Terceiros',
        'ACCOUNT': 'Conta',
        'CURRENT_ACCOUNT': 'Conta corrente',
        'CHECK_NUMBER': 'Nº do Cheque',
        'BANK': 'Banco',
        'BRANCH': 'Agência',
        'AMOUNT': 'Valor'
      }
    })
  }

  angular.module('app.finance.bill-payment')
    .config(BillPaymentTranslate)
})();

(function () {
    'use strict';

    /** @ngInject */
    function BillPaymentController($rootScope, $scope, $state, CONFIG, $window,
                                   $stateParams, $a4Sidenav, SideExtra, $document, Session,
                                   CashierSessionService, $mdSidenav, $timeout, Toast,
                                   PaymentControl,
                                   BillPaymentService, a4Moment, $filter, Utils, $mdDialog,
                                   Common, ModalFactory, A4PaymentService) {

      var vm = this;
      vm.currentItem = {};
      vm.currentItem.currentItemList = [];
      vm.currentaccount_list = [];
      vm.show_list = false;
      vm.action = {};
      vm.action.billsSelected = [];
      vm.action.difference = 0;
      vm.action.paymentTax = 0;
      vm.action.is_partial_payment = false;
      vm.action.issue_date = a4Moment();
      vm.action.date = vm.action.issue_date;
      vm.totalAmount = 0;
      vm.bill = {amount: vm.totalAmount};
      vm.checkList = [];
      vm.movementTypes = [];
      vm.banks = [];
      vm.accrualsDiscounts = [];
      vm.checkInterest = null;
      vm.toggle = {};
      vm.action.totalFine = 0;
      vm.action.totalInterest = 0;
      vm.action.totalAmountCalc = 0;
      vm.is_manual_payment = angular.isDefined(SideExtra.is_manual_payment);
      vm.today = a4Moment().format('YYYY-MM-DD');
      vm.is_responsible = SideExtra.is_responsible

//      console.log($stateParams)
//      console.log(SideExtra)

      /**
       * Escuta o evento "setpayment" com as bills selecionadas
       * Este evento é disparado quando o a sidebar de pagamento é aberto
       */
      vm.setpayment = function (item) {
        vm.currentItem.currentItemList = angular.isArray(item) ? item : [item];
        vm.action.billsSelected = vm.currentItem.currentItemList;
        vm.action.currentItemList = vm.currentItem.currentItemList;
        vm.getAllCurrentAccounts();
        vm.getAllThirdPartyChecks();
        vm.getAllMovementsType();
        vm.getAllBanks();
        vm.getCheckInterest();
        vm.setPaymentDate(vm.action.issue_date);
        // vm.calcTotalAmount(vm.action.billsSelected);
        vm.action.billsSelected.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.due_date) - new Date(a.due_date);
        });

        vm.currentItem.currentItemList.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.due_date) - new Date(a.due_date);
        });
        vm.show_list = true;
      };

      vm.init = function () {
        if (angular.isDefined($stateParams.bills || SideExtra.bills)) {
          vm.receiptCart();
        } else {
          vm.setpayment(vm.item);
        }
        PaymentControl.setItemsSelected(vm.action.billsSelected);
        PaymentControl.setPaymentDate(vm.action.issue_date);
        vm.toggle.list1 = true;
      };


      /**
       * No momento da comanda, essa função é disparada para abrir o slide de recebimento, para execução na comanda;
       */
      vm.receiptCart = function () {
        vm.currentItem.currentItemList = angular.copy($stateParams.bills || SideExtra.bills);
        vm.action.cashier_session_id = $stateParams.cashier_session_id || SideExtra.cashier_session_id;
        vm.action.person_id = $stateParams.person_id || SideExtra.person_id;
        vm.action.billsSelected = vm.currentItem.currentItemList;
        vm.person_name = SideExtra.person_name;
        vm.action.currentItemList = vm.currentItem.currentItemList;

        $state.current = 'private.finance.cashier-session';
        for (var i = 0; i < vm.action.billsSelected.length; i++) {
          vm.action.billsSelected[i].debit_credit = 'C';
        }
        vm.action.check_pad = true;

        vm.getAllCurrentAccounts();
        vm.getAllThirdPartyChecks();
        vm.getAllMovementsType();
        vm.getAllBanks();
        vm.getCheckInterest();
        vm.calcTotalAmountProducts(vm.currentItem.currentItemList);
        vm.setPaymentDate(vm.action.issue_date);
        // vm.calcTotalAmount(vm.currentItem.currentItemList);

        vm.show_list = true;
        $timeout(function () {
          $mdSidenav('sidenav-global').open();
        });
      };

      vm.separeId = function (items) {
        var ids = [];
        items.forEach(function (item) {
          if (angular.isUndefined(item.product_group_id)) {
            ids.push(item.id);
          }
        });
        return ids;
      };

      vm.verifyDateOfPartialPayments = function (date) {
        for (var i = 0; i < vm.action.billsSelected.length; i++) {
          if (angular.isDefined(vm.action.billsSelected[i].partial_payment_msg) &&
            vm.action.billsSelected[i].partial_payment_msg !== null && a4Moment(vm.action.billsSelected[i].settlement_date).isAfter(a4Moment(date))) {
            Common.Toast.error('Existe título selecionado com pagamento parcial feito em ' + a4Moment(vm.action.billsSelected[i].settlement_date).format('DD/MM/YYYY') +
              '.\n Não é possível fazer pagamento deste título com data anterior ao último pagamento parcial.');
            return false;
          }
        }
        return true;
      };

      vm.setPaymentDate = function (date) {
        date = angular.isUndefined(date) ? vm.action.date : date;
        if (vm.verifyDateOfPartialPayments(date)) {
          vm.action.date = a4Moment(date).format('YYYY-MM-DD');
          var ids = vm.separeId(vm.action.billsSelected);
          A4PaymentService.getValueOfBillsByDate({date: vm.action.date, ids: ids.toString()})
            .then(function (resp) {
              var items = resp.plain();
              var copy = angular.copy(items);
              items.forEach(function (item) {
                var oldItem = PaymentControl.getItemAndIndexById(item.id);
                if (item.type === 3) {
                  item.final_value = -(item.final_value);
                  item.amount = -(item.amount);
                }
                item.calc_final_value = item.final_value;
                oldItem.item.difference = isNaN(oldItem.item.difference) ? 0 : oldItem.item.difference;
                item.final_value = item.partial_payment_msg == null ? item.calc_final_value - (oldItem.item.difference * -1) : item.calc_final_value;
                item.allowance = oldItem.item.allowance;
                item.difference = oldItem.item.difference;
                item.is_partial_payment = oldItem.item.is_partial_payment;
                item.partial_payment_value = 0;
                item.allowance_value = 0;
                item.selected_option = null;
                item.edit_item = false;
                PaymentControl.updateItemOnList(item, oldItem.index);
                // vm.action.billsSelected = PaymentControl.getItemsSelected();
                $rootScope.$broadcast('BILL_LIST.change', PaymentControl.getItemsSelected());
              });
              vm.action.issue_date = vm.action.date;
              vm.updateAmount(vm.action.billsSelected);
            })
        } else {
          vm.setPaymentDate(a4Moment());
        }
      };

      vm.updateAmount = function (list) {
        var totalAmount = 0;
        var totalFine = 0;
        var totalInterest = 0;
        angular.forEach(list, function (value) {
          totalAmount += parseFloat(value.final_value);
          totalFine += parseFloat(value.calc_fine_value);
          totalInterest += parseFloat(value.calc_interest_value);
        });
        vm.totalFine = totalFine;
        vm.totalInterest = totalInterest;
        /** Se o total calculado for igual ao total ou se for 0, coloca o valor calculado na função, senão mantém o valor anterior */
        vm.totalAmountCalc = ((vm.totalAmountCalc === vm.totalAmount) || (vm.totalAmountCalc === 0)) ? totalAmount : vm.totalAmountCalc;
        vm.totalAmount = totalAmount;
      };

      /**
       * Carrega todos os 'currentAccount'
       */
      vm.getAllCurrentAccounts = function () {
        vm.show_loader = true;
        BillPaymentService
          .getAllCurrentAccounts()
          .then(function (response) {
            $scope.currentaccountlist = response;
            vm.currentaccount_list = response;
            vm.show_loader = false;
          })
          .catch(function () {
            Toast.error('Erro ao desfazer negociação.');
            vm.show_loader = false;
          });
      };

      /**
       * Calcula todos os bills selecionados
       */
      vm.calcTotalAmount = function (item) {
        var totalAmount = 0;
        angular.forEach(item, function (value) {
          totalAmount += parseFloat(value.final_value);
        });
        /** Se o total calculado for igual ao total ou se for 0, coloca o valor calculado na função, senão mantém o valor anterior */
        // vm.totalAmountCalc = (parseFloat(vm.totalAmountCalc) === parseFloat(vm.totalAmount) || vm.totalAmountCalc === 0) ? totalAmount : vm.totalAmountCalc;
        vm.totalAmount = totalAmount;
      };


      /**
       * Calcula todos os produtos selecionados para o checkout
       */
      vm.calcTotalAmountProducts = function (item) {
        vm.totalAmount = 0;
        angular.forEach(item, function (value) {
          vm.totalAmount += parseFloat(value.price);
        });
      };

      /**
       * Carrega todos os cheques de terceiros em mãos
       */
      vm.getAllThirdPartyChecks = function () {
        vm.show_loader = true;
        BillPaymentService
          .getAllThirdPartyChecks()
          .then(function (response) {
            vm.show_loader = false;
            if (response.plain() !== null) {
              vm.checkList = response.plain();
            }
          })
          .catch(function () {
            vm.show_loader = false;
            Toast.error('Error');
          });
      };

      /**
       * Carrega todos os tipos de movimentos
       */
      vm.getAllMovementsType = function () {
        vm.show_loader = true;
        BillPaymentService
          .getAllMovementsType()
          .then(function (response) {
            vm.show_loader = false;
            if (response.plain() !== null) {
              vm.movementTypes = response;
            }
          })
          .catch(function () {
            vm.show_loader = false;
            Toast.error('Erro');
          });
      };

      /**
       * Carrega todos os bancos
       */
      vm.getAllBanks = function () {
        vm.show_loader = true;
        BillPaymentService.getAllBanks()
          .then(function (response) {
            vm.show_loader = false;
            if (response.plain() !== null) {
              vm.banks = response;
            }
          })
          .catch(function () {
            vm.show_loader = false;
            Toast.error('Erro');
          });
      };

      /**
       * Carrega todas as empresas associadas
       */
      vm.getCheckInterest = function () {
        vm.show_loader = true;
        BillPaymentService
          .getCompanies()
          .then(function (response) {
            vm.show_loader = false;
            if (response !== null && response.length !== 0) {
              vm.checkInterest = response[0]['check_interest_per_month'];
            }
          })
          .catch(function () {
            vm.show_loader = false;
            Toast.error('Erro');
          });
      };

      /**
       * Verifica se há mais de um fornecedor para ações, se sim, não é permitivo
       * fazer um pagamento com diferença.
       * @param {type} bills - Lista de titulos
       * @returns {Boolean} Se True existe mais de um fornecedor na lista;
       */
      vm.verifySupliers = function (bills) {
        if (bills.length === undefined || bills.length === 1) {
          return false;
        } else {
          var any_person = bills[0].person_name;
          for (var i = 0; i < bills.length; i++) {
            if (bills[i].person_name !== any_person) {
              return true;
            }
          }
        }
        return false;
      };

      vm.close = function () {
        $a4Sidenav().close();
      };

      vm.checkDifference = function () {
        for (var i = 0; i < vm.action.billsSelected.length; i++) {
          if (vm.action.billsSelected[i].allowance_difference === true) {
            vm.action.billsSelected[i].difference = 0;
          }
        }
      };

      vm.verifyAndSubmit = function () {
        if (vm.action.hasmoredifference) {
          var diff = $filter('currency')(vm.action.difference, 'R$ ', 2);

          ModalFactory.confirm(null, 'Confirmar crédito',
            "Ao concluir este recebimento com diferença a maior, o valor " + diff + " será creditado para este cliente.",
            'Confirmar', 'Cancelar', 'finance')
            .then(function () {
              vm.submit();
            });
        } else {
          vm.submit();
        }
      }

      /**
       * Executa o pagamento.
       * @returns {boolean}
       */
      vm.submit = function () {
        $rootScope.show_loader = true;
        vm.show_loader = true;
        vm.checkDifference();
        vm.action.issue_date = vm.action.date;
        var result = angular.copy(vm.action);//copia da informação original !important
        /** Verifica necessidade de pagamento ou recebimento com diferença */
        var check = vm.checkAmountDifference(vm.totalAmount, vm.getAmountFromPayments(result.payments), vm.action.is_partial_payment);
        if (!check) {
          return false;
        }

        var payments = vm.parsePaymentsList(result.payments, result.issue_date);

        var list = vm.getBillList(vm.currentItem.currentItemList, payments);
        if(list === null){
          return;
        }
        var issue_date = vm.setDateInPaymentsAndVerifyDate(result.issue_date, list[0].debit_credit, payments);

        if (issue_date !== null) {
          list = vm.setNewFieldsInList(list, 10, issue_date, result);

          var verify = vm.verifyIfFildsOfPaymentIsFull(result.payments);

          if (!verify) {
            if (result.payment_with_difference) {
              /** Verifica se há fornecedores diferentes no titulos selecionados. */
              if (vm.verifySupliers(list)) {
                Toast.error('Com fornecedores diferentes não é possível criar um titulo de diferença.', 2000);
                return false;
              }
              if (result.diff_date === undefined) {
                Toast.error('Data da diferença é obrigatória.', 2000);
                return false;
              }
            }

            if (result.payments === undefined || result.payments.length === 0) {
              Toast.error('Adicione uma ou mais formas de pagamento.', 2000);
              return false;
            }

            var data = {
              issue_date: issue_date,
              list: list,
              payments: payments,
              difference: vm.action.difference,
              files: vm.files !== null ? vm.files : [],
              payment_diff_date: result.diff_date, confirm: result.confirm,
              cashier_session_id: result.cashier_session_id,
              person_id: result.person_id,
              notes: vm.action.notes
            };
            BillPaymentService.makePayment(data)
              .then(function (response) {
                vm.show_loader = false;
                if (response) {
                  $rootScope.$emit('UPDATE_BILL_LIST');
                  vm.close();
                  Toast.success("Ação realizada com sucesso");
                  if (vm.is_manual_payment) {
                    CashierSessionService.printGuestCheckPadReport(response.bill_action_id, false);
                  }

                  if (!vm.is_manual_payment) {
                    $state.go($state.current, {bill_action_id: response.bill_action_id}, {reload: true});
                  }
                  $rootScope.show_loader = false;
                }
              })
              .catch(function (response) {
                vm.show_loader = false;
                $rootScope.show_loader = false;
                if(angular.isDefined(response.data.exceededProducts)){
                  ModalFactory.custom('app/finance/bill-payment/modals/stockout-message-modal.html', {products: response.data.exceededProducts});
                }else {

                  /**Caso a mensagem de erro venha como uma mensagem sql, recorta o error_code e o define como o valor de mensagem */
                  if (response.data[0].includes('"error_code"')) {
                    // Regex para extrair o "error_code"
                    var match = response.data[0].match(/"error_code"\s*:\s*"([^"]+)"/);
                    response.data[0] = match[1];
                  }

                  switch (response.data[0]) {
                    case 'WRONG_TOTAL_PAYMENT':
                      Toast.error('Existe diferença não esperada nos valores.');
                      break;
                    case 'CLOSED_DAY' :
                      Toast.error('Dia fechado');
                      break;
                    case 'WITHOUT_AMOUNT_TO_TRANSACTION' :
                      vm.confirmNegativePayment();
                      Toast.error('Sem saldo para realizar o pagamento');
                      break;
                    case 'BILL_EVENT_AMOUNT_PAID_LOWER_FINE_INTEREST' :
                      Toast.error('O valor minimo para o pagamento parcial é a soma dos juros e da multa.')
                      break;
                    default:
                      Toast.error('Erro ao carregar informação.');
                      break;
                  }
                }

              });
          } else {
            $rootScope.show_loader = false;
            vm.show_loader = false;
            $timeout(function () {
              Toast.error('Erro ao carregar informação.');
            }, 2000);
          }
        }
      };

      /**
       * confirmNegativePayment
       * Se a conta não tem saldo para a transação, confirmar com o usuário se deseja entrar no 'limite'
       */
      vm.confirmNegativePayment = function () {
        var action = angular.copy(vm.action);
        ModalFactory.confirm(
          null,
          'Confirmação',
          'Você não tem saldo para realizar essa ação. Deseja continuar?',
          'Confirmar',
          'Cancelar',
          'finance'
        ).then(function () {
          vm.action = action;
          vm.action.confirm = true;
          vm.submit();
        }).catch(function () {
          Common.Toast.warning('Ação cancelada.');
        });
      };

      /**
       *
       * @param payments
       * @param datePayment
       * @returns {Array}
       */
      vm.parsePaymentsList = function (payments, datePayment) {
        var result = [];

        angular.forEach(payments, function (payment) {
          var obj = null;

          if (payment.movement_type_id === 1) { //pagamento c dinheiro
            obj = {
              amount: payment.amount,
              current_account_id: payment.current_account_id,
              date: datePayment,
              debit_credit: payment.debit_credit.toUpperCase(),
              movement_type_id: payment.movement_type_id
            };
          } else if (payment.movement_type_id === 2 || payment.movement_type_id === 5) { //pagamento c cheque
            if (payment.type === 'PayCheck') {
              obj = {
                amount: payment.amount,
                account: payment.current_account.bank_account_number,
                number: payment.document,
                bank_id: payment.current_account.bank_id,
                blocked: payment.blocked,
                branch: payment.current_account.bank_branch,
                current_account_id: payment.current_account_id,
                date: payment.date, // A DATA TEM QUE SE A DO CHEQUE, E NÃO A DATA DO RECEBIMENTO
                debit_credit: payment.debit_credit.toUpperCase(),
                is_third_party_check: payment.is_third_party_check,
                movement_type_id: payment.movement_type_id,
                newDate: a4Moment(payment.newDate).format('YYYY-MM-DD')
              };

            } else {
              obj = {
                amount: payment.amount,
                account: payment.account,
                number: payment.number,
                bank_id: payment.bank.id,
                blocked: payment.blocked,
                branch: payment.branch,
                current_account_id: payment.current_account_id,
                date: payment.date, // A DATA TEM QUE SE A DO CHEQUE, E NÃO A DATA DO RECEBIMENTO
                debit_credit: payment.debit_credit.toUpperCase(),
                hasInterest: payment.hasInterest,
                interest_decision: payment.interest_decision,
                interest_value: payment.interest_value,
                is_third_party_check: payment.is_third_party_check,
                movement_type_id: payment.movement_type_id,
                newDate: a4Moment(payment.newDate).format('YYYY-MM-DD')
              };

            }



          } else if (payment.movement_type_id === 20) { //pagamento c cartão de débito
            obj = {
              amount: payment.amount,
              document: payment.document,
              card_number: payment.card_number,
              movement_type_id: payment.movement_type_id,
              suggested_date: payment.suggested_date,
              date: datePayment,
              debit_credit: payment.type.toUpperCase(),
              current_account_id: angular.isDefined(payment.debitCard) ? payment.debitCard.current_account_id : payment.current_account_id,
              current_account_type_id: $filter('filter')(payment.current_account,
                {id: angular.isDefined(payment.debitCard) ? payment.debitCard.current_account_id : payment.current_account_id})[0].current_account_type_id,
              debit_card_id: angular.isDefined(payment.debitCard) ? payment.debitCard.id : null
            };

          } else if (payment.movement_type_id === 21) { //pagamento c cartão de crédito

            obj = {
              amount: payment.amount + ((angular.isDefined(payment.paymentTax) && payment.paymentTax !== null) ? payment.paymentTax : 0),
              document: payment.document,
              payment_tax: payment.paymentTax,
              card_number: payment.card_number,
              movement_type_id: payment.movement_type_id,
              suggested_date: payment.suggested_date,
              date: datePayment,
              debit_credit: payment.type.toUpperCase(),
              current_account_id: angular.isDefined(payment.creditCard) ? payment.creditCard.current_account_id : payment.current_account_id,
              current_account_type_id: $filter('filter')(payment.currentAccountlist,
                {id: angular.isDefined(payment.creditCard) ? payment.creditCard.current_account_id : payment.current_account_id})[0].current_account_type_id,
              credit_card_id: angular.isDefined(payment.creditCard) ? payment.creditCard.id : null
            };

          } else if ((payment.movement_type_id >= 10 && payment.movement_type_id <= 15) || payment.movement_type_id === 22) { //pagamento c conta banco

            obj = {
              amount: payment.amount,
              current_account_id: payment.current_account_id,
              date: datePayment,
              debit_credit: payment.debit_credit.toUpperCase(),
              movement_type_id: payment.movement_type_id
            };
          } else if (payment.movement_type_id === 57) { //pagamento c crédito
            obj = {
              amount: payment.amount,
              current_account_id: null,
              person_id: payment.person_id,
              date: datePayment,
              debit_credit: 'D',
              movement_type_id: payment.movement_type_id,
            };
            console.log('eu estou aqui!!!')
          }
          result.push(obj);
        });

        return result;
      };

      /**
       * Retorna o somatorio de dos pagamentos.
       * @param payments
       * @returns {number}
       */
      vm.getAmountFromPayments = function (payments) {
        var sum = 0;
        angular.forEach(payments, function (item) {
          if (item.amount !== '') {
            item.amount = item.amount === null ? 0 : parseFloat(item.amount);
            sum = (sum + parseFloat(item.amount.toFixed(2)));
          }
        });
        return sum;
      };

      /**
       * Verifica se o valor total é diferente do inserido para pagamento ou recibimento.
       * @param amount - Valor total
       * @param payment_amount - Valores inseridos para pagamento ou recebimento.
       * @param is_partial_payment
       * @returns {boolean}
       */
      vm.checkAmountDifference = function (amount, payment_amount, is_partial_payment) {
        var is_different = false;
        if (typeof amount === "string") {
          amount = parseFloat(amount);
        }

        if (is_different.result && !vm.action.payment_with_difference) {
          Toast.warning(is_different.message, 8000);
          return false;
        }

        return true;
      };

      /**
       * Retorna dados necessarios para o pagamento.
       * @param listOfSelected - Selecionado para o pagamento
       * @returns {Array}
       */
      vm.getBillList = function (listOfSelected) {
        var list = [];
        angular.forEach(listOfSelected, function (bill) {
          if(isNaN(bill.allowance)){
            return null;
          }
          var final_value = 0;
          if (angular.isDefined(bill.partial_payment_value) && bill.partial_payment_value > 0) {
            final_value = bill.partial_payment_value;
          } else if (angular.isDefined(bill.allowance) && bill.allowance !== null && bill.allowance > 0) {
            final_value = bill.final_value - bill.allowance;
          } else {
            final_value = bill.final_value;
          }

          var discount = parseFloat(bill.calc_discount_cond_value) + parseFloat(bill.calc_discount_prom_value) + parseFloat(bill.discount_fixed_value);

          if(isNaN(discount)){
            discount = 0;
          }
          
          var calc_diff = -parseFloat(((parseFloat(bill.final_value) + (angular.isDefined(bill.partial_payment_value) && bill.partial_payment_value > 0 ? discount - bill.allowance : 0)) - final_value).toFixed(2)) //final_value calculado pela view menos final_value definido na operação (após definir valor de pagamento parcial)
          /** Valor calculado pois para definir o valor da diferença em um título sem pagamento parcial devemos utilizar o valor calculado pela view,
           * se tiver pagamento parcial devemos utilizar o valor original do título */
          // var amount_calc_difference = angular.isDefined(bill.partial_payment_value) && bill.partial_payment_value > 0 ? bill.amount : bill.final_value;
          list.push({
            id: bill.id,
            product_id: bill.product_id,
            amount: bill.amount,
            amount_paid: bill.amount_paid,
            is_partial_payment: bill.is_partial_payment,
            interest_decision: bill.interest_decision,
            bill_category_id: bill.bill_category_id,
            bill_details: bill.bill_details,
            final_value: final_value,
            description: bill.description,
            person_id: bill.person_id,
            beneficiary_id: bill.beneficiary_id === null || angular.isUndefined(bill.beneficiary_id) ? null: bill.beneficiary_id,
            beneficiary_name: bill.beneficiary_name === null || angular.isUndefined(bill.beneficiary_name) ? null : bill.beneficiary_name,
            debit_credit: bill.debit_credit,
            type: bill.type,
            calc_fine_value: bill.calc_fine_value !== null ? bill.calc_fine_value : null,
            calc_interest_value: bill.calc_interest_value !== null ? bill.calc_interest_value : null,
            allowance: bill.allowance !== null ? bill.allowance * -1 : null,
            difference: calc_diff,
            quantity: bill.quantity == null || angular.isUndefined(bill.quantity) ? 1 : bill.quantity,
            calc_discount_cond_value: bill.calc_discount_cond_value !== null ? bill.calc_discount_cond_value : 0,
            calc_discount_prom_value: bill.calc_discount_prom_value !== null ? bill.calc_discount_prom_value : 0,
            discount: angular.isDefined(bill.productDiscount) ? bill.productDiscount : null,
            bill_serie_id: angular.isDefined(bill.bill_serie_id) ? bill.bill_serie_id : null
          });
        });
        return list;
      };

      /**
       * Verifica qual titulo será pago parcialmente
       * @param listOfSelected - Lista de titulos selecionados para o pagamento
       * @param payments - Lista de pagamentos
       * @return array
       */
      vm.verifyPartialPayment = function (listOfSelected, payments) {
        var valor_total_do_pagamento = 0;
        var valor_disponivel = 0;

        /** Pega os valores disponíveis para o pagamento */
        payments.forEach(function (value) {
          value.amount = parseFloat(value.amount);
          valor_total_do_pagamento += value.amount;
        });
        valor_disponivel = valor_total_do_pagamento;

        /** Converte valores dos titulos para float */
        angular.forEach(listOfSelected, function (bill) {
          bill.amount = parseFloat(bill.amount);
          bill.amount_paid = parseFloat(bill.amount_paid);
          bill.final_value = parseFloat(bill.final_value);
        });

        /** Ordena titulos pelo valor final ascendente */
        listOfSelected = $filter('orderBy')(listOfSelected, '+final_value');

        angular.forEach(listOfSelected, function (bill) {
          if (valor_disponivel < bill.final_value) {
            bill.is_partial_payment = true;
            bill.amount_paid = valor_disponivel;
          } else {
            bill.is_partial_payment = false;
            bill.amount_paid = bill.final_value;
            valor_disponivel -= bill.final_value;
          }
        });
        return listOfSelected;
      };

      /**
       *
       * @param list
       * @param idChange
       * @param issue_date
       * @param action
       * @return {*}
       */
      vm.setNewFieldsInList = function (list, idChange, issue_date, action) {
        for (var i = 0; i < list.length; i++) {
          list[i].individual_amount = vm.addAccrualsDiscounts(i, list[i].amount);
          list[i].diff_date = Utils.convertDate(action.diff_date);
          // list[i].amount = vm.totalAmount;
          list[i].was_paid = 0;
          if (typeof list[i].bill_details !== 'undefined') {
            list[i].bill_details.description = list[i].description;
            list[i].bill_details.amount = list[i].amount;
            list[i].bill_details.bill_category_id = list[i].bill_category_id;
          } else {
            list[i].bill_details = [];
          }
          list[i].idChange = idChange;
          list[i].issue_date = issue_date;
        }

        return list;
      };

      /**
       * Verifica se os campos conta e valor em informações de pagamento estão preenchidos
       * @param {type} payments
       * @returns {Boolean}
       */
      vm.verifyIfFildsOfPaymentIsFull = function (payments) {

        if (payments !== undefined) {
          for (var i = 0; i < payments.length; i++) {

            if (payments[i].amount === null || payments[i].amount === "") {
              Toast.error('Para título já pago é necessário informar o valor do pagamento');
              return true;
            }
            if (typeof payments[i].movement_type_id === 'undefined') {
              Toast.error('Necessário forma de pagamento');
              return true;
            }
          }
        }

        return false;
      };

      /**
       * Coloca o campo date no objeto de payments.
       * @param {type} date - data no formato
       * @param debit_credit
       * @param payments - dados do request
       * @returns boolean|type
       */
      vm.setDateInPaymentsAndVerifyDate = function (date, debit_credit, payments) {
        if (date !== null) {
          var len = payments.length;
          var newDate = date;
          for (var i = 0; i < len; i++) {
            // Esse código foi comentado porque está sobrepondo as datas dos cheques pré-datados
            //payments[i].date = newDate;
            //esse codigo foi comentado porque esta sobrepondo casos em que é necessário mudar o debit_credit para creditos en caixa(movement_type_id = 57)
            //payments[i].debit_credit = debit_credit;
          }
          return newDate;
        } else {
          Toast.error('REQUIRED_PAYMENT_DATE');
          return false;
        }
      };

      /**
       * Retorna valor total do titulo (apenas para o html)
       * @param id
       * @param amount
       * @returns {string}
       */
      vm.addAccrualsDiscounts = function (id, amount) {
        var result = amount;
        if (id !== null && amount !== null) {
          if (vm.accrualsDiscounts[id] !== null && angular.isDefined(vm.accrualsDiscounts[id])) {
            var interest = vm.accrualsDiscounts[id].interest;
            var fine = vm.accrualsDiscounts[id].fine;
            var discount = vm.accrualsDiscounts[id].discount;
            var accruals = (interest + fine) - discount;
            accruals = vm.applyAllowenceIfExist(vm.accrualsDiscounts[id], accruals);
            result = isNaN(accruals) ? result : parseFloat(result) + accruals;
          }
        }
        return parseFloat(result).toFixed(2);
      };

      /**
       * Remove o bill selecionado
       */
      vm.removeItem = function (item) {
        var index = vm.currentItem.currentItemList.indexOf(item);
        vm.currentItem.currentItemList.splice(index, 1);
        vm.calcTotalAmountProducts(vm.currentItem.currentItemList);
        vm.calcTotalAmount(vm.currentItem.currentItemList);
      };

      /**
       * Abre o modal para edição do valor, desconto, multa e juros
       * @param item
       */
      vm.editItem = function (item) {
        var index = vm.currentItem.currentItemList.indexOf(item);
        if (angular.isDefined(item.productDiscount)) {
          item.totalDiscount = parseFloat(item.productDiscount);
        } else {
          item.totalDiscount = parseFloat(item.calc_discount_cond_value) + parseFloat(item.calc_discount_prom_value) + parseFloat(item.discount_fixed_value) + parseFloat(item.discount);
        }
        item.value_paid = item.final_value;
        ModalFactory.customClean(
          'app/finance/bill-payment/modals/EditBillValues.html',
          'BillPaymentEditItemController',
          'vm',
          false,
          item
        ).then(function (value) {
          vm.currentItem.currentItemList[index] = value;
          vm.calcTotalAmount(vm.currentItem.currentItemList);
        }).catch(function () {
        });
      };

      /**
       * Calcula o valor após a edição no modal
       * @param item
       * @returns {*}
       */
      vm.calcAmount = function (item) {
        /** variável temporária para guardar o valor calculado */
        var temp = item.final_value;

        /** Subtrai abonos */
        if (angular.isDefined(item.allowance) && item.allowance !== null && item.allowance !== '') {
          temp = parseFloat(temp) - parseFloat(item.allowance);
        }

        /** Soma diferenças */
        if (angular.isDefined(item.value_paid) && item.value_paid !== null && item.value_paid !== '') {
          item.difference = parseFloat(temp) - parseFloat(item.value_paid);
        }

        temp = temp - item.difference;
        item.final_value = parseFloat(temp);

        return item;
      };

      vm.init();

    }

    angular
      .module('app.finance.bill-payment')
      .controller('BillPaymentController', BillPaymentController);
  }
)();

(function () {
  'use strict';

  /** @ngInject */
  function BillPaymentEditItemController(ModalExtra, $rootScope, $mdDialog) {
    var vm = this;
    /**
     * Flag para indicar se a diferença entre o valor pago e o valor esperado
     * é um crédito ou não
     * @type {boolean}
     */
    vm.is_credit = false;
    vm.selected_option = 'a';

    vm.init = function () {
      vm.item = angular.copy(ModalExtra);
      vm.item.totalDiscount = angular.isDefined(vm.item.totalDiscount) &&
      !isNaN(vm.item.totalDiscount) ? vm.item.totalDiscount : 0;

      vm.item.totalDiscountTemp = parseFloat(angular.copy(vm.item.totalDiscount));
      vm.item.showTotal = parseFloat(angular.copy(vm.item.final_value));
      vm.item.showDifference = 0;
      vm.item.allowance = 0;
      vm.item.is_partial_payment = false;
      vm.item.calc_interest_value = angular.isDefined(vm.item.calc_interest_value) ? vm.item.calc_interest_value : 0;
      vm.item.difference = angular.isDefined(vm.item.difference) ? vm.item.difference : 0;
      vm.item.calc_fine_value = angular.isDefined(vm.item.calc_fine_value) ? vm.item.calc_fine_value : 0;
      vm.item.amount = angular.isDefined(vm.item.amount) ? vm.item.amount : vm.item.final_value;
    };

    /**
     * Quando houver mudança no input de valor a pagar, recalcula o abono e a diferença
     */
    vm.changeFinalValue = function () {

      if(vm.item.debit_credit === 'D'){
        if(vm.item.is_partial_payment){
          vm.item.calc_fine_value = 0;
          vm.item.calc_interest_value = 0;
          vm.item.calc_discount_cond_value = 0;
        }
        var amount = vm.item.partial_payment_msg !== null ?  + parseFloat(vm.item.difference) : parseFloat(vm.item.amount);
        vm.item.calc_fine_value = vm.item.calc_fine_value !== null ? vm.item.calc_fine_value : 0;
        vm.item.calc_interest_value = vm.item.calc_interest_value !== null ? vm.item.calc_interest_value : 0;
        vm.item.calc_discount_cond_value = vm.item.calc_discount_cond_value !== null ? vm.item.calc_discount_cond_value : 0;
        // console.log(vm.item.final_value);
        // console.log(vm.item.amount);
        // console.log(vm.item.difference);
        // console.log(vm.item.calc_fine_value);
        // console.log(vm.item.calc_interest_value);
        // console.log(vm.item.calc_discount_cond_value);
        vm.item.value_paid = amount + parseFloat(vm.item.calc_fine_value)
          + parseFloat(vm.item.calc_interest_value) - parseFloat(vm.item.calc_discount_cond_value) ;
      }
      /** @vm.item.difference
       *  Quando o título estiver sendo pago com um valor maior do que o esperado,
       *  a diferença será POSITIVA.
       *  Quando estiver sendo pago com um valor menor,
       *  a diferença será NEGATIVA. */
      // var amount = angular.isDefined(vm.item.partial_payment_msg) && vm.item.partial_payment_msg !== null ? Math.abs(vm.item.difference) : parseFloat(vm.item.amount);
      // var fine = vm.item.calc_fine_value !== null ? vm.item.calc_fine_value : 0;
      // var interest = vm.item.calc_interest_value !== null ? vm.item.calc_interest_value : 0;
      // var discount = 0;
      //
      // if (parseFloat(vm.item.value_paid) > parseFloat(vm.item.final_value)) {
      //   discount = parseFloat(angular.copy(vm.item.totalDiscount));
      //   vm.item.totalDiscountTemp = discount;
      //   vm.item.showTotal = amount - vm.item.totalDiscountTemp + parseFloat(fine) + parseFloat(interest);
      //   vm.item.showDifference = -(vm.item.final_value - vm.item.value_paid);
      // } else if (parseFloat(vm.item.value_paid) < parseFloat(vm.item.final_value)) {
      //   discount = angular.isDefined(vm.item.is_partial_payment) && vm.item.is_partial_payment === 0 ? parseFloat(angular.copy(vm.item.totalDiscount)) : 0;
      //   vm.item.totalDiscountTemp = discount;
      //   vm.item.showTotal = amount - vm.item.totalDiscountTemp + parseFloat(fine) + parseFloat(interest);
      //   vm.item.showDifference = -(vm.item.showTotal - vm.item.value_paid);
      // } else {
      //   vm.item.showDifference = -(vm.item.final_value - vm.item.value_paid);
      //   vm.item.showTotal = amount - vm.item.totalDiscountTemp + parseFloat(fine) + parseFloat(interest);
      //   vm.item.totalDiscountTemp = angular.copy(vm.item.totalDiscount);
      // }
      // vm.is_credit = vm.item.showDifference > 0;
      // vm.alert_fine_interest = vm.item.value_paid < (parseFloat(vm.item.calc_fine_value) + parseFloat(vm.item.calc_interest_value));
    };

    /**
     * Quando houver mudança no input de abono, recalcula o valor da diferença
     */
    /*    vm.changeAllowance = function () {
          vm.item.difference = -(vm.item.calc_final_value - vm.item.value_paid - vm.item.allowance);
        };*/

    /**
     * Quando houver mudança no checkbox de "Abona toda a diferença", atribui o valor da diferença para o abono
     */
    vm.changeAllowanceDifference = function () {
      var discount = 0;
      /** Se não for uma diferença a maior/crédito */
      if (!vm.is_credit) {
        var amount = vm.item.partial_payment_msg !== null ? Math.abs(vm.item.difference) : parseFloat(vm.item.amount);
        discount = vm.item.is_partial_payment === '0' ? parseFloat(angular.copy(vm.item.totalDiscount)) : 0;
        vm.item.showTotal = amount - discount + (vm.item.calc_fine_value !== null ? parseFloat(vm.item.calc_fine_value) : 0) +
          (vm.item.calc_interest_value !== null ? parseFloat(vm.item.calc_interest_value) : 0);
        vm.item.showDifference = -(vm.item.showTotal - vm.item.value_paid);
        vm.item.totalDiscountTemp = discount;
      } else {
        discount = parseFloat(angular.copy(vm.item.totalDiscount));
        vm.item.showDifference = vm.item.is_partial_payment === '1' ? 0 : -(vm.item.final_value - vm.item.value_paid);
        vm.item.totalDiscountTemp = discount;
      }
    };

    vm.answer = function (item) {
      item.final_value = item.value_paid;
      item.difference = vm.item.showDifference;
      item.allowance = vm.item.is_partial_payment === '0' ? angular.copy(item.difference) : 0;
      $rootScope.$broadcast('ModalFactory.close', item);
    };

    /**
     * Fecha o modal
     */
    vm.closeModal = function () {
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular
    .module('app.finance.bill-payment')
    .controller('BillPaymentEditItemController', BillPaymentEditItemController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function BillNegotiateController($rootScope, $scope, $state, $mdSidenav, $a4Sidenav, a4Moment, A4PaymentService,
                                   Session, Toast, ModalFactory, BillNegotiateService, BankSlipRuleService, Utils) {

    var vm = this;
    vm.totalAmount = 0;
    vm.interest_value = 0;
    vm.bill = {};
    vm.bill_undo = {};
    vm.billList = [];
    vm.billListId = [];
    vm.payment_installments = [];
    vm.currentItem = {};
    vm.currentItem.amount = 0;
    vm.currentItem.date = a4Moment();
    vm.currentItem.currentItemList = {};
    vm.bank_slip_rule_id = null;
    vm.disabledSubmit = false;
    vm.show_table = false;
    vm.show_list = false;
    vm.calculateInstalmentValue = {};


    vm.currentItem.allowanceFine = false;
    vm.currentItem.allowanceInterest = false;
    vm.currentItem.giveLostedDiscounts = false;
    vm.currentItem.giveFutureDiscounts = true;

    vm.init = function () {
      if (vm.undonegotiate === false) {
        setnegotiate(vm.item);
        vm.getAllBankSlipRules();
        vm.getAllFinesRule();
      } else {
        undonegotiate(vm.item);
      }
    };

    vm.getAllBankSlipRules = function () {
      $rootScope.show_loader = true;
      vm.allRules = [];
      BankSlipRuleService.getAllBankSlipRules()
        .then(function (response) {
          vm.bank_slip_rules = response;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.getAllFinesRule = function () {
      $rootScope.show_loader = true;
      vm.finesRules = [];
      BillNegotiateService.getAllFinesRuleForNegotiation().then(function (response) {
        var obj = response.plain();
        vm.finesRules = obj.fines_rules;
        vm.fines_rule_id = obj.suggestion_fines_rule;
        vm.bank_slip_rule_id = obj.suggestion_bank_slip_rule;
        $rootScope.show_loader = false;
      })
    };

    vm.close = function () {
      $a4Sidenav().close()
    };

    /**
     * Escuta o evento "setnegotiate" com as bills selecionadas
     * Este evento é disparado quando o a sidebar de negociação é aberta
     */
    var setnegotiate = function (item) {
      vm.bill = item;
      vm.bill.person_id_payer = item.person_id;
      vm.billList = angular.isArray(item) ? item : [item];
      vm.billListId = vm.getIds(item);
      A4PaymentService.getValueOfBillsByDate({
        date: vm.currentItem.date.format('YYYY-MM-DD'),
        ids: vm.billListId.toString()
      })
        .then(function (resp) {
          vm.currentItem.date = vm.currentItem.date.format('YYYY-MM-DD');
          vm.billList = resp.plain();
          vm.updateCalc();
          vm.show_list = true;
        })
    };

    vm.getIds = function (bills) {
      var listBills = angular.isArray(bills) ? bills : [bills];
      var listIds = [];

      angular.forEach(listBills, function (bill) {
        listIds.push(bill.id);
      });

      return listIds;
    };

    /**
     * Escuta o evento "undonegotiate" com as bills selecionados
     * Este evento é disparado quando o a sidebar de cancelamento de negociação é aberta
     */
    var undonegotiate = function (item) {

      $rootScope.show_loader = true;
      vm.bill = item;
      vm.currentItem = vm.bill;
      vm.currentItem.currentItemList = angular.isArray(item) ? item : [item];

      BillNegotiateService
        .getExpensesNegociation({bill_id: item.id})
        .then(function (response) {
          vm.bill_undo = response;
          vm.currentItem.amount = response.total;
          vm.payment_installments = response.generated_installments;

          $rootScope.show_loader = false;
          angular.forEach(vm.payment_installments, function (item, index) {
            var formatDate = item.date.split('/');
            vm.payment_installments[index].date = new Date(formatDate[2] + '/' + formatDate[1] + '/' + formatDate[0]);
          });

        }).catch(function (response) {
        Toast.error('GET_DATA_ERROR');
        $rootScope.show_loader = false;
      });
    };


    /**
     * Exibe uma confirmação para o cancelamento da negociação
     */
    vm.undoNegociation = function (ev) {
      var msg = 'A negociação será desfeita. Deseja realmente confirmar?';
      ModalFactory.confirm(ev, 'Negociação', msg, 'Confirmar', 'Cancelar')
        .then(function () {
          vm.confirmUndoNegociation();
        });
    };

    /**
     * Cancela realmente a negociação
     */
    vm.confirmUndoNegociation = function () {
      if (vm.bill.id != null && vm.bill_undo.is_undoable) {
        vm.disabledSubmit = true;

        BillNegotiateService
          .undoNegociationById({bill_id: vm.bill.id})
          .then(function (response) {
            $a4Sidenav().close();
            Toast.success("Ação realizada com sucesso");
            vm.disabledSubmit = false;
            $state.go($state.current, {}, {reload: true});
          })
          .catch(function (response) {
            vm.disabledSubmit = false;
            Toast.error('Erro ao desfazer negociação.');
          });

      } else {
        Toast.error("Não pode fazer esta ação com titulos pagos", 'A4 Web');
      }
    };

    /**
     * Escuta o evento "isSidenavOpen" e atualiza para 0 o valor das negociações
     * Este evento é disparado quando o a sidebar de negociação é fechado
     */
    $scope.$watch('isSidenavOpen', function (newValue, oldValue) {
      if (!newValue) {
        vm.payment_installments = [];
      }
    });

    /**
     * Atualiza o cálculo dos bills selecionados
     */
    vm.updateCalc = function () {
      vm.calcTotalAmount(vm.billList);
      vm.currentItem.amount = vm.currentItem.totalAmount;
      vm.currentItem.currentItemList = vm.billList;
    };

    vm.changeTotalAmount = function () {
      vm.currentItem.amount = vm.currentItem.totalAmount;
    };

    vm.setnegotiate = function () {
      setnegotiate(vm.bill);
    };

    /**
     * Calcula todos os bills selecionados
     */
    vm.calcTotalAmount = function (list) {
      vm.currentItem.totalAmount = 0;
      vm.currentItem.totaldiscounts = 0;
      vm.currentItem.totalMulta = 0;
      vm.currentItem.totalJuros = 0;
      vm.currentItem.totalMissedDiscounts = 0;
      vm.currentItem.futureDiscounts = 0;
      angular.forEach(list, function (value) {
        vm.currentItem.totalAmount += parseFloat(value.final_value);
        vm.currentItem.totaldiscounts += parseFloat(value.discount_fixed_value) + parseFloat(value.calc_discount_cond_value) + parseFloat(value.calc_discount_prom_value);
        vm.currentItem.totalMulta += parseFloat(value.calc_fine_value);
        vm.currentItem.totalJuros += parseFloat(value.calc_interest_value);
        vm.currentItem.totalMissedDiscounts += parseFloat(value.missed_discount);
        var futureDiscount = (parseFloat(value.calc_discount_cond_value) + parseFloat(value.calc_discount_prom_value))
          - parseFloat(value.missed_discount);
        vm.currentItem.futureDiscounts += angular.isDefined(futureDiscount) && !isNaN(futureDiscount) && futureDiscount > 0 ? futureDiscount : 0;
      });
      vm.originalTotalAmount = angular.copy(vm.totalAmount);
      vm.show_table = true;
      $scope.$applyAsync();
    };

    /**
     *
     * @param value - Valor a ser subtraído ou adicionado
     * @param bool - true: realiza a operação - false: desfaz a operação
     */
    vm.changeFinalValue = function (value, bool) {
      /*vm.calcTotalAmount(vm.billList);*/
      if (bool) {
        vm.currentItem.totalAmount -= value;
        vm.currentItem.amount = vm.currentItem.totalAmount;
      } else {
        vm.currentItem.totalAmount += value;
        vm.currentItem.currentItem.amount = vm.currentItem.totalAmount;
      }
      $scope.$applyAsync();
    };

    /**
     * Criação das parcelas na negociação de multiplas despesas
     */
    vm.createInstallmentsNegociation = function () {
      if (!vm.checkIfInstallmentsIsValid(vm.currentItem)) {
        Toast.warning('O valor total das parcelas é diferente do valor da despesa.');
        return;
      } else if (vm.payment_installments.length > 0) {

        vm.disabledSubmit = true;
        $rootScope.show_loader = true;
        // vm.billListId[0] = vm.billList.id;

        BillNegotiateService.createInstallmentsNegociation({
          bill_category_id: vm.billList[0].bill_category_id,
          billsSelected: vm.billListId,
          debit_credit: vm.billList[0].debit_credit,
          installments: vm.payment_installments,
          person_id: vm.billList[0].person_id,
          person_id_payer: vm.billList[0].person_id,
          bank_slip_rule_id: vm.bank_slip_rule_id,
          fines_rule_id: vm.fines_rule_id,
          company_id: Session.get('current_company', "sessionStorage"),
          description: vm.currentItem.description,
          notes: vm.currentItem.notes,
          date: vm.currentItem.date

        })
          .then(function () {
            $a4Sidenav().close();
            Toast.success("Ação realizada com sucesso");
            $scope.$emit('open-undo-negotiate',
              {
                id: vm.billList[0].id,
                settlement_date: a4Moment(vm.currentItem.date).format('DD/MM/YYYY'),
                amount_paid: vm.currentItem.totalAmount
              }
            );

            vm.disabledSubmit = false;
            $rootScope.show_loader = false;
          })
          .catch(function (response) {
            Toast.error('GET_DATA_ERROR');

            vm.disabledSubmit = false;
            $rootScope.show_loader = false;
          });

      } else {
        Toast.warning('Adicione uma ou mais parcelas válidas para a negociação.');
      }

    };

    /**
     * Valida se o valor total das parcelas é igual ao valor da despesa
     * Só executa essa validacao em caso de despesa parcelada e recorrencia com vencimentos variaveis
     * @param current_item
     * @returns {boolean}
     */
    vm.checkIfInstallmentsIsValid = function (current_item) {
      // var sum = 0;
      // var entry_value = 0;
      // var first_due_date = null;
      // angular.forEach(vm.payment_installments, function (item) {
      //   if (item.amount !== '') {
      //     item.amount = item.amount == null ? 0 : parseFloat(item.amount);
      //     sum = Utils.roundFloat(sum + parseFloat(item.amount));
      //   }
      //   if (item.idx === 0) {
      //     first_due_date = item.due_date;
      //   }
      //   if (angular.isUndefined(item.idx)) {
      //     entry_value = item.amount;
      //   }
      // });
      // var instalment_value = Utils.roundFloat(parseFloat(sum));
      // var difference_between_first_due_date_and_today = a4Moment(first_due_date).diff(a4Moment().startOf('day'), 'days');
      // if (vm.interest_value !== 0) {
      //   /*var old_amount = current_item.amount;
      //   current_item.amount = vm.calculateInstalmentValue(current_item.amount, (old_amount - entry_value), difference_between_first_due_date_and_today);*/
      // }
      return (current_item.pending_difference === 0);
    };

    /**
     * Remove o bill selecionado
     */
    vm.removeItem = function (item) {
      var index = vm.currentItem.currentItemList.indexOf(item);
      vm.currentItem.currentItemList.splice(index, 1);
      vm.updateCalc();
    };

    vm.init();


  };

  angular
    .module('app.finance.bill-negotiate')
    .controller('BillNegotiateController', BillNegotiateController);
})
();

(function () {
  'use strict';

  /** @ngInject */
  function BillNegotiateService(Restangular) {

    var createInstallmentsNegociation = function (obj) {
      return Restangular.one('bill').all('installmentsnegociation').post(obj);
    };

    var getExpensesNegociation = function (obj) {
      return Restangular.one('bill').one('getExpensesNegociation').get(obj);
    };

    var undoNegociationById = function (obj) {
      return Restangular.one('bill').one('undoNegociationById').get(obj);
    };

    var getAllFinesRuleForNegotiation = function (obj) {
      return Restangular.one('bill').one('getallfinesrulefornegotiation').get(obj);
    };

    return {
      createInstallmentsNegociation: createInstallmentsNegociation,
      getExpensesNegociation: getExpensesNegociation,
      undoNegociationById: undoNegociationById,
      getAllFinesRuleForNegotiation: getAllFinesRuleForNegotiation
    };

  }

  angular
    .module('app.finance.bill-negotiate')
    .factory('BillNegotiateService', BillNegotiateService);

})();
(function () {
  'use strict';

  /** @ngInject */
  function BillExpenseService(Restangular) {
    var vm = {};

    /**
     * getAll
     * @param obj
     */
    vm.getAll = function (obj) {
      return Restangular.all('bill').one('listall').get(obj);
    };

    /**
     * storeSingleBill
     * @param obj
     */
    vm.storeSingleBill = function (bill) {
      return Restangular.all('bill').one('createsingle').customPOST(bill);
    };

    /**
     * storeRecurrenceBill
     * @param obj
     */
    vm.storeRecurrenceBill = function (bill) {
      return Restangular.all('bill').one('createrecurrence').customPOST(bill);
    };

    /**
     * storeFreeInstalment
     * @param obj
     */
    vm.storeFreeInstalment = function (bill) {
      return Restangular.all('bill').one('createfreeinstallment').customPOST(bill);
    };

    /**
     * deleteBill
     * @param obj
     */
    vm.deleteBill = function (obj) {
      return Restangular.one('bill').all('billdelete').post(obj);
    };

    vm.deleteMultipleBill = function (obj) {
      return Restangular.one('bill').all('billdeletemultiple').post(obj);
    };

    vm.changeStatusMultipleBills = function (obj) {
      return Restangular.one('bill').all('changestatusmultiple').post(obj);
    };

    vm.changeStatusOfBill = function (obj) {
      return Restangular.all('bill').one('changestatus').customPOST(obj);
    };

    /**
     * updateSingleBill
     * @param obj
     */
    vm.updateSingleBill = function (bill) {
      return Restangular.all('bill').one('updatesingle', bill.id).customPUT(bill);
    };

    /**
     * updateRecurrenceBill
     * @param obj
     */
    vm.updateRecurrenceBill = function (bill) {
      return Restangular.all('bill').one('updaterecurrencebill', bill.id).customPUT(bill);
    };

    /**
     * updateFreeInstalment
     * @param obj
     */
    vm.updateAllSerie = function (bill) {
      return Restangular.all('bill').one('updateallserie', bill.id).customPUT(bill);
    };

    /**
     * getCategories
     * @param type
     */
    vm.getCategories = function (type) {
      return Restangular.all('bill').one('getcategoriesbytype', type).get();
    };

    /**
     * getAllPersons
     */
    vm.getAllPersons = function () {
      return Restangular.all('bill').one('getallpersons').get();
    };

    /**
     * Retorna os tipos de status para filtragem
     * @returns {[*,*,*,*,*,*,*,*,*]}
     */
    vm.getFilterStatus = function () {
      return [
        {id: 90, name: 'Vencidos', status: 'VENCIDO'},
        {id: 91, name: 'A Vencer', status: 'A_VENCER'},
        {id: 92, name: 'Vencem Hoje', status: 'VENCE_HOJE'},
        {id: 2, name: 'Cancelados', status: 'CANCELADO'},
        {id: 3, name: 'Dispensados', status: 'DISPENSADO'},
        {id: 4, name: 'Negociados', status: 'NEGOCIADO'},
        {id: 5, name: 'Duvidosos', status: 'DUVIDOSO'},
        {id: 6, name: 'Prejuizos', status: 'PREJUIZO'},
        {id: 10, name: 'Pagos', status: 'PARCIALY_PAID'},
        {id: 12, name: 'Pagos Parcialmente', status: 'PAID_OUT'},
      ]
    };

    return vm;
  }

  angular.module('app.finance.bill-expense')
    .factory('BillExpenseService', BillExpenseService);


})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.bill-expense', {
        url: '/bill-expense',
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/bill-expense/views/index.html',
            controller: 'BillExpenseController',
            controllerAs: 'vm'
          },
          'contract@private.finance.bill-expense': {
            controller: 'ContractExpenseController',
            controllerAs: 'vm',
            templateUrl: 'app/finance/bill-expense/contract/contract.html'
          }
        }
      });

  }

  angular
    .module('app.finance.bill-expense')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'ctspag_menu';
    var path = 'finance.bill-expense';
    msNavigationService.saveItem('finance.bill-expense', {
      title: 'A Pagar',
      icon: 'icon-debug-step-out',
      state: 'private.finance.bill-expense',
      weight: 5,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.finance.bill-expense')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function BillExpenseEditController(BillExpenseService, SideExtra, $rootScope,
                                     PersonService, BillReceiptService, a4Moment,
                                     Common, $a4Sidenav, $timeout) {

    var vm = this;

    vm.searchText = '';

    vm.debit_credit = 'D';
    vm.filter_date = null;
    vm.persons = [];
    vm.all_bills = [];
    vm.currentItems = [];
    vm.categories = [];
    vm.selected_status = [];
    vm.currentItem = {};
    vm.currentItem.was_paid = 1;
    vm.currentItem.end_of_recurrence = 0;

    vm.frequency_options = [
      {id: 1, name: 'Dia(s)', value: 'day'},
      {id: 2, name: 'Mês(s)', value: 'month'},
      {id: 3, name: 'Ano(s)', value: 'year'},
      {id: 4, name: 'Livre', value: false}
    ];

    vm.status = [
      {id: 4, name: 'A vencer', status: 'a_vencer'},
      {id: 5, name: 'Vencem Hoje', status: 'vence_hoje'},
      {id: 2, name: 'Vencidos', status: 'vencido'},
      {id: 10, name: 'Pagos', status: 'pago'},
      {id: 3, name: 'Cancelados', status: 'cancelado'},
      {id: 6, name: 'Dispensados', status: 'dispensado'},
      {id: 7, name: 'Negociados', status: 'negociado'},
      {id: 8, name: 'Duvidosos', status: 'duvidoso'},
      {id: 9, name: 'Prejuizos', status: 'prejuizo'}
    ];

    vm.payment_method = [
      {id: 1, name: "Dinheiro"},
      {id: 2, name: "Cheque(s)"},
      {id: 10, name: "Boleto"},
      {id: 11, name: "Depósito"},
      {id: 12, name: "Transferência"},
      {id: 15, name: "Pix"},
      {id: 20, name: "Cartão de débito"},
      {id: 21, name: "Cartão de crédito"},
      {id: 22, name: "Débito automático"}
    ];

    /** init
     */
    vm.init = function () {
      vm.getCategories();
      vm.getRangeOfYears();
      vm.getRangeOfMonths();
      vm.getBillById(SideExtra.bill.id, SideExtra.bill.edit_expense);
    };

    /**
     * Faz o request para a API e retorna a despesa por id
     * @param id - identificador do titulo
     * @param edit_expense - identificador do titulo
     */
    vm.getBillById = function (id, edit_expense) {
      BillReceiptService.getBillById(id, {'edit_expense': edit_expense})
        .then(function (response) {
          vm.currentItem = response.plain();

          vm.currentItem.amount = vm.currentItem.amount !== null ? parseFloat(vm.currentItem.amount) : vm.currentItem.amount;
          vm.currentItem.issue_date = vm.currentItem.issue_date !== null ? a4Moment(response.issue_date) : vm.currentItem.issue_date;

          if (vm.currentItem.due_date !== null) {
            vm.currentItem.due_date = a4Moment(response.due_date);
            vm.currentItem.issue_date = a4Moment(response.due_date);
          }

          if (vm.currentItem.payment_installments !== undefined) {
            vm.currentItem.hasPaid = vm.getIfInstallmentHasOnePaid(vm.currentItem.payment_installments);
          }

          if (vm.currentItem !== undefined) {

            if (vm.currentItem.next_adjustment_date) {
              vm.currentItem.next_adjustment_date = a4Moment(vm.currentItem.next_adjustment_date);
            }

            if (vm.currentItem.date_end) {
              vm.currentItem.end_of_recurrence = 1;
              vm.currentItem.date_end = a4Moment(vm.currentItem.date_end);
            }

            if (vm.currentItem.date_first) {
              vm.currentItem.date_first = a4Moment(vm.currentItem.date_first);
            }

            if (vm.currentItem.quantity > 0) {
              vm.currentItem.end_of_recurrence = 0;
            }

            if (angular.isArray(vm.currentItem.discounts_rules) && vm.currentItem.discounts_rules.length > 0) {
              vm.currentItem.discounts_rules.forEach(function (value) {
                value.end_date = a4Moment(value.end_date);
                value.start_date = a4Moment(value.start_date);
              })
            }

            if (vm.currentItem.tags !== null && vm.currentItem.tags.length > 0) {
              vm.currentItem.tags = vm.currentItem.tags.filter(function (item, i, ar) {
                return ar.indexOf(item) === i;
              });
            }

            vm.currentItem.frequency = response.frequency;
            vm.currentItem.frequency_qty = response.frequency_qty;
            vm.currentItem.frequency_type = response.frequency_type;
          }
          $rootScope.show_loader = false;
        });
    };

    /**
     * Verifica se algum installments está pago.
     * @param payment_installments - Lista de parcelas.
     * @returns {boolean}
     */
    vm.getIfInstallmentHasOnePaid = function (payment_installments) {
      for (var i = 0, len = payment_installments.length; i < len; i++) {
        if (payment_installments[i].status == 1) {
          return true
        }
      }
    };

    /**
     * getCategories
     * Retorna todas as categorias possiveis para um titulo
     */
    vm.getCategories = function () {
      BillExpenseService.getCategories(vm.debit_credit)
        .then(function (response) {
          vm.categories = response.plain();
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * Retorna a lista de pessoas filtrada pela consulta para o auto complete
     * @param query - nome pesquisado
     * @returns {Void}
     */
    vm.listAllPersons = function (query) {
      return PersonService.listAll({query: query});
    };

    /**
     * submit
     * @param currentItem
     */
    vm.submit = function (currentItem) {
      switch (parseInt(currentItem.was_paid)) {
        case(1):
          /** update single bill */
          vm.updateSingleBill(currentItem);
          break;
        case(2):
          /** update recurrence */
          /** update pelo tipo de recorrencia */
          switch (parseInt(currentItem.edit_expense)) {
            case 1 || 0:
              vm.updateSingleBill(currentItem);
              break;
            case 2:
              vm.updateRecurrenceBill(currentItem);
              break;
            case 3:
              vm.updateAllSerie(currentItem);
              break;
          }
          break;
        case(3):
          /** update installments */
          vm.updateAllSerie(currentItem);
          break;
      }
    };

    /**
     * updateSingleBill
     * @param currentItem
     */
    vm.updateSingleBill = function (currentItem) {
      BillExpenseService.updateSingleBill(currentItem)
        .then(function (response) {
          if (response && response.result) {
            vm.closeSideBar('Pagamento editado com sucesso!');
          } else {
            Common.Toast.error('Erro ao editar esse pagamento.');
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * updateRecurrenceBill
     * @param currentItem
     */
    vm.updateRecurrenceBill = function (currentItem) {
      BillExpenseService.updateRecurrenceBill(currentItem)
        .then(function (response) {
          if (response && response.result) {
            vm.closeSideBar('Recorrência editada com sucesso!');
          } else {
            Common.Toast.error('Erro ao editar essa recorrência.');
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * updateAllSerie
     * @param currentItem
     */
    vm.updateAllSerie = function (currentItem) {
      /** Se houver diferença entre o valor atual do titulo e a referência ao mesmo ID no grid de parcelas */
      currentItem.payment_installments = vm.updateAmountOfList(currentItem);
      BillExpenseService.updateAllSerie(currentItem)
        .then(function (response) {
          if (response && response.result) {
            vm.closeSideBar('Parcelamento editado com sucesso!');
          } else {
            Common.Toast.error('Erro ao editar esse parcelamento.');
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    /**
     * closeEditSideBar
     */
    vm.closeSideBar = function (msg) {
      vm.filter_date = null;
      if (!angular.isUndefined(msg)) {
        Common.Toast.success(msg);
      }
      $a4Sidenav().close();
      //vm.getAll();
    };

    /**
     * getRangeOfYear
     * Range de anos para o select de 'mais detalhes'
     */
    vm.getRangeOfYears = function () {
      var result = 2010;
      var arr = [];
      while (result <= 2027) {
        arr.push(result);
        result++;
      }
      vm.range_of_year = arr;
    };

    /**
     * getRangeOfMonths
     * Range de meses para o select de 'mais detalhes'
     */
    vm.getRangeOfMonths = function () {
      var arr = [];
      var months = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
      ];

      for (var i = 0; i < 12; i++) {
        var label = (i < 9) ? '0' + (i + 1) : (i + 1);
        var name = label + '  |  ' + months[i];
        arr.push({'name': name, 'value': (i + 1)});
      }

      vm.range_of_months = arr;
    };

    /**
     *  @param id
     */
    vm.frequencyOptions = function (id) {
      angular.forEach(vm.frequency_options, function (item, i) {
        if (item.id === id) {
          vm.currentItem.frequency_option_name = item.value;
        }

        vm.disabled = (vm.currentItem.frequency !== 4);
      });
    };

    /**
     * apiErrorMessageByStatusCode
     * Toast error com mensagens baseada no statusCode da api
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista.');
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor.');
          break;
      }
    };

    /**
     * @param value
     */
    vm.tabChange = function (value) {
      $timeout(function () {
        vm.selectedTab = (value === 1) ? 0 : vm.selectedTab;
        vm.selectedTab = (value === 2) ? 2 : vm.selectedTab;
      }, 300);
    };

    vm.init();

  }

  angular
    .module('app.finance.bill-expense')
    .controller('BillExpenseEditController', BillExpenseEditController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function BillExpenseCreateController($a4Sidenav, BillExpenseService, Common, PersonService, $timeout, a4Moment, $rootScope) {

    var vm = this;
    vm.searchText = '';
    vm.debit_credit = 'D';
    vm.filter_date = null;
    vm.persons = [];
    vm.all_bills = [];
    vm.bills = [];
    vm.categories = [];
    vm.selected_status = [];
    vm.currentItem = {};
    vm.currentItem.was_paid = 1;
    vm.currentItem.end_of_recurrence = 0;
    vm.currentItem.recurrency_on_value = 0;
    vm.currentItem.issue_date = a4Moment();

    vm.frequency_options = [
      {id: 1, name: 'Dia(s)', value: 'day'},
      {id: 2, name: 'Mês(s)', value: 'month'},
      {id: 3, name: 'Ano(s)', value: 'year'},
      {id: 4, name: 'Livre', value: false}
    ];

    vm.status = [
      {id: 4, name: 'A vencer', status: 'a_vencer'},
      {id: 5, name: 'Vencem Hoje', status: 'vence_hoje'},
      {id: 2, name: 'Vencidos', status: 'vencido'},
      {id: 10, name: 'Pagos', status: 'pago'},
      {id: 3, name: 'Cancelados', status: 'cancelado'},
      {id: 6, name: 'Dispensados', status: 'dispensado'},
      {id: 7, name: 'Negociados', status: 'negociado'},
      {id: 8, name: 'Duvidosos', status: 'duvidoso'},
      {id: 9, name: 'Prejuizos', status: 'prejuizo'}
    ];

    vm.payment_method = [
      {id: 1, name: "Dinheiro"},
      {id: 2, name: "Cheque(s)"},
      {id: 10, name: "Boleto"},
      {id: 11, name: "Depósito"},
      {id: 12, name: "Transferência"},
      {id: 15, name: "Pix"},
      {id: 20, name: "Cartão de débito"},
      {id: 21, name: "Cartão de crédito"},
      {id: 22, name: "Débito automático"}
    ];

    /**
     * init
     */
    vm.init = function () {
      vm.getCategories();
      vm.getRangeOfYears();
      vm.getRangeOfMonths();
      vm.getAllPersons();
    };

    /**
     * getCategories
     * Retorna todas as categorias possiveis para um titulo
     */
    vm.getCategories = function () {
      $rootScope.show_loader = true;
      BillExpenseService.getCategories(vm.debit_credit)
        .then(function (response) {
          vm.categories = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });
    };

    /**
     * apiErrorMessageByStatusCode
     * Toast error com mensagens baseada no statusCode da api
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista.');
          break;
        case 500:
          /*Common.Toast.error('Não foi possivel comunicar com o servidor.');*/
          break;
      }
    };


    /**
     * getAllPersons
     * Retorna todos os persons
     */
    vm.getAllPersons = function () {
      $rootScope.show_loader = true;
      BillExpenseService.getAllPersons()
        .then(function (response) {
          if (response) {
            vm.persons = response.plain();
          }
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna a lista de pessoas filtrada pela consulta para o auto complete
     * @param query - nome pesquisado
     * @returns {Void}
     */
    vm.listAllPersons = function (query) {
      return PersonService.listAll({query: query});
    };


    /**
     * getRangeOfYear
     * Range de anos para o select de 'mais detalhes'
     */
    vm.getRangeOfYears = function () {
      var result = 2010;
      var arr = [];
      while (result <= 2027) {
        arr.push(result);
        result++;
      }
      vm.range_of_year = arr;
    };

    /**
     * getRangeOfMonths
     * Range de meses para o select de 'mais detalhes'
     */
    vm.getRangeOfMonths = function () {
      var arr = [];
      var months = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
      ];

      for (var i = 0; i < 12; i++) {
        var label = (i < 9) ? '0' + (i + 1) : (i + 1);
        var name = label + '  |  ' + months[i];
        arr.push({'name': name, 'value': (i + 1)});
      }

      vm.range_of_months = arr;
    };

    /**
     *
     * @param currentItem
     */
    vm.submit = function (currentItem) {
      /** create */
      if (!currentItem.hasOwnProperty('id')) {
        currentItem.debit_credit = vm.debit_credit;
        switch (parseInt(currentItem.was_paid)) {
          case(1):
            /** create single bill */
            vm.storeSingleBill(currentItem);
            break;
          case(2):
            /** create recurrence */
            vm.storeRecurrenceBill(currentItem);
            break;
          case(3):
            /**create installments */
            vm.storeFreeInstalment(currentItem);
            break;
        }
      }
    };

    /**
     * storeSingleBill
     * @param currentItem
     */
    vm.storeSingleBill = function (currentItem) {
      $rootScope.show_loader = true;
      /** create single bill */
      BillExpenseService.storeSingleBill(currentItem)
        .then(function (response) {
          if (response) {
            vm.closeSideBar('Pagamento criado com sucesso!');
            $rootScope.show_loader = false;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });
    };

    /**
     * storeRecurrenceBill
     * @param currentItem
     */
    vm.storeRecurrenceBill = function (currentItem) {
      $rootScope.show_loader = true;
      // recurrence
      BillExpenseService.storeRecurrenceBill(currentItem)
        .then(function (response) {
          if (response) {
            vm.closeSideBar('Recorrência criada com sucesso!');
            $rootScope.show_loader = false;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });
    };

    /**
     * @param value
     */
    vm.tabChange = function (value) {
      $timeout(function () {
        vm.selectedTab = (parseInt(value) === 1) ? 0 : vm.selectedTab;
        vm.selectedTab = (parseInt(value) === 2) ? 2 : vm.selectedTab;
      }, 300);
    };

    /**
     * storeFreeInstalment
     * @param currentItem
     */
    vm.storeFreeInstalment = function (currentItem) {
      $rootScope.show_loader = true;
      // installments
      BillExpenseService.storeFreeInstalment(currentItem)
        .then(function (response) {
          if (response) {
            vm.closeSideBar('Parcela livre criada com sucesso!');
            $rootScope.show_loader = false;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });
    };

    /**
     * updateAmountOfList
     * se houver diferença entre o valor atual do titulo e a referência ao mesmo ID no grid de parcelas
     * @param currentItem
     * @returns {Array}
     */
    vm.updateAmountOfList = function (currentItem) {
      var arr = [];
      angular.forEach(currentItem.payment_installments, function (item, i) {
        if (currentItem.id === item.bill_id && currentItem.amount !== item.amount) {
          item.amount = currentItem.amount;
        }
        arr.push(item);
      });
      return arr;
    };

    /**
     * Valida se o valor total das parcelas é igual ao valor da despesa
     * Só executa essa validacao em caso de despesa parcelada e recorrencia com vencimentos variaveis
     * @param currentItem
     * @returns {boolean}
     */
    vm.installmentsIsValid = function (currentItem) {
      if (currentItem.was_paid === 3 || (currentItem.was_paid === 2 && currentItem.frequency_type === 1)) {
        var result = false;
        var sum = 0;

        angular.forEach(currentItem.payment_installments, function (item) {
          if (item.amount !== '') {
            item.amount = item.amount == null ? 0 : parseFloat(item.amount);
            sum = (sum + parseFloat(item.amount.toFixed(2)));
          }
        });

        result = (currentItem.amount === sum.toFixed(2));

        if (!result) {
          Common.Toast.warning('O valor total das parcelas é diferente do valor da despesa.');
        }

        return result;
      } else {
        return true;
      }
    };

    /**
     * Template by was_paid
     */
    vm.changeWasPaid = function () {

      var tmp = vm.currentItem;

      if (vm.currentItem.was_paid === 1) {
        // single bill

        vm.activate_recurrence = false;
        vm.currentItem.person_id = tmp.person_id;
        vm.currentItem.description = tmp.description;
        vm.currentItem.document_reference = tmp.document_reference;
        vm.currentItem.debit_credit = vm.debit_credit;
        vm.currentItem.tags = tmp.tags;
        vm.currentItem.files = tmp.files;
        vm.currentItem.notes = tmp.notes;
        vm.currentItem.was_paid = tmp.was_paid;
        vm.currentItem.bill_details = tmp.bill_details;
        vm.currentItem.accrual_month = tmp.accrual_month;
        vm.currentItem.accrual_year = tmp.accrual_year;
        vm.currentItem.date_first = tmp.date_first;
        vm.currentItem.issue_date = tmp.issue_date

      } else if (vm.currentItem.was_paid === 2) {

        vm.activate_recurrence = true;
        vm.currentItem.person_id = tmp.person_id;
        vm.currentItem.description = tmp.description;
        vm.currentItem.document_reference = tmp.document_reference;
        vm.currentItem.debit_credit = vm.debit_credit;
        vm.currentItem.files = tmp.files;
        vm.currentItem.was_paid = tmp.was_paid;
        vm.currentItem.accrual_month = tmp.accrual_month;
        vm.currentItem.accrual_year = tmp.accrual_year;
        vm.currentItem.date_first = tmp.date_first;
        vm.currentItem.issue_date = tmp.issue_date;
        vm.currentItem.frequency_type = 0;
        vm.currentItem.frequency_qty = 1;
        vm.currentItem.end_of_recurrence = 0;
        vm.currentItem.frequency = 2;
        vm.currentItem.discounts_rules = tmp.discounts_rules;
        vm.currentItem.accrual_date_type = tmp.accrual_date_type;
        vm.currentItem.payment_installments = tmp.payment_installments;
        vm.currentItem.date_end = tmp.date_end;
        vm.currentItem.recurrency_on_value = 0;

      } else if (vm.currentItem.was_paid === 3) {
        vm.activate_recurrence = false;
        vm.currentItem.person_id = tmp.person_id;
        vm.currentItem.description = tmp.description;
        vm.currentItem.document_reference = tmp.document_reference;
        vm.currentItem.debit_credit = vm.debit_credit;
        vm.currentItem.tags = tmp.tags;
        vm.currentItem.files = tmp.files;
        vm.currentItem.was_paid = tmp.was_paid;
        vm.currentItem.bill_details = tmp.bill_details;
        vm.currentItem.accrual_month = tmp.accrual_month;
        vm.currentItem.accrual_year = tmp.accrual_year;
        vm.currentItem.date_first = tmp.date_first;
        vm.currentItem.issue_date = tmp.issue_date;
        vm.currentItem.payment_installments = tmp.payment_installments;
        vm.currentItem.quantity = 1;
      }

    };


    /**
     * closeEditSideBar
     */
    vm.closeSideBar = function (msg) {
      vm.filter_date = null;
      if (!angular.isUndefined(msg)) {
        Common.Toast.success(msg);
      }

      $a4Sidenav().close()
        .then(function () {
          $rootScope.$broadcast("DO_PAGINATE");
        });


    };


    vm.init();

  }

  angular
    .module('app.finance.bill-expense')
    .controller('BillExpenseCreateController', BillExpenseCreateController);

})
();


(function () {
  'use strict';

  /** @ngInject */
  function BillExpenseController(PoliciesService, $scope, $a4Sidenav, $a4FloatButton, ModalFactory, $rootScope,
                                 $mdDialog, $timeout, a4Moment, Common, BillExpenseService, $filter, BillReceiptService) {

    var vm = this;
    vm.filter_date = {
      startDate: a4Moment().startOf('year').format('YYYY-MM-DD'),
      endDate: a4Moment().endOf('month').format('YYYY-MM-DD')
    };
    vm.tableItemsSelected = [];
    vm.date = null;
    vm.current_page = 0;
    vm.selected_status = [];
    vm.statusDefined = [90, 91];
    vm.show_button_more = true;
    /** Contador da página, para ser utilizado no infinite scroll */
    vm.contPag = 1;
    vm.selected_tab = null;
    vm.bills = {};
    vm.search = null;
    vm.ExpenseService = BillExpenseService;


    /** Variável para avisar quando não existem mais dados para serem carregados em tela */
    vm.hasDataToLoad = true;

    /**
     * init
     */
    vm.init = function () {
      vm.status_filter = BillExpenseService.getFilterStatus();
      vm.disabled = true;
      vm.getAll(vm.current_page, 20, null, null, null, undefined, 'desc');
    };

    var lt1 = $rootScope.$on("DO_PAGINATE", function () {
      vm.getAll(1);
    });

    /**
     * Retorna todos os titulos para pagamentos
     */
    vm.getAll = function (page, qtd, date, person_id, status, flag, order) {
      /** Só faz o request caso o último não tenha retornado um array vazio ou tenha status selecionado. */
      vm.show_button_more = true;
      $rootScope.show_loader = true;
      vm.show_loader = true;
      vm.current_page++;
      qtd = angular.isUndefined(qtd) ? 30 : qtd;
      status = angular.isUndefined(status) ? null : status;
      person_id = angular.isUndefined(person_id) ? person_id : null;
      date = date == null ? {startDate: null, endDate: null} : date;
      flag = !angular.isUndefined(flag);

      vm.infiniteScrollFormat(flag, status, date);

      var obj = {
        startDate: vm.date === null ? date.startDate : vm.date.startDate,
        endDate: vm.date === null ? date.endDate : vm.date.endDate,
        debit_credit: vm.debit_credit,
        person_id: person_id,
        page: page === 1 ? page : vm.current_page,
        qtd: page === 1 && vm.current_page !== page ? vm.current_page * 20 : 20,
        status: vm.statusDefined.length === 0 ? null : vm.statusDefined.toString(),
        direction: angular.isUndefined(order) ? 'desc' : (order.substring(0, 1) === '-' ? 'desc' : 'asc'),
        search: vm.search
      };

      return vm.promise = BillReceiptService.getAll(obj)
        .then(function (response) {
          var bills = response.plain();
          if (obj.page === 1) {
            vm.bills = bills;
          } else {
            vm.bills.data = vm.bills.data.concat(bills.data);
          }
          if (bills.data.length === 0) {
            vm.show_button_more = false;
          }
          vm.bills.order = order;
          $rootScope.show_loader = false;
          vm.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
          vm.show_loader = false;
        })
    };

    vm.infiniteScrollFormat = function (flag, status, date) {
      /** Variável para verificar se o botão de pesquisa foi clicado. Caso tenha sido, reajusta os filtros da página. */
      if (flag) {
        vm.statusDefined = [];
        flag = false;
        if (status) {
          for (var i = 0; i < status.length; i++)
            vm.statusDefined.push(status[i].id);
        }
      }

      /** Adiciona os Ids dos status selecionados em um Array */
      if (status) {
        /** Quando o filtro é desselecionado, o status vira null, e uma busca normal é realizada (sem filtros) */
        if (status.length === 0) {
          status = null;
        } else {
          for (var i = 0; i < status.length; i++)
            vm.statusDefined.push(status[i].id);
        }
      }

      if (!status) {
        status = [];
      }

      /** Persiste o filtro da data selecionado, para não perder a referência quando for chamado o infinite scroll. */
      if (date.startDate !== null) {
        vm.date = date;
      }
    };

    /**
     * Filtra despesas por data
     * @param date - date
     * @param status
     */
    vm.filterExpenses = function (date, status) {
      $rootScope.show_loader = true;
      var qtd = angular.isUndefined(vm.bills.per_page) ? 20 : vm.bills.per_page;
      var page = angular.isUndefined(vm.bills.current_page) ? 1 : vm.bills.current_page;
      var status_send = [];
      /** Filtro de status */
      if (!angular.isUndefined(status)) {
        status.forEach(function (value) {
          status_send.push(value.id);
        })
      }
      date = vm.formatDateForFilter(date);
      var obj = {
        status: status_send.toString(), startDate: date.startDate, endDate: date.endDate,
        debit_credit: vm.debit_credit, page: page, qtd: qtd
      };

      BillExpenseService.getAll(obj)
        .then(function (response) {
          if (response) {
            vm.bills = response;
          }
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
          $rootScope.show_loader = false;
        });

    };

    /**
     * Formata a data para o filtro
     * @param date
     */
    vm.formatDateForFilter = function (date) {
      if (angular.isUndefined(date)) {
        return {
          startDate: a4Moment().startOf('month').format('YYYY-MM-DD'),
          endDate: a4Moment().endOf('month').format('YYYY-MM-DD')
        };
      } else {
        return {
          startDate: a4Moment(date.startDate).format('YYYY-MM-DD'),
          endDate: a4Moment(date.endDate).format('YYYY-MM-DD')
        };
      }
    };

    /**
     * createNewBill
     * Abre sidebar com formulário de novo titulo
     */
    vm.createNewBill = function () {
      $a4Sidenav({'width': '700px'}).open('app/finance/bill-expense/views/new-form.html', 'BillExpenseCreateController', 'vm', {});
      $rootScope.show_loader = false;
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();

    $scope.$on('$destroy', function () {
      [].forEach(function (fn) {
        fn();
      })
    })

  }

  angular
    .module('app.finance.bill-expense')
    .controller('BillExpenseController', BillExpenseController);

})();

(function () {
  'use strict';

  function BillChargeBackService(Restangular) {

    /**
     * Retorna todas as contas disponíveis.
     */
    var getAllCurrentAccounts = function () {
      return Restangular.one('bill').one('getallcurrentaccounts').get();
    };

    /**
     * Retorna todos os checque de terceiros em mãos.
     */
    var getAllMovementsType = function () {
      return Restangular.one('movement').one('getallmovementtypes').get();
    };

    /**
     * Retorna as categorias pelo tipo indicado.
     */
    var getCategoriesByType = function (obj) {
      return Restangular.all('bill').one('getcategoriesbytype', obj).get();
    };

    /**
     * Retorna as categorias pelo tipo indicado.
     */
    var getRelatedExpenses = function (obj) {
      return Restangular.one('bill').one('getchangebackbills').get(obj);
    };

    /**
     * Informa os dados para desfazer a negociação.
     */
    var doChargeBack = function (obj) {
      return Restangular.one('bill').all('chargeback').post(obj);
    };

    return {
      getAllCurrentAccounts: getAllCurrentAccounts,
      getAllMovementsType: getAllMovementsType,
      getCategoriesByType: getCategoriesByType,
      getRelatedExpenses: getRelatedExpenses,
      doChargeBack: doChargeBack
    };

  }

  angular
    .module('app.finance.bill-chargeback')
    .factory('BillChargeBackService', BillChargeBackService);

})();
(function () {
  'use strict';

  /** @ngInject */
  function BillChargeBackController($scope, $state, $a4Sidenav, CONFIG, $document, ReportsService, Session,
                                    BankSlipService, BillPaymentService, Common, ModalFactory, BillChargeBackService, a4Moment, $rootScope) {

    var vm = this;
    vm.action = {};
    vm.payments = [];
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.bill = {};
    vm.changebackdate = a4Moment().format('YYYY-MM-DD');
    vm.totalAmount = 0;
    vm.hasGeneratedBillPaid = false;
    vm.toggle = {};
    vm.toggle.list = true;
    vm.show_form = false;
    vm.notes = null;
    vm.charge_back_option = 'CREDIT';
    vm.bill_option = 'OPEN';
    vm.movement_type = null;
    vm.current_account = null;

    vm.init = function () {
      vm.chargeback(vm.item);
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };


    vm.close = function () {
      $a4Sidenav().close()
    };

    /**
     * Escuta o evento "setnegotiate" com as bills selecionadas
     * Este evento é disparado quando o a sidebar de negociação é aberta
     */
    vm.chargeback = function (item) {
      vm.bill = item;
      vm.billList = angular.isArray(item) ? item : [item];
      vm.getRelatedExpenses(item.id, item.status);
    };


    /**
     * Retorna as despesas relacionadas a negociação
     * @param id
     * @param status
     */
    vm.getRelatedExpenses = function (id, status) {

      if (id != null && (status === 10 || status === 11 || status === 12 || status === 13 || status === 14)) {
        vm.show_loader = true;
        BillChargeBackService.getRelatedExpenses({bill_id: id, status: status})
          .then(function (response) {
            vm.show_form = true;
            vm.payments = response.payments;
            vm.action.billsSelected = response.bills;
            vm.totalAmount = response.total;
            vm.action_id = response.action_id;
            vm.person_id = response.person_id;
            vm.hasGeneratedBillPaid = response.has_generated_bill_paid;
            vm.show_loader = false;
          })
          .catch(function () {
            vm.show_form = true;
            Common.Toast.error('Erro ao buscar as itens relacionadas');
            vm.show_loader = false;
          });
      }
    };

    /**
     * realiza o reembolso
     */
    vm.changeBackConfimation = function () {
      var msg = 'O estorno será efetuado. Deseja realmente continuar?';
      var bill_ids = vm.action.billsSelected.map(function (item) {
        return item.id;
      });
      ModalFactory.confirm(null, 'Confirma', msg, 'Confirmar', 'Cancelar', 'finance')
        .then(function () {
          vm.show_form = false;
          BillChargeBackService.doChargeBack({
            current_account_id: vm.payments[0].current_account_id,
            changebackdate: vm.changebackdate,
            bill_ids: bill_ids.toString(),
            status: vm.bill.status,
            action_id: vm.action_id,
            notes: vm.notes,
            person_id: vm.person_id,
            charge_back_option: vm.charge_back_option,
            bill_option: vm.bill_option,
            current_account: vm.current_account,
            movement_type: vm.movement_type
          }).then(function (response) {
            vm.show_form = true;
            if (response) {
              if (vm.charge_back_option === 'CHARGE_BACK') {
                ModalFactory.custom('app/components/a4-credits-person/refund-print-checkpad.html', {}).then(function (print_checkpad) {
                  if (print_checkpad) {
                    vm.printCreditCheckpad({movement_id: response.id});
                  }
                  vm.close();
                  Common.Toast.success('Estorno realizado com sucesso');
                  $rootScope.$emit('UPDATE_BILL_LIST');
                  // $state.go($state.current, {}, {reload: true});
                });
              } else {
                vm.close();
                Common.Toast.success('Estorno realizado com sucesso');
                $rootScope.$emit('UPDATE_BILL_LIST');
                // $state.go($state.current, {}, {reload: true});
              }
            }
          }).catch(function (response) {
            vm.show_form = true;
            Common.Toast.warning(response.data.message);
            vm.validateMessages(response);
          });

        })
    };

    vm.printCreditCheckpad = function (data) {
      var href = vm.webLink + 'api/reports/creditcheckpad?token=' +
        vm.conf.token + '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        '&user_id=' + vm.conf.user_id + '&person_id=' + vm.person_id + '&movement_id=' + data.movement_id;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    /**
     * Faz a validação de todos os retornos de submit na criação de pessoa.
     * @param {type} message - Constante de messagem
     * @param {type} object - objeto criado.
     */
    vm.validateMessages = function (message) {
      switch (message) {
        case 'HAS_GENERATED_BILL_PAID': {
          Common.Toast.error('HAS_GENERATED_BILL_PAID');
          break;
        }
      }
    };


    vm.init();
  }

  angular
    .module('app.finance.bill-chargeback')
    .controller('BillChargeBackController', BillChargeBackController)
})();
(function () {
    'use strict';

    angular
      .module('app.finance.billcategory', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BillCategoryService(Restangular) {
    var vm = {};

    vm.saveOnAPI = function (form, category) {
      if (form.$valid) {
        if (category.id == null) {
          return Restangular.all('billcategory').post(category);
        }
      }
    };

    vm.updateOnAPI = function (form, category) {
      if (form.$valid) {
        if (category.id != null && category.id != "") {
          return Restangular.all('billcategory', category.id).post(category);
        }
      }
    };

    vm.getTabs = function () {
      return Restangular.one('billcategory').get();
    };

    vm.updateMovedList = function (category) {
      return Restangular.one('billcategory', category.id).customPUT(category);
    };

    vm.remove = function (id, node) {
      if (id !== null && id !== "") {
        return Restangular.one('billcategory', id).remove();
      }
    };

    vm.getAll = function (params) {
      return Restangular.one('billcategory').one('listall').get(params);
    };

    vm.getAllByType = function (debit_credit) {
      return Restangular.one('billcategory').one('getcategoriesbytype', debit_credit).get();
    };

    return vm;

  }

  angular
    .module('app.finance.billcategory')
    .factory("BillCategoryService", BillCategoryService);

})();
(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.finance.billcategory', {
        url: '/billcategory',
        templateUrl: 'app/finance/bill-category/views/index.html',
        controller: 'BillCategoryController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.finance.billcategory')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function FinanceTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      CATEGORIES_PLAIN: 'Categorias',
      CATEGORY_SUCCESS: 'Categoria salva com sucesso',
      CATEGORY_ERROR: 'Erro em categorias',
      CANT_BE_ADD_REMOVE: 'Não é possivel: Adicionar, Apagar ',
      CANT_BE_MOVE: 'Não é possivel: Mover, Alterar ',
      CLOSE_CATEGORIES: 'Fechar categorias',
      CREATE_NEW_CATEGORY: 'Criar nova categoria',
      HAVE_LAUNCH_BILL: 'Categoria pai, já tem titulos atribuidos',
      DELETE_MSG_FROM_CATEGORY: 'Deseja realmente apagar esta categoria?',
      DELETE_MSG_FROM_CATEGORY_2: 'ATENÇÃO! Todas as categorias associadas a este grupo serão eliminadas. Deseja realmente apagar?',
      DELELE_ERROR: 'Erro ao apagar.',
      DELETE_MSG_SUCCESS: 'Conta excluida.',
      DELELE_MSG_ERROR: 'Conta possui lançamentos, não pode ser excluida.',
      EDIT_CATEGORY: 'Editar Categoria',
      GROUP_CATEGORY_NOT_BE_DELETED: 'Este grupo não pode ser apagado, pois contém categorias com lançamento!',
      NAME_OF_NEW_CATEGORY: 'Nome da categoria',
      OPEN_CATEGORIES: 'Abrir Categorias'

    });

  }

  angular
    .module('app.finance')
    .config(FinanceTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
  };

  angular
    .module('app.finance.billcategory')
    .run(run);

})();





(function () {
  "use strict";

  /** @ngInject */
  function BillCategory(BillCategoryService, ModalFactory, $scope, $filter, $state, $timeout, $rootScope, Common) {

    var vm = this;
    vm.accountCategories = [];
    vm.category = {};
    vm.credit_debit_types = ['c', 'd'];
    vm.tree = [];
    vm.list = [];
    vm.curr_tab = 0;
    vm.CollapseClose = true;

    /**
     *
     * Submit de formulario e difereciação de acordo com o tipo do formulário
     * edit ou create.
     * @param form_category
     * @param category
     */
    vm.submit = function (form_category, category) {
      $rootScope.show_loader = true;
      if (form_category.$valid) {
        if (category.id === null || angular.isUndefined(category.id)) {
          if (category.name.length <= 50) {
            vm.changeLevaesPath(category, undefined);
            BillCategoryService.saveOnAPI(form_category, category)
              .then(function () {
                Common.Toast.success($filter('translate')('CATEGORY_SUCCESS'));
                $state.go($state.current.name, {}, {reload: true});
                $rootScope.show_loader = false;
              })
              .catch(function (response) {
                switch (response.messages) {
                  case 'IDENTING_LEVEL_LIMIT':
                    Common.Toast.error($filter('translate')('IDENTING_LEVEL_LIMIT'));
                    break;
                  case 'HAVE_LAUNCH_BILL':
                    Common.Toast.error($filter('translate')('HAVE_LAUNCH_BILL'));
                    break;
                  default:
                    Common.Toast.error($filter('translate')('CATEGORY_ERROR'));
                    break;
                }
                $rootScope.show_loader = false;
              });
          } else {
            Common.Toast.error($filter('translate')('ERROR_LENGTH'));
          }
        } else {
          if (category.name.length <= 30) {
            vm.changeLevaesPath(category, undefined);
            BillCategoryService.updateOnAPI(form_category, category)
              .then(function () {
                Common.Toast.success($filter('translate')('UPDATE_SUCCESS'));
                $state.go($state.current.name, {}, {reload: true});
                $rootScope.show_loader = false;
              })
              .catch(function () {
                Common.Toast.error($filter('translate')('UPDATE_ERROR'));
                $rootScope.show_loader = false;
              });
          } else {
            Common.Toast.error($filter('translate')('ERROR_LENGTH'));
          }
        }
      }
    };

    vm.treeOptions = {
      beforeDrop: function () {
        return true;
      },
      dropped: function (event) {
        var receita = 1; // referente ao id do banco de dados
        var despesa = 2; // referente ao id do banco de dados
        var mySelf = event.source.nodeScope.$modelValue;
        mySelf.identing_level = event.dest.nodesScope.depth() + 2;
        mySelf.order = event.dest.index + 1;
        vm.orderObj(event.source.nodesScope.$modelValue);
        vm.orderObj(event.dest.nodesScope.$modelValue);
        //update para a posição
        mySelf.actions = [JSON.stringify([event.source.nodeScope.$modelValue]), JSON.stringify(event.dest.nodesScope.$modelValue)];
        if (event.dest.nodesScope.$parent.$modelValue === undefined) {
          if (mySelf.debit_credit === 'D') {
            mySelf.id_parent = despesa;
          } else {
            mySelf.id_parent = receita;
          }
          BillCategoryService.updateMovedList(mySelf)
            .then(function () {
              vm.listAll(mySelf.debit_credit);
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error($filter('translate')('UPDATE_ERROR'));
              $rootScope.show_loader = false;
              return false;
            });
        } else {
          mySelf.id_parent = event.dest.nodesScope.$parent.$modelValue.id;
          mySelf.path = event.dest.nodesScope.$parent.$modelValue.path + event.dest.nodesScope.$parent.$modelValue.name + " > ";
          vm.changeLevaesPath(mySelf, event.dest.nodesScope.$parent.$modelValue);

          BillCategoryService.updateMovedList(mySelf)
            .then(function () {
              vm.listAll(mySelf.debit_credit);
            })
            .catch(function () {
              Common.Toast.error($filter('translate')('UPDATE_ERROR'));
              return false;
            });
        }
      }

    };

    /**
     * Troca o path dos pai e dos filhos
     * @param {type} no - Qual estou editando.
     * @param {type} pai - Pai do que estou editando
     * @author Artur Hayne <arturhayne@simetrianet.com.br>
     */
    vm.changeLevaesPath = function (no, pai) {
      if (pai !== undefined) {
        no.path = pai.path + pai.name + " > ";
        no.identing_level = pai.identing_level + 1;
      }
      angular.forEach(no.nodes, function (value, key) {
        vm.changeLevaesPath(value, no);
      });
    };


    /**
     * Reordena os objetos.
     * @param {type} array - Vetor com todos os objetos.
     * @author Artur Hayne <arturhayne@simetrianet.com.br>
     */
    vm.orderObj = function (array) {
      for (var i = 0; i < array.length; i++) {
        array[i].order = i + 1;
      }
    };

    /**
     * Abre o modal de Edição.
     * @param {type} $event - Escopo do controller.
     * @param {type} node - nó
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.editLeafOnTree = function ($event, node) {
      var title = $filter('translate')('EDIT_CATEGORY') + ' ' + $filter('translate')(node.name);
      ModalFactory.prompt([], title, ' ', ' ', node.name)
        .then(function (resp) {
          vm.category = node;
          vm.category.id_parent = node.id_parent;
          vm.category.debit_credit = node.debit_credit;
          vm.category.name = resp;
          vm.submit({$valid: true}, vm.category);
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };
    /**
     * Abre o modal de Criação.
     * @param {type} $event - Escopo do controller.
     * @param {type} node - nó
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.newLeafOnTree = function ($event, node) {
      var title = $filter('translate')('CREATE_NEW_CATEGORY') + ' ' + $filter('translate')('ON') + ' ' + $filter('translate')(node.name);
      ModalFactory.prompt([], title, ' ')
        .then(function (resp) {
          vm.category.id_parent = node.id;
          vm.category.debit_credit = node.debit_credit;
          vm.category.name = resp;
          vm.submit({$valid: true}, vm.category);
        });
    };

    /**
     * Faz o request para a API e deleta o registro selecionado..
     * @param {Int} node - no completo
     * @returns Void,
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.remove = function (node) {
      $rootScope.show_loader = true;
      vm.verifynodes(node)
        .then(function () {
          if (node != undefined && node.id != null && node.id != "") {
            BillCategoryService.remove(node.id, node.nodes)
              .then(function (response) {
                Common.Toast.success($filter('translate')('DELETE_SUCCESS'));
                $state.go($state.current.name, {}, {reload: true});
                $rootScope.show_loader = false;
              })
              .catch(function (response) {
                $rootScope.show_loader = false;
                switch (response.data.msg) {

                  case 'NOT_ACCEPTABLE':
                    if (response.status == 406 && response.data.object.is_not_group == undefined) {
                      Common.Toast.error($filter('translate')('GROUP_CATEGORY_NOT_BE_DELETED'));
                    }
                    if (response.data.object.is_not_group == true) {
                      Common.Toast.error($filter('translate')('CATEGORY_NOT_BE_DELETED'));
                    }
                    break;
                  case 'ID_NOT_DEFINED':
                    Common.Toast.error($filter('translate')('ID_NOT_DEFINED'));
                    break;
                }
              });
          } else {
            $rootScope.show_loader = false;
            Common.Toast.error($filter('translate')('NOT_POSSIBLE_DELETE'));
          }
        }).catch(function () {
        $rootScope.show_loader = false;
      });

    };
    /**
     * Verifica se a categoria tem nodes, se sim manda uma msg se não, manda
     * outro tipo de mensagem
     * @param {debit_credit} obj Objeto completo vindo do banco de dados com seus nodes
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {Confirm BOX}
     */
    vm.verifynodes = function (obj) {
      var data = {};
      if (obj != undefined && obj.nodes.length > 0) {
        data.msg = $filter('translate')('DELETE_MSG_FROM_CATEGORY_2');
      } else {
        data.msg = $filter('translate')('DELETE_MSG_FROM_CATEGORY');
      }
      return ModalFactory.confirm(null, 'Exclusão de categoria', data.msg, 'Confirmar', 'Cancelar', 'finance');
    };

    /**
     * Faz um request para trazer todas as categorias.
     * @returns Void,
     * @author Equipe
     */
    vm.listAll = function (debit_credit) {
      $rootScope.show_loader = true;
      vm.accountCategories = [];
      vm.list = [];
      vm.parent = [];
      BillCategoryService.getAll({debit_credit: debit_credit})
        .then(function (response) {
          vm.accountCategories = response.nodes;
          vm.list = response.nodes;
          vm.parent = response.parent;
          $scope.$applyAsync();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Fecha todas as categorias abertas
     * @returns Void,
     */
    vm.collapseAll = function () {
      $rootScope.$broadcast('angular-ui-tree:collapse-all');
    };

    /**
     * Abre todas as categorias
     * @returns Void,
     */
    vm.expandAll = function () {
      $rootScope.$broadcast('angular-ui-tree:expand-all');
    };


    vm.getCreditDebitType = function (selected) {
      return selected === 'C' ? 'Crédito' : 'Débito';
    };
    /**
     * Fornece um array com 30 numeros para a informar o dia de vencimento e o dia de fechamento
     * no formulario
     * @param {debit_credit} n - Quantidade de posições se não passado retornará null.
     * @returns {Array} - Todas as posições
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.range = function (n) {
      if (typeof n !== 'undefined' && n !== null) {
        vm.arr = [];
        for (var i = 1; i <= n; i++) {
          vm.arr.push({id: i});
        }
      } else {
        return null;
      }
    };

    /**
     * Função de controle de tab de categorias.
     * @param {type} tab - id da tab
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.changeForm = function (tab) {
      if (vm.curr_tab != tab) {
        if (tab == 1) {
          $rootScope.$broadcast('loading-a4-show');
          vm.listAll('D');
        } else {
          $rootScope.$broadcast('loading-a4-show');
          vm.listAll('C');
        }

        vm.CollapseClose = true;
        vm.curr_tab = vm.curr_tab == 1 ? 0 : 1;
      }
    };

    vm.init = function () {
      vm.listAll('C');
      vm.getTabs();
    };

    vm.getTabs = function () {
      $rootScope.show_loader = true;
      BillCategoryService.getTabs()
        .then(function (res) {
          vm.tabs = res.tabs;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Modifica botão de abrir e fechar categorias.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    vm.changeCollapse = function () {
      vm.CollapseClose = !vm.CollapseClose;
    };

    vm.init();
  }

  angular
    .module("app.finance.billcategory")
    .controller("BillCategoryController", BillCategory);
})();

(function () {
  'use strict';

  /** @ngInject */
  function BankSlipRuleService(Restangular) {
    var vm = {};
    /**
     *
     * @param {type} obj
     * @returns {$q@call;defer.promise}
     */
    vm.getAllBankSlipRules = function (obj) {
      return Restangular.one("banksliprule").one('getAll').get(obj);
    };

    /**
     * Faz requisição para criação da regra de acrecimos.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    vm.createbankslipRules = function (obj) {
      return Restangular.all("banksliprule").post(obj);
    };

    /**
     * Retorna todas as contas correntes bancárias.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    vm.getBankAccounts = function () {
      return Restangular.one("banksliprule").all('getbankcurrentaccounts').getList();
    };

    vm.setIsInactive = function (obj) {
      return Restangular.one('banksliprule').all('setisinactive').post(obj);
    };

    /**
     * Faz requisição para atualização da regra de ajuste.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    vm.updatebankslipRules = function (obj) {
      return Restangular.one("banksliprule", obj.id).customPUT(obj);
    };

    return vm;
  }

  angular.module('app.finance.banksliprule')
    .factory('BankSlipRuleService', BankSlipRuleService);
})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.banksliprule', {
        url: '/settings/banksliprule',
        public: false,
        templateUrl: 'app/finance/bank-slip-rule/views/index.html',
        controller: 'BankSlipRuleController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Regras de Boleto'
        }
      });
  }

  angular
    .module('app.finance.banksliprule')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function BankSlipRule($rootScope, $scope, $a4FloatButton, $a4Sidenav, $mdMenu, BankSlipRuleService, Common, ModalFactory) {
    var vm = this;
    vm.show_inactive_rules = false;

    vm.allRules = [];
    vm.allAccounts = [];

    var ltn = $rootScope.$on('BANK_SLIP_RULE.update.list', function () {
      vm.getAllBankSlipRules();
    });

    vm.init = function () {
      vm.getAllBankSlipRules();
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.openAside()',
        theme: 'finance', icon: 'plus', label: 'Criar nova regra de boleto'
      });
    };

    /**
     * Abre a sidebar.
     */
    vm.openAside = function (data) {
      if (angular.isUndefined(data)) {
        data = {formCreate: true, editable: true};
      } else {
        data.formCreate = false;
        data.editable = false;
      }
      $a4Sidenav({width: '800px'})
        .open('app/finance/bank-slip-rule/views/sidenavs/sidenav.html', 'BankSlipRuleCreateEditController', 'vm', data);
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    /**
     * Define regra como ativa ou inativa
     * @param rule
     * @param option
     */
    vm.setIsInactive = function (rule, option) {
      var title = option === true ? "Confirmar desativação" : "Confirmar ativação";
      var text = option === true ? "Deseja realmente desativar esta regra de boleto?" : "Deseja realmente ativar esta regra de boleto?";
      ModalFactory.confirm(null, title,
        text,
        'Confirmar', 'Cancelar', 'finance').then(function () {
        $rootScope.show_loader = true;
        BankSlipRuleService.setIsInactive({is_inactive: option, bank_slip_rule_id: rule.id}).then(function () {
          Common.Toast.success('Regra alterada com sucesso!');
          vm.getAllBankSlipRules();
        })
      })
    };


    vm.getAllBankSlipRules = function () {
      $rootScope.show_loader = true;
      vm.allRules = [];
      BankSlipRuleService.getAllBankSlipRules({show_inactive_rules: vm.show_inactive_rules})
        .then(function (response) {
          vm.allRules = response;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (ln) {
        ln();
      });
      if (angular.isDefined(vm.floatButton)) {
        vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      }
    });

    vm.init();
  }

  angular.module('app.finance.banksliprule')
    .controller('BankSlipRuleController', BankSlipRule);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BankSlipRuleCreateEditController($scope, $rootScope, Common, BankSlipRuleService, SideExtra, $a4Sidenav) {

    var vm = this;
    vm.bank_slip_rule = {
      is_inactive: false,
      default_detail_method: 1,
      is_show_details: false,
      is_aggregate_bills: false,
      is_aggregate_beneficiaries: true,
      permanence_type: 2,
      permanence_days: null,
      permanence_limit_date: null
    };
    vm.bank_slip_rule = angular.extend(vm.bank_slip_rule, SideExtra);
    vm.editable = angular.isDefined(SideExtra.editable) ? SideExtra.editable : false;
    vm.formCreate = angular.isDefined(SideExtra.formCreate) ? SideExtra.formCreate : false;

    vm.init = function () {
      vm.bank_slip_rule.is_inactive =
        (angular.isUndefined(vm.bank_slip_rule.is_inactive) || vm.bank_slip_rule.is_inactive == null) ? false : vm.bank_slip_rule.is_inactive;
      vm.getBankAccounts();
    };

    /**
     * Fecha slide
     */
    vm.close = function () {
      $a4Sidenav().close();
    };

    /**
     * Lista de contas
     */
    vm.getBankAccounts = function () {
      $rootScope.show_loader = true;
      BankSlipRuleService.getBankAccounts()
        .then(function (response) {
          vm.accounts = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Cria e edita regra de boletos
     * @param bankSlipRule
     * @param form
     */
    vm.submit = function (bankSlipRule, form) {
      if (form.$valid) {
        $rootScope.show_loader = true;
        if (bankSlipRule.name !== '' && bankSlipRule.name !== undefined) {
          if (bankSlipRule.current_account_id !== '' && bankSlipRule.current_account_id !== undefined) {
            if (bankSlipRule.id === undefined || bankSlipRule.id == null) {

              bankSlipRule.is_show_details = (bankSlipRule.is_show_details === undefined) ? false : bankSlipRule.is_show_details;
              bankSlipRule.is_inactive = (bankSlipRule.is_inactive === undefined) ? false : bankSlipRule.is_inactive;

              BankSlipRuleService.createbankslipRules(bankSlipRule)
                .then(function () {
                  Common.Toast.success("Regra adicionada com sucesso");
                  $rootScope.show_loader = false;
                  vm.close();
                  $rootScope.$broadcast('BANK_SLIP_RULE.update.list');
                })
                .catch(function (error) {
                  Common.Toast.error(error.data.message);
                  $rootScope.show_loader = false;
                });
            } else {
              BankSlipRuleService.updatebankslipRules(bankSlipRule)
                .then(function () {
                  Common.Toast.success("Regra atualizada com sucesso");
                  $rootScope.show_loader = false;
                  vm.close();
                  $rootScope.$broadcast('BANK_SLIP_RULE.update.list');
                })
                .catch(function () {
                  Common.Toast.error('Erro ao executar essa ação.');
                  $rootScope.show_loader = false;
                });
            }
          } else {
            Common.Toast.error("Conta corrente é obrigatório");
          }
        } else {
          Common.Toast.error("Nome é obrigatório");
        }
      }
    };

    /**
     *
     */
    vm.isEditable = function () {
      vm.editable = !vm.editable;
    };

    vm.init();

  }

  angular
    .module('app.finance.banksliprule')
    .controller('BankSlipRuleCreateEditController', BankSlipRuleCreateEditController);
})();
(function () {
  'use strict';

  function BankSlipService($http, Restangular, a4Moment, CONFIG, Common) {

    /**
     * Retorna todos os boletos
     * @returns {array}
     * @param obj
     */
    var getAllBankSlip = function (obj) {
      return Restangular.one('bankslip').one('getAll').get(obj);
    };

    var getBankSlipsForExternalFinancialStatement = function (obj) {
      return Restangular.one('bankslip').one('getbankslipsforexternalfinancialstatement').get(obj);
    };

    /**
     * Verifica a existencia de uma conta a4pag valida
     * @returns {array}
     * @param obj
     */
    var hasA4PagAccount = function (obj) {
      return Restangular.one('bankslip').one('hasa4pagaccount').get(obj);
    };

    /**
     * Retorna todas as contas
     * @returns {array}
     */
    var getAllCurrentAccounts = function () {
      return Restangular.all('currentaccount/listall').getList();
    };

    var listBillingAccounts = function () {
      return Restangular.all('/currentaccount/listbillingaccounts').getList();
    };

    /**
     * Retorna todas as contas correntes bancárias.
     * @returns {array}
     */
    var getBankAccount = function () {
      return Restangular.all('banksliprule/getbankcurrentaccounts').getList();
    };

    /**
     * Retorna todas as regras de boleto
     * @returns {array}
     */
    var getAllBankSlipRule = function () {
      return Restangular.all('banksliprule/getAll').getList();
    };

    var getBankSlipRuleUsedByPeriod = function (obj) {
      return Restangular.one('banksliprule').one('usedrules').get(obj);
    };

    var getBankSlipsForSelection = function (obj) {
      return Restangular.one('bankslip').one('getbankslipforselection').get(obj);
    };

    var createBankFileSend = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/bankslip/createbankfilesend',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];

        var linkElement = document.createElement('a');
        try {
          if (obj.type == 0 || obj.type == 3) {
            var blob = new Blob([data], {type: contentType});
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            var filename = 'boletos' + a4Moment().format('DD/MM/YYYY') + '.pdf';
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": true
            });
            linkElement.dispatchEvent(clickEvent);
          }
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }).catch(function (response) {
        var decoder = new TextDecoder("utf-8");
        var domString = decoder.decode(response.data);
        var json = angular.fromJson(domString);
        deffered.reject(json);
      });

      return deffered.promise;
    };

    /**
     * Envia todos os boletos
     * @param obj
     * @returns {array}
     */
    var sendAllBoletos = function (obj) {
      return Restangular.all('bankslip/generate/print').customPOST(obj);
    };

    /**
     * Envia email para os titulos selecionados
     * @param list
     * @returns {*}
     */
    var sendMail = function (list) {
      return Restangular.all('fichafinanceiracliente').customPOST({list: list});
    };

    /**
     * Criação de boleto em grupo
     * @returns {*}
     * @param obj
     */
    var cluster = function (obj) {

      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/bankslip/cluster',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];

        var linkElement = document.createElement('a');
        try {
          if (obj.type == 0 || obj.type == 3) {
            var blob = new Blob([data], {type: contentType});
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            var filename = 'boletos' + a4Moment().format('DD/MM/YYYY') + '.pdf';
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": true
            });
            linkElement.dispatchEvent(clickEvent);
          }
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }).catch(function (response) {
        var decoder = new TextDecoder("utf-8");
        var domString = decoder.decode(response.data);
        var json = angular.fromJson(domString);
        deffered.reject(json);
      });

      return deffered.promise;
    };

    var getBankSlipsPendingRegisterA4Pag = function () {
      return Restangular.one('bankslip').one('bankslipspendingregistera4pag').get();
    };

    return {
      getAllBankSlip: getAllBankSlip,
      getBankSlipsForExternalFinancialStatement: getBankSlipsForExternalFinancialStatement,
      getAllCurrentAccounts: getAllCurrentAccounts,
      getBankAccount: getBankAccount,
      getAllBankSlipRule: getAllBankSlipRule,
      sendAllBoletos: sendAllBoletos,
      sendMail: sendMail,
      cluster: cluster,
      createBankFileSend: createBankFileSend,
      hasA4PagAccount: hasA4PagAccount,
      getBankSlipsForSelection: getBankSlipsForSelection,
      getBankSlipRuleUsedByPeriod: getBankSlipRuleUsedByPeriod,
      getBankSlipsPendingRegisterA4Pag: getBankSlipsPendingRegisterA4Pag,
      listBillingAccounts: listBillingAccounts
    };

  };

  angular
    .module('app.finance.bankslip')
    .factory('BankSlipService', BankSlipService);

})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.bankslip', {
        url: '/bankslip',
        public: false,
        views: {
          '': {
            templateUrl: 'app/finance/bank-slip/views/index.html',
            controller: 'BankSlipController',
            controllerAs: 'vm'
          },
          'bank-file-send@private.finance.bankslip': {
            templateUrl: 'app/finance/bank-file-send/views/index.html',
            controller: 'BankFileSendController',
            controllerAs: 'vm'
          },
          'bank-file-receive@private.finance.bankslip': {
            templateUrl: 'app/finance/bank-file-receive/views/index.html',
            controller: 'BankFileReceiveController',
            controllerAs: 'vm'
          }
        }
      });
  };

  angular
    .module('app.finance.bankslip')
    .config(routerConfig);

})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {

    var role_cobranca = 'cobanc_menu';
    var role_boleto = 'cobanc_bol';
    var path_cobranca = 'finance.bankcharges';
    var path_boleto = 'finance.bankcharges.bankslip';

    msNavigationService.saveItem('finance.bankcharges', {
      title: 'Boletos',
      icon: 'icon-barcode',
      auth: role_boleto,
      state: 'private.finance.bankslip',
      weight: 7,
      // title: 'Boletos',
      // icon: 'icon-bank',
      // auth: role_cobranca,
      // weight: 7,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role_cobranca, path_cobranca);
      }
    });

    // msNavigationService.saveItem('finance.bankcharges.bankslip', {
    //   title: 'Boletos',
    //   icon: 'icon-barcode',
    //   auth: role_boleto,
    //   state: 'private.finance.bankslip',
    //   weight: 2,
    //   hidden: function () {
    //     return !PoliciesService.checkPolicyAndProfile(role_boleto, path_boleto);
    //   }
    // });
  }

  angular
    .module('app.finance.bankslip')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function BankSlipController($rootScope, $document, $window, Common, PoliciesService, BankFileSendService, ModalFactory, Session, LocalStorage,
                              $scope, $filter, a4Moment, BankSlipService, CONFIG, ProductService, $a4FloatButton, PersonService, EducationalService) {

    var vm = this;

    /** Constantes de status do boleto */
    vm.BANK_SLIP_STATUS_NOT_GENERATED = -1;
    vm.BANK_SLIP_STATUS_WAITING_FILE_SEND = 0;
    vm.BANK_SLIP_STATUS_TO_REGISTER = 1;
    vm.BANK_SLIP_STATUS_SENT = 2;
    vm.BANK_SLIP_STATUS_REGISTERED = 3;
    vm.BANK_SLIP_STATUS_DONE = 5;
    vm.BANK_SLIP_STATUS_PAID = 6;

    vm.search_person_bank_slips = null;
    vm.current_profile = Session.getCurrentProfile();
    vm.items = [];
    vm.product_groups = [];
    vm.person = null;
    vm.product_ids = [];
    vm.current_account = null;
    vm.current_accounts = [];
    vm.bank_slip_rule = null;
    vm.all_bank_slip_rules = [];
    vm.days_to_expire = null;
    vm.selected_tab = null;
    vm.selected_bank_slip = [];
    vm.filter_date = {
      startDate: a4Moment().startOf('month').format('YYYY-MM-DD'),
      endDate: a4Moment().endOf('year').format('YYYY-MM-DD')
    };
    vm.bankslipgroup = {
      type: 0,
      product_group_id: undefined,
      current_account_id: undefined,
      is_api: false,
      bank_slip_rule_id: null,
      product_ids: [],
      month: [a4Moment().month() + 1],
      year: a4Moment().year(),
      carne: 0,
      get_conditional_enrolment: false,
      force_bank_slip_rule: false,
      order_by_student: angular.isUndefined(LocalStorage.get('order_bank_slips_by_student')) || LocalStorage.get('order_bank_slips_by_student') === null ? false : LocalStorage.get('order_bank_slips_by_student')
    };

    /**
     * init
     */
    vm.init = function () {
      if (vm.checkPolicies('cobanc_rem_alt')) {
        vm.bankslipgroup.type = 3;
      }
      vm.getAllCurrentAccount();
      vm.getAllBankSlipRule();
      vm.getAllBankSlipPaginate(1, 75, null, vm.filter_date);
      // vm.getServices();get_conditional_enrolment
      vm.getSchoolPeriod();
      vm.subdomain = $document[0].domain.split('.')[0];
      vm.webLink = CONFIG.webApiUri + 'api/bankslip/generate/print';
      vm.webLinkPrint = '';
      vm.status = vm.BANK_SLIP_STATUS_NOT_GENERATED;
      // vm.allProductGroups();
      vm.setMonthsAndYears();
      // vm.getFileSendStatistics();
      vm.bankslipgroup.bank_slip_rule_id = null;
    };

    vm.searchBankSlip = function (search) {
      vm.getAllBankSlipPaginate(1, 15, vm.status, vm.filter_date);
    };

    vm.getSelectedBankSlipRuleIsApi = function() {
      if (!vm.bankslipgroup.bank_slip_rule_id || !vm.all_bank_slip_rules) return false;

      // Encontra a regra selecionada
      var selectedRule = vm.all_bank_slip_rules.find(function(rule) {
        return rule.id === vm.bankslipgroup.bank_slip_rule_id;
      });

      // Encontra a conta corrente selecionada
      var selectedAccount = vm.all_current_accounts.find(function(account) {
        return account.id === vm.bankslipgroup.current_account_id;
      });

      if (selectedRule && selectedRule.is_api === true && (selectedRule.bank_id == 33 || selectedRule.bank_id == 237)) {
        // Verifica as condições para cada texto
        if (selectedRule.expiration_date_counter == 0) {
          return 1; // Estiver no dia de expiração
        } else if (selectedRule.expiration_date_counter <= 15 && selectedRule.expiration_date_counter > 0) {
          return 2; // Faltar de 1 a 15 dias
        } else if (selectedRule.expiration_date_counter < 0) {
          return 3 // Tiver expirado
        }
      }
    };

    vm.getSelectedCurrentAccountIsApi = function() {
      if (!vm.all_current_accounts) return false;

      // Encontra a conta corrente selecionada
      var selectedAccount = vm.all_current_accounts.find(function(account) {
        return account.id === vm.bankslipgroup.current_account_id;
      });

      if (selectedAccount && selectedAccount.is_api === true && (selectedAccount.bank_id == 33 || selectedAccount.bank_id == 237)) {
        // Verifica as condições para cada texto
        if (selectedAccount.expiration_date_counter == 0) {
          return 1; // Estiver no dia de expiração
        } else if (selectedAccount.expiration_date_counter <= 15 && selectedAccount.expiration_date_counter > 0) {
          return 2; // Faltar de 1 a 15 dias
        } else if (selectedAccount.expiration_date_counter < 0) {
          return 3 // Tiver expirado
        }
      }
    };

    /**
     *  Retorna o periodo letívo selecionado
     */
    vm.getSchoolPeriod = function () {
      EducationalService.getSchoolsPeriod()
        .then(function (periods) {
          vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
          vm.school_period = $filter('filter')(periods.plain().list, {id: vm.current_school_period_id})[0];
          $rootScope.show_loader = false;
        })
    };

    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };
    
    /**
     * Define o array de meses e anos a serem selecionados
     */
    vm.setMonthsAndYears = function () {
      vm.months = [];
      vm.years = [];
      /** os meses no momente são tratados de 0 a 11, sendo 0 - Janeiro e 11 - Dezembro */
      for (var i = 0; i <= 11; i++) {
        var momentVar = a4Moment().startOf('year');
        momentVar.add('month', i);
        vm.months.push({id: momentVar.month() + 1, name: momentVar.format('MMMM')});
      }

      for (var i2 = 0; i2 <= 7; i2++) {
        var momentVar3 = a4Moment().subtract(3, 'years').add('year', i2);
        vm.years.push({id: momentVar3.year(), name: momentVar3.format('YYYY')});
      }
    };

    /**
     * Define o array de meses e anos a serem selecionados
     */
    vm.setMonthsForYear = function () {
      /*vm.months = [];
      var current_year = a4Moment().year();
      var current_month = a4Moment().month();
      if (current_year < vm.bankslipgroup.year) {
        var momentVar = a4Moment().startOf('year');
        for (var i = 0; i <= 11; i++) {
          vm.months.push({id: momentVar.month() + 1, name: momentVar.format('MMMM')});
          momentVar.add('month', 1);
        }
        vm.bankslipgroup.month = [];
      } else {
        /!** os meses no momente são tratados de 0 a 11, sendo 0 - Janeiro e 11 - Dezembro *!/
        for (var i = 0; i <= 11; i++) {
          if (current_year > vm.bankslipgroup.year) {
            var momentVar = a4Moment().subtract(1, 'years').startOf('year');
          } else {
            var momentVar = a4Moment().startOf('year');
          }
          if (i >= current_month || current_year !== vm.bankslipgroup.year) {
            momentVar.add('month', i);
            vm.months.push({id: momentVar.month() + 1, name: momentVar.format('MMMM')});
          }
          /!** se for dezembro já adiciona janeiro novamente *!/
          if (current_month === 11) {
            var firstMonth = a4Moment().startOf('year');
            vm.months.push({id: firstMonth.month(), name: firstMonth.format('MMMM')});
          }
        }
        vm.bankslipgroup.month = [];
      }*/
      /*for (var i2 = 0; i2 <= 5; i2++) {
        var momentVar3 = a4Moment().add('year', i2);
        vm.years.push({id: momentVar3.year(), name: momentVar3.format('YYYY')});
      }*/
    };

    vm.getFileSendStatistics = function () {
      BankFileSendService.getFilesSendStatistics()
        .then(function (resp) {
          vm.file_send_statistics = resp.plain();
        });
    };

    /**
     * Item selecionado no autocomplete de pessoas
     * @param item
     */
    vm.selectedItemChange = function (item) {
      if (angular.isDefined(item)) {
        vm.bankslipgroup.person_id = item.id;
        vm.bankslipgroup.month = [null];
      } else if (angular.isUndefined(item)) {
        vm.bankslipgroup.month = [a4Moment().month() + 1];
      }
    };

    /**
     * Retorna todos agrupamentos
     */
    vm.allProductGroups = function () {
      if (vm.product_groups.length === 0) {
        return ProductService.getProductGroupsUsedByPeriod({
          month: vm.bankslipgroup.month.toString(),
          year: vm.bankslipgroup.year
        })
          .then(function (response) {
            vm.product_groups = response.plain();
            vm.product_groups.unshift({id: null, name: 'Nenhum'});
            $rootScope.show_loader = false;
          })
          .catch(function (error) {
            $rootScope.show_loader = false;
            Common.Toast.error(error)
          });
      } else {
        var deffered = Common.$q.defer();
        deffered.resolve(vm.product_groups);
        return deffered.promise;
      }

    };

    /**
     * Retorna os serviços associados a um grupo de serviço
     * @param group_id
     */
    vm.getProductsByGroup = function (group_id) {
      vm.bankslipgroup.product_ids = [];
      if (group_id === null) {
        vm.bankslipgroup.product_group_id = undefined;
      } else {
        ProductService.getProductsByGroup({group_id: group_id})
          .then(function (resp) {
            vm.products = resp.plain();
          });
      }
    };

    vm.setProducts = function (products) {
      if (angular.isUndefined(products)) {
        vm.bankslipgroup.product_ids = [];
      } else if (products[0] === null) {
        vm.products.forEach(function (item) {
          vm.bankslipgroup.product_ids.push(item.id);
        })
      }
    };


    /**
     * Abre o modal para adicionar informações ao arquivo remessa e faz a submissão
     */
    vm.openModal = function () {
      ModalFactory.customClean(
        'app/finance/bank-slip/views/modal.html',
        'BankSlipFileSendController',
        'vm', false, {
          bank_slips: vm.selected_bank_slip,
          account: vm.current_account,
          status: vm.status,
        }
      ).then(function (response) {
        if (response === 'change_tab_send') {
          vm.selected_tab = 1;
          vm.selected_bank_slip = [];
          vm.switchStatus(0)
        }
        $rootScope.show_loader = false;
      });
    };


    vm.getServices = function () {
      ProductService.getOnlyServices()
        .then(function (resp) {
          vm.services = resp.plain();
        })
    };

    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    vm.isIndeterminate = function () {
      return (vm.selected.length !== 0 &&
        vm.selected.length !== vm.items.length);
    };

    vm.isChecked = function () {
      return vm.selected.length === vm.items.length;
    };


    /**
     * Executa link de impressão de boletos
     */
    vm.printBankSlip = function () {
      var element = angular.element('<a />');
      element.click(function () {
        $window.open(vm.webLinkPrint, "_blank");
      });
      element.trigger('click');
    };

    /**
     * Transforma o link de impressão de boletos
     * @param obj
     * @param clean
     * @returns
     */
    vm.build_print_link = function (obj, clean) {

      if (!angular.isUndefined(clean)) {
        vm.webLinkPrint = vm.webLink;
        return;
      }

      var output_join = [];

      obj.forEach(function (val) {
        output_join.push(val.bank_slip_id);
      });

      vm.webLinkPrint = vm.webLink + '?' + 'check=' + btoa(output_join.toString()) + '&connection=' + vm.subdomain;
    };

    /**
     * Geração de boletos em grupo
     */
    vm.generateBankSlipsPDF = function (form_data, form) {
      if (form.$valid) {
        $rootScope.show_loader = true;
        var form_data_copy = angular.copy(form_data);
        form_data_copy.month = form_data.month.toString();
        form_data_copy.get_conditional_enrolment = form_data.get_conditional_enrolment.toString();
        form_data_copy.force_bank_slip_rule = form_data.force_bank_slip_rule.toString();
        BankSlipService.cluster(form_data_copy)
          .then(function () {
            vm.getFileSendStatistics();
            $rootScope.show_loader = false;
            Common.Toast.success('Geração realizada com sucesso');
          })
          .catch(function (error) {
            Common.Toast.error(error.message || error.data.message);
            $rootScope.show_loader = false;
          })
      } else {
        Common.Toast.warning('Selecione os campos obrigatórios');
      }
    };

    /**
     * Busca pessoa para impressão dos boletos;
     */
    vm.getBankSlipPerson = function (query) {
      return PersonService.listAll({query: query});
    };

    /**
     * Faz a consulta de acordo com o status solicitado
     * @param status
     */
    vm.switchStatus = function (status) {
      switch (parseInt(status)) {
        case vm.BANK_SLIP_STATUS_NOT_GENERATED:
          vm.status = vm.BANK_SLIP_STATUS_NOT_GENERATED;
          break;
        case vm.BANK_SLIP_STATUS_WAITING_FILE_SEND:
          vm.status = vm.BANK_SLIP_STATUS_WAITING_FILE_SEND;
          vm.getAllBankSlipPaginate(1, 15, vm.BANK_SLIP_STATUS_WAITING_FILE_SEND, vm.filter_date);
          vm.selected_bank_slip = [];
          vm.bank_slip_paginate.data = [];
          break;
        case vm.BANK_SLIP_STATUS_DONE:
          vm.status = vm.BANK_SLIP_STATUS_DONE;
          vm.getAllBankSlipPaginate(1, 15, vm.BANK_SLIP_STATUS_DONE, vm.filter_date);
          vm.selected_bank_slip = [];
          vm.bank_slip_paginate.data = [];
          break;
        case vm.BANK_SLIP_STATUS_PAID:
          vm.status = vm.BANK_SLIP_STATUS_PAID;
          vm.getAllBankSlipPaginate(1, 15, vm.BANK_SLIP_STATUS_PAID, vm.filter_date);
          vm.selected_bank_slip = [];
          vm.bank_slip_paginate.data = [];
          break;
        case vm.BANK_SLIP_STATUS_REGISTERED:
          vm.status = vm.BANK_SLIP_STATUS_TO_REGISTER + ',' + vm.BANK_SLIP_STATUS_SENT + ',' + vm.BANK_SLIP_STATUS_REGISTERED;
          vm.getAllBankSlipPaginate(1, 15, vm.status, vm.filter_date);
          vm.selected_bank_slip = [];
          vm.bank_slip_paginate.data = [];
          break;
      }
    };

    /**
     * Retorna a paginação de titulos
     */
    vm.getAllBankSlipPaginate = function (page, qty, status, date) {
      $rootScope.show_loader = true;
      page = (angular.isUndefined(page) || page === null) ? 1 : page;
      qty = (angular.isUndefined(qty) || qty === null) ? 15 : qty;
      status = (angular.isUndefined(status) || status === null) ? vm.status : status;
      date = (angular.isUndefined(date) || date === null) ? vm.filter_date : date;


      vm.promise = BankFileSendService.getAllBankSlipPaginate({
        initialDate: date.startDate,
        endDate: date.endDate,
        status: status, page: page, qtd: qty,
        service_group: vm.service_group,
        service: vm.service,
        not_canceled: true,
        search_person_bank_slips: vm.search_person_bank_slips
      }).then(function (response) {
        vm.bank_slip_paginate = response.plain();
        vm.bank_slip_paginate_original = angular.copy(vm.bank_slip_paginate);
        $rootScope.show_loader = false;
      }).catch(function () {
        $rootScope.show_loader = false;
      })
    };

    /**
     * Retorna todas as contas
     */
    vm.getAllCurrentAccount = function () {
      vm.current_accounts = [];
      BankSlipService.listBillingAccounts()
        .then(function (response) {
          var current_accounts = response.plain();
          vm.all_current_accounts = $filter('filter')(current_accounts, {current_account_type_id: 2});
          vm.all_current_accounts.unshift({id: undefined, name: 'Usar Regra de boleto'});
        });
    };

    /**
     * Define uma conta corrente
     */
    vm.setCurrentAccount = function (item) {
      if (angular.isUndefined(item) && vm.all_current_accounts.length > 0) {
        vm.main_account = $filter('filter')(vm.all_current_accounts, {is_main: true, current_account_type_id: 2})[0];
        if (angular.isDefined(vm.main_account) && vm.main_account !== null) {
          vm.bankslipgroup.current_account_id = vm.main_account.id;
        }
        vm.all_current_accounts.forEach(function(current_account) {
          if (current_account.id === vm.bankslipgroup.current_account_id) {
            vm.bankslipgroup.is_api = current_account.is_api;
          }
        })
      }
    };
    /**
     * Define uma regra de boleto
     */
    vm.setBankSlipRule = function (item) {
      if (angular.isUndefined(item) && vm.all_bank_slip_rules.length > 0) {
        vm.bankslipgroup.bank_slip_rule_id = vm.all_bank_slip_rules[1].id;
      }
      vm.all_bank_slip_rules.forEach(function(rule) {
        if (rule.id === vm.bankslipgroup.bank_slip_rule_id) {
          vm.bankslipgroup.is_api = rule.is_api;
        }
      })
    };

    vm.setOrderBy = function () {
      LocalStorage.add('order_bank_slips_by_student', vm.bankslipgroup.order_by_student);
    }
    /**
     * Abre modal para selecionar individualmente os boletos
     */
    vm.selectBankSlips = function () {
      // if (vm.bankslipgroup.bank_slip_rule_id !== null) {
      //   vm.bankslipgroup.product_group_id = undefined;
      //   vm.bankslipgroup.product_ids = undefined;
      // }
      var obj = {
        bank_slip_rule_id: angular.isUndefined(vm.bankslipgroup.bank_slip_rule_id) ? null : vm.bankslipgroup.bank_slip_rule_id,
        product_group_id: angular.isUndefined(vm.bankslipgroup.product_group_id) ? null : vm.bankslipgroup.product_group_id,
        current_account_id: angular.isUndefined(vm.bankslipgroup.current_account_id) ? null : vm.bankslipgroup.current_account_id,
        product_ids: angular.isUndefined(vm.bankslipgroup.product_ids) ? null : vm.bankslipgroup.product_ids.toString(),
        month: vm.bankslipgroup.month.toString(),
        year: vm.bankslipgroup.year,
        order_by_student: vm.bankslipgroup.order_by_student,
        type: vm.bankslipgroup.type,
        carne: vm.bankslipgroup.carne,
        person_id: vm.person == null ? undefined : vm.person.id,
        description: vm.bankslipgroup.description,
        get_conditional_enrolment: vm.bankslipgroup.get_conditional_enrolment.toString(),
        force_bank_slip_rule: vm.bankslipgroup.force_bank_slip_rule.toString()
      };
      ModalFactory.customClean(
        'app/finance/bank-slip/views/bank-slip-select-modal.html',
        'BankSlipSelectModalController',
        'vm', false, obj
      ).then(function () {
        $rootScope.show_loader = false;
      });
    };

    /**
     * Retorna todas as regras de boleto
     */
    vm.getAllBankSlipRule = function () {
      if (vm.bankslipgroup.current_account_id === undefined) {
        vm.all_bank_slip_rules = [];
        BankSlipService.getBankSlipRuleUsedByPeriod({
          month: vm.bankslipgroup.month.toString(),
          year: vm.bankslipgroup.year
        })
          .then(function (response) {
            vm.all_bank_slip_rules = response.plain();
            if (vm.all_bank_slip_rules.length > 0) {
              // vm.all_bank_slip_rules[0].is_api = false;
              vm.days_to_expire = vm.all_bank_slip_rules[0].expiration_date_counter 
              vm.bankslipgroup.bank_slip_rule_id = vm.bankslipgroup.bank_slip_rule_id === null ? vm.all_bank_slip_rules[0].id :
                $filter('filter')(vm.all_bank_slip_rules, {id: vm.bankslipgroup.bank_slip_rule_id});
              vm.bankslipgroup.bank_slip_rule_id = angular.isDefined(vm.bankslipgroup.bank_slip_rule_id[0]) ? vm.bankslipgroup.bank_slip_rule_id[0].id : vm.bankslipgroup.bank_slip_rule_id;
              vm.all_bank_slip_rules.forEach(function (rules) {
                if(rules.id === vm.bankslipgroup.bank_slip_rule_id) {
                  vm.bankslipgroup.is_api = rules.is_api;
                }
              })

              // $filter('filter')
              // vm.bankslipgroup.bank_slip_rule_id = vm.all_bank_slip_rules[0].id;
            }
            vm.all_bank_slip_rules.unshift({id: undefined, name: 'Usar conta corrente'})
          })
      }
    };


    vm.extractBankSlipId = function (array) {
      var _arrayIds = [];
      for (var i = 0; i < array.length; i++) {
        _arrayIds.push(array[i].bank_slip_id);
      }
      return _arrayIds;
    };


    vm.someBankSlip = function (selected) {
      var sendIds = extractBankSlipId(selected);
      BankSlipService.sendAllBoletos(sendIds)
        .then(function (response) {
          var anchor = angular.element('<a/>');
          anchor.attr({
            href: 'data:attachment/pdf;charset=utf-8,' + encodeURI(response),
            target: '_blank',
            download: 'filename.pdf'
          })[0].click();
          $rootScope.show_loader = false;
        })
    };

    /**
     * Envia e-mails com a lista de boleto / nota-fiscal para os clientes
     */
    vm.sendMail = function () {

      if (vm.selected_bank_slip.length > 0) {

        var list = [];

        //separa apenas os ids unicos (person) para a lista
        angular.forEach(vm.selected_bank_slip, function (person, id) {
          var id = parseInt(person['person_id']);
          if (list.indexOf(id) === -1) {
            list.push(id);
          }
        });

        //envia a lista de persons
        BankSlipService.sendMail(list)
          .then(function (response) {
            if (response.result) {
              Common.Toast.success("Lista de e-mails enviada com sucesso!", 'A4 Web');
            }
            $rootScope.show_loader = false;
          })
          .catch(function () {
            Common.Toast.error("Erro ao enviar lista de emails", 'A4 Web');
            $rootScope.show_loader = false;
          });

      } else {
        Common.Toast.warning("Selecione um ou mais boletos.", 'A4 Web');
      }

    };

    /**
     * Ouvinte para as mudanças de valores no DateRangePicker
     */
    var datePicker = $rootScope.$on('DateRangePicker.Change', function (event, args) {
      if (args != null) {
        var start = args.start;
        var end = args.end;
        $rootScope.$broadcast('loadingBlock.show');
        vm.filter_date = {start: start, end: end};
        vm.getAllBankSlipPaginate(1, 75, null, vm.filter_date);
        $scope.$applyAsync();
      }
    });

    /**
     * Retorna uma range de datas (data inicial e data final)
     * @returns {object}
     */
    vm.getRangeOfDate = function () {
      var date = null;
      if (vm.filter_date.start != null && vm.filter_date.end != null) {
        date = {startDate: vm.filter_date.start, endDate: vm.filter_date.end};
      } else {
        date = {
          startDate: a4Moment().startOf('month').format('YYYY-MM-DD'),
          endDate: a4Moment().endOf('month').format('YYYY-MM-DD')
        };
      }
      return date;
    };

    vm.generateLink = function () {
      vm.build_print_link(vm.selected_bank_slip);
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    var ltn = $rootScope.$on('UPDATE_PENDING_FILES', function () {
      vm.getFileSendStatistics();
    });

    vm.init();

  };

  angular
    .module('app.finance.bankslip')
    .controller('BankSlipController', BankSlipController);
})();

(function () {
  'use strict';

  /** @ngInject*/
  function BankSlipSelectModalController($rootScope, Common, BankSlipService,
                                         a4Moment, Utils, ModalExtra) {

    var vm = this;
    vm.selected_bank_slips = [];

    vm.init = function () {

      vm.person_id = ModalExtra.person_id;
      vm.product_ids = ModalExtra.product_ids;
      vm.product_group_id = ModalExtra.product_group_id;
      vm.bank_slip_rule_id = ModalExtra.bank_slip_rule_id;
      vm.current_account_id = ModalExtra.current_account_id;
      vm.month = ModalExtra.month;
      vm.year = ModalExtra.year;
      vm.type = ModalExtra.type;
      vm.carne = ModalExtra.carne;
      vm.order_by_student = ModalExtra.order_by_student;
      vm.description = ModalExtra.description;
      vm.get_conditional_enrolment = ModalExtra.get_conditional_enrolment;
      vm.force_bank_slip_rule = ModalExtra.force_bank_slip_rule;
      vm.getBankSlips();
    };

    /**
     * Busca os boletos com base na regra de boleto ou nos produtos selecionados
     *
     */
    vm.getBankSlips = function (page, qty) {
      page = (angular.isUndefined(page) || page === null) ? 1 : page;
      qty = (angular.isUndefined(qty) || qty === null) ? 25 : qty;
      vm.loader = true;
      vm.promise = BankSlipService.getBankSlipsForSelection({
        type: vm.type,
        person_id: vm.person_id,
        product_ids: vm.product_ids,
        product_group_id: vm.product_group_id,
        current_account_id: vm.current_account_id,
        bank_slip_rule_id: vm.bank_slip_rule_id,
        order_by_student: vm.order_by_student,
        month: vm.month,
        year: vm.year,
        page: page,
        qtd: qty,
        get_conditional_enrolment: vm.get_conditional_enrolment,
        force_bank_slip_rule: vm.force_bank_slip_rule,
        limit: 20
      }).then(function (response) {
        vm.bank_slip_paginate = response.plain();
        vm.loader = false;
      })
    };


    vm.closeModal = function (response) {
      $rootScope.$broadcast('ModalFactory.close', response);
    };

    /**
     * Formata a string de beneficiarios do boleto
     * @param beneficiaries
     */
    vm.formatBeneficiaries = function (beneficiaries) {
      return angular.fromJson(beneficiaries.replace('{', '[').replace('}', ']'));
    };
    /**
     * Formata a string de beneficiarios do boleto
     * @param services
     */
    vm.formatServices = function (services) {
      return angular.fromJson(services.replace('{', '[').replace('}', ']'));
    };

    /**
     * Formata string com aspas duplas
     * @param name
     * @returns {*}
     */
    vm.formatName = function (name) {
      return Utils.removeDoubleQuotes(name);
    };

    /**
     * Submete os boletos selecionados e gera o arquivo remessa deles
     */
    vm.submit = function () {

      vm.loader = true;
      BankSlipService.createBankFileSend({
        bank_slips: vm.selected_bank_slips,
        type: vm.type,
        carne: vm.carne,
        description: vm.description,
      }).then(function () {
        Common.Toast.success('Arquivo remessa e boletos gerados com sucesso');
        vm.loader = false;
        vm.closeModal();
      }).catch(function (error) {
        vm.loader = false;
        Common.Toast.error(error.message);
      })
    };

    vm.init();

  }

  angular
    .module('app.finance.bankslip')
    .controller('BankSlipSelectModalController', BankSlipSelectModalController);
})();

(function () {
  'use strict';

  /** @ngInject*/
  function BankSlipFileSendController($rootScope, Common, BankFileSendService,
                                      a4Moment, ModalExtra) {

    var vm = this;
    vm.intervalPromise = null;
    vm.result_process = null;
    vm.preload_value = null;
    vm.services = [];
    vm.loading_remessa = false;
    vm.service = null;
    vm.service_groups = [];
    vm.service_group = null;
    vm.file = null;
    vm.individual_print = false;
    vm.filter_date = {
      startDate: a4Moment().startOf('month').format("YYYY-MM-DD"),
      endDate: a4Moment().endOf('month').format("YYYY-MM-DD")
    };
    vm.all_file_send = [];
    vm.search = "";

    vm.filesend = {
      current_account_id: null,
      description: "",
      file_name: "",
      sequential: ""
    };

    vm.selected = [];

    /**
     * Inicialização de controlador
     * @type {*}
     */
    vm.init = function () {
      vm.filesend.current_account_id = ModalExtra.account;
      vm.selected = ModalExtra.bank_slips;
      vm.status = ModalExtra.status;
      vm.setFileName();
      vm.setSequencial();
    };

    /**
     * Define o sequencial
     */
    vm.setSequencial = function () {
      BankFileSendService.getLastSequential()
        .then(function (response) {
          vm.filesend.sequential = response.sequential + 1;
        })
    };

    /**
     * Define o nome para o arquivo remessa
     */
    vm.setFileName = function () {
      vm.filesend.file_name = "rem" + a4Moment().format('YYYYMMDD_HHmm');
    };

    /**
     *
     * @param form
     * @param file_send
     */
    vm.submit = function (file_send) {
      vm.loading_remessa = true;
      if (vm.selected.length === 0 && vm.status !== 0) {
        Common.Toast.error('Selecione pelo menos um titulo/boleto.');
      } else {
        var sender_object = angular.copy(file_send);
        sender_object.bills = vm.selected;
        sender_object.file_name = sender_object.file_name + ".rem";
        BankFileSendService.generateFileSend(sender_object)
          .then(function () {
            Common.Toast.success('Arquvo remessa criado com sucesso!!');
            vm.closeModal('change_tab_send');
            vm.loading_remessa = false;
          })
          .catch(function (response) {
            switch (response.status) {
              case 404:
                vm.loading_remessa = false;
                break;
              case 406:
                vm.loading_remessa = false;
                vm.closeModal();
                Common.Toast.warning(response.data.message);
                break;
              case 500:
                Common.Toast.error('INTERNAL_ERROR_TRY_AGAIN');
                vm.loading_remessa = false;
                break;
            }
          });
      }
    };

    vm.closeModal = function (response) {
      $rootScope.$broadcast('ModalFactory.close', response);
    };

    vm.init();

  }

  angular
    .module('app.finance.bankslip')
    .controller('BankSlipFileSendController', BankSlipFileSendController);
})();
(function () {
  'use strict';

  /** @ngInject*/
  function NewBankFileSendController($rootScope, Common, BankFileSendService,
                                     a4Moment, BankSlipService, $state, $scope, ProductService) {

    var vm = this;
    vm.intervalPromise = null;
    vm.result_process = null;
    vm.preload_value = null;
    vm.services = [];
    vm.service = null;
    vm.service_groups = [];
    vm.service_group = null;
    vm.file = null;
    vm.individual_print = false;
    vm.filter_date = {
      startDate: a4Moment().startOf('month').format("YYYY-MM-DD"),
      endDate: a4Moment().endOf('month').format("YYYY-MM-DD")
    };
    vm.all_file_send = [];
    vm.search = "";

    vm.bank_slip_paginate = {
      per_page: 15,
      current_page: 1
    };

    vm.filesend = {
      current_account_id: null,
      description: "",
      file_name: "",
      sequential: ""
    };

    vm.selected = [];

    /**
     * Inicialização de controlador
     * @type {*}
     */
    var ltn = $scope.$on('$viewContentLoaded', function () {
      vm.setFileName();
      vm.setSequencial();
      vm.getCurrentAccountCollection();
      vm.getServices();
      vm.getGroupServices();
      vm.getAllBankSlipPaginate(1, 15, null, vm.filter_date);
      ltn();
    });

    /***
     * Retorna os serviços
     */
    vm.getServices = function (group) {
      ProductService.getOnlyServices({group: group})
        .then(function (resp) {
          vm.services = resp.plain();
        })
    };

    /**
     * Retorna os grupos de serviço
     */
    vm.getGroupServices = function () {
      ProductService.getServiceGroups()
        .then(function (resp) {
          vm.service_groups = resp.plain();
          vm.service_groups.push({id: null, name: 'Não agrupado'})
        })
    }

    /**
     * Retorna as contas correntes disponiveis
     */
    vm.getCurrentAccountCollection = function () {
      BankFileSendService.getCurrentAccountWithColletionConfig()
        .then(function (response) {
          vm.current_accounts_with_collection_config = response;
        });
    };

    /**
     * Ajusta variáreis de tela
     */
    vm.adjustVariables = function () {
      vm.service = null;
      vm.individual_print = false;
    };

    /**
     * Retorna a paginação de titulos
     */
    vm.getAllBankSlipPaginate = function (page, qty, search, date) {
      page = (angular.isUndefined(page) || page === null) ? vm.bank_slip_paginate.current_page : page;
      qty = (angular.isUndefined(qty) || qty === null) ? vm.bank_slip_paginate.per_page : qty;
      search = (angular.isUndefined(search) || search === null) ? "" : search;
      date = (angular.isUndefined(date) || date === null) ? vm.filter_date : date;

      vm.promise = BankFileSendService.getAllBankSlipPaginate({
        initialDate: date.startDate,
        endDate: date.endDate,
        search: search, page: page, qtd: qty,
        service_group: vm.service_group,
        service: vm.service
      })
        .then(function (response) {
          vm.bank_slip_paginate = response;
          vm.bank_slip_filtrated = vm.bank_slip_paginate;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Define o sequencial
     */
    vm.setSequencial = function () {
      BankFileSendService.getLastSequential()
        .then(function (response) {
          vm.filesend.sequential = response.sequential + 1;
        })
    };

    /**
     * Define o nome para o arquivo remessa
     */
    vm.setFileName = function () {
      vm.filesend.file_name = "rem" + a4Moment().format('YYYYMMDD_HHmm');
    };

    /**
     *
     * @param form
     * @param file_send
     */
    vm.submit = function (form, file_send) {
      if (vm.selected.length === 0) {
        Common.Toast.error('Selecione pelo menos um titulo/boleto.');
      } else {
        var sender_object = angular.copy(file_send);
        sender_object.bills = vm.selected;
        if (form.$valid) {
          sender_object.file_name = sender_object.file_name + ".rem";
          BankFileSendService.generateFileSend(sender_object)
            .then(function () {
              Common.Toast.success('Arquvo remessa criado com sucesso!!');
              $rootScope.show_loader = false;
              $state.go('private.finance.bank-file-send');
            })
            .catch(function (response) {
              switch (response.status) {
                case 500:
                  Common.Toast.error('INTERNAL_ERROR_TRY_AGAIN');
                  break;
                case 404:
                  break;
              }
              $rootScope.show_loader = false;
            });
        }
      }
    };

    /**
     * Destrutor da classe
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

  }

  angular
    .module('app.finance.bank-file-send')
    .controller('NewBankFileSendController', NewBankFileSendController);
})();
(function () {
  'use strict';

  /** @ngInject*/
  function BankFileSendService(Restangular) {

    var vm = {};

    vm.getCurrentAccountWithColletionConfig = function (obj) {
      return Restangular.one("bankfilesend").one('getCurrentAccountWithColletionConfig').get(obj);
    };

    vm.getDetails = function (id, obj) {
      return Restangular.one("bankfilesend", id).get(obj);
    };

    vm.getLastSequential = function () {
      return Restangular.one("bankfilesend/getLastSequentialOfBankFileSend").get();
    };

    vm.generateFileSend = function (obj) {
      return Restangular.one("bankfilesend/generateRemessa").customPOST(obj);
    };

    vm.getAllBankSlipPaginate = function (obj) {
      return Restangular.one("bankfilesend").one('getAllBankSlipPaginate').get(obj);
    };

    vm.getAllBankSlip = function () {
      return Restangular.all("bankfilesend/getAllBankSlip").getList();
    };

    vm.getAllFileSend = function (obj) {
      return Restangular.one("bankfilesend").one('getAll').get(obj);
    };

    vm.sendSearch = function (search) {
      return Restangular.all("bankfilesend").one("getAllBankSlip").get(search);
    };

    vm.verifyCanDelete = function (id) {
      return Restangular.one("bankfilesend", id).one('verifycandelete').get(id);
    };

    vm.cancelBankFileSend = function(obj)
    {
      return Restangular.one('bankfilesend', obj.bank_file_send_id).all('cancel').post();
    };

    vm.getFilesSendStatistics = function () {
      return Restangular.one("bankfilesend").one("filestatistics").get();
    };

    vm.confirmSent = function (file) {
      return Restangular.one('bankfilesend').all('confirmsent').post(file);
    };

    vm.registerBankFileSendDownload = function (obj) {
      return Restangular.one('bankfilesend', obj.id).all('registerbankfilesenddownload').post(obj);
    };

    return vm;
  }

  angular.module('app.finance.bank-file-send')
    .factory('BankFileSendService', BankFileSendService);
})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.bank-file-send', {
        url: '/bank-file-send',
        public: false,
        templateUrl: 'app/finance/bank-file-send/views/index.html',
        controller: 'BankFileSendController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Arquivo Remessa'
        }
      })
      .state('private.finance.bank-file-send-new-file', {
        url: '/bank-file-send/new-file',
        public: false,
        templateUrl: 'app/finance/bank-file-send/views/new-file.html',
        controller: 'NewBankFileSendController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Novo arquivo remessa'
        }
      });
  }

  angular
    .module('app.finance.bank-file-send')
    .config(routerConfig);

})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    // msNavigationService.saveItem('finance.bankcharges.bank-file-send', {
    //   title: 'Arquivo Remessa',
    //   icon: 'icon-box-upload',
    //   state: 'private.finance.bank-file-send',
    //   weight: 1
    // });
  }

  angular
    .module('app.finance.bank-file-send')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject*/
  function BankFileSendController(PoliciesService, BankSlipService, ModalFactory, Common, CONFIG, BankFileSendService, $state,
                                  $filter, Session, $document, $window, $scope, $rootScope) {

    var vm = this;
    vm.intervalPromise = null;
    vm.result_process = null;
    vm.preload_value = null;
    vm.file = null;
    vm.all_file_send = [];
    vm.url_download = CONFIG.webApiUri + "/api/bankfilesend/download/";
    vm.search = "";

    vm.file_send = {
      per_page: 15,
      current_page: 1
    };

    vm.init = function () {
      vm.getCurrentAccount();
    };

    /**
     * Retorna todas as contas correntes
     */
    vm.getCurrentAccount = function () {
      $rootScope.show_loader = true;
      BankFileSendService.getCurrentAccountWithColletionConfig()
        .then(function (response) {
          vm.current_account_type_bank = response.plain();
          vm.current_account_id = vm.current_account_type_bank.filter(function (item) {
            return item.is_main || item.bank_branch_name === "A4 PAG";
          })[0];
          if (angular.isDefined(vm.current_account_id)) {
            vm.current_account_id = vm.current_account_id.id;
          }

          vm.promise = vm.getAll(null, null, vm.current_account_id);
          $rootScope.show_loader = false;
        });
    };

    /**
     * Executa o download de um arquivo remessa
     * @param element
     * @param file_id
     */
    vm.downloadFile = function (element, file_id) {
      $rootScope.show_loader = true;
      BankFileSendService.registerBankFileSendDownload({id: file_id})
        .then(function () {
          var subdomain = $document[0].domain.split('.')[0];
          var url = vm.url_download + file_id + "?company=" + Session.get('current_company', "sessionStorage") + "&connection=" + subdomain;
          $window.open(url);
          vm.promise = vm.getAll(null, null, vm.current_account_id);
        });
    };

    vm.sendSearch = function (search) {
      var pesquisa = {search: search};
      BankFileSendService.sendSearch(pesquisa)
        .then(function (response) {
          if (response !== []) {
            vm.bank_slip_filtrated = response;
          }
          $rootScope.show_loader = false;
        });
    };

    var ltn2 = $scope.$watch('vm.search', function (newer) {
      if (newer !== '' && newer != null) {
        vm.sendSearch(newer);
      }
    });


    /**
     * Retorna todos os arquivos remessa
     */
    vm.getAll = function (page, qtd, current_account_id) {
      $rootScope.show_loader = true;
      qtd = vm.file_send.per_page;
      page = (page === undefined || page === null) ? 1 : page;
      current_account_id = (current_account_id === undefined || current_account_id === null) ? vm.current_account_id : current_account_id;

      BankFileSendService.getAllFileSend({page: page, qtd: qtd, current_account_id: current_account_id})
        .then(function (response) {
          vm.file_send = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          Common.Toast.error(response.data)
          $rootScope.show_loader = false;
        });
    };

    /**
     * Faz ou desfaz a confirmação do envio de um arquivo remessa
     * @param file
     * @param confirm - flag para confirmar ou desfazer confirmação
     */
    vm.confirmSent = function (file, confirm) {
      ModalFactory.confirm(null,
        (confirm ? 'Confirmação ' : 'Desfazer confirmação ') + 'de envio',
        "Confirma que o arquivo remessa" + (confirm ? ' foi ' : ' não foi ') + "enviado para o banco?",
        "Confirmar", "Cancelar", "finance", vm.submitConfirmSent, file)
        .then(function () {
          vm.promise = vm.getAll(vm.file_send.current_page, vm.file_send.per_page, vm.current_account_id);
          $rootScope.$broadcast('UPDATE_PENDING_FILES');
        });
    };

    /**
     * Função de submissão para o modal
     * @param file
     */
    vm.submitConfirmSent = function (file) {
      return BankFileSendService.confirmSent(file);
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.deleteBankFileSend = function (file) {
      $rootScope.show_loader = true;
      BankFileSendService.verifyCanDelete(file.id)
        .then(function (response) {
          $rootScope.show_loader = false;
          if (response === 'can_delete') {
            ModalFactory.open('require_password', null, null, {
                bank_file_send_id: file.id
              }, null, 'finance', vm.executeCancel,
              'Cancelamento de arquivo remessa e boletos', 'Digite sua senha para cancelar o arquivo remessa e os boletos',
              'Ao cancelar este arquivo remessa TODOS OS BOLETOS NESTE ARQUIVO REMESSA SERÃO TAMBÉM CANCELADOS e estarão disponíveis para serem incluídos em outro arquivo remessa.' +
              'Tenha certeza que o arquivo gerado neste lote não foi e nem será enviado para o banco, caso contrário, poderá haver ' +
              'duplicação de boletos registrados no banco acarretando em custos extras de cobrança bancária para vocês. ' +
              'Tem certeza que deseja cancelar este arquivo remessa e seus boletos?').then(function () {
              vm.promise = vm.getAll(null, null, vm.current_account_id);
              Common.Toast.success('Remessa cancelada com sucesso!');
            });
          } else {
            ModalFactory.alert("Não é possível cancelar esta remessa",
              "A remessa não pode ser cancelada porque existem boletos associados que não estão no status 'A registrar'",
              "modal", "Ok", "false", "finance");
          }
        })
    };

    vm.executeCancel = function (obj) {
      return BankFileSendService.cancelBankFileSend(obj);
    };

    /**
     * Mostra os detalhes do arquivo remessa
     * @param item
     */
    vm.fileSendDetails = function (item) {
      ModalFactory.customClean('app/finance/bank-file-send/views/file-send-details.html',
        /** @ngInject */
        function (ModalExtra, $mdDialog) {
          var vm = this;
          vm.item = ModalExtra.item;
          vm.current_tab = 0;
          if (vm.item.status !== 'Processado') {
            vm.current_tab = null;
          }
          vm.getDetails = function (page, qty) {
            page = page == null ? 1 : page;
            qty = qty == null ? 15 : qty;
            vm.promise = BankFileSendService.getDetails(item.id, {page: page, qty: qty, tab: vm.current_tab})
              .then(function (resp) {
                vm.details = resp;
              })
          };
          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.getDetails(1, 15);
        }
        , 'vm', false, {item: item})
        .then(function () {
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.init();
    /**
     * Destrutor da classe
     */
    $scope.$on('$destroy', function () {
      [ltn2].forEach(function (fn) {
        fn();
      })
    });

  }

  angular
    .module('app.finance.bank-file-send')
    .controller('BankFileSendController', BankFileSendController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function BankFileSendDetails($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        details: '=?',
        tab: '=?',
        paginate: '=?'
      },
      controller: 'BankFileSendDetailsController',
      controllerAs: 'vm',
      templateUrl: 'app/finance/bank-file-send/views/file-send-details-table.html',
      link: function () {
      }
    }
  }

  angular.module('app.finance.bank-file-send')
    .directive('bankFileSendDetails', BankFileSendDetails);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BankFileSendDetailsController($scope, $rootScope) {
    var vm = this;


  }

  angular.module('app.finance.bank-file-send')
    .controller('BankFileSendDetailsController', BankFileSendDetailsController);
})();
(function () {
  'use strict';

  /** @ngInject*/
  function NewFileReceivedController($mdDialog, BankFileReceiveService, Common, $rootScope, ModalFactory) {
    var vm = this;
    vm.loading_return = false;
    vm.doubleclick = false;
    /**
     * Upload e processamento do arquivo retorno
     * @param file
     */
    vm.uploadFile = function (file) {
      vm.doubleclick = true;
      if (file != null) {
        vm.loading_return = true;
        BankFileReceiveService.verifyBankFileReceiveReprocess({filename: file.name})
          .then(function (reprocess) {
            if (reprocess.count === 0) {
              return vm.process(file);
            } else {
              ModalFactory.confirm(null, "Confirmar reprocessamento",
                "Este arquivo retorno já foi processado. Deseja reprocessar?",
                'Confirmar', 'Cancelar', 'finance').then(function () {
                vm.process(file);
              }).catch(function () {
                vm.cancel();
              });
            }
          });
      } else {
        Common.Toast.warning('Selecione um arquivo para processar.');
        vm.loading_return = false;
      }
      vm.doubleclick = false;
    };

    vm.process = function (file) {
      $rootScope.show_loader = true;
      BankFileReceiveService.sendFile(file)
        .then(function (response) {
          vm.result_process = response;
          vm.loading_return = false;
          vm.doubleclick = false;
          $rootScope.show_loader = false;
          vm.answer(true);
          Common.Toast.success('Arquivo lido com sucesso.');
        })
        .catch(function (error) {
          switch (error.data.message) {
            case 'TYPE_OF_INVALID_FILE':
              Common.Toast.warning('Tipo de arquivo invalido.');
              break;
            case 'ERROR_PROCESSING_RETURN_FILE_DATA':
              Common.Toast.warning('Erro ao ler retorno, verifique seu arquivo.');
              break;
            case 'ERROR_IN_REGISTRY_CHECKER_DIGIT':
              Common.Toast.warning('Erro no digito verificador do registro.');
              break;
            default:
              Common.Toast.warning(error.data.message);
              break;
          }
          vm.doubleclick = false;
          vm.loading_return = false;
        });
    };

    vm.answer = function (answer) {
      $mdDialog.hide(answer);
    };

    vm.cancel = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };
  }
  angular
    .module('app.finance.bank-file-receive')
    .controller('NewFileReceivedController', NewFileReceivedController)
})();
(function () {
  'use strict';

  /** @ngInject*/
  function DetailsFileReceivedController($mdDialog, Common, ModalExtra, BankFileReceiveService, $rootScope, $filter) {
    var vm = this;
    vm.item = ModalExtra;
    vm.details = {};
    vm.show_soldout = false;
    vm.show_downloaded = false;
    vm.show_accept = false;
    vm.show_rejection = false;
    vm.show_tax = false;
    vm.show_others = false;
    vm.option_difference = 'show';

    vm.difference_consts = {
      a_definir: 0,
      abonar: 1,
      manter_diferenca: 2
    };

    vm.emit = function(item){
    };

    /**
     *  * Especificação do codigo details_status
     * 1) Liquidação - 06
     * 2) Liquidação após baixa ou tit não registrado - 17
     * 3) Liquidação em cartório
     * 10) Baixa - 09
     * 20) Entrada confirmada - 02
     * 30) Entrada rejeitada - 03
     * 50) Debito de tarifa/custas - 28
     * 90) Outros
     */
    vm.details_status = [
      {id: 1, name: 'Liquidado'},
      {id: 2, name: 'Liquidação após baixa ou titulo não registrado'},
      {id: 3, name: 'Liquidação em cartório'},
      {id: 10, name: 'Baixa'},
      {id: 20, name: 'Entrada confirmada (Aceite)'},
      {id: 30, name: 'Entrada rejeitada'},
      {id: 50, name: 'Debito de tarifa/custas'},
      {id: 90, name: 'Outros'},
    ];

    vm.init = function () {
      vm.verify(vm.item.id);
    };

    vm.verify = function (bank_file_received_id) {
      BankFileReceiveService.getFileReceiveVerify(bank_file_received_id)
        .then(function (response) {
          vm.show_soldout = response.soldout > 0;
          vm.show_downloaded = response.downloaded > 0;
          vm.show_accept = response.accepted > 0;
          vm.show_rejection = response.rejected > 0;
          vm.show_tax = response.tax > 0;
          vm.show_others = response.others > 0;
          vm.show_reprocesseds = response.reprocessations > 0;
        });
    };

    vm.paginate = function () {
      switch (vm.current_tab) {
        case 0:
          vm.getDetailsSoldOut();
          break;
        case 1:
          vm.getDetailsAccept();
          break;
        case 2:
          vm.getDetailsRejection();
          break;
        case 3:
          vm.getDetailsDownloaded();
          break;
        case 4:
          vm.getDetailsTax();
          break;
        case 5:
          vm.getDetailsOthers();
          break;
      }
    };

    /**
     * Tratamento das diferenças
     * @param record - Item do arquivo retorno
     * @param option - Opção escolhida pelo usuário.
     */
    vm.differenceTreatment = function (record, option) {
      BankFileReceiveService.differenceTreatment(record.bank_slip_id, option)
        .then(function (response) {
          Common.Toast.success('Ação realizada com sucesso');
        })
        .catch(function (error) {
          Common.Toast.error(error.message || error.data.message);
        })
    };

    vm.getDetailsStatus = function (operation_sys) {
      return $filter('filter')(vm.details_status, {id: operation_sys})[0].name;
    };

    vm.answer = function (answer) {
      $rootScope.show_loader = false;
      $mdDialog.hide(answer);
    };

    vm.toggle = function (content_id) {
      angular.element(content_id).slideToggle(300);
    };

    /**
     * Resgata os detalhes de LIQUIDAÇÃO do arquivo retorno
     */
    vm.getDetailsSoldOut = function (page, qty) {
      $rootScope.show_loader = true;
      page = page == null ? 1 : page;
      qty = qty == null ? 15 : qty;

      return BankFileReceiveService.getFileReceiveDetails(vm.item.id,
        {status: '1,2,3', page: page, qty: qty, show_reprocessed: vm.show_reprocessed})
        .then(function (response) {
          vm.details.soldout = response;
          vm.show_soldout = vm.details.soldout.total > 0;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Resgata os detalhes de BAIXA do arquivo retorno
     */
    vm.getDetailsDownloaded = function (page, qty) {
      $rootScope.show_loader = true;
      page = page == null ? 1 : page;
      qty = qty == null ? 15 : qty;

      return BankFileReceiveService.getFileReceiveDetails(vm.item.id,
        {status: '10', page: page, qty: qty, show_reprocessed: vm.show_reprocessed})
        .then(function (response) {
          vm.details.downloaded = response;
          vm.show_downloaded = vm.details.downloaded.total > 0;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Resgata os detalhes de ACEITE do arquivo retorno
     */
    vm.getDetailsAccept = function (page, qty) {
      $rootScope.show_loader = true;
      page = page == null ? 1 : page;
      qty = qty == null ? 15 : qty;

      return BankFileReceiveService.getFileReceiveDetails(vm.item.id,
        {status: '20', page: page, qty: qty, show_reprocessed: vm.show_reprocessed})
        .then(function (response) {
          vm.details.accept = response;
          vm.show_accept = vm.details.accept.total > 0;
          $rootScope.show_loader = false;
        })
    };
    /**
     * Resgata os detalhes de REJEIÇÃO do arquivo retorno
     */
    vm.getDetailsRejection = function (page, qty) {
      $rootScope.show_loader = true;
      page = page == null ? 1 : page;
      qty = qty == null ? 15 : qty;

      return BankFileReceiveService.getFileReceiveDetails(vm.item.id,
        {status: '30', page: page, qty: qty, show_reprocessed: vm.show_reprocessed})
        .then(function (response) {
          vm.details.rejection = response;
          vm.show_rejection = true;
          vm.show_rejection = vm.details.rejection.total > 0;
          $rootScope.show_loader = false;
        })
    };
    /**
     * Resgata os detalhes de TAXAS do arquivo retorno
     */
    vm.getDetailsTax = function (page, qty) {
      $rootScope.show_loader = true;
      page = page == null ? 1 : page;
      qty = qty == null ? 15 : qty;

      return BankFileReceiveService.getFileReceiveDetails(vm.item.id,
        {status: '50', page: page, qty: qty, show_reprocessed: vm.show_reprocessed})
        .then(function (response) {
          vm.details.tax = response;
          vm.show_tax = vm.details.tax.total > 0;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Resgata os detalhes de OUTROS do arquivo retorno
     */
    vm.getDetailsOthers = function (page, qty) {
      $rootScope.show_loader = true;
      page = page == null ? 1 : page;
      qty = qty == null ? 15 : qty;

      return BankFileReceiveService.getFileReceiveDetails(vm.item.id,
        {status: '90', page: page, qty: qty, show_reprocessed: vm.show_reprocessed})
        .then(function (response) {
          vm.details.others = response;
          vm.show_others = vm.details.others.total > 0;
          $rootScope.show_loader = false;
        })
    };

    vm.init();
    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }

  angular
    .module('app.finance.bank-file-receive')
    .controller('DetailsFileReceivedController', DetailsFileReceivedController)
    .directive('detailstable', function () {
      return {
        scope: {
          list: '=',
          paginateFunction: '&',
          promisse: '=',
          soldout: '='
        },
        restrict: 'E',
        templateUrl: 'app/finance/bank-file-receive/views/details-table.html',
        controller: (function ($scope, BankFileReceiveService, Common) {
          var vm = this;
          vm.show_reprocessed = false;
          vm.difference_consts = {
            a_definir: 0,
            abonar: 1,
            manter_diferenca: 2
          };
          vm.internPaginate = function (page, qty) {
            $scope.showLoader = true;
            $scope.paginateFunction({
              page: page,
              qty: qty,
              show_reprocessed: vm.show_reprocessed
            })
              .then(function () {
                $scope.showLoader = false;
              });
          };


          /**
           * Tratamento das diferenças
           * @param record - Item do arquivo retorno
           * @param option - Opção escolhida pelo usuário.
           */
          vm.differenceTreatment = function (record, option) {
            BankFileReceiveService.differenceTreatment(record.bank_slip_id, option)
              .then(function (response) {
                Common.Toast.success('Ação realizada com sucesso');
              })
              .catch(function (error) {
                Common.Toast.error(error.message || error.data.message);
              })
          };


          /**
           * Realiza as operações com status de Incoerente
           * @param item - item do arquivo retorno
           */
          vm.doOperation = function (item) {
            $scope.showLoader = true;
            BankFileReceiveService.reprocessIncoherentBankSlipOperation(item)
              .then(function (resp) {
                $scope.showLoader = false;
                item.issue_sys = 0;
                Common.Toast.success('Ação realizada com sucesso');
              })
              .catch(function (error) {
                $scope.showLoader = false;
                Common.Toast.error(error.message || error.data.message);
              })
          };
        }),
        controllerAs: 'vm'
      };
    });

})();

(function () {
  'use strict';

  /** @ngInject*/
  function BankFileReceiveService(Restangular) {

    var vm = {};

    vm.sendFile = function (file) {
      return Restangular.one('bankfilereceive').all("process").post(file);
    };

    vm.reprocessIncoherentBankSlipOperation = function (obj) {
      return Restangular.one('bankfilereceive').all("reprocessbankslip").post(obj);
    };

    vm.getAll = function (queryString) {
      return Restangular.one('bankfilereceive').one("getall").get(queryString);
    };

    vm.getFileReceiveDetails = function (id, obj) {
      return Restangular.one('bankfilereceive', id).one("details").get(obj);
    };

    vm.getFileReceiveVerify = function (id) {
      return Restangular.one('bankfilereceive', id).one("verify").get();
    };

    vm.differenceTreatment = function (bank_slip_id, option) {
      return Restangular.one('bankfilereceive').one('bankslip', bank_slip_id).one('option', option).one("difference").post();
    };

    vm.verifyBankFileReceiveReprocess = function (obj) {
      return Restangular.one('bankfilereceive').one('verifybankfilereceivereprocess').get(obj);
    };


    return vm;
  }

  angular.module('app.finance.bank-file-receive')
    .factory('BankFileReceiveService', BankFileReceiveService);
})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.bank-file-receive', {
        url: '/bank-file-receive',
        public: false,
        templateUrl: 'app/finance/bank-file-receive/views/index.html',
        controller: 'BankFileReceiveController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Arquivo Retorno'
        }
      });
  };

  angular
    .module('app.finance.bank-file-receive')
    .config(routerConfig);

})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    // msNavigationService.saveItem('finance.bankcharges.bank-file-receive', {
    //   title: 'Arquivo Retorno',
    //   icon: 'icon-box-download',
    //   state: 'private.finance.bank-file-receive',
    //   weight: 3
    // });
  }

  angular
    .module('app.finance.bank-file-receive')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject*/
  function BankFileReceiveController($scope, $interval, CONFIG, $document, Session, $a4FloatButton, BankFileReceiveService,
                                     PoliciesService, ModalFactory, BankFileSendService, $rootScope, ReportsService) {

    var vm = this;
    vm.intervalPromise = null;
    vm.result_process = null;
    vm.preload_value = null;
    vm.file = null;
    vm.show_inactive = false;
    vm.file_received = [];
    vm.show_only_pending = false;
    vm.current_account_id = null;
    vm.file_received = {
      per_page: 15,
      current_page: 1
    };
    vm.webLink = CONFIG.webApiUri;
    vm.filter_date = null;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    vm.init = function () {
      vm.getCurrentAccount();
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      if (!vm.checkPolicies('cobanc_ret_alt')) {
        vm.floatButton = $a4FloatButton({
          scope: $scope, theme: 'finance',
          onClick: 'vm.newReceivedFile()',
          label: 'Ler novo arquivo retorno'
        });
      }
    };

    /**
     * Retorna todas as contas correntes
     */
    vm.getCurrentAccount = function () {
      $rootScope.show_loader = true;
      BankFileSendService.getCurrentAccountWithColletionConfig({show_inactive: vm.show_inactive})
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.current_account_type_bank = response.plain();
          vm.current_account_id = vm.current_account_type_bank.filter(function (item) {
            return item.is_main;
          })[0].id;

          vm.get(null, null, vm.current_account_id, vm.show_only_pending);
        });
    };

    /**
     * Recebe os detalhes do arquivo retorno
     * @param item
     */
    vm.receivedDetails = function (item) {
      item.print_details = vm.getReceivedReport;
      ModalFactory.customClean('app/finance/bank-file-receive/views/file-receive-details.html',
        'DetailsFileReceivedController', 'vm', false, item)
        .then(function (res) {
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Leitura de novo arquivo retorno
     */
    vm.newReceivedFile = function () {
      ModalFactory.customClean('app/finance/bank-file-receive/views/new-process.html',
        'NewFileReceivedController', 'vm', false, null)
        .then(function (res) {
          if (res) {
            vm.get(null, null, vm.current_account_id, vm.show_only_pending)
          }
          $rootScope.show_loader = false;
        });
    };

    vm.getReceivedReport = function (id) {
      var href = vm.webLink + 'api/reports/banfilereceivereport?token=' + vm.conf.token + '&company='
        + vm.conf.current_company + '&connection=' + vm.conf.current_connection +
        '&bank_file_receive_id=' + id;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    /**
     * Resgatas todos os arquivos retorno processados
     * @param page - pagina corrente
     * @param qtd - quantidade de registros
     * @param current_account_id - (opcional) conta corrente
     */
    vm.get = function (page, qtd, current_account_id, show_only_pending) {
      $rootScope.show_loader = true;
      page = (angular.isUndefined(page) || page === null) ? vm.file_received.current_page : page;
      qtd = vm.file_received.per_page;
      current_account_id = (angular.isUndefined(current_account_id) || current_account_id === null) ?
        vm.current_account_id : current_account_id;

      vm.promise = BankFileReceiveService.getAll({page: page, qtd: qtd, current_account_id: current_account_id, show_only_pending: show_only_pending ? show_only_pending : false})
        .then(function (resp) {
          vm.file_received = resp;
          $rootScope.show_loader = false;
        });
    };

    /**
     * Seta o arquivo selecionado
     * @param file
     */
    $scope.setFile = function (file) {
      vm.file = file;
    };


    /**
     * Simulação de preload
     */
    vm.fakePreload = function () {
      vm.preload_value = 50;
      vm.intervalPromise = $interval(vm.preload, 100);
    };

    vm.preload = function () {
      var time = parseInt(vm.preload_value);
      time = time < 100 ? time + 1 : time;
      vm.preload_value = time;
    };

    vm.endPreload = function () {
      $interval.cancel(vm.intervalPromise);
      vm.intervalPromise = null;
      vm.preload_value = null;
      vm.file = null;
    };

    /**
     * convert para valor em real
     * @param value
     * @returns {string}
     */
    vm.maskReal = function (value) {
      return Utils.realMask(value);
    };

    /**
     * Convert string para o formato XX/XX/XX
     * @param str
     * @returns {string}
     */
    vm.convertSingleDate = function (str) {
      return Utils.convertSingleDate(str);
    };

    /**
     * Retorna o valor total processado
     * @returns {string}
     */
    vm.getTotal = function () {

      var total = 0;

      if (vm.result_process != null) {

        angular.forEach(vm.result_process.collection, function (result) {
          if (vm.result_process.cnab === 240) {
            if (result.segmentoT.valorTitulo != null) {
              total = parseFloat(total) + parseFloat(result.segmentoT.valorTitulo);
            }
          } else if (vm.result_process.cnab === 400) {
            total = parseFloat(total) + parseFloat(result.valor);
          }

        });

      }

      return vm.maskReal(total.toFixed(2));

    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    $scope.$on('$destroy', function () {
      vm.floatButton.destroy();
    });

    vm.init();

  }

  angular
    .module('app.finance.bank-file-receive')
    .controller('BankFileReceiveController', BankFileReceiveController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function BillsReceivedBank(ModalExtra, $mdDialog, BankFileReceiveService, $rootScope) {
    var vm = this;
    vm.data = ModalExtra;
    vm.query = {
      limit: 1000,
      page: 1
    };

    vm.init = function () {
      vm.getAccountsByType();
    };

    vm.convertDate = function (date) {
      var cDate = date.split('-');
      return cDate[2] + '/' + cDate[1] + '/' + cDate[0]
    };

    vm.getAccountsByType = function () {
      BankFileReceiveService.getFileReceived()
        .then(function (resp) {
          vm.current_accounts_bank = resp;
          $rootScope.show_loader = false;
        })
    };

    vm.closeModal = function () {
      $rootScope.show_loader = false;
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular
    .module('app.finance.bank-file-receive')
    .controller('BillsReceivedBank', BillsReceivedBank)

})();









(function () {
  'use strict';

  /** @ngInject */
  function AdditionsService(Restangular) {
    var self = {};

    /**
     *
     * @param {type} obj
     * @returns {$q@call;defer.promise}
     */
    self.getAlladditionsRoles = function () {
      return Restangular.all("finesrule/getAll").getList();
    };

    /**
     * Faz requisição para criação da regra de acrecimos.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    self.createadditionRole = function (rule) {
      return Restangular.one("finesrule").customPOST(rule);
    };

    self.getAllCategories = function () {
      return Restangular.one('billcategory').customGET('listall', {debit_credit: 'C'});
    };

    self.getById = function (id) {
      return Restangular.one('finesrule/getbyid', id).get();
    };

    /**
     * Faz requisição para atualização da regra de ajuste.
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     * @returns {$q@call;defer.promise}
     */
    self.updateadditionsRole = function (obj) {
      return Restangular.one("finesrule", obj.id).customPUT(obj);
    };

    return self;
  }

  angular
    .module('app.finance.additions')
    .factory('AdditionsService', AdditionsService)

})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.additions', {
        url: '/settings/additions',
        public: false,
        templateUrl: 'app/finance/additions/views/index.html',
        controller: 'AdditionsController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'Regras de Acréscimos'
        }
      });
  }

  angular
    .module('app.finance.additions')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function AdditionsController(AdditionsService, $log, $timeout, Common, $rootScope, $scope) {

    var vm = this;

    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.searchTextChange = searchTextChange;

    vm.init = function () {

      vm.repos = vm.loadAll();

      vm.getAlladditionsRules();
      vm.getCategories();
      vm.includeScope = {};
      vm.includeScope.topSmall = true;
      vm.includeScope.simulateQuery = vm.simulateQuery;
      vm.includeScope.isDisabled = vm.isDisabled;
      vm.includeScope.querySearch = vm.querySearch;
      vm.includeScope.selectedItemChange = vm.selectedItemChange;
      vm.includeScope.searchTextChange = vm.searchTextChange;
      vm.includeScope.submit = vm.submit;
    };

    /**
     * Abre a sidebar.
     * @param {ev, idAside}
     */
    vm.openAside = function (ev, idAside) {
      vm.includeScope.editable = true;
      vm.includeScope.formCreate = true;
      $rootScope.$broadcast('a4.table.open.sidenav');
    };

    var listener1 = $rootScope.$on('a4-table.toggled', function (ev, item) {
      vm.includeScope.bill_category_interest = null;
      vm.includeScope.bill_category_fine = null;
      if (item != null && item.id != undefined) {
        vm.includeScope.editable = false;
        vm.getById(item.id);
      }
    });

    vm.getById = function (id) {
      $rootScope.show_loader = true;
      AdditionsService.getById(id)
        .then(function (response) {
          if (response != null) {
            vm.role = response;
            vm.includeScope.bill_category_interest = vm.role.bill_category_interest;
            vm.includeScope.bill_category_fine = vm.role.bill_category_fine;
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel resgatar este item.');
          $rootScope.show_loader = false;
        });
    };

    vm.submit = function (addition) {
      $rootScope.show_loader = true;
      if (addition.name != '' && addition.name != undefined) {
        if (addition.id == undefined || addition.id == null) {
          if (addition.is_inactive == undefined) {
            addition.is_inactive = false;
          }

          AdditionsService.createadditionRole(addition)
            .then(function () {
              Common.Toast.success("Regra adicionada com sucesso");
              $rootScope.$broadcast('a4.table.close.sidenav');
              vm.getAlladditionsRules();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro ao executar essa ação.');
              $rootScope.show_loader = false;
            });

        } else {
          if (addition.is_inactive == undefined) {
            addition.is_inactive = false;
          }
          
          AdditionsService.updateadditionsRole(addition)
            .then(function () {
              Common.Toast.success("Regra atualizada com sucesso");
              $rootScope.$broadcast('a4.table.close.sidenav');
              vm.getAlladditionsRules();
              $rootScope.show_loader = false;
            })
            .catch(function () {
              Common.Toast.error('Erro ao executar essa ação.');
              $rootScope.show_loader = false;
            });

        }
      } else {
        Common.Toast.error('O nome é obrigatório');
      }
    };

    vm.getAlladditionsRules = function () {
      $rootScope.show_loader = true;
      vm.allRoles = [];
      AdditionsService.getAlladditionsRoles()
        .then(function (response) {
          vm.allRoles = response;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna as categorias
     */
    vm.getCategories = function () {
      AdditionsService.getAllCategories()
        .then(function (response) {
          vm.allCategories = vm.parseCategoryList(response.nodes);
          vm.includeScope.allCategories = vm.allCategories;
        })
        .catch(function () {
          Common.Toast.error('Erro ao executar essa ação.');
        });
    };

    vm.parseCategoryList = function (list) {
      var result = [];
      if (list != null && list.length > 0) {
        angular.forEach(list, function (item) {
          if (item.nodes.length > 0) {
            angular.forEach(item.nodes, function (cat) {
              result.push(cat);
            });
          }
        });
      } else {
        result = list;
      }
      return result;
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      var results = query ? vm.includeScope.allCategories.filter(createFilterFor(query)) : vm.includeScope.allCategories,
        deferred;
      if (vm.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () {
          deferred.resolve(results);
        }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Create filter function for a query string
     */
    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    /**
     * Build `components` list of key/value pairs
     */
    vm.loadAll = function () {
      var repos = [];
      return repos.map(function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    };

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };

    }

    $scope.$on('$destroy', function () {
      [listener1].forEach(function (fn) {
        fn();
      });
    });

    vm.init();

  }


  angular
    .module('app.finance.additions')
    .controller('AdditionsController', AdditionsController);

})();

(function () {
  'use strict';

  angular
    .module('app.finance.a4pag', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function A4PagService(Restangular) {
    return {
      membership: function () {
        return Restangular.one('a4pag').all('membership').post()
      }
    }
  }

  angular
    .module('app.finance.a4pag')
    .factory('A4PagService', A4PagService);

})();

(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.a4pag', {
        url: '/a4pag',
        public: false,
        templateUrl: 'app/finance/a4pag/index.html',
        controller: 'A4PagController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'A4Pag'
        }
      });
  }

  angular
    .module('app.finance.a4pag')
    .config(routerConfig);


})();



// (function () {
//   'use strict';

//   /** @ngInject */
//   function run(msNavigationService, PoliciesService) {
//     var role = 'a4pag_menu';
//     var path = 'finance.a4pag';

//     msNavigationService.saveItem('finance.a4pag', {
//       title: 'A4 Pag',
//       icon: 'icon-cash-100',
//       state: 'private.finance.a4pag',
//       weight: 30,
//       badge: {
//         content: 'Novo!',
//         color: 'green'
//       },
//       hidden: function () {
//         return !PoliciesService.checkPolicyAndProfile(role, path);
//       }
//     });
//   }

//   angular
//     .module('app.finance.nfse')
//     .run(run);

// })();



(function () {
  'use strict';

  /** @ngInject */
  function A4PagController($rootScope, A4PagService, ModalFactory, BankSlipService) {
    var vm = this;

    vm.imagePath = '../assets/images/backgrounds/backgroudcard.jpg';
    vm.windowHeight = angular.element("#main").height();
    vm.has_a4pag_account = false;

    vm.init = function () {
      BankSlipService.hasA4PagAccount()
        .then(function (response) {
          vm.has_a4pag_account = response;
        });
      vm.getBankSlipsPendingRegister();
    };

    /**
     * Retorna os boletos pendentes de registro e uma contagem dos boletos com problemas
     */
    vm.getBankSlipsPendingRegister = function () {
      BankSlipService.getBankSlipsPendingRegisterA4Pag()
        .then(function (response) {
          vm.data = response;
        });
    };

    vm.openModalBankSlipsProblems = function () {
      ModalFactory.customClean('app/finance/a4pag/views/bank-slip-problems-modal.html',
       'A4PagBankSlipsController', 'vm', false, vm.data)
        .then(function (res) {
          // $rootScope.show_loader = false;
        })
        .catch(function () {
          // $rootScope.show_loader = false;
        });
    };

    /**
     * Solicita a adesão
     */
    vm.membership = function () {
      ModalFactory.confirm(null,
        "Confirmar pedido de adesão?",
        "Ao confirmar o A4Cloud enviará um pedido para nossa equipe. :D",
        "Confirmar", "Cancelar", "finance")
        .then(function () {
          vm.loading = true;
          $rootScope.show_loader = true;
          A4PagService.membership()
            .then(function (response) {
              $rootScope.show_loader = false;
              if (response) {
                vm.loading = false;
                ModalFactory.alert(
                  'Olá!',
                  'Recebemos sua solicitação e já estamos trabalhando nisso. Aguarde o contato da nossa equipe.',
                  'Recebemos sua solicitação e já estamos trabalhando nisso. Aguarde o contato da nossa equipe.',
                  'Entendi!');
              } else {
                vm.loading = false;
                ModalFactory.alert(
                  'Olá!',
                  'Houve um problema na sua solicitação, entre em contato com o nosso SUPORTE.',
                  'Houve um problema na sua solicitação, entre em contato com o nosso SUPORTE.',
                  'Entendi!');
              }
            })
            .catch(function (response) {
              vm.loading = false;
              $rootScope.show_loader = false;
              if (response.message == 'Já existe um cliente com este CNPJ') {
                ModalFactory.alert(
                  'Olá!',
                  'Verificamos que já realizou um pedido aguarde o contato da nossa equipe.',
                  'Verificamos que já realizou um pedido aguarde o contato da nossa equipe.',
                  'Entendi!');
              } else {
                vm.loading = false;
                $rootScope.show_loader = false;
                ModalFactory.alert(
                  'Olá!',
                  response.message,
                  response.message,
                  'Entendi!');
              }
            })
        });
    };

    vm.init();
  }
  angular
    .module('app.finance.a4pag')
    .controller('A4PagController', A4PagController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function A4PagBankSlipsController($rootScope, A4PagService, ModalExtra, $filter, $mdDialog) {
    var vm = this;

    vm.has_a4pag_account = false;

    vm.init = function () {
      vm.data = ModalExtra;
      vm.filterBankSlips();
    };

    /**
     * Filtra a lista de acordo com o problema para listas do modal
     * @returns {*}
     */
    vm.filterBankSlips = function(){
      vm.error_national_id_number = $filter('filter')(vm.data.bank_slips, {error_national_id_number: true});
      vm.error_address_postal_code_invalid = $filter('filter')(vm.data.bank_slips, {error_address_postal_code_invalid: true});
      vm.error_address_postal_code = $filter('filter')(vm.data.bank_slips, {error_address_postal_code: true});
      vm.error_address_house_number = $filter('filter')(vm.data.bank_slips, {error_address_house_number: true});
      vm.error_address_street = $filter('filter')(vm.data.bank_slips, {error_address_street: true});
      vm.error_address_district = $filter('filter')(vm.data.bank_slips, {error_address_district: true});
      vm.error_address_city = $filter('filter')(vm.data.bank_slips, {error_address_city: true});
      vm.error_address_state = $filter('filter')(vm.data.bank_slips, {error_address_state: true});
      vm.alert_fine_value = $filter('filter')(vm.data.bank_slips, {alert_fine_value: true});
      vm.alert_interest_value = $filter('filter')(vm.data.bank_slips, {alert_interest_value: true});
      vm.alert_discounts = $filter('filter')(vm.data.bank_slips, {alert_discounts: true});
    };

    vm.closeModal = function () {
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular
    .module('app.finance.a4pag')
    .controller('A4PagBankSlipsController', A4PagBankSlipsController)
    .directive('bankslipstable', function () {
    return {
      scope: {
        list: '='
      },
      restrict: 'E',
      templateUrl: 'app/finance/a4pag/views/bank-slips-table.html',
      controller: (function ($scope, BankFileReceiveService, Common, $state, $mdDialog) {
        var vm = this;
        vm.data = $scope.list;

        /**
         * Formata a string de beneficiarios do boleto
         * @param beneficiaries
         */
        vm.formatBeneficiaries = function (beneficiaries) {
          return angular.fromJson(beneficiaries.replace('{', '[').replace('}', ']'));
        };

        /**
         * Redireciona para a página do cadastro da pessoa
         * @param person_id
         */
        vm.goToPerson = function(person_id){
          $mdDialog.cancel();
          $state.go('private.finance.person-profile', {id: person_id});
        };
      }),
      controllerAs: 'vm'
    };
  });

})();

(function () {
  'use strict';

  /** @ngInject */
  function TypingDateService(Restangular) {

    /**
     * Retorna todos os critérios
     * @returns array
     */
    var getEventsLaunched = function (obj) {
      return Restangular.one('graderule').one('geteventslaunched').get(obj);
    };

    /**
     * Retorna o critério pelo id
     * @returns array
     */
    var getById = function (id) {
      return Restangular.one('graderule', id).get();
    };

    /**
     * Cria um novo critério
     * @param obj
     */
    var saveTypingDates = function (obj) {
      return Restangular.one('graderule').all('savetypingdates').post(obj);
    };

    /**
     * Atualiza o critério
     * @param obj
     */
    var updateGradeRule = function (obj) {
      return Restangular.one('graderule', obj.id).customPUT(obj);
    };

    /**
     * Cria ou atualiza os itens de regras de critérios
     * @param obj
     */
    var createAndUpdateGradeRuleItem = function (obj) {
      return Restangular.all('graderule/createandupdategraderuleitem').post(obj);
    };

    var getGradeRoundRule = function () {
      return Restangular.all('graderule').one('getgraderoundrule').get();
    };

    /**
     * Deleta um critério
     * @param id - id do critério
     */
    var deleteCriteria = function (id) {
      return Restangular.one('graderule', id).remove();
    };

    /**
     * Deleta um evento do critério
     * @param id - id do evento do critério
     */
    var deleteGradeRuleItem = function (id) {
      return Restangular.one('graderule').one('deletegraderuleitem', id).remove();
    };

    /**
     * Formata uma string com o nome do evento e descrição
     * @param items
     * @returns {*}
     */
    var formatEventNameDescription = function (items) {
      items.forEach(function (item) {

        item.name_event = item.name + ' | ' + item.description;

      });

      return items;
    };


    return {
      getEventsLaunched: getEventsLaunched,
      getById: getById,
      deleteCriteria: deleteCriteria,
      saveTypingDates: saveTypingDates,
      updateGradeRule: updateGradeRule,
      createAndUpdateGradeRuleItem: createAndUpdateGradeRuleItem,
      getGradeRoundRule: getGradeRoundRule,
      deleteGradeRuleItem: deleteGradeRuleItem,
      formatEventNameDescription: formatEventNameDescription

    };

  }

  angular
    .module('app.educational.typing-date')
    .factory('TypingDateService', TypingDateService);

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.typing-date', {
        public: false,
        url: '/typing/date',
        templateUrl: 'app/educational/typing-date/views/typing-date.html',
        abstract: true
      })
      .state('private.educational.typing-date.list', {
        url: '/list',
        public: false,
        views: {
          'typing-date': {
            templateUrl: 'app/educational/typing-date/views/list.html',
            controller: 'TypingDateController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.typing-date.edit', {
        url: '/:id/view',
        public: false,
        views: {
          'typing-date': {
            templateUrl: 'app/educational/typing-date/views/typing-date-page.html',
            controller: 'TypingDateEditController',
            controllerAs: 'vm'
          }
        }
      })

  }

  angular
    .module('app.educational.typing-date')
    .config(routerConfig);

})();



(function () {
  'use strict';

  /** @ngInject */
  function TypingDateEditController($rootScope, $state, $timeout, $filter, EvaluationCriteriaService, Common, ClassGroupingService, TypingDateService) {

    var vm = this;
    vm.search_text = '';
    vm.replaceRegex = /(\W|\s)/g;
    vm.selected = null;
    vm.form = {
      mode_edit: true,
      evaluation_criteria: {}
    };
    vm.list = {
      grade_rule: {
        block_type: []
      }
    };

    vm.list.grade_rule.block_type = [
      {
        id: 1,
        name: "Sem bloqueio",
        description: 'As notas podem ser lançadas/alteradas a qualquer tempo. As datas de abertura e encerramento serão ' +
        'usadas apenas para alertar os professores do período de lançamento.'
      },
      {
        id: 2,
        name: "Bloqueio para alteração",
        description: 'As notas só poderão ser lançadas e alteradas a partir da data de abertura. A partir da data do' +
        ' encerramento nenhuma nota já lançada poderá ser alterada.'
      },
      {
        id: 3,
        name: "Bloqueio para lançamento e alteração",
        description: 'As notas só poderão ser lançadas e alteradas a partir da data de abertura. A partir da data de ' +
        'encerramento nenhuma nota poderá ser mais lançada nem alterada.'
      }];

    vm.init = function () {
      /**
       * Timeout posto por tempo de carregamento do form por ser muito grande
       * estar atrapalhando o carregamento dos dados
       */
      vm.getById($state.params.id);
    };

    /**
     * Resgata o objeto referente ao critério
     * @param id - identificador do critério
     */
    vm.getById = function (id) {
      $rootScope.show_loader = true;
      TypingDateService.getEventsLaunched({grade_rule_id: id})
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.form.grade_rule = response.grade_rule;
          vm.form.grade_rule.grade_rule_items = response.grade_rule_items;
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Não foi possivel recuperar o critério.');
        });
    };

    /**
     * Submissão para atualização de critério
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        $rootScope.show_loader = true;
        TypingDateService.saveTypingDates(item)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Critério atualizado com sucesso');
            $state.go('private.educational.typing-date.list');
          })
          .catch(function (response) {
            $rootScope.show_loader = false;
            if (response.data.message === 'CLOSE_DATE_ERROR') {
              Common.Toast.warning('Existe uma data de fechamento menor que uma data de abertura.');
            }
          });
      }
    };

    vm.close = function () {
      $state.go('private.educational.typing-date.list');
    };

    vm.init();

  }

  angular
    .module('app.educational.typing-date')
    .controller('TypingDateEditController', TypingDateEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function TypingDateController($rootScope, $scope, $state, $a4FloatButton, EvaluationCriteriaService) {

    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.form = {};

    vm.init = function () {
      vm.paginate();
      // vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createEvaluationCriteria()', icon: 'icon-plus'});
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterEvaluationCriteriaList = function (query) {
      EvaluationCriteriaService.getAll({query: query})
        .then(function (response) {
          vm.grid.rows = response;
        })
    };

    /**
     * Manda para a criação de critérios
     */
    vm.createEvaluationCriteria = function () {
      $state.go('private.educational.evaluation-criteria.create');
    };

    /**
     * Edição do critério
     * @param item - item a ser editado
     */
    vm.editEvaluationCriteria = function (item) {
      $state.go('private.educational.typing-date.edit', {id: item.id});
    };

    /**
     * Paginação dos critérios existentes
     */
    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = EvaluationCriteriaService.getAll({limit: limit, page: page, typing_block: true})
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.grid = response;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.init();

  }

  angular
    .module('app.educational.typing-date')
    .controller('TypingDateController', TypingDateController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function TimetableTemplateService(Restangular) {

    /**
     * Retorna todos os templates de grade horário
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('timetabletemplate').get(obj);
    };

    var create = function (data) {
      return Restangular.all('timetabletemplate').post(data);
    };

    var update = function (data) {
      return Restangular.one('timetabletemplate', data.id).customPUT(data);
    };

    var getById = function (id) {
      return Restangular.one('timetabletemplate', id).get();
    };

    var getItemsByTemplateId = function (obj) {
      return Restangular.one('timetabletemplate').one('getitemsbytemplateid').get(obj);
    };


    var deleteTimetable = function (id) {
      return Restangular.one('timetabletemplate', id).remove();
    };


    return {
      getAll: getAll,
      update: update,
      getById: getById,
      getItemsByTemplateId: getItemsByTemplateId,
      create: create,
      deleteTimetable: deleteTimetable
    };

  }

  angular
    .module('app.educational.timetable-template')
    .factory('TimetableTemplateService', TimetableTemplateService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.timetable-template', {
        url: '/timetable-template',
        public: false,
        templateUrl: 'app/educational/timetable-template/views/index.html',
        controller: 'TimetableTemplateController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'TimetableTemplate'
        }
      });
  }

  angular
    .module('app.educational.timetable-template')
    .config(routerConfig);


})();
(function() {
  'use strict';

  /** @ngInject */
  function run(){
    /*msNavigationService.saveItem('timetable-template', {
      title : 'Grade de Horário',
      icon  : 'icon-timetable',
      state : 'private.educational.timetable-template'
    });*/
  }

  angular
    .module('app.educational.timetable-template')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function TimetableTemplateEditController($rootScope, TimetableTemplateService, Common, ModalExtra, ModalFactory, a4Moment) {
    var vm = this;

    vm.form = {
      mode_edit: true,
      timetable_template: {},
      timetable_template_item: []
    };

    vm.init = function () {
      vm.form.timetable_template = ModalExtra;
      vm.getItemsByTemplateId(vm.form.timetable_template);
    };


    /**
     * Pega as faixas de horário do grid de horários
     * @param item - item
     */
    vm.getItemsByTemplateId = function (item) {
      TimetableTemplateService.getItemsByTemplateId(item)
        .then(function (response) {
          vm.tratado = response.plain();

          angular.forEach(vm.tratado, function (item) {
            var initial_time = item.initial_time.split(":");
            var final_time = item.final_time.split(":");
            item.initial_time = a4Moment('2020-01-01 ' + parseInt(initial_time[0]) + ':' + parseInt(initial_time[1]) + ':' + parseInt(initial_time[2])).format('HH:mm');
            item.final_time = a4Moment('2020-01-01 ' + parseInt(final_time[0]) + ':' + parseInt(final_time[1]) + ':' + parseInt(final_time[2])).format('HH:mm');
          });
          if (vm.tratado.length > 0) {
            vm.form.timetable_template_item = vm.tratado;
          }
          $rootScope.show_loader = false;
        });
    };

    vm.submit = function (item, form) {
      if (form.$valid) {
        TimetableTemplateService.update(item)
          .then(function () {
            Common.Toast.success('Template atualizado com sucesso');
            vm.close();
            $rootScope.$broadcast('update.timetable-template.list');
          }).catch(function (response) {
          switch (response.data.message) {
            case "DUPLICATED_NAME":
              Common.Toast.warning('Existe um template com esse nome no sistema.');
              vm.paginate();
              break;
            case "EMPTY_NAME":
              Common.Toast.warning('Nome do template não pode ficar em branco.');
              vm.paginate();
              break;
            case "SHOCK_BETWEEN_SCHEDULES":
              Common.Toast.warning('Não foi possível salvar, está ocorrendo choque entre horários.');
              vm.paginate();
              break;
            default:
              Common.Toast.error('Não foi possivel editar o template.');
              vm.paginate();
              break;
          }
        });
      }
    };

    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular
    .module('app.educational.timetable-template')
    .controller('TimetableTemplateEditController', TimetableTemplateEditController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function TimetableTemplateCreateController($rootScope, TimetableTemplateService, Common) {
    var vm = this;

    vm.form = {
      mode_edit: true,
      timetable_template: {
        weeks_in_sequency: 1
      },
      timetable_template_item: []
    };

    vm.init = function () {
    };

    vm.submit = function (item, form) {
      if (form.$valid) {
        item.weeks_in_sequency = 1;
        TimetableTemplateService.create(item)
          .then(function () {
            Common.Toast.success('Template criado com sucesso');
            $rootScope.show_loader = false;
            vm.close();
            $rootScope.$broadcast('update.timetable-template.list');
          })
          .catch(function (response) {
            $rootScope.show_loader = false;
            switch (response.data.message) {
              case "DUPLICATED_NAME":
                Common.Toast.warning('Existe um template com esse nome no sistema.');
                vm.paginate();
                break;
              case "EMPTY_NAME":
                Common.Toast.warning('Nome do template não pode ficar em branco.');
                vm.paginate();
                break;
               case "SHOCK_BETWEEN_SCHEDULES":
                  Common.Toast.warning('Não foi possível salvar, está ocorrendo choque entre horários.');
                  vm.paginate();
                  break;
              default:
                Common.Toast.error('Não foi possivel editar o template.');
                vm.paginate();
                break;
            }
          })
        }
    };

    vm.paginate = function (page, limit) {
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = TimetableTemplateService.getAll({limit:limit, page:page})
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [50, 100, 150,{
              label: 'Todas',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
          $rootScope.show_loader = false;
        });
    };

    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular
    .module('app.educational.timetable-template')
    .controller('TimetableTemplateCreateController', TimetableTemplateCreateController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function TimetableTemplateController($rootScope, $scope, $a4FloatButton, ModalFactory, Common, TimetableTemplateService) {

    var vm = this;

    var ltn1 = $rootScope.$on('update.timetable-template.list', function () {
      vm.paginate();
    });

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.currentDate = new Date();

    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = TimetableTemplateService.getAll({limit:limit, page:page})
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [50, 100, 150,{
              label: 'Todas',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
          $rootScope.show_loader = false;
        });
    };


    vm.form = {};

    vm.init = function () {
      vm.paginate();
      vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createTimetableTemplate()'});
    };

    /**
     * Abre o modal de criação de template de grade de horário
     */
    vm.createTimetableTemplate = function () {
      ModalFactory.customClean(
        'app/educational/timetable-template/views/form.html',
        'TimetableTemplateCreateController',
        'vm', false
      );
      $rootScope.show_loader = false;
    };

    /**
     * Abre o modal de edição de template de grade de horário
     * @param item - item clicado
     */
    vm.editTimetableTemplate = function (item) {
      $rootScope.show_loader = true;
      TimetableTemplateService.getById(item.id)
        .then(function (response) {
          $rootScope.show_loader = false;
          var template = response.plain();
          ModalFactory.customClean('app/educational/timetable-template/views/form.html',
            'TimetableTemplateEditController',
            'vm', false, template
            );
        }).catch(function () {
        $rootScope.show_loader = false;
      });
    };

    vm.delete = function (index) {
      ModalFactory.confirm(null,
        'Confirmação de Exclusão',
        'Deseja realmente excluir o template?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          TimetableTemplateService.deleteTimetable(index)
            .then(function () {
              Common.Toast.success('Template excluído com sucesso!');
              vm.paginate();
            })
        }).catch(function (response) {
        switch (response.data.message) {
          default:
            Common.Toast.error('Não foi possivel remover o template.');
            vm.paginate();
            break;
        }
      })

    };

    vm.openSide = function () {
      $rootScope.$broadcast('a4.table.open.sidenav');
    };

    $scope.$on('$destroy', function () {
      [ltn1].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.timetable-template')
    .controller('TimetableTemplateController', TimetableTemplateController);

})();


(function () {
  'use strict';

  angular
    .module('app.educational.tables', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function EducationalTablesService(Restangular) {

    var vm = this;

    vm.getAll = function (obj) {
      return Restangular.one('tables').get(obj);
    };
    vm.create = function (obj) {
      return Restangular.all('tables').post(obj);
    };
    vm.delete = function (obj) {
      return Restangular.one('tables', obj.id).remove(obj);
    };
    vm.update = function (obj) {
      return Restangular.one('tables', obj.id).customPUT(obj);
    };
    return vm;
  }

  angular
    .module('app.educational.tables')
    .factory('EducationalTablesService', EducationalTablesService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.tables', {
        url: '/tables',
        public: false,
        templateUrl: 'app/educational/tables/views/index.html',
        controller: 'EducationalTablesController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Tabelas'
        }
      });
  }

  angular
    .module('app.educational.tables')
    .config(routerConfig);
})();



(function () {
  'use strict';

  /** @ngInject */
  function EducationalTablesController($scope, $a4FloatButton, $mdDialog, ModalFactory, Common, DiscountsService, $rootScope,
                                       CancelReasonsService, $mdEditDialog, EducationalTablesService) {

    var vm = this;
    vm.items = {
      data: []
    };
    vm.grid = [];
    vm.selected = [];
    vm.query_filter = '';
    vm.crud_options = {
      fields_dictionary: {
        id: 'Código',
        nome: 'Nome do indivíduo',
        idade: 'Quantos anos tem',
        raca: 'Raça'
      }
    };
    vm.filter_show = false;
    vm.filter = {
      options: {
        debounce: 500
      },
      show: false
    };
    vm.table = {};

    vm.tables = [
      {id: 'enrolment_cancel_reason', name: 'Motivos de cancelamento', columns: [{id: 'name', name: 'Nome'}]},
      {id: 'general_event_type', name: 'Tipos de evento gerais', columns: [{id: 'name', name: 'Nome'}]},
      {id: 'charge_event_type', name: 'Tipos de evento de cobrança', columns: [{id: 'name', name: 'Nome'}]},
      {id: 'person_function', name: 'Função na empresa', columns: [{id: 'name', name: 'Nome'}]},
      {id: 'person_sector', name: 'Setor da empresa', columns: [{id: 'name', name: 'Nome'}]}
      /*{id: 'country', name: 'Países', columns: [{id: 'name', name: 'Nome'}, {id: 'nationality', name: 'Nacionalidade'}]}*/
    ];
    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      $rootScope.show_loader = true;
      vm.openModalChangeTable();
    };

    /**
     * Form de criação
     */
    vm.openModalAddItem = function () {
      ModalFactory.custom(
        'app/educational/tables/views/modal-add-item.html',
        {columns: vm.table.columns},
        true
      ).then(function (item) {
        vm.createItem(item);
      });
    };

    /**
     * Criação de item
     * @param data
     */
    vm.createItem = function (data) {
      $rootScope.show_loader = true;
      EducationalTablesService.create({data: data, table: vm.table.id})
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Item criado com sucesso!');
          vm.changeTable(vm.table);
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao criar item');
        })
    };

    /**
     * Edição de item
     * @param id
     * @param column
     * @param data
     */
    vm.editItem = function (id, column, data) {
      $rootScope.show_loader = true;
      var obj = {};
      obj[column] = data;
      EducationalTablesService.update({id: id, data: obj, table: vm.table.id})
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Item editado com sucesso!');
        })
        .catch(function () {
          $rootScope.show_loader = false;
          vm.changeTable(vm.table);
          Common.Toast.error('Erro ao editar item');
        })
    };

    /**
     * Seleção da tabela
     */
    vm.openModalChangeTable = function () {
      ModalFactory.custom(
        'app/educational/tables/views/modal-change-table.html',
        {tables: vm.tables},
        true
      ).then(function (table) {
        vm.changeTable(table);
      });
    };

    /**
     * Modifica a lista de itens de acordo com a tabela selecionada no modal
     * @param table
     */
    vm.changeTable = function (table) {
      $rootScope.show_loader = true;
      EducationalTablesService.getAll({table: table.id})
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.table = table;
          vm.items.data_bkp = response.plain();
          vm.items.data = response.plain();
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao buscar itens');
        })
    };

    /**
     * Remove o filtro da lista
     */
    vm.removeFilter = function () {
      vm.filter.show = false;
      vm.query_filter = '';
    };

    /**
     * Exclui um motivo de cancelamento
     * @param id
     * @param name
     */
    vm.delete = function (id, name) {
      ModalFactory.confirm(null, 'Excluir item', 'Confirma a exclusão do item ' + name + '?',
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          $rootScope.show_loader = true;
          EducationalTablesService.delete({id: id, table: vm.table.id})
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Item excluído com sucesso!');
              vm.changeTable(vm.table);
            })
            .catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Não foi possível excluir o item');
            })
        })
    };

    /**
     * Edita um motivo de cancelamento
     * @param item
     */
    vm.editReason = function (item) {
      ModalFactory.prompt(null, 'Edição de motivo de cancelamento',
        'Digite o novo motivo de cancelamento', '', item.name,
        'Salvar', 'Cancelar', 'educational').then(function (reason) {
        $rootScope.show_loader = true;
        CancelReasonsService.updateCancelReason({name: reason, id: item.id}).then(function () {
          vm.getAllReasons();
          Common.Toast.success('Motivo atualizado com sucesso!');
        })

      })
    };

    /**
     * Abre o input para edição do item
     * @param event
     * @param item
     * @param column
     */
    vm.editComment = function (event, item, column) {
      event.stopPropagation();
      var promise = $mdEditDialog.small({
        modelValue: item[column],
        placeholder: 'Add a comment',
        save: function (input) {
          vm.editItem(item.id, column, input.$modelValue);
          item[column] = input.$modelValue;
        },
        targetEvent: event,
        validators: {
          'md-maxlength': 100
        }
      });
      promise.then(function (ctrl) {
        var input = ctrl.getInput();
        input.$viewChangeListeners.push(function () {
          // dessert.name = input.$modelValue;
          input.$setValidity('test', input.$modelValue !== 'test');
          // input.$setViewValue('aberto');
        });
      });
    };

    vm.init();
  }


  angular
    .module('app.educational.tables')
    .controller('EducationalTablesController', EducationalTablesController);

})();

(function() {
    'use strict';
    angular
        .module('app.educational.subject', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function SubjectService(Restangular) {

    /**
     * Retorna todos os cursos
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('subject').get(obj);
    };

    /**
     * Retorna todos os cursos exceto os informados na lista
     * @returns array
     */
    var getAllExcept = function (obj) {
      return Restangular.all('subject').getList(obj);
    };

    var create = function (data) {
      return Restangular.all('subject').post(data);
    };

    var update = function (data) {
      return Restangular.one('subject', data.id).customPUT(data);
    };

    var get = function (id) {
      return Restangular.one('subject', id).get();
    };

    var deleteSubject = function (id) {
      return Restangular.one('subject', id).remove();
    };

    var getCoursesWithSubject = function (obj) {
      return Restangular.one('subject').one('getcourseswithsubject').get(obj);
    };

    var isAssociatedToMatrix = function (id) {
      return Restangular.one('/subject/isassociated', id).get();
    };

    var associateSubjectToPeriod = function (data) {
      return Restangular.one('subject').all('associatesubjecttoperiod').post(data);
    };

    var editAssociatedSubjectPeriod = function (data) {
      return Restangular.one('subject').all('editassociatedsubjectperiod').post(data);
    };

    /**
     * Retorna a disciplina desejada na pesquisa
     * @returns array
     */
    var searchSubjects = function (query) {
      return Restangular.one('subject').one('searchsubjects').get(query);
    };

    var getSubjectsRequirements = function (obj) {
      return Restangular.one('subject').one('getsubjectsrequirements').get(obj);
    };

    var getPreviousSubjectsRequirements = function (obj) {
      return Restangular.one('subject').one('getprevioussubjectsrequirements').get(obj);
    };

    var getSubjectPeriodById = function (obj) {
      return Restangular.one('subject').one('getsubjectperiodbyid').get(obj);
    };

    var getSubjectClassifications = function () {
      return Restangular.one('subject').one('getsubjectclassifications').get();
    };

    var getSubjectKnowledgeAreas = function () {
      return Restangular.one('subject').one('getsubjectknowledgeareas').get();
    };

    var getSubjectNationalCurriculum = function () {
      return Restangular.one('subject').one('getsubjectnationalcurriculum').get();
    };

    var getSubjectsWithEquivalence = function (obj) {
      return Restangular.one('subject').one('getsubjectswithequivalence').get(obj);
    };

    var createSubjectsRequirements = function (data) {
      return Restangular.all('subjectrequirement').post(data);
    };

    var deleteSubjectPeriod = function (data) {
      return Restangular.one('subject').all('deletesubjectperiod').post(data);
    };

    var getSubjectsForEnrolment = function (data) {
      return Restangular.one('subject').one('getsubjectsenrolment').get(data);
    };

    var getGroupsForSubject = function (data) {
      return Restangular.one('subject').one('getgroupsforsubject').get(data);
    };

    var getSubjectsForLessonPlanCourse = function (data) {
      return Restangular.one('subject').one('getsubjectsforlessonplancourse').get(data);
    };

    var getSubjectsGroup = function (data) {
      return Restangular.one('subject').one('getsubjectsgroup').get(data);
    };

    var getSubjectByGradeRule = function (obj) {
      return Restangular.one('subject').one('getsubjectsbygraderule').get(obj)
    };


    return {
      getAll: getAll,
      getAllExcept: getAllExcept,
      update: update,
      get: get,
      create: create,
      deleteSubject: deleteSubject,
      getSubjectsForLessonPlanCourse: getSubjectsForLessonPlanCourse,
      searchSubjects: searchSubjects,
      getCoursesWithSubject: getCoursesWithSubject,
      isAssociatedToMatrix: isAssociatedToMatrix,
      associateSubjectToPeriod: associateSubjectToPeriod,
      getSubjectsRequirements: getSubjectsRequirements,
      getPreviousSubjectsRequirements: getPreviousSubjectsRequirements,
      getSubjectClassifications: getSubjectClassifications,
      getSubjectKnowledgeAreas: getSubjectKnowledgeAreas,
      getSubjectNationalCurriculum: getSubjectNationalCurriculum,
      createSubjectsRequirements: createSubjectsRequirements,
      getSubjectPeriodById: getSubjectPeriodById,
      getSubjectsWithEquivalence: getSubjectsWithEquivalence,
      editAssociatedSubjectPeriod: editAssociatedSubjectPeriod,
      deleteSubjectPeriod: deleteSubjectPeriod,
      getSubjectsForEnrolment: getSubjectsForEnrolment,
      getGroupsForSubject: getGroupsForSubject,
      getSubjectsGroup: getSubjectsGroup,
      getSubjectByGradeRule: getSubjectByGradeRule
    };

  }

  angular
    .module('app.educational.subject')
    .factory('SubjectService', SubjectService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.subject', {
        url: '/subject',
        public: false,
        templateUrl: 'app/educational/subject/views/subject.html',
        controller: 'SubjectController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.educational.subject')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'disc_menu';
    var path = 'config.subject';
    msNavigationService.saveItem(path, {
      title: 'Disciplinas',
      icon: 'icon-book-open',
      auth: role,
      state: 'private.educational.subject',
      weight: 2,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.subject')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function SubjectEditController($rootScope, BillReceiptService, SubjectService, Common, ModalExtra, EducationalService) {
    var vm = this;
    vm.academic_type = 1;
    vm.is_bilingual_school = false;

    vm.list = {
      subject: {}
    };

    vm.form = {
      mode_edit: true
    };

    vm.init = function () {
      vm.form.subject = ModalExtra;
      EducationalService.getAcademicTypeOfCompany().then(function (response) {
        vm.academic_type = response;
        vm.getSubjectClassifications();
        vm.getSubjectKnowledgeAreas();
        vm.getSubjectNationalCurriculum();
        BillReceiptService.getConfig().then(function (config) {
          config = config.plain();
          vm.is_bilingual_school = config.is_bilingual_school;
        })
      });
    };

    vm.getSubjectClassifications = function () {
      SubjectService.getSubjectClassifications()
        .then(function (response) {
          vm.list.subject.subject_classification_id = response;
          $rootScope.show_loader = false;
        })
    };

    vm.getSubjectKnowledgeAreas = function () {
      SubjectService.getSubjectKnowledgeAreas()
        .then(function (response) {
          vm.list.subject.subject_knowledge_area_id = response;
          $rootScope.show_loader = false;
        })
    };

    vm.getSubjectNationalCurriculum = function () {
      SubjectService.getSubjectNationalCurriculum()
        .then(function (response) {
          vm.list.subject.subject_national_curriculum_id = response;
          $rootScope.show_loader = false;
        })
    };


    vm.submit = function (item, form) {
      if (form.$valid) {
        SubjectService.update(item)
          .then(function () {
            Common.Toast.success('Disciplina atualizada com sucesso');
            vm.close();
            $rootScope.$broadcast('update.subject.list');
          })
          .catch(function (warning) {
            if (angular.isObject(warning.data)) {
              angular.forEach(warning.data, function (value, key) {

                switch (value[0]) {
                  case 'ALIAS_IS_REQUIRED':
                    Common.Toast.warning('Campo apelido é obrigatório ');
                    break;
                  case 'ALIAS_SHOULD_BE_A_STRING':
                    Common.Toast.warning('Campo apelido apenas texto ');
                    break;
                  case 'ALIAS_IS_UNIQUE_COLUMN':
                    Common.Toast.warning('Já existe disciplina com este apelido ');
                    break;
                  case 'ALIAS_MAX_CHARACTER_EXCEDEED':
                    Common.Toast.warning('Quantidade de caracteres excedido ');
                    break;
                  case 'NAME_MUST_BE_A_STRING':
                    Common.Toast.warning('Campo nome apenas texto ');
                    break;
                  case 'NAME_IS_REQUIRED':
                    Common.Toast.warning('Campo nome é obrigatório ');
                    break;
                  case 'NAME_IS_UNIQUE_COLUMN':
                    Common.Toast.warning('Já existe disciplina com este nome ');
                    break;
                  case 'NAME_MAX_CHARACTER_EXCEDEED':
                    Common.Toast.warning('Quantidade de caracteres excedido ');
                    break;
                  case 'COMPANY_ID_IS_REQUIRED':
                    Common.Toast.warning('Campo Apelido é obrigatório ');
                    break;
                  default:
                    break;
                }
              });
            }

          })
      }
    };

    vm.init();

    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

  }

  angular
    .module('app.educational.subject')
    .controller('SubjectEditController', SubjectEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function SubjectCreateController($rootScope, SubjectService, Common, ModalExtra, EducationalService, BillReceiptService,
                                   $mdDialog) {
    var vm = this;
    vm.academic_type = 1;
    vm.is_bilingual_school = false;

    vm.list = {
      subject: {}
    };

    vm.form = {
      mode_edit: true,
      subject: {
        name: angular.isDefined(ModalExtra) ? ModalExtra.name : undefined,
        special_type: angular.isDefined(ModalExtra) ? ModalExtra.special_type : undefined
      }
    };

    vm.init = function () {
      EducationalService.getAcademicTypeOfCompany().then(function (response) {
        vm.academic_type = response;
        vm.getSubjectClassifications();
        vm.getSubjectKnowledgeAreas();
        vm.getSubjectNationalCurriculum();
        BillReceiptService.getConfig().then(function (config) {
          config = config.plain();
          vm.is_bilingual_school = config.is_bilingual_school;
        })
      });

    };

    vm.getSubjectClassifications = function () {
      SubjectService.getSubjectClassifications()
        .then(function (response) {
          vm.list.subject.subject_classification_id = response;
          $rootScope.show_loader = false;
        })
    };

    vm.getSubjectKnowledgeAreas = function () {
      SubjectService.getSubjectKnowledgeAreas()
        .then(function (response) {
          vm.list.subject.subject_knowledge_area_id = response;
          $rootScope.show_loader = false;
        })
    };

    vm.getSubjectNationalCurriculum = function () {
      SubjectService.getSubjectNationalCurriculum()
        .then(function (response) {
          vm.list.subject.subject_national_curriculum_id = response;
          $rootScope.show_loader = false;
        })
    };

    vm.submit = function (item, form) {
      if (form.$valid) {
        SubjectService.create(item)
          .then(function (response) {
            Common.Toast.success('Disciplina criada com sucesso');
            vm.close(response);
            $rootScope.show_loader = false;
            $rootScope.$broadcast('matrix.subject.created', response);
            $rootScope.$broadcast('update.subject.list');
          })
          .catch(function (warning) {
            if (angular.isObject(warning.data)) {
              angular.forEach(warning.data.errors, function (value, key) {
                switch (value[0]) {
                  case 'ALIAS_IS_REQUIRED':
                    Common.Toast.warning('Campo apelido é obrigatório ');
                    break;
                  case 'ALIAS_SHOULD_BE_A_STRING':
                    Common.Toast.warning('Campo apelido apenas texto ');
                    break;
                  case 'ALIAS_IS_UNIQUE_COLUMN':
                    Common.Toast.warning('Já existe disciplina com este apelido ');
                    break;
                  case 'ALIAS_MAX_CHARACTER_EXCEDEED':
                    Common.Toast.warning('Quantidade de caracteres excedido ');
                    break;
                  case 'NAME_MUST_BE_A_STRING':
                    Common.Toast.warning('Campo nome apenas texto ');
                    break;
                  case 'NAME_IS_REQUIRED':
                    Common.Toast.warning('Campo nome é obrigatório ');
                    break;
                  case 'NAME_IS_UNIQUE_COLUMN':
                    Common.Toast.warning('Já existe disciplina com este nome ');
                    break;
                  case 'NAME_MAX_CHARACTER_EXCEDEED':
                    Common.Toast.warning('Quantidade de caracteres excedido ');
                    break;
                  case 'COMPANY_ID_IS_REQUIRED':
                    Common.Toast.warning('Campo Apelido é obrigatório ');
                    break;
                }
              });
            }

          })
      }
    };

    vm.close = function (result) {
      $mdDialog.hide(result);
    };

    vm.init();
  }

  angular
    .module('app.educational.subject')
    .controller('SubjectCreateController', SubjectCreateController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function SubjectController(ModalFactory, CONFIG, SubjectService, $rootScope, $scope, $a4FloatButton, Common, PoliciesService, $mdMenu) {
    var vm = this;
    vm.show_inactive = false;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    vm.paginate = function (page, limit, query) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 20;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = SubjectService.getAll({
        page: page, limit: limit, query: query,
        show_inactive: vm.show_inactive
      })
        .then(function (response) {
          response.data.map(function (item) {
            if (item.uses !== null) {
              var uses = item.uses.replace('{', '').replace('}', '').replace(/"/g, '');
              item.uses = uses;
            } else {
              item.uses = '';
            }
            return item;
          });
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [20, 40, 50, {
              label: 'Todas',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Falha ao recuperar a lista de disciplinas');
        });
    };

    vm.form = {};

    vm.init = function () {
      vm.paginate();
      if (!vm.checkPolicies('disc_alt')) {
        $a4FloatButton({scope: $scope, icon: 'add', onClick: 'vm.createSubject()'});
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Abre o modal de criação de disciplinas
     */
    vm.createSubject = function () {
      ModalFactory.customClean(
        'app/educational/subject/views/form.html',
        'SubjectCreateController',
        'vm', false
      );
    };

    /**
     * Abre o modal de edição de disciplinas
     * @param item - item clicado
     */
    vm.editSubject = function (item) {
      SubjectService.isAssociatedToMatrix(item.id)
        .then(function (response) {
          if (response.result) {
            ModalFactory.confirm(null,
              'Atenção',
              "A alteração de uma disciplina em uso irá afetar todas grades curriculares que já utilizaram esta disciplina. " +
              "A alteração de uma disciplina só deve ocorrer por motivo de correção de algum erro na sua criação. " +
              "No caso de necessidade de mudança de disciplina que só deva refletir em grades futuras, " +
              "por favor crie uma nova disciplina para que o passado não seja afetado.",
              "Confirmar", "Cancelar", "educational")
              .then(function () {
                vm.getSubject(item.id);
              });
          } else {
            vm.getSubject(item.id);
          }
        });
    };

    /**
     * Busca a disciplina pelo id
     * @param id - identificador da disciplina
     */
    vm.getSubject = function (id) {
      SubjectService.get(id)
        .then(function (response) {
          ModalFactory.customClean(
            'app/educational/subject/views/form.html',
            'SubjectEditController',
            'vm', false, response.plain()
          );
        })
    };

    vm.getAll = function () {
      SubjectService.getAll()
        .then(function (response) {
          vm.grid.rows = response.plain();
        });
    };

    vm.delete = function (index) {
      ModalFactory.confirm(null,
        'Confirmação de Exclusão',
        'Deseja realmente excluir a disciplina?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          SubjectService.deleteSubject(index)
            .then(function () {
              Common.Toast.success('Disciplina excluída com sucesso!');
              vm.paginate();
            }).catch(function (response) {
            if (response.data.message === 'SUBJECT_IS_ASSOCIATE_TO_MATRIX') {
              Common.Toast.warning('Não é possível excluir a disciplina, pois ela está associada a uma grade.');
            } else if (response.data.result === 'Unauthorized') {
              Common.Toast.error('Não autorizado.');
            } else {
              Common.Toast.error('Erro ao excluir a disciplina.');
            }
          })
        })
    };

    vm.init();
  }

  angular
    .module('app.educational.subject')
    .controller('SubjectController', SubjectController)
})();
(function() {
  'use strict';
  angular
    .module('app.educational.students-records-messages', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function StudentsRecordsMessagesService(Restangular) {
    var getAll = function (obj) {
      return Restangular.one('studentsrecordsmessages').get(obj);
    };

    var getReportMessages = function (obj) {
      return Restangular.one('studentsrecordsmessages').one('getreportmessages').get(obj);
    };

    var saveMessages = function (obj) {
      return Restangular.one('studentsrecordsmessages').all('savemessages').post(obj);
    };

    var updateMessages = function (obj) {
      return Restangular.one('studentsrecordsmessages').all('updatemessages').post(obj);
    };

    var createNewMessage = function (obj) {
      return Restangular.one('studentsrecordsmessages').all('createnewmessage').post(obj);
    };

    var deleteStudentMessage = function (obj) {
      return Restangular.one('studentsrecordsmessages').one('deletestudentmessage').remove(obj);
    };

    return {
      createNewMessage: createNewMessage,
      deleteStudentMessage: deleteStudentMessage,
      getAll: getAll,
      getReportMessages: getReportMessages,
      saveMessages: saveMessages,
      updateMessages: updateMessages
    };

  }

  angular
    .module('app.educational.students-records-messages')
    .factory('StudentsRecordsMessagesService', StudentsRecordsMessagesService)

})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.students-records-messages', {
        url: '/students-records-messages/',
        public: false,
        templateUrl: 'app/educational/students-records-messages/views/students-records-messages-grid.html',
        controller: 'StudentsRecordsMessagesController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.educational.students-records-messages')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'msg_boletim';
    var path = 'educational.students-records-messages';

    msNavigationService.saveItem(path, {
      title: 'Mensagens dos boletins',
      icon: 'icon-clipboard-text',
      state: 'private.educational.students-records-messages',
      weight: 13,
      auth: role,
      hidden: function () {
        // Item removido da estrutura principal de menus.
        // Mantém a rota ativa, mas esconde o item do menu; acesso apenas pelo botão em Ferramentas.
        return true;
      }
    });
  }

  angular
    .module('app.educational.students-records-messages')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function StudentsRecordsMessagesController($state, $rootScope, $scope, StudentsRecordsMessagesService,
                                             $a4FloatButton, StudentsService, Common, CourseService, EducationalService, GroupService, ModalFactory) {

    var vm = this;
    vm.course_id = null;
    vm.group_id = null;
    vm.grade_rule_item_id = null;
    vm.items_to_save = [];

    vm.getAll = function (page) {
      if (vm.grade_rule_item_id !== null && vm.group_id !== null) {
        $rootScope.show_loader = true;
        StudentsRecordsMessagesService.getAll({
          grade_rule_item_id: vm.grade_rule_item_id,
          group_id: vm.group_id,
          course_id: vm.course_id,
          page: page
        }).then(function (response) {
          var result = response.plain();
          for (var i = 0; i < result.data.length; i++) {
            if (result.data[i].report_message_id == null && result.data[i].report_student_message == null) {
              result.data[i].new = true;
            }
          }
          vm.paginate = result;
          $rootScope.show_loader = false;
        })
      }
    };

    /**
     * Busca os cursos para o filtro
     * @returns {*}
     */
    vm.loadCourses = function () {
      return CourseService.getAll({only_active: true})
        .then(function (courses) {
          vm.courses = courses;
        });
    };

    /**
     * Busca turmas de acordo com o curso, para o filtro
     * @param course_id
     */
    vm.setGroups = function (course_id) {
      CourseService.getGroupsByCourse(course_id)
        .then(function (groups) {
          vm.groups = groups.data;
        });
    };

    /**
     * Atualiza id da mensagem quando o auto-complete for alterado
     * @param id
     * @param item
     */
    vm.changeIdMessage = function (id, item) {
      item.report_message_id = id;
    };

    /**
     * Salva mensagem do boletim
     */
    vm.save = function () {
      if (vm.items_to_save.length !== 0) {
        $rootScope.show_loader = true;
        StudentsRecordsMessagesService.updateMessages({
          data: vm.items_to_save
        }).then(function () {
          Common.Toast.success('Mensagens salvas com sucesso!');
          vm.getAll();
          vm.items_to_save = [];
        })
      } else {
        Common.Toast.error('Para salvar, você precisa associar alunos e mensagens!');
      }
    };

    /**
     * Função disparada quando o valor do item do auto-complete de algum item é alterado
     * 1 - Verifica se o item está na lista de elementos a serem salvos
     * 2 - Se ele não estiver, adiciona no Array.
     * @param item
     */
    vm.addItem = function (item) {
      if (vm.items_to_save.filter(function (element) {
        return element.enrolment_period_id === item.enrolment_period_id && element.grade_rule_item_id === item.grade_rule_item_id;
      }).length > 0) {
        return;
      } else {
        item.grade_rule_item_id = vm.grade_rule_item_id;
        item.new = true;
        vm.items_to_save.push(item);
      }
    };

    /**
     * Exclui mensagem do boletim
     * @param item
     */
    vm.delete = function (item) {
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Você deseja excluir a mensagem para esse aluno?',
        'Excluir',
        'Fechar',
        'educational'
      ).then(function () {
        $rootScope.show_loader = true;
        StudentsRecordsMessagesService.deleteStudentMessage({
          enrolment_period_id: item.enrolment_period_id,
          grade_rule_item_id: item.grade_rule_item_id,
          report_message_id: item.report_message_id,
          report_student_message: item.report_student_message
        }).then(function (response) {
          Common.Toast.success('Mensagem apagada com sucesso');
          vm.getAll();
        })
      }).catch(function () {
        Common.Toast.warning('Ação cancelada.');
      });
    };

    /**
     * Busca os itens da grade
     * @param group_id
     * @param student_id
     */
    vm.getGradeRuleItems = function (group_id) {
      EducationalService.getGradeRuleItems({group_id: group_id, course_id: vm.course_id})
        .then(function (response) {
          vm.grade_rule_items = response.plain();
        })
    };

    /**
     * Busca as mensagens de boletim para o autocomplete
     * @param message
     * @returns {*}
     */
    vm.getReportMessages = function (message) {
      return StudentsRecordsMessagesService.getReportMessages({message: message});
    };

    /**
     * Cria mensagem de boletim
     */
    vm.createMessageForGroup = function () {
      ModalFactory.customClean('app/educational/students-records-messages/views/modal-create.html',
        'CreateMessageModalController', 'vm', false, {
          group_id: vm.group_id,
          course_id: vm.course_id,
          grade_rule_item_id: vm.grade_rule_item_id
        }).then(function (response) {
        if (response) {
          vm.getAll();
        }
      })
    };

    /**
     * Abre prompt para digitação de nova mensagem
     */
    vm.openNewReportMessageModal = function () {
      ModalFactory.custom('app/educational/students-records-messages/views/modal-message.html',
        null,
        false,
        null).then(function (message) {
        if (angular.isUndefined(message) || message === '') {
          Common.Toast.error("Você precisa digitar uma mensagem!");
        } else {
          vm.createNewReportMessage(message);
        }
      })
    };

    /**
     * Cria nova mensagem
     * @param message
     */
    vm.createNewReportMessage = function (message) {
      $rootScope.show_loader = true;
      StudentsRecordsMessagesService.createNewMessage({message: message}).then(function () {
        Common.Toast.success('Mensagem criada com sucesso!');
        $rootScope.show_loader = false;
      })
    };

    vm.init = function () {

    };

    vm.init();

  }

  angular
    .module('app.educational.students-records-messages')
    .controller('StudentsRecordsMessagesController', StudentsRecordsMessagesController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CreateMessageModalController($state, $rootScope, $mdDialog, StudentsRecordsMessagesService,
                                        $a4FloatButton, StudentsService, Common, CourseService, EducationalService,
                                        GroupService, ModalExtra, ModalFactory) {

    var vm = this;
    vm.course_selected = ModalExtra.course_id;
    vm.group_selected = ModalExtra.group_id;
    vm.grade_selected = ModalExtra.grade_rule_item_id;
    vm.custom_message = null;
    vm.message = null;

    vm.init = function () {
      vm.loadCourses();
      /**
       * Caso os filtros tenham sido selecionados, busca os dados para que o respectivo filtro já apareça
       * no select do modal.
       */
      if (vm.group_selected !== null){
        vm.setGroups(vm.course_selected);
      }
      if (vm.grade_selected !== null){
        vm.getGradeRuleItems(vm.group_selected);
      }

    };

    /**
     * Busca os cursos para o filtro
     * @returns {*}
     */
    vm.loadCourses = function () {
      return CourseService.getAll({only_active: true})
        .then(function (courses) {
          vm.courses = courses;
        });
    };

    /**
     * Busca turmas de acordo com o curso, para o filtro
     * @param course_id
     */
    vm.setGroups = function (course_id) {
      CourseService.getGroupsByCourse(course_id)
        .then(function (groups) {
          vm.groups = groups.data;
        });
    };

    vm.getGradeRuleItems = function (group_id) {
      EducationalService.getGradeRuleItems({group_id: group_id, course_id: vm.course_selected})
        .then(function (response) {
          vm.grade_rule_items = response.plain();
        })
    };

    /**
     * Busca todas as mensagens da empresa
     */
    vm.getReportMessages = function (message) {
      return StudentsRecordsMessagesService.getReportMessages({message: message});
    };


    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.save = function () {
      vm.loader = true;
      StudentsRecordsMessagesService.saveMessages({
        group_id: vm.group_selected,
        message_id: vm.message !== null ? vm.message.id : null,
        custom_message: vm.custom_message,
        grade_rule_item_id: vm.grade_selected
      }).then(function (response) {
        if (response) {
          vm.close(true);
          Common.Toast.success('Mensagens dos boletins criadas com sucesso');
        }
        vm.loader = false;
      })
    };

    vm.init();

  }

  angular
    .module('app.educational.students-records-messages')
    .controller('CreateMessageModalController', CreateMessageModalController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function StudentsService(Restangular, $http, CONFIG, Common) {

    var person = {};

    /**
     * Retorna todos os estudantees
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('students').get(obj);
    };

    var getInfosForOnlineEnrolment = function (obj) {
      return Restangular.one('students').one('getinfosforonlineenrolment').get(obj);
    };

    /**
     * Retorna todos os tipos de pcd
     * @returns 
     */
    var getPersonPcd = function () {
      return Restangular.one('students').one('getpersonpcd').get();
    }

    /**
     * Retorna o estudante pelo id
     * @returns array
     */
    var getById = function (id, is_enrolment, matrix_period, group_id, enrolment_period_id) {
      return Restangular.one('students', id).get({
        is_enrolment: is_enrolment,
        matrix_period: matrix_period, group_id: group_id,
        enrolment_period_id: enrolment_period_id
      });
    };

    /**
     * Retorna o estudante pelo id
     * @returns array
     */
    var destroy = function (id) {
      return Restangular.one('students', id).remove();
    };

    /**
     * Cria um novo estudante
     */
    var createStudent = function (obj) {
      return Restangular.all('students').post(obj);
    };

    /**
     * Atualiza um estudante
     */
    var updateStudent = function (obj) {
      return Restangular.one('students', obj.id).customPUT(obj);
    };

    /**
     * Remove um estudante
     */
    var deleteStudent = function (id) {
      return Restangular.one('students', id).remove();
    };

    var changeEnrolmentDate = function (obj) {
      return Restangular.one('students').all('changeenrolmentdate').post(obj);
    };

    /**
     * Retorna as informações necessárias para o formulário.
     */
    var getInfos = function (person_id) {
      return Restangular.one('/students/forminfo', person_id).get();
    };

    /**
     * Realiza a troca da turma do estudante.
     */
    var changegroupstudent = function (obj) {
      return Restangular.one('students').all('changegroupstudent').post(obj);
    };
    /**
     * Realiza a remoção ou atualização da foto
     */
    var updateOrDeleteProfileImage = function (obj) {
      return Restangular.one('students').all('updatedeleteprofileimage').post(obj);
    };

    /**
     * Retorna as ocorrências de um aluno
     * @returns array
     */
    var getStudentOccurrences = function (obj) {
      return Restangular.one('students').one('occurrences').get(obj);
    };

    var getOccurrenceTypes = function (obj) {
      return Restangular.one('students').one('getoccurrencetypes').get(obj);
    };

    var deleteStudentOccurrence = function (obj) {
      return Restangular.one('students').all('deleteoccurrence').post(obj);
    };

    var updateLessonStudentNotes = function (obj) {
      return Restangular.one('students').all('updatelessonstudentnotes').post(obj);
    };
    /**
     * Retorna as ocorrências de um aluno
     * @returns array
     */
    var getCourseAndGroup = function (obj) {
      return Restangular.one('students').one('course').one('groups').get(obj);
    };

    /**
     * Retorna as ocorrências de um aluno
     * @returns array
     */
    var getStudentParents = function (obj) {
      return Restangular.one('students').one('getparents').get(obj);
    };

    /**
     * Retorna as ocorrências de um aluno
     * @returns array
     */
    var getStudentContracts = function (obj) {
      return Restangular.one('student', obj.id).one('contracts').get(obj);
    };

    /**
     * Retorna as informações financeiras do último periodo letivo do aluno
     * @returns array
     */
    var getLastEnrolmentData = function (id) {
      return Restangular.one('students', id).one('getlastenrolmentdata').get();
    };

    var getStudentEnrolments = function (obj) {
      return Restangular.one('students').one('getstudentenrolments').get(obj);
    };

    /**
     * Verifica se o aluno tem mais de uma matrícula no período
     * @param obj
     * @returns {*}
     */
    var verifyStudentEnrolment = function (obj) {
      return Restangular.one('students').one('verifyenrolment').get(obj);
    };

    var getLessons = function (obj) {
      return Restangular.one('students').one('lessons').get(obj);
    };

    var verifyStudentLessons = function (obj) {
      return Restangular.one('students').one('verifylessons').get(obj);
    };

    /**
     * Retorna os alunos de acordo com o responsável
     * @returns array
     */
    var getFinancialPendencies = function (obj) {
      return Restangular.one('integration').one('financialpendencies').get(obj);
    };

    var cancelEnrolmentAndContracts = function (obj) {
      return Restangular.one('students').all('cancelenrolmentandcontracts').post(obj);
    };

    var editCancelInfo = function (obj) {
      return Restangular.one('students').all('editcancelinfo').post(obj);
    };

    var changeResponsible = function (obj) {
      return Restangular.one('students').all('changeresponsible').post(obj);
    };

    var changeRelationship = function (obj) {
      return Restangular.one('students').all('changerelationship').post(obj);
    };

    var deleteResponsible = function (obj) {
      return Restangular.one('students').all('deleteresponsible').post(obj);

    };

    var saveAccessCardNumber = function (obj){
      return Restangular.one('students').all('saveaccesscardnumber').post(obj);
    };

    var undoCancelmentOfEnrolmentAndContracts = function (obj) {
      return Restangular.one('students').all('undocancel').post(obj);
    };

    var addResponsible = function (obj) {
      return Restangular.one('students').all('addresponsible').post(obj);
    };

    var getAnotherDependents = function (obj) {
      return Restangular.one('students').one('getanotherdependents').get(obj);
    };

    var changePayee = function (obj) {
      return Restangular.one('students').all('changepayee').post(obj);
    };

    var decryptOccurrence = function (id) {
      return Restangular.one('students').one('occurrence', id).one('decrypt').get();
    };

    var getPersonMedicalData = function (obj) {
      return Restangular.one('students').one('getpersonmedicaldata').get(obj);
    };

    var getSchoolOrigins = function (obj) {
      return Restangular.one('students').one('getschoolorigins').get(obj);
    };

    var getCountriesOfStudent = function (obj) {
      return Restangular.one('students').one('getcountriesofstudent').get(obj)
    }

    var updatePersonMedicalData = function (obj) {
      return Restangular.one('students').all('updatepersonmedicaldata').post(obj);
    };

    var verifyBankSlipsForPayee = function (obj) {
      return Restangular.one('students').all('verifybankslipsforpayee').post(obj);
    };

    var updatePreEnrolmentStatus = function (obj) {
      return Restangular.one('students').all('updatepreenrolmentstatus').post(obj);
    };

    var verifyDelete = function (obj) {
      return Restangular.one('enrolment').one('verifydelete').get(obj);
    };

    var getEnrolmentMatrix = function (obj) {
      return Restangular.one('enrolment').one('enrolmentmatrix').get(obj);
    };

    var deleteEnrolment = function (obj) {
      return Restangular.one('enrolment').all('deleteenrolment').post(obj);
    };

    var changeGroupOfMultipleStudents = function (obj) {
      return Restangular.one('students').all('changegroupofmultiplestudents').post(obj);
    };

    var createSchoolOrigin = function (obj) {
      return Restangular.one('students').all('createschoolorigin').post(obj);
    };

    var defineIndependent = function (obj) {
      return Restangular.one('students').all('defineindependent').post(obj);
    };

    var defineNotDeclared = function (obj) {
      return Restangular.one('students').all('definenotdeclared').post(obj);
    };

    var defineResponsible = function (obj) {
      return Restangular.one('students').all('defineresponsible').post(obj);
    };

    var ManageCoResponsable = function (obj) {
      return Restangular.one('students').all('managecoresponsable').post(obj);
    };

    var definePayee = function (obj) {
      return Restangular.one('students').all('definepayee').post(obj);
    };

    var defineGuarantor = function (obj) {
      return Restangular.one('students').all('defineguarantor').post(obj);
    };

    var removeGuarantor = function (obj) {
      return Restangular.one('students').all('removeguarantor').post(obj);
    };
    var createOrUpdateGates = function (obj) {
      return Restangular.one('students').all('createorupdategates').post(obj);
    };
    var createOrUpdateAgendaEdu = function (obj) {
      return Restangular.one('students').all('createorupdateagendaedu').post(obj);
    };

    var setPersonData = function (person_data) {
      person = person_data;
    };

    var getPersonData = function () {
      return person;
    };

    var exportDataForSET = function (obj, institution_number, file_sequence) {

      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/students/exportdataforset',
        data: obj,
        responseType: 'text/plain'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];

        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          var filename = 'ARQUIVO_RETORNO_INST_' + institution_number + '_REM_' + file_sequence + '.txt';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });

      return deffered.promise;
    };

    return {
      getAll: getAll,
      createStudent: createStudent,
      createSchoolOrigin: createSchoolOrigin,
      changePayee: changePayee,
      getById: getById,
      destroy: destroy,
      exportDataForSET: exportDataForSET,
      verifyDelete: verifyDelete,
      updateStudent: updateStudent,
      deleteStudent: deleteStudent,
      changeGroupOfMultipleStudents: changeGroupOfMultipleStudents,
      deleteResponsible: deleteResponsible,
      getInfos: getInfos,
      getSchoolOrigins: getSchoolOrigins,
      changegroupstudent: changegroupstudent,
      changeRelationship: changeRelationship,
      saveAccessCardNumber: saveAccessCardNumber,
      getStudentOccurrences: getStudentOccurrences,
      getLessons: getLessons,
      undoCancelmentOfEnrolmentAndContracts: undoCancelmentOfEnrolmentAndContracts,
      changeResponsible: changeResponsible,
      editCancelInfo: editCancelInfo,
      getFinancialPendencies: getFinancialPendencies,
      updateOrDeleteProfileImage: updateOrDeleteProfileImage,
      verifyStudentEnrolment: verifyStudentEnrolment,
      getStudentParents: getStudentParents,
      getCourseAndGroup: getCourseAndGroup,
      getStudentContracts: getStudentContracts,
      cancelEnrolmentAndContracts: cancelEnrolmentAndContracts,
      addResponsible: addResponsible,
      verifyStudentLessons: verifyStudentLessons,
      getAnotherDependents: getAnotherDependents,
      getStudentEnrolments: getStudentEnrolments,
      deleteStudentOccurrence: deleteStudentOccurrence,
      updateLessonStudentNotes: updateLessonStudentNotes,
      decryptOccurrence: decryptOccurrence,
      getPersonMedicalData: getPersonMedicalData,
      updatePersonMedicalData: updatePersonMedicalData,
      verifyBankSlipsForPayee: verifyBankSlipsForPayee,
      updatePreEnrolmentStatus: updatePreEnrolmentStatus,
      deleteEnrolment: deleteEnrolment,
      changeEnrolmentDate: changeEnrolmentDate,
      getEnrolmentMatrix: getEnrolmentMatrix,
      defineIndependent: defineIndependent,
      defineNotDeclared: defineNotDeclared,
      setPersonData: setPersonData,
      getOccurrenceTypes: getOccurrenceTypes,
      getPersonData: getPersonData,
      definePayee: definePayee,
      defineGuarantor: defineGuarantor,
      removeGuarantor: removeGuarantor,
      defineResponsible: defineResponsible,
      getInfosForOnlineEnrolment: getInfosForOnlineEnrolment,
      getLastEnrolmentData: getLastEnrolmentData,
      createOrUpdateGates: createOrUpdateGates,
      createOrUpdateAgendaEdu: createOrUpdateAgendaEdu,
      ManageCoResponsable: ManageCoResponsable,
      getCountriesOfStudent: getCountriesOfStudent,
      getPersonPcd: getPersonPcd
    };

  }

  angular
    .module('app.educational.students')
    .factory('StudentsService', StudentsService)

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.students', {
        public: false,
        url: '/students',
        templateUrl: 'app/educational/students/views/students.html',
        abstract: true
      })
      .state('private.educational.students.list', {
        url: '/list',
        params: {
          tab_selected: null
        },
        public: false,
        views: {
          'students': {
            templateUrl: 'app/educational/students/views/list.html',
            controller: 'StudentsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.students.edit', {
        url: '/:id/:enrolment_period_id/:course_id/:group_id/:course_equivalence_id/:matrix_period/view/:change_school_period',
        params: {
          enrolment_period_id: null,
          id: null,
          group_id: null,
          course_id: null,
          course_equivalence_id: null,
          matrix_period: null,
          change_school_period: null
        },
        public: false,
        views: {
          'students': {
            templateUrl: 'app/educational/students/views/students-page.html',
            controller: 'StudentsEditController',
            controllerAs: 'vm'
          },
          'classes@private.educational.students.edit': {
            templateUrl: 'app/educational/students/classes/views/classes.html',
            controller: 'ClassesStudentsController',
            controllerAs: 'vm'
          },
          'classrooms@private.educational.students.edit': {
            templateUrl: 'app/educational/students/classrooms/views/classrooms.html',
            controller: 'ClassroomsStudentsController',
            controllerAs: 'vm'
          },
          'financial@private.educational.students.edit': {
            templateUrl: 'app/educational/students/financial/views/financial.html',
            controller: 'FinancialStudentsController',
            controllerAs: 'vm'
          },
          'school-reports@private.educational.students.edit': {
            templateUrl: 'app/educational/students/school-reports/views/school-reports.html',
            controller: 'SchoolReportsController',
            controllerAs: 'vm'
          },
          'questionnaires-student@private.educational.students.edit': {
            templateUrl: 'app/educational/students/questionnaires/views/questionnaires.html',
            controller: 'QuestionnairesStudentsController',
            controllerAs: 'vm'
          },
          'evaluations-student@private.educational.students.edit': {
            templateUrl: 'app/educational/students/evaluations-student/views/evaluations-student.html',
            controller: 'EvaluationsStudentController',
            controllerAs: 'vm'
          },
          'occurrences@private.educational.students.edit': {
            templateUrl: 'app/educational/students/occurrences/views/occurrences.html',
            controller: 'OccurrencesStudentsController',
            controllerAs: 'vm'
          },
          'schoolrecords@private.educational.students.edit': {
            templateUrl: 'app/educational/students/schoolrecords/views/schoolrecords.html',
            controller: 'SchoolRecordsController',
            controllerAs: 'vm'
          },
          'timetable@private.educational.students.edit': {
            templateUrl: 'app/educational/students/timetable/views/timetable.html',
            controller: 'TimetableStudentsController',
            controllerAs: 'vm'
          },
          'wall@private.educational.students.edit': {
            templateUrl: 'app/educational/students/wall/views/wall.html',
            controller: 'WallStudentsController',
            controllerAs: 'vm'
          },
          'parents@private.educational.students.edit': {
            templateUrl: 'app/educational/students/parents/views/parents.html',
            controller: 'ParentsStudentsController',
            controllerAs: 'vm'
          },
          'documents@private.educational.students.edit': {
            templateUrl: 'app/educational/students/documents/views/documents_student.html',
            controller: 'DocumentsStudentController',
            controllerAs: 'vm'
          },
          'medical-records@private.educational.students.edit': {
            templateUrl: 'app/educational/students/medical-records/views/medical-records.html',
            controller: 'MedicalRecordsController',
            controllerAs: 'vm'
          },
          'complementary-activities@private.educational.students.edit': {
            templateUrl: 'app/educational/students/complementary-activities/views/complementary-activities.html',
            controller: 'ComplementaryActivitiesController',
            controllerAs: 'vm'
          },
          'extra-subjects@private.educational.students.edit': {
            templateUrl: 'app/educational/students/extra-subjects/views/extra-subjects.html',
            controller: 'ExtraSubjectsController',
            controllerAs: 'vm'
          },
          'subjects@private.educational.students.edit': {
            templateUrl: 'app/educational/students/subjects/views/subjects.html',
            controller: 'SubjectsStudentsController',
            controllerAs: 'vm'
          },
          'enrolments-student@private.educational.students.edit': {
            templateUrl: 'app/educational/students/enrolments-student/views/enrolments-student.html',
            controller: 'EnrolmentsStudentController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.students.create', {
        url: '/create',
        public: false,
        views: {
          'students': {
            templateUrl: 'app/educational/students/views/students-page.html',
            controller: 'StudentsCreateController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.students')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run($rootScope, msNavigationService, PoliciesService, Session, CONFIG) {
    var role = 'aluno_menu';
    var path = 'secretary.students';

    $rootScope.$on(CONFIG.events.side_menu.update, function () {
      if (PoliciesService.checkPolicyFromMenu(role) && PoliciesService.isParent()
        && CONFIG.profile.parent === Session.getCurrentProfile()) {

        var user = Session.getUser();
        msNavigationService.saveItem("educational.students", {
          title: 'Dependentes',
          icon: 'icon-account-box',
          auth: role,
          state: user.relations.length > 1 ? 'private.educational.students.list' : 'private.educational.students.edit' ,
          stateParams: {'id': user.relations.length > 1 ? null : user.relations[0].id},
          weight: 1,
          hidden: function () {
            return !PoliciesService.checkPolicyAndProfile(role, "educational.students");
          }
        });

      } else if (PoliciesService.checkPolicyFromMenu(role) && !PoliciesService.isParent()) {

        msNavigationService.saveItem(path, {
          title: 'Alunos e matrículas',
          icon: 'icon-account-box',
          auth: 'aluno_menu',
          state: 'private.educational.students.list',
          weight: 1,
          hidden: function () {
            return !PoliciesService.checkPolicyAndProfile(role, path);
          }
        });

      }

    });


    $rootScope.$broadcast(CONFIG.events.side_menu.update);


  }

  angular
    .module('app.educational.students')
    .run(run);

})();



(function () {
  'use strict';

  function StudentsEditController($rootScope, $scope, $state, $stateParams, $a4FloatButton, Session, StudentsService, a4Moment,
                                  PersonService, Common, ModalFactory, LocalStorage, PoliciesService, CONFIG, Utils) {

    var vm = this;
    var LocalStorageKEY = 'students_current_tab';
    vm.search_text = '';
    vm.blockFormEmail = false;
    vm.show_tabs = false;
    vm.matrix_period = $stateParams.matrix_period;
    vm.group_id = $stateParams.group_id;
    vm.enrolment_period_id = $stateParams.enrolment_period_id;
    vm.selected_tab = LocalStorage.get(LocalStorageKEY);
    vm.form = {mode_edit: false, person: {}, person_student: {}};
    vm.list = {person: {}, person_student: {}};
    vm.profile_selected = PoliciesService.currentProfile();
    vm.person_copy = {show_form: false};
    vm.students = Session.getUser().relations;
    vm.context = Session.getContext();
    vm.student_id = null;
    vm.email_error = null;
    vm.has_email_error = false;
    vm.CONFIG = CONFIG;
    vm.tabs = [];
    vm.current_school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.is_responsible = Session.get('is_responsible');


    /**
     * Escuta da tab corrente, a cada troca de tab em estudantes, esta escuta salva a corrente no localstorage;
     * @type {*}
     */
    var ltn = $scope.$watch(function () {
        // return vm.selected_tab;
      },
      function (newer, older) {
        // if (parseInt(newer) !== parseInt(older))
        //   LocalStorage.add(LocalStorageKEY, newer);
      });

    /**
     * Esculta a troca do campo de Estado no formulário de criação de aluno
     * @type {*}
     */
    var ltn2 = $rootScope.$on('person_address_state_change', function (ev, address_state_id) {
      vm.form.person.address_city = null;
      vm.changeAddressState(address_state_id);
    });

    /**
     * Esculta a troca do campo de Estado no formulário de criação de aluno
     * @type {*}
     */
    var ltn3 = $rootScope.$on('person_birth_certificate_registry_state_change', function (ev, birth_certificate_registry_state) {
      vm.form.person.birth_certificate_registry_city = null;
      vm.changeAddressStateRegistry(birth_certificate_registry_state);
    });

    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    var ltn4 = $rootScope.$on('address_postal_code.blur', function (ev, CEP) {
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          vm.form.person.address_state = address.uf;
          vm.form.person.address_city = address.localidade;
          vm.form.person.address_street = address.logradouro;
          vm.form.person.address_district = address.bairro;
          vm.changeAddressState(vm.form.person.address_state, address.localidade);
        });
    });

    var ltn5 = $scope.$on("$viewContentLoaded", function () {
      var user = Session.getUser();
      if ((PoliciesService.isStudent() && PoliciesService.currentProfile() === CONFIG.profile.student)) {
        vm.student_id = user.person.id;
      } else if (PoliciesService.isParent() && PoliciesService.currentProfile() === CONFIG.profile.parent) {
        vm.student_id = $state.params.id;
      } else {
        vm.student_id = $state.params.id;
      }

      // vm.getFormInfos();
    });

    /**
     * Inicializador do controlador
     */
    vm.init = function () {
      /**
       * Emite evento de mudança do período letivo, caso necessário
       * Parece que o Disabled não funciona para nada
       */
      if (angular.isDefined($stateParams.change_school_period) && $stateParams.change_school_period !== null
        && parseInt(vm.current_school_period) !== parseInt($stateParams.change_school_period.replace(/\D/g, ''))) {
        $scope.$emit('change-school-period',
          $stateParams.change_school_period
        );
      }

      var user = Session.getUser();
      if ((PoliciesService.isStudent() && PoliciesService.currentProfile() === CONFIG.profile.student)) {
        vm.student_id = user.person.id;
      } else if (PoliciesService.isParent() && PoliciesService.currentProfile() === CONFIG.profile.parent) {
        vm.student_id = $state.params.id;
      } else {
        vm.student_id = $state.params.id;
      }

      vm.getById(vm.student_id);

      vm.create_tabs();

      //vm.getFormInfos();

    };

     /**
     * Inicializador do controlador
     */
    vm.create_tabs = function () {

      var tabs = [];
      var tab_index = 0;

      if (vm.checkProfile(vm.CONFIG.profile.student)) {
        tabs.push(
          {
            id: ++tab_index,
            label: 'Mural',
            uiView: "wall"
          }
        );
      }

      tabs.push(
        {
          id: ++tab_index,
          label: 'Agenda',
          uiView: "timetable"
        }
      );

      tabs.push(
        {
          id: ++tab_index,
          label: 'Classes',
          uiView: "classes"
        }
      );

      tabs.push(
        {
          id: ++tab_index,
          label: 'Aulas',
          uiView: "classrooms"
        }
      );

      if (vm.checkPolicies('aluno_boletim')) {
        tabs.push(
          {
            id: ++tab_index,
            label: 'Boletim',
            uiView: "school-reports"
          }
        );
      }

      if (vm.checkPolicies('aluno_boletim')) {
        tabs.push(
          {
            id: ++tab_index,
            label: 'Questionários',
            uiView: "questionnaires-student"
          }
        );
      }

      if (vm.checkProfile(vm.CONFIG.profile.student)) {
        tabs.push({
          id: ++tab_index,
          label: 'Avaliações',
          uiView: "evaluations-student"
        });
      }
      // console.log('vm.context.parent: ' + vm.context.parent);
      // console.log('vm.checkPolicies(\'aluno_ocor\'): ' + vm.checkPolicies('aluno_ocor'));
      // console.log('!vm.CONFIG.profile.student: ' + !vm.checkProfile(vm.CONFIG.profile.student));
      /*
      Retirado o  && !vm.checkProfile(vm.CONFIG.profile.student) para que apareça as ocorrências dentro de qualquer perfil ligado ao aluno, pois
      dentro do sistema ja possui uma forma de controlar qual perfil tem acesso ao que.
       */
      if (vm.checkPolicies('aluno_ocor')) {
        tabs.push(
          {
            id: ++tab_index,
            label: 'Ocorrências',
            uiView: "occurrences"
          }
        );
      }

      if (LocalStorage.get('has_app_finance')) {
        if ((!vm.checkProfile(vm.CONFIG.profile.student) && !vm.checkProfile(vm.CONFIG.profile.parent)
          && !vm.checkProfile(vm.CONFIG.profile.group_coordinator) && vm.checkPolicies('ctsrec')
          && !vm.checkProfile(vm.CONFIG.profile.teacher)) || vm.is_responsible
          || (vm.checkPolicies('resp_financial') || vm.checkPolicies('aluno_financial'))) {
          tabs.push(
            {
              id: ++tab_index,
              label: 'Financeiro',
              uiView: "financial"
            }
          );
        }
      }

      if (!vm.checkProfile(vm.CONFIG.profile.student) && vm.checkPolicies('aluno_historico') && $stateParams.course_equivalence_id < 300) {
        tabs.push(
          {
            id: ++tab_index,
            label: 'Histórico escolar',
            uiView: "schoolrecords"
          }
        );
      }


      // Colaboradores que não são professores

      if (!vm.checkProfile(vm.CONFIG.profile.teacher)
        && (!vm.checkProfile(vm.CONFIG.profile.parent))
        && !vm.checkProfile(vm.CONFIG.profile.student)) {

        tabs.push(
          {
            id: ++tab_index,
            label: 'Documentos entregues',
            uiView: "documents"
          }
        );

        tabs.push(
          {
            id: ++tab_index,
            label: 'Dados médicos',
            uiView: "medical-records"
          }
        );

        tabs.push(
          {
            id: ++tab_index,
            label: 'Responsáveis',
            uiView: 'parents'
          }
        );

        tabs.push(
          {
            id: ++tab_index,
            label: 'Matrículas',
            uiView: "enrolments-student"
          }
        );

        tabs.push(
          {
            id: ++tab_index,
            label: 'Disciplinas',
            uiView: "subjects"
          }
        );
      }


      if ($state.params.course_equivalence_id >= 300) {
        tabs.push(
          {
            id: ++tab_index,
            label: 'Atividades Complementares',
            uiView: "complementary-activities"
          }
        );
        tabs.push(
          {
            id: ++tab_index,
            label: 'Disciplinas Extras',
            uiView: "extra-subjects"
          }
        );
      }

      vm.tabs = tabs;

    };

    /**
     * Abre o modal para edição da foto do aluno
     */
    vm.editImage = function () {
      ModalFactory.customClean(
        'app/educational/students/views/edit-image.html',
        /** @ngInject */
        function ($rootScope, $mdDialog, ModalExtra) {
          var vm = this;
          vm.last_photo = ModalExtra.last_photo;
          vm.myCroppedImage = '';
          vm.imageFormat = '';

          vm.submit = function (photo) {
            $mdDialog.hide({new_photo: photo, format: vm.imageFormat});
          };

          vm.deleteImage = function () {
            $mdDialog.hide({new_photo: '', format: ''})
          };

          vm.handleFileSelect = function (event) {
            var file = event.currentTarget.files[0];
            var reader = new FileReader();

            reader.onload = function (event) {
              $scope.$apply(function ($scope) {
                vm.myImage = event.target.result;
              });
            };

            reader.readAsDataURL(file);
          };

          vm.selectImage = function (event) {
            vm.handleFileSelect(event);
          };

          vm.closeModal = function () {
            $mdDialog.cancel();
          };
        }, 'vm', false, {last_photo: vm.form.person.profile_image.new_photo}
      ).then(function (photo) {
        if (photo.new_photo === '') {
          vm.deleteImage();
        } else {
          vm.form.person.profile_image = photo;
          /** Realiza a copia dos dados */
          var new_item = angular.copy(vm.form.person);
          StudentsService.updateOrDeleteProfileImage(new_item)
            .then(function () {
              Common.Toast.success('Foto atualizada com sucesso');
              $state.go($state.current.name, {id: new_item.id}, {reload: true});
            })
            .catch(function () {
              Common.Toast.error('Erro ao atualizar a foto');
            })
        }
      });
    };

    /**
     * Remove a referência da imagem
     */
    vm.deleteImage = function () {
      ModalFactory.confirm(null,
        "Remover imagem",
        "Confirmar remoção da imagem deste aluno?",
        "Confirmar", "Cancelar", "educational")
        .then(function () {
          /** Realiza a copia dos dados */
          var new_item = angular.copy(vm.form.person);
          new_item.profile_image.new_photo = '';
          StudentsService.updateOrDeleteProfileImage(new_item)
            .then(function () {
              vm.form.person.profile_image.new_photo = '';
              Common.Toast.success('Foto removida com sucesso');
              $state.go($state.current.name, {id: new_item.id}, {reload: true});
            })
            .catch(function (err) {
              console.log(err.data.message);
              if(err.data.message === 'NOT_MOST_RECENT_PHOTO') {
                ModalFactory.confirm(null,
                  "Aluno com foto de outro preríodo",
                  "O aluno possui fotos registradas em outros periodos letivos" +
                  " caso deseje retira-la basta mudar o período letivo e exclui-la",
                  "Confirmar", "Cancelar", "educational")
              } else {
                Common.Toast.error('Erro ao remover a foto');
              }

            })
        })
    };

    vm.reload = function () {
      // console.log("vm.selected_tab: " + vm.selected_tab);
      // console.log("vm.tabs:");
      // console.log(vm.tabs);
      // console.log("vm.tabs: "+vm.tabs);
      $rootScope.$broadcast('student.tab.reload');
    };

    /**
     * Realiza a verificação do perfil selecionado
     * @param profile
     * @returns {boolean}
     */
    vm.checkProfile = function (profile) {
      return PoliciesService.currentProfile() === profile;
    };

    /**
     * Verifica se o usuário é um responsável
     * @returns {boolean}
     */
    vm.isParent = function () {
      var user = Session.getUser();
      vm.students = user.relations.length === 0 ? [{id: user.person.id, name: user.person.name}] : user.relations;
      return PoliciesService.isParent();
    };

    /**
     * Resgata o objeto referente ao estudante
     * @param person_id - identificador do estudante
     */
    vm.getById = function (person_id) {
      StudentsService.getById(person_id, false, vm.matrix_period, vm.group_id, vm.enrolment_period_id)
        .then(function (response) {
          vm.form.person = Utils.mergeObjects(angular.copy(response.person), angular.copy(response.person_student));
          if (angular.isDefined(vm.matrix_period) && vm.matrix_period !== null) {
            vm.form.person.matrix_period = vm.matrix_period;
          }
          vm.form.person.enrolment_date = a4Moment(vm.form.person.enrolment_date);
          vm.form.person.dob = a4Moment(vm.form.person.dob, 'YYYY-MM-DD');
          vm.form.person.profile_image = {
            new_photo: response.person.file_reference ?
              CONFIG.webApiUri + response.person.file_reference : '/assets/images/avatars/profile.jpg'
          };

          // vm.changeAddressState(vm.form.person.address_state, vm.form.person.address_city);
          // vm.changeStateBirth(vm.form.person.state_of_birth, vm.form.person.place_of_birth);

          $state.params.attendance_mode = response.person.attendance_mode;
          $state.params.attendance_mode_id = response.person.attendance_mode_id;
          $state.params.enrolment_period_id = response.person.enrolment_period_id;
          $state.params.matrix_period = $state.params.matrix_period == null ? response.person.matrix_period : $state.params.matrix_period;
          $state.params.course_enrolment_system_id = response.person.course_enrolment_system_id;
          $state.params.id = response.person.id;
          $state.params.student_id = response.person.id;
          $state.params.course_equivalence_id = angular.isDefined(response.person.course_equivalence_id) ? response.person.course_equivalence_id : $state.params.course_equivalence_id;
          $state.params.course_id = angular.isDefined(response.person.course_id) ? response.person.course_id : $state.params.course_id;
          $state.params.group_id = angular.isDefined(response.person.group_id) ? response.person.group_id : $state.params.course_id;
          $state.params.enrolment_status_id = angular.isDefined(response.person.enrolment_status_id) ? response.person.enrolment_status_id : null;
          $state.params.person_id_payee = angular.isDefined(response.person.person_id_payee) ? response.person.person_id_payee : null;
          $state.params.bill_serie_id = angular.isDefined(response.person.bill_serie_id) ? response.person.bill_serie_id : null;
          $state.params.school_period_id = vm.current_school_period;
          StudentsService.setPersonData(vm.form.person);
          vm.person_copy = angular.copy(vm.form.person);
          vm.person_copy.show_form = true;
          vm.contact_copy = angular.copy(vm.form.person);
          
          vm.list.person.attendance_mode = [{id: vm.person_copy.attendance_mode_id, name: vm.person_copy.attendance_mode}]
          $scope.$applyAsync();
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel recuperar os dados do estudante.');
        });
    };

    /**
     * Executa a chamada para a API, para a deleção de um determinado estudante
     * @param index - identificador do estudante, para deleção
     */
    vm.deleteStudent = function (index) {
      ModalFactory.confirm(null,
        'Deseja remover este estudante?',
        'Esta operação não pode ser desfeita.',
        'Remover Estudante', 'Cancelar', 'educational')
        .then(function (response) {
          if (response) {
            StudentsService.destroy(index.id)
              .then(function () {
                Common.Toast.success('Estudante removido com sucesso.');
                $state.go('private.educational.students.list');
              })
              .catch(function (fail) {
                if (angular.isObject(fail.data)) {
                  angular.forEach(fail.data, function (value) {
                    switch (value[0]) {
                      case 'PERSON_COMPANY_EXCLUSION_ERROR':
                        Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                        break;
                      case 'PERSON_STUDENT_EXCLUSION_ERROR':
                        Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                        break;
                      case 'PERSON_STUDENT_HAS_INFOS_ACTIVE_ENROLLMENT':
                        Common.Toast.warning('Existem informações associadas a este estudante, remoção não permitida');
                        break;
                    }
                  });
                }
              })
          }
        });
    };

    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      StudentsService.getInfos()
        .then(function (response) {
          vm.list.person = response.person;
          vm.list.person_student = response.person_student;
          //vm.getById(vm.student_id);
          //vm.create_tabs();
        })
    };

    /**
     * Habilita e desabilita a edição do estudante
     */
    vm.ableEdit = function () {
      vm.form.mode_edit = !vm.form.mode_edit;
      if (!vm.form.mode_edit) {
        vm.getById(vm.student_id);
      }

      if (vm.form.mode_edit === true) {
        vm.getFormInfos()
      }
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param item - novo item selecionado
     */
    vm.changeStudent = function (item) {
      if (angular.isDefined(item)) {
        if (PoliciesService.isParent()) {
          LocalStorage.add('current_student', parseInt(item.id));
        }
        $state.go('private.educational.students.edit', {
          id: item.id, course_id: item.course_id, group_id: item.group_id,
          course_equivalence_id: item.course_equivalence_id, matrix_period: item.matrix_period,
          enrolment_period_id: item.enrolment_period_id
        }, {reload: true});
      }
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     * @param city - cidade retornada pela busca por cep
     */
    vm.changeAddressState = function (address_state_id, city) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
          if (angular.isDefined(city)) {
            vm.list.person.address_city.forEach(function (item) {
              if (item.name.toLowerCase() === city.toLowerCase()) {
                vm.form.person.address_city = item.id;
              }
            });
          }
        })
    };

    vm.changeStateBirth = function (address_state_id) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.place_of_birth = response.plain();
        })
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param birth_certificate_registry_state - novo item selecionado
     */
    vm.changeAddressStateRegistry = function (birth_certificate_registry_state) {
      PersonService.getCities(birth_certificate_registry_state)
        .then(function (response) {
          vm.list.person.birth_certificate_registry_city = response.plain();
        })
    };

    /** Formata corretamente para o banco as datas que usam mascaras */
    vm.formatCorretDate = function (date) {
      if (date != null && angular.isDefined(date)) {
        return date.split("/").reverse().join("-");
      }
    };

    /**
     * Submissão para atualização de estudante
     */
    vm.submit = function (form, item) {
      if (!form.$invalid) {
        $rootScope.show_loader = true;
console.log(item)
        vm.person_color = [
          {id: 1, name: 'Branca'},
          {id: 2, name: 'Preta'},
          {id: 3, name: 'Parda'},
          {id: 4, name: 'Amarela'},
          {id: 5, name: 'Indígena'},
          {id: 999, name: 'Não declarada'}];

          if (item.school_origin_id) {
            StudentsService.getSchoolOrigins({id: item.school_origin_id}).then(function (response) {
              item.school_origin_name = response.name
            })
          }

          if (item.country_of_birth) {
            StudentsService.getCountriesOfStudent({ 
            country_birth_id: item.country_id_of_birth, 
            country_nationality_id: item.country_id_nationality}).then(function (response) {
              //Informações atualizadas da nacionalidade
              item.country_id_nationality = response.country_nacionality.id
              item.country_nationality = response.country_nacionality.nationality
              item.country_nationality_name = response.country_nacionality.name

              //Informações atualizadas do pais de nascimento
              item.country_id_of_birth = response.country_birth.id
              item.country_birth_nationality = response.country_birth.nationality
              item.country_birth = response.country_birth.name
              item.country_of_birth = response.country_birth.name
            })
          }

          if (item.person_color_id) {
            // Encontra o objeto correspondente em vm.person_color pelo ID
            var matchedColor = vm.person_color.find(function(color) {
              return color.id === item.person_color_id;
            });
          
            // Se houver um item correspondente e o nome atual não corresponder, atualiza o nome
            if (matchedColor && item.person_color_name !== matchedColor.name) {
              item.person_color_name = matchedColor.name;
            }
          }

        if (item.address_city !== null && typeof item.address_city === 'object') {
          item.address_city = item.address_city.name;
        }

        item.course_id = $stateParams.course_id;
        var new_item = angular.copy(item);
        /** Realiza o tratamento das datas */
        if (angular.isDefined(new_item.profile_image)) {
          new_item.profile_image.new_photo = new_item.profile_image.new_photo === '/assets/images/avatars/profile.jpg' ? null : new_item.profile_image.new_photo;
        }
        StudentsService.updateStudent(new_item)
          .then(function () {
            vm.form.mode_edit = false;
            Common.Toast.success('Estudante atualizado com sucesso');
            $rootScope.show_loader = false;
            /*$state.go($state.current.name, {id: new_item.id}, {reload: true});*/
            vm.general_tab = 0;
          })
          .catch(function (fail) {
            if (angular.isObject(fail.data)) {
              angular.forEach(fail.data, function (value) {
                switch (value[0]) {
                  case 'NAME_IS_REQUIRED':
                    Common.Toast.warning('Campo nome é obrigatório.');
                    break;
                  case 'ALREADY_EXISTS_PERSON_WITH_THIS_NAME':
                    Common.Toast.warning('Já existe uma pessoa com este nome.');
                    break;
                  case 'ADDRESS_CITY_IS_REQUIRED':
                    Common.Toast.warning('Por favor selecione uma Cidade.');
                    break;
                  case 'ADDRESS_STATE_IS_REQUIRED':
                    Common.Toast.warning('Por favor selecione um Estado.');
                    break;
                  case 'NATIONAL_ID_NUMBER_IS_REQUIRED':
                    Common.Toast.warning('Por favor digite o CPF do estudante.');
                    break;
                  case 'NATIONAL_ID_NUMBER_ALREADY_BEEN_USED':
                    Common.Toast.warning('Este CPF já foi utilizado por outro estudante.');
                    break;
                  case 'EMAIL_IS_REQUIRED':
                    Common.Toast.warning('Campo E-mail é obrigatório.');
                    break;
                  case 'EMAIL_EXISTS':
                    Common.Toast.warning('E-mail já existe para outro usuário.');
                    break;
                  case 'ID_ISSUER_IS_REQUIRED':
                    Common.Toast.warning('Selecione o Orgão Expedidor do RG.');
                    break;
                  case 'ID_NUMBER_IS_REQUIRED':
                    Common.Toast.warning('Digite sua identidade.');
                    break;
                  case 'PERSON_SEX_ID_IS_REQUIRED':
                    Common.Toast.warning('Defina o sexo por favor.');
                    break;
                }
              });
              if (fail.data.message !== null) {
                if (fail.data.message === 'The given data was invalid.') {
                  Common.Toast.error('Dados faltando no formulário');
                } 
                //else if(fail.data.message == 'PERSON_COUNTRY_ID_NATIONALITY_IS_NULL'){
                //  Common.Toast.warning("Por favor, preencha o campo de nacionalidade para continuar");
                //}
                else {
                  Common.Toast.error(fail.data.message);
                }
              }
            } else {
              Common.Toast.warning('Erro ao salvar');
            }
            $rootScope.show_loader = false;
          });
        $rootScope.show_loader = false;
      } else {
        Common.Toast.error('Informação inválida no formulário');
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return PoliciesService.checkPolicyFromMenu(policy);
    };


    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn, ltn2, ltn3, ltn4, ltn5].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.students')
    .controller('StudentsEditController', StudentsEditController);

})();

(function () {
  'use strict';

  function StudentsCreateController($rootScope, $scope, $state, StudentsService, PersonService, Common, LocalStorage, PoliciesService){

    var vm = this;
    var LocalStorageKEY = 'responsibles_current_tab';
    vm.search_text = '';
    vm.show_tabs = false;
    vm.selected_tab = LocalStorage.get(LocalStorageKEY);
    vm.form = {
      mode_edit: true,
      person: {}
    };
    vm.list = {
      person: {},
      person_student: {}
    };

    /**
     * Esculta a troca do campo de Estado no formulário de criação de aluno
     * @type {*}
     */
    var ltn = $rootScope.$on('person_address_state_change', function (ev, address_state_id) {
      vm.form.person.address_city = null;
      vm.changeAddressState(address_state_id);
    });

    /**
     * Esculta a troca do campo de Estado no formulário de criação de aluno
     * @type {*}
     */
    var ltn2 = $rootScope.$on('person_birth_certificate_registry_state_change', function (ev, birth_certificate_registry_state){
      vm.form.person.birth_certificate_registry_city = null;
      vm.changeAddressStateRegistry(birth_certificate_registry_state);
    });

    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    var ltn3 = $rootScope.$on('address_postal_code.blur', function (ev, CEP) {
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          vm.form.person.address_state = address.uf;
          vm.form.person.address_city = address.localidade;
          vm.form.person.address_street = address.logradouro;
          vm.form.person.address_district = address.bairro;
          vm.changeAddressState(vm.form.person.address_state, address.localidade);

        })
    });

    vm.init = function () {
      vm.getFormInfos();
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param item - novo item selecionado
     */
    vm.changeStudent = function (item) {
      if (angular.isDefined(item)) {
        $state.go('private.educational.students.edit', {id: item.id}, {reload: true});
      }
    };


    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     */
    vm.changeAddressState = function (address_state_id) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
        })
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param birth_certificate_registry_state - novo item selecionado
     */
    vm.changeAddressStateRegistry = function (birth_certificate_registry_state) {
      PersonService.getCities(birth_certificate_registry_state)
        .then(function (response) {
          vm.list.person.birth_certificate_registry_city = response.plain();
        })
    };

    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      StudentsService.getInfos()
        .then(function (response) {
          vm.list.person = response.person;
          vm.list.person_student = response.person_student;
        })
    };

    /** Formata corretamente para o banco as datas que usam mascaras */
    vm.formatCorretDate = function (date) {
      if(date != null && angular.isDefined(date)){
        return date.split("/").reverse().join("-");
      }
    };

    /**
     * Submissão do estudante
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        /** Realiza a copia dos dados */
        var new_item = angular.copy(item);
        /** Realiza o tratamento das datas */
        new_item.dob = (angular.isString(new_item.dob)) ? vm.formatCorretDate(new_item.dob) : vm.formatCorretDate(new_item.dob.toLocaleDateString());

        StudentsService.createStudent(new_item)
          .then(function (response) {
            Common.Toast.success('Estudante criado com sucesso');
            $state.go('private.educational.students.edit', {id: response.id});
            vm.form.mode_edit = false;
          })
          .catch(function (fail) {
            if (angular.isObject(fail.data)) {
              angular.forEach(fail.data, function (value) {
                switch (value[0]) {
                  case 'NAME_IS_REQUIRED':
                    Common.Toast.warning('Campo nome é obrigatório.');
                    break;
                  case 'ADDRESS_CITY_IS_REQUIRED':
                    Common.Toast.warning('Por favor selecione uma Cidade.');
                    break;
                  case 'ADDRESS_STATE_IS_REQUIRED':
                    Common.Toast.warning('Por favor selecione um Estado.');
                    break;
                  case 'NATIONAL_ID_NUMBER_IS_REQUIRED':
                    Common.Toast.warning('Por favor digite o CPF do estudante.');
                    break;
                  case 'NATIONAL_ID_NUMBER_ALREADY_BEEN_USED':
                    Common.Toast.warning('Este CPF já foi utilizado por outro estudante.');
                    break;
                  case 'EMAIL_IS_REQUIRED':
                    Common.Toast.warning('Campo E-mail é obrigatório.');
                    break;
                  case 'ID_ISSUER_IS_REQUIRED':
                    Common.Toast.warning('Selecione o Orgão Expedidor do RG.');
                    break;
                  case 'ID_NUMBER_IS_REQUIRED':
                    Common.Toast.warning('Digite sua identidade.');
                    break;
                  case 'PERSON_SEX_ID_IS_REQUIRED':
                    Common.Toast.warning('Defina o sexo por favor.');
                    break;
                }
              });
            }
          })
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn, ltn2, ltn3].forEach(function (fn) {
        fn();
      })
    });

    vm.init()

  }

  angular
    .module('app.educational.students')
    .controller('StudentsCreateController', StudentsCreateController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function StudentsController($rootScope, $timeout, $mdMenu, $scope, $state, $stateParams,
                              $a4FloatButton, a4Moment, CourseService, CONFIG, StudentsService,
                              GroupsService, EnrolmentService, ModalFactory, Common,
                              PersonService, AppLog,
                              PoliciesService, ReportsService, EducationalService, Session) {
    var vm = this;
    vm.company = Session.getCurrentCompany();
    vm.profile = Session.getCurrentProfile();
    vm.form = {};
    vm.enrolment_status_id = null;
    vm.current_page = 0;
    vm.grid = {rows: [], info: {}, order: null};
    vm.is_inactive = false;
    vm.list_options = [{name: 'Ativos', value: 'inactives'}, {name: 'Inativos', value: 'actives'}];
    vm.show_inactive = false;
    vm.currentTab = 0;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.search = null;
    vm.is_without_school_period = false;
    vm.school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.EXCLUI_MATRICULA_ALUNO_RESPS = 0;
    vm.EXCLUI_MATRICULA_ALUNO = 1;
    vm.EXCLUI_MATRICULA = 2;

    vm.resize = function () {
      vm.windowHeight = (angular.element("#content").height() - (angular.element("#page-material-table").height() + angular.element("#toolbar").height())) * 0.8;
      if (vm.windowHeight < 560) {
        vm.windowHeight = vm.windowHeight * 0.97;
        if (vm.windowHeight < 460) {
          vm.windowHeight = vm.windowHeight * 0.95;
        }
        if (vm.windowHeight < 390) {
          vm.windowHeight = vm.windowHeight * 0.91;
          if (vm.windowHeight < 320) {
            vm.windowHeight = vm.windowHeight * 0.91;
          }
        }
      }
    };

    var ln = $(window).resize(function () {
      vm.resize();
    });

    vm.init = function () {
      vm.api_uri = CONFIG.webApiUri;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.getSchoolPeriod();
      if ($stateParams.tab_selected === "1") {
        vm.currentTab = 1;
      }
      EnrolmentService.getAllEnrolmentStatus()
        .then(function (resp) {
          vm.enrolment_status = resp.plain();
        });
      vm.resize();
      $timeout(function () {
        vm.resize();
      }, 2000);

      // Verifica de ativa o botão de sincronização com as catracas da Madis
      if((vm.company === 734 || vm.company === 713) && (vm.profile === 3 ||vm.profile === 0 )) {
        vm.show_gate_sync = true;
      }

    };

    /**
     * Aumenta a foto do aluno ao passar o mouse por cima
     * @param id
     */
    vm.expandImage = function (id) {
      var image = angular.element(document.getElementById(id));
      image[0].style['max-width'] = '150px';
      image[0].style['width'] = '150px';
      image[0].style['height'] = '90px';
    };

    /**
     * Reduz a foto para o tamanho normal após retirar o cursor do mouse
     * @param id
     */
    vm.unexpandImage = function (id) {
      var image = angular.element(document.getElementById(id));
      image[0].style['max-width'] = '39px';
      image[0].style['width'] = '39px';
      image[0].style['height'] = '';
    };

    vm.getDefaultSchoolPeriod = function (school_periods) {
      for (var i = school_periods.length; i--;) {
        if (school_periods[i].is_default === true) {
          return school_periods[i].id;
        }
      }
    };

    vm.doEnrolment = function (pre_enrolment) {
      if (pre_enrolment === '1' && (vm.conf.current_school_period_id < vm.conf.default_school_period_id)) {
        ModalFactory.alert(
          "Pré-matrícula não habilitada", "O processo de pré-matrícula só pode ser realizado em um período letivo maior ou igual que o período padrão. " +
          "Para realizar o processo, mude para um período maior que " + vm.conf.default_school_period_id,
          "modal", "Ok", "false", "educational"
        );
      } else {
        if (vm.conf.current_school_period_id !== vm.conf.school_period_default_enrolment_id) {
          ModalFactory.confirm(null,
            "Período letivo selecionado diferente do padrão de matrícula",
            "O período letivo selecionado (" + vm.conf.current_school_period_id + ") é diferente do período definido " +
            "como padrão para matrícula (" + vm.conf.school_period_default_enrolment_id + "). Deseja continuar?",
            "Continuar", "Cancelar", "educational")
            .then(function () {
              $state.go('private.educational.enrolment.new', {pre_enrolment: pre_enrolment});
            });
        } else {
          $state.go('private.educational.enrolment.new', {pre_enrolment: pre_enrolment});
        }
      }
    };

    /**
     * Executa uma função desejada na lista de opções do grid
     * @param student
     * @param option
     */
    vm.clickActions = function (student, option) {
      switch (option) {
        case 'change-group':
          vm.changeCourse(student, true);
          break;
        case 'go-to-external-statement':
          vm.getExternalFinancialStatement(student);
          break;
        case 'change-course':
          vm.changeCourse(student, false);
          break;
        case 'confirm-enrolment':
          vm.confirmEnrolment(student);
          break;
        case 'edit-enrolment-date':
          vm.editEnrolmentDate(student);
          break;
        case 'cancel-enrolment':
          vm.cancelEnrolment(student);
          break;
        case 'undo-cancel-enrolment':
          vm.undoCancelEnrolment(student);
          break;
        case 'delete-enrolment':
          vm.deleteEnrolment(student);
          break;
        case 'approve-pre-enrolment':
          ModalFactory.confirm(null, "Confirmar aprovação",
            "Deseja realmente aprovar a pré-matrícula deste aluno?",
            'Confirmar', 'Cancelar', 'educational')
            .then(function () {
              vm.updatePreEnrolmentStatus(student, 2);
            });
          break;
        case 'disapprove-pre-enrolment':
          ModalFactory.confirm(null, "Confirmar reprovação",
            "Deseja realmente reprovar a pré-matrícula deste aluno?",
            'Confirmar', 'Cancelar', 'educational')
            .then(function () {
              vm.updatePreEnrolmentStatus(student, 3);
            });
          break;
        case 'ausent':
          ModalFactory.confirm(null, "Confirmar ausência",
            "Deseja realmente definir este aluno como ausente?",
            'Confirmar', 'Cancelar', 'educational')
            .then(function () {
              vm.updatePreEnrolmentStatus(student, 4);
            });
          break;
        case 'student-access-card-number-link':
          vm.openAccessCardModal(student);
          break;
        default:
          break;
      }
    };

    /**
     * Redireciona para ficha financeira externa
     * @param person
     */
    vm.getExternalFinancialStatement = function (person) {
      $rootScope.show_loader = true;
      PersonService.getExternalFinancialStatementLink({person_id: person.id})
        .then(function (link) {
          $rootScope.show_loader = false;
          var element = document.createElement('a');
          element.setAttribute('href', link);
          element.setAttribute('target', '_blank');
          return element.click();
        }).catch(function (error) {
        $rootScope.show_loader = false;
        Common.Toast.error(error.data.message);
      })
    };


    /**
     * Exclusão de matrícula
     * @param student
     */
    vm.deleteEnrolment = function (student) {
      $rootScope.show_loader = true;
      StudentsService.verifyDelete(student).then(function (response) {
        $rootScope.show_loader = false;
        /** Caso a exclusão não seja bloqueada */
        if (angular.isUndefined(response.block) || response.block.length === 0) {
          /** Verifica situações para o usuário decidir em relação à exclusão */
          if (response.alert.enrolments === true) {
            vm.confirmDeleteEnrolment(student, vm.EXCLUI_MATRICULA);
          } else {
            var text = vm.defineDeleteText(response.alert);
            ModalFactory.custom('app/educational/students/views/student-delete-modal.html', {
              alerts: response.alert,
              student: student,
              text: text,
              option: null
            }).then(function (response) {
              vm.confirmDeleteEnrolment(student, response);
            })
          }
        } else {
          ModalFactory.custom('app/components/modal/Templates/operationError.html', {
            reasons: response.block,
            name: 'Exclusão de matrícula',
            message: 'Este aluno não poderá ser excluído porque:',
            theme: 'educational'
          }, false);
        }
      });
    };

    vm.defineDeleteText = function (alerts) {
      if (alerts.resp_dep === 0 && alerts.employee === 0 && alerts.responsible === 0
        && alerts.resp_employee === 0 && alerts.resp_enrolment === 0) {
        return "Este aluno e os seus responsáveis não possuem outra matrícula no sistema. Deseja excluir os dados do alunos e dos responsáveis também?";
      } else if (alerts.employee === 0 && alerts.responsible === 0) {
        return "Este aluno não possui outra matrícula no sistema, deseja excluir os seus dados também?";
      }
    };

    vm.confirmDeleteEnrolment = function (student, option) {
      ModalFactory.open('require_password', null, null, {
          student: student,
          option: option
        }, null, 'educational', vm.executeDelete,
        'Confirmação de exclusão de matrícula', 'Confirme sua senha para excluir a matrícula', null).then(function () {
        vm.grid.rows = [];
        vm.current_page = 0;
        if (vm.currentTab === 0) {
          vm.paginate();
        } else {
          vm.getPreEnrolment();
        }
        Common.Toast.success('Matrícula excluída com sucesso!');
        $rootScope.show_loader = false;
      });
    };

    vm.executeDelete = function (obj) {
      return StudentsService.deleteEnrolment(obj)
        .catch(function(error) {
          // Verifica se o erro é uma violação de chave estrangeira (SQLSTATE[23503])
          if (error.data.message.includes("SQLSTATE[23503]")) {
            // Define uma mensagem específica para esse tipo de erro
            error.data.message = "Não é permitido a exclusão de matrículas, quando houver títulos pagos. Efetue o cancelamento da matrícula.";
          }
          // Lança o erro novamente para que ele seja tratado pela lógica de tratamento de erro do seu código
          throw error;
        });
    };

    /**
     * Abre o modal para a mudança de turma do aluno
     */
    vm.changeGroup = function (student) {
      /**
       * Realiza a busca das turmas pelo curso
       */
      if (angular.isDefined(student)) {
        $rootScope.show_loader = true;
        GroupsService.getCourseGroups({
          except_current_group: true,
          id: student.id,
          group_id: student.group_id,
          course_id: student.course_id
        })
          .then(function (response) {
            /** Se houver alguma turma para troca, abro o modal */
            if (response.length !== 0) {
              student.list_groups = (angular.isArray(response.plain())) ? response.plain() : [];
              /**
               * Verifica se há mais de uma matrícula do estudante no período
               */
              StudentsService.verifyStudentEnrolment({
                student_id: student.id,
                matrix_period: student.matrix_period
              }).then(function (check) {
                if (check === true) {
                  ModalFactory.customClean(
                    'app/educational/students/views/students-change-group.html',
                    'StudentsChangeGroupController',
                    'vm', false, student
                  ).then(function (response) {
                    if (response) {
                      vm.current_page = 0;
                      vm.grid.rows = [];
                      vm.paginate();
                    }
                  });
                } else {
                  Common.Toast.warning('Este aluno possui duas matrículas no mesmo período!');

                }
              });
              /** Caso não haja nenhuma turma para troca */
            } else {
              Common.Toast.warning('Não existem turmas para realizar a troca para este aluno!');
            }
          });
        $rootScope.show_loader = false;
      }
    };

    /**
     * Realiza edição da data da matrícula do aluno selecionado
     * @param student
     */
    vm.editEnrolmentDate = function (student) {
      var obj = {
        date: a4Moment(student.enrolment_date)
      };
      ModalFactory.custom('app/educational/students/views/students-change-enrolment-date.html', obj, true).then(function (date) {
        $rootScope.show_loader = true;
        StudentsService.changeEnrolmentDate({student: student, enrolment_date: date}).then(function () {
          vm.grid.rows = [];
          vm.current_page = 0;
          vm.paginate();
          Common.Toast.success('Data da matrícula atualizada com sucesso!');
          $rootScope.show_loader = false;

        })
      })
    };

    /**
     * Altera o curso do aluno
     * @param student
     */
    vm.changeCourse = function (student, isChangeGroup) {
      CourseService.getAll({only_active: true})
        .then(function (courses) {
          student.list_courses = courses;
          student.change_course = true;
          ModalFactory.customClean('app/educational/students/views/students-change-course.html',
            'StudentsChangeGroupController', 'vm', false, {student: student, isChangeGroup: isChangeGroup}).then(function (response) {
            if (response) {
              vm.current_page = 0;
              vm.grid.rows = [];
              vm.paginate();
            }
          })
        });
    };

    /***
     * Confirma manualmente a matrícula do estudante, alterando o status
     * de "Aguardando pagamento" para "Matriculado"
     * @param student
     */

    vm.confirmEnrolment = function (student) {

      ModalFactory.confirm(null, "Confirmar matrícula",
        "Deseja realmente confirmar manualmente esta matrícula em andamento?",
        'Confirmar', 'Cancelar')
        .then(function () {
          EnrolmentService.confirmEnrolment(student).then(function () {
            Common.Toast.success('Matrícula confirmada com sucesso.');
            vm.grid.rows = [];
            vm.current_page = 0;
            vm.paginate();
          }).catch(function () {
            Common.Toast.warning('Problemas na confirmação da matrícula.');
          })
        });

    };

    /**
     * Abre o modal para o cancelamento de uma matrícula
     * @param student
     */
    vm.cancelEnrolment = function (student) {
      ModalFactory.customClean(
        'app/educational/students/views/students-cancel-enrolment.html',
        'StudentsCancelEnrolmentController',
        'vm', false, {student: student}
      ).then(function (form) {
        $rootScope.show_loader = true;
        ModalFactory.open('require_password', null, null, form, null, 'educational', vm.executeEnrolmentCancel,
          'Cancelamento de matrícula', 'Confirme a senha para cancelar a matrícula e os contratos selecionados', null)
          .then(function () {
            vm.grid.rows = [];
            vm.current_page = 0;
            vm.paginate();
            Common.Toast.success("Matrícula cancelada com sucesso!");
          })
      }).catch(function () {
      });
    };

    /**
     * Função que cancela a matrícula
     * @param form
     * @returns {*}
     */
    vm.executeEnrolmentCancel = function (form) {
      return StudentsService.cancelEnrolmentAndContracts(form);
    };


    /**
     * Abre o modal para desfazer o cancelamento de uma matrícula
     * @param student
     */
    vm.undoCancelEnrolment = function (student) {
      ModalFactory.customClean(
        'app/educational/students/views/students-undo-cancel-enrolment.html',
        /** @ngInject */
        function (StudentsService, ModalFactory, ModalExtra, $mdDialog) {
          var vm = this;
          vm.form = {};
          vm.student = ModalExtra.student;
          vm.form.contracts = [];
          vm.show_loading = false;
          /**
           * Fecha o modal
           */
          vm.close = function (obj) {
            $mdDialog.hide(obj);
          };
          /**
           * Busca os contratos do ano atual do aluno, inclusive os cancelados, e adiciona ao formulário o contrato principal
           */
          vm.getStudentContracts = function () {
            vm.show_loading = true;
            vm.disableButton = true;
            StudentsService.getStudentContracts({
              id: vm.student.id, withSchoolPeriod: true,
              canceled: true
            }).then(function (response) {
              vm.studentContracts = response.plain();
              for (var i = 0; i < vm.studentContracts.length; i++) {
                if (vm.studentContracts[i].external_id) {
                  vm.form.contracts.push(vm.studentContracts[i]);
                }
              }
              vm.show_loading = false;
              vm.disableButton = false;
            });
            $rootScope.show_loader = false;
          };

          vm.submit = function () {
            vm.show_loading = true;
            vm.disableButton = true;
            vm.form.student_id = vm.student.id;
            vm.form.group_id = vm.student.group_id;
            vm.form.course_id = vm.student.course_id;
            vm.form.matrix_period = vm.student.matrix_period;
            vm.close(vm.form);
          };
          vm.init = function () {
            vm.getStudentContracts();
          };
          vm.init();
        },
        'vm', false, {student: student}
      ).then(function (obj) {
        ModalFactory.open('require_password', null, null, obj, null, 'educational', vm.executeUndoCancel,
          'Descancelamento de matrícula', 'Confirme sua senha para descancelar a matrícula', null)
          .then(function () {
            Common.Toast.success("Matrícula descancelada com sucesso!");
            vm.grid.rows = [];
            vm.current_page = 0;
            vm.paginate();
          }).catch(function () {
          Common.Toast.error("Erro ao descancelar matrícula");
        });
      });
      $rootScope.show_loader = false;
    };
    /**
     * Função que desfaz o cancelamento da matrícula
     */
    vm.executeUndoCancel = function (form) {
      return StudentsService.undoCancelmentOfEnrolmentAndContracts(form);
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Abertura do assistente de matricula
     */
    vm.createEnrolment = function () {
      ModalFactory.customClean(
        'app/educational/enrolment/views/enrolment-wizard.html',
        'EnrolmentAssistantController',
        'vm', false
      );
    };

    vm.openAccessCardModal = function (student) {
      ModalFactory.custom('app/educational/students/views/students-access-card-number-link.html', angular.copy(student))
        .then(function (modalData) {
          $rootScope.show_loader = true;
          StudentsService.saveAccessCardNumber(modalData).then(function (response) {
              if (response) {
                Common.Toast.success("Cartão salvo com sucesso!");
                $rootScope.show_loader = false;
              }
            }).catch(function (error) {
            Common.Toast.error("Erro ao salvar cartão");
            $rootScope.show_loader = false;
          })
        });
    }

    vm.changeOptionsSelected = function () {
      vm.grid.rows = [];
      vm.current_page = 0;
      vm.paginate();
    };

    vm.getEnrolment = function () {
      vm.grid.rows = [];
      vm.current_page = 0;
      vm.paginate();
    };

    vm.getPreEnrolment = function () {
      vm.grid.rows = [];
      vm.current_page = 0;
      vm.paginate(true);
    };

    vm.paginate = function (pre_enrolment, page_filter, search) {
      vm.doPaginate(pre_enrolment, page_filter, search);
    }

    vm.reorder = function (order) {
      vm.current_page = 0;
      vm.doPaginate(undefined, undefined, undefined, order);
    }

    /**
     * Retorna todos os estudantes disponíveis
     * @param pre_enrolment
     * @param page_filter
     * @param search
     * @param order
     */
    vm.doPaginate = function (pre_enrolment, page_filter, search, order) {
      pre_enrolment = angular.isDefined(pre_enrolment) && pre_enrolment
      vm.current_page = angular.isDefined(page_filter) ? page_filter : vm.current_page + 1;

      if (vm.currentTab) {
        pre_enrolment = 1
      }
      
      $rootScope.show_loader = true;
      var limit = 30;
      var page = vm.current_page ? vm.current_page : 1;
      var inactives_too = vm.is_inactive;
      var show_inactive = vm.show_inactive;
      var direction = 'asc';
      var order_by = null;
      search = angular.isDefined(search) ? search : vm.search;
      if (vm.grid.order === null && angular.isDefined(order)) {
        direction = order.substring(0, 1) === '-' ? 'desc' : 'asc';
      } else if (vm.grid.order !== null) {
        direction = vm.grid.order.substring(0, 1) === '-' ? 'desc' : 'asc';
      }
      if (angular.isUndefined(order)) {
        order_by = vm.grid.order === null ? null : (vm.grid.order.substring(0, 1) === '-' ? vm.grid.order.substring(1) : vm.grid.order)
      } else {
        order_by = (order.substring(0, 1) === '-' ? order.substring(1) : order);
      }

      vm.grid.promise = StudentsService.getAll({
        limit: limit,
        page: page,
        inactives_too: inactives_too,
        show_inactive: show_inactive,
        options: vm.filter_selected,
        pre_enrolment: pre_enrolment === 1 ? 'true' : pre_enrolment,
        enrolment_status_id: vm.enrolment_status_id,
        query: search,
        order_by: order_by,
        direction: direction
      })
        .then(function (response) {
          if (page === 1) {
            vm.grid.rows = [];
          }
          var rows = response.data;
          for (var i = 0; i < rows.length; i++) {
            if (rows[i].matrix_qty > 1) {
              rows[i].group_name = rows[i].group_name + " | " + rows[i].matrix_period + "/" + rows[i].matrix_qty;
            }
            switch (rows[i].pre_enrol_status) {
              case 0:
                rows[i].pre_enrol_status = 'Pré-matrícula em andamento';
                break;
              case 1:
                rows[i].pre_enrol_status = 'Em análise';
                break;
              case 2:
                rows[i].pre_enrol_status = 'Aprovado';
                break;
              case 3:
                rows[i].pre_enrol_status = 'Reprovado';
                break;
              case 4:
                rows[i].pre_enrol_status = 'Ausente';
                break;

            }
            if (angular.isDefined(rows[i].group_status_id) &&
              (rows[i].group_status_id === 4 && rows[i].enrolment_status === 'Matriculado')) {
              rows[i].enrolment_status = 'Turma_encerrada';
            }
            if (rows[i].conclusion_date !== null) {
              rows[i].enrolment_status = 'Concluído';
            }
          }
          vm.grid.rows = vm.grid.rows.concat(rows);
          /*          if (vm.grid.rows.length > 0 && vm.grid.rows[0].school_period_id === 0) {
                      vm.is_without_school_period = true;
                    }*/
          vm.grid.info = {
            limit_options: [20, 30, 40, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        });
    };

    /**
     * Chamada do serviço de retorna todos os grupos de curso da API
     */
    vm.getAll = function (enrolment_status_id) {
      $rootScope.show_loader = true;
      StudentsService.getAll({enrolment_status_id: enrolment_status_id})
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.grid.rows = response.plain();
        })
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterStudentsList = function (query) {
      var inactives_too = vm.is_inactive;

      StudentsService.getAll({query: query, inactives_too: inactives_too, show_inactive: vm.show_inactive})
        .then(function (response) {
          vm.grid.rows = response.plain();
        })
    };

    /**
     * Manda para a criação de estudante
     */
    vm.createStudents = function () {
      $state.go('private.educational.students.create');
    };

    /**
     * Edição de estudante
     * @param item - item a ser editado
     */
    vm.editStudents = function (item) {
      $state.go('private.educational.students.edit', {
        id: item.id,
        course_id: item.course_id,
        group_id: item.group_id,
        course_equivalence_id: item.course_equivalence_id,
        matrix_period: item.matrix_period,
        enrolment_period_id: item.enrolment_period_id
      });
    };

    /**
     * Executa a chamada para a API, para a deleção de um determinado estudante
     * @param index - identificador do estudante, para deleção
     */
    vm.deleteStudent = function (index) {
      ModalFactory.confirm(null,
        'Deseja remover este estudante?',
        'Esta operação não pode ser desfeita.',
        'Remover Estudante', 'Cancelar', 'educational')
        .then(function (response) {
          if (response) {
            StudentsService.destroy(index)
              .then(function () {
                Common.Toast.success('Estudante removido com sucesso.');
                vm.grid.rows = [];
                vm.current_page = 0;
                vm.paginate();
              })
              .catch(function (fail) {
                if (angular.isObject(fail.data)) {
                  angular.forEach(fail.data, function (value) {
                    switch (value[0]) {
                      case 'PERSON_COMPANY_EXCLUSION_ERROR':
                        Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                        break;
                      case 'PERSON_STUDENT_EXCLUSION_ERROR':
                        Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                        break;
                      case 'PERSON_STUDENT_HAS_INFOS_ACTIVE_ENROLLMENT':
                        Common.Toast.warning('Existem informações associadas a este estudante, remoção não permitida');
                        break;
                    }
                  });
                }
              })
          }
        });
    };

    /**
     * Atualiza status de pré-matrícula de um aluno
     * @param item
     * @param status
     */
    vm.updatePreEnrolmentStatus = function (item, status) {
      $rootScope.show_loader = true;
      StudentsService.updatePreEnrolmentStatus({
        person_id: item.id,
        group_id: item.group_id,
        pre_enrol_status: status
      }).then(function () {
        vm.getPreEnrolment();
        Common.Toast.success('Status alterado com sucesso!');
      })
    };

    /**
     * Resgata os períodos letivos
     */
    vm.getSchoolPeriod = function () {
      EducationalService.getSchoolsPeriod()
        .then(function (periods) {
          vm.conf.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
          vm.conf.school_period_default_enrolment_id = angular.isDefined(periods.default_enrolment[0]) ? periods.default_enrolment[0].id : periods.selected.id;
          vm.conf.default_school_period_id = vm.getDefaultSchoolPeriod($scope.educational.school_period.list);
        })
    };

    vm.openCancelDetail = function (student) {
      if (student.enrolment_status_id === 32) {
        $rootScope.show_loader = true;
        EnrolmentService.getCancelReasons().then(function (response) {
          var cancelReasons = response.plain();
          $rootScope.show_loader = false;
          ModalFactory.custom('app/educational/students/views/cancel-reason-edit.html', {
            student: student,
            cancelReasons: cancelReasons
          }).then(function (student) {
            $rootScope.show_loader = true;
            StudentsService.editCancelInfo(student).then(function () {
              Common.Toast.success('Informações do cancelamento editadas com sucesso');
              vm.grid.rows = [];
              vm.current_page = 0;
              vm.paginate();
            })

          });
        });
      }
    };

    vm.createOrUpdateGates = function() {
      $rootScope.show_loader = true;
      ModalFactory.confirm(null,
        'Atenção',
        'ao confirmar, todas as informações dos alunos no sistema serão sincrnizados com o sistema de catracas MADIS',
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          StudentsService.createOrUpdateGates()
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Informações de cadastro das catracas atualizadas com sucesso');
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.warning(error.data.message);
            })
        });
      $rootScope.show_loader = false;
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
    vm.resize();
    // $scope.$on('$destroy', function () {
    //   [ltn].forEach(function (fn) {
    //     fn();
    //   })
    // });
  }

  angular
    .module('app.educational.students')
    .controller('StudentsController', StudentsController)
})();

(function () {
    'use strict';

    /** @ngInject */
    function StudentsChangeGroupController(
      $rootScope,
      $filter,
      $mdDialog,
      a4Moment,
      A4ContractService,
      CourseService,
      ModalExtra,
      Common,
      StudentsService,
      GroupsService,
      EnrolmentService,
      LocalStorage
    ){

      var vm = this;

      vm.form = {
        mode_edit: true,
        person: {},
        changeDate: a4Moment(),
        has_lessons: false,
        lesson_date: a4Moment(),
        change_plan_date: a4Moment(),
        lesson_option: 0,
        change_plan_option: 2
      };
      vm.new_payment_plan = null;
      vm.list = {
        person: {}
      };
      vm.contract = {};
      vm.show_amount_contract = false;
      vm.show_options_contract = null;

      /**
       * Função de inicialização do controlador.
       */
      vm.init = function () {
        vm.form.person = ModalExtra.student;
        vm.isChangeGroup = ModalExtra.isChangeGroup;
        vm.courses = ModalExtra.student.list_courses;
        vm.list.person.new_group_id = ModalExtra.list_groups;
        vm.form.person.initial_date = new Date();
        vm.has_finance = LocalStorage.get('has_app_finance');
        vm.change_course = ModalExtra.change_course === true ? true : null;
        vm.verifyStudentLessons();
        if (vm.has_finance) {
          vm.getStudentContracts();
        } else {
          vm.have_contract = true;
        }
        if(ModalExtra.isChangeGroup) {
          vm.setGroups(vm.form.person.course_id);
        }
      };

      vm.changeDate = function () {
        vm.form.lesson_date = vm.form.changeDate;
        vm.form.change_plan_date = vm.form.changeDate;
      };
      /**
       * Busca os contratos do estudante
       */
      vm.getStudentContracts = function () {
        vm.show_loading = true;
        StudentsService.getStudentContracts({
          id: vm.form.person.id,
          withSchoolPeriod: true,
          enrolment_period_id: vm.form.person.enrolment_period_id
        })
          .then(function (response) {
            vm.student_contracts = response.plain();
            vm.selectMainContract();
          })
      };

      vm.getIndividualDiscounts = function (bill_serie_id) {
        A4ContractService.getIndividualDiscounts(bill_serie_id)
          .then(function (discounts) {
            vm.main_contract.discounts = discounts.plain();
          })

      };

      /**
       * Seleciona o seu contrato principal, ou seja, o contrato da sua turma atual
       */
      vm.selectMainContract = function () {
        if (vm.form.person.contract_type === 'U') {
          vm.main_contract = $filter('filter')(vm.student_contracts,
            {external_id: vm.form.person.group_id, matrix_period: 1, is_deleted: false})[0];
        } else {
          vm.main_contract = $filter('filter')(vm.student_contracts,
            {external_id: vm.form.person.group_id, matrix_period: vm.form.person.matrix_period, is_deleted: false})[0];
        }
        vm.show_loading = false;
        vm.have_contract = true;
        if (angular.isDefined(vm.main_contract)) {
          vm.getIndividualDiscounts(vm.main_contract.bill_serie_id);
        } else {
          Common.Toast.error('Esse aluno não possui um contrato principal!');
          vm.has_finance = false;
          vm.show_loading = false;
          vm.have_contract = false;
        }
      };

      /**
       * Executa o fechamento do Modal
       */
      vm.close = function () {
        $rootScope.$broadcast('ModalFactory.close');
      };

      /**
       * Busca os planos de aula para a turma selecionada
       */
      vm.getPaymentPlansForGroup = function (group_matrix) {
        var group_id = group_matrix.split('|')[0];
        EnrolmentService.getPaymentPlansForGroup({group_id: group_id})
          .then(function (response) {
            vm.payment_plans = response.plain();
            if (vm.payment_plans.length === 1) {
              vm.setPaymentPlan(vm.payment_plans[0].payment_plan_id);
            }
          })
      };

      /**
       * Busca as turmas de acordo com o curso selecionado
       * @param course_id
       */
      vm.setGroups = function (course_id) {
        GroupsService.getCourseGroups({
          id: vm.form.person.id,
          group_id: vm.form.person.group_id,
          course_id: course_id
        })
          .then(function (groups) {
            vm.groups = groups.plain();
          });
      };

      /**
       * Seleciona o novo plano de pagamento
       * @param payment_plan_id
       */
      vm.setPaymentPlan = function (payment_plan_id) {
        vm.show_amount_contract = false;
        var selected = $filter('filter')(vm.payment_plans, {payment_plan_id: payment_plan_id}, true)[0];
        vm.contract.payment_plan_id = payment_plan_id;
        vm.contract.quantity = selected.quantity;
        vm.contract.bank_slip_rule_id = selected.bank_slip_rule_id;
        vm.contract.debit_credit = 'C';
        vm.contract.frequency = selected.frequency;
        vm.contract.frequency_qty = selected.frequency_qty;
        vm.contract.product_id = selected.product_id;
        vm.contract.amount = selected.recurrence_on_value === 2 ? (selected.price / selected.quantity) : selected.price;
        vm.contract.date_first = selected.date_first === null || selected.date_first === '' ? '' : a4Moment(selected.date_first).format('YYYY-MM-DD');
        vm.contract.preferential_due_day = vm.main_contract.preferential_due_day;

        if (vm.main_contract.payment_plan_id === payment_plan_id && vm.main_contract.amount === vm.contract.amount) {
          vm.show_options_contract = false;
        } else {
          vm.show_options_contract = true;
        }

        if (vm.contract.amount === null) {
          vm.show_amount_contract = true;
        }
      };
      /*
       vm.changePlan = function (obj, form) {
         if (form.$valid) {
           ContractService.changePaymentPlan(obj, vm.main_contract.bill_serie_id)
             .then(function () {
             })
         }
       };
   */
      /**
       * Verifica se o aluno possui registro de aulas
       * @param student_id
       */
      vm.verifyStudentLessons = function () {
        StudentsService.verifyStudentLessons({student_id: vm.form.person.id, group_id: vm.form.person.group_id}
        ).then(function (has_lessons) {
          if (has_lessons) {
            vm.has_lessons = true;
            vm.last_lesson_date = a4Moment(has_lessons.plain().lesson_date).format('DD/MM/YYYY');
          } else {
            vm.has_lessons = false;
          }
        })
      };

      /**
       * Submit do formulário
       */
      vm.submit = function () {

        vm.show_loading = true;
        vm.disableButton = true;
        var obj = {
          contract: vm.contract,
          discounts: angular.isDefined(vm.main_contract) ? vm.main_contract.discounts : [],
          change_plan_option: vm.form.change_plan_option,
          lesson_option: vm.form.lesson_option,
          lesson_date: a4Moment(vm.form.lesson_date).format('YYYY-MM-DD'),
          change_contract_date: vm.form.change_plan_date,
          person_id: vm.form.person.id,
          matrix_period: parseInt(vm.new_group_id.split('|')[1]),
          old_matrix_period: vm.form.person.matrix_period,
          change_date: vm.form.changeDate,
          new_group_id: parseInt(vm.new_group_id.split('|')[0]),
          old_group_id: vm.form.person.group_id,
          has_lessons: vm.has_lessons,
          bill_serie_id: angular.isDefined(vm.main_contract) ? vm.main_contract.bill_serie_id : null,
          has_finance: vm.has_finance
        };
        StudentsService.changegroupstudent(obj)
          .then(function () {
            $mdDialog.hide(true);
            $rootScope.$broadcast('students.list.update');
            Common.Toast.success('Aluno realocado com sucesso!');
          })
          .catch(function (error) {
            if (error.data.message === 'NO_BILLS_TO_CREATE') {
              Common.Toast.error('Não existe títulos a serem criados com esta forma de troca de contrato. Reelabore.');
            } else {
              Common.Toast.error(error.data.message);
            }
            vm.show_loading = false;
            vm.disableButton = false;

          })
      };

      vm.init();
    }

    angular
      .module('app.educational.students')
      .controller('StudentsChangeGroupController', StudentsChangeGroupController)
  }

)();

(function () {
  'use strict';

  /** @ngInject */
  function StudentsCancelEnrolmentController($rootScope, $mdDialog, Common, EnrolmentService, ModalFactory, ModalExtra, a4Moment, StudentsService) {
    var vm = this;
    vm.form = {};
    vm.student = ModalExtra.student;
    vm.form.cancelDate = a4Moment();
    vm.form.contracts = [];
    vm.show_loading = false;
    /**
     * Fecha o modal
     */
    vm.close = function () {
      $mdDialog.hide(true);
    };

    /**
     * Busca as razões de cancelamento, para o select.
     */
    vm.getCancelReasons = function () {
      vm.show_loading = true;
      EnrolmentService.getCancelReasons().then(function (response) {
        vm.cancelReasons = response.plain();
        vm.show_loading = false;
      });
    };

    /**
     * Busca os contratos do ano atual do aluno
     */
    vm.getStudentContracts = function () {
      $rootScope.show_loader = true;
      vm.show_loading = true;
      StudentsService.getStudentContracts({
        id: vm.student.id, withSchoolPeriod: true,
        group_id: vm.student.group_id,
        verify_contract_type: true, is_enrolment_cancel: true, enrolment_period_id: vm.student.enrolment_period_id
      }).then(function (response) {
        vm.studentContracts = response.plain();
        for (var i = 0; i < vm.studentContracts.length; i++) {
          if (vm.studentContracts[i].external_id) {
            vm.form.contracts.push(vm.studentContracts[i]);
          }
        }
        vm.show_loading = false;
      });
      $rootScope.show_loader = false;
    };

    /**
     * Retorna se o item do checkbox deve estar marcado
     * @param contract
     * @returns {boolean}
     */
    vm.isItemChecked = function (contract) {
      for (var i = 0; i < vm.form.contracts.length; i++) {
        if (vm.form.contracts[i].bill_serie_id === contract.bill_serie_id &&
          vm.form.contracts[i].amount === contract.amount) {
          return true;
        }
      }
      return false;
    };

    /**
     * Adiciona ou remove o contrato da lista de checkbox marcados.
     * @param contract
     */
    vm.manipulateListOfContracts = function (contract) {
      for (var z = 0; z < vm.form.contracts.length; z++) {
        if (vm.form.contracts[z].bill_serie_id === contract.bill_serie_id &&
          vm.form.contracts[z].amount === contract.amount) {
          vm.form.contracts.splice(z, 1);
          return;
        }
      }
      vm.form.contracts.push(contract);
    };

    vm.submit = function () {
      vm.show_loading = true;
      vm.disableButton = true;
      vm.form.student_id = vm.student.id;
      vm.form.group_id = vm.student.group_id;
      vm.form.course_id = vm.student.course_id;
      vm.form.matrix_period = vm.student.matrix_period;
      $mdDialog.hide(vm.form);

    };

    vm.init = function () {
      vm.getCancelReasons();
      vm.getStudentContracts();
    };

    vm.init();

  }

  angular
    .module('app.educational.students')
    .controller('StudentsCancelEnrolmentController', StudentsCancelEnrolmentController)
})();

(function() {
  'use strict';
  angular
    .module('app.educational.statistics', []);
})();

(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.statistics', {
        public: true,
        url: '/statistics',
        templateUrl: 'app/educational/statistics/index.html',
        controller: 'StatisticsController',
        controllerAs: 'vm',
        abstract: false
      });
  }

  angular
    .module('app.educational.statistics')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, LocalStorage) {
    var path = 'secretary.statistics';
    var company = LocalStorage.get('current_company', "sessionStorage");

    msNavigationService.saveItem(path, {
      title: 'Estatísticas',
      icon: 'icon-poll',
      state: 'private.educational.statistics',
      weight: 7,
      // hidden: function () {
      //   //caso seja portal do saber ou porto seguro
      //   return !(company === 683 || company === 101224 || company === 101321 || company === 101249);
      // }
    });
  }

  angular
    .module('app.educational.statistics')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function StatisticsController(CourseService, $rootScope, GroupService, SubjectService, 
                                EducationalService, ModalFactory, Common,ReportsService, Session) {

    var vm = this;
    vm.course_selected  = null;
    vm.group_selected   = null;
    vm.subject_selected = null;
    vm.event_selected = null;
    vm.data_view = null;
    vm.grade_rule_selected = null;
    vm.chart = {};
    vm.colors = ["#8c0000", "#000a9a", "#009a00", "#E89C32", "#9D00E8"];
    // vm.series = ["De 0.00 a 49.99", "De 50.00 a 69.99", "De 70.00 a 100.00"];
    // vm.series = ["De 0.00% a 49.99%", "De 50.00% a 69.99%", "De 70.00% a 100.00%"];

    vm.selected_tab = 'course';
    vm.init = function () {
      vm.getAllCourses();
      vm.getGradeRuleFromActiveGroups();
      vm.getGradeRangeAnalyses();
    };

    vm.getGradeRangeAnalyses = function () {
      EducationalService.getGradeRangeAnalyses()
        .then(function (response) {
        vm.grade_ranges = response.plain();
        //captura os limites e adiciopna o padrao  de legenda, com de x% a y%
        vm.series = [
          "De" + vm.grade_ranges[0].limit_from + "% a " + vm.grade_ranges[0].limit_to + "%",
          "De" + vm.grade_ranges[1].limit_from + "% a " + vm.grade_ranges[1].limit_to + "%",
          "De" + vm.grade_ranges[2].limit_from + "% a " + vm.grade_ranges[2].limit_to + "%",
          vm.grade_ranges[3]
        ]
        });
    };

    vm.blankOptions = function (tab) {
      vm.course_selected  = null;
      vm.groups   = null;
      vm.grade_rules = null;
      vm.subject_selected = null;
      vm.event_selected = null;
      vm.grade_rule_selected = null;
      vm.chart = null;
      // vm.title = null;
      if(tab < 2) {
        vm.getGradeRuleFromActiveGroups();
      }
    };

    vm.getGradeRuleFromActiveGroups = function () {
      EducationalService.getGradeRuleFromActiveGroups()
        .then(function (response) {
          vm.grade_rules = response.plain();
        })
    };

    vm.getEventByGradeRule = function () {
      EducationalService.getEventByGradeRule({grade_rule_id: vm.grade_rule_selected.id})
        .then(function (response) {
          vm.grade_rule_items = response.plain();
          vm.getSubjectByGradeRule();
        })
    };

    vm.getSubjectByGradeRule = function () {
      SubjectService.getSubjectByGradeRule({grade_rule_id: vm.grade_rule_selected.id})
        .then(function (response) {
          vm.subjects = response.plain()
        })
    };

    vm.getAllCourses = function () {
      $rootScope.show_loader = true;
      CourseService.getAll({only_active: true})
        .then(function (response) {
          vm.courses = response.plain();
        });
      $rootScope.show_loader = false;
    };

    vm.getAllSubjects = function () {
      SubjectService.getAll({without_grouped: true})
        .then(function (response) {
          vm.subjects = response.plain()
        })
    };

    vm.getGroupsBycourse = function(course_id, tab) {
      console.log(course_id);
      console.log(vm.course_selected);
      console.log(tab);
      if(course_id !== 0) {
        GroupService.getGroupsByCourse(course_id, {
          paginate: false,
          show_inactive_groups: false
        })
          .then(function (response) {
            vm.groups = response.plain();
            if(angular.isDefined(vm.groups[1])) {
              // vm.getGradeOrSubjects(vm.groups[0].id, tab);
              vm.group_selected = null;
            } else {
              vm.group_selected = vm.groups[0];
              vm.getGradeOrSubjects(vm.group_selected.id, tab);
            }
          }).catch(function (error) {
            vm.course_selected = null;
            Common.Toast.warning(error.data.message);
          })
      } else {
        vm.group_selected = 0;
        if(tab === 2){
          vm.getGradeRuleFromActiveGroups();
        } else {
          vm.getAllSubjects();
        }
      }
    };

    vm.getGradeOrSubjects = function(group_id, tab) {
      if(tab === 3) {
        if(group_id !== undefined) {
          SubjectService.getSubjectsGroup({group_id: group_id})
            .then(function (response) {
              vm.subjects = response.plain();
            })
        } else {
          SubjectService.getAll()
            .then(function (response) {
              vm.subjects = response.plain();
            })
        }
      } else if (tab === 2) {
        EducationalService.getGradeRuleByGroup({group_id: group_id})
          .then(function (response) {
            vm.grade_rules = response.plain();
          })
      }
    };

    vm.toggle_view = function() {
    };

    vm.submit = function(tab) {
      switch (tab) {
        case 0:
          EducationalService.getStatisticsForCourse({
            subject: vm.subject_selected.id,
            subject_name: vm.subject_selected.name,
            event: vm.event_selected.name,
            grade_rule: vm.grade_rule_selected.id
          }).then(function (response) {
            vm.chart = response.plain()[0];
            vm.title = response.plain()[1];
            vm.data_view = response.plain()[0].data
          });
        break;
        case 1:
          EducationalService.getStatisticsForGroup({
            subject: vm.subject_selected.id,
            subject_name: vm.subject_selected.name,
            event: vm.event_selected.name,
            grade_rule: vm.grade_rule_selected.id
          }).then(function (response) {
            vm.chart = response.plain()[0];
            vm.title = response.plain()[1];
            vm.data_view = response.plain()[0].data
          });
        break;
        case 2:
          EducationalService.getStatisticsForSubject({
            course: vm.course_selected.id,
            course_alias: vm.course_selected.alias,
            group: vm.group_selected.id,
            group_name: vm.group_selected.name,
            event: vm.event_selected.name
          }).then(function (response) {
            vm.chart = response.plain()[0];
            vm.title = response.plain()[1];
            vm.data_view = response.plain()[0].data
          });
        break;
        case 3:
          EducationalService.getStatisticsForEvent({
            course: vm.course_selected.id,
            course_alias: vm.course_selected.alias,
            group: vm.group_selected.id,
            group_name: vm.group_selected.name,
            subject: vm.subject_selected.id,
            subject_name: vm.subject_selected.name
          }).then(function (response) {
            vm.chart = response.plain()[0];
            vm.title = response.plain()[1];
            vm.data_view = response.plain()[0].data
          });
        break;
      }

    };

    vm.openChartsConfig = function() {
        ModalFactory.customClean(
          'app/educational/statistics/statistics-config-modal.html',
          'StatisticsConfigModalController',
          'vm', false, vm.grade_ranges
        ).then(function() {
          vm.getGradeRangeAnalyses();
        })
    };

    vm.printChart = function (tab) {
      $rootScope.show_loader = true;
     ReportsService.reportFactory('GET',
      'api/reports/printchart',
      {
        type: tab,
        course: vm.course_selected !== null ? vm.course_selected.id: null, //vm.course_selected.id
        course_alias: vm.course_selected !== null ? vm.course_selected.alias: null,//vm.course_selected.alias
        group: vm.group_selected !== null ? vm.group_selected.id: null,//vm.group_selected.id
        group_name: vm.group_selected !== null ? vm.group_selected.name: null,//vm.group_selected.name
        subject: (vm.subject_selected !== null && vm.subject_selected !== 0) ? vm.subject_selected.id: null,//vm.subject_selected.id
        subject_name: vm.subject_selected !== null ? vm.subject_selected.name: null,//vm.subject_selected.name
        grade_rule: vm.grade_rule_selected !== null ? vm.grade_rule_selected.id: null,//vm.grade_rule_selected.id
        event: vm.event_selected !== null ? vm.event_selected.name: null//vm.event_selected.name
      }).then(function() {
      $rootScope.show_loader = false;
      }).catch(function(error) {
        Common.Toast.error(error.message || error.data.message);
      })
    }

    vm.init();
  }

  angular
    .module('app.educational.statistics')
    .controller('StatisticsController', StatisticsController)
})();

(function () {
    'use strict';
  
    /** @ngInject */
    function StatisticsConfigModalController($rootScope, EducationalService, ModalExtra, $scope) {
      var vm = this;
      vm.limitError = false;
  
      vm.init = function ()  {
        vm.getGradeRangeAnalyses();

      };


      vm.getGradeRangeAnalyses = function () {
        EducationalService.getGradeRangeAnalyses()
          .then(function (response) {
          vm.ranges = response.plain();
          vm.ranges.forEach(function(range) {
            console.log(range);
            range.limit_from /= 100;
            range.limit_to /= 100;
          });
          });
      };

      vm.checkLimit = function(modelPath) {
        
        // Usar $parse para avaliar a expressão do caminho do modelo
        var value = $scope.$eval(modelPath);
        if (value > 1) {
            value = 1;
        } else {
            // Limitar a duas casas decimais
        }

        // Atualizar o modelo com o novo valor
        $scope.$eval(modelPath + ' = ' + value);
    };

      /** Realiza o fechamento do modal */
      vm.closeModal = function () {
        $rootScope.$broadcast('ModalFactory.close');
      };
    
      vm.submit = function () {
        $rootScope.show_loader = true;
        vm.closeModal();

        EducationalService.submitGradeRangeAnalyses({ranges: vm.ranges})
        .then(function () {
        $rootScope.show_loader = false;      
        });
      };
  
      vm.init();
    }
  
    angular
    .module('app.educational.statistics')
    .controller('StatisticsConfigModalController', StatisticsConfigModalController)
  
  })();
(function () {
  'use strict';

  angular
    .module('app.educational.settings-edu', []);

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.settings-edu', {
        url: '/settings',
        public: false,
        templateUrl: 'app/educational/settings/views/index.html',
        controller: 'SettingsControllerEdu',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Configurações'
        }
      });
  }

  angular
    .module('app.educational.settings-edu')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'config_menu';
    var path = 'config.settings';

    msNavigationService.saveItem(path, {
      title: 'Mais Configurações',
      icon: 'icon-cog',
      auth: role,
      state: 'private.educational.settings-edu',
      weight: 9999,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.settings-edu')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function SettingsControllerEdu($rootScope, Common, PoliciesService, ModalFactory, NFSEService, Session, StudentsService) {

    var vm = this;

    vm.profile = PoliciesService.currentProfile();
    vm.company = Session.getCurrentCompany();

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    // Verifica se ativa o botão de sincronização com o AgendaEdu
    if((vm.company === 683 || vm.company === 101224 || vm.company === 101321) && (vm.profile === 3 || vm.profile === 0 )) {
      vm.show_agendaedu_sync = true;
    }

    /**
     * Lista de recursos de configurações
     */
    vm.boardList = [
      {
        "name": "Datas Limite para Notas",
        "state": "private.educational.typing-date.list",
        "icon": 'icon-calendar',
        "policy": !vm.checkPolicies('bloq_nota_conf')
      },
      {
        "name": "Critério de Avaliação",
        "state": "private.educational.evaluation-criteria.list",
        "icon": 'icon-clipboard-text',
        "policy": !vm.checkPolicies('crit_aval_conf')
      },
      {
        "name": "Critério de Arredondamento",
        "state": "private.educational.rounding-criteria.list",
        "icon": 'icon-clipboard-alert',
        "policy": !vm.checkPolicies('crit_arred_conf')
      },
      {
        "name": "Critério de Conceito",
        "state": "private.educational.concept-criteria.list",
        "icon": 'icon-clipboard-check',
        "policy": !vm.checkPolicies('crit_conc_conf')
      },
      {
        "name": "Períodos letivos",
        "state": "private.educational.school-period-config.config",
        "icon": 'icon-calendar-check-multiple',
        "policy": !vm.checkPolicies('per_let_conf')
      },
      {
        "name": "Mensagens",
        "state": "private.educational.documents.list",
        "icon": 'icon-message-text',
        "policy": !vm.checkPolicies('educ_msgs')
      },
      {
        "name": "Tabelas",
        "state": "private.educational.tables",
        "icon": 'icon-blur-radial',
        "policy": !vm.checkPolicies('educ_tables')
      },
      {
        "name": "Grades de Horário",
        "state": "private.educational.timetable-template",
        "icon": 'icon-timetable',
        "policy": !vm.checkPolicies('hor_model_conf')
      },
      {
        "name": "Histórico do Aluno",
        "state": "private.educational.school-records-config",
        "icon": 'icon-book-multiple-variant',
        "policy": !vm.checkPolicies('hist_esc_conf')
      },

      // Observe que esta opção por aqui abre um módulo um pouco diferente da opção que está ativa agora.
      // Ao ter nova necessidade, é importante verificar as duas opções
      // {
      //   "name": "Importação de imagem em lote",
      //   "state": "private.educational.import-photos",
      //   "icon": 'icon-image',
      //   "policy": true
      // }
    ];

    /**
     * Abre o modal para renumerar os estudantes da turma para que a numeração corresponda à ordem alfabética
     */
    vm.renumberStudents = function () {
      ModalFactory.customClean("app/educational/settings/views/renumber-students.html",
        "RenumberStudentsController", "vm", false, {});
    };

    /**
     * Abre modal de configurações de empresa corrente
     */
    vm.openConfigurationForFileBatch = function () {
      ModalFactory.customClean("app/educational/settings/views/file-batch.html",
        "FileBatchController", "vm", false, {});
    };

    /**
     * Abre modal de configurações de empresa corrente
     */
    vm.openEnrolmentConfiguration = function () {
      ModalFactory.customClean("app/educational/settings/views/enrolment-configuration.html",
        "EnrolmentConfigurationController", "vm", false, {});
    };

    /**
     * Abre modal de configurações de boletim escolar
     */
    vm.openGradeReportConfiguration = function () {
      ModalFactory.customClean("app/educational/settings/views/grade-report-configuration.html",
        "GradeReportConfigurationController", "vm", false, {});
    };

    vm.openDataExportForSET = function () {
      ModalFactory.customClean("app/educational/settings/views/data-export-set.html",
        "DataExportSetController", "vm", false, {});
    };

    vm.getCurrentCompany = function () {
      return NFSEService.getCurrentCompany();
    };

    vm.openEmailConfig = function () {
      vm.getCurrentCompany().then(function (company) {
        ModalFactory.custom('app/educational/settings/views/email-config.html', {
          company: company.plain(),
          theme: 'educational'
        }, false)
          .then(function (response) {
            if (response) {
              $rootScope.show_loader = true;
              NFSEService.updateCompanyConfig(response).then(function () {
                Common.Toast.success('Configuração de e-mail salva com sucesso.');
                $rootScope.show_loader = false;
              })
            }
          })
      })
    };

    vm.openChangeTeacher = function () {
      ModalFactory.customClean("app/educational/settings/views/change-teacher-modal.html",
        "ChangeTeacherController", "vm", false, {}).then(function () {
      });
    };

    vm.createOrUpdateAgendaEdu = function() {
      $rootScope.show_loader = true;
      ModalFactory.confirm(null,
        'Atenção',
        'ao confirmar, todas as informações dos alunos no sistema serão sincrnizados com o sistema de Agenda Edu',
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          StudentsService.createOrUpdateAgendaEdu()
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Informações de cadastro do AgendaEdu atualizadas com sucesso');
            })
            .catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Erro ao atualizar o AgendaEdu');
            })
        });
      $rootScope.show_loader = false;
    };

  }

  angular
    .module('app.educational.settings-edu')
    .controller('SettingsControllerEdu', SettingsControllerEdu);

})();

(function () {
  'use strict';

  /** @ngInject */
  function RenumberStudentsController($rootScope, CONFIG, Common, GroupsService, Session) {

    var vm = this;
    vm.CONFIG = CONFIG;
    vm.isProcessing = false;
    vm.determinateValue = 0;

    vm.submit = function () {
      vm.isProcessing = true;
      GroupsService.renumberStudents()
        .then(function () {
          Common.Toast.success("Renumeração efetuada com sucesso");
          vm.isProcessing = false;
          vm.closeModal();
        })
        .catch(function (response) {
          Common.Toast.error(response.message);
          vm.isProcessing = false;
        });
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    }

  }

  angular.module('app.educational.settings-edu')
    .controller('RenumberStudentsController', RenumberStudentsController)


})();
(function () {
  'use strict';

  /** @ngInject */
  function GradeReportConfigurationController($rootScope, SettingsService, Common) {

    var vm = this;
    vm.show_loading = true;
    vm.show_saving = false;
    vm.grade_report_config = {
      block_external_grade_report_link: false
    };


    vm.init = function () {
      vm.get();
    };

    /**
     * Retorna a configuração da empresa
     */
    vm.get = function () {
      vm.show_loading = true;
      SettingsService.getGradeReportConfiguration()
        .then(function (response) {
          var data = response.plain();
          vm.grade_report_config = {
            block_external_grade_report_link: data.block_external_grade_report_link || false
          };
          vm.show_loading = false;
        })
        .catch(function (error) {
          vm.show_loading = false;
          Common.Toast.error(error.message || 'Erro ao carregar configurações');
        });
    };

    /**
     * Salvar configuração
     * @param form - Objeto que representa o formulário
     * @param item - Item com valores do formulário
     */
    vm.saveConfig = function (form, item) {
      if (form.$valid && !vm.show_saving) {
        vm.show_saving = true;
        SettingsService.saveGradeReportConfiguration(item)
          .then(function () {
            Common.Toast.success('Configurações salvas com sucesso');
            vm.show_saving = false;
            vm.close();
          })
          .catch(function (error) {
            vm.show_saving = false;
            Common.Toast.error(error.message || 'Erro ao salvar configurações');
          })
      }
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular
    .module('app.educational.settings-edu')
    .controller('GradeReportConfigurationController', GradeReportConfigurationController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function FileBatchController($rootScope, $document, CONFIG, Common, DropzoneService, Session) {

    var vm = this;
    vm.CONFIG = CONFIG;
    vm.isProcessing = false;
    vm.determinateValue = 0;

    vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/students/filesinbatch?connection=' + $document[0].domain.split('.')[0] + '&company=' + Session.getCurrentCompany() +
        '&current_school_period=' + vm.current_school_period_id,
      paramName: 'file',
      maxFilesize: '300',
      acceptedFiles: DropzoneService.getMimeTypes(['ZIP']),
      uploadMultiple: true,
      parallelUploads: 50,
      maxFiles: 1,
      autoProcessQueue: true
    };
    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'addedfile': function () {
        vm.isProcessing = true;
      },
      'uploadprogress': function (item, progress, bytesSent) {
        vm.determinateValue = progress;
      },
      'success': function () {
        vm.determinateValue = 100;
        Common.Toast.success("Imagens enviadas com sucesso");
        vm.closeModal();
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    }

  }

  angular.module('app.educational.settings-edu')
    .controller('FileBatchController', FileBatchController)


})();
(function () {
  'use strict';

  /** @ngInject */
  function EnrolmentConfigurationController($rootScope, SettingsService, Common) {

    var vm = this;
    vm.show_loading = true;
    vm.show_saving = false;
    vm.enrolment_config = {
      enrolment_bank_slip_type: 0,
      enrolment_bank_slip_number_initial: null,
      enrolment_bank_slip_number_final: null,
      enrolment_online_initial_date: null,
      enrolment_online_final_date: null
    };


    vm.init = function () {
      vm.get();
    };

    /**
     * Retorna a configuração da empresa
     */
    vm.get = function () {
      vm.show_loading = true;
      SettingsService.getEnrolmentConfiguration()
        .then(function (response) {
          vm.enrolment_config = response.plain();
          vm.show_loading = false;
        })
        .catch(function (error) {
          vm.show_loading = false;
          Common.Toast.error(error.message || 'Erro ao carregar configurações');
        });
    };

    /**
     * Salvar configuração
     * @param form - Objeto que representa o formulário
     * @param item - Item com valores do formulário
     */
    vm.saveConfig = function (form, item) {
      if (form.$valid && !vm.show_saving) {
        vm.show_saving = true;
        SettingsService.saveEnrolmentConfiguration(item)
          .then(function () {
            Common.Toast.success('Configurações salvas com sucesso');
            vm.show_saving = false;
            vm.close();
          })
          .catch(function (error) {
            vm.show_saving = false;
            Common.Toast.error(error.message || 'Erro ao salvar configurações');
          })
      }
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular
    .module('app.educational.settings-edu')
    .controller('EnrolmentConfigurationController', EnrolmentConfigurationController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DataExportSetController($document, $scope, $rootScope, a4Moment, CONFIG, Common, CourseService,
                                   GroupService, StudentsService, Session, ReportsService) {

    var vm = this;
    vm.CONFIG = CONFIG;
    vm.webLink = CONFIG.webApiUri;
    vm.with_primary = false;
    vm.isProcessing = false;
    vm.determinateValue = 0;
    vm.only_with_cpf = false;
    vm.only_after_date = false;
    vm.institution_number = null;
    vm.file_sequence = null;
    vm.enrolment_date_after = null;
    vm.school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    vm.course_id = 0;
    vm.group_id = 0;
    vm.courses = [];
    vm.groups = [];

    vm.getCourses = function () {
      CourseService.getAll({only_active: true})
        .then(function (response) {
          vm.courses = response.plain();
        });
      $rootScope.show_loader = false;
    };
    /**
     * Retorna as turmas de um curso selecionado
     * @param course_id
     */
    vm.getGroups = function (course_id) {
      GroupService.getGroupsByCourse(course_id)
        .then(function (response) {
          vm.groups = response.plain().data;
          if (vm.groups.length > 0) {
            vm.groups.push({id: 0, name: 'Todas as turmas'});
            vm.print.group_selected = 0;
          } else {
            vm.groups.push({id: 0, name: 'Todas as turmas'});
            vm.print.group_selected = null;
          }
        });
    };

    vm.init = function () {
      vm.getCourses();
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
          vm.conf.current_school_period_id = $scope.educational.school_period.selected.id;
        });
    };


    vm.generateTXT = function () {
      vm.isProcessing = true;
      var date = vm.enrolment_date_after !== null ? a4Moment(vm.enrolment_date_after).format('YYYY-MM-DD') : null;
      StudentsService.exportDataForSET({
        institution_number: vm.institution_number,
        group_id: vm.group_id,
        course_id: vm.course_id,
        only_with_cpf: vm.only_with_cpf,
        only_after_date: vm.only_after_date,
        enrolment_date_after: date,
        with_primary: vm.with_primary
      }, vm.institution_number, vm.file_sequence).then(function () {
        vm.isProcessing = false;
      })
    };

    vm.printReport = function () {
      var date = vm.enrolment_date_after !== null ? a4Moment(vm.enrolment_date_after).format('YYYY-MM-DD') : null;
      var href = vm.webLink + 'api/reports/listforexportset?token=' + vm.conf.token + '&company=' + vm.conf.current_company
        + '&connection=' + vm.conf.current_connection + '&group_id=' + vm.group_id +
        '&institution_number=' + vm.institution_number + '&user_id=' + vm.conf.user_id
        + "&file_sequence=" + vm.file_sequence + '&course_id=' + vm.course_id
        + "&only_with_cpf=" + vm.only_with_cpf
        + "&with_primary=" + vm.with_primary
        + "&current_school_period=" + vm.school_period
        + "&only_after_date=" + vm.only_after_date + "&enrolment_date_after=" + date;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular.module('app.educational.settings-edu')
    .controller('DataExportSetController', DataExportSetController)

})();
(function () {
  'use strict';

  /** @ngInject */
  function ChangeTeacherController($scope, $rootScope, a4Moment, Common, ClassesService, PersonService) {
    var vm = this;
    vm.showLoaderClasses = false;
    vm.showLoaderSubmit = false;
    vm.form = {
      dateChange: a4Moment(),
      oldTeacher: null,
      newTeacher: null,
      selectedClasses: []
    };
    vm.toggleAll = false;
    vm.classes = null;

    vm.manageToggleAll = function (toggleAll) {
      if (toggleAll) {
        vm.classes.forEach(function (item) {
          if (!vm.isClassSelected(item)) {
            vm.form.selectedClasses.push({group_id: item.group_id, subject_id: item.subject_id, matrix_period: item.matrix_period});
          }
        })
      } else {
        vm.form.selectedClasses = [];
      }
      $scope.$applyAsync();
    };

    vm.addOrRemoveSelectedClass = function (selectedClass) {
      if (!vm.isClassSelected(selectedClass)) {
        vm.form.selectedClasses.push({group_id: selectedClass.group_id, subject_id: selectedClass.subject_id, matrix_period: selectedClass.matrix_period});
      } else {
        vm.form.selectedClasses = vm.form.selectedClasses.filter(function (item) {
          return !(item.group_id === selectedClass.group_id && item.subject_id === selectedClass.subject_id && item.matrix_period === selectedClass.matrix_period)
        })
      }
    };

    vm.isClassSelected = function (classItem) {
      var isOnArray = false;
      vm.form.selectedClasses.forEach(function (item) {
        if (item.group_id === classItem.group_id && item.subject_id === classItem.subject_id && item.matrix_period === classItem.matrix_period) {
          isOnArray = true;
        }
      });
      return isOnArray;
    };

    vm.getTeachers = function (query) {
      return PersonService.getPersonWithFilter({query: query, selected_tab: 3});
    };

    vm.getClassesFromTeacher = function (teacher) {
      vm.showLoaderClasses = true;
      ClassesService.getClassByTeacher({teacher_id: teacher.id}).then(function (response) {
        vm.classes = response.plain();
        vm.showLoaderClasses = false;
      })
    };

    vm.submit = function () {
      vm.showLoaderSubmit = true;
      ClassesService.changeTeacherOfClasses({
        person_id_teacher_new: vm.form.newTeacher.id,
        person_id_teacher_old: vm.form.oldTeacher.id,
        classes: vm.form.selectedClasses,
        date_change: a4Moment(vm.form.dateChange).format('YYYY-MM-DD')
      }).then(function () {
        Common.Toast.success("Troca realizada com sucesso!");
        vm.closeModal();
      });
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

  }

  angular
    .module('app.educational.settings-edu').controller('ChangeTeacherController', ChangeTeacherController);
})();

(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.school-records-config', {
        url: '/schoolrecord/config',
        public: false,
        templateUrl: 'app/educational/school-records-config/views/index.html',
        controller: 'SchoolRecordsConfigController',
        controllerAs: 'vm',
        data : {
          pageTitle: 'SchoolRecords'
        }
      });
  }

  angular
    .module('app.educational.school-records-config')
    .config(routerConfig);

})();
(function() {
  'use strict';

  /** @ngInject */
  function run(){
    /*msNavigationService.saveItem('schoolrecords', {
      title : 'Histórico do Aluno',
      icon  : 'icon-book-multiple-variant',
      state : 'private.educational.schoolrecords'
    });*/
  }

  angular
    .module('app.educational.school-records-config')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function SchoolRecordsConfigController($filter, $rootScope, $scope, BillReceiptService, SchoolRecordsService, Common, ModalFactory) {

    var vm = this;
    vm.general_variables = [
      {
        name: '{{Aluno_Nome}}',
        presentation: 'Nome do aluno'
      }, {
        name: '{{Aluno_Curso}}',
        presentation: 'Curso'
      }, {
        name: '{{Aluno_Turma}}',
        presentation: 'Turma'
      }, {
        name: '{{Aluno_Periodo}}',
        presentation: 'Período letivo'
      }, {
        name: '{{Data_Atual_Extenso}}',
        presentation: 'Data atual por extenso'
      },
    ];

    vm.header_footer_variables = [
      {
        name: '{{Escola_Nome}}',
        presentation: 'Nome da escola'
      }, {
        name: '{{Escola_CNPJ}}',
        presentation: 'CNPJ da escola'
      }, {
        name: '{{Escola_Telefone}}',
        presentation: 'Telefone da escola'
      }, {
        name: '{{Escola_Endereco_Rua}}',
        presentation: 'Rua da escola'
      }, {
        name: '{{Escola_Endereco_Numero}}',
        presentation: 'Número do endereço da escola'
      }, {
        name: '{{Escola_Endereco_Bairro}}',
        presentation: 'Bairro da escola'
      }, {
        name: '{{Escola_Endereco_CEP}}',
        presentation: 'CEP da escola'
      }, {
        name: '{{Escola_Endereco_Cidade}}',
        presentation: 'Cidade da escola'
      }, {
        name: '{{Escola_Endereco_Estado}}',
        presentation: 'Estado da escola'
      }, {
        name: '{{Data_Atual_Extenso}}',
        presentation: 'Data atual por extenso'
      },
    ];

    /**
     * Adiciona variáveis aos textos configuráveis
     * @param input
     * @param item
     */
    vm.setVariable = function (input, item) {
      // vm.config[input] += ' ' + item.name;
      var elem =  document.getElementsByName(input)[0];
      if (elem.selectionStart || elem.selectionStart === '0') {
        var _startSelection = elem.selectionStart;
        var _endSelection = elem.selectionEnd;
        elem.value = elem.value.substring(0, _startSelection)
          + ' ' + item.name
          + elem.value.substring(_endSelection, elem.value.length);
      } else {
        elem.value += ' ' + item.name;
      }
    };

    vm.submit = function () {
      $rootScope.show_loader = true;
      SchoolRecordsService.saveSchoolRecordsConfig(vm.config).then(function () {
        Common.Toast.success('Configurações gerais dos históricos salvas com sucesso!');
        $rootScope.show_loader = false;
      })
    };

    vm.limitInputSize = function (item, field, limit) {
      var string = angular.copy(item).toString();
      if (string.length > limit) {
        vm.config[field] = parseInt(string.slice(0, limit));
      }
    };

    vm.form = {
      mode_edit: false
    };

    vm.school_records = {
      types: [
        {id: 1, name: 'Ensino Infantil', type: 'pre'},
        {id: 2, name: 'Ensino Fundamental', type: 'primary'},
        {id: 3, name: 'Ensino Médio', type: 'high'}
      ]
    };

    vm.school_records_selected = [];

    vm.init = function () {
      $rootScope.show_loader = true;
      BillReceiptService.getConfig().then(function (response) {
        vm.config = response.plain();
        $rootScope.show_loader = false;
      });
      /*      Common.Toast.error('Em desenvolvimento!');*/

    };

    /** Classificação padrão das disciplinas */
    vm.classification = [
      {'id': 1, 'name': 'Base Nacional Comum', 'subject_classification_id': 1, nodes: []},
      {'id': 2, 'name': 'Parte Diversificada', 'subject_classification_id': 2, nodes: []},
      {'id': 3, 'name': 'Formação Profissionalizante', 'subject_classification_id': 3, nodes: []}
    ];

    /**
     * Resgata as disciplinas
     */
    vm.selectSubjectSchoolRecords = function (type) {
      $rootScope.show_loader = true;
      SchoolRecordsService.getSubjectSchoolRecordsConfig({type: type})
        .then(function (response) {
          vm.subjects = response.plain();
          vm.subjects = vm.subjects[type];

          vm.subjects = $filter('orderBy')(vm.subjects, 'sequence'); //Ordena as disciplinas vindas pela sequência

          /** Realiza a limpeza */
          vm.classification[0].nodes = [];
          vm.classification[1].nodes = [];
          vm.classification[2].nodes = [];

          /** Realiza a varredura das disciplinas */
          angular.forEach(vm.subjects, function (item) {
            var group = item.subject_classification_id;

            /** Possibilita o item a receber itens */
            if (angular.isUndefined(item.nodes)) {
              item.nodes = [];
            }
            /** Agrupamento pela Base Nacional Comum */
            if (group === 1) {
              /** aninha as disciplinas que são filhas ou não */
              if (angular.isDefined(item.subject_id_parent) && item.subject_id_parent !== null) {
                angular.forEach(vm.classification[0].nodes, function (parent) {
                  if (parent.id === item.subject_id_parent) parent.nodes.push(item);
                });
              } else {
                vm.classification[0].nodes.push(item);
              }
            }
            /** Agrupamento Parte Diversificada */
            else if (group === 2) {
              /** aninha as disciplinas que são filhas ou não */
              if (angular.isDefined(item.subject_id_parent) && item.subject_id_parent !== null) {
                angular.forEach(vm.classification[1].nodes, function (parent) {
                  if (parent.id === item.subject_id_parent) parent.nodes.push(item);
                });
              } else {
                vm.classification[1].nodes.push(item);
              }
            }/** Formação Profissionalizante */
            else if (group === 3) {
              /** aninha as disciplinas que são filhas ou não */
              if (angular.isDefined(item.subject_id_parent) && item.subject_id_parent !== null) {
                angular.forEach(vm.classification[2].nodes, function (parent) {
                  if (parent.id === item.subject_id_parent) parent.nodes.push(item);
                });
              } else {
                vm.classification[2].nodes.push(item);
              }
            }

          });
          $rootScope.show_loader = false;

        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Não foi possivel recuperar as disciplinas do histórico.');
        });
    };

    /**
     * Atualiza a configuração da ordem das disciplinas no histórico
     */
    vm.updateSchoolRecordsSubjectConfig = function (obj) {
      SchoolRecordsService.updateSchoolRecordsSubjectConfig({subjects: obj, type: vm.school_records_selected})
        .then(function (response) {
          Common.Toast.success('Configuração de disciplinas atualizada com sucesso.');
        })
        .catch(function (error) {
          Common.Toast.error('Não foi possivel atualizar as disciplinas do histórico.');
        })
    };

    /**
     * Abre modal para configurações gerais do histórico
     */
    vm.openConfigModal = function () {
      $rootScope.show_loader = true;
      BillReceiptService.getConfig().then(function (response) {
        $rootScope.show_loader = false;
        ModalFactory.customClean(
          'app/educational/school-records-config/views/config-modal.html',
          'SchoolRecordsConfigModalController',
          'vm', false, {config: response.plain()}
        );
      });
      /*      Common.Toast.error('Em desenvolvimento!');*/
    };

    vm.init();
  }

  angular
    .module('app.educational.school-records-config')
    .controller('SchoolRecordsConfigController', SchoolRecordsConfigController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function SchoolRecordsConfigModalController($rootScope, $mdDialog, SchoolRecordsService, Common, ModalExtra) {
    var vm = this;
    vm.general_variables = [
      {
        name: '{{Aluno_Nome}}',
        presentation: 'Nome do aluno'
      }, {
        name: '{{Aluno_Curso}}',
        presentation: 'Curso'
      }, {
        name: '{{Aluno_Turma}}',
        presentation: 'Turma'
      }, {
        name: '{{Aluno_Periodo}}',
        presentation: 'Período letivo'
      }, {
        name: '{{Data_Atual_Extenso}}',
        presentation: 'Data atual por extenso'
      },
    ];

    vm.header_footer_variables = [
      {
        name: '{{Escola_Nome}}',
        presentation: 'Nome da escola'
      }, {
        name: '{{Escola_CNPJ}}',
        presentation: 'CNPJ da escola'
      }, {
        name: '{{Escola_Telefone}}',
        presentation: 'Telefone da escola'
      }, {
        name: '{{Escola_Endereco_Rua}}',
        presentation: 'Rua da escola'
      }, {
        name: '{{Escola_Endereco_Numero}}',
        presentation: 'Número do endereço da escola'
      }, {
        name: '{{Escola_Endereco_Bairro}}',
        presentation: 'Bairro da escola'
      }, {
        name: '{{Escola_Endereco_CEP}}',
        presentation: 'CEP da escola'
      }, {
        name: '{{Escola_Endereco_Cidade}}',
        presentation: 'Cidade da escola'
      }, {
        name: '{{Escola_Endereco_Estado}}',
        presentation: 'Estado da escola'
      }, {
        name: '{{Data_Atual_Extenso}}',
        presentation: 'Data atual por extenso'
      },
    ];

    /**
     * Adiciona variáveis aos textos configuráveis
     * @param input
     * @param item
     */
    vm.setVariable = function (input, item) {
      vm.config[input] += ' ' + item.name;
    };

    vm.show_loading = false;
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.submit = function () {
      vm.show_loading = true;
      SchoolRecordsService.saveSchoolRecordsConfig(vm.config).then(function () {
        Common.Toast.success('Configurações gerais dos históricos salvas com sucesso!');
        $mdDialog.hide(true);
      })
    };

    vm.init = function () {
      vm.config = ModalExtra.config;
      vm.config.sr_has_header = vm.config.sr_has_header === null ? true : vm.config.sr_has_header;
      vm.config.sr_general_notes = vm.config.sr_general_notes === null ? '' : vm.config.sr_general_notes;
      vm.config.sr_certificate = vm.config.sr_certificate === null ? '' : vm.config.sr_certificate;
      vm.config.sr_fail_message = vm.config.sr_fail_message === null ? '' : vm.config.sr_fail_message;
      vm.config.sr_has_fail_message = vm.config.sr_has_fail_message === null ? true : vm.config.sr_has_fail_message;
      vm.config.sr_has_general_notes = vm.config.sr_has_general_notes === null ? true : vm.config.sr_has_general_notes;
      vm.config.sr_certificate_option = vm.config.sr_certificate_option === null ? 1 : vm.config.sr_certificate_option;
      vm.config.sr_has_security_code = vm.config.sr_has_security_code === null ? null : vm.config.sr_has_security_code;
      vm.config.sr_security_code_act = vm.config.sr_security_code_act === null ? null : vm.config.sr_security_code_act;
      vm.config.sr_security_code_act_year = vm.config.sr_security_code_act_year === null ? null : vm.config.sr_security_code_act_year;
    };

    vm.init();
  }

  angular.module('app.educational.school-records-config')
    .controller('SchoolRecordsConfigModalController', SchoolRecordsConfigModalController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function SchoolPeriodConfigService(Restangular) {

    var getSchoolsPeriodSeries = function () {
      return Restangular.one('schoolperiod').one('getallperiodserie').get();
    };

    var savePeriodSeries = function (obj) {
      return Restangular.all('schoolperiod').post(obj);
    };

    return {
      getSchoolsPeriodSeries: getSchoolsPeriodSeries,
      savePeriodSeries: savePeriodSeries
    }

  }

  angular
    .module('app.educational.school-period-config')
    .factory('SchoolPeriodConfigService', SchoolPeriodConfigService);

})();

(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.school-period-config', {
        public: false,
        url: '/school-period-config',
        templateUrl: 'app/educational/school-period-config/views/school-period-config.html',
        abstract: true
      })
      .state('private.educational.school-period-config.config', {
        url: '/config',
        public: false,
        views: {
          'school-period-config': {
            templateUrl: 'app/educational/school-period-config/views/config.html',
            controller: 'SchoolPeriodConfigController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.school-period-config')
    .config(routerConfig);

})();
(function () {
  'use strict';

  /** @ngInject */
  function SchoolPeriodConfigController($rootScope, Common, SchoolPeriodConfigService, PoliciesService) {

    var vm = this;
    vm.saving = false;
    vm.form = {
      mode_edit: true
    };

    /**
     * Função de iniciação do controlador
     */
    vm.init = function () {
      $rootScope.show_loader = true;
      vm.getSchoolsPeriodSeries();
      $rootScope.show_loader = false;
    };

    /**
     * Bloqueia os períodos caso seja sem período ou com algum período definido
     * @param item
     * @param id
     */
    vm.blockItems = function (item, id) {
      var count = 0;
      if (vm.items.indexOf(item) === 0) {
        /** Verifica e habilita os com períodos ou o sem período */
        if (vm.items[0].is_selected) {
          angular.forEach(vm.items, function (item) {
            if (item.id !== 0) {
              item.disabled = true;
              item.is_selected = false;
            }
          });
        }
        if (!vm.items[0].is_selected) {
          angular.forEach(vm.items, function (item) {
            if (item.id !== 0) {
              item.disabled = false;
            }
          });
        }
      } else {
        angular.forEach(vm.items, function (item) {
          if (item.id !== 0 && item.is_selected) {
            count = count + 1;
            vm.items[0].disabled = true;
          }
        });
        if (count === 0) {
          vm.items[0].disabled = false;
        }
      }
      vm.savePeriodConfig(vm.items);
      angular.element('#' + id).trigger('focus');
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Pega todos os períodos letivos disponíveis
     */
    vm.getSchoolsPeriodSeries = function () {
      SchoolPeriodConfigService.getSchoolsPeriodSeries()
        .then(function (response) {
          vm.items = response.plain();
          if (vm.items[0].is_selected) {
            angular.forEach(vm.items, function (item) {
              item.disabled = false;
            });
          }
        })
    };

    /**
     * Salva as configurações
     */
    vm.savePeriodConfig = function (selected) {
      vm.saving = true;
      SchoolPeriodConfigService.savePeriodSeries({periods: selected})
        .then(function (response) {
          if (response) {
            Common.Toast.success('Configuração atualizado com sucesso!');
            vm.saving = false;
          }
        })
    };

    vm.init();
  }

  angular
    .module('app.educational.school-period-config')
    .controller('SchoolPeriodConfigController', SchoolPeriodConfigController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function SchoolPeriodService(Restangular, moment) {

    var getAll = function (obj) {
      return Restangular.one('schoolperiod').one('getall').get(obj);
    };

    var changeDefaultSchoolPeriod = function (obj) {
      return Restangular.one('schoolperiod').all('setdefault').post(obj);
    };

    var changeDefaultSchoolPeriodEnrolment = function (obj) {
      return Restangular.one('schoolperiod').all('setdefaultenrolment').post(obj);
    };

    var savePeriod = function (obj) {
      return Restangular.one('schoolperiod').all('savenewperiod').post(obj);
    };

    var updatePeriod = function (obj) {
      return Restangular.one('schoolperiod', obj.id).customPUT(obj);
    };

    var deletePeriod = function (id) {
      return Restangular.one('schoolperiod', id).remove();
    };

    var getLastPeriodBySerie = function (obj) {
      return Restangular.one('schoolperiod').one('getlastperiodbyserie').get(obj);
    };

    var getDatesForSchoolPeriod = function (school_period) {
      var dates = {
        initial_date: {},
        final_date: {}
      };
      dates.initial_date = moment(school_period.final_date).add(1, 'day')._d;
      dates.final_date = moment(school_period.final_date).add(school_period.months, 'months').endOf('month').subtract(3, 'hours')._d;

      return dates;
    };

    return {
      getAll: getAll,
      savePeriod: savePeriod,
      updatePeriod: updatePeriod,
      deletePeriod: deletePeriod,
      getLastPeriodBySerie: getLastPeriodBySerie,
      changeDefaultSchoolPeriod: changeDefaultSchoolPeriod,
      getDatesForSchoolPeriod: getDatesForSchoolPeriod,
      changeDefaultSchoolPeriodEnrolment: changeDefaultSchoolPeriodEnrolment
    }

  }

  angular
    .module('app.educational.school-period')
    .factory('SchoolPeriodService', SchoolPeriodService);

})();

(function() {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.school-period', {
        public: false,
        url: '/school/period',
        templateUrl: 'app/educational/school-period/views/school-period.html',
        abstract: true
      })
      .state('private.educational.school-period.list', {
        url: '/list',
        public: false,
        views: {
          'school-period': {
            templateUrl: 'app/educational/school-period/views/list.html',
            controller: 'SchoolPeriodController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.school-period')
    .config(routerConfig);

})();
(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'per_let_conf';
    var path = 'config.school-period';

    msNavigationService.saveItem(path, {
      title: 'Períodos Letivos',
      icon: 'icon-calendar-check-multiple',
      auth: role,
      state: 'private.educational.school-period.list',
      weight: 1,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.school-period')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function SchoolPeriodController($scope, $filter, Common, SchoolPeriodService, PoliciesService,
                                  SchoolPeriodConfigService, $a4FloatButton, ModalFactory, $rootScope) {

    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };
    vm.school_period_series = [];
    vm.school_period_serie = null;

    vm.init = function () {
      vm.getSchoolsPeriodSeries();
    };

    /** Atualiza a lista de períodos */
    var ltn = $rootScope.$on('school.period.list.update', function () {
      vm.getAllSchoolPeriod();
    });


    /**
     * Ouvinte para mudança de tipo de período
     */
    $scope.$watch('vm.school_period_serie', function () {
      if (vm.school_period_serie !== null) {
        vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createSchoolPeriod()', label: "Novo período"});
        vm.getAllSchoolPeriod();
      }
    }, true);

    vm.createSchoolPeriod = function () {
      ModalFactory.customClean(
        'app/educational/school-period/views/modal.html',
        'SchoolPeriodCreateController',
        'vm', false, {
          school_period_serie: vm.school_period_serie,
          school_period: {}
        }
      );
    };

    vm.editSchoolPeriod = function (school_period) {
      var edit_school_period = angular.copy(school_period);
      edit_school_period.initial_date = school_period.initial_date.replace('/', '-').replace('/', '-').split("-").reverse().join("-");
      edit_school_period.final_date = school_period.final_date.replace('/', '-').replace('/', '-').split("-").reverse().join("-");
      ModalFactory.customClean(
        'app/educational/school-period/views/modal.html',
        'SchoolPeriodCreateController',
        'vm', false, {
          school_period_serie: vm.school_period_serie,
          school_period: edit_school_period
        }
      );
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Resgata todos os períodos, com paginação de limite 50 por pagina
     * @param page - (Opcional) Pagina de destino
     * @param limit - limite de registros
     */
    vm.getAllSchoolPeriod = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = SchoolPeriodService.getAll({limit: limit, page: page, period_type: vm.school_period_serie})
        .then(function (response) {
          vm.grid.rows = vm.formatGrid(response.data);
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todas',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        });
    };

    vm.clickActions = function (item, option) {
      switch (option) {
        case 'change-default':
          vm.changeDefaultSchoolPeriod(item);
          break;
        case 'change-default-enrolment':
          vm.changeDefaultSchoolPeriodEnrolment(item);
          break;
        case 'delete_period':
          vm.deleteSchoolPeriod(item);
          break;
      }
    };

    vm.deleteSchoolPeriod = function (school_period) {
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Tem certeza que deseja excluir o período letivo ' + school_period.id + '?',
        'Confirmar',
        'Cancelar',
        'educational'
      ).then(function () {
        $rootScope.show_loader = true;
        SchoolPeriodService.deletePeriod(school_period.id).then(function () {
          Common.Toast.success('Período letivo excluído com sucesso!');
          vm.getAllSchoolPeriod();
        }).catch(function (error) {
          Common.Toast.error(error.data.message);
          $rootScope.show_loader = false;
        })
      })
    };

    /**
     * Altera período letivo padrão da empresa selecionada
     * @param item
     */
    vm.changeDefaultSchoolPeriod = function (item) {
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Tem certeza que deseja definir o período letivo de ' + item.id + ' como o período letivo padrão?',
        'Confirmar',
        'Cancelar',
        'educational'
      ).then(function () {
        $rootScope.show_loader = true;
        SchoolPeriodService.changeDefaultSchoolPeriod({
          school_period_serie_id: item.school_period_serie_id,
          school_period_id: item.id, company: item.company_id
        }).then(function (response) {
          Common.Toast.success('Período letivo padrão definido com sucesso');
          vm.getAllSchoolPeriod();
        })
      })
    };

    /**
     * Altera período letivo padrão da empresa selecionada
     * @param item
     */
    vm.changeDefaultSchoolPeriodEnrolment = function (item) {
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Tem certeza que deseja definir o período letivo de ' + item.id + ' como o período letivo padrão para matrículas?',
        'Confirmar',
        'Cancelar',
        'educational'
      ).then(function () {
        $rootScope.show_loader = true;
        SchoolPeriodService.changeDefaultSchoolPeriodEnrolment({
          school_period_serie_id: item.school_period_serie_id,
          school_period_id: item.id, company: item.company_id
        }).then(function (response) {
          Common.Toast.success('Período letivo padrão para matrícula definido com sucesso');
          vm.getAllSchoolPeriod();
        })
      })
    };

    /**
     * Pega todos os períodos letivos disponíveis
     */
    vm.getSchoolsPeriodSeries = function () {
      $rootScope.show_loader = true;
      SchoolPeriodConfigService.getSchoolsPeriodSeries()
        .then(function (response) {
          vm.school_period_series = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Realiza a formatação necessária para a exibição do grid
     * @param array
     * @returns {*}
     */
    vm.formatGrid = function (array) {
      angular.forEach(array, function (item) {
        /** Formata as datas iniciais e finais*/
        item.initial_date = $filter('date')(item.initial_date, "dd/MM/yyyy");
        item.final_date = $filter('date')(item.final_date, "dd/MM/yyyy");
      });

      return array;
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.school-period')
    .controller('SchoolPeriodController', SchoolPeriodController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function SchoolPeriodCreateController($rootScope, a4Moment, ModalExtra, Common, SchoolPeriodService, moment) {

    var vm = this;

    vm.form = {
      mode_edit: true,
      school_period: {}

    };

    vm.init = function () {
      vm.form.school_period = angular.copy(ModalExtra.school_period);
      vm.school_period_serie = ModalExtra.school_period_serie;
      vm.form.school_period.school_period_serie_id = vm.school_period_serie;
      if (vm.form.school_period.id === null) {
        vm.getLastPeriodBySequence();
      } else {
        /*        vm.form.school_period.initial_date = a4Moment(vm.form.school_period.initial_date.replace('/', '-').replace('/', '-')).format('YYYY-MM-DD');
                vm.form.school_period.final_date = a4Moment(vm.form.school_period.final_date.replace('/', '-').replace('/', '-')).format('YYYY-MM-DD');*/
      }
    };

    vm.getLastPeriodBySequence = function () {
      SchoolPeriodService.getLastPeriodBySerie({school_period_serie: vm.school_period_serie})
        .then(function (response) {
          vm.last_school_period = response.plain();
          vm.form.school_period.name = vm.configureSchoolPeriodName(vm.last_school_period.name);
          vm.setDates(vm.last_school_period);
        });
      // ModalFactory.customClean(
      //   'app/educational/school-period/views/modal.html',
      //   'SchoolPeriodCreateController',
      //   'vm', false, {}
      // );
    };

    vm.setDates = function (school_period) {
      var dates = SchoolPeriodService.getDatesForSchoolPeriod(school_period);
      vm.form.school_period.initial_date = dates.initial_date;
      vm.form.school_period.final_date = dates.final_date;
    };

    vm.configureSchoolPeriodName = function (id) {
      var name = '';
      var string_id = id.toString();
      if (string_id.length > 4) {
        name = string_id.substr(0, 4) + '/' + string_id.substr(-1);
      } else {
        name = string_id;
      }
      return name;
    };

    vm.submit = function (item, form) {
      if (form.$valid) {
        if (angular.isUndefined(item.id)) {
          SchoolPeriodService.savePeriod(item)
            .then(function () {
              $rootScope.$broadcast('school.period.list.update');
              Common.Toast.success('Período criado com sucesso!');
              vm.close();
            })
            .catch(function () {
              Common.Toast.error('Erro ao criar período!');
            })
        } else {
          item.school_period = angular.copy(vm.form.school_period);
          SchoolPeriodService.updatePeriod(item)
            .then(function () {
              $rootScope.$broadcast('school.period.list.update');
              Common.Toast.success('Período atualizado com sucesso!');
              vm.close();
            }).catch(function (error) {
            Common.Toast.error(error.data.message);
          });
        }
      }
    };

    /**
     * Fecha o modal de criação
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular
    .module('app.educational.school-period')
    .controller('SchoolPeriodCreateController', SchoolPeriodCreateController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function RoundingCriteriaService(Restangular) {

    var all = function (obj) {
      return Restangular.one('graderoundrule').get(obj);
    };

    var create = function (obj) {
      return Restangular.all('graderoundrule').post(obj);
    };

    var get = function (id) {
      return Restangular.one('graderoundrule', id).get();
    };

    var update = function (id, obj) {
      return Restangular.one('graderoundrule', id).customPUT(obj);
    };

    var destroy = function (id) {
      return Restangular.one('graderoundrule', id).remove();
    };

    return {
      all: all,
      get: get,
      create: create,
      update: update,
      destroy: destroy
    };

  }

  angular
    .module('app.educational.rounding-criteria')
    .factory('RoundingCriteriaService', RoundingCriteriaService);

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.rounding-criteria', {
        public: false,
        url: '/rounding/criteria',
        templateUrl: 'app/educational/rounding-criteria/views/rounding-criteria.html',
        abstract: true
      })
      .state('private.educational.rounding-criteria.list', {
        url: '/list',
        public: false,
        views: {
          'rounding-criteria': {
            templateUrl: 'app/educational/rounding-criteria/views/list.html',
            controller: 'RoundingCriteriaController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.rounding-criteria.edit', {
        url: '/:id/view',
        public: false,
        views: {
          'rounding-criteria': {
            templateUrl: 'app/educational/rounding-criteria/views/rounding-criteria-page.html',
            controller: 'RoundingCriteriaCreateController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.rounding-criteria.create', {
        url: '/create',
        public: false,
        views: {
          'rounding-criteria': {
            templateUrl: 'app/educational/rounding-criteria/views/rounding-criteria-page.html',
            controller: 'RoundingCriteriaEditController',
            controllerAs: 'vm'
          }
        }
      });

  }

  angular
    .module('app.educational.rounding-criteria')
    .config(routerConfig);

})();



(function () {
  'use strict';

  /** @ngInject */
  function RoundingCriteriaEditController($rootScope, $scope, Common, ModalExtra, RoundingCriteriaService) {

    var vm = this;
    vm.form = {
      grade_round_rule: {name: ''},
      grade_round_rule_item: {
        items: [{up_to: 0, rounding: 0}]
      },
      mode_edit: true
    };


    /** Adição de regra de arredondamento */
    var ltn1 = $rootScope.$on('add_item', function () {
      vm.form.grade_round_rule_item.items.push({up_to: 0, rounding: 0});
    });

    /** Remoção de regra de arredondamento */
    var ltn2 = $rootScope.$on('remove_item', function (ev, item) {
      vm.form.grade_round_rule_item.items.splice(item, 1);
    });

    vm.init = function () {
      if (angular.isDefined(ModalExtra.id)) {
        vm.getById(ModalExtra.id);
      }
    };

    /** Retorna apenas um critério de arredondamento */
    vm.getById = function (id) {
      RoundingCriteriaService.get(id)
        .then(function (item) {
          vm.form.grade_round_rule = item.grade_round_rule;
          vm.form.grade_round_rule_item.items = item.grade_round_rule_item;
        })
    };

    /**
     * Submissão de dados para atualização de um critério de arredondamento
     * @param item
     * @param form
     */
    vm.submitRoundingCriteria = function (item, form) {
      if (form.$valid) {
        if (item.items.length > 0) {

          var grade_round_rule = {};
          /** Seta os items para os objetos em questão */
          grade_round_rule.grade_round_rule_item = item.items;
          grade_round_rule.grade_round_rule = {
            id: item.id,
            name: item.name
          };
          /** Executa o chamado para api, para atualizar o registro */
          RoundingCriteriaService.update(
            grade_round_rule.grade_round_rule.id,
            grade_round_rule
          )
            .then(function () {
              Common.Toast.success("Critério atualizado com sucesso");
              $rootScope.$broadcast("update.rounding-criteria.list");
              vm.close();
            })
            .catch(function () {
              Common.Toast.error("Não foi possivel atualizar critério, por favor tente mais tarde.");
            });
        } else {
          Common.Toast.success("Obrigatório pelo menos um arredondamento");
        }

      }
    };

    /**
     * Fecha o modal de criação
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

    $scope.$on('$destroy', function () {
      [ltn1, ltn2].forEach(function (fn) {
        fn();
      })
    });
  }

  angular
    .module('app.educational.rounding-criteria')
    .controller('RoundingCriteriaEditController', RoundingCriteriaEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function RoundingCriteriaCreateController($rootScope, $scope, Common, RoundingCriteriaService) {

    var vm = this;
    vm.form = {
      grade_round_rule: {name: ''},
      grade_round_rule_item: {
        items: [{up_to: 0, rounding: 0}]
      },
      mode_edit: true
    };

    /** Adição de regra de arredondamento */
    var ltn1 = $rootScope.$on('add_item', function () {
      vm.form.grade_round_rule_item.items.push({up_to: 0, rounding: 0});
    });

    /** Remoção de regra de arredondamento */
    var ltn2 = $rootScope.$on('remove_item', function (ev, item) {
      vm.form.grade_round_rule_item.items.splice(item, 1);
    });

    /** inicia o controllador com funções necessárias */
    vm.init = function () {
    };

    /**
     * Fecha o modal de criação
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /**
     * Submissão de dados para criação de um novo critério de arredondamento
     * @param item
     * @param form
     */
    vm.submitRoundingCriteria = function (item, form) {
      if (form.$valid) {
        if (item.items.length > 0) {

          var grade_round_rule = {};
          /** Seta os items para os objetos em questão */
          grade_round_rule.grade_round_rule_item = item.items;
          grade_round_rule.grade_round_rule = {
            name: item.name
          };

          RoundingCriteriaService.create(grade_round_rule)
            .then(function () {
              Common.Toast.success("Critério criado com sucesso");
              $rootScope.$broadcast("update.rounding-criteria.list");
              vm.close();
            })
            .catch(function () {
              Common.Toast.error("Não foi possivel criar um novo critério, por favor tente mais tarde.");
            });
        } else {
          Common.Toast.success("Obrigatório pelo menos um arredondamento");
        }

      }
    };


    vm.init();

    $scope.$on('$destroy', function () {
      [ltn1, ltn2].forEach(function (fn) {
        fn();
      })
    });
  }

  angular
    .module('app.educational.rounding-criteria')
    .controller('RoundingCriteriaCreateController', RoundingCriteriaCreateController)
})
();
(function () {
  'use strict';

  /** @ngInject */
  function RoundingCriteriaController($rootScope, $scope, $a4FloatButton, RoundingCriteriaService, ModalFactory, Common) {

    var vm = this;
    vm.grid = {rows: [], info: {}};
    vm.form = {};

    var ltn1 = $rootScope.$on('update.rounding-criteria.list', function () {
      vm.paginate();
    });

    vm.init = function () {
      vm.paginate();
      vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createRoundingCriteria()'});
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterEvaluationCriteriaList = function (query) {
      RoundingCriteriaService.all({query: query})
        .then(function (response) {
          vm.grid.rows = response;
        })
    };

    /**
     * Abre modal para a criação de critérios de arredondamento
     */
    vm.createRoundingCriteria = function () {
      ModalFactory.customClean(
        'app/educational/rounding-criteria/views/dialog-rounding-criteria.html',
        'RoundingCriteriaCreateController',
        'vm', false, null
      );
    };

    /**
     * Edição do critério
     * @param item - item a ser editado
     */
    vm.editRoundingCriteria = function (item) {
      ModalFactory.customClean(
        'app/educational/rounding-criteria/views/dialog-rounding-criteria.html',
        'RoundingCriteriaEditController',
        'vm', false, item
      );
    };

    /**
     * Paginação dos critérios existentes
     */
    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = RoundingCriteriaService.all({limit: limit, page: page})
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
        });
      $rootScope.show_loader = false;
    };

    /**
     * Executa a deleção de um critério de arredondamento
     * @param index - Identificador do critério
     */
    vm.delete = function (index) {
      ModalFactory.confirm(null,
        'Exclusão de critério',
        'Deseja realmente excluir este critério de arredondamento?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          RoundingCriteriaService.destroy(index)
            .then(function () {
              Common.Toast.success('Critério excluído com sucesso!');
              vm.paginate();
            }).catch(function (response) {
            if (response.data.message === 'CRITERIA_ASSOCIATED_TO_GRADE_RULE') {
              Common.Toast.warning('Não é possível excluir, arredondamento associado a um critério de avaliação.');
            } else {
              Common.Toast.error('Erro ao excluir o critério.');
            }
          })
        })

    };

    $scope.$on('$destroy', function () {
      [ltn1].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.rounding-criteria')
    .controller('RoundingCriteriaController', RoundingCriteriaController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ResponsiblesService(Restangular) {

    /**
     * Retorna todos os colaboradores
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('responsibles').get(obj);
    };

    /**
     * Retorna todos os estudantes do colaborador
     * @param obj
     * @returns {*}
     */
    var getStudentsForResponsible = function (obj) {
      return Restangular.one('responsibles').one('getstudentsforresponsible').get(obj);
    };

    /**
     * Retorna todos os colaboradores
     * @returns array
     */
    var getPersonInfo = function () {
      return Restangular.one('responsibles').one('getinfo').get();
    };

    /**
     * Retorna todos os colaboradores
     * @returns array
     */
    var getInfos = function () {
      return Restangular.one('responsibles').one('getinfos').get();
    };

    /**
     * Retorna o colaborador pelo id
     * @returns array
     */
    var getById = function (id, obj) {
      return Restangular.one('responsibles', id).get(obj || {});
    };


    /**
     * Cria um novo colaborador
     */
    var createResponsible = function (obj) {
      return Restangular.all('responsibles').post(obj);
    };

    /**
     * Atualiza um colaborador
     */
    var updateResponsible = function (obj) {
      return Restangular.one('responsibles', obj.id).customPUT(obj);
    };

    /**
     * Remove um colaborador
     */
    var deleteResponsible = function (id) {
      return Restangular.one('responsibles', id).remove();
    };

    /**
     * Retorna os estudantes para realizar re-matrícula online
     * @param obj
     */
    var getStudentsForReEnrolment = function (obj) {
      return Restangular.one('students').one('getstudentsforreenrolment').get(obj);
    };

    var saveResponsibleCPF = function (obj) {
      return Restangular.one('responsibles').all('saveresponsiblecpf').post(obj);
    };

    var saveEditLog = function (obj) {
      return Restangular.one('responsibles').one('saveeditlog').get(obj);
    }

    var getProfessionsByQuery = function (obj) {
      return Restangular.one('responsibles').one('getprofessionsbyquery').get(obj);
    };

    /**
     * Atualiza o status de uma alteração de responsável
     * @param obj
     * @returns {*}
     */
    var updateResponsibleStatus = function (obj) {
      return Restangular.one('responsibles').all('updateresponsiblestatus').post(obj);
    };

    return {
      getAll: getAll,
      createResponsible: createResponsible,
      getById: getById,
      updateResponsible: updateResponsible,
      deleteResponsible: deleteResponsible,
      getPersonInfo: getPersonInfo,
      getStudentsForResponsible: getStudentsForResponsible,
      getInfos: getInfos,
      getStudentsForReEnrolment: getStudentsForReEnrolment,
      saveResponsibleCPF: saveResponsibleCPF,
      getProfessionsByQuery: getProfessionsByQuery,
      saveEditLog: saveEditLog,
      updateResponsibleStatus: updateResponsibleStatus
    };

  }

  angular
    .module('app.educational.responsibles')
    .factory('ResponsiblesService', ResponsiblesService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.responsibles', {
        public: false,
        url: '/responsibles',
        templateUrl: 'app/educational/responsibles/views/responsibles.html',
        abstract: true
      })
      .state('private.educational.responsibles.list', {
        url: '/list',
        public: false,
        views: {
          'responsibles': {
            templateUrl: 'app/educational/responsibles/views/list.html',
            controller: 'ResponsiblesController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.responsibles.edit', {
        url: '/:id/view/:change_school_period/:is_payee',
        params: {
          change_school_period: null,
          is_payee: null
        },
        public: false,
        views: {
          'responsibles': {
            templateUrl: 'app/educational/responsibles/views/responsibles-page.html',
            controller: 'ResponsiblesEditController',
            controllerAs: 'vm'
          },
          'dependents@private.educational.responsibles.edit': {
            templateUrl: 'app/educational/responsibles/dependents/views/dependents.html',
            controller: 'ResponsiblesDependentsController',
            controllerAs: 'vm'
          },
          'financial@private.educational.responsibles.edit': {
            templateUrl: 'app/educational/responsibles/financial-situation/views/financial-situation.html',
            controller: 'FinancialSituationController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.responsibles.create', {
        url: '/create',
        public: false,
        views: {
          'responsibles': {
            templateUrl: 'app/educational/responsibles/views/responsibles-page.html',
            controller: 'ResponsiblesCreateController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.responsibles')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService, CONFIG, Session, $rootScope) {
    var role = 'resp_menu';
    var path = 'secretary.responsibles';

    $rootScope.$on(CONFIG.events.side_menu.update, function () {

      if (PoliciesService.checkPolicyFromMenu(role) && PoliciesService.isParent()
        && CONFIG.profile.parent === Session.getCurrentProfile()) {

        var user = Session.getUser();

        msNavigationService.saveItem("educational.responsibles", {
          title: 'Meu perfil',
          icon: 'icon-account',
          auth: role,
          state: 'private.educational.responsibles.edit',
          stateParams: {'id': user.person.id},
          weight: 3,
          hidden: function () {
            return !PoliciesService.checkPolicyAndProfile(role, "educational.responsibles");
          }
        });

      } else if (PoliciesService.checkPolicyFromMenu(role) && !PoliciesService.isParent()) {

        msNavigationService.saveItem(path, {
          title: 'Pais, Responsáveis e Fiadores',
          icon: 'icon-account',
          auth: role,
          state: 'private.educational.responsibles.list',
          weight: 3,
          hidden: function () {
            return !PoliciesService.checkPolicyAndProfile(role, path);
          }
        });

      }

    });

    $rootScope.$broadcast(CONFIG.events.side_menu.update);
  }

  angular
    .module('app.educational.responsibles')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function ResponsiblesEditController(CONFIG, Session, $stateParams, $scope, $state, $timeout, $a4FloatButton,
                                      CollaboratorsService, Common, LocalStorage, ResponsiblesService,
                                      $rootScope, Utils, PersonService, PoliciesService, $window, $q, ModalFactory) {

    var vm = this;
    var LocalStorageKEY = 'responsibles_current_tab';
    vm.search_text = '';
    vm.show_tabs = false;
    vm.person_id = $stateParams.id;
    vm.is_payee = $stateParams.is_payee;
    vm.params = $stateParams;
    vm.selected_tab = LocalStorage.get(LocalStorageKEY);
    vm.current_school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.searchText_place_of_birth = '';
    vm.searchText_state_of_birth = '';
    vm.waiting_city_place_of_birth = false;
    vm.searchText_address_state = '';
    vm.searchText_address_city = '';
    vm.blockFormEmail = false;
    vm.waiting_city_address_city = false;
    vm.form = {
      mode_edit: false,
      person: {},
      person_parent: {}
    };
    vm.CONFIG = CONFIG;

    vm.list = {
      person: {},
      person_parent: {}
    };

    vm.has_app_finance = LocalStorage.get('has_app_finance');

    /**
     * Escuta da tab corrente, a cada troca de tab em colaboradores, esta escuta salva a corrente no localstorage;
     * @type {*}
     */
    var ltn = $scope.$watch(function () {
        return vm.selected_tab;
      },
      function (newer, older) {
        if (parseInt(newer) !== parseInt(older))
          LocalStorage.add(LocalStorageKEY, newer);
      });

    /**
     * Esculta a troca do campo de Estado no formulário de criação de colaborador
     * @type {*}
     */
    var ltn1 = $rootScope.$on('person_address_state_change', function (ev, address_state_id) {
      vm.form.person.address_city = null;
      vm.changeAddressState(address_state_id);
    });

    /**
     * Esculta a troca do campo de Estado no formulário de criação de colaborador
     * @type {*}
     */
    var ltn2 = $rootScope.$on('person_address_state_birth_change', function (ev, address_state_id) {
      vm.form.person.place_of_birth = null;
      vm.changeStateBirth(address_state_id);
    });

    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    var ltn3 = $rootScope.$on('address_postal_code.blur', function (ev, CEP) {
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          vm.form.person.address_state = address.uf;
          // vm.form.person.address_city = address.localidade;
          vm.form.person.address_street = address.logradouro;
          vm.form.person.address_district = address.bairro;
          vm.changeAddressState(vm.form.person.address_state, address.localidade);
          $rootScope.show_loader = false;
        })
    });

    var ltn4 = $rootScope.$on('countryNationalityChanged', function(event, newVal) {
      vm.last_known_nationality = newVal;
    });

    vm.init = function () {
      /**
       * Emite evento de mudança do período letivo, caso necessário
       */
      if (angular.isDefined($stateParams.change_school_period) && $stateParams.change_school_period !== null
        && parseInt(vm.current_school_period) !== parseInt($stateParams.change_school_period.replace(/\D/g,''))){
        $scope.$emit('change-school-period',
          $stateParams.change_school_period
        );
      }
      vm.getFormInfos();
      if ($state.params.hasOwnProperty('id')) {
        vm.getById($state.params.id);
      }
    };

    /**
     * Habilita e desabilita a edição do colaborador
     */
    vm.ableEdit = function () {
      vm.form.mode_edit = !vm.form.mode_edit;
      if (!vm.form.mode_edit) {
        /*vm.getById($state.params.id);*/
      }
    };

    vm.reload = function(){
    };

    vm.changeProfession = function (item) {
      vm.form.person.person_profession_id = item === null ? null : item.id;
    };
    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      $rootScope.show_loader = true;
      ResponsiblesService.getPersonInfo()
        .then(function (response) {
          vm.list.person = response.person;
          vm.list.person.type = [{'id': 1, 'name': 'Pessoa Física'},
            {'id': 2, 'name': 'Pessoa Jurídica'}];
          vm.list.person.id_issuer = CollaboratorsService.getListIdIssuer();
          $rootScope.show_loader = false;
          $timeout(function () {
            if (vm.form.person.person_profession_id !== null) {
              for (var i = vm.list.person.person_profession_id.length; i--;) {
                if (vm.list.person.person_profession_id[i].id === vm.form.person.person_profession_id) {
                  vm.selected_profession = vm.list.person.person_profession_id[i];
                }
              }
            }
            $rootScope.show_loader = false;
          }, 2000);
          //vm.list.person_employee = response.person_employee;
        })
    };

    vm.getAddressByCep = function (cep) {
      $rootScope.show_loader = true;
      PersonService.getAddressByCep(cep)
        .then(function (address) {
          vm.form.person.address_state = address.uf;
          vm.searchText_address_state = address.uf;
          vm.form.person.address_city = address.localidade;
          vm.searchText_address_city = address.localidade;
          vm.form.person.address_street = address.logradouro;
          vm.form.person.address_district = address.bairro;
          // vm.changeAddressState(vm.form.person.address_state, address.localidade);
          $rootScope.show_loader = false;
        })
    };
    /**
     * Realiza a escuta do campo de auto-complete
     * @param item - novo item selecionado
     */
    vm.changeResponsible = function (item) {
      if (angular.isDefined(item)) {
        $state.go('private.educational.responsibles.edit', {id: item.person_id_related}, {reload: true});
      }
    };

    /**
     * Realiza a escuta do campo de auto-complete de Estado do endereço
     * @param address_state_id - novo item selecionado
     */
    vm.changeAddressState = function (address_state_id) {
      vm.waiting_city_address_city = true;

      if (angular.isDefined(address_state_id) && angular.isDefined(address_state_id.id)) {
        vm.form.person.address_state = address_state_id.id;
      } else if (vm.searchText_address_state !== null && vm.searchText_address_state !== '' && vm.searchText_address_state.length === 2) {
        vm.form.person.address_state = vm.searchText_address_state;
      }
      var state = vm.form.person.address_state;
      PersonService.getCities(state)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
          vm.waiting_city_address_city = false;
          var city = $window.document.getElementById('autocomplete_address_city');
          if (city !== null && angular.isDefined(city)) {
            city.focus();
          }
        })
        .catch(function () {
          vm.waiting_city_address_city = false;
        });
    };

    vm.getProfessions = function (query) {
      return ResponsiblesService.getProfessionsByQuery({query: query});
    };
    /**
     * Realiza a escuta do campo de auto-complete de Estado de emissão do RG
     * @param address_state_id - novo item selecionado
     * @param address_state_id
     */
    vm.changeStateBirth = function (address_state_id) {
      vm.waiting_city_of_birth = true;

      if (angular.isDefined(address_state_id) && angular.isDefined(address_state_id.id)) {
        vm.form.person.state_of_birth = address_state_id.id;
      } else if (vm.searchText_state_of_birth !== null && vm.searchText_state_of_birth !== '' && vm.searchText_state_of_birth.length === 2) {
        vm.form.person.state_of_birth = vm.searchText_state_of_birth;
      }
      var state = vm.form.person.state_of_birth;
      PersonService.getCities(state)
        .then(function (response) {
          vm.list.person.place_of_birth = response.plain();
          vm.waiting_city_of_birth = false;
          var city = $window.document.getElementById('autocomplete_place_of_birth');
          if (city !== null && angular.isDefined(city)) {
            city.focus();
          }
        })
        .catch(function () {
          vm.waiting_city_of_birth = false;
        })
    };

    /**
     * Busca de estado de nascimento e do endereço
     * @param filterText
     * @returns {*}
     */
    vm.getStateBirth = function (filterText) {
      var d = $q.defer();

      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        filteredItems = vm.list.person.address_state.filter(function (item) {
          return (item.id.toLowerCase()).indexOf(searchStrLower) > -1;
        });
      } else {
        filteredItems = vm.list.person.address_state;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Busca de cidade de nascimento
     * @param filterText
     * @returns {*}
     */
    vm.getPlaceBirth = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        if (angular.isDefined(vm.list.person.place_of_birth)) {
          filteredItems = vm.list.person.place_of_birth.filter(function (item) {
            return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
          });
        }
      } else {
        filteredItems = vm.list.person.place_of_birth;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Define a cidade de nascimento
     * @param item
     */
    vm.setPlaceBirth = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.name)) {
        vm.form.person.place_of_birth = item.name;
      }
    };
    /**
     * Busca de cidade do endereço
     * @param filterText
     * @returns {*}
     */
    vm.getAddressCity = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        if (angular.isDefined(vm.list.person.address_city)) {
          filteredItems = vm.list.person.address_city.filter(function (item) {
            return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
          });
        }
      } else {
        filteredItems = vm.list.person.address_city;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Define a cidade do endereço
     * @param item
     */
    vm.setAddressCity = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.name)) {
        vm.form.person.address_city = item.name;
      }
    };
    /**
     * Resgata o objeto referente ao colaborador
     * @param responsible_id - identificador do colaborador
     */
    vm.getById = function (responsible_id) {
      $rootScope.show_loader = true;
      ResponsiblesService.getById(responsible_id)
        .then(function (response) {
          vm.form.person = Utils.mergeObjects(angular.copy(response.person), angular.copy(response.person_parent));
          vm.form.person_parent = response.person_parent;
          // vm.changeAddressState(vm.form.person.address_state, vm.form.person.address_city);
          // vm.changeStateBirth(vm.form.person.state_of_birth, vm.form.person.place_of_birth);
          vm.person_copy = vm.form.person;
          vm.person_copy.is_payee = vm.is_payee;
          vm.contact_copy = vm.form.person;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Não foi possivel recuperar os dados do colaborador.');
        });
    };

    vm.submit = function (form, item) {
      if (!form.$invalid) {
        vm.form.mode_edit = false;
        $rootScope.show_loader = true;
        /** Realiza a copia dos dados */
        var new_item = angular.copy(item);
        /** Realiza o tratamento das datas */
        if (vm.form.person.selected_profession !== null) {
          new_item.new_profession_name = vm.form.person.selected_profession;
        }
        if ((angular.isUndefined(vm.form.person.state_of_birth) || vm.form.person.state_of_birth === null) && vm.searchText_state_of_birth !== '') {
          new_item.state_of_birth = vm.searchText_state_of_birth;
        }
        if ((angular.isUndefined(vm.form.person.place_of_birth) || vm.form.person.place_of_birth === null) && vm.searchText_place_of_birth !== '') {
          new_item.place_of_birth = vm.searchText_place_of_birth;
        }
        if ((angular.isUndefined(vm.form.person.address_state) || vm.form.person.address_state === null) && vm.searchText_address_state !== '') {
          new_item.address_state = vm.searchText_address_state;
        }
        if ((angular.isUndefined(vm.form.person.address_city) || vm.form.person.address_city === null) && vm.searchText_address_city !== '') {
          new_item.address_city = vm.searchText_address_city;
        }
        if ((new_item.country_id_nationality !== null && new_item.country_id_nationality !== vm.last_known_nationality) || new_item.country_id_nationality == null) {
          new_item.country_id_nationality = vm.last_known_nationality;
        }

        ResponsiblesService.updateResponsible(new_item)
          .then(function () {
            Common.Toast.success('Responsável editado com sucesso');
            vm.form.mode_edit = false;
            $rootScope.show_loader = false;
            /*vm.getById($state.params.id);*/
          })
          .catch(function (error) {
            if (error.data.message !== null && error.data.messages !== 'EMAIL_EXISTS') {
              Common.Toast.error(error.data.message);
              $rootScope.show_loader = false;
            } else {
              Common.Toast.error('Erro ao editar responsável');
              $rootScope.show_loader = false;
            }
            if (error.data.messages === 'EMAIL_EXISTS') {
              ModalFactory.open("email-exists", null, "PersonController", {
                persons: error.data.persons,
                selected: new_item.name,
                show_button: true
              }, null, 'educational', null, null, null, null, false)
                .catch(function () {
                  $rootScope.show_loader = false;
                })
            }
            // if(error.data.message =='PERSON_COUNTRY_ID_NATIONALITY_IS_NULL'){
            //  Common.Toast.warning("Por favor, preencha o campo de nacionalidade para continuar");
            // }
          })
      } else {
        Common.Toast.error('Informação inválida no formulário');
      }
    };

    /** Formata corretamente para o banco as datas que usam mascaras */
    vm.formatCorretDate = function (date) {
      if (date != null && angular.isDefined(date)) {
        return date.split("/").reverse().join("-");
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Realiza a verificação do perfil selecionado
     * @param profile
     * @returns {boolean}
     */
    vm.checkProfile = function (profile) {
      return PoliciesService.currentProfile() === profile;
    };

    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn, ltn1, ltn2, ltn3, ltn4].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.responsibles')
    .controller('ResponsiblesEditController', ResponsiblesEditController);
})();

(function () {
  'use strict';

  function ResponsiblesCreateController($scope, $window, $state, CollaboratorsService, Common, LocalStorage, ResponsiblesService,
                                        $rootScope, PersonService, PoliciesService, $q, $timeout) {

    var vm = this;
    var LocalStorageKEY = 'responsibles_current_tab';
    vm.search_text = '';
    vm.show_tabs = false;
    vm.blockFormEmail = false;
    vm.selected_tab = LocalStorage.get(LocalStorageKEY);
    vm.form = {
      mode_edit: true,
      person: {
        type: 1,
        is_deceased:false
      }
    };

    vm.list = {
      person: {},
      person_parent: {}
    };

    vm.init = function () {
      if ($state.params.hasOwnProperty('id')) {
        vm.getById($state.params.id);
      }
    };

    //Ouve se o campo de "Pessoa falecida" foi marcada
    $scope.$on('isDecease', function (event, isDecease) {
      vm.form.person.is_deceased = isDecease;
    })

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     */
    vm.changeAddressState = function (address_state_id, city) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
          angular.forEach(vm.list.person.address_city, function (address_city) {
            if (address_city.name === city) {
              vm.form.person.address_city = address_city.id;
            }
          })
        })
    };
    /**
     * Busca de estado de nascimento e do endereço
     * @param filterText
     * @returns {*}
     */
    vm.getStateBirth = function (filterText) {
      var d = $q.defer();

      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        filteredItems = vm.list.person.address_state.filter(function (item) {
          return (item.id.toLowerCase()).indexOf(searchStrLower) > -1;
        });
      } else {
        filteredItems = vm.list.person.address_state;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };


    /**
     * Realiza a escuta do campo de auto-complete de Estado do endereço
     * @param address_state_id - novo item selecionado
     * @param city
     */
    vm.changeAddressState = function (address_state_id, city) {
      vm.waiting_city_address_city = true;

      if (angular.isDefined(address_state_id) && angular.isDefined(address_state_id.id)) {
        vm.form.person.address_state = address_state_id.id;
      } else if (vm.searchText_address_state !== null && vm.searchText_address_state !== '' && vm.searchText_address_state.length === 2) {
        vm.form.person.address_state = vm.searchText_address_state;
      }
      var state = vm.form.person.address_state;
      PersonService.getCities(state)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
          vm.waiting_city_address_city = false;
          var city = $window.document.getElementById('autocomplete_address_city');
          if (city !== null && angular.isDefined(city)) {
            city.focus();
          }
        })
        .catch(function () {
          vm.waiting_city_address_city = false;
        });
    };

    /**
     * Busca de cidade do endereço
     * @param filterText
     * @returns {*}
     */
    vm.getAddressCity = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        if (angular.isDefined(vm.list.person.address_city)) {
          filteredItems = vm.list.person.address_city.filter(function (item) {
            return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
          });
        }
      } else {
        filteredItems = vm.list.person.address_city;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };


    /**
     * Define a cidade do endereço
     * @param item
     */
    vm.setAddressCity = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.name)) {
        vm.form.person.address_city = item.name;
      }
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     */
    vm.changeBirthState = function (address_state_id) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.place_of_birth = response.plain();
        })
    };

    vm.changeStateBirth = function (address_state_id) {
      var city;
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.place_of_birth = response.plain();
          city = angular.isDefined(city) ? city : (angular.isDefined(vm.form.person.place_of_birth) ? vm.form.person.place_of_birth : '');
          if (angular.isDefined(city)) {
            vm.list.person.place_of_birth.forEach(function (item) {
              if (item.name.toLowerCase() === city.toLowerCase()) {
                vm.form.person.place_of_birth = item.id;
              }
            });
          }
          $rootScope.show_loader = false;
        })
    };
    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      ResponsiblesService.getPersonInfo()
        .then(function (response) {
          vm.list.person = response.person;
          vm.list.person.type = [{'id': 1, 'name': 'Pessoa Física'},
            {'id': 2, 'name': 'Pessoa Jurídica'}];
          vm.list.person.id_issuer = CollaboratorsService.getListIdIssuer();
          //vm.list.person_employee = response.person_employee;
        })
    };

    vm.submit = function (form, item) {
      if (!form.$invalid) {

        vm.form.mode_edit = false;
        ResponsiblesService.createResponsible(item)
          .then(function (response) {
            Common.Toast.success('Responsável criado com sucesso');
            $state.go('private.educational.responsibles.edit', {id: response.result.id});
          })
          .catch(function (response) {
            if (angular.isDefined(response.data.errors)) {
              var errors = response.data.errors;
              if (angular.isDefined(errors.name)) {
                errors.name.forEach(function (item) {
                  if (item === 'ALREADY_EXISTS_PERSON_WITH_THIS_NAME') {
                    Common.Toast.error('Já esxiste uma pessoa no sistema com este nome');
                  }
                });
              }
              if (angular.isDefined(errors.name)) {
                errors.address_city.forEach(function (item) {
                  if (item === 'ADDRESS_CITY_IS_REQUIRED') {
                    Common.Toast.error('Cidade do endereço é obrigatória');
                  }
                });
              }
              if (angular.isDefined(errors.name)) {
                errors.address_state.forEach(function (item) {
                  if (item === 'ADDRESS_STATE_IS_REQUIRED') {
                    Common.Toast.error('Estado do endereço é obrigatório');
                  }
                });
              }
              if (angular.isDefined(errors.name)) {
                errors.national_id_number.forEach(function (item) {
                  if (item === 'NATIONAL_ID_NUMBER_ALREADY_BEEN_USED') {
                    Common.Toast.error('CPF já utilizado por outra pessoa');
                  }
                });
              }
              // Common.Toast.error(response.data.errors.name[0] === 'ALREADY_EXISTS_PERSON_WITH_THIS_NAME' ? 'Já esxiste uma pessoa no sistema com este nome' : 'Erro ao criar responsável');
            } else if (error.data.message !== null) {
              Common.Toast.error(error.data.message);
            } else {
              Common.Toast.error('Erro ao criar responsável');
            }
          })
      }
    };

    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    var ltn3 = $rootScope.$on('address_postal_code.blur', function (ev, CEP) {
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          vm.form.person.address_state = address.uf;
          // vm.form.person.address_city = address.localidade;
          vm.form.person.address_street = address.logradouro;
          vm.form.person.address_district = address.bairro;
          vm.changeAddressState(vm.form.person.address_state, address.localidade);
        })
    });

    /**
     * Escuta da tab corrente, a cada troca de tab em colaboradores, esta escuta salva a corrente no localstorage;
     * @type {*}
     */
    var ltn = $scope.$watch(function () {
        return vm.selected_tab;
      },
      function (newer, older) {
        if (parseInt(newer) !== parseInt(older))
          LocalStorage.add(LocalStorageKEY, newer);
      });

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };


    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn, ltn1, ltn2, ltn3].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.responsibles')
    .controller('ResponsiblesCreateController', ResponsiblesCreateController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ResponsiblesController($rootScope, $scope, $state, $a4FloatButton,
                                  ResponsiblesService, ModalFactory, Common, PoliciesService, $window,
                                  PersonService) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.gridStudents = {
      rows: [],
      info: {}
    };

    vm.form = {};

    vm.person = {name: ''};
    vm.is_inactive = false;

    /**
     * Evento de inicialização da tela
     * @type {*}
     */
    var ltn = $rootScope.$on('a4-form-dic-data.grid.loaded', function () {
      vm.paginate();
    });

    var ltn2 = $rootScope.$on('a4-form-dic-data.gridStudents.loaded', function () {
      vm.getStudentsForResponsible();
    });

    vm.init = function () {
      if (!vm.checkPolicies('resp_alt')) {
        vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createResponsible()'});
      }
    };


    /**
     * Retorna todos os grupos de curso disponíveis
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     */
    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = ResponsiblesService.getAll({limit: limit, page: page, only_inactives: vm.is_inactive})
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
          $rootScope.show_loader = false;
        });
    };

    /**
     * Recupera todos os alunos relacionados ao responsável
     *
     */
    vm.getStudentsForResponsible = function (page, limit) {
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;
      vm.gridStudents.promise = ResponsiblesService.getStudentsForResponsible({limit: limit, page: page})
        .then(function (response) {
          vm.gridStudents.rows = response.data;
          vm.gridStudents.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        });

    };

    vm.clickActions = function (item, option) {
      switch (option) {
        case 'go-to-external-statement':
          vm.getExternalFinancialStatement(item);
          break;
      }
    };

    /**
     * Redireciona para ficha financeira externa
     * @param person
     */
    vm.getExternalFinancialStatement = function (person) {
      $rootScope.show_loader = true;
      PersonService.getExternalFinancialStatementLink({person_id: person.person_id_related})
        .then(function (link) {
          $rootScope.show_loader = false;
          var element = document.createElement('a');
          element.setAttribute('href', link);
          element.setAttribute('target', '_blank');
          return element.click();
        }).catch(function (error) {
        $rootScope.show_loader = false;
        Common.Toast.error(error.data.message);
      })
    };

    /**
     * Chamada do serviço de retorna todos os grupos de curso da API
     */
    vm.getAll = function () {
      ResponsiblesService.getAll()
        .then(function (response) {
          vm.grid.rows = response;
        });
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterResponsiblesList = function (query) {
      ResponsiblesService.getAll({query: query, only_inactives: vm.is_inactive})
        .then(function (response) {
          vm.grid.rows = response;
        })
    };


    /**
     * Edição de colaborador
     * @param item - item a ser editado
     */
    vm.editResponsible = function (item) {
      console.log(item)
      $state.go('private.educational.responsibles.edit', {id: item.person_id_related !== null ? item.person_id_related : item.responsible_id});
    };

    /**
     * Edição de colaborador
     * @param item - item a ser editado
     */
    vm.createResponsible = function () {
      $state.go('private.educational.responsibles.create');
    };

    vm.deleteResponsible = function (id) {
      ModalFactory.confirm(null,
        'Deseja remover este responsável?',
        'Esta operação não pode ser desfeita.',
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          ResponsiblesService.deleteResponsible(id)
            .then(function () {
              Common.Toast.success('Responsável removido com sucesso.');
              vm.paginate();
            })
            .catch(function (fail) {
              if (angular.isObject(fail.data)) {
                angular.forEach(fail.data, function (value) {
                  switch (value[0]) {
                    case 'PERSON_COMPANY_EXCLUSION_ERROR':
                      Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                      break;
                    case 'PERSON_PARENT_EXCLUSION_ERROR':
                      Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                      break;
                    case 'RESPONSIBLE_HAS_STUDENT_RELATION':
                      Common.Toast.warning('Existem estudantes vinculados a este responsável, remoção não permitida');
                      break;
                  }
                });
              }
            })
        })
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();

    $scope.$on('$destroy', function () {
      [ltn, ltn2].forEach(function (fn) {
        fn();
      })
    });
  }

  angular
    .module('app.educational.responsibles')
    .controller('ResponsiblesController', ResponsiblesController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ResponsiblesAssistantController($scope, $rootScope, $timeout, ModalFactory, ModalExtra, Common, PersonService, ResponsiblesService, CollaboratorsService) {
    var vm = this;

    vm.form = {
      mode_edit: true,
      person: {}
    };

    vm.list = {
      person: {},
      person_parent: {}
    };

    /**
     * Esculta a troca do campo de Estado no formulário de criação de colaborador
     * @type {*}
     */
    var ltn1 = $rootScope.$on('person_address_state_change', function (ev, address_state_id) {
      vm.form.person.address_city = null;
      vm.changeAddressState(address_state_id);
    });

    /**
     * Esculta a troca do campo de Estado no formulário de criação de colaborador
     * @type {*}
     */
    var ltn2 = $rootScope.$on('person_address_state_birth_change', function (ev, address_state_id) {
      vm.form.person.place_of_birth = null;
      vm.changeBirthState(address_state_id);
    });

    vm.init = function () {
      vm.getFormInfos();
      vm.form.person.name = ModalExtra.name;
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     */
    vm.changeAddressState = function (address_state_id, city) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
          angular.forEach(vm.list.person.address_city, function (address_city) {
            if (address_city.name === city) {
              vm.form.person.address_city = address_city.id;
            }
          })
        })
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     */
    vm.changeBirthState = function (address_state_id) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.place_of_birth = response.plain();
        })
    };

    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      $rootScope.show_loader = true;
      ResponsiblesService.getPersonInfo()
        .then(function (response) {
          vm.list.person = response.person;
          vm.list.person.type = [{'id': 1, 'name': 'Pessoa Física'},
            {'id': 2, 'name': 'Pessoa Jurídica'}];
          vm.list.person.id_issuer = CollaboratorsService.getListIdIssuer();
          $rootScope.show_loader = false;
          //vm.list.person_employee = response.person_employee;
        })
    };


    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    var ltn3 = $rootScope.$on('address_postal_code.blur', function (ev, CEP) {
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          vm.form.person.address_state = address.uf;
          // vm.form.person.address_city = address.localidade;
          vm.form.person.address_street = address.logradouro;
          vm.form.person.address_district = address.bairro;
          vm.changeAddressState(vm.form.person.address_state, address.localidade);
        })
    });

    /**
     * Executa o fechamento do Modal
     * ele deve restaurar o assistente com os dados já imputados
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
      // ModalFactory.customClean(
      //   'app/educational/enrolment/views/enrolment-wizard.html',
      //   'EnrolmentAssistantController',
      //   'vm', false, data
      // );

    };

    /**
     * Recebe as submissões de todas as etapas do assitente
     */
    vm.submit = function () {
    };

    vm.finish = function (form) {
      var item = form.person;
      $rootScope.show_loader = true;
      ResponsiblesService.createResponsible(item)
        .then(function () {
          var data = ModalExtra.enrolment_data;

          /** Adiciona no objeto o novo responsável */
          $rootScope.$broadcast('ModalFactory.close');
          Common.Toast.success('Responsável criado com sucesso, continue a matricula do aluno');

        })
        .catch(function (response) {
          if(angular.isDefined(response.data.errors.name)){
            Common.Toast.error(response.data.errors.name[0] === 'ALREADY_EXISTS_PERSON_WITH_THIS_NAME' ? 'Já esxiste uma pessoa no sistema com este nome' : 'Erro ao criar responsável');
          } else {
            Common.Toast.error('Erro ao criar responsável');
          }
        });
      $rootScope.show_loader = false;
    };

    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn1, ltn2, ltn3].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.responsibles')
    .controller('ResponsiblesAssistantController', ResponsiblesAssistantController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService, CONFIG, Session, $rootScope) {
    var role = 'resp_menu';
    var path = 'secretary.responsible-changes';

    $rootScope.$on(CONFIG.events.side_menu.update, function () {

      msNavigationService.saveItem(path, {
        title: 'Alterações pelo responsável',
        icon: 'icon-account-edit',
        auth: role,
        state: 'private.educational.responsible-changes.list',
        weight: 7,
        hidden: function () {
          return false; // Sempre visível para teste
        }
      });

    });

    $rootScope.$broadcast(CONFIG.events.side_menu.update);
  }

  angular
    .module('app.educational.responsible-changes')
    .run(run);

})();

(function () {
  'use strict';
  angular
    .module('app.educational.reports', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function ReportsService($http, $rootScope, CONFIG, Common, Restangular, ModalFactory, Utils) {

    var reportFactory = function (httpMethod, urlReport, parameters, filename) {
      $rootScope.show_loader = true;
      var deffered = Common.$q.defer();
      var parametersUrl = Utils.transformObjectInParametersUrl(parameters);
      $http({
        method: httpMethod,
        url: CONFIG.webApiUri + urlReport + '?' + parametersUrl,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);
          linkElement.setAttribute('href', url);
          if (parameters.is_csv) {
            linkElement.setAttribute("download", filename);
          } else {
            linkElement.setAttribute('target', '_blank');
          }
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          $rootScope.show_loader = false;
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      })
        .catch(function (err) {
          deffered.reject(err);
          $rootScope.show_loader = false;
        });
      return deffered.promise;
    };

    var getToken = function () {
      return Restangular.one('reports').one('token').get();
    };

    var enrolmentEvolutionChart = function () {
      return Restangular.one('reports').one('enrolmentevolutionchart').get();
    };

    var enrolmentByCourseChart = function () {
      return Restangular.one('reports').one('enrolmentbycoursechart').get();
    };

    var getEnrolmentItems = function () {
      return Restangular.one('enrolment').one('getallenrolmentitem').get();
    };

    var finalresultsreport = function (obj) {
      return Restangular.one('reports').one('finalresultsreport').get(obj);
    };

    var registrationbookreport = function (obj) {
      return Restangular.one('reports').one('registrationbookreport').get(obj);
    };

    var studentWalletReport = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/studentwalletreport?group_id=' + obj.group_id + '&type=' + obj.type +
          '&course_id=' + obj.course_id+
          '&enrolment_period_id=' + obj.enrolment_period_id +
          '&one=' + obj.options.one +
          '&two=' + obj.options.two +
          '&three=' + obj.options.three +
          '&carrier=' + obj.options.carrier +
          '&transport=' + obj.options.transport +
          '&authorization=' + obj.options.authorization +
          '&responsible_sign=' + obj.options.responsible_sign +
          '&photo=' + obj.options.photo +
          '&title=' + obj.options.title
        ,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);
          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {
        deffered.reject(error);
      });
      return deffered.promise;
    };
    var compliantDefaulting = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/compliantdefaulting?group_id=' + obj.group_id + '&year=' + obj.year
          + '&compliant_type=' + obj.compliant_type + '&course_id=' + obj.course_id + '&service_id=' + obj.service_id,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {
        deffered.reject(error);
      });
      return deffered.promise;
    };

    var studentsEnrolledReport = function (group, course) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/studentsenrolledreport?group_id=' + group.id + '&course_id=' + course.id,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);
          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", 'alunos_matriculados_' + course.name + '_' + group.name + '.pdf');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var getReportPDF = function (variables, id, orientation, name) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/' + id + '/' + orientation + '/generatepdf',
        data: {variables: variables},
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          // linkElement.setAttribute('target', '_blank');
          var filename = name + '.pdf';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var getReportCSV = function (id, name, variables) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/' + id + '/generatecsv',
        data: {variables: variables},
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          // linkElement.setAttribute('target', '_blank');
          var filename = name + '.csv';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;

    };

    var getReportXLSX = function (id, name, variables) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/' + id + '/generatexlsx',
        data: {variables: variables},
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          // linkElement.setAttribute('target', '_blank');
          var filename = name + '.xlsx';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var printStudentsDiscounts = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/studentsdiscounts?discount_option=' + obj.discount_option +
          "&discount_type=" + obj.discount_type +
          (angular.isDefined(obj.start_date) ? "&start_date=" + obj.start_date : '') +
          (angular.isDefined(obj.end_date) ? "&end_date=" + obj.end_date : '') +
          (angular.isDefined(obj.initial_value) ? "&initial_value=" + obj.initial_value : '') +
          (angular.isDefined(obj.end_value) ? "&end_value=" + obj.end_value : '') +
          (angular.isDefined(obj.reason_id) ? "&reason_id=" + obj.reason_id : '') +
          (angular.isDefined(obj.service_id) ? "&service_id=" + obj.service_id : '') +
          (angular.isDefined(obj.person_id) ? "&person_id=" + obj.person_id : '') +
          (angular.isDefined(obj.start_date_entered) ? "&start_date_entered=" + obj.start_date_entered : '') +
          (angular.isDefined(obj.end_date_entered) ? "&end_date_entered=" + obj.end_date_entered : '') +
          (angular.isDefined(obj.payment_plan_discount) ? "&payment_plan_discount=" + obj.payment_plan_discount : '') +
          (angular.isDefined(obj.service_type) ? "&service_type=" + obj.service_type : '') +
          (angular.isDefined(obj.course) ? "&course=" + obj.course : '') +
          (angular.isDefined(obj.groups) ? "&groups=" + obj.groups : ''),
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };


    var printRegistrationBook = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/registrationbookreport?' +
          (angular.isDefined(obj.group) ? "group=" + obj.group : '') +
          (angular.isDefined(obj.initial_date) ? "&initial_date=" + obj.initial_date : '') +
          (angular.isDefined(obj.final_date) ? "&final_date=" + obj.final_date : '') +
          (angular.isDefined(obj.course) ? "&course=" + obj.course : '') +
          (angular.isDefined(obj.school_period_id) ? "&school_period_id=" + obj.school_period_id : '') +
          (angular.isDefined(obj.order_by_enroment_number)  ?"&order_by_enroment_number=" + obj.order_by_enroment_number:''),
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var classRecords = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/classrecords?' +
          (angular.isDefined(obj.group_id) ? "group_id=" + obj.group_id : '') +
          (angular.isDefined(obj.matrix_period) ? "&matrix_period=" + obj.matrix_period : '') +
          (angular.isDefined(obj.subject_id) ? "&subject_id=" + obj.subject_id : '') +
          (angular.isDefined(obj.option) ? "&option=" + obj.option : '') +
          (angular.isDefined(obj.course_name) ? "&course_name=" + obj.course_name : '') +
          (angular.isDefined(obj.subject_id_course) ? "&subject_id_course=" + obj.subject_id_course : '') +
          (angular.isDefined(obj.start_date) && obj.start_date != null ? "&start_date=" + obj.start_date : '') +
          (angular.isDefined(obj.end_date) && obj.end_date != null ? "&end_date=" + obj.end_date : ''),
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var printAbsencesMap = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/absencesmap?' +
          (angular.isDefined(obj.group) ? "group=" + obj.group : '') +
          (angular.isDefined(obj.course) ? "&course=" + obj.course : '') +
          (angular.isDefined(obj.school_period_id) ? "&school_period_id=" + obj.school_period_id : ''),
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var printEnrolmentStatistics = function () {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/enrolmentstatistics',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var printStudentsSchoolPeriods = function () {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/studentsschoolperiods',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var printNewStudents = function () {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/newstudents',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var getLable = function () {
      return Restangular.one('reports').one('getlableconfig').get();

    };

    var updateLablesConfig = function (obj) {
     return Restangular.one('reports').all('updatelableconfig').post(obj);

    };

    return {
      reportFactory: reportFactory,
      getToken: getToken,
      getReportPDF: getReportPDF,
      getReportCSV: getReportCSV,
      getReportXLSX: getReportXLSX,
      finalresultsreport: finalresultsreport,
      studentWalletReport: studentWalletReport,
      registrationbookreport: registrationbookreport,
      studentsEnrolledReport: studentsEnrolledReport,
      printStudentsDiscounts: printStudentsDiscounts,
      printEnrolmentStatistics: printEnrolmentStatistics,
      printStudentsSchoolPeriods: printStudentsSchoolPeriods,
      printAbsencesMap: printAbsencesMap,
      printNewStudents: printNewStudents,
      compliantDefaulting: compliantDefaulting,
      classRecords: classRecords,
      getEnrolmentItems: getEnrolmentItems,
      enrolmentEvolutionChart: enrolmentEvolutionChart,
      enrolmentByCourseChart: enrolmentByCourseChart,
      printRegistrationBook: printRegistrationBook,
      updateLablesConfig: updateLablesConfig,
      getLable: getLable

    };

  }

  angular
    .module('app.educational.reports')
    .factory("ReportsService", ReportsService);

})();



(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('private.educational.reports', {
      abstract: true,
      templateUrl: 'app/educational/reports/views/list.html',
      controller: 'ReportsController',
      controllerAs: 'vm',
      public: false
    })
      .state('private.educational.reports.details', {
        url: '/reports',
        views: {
          'reports': {
            templateUrl: 'app/educational/reports/views/reportList.html',
            controller: 'ReportListController',
            controllerAs: 'vm'
          },
          'reportDetails': {
            templateUrl: 'app/educational/reports/views/reportDetail.html',
            controller: 'ReportDetailController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.reports')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'relat_menu';
    var path = 'educational.reports';

    msNavigationService.saveItem(path, {
      title: 'Relatórios',
      icon: 'icon-clipboard-text',
      auth: role,
      state: 'private.educational.reports.details',
      weight: 50,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.reports')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function ReportsController(PoliciesService) {
    var vm = this;

    vm.init = function () {
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();


  }

  angular
    .module('app.educational.reports')
    .controller('ReportsController', ReportsController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function ReportListController($rootScope, EducationalService, Session) {
      var vm = this;
      vm.academic_type = 1;
      vm.school_period_selected = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();

      vm.showList = true;
      /**
       * Função de inicialização do controllador
       */
      vm.init = function () {
        EducationalService.getAcademicTypeOfCompany().then(function (response) {
          vm.academic_type = response;
          vm.reportList = [
             {
              "id": 0,
              "name": "Adimplentes e inadimplentes",
              "template": 'app/educational/reports/views/reports-temp/compliant-defaulting.html',
              "icon": 'icon-view-list',
              "has_group_filter": true,
            }, {
              "id": 0,
              "name": "Alunos aprovados/reprovados por etapa",
              "template": 'app/educational/reports/views/reports-temp/students-approved-disapproved.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 0,
              "name": "Alunos aprovados/reprovados por turma",
              "template": 'app/educational/reports/views/reports-temp/students-approved-disapproved-by-group.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 0,
              "name": "Alunos cadastrados em serviços",
              "template": 'app/educational/reports/views/reports-temp/students-services.html',
              "icon": 'icon-view-list',
              "has_group_filter": false
            }, {
              "id": 0,
              "name": "Alunos com fotos",
              "template": 'app/educational/reports/views/reports-temp/students-with-pictures.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 0,
              "name": "Alunos com pagamento em dia",
              "template": 'app/educational/reports/views/reports-temp/students-up-to-dates.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 1,
              "name": "Alunos e Descontos",
              "template": 'app/educational/reports/views/reports-temp/students-discounts.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 1,
              "name": "Alunos e disciplinas em branco",
              "template": 'app/educational/reports/views/reports-temp/blank-subjects.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 1,
              "name": "Alunos e Períodos Letivos",
              "template": 'app/educational/reports/views/reports-temp/students-school-periods.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 1,
              "name": "Alunos e planos de pagamento",
              "template": 'app/educational/reports/views/reports-temp/students-payment-plans.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 1,
              "name": "Alunos em dependências",
              "template": 'app/educational/reports/views/reports-temp/students-dependencies.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 1,
              "name": "Alunos em etapa condicional",
              "template": 'app/educational/reports/views/reports-temp/students-conditional-step.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 2,
              "name": "Alunos matriculados",
              "template": 'app/educational/reports/views/reports-temp/students-enrolled.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 2,
              "name": "Alunos da matrícula/pré-matrícula online",
              "template": 'app/educational/reports/views/reports-temp/students-online-enrolment.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 2,
              "name": "Alunos não frequentes",
              "template": 'app/educational/reports/views/reports-temp/students-canceled.html',
              "icon": 'icon-view-list',
              "has_group_filter": false
            }, {
              "id": 2,
              "name": "Alunos novos",
              "template": 'app/educational/reports/views/reports-temp/new-students.html',
              "icon": 'icon-view-list',
              "has_group_filter": false
            }, {
              "id": 3,
              "name": "Alunos que não renovaram matrícula",
              "template": 'app/educational/reports/views/reports-temp/students-without-renovation.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 4,
              "name": "Alunos sem Descontos",
              "template": 'app/educational/reports/views/reports-temp/students-without-discounts.html',
              "icon": 'icon-view-list',
              "has_group_filter": false
            }, {
              "id": 4,
              "name": "Alunos que Trocaram de Curso ou Turma",
              "template": 'app/educational/reports/views/reports-temp/students-who-changed-course-per-period.html',
              "icon": 'icon-view-list',
              "has_group_filter": false
            }, {
              "id": 5,
              "name": "Aniversários dos alunos",
              "template": 'app/educational/reports/views/reports-temp/birthday-list.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 6,
              "name": "Ata de avaliações",
              "template": 'app/educational/reports/views/reports-temp/avaliations-result.html',
              "icon": 'icon-timetable',
              "has_group_filter": true,
            }, {
              "id": 6,
              "name": "Ata de resultados finais",
              "template": 'app/educational/reports/views/reports-temp/final-result.html',
              "icon": 'icon-timetable',
              "has_group_filter": true,
              "show": true//vm.school_period_selected.toString().length === 4
            },
            {
              "id": 6,
              "name": "Ata de resultados finais",
              "template": 'app/educational/reports/views/reports-temp/final-result-whiteout-period.html',
              "icon": 'icon-timetable',
              "has_group_filter": true,
              "show": false
            }, {
              "id": 7,
              "name": "Boletins",
              "template": 'app/educational/reports/views/reports-temp/students_records.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 8,
              "name": "Caderneta do aluno",
              "template": 'app/educational/reports/views/reports-temp/student-notebook.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 8,
              "name": "Carteirinhas dos alunos",
              "template": 'app/educational/reports/views/reports-temp/student-wallet.html',
              "icon": 'icon-timetable',
              "has_group_filter": false
            }, {
              "id": 8,
              "name": "Certificado de matrícula",
              "template": 'app/educational/reports/views/reports-temp/enrolment-certificate.html',
              "icon": 'icon-timetable',
              "has_group_filter": false
            }, {
              "id": 8,
              "name": "Classificação dos alunos",
              "template": 'app/educational/reports/views/reports-temp/students-classification.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 8,
              "name": "Contatos dos alunos",
              "template": 'app/educational/reports/views/reports-temp/students-contacts.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 8,
              "name": "Diários de frequência",
              "template": 'app/educational/reports/views/reports-temp/frequency-diary.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 8,
              "name": "Diários de frequência anual",
              "template": 'app/educational/reports/views/reports-temp/annual-frequency-diary.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 8,
              "name": "Diário de Avaliações",
              "template": 'app/educational/reports/views/reports-temp/grade-rule-diary.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 8,
              "name": "Disciplinas pendentes",
              "template": 'app/educational/reports/views/reports-temp/pending-subjects.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 8,
              "name": "Documentos pendentes",
              "template": 'app/educational/reports/views/reports-temp/pending-documents.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 9,
              "name": "Estatísticas das matrículas",
              "template": 'app/educational/reports/views/reports-temp/enrolment-statistics.html',
              "icon": 'icon-timetable',
              "has_group_filter": false
            }, {
              "id": 9,
              "name": "Etiquetas dos alunos",
              "template": 'app/educational/reports/views/reports-temp/students-tags.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 10,
              "name": "Ficha de matrícula",
              "template": 'app/educational/reports/views/reports-temp/enrolment-form.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 10,
              "name": "Ficha individual do aluno",
              "template": 'app/educational/reports/views/reports-temp/individual-form.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 10,
              "name": "Hora/Aulas",
              "template": 'app/educational/reports/views/reports-temp/hours-lessons.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 10,
              "name": "Históricos",
              "template": 'app/educational/reports/views/reports-temp/school-records.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 10,
              "name": "Inadimplência por curso/turma",
              "template": 'app/educational/reports/views/reports-temp/defaults-report.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 10,
              "name": "Listagem de alunos por turma (com idade)",
              "template": 'app/educational/reports/views/reports-temp/students-list-per-group.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            },
            {
              "id": 11,
              "name": "Livro de matrícula",
              "template": 'app/educational/reports/views/reports-temp/registration-book.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            },
            {
              "id": 11,
              "name": "Mapa de faltas",
              "template": 'app/educational/reports/views/reports-temp/absence-map.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            },
            {
              "id": 11,
              "name": "Mapa de frequência",
              "template": 'app/educational/reports/views/reports-temp/frequency-map.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            },
            {
              "id": 11,
              "name": "Mapa de notas",
              "template": 'app/educational/reports/views/reports-temp/notes-map.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            },
            {
              "id": 16,
              "name": "Matriculas efetuadas por usuário",
              "template": 'app/educational/reports/views/reports-temp/registration-by-user.html',
              "icon": 'icon-view-list',
              "has_group_filter": false
            },
              {
              "id": 11,
              "name": "Notas pendentes",
              "template": 'app/educational/reports/views/reports-temp/pending-notes.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 12,
              "name": "Ocorrências",
              "template": 'app/educational/reports/views/reports-temp/student-occurrences.html',
              "icon": 'icon-view-list',
              "has_group_filter": false
            }, {
              "id": 13,
              "name": "Protocolo de recebimento/entrega",
              "template": 'app/educational/reports/views/reports-temp/receive-protocol.html',
              "icon": 'icon-view-list',
              "has_group_filter": true
            }, {
              "id": 14,
              "name": "Registros de aulas",
              "template": 'app/educational/reports/views/reports-temp/class-records.html',
              "icon": 'icon-timetable',
              "has_group_filter": true
            }, {
              "id": 15,
              "name": "Responsáveis e dependentes",
              "template": 'app/educational/reports/views/reports-temp/responsibles-and-dependents.html',
              "icon": 'icon-view-list',
              "has_group_filter": false
            },
          ];
        })
      };

      /**
       * Função que escuta a seleção do relatório
       * @param item - Item selecionado na lista
       */
      vm.selectReport = function (item) {
        $rootScope.$broadcast("report-selected", item);
        vm.showList=false;
      };

      var ltn =  $rootScope.$on("show-list", function (ev, value) {
        vm.showList = value;
      })

      vm.init();
    }

    angular
      .module('app.educational.reports')
      .controller('ReportListController', ReportListController);

  }

)();

(function () {
  'use strict';

  /** @ngInject */
  function ReportDetailController($rootScope, $scope, CONFIG, $document, Session, ClassesService, Common, EnrolmentService, moment,
                                  CourseService, EducationalService, GroupService, ProductService, SchoolPeriodService, CollaboratorsService, ModalFactory, 
                                  ReportsService, StudentsService, a4Moment, IndividualDiscountsService, LessonPlanService, RolesService, BillReceiptService, PaymentPlanService) {
    var vm = this;
    vm.WEB_CONST = CONFIG.webApiUri;
    vm.header_final_results = '';
    vm.observations_final_results = '';
    vm.only_new_students = false;
    vm.exclude_event_done = false;
    vm.school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.selected_student = null;
    vm.selected_collaborator = null;
    vm.person_relation_type_id = null;
    vm.subject_selected_report = 0;
    vm.selected_class = null;
    vm.recordsCheckbox = 1;
    vm.classification_option = 1;
    vm.notenrolled = false;
    vm.tagOption = 1;
    vm.number_of_tags = 1;
    vm.combineCourseGroup=false;
    vm.registration_numbr = true;
    vm.card_numbr = true;
    vm.advanced_options = false;
    vm.filterTag = 0;
    vm.show_month_days = false;
    vm.tagWithPicture = false;
    vm.tagWithCpfAndEmail = false;
    vm.show_all_occurrences = false;
    vm.alias_subject = false;
    vm.school_days = 200;
    vm.wallet_config = 1;
    vm.notebook_config = 1;
    vm.compliant_type = 1;
    vm.side_school_report = 1;
    vm.optionRecords = 1;
    vm.gradeRuleDiaryOption = 1;
    vm.filter_service_id = null;
    vm.filter_service = null;
    vm.selected_course = null;
    vm.selected_subject = null;
    vm.pending_notes_option = 1;
    vm.selected_group = null;
    vm.where_option = 1;
    vm.print_enrolled = false;
    vm.print_caption = true;
    vm.not_print_footer = false;
    vm.filter_statistics_date = false;
    vm.grade_rule_item = null;
    vm.discount_option = 0;
    vm.only_more_than_two = false;
    vm.discount_type = 2;
    vm.service_type = 2;
    vm.only_mensality = false;
    vm.payment_plan_discount = 2;
    vm.enrolment_form_option = 1;
    vm.include_responsibles = false;
    vm.only_new = false;
    vm.showWarningLED = false;
    vm.showWarningLEDForm = true;
    vm.group_selected_report = null;
    vm.is_superior_course = false;
    vm.dont_print_days = false;
    vm.show_inactive_groups = false;
    vm.only_enrolment_item_handed = false;
    vm.not_exists = false;
    vm.printInstagram=false;
    vm.approvedDisapproved = 1;
    vm.orderByEnrolmentNumber=false;
    vm.lable = {
      a4: {
        margin_top: null,
        margin_left: null,
        margin_horizontal: null,
        margin_vertical: null
      },
      letter: {
        margin_top: null,
        margin_left: null,
        margin_horizontal: null,
        margin_vertical: null
      }
    };
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.without_company = false;
    vm.selected_service = null;
    vm.filter_up_to_date = 0;
    vm.breakForMonth = true;
    vm.report_selected = null;
    vm.occurrencesCheckbox = 'group';
    vm.print = {
      course_selected: null,
      enrolment_status_selected: null,
      group_selected: 0,
      selected_filter: 0,
      selected_order: 0,
      show_concluded_groups: true,
      payment_plan_selected: null
    };
    vm.only_active_contracts = false;
    vm.school_record_config = {
      history_superior_option: 1,
      recordsCheckbox: 2,
      repeat_pendent_subjects: false,
      include_subjects_without_enrolment: false,
      not_include_teacher_column: false,
      individual_observation: null,
      course_observation: null,
      print_complementar_on_another_page: true,
      order_by: 1
    };

    vm.frequency_map_config = {
      course_selected: null,
      group_selected: null,
      subject_id: null,
      date_range: {
        startDate: a4Moment().startOf('month'),
        endDate: a4Moment().endOf('month')
      },
      option: 1
    };

    vm.wallet_orientation = {
      one: true, two: true, three: true, photo: false,
      carrier: true, transport: true, authorization: true,
      responsible_sign: true, title: 1
    };
    vm.selected_class = {};
    vm.courses = [];
    vm.groups = [];
    vm.years = [];
    vm.enrolment_status = [];
    vm.paymentPlans = [];
    vm.enrolment_status_selected = 10;
    vm.searchTerm = '';
    vm.print_dependency = false;
    vm.financeOrPedagogic = 1;
    vm.selectedSchoolPeriod = null;
    vm.documentTitle = null;
    vm.hide_disciplines = false;
    vm.optionBirthday = 1;
    vm.block_button = true;
    vm.print_photo = false;
    vm.flag_logo = false;
    vm.print_graphic = false;
    vm.group_selected = null;
    vm.course_selected = null;
    vm.date_selected = a4Moment();
    vm.secretary_name = null;
    vm.hide_defaulters = false;
    vm.show_non_regular_student = false;
    vm.hide_teacher_and_subject = false;
    vm.separe_groups = false;
    vm.showFinanceResponsible = false;
    vm.windowWidth = angular.element("body").width();
    vm.buttonsBlankSubjects = [
      {
        icon: 'icon-file-pdf', label: 'Gerar relatório em PDF',
        isCSV: false
      },
      {
        icon: 'icon-file-excel', label: 'Gerar relatório em CSV',
        isCSV: true
      }
    ];
    vm.selected_user = null;

    vm.service_date = {
      startDate: a4Moment().startOf('year').format('YYYY-MM-DD'),
      endDate: a4Moment().endOf('year').format('YYYY-MM-DD')
    };


    vm.active_contracts = false;

    /**
     * Escuta para seleção de relatório
     * @type {*}
     */
    var ltn = $rootScope.$on("report-selected", function (ev, value) {
      vm.report_selected = value;
      vm.print.date_range = {
        startDate: a4Moment().startOf('year'),
        endDate: a4Moment().startOf('day')
      };
      vm.print.date_limit = a4Moment();
    });

    vm.getPaymentPlans = function () {
      $rootScope.show_loader = true;
      PaymentPlanService.getAllPaymentPlan()
        .then(function (response) {
          vm.paymentPlans = response.plain();
        });
      $rootScope.show_loader = false;
    };

    vm.studentsprintPendingDocuments = function () { 
      var studentspendingDocumentsParameters = {
        course_id: vm.print.course_selected.id,
        only_enrolment_item_handed: vm.only_enrolment_item_handed,
        enrolment_item_id:vm.print.enrolment_item_selected.id
      };

      ReportsService.reportFactory('GET', 'api/reports/studentspendingdocuments', studentspendingDocumentsParameters);
    }

    //Função que retorna a lista para tela e seta o report selecionado como nulo.
    vm.changeShowList = function (){
      $rootScope.$broadcast("show-list", true);
      vm.report_selected = null;
    }

    vm.unblock_button = function () {
      vm.block_button = false;
    };

    /**
     * Função generica que retira o valor de filter_date(variavel generica usada para date-range-picker)
     */
    vm.blank_filter_date = function () {
      vm.filter_date.start_date = null;
      vm.filter_date.end_date = null;
    };

    /*********************Ata de resultados finais e Livro de matrícula*******************************/

    /**
     * Usado para ata de resultados finais
     */
    vm.getCourses = function (allCourses) {
      $rootScope.show_loader = true;
      if(angular.isUndefined(allCourses)){
        allCourses=true;
      }
      CourseService.getAll({only_active: true})
        .then(function (response) {
          vm.courses = response.plain();
          if(allCourses){
            vm.courses.push({id: 0, name: 'Todos os cursos'});
          }
        });
      $rootScope.show_loader = false;

    };

    vm.printFrequencyMap = function () {
      vm.frequency_map_config.start_date = a4Moment(vm.frequency_map_config.date_range.startDate).format('YYYY-MM-DD');
      vm.frequency_map_config.end_date = a4Moment(vm.frequency_map_config.date_range.endDate).format('YYYY-MM-DD');
      vm.frequency_map_config.selected_student_name = null;
      vm.frequency_map_config.selected_student_id = null;

      if (vm.frequency_map_config.option == 4) {
        vm.frequency_map_config.selected_student_name = vm.selected_student_report.name;
        vm.frequency_map_config.selected_student_id = vm.selected_student_report.id;
      }

      if (vm.frequency_map_config.option === 3) vm.frequency_map_config.subject_id = null;

      ReportsService.reportFactory('GET', 'api/reports/frequencymapreport', vm.frequency_map_config); 
    };


    vm.printEnrolmentForm = function () {
      ReportsService.reportFactory('GET',
        'api/reports/printenrolmentform',
        {
        student_id: (vm.selected_student) ? vm.selected_student.id : null,
        group_student: (vm.selected_student) ? vm.selected_student.group_id : null,
        group_id: vm.group_selected_report,
        course_id: (vm.print.course_selected) ? vm.print.course_selected.id : null,
        enrolment_status_id: vm.print.enrolment_status_selected,
        option: vm.enrolment_form_option,
        school_period_id: vm.conf.current_school_period_id,
        print_photo: vm.print_photo
      }).catch(function () {
        Common.Toast.error("não possuem alunos dentro do filtro selecionado");
      })
    };


    vm.printStudentsClassification = function () {

      var studentsClassificationParameters = {
        course_id: vm.print.course_selected.id,
        group_id: vm.group_selected_report,
        user_id: vm.conf.user_id,
        option: vm.classification_option,
        grade_rule_item: vm.grade_rule_item,
        current_school_period: vm.school_period,
        combine_course_group:vm.combineCourseGroup

      };

      ReportsService.reportFactory('GET', 'api/reports/studentsclassification', studentsClassificationParameters);
    };

    vm.getBlankSubjects = function (isCsv) {
      ReportsService.reportFactory('GET', 'api/reports/blanksubjectsreport', {
        group_id: vm.print.group_selected,
        course_id: vm.print.course_selected.id,
        is_csv: isCsv
      }, 'ALUNOS_E_DISCIPLINAS_EM_BRANCO.csv');
    };

    vm.printEnrolmentCertificate = function () {
      ReportsService.reportFactory('GET', 'api/reports/enrolmentcertificate', {
        student_id: vm.selected_student_report.id,
        show_warning: vm.showWarningLED,
        group_id: vm.selected_student_report.group_id,
        matrix_period: vm.selected_student_report.matrix_period
      })
    }


    vm.printServiceStudents = function () {
      ReportsService.reportFactory('GET',
        'api/reports/studentsservice',
        {
          product_id: vm.selected_service.id,
          school_period_id: vm.school_period,
          where_option: vm.where_option,
          service_start_date: vm.service_date && angular.isDefined(vm.service_date.startDate) 
          && vm.service_date.startDate !== null ? vm.service_date.startDate : null,
          service_end_date: vm.service_date && angular.isDefined(vm.service_date.endDate) 
          && vm.service_date.endDate !== null ? vm.service_date.endDate : null,
          active_contracts: vm.active_contracts
        })
    }

    vm.getAllEnrolmentStatus = function () {
      EnrolmentService.getAllEnrolmentStatus().then(function (response) {
        vm.enrolment_status = response.plain();
      })
    };

    vm.getServices = function (search) {
      return vm.returnService(search);
    };

    vm.getSubjectsByCourse = function (course_id) {
      LessonPlanService.getSubjectsByCourse({course_id: course_id}).then(function (response) {
        vm.subjects_course = response.plain();
      })
    };

    vm.returnService = function (query) {
      return ProductService.getServicesByQuery({query: query});
    };

    vm.getCoursesForResponsibles = function () {
      $rootScope.show_loader = true;
      CourseService.getAll({only_active: true})
        .then(function (response) {
          vm.courses = response.plain();
        });
      $rootScope.show_loader = false;

    };


    /**
     * Retorna as turmas de um curso selecionado
     * @param course_selected - identificador do curso selecionado
     */
    vm.getGroups = function (course_selected) {
      if (course_selected.id !== 0) {
        vm.groups = [];
        $rootScope.show_loader = true;
        GroupService.getGroupsByCourse(course_selected.id, {
          paginate: false,
          show_inactive_groups: vm.show_inactive_groups
        })
          .then(function (response) {
            vm.groups = response.plain();
            if (vm.groups.length > 0) {
              var all_groups = angular.copy(vm.groups[0]);
              all_groups.id = 0;
              all_groups.group_id_period = '0_0';
              all_groups.name = 'Todas as turmas';
              all_groups.result = 'Todas as turmas';
              vm.groups.push(all_groups);
              vm.groups = angular.copy(vm.groups);
            } else {
              vm.groups.push({
                id: 0, name: 'Todas as turmas',
                group_id_period: '0_1'
              });
              vm.print.group_selected = null;
            }
            $rootScope.show_loader = false;
          })
          .catch(function () {
            Common.Toast.error('Erro ao buscar turmas');
            $rootScope.show_loader = false;
          });
      } else {
        vm.groups = [];
        vm.groups.push({id: 0, name: 'Todas as turmas', group_id_period: '0_0'});
        vm.print.group_selected = null;
      }
      vm.checkSuperiorCourse(course_selected.course_equivalence_id);
    };

    vm.getGroupsForResponsibles = function (course_selected) {
      GroupService.getGroupsByCourse(course_selected.id)
        .then(function (response) {
          vm.groupsForResponsibles = response.plain().data;
        })
    };

    /*********************END Ata de resultados finais e Livro de matrícula*******************************/


    /************************Ficha de Matrícula*******************************/


    /**
     * Lista de estudantes
     */
    vm.getStudents = function (query) {
      query = angular.isDefined(query) ? query : '';
      return StudentsService.getAll({
        query: query, is_search: true,
        enrolment_status_id: vm.print.enrolment_status_selected,
        show_inactive: vm.show_inactive_groups
      });
    };

    /**
     * Lista de estudantes que não são ouvintes ou alunos com necessidades especiais
     */
    vm.getRegularStudents = function (query) {
      query = angular.isDefined(query) ? query : '';
      return StudentsService.getAll({
        query: query, is_search: true,
        show_inactive: vm.show_inactive_groups,
        is_regular_students: true
      });
    };

    /************************END Ficha de Matrícula*******************************/

    vm.getCollaborators = function (query) {
      query = angular.isDefined(query) ? query : '';
      return CollaboratorsService.getAll({
        query: query, is_search: true,
        show_inactive: vm.show_inactive_groups
      });
    };

    /**
     * Função de inicialização do controlador
     */
    vm.init = function () {
      vm.getConfig();
      vm.getAllSchoolPeriod();
      EducationalService.getAcademicTypeOfCompany().then(function (response) {
        vm.academic_type = response;
      });
      vm.conf.current_company = Session.get('current_company', "sessionStorage");

      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
          vm.conf.current_school_period_id = $scope.educational.school_period.selected.id;
        });
      vm.ranges = {
        'Hoje': [a4Moment(), a4Moment().startOf('day')],
        'Esta semana': [a4Moment().startOf('week'), a4Moment().endOf('week')],
        'Este mês': [a4Moment().startOf('month'), a4Moment().endOf('month')],
        'Mês anterior': [a4Moment().subtract(1, 'month').startOf('month'), a4Moment().subtract(1, 'month').endOf('month')],
        'Últimos 7 Dias': [a4Moment().subtract(7, 'days'), a4Moment()],
        'Últimos 30 Dias': [a4Moment().subtract(30, 'days'), a4Moment()],
        'Início do ano até hoje': [a4Moment().startOf('year'), a4Moment().startOf('day')]
      };
      for (var i2 = 0; i2 <= 5; i2++) {
        var momentVar3 = a4Moment().subtract(1, 'years').add('year', i2);
        vm.years.push({id: momentVar3.year(), name: momentVar3.format('YYYY')});
      }
      vm.current_year = a4Moment().year();
    };

    vm.getConfig = function () {
      BillReceiptService.getConfig()
        .then(function (response) {
          vm.config = response.plain();
        });
    }

    /**
     * Resgata possiveis relações de responsáveis ao aluno
     */
    vm.getPersonRelationLegal = function () {
      EnrolmentService.getPersonRelationLegal()
        .then(function (list) {
          vm.person_relation_types = list.plain();
        });
    };

    /**
     * Retorna os documentos
     */
    vm.getDocuments = function () {
      ReportsService.getEnrolmentItems()
        .then(function (resp) {
          vm.enrolment_items = resp.plain();
        })
    };

    /**
     * Busca os itens da grade
     * @param group_id
     * @param student_id
     * @param only_conditional
     * @param matrix_period
     * @param get_all
     */
    vm.getGradeRuleItems = function (group_id, student_id, only_conditional, matrix_period, get_all) {
      EducationalService.getGradeRuleItems({
        student_id: student_id,
        group_id: group_id,
        matrix_period: matrix_period,
        course_id: vm.print && angular.isDefined(vm.print.course_selected) && vm.print.course_selected !== null ? vm.print.course_selected.id : null, 
        student_group_id: angular.isDefined(vm.selected_student_report) ? vm.selected_student_report.group_id : null,
        only_conditional: angular.isDefined(only_conditional) ? only_conditional : false,
        get_all: angular.isDefined(get_all) ? get_all : false
      })
        .then(function (response) {
          vm.grade_rule_items = response.plain();
        })
    };

    /**
     * HISTORICO
     */

    vm.checkSuperiorCourse = function (equivalence_id) {
      vm.is_superior_course = (equivalence_id >= 300 && equivalence_id <= 365) || equivalence_id === 999;
    };

    vm.checkConfigOfSchoolRecordsBeforePrint = function () {
      console.log(vm.config.sr_certificate_option);
      if(vm.config.sr_certificate_option == 2) {
        ModalFactory.confirm(null,
          "Exibir certificado",
          "Deseja imprimir o certificado junto do historico?",
          'Sim', 'Não',
          'educational'
        ).then(function() {
          vm.printSchoolRecords(true);
        }).catch(function() {
          vm.printSchoolRecords(false);
        })
      } else {
        vm.printSchoolRecords(false);
      }
    }

    vm.printSchoolRecords = function (print_certificate) {
      var type = null;
      var href = null;
      var element = null;

      if (vm.selected_student_report.course_equivalence_id < 100){
        type = 'pre'
      }else if (vm.selected_student_report.course_equivalence_id >= 100 && vm.selected_student_report.course_equivalence_id <= 199) {
        type = 'primary';
      } else if (vm.selected_student_report.course_equivalence_id >= 200 && vm.selected_student_report.course_equivalence_id <= 299) {
        type = 'all';
      } else if (vm.selected_student_report.course_equivalence_id >= 300 && vm.selected_student_report.course_equivalence_id <= 399) {
        type = 'superior';
      } else {
        type = 'technical';
      }

      if (type === 'primary' || type === 'all' || type === 'pre') {
        ReportsService.reportFactory('GET',
          'api/schoolrecords/report/' + vm.selected_student_report.id,
          {
            type: type,
            user_id: vm.conf.user_id,
            print_certificate: print_certificate
          });
      } else {
        ReportsService.reportFactory('GET',
          'api/superiorschoolrecords/report/' + vm.selected_student_report.id,
          {
            type: type,
            history_option: vm.school_record_config.history_superior_option,
            student_group_id: vm.selected_student_report.group_id,
            observation: vm.school_record_config.individual_observation,
            repeat_pendent_subjects: vm.school_record_config.repeat_pendent_subjects,
            include_subjects_without_enrolment: vm.school_record_config.include_subjects_without_enrolment,
            not_include_teacher_column: vm.school_record_config.not_include_teacher_column,
            order_by: vm.school_record_config.order_by,
            print_complementar_on_another_page: vm.school_record_config.print_complementar_on_another_page,
            user_id: vm.conf.user_id,
            print_certificate: print_certificate
          });
      }
    };


    /**
     * Retorna todas as razões de desconto
     */
    vm.getDiscountsReasons = function (query) {
      return IndividualDiscountsService.getDiscountsReasons({query: query});
    };
    /**
     * Retorna todas as pessoas que inseriram desconto em um contrato
     */
    vm.getUsersEnteredDiscount = function (query) {
      return IndividualDiscountsService.getUsersEnteredDiscount({query: query});
    };

    /** --------------------------------- */
    /**
     * Lista de classes
     */
    vm.getClasses = function (query) {
      query = angular.isDefined(query) ? query : '';
      return ClassesService.all({query: query});
    };

    /**
     * Busca todos os períodos letivos
     */
    vm.getAllSchoolPeriod = function () {
      SchoolPeriodService.getAll().then(function (response) {
        vm.school_periods = response.plain();
      })
    };

    /**
     * Retorna todos os produtos
     */
    vm.getAllServices = function (query) {
      return ProductService.getAllProducts({
        query: angular.isDefined(query) ? query : null,
        only_services: true,
        show_inactive_products: true,
        withoutExternalId: true,
        autocomplete: true,
        compliant_type: vm.compliant_type
      });
    };
    /**
     * Item selecionado no autocomplete de serviços
     * @param item
     */
    vm.selectedServiceChange = function (item) {
      if (angular.isDefined(item)) {
        vm.filter_service_id = item.id;
      } else {
        vm.filter_service_id = null;
      }
    };
    /**
     * Gera as carteirinhas dos estudantes de uma turma
     */
    vm.generateWallets = function () {
      $rootScope.show_loader = true;
      ReportsService.studentWalletReport({
        course_id: vm.print.course_selected !== null && angular.isDefined(vm.print.course_selected.id) ? vm.print.course_selected.id : null,
        group_id: vm.print.group_selected !== null ? vm.print.group_selected : 0,
        type: vm.wallet_config,
        options: vm.wallet_orientation,
        enrolment_period_id: angular.isDefined(vm.selected_student_report) && vm.selected_student_report !== null ? vm.selected_student_report.enrolment_period_id : null
      })
        .then(function () {
          $rootScope.show_loader = false;
        }).catch(function (response) {
        $rootScope.show_loader = false;
        Common.Toast.error("Ocorreu um erro");
      });
    };

    vm.printHoursLessons = function () {
      return ReportsService.reportFactory('GET', 'api/reports/hourslessonsreport', {
        group_id: angular.isDefined(vm.print.group_selected) ? (angular.isDefined(vm.print.group_selected.id) ? vm.print.group_selected.id : vm.print.group_selected) : null,
        course_id: angular.isDefined(vm.print.course_selected.id) ? vm.print.course_selected.id : null
      });
    };

    /**
     * Relatório de alunos matriculados
     */
    vm.studentsEnrolled = function () {
      $rootScope.show_loader = true;
      ReportsService.studentsEnrolledReport(vm.print.group_selected, vm.print.course_selected)
        .then(function () {
          $rootScope.show_loader = false;
        })
        .catch(function (response) {
          $rootScope.show_loader = false;
          Common.Toast.error(response.message);
        });
    };

    vm.printStudentEnrolled = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/studentsenrolledreport',
        {
          token: vm.conf.token,
          company: vm.conf.current_company,
          connection: vm.conf.current_connection,
          group_id: vm.print.group_selected !==null?(angular.isDefined(vm.print.group_selected) ? (angular.isDefined(vm.print.group_selected.id) ? vm.print.group_selected.id : vm.print.group_selected) : null): null ,
          group_id_period: vm.print.group_selected!==null?(angular.isDefined(vm.print.group_selected.group_id_period)?vm.print.group_selected.group_id_period:null):null,
          course_id: vm.print.course_selected !==null?(angular.isDefined(vm.print.course_selected.id) ? vm.print.course_selected.id : null):null,
          filter_by: vm.print.selected_filter,
          order_by: vm.print.selected_order,
          date_limit: a4Moment(vm.print.date_limit).format('YYYY-MM-DD'),
          show_concluded_groups: vm.print.show_concluded_groups,
          start_date: a4Moment(vm.print.date_range.startDate).format('YYYY-MM-DD'),
          end_date: a4Moment(vm.print.date_range.endDate).format('YYYY-MM-DD'),
          user_id: vm.conf.user_id,
          status: vm.enrolment_status_selected,
          current_school_period: vm.school_period
        })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    }

    /**
     * Relatório de alunos com matrícula online
     */
      vm.printStudentsOnlineEnrolmentReport = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/studentsonlineenrolmentreport',
        {
          token: vm.conf.token,
          user_id: vm.conf.user_id,
          group_id: vm.print.group_selected !==null?(angular.isDefined(vm.print.group_selected) ? (angular.isDefined(vm.print.group_selected.id) ? vm.print.group_selected.id : vm.print.group_selected) : null): null ,
          group_id_period: vm.print.group_selected!==null?(angular.isDefined(vm.print.group_selected.group_id_period)?vm.print.group_selected.group_id_period:null):null,
          course_id: vm.print.course_selected !==null?(angular.isDefined(vm.print.course_selected.id) ? vm.print.course_selected.id : null):null,
          filter_by: vm.print.selected_filter,
          start_date: a4Moment(vm.print.date_range.startDate).format('YYYY-MM-DD'),
          end_date: a4Moment(vm.print.date_range.endDate).format('YYYY-MM-DD'),
          date_limit:a4Moment(vm.print.date_limit).format('YYYY-MM-DD')
        }).then(function () {
        $rootScope.show_loader = false;
        Common.Toast.success('Download concluído');
      })
        .catch(function (error) {
          $rootScope.show_loader = false;
          if(error.status === 404 ) {
            Common.Toast.error('Não há alunos para os filtros selecionados.')
          }
        })
    };

    /**
     * Relatório de Aniversário dos estudantes
     */
    vm.printstudentsbirthdays = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/printstudentsbirthdays',
        {
          token: vm.conf.token,
          month:vm.selectedMonth.value,
          break_for_month:vm.breakForMonth,
          orderBy:vm.orderByBirthday,
          school_period_id:vm.school_period,
          monthName:vm.selectedMonth.name,
          groupsPerPage:vm.printWithGroupsPerPage,
          optionBirthday:vm.optionBirthday,
          course_id: vm.course_selected !== null?vm.course_selected.id:null,
          group_id: vm.group_selected,
        }).then(function () {
        $rootScope.show_loader = false;
        Common.Toast.success('Download concluído');
      })
        .catch(function (error) {
          $rootScope.show_loader = false;
          if(error.status === 404 ) {
            Common.Toast.error('Não há alunos para os filtros selecionados.')
          }
        })
    };

    /**
     * Relatório de Ata das avaliações
     */
    vm.printavaliationsresult = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/avaliationsresult',
        {
          token: vm.conf.token,
          course_id : vm.print.course_selected !== null?(vm.print.course_selected.id !== null?vm.print.course_selected.id:null):null,
          group_id : vm.group_selected_report !== null?(vm.group_selected_report.id !== null?vm.group_selected_report.id:null):null,
          user_id : vm.conf.user_id,
          hide_defaulters : vm.hide_defaulters,
          matrix_period :angular.isDefined(vm.group_selected_report.matrix_period) ? vm.group_selected_report.matrix_period : null
        }).then(function () {
        $rootScope.show_loader = false;
        Common.Toast.success('Download concluído');
      })
        .catch(function (error) {
          $rootScope.show_loader = false;
          if(error.status === 404 ) {
            Common.Toast.error('Não há alunos para os filtros selecionados.')
          }
        })
    };

    vm.printStudentsWithoutRenovation = function () {
      $rootScope.show_loader = true;
      console.log(vm.selected_group)
      console.log(vm.school_periods[vm.selectedSchoolPeriod].id)
      console.log(vm.school_periods[vm.selectedSchoolPeriod+1].id)
      ReportsService.reportFactory('GET',
        'api/reports/printstudentswithoutrenovation',
        {
          token: vm.conf.token,
          company: vm.conf.current_company,
          group_id: vm.selected_group,
          course_id: vm.selected_course !== null ? vm.selected_course.id : null,
          separe_groups: vm.separe_groups,
          show_finance_responsible: vm.showFinanceResponsible,
          connection: vm.conf.current_connection,
          school_period_compare: vm.school_periods[vm.selectedSchoolPeriod].id,
          school_period_id: vm.school_periods[vm.selectedSchoolPeriod+1].id,
          current_school_period: vm.school_period
        })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    }

    vm.printEnrolmentContract = function () {
      $rootScope.show_loader = true;
      EnrolmentService.printEnrolmentContract({
        person_id: vm.selected_student.id
      })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    vm.classRecords = function () {
      $rootScope.show_loader = true;
      ReportsService.classRecords({
        group_id: angular.isDefined(vm.selected_class.group_id) && vm.selected_class.group_id !== null ? vm.selected_class.group_id : vm.group_selected_report,
        matrix_period: angular.isDefined(vm.selected_class.matrix_period) && vm.selected_class.matrix_period !== null ? vm.selected_class.matrix_period : 1,
        subject_id: vm.selected_class.subject_id,
        option: vm.optionRecords,
        course_name: vm.print.course_selected !== null ? vm.print.course_selected.name : null,
        subject_id_course: vm.subject_selected,
        start_date: vm.filter_date.startDate,
        end_date: vm.filter_date.endDate
      })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    vm.compliantDefaulting = function () {
      $rootScope.show_loader = true;
      ReportsService.compliantDefaulting({
        group_id: vm.group_selected_report, year: vm.current_year, service_id: vm.filter_service_id,
        compliant_type: vm.compliant_type, course_id: vm.print.course_selected.id
      })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          if(error.status==406){
            Common.Toast.warning('Não existem títulos para este serviço no ano selecionado');
          }
        })
    };

    vm.printRegistrationBook = function () {
      $rootScope.show_loader = true;
      ReportsService.printRegistrationBook({
        group: vm.print.group_selected.id, initial_date: a4Moment(vm.print.date_range.startDate).format('YYYY-MM-DD'),
        final_date: a4Moment(vm.print.date_range.endDate).format('YYYY-MM-DD'), course: vm.print.course_selected.id,
        school_period_id: vm.conf.current_school_period_id,
        order_by_enroment_number:vm.orderByEnrolmentNumber
      })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Relatório Estatísticas de matrícula
     */
    vm.printEnrolmentStatistics = function () {

      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/enrolmentstatistics',
        {
          start_date: angular.isDefined(vm.filter_date) ? vm.filter_date.startDate : null,
          end_date: angular.isDefined(vm.filter_date) ? vm.filter_date.endDate : null

        })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Relatório de disciplinas pendentes
     */
    vm.printPendingSubjects = function(){
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/pendingsubjects',
        {
          course_id:vm.print.course_selected.id,
          group_id:vm.group_selected_report,
          start_date: angular.isDefined(vm.print.date_range) ? a4Moment(vm.print.date_range.startDate).format('YYYY-MM-DD') : null,
          end_date: angular.isDefined(vm.print.date_range) ? a4Moment(vm.print.date_range.endDate).format('YYYY-MM-DD'): null,
          user_id:vm.conf.user_id,
        })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    }

    /**
     * Relatório Alunos e Períodos Letivos
     */
    vm.printStudentsSchoolPeriods = function () {
      $rootScope.show_loader = true;
      ReportsService.printStudentsSchoolPeriods()
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Relatório de alunos Que Mudaram de Curso  Um Perído Letivo
     */
    vm.printStudentsWhoChangedCoursePerPeriods = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/studentswhochangedcourseperperiods',
        vm.school_period)
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Relatório Contatos dos alunos
     */
    vm.printStudentsContacts = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/studentscontacts',
        {
          group_id: angular.isDefined(vm.print.group_selected) ? (angular.isDefined(vm.print.group_selected.id) ? vm.print.group_selected.id : vm.print.group_selected) : null,
          enrolment_status_id:vm.enrolment_status_selected,
          course_id:vm.print.course_selected.id,
          only_new:vm.only_new,
          printInstagram:vm.printInstagram
        }
      ).then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    vm.printStudentsDependenciesReport = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/studentsdependenciesreport',
        {
          group_id: angular.isDefined(vm.print.group_selected) ? (angular.isDefined(vm.print.group_selected.id) ? vm.print.group_selected.id : vm.print.group_selected) : null,
          user_id:vm.conf.user_id,
          course_id:vm.print.course_selected.id,
          token:vm.conf.token
        }
      ).then(function () {
        $rootScope.show_loader = false;
        Common.Toast.success('Download concluído');
      })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Relatório Mapa de Faltas
     */
    vm.printAbsencesMap = function () {
      $rootScope.show_loader = true;
      ReportsService.printAbsencesMap({
        group: vm.group_selected_report,
        course: vm.print.course_selected.id,
        school_period_id: vm.conf.current_school_period_id
      })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Relatório de alunos com pagamento em dia
     */
    vm.printStudentsUpToDate = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/studentsuptodates',
        {
          range:JSON.stringify(vm.date_up_to_date),
          filter:vm.filter_up_to_date,
          user_id:vm.conf.user_id,
          include_responsibles:vm.include_responsibles,
          only_mensality:vm.only_mensality
        }).then(function () {
        $rootScope.show_loader = false;
        Common.Toast.success('Download concluído');
      })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Relatório de descontos
     * @param obj
     */
    vm.printStudentsDiscounts = function (obj) {
      $rootScope.show_loader = true;
      ReportsService.printStudentsDiscounts(obj)
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    /**
     * Relatório de alunos novos
     */
    vm.printNewStudents = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/newstudents',
        {
          enrolment_status: vm.print.enrolment_status_selected
        }
      )
    }


    /** LISTA DE ANIVERSÁRIOS */

    vm.months = [
      {
        name: "Todos os meses",
        value: 0
      }, {
        name: "Janeiro",
        value: 1
      },
      {
        name: "Fevereiro",
        value: 2
      }, {
        name: "Março",
        value: 3
      }, {
        name: "Abril",
        value: 4
      }, {
        name: "Maio",
        value: 5
      }, {
        name: "Junho",
        value: 6
      }, {
        name: "Julho",
        value: 7
      }, {
        name: "Agosto",
        value: 8
      }, {
        name: "Setembro",
        value: 9
      }, {
        name: "Outubro",
        value: 10
      }, {
        name: "Novembro",
        value: 11
      }, {
        name: "Dezembro",
        value: 12
      }
    ];

    vm.generateSchoolRecord = function () {
      ReportsService.reportFactory('GET',
        'api/reports/schoolreport',
        {
          course_id: (vm.print && vm.print.course_selected && vm.print.course_selected.id) || null,
          group_id: vm.group_selected_report,
          student_id: (vm.selected_student_report && vm.selected_student_report.id) || null,
          grade_rule_item: vm.grade_rule_item,
          student_group_id: (vm.selected_student_report && vm.selected_student_report.group_id) || null,
          side_school_report: vm.side_school_report,
          matrix_period: (vm.selected_student_report && vm.selected_student_report.matrix_period) || null,
          matrix_id: (vm.selected_student_report && vm.selected_student_report.matrix_id) || null,
          print_photo: vm.print_photo,
          print_graphic: vm.print_graphic,
          dont_print_footer: vm.not_print_footer,
          flag_logo: vm.flag_logo
        });
    }

    vm.generateIndividualStudentForm = function () {
          ReportsService.reportFactory('GET',
            'api/reports/individualstudentform',
            {
              course_id: (vm.print && vm.print.course_selected && vm.print.course_selected.id) || null,
              group_id: vm.group_selected_report,
              enrolment_status_id: vm.print.enrolment_status_selected,
              student_id: (vm.selected_student_report && vm.selected_student_report.id) || null,
              type: vm.recordsCheckbox,
              matrix_period: (vm.selected_student_report && vm.selected_student_report.matrix_period) || null,
              registration_numbr: vm.registration_numbr
          }).then(function(response) {
            Common.Toast.success('Relatório impresso com sucesso!')
          }).catch(function(error) {
            if(error.status === 404 ) {
              Common.Toast.error('Não há registros de disciplinas para os alunos da turma selecionada ou para o aluno selecionado.')
            }
          })
        }


    vm.generateStudentsConditionalStep = function () {
      ReportsService.reportFactory('GET', 'api/reports/studentsconditionalstep',
        {
        company: vm.conf.current_company,
        course_id: vm.print.course_selected.id,
        group_id: vm.group_selected_report,
        grade_rule_item: vm.grade_rule_item,
        current_school_period: vm.school_period,
        exclude_event_done: vm.exclude_event_done
      });
    }

    vm.generatePendingNotes = function () {
      ReportsService.reportFactory('GET', 'api/reports/pendingnotes',
        {
          token: vm.conf.token,
          company_id: vm.conf.current_company,
          connection: vm.conf.current_connection,
          course_id: vm.print.course_selected.id,
          group_id: vm.group_selected_report,
          user_id: vm.conf.user_id,
          option: vm.pending_notes_option,
          grade_rule_item: vm.grade_rule_item,
          subject_id: vm.selected_subject,
          current_school_period: vm.school_period
        }
      )
    }


    vm.generateStudentOccurrences = function () {
      ReportsService.reportFactory('GET',
        'api/reports/studentoccurrence',
        {
          student_id: (vm.selected_student && vm.selected_student.id ) || 0,
          collaborator_id: (vm.selected_collaborator && vm.selected_collaborator.id) || 0,
          course_id: (vm.print.course_selected && vm.print.course_selected.id),
          group_id: vm.group_selected_report,
          show_all: vm.show_all_occurrences,
          start_date: vm.print.date_range && vm.print.date_range.startDate ? a4Moment(vm.print.date_range.startDate).format('YYYY-MM-DD') : null,
          end_date: vm.print.date_range && vm.print.date_range.endDate ? a4Moment(vm.print.date_range.endDate).format('YYYY-MM-DD') : null,
          filter_option: vm.occurrencesCheckbox,
          user_id: vm.conf.user_id
      });
    }

    vm.registrationByUser = function () {
        vm.selected_user = angular.isDefined(vm.users_filter) && vm.users_filter.name  !== null ? vm.users_filter.name.name : null ;
        if(vm.recordsCheckbox == 1) {
          vm.selected_user = null
        }
      ReportsService.reportFactory('GET',
        'api/reports/registrationbyuser',
        {
          start_date: a4Moment(vm.print.date_range.startDate).format('YYYY-MM-DD'),
          end_date: a4Moment(vm.print.date_range.endDate).format('YYYY-MM-DD'),
          user: vm.selected_user
    })
    }

    vm.getAllLogUsers = function () {
      RolesService.getAllLogUsers()
        .then(function (response) {
          vm.users_filter = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error("Erro ao listar usuários.", 'A4 Web');
          $rootScope.show_loader = false;
        })
    };

    vm.studentsPictures = function () {
      ReportsService.reportFactory('GET',
        'api/reports/studentspicturesreport',
        {
          group_id: angular.isDefined(vm.print.group_selected.id)?vm.print.group_selected.id:0,
          course_id: vm.print.course_selected.id
        })
    }

    vm.printFinalResult = function (period) {
      ReportsService.reportFactory('GET',
        'api/reports/finalresults',
        {
          period: period,
          group_id: vm.print.group_selected,
          course_id: vm.print.course_selected.id,
          secretary_name: vm.secretary_name,
          school_days: vm.school_days,
          header: vm.header_final_results,
          observation: vm.observations_final_results,
          print_dependency:vm.print_dependency,
          print_caption: vm.print_caption,
          date: moment(vm.date_selected).format('YYYY-MM-DD'),
          alias_subject: vm.alias_subject,
          school_period_id: vm.school_period
        });
    };

    vm.printApprovedOrDisapprovedByGroup = function() {
      ReportsService.reportFactory('GET',
        'api/reports/studentsapprovedbygroup',
        {
          token:vm.conf.token,
          user_id: vm.conf.user_id,
          course_id: vm.print.course_selected.id,
          group_id: vm.print.group_selected.id,
          option: vm.approvedDisapproved
        });
    };

    vm.printStudentsPaymentPlans = function() {
      ReportsService.reportFactory('GET',
        'api/reports/studentspaymentplansreport',
        {
          token:vm.conf.token,
          enrolment_status_id: vm.print.enrolment_status_selected,
          user_id: vm.conf.user_id,
          course_id: vm.print.course_selected.id,
          group_id:  angular.isDefined(vm.print.group_selected.id)?vm.print.group_selected.id:0,
          payment_plan_id: vm.print.payment_plan_selected,
          only_active_contracts: vm.only_active_contracts
        }).then(function(response) {
         Common.Toast.success('Relatório impresso com sucesso!')
         }).catch(function(error) {
          Common.Toast.error('Não há alunos para os filtros selecionados.')
          // Se não houver alunos, o catch será acionado
         })
    };

    vm.printApprovedOrDisapproved = function() {
      ReportsService.reportFactory('GET',
        'api/reports/studentsapproveddisapproved',
        {
          course_id: vm.print.course_selected.id,
          group_id: vm.group_selected_report,
          grade_rule_item: vm.grade_rule_item,
          option: vm.approvedDisapproved
        });
    };

     vm.printFrequencyDiary = function() {
       ReportsService.reportFactory('GET',
         'api/reports/frequencydiary',
         {
           course_id: vm.print.course_selected.id,
           group_id: vm.group_selected_report,
           selected_month: vm.selectedMonth,
           subject_id: vm.subject_selected_report,
           dont_print_days: vm.dont_print_days,
           hide_defaulters: vm.hide_defaulters,
           show_non_regular_student: vm.show_non_regular_student,
           show_month_days: vm.show_month_days,
           hide_teacher_and_subject: vm.hide_teacher_and_subject,
           hide_disciplines: vm.hide_disciplines
         })
     }

    vm.printAnnualFrequencyDiary = function() {
      ReportsService.reportFactory('GET',
        'api/reports/annualfrequencydiary',
        {
          course_id: vm.print.course_selected.id,
          group_id: vm.group_selected_report,
          subject_id: vm.subject_selected_report
        })
    }

     vm.printStudentNotebook = function () {
       var requestData = {
         selected_subject: vm.subject_selected_report
       };

       if (vm.selected_student_report) {
         requestData.student_id = vm.selected_student_report.id;
       }

       if (vm.print.course_selected) {
         requestData.course_id = vm.print.course_selected.id;
       }

       if (vm.print.group_selected) {
         requestData.group_id = vm.print.group_selected;
       }

       ReportsService.reportFactory('GET',
         'api/reports/studentnotebook', requestData)
     }

    vm.clearSelectionsOfNotebook = function() {
      // Limpar modelos associados às seleções
      vm.print.course_selected = null;
      vm.print.group_selected = null;
      vm.selected_student_report = null;
      vm.subject_selected_report = null;
      vm.searchText = null;
      vm.subjects_course = null;
    };

     vm.printStudentsCanceled = function () {
       ReportsService.reportFactory('GET',
         'api/reports/studentscanceled',
         {
           company: vm.conf.current_company,
           group_id: vm.group_selected_report.id,
           course_id: vm.print.course_selected.id,
           matrix_period: vm.group_selected_report.matrix_period,
           start_date: a4Moment(vm.print.date_range.startDate).format('YYYY-MM-DD'),
           end_date: a4Moment(vm.print.date_range.endDate).format('YYYY-MM-DD'),
           connection: vm.conf.current_connection,
           user_id: vm.conf.user_id,
           current_school_period: vm.school_period
         }).then(function(response) {
         Common.Toast.success('Relatório impresso com sucesso!')
         }).catch(function(error) {
           if(error.status === 404 ) {
              Common.Toast.error('Não há alunos para os filtros selecionados.')
           }
         })
     }

     vm.printGradeRuleDiary = function() {
      ReportsService.reportFactory('GET',
        'api/reports/graderulediary',
        {
          token: vm.conf.token,
          company: vm.conf.current_company,
          connection: vm.conf.current_connection,
          course_id: vm.print.course_selected.id,
          group_id: vm.group_selected_report.id,
          matrix_period: vm.group_selected_report.matrix_period,
          subject_id: vm.subject_selected_report,
          user_id: vm.conf.user_id,
          option: vm.gradeRuleDiaryOption,
          current_school_period: vm.school_period,
          hide_defaulters: vm.hide_defaulters  
        }
      ).then(function () {
        Common.Toast.success('Relatório impresso com sucesso!')
      }).catch(function() {
        Common.Toast.error('Ocorreu um erro na impressão do relatório')
      })
     }


    vm.printreceiveprotocol = function () {
      ReportsService.reportFactory('GET',
        'api/reports/printreceiveprotocol',
      {
        user_id: vm.conf.user_id,
        group_id_period: vm.print.group_selected.group_id_period,
        current_school_period: vm.school_period,
        course_id: vm.print.course_selected.id,
        show_inactive_groups: vm.show_inactive_groups,
        document_title: vm.documentTitle,
        enrolment_status:  vm.enrolment_status_selected
      })
    }


      vm.color = "#bbbbbb";
      vm.filterBoxColor = function () {
        if (vm.discount_option === '4') {
          return {'background-color': vm.color};
        }
      };

      /**
       * Define o número de tags por página, caso a etiqueta seja impressa pra um único aluno
       * */
      vm.getNumberOfTags = function (number_of_tags) {
        vm.number_of_tags = number_of_tags;
      }
      vm.getNumbers = function () {
          vm.number_list = [];
          for (var i = 1; i <= 100; i++) {
            vm.number_list.push(i)
          }
        return vm.number_list
      }

    vm.printLables  = function () {
      ReportsService.reportFactory('GET',
        'api/reports/studentstags',
        {
          filter_tag: vm.filterTag,
          number_of_tags: vm.number_of_tags,
          enrolment_period_id: angular.isDefined(vm.selected_student_report) && vm.selected_student_report !== null ?
            vm.selected_student_report.enrolment_period_id : 0,
          group_id: vm.print.group_selected !== null && angular.isDefined(vm.print.group_selected.id) ?
            vm.print.group_selected.id  : 0,
          course_id: angular.isDefined(vm.print.course_selected.id) ?
            vm.print.course_selected.id : null,
          tagWithPicture: vm.tagWithPicture,
          tag_option: vm.tagOption,
          tagWithCpfAndEmail:vm.tagWithCpfAndEmail
        })
    };


    vm.spec_config = function () {
      vm.getLableConfig();
      vm.advanced_options = !vm.advanced_options;
    };

    vm.getLableConfig = function() {
      $rootScope.show_loader = true;
      ReportsService.getLable()
        .then(function (response) {

          var lable = angular.isObject(response[0].config.lable) ?
            response[0].config.lable : JSON.parse(response[0].config.lable);

          vm.lable.a4 = lable.A4;
          vm.lable.letter = lable.letter;
          $rootScope.show_loader = false;
        })
    };

    vm.updateLablesConfig = function() {
      $rootScope.show_loader = true;
      ReportsService.updateLablesConfig(vm.lable)
        .then(function () {
          vm.getLableConfig();
          $rootScope.show_loader = false;
        });
    };


    vm.selectedMonth = null;
    vm.orderByBirthday = null;
    vm.printWithGroupsPerPage = false;

    vm.init();


    /**
     * Destroy todos as escutas do controlador
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    })
  }

  angular
    .module('app.educational.reports')
    .controller('ReportDetailController', ReportDetailController);

})();



(function () {
  'use strict';
  angular.module('app.educational.educational-reports-generation', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function EducationalReportsService(Restangular, CONFIG, Common, $http, $rootScope) {
    var vm = this;

    vm.getDataMonthlyFinancialReport = function (obj) {
      return Restangular.one('reports').one('monthlyfinancialflow').get(obj);
    };

    vm.getDefaultsReport = function (obj) {
      return Restangular.one('reports').one('defaults').get(obj);
    };

    vm.getIncomeTaxReport = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/incometax',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          var filename = obj.name + '.pdf';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": true
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;

    };

    vm.getPersonPayeeByName = function (query) {
      return Restangular.one('person').one('getpersonpayee').get(query);

    };

    return vm;
  }

  angular.module('app.educational.educational-reports-generation')
    .service('EducationalReportsService', EducationalReportsService)
})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.educational-reports-generation', {
        url: '/educational-reports-generation',
        public: false,
        abstract: true,
        templateUrl: 'app/educational/report-generation/index.html',
      })
      .state('private.educational.educational-reports-generation.all', {
        url: '/all',
        public: false,
        views: {
          'report-generation': {
            templateUrl: 'app/educational/report-generation/all.html',
            controller: 'EducationalReportsGenerationController',
            controllerAs: 'vm',
          }
        }
      })
  }

  angular
    .module('app.finance.finance-reports-generation')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {

    var role = 'report_generator_edu';
    var path = 'educational.reports';

    msNavigationService.saveItem('educational.educational-reports-generation', {
      title: 'Gerador de Relatórios',
      icon: 'icon-chart-line',
      state: 'private.educational.educational-reports-generation.all',
      weight: 997,
      auth: role,

      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.educational-reports-generation')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function EducationalReportsController($rootScope, PoliciesService, $window) {

    var vm = this;
    vm.windowHeight = $window.innerHeight - 64;
    $rootScope.show_loader = false;
    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

  }

  angular
    .module('app.educational.educational-reports-generation')
    .controller('EducationalReportsGenerationController', EducationalReportsController)
})();

(function () {
  'use strict';

  angular
    .module('app.educational.re-enrollment', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function SignContractEnrolmentResponsiblesController(CONFIG, $http, $rootScope, Common, ModalExtra, EnrolmentService,
                                                       ReportsService, Session, $sce, $mdDialog, LocalStorage, $filter) {

    var vm = this;
    vm.conf = {};
    vm.show_loader = false;
    vm.show_sign = false;
    vm.loading = false;
    vm.user = Session.getUser();
    vm.person = vm.user !== null && angular.isDefined(vm.user.person) ? vm.user.person : {email: 'email'};
    vm.person.email = vm.person.email === null || angular.isUndefined(vm.person.email) ? vm.user.email : vm.person.email;
    vm.companies = LocalStorage.get(CONFIG.storage.companies);
    vm.config = angular.isDefined(vm.companies) && vm.companies !== null ? $filter('filter')(vm.companies, {id: Session.getCurrentCompany()})[0].config : null;

    // Detect if the device is Android
    vm.isAndroid = /Android/i.test(navigator.userAgent);
    
    vm.init = function () {
      vm.student = ModalExtra;
      vm.student.content = null;
      vm.person.content = vm.student.content;
      if (angular.isDefined(vm.student.artifact_id) && vm.student.artifact_id !== null && vm.student.extension !== 'html'){
        vm.show_sign = true;
      }
      if (angular.isDefined(vm.student.config) && vm.student.config !== null) {
        vm.config = vm.student.config;
        vm.person = angular.copy(vm.student);
      }
      vm.getContract();
    };

    // Carrega a biblioteca PDF.js se ainda não estiver carregada
    vm.loadPdfLibrary = function() {
      return new Promise(function(resolve) {
        if (window.pdfjsLib) {
          resolve(window.pdfjsLib);
          return;
        }

        // Carregar PDF.js da CDN
        var script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.9.359/pdf.min.js';
        script.onload = function() {
          // Configurar worker
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.9.359/pdf.worker.min.js';
          resolve(window.pdfjsLib);
        };
        document.head.appendChild(script);
      });
    };

    vm.getContract = function () {
      vm.show_loader = true;
      vm.pdfLoaded = false;

      // Carregar a biblioteca PDF.js primeiro
      vm.loadPdfLibrary().then(function() {
        // Agora buscar o PDF
        $http({
          method: 'GET',
          url: CONFIG.webApiUri + 'api/reports/printenrolmentcontract?person_id=' + vm.student.student_id
            + (angular.isDefined(vm.student.group_id) ? ('&group_id=' + vm.student.group_id) : '')
            + (angular.isDefined(vm.student.school_period_id) ? ('&school_period_re_enrolment=' + vm.student.school_period_id) : '')
            + (angular.isDefined(vm.student.bill_serie_id) ? ('&bill_serie_id=' + vm.student.bill_serie_id) : ''),
          responseType: 'arraybuffer'
        })
          .then(function (response) {
            var data = response.data;
            var headers = response.headers();
            
            // Salvar o PDF como Blob
            vm.pdfBlob = new Blob([data], {type: headers['content-type']});
            var fileURL = window.URL.createObjectURL(vm.pdfBlob);
            
            // Usar o mesmo URL tanto para o iframe quanto para o PDF.js
            vm.student.content = $sce.trustAsResourceUrl(fileURL);
            vm.pdfBlobUrl = fileURL;
            vm.pdfLoaded = true;
            
            // Renderizar o PDF via PDF.js se estivermos no Android
            if (vm.isAndroid) {
              setTimeout(function() {
                vm.renderPdf(fileURL);
              }, 100);
            }
            
            vm.show_loader = false;
            $rootScope.show_loader = false;
          });
      });
    };

    vm.printEnrolmentContract = function()
    {
      vm.loading = true;
      EnrolmentService.printEnrolmentContract({
        person_id: vm.student.student_id,
        group_id: vm.student.group_id,
        school_period_id: vm.student.school_period_id
      })
        .then(function () {
          vm.loading = false;
          Common.Toast.success('Download concluído');
        })
    };

    /**
     * Fecha o modal
     */
    vm.closeModal = function () {
      $mdDialog.hide();
    };

    /**
     * Renderiza o PDF usando PDF.js
     */
    vm.renderPdf = function(pdfUrl) {
      if (!pdfUrl || !window.pdfjsLib) return;
      
      var pdfContainer = document.getElementById('pdf-container-android');
      if (!pdfContainer) return;
      
      // Limpar container
      while (pdfContainer.firstChild) {
        pdfContainer.removeChild(pdfContainer.firstChild);
      }
      
      // Carregar o documento PDF
      window.pdfjsLib.getDocument(pdfUrl).promise.then(function(pdf) {
        // Definir as páginas iniciais para renderizar (aqui mostramos a primeira página)
        for (var pageNum = 1; pageNum <= Math.min(pdf.numPages, 2); pageNum++) {
          renderPage(pdf, pageNum, pdfContainer);
        }
      });
      
      function renderPage(pdf, pageNumber, container) {
        pdf.getPage(pageNumber).then(function(page) {
          // Calcular escala para ajustar à largura do container
          var containerWidth = container.clientWidth;
          var viewport = page.getViewport({scale: 1});
          var scale = containerWidth / viewport.width;
          viewport = page.getViewport({scale: scale});
          
          // Criar canvas para esta página
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          canvas.style.marginBottom = '10px';
          
          // Adicionar canvas ao container
          container.appendChild(canvas);
          
          // Renderizar a página no canvas
          page.render({
            canvasContext: context,
            viewport: viewport
          });
        });
      }
    };
    
    /**
     * Download and open PDF for Android devices
     * This creates a temporary download link and triggers it
     */
    vm.downloadAndOpenPdf = function() {
      if (!vm.pdfBlobUrl) return;
      
      // Create a temporary anchor element to trigger download
      var a = document.createElement('a');
      a.href = vm.pdfBlobUrl;
      a.download = 'contrato.pdf'; // Set filename for download
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      
      // Clean up
      setTimeout(function() {
        document.body.removeChild(a);
        Common.Toast.success('Download concluído. Agora abra o arquivo para visualizar o contrato.');
      }, 100);
    };

    vm.init();
  }

  angular.module('app.educational.re-enrollment')
    .controller('SignContractEnrolmentResponsiblesController', SignContractEnrolmentResponsiblesController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.re-enrollment', {
        public: false,
        url: '/re-enrollment',
        templateUrl: 'app/educational/re-enrollment/view.html',
        abstract: true
      })
      .state('private.educational.re-enrollment.show', {
        url: '/show',
        public: false,
        views: {
          'reEnrollment': {
            templateUrl: 'app/educational/re-enrollment/re-enrollment.html',
            controller: 'ReEnrolmentController',
            controllerAs: 'vm'
          }
        }
      })
  }

  angular
    .module('app.educational.re-enrollment')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService, Session) {
    msNavigationService.saveItem('educational.enrollment', {
      title: 'Matrícula online',
      icon: 'icon-school',
      state: 'private.educational.re-enrollment.show',
      weight: 6,
      hidden: function () {
        return !PoliciesService.isParent() || !Session.getContext().is_payee;
      }
    });
  }

  angular
    .module('app.educational.re-enrollment')
    .run(run);

})();





(function () {
  'use strict';

  function ReEnrolmentController($rootScope, a4Moment, Common, EnrolmentService, ModalFactory, ResponsiblesService,
                                 CONFIG, $http, $sce, ReportsService, LocalStorage, Session, $filter) {
    var vm = this;

    vm.date = {
      initial_date: null,
      final_date: null
    };
    vm.students = [];
    vm.allow_enrolment = false;
    vm.today = a4Moment();
    vm.year = Session.getCurrentSchoolPeriod().id;
    vm.has_pendences = 0;
    vm.companies = LocalStorage.get(CONFIG.storage.companies);
    vm.config = $filter('filter')(vm.companies, {id: Session.getCurrentCompany()})[0].config;
    vm.MATRICULA_CONDICIONAL = 1;
    vm.AGUARDANDO_ASSINATURA_ONLINE = 7;

    vm.init = function () {
      vm.getPaymentPendences();
      ReportsService.getToken()
        .then(function (token) {
          vm.token = token;
        });
    };

    /**
     * Retorna pendencias de pagamento para um responsável
     */
    vm.getPaymentPendences = function () {
      $rootScope.show_loader = true;
      EnrolmentService.getPaymentPendences('responsible')
        .then(function (response) {
          var pendences = response.pendences;
          $rootScope.show_loader = false;
          vm.has_pendences = angular.isUndefined(pendences) ? 0 : pendences;
          vm.getDatesForEnrolmentOnline();
        });
    };

    /**
     * Retorna as datas para re-matrícula online
     */
    vm.getDatesForEnrolmentOnline = function () {
      $rootScope.show_loader = true;
      EnrolmentService.getDatesForEnrolmentOnline()
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.date.initial_date = a4Moment(response.initial_date);
          vm.date.final_date = a4Moment(response.final_date);
          var initial_and_final_date_is_null = (vm.date.initial_date === null && vm.date.final_date === null);
          if (!initial_and_final_date_is_null &&
            !(vm.date.initial_date.isAfter(vm.today)) && !(vm.date.final_date.isBefore(vm.today))) {
            vm.allow_enrolment = true;
            vm.getStudentsForReEnrolment();
          }
        })
    };

    vm.getStudentsForReEnrolment = function () {
      $rootScope.show_loader = true;
      ResponsiblesService.getStudentsForReEnrolment()
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.students = response.plain();
        })
    };

    /**
     * Abre o modal de confirmação da matrícula
     * @param student
     */
    vm.confirmEnrolment = function (student) {
      ModalFactory.custom(
        'app/educational/re-enrollment/confirm-enrolment.html',
        {notes: vm.config, year: vm.year},
        false
      ).then(function () {
        vm.printEnrolmentContract(student);

      })
    };

    /**
     * Abre o modal para impressão de documentos
     * @param student
     */
    vm.openModal = function (student) {
      ModalFactory.customClean(
        'app/educational/re-enrollment/print-documents.html',
        'PrintDocumentsEnrolmentResponsiblesController',
        'vm',
        false,
        student
      )
    };

    /**
     * Realiza a impressão do formulário de matrícula do aluno
     */
    vm.printEnrolmentContract = function (student) {
      $rootScope.show_loader = true;
      ModalFactory.customClean(
        'app/educational/re-enrollment/contract.html',
        'SignContractEnrolmentResponsiblesController',
        'vm',
        false,
        student
      ).then(function () {
        $rootScope.show_loader = true;
        EnrolmentService.confirmEnrolmentOnline(student)
          .then(function () {
            $rootScope.show_loader = false;
            Common.Toast.success('Matrícula confirmada com sucesso');
            ModalFactory.custom(
              'app/educational/re-enrollment/confirm-message.html', vm.config)
              .then(function () {
                vm.openModal(student)
              });
            vm.getStudentsForReEnrolment();
          }).catch(function () {
          $rootScope.show_loader = false;
        })
      });

    };

    vm.init();

  }

  angular
    .module('app.educational.re-enrollment')
    .controller('ReEnrolmentController', ReEnrolmentController);

})
();

(function () {
  'use strict';

  /** @ngInject */
  function PrintDocumentsEnrolmentResponsiblesController(CONFIG, $http, $rootScope, Common, ModalExtra, EnrolmentService,
                                                         ReportsService, ContractService, LocalStorage, $filter, Session) {

    var vm = this;
    vm.conf = {};
    vm.show_loader = false;
    vm.companies = LocalStorage.get(CONFIG.storage.companies);
    vm.config = $filter('filter')(vm.companies, {id: Session.getCurrentCompany()})[0].config;

    vm.init = function () {
      vm.student = ModalExtra;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };

    /**
     * Realiza a impressão do boleto referente à primeira parcela das mensalidades
     */
    vm.printBankSlip = function () {
      vm.show_loader = true;
      EnrolmentService.printBankSlipEnrolment(vm.student.student_id, vm.student.school_period_id)
        .then(function () {
          vm.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          vm.show_loader = false;
          Common.Toast.warning(error.message);
        });
    };

    /**
     * Realiza a impressão do formulário de matrícula do aluno
     */
    vm.printEnrolmentForm = function () {
      ReportsService.reportFactory( 'GET','api/reports/printenrolmentform',
        {
          student_id: vm.student.student_id,
          school_period: vm.student.school_period_id,
          option: 1,
          group_student: vm.student.group_id

        })



      // vm.show_loader = true;
      // EnrolmentService.printEnrolmentForm({
      //   person_id: vm.student.student_id,
      //   school_period_id: vm.student.school_period_id,
      //   options: vm.wallet_orientation,
      //   token: vm.conf.token
      // })
      //   .then(function () {
      //     vm.show_loader = false;
      //     Common.Toast.success('Download concluído');
      //   })
      //   .catch(function (error) {
      //     vm.show_loader = false;
      //     Common.Toast.warning(error.data.message);
      //   });
    };
    /**
     * Realiza a impressão do formulário de matrícula do aluno
     */
    vm.printEnrolmentContract = function () {
      vm.show_loader = true;
      if(vm.config.enrolment_online_is_electronic_signature === false){
        EnrolmentService.printEnrolmentContract({
          person_id: vm.student.student_id,
          group_id: vm.student.group_id,
          school_period_id: vm.student.school_period_id
        })
          .then(function () {
            vm.show_loader = false;
            Common.Toast.success('Download concluído');
          })
          .catch(function (error) {
            vm.show_loader = false;
            Common.Toast.warning(error.data.message);
          });
      } else{
        ContractService.printDocument(vm.student.bill_serie_id)
          .then(function () {
            vm.show_loader = false;
            Common.Toast.success('Download concluído');
          })
          .catch(function (error) {
            vm.show_loader = false;
            Common.Toast.warning(error.data.message);
          });
      }
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular.module('app.educational.re-enrollment')
    .controller('PrintDocumentsEnrolmentResponsiblesController', PrintDocumentsEnrolmentResponsiblesController)
})();

(function () {
  'use strict';

  angular.module('app.educational.persons', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.persons', {
        url: '/persons/',
        public: false,
        templateUrl: 'app/educational/persons/views/index.html',
        controller: 'EducationalPersonsController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.educational.persons')
    .config(routerConfig);
})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'aluno_menu';
    var path = 'secretary.persons';
    var current_profile = PoliciesService.currentProfile();
    var hidden = (current_profile === 7);

    msNavigationService.saveItem(path, {
      title: 'Pessoas',
      icon: 'icon-account',
      state: 'private.educational.persons',
      weight: 5,
      auth: role,
      hidden: function () {
        return hidden;
      }
    });
  }

  angular
    .module('app.educational.persons')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function EducationalPersonsController(){

  }

  angular.module('app.educational.persons')
    .controller('EducationalPersonsController', EducationalPersonsController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseService(Restangular) {

    /**
     * Razões de bloqueio de celula
     * @param blockCode - Codigo do bloqueio
     * @returns {*}
     */
    var blockReasons = function (blockCode) {
      switch (blockCode) {
        case 1:
          return 'Este evento para esta disciplina está configurado para lançamento agrupado (Ainda não implementado)'
        case 2:
          return 'Período de lançamento do evento ainda não foi informado';
        case 3:
          return 'Período de lançamento do evento ainda não iniciou';
        case 4:
          return 'Período de lançamento do evento está encerrado';
        case 5:
          return 'A nota não pode ser alterada porque o prazo já foi encerrado (Ainda não implementado)';
        case 6:
          return 'Condicional do evento não atendido (Ainda não implementado)';
        case 7:
          return 'Conselho de classe indevido (não precisa de conselho) (Ainda não implementado)';
      }
    };

    /**
     * Retorna as disciplinas da turma que o aluno está matriculado
     * @returns array
     */
    var getStudentsSubjects = function (obj) {
      return Restangular.one('students').one('getstudentssubject').get(obj);
    };

    /**
     * Retorna os estudantes pelo agrupamento
     * @returns array
     */
    var getStudentsBySubjectGroup = function (obj) {
      return Restangular.one('grade').one('getstudentsbysubjectgroup').get(obj);
    };

    /**
     * Retorna as disciplinas que possuem matrícula
     * @returns array
     */
    var getAllEnrolmentSubjects = function (obj) {
      return Restangular.one('grade').one('getallenrolmentsubjects').get(obj);
    };

    /**
     * Retorna as turmas que possuem matrícula
     * @returns array
     */
    var getAllEnrolmentGroups = function (obj) {
      return Restangular.one('grade').one('getallenrolmentgroups').get(obj);
    };

    var saveNotes = function (obj) {
      return Restangular.all('grade').post(obj);
    };

    var setPrecision = function (value, precision) {
      return parseFloat(value).toFixed(precision);
    };

    /**
     * Formata uma string com o nome do evento e descrição
     * @param items
     * @returns {*}
     */
    var formatEventNameDescription = function (items) {
      items.forEach(function (item) {
        item.name = item.name + ' | ' + item.description;
      });
      return items;
    };

    return {
      getStudentsSubjects: getStudentsSubjects,
      getStudentsBySubjectGroup: getStudentsBySubjectGroup,
      getAllEnrolmentSubjects: getAllEnrolmentSubjects,
      getAllEnrolmentGroups: getAllEnrolmentGroups,
      saveNotes: saveNotes,
      getReasons: blockReasons,
      setPrecision: setPrecision,
      formatEventNameDescription: formatEventNameDescription
    };
  }

  angular
    .module('app.educational.note-release')
    .factory('NoteReleaseService', NoteReleaseService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.note-release', {
        public: false,
        url: '/note-release',
        templateUrl: 'app/educational/note-release/views/note-release-page.html',
        abstract: false
      })
      .state('private.educational.note-release.list', {
        url: '/list',
        public: false,
        views: {
          'note-release': {
            templateUrl: 'app/educational/note-release/views/note-release.html',
            controller: 'NoteReleaseController',
            controllerAs: 'vm'
          },
          'subjects@private.educational.note-release.list': {
            templateUrl: 'app/educational/note-release/subjects/views/note-release-subjects.html',
            controller: 'NoteReleaseSubjectsController',
            controllerAs: 'vm'
          },
          'groups@private.educational.note-release.list': {
            templateUrl: 'app/educational/note-release/groups/views/note-release-groups.html',
            controller: 'NoteReleaseGroupsController',
            controllerAs: 'vm'
          },
          'grouping@private.educational.note-release.list': {
            templateUrl: 'app/educational/note-release/grouping/views/note-release-grouping.html',
            controller: 'NoteReleaseGroupingController',
            controllerAs: 'vm'
          },
          'students@private.educational.note-release.list': {
            templateUrl: 'app/educational/note-release/students/views/note-release-student.html',
            controller: 'NoteReleaseStudentsController',
            controllerAs: 'vm'
          },
          'council@private.educational.note-release.list': {
            templateUrl: 'app/educational/note-release/council/views/note-release-council.html',
            controller: 'NoteReleaseCouncilController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.note-release')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'nota_menu';
    var path = 'secretary.note-release';
    msNavigationService.saveItem(path, {
      title: 'Lançamento de Nota',
      icon: 'icon-pen',
      auth: role,
      state: 'private.educational.note-release.list',
      weight: 2,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });

  }

  angular
    .module('app.educational.note-release')
    .run(run);

})();



(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseDirective(Common, NoteReleaseCharactersAllowedService) {
    return {
      restrict: "A",
      required: '[^ngModel]',
      scope: {
        ngModel: '=ngModel',
        hasCodeRule: '=?',
        noteReleaseHasCouncil: '=?',
        noteReleaseCodes: '=?',
        noteReleaseItem: '=?',
        noteReleaseMaskPrecision: '=?',
        noteReleaseMaskMaxNumber: '=?'
      },
      link: function ($scope, elem) {
        $scope.$watch('ngModel', function (current, old) {
          if (old !== null && $scope.hasCodeRule && $scope.ngModel !== '' && angular.isString(old) &&
            ((!isNaN(current) && current.toString().indexOf('.') !== -1) || angular.isUndefined(current))) {
            $scope.ngModel = old;
            $scope.$applyAsync();
          }
        });
        elem.bind('keypress', function (event) {
          /** Verifica alguns caracteres invalidos */
          if (event.key === '-' || event.key === '+' || event.key === '*' || event.key === '/') {
            event.preventDefault();
          }
        });

        elem.bind('keyup', function (event) {
          /** Caso o campo tenha critério de conceito */
          if ($scope.hasCodeRule) {

            //46 (delete) 8 (backspace)
          if (event.keyCode !== 8 && event.keyCode !== 46) {         
           if ($scope.ngModel !== '') {
              var concept = NoteReleaseCharactersAllowedService.verify($scope.ngModel,
                $scope.noteReleaseMaskPrecision, $scope.noteReleaseCodes, $scope.noteReleaseHasCouncil);
              if (concept === null) {
                $scope.ngModel = null;
              } else {
                /** Se for apenas uma string, então, o valor é posto no modelo */
                if (angular.isString(concept)) {
                  $scope.ngModel = concept;
                } /** Se não, é um objeto de critério de conceito */
                else {
                  $scope.noteReleaseItem['value'] = concept.limit;
                  if ($scope.ngModel !== $scope.noteReleaseItem['value']) {
                    $scope.ngModel = concept.code;
                  }
                }
              }
            } else {
              $scope.noteReleaseItem.value = null;
              $scope.ngModel = null;
            }
          }

            /** Verifica se um $digest já está em progresso, caso não esteja, então é lançado um $apply(); */
            if (!$scope.$$phase) {
              $scope.$apply();
            }

          } else {
            /** Se valor for maior que o definido no noteReleaseMaskMaxNumber então ele apaga no número do input */
            if (angular.isDefined($scope.noteReleaseMaskMaxNumber)
              && parseFloat($scope.ngModel) > parseFloat($scope.noteReleaseMaskMaxNumber)) {
              $scope.ngModel = null;
              Common.Toast.warning('Nota máxima permitida: ' +
                parseFloat($scope.noteReleaseMaskMaxNumber).toFixed(parseInt($scope.noteReleaseMaskPrecision)));
            } else
            /** Se a coluna contém conselho de classe, então não pode aceitar FN DP SR */
            if (angular.isDefined($scope.noteReleaseHasCouncil) && $scope.noteReleaseHasCouncil) {
              if (NoteReleaseCharactersAllowedService.isChar($scope.ngModel)) {
                $scope.ngModel = null;
              } else {
                $scope.ngModel = NoteReleaseCharactersAllowedService.verify($scope.ngModel, $scope.noteReleaseMaskPrecision);
              }
            } else {
              $scope.ngModel = NoteReleaseCharactersAllowedService.verify($scope.ngModel, $scope.noteReleaseMaskPrecision);

            }


            /** Verifica se um $digest já está em progresso, caso não esteja, então é lançado um $apply(); */
            if (!$scope.$$phase) {
              $scope.$apply();
            }

          }

        });

        elem.bind('keydown', function (event) {
          switch (event.which) {
            /** Seta para a esquerda */
            case 37:
              if (angular.element(elem).closest('td').find('input').length > 1
                && angular.element(elem)[0].type === 'number') {
                angular.element(elem).closest('td').find('input').first().focus()
              } else {
                angular.element(elem).closest('td').prev().find('input').last().focus();
              }
              /*angular.element(elem).closest('td').prev().find('input').focus();*/
              break;
            /** Seta para cima */
            case 38:
              angular.element(elem).closest('tr').prev()
                .find('td:eq(' + angular.element(elem).closest('td').index() + ')').find('input').first().focus();
              break;
            /** Seta para a direita */
            case 39:
              if (angular.element(elem).closest('td').find('input').length > 1
                && angular.element(elem)[0].type === 'text') {
                angular.element(elem).closest('td').find('input').last().focus()
              } else {
                angular.element(elem).closest('td').next().find('input').first().focus();
              }
              break;
            /** Seta para baixo */
            case 40:
              angular.element(elem).closest('tr').next()
                .find('td:eq(' + angular.element(elem).closest('td').index() + ')').find('input').first().focus();
              break;
            /** Enter */
            case 13:
              angular.element(elem).closest('tr').next()
                .find('td:eq(' + angular.element(elem).closest('td').index() + ')').find('input').first().focus();
              break;
          }
        })
      }
    };
  }

  angular
    .module('app.educational.note-release')
    .directive('noteReleaseMask', NoteReleaseDirective)

})();

(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseController(ClassGroupingService, PoliciesService) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.floatButton = null;
    vm.show_grouping = true;

    vm.subjects = [];
    vm.event_selected = [];
    vm.selectAllEvent = false;
    vm.listStudents = [];
    vm.listStudentsSelected = null;
    vm.buttons = {
      submit: true,
      group: false,
      allowGroup: false
    };

    vm.init = function () {
      vm.filterRelease = 'student';
      vm.checkIdentifier();
      // vm.filterRelease = 'council';
    };

    /**
     * Realiza o limpeza dos objetos
     */
    vm.clear = function () {
      vm.subject_selected = null;
      vm.student_selected = null;
      vm.group_selected = null;
      vm.event_selected = null;
      vm.students = null;
      vm.subjects = null;
      vm.grid.grades = [];
      vm.grid.students = [];
    };

    /**
     * Verifica se o usuário logado é um professor e se ele possui agrupamento
     * @returns {boolean}
     */
    vm.checkIdentifier = function () {
      if(PoliciesService.isTeacher()){
        ClassGroupingService.getGradeGroupingForTeacher()
          .then(function (response) {
            if(response.plain().length === 0){
              vm.show_grouping = false;
            }
          });
      }
    };


    vm.init();
  }

  angular
    .module('app.educational.note-release')
    .controller('NoteReleaseController', NoteReleaseController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseGroupController($rootScope, $scope, Common, ModalExtra) {
    var vm = this;

    vm.new_note = null;

    vm.init = function () {
      vm.event = ModalExtra.event;
      vm.grades = ModalExtra.grades;
      vm.students = ModalExtra.students;
      vm.all_students = ModalExtra.all_students;
    };

    /**
     * Formata o valor não conceitual da nota para que seja decimal
     * @param value
     * @param maxValue
     * @returns {string}
     */
    vm.formatNote = function (value, maxValue) {
      var new_value = parseFloat(parseFloat(value).toFixed(2));
      var new_maxValue = parseFloat(parseFloat(maxValue).toFixed(2));
      if (!angular.isString(new_value)) {
        if (parseFloat(parseFloat(new_value).toFixed(2)) > parseFloat(parseFloat(new_maxValue).toFixed(2))) {
          Common.Toast.warning('Valor máximo permitido: ' + maxValue);
          $scope.formNoteReleaseGroup.note.$setValidity('pattern', true);
        }
      }
    };

    /**
     * Filtra os eventos de acordo com o selecionado pelo usuário
     */
    vm.filterEvents = function () {
      return vm.grades.filter(function (grade) {
        if (vm.event !== null) {
          return vm.event.indexOf(grade.name) !== -1;
        }
      });
    };

    /**
     * Filtra os eventos de acordo com o selecionado pelo usuário
     */
    vm.filterStudents = function () {
      return vm.all_students.filter(function (grade) {
        if (vm.students !== null) {
          return vm.students.indexOf(grade.person_id) !== -1;
        }
      });
    };

    /**
     * Retorna o valor desejado das definições da grade
     * @param id
     * @param field - campo desejado
     */
    vm.getValue = function (id, field) {
      var index = vm.findIndexGrades(id);

      if (index >= 0) {
        return vm.grades[index][field];
      }
    };

    /**
     * Encontra o índice dos eventos
     * @param id
     */
    vm.findIndexGrades = function (id) {
      return vm.grades.indexOf(vm.grades.filter(function (i) {
          return i.name === id
        })[0]
      );
    };


    /**
     * Encontra o índice do estudante
     * @param id
     */
    vm.findIndexStudent = function (id) {
      return vm.all_students.indexOf(vm.all_students.filter(function (i) {
          return i.person_id === id
        })[0]
      );
    };

    vm.submit = function () {
      if (angular.isDefined(vm.new_note)) {
        if (ModalExtra.is_grouping_release){
          vm.event = vm.event[0].split(' |')[0];
        }
        angular.forEach(vm.students, function (i) {
          var indexStudent = vm.findIndexStudent(i)
          if (indexStudent !== -1) {
            if (ModalExtra.is_grouping_release) {
              vm.all_students[indexStudent].grade_json[vm.event].valueGrouping = parseFloat(vm.new_note);
              $rootScope.$broadcast('note-release.group.log', {
                new_grade: parseFloat(vm.new_note),
                old_grade: vm.all_students[vm.findIndexStudent(i)].grade_json[vm.event].valueGrouping,
                student: vm.all_students[vm.findIndexStudent(i)],
                item: vm.event
              });
            } else {
              vm.all_students[indexStudent].grade_json[vm.event].valueTeacher = parseFloat(vm.new_note);
              $rootScope.$broadcast('note-release.group.log', {
                new_grade: parseFloat(vm.new_note),
                old_grade: vm.all_students[vm.findIndexStudent(i)].grade_json[vm.event].value,
                student: vm.all_students[vm.findIndexStudent(i)],
                item: vm.event
              });
            }
          }
        });
        $rootScope.$broadcast('note-release.group', vm.all_students);
        vm.close();
      } else {
        Common.Toast.warning('Nota inválida');
      }
    };

    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular
    .module('app.educational.note-release')
    .controller('NoteReleaseGroupController', NoteReleaseGroupController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function NoteReleaseCharactersAllowedService($filter) {

    var original_allowed_characters = ['F', 'D', 'S', 'FN', 'DP', 'SR'];
    var allowed_characters = ['F', 'D', 'S', 'FN', 'DP', 'SR'];

    var allowed_numbers = /^(\d\.)|(\d\.\d|\d)/g;

    /**
     * Executa verificações de critério de conceito, e conselho de classe.
     * @param value - Valor digitado
     * @param precision - Precisão do campo, ou seja, decimais permitidos
     * @param code_rule - lista de critérios de conceito, caso haja
     * @param has_council - Se tem ou não conselho de classe;
     * @returns {*}
     */
    var verify = function (value, precision, code_rule, has_council) {

      var value = value + '';

      code_rule = angular.isUndefined(code_rule) ? null : code_rule;
      has_council = angular.isUndefined(has_council) ? null : has_council;
      var new_value = parseFloat(value);

      /** Verifica se o valor digitado é numérico */
      if (angular.isNumber(new_value) && !isNaN(new_value)) {
        /** Se EVENTO tiver critério de conceito não deve permitir digitar numéros*/
        if (code_rule !== null && value !== null) {
          return null;
        } else {
          /** Tratamento de decimais */
          var split = value.split('.');
          if (angular.isDefined(split[1])) split[1] = split[1].substring(0, precision);
          split = split.join('.');
          /** Não realiza o match se o usuário digitar um ., supondo que irá completar o dígito do número em seguida */
          if (!angular.isArray(split) && split.slice(-1) !== '.') {
            var result = split.match(allowed_numbers);
          } else {
            result = split;
          }
          return angular.isArray(result) ? result.join('') : result;
        }

      } else {

        /** Se EVENTO tiver critério de conceito */
        if (code_rule !== null && value !== null) {

          /** Se EVENTO tiver critério de conceito e NÃO tem conselho de classe */
          if (has_council !== null && !has_council) {

            /** Insere letras do critério de conceito como letras permitidas para digitação */
            setCodeRuleAsAllowedChars(code_rule);

            /** Busca o valor digitado na lista de valores permitidos */
            var founded = find(allowed_characters, value);
            /** Se for um valor não permitido */
            if (angular.isUndefined(founded) || founded === null) {
              /** Então buscará o mesmo valor nos critérios de conceito */
              var founded_hot_key = $filter('filter')(code_rule, value)[0];
              /** Se existir no critério de conceito, então é retornado. */
              if (angular.isDefined(founded_hot_key)) {
                return founded_hot_key;
              }

            } else {
              /** Filtros para verificar se o caracter digitado corresponde a algum do critério */
              if (value.length == 1) {
                var founded_code = $filter('filter')(code_rule, function(item) {
                // Verifica se 'hotkeys' está presente no item
                return item.hot_key && founded.indexOf(item.hot_key) !== -1;
              })[0];
              }

              /** Se não achar um critério de conceito valido, então significa nesta parte do código, que
               * é uma das combinações: FN, DP, SR. Sendo assim, o mesmo é retornado */
              if (angular.isUndefined(founded_code)) {
                if (founded == 'F') {
                  founded = 'FN';
                } else if (founded == 'D') {
                  founded = 'DP'
                } else if (founded == 'S') {
                  founded = 'SR'
                }

                return founded;
              }
              return founded_code;

            }
          } else {
            /** Filtros para verificar se o caracter digitado corresponde a algum do critério */
            var founded_code = $filter('filter')(code_rule, {code: value.toUpperCase()})[0];
            var founded_hot_key = $filter('filter')(code_rule, {hot_key: value.toUpperCase()})[0];

            if (angular.isUndefined(founded_code) && angular.isDefined(founded_hot_key)) {
              return founded_hot_key;
            } else if (angular.isDefined(founded_code)) {
              return founded_code;
            }
          }

        } else {
          var founded = find(allowed_characters, value);
        }

        return angular.isUndefined(founded) ? null : founded;
      }
    };

    /**
     * Insere as letras do critério de conceito como letras permitidas.
     * @param array - Lista de letras do critério.
     */
    var setCodeRuleAsAllowedChars = function (array) {
      allowed_characters = original_allowed_characters;
      array.forEach(function (item) {
        allowed_characters.push(item.hot_key.toUpperCase());
      });
    };

    /**
     * Realiza uma busca em um array passado como parametro.
     * @param array - Lista
     * @param value - Valor para procurar na lista.
     */
    var find = function (array, value) {
      return allowed_characters.find(function (item) {
        if (angular.isDefined(value) && value != null) {
          return item === value.toUpperCase();
        }
      });
    };

    /**
     * Verifica se o valor é uma STRING
     * @param value
     * @returns {*|boolean}
     */
    var isChar = function (value) {
      return angular.isString(value) && (angular.isNumber(parseFloat(value)) && isNaN(parseFloat(value)));
    };


    return {
      verify: verify,
      isChar: isChar
    };
  }

  angular
    .module('app.educational.note-release')
    .factory('NoteReleaseCharactersAllowedService', NoteReleaseCharactersAllowedService)

})();
(function() {
    'use strict';
    angular
        .module('app.educational.lesson-plan', []);
})();

(function () {
  'use strict';

  /** @ngInject*/

  function LessonPlanService(Restangular) {
    var vm = this;

    vm.getAll = function (obj) {
      return Restangular.one('lessonplan').get(obj);
    };

    vm.createLessonPlan = function (obj) {
      return Restangular.all('lessonplan').post(obj);
    };

    vm.updateLessonPlan = function (obj) {
      return Restangular.one('lessonplan', obj.id).customPUT(obj);
    };

    vm.deleteLessonPlan = function (id) {
      return Restangular.one('lessonplan', id).remove();
    };

    vm.getCoursesForPlan = function (obj) {
      return Restangular.one('lessonplan').one('getcoursesforplan').get(obj);
    };

    vm.getSubjectsByCourse = function (obj) {
      return Restangular.one('lessonplan').one('getsubjectscourse').get(obj);
    };

    vm.getById = function (obj) {
      return Restangular.one('lessonplan', obj.lesson_plan_id).get(obj);
    };

    vm.updateLessonPlan = function (obj) {
      return Restangular.one('lessonplan', obj.id).customPUT(obj);
    };

    vm.getGroupsToApplyLessonPlan = function (obj) {
      return Restangular.one('lessonplan').one('getgroupsapply').get(obj);
    };

    vm.applyLessonPlanToClass = function (obj) {
      return Restangular.one('lessonplan').all('applytogroup').post(obj);
    };

    vm.reapplyLessonPlanToClass = function (obj) {
      return Restangular.one('lessonplan').all('reapplytogroup').post(obj);
    }

    vm.deleteLessonPlan = function (id) {
      return Restangular.one('lessonplan', id).remove();
    };

    vm.createLessonPlanItem = function (obj) {
      return Restangular.all('lessonplanitem').post(obj);
    };

    vm.getInfoForm = function (obj) {
      return Restangular.one('lessonplanitem').one('getinfo').get(obj);
    };

    vm.createLessonPlanItem = function (obj) {
      return Restangular.all('lessonplanitem').post(obj);
    };

    vm.updateLessonPlanItem = function (obj) {
      return Restangular.one('lessonplanitem', obj.id).customPUT(obj);
    };

    vm.getLessonPlanItemArtifact = function (lesson_plan_item_id) {
      return Restangular.one('lessonplanitem', lesson_plan_item_id).one('getfiles').get();
    };

    vm.removeLessonPlanItem = function (obj) {
      return Restangular.one('lessonplanitem', obj.lesson_plan_id).remove(obj);
    };

    return vm;
  }

  angular
    .module('app.educational.lesson-plan')
    .factory('LessonPlanService', LessonPlanService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.lesson-plan', {
        public: false,
        url: '/lesson-plan',
        templateUrl: 'app/educational/lesson-plan/views/lesson-plan.html',
        abstract: true
      })
      .state('private.educational.lesson-plan.list', {
        url: '/list',
        public: false,
        views: {
          'lesson-plan': {
            templateUrl: 'app/educational/lesson-plan/views/list.html',
            controller: 'LessonPlanController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.lesson-plan.edit', {
        url: '/:id/:course_id/:subject_id/view',
        public: false,
        params: {
          course_id: null,
          subject_id: null
        },
        views: {
          'lesson-plan': {
            templateUrl: 'app/educational/lesson-plan/views/lesson-plan-page.html',
            controller: 'LessonPlanEditController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.lesson-plan')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'plano_aula';
    var path = 'coordination.lesson-plan';

    msNavigationService.saveItem(path, {
      title: 'Plano de Aulas',
      icon: 'icon-book-multiple',
      state: 'private.educational.lesson-plan.list',
      auth: role,
      weight: 2,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.groups')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function LessonPlanController($a4FloatButton, $rootScope, $scope, $state, CourseService,
                                LessonPlanService, PoliciesService, SubjectService,
                                ModalFactory, Common) {

    var vm = this;
    vm.grid = {};
    vm.course_id = null;
    vm.subject_id = null;

    vm.init = function () {
      vm.teacherID = $state.params.id;
      vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.addPlan()', theme: 'educational'});
      vm.paginate();
    };

    /**
     * Listagem de planos
     * @param limit
     * @param page
     */
    vm.paginate = function (page, limit, course_id, subject_id) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 20;
      page = angular.isDefined(page) ? page : 1;
      vm.grid.promise = LessonPlanService.getAll({
        limit: limit,
        page: page,
        teacher_id: vm.teacherID,
        course_id: angular.isDefined(course_id) ? course_id : vm.course_id,
        subject_id: angular.isDefined(subject_id) ? subject_id : vm.subject_id
      })
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [20, 40, 80, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        })
    };


    /**
     * Exclusão de um plano
     * @param id
     */
    vm.delete = function (id) {
      ModalFactory.confirm(null, "Deletar plano de aula", "Tem certeza que deseja deletar este plano de aula?", "Confirmar", "Cancelar",
        "educational").then(function () {
        LessonPlanService.deleteLessonPlan(id).then(function (response) {
          Common.Toast.success("Plano de aula deletado com sucesso!")
          vm.paginate();
        }).catch(function (response) {
          if (response.data === "HAS_LESSON_PLAN_ITEM_ASSOCIATED") {
            Common.Toast.error("O plano de aula possui aulas, não pode ser deletado!");
          } else {
            Common.Toast.error("Erro ao excluir plano de aula!");
          }
        })
      })
    };

    /**
     * Ações do grid
     * @param plan
     * @param option
     */
    vm.clickActions = function (plan, option) {
      switch (option) {
        case 'edit':
          vm.editPlan(plan);
          break;
        default:
          break;
      }
    };

    /**
     * Vai para a página de visualização das aulas do plano
     * @param plan
     */
    vm.viewPlan = function (plan) {
      $state.go('private.educational.lesson-plan.edit', {id: plan.id, course_id: plan.course_id,
        subject_id: plan.subject_id});
    };

    /**
     * Abre o modal para edição do nome do plano
     * @param obj
     */
    vm.editPlan = function (obj) {
      ModalFactory.customClean('app/educational/lesson-plan/views/modal-edit.html',
        'LessonPlanEditsController', 'vm', false, obj)
        .then(function( response ){
          if (response) {
            vm.paginate();
          }
        })
    };

    /**
     * Abre o modal para criação de um novo plano
     */
    vm.addPlan = function () {
      ModalFactory.customClean('app/educational/lesson-plan/views/modal-create.html',
        'LessonPlanCreateController', 'vm', false, {})
        .then(function (response) {
          if (response) {
            vm.paginate();
          }
        });
    };

    /**
     * Busca os cursos para o filtro
     * @returns {*}
     */
    vm.loadCourses = function () {
      return LessonPlanService.getCoursesForPlan()
        .then(function (courses) {
          vm.courses = courses;
        });
    };

    /**
     * Busca as disciplinas para o filtro
     * @returns {*}
     */
    vm.loadSubjects = function () {
      /**
       * Verifica se o filtro de curso está selecionado. Se não estiver, busca todas as disciplinas.
       * Se estiver, busca apenas as disciplinas do curso.
       */
      if (vm.course_id === null){
        return SubjectService.getAll()
          .then(function (subjects) {
            vm.subjects = subjects;
          });
      } else {
        return LessonPlanService.getSubjectsByCourse({course_id: vm.course_id})
          .then(function (subjects) {
            vm.subjects = subjects;
          });
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };
    vm.init();
  }

  angular
    .module('app.educational.lesson-plan')
    .controller('LessonPlanController', LessonPlanController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function LessonPlanEditController($rootScope, $scope, $state, $document, $a4FloatButton, a4Moment, CONFIG, Common, LessonPlanService,
                                    ReportsService, Session, ModalFactory, PoliciesService) {

    var vm = this;
    vm.grid = {
      rows: [],
      info: {}
    };

    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };

    vm.init = function () {
      if ($state.params.hasOwnProperty('id')) {
        vm.plan_id = $state.params.id;
        vm.plan = $state.params;
        vm.getLessonItems();
      }
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createItem()', theme: 'educational'});
    };

    vm.printLessonPlan = function () {
      var href = vm.webLink + 'api/lessonplan/' + vm.plan_id + '/printlessonplan?token=' + vm.conf.token + "&current_school_period=" +
        '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();
    };

    /**
     * Resgata o objeto referente ao plano de aulas
     * @param limit - limite de itens na lista
     * @param page - página da lista
     */
    vm.getLessonItems = function (page, limit) {
      limit = angular.isDefined(limit) ? limit : 30;
      page = angular.isDefined(page) ? page : 1;
      vm.grid.promise = LessonPlanService.getById({lesson_plan_id: vm.plan_id, limit: limit, page: page})
        .then(function (response) {
          vm.lesson_plan = response.lesson_plan;
          vm.lesson_plan_items = response.lesson_plan_items;
          vm.grid.rows = response.lesson_plan_items.data;
          vm.grid.info = {
            limit_options: [30, 60, 90, 120, {
              label: 'Todos',
              value: function () {
                return response.lesson_plan_items.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.lesson_plan_items.total
          };
          $rootScope.show_loader = false;
        })
    };

    vm.openModalSelectGroup = function () {
      LessonPlanService.getGroupsToApplyLessonPlan({
        course_id: vm.plan.course_id,
        subject_id: vm.plan.subject_id
      })
        .then(function (response) {
          ModalFactory.customClean('app/educational/lesson-plan/views/lesson-plan-apply-group.html',
            /** @ngInject */
            function (LessonPlanService, $mdDialog, ModalExtra) {
              var vm = this;
              vm.groups = ModalExtra;
              vm.group = {};
              vm.has_plan = false;

              vm.submit = function (selectedGroup) {
                $mdDialog.hide({selectedGroup: selectedGroup, has_plan: vm.has_plan});
              };

              vm.showWarningMessage = function (group) {
                if (angular.isDefined(group) && group.length > 0) {
                  group.forEach(function (item) {
                    if (item.has_plan) {
                      vm.has_plan = true;
                      return;
                    }
                  })
                }
              };

              vm.close = function () {
                $mdDialog.cancel();
              };
            }, 'vm',
            false, response.plain()).then(function (response) {
            if (response.has_plan) {
              vm.reapplyLessonPlanToClass(response.selectedGroup);
            } else {
              vm.applyLessonPlanToClass(response.selectedGroup);
            }
          });
        });
    };

    /**
     * Reaplica o plano de pagamento sobre uma turma
     * @param selectedGroups
     */
    vm.reapplyLessonPlanToClass = function (selectedGroups) {

      LessonPlanService.reapplyLessonPlanToClass({groups: selectedGroups, lesson_plan_id: vm.plan_id})
        .then(function () {
          Common.Toast.success("Plano reaplicado com sucesso!")
        })
        .catch(function (response) {
          Common.Toast.error(response.data.message);
        })
    };

    /**
     * Aplica o plano de pagamento sobre uma turma
     * @param selectedGroups
     */
    vm.applyLessonPlanToClass = function (selectedGroups) {
      LessonPlanService.applyLessonPlanToClass({groups: selectedGroups, lesson_plan_id: vm.plan_id})
        .then(function () {
          Common.Toast.success("Plano aplicado com sucesso!")
        })
        .catch(function (response) {
          Common.Toast.error(response.data.message);
        })
    };

    /**
     * Abre o modal para criação de novo planejamento de aula
     */
    vm.createItem = function () {
      ModalFactory.customClean('app/educational/lesson-plan/views/lesson-plan-item-modal.html',
        'LessonPlanItemCreateController', 'vm',
        true, {lesson_plan_id: vm.plan_id}).then(function (addAnother) {
        if (addAnother) {
          vm.createItem();
        }
        vm.getLessonItems();
      });
    };

    /**
     * Abre modal para edição do item do plano
     */
    vm.editPlanItem = function (item) {
      var edit = angular.copy(item);
      ModalFactory.customClean('app/educational/lesson-plan/views/lesson-plan-item-modal.html',
        'LessonPlanItemEditController', 'vm',
        true, {lesson_plan_item: edit}).then(function () {
        vm.getLessonItems();
      });
    };


    /**
     * Remove um item de plano de aulas
     * @param index - identificador do item
     * @param item - Item completo
     */
    vm.removePlanItem = function (index, item) {

      ModalFactory.confirm(null,
        "Excluir item de plano de aula de sequência " + item.lesson_sequence + " ",
        "Deseja realmente excluir este item do plano de aulas",
        "Confirmar", "Cancelar", "educational")
        .then(function () {

          LessonPlanService.removeLessonPlanItem(item)
            .then(function (items) {
              Common.Toast.success("Item removido com sucesso!");
              vm.grid.rows = items.data;
              vm.grid.info = {
                limit_options: [15, 30, 60, 90, 120, {
                  label: 'Todos',
                  value: function () {
                    return items.total;
                  }
                }],
                limit: 15,
                page: 1,
                total: items.total
              };
            });
        });

    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };


    vm.init();


  }

  angular.module('app.educational.lesson-plan')
    .controller('LessonPlanEditController', LessonPlanEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function LessonPlanItemEditController($scope, $state, $rootScope, LessonPlanService, Common, PoliciesService,
                                    $a4FloatButton, ModalFactory, DropzoneService, CONFIG, ModalExtra) {
    var vm = this;
    vm.grid = {
      rows: [],
      info: {}
    };
    vm.artefacts = [];
    vm.CONFIG = CONFIG;
    vm.lesson_plan_item = {};
    vm.dzOptions = {
      url: CONFIG.webApiUri,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'GIF', 'XLS', 'XLSX', 'PPT', 'PPTX', 'ZIP', 'MP3', 'MP4', 'WMV', 'AVI']),
      uploadMultiple: true,
      parallelUploads: 10,
      maxFiles: 5,
      autoProcessQueue: false
    };

    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'addedfile': function (file) {
        DropzoneService.getBase64(file)
          .then(function (base64) {
            vm.lesson_plan_item.files.push({name: file.name, base64: base64, size: file.size});
          });
      },
      'dragenter': function (file) {
        DropzoneService.getBase64(file)
          .then(function (base64) {
            vm.lesson_plan_item.files.push({name: file.name, base64: base64, size: file.size});
          });
      },
      'successmultiple': function (file, xhr) {
        if (xhr) {
          angular.forEach(xhr, function (item) {
            vm.artefacts.splice(0, 0, item);
          });
          vm.btnMultipleFiles = false;
          vm.submitOnlyFile(vm.lesson, vm.artefacts);
          vm.dzMethods.removeAllFiles(true);
        }
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.init = function () {
      if ($state.params.hasOwnProperty('id')) {
        vm.plan_id = $state.params.id;
      }

      if (ModalExtra.lesson_plan_item != null) {
        vm.getInfoUpdate(ModalExtra.lesson_plan_item);
      }
    };

    /**
     * Retorna os tipos de aulas
     * @param lesson_plan_item
     */
    vm.getInfoUpdate = function (lesson_plan_item) {
      LessonPlanService.getInfoForm({lesson_plan_id: lesson_plan_item.lesson_plan_id}).then(function (response) {
        vm.types_list = response.lesson_types;
      });
      vm.lesson_plan_item = lesson_plan_item;
      console.log(vm.lesson_plan_item);
      vm.lesson_plan_item.files = [];
      vm.getFiles(lesson_plan_item.id);
    };

    vm.submit = function () {
      vm.update(vm.lesson_plan_item);
    };

    /**
     * Busca os arquivos do item de plano de aula
     */
    vm.getFiles = function (lesson_plan_item_id) {
      LessonPlanService.getLessonPlanItemArtifact(lesson_plan_item_id)
        .then(function (files) {
          vm.lesson_plan_item.files = files;
        });
    };

    /** Edição de uma aula do plano*/
    vm.update = function (lessonPlanItem) {
      vm.disabled = true;
      LessonPlanService.updateLessonPlanItem(lessonPlanItem).then(function () {
        vm.closeModal(false);
        Common.Toast.success("Aula alterada com sucesso!");
      })
        .catch(function () {
          Common.Toast.error('Erro ao criar aula');
          vm.disabled = false;
        })
    };


    vm.closeModal = function (addAnother) {
      $rootScope.$broadcast('ModalFactory.close', addAnother);
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };


    vm.init();
  }

  angular
    .module('app.educational.lesson-plan')
    .controller('LessonPlanItemEditController', LessonPlanItemEditController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function LessonPlanItemCreateController($scope, $state, $rootScope, LessonPlanService, Common, PoliciesService,
                                          $a4FloatButton, ModalExtra, DropzoneService, CONFIG, LocalStorage, $document) {
    var vm = this;
    vm.addAnother = false;
    vm.shouldDuplicate = false;
    vm.isEdit = false;
    vm.lesson_plan_item = {};
    vm.lesson_plan_item.files = [];
    vm.CONFIG = CONFIG;
    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");

    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/classes/uploadfiles?company=' + company + '&connection=' + connection,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'GIF', 'XLS', 'XLSX', 'PPT', 'PPTX', 'ZIP', 'MP3', 'MP4', 'WMV', 'AVI']),
      uploadMultiple: true,
      parallelUploads: 10,
      maxFiles: 5,
      autoProcessQueue: true
    };

    vm.init = function () {
      $rootScope.show_loader = false;
      if (!angular.isUndefined(ModalExtra.lesson_plan_id)) {
        vm.getInfoForm(ModalExtra.lesson_plan_id);
      }

    };

    /**
     * Retorna as informações para o formulário de criação
     * @param lesson_plan_id
     */
    vm.getInfoForm = function (lesson_plan_id) {
      LessonPlanService.getInfoForm({lesson_plan_id: lesson_plan_id})
        .then(function (response) {
          vm.types_list = response.lesson_types;
        })
    };

    /**
     * Retorna os tipos de aulas
     * @param lesson_plan_item
     */
    vm.getInfoUpdate = function (lesson_plan_item) {
      LessonPlanService.getInfoForm({lesson_plan_id: lesson_plan_item.lesson_plan_id}).then(function (response) {
        vm.types_list = response.lesson_types;
      });
      vm.lesson_plan_item = lesson_plan_item;
    };

    vm.submit = function () {
      vm.create(vm.lesson_plan_item);
    };


    /** Criação de uma aula no plano */
    vm.create = function (lessonPlanItem) {
      vm.disabled = true;
      lessonPlanItem.should_duplicate = vm.shouldDuplicate;
      lessonPlanItem.lesson_plan_id = ModalExtra.lesson_plan_id;
      LessonPlanService.createLessonPlanItem(lessonPlanItem)
        .then(function () {
          vm.closeModal(vm.addAnother);
          Common.Toast.success("Aula inserida com sucesso!");
        })
        .catch(function () {
          Common.Toast.error('Erro ao criar aula');
          vm.disabled = false;
        })
    };




    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'addedfile': function (file) {
        DropzoneService.getBase64(file)
          .then(function (base64) {
            vm.lesson_plan_item.files.push({name: file.name, base64: base64, size: file.size});
          });
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.closeModal = function (addAnother) {
      $rootScope.$broadcast('ModalFactory.close', addAnother);
    };


    vm.init();
  }

  angular
    .module('app.educational.lesson-plan')
    .controller('LessonPlanItemCreateController', LessonPlanItemCreateController)
})();

(function () {
    'use strict';
  
    /** @ngInject */
    function LessonPlanEditsController($mdDialog, $rootScope, $scope, $state, LessonPlanService, ModalExtra, Common) {
  
      var vm = this;
      vm.list = {
        lesson_plan: {
          course_id: [],
          subject_id: []
        }
      };
  
  
      vm.form = {
        mode_edit: true,
        lesson_plan: ModalExtra
      };
  
      var ltn = $rootScope.$on('course_change', function (ev, course_id) {
        vm.form.lesson_plan.subject_id = null;
        vm.getSubjectsByCourse(course_id);
      });
  
      vm.init = function () {
        vm.teacherID = $state.params.id;
        vm.getCoursesForPlan();
        vm.getSubjectsByCourse(vm.form.lesson_plan.course_id);
      };
  
      /**
       * Retorna os cursos disponíveis para criar um plano
       */
      vm.getCoursesForPlan = function () {
        vm.show_loader = true;
        LessonPlanService.getCoursesForPlan()
          .then(function (response) {
            vm.list.lesson_plan.course_id = response.plain();
            vm.show_loader = false;
          })
      };
  
      /**
       * Retorna as disciplinas baseadas no curso escolhido
       */
      vm.getSubjectsByCourse = function (course_id) {
        $rootScope.show_loader = true;
        LessonPlanService.getSubjectsByCourse({course_id: course_id})
          .then(function (response) {
            vm.list.lesson_plan.subject_id = response.plain();
            $rootScope.show_loader = false;
          })
      };
  
      vm.submit = function (plan) {
        plan.person_id = vm.teacherID;
        LessonPlanService.updateLessonPlan({id: plan.id,lesson_plan:{name:plan.name,subject_id:plan.subject_id, course_id:plan.course_id}}).then(function (response) {
            Common.Toast.success("Plano de aula editado com sucesso!");
            $mdDialog.hide(true);
        }).catch(function () {
            Common.Toast.error("Erro ao editar plano de aula!");
            $mdDialog.hide(false);
        })
      };
  
      vm.close = function () {
        $mdDialog.cancel();
      };
  
      vm.init();
  
      /**
       * Destruct dos eventos registrados pelo controlador
       */
      $scope.$on('$destroy', function () {
        [ltn].forEach(function (fn) {
          fn();
        })
      });
    }
  
    angular
      .module('app.educational.lesson-plan')
      .controller('LessonPlanEditsController', LessonPlanEditsController)
  })();
(function () {
  'use strict';

  /** @ngInject */
  function LessonPlanCreateController($mdDialog, $rootScope, $scope, $state, LessonPlanService, ModalExtra, Common) {

    var vm = this;
    vm.list = {
      lesson_plan: {
        course_id: [],
        subject_id: []
      }
    };


    vm.form = {
      mode_edit: true,
      lesson_plan: {
        name: angular.isDefined(ModalExtra) ? ModalExtra.name : undefined
      }
    };

    var ltn = $rootScope.$on('course_change', function (ev, course_id) {
      vm.form.lesson_plan.subject_id = null;
      vm.getSubjectsByCourse(course_id);
    });

    vm.init = function () {
      vm.teacherID = $state.params.id;
      vm.getCoursesForPlan();
    };

    /**
     * Retorna os cursos disponíveis para criar um plano
     */
    vm.getCoursesForPlan = function () {
      vm.show_loader = true;
      LessonPlanService.getCoursesForPlan()
        .then(function (response) {
          vm.list.lesson_plan.course_id = response.plain();
          vm.show_loader = false;
        })
    };

    /**
     * Retorna as disciplinas baseadas no curso escolhido
     */
    vm.getSubjectsByCourse = function (course_id) {
      $rootScope.show_loader = true;
      LessonPlanService.getSubjectsByCourse({course_id: course_id})
        .then(function (response) {
          vm.list.lesson_plan.subject_id = response.plain();
          $rootScope.show_loader = false;
        })
    };

    vm.submit = function (plan) {
      plan.person_id = vm.teacherID;
      LessonPlanService.createLessonPlan(plan)
        .then(function () {
          Common.Toast.success('Plano de aulas criado com sucesso!');
          $mdDialog.hide(true);
        })
        .catch(function () {
          Common.Toast.error('Erro ao criar plano de aula.');
          $mdDialog.hide(false);
        });
    };

    vm.close = function () {
      $mdDialog.cancel();
    };

    vm.init();

    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });
  }

  angular
    .module('app.educational.lesson-plan')
    .controller('LessonPlanCreateController', LessonPlanCreateController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function InformativeReportService(Restangular) {

      /**
       * Retorna todos os boletins informativos
       * @returns array
       */
      var getAll = function (obj) {
        return Restangular.one('document').get(obj);
      };

      /**
       * Retorna o boletim pelo id
       * @returns array
       */
      var getById = function (id) {
        return Restangular.one('document', id).get();
      };

      /**
       * Cria um novo boletim informativo
       */
      var createInformative = function (obj) {
          return Restangular.all('document').post(obj);
      };

      /**
       * Atualiza um novo boletim informativo
       */
      var updateInformative = function (obj) {
          return Restangular.one('document', obj.id).customPUT(obj);
      };

      /**
       * Remove o boletim informativo
       * @param informative
       */
      var deleteInformative = function (id) {
          return Restangular.one('document', id).remove();
      };

    return {
      getAll: getAll,
      getById: getById,
      createInformative: createInformative,
      updateInformative: updateInformative,
      deleteInformative: deleteInformative
    };
  }

  angular
    .module('app.educational.informative-report')
    .factory('InformativeReportService', InformativeReportService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.informative-report', {
        public: false,
        url: '/informative-report',
        templateUrl: 'app/educational/informative-report/views/informative-report.html',
        abstract: true
      })
      .state('private.educational.informative-report.list', {
        url: '/list',
        public: false,
        views: {
          'informative-report': {
            templateUrl: 'app/educational/informative-report/views/list.html',
            controller: 'InformativeReportController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.informative-report.edit', {
        url: '/:id/view',
        public: false,
        views: {
          'informative-report': {
            templateUrl: 'app/educational/informative-report/views/informative-report-page.html',
            controller: 'InformativeReportEditController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.informative-report.create', {
        url: '/create',
        public: false,
        views: {
          'informative-report': {
            templateUrl: 'app/educational/informative-report/views/informative-report-page.html',
            controller: 'InformativeReportCreateController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.informative-report')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'curso_menu';
    var path = 'secretary.informative-report';

    msNavigationService.saveItem(path, {
      title: 'Boletim Informativo',
      icon: 'icon-message-draw',
      auth: role,
      state: 'private.educational.informative-report.list',
      weight: 5,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.informative-report')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function InformativeReportEditController($scope, $state, $document, InformativeReportService, CONFIG, DropzoneService,
                                           Common, ModalFactory, LocalStorage, PoliciesService, CoordinatorsService) {
    var vm = this;
    vm.form = {};
    vm.form.document = {};
    vm.form.mode_edit = false;
    vm.CONFIG = CONFIG;
    vm.url = CONFIG.webApiUri + '/uploads/';
    vm.with_final_date = false;
    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");

    vm.init = function () {
      vm.getById($state.params.id);
    };

    vm.getById = function (id) {
      InformativeReportService.getById(id)
        .then(function (response) {
          vm.form.document = response.plain();
          vm.setTree();
        })
    };

    /**
     * Define os itens da árvore
     */
    vm.setTree = function () {
      CoordinatorsService.getTree()
        .then(function (response) {
          vm.coursesAndGroups = response.plain();
          angular.forEach(vm.form.document.groups, function (group) {
            angular.forEach(vm.coursesAndGroups, function (course) {
              vm.defineGroupChecked(course, group);
            });
          });
        });
    };

    /**
     * Define os itens selecionados na árvore
     * @param items
     * @param id
     * @returns {*}
     */
    vm.defineGroupChecked = function (items, id) {
      if (angular.isDefined(items.children) && items.children.length > 0) {
        angular.forEach(items.children, function (item) {
          vm.defineGroupChecked(item, id);
        });
      } else if (items.id === id) {
        items.state.selected = true;
      }
      return items;
    };

    /**
     * Define as configurações para o upload
     */
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/document/uploadfiles?company=' + company + '&connection=' + connection,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['JPG', 'PNG', 'GIF']),
      uploadMultiple: false,
      parallelUploads: 1,
      maxFiles: 1,
      autoProcessQueue: true
    };

    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'success': function (file, xhr) {
        vm.form.document.file_reference = xhr.file_reference;
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    /**
     * Remove imagem
     */
    vm.removeImage = function () {
      vm.dzMethods.removeAllFiles(true);
      vm.form.document.file_reference = null;
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Submete o boletim informativo a atualização..
     */
    vm.submit = function (form, item) {
      if (form.$valid) {
        if (angular.isDefined(item.id)) {
          InformativeReportService.updateInformative(item)
            .then(function (response) {
              Common.Toast.success('Boletim informativo atualizado com sucesso!');
              vm.getById(response.id);
              vm.form.mode_edit = false;
              $state.go('private.educational.informative-report.list');
            })
        }
      }
    };

    vm.tinymceOptions = {
      setup: function (editor) {
        vm.editor = editor;
      },
      inline: false,
      entity_encoding: "raw",
      plugins: 'link',
      menubar: false,
      toolbar: 'undo redo | bold italic underline strikethrough | link | removeformat',
      forced_root_block: '', // Desabilita a criação automática de <p>
      force_br_newlines: true, // Força o uso de <br> em vez de <p>
      force_p_newlines: false, // Impede a criação de <p> ao pressionar Enter
      preserve_styles: false, // Desabilita a remoção de estilos inline
      remove_linebreaks: false, // Mantém quebras de linha
      content_style: "body { font-family: Arial, sans-serif; font-size: 14px; }",
      formats: {
        bold: { inline: 'b' },
        italic: { inline: 'i' },
        underline: { inline: 'u' },
        strikethrough: { inline: 's' },
        code: { inline: 'code' },
        pre: { block: 'pre' }
      },
      valid_elements: 'b,i,u,s,code,pre,a[href|target=_blank],br',
      height: 400
    };
    

    vm.init();
  }

  angular
    .module('app.educational.informative-report')
    .controller('InformativeReportEditController', InformativeReportEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function InformativeReportCreateController(a4Moment, $scope, $state, $document, LocalStorage, InformativeReportService,
                                             Common, CONFIG, DropzoneService, CoordinatorsService) {
    var vm = this;
    vm.form = {};
    vm.form.document = {
      date: a4Moment(),
      final_date: a4Moment(null)
    };
    vm.form.mode_edit = false;
    vm.with_final_date = false;
    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");

    vm.init = function () {
      vm.form.mode_edit = true;
      vm.setTree();
    };

    vm.setTree = function () {
      CoordinatorsService.getTree()
        .then(function (response) {
          vm.coursesAndGroups = response.plain();
          vm.tree_data = response.plain();
        });
    };

    /**
    * Define as configurações para o upload
    */
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/document/uploadfiles?company=' + company + '&connection=' + connection,
      paramName: 'file',
      maxFilesize: '300',
      acceptedFiles: DropzoneService.getMimeTypes(['JPG', 'PNG', 'GIF']),
      uploadMultiple: false,
      parallelUploads: 1,
      maxFiles: 1,
      autoProcessQueue: true
    };

    /**
    * Define o comportamento após o upload
    */
    vm.dzCallbacks = {
      'success': function (file, xhr) {
          vm.form.document.file_reference = xhr.file_reference;
      },
      'error': function (file, errorMessage) {
          Common.Toast.error(errorMessage);
      }
    };

    /**
     * Remove imagem
     */
    vm.removeImage = function () {
      vm.dzMethods.removeAllFiles(true);
      vm.form.document.file_reference = null;
    };

    /**
     * Submete o boletim a criação..
     */
    vm.submit = function (form, item) {
      if (form.$valid) {
          item.type = 1;
          item.company_id = company;
          InformativeReportService.createInformative(item)
          .then(function (response) {
            Common.Toast.success('Boletim informativo criado com sucesso!');
            $state.go('private.educational.informative-report.edit', {id: response});
            vm.form.mode_edit = false;
          })
      }
    };

    vm.init();
  }

  angular
    .module('app.educational.informative-report')
    .controller('InformativeReportCreateController', InformativeReportCreateController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function InformativeReportController($scope, $state, $a4FloatButton, $filter, Common, InformativeReportService, PoliciesService, ModalFactory) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.form = {};

    vm.init = function () {
      vm.paginate();
      vm.floatButton = $a4FloatButton({scope: $scope, uiSref: 'private.educational.informative-report.create'});
    };

    /**
     * Retorna todos os boletim informativo disponíveis
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     */
    vm.paginate = function (page, limit) {
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;
      var type = 1; //Boletim Infomativo

      vm.grid.promise = InformativeReportService.getAll({limit: limit, page: page, type: type})
        .then(function (response) {
          vm.grid.rows = vm.formatGrid(response.data);
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
        });
    };

      /**
       * Realiza a formatação necessária para a exibição do grid
       * @param array
       * @returns {*}
       */
      vm.formatGrid = function (array) {
          /** Filtro para data e horários */
          angular.forEach(array, function (item) {

            if(item.for_student === true){
                item.for_profile = 'Estudantes';
            }
            if(item.for_parents === true){
                item.for_profile = 'Parentes';
            }
            if(item.for_teacher === true){
                item.for_profile = 'Professores';
            }
            if(item.for_employee === true){
                item.for_profile = 'Funcionários';
            }

            /** Filtro para datas */
            item.date = $filter('date')(item.date, "dd/MM/yyyy (EEE)");
            item.final_date = $filter('date')(item.final_date, "dd/MM/yyyy (EEE)");

          });

          return array;
      };

    /**
     * Chamada do serviço de retorna todos os boletins informativos da API
     */
    vm.getAll = function () {
      InformativeReportService.getAll()
        .then(function (response) {
          vm.grid.rows = response;
        })
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterInformativeReportsList = function (query) {
      InformativeReportService.getAll({query: query})
        .then(function (response) {
          vm.grid.rows = response;
        })
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Edição de boletim informativo
     * @param item - item a ser editado
     */
    vm.editInformativeReport = function (item) {
      $state.go('private.educational.informative-report.edit', {id: item.id});
    };

      vm.deleteInformativeReport = function (id) {
          ModalFactory.confirm(
              '',
              "Confirmar exclusão",
              "Deseja realmente excluir esse boletim informativo",
              'Confirmar',
              'Cancelar')
              .then(function (response) {
                  if (response) {
                      InformativeReportService.deleteInformative(id)
                          .then(function () {
                              Common.Toast.success('Boletim informativo excluído com sucesso!');
                              vm.paginate();
                          });
                  }
              })
      };

    vm.init();
  }

  angular
    .module('app.educational.informative-report')
    .controller('InformativeReportController', InformativeReportController)
})();
(function () {
  'use strict'

  angular
    .module('app.educational.import-photos', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.import-photos', {
        url: '/import-photos',
        public: false,
        templateUrl: 'app/educational/import-photos/views/index.html',
        controller: 'ImportPhotosController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Importação de Fotos'
        }
      });
  }

  angular
    .module('app.educational.import-photos')
    .config(routerConfig);
})();



(function () {
  'use strict';

  /** @ngInject */
  function ImportPhotosController($rootScope, $document, CONFIG, Common, DropzoneService, Session, ModalFactory) {

    var vm = this;
    vm.CONFIG = CONFIG;
    vm.isProcessing = false;
    vm.determinateValue = 0;
    vm.files = {};
    vm.files = {};

    vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/students/filesinbatch?connection=' + $document[0].domain.split('.')[0] + '&company=' + Session.getCurrentCompany() +
        '&current_school_period=' + vm.current_school_period_id,
      paramName: 'file',
      maxFilesize: '2',
      acceptedFiles: DropzoneService.getMimeTypes(['png', 'jpg']),
      uploadMultiple: true,
      parallelUploads: 50,
      maxFiles: 1000,
      autoProcessQueue: true,
      init: function () {
        var dropzoneInstance = this;

        this.on("addedfile", function(file) {
            var reader = new FileReader();
            reader.onload = function(event) {
                var img = new Image();
                img.onload = function() {
                    console.log("Width:", img.width);
                    console.log("Height:", img.height);
                    if (img.width > 300 && img.height > 400) {
                        dropzoneInstance.removeFile(file);
                        console.log(file);
                        Common.Toast.error("Arquivo:" + file.name + " removido por exceder as proporções requeridas (300x400)");
                    }
                };
                img.src = event.target.result;
            };
            reader.readAsDataURL(file);
        });
      }
    };

    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'addedfile': function (file) {
// por conta do momento que o arquivo e montado, eu migrei toda a funcao de addfile para o init option
    },
      'addedfiles': function (files) {

      },
      'uploadprogress': function (item, progress, bytesSent) {
        vm.determinateValue = progress;
      },
      'successmultiple': function () {
        // vm.determinateValue = 100;
        Common.Toast.success("Imagens enviadas com sucesso");
        // vm.closeModal();
      },
      'error': function (file, errorMessage) {
        // Common.Toast.error(errorMessage.message);
      }
    };

    vm.openModalImport = function () {
      ModalFactory.customClean("app/educational/import-photos/views/file-batch.html",
        "ImportPhotosController", "vm", false, {});
    };

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    }

  }

  angular.module('app.educational.import-photos')
    .controller('ImportPhotosController', ImportPhotosController)


})();

(function () {
  'use strict';

  /** @ngInject */
  function GroupsService(Restangular) {

    /**
     * Retorna todos os turmas
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('groups').one('getall').get(obj);
    };

    /**
     * Retorna a turma pelo id
     * @returns array
     */
    var getById = function (id, matrix_period) {
      return Restangular.one('groups', id).get({matrix_period: matrix_period});
    };

    var getAttendanceType = function (obj) {
      return Restangular.one('groups').one('getattendancetype').get(obj);
    };

    var getAvailableGroupShifts = function (obj) {
      return Restangular.one('groups').one('getavailablesgroupshifts').get(obj);
    };

    var getStudentsAbsences = function (obj) {
      return Restangular.one('groups').one('getabsences').get(obj);
    };

    var changeGradeRuleGroup = function (obj) {
      return Restangular.one('groups').all('changegraderulegroup').post(obj);
    };

    var recalculateGroup = function (obj) {
      return Restangular.one('groups').all('recalculategroup').post(obj);
    };

    var getPendingGradesByGroup = function (obj) {
      return Restangular.one('groups').one('getpendinggradesbygroup').get(obj);
    };

    /**
     * Faz a requisição para atualização da turma
     * @returns array
     */
    var updateGroup = function (obj) {
      return Restangular.one('groups', obj.id).put(obj);
    };

    /**
     * Retorna as turmas disponíveis para matrícula a partir do id do curso
     * @returns array
     */
    var getGroupsForEnrolment = function (course_id, person_id) {
      return Restangular.one('groups', course_id).one('groupsenrolment').get(person_id);
    };

    /**
     * Retorna as turmas disponíveis para matrícula a partir do id do curso
     * @returns array
     */
    var getGroupModules = function (group_id) {
      return Restangular.one('group', group_id).one('modules').get();
    };

    /**
     * Retorna as turmas disponíveis de um curso para um aluno
     * @returns array
     */
    var getCourseGroups = function (person_id) {
      return Restangular.one('groups').one('fromcourse').get(person_id);
    };

    /**
     * Retorna as informações disponíveis da turma de origem para possíveis matrículas
     * @returns array
     */
    var getSourceGroupInfo = function (group) {
      return Restangular.one('groups').one('getsourcegroupinfo').get(group);
    };

    /**
     * Retorna as informações disponíveis da turma de origem para possíveis matrículas
     * @returns array
     */
    var getDestinyGroupInfo = function (group) {
      return Restangular.one('groups').one('getdestinygroupinfo').get(group);
    };

    /**
     * Renumera os estudantes da turma para que a numeração corresponda à ordem alfabética
     */
    var renumberStudents = function () {
      return Restangular.one('groups').all('renumberstudents').post();
    };

    var getStudentsByGroup = function (obj) {
      return Restangular.one('groups').one('getstudentsbygroup').get(obj);
    };

    var saveFrequency = function (obj) {
      return Restangular.one('groups').all('savefrequencybygroup').post(obj);
    };

    var verifyPendentStudents = function (obj) {
      return Restangular.one('groups').one('verifypendentstudents').get(obj);
    };

    var getGroupsByTeacher = function (obj) {
      return Restangular.one('groups').one('getgroupsbyteacher').get(obj);
    };

    var deleteGroup = function (id, obj) {
      return Restangular.one('groups', id).remove(obj);
    };

    return {
      getAll: getAll,
      getById: getById,
      updateGroup: updateGroup,
      getAvailableGroupShifts: getAvailableGroupShifts,
      changeGradeRuleGroup: changeGradeRuleGroup,
      getStudentsAbsences: getStudentsAbsences,
      getAttendanceType: getAttendanceType,
      getPendingGradesByGroup: getPendingGradesByGroup,
      getGroupModules: getGroupModules,
      getGroupsForEnrolment: getGroupsForEnrolment,
      getCourseGroups: getCourseGroups,
      getSourceGroupInfo: getSourceGroupInfo,
      recalculateGroup: recalculateGroup,
      getStudentsByGroup: getStudentsByGroup,
      getDestinyGroupInfo: getDestinyGroupInfo,
      renumberStudents: renumberStudents,
      saveFrequency: saveFrequency,
      verifyPendentStudents: verifyPendentStudents,
      deleteGroup: deleteGroup,
      getGroupsByTeacher: getGroupsByTeacher
    };
  }

  angular
    .module('app.educational.groups')
    .factory('GroupsService', GroupsService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.groups', {
        public: false,
        url: '/groups',
        templateUrl: 'app/educational/groups/views/groups.html',
        abstract: true
      })
      .state('private.educational.groups.list', {
        url: '/list',
        public: false,
        views: {
          'groups': {
            templateUrl: 'app/educational/groups/views/list.html',
            controller: 'GroupsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.groups.edit', {
        url: '/:id/:matrix_period/view',
        public: false,
        params: {
          id: null,
          matrix_period: null
        },
        views: {
          'groups': {
            templateUrl: 'app/educational/groups/views/groups-page.html',
            controller: 'GroupsEditController',
            controllerAs: 'vm'
          },
          'timetable@private.educational.groups.edit': {
            templateUrl: 'app/educational/groups/timetable/views/timetable.html',
            controller: 'TimetableController',
            controllerAs: 'vm'
          },
          'students@private.educational.groups.edit': {
            templateUrl: 'app/educational/groups/students/views/students.html',
            controller: 'StudentsGroupController',
            controllerAs: 'vm'
          },
          'notes-pending-group@private.educational.groups.edit': {
            templateUrl: 'app/educational/groups/notes-pending/views/notes-pending.html',
            controller: 'NotesPendingGroupController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.groups.create', {
        url: '/create',
        public: false,
        views: {
          'groups': {
            templateUrl: 'app/educational/groups/views/groups-page.html',
            controller: 'GroupsCreateController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.groups')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'turma_menu';
    var path = 'config.groups';

    msNavigationService.saveItem(path, {
      title: 'Turmas',
      icon: 'icon-chair-school',
      auth: role,
      state: 'private.educational.groups.list',
      weight: 4,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.groups')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function GroupsEditController($scope, $state, $rootScope, GroupsService, Common, LocalStorage, PoliciesService, ModalFactory, Session, PersonService) {
    var vm = this;
    var LocalStorageKEY = 'groups_current_tab';
    vm.search_text = '';
    vm.show_tabs = false;
    vm.school_period_free = 0;
    vm.group_modules = [];
    vm.selected_tab = LocalStorage.get(LocalStorageKEY);
    vm.form = {
      group: {}
    };
    vm.can_complete = true;

    vm.init = function () {
      if ($state.params.hasOwnProperty('id')) {
        vm.getById($state.params.id);
      }
      vm.can_edit = vm.checkPolicies('turma_hor_alt');
    };

    vm.getTeachers = function (query) {
      return PersonService.getPersonWithFilter({query: query, selected_tab: 3});
    };

    /**
     * Resgata o objeto referente a turma
     * @param group_id - identificador da turma
     */
    vm.getById = function (group_id) {
      GroupsService.getById(group_id, $state.params.matrix_period)
        .then(function (response) {
          vm.form = response.plain();
          vm.current_status = angular.copy(vm.form.group_status_id);
          $rootScope.show_loader = false;
          
          // mantem a informação de professor, caso exista, no formato da seleção do campo de seleção de professor
          if (vm.form.person_id_teacher && vm.form.teacher_name) {
            vm.form.person_teacher = {
              id: vm.form.person_id_teacher,
              name: vm.form.teacher_name
            };
          }
          
          // mantem a informação de professor auxiliar, caso exista, no formato da seleção do campo de seleção de professor auxiliar
          if (vm.form.person_id_teacher_aux && vm.form.teacher_aux_name) {
            vm.form.person_teacher_aux = {
              id: vm.form.person_id_teacher_aux,
              name: vm.form.teacher_aux_name
            };
          }

          /** Só busca os modulos se for sem periodo letivo  */
          if (vm.form.school_period_id === vm.school_period_free) {
            vm.getGroupModules(vm.form.id);
          }
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel recuperar os dados da turma.');
        });
    };

    /**
     * Retorna todos os modulos da turma
     */
    vm.getGroupModules = function (group_id) {
      GroupsService.getGroupModules(group_id)
        .then(function (response) {
          vm.group_modules = response.plain();
        })
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param item - novo item selecionado
     */
    vm.changeGroup = function (item) {
      if (angular.isDefined(item)) {
        $state.go('private.educational.groups.edit', {
          id: item.id, matrix_period: item.matrix_period_current
        }, {reload: true});
      }
    };

    /**
     * Verifica se tem alunos sem conclusão pedagógica
     */
    vm.verifyStudentsToComplete = function () {
      GroupsService.verifyPendentStudents({
        group_id: vm.form.id,
        matrix_period: $state.params.matrix_period
      }).then(function (response) {
        if (response > 0) {
          ModalFactory.alert(
            "Período não pode ser concluído", "Este período possui alunos sem conclusão pedagógica. Favor resolver estes alunos antes de concluir o período.",
            "modal", "Ok", "false", "educational"
          );
        }
      })
    };

    /**
     * Salva edições na turma
     */
    vm.save = function (item) {
      var obj = angular.copy(item);
      console.log(obj)
      /** Caso o status esteja sendo alterado para 'Concluído', realizar tratamentos */
      if (vm.form.group_status_id === 4 && vm.current_status !== 4) {
        $rootScope.show_loader = true;
        GroupsService.verifyPendentStudents({
          group_id: vm.form.id,
          matrix_period: $state.params.matrix_period
        }).then(function (response) {
          $rootScope.show_loader = false;
          if (response > 0) {
            ModalFactory.confirm(null,
              "Conclusão de período",
              "Este período possui alunos sem conclusão pedagógica. Deseja prosseguir com a conclusão? NÃO SERÁ possível reverter essa operação.",
              'Concluir', 'Cancelar',
              'educational'
            ).then(function () {
              vm.update(obj);
            });
          } else {
            $rootScope.show_loader = false;
            ModalFactory.confirm(null,
              "Conclusão de período",
              "Deseja realmente concluir este período? NÃO SERÁ possível reverter essa operação.",
              'Concluir', 'Cancelar',
              'educational'
            ).then(function () {
              vm.update(obj);
            });
          }
        })
      } else {
        vm.update(obj);
      }
    };

    vm.update = function (obj) {
      var infos = {
        capacity: obj.capacity,
        name: obj.name,
        id: obj.id,
        group_shift_id: obj.group_shift_id,
        initial_date: obj.initial_date,
        final_date: obj.final_date,
        group_status_id: obj.group_status_id,
        matrix_period: obj.matrix_period_current,
        matrix_id: obj.matrix_id,
        cnpj: obj.cnpj,
        group_corporate_name: obj.group_corporate_name,
        person_teacher: angular.isDefined(obj.person_teacher) && obj.person_teacher != null 
          ? obj.person_teacher.id : 0,
        person_teacher_aux: angular.isDefined(obj.person_teacher_aux) && obj.person_teacher_aux != null
          ? obj.person_teacher_aux.id : 0,

      };
      $rootScope.show_loader = true;
      GroupsService.updateGroup(infos)
        .then(function () {
          $rootScope.show_loader = false;
          vm.getById($state.params.id);
          Common.Toast.success("Turma atualizada com sucesso")
        })
        .catch(function (error) {
          Common.Toast.success(error.message || error.data.message);
          $rootScope.show_loader = false;
        });
    };

    /**
     * Escuta da tab corrente, a cada troca de tab em turmas, esta escuta salva a corrente no localstorage;
     * @type {*}
     */
    var ltn = $scope.$watch(function () {
        return vm.selected_tab;
      },
      function (newer, older) {
        if (parseInt(newer) !== parseInt(older))
          LocalStorage.add(LocalStorageKEY, newer);
      });

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();


  }

  angular
    .module('app.educational.groups')
    .controller('GroupsEditController', GroupsEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function GroupsCreateEditController($scope, $rootScope, $state, $a4FloatButton, GroupsService, Common, ModalFactory, PoliciesService) {
    var vm = this;

    vm.list = {};
    vm.list.group = {};
    vm.form = {};
    vm.form.group = {};
    vm.form.mode_edit = false;
    vm.selected_tab = 0;

    vm.init = function () {
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        uiSref: 'private.educational.groups.list',
        icon: 'undo',
        label: 'voltar a lista de turmas'
      });
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Submete o curso a criação..
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        if (angular.isDefined(item.id)) {
          GroupsService.updateGroup(item)
            .then(function (response) {
              Common.Toast.success('Curso atualizado com sucesso!');
              vm.getById(response.id);
              vm.form.mode_edit = false;
              $state.reload($state.current.name);
            })
            .catch(function (response) {
              switch (response.data.message) {
                case "DUPLICATED_NAME":
                  Common.Toast.warning('Existe um curso com esse nome no sistema.');
                  break;
                case "EMPTY_NAME":
                  Common.Toast.warning('Nome do curso não pode ficar em branco.');
                  break;
                default:
                  Common.Toast.error('Não foi possivel inserir o curso.');
                  break;
              }
            });
        } else {
          GroupsService.createGroup(item)
            .then(function (response) {
              Common.Toast.success('Curso criado com sucesso!');
              $state.go('private.educational.groups.edit', {id: response.id});
              vm.form.mode_edit = false;
            })
            .catch(function (response) {
              switch (response.data.message) {
                case "DUPLICATED_NAME":
                  Common.Toast.warning('Existe um curso com esse nome no sistema.');
                  break;
                case "EMPTY_NAME":
                  Common.Toast.warning('Nome do curso não pode ficar em branco.');
                  break;
                default:
                  Common.Toast.error('Não foi possivel inserir o curso.');
                  break;
              }
            });
        }
      } else {
        Common.Toast.error('Existe erros no formulário');
      }

    };


    vm.delete = function (item) {
      ModalFactory.confirm(null,
        'Deseja remover o curso?',
        'O curso ' + item.name + ' será removida',
        'Confirmar', 'Cancelar', 'educational')
        .then(function (response) {
          if (response) {
            GroupsService.deleteGroup(item.id)
              .then(function () {
                Common.Toast.success('Curso excluído com sucesso!');
                $state.go('private.educational.groups.list');
              })
              .catch(function (response) {
                switch (response.data.message) {
                  case "EXISTS_MATRIX_IN_THIS_COURSE":
                    Common.Toast.warning('Este curso contém grades associadas a ele, não é possível excluir.');
                    break;
                  default:
                    Common.Toast.error('Não foi possivel excluir o grupo.');
                    break;
                }
              })
          }
        });
    };

    vm.close = function () {
      if ($state.params.hasOwnProperty('id')) {
        vm.form.mode_edit = !vm.form.mode_edit;
        if (!vm.form.mode_edit) {
          vm.getById($state.params.id);
        }
      } else {
        $state.go('private.educational.groups.list');
      }
    };

    vm.init();
  }

  angular
    .module('app.educational.groups')
    .controller('GroupsCreateController', GroupsCreateEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function GroupsController($rootScope, $state, $a4FloatButton, Common, CourseService, GroupsService, PoliciesService, ModalFactory) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };
    vm.courses = [];
    vm.form = {};
    vm.show_group_completed = false;

    vm.group = {name: ''};

    vm.init = function () {
      /*vm.paginate();*/
      vm.getCourses();
      // vm.floatButton = $a4FloatButton({scope: $scope, uiSref: 'private.educational.groups.create'});
    };

    /**
     * Retorna todos os grupos de curso disponíveis
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     * @param course_id - Identificador do curso para filtro
     */
    vm.paginate = function (page, limit, course_id) {
      /*$rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 20;
      page = angular.isDefined(page) ? page : 1;
      course_id = (angular.isDefined(course_id) ? course_id : (angular.isDefined(vm.course_id) ? vm.course_id : undefined));
      vm.show_group_completed = (angular.isDefined(vm.show_group_completed) ? vm.show_group_completed : false);

      vm.promise = GroupsService.getAll({
        limit: limit,
        page: page,
        course_id: course_id,
        show_group_completed: vm.show_group_completed
      })
        .then(function (response) {
          vm.grid = response;

          if (vm.grid.data.length > 0 && vm.grid.data[0].school_period_id === 0) {
            vm.is_without_school_period = true;
          }

          $rootScope.show_loader = false;
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.message || error.data.message);
        });*/
    };

    /**
     * Retorna todos os cursos
     */
    vm.getCourses = function () {
      CourseService.getCoursesWithGroups()
        .then(function (response) {
          vm.courses = response
        })
        .catch(function (error) {
          Common.Toast.error(error.message || error.data.message);
        });
    };

    /**
     * Executa uma função desejada na lista de opções do grid
     * @param group
     * @param option
     */
    vm.clickActions = function (group, option) {
      switch (option) {
        case 'conditional-group-enrollment':
          vm.conditionalGroupEnrollment(group);
          break;
        default:
      }
    };

    /**
     * Exclui turma
     * @param item
     */
    vm.deleteGroup = function (item) {
      ModalFactory.confirm(null, "Confirmar exclusão",
        "Deseja realmente excluir esta turma?",
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          $rootScope.show_loader = true;
          GroupsService.deleteGroup(item.id, {matrix_period: item.matrix_period}).then(function () {
            Common.Toast.success('Turma excluída com sucesso!');
            vm.paginate();
            $rootScope.show_loader = false;
          }).catch(function (errors) {
            $rootScope.show_loader = false;
            ModalFactory.custom('app/components/modal/Templates/operationError.html', {
              reasons: errors.data,
              name: 'Exclusão de turma',
              message: 'Esta turma não poderá ser excluída porque:',
              theme: 'educational'
            }, false);
          })
        });
    };


    /**
     * Abre o modal para a matrícula em grupo condicional
     */
    vm.conditionalGroupEnrollment = function (group) {
      $rootScope.show_loader = true;
      ModalFactory.customClean(
        'app/educational/groups/views/forms/conditional-group-enrollment-dialog.html',
        'ConditionalGroupEnrollmentController',
        'vm', false, group
      ).then(function () {
        $rootScope.show_loader = false;
      }).catch(function () {
        $rootScope.show_loader = false;
      });
    };

    /**
     * Chamada do serviço de retorna todos os grupos de curso da API
     */
    vm.getAll = function () {
      GroupsService.getAll()
        .then(function (response) {
          vm.grid.rows = response;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterGroupsList = function (query) {
      GroupsService.getAll({query: query})
        .then(function (response) {
          vm.grid.rows = response;
        })
    };
    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Edição de turmas
     * @param item - item a ser editado
     */
    vm.editGroup = function (item) {
      $state.go('private.educational.groups.edit', {id: item.group_id, matrix_period: item.matrix_period});
    };


    vm.init();
  }

  angular
    .module('app.educational.groups')
    .controller('GroupsController', GroupsController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ConditionalGroupEnrollmentController($rootScope, $state,
                                                GroupsService, EnrolmentService, LocalStorage, ModalFactory, ModalExtra, Common) {
    var vm = this;

    vm.payment_plan_has_price = true;

    vm.form = {
      mode_edit: true,
      group: {},
      origin_group: {},
      selected_group: null
    };

    vm.show_loading = false;
    vm.do_finance_enrolment = true;

    vm.list = {
      groups: {}
    };

    vm.init = function () {
      /** Se for o retorno por conta de cancelamento do modal */
      if (angular.isDefined(ModalExtra.continue)) {
        vm.form.group = ModalExtra.origin_group;
        vm.form.selected_group = ModalExtra.selected_group;
        vm.form.origin_group = ModalExtra.destiny_group;
        $rootScope.show_loader = false;

      } else {
        vm.form.group = ModalExtra;
        /** Dados necessários */
        var data = {
          matrix_period: vm.form.group.matrix_period,
          group_id: vm.form.group.group_id,
          course_id: vm.form.group.course_id,
          course_equivalence_id: vm.form.group.course_equivalence_id
        };

        vm.getGroupData(data);
        vm.getDestinyGroupInfo(data);
        $rootScope.show_loader = false;
      }
      vm.has_finance = LocalStorage.get('has_app_finance');
    };

    vm.verifyPaymentPlan = function (payment_plan_id) {
      vm.form.group.payment_plans.forEach(function (item) {
        if (item.id === payment_plan_id) vm.payment_plan = item;
      });
      if (vm.payment_plan.price !== null) vm.payment_plan_has_price = true;
      else vm.payment_plan_has_price = false;
    };
    /**
     * Abre o modal para a matrícula em grupo condicional
     */
    vm.getGroupData = function (group) {
      /**
       * Realiza a busca das turmas pelo curso
       */
      if (angular.isDefined(group)) {
        GroupsService.getSourceGroupInfo(group)
          .then(function (response) {
            // vm.form.group.enrollment_info = response.plain();
            vm.form.group.vacancy = response.vacancy;
            vm.form.group.payment_plans = response.payment_plans;
            vm.form.group.matrix = response.matrix;
            vm.form.group.contract_type = response.contract_type;
            vm.form.group.course_equivalence_id = response.course_equivalence_id;
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Resgata a sugestão de turma para matrícula
     */
    vm.getDestinyGroupInfo = function (group) {
      /**
       * Realiza a busca das turmas pelo curso
       */
      if (angular.isDefined(group)) {
        GroupsService.getDestinyGroupInfo(group)
          .then(function (response) {
            vm.form.origin_group = response.plain();
            vm.form.selected_group = vm.form.origin_group[0];
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Valida o fomulário e submete os dados
     * @param item
     * @param form
     */
    vm.submit = function (item, form) {
      // var enrollments_available = parseInt(vm.form.group.vacancy) - (parseInt(item.aprovados) + parseInt(item.em_curso));
      var students_available = (parseInt(item.aprovados) + parseInt(item.em_curso)) - parseInt(item.rematriculados);
      var total = parseInt(vm.form.group.vacancy) - students_available;

      if (form.$valid) {
        /** Se a turma de destino trouxer mais matrículas do que as vagas disponíveis */
        if (parseInt(vm.form.group.vacancy) < students_available) {
          ModalFactory.confirm(null,
            'Vagas não suficientes',
            'Este processo de matricula irá ultrapassar em ' + Math.abs(total) + ' as vagas na turma de destino. Deseja realizar as matrículas?',
            'Confirmar', 'Cancelar', 'educational')
            .then(function () {
              vm.submitEnrollment(vm.form, item);
            })
            .catch(function () {
              var backup = {
                origin_group: vm.form.group,
                selected_group: item,
                destiny_group: vm.form.origin_group,
                continue: true
              };
              ModalFactory.customClean(
                'app/educational/groups/views/forms/conditional-group-enrollment-dialog.html',
                'ConditionalGroupEnrollmentController',
                'vm', false, backup
              );
            });
        } else {
          vm.submitEnrollment(vm.form, item);
        }

      }
    };

    /**
     * Submete os dados para realização ou não da matricula
     * @param form
     * @param item
     */
    vm.submitEnrollment = function (form, item) {
      if (vm.form.group.contract_type === 'U' && vm.form.group.course_equivalence_id >= 300) {
        vm.do_finance_enrolment = false;
      }
      vm.show_loading = true;
      $rootScope.show_loader = true;
      var data = {
        destiny_group: vm.form.group.group_id,
        origin_group: item.group_id,
        matrix_period: vm.form.group.matrix_period,
        course_id: vm.form.group.course_id,
        payment_plan_id: vm.form.group.payment_plan_id,
        has_finance: vm.has_finance,
        do_finance_enrolment: vm.do_finance_enrolment,
        contract_type: vm.form.group.contract_type
      };
      if (!vm.payment_plan_has_price) {
        data.amount = vm.form.group.amount;
      } else if (vm.has_finance && vm.do_finance_enrolment) {
        data.amount = vm.payment_plan.price;
      }
      /** Realiza as matriculas dos alunos da turma */
      EnrolmentService.conditionalGroupEnrollment(data)
        .then(function (response) {
          vm.show_loading = false;
          $rootScope.show_loader = false;
          if (response) {
            vm.close();
            Common.Toast.success('Matrículas realizadas com sucesso!');
          }
        })
        .catch(function (error) {
          vm.show_loading = false;
          $rootScope.show_loader = false;
          switch (error.data.message) {
            case 'NO_HAVE_STUDENTS':
              Common.Toast.error('Não existem alunos aptos para a matrícula na nova turma.');
              break;
            case 'ALL_WERE_ENROLLED':
              Common.Toast.error('Todos os alunos aprovados desta turma já foram matriculados.');
              break;
            case 'GROUP_WITHOUT_PAYMENT_PLAN':
              Common.Toast.error('A turma de destino não possui plano de pagamento associado.');
              break;
            default:
              Common.Toast.error('Erro ao realizar as matrículas.');
              break;
          }
        });
    };

    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular
    .module('app.educational.groups')
    .controller('ConditionalGroupEnrollmentController', ConditionalGroupEnrollmentController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function FinanceEnrolment($rootScope, ModalFactory, IndexService) {
    $rootScope.$on('$stateChangeStart', function (event, next, toParams, fromState) {
      if (IndexService.isStopPropagation()) {
        event.preventDefault();
        ModalFactory.confirm(null,
          'Exclusão de Critério',
          'Deseja realmente excluir este critério de conceito?',
          'Confirmar',
          'Cancelar',
          'educational')
          .then(function () {
          });
      }
    });
  }

  angular.module('app.educational.finance-enrolment')
    .run(FinanceEnrolment)

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.finance-enrolment', {
        public: false,
        url: '/finance-enrolment',
        template: '<div ui-view="finance-enrolment"></div>',
        abstract: true
      })
      .state('private.educational.finance-enrolment.list', {
        url: '/finance-enrolment/list',
        public: false,
        views: {
          'finance-enrolment': {
            templateUrl: 'app/educational/finance-enrolment/views/finance-enrolment-grid.html',
            controller: 'FinanceEnrolmentController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.finance-enrolment.enrolment', {
        url: '/finance-enrolment/enrolment/:id/:group_id/:course_id/:matrix_period/:contract_type',
        public: false,
        params: {student: null, contract_type: null, matrix_period: null},
        views: {
          'finance-enrolment': {
            templateUrl: 'app/educational/finance-enrolment/finance-enrolment-page.html',
            controller: 'FinanceEnrolmentAssistantController',
            controllerAs: 'enrolment'
          }, 'finance-enrolment-payment_plan@private.educational.finance-enrolment.enrolment': {
            templateUrl: 'app/educational/finance-enrolment/finance-enrolment-steps/payment-plan/finance-enrolment-payment_plan.html',
            controller: 'FinanceEnrolmentPaymentPlanController',
            controllerAs: 'vm'
          }, 'finance-enrolment-discounts@private.educational.finance-enrolment.enrolment': {
            templateUrl: 'app/educational/finance-enrolment/finance-enrolment-steps/discounts/finance-enrolment-discounts.html',
            controller: 'FinanceEnrolmentDiscountsController',
            controllerAs: 'vm'
          }, 'finance-enrolment-end@private.educational.finance-enrolment.enrolment': {
            templateUrl: 'app/educational/finance-enrolment/finance-enrolment-steps/end/finance-enrolment-end.html',
            controller: 'FinanceEnrolmentEndController',
            controllerAs: 'vm'
          }
        }


      });
  }

  angular
    .module('app.educational.finance-enrolment')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService, LocalStorage) {
    var path = 'secretary.finance-enrolment';

    msNavigationService.saveItem(path, {
      title: 'Matrícula financeira',
      icon: 'icon-currency-usd',
      state: 'private.educational.finance-enrolment.list',
      weight: 6,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile('matricula_fin', path) || !LocalStorage.get('has_app_finance');
      }
    });
  }

  angular
    .module('app.educational.finance-enrolment')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function FinanceEnrolmentController($state, $stateParams, $rootScope, $scope, $document, CONFIG, Common,
                                      ModalFactory, StudentsService, a4Socket, Session) {

    var vm = this;
    vm.list_channel = null;
    vm.search = '';
    vm.grid = {
      rows: [],
      info: {}
    };

    vm.init = function () {
      vm.paginate();
      // vm.initSocket();
    };

    vm.initSocket = function () {
      var subdomain = $document[0].domain.split('.')[0];
      vm.list_channel = Session.getCurrentCompany() + '_' + subdomain + CONFIG.socket.mat_fin_updated;

      a4Socket.connect(vm.list_channel).on(vm.list_channel, function (data) {
        vm.grid.rows = angular.fromJson(data);
      });
    };

    /**
     * Função de paginação que só trás os alunos aguardando matrícula financeira
     * @param page
     * @param limit
     */
    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 20;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = StudentsService.getAll({
        limit: limit,
        page: page,
        only_waiting_finance_enrolment: true,
        options: vm.filter_selected,
        query: vm.search
      })
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [20, 30, 40, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        });
    };

    vm.clickActions = function (item, option) {
      console.log(option)
      switch (option) {
        case 'finance-enrolment':
          vm.doFinanceEnrolment(item);
          break;
        default:
      }
    };

    /**
     * Abre o wizard para a matrícula financeira do aluno
     * @param student
     */
    vm.doFinanceEnrolment = function (student) {
      $state.go('private.educational.finance-enrolment.enrolment', {
        id: student.id, group_id: student.group_id,
        course_id: student.course_id,
        contract_type: student.contract_type,
        matrix_period: student.matrix_period
      });
    };

    vm.delete = function (student) {
      $rootScope.show_loader = true;
      StudentsService.verifyDelete(student).then(function (response) {
        $rootScope.show_loader = false;
        /** Caso a exclusão não seja bloqueada */
        if (angular.isUndefined(response.block) || response.block.length === 0) {
          /** Verifica situações para o usuário decidir em relação à exclusão */
          if (response.alert.enrolments === true) {
            vm.confirmDeleteEnrolment(student, 2);
          } else {
            var text = vm.defineDeleteText(response.alert);
            ModalFactory.custom('app/educational/students/views/student-delete-modal.html', {
              alerts: response.alert,
              student: student,
              text: text,
              option: null
            }).then(function (response) {
              vm.confirmDeleteEnrolment(student, response);
            })
          }
        } else {
          ModalFactory.custom('app/components/modal/Templates/operationError.html', {
            reasons: response.block,
            name: 'Exclusão de matrícula',
            message: 'Este aluno não poderá ser excluído porque:',
            theme: 'educational'
          }, false);
        }
      });
    };

    vm.defineDeleteText = function (alerts) {
      if (alerts.resp_dep === 0 && alerts.employee === 0 && alerts.responsible === 0
        && alerts.resp_employee === 0 && alerts.resp_enrolment === 0) {
        return "Este aluno e os seus responsáveis não possuem outra matrícula no sistema. Deseja excluir os dados do alunos e dos responsáveis também?";
      } else if (alerts.employee === 0 && alerts.responsible === 0) {
        return "Este aluno não possui outra matrícula no sistema, deseja excluir os seus dados também?";
      }
    };

    vm.confirmDeleteEnrolment = function (student, option) {
      ModalFactory.open('require_password', null, null, {
          student: student,
          option: option
        }, null, 'educational', vm.executeDelete,
        'Confirmação de exclusão de matrícula', 'Confirme sua senha para excluir a matrícula', null).then(function () {
        vm.grid.rows = [];
        vm.current_page = 0;
        vm.paginate();
        Common.Toast.success('Matrícula excluída com sucesso!');
        $rootScope.show_loader = false;
      });
    };

    vm.executeDelete = function (obj) {
      return StudentsService.deleteEnrolment(obj);
    };


    vm.init();
    //
    // $scope.$on('$destroy', function () {
    //   a4Socket.disconnect(vm.list_channel);
    // })

  }

  angular
    .module('app.educational.finance-enrolment')
    .controller('FinanceEnrolmentController', FinanceEnrolmentController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function FinanceEnrolmentAssistantController(EnrolmentService, $stateParams, a4Moment, $rootScope, $scope, $timeout,
                                               $filter, Common, StudentsService, ModalFactory) {

    var enrolment = this;
    enrolment.student = {};
    enrolment.stepSelected = 0;
    enrolment.student.id = $stateParams.id;
    enrolment.student.group_id = $stateParams.group_id;
    enrolment.student.course_id = $stateParams.course_id;
    enrolment.student.contract_type = $stateParams.contract_type;
    enrolment.student.matrix_period = $stateParams.matrix_period;
    enrolment.contract = {};
    enrolment.steps = {
      payment_plan: {id: 0, completed: false, disabled: false},
      end: {id: 1, completed: false, disabled: true}
    };
    enrolment.student_responsible = [];
    enrolment.enableEndStep = false;

    enrolment.init = function () {
      $rootScope.show_loader = false;
      StudentsService.getById(enrolment.student.id, false, enrolment.student.matrix_period, enrolment.student.group_id)
        .then(function (person) {
          enrolment.student.name = person.person.name;
          enrolment.student.national_id_number = person.national_id_number;
          enrolment.student.dob = a4Moment(person.person.dob, 'YYYY-MM-DD');
          enrolment.student.person_id_payee = person.person.person_id_payee;
          enrolment.student.school_period_id = person.person.school_period_id;
          enrolment.getStudentParents();
        });
    };

    /**
     * Busca os responsáveis do aluno, e adiciona ao contrato
     */
    enrolment.getStudentParents = function () {
      StudentsService.getStudentParents({student_id: enrolment.student.id, group_id: enrolment.student.group_id, matrix_period: enrolment.student.matrix_period})
        .then(function (response) {
          enrolment.student_responsible = response.plain();
        });
    };

    enrolment.submit = function (step) {
      var deferred = Common.$q.defer();
      var wizard = {CONTRACT: 0, CONCLUSAO: 1};
      switch (step.id) {
        case wizard.CONTRACT:
          deferred.resolve(true);
          break;
      }
      return deferred.promise;
    };

    enrolment.init();
    enrolment.enableNextStep = function (maxStep) {
      /** não pode exceder o maximo de passos */
      if (enrolment.stepSelected >= maxStep) {
        return;
      }
      /** So incrementa até o maximo possível */
      if (enrolment.stepSelected === $scope.stepProgress - 1) {
        $scope.stepProgress = $scope.stepProgress + 1;
      }
      /** Selecionado recebe o proximo step */
      enrolment.stepSelected = enrolment.stepSelected + 1;
    };
    /**
     * Executa o submit do step corrente
     * @param stepData - dados para submissão
     * @param isSkip - se deve ser passado ou não
     * @param form - dados referente ao formulário
     */
    enrolment.submitCurrentStep = function (stepData, isSkip, form) {
      enrolment.showBusyText = true;
      enrolment.submit(stepData)
        .then(function () {
          if (!stepData.completed && !isSkip) {
            /** move to next step when success */
            $timeout(function () {
              enrolment.showBusyText = false;
              stepData.completed = true;
              enrolment.steps.end.disabled = false;
              enrolment.enableNextStep(2);
              angular.element('md-step-content.md-active select:first, md-step-content.md-active input[type="text"]:first').focus();
            }, 1000);
          } else {
            enrolment.showBusyText = false;
            enrolment.enableNextStep(2);
          }
        })
    };

    /**
     * Move o wizard para a etapa anterior
     */
    enrolment.moveToPreviousStep = function () {
      if (enrolment.stepSelected > 0) {
        enrolment.stepSelected = enrolment.stepSelected - 1;
      }
    };


  }

  angular
    .module('app.educational.finance-enrolment')
    .controller('FinanceEnrolmentAssistantController', FinanceEnrolmentAssistantController)
})();
(function () {
  'use strict';

  angular.module('app.educational.external-pre-enrolment', []);
})();
(function () {
  'use strict';

  /** @ngInject*/

  function ExternalPreEnrolmentService(Restangular) {
    var vm = this;

    vm.submitPreEnrolment = function (obj) {
      return Restangular.one('enrolment').all('externalpreenrolmentsubmit').post(obj);
    };

    vm.getResponsibleData = function (obj) {
      return Restangular.one('enrolment').one('getresponsibledata').get(obj);
    };

    vm.finish = function (obj) {
      return Restangular.one('enrolment').all('finishpreenrolmentonline').post(obj);
    };

    return vm;
  }

  angular
    .module('app.educational.external-pre-enrolment')
    .factory('ExternalPreEnrolmentService', ExternalPreEnrolmentService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('public.external-pre-enrolment', {
        url: '/educational/external-pre-enrolment',
        controller: 'ExternalPreEnrolmentController',
        controllerAs: 'vm',
        templateUrl: 'app/educational/external-pre-enrolment/views/index.html',
        public: true

      })
      .state('public.external-pre-enrolment-confirmation', {
        url: '/educational/external-pre-enrolment-confirmation/:token',
        params: {
          responsible: null
        },
        controller: 'ExternalPreEnrolmentController',
        controllerAs: 'vm',
        templateUrl: 'app/educational/external-pre-enrolment/views/confirmation.html',
        public: true
      });

  }

  angular
    .module('app.educational.external-pre-enrolment')
    .config(routerConfig);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ExternalPreEnrolmentController($document, $scope, Common, StudentsService, ExternalPreEnrolmentService,
                                          LoginService, GroupsService, $stateParams, $state, 
                                          $timeout, a4Moment, ModalFactory, Session, $rootScope, RolesService) {
    var vm = this;
    vm.show_form = false;
    vm.show_mail_sent = false;
    vm.windowHeight = angular.element("body").height();
    vm.windowWidth = angular.element("body").width();
    vm.formWidth = 35;
    vm.showResponsible = false;
    vm.showDependents = false;
    vm.isHiddenInformation =  $rootScope.isHiddenInformation || false;
    vm.finished = false;
    vm.courses = [];
    vm.group_shifts = [];
    vm.token = $stateParams.token;
    /** caso seja raio de sol, no reload do controller pega as informa'coes antigas */
    vm.responsible = vm.type_user_login  == 'enrolment_number' ? $stateParams.responsible :
     {
      type: 20,
      person_sex_id: 'M'
    };
    vm.sexs = [{
      id: 'M',
      name: 'Masculino'
    },
      {
        id: 'F',
        name: 'Feminino'
      }];

    vm.empty_dependent_object = {
      name: '',
      course_id: null,
      group_shift_id: null,
      person_sex_id: 'M',
      dob: a4Moment(),
      national_id_number: null,
      school_origin_id: null,
      type: 22,
      is_responsible: false
    };

    vm.dependents = [
      angular.copy(vm.empty_dependent_object)
    ];

    vm.loading = false;

    var ln = $(window).resize(function () {
      vm.resize();
    });


    vm.init = function () {
      vm.getLogo();
      vm.resize();
      vm.getLoginType();
      vm.getAllCompanies();
      if (angular.isDefined(vm.token) && vm.token !== null) {
        vm.getInfos();
      }
      $timeout(function () {
        vm.showResponsible = true;
        vm.show_form = true;
      }, 1000);

      if (angular.isDefined($rootScope.currentResponsibleAccount)) {
        angular.extend(vm.responsible, $rootScope.currentResponsibleAccount);
      }

    };

    vm.getLoginType = function () {
      LoginService.getLoginType()
        .then(function(response) {
          /** TODO: por enquanto pega apenas o primeiro companie
           *  que aparecer porque importa apenas se e o raio de sol
           *  ou nao, mas no futuro ser'a importante uma forma mais dinamica 
           */
          vm.type_user_login = response.plain()[0].type_user_login;
          if(response.plain()[0].type_user_login  == 'enrolment_number') {
            vm.responsible = $stateParams.responsible !== null ? $stateParams.responsible : vm.responsible
          };
        })
    };
    /**
     * Ajusta tamanho do card
     */
    vm.resize = function () {
      vm.windowHeight = angular.element("body").height();
      vm.windowWidth = angular.element("body").width();
      if (vm.windowWidth < 1000) {
        vm.formWidth = 100;
      } else {
        vm.formWidth = 35;
      }
      $scope.$applyAsync();
    };

    /**
     * Habilita página de dependentes
     */
    vm.goToDependents = function () {
      vm.showResponsible = false;
      $timeout(function () {
        vm.showDependents = true;
      }, 1000)
    };

    /**
     * Busca logo da empresa
     */
    vm.getLogo = function () {
      var subdomain = $document[0].domain.split('.')[0];
      LoginService.getLogo(subdomain)
        .then(function (response) {
          vm.screen_image = response.image;
        })
    };

    /**
     * Busca turnos disponíveis para o curso
     * @param course_id
     */
    vm.getGroupShifts = function (course_id) {
      GroupsService.getAvailableGroupShifts({course_id: course_id})
        .then(function (group_shifts) {
          vm.group_shifts = group_shifts.plain();
        })
    };

    vm.getAllCompanies = function () {
      LoginService.getCompanys()
        .then(function (response) {
          vm.companies = response.plain();
        })
    };

    vm.filterCoursesByCompany = function (index) {
      console.log(vm.dependents[index]);
      vm.dependents[index].courses = vm.courses.filter(function(item) {
        return item.company_id === vm.dependents[index].company_id
      })
    };

    vm.getResponsibleData = function (isResponsible, index) {
      if(isResponsible) {
        $rootScope.show_loader = true
        ExternalPreEnrolmentService.getResponsibleData({token: vm.token})
          .then(function(response) {
            vm.dependents[index].name = response.plain().name;
            vm.dependents[index].person_sex_id = response.plain().person_sex_id;
            vm.dependents[index].national_id_number = response.plain().national_id_number;
            vm.dependents[index].school_origin_id = response.plain().school_origin_id;
            vm.dependents[index].dob = vm.responsible.dob;
            vm.dependents[index].is_responsible = true
            $rootScope.show_loader = false
          })
      } else {
        vm.dependents[index] = vm.empty_dependent_object;
      }
    }

    /**
     * Adiciona dependente
     */
    vm.addDependent = function () {
      vm.dependents.push(angular.copy(vm.empty_dependent_object));
    };

    /**
     * Submit para primeira etapa da matrícula online
     */
    vm.submit = function () {
      if (vm.responsible.password !== vm.responsible.password_confirm) {
        Common.Toast.error('A senha deve ser igual à confirmação da senha');
        return;
      }
      if (vm.responsible.email !== vm.responsible.email_confirmation) {
        Common.Toast.error('O email deve ser igual à confirmação do email');
        return;
      }
      vm.loading = true;
      ExternalPreEnrolmentService.submitPreEnrolment({responsible: vm.responsible})
        .then(function (response) {
          if (response) { 
            vm.show_form = false;
            if(vm.type_user_login == 'enrolment_number') {
              $state.go('public.external-pre-enrolment-confirmation', {
                responsible: vm.responsible
              });
            }
            $timeout(function () {
              vm.show_mail_sent = true;
            }, 1000);
            $scope.$applyAsync();
          }
        }).catch(function (error) {
          vm.loading = false;
          if (error.data.message.contains("EMAIL_ALREADY_EXISTS")) {
            Common.Toast.error("Esse email já está registrado no sistema, por favor utilize outro.")
          }
        })

    };

    /**
     * Busca informações para form
     */
    vm.getInfos = function (company_id) {
      StudentsService.getInfosForOnlineEnrolment({company_id: company_id}).then(function (response) {
        var infos = response.plain();
        vm.courses = infos.courses;
        vm.school_origins = infos.school_origins;
        vm.states = infos.states;
      })
    };

    /**
     * Cria escola de origem
     * @param dependent
     */
    vm.createNewSchoolOrigin = function (dependent) {
      ModalFactory.customClean('app/components/a4-student-form/modal-school-origin.html',
        /** @ngInject */
        function ModalSchoolOriginController($mdDialog, $q, ModalExtra, PersonService, StudentsService) {
          var vm = this;
          vm.states = [];
          vm.cities = [];
          vm.school_origin = {
            name: null,
            state_id: null,
            city: null
          };
          vm.states = ModalExtra.states;
          vm.closeModal = function () {
            $mdDialog.cancel();
          };
          vm.changeState = function (state) {
            PersonService.getCities(state)
              .then(function (response) {
                vm.cities = response.plain();
              })
          };
          vm.submit = function (school_origin) {
            StudentsService.createSchoolOrigin({school_origin: school_origin})
              .then(function (school) {
                $mdDialog.hide(school.id);
              })
          }
        }, 'vm', true, {
          states: vm.states
        }).then(function (school_origin_id) {
        if (school_origin_id !== null) {
          Common.Toast.success("Escola de origem criada com sucesso!");
          vm.getInfos();
          dependent.school_origin_id = school_origin_id;
        }
      })
    };

    vm.finish = function () {
      vm.loading = true;
      ExternalPreEnrolmentService.finish({
        responsible: vm.responsible,
        dependents: vm.dependents,
        token: vm.token
      }).then(function (response) {
        if (response) {
          Common.Toast.success('Processo de matrícula realizado com sucesso!');
          vm.showDependents = false;
          $timeout(function () {
            vm.finished = true;
          }, 1000);
        }
      })
    };

    vm.exit = function () {
      $state.go('public.login');
    };

    vm.init();

  }

  angular.module('app.educational.external-pre-enrolment')
    .controller('ExternalPreEnrolmentController', ExternalPreEnrolmentController);
})();
(function () {
    'use strict';
  
    angular.module('app.educational.external-person-edit', []);
  })();
(function () {
    'use strict';
  
    /** @ngInject */
    function routerConfig($stateProvider) {
      $stateProvider
        .state('public.external-person-edit', {
          url: '/educational/external-person-edit/:person_id',
          controller: 'ExternalPersonEditController',
          controllerAs: 'vm',
          templateUrl: 'app/educational/external-person-edit/views/index.html',
          public: true
        });
    }
  
    angular
      .module('app.educational.external-person-edit')
      .config(routerConfig);
  
  })();
(function () {
    'use strict';

    /** @ngInject */
    function ExternalPersonEditController($rootScope, Common, $stateParams, ResponsiblesService, ModalFactory, $timeout, $scope, Session, Utils, $document, LoginService) {
      var vm = this;
      vm.person_id = parseInt(atob($stateParams.person_id), 10);
      vm.show_form = false;
      vm.show_success_message = false;
      vm.windowHeight = angular.element("body").height();
      vm.windowWidth = angular.element("body").width();
      vm.formWidth = 35;
      vm.loading = false;

      vm.form = {
        mode_edit: true,
        person: {}
      };
      vm.list = {
        person: {}
      }
      
      // Objeto para armazenar as descrições dos valores selecionados
      vm.show = {};

      var ln = $(window).resize(function () {
        vm.resize();
      });

      vm.init = function () {
        vm.getLogo();
        vm.resize();
        vm.getResponsiblesById();
        vm.getFormInfos();
        $timeout(function () {
          vm.show_form = true;
        }, 1000);
      };

      /**
       * Ajusta tamanho do card
       */
      vm.resize = function () {
        vm.windowHeight = angular.element("body").height();
        vm.windowWidth = angular.element("body").width();
        if (vm.windowWidth < 1000) {
          vm.formWidth = 100;
        } else {
          vm.formWidth = 35;
        }
        $scope.$applyAsync();
      };

      /**
       * Busca logo da empresa
       */
      vm.getLogo = function () {
        var subdomain = $document[0].domain.split('.')[0];
        LoginService.getLogo(subdomain)
          .then(function (response) {
            vm.screen_image = response.image;
          })
          .catch(function (error) {
            console.log('Erro ao carregar logo:', error);
          });
      };

      /**
       * Busca a descrição de um valor baseado no ID
       */
      vm.getDescriptionById = function(list, id) {
        if (!list || !id) return null;
        for (var i = 0; i < list.length; i++) {
          if (list[i].id == id) {
            return list[i].name;
          }
        }
        return null;
      };

      /**
       * Atualiza o objeto show com as descrições dos valores selecionados
       */
      vm.updateShowObject = function() {
        vm.show = {};
        
        // Estado civil
        if (vm.form.person.person_marital_status_id) {
          vm.show.person_marital_status_id = vm.getDescriptionById(
            vm.list.person.person_marital_status_id, 
            vm.form.person.person_marital_status_id
          );
        }
        
        // Cor/Raça
        if (vm.form.person.person_color_id) {
          vm.show.person_color_id = vm.getDescriptionById(
            vm.list.person.person_color_id, 
            vm.form.person.person_color_id
          );
        }
        
        // Nível educacional
        if (vm.form.person.person_educational_level_id) {
          vm.show.person_educational_level_id = vm.getDescriptionById(
            vm.list.person.person_educational_level_id, 
            vm.form.person.person_educational_level_id
          );
        }
        
        // Profissão
        if (vm.form.person.selected_profession) {
          vm.show.person_profession_id = vm.form.person.selected_profession.name;
        }
        
        // Sexo
        if (vm.form.person.person_sex_id) {
          vm.show.person_sex_id = vm.getDescriptionById(
            vm.list.person.person_sex_id, 
            vm.form.person.person_sex_id
          );
        }
      };

      vm.getResponsiblesById = function () {
        $rootScope.show_loader = true;
        ResponsiblesService.getById(vm.person_id, {is_external_page: true})
        .then(function(response) {
            vm.form.person = Utils.mergeObjects(angular.copy(response.person), angular.copy(response.person_parent));
            vm.person_copy = vm.form.person

            $rootScope.show_loader = false;
        })
        .catch(function(error) {
            console.log('Erro ao carregar dados da pessoa:', error);
            $rootScope.show_loader = false;
        });
      }

      vm.getFormInfos = function () {
        $rootScope.show_loader = true;
        ResponsiblesService.getPersonInfo()
          .then(function (response) {
            vm.list.person = response.person;
            $rootScope.show_loader = false;
            $timeout(function () {
              if (vm.form.person.person_profession_id !== null) {
                for (var i = vm.list.person.person_profession_id.length; i--;) {
                  if (vm.list.person.person_profession_id[i].id === vm.form.person.person_profession_id) {
                    vm.person_copy.selected_profession = vm.list.person.person_profession_id[i];
                  }
                }
              }
              // Atualiza o objeto show após carregar as informações
              vm.updateShowObject();
              $rootScope.show_loader = false;
            }, 2000);
          })
          .catch(function(error) {
              console.log('Erro ao carregar informações do formulário:', error);
              $rootScope.show_loader = false;
          });
      };

      vm.getProfessions = function (query) {
        $scope.person.new_profession_name = query;
        return ResponsiblesService.getProfessionsByQuery({query: query});
      };

      vm.changeProfession = function (item) {
        vm.person_copy.person_profession_id = angular.isUndefined(item) || item === null ? null : item.id;
        // Atualiza o objeto show quando a profissão muda
        vm.updateShowObject();
      };

      vm.submit = function (form, item) {
        if (!form.$invalid) {
          vm.loading = true;
          $rootScope.show_loader = true;
          
          // Atualiza o objeto show antes de enviar
          vm.updateShowObject();
          
          /** Realiza a copia dos dados */
          var new_item = angular.copy(item);

          if (vm.form.person.selected_profession !== null) {
            new_item.new_profession_name = vm.form.person.selected_profession;
          }
          
          // Adiciona o objeto show aos dados enviados
          new_item.show = vm.show;

          ResponsiblesService.saveEditLog(new_item)
            .then(function () {
              $rootScope.show_loader = false;
              vm.loading = false;

              // Desabilita a edição após sucesso
              vm.form.mode_edit = false;

              // Esconde o formulário e mostra mensagem de sucesso
              vm.show_form = false;
              $timeout(function () {
                vm.show_success_message = true;
              }, 1000);

              // Mostra modal de agradecimento
              ModalFactory.alert(
                "Obrigado!",
                "Obrigado pela atualização das suas informações.",
                "modal",
                "OK",
                "false",
                "educational"
              );
            })
            .catch(function (error) {
                Common.Toast.error('Requisição de edição não pode ser feita.');
                $rootScope.show_loader = false;
                vm.loading = false;
            })
        } else {
          Common.Toast.error('Informação inválida no formulário');
        }
      };

      vm.init();
    }

    angular.module('app.educational.external-person-edit')
      .controller('ExternalPersonEditController', ExternalPersonEditController);
  })();

(function () {
  'use strict';
  angular.module('app.educational.external-document-assign', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function SignDocumentController(CONFIG, $http, $rootScope, Common, ModalExtra, EnrolmentService,
                                  ReportsService, Session, $sce, $mdDialog, LocalStorage, $filter) {

    var vm = this;
    vm.conf = {};
    vm.show_loader = false;
    vm.show_sign = false;
    vm.loading = false;
    vm.user = Session.getUser();
    vm.person = vm.user !== null && angular.isDefined(vm.user.person) ? vm.user.person : {email: 'email'};
    vm.person.email = vm.person.email === null || angular.isUndefined(vm.person.email) ? vm.user.email : vm.person.email;
    vm.companies = LocalStorage.get(CONFIG.storage.companies);
    vm.config = angular.isDefined(vm.companies) && vm.companies !== null ? $filter('filter')(vm.companies, {id: Session.getCurrentCompany()})[0].config : null;
    vm.list = {enrolment: {attendance_mode_id: [{id: 1, name: 'Presencial'}, {id: 2, name: 'On-line'}]}};
    vm.form = {mode_edit: true, enrolment: {attendance_mode_id: null}};

    vm.init = function () {
      vm.data = ModalExtra;
      vm.data.form = vm.form;
      // vm.student.content = null;
      // vm.person.content = vm.student.content;
      // if (angular.isDefined(vm.student.artifact_id) && vm.student.artifact_id !== null){
      //   vm.show_sign = true;
      // }
      // if (angular.isDefined(vm.student.config) && vm.student.config !== null) {
      vm.config = vm.data.config;
      vm.person = angular.copy(vm.data);
      // }
      vm.getContract();
    };

    vm.getContract = function () {
      vm.show_loader = true;
      vm.filter = {
        selectedPerson: {'id': vm.data.student_id},
        is_financial_resp: true
      };
      var obj = {filter: vm.filter, id: vm.data.document_id, school_period_id: vm.data.school_period_id};
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/document/generateDocuments',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var file = new Blob([data], {type: headers['content-type']});
        var fileURL = window.URL.createObjectURL(file);
        vm.data.content = $sce.trustAsResourceUrl(fileURL);
        vm.show_loader = false;
        $rootScope.show_loader = false;
      });
    };

    vm.printEnrolmentContract = function () {
      vm.loading = true;
      vm.filter = {
        selectedPerson: {'id': vm.data.student_id},
        is_financial_resp: true
      };
      var obj = {filter: vm.filter, id: vm.data.document_id, school_period_id: vm.data.school_period_id};
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/document/generateDocuments',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var file = new Blob([data], {type: headers['content-type']});
        var fileURL = window.URL.createObjectURL(file);
        var linkElement = document.createElement('a');
        // vm.data.content = $sce.trustAsResourceUrl(fileURL);
        linkElement.setAttribute('href', fileURL);
        linkElement.setAttribute('target', '_blank');
        var clickEvent = new MouseEvent("click", {
          "view": window, "bubbles": true, "cancelable": false
        });
        linkElement.dispatchEvent(clickEvent);
        vm.show_loader = false;
        $rootScope.show_loader = false;
      });
    };

    /**
     * Fecha o modal
     */
    vm.closeModal = function () {
      // $mdDialog.hide();
    };

    vm.init();
  }

  angular.module('app.educational.external-document-assign')
    .controller('SignDocumentController', SignDocumentController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('public.external-document-assign', {
        url: '/educational/external-document-assign/:token',
        controller: 'ExternalDocumentAssignController',
        controllerAs: 'vm',
        templateUrl: 'app/educational/external-document-assign/views/index.html',
        public: true

      })

  }

  angular
    .module('app.educational.external-document-assign')
    .config(routerConfig);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ExternalDocumentAssignController($document, $scope, $stateParams, $rootScope, a4Moment, Utils, EnrolmentService, LoginService,
                                            $interval,
                                            ContractService, CONFIG, Common, DocumentsService, ModalFactory, $http, PersonService, $timeout) {
    var vm = this;
    vm.windowHeight = angular.element("body").height();
    vm.windowWidth = angular.element("body").width();
    vm.url_background = 'url(../assets/images/backgrounds/' + new Date().toLocaleString('en-US', {'month': 'long'}).toLowerCase() + '.jpg)';
    vm.showAssign = false;
    vm.show_loader = false;
    vm.showAuthentication = false;
    vm.cpfFormWidth = 30;
    vm.token = $stateParams.token;
    var ln = $(window).resize(function () {
      vm.windowHeight = angular.element("body").height();
      vm.windowWidth = angular.element("body").width();
      if (vm.windowWidth < 1000) {
        vm.cpfFormWidth = 100;
      }
      $scope.$applyAsync();
    });

    vm.getLogo = function () {
      var subdomain = $document[0].domain.split('.')[0];
      LoginService.getLogo(subdomain)
        .then(function (response) {
          vm.screen_image = response.image;
        })
    };

    /**
     * Decide qual modal abrir a depender da informação do token
     * Se for array, é porque o token veio no formato enrolment_period_id-document_id
     * Senão, veio bill_serie_id
     */
    vm.sign = function (document) {
      if(document.email === null || document.email === '') {
        return Common.Toast.error("pessoa sem email cadastrado");
      }
      if (angular.isArray(vm.token_decoded) && vm.token_decoded.length > 1) {
        vm.signDocument(document);
      } else {
        vm.signContract(document);
      }
    };

    /**
     * Abre o contrato para visualização
     */
    vm.signContract = function (document) {
      ModalFactory.customClean(
        'app/educational/re-enrollment/contract.html',
        'SignContractEnrolmentResponsiblesController',
        'vm',
        false,
        document
      ).then(function () {
        document.artifact_id = 1;
        document.sign_confirmed = true;
        /*ModalFactory.customClean(
          'app/educational/re-enrollment/print-documents.html',
          'PrintDocumentsEnrolmentResponsiblesController',
          'vm',
          false,
          vm.data
        )*/
      })
    };

    /**
     * Abre o documento para visualização
     */
    vm.signDocument = function (document) {
      ModalFactory.customClean(
        'app/educational/external-document-assign/views/document.html',
        'SignDocumentController',
        'vm',
        false,
        document
      ).then(function () {
        document.artifact_id = 1;
        document.sign_confirmed = true;
        /*ModalFactory.customClean(
          'app/educational/re-enrollment/print-documents.html',
          'PrintDocumentsEnrolmentResponsiblesController',
          'vm',
          false,
          vm.data
        )*/
      })
    };


    /**
     * Decide qual documento imprimir a depender da informação do token
     * Se for array, é porque o token veio no formato enrolment_period_id-document_id
     * Senão, veio bill_serie_id
     */
    vm.print = function (document) {
      if (angular.isArray(vm.token_decoded) && vm.token_decoded.length > 1) {
        vm.printDocument(document);
      } else {
        vm.printContract(document);
      }
    };

    vm.printContract = function (document) {
      vm.show_loader = true;
      if (document.config.enrolment_online_is_electronic_signature === false) {
        EnrolmentService.printEnrolmentContract({
          person_id: document.student_id,
          group_id: document.group_id,
          school_period_id: document.school_period_id
        })
          .then(function () {
            vm.show_loader = false;
            Common.Toast.success('Download concluído');
          })
          .catch(function (error) {
            vm.show_loader = false;
            Common.Toast.warning(error.data.message);
          });
      } else {
        ContractService.printDocument(document.bill_serie_id)
          .then(function () {
            vm.show_loader = false;
            Common.Toast.success('Download concluído');
          })
          .catch(function (error) {
            vm.show_loader = false;
            Common.Toast.warning(error.data.message);
          });
      }
    };

    vm.printDocument = function (document) {
      vm.loading = true;
      $rootScope.show_loader = false;
      var obj = {
        enrolment_period_id: document.enrolment_period_id,
        id: document.document_id,
        school_period_id: document.school_period_id
      };
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/document/generateDocumentAssign',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var file = new Blob([data], {type: headers['content-type']});
        var fileURL = window.URL.createObjectURL(file);
        var linkElement = document.createElement('a');
        linkElement.setAttribute('href', fileURL);
        linkElement.setAttribute('target', '_blank');
        var clickEvent = new MouseEvent("click", {
          "view": window, "bubbles": true, "cancelable": false
        });
        linkElement.dispatchEvent(clickEvent);
        vm.show_loader = false;
        $rootScope.show_loader = false;
      });
    };

    vm.verifyCpf = function () {
      if (vm.cpf === vm.data[0].national_id_number) {
        vm.showAuthentication = false;
        vm.showAssign = true;
      } else {
        Common.Toast.error('CPF/CNPJ incorreto.');
      }
    };

    vm.init = function () {
      vm.getLogo();
      if (vm.windowWidth < 1000) {
        vm.cpfFormWidth = 100;
      }
      vm.token_decoded = atob(vm.token).split('-');
      DocumentsService.getInfoForExternalDocumentAssign({token: vm.token})
        .then(function (response) {
          vm.data = response.plain()
          vm.showAuthentication = true;
        })
    };

    vm.init();
  }

  angular.module('app.educational.external-document-assign')
    .controller('ExternalDocumentAssignController', ExternalDocumentAssignController);
})();

(function () {
  'use strict';

  angular
    .module('app.educational.events', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function EventsService(Restangular) {

    var getListValuesForEvents = function () {
      return Restangular.one('events').one('getlistvalues').get();
    };

    var saveEvents = function (obj) {
      return Restangular.all('events').post(obj);
    };

    var updateEvent = function (obj) {
      return Restangular.one('events').all('updateevent').post(obj);
    };

    return {
      getListValuesForEvents: getListValuesForEvents,
      saveEvents: saveEvents,
      updateEvent: updateEvent
    }
  }
  angular
    .module('app.educational.events')
    .factory('EventsService', EventsService);

})();

(function () {
  'use strict';

  /** @ngInject */
  function EvaluationCriteriaService(Restangular) {

    /**
     * Retorna todos os critérios
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('graderule').get(obj);
    };

    /**
     * Retorna o critério pelo id
     * @returns array
     */
    var getById = function (id) {
      return Restangular.one('graderule', id).get();
    };

    /**
     * Cria um novo critério
     * @param obj
     */
    var createGradeRule = function (obj) {
      return Restangular.all('graderule').post(obj);
    };

    /**
     * Atualiza o critério
     * @param obj
     */
    var updateGradeRule = function (obj) {
      return Restangular.one('graderule', obj.id).customPUT(obj);
    };

    /**
     * Cria ou atualiza os itens de regras de critérios
     * @param obj
     */
    var createAndUpdateGradeRuleItem = function (obj) {
      return Restangular.all('graderule/createandupdategraderuleitem').post(obj);
    };

    var getGradeRoundRule = function () {
      return Restangular.all('graderule').one('getgraderoundrule').get();
    };

    /**
     * Deleta um critério
     * @param id - id do critério
     */
    var deleteCriteria = function (id) {
      return Restangular.one('graderule', id).remove();
    };

    /**
     * Deleta um evento do critério
     * @param id - id do evento do critério
     */
    var deleteGradeRuleItem = function (id) {
      return Restangular.one('graderule').one('deletegraderuleitem', id).remove();
    };

    var duplicateGradeRule = function (obj) {
      return Restangular.one('graderule', obj.id).all('duplicategraderule').post(obj);
    };



    return {
      getAll: getAll,
      getById: getById,
      deleteCriteria: deleteCriteria,
      createGradeRule: createGradeRule,
      updateGradeRule: updateGradeRule,
      createAndUpdateGradeRuleItem: createAndUpdateGradeRuleItem,
      getGradeRoundRule: getGradeRoundRule,
      deleteGradeRuleItem: deleteGradeRuleItem,
      duplicateGradeRule: duplicateGradeRule
    };

  }

  angular
    .module('app.educational.evaluation-criteria')
    .factory('EvaluationCriteriaService', EvaluationCriteriaService);

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.evaluation-criteria', {
        public: false,
        url: '/evaluation/criteria',
        templateUrl: 'app/educational/evaluation-criteria/views/evaluation-criteria.html',
        abstract: true
      })
      .state('private.educational.evaluation-criteria.list', {
        url: '/list',
        public: false,
        views: {
          'evaluation-criteria': {
            templateUrl: 'app/educational/evaluation-criteria/views/list.html',
            controller: 'EvaluationCriteriaController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.evaluation-criteria.edit', {
        url: '/:id/view',
        public: false,
        views: {
          'evaluation-criteria': {
            templateUrl: 'app/educational/evaluation-criteria/views/evaluation-criteria-page.html',
            controller: 'EvaluationCriteriaEditController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.evaluation-criteria.create', {
        url: '/create',
        public: false,
        views: {
          'evaluation-criteria': {
            templateUrl: 'app/educational/evaluation-criteria/views/evaluation-criteria-page.html',
            controller: 'EvaluationCriteriaCreateController',
            controllerAs: 'vm'
          }
        }
      });

  }

  angular
    .module('app.educational.evaluation-criteria')
    .config(routerConfig);

})();



(function () {
  'use strict';

  /** @ngInject */
  function EvaluationCriteriaEditController($state, $rootScope, $timeout, $filter, EvaluationCriteriaService, Common, ModalFactory) {

    var vm = this;
    vm.search_text = '';
    vm.replaceRegex = /(\W|\s)/g;
    vm.selected = null;
    vm.form = {
      mode_edit: false,
      evaluation_criteria: {}
    };
    vm.list = {
      evaluation_criteria: {},
      grade_rule_items: []
    };

    vm.init = function () {
      /**
       * Timeout posto por tempo de carregamento do form por ser muito grande
       * estar atrapalhando o carregamento dos dados
       */
      $timeout(function () {
        vm.getById($state.params.id);
      }, 1800)
    };

    /**
     * Adiciona etapas aos critérios
     */
    vm.addStep = function (list) {
      var item = {
        type: 'A',
        name: 'ITEM' + (list.length + 1),
        nodes: [],
        pass_grade: vm.form.grade_rule.pass_grade,
        max_grade: vm.form.grade_rule.max_grade,
        precision: vm.form.grade_rule.precision,
        grade_round_rule_id: vm.form.grade_rule.grade_round_rule_id,
        type_event: 'C'
      };

      list.push(item);
      vm.selectItem(item);
    };

    /**
     * Realiza a verificação da adição do item da lista
     */
    vm.add = function (item) {
      item.type = 'E';
      item.name = item.name.replace(vm.replaceRegex, '').toUpperCase();
      item.grade_rule_item_id_parent = item.parent;
      item.pass_grade = vm.form.grade_rule.pass_grade;
      item.max_grade = vm.form.grade_rule.max_grade;
      item.precision = vm.form.grade_rule.precision;
      item.grade_round_rule_id = vm.form.grade_rule.grade_round_rule_id;
      item.type_event = 'C';
    };

    /**
     * Realiza a verificação da seleção do item da lista
     */
    vm.selectItem = function (item) {
      vm.selected = item;

      /** Valores default */
      vm.selected.conditional = (angular.isDefined(item.conditional)) ? item.conditional : null;
      vm.selected.has_attendance = (angular.isDefined(item.has_attendance)) ? item.has_attendance : false;
      vm.selected.is_external_rule = (angular.isDefined(item.is_external_rule)) ? item.is_external_rule : false;
      vm.selected.show_on_grade = (angular.isDefined(item.show_on_grade)) ? item.show_on_grade : false;
      vm.selected.show_on_school_records = (angular.isDefined(item.show_on_school_records)) ? item.show_on_school_records : false;
      vm.selected.has_class_council = (angular.isDefined(item.has_class_council)) ? item.has_class_council : false;

      /** Tipo de evento */
      if (angular.isUndefined(vm.selected.type_event)) {
        vm.selected.type_event = (vm.selected.formula !== null) ? 'C' : 'L';
      }
    };

    /**
     * Realiza a verificação da remoção do item da lista
     */
    vm.delete = function (item) {

      /** Verifica se não possui eventos caso se trate de uma etapa */
      if (angular.isDefined(item.$parent.$nodeScope.$modelValue.nodes) && item.$parent.$nodeScope.$modelValue.nodes.length) {
        Common.Toast.error('Não é possível remover. É necessário remover os eventos antes de remover a etapa.');
      } else {
        if (angular.isDefined(item.$parent.$nodeScope.$modelValue.confirm_id)) {

          /** Realiza a confirmação de remoção e executa se assim desejar */
          ModalFactory.confirm(null,
            'Atenção',
            "Deseja realmente deletar este critério?",
            "Confirmar", "Cancelar", "educational")
            .then(function () {
              EvaluationCriteriaService.deleteGradeRuleItem(item.$parent.$nodeScope.$modelValue.confirm_id)
                .then(function () {
                  item.remove();
                  Common.Toast.success('Critério removido com sucesso.');
                  $rootScope.show_loader = false;
                });
            })
            .catch(function (response) {
              if (response.data.message === 'CRITERIA_ASSOCIATED_EVENTS') {
                Common.Toast.warning('Não é possível remover a etapa que possui eventos.');
              }
              $rootScope.show_loader = false;
            });

        } else {
          item.remove();
        }
      }
    };


    /**
     * Resgata o objeto referente ao critério
     * @param id - identificador do critério
     */
    vm.getById = function (id) {
      $rootScope.show_loader = true;
      EvaluationCriteriaService.getById(id)
        .then(function (response) {
          vm.form.grade_rule = response.grade_rule;
          vm.list.grade_rule_items = response.grade_rule_items = $filter('orderBy')(response.grade_rule_items, 'seq');
          vm.list.grade_code_rule_item = response.grade_code_rule;
          vm.list.grade_round_rule_item = response.grade_round_rule;

          /** Define um item padrão quando não houver critérios do banco */
          vm.list.grade_rule_items = (vm.list.grade_rule_items.length) ? vm.list.grade_rule_items : [];

          vm.list.grade_rule_items = vm.list.grade_rule_items.filter(function (item) {
            item.confirm_id = item.id;
            /** Tratamento nos itens filhos */
            if (item.nodes.length > 0) {
              item.nodes = item.nodes.filter(function (value) {
                value.confirm_id = value.id;
                $rootScope.show_loader = false;
                return value;
              });
            }
            $rootScope.show_loader = false;
            return item;
          });
          $rootScope.show_loader = false;

          /** Define o item da lista, como o selecionado */
          if (angular.isDefined(vm.list.grade_rule_items[0])) {
            vm.selectItem(vm.list.grade_rule_items[0]);
          }


        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Não foi possivel recuperar o critério.');
        });
    };

    /**
     * Submissão para atualização de critério
     */
    vm.submitGradeRule = function (item, form) {
      if (form.$valid) {
        $rootScope.show_loader = true;
        EvaluationCriteriaService.updateGradeRule(item)
          .then(function () {
            Common.Toast.success('Critério atualizado com sucesso');
            $rootScope.show_loader = false;
          })
          .catch(function (response) {
            if (response.data.message === 'CRITERIA_UPDATE_ERROR') {
              Common.Toast.warning('Não é possível atualizar o critério.');
            }
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Submissão para adição de itens de criétio
     */
    vm.submitGradeRuleItems = function (items, form, saved_by_grouping) {
      var new_items = angular.copy(items);
      $rootScope.show_loader = true;

      /** Tratamento da ordenação necessário para migração */
      var i = 0;
      angular.forEach(new_items, function (items) {
        items.seq = i;
        angular.forEach(items.nodes, function (item) {
          item.seq = i++;
        });
        i++;
      });

      /** Tratamento nos itens pai */
      new_items = new_items.filter(function (value) {
        value = vm.treeTreatment(value);
        /** Tratamento nos itens filhos */
        if (value.nodes.length > 0) {
          value = angular.extend(value, vm.newGroupingObject());
          value.nodes = value.nodes.filter(function (item) {
            item = vm.treeTreatment(item);
            return item;
          });
        }
        return value;
      });

      /** Valida e submete o formulário de critério */
      if (form.$valid || saved_by_grouping) {
        ModalFactory.confirm(null, "Recálculo de notas",
          "Atenção! Ao salvar este critério serão recalculadas as notas de todos os alunos das turmas associadas.",
          'Confirmar', 'Cancelar', 'educational')
          .then(function () {
            ModalFactory.custom('app/educational/evaluation-criteria/views/alertLoading.html');
            vm.promise = EvaluationCriteriaService.createAndUpdateGradeRuleItem({
              grade_rule_items: new_items, grade_rule_id: $state.params.id
            }).then(function () {
              vm.getById(new_items[0].grade_rule_id);
              Common.Toast.success('Eventos de critério atualizados com sucesso');
              $timeout(function () {
                $rootScope.$broadcast('CUSTOM.close');
              }, 2000);
              $rootScope.show_loader = false;
            }).catch(function (response) {
              if (response.data.message === 'CRITERIA_CREATE_ITEM_ERROR') {
                Common.Toast.warning('Não é possível criar o evento de critério.');
              } else if (response.data.message === 'CRITERIA_UPDATE_ITEM_ERROR') {
                Common.Toast.warning('Não é possível atualizar o evento de critério.');
              } else {
                Common.Toast.warning(response.data.message);
              }
              $timeout(function () {
                $rootScope.$broadcast('CUSTOM.close');
              }, 2000);
              $rootScope.show_loader = false;
            });
          }).catch(function () {
          $rootScope.show_loader = false;
        });
      }
    };

    /**
     * Executa tratamentos no objeto de saida para salvamento
     * @param item - item para tratamento.
     * @returns {*}
     */
    vm.treeTreatment = function (item) {
      /** Move o confirm_id para o id se houver e remove o id padrão do angular-ui-tree */
      if (angular.isDefined(item.confirm_id)) {
        item.id = item.confirm_id;
        delete item.confirm_id;
      } else {
        delete item.id;
      }

      return item;
    };

    /**
     *
     * @param value
     * @returns {{company_id_migration: null, conditional: null, description: string, formula: null, formula_aux: null, grade_code_rule_id: null, grade_round_rule_id: number, grade_rule_id: number, grade_rule_item_id_parent: null, has_attendance: boolean, has_class_council: boolean, id: number, is_external_rule: boolean, is_pf_rc: null, label: string, max_grade: string, name: string, pass_grade: string, precision: number, seq: null, show_on_grade: boolean, show_on_school_records: boolean, type: string, type_event: string}}
     */
    vm.newGroupingObject = function () {
      return {
        company_id_migration: null,
        conditional: null,
        formula: null,
        formula_aux: null,
        grade_code_rule_id: null,
        grade_rule_item_id_parent: null,
        has_attendance: false,
        has_class_council: false,
        is_external_rule: false,
        is_pf_rc: null,
        max_grade: null,
        pass_grade: null,
        precision: null,
        show_on_grade: false,
        show_on_school_records: false
      };
    };


    vm.init();

  }

  angular
    .module('app.educational.evaluation-criteria')
    .controller('EvaluationCriteriaEditController', EvaluationCriteriaEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function EvaluationCriteriaCreateController($state, $rootScope, EvaluationCriteriaService, Common) {

    var vm = this;
    vm.search_text = '';
    vm.valueDefault = [{grade_rule_id: 'Critério', conditional: 'launched'}];
    vm.form = {
      grade_rule: {},
      mode_edit: true,
      evaluation_criteria: {}
    };
    vm.list = {
      evaluation_criteria: {}
    };

    vm.init = function () {
      /** Define um item padrão quando não houver critérios do banco */
      vm.list.grade_rule_items = vm.valueDefault;
      vm.selectItem(vm.list.grade_rule_items[0]);
      vm.getGradeRoundRule();
    };

    /**
     * Adiciona etapas aos critérios
     */
    vm.addStep = function (list) {
      list.push({name: 'Item ' + (list.length + 1), nodes: []});
    };

    /**
     * Realiza a verificação da seleção do item da lista
     */
    vm.selectItem = function (item) {
      vm.selected = item;
      if (angular.isUndefined(item.conditional)) {
        vm.selected.conditional = 'launched';
      }
    };

    /**
     * Realiza a verificação da remoção do item da lista
     */
    vm.delete = function (item) {
      item.remove();
    };

    /**
     * Realiza a verificação da adição do item da lista
     */
    vm.add = function (item) {
    };

    /**
     * Resgata a lista de regra de arredondamento
     */
    vm.getGradeRoundRule = function () {
      EvaluationCriteriaService.getGradeRoundRule()
        .then(function (response) {
          vm.list.grade_round_rule_item = response;
        });
    };

    /**
     * Submissão do critério
     */
    vm.submitGradeRule = function (item, form) {
      if (form.$valid) {
        $rootScope.show_loader = true;
        EvaluationCriteriaService.createGradeRule(item)
          .then(function (response) {
            Common.Toast.success('Critério criado com sucesso');
            $state.go('private.educational.evaluation-criteria.edit', {id: response.result});
            vm.form.mode_edit = false;
            $rootScope.show_loader = false;
          })
          .catch(function (error) {
            Common.Toast.error(error.message || error.data.message);
            $rootScope.show_loader = false;
          });
      }
    };

    vm.init()

  }

  angular
    .module('app.educational.evaluation-criteria')
    .controller('EvaluationCriteriaCreateController', EvaluationCriteriaCreateController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function EvaluationCriteriaController($rootScope, $scope, $state, $a4FloatButton, EvaluationCriteriaService, ModalFactory, Common) {

    var vm = this;

    vm.grid = {rows: [], info: {}};
    vm.form = {};

    /**
     * Evento de inicialização da tela
     * @type {*}
     */
    var ltn = $rootScope.$on('a4-grid-dic-data.loaded', function () {
      vm.paginate();
    });

    var ltn1 = $rootScope.$on('update.evaluation-criteria.list', function () {
      vm.paginate();
    });

    vm.init = function () {
      vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createEvaluationCriteria()', icon: 'add'});
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterEvaluationCriteriaList = function (query) {
      EvaluationCriteriaService.getAll({query: query})
        .then(function (response) {
          vm.grid.rows = response.plain();
        })
    };

    /**
     * Manda para a criação de critérios
     */
    vm.createEvaluationCriteria = function () {
      $state.go('private.educational.evaluation-criteria.create');
    };

    /**
     * Edição do critério
     * @param item - item a ser editado
     */
    vm.editEvaluationCriteria = function (item) {
      $state.go('private.educational.evaluation-criteria.edit', {id: item.id});
    };

    /**
     * Paginação dos critérios existentes
     */
    vm.paginate = function (page, limit) {
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      $rootScope.show_loader = true;

      vm.grid.promise = EvaluationCriteriaService.getAll({limit: limit, page: page})
        .then(function (response) {
          vm.grid.rows = response.data;
          console.log(vm.grid.rows)
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };


    vm.delete = function (index) {
      ModalFactory.confirm(null,
        'Confirmação de Exclusão',
        'Deseja realmente excluir o critério?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          $rootScope.show_loader = true;
          EvaluationCriteriaService.deleteCriteria(index)
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Critério excluído com sucesso!');
              vm.paginate();
            }).catch(function (response) {
            $rootScope.show_loader = false;
            if (response.data.message === 'CRITERIA_ASSOCIATED_GROUP') {
              Common.Toast.warning('Não é possível excluir o critério, ele está associado a uma turma.');
            } else {
              Common.Toast.error('Erro ao excluir o critério.');
            }
          })
        })
    };

    vm.clickAction = function (item, option) {
      switch (option) {
        case 'duplicate':
          vm.duplicateGradeRule(item);
          break;
      }
    };

    vm.duplicateGradeRule = function (grade_rule) {
      ModalFactory.confirm(null, 'Duplicar critério de avaliação',
        'Deseja realmente duplicar este critério?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          $rootScope.show_loader = true;
          EvaluationCriteriaService.duplicateGradeRule(grade_rule)
            .then(function () {
              Common.Toast.success('Critério duplicado com sucesso!');
              vm.paginate();
            }).catch(function (error) {
            Common.Toast.error(error.data.message);
          })
        });
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.evaluation-criteria')
    .controller('EvaluationCriteriaController', EvaluationCriteriaController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function EnrolmentService(Restangular, $http, CONFIG, Common) {

    /**
     * Retorna todos os cursos e turmas ativas
     *
     */
    var getEnrolmentFormInfo = function (obj) {
      return Restangular.one('enrolment').one('getenrolmentforminfo').get(obj);
    };

    /**
     * Retorna uma matricula ativa em Progresso da pessoa
     *
     */
    var getEnrolmentProgress = function (person_id) {
      return Restangular.one('enrolment').one('person', person_id).one('progress').get();
    };

    /**
     * Retorna pendencias financeira de uma pessoa
     */
    var getPaymentPendences = function (person_id) {
      return Restangular.one('enrolment').one('person', person_id).one('pendences').get();
    };

    var getAllEnrolmentStatus = function () {
      return Restangular.one('enrolment').one('getallenrolmentstatus').get();
    };
    /**
     * Realiza a verificação de vagas da turma
     * @returns array
     */
    var checkForEnrolmentVacancies = function (group_id) {
      return Restangular.one('enrolment').one('checkforenrollmentvacancies').get({group_id: group_id});
    };

    var getEnrolmentStudent = function (query) {
      return Restangular.one('enrolment').one('student').get(query);
    };

    var getPersonRelationLegal = function () {
      return Restangular.one('enrolment').one('getpersonrelationlegal').get();
    };

    var getDatesForEnrolmentOnline = function () {
      return Restangular.one('enrolment').one('getdatesenrolmentonline').get();
    };

    var getContractType = function (obj) {
      return Restangular.one('enrolment').one('getcontracttype').get(obj);
    };

    var getPersonResponsableLegal = function (query) {
      return Restangular.one('enrolment').one('getpersonresponsablelegal').get(query);
    };

    var getSubjectScheduleGrade = function (course_id, group_id) {
      return Restangular.one('enrolment').one('schedule').get({course_id: course_id, group_id: group_id});
    };

    /**
     * Realiza a sugestão do curso a partir do aluno já matriculado na casa
     * @param person_id
     */
    var getSuggestionForCoursesAndGroups = function (person_id) {
      return Restangular.one('enrolment').one('getsuggestionforcoursesandgroups').get({person_id: person_id});
    };

    var storeStudent = function (obj) {
      return Restangular.one('enrolment').all('student').post(obj);
    };

    var storeSubject = function (obj) {
      return Restangular.one('enrolment').all('subject').post(obj);
    };

    var getCancelReasons = function () {
      return Restangular.one('enrolment').one('getcancelreasons').get();
    };

    var storeAddressAndDocuments = function (obj) {
      return Restangular.one('enrolment').one('address').all('documents').post(obj);
    };

    var storeMedicalRecords = function (obj) {
      return Restangular.one('enrolment').all('medicalrecords').post(obj);
    };

    var setStatusForWaitingForPayment = function (obj) {
      return Restangular.one('enrolment').all('setstatusforwaitingforpayment').post(obj);
    };

    var setStatusForWaitingOnlineEnrolment = function (obj) {
      return Restangular.one('enrolment').all('setstatusforwaitingonlineenrolment').post(obj);
    };

    var storeResponsibles = function (obj) {
      return Restangular.one('enrolment').all('responsibles').post(obj);
    };

    var storeContract = function (obj) {
      return Restangular.one('enrolment').all('makecontract').post(obj);
    };

    var getCurrentSchoolPeriodId = function () {
      return Restangular.one('enrolment').one('getcurrentschoolperiod').get();
    };

    var getGroupsEnrolment = function (obj) {
      return Restangular.one('enrolment').one('getgroupsenrolment').get(obj);
    };

    var conditionalGroupEnrollment = function (obj) {
      return Restangular.one('enrolment').all('conditionalgroupenrollment').post(obj);
    };

    var confirmEnrolment = function (obj) {
      return Restangular.one('enrolment').all('confirmenrolment').post(obj);
    };

    var confirmMultipleEnrolments = function (obj) {
      return Restangular.one('enrolment').all('confirmmultipleenrolments').post(obj);
    };

    var printEnrolmentForm = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/printenrolmentform?token=' + obj.token + '&student_id=' + obj.person_id +
          '&school_period_id=' + obj.school_period_id + '&option=1',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var printEnrolmentContract = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'GET',
        url: CONFIG.webApiUri + 'api/reports/printenrolmentcontract?person_id=' + obj.person_id
          + (angular.isDefined(obj.group_id) ? ('&group_id=' + obj.group_id) : '')
          + (angular.isDefined(obj.school_period_id) ? ('&school_period_re_enrolment=' + obj.school_period_id) : '')
          + (angular.isDefined(obj.bill_serie_id) ? ('&bill_serie_id=' + obj.bill_serie_id) : '')
          + (angular.isDefined(obj.is_finance) ? ('&is_finance=' + obj.is_finance) : ''),
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };


    /**
     * Retorna as informações necessárias para o formulário.
     */
    var getListIdIssuer = function () {
      return [
        {id: 'SSP', name: 'Secretaria de Segurança Pública'},
        {id: 'PM', name: 'Polícia Militar'},
        {id: 'PC', name: 'Policia Civil'},
        {id: 'CNT', name: 'Carteira Nacional de Habilitação'},
        {id: 'DIC', name: 'Diretoria de Identificação Civil'},
        {id: 'CTPS', name: 'Carteira de Trabaho e Previdência Social'},
        {id: 'FGTS', name: 'Fundo de Garantia do Tempo de Serviço'},
        {id: 'IFP', name: 'Instituto Félix Pacheco'},
        {id: 'IPF', name: 'Instituto Pereira Faustino'},
        {id: 'IML', name: 'Instituto Médico:Legal'},
        {id: 'MTE', name: 'Ministério do Trabalho e Emprego'},
        {id: 'MMA', name: 'Ministério da Marinha'},
        {id: 'MAE', name: 'Ministério da Aeronáutica'},
        {id: 'MEX', name: 'Ministério do Exército'},
        {id: 'POF', name: 'Polícia Federal'},
        {id: 'POM', name: 'Polícia Militar'},
        {id: 'SES', name: 'Carteira de Estrangeiro'},
        {id: 'SJS', name: 'Secretaria da Justiça e Segurança'},
        {id: 'SJTS', name: 'Secretaria da Justiça do Trabalho e Segurança'},
        {id: 'ZZZ', name: 'Outros (inclusive exterior)'}
      ];
    };

    var getPaymentPlansForGroup = function (obj) {
      return Restangular.one('enrolment').one('getpaymentplansgroup').get(obj);
    };

    var printBankSlip = function (person_id, student_id, student_name) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/enrolment/' + person_id + '/' + student_id + '/printbankslip',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", student_name + '.pdf');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    /**
     * Realiza a impressão do boleto referente à primeira parcela das mensalidades
     */
    var printBankSlipEnrolment = function (person_id_beneficiary, school_period_id) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/enrolment/' + school_period_id + '/' + person_id_beneficiary + '/printbankslipenrolment',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", 'boleto_matricula_online.pdf');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var confirmEnrolmentOnline = function (obj) {
      return Restangular.one('enrolment').all('confirmenrolmentonline').post(obj);
    };

    var changeStatusEnrolmentSubject = function (obj) {
      return Restangular.one('enrolment').all('changestatusenrolmentsubject').post(obj);
    };

    var doEnrolmentSubject = function (obj) {
      return Restangular.one('enrolment').all('enrolmentsubject').post(obj);
    };

    var enrolmentDependency = function (obj) {
      return Restangular.one('enrolment').all('enrolmentdependency').post(obj);
    };

    var getSchoolRecordsObservation = function (obj) {
      return Restangular.one('enrolment').one('getschoolrecordsobservation').get(obj);
    };

    var saveSchoolRecordsObservation = function (obj) {
      return Restangular.one('enrolment').all('saveschoolrecordsobservation').post(obj);
    };

    var isCheckCpf = function (obj) {
      return Restangular.one('enrolment').one('ischeckcpf').get(obj);
    };

    return {
      getEnrolmentProgress: getEnrolmentProgress,
      getCurrentSchoolPeriodId: getCurrentSchoolPeriodId,
      getSubjectScheduleGrade: getSubjectScheduleGrade,
      getEnrolmentFormInfo: getEnrolmentFormInfo,
      checkForEnrolmentVacancies: checkForEnrolmentVacancies,
      getEnrolmentStudent: getEnrolmentStudent,
      getPersonResponsableLegal: getPersonResponsableLegal,
      getPersonRelationLegal: getPersonRelationLegal,
      getSchoolRecordsObservation: getSchoolRecordsObservation,
      saveSchoolRecordsObservation: saveSchoolRecordsObservation,
      getSuggestionForCoursesAndGroups: getSuggestionForCoursesAndGroups,
      storeStudent: storeStudent,
      getContractType: getContractType,
      storeSubject: storeSubject,
      setStatusForWaitingForPayment: setStatusForWaitingForPayment,
      storeAddressAndDocuments: storeAddressAndDocuments,
      storeMedicalRecords: storeMedicalRecords,
      storeResponsibles: storeResponsibles,
      storeContract: storeContract,
      getListIdIssuer: getListIdIssuer,
      conditionalGroupEnrollment: conditionalGroupEnrollment,
      getPaymentPlansForGroup: getPaymentPlansForGroup,
      confirmEnrolment: confirmEnrolment,
      getPaymentPendences: getPaymentPendences,
      printBankSlip: printBankSlip,
      printBankSlipEnrolment: printBankSlipEnrolment,
      getDatesForEnrolmentOnline: getDatesForEnrolmentOnline,
      confirmEnrolmentOnline: confirmEnrolmentOnline,
      printEnrolmentForm: printEnrolmentForm,
      printEnrolmentContract: printEnrolmentContract,
      getCancelReasons: getCancelReasons,
      getAllEnrolmentStatus: getAllEnrolmentStatus,
      changeStatusEnrolmentSubject: changeStatusEnrolmentSubject,
      getGroupsEnrolment: getGroupsEnrolment,
      doEnrolmentSubject: doEnrolmentSubject,
      enrolmentDependency: enrolmentDependency,
      confirmMultipleEnrolments: confirmMultipleEnrolments,
      setStatusForWaitingOnlineEnrolment: setStatusForWaitingOnlineEnrolment,
      isCheckCpf: isCheckCpf
    };
  }

  angular
    .module('app.educational.enrolment')
    .factory('EnrolmentService', EnrolmentService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.enrolment', {
        public: false,
        url: '/enrolment',
        templateUrl: 'app/educational/enrolment/views/enrolment.html',
        abstract: true
      })
      .state('private.educational.enrolment.new', {
          url: '/new/:pre_enrolment',
          public: false,
          params: {
            pre_enrolment: null
          },
          views: {
            'enrolment': {
              templateUrl: 'app/educational/enrolment/views/enrolment-page.html',
              controller: 'EnrolmentAssistantController',
              controllerAs: 'enrolment'
            },
            'init@private.educational.enrolment.new': {
              templateUrl: 'app/educational/enrolment/enrolment-steps/init/init.html',
              controller: 'InitStepController',
              controllerAs: 'vm'
            },
            'course@private.educational.enrolment.new': {
              templateUrl: 'app/educational/enrolment/enrolment-steps/course/course.html',
              controller: 'CourseStepController',
              controllerAs: 'vm'
            },
            'subject@private.educational.enrolment.new': {
              templateUrl: 'app/educational/enrolment/enrolment-steps/subject/subject.html',
              controller: 'SubjectStepController',
              controllerAs: 'vm'
            },
            'student@private.educational.enrolment.new': {
              templateUrl: 'app/educational/enrolment/enrolment-steps/student/student.html',
              controller: 'StudentStepController',
              controllerAs: 'vm'
            },
            'address@private.educational.enrolment.new': {
              templateUrl: 'app/educational/enrolment/enrolment-steps/address/address.html',
              controller: 'AddressStepController',
              controllerAs: 'vm'
            },
            'documents@private.educational.enrolment.new': {
              templateUrl: 'app/educational/enrolment/enrolment-steps/documents/documents.html',
              controller: 'DocumentsStepController',
              controllerAs: 'vm'
            },
            'medical_data@private.educational.enrolment.new': {
              templateUrl: 'app/educational/enrolment/enrolment-steps/medical_data/medical_data.html',
              controller: 'MedicalDataStepController',
              controllerAs: 'vm'
            },
            'responsibles@private.educational.enrolment.new': {
              templateUrl: 'app/educational/enrolment/enrolment-steps/responsibles/responsibles.html',
              controller: 'ResponsiblesStepController',
              controllerAs: 'vm'
            },
            'end@private.educational.enrolment.new': {
              templateUrl: 'app/educational/enrolment/enrolment-steps/end/end.html',
              controller: 'EndStepController',
              controllerAs: 'vm'
            }
          }
        }
      );
  }

  angular
    .module('app.educational.enrolment')
    .config(routerConfig);

})();
(function () {
  'use strict';

  /** @ngInject */
  function EnrolmentAssistantController($scope, $state, $rootScope, $stateParams, $timeout, $filter, a4Moment,
                                        ModalFactory, Common, EnrolmentService, moment, a4FormDicDataUtilsService, CourseDocumentsService,
                                        Session, StudentsService, CourseService, PersonService, SubjectService, GroupsService) {
    var enrolment = this;
    enrolment.course_id = null;
    /** Inicialização de variaveis */
    enrolment.stepSelected = 0;
    enrolment.current_school_period = Session.getCurrentSchoolPeriod().id;

    enrolment.steps = {
      inicio: {id: 0, completed: false, disabled: false},
      course: {id: 1, completed: false, disabled: true},
      students: {id: 2, completed: false, disabled: true},
      subject: {id: 3, completed: false, disabled: true},
      documents: {id: 4, completed: false, disabled: true},
      medical_data: {id: 5, completed: false, disabled: true},
      responsibles: {id: 6, completed: false, disabled: true},
      address: {id: 7, completed: false, disabled: true},
      end: {id: 8, completed: false, disabled: true}
    };

    enrolment.personSelected = {};
    enrolment.person_relation_suggestion = [
      {person_relation_type_id: 1, is_responsible: true},
      {person_relation_type_id: 1, is_responsible: true}
    ];
    enrolment.form = {
      show_cancel: false,
      mode_edit: true,
      search_text: '',
      person: {},
      person_student: {},
      student: null,
      enrolment: {},
      matrix: {},
      subject_period: {},
      timetable: {},
      person_medical_data: {},
      person_relation: {person_id_relation: []},
      subject: {},
      group: {group_id: {}},
      contract: {}
    };
    enrolment.list = {
      person: {name: [], search: []}, student: {search: []}, enrolment: {group_id: [], groups: []},
      matrix: {}, subject_period: {}, timetable: {course_id: [], group_id: []}, person_medical_data: {},
      person_relation: {search: [], person_id_relation: [], person_relation_type_id: [], groups: []},
      subject: {id: []}, group: {group_id: []},
      contract: {payment_plan_id: []}
    };
    enrolment.select_default = {name: "Selecione", id: null};
    enrolment.suggestion = {curse: {}, group_name: ""};
    enrolment.student = {};
    enrolment.student.idOfDocuments = [];

    /** Evento para realizar a sugestão de professor e horário a partir da disciplina */
    var ltn1 = $rootScope.$on('enrolment_group_id_change', function (ev, group_id) {
      enrolment.checkForEnrolmentVacancies(group_id);
      enrolment.getSubjectsForEnrolment(group_id);
      enrolment.getSubjectScheduleGrade(enrolment.course_id, group_id);
      enrolment.getPaymentPlansForGroup(group_id);
    });
    /**
     * Escuta mudança de objeto selecionado no autocomplete
     * @type {*}
     */
    var ltn2 = $rootScope.$on('student-search-autocomplete-item-change', function (ev, objPerson) {
      if (angular.isDefined(objPerson)) {
        $rootScope.show_loader = true;
        StudentsService.getById(objPerson.id, true)
          .then(function (person) {
            enrolment.form.student = person.person;
            enrolment.form.student.is_independent = angular.isUndefined(person.person_student) ? false : person.person_student.is_independent;
            enrolment.form.student.dob = a4Moment(enrolment.form.student.dob, 'YYYY-MM-DD');
            enrolment.form.student = angular.extend(enrolment.form.student, person.person_student);
            enrolment.personSelected = person;
            var person_id = (angular.isDefined(enrolment.form.student.id)) ? enrolment.form.student.id : null;
            enrolment.getPersonResponsableLegal(person_id, null, true);
            $scope.$applyAsync();
            $rootScope.show_loader = false;
          });
      }
    });

    /**
     * Escuta mudanças no texto escrito no autocomplete de seleção de alunos
     * @type {*}
     */
    var ltn3 = $rootScope.$on('student-search-autocomplete-text-change', function (ev, text) {
      if (angular.isDefined(text)) {
        enrolment.form.student = {};
        enrolment.form.student.name = text;
      }
    });
    /**
     * Esculta a troca do campo de Estado no formulário de criação de aluno
     * @type {*}
     */
    var ltn4 = $rootScope.$on('person_address_state_change', function (ev, address_state_id) {
      enrolment.form.person.address_city = null;
      enrolment.changeAddressState(address_state_id);
    });
    /**
     * Esculta a troca do campo de Estado no formulário de criação de aluno
     * @type {*}
     */
    var ltn5 = $rootScope.$on('person_birth_certificate_registry_state_change', function (ev, birth_certificate_registry_state) {
      enrolment.form.person.birth_certificate_registry_city = null;
      enrolment.changeAddressStateRegistry(birth_certificate_registry_state);
    });
    /**
     * Esculta a troca do campo de Estado no formulário de criação de aluno
     * @type {*}
     */
    var ltn6 = $rootScope.$on('person_school_origin_state_change', function (ev, school_origin_state) {
      enrolment.form.person.school_origin_city = null;
      enrolment.changeAddressStateSchool(school_origin_state);
    });
    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    var ltn7 = $rootScope.$on('address_postal_code.blur', function (ev, CEP) {
      // enrolment.getAddressByCep(CEP);
    });
    /** Evento para realizar a exibição das turmas de acordo com o curso */
    var ltn8 = $rootScope.$on('enrolment_course_id_change', function (ev, course_id) {
      enrolment.course_id = course_id;
      enrolment.changeCourse(course_id);
    });
    /** Evento para realizar a exibição das turmas de acordo com o curso */
    var ltn10 = $rootScope.$on('person_relation_person_relation_create', function (ev, text, data) {
      enrolment.createResponsibles(text, data);
    });

    /** Evento para selecionar a turma de acordo com a sugestão  */
    var ltn12 = $scope.$watch('vm.form.timetable.course_id', function (newVal, oldval) {
      var course = newVal;
      if (course !== oldval && angular.isDefined(course) && angular.isDefined(course.id)) {
        enrolment.changeCourse(course.id);
      }
    });
    /** Evento para realizar a exibição das turmas de acordo com a disciplina */
    var ltn13 = $rootScope.$on('subject_selected', function (ev, subject) {
      if (angular.isDefined(subject) && subject !== null) {
        enrolment.getGroupsForSubject(subject);
      }
    });
    /** Evento para adicionar o responsável à lista de responsáveis selecionados */
    var ltn14 = $rootScope.$on('person_relation_person_id_relation_click', function (ev, responsible) {
      enrolment.addResponsibleToList(responsible);
    });
    /** Evento para remover o responsável da lista de responsáveis selecionados */
    var ltn15 = $rootScope.$on('remove_responsible_selected', function (ev, responsible) {
      enrolment.removeResponsibleToList(responsible);
    });
    /** Evento busca de disciplinas */
    var ltn16 = $rootScope.$on('subject_search_change', function (ev, text) {
      enrolment.getSubjectsForEnrolment(enrolment.form.timetable.group_id, text);
    });
    /** Evento adição e remoção de turma selecionada para o grid na matricula */
    var ltn17 = $rootScope.$on('groups_selected_for_enrolment', function (ev, group_selected) {

      /** Timeout implementado para atrazo de scopo, por questões estritas do javascript*/
      $timeout(function () {
        /** Verifica se existem turmas reais para a disciplina escolhida */
        if (angular.isArray(group_selected.groups) && group_selected.groups.length > 0) {
          try {
            /** Verificação de choque de horário */
            group_selected.groups.forEach(function (item) {
              enrolment.verifyTimeShock(item, enrolment.form.subject.id);
            });

            /** Desabilitar e habilitar turmas não selecionadas */
            enrolment.ableAndDisableGroupsFromSubject(group_selected);

            /** Itera as celulas da grade para inserir uma nova disciplina */
            group_selected.groups.forEach(function (item) {
              /** Busca o indice do vetor para referencia da linha de horário */
              var indexRow = enrolment.form.subject.id.map(function (listItem) {
                return listItem.initial_time;
              }).indexOf(item.initial_time);

              /** Busca o indice do vetor para referencia da celula do horário */
              var indexCell = enrolment.form.subject.id[indexRow].schedule_subject.map(function (listItem) {
                return listItem.day_of_week;
              }).indexOf(item.day_of_week);

              /** Adiciona ou remove os objetos do grid*/
              if (angular.isDefined(enrolment.form.subject.id[indexRow].schedule_subject[indexCell].alias)) {
                /** Como as celulas já são criadas antes, para remover a disciplina apenas preenchemos a celula com um objeto padrão */
                enrolment.form.subject.id[indexRow].schedule_subject[indexCell] = {day_of_week: item.day_of_week}
              } else {
                /** Adiciona o item em uma nova celula */
                enrolment.form.subject.id[indexRow].schedule_subject[indexCell] = item;
              }

            });

            /** Liberação de co-requisitos */
            enrolment.coRequirementRelease(group_selected.groups, group_selected);
          } catch (err) {
            /** Em caso de choque de horário é mostrada uma mensagem para o usuário. */
            if (enrolment.form.subject.hide_message === true) {
              enrolment.form.subject.hide_message = false;
              angular.element("#alert-card-schedule-subheader").html(err.message);
            }
            /** Filtro na lista de disciplinas e turmas para realizar a desmarcação do checkbox selecionado pelo operador*/
            enrolment.list.subject.search.filter(function (item) {
              item.children = item.children.filter(function (child) {
                /** Realiza uma busca na lista de turmas, caso ache a equivalência então torna o checkbox unchecked */
                if (angular.isDefined(err.item.subject_id) && err.item.subject_id === child.id) {
                  child.checked = false;
                }
                return child;
              });
            });
          }
        }
      }, 100);
    });


    /**
     * Inicialização do Controlador
     */
    enrolment.init = function () {
      enrolment.form.pre_enrolment = $state.params.pre_enrolment;
    };

    /**
     * Resgata a grade de horário de um curso para visualização na matricula
     * @param course_id - identificador do curso
     * @param group_id - identificador da turma
     */
    enrolment.getSubjectScheduleGrade = function (course_id, group_id) {
      if (course_id != null && group_id != null) {
        EnrolmentService.getSubjectScheduleGrade(course_id, group_id)
          .then(function (schedules) {
            enrolment.form.subject.id = schedules.plain();
          });
      }
    };

    /**
     * Desabitita as turmas não selecionadas de uma disciplina, pois apenas é possivel se matricular em uma turma
     * de uma determinada disciplina.
     * @param group_selected - Turma selecionada
     */
    enrolment.ableAndDisableGroupsFromSubject = function (group_selected) {
      /** Filtro na lista de disciplinas */
      enrolment.list.subject.search.filter(function (item) {
        /** é selecionada apenas a disciplina na qual a turma foi selecionada */
        if (group_selected.id === item.id) {
          item.children = item.children.filter(function (child) {
            /** criado um novo atributo de controle, apenas para essa função */
            child.blocked = angular.isUndefined(child.blocked) ? false : child.blocked;
            if (group_selected.$$hashKey !== child.$$hashKey && child.blocked === false) {
              /** desabitita o checkbox */
              child.disabled = true;
              /** muda valor da variável de controle para TRUE */
              child.blocked = true;
            } else {
              /** habilita o checkbox */
              child.disabled = false;
              /** muda valor da variável de controle para FALSE */
              child.blocked = false;
            }
            return child;
          });
        }
        return item;
      })
    };

    /**
     * Realiza a liberação de disciplinas com co-requisito
     */
    enrolment.coRequirementRelease = function (groups) {
      enrolment.list.subject.search =
        /** Realização de um filtro para modificar os atributos da lista */
        enrolment.list.subject.search.filter(function (item) {
          /** Iteração dos items requeridos */
          item.requirements.forEach(function (requirement) {
            /** Realiza a modificação do atributo de bloqueio */
            if (requirement.subject_id_requirement === groups[0].subject_id) {
              if (item.disabled) {
                item.disabled = false;
              } else {
                item.expanded = false;
                item.disabled = true;
                /** Filtragem para desmarcar checkbox de turma marcada */
                item.children = item.children.filter(function (child) {
                  child.checked = false;
                  return child;
                });
                /**
                 * Verificação de disciplinas matriculadas, caso seja removida algum requisito, a
                 * disciplina que tem requisito deve ser removida tambem
                 */
                enrolment.verifyIfHasSubjectsSubscribedWithoutRequirements(requirement);
              }
            }
          });
          return item;
        });
    };

    /**
     * Verificação de choque de horário na grade de disciplinas
     * @param item - turma da disciplina a ser inserida
     * @param list - lista de todas as disciplinas já postas na grade de horário.
     * @throws Object - Em caso de choque de horário é lançado um objeto exception com os paramentros do choque
     */
    enrolment.verifyTimeShock = function (item, list) {
      for (var i = 0; i < list.length; i++) {
        var schedule_row = list[i];
        var cell = $filter('filter')(schedule_row.schedule_subject, {day_of_week: item.day_of_week})[0];
        if (angular.isDefined(cell.initial_time) && angular.isDefined(cell.subject_id)) {
          /** Define uma data qualquer apenas para comparação de choque de horário */
          var cell_initial_time = moment(moment().format('YYYY-MM-DD') + "T" + cell.initial_time);
          var cell_final_time = moment(moment().format('YYYY-MM-DD') + "T" + cell.final_time);
          var selected_initial_time = moment(moment().format('YYYY-MM-DD') + "T" + item.initial_time);
          var selected_final_time = moment(moment().format('YYYY-MM-DD') + "T" + item.final_time);

          if (cell.subject_id !== item.subject_id) {
            /** Verificação de choque no horário inicial */
            if (selected_initial_time.isBetween(cell_initial_time, cell_final_time, null, '[)')) {
              throw {
                message: 'Choque de horário de ' + item.alias + " com a disciplina já selecionada " + cell.alias,
                item: item,
                cell: cell
              };
            }
            /** Verificação de choque no horário final */
            if (selected_final_time.isAfter(cell_initial_time) && (selected_final_time.isSame(cell_final_time) || selected_final_time.isBefore(cell_final_time))) {
              throw {
                message: 'Choque de horário de ' + item.alias + " com a disciplina já selecionada " + cell.alias,
                item: item,
                cell: cell
              };
            }
          }
        }
      }
      return false;
    };

    /**
     * Verificação e remoção matriculas em materias com o requisito não aplicado.
     */
    enrolment.verifyIfHasSubjectsSubscribedWithoutRequirements = function (requirement) {
      /** Executa uma filtragem na lista de disciplinas */
      enrolment.form.subject.id = enrolment.form.subject.id.filter(function (item) {
        var new_schedule_subject = [];
        /** verifica cada item do array de requeridos para remover algum requisito matriculado */
        item.schedule_subject.forEach(function (schedule) {
          if (angular.isDefined(schedule.subject_id)) {
            /** Caso a turma da disciplina selecionada seja igual a alguma da grade, ela é removida */
            if (schedule.subject_id === requirement.subject_id) {
              new_schedule_subject.push({day_of_week: schedule.day_of_week});
            } else {
              new_schedule_subject.push(schedule);
            }
          } else {
            new_schedule_subject.push(schedule);
          }
        });
        /** Atribue a nova lista de materias. */
        item.schedule_subject = new_schedule_subject;
        return item;
      })
    };

    /**
     * Resgata as turmas de uma disciplina
     * @param subject_id - identificador da disciplina
     */
    enrolment.getGroupsForSubject = function (subject_id) {
      var group_id = enrolment.form.timetable.group_id;
      var course_id = enrolment.form.timetable.course_id;

      SubjectService.getGroupsForSubject({subject_id: subject_id, group_id: group_id, course_id: course_id})
        .then(function (response) {
          enrolment.list.group.group_id = response;
        });
    };

    /**
     * Define os campos padrão para os selects não obrigatoríos
     */
    enrolment.addSelectDefault = function () {
      enrolment.list.timetable.course_id.splice(0, 0, enrolment.select_default);
    };

    /**
     * Adiciona um responsável à lista de responsáveis selecionados
     */
    enrolment.addResponsibleToList = function (responsible) {
      if (angular.isDefined(responsible) && angular.isDefined(responsible.id)) {
        var resp = {
          id: responsible.id,
          is_responsible: responsible.is_responsible,
          name: responsible.name,
          national_id_number: responsible.number,
          person_relation_type_id: responsible.person_relation_type_id,
          person_sex_id: responsible.person_sex_id
        };
        /** Caso seja o primeiro responsável da lista */
        if (angular.isUndefined(enrolment.form.person_relation.person_id_relation)) {
          enrolment.form.person_relation.person_id_relation = [];
          enrolment.form.person_relation.person_id_relation.push(resp);
        } else {
          /** Se já houver responsáveis, testa se o responsável já existe na lista*/
          var isExists = $filter('filter')(enrolment.form.person_relation.person_id_relation, {id: resp.id})[0];
          if (angular.isUndefined(isExists)) {
            enrolment.form.person_relation.person_id_relation.push(resp);
          }
        }
      }
    };

    /**
     * Remove um responsável da lista de responsáveis selecionados
     */
    enrolment.removeResponsibleToList = function (responsible) {
      /** Remove o item da lista pelo identificador do responsável*/
      enrolment.form.person_relation.person_id_relation =
        enrolment.form.person_relation.person_id_relation.filter(function (obj) {
          return obj.id !== responsible.id;
        });
    };

    /**
     * Resgata todos os cursos
     */
    enrolment.getCourses = function () {
      CourseService.getAll({only_active: true})
        .then(function (response) {
          enrolment.list.timetable.course_id = response.plain();
          $rootScope.show_loader = false;
          enrolment.addSelectDefault();
        });
    };

    /**
     * Realiza a busca das turmas pelo curso
     */
    enrolment.changeCourse = function (course_id, person_id) {

      if (angular.isDefined(course_id)) {
        GroupsService.getGroupsForEnrolment(course_id, {person_id: person_id})
          .then(function (response) {
            enrolment.form.timetable.group_id = {};
            enrolment.list.timetable.group_id = (angular.isArray(response.plain())) ? response.plain() : [];

            /** Verifica se há alguma sugestão*/
            if (angular.isArray(enrolment.list.timetable.group_id)) {
              /** Tras as disciplinas de um curso para matricula */


              angular.forEach(enrolment.list.timetable.group_id, function (item) {
                if (enrolment.suggestion.group_name != null) {
                  /** Realiza o tratamento do nome para buscar a sugestão correta*/
                  var expr = /^(?:[A-Za-z]+)(?:[A-Za-z0-9 _]*)(.*? -)/i;
                  var str = enrolment.suggestion.group_name;
                  var match = str.match(expr);
                  /** Se houver sugestão */
                  if (match != null) {
                    var suggestion = match[0].replace(' -', '');
                    if (item.name.search(suggestion)) {
                      var group_id = item.id;
                      enrolment.form.timetable.group_id = group_id;
                      /** Caso tenha uma sugestão de turma, deve trazer outros dados referente a turma sugerida */
                      enrolment.checkForEnrolmentVacancies(group_id);
                      enrolment.getSubjectsForEnrolment(group_id);
                      enrolment.getSubjectScheduleGrade(enrolment.course_id, group_id);
                    }
                  } else {
                    if (enrolment.suggestion.group_id === item.id)
                      enrolment.form.timetable.group_id = item.id;
                  }
                }


              });
            }

          })
      }

    };

    /**
     * Realiza a troca dos dados do select de cidade baseada no estado selecionado
     * @param address_state_id - estado item selecionado
     * @param city - cidade retornada pelo consulta a partir do cep
     */
    enrolment.changeAddressState = function (address_state_id, city) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          enrolment.list.person.address_city = response.plain();
          angular.forEach(enrolment.list.person.address_city, function (address_city) {
            if (address_city.name === city) {
              enrolment.form.person.address_city = address_city.id;
            }
          })
        })
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param birth_certificate_registry_state - novo item selecionado
     */
    enrolment.changeAddressStateRegistry = function (birth_certificate_registry_state) {
      PersonService.getCities(birth_certificate_registry_state)
        .then(function (response) {
          enrolment.list.person.birth_certificate_registry_city = response.plain();
        })
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param school_origin_state
     */
    enrolment.changeAddressStateSchool = function (school_origin_state) {
      PersonService.getCities(school_origin_state)
        .then(function (response) {
          enrolment.list.person_student.school_origin_city = response.plain();
        })
    };

    /**
     * Executa o fechamento do Modal
     * @param data - Objeto já editado, em caso de cancelar o cancelamento do processo de matricula
     * ele deve restaurar o assistente com os dados já imputados
     */
    enrolment.close = function (data) {
      ModalFactory.confirm(null,
        'Atenção - Cancelamento do Processo de Matricula',
        "Este processo irá remover todos os dados deste aluno. ",
        "Cancelar", "Voltar", "educational", false)
        .then(function (response) {
          if (response) {
            $rootScope.$broadcast('ModalFactory.close');
          }
        })
        .catch(function () {
          ModalFactory.customClean(
            'app/educational/enrolment/views/enrolment-wizard.html',
            'EnrolmentAssistantController',
            'vm', false, data
          );
        });

    };

    /**
     * Executa a criação dos responsáveis
     * @param name
     * @param data - Objeto já editado, em caso de cancelar o cancelamento do processo de matricula
     * ele deve restaurar o assistente com os dados já imputados
     */
    enrolment.createResponsibles = function (name, data) {
      var responsibles = {
        name: name,
        enrolment_data: data
      };

      $rootScope.$broadcast('ModalFactory.close');

      ModalFactory.customClean(
        'app/educational/responsibles/views/responsibles-wizard.html',
        'ResponsiblesAssistantController',
        'vm', false, responsibles
      );
      return false;
    };


    /**
     * Resgata possiveis responsáveis pelo aluno
     */
    enrolment.getPersonResponsableLegal = function (id, query) {
      $rootScope.show_loader = true;
      EnrolmentService.getPersonResponsableLegal({id: id, query: query})
        .then(function (response) {
          enrolment.list.person_relation.search = response.list;
          $rootScope.show_loader = false;
        });
    };

    /**
     * Resgata possiveis relações de responsáveis ao aluno
     */
    enrolment.getPersonRelationLegal = function () {
      EnrolmentService.getPersonRelationLegal()
        .then(function (list) {
          enrolment.list.person_relation.person_relation_type_id = list.plain();
          $rootScope.show_loader = false;
        });
    };


    /**
     * Reune todas informações necessárias para o formulário
     */
    enrolment.getEnrolmentFormInfo = function () {
      $rootScope.show_loader = true;
      EnrolmentService.getEnrolmentFormInfo()
        .then(function (response) {
          enrolment.list.person = angular.extend(enrolment.list.person, response.person);
          enrolment.list.person_student = response.person_student;
          enrolment.list.enrolment = response.enrolment;
          enrolment.list.enrolment.groups = enrolment.list.enrolment.group_id.reduce(function (previous, current) {
            if (previous.indexOf(current.course_name) === -1) {
              previous.push(current.course_name);
            }
            return previous;
          }, []);
          /** Lista de orgãos expedidores */
          enrolment.list.person.id_issuer = EnrolmentService.getListIdIssuer();
          /** Atualiza a cidade de acordo com o CEP */
          if (angular.isDefined(enrolment.list.person.address_postal_code)) {
            $timeout(function () {
              enrolment.getAddressByCep(enrolment.list.person.address_postal_code);
            }, 600);
          }
        });
      $rootScope.show_loader = false;
    };

    /**
     * Retorna todos os grupos de curso disponíveis
     */
    enrolment.checkForEnrolmentVacancies = function (group_id) {
      EnrolmentService.checkForEnrolmentVacancies(group_id)
        .then(function (response) {
          if (response.result) {
            Common.Toast.warning(response.message);
          }
        });
    };


    /**
     * Finalização do assistente de matrícula
     */
    enrolment.finish = function () {
      Common.Toast.success("Matricula finalizada");
    };

    /**
     * Lista de relação de passos do wizard
     * @returns {{INICIO: number, CURSO: number, DISCIPLINA: number, ALUNOS: number, ENDERECO: number, DOCUMENTOS: number, DADOSMEDICOS: number, RESPONSAVEIS: number, CONCLUSAO: number}}
     */
    enrolment.wizardItemList = function () {
      return {
        CURSO: 0,
        INICIO: 1,
        ALUNOS: 2,
        DISCIPLINA: 3,
        DOCUMENTOS: 4,
        DADOSMEDICOS: 5,
        RESPONSAVEIS: 6,
        ENDERECO: 7,
        CONCLUSAO: 8
      }
    };

    /**
     * Resgata o endereço através do CEP informado
     * @param CEP
     */
    enrolment.getAddressByCep = function (CEP) {
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          if (angular.isDefined(address.erro) && address.erro) {
            return;
          }
          enrolment.form.person.address_state = address.uf;
          enrolment.form.person.address_city = address.localidade;
          enrolment.form.person.address_street = address.logradouro;
          enrolment.form.person.address_district = address.bairro;
          enrolment.changeAddressState(address.uf, address.localidade);
        })
    };

    /**
     * Recebe as submissões de todas as etapas do assistente
     */
    enrolment.submit = function (item, form, wizardItem) {
      var deferred = Common.$q.defer();
      var result = a4FormDicDataUtilsService.copy(item);
      /** Realiza a copia dos dados */
      enrolment.new_item = angular.copy(result);
      /** Realiza o tratamento das datas */
      if (angular.isDefined(enrolment.new_item.dob) && enrolment.new_item.dob._isAMomentObject) {
        enrolment.new_item.dob = enrolment.new_item.dob._d;
      }
      enrolment.new_item.enrolment_wizard_step = enrolment.stepSelected + 1;
      enrolment.new_item.group_id = enrolment.form.timetable.group_id;
      /** Define a relação do aluno com os responsáveis */
      if ((angular.isDefined(enrolment.new_item.person_id_relation) && enrolment.new_item.person_id_relation.length)) {
        angular.forEach(enrolment.new_item.person_id_relation, function (relation) {
          relation.person_id_related = enrolment.form.person.id;
        });
      }
      var wizard = enrolment.wizardItemList();
      switch (wizardItem.id) {
        case wizard.CURSO:
          deferred.resolve(true);
          break;
        case wizard.INICIO:
          deferred.resolve(true);
          break;
        case wizard.DISCIPLINA:
          deferred.resolve(true);
          break;
        case wizard.ALUNOS:
          var student = enrolment.new_item.student;
          student.subject = enrolment.new_item.subject.id;
          student.enrolment_wizard_step = enrolment.new_item.enrolment_wizard_step;
          student.matrix_period = enrolment.new_item.timetable.matrix_period;
          student.group_id = enrolment.new_item.timetable.group_id;
          student.course_id = enrolment.new_item.timetable.course_id;
          student.is_pre_enrolment = enrolment.new_item.pre_enrolment;
          EnrolmentService.storeStudent(student).then(function (person_id) {
            enrolment.form.person.id = person_id;
            enrolment.form.student.id = person_id;
            enrolment.new_item.student.person_id = person_id;
            enrolment.new_item.student.id = person_id;

            Common.Toast.success('Matricula parcialmente salva');
            deferred.resolve(true);
          }).catch(function (fail) {
            if (angular.isObject(fail.data)) {
              angular.forEach(fail.data, function (value) {
                switch (value[0]) {
                  case 'NATIONAL_ID_NUMBER_ALREADY_BEEN_USED':
                    Common.Toast.warning('CPF já utilizado por outro aluno.');
                    break;
                }
              });
              Common.Toast.error(fail.data.message)
            }
          });
          break;
        case wizard.ENDERECO:
          var address = enrolment.new_item.student;
          address.group_id = enrolment.new_item.timetable.group_id;
          address.course_id = enrolment.new_item.timetable.course_id;
          address.enrolment_wizard_step = enrolment.new_item.enrolment_wizard_step;
          EnrolmentService.storeAddressAndDocuments(address).then(function () {
            Common.Toast.success('Matricula parcialmente salva');
            deferred.resolve(true);
          }).catch(function () {
            deferred.reject(true);
          });
          break;
        case wizard.DOCUMENTOS:
          var student = enrolment.new_item.student;
          student.group_id = enrolment.new_item.timetable.group_id;
          student.course_id = enrolment.new_item.timetable.course_id;
          student.enrolment_wizard_step = enrolment.new_item.enrolment_wizard_step;
          student.idOfDocuments = enrolment.student.idOfDocuments;
          CourseDocumentsService.saveDocumentsForStudent({
            documents: enrolment.student.idOfDocuments,
            person_id: student.id,
            group_id: student.group_id
          }).then(function () {
            Common.Toast.success('Matricula parcialmente salva');
            deferred.resolve(true);
          }).catch(function () {
            deferred.reject(true);
          });
          break;
        case wizard.DADOSMEDICOS:
          var student = enrolment.new_item.person_medical_data;
          student.dob = enrolment.new_item.student.dob;
          student.name = enrolment.new_item.student.name;
          student.person_id = enrolment.form.person.id;
          student.national_id_number = enrolment.new_item.student.national_id_number;
          student.group_id = enrolment.new_item.group_id;
          student.course_id = enrolment.new_item.course_id;
          student.enrolment_wizard_step = enrolment.new_item.enrolment_wizard_step;

          EnrolmentService.storeMedicalRecords(student).then(function (response) {
            Common.Toast.success('Matricula parcialmente salva');
            deferred.resolve(true);
          }).catch(function () {
            deferred.reject(true);
          });
          break;
        case wizard.RESPONSAVEIS:
          var student = enrolment.new_item.student;
          student.group_id = enrolment.new_item.timetable.group_id;
          student.course_id = enrolment.new_item.timetable.course_id;
          student.enrolment_wizard_step = enrolment.new_item.enrolment_wizard_step;
          student.person_id_relation = enrolment.new_item.person_relation.person_id_relation;
          EnrolmentService.storeResponsibles(student).then(function () {
            Common.Toast.success('Matricula parcialmente salva');
            deferred.resolve(true);
          }).catch(function () {
            deferred.reject(true);
          });
          break;
        case wizard.FINANCEIRO:
          var responsible = $filter('filter')(enrolment.new_item.person_relation.person_id_relation, {is_responsible: true}, true);
          var contract = enrolment.new_item.contract;
          contract.person_id_beneficiary = enrolment.new_item.student.id;
          contract.debit_credit = 'C';
          contract.status = 1;
          contract.end_of_recurrence = 0;
          contract.type = 1;
          contract.due_date = contract.date_first;
          contract.person_id = angular.isDefined(responsible) ? responsible[0].id : enrolment.new_item.student.id;
          contract.group_id = enrolment.new_item.timetable.group_id;
          contract.course_id = enrolment.new_item.timetable.course_id;
          contract.dob = enrolment.new_item.student.dob;
          contract.name = enrolment.new_item.student.name;
          contract.national_id_number = enrolment.new_item.student.national_id_number;
          contract.enrolment_wizard_step = enrolment.new_item.enrolment_wizard_step;
          EnrolmentService.storeContract(contract).then(function () {
            Common.Toast.success('Matricula parcialmente salva');
            deferred.resolve(true);
          }).catch(function () {
            deferred.reject(true);
          });
          break;
      }

      return deferred.promise;

    };

    enrolment.isAbleFinished = false;

    /**
     * Funções do form de tipo form-wizard --------------------------------------------------
     */

    enrolment.enableNextStep = function (maxStep) {
      /** não pode exceder o maximo de passos */
      if (enrolment.stepSelected >= maxStep) {
        return;
      }
      /** So incrementa até o maximo possível */
      if (enrolment.stepSelected === $scope.stepProgress - 1) {
        $scope.stepProgress = $scope.stepProgress + 1;
      }
      /** Selecionado recebe o proximo step */
      enrolment.stepSelected = enrolment.stepSelected + 1;
    };

    /**
     * Move o wizard para sua tela anterior
     */
    enrolment.moveToPreviousStep = function () {
      if (enrolment.stepSelected > 0) {
        enrolment.stepSelected = enrolment.stepSelected - 1;
      }
    };

    /**
     * Executa o submit do step corrente
     * @param stepData - dados para submissão
     * @param isSkip - se deve ser passado ou não
     * @param form - dados referente ao formulário
     */
    enrolment.submitCurrentStep = function (stepData, isSkip, form) {
      if (form.$valid) {
        enrolment.showBusyText = true;
        enrolment.submit(enrolment.form, null, stepData)
          .then(function () {
            if (!stepData.completed && !isSkip) {
              /** move to next step when success */
              $timeout(function () {
                enrolment.showBusyText = false;
                stepData.completed = true;
                enrolment.enableNextStep(9);
                angular.element('md-step-content.md-active select:first, md-step-content.md-active input[type="text"]:first').focus();
              }, 1000);
            } else {
              enrolment.showBusyText = false;
              enrolment.enableNextStep(9);
            }
          });
      }
    };

    /** Função que submita o final do wizard */
    enrolment.wFinish = function (form) {
      vm.isAbleFinished = true;
      $scope.finishWizard(form);
    };


    /** Formata corretamente para o banco as datas que usam mascaras */
    enrolment.formatCorretDate = function (date) {
      if (date != null && angular.isDefined(date)) {
        return date.toString().split("/").reverse().join("-");
      }
    };

    $scope.$on('$destroy', function () {
      [ltn1, ltn2, ltn3, ltn4, ltn5, ltn6, ltn7,
        ltn8, ltn10, ltn12, ltn13, ltn14,
        ltn15, ltn16, ltn17].forEach(function (fn) {
        fn();
      })
    });

    enrolment.init();

  }

  angular
    .module('app.educational.enrolment')
    .controller('EnrolmentAssistantController', EnrolmentAssistantController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function DocumentsService(Restangular, $http, Common, CONFIG) {
    var vm = this;

    /**
     * Retorna todas as mensagens
     * @returns array
     */
    vm.getAll = function (obj) {
      return Restangular.one('document').get(obj);
    };

    vm.create = function (obj) {
      return Restangular.all('document').post(obj);
    };

    vm.getResources = function () {
      return Restangular.one('document').one('getresources').get();
    };

    vm.getById = function (id) {
      return Restangular.one('document', id).get();
    };

    /**
     * Atualiza um novo boletim informativo
     */
    vm.updateDocument = function (obj) {
      return Restangular.one('document', obj.id).customPUT(obj);
    };

    vm.deleteDocument = function (id) {
      return Restangular.one('document', id).remove();
    };

    vm.disableDocument = function (id) {
      return Restangular.one('document').all('disable').post({id: id});
    };

    vm.sendDocument = function (obj) {
      return Restangular.one('document').all('send').post(obj);
    };

    vm.uploadFile = function (obj) {
      return Restangular.one('document').all('uploadfiles').post(obj);
    };

    vm.getInfoForExternalDocumentAssign = function (obj) {
      return Restangular.one('document').one('getinfoforexternaldocumentassign').get(obj);
    };

    vm.getWaterMark = function (obj) {
      return Restangular.one('document').one('getwatermark').get(obj);
    }

    vm.deleteWaterMark = function (obj) {
      return Restangular.one('document').all('deletewatermark').post(obj);
    }

    vm.downloadDocument = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/document/generateDocument',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];

        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('target', '_blank');
          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }).catch(function (response) {
        var decoder = new TextDecoder("utf-8");
        var domString = decoder.decode(response.data);
        var json = angular.fromJson(domString);
        deffered.reject(json);
      });

      return deffered.promise;
    };

    return vm;
  }

  angular
    .module('app.educational.documents')
    .factory('DocumentsService', DocumentsService)
})();

(function () {
  'use strict';

  /** @ngInject */
  function DocumentsSendPrintController($rootScope, $scope, $interval, Common, CommunicationService,
                                        ModalExtra, CoordinatorsService, DocumentsService, EnrolmentService,
                                        PersonService, PoliciesService, ProductService) {
    var vm = this;
    vm.searchText = '';
    vm.selected_tab = 0;
    vm.show_circular_loader = false;
    vm.show_receivers = false;
    vm.receivers_info = {};
    vm.print_msg = false;
    vm.print_landscape = false;
    vm.without_margin = false;
    vm.use_watermark = false;
    vm.message_index = null;
    vm.use_services = false;
    vm.waiting_msg = '';
    vm.messages = [
      'Aguarde um pouco, estamos gerando o seu documento, pode levar alguns minutos...',
      'Aguarde mais um pouco, ainda estamos aqui :D ',
      'Não se preocupe, estamos terminando... ',
    ];
    vm.filter = {
      selectedCoursesAndGroups: [],
      selectedBillSerie: null,
      is_financial_resp: true,
      is_pedagogic_resp: true,
      is_father: true,
      is_mother: true,
      selected_option: "0",
      student_financial_option: 0,
      selected_enrolment_status: [],
      only_without_signed_contract: false,
      selectedPerson: null
    };
    vm.was_logo_position_selected = false;
    vm.position_logo = 'left';
    vm.document = {};

    vm.init = function () {
      vm.document = ModalExtra.document;
      vm.selected_profile = ModalExtra.selected_tab;
      if (vm.document.type === '8') {
        vm.selected_profile = 5;
        vm.filter.is_father = false;
        vm.filter.is_mother = false;
        vm.filter.is_pedagogic_resp = false;
        vm.filter.is_financial_resp = true;
        vm.filter.only_without_signed_contract = true;
      }
      if (vm.selected_profile === 2 || vm.selected_profile === 3) {
        vm.filter.selected_option = 1;
      }
      EnrolmentService.getAllEnrolmentStatus()
        .then(function (resp) {
          vm.enrolment_status = resp.plain();
        });
      if(vm.selected_profile === 5) {
        ProductService.getServicesWithDocumentAttached({document: vm.document.id})
          .then(function (response) {
            vm.services = response.plain();
          })
      }
      vm.setTree();
    };

    vm.onPersonSelected = function(item) { 
      vm.filter.selectedCoursesAndGroups = [item.group_id * 100];
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.setTree = function () {
      CoordinatorsService.getTree()
        .then(function (response) {
          vm.coursesAndGroups = response.plain();
        });
    };

    $scope.$watch('vm.filter.selectedCoursesAndGroups', function (newValue, oldValue) {
      vm.show_receivers = false;
    });

    $scope.$watch('vm.filter.selectedBillSerie', function (newValue, oldValue) {
      vm.show_receivers = false;
    });

    vm.onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };

    vm.setShowReceiversToFalse = function () {
      vm.show_receivers = false;
    };

    vm.submit = function (form, filter, action, send_option) {
      $scope.$applyAsync();
      filter.selectedCoursesAndGroups = filter.selectedCoursesAndGroups.filter(vm.onlyUnique);

      switch (action) {
        case 'send':
          vm.show_circular_loader = true;
          if (vm.show_receivers === false && vm.selected_tab !== 1) {
            CommunicationService.getReceivers({
              document_id: vm.document.id,
              filter: filter
            }).then(function (response) {
              vm.show_receivers = true;
              vm.show_circular_loader = false;
              var data = response.plain();
              vm.receivers_info.persons = data.persons;
              vm.receivers_info.persons_without_email = data.persons_without_email;
              vm.receivers_info.persons_with_email = data.persons_with_email;
              vm.receivers_info.persons_email_sent = data.persons_email_sent;
              vm.receivers_info.persons_total = data.persons_total;
            }).catch(function (error) {
              vm.show_circular_loader = false;
              Common.Toast.error(error.data.message);
            });
          } else {
            DocumentsService.sendDocument({
              filter: filter, id: vm.document.id,
              send_option: send_option
            })
              .then(function () {
                vm.show_circular_loader = false;
                vm.close(true);
              })
              .catch(function () {
                vm.show_circular_loader = false;
                vm.close(false);
              });
          };
          break;
        case 'print':
          if (vm.document.print_logo === true && !vm.was_logo_position_selected) {
            vm.was_logo_position_selected = true;
          } else if (vm.document.print_logo === true && vm.was_logo_position_selected) {
            vm.printDocument(filter);
          } else {
            vm.printDocument(filter);
          }
          break;
      }
    }


    vm.printReceivers = function (filter) {
      vm.show_circular_loader = true;
      CommunicationService.getReceivers({
        document_id: vm.document.id,
        filter: filter
      }).then(function (response) {
        CommunicationService.getReceiversReport({persons: response.plain().persons})
          .then(function () {
            vm.show_circular_loader = false;
            var data = response.plain();
            vm.receivers_info.persons = data.persons;
            vm.receivers_info.persons_without_email = data.persons_without_email;
            vm.receivers_info.persons_with_email = data.persons_with_email;
            vm.receivers_info.persons_email_sent = data.persons_email_sent;
            vm.receivers_info.persons_total = data.persons_total;
            vm.show_receivers = true;
          });
      });
    };

    vm.printDocument = function (filter) {
      vm.show_circular_loader = true;
      vm.print_msg = true;
      vm.waiting_msg = vm.messages[0];
      vm.message_index = 1;
      var exit_interval = $interval(function () {
        if (angular.isDefined(vm.messages[vm.message_index])) {
          vm.waiting_msg = vm.messages[vm.message_index];
          vm.message_index++;
        } else {
          vm.message_index = 0;
        }
      }, 15000);
      DocumentsService.downloadDocument({
        filter: filter,
        id: vm.document.id,
        position_logo: vm.position_logo,
        print_landscape: vm.print_landscape,
        without_margin: vm.without_margin,
        use_watermark: vm.use_watermark
      })
        .then(function () {
          vm.show_circular_loader = false;
          $interval.cancel(exit_interval);
          exit_interval = undefined;
          vm.waiting_msg = "Arquivo foi gerado com sucesso!";
        })
        .catch(function (response) {
          vm.show_circular_loader = false;
          $interval.cancel(exit_interval);
          exit_interval = undefined;
          Common.Toast.error(response.message);
          vm.waiting_msg = "Ocorreu algum erro na geração do arquivo, entre em contato com os administradores.!";
        });
    };

    vm.getPersons = function (query) {
      return PersonService.getPersonWithFilter({query: query, selected_tab: ModalExtra.selected_tab});
    };

    /**
     * Realiza fechamento do serviço do modal
     */
    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.init();
  }

  angular
    .module('app.educational.documents')
    .controller('DocumentsSendPrintController', DocumentsSendPrintController)
})();

(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.documents', {
        public: false,
        url: '/documents',
        templateUrl: 'app/educational/documents/views/documents.html',
        abstract: true
      })
      .state('private.educational.documents.list', {
        url: '/list',
        public: false,
        views: {
          'documents': {
            templateUrl: 'app/educational/documents/views/list.html',
            controller: 'DocumentsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.documents.create-edit', {
        url: '/create-edit/:for/:id',
        public: false,
        views: {
          'documents': {
            templateUrl: 'app/educational/documents/views/create-edit.html',
            controller: 'DocumentsCreateEditController',
            controllerAs: 'vm'
          }
        }
      });

  }

  angular
    .module('app.educational.documents')
    .config(routerConfig);

})();



(function () {
  'use strict';

  /** @ngInject */
  function Documents(DocumentsService, Common) {
    var vm = this;
    vm.resources = [];
    vm.allresources = [];
    vm.collaborators = [];
    vm.responsables = [];
    vm.students = [];
    vm.teacher = [];

    vm.setResources = function (resources) {
      vm.resources = resources;
      vm.allresources = resources.allresources;
      vm.collaborators = resources.collaborators;
      vm.responsables = resources.responsables;
      vm.students = resources.students;
      vm.teacher = resources.teacher;

    };

    vm.getCollaborators = function () {
      return vm.collaborators;
    };

    vm.getResponsables = function () {
      return vm.responsables;
    };

    vm.getStudents = function () {
      return vm.students;
    };

    vm.getTeacher = function () {
      return vm.teacher;
    };

    vm.getAll = function () {
      return vm.allresources;
    };

    /**
     * Retorna recursos do sistemas
     * @return {*}
     */
    vm.getResources = function () {
      var deffered = Common.$q.defer();
      if (vm.resources.length === 0) {
        DocumentsService.getResources()
          .then(function (resources) {
            vm.setResources(resources.plain());
            deffered.resolve(vm.resources);
          })
          .catch(function (error) {
            Common.Toast.warning(error.message);
            deffered.resolve(false);
          })
      } else {
        deffered.resolve(true);
      }
      return deffered.promise;
    };

    return vm;
  }

  angular
    .module('app.educational.documents')
    .factory('Documents', Documents)
})();

(function () {
  'use strict';

  /** @ngInject */
  function DocumentsCreateEditController($scope, $rootScope, $document, $stateParams, Common, CONFIG, Documents, DocumentsService, DropzoneService, LocalStorage) {
    var vm = this;
    vm.profile = '';
    vm.is_wysiwyg = false;
    vm.form = {};
    vm.variables = [];
    vm.form.document = {
      date: null,
      final_date: null,
      content: ""
    };

    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");

    /** Define as configurações para o upload */
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/document/uploadfiles?company=' + company + '&connection=' + connection,
      paramName: 'file',
      maxFilesize: '10',
      acceptedFiles: DropzoneService.getMimeTypes(['JPG', 'PNG', 'GIF']),
      uploadMultiple: false,
      parallelUploads: 1,
      maxFiles: 1,
      autoProcessQueue: true
    };


    vm.options = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'strikeThrough', 'underline', 'ul', 'ol'],
      ['undo', 'redo', 'clear', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'clear', 'insertImage', 'insertLink', 'insertVideo'],
      ['html'],
    ];

    vm.tinymceOptions = {
      setup: function (editor) {
        vm.editor = editor;
        // editor.execCommand('mceInsertContent', false, text);
      },
      inline: false,
      entity_encoding: "raw",
      plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks ' +
        'visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc ' +
        'insertdatetime advlist lists wordcount imagetools textpattern noneditable charmap emoticons textcolor',
      skin: 'lightgray',
      theme: 'modern',
      fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
      menubar: 'file edit view insert format tools table help forecolor backcolor',
      toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | ' +
        'alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | removeformat | ' +
        'pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ' +
        'ltr rtl | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | ' +
        'tableinsertcolbefore tableinsertcolafter tabledeletecol | forecolor backcolor',
      toolbar_sticky: true,
      color_cols: 5,
      file_picker_callback: function (cb, value, meta) {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.onchange = function () {
          var file = this.files[0];
          var reader = new FileReader();
          reader.onload = function (event) {
            DocumentsService.uploadFile({
              file: {
                photo: event.target.result,
                format: file.type.split('/')[1]
              }
            }).then(function (response) {
              cb(response.upload, {title: file.name});
            });
          };
          reader.readAsDataURL(file);
        };

        input.click();
      },
      color_map: [
        '#BFEDD2', 'Light Green',
        '#FBEEB8', 'Light Yellow',
        '#F8CAC6', 'Light Red',
        '#ECCAFA', 'Light Purple',
        '#C2E0F4', 'Light Blue',

        '#2DC26B', 'Green',
        '#F1C40F', 'Yellow',
        '#E03E2D', 'Red',
        '#B96AD9', 'Purple',
        '#3598DB', 'Blue',

        '#169179', 'Dark Turquoise',
        '#E67E23', 'Orange',
        '#BA372A', 'Dark Red',
        '#843FA1', 'Dark Purple',
        '#236FA1', 'Dark Blue',

        '#ECF0F1', 'Light Gray',
        '#CED4D9', 'Medium Gray',
        '#95A5A6', 'Gray',
        '#7E8C8D', 'Dark Gray',
        '#34495E', 'Navy Blue',

        '#000000', 'Black',
        '#ffffff', 'White'
      ],
      height: 400
    };

    /** Define o comportamento após o upload */
    vm.dzCallbacks = {
      'success': function (file, xhr) {
        vm.form.document.file_reference = xhr.file_reference;
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.init = function () {
      if ($stateParams.id) {
        vm.getById($stateParams.id);
      }
      Documents.getResources()
        .then(function () {
          vm.defineProfile($stateParams.for);
        });
    };

    vm.setVariable = function (item) {
      vm.editor.insertContent(item.name);
    };


    /**
     * Define qual o perfil selecionado para a mensagem
     * @param profile
     */
    vm.defineProfile = function (profile) {
      switch (profile) {
        case '0':
          vm.profile = 'Todos';
          vm.variables = Documents.getAll();
          break;
        case '1':
          vm.profile = 'Alunos';
          vm.form.document.for_student = true;
          vm.variables = Documents.getStudents();
          break;
        case '2':
          vm.profile = 'Responsáveis';
          vm.form.document.for_parents = true;
          vm.variables = Documents.getResponsables();
          break;
        case '3':
          vm.profile = 'Professores';
          vm.form.document.for_teacher = true;
          vm.variables = Documents.getTeacher();
          break;
        case '4':
          vm.profile = 'Colaboradores';
          vm.form.document.for_employee = true;
          vm.variables = Documents.getCollaborators();
          break;
        case '5':
          vm.profile = 'Contratos';
          vm.form.document.for_student = true;
          vm.variables = Documents.getStudents();
          break;
      }
    };

    /**
     * Inverte string
     * @param string
     * @returns {*}
     */
    vm.reverseString = function (string) {
      return string.split('').reverse().join('');
    };
    /**
     * Retorna os dados da mensagem em caso de edição
     * @param id
     */
    vm.getById = function (id) {
      $rootScope.show_loader = true;
      DocumentsService.getById(id)
        .then(function (response) {
          vm.form.document = response;
          vm.is_wysiwyg = vm.form.document.is_wysiwyg;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Submete o boletim a criação..
     */
    vm.submit = function (form, item) {
      $rootScope.show_loader = true;
      item.for = $stateParams.for;
      // A aba de contrato, é documento por aluno do tipo "Contrato" (2)
      if(item.for == '5') {
        item.for = '1';
        item.type = 2;
      }
      // Assinatura externa é sempre por responsável e do tipo "Assinatura externa" (8)
      //caso o type deja 5, que é o termo de negocioação, não é para mudar seu type que é especial
      if(item.for == '2' && item.type != 5) {
        if(item.content.includes('{{Assinatura_Externa}}')) {
          item.type = 8;
        } else {
          item.type = 3;
        }
      }
      if (form.$valid) {
        if (item.id) {
          item.is_wysiwyg = vm.is_wysiwyg;
          DocumentsService.updateDocument(item)
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Mensagem atualizada com sucesso!');
              // $state.go('private.educational.informative-report.edit', {id: response});
              // vm.form.mode_edit = false;
            })
            .catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Erro ao atualizar mensagem');
            })
        } else {
          item.is_wysiwyg = vm.is_wysiwyg;
          item.company_id = company;

          /** Caso não tenha um type definido define o type como comunicação (3) por padrão
           * -Comentador por Rodrigo, 03/05/2024
           * */
          if (!item.type) {
            item.type = 3;
          }
          DocumentsService.create(item)
            .then(function (id) {
              $rootScope.show_loader = false;
              item.id = id;
              Common.Toast.success('Mensagem criada com sucesso!');
              // $state.go('private.educational.informative-report.edit', {id: response});
              // vm.form.mode_edit = false;
            })
            .catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Erro ao criar mensagem');
            })
        }
      }
    };

    vm.init();

  }

  angular
    .module('app.educational.documents')
    .controller('DocumentsCreateEditController', DocumentsCreateEditController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function DocumentsController($a4FloatButton, $rootScope, $filter, $scope, $state, Common, DocumentsService,
                               ModalFactory, PoliciesService) {

    var vm = this;
    vm.selected_tab = 0;
    vm.grid = {
      rows: [],
      info: {}
    };

    vm.init = function () {
      vm.paginate();
      vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createDocument()', theme: 'educational'});
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;
      var tab = vm.selected_tab === 0 ? null : vm.selected_tab;
      var type = '4,3,8'; //Correspondência, email de ativação de conta e link para ass de contrato
      //TODO: por enquanto a visualização de contratos é a mesma de alunos, isso depois será mudado
      if(vm.selected_tab == 5) {
        tab = 1;
        type = '2'
      }
      DocumentsService.getAll({limit: limit, page: page, type: type, for: tab})
        .then(function (response) {
          vm.grid.rows = vm.formatGrid(response.data);
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        });
    };

    /**
     * Realiza a formatação necessária para a exibição do grid
     * @param array
     * @returns {*}
     */
    vm.formatGrid = function (array) {
      /** Filtro para data e horários */
      angular.forEach(array, function (item) {

        if (item.for_student === true) {
          item.for_profile = 'Estudantes';
        }
        if (item.for_parents === true) {
          item.for_profile = 'Parentes';
        }
        if (item.for_teacher === true) {
          item.for_profile = 'Professores';
        }
        if (item.for_employee === true) {
          item.for_profile = 'Funcionários';
        }


        /** Filtro para datas */
        item.date = $filter('date')(item.date, "dd/MM/yyyy (EEE)");
        item.final_date = $filter('date')(item.final_date, "dd/MM/yyyy (EEE)");

      });

      return array;
    };

    /**
     * Atualiza a lista ao mudar de aba
     */
    vm.reload = function () {
      vm.paginate();
    };

    vm.delete = function (item) {
      if(item.type !== "5") {
        ModalFactory.confirm(null, "Confirmar exclusão",
          "Deseja realmente excluir este documento?",
          'Confirmar', 'Cancelar', 'educational').then(function () {
          $rootScope.show_loader = true;
          DocumentsService.deleteDocument(item.id).then(function () {
            $rootScope.show_loader = false;
            vm.paginate();
          })
        });
      } else {
        Common.Toast.error('Não é possivel excluir o termo de renegociação');
        $rootScope.show_loader = false;
      }
    };

    /**
     * Cria uma nova mensagem
     */
    vm.createDocument = function () {
      $state.go('private.educational.documents.create-edit', {for: vm.selected_tab})
    };

    /**
     * Edita uma mensagem
     * @param document
     */
    vm.editDocument = function (document) {
      if (!vm.checkPolicies('edit_educ_msgs')) {
        $state.go('private.educational.documents.create-edit', {for: vm.selected_tab, id: document.id})
      }
    };

    /**
     * Executa uma função desejada na lista de opções do grid
     * @param document
     * @param option
     */
    vm.clickActions = function (document, option) {
      switch (option) {
        case 'send-document':
          vm.sendDocument(document);
          break;
        case 'disable-document':
          vm.disableDocument(document);
          break;
        default:
      }
    };

    /**
     * Desativa um documento
     * @param document
     */
    vm.disableDocument = function (document) {
      ModalFactory.confirm(null,
        'Desativar documento?',
        "Confirme para desativar o documento, após essa ação ele não será mais listado no sistema.",
        'Confirmar', 'Cancelar', 'educational'
      ).then(function () {
        $rootScope.show_loader = true;
        DocumentsService.disableDocument(document.id)
          .then(function () {
            $rootScope.show_loader = false;
            vm.paginate();
          })
          .catch(function () {
            Common.Toast.error('Erro ao desativar');
          })
      });
    }

    vm.openModalEdit = function() {
      ModalFactory.customClean(
        'app/educational/documents/views/document-options.html',
        'DocumentOptionsController', 'vm', false,
        {})
        .then(function (response) {
          if (response) {
            Common.Toast.success('Configurações salvas com sucesso');
          }

        });
    }

    /**
     * Abre o modal para envio da mensagem
     * @param document
     */
    vm.sendDocument = function (document) {
      if (vm.selected_tab === 0) {
        ModalFactory.confirm(null,
          'Deseja enviar a mensagem para todos do sistema?',
          "A mensagem será enviada para todos os usuários do sistema que possuem e-mail cadastrado, '<\br>' " +
          "independente da sua categoria",
          'Confirmar', 'Cancelar', 'educational'
        )
      } else if (document.type === '4') {
        ModalFactory.customClean(
          'app/educational/documents/views/modal-send.html',
          'DocumentsSendPrintController', 'vm', false,
          {document: document, selected_tab: vm.selected_tab})
          .then(function (response) {
            if (response) {
              Common.Toast.success('Mensagem enviada com sucesso');
            }
            // if (response) {
            //   vm.paginate();
            // }
          });
      } else if (vm.selected_tab === 4) {
        ModalFactory.customClean(
          'app/educational/documents/views/modal-send.html',
          'DocumentsSendPrintController', 'vm', false,
          {})
          .then(function (response) {
            if (response) {
              Common.Toast.success('Mensagem enviada com sucesso');
            }

          });

      } else {
        ModalFactory.customClean(
          'app/educational/documents/views/modal-send.html',
          'DocumentsSendPrintController', 'vm', false,
          {document: document, selected_tab: vm.selected_tab})
          .then(function (response) {
            if (response) {
              Common.Toast.success('Mensagem enviada com sucesso');
            }
            // if (response) {
            //   vm.paginate();
            // }
          });
      }
    };

    $scope.$on('$destroy', function () {
      if (vm.floatButton !== null) {
        vm.floatButton.destroy();
      }
    });

    vm.init();
  }

  angular
    .module('app.educational.documents')
    .controller('DocumentsController', DocumentsController)
})();

(function () {
    'use strict';
  
    /** @ngInject */
    function DocumentOptionsController(LocalStorage, DropzoneService, CONFIG, $mdDialog, $document, Common, DocumentsService, $window) {
      var vm = this;
      var connection = $document[0].domain.split('.')[0];
      var company = LocalStorage.get('current_company', "sessionStorage");
      vm.water_mark = null;
      vm.url = CONFIG.webApiUri;

      vm.init = function () {
        vm.getWaterMark();
        console.log(vm.water_mark);
      }
  
          /** Define as configurações para o upload */
          vm.dzOptions = {
            url: CONFIG.webApiUri + 'api/document/uploadsinglefile?company=' + company + '&connection=' + connection,
            paramName: 'file',
            maxFilesize: '10000',
            acceptedFiles: DropzoneService.getMimeTypes(['PNG']),
            uploadMultiple: false,
            parallelUploads: 1,
            maxFiles: 1,
            autoProcessQueue: true
          };
      
          vm.dzCallbacks = {
            'addedfile': function (file) {
                Object.defineProperty(file, 'name', {
                  writable: true,
                  value: 'watermark.png'
                });
            
                DropzoneService.getBase64(file).then(function (base64) {
                  // vm.water_mark = { name: 'watermark', base64: base64, size: file.size };
                });
              },
              'sending': function (file, xhr, formData) {
                formData.append('customFileName', 'watermark.png');
              },
            'success': function (file, xhr) {
              vm.getWaterMark();
            },
            'error': function (file, errorMessage) {
              Common.Toast.error(errorMessage);
            }
          };

          vm.getWaterMark = function () {
            DocumentsService.getWaterMark()
                .then(function(response) {
                    vm.water_mark = response;
                })
          }

          vm.deleteWaterMark = function () {
            DocumentsService.deleteWaterMark()
                .then(function() {
                    vm.water_mark = null;
                })
          }

          vm.openUrl = function () {
            console.log(vm.url);
            console.log(vm.water_mark);
            console.log(vm.url + vm.water_mark);
            $window.open(vm.url + vm.water_mark);
          }
      
          vm.closeModal = function () {
            $mdDialog.hide();
          };

          vm.init();
  
    }
  
    angular
      .module('app.educational.documents')
      .controller('DocumentOptionsController', DocumentOptionsController)
  })();
  
(function () {
  'use strict';

  angular
    .module('app.educational.dashboard', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.dashboard', {
        url: '/dashboard',
        public: false,
        auth: 'educational_dash',
        templateUrl: 'app/educational/dashboard/dashboard.html',
        controller: 'DashboardEduController',
        controllerAs: 'vm'
      })
      .state('private.educational.dashboard.students', {
        url: '/students/:id',
        params: {
          id: null
        },
        public: false,
        views: {
          'students': {
            templateUrl: 'app/educational/students/views/students-page.html',
            controller: 'StudentsEditController',
            controllerAs: 'vm'
          },
          'classes@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/classes/views/classes.html',
            controller: 'ClassesStudentsController',
            controllerAs: 'vm'
          },
          'evaluations-student@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/evaluations-student/views/evaluations-student.html',
            controller: 'EvaluationsStudentController',
            controllerAs: 'vm'
          },
          'classrooms@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/classrooms/views/classrooms.html',
            controller: 'ClassroomsStudentsController',
            controllerAs: 'vm'
          },
          'financial@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/financial/views/financial.html',
            controller: 'FinancialStudentsController',
            controllerAs: 'vm'
          },
          'school-reports@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/school-reports/views/school-reports.html',
            controller: 'SchoolReportsController',
            controllerAs: 'vm'
          },
          'occurrences@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/occurrences/views/occurrences.html',
            controller: 'OccurrencesStudentsController',
            controllerAs: 'vm'
          },
          'schoolrecords@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/schoolrecords/views/schoolrecords.html',
            controller: 'SchoolRecordsController',
            controllerAs: 'vm'
          },
          'timetable@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/timetable/views/timetable.html',
            controller: 'TimetableStudentsController',
            controllerAs: 'vm'
          },
          'wall@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/wall/views/wall.html',
            controller: 'WallStudentsController',
            controllerAs: 'vm'
          },
          'extra-subjects@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/extra-subjects/views/extra-subjects.html',
            controller: 'ExtraSubjectsController',
            controllerAs: 'vm'
          },
          'subjects@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/subjects/views/subjects.html',
            controller: 'SubjectsStudentsController',
            controllerAs: 'vm'
          },
          'questionnaires-student@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/questionnaires/views/questionnaires.html',
            controller: 'QuestionnairesStudentsController',
            controllerAs: 'vm'
          },
          'medical-records@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/medical-records/views/medical-records.html',
            controller: 'MedicalRecordsController',
            controllerAs: 'vm'
          },
          'documents@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/documents/views/documents_student.html',
            controller: 'DocumentsStudentController',
            controllerAs: 'vm'
          },
          'enrolments-student@private.educational.dashboard.students': {
            templateUrl: 'app/educational/students/enrolments-student/views/enrolments-student.html',
            controller: 'EnrolmentsStudentController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.dashboard')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('educational.dashboard', {
      title: 'Mural',
      icon: 'icon-window-restore',
      state: 'private.educational.dashboard',
      weight: 1
    });
  }

  angular
    .module('app.educational.dashboard')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function DashboardController($rootScope, PoliciesService, CONFIG, GridService, InformativeReportService, Session,
                               ClassesService, ModalFactory, ReportsService, $state, Common, PersonService, ResponsiblesService) {

    var vm = this;
    vm.documents = [];
    vm.url = CONFIG.webApiUri + 'uploads/';
    vm.profile_selected = Session.get(CONFIG.storage.profile);
    vm.school_period_selected = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.CONFIG = CONFIG;
    vm.email_errors = [];
    vm.email_report = [];
    vm.enrolment_evolution_chart = {};
    vm.enrolment_by_course_chart = {};
    vm.show_dashboard = false;
    vm.user_email = null;
    vm.person = null;

    vm.init = function () {
      vm.getInformativeReport();
      vm.show_dashboard = !vm.checkPolicies('info_gerenciais');
      // vm.getPendencies();
      
      if (vm.checkProfile(vm.CONFIG.profile.parent)) {
      vm.getResponsibleInfos(Session.user.id)
    }
    };

    vm.saveResponsibleEmail = function () {
      $rootScope.show_loader = true;
      PersonService.saveResponsibleEmail({
        user_email: vm.user_email,
        user_id: Session.user.id
      })
      .then(function (response) {
        $rootScope.show_loader = false;
        vm.getResponsibleInfos(Session.user.id);
        Common.Toast.success('Email salvo com sucesso!');
      })
      .catch(function (error) {
        $rootScope.show_loader = false;
        Common.Toast.error('Não foi possível salvar o email.');
      })
    };

    vm.getResponsibleInfos = function (responsible_id) {
      $rootScope.show_loader = true
      ResponsiblesService.getById(responsible_id)
      .then(function (response) {
        $rootScope.show_loader = false
        vm.person = response.person
      });
    };


    /**
     * Retorna todos os boletim informativo disponíveis de acordo com o perfil do usuário
     */
    vm.getInformativeReport = function () {
      var limit = false;

      InformativeReportService.getAll({limit: limit, is_dashboard: true, type: 1})
        .then(function (response) {
          vm.documents = response;
        });
    };

    vm.showEmailsDetails = function () {
      ModalFactory.customClean('app/educational/dashboard/emails-errors-details.html',
        'A4BillGridDetailsController', 'vm', true, {report: vm.email_report});
    };

    /**
     * Retorna pendências de notas e aulas do usuário
     */
    vm.getPendencies = function () {
      // ClassesService.getPendencies()
      //   .then(function (response) {
      //     vm.tree_data = response.plain();
      //   });
    };
    vm.loadCharts = function () {
      vm.getEmailsInfo();
      vm.enrolmentEvolutionChart();
      vm.enrolmentByCourseChart();
    };

    vm.getEmailsInfo = function () {
      $rootScope.show_loader = true;
      GridService.getEmailsInfo().then(function (response) {
        var data = response.plain();
        vm.emails_errors = data.aggregation;
        vm.emails_report = data.report;
        $rootScope.show_loader = false;
      })
    };

    /**
     * Retorna pendências de notas e aulas do usuário
     */
    vm.openImage = function (url, title) {
      ModalFactory.customClean(
        'app/educational/dashboard/show-image.html',
        /** @ngInject */
        function ($rootScope, ModalExtra) {
          var vm = this;
          vm.url = ModalExtra.url;
          vm.title = ModalExtra.title;
          vm.close = function () {
            $rootScope.$broadcast('ModalFactory.close');
          }
        },
        'vm', false, {url: url, title: title}
      );
    };

    vm.enrolmentEvolutionChart = function () {
      vm.enrolment_evolution_chart.options = {
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [
            {
              id: 'y-axis-1',
              type: 'linear',
              display: true,
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'Quantidade'
              }
            }
          ]
        },
        elements: {
          line: {
            fill: false
          }
        }
      };
      vm.enrolment_evolution_chart.series = vm.school_period_selected > 0 ? ['Matriculas', 'Permaneceram', 'Alunos novos', 'Saíram', 'Concluíram'] : ['Matriculas', 'Permaneceram', 'Alunos novos', 'Saíram'];
      vm.enrolment_evolution_chart.colors = vm.school_period_selected > 0 ? ["#018c03", "#226f9a", "#989a00", "#9a4c00", "#5c009a"] : ["#018c03", "#226f9a", "#989a00", "#9a4c00"];
      vm.enrolment_evolution_chart.data = [];
      ReportsService.enrolmentEvolutionChart()
        .then(function (resp) {
          var data = resp.plain();
          vm.enrolment_evolution_chart.data[0] = data.enrolment;
          vm.enrolment_evolution_chart.data[1] = data.retention;
          vm.enrolment_evolution_chart.data[2] = data.new;
          vm.enrolment_evolution_chart.data[3] = data.evasion;
          if (vm.school_period_selected > 0) {
            vm.enrolment_evolution_chart.data[4] = data.graduation;
          }
          vm.enrolment_evolution_chart.labels = data.school_period_name;
        })
    };

    vm.enrolmentByCourseChart = function () {
      vm.enrolment_by_course_chart.options = {
        legend: {
          reverse: true,
          display: true
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [
            {
              id: 'y-axis-1',
              type: 'linear',
              display: true,
              stacked: true,
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'Quantidade'
              }
            }
          ]
        },
        elements: {
          line: {
            fill: false
          }
        }
      };
      vm.enrolment_by_course_chart.series = vm.school_period_selected > 0 ? ['Permaneceram', 'Alunos novos', 'Saíram'] : ['Permaneceram', 'Alunos novos'];
      vm.enrolment_by_course_chart.colors = vm.school_period_selected > 0 ? ["#226f9a", "#989a00", "#9a4c00"] : ["#226f9a", "#989a00"];
      vm.enrolment_by_course_chart.data = [];
      ReportsService.enrolmentByCourseChart()
        .then(function (resp) {
          var data = resp.plain();
          vm.enrolment_by_course_chart.data[0] = data.retention;
          vm.enrolment_by_course_chart.data[1] = data.new;
          if (vm.school_period_selected > 0) {
            vm.enrolment_by_course_chart.data[2] = data.evasion;
          }
          vm.enrolment_by_course_chart.labels = data.course_alias;
        })
    };


    vm.printChart = function () {
      $rootScope.show_loader = true;
     ReportsService.reportFactory('GET',
      'api/reports/printchart',
      { type: 4 }).then(function() {
      $rootScope.show_loader = false;
      }).catch(function(error) {
        Common.Toast.error(error.message || error.data.message);
      })
    }

    /**
     * Realiza a verificação do perfil selecionado
     * @param profile
     * @returns {boolean}
     */
    vm.checkProfile = function (profile) {
      return PoliciesService.currentProfile() === profile;
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();

  }

  angular
    .module('app.educational.dashboard')
    .controller('DashboardEduController', DashboardController);

})();

(function() {
    'use strict';
    angular
        .module('app.educational.course-group', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function CourseGroupService(Restangular) {

    /**
     * Retorna todos os cursos
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('course_group').get(obj);
    };

    /**
     * Retorna s curso pelo id
     * @returns array
     */
    var getById = function (id) {
      return Restangular.one('course', id).get();
    };

    /**
     * Retorna todos os grupos de cursos
     * @returns array
     */
    var getGroups = function () {
      return Restangular.one("course/getgroups").get();
    };

    /**
     * Retorna todos os graus de cursos conferidos.
     * @returns array
     */
    var getDegreeConferred = function () {
      return Restangular.one("course/getdeegreeconferred").get();
    };

    /**
     * Cria um novo curso
     */
    var createGroup = function (obj) {
      return Restangular.all('course_group').post({group: obj});
    };

    /**
     * Atualiza um novo curso
     */
    var updateGroup = function (obj) {
      return Restangular.one('course_group', obj.id).customPUT({group: obj});
    };

    /**
     * Remove um curso
     */
    var deleteGroup = function (id) {
      return Restangular.one('course_group', id).remove();
    };

    return {
      getAll: getAll,
      getGroups: getGroups,
      getDegreeConferred: getDegreeConferred,
      createGroup: createGroup,
      getById: getById,
      updateGroup: updateGroup,
      deleteGroup: deleteGroup
    };

  }

  angular
    .module('app.educational.course-group')
    .factory('CourseGroupService', CourseGroupService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.course-group', {
        url: '/course-group',
        public: false,
        templateUrl: 'app/educational/course-group/views/course-group.html',
        controller: 'CourseGroupController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.educational.course-group')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'curso';
    var path = 'config.course-group';

    msNavigationService.saveItem('config.course-group', {
      title: 'Grupos de Curso',
      icon: 'icon-bookmark',
      auth: 'curso',
      state: 'private.educational.course-group',
      weight: 6,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.course-group')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function CourseGroupController($scope, $rootScope, $timeout, $a4FloatButton,
                                 ModalFactory, CourseGroupService, Common, PoliciesService) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.form = {};

    vm.group = {name: ''};

    /**
     * Evento de inicialização da tela
     * @type {*}
     */
    var ltn = $rootScope.$on('a4-grid-dic-data.loaded', function () {
      vm.paginate();
    });

    vm.init = function () {
      if(!vm.checkPolicies('curso_alt')){
        vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createCourse(vm.group)'});
      }
    };

    /**
     * Retorna todos os grupos de curso disponíveis
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     */
    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = CourseGroupService.getAll({limit: limit, page: page})
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
          $rootScope.show_loader = false;
        });
    };

    /**
     * Chamada do serviço de retorna todos os grupos de curso da API
     */
    vm.getAll = function () {
      CourseGroupService.getAll()
        .then(function (response) {
          vm.grid.rows = response;
        })
        .catch(function () {
        });
    };

    vm.editCourse = function (item) {
      ModalFactory.prompt(null,
        'Editar grupo',
        ' ',
        'Nome do grupo',
        item.name,
        'Salvar',
        'Cancelar',
        'educational', vm.checkPolicies('curso_alt'))
        .then(function (response) {
            item.name = response;
            CourseGroupService.updateGroup(item)
              .then(function () {
                Common.Toast.success('Grupo editado com sucesso!');
                vm.paginate();
              })
              .catch(function (response) {
                switch (response.data.message) {
                  case "DUPLICATED_NAME":
                    Common.Toast.warning('Existe um grupo com esse nome no sistema.');
                    vm.paginate();
                    break;
                  case "EMPTY_NAME":
                    Common.Toast.warning('Nome do grupo não pode ficar em branco.');
                    vm.paginate();
                    break;
                  default:
                    Common.Toast.error('Não foi possivel editar o grupo.');
                    vm.paginate();
                    break;
                }
              })
          }
        );
    };

    vm.createCourse = function (item) {
      ModalFactory.prompt(null,
        'Criar novo grupo',
        ' ',
        'Nome do grupo',
        null,
        'Salvar',
        'Cancelar',
        'educational', vm.checkPolicies('curso_alt'))
        .then(function (response) {
            if (response == undefined) {
              Common.Toast.warning('Nome do grupo não pode ficar em branco.');
              return;
            }
            item.name = response;
            CourseGroupService.createGroup(item)
              .then(function () {
                Common.Toast.success('Grupo criado com sucesso!');
                vm.paginate();
              })
              .catch(function (response) {
                switch (response.data.message) {
                  case "DUPLICATED_NAME":
                    Common.Toast.warning('Existe um grupo com esse nome no sistema.');
                    break;
                  case "EMPTY_NAME":
                    Common.Toast.warning('Nome do grupo não pode ficar em branco.');
                    break;
                  default:
                    Common.Toast.error('Não foi possivel inserir o grupo.');
                    break;
                }
              })
          }
        );
    };

    /**
     * Verifica Políticas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.deleteCourse = function (index) {
      ModalFactory.confirm(
        '',
        "Confirmar exclusão",
        "Deseja realmente excluir esse grupo",
        'Confirmar',
        'Cancelar')
        .then(function (response) {
          if (response) {
            CourseGroupService.deleteGroup(index)
              .then(function () {
                Common.Toast.success('Grupo excluído com sucesso!');
                vm.paginate();
              })
              .catch(function (response) {
                switch (response.data.message) {
                  case "EXISTS_COURSE_IN_THIS_GROUP":
                    Common.Toast.warning('Este grupo contém cursos associados a ele, não é possível excluir.');
                    break;
                  default:
                    Common.Toast.error('Não foi possivel excluir o grupo.');
                    break;
                }
              })
          }
        })
    };
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });
    vm.init();
  }

  angular
    .module('app.educational.course-group')
    .controller('CourseGroupController', CourseGroupController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CourseService(Restangular) {

    /**
     * Retorna todos os cursos
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('course').get(obj);
    };

    var getAllForOnlineEnrolment = function (obj) {
      return Restangular.one('course').one('getallcoursesonlineenrolment').get(obj);
    };

    /**
     * Retorna s curso pelo id
     * @returns array
     */
    var getById = function (id) {
      return Restangular.one('course', id).get();
    };

    /**
     * Retorna as turmas pelo id do curso
     * @returns array
     */
    var getGroupsByCourse = function (course_id, obj) {
      return Restangular.one('course', course_id).one('groups').get(obj);
    };
    /**
     * Retorna as turmas pelo id do curso
     * @returns array
     */
    var getCoursesWithGroups = function () {
      return Restangular.one('course').one('withgroups').get();
    };

    /**
     * Retorna todos os cursos equivalentes
     * @returns array
     */
    var getInfoForCourse = function () {
      return Restangular.one("course").one('getinfoforcourse').get();
    };

    /**
     * Retorna informações financeiras do curso
     * @param obj
     * @returns {*}
     */
    var getFinanceCourseInfo = function (obj) {
      return Restangular.one('course').one('getfinancecourseinfo').get(obj);
    };
    /**
     * Salva informações financeiras do curso
     * @param obj
     * @returns {*}
     */
    var saveFinanceCourseInfo = function (obj) {
      return Restangular.one('course').all('savefinancecourseinfo').post(obj);
    };

    /**
     * Cria um novo curso
     */
    var createCourse = function (obj) {
      return Restangular.all('course').post({course: obj});
    };

    /**
     * Atualiza um novo curso
     */
    var updateCourse = function (obj) {
      return Restangular.one('course', obj.id).customPUT({course: obj});
    };

    var duplicateCourse = function (obj) {
      return Restangular.one('course', obj.id).all('duplicatecourse').post(obj);
    };

    /**
     * Busca cursos pelo nome
     * @param obj
     * @returns {*}
     */
    var getAllCoursesByText = function (obj) {
      return Restangular.one('course').one('getallcoursesbytext').get(obj);
    };

    var getCoursesAndExtraServices = function (obj) {
      return Restangular.one('course').one('getcoursesandservices').get(obj);
    };

    var getGroupsInfosByCourse = function (obj) {
      return Restangular.one('course').one('getgroupsinfosbycourse').get(obj);
    };

    /**
     * Remove um curso
     */
    var deleteCourse = function (id) {
      return Restangular.one('course', id).remove();
    };

    return {
      getAll: getAll,
      getAllCoursesByText: getAllCoursesByText,
      getAllForOnlineEnrolment: getAllForOnlineEnrolment,
      getGroupsByCourse: getGroupsByCourse,
      createCourse: createCourse,
      getById: getById,
      duplicateCourse: duplicateCourse,
      getInfoForCourse: getInfoForCourse,
      getCoursesWithGroups: getCoursesWithGroups,
      updateCourse: updateCourse,
      deleteCourse: deleteCourse,
      getGroupsInfosByCourse: getGroupsInfosByCourse,
      getCoursesAndExtraServices: getCoursesAndExtraServices,
      getFinanceCourseInfo: getFinanceCourseInfo,
      saveFinanceCourseInfo: saveFinanceCourseInfo
    };

  }

  angular
    .module('app.educational.course')
    .factory('CourseService', CourseService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.course', {
        public: false,
        url: '/course',
        templateUrl: 'app/educational/course/views/course.html',
        abstract: true
      })
      .state('private.educational.course.list', {
        url: '/list',
        public: false,
        views: {
          'course': {
            templateUrl: 'app/educational/course/views/list.html',
            controller: 'CourseController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.course.edit', {
        url: '/:id/:course_equivalence_id/view',
        public: false,
        views: {
          'course': {
            templateUrl: 'app/educational/course/views/course-page.html',
            controller: 'CourseEditController',
            controllerAs: 'vm'
          },
          'matrix@private.educational.course.edit': {
            templateUrl: 'app/educational/course/matrix/views/matrix.html',
            controller: 'MatrixController',
            controllerAs: 'vm'
          },
          'documents@private.educational.course.edit': {
            templateUrl: 'app/educational/course/documents/views/documents.html',
            controller: 'CourseDocumentsController',
            controllerAs: 'vm'
          },
          'group@private.educational.course.edit': {
            templateUrl: 'app/educational/course/group/views/group.html',
            controller: 'GroupController',
            controllerAs: 'vm'
          },
          'students@private.educational.course.edit': {
            templateUrl: 'app/educational/course/students/views/students.html',
            controller: 'CourseStudentsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.course.create', {
        url: '/create',
        public: false,
        views: {
          'course': {
            templateUrl: 'app/educational/course/views/course-page.html',
            controller: 'CourseCreateController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.course')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'curso_menu';
    var path = 'config.course';

    msNavigationService.saveItem(path, {
      title: 'Cursos',
      icon: 'icon-school',
      auth: role,
      state: 'private.educational.course.list',
      weight: 3,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.course')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function CourseEditController($scope, $state, $a4FloatButton, $rootScope, CourseService, Common, ModalFactory, PoliciesService, LocalStorage) {
    var vm = this;
    var LocalStorageKEY = 'course_current_tab';
    vm.list = {};
    vm.list.course = {};
    vm.form = {};
    vm.form.course = {};
    vm.form.mode_edit = false;
    vm.selected_tab = LocalStorage.get(LocalStorageKEY);
    vm.companies = [];
    vm.bill_categories = [];

    vm.init = function () {
      if (!vm.checkPolicies('curso')) {
        // $a4FloatButton({
        //   scope: $scope,
        //   uiSref: 'private.educational.course.list',
        //   icon: 'undo',
        //   label: 'voltar a lista de cursos'
        // });
      }
      vm.getById($state.params.id);
      vm.getInfoForCourse();
    };

    vm.getInfoForCourse = function () {
      CourseService.getInfoForCourse()
        .then(function (response) {
          vm.list.course = response.plain();
          $rootScope.show_loader = false;
        })
    };

    vm.getById = function (id) {
      CourseService.getById(id)
        .then(function (response) {
          vm.form.course = response.plain();
          vm.form.course.school_period_serie_id_disabled = true;
          $state.params.course_equivalence_id = vm.form.course.course_equivalence_id;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel recuperar os dados do curso.');
          $rootScope.show_loader = false;
        });

    };

    vm.getFinanceCourseInfo = function () {
      CourseService.getFinanceCourseInfo({course_id: $state.params.id}).then(function (response) {
        var obj = response.plain();
        vm.companies = obj.companies;
        vm.bill_categories = obj.bill_categories;
        vm.course_finance = obj.info_course;
      })
    };

    vm.saveFinanceCourseInfo = function () {
      $rootScope.show_loader = true;
      CourseService.saveFinanceCourseInfo({product_group: vm.course_finance})
        .then(function () {
          Common.Toast.success('Informações salvas com sucesso!');
          $rootScope.show_loader = false;
        }).catch(function (error) {
        Common.Toast.error(error.data.message);
        $rootScope.show_loader = false;
      })
    };


    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Submete o curso a criação..
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        if (angular.isDefined(item.id)) {
          CourseService.updateCourse(item)
            .then(function (response) {
              Common.Toast.success('Curso atualizado com sucesso!');
              vm.getById(response.id);
              vm.form.mode_edit = false;
              $state.reload($state.current.name);
            })
            .catch(function (response) {
              $rootScope.show_loader = false;
              switch (response.data.message) {
                case "DUPLICATED_NAME":
                  Common.Toast.warning('Existe um curso com esse nome no sistema.');
                  break;
                case "EMPTY_NAME":
                  Common.Toast.warning('Nome do curso não pode ficar em branco.');
                  break;
                default:
                  Common.Toast.error('Não foi possivel inserir o curso.');
                  break;
              }
            });
        }
      }
    };


    vm.delete = function (item) {
      ModalFactory.confirm(null,
        'Deseja remover o curso?',
        'O curso ' + item.name + ' será removida',
        'Confirmar', 'Cancelar', 'educational')
        .then(function (response) {

          if (response) {
            CourseService.deleteCourse(item.id)
              .then(function () {
                Common.Toast.success('Curso excluído com sucesso!');
                $state.go('private.educational.course.list');
              })
              .catch(function (response) {
                switch (response.data.message) {
                  case "EXISTS_MATRIX_OR_GROUP_IN_THIS_COURSE":
                    Common.Toast.warning('Este curso contém grades ou turmas associadas a ele, não é possível excluir.');
                    break;
                  default:
                    Common.Toast.error('Não foi possivel excluir o grupo.');
                    break;
                }
              })
          }
        });
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param item - novo item selecionado
     */
    vm.changeGroup = function (item) {
      if (angular.isDefined(item)) {
        $state.go('private.educational.course.edit', {id: item.id}, {reload: true});
      }
    };

    vm.close = function () {
      if ($state.params.hasOwnProperty('id')) {
        vm.form.mode_edit = !vm.form.mode_edit;
        if (!vm.form.mode_edit) {
          vm.getById($state.params.id);
        }
      } else {
        $state.go('private.educational.course.list');
      }
    };

    /**
     * Escuta da tab corrente, a cada troca de tab em turmas, esta escuta salva a corrente no localstorage;
     * @type {*}
     */
    var ltn = $scope.$watch(function () {
        return vm.selected_tab;
      },
      function (newer, older) {
        if (parseInt(newer) !== parseInt(older))
          LocalStorage.add(LocalStorageKEY, newer);
      });

    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });


    vm.init();
  }

  angular
    .module('app.educational.course')
    .controller('CourseEditController', CourseEditController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CourseCreateController($rootScope, $state, CourseService, Common) {
    var vm = this;
    vm.list = {};
    vm.list.course = {};
    vm.form = {};
    vm.form.course = {};
    vm.form.mode_edit = false;
    vm.selected_tab = 0;

    vm.init = function () {
      vm.form.mode_edit = true;
      vm.getInfoForCourse();
    };

    vm.getInfoForCourse = function () {
      CourseService.getInfoForCourse()
        .then(function (response) {
          vm.list.course = response.plain();
          if(vm.list.course.school_period_serie_id.length === 1){
            vm.form.course.school_period_serie_id = vm.list.course.school_period_serie_id[0].id;
          }
          $rootScope.show_loader = false;
        })
    };

    /**
     * Submete o curso a criação..
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        CourseService.createCourse(item)
          .then(function (response) {
            Common.Toast.success('Curso criado com sucesso!');
            $state.go('private.educational.course.edit', {id: response.id});
            vm.form.mode_edit = false;
          })
          .catch(function (response) {
            switch (response.data.message) {
              case "DUPLICATED_NAME":
                Common.Toast.warning('Existe um curso com esse nome no sistema.');
                break;
              case "EMPTY_NAME":
                Common.Toast.warning('Nome do curso não pode ficar em branco.');
                break;
              default:
                Common.Toast.error('Não foi possivel inserir o curso.');
                break;
            }
          });
      }
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param item - novo item selecionado
     */
    vm.changeGroup = function (item) {
      if (angular.isDefined(item)) {
        $state.go('private.educational.course.edit', {id: item.id}, {reload: true});
      }
    };

    vm.close = function () {
      if ($state.params.hasOwnProperty('id')) {
        vm.form.mode_edit = !vm.form.mode_edit;
        if (!vm.form.mode_edit) {
          vm.getById($state.params.id);
        }
      } else {
        $state.go('private.educational.course.list');
      }
    };


    vm.init();
  }

  angular
    .module('app.educational.course')
    .controller('CourseCreateController', CourseCreateController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CourseController($state, $rootScope, $mdMenu, $scope, $a4FloatButton, Common, CourseService, ModalFactory, PoliciesService) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.form = {};
    vm.only_active = false;


    /**
     * Evento de inicialização da tela
     * @type {*}
     */
    var ltn = $rootScope.$on('a4-grid-dic-data.loaded', function () {
      vm.getAllCourse();
    });


    /**
     * Função de inicialização do controlador.
     */
    vm.init = function () {
      if (!vm.checkPolicies('curso_alt')) {
        vm.float_button = $a4FloatButton({
          scope: $scope,
          uiSref: 'private.educational.course.create',
          theme: 'educational',
          label: 'Criar novo'
        });
      }
      vm.getAllCourse();
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };


    /**
     * Resgata todos os cursos, com paginação de limite 50 por pagina
     * @param page - (Opcional) Pagina de destino
     * @param limit - limite de registros
     */
    vm.getAllCourse = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 20;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = CourseService.getAll({limit: limit, page: page, only_active: !vm.only_active})
        .then(function (response) {
          vm.grid = response.plain();
          $rootScope.show_loader = false;
        });
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterCourseList = function (query) {
      CourseService.getAll({query: query, only_active: !vm.only_active, include_empty: true})
        .then(function (response) {
          vm.grid.data = response.plain();
          $rootScope.show_loader = false;
        })
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.clickActions = function (course, action) {
      switch (action) {
        case 'duplicate':
          vm.duplicate(course);
          break;
      }
    };

    vm.duplicate = function (course) {
      ModalFactory.prompt(
        null,
        'Nome da duplicação',
        'Digite o nome do novo curso:',
        '',
        course.name,
        'Confirmar',
        'Cancelar',
        'educational').then(function (course_name) {
        $rootScope.show_loader = true;
        course.new_name = course_name;
        CourseService.duplicateCourse(course).then(function (response) {
          if (response) {
            Common.Toast.success('Curso duplicado com sucesso!');
            vm.getAllCourse();
          }
        })
      });
    };

    /**
     * Edição de cursos
     * @param item - item a ser editado
     */
    vm.editCourse = function (item) {
      $state.go('private.educational.course.edit', {id: item.id, course_equivalence_id: item.course_equivalence_id});
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.course')
    .controller('CourseController', CourseController)
})();

(function() {
  'use strict';
  angular
    .module('app.educational.coordinators', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function CoordinatorsService(Restangular) {
    var get = function (obj) {
      return Restangular.one('coordinators').get(obj);
    };

    var getTeachersAndColaborators = function (query) {
      return Restangular.one('coordinators').one('catch').get(query);
    };

    var getTree = function (obj) {
      return Restangular.one('course').one('gettreeofcoursesandactivegroups').get(obj);
    }

    var getTreeOfCoordinator = function (person_id) {
      return Restangular.one('course').one('gettreeofcoursesandactivegroupsforperson').get({person_id: person_id});
    }

    var getListOfCoordinatedGroupsOfCoordinator = function (person_id) {
      return Restangular.one('coordinators').one('getlistofcoordinatedgroupsofcoordinator').get({person_id: person_id});
    }

    var getGroupsWithoutCoordinators = function () {
      return Restangular.one('coordinators').one('groupswithoutcoordinators').get();
    }

    var createCoordinator = function (obj) {
      return Restangular.all('coordinators').post(obj);
    }

    var updateCoordinator = function (obj) {
      return Restangular.one('coordinators', obj[0].person_id).customPUT(obj);
    }

    var removeCoordinator = function (obj) {
      return Restangular.one('coordinators').all('removeCoordinator').post(obj);

    }

    return {
      get: get,
      getTeachersAndColaborators: getTeachersAndColaborators,
      getTree: getTree,
      getGroupsWithoutCoordinators: getGroupsWithoutCoordinators,
      createCoordinator: createCoordinator,
      updateCoordinator: updateCoordinator,
      removeCoordinator: removeCoordinator,
      getTreeOfCoordinator: getTreeOfCoordinator,
      getListOfCoordinatedGroupsOfCoordinator: getListOfCoordinatedGroupsOfCoordinator

    };

  }

  angular
    .module('app.educational.coordinators')
    .factory('CoordinatorsService', CoordinatorsService)

})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.coordinators', {
        public: false,
        url: '/coordinators',
        template: '<div ui-view="coordinators"></div>',
        abstract: true
      })
      .state('private.educational.coordinators.list', {
        url: '/coordinators/list',
        public: false,
        views: {
          'coordinators': {
            templateUrl: 'app/educational/coordinators/views/coordinators-grid.html',
            controller: 'CoordinatorsController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.coordinators')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'group_coord';
    var path = 'coordination.coordinators';

    msNavigationService.saveItem(path, {
      title: 'Coordenação de cursos',
      icon: 'icon-bulletin-board',
      state: 'private.educational.coordinators.list',
      weight: 5,
      auth: role,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.coordinators')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function CoordinatorsEditController($state, $mdDialog, $rootScope, $scope, $a4FloatButton, CoordinatorsService, Common, ModalExtra) {

    var vm = this;

    vm.coordinator = ModalExtra.item;
    vm.selectedBeforeSubmit = [];

    vm.close = function () {
      $mdDialog.cancel();
    };

    /**
     * Submit do formulário. Pega todos os ids de turma e a pessoa selecionada, e itera criando os papéis de coordenador(a).
     * @param form
     */
    vm.submit = function () {

      var arrayObjects = [];
      for (var i = 0; i < vm.selectedCoursesAndGroups.length; i++) {
        if (vm.selectedCoursesAndGroups[i] < 1000000) {
          var objCreate = {};
          objCreate.person_id = vm.coordinator.person_id;
          objCreate.group_id = parseInt(((vm.selectedCoursesAndGroups[i]) / 100));
          arrayObjects.push(objCreate);
        }
      }
      /** Caso não existam turmas marcadas no formulário, chama a função que deleta os papéis do coordenador */
      if (angular.isUndefined(arrayObjects[0])) {
        vm.deleteCourses(vm.coordinator);
      } else {
        vm.updateCoordinators(arrayObjects);
      }
    };


    /**
     * Retorna lista de turmas coordenadas pela pessoa no período letivo corrente
     * @param person_id
     */
    vm.getCoordinatedGroups = function (person_id) {
      CoordinatorsService.getListOfCoordinatedGroupsOfCoordinator(person_id).then(function (response) {
        vm.selectedBeforeSubmit = response.plain();
      })
    };

    /**
     * Altera um coordenador
     * @param obj
     */
    vm.updateCoordinators = function (obj) {
      CoordinatorsService.updateCoordinator(obj)
        .then(function () {
          $mdDialog.hide(true);
        })
        .catch(function (response) {
          Common.Toast.error(response.data.message);
        })
    };

    /**
     * Deleta os papéis de coordenador da pessoa
     * @param item
     */
    vm.deleteCourses = function (item) {
      CoordinatorsService.removeCoordinator(item).then(function () {
      })
    };


    vm.init = function () {
      vm.setTree(vm.coordinator.person_id);
      vm.getCoordinatedGroups(vm.coordinator.person_id);
    };

    vm.teachers_and_colaborators = [];

    /**
     * Retorna possíveis coordenadores: professores ou colaboradores, para
     * o autocomplete do modal.
     * @param text
     * @returns {*}
     */
    vm.getTeachersAndColaborators = function (text) {
      return CoordinatorsService.getTeachersAndColaborators({query: text});
    };

    /**
     * Faz a requisição para a tree-view, com o id do coordenador selecionado, buscando
     * suas turmas já coordenadas.
     * @param person_id
     */
    vm.setTree = function (person_id) {
      CoordinatorsService.getTreeOfCoordinator(person_id).then(function (response) {
        vm.coursesAndGroups = response.plain();
      });
    };

    vm.init();
  }

  angular
    .module('app.educational.coordinators')
    .controller('CoordinatorsEditController', CoordinatorsEditController)
})
();
(function () {
  'use strict';

  /** @ngInject */
  function CoordinatorsCreateController($state, $mdDialog, $rootScope, $scope, $a4FloatButton, CoordinatorsService, Common) {

    var vm = this;

    vm.close = function () {
      $mdDialog.cancel();
    };

    /**
     * Submit do formulário. Pega todos os ids de turma e a pessoa selecionada, e itera criando os papéis de coordenador(a).
     * @param form
     */
    vm.submit = function () {
      var arrayObjects = [];
      for (var i = 0; i < vm.selectedCoursesAndGroups.length; i++) {
        if (parseInt(vm.selectedCoursesAndGroups[i]) < 1000000) {
          var objCreate = {};
          objCreate.person_id = vm.selectedPerson.id;
          objCreate.group_id = parseInt(((vm.selectedCoursesAndGroups[i]) / 100));
          arrayObjects.push(objCreate);
        }
      }
      vm.createCoordinators(arrayObjects);
    };

    /**
     * Cria um coordenador para uma turma
     * @param obj
     */
    vm.createCoordinators = function (obj) {
      CoordinatorsService.createCoordinator(obj)
        .then(function () {
          $mdDialog.hide(true);
        })
        .catch(function (response) {
          Common.Toast.error(response.data.message);
        })
    };


    vm.init = function () {
      vm.setTree();
    };

    vm.teachers_and_colaborators = [];

    /**
     * Retorna possíveis coordenadores: professores ou colaboradores, para
     * o autocomplete do modal.
     * @param text
     * @returns {*}
     */
    vm.getTeachersAndColaborators = function (text) {

      return CoordinatorsService.getTeachersAndColaborators({query: text});
    };

    /**
     * Busca a árvore de cursos e turmas.
     */
    vm.setTree = function () {
      CoordinatorsService.getTree().then(function (response) {
        vm.coursesAndGroups = response.plain();
      });
    };


    vm.init();

  }

  angular
    .module('app.educational.coordinators')
    .controller('CoordinatorsCreateController', CoordinatorsCreateController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CoordinatorsController($state, $rootScope, $scope, $a4FloatButton, Common, CoordinatorsService, ModalFactory) {

    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };
    vm.selectedCoursesAndGroups = [];

    vm.init = function () {
      vm.paginate();
      vm.getGroupsWithoutCoordinator();
      vm.floatButton = $a4FloatButton({scope: $scope, label: 'Adicionar coordenador', onClick: 'vm.addCoordinator()'});
    }

    /**
     * Paginador do grid
     * @param page
     * @param limit
     */

    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = CoordinatorsService.get({limit: limit, page: page})
        .then(function (response) {
          vm.grid.rows = response.plain();
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
          vm.getGroupsWithoutCoordinator();
          $rootScope.show_loader = false;
        });
    };

    /**
     * Evento do float button, abre modal para adicionar um novo coordenador
     *
     */
    vm.addCoordinator = function () {
      ModalFactory.customClean('app/educational/coordinators/views/modal-create.html',
        'CoordinatorsCreateController', 'vm', false, {})
        .then(function (response) {
          if (response) {
            Common.Toast.success('Coordenador criado com sucesso!');
            vm.paginate();
          }
        });
    }

    /**
     * Busca a quantidade de turmas sem coordenador, no período letivo corrente.
     */
    vm.getGroupsWithoutCoordinator = function () {
      CoordinatorsService.getGroupsWithoutCoordinators()
        .then(function (response) {
          vm.groupsWithoutCoordinator = response;
        })
    }

    vm.clickActions = function (item, option) {
      switch (option) {
        case 'change-groups':
          vm.editCoordinator(item);
          break;
        default:
      }
    };

    /**
     * Abre modal para edição das turmas do coordenador
     * @param item
     */
    vm.editCoordinator = function (item) {
      ModalFactory.customClean('app/educational/coordinators/views/modal-edit.html',
        'CoordinatorsEditController', 'vm', false, {item: item})
        .then(function (response) {
          if (response) {
            Common.Toast.success('Coordenador alterado com sucesso!');
            vm.paginate();
          }
        });
    }

    /**
     * Deleta um papel de coordenador de turma
     * @param id
     */
    vm.delete = function (item) {
      ModalFactory.confirm(null, "Deletar coordenador",
        "Tem certeza que deseja deletar este papel de coordenador de curso?",
        "Confirmar",
        "Cancelar",
        "educational").then(function (response) {
        if (response) {
          CoordinatorsService.removeCoordinator(item).then(function (response) {
            if (response) {
              Common.Toast.success('Coordenador removido com sucesso!');
              vm.paginate();
            }
          })
        }
      })
    }


    vm.init();
  }

  angular
    .module('app.educational.coordinators')
    .controller('CoordinatorsController', CoordinatorsController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ConceptCriteriaService(Restangular) {

    /**
     * Retorna todos os critérios
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('gradecode').get(obj);
    };

    /**
     * Retorna o critério pelo id
     * @returns array
     */
    var get = function (id) {
      return Restangular.one('gradecode', id).get();
    };

    /**
     * Cria um novo critério
     * @param obj
     */
    var createGradeCode = function (obj) {
      return Restangular.all('gradecode').post(obj);
    };

    /**
     * Atualiza o critério
     * @param obj
     */
    var updateGradeCode = function (id, obj) {
      return Restangular.one('gradecode', id).customPUT(obj);
    };

    /**
     * Deleta um critério
     * @param id - id do critério
     */
    var deleteCriteria = function (id) {
      return Restangular.one('gradecode', id).remove();
    };


    return {
      getAll: getAll,
      get: get,
      deleteCriteria: deleteCriteria,
      createGradeCode: createGradeCode,
      updateGradeCode: updateGradeCode
    };

  }

  angular
    .module('app.educational.concept-criteria')
    .factory('ConceptCriteriaService', ConceptCriteriaService);

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.concept-criteria', {
        public: false,
        url: '/concept/criteria',
        templateUrl: 'app/educational/concept-criteria/views/concept-criteria.html',
        abstract: true
      })
      .state('private.educational.concept-criteria.list', {
        url: '/list',
        public: false,
        views: {
          'concept-criteria': {
            templateUrl: 'app/educational/concept-criteria/views/list.html',
            controller: 'ConceptCriteriaController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.concept-criteria.edit', {
        url: '/:id/view',
        public: false,
        views: {
          'concept-criteria': {
            templateUrl: 'app/educational/concept-criteria/views/concept-criteria-page.html',
            controller: 'ConceptCriteriaEditController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.concept-criteria.create', {
        url: '/create',
        public: false,
        views: {
          'concept-criteria': {
            templateUrl: 'app/educational/concept-criteria/views/concept-criteria-page.html',
            controller: 'ConceptCriteriaCreateController',
            controllerAs: 'vm'
          }
        }
      });

  }

  angular
    .module('app.educational.concept-criteria')
    .config(routerConfig);

})();



(function () {
  'use strict';

  /** @ngInject */
  function ConceptCriteriaController($rootScope, $scope, $a4FloatButton, ConceptCriteriaService, ModalFactory, Common) {

    var vm = this;

    var ltn1 = $rootScope.$on('update.concept-criteria.list', function () {
      vm.paginate();
    });

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.form = {};

    vm.init = function () {
      vm.paginate();
      vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createConceptCriteria()'});
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterConceptCriteriaList = function (query) {
      ConceptCriteriaService.getAll({query: query})
        .then(function (response) {
          vm.grid.rows = response;
        })
    };

    /**
     * Manda para a criação de critérios
     */
    vm.createConceptCriteria = function () {
      ModalFactory.customClean(
        'app/educational/concept-criteria/views/create-edit.html',
        'ConceptCriteriaCreateController',
        'vm', false, {}
      );
    };

    /**
     * Abre modal para a edição do critério
     */
    vm.editConceptCriteria = function (criteria) {
      ModalFactory.customClean(
        'app/educational/concept-criteria/views/create-edit.html',
        'ConceptCriteriaEditController',
        'vm', false, criteria
      ).then(function () {
        vm.show_loader = false;
      });
    };

    /**
     * Paginação dos critérios existentes
     */
    vm.paginate = function (page, limit) {
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = ConceptCriteriaService.getAll({limit: limit, page: page})
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
        });
    };


    /**
     * Executa chamado a api, para realizar a exclusão de um critério de conceito
     * @param index - Identificador do critério
     */
    vm.delete = function (index) {
      ModalFactory.confirm(null,
        'Exclusão de Critério',
        'Deseja realmente excluir este critério de conceito?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          ConceptCriteriaService.deleteCriteria(index)
            .then(function () {
              Common.Toast.success('Critério de conceito excluído com sucesso!');
              vm.paginate();
            }).catch(function (response) {
            if (response.data.message === 'CRITERIA_ASSOCIATED_TO_GRADE_RULE') {
              Common.Toast.warning('Não é possível excluir, conceito associado a um critério de avaliação.');
            } else {
              Common.Toast.error('Erro ao excluir o critério.');
            }
          })
        })

    };
    $scope.$on('$destroy', function () {
      [ltn1].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.concept-criteria')
    .controller('ConceptCriteriaController', ConceptCriteriaController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ConceptCriteriaEditController($rootScope, $scope, ConceptCriteriaService, ModalExtra, Common) {

    var vm = this;
    vm.show_loader = false;
    vm.form = {
      grade_code_rule: {},
      grade_code_rule_item: {items: []},
      mode_edit: true
    };

    /** Evento para adicionar conceitos a lista*/
    var ltn1 = $rootScope.$on('add_item', function () {
      vm.form.grade_code_rule_item.items.push({name: '', limit: 0, hot_key: ''});
    });

    /** Remoção de regra de conceito */
    var ltn2 = $rootScope.$on('remove_item', function (ev, item) {
      var index = vm.form.grade_code_rule_item.items.indexOf(item);
      vm.form.grade_code_rule_item.items.splice(index, 1);
    });

    /** Inicia o controlador */
    vm.init = function () {
      if (angular.isDefined(ModalExtra.id)) {
        vm.show_loader = true;
        vm.getById(ModalExtra.id);
      }
    };

    /**
     * Retorna um determinado critério de conceito
     * @param id - Identificador do critério
     */
    vm.getById = function (id) {
      ConceptCriteriaService.get(id)
        .then(function (response) {
          vm.form.grade_code_rule = response.rule;
          vm.form.grade_code_rule_item.items = response.items;
          vm.show_loader = false;
        })
    };

    /**
     * Executa fechamento do dialog
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /**
     * Executa o chamado para api, para realizar a atualização do critério
     * @param criteria
     * @param form
     */
    vm.saveCriteria = function (criteria, form) {
      if (form.$valid) {
        var grade_code_rule = {};
        /** Seta os items para os objetos em questão */
        grade_code_rule.grade_code_rule_item = criteria.items;
        grade_code_rule.grade_code_rule = {
          id: criteria.id,
          name: criteria.name
        };
        ConceptCriteriaService.updateGradeCode(grade_code_rule.grade_code_rule.id, grade_code_rule)
          .then(function () {
            vm.close();
            Common.Toast.success('Critério de conceito atualizado com sucesso');
            $rootScope.$broadcast('update.concept-criteria.list');
          })
      }
    };

    $scope.$on('$destroy', function () {
      [ltn1, ltn2].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.concept-criteria')
    .controller('ConceptCriteriaEditController', ConceptCriteriaEditController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ConceptCriteriaCreateController($rootScope, $scope, ConceptCriteriaService, ModalFactory, Common) {

    var vm = this;
    vm.form = {
      grade_code_rule: {},
      grade_code_rule_item: {items: [{name: '', limit: 0, hot_key: ''}]},
      mode_edit: true
    };

    /** Evento para adicionar novo conceito a lista */
    var ltn1 = $rootScope.$on('add_item', function () {
      vm.form.grade_code_rule_item.items.push({name: '', limit: 0, hot_key: ''});
    });

    /** Remoção de regra de conceito */
    var ltn2 = $rootScope.$on('remove_item', function (ev, item) {
      vm.form.grade_code_rule_item.items.splice(item, 1);
    });

    vm.init = function () {
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterConceptCriteriaList = function (query) {
      ConceptCriteriaService.getAll({query: query})
        .then(function (response) {
          vm.grid.rows = response;
        })
    };


    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /**
     * Executa o chamado para api, para realizar a criação do critério
     * @param criteria
     * @param form
     */
    vm.saveCriteria = function (criteria, form) {
      if (form.$valid) {
        var grade_code_rule = {};
        /** Seta os items para os objetos em questão */
        grade_code_rule.grade_code_rule_item = criteria.items;
        grade_code_rule.grade_code_rule = {
          name: criteria.name
        };
        ConceptCriteriaService.createGradeCode(grade_code_rule)
          .then(function () {
            vm.close();
            Common.Toast.success('Critério de conceito criado com sucesso');
            $rootScope.$broadcast('update.concept-criteria.list');
          })
      }
    };


    $scope.$on('$destroy', function () {
      [ltn1, ltn2].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.concept-criteria')
    .controller('ConceptCriteriaCreateController', ConceptCriteriaCreateController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function CollaboratorsService(Restangular, moment) {

    /**
     * Retorna todos os colaboradores
     * @returns array
     */
    var getAll = function (obj) {
      return Restangular.one('collaborators').get(obj);
    };

    /**
     * Retorna o colaborador pelo id
     * @returns array
     */
    var getById = function (id) {
      return Restangular.one('collaborators', id).get();
    };


    var getPendentGradesByTeacher = function (obj) {
      return Restangular.one('collaborators').one('getpendentgradesbyteacher').get(obj);
    };

    var getDocuments = function (obj) {
      return Restangular.one('collaborators').one('getdocuments').get(obj);
    };

    /**
     * Retorna o colaborador pelo id
     * @returns array
     */
    var destroy = function (id) {
      return Restangular.one('collaborators', id).remove();
    };

    /**
     * Cria um novo colaborador
     */
    var createCollaborator = function (obj) {
      return Restangular.all('collaborators').post(obj);
    };

    /**
     * Atualiza um colaborador
     */
    var updateCollaborator = function (obj) {
      return Restangular.one('collaborators', obj.id).customPUT(obj);
    };

    /**
     * Remove um colaborador
     */
    var deleteCollaborator = function (id) {
      return Restangular.one('collaborators', id).remove();
    };

    /**
     * Desativa um colaborador
     */
    var deactivateCollaborator = function (id) {
      return Restangular.one('collaborators').all('deactivatecollaborator').post({id: id});
    };

    var verifyNewCollaborator = function (obj) {
      return Restangular.one('collaborators').all('verifynewcollaborator').post(obj);
    };

    var uploadDocuments = function (obj) {
      return Restangular.one('collaborators').all('uploaddocuments').post(obj);
    };

    var deleteDocumentFile = function (obj) {
      return Restangular.one('collaborators').all('deletedocumentfile').post(obj);
    };

    /**
     * Retorna as informações necessárias para o formulário.
     */
    var getInfos = function () {
      return Restangular.one('/collaborators/forminfo').get();
    };

    /**
     * Retorna as informações necessárias para o formulário.
     */
    var getListIdIssuer = function () {
      return [
        {id: 'SSP', name: 'Secretaria de Segurança Pública'},
        {id: 'PM', name: 'Polícia Militar'},
        {id: 'PC', name: 'Policia Civil'},
        {id: 'CNT', name: 'Carteira Nacional de Habilitação'},
        {id: 'DIC', name: 'Diretoria de Identificação Civil'},
        {id: 'CTPS', name: 'Carteira de Trabaho e Previdência Social'},
        {id: 'FGTS', name: 'Fundo de Garantia do Tempo de Serviço'},
        {id: 'IFP', name: 'Instituto Félix Pacheco'},
        {id: 'IPF', name: 'Instituto Pereira Faustino'},
        {id: 'IML', name: 'Instituto Médico:Legal'},
        {id: 'MTE', name: 'Ministério do Trabalho e Emprego'},
        {id: 'MMA', name: 'Ministério da Marinha'},
        {id: 'MAE', name: 'Ministério da Aeronáutica'},
        {id: 'MEX', name: 'Ministério do Exército'},
        {id: 'POF', name: 'Polícia Federal'},
        {id: 'POM', name: 'Polícia Militar'},
        {id: 'SES', name: 'Carteira de Estrangeiro'},
        {id: 'SJS', name: 'Secretaria da Justiça e Segurança'},
        {id: 'SJTS', name: 'Secretaria da Justiça do Trabalho e Segurança'},
        {id: 'ZZZ', name: 'Outros (inclusive exterior)'}
      ];
    };

    var getLessons = function (obj) {
      return Restangular.one('collaborators').one('getlessons').get(obj);
    };

    var getCollaboratorOccurrences = function (obj) {
      return Restangular.one('collaborators').one('occurrences').get(obj);
    };

    var getOccurrenceTypes = function (obj) {
      return Restangular.one('collaborators').one('occurrencetypes').get(obj);
    }

    var decryptOccurrence = function (id) {
      return Restangular.one('collaborators').one('occurrence', id).one('decrypt').get();
    }

    var deleteCollaboratorOccurrence = function (obj) {
      return Restangular.one('collaborators').all('deleteoccurrence').post(obj);
    }

    return {
      getListIdIssuer: getListIdIssuer,
      getAll: getAll,
      getPendentGradesByTeacher: getPendentGradesByTeacher,
      destroy: destroy,
      getInfos: getInfos,
      createCollaborator: createCollaborator,
      getById: getById,
      updateCollaborator: updateCollaborator,
      deleteCollaborator: deleteCollaborator,
      getLessons: getLessons,
      verifyNewCollaborator: verifyNewCollaborator,
      deactivateCollaborator: deactivateCollaborator,
      getDocuments: getDocuments,
      uploadDocuments: uploadDocuments,
      deleteDocumentFile: deleteDocumentFile,
      getCollaboratorOccurrences: getCollaboratorOccurrences,
      getOccurrenceTypes: getOccurrenceTypes,
      decryptOccurrence: decryptOccurrence,
      deleteCollaboratorOccurrence: deleteCollaboratorOccurrence
    };

  }

  angular
    .module('app.educational.collaborators')
    .factory('CollaboratorsService', CollaboratorsService)

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.collaborators', {
        public: false,
        url: '/collaborators',
        templateUrl: 'app/educational/collaborators/views/collaborators.html',
        abstract: true
      })
      .state('private.educational.collaborators.list', {
        url: '/list',
        public: false,
        views: {
          'collaborators': {
            templateUrl: 'app/educational/collaborators/views/list.html',
            controller: 'CollaboratorsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.collaborators.edit', {
        url: '/:id/view',
        public: false,
        views: {
          'collaborators': {
            templateUrl: 'app/educational/collaborators/views/collaborators-page.html',
            controller: 'CollaboratorsEditController',
            controllerAs: 'vm'
          },
          'documents@private.educational.collaborators.edit': {
            templateUrl: 'app/educational/collaborators/documents/views/documents.html',
            controller: 'DocumentsCollaboratorsController',
            controllerAs: 'vm'
          },
          'timetable@private.educational.collaborators.edit': {
            templateUrl: 'app/educational/collaborators/timetable/views/timetable.html',
            controller: 'TimetableCollaboratorsController',
            controllerAs: 'vm'
          },
          'pendencies@private.educational.collaborators.edit': {
            templateUrl: 'app/educational/collaborators/pendencies/views/pendencies.html',
            controller: 'PendenciesCollaboratorsController',
            controllerAs: 'vm'
          },
          'classes@private.educational.collaborators.edit': {
            templateUrl: 'app/educational/collaborators/classes/views/classes.html',
            controller: 'ClassesCollaboratorsController',
            controllerAs: 'vm'
          },
          'occurrences@private.educational.collaborators.edit': {
            templateUrl: 'app/educational/collaborators/occurrences/views/occurrences.html',
            controller: 'OccurrencesCollaboratorsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.collaborators.create', {
        url: '/create',
        params: {name: null},
        public: false,
        views: {
          'collaborators': {
            templateUrl: 'app/educational/collaborators/views/collaborators-page.html',
            controller: 'CollaboratorsCreateController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.collaborators')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run($rootScope, msNavigationService, PoliciesService, CONFIG) {
    var role = 'colab_menu';
    var role2 = 'colab';
    var path = 'secretary.collaborators';

    $rootScope.$on(CONFIG.events.side_menu.update, function () {

      if (PoliciesService.checkPolicyFromMenu(role)) {

        msNavigationService.saveItem(path, {
          title: 'Professores e Colaboradores',
          icon: 'icon-account-multiple',
          auth: role,
          state: 'private.educational.collaborators.list',
          weight: 4,
          hidden: function () {
            return !PoliciesService.checkPolicyAndProfile(role, path);
          }
        });

      } else if (PoliciesService.checkPolicyFromMenu(role2)) {

        msNavigationService.saveItem(path, {
          title: 'Agenda',
          icon: 'icon-calendar',
          auth: role2,
          state: 'private.educational.collaborators.edit',
          weight: 4,
          hidden: function () {
            return !PoliciesService.checkPolicyAndProfile(role2, path);
          }
        });

      }
    });

    $rootScope.$broadcast(CONFIG.events.side_menu.update);
  }

  angular
    .module('app.educational.collaborators')
    .run(run);

})();



(function () {
  'use strict';

  function CollaboratorsEditController($scope, $state, $rootScope, $timeout, $a4FloatButton, CollaboratorsService,
                                       Common, ModalFactory, PersonService, LocalStorage, PoliciesService, Utils) {

    var vm = this;
    var LocalStorageKEY = 'collaborators_current_tab';
    vm.search_text = '';
    vm.show_tabs = false;
    vm.selected_tab = LocalStorage.get(LocalStorageKEY);
    vm.person_id = $state.params.id;
    vm.searchTextProfession = null;
    vm.form = {
      mode_edit: false,
      person: {},
      person_employee: {},
      person_teacher: {}
    };
    vm.list = {
      person: {},
      person_employee: {},
      person_teacher: {}
    };

    /**
     * Evento de inicialização da tela
     * @type {*}
     */
    var ltn1 = $rootScope.$on('a4-form-dic-data.form.loaded', function () {
      if (vm.checkIdentifier()) {
        vm.teacherId = 'is_teacher';
      } else {
        vm.getById($state.params.id);
        vm.getFormInfos();
      }
    });

    vm.init = function () {
      vm.teacherId = 'is_teacher';
    };

    /**
     * Retorna as aulas do professor
     */
    vm.getLessons = function (id, start, end) {
      start = angular.isDefined(start) ? start : moment().startOf('week');
      end = angular.isDefined(end) ? end : moment().endOf('week');

      return CollaboratorsService.getLessons({id: id, start: start, end: end});
    };

    /**
     * Resgata o objeto referente ao colaborador
     * @param person_id - identificador do colaborador
     */
    vm.getById = function (person_id) {
      CollaboratorsService.getById(person_id)
        .then(function (response) {
          vm.form.person = Utils.mergeObjects(response.person, response.person_employee, response.person_teacher);
          vm.form.person_employee = response.person_employee;
          vm.form.person_teacher = response.person_teacher;
          if (vm.form.person.address_state !== null) {
            vm.changeAddressState(vm.form.person.address_state);
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel recuperar os dados do colaborador.');
        });
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Verifica se o usuário logado é um professor
     * @returns {boolean}
     */
    vm.checkIdentifier = function () {
      return PoliciesService.isTeacher();
    };


    /**
     * Executa a chamada para a API, para a deleção de um determinado colaborador
     * @param index - identificador do colaborador, para deleção
     */
    vm.deleteCollaborator = function (index) {
      ModalFactory.confirm(null,
        'Deseja remover este colaborador?',
        'Esta operação não pode ser desfeita.',
        'Confirmar', 'Cancelar', 'educational')
        .then(function (response) {
          if (response) {
            CollaboratorsService.destroy(index.id)
              .then(function () {
                Common.Toast.success('Colaborador removido com sucesso.');
                $rootScope.$on('collaborators.list.update');
                $state.go('private.educational.collaborators.list');
              })
              .catch(function (fail) {
                if (angular.isObject(fail.data)) {
                  angular.forEach(fail.data, function (value) {
                    switch (value[0]) {
                      case 'PERSON_COMPANY_EXCLUSION_ERROR':
                        Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                        break;
                      case 'PERSON_EMPLOYEE_EXCLUSION_ERROR':
                        Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                        break;
                      case 'PERSON_HAS_INFOS_EXCLUSION_PROHIBITED':
                        Common.Toast.warning('Existem informações associadas a este colaborador, remoção não permitida');
                        break;
                    }
                  });
                }
              })
          }
        });
    };


    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      CollaboratorsService.getInfos()
        .then(function (response) {
          vm.list.person = response.person;
          vm.list.person.id_issuer = CollaboratorsService.getListIdIssuer();
          vm.list.person_employee = response.person_employee;
          vm.list.person_teacher = response.person_employee;
          if (vm.form.person.address_state !== null) {
            vm.changeAddressState(vm.form.person.address_state);
          }
          $rootScope.show_loader = false;
        })
    };

    /**
     * Habilita e desabilita a edição do colaborador
     */
    vm.ableEdit = function () {
      vm.form.mode_edit = !vm.form.mode_edit;
      if (!vm.form.mode_edit) {
        vm.getById($state.params.id);
      }
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param item - novo item selecionado
     */
    vm.changeCollaborator = function (item) {
      if (angular.isDefined(item)) {
        $state.go('private.educational.collaborators.edit', {id: item.id}, {reload: true});
      }
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     */
    vm.changeAddressState = function (address_state_id) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
        })
    };

    /** Formata corretamente para o banco as datas que usam máscaras */
    vm.formatCorretDate = function (date) {
      if (date != null && angular.isDefined(date)) {
        return date.split("/").reverse().join("-");
      }
    };

    /**
     * Submissão para atualização de colaborador
     */
    vm.submit = function (form, item) {
      if (!form.$invalid) {
        /** Realiza a copia dos dados */
        var new_item = angular.copy(item);
        // if ((angular.isUndefined(vm.form.person.person_profession_id) || vm.form.person.person_profession_id === null)
        //   && vm.searchTextProfession !== null) {
        //   new_item.new_profession_name = vm.searchTextProfession;
        // }
        // if (vm.form.person.selected_profession !== null) {
        //   new_item.new_profession_name = vm.form.person.selected_profession;
        // }
        CollaboratorsService.updateCollaborator(new_item)
          .then(function () {
            Common.Toast.success('Colaborador atualizado com sucesso');
            $state.go($state.current.name, {id: item.id}, {reload: true});
          })
          .catch(function (fail) {
            if (angular.isDefined(fail.data.errors)) {
              if (angular.isDefined(fail.data.errors.national_id_number)) {
                Common.Toast.warning('Este CPF já é utilizado por outra pessoa.');
              }
            } else {
              switch (fail.data.message) {
                case 'NAME_IS_REQUIRED':
                  Common.Toast.warning('Campo nome é obrigatório.');
                  break;
                case 'TEACHER_IS_IN_TIMETABLE':
                  Common.Toast.warning('Professor associado a uma grade não pode deixar de ser um professor.');
                  break;
                case 'ALREADY_EXISTS_PERSON_WITH_THIS_NAME':
                  Common.Toast.warning('Já existe uma pessoa com este nome.');
                  break;
                case 'ADDRESS_CITY_IS_REQUIRED':
                  Common.Toast.warning('Por favor selecione uma Cidade.');
                  break;
                case 'ADDRESS_STATE_IS_REQUIRED':
                  Common.Toast.warning('Por favor selecione um Estado.');
                  break;
                case 'NATIONAL_ID_NUMBER_IS_REQUIRED':
                  Common.Toast.warning('Por favor digite o CPF do colaborador.');
                  break;
                case 'NATIONAL_ID_NUMBER_ALREADY_BEEN_USED':
                  Common.Toast.warning('Este CPF já foi utilizado por outro colaborador.');
                  break;
                case 'EMAIL_IS_REQUIRED':
                  Common.Toast.warning('Campo E-mail é obrigatório.');
                  break;
                case 'ID_ISSUER_IS_REQUIRED':
                  Common.Toast.warning('Selecione o Orgão Expedidor do RG.');
                  break;
                case 'ID_NUMBER_IS_REQUIRED':
                  Common.Toast.warning('Digite sua identidade.');
                  break;
                case 'PERSON_SEX_ID_IS_REQUIRED':
                  Common.Toast.warning('Defina o sexo por favor.');
                  break;
                case 'The given data was invalid.':
                  Common.Toast.warning('Há dados inválidos no formulário.');
                  break;
                default:
                  Common.Toast.warning(fail.data.message);
              }
              $rootScope.show_loader = false;
            }
          });
      } else {
        Common.Toast.error('Informação inválida no formulário');
      }
    };


    /**
     * Escuta da tab corrente, a cada troca de tab em colaboradores, esta escuta salva a corrente no localstorage;
     * @type {*}
     */
    var ltn = $scope.$watch(function () {
        return vm.selected_tab;
      },
      function (newer, older) {
        if (parseInt(newer) !== parseInt(older))
          LocalStorage.add(LocalStorageKEY, newer);
      });

    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    var ltn2 = $rootScope.$on('address_postal_code.blur', function (ev, CEP) {
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          vm.form.person.address_state = address.uf;
          vm.form.person.address_city = address.localidade;
          vm.form.person.address_street = address.logradouro;
          vm.form.person.address_district = address.bairro;
        })
    });

    /**
     * Esculta a troca do campo de Estado no formulário de criação de colaborador
     * @type {*}
     */
    var ltn3 = $rootScope.$on('person_address_state_change', function (ev, address_state_id) {
      vm.form.person.address_city = null;
      vm.changeAddressState(address_state_id);
    });


    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn, ltn1, ltn2, ltn3].forEach(function (fn) {
        fn();
      })
    });
    vm.init();
  }

  angular
    .module('app.educational.collaborators')
    .controller('CollaboratorsEditController', CollaboratorsEditController);

})();

(function () {
  'use strict';

  function CollaboratorsCreateController($scope, $state, $stateParams, $rootScope, CollaboratorsService, Common, PoliciesService, PersonService) {

    var vm = this;
    vm.form = {
      mode_edit: true,
      person: {
        is_inactive: false
      }
    };
    vm.list = {
      person: {},
      person_employee: {},
      person_teacher: {}
    };
    vm.searchTextProfession = null;

    vm.init = function () {
      if ($stateParams.name !== null) {
        vm.form.person.name = $stateParams.name;
      }
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param item - novo item selecionado
     */
    vm.changeCollaborator = function (item) {
      if (angular.isDefined(item)) {
        $state.go('private.educational.collaborators.edit', {id: item.id}, {reload: true});
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     */
    vm.changeAddressState = function (address_state_id) {
      PersonService.getCities(address_state_id)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
        })
    };

    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      CollaboratorsService.getInfos()
        .then(function (response) {
          vm.list.person = response.person;
          vm.list.person.id_issuer = CollaboratorsService.getListIdIssuer();
          vm.list.person_employee = response.person_employee;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Submissão de colaborador
     */
    vm.submit = function (form, item) {
      if (!form.$invalid) {
        if (angular.isUndefined(vm.form.person.person_profession_id) && vm.searchTextProfession !== null) {
          item.new_profession_name = vm.searchTextProfession;
        }
        // if (vm.form.person.selected_profession !== null) {
        //   item.new_profession_name = vm.form.person.selected_profession;
        // }
        CollaboratorsService.createCollaborator(item)
          .then(function (response) {
            Common.Toast.success('Colaborador criado com sucesso');
            $state.go('private.educational.collaborators.edit', {id: response.id});
            vm.form.mode_edit = false;
          })
          .catch(function (fail) {
            if (angular.isObject(fail.data)) {
              angular.forEach(fail.data, function (value) {
                switch (value[0]) {
                  case 'NAME_IS_REQUIRED':
                    Common.Toast.warning('Campo nome é obrigatório.');
                    break;
                  case 'ALREADY_EXISTS_PERSON_WITH_THIS_NAME':
                    Common.Toast.warning('Já existe uma pessoa com este nome.');
                    break;
                  case 'ADDRESS_CITY_IS_REQUIRED':
                    Common.Toast.warning('Por favor selecione uma Cidade.');
                    break;
                  case 'ADDRESS_STATE_IS_REQUIRED':
                    Common.Toast.warning('Por favor selecione um Estado.');
                    break;
                  case 'NATIONAL_ID_NUMBER_IS_REQUIRED':
                    Common.Toast.warning('Por favor digite o CPF do colaborador.');
                    break;
                  case 'NATIONAL_ID_NUMBER_ALREADY_BEEN_USED':
                    Common.Toast.warning('Este CPF já foi utilizado por outro colaborador.');
                    break;
                  case 'EMAIL_IS_REQUIRED':
                    Common.Toast.warning('Campo E-mail é obrigatório.');
                    break;
                  case 'ID_ISSUER_IS_REQUIRED':
                    Common.Toast.warning('Selecione o Orgão Expedidor do RG.');
                    break;
                  case 'ID_NUMBER_IS_REQUIRED':
                    Common.Toast.warning('Digite sua identidade.');
                    break;
                  case 'PERSON_SEX_ID_IS_REQUIRED':
                    Common.Toast.warning('Defina o sexo por favor.');
                    break;
                }
              });
              if (fail.data.message !== null) {
                Common.Toast.error(fail.data.message);
              } else {
                Common.Toast.error('Erro ao criar responsável');
              }
            }
          })
      }
    };


    /**
     * Esculta a troca do campo de Estado no formulário de criação de colaborador
     * @type {*}
     */
    var ltn = $rootScope.$on('person_address_state_change', function (ev, address_state_id) {
      vm.form.person.address_city = null;
      vm.changeAddressState(address_state_id);
    });

    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    var ltn2 = $rootScope.$on('address_postal_code.blur', function (ev, CEP) {
      if (angular.isDefined(CEP) && CEP.length) {
        PersonService.getAddressByCep(CEP)
          .then(function (address) {
            vm.form.person.address_state = address.uf;
            // vm.form.person.address_city = address.localidade;
            vm.form.person.address_street = address.logradouro;
            vm.form.person.address_district = address.bairro;
            vm.changeAddressState(vm.form.person.address_state, address.localidade);

          })
      }
    });

    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn, ltn2].forEach(function (fn) {
        fn();
      })
    });

    vm.init()


  }

  angular
    .module('app.educational.collaborators')
    .controller('CollaboratorsCreateController', CollaboratorsCreateController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function CollaboratorsController($scope, $state, $rootScope, $a4FloatButton, CollaboratorsService, Common, ModalFactory, PoliciesService) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.form = {};

    vm.person = {name: ''};
    vm.is_inactive = false;

    var ltn = $rootScope.$on('collaborators.list.update', function () {
      vm.paginate();
    });

    /**
     * Evento de inicialização da tela
     * @type {*}
     */
    var ltn1 = $rootScope.$on('a4-grid-dic-data.loaded', function () {
      vm.paginate();
    });

    vm.init = function () {
      $rootScope.show_loader = true;
      if (!vm.checkPolicies('colab_alt')) {
        $a4FloatButton({scope: $scope, onClick: 'vm.createCollaborator()'});
      }
      $rootScope.show_loader = false;
    };

    /**
     * Ações do grid
     * @param item
     * @param action
     */
    vm.makeAction = function (item, action) {
      switch (action) {
        case 'deactivate':
          vm.deactivateCollaborator(item);
          break;
        case 'activate':
          vm.activateCollaborator(item);
          break;
      }
    };

    vm.deactivateCollaborator = function (item) {
      ModalFactory.confirm(null,
        'Confirmação de desativação',
        'Deseja desativar o colaborador ' + item.name + '?',
        'Confirmar', 'Voltar', 'educational', vm.submitDeactivate, item)
        .then(function () {
          Common.Toast.success('Colaborador desativado com sucesso.');
          vm.paginate();
        });
    };

    vm.activateCollaborator = function (item) {
      ModalFactory.confirm(null,
        'Confirmação de ativação',
        'Deseja ativar o colaborador ' + item.name + '?',
        'Confirmar', 'Voltar', 'educational', vm.submitDeactivate, item)
        .then(function () {
          Common.Toast.success('Colaborador ativado com sucesso.');
          vm.paginate();
        });
    };

    vm.submitDeactivate = function (item) {
      return CollaboratorsService.deactivateCollaborator(item.id);
    };

    /**
     * Executa a chamada para a API, para a deleção de um determinado colaborador
     * @param index - identificador do colaborador, para deleção
     */
    vm.deleteCollaborator = function (index) {
      ModalFactory.confirm(null,
        'Deseja remover este colaborador?',
        'Esta operação não pode ser desfeita.',
        'Remover Colaborador', 'Cancelar', 'educational')
        .then(function (response) {
          if (response) {
            CollaboratorsService.destroy(index)
              .then(function () {
                Common.Toast.success('Colaborador removido com sucesso.');
                vm.paginate();
              })
              .catch(function (fail) {
                if (angular.isObject(fail.data)) {
                  angular.forEach(fail.data, function (value) {
                    switch (value[0]) {
                      case 'PERSON_COMPANY_EXCLUSION_ERROR':
                        Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                        break;
                      case 'PERSON_EMPLOYEE_EXCLUSION_ERROR':
                        Common.Toast.warning('Ocorreu um erro nos nossos servidores, tente mais tarde');
                        break;
                      case 'PERSON_HAS_INFOS_EXCLUSION_PROHIBITED':
                        Common.Toast.warning('Existem informações associadas a este colaborador, remoção não permitida');
                        break;
                    }
                  });
                }
              })
          }
        });
    };

    /**
     * Retorna todos os colaboradores disponíveis
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     */
    vm.paginate = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 20;
      page = angular.isDefined(page) ? page : 1;
      var only_inactives = vm.is_inactive;

      vm.grid.promise = CollaboratorsService.getAll({
        limit: limit,
        page: page,
        only_inactives: only_inactives,
      })
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [20, 40, 50, {
              label: 'Todos',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
          $rootScope.show_loader = false;
        });
    };

    /**
     * Chamada do serviço de retorna todos os grupos de curso da API
     */
    vm.getAll = function () {
      CollaboratorsService.getAll()
        .then(function (response) {
          vm.grid.rows = response.plain();
        });
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterCollaboratorsList = function (query) {
      CollaboratorsService.getAll({query: query, only_inactives: vm.is_inactive})
        .then(function (response) {
          vm.grid.rows = response.plain();
        })
    };

    /* ModalFactory.confirm(null,
       'Deseja remover o curso?',
       'O curso ' + item.name + ' será removida',
       'Confirmar', 'Cancelar', 'educational')*/

    /**
     * Abre o modal de pesquisa para criação de colaborador
     */
    vm.createCollaborator = function () {
      ModalFactory.customClean(
        'app/educational/collaborators/views/search-collaborator-modal.html',
        /** @ngInject */
        function ($document, $rootScope, Common, PersonService, ModalFactory) {
          var vm = this;
          vm.querySearch = function (query) {
            return PersonService.searchPerson({search: query, hasCompany: false, no_collaborators: true});
          };
          vm.submit = function (person) {
            if (person === null) {
              vm.closeModal();
              $state.go('private.educational.collaborators.create', {name: vm.searchText});
            } else {
              vm.closeModal();
              CollaboratorsService.verifyNewCollaborator({person_id: person.id, code: 0}).then(function (response) {
                if (response === 'USER_EMPLOYEE_ON_ANOTHER_COMPANY') {
                  ModalFactory.confirm(null, 'Confirmação', 'O usuário já é colaborador em outra empresa do sistema', 'Continuar', 'Cancelar', 'educational')
                    .then(function () {
                      $rootScope.show_loader = true;
                      CollaboratorsService.verifyNewCollaborator({person_id: person.id, code: 1}).then(function () {
                        $state.go('private.educational.collaborators.edit', {id: person.id});
                        $rootScope.show_loader = false;
                        Common.Toast.success('Novo colaborador criado com sucesso!');
                      })
                    })
                } else {
                  $rootScope.show_loader = true;
                  CollaboratorsService.verifyNewCollaborator({person_id: person.id, code: 1}).then(function () {
                    $state.go('private.educational.collaborators.edit', {id: person.id});
                    $rootScope.show_loader = false;
                    Common.Toast.success('Novo colaborador criado com sucesso!');
                  })
                }
              });
            }
          };
          vm.closeModal = function () {
            $rootScope.$broadcast('ModalFactory.close');
          }
        },
        'vm', false, {}
      );
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Edição de colaborador
     * @param item - item a ser editado
     * @param policy_access
     */
    vm.editCollaborator = function (item, policy_access) {
      $state.go('private.educational.collaborators.edit', {id: item.id});
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.collaborators')
    .controller('CollaboratorsController', CollaboratorsController)
})();
(function () {
  'use strict';

  function ClassesShowController($scope, $rootScope, $state, $timeout, $a4FloatButton, ClassesService, PoliciesService, Common, LocalStorage) {

    var vm = this;
    var LocalStorageKEY = 'classes_current_tab';
    vm.search_text = '';
    vm.show_tabs = false;
    vm.selected_tab = LocalStorage.get(LocalStorageKEY);
    vm.form = {
      mode_edit: false,
      classe: {}
    };
    vm.list = {
      classe: {}
    };


    /**
     * Escuta da tab corrente, a cada troca de tab em estudantes, esta escuta salva a corrente no localstorage;
     * @type {*}
     */
    var ltn = $scope.$watch(function () {
        return vm.selected_tab;
      },
      function (newer, older) {
        if (parseInt(newer) !== parseInt(older))
          LocalStorage.add(LocalStorageKEY, newer);
      });


    vm.init = function () {
      if(!vm.checkPolicies('classe')){

      }
      /**
       * Timeout posto por tempo de carregamento do form por ser muito grande
       * estar atrapalhando o carregamento dos dados
       */
      $timeout(function () {
        vm.getById($state.params);
      }, 1800)
    };

    /**
     * Resgata o objeto referente a classe
     * @param obj - com o identificador do grupo e disciplina
     */
    vm.getById = function (obj) {
      ClassesService.getById(obj)
        .then(function (response) {
          if (angular.isDefined(response) && response.length > 0) {
            vm.form.classes = response;
            vm.form.classe = vm.form.classes[0];
            vm.form.classe.name = vm.form.classes[0].alias + ' | '
              + vm.form.classes[0].group_name + ' | ' + vm.form.classes[0].subject_name;
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Não foi possivel recuperar os dados da classe.');
        });
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param item - novo item selecionado
     */
    vm.changeClass = function (item) {
      if (angular.isDefined(item)) {
        $state.go('private.educational.classes.show', {group_id: item.id, subject_id: item.subject_id}, {reload: true});
      }
    };

    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }

  angular
    .module('app.educational.classes')
    .controller('ClassesShowController', ClassesShowController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassesService(Restangular) {

    /**
     * Retorna todas as classes
     * @returns array
     */
    var all = function (obj) {
      return Restangular.one('classes').get(obj);
    };

    /**
     * Retorna a classe pelo id
     * @returns array
     */
    var getById = function (obj) {
      return Restangular.one('classes', obj.group_id).get(obj);
    };

    var getPendingGradesByClass = function (obj) {
      return Restangular.one('classes').one('getpendinggradesbyclass').get(obj);
    };

    /**
     * Retorna a classe pelo id
     * @returns array
     */
    var saveFrequencyOfStudents = function (obj) {
      return Restangular.one('classes').all('savefrequency').post(obj);
    };

    var getLessonsIdFromList = function (list) {
      var ids = [];
      list.forEach(function (value) {
        if (angular.isDefined(value.id) && value.id !== null) {
          var find = ids.find(function (item) {
            return item === value.id;
          });
          if (angular.isUndefined(find)) {
            ids.push(value.id);
          }
        }
      });
      return ids;
    };

    var getStudentsForClass = function (obj) {
      return Restangular.one('classes').one('getstudentsforclass').get(obj);
    };

    var getClassesForStudent = function (obj) {
      return Restangular.one('classes').one('getclassesforstudent').get(obj);
    };

    var getLessonsInSequence = function (obj) {
      return Restangular.one('classes').one('getlessonsinsequence').get(obj);
    };

    var getClassByTeacher = function (obj) {
      return Restangular.one('classes').one('getclassbyteacher').get(obj);
    };

    var getDataForYeldGraph = function (obj) {
      return Restangular.one('classes').one('getdataforyeldgraph').get(obj);
    };

    var getPendencies = function () {
      return Restangular.one('classes').one('getpendencies').get();
    };

    var changeTeacherOfClasses = function (obj) {
      return Restangular.one('classes').all('changeteacherofclasses').post(obj);
    };

    var getClassStorage = function () {

    };

    var setClassStorage = function (data) {

    };

    return {
      all: all,
      getById: getById,
      getLessonsIdFromList: getLessonsIdFromList,
      getPendingGradesByClass: getPendingGradesByClass,
      saveFrequencyOfStudents: saveFrequencyOfStudents,
      getStudentsForClass: getStudentsForClass,
      getLessonsInSequence: getLessonsInSequence,
      getClassByTeacher: getClassByTeacher,
      getDataForYeldGraph: getDataForYeldGraph,
      getClassesForStudent: getClassesForStudent,
      getPendencies: getPendencies,
      changeTeacherOfClasses: changeTeacherOfClasses
    };
  }

  angular
    .module('app.educational.classes')
    .factory('ClassesService', ClassesService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.classes', {
        public: false,
        url: '/classes',
        auth: 'classe',
        abstract: true,
        template: '<div ui-view="classes" id="page-material-table-classes"></div>'
      })
      .state('private.educational.classes.list', {
        url: '/list',
        public: false,
        parent: 'private.educational.classes',
        auth: 'classe',
        views: {
          'classes': {
            templateUrl: 'app/educational/classes/views/list.html',
            controller: 'ClassesController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.classes.show', {
        url: '/:group_id/:matrix_period/:subject_id/view',
        public: false,
        views: {
          'classes': {
            templateUrl: 'app/educational/classes/views/classes-page.html',
            controller: 'ClassesShowController',
            controllerAs: 'vm',
          },
          'classrooms@private.educational.classes.show': {
            templateUrl: 'app/educational/classes/classrooms/views/classrooms.html',
            controller: 'ClassroomsClassesController',
            controllerAs: 'vm',
          },
          'students@private.educational.classes.show': {
            templateUrl: 'app/educational/classes/students/views/students.html',
            controller: 'StudentsClassesController',
            controllerAs: 'vm'
          },
          'grades@private.educational.classes.show': {
            templateUrl: 'app/educational/classes/grades/views/grades.html',
            controller: 'GradesClassesController',
            controllerAs: 'vm'
          },
          'yield-graph@private.educational.classes.show': {
            templateUrl: 'app/educational/classes/yield-graph/views/yield-graph.html',
            controller: 'YieldGraphClassesController',
            controllerAs: 'vm'
          },
          'notes-release@private.educational.classes.show': {
            templateUrl: 'app/educational/classes/notes-release/views/notes-release.html',
            controller: 'NotesReleaseClassesController',
            controllerAs: 'vm'
          },
          'notes-pending@private.educational.classes.show': {
            templateUrl: 'app/educational/classes/notes-pending/views/notes-pending.html',
            controller: 'NotesPendingClassesController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.classes')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {

    var role = 'classe_menu';
    var path = 'config.classes';
    msNavigationService.saveItem(path, {
      title: 'Classes',
      icon: 'icon-book-multiple-variant',
      state: 'private.educational.classes.list',
      auth: role,
      weight: 5,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path);
      }
    });
  }

  angular
    .module('app.educational.classes')
    .run(run);

})();
(function () {
  'use strict';

  /** @ngInject */
  function Classes() {
    var vm = this;
    vm.courses = null;
    vm.groups = null;
    vm.subjects = null;
    vm.cards = null;
    vm.group_id = null;
    vm.course_id = null;
    vm.subject_id = null;

    vm.setCourses = function (courses) {
      vm.courses = courses;
    };

    vm.setGroups = function (groups) {
      vm.groups = groups;
    };

    vm.setSubjects = function (subjects) {
      vm.subjects = subjects;
    };

    vm.setGroupId = function (group_id) {
      vm.group_id = group_id;
    };

    vm.setCourseId = function (course_id) {
      vm.course_id = course_id;
    };

    vm.setSubjectId = function (subject_id) {
      vm.subject_id = subject_id;
    };

    vm.setCards = function (cards) {
      vm.cards = cards;
    };

    vm.getCourses = function () {
      return vm.courses;
    };

    vm.getGroups = function () {
      return vm.groups;
    };

    vm.getSubjects = function () {
      return vm.subjects;
    };

    vm.getGroupId = function () {
      return vm.group_id;
    };

    vm.getCourseId = function () {
      return vm.course_id;
    };

    vm.getSubjectId = function () {
      return vm.subject_id;
    };

    vm.getCards = function () {
      return vm.cards;
    };


    return vm;

  }

  angular
    .module('app.educational.classes')
    .factory('Classes', Classes)

})();
(function () {
    'use strict';

    /** @ngInject */
    function ClassesController($document, $window, $state, $mdMenu, $timeout, $rootScope, $scope, $filter,
                               ClassesService, Classes, CourseService, PoliciesService) {
      var vm = this;
      vm.subject_id = null;
      vm.group_id = null;
      vm.course_id = null;
      vm.is_detailed = false;
      vm.hasDataToLoad = true;
      vm.withoutClasses = false;

      /**
       * Listener do scroll infinito:
       * Primeiro, são definidas duas variáveis: a posição atual do scroll e a altura máxima.
       * Caso a posição do scroll chegue até a altura máxima e nenhum filtro esteja selecionado,
       * ele realiza o método do infiniteScroll
       */
      var ln = angular.element('#content').bind("scroll", function () {
        var currentPositionOfScroll = angular.element(this).scrollTop();
        var fullHeight = angular.element('#page-material-table').height();
        /** Verificação dos filtros, a desativação do primeiro desabilita os outros. */
        if (vm.course_id === null) {
          vm.group_id = null;
          vm.subject_id = null;
        }
        /**
         * Só realiza o infinite scroll caso não tenham filtros selecionados, e compara com mais exatidão o tamanho da tela
         * e a posição do scroll
         */
        if (parseInt(currentPositionOfScroll + angular.element(this).height()) >= parseInt(fullHeight)
          && (vm.course_id === null && vm.group_id === null && vm.subject_id === null)) {
          vm.paginateWithInfiniteScroll(vm.cards.current_page + 1);
        }
      });

      vm.init = function () {

        var cards = angular.copy(Classes.getCards());
        if (cards == null) {
          vm.paginate();
        } else {
          vm.cards = cards;
          vm.cardsData = cards.data;
          vm.courses = Classes.getCourses();
          vm.groups = Classes.getGroups();
          vm.subjects = Classes.getSubjects();
          vm.course_id = Classes.getCourseId();
          vm.group_id = Classes.getGroupId();
          vm.subject_id = Classes.getSubjectId();
          vm.filterBySubject(vm.subject_id);
        }
      };


      /**
       * Abre o menu do card
       * @param $mdMenu
       * @param ev
       */
      vm.open_menu = function ($mdMenu, ev) {
        vm.originatorEv = ev;
        $mdMenu.open(ev);
      };

      /**
       * Retorna todos as classes disponíveis
       * @param page - pagina corrente da paginação
       * @param limit - limite de registros por pagina
       * @param query - Busca de registros
       * @param course_id
       * @param group_id
       */
      vm.paginate = function (page, limit, query, course_id, group_id) {
        $rootScope.show_loader = true;
        limit = angular.isDefined(limit) ? limit : 50;
        page = angular.isDefined(page) ? page : 1;
        course_id = angular.isDefined(course_id) ? course_id : undefined;
        group_id = angular.isDefined(group_id) ? group_id : undefined;

        ClassesService.all({
          limit: limit, page: page, query: query, course_id: course_id, group_id: group_id
        })
          .then(function (response) {
            Classes.setCards(angular.copy(response.plain()));
            vm.cardsData = response.data;
            vm.cards = response.plain();
            vm.setSubjects();
            if (response.data.length === 0) {
              vm.hasDataToLoad = false;
              if (angular.isUndefined(course_id)){
                vm.withoutClasses = true;
              }
            }
            $timeout(function () {
              $rootScope.show_loader = false;
            }, 1000);
          });
      };

      /**
       * Paginação das classes sem filtros, utilizando o infinite scroll
       * As classes na tela são incrementadas conforme o scroll da tela chega ao final,
       * ao invés de substituídas(como é feito no método vm.paginate)
       * @param page
       * @param limit
       * @param query
       * @param course_id
       * @param group_id
       */
      vm.paginateWithInfiniteScroll = function (page, limit, query, course_id, group_id) {
        if (vm.hasDataToLoad || angular.isDefined(course_id) || angular.isDefined(group_id) || angular.isDefined(vm.subject_id)) {
          vm.hasDataToLoad = true;
          $rootScope.show_loader = true;
          limit = angular.isDefined(limit) ? limit : 50;
          page = angular.isDefined(page) ? page : 1;
          course_id = angular.isDefined(course_id) ? course_id : undefined;
          group_id = angular.isDefined(group_id) ? group_id : undefined;

          ClassesService.all({
            limit: limit, page: page, query: query, course_id: course_id, group_id: group_id
          })
            .then(function (response) {
              vm.cardsData = response.data;
              var paginateData = response.plain();
              var cardsData = vm.cards.data.concat(paginateData.data);
              vm.cards = paginateData;
              vm.cards.data = cardsData;
              Classes.setCards(angular.copy(vm.cards));
              vm.setSubjects();
              if (response.data.length === 0) {
                vm.hasDataToLoad = false;
              }
              $timeout(function () {
                $rootScope.show_loader = false;
              }, 1000);
            });
        }
      };

      /**
       * Ao abrir filtro de cursos buscará os cursos disponíveis
       * @return {*}
       */
      vm.loadCourses = function () {
        return Classes.getCourses() || CourseService.getAll({only_active: true})
          .then(function (courses) {
            vm.courses = courses;
            Classes.setCourses(vm.courses);
          });
      };

      /**
       * Filtra a lista por disciplinas
       */
      vm.filterBySubject = function (subject_id) {
        Classes.setSubjectId(subject_id);
        if (subject_id == null) {
          vm.cards.data = angular.copy(vm.cardsData);
        } else {
          vm.cards.data = $filter('filter')(angular.copy(vm.cardsData), {subject_id: subject_id}, true);
        }
      };

      /**
       * Define o filtro por turmas
       * @param course_id
       */
      vm.setGroups = function (course_id) {
        Classes.setCourseId(course_id);
        CourseService.getGroupsByCourse(course_id)
          .then(function (groups) {
            vm.group_id = null;
            vm.groups = groups.data;
            Classes.setGroups(vm.groups);
            if (groups.data.length === 1) {
              vm.group_id = groups.data[0].id;
              Classes.setGroupId(vm.group_id);
            }
            vm.setSubjects();
          });
      };


      /**
       * Define o filtro por disciplinas
       */
      vm.setSubjects = function () {
        vm.subjects = [];
        vm.cards.data.forEach(function (item) {
          var obj = {id: item.subject_id, name: item.subject_name};
          var is_push = true;

          vm.subjects.map(function (itemSubject) {
            if (itemSubject.id === obj.id) {
              is_push = false;
            }
          });

          if (is_push) {
            vm.subjects.push(obj);
          }

        });
        Classes.setSubjects(vm.subjects);
      };

      /**
       * Verifica Politicas de acesso
       * @param policy - Identificador da politica de acesso
       * @returns {boolean}
       */
      vm.checkPolicies = function (policy) {
        return !PoliciesService.checkPolicyFromMenu(policy);
      };

      /**
       * Exibição da classe
       * @param item - item a ser editado
       */
      vm.editClass = function (item) {
        $state.go('private.educational.classes.show', {
          group_id: item.id,
          subject_id: item.subject_id,
          matrix_period: item.matrix_period
        });
      };

      vm.init();

      /**
       * Ao sair da tela, destrói o listener do scroll infinito.
       */
      $scope.$on('$destroy', function () {
        ln.unbind();
        ln.off();
      });
    }

    angular
      .module('app.educational.classes')
      .controller('ClassesController', ClassesController)
  }

)();
(function () {
  'use strict';

  /** @ngInject */
  function ClassReleaseService(Restangular) {

    var getAll = function (obj) {
      return Restangular.one('classes').get(obj);
    };

    var getByFilter = function (obj) {
      return Restangular.one('classes').all('getclassesbyfilter').post(obj);
    };

    var getClassesByStudent = function (obj) {
      return Restangular.one('classes').one('getclassesbystudent').get(obj);
    };

    var getLessonTypes = function () {
      return Restangular.one('lesson').one('gettypes').get();
    };

    var getListOfLocations = function () {
      return Restangular.one('lesson').one('getlocations').get();
    };

    var save = function (obj) {
      return Restangular.all('lesson').post(obj);
    };

    var undoLessonPerformed = function (obj) {
      return Restangular.one('lesson').all('undoperformed').post(obj);
    };

    var createLessonPlan = function (obj) {
      return Restangular.one('lesson').all('createplan').post(obj);
    };

    var cancelLesson = function (obj) {
      return Restangular.one('lesson').all('cancellesson').post(obj);
    };

    var updateLesson = function (obj) {
      return Restangular.one('lesson', obj.lesson_id).all('updatelesson').post(obj);

    };

    var getLessonArtifact = function (id) {
      return Restangular.one('lesson', id).one('getfiles').get();
    };

    var deleteLesson = function (id, obj) {
      return Restangular.one('lesson', id).all('removeplan').post(obj);
    };

    var deleteExtraLesson = function (obj) {
      return Restangular.one('lesson').all('deleteextralesson').post(obj);
    };

    var undoCancelLesson = function (obj) {
      return Restangular.one('lesson').all('undocancellesson').post(obj);
    };

    /**
     * Busca todas as aulas
     * @param obj
     */
    var classRooms = function (obj) {
      return Restangular.one('classes').one('getclassroom').get(obj);
    };

    /**
     * Busca todos os links e anexos das aulas
     * @param id
     */
    var getLessonsArtifacts = function (id) {
      return Restangular.one('lessonplanitem', id).one('getfiles').get();
    };

    /**
     * Busca todos os estudantes
     * @param obj
     */
    var getStudents = function (obj) {
      return Restangular.one('classes').one('getstudents').get(obj);
    };

    var saveLinks = function (obj) {
      return Restangular.one('classes').all('savelinks').post(obj);
    };

    var saveFiles = function (obj) {
      return Restangular.one('classes').all('savefiles').post(obj);
    };

    var createExtraLesson = function (obj) {
      return Restangular.one('lesson').all('createextra').post(obj);
    };

    var editExtraLesson = function (obj) {
      return Restangular.one('lesson').all('editextra').post(obj);
    };

    var getDateOfNextLesson = function (obj) {
      return Restangular.one('lesson').one('getdateofnextlesson').get(obj);
    };

    return {
      getAll: getAll,
      getByFilter: getByFilter,
      getClassesByStudent: getClassesByStudent,
      save: save,
      classRooms: classRooms,
      getDateOfNextLesson: getDateOfNextLesson,
      getLessonsArtifacts: getLessonsArtifacts,
      getStudents: getStudents,
      saveLinks: saveLinks,
      saveFiles: saveFiles,
      undoLessonPerformed: undoLessonPerformed,
      cancelLesson: cancelLesson,
      getLessonTypes: getLessonTypes,
      undoCancelLesson: undoCancelLesson,
      createLessonPlan: createLessonPlan,
      deleteLesson: deleteLesson,
      updateLesson: updateLesson,
      getLessonArtifact: getLessonArtifact,
      createExtraLesson: createExtraLesson,
      deleteExtraLesson: deleteExtraLesson,
      getListOfLocations: getListOfLocations,
      editExtraLesson: editExtraLesson
    };
  }

  angular
    .module('app.educational.classes')
    .factory('ClassReleaseService', ClassReleaseService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.class-release', {
        public: false,
        url: '/class-release',
        templateUrl: 'app/educational/class-release/views/class-release.html',
        abstract: true
      })
      .state('private.educational.class-release.accomplish', {
        public: false,
        url: '/{lesson_date}/{group_id}/{subject_id}/{matrix_period}/accomplish',
        views: {
          'class-release': {
            templateUrl: 'app/educational/class-release/views/class-release-page.html',
            controller: 'ClassReleaseAssistantController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.class-release.list', {
        url: '/list',
        public: false,
        params: {
          group_id: null,
          matrix_period: null,
          subject_id: null,
          lesson_date: null
        },
        views: {
          'class-release': {
            templateUrl: 'app/educational/class-release/views/list.html',
            controller: 'ClassReleaseController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.educational.class-release.edit', {
        url: '/:id/view',
        public: false,
        views: {
          'class-release': {
            templateUrl: 'app/educational/class-release/views/class-release-page.html',
            controller: 'ClassReleaseEditController',
            controllerAs: 'vm'
          }
        }
      });
  }

  angular
    .module('app.educational.class-release')
    .config(routerConfig);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    // var role = 'aula_menu';
    // var path = 'educational.class-release';
    // msNavigationService.saveItem(path, {
    //   title: 'Lançamento de aulas',
    //   icon: 'icon-pencil',
    //   auth: role,
    //   state: 'private.educational.class-release.list',
    //   weight: 7,
    //   hidden: function () {
    //     return !PoliciesService.checkPolicyAndProfile(role, path); // must be a boolean value
    //   },
    // });
  }

  angular
    .module('app.educational.class-release')
    .run(run);

})();
(function () {
	'use strict';

	function ClassReleaseController($scope, $rootScope, $state, $filter, $a4FloatButton, ClassReleaseService,
	                                ModalFactory, $stateParams, ClassesService, Common, PoliciesService, CONFIG) {
		var vm = this;

		/** Definição de variáveis */
		vm.floatButton = null;
		vm.allowNext = true;
		vm.buttonTitle = 'Próximo';
		vm.buttonIcon = 'savepy';
		vm.has_date = false;
		vm.openFrequency = false;
		vm.selectAllClass = false;
		vm.classSelected = [];
		vm.selectAllStatus = false;
		vm.statusSelected = [0];
		vm.releaseInEdition = null;
		vm.CONFIG = CONFIG;

		/** Grid padrão */
		vm.grid = {
			rows: [],
			info: {},
			promise: {},
			selected: [],
			selected_column: 'date_hour',
			title: {
				name: 'Aulas disponíveis',
				show: false
			}
		};

		/** Status das aulas */
		vm.lesson_status = [
			{id: 0, name: 'Pendente'},
			{id: 1, name: 'Realizada'}
		];

		/** Botão de status das aulas */
		vm.buttonStates = [
			{textButton: 'Pendente', background: '#9e9e9e', color: 'white', value: 0},
			{textButton: 'Realizada', background: '#7cb342', color: 'white', value: 1}
		];

		/** Botão de frequência dos alunos */
		vm.buttonStatesFrequency = [
			{textButton: 'Presente', background: '#7cb342', color: 'white', value: 1, height: '25px'},
			{textButton: 'Ausente', background: '#9e9e9e', color: 'white', value: 2, height: '25px'},
			{textButton: 'Atrasado', background: '#f57c00', color: 'white', value: 3, height: '25px'},
			{textButton: 'Saiu antes', background: '#00838f', color: 'white', value: 4, height: '25px'}
		];

		/** Formulário padrão */
		vm.form = {
			class: {},
			date: {
				initDate: null,
				endDate: null
			},
			status: 0,
			selected_period: 6 //período customizado
		};

		/** Eventos */

		/** Critérios para o botão de lançamento e frequência */
		var ltn = $rootScope.$watch(function () {
			return vm.selected_tab;
		}, function (newValue, oldValue) {

			/** Atualiza o grid se for para a aba de listagem */
			if (vm.selected_tab == 0) {
				vm.paginate();
				vm.grid.selected = [];
			}

			/** Cria o botão a partir do critério para
			 *  permissão de lançamento de frequência
			 *  ou somente a aula */
			if (angular.isDefined(vm.schoolrooms) &&
				vm.schoolrooms.length === 1 &&
				(vm.schoolrooms[0].lesson_status_id === 4 || vm.schoolrooms[0].lesson_status_id === 0)) {
				vm.buttonTitle = 'Concluir';
				vm.buttonIcon = 'save';
				vm.buttonFunction = 'vm.saveLessons(0)';
			} else {
				vm.buttonTitle = 'Próximo';
				vm.buttonIcon = 'skip_next';
				vm.buttonFunction = 'vm.submit()';
			}
			/** Critério para permitir lançamento de frequência */
			if (vm.floatButton !== null) {
				vm.floatButton.destroy();
			}
			/** Se estiver na aba de lançamento */
			if (vm.selected_tab === 1) {
				vm.floatButton = $a4FloatButton({
					scope: $scope, icon: vm.buttonIcon, label: vm.buttonTitle, onClick: vm.buttonFunction
				});
			}
			/** Se estiver na aba de frequência */
			if (vm.selected_tab === 2) {
				vm.floatButton = $a4FloatButton({
					scope: $scope, icon: 'save', label: 'Lançar aula(s)', onClick: 'vm.submitData()'
				});
			}
		});

		/** Verifica se há alteração na data para o filtro */
		var ltn1 = $rootScope.$watch(function () {
			return vm.form.date;
		}, function (newValue, oldValue) {
			if (newValue && oldValue && newValue !== oldValue) {
				vm.paginate();
				vm.grid.selected = [];
			}
		}, true);

		/** Verifica se há alteração no status para o filtro */
		var ltn2 = $rootScope.$watch(function () {
			return vm.statusSelected;
		}, function (newValue, oldValue) {
			if (newValue !== oldValue) {
				if (angular.isDefined(vm.form.date.initDate)) {
					vm.paginate();
					vm.grid.selected = [];
				}
			}
		}, true);

		/** Atualiza o grid padrão se for fechado o assistente */
		var ltn3 = $rootScope.$on('class.release.assistant.close', function () {
			vm.paginate();
		});

		/** Verifica se há alteração de classe para o filtro */
		var ltn4 = $rootScope.$watch(function () {
			return vm.classSelected;
		}, function (newValue, oldValue) {
			if (newValue && oldValue && newValue !== oldValue) {
				if (angular.isDefined(vm.form.date.initDate)) {
					vm.paginate();
					vm.grid.selected = [];
				}
			}
		}, true);

		/** Ouve a exclusão de artefatos */
		var ltn5 = $rootScope.$on('artefact.remove', function (ev, lessons) {
			/** Exibe o modal para adição de anexos */
			ModalFactory.customClean('app/educational/classes/classrooms/dialog/lesson-artefact-dialog.html',
				'LessonArtefactController',
				'vm', true, lessons
			);
		});

		/** Atualiza a quantidade de anexos */
		var ltn6 = $rootScope.$on('artefact.close', function (ev, lesson) {
			if (angular.isDefined(lesson)) {
				if (angular.isDefined(vm.schoolrooms)) {
					var index = vm.schoolrooms.indexOf(lesson);
					lesson.artifact_qtd = lesson.links.length + lesson.files.length;
					vm.schoolrooms[index] = lesson;
				}
				/** Se houver grid */
				if (angular.isDefined(vm.grid.rows)) {
					var index = vm.grid.rows.indexOf(lesson);
					lesson.artifact_qtd = lesson.links.length + lesson.files.length;
					vm.grid.rows[index] = lesson;
				}
			}
		});

		/** Função de inicio do controlador */
		vm.init = function () {
			if ($stateParams.group_id !== null && $stateParams.matrix_period !== null
				&& $stateParams.subject_id !== null && $stateParams.lesson_date !== null) {
				vm.getLessonsInSequence($stateParams);
				//TODO verificar uso dos parâmetros
				vm.form.class.group_id = $stateParams.group_id;
				vm.group_id = $stateParams.group_id;
				vm.form.class.subject_id = $stateParams.subject_id;
				vm.subject_id = $stateParams.subject_id;
				vm.form.class.matrix_period = $stateParams.matrix_period;
				vm.matrix_period = $stateParams.matrix_period;
			}
		};


		/**
		 * Retorna todos as classes disponíveis para este professor
		 */
		vm.getClasses = function () {
			ClassReleaseService.getAll({teacher_id: vm.teacherID})
				.then(function (response) {
					vm.classes = response.plain();
				})
		};

		/**
		 * Seleciona ou não todas as classes
		 */
		vm.selectAllClasses = function () {
			if (vm.selectAllClass) {
				vm.classSelected = [];
				vm.selectAllClass = false;
			} else {
				vm.classSelected = [];
				angular.forEach(vm.classes, function (event) {
					var fakeID = event.id + '|' + event.subject_id + '|' + event.matrix_period;
					vm.classSelected.push(fakeID)
				});
				vm.selectAllClass = true;
			}
		};

		/**
		 * Seleciona ou não todos os status
		 */
		vm.selectAllStatusPossible = function () {
			if (vm.selectAllStatus) {
				vm.statusSelected = [];
				vm.selectAllStatus = false;
			} else {
				vm.statusSelected = [];
				angular.forEach(vm.lesson_status, function (event) {
					vm.statusSelected.push(event.id)
				});
				vm.selectAllStatus = true;
			}
		};

		/**
		 * Recebe as aulas em sequência
		 * @param obj
		 */
		vm.getLessonsInSequence = function (obj) {
			ClassesService.getLessonsInSequence(obj)
				.then(function (response) {
					vm.schoolrooms = response.plain();
					vm.saveLessons(1);
					//vm.selected_tab = 1;
				});
		};


		/**
		 * Realiza a verificação do perfil selecionado
		 * @param profile
		 * @returns {boolean}
		 */
		vm.checkProfile = function (profile) {
			return PoliciesService.currentProfile() === profile;
		};

		/**
		 * Retorna todos as classes disponíveis
		 * @param page - pagina corrente da paginação
		 * @param limit - limite de registros por pagina
		 */
		vm.paginate = function (page, limit) {
			$rootScope.show_loader = true;
			limit = angular.isDefined(limit) ? limit : 50;
			page = angular.isDefined(page) ? page : 1;

			vm.grid.promise = ClassReleaseService.getByFilter({
				limit: limit,
				page: page,
				date: vm.form.date,
				id: vm.form.class.id,
				subject_id: vm.form.class.subject_id,
				matrix_period: vm.form.class.matrix_period,
				lesson_class: (vm.classSelected.length) ? vm.classSelected : null,
				lesson_status_id: (vm.statusSelected.length) ? vm.statusSelected : null,
				teacher_id: vm.teacherID
			})
				.then(function (response) {
					vm.grid.rows = vm.formatGrid(response.data);
					vm.grid.info = {
						limit_options: [50, 100, 150, {
							label: 'Todas',
							value: function () {
								return response.total;
							}
						}],
						limit: limit,
						page: page,
						total: response.total

					}
					$rootScope.show_loader = false;
				});
			vm.has_date = false;
		};

		/**
		 * Verifica Politicas de acesso
		 * @param policy - Identificador da politica de acesso
		 * @returns {boolean}
		 */
		vm.checkPolicies = function (policy) {
			return !PoliciesService.checkPolicyFromMenu(policy);
		};

		/**
		 * Faz o submit das informações da aula e da frequência dos alunos
		 */
		vm.submitData = function () {
			vm.saveLessons(0);
			vm.submitFrequency();
		};

		/**
		 * Submissão da frequência dos alunos
		 */
		vm.submitFrequency = function () {
			ClassesService.saveFrequencyOfStudents({students: vm.students, ids: vm.ids})
				.then(function () {
					Common.Toast.success('Frequência salva com sucesso');
					vm.selected_tab = 0;
					vm.paginate();
					vm.grid.selected = [];
				})
				.catch(function () {
					Common.Toast.error('Erro ao salvar frequência');
				})
		};

		/**
		 * Realiza a formatação necessária para a exibição do grid
		 * @param array
		 * @returns {*}
		 */
		vm.formatGrid = function (array) {
			/** Filtro para data e horários */
			angular.forEach(array, function (item) {

				/** Splita a initial e final time*/
				if (angular.isDefined(item.initial_time)) {
					item.initial_time = item.initial_time.substr(0, 5);
				}
				if (angular.isDefined(item.final_time)) {
					item.final_time = item.final_time.substr(0, 5);
				}


				/** Filtro para horário */
				item.time = $filter('date')(item.initial_time, "h:mma") + ' - '
					+ $filter('date')(item.final_time, "h:mma");

				/** Filtro para data */
				item.show_date = $filter('date')(item.date, "dd/MM/yyyy (EEE)");

				/** Definição de Data e Hora */
				item.date_hour = item.show_date + ' | ' + item.time;

				item.class = item.course_name + ' | ' + item.group_name + ' | ' + item.subject_name;

				item.lesson_status_name = (item.lesson_status_name === null) ? 'Pendente' : item.lesson_status_name;
			});

			return array;
		};

		/**
		 * Executa uma função desejada na lista de opções do grid
		 * @param lesson
		 * @param option
		 */
		vm.clickActions = function (lesson, option) {
			switch (option) {
				case 'open-attachments':
					lesson.can_edit = (vm.checkProfile(vm.CONFIG.profile.is_teacher));
					vm.openAttachments(lesson);
					break;
				default:
			}
		};

		/** Exibe o modal para adição de anexos */
		vm.openAttachments = function (lesson) {
			ModalFactory.customClean('app/educational/classes/classrooms/dialog/lesson-artefact-dialog.html',
				'LessonArtefactController',
				'vm', true, lesson
			);
		};

		/**
		 * Exibição da classe
		 * @param item - item a ser editado
		 */
		vm.editClass = function (item) {
			$state.go('private.educational.class-release.edit', {id: item.id});
		};

		/**
		 * Edita somente uma aula
		 */
		vm.editLesson = function (item) {
			item.lesson_status_id = (item.lesson_status_id === null) ? 0 : item.lesson_status_id;
			vm.releaseInEdition = ' -> ' + item.class;
			vm.group_id = item.group_id;
			vm.subject_id = item.subject_id;
			vm.matrix_period = item.matrix_period;
			vm.schoolrooms = [item];
			vm.selected_tab = 1;
			vm.saveLessons();
		};

		/**
		 * Salva as informações da aula
		 * @param tab - aba que deve ser selecionada após a requisição
		 */
		vm.saveLessons = function () {
			ClassReleaseService.save({lessons: vm.schoolrooms})
				.then(function (response) {
					vm.openFrequency = true;
					vm.ids = response.ids;
					vm.schoolrooms = response.lessons;
					vm.getStudents(vm.ids);
				})
		};


		/**
		 * Edita as aulas selecionadas
		 */
		vm.editLessons = function () {
			vm.schoolrooms = vm.grid.selected;
			vm.releaseInEdition = ' -> ' + vm.grid.selected[0].class;
			vm.group_id = vm.grid.selected[0].group_id;
			vm.subject_id = vm.grid.selected[0].subject_id;
			vm.matrix_period = vm.grid.selected[0].matrix_period;
			vm.selected_tab = 1;

			vm.saveLessons(1);
		};

		/**
		 * Abre o modal para inserção de observações no aluno
		 * @param item
		 * @param notes
		 */
		vm.insertNotes = function (item, notes) {
			ModalFactory.custom(
				'app/educational/classes/classrooms/views/notes.html',
				item[notes]
			).then(function (note) {
				$filter('filter')(vm.students, {person_id: item.person_id})[0][notes] = note;
			});
		};

		/** Destroi os eventos após a utilização */
		$scope.$on('$destroy', function () {
			[ltn, ltn1, ltn2, ltn3, ltn4, ltn5, ltn6].forEach(function (fn) {
				fn();
			})
		});

		vm.init();

	}

	angular.module('app.educational.class-release')
		.controller('ClassReleaseController', ClassReleaseController)

})();
(function(){
  'use strict';

  function ClassReleaseEditController() {
    var vm = this;

    vm.init = function () {
    };

    vm.init();
  }

  angular
    .module('app.educational.class-release')
    .controller('ClassReleaseEditController', ClassReleaseEditController)

})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassReleaseChooseController($mdDialog, ClassesService) {
    var vm = this;
    vm.classes = [];
    vm.subjects = [];
    vm.courses = [];
    vm.groups = [];

    vm.init = function () {
      vm.getClasses();
    };

    /**
     * Retorna todos as classes disponíveis
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     * @param query - Busca de registros
     */
    vm.getClasses = function (page, query) {
      page = angular.isDefined(page) ? page : 1;

      ClassesService.all({limit: 100000, page: page, query: query})
        .then(function (response) {
          vm.classes = response.data;
          vm.getSubjects();
        });
    };

    /**
     *
     */
    vm.getSubjects = function () {
      vm.subjects = [];
    };

    /**
     *
     */
    vm.getCourses = function () {

    };

    /**
     *
     */
    vm.getGroups = function () {

    };


    vm.init();

  }

  angular.module('app.educational.class-release')
    .controller('ClassReleaseChooseController', ClassReleaseChooseController);


})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassReleaseAssistantController($rootScope, $scope, $state, $filter,
                                           $stateParams, $a4FloatButton, a4Moment,
                                           ClassReleaseService, ClassesService, Common, ModalFactory) {
    var vm = this;
    vm.classes = [];
    vm.schoolrooms = [];
    vm.lesson = {};
    vm.form = {};
    vm.disable_frequency_tab = true;
    /** Inicialização de variaveis */

    vm.buttonStates = [
      {textButton: 'Pendente', background: '#d4d2d3', color: 'white', value: 0},
      {textButton: 'Realizada', background: '#7cb342', color: 'white', value: 1}
    ];

    vm.buttonStatesFrequency = [
      {textButton: 'Presente', background: '#16c922', color: 'white', colorIcon: '#ffffff', value: 1},
      {textButton: 'Ausente', background: '#ff1315', color: 'white', colorIcon: '#ffffff', value: 2},
      {textButton: 'Atrasado', background: '#ffc909', color: 'white', colorIcon: '#ffffff', value: 3},
      {textButton: 'Saiu antes', background: '#3e00ff', color: 'white', colorIcon: '#ffffff', value: 4},
      {textButton: 'On-line', background: '#930f50', color: 'white', colorIcon: '#ffffff', value: 5}
    ];


    vm.templates = {
      classroom: 'app/educational/class-release/dialog/classroom.html',
      files: 'app/educational/class-release/dialog/files.html'
    };

    vm.init = function () {
      if ($stateParams.group_id !== null && $stateParams.matrix_period !== null
        && $stateParams.subject_id !== null && $stateParams.lesson_date !== null) {
        vm.getLessonsInSequence($stateParams);
        //TODO verificar uso dos parâmetros
        vm.form.group_id = $stateParams.group_id;
        vm.group_id = $stateParams.group_id;
        vm.form.subject_id = $stateParams.subject_id;
        vm.subject_id = $stateParams.subject_id;
        vm.form.matrix_period = $stateParams.matrix_period;
        vm.matrix_period = $stateParams.matrix_period;
      }
    };
    /**
     * Recebe a lista de arquivos(artifacts)
     * @param id
     */
    vm.getFiles = function (id) {
      ClassReleaseService.getLessonArtifact(id).then(function (files) {
        vm.schoolrooms.forEach(function (item) {
          return item.artefacts = files
        })
      });
    };
    /**
     * Insere observações para o aluno na aula
     * @param item
     * @param notes
     */
    vm.insertNotes = function (item, notes) {
      ModalFactory.custom(
        'app/educational/classes/classrooms/views/notes.html',
        item[notes]
      ).then(function (note) {
        $filter('filter')(vm.students, {person_id: item.person_id})[0][notes] = note;
      });
    };

    /**
     * Formatação da string que representa a quantidade de faltas, atrasos e saídas antecipadas do aluno
     * @param item
     * @param frequency
     */
    vm.formatStringAbsencesLatenessEarly = function (item) {
      console.log(vm.ids);
      var absences = item.absences;
      var lateness = item.lateness;
      var early = item.early;
      var online = item.online;
      var frequency_count = '';
      var string_absences = '';
      var string_lateness = '';
      var string_early = '';
      var string_online = '';
      /** Para cada aula */
      vm.ids.forEach(function (id) {
        var class_id = 'class_' + id;
        var frequency = item[class_id];
        switch (frequency) {
          case 2:
            absences = absences + 1;
            break;
          case 3:
            lateness = lateness + 1;
            break;
          case 4:
            early = early + 1;
            break;
          case 5:
            online = online + 1;
            break;
        }
        if (absences !== 0 && angular.isDefined(absences)) {
          string_absences = absences + ((absences === 1) ? ' falta' : ' faltas');
        }
        if (lateness !== 0 && angular.isDefined(lateness)) {
          string_lateness = lateness + ((lateness === 1) ? ' atraso' : ' atrasos');
        }
        if (early !== 0 && angular.isDefined(early)) {
          string_early = early + ((early === 1) ? ' saída antecipada' : ' saídas antecipadas');
        }
        if (online !== 0 && angular.isDefined(online)) {
          string_online = online + ((online === 1) ? ' on-line' : ' on-lines');
        }
        frequency_count = string_absences + ((lateness !== 0 && angular.isDefined(lateness) && string_lateness !== '') ? ' | ' + string_lateness : '') +
          ((early !== 0 && angular.isDefined(early) && string_early !== '') ? ' | ' + string_early : '')+
          ((online !== 0 && angular.isDefined(online) && string_online !== '') ? ' | ' + string_online : '');
        item.frequency_count = frequency_count;
      });
    };

    /**
     * Recebe as aulas em sequência
     * @param obj
     */
    vm.getLessonsInSequence = function (obj) {
      $rootScope.show_loader = true;
      ClassesService.getLessonsInSequence(obj)
        .then(function (response) {
          vm.schoolrooms = response.plain();
          vm.schoolrooms = vm.schoolrooms.map(function (schoolroom) {
            schoolroom.artefacts = [];
            vm.getFiles(schoolroom.lesson_id);
            return schoolroom;
          })
          // vm.saveLessons();
          vm.floatButton = $a4FloatButton({
            scope: $scope, icon: 'save', label: 'Salvar',
            onClick: 'vm.submit(lesson_form)'
          });
          $rootScope.show_loader = false;
        });
    };
    /** Exibe o modal para adição de anexos */
    vm.addAttachment = function (lesson) {
      ModalFactory.customClean('app/educational/classes/classrooms/dialog/lesson-artefact-dialog.html',
        'LessonArtefactController',
        'vm', true, lesson
      )
    };

    /**
     * Visualização dos campos complementares de aulas
     */
    vm.moreLessonInfo = function (item) {
      ModalFactory.customClean('app/educational/class-release/dialog/more-info.html',
        /** @ngInject */
        function ($rootScope, $mdDialog, ModalExtra) {
          var vm = this;
          vm.lesson = ModalExtra;
          vm.lesson_type = [
            {id: 1, name: 'Aula expositiva'},
            {id: 2, name: 'Aula prática / laboratório'},
            {id: 3, name: 'Workshop'},
            {id: 4, name: 'Apresentação de alunos'},
            {id: 5, name: 'Avaliação'}
          ];
          vm.closeModal = function () {
            $rootScope.$broadcast('ModalFactory.close');
          };
        },
        'vm', true, item)
    };


    /**
     * Salva as informações da aula
     * @param tab - aba que deve ser selecionada após a requisição
     */
    vm.saveLessons = function () {
      $rootScope.show_loader = true;
      vm.schoolrooms.forEach(function (item) {
        item.lesson_status_id = 1;
      });

      return ClassReleaseService.save({lessons: vm.schoolrooms});
    };

    /**
     * Submissão da frequência dos alunos
     */
    vm.submitFrequency = function () {
      ClassesService.saveFrequencyOfStudents({students: vm.students, ids: vm.ids})
        .then(function () {
          Common.Toast.success('Frequência salva com sucesso');
          if (vm.selected_tab === 1) {
            ModalFactory.custom('app/educational/class-release/views/class-release-finish-option.html',
              null,
              true).then(function (option) {
              if (option === 1) {
                $state.go('private.educational.classes.show', {
                  group_id: $stateParams.group_id,
                  subject_id: $stateParams.subject_id,
                  matrix_period: $stateParams.matrix_period
                });
              } else {
                if (a4Moment(vm.schoolrooms[0].date) === a4Moment()) {
                  ModalFactory.alert(
                    "Atenção", "Não é possivel realizar aulas de uma data futura a atual," +
                    " você será redirecionado para a lista de aulas",
                    "modal", "Ok", "false", "educational"
                  ).then(function () {
                    $state.go('private.educational.classes.show', {
                      group_id: $stateParams.group_id,
                      subject_id: $stateParams.subject_id,
                      matrix_period: $stateParams.matrix_period
                    });
                  })
                } else {
                  $rootScope.show_loader = true;
                  ClassReleaseService.getDateOfNextLesson(
                    {
                      group_id: $stateParams.group_id,
                      subject_id: $stateParams.subject_id,
                      matrix_period: $stateParams.matrix_period,
                      lesson_date: $stateParams.lesson_date
                    }
                  ).then(function (date) {
                    if (date !== '0000-00-00' && a4Moment(date) <= a4Moment()) {
                      $state.go('private.educational.class-release.accomplish', {
                        group_id: $stateParams.group_id, subject_id: $stateParams.subject_id,
                        matrix_period: $stateParams.matrix_period, lesson_date: date
                      });
                      $rootScope.show_loader = false;
                    } else {
                      $state.go('private.educational.classes.show', {
                        group_id: $stateParams.group_id,
                        subject_id: $stateParams.subject_id,
                        matrix_period: $stateParams.matrix_period
                      });
                      Common.Toast.error('Não há próxima aula a ser realizada.');
                    }
                  })
                }
              }
            });
          }
        })
        .catch(function () {
          Common.Toast.error('Erro ao salvar frequência');
        })
    };

    /**
     * Pega os estudantes vinculados a aula
     * @param ids
     */
    vm.getStudents = function (ids) {
      var classe = {
        group_id: vm.group_id,
        subject_id: vm.subject_id,
        matrix_period: vm.matrix_period
      };
      ClassReleaseService.getStudents({
        classe: classe,
        lessons: {ids: ids}
      })
        .then(function (response) {
          vm.students = response.students;
          vm.date = response.date;
          $rootScope.show_loader = false;
        })
    };

    /** Submissão dos dados */
    vm.submit = function (form) {
      vm.openFrequency = true;
      vm.disable_frequency_tab = false;
      var goToFrequency = true;

      vm.saveLessons()
        .then(function (response) {
          vm.openFrequency = true;
          vm.ids = response.ids;
          vm.schoolrooms = response.lessons;
          vm.floatButton.destroy();
          vm.floatButton = $a4FloatButton({
            scope: $scope, icon: 'save', label: 'Concluir', onClick: 'vm.submitFrequency()'
          });
          vm.getStudents(vm.ids);

          /** Verifica se lição cancelada */
          angular.forEach(vm.schoolrooms, function (item) {
            if (item.lesson_status_id === 4) {
              goToFrequency = false;
            }
          });
          vm.selected_tab = 1;
        }).catch(function (response) {
          $rootScope.show_loader = false;
          Common.Toast.error(response.data.message);
        });
    };

    /**
     * Seleciona o link
     * @param event
     */
    vm.getSelectedChipLinkIndex = function (event) {
      vm.selectedChipLink = angular.element(event.currentTarget).controller('mdChips').selectedChip;
    };

    /**
     * Seleciona o link
     * @param event
     */
    vm.getSelectedChipFileIndex = function (event) {
      vm.selectedChipFile = angular.element(event.currentTarget).controller('mdChips').selectedChip;
    };

    /**
     * Seleciona o chip recém criado para edição dos dados
     */
    vm.selectAddLink = function () {
      var chip = angular.element('md-chips.chip-links').controller('mdChips').selectedChip;
      if (chip !== -1 && angular.isDefined(chip)) {
        vm.selectedChipLink = chip;
      }
    };

    /**
     * Seleciona o chip recém criado para edição dos dados
     */
    vm.selectAddFile = function () {
      var chip = angular.element('md-chips.chip-files').controller('mdChips').selectedChip;
      if (chip !== -1 && angular.isDefined(chip)) {
        vm.selectedChipFile = chip;
      }
    };

    /**
     * Envia o formulário de links
     * @param form
     * @param lesson
     * @param links
     */
    vm.submitLinks = function (form, lesson, links) {
      if (form.$valid) {
        vm.submitAndSaveLinks(lesson, links);
      } else {
        Common.Toast.error('Verifique os dados informados.');
      }
    };

    /**
     * Salva os links existentes
     * @param lesson
     * @param links
     */
    vm.saveLinks = function (lesson, links) {
      var valid = true;
      /** Verifica se todas URLs são válidas */
      angular.forEach(links, function (item) {
        var pattern = /(http(s)?)/gi;
        if (!pattern.exec(item.file_reference)) {
          valid = false;
          Common.Toast.error('Verifique a URL do link inserido.');
          return false;
        }
      });
      /** Submete se estiverem válidos*/
      if (valid) vm.submitAndSaveLinks(lesson, links);
    };

    /**
     * Submete os links da referida lição
     * @param lesson
     * @param links
     */
    vm.submitAndSaveLinks = function (lesson, links) {
      ClassReleaseService.saveLinks({id: lesson.id, links: links})
        .then(function (response) {
          if (response) {
            Common.Toast.success('Links vinculados com sucesso.');
            lesson.links = response.links;
            lesson.files = response.files;
          }
        })
    };

    /**
     * Submete os arquivos da referida lição
     * @param lesson
     * @param links
     */
    vm.submitAndSaveFiles = function (lesson, files) {

      /** Verifica se há um novo upload de arquivo
       * e aloca as informaçõe corretamente */
      angular.forEach(files, function (item) {
        if (item.origin) {
          item.file_reference = item.origin.file;
          item.extension = item.origin.extension;
          item.size = item.origin.size;
          item.upload = item.origin.upload;
        }
      });

      ClassReleaseService.saveFiles({id: lesson.id, files: files})
        .then(function (response) {
          if (response) {
            Common.Toast.success('Os arquivos foram vinculados com sucesso.');
            lesson.links = response.links;
            lesson.files = response.files;
          }
        })
    };

    /**
     * Envia o formulário de links
     * @param form
     * @param lesson
     * @param links
     */
    vm.submitFiles = function (form, lesson, files) {
      if (form.$valid) {
        vm.submitAndSaveFiles(lesson, files);
      } else {
        Common.Toast.error('Verifique os dados informados.');
      }
    };

    /**
     * Salva os links existentes
     * @param lesson
     * @param links
     */
    vm.saveFiles = function (lesson, links) {
      /** Submete se estiverem válidos*/
      vm.submitAndSaveFiles(lesson, links);
    };


    vm.init();

    vm.close = function () {
      $rootScope.$broadcast('class.release.assistant.close');
      $rootScope.$broadcast('ModalFactory.close');
    };

  }

  angular
    .module('app.educational.class-release')
    .controller('ClassReleaseAssistantController', ClassReleaseAssistantController)

})();

(function () {
  'use strict';

  /** @ngInject */
  function ClassGroupingService(Restangular) {

    /**
     * Busca todas as aulas
     * @param obj
     */
    var getAll = function (obj) {
      return Restangular.one('classgrouping').get(obj);
    };

    /**
     * Salva o agrupamentp
     * @param obj
     */
    var save = function (obj) {
      return Restangular.all('classgrouping').post(obj);
    };

    /**
     * Busca as turmas ativas
     * @param obj
     */
    var getActiveGroups = function (obj) {
      return Restangular.one('classgrouping').one('getgroups').get(obj);
    };

    /**
     * Busca os eventos pelo agrupamento
     * @param obj
     */
    var getEventsByGrouping = function (obj) {
      return Restangular.one('classgrouping').one('geteventsbygrouping').get(obj);
    };

    /**
     * Busca todos os professores
     * @param obj
     */
    var getTeachers = function (obj) {
      return Restangular.one('classgrouping').one('getteachers').get(obj);
    };

    /**
     * Busca os agrupamentos para um professor
     * @param obj
     */
    var getGradeGroupingForTeacher = function (obj) {
      return Restangular.one('classgrouping').one('getgradegroupingteacher').get(obj);
    };

    /**
     * Busca as disciplinas e eventos de uma disciplina
     * @param obj
     */
    var getSubjectsAndEventsForGroup = function (obj) {
      return Restangular.one('classgrouping').one('getsubjectsandevents').get(obj);
    };

    /**
     * Formata uma string com o apelido do curso e o nome da turma
     * @param items
     * @returns {*}
     */
    var formatNameCourseGroup = function (items) {
      items.forEach(function (item) {

        item.name = item.course_alias + ' | ' + item.group_name;

      });

      return items;
    };

    /**
     * Formata uma string com o nome do evento e descrição
     * @param items
     * @returns {*}
     */
    var formatEventNameDescription = function (items) {
      items.forEach(function (item) {

        item.name = item.name + ' | ' + item.description;

      });

      return items;
    };

    /**
     * Atualiza informações do evento
     * @returns array
     */
    var remove = function (id) {
      return Restangular.one('classgrouping', id).remove();
    };

    /**
     * Busca um agrupamento
     * @param id
     */
    var getGrouping = function (id) {
      return Restangular.one('classgrouping', id).get();
    };

    /**
     * Salva o agrupamentp
     * @param obj
     * @param id
     */
    var update = function (obj, id) {
      return Restangular.one('classgrouping', id).customPUT(obj);
    };

    return {
      getAll: getAll,
      save: save,
      getActiveGroups: getActiveGroups,
      getEventsByGrouping: getEventsByGrouping,
      formatNameCourseGroup: formatNameCourseGroup,
      getSubjectsAndEventsForGroup: getSubjectsAndEventsForGroup,
      getTeachers: getTeachers,
      formatEventNameDescription: formatEventNameDescription,
      remove: remove,
      getGrouping: getGrouping,
      update: update,
      getGradeGroupingForTeacher: getGradeGroupingForTeacher
    };
  }

  angular
    .module('app.educational.class-grouping')
    .factory('ClassGroupingService', ClassGroupingService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.class-grouping', {
        public: false,
        url: '/class-grouping',
        controller: "ClassGroupingController",
        controllerAs: "vm",
        templateUrl: 'app/educational/class-grouping/views/list.html'
      });
  }

  angular
    .module('app.educational.class-grouping')
    .config(routerConfig);
})();

(function () {
  'use strict';

  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'agrup_classe_menu';
    var path = 'coordination.class-grouping';

    msNavigationService.saveItem(path, {
      title: 'Agrupamento de Classes',
      icon: 'icon-group',
      auth: role,
      state: 'private.educational.class-grouping',
      weight: 10,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path); // must be a boolean value
      }
    });
  }

  angular
    .module('app.educational.class-grouping')
    .run(run);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassGroupingController($rootScope, $scope, $a4FloatButton, Common, PoliciesService, ModalFactory, ClassGroupingService) {
    var vm = this;

    var CLASS_GROUPING = 1;
    var GRADE_GROUPING = 2;

    /** Grid padrão */
    vm.grid = {
      rows: [],
      info: {},
      promise: {}
    };

    vm.grouping_type = '2';


    /**
     * Evento de inicialização da tela
     * @type {*}
     */
    var ltn = $rootScope.$on('a4-grid-dic-data.loaded', function () {
      vm.getAll(GRADE_GROUPING);
    });

    var ltn1 = $rootScope.$on('update.list.grouping', function (ev, obj) {
      vm.getAll(obj.special_type);
    });

    /**
     * Escuta da tab corrente, a cada troca de tab em turmas, esta escuta salva a corrente no localstorage;
     * @type {*}
     */
    var ltn2 = $scope.$watch(function () {
        return vm.grouping_type;
      },
      function (newer) {
        vm.getAll(newer);
        vm.createFloatButton(newer);
      });

    vm.init = function () {
      if (!vm.checkPolicies('agrup_classe_alt')) {
        vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createGradeGrouping()'});
      }
    };

    vm.getAll = function (type) {
      $rootScope.show_loader = true;
      ClassGroupingService.getAll({grouping_type: type})
        .then(function (res) {
          vm.grid.rows = ClassGroupingService.formatNameCourseGroup(res.plain());
          $rootScope.show_loader = false;
        })
        .catch();

    };

    /**
     * Criação do botão flutuante de acordo com o tipo de agrupamento
     * @param type
     */
    vm.createFloatButton = function (type) {
      /** Caso já exista um botão, destroy e cria um novo */
      if (angular.isDefined(vm.floatButton) && vm.floatButton !== null) {
        vm.floatButton.destroy();
      }
      switch (type) {
        case '1':
          /** Botão de criação de um agrupamento de classe para aulas */
          if (!vm.checkPolicies('agrup_classe_alt')) {
            vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createClassGrouping()'});
          }
          break;
        case '2':
          /** Botão de criação de um agrupamento de classe para notas */
          if (!vm.checkPolicies('agrup_classe_alt')) {
            vm.floatButton = $a4FloatButton({scope: $scope, onClick: 'vm.createGradeGrouping()'});
          }
          break;
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Abre o modal de criação de agrupamento de notas
     */
    vm.createGradeGrouping = function () {
      $rootScope.$broadcast('ModalFactory.close');
      ModalFactory.customClean(
        'app/educational/class-grouping/views/create.html',
        'ClassGroupingCreateGradeController',
        'vm', false, {}
      );
      return false;
    };

    /**
     * Abre o modal de criação de agrupamento de classe
     */
    vm.createClassGrouping = function () {
      $rootScope.$broadcast('ModalFactory.close');
      ModalFactory.customClean(
        'app/educational/class-grouping/views/create-class.html',
        'ClassGroupingCreateClassController',
        'vm', false, {}
      );
      return false;
    };

    vm.deleteGrouping = function (index) {
      ModalFactory.confirm(null,
        'Confirmação de Exclusão',
        'As notas já lançadas através deste agrupamento não serão afetadas pela exclusão do agrupamento. Confirmar?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          ClassGroupingService.remove(index)
            .then(function () {
              $rootScope.$broadcast('update.list.grouping', {special_type: vm.grouping_type});
              Common.Toast.success('Agrupamento excluido com sucesso');
            })
            .catch(function (error) {
              Common.Toast.error(error.data.message);
            });
        });
    };

    vm.editGradeGrouping = function (item) {
      ModalFactory.confirm(null,
        'Confirmação de Edição',
        'As notas já lançadas através deste agrupamento não serão afetadas pela edição do agrupamento. Confirmar?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          ClassGroupingService.getGrouping(item.id)
            .then(function (res) {
              $rootScope.$broadcast('ModalFactory.close');
              ModalFactory.customClean(
                'app/educational/class-grouping/views/edit.html',
                'ClassGroupingEditGradeController',
                'vm', false, res.plain()
              );''
              return false;
            });
        });
    };

    vm.editClassGrouping = function (item) {
      ClassGroupingService.getGrouping(item.id)
        .then(function (res) {
          $rootScope.$broadcast('ModalFactory.close');
          ModalFactory.customClean(
            'app/educational/class-grouping/views/edit-class.html',
            'ClassGroupingCreateClassController',
            'vm', false, res.plain()
          );
          return false;
        });
    };

    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn, ltn1, ltn2].forEach(function (fn) {
        fn();
      })
    });


    vm.init();
  }

  angular
    .module('app.educational.class-grouping')
    .controller('ClassGroupingController', ClassGroupingController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassGroupingEditGradeController($rootScope, $mdDialog, ClassGroupingService, Common, ModalExtra) {
    var vm = this;

    vm.students = [];

    vm.form = {
      mode_edit: true,
      class_grouping_subject: {
        subjects: []
      },
      class_grouping_event: {
        events: []
      },
      subject: {}
    };

    vm.list = {
      subject: {
        group_id: [],
        person_id_teacher: []
      },
      class_grouping_subject: {
        subjects: []
      },
      class_grouping_event: {
        events: []
      }
    };

    /** Função de inicio do controlador */
    vm.init = function () {
      vm.form.class_grouping_subject.subjects = ModalExtra.subjects;
      vm.form.class_grouping_event.events = ClassGroupingService.formatEventNameDescription(ModalExtra.events);
      vm.form.subject.name = ModalExtra.name;
      vm.form.subject.group_id = ModalExtra.group_id;
      vm.form.subject.person_id_teacher = ModalExtra.person_id_teacher;
      vm.form.subject.id = ModalExtra.id;
      vm.form.subject.matrix_period = ModalExtra.matrix_period;
      vm.getActiveGroups();
      vm.getTeachers();
    };

    vm.getActiveGroups = function () {
      ClassGroupingService.getActiveGroups()
        .then(function (res) {
          vm.list.subject.group_id = ClassGroupingService.formatNameCourseGroup(res.plain());
        })
        .catch();
    };

    vm.getTeachers = function () {
      ClassGroupingService.getTeachers()
        .then(function (res) {
          vm.list.subject.person_id_teacher = res.plain();
        })
        .catch();
    };

    vm.submitGrouping = function (item) {
      item.special_type = 2;
      ClassGroupingService.update(item, item.id)
        .then(function () {
          Common.Toast.success('Agrupamento editado com sucesso!');
          vm.close();
          $rootScope.$broadcast('update.list.grouping', {special_type: 2});
        })
        .catch(function (error) {
          if( error.data.message === "hasSameDisciplineEvent"){
            Common.Toast.error('A mesma disciplina/evento já está existe em outro agrupamento para a mesma turma!');
          } else if( error.data.message === "nameDuplication"){
            Common.Toast.error('Já existe um agrupamento de notas com este nome!');
          } else {
            Common.Toast.error(error.data.message);
          }
        });
    };

    vm.close = function () {
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular
    .module('app.educational.class-grouping')
    .controller('ClassGroupingEditGradeController', ClassGroupingEditGradeController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassGroupingEditClassController($rootScope, $mdDialog, ClassGroupingService, Common, ModalExtra) {
    var vm = this;

    vm.students = [];

    vm.form = {
      mode_edit: true,
      class_grouping_subject: {
        subjects: []
      },
      subject: {}
    };

    vm.list = {
      subject: {
        group_id: [],
        person_id_teacher: []
      },
      class_grouping_subject: {
        subjects: []
      }
    };

    /** Função de inicio do controlador */
    vm.init = function () {
      vm.form.class_grouping_subject.subjects = ModalExtra.subjects;
      vm.form.subject.name = ModalExtra.name;
      vm.form.subject.group_id = ModalExtra.group_id;
      vm.form.subject.person_id_teacher = ModalExtra.person_id_teacher;
      vm.form.subject.id = ModalExtra.id;
      vm.form.subject.matrix_period = ModalExtra.matrix_period;
      vm.getActiveGroups();
      vm.getTeachers();
    };

    vm.getActiveGroups = function () {
      ClassGroupingService.getActiveGroups()
        .then(function (res) {
          vm.list.subject.group_id = ClassGroupingService.formatNameCourseGroup(res.plain());
        })
        .catch();
    };

    vm.getTeachers = function () {
      ClassGroupingService.getTeachers()
        .then(function (res) {
          vm.list.subject.person_id_teacher = res.plain();
        })
        .catch();
    };

    vm.submitGrouping = function (item) {
      item.special_type = 1;
      ClassGroupingService.update(item, item.id)
        .then(function () {
          Common.Toast.success('Agrupamento editado com sucesso!');
          vm.close();
          $rootScope.$broadcast('update.list.grouping', {special_type: 1});
        })
        .catch(function (error) {
          if( error.data.message === "hasSameDisciplineEvent"){
            Common.Toast.error('A mesma disciplina/evento já está existe em outro agrupamento para a mesma turma!');
          } else if( error.data.message === "nameDuplication"){
            Common.Toast.error('Já existe um agrupamento de notas com este nome!');
          } else {
            Common.Toast.error(error.data.message);
          }
        });
    };

    vm.close = function () {
      $mdDialog.cancel();
    };

    vm.init();
  }

  angular
    .module('app.educational.class-grouping')
    .controller('ClassGroupingEditClassController', ClassGroupingEditClassController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassGroupingCreateGradeController($rootScope, $scope, $filter, $mdDialog, ClassGroupingService, Common) {
    var vm = this;

    vm.students = [];

    vm.form = {
      mode_edit: true,
      class_grouping_subject: {
        subjects: []
      },
      class_grouping_event: {
        events: []
      },
      subject: {}
    };

    vm.list = {
      subject: {
        group_id: [],
        person_id_teacher: []
      }
    };

    /**
     * Esculta a troca do campo de Estado no formulário de criação de colaborador
     * @type {*}
     */
    var ltn = $rootScope.$on('subject_group_change', function (ev, group_id) {
      vm.getSubjectsAndEventsForGroup(group_id);
    });

    /** Função de inicio do controlador */
    vm.init = function () {
      vm.getActiveGroups();
      vm.getTeachers();
    };

    vm.getActiveGroups = function () {
      ClassGroupingService.getActiveGroups()
        .then(function (res) {
          vm.list.subject.group_id = ClassGroupingService.formatNameCourseGroup(res.plain());
        })
        .catch();
    };

    vm.getTeachers = function () {
      ClassGroupingService.getTeachers()
        .then(function (res) {
          vm.list.subject.person_id_teacher = res.plain();
        })
        .catch();
    };

    vm.getSubjectsAndEventsForGroup = function (group_id) {
      var matrix_period = $filter('filter')(vm.list.subject.group_id, {id: group_id})[0].matrix_period;
      ClassGroupingService.getSubjectsAndEventsForGroup({group_id: group_id, matrix_period: matrix_period, grouping_type: 2})
        .then(function (res) {
          vm.form.class_grouping_event.events = ClassGroupingService.formatEventNameDescription(res.events);
          vm.form.class_grouping_subject.subjects = res.subjects;
        })
        .catch();
    };

    vm.submitGrouping = function (item, form) {
      item.special_type = 2;
      item.matrix_period = $filter('filter')(vm.list.subject.group_id, {id: item.group_id})[0].matrix_period;
      ClassGroupingService.save(item)
        .then(function () {
          Common.Toast.success('Agrupamento criado com sucesso!');
          vm.close();
          $rootScope.$broadcast('update.list.grouping', {special_type: 2});
        })
        .catch(function (error) {
          if( error.data.message === "hasSameDisciplineEvent"){
            Common.Toast.error('A mesma disciplina/evento já está existe em outro agrupamento para a mesma turma!');
          } else if( error.data.message === "nameDuplication"){
            Common.Toast.error('Já existe um agrupamento de notas com este nome!');
          } else {
            Common.Toast.error(error.data.message);
          }
        });
    };

    vm.close = function () {
      $mdDialog.cancel();
    };


    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });


    vm.init();
  }

  angular
    .module('app.educational.class-grouping')
    .controller('ClassGroupingCreateGradeController', ClassGroupingCreateGradeController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ClassGroupingCreateClassController($rootScope, CourseService, MatrixService, $scope, $filter, $mdDialog, ClassGroupingService, Common, ModalExtra) {
    var vm = this;

    vm.students = [];

    vm.form = {
      mode_edit: true,
      class_grouping_subject: {
        subjects: []
      },
      class_grouping_event: {
        events: []
      },
      subject: {}
    };

    vm.list = {
      subject: {
        group_id: [],
        person_id_teacher: []
      }
    };

    /**
     * Esculta a troca do campo de Estado no formulário de criação de colaborador
     * @type {*}
     */
    var ltn = $rootScope.$on('subject_course_change', function (ev, course_id) {
      vm.getMatrixOfCourse(course_id);
    });

    var ltn2 = $rootScope.$on('subject_matrix_change', function (ev, matrix_id) {
      vm.getMatrixPeriod(matrix_id);
    });

    vm.getMatrixPeriod = function (matrix_id) {
      MatrixService.getMatrixPeriod({matrix_id: matrix_id, without_groupings: true}).then(function (response) {
        var obj = response.plain();
        vm.form.class_grouping_subject.subjects = obj[0].subjects;
      })
    };


    vm.getMatrixOfCourse = function (course_id) {
      MatrixService.getMatrixOfCourse({course_id: course_id, only_actives: true}).then(function (response) {
        vm.list.subject.matrix_id = response.plain();
      })
    };

    /** Função de inicio do controlador */
    vm.init = function () {
      vm.getCourses();
      vm.getTeachers();
      if (angular.isDefined(ModalExtra) && ModalExtra !== null) {
        vm.form.class_grouping_subject.subjects = ModalExtra.subjects;
        vm.form.subject.name = ModalExtra.name;
        vm.form.subject.id = ModalExtra.id;
        vm.form.subject.course_id = ModalExtra.course_id;
        vm.getMatrixOfCourse(ModalExtra.course_id);
        vm.form.subject.matrix_id = ModalExtra.matrix_id;
        vm.form.subject.matrix_period = ModalExtra.matrix_period;
      }
    };

    vm.getCourses = function () {
      CourseService.getAll({only_active: true})
        .then(function (res) {
          vm.list.subject.course_id = res.plain();
        })
        .catch();
    };

    vm.getTeachers = function () {
      ClassGroupingService.getTeachers()
        .then(function (res) {
          vm.list.subject.person_id_teacher = res.plain();
        })
        .catch();
    };

    vm.getSubjectsAndEventsForGroup = function (group_id) {
      var matrix_period = $filter('filter')(vm.list.subject.group_id, {id: group_id})[0].matrix_period;
      ClassGroupingService.getSubjectsAndEventsForGroup({
        group_id: group_id,
        matrix_period: matrix_period,
        grouping_type: 1
      })
        .then(function (res) {
          vm.form.class_grouping_subject.subjects = res.subjects;
        })
        .catch();
    };

    vm.submitGrouping = function (item, form) {
      item.special_type = 1;
      if (vm.list.subject.matrix_id !== null && vm.list.subject.matrix_id.length > 0) {
        var matrix_period = $filter('filter')(vm.list.subject.matrix_id, {id: item.matrix_id})[0].matrix_period[0].matrix_period;
        item.matrix_period = matrix_period;
        if (angular.isDefined(item.id) && item.id !== null) {
          ClassGroupingService.update(item, item.id)
            .then(function () {
              Common.Toast.success('Agrupamento criado com sucesso!');
              vm.close();
              $rootScope.$broadcast('update.list.grouping', {special_type: 1});
            })
        } else {
          ClassGroupingService.save(item)
            .then(function () {
              Common.Toast.success('Agrupamento criado com sucesso!');
              vm.close();
              $rootScope.$broadcast('update.list.grouping', {special_type: 1});
            })
            .catch(function (error) {
              if (error.data.message === "hasSameDisciplineEvent") {
                Common.Toast.error('Já existe um agrupamento de aulas para esta mesma turma!');
              } else if (error.data.message === "nameDuplication") {
                Common.Toast.error('Já existe um agrupamento de aulas com este nome!');
              } else {
                Common.Toast.error(error.data.message);
              }
            });
        }
      } else {
        Common.Toast.error("Selecione as disciplinas");
      }
    };

    vm.close = function () {
      $mdDialog.cancel();
    };


    /**
     * Destruct dos eventos registrados pelo controlador
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });


    vm.init();
  }

  angular
    .module('app.educational.class-grouping')
    .controller('ClassGroupingCreateClassController', ClassGroupingCreateClassController)
})();
(function(){
  angular.module('models', []);

  angular.module('models').factory('models', function(Pessoa, Animal){
    /**
     * Um objeto pra registrar os meus modelos de coisas persistentes
     */
    var models = {};
    
    models.Pessoa = Pessoa;
    models.Animal = Animal;
    
    return models;
  });
  
  angular.module('models').factory('Pessoa', function(){
    /**
     * Um construtor de pessoas
     */
    function Pessoa(nome, idade){
      this.nome = nome;
      this.idade = idade;
    }
    
    Pessoa.crud_fields = [
      _field('id', 'id'), 
      _field('nome', 'string'), 
      _field('idade', 'int')
    ];
    
    angular.extend(Pessoa.prototype, {
      aniversario: aniversario
    });
    
    function aniversario(){
      var p = this;
      p.idade++;
    }
    
    return Pessoa;
  });
  
  angular.module('models').factory('Animal', function(){
    /**
     * Um construtor de animais
     */
    function Animal(nome, raca){
      this.nome = nome;
      this.raca = raca;
    }
  
    Animal.crud_fields = [
      _field('id', 'id'), 
      _field('nome', 'string'), 
      _field('raca', 'string')
    ];
    
    angular.extend(Animal.prototype, {
      corre: corre
    });
    
    function corre(){
    }
    
    return Animal;
  });
  
  function _field(name, type){
    return {
      name: name,
      type: type
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.educational.cancel-reasons', ['models']);

})();
(function () {
  'use strict'

  /** @ngInject */
  function CancelReasonsService(Restangular) {

    var vm = this;

    vm.getAll = function (obj) {
      return Restangular.one('enrolmentcancelreason').get(obj);
    };
    vm.create = function (obj) {
      return Restangular.all('enrolmentcancelreason').post(obj);
    };
    vm.deleteCancelReason = function (id) {
      return Restangular.one('enrolmentcancelreason', id).remove();
    };
    vm.updateCancelReason = function (obj) {
      return Restangular.one('enrolmentcancelreason', obj.id).customPUT(obj);
    };
    return vm;
  }

  angular
    .module('app.educational.cancel-reasons')
    .factory('CancelReasonsService', CancelReasonsService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational.cancel-reasons', {
        url: '/cancel-reasons',
        public: false,
        templateUrl: 'app/educational/cancel-reasons/views/index.html',
        controller: 'CancelReasonsController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Motivos de cancelamento'
        }
      });
  }

  angular
    .module('app.educational.cancel-reasons')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function CancelReasonsController($scope, $a4FloatButton, $mdDialog, ModalFactory, Common, DiscountsService, $rootScope,
                                   CancelReasonsService, Pessoa) {

    var vm = this;
    vm.items = [];
    vm.grid = [];
    vm.crud_options = {
      fields_dictionary: {
        id: 'Código',
        nome: 'Nome do indivíduo',
        idade: 'Quantos anos tem',
        raca: 'Raça',
      }
    };
    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      vm.pessoa = Pessoa;
      $rootScope.show_loader = true;
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.createReason()', label: 'Criar novo motivo', theme: 'educational'
      });
      vm.getAllReasons();
    };

    /**
     * Cria novo motivo de cancelamento
     */
    vm.createReason = function () {
      ModalFactory.prompt(null, 'Criação de motivo de cancelamento',
        'Digite o novo motivo de cancelamento', '', '',
        'Salvar', 'Cancelar', 'educational').then(function (reason) {
        $rootScope.show_loader = true;
        CancelReasonsService.create({name: reason}).then(function () {
          vm.getAllReasons();
          Common.Toast.success('Motivo criado com sucesso!');
        })

      })
    };

    /**
     * Exclui um motivo de cancelamento
     * @param id
     */
    vm.delete = function (id) {
      ModalFactory.confirm(null, 'Excluir motivo de cancelamento', 'Tem certeza que deseja deletar este motivo de cancelamento?',
        'Confirmar', 'Cancelar', 'educational', false).then(function () {
        $rootScope.show_loader = true;
        CancelReasonsService.deleteCancelReason(id).then(function () {
          vm.getAllReasons();
          Common.Toast.success('Motivo deletado com sucesso!');
        })
      })
    };

    /**
     * Edita um motivo de cancelamento
     * @param item
     */
    vm.editReason = function (item) {
      ModalFactory.prompt(null, 'Edição de motivo de cancelamento',
        'Digite o novo motivo de cancelamento', '', item.name,
        'Salvar', 'Cancelar', 'educational').then(function (reason) {
        $rootScope.show_loader = true;
        CancelReasonsService.updateCancelReason({name: reason, id: item.id}).then(function () {
          vm.getAllReasons();
          Common.Toast.success('Motivo atualizado com sucesso!');
        })

      })
    };

    /**
     * Retorna todos os motivos de cancelamento.
     * @returns {reason}
     */
    vm.getAllReasons = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;
      CancelReasonsService.getAll({page: page, limit: limit}).then(function (response) {
        vm.reasons = response;
        $rootScope.show_loader = false;
      })
    };

    vm.init();
  }


  angular
    .module('app.educational.cancel-reasons')
    .controller('CancelReasonsController', CancelReasonsController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function AcademicCalendarService(Restangular) {

    /**
     * Retorna todos os eventos de calendário
     * @returns array
     */
    var all = function (obj) {
      return Restangular.one('academiccalendar').get(obj);
    };

    /**
     * Retorna todos informações para o formulário
     * @returns array
     */
    var infos = function () {
      return Restangular.one('academiccalendar').one('forminfos').get();
    };

    /**
     * Cria um novo evento para o formulário
     * @returns array
     */
    var get = function (id) {
      return Restangular.one('academiccalendar', id).get();
    };


    /**
     * Cria um novo evento para o formulário
     * @returns array
     */
    var store = function (obj) {
      return Restangular.all('academiccalendar').post(obj);
    };

    /**
     * Atualiza informações do evento
     * @returns array
     */
    var update = function (obj, id) {
      return Restangular.one('academiccalendar', id).customPUT(obj);
    };

    /**
     * Atualiza informações do evento
     * @returns array
     */
    var remove = function (id) {
      return Restangular.one('academiccalendar', id).remove();
    };


    return {
      all: all,
      infos: infos,
      store: store,
      update: update,
      get: get,
      remove: remove
    };
  }

  angular
    .module('app.educational.academic-calendar')
    .factory('AcademicCalendarService', AcademicCalendarService);
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.educational.academic-calendar', {
        public: false,
        url: '/academic-calendar',
        controller: 'AcademicCalendarController',
        controllerAs: 'vm',
        templateUrl: 'app/educational/academic-calendar/views/academic-calendar.html',
      })
  }

  angular
    .module('app.educational.academic-calendar')
    .config(routerConfig);
})();

(function () {
  'use strict';
  angular
    .module('app.educational', [
      'app.educational.dashboard',
      'app.educational.course',
      'app.educational.course-group',
      'app.educational.subject',
      'app.educational.settings-edu',
      'app.educational.timetable-template',
      'app.educational.groups',
      'app.educational.collaborators',
      'app.educational.students',
      'app.educational.external-document-assign',
      'app.educational.external-pre-enrolment',
      'app.educational.external-person-edit',
      'app.educational.responsibles',
      'app.educational.enrolment',
      'app.educational.school-records-config',
      'app.educational.school-period-config',
      'app.educational.evaluation-criteria',
      'app.educational.rounding-criteria',
      'app.educational.concept-criteria',
      'app.educational.classes',
      'app.educational.coordinators',
      'app.educational.class-grouping',
      'app.educational.note-release',
      'app.educational.academic-calendar',
      'app.educational.class-release',
      'app.educational.typing-date',
      'app.educational.reports',
      'app.educational.persons',
      'app.educational.school-period',
      'app.educational.events',
      'app.educational.informative-report',
      'app.educational.lesson-plan',
      'app.educational.finance-enrolment',
      'app.educational.statistics',
      'app.educational.documents',
      'app.educational.students.documents',
      'app.educational.re-enrollment',
      'app.educational.educational-reports-generation',
      'app.educational.students-records-messages',
      'app.educational.cancel-reasons',
      'app.educational.students.medical-records',
      'app.educational.enrolmentsstudent',
      'app.educational.tables',
      'app.educational.import-photos',
      'app.educational.responsible-changes'
    ]);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'calend_menu';
    var path = 'coordination.academic-calendar';

    msNavigationService.saveItem(path, {
      title: 'Calendário Academico',
      icon: 'icon-calendar',
      auth: role,
      state: 'private.educational.academic-calendar',
      weight: 1,
      hidden: function () {
        return !PoliciesService.checkPolicyAndProfile(role, path); // must be a boolean value
      }
    });

  }

  angular
    .module('app.educational')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function AcademicCalendarController($rootScope, $scope, $filter, $a4FloatButton, AcademicCalendarService, ModalFactory, PoliciesService) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };

    vm.form = {};

    var ltn = $rootScope.$on('academic.calendar.list.update', function () {
      vm.getAllCalendarEvents();
    });

    /**
     * Evento de inicialização da tela
     * @type {*}
     */
    var ltn1 = $rootScope.$on('a4-grid-dic-data.loaded', function () {
      vm.getAllCalendarEvents();
    });


    /**
     * Função de inicialização do controlador.
     */
    vm.init = function () {
      if(!vm.checkPolicies('calend_alt')){
        $a4FloatButton({scope: $scope, icon: 'add', onClick: 'vm.createEvent()'});
      }
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Abre o modal para criação de eventos de calendário
     */
    vm.createEvent = function () {
      ModalFactory.customClean(
        'app/educational/academic-calendar/views/new-calendar-event.html',
        'AcademicCalendarCreateController',
        'vm', false, {}
      );
    };

    /**
     * Abre o modal para edição de evento de calendário
     */
    vm.editCalendarEvent = function (item) {
      vm.getById(item.id)
        .then(function (response) {
          ModalFactory.customClean(
            'app/educational/academic-calendar/views/new-calendar-event.html',
            'AcademicCalendarEditController',
            'vm', false, response.plain()
          );
        });
    };

    /**
     * Executa a exclusão de um evento de calendário
     * @param index - Identificador do evento
     */
    vm.deleteEvent = function (index) {

      ModalFactory.confirm(null,
        'Confirmação de Exclusão',
        'Deseja realmente excluir o Evento?',
        'Confirmar',
        'Cancelar',
        'educational')
        .then(function () {
          AcademicCalendarService.remove(index)
            .then(function () {
              $rootScope.$broadcast('academic.calendar.list.update');
              Common.Toast.success('Evento de calendário excluido com sucesso');
            });
        });

    };

    /**
     * Resgate de um evento do calendário.
     */
    vm.getById = function (id) {
      return AcademicCalendarService.get(id)
    };

    /**
     * Resgata todos os cursos, com paginação de limite 50 por pagina
     * @param page - (Opcional) Pagina de destino
     * @param limit - limite de registros
     */
    vm.getAllCalendarEvents = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;

      vm.grid.promise = AcademicCalendarService.all({limit: limit, page: page})
        .then(function (response) {
          vm.grid.rows = vm.formatDate(response.data);
          vm.grid.info = {
            limit_options: [50, 100, 150, {
              label: 'Todas',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          }
          $rootScope.show_loader = false;
        });
    };

    /**
     * Realiza a formatação necessária das datas e horas
     * @param array
     * @returns {*}
     */
    vm.formatDate = function (array) {
      /** Filtro para data e horários */
      angular.forEach(array, function (item) {
        /** Filtro para data */
        item.new_date = item.date + ' (' + item.day + ')';
      });

      return array;
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.academic-calendar')
    .controller('AcademicCalendarController', AcademicCalendarController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function AcademicCalendarEditController($scope, $rootScope, AcademicCalendarService, Common, ModalExtra, a4Moment, PoliciesService) {
    var vm = this;

    vm.form = {};
    vm.form.calendar = {};
    vm.form.mode_edit = true;

    vm.list = {
      calendar: {
        type: [],
        group_id: []
      }
    };

    var ltn = $rootScope.$watch(function () {
      return vm.form.calendar.date;
    }, function (newValue, oldValue) {
      if (newValue && oldValue && newValue !== oldValue) {
        vm.list.calendar.min_date = newValue;
        vm.form.calendar.date_end = newValue;
      }
    }, true);

    /**
     * evento de inicialização.
     */
    vm.init = function () {
      vm.getFormInfos();
    };


    /**
     * Resgata todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      AcademicCalendarService.infos()
        .then(function (response) {
          vm.list.calendar.type = response.type;
          vm.list.calendar.type_of_holiday = response.type_of_holiday;
          vm.list.calendar.group_id = response.group_id;
          vm.form.calendar = ModalExtra;
          vm.form.calendar.date = a4Moment(ModalExtra.date).format('YYYY-MM-DD').toDate();
          vm.list.calendar.min_date = a4Moment().startOf('year');
          if (angular.isDefined(vm.form.calendar.date_end)) {
            vm.form.calendar.date_end = a4Moment(ModalExtra.date_end, 'YYYY-MM-DD').toDate();
          } else {
            vm.form.calendar.date_end = null;
          }
          if ($scope.$$phase) {
            $scope.$apply();
          }
        })
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Criação do evento
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        $rootScope.show_loader = true;
        AcademicCalendarService.update(item, item.id)
          .then(function () {
            $rootScope.show_loader = false;
            $rootScope.$broadcast('academic.calendar.list.update');
            vm.cancel();
            Common.Toast.success('Evento de calendário atualizado com sucesso')
          })
          .catch(function (error) {
            Common.Toast.success(error.message);
            $rootScope.show_loader = false;
          })
      }
    };

    vm.init();
    /**
     * Fecha o modal
     */
    vm.cancel = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

  }

  angular
    .module('app.educational.academic-calendar')
    .controller('AcademicCalendarEditController', AcademicCalendarEditController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function AcademicCalendarCreateController($scope, $rootScope, AcademicCalendarService, Common, moment, PoliciesService) {
    var vm = this;

    vm.form = {};
    vm.form.calendar = {};
    vm.form.mode_edit = true;

    vm.list = {
      calendar: {
        type: [],
        group_id: []
      }
    };

    var ltn = $rootScope.$watch(function () {
      return vm.form.calendar.date;
    }, function (newValue, oldValue) {
      if(newValue && oldValue && newValue !== oldValue){
        vm.list.calendar.min_date = newValue;
        vm.form.calendar.date_end = newValue;
      }
    }, true);

    /**
     * Função de inicialização do controlador.
     */
    vm.init = function () {
      vm.getFormInfos();
    };

    /**
     * Resgata todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      AcademicCalendarService.infos()
        .then(function (response) {
          vm.list.calendar = response.plain();
          vm.form.calendar.date = moment().toDate();
          vm.form.calendar.date_end = moment().toDate();
          vm.list.calendar.min_date = vm.form.calendar.date;
          vm.form.calendar.type = 1;
          vm.form.calendar.is_per_group = false;
          vm.form.calendar.type_of_holiday = 1;
        })
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Criação do evento
     */
    vm.submit = function (item, form) {
      if (form.$valid) {
        AcademicCalendarService.store(item)
          .then(function () {
            $rootScope.$broadcast('academic.calendar.list.update');
            Common.Toast.success('Evento de calendário criado com sucesso');
            vm.cancel();
          })
      }
    };

    /**
     * Fecha o modal
     */
    vm.cancel = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();
  }

  angular
    .module('app.educational.academic-calendar')
    .controller('AcademicCalendarCreateController', AcademicCalendarCreateController);

})();

(function () {
  'use strict';

  /** @ngInject*/
  function QuestionnairesService(Restangular, ReportsService) {
    var vm = this;

    vm.getAll = function (obj) {
      return Restangular.one('questionnaire').get(obj);
    };

    vm.createQuestionnaire = function (obj) {
      return Restangular.all('questionnaire').post(obj);
    };

    vm.updateQuestionnaire = function (obj) {
      return Restangular.one('questionnaire', obj.questionnaire.id).customPUT(obj);
    };

    vm.deleteQuestionnaire = function (id) {
      return Restangular.one('questionnaire', id).remove();
    };

    vm.getGradeCodeRules = function () {
      return Restangular.one('gradecode').one('getall').get();
    };

    vm.checkQuestionWithAnswer = function (obj) {
      return Restangular.one('questionnaire').one('checkquestionwithanswer').get(obj);
    };

    vm.getQuestionScales = function () {
      return Restangular.one('questionnaire').one('getquestionscales').get();
    };

    vm.getQuestionnaireEvents = function () {
      return Restangular.one('questionnaire').one('getquestionnaireevents').get();
    };

    vm.createQuestionScale = function (obj) {
      return Restangular.one('questionnaire').all('createquestionscale').post(obj);
    };

    vm.updateQuestionScale = function (obj) {
      return Restangular.one('questionnaire').all('updatequestionscale').post(obj);
    };

    vm.deleteQuestionScale = function (id) {
      return Restangular.one('questionnaire', id).all('deletequestionscale').post();
    };

    vm.getGradeRuleItems = function (obj) {
      return Restangular.one('questionnaire').one('getgraderuleitems').get(obj);
    };

    vm.createQuestionnaireEvent = function (obj) {
      return Restangular.one('questionnaire').all('createquestionnaireevent').post(obj);
    };

    vm.updateQuestionnaireEvent = function (obj) {
      return Restangular.one('questionnaire').all('updatequestionnaireevent').post(obj);
    };
    vm.deleteQuestionnaireEvent = function (obj) {
      return Restangular.one('questionnaire').all('deletequestionnaireevent').post(obj);
    };

    vm.getInfosForQuestionnaire = function () {
      return Restangular.one('questionnaire').one('getinfosforquestionnaire').get();
    };

    vm.getInfoOfQuestionnaire = function (obj) {
      return Restangular.one('questionnaire').one('getinfoofquestionnaire').get(obj);
    };

    vm.getPreview = function (obj) {
      return Restangular.one('questionnaire').all('getpreview').post(obj);
    };

    vm.getEventsForGroup = function (obj) {
      return Restangular.one('questionnaire').one('geteventsforgroup').get(obj);
    };

    vm.getGroupsForList = function (obj) {
      return Restangular.one('questionnaire').one('getgroupsforlist').get(obj);
    };

    vm.getQuestionnaireStatus = function(obj) {
      return Restangular.one('questionnaire').one('getquestionnairestatus').get(obj);
    }

    vm.updateQuestionnaireStatus = function(obj) {
      return Restangular.one('questionnaire').all('updatequestionnairestatus').post(obj);
    }

    vm.getGroupsAndEventsOfQuestionnaire = function (obj) {
      return Restangular.one('questionnaire').one('getgroupsandeventsofquestionnaire').get(obj);
    };

    vm.getItemsWithStudents = function (obj) {
      return Restangular.one('questionnaire').one('getitemswithstudents').get(obj);
    };

    vm.saveAnswer = function (obj) {
      return Restangular.one('questionnaire').all('saveanswer').post(obj);
    };

    vm.createTag = function (obj) {
      return Restangular.one('questionnaire').all('createtag').post(obj);
    };

    vm.getStudentQuestionnaires = function (obj) {
      return Restangular.one('questionnaire').one('getstudentquestionnaires').get(obj);
    };

    vm.getAvailableStudents = function(obj) {
        return Restangular.one('questionnaire').all('getavailablestudents').post(obj);
    }

    vm.getStudentEvaluations = function (obj) {
      return Restangular.one('questionnaire').one('getstudentevaluations').get(obj);
    };

    vm.getQuestionTags = function (obj) {
      return Restangular.one('questionnaire').one('getquestiontags').get(obj);
    };

    vm.searchQuestion = function (obj) {
      return Restangular.one('questionnaire').one('searchquestion').get(obj);
    };

    vm.getQuestion = function (obj) {
      return Restangular.one('questionnaire').one('getquestion').get(obj);
    };

    vm.getEvaluationLink = function (obj) {
      return Restangular.one('questionnaire').one('getevaluationlink').get(obj);
    };

    vm.getEvaluationAnswerInfo = function (obj) {
      return Restangular.one('questionnaire').one('getevaluationanswerinfo').get(obj);
    };

    vm.getInfoForPrintEvaluation = function (obj) {
      return Restangular.one('questionnaire').one('getinfoforprintevaluation').get(obj);
    };

    vm.getAnswersLogByQuestionnaireId = function (obj) {
      return Restangular.one('questionnaire').one('getanswerslog').get(obj);
    };

    vm.getPrintRighAnswer = function (obj) {
      return Restangular.one('questionnaire').one('printAnswerSheet').get(obj)
    };

    vm.answerSingleQuestion = function (obj) {
      return Restangular.one('questionnaire').all('answersinglequestion').post(obj);
    };

    vm.answerQuestionnaire = function (obj) {
      return Restangular.one('questionnaire').all('answer').post(obj);
    };

    vm.startAnswer = function (obj) {
      return Restangular.one('questionnaire').all('startanswer').post(obj);
    };

    vm.saveQuestionFile = function (obj) {
      return Restangular.one('questionnaire').all('savequestionfile').post(obj);
    };

    vm.deleteQuestionFile = function (obj) {
      return Restangular.one('questionnaire').all('deletequestionfile').post(obj);
    };

    vm.getConfig = function (obj) {
      return Restangular.one('questionnaire').one('getconfig').get(obj);
    };

    vm.saveConfig = function (obj) {
      return Restangular.one('questionnaire').all('saveconfig').post(obj);
    };

    vm.activateUnactivate = function (obj) {
      return Restangular.one('questionnaire').all('activateunactivate').post(obj);
    };

    vm.duplicateQuestionnaire = function (obj) {
      return Restangular.one('questionnaire').all('duplicatequestionnaire').post(obj);
    };

    vm.getStudentsByEvaluations = function (id) {
      return Restangular.one('questionnaire').one('getstudentsbyevaluations').get(id);
    };

    vm.submitGradedQuestion = function (obj) {
      return Restangular.one('questionnaire').all('submitgradedquestion').post(obj);
    };

    vm.submitQuestionnairePoints = function (obj) {
      return Restangular.one('questionnaire').all('submitquestionnairepoints').post(obj);
    };

    vm.getAllRegisterFingerprint = function (obj) {
      return Restangular.one('questionnaire').one('getallregisterfingerprint').get(obj);
    };

    vm.deleteDevice = function (obj) {
      return Restangular.one('questionnaire').all('deletedevice').post(obj);
    };

    vm.addDevice = function (obj) {
      return Restangular.one('questionnaire').all('adddevice').post(obj);
    };

    vm.toggleDeviceStatus = function (obj) {
      return Restangular.one('questionnaire').all('toggledevicestatus').post(obj);
    };

    vm.evaluationPrint = function (obj) {
      return ReportsService.reportFactory('GET',
        "api/reports/evaluationprint",
        obj);
    };

    vm.publishQuestionnaire = function(id) {
      return Restangular.one('questionnaire', id).all('publishquestionnaire').post();
    }

    return vm;
  }

  angular
    .module('app.evaluations.questionnaires')
    .factory('QuestionnairesService', QuestionnairesService)
})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.questionnaires', {
        public: false,
        url: '/questionnaires',
        template: '<div ui-view="questionnaires"></div>',
        abstract: true
      })
      .state('private.evaluations.questionnaires.realize', {
      url: '/:questionnaire_id/:group_id/:matrix_period/:event/:person_id',
      params: {
        questionnaire_id: null,
        group_id: null,
        matrix_period: null,
        event: null,
        person_id: null
      },
      public: false,
      views: {
        'questionnaires': {
          templateUrl: 'app/evaluations/questionnaires/views/questionnaire-realize.html',
          controller: 'QuestionnaireRealizeController',
          controllerAs: 'vm'
        }
      }
    })
      .state('private.evaluations.questionnaires.create', {
        url: '/create/:type',
        public: false,
        params: {
          questionnaire: {id: null},
          type: null,
          edit: false,
          items: [],
          groups: [],
          events: [],
          teachers_events: null
        },
        views: {
          'questionnaires': {
            templateUrl: 'app/evaluations/questionnaires/views/questionnaire-page.html',
            controller: 'QuestionnaireModalController',
            controllerAs: 'vm'
          }
        }
      })
      .state('private.evaluations.questionnaires.edit', {
        url: '/{id}/view',
        public: false,
        params: {
          questionnaire: {id: null},
          edit: false,
          tab_selected: null,
          items: [],
          groups: [],
          events: [],
          teachers_events: null
        },
        views: {
          'questionnaires': {
            templateUrl: 'app/evaluations/questionnaires/views/questionnaire-page.html',
            controller: 'QuestionnaireModalController',
            controllerAs: 'vm'
          }
        }
      });
    /**
     * aqui ficará a rota para o back
     */
  }

  angular
    .module('app.evaluations.questionnaires')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function questionnairesList($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        questionnairesType: '=?',
        label: '=?',
        icon: '=?'
      },
      controller: 'QuestionnairesController',
      controllerAs: 'vm',
      templateUrl: 'app/evaluations/questionnaires/views/index.html',
      link: function () {
      }
    }
  }

  angular.module('app.evaluations.questionnaires')
    .directive('questionnairesList', questionnairesList);
})();
(function () {
  'use strict';

  /** @ngInject */
  function QuestionnairesController($a4FloatButton, $document, $scope, $rootScope, $mdMenu, LocalStorage,
                                    $state, CONFIG, Common, QuestionnairesService, ModalFactory, Session,
                                    $http, CourseService, LessonPlanService, $timeout, $q,
                                    PoliciesService, ReportsService, sessionFilterService) {
    var vm = this;
    vm.webLink = CONFIG.webApiUri;
    vm.show_inactive = false;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null,
    };
    vm.current_school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ?
      Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.group_id = null;
    vm.course_id = null;
    vm.subject_id = null;
    vm.questionnaire_id = null;
    vm.questionnaireStatus = [];
    vm.user = Session.getUser();
    vm.company = LocalStorage.get('current_company', "sessionStorage"); 
    vm.current_profile = PoliciesService.currentProfile();
    vm.orderBy = '-creation';
    vm.STUDENTS_EVALUATION = 20;
    vm.SERVICE_UNAVAILABLE = 503;
    vm.KNOWLEDGE_TEST = 2;
    vm.saveTimeout = null;
    vm.company = Session.getCurrentCompany();

    vm.reorder = function (order){
      vm.orderBy = order;
    };

    //Define as opções de filtragem do filtro de status
    vm.questionnaire_status = [
      { id: 'nao_realizado', name: 'Não realizado' },
      { id: 'em_andamento', name: 'Em andamento' },
      { id: 'concluido', name: 'Concluído' }
    ];

    vm.getAll = function (page, limit) {
      $rootScope.show_loader = true;
      vm.group_id = vm.course_id != null ? vm.group_id : null
      vm.subject_id = vm.course_id != null ? vm.subject_id : null
  
      $scope.currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
      $scope.currentTime = new Date().toTimeString().split(' ')[0]; // HH:MM:SS
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;
      QuestionnairesService.getAll({
        limit: limit, page: page,
        questionnaire_type_id: $scope.questionnairesType,
        show_inactive: vm.show_inactive,
        course_id: vm.course_id,
        group_id: vm.group_id,
        subject_id: vm.subject_id,
        questionnaire_status: vm.questionnaire_id
      }).then(function (response) {
        vm.questionnaires = response;
        if (vm.questionnaire_id) {
          console.log(vm.questionnaire_id)
          vm.applyFilter(vm.questionnaire_id); // Aplica o filtro selecionado
        } else {
          vm.questionnaires = vm.questionnaires; // Mostra todos os questionários se não houver filtro selecionado
        }

        $rootScope.show_loader = false;
      })
    };

    vm.loadCourses = function () {
      return CourseService.getAll({only_active: true})
        .then(function (courses) {
          vm.courses = courses;
        });
    };

    vm.applyFilter = function (filterName) {
      vm.questionnaires.data = vm.questionnaires.data.reduce(function (acc, item) {
        if (vm.filters[filterName] && vm.filters[filterName](item)) {
          acc.push(item);
        }
        return acc;
      }, []);
    };

    vm.filters = {
      'Não realizado': function (item) {
        console.log(item)
        const currentDate = $scope.currentDate;
        const currentTime = $scope.currentTime;
        return ((item.application_date > currentDate || (item.application_date == currentDate && currentTime < item.answer_max_time_minutes))) && item.application_date !== null;
      },
      'Em andamento': function (item) {
        const currentDate = $scope.currentDate;
        const currentTime = $scope.currentTime;
        return (item.questionnaire_status === 'Em andamento' || item.questionnaire_status === 'Em andamento (especial)') ||
               (item.application_date == currentDate && item.answer_max_time_minutes < currentTime && item.execution_time > currentTime);
      },
      'Concluído': function (item) {
        console.log(item)
        const currentDate = $scope.currentDate;
        const currentTime = $scope.currentTime;
        return ((item.questionnaire_status === 'Concluído') ||
               (item.application_date < currentDate || (item.application_date == currentDate && currentTime > item.execution_time))) && item.questionnaire_answer_type_id !== "Impresso";
      }
    };

    vm.changeStatusQuestionnaire = function(questionnaire) {
      /*Caso questionnaire seja um objeto com todas as informações de questionário utiliza o questionnaire_status_id que tem dentro dele para o selectedStatus, se não for, questionnaire 
        será um objeto somente com a informação de questionnaire_status_id bastando apenas usar questionnaire como selectedStatus*/
      ModalFactory.custom('app/evaluations/questionnaires/views/change-status-modal.html', {
        questionnaireStatus: vm.questionnaireStatus,
        selectedStatus: angular.isDefined(questionnaire.questionnaire_status_id) ? questionnaire.questionnaire_status_id : questionnaire
      }, true).then(function (data) {
        $rootScope.show_loader = true;
        QuestionnairesService.updateQuestionnaireStatus({
          questionnaire_id: questionnaire.id,
          questionnaire_status_id: data.selectedStatus
        }).then(function(response){
          $rootScope.show_loader = false;
          vm.getAll();
        })

      })
    }

    /** Função responsável por definir o status de um questionário como rascunho (0) ou como pendente (25) */
    vm.approveOrDisapproveQuestionnaire = function(questionnaire_id) {
      ModalFactory.confirm(null,
        "Aprovação de avaliação.",
        "Deseja aprovar essa avaliação? Caso opte por não aprovar agora você ainda poderá aprovar ela no futuro.",
        'Sim', 'Não',
        'evaluations'
      ).then(function() {
        console.log(vm.user)
        console.log(vm.current_profile)
        QuestionnairesService.updateQuestionnaireStatus({
          questionnaire_id: questionnaire_id,
          questionnaire_status_id: 0
        }).then(function () {
          vm.getAll();
          Common.Toast.success('Avaliação aprovada!')
        }) 
      }).catch(function() {
        QuestionnairesService.updateQuestionnaireStatus({
          questionnaire_id: questionnaire_id,
          questionnaire_status_id: 25
        }).then(function () {
          vm.getAll();
          Common.Toast.error('Avaliação não aprovada!')
        }) 
      })
    }

    vm.getSubjectsByCourse = function (course_id) {
      LessonPlanService.getSubjectsByCourse({course_id: course_id}).then(function (response) {
        vm.subjects = response.plain();
      })
    };

    /**
     * Define o filtro por turmas
     * @param course_id
     */
    vm.setGroups = function (course_id) {
      CourseService.getGroupsByCourse(course_id)
        .then(function (groups) {
          //vm.group_id = null;
          vm.groups = groups.data;
        });
    };

    /**
     * Abre modal de criação de questionário
     */
    vm.openCreateModal = function () {
      $state.go('private.evaluations.questionnaires.create', {
        questionnaire: {
          grade_code_rule_id: null, items: [], events: [], questionnaire_type_id: $scope.questionnairesType,
          course_equivalence_id: null,
          questionnaire_event_id: null
        },
        type: $scope.questionnairesType,
        edit: false
      });
      // ModalFactory.customClean('app/evaluations/questionnaires/views/questionnaire-modal.html', 'QuestionnaireModalController',
      //   'vm', false, {
      //     questionnaire: {
      //       grade_code_rule_id: null, items: [], events: [], questionnaire_type_id: $scope.questionnairesType,
      //       course_equivalence_id: null,
      //       questionnaire_event_id: null
      //     },
      //     edit: false
      //   }).then(function (response) {
      //   if (response) {
      //     vm.getAll(1, 15);
      //   }
      // })
    };

    vm.activateUnactivate = function (questionnaire) {
      $rootScope.show_loader = true;
      QuestionnairesService.activateUnactivate({questionnaire_id: questionnaire.id}).then(function () {
        vm.getAll();
        Common.Toast.success("Questionário alterado com sucesso!");
      })
    };


    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Abre o modal de edição de questionário
     * @param item
     */
    vm.openEditModal = function (item) {
      // $rootScope.show_loader = true;
      // QuestionnairesService.getInfoOfQuestionnaire({questionnaire_id: item.id})
      //   .then(function (response) {
      //     var info = response.plain();
      //     $rootScope.show_loader = false;
      $state.go('private.evaluations.questionnaires.edit', {
        id: item.id,
        questionnaire: angular.copy(item),
        edit: true
      });
      // ModalFactory.customClean('app/evaluations/questionnaires/views/questionnaire-modal.html', 'QuestionnaireModalController',
      //   'vm', false, {
      //     questionnaire: angular.copy(item),
      //     edit: true,
      //     items: items,
      //     groups: groups,
      //     events: events,
      //     teachers_events: teachers_events
      //   }).then(function (response) {
      //   if (response) {
      //     vm.getAll(1, 15);
      //   }
      // })
      // });
    };

    vm.getSelectedRespondent = function (respondents) {
      if (angular.isUndefined(respondents[0])) {
        return null;
      }

      if (respondents.length === 1) {
        return respondents[0];
      }

      for (var i = 0; i < respondents.length; i++) {
        if (respondents[i].id === vm.user.id) {
          return respondents[i];
        }
      }

      return respondents[0];
    };

    /**
     * Abre o modal de seleção de turma para preenchimento ou impressão do questionário
     * @param item
     * @param type - 0 : preenchimento - 1 : impressão
     */
    vm.selectGroupForQuestionnaire = function (item, type) {
      $rootScope.show_loader = true;
      QuestionnairesService.getGroupsAndEventsOfQuestionnaire({
        questionnaire_id: item.id
      })
        .then(function (response) {
          var data = response.plain();
          if (data.groups.length > 0) {
            ModalFactory.customClean('app/evaluations/questionnaires/views/questionnaire-select-options-modal.html',
              'QuestionnaireSelectOptionModalController', 'vm', false, {
                groups: data.groups,
                school_period_id: data.school_period_id,
                events: data.events,
                type: type,
                respondents: data.respondents,
                group_selected: data.groups[0].group_matrix_period,
                event_selected: angular.isDefined(data.events[0]) ? data.events[0].id : null,
                respondent_selected: vm.getSelectedRespondent(data.respondents)
              })
              .then(function (answer) {
                var group_id = answer.group_selected.split('-')[0];
                var matrix_period = answer.group_selected.split('-')[1];
                var event = answer.event_selected;
                var student = answer.student;
                var respondent = answer.respondent_selected;
                var filterSelected = answer.filter_selected;
                if (type === 0) {
                  vm.realizeQuestionnaire(item.id, group_id, matrix_period, event, student);
                } else {
                  vm.printQuestionnaire(item.id, group_id, matrix_period, event, student, respondent, filterSelected);
                }
              });
          } else {
            Common.Toast.error('Para realizar um questionário é necessário que ele tenha turmas associadas!');
          }
          $rootScope.show_loader = false;
        })
    };

    vm.printEvaluation = function (questionnaire) {
      $rootScope.show_loader = true;
      QuestionnairesService.getInfoForPrintEvaluation({questionnaire_id: questionnaire.id})
        .then(function (response) {
          $rootScope.show_loader = false;
          var data = response.plain();
          if (data.groups.length > 0) {
            ModalFactory.custom('app/evaluations/questionnaires/views/select-group-or-student.html', {
              data: data,
              selected_group: data.groups[0].group_id,
              selected_persons: [data.students[0].enrolment_period_id],
              option: 0,
              columns_option: 0,
              two_columns: false,
            }).then(function (options) {
              var deffered = Common.$q.defer();
              $rootScope.show_loader = true;
              $http({
                method: 'GET',
                url: vm.webLink + 'api/reports/evaluationprint?token=' + vm.conf.token +
                  +'&company=' + vm.conf.current_company
                  + '&connection=' + vm.conf.current_connection
                  + '&selected_option=' + options.option
                  + '&enrolment_period_ids=' + options.selected_persons.join(',')
                  + '&group_id=' + options.selected_group
                  + '&URI=' + vm.webLink
                  + '&user_id=' + vm.conf.user_id
                  + '&questionnaire_id=' + questionnaire.id
                  + '&selected_column_option=' + options.columns_option
                  + '&two_columns=' + options.two_columns,
                responseType: 'arraybuffer'
              }).then(function (response) {
                var headers = response.headers();
                var status = response.status;
                var data = response.data;

                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');
                try {
                  var blob = new Blob([data], {type: contentType});
                  var url = window.URL.createObjectURL(blob);
                  linkElement.setAttribute('href', url);
                  linkElement.setAttribute('target', '_blank');
                  var clickEvent = new MouseEvent("click", {
                    "view": window, "bubbles": true, "cancelable": false
                  });
                  linkElement.dispatchEvent(clickEvent);
                  deffered.resolve(true);
                  $rootScope.show_loader = false;
                } catch (ex) {
                  deffered.reject(ex);
                  $rootScope.show_loader = false;
                }
              }, function (error) {

              });
              return deffered.promise;
            })

          } else {
            Common.Toast.error('Questionário sem turmas associadas');
          }
        })
    };

    vm.getPrintRightAnswerSheet = function (questionnaireId) {
        ReportsService.reportFactory('GET', 'api/reports/printanswersheet',
          {
            questionnaire_id: questionnaireId,
          })
          .catch(function (response) {
            if(response.status == vm.SERVICE_UNAVAILABLE) {
              Common.Toast.error('Exercício sem respostas cadastradas')
            }
        })

    };

    /**Função de impressão de cartão resposta */
    vm.printReplyCard = function (questionnaireId) {
      ReportsService.reportFactory('GET', 'api/reports/printreplycard',
        {
          questionnaire_id: questionnaireId,
        })
    };

    /** abre modal com log de respostas da prova seleciomnada */
      vm.getAnswersLog = function (questionnaireId, questionnaireName) {
          ModalFactory.customClean('app/evaluations/questionnaires/views/answers-log.html',
            /**@ngInject*/
            'QuestionnaireAnswerLogController', 'vm', true, {'id': questionnaireId, 'name': questionnaireName});
      }
    /**
     * Vai para a tela de realização de questionário
     * @param questionnaire_id
     * @param group_id
     * @param matrix_period
     * @param event
     * @param student
     */
    vm.realizeQuestionnaire = function (questionnaire_id, group_id, matrix_period, event, student) {
      $state.go('private.evaluations.questionnaires.realize', {
        questionnaire_id: questionnaire_id,
        group_id: group_id,
        matrix_period: matrix_period,
        event: event,
        person_id: student === null ? null : student.person_id
      });
    };

    vm.printQuestionnaire = function (questionnaire_id, group_id, matrix_period, event, student, respondent, filterSelected) {
      student = student === null ? null : student.person_id;
      filterSelected === null ? null: filterSelected;

      return ReportsService.reportFactory('GET',
        "api/reports/printquestionnaire",
        {
          questionnaire_id: questionnaire_id,
          group_id: group_id,
          matrix_period: matrix_period,
          event: event,
          person_id: student,
          respondent: respondent,
          filter_selected: filterSelected
        });
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    /**
     * Duplica a avaliação selecionada
     * @param item
     */
    vm.duplicate = function (item) {
      ModalFactory.prompt(null,
        'Duplicar avaliação',
        "Defina um nome para a nova avaliação, caso fique em branco será criado como 'Cópia de " + item.name + "'.",
        'Nome da avaliação',
        null,
        'Salvar',
        'Cancelar',
        'evaluations')
        .then(function (resp) {
          $rootScope.show_loader = true;
          QuestionnairesService.duplicateQuestionnaire({id: item.id, name: resp})
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Avaliação duplicada com sucesso!');
              vm.getAll(1, 15);
            })
            .catch(function () {
              $rootScope.show_loader = false;
              Common.Toast.error('Erro ao duplicar avaliação');
            })
        })
    }

    vm.getQuestionnaireStatus = function() {
      QuestionnairesService.getQuestionnaireStatus().then(function(response){
        vm.questionnaireStatus = response.plain();
      })
    }

    vm.checkProfile = function () {
      vm.is_adm = PoliciesService.currentProfile() === 3 || PoliciesService.currentProfile() === 0;
    };

    vm.init = function () {
      vm.checkProfile();
      
      vm.checkSessionFilters();
      vm.setupFilterWatchers();

      var type = null;
      if ($scope.questionnairesType >= 0 && $scope.questionnairesType <= 2) {
        type = 'knowledge';
      } else {
        type = 'questionnaire';
      }
      //vm.getAll(1, 15);
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.openCreateModal()', label: 'Criar novo questionário', theme: 'evaluations',
        conditional: vm.checkPolicies('evaluations_' + type + '_create')
      });
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
        vm.getQuestionnaireStatus();
    };

    // Verifica se há filtros salvos na sessão
    vm.checkSessionFilters = function () {
      sessionFilterService.initializeWithFilters({
          storageKey: 'questionnaireFilters',
          onFiltersLoaded: function(filters) {
              // Aplicar todos os filtros carregados
              vm.searchText = filters.search || '';
              vm.course_id = filters.course_id || null;
              vm.status = filters.status || null;
              vm.subject_id = filters.subject_id || null;
              vm.group_id = filters.group_id || null;
          },
          onInitialized: function(hasSavedFilters, filters) {
            //Caso os filtros não sejam da company logada retira todos os filtros aplicados pelo registro da sessão.
            if (hasSavedFilters && (filters.company !== vm.company)) {
              vm.searchText = '';
              vm.course_id = null;
              vm.status = null;
              vm.subject_id = null;
              vm.group_id = null;
            }

            if (hasSavedFilters && filters.course_id) {
              return vm.loadCourses().then(function() {
                vm.setGroups(filters.course_id);
                vm.getSubjectsByCourse(filters.course_id);
                vm.getAll(1, 15);
                return true;
              });
            } else {
              vm.getAll(1, 15);
              return $q.resolve(false);
            }
          }
      });
    };

    // Constrói os whatchers em cada propriedade usada em filtros
    vm.setupFilterWatchers = function () {
      
      // Watch em cada propriedade individual
      var propertiesToWatch = ['search', 'course_id', 'status', 'group_id', 'subject_id'];
      
      propertiesToWatch.forEach(function(prop) {
        $scope.$watch('vm.' + prop, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            vm.saveFiltersToSession();
          }
        });
      });
    }

    //Salva filtros na sessão.
    vm.saveFiltersToSession = function() {
      if (vm.saveTimeout) $timeout.cancel(vm.saveTimeout);
      
      vm.saveTimeout = $timeout(function() {
        var filters = {
          search: vm.searchText,
          course_id: vm.course_id,
          status: vm.status,
          group_id: vm.group_id,
          subject_id: vm.subject_id,
          company: vm.company
        };
        
        sessionFilterService.saveFilters(filters, 'questionnaireFilters');
      }, 300);
    }

    vm.correctQuestionnaire = function(item) {
      ModalFactory.customClean('app/evaluations/questionnaires/correct-questionnaire/correct-questionnaire.html',
        'CorrectQuestionnaireController', 'vm', false,
        {
          item: item
        }
    );
      // $state.go('private.educational.students.list');
      // Common.Toast.success("A pagina ainda não está pronta!");
    };

    vm.publishQuestionnaire = function (id) {
      ModalFactory.confirm(null,
        "Publicar questionário",
        "Você deseja que o questionário esteja disponível para os alunos e responsáveis?",
        "Confirmar", "Cancelar", "evaluations")
        .then(function () {
          $rootScope.show_loader = true;
          QuestionnairesService.publishQuestionnaire(id).then(function () {
            Common.Toast.success('Questionário publicado com sucesso');
            $rootScope.show_loader = false;
          });

        })
    }

    vm.init();
  }

  angular.module('app.evaluations.questionnaires')
    .controller('QuestionnairesController', QuestionnairesController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function questionnairesHeaderFooterConfig($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        type: '=?',
      },
      controller: 'QuestionnairesHeaderFooterConfigController',
      controllerAs: 'vm',
      templateUrl: 'app/evaluations/questionnaires/views/questionnaires-header-footer-config.html',
      link: function () {
      }
    }
  }

  angular.module('app.evaluations.questionnaires')
    .directive('questionnairesHeaderFooterConfig', questionnairesHeaderFooterConfig);
})();
(function () {
  'use strict';

  /** @ngInject */
  function QuestionnairesHeaderFooterConfigController($scope, $rootScope, Common, QuestionnairesService, DocumentsService, $location) {
    var vm = this;
    vm.form = {};

    vm.variables = [
      {
        name: '{{Escola_Nome}}',
        presentation: 'Nome da escola'
      }, {
        name: '{{Nome_Questionario}}',
        presentation: 'Nome do questionário'
      }, {
        name: '{{Disciplina_Questionario}}',
        presentation: 'Disciplina do questionário'
      }, {
        name: '{{Etapa_Questionario}}',
        presentation: 'Etapa'
      }, {
        name: '{{Curso_Questionario}}',
        presentation: 'Curso'
      }, {
        name: '{{Turma_Questionario}}',
        presentation: 'Turma'
      }, {
        name: '{{Periodo_Letivo}}',
        presentation: 'Período letivo'
      }, {
        name: '{{Nome_Aluno}}',
        presentation: 'Nome do aluno(a)'
      },
      {
        name: '{{Data_Atual}}',
        presentation: 'Data atual'
      },
    ];
    // Adiciona variáveis de professor respondente e evento condicionalmente baseado no path da página
    if (!$location.path().includes('/knowledge-config')) {
      vm.variables.push(
        {
          name: '{{Nome_Professor}}',
          presentation: 'Nome do professor'
        },
        {
          name: '{{Nome_Evento}}',
          presentation: 'Nome do evento'
        }
      );
    }

    vm.tinymceOptions = {
      inline: false,
      entity_encoding: "raw",
      plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks ' +
        'visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc ' +
        'insertdatetime advlist lists wordcount imagetools textpattern noneditable charmap emoticons textcolor',
      skin: 'lightgray',
      theme: 'modern',
      fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
      menubar: 'file edit view format tools help forecolor backcolor',
      toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | ' +
        'alignleft aligncenter alignright alignjustify | outdent indent | insertfile image media template link anchor codesample |',
      toolbar_sticky: true,
      color_cols: 5,
      file_picker_callback: function (cb, value, meta) {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.onchange = function () {
          var file = this.files[0];
          var reader = new FileReader();
          reader.onload = function (event) {
            DocumentsService.uploadFile({
              file: {
                photo: event.target.result,
                format: file.type.split('/')[1]
              }
            }).then(function (response) {
              cb(response.upload, {title: file.name});
            });
          };
          reader.readAsDataURL(file);
        };

        input.click();
      },
      color_map: [
        '#BFEDD2', 'Light Green',
        '#FBEEB8', 'Light Yellow',
        '#F8CAC6', 'Light Red',
        '#ECCAFA', 'Light Purple',
        '#C2E0F4', 'Light Blue',

        '#2DC26B', 'Green',
        '#F1C40F', 'Yellow',
        '#E03E2D', 'Red',
        '#B96AD9', 'Purple',
        '#3598DB', 'Blue',

        '#169179', 'Dark Turquoise',
        '#E67E23', 'Orange',
        '#BA372A', 'Dark Red',
        '#843FA1', 'Dark Purple',
        '#236FA1', 'Dark Blue',

        '#ECF0F1', 'Light Gray',
        '#CED4D9', 'Medium Gray',
        '#95A5A6', 'Gray',
        '#7E8C8D', 'Dark Gray',
        '#34495E', 'Navy Blue',

        '#000000', 'Black',
        '#ffffff', 'White'
      ],
      height: 200,
    };

    vm.font_styles = [
      "'Arial', sans-serif",
      "'Sans-Serif'",
      "'Comic Sans MS', cursive, sans-serif",
      "'Times New Roman', Times, serif",
      "'Courier New', Courier, monospace",
      "'Verdana', Geneva, sans-serif",
      "'Trebuchet MS', Helvetica, sans-serif",
      "'Arial Black', Gadget, sans-serif",
      "'Impact', Charcoal, sans-serif",
      "'Bookman', serif",
      "'Garamond', serif",
      "'Palatino', 'Palatino Linotype', 'Book Antiqua', serif",
      "'Georgia', serif"
    ];

    vm.font_sizes = [
      '8', '9', '10', '11', '12', 
      '14', '16', '18', '20', '22', 
      '24', '26', '28', '36', '48', 
      '72'
    ];

    vm.tinymceOptionsHeader = angular.copy(vm.tinymceOptions);
    vm.tinymceOptionsHeader.setup = function (editor) {
      vm.editorHeader = editor;
    };
    vm.tinymceOptionsFooter = angular.copy(vm.tinymceOptions);
    vm.tinymceOptionsFooter.setup = function (editor) {
      vm.editorFooter = editor;
    };

    vm.saveConfig = function () {
      $rootScope.show_loader = true
      QuestionnairesService.saveConfig({
        config: vm.form,
        type: $scope.type
      }).then(function () {
        $rootScope.show_loader = false;
        Common.Toast.success('Configurações salvas com sucesso!');
      });
    };

    /**
     * Inverte string
     * @param string
     * @returns {*}
     */
    vm.reverseString = function (string) {
      return string.split('').reverse().join('');
    };

    vm.setVariable = function (item, type) {
      if (type === 'header') {
        vm.editorHeader.insertContent(item.name);
      } else {
        vm.editorFooter.insertContent(item.name);
      }

      // var regex = new RegExp("<body>(.|\n)*?</body>");
      // if (vm.form[type].match(regex) !== null) {
      //   var string = vm.reverseString(vm.form[type].match(regex)[0].replace("</body>", '').replace("<body>", ''));
      //   string = "<body>" + vm.reverseString(string.replace(">p/<", '')) +
      //     " " + item.name + "</p> </body>";
      //   vm.form[type] = vm.form[type].replace(regex, string);
      // } else {
      //   vm.form[type] += ' ' + item.name;
      // }
    };

    vm.init = function () {
      $rootScope.show_loader = true;
      QuestionnairesService.getConfig({type: $scope.type}).then(function (response) {
        vm.form = response.plain();
        $rootScope.show_loader = false;
      })
    };

    vm.init();

  }

  angular.module('app.evaluations.questionnaires')
    .controller('QuestionnairesHeaderFooterConfigController', QuestionnairesHeaderFooterConfigController);
})
();
(function () {
  'use strict';

  /** @ngInject */
  function QuestionnaireSelectOptionModalController(ModalExtra, GroupsService, $rootScope, $mdDialog) {
    var vm = this;
    vm.filter_selected = 0;
    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };
    vm.scope = {};
    vm.scope.groups = ModalExtra.groups;
    vm.scope.events = ModalExtra.events;
    vm.scope.respondents = ModalExtra.respondents;
    vm.scope.group_selected = ModalExtra.group_selected;
    vm.scope.event_selected = ModalExtra.event_selected;
    vm.scope.respondent_selected = null;
    vm.scope.student = null;
    vm.type = ModalExtra.type;

    vm.setGroupsIds = function () {
      vm.groups_ids = [];
      for (var i = vm.scope.groups.length; i--;) {
        vm.groups_ids.push(vm.scope.groups[i].id);
      }
    };
    vm.setGroupsIds();
    vm.getStudentsByGroup = function (text) {
      return GroupsService.getStudentsByGroup({
        query: text,
        group_id: vm.groups_ids.join(','),
        filter: vm.filter_selected,
        student_questionnaire: true
      })
    };

    vm.answer = function (answer) {
      vm.scope.filter_selected = vm.filter_selected;
      if (vm.filter_selected === 0) {
        vm.scope.group_selected = vm.scope.student.group_id + '-' + vm.scope.student.matrix_period;
      }
      $mdDialog.hide(answer);
    };
  }

  angular.module('app.evaluations.questionnaires')
    .controller('QuestionnaireSelectOptionModalController', QuestionnaireSelectOptionModalController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function QuestionnaireRealizeController($state, $rootScope, $timeout, Common, ModalFactory, QuestionnairesService, Session) {
    var vm = this;
    vm.is_questionnaire = true;
    vm.show_answers = true;
    vm.questionnaire_type = false;
    vm.filter = {
      group_id: $state.params.group_id,
      matrix_period: $state.params.matrix_period,
      questionnaire_id: $state.params.questionnaire_id,
      event: $state.params.event,
      person_id: $state.params.person_id,
      user_id: Session.user.id
    };
    vm.init = function () {
      var user = Session.getUser();
      vm.user_id = user.id
      $rootScope.show_loader = true;
      QuestionnairesService.getItemsWithStudents(vm.filter).then(function (response) {
        vm.questionnaires = response.plain();
        vm.index = 0;
        vm.selected_questionnaire = vm.questionnaires[vm.index];
        vm.questionnaire_type = vm.questionnaires[vm.index].questionnaire_info.questionnaire_type_id;
        $rootScope.show_loader = false;
      });
    };

    vm.formatMultipleOptionsQuestions = function (questions) {
      questions.forEach(function (question) {
        if (question.question_type_id === 'XM') {
          question.items.forEach(function (item) {
            item.right_answer = [];
            question.options.forEach(function (option) {
              if (angular.isDefined(item[option.ord]) && item[option.ord]) {
                item.right_answer.push(option.ord);
              }
            })
          });
        }
      });
      return questions;
    };

    /*Caso o formulário já esteja respondido, não devem haver alterações salvas, o sistema apenas
    *passará para o próximo aluno ou sairá da pagina de realização do questionário.
    */
    vm.quitOrGoToNext = function (goToNext) {
      if (goToNext) {
        $timeout(function () {
          vm.index++;
          vm.selected_questionnaire = vm.questionnaires[vm.index];
          $rootScope.show_loader = false;
          Common.Toast.success('Redirecionando para o próximo aluno.');
        }, 1000);
      } else {
        Common.Toast.success('Voltando para a lista de avaliações.');
        $rootScope.show_loader = false;
        $state.go('private.evaluations.students-evaluation');
      }
    }

    vm.submit = function (goToNext) {
      $rootScope.show_loader = true;
      vm.selected_questionnaire.user_id = Session.user.id;
      vm.selected_questionnaire.person_id = vm.selected_questionnaire.id;
      vm.selected_questionnaire.questions = vm.formatMultipleOptionsQuestions(vm.selected_questionnaire.questions);
      vm.selected_questionnaire.questionnaire_event_item_id = vm.filter.event;
      QuestionnairesService.answerQuestionnaire(vm.selected_questionnaire).then(function (response) {
        if (response) {
          if (goToNext) {
            $timeout(function () {
              vm.index++;
              vm.selected_questionnaire = vm.questionnaires[vm.index];
              $rootScope.show_loader = false;
              Common.Toast.success('Resposta salva com sucesso!');
            }, 1000);
          } else {
            Common.Toast.success('Resposta salva com sucesso!');
            $rootScope.show_loader = false;
            $state.go('private.evaluations.students-evaluation');
          }
        }
      })
    };

    vm.init();
  }

  angular.module('app.evaluations.questionnaires')
    .controller('QuestionnaireRealizeController', QuestionnaireRealizeController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function QuestionnaireModalController($rootScope, $scope, $timeout, Common, QuestionnairesService, $window, ModalFactory,
                                        PersonService, PoliciesService, Session, SubjectService, $stateParams, LocalStorage, $state, a4Moment, moment) {
    var vm = this;

    vm.TESTES_E_PROVAS = 2;

    vm.show_question_fab = null;
    vm.form = $stateParams.questionnaire;
    vm.original_questionnaire_answer_type_id = angular.isUndefined($stateParams.questionnaire.questionnaire_answer_type_id) ?
      null : $stateParams.questionnaire.questionnaire_answer_type_id;
    vm.items = angular.isUndefined($stateParams.questionnaire.items) ? [] : $stateParams.questionnaire.items;
    vm.events = angular.isUndefined($stateParams.questionnaire.events) ? [] : $stateParams.questionnaire.events;
    vm.groups = angular.isUndefined($stateParams.questionnaire.groups) ? [] : $stateParams.questionnaire.groups;
    vm.teachers_events = angular.isUndefined($stateParams.questionnaire.teachers_events) ? [] : $stateParams.questionnaire.teachers_events;
    vm.availableStudents = [];
    vm.is_teacher = PoliciesService.isTeacher() || PoliciesService.isGroupCoordinator();
    vm.gradeRuleItems = [];
    vm.grade_rule_item_selected = null;
    vm.selectedTime = null;
    vm.selectedDate = null;
    vm.is_question = false;
    vm.execution_time = null;
    vm.select_students = false;
    vm.is_edit = $stateParams.edit;
    vm.show_loading = false;
    vm.types = {
      0: ' avaliação para o banco de questões',
      1: ' avaliação para listas de exercícios',
      2: ' avaliação para testes e provas',
      20: ' questionário para avaliação de alunos',
      21: ' questionário para avaliação psicopedagógica',
      22: ' questionário para avaliação de professores',
      23: ' questionário para pesquisas gerais'
    };
    vm.isDisabled = false;
    vm.title = vm.types[parseInt($stateParams.type)];
    vm.options = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'strikeThrough', 'underline', 'ul', 'ol'],
      ['undo', 'clear', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'clear', 'insertImage', 'insertLink']
    ];
    vm.grade_code_rules = [];
    vm.grid = {
      data: [],
      rows: []
    };

    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.enableQuestionFab = function () {
      vm.show_question_fab = 1
    };

    vm.disableQuestionFab = function () {
      vm.show_question_fab = 0
    };
    /**
     * Adiciona novo item ao questionário
     */
    vm.addItem = function () {
      var questionNumber = vm.items.filter(function (p) { return p.question_type_id !== 'SP' });

      var item = {
        stem: '',
        notes: '',
        image_checkbox: false,
        question_type_id: 'QU',
        right_answer: null,
        ord: vm.items.length + 1,
        question_number: questionNumber.length + 1,
        subject_id: vm.form.subject_id,
        questionnaire_type_id: vm.form.questionnaire_type_id,
        course_equivalence_id: vm.form.course_equivalence_id,
        items: [],
        tags: [],
        artifact_id: null,
        file_reference: null,
        isDisabled: vm.isDisabled
      };
      vm.items.push(item);

      /** Coloca o focus no título da nova questão adicionada */
      $timeout(function () {
        angular.element('.stem-' + item.ord).find('input').first().focus();
      }, 100)
    };

    vm.addItemSeparator = function () {

      var item = {
        stem: '',
        notes: '',
        image_checkbox: false,
        question_type_id: 'SP',
        subject_id: vm.form.subject_id,
        ord: vm.items.length + 1,
        questionnaire_type_id: vm.form.questionnaire_type_id,
        course_equivalence_id: vm.form.course_equivalence_id,
        items: [],
        tags: [],
        artifact_id: null,
        file_reference: null,
        isDisabled: false
      };
      vm.items.push(item);

      $timeout(function () {
        angular.element('.stem-' + item.ord).find('input').first().focus();
      }, 100)
    };

    /**
     * Adiciona subitem
     * @param question
     */
    vm.addOption = function (question) {
      if (angular.isUndefined(question.items)) {
        question.items = [];
      }
      var option = {
        name: '',
        ord: question.items.length,
        is_right_answer: false
      };
      question.items.push(option);

      /** Coloca o focus na nova alternativa adicionada */
      $timeout(function () {
        angular.element('.question-' + question.ord).find('input').last().focus();
      }, 100);
    };

    /**
     * Quando é selecionada a opçaõ 'Lista de opções' e a lista
     * de subitens do item está vazia, adiciona o primeiro subitem
     * @param item
     */
    vm.addFirstOption = function (item) {
      if (item.items.length === 0) {
        vm.addOption(item);
      }
    };

    vm.importItem = function () {

      ModalFactory.customClean('app/evaluations/questionnaires/views/import-question.html', 'ImportQuestionModalController',
        'vm', false, {
          questionnaire: angular.copy(vm.form),
          items: vm.form.items,
          items_ids: vm.items_ids
        }).then(function (questions) {
        questions.forEach(function (question) {
          var questionNumber = vm.items.filter(function (p) { return p.question_type_id !== 'SP' });
          vm.items_ids.push(question.id);
          if (question.question_id_origin !== null) {
            vm.items_ids.push(question.question_id_origin);
          }
          vm.items.push({
            stem: question.stem,
            notes: question.notes,
            image_checkbox: question.image_checkbox,
            question_id_origin: question.id,
            question_type_id: question.question_type_id,
            right_answer: question.right_answer,
            ord: vm.items.length + 1,
            question_number: questionNumber.length + 1,
            subject_id: vm.form.subject_id,
            questionnaire_type_id: vm.form.questionnaire_type_id,
            course_equivalence_id: vm.form.course_equivalence_id,
            items: question.items,
            file_reference: question.file_reference,
            artifact_id: question.artifact_id,
            tags: question.tags,
            is_canceled: question.is_canceled
          });
        })
      })
    };

    /**
     * Insere/remove uma turma na lista de turmas do questionário ao clicar no checkbox correspondente
     * @param group_id
     * @param group
     */
    vm.insertOrRemoveGroup = function (group_id, group) {
      if (vm.groups.includes(group_id)) {
        vm.groups.splice(vm.groups.indexOf(group_id), 1);
      } else {
        vm.groups.push(group_id);
        if (angular.isUndefined(group.events) || group.events == null || group.events.length === 0) {
          vm.getEventsForGroup(group);
        }
      }

      vm.getGradeRuleItemsForGroups(vm.groups);
      vm.getAvailableStudents(vm.groups);
    };

    vm.grid.rows.forEach(function(student) {
      student.selected = student.status === 0; // Define o estado de seleção com base no status
    });

    vm.selectStudents = function(students) {
      students.forEach(function (student) {
        if(!angular.isDefined(student.status_name)) {
          student.status_name = 'indisponível';
          student.status = -1;
        }
        if(student.status === 0) {
          student.selected = true;
        }

      });
    };

    /**
     * função de selecionar os alunos caso queira que apenas alguns expecificos façam a prova
     */
    vm.toggleStudent = function(student, index) {
      if ((student.status === 0 || student.status === -1) || angular.isUndefined(student.status)) {
        student.status = student.status === 0 ? -1 : 0;
        student.status_name = student.status_name === 'Pendente' ? 'indisponível' : 'Pendente';
      }
    };


    vm.getAvailableStudents = function (groups) {
      QuestionnairesService.getAvailableStudents({
        groups: groups,
        grade_rule_item: vm.grade_rule_item_selected.name ,
        subject_id: vm.form.subject_id,
        original_questionnaire_answer_type_id: vm.original_questionnaire_answer_type_id,
        questionnaire_id: angular.isDefined(vm.form.id) ? vm.form.id : null
      })
        .then(function (response) {
          vm.grid.rows = response.plain();
      })
    }

    vm.getEventsForGroup = function (group) {
      if (vm.form.questionnaire_type_id === 2) {
        vm.show_loading = true;
        QuestionnairesService.getEventsForGroup({
          group_id: group.group_id.split('-')[0],
          matrix_period: group.matrix_period
        })
          .then(function (response) {
            group.events = response.plain();
            vm.show_loading = false;
          });
      }
    };

    vm.getGradeRuleItemsForGroups = function (groups) {
      $rootScope.show_loader = true;
      QuestionnairesService.getGradeRuleItems({ groups: groups })
        .then(function (gradeRuleItems) {
          vm.gradeRuleItems = gradeRuleItems.plain();
          $rootScope.show_loader = false;
        });
    };

    vm.getSelectedGroups = function (groups) {
      var selected_groups = [];
      for (var z = vm.courses_and_groups.length; z--;) {
        for (var y = vm.courses_and_groups[z].groups.length; y--;) {
          for (var i = groups.length; i--;) {
            if (vm.courses_and_groups[z].groups[y].group_id === groups[i]) {
              selected_groups.push(vm.courses_and_groups[z].groups[y]);
            }
          }
        }
      }
      return selected_groups;
    };

    vm.submit = function (backpage) {
      console.log(backpage);
      if(vm.grade_rule_item_selected !== null) {
        vm.form.grade_rule_item_id = vm.grade_rule_item_selected.id;
        vm.form.grade_rule_item_name = vm.grade_rule_item_selected.name;
        vm.form.total_points = vm.grade_rule_item_selected.max_grade;
      }
      vm.form.execution_time = vm.execution_time;
      vm.form.answer_max_time_minutes = vm.selectedTime;
      vm.form.application_date = vm.selectedDate !== null
        ? a4Moment(vm.selectedDate).format('YYYY-MM-DD') : null;
      var obj = {
        questionnaire: vm.form,
        items: vm.items,
        events: vm.events,
        groups: vm.getSelectedGroups(vm.groups),
        questionnaire_persons: vm.grid.rows
      };
      $rootScope.show_loader = true;


      if (angular.isDefined($stateParams.id) && $stateParams.id !== null) {
        QuestionnairesService.updateQuestionnaire(obj).then(function () {
          Common.Toast.success('Questionário atualizado com sucesso!');
          if (backpage) {
            QuestionnairesService.getInfoOfQuestionnaire({questionnaire_id: vm.form.id})
              .then(function (response) {
                var info = response.plain();
                vm.grid.rows = info.available_students;
                vm.items = info.items;
                vm.items_ids = info.items_ids;

                vm.items.forEach(function(item) {
                  if (item.image_size < 0) {
                    item.image_checkbox = true;
                    item.image_size = Math.abs(item.image_size);
                  } else if (item.image_size > 0) {
                    item.image_checkbox = false;
                  }
                });

                $rootScope.show_loader = false
              })
          } else {
            vm.backPage();
          }
        }).catch(function (err) {
          Common.Toast.error(err.data.message);
          $rootScope.show_loader = false;
        });
      } else {
        QuestionnairesService.createQuestionnaire(obj).then(function () {
          Common.Toast.success('Questionário criado com sucesso!');
          vm.backPage();
        }).catch(function (err) {
          Common.Toast.error(err.data.message);
          $rootScope.show_loader = false;
        });
      }
    };


    vm.enterPressed = function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();

        return vm.addItem();
      }
    };

    /**
     * Filtra os cursos que possuem a disciplina selecionada na grade corrente
     * @param subject_id
     */
    vm.filterCourses = function (subject_id) {
      vm.show_loading = true;
      SubjectService.getCoursesWithSubject({ subject_id: subject_id }).then(function (response) {
        var used_courses = response.plain();
        vm.courses_and_groups = vm.courses_and_groups.filter(function (course) {
          var course_has_subject = false;
          used_courses.forEach(function (course_with_subject) {
            if (course_with_subject === course.course_id) {
              course_has_subject = true;
            }
          });
          return course_has_subject;
        });
        if (subject_id !== vm.form.subject_id) {
          vm.form.subject_id = subject_id;
        }
        vm.show_loading = false;
      })
    };

    vm.filterCourseEquivalence = function (course_equivalence_id) {
      vm.filterSubjects(course_equivalence_id);
      vm.courses_and_groups = vm.original_courses_and_groups.filter(function (course) {
        return course.course_equivalence_id === course_equivalence_id;
      });
    };

    vm.filterSubjects = function (course_equivalence_id) {
      vm.show_loading = true;
      SubjectService.getSubjectsWithEquivalence({ course_equivalence_id: course_equivalence_id }).then(function (subjects) {
        vm.form_info.subjects = subjects.plain();
        vm.show_loading = false;
      })
    };

    /**
     * Seta os eventos e professores selecionados para cada turma, caso existam.
     */
    vm.adjustGroups = function () {
      vm.original_courses_and_groups.forEach(function (course) {
        course.groups.forEach(function (group) {
          if (vm.is_edit) {
            vm.teachers_events.forEach(function (item) {
              if (group.group_id === item.group_id) {
                group.person_id_respondent = item.person_id_respondent;
                group.grade_rule_item_id = item.grade_rule_item_id;
                group.publish_start_date = item.publish_start_date;
                group.publish_last_date = item.publish_last_date;
                vm.getEventsForGroup(group);
              }
            })
          } else {
            group.person_id_respondent = null;
            group.grade_rule_item_id = null;
          }
        })
      })
    };



    /**
     * Tratamento  dos minutos TODO: adicionar o tratamento para minutos usando o A4Moment
     */
    vm.formatMinutes = function (time) {
      var minutes = moment.duration(time, 'minutes');
      var formated_time = moment.utc(minutes.asMilliseconds()).format('HH:mm:ss');
      return formated_time
    };

    vm.getGroupsForList = function (questionnaire_id) {
      $rootScope.show_loader = true;
      QuestionnairesService.getGroupsForList({ questionnaire_id: questionnaire_id }).then(function (response) {
        vm.original_courses_and_groups = angular.copy(response.courses);
        vm.adjustGroups();
        vm.courses_and_groups = angular.copy(vm.original_courses_and_groups);
        if (vm.is_edit && vm.form.subject_id !== null) {
          vm.filterCourses(vm.form.subject_id);
        }
        if (vm.is_edit && vm.form.course_equivalence_id !== null) {
          vm.filterCourseEquivalence(vm.form.course_equivalence_id);
        }
        vm.school_period = response.school_period;
        $rootScope.show_loader = false;
      });
    };

    vm.getQuestionnairePersons = function (questionnaire_id) {
      QuestionnairesService.getQuestionnairePersons({ questionnaire_id: questionnaire_id })
        .then(function (response) {
          vm.form.questionnaire_persons = response.plain();
        });
    }

    vm.getAcademicTypeOfCompany = function () {
      return Session.companies.find(function (company) {
        return company.id === Session.current_company;
      })
    };

    vm.init = function () {
      if (angular.isDefined($stateParams.id) && $stateParams.id !== null) {
        vm.is_edit = true;
      }
      vm.academic_type = vm.getAcademicTypeOfCompany().academic_type;

      if (angular.isDefined($stateParams.id) && $stateParams.id !== null) {

        QuestionnairesService.getInfoOfQuestionnaire({ questionnaire_id: $stateParams.id })
          .then(function (response) {
            var info = response.plain();
            vm.form = info.questionnaire;
            vm.online_questionnaire_done = info.online_questionnaire_done;
            vm.items = info.items;
            vm.items_ids = info.items_ids;
            vm.events = info.events;
            vm.groups = info.groups;
            vm.teachers_events = info.teachers_events;
            vm.grid.rows = info.available_students;
            vm.questionnaire_persons = info.questionnaire_persons;
            vm.selectedDate = a4Moment(info.questionnaire.application_date);
            vm.grade_rule_item_selected = info.grade_rule_item !== null ? info.grade_rule_item[0] : null;
            vm.execution_time = vm.formatMinutes(info.questionnaire.execution_time);
            vm.selectedTime = vm.formatMinutes(info.questionnaire.answer_max_time_minutes);
            $scope.$applyAsync();

            vm.items.forEach(function(item) {
              if (item.image_size < 0) {
                item.image_checkbox = true;
                item.image_size = Math.abs(item.image_size);
              } else if (item.image_size > 0) {
                item.image_checkbox = false;
              }
            });

            $rootScope.show_loader = false;
            vm.getGroupsForList($stateParams.id);
            vm.getGradeRuleItemsForGroups(vm.groups);
            vm.current_tab = $stateParams.tab_selected == null ? 0 : $stateParams.tab_selected;
          });


      } else {

        vm.form = (angular.isUndefined(LocalStorage.get('question_form')) || LocalStorage.get('question_form') === null)
        || (angular.isDefined(vm.form.questionnaire_type_id) && vm.form.questionnaire_type_id !== null) ?
          vm.form : LocalStorage.get('question_form');
        LocalStorage.add('question_form', vm.form);
        vm.items_ids = [];
        vm.getGroupsForList($stateParams.id);
      }

      QuestionnairesService.getInfosForQuestionnaire().then(function (response) {
        vm.form_info = response.plain();
      });
      PersonService.getTeachers().then(function (response) {
        vm.teachers = response.plain();

        //Acrescenta um valor para zerar a informação do campo caso seja necessário.
        vm.teachers.unshift({
          id: null,
          name: 'Professor indefinido'
        });

      })
    };

    vm.backPage = function () {
      if(angular.isDefined(vm.form.questionnaire_type_id) && vm.form.questionnaire_type_id === 1) {
        //volta para Lista de exercicios
        $state.go('private.evaluations.exercises-list');
      } else if (angular.isDefined(vm.form.questionnaire_type_id) && vm.form.questionnaire_type_id === 2) {
        //volta para a pagina de testes e provas
        $state.go('private.evaluations.knowledge-test');
      } else if (angular.isDefined(vm.form.questionnaire_type_id) && vm.form.questionnaire_type_id === 20) {
        //volta para a pagina de aval. infantil
        $state.go('private.evaluations.students-evaluation');
      } else {
        //volta para a pagina de banco de questoes
        $state.go('private.evaluations.questions-repository');
      }
    };

    vm.clickActions = function (item, option) {
      switch (option) {
        case 'correct':
          vm.correctQuestionnaire(item);
          break;
        default:
      }
    };
    vm.correctQuestionnaire = function (item) {
      if (item.status < 10) {
        ModalFactory.alert(
          "Avaliação ainda não pode ser corrigida",
          "Este aluno ainda não concluiu a avaliação",
          "modal", "Ok", "false", "evaluations"
        );

      } else {
        $rootScope.show_loader = true;
        QuestionnairesService.getEvaluationLink({
          person_id: item.person_id,
          questionnaire_id: vm.form.id,
          group_id: item.group_id,
          matrix_period: item.matrix_period,
          cookie: 'is_allowed'
        }).then(function (link) {
          $rootScope.show_loader = false;
          var token = link.split('answer-questionnaire\/')[1];
          $state.go('public.answer-questionnaire', {
            token: token
          });
        })
      }
    };

    vm.applyGrade = function (gri_name) {
      ModalFactory.confirm(null,
        "Incorporar notas ao evento",
        "Atenção, ao clicar em Concluir, as notas serão distribuidas para o evento:  " + gri_name,
        'Concluir', 'Cancelar',
        'evaluations'
      ).then(function () {
        QuestionnairesService.submitQuestionnairePoints({
          questionnaire_id: vm.form.id,
          group_id: vm.groups,
          subject_id: vm.form.subject_id});
      }).then(function () {
        Common.Toast.success("Notas atualizadas com sucesso");
      });
    };

    vm.isInformationsTabValid = function() {
      // Campos obrigatórios base
      var isBaseValid = (vm.form.name && vm.form.subject_id);
      
      // Validação específica para "Testes e Provas"
      var isTestOrExam = (vm.form.questionnaire_type_id === vm.TESTES_E_PROVAS);
      var isAnswerTypeValid = (isTestOrExam) ? vm.form.questionnaire_answer_type_id !== undefined : true;
    
      // Validação para questionários de evento (se aplicável)
      var isEventValid = (vm.form.questionnaire_type_id >= 20) ? vm.form.questionnaire_event_id : true;
    
      return isBaseValid && isAnswerTypeValid && isEventValid;
    };

    vm.init();

  }

  angular.module('app.evaluations.questionnaires')
    .controller('QuestionnaireModalController', QuestionnaireModalController);
})();

(function () {
    'use strict';
  
    /** @ngInject */
    function QuestionnaireAnswerLogController($mdDialog, ModalExtra, QuestionnairesService) {
        var vm = this;
        vm.questionnaire_id = ModalExtra.id;
        vm.questionnaire_name = ModalExtra.name;
        vm.person_id = null;
        vm.selected_students = null;

        vm.init = function () {
            vm.getAnswerslog();
        };

        vm.getAnswerslog = function (persons) {
            QuestionnairesService.getAnswersLogByQuestionnaireId({'questionnaire_id': vm.questionnaire_id, 'persons': JSON.stringify(persons)})
            .then(function(response) {
              vm.answers_log = response.plain()[0];
              vm.students = response.plain()[1];
            });
        };

        vm.close = function () {
          $mdDialog.cancel();
        };

        vm.init();
} 
    angular.module('app.evaluations.questionnaires')
      .controller('QuestionnaireAnswerLogController', QuestionnaireAnswerLogController);
  })();
(function () {
  'use strict';

  /** @ngInject */
  function ImportQuestionModalController(ModalExtra, GroupsService, $rootScope, $mdDialog, QuestionnairesService,
                                         $mdConstant, Common) {
    var vm = this;
    vm.filter_selected = 0;
    vm.type = ModalExtra.type;
    vm.selected = [];
    vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    vm.stem = null;
    vm.tags = [];

    vm.init = function () {
      vm.questionnaire = ModalExtra.questionnaire;
      vm.items_ids = ModalExtra.items_ids;
      vm.searchQuestion();
    };

    /**
     * Busca de questão a partir do enunciado ou etiqueta
     * @returns {*}
     */
    vm.searchQuestion = function () {
      vm.search_tags = '';
      vm.tags.forEach(function (tag) {
        if (vm.search_tags.length === 0) {
          vm.search_tags += tag.name;
        } else {
          vm.search_tags += ',' + tag.name;
        }
      })
      vm.promise = QuestionnairesService.searchQuestion({
        query: vm.stem,
        tags: vm.search_tags,
        items_ids: vm.items_ids.join(','),
        questionnaire_id: vm.questionnaire.id,
        subject: vm.questionnaire.subject_id,
        questionnaire_type: vm.questionnaire.questionnaire_type_id,
        course_equivalence: vm.questionnaire.course_equivalence_id
      })
        .then(function (resp) {
          vm.questions = resp.plain();
        });
    }

    vm.getQuestionTags = function (query) {
      return QuestionnairesService.getQuestionTags({query: query});
    }

    vm.transformChip = function (chip) {
      if (angular.isObject(chip)) {
        return chip;
      }
      Common.Toast.warning('Só é possível buscar por etiquetas já criadas');
      return null;
    }

    vm.answer = function (questions) {
      $mdDialog.hide(questions);
    }

    vm.closeModal = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular.module('app.evaluations.questionnaires')
    .controller('ImportQuestionModalController', ImportQuestionModalController);
})();
(function () {
  'use strict';
  angular.module('app.evaluations.questionnaire-events', [])
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.questionnaire-events', {
        url: '/questionnaire-events',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/questionnaire-events/views/questionnaire-events.html',
        controller: 'QuestionnaireEventsController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.questionnaire-events')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'questionnaires';
    var path = 'eval-configurations.questionnaire-events';

    msNavigationService.saveItem(path, {
      title: 'Etapas',
      icon: 'icon-server',
      state: 'private.evaluations.questionnaire-events',
      weight: 18,
      auth: role,
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.questionnaire-events')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function QuestionnaireEventsController($a4FloatButton, $scope, $rootScope, Common, QuestionnairesService, ModalFactory) {
    var vm = this;
    vm.events = [];

    vm.getEvents = function () {
      $rootScope.show_loader = true;
      QuestionnairesService.getQuestionnaireEvents().then(function (response) {
        vm.events = response.plain();
        $rootScope.show_loader = false;
      })
    };

    vm.addEventItem = function (items) {
      items.push({
        id: null,
        name: '',
        alias: '',
        ord: items.length + 1
      });
    };

    vm.createEvent = function () {
      ModalFactory.custom('app/evaluations/questionnaire-events/views/modal.html', {
        addRow: vm.addEventItem,
        questionnaire_event_items: [],
        is_edit: false,
        can_delete: true
      }).then(function (event) {
        $rootScope.show_loader = true;
        QuestionnairesService.createQuestionnaireEvent(event).then(function () {
          Common.Toast.success("Etapa de questionário criado com sucesso!");
          vm.getEvents();
        })
      })
    };

    vm.editEvent = function (item) {
      item.is_edit = true;
      item.addRow = vm.addEventItem;
      ModalFactory.custom('app/evaluations/questionnaire-events/views/modal.html', angular.copy(item)).then(function (event) {
        $rootScope.show_loader = true;
        QuestionnairesService.updateQuestionnaireEvent(event).then(function () {
          Common.Toast.success("Etapa de questionário atualizado com sucesso!");
          vm.getEvents();
        })
      })
    };

    vm.deleteEvent = function (item){
      ModalFactory.confirm(null,
        item.name,
        'Tem certeza que deseja excluir a etapa ' + item.name + '?',
        'Confirmar',
        'Cancelar',
        'evaluations').then(function () {
        $rootScope.show_loader = true;
        QuestionnairesService.deleteQuestionnaireEvent(item).then(function () {
          Common.Toast.success("Etapa removida com sucesso!");
          vm.getEvents();
        })
      })
    };

    vm.init = function () {
      vm.getEvents();
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.createEvent()', label: 'Criar nova etapa', theme: 'evaluations'
      });
    };

    vm.init();

  }

  angular.module('app.evaluations.questionnaire-events')
    .controller('QuestionnaireEventsController', QuestionnaireEventsController);
})();
(function () {
  'use strict';

  angular.module('app.evaluations.question-scales', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.question-scales', {
        url: '/question-scales',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/question-scales/views/question-scales.html',
        controller: 'QuestionScalesController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.question-scales')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'questionnaires';
    var path = 'eval-configurations.question-scales';

    msNavigationService.saveItem(path, {
      title: 'Escalas de matriz',
      icon: 'icon-group',
      state: 'private.evaluations.question-scales',
      weight: 17,
      auth: role,
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.question-scales')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function QuestionScalesController($a4FloatButton, $scope, $rootScope, Common, ModalFactory, QuestionnairesService) {
    var vm = this;
    vm.scales = [];

    vm.init = function () {
      vm.getQuestionScales();
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.createScale()', label: 'Criar nova escala', theme: 'evaluations'
      });
    };

    vm.getQuestionScales = function () {
      $rootScope.show_loader = true;
      QuestionnairesService.getQuestionScales().then(function (response) {
        vm.scales = response.plain();
        $rootScope.show_loader = false;
      })
    };

    vm.createScale = function () {
      ModalFactory.custom('app/evaluations/question-scales/views/modal.html', {
        scale: {
          name: null,
          question_scale_items: [],
          addRow: vm.addScaleRow,
          moveUp: vm.moveUp,
          moveDown: vm.moveDown
        },
        is_edit: false
      }).then(function (new_scale) {
        $rootScope.show_loader = true;
        QuestionnairesService.createQuestionScale(new_scale).then(function () {
          Common.Toast.success("Escala criada com sucesso!");
          vm.getQuestionScales();
        })
      })
    };

    vm.editScale = function (scale) {
      scale.addRow = vm.addScaleRow;
      scale.moveUp = vm.moveUp;
      scale.moveDown = vm.moveDown;
      scale.question_scale_id = scale.id;
      ModalFactory.custom('app/evaluations/question-scales/views/modal.html', {
        scale: scale,
        is_edit: true
      }).then(function (updated_scale) {
        QuestionnairesService.updateQuestionScale(updated_scale).then(function () {
          Common.Toast.success("Escala atualizada com sucesso!");
          vm.getQuestionScales();
        })
      });
    };

    vm.deleteScale = function (item) {
      ModalFactory.confirm(null,
        item.name,
        'Tem certeza que deseja excluir esta escala?',
        'Confirmar',
        'Cancelar',
        'evaluations').then(function () {
        $rootScope.show_loader = true;
        QuestionnairesService.deleteQuestionScale(item.id).then(function () {
          Common.Toast.success("Escala removida com sucesso!");
          vm.getQuestionScales();
        })
      })
    };

    /**
     * Move elemento de um array para uma posição acima
     * @param array
     * @param index
     */
    vm.moveUp = function (array, index) {
      var element = array[index];
      if (index !== 0) {
        array.splice(index, 1);
        array.splice(index - 1, 0, element);
      } else {
        array.splice(index, 1);
        array.splice(array.length, 0, element);
      }
    };

    /**
     * Move elemento de um array para uma posição abaixo
     * @param array
     * @param index
     */
    vm.moveDown = function (array, index) {
      var element = array[index];
      if (index !== array.length - 1) {
        array.splice(index, 1);
        array.splice(index + 1, 0, element);
      } else {
        array.splice(index, 1);
        array.splice(0, 0, element);
      }
    };

    vm.addScaleRow = function (scale) {
      scale.question_scale_items.push({
        name: '',
        alias: ''
      });
    };

    vm.init();

  }

  angular.module('app.evaluations.question-scales')
    .controller('QuestionScalesController', QuestionScalesController);
})();
(function () {
  'use strict';

  angular.module('app.evaluations.device-register', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ModalEditDeviceController(ModalExtra, $rootScope, $mdDialog, QuestionnairesService, a4Moment) {
    var vm = this;
    vm.device = ModalExtra.device;
    vm.toggleDeviceStatus = function () {
      $rootScope.show_loader = true;
      $mdDialog.cancel().then(function () {
        QuestionnairesService.toggleDeviceStatus({name: vm.device.name, is_allowed: vm.device.is_allowed})
          .then(function () {
            $rootScope.$broadcast('PAGINATE');
          })
      });
    };

    vm.deleteDevice = function () {
      vm.expiration_time = a4Moment('1970-01-01', 'YYYY-MM-DD').toDate().toUTCString();
      $rootScope.show_loader = true;
      $mdDialog.cancel().then(function () {
        QuestionnairesService.deleteDevice({device_name: vm.device.name})
          .then(function () {
            document.cookie = 'registered_device =; expires=' + vm.expiration_time;
            $rootScope.$broadcast('PAGINATE');
          })
      })
    };

    vm.closeModal = function () {
      $mdDialog.cancel()
    };


  }

  angular.module('app.evaluations.device-register')
    .controller('ModalEditDeviceController', ModalEditDeviceController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function ModalAddDeviceController(Session, $rootScope, a4Moment, $mdDialog, QuestionnairesService, Common) {
    var vm = this;
    vm.expiration_time = a4Moment().add(5, 'year').toDate().toUTCString();
    vm.is_allowed = true;
    vm.cookie = document.cookie.split('=')[1];

    vm.init = function () {
    };

    vm.addDevice = function () {
      $rootScope.show_loader = true;
      $mdDialog.cancel().then(function () {
        QuestionnairesService.addDevice({
          device_name: vm.device_name,
          is_allowed: vm.is_allowed,
          user_id: Session.user.id,
          fingerprint: navigator.userAgent + navigator.language +  window.resolution,
          cookie: vm.cookie})
          .then(function (response) {
            document.cookie = 'registered_device=' + response + '; expires=' + vm.expiration_time;
            $rootScope.$broadcast('PAGINATE');
          }).catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data.message);
        });
      })
    };

    vm.closeModal = function () {
      $mdDialog.cancel();
    };


    vm.init();
  }

  angular.module('app.evaluations.device-register')
    .controller('ModalAddDeviceController', ModalAddDeviceController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.device-register', {
        url: '/device-register',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/device-register/views/device-register.html',
        controller: 'DeviceRegisterController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.device-register')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    var role = 'questionnaires';
    var path = 'eval-configurations.device-register';

    msNavigationService.saveItem(path, {
      title: 'Registro de dispositivo',
      icon: 'icon-cog',
      state: 'private.evaluations.device-register',
      weight: 17,
      auth: role,
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations.device-register')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function DeviceRegisterController(QuestionnairesService, ModalFactory, $mdDialog, Session, $rootScope, $scope, Common, a4Moment) {
    var vm = this;

    var ltn = $rootScope.$on('PAGINATE', function () {
      vm.getAllRegisterFingerprint();
    });

    vm.init = function () {
      vm.getAllRegisterFingerprint();
    };

    vm.getAllRegisterFingerprint = function () {
      QuestionnairesService.getAllRegisterFingerprint()
        .then(function (response) {
          vm.devices = response.plain();
          $rootScope.show_loader = false;
        })
    };



    vm.openModal = function(option, device) {
      if (option === 0) {
        ModalFactory.customClean("app/evaluations/device-register/views/add-device-modal.html",
          'ModalAddDeviceController', "vm", false, {})
      } else if (option === 1) {
        ModalFactory.customClean("app/evaluations/device-register/views/device-modal.html",
          'ModalEditDeviceController'
          , "vm", false, {device: device})
      }
    };


    vm.init();

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

  }

  angular.module('app.evaluations.device-register')
    .controller('DeviceRegisterController', DeviceRegisterController);
})();
(function () {
  'use strict';

  angular
    .module('app.evaluations.dashboard', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.evaluations.dashboard', {
        url: '/dashboard',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/evaluations/dashboard/dashboard.html',
        controller: 'DashboardEvaluationsController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.evaluations.dashboard')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('evaluations.dashboard', {
      title: 'Dashboard',
      icon: 'icon-window-restore',
      state: 'private.evaluations.dashboard',
      class: "md-primary",
      weight: 1
    });
  }

  angular
    .module('app.evaluations.dashboard')
    .run(run);

})();






(function () {
  'use strict';

  /** @ngInject */
  function DashboardController() {
    var vm = this;
    vm.init = function () {
    };

    vm.init();
  }

  angular
    .module('app.evaluations.dashboard')
    .controller('DashboardEvaluationsController', DashboardController);

})();
(function () {
  'use strict';


  angular
    .module('app.controlpanel.unification', [])
    

})();

(function () {
  'use strict';

  /** @ngInject */
  function UnificationService(Restangular) {

    var vm = this;

    vm.verifyDuplicated = function () {
      return Restangular.one('unification').one('all').get();
    };

    /**
     * Unifica item selecionado
     */
    vm.unificate = function (obj) {
      return Restangular.one('unification').all('one').post(obj);
    };

    return vm;

  }

  angular
    .module('app.controlpanel.unification')
    .factory('UnificationService', UnificationService);


})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.controlpanel.unification', {
        url: '/unification',
        auth: 'ctl_dash',
        public: false,
        templateUrl: 'app/controlpanel/unification/index.html',
        controller: 'UnificationController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.controlpanel.unification')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject*/
  function UnificationController($rootScope, UnificationService, Common, ModalFactory) {
    var vm = this;

    vm.duplicated = [];

    /**
     * Unifica um item selecionado
     */
    vm.unificate = function (item, index) {
      ModalFactory.confirm(null,
        'Unificar Pessoa',
        'Após confimar, aguarde o encerramento da unificação, pode levar alguns minutos',
        'Unificar', "Cancelar", 'controlpanel')
        .then(function () {
          $rootScope.show_loader = true;
          UnificationService.unificate(item)
            .then(function () {
              Common.Toast.success("Pessoa Unificada");
              /** Remove o item unificado do array */
              vm.duplicated.splice(index, 1);
              $rootScope.show_loader = false;
            })
            .catch(function (error) {
              Common.Toast.warning(error.data.message)
              $rootScope.show_loader = false;
            });
        })


    };

    /**
     * Verifica se existem pessoas duplicadas no banco
     */
    vm.verifyDuplicated = function () {
      ModalFactory.confirm(null,
        'Verificar existência de duplicatas',
        'Após confimar, aguarde o encerramento da recuperação dos dados, pode levar alguns minutos',
        'Buscar', "Cancelar", 'controlpanel')
        .then(function () {
          $rootScope.show_loader = true;
          UnificationService.verifyDuplicated()
            .then(function (response) {
              $rootScope.show_loader = false;
              vm.duplicated = response.plain();
            })
            .catch(function () {
              $rootScope.show_loader = false;
            })
        })
    }
  }

  angular
    .module('app.controlpanel.unification')
    .controller('UnificationController', UnificationController)
})();
(function () {
  'use strict';

  function UsersController($rootScope, $scope, EducationalService, Session, $a4FloatButton, Common, ReportsService,
                           ModalFactory, RolesService, PersonService, LocalStorage, CONFIG, $timeout) {

    var vm = this;
    $scope.roleSelected = null;
    vm.roleSelected = [];
    vm.school_periods = [];
    vm.school_period_selected = 'null';
    vm.doubleclick = false;
    vm.show_password = false;
    vm.check = false;
    vm.profile = LocalStorage.get(CONFIG.storage.profile);
    vm.is_suport = Session.user.email == 'suporte@simetrianet.com.br';
    vm.user_status_selected = 'null';

    vm.userStatus = [
      {id: 1, name: 'Convidado'},
      {id: 10, name: 'Ativa'},
      {id: 11, name: 'Senha temporária'},
      {id: 20, name: 'Bloqueada'},
      {id: 21, name: 'Inativo'}
    ]


    vm.init = function () {
      vm.getSchoolPeriods();
      vm.getAllRoles();
      vm.getAllUsers(1);
    };


    vm.getSchoolPeriods = function () {
      EducationalService.getSchoolsPeriod(Session.get('current_company', "sessionStorage"))
        .then(function (periods) {
          vm.school_periods = periods.plain();
          $rootScope.show_loader = false;
        })
    };

    /**
     * Busca todos os recursos de um determinado usuário.
     */
    vm.getAllRoles = function () {
      $rootScope.show_loader = true;
      RolesService.getAllRoles()
        .then(function (response) {
          vm.roles = response.plain();
          vm.profiles = [];
          /**
           * Manipula array para o select
           */
          for (var i = 0; i < vm.roles.length; i++) {
            if (vm.roles[i].id === 2 || vm.roles[i].id === 6 || vm.roles[i].id === 1 || vm.roles[i].id === 7 || vm.roles[i].id === 4) {
              var element = angular.copy(vm.roles[i]);
              var index = angular.copy(i);
              vm.roles.splice(index, 1);
              i--;
              vm.profiles.push(element);
            }
          }

          for (var z = vm.profiles.length; z--;) {
            if (vm.profiles[z].id === 6) {
              vm.profiles[z].name = 'Colaboradores';
            }
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Retorna todos os usuários disponíveis
     * IMPORTANTE: lembrar que essa funcao
     * tambem 'e chamada no paginate da view
     */
    vm.getAllUsers = function (page, limit) {
      vm.query = $scope.search;
      $rootScope.show_loader = true;
      if(vm.check) {
        $timeout(function() {
          vm.getAllPersons(page, limit, vm.query, vm.roleSelected)
        }, 0);
      } else {
        RolesService.getAllUsers({
          page: page, limit: 50, role: vm.roleSelected, query: angular.isUndefined(vm.query) ? $scope.search : vm.query,
          school_period: vm.school_period_selected, user_status: vm.user_status_selected
        })
          .then(function (response) {
            vm.users = response.plain();
            for (var i = 0; vm.users.data.length > i; i++) {
              switch (vm.users.data[i].status) {
                case 1:
                  vm.users.data[i].status_name = 'Pendente';
                  break;
                case 10:
                  vm.users.data[i].status_name = 'Ativo';
                  break;
                case 11:
                  vm.users.data[i].status_name = 'Migrado';
                  break;
                case 20:
                  vm.users.data[i].status_name = 'Bloqueado';
                  break;
                case 21:
                  vm.users.data[i].status_name = 'Inativo';
                  break;
                case null:
                  vm.users.data[i].status_name = 'Inativo';
                  break;
              }

              /** Formatação da lista de papéis dos usuários */
              vm.users.data[i].roles = vm.users.data[i].roles !== '{}' && vm.users.data[i].roles !== null ?
                (vm.users.data[i].roles).replace('{', '').replace('}', '').replace(/,/g, ', ').replace(/"/g, '').replace(/Alunos/g, 'Aluno').replace(/Responsáveis/g, 'Responsável')
                : '{}';
            }
            $rootScope.show_loader = false;
          })
          .catch(function () {
            Common.Toast.error("Erro ao listar usuários.", 'A4 Web');
            $rootScope.show_loader = false;
          })
      }
    };

    vm.printUsers = function () {
      ReportsService.reportFactory('GET', 
        'api/reports/printUsers',
        {
          role: vm.roleSelected, 
          query: angular.isUndefined(vm.query) ? $scope.search : vm.query,
          school_period: vm.school_period_selected, 
          user_status: vm.user_status_selected
        }).catch(function () {
          Common.Toast.error("Ocorreu um erro na impressão do relatório")
        })
    }

    vm.getAllPersons = function (page, limit, query, role) {
      PersonService.getAllPersons({page: page, limit: limit,  query: query, role: role})
      .then(function (response) {
      vm.users = response.plain();
      for (var i = 0; vm.users.data.length > i; i++) {
        switch (vm.users.data[i].status) {
          case 1:
            vm.users.data[i].status_name = 'Pendente';
            break;
          case 10:
            vm.users.data[i].status_name = 'Ativo';
            break;
          case 11:
            vm.users.data[i].status_name = 'Migrado';
            break;
          case 20:
            vm.users.data[i].status_name = 'Bloqueado';
            break;
          case 21:
            vm.users.data[i].status_name = 'Inativo';
            break;
          case null:
            vm.users.data[i].status_name = 'Inativo';
            break;
        }
      }
      $rootScope.show_loader = false;
    })
    }

    /** Funcao de modificar os logins de email para
     * numero de matricula(aluno) ou cpf(responsavel)
     * TODO: precisa ser otimizada desse jeito esta horrivel 
     */
    vm.changepasswordforraiodesol = function () {
      PersonService.changePasswordForRaioDeSol();
    };

    vm.activeUsers = function () {
      RolesService.activeUsers({
        school_period_id: vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod(),
        is_parent: false       
      }).then(function (){
        Common.Toast.success("Rotina realizada com sucesso! Recarregue a pagina pra ver o resultado");
      })
    }

    /**
     * Abre um modal para criação/edição de um usuário
     */
    vm.createUser = function () {
      var userNew = {};
      userNew.user_role = [];
      ModalFactory.customClean("app/controlpanel/roles/views/newUser.html", "UserCreateEditController", "vm", false, {
        user: userNew,
        roles: vm.roles,
        toggle: vm.toggleCheck,
        checked: vm.checked
      }).then(function (confirm) {
        if (confirm) {
          Common.Toast.success("Usuário criado com sucesso!");
        }
        vm.getAllUsers(1, vm.roleSelected);
      }).catch(function (error) {
        Common.Toast.error(error.message);
        $rootScope.show_loader = false;
      });
    };

    /**
     * @param ev
     * @param user
     */
    vm.updateUser = function (ev, user) {
      if(angular.isUndefined(user.user_id)) {
        user.user_id = user.id;
      }
      vm.doubleclick = true;
      user = vm.getUserById(user.id);
      RolesService.getAllRoles()
        .then(function (response) {
          vm.rolesUser = response.plain();
          RolesService.getUserRoleByUserId({id: user.user_id})
            .then(function (userRoles) {
              $rootScope.show_loader = false;
              user.user_role = userRoles.plain();
              ModalFactory.customClean("app/controlpanel/roles/views/editUser.html", "UserCreateEditController", "vm", false, {
                user: user,
                roles: vm.rolesUser,
                toggle: vm.toggleCheck,
                isContained: vm.isContained,
                checked: vm.checked,
                verifyPasswords: vm.verifyPasswords
              })
                .then(function (confirm) {
                  vm.doubleclick = false;
                  vm.getAllUsers(1, vm.roleSelected);
                  Common.Toast.success("Atualização realizada com sucesso!");
                })
                .catch(function (error) {
                  vm.doubleclick = false;
                  vm.getAllUsers(1, vm.roleSelected);
                  Common.Toast.error(error.data.message);
                });
            })
            .catch(function () {
              vm.doubleclick = false;
            })
        })
        .catch(function () {
          vm.doubleclick = false;
        });
    };

    /**
     * Executa a modificação de senha de um determinado usuário.
     * @param user_id - identificador do usuário.
     */
    vm.changePassword = function (user_id) {
      ModalFactory.custom("app/controlpanel/roles/views/changePassword.html")
        .then(function (user) {
          user.id = user_id;
          RolesService.changePassword(user)
            .then(function () {
              Common.Toast.success('Senha modificada com sucesso');
              $rootScope.show_loader = false;
            })
            .catch(function () {
              $rootScope.show_loader = false;
            });
        });
    };

    vm.editEmail = function (user) {
      ModalFactory.prompt(
        null,
        'Editar e-mail',
        'Ao modificar este e-mail o usuário perderá o acesso ao sistema, sendo necessário realizar novamente a ativação da conta.',
        'E-mail',
        user.email,
        'Confirmar',
        'Cancelar',
        'controlpanel')
        .then(function (email) {
          vm.changeEmail({
            email: email,
            id: user.id,
            ask_email: angular.isDefined(user.ask_email) ? user.ask_email : false
          }, user);
        })
    };

    vm.changeEmail = function (obj, user) {
      $rootScope.show_loader = true;
      RolesService.changeEmail(obj)
        .then(function () {
          $rootScope.show_loader = false;
          ModalFactory.alert(
            "E-mail atualizado com sucesso",
            "Foi enviado um e-mail ao novo endereço para que o usuário possa realizar a reativação da conta.",
            "modal", "Ok", "false", "controlpanel"
          ).then(function () {
            vm.getAllUsers(1, vm.roleSelected, $scope.search);
          });
        }).catch(function (error) {
        $rootScope.show_loader = false;
        if (error.data.messages === 'EMAIL_EXISTS') {
          //Existem pessoas com esse email já cadastrado!
          ModalFactory.open("email-exists", null, "PersonController", {
            persons: error.data.persons,
            selected: user.name
          }, null, 'finance', null, null, null, null, false)
            .then(function (response) {
              obj.replace_email = true;
              obj.ask_email = true;
              vm.changeEmail(obj);
            });
        }
      })
    };

    /**
     * Busca a regra do usuário pelo identificador do usuário.
     * @param user_id - identificador do usuário
     */
    vm.getUserRoleByUserId = function (user_id) {
      RolesService.getUserRoleByUserId({id: user_id})
        .then(function (response) {
          vm.userRoles = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Busca o usuário pelo seu identificador
     * @param user_id - identificador do usuário
     * @returns {*}
     */
    vm.getUserById = function (user_id) {
      if (user_id !== undefined) {
        var result = null;
        angular.forEach(vm.users.data, function (user, i) {
          if (user.id === user_id) {
            result = user;
            vm.getUserRoleByUserId(user.id);
          }
        });
        return result;
      }
    };

    vm.init();

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      });
      vm.floatButton.destroy();
    })
  }

  angular
    .module('app.roles')
    .controller('UsersController', UsersController)
})();
(function () {
  'use strict';

  function UserCreateEditController($rootScope, Common, ModalExtra, RolesService, Session, ModalFactory) {
    var vm = this;
    vm.isCollaborator = false;
    vm.user = angular.copy(ModalExtra.user);
    vm.companyEdit = Session.get('current_company', "sessionStorage");
    vm.blocked = vm.user.status === 20;
    vm.roles = ModalExtra.roles;
    vm.editable = true;
    vm.itensSelected = [];


    vm.init = function () {
      RolesService.getCompanys().then(function (response) {
        vm.companys = response.plain();
      });

      if (vm.user.status === 10) {
        vm.is_active = true;
      } else {
        vm.is_active = false;
      }
    };

    vm.changeCompany = function () {
      RolesService.getUserRoleByUserId({
        id: vm.user.id,
        company_id: vm.companyEdit,
        changeCompany: 1
      })
        .then(function (userRoles) {
          vm.user.user_role = userRoles.plain();
        });
    };
    /**
     *
     * @param user
     */
    vm.update = function (user, close) {
      user.type = 1;
      // user.is_employee = true;
      user.is_user = true;
      user.user_role = vm.itensSelected;
      user.companyEdit = vm.companyEdit;
      user.ask_email = angular.isDefined(user.ask_email) ? user.ask_email : false;
      if (vm.blocked === true) {
        user.status = 20;
      } else if (!vm.is_active && user.status !== 20) {
        user.status = null;
      } else if (user.status === 20 || vm.is_active) {
        user.status = 10;
      }
      RolesService.updateUser(user)
        .then(function () {
          if (close) {
            vm.closeModal(true);
          } else {
            Common.Toast.success('Salvo com sucesso');
          }
        })
        .catch(function (error) {
          if (error.data.messages === 'EMAIL_EXISTS') {
            //Existem pessoas com esse email já cadastrado!
            ModalFactory.open("email-exists", null, "PersonController", {
              persons: error.data.persons,
              selected: user.name
            }, null, 'finance', null, null, null, null, false)
              .then(function (response) {
                user.replace_email = true;
                user.ask_email = true;
                vm.update(user, close);
              });
          }
          error.data.message = error.data.messages === 'EMAIL_EXISTS' ? 'E-mail já existente' : error.message;
          if (close) {
            vm.closeModal(error);
          } else {
            Common.Toast.error(angular.isUndefined(error.data.message) ? error : error.data.message);
          }
        });
    };

    vm.setIsCollaborator = function () {
      for (var i = 0; i < vm.user.user_role.length; i++) {
        if (vm.user.user_role[i].id === 6) {
          vm.isCollaborator = true;
          break;
        }
      }
    };

    /**
     * Criação de um novo usuário
     * @param user
     * @param form
     */
    vm.saveNewUser = function (user, form) {
      if (form.$valid) {
        vm.loading = true;
        user.type = 1;
        user.is_employee = true;
        user.is_user = true;
        user.user_role = vm.itensSelected;
        RolesService.saveNewUser(user)
          .then(function () {
            vm.loading = false;
            vm.closeModal(true);
          })
          .catch(function (error) {
            vm.loading = false;
            Common.Toast.error(error.message || error.data.message);
          })
      }
    };

    /**
     * Verifica os itens selecionados no Select multiplo
     * @param role_user_list
     * @param role_id
     * @return {boolean}
     */
    vm.isContained = function (role_user_list, role_id) {
      role_id = parseInt(role_id);
      if (role_id != null && role_user_list !== null && role_user_list.length > 0) {
        var result = false;
        angular.forEach(role_user_list, function (item) {
          if (item != null && item.id === role_id) {
            result = true;
          }
        });

        return result;
      }
    };


    /**
     * Fecha modal
     */
    vm.closeModal = function (data) {
      $rootScope.$broadcast("ModalFactory.close", data);
    };

    vm.setIsCollaborator();
    vm.init();

  }

  angular
    .module('app.roles')
    .controller('UserCreateEditController', UserCreateEditController)

})();

(function () {
  'use strict';

  /** @ngInject*/
  function RolesService(Restangular) {
    var vm = {};

    vm.getAllRoles = function () {
      return Restangular.one('usergroup').all('getall').getList();
    };

    vm.getAllResouces = function () {
      return Restangular.all('usergroup').customGET('', {resources: true});
    };

    vm.deleteRole = function (role) {
      return Restangular.one('usergroup', role.id).remove();
    };

    vm.confirmPassword = function (obj) {
      return Restangular.one('users').all('confirmpassword').post(obj);
    };

    vm.saveNewRole = function (role) {
      return Restangular.all('usergroup').post(role);
    };

    vm.getById = function (id) {
      return Restangular.one('usergroup').one('getbyid', id).get();
    };

    vm.getResourcesTree = function () {
      return Restangular.one('usergroup').one('getresourcestree', false).get();
    };

    vm.updateRole = function (role) {
      return Restangular.one('usergroup', role.id).customPUT(role);
    };

    vm.getAllUsers = function (obj) {
      return Restangular.one('users').one('getalluserperson').get(obj);
    };

    vm.getAllLogUsers = function (obj) {
      return Restangular.one('users').one('getalllogusers').get(obj);
    };

    vm.getUserRoleByUserId = function (obj) {
      return Restangular.one('users').one('getuserrolebyid').get(obj);
    };

    vm.getUserRoleModule = function (user_id, sys_user_role_id, company_id) {
      return Restangular.one('users').one('getuserrolemodules').get({
        user_id: user_id,
        sys_user_role_id: sys_user_role_id,
        company_id: company_id
      });
    };

    vm.saveNewUser = function (user) {
      return Restangular.all('person').post(user);
    };

    vm.updateUser = function (user) {
      return Restangular.one('person', user.id).customPUT(user);
    };

    vm.roleHasUser = function (role_id) {
      return Restangular.one('usergroup').one('hasuser', role_id).get();
    };

    vm.changePassword = function (obj) {
      return Restangular.one('users', obj.id).all('changePassword').post(obj);
    };

    vm.activeUsers = function (obj) {
      return Restangular.one('users').one('activate', obj.school_period_id, obj.is_parent).get(obj);
    };

    vm.changeEmail = function (obj) {
      return Restangular.one('users', obj.id).all('changeemail').post(obj);
    };

    vm.getCompanysForUser = function (obj) {
      return Restangular.one('users').one('getcompanysforuser').get(obj);
    };

    vm.createPersonCompany = function (obj) {
      return Restangular.one('users').all('createpersoncompany').post(obj);
    };

    vm.getCompanys = function (obj) {
      return Restangular.one('company').one('getall').get(obj);
    };

    return vm;

  }

  angular.module('app.roles')
    .factory('RolesService', RolesService);

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.controlpanel.users', {
        url: '/users',
        public: false,
        templateUrl: 'app/controlpanel/roles/views/index.html',
        controller: 'UsersController',
        controllerAs: 'vm'
      })
    .state('private.controlpanel.manageroles', {
      url:'/manageroles',
      public: false,
      templateUrl: 'app/controlpanel/roles/views/manage.html',
      controller: 'RolesController',
      controllerAs: 'vm'
    });
  }

  angular
    .module('app.roles')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function RolesController($rootScope, $scope, $a4FloatButton, RolesService, Common, ModalFactory, $filter) {

    var vm = this;

    vm.roles = [];
    vm.role = {};
    $rootScope.show_loader = false;

    vm.selected = [];

    /**
     * Evento disparado apenas quando as views estão carregadas
     */
    var ltn = $scope.$on('$viewContentLoaded', function () {
      vm.getAllRoles();
      vm.getAllResources();
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.openModalRole($event, null);', theme: 'controlpanel',
        label: 'Criar nova regra'
      });
    });

    vm.toggleCheck = function (item, list) {
      var check = $filter('filter')(list, {id: item.id})[0];
      if (check !== undefined) {
        var idx = list.map(function (check) {
          return check.id;
        }).indexOf(check.id);
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    };

    vm.checked = function (item, list) {
      var check = $filter('filter')(list, {id: item.id})[0];
      if (check !== undefined) {
        return true;
      }
    };

    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    /**
     * Verifica igualdade entre as senha digitadas
     * @param password - Campo de senha
     * @param repeat_password - Campo de validação da senha
     * @returns {boolean}
     */
    vm.verifyPasswords = function (password, repeat_password) {
      if (password === repeat_password) {
        return true;
      }
      return false;
    };

    /**
     * Busca todos os recursos de um determinado usuário.
     */
    vm.getAllRoles = function () {
      $rootScope.show_loader = true;

      RolesService.getAllRoles()
        .then(function (response) {
          vm.roles = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Remove uma regra de usuário.
     * @param role - identificador da regra
     */
    vm.deleteRole = function (role) {
      RolesService.deleteRole(role)
        .then(function () {
          Common.Toast.success("Deletado com sucesso!");
          vm.getAllRoles();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Executa a validação de uma deleção de uma regra, caso tenha usuário com esta regra é pedida uma confirmação.
     * @param role - objeto da regra em questão.
     */
    vm.roleHasUser = function (role) {
      RolesService.roleHasUser(role.id)
        .then(function (response) {
          if (response) {
            ModalFactory.confirm(null, 'Exclusão de regra', "Este papel contém usuários associados, remover mesmo assim?", 'Confirmar',
              'Cancelar', 'controlpanel')
              .then(function () {
                vm.deleteRole(role)
              });
          } else {
            ModalFactory.confirm(null, 'Exclusão de regra', "Deseja remover realmente esta regra?", 'Confirmar',
              'Cancelar', 'controlpanel')
              .then(function () {
                vm.deleteRole(role)
              });
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error("Erro ao deletar!");
          $rootScope.show_loader = false;
        })
    };


    vm.getAllResources = function () {
      $rootScope.show_loader = true;
      RolesService.getAllResouces()
        .then(function (response) {
          vm.resources = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.getById = function (id) {
      if (id !== undefined) {
        return RolesService.getById(id);
      }
    };
    /**
     * Abre um modal para criação/edição de um papel
     *
     * @param ev
     * @param role
     */
    vm.openModalRole = function (ev, role) {
      if (role != null) {
        vm.getById(role.id)
          .then(function (response) {
            ModalFactory.open("roles/editRole", ev, "RolesController", {
              role: response,
              resources: response.resources
            }, 'finance').then(function (response) {
              vm.update(response);
            });
            $rootScope.show_loader = false;
          })
      } else {
        ModalFactory.open("roles/newRole", ev, "RolesController", {
          resources: vm.resources
        }, 'finance').then(function (role) {
          if (role.resources === undefined) {
            role.resources = [];
          }
          vm.addNewRole(role);
          $rootScope.show_loader = false;
        })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }
    };


    /**
     * Atualiza a regra de usuário
     * @param role - Regra de usuário
     */
    vm.update = function (role) {
      RolesService.updateRole(role)
        .then(function () {
          Common.Toast.success("Edição realizada com sucesso!");
          vm.getAllRoles();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Adiciona uma nova regra de usuário
     * @param role - Objeto da regra de usuário do front
     */
    vm.addNewRole = function (role) {
      RolesService.saveNewRole(role)
        .then(function () {
          Common.Toast.success("Salvo com sucesso!");
          vm.getAllRoles();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error("Erro ao salvar!");
          $rootScope.show_loader = false;
        })

    };


    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      });
      vm.floatButton.destroy();
    })

  }

  angular
    .module('app.roles')
    .controller('RolesController', RolesController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ProfileService(Restangular) {

    var getProfileById = function (id) {
      return Restangular.one('person', id).get();
    };

    return {
      getProfileById: getProfileById
    };

  }

  angular
    .module('app.controlpanel.profile')
    .factory('ProfileService', ProfileService);

})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.controlpanel.profile', {
        url: '/profile',
        public: false,
        auth: 'ctl_dash',
        templateUrl: 'app/controlpanel/profile/views/index.html',
        controller: 'ProfileController',
        controllerAs: 'page'
      });
  }

  angular
    .module('app.controlpanel.profile')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function ProfileController($rootScope, Session, ProfileService) {
    var vm = this;
    vm.editable = false;

    vm.profile = {};
    $rootScope.show_loader = false;

    vm.init = function () {
      ProfileService.getProfileById(Session.getUser().person.id)
        .then(function (person) {
          vm.profile = person;
          vm.profile.dob = vm.profile.dob == null ? '' : vm.profile.dob;
          vm.profile.image = vm.profile.image ? vm.profile.image : '/assets/images/avatars/profile.jpg';
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.submitProfile = function () {

    };


    vm.init();

  }

  angular
    .module('app.controlpanel.profile')
    .controller('ProfileController', ProfileController);

})();

(function () {
  'use strict';
  
  /** @ngInject */
  function mdDateConfig() {
   
  }
  
  angular
    .module('app.controlpanel.profile')
    .config(mdDateConfig);
  
})();
(function () {
  'use strict';

  angular
    .module('app.controlpanel.dashboard', [])
    

})();

(function () {
  'use strict';

  /** @ngInject */
  function PersonUnificationController(DashboardService, Common, ModalExtra, $rootScope, $mdDialog,
                                       ModalFactory) {
    var vm = this;
    vm.disable = false;
    vm.closeModal = function () {
      $mdDialog.cancel();
    };

    vm.unificate = function () {
      vm.disable = true;
      DashboardService.runUnificate().then(function (response) {
        ModalFactory.alert(
          "Unificação realizada com sucesso", "Foram unificados um total de " + response.unifications + " pessoas.",
          "modal", "Ok", "false", "controlpanel"
        ).then(function () {
          vm.closeModal();
        });
      })
    };

  }

  angular
    .module('app.controlpanel.dashboard')
    .controller('PersonUnificationController', PersonUnificationController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function IpBlockController(DashboardService, Common, ModalExtra, $rootScope, $mdDialog) {
    var vm = this;
    vm.ips = [];
    vm.has_block_ip = false;
    vm.block_button = false;

    vm.closeModal = function () {
      $mdDialog.cancel();
    };

    vm.addItem = function () {
      vm.ips.push({address: ''});
    };

    vm.submit = function () {
      vm.block_button = true;
      DashboardService.saveIpBlock({
        has_block_ip: vm.has_block_ip,
        ips: vm.ips
      }).then(function () {
        Common.Toast.success('Configurações salvas com sucesso!');
        vm.closeModal();
      })
    };

    vm.init = function () {
      vm.ips = ModalExtra.ips;
      vm.has_block_ip = ModalExtra.has_block_ip;
    };

    vm.init();
  }

  angular
    .module('app.controlpanel.dashboard')
    .controller('IpBlockController', IpBlockController);
})();
(function () {
  'use strict';

  angular
    .module('app.controlpanel.import-data', [])
})();

(function () {
  'use strict';

  /** @ngInject */
  function ImportDataService(Restangular) {
    var vm = this;

    vm.sendFile = function (obj) {
      return Restangular.all("fmd").post(obj);
    };

    vm.saveMapping = function (obj) {
      return Restangular.one('fmd').all('savemapping').post(obj);
    };

    vm.validateFields = function (obj) {
      return Restangular.one('fmd').all('validatefields').post(obj);
    };

    vm.getInfosForMigration = function (obj) {
      return Restangular.one('fmd').one('getinfo').get(obj);
    };

    vm.getUploadedFiles = function (obj) {
      return Restangular.one('fmd').one('getuploadedfiles').get(obj);
    };

    vm.deleteMigrationFile = function (obj) {
      return Restangular.one('fmd', obj.id).all('deletemigrationfile').post(obj);
    };

    vm.updateMigrationColumn = function (obj) {
      return Restangular.one('fmd').all('updatemigrationcolumn').post(obj);
    };

    return vm;
  }

  angular
    .module('app.controlpanel.import-data')
    .factory('ImportDataService', ImportDataService);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.controlpanel.import-data', {
        url: '/import-data',
        public: false,
        templateUrl: 'app/controlpanel/import-data/index.html',
        controller: 'ImportDataController',
        controllerAs: 'vm',
      });
  }

  angular
    .module('app.controlpanel.import-data')
    .config(routerConfig);
})();
(function () {
  'use strict';

  /** @ngInject */
  function ImportDataController($rootScope, $scope, $mdEditDialog, $http, $q, $filter, Common, ImportDataService,
                                ModalFactory) {
    var vm = this;
    vm.file = null;
    vm.mandatory_not_found = [];
    vm.file_processed = false;
    vm.errors = [];
    vm.map_first_line = null;
    vm.selectedSpreadsheet = null;
    vm.selectedSystem = null;
    vm.uploadedFiles = [];
    vm.showFiles = false;
    vm.haveMapping = false;

    vm.data_patterns = {
      date: 'aaaa-mm-dd',
      numeric: '1000.00'
    };

    vm.date_patterns = [
      'aaaa-mm-dd',
      'dd-mm-aaaa',
      'mm-dd-aaaa',
      'dd/mm/aaaa',
      'mm/dd/aaaa'
    ];

    vm.numeric_patterns = [
      '1000.00',
      '1.000,00',
      '1000,00'
    ];

    vm.init = function () {
      // vm.getJson();
      vm.getInfosForMigration();
      vm.getUploadedFiles();
    };

    vm.getInfosForMigration = function () {
      $rootScope.show_loader = true;
      ImportDataService.getInfosForMigration().then(function (response) {
        var objResponse = response.plain();
        vm.spreadSheets = objResponse.spreadSheets;
        vm.systems = objResponse.systems;
        vm.mappings = objResponse.mappings;
        vm.formatArrays();
        $rootScope.show_loader = false;
      })
    };

    vm.getUploadedFiles = function () {
      ImportDataService.getUploadedFiles().then(function (response) {
        vm.uploadedFiles = response.plain();
        $rootScope.show_loader = false;
      })
    };

    vm.setMapping = function (system_id) {
      for (var i = 0; i < vm.mappings.length; i++) {
        console.log(vm.mappings[i].migration_system_id);
        console.log(system_id);
        console.log(vm.mappings[i].migration_spreadsheet_id);
        console.log(vm.selectedSpreadsheet.id);
        if (vm.mappings[i].migration_system_id === system_id && vm.mappings[i].migration_spreadsheet_id === vm.selectedSpreadsheet.id) {
          if (vm.mappings[i].mapping !== null) {
            console.log('entrou');
            $rootScope.show_loader = true;
            vm.map_first_line = JSON.parse(vm.mappings[i].mapping);
            vm.first_line = angular.copy(vm.map_first_line);
            vm.setFirstLine();
            vm.json_option = $filter('filter')(vm.json, {show: true});
            vm.mandatory_not_found = $filter('filter')(vm.json_option, {mandatory: true});
            vm.haveMapping = true;
            $scope.$applyAsync();
            $rootScope.show_loader = false;
          } else {
            vm.json_option = null;
            vm.mandatory_not_found = null;
            vm.first_line = null;
            vm.json = null;
            vm.map_first_line = null;
          }
        }
      }
    };

    vm.setFirstLine = function () {
      vm.first_line = vm.first_line.map(function (item) {
        if (angular.isDefined(item.origin)) {
          item = item.origin;
        }
        var found = null;
        var to = null;
        if (vm.json !== null) {
          vm.json.map(function (column) {
            if (column.name.toLowerCase() === item.toLowerCase()) {
              found = column;
              found.type = column.type;
              found.maxlength = angular.isDefined(column.maxlength) ? column.maxlength : null;
              column.show = false;
              to = column.name;
            } else {
              to = to !== null ? to : vm.testReference(item, column.name);
            }
            column.show = !(angular.isDefined(column.show) && column.show === false);
            return column;
          });

        }
        return {
          origin: item, to: to, found: found !== null, mandatory: found !== null ? found.mandatory : false,
          type: found !== null ? found.type : false,
          maxlength: found !== null ? found.maxlength : null
        };
      });
    };

    vm.saveMapping = function () {
      $rootScope.show_loader = true;
      ImportDataService.saveMapping({
        spreadsheet: vm.selectedSpreadsheet,
        system: vm.selectedSystem,
        mapping: vm.map_first_line
      }).then(function () {
        $rootScope.show_loader = false;
        Common.Toast.success("Colunas salvas com sucesso");
      });
    };

    vm.formatArrays = function () {
      for (var i = 0; i < vm.spreadSheets.length; i++) {
        vm.spreadSheets[i].columns = JSON.parse(vm.spreadSheets[i].columns);
      }
    };

    /**
     * Retorna o json padrão de colunas
     * @returns {*}
     */
    vm.getJson = function () {
      var deferred = $q.defer();
      $http.get('app/controlpanel/import-data/student.json')
        .then(function (resp) {
          vm.json = resp.data;
          deferred.resolve(true);
        });
      return deferred.promise;
    };

    /**
     * Realiza o processamento do CSV
     * @param file
     */
    vm.newCsv = function (file) {
      $rootScope.show_loader = true;
      console.log(vm.json);
      var option = {
        complete: function (results) {
          vm.first_line = results.data[0];
          vm.parse_file = results;
          vm.delimiter = results.meta.delimiter;
          console.log(vm.delimiter);
          console.log(vm.first_line);
          $rootScope.show_loader = false;
          vm.setFirstLine();
          if (vm.map_first_line === null) {
            vm.map_first_line = $filter('filter')(vm.first_line, {found: false});
            vm.json_option = $filter('filter')(vm.json, {show: true});
            vm.mandatory_not_found = $filter('filter')(vm.json_option, {mandatory: true});
          }
          $scope.$applyAsync();
        },
        delimitersToGuess: [',', ';', '|', '\t']
      };
      var blob = vm.dataURItoBlob(file.file, null);
      Papa.parse(blob, option);
      vm.file_processed = true;
      Common.Toast.success("Arquivo CSV carregado em memória.");
    };

    vm.changeJson = function (json) {
      vm.json = json;
      vm.json_option = $filter('filter')(vm.json, {show: true});
      vm.mandatory_not_found = $filter('filter')(vm.json_option, {mandatory: true});
      console.log(vm.json);
      console.log(vm.json_option);
      console.log(vm.mandatory_not_found);
      if (vm.selectedSystem !== null){
        vm.setMapping(vm.selectedSystem);
      }
    };

    vm.changeColumn = function (column, oldTo) {
      console.log(column);
      console.log(oldTo);
      console.log(vm.haveMapping);
      if (vm.haveMapping) {
        $rootScope.show_loader = true;
        ImportDataService.updateMigrationColumn({
          spreadsheet: vm.selectedSpreadsheet,
          system: vm.selectedSystem,
          to: column.to,
          from: oldTo === null || oldTo === "" ? column.origin : oldTo
        }).then(function () {
          Common.Toast.success("Coluna alterada com sucesso!");
          $rootScope.show_loader = false;
        }).catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error("Erro na alteração da coluna");
        })
      }
    };

    vm.submitCsv = function () {
      ModalFactory.custom('app/controlpanel/import-data/modal-option-csv.html', {}).then(function (option) {
        $rootScope.show_loader = true;
        var founds = $filter('filter')(vm.first_line, {found: true});
        var concat = founds.concat(vm.map_first_line);
        ImportDataService.sendFile({
          columns: concat,
          file: vm.file,
          spreadsheet: vm.selectedSpreadsheet,
          system: vm.selectedSystem,
          mapping: vm.map_first_line,
          create_new_table: option,
          delimiter: vm.delimiter
        })
          .then(function () {
            Common.Toast.success("Dados salvos com sucesso");
            vm.getUploadedFiles();
            $rootScope.show_loader = false;
          }).catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error("Problema no processamento do CSV");
        });
      });
    };

    vm.deleteFile = function (file) {
      console.log(file);
      $rootScope.show_loader = true;
      ImportDataService.deleteMigrationFile(file).then(function () {
        vm.getUploadedFiles();
      })
    };

    vm.validateFields = function () {
      $rootScope.show_loader = true;
      var founds = $filter('filter')(vm.first_line, {found: true});
      var concat = founds.concat(vm.map_first_line);
      ImportDataService.validateFields({
        patterns: vm.data_patterns,
        spreadsheet: vm.selectedSpreadsheet,
        system: vm.selectedSystem,
        columns: concat
      }).then(function (response) {
        vm.errors = response.plain();
        $rootScope.show_loader = false;
      })
    };

    /**
     * Verifica correspondência entre colunas do CSV com colunas padrão
     * @param column - coluna do csv
     * @param reference - coluna padrão
     * @returns {null|*}
     */
    vm.testReference = function (column, reference) {
      return null;
      var split = reference.split('_');
      var count = 0;
      column = vm.removeAccents(column.toLowerCase());
      split.forEach(function (item) {
        if (column.indexOf(item) > -1) {
          count++;
        }
      });
      if (count >= split.length) {
        return reference;
      }
    };

    /**
     * Remove acentos da string
     * @param value
     * @returns {*}
     */
    vm.removeAccents = function (value) {
      return value
        .replace(/á/g, 'a')
        .replace(/ã/g, 'a')
        .replace(/é/g, 'e')
        .replace(/í/g, 'i')
        .replace(/ó/g, 'o')
        .replace(/õ/g, 'o')
        .replace(/ú/g, 'u');
    };

    /**
     * Converte dados base64 recebidos pelo input de arquivos para blob (o Papaparse só funciona com blob)
     * @param dataURI
     * @param callback
     * @returns {Blob}
     */
    vm.dataURItoBlob = function (dataURI, callback) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      var bb = new Blob([ab]);
      return bb;
    };

    vm.init();
  }

  angular
    .module('app.controlpanel.import-data')
    .controller('ImportDataController', ImportDataController);
})();

(function () {
    'use strict';
  
    /** @ngInject */
    function IdleMinutesToBlockController($injector, DashboardService, Common, ModalExtra, $mdDialog, $interval, a4IdleMinutesToBlock, LocalStorage) {
      var vm = this;
      vm.count = 60;
      vm.block_button = false;

      vm.init = function () {
        vm.idle_minutes_to_block = ModalExtra.idle_minutes_to_block;
        vm.has_idle_minutes_to_block = ModalExtra.idle_minutes_to_block > 0 ? true : false
      };

      var countDown = $interval(function () {
        if (vm.count > 0) {
          vm.count--; // Decrementa o contador
        } else {
          $interval.cancel(countDown); // Para o contador ao chegar a 0
          $mdDialog.cancel();
        }
      }, 1000);

      if (typeof BroadcastChannel !== 'undefined') {
        var channel = new BroadcastChannel('modal_countdown');
    
        channel.onmessage = function (event) {
          var message = event.data;

          if (message.type === 'update_count') {
            vm.count = event.data.count; // Atualiza o valor da contagem
          }

          if (message.type === 'close_modal') {
            $mdDialog.hide(); //fecha o modal
            var LockService = $injector.get('LockService'); // Obtém LockService dinamicamente
            var $state = $injector.get('$state');  
            LockService.lockSystem()
            .then(function () {
              $state.go('private.lockscreen');
            })
          }
        };
      } else {
        // Fallback para localStorage
        $scope.$on('LocalStorage:changed', function (event, key, newValue) {
          if (key === 'sync_event') {
            var message = JSON.parse(newValue);
            if (message.type === 'close_modal') {
              $mdDialog.hide();
            }
            if (message.type === 'update_count') {
              vm.count = message.count; // Atualiza o valor da contagem
            }
          }
        });
      }

      vm.$onDestroy = function () {
        $interval.cancel(countDown);
      };
  
      vm.closeModal = function () {
        DashboardService.getIdleMinutesToBlock();
        $mdDialog.hide();

      // Notifica outras abas para fechar o modal
      if (typeof BroadcastChannel !== 'undefined') {
        var channel = new BroadcastChannel('modal_countdown');
        channel.postMessage({ type: 'close_modal' });
      } else {
        // Fallback para localStorage
        LocalStorage.add('sync_event', JSON.stringify({ type: 'close_modal' }));
      }
      };
  
      vm.submit = function () {
        vm.block_button = true;
        vm.idle_minutes_to_block = vm.has_idle_minutes_to_block == true ? vm.idle_minutes_to_block : 0; 
        DashboardService.saveIdleMinutesToBlock({idle_minutes_to_block: vm.idle_minutes_to_block})
        .then(function () {
          LocalStorage.add('idle_minutes_to_block', vm.idle_minutes_to_block);
          a4IdleMinutesToBlock.startMonitoring();
          Common.Toast.success('Configurações salvas com sucesso!');
          vm.closeModal();
        })
      };
  

      vm.init();
    }
  
    angular
      .module('app.controlpanel.dashboard')
      .controller('IdleMinutesToBlockController', IdleMinutesToBlockController);
  })();
(function () {
  'use strict';

  /** @ngInject */
  function DashboardService(Restangular, CONFIG, PoliciesService, LocalStorage, EducationalService, Session, $document) {
    var current_connection = $document[0].domain.split('.')[0];
    var user_email = angular.isDefined(Session.user) ? Session.user.email : null;

    var profile_selected = Session.getCurrentProfile();
    var getIpBlockInfo = function (obj) {
      return Restangular.one('users').one('getipblockinfo').get(obj);
    };

    var saveIpBlock = function (obj) {
      return Restangular.one('users').all('saveipblock').post(obj);
    };

    var getIdleMinutesToBlock = function (obj) {
      return Restangular.one('users').one('getidleminutestoblock').get(obj);
    };

    var saveIdleMinutesToBlock  = function (obj) {
      return Restangular.one('users').all('saveidleminutestoblock').post(obj);
    };

    var runUnificate = function (obj) {
      return Restangular.one('users').all('unificatepersons').post(obj);
    };
    return {
      /**
       * Lista de itens de configuração do dashboard do painel de controle
       * @returns {[*,*,*]}
       */
      getDashBoardConfigList: function () {
        return [
          {
            name: "Gerenciar usuários",
            state: "private.controlpanel.users",
            icon: 'icon-account-multiple',
            is_show: PoliciesService.checkPolicyFromMenu('user_manage')
          }, {
            name: "Gerenciar papéis de usuário",
            state: "private.controlpanel.manageroles",
            icon: 'icon-lock-unlocked',
            is_show: PoliciesService.checkPolicyFromMenu('sys_user_role_manage')
          },
          {
            name: "Gerenciar IPs para acesso",
            state: "ip_block",
            icon: 'icon-laptop-windows',
            is_show: PoliciesService.checkPolicyFromMenu('sys_user_role_manage')
          }, {
            name: "Mudanças do sistema",
            state: "private.controlpanel.app-log",
            icon: 'icon-elevation-rise',
            is_show: profile_selected === 0
          },
          {
            name: "Unificação de pessoas",
            state: "person_unification",
            icon: 'icon-account-multiple-outline',
            is_show: PoliciesService.checkPolicyFromMenu('person_unification')
          },
          {
            name: "Migração",
            state: "private.controlpanel.import-data",
            icon: 'icon-import',
            is_show: current_connection === 'a4simetria' || current_connection === 'labs' || user_email === 'suporte@simetrianet.com.br'
          },
          {
            name: "Preferências",
            state: "private.controlpanel.profile",
            icon: 'icon-account',
            is_show: true
          },
          {
            name: "Bloquear sessão",
            state: "private.lockscreen",
            icon: 'icon-lock',
            is_show: true
          }
          // ,{
          //   name: "Gerenciar tempo ocioso",
          //   state: "idle_minutes_to_block",
          //   icon: 'icon-lock',
          //   is_show: true
          // }
        ]
      },

      /**
       * Lista de itens de aplicações do dashboard do painel de controle
       * @returns {[*,*]}
       */
      getDashBoardAppList: function () {
        return [
          {
            name: "Financeiro",
            state: "private.finance.dashboard",
            icon: 'assets/images/logos/a4finance.png',
            is_show: PoliciesService.checkPolicyFromMenu('financeiro') && LocalStorage.get('has_app_finance')
          },
          {
            name: "Educacional",
            state: "private.educational.dashboard",
            icon: 'assets/images/logos/a4educational.png',
            is_show: PoliciesService.checkPolicyFromMenu('educational')
          },
          {
            name: "Relacionamento",
            state: "private.crm.dashboard",
            icon: 'assets/images/logos/a4crm.jpg',
            is_show: PoliciesService.checkPolicyFromMenu('crm')
          },
          {
            name: "Estoque",
            state: "private.stock.dashboard",
            icon: 'assets/images/logos/a4stock.png',
            is_show: PoliciesService.checkPolicyFromMenu('estoque_menu')
          },
          {
            name: "Avaliações",
            state: "private.evaluations.dashboard",
            icon: 'assets/images/logos/a4evaluations.png',
            is_show: PoliciesService.checkPolicyFromMenu('evaluations')
          },
          {
            name: "Solicitações",
            state: "private.process.dashboard",
            icon: 'assets/images/logos/a4process.png',
            is_show: PoliciesService.checkPolicyFromMenu('process') && (current_connection === 'portaldosaber' || current_connection === 'a4simetria' || current_connection === 'labs') || user_email === 'suporte@simetrianet.com.br'
          }
        ]

      },
      getIpBlockInfo: getIpBlockInfo,
      saveIpBlock: saveIpBlock,
      runUnificate: runUnificate,
      getIdleMinutesToBlock: getIdleMinutesToBlock,
      saveIdleMinutesToBlock: saveIdleMinutesToBlock
    }

  }

  angular
    .module('app.controlpanel.dashboard')
    .factory('DashboardService', DashboardService);


})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.controlpanel.dashboard', {
        url: '/dashboard',
        auth: 'ctl_dash',
        public: false,
        templateUrl: 'app/controlpanel/dashboard/dashboard.html',
        controller: 'DashboardControlController',
        controllerAs: 'vm',
      });
  }

  angular
    .module('app.controlpanel.dashboard')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function DashboardController($scope, $state, $window, DashboardService, EducationalService,
                               Session, CONFIG, LocalStorage, ModalFactory, $rootScope) {
    var vm = this;
    vm.listMenu = [];
    vm.boardList = [];
    vm.configMenu = [];
    vm.context = Session.get(CONFIG.storage.context);
    vm.profile_selected = Session.get(CONFIG.storage.profile);
    vm.init = function () {
      if (angular.isUndefined(Session.get(CONFIG.storage.profile)) || Session.get(CONFIG.storage.profile) === null) {
        vm.verifyProfile(vm.context);
        $rootScope.show_loader = false;
      }
    };

    /**
     * Evento disparado apenas quando as views estão carregadas
     */
    var ltn = $scope.$on('$viewContentLoaded', function () {
      vm.boardList = DashboardService.getDashBoardAppList();
      vm.configMenu = DashboardService.getDashBoardConfigList();
      $rootScope.show_loader = false;
    });

    /**
     * Função de redirecionamento de states
     * @param state
     */
    vm.stateGo = function (state) {
      if (state === 'ip_block') {
        vm.openIpBlockModal();
      } else if (state === 'person_unification') {
        vm.openUnificationModal();
      } else if (state === 'idle_minutes_to_block') {
        vm.openIdleMinutesToBlockModal();
      } else {
        $state.go(state);
      }
    };

    /**
     * Abre modal para configuração de bloqueio de IP
     */
    vm.openIpBlockModal = function () {
      DashboardService.getIpBlockInfo().then(function (response) {
        var data = response.plain();
        var ips = data.ips;
        var has_block_ip = data.has_block_ip;
        /*if (ips.length === 0) {
          ips.push({address: ''});
        }*/
        ModalFactory.customClean('app/controlpanel/ip-block/views/modal.html',
          'IpBlockController', 'vm', false, {ips: ips, has_block_ip: has_block_ip}).then(function () {
        })
      })
    };

    vm.openUnificationModal = function () {
      ModalFactory.customClean('app/controlpanel/person-unification/views/modal.html',
        'PersonUnificationController', 'vm', false, {}).then(function () {
      })
    };

    vm.openIdleMinutesToBlockModal = function () {
      DashboardService.getIdleMinutesToBlock().then(function (response) {
        var idle_minutes_to_block = response;
        ModalFactory.customClean('app/controlpanel/idle-minutes-to-block/views/modal.html',
          'IdleMinutesToBlockController', 'vm', false, {idle_minutes_to_block: idle_minutes_to_block}).then(function () {
        })
      })
    };

    /**
     * Permite selecionar os perfis disponíveis
     * @param profiles
     */
    vm.verifyProfile = function (profiles) {
      var any_profiles = 0;
      var possibleProfiles = [];
      angular.forEach(profiles, function (item, key) {
        if (item === true) {
          any_profiles = any_profiles + 1;
          possibleProfiles.push(key);
        }
      });

      /** Se houver mais que uma opção abre o modal para a escolha */
      if (any_profiles > 1) {
        vm.switchProfile(profiles);
      } else {
        LocalStorage.add(CONFIG.storage.profile, possibleProfiles[0]);
        $window.location.reload();
      }
    };

    /**
     * Abre o modal para a escolha de perfil para exibição do sistema
     */
    vm.switchProfile = function (profiles) {
      ModalFactory.customClean(
        'app/controlpanel/switch-profile.html',
        'SwitchProfileControlPanel',
        'vm', false, profiles
      );
    };

    vm.init();

    /**
     * Destrutor de classe
     */
    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      });

    })

  }

  angular
    .module('app.controlpanel.dashboard')
    .controller('DashboardControlController', DashboardController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ReportStack() {
    var vm = this;

    vm.stack = [];

    /**
     * Conta os itens da pilha
     */
    vm.count = function () {
      return vm.stack.length;
    };

    /**
     * Adiciona um item a pilha
     * @param state - Item para por na pilha
     * @param clicked - Item clicado
     */
    vm.stackUp = function (state, clicked) {
      var stackItem = {state: state, clicked: clicked};
      vm.stack.push(stackItem);
    };


    /**
     * Remove um item a pilha
     * @returns mixed - Retorna o item removido da pilha
     */
    vm.stackDown = function () {
      return vm.stack.pop();
    };

    /**
     * Desempilha até um determinado indice
     * @param key - indice da pilha
     * @return array Retorna a nova pilha
     */
    vm.stackDownAt = function (key) {
      var stackIndex = (vm.stack.length - 1);
      for (var i = stackIndex; i > key; i--) {
        vm.stackDown();
      }
      return vm.getStack();
    };

    /**
     * Limpa a pilha
     */
    vm.clearStack = function () {
      vm.stack = [];
    };

    /**
     * Retorna a pilha completa
     * @returns {Array}
     */
    vm.getStack = function () {
      return vm.stack;
    };

    return vm;
  }

  angular.module('app.controlpanel.central-reports')
    .factory('ReportStack', ReportStack)

})();
(function () {
  'use strict';

  /** @ngInject */
  function ReportItemController($document, $rootScope, CentralReportsService, Common, ModalExtra, CONFIG, ReportsService) {
    var vm = this;

    vm.data = ModalExtra;
    vm.report_paginate = ModalExtra.report_paginate;
    vm.report = null;
    vm.block_button = false;
    vm.CONFIG = CONFIG;

    /**
     * Formata as colunas do relatório a serem exibidas.
     */
    vm.formatColsToShow = function () {
      vm.report = angular.fromJson(vm.data.report_data.model_json);
    };

    vm.init = function () {
      vm.formatColsToShow();
    };

    vm.getGroupedTotal = function (data, column, group) {
      var total = 0;
      for (var i = 0; i < data[group].length; i++) {
        total += parseFloat(data[group][i][column]);
      }
      return total;
    };

    /**
     * Pega o PDF do relatório
     * @param orientation - Posição do papel
     */
    vm.getPDF = function (orientation) {
      vm.block_button = true;
      ReportsService.getReportPDF(vm.data.variables, vm.data.report_data.id, orientation, vm.data.report_data.name)
        .then(function () {
          vm.block_button = false;
        })
        .catch(function () {
          vm.block_button = false;
        })
    };

    /**
     * Gera o relatório em Excel
     */
    vm.getXLSX = function () {
      vm.block_button = true;
      ReportsService.getReportXLSX(vm.data.report_data.id, vm.data.report_data.name, vm.data.variables)
        .then(function () {
          vm.block_button = false;
        })
        .catch(function () {
          vm.block_button = false;
        })
    };
    
    /**
     * Gera o relatório em CSV
     */
    vm.getCSV = function () {
      vm.block_button = true;
      ReportsService.getReportCSV(vm.data.report_data.id, vm.data.report_data.name, vm.data.variables)
        .then(function (response) {
          vm.block_button = false;
        }).catch(function () {
        vm.block_button = false;
      })
    };

    /**
     * Retorna dados do relatório por pagina
     * @param page - Número da pagina
     */
    vm.getReportPage = function (page) {
      vm.promise = CentralReportsService.generateReport(vm.data.report_data.id, vm.data.variables, page)
        .then(function (response) {
          var records = response.plain();
          if (!angular.isArray(records.master)) {
            vm.report_paginate = records.master;
          } else {
            vm.data.report_array = records;
          }
        })
        .catch(function (error) {
          Common.Toast.error(error.data.message || error.message);
          $rootScope.show_loader = false;
        })
    };


    /**
     * Transforma o link de impressão de relatório
     * @param obj
     * @returns
     */
    vm.build_print_link = function (obj) {
      var output_join = '';
      angular.forEach(obj, function (key, val) {
        output_join += val + '[start]=' + key.start + '&' + val + '[end]=' + key.end + '&';
      });
      return output_join;
    };


    /**
     * Fecha o modal
     */
    vm.closeModal = function (item) {
      $rootScope.$broadcast('ModalFactory.close', item);
    };

    vm.init();

  }

  angular
    .module('app.controlpanel.central-reports')
    .controller('ReportItemController', ReportItemController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CentralReportsService(Restangular, $http, CONFIG, Common) {

    /** Cria um novo item de relatório */
    var createItem = function (obj) {
      return Restangular.all('reports').post(obj);
    };

    /** Cria um novo item de relatório */
    var remove = function (id) {
      return Restangular.one('reports', id).remove();
    };

    /** Cria um novo item de relatório */
    var generateReport = function (id, obj, page) {
      return Restangular.one('reports', id).one('generate').get({data: obj, page: page});
    };

    /** Move um relatório para uma pasta */
    var moveReportToFolder = function (obj) {
      return Restangular.one('reports').one('movetofolder').get(obj);
    };

    var duplicateReport = function (item) {
      return Restangular.all('reports').all('duplicate').post(item);
    };

    /** Cria um novo item de relatório em word */
    var generateWordReport = function (id, report_name) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/' + id + '/generateword',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", report_name + '.docx');

          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    /** Cria um novo item de relatório em word */
    var downloadWordTemplate = function (id) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/' + id + '/downloadwordtemplate',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;
        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", 'template.docx');

          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };


    /** Cria um novo item de relatório em word */
    var generateWordReportPDF = function (id, report_name) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/reports/' + id + '/downloadwordpdf',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", report_name + '.pdf');

          var clickEvent = new MouseEvent("click", {
            "view": window, "bubbles": true, "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });
      return deffered.promise;
    };

    var getAll = function () {
      return Restangular.one('reports').get();
    };

    var updateItem = function (id, obj) {
      return Restangular.one('reports', id).all('update').post(obj);
    };

    return {
      createItem: createItem,
      updateItem: updateItem,
      remove: remove,
      generateReport: generateReport,
      duplicateReport: duplicateReport,
      generateWordReport: generateWordReport,
      downloadWordTemplate: downloadWordTemplate,
      generateWordReportPDF: generateWordReportPDF,
      getAll: getAll,
      moveReportToFolder: moveReportToFolder
    }

  }

  angular
    .module('app.controlpanel.central-reports')
    .factory('CentralReportsService', CentralReportsService);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.controlpanel.central-reports', {
        url: '/centralreports',
        public: false,
        templateUrl: 'app/controlpanel/central-reports/central-reports.html',
        controller: 'CentralReportsController',
        controllerAs: 'vm',
      });
  }

  angular
    .module('app.controlpanel.central-reports')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function CentralReportsGenerateDirective() {
    return {
      restrict: 'E',
      controller: 'CentralReportsController',
      controllerAs: 'vm',
      templateUrl: 'app/controlpanel/central-reports/central-reports.html',
      scope: {
        withbackward: '=?',
        backwardstate: '@?',
        isFinance: '=?',
        theme: '=?',
        isEducational: '=?',
      },
      link: function (scope) {
        scope.withbackward = angular.isUndefined(scope.withbackward) ? true : scope.withbackward;
        scope.theme = angular.isUndefined(scope.theme) ? 'finance' : scope.theme;
        scope.isFinance = angular.isUndefined(scope.isFinance) ? false : scope.isFinance;
        scope.isEducational = angular.isUndefined(scope.isEducational) ? false : scope.isEducational;

        if (scope.isEducational) {
          scope.theme = "educational";
        } else if (scope.isFinance) {
          scope.theme = 'finance';
        }

        scope.backwardstate = angular.isUndefined(scope.backwardstate) ? 'private.controlpanel.central-reports' : scope.backwardstate;
      }
    }
  }

  angular
    .module('app.controlpanel.central-reports')
    .directive('centralReportsGenerateDirective', CentralReportsGenerateDirective);

})();

(function () {
  'use strict';

  /** @ngInject */
  function CentralReportsCreateController($rootScope, CentralReportsService, Common, ModalExtra) {
    var vm = this;

    vm.show_progress = false;
    vm.report = {};
    vm.folder = ModalExtra == null ? {} : ModalExtra;

    /**
     * Realiza a submissão do item
     * @param item
     */
    vm.submit = function (item) {
      vm.show_progress = true;
      item.id_parent = vm.folder.id;
      CentralReportsService.createItem(item)
        .then(function (response) {
          Common.Toast.success('Item criado com sucesso');
          vm.close(response.plain());
          vm.show_progress = false;
        })
        .catch(function () {
          vm.close('close');
          vm.show_progress = false;
        })
    };

    /**
     * Fecha o modal
     */
    vm.close = function (item) {
      $rootScope.$broadcast('ModalFactory.close', item);
    }

  }

  angular
    .module('app.controlpanel.central-reports')
    .controller('CentralReportsCreateController', CentralReportsCreateController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function CentralReportsController($filter, $rootScope, $scope, $mdSidenav, $http, $a4FloatButton, DefineDetailsWizardService,
                                    Common, ModalFactory, CentralReportsService, JockerVariables, ReportStack, PoliciesService) {
    var vm = this;
    vm.currentView = 'list';
    vm.windowHeight = angular.element("#main").height();
    vm.selected = null;
    vm.file = undefined;
    vm.ace_options = {
      mode: 'json',
      useWrapMode: true,
      showGutter: true,
      firstLineNumber: 1
    };
    vm.type_item = {
      folder: 1,
      report: 2
    };

    $scope.myHtml = "<h1>Hello World</h1>";
    $scope.froalaOptions = {};


    vm.showDetails = true;
    vm.items = [];
    vm.breadCrumb = [];
    vm.data = null;

    /**
     * Select an item
     *
     * @param item
     */
    vm.select = select;

    function select(item) {
      vm.selected = item;
      if (vm.selected !== null && vm.selected.model_json !== null) {
        vm.selected.model_json = JSON.stringify(angular.fromJson(vm.selected.model_json), null, 4);
      }
    }

    /**
     * Toggle details
     *
     * @param item
     */
    vm.toggleDetails = toggleDetails;

    function toggleDetails(item) {
      vm.selected = item;
      toggleSidenav('details-sidenav');
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    vm.toggleSidenav = toggleSidenav;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Toggle view
     */
    vm.toggleView = toggleView;

    function toggleView() {
      vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
    }


    vm.init = function () {
      vm.getAllItems();
    };


    vm.REPORTTYPE = [
      {id: 1, name: 'Pasta'},
      {id: 2, name: 'Relatório'},
      {id: 3, name: 'Documento Word'},
      {id: 4, name: 'Documento Excel'}
    ];
    /**
     * Retorna a string do tipo do item de relatório
     * @param type
     */
    vm.getReportType = function (type) {
      return $filter('filter')(vm.REPORTTYPE, {id: type}, false)[0];
    };

    /**
     * Retorna a lista de todos os items
     */
    vm.getAllItems = function () {
      $rootScope.show_loader = true;
      CentralReportsService.getAll()
        .then(function (response) {
          vm.items = [];
          vm.allitems = response.plain();
          vm.items = response.plain();

          /** Variavel isFinance definida pela diretiva */
          if ($scope.isFinance) {
            var finance_stack = $filter('filter')(vm.items, {name: 'Financeiro', type: 1})[0];
            vm.goForward(finance_stack, null);
          }

          /** Variavel isEducational definida pela diretiva */
          if ($scope.isEducational) {
            var educational_stack = $filter('filter')(vm.items, {name: 'Educacional', type: 1})[0];
            vm.goForward(educational_stack, null);
          }

          if (vm.selected === null) {
            vm.selected = vm.items[0];
          }
          $rootScope.show_loader = false;
        })
    };


    //Abre modal para a seleção da pasta para qual o relatório vai ser transferido
    vm.openMoveToFolderModal = function (item) {
      // Filtra apenas as pastas (type == 1) e remove a pasta atual do item
      var folders = vm.items.filter(function (i) {
        return i.type === 1 && i.id !== item.parent_id;
      });

      var data = {
        reportItem: item,
        folders: folders
      };

      ModalFactory.customClean(
        'app/components/a4-move-reports-to-folder/a4-move-reports-to-folder.html',
        'MoveToFolderDialogController',
        'dialog',
        true,
        data,
        null
      ).then(function (selectedFolder) {
        if (selectedFolder) {
          vm.moveReportToFolder(item, selectedFolder);
        }
      })
    };

    /**
     * Move o relatório para a pasta selecionada
     * @param report - Relatório a ser movido
     * @param targetFolder - Pasta de destino
     */
    vm.moveReportToFolder = function (report, targetFolder) {
      $rootScope.show_loader = true;

      var obj = {
        report_id: report.id,
        folder_id: targetFolder.id
      };

      CentralReportsService.moveReportToFolder(obj)
        .then(function (response) {
          $rootScope.show_loader = false;

          // Atualiza o relatório na interface
          report.parent_id = targetFolder.id;

          // Remove o relatório da lista atual se estiver em uma pasta
          if (vm.breadCrumb.length > 0) {
            vm.items = vm.items.filter(function (item) {
              return item.id !== report.id;
            });
          }

          vm.getAllItems();
          Common.Toast.success('Relatório movido para a pasta "' + targetFolder.name + '" com sucesso!');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data.message);
        });
    };

    /**
     * Geração de relatório
     */
    vm.generateReport = function (report_selected) {
      /** Verifica as variaveis curingas */
      vm.verifyJockerVariables(report_selected.model_json)
        .then(function (variables) {
          if (variables !== 'close') {
            ModalFactory.confirm(null,
              'Gerar Relatório',
              'Após confimar, aguarde o encerramento da geração, pode levar alguns minutos',
              'Confirmar', "Cancelar", 'controlpanel')
              .then(function () {
                $rootScope.show_loader = true;
                CentralReportsService.generateReport(report_selected.id, variables)
                  .then(function (response) {
                    vm.data = response.plain();
                    ModalFactory.customClean(
                      'app/controlpanel/central-reports/modals/report.html',
                      'ReportItemController',
                      'vm', false, {
                        report_paginate: vm.data.master,
                        report_array: vm.data,
                        report_data: report_selected,
                        variables: variables,
                        theme: $scope.theme
                      }
                    ).then(function () {
                      $rootScope.show_loader = false;
                    });
                  })
                  .catch(function (error) {
                    Common.Toast.error(error.data.message || error.message);
                    $rootScope.show_loader = false;
                  })
              });
          }
        });
    };

    /**
     * Duplica relatório
     * @param item
     */
    vm.duplicateReport = function (item) {
      $rootScope.show_loader = true;
      CentralReportsService.duplicateReport(item).then(function () {
        vm.getAllItems();
        Common.Toast.success('Relatório duplicado com sucesso!');
        $rootScope.show_loader = false;
      }).catch(function () {
        $rootScope.show_loader = false;
      })
    };

    /**
     * Verifica as variaveis curingas no json do relatório
     * @param model_json - Json do relatório
     */
    vm.verifyJockerVariables = function (model_json) {
      var json = angular.fromJson(model_json);
      var jocker = JockerVariables(json);
      jocker.setTheme($scope.theme);
      return jocker.get();
    };

    /**
     * Baixa o modelo do relatório em word
     */
    vm.donwloadWordTemplate = function (selected) {
      $rootScope.show_loader = true;
      CentralReportsService.downloadWordTemplate(selected.id)
        .then(function (data) {
          $rootScope.show_loader = false;
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
        })
    };
    /**
     * Gera relatório com base em modelo word
     */
    vm.generateWordReport = function (selected) {
      ModalFactory.confirm(null,
        'Gerar Relatório em Word',
        'Após confimar, aguarde o encerramento da geração, pode levar alguns minutos',
        'Gerar Word', "Cancelar", 'controlpanel')
        .then(function () {
          $rootScope.show_loader = true;
          CentralReportsService.generateWordReport(selected.id, selected.name)
            .then(function () {
              $rootScope.show_loader = false;
            })
            .catch(function () {
              $rootScope.show_loader = false;
            })
        })
    };

    /**
     * Gera relatório com base em modelo word
     */
    vm.openWYsyWyg = function () {
      ModalFactory.customClean(
        'app/controlpanel/central-reports/sidenavs/main/htmleditor.html',
        'CentralReportsCreateController',
        'vm', false, {}
      )
        .then(function () {

        })
    };

    /**
     * Gera relatório com base em modelo word
     */
    vm.generateWordReportPDF = function (selected) {
      ModalFactory.confirm(null,
        'Gerar Relatório em PDF',
        'Após confimar, aguarde o encerramento da geração, pode levar alguns minutos',
        'Gerar Word', "Cancelar", 'controlpanel')
        .then(function () {
          $rootScope.show_loader = true;
          CentralReportsService.generateWordReportPDF(selected.id, selected.name)
            .then(function () {
              $rootScope.show_loader = false;
            })
        })
    };


    /**
     * Salva o item selecionado
     * @param selected - Item selecionado
     */
    vm.saveItem = function (selected) {
      selected.file = vm.file;
      if (vm.syntaxCheck(selected.model_json)) {
        $rootScope.show_loader = true;
        CentralReportsService.updateItem(selected.id, selected)
          .then(function (itemUpdated) {
            $rootScope.show_loader = false;
            Common.Toast.success("Item atualizado com sucesso");
            vm.selected = itemUpdated.plain();
            vm.items[vm.items.indexOf(selected)] = vm.selected;
          })
          .catch(function (error) {
            Common.Toast.error(error.message);
          })
      } else {
        Common.Toast.error("Erro de syntax no JSON, verifique sua escrita");
      }
    };

    /**
     * Abre o modal para criar um novo item
     */
    vm.openModalCreate = function (folder) {
      folder = (folder === undefined || folder === null) ? null : folder;
      (folder == null) ? folder = {theme: $scope.theme} : folder.theme = $scope.theme;
      ModalFactory.customClean(
        'app/controlpanel/central-reports/modals/create.html',
        'CentralReportsCreateController',
        'vm', false, folder
      ).then(function (item) {
        if (angular.isDefined(item) && item !== 'close') {
          if (folder !== null && angular.isDefined(folder.nodes)) {
            folder.nodes.push(item);
          } else if (angular.isDefined(vm.items)) {
            vm.items.push(item);
          }
          if (item.type === vm.type_item.report) {
            vm.defineDetails(item, true)
          }
        }
        $rootScope.show_loader = false;
      });
    };

    /**
     * Remove um item
     * @param item - item a ser removido
     */
    vm.removerItem = function (item) {
      if (item.type === 1) { //Pasta
        vm.remove(item, "Remover pasta", "Ao remover está pasta, todos os item dentro dela serão removidos também, Deseja realmente realizar esta ação?");
      } else if (item.type >= 2) {//Documento (Relatório)
        vm.remove(item, "Remover relatório", "Deseja realmente realizar esta ação?");
      }
    };

    /**
     * Chama o request para remoção de um item
     * @param item - Item a ser removido
     * @param title - Titulo do modal de confirmação
     * @param message - Mensagem do modal de confirmação
     */
    vm.remove = function (item, title, message) {
      ModalFactory.confirm(null,
        title, message, 'Remover', "Cancelar", 'controlpanel')
        .then(function () {
          $rootScope.show_loader = true;
          CentralReportsService.remove(item.id)
            .then(function (response) {
              $rootScope.show_loader = false;
              if (response) {
                Common.Toast.success("Item removido com sucesso");
                vm.items.splice(vm.items.indexOf(item), 1)
              }

            });
        })
    };

    /**
     * Definição de JSON de consulta de relátorio
     * @param item
     * @param is_editable
     */
    vm.defineDetails = function (item, is_editable) {
      item.is_editable = angular.isUndefined(is_editable) ? true : is_editable;
      item.theme = $scope.theme;
      ModalFactory.customClean(
        'app/controlpanel/central-reports/define-details-wizard/index.html',
        'DefineDetailsWizardController',
        'details', false, item)
        .then(function () {
          ReportStack.clearStack();
          DefineDetailsWizardService.clear();
          /*vm.generateReport(vm.selected);*/
          vm.getAllItems();
        })
        .catch(function () {
          ReportStack.clearStack();
          DefineDetailsWizardService.clear();
          vm.getAllItems();
        })
    };

    /**
     * Verifica a syntax do json
     * @param json
     */
    vm.syntaxCheck = function (json) {
      try {
        angular.fromJson(json);
        return true;
      } catch (e) {
        return false;
      }
    };

    vm.checkPolicies = function (policy) {
      return PoliciesService.checkPolicyFromMenu(policy);
    };


    /************************************** NAVEGAÇÂO DE ARQUIVOS ********************************/
    /**
     * Verifica se existem itens na pilha
     * @returns {boolean}
     */
    vm.showBack = function () {
      /** Caso seja filtrado pelo educational, financeiro então é definido 1 item a mais para o root */
      if ($scope.isEducational || $scope.isFinance) {
        return ReportStack.count() > 1;
      } else {
        return ReportStack.count() > 0;
      }
    };

    /**
     * Função para navegar pelas pastas a partir do breadcrumb
     * @param breadcrumb - Item do breadcrumb clicado
     * @param key - Chave do item no array
     * @param root - é para a raiz?
     */
    vm.navigateTo = function (breadcrumb, key, root) {
      if (angular.isDefined(breadcrumb.state) && breadcrumb.state !== null) {
        vm.breadCrumb = ReportStack.stackDownAt(key);
        if (root && angular.isDefined(breadcrumb) && breadcrumb !== null) {
          vm.items = breadcrumb.state;
        } else if (angular.isDefined(breadcrumb)) {
          vm.items = breadcrumb.clicked.nodes;
        }
      }
    };

    /**
     * Função para voltar de uma pasta
     */
    vm.goBack = function () {
      var stack = ReportStack.stackDown();
      if (angular.isDefined(stack.state) && stack.state.length > 0) {
        vm.items = stack.state;
      }
      vm.breadCrumb = ReportStack.getStack();
    };

    /**
     * Função de navegação na arvore de arquivos
     * @param folder - Item clicado
     * @param state - Estado atual
     */
    vm.goForward = function (folder, state) {
      if (angular.isDefined(folder) && folder.type === 1) {
        ReportStack.stackUp(state, folder);
        vm.breadCrumb = ReportStack.getStack();
        vm.items = folder.nodes;
      }
    };

    $scope.$on("$destroy", function () {
      ReportStack.clearStack();
    });

    vm.init();
  }

  angular
    .module('app.controlpanel.central-reports')
    .controller('CentralReportsController', CentralReportsController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function JockerVariables(Common, ModalFactory) {
    var vm = this;
    vm.json = '';
    vm.variables = [];
    vm.theme = '';

    vm.get = function () {
      vm.variables = [];
      var deffered = Common.$q.defer();
      if (angular.isDefined(vm.json.filter.general)) {
        vm.json.filter.general.forEach(function (item) {
          vm.pushFilter(item);
        });
      }

      if (vm.variables.length === 0) {
        deffered.resolve(true);
      } else {
        vm.openAskModal(vm.variables)
          .then(function (model) {
            deffered.resolve(model);
          })
          .catch(function (error) {
            deffered.reject(error)
          });
      }
      return deffered.promise;
    };

    vm.treeFilter = function () {

    };

    vm.pushFilter = function (item) {
      if (item.type === 'item') {
        var column = item.column.representation.split(" AS ")[1].replace("\}\}", '');
        if (item.filter_value_start === '?') {
          vm.variables.push({
            name: item.column.presentation,
            operator: item.operator.name,
            column: column,
            type: item.column.type,
            size: item.column.size,
            request_route: item.column.request_route,
            is_two: vm.isTwoVariable(item)
          });
        }
      } else if (item.type === 'container') {
        item.columns[0].forEach(function (container_filter) {
          vm.pushFilter(container_filter);
        })
      }
    };

    /**
     * Retorna as ultimas variaveis coletadas;
     * @return {Array}
     */
    vm.getLastVariables = function () {
      return vm.variables;
    };


    /**
     * Abre o modal de pergunta das variaveis
     */
    vm.openAskModal = function (variables) {
      var deffered = Common.$q.defer();
      ModalFactory.customClean("app/controlpanel/central-reports/ask-fields.html",
        /** @ngInject */
        function ($rootScope, ModalExtra, Restangular, Utils) {
          var vm = this;
          vm.theme = ModalExtra.theme;
          vm.model = {};
          vm.itens = [];
          vm.itens = ModalExtra.data;
          vm.months = Utils.months();
          /**
           * Busca dados de select box pela url passada
           * @param item
           */
          vm.getDataFromRequestRoute = function (item) {
            var url = item.request_route;
            Restangular.one(url).get()
              .then(function (response) {
                item.data_list = response.plain();
              })
          };

          vm.cancel = function () {
            $rootScope.$broadcast('ModalFactory.close', 'close');
          };

          vm.confirm = function () {
            $rootScope.$broadcast('ModalFactory.close', vm.model);
          }

        }, "vm", false,
        {data: variables, theme: vm.theme})
        .then(function (response) {
          deffered.resolve(response)
        })
        .catch(function (error) {
          deffered.reject(error)
        });
      return deffered.promise;
    };

    /**
     * Verifica a quantidade de variaveis
     * @return {function(*): *}
     */
    vm.isTwoVariable = function (item) {
      switch (true) {
        case item.operator.value === 'between':
          return true;
        case item.operator.value === 'notbetween' :
          return true;
        case item.operator.value === 'in':
          return false;
        case item.operator.value === 'notin':
          return false;
        default:
          return false;
      }
    };

    vm.setTheme = function (theme) {
      vm.theme = theme;
    };


    return function (json) {
      vm.json = json;
      return vm;
    };

  }

  angular.module('app.controlpanel.central-reports')
    .factory('JockerVariables', JockerVariables)

})();
(function () {
  'use strict';

  angular
    .module('app.controlpanel.app-log', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function AppLogService(Restangular) {

    var vm = this;

    vm.getAll = function (obj) {
      return Restangular.one('applog').get(obj);
    };
    vm.getFormInfo = function () {
      return Restangular.one('applog').one('forminfo').get();
    };
    vm.create = function (obj) {
      return Restangular.all('applog').post(obj);
    };
    vm.saveEvaluation = function (obj) {
      return Restangular.all('applog').all('saveeval').post(obj);
    };
    vm.delete = function (id) {
      return Restangular.one('applog', id).remove();
    };
    vm.update = function (obj) {
      return Restangular.one('applog', obj.id).customPUT(obj);
    };
    return vm;
  }

  angular
    .module('app.controlpanel.app-log')
    .factory('AppLogService', AppLogService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.controlpanel.app-log', {
        url: '/app-log',
        public: false,
        templateUrl: 'app/controlpanel/app-log/views/index.html',
        controller: 'AppLogController',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Relatório do sistema'
        }
      });
  }

  angular
    .module('app.controlpanel.app-log')
    .config(routerConfig);


})();




(function () {
  'use strict';

  /** @ngInject */
  function AppLogController($q, $document, $scope, $a4FloatButton, $mdDialog, a4Moment, ModalFactory, Common, $rootScope, AppLogService, Session,
                            AppLog, CONFIG) {

    var vm = this;
    vm.current_connection = $document[0].domain.split('.')[0];
    vm.items = [];
    vm.grid = [];
    vm.list = {app_log_history: {}};
    vm.form = {
      mode_edit: true,
      app_log_history: {}
    };
    vm.user = Session.getUser();
    vm.timelineOptions = {
      scrollEl: '#content'
    };
    vm.currentPage = 1;
    vm.pauseScroll = false;
    vm.totalPages = 3;
    vm.timeline = [];
    vm.webLink = CONFIG.webApiUri;

    vm.icon_type =
      {
        1: 'a4educational.png',
        2: 'a4geral.png',
        51: 'a4finance.png',
        148: 'a4crm.jpg'
      };

    vm.loadNextPage = function () {
      var deferred = $q.defer();
      vm.getAllLog(vm.currentPage, 4);
      deferred.resolve(true);
    };
    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      if (vm.current_connection === 'labs' || vm.current_connection === 'a4simetria' || vm.current_connection === 'a4tecnologia') {
        vm.floatButton = $a4FloatButton({
          scope: $scope, onClick: 'vm.createLog()', label: 'Criar novo log', theme: 'controlpanel'
        });
      }
      vm.getAllLog(4);
    };

    /**
     * Exclui um motivo de cancelamento
     * @param id
     */
    vm.delete = function (id) {
      ModalFactory.confirm(null, 'Excluir log', 'Confirma a exclusão desse log? Essa ação não poderá ser desfeita.',
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          $rootScope.show_loader = true;
          AppLogService.delete(id)
            .then(function () {
              vm.getAllLog();
              Common.Toast.success('Log excluído com sucesso!');
            })
        })
    };

    vm.createLog = function () {
      ModalFactory.customClean(
        'app/controlpanel/app-log/views/form.html',
        'AppLogCreateEditController',
        'vm', false, {}
      ).then(function () {
        vm.getAllLog();
      });
    };

    /**
     * Edita um motivo de cancelamento
     * @param item
     */
    vm.editLog = function (item) {
      if (vm.current_connection === 'labs' || vm.current_connection === 'a4simetria' || vm.current_connection === 'a4tecnologia') {
        if (item.description !== null) {
          var regex1 = /<p>/gi;
          var regex2 = /<\/p>/gi;
          item.description = item.description.replaceAll(regex1, '').replaceAll(regex2, '');
        }
        ModalFactory.customClean(
          'app/controlpanel/app-log/views/form.html',
          'AppLogCreateEditController',
          'vm', false, item
        ).then(function () {
          vm.getAllLog();
        });
      }
    };

    vm.convertScope = function (scope) {
      var obj = {};
      switch (scope) {
        case "1":
          obj.title = "Ed. infantil";
          obj.cssClass = "badgeEdInf";
          break;
        case "2":
          obj.title = "Ed. básica";
          obj.cssClass = "badgeEdBas";
          break;
        case "3":
          obj.title = "Faculdade";
          obj.cssClass = "badgeFacul";
          break;
        case "4":
          obj.title = "Curso livre";
          obj.cssClass = "badgeFreeCourse";
          break;
      }
      return obj;
    };

    vm.defineScopes = function (scopes) {
      if (scopes !== null) {
        var regex1 = /{/gi;
        var regex2 = /}/gi;

        scopes = scopes.replaceAll(regex1, '').replaceAll(regex2, '').split(',')
          .map(function (scope) {
            return vm.convertScope(scope);
          });
      }
      return scopes;
    };

    vm.evaluateCard = function (card, button) {
      card.buttons.map(function (item) {
        if (item.id !== button.id) {
          item.selected = false;
        }
      });
      var but = card.buttons[button.id - 1];
      if (!but.selected) {
        card.has_button_selected = true;
        card.buttons[button.id - 1].selected = true;
        card.button_selected = button.id;
      } else {
        card.has_button_selected = false;
        card.buttons[button.id - 1].selected = false;
        card.button_selected = null;
      }
    };

    vm.saveEvaluation = function (card) {
      $rootScope.show_loader = true;
      AppLogService.saveEvaluation({
        app_log_history_id: card.id,
        feedback: card.feedback,
        rating: card.button_selected
      }).then(function (response) {
        $rootScope.show_loader = false;
        if (response) {
          Common.Toast.success('Avaliação salva com sucesso!');
          vm.getAllLog(4);
        }
      })
    };

    /**
     * Retorna logs
     * @param limit
     */
    vm.getAllLog = function (limit) {
      /*$rootScope.show_loader = true;*/
      var array = [];
      AppLogService.getAll({page: vm.currentPage, limit: limit}).then(function (response) {
        vm.logs = response.plain();
        vm.logs.forEach(function (item) {
          var icon = vm.icon_type[item.sys_module_id_app];
          var scopes = vm.defineScopes(item.scope);
          var rating = item.rating;
          var feedback = item.feedback;
          var obj = {
            id: item.id,
            event: item.name,
            time: item.launch_date !== null ? a4Moment(item.launch_date).format('DD/MM/YYYY') : item.launch_date,
            icon: "assets/images/logos/" + icon,
            type: item.type,
            module: item.sys_module,
            logInfo: item,
            sys_module_app: item.sys_module_id_app,
            card: {
              id: item.id,
              logInfo: item,
              title: item.name,
              feedback: feedback,
              text: item.description,
              scopes: scopes,
              clicked: vm.evaluateCard,
              save: vm.saveEvaluation,
              edit: vm.editLog,
              has_button_selected: rating !== null,
              button_selected: rating,
              buttons:
                [
                  {
                    id: 1,
                    title: 'Não uso :/',
                    color: 'rgba(192,192,192,0.68)',
                    selected: rating === 1
                  },
                  {
                    id: 2,
                    title: 'Não gostei :(',
                    color: 'rgba(201,69,72,0.47)',
                    selected: rating === 2
                  },
                  {
                    id: 3,
                    title: 'Tanto faz :|',
                    color: 'rgba(229,222,49,0.64)',
                    selected: rating === 3
                  },
                  {
                    id: 4,
                    title: 'Gostei :)',
                    color: 'rgba(63,207,33,0.63)',
                    selected: rating === 4
                  },
                  {
                    id: 5,
                    title: 'Amei :D',
                    color: 'rgba(75,172,206,0.47)',
                    selected: rating === 5
                  }
                ],
              template: "app/controlpanel/app-log/templates/template-9.html",
              media: {
                image: {
                  src: item.file_reference !== null ? vm.webLink + item.file_reference :
                    null,
                  alt: ""
                }
              }
            }
          };
          array.push(obj);
        });
        vm.timeline = array;
        vm.currentPage++;
        $rootScope.show_loader = false;
      })
    };

    vm.init();
  }

  angular
    .module('app.controlpanel.app-log')
    .controller('AppLogController', AppLogController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function AppLogCreateEditController($scope, $a4FloatButton, $mdDialog, ModalFactory, Common, DiscountsService, $rootScope,
                                      CancelReasonsService, ModalExtra, $mdEditDialog, AppLogService, RolesService, $document,
                                      $window) {

    var vm = this;
    vm.items = [];
    vm.grid = [];
    vm.list = {app_log_history: {}};
    vm.form = {
      mode_edit: true,
      app_log_history: {}
    };
    vm.img_base64 = null;
    vm.img_load = false;
    vm.input_app_log_image = angular.element('#app_log_image');
    vm.log_image = {};

    vm.sys_module_id = null;
    $window.addEventListener('paste', function(e){
      vm.img_load = false;
      // vm.input_app_log_image.files = e.clipboardData.files;
      retrieveImageFromClipboardAsBase64(e, function (imageDataBase64) {
        // If there's an image, open it in the browser as a new window :)
        // vm.img_base64 = imageDataBase64;
        // vm.log_image.file = imageDataBase64;
      });
    });

    /**
     * This handler retrieves the images from the clipboard as a base64 string and returns it in a callback.
     *
     * @param pasteEvent
     * @param callback
     */
    function retrieveImageFromClipboardAsBase64(pasteEvent, callback, imageFormat) {
      if (pasteEvent.clipboardData == false) {
        if (typeof (callback) == "function") {
          callback(undefined);
        }
      }
      ;
      var items = pasteEvent.clipboardData.files;
      if (items === undefined) {
        if (typeof (callback) == "function") {
          callback(undefined);
        }
      }
      ;

      for (var i = 0; i < items.length; i++) {
        // Skip content if not image
        if (items[i].type.indexOf("image") === -1) continue;
        // Retrieve image on clipboard as blob
        var blob = items[i];

        // Create an abstract canvas and get context
        var mycanvas = document.createElement("canvas");
        var ctx = mycanvas.getContext('2d');

        // Create an image
        var img = new Image();

        // Once the image loads, render the img on the canvas
        img.onload = function () {
          // Update dimensions of the canvas with the dimensions of the image
          mycanvas.width = this.width;
          mycanvas.height = this.height;
          ctx.drawImage(img, 0, 0);
          alert("Imagem carregada");
          vm.img_load = true;
          vm.img_base64 = mycanvas.toDataURL(
            (imageFormat || "image/png")
          );
          vm.log_image.file = vm.img_base64;
          // Execute callback with the base64 URI of the image
          // if(typeof(callback) == "function"){
          //   callback(mycanvas.toDataURL(
          //     (imageFormat || "image/png")
          //   ));
          // }

        };
        var URLObj = window.URL || window.webkitURL;
        img.src = URLObj.createObjectURL(blob);
      }
    }

    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      $rootScope.show_loader = true;
      AppLogService.getFormInfo()
        .then(function (resp) {
          vm.list.app_log_history.type = resp.type;
          vm.list.app_log_history.issue_status = resp.issue_status;
          vm.list.app_log_history.publish_status = resp.publish_status;
          vm.list.app_log_history.manual_update_status = resp.manual_update_status;
          vm.list.app_log_history.sys_module_id = resp.sys_module_id;
          vm.list.app_log_history.scope = resp.scope;
          vm.list.app_log_history.sys_module_id_app = resp.sys_module_id_app;
          vm.form.app_log_history = ModalExtra;
          $rootScope.show_loader = false;
        });
      RolesService.getResourcesTree()
        .then(function (resp) {
          vm.data = resp.plain();
        })
    };
    vm.myCroppedImage = '';
    vm.imageFormat = '';
    vm.handleFileSelect = function (event) {
      var file = event.currentTarget.files[0];
      var reader = new FileReader();

      reader.onload = function (event) {
        $scope.$apply(function ($scope) {
          vm.myImage = event.target.result;
        });
      };

      reader.readAsDataURL(file);
    };

    vm.selectImage = function (event) {
      vm.handleFileSelect(event);
    };
    /**
     * Cria novo log
     */
    vm.submit = function (item, form) {
      if (vm.sys_module_id !== null) {
        item.sys_module_id = vm.sys_module_id.pop();
      }
      item.log_image = vm.log_image;
      $rootScope.show_loader = true;
      if (angular.isUndefined(item.id)) {
        if (vm.sys_module_id === null) {
          Common.Toast.warning('Selecione um módulo!');
          $rootScope.show_loader = false;
        }
        AppLogService.create(item)
          .then(function () {
            vm.close();
            $rootScope.show_loader = false;
            Common.Toast.success('Log criado com sucesso!');
          })
      } else {
        AppLogService.update(item)
          .then(function () {
            vm.close();
            $rootScope.show_loader = false;
            Common.Toast.success('Log editado com sucesso!');
          })
      }
    };

    /**
     * Fecha modal
     * @param data
     */
    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.init();
  }


  angular
    .module('app.controlpanel.app-log')
    .controller('AppLogCreateEditController', AppLogCreateEditController);

})();

(function () {
  'use strict';
  angular.module('app.crm.reports', []);
})();
(function () {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.crm.reports', {
        url: '/reports',
        public: false,
        abstract: true,
        templateUrl: 'app/crm/reports/views/reports-page.html',
      })
      .state('private.crm.reports.list', {
        url: '/list',
        public: false,
        views: {
          'reports': {
            templateUrl: 'app/crm/reports/views/list.html',
            controller: 'ReportsController',
            controllerAs: 'vm',
          }
        }
      }).state('private.crm.reports.charge-report', {
      url: '/reports',
      public: false,
      views: {
        'reports': {
          templateUrl: 'app/crm/reports/charge-report/index.html',
          controller: 'ChargeReportController',
          controllerAs: 'vm',
        }
      }
    })
  }


  angular
    .module('app.crm.reports')
    .config(routerConfig);


})();



(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('crm.reports', {
      title: 'Relatórios',
      icon: 'icon-chart-line',
      state: 'private.crm.reports.list',
      class: "md-primary",
      weight: 8
    });
  }

  angular
    .module('app.crm.reports')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function ReportsController($rootScope, $window) {
    var vm = this;
    vm.windowHeight = $window.innerHeight - 64;
    $rootScope.show_loader = false;

    /**
     * Lista de recursos de configurações
     */
    vm.boardList = [
      {
        "name": "Relatório de cobranças",
        "state": "private.crm.reports.charge-report",
        "icon": 'icon-cash-usd',
        "description": "Relatório de cobranças",
        "policy": true
      }
    ];

  }

  angular.module('app.crm.reports')
    .controller('ReportsController', ReportsController)
})();
(function () {
  'use strict';

  angular.module('app.crm.prospects', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.crm.prospects', {
        url: '/prospects',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/crm/prospects/views/prospects.html',
        controller: 'ProspectsController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.crm.prospects')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run($document, msNavigationService) {
    var current_connection = $document[0].domain.split('.')[0];
    var hidden = !(current_connection === 'labs' || current_connection === 'a4simetria' || current_connection === 'a4tecnologia');
    msNavigationService.saveItem('crm.prospects', {
      title: 'Prospecção',
      icon: 'icon-account-search',
      state: 'private.crm.prospects',
      class: "md-primary",
      weight: 4,
      hidden: function () {
        return hidden;
      }
    });
  }

  angular
    .module('app.crm.prospects')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function ProspectsController($scope, $rootScope) {
    var vm = this;


  }

  angular.module('app.crm.prospects')
    .controller('ProspectsController', ProspectsController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function LeadsService(Restangular) {

    var getLeads = function (obj) {
      return Restangular.one('leads').get(obj);
    };

    var getFormInfo = function (obj) {
      return Restangular.one('leads').one('getforminfo').get(obj);
    };

    var getById = function (id) {
      return Restangular.one('leads', id).get();
    };

    var getLeadContacts = function (obj) {
      return Restangular.one('leads').one('getleadcontacts').get(obj);
    };

    var createLead = function (obj) {
      return Restangular.all('leads').post(obj);
    };

    var updateLead = function (obj, id) {
      return Restangular.one('leads', id).customPUT(obj);
    };

    return {
      createLead: createLead,
      getById: getById,
      getLeadContacts: getLeadContacts,
      getLeads: getLeads,
      getFormInfo: getFormInfo,
      updateLead: updateLead
    };

  }

  angular
    .module('app.crm.leads')
    .factory('LeadsService', LeadsService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.crm.leads', {
        url: '/leads',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/crm/leads/views/leads.html',
        controller: 'LeadsController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.crm.leads')
    .config(routerConfig);

})();





(function () {
	'use strict';

	/** @ngInject */
	function run($document, msNavigationService) {
		var current_connection = $document[0].domain.split('.')[0];
		var hidden = !(current_connection === 'labs' || current_connection === 'a4simetria' || current_connection === 'a4tecnologia');
		msNavigationService.saveItem('crm.leads', {
			title: 'Leads',
			icon: 'icon-account-network',
			state: 'private.crm.leads',
			class: "md-primary",
			weight: 3,
			hidden: function () {
				return hidden;
			}
		});
	}

	angular
		.module('app.crm.leads')
		.run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function LeadsController($scope, $state, $rootScope, $a4FloatButton, Common, ModalFactory, LeadsService) {
    var vm = this;
    vm.leads = {};
    vm.PESSOA_JURIDICA = 2;
    vm.CONTATO_DE_EMPRESA = 50;
    vm.search = '';

    vm.init = function () {
      vm.floatButton = $a4FloatButton({
        scope: $scope,
        theme: 'crm',
        label: 'Adicionar lead',
        icon: 'person_add',
        onClick: 'vm.addLead()'
      });

      vm.getLeads(1, 15);
    };

    vm.goToLeadPage = function (lead) {
      $state.go('private.crm.lead', {person_id: lead.id});
    };

    vm.addLead = function () {
      ModalFactory.customClean("app/crm/leads/views/modal.html",
        "LeadsModalController", "vm", false, {
          lead: {person_sex_id: 'M', sales_stage_id: 10, type: vm.PESSOA_JURIDICA},
          contacts: []
        }
      )
        .then(function (response) {
          if (response) {
            Common.Toast.success("Lead criado com sucesso!");
            vm.getLeads();
          }
        });
    };

    vm.editLead = function (person_id) {
      $rootScope.show_loader = true;
      LeadsService.getById(person_id).then(function (response) {
        var leadInfo = response.plain();
        $rootScope.show_loader = false;
        ModalFactory.customClean("app/crm/leads/views/modal.html",
          "LeadsModalController", "vm", false, {lead: leadInfo.lead, contacts: leadInfo.contacts})
          .then(function (response) {
            if (response) {
              Common.Toast.success("Lead atualizado com sucesso!");
              vm.getLeads();
            }
          })

      });
    };

    vm.getLeads = function (page, limit) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 15;
      page = angular.isDefined(page) ? page : 1;
      LeadsService.getLeads({limit: limit, page: page, query: vm.search}).then(function (response) {
        vm.leads = response;
        vm.leads.data = response.data;
        vm.leads.info = {
          limit_options: [15, 30, 60, {
            label: 'Todos',
            value: function () {
              return response.total;
            }
          }],
          limit: limit,
          page: page,
          total: response.total
        };
        $rootScope.show_loader = false;
      });
    };

    vm.init();
  }

  angular
    .module('app.crm.leads')
    .controller('LeadsController', LeadsController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function LeadsModalController($scope, $rootScope, $mdDialog, LeadsService, ModalExtra) {
    var vm = this;
    vm.loader = false;
    vm.CONTATO_DE_EMPRESA = 50;

    vm.formInfo = {
      salesStages: [],
      contactRoles: []
    };
    vm.salesStages = [];
    vm.personSex = [
      {id: 'M', 'name': 'Masculino'},
      {id: 'F', 'name': 'Feminino'}
    ];

    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.getFormInfo = function () {
      vm.loader = true;
      LeadsService.getFormInfo().then(function (response) {
        vm.formInfo = response.plain();
        vm.loader = false;
      })
    };

    vm.init = function () {
      vm.lead = ModalExtra.lead;
      vm.contacts = ModalExtra.contacts;
      vm.getFormInfo();
    };


    vm.save = function () {
      vm.loader = true;
      if (vm.lead.id) {
        LeadsService.updateLead({lead: vm.lead, contacts: vm.contacts}, vm.lead.id).then(function () {
          vm.loader = false;
          $mdDialog.hide(true);
        })
      } else {
        LeadsService.createLead({lead: vm.lead, contacts: vm.contacts}).then(function () {
          vm.loader = false;
          $mdDialog.hide(true);
        })
      }
    };

    vm.init();

  }

  angular.module('app.crm.leads')
    .controller('LeadsModalController', LeadsModalController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function EmailManagementService(Restangular) {

    var getAllIndividual = function (obj) {
      return Restangular.one('email_management').get(obj);
    };

    var getAllGrouped = function (obj) {
      return Restangular.one('email_management').one('getallgrouped').get(obj);
    };

    return {
      getAllIndividual: getAllIndividual,
      getAllGrouped: getAllGrouped
    };

  }

  angular
    .module('app.crm.emailmanagement')
    .factory('EmailManagementService', EmailManagementService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.crm.individual-email-management', {
        url: '/individual-email-management',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/crm/email-management/individual/index.html',
        controller: 'IndividualEmailManagementController',
        controllerAs: 'vm'
      }).state('private.crm.grouped-email-management', {
      url: '/grouped-email-management',
      public: false,
      auth: 'finance_dash',
      templateUrl: 'app/crm/email-management/grouped/index.html',
      controller: 'GroupedEmailManagementController',
      controllerAs: 'vm'
    });
  }

  angular
    .module('app.crm.emailmanagement')
    .config(routerConfig);

})();





(function () {
  'use strict';

  angular
    .module('app.crm.dashboard', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.crm.dashboard', {
        url: '/dashboard',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/crm/dashboard/dashboard.html',
        controller: 'DashboardCrmController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.crm.dashboard')
    .config(routerConfig);

})();





(function () {
	'use strict';

	/** @ngInject */
	function run(msNavigationService) {
		msNavigationService.saveItem('crm.dashboard', {
			title: 'Dashboard',
			icon: 'icon-window-restore',
			state: 'private.crm.dashboard',
			class: "md-primary",
			weight: 1
		});
	}

	angular
		.module('app.crm.dashboard')
		.run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function DashboardController() {
    var vm = this;
    vm.init = function () {
    };

    vm.init();
  }

  angular
    .module('app.crm.dashboard')
    .controller('DashboardCrmController', DashboardController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ChargeService(Restangular) {

    var getAll = function (obj) {
      return Restangular.one('charges').get(obj);
    };

    var getEventFormats = function (obj) {
      return Restangular.one('charges').one('geteventformats').get(obj);
    };

    var getEventTypes = function (obj) {
      return Restangular.one('charges').one('geteventtypes').get(obj);
    };

    var createCharge = function (obj) {
      return Restangular.all('charges').post(obj);
    };

    var editCharge = function (obj) {
      return Restangular.one('charges', obj.id).customPUT(obj);
    };

    var deleteCharge = function (obj) {
      return Restangular.one('charges', obj.id).remove();
    };

    return {
      createCharge: createCharge,
      deleteCharge: deleteCharge,
      getAll: getAll,
      getEventFormats: getEventFormats,
      getEventTypes: getEventTypes,
      editCharge: editCharge
    };

  }

  angular
    .module('app.crm.dashboard')
    .factory('ChargeService', ChargeService);

})();

(function () {
  'use strict';

  angular
    .module('app.crm.charge', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.crm.charge', {
        url: '/charge',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/crm/charge/charge.html',
        controller: 'ChargeController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.crm.charge')
    .config(routerConfig);

})();





(function () {
	'use strict';

	/** @ngInject */
	function run(msNavigationService) {
		msNavigationService.saveItem('crm.charge', {
			title: 'Cobrança',
			icon: 'icon-square-inc-cash',
			state: 'private.crm.charge',
			class: "md-primary",
			weight: 5
		});
	}

	angular
		.module('app.crm.charge')
		.run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function ChargeController() {
    var vm = this;


  }

  angular
    .module('app.crm.dashboard')
    .controller('ChargeController', ChargeController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ChargeModalController($rootScope, $scope, $a4FloatButton, a4Moment, ChargeService, Common,
                                 LeadsService, Session, ModalExtra, ModalFactory, PersonService) {
    var vm = this;

    vm.type = ModalExtra.type;
    vm.event = vm.type === 'charge' ? 'cobrança' : 'prospecção';
    vm.is_prospect = vm.type === 'prospects';
    vm.event_contacts = [];
    vm.form = {
      time_done: null,
      date_done: null,
      notes_done: null,
      time_scheduled: null,
      date_scheduled: null,
      notes_scheduled: null,
      event_type_id: null,
      event_format_id: null,
      event_nature_id: vm.is_prospect ? 15 : 8
    };
    vm.without_programation = 0;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.responsible = angular.isDefined(ModalExtra.responsible) ? ModalExtra.responsible : null;
    vm.withResponsible = angular.isDefined(ModalExtra.responsible);
    vm.charger = {
      id: Session.user.id,
      name: Session.user.person.name
    };


    /**
     * Busca todos os formatos de eventos
     */
    vm.getEventFormats = function () {
      ChargeService.getEventFormats().then(function (response) {
        vm.event_formats = response.plain();
      })
    };

    /**
     * Busca todos os tipos de eventos
     */
    vm.getEventTypes = function () {
      ChargeService.getEventTypes({type: vm.type}).then(function (response) {
        vm.event_types = response.plain();
      })
    };

    /**
     * Formata todas as datas e horários do formulário
     */
    vm.formatDatesAndHours = function () {
      vm.form.date_done = (angular.isDefined(vm.form.date_done) && vm.form.date_done !== null && !vm.is_programated) ? a4Moment(vm.form.date_done).format('YYYY-MM-DD') : null;
      vm.form.date_scheduled = (angular.isDefined(vm.form.date_scheduled) && vm.form.date_scheduled !== null) ? a4Moment(vm.form.date_scheduled).format('YYYY-MM-DD') : null;
      vm.form.time_done = (angular.isDefined(vm.form.time_done) && vm.form.time_done !== null && !vm.is_programated) ? a4Moment(vm.form.time_done).format('H:mm') : null;
      vm.form.time_scheduled = (angular.isDefined(vm.form.time_scheduled) && vm.form.time_scheduled !== null) ? a4Moment(vm.form.time_scheduled).format('H:mm') : null;
    };

    vm.time_done_change = function () {

    };

    vm.time_scheduled_change = function () {

    };

    vm.date_done_change = function () {

    };

    vm.date_scheduled_change = function () {

    };

    /**
     * Salva o evento de cobrança
     */
    vm.save = function () {
      vm.formatDatesAndHours();
      vm.form.person_id = vm.responsible.id;
      vm.form.person_id_owner = Session.user.id;
      vm.form.person_id_event = vm.charger.id;
      vm.loader = true;
      ChargeService.createCharge(vm.form).then(function (response) {
        if (response) {
          vm.close(true);
          Common.Toast.success('Evento criado com sucesso!');
          vm.loader = false;
        } else {
          Common.Toast.error('Ocorreu um erro!');
          vm.loader = false;
        }
      })
    };


    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.getResponsibles = function (query) {
      return PersonService.getPersonWithFilter({
        query: query,
        selected_tab: (vm.type === 'charge' ? 66 : 67),
        is_crm: true
      });
    };

    vm.changeResponsible = function (responsible) {
      if (vm.type === 'prospects') {
        LeadsService.getLeadContacts({person_id: responsible.id})
          .then(function (contacts) {
            vm.event_contacts = contacts.plain();
          })
      }
    };


    vm.getCollaborators = function (query) {
      return PersonService.getPersonWithFilter({query: query, selected_tab: 4});
    };

    vm.init = function () {
      vm.getEventFormats();
      vm.getEventTypes();
      vm.conf.user_id = Session.user.id;
      vm.conf.user_name = Session.user.person.name;
      if (vm.withResponsible){
        vm.changeResponsible(vm.responsible);
      }
    };

    vm.init();
  }

  angular
    .module('app.crm.dashboard')
    .controller('ChargeModalController', ChargeModalController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function ChargeModalEditController($rootScope, $scope, $a4FloatButton, a4Moment, ChargeService, LeadsService, Common, ModalFactory, ModalExtra, PersonService) {
    var vm = this;

    vm.form = ModalExtra.form;
    vm.type = ModalExtra.type;
    vm.event = vm.type === 'charge' ? 'cobrança' : 'prospecção';
    vm.responsible = {
      id: vm.form.person_id,
      name: ModalExtra.responsible_name
    };

    vm.charger = {
      id: angular.isDefined(vm.form.person_id_event) && vm.form.person_id_event !== null ? vm.form.person_id_event : null,
      name: angular.isDefined(ModalExtra.person_event_name) && ModalExtra.person_event_name !== null ? ModalExtra.person_event_name : null
    };
    if (vm.charger.id === null) {
      vm.charger = null;
    }

    vm.is_edit = true;
    vm.time_done_change = false;
    vm.time_scheduled_change = false;
    vm.date_done_change = false;
    vm.date_scheduled_change = false;
    vm.loader = false;

    /**
     * Busca todos os formatos de eventos
     */
    vm.getEventFormats = function () {
      ChargeService.getEventFormats().then(function (response) {
        vm.event_formats = response.plain();
      })
    };

    /**
     * Busca todos os tipos de eventos
     */
    vm.getEventTypes = function () {
      ChargeService.getEventTypes().then(function (response) {
        vm.event_types = response.plain();
      })
    };

    /**
     * Formata todas as datas e horários do formulário
     */
    vm.formatDatesAndHours = function () {
      vm.form.time_done = (angular.isDefined(vm.form.time_done) && vm.form.time_done !== null) ? a4Moment(vm.form.time_done).format('H:mm') : null;
      vm.form.time_scheduled = (angular.isDefined(vm.form.time_scheduled) && vm.form.time_scheduled !== null) ? a4Moment(vm.form.time_scheduled).format('H:mm') : null;
      vm.form.date_done = (angular.isDefined(vm.form.date_done) && vm.form.date_done !== null) ? a4Moment(vm.form.date_done).format('YYYY-MM-DD') : null;
      vm.form.date_scheduled = (angular.isDefined(vm.form.date_scheduled) && vm.form.date_scheduled !== null) ? a4Moment(vm.form.date_scheduled).format('YYYY-MM-DD') : null;
    };

    /**
     * Faz o update do evento de cobrança
     */
    vm.save = function () {
      vm.loader = true;
      vm.formatDatesAndHours();
      vm.form.person_id = vm.responsible.id;
      vm.form.person_id_event = vm.charger.id;
      ChargeService.editCharge(vm.form).then(function (response) {
        if (response) {
          vm.close(true);
          Common.Toast.success('Evento editado com sucesso!');
          vm.loader = false;
        } else {
          Common.Toast.error('Ocorreu um erro!');
          vm.loader = false;
        }
      })
    };

    vm.time_done_change = function () {
      vm.time_done_change = true;
    };

    vm.time_scheduled_change = function () {
      vm.time_scheduled_change = true;
    };

    vm.date_done_change = function () {
      vm.date_done_change = true;
    };

    vm.date_scheduled_change = function () {
      vm.date_scheduled_change = true;
    };


    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.getResponsibles = function (query) {
      return PersonService.getPersonWithFilter({
        query: query,
        selected_tab: (vm.type === 'charge' ? 66 : 67),
        is_crm: true
      });
    };

    vm.changeResponsible = function (responsible) {
      if (vm.type === 'prospects') {
        LeadsService.getLeadContacts({person_id: responsible.id})
          .then(function (contacts) {
            vm.event_contacts = contacts.plain();
          })
      }
    };


    vm.getCollaborators = function (query) {
      return PersonService.getPersonWithFilter({query: query, selected_tab: 4});
    };


    vm.init = function () {
      if (vm.form.time_done !== null) {
        vm.form.time_done = new Date("2020-01-01 " + vm.form.time_done);
      }
      if (vm.form.time_scheduled !== null) {
        vm.form.time_scheduled = new Date("2020-01-01 " + vm.form.time_scheduled);
      }
      $scope.$applyAsync();
      vm.changeResponsible({id: vm.responsible.id});
      vm.getEventFormats();
      vm.getEventTypes();
      // vm.formatDatesAndHours();
    };

    vm.init();
  }

  angular
    .module('app.crm.dashboard')
    .controller('ChargeModalEditController', ChargeModalEditController);

})();

(function () {
  'use strict';

  angular.module('app.crm.activities', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('private.crm.activities', {
        url: '/activities',
        public: false,
        auth: 'finance_dash',
        templateUrl: 'app/crm/activities/views/activities.html',
        controller: 'ActivitiesController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.crm.activities')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function run($document, msNavigationService) {
    var current_connection = $document[0].domain.split('.')[0];
    var hidden = !(current_connection === 'labs' || current_connection === 'a4simetria' || current_connection === 'a4tecnologia');
    msNavigationService.saveItem('crm.activities', {
      title: 'Atividades',
      icon: 'icon-clipboard-outline',
      state: 'private.crm.activities',
      class: "md-primary",
      weight: 2,
      hidden: function () {
        return hidden;
      }
    });
  }

  angular
    .module('app.crm.activities')
    .run(run);

})();





(function () {
  'use strict';

  /** @ngInject */
  function ActivitiesController($scope, $state, $rootScope, a4Moment, ChargeService) {
    var vm = this;
    vm.selectedDate = a4Moment().startOf('day');
    vm.activities = [];
    vm.byDay = true;
    vm.byWeek = false;
    vm.byMonth = false;
    vm.selectedFilter = 'day';
    vm.options = {'byDay': 'por dia', 'byWeek': 'por semana', 'byMonth': 'por mês'};

    vm.setVisualization = function (selected) {
      vm.selectedFilter = selected.split('by')[1].toLowerCase();
      for (var option in vm.options){
        if (option !== selected){
          vm[option] = false;
        } else {
          vm[option] = true;
        }
      }

      vm.selectedDate = a4Moment().startOf('day');
      vm.getActivities();

      $scope.$applyAsync();
    };

    vm.previousDate = function () {
      vm.selectedDate = vm.selectedDate.subtract(1, vm.selectedFilter + "s");
      vm.getActivities();
      $scope.$applyAsync();
    };

    vm.nextDate = function () {
      vm.selectedDate = vm.selectedDate.add(1, vm.selectedFilter + "s");
      vm.getActivities();
      $scope.$applyAsync();
    };

    vm.goToLead = function (lead) {
      $state.go('private.crm.lead', {person_id: lead.person_id});
    };

    vm.getActivities = function () {
      $rootScope.show_loader = true;
      ChargeService.getAll(
        {
          date: angular.copy(vm.selectedDate).format('YYYY-MM-DD'),
          filterBy: vm.selectedFilter,
          type: 'prospects',
          order: 'asc'
        })
        .then(function (response) {
          vm.activities = response.plain();
          $rootScope.show_loader = false;
        })
    };

    vm.init = function () {
      vm.getActivities();
    };

    vm.init();

  }

  angular.module('app.crm.activities')
    .controller('ActivitiesController', ActivitiesController);
})();

(function () {
  'use strict';

  angular.module('app.widget-component',
    []);
})();

(function () {
  'use strict';
  /** @ngInject */
  function widgetComponent() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/widget-component/view/widget-component.html',
      scope: {
        questionnaire: '=',
        obj: '=',
        actionStatus: '='
      },
      controller: 'WidgetComponentController',
      controllerAs: 'vm'
    }
  }

  angular
    .module('app.widget-component')
    .directive('widgetComponent', widgetComponent)
})();

(function () {
  'use strict';

  /** @ngInject */
  function WidgetComponentController(ModalFactory, QuestionnairesService, $rootScope, $scope, $state, Common, Session) {
    var vm = this;

    vm.ACTION_STATUS = {
      0: 'Realizar',
      1: 'Continuar',
      10: 'Em correção',
      11: 'Ver correção',
      12: 'Fora da data',
      13: 'Fora do horário',
      14: 'Fora do horário',
      20: 'Concluído'
    };

    vm.obj = $scope.obj;
    console.log($scope.obj);
    vm.person_id = vm.obj.person_id;
    vm.group_id = vm.obj.group_id;
    vm.matrix_period = vm.obj.matrix_period;
    vm.cookie = vm.obj.cookie;

    vm.goToEvaluation = function (evaluation) {
      $rootScope.show_loader = true;
      if (evaluation.qp_status >= 10) {
        vm.cookie = "is_allowed";
      }
      QuestionnairesService.getEvaluationLink({
        person_id: vm.person_id,
        questionnaire_id: evaluation.id,
        group_id: vm.group_id,
        matrix_period: vm.matrix_period,
        cookie: vm.cookie
      }).then(function (link) {
        $rootScope.show_loader = false;
        var token = link.split('answer-questionnaire\/')[1];
        $state.go('public.answer-questionnaire', {
          token: token
        });
      }).catch(function (err) {
        $rootScope.show_loader = false;
        Common.Toast.error(err.data);
      })
    };

    vm.printQuestionnaire = function (evaluation) {
      QuestionnairesService.evaluationPrint({
        selected_option: 2,
        enrolment_period_ids: null,
        group_id: vm.group_id,
        questionnaire_id: evaluation.id,
        selected_column_option: 0,
        user_id: Session.user.id
      })
    };

    vm.evaluationAction = function (evaluation) {
      switch (evaluation.qp_status) {
        case 0:
        case 1:
          vm.goToEvaluation(evaluation);
          break;
        case 10:
        case 11:
          // TODO
          break;
        case 12 && evaluation.application_date !== null:
          ModalFactory.alert(
            "Ainda não é o dia da avaliação",
            "A avaliação estará disponível no dia   " + evaluation.application_date,
            'modal', "Ok", 'false',
            'educational'
          );
          break;
        case 13:
          ModalFactory.alert(
            "Está fora do Horário!",
            "Esta avaliação tem o horário de término as: " + evaluation.execution_time,
            'modal', "Ok", 'false',
            'educational'
          );
          break;
        case 14:
          ModalFactory.alert(
            "Está fora do Horário!",
            "Esta avaliação tem o horário de inicio as: " + evaluation.answer_max_time_minutes + " e termino as: " +
            evaluation.execution_time,
            'modal', "Ok", 'false',
            'educational'
          );
          break;
        case 20:
          vm.goToEvaluation(evaluation);
          break;
      }
    };
  }

  angular
    .module('app.widget-component')
    .controller('WidgetComponentController', WidgetComponentController)
})();

"use strict";
!function () {
  navigator.getMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia, window.hasUserMedia = function () {
    return navigator.getMedia ? !0 : !1
  }
}(), angular.module("webcam", []).directive("webcam", function () {
  return {
    template: '<div class="webcam" ng-transclude></div>',
    restrict: "E",
    replace: !0,
    transclude: !0,
    scope: {onError: "&", onStream: "&", onStreaming: "&", placeholder: "=", config: "=channel"},
    link: function (a, b) {
      var c = null, d = null, e = null;
      a.config = a.config || {};
      var f = function (a) {
        a && angular.element(a).remove()
      }, g = function () {
        d && "function" == typeof d.stop && d.stop(), c && delete c.src
      }, h = function (b) {
        if (d = b, navigator.mozGetUserMedia) c.mozSrcObject = b; else {
          var e = window.URL || window.webkitURL;
          c.src = e.createObjectURL(b)
        }
        c.play(), a.config.video = c, a.onStream && a.onStream({stream: b})
      }, i = function (b) {
        f(e), console && console.log && console.log("The following error occured: ", b), a.onError && a.onError({err: b})
      }, j = function () {
        c = document.createElement("video"), c.setAttribute("class", "webcam-live"), c.setAttribute("autoplay", ""), b.append(c), a.placeholder && (e = document.createElement("img"), e.setAttribute("class", "webcam-loader"), e.src = a.placeholder, b.append(e));
        var d = !1, g = b.width = a.config.videoWidth || 320, j = b.height = 0;
        if (!window.hasUserMedia()) return void i({code: -1, msg: "Browser does not support getUserMedia."});
        var k = {video: !0, audio: !1};
        navigator.getMedia(k, h, i), c.addEventListener("canplay", function () {
          if (!d) {
            var b = g / c.videoWidth;
            j = c.videoHeight * b || a.config.videoHeight, c.setAttribute("width", g), c.setAttribute("height", j), d = !0, a.config.video = c, f(e), a.onStreaming && a.onStreaming()
          }
        }, !1)
      }, k = function () {
        g(), c.remove()
      };
      a.$on("$destroy", g), a.$on("START_WEBCAM", j), a.$on("STOP_WEBCAM", k), j()
    }
  }
});
(function () {
    'use strict';
    angular
        .module('app.utils', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function Utils($filter, a4Moment) {

    /**
     * Concatena a string de detalhes para mostrar no grid
     * @param item
     * @param debitcredit
     * @returns {string}
     */
    function detailByMovement(item, debitcredit) {
      if (item.hasOwnProperty('suggested_date') || item.hasOwnProperty('date')) {
        var date = item.suggested_date !== null && item.suggested_date !== '' ? a4Moment(item.suggested_date) : null;
        var date_formated = date !== null && date !== '' ? date.format('DD/MM/YYYY') : null;
        item.suggested_date = date !== null && date !== '' ? date.format('YYYY-MM-DD') : null;
        item.formatted_date = a4Moment(item.date).format('DD/MM/YYYY');
        item.date = a4Moment(item.date).format('YYYY-MM-DD');
      }

      var result = '';
      //debugger;
      switch (parseInt(item.movement_type_id)) {
        case 2:
          //cheque
          if (debitcredit.toLowerCase() === 'd') {
            result = "Ch." + item.document;
          } else {
            result += item.bank !== null ? "Bco: " + item.bank.number_bank : "Bco: " + item.number_bank;
            result += item.branch !== null ? " / Ag:" + item.branch : " / Ag: --- ";
            result += item.account !== null ? " / cc:" + item.account : " / cc: --- ";
            result += item.number !== null ? " / Ch:" + item.number : " / Ch: --- ";
            if (angular.isDefined(item.formatted_date)) {
              result += ' / Para: ' + item.formatted_date;
            }
          }
          break;
        case 5:
          //cheque de terceiros
          if (debitcredit.toLowerCase() === 'd') {
            result = item.detail;
          } else {
            result += item.bank !== null ? "Bco: " + item.bank.number_bank : "Bco: --- ";
            result += item.branch !== null ? "/ Ag:" + item.branch : "/ Ag: --- ";
            result += item.account !== null ? "/ cc:" + item.account : "/ cc: --- ";
            result += item.number !== null ? "/ Ch:" + item.number : "/ Ch: --- ";
          }
          break;
        case 20:
          //Cartão de débito recebimento
          if (debitcredit.toLowerCase() === 'c' && item.document !== undefined && item.card_number !== undefined && item.suggested_date !== undefined) {
            result = 'Ultimos 4 dg: ' + item.card_number + ' | Aut: ' + item.document + ' | Para: ' + date_formated;
          } else if (debitcredit.toLowerCase() === 'c' && item.document !== undefined && item.card_number !== undefined) {
            result = 'Ultimos 4 dg: ' + item.card_number + ' | Aut: ' + item.document;
          } else if (debitcredit.toLowerCase() === 'c' && item.document !== undefined && item.suggested_date !== undefined) {
            result = 'Aut: ' + item.document + ' | Para: ' + date_formated;
          } else if (debitcredit.toLowerCase() === 'c' && item.card_number !== undefined && item.suggested_date !== undefined) {
            result = 'Ultimos 4 dg: ' + item.card_number + ' | Para: ' + date_formated;
          } else if (debitcredit.toLowerCase() === 'c' && item.document !== undefined) {
            result = 'Aut: ' + item.document;
          } else if (debitcredit.toLowerCase() === 'c' && item.card_number !== undefined) {
            result = 'Ultimos 4 dg: ' + item.card_number;
          } else if (debitcredit.toLowerCase() === 'c' && item.suggested_date !== undefined) {
            result = 'Para: ' + date_formated;
          }
          //Cartão de débito pagamento
          if (debitcredit.toLowerCase() === 'd' && (item.suggested_date !== undefined && item.suggested_date !== null)) {
            result = 'Para: ' + date_formated;
          }
          break;
        case 21:
          //Cartão de crédito recebimento
          if (debitcredit.toLowerCase() === 'c' && item.document !== undefined && item.card_number !== undefined && item.suggested_date !== undefined) {
            result = 'Ultimos 4 dg: ' + item.card_number + ' | Aut: ' + item.document + ' | Para: ' + date_formated;
          } else if (debitcredit.toLowerCase() === 'c' && item.document !== undefined && item.card_number !== undefined) {
            result = 'Ultimos 4 dg: ' + item.card_number + ' | Aut: ' + item.document;
          } else if (debitcredit.toLowerCase() === 'c' && item.document !== undefined && item.suggested_date !== undefined) {
            result = 'Aut: ' + item.document + ' | Para: ' + date_formated;
          } else if (debitcredit.toLowerCase() === 'c' && item.card_number !== undefined && item.suggested_date !== undefined) {
            result = 'Ultimos 4 dg: ' + item.card_number + ' | Para: ' + date_formated;
          } else if (debitcredit.toLowerCase() === 'c' && item.document !== undefined) {
            result = 'Aut: ' + item.document;
          } else if (debitcredit.toLowerCase() === 'c' && item.card_number !== undefined) {
            result = 'Ultimos 4 dg: ' + item.card_number;
          } else if (debitcredit.toLowerCase() === 'c' && item.suggested_date !== undefined) {
            result = 'Para: ' + date_formated;
          }
          //Cartão de crédito pagamento
          if (debitcredit.toLowerCase() === 'd' && (item.suggested_date !== undefined && item.suggested_date !== null)) {
            result = 'Para: ' + date_formated;
          }
          break;
        default:
          result = '';
      }
      return result;
    }

    /**
     * Converte data de XXXX-XX-XX para XX/XX/XXXX
     * @param date
     * @return Date
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    function convertDateToInterface(date) {
      if (date !== null) {
        var dateconverted = date.split('-');
        return new Date(dateconverted[0], dateconverted[1], dateconverted[2]);
      }
    }

    /**
     * Converte data do formato dd/mm/yyyy para formato yyyy-mm-dd
     * @param date
     * @returns {*}
     */
    function convertDate(date) {
      if (date === undefined) {
        return null;
      }

      if (typeof date === 'string' && date.indexOf('/') > -1) {
        var dateconverted = date.split('/');
        return new Date(dateconverted[2], dateconverted[1], dateconverted[0]);
      } else {
        return date;
      }
    }

    /**
     * Converte data de XX-XX-XXXX para XX/XX/XXXX
     * @param date
     * @return String
     * @author Israel Brito <israel.brito@simetrianet.com.br>
     */
    function convertDateInvert(date) {
      var dateconverted = date.split('-');
      return dateconverted[2] + "/" + dateconverted[1] + "/" + dateconverted[0];
    }

    /**
     * Overwrites obj1's values with obj2's and adds obj2's if non existent in obj1
     * @param obj1
     * @param obj2
     * @returns obj3 a new object based on obj1 and obj2
     */
    function mergeObjects(obj1, obj2) {
      var obj3 = {};
      for (var attrname in obj1) {
        obj3[attrname] = obj1[attrname];
      }
      for (var attrname in obj2) {
        obj3[attrname] = obj2[attrname];
      }
      return obj3;
    }

    /**
     * Formata mascara de cnpj
     * @param v
     * @returns {string}
     */
    function formatToCNPJ(v) {

      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/, "$1.$2");
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
      v = v.replace(/(\d{4})(\d)/, "$1-$2");

      return v
    }

    /**
     * Mascara para numero de telefone
     * @param v
     * @returns {*}
     */
    function formatToPhoneNumber(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d\d)(\d)/g, "($1) $2");
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
      return v;
    }

    /**
     * Array com competencia dos ultimos dois anos
     * @returns {Array}
     */
    function getCompetenceArray() {
      var list = [];

      //intervalo dos ultimos dois anos
      var initYear = a4Moment().subtract(2, 'year').format('YYYY');
      var currYear = a4Moment().format('YYYY');

      //year
      for (var i = initYear; i <= currYear; i++) {
        //months
        for (var n = 0; n < 12; n++) {
          list.push({month: (n + 1), year: i});
        }
      }

      list.reverse();

      return list;
    }

    /**
     * Retorna os meses do ano (string)
     * @param id
     * @returns {string}
     */
    function monthById(id) {

      var months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ];

      return months[id];

    }

    /**
     * Retorna array de objetos com os meses
     * @returns {*[]}
     */
    function months() {
      return [
        {id: 1, name: 'Janeiro'},
        {id: 2, name: 'Fevereiro'},
        {id: 3, name: 'Março'},
        {id: 4, name: 'Abril'},
        {id: 5, name: 'Maio'},
        {id: 6, name: 'Junho'},
        {id: 7, name: 'Julho'},
        {id: 8, name: 'Agosto'},
        {id: 9, name: 'Setembro'},
        {id: 10, name: 'Outubro'},
        {id: 11, name: 'Novembro'},
        {id: 12, name: 'Dezembro'}
      ];
    }


    function roundFloat(number) {
      return (Math.round(number * 100, 2) / 100);
    }


    /**
     * Aplica mascara financeira no padrão (R$ 0,00)
     * @param value
     * @returns {string}
     */
    function realMask(value) {
      var currency;
      if (value == 0 || value == null) {
        currency = $filter('currency')(0, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      } else if (value > 0) {
        currency = $filter('currency')(value, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      }
    }

    /**
     * Convert a string XXXXXX para XX/XX/XX
     * @param str
     * @returns {string}
     */
    function convertSingleDate(str) {
      return str.substr(0, 2) + '/' + str.substr(2, 2) + '/' + str.substr(4, 2);
    }

    /**
     * Faz o usuário automaticamente copiar um texto
     * @param text
     */
    function copyToClipboard(text) {
      // create temp element
      var copyElement = document.createElement("span");
      copyElement.appendChild(document.createTextNode(text));
      copyElement.id = 'tempCopyToClipboard';
      angular.element(document.body.append(copyElement));

      // select the text
      var range = document.createRange();
      range.selectNode(copyElement);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      // copy & cleanup
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      copyElement.remove();
    }

    function hideEmail(email) {
      var first_part_mail = email.split('@')[0];
      var last_part_mail = email.split('@')[1];
      first_part_mail = first_part_mail.substring(0, 3) + first_part_mail.substring(3, first_part_mail.length).split('').map(function (string) {
        return string.replace(string, '*')
      })
        .join('');
      return first_part_mail + '@' + last_part_mail;
    }

    function hidePhone(phone) {
      return phone.substring(0, 5) + '-' + phone.substring(5, phone.length).split('').map(function (string) {
        return string.replace(string, '*')
      }).join('');
    }

    /**
     * Remove aspas duplas
     * @param string
     * @returns {*}
     */
    function removeDoubleQuotes(string) {
      return string.replace(/"/g, '').replace(/null/g, '');
    }

    function abbreviateString(string, length) {
      var string_length = string.length;
      if (length >= string_length) {
        return string;
      }
      var array_string = string.split(' ');
      var last_index_array = array_string.length - 1;
      var string_current_length = array_string[0].length + array_string[last_index_array].length + (string.split(' ').length - 1);
      for (var i = 1; i < last_index_array; i++) {
        if (array_string[i].length > 3 && (array_string[i].length + string_current_length +
          ((last_index_array - i) * 2)) > length) {
          array_string[i] = array_string[i].substr(0, 1) + '.';
        }
        string_current_length += array_string[i].length;
      }
      return array_string.join(' ');
    }

    function transformObjectInParametersUrl(obj){
      var urlParameters = '';
      for (var key in obj){
        var keyValue = key + '=' + obj[key];
        urlParameters += (urlParameters === '') ? keyValue : '&' + keyValue;
      }
      return urlParameters;
    }

    return {
      abbreviateString: abbreviateString,
      roundFloat: roundFloat,
      convertSingleDate: convertSingleDate,
      realMask: realMask,
      hideEmail: hideEmail,
      hidePhone: hidePhone,
      monthById: monthById,
      getCompetenceArray: getCompetenceArray,
      formatToPhoneNumber: formatToPhoneNumber,
      formatToCNPJ: formatToCNPJ,
      convertDateInvert: convertDateInvert,
      convertDate: convertDate,
      convertDateToInterface: convertDateToInterface,
      detailByMovement: detailByMovement,
      months: months,
      mergeObjects: mergeObjects,
      copyToClipboard: copyToClipboard,
      removeDoubleQuotes: removeDoubleQuotes,
      transformObjectInParametersUrl: transformObjectInParametersUrl
    };

  }

  angular
    .module('app.utils')
    .factory("Utils", Utils);
})();
(function () {
    'use strict';

    angular
      .module('app.treeview', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function Treeview() {
    Array.prototype.remove = function () {
      var what, a = arguments, L = a.length, ax;
      while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
          this.splice(ax, 1);
        }
      }
      return this;
    };

    /**
     * Modelo de Dados para o TreeView
     *
     *    {
     *    'text': 'Root node 2',
     *    'state': {
     *        'opened': true,
     *        'selected': true
     *    },
     *    'children': [
     *        {'text': 'Child 1'},
     *        'Child 2'
     *    ]
     * }
     */
    return {
      restrict: 'EA',
      scope: {
        data: "=",
        response: '=',
        three_state: '=',
        cascade: '=',
        plugins: '=?'
      },
      templateUrl: 'app/components/tree-view/templates/treeview.html',
      link: function (scope) {
        var selected = [];
        scope.plugins = angular.isDefined(scope.plugins) && scope.plugins !== '' ? scope.plugins : "checkbox,types,changed";
        scope.tree_state = angular.isUndefined(scope.tree_state) ? true : scope.tree_state;
        scope.typesConfig = {
          "default": {
            "icon": "icon-menu",

          },
          "checkbox": {
            "three_state": false
          }
        };

        scope.checkbox = {
          three_state: scope.tree_state,
        };

        if (angular.isDefined(scope.cascade)) {
          scope.checkbox.cascade = scope.cascade;
        }

        /**
         * Função que escuta a seleção de item na treeview
         * @param e - Evento
         * @param data - Dados do item
         */
        scope.changeCB = function (e, data) {
          //
          // selected.remove(data.changed.deselected[0]);
          // data.changed.deselected.forEach(function (value) {
          //   selected.remove(value);
          // });
          //
          // if(data.action === 'ready'){
          //   selected = selected.concat(data.selected);
          //   selected = selected.filter(function (value, index, self) {
          //     return self.indexOf(value) === index;
          //   })
          // } else{
          //   selected = selected.concat(data.changed.selected);
          //   selected.push(data.node.parent);
          //   selected = selected.filter(function (value, index, self) {
          //     return self.indexOf(value) === index;
          //   })
          // }
          if (angular.isDefined(data.changed)) {
            data.changed.deselected.forEach(function (value) {
              selected.remove(value);
            });
          }
          selected = selected.concat(data.selected);

          scope.response = selected;
          scope.$apply();
        }
      }
    };
  }

  angular
    .module('app.treeview')
    .directive("treeview", Treeview);
})
();


(function () {
  'use strict';
  angular
    .module('app.components', [
      'a4.cript',
      'a4-compress',
      'app.a4-menu-system',
      'app.a4address',
      'app.a4checks',
      'app.a4creditsperson',
      'app.a4optionsmovement',
      'app.a4birthinformations',
      'app.a4billsoperation',
      'app.a4-move-reports-to-folder',
      'app.a4studentform',
      'app.a4crmcontactgrid',
      'app.a4-app-log',
      'app.a4-card-controls',
      'app.a4studentcontactform',
      'app.a4studentresponsiblesform',
      'app.a4responsibleform',
      'app.a4responsiblecontactform',
      'app.a4collaboratorform',
      'app.a4collaboratorcontactform',
      'app.a4studentdocuments',
      'app.a4question',
      'app.a4pendentgrades',
      'app.a4productgroupconfig',
      'app.a4schoolrecordconfig',
      'app.a4emailserrors',
      'app.a4emailwarning',
      'app.a4stocktransactions',
      'app.a4persondocuments',
      'app.modal',
      'app.nestedlist',
      'app.utils',
      'app.a4cpf',
      'app.a4email',
      'app.a4-guide-button',
      'app.a4-table',
      'app.a4-table-check',
      'app.a4-table-expandable',
      'app.a4-table-installments',
      'app.a4-payments-grid',
      'app.a4-table-advanced',
      'app.a4-groups',
      'app.jsTree.directive',
      'app.treeview',
      'app.a4-upload-image',
      'app.select-grid',
      'app.select-rules',
      'app.a4-accounts-grid',
      'app.a4-charts',
      'app.a4-charts-bar',
      'app.a4-md-dialog',
      'app.date-range-picker',
      'app.a4-edit-table',
      'app.a4-table-installments',
      'app.numbers-only',
      'app.select-dropdown',
      'app.a4-detail-grid',
      'app.date-picker',
      'app.sidenav',
      'app.a4formdicdata',
      'app.a4-float-button',
      'app.a4searchfield',
      'app.a4-ui-tree',
      'app.a4-table-fixed',
      'app.a4-switch-button',
      'app.a4-upload-drag',
      'app.a4-calendar',
      'app.a4-file-upload',
      'app.a4-bill-grid',
      'app.a4-promise-queue',
      'app.a4-infinite-scroll',
      'app.a4-socket',
      'multi-select-tree',
      'app.widget-component',
      'app.a4-contract',
      'app.a4-bank-slip',
      'app.a4-contract-grid',
      'app.a4-filter',
      'app.a4-card-message',
      'app.a4-negotiation',
      'app.a4-negotiation-details',
      'app.a4-autocomplete',
      'app.a4-guest-check-pad-report',
      'app.a4-block-message',
      'app.a4-discounts',
      'app.a4-persons',
      'app.a4-subject-grid',
      'app.a4-digital-sign',
      'app.a4-board-list',
      'app.a4-process-list',
      'app.a4-process-filter',
      'app.a4-crud-table',
      'a4TreeGrid',
      'clmtrackr'
    ]);
})();

(function () {
  'use strict';

  /** @ngInject */
  function Toast($mdToast) {
    var vm = {};

    vm.success = function (message, time) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(angular.isUndefined(time) ? 5000 : time)
          .theme('success')
      );
    };

    vm.error = function (message, time) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(angular.isUndefined(time) ? 5000 : time)
          .theme('error')
      );
    };

    vm.warning = function (message, time) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(angular.isUndefined(time) ? 5000 : time)
          .theme('warning')
      );
    };

    return vm;
  }

  angular.module('app.components')
    .factory('Toast', Toast);

})();


angular.module('app.components').directive("showPassword", function () {
  return function linkFn(scope, elem, attrs) {
    scope.$watch(attrs.showPassword, function (newValue) {
      if (newValue) {
        elem.attr("type", "text");
      } else {
        elem.attr("type", "password");
      }
    });
  };
});
(function () {
    'use strict';

    angular
        .module('app.select-rules', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function selectRules(DiscountsService, AdditionsService, $filter, a4Moment, $rootScope) {
    return {
      template: '<div ng-include="getContentUrl()"></div>',
      restrict: "E",
      scope: {
        list: '=',
        disableInitialDate: '@',
        titleFirstField: '@',
        allrules: '='
      },
      link: function (scope, elements, attrs) {

        scope.isAddItem = false;
        scope.init = function () {
          scope.addBlankItem();
          if (attrs.templatename === 'discount') {
            scope.getAllDiscountsRules();
          }
          if (attrs.templatename === 'fines') {
            scope.getAlladditionsRules();
          }
        };

        /** Realiza a verificação se existe algum item de desconto na lista */
        var ltn = $rootScope.$on('UPDATE_DISCOUNTS_RULE_LIST', function () {
          scope.verifyIfHasMoreThenOneItens();
        });

        scope.convertDateAndAddDay = function (date, day) {
          if (date !== undefined && date !== null) {
            date = date.split("/");
            var newDate = date[1] + "," + date[0] + "," + date[2];
            var mDate = a4Moment(new Date(newDate)).add(1, 'days').format("YYYY-MM-DD");
            return $filter('date')(mDate, 'dd/MM/yyyy');
          }
        };

        scope.getContentUrl = function () {
          return 'app/components/select-rules/template/' + attrs.templatename + '.html';
        };

        scope.getAllDiscountsRules = function () {
          DiscountsService.getAllDiscountsRules()
            .then(function (response) {
              scope.alldiscounts = response;
              scope.addBlankItem();
            });
        };

        scope.getAlladditionsRoles = function () {
          AdditionsService.getAlladditionsRules()
            .then(function (response) {
              scope.alladditions = response;
            });
        };

        scope.addBlankItem = function (status) {
          if ((angular.isUndefined(scope.list) || scope.list.length <= 0) && angular.isUndefined(status)) {
            scope.list = [];
            scope.inserted = {
              idx: scope.list.length,
              discounts_rule_id: null,
              first_row: true,
              start_date: null,
              end_date: null
            };
            scope.list.push(scope.inserted);
          }
          if (status === 'edit') {
            scope.inserted = {
              idx: scope.list.length,
              first_row: false,
              start_date: null,
              end_date: null
            };
            scope.list.push(scope.inserted);
          }
        };

        scope.remove = function (index) {
          scope.list.splice(index, 1);
        };

        scope.$watch('list.length', function (newValue, oldValue) {

          if (oldValue < newValue && attrs.templatename === 'fines') {
            for (var i = 0; i < scope.list.length; i++) {
              if (typeof scope.list[i].date_first !== undefined) {
                var newDate = scope.convertDateAndAddDay(scope.list[i].date_end, 1);
                if (i < scope.list.length - 1) {
                  scope.list[i + 1].date_first = newDate;
                }
              }
            }
          }
        });

        scope.verifyIfHasMoreThenOneItens = function () {
          if (scope.list[0].end_date !== undefined && scope.list[0].end_date !== '' &&
            scope.list[0].start_date !== undefined && scope.list[0].start_date !== '' &&
            scope.list[0].discounts_rule_id !== undefined && scope.list[0].discounts_rule_id !== '') {
            scope.isAddItem = true;
          } else {
            scope.isAddItem = false;
          }
        };

        scope.verifyIfEndDateSmallerThanInitialDate = function (end, initial, index) {
          if (scope.dateToTimestamp(end)
            <= scope.dateToTimestamp(initial)) {
            scope.list[index].end_date = "";
            return true;
          }
          scope.verifyIfHasMoreThenOneItens();
          return false;
        };

        /**
         * Converte a data de XX/XX/XXXX para timestamp
         * @param {type} date
         * @returns {int} Timestamp
         * @author Israel Brito <israel.brito@simetrianet.com.br>
         */

        scope.dateToTimestamp = function (date) {
          if (date !== undefined && date !== "" && date !== null && typeof date !== 'object') {
            date = date.split("/");
            date = new Date(date[1] + "," + date[0] + "," + date[2]);
            return date.setDate(date.getDate() + 1);
          }
        };

        scope.$on('$destroy', function () {
          [ltn].forEach(function (fn) {
            fn();
          })
        });
        scope.init();
      }
    };
  }

  angular
    .module('app.select-rules')
    .directive('selectRules', selectRules);
})();
(function () {
  'use strict';

  angular
    .module('app.select-grid', []);
})();
(function () {
  'use strict';

    /** @ngInject */
  function SelectGrid($rootScope, $filter, a4Moment, $scope, Common) {
    return {
      restrict: "E",
      scope: {
        list: "=",
        paymentplans: "=",
        documents: "="
      },
        controller: 'SelectGridController',
        controllerAs: 'vm',
      templateUrl: 'app/components/select-grid/templates/single.html',
      link: function (scope, element, attr, controller) {
        scope.filtered = [];
        scope.selected = [];

        /**
         * Init
         */
        scope.init = function () {
          if (scope.list != null && scope.list.length === 0) {
            scope.addItem();
          }
        };

        /**
         * Adiciona itens a lista
         */
        scope.addItem = function () {
          scope.list.push(scope.createItemList());
        };

        /**
         * remove itens da lista
         * @param item
         * @param id
         */
        scope.removeItem = function (item, id) {
            controller.removePaymentPlan()
            .then(function () {
                if (scope.list.indexOf(item) !== -1) {
                    scope.list.splice(id, 1);
                    }
            });
        };

        /**
         * Cria o objeto padrão para a lista
         * @returns object
         */
        scope.createItemList = function () {
          return {price: null, date_first: null, ppp_id: null, product_id: null};
        };

        /**
         * Retorna a posição do item no array por seu id
         * @param value
         * @returns number
         */
        scope.getPosition = function (value) {
          var pos = null;
          angular.forEach(scope.selected, function (item, i) {
            if (pos == null && value === item.id) {
              pos = i;
            }
          });
          return pos;
        };

        /**
         * Retorna o plano de pagamento pelo id
         * @param id
         * @returns object
         */
        scope.getPaymentPlanById = function (id) {
          var result = null;
          angular.forEach(scope.paymentplans, function (item) {
            if (result == null && item.id === id) {
              result = item;
            }
          });
          return result;
        };

        /**
         * aplica mascara financeira no padrão (R$ 0,00)
         * @param value
         * @returns {string}
         */
        scope.applyMask = function (value) {
          var currency = 0;
          if (value === 0 || value == null) {
            currency = $filter('currency')(0, 'R$ ', 2);
            return currency;
          } else if (value > 0) {
            currency = $filter('currency')(value, 'R$ ', 2);
            return currency.replace(".", ",").replace(",", ".");
          }
        };

        /**
         * Checa se o formulario é valido e notifica ao controller
         */
        scope.$watch('list', function () {
          if (scope.isValidList(scope.list)) {
            $rootScope.$broadcast('Product.isValid', false);
          } else {
            $rootScope.$broadcast('Product.isValid', true);
          }
        }, true);

        /**
         * Checa se existem planos de pagamentos repetidos associados a lista
         * @param list
         * @returns {boolean}
         */
        scope.isValidList = function (list) {
          var result = false;
          var count = 0;
          angular.forEach(list, function (l) {
            if (!result) {
              var tmp = l.payment_plan_id;
              angular.forEach(list, function (t) {
                if (t.payment_plan_id === tmp) {
                  count = count + 1;
                }
              });
              if (count > 1) {
                result = true;
              }
              count = 0;
            }
          });
          return result;
        };

        scope.init();
      }
    };
  }

  SelectGrid.$inject = ['$rootScope', '$filter', 'toastr', 'ModalFactory'];
  angular
    .module('app.select-grid')
    .directive("selectgrid", SelectGrid);
})();
(function () {
    'use strict';

    /** @ngInject */
    function selectGridController($rootScope, $filter, ModalFactory){
        var vm = this;

        vm.removePaymentPlan = function () {
           return ModalFactory.confirm(null,
                "Desassociar plano de pagamento ao serviço",
                "Ao desassociar este plano de pagamento deste serviço, não será mais possível " +
               "criar contratos deste serviço com este plano de pagamento, entretanto, isso " +
               "não afetará os contratos que já foram criados vinculados a este plano.\n",
                'Desassociar', 'Cancelar',
                'finance')
        }

    }



    angular.module('app.select-grid').controller('SelectGridController', selectGridController);

})();
(function () {
  'use strict';

  angular
    .module('app.select-dropdown', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function selectDropdown() {

    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/select-dropdown/templates/index.html',
      scope: {
        title: '@',
        placeholder: '@',
        selectedItems: '=',
        value: '=ngModel',
        multiple: '@',
        ngChange: '&?'
      },

      link: function (scope, element, attrs) {
        scope.searchTerm;
        scope.clearSearchTerm = function () {
          scope.searchTerm = '';
        };

        element.find('input').on('keydown', function (ev) {
          ev.stopPropagation();
        });

        /**
         * isContained
         * Se o status esta contido no array de seleção
         * @param status_id
         * @returns {boolean}
         */
        scope.isContained = function (status_id) {
          if (status_id != null && scope.selectedItems != null && scope.selectedItems.length > 0) {

            var result = false;
            angular.forEach(scope.selectedItems, function (item, i) {
              if (item != null && item.id == status_id) {
                result = true;
              }
            });

            return result;
          }
        };

      }
    }
  }

  angular
    .module('app.select-dropdown')
    .directive('selectDropdown', selectDropdown)
})();

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('pdfViewer', pdfViewer);

  /** @ngInject */
  function pdfViewer() {
    return {
      restrict: 'E',
      scope: {
        pdfSrc: '='
      },
      template: '<div class="pdf-container"><canvas id="pdf-canvas" class="pdf-canvas"></canvas></div>',
      link: function (scope, element) {
        var container = angular.element(element[0].querySelector('.pdf-container'));
        var canvas = angular.element(element[0].querySelector('.pdf-canvas'))[0];
        var ctx = canvas.getContext('2d');
        var pdfDoc = null;
        var pageNum = 1;
        var scale = 1.5;
        
        // Configurações de estilo para o container e canvas
        container.css({
          'width': '100%',
          'height': '100%',
          'overflow': 'auto',
          'position': 'relative'
        });
        
        canvas.style.width = '100%';
        
        function renderPage(num) {
          // Usando o PDFJS global
          if (window.PDFJS && pdfDoc) {
            pdfDoc.getPage(num).then(function(page) {
              var viewport = page.getViewport({scale: scale});
              canvas.height = viewport.height;
              canvas.width = viewport.width;
              
              var renderContext = {
                canvasContext: ctx,
                viewport: viewport
              };
              
              page.render(renderContext);
            });
          }
        }
        
        function loadPDF(url) {
          if (!url) return;
          
          if (window.PDFJS) {
            // Se PDFJS já foi carregado
            window.PDFJS.getDocument(url).promise.then(function(pdf) {
              pdfDoc = pdf;
              renderPage(pageNum);
            });
          } else {
            // Se precisamos carregar o PDFJS primeiro
            var script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.9.359/pdf.min.js';
            script.onload = function() {
              window.PDFJS = window.pdfjsLib;
              window.PDFJS.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.9.359/pdf.worker.min.js';
              
              window.PDFJS.getDocument(url).promise.then(function(pdf) {
                pdfDoc = pdf;
                renderPage(pageNum);
              });
            };
            document.head.appendChild(script);
          }
        }
        
        scope.$watch('pdfSrc', function(newVal) {
          if (newVal) {
            loadPDF(newVal.toString());
          }
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.numbers-only', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function numberOnly($filter, $q) {

    return {
      restrict: 'A',
      transclude: true,
      require: 'ngModel',
      link: function (scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (inputValue) {
          var transformedInput = inputValue ? inputValue.replace(/[^\d]/g, '') : null;

          if (transformedInput != inputValue) {
            modelCtrl.$setViewValue(transformedInput);
            modelCtrl.$render();
          }

          return transformedInput;
        });
      }
    }
  }

  angular
    .module('app.numbers-only')
    .directive('numberOnly', numberOnly)
})();

(function () {
    'use strict';
    angular
            .module('app.nestedlist', []);
})();
(function () {
  'use strict';
  function NestedList() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/nested-list/templateNestedList.html',
      controller: 'BillCategoryController',
      controllerAs: 'vm',
      scope: {
        parent: '=',
        nodes: '=',
        treeOptions: '='
      },
      link: function (scope) {

        scope.remove = function (s) {
          s.remove();
        };

        scope.toggle = function (s) {
          s.toggle();
        };

        scope.moveLastToTheBeginning = function () {
          var a = vm.data.pop();
          scope.data.splice(0, 0, a);
        };

        scope.collapseAll = function () {
          scope.$broadcast('angular-ui-tree:collapse-all');
        };

        scope.expandAll = function () {
          scope.$broadcast('angular-ui-tree:expand-all');
        };
      }
    }
  }

  NestedList.$inject = [];
  angular
    .module('app.nestedlist')
    .directive('nestedList', NestedList);
})();
(function () {
  'use strict';
  /** @ngInject */
  function NestedListController() {
    var vm = this;

    vm.remove = function (scope) {
      scope.remove();
    };

    vm.toggle = function (scope) {
      scope.toggle();
    };

    vm.moveLastToTheBeginning = function () {
      var a = vm.data.pop();
      vm.data.splice(0, 0, a);
    };

    vm.collapseAll = function () {
      vm.$broadcast('angular-ui-tree:collapse-all');
    };

    vm.expandAll = function () {
      vm.$broadcast('angular-ui-tree:expand-all');
    };
  }

  angular
    .module('app.nestedlist')
    .controller('NestedListController', NestedListController);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }
            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('MsTimelineController', MsTimelineController)
    .directive('msTimeline', msTimelineDirective)
    .directive('msTimelineItem', msTimelineItemDirective);

  /** @ngInject */
  function MsTimelineController() {
    var vm = this;

    // Data
    vm.scrollEl = undefined;

    // Methods
    vm.setScrollEl = setScrollEl;
    vm.getScrollEl = getScrollEl;

    //////////

    /**
     * Set scroll element
     *
     * @param scrollEl
     */
    function setScrollEl(scrollEl) {
      vm.scrollEl = scrollEl;
    }

    /**
     * Get scroll element
     *
     * @returns {undefined|*}
     */
    function getScrollEl() {
      return vm.scrollEl;
    }
  }

  /** @ngInject */
  function msTimelineDirective() {
    return {
      scope: {
        msTimeline: '=?',
        loadMore: '&?msTimelineLoadMore'
      },
      controller: 'MsTimelineController',
      compile: function (tElement) {
        tElement.addClass('ms-timeline');

        return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
          // Create an element for triggering the load more action and append it
          var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
          // iElement.append(loadMoreEl);

          // Default config
          var config = {
            scrollEl: '#content'
          };

          // Extend the configuration
          config = angular.extend(config, scope.msTimeline, {});

          // Grab the scrollable element and store it in the controller for general use
          var scrollEl = angular.element(config.scrollEl);
          MsTimelineCtrl.setScrollEl(scrollEl);

          // Threshold
          var threshold = 144;

          // Register onScroll event for the first time
          registerOnScroll();

          /**
           * onScroll Event
           */
          function onScroll() {
            if (scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top) {
              // Show the loader
              loadMoreEl.addClass('show');

              // Unregister scroll event to prevent triggering the function over and over again
              unregisterOnScroll();

              // Trigger load more event
              if (angular.isDefined(scope.loadMore())) {
                scope.loadMore().then(
                  // Success
                  function () {
                    // Hide the loader
                    loadMoreEl.removeClass('show');

                    // Register the onScroll event again
                    registerOnScroll();
                  },

                  // Error
                  function () {
                    // Remove the loader completely
                    loadMoreEl.remove();
                  }
                );
              } else {
                loadMoreEl.removeClass('show');
                loadMoreEl.remove();
              }
            }
          }

          /**
           * onScroll event registerer
           */
          function registerOnScroll() {
            scrollEl.on('scroll', onScroll);
          }

          /**
           * onScroll event unregisterer
           */
          function unregisterOnScroll() {
            scrollEl.off('scroll', onScroll);
          }

          // Cleanup
          scope.$on('$destroy', function () {
            unregisterOnScroll();
          });
        };
      }
    };
  }

  /** @ngInject */
  function msTimelineItemDirective($timeout, $q) {
    return {
      scope: true,
      require: '^msTimeline',
      compile: function (tElement) {
        tElement.addClass('ms-timeline-item').addClass('hidden');

        return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
          var threshold = 72,
            itemLoaded = false,
            itemInViewport = false,
            scrollEl = MsTimelineCtrl.getScrollEl();

          //////////

          init();

          /**
           * Initialize
           */
          function init() {
            // Check if the timeline item has ms-card
            if (iElement.find('ms-card')) {
              // If the ms-card template loaded...
              scope.$on('msCard::cardTemplateLoaded', function (event, args) {
                var cardEl = angular.element(args[0]);

                // Test the card to see if there is any image on it
                testForImage(cardEl).then(function () {
                  $timeout(function () {
                    itemLoaded = true;
                  });
                });
              });
            } else {
              // Test the element to see if there is any image on it
              testForImage(iElement).then(function () {
                $timeout(function () {
                  itemLoaded = true;
                });
              });
            }

            // Check if the loaded element also in the viewport
            scrollEl.on('scroll', testForVisibility);

            // Test for visibility for the first time without waiting for the scroll event
            testForVisibility();
          }

          // Item ready watcher
          var itemReadyWatcher = scope.$watch(
            function () {
              return itemLoaded && itemInViewport;
            },
            function (current, old) {
              if (angular.equals(current, old)) {
                return;
              }

              if (current) {
                iElement.removeClass('hidden').addClass('animate');

                // Unbind itemReadyWatcher
                itemReadyWatcher();
              }
            }, true);

          /**
           * Test the given element for image
           *
           * @param element
           * @returns promise
           */
          function testForImage(element) {
            var deferred = $q.defer(),
              imgEl = element.find('img');

            if (imgEl.length > 0) {
              imgEl.on('load', function () {
                deferred.resolve('Image is loaded');
              });
            } else {
              deferred.resolve('No images');
            }

            return deferred.promise;
          }

          /**
           * Test the element for visibility
           */
          function testForVisibility() {
            if (scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold) {
              $timeout(function () {
                itemInViewport = true;
              });

              // Unbind the scroll event
              scrollEl.off('scroll', testForVisibility);
            }
          }
        };
      }
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('msSplashScreen', msSplashScreenDirective);

  /** @ngInject */
  function msSplashScreenDirective($animate) {
    return {
      restrict: 'E',
      link: function (scope, iElement) {
        var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function () {
          $animate.removeClass(iElement, 'show-splash-screen').then(function () {
            $animate.addClass(iElement, 'hide-splash-screen').then(function () {
              // De-register scope event
              // splashScreenRemoveEvent();
              // Null-ify everything else
              // scope = iElement = null;
            });
          });
        });

        var splashScreenActiveEvent = scope.$on('msSplashScreen::active', function () {
          $animate.removeClass(iElement, 'hide-splash-screen').then(function () {
            $animate.addClass(iElement, 'show-splash-screen').then(function () {
              // splashScreenActiveEvent();
              // scope = iElement = null;
            })
          })

        })
      }
    };
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/components/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink()
                {
                    // Data

                };
            }
        };
    }
})();
(function () {
    /* global PerfectScrollbar */
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
// (function () {
//   'use strict';
//
//   /** @ngInject */
//   function configProvider($provide) {
//     $provide.decorator('msNavigationService', ['$delegate', 'PoliciesService', function ($delegate, PoliciesService) {
//
//       var originalSaveItem = $delegate.saveItem;
//       $delegate.saveItem = function (path, item) {
//         if (PoliciesService.checkPolicy(item.auth)) {
//           originalSaveItem.apply($delegate, arguments);
//         }
//       };
//
//       return $delegate;
//
//     }]);
//
//
//   }
//
//   angular
//     .module('app.core')
//     .config(configProvider);
//
// })();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';
    angular.module('app.modal', []);
})();


(function () {
  'use strict';

  /** @ngInject */
  function Modal($rootScope, $mdDialog, Common, RolesService, Session, a4Moment) {

    var vm = this;

    $rootScope.$on('ModalFactory.close', function (ev, data) {
      $mdDialog.hide(data);
    });

    /**
     * Cria um novo modal;
     * @param {type} templateName - Nome do arquivo dentro da pasta
     * @param {type} $event - Evento angular de abertura.
     * @param {String} controller - Controllador do dialog.
     * @param {String} data - Dados passados para o dialog
     * @param {String} item - Um item passado para o dialog
     * /js/app/Components/modal/Templates
     * @param theme - Tema do modal
     * @param submitFunction - Função para ser executada após submissão do modal
     * @param title - Título do modal
     * @param text - Texto do modal
     * @param subtitle - Subtítulo
     * @returns {undefined}
     */
    vm.open = function (templateName, $event, controller, data, item, theme, submitFunction, title, text, subtitle, clickOutsideToClose) {
      return $mdDialog.show({
        controller: function ($scope, data, item) {
          var vm = this;
          vm.show_loading = false;
          vm.user_name = angular.isDefined(Session.user) ? Session.user.person.name : '';
          var name = vm.user_name.split(' ');
          vm.user_name = name.length > 1 ? name[0] + name[name.length - 1] : name[0];
          vm.date = a4Moment().format('DD/MM/YYYY');
          vm.hour = a4Moment().format('HH:mm');
          $scope.item = item;
          vm.scope = data;
          vm.theme = theme;
          vm.error = false;
          vm.font = 15;
          vm.fatal_error = false;
          vm.title = angular.isDefined(title) ? title : null;
          vm.text = angular.isDefined(text) ? text : null;
          vm.subtitle = angular.isDefined(subtitle) ? subtitle : null;
          vm.answer = function (answer) {
            $mdDialog.hide(answer);
          };
          /**
           * Verificação da senha do usuário
           * @param answer
           */
          vm.confirmPassword = function (answer) {
            vm.show_loading = true;
            RolesService.confirmPassword({'password': answer}).then(function (response) {
              if (response.result) {
                if (angular.isDefined(submitFunction)) {
                  submitFunction(vm.scope).then(function (response) {
                    $mdDialog.hide(response);
                  }).catch(function (error) {
                    vm.show_loading = false;
                    vm.fatal_error = true;
                    vm.error = true;
                    vm.error_message = error.data.message;
                  });
                } else {
                  $mdDialog.hide(true);
                }
              }
            }).catch(function (response) {
              vm.show_loading = false;
              vm.scope.password = "";
              if (response.data.message === "PASSWORD_INCORRECT") {
                vm.error_message = 'Senha incorreta!';
              } else if (response.data.message === "CANT_FIND_USER") {
                vm.error_message = 'Usuário não encontrado!';
              }
              vm.error = true;
            })
          };

          vm.closeModal = function () {
            $mdDialog.cancel();
          };
          vm.editable = false;
        },
        controllerAs: 'vm',
        templateUrl: "app/components/modal/Templates/" + templateName + ".html",
        targetEvent: $event,
        clickOutsideToClose: angular.isDefined(clickOutsideToClose) ? clickOutsideToClose : true,
        locals: {
          data: data,
          item: item
        }
      });
    };

    vm.alert = function (title, textContent, ariaLabel, okayBtn, clickOutsideToClose, theme) {
      // Appending dialog to document.body to cover sidenav in docs app
      // Modal dialogs should fully cover application
      // to prevent interaction outside of dialog
      return $mdDialog.show(
        $mdDialog.alert()
          .clickOutsideToClose(clickOutsideToClose)
          .title(title)
          .theme(theme)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok(okayBtn)
      );
    };

    vm.custom = function (template, data, clickOutsideToClose, policy) {
      return $mdDialog.show({
        onComplete: function () {
          $rootScope.$broadcast('CUSTOM.opened');
          /** Verifica as política de acesso */
          if (angular.isDefined(policy)) {
            vm.checkPoliciesDialog(policy);
          }
        },
        controller: function ($scope, ModalData, $rootScope, SysTableColumn) {
          var vm = this;
          vm.scope = ModalData;
          vm.required_fields_responsible = SysTableColumn.getColumnsByScope('RESPONSIBLE');
          vm.required_fields_payee = SysTableColumn.getColumnsByScope('PAYEE');
          vm.answer = function (answer) {
            $mdDialog.hide(answer);
          };
          vm.closeModal = function () {
            $mdDialog.cancel();
          };

          var ltn = $rootScope.$on('CUSTOM.close', function () {
            vm.closeModal();
          });

          $scope.$on('$destroy', function () {
            [ltn].forEach(function (fn) {
              fn();
            })
          });
        },
        controllerAs: 'vm',
        templateUrl: template,
        clickOutsideToClose: clickOutsideToClose,
        locals: {
          ModalData: data
        }
      });
    };

    vm.customClean = function (template, controller, controllerAs, clickOutsideToClose, data, policy) {
      return $mdDialog.show({
        onComplete: function () {
          $rootScope.$broadcast('CUSTOM_CLEAN.opened');
          /** Verifica as políticas de acesso */
          vm.checkPoliciesDialog(policy);
        },
        onRemoving: function () {
          $rootScope.$broadcast('CUSTOM_CLEAN.closed')
        },
        controller: controller,
        controllerAs: controllerAs,
        templateUrl: template,
        escapeToClose: false,
        clickOutsideToClose: clickOutsideToClose,
        locals: {
          ModalExtra: data
        }
      });
    };

    vm.confirmModal = function (ev, title, text, okText, cancelText, theme, submitFunction, data) {
      return $mdDialog.show({
        controller: function ($scope, data) {
          var vm = this;
          vm.show_loading = false;
          vm.user_name = angular.isDefined(Session.user) ? Session.user.person.name : 'Usuário não identificado';
          var name = angular.isDefined(Session.user) ? Session.user.person.name.split(' ') : '';
          vm.user_name = name.length > 1 ? name[0] + name[name.length - 1] : name[0];
          vm.date = a4Moment().format('DD/MM/YYYY');
          vm.hour = a4Moment().format('HH:mm');
          vm.scope = angular.isDefined(data) ? data : null;
          vm.text = text;
          vm.okText = okText;
          vm.cancelText = cancelText;
          vm.theme = theme;
          vm.fatal_error = false;
          vm.answer = function (answer) {
            if (angular.isDefined(submitFunction)) {
              vm.show_loading = true;
              submitFunction(vm.scope).then(function (response) {
                $mdDialog.hide(response);
              }).catch(function (error) {
                vm.show_loading = false;
                vm.fatal_error = true;
                vm.error_message = error.data.message;
              })
            } else {
              vm.show_loading = true;
              $mdDialog.hide(answer);
            }
          };

          vm.closeModal = function () {
            $mdDialog.cancel();
          };
        },
        controllerAs: 'vm',
        templateUrl: "app/components/modal/Templates/confirm.html",
        clickOutsideToClose: false,
        locals: {
          data: angular.isDefined(data) ? data : null
        }
      });
    };

    vm.promptModal = function (ev, title, text, placeholder, initialValue, okText, cancelText, theme, policy, required) {
      var deferred = Common.$q.defer();
      var confirm = $mdDialog.prompt({
        onComplete: function (scope, element) {
          /** Verifica as política de acesso */
          vm.checkPoliciesDialog(policy);
        }
      })
        .title(!!title ? title : "Custom Title")
        .textContent(!!text ? text : "Custom Text")
        .placeholder(placeholder)
        .required(!!required ? required : false)
        .ariaLabel(placeholder)
        .targetEvent(ev)
        .theme(theme)
        .ok(!!okText ? okText : "Ok")
        .cancel(!!cancelText ? cancelText : "Cancelar");


      if (initialValue) {
        confirm.initialValue(initialValue)
      }

      $mdDialog.show(confirm).then(function (result) {
        deferred.resolve(result);
      }, function () {
        deferred.reject(true);
      });
      return deferred.promise;
    };

    /**
     * Aplica as Políticas ao ModalFactory
     * @param policy
     */
    vm.checkPoliciesDialog = function (policy) {
      if (policy) {
        angular.element('md-dialog-content md-input-container input, md-dialog-actions button.md-confirm-button, md-content .submit-button, md-content input, md-content md-select, md-content select, md-content textarea')
          .attr('disabled', true);
      }
    };

    return {
      /**
       * Cria um novo modal;
       * @param {type} templateName - Nome do arquivo dentro da pasta
       * /js/app/Components/modal/Templates
       * @returns {undefined}
       */
      open: vm.open,
      alert: vm.alert,
      custom: vm.custom,
      customClean: vm.customClean,
      /**
       * Cria um novo modal de confirm;
       * @param {type} templateName - Nome do arquivo dentro da pasta
       * /js/app/Components/modal/Templates
       * @returns {undefined}
       */
      confirm: vm.confirmModal,
      prompt: vm.promptModal
    };
  }


  angular
    .module('app.modal')
    .factory('ModalFactory', Modal);
})();


(function () {
  'use strict';

  angular
    .module('app.date-range-picker', ['daterangepicker']);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DateRangeTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      YESTERDAY: 'Categorias',
      TODAY: 'Não é possivel: Adicionar, Apagar ',
      THIS_WEEK: 'Não é possivel: Mover, Alterar ',
      LAST_WEEK: 'Fechar categorias',
      THIS_MONTH: 'Criar nova categoria',
      LAST_MONTH: 'Deseja realmente apagar esta categoria?',
      THIS_YEAR: 'ATENÇÃO! Todas as categorias associadas a este grupo serão eliminadas. Deseja realmente apagar?',
      LAST_YEAR: 'Erro ao apagar.'
    });

  }

  angular
    .module('app.date-range-picker')
    .config(DateRangeTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function dateRangePicker(a4Moment) {

    return {
      restrict: 'E',
      required: '[^ngModel]',
      scope: {
        value: '=ngModel',
        label: '@?',
        text1: '@placeholderStart',
        text2: '@placeholderEnd',
        ngChange: '&?',
        options: '=?',
        disabled: '=?',
        selectedPeriod: '=',
        enabledPeriod: '@',
        enableMonths: '@',
        monthsText: '@',
        timePicker: '@',
        ranges: '=?'
      },
      controller: 'DateRangePickerController',
      controllerAs: 'vm',
      templateUrl: 'app/components/date-range-picker/date-range-picker.html',
      link: function ($scope, element) {
        $scope.format = $scope.timePicker === 'true' ? 'YYYY-MM-DD HH:mm' :'YYYY-MM-DD';

        $scope.label = ($scope.label === 'true' || angular.isUndefined($scope.label)) ? 'Datas' : $scope.label;

        element.on('apply.daterangepicker', function (ev, picker) {
          if (angular.isDefined($scope.ngChange)) {
            $scope.ngChange({
              startDate: picker.startDate.format($scope.format),
              endDate: picker.endDate.format($scope.format)
            });
          }
          $scope.value.startDate = picker.startDate.format($scope.format);
          $scope.value.endDate = picker.endDate.format($scope.format);
        });
        /**
         * Inicializador da diretiva
         */
        $scope.init = function () {

          if (angular.isUndefined($scope.value) || $scope.value === '' || $scope.value === null) {
            $scope.initDate = null;
            $scope.endDate = null;
            $scope.value = {
              initDate: null,
              endDate: null
            }
          } else {
            $scope.initDate = $scope.value.initDate;
            $scope.endDate = $scope.value.endDate;
          }
        };

        $scope.changeOnDatePicker = function (newer) {
          if (angular.isDefined($scope.ngChange)) {
            $scope.ngChange({date: newer});
          }
          if ($scope.value === undefined || $scope.value === '') {
            $scope.value = a4Moment(null);
          } else {
            $scope.value = newer.endDate;
          }
          $scope.change = newer;
          $rootScope.$broadcast('DATEPICKER.change', $scope.value);
        };

        $scope.init();
      }
    }
  }

  angular
    .module('app.date-range-picker')
    .directive('dateRangePicker', dateRangePicker)
})();

(function () {
  'use strict';

  /** @ngInject */
  function DateRangePickerController($scope, a4Moment) {
    var vm = this;
    vm.choice = null;
    vm.ranges = {
      'Hoje': [a4Moment(), a4Moment().startOf('day')],
      'Esta semana': [a4Moment().startOf('week'), a4Moment().endOf('week')],
      'Este mês': [a4Moment().startOf('month'), a4Moment().endOf('month')],
      'Mês anterior': [a4Moment().subtract(1, 'month').startOf('month'), a4Moment().subtract(1, 'month').endOf('month')],
      'Próximo mês': [a4Moment().add(1, 'month').startOf('month'), a4Moment().add(1, 'month').endOf('month')],
      'Últimos 7 Dias': [a4Moment().subtract(7, 'days'), a4Moment()],
      'Últimos 30 Dias': [a4Moment().subtract(30, 'days'), a4Moment()],
      'Início do ano até hoje': [a4Moment().startOf('year'), a4Moment()],
      'De hoje até o final do ano': [a4Moment(), a4Moment().endOf('year')],
      'Últimos 12 meses': [a4Moment().subtract(11, 'month').startOf('month'), a4Moment().endOf('month')],
      'Este ano': [a4Moment().startOf('year'), a4Moment().endOf('year')],
      'Ano passado': [a4Moment().subtract(1, 'year').startOf('year'), a4Moment().subtract(1, 'year').endOf('year')]
    };

    vm.options = {
      timePicker: $scope.timePicker === 'true',
      timePicker24Hour: $scope.timePicker === 'true',
      showDropdowns: true,
      applyClass: 'md-button md-primary md-ink-ripple',
      cancelClass: 'md-button md-primary md-ink-ripple',
      autoApply: true,
      locale: {
        applyLabel: "Aplicar",
        fromLabel: "De",
        format: $scope.timePicker === 'true' ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY",
        toLabel: "Até",
        customRangeLabel: 'Customizado',
        daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio",
          "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        firstDay: 1
      },
      ranges: angular.isDefined($scope.ranges) ? $scope.ranges : vm.ranges
    };

    // var ltn = $scope.$watch(function () {
    //   return $scope.value;
    // }, function (newer) {
    //   if (!angular.isUndefined($scope.ngChange)) {
    //     $scope.ngChange({date: newer});
    //   }
    // });
    //
    // $scope.$on('$destroy', function () {
    //   [ltn].forEach(function (fn) {
    //     fn();
    //   })
    // })

  }

  angular.module('app.date-range-picker')
    .controller('DateRangePickerController', DateRangePickerController);

})();

(function () {
  'use strict';

  /** @ngInject*/
  function dateRange() {

  }

  angular
    .module('app.date-range-picker')
    .config(dateRange);

})();
(function () {
  'use strict';

  angular
    .module('app.date-picker', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DateRangeTranslate($translateProvider) {

    $translateProvider.translations('pt', {});

  }

  angular
    .module('app.date-picker')
    .config(DateRangeTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function datePicker($rootScope, a4Moment) {

    return {
      restrict: 'E',
      templateUrl: 'app/components/date-picker/date-picker.html',
      required: '[^ngModel]',
      scope: {
        value: '=ngModel',
        placeholder: '@?',
        label: '@?',
        maxDate: '=?',
        minDate: '=?',
        disabled: '=?',
        isGerador: '=?',
        type: '@?',
        ngChange: '&?',
        required: '=?',
        withoutIcon: '@?',
        readOnly: '@?',
      },
      controller: 'DatePickerController',
      controllerAs: 'vm',
      link: function ($scope, element) {
        $scope.format = 'YYYY-MM-DD';

        $scope.withoutIcon = $scope.withoutIcon === 'true';

        element.on('apply.daterangepicker', function (ev, picker) {
          if (angular.isDefined($scope.ngChange)) {
            $scope.ngChange({date: picker.endDate.format('YYYY-MM-DD')});
          }
        });

        if (angular.isUndefined($scope.value)) {
          $scope.value = null;
        }

        $scope.updateDate = function () {
          $scope.value = a4Moment($scope.date).format($scope.format);
          $rootScope.$broadcast('DATERANGEPICKER.change', $scope.value);
        };

        $scope.changeOnDatePicker = function (newer) {
          if (angular.isDefined($scope.ngChange)) {
            $scope.ngChange({date: newer});
          }
          if ($scope.value === undefined || $scope.value === '') {
            $scope.value = a4Moment(null);
          } else {
            $scope.value =a4Moment(newer).format('YYYY-MM-DD')
          }
          $scope.change = newer;
          $rootScope.$broadcast('DATEPICKER.change', $scope.value);
        };
      }
    }
  }

  angular
    .module('app.date-picker')
    .directive('datePicker', datePicker);
})();

(function () {
  'use strict';

  /** @ngInject */
  function DatePickerController($scope, a4Moment) {
    var vm = this;

    vm.format = 'YYYY-MM-DD';

    $scope.dateFields = {};

    vm.options = {
      showDropdowns: true,
      minDate: angular.isUndefined($scope.minDate) ? a4Moment('1900-01-01') : $scope.minDate,
      maxDate: angular.isUndefined($scope.maxDate) ? a4Moment('2100-12-31') : $scope.maxDate,
      applyClass: 'md-button md-primary md-ink-ripple',
      cancelClass: 'md-button md-primary md-ink-ripple',
      singleDatePicker: true,
      autoApply: true,
      autoUpdateInput: false,
      locale: {
        applyLabel: "Aplicar",
        fromLabel: "De",
        format: "DD/MM/YYYY",
        toLabel: "Até",
        cancelLabel: 'Limpar',
        customRangeLabel: 'Customizado',
        daysOfWeek: [
          "Dom",
          "Seg",
          "Ter",
          "Qua",
          "Qui",
          "Sex",
          "Sab"
        ],
        monthNames: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ],
        firstDay: 1
      },

      /*ranges: {
        'Hoje': [a4Moment().format(vm.format), a4Moment().startOf('day').format(vm.format)],
        'Esta semana': [a4Moment().startOf('week').format(vm.format), a4Moment().endOf('week').format(vm.format)],
        'Este mês': [a4Moment().startOf('month').format(vm.format), a4Moment().endOf('month').format(vm.format)],
        'Mês anterior': [a4Moment().subtract(1, 'month').startOf('month').format(vm.format), a4Moment().subtract(1, 'month').endOf('month').format(vm.format)],
        'Últimos 7 Dias': [a4Moment().subtract(6, 'days').format(vm.format), a4Moment().format(vm.format)],
        'Últimos 30 Dias': [a4Moment().subtract(29, 'days').format(vm.format), a4Moment().format(vm.format)],
        'Início do ano até hoje': [a4Moment().startOf('year').format(vm.format), a4Moment().format(vm.format)]
      }*/
    };
  }

  angular.module('app.date-picker')
    .controller('DatePickerController', DatePickerController)
})();

(function () {
  'use strict';

  /** @ngInject*/
  function dateRange($mdDateLocaleProvider, moment) {
    $mdDateLocaleProvider.formatDate = function (date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    };

    $mdDateLocaleProvider.parseDate = function (dateString) {
      var m = moment(dateString, 'DD/MM/YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };
  }

  angular
    .module('app.date-picker')
    .config(dateRange);

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('customOnChange', function() {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var onChangeHandler = scope.$eval(attrs.customOnChange);
          element.bind('change', onChangeHandler);
        }
      };
    });

})();
(function () {
  'use strict';
  angular
    .module('a4.cript', []);
})();


(function () {
  /* globals JSON, CryptoJS */
  'use strict';

  /**
   * Provide a service for Crypt/Decrypt offline storage (localStorage/sessionStorage) data in application
   * @class CryptService
   * @module services
   * @main CryptService
   * @class CryptService
   * @static
   */

  /** @ngInject */
  function CryptService(localStorageService) {

    return {
      /**
       * Encrypt object values
       * @param  {String} text value for encrypt
       * @return {String}        String with encrypted values
       * @method encrypt
       */
      encrypt: function (text) {
        if (this.checkCrypto()) {
          return CryptoJS.AES.encrypt(text, this.getSecret());
        }
      },

      /**
       * Decrypt object values
       * @param  {Object} encrypted Object for decrypt
       * @return {String}           Decrypted string
       * @method decrypt
       */
      decrypt: function (encrypted) {
        if (this.checkCrypto()) {
          encrypted = encrypted == null ? '' : encrypted;
          var decrypted = CryptoJS.AES.decrypt(encrypted, this.getSecret());
          if (!!decrypted.toString(CryptoJS.enc.Utf8)) {
            return angular.fromJson(decrypted.toString(CryptoJS.enc.Utf8));
          }
        }
      },

      setSecret: function (text) {
        localStorageService.set(btoa(btoa('secret')), text);
      },

      getSecret: function () {
        var storage = localStorageService.get(btoa(btoa('secret')));
        return storage == null ? '' : storage;
      },
      checkCrypto: function () {
        return typeof CryptoJS !== 'undefined';
      }
    }
  }


  angular
    .module('a4.cript')
    .factory('CryptService', CryptService);
})();
/*
 CryptoJS v3.1.2
 code.google.com/p/crypto-js
 (c) 2009-2013 by Jeff Mott. All rights reserved.
 code.google.com/p/crypto-js/wiki/License
 */
var CryptoJS=CryptoJS||function(u,p){var d={},l=d.lib={},s=function(){},t=l.Base={extend:function(a){s.prototype=this;var c=new s;a&&c.mixIn(a);c.hasOwnProperty("init")||(c.init=function(){c.$super.init.apply(this,arguments)});c.init.prototype=c;c.$super=this;return c},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var c in a)a.hasOwnProperty(c)&&(this[c]=a[c]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.init.prototype.extend(this)}},
    r=l.WordArray=t.extend({init:function(a,c){a=this.words=a||[];this.sigBytes=c!=p?c:4*a.length},toString:function(a){return(a||v).stringify(this)},concat:function(a){var c=this.words,e=a.words,j=this.sigBytes;a=a.sigBytes;this.clamp();if(j%4)for(var k=0;k<a;k++)c[j+k>>>2]|=(e[k>>>2]>>>24-8*(k%4)&255)<<24-8*((j+k)%4);else if(65535<e.length)for(k=0;k<a;k+=4)c[j+k>>>2]=e[k>>>2];else c.push.apply(c,e);this.sigBytes+=a;return this},clamp:function(){var a=this.words,c=this.sigBytes;a[c>>>2]&=4294967295<<
      32-8*(c%4);a.length=u.ceil(c/4)},clone:function(){var a=t.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var c=[],e=0;e<a;e+=4)c.push(4294967296*u.random()|0);return new r.init(c,a)}}),w=d.enc={},v=w.Hex={stringify:function(a){var c=a.words;a=a.sigBytes;for(var e=[],j=0;j<a;j++){var k=c[j>>>2]>>>24-8*(j%4)&255;e.push((k>>>4).toString(16));e.push((k&15).toString(16))}return e.join("")},parse:function(a){for(var c=a.length,e=[],j=0;j<c;j+=2)e[j>>>3]|=parseInt(a.substr(j,
        2),16)<<24-4*(j%8);return new r.init(e,c/2)}},b=w.Latin1={stringify:function(a){var c=a.words;a=a.sigBytes;for(var e=[],j=0;j<a;j++)e.push(String.fromCharCode(c[j>>>2]>>>24-8*(j%4)&255));return e.join("")},parse:function(a){for(var c=a.length,e=[],j=0;j<c;j++)e[j>>>2]|=(a.charCodeAt(j)&255)<<24-8*(j%4);return new r.init(e,c)}},x=w.Utf8={stringify:function(a){try{return decodeURIComponent(escape(b.stringify(a)))}catch(c){throw Error("Malformed UTF-8 data");}},parse:function(a){return b.parse(unescape(encodeURIComponent(a)))}},
    q=l.BufferedBlockAlgorithm=t.extend({reset:function(){this._data=new r.init;this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=x.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var c=this._data,e=c.words,j=c.sigBytes,k=this.blockSize,b=j/(4*k),b=a?u.ceil(b):u.max((b|0)-this._minBufferSize,0);a=b*k;j=u.min(4*a,j);if(a){for(var q=0;q<a;q+=k)this._doProcessBlock(e,q);q=e.splice(0,a);c.sigBytes-=j}return new r.init(q,j)},clone:function(){var a=t.clone.call(this);
      a._data=this._data.clone();return a},_minBufferSize:0});l.Hasher=q.extend({cfg:t.extend(),init:function(a){this.cfg=this.cfg.extend(a);this.reset()},reset:function(){q.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);return this._doFinalize()},blockSize:16,_createHelper:function(a){return function(b,e){return(new a.init(e)).finalize(b)}},_createHmacHelper:function(a){return function(b,e){return(new n.HMAC.init(a,
    e)).finalize(b)}}});var n=d.algo={};return d}(Math);
(function(){var u=CryptoJS,p=u.lib.WordArray;u.enc.Base64={stringify:function(d){var l=d.words,p=d.sigBytes,t=this._map;d.clamp();d=[];for(var r=0;r<p;r+=3)for(var w=(l[r>>>2]>>>24-8*(r%4)&255)<<16|(l[r+1>>>2]>>>24-8*((r+1)%4)&255)<<8|l[r+2>>>2]>>>24-8*((r+2)%4)&255,v=0;4>v&&r+0.75*v<p;v++)d.push(t.charAt(w>>>6*(3-v)&63));if(l=t.charAt(64))for(;d.length%4;)d.push(l);return d.join("")},parse:function(d){var l=d.length,s=this._map,t=s.charAt(64);t&&(t=d.indexOf(t),-1!=t&&(l=t));for(var t=[],r=0,w=0;w<
l;w++)if(w%4){var v=s.indexOf(d.charAt(w-1))<<2*(w%4),b=s.indexOf(d.charAt(w))>>>6-2*(w%4);t[r>>>2]|=(v|b)<<24-8*(r%4);r++}return p.create(t,r)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}})();
(function(u){function p(b,n,a,c,e,j,k){b=b+(n&a|~n&c)+e+k;return(b<<j|b>>>32-j)+n}function d(b,n,a,c,e,j,k){b=b+(n&c|a&~c)+e+k;return(b<<j|b>>>32-j)+n}function l(b,n,a,c,e,j,k){b=b+(n^a^c)+e+k;return(b<<j|b>>>32-j)+n}function s(b,n,a,c,e,j,k){b=b+(a^(n|~c))+e+k;return(b<<j|b>>>32-j)+n}for(var t=CryptoJS,r=t.lib,w=r.WordArray,v=r.Hasher,r=t.algo,b=[],x=0;64>x;x++)b[x]=4294967296*u.abs(u.sin(x+1))|0;r=r.MD5=v.extend({_doReset:function(){this._hash=new w.init([1732584193,4023233417,2562383102,271733878])},
  _doProcessBlock:function(q,n){for(var a=0;16>a;a++){var c=n+a,e=q[c];q[c]=(e<<8|e>>>24)&16711935|(e<<24|e>>>8)&4278255360}var a=this._hash.words,c=q[n+0],e=q[n+1],j=q[n+2],k=q[n+3],z=q[n+4],r=q[n+5],t=q[n+6],w=q[n+7],v=q[n+8],A=q[n+9],B=q[n+10],C=q[n+11],u=q[n+12],D=q[n+13],E=q[n+14],x=q[n+15],f=a[0],m=a[1],g=a[2],h=a[3],f=p(f,m,g,h,c,7,b[0]),h=p(h,f,m,g,e,12,b[1]),g=p(g,h,f,m,j,17,b[2]),m=p(m,g,h,f,k,22,b[3]),f=p(f,m,g,h,z,7,b[4]),h=p(h,f,m,g,r,12,b[5]),g=p(g,h,f,m,t,17,b[6]),m=p(m,g,h,f,w,22,b[7]),
    f=p(f,m,g,h,v,7,b[8]),h=p(h,f,m,g,A,12,b[9]),g=p(g,h,f,m,B,17,b[10]),m=p(m,g,h,f,C,22,b[11]),f=p(f,m,g,h,u,7,b[12]),h=p(h,f,m,g,D,12,b[13]),g=p(g,h,f,m,E,17,b[14]),m=p(m,g,h,f,x,22,b[15]),f=d(f,m,g,h,e,5,b[16]),h=d(h,f,m,g,t,9,b[17]),g=d(g,h,f,m,C,14,b[18]),m=d(m,g,h,f,c,20,b[19]),f=d(f,m,g,h,r,5,b[20]),h=d(h,f,m,g,B,9,b[21]),g=d(g,h,f,m,x,14,b[22]),m=d(m,g,h,f,z,20,b[23]),f=d(f,m,g,h,A,5,b[24]),h=d(h,f,m,g,E,9,b[25]),g=d(g,h,f,m,k,14,b[26]),m=d(m,g,h,f,v,20,b[27]),f=d(f,m,g,h,D,5,b[28]),h=d(h,f,
      m,g,j,9,b[29]),g=d(g,h,f,m,w,14,b[30]),m=d(m,g,h,f,u,20,b[31]),f=l(f,m,g,h,r,4,b[32]),h=l(h,f,m,g,v,11,b[33]),g=l(g,h,f,m,C,16,b[34]),m=l(m,g,h,f,E,23,b[35]),f=l(f,m,g,h,e,4,b[36]),h=l(h,f,m,g,z,11,b[37]),g=l(g,h,f,m,w,16,b[38]),m=l(m,g,h,f,B,23,b[39]),f=l(f,m,g,h,D,4,b[40]),h=l(h,f,m,g,c,11,b[41]),g=l(g,h,f,m,k,16,b[42]),m=l(m,g,h,f,t,23,b[43]),f=l(f,m,g,h,A,4,b[44]),h=l(h,f,m,g,u,11,b[45]),g=l(g,h,f,m,x,16,b[46]),m=l(m,g,h,f,j,23,b[47]),f=s(f,m,g,h,c,6,b[48]),h=s(h,f,m,g,w,10,b[49]),g=s(g,h,f,m,
      E,15,b[50]),m=s(m,g,h,f,r,21,b[51]),f=s(f,m,g,h,u,6,b[52]),h=s(h,f,m,g,k,10,b[53]),g=s(g,h,f,m,B,15,b[54]),m=s(m,g,h,f,e,21,b[55]),f=s(f,m,g,h,v,6,b[56]),h=s(h,f,m,g,x,10,b[57]),g=s(g,h,f,m,t,15,b[58]),m=s(m,g,h,f,D,21,b[59]),f=s(f,m,g,h,z,6,b[60]),h=s(h,f,m,g,C,10,b[61]),g=s(g,h,f,m,j,15,b[62]),m=s(m,g,h,f,A,21,b[63]);a[0]=a[0]+f|0;a[1]=a[1]+m|0;a[2]=a[2]+g|0;a[3]=a[3]+h|0},_doFinalize:function(){var b=this._data,n=b.words,a=8*this._nDataBytes,c=8*b.sigBytes;n[c>>>5]|=128<<24-c%32;var e=u.floor(a/
    4294967296);n[(c+64>>>9<<4)+15]=(e<<8|e>>>24)&16711935|(e<<24|e>>>8)&4278255360;n[(c+64>>>9<<4)+14]=(a<<8|a>>>24)&16711935|(a<<24|a>>>8)&4278255360;b.sigBytes=4*(n.length+1);this._process();b=this._hash;n=b.words;for(a=0;4>a;a++)c=n[a],n[a]=(c<<8|c>>>24)&16711935|(c<<24|c>>>8)&4278255360;return b},clone:function(){var b=v.clone.call(this);b._hash=this._hash.clone();return b}});t.MD5=v._createHelper(r);t.HmacMD5=v._createHmacHelper(r)})(Math);
(function(){var u=CryptoJS,p=u.lib,d=p.Base,l=p.WordArray,p=u.algo,s=p.EvpKDF=d.extend({cfg:d.extend({keySize:4,hasher:p.MD5,iterations:1}),init:function(d){this.cfg=this.cfg.extend(d)},compute:function(d,r){for(var p=this.cfg,s=p.hasher.create(),b=l.create(),u=b.words,q=p.keySize,p=p.iterations;u.length<q;){n&&s.update(n);var n=s.update(d).finalize(r);s.reset();for(var a=1;a<p;a++)n=s.finalize(n),s.reset();b.concat(n)}b.sigBytes=4*q;return b}});u.EvpKDF=function(d,l,p){return s.create(p).compute(d,
  l)}})();
CryptoJS.lib.Cipher||function(u){var p=CryptoJS,d=p.lib,l=d.Base,s=d.WordArray,t=d.BufferedBlockAlgorithm,r=p.enc.Base64,w=p.algo.EvpKDF,v=d.Cipher=t.extend({cfg:l.extend(),createEncryptor:function(e,a){return this.create(this._ENC_XFORM_MODE,e,a)},createDecryptor:function(e,a){return this.create(this._DEC_XFORM_MODE,e,a)},init:function(e,a,b){this.cfg=this.cfg.extend(b);this._xformMode=e;this._key=a;this.reset()},reset:function(){t.reset.call(this);this._doReset()},process:function(e){this._append(e);return this._process()},
  finalize:function(e){e&&this._append(e);return this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(e){return{encrypt:function(b,k,d){return("string"==typeof k?c:a).encrypt(e,b,k,d)},decrypt:function(b,k,d){return("string"==typeof k?c:a).decrypt(e,b,k,d)}}}});d.StreamCipher=v.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var b=p.mode={},x=function(e,a,b){var c=this._iv;c?this._iv=u:c=this._prevBlock;for(var d=0;d<b;d++)e[a+d]^=
  c[d]},q=(d.BlockCipherMode=l.extend({createEncryptor:function(e,a){return this.Encryptor.create(e,a)},createDecryptor:function(e,a){return this.Decryptor.create(e,a)},init:function(e,a){this._cipher=e;this._iv=a}})).extend();q.Encryptor=q.extend({processBlock:function(e,a){var b=this._cipher,c=b.blockSize;x.call(this,e,a,c);b.encryptBlock(e,a);this._prevBlock=e.slice(a,a+c)}});q.Decryptor=q.extend({processBlock:function(e,a){var b=this._cipher,c=b.blockSize,d=e.slice(a,a+c);b.decryptBlock(e,a);x.call(this,
  e,a,c);this._prevBlock=d}});b=b.CBC=q;q=(p.pad={}).Pkcs7={pad:function(a,b){for(var c=4*b,c=c-a.sigBytes%c,d=c<<24|c<<16|c<<8|c,l=[],n=0;n<c;n+=4)l.push(d);c=s.create(l,c);a.concat(c)},unpad:function(a){a.sigBytes-=a.words[a.sigBytes-1>>>2]&255}};d.BlockCipher=v.extend({cfg:v.cfg.extend({mode:b,padding:q}),reset:function(){v.reset.call(this);var a=this.cfg,b=a.iv,a=a.mode;if(this._xformMode==this._ENC_XFORM_MODE)var c=a.createEncryptor;else c=a.createDecryptor,this._minBufferSize=1;this._mode=c.call(a,
  this,b&&b.words)},_doProcessBlock:function(a,b){this._mode.processBlock(a,b)},_doFinalize:function(){var a=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){a.pad(this._data,this.blockSize);var b=this._process(!0)}else b=this._process(!0),a.unpad(b);return b},blockSize:4});var n=d.CipherParams=l.extend({init:function(a){this.mixIn(a)},toString:function(a){return(a||this.formatter).stringify(this)}}),b=(p.format={}).OpenSSL={stringify:function(a){var b=a.ciphertext;a=a.salt;return(a?s.create([1398893684,
  1701076831]).concat(a).concat(b):b).toString(r)},parse:function(a){a=r.parse(a);var b=a.words;if(1398893684==b[0]&&1701076831==b[1]){var c=s.create(b.slice(2,4));b.splice(0,4);a.sigBytes-=16}return n.create({ciphertext:a,salt:c})}},a=d.SerializableCipher=l.extend({cfg:l.extend({format:b}),encrypt:function(a,b,c,d){d=this.cfg.extend(d);var l=a.createEncryptor(c,d);b=l.finalize(b);l=l.cfg;return n.create({ciphertext:b,key:c,iv:l.iv,algorithm:a,mode:l.mode,padding:l.padding,blockSize:a.blockSize,formatter:d.format})},
  decrypt:function(a,b,c,d){d=this.cfg.extend(d);b=this._parse(b,d.format);return a.createDecryptor(c,d).finalize(b.ciphertext)},_parse:function(a,b){return"string"==typeof a?b.parse(a,this):a}}),p=(p.kdf={}).OpenSSL={execute:function(a,b,c,d){d||(d=s.random(8));a=w.create({keySize:b+c}).compute(a,d);c=s.create(a.words.slice(b),4*c);a.sigBytes=4*b;return n.create({key:a,iv:c,salt:d})}},c=d.PasswordBasedCipher=a.extend({cfg:a.cfg.extend({kdf:p}),encrypt:function(b,c,d,l){l=this.cfg.extend(l);d=l.kdf.execute(d,
  b.keySize,b.ivSize);l.iv=d.iv;b=a.encrypt.call(this,b,c,d.key,l);b.mixIn(d);return b},decrypt:function(b,c,d,l){l=this.cfg.extend(l);c=this._parse(c,l.format);d=l.kdf.execute(d,b.keySize,b.ivSize,c.salt);l.iv=d.iv;return a.decrypt.call(this,b,c,d.key,l)}})}();
(function(){for(var u=CryptoJS,p=u.lib.BlockCipher,d=u.algo,l=[],s=[],t=[],r=[],w=[],v=[],b=[],x=[],q=[],n=[],a=[],c=0;256>c;c++)a[c]=128>c?c<<1:c<<1^283;for(var e=0,j=0,c=0;256>c;c++){var k=j^j<<1^j<<2^j<<3^j<<4,k=k>>>8^k&255^99;l[e]=k;s[k]=e;var z=a[e],F=a[z],G=a[F],y=257*a[k]^16843008*k;t[e]=y<<24|y>>>8;r[e]=y<<16|y>>>16;w[e]=y<<8|y>>>24;v[e]=y;y=16843009*G^65537*F^257*z^16843008*e;b[k]=y<<24|y>>>8;x[k]=y<<16|y>>>16;q[k]=y<<8|y>>>24;n[k]=y;e?(e=z^a[a[a[G^z]]],j^=a[a[j]]):e=j=1}var H=[0,1,2,4,8,
  16,32,64,128,27,54],d=d.AES=p.extend({_doReset:function(){for(var a=this._key,c=a.words,d=a.sigBytes/4,a=4*((this._nRounds=d+6)+1),e=this._keySchedule=[],j=0;j<a;j++)if(j<d)e[j]=c[j];else{var k=e[j-1];j%d?6<d&&4==j%d&&(k=l[k>>>24]<<24|l[k>>>16&255]<<16|l[k>>>8&255]<<8|l[k&255]):(k=k<<8|k>>>24,k=l[k>>>24]<<24|l[k>>>16&255]<<16|l[k>>>8&255]<<8|l[k&255],k^=H[j/d|0]<<24);e[j]=e[j-d]^k}c=this._invKeySchedule=[];for(d=0;d<a;d++)j=a-d,k=d%4?e[j]:e[j-4],c[d]=4>d||4>=j?k:b[l[k>>>24]]^x[l[k>>>16&255]]^q[l[k>>>
8&255]]^n[l[k&255]]},encryptBlock:function(a,b){this._doCryptBlock(a,b,this._keySchedule,t,r,w,v,l)},decryptBlock:function(a,c){var d=a[c+1];a[c+1]=a[c+3];a[c+3]=d;this._doCryptBlock(a,c,this._invKeySchedule,b,x,q,n,s);d=a[c+1];a[c+1]=a[c+3];a[c+3]=d},_doCryptBlock:function(a,b,c,d,e,j,l,f){for(var m=this._nRounds,g=a[b]^c[0],h=a[b+1]^c[1],k=a[b+2]^c[2],n=a[b+3]^c[3],p=4,r=1;r<m;r++)var q=d[g>>>24]^e[h>>>16&255]^j[k>>>8&255]^l[n&255]^c[p++],s=d[h>>>24]^e[k>>>16&255]^j[n>>>8&255]^l[g&255]^c[p++],t=
  d[k>>>24]^e[n>>>16&255]^j[g>>>8&255]^l[h&255]^c[p++],n=d[n>>>24]^e[g>>>16&255]^j[h>>>8&255]^l[k&255]^c[p++],g=q,h=s,k=t;q=(f[g>>>24]<<24|f[h>>>16&255]<<16|f[k>>>8&255]<<8|f[n&255])^c[p++];s=(f[h>>>24]<<24|f[k>>>16&255]<<16|f[n>>>8&255]<<8|f[g&255])^c[p++];t=(f[k>>>24]<<24|f[n>>>16&255]<<16|f[g>>>8&255]<<8|f[h&255])^c[p++];n=(f[n>>>24]<<24|f[g>>>16&255]<<16|f[h>>>8&255]<<8|f[k&255])^c[p++];a[b]=q;a[b+1]=s;a[b+2]=t;a[b+3]=n},keySize:8});u.AES=p._createHelper(d)})();
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
      (global.clm = factory());
}(this, (function () { 'use strict';

  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





  function createCommonjsModule(fn, module) {
    return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var numeric1_2_6 = createCommonjsModule(function (module, exports) {
    "use strict";

    var numeric = exports;
    if(typeof commonjsGlobal !== "undefined") { commonjsGlobal.numeric = numeric; }

    numeric.version = "1.2.6";

// 1. Utility functions
    numeric.bench = function bench (f,interval) {
      var t1,t2,n,i;
      if(typeof interval === "undefined") { interval = 15; }
      n = 0.5;
      t1 = new Date();
      while(1) {
        n*=2;
        for(i=n;i>3;i-=4) { f(); f(); f(); f(); }
        while(i>0) { f(); i--; }
        t2 = new Date();
        if(t2-t1 > interval) break;
      }
      for(i=n;i>3;i-=4) { f(); f(); f(); f(); }
      while(i>0) { f(); i--; }
      t2 = new Date();
      return 1000*(3*n-1)/(t2-t1);
    };

    numeric._myIndexOf = (function _myIndexOf(w) {
      var n = this.length,k;
      for(k=0;k<n;++k) if(this[k]===w) return k;
      return -1;
    });
    numeric.myIndexOf = (Array.prototype.indexOf)?Array.prototype.indexOf:numeric._myIndexOf;

    numeric.Function = Function;
    numeric.precision = 4;
    numeric.largeArray = 50;

    numeric.prettyPrint = function prettyPrint(x) {
      function fmtnum(x) {
        if(x === 0) { return '0'; }
        if(isNaN(x)) { return 'NaN'; }
        if(x<0) { return '-'+fmtnum(-x); }
        if(isFinite(x)) {
          var scale = Math.floor(Math.log(x) / Math.log(10));
          var normalized = x / Math.pow(10,scale);
          var basic = normalized.toPrecision(numeric.precision);
          if(parseFloat(basic) === 10) { scale++; normalized = 1; basic = normalized.toPrecision(numeric.precision); }
          return parseFloat(basic).toString()+'e'+scale.toString();
        }
        return 'Infinity';
      }
      var ret = [];
      function foo(x) {
        var k;
        if(typeof x === "undefined") { ret.push(Array(numeric.precision+8).join(' ')); return false; }
        if(typeof x === "string") { ret.push('"'+x+'"'); return false; }
        if(typeof x === "boolean") { ret.push(x.toString()); return false; }
        if(typeof x === "number") {
          var a = fmtnum(x);
          var b = x.toPrecision(numeric.precision);
          var c = parseFloat(x.toString()).toString();
          var d = [a,b,c,parseFloat(b).toString(),parseFloat(c).toString()];
          for(k=1;k<d.length;k++) { if(d[k].length < a.length) a = d[k]; }
          ret.push(Array(numeric.precision+8-a.length).join(' ')+a);
          return false;
        }
        if(x === null) { ret.push("null"); return false; }
        if(typeof x === "function") {
          ret.push(x.toString());
          var flag = false;
          for(k in x) { if(x.hasOwnProperty(k)) {
            if(flag) ret.push(',\n');
            else ret.push('\n{');
            flag = true;
            ret.push(k);
            ret.push(': \n');
            foo(x[k]);
          } }
          if(flag) ret.push('}\n');
          return true;
        }
        if(x instanceof Array) {
          if(x.length > numeric.largeArray) { ret.push('...Large Array...'); return true; }
          var flag = false;
          ret.push('[');
          for(k=0;k<x.length;k++) { if(k>0) { ret.push(','); if(flag) ret.push('\n '); } flag = foo(x[k]); }
          ret.push(']');
          return true;
        }
        ret.push('{');
        var flag = false;
        for(k in x) { if(x.hasOwnProperty(k)) { if(flag) ret.push(',\n'); flag = true; ret.push(k); ret.push(': \n'); foo(x[k]); } }
        ret.push('}');
        return true;
      }
      foo(x);
      return ret.join('');
    };

    numeric.parseDate = function parseDate(d) {
      function foo(d) {
        if(typeof d === 'string') { return Date.parse(d.replace(/-/g,'/')); }
        if(!(d instanceof Array)) { throw new Error("parseDate: parameter must be arrays of strings"); }
        var ret = [],k;
        for(k=0;k<d.length;k++) { ret[k] = foo(d[k]); }
        return ret;
      }
      return foo(d);
    };

    numeric.parseFloat = function parseFloat_(d) {
      function foo(d) {
        if(typeof d === 'string') { return parseFloat(d); }
        if(!(d instanceof Array)) { throw new Error("parseFloat: parameter must be arrays of strings"); }
        var ret = [],k;
        for(k=0;k<d.length;k++) { ret[k] = foo(d[k]); }
        return ret;
      }
      return foo(d);
    };

    numeric.parseCSV = function parseCSV(t) {
      var foo = t.split('\n');
      var j,k;
      var ret = [];
      var pat = /(([^'",]*)|('[^']*')|("[^"]*")),/g;
      var patnum = /^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/;
      var stripper = function(n) { return n.substr(0,n.length-1); };
      var count = 0;
      for(k=0;k<foo.length;k++) {
        var bar = (foo[k]+",").match(pat),baz;
        if(bar.length>0) {
          ret[count] = [];
          for(j=0;j<bar.length;j++) {
            baz = stripper(bar[j]);
            if(patnum.test(baz)) { ret[count][j] = parseFloat(baz); }
            else ret[count][j] = baz;
          }
          count++;
        }
      }
      return ret;
    };

    numeric.toCSV = function toCSV(A) {
      var s = numeric.dim(A);
      var i,j,m,n,row,ret;
      m = s[0];
      n = s[1];
      ret = [];
      for(i=0;i<m;i++) {
        row = [];
        for(j=0;j<m;j++) { row[j] = A[i][j].toString(); }
        ret[i] = row.join(', ');
      }
      return ret.join('\n')+'\n';
    };

    numeric.getURL = function getURL(url) {
      var client = new XMLHttpRequest();
      client.open("GET",url,false);
      client.send();
      return client;
    };

    numeric.imageURL = function imageURL(img) {
      function base64(A) {
        var n = A.length, i,x,y,z,p,q,r,s;
        var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var ret = "";
        for(i=0;i<n;i+=3) {
          x = A[i];
          y = A[i+1];
          z = A[i+2];
          p = x >> 2;
          q = ((x & 3) << 4) + (y >> 4);
          r = ((y & 15) << 2) + (z >> 6);
          s = z & 63;
          if(i+1>=n) { r = s = 64; }
          else if(i+2>=n) { s = 64; }
          ret += key.charAt(p) + key.charAt(q) + key.charAt(r) + key.charAt(s);
        }
        return ret;
      }
      function crc32Array (a,from,to) {
        if(typeof from === "undefined") { from = 0; }
        if(typeof to === "undefined") { to = a.length; }
        var table = [0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
          0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
          0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE, 0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
          0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
          0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
          0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
          0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
          0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924, 0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
          0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
          0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
          0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
          0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
          0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2, 0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
          0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
          0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
          0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
          0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
          0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8, 0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
          0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
          0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
          0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
          0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
          0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236, 0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
          0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
          0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
          0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
          0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
          0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C, 0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
          0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
          0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
          0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
          0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D];

        var crc = -1, y = 0, n = a.length,i;

        for (i = from; i < to; i++) {
          y = (crc ^ a[i]) & 0xFF;
          crc = (crc >>> 8) ^ table[y];
        }

        return crc ^ (-1);
      }

      var h = img[0].length, w = img[0][0].length, s1, s2, next,k,length,a,b,i,j,adler32,crc32;
      var stream = [
        137, 80, 78, 71, 13, 10, 26, 10,                           //  0: PNG signature
        0,0,0,13,                                                  //  8: IHDR Chunk length
        73, 72, 68, 82,                                            // 12: "IHDR"
        (w >> 24) & 255, (w >> 16) & 255, (w >> 8) & 255, w&255,   // 16: Width
        (h >> 24) & 255, (h >> 16) & 255, (h >> 8) & 255, h&255,   // 20: Height
        8,                                                         // 24: bit depth
        2,                                                         // 25: RGB
        0,                                                         // 26: deflate
        0,                                                         // 27: no filter
        0,                                                         // 28: no interlace
        -1,-2,-3,-4,                                               // 29: CRC
        -5,-6,-7,-8,                                               // 33: IDAT Chunk length
        73, 68, 65, 84,                                            // 37: "IDAT"
        // RFC 1950 header starts here
        8,                                                         // 41: RFC1950 CMF
        29                                                         // 42: RFC1950 FLG
      ];
      crc32 = crc32Array(stream,12,29);
      stream[29] = (crc32>>24)&255;
      stream[30] = (crc32>>16)&255;
      stream[31] = (crc32>>8)&255;
      stream[32] = (crc32)&255;
      s1 = 1;
      s2 = 0;
      for(i=0;i<h;i++) {
        if(i<h-1) { stream.push(0); }
        else { stream.push(1); }
        a = (3*w+1+(i===0))&255; b = ((3*w+1+(i===0))>>8)&255;
        stream.push(a); stream.push(b);
        stream.push((~a)&255); stream.push((~b)&255);
        if(i===0) stream.push(0);
        for(j=0;j<w;j++) {
          for(k=0;k<3;k++) {
            a = img[k][i][j];
            if(a>255) a = 255;
            else if(a<0) a=0;
            else a = Math.round(a);
            s1 = (s1 + a )%65521;
            s2 = (s2 + s1)%65521;
            stream.push(a);
          }
        }
        stream.push(0);
      }
      adler32 = (s2<<16)+s1;
      stream.push((adler32>>24)&255);
      stream.push((adler32>>16)&255);
      stream.push((adler32>>8)&255);
      stream.push((adler32)&255);
      length = stream.length - 41;
      stream[33] = (length>>24)&255;
      stream[34] = (length>>16)&255;
      stream[35] = (length>>8)&255;
      stream[36] = (length)&255;
      crc32 = crc32Array(stream,37);
      stream.push((crc32>>24)&255);
      stream.push((crc32>>16)&255);
      stream.push((crc32>>8)&255);
      stream.push((crc32)&255);
      stream.push(0);
      stream.push(0);
      stream.push(0);
      stream.push(0);
//    a = stream.length;
      stream.push(73);  // I
      stream.push(69);  // E
      stream.push(78);  // N
      stream.push(68);  // D
      stream.push(174); // CRC1
      stream.push(66);  // CRC2
      stream.push(96);  // CRC3
      stream.push(130); // CRC4
      return 'data:image/png;base64,'+base64(stream);
    };

// 2. Linear algebra with Arrays.
    numeric._dim = function _dim(x) {
      var ret = [];
      while(typeof x === "object") { ret.push(x.length); x = x[0]; }
      return ret;
    };

    numeric.dim = function dim(x) {
      var y,z;
      if(typeof x === "object") {
        y = x[0];
        if(typeof y === "object") {
          z = y[0];
          if(typeof z === "object") {
            return numeric._dim(x);
          }
          return [x.length,y.length];
        }
        return [x.length];
      }
      return [];
    };

    numeric.mapreduce = function mapreduce(body,init) {
      return Function('x','accum','_s','_k',
        'if(typeof accum === "undefined") accum = '+init+';\n'+
        'if(typeof x === "number") { var xi = x; '+body+'; return accum; }\n'+
        'if(typeof _s === "undefined") _s = numeric.dim(x);\n'+
        'if(typeof _k === "undefined") _k = 0;\n'+
        'var _n = _s[_k];\n'+
        'var i,xi;\n'+
        'if(_k < _s.length-1) {\n'+
        '    for(i=_n-1;i>=0;i--) {\n'+
        '        accum = arguments.callee(x[i],accum,_s,_k+1);\n'+
        '    }'+
        '    return accum;\n'+
        '}\n'+
        'for(i=_n-1;i>=1;i-=2) { \n'+
        '    xi = x[i];\n'+
        '    '+body+';\n'+
        '    xi = x[i-1];\n'+
        '    '+body+';\n'+
        '}\n'+
        'if(i === 0) {\n'+
        '    xi = x[i];\n'+
        '    '+body+'\n'+
        '}\n'+
        'return accum;'
      );
    };
    numeric.mapreduce2 = function mapreduce2(body,setup) {
      return Function('x',
        'var n = x.length;\n'+
        'var i,xi;\n'+setup+';\n'+
        'for(i=n-1;i!==-1;--i) { \n'+
        '    xi = x[i];\n'+
        '    '+body+';\n'+
        '}\n'+
        'return accum;'
      );
    };


    numeric.same = function same(x,y) {
      var i,n;
      if(!(x instanceof Array) || !(y instanceof Array)) { return false; }
      n = x.length;
      if(n !== y.length) { return false; }
      for(i=0;i<n;i++) {
        if(x[i] === y[i]) { continue; }
        if(typeof x[i] === "object") { if(!same(x[i],y[i])) return false; }
        else { return false; }
      }
      return true;
    };

    numeric.rep = function rep(s,v,k) {
      if(typeof k === "undefined") { k=0; }
      var n = s[k], ret = Array(n), i;
      if(k === s.length-1) {
        for(i=n-2;i>=0;i-=2) { ret[i+1] = v; ret[i] = v; }
        if(i===-1) { ret[0] = v; }
        return ret;
      }
      for(i=n-1;i>=0;i--) { ret[i] = numeric.rep(s,v,k+1); }
      return ret;
    };


    numeric.dotMMsmall = function dotMMsmall(x,y) {
      var i,j,k,p,q,r,ret,foo,bar,woo,i0,k0,p0,r0;
      p = x.length; q = y.length; r = y[0].length;
      ret = Array(p);
      for(i=p-1;i>=0;i--) {
        foo = Array(r);
        bar = x[i];
        for(k=r-1;k>=0;k--) {
          woo = bar[q-1]*y[q-1][k];
          for(j=q-2;j>=1;j-=2) {
            i0 = j-1;
            woo += bar[j]*y[j][k] + bar[i0]*y[i0][k];
          }
          if(j===0) { woo += bar[0]*y[0][k]; }
          foo[k] = woo;
        }
        ret[i] = foo;
      }
      return ret;
    };
    numeric._getCol = function _getCol(A,j,x) {
      var n = A.length, i;
      for(i=n-1;i>0;--i) {
        x[i] = A[i][j];
        --i;
        x[i] = A[i][j];
      }
      if(i===0) x[0] = A[0][j];
    };
    numeric.dotMMbig = function dotMMbig(x,y){
      var gc = numeric._getCol, p = y.length, v = Array(p);
      var m = x.length, n = y[0].length, A = new Array(m), xj;
      var VV = numeric.dotVV;
      var i,j,k,z;
      --p;
      --m;
      for(i=m;i!==-1;--i) A[i] = Array(n);
      --n;
      for(i=n;i!==-1;--i) {
        gc(y,i,v);
        for(j=m;j!==-1;--j) {
          z=0;
          xj = x[j];
          A[j][i] = VV(xj,v);
        }
      }
      return A;
    };

    numeric.dotMV = function dotMV(x,y) {
      var p = x.length, q = y.length,i;
      var ret = Array(p), dotVV = numeric.dotVV;
      for(i=p-1;i>=0;i--) { ret[i] = dotVV(x[i],y); }
      return ret;
    };

    numeric.dotVM = function dotVM(x,y) {
      var i,j,k,p,q,r,ret,foo,bar,woo,i0,k0,p0,r0,s1,s2,s3,baz,accum;
      p = x.length; q = y[0].length;
      ret = Array(q);
      for(k=q-1;k>=0;k--) {
        woo = x[p-1]*y[p-1][k];
        for(j=p-2;j>=1;j-=2) {
          i0 = j-1;
          woo += x[j]*y[j][k] + x[i0]*y[i0][k];
        }
        if(j===0) { woo += x[0]*y[0][k]; }
        ret[k] = woo;
      }
      return ret;
    };

    numeric.dotVV = function dotVV(x,y) {
      var i,n=x.length,i1,ret = x[n-1]*y[n-1];
      for(i=n-2;i>=1;i-=2) {
        i1 = i-1;
        ret += x[i]*y[i] + x[i1]*y[i1];
      }
      if(i===0) { ret += x[0]*y[0]; }
      return ret;
    };

    numeric.dot = function dot(x,y) {
      var d = numeric.dim;
      switch(d(x).length*1000+d(y).length) {
        case 2002:
          if(y.length < 10) return numeric.dotMMsmall(x,y);
          else return numeric.dotMMbig(x,y);
        case 2001: return numeric.dotMV(x,y);
        case 1002: return numeric.dotVM(x,y);
        case 1001: return numeric.dotVV(x,y);
        case 1000: return numeric.mulVS(x,y);
        case 1: return numeric.mulSV(x,y);
        case 0: return x*y;
        default: throw new Error('numeric.dot only works on vectors and matrices');
      }
    };

    numeric.diag = function diag(d) {
      var i,i1,j,n = d.length, A = Array(n), Ai;
      for(i=n-1;i>=0;i--) {
        Ai = Array(n);
        i1 = i+2;
        for(j=n-1;j>=i1;j-=2) {
          Ai[j] = 0;
          Ai[j-1] = 0;
        }
        if(j>i) { Ai[j] = 0; }
        Ai[i] = d[i];
        for(j=i-1;j>=1;j-=2) {
          Ai[j] = 0;
          Ai[j-1] = 0;
        }
        if(j===0) { Ai[0] = 0; }
        A[i] = Ai;
      }
      return A;
    };
    numeric.getDiag = function(A) {
      var n = Math.min(A.length,A[0].length),i,ret = Array(n);
      for(i=n-1;i>=1;--i) {
        ret[i] = A[i][i];
        --i;
        ret[i] = A[i][i];
      }
      if(i===0) {
        ret[0] = A[0][0];
      }
      return ret;
    };

    numeric.identity = function identity(n) { return numeric.diag(numeric.rep([n],1)); };
    numeric.pointwise = function pointwise(params,body,setup) {
      if(typeof setup === "undefined") { setup = ""; }
      var fun = [];
      var k;
      var avec = /\[i\]$/,p,thevec = '';
      var haveret = false;
      for(k=0;k<params.length;k++) {
        if(avec.test(params[k])) {
          p = params[k].substring(0,params[k].length-3);
          thevec = p;
        } else { p = params[k]; }
        if(p==='ret') haveret = true;
        fun.push(p);
      }
      fun[params.length] = '_s';
      fun[params.length+1] = '_k';
      fun[params.length+2] = (
        'if(typeof _s === "undefined") _s = numeric.dim('+thevec+');\n'+
        'if(typeof _k === "undefined") _k = 0;\n'+
        'var _n = _s[_k];\n'+
        'var i'+(haveret?'':', ret = Array(_n)')+';\n'+
        'if(_k < _s.length-1) {\n'+
        '    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee('+params.join(',')+',_s,_k+1);\n'+
        '    return ret;\n'+
        '}\n'+
        setup+'\n'+
        'for(i=_n-1;i!==-1;--i) {\n'+
        '    '+body+'\n'+
        '}\n'+
        'return ret;'
      );
      return Function.apply(null,fun);
    };
    numeric.pointwise2 = function pointwise2(params,body,setup) {
      if(typeof setup === "undefined") { setup = ""; }
      var fun = [];
      var k;
      var avec = /\[i\]$/,p,thevec = '';
      var haveret = false;
      for(k=0;k<params.length;k++) {
        if(avec.test(params[k])) {
          p = params[k].substring(0,params[k].length-3);
          thevec = p;
        } else { p = params[k]; }
        if(p==='ret') haveret = true;
        fun.push(p);
      }
      fun[params.length] = (
        'var _n = '+thevec+'.length;\n'+
        'var i'+(haveret?'':', ret = Array(_n)')+';\n'+
        setup+'\n'+
        'for(i=_n-1;i!==-1;--i) {\n'+
        body+'\n'+
        '}\n'+
        'return ret;'
      );
      return Function.apply(null,fun);
    };
    numeric._biforeach = (function _biforeach(x,y,s,k,f) {
      if(k === s.length-1) { f(x,y); return; }
      var i,n=s[k];
      for(i=n-1;i>=0;i--) { _biforeach(typeof x==="object"?x[i]:x,typeof y==="object"?y[i]:y,s,k+1,f); }
    });
    numeric._biforeach2 = (function _biforeach2(x,y,s,k,f) {
      if(k === s.length-1) { return f(x,y); }
      var i,n=s[k],ret = Array(n);
      for(i=n-1;i>=0;--i) { ret[i] = _biforeach2(typeof x==="object"?x[i]:x,typeof y==="object"?y[i]:y,s,k+1,f); }
      return ret;
    });
    numeric._foreach = (function _foreach(x,s,k,f) {
      if(k === s.length-1) { f(x); return; }
      var i,n=s[k];
      for(i=n-1;i>=0;i--) { _foreach(x[i],s,k+1,f); }
    });
    numeric._foreach2 = (function _foreach2(x,s,k,f) {
      if(k === s.length-1) { return f(x); }
      var i,n=s[k], ret = Array(n);
      for(i=n-1;i>=0;i--) { ret[i] = _foreach2(x[i],s,k+1,f); }
      return ret;
    });

    /*numeric.anyV = numeric.mapreduce('if(xi) return true;','false');
numeric.allV = numeric.mapreduce('if(!xi) return false;','true');
numeric.any = function(x) { if(typeof x.length === "undefined") return x; return numeric.anyV(x); }
numeric.all = function(x) { if(typeof x.length === "undefined") return x; return numeric.allV(x); }*/

    numeric.ops2 = {
      add: '+',
      sub: '-',
      mul: '*',
      div: '/',
      mod: '%',
      and: '&&',
      or:  '||',
      eq:  '===',
      neq: '!==',
      lt:  '<',
      gt:  '>',
      leq: '<=',
      geq: '>=',
      band: '&',
      bor: '|',
      bxor: '^',
      lshift: '<<',
      rshift: '>>',
      rrshift: '>>>'
    };
    numeric.opseq = {
      addeq: '+=',
      subeq: '-=',
      muleq: '*=',
      diveq: '/=',
      modeq: '%=',
      lshifteq: '<<=',
      rshifteq: '>>=',
      rrshifteq: '>>>=',
      bandeq: '&=',
      boreq: '|=',
      bxoreq: '^='
    };
    numeric.mathfuns = ['abs','acos','asin','atan','ceil','cos',
      'exp','floor','log','round','sin','sqrt','tan',
      'isNaN','isFinite'];
    numeric.mathfuns2 = ['atan2','pow','max','min'];
    numeric.ops1 = {
      neg: '-',
      not: '!',
      bnot: '~',
      clone: ''
    };
    numeric.mapreducers = {
      any: ['if(xi) return true;','var accum = false;'],
      all: ['if(!xi) return false;','var accum = true;'],
      sum: ['accum += xi;','var accum = 0;'],
      prod: ['accum *= xi;','var accum = 1;'],
      norm2Squared: ['accum += xi*xi;','var accum = 0;'],
      norminf: ['accum = max(accum,abs(xi));','var accum = 0, max = Math.max, abs = Math.abs;'],
      norm1: ['accum += abs(xi)','var accum = 0, abs = Math.abs;'],
      sup: ['accum = max(accum,xi);','var accum = -Infinity, max = Math.max;'],
      inf: ['accum = min(accum,xi);','var accum = Infinity, min = Math.min;']
    };

    (function () {
      var i,o;
      for(i=0;i<numeric.mathfuns2.length;++i) {
        o = numeric.mathfuns2[i];
        numeric.ops2[o] = o;
      }
      for(i in numeric.ops2) {
        if(numeric.ops2.hasOwnProperty(i)) {
          o = numeric.ops2[i];
          var code, codeeq, setup = '';
          if(numeric.myIndexOf.call(numeric.mathfuns2,i)!==-1) {
            setup = 'var '+o+' = Math.'+o+';\n';
            code = function(r,x,y) { return r+' = '+o+'('+x+','+y+')'; };
            codeeq = function(x,y) { return x+' = '+o+'('+x+','+y+')'; };
          } else {
            code = function(r,x,y) { return r+' = '+x+' '+o+' '+y; };
            if(numeric.opseq.hasOwnProperty(i+'eq')) {
              codeeq = function(x,y) { return x+' '+o+'= '+y; };
            } else {
              codeeq = function(x,y) { return x+' = '+x+' '+o+' '+y; };
            }
          }
          numeric[i+'VV'] = numeric.pointwise2(['x[i]','y[i]'],code('ret[i]','x[i]','y[i]'),setup);
          numeric[i+'SV'] = numeric.pointwise2(['x','y[i]'],code('ret[i]','x','y[i]'),setup);
          numeric[i+'VS'] = numeric.pointwise2(['x[i]','y'],code('ret[i]','x[i]','y'),setup);
          numeric[i] = Function(
            'var n = arguments.length, i, x = arguments[0], y;\n'+
            'var VV = numeric.'+i+'VV, VS = numeric.'+i+'VS, SV = numeric.'+i+'SV;\n'+
            'var dim = numeric.dim;\n'+
            'for(i=1;i!==n;++i) { \n'+
            '  y = arguments[i];\n'+
            '  if(typeof x === "object") {\n'+
            '      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);\n'+
            '      else x = numeric._biforeach2(x,y,dim(x),0,VS);\n'+
            '  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);\n'+
            '  else '+codeeq('x','y')+'\n'+
            '}\nreturn x;\n');
          numeric[o] = numeric[i];
          numeric[i+'eqV'] = numeric.pointwise2(['ret[i]','x[i]'], codeeq('ret[i]','x[i]'),setup);
          numeric[i+'eqS'] = numeric.pointwise2(['ret[i]','x'], codeeq('ret[i]','x'),setup);
          numeric[i+'eq'] = Function(
            'var n = arguments.length, i, x = arguments[0], y;\n'+
            'var V = numeric.'+i+'eqV, S = numeric.'+i+'eqS\n'+
            'var s = numeric.dim(x);\n'+
            'for(i=1;i!==n;++i) { \n'+
            '  y = arguments[i];\n'+
            '  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);\n'+
            '  else numeric._biforeach(x,y,s,0,S);\n'+
            '}\nreturn x;\n');
        }
      }
      for(i=0;i<numeric.mathfuns2.length;++i) {
        o = numeric.mathfuns2[i];
        delete numeric.ops2[o];
      }
      for(i=0;i<numeric.mathfuns.length;++i) {
        o = numeric.mathfuns[i];
        numeric.ops1[o] = o;
      }
      for(i in numeric.ops1) {
        if(numeric.ops1.hasOwnProperty(i)) {
          setup = '';
          o = numeric.ops1[i];
          if(numeric.myIndexOf.call(numeric.mathfuns,i)!==-1) {
            if(Math.hasOwnProperty(o)) setup = 'var '+o+' = Math.'+o+';\n';
          }
          numeric[i+'eqV'] = numeric.pointwise2(['ret[i]'],'ret[i] = '+o+'(ret[i]);',setup);
          numeric[i+'eq'] = Function('x',
            'if(typeof x !== "object") return '+o+'x\n'+
            'var i;\n'+
            'var V = numeric.'+i+'eqV;\n'+
            'var s = numeric.dim(x);\n'+
            'numeric._foreach(x,s,0,V);\n'+
            'return x;\n');
          numeric[i+'V'] = numeric.pointwise2(['x[i]'],'ret[i] = '+o+'(x[i]);',setup);
          numeric[i] = Function('x',
            'if(typeof x !== "object") return '+o+'(x)\n'+
            'var i;\n'+
            'var V = numeric.'+i+'V;\n'+
            'var s = numeric.dim(x);\n'+
            'return numeric._foreach2(x,s,0,V);\n');
        }
      }
      for(i=0;i<numeric.mathfuns.length;++i) {
        o = numeric.mathfuns[i];
        delete numeric.ops1[o];
      }
      for(i in numeric.mapreducers) {
        if(numeric.mapreducers.hasOwnProperty(i)) {
          o = numeric.mapreducers[i];
          numeric[i+'V'] = numeric.mapreduce2(o[0],o[1]);
          numeric[i] = Function('x','s','k',
            o[1]+
            'if(typeof x !== "object") {'+
            '    xi = x;\n'+
            o[0]+';\n'+
            '    return accum;\n'+
            '}'+
            'if(typeof s === "undefined") s = numeric.dim(x);\n'+
            'if(typeof k === "undefined") k = 0;\n'+
            'if(k === s.length-1) return numeric.'+i+'V(x);\n'+
            'var xi;\n'+
            'var n = x.length, i;\n'+
            'for(i=n-1;i!==-1;--i) {\n'+
            '   xi = arguments.callee(x[i]);\n'+
            o[0]+';\n'+
            '}\n'+
            'return accum;\n');
        }
      }
    }());

    numeric.truncVV = numeric.pointwise(['x[i]','y[i]'],'ret[i] = round(x[i]/y[i])*y[i];','var round = Math.round;');
    numeric.truncVS = numeric.pointwise(['x[i]','y'],'ret[i] = round(x[i]/y)*y;','var round = Math.round;');
    numeric.truncSV = numeric.pointwise(['x','y[i]'],'ret[i] = round(x/y[i])*y[i];','var round = Math.round;');
    numeric.trunc = function trunc(x,y) {
      if(typeof x === "object") {
        if(typeof y === "object") return numeric.truncVV(x,y);
        return numeric.truncVS(x,y);
      }
      if (typeof y === "object") return numeric.truncSV(x,y);
      return Math.round(x/y)*y;
    };

    numeric.inv = function inv(x) {
      var s = numeric.dim(x), abs = Math.abs, m = s[0], n = s[1];
      var A = numeric.clone(x), Ai, Aj;
      var I = numeric.identity(m), Ii, Ij;
      var i,j,k,x;
      for(j=0;j<n;++j) {
        var i0 = -1;
        var v0 = -1;
        for(i=j;i!==m;++i) { k = abs(A[i][j]); if(k>v0) { i0 = i; v0 = k; } }
        Aj = A[i0]; A[i0] = A[j]; A[j] = Aj;
        Ij = I[i0]; I[i0] = I[j]; I[j] = Ij;
        x = Aj[j];
        for(k=j;k!==n;++k)    Aj[k] /= x;
        for(k=n-1;k!==-1;--k) Ij[k] /= x;
        for(i=m-1;i!==-1;--i) {
          if(i!==j) {
            Ai = A[i];
            Ii = I[i];
            x = Ai[j];
            for(k=j+1;k!==n;++k)  Ai[k] -= Aj[k]*x;
            for(k=n-1;k>0;--k) { Ii[k] -= Ij[k]*x; --k; Ii[k] -= Ij[k]*x; }
            if(k===0) Ii[0] -= Ij[0]*x;
          }
        }
      }
      return I;
    };

    numeric.det = function det(x) {
      var s = numeric.dim(x);
      if(s.length !== 2 || s[0] !== s[1]) { throw new Error('numeric: det() only works on square matrices'); }
      var n = s[0], ret = 1,i,j,k,A = numeric.clone(x),Aj,Ai,alpha,temp,k1,k2,k3;
      for(j=0;j<n-1;j++) {
        k=j;
        for(i=j+1;i<n;i++) { if(Math.abs(A[i][j]) > Math.abs(A[k][j])) { k = i; } }
        if(k !== j) {
          temp = A[k]; A[k] = A[j]; A[j] = temp;
          ret *= -1;
        }
        Aj = A[j];
        for(i=j+1;i<n;i++) {
          Ai = A[i];
          alpha = Ai[j]/Aj[j];
          for(k=j+1;k<n-1;k+=2) {
            k1 = k+1;
            Ai[k] -= Aj[k]*alpha;
            Ai[k1] -= Aj[k1]*alpha;
          }
          if(k!==n) { Ai[k] -= Aj[k]*alpha; }
        }
        if(Aj[j] === 0) { return 0; }
        ret *= Aj[j];
      }
      return ret*A[j][j];
    };

    numeric.transpose = function transpose(x) {
      var i,j,m = x.length,n = x[0].length, ret=Array(n),A0,A1,Bj;
      for(j=0;j<n;j++) ret[j] = Array(m);
      for(i=m-1;i>=1;i-=2) {
        A1 = x[i];
        A0 = x[i-1];
        for(j=n-1;j>=1;--j) {
          Bj = ret[j]; Bj[i] = A1[j]; Bj[i-1] = A0[j];
          --j;
          Bj = ret[j]; Bj[i] = A1[j]; Bj[i-1] = A0[j];
        }
        if(j===0) {
          Bj = ret[0]; Bj[i] = A1[0]; Bj[i-1] = A0[0];
        }
      }
      if(i===0) {
        A0 = x[0];
        for(j=n-1;j>=1;--j) {
          ret[j][0] = A0[j];
          --j;
          ret[j][0] = A0[j];
        }
        if(j===0) { ret[0][0] = A0[0]; }
      }
      return ret;
    };
    numeric.negtranspose = function negtranspose(x) {
      var i,j,m = x.length,n = x[0].length, ret=Array(n),A0,A1,Bj;
      for(j=0;j<n;j++) ret[j] = Array(m);
      for(i=m-1;i>=1;i-=2) {
        A1 = x[i];
        A0 = x[i-1];
        for(j=n-1;j>=1;--j) {
          Bj = ret[j]; Bj[i] = -A1[j]; Bj[i-1] = -A0[j];
          --j;
          Bj = ret[j]; Bj[i] = -A1[j]; Bj[i-1] = -A0[j];
        }
        if(j===0) {
          Bj = ret[0]; Bj[i] = -A1[0]; Bj[i-1] = -A0[0];
        }
      }
      if(i===0) {
        A0 = x[0];
        for(j=n-1;j>=1;--j) {
          ret[j][0] = -A0[j];
          --j;
          ret[j][0] = -A0[j];
        }
        if(j===0) { ret[0][0] = -A0[0]; }
      }
      return ret;
    };

    numeric._random = function _random(s,k) {
      var i,n=s[k],ret=Array(n), rnd;
      if(k === s.length-1) {
        rnd = Math.random;
        for(i=n-1;i>=1;i-=2) {
          ret[i] = rnd();
          ret[i-1] = rnd();
        }
        if(i===0) { ret[0] = rnd(); }
        return ret;
      }
      for(i=n-1;i>=0;i--) ret[i] = _random(s,k+1);
      return ret;
    };
    numeric.random = function random(s) { return numeric._random(s,0); };

    numeric.norm2 = function norm2(x) { return Math.sqrt(numeric.norm2Squared(x)); };

    numeric.linspace = function linspace(a,b,n) {
      if(typeof n === "undefined") n = Math.max(Math.round(b-a)+1,1);
      if(n<2) { return n===1?[a]:[]; }
      var i,ret = Array(n);
      n--;
      for(i=n;i>=0;i--) { ret[i] = (i*b+(n-i)*a)/n; }
      return ret;
    };

    numeric.getBlock = function getBlock(x,from,to) {
      var s = numeric.dim(x);
      function foo(x,k) {
        var i,a = from[k], n = to[k]-a, ret = Array(n);
        if(k === s.length-1) {
          for(i=n;i>=0;i--) { ret[i] = x[i+a]; }
          return ret;
        }
        for(i=n;i>=0;i--) { ret[i] = foo(x[i+a],k+1); }
        return ret;
      }
      return foo(x,0);
    };

    numeric.setBlock = function setBlock(x,from,to,B) {
      var s = numeric.dim(x);
      function foo(x,y,k) {
        var i,a = from[k], n = to[k]-a;
        if(k === s.length-1) { for(i=n;i>=0;i--) { x[i+a] = y[i]; } }
        for(i=n;i>=0;i--) { foo(x[i+a],y[i],k+1); }
      }
      foo(x,B,0);
      return x;
    };

    numeric.getRange = function getRange(A,I,J) {
      var m = I.length, n = J.length;
      var i,j;
      var B = Array(m), Bi, AI;
      for(i=m-1;i!==-1;--i) {
        B[i] = Array(n);
        Bi = B[i];
        AI = A[I[i]];
        for(j=n-1;j!==-1;--j) Bi[j] = AI[J[j]];
      }
      return B;
    };

    numeric.blockMatrix = function blockMatrix(X) {
      var s = numeric.dim(X);
      if(s.length<4) return numeric.blockMatrix([X]);
      var m=s[0],n=s[1],M,N,i,j,Xij;
      M = 0; N = 0;
      for(i=0;i<m;++i) M+=X[i][0].length;
      for(j=0;j<n;++j) N+=X[0][j][0].length;
      var Z = Array(M);
      for(i=0;i<M;++i) Z[i] = Array(N);
      var I=0,J,ZI,k,l,Xijk;
      for(i=0;i<m;++i) {
        J=N;
        for(j=n-1;j!==-1;--j) {
          Xij = X[i][j];
          J -= Xij[0].length;
          for(k=Xij.length-1;k!==-1;--k) {
            Xijk = Xij[k];
            ZI = Z[I+k];
            for(l = Xijk.length-1;l!==-1;--l) ZI[J+l] = Xijk[l];
          }
        }
        I += X[i][0].length;
      }
      return Z;
    };

    numeric.tensor = function tensor(x,y) {
      if(typeof x === "number" || typeof y === "number") return numeric.mul(x,y);
      var s1 = numeric.dim(x), s2 = numeric.dim(y);
      if(s1.length !== 1 || s2.length !== 1) {
        throw new Error('numeric: tensor product is only defined for vectors');
      }
      var m = s1[0], n = s2[0], A = Array(m), Ai, i,j,xi;
      for(i=m-1;i>=0;i--) {
        Ai = Array(n);
        xi = x[i];
        for(j=n-1;j>=3;--j) {
          Ai[j] = xi * y[j];
          --j;
          Ai[j] = xi * y[j];
          --j;
          Ai[j] = xi * y[j];
          --j;
          Ai[j] = xi * y[j];
        }
        while(j>=0) { Ai[j] = xi * y[j]; --j; }
        A[i] = Ai;
      }
      return A;
    };

// 3. The Tensor type T
    numeric.T = function T(x,y) { this.x = x; this.y = y; };
    numeric.t = function t(x,y) { return new numeric.T(x,y); };

    numeric.Tbinop = function Tbinop(rr,rc,cr,cc,setup) {
      var io = numeric.indexOf;
      if(typeof setup !== "string") {
        var k;
        setup = '';
        for(k in numeric) {
          if(numeric.hasOwnProperty(k) && (rr.indexOf(k)>=0 || rc.indexOf(k)>=0 || cr.indexOf(k)>=0 || cc.indexOf(k)>=0) && k.length>1) {
            setup += 'var '+k+' = numeric.'+k+';\n';
          }
        }
      }
      return Function(['y'],
        'var x = this;\n'+
        'if(!(y instanceof numeric.T)) { y = new numeric.T(y); }\n'+
        setup+'\n'+
        'if(x.y) {'+
        '  if(y.y) {'+
        '    return new numeric.T('+cc+');\n'+
        '  }\n'+
        '  return new numeric.T('+cr+');\n'+
        '}\n'+
        'if(y.y) {\n'+
        '  return new numeric.T('+rc+');\n'+
        '}\n'+
        'return new numeric.T('+rr+');\n'
      );
    };

    numeric.T.prototype.add = numeric.Tbinop(
      'add(x.x,y.x)',
      'add(x.x,y.x),y.y',
      'add(x.x,y.x),x.y',
      'add(x.x,y.x),add(x.y,y.y)');
    numeric.T.prototype.sub = numeric.Tbinop(
      'sub(x.x,y.x)',
      'sub(x.x,y.x),neg(y.y)',
      'sub(x.x,y.x),x.y',
      'sub(x.x,y.x),sub(x.y,y.y)');
    numeric.T.prototype.mul = numeric.Tbinop(
      'mul(x.x,y.x)',
      'mul(x.x,y.x),mul(x.x,y.y)',
      'mul(x.x,y.x),mul(x.y,y.x)',
      'sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))');

    numeric.T.prototype.reciprocal = function reciprocal() {
      var mul = numeric.mul, div = numeric.div;
      if(this.y) {
        var d = numeric.add(mul(this.x,this.x),mul(this.y,this.y));
        return new numeric.T(div(this.x,d),div(numeric.neg(this.y),d));
      }
      return new T(div(1,this.x));
    };
    numeric.T.prototype.div = function div(y) {
      if(!(y instanceof numeric.T)) y = new numeric.T(y);
      if(y.y) { return this.mul(y.reciprocal()); }
      var div = numeric.div;
      if(this.y) { return new numeric.T(div(this.x,y.x),div(this.y,y.x)); }
      return new numeric.T(div(this.x,y.x));
    };
    numeric.T.prototype.dot = numeric.Tbinop(
      'dot(x.x,y.x)',
      'dot(x.x,y.x),dot(x.x,y.y)',
      'dot(x.x,y.x),dot(x.y,y.x)',
      'sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))'
    );
    numeric.T.prototype.transpose = function transpose() {
      var t = numeric.transpose, x = this.x, y = this.y;
      if(y) { return new numeric.T(t(x),t(y)); }
      return new numeric.T(t(x));
    };
    numeric.T.prototype.transjugate = function transjugate() {
      var t = numeric.transpose, x = this.x, y = this.y;
      if(y) { return new numeric.T(t(x),numeric.negtranspose(y)); }
      return new numeric.T(t(x));
    };
    numeric.Tunop = function Tunop(r,c,s) {
      if(typeof s !== "string") { s = ''; }
      return Function(
        'var x = this;\n'+
        s+'\n'+
        'if(x.y) {'+
        '  '+c+';\n'+
        '}\n'+
        r+';\n'
      );
    };

    numeric.T.prototype.exp = numeric.Tunop(
      'return new numeric.T(ex)',
      'return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))',
      'var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;');
    numeric.T.prototype.conj = numeric.Tunop(
      'return new numeric.T(x.x);',
      'return new numeric.T(x.x,numeric.neg(x.y));');
    numeric.T.prototype.neg = numeric.Tunop(
      'return new numeric.T(neg(x.x));',
      'return new numeric.T(neg(x.x),neg(x.y));',
      'var neg = numeric.neg;');
    numeric.T.prototype.sin = numeric.Tunop(
      'return new numeric.T(numeric.sin(x.x))',
      'return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));');
    numeric.T.prototype.cos = numeric.Tunop(
      'return new numeric.T(numeric.cos(x.x))',
      'return x.exp().add(x.neg().exp()).div(2);');
    numeric.T.prototype.abs = numeric.Tunop(
      'return new numeric.T(numeric.abs(x.x));',
      'return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));',
      'var mul = numeric.mul;');
    numeric.T.prototype.log = numeric.Tunop(
      'return new numeric.T(numeric.log(x.x));',
      'var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();\n'+
      'return new numeric.T(numeric.log(r.x),theta.x);');
    numeric.T.prototype.norm2 = numeric.Tunop(
      'return numeric.norm2(x.x);',
      'var f = numeric.norm2Squared;\n'+
      'return Math.sqrt(f(x.x)+f(x.y));');
    numeric.T.prototype.inv = function inv() {
      var A = this;
      if(typeof A.y === "undefined") { return new numeric.T(numeric.inv(A.x)); }
      var n = A.x.length, i, j, k;
      var Rx = numeric.identity(n),Ry = numeric.rep([n,n],0);
      var Ax = numeric.clone(A.x), Ay = numeric.clone(A.y);
      var Aix, Aiy, Ajx, Ajy, Rix, Riy, Rjx, Rjy;
      var i,j,k,d,d1,ax,ay,bx,by,temp;
      for(i=0;i<n;i++) {
        ax = Ax[i][i]; ay = Ay[i][i];
        d = ax*ax+ay*ay;
        k = i;
        for(j=i+1;j<n;j++) {
          ax = Ax[j][i]; ay = Ay[j][i];
          d1 = ax*ax+ay*ay;
          if(d1 > d) { k=j; d = d1; }
        }
        if(k!==i) {
          temp = Ax[i]; Ax[i] = Ax[k]; Ax[k] = temp;
          temp = Ay[i]; Ay[i] = Ay[k]; Ay[k] = temp;
          temp = Rx[i]; Rx[i] = Rx[k]; Rx[k] = temp;
          temp = Ry[i]; Ry[i] = Ry[k]; Ry[k] = temp;
        }
        Aix = Ax[i]; Aiy = Ay[i];
        Rix = Rx[i]; Riy = Ry[i];
        ax = Aix[i]; ay = Aiy[i];
        for(j=i+1;j<n;j++) {
          bx = Aix[j]; by = Aiy[j];
          Aix[j] = (bx*ax+by*ay)/d;
          Aiy[j] = (by*ax-bx*ay)/d;
        }
        for(j=0;j<n;j++) {
          bx = Rix[j]; by = Riy[j];
          Rix[j] = (bx*ax+by*ay)/d;
          Riy[j] = (by*ax-bx*ay)/d;
        }
        for(j=i+1;j<n;j++) {
          Ajx = Ax[j]; Ajy = Ay[j];
          Rjx = Rx[j]; Rjy = Ry[j];
          ax = Ajx[i]; ay = Ajy[i];
          for(k=i+1;k<n;k++) {
            bx = Aix[k]; by = Aiy[k];
            Ajx[k] -= bx*ax-by*ay;
            Ajy[k] -= by*ax+bx*ay;
          }
          for(k=0;k<n;k++) {
            bx = Rix[k]; by = Riy[k];
            Rjx[k] -= bx*ax-by*ay;
            Rjy[k] -= by*ax+bx*ay;
          }
        }
      }
      for(i=n-1;i>0;i--) {
        Rix = Rx[i]; Riy = Ry[i];
        for(j=i-1;j>=0;j--) {
          Rjx = Rx[j]; Rjy = Ry[j];
          ax = Ax[j][i]; ay = Ay[j][i];
          for(k=n-1;k>=0;k--) {
            bx = Rix[k]; by = Riy[k];
            Rjx[k] -= ax*bx - ay*by;
            Rjy[k] -= ax*by + ay*bx;
          }
        }
      }
      return new numeric.T(Rx,Ry);
    };
    numeric.T.prototype.get = function get(i) {
      var x = this.x, y = this.y, k = 0, ik, n = i.length;
      if(y) {
        while(k<n) {
          ik = i[k];
          x = x[ik];
          y = y[ik];
          k++;
        }
        return new numeric.T(x,y);
      }
      while(k<n) {
        ik = i[k];
        x = x[ik];
        k++;
      }
      return new numeric.T(x);
    };
    numeric.T.prototype.set = function set(i,v) {
      var x = this.x, y = this.y, k = 0, ik, n = i.length, vx = v.x, vy = v.y;
      if(n===0) {
        if(vy) { this.y = vy; }
        else if(y) { this.y = undefined; }
        this.x = x;
        return this;
      }
      if(vy) {
        if(y) { /* ok */ }
        else {
          y = numeric.rep(numeric.dim(x),0);
          this.y = y;
        }
        while(k<n-1) {
          ik = i[k];
          x = x[ik];
          y = y[ik];
          k++;
        }
        ik = i[k];
        x[ik] = vx;
        y[ik] = vy;
        return this;
      }
      if(y) {
        while(k<n-1) {
          ik = i[k];
          x = x[ik];
          y = y[ik];
          k++;
        }
        ik = i[k];
        x[ik] = vx;
        if(vx instanceof Array) y[ik] = numeric.rep(numeric.dim(vx),0);
        else y[ik] = 0;
        return this;
      }
      while(k<n-1) {
        ik = i[k];
        x = x[ik];
        k++;
      }
      ik = i[k];
      x[ik] = vx;
      return this;
    };
    numeric.T.prototype.getRows = function getRows(i0,i1) {
      var n = i1-i0+1, j;
      var rx = Array(n), ry, x = this.x, y = this.y;
      for(j=i0;j<=i1;j++) { rx[j-i0] = x[j]; }
      if(y) {
        ry = Array(n);
        for(j=i0;j<=i1;j++) { ry[j-i0] = y[j]; }
        return new numeric.T(rx,ry);
      }
      return new numeric.T(rx);
    };
    numeric.T.prototype.setRows = function setRows(i0,i1,A) {
      var j;
      var rx = this.x, ry = this.y, x = A.x, y = A.y;
      for(j=i0;j<=i1;j++) { rx[j] = x[j-i0]; }
      if(y) {
        if(!ry) { ry = numeric.rep(numeric.dim(rx),0); this.y = ry; }
        for(j=i0;j<=i1;j++) { ry[j] = y[j-i0]; }
      } else if(ry) {
        for(j=i0;j<=i1;j++) { ry[j] = numeric.rep([x[j-i0].length],0); }
      }
      return this;
    };
    numeric.T.prototype.getRow = function getRow(k) {
      var x = this.x, y = this.y;
      if(y) { return new numeric.T(x[k],y[k]); }
      return new numeric.T(x[k]);
    };
    numeric.T.prototype.setRow = function setRow(i,v) {
      var rx = this.x, ry = this.y, x = v.x, y = v.y;
      rx[i] = x;
      if(y) {
        if(!ry) { ry = numeric.rep(numeric.dim(rx),0); this.y = ry; }
        ry[i] = y;
      } else if(ry) {
        ry = numeric.rep([x.length],0);
      }
      return this;
    };

    numeric.T.prototype.getBlock = function getBlock(from,to) {
      var x = this.x, y = this.y, b = numeric.getBlock;
      if(y) { return new numeric.T(b(x,from,to),b(y,from,to)); }
      return new numeric.T(b(x,from,to));
    };
    numeric.T.prototype.setBlock = function setBlock(from,to,A) {
      if(!(A instanceof numeric.T)) A = new numeric.T(A);
      var x = this.x, y = this.y, b = numeric.setBlock, Ax = A.x, Ay = A.y;
      if(Ay) {
        if(!y) { this.y = numeric.rep(numeric.dim(this),0); y = this.y; }
        b(x,from,to,Ax);
        b(y,from,to,Ay);
        return this;
      }
      b(x,from,to,Ax);
      if(y) b(y,from,to,numeric.rep(numeric.dim(Ax),0));
    };
    numeric.T.rep = function rep(s,v) {
      var T = numeric.T;
      if(!(v instanceof T)) v = new T(v);
      var x = v.x, y = v.y, r = numeric.rep;
      if(y) return new T(r(s,x),r(s,y));
      return new T(r(s,x));
    };
    numeric.T.diag = function diag(d) {
      if(!(d instanceof numeric.T)) d = new numeric.T(d);
      var x = d.x, y = d.y, diag = numeric.diag;
      if(y) return new numeric.T(diag(x),diag(y));
      return new numeric.T(diag(x));
    };
    numeric.T.eig = function eig() {
      if(this.y) { throw new Error('eig: not implemented for complex matrices.'); }
      return numeric.eig(this.x);
    };
    numeric.T.identity = function identity(n) { return new numeric.T(numeric.identity(n)); };
    numeric.T.prototype.getDiag = function getDiag() {
      var n = numeric;
      var x = this.x, y = this.y;
      if(y) { return new n.T(n.getDiag(x),n.getDiag(y)); }
      return new n.T(n.getDiag(x));
    };

// 4. Eigenvalues of real matrices

    numeric.house = function house(x) {
      var v = numeric.clone(x);
      var s = x[0] >= 0 ? 1 : -1;
      var alpha = s*numeric.norm2(x);
      v[0] += alpha;
      var foo = numeric.norm2(v);
      if(foo === 0) { /* this should not happen */ throw new Error('eig: internal error'); }
      return numeric.div(v,foo);
    };

    numeric.toUpperHessenberg = function toUpperHessenberg(me) {
      var s = numeric.dim(me);
      if(s.length !== 2 || s[0] !== s[1]) { throw new Error('numeric: toUpperHessenberg() only works on square matrices'); }
      var m = s[0], i,j,k,x,v,A = numeric.clone(me),B,C,Ai,Ci,Q = numeric.identity(m),Qi;
      for(j=0;j<m-2;j++) {
        x = Array(m-j-1);
        for(i=j+1;i<m;i++) { x[i-j-1] = A[i][j]; }
        if(numeric.norm2(x)>0) {
          v = numeric.house(x);
          B = numeric.getBlock(A,[j+1,j],[m-1,m-1]);
          C = numeric.tensor(v,numeric.dot(v,B));
          for(i=j+1;i<m;i++) { Ai = A[i]; Ci = C[i-j-1]; for(k=j;k<m;k++) Ai[k] -= 2*Ci[k-j]; }
          B = numeric.getBlock(A,[0,j+1],[m-1,m-1]);
          C = numeric.tensor(numeric.dot(B,v),v);
          for(i=0;i<m;i++) { Ai = A[i]; Ci = C[i]; for(k=j+1;k<m;k++) Ai[k] -= 2*Ci[k-j-1]; }
          B = Array(m-j-1);
          for(i=j+1;i<m;i++) B[i-j-1] = Q[i];
          C = numeric.tensor(v,numeric.dot(v,B));
          for(i=j+1;i<m;i++) { Qi = Q[i]; Ci = C[i-j-1]; for(k=0;k<m;k++) Qi[k] -= 2*Ci[k]; }
        }
      }
      return {H:A, Q:Q};
    };

    numeric.epsilon = 2.220446049250313e-16;

    numeric.QRFrancis = function(H,maxiter) {
      if(typeof maxiter === "undefined") { maxiter = 10000; }
      H = numeric.clone(H);
      var H0 = numeric.clone(H);
      var s = numeric.dim(H),m=s[0],x,v,a,b,c,d,det,tr, Hloc, Q = numeric.identity(m), Qi, Hi, B, C, Ci,i,j,k,iter;
      if(m<3) { return {Q:Q, B:[ [0,m-1] ]}; }
      var epsilon = numeric.epsilon;
      for(iter=0;iter<maxiter;iter++) {
        for(j=0;j<m-1;j++) {
          if(Math.abs(H[j+1][j]) < epsilon*(Math.abs(H[j][j])+Math.abs(H[j+1][j+1]))) {
            var QH1 = numeric.QRFrancis(numeric.getBlock(H,[0,0],[j,j]),maxiter);
            var QH2 = numeric.QRFrancis(numeric.getBlock(H,[j+1,j+1],[m-1,m-1]),maxiter);
            B = Array(j+1);
            for(i=0;i<=j;i++) { B[i] = Q[i]; }
            C = numeric.dot(QH1.Q,B);
            for(i=0;i<=j;i++) { Q[i] = C[i]; }
            B = Array(m-j-1);
            for(i=j+1;i<m;i++) { B[i-j-1] = Q[i]; }
            C = numeric.dot(QH2.Q,B);
            for(i=j+1;i<m;i++) { Q[i] = C[i-j-1]; }
            return {Q:Q,B:QH1.B.concat(numeric.add(QH2.B,j+1))};
          }
        }
        a = H[m-2][m-2]; b = H[m-2][m-1];
        c = H[m-1][m-2]; d = H[m-1][m-1];
        tr = a+d;
        det = (a*d-b*c);
        Hloc = numeric.getBlock(H, [0,0], [2,2]);
        if(tr*tr>=4*det) {
          var s1,s2;
          s1 = 0.5*(tr+Math.sqrt(tr*tr-4*det));
          s2 = 0.5*(tr-Math.sqrt(tr*tr-4*det));
          Hloc = numeric.add(numeric.sub(numeric.dot(Hloc,Hloc),
              numeric.mul(Hloc,s1+s2)),
            numeric.diag(numeric.rep([3],s1*s2)));
        } else {
          Hloc = numeric.add(numeric.sub(numeric.dot(Hloc,Hloc),
              numeric.mul(Hloc,tr)),
            numeric.diag(numeric.rep([3],det)));
        }
        x = [Hloc[0][0],Hloc[1][0],Hloc[2][0]];
        v = numeric.house(x);
        B = [H[0],H[1],H[2]];
        C = numeric.tensor(v,numeric.dot(v,B));
        for(i=0;i<3;i++) { Hi = H[i]; Ci = C[i]; for(k=0;k<m;k++) Hi[k] -= 2*Ci[k]; }
        B = numeric.getBlock(H, [0,0],[m-1,2]);
        C = numeric.tensor(numeric.dot(B,v),v);
        for(i=0;i<m;i++) { Hi = H[i]; Ci = C[i]; for(k=0;k<3;k++) Hi[k] -= 2*Ci[k]; }
        B = [Q[0],Q[1],Q[2]];
        C = numeric.tensor(v,numeric.dot(v,B));
        for(i=0;i<3;i++) { Qi = Q[i]; Ci = C[i]; for(k=0;k<m;k++) Qi[k] -= 2*Ci[k]; }
        var J;
        for(j=0;j<m-2;j++) {
          for(k=j;k<=j+1;k++) {
            if(Math.abs(H[k+1][k]) < epsilon*(Math.abs(H[k][k])+Math.abs(H[k+1][k+1]))) {
              var QH1 = numeric.QRFrancis(numeric.getBlock(H,[0,0],[k,k]),maxiter);
              var QH2 = numeric.QRFrancis(numeric.getBlock(H,[k+1,k+1],[m-1,m-1]),maxiter);
              B = Array(k+1);
              for(i=0;i<=k;i++) { B[i] = Q[i]; }
              C = numeric.dot(QH1.Q,B);
              for(i=0;i<=k;i++) { Q[i] = C[i]; }
              B = Array(m-k-1);
              for(i=k+1;i<m;i++) { B[i-k-1] = Q[i]; }
              C = numeric.dot(QH2.Q,B);
              for(i=k+1;i<m;i++) { Q[i] = C[i-k-1]; }
              return {Q:Q,B:QH1.B.concat(numeric.add(QH2.B,k+1))};
            }
          }
          J = Math.min(m-1,j+3);
          x = Array(J-j);
          for(i=j+1;i<=J;i++) { x[i-j-1] = H[i][j]; }
          v = numeric.house(x);
          B = numeric.getBlock(H, [j+1,j],[J,m-1]);
          C = numeric.tensor(v,numeric.dot(v,B));
          for(i=j+1;i<=J;i++) { Hi = H[i]; Ci = C[i-j-1]; for(k=j;k<m;k++) Hi[k] -= 2*Ci[k-j]; }
          B = numeric.getBlock(H, [0,j+1],[m-1,J]);
          C = numeric.tensor(numeric.dot(B,v),v);
          for(i=0;i<m;i++) { Hi = H[i]; Ci = C[i]; for(k=j+1;k<=J;k++) Hi[k] -= 2*Ci[k-j-1]; }
          B = Array(J-j);
          for(i=j+1;i<=J;i++) B[i-j-1] = Q[i];
          C = numeric.tensor(v,numeric.dot(v,B));
          for(i=j+1;i<=J;i++) { Qi = Q[i]; Ci = C[i-j-1]; for(k=0;k<m;k++) Qi[k] -= 2*Ci[k]; }
        }
      }
      throw new Error('numeric: eigenvalue iteration does not converge -- increase maxiter?');
    };

    numeric.eig = function eig(A,maxiter) {
      var QH = numeric.toUpperHessenberg(A);
      var QB = numeric.QRFrancis(QH.H,maxiter);
      var T = numeric.T;
      var n = A.length,i,k,flag = false,B = QB.B,H = numeric.dot(QB.Q,numeric.dot(QH.H,numeric.transpose(QB.Q)));
      var Q = new T(numeric.dot(QB.Q,QH.Q)),Q0;
      var m = B.length,j;
      var a,b,c,d,p1,p2,disc,x,y,p,q,n1,n2;
      var sqrt = Math.sqrt;
      for(k=0;k<m;k++) {
        i = B[k][0];
        if(i === B[k][1]) {
          // nothing
        } else {
          j = i+1;
          a = H[i][i];
          b = H[i][j];
          c = H[j][i];
          d = H[j][j];
          if(b === 0 && c === 0) continue;
          p1 = -a-d;
          p2 = a*d-b*c;
          disc = p1*p1-4*p2;
          if(disc>=0) {
            if(p1<0) x = -0.5*(p1-sqrt(disc));
            else     x = -0.5*(p1+sqrt(disc));
            n1 = (a-x)*(a-x)+b*b;
            n2 = c*c+(d-x)*(d-x);
            if(n1>n2) {
              n1 = sqrt(n1);
              p = (a-x)/n1;
              q = b/n1;
            } else {
              n2 = sqrt(n2);
              p = c/n2;
              q = (d-x)/n2;
            }
            Q0 = new T([[q,-p],[p,q]]);
            Q.setRows(i,j,Q0.dot(Q.getRows(i,j)));
          } else {
            x = -0.5*p1;
            y = 0.5*sqrt(-disc);
            n1 = (a-x)*(a-x)+b*b;
            n2 = c*c+(d-x)*(d-x);
            if(n1>n2) {
              n1 = sqrt(n1+y*y);
              p = (a-x)/n1;
              q = b/n1;
              x = 0;
              y /= n1;
            } else {
              n2 = sqrt(n2+y*y);
              p = c/n2;
              q = (d-x)/n2;
              x = y/n2;
              y = 0;
            }
            Q0 = new T([[q,-p],[p,q]],[[x,y],[y,-x]]);
            Q.setRows(i,j,Q0.dot(Q.getRows(i,j)));
          }
        }
      }
      var R = Q.dot(A).dot(Q.transjugate()), n = A.length, E = numeric.T.identity(n);
      for(j=0;j<n;j++) {
        if(j>0) {
          for(k=j-1;k>=0;k--) {
            var Rk = R.get([k,k]), Rj = R.get([j,j]);
            if(numeric.neq(Rk.x,Rj.x) || numeric.neq(Rk.y,Rj.y)) {
              x = R.getRow(k).getBlock([k],[j-1]);
              y = E.getRow(j).getBlock([k],[j-1]);
              E.set([j,k],(R.get([k,j]).neg().sub(x.dot(y))).div(Rk.sub(Rj)));
            } else {
              E.setRow(j,E.getRow(k));
              continue;
            }
          }
        }
      }
      for(j=0;j<n;j++) {
        x = E.getRow(j);
        E.setRow(j,x.div(x.norm2()));
      }
      E = E.transpose();
      E = Q.transjugate().dot(E);
      return { lambda:R.getDiag(), E:E };
    };

// 5. Compressed Column Storage matrices
    numeric.ccsSparse = function ccsSparse(A) {
      var m = A.length,n,foo, i,j, counts = [];
      for(i=m-1;i!==-1;--i) {
        foo = A[i];
        for(j in foo) {
          j = parseInt(j);
          while(j>=counts.length) counts[counts.length] = 0;
          if(foo[j]!==0) counts[j]++;
        }
      }
      var n = counts.length;
      var Ai = Array(n+1);
      Ai[0] = 0;
      for(i=0;i<n;++i) Ai[i+1] = Ai[i] + counts[i];
      var Aj = Array(Ai[n]), Av = Array(Ai[n]);
      for(i=m-1;i!==-1;--i) {
        foo = A[i];
        for(j in foo) {
          if(foo[j]!==0) {
            counts[j]--;
            Aj[Ai[j]+counts[j]] = i;
            Av[Ai[j]+counts[j]] = foo[j];
          }
        }
      }
      return [Ai,Aj,Av];
    };
    numeric.ccsFull = function ccsFull(A) {
      var Ai = A[0], Aj = A[1], Av = A[2], s = numeric.ccsDim(A), m = s[0], n = s[1], i,j,j0,j1,k;
      var B = numeric.rep([m,n],0);
      for(i=0;i<n;i++) {
        j0 = Ai[i];
        j1 = Ai[i+1];
        for(j=j0;j<j1;++j) { B[Aj[j]][i] = Av[j]; }
      }
      return B;
    };
    numeric.ccsTSolve = function ccsTSolve(A,b,x,bj,xj) {
      var Ai = A[0], Aj = A[1], Av = A[2],m = Ai.length-1, max = Math.max,n=0;
      if(typeof bj === "undefined") x = numeric.rep([m],0);
      if(typeof bj === "undefined") bj = numeric.linspace(0,x.length-1);
      if(typeof xj === "undefined") xj = [];
      function dfs(j) {
        var k;
        if(x[j] !== 0) return;
        x[j] = 1;
        for(k=Ai[j];k<Ai[j+1];++k) dfs(Aj[k]);
        xj[n] = j;
        ++n;
      }
      var i,j,j0,j1,k,l,l0,l1,a;
      for(i=bj.length-1;i!==-1;--i) { dfs(bj[i]); }
      xj.length = n;
      for(i=xj.length-1;i!==-1;--i) { x[xj[i]] = 0; }
      for(i=bj.length-1;i!==-1;--i) { j = bj[i]; x[j] = b[j]; }
      for(i=xj.length-1;i!==-1;--i) {
        j = xj[i];
        j0 = Ai[j];
        j1 = max(Ai[j+1],j0);
        for(k=j0;k!==j1;++k) { if(Aj[k] === j) { x[j] /= Av[k]; break; } }
        a = x[j];
        for(k=j0;k!==j1;++k) {
          l = Aj[k];
          if(l !== j) x[l] -= a*Av[k];
        }
      }
      return x;
    };
    numeric.ccsDFS = function ccsDFS(n) {
      this.k = Array(n);
      this.k1 = Array(n);
      this.j = Array(n);
    };
    numeric.ccsDFS.prototype.dfs = function dfs(J,Ai,Aj,x,xj,Pinv) {
      var m = 0,foo,n=xj.length;
      var k = this.k, k1 = this.k1, j = this.j,km,k11;
      if(x[J]!==0) return;
      x[J] = 1;
      j[0] = J;
      k[0] = km = Ai[J];
      k1[0] = k11 = Ai[J+1];
      while(1) {
        if(km >= k11) {
          xj[n] = j[m];
          if(m===0) return;
          ++n;
          --m;
          km = k[m];
          k11 = k1[m];
        } else {
          foo = Pinv[Aj[km]];
          if(x[foo] === 0) {
            x[foo] = 1;
            k[m] = km;
            ++m;
            j[m] = foo;
            km = Ai[foo];
            k1[m] = k11 = Ai[foo+1];
          } else ++km;
        }
      }
    };
    numeric.ccsLPSolve = function ccsLPSolve(A,B,x,xj,I,Pinv,dfs) {
      var Ai = A[0], Aj = A[1], Av = A[2],m = Ai.length-1, n=0;
      var Bi = B[0], Bj = B[1], Bv = B[2];

      var i,i0,i1,j,J,j0,j1,k,l,l0,l1,a;
      i0 = Bi[I];
      i1 = Bi[I+1];
      xj.length = 0;
      for(i=i0;i<i1;++i) { dfs.dfs(Pinv[Bj[i]],Ai,Aj,x,xj,Pinv); }
      for(i=xj.length-1;i!==-1;--i) { x[xj[i]] = 0; }
      for(i=i0;i!==i1;++i) { j = Pinv[Bj[i]]; x[j] = Bv[i]; }
      for(i=xj.length-1;i!==-1;--i) {
        j = xj[i];
        j0 = Ai[j];
        j1 = Ai[j+1];
        for(k=j0;k<j1;++k) { if(Pinv[Aj[k]] === j) { x[j] /= Av[k]; break; } }
        a = x[j];
        for(k=j0;k<j1;++k) {
          l = Pinv[Aj[k]];
          if(l !== j) x[l] -= a*Av[k];
        }
      }
      return x;
    };
    numeric.ccsLUP1 = function ccsLUP1(A,threshold) {
      var m = A[0].length-1;
      var L = [numeric.rep([m+1],0),[],[]], U = [numeric.rep([m+1], 0),[],[]];
      var Li = L[0], Lj = L[1], Lv = L[2], Ui = U[0], Uj = U[1], Uv = U[2];
      var x = numeric.rep([m],0), xj = numeric.rep([m],0);
      var i,j,k,j0,j1,a,e,c,d,K;
      var sol = numeric.ccsLPSolve, max = Math.max, abs = Math.abs;
      var P = numeric.linspace(0,m-1),Pinv = numeric.linspace(0,m-1);
      var dfs = new numeric.ccsDFS(m);
      if(typeof threshold === "undefined") { threshold = 1; }
      for(i=0;i<m;++i) {
        sol(L,A,x,xj,i,Pinv,dfs);
        a = -1;
        e = -1;
        for(j=xj.length-1;j!==-1;--j) {
          k = xj[j];
          if(k <= i) continue;
          c = abs(x[k]);
          if(c > a) { e = k; a = c; }
        }
        if(abs(x[i])<threshold*a) {
          j = P[i];
          a = P[e];
          P[i] = a; Pinv[a] = i;
          P[e] = j; Pinv[j] = e;
          a = x[i]; x[i] = x[e]; x[e] = a;
        }
        a = Li[i];
        e = Ui[i];
        d = x[i];
        Lj[a] = P[i];
        Lv[a] = 1;
        ++a;
        for(j=xj.length-1;j!==-1;--j) {
          k = xj[j];
          c = x[k];
          xj[j] = 0;
          x[k] = 0;
          if(k<=i) { Uj[e] = k; Uv[e] = c;   ++e; }
          else     { Lj[a] = P[k]; Lv[a] = c/d; ++a; }
        }
        Li[i+1] = a;
        Ui[i+1] = e;
      }
      for(j=Lj.length-1;j!==-1;--j) { Lj[j] = Pinv[Lj[j]]; }
      return {L:L, U:U, P:P, Pinv:Pinv};
    };
    numeric.ccsDFS0 = function ccsDFS0(n) {
      this.k = Array(n);
      this.k1 = Array(n);
      this.j = Array(n);
    };
    numeric.ccsDFS0.prototype.dfs = function dfs(J,Ai,Aj,x,xj,Pinv,P) {
      var m = 0,foo,n=xj.length;
      var k = this.k, k1 = this.k1, j = this.j,km,k11;
      if(x[J]!==0) return;
      x[J] = 1;
      j[0] = J;
      k[0] = km = Ai[Pinv[J]];
      k1[0] = k11 = Ai[Pinv[J]+1];
      while(1) {
        if(isNaN(km)) throw new Error("Ow!");
        if(km >= k11) {
          xj[n] = Pinv[j[m]];
          if(m===0) return;
          ++n;
          --m;
          km = k[m];
          k11 = k1[m];
        } else {
          foo = Aj[km];
          if(x[foo] === 0) {
            x[foo] = 1;
            k[m] = km;
            ++m;
            j[m] = foo;
            foo = Pinv[foo];
            km = Ai[foo];
            k1[m] = k11 = Ai[foo+1];
          } else ++km;
        }
      }
    };
    numeric.ccsLPSolve0 = function ccsLPSolve0(A,B,y,xj,I,Pinv,P,dfs) {
      var Ai = A[0], Aj = A[1], Av = A[2],m = Ai.length-1, n=0;
      var Bi = B[0], Bj = B[1], Bv = B[2];

      var i,i0,i1,j,J,j0,j1,k,l,l0,l1,a;
      i0 = Bi[I];
      i1 = Bi[I+1];
      xj.length = 0;
      for(i=i0;i<i1;++i) { dfs.dfs(Bj[i],Ai,Aj,y,xj,Pinv,P); }
      for(i=xj.length-1;i!==-1;--i) { j = xj[i]; y[P[j]] = 0; }
      for(i=i0;i!==i1;++i) { j = Bj[i]; y[j] = Bv[i]; }
      for(i=xj.length-1;i!==-1;--i) {
        j = xj[i];
        l = P[j];
        j0 = Ai[j];
        j1 = Ai[j+1];
        for(k=j0;k<j1;++k) { if(Aj[k] === l) { y[l] /= Av[k]; break; } }
        a = y[l];
        for(k=j0;k<j1;++k) y[Aj[k]] -= a*Av[k];
        y[l] = a;
      }
    };
    numeric.ccsLUP0 = function ccsLUP0(A,threshold) {
      var m = A[0].length-1;
      var L = [numeric.rep([m+1],0),[],[]], U = [numeric.rep([m+1], 0),[],[]];
      var Li = L[0], Lj = L[1], Lv = L[2], Ui = U[0], Uj = U[1], Uv = U[2];
      var y = numeric.rep([m],0), xj = numeric.rep([m],0);
      var i,j,k,j0,j1,a,e,c,d,K;
      var sol = numeric.ccsLPSolve0, max = Math.max, abs = Math.abs;
      var P = numeric.linspace(0,m-1),Pinv = numeric.linspace(0,m-1);
      var dfs = new numeric.ccsDFS0(m);
      if(typeof threshold === "undefined") { threshold = 1; }
      for(i=0;i<m;++i) {
        sol(L,A,y,xj,i,Pinv,P,dfs);
        a = -1;
        e = -1;
        for(j=xj.length-1;j!==-1;--j) {
          k = xj[j];
          if(k <= i) continue;
          c = abs(y[P[k]]);
          if(c > a) { e = k; a = c; }
        }
        if(abs(y[P[i]])<threshold*a) {
          j = P[i];
          a = P[e];
          P[i] = a; Pinv[a] = i;
          P[e] = j; Pinv[j] = e;
        }
        a = Li[i];
        e = Ui[i];
        d = y[P[i]];
        Lj[a] = P[i];
        Lv[a] = 1;
        ++a;
        for(j=xj.length-1;j!==-1;--j) {
          k = xj[j];
          c = y[P[k]];
          xj[j] = 0;
          y[P[k]] = 0;
          if(k<=i) { Uj[e] = k; Uv[e] = c;   ++e; }
          else     { Lj[a] = P[k]; Lv[a] = c/d; ++a; }
        }
        Li[i+1] = a;
        Ui[i+1] = e;
      }
      for(j=Lj.length-1;j!==-1;--j) { Lj[j] = Pinv[Lj[j]]; }
      return {L:L, U:U, P:P, Pinv:Pinv};
    };
    numeric.ccsLUP = numeric.ccsLUP0;

    numeric.ccsDim = function ccsDim(A) { return [numeric.sup(A[1])+1,A[0].length-1]; };
    numeric.ccsGetBlock = function ccsGetBlock(A,i,j) {
      var s = numeric.ccsDim(A),m=s[0],n=s[1];
      if(typeof i === "undefined") { i = numeric.linspace(0,m-1); }
      else if(typeof i === "number") { i = [i]; }
      if(typeof j === "undefined") { j = numeric.linspace(0,n-1); }
      else if(typeof j === "number") { j = [j]; }
      var p,p0,p1,P = i.length,q,Q = j.length,r,jq,ip;
      var Bi = numeric.rep([n],0), Bj=[], Bv=[], B = [Bi,Bj,Bv];
      var Ai = A[0], Aj = A[1], Av = A[2];
      var x = numeric.rep([m],0),count=0,flags = numeric.rep([m],0);
      for(q=0;q<Q;++q) {
        jq = j[q];
        var q0 = Ai[jq];
        var q1 = Ai[jq+1];
        for(p=q0;p<q1;++p) {
          r = Aj[p];
          flags[r] = 1;
          x[r] = Av[p];
        }
        for(p=0;p<P;++p) {
          ip = i[p];
          if(flags[ip]) {
            Bj[count] = p;
            Bv[count] = x[i[p]];
            ++count;
          }
        }
        for(p=q0;p<q1;++p) {
          r = Aj[p];
          flags[r] = 0;
        }
        Bi[q+1] = count;
      }
      return B;
    };

    numeric.ccsDot = function ccsDot(A,B) {
      var Ai = A[0], Aj = A[1], Av = A[2];
      var Bi = B[0], Bj = B[1], Bv = B[2];
      var sA = numeric.ccsDim(A), sB = numeric.ccsDim(B);
      var m = sA[0], n = sA[1], o = sB[1];
      var x = numeric.rep([m],0), flags = numeric.rep([m],0), xj = Array(m);
      var Ci = numeric.rep([o],0), Cj = [], Cv = [], C = [Ci,Cj,Cv];
      var i,j,k,j0,j1,i0,i1,l,p,a,b;
      for(k=0;k!==o;++k) {
        j0 = Bi[k];
        j1 = Bi[k+1];
        p = 0;
        for(j=j0;j<j1;++j) {
          a = Bj[j];
          b = Bv[j];
          i0 = Ai[a];
          i1 = Ai[a+1];
          for(i=i0;i<i1;++i) {
            l = Aj[i];
            if(flags[l]===0) {
              xj[p] = l;
              flags[l] = 1;
              p = p+1;
            }
            x[l] = x[l] + Av[i]*b;
          }
        }
        j0 = Ci[k];
        j1 = j0+p;
        Ci[k+1] = j1;
        for(j=p-1;j!==-1;--j) {
          b = j0+j;
          i = xj[j];
          Cj[b] = i;
          Cv[b] = x[i];
          flags[i] = 0;
          x[i] = 0;
        }
        Ci[k+1] = Ci[k]+p;
      }
      return C;
    };

    numeric.ccsLUPSolve = function ccsLUPSolve(LUP,B) {
      var L = LUP.L, U = LUP.U, P = LUP.P;
      var Bi = B[0];
      var flag = false;
      if(typeof Bi !== "object") { B = [[0,B.length],numeric.linspace(0,B.length-1),B]; Bi = B[0]; flag = true; }
      var Bj = B[1], Bv = B[2];
      var n = L[0].length-1, m = Bi.length-1;
      var x = numeric.rep([n],0), xj = Array(n);
      var b = numeric.rep([n],0), bj = Array(n);
      var Xi = numeric.rep([m+1],0), Xj = [], Xv = [];
      var sol = numeric.ccsTSolve;
      var i,j,j0,j1,k,J,N=0;
      for(i=0;i<m;++i) {
        k = 0;
        j0 = Bi[i];
        j1 = Bi[i+1];
        for(j=j0;j<j1;++j) {
          J = LUP.Pinv[Bj[j]];
          bj[k] = J;
          b[J] = Bv[j];
          ++k;
        }
        bj.length = k;
        sol(L,b,x,bj,xj);
        for(j=bj.length-1;j!==-1;--j) b[bj[j]] = 0;
        sol(U,x,b,xj,bj);
        if(flag) return b;
        for(j=xj.length-1;j!==-1;--j) x[xj[j]] = 0;
        for(j=bj.length-1;j!==-1;--j) {
          J = bj[j];
          Xj[N] = J;
          Xv[N] = b[J];
          b[J] = 0;
          ++N;
        }
        Xi[i+1] = N;
      }
      return [Xi,Xj,Xv];
    };

    numeric.ccsbinop = function ccsbinop(body,setup) {
      if(typeof setup === "undefined") setup='';
      return Function('X','Y',
        'var Xi = X[0], Xj = X[1], Xv = X[2];\n'+
        'var Yi = Y[0], Yj = Y[1], Yv = Y[2];\n'+
        'var n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;\n'+
        'var Zi = numeric.rep([n+1],0), Zj = [], Zv = [];\n'+
        'var x = numeric.rep([m],0),y = numeric.rep([m],0);\n'+
        'var xk,yk,zk;\n'+
        'var i,j,j0,j1,k,p=0;\n'+
        setup+
        'for(i=0;i<n;++i) {\n'+
        '  j0 = Xi[i]; j1 = Xi[i+1];\n'+
        '  for(j=j0;j!==j1;++j) {\n'+
        '    k = Xj[j];\n'+
        '    x[k] = 1;\n'+
        '    Zj[p] = k;\n'+
        '    ++p;\n'+
        '  }\n'+
        '  j0 = Yi[i]; j1 = Yi[i+1];\n'+
        '  for(j=j0;j!==j1;++j) {\n'+
        '    k = Yj[j];\n'+
        '    y[k] = Yv[j];\n'+
        '    if(x[k] === 0) {\n'+
        '      Zj[p] = k;\n'+
        '      ++p;\n'+
        '    }\n'+
        '  }\n'+
        '  Zi[i+1] = p;\n'+
        '  j0 = Xi[i]; j1 = Xi[i+1];\n'+
        '  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];\n'+
        '  j0 = Zi[i]; j1 = Zi[i+1];\n'+
        '  for(j=j0;j!==j1;++j) {\n'+
        '    k = Zj[j];\n'+
        '    xk = x[k];\n'+
        '    yk = y[k];\n'+
        body+'\n'+
        '    Zv[j] = zk;\n'+
        '  }\n'+
        '  j0 = Xi[i]; j1 = Xi[i+1];\n'+
        '  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;\n'+
        '  j0 = Yi[i]; j1 = Yi[i+1];\n'+
        '  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;\n'+
        '}\n'+
        'return [Zi,Zj,Zv];'
      );
    };

    (function() {
      var k,A,B,C;
      for(k in numeric.ops2) {
        if(isFinite(eval('1'+numeric.ops2[k]+'0'))) A = '[Y[0],Y[1],numeric.'+k+'(X,Y[2])]';
        else A = 'NaN';
        if(isFinite(eval('0'+numeric.ops2[k]+'1'))) B = '[X[0],X[1],numeric.'+k+'(X[2],Y)]';
        else B = 'NaN';
        if(isFinite(eval('1'+numeric.ops2[k]+'0')) && isFinite(eval('0'+numeric.ops2[k]+'1'))) C = 'numeric.ccs'+k+'MM(X,Y)';
        else C = 'NaN';
        numeric['ccs'+k+'MM'] = numeric.ccsbinop('zk = xk '+numeric.ops2[k]+'yk;');
        numeric['ccs'+k] = Function('X','Y',
          'if(typeof X === "number") return '+A+';\n'+
          'if(typeof Y === "number") return '+B+';\n'+
          'return '+C+';\n'
        );
      }
    }());

    numeric.ccsScatter = function ccsScatter(A) {
      var Ai = A[0], Aj = A[1], Av = A[2];
      var n = numeric.sup(Aj)+1,m=Ai.length;
      var Ri = numeric.rep([n],0),Rj=Array(m), Rv = Array(m);
      var counts = numeric.rep([n],0),i;
      for(i=0;i<m;++i) counts[Aj[i]]++;
      for(i=0;i<n;++i) Ri[i+1] = Ri[i] + counts[i];
      var ptr = Ri.slice(0),k,Aii;
      for(i=0;i<m;++i) {
        Aii = Aj[i];
        k = ptr[Aii];
        Rj[k] = Ai[i];
        Rv[k] = Av[i];
        ptr[Aii]=ptr[Aii]+1;
      }
      return [Ri,Rj,Rv];
    };

    numeric.ccsGather = function ccsGather(A) {
      var Ai = A[0], Aj = A[1], Av = A[2];
      var n = Ai.length-1,m = Aj.length;
      var Ri = Array(m), Rj = Array(m), Rv = Array(m);
      var i,j,j0,j1,p;
      p=0;
      for(i=0;i<n;++i) {
        j0 = Ai[i];
        j1 = Ai[i+1];
        for(j=j0;j!==j1;++j) {
          Rj[p] = i;
          Ri[p] = Aj[j];
          Rv[p] = Av[j];
          ++p;
        }
      }
      return [Ri,Rj,Rv];
    };

// The following sparse linear algebra routines are deprecated.

    numeric.sdim = function dim(A,ret,k) {
      if(typeof ret === "undefined") { ret = []; }
      if(typeof A !== "object") return ret;
      if(typeof k === "undefined") { k=0; }
      if(!(k in ret)) { ret[k] = 0; }
      if(A.length > ret[k]) ret[k] = A.length;
      var i;
      for(i in A) {
        if(A.hasOwnProperty(i)) dim(A[i],ret,k+1);
      }
      return ret;
    };

    numeric.sclone = function clone(A,k,n) {
      if(typeof k === "undefined") { k=0; }
      if(typeof n === "undefined") { n = numeric.sdim(A).length; }
      var i,ret = Array(A.length);
      if(k === n-1) {
        for(i in A) { if(A.hasOwnProperty(i)) ret[i] = A[i]; }
        return ret;
      }
      for(i in A) {
        if(A.hasOwnProperty(i)) ret[i] = clone(A[i],k+1,n);
      }
      return ret;
    };

    numeric.sdiag = function diag(d) {
      var n = d.length,i,ret = Array(n),i1,i2,i3;
      for(i=n-1;i>=1;i-=2) {
        i1 = i-1;
        ret[i] = []; ret[i][i] = d[i];
        ret[i1] = []; ret[i1][i1] = d[i1];
      }
      if(i===0) { ret[0] = []; ret[0][0] = d[i]; }
      return ret;
    };

    numeric.sidentity = function identity(n) { return numeric.sdiag(numeric.rep([n],1)); };

    numeric.stranspose = function transpose(A) {
      var ret = [], n = A.length, i,j,Ai;
      for(i in A) {
        if(!(A.hasOwnProperty(i))) continue;
        Ai = A[i];
        for(j in Ai) {
          if(!(Ai.hasOwnProperty(j))) continue;
          if(typeof ret[j] !== "object") { ret[j] = []; }
          ret[j][i] = Ai[j];
        }
      }
      return ret;
    };

    numeric.sLUP = function LUP(A,tol) {
      throw new Error("The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.");
    };

    numeric.sdotMM = function dotMM(A,B) {
      var p = A.length, q = B.length, BT = numeric.stranspose(B), r = BT.length, Ai, BTk;
      var i,j,k,accum;
      var ret = Array(p),reti;
      for(i=p-1;i>=0;i--) {
        reti = [];
        Ai = A[i];
        for(k=r-1;k>=0;k--) {
          accum = 0;
          BTk = BT[k];
          for(j in Ai) {
            if(!(Ai.hasOwnProperty(j))) continue;
            if(j in BTk) { accum += Ai[j]*BTk[j]; }
          }
          if(accum) reti[k] = accum;
        }
        ret[i] = reti;
      }
      return ret;
    };

    numeric.sdotMV = function dotMV(A,x) {
      var p = A.length, Ai, i,j;
      var ret = Array(p), accum;
      for(i=p-1;i>=0;i--) {
        Ai = A[i];
        accum = 0;
        for(j in Ai) {
          if(!(Ai.hasOwnProperty(j))) continue;
          if(x[j]) accum += Ai[j]*x[j];
        }
        if(accum) ret[i] = accum;
      }
      return ret;
    };

    numeric.sdotVM = function dotMV(x,A) {
      var i,j,Ai,alpha;
      var ret = [], accum;
      for(i in x) {
        if(!x.hasOwnProperty(i)) continue;
        Ai = A[i];
        alpha = x[i];
        for(j in Ai) {
          if(!Ai.hasOwnProperty(j)) continue;
          if(!ret[j]) { ret[j] = 0; }
          ret[j] += alpha*Ai[j];
        }
      }
      return ret;
    };

    numeric.sdotVV = function dotVV(x,y) {
      var i,ret=0;
      for(i in x) { if(x[i] && y[i]) ret+= x[i]*y[i]; }
      return ret;
    };

    numeric.sdot = function dot(A,B) {
      var m = numeric.sdim(A).length, n = numeric.sdim(B).length;
      var k = m*1000+n;
      switch(k) {
        case 0: return A*B;
        case 1001: return numeric.sdotVV(A,B);
        case 2001: return numeric.sdotMV(A,B);
        case 1002: return numeric.sdotVM(A,B);
        case 2002: return numeric.sdotMM(A,B);
        default: throw new Error('numeric.sdot not implemented for tensors of order '+m+' and '+n);
      }
    };

    numeric.sscatter = function scatter(V) {
      var n = V[0].length, Vij, i, j, m = V.length, A = [], Aj;
      for(i=n-1;i>=0;--i) {
        if(!V[m-1][i]) continue;
        Aj = A;
        for(j=0;j<m-2;j++) {
          Vij = V[j][i];
          if(!Aj[Vij]) Aj[Vij] = [];
          Aj = Aj[Vij];
        }
        Aj[V[j][i]] = V[j+1][i];
      }
      return A;
    };

    numeric.sgather = function gather(A,ret,k) {
      if(typeof ret === "undefined") ret = [];
      if(typeof k === "undefined") k = [];
      var n,i,Ai;
      n = k.length;
      for(i in A) {
        if(A.hasOwnProperty(i)) {
          k[n] = parseInt(i);
          Ai = A[i];
          if(typeof Ai === "number") {
            if(Ai) {
              if(ret.length === 0) {
                for(i=n+1;i>=0;--i) ret[i] = [];
              }
              for(i=n;i>=0;--i) ret[i].push(k[i]);
              ret[n+1].push(Ai);
            }
          } else gather(Ai,ret,k);
        }
      }
      if(k.length>n) k.pop();
      return ret;
    };

// 6. Coordinate matrices
    numeric.cLU = function LU(A) {
      var I = A[0], J = A[1], V = A[2];
      var p = I.length, m=0, i,j,k,a,b,c;
      for(i=0;i<p;i++) if(I[i]>m) m=I[i];
      m++;
      var L = Array(m), U = Array(m), left = numeric.rep([m],Infinity), right = numeric.rep([m],-Infinity);
      var Ui, Uj,alpha;
      for(k=0;k<p;k++) {
        i = I[k];
        j = J[k];
        if(j<left[i]) left[i] = j;
        if(j>right[i]) right[i] = j;
      }
      for(i=0;i<m-1;i++) { if(right[i] > right[i+1]) right[i+1] = right[i]; }
      for(i=m-1;i>=1;i--) { if(left[i]<left[i-1]) left[i-1] = left[i]; }
      var countL = 0, countU = 0;
      for(i=0;i<m;i++) {
        U[i] = numeric.rep([right[i]-left[i]+1],0);
        L[i] = numeric.rep([i-left[i]],0);
        countL += i-left[i]+1;
        countU += right[i]-i+1;
      }
      for(k=0;k<p;k++) { i = I[k]; U[i][J[k]-left[i]] = V[k]; }
      for(i=0;i<m-1;i++) {
        a = i-left[i];
        Ui = U[i];
        for(j=i+1;left[j]<=i && j<m;j++) {
          b = i-left[j];
          c = right[i]-i;
          Uj = U[j];
          alpha = Uj[b]/Ui[a];
          if(alpha) {
            for(k=1;k<=c;k++) { Uj[k+b] -= alpha*Ui[k+a]; }
            L[j][i-left[j]] = alpha;
          }
        }
      }
      var Ui = [], Uj = [], Uv = [], Li = [], Lj = [], Lv = [];
      var p,q,foo;
      p=0; q=0;
      for(i=0;i<m;i++) {
        a = left[i];
        b = right[i];
        foo = U[i];
        for(j=i;j<=b;j++) {
          if(foo[j-a]) {
            Ui[p] = i;
            Uj[p] = j;
            Uv[p] = foo[j-a];
            p++;
          }
        }
        foo = L[i];
        for(j=a;j<i;j++) {
          if(foo[j-a]) {
            Li[q] = i;
            Lj[q] = j;
            Lv[q] = foo[j-a];
            q++;
          }
        }
        Li[q] = i;
        Lj[q] = i;
        Lv[q] = 1;
        q++;
      }
      return {U:[Ui,Uj,Uv], L:[Li,Lj,Lv]};
    };

    numeric.cLUsolve = function LUsolve(lu,b) {
      var L = lu.L, U = lu.U, ret = numeric.clone(b);
      var Li = L[0], Lj = L[1], Lv = L[2];
      var Ui = U[0], Uj = U[1], Uv = U[2];
      var p = Ui.length, q = Li.length;
      var m = ret.length,i,j,k;
      k = 0;
      for(i=0;i<m;i++) {
        while(Lj[k] < i) {
          ret[i] -= Lv[k]*ret[Lj[k]];
          k++;
        }
        k++;
      }
      k = p-1;
      for(i=m-1;i>=0;i--) {
        while(Uj[k] > i) {
          ret[i] -= Uv[k]*ret[Uj[k]];
          k--;
        }
        ret[i] /= Uv[k];
        k--;
      }
      return ret;
    };

    numeric.cgrid = function grid(n,shape) {
      if(typeof n === "number") n = [n,n];
      var ret = numeric.rep(n,-1);
      var i,j,count;
      if(typeof shape !== "function") {
        switch(shape) {
          case 'L':
            shape = function(i,j) { return (i>=n[0]/2 || j<n[1]/2); };
            break;
          default:
            shape = function(i,j) { return true; };
            break;
        }
      }
      count=0;
      for(i=1;i<n[0]-1;i++) for(j=1;j<n[1]-1;j++)
        if(shape(i,j)) {
          ret[i][j] = count;
          count++;
        }
      return ret;
    };

    numeric.cdelsq = function delsq(g) {
      var dir = [[-1,0],[0,-1],[0,1],[1,0]];
      var s = numeric.dim(g), m = s[0], n = s[1], i,j,k,p,q;
      var Li = [], Lj = [], Lv = [];
      for(i=1;i<m-1;i++) for(j=1;j<n-1;j++) {
        if(g[i][j]<0) continue;
        for(k=0;k<4;k++) {
          p = i+dir[k][0];
          q = j+dir[k][1];
          if(g[p][q]<0) continue;
          Li.push(g[i][j]);
          Lj.push(g[p][q]);
          Lv.push(-1);
        }
        Li.push(g[i][j]);
        Lj.push(g[i][j]);
        Lv.push(4);
      }
      return [Li,Lj,Lv];
    };

    numeric.cdotMV = function dotMV(A,x) {
      var ret, Ai = A[0], Aj = A[1], Av = A[2],k,p=Ai.length,N;
      N=0;
      for(k=0;k<p;k++) { if(Ai[k]>N) N = Ai[k]; }
      N++;
      ret = numeric.rep([N],0);
      for(k=0;k<p;k++) { ret[Ai[k]]+=Av[k]*x[Aj[k]]; }
      return ret;
    };

// 7. Splines

    numeric.Spline = function Spline(x,yl,yr,kl,kr) { this.x = x; this.yl = yl; this.yr = yr; this.kl = kl; this.kr = kr; };
    numeric.Spline.prototype._at = function _at(x1,p) {
      var x = this.x;
      var yl = this.yl;
      var yr = this.yr;
      var kl = this.kl;
      var kr = this.kr;
      var x1,a,b,t;
      var add = numeric.add, sub = numeric.sub, mul = numeric.mul;
      a = sub(mul(kl[p],x[p+1]-x[p]),sub(yr[p+1],yl[p]));
      b = add(mul(kr[p+1],x[p]-x[p+1]),sub(yr[p+1],yl[p]));
      t = (x1-x[p])/(x[p+1]-x[p]);
      var s = t*(1-t);
      return add(add(add(mul(1-t,yl[p]),mul(t,yr[p+1])),mul(a,s*(1-t))),mul(b,s*t));
    };
    numeric.Spline.prototype.at = function at(x0) {
      if(typeof x0 === "number") {
        var x = this.x;
        var n = x.length;
        var p,q,mid,floor = Math.floor,a,b,t;
        p = 0;
        q = n-1;
        while(q-p>1) {
          mid = floor((p+q)/2);
          if(x[mid] <= x0) p = mid;
          else q = mid;
        }
        return this._at(x0,p);
      }
      var n = x0.length, i, ret = Array(n);
      for(i=n-1;i!==-1;--i) ret[i] = this.at(x0[i]);
      return ret;
    };
    numeric.Spline.prototype.diff = function diff() {
      var x = this.x;
      var yl = this.yl;
      var yr = this.yr;
      var kl = this.kl;
      var kr = this.kr;
      var n = yl.length;
      var i,dx,dy;
      var zl = kl, zr = kr, pl = Array(n), pr = Array(n);
      var add = numeric.add, mul = numeric.mul, div = numeric.div, sub = numeric.sub;
      for(i=n-1;i!==-1;--i) {
        dx = x[i+1]-x[i];
        dy = sub(yr[i+1],yl[i]);
        pl[i] = div(add(mul(dy, 6),mul(kl[i],-4*dx),mul(kr[i+1],-2*dx)),dx*dx);
        pr[i+1] = div(add(mul(dy,-6),mul(kl[i], 2*dx),mul(kr[i+1], 4*dx)),dx*dx);
      }
      return new numeric.Spline(x,zl,zr,pl,pr);
    };
    numeric.Spline.prototype.roots = function roots() {
      function sqr(x) { return x*x; }
      var ret = [];
      var x = this.x, yl = this.yl, yr = this.yr, kl = this.kl, kr = this.kr;
      if(typeof yl[0] === "number") {
        yl = [yl];
        yr = [yr];
        kl = [kl];
        kr = [kr];
      }
      var m = yl.length,n=x.length-1,i,j,k,y,s,t;
      var ai,bi,ci,di, ret = Array(m),ri,k0,k1,y0,y1,A,B,D,dx,cx,stops,z0,z1,zm,t0,t1,tm;
      var sqrt = Math.sqrt;
      for(i=0;i!==m;++i) {
        ai = yl[i];
        bi = yr[i];
        ci = kl[i];
        di = kr[i];
        ri = [];
        for(j=0;j!==n;j++) {
          if(j>0 && bi[j]*ai[j]<0) ri.push(x[j]);
          dx = (x[j+1]-x[j]);
          cx = x[j];
          y0 = ai[j];
          y1 = bi[j+1];
          k0 = ci[j]/dx;
          k1 = di[j+1]/dx;
          D = sqr(k0-k1+3*(y0-y1)) + 12*k1*y0;
          A = k1+3*y0+2*k0-3*y1;
          B = 3*(k1+k0+2*(y0-y1));
          if(D<=0) {
            z0 = A/B;
            if(z0>x[j] && z0<x[j+1]) stops = [x[j],z0,x[j+1]];
            else stops = [x[j],x[j+1]];
          } else {
            z0 = (A-sqrt(D))/B;
            z1 = (A+sqrt(D))/B;
            stops = [x[j]];
            if(z0>x[j] && z0<x[j+1]) stops.push(z0);
            if(z1>x[j] && z1<x[j+1]) stops.push(z1);
            stops.push(x[j+1]);
          }
          t0 = stops[0];
          z0 = this._at(t0,j);
          for(k=0;k<stops.length-1;k++) {
            t1 = stops[k+1];
            z1 = this._at(t1,j);
            if(z0 === 0) {
              ri.push(t0);
              t0 = t1;
              z0 = z1;
              continue;
            }
            if(z1 === 0 || z0*z1>0) {
              t0 = t1;
              z0 = z1;
              continue;
            }
            var side = 0;
            while(1) {
              tm = (z0*t1-z1*t0)/(z0-z1);
              if(tm <= t0 || tm >= t1) { break; }
              zm = this._at(tm,j);
              if(zm*z1>0) {
                t1 = tm;
                z1 = zm;
                if(side === -1) z0*=0.5;
                side = -1;
              } else if(zm*z0>0) {
                t0 = tm;
                z0 = zm;
                if(side === 1) z1*=0.5;
                side = 1;
              } else break;
            }
            ri.push(tm);
            t0 = stops[k+1];
            z0 = this._at(t0, j);
          }
          if(z1 === 0) ri.push(t1);
        }
        ret[i] = ri;
      }
      if(typeof this.yl[0] === "number") return ret[0];
      return ret;
    };
    numeric.spline = function spline(x,y,k1,kn) {
      var n = x.length, b = [], dx = [], dy = [];
      var i;
      var sub = numeric.sub,mul = numeric.mul,add = numeric.add;
      for(i=n-2;i>=0;i--) { dx[i] = x[i+1]-x[i]; dy[i] = sub(y[i+1],y[i]); }
      if(typeof k1 === "string" || typeof kn === "string") {
        k1 = kn = "periodic";
      }
      // Build sparse tridiagonal system
      var T = [[],[],[]];
      switch(typeof k1) {
        case "undefined":
          b[0] = mul(3/(dx[0]*dx[0]),dy[0]);
          T[0].push(0,0);
          T[1].push(0,1);
          T[2].push(2/dx[0],1/dx[0]);
          break;
        case "string":
          b[0] = add(mul(3/(dx[n-2]*dx[n-2]),dy[n-2]),mul(3/(dx[0]*dx[0]),dy[0]));
          T[0].push(0,0,0);
          T[1].push(n-2,0,1);
          T[2].push(1/dx[n-2],2/dx[n-2]+2/dx[0],1/dx[0]);
          break;
        default:
          b[0] = k1;
          T[0].push(0);
          T[1].push(0);
          T[2].push(1);
          break;
      }
      for(i=1;i<n-1;i++) {
        b[i] = add(mul(3/(dx[i-1]*dx[i-1]),dy[i-1]),mul(3/(dx[i]*dx[i]),dy[i]));
        T[0].push(i,i,i);
        T[1].push(i-1,i,i+1);
        T[2].push(1/dx[i-1],2/dx[i-1]+2/dx[i],1/dx[i]);
      }
      switch(typeof kn) {
        case "undefined":
          b[n-1] = mul(3/(dx[n-2]*dx[n-2]),dy[n-2]);
          T[0].push(n-1,n-1);
          T[1].push(n-2,n-1);
          T[2].push(1/dx[n-2],2/dx[n-2]);
          break;
        case "string":
          T[1][T[1].length-1] = 0;
          break;
        default:
          b[n-1] = kn;
          T[0].push(n-1);
          T[1].push(n-1);
          T[2].push(1);
          break;
      }
      if(typeof b[0] !== "number") b = numeric.transpose(b);
      else b = [b];
      var k = Array(b.length);
      if(typeof k1 === "string") {
        for(i=k.length-1;i!==-1;--i) {
          k[i] = numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(T)),b[i]);
          k[i][n-1] = k[i][0];
        }
      } else {
        for(i=k.length-1;i!==-1;--i) {
          k[i] = numeric.cLUsolve(numeric.cLU(T),b[i]);
        }
      }
      if(typeof y[0] === "number") k = k[0];
      else k = numeric.transpose(k);
      return new numeric.Spline(x,y,y,k,k);
    };

// 8. FFT
    numeric.fftpow2 = function fftpow2(x,y) {
      var n = x.length;
      if(n === 1) return;
      var cos = Math.cos, sin = Math.sin, i,j;
      var xe = Array(n/2), ye = Array(n/2), xo = Array(n/2), yo = Array(n/2);
      j = n/2;
      for(i=n-1;i!==-1;--i) {
        --j;
        xo[j] = x[i];
        yo[j] = y[i];
        --i;
        xe[j] = x[i];
        ye[j] = y[i];
      }
      fftpow2(xe,ye);
      fftpow2(xo,yo);
      j = n/2;
      var t,k = (-6.2831853071795864769252867665590057683943387987502116419/n),ci,si;
      for(i=n-1;i!==-1;--i) {
        --j;
        if(j === -1) j = n/2-1;
        t = k*i;
        ci = cos(t);
        si = sin(t);
        x[i] = xe[j] + ci*xo[j] - si*yo[j];
        y[i] = ye[j] + ci*yo[j] + si*xo[j];
      }
    };
    numeric._ifftpow2 = function _ifftpow2(x,y) {
      var n = x.length;
      if(n === 1) return;
      var cos = Math.cos, sin = Math.sin, i,j;
      var xe = Array(n/2), ye = Array(n/2), xo = Array(n/2), yo = Array(n/2);
      j = n/2;
      for(i=n-1;i!==-1;--i) {
        --j;
        xo[j] = x[i];
        yo[j] = y[i];
        --i;
        xe[j] = x[i];
        ye[j] = y[i];
      }
      _ifftpow2(xe,ye);
      _ifftpow2(xo,yo);
      j = n/2;
      var t,k = (6.2831853071795864769252867665590057683943387987502116419/n),ci,si;
      for(i=n-1;i!==-1;--i) {
        --j;
        if(j === -1) j = n/2-1;
        t = k*i;
        ci = cos(t);
        si = sin(t);
        x[i] = xe[j] + ci*xo[j] - si*yo[j];
        y[i] = ye[j] + ci*yo[j] + si*xo[j];
      }
    };
    numeric.ifftpow2 = function ifftpow2(x,y) {
      numeric._ifftpow2(x,y);
      numeric.diveq(x,x.length);
      numeric.diveq(y,y.length);
    };
    numeric.convpow2 = function convpow2(ax,ay,bx,by) {
      numeric.fftpow2(ax,ay);
      numeric.fftpow2(bx,by);
      var i,n = ax.length,axi,bxi,ayi,byi;
      for(i=n-1;i!==-1;--i) {
        axi = ax[i]; ayi = ay[i]; bxi = bx[i]; byi = by[i];
        ax[i] = axi*bxi-ayi*byi;
        ay[i] = axi*byi+ayi*bxi;
      }
      numeric.ifftpow2(ax,ay);
    };
    numeric.T.prototype.fft = function fft() {
      var x = this.x, y = this.y;
      var n = x.length, log = Math.log, log2 = log(2),
        p = Math.ceil(log(2*n-1)/log2), m = Math.pow(2,p);
      var cx = numeric.rep([m],0), cy = numeric.rep([m],0), cos = Math.cos, sin = Math.sin;
      var k, c = (-3.141592653589793238462643383279502884197169399375105820/n),t;
      var a = numeric.rep([m],0), b = numeric.rep([m],0),nhalf = Math.floor(n/2);
      for(k=0;k<n;k++) a[k] = x[k];
      if(typeof y !== "undefined") for(k=0;k<n;k++) b[k] = y[k];
      cx[0] = 1;
      for(k=1;k<=m/2;k++) {
        t = c*k*k;
        cx[k] = cos(t);
        cy[k] = sin(t);
        cx[m-k] = cos(t);
        cy[m-k] = sin(t);
      }
      var X = new numeric.T(a,b), Y = new numeric.T(cx,cy);
      X = X.mul(Y);
      numeric.convpow2(X.x,X.y,numeric.clone(Y.x),numeric.neg(Y.y));
      X = X.mul(Y);
      X.x.length = n;
      X.y.length = n;
      return X;
    };
    numeric.T.prototype.ifft = function ifft() {
      var x = this.x, y = this.y;
      var n = x.length, log = Math.log, log2 = log(2),
        p = Math.ceil(log(2*n-1)/log2), m = Math.pow(2,p);
      var cx = numeric.rep([m],0), cy = numeric.rep([m],0), cos = Math.cos, sin = Math.sin;
      var k, c = (3.141592653589793238462643383279502884197169399375105820/n),t;
      var a = numeric.rep([m],0), b = numeric.rep([m],0),nhalf = Math.floor(n/2);
      for(k=0;k<n;k++) a[k] = x[k];
      if(typeof y !== "undefined") for(k=0;k<n;k++) b[k] = y[k];
      cx[0] = 1;
      for(k=1;k<=m/2;k++) {
        t = c*k*k;
        cx[k] = cos(t);
        cy[k] = sin(t);
        cx[m-k] = cos(t);
        cy[m-k] = sin(t);
      }
      var X = new numeric.T(a,b), Y = new numeric.T(cx,cy);
      X = X.mul(Y);
      numeric.convpow2(X.x,X.y,numeric.clone(Y.x),numeric.neg(Y.y));
      X = X.mul(Y);
      X.x.length = n;
      X.y.length = n;
      return X.div(n);
    };

//9. Unconstrained optimization
    numeric.gradient = function gradient(f,x) {
      var n = x.length;
      var f0 = f(x);
      if(isNaN(f0)) throw new Error('gradient: f(x) is a NaN!');
      var max = Math.max;
      var i,x0 = numeric.clone(x),f1,f2, J = Array(n);
      var div = numeric.div, sub = numeric.sub,errest,roundoff,max = Math.max,eps = 1e-3,abs = Math.abs, min = Math.min;
      var t0,t1,t2,it=0,d1,d2,N;
      for(i=0;i<n;i++) {
        var h = max(1e-6*f0,1e-8);
        while(1) {
          ++it;
          if(it>20) { throw new Error("Numerical gradient fails"); }
          x0[i] = x[i]+h;
          f1 = f(x0);
          x0[i] = x[i]-h;
          f2 = f(x0);
          x0[i] = x[i];
          if(isNaN(f1) || isNaN(f2)) { h/=16; continue; }
          J[i] = (f1-f2)/(2*h);
          t0 = x[i]-h;
          t1 = x[i];
          t2 = x[i]+h;
          d1 = (f1-f0)/h;
          d2 = (f0-f2)/h;
          N = max(abs(J[i]),abs(f0),abs(f1),abs(f2),abs(t0),abs(t1),abs(t2),1e-8);
          errest = min(max(abs(d1-J[i]),abs(d2-J[i]),abs(d1-d2))/N,h/N);
          if(errest>eps) { h/=16; }
          else break;
        }
      }
      return J;
    };

    numeric.uncmin = function uncmin(f,x0,tol,gradient,maxit,callback,options) {
      var grad = numeric.gradient;
      if(typeof options === "undefined") { options = {}; }
      if(typeof tol === "undefined") { tol = 1e-8; }
      if(typeof gradient === "undefined") { gradient = function(x) { return grad(f,x); }; }
      if(typeof maxit === "undefined") maxit = 1000;
      x0 = numeric.clone(x0);
      var n = x0.length;
      var f0 = f(x0),f1,df0;
      if(isNaN(f0)) throw new Error('uncmin: f(x0) is a NaN!');
      var max = Math.max, norm2 = numeric.norm2;
      tol = max(tol,numeric.epsilon);
      var step,g0,g1,H1 = options.Hinv || numeric.identity(n);
      var dot = numeric.dot, inv = numeric.inv, sub = numeric.sub, add = numeric.add, ten = numeric.tensor, div = numeric.div, mul = numeric.mul;
      var all = numeric.all, isfinite = numeric.isFinite, neg = numeric.neg;
      var it=0,i,s,x1,y,Hy,Hs,ys,i0,t,nstep,t1,t2;
      var msg = "";
      g0 = gradient(x0);
      while(it<maxit) {
        if(typeof callback === "function") { if(callback(it,x0,f0,g0,H1)) { msg = "Callback returned true"; break; } }
        if(!all(isfinite(g0))) { msg = "Gradient has Infinity or NaN"; break; }
        step = neg(dot(H1,g0));
        if(!all(isfinite(step))) { msg = "Search direction has Infinity or NaN"; break; }
        nstep = norm2(step);
        if(nstep < tol) { msg="Newton step smaller than tol"; break; }
        t = 1;
        df0 = dot(g0,step);
        // line search
        x1 = x0;
        while(it < maxit) {
          if(t*nstep < tol) { break; }
          s = mul(step,t);
          x1 = add(x0,s);
          f1 = f(x1);
          if(f1-f0 >= 0.1*t*df0 || isNaN(f1)) {
            t *= 0.5;
            ++it;
            continue;
          }
          break;
        }
        if(t*nstep < tol) { msg = "Line search step size smaller than tol"; break; }
        if(it === maxit) { msg = "maxit reached during line search"; break; }
        g1 = gradient(x1);
        y = sub(g1,g0);
        ys = dot(y,s);
        Hy = dot(H1,y);
        H1 = sub(add(H1,
            mul(
              (ys+dot(y,Hy))/(ys*ys),
              ten(s,s)    )),
          div(add(ten(Hy,s),ten(s,Hy)),ys));
        x0 = x1;
        f0 = f1;
        g0 = g1;
        ++it;
      }
      return {solution: x0, f: f0, gradient: g0, invHessian: H1, iterations:it, message: msg};
    };

// 10. Ode solver (Dormand-Prince)
    numeric.Dopri = function Dopri(x,y,f,ymid,iterations,msg,events) {
      this.x = x;
      this.y = y;
      this.f = f;
      this.ymid = ymid;
      this.iterations = iterations;
      this.events = events;
      this.message = msg;
    };
    numeric.Dopri.prototype._at = function _at(xi,j) {
      function sqr(x) { return x*x; }
      var sol = this;
      var xs = sol.x;
      var ys = sol.y;
      var k1 = sol.f;
      var ymid = sol.ymid;
      var n = xs.length;
      var x0,x1,xh,y0,y1,yh,xi;
      var floor = Math.floor,h;
      var c = 0.5;
      var add = numeric.add, mul = numeric.mul,sub = numeric.sub, p,q,w;
      x0 = xs[j];
      x1 = xs[j+1];
      y0 = ys[j];
      y1 = ys[j+1];
      h  = x1-x0;
      xh = x0+c*h;
      yh = ymid[j];
      p = sub(k1[j  ],mul(y0,1/(x0-xh)+2/(x0-x1)));
      q = sub(k1[j+1],mul(y1,1/(x1-xh)+2/(x1-x0)));
      w = [sqr(xi - x1) * (xi - xh) / sqr(x0 - x1) / (x0 - xh),
        sqr(xi - x0) * sqr(xi - x1) / sqr(x0 - xh) / sqr(x1 - xh),
        sqr(xi - x0) * (xi - xh) / sqr(x1 - x0) / (x1 - xh),
        (xi - x0) * sqr(xi - x1) * (xi - xh) / sqr(x0-x1) / (x0 - xh),
        (xi - x1) * sqr(xi - x0) * (xi - xh) / sqr(x0-x1) / (x1 - xh)];
      return add(add(add(add(mul(y0,w[0]),
              mul(yh,w[1])),
            mul(y1,w[2])),
          mul( p,w[3])),
        mul( q,w[4]));
    };
    numeric.Dopri.prototype.at = function at(x) {
      var i,j,k,floor = Math.floor;
      if(typeof x !== "number") {
        var n = x.length, ret = Array(n);
        for(i=n-1;i!==-1;--i) {
          ret[i] = this.at(x[i]);
        }
        return ret;
      }
      var x0 = this.x;
      i = 0; j = x0.length-1;
      while(j-i>1) {
        k = floor(0.5*(i+j));
        if(x0[k] <= x) i = k;
        else j = k;
      }
      return this._at(x,i);
    };

    numeric.dopri = function dopri(x0,x1,y0,f,tol,maxit,event) {
      if(typeof tol === "undefined") { tol = 1e-6; }
      if(typeof maxit === "undefined") { maxit = 1000; }
      var xs = [x0], ys = [y0], k1 = [f(x0,y0)], k2,k3,k4,k5,k6,k7, ymid = [];
      var A2 = 1/5;
      var A3 = [3/40,9/40];
      var A4 = [44/45,-56/15,32/9];
      var A5 = [19372/6561,-25360/2187,64448/6561,-212/729];
      var A6 = [9017/3168,-355/33,46732/5247,49/176,-5103/18656];
      var b = [35/384,0,500/1113,125/192,-2187/6784,11/84];
      var bm = [0.5*6025192743/30085553152,
        0,
        0.5*51252292925/65400821598,
        0.5*-2691868925/45128329728,
        0.5*187940372067/1594534317056,
        0.5*-1776094331/19743644256,
        0.5*11237099/235043384];
      var c = [1/5,3/10,4/5,8/9,1,1];
      var e = [-71/57600,0,71/16695,-71/1920,17253/339200,-22/525,1/40];
      var i = 0,er,j;
      var h = (x1-x0)/10;
      var it = 0;
      var add = numeric.add, mul = numeric.mul, y1,erinf;
      var max = Math.max, min = Math.min, abs = Math.abs, norminf = numeric.norminf,pow = Math.pow;
      var any = numeric.any, lt = numeric.lt, and = numeric.and, sub = numeric.sub;
      var e0, e1, ev;
      var ret = new numeric.Dopri(xs,ys,k1,ymid,-1,"");
      if(typeof event === "function") e0 = event(x0,y0);
      while(x0<x1 && it<maxit) {
        ++it;
        if(x0+h>x1) h = x1-x0;
        k2 = f(x0+c[0]*h,                add(y0,mul(   A2*h,k1[i])));
        k3 = f(x0+c[1]*h,            add(add(y0,mul(A3[0]*h,k1[i])),mul(A3[1]*h,k2)));
        k4 = f(x0+c[2]*h,        add(add(add(y0,mul(A4[0]*h,k1[i])),mul(A4[1]*h,k2)),mul(A4[2]*h,k3)));
        k5 = f(x0+c[3]*h,    add(add(add(add(y0,mul(A5[0]*h,k1[i])),mul(A5[1]*h,k2)),mul(A5[2]*h,k3)),mul(A5[3]*h,k4)));
        k6 = f(x0+c[4]*h,add(add(add(add(add(y0,mul(A6[0]*h,k1[i])),mul(A6[1]*h,k2)),mul(A6[2]*h,k3)),mul(A6[3]*h,k4)),mul(A6[4]*h,k5)));
        y1 = add(add(add(add(add(y0,mul(k1[i],h*b[0])),mul(k3,h*b[2])),mul(k4,h*b[3])),mul(k5,h*b[4])),mul(k6,h*b[5]));
        k7 = f(x0+h,y1);
        er = add(add(add(add(add(mul(k1[i],h*e[0]),mul(k3,h*e[2])),mul(k4,h*e[3])),mul(k5,h*e[4])),mul(k6,h*e[5])),mul(k7,h*e[6]));
        if(typeof er === "number") erinf = abs(er);
        else erinf = norminf(er);
        if(erinf > tol) { // reject
          h = 0.2*h*pow(tol/erinf,0.25);
          if(x0+h === x0) {
            ret.msg = "Step size became too small";
            break;
          }
          continue;
        }
        ymid[i] = add(add(add(add(add(add(y0,
                    mul(k1[i],h*bm[0])),
                  mul(k3   ,h*bm[2])),
                mul(k4   ,h*bm[3])),
              mul(k5   ,h*bm[4])),
            mul(k6   ,h*bm[5])),
          mul(k7   ,h*bm[6]));
        ++i;
        xs[i] = x0+h;
        ys[i] = y1;
        k1[i] = k7;
        if(typeof event === "function") {
          var yi,xl = x0,xr = x0+0.5*h,xi;
          e1 = event(xr,ymid[i-1]);
          ev = and(lt(e0,0),lt(0,e1));
          if(!any(ev)) { xl = xr; xr = x0+h; e0 = e1; e1 = event(xr,y1); ev = and(lt(e0,0),lt(0,e1)); }
          if(any(ev)) {
            var xc, yc, en,ei;
            var side=0, sl = 1.0, sr = 1.0;
            while(1) {
              if(typeof e0 === "number") xi = (sr*e1*xl-sl*e0*xr)/(sr*e1-sl*e0);
              else {
                xi = xr;
                for(j=e0.length-1;j!==-1;--j) {
                  if(e0[j]<0 && e1[j]>0) xi = min(xi,(sr*e1[j]*xl-sl*e0[j]*xr)/(sr*e1[j]-sl*e0[j]));
                }
              }
              if(xi <= xl || xi >= xr) break;
              yi = ret._at(xi, i-1);
              ei = event(xi,yi);
              en = and(lt(e0,0),lt(0,ei));
              if(any(en)) {
                xr = xi;
                e1 = ei;
                ev = en;
                sr = 1.0;
                if(side === -1) sl *= 0.5;
                else sl = 1.0;
                side = -1;
              } else {
                xl = xi;
                e0 = ei;
                sl = 1.0;
                if(side === 1) sr *= 0.5;
                else sr = 1.0;
                side = 1;
              }
            }
            y1 = ret._at(0.5*(x0+xi),i-1);
            ret.f[i] = f(xi,yi);
            ret.x[i] = xi;
            ret.y[i] = yi;
            ret.ymid[i-1] = y1;
            ret.events = ev;
            ret.iterations = it;
            return ret;
          }
        }
        x0 += h;
        y0 = y1;
        e0 = e1;
        h = min(0.8*h*pow(tol/erinf,0.25),4*h);
      }
      ret.iterations = it;
      return ret;
    };

// 11. Ax = b
    numeric.LU = function(A, fast) {
      fast = fast || false;

      var abs = Math.abs;
      var i, j, k, absAjk, Akk, Ak, Pk, Ai;
      var max;
      var n = A.length, n1 = n-1;
      var P = new Array(n);
      if(!fast) A = numeric.clone(A);

      for (k = 0; k < n; ++k) {
        Pk = k;
        Ak = A[k];
        max = abs(Ak[k]);
        for (j = k + 1; j < n; ++j) {
          absAjk = abs(A[j][k]);
          if (max < absAjk) {
            max = absAjk;
            Pk = j;
          }
        }
        P[k] = Pk;

        if (Pk != k) {
          A[k] = A[Pk];
          A[Pk] = Ak;
          Ak = A[k];
        }

        Akk = Ak[k];

        for (i = k + 1; i < n; ++i) {
          A[i][k] /= Akk;
        }

        for (i = k + 1; i < n; ++i) {
          Ai = A[i];
          for (j = k + 1; j < n1; ++j) {
            Ai[j] -= Ai[k] * Ak[j];
            ++j;
            Ai[j] -= Ai[k] * Ak[j];
          }
          if(j===n1) Ai[j] -= Ai[k] * Ak[j];
        }
      }

      return {
        LU: A,
        P:  P
      };
    };

    numeric.LUsolve = function LUsolve(LUP, b) {
      var i, j;
      var LU = LUP.LU;
      var n   = LU.length;
      var x = numeric.clone(b);
      var P   = LUP.P;
      var Pi, LUi, LUii, tmp;

      for (i=n-1;i!==-1;--i) x[i] = b[i];
      for (i = 0; i < n; ++i) {
        Pi = P[i];
        if (P[i] !== i) {
          tmp = x[i];
          x[i] = x[Pi];
          x[Pi] = tmp;
        }

        LUi = LU[i];
        for (j = 0; j < i; ++j) {
          x[i] -= x[j] * LUi[j];
        }
      }

      for (i = n - 1; i >= 0; --i) {
        LUi = LU[i];
        for (j = i + 1; j < n; ++j) {
          x[i] -= x[j] * LUi[j];
        }

        x[i] /= LUi[i];
      }

      return x;
    };

    numeric.solve = function solve(A,b,fast) { return numeric.LUsolve(numeric.LU(A,fast), b); };

// 12. Linear programming
    numeric.echelonize = function echelonize(A) {
      var s = numeric.dim(A), m = s[0], n = s[1];
      var I = numeric.identity(m);
      var P = Array(m);
      var i,j,k,l,Ai,Ii,Z,a;
      var abs = Math.abs;
      var diveq = numeric.diveq;
      A = numeric.clone(A);
      for(i=0;i<m;++i) {
        k = 0;
        Ai = A[i];
        Ii = I[i];
        for(j=1;j<n;++j) if(abs(Ai[k])<abs(Ai[j])) k=j;
        P[i] = k;
        diveq(Ii,Ai[k]);
        diveq(Ai,Ai[k]);
        for(j=0;j<m;++j) if(j!==i) {
          Z = A[j]; a = Z[k];
          for(l=n-1;l!==-1;--l) Z[l] -= Ai[l]*a;
          Z = I[j];
          for(l=m-1;l!==-1;--l) Z[l] -= Ii[l]*a;
        }
      }
      return {I:I, A:A, P:P};
    };

    numeric.__solveLP = function __solveLP(c,A,b,tol,maxit,x,flag) {
      var sum = numeric.sum, log = numeric.log, mul = numeric.mul, sub = numeric.sub, dot = numeric.dot, div = numeric.div, add = numeric.add;
      var m = c.length, n = b.length,y;
      var unbounded = false, cb,i0=0;
      var alpha = 1.0;
      var f0,df0,AT = numeric.transpose(A), svd = numeric.svd,transpose = numeric.transpose,leq = numeric.leq, sqrt = Math.sqrt, abs = Math.abs;
      var muleq = numeric.muleq;
      var norm = numeric.norminf, any = numeric.any,min = Math.min;
      var all = numeric.all, gt = numeric.gt;
      var p = Array(m), A0 = Array(n),e=numeric.rep([n],1), H;
      var solve = numeric.solve, z = sub(b,dot(A,x)),count;
      var dotcc = dot(c,c);
      var g;
      for(count=i0;count<maxit;++count) {
        var i,j,d;
        for(i=n-1;i!==-1;--i) A0[i] = div(A[i],z[i]);
        var A1 = transpose(A0);
        for(i=m-1;i!==-1;--i) p[i] = (/*x[i]+*/sum(A1[i]));
        alpha = 0.25*abs(dotcc/dot(c,p));
        var a1 = 100*sqrt(dotcc/dot(p,p));
        if(!isFinite(alpha) || alpha>a1) alpha = a1;
        g = add(c,mul(alpha,p));
        H = dot(A1,A0);
        for(i=m-1;i!==-1;--i) H[i][i] += 1;
        d = solve(H,div(g,alpha),true);
        var t0 = div(z,dot(A,d));
        var t = 1.0;
        for(i=n-1;i!==-1;--i) if(t0[i]<0) t = min(t,-0.999*t0[i]);
        y = sub(x,mul(d,t));
        z = sub(b,dot(A,y));
        if(!all(gt(z,0))) return { solution: x, message: "", iterations: count };
        x = y;
        if(alpha<tol) return { solution: y, message: "", iterations: count };
        if(flag) {
          var s = dot(c,g), Ag = dot(A,g);
          unbounded = true;
          for(i=n-1;i!==-1;--i) if(s*Ag[i]<0) { unbounded = false; break; }
        } else {
          if(x[m-1]>=0) unbounded = false;
          else unbounded = true;
        }
        if(unbounded) return { solution: y, message: "Unbounded", iterations: count };
      }
      return { solution: x, message: "maximum iteration count exceeded", iterations:count };
    };

    numeric._solveLP = function _solveLP(c,A,b,tol,maxit) {
      var m = c.length, n = b.length,y;
      var sum = numeric.sum, log = numeric.log, mul = numeric.mul, sub = numeric.sub, dot = numeric.dot, div = numeric.div, add = numeric.add;
      var c0 = numeric.rep([m],0).concat([1]);
      var J = numeric.rep([n,1],-1);
      var A0 = numeric.blockMatrix([[A                   ,   J  ]]);
      var b0 = b;
      var y = numeric.rep([m],0).concat(Math.max(0,numeric.sup(numeric.neg(b)))+1);
      var x0 = numeric.__solveLP(c0,A0,b0,tol,maxit,y,false);
      var x = numeric.clone(x0.solution);
      x.length = m;
      var foo = numeric.inf(sub(b,dot(A,x)));
      if(foo<0) { return { solution: NaN, message: "Infeasible", iterations: x0.iterations }; }
      var ret = numeric.__solveLP(c, A, b, tol, maxit-x0.iterations, x, true);
      ret.iterations += x0.iterations;
      return ret;
    };

    numeric.solveLP = function solveLP(c,A,b,Aeq,beq,tol,maxit) {
      if(typeof maxit === "undefined") maxit = 1000;
      if(typeof tol === "undefined") tol = numeric.epsilon;
      if(typeof Aeq === "undefined") return numeric._solveLP(c,A,b,tol,maxit);
      var m = Aeq.length, n = Aeq[0].length, o = A.length;
      var B = numeric.echelonize(Aeq);
      var flags = numeric.rep([n],0);
      var P = B.P;
      var Q = [];
      var i;
      for(i=P.length-1;i!==-1;--i) flags[P[i]] = 1;
      for(i=n-1;i!==-1;--i) if(flags[i]===0) Q.push(i);
      var g = numeric.getRange;
      var I = numeric.linspace(0,m-1), J = numeric.linspace(0,o-1);
      var Aeq2 = g(Aeq,I,Q), A1 = g(A,J,P), A2 = g(A,J,Q), dot = numeric.dot, sub = numeric.sub;
      var A3 = dot(A1,B.I);
      var A4 = sub(A2,dot(A3,Aeq2)), b4 = sub(b,dot(A3,beq));
      var c1 = Array(P.length), c2 = Array(Q.length);
      for(i=P.length-1;i!==-1;--i) c1[i] = c[P[i]];
      for(i=Q.length-1;i!==-1;--i) c2[i] = c[Q[i]];
      var c4 = sub(c2,dot(c1,dot(B.I,Aeq2)));
      var S = numeric._solveLP(c4,A4,b4,tol,maxit);
      var x2 = S.solution;
      if(x2!==x2) return S;
      var x1 = dot(B.I,sub(beq,dot(Aeq2,x2)));
      var x = Array(c.length);
      for(i=P.length-1;i!==-1;--i) x[P[i]] = x1[i];
      for(i=Q.length-1;i!==-1;--i) x[Q[i]] = x2[i];
      return { solution: x, message:S.message, iterations: S.iterations };
    };

    numeric.MPStoLP = function MPStoLP(MPS) {
      if(MPS instanceof String) { MPS.split('\n'); }
      var state = 0;
      var states = ['Initial state','NAME','ROWS','COLUMNS','RHS','BOUNDS','ENDATA'];
      var n = MPS.length;
      var i,j,z,N=0,rows = {}, sign = [], rl = 0, vars = {}, nv = 0;
      var name;
      var c = [], A = [], b = [];
      function err(e) { throw new Error('MPStoLP: '+e+'\nLine '+i+': '+MPS[i]+'\nCurrent state: '+states[state]+'\n'); }
      for(i=0;i<n;++i) {
        z = MPS[i];
        var w0 = z.match(/\S*/g);
        var w = [];
        for(j=0;j<w0.length;++j) if(w0[j]!=="") w.push(w0[j]);
        if(w.length === 0) continue;
        for(j=0;j<states.length;++j) if(z.substr(0,states[j].length) === states[j]) break;
        if(j<states.length) {
          state = j;
          if(j===1) { name = w[1]; }
          if(j===6) return { name:name, c:c, A:numeric.transpose(A), b:b, rows:rows, vars:vars };
          continue;
        }
        switch(state) {
          case 0: case 1: err('Unexpected line');
          case 2:
            switch(w[0]) {
              case 'N': if(N===0) N = w[1]; else err('Two or more N rows'); break;
              case 'L': rows[w[1]] = rl; sign[rl] = 1; b[rl] = 0; ++rl; break;
              case 'G': rows[w[1]] = rl; sign[rl] = -1;b[rl] = 0; ++rl; break;
              case 'E': rows[w[1]] = rl; sign[rl] = 0;b[rl] = 0; ++rl; break;
              default: err('Parse error '+numeric.prettyPrint(w));
            }
            break;
          case 3:
            if(!vars.hasOwnProperty(w[0])) { vars[w[0]] = nv; c[nv] = 0; A[nv] = numeric.rep([rl],0); ++nv; }
            var p = vars[w[0]];
            for(j=1;j<w.length;j+=2) {
              if(w[j] === N) { c[p] = parseFloat(w[j+1]); continue; }
              var q = rows[w[j]];
              A[p][q] = (sign[q]<0?-1:1)*parseFloat(w[j+1]);
            }
            break;
          case 4:
            for(j=1;j<w.length;j+=2) b[rows[w[j]]] = (sign[rows[w[j]]]<0?-1:1)*parseFloat(w[j+1]);
            break;
          case 5: /*FIXME*/ break;
          case 6: err('Internal error');
        }
      }
      err('Reached end of file without ENDATA');
    };
// seedrandom.js version 2.0.
// Author: David Bau 4/2/2011
//
// Defines a method Math.seedrandom() that, when called, substitutes
// an explicitly seeded RC4-based algorithm for Math.random().  Also
// supports automatic seeding from local or network sources of entropy.
//
// Usage:
//
//   <script src=http://davidbau.com/encode/seedrandom-min.js></script>
//
//   Math.seedrandom('yipee'); Sets Math.random to a function that is
//                             initialized using the given explicit seed.
//
//   Math.seedrandom();        Sets Math.random to a function that is
//                             seeded using the current time, dom state,
//                             and other accumulated local entropy.
//                             The generated seed string is returned.
//
//   Math.seedrandom('yowza', true);
//                             Seeds using the given explicit seed mixed
//                             together with accumulated entropy.
//
//   <script src="http://bit.ly/srandom-512"></script>
//                             Seeds using physical random bits downloaded
//                             from random.org.
//
//   <script src="https://jsonlib.appspot.com/urandom?callback=Math.seedrandom">
//   </script>                 Seeds using urandom bits from call.jsonlib.com,
//                             which is faster than random.org.
//
// Examples:
//
//   Math.seedrandom("hello");            // Use "hello" as the seed.
//   document.write(Math.random());       // Always 0.5463663768140734
//   document.write(Math.random());       // Always 0.43973793770592234
//   var rng1 = Math.random;              // Remember the current prng.
//
//   var autoseed = Math.seedrandom();    // New prng with an automatic seed.
//   document.write(Math.random());       // Pretty much unpredictable.
//
//   Math.random = rng1;                  // Continue "hello" prng sequence.
//   document.write(Math.random());       // Always 0.554769432473455
//
//   Math.seedrandom(autoseed);           // Restart at the previous seed.
//   document.write(Math.random());       // Repeat the 'unpredictable' value.
//
// Notes:
//
// Each time seedrandom('arg') is called, entropy from the passed seed
// is accumulated in a pool to help generate future seeds for the
// zero-argument form of Math.seedrandom, so entropy can be injected over
// time by calling seedrandom with explicit data repeatedly.
//
// On speed - This javascript implementation of Math.random() is about
// 3-10x slower than the built-in Math.random() because it is not native
// code, but this is typically fast enough anyway.  Seeding is more expensive,
// especially if you use auto-seeding.  Some details (timings on Chrome 4):
//
// Our Math.random()            - avg less than 0.002 milliseconds per call
// seedrandom('explicit')       - avg less than 0.5 milliseconds per call
// seedrandom('explicit', true) - avg less than 2 milliseconds per call
// seedrandom()                 - avg about 38 milliseconds per call
//
// LICENSE (BSD):
//
// Copyright 2010 David Bau, all rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//   1. Redistributions of source code must retain the above copyright
//      notice, this list of conditions and the following disclaimer.
//
//   2. Redistributions in binary form must reproduce the above copyright
//      notice, this list of conditions and the following disclaimer in the
//      documentation and/or other materials provided with the distribution.
//
//   3. Neither the name of this module nor the names of its contributors may
//      be used to endorse or promote products derived from this software
//      without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
    /**
     * All code is in an anonymous closure to keep the global namespace clean.
     *
     * @param {number=} overflow
     * @param {number=} startdenom
     */

// Patched by Seb so that seedrandom.js does not pollute the Math object.
// My tests suggest that doing Math.trouble = 1 makes Math lookups about 5%
// slower.
    numeric.seedrandom = { pow:Math.pow, random:Math.random };

    (function (pool, math, width, chunks, significance, overflow, startdenom) {


//
// seedrandom()
// This is the seedrandom function described above.
//
      math['seedrandom'] = function seedrandom(seed, use_entropy) {
        var key = [];
        var arc4;

        // Flatten the seed string or build one from local entropy if needed.
        seed = mixkey(flatten(
          use_entropy ? [seed, pool] :
            arguments.length ? seed :
              [new Date().getTime(), pool, window], 3), key);

        // Use the seed to initialize an ARC4 generator.
        arc4 = new ARC4(key);

        // Mix the randomness into accumulated entropy.
        mixkey(arc4.S, pool);

        // Override Math.random

        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.

        math['random'] = function random() {  // Closure to return a random double:
          var n = arc4.g(chunks);             // Start with a numerator n < 2 ^ 48
          var d = startdenom;                 //   and denominator d = 2 ^ 48.
          var x = 0;                          //   and no 'extra last byte'.
          while (n < significance) {          // Fill up all significant digits by
            n = (n + x) * width;              //   shifting numerator and
            d *= width;                       //   denominator and generating a
            x = arc4.g(1);                    //   new least-significant-byte.
          }
          while (n >= overflow) {             // To avoid rounding up, before adding
            n /= 2;                           //   last byte, shift everything
            d /= 2;                           //   right using integer math until
            x >>>= 1;                         //   we have exactly the desired bits.
          }
          return (n + x) / d;                 // Form the number within [0, 1).
        };

        // Return the seed that was used
        return seed;
      };

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
      /** @constructor */
      function ARC4(key) {
        var t, u, me = this, keylen = key.length;
        var i = 0, j = me.i = me.j = me.m = 0;
        me.S = [];
        me.c = [];

        // The empty key [] is treated as [0].
        if (!keylen) { key = [keylen++]; }

        // Set up S using the standard key scheduling algorithm.
        while (i < width) { me.S[i] = i++; }
        for (i = 0; i < width; i++) {
          t = me.S[i];
          j = lowbits(j + t + key[i % keylen]);
          u = me.S[j];
          me.S[i] = u;
          me.S[j] = t;
        }

        // The "g" method returns the next (count) outputs as one number.
        me.g = function getnext(count) {
          var s = me.S;
          var i = lowbits(me.i + 1); var t = s[i];
          var j = lowbits(me.j + t); var u = s[j];
          s[i] = u;
          s[j] = t;
          var r = s[lowbits(t + u)];
          while (--count) {
            i = lowbits(i + 1); t = s[i];
            j = lowbits(j + t); u = s[j];
            s[i] = u;
            s[j] = t;
            r = r * width + s[lowbits(t + u)];
          }
          me.i = i;
          me.j = j;
          return r;
        };
        // For robust unpredictability discard an initial batch of values.
        // See http://www.rsa.com/rsalabs/node.asp?id=2009
        me.g(width);
      }

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
      /** @param {Object=} result
       * @param {string=} prop
       * @param {string=} typ */
      function flatten(obj, depth, result, prop, typ) {
        result = [];
        typ = typeof(obj);
        if (depth && typ == 'object') {
          for (prop in obj) {
            if (prop.indexOf('S') < 5) {    // Avoid FF3 bug (local/sessionStorage)
              try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
            }
          }
        }
        return (result.length ? result : obj + (typ != 'string' ? '\0' : ''));
      }

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
      /** @param {number=} smear
       * @param {number=} j */
      function mixkey(seed, key, smear, j) {
        seed += '';                         // Ensure the seed is a string
        smear = 0;
        for (j = 0; j < seed.length; j++) {
          key[lowbits(j)] =
            lowbits((smear ^= key[lowbits(j)] * 19) + seed.charCodeAt(j));
        }
        seed = '';
        for (j in key) { seed += String.fromCharCode(key[j]); }
        return seed;
      }

//
// lowbits()
// A quick "n mod width" for width a power of 2.
//
      function lowbits(n) { return n & (width - 1); }

//
// The following constants are related to IEEE 754 limits.
//
      startdenom = math.pow(width, chunks);
      significance = math.pow(2, significance);
      overflow = significance * 2;

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to intefere with determinstic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
      mixkey(math.random(), pool);

// End anonymous scope, and pass initial values.
    }(
      [],   // pool: entropy pool starts empty
      numeric.seedrandom, // math: package containing random, pow, and seedrandom
      256,  // width: each RC4 output is 0 <= x < 256
      6,    // chunks: at least six RC4 outputs for each double
      52    // significance: there are 52 significant digits in a double
    ));
    /* This file is a slightly modified version of quadprog.js from Alberto Santini.
 * It has been slightly modified by Sébastien Loisel to make sure that it handles
 * 0-based Arrays instead of 1-based Arrays.
 * License is in resources/LICENSE.quadprog */
    (function(exports) {

      function base0to1(A) {
        if(typeof A !== "object") { return A; }
        var ret = [], i,n=A.length;
        for(i=0;i<n;i++) ret[i+1] = base0to1(A[i]);
        return ret;
      }
      function base1to0(A) {
        if(typeof A !== "object") { return A; }
        var ret = [], i,n=A.length;
        for(i=1;i<n;i++) ret[i-1] = base1to0(A[i]);
        return ret;
      }

      function dpori(a, lda, n) {
        var i, j, k, kp1, t;

        for (k = 1; k <= n; k = k + 1) {
          a[k][k] = 1 / a[k][k];
          t = -a[k][k];
          //~ dscal(k - 1, t, a[1][k], 1);
          for (i = 1; i < k; i = i + 1) {
            a[i][k] = t * a[i][k];
          }

          kp1 = k + 1;
          if (n < kp1) {
            break;
          }
          for (j = kp1; j <= n; j = j + 1) {
            t = a[k][j];
            a[k][j] = 0;
            //~ daxpy(k, t, a[1][k], 1, a[1][j], 1);
            for (i = 1; i <= k; i = i + 1) {
              a[i][j] = a[i][j] + (t * a[i][k]);
            }
          }
        }

      }

      function dposl(a, lda, n, b) {
        var i, k, kb, t;

        for (k = 1; k <= n; k = k + 1) {
          //~ t = ddot(k - 1, a[1][k], 1, b[1], 1);
          t = 0;
          for (i = 1; i < k; i = i + 1) {
            t = t + (a[i][k] * b[i]);
          }

          b[k] = (b[k] - t) / a[k][k];
        }

        for (kb = 1; kb <= n; kb = kb + 1) {
          k = n + 1 - kb;
          b[k] = b[k] / a[k][k];
          t = -b[k];
          //~ daxpy(k - 1, t, a[1][k], 1, b[1], 1);
          for (i = 1; i < k; i = i + 1) {
            b[i] = b[i] + (t * a[i][k]);
          }
        }
      }

      function dpofa(a, lda, n, info) {
        var i, j, jm1, k, t, s;

        for (j = 1; j <= n; j = j + 1) {
          info[1] = j;
          s = 0;
          jm1 = j - 1;
          if (jm1 < 1) {
            s = a[j][j] - s;
            if (s <= 0) {
              break;
            }
            a[j][j] = Math.sqrt(s);
          } else {
            for (k = 1; k <= jm1; k = k + 1) {
              //~ t = a[k][j] - ddot(k - 1, a[1][k], 1, a[1][j], 1);
              t = a[k][j];
              for (i = 1; i < k; i = i + 1) {
                t = t - (a[i][j] * a[i][k]);
              }
              t = t / a[k][k];
              a[k][j] = t;
              s = s + t * t;
            }
            s = a[j][j] - s;
            if (s <= 0) {
              break;
            }
            a[j][j] = Math.sqrt(s);
          }
          info[1] = 0;
        }
      }

      function qpgen2(dmat, dvec, fddmat, n, sol, crval, amat,
                      bvec, fdamat, q, meq, iact, nact, iter, work, ierr) {

        var i, j, l, l1, info, it1, iwzv, iwrv, iwrm, iwsv, iwuv, nvl, r, iwnbv,
          temp, sum, t1, tt, gc, gs, nu,
          t1inf, t2min,
          vsmall, tmpa, tmpb,
          go;

        r = Math.min(n, q);
        l = 2 * n + (r * (r + 5)) / 2 + 2 * q + 1;

        vsmall = 1.0e-60;
        do {
          vsmall = vsmall + vsmall;
          tmpa = 1 + 0.1 * vsmall;
          tmpb = 1 + 0.2 * vsmall;
        } while (tmpa <= 1 || tmpb <= 1);

        for (i = 1; i <= n; i = i + 1) {
          work[i] = dvec[i];
        }
        for (i = n + 1; i <= l; i = i + 1) {
          work[i] = 0;
        }
        for (i = 1; i <= q; i = i + 1) {
          iact[i] = 0;
        }

        info = [];

        if (ierr[1] === 0) {
          dpofa(dmat, fddmat, n, info);
          if (info[1] !== 0) {
            ierr[1] = 2;
            return;
          }
          dposl(dmat, fddmat, n, dvec);
          dpori(dmat, fddmat, n);
        } else {
          for (j = 1; j <= n; j = j + 1) {
            sol[j] = 0;
            for (i = 1; i <= j; i = i + 1) {
              sol[j] = sol[j] + dmat[i][j] * dvec[i];
            }
          }
          for (j = 1; j <= n; j = j + 1) {
            dvec[j] = 0;
            for (i = j; i <= n; i = i + 1) {
              dvec[j] = dvec[j] + dmat[j][i] * sol[i];
            }
          }
        }

        crval[1] = 0;
        for (j = 1; j <= n; j = j + 1) {
          sol[j] = dvec[j];
          crval[1] = crval[1] + work[j] * sol[j];
          work[j] = 0;
          for (i = j + 1; i <= n; i = i + 1) {
            dmat[i][j] = 0;
          }
        }
        crval[1] = -crval[1] / 2;
        ierr[1] = 0;

        iwzv = n;
        iwrv = iwzv + n;
        iwuv = iwrv + r;
        iwrm = iwuv + r + 1;
        iwsv = iwrm + (r * (r + 1)) / 2;
        iwnbv = iwsv + q;

        for (i = 1; i <= q; i = i + 1) {
          sum = 0;
          for (j = 1; j <= n; j = j + 1) {
            sum = sum + amat[j][i] * amat[j][i];
          }
          work[iwnbv + i] = Math.sqrt(sum);
        }
        nact = 0;
        iter[1] = 0;
        iter[2] = 0;

        function fn_goto_50() {
          iter[1] = iter[1] + 1;

          l = iwsv;
          for (i = 1; i <= q; i = i + 1) {
            l = l + 1;
            sum = -bvec[i];
            for (j = 1; j <= n; j = j + 1) {
              sum = sum + amat[j][i] * sol[j];
            }
            if (Math.abs(sum) < vsmall) {
              sum = 0;
            }
            if (i > meq) {
              work[l] = sum;
            } else {
              work[l] = -Math.abs(sum);
              if (sum > 0) {
                for (j = 1; j <= n; j = j + 1) {
                  amat[j][i] = -amat[j][i];
                }
                bvec[i] = -bvec[i];
              }
            }
          }

          for (i = 1; i <= nact; i = i + 1) {
            work[iwsv + iact[i]] = 0;
          }

          nvl = 0;
          temp = 0;
          for (i = 1; i <= q; i = i + 1) {
            if (work[iwsv + i] < temp * work[iwnbv + i]) {
              nvl = i;
              temp = work[iwsv + i] / work[iwnbv + i];
            }
          }
          if (nvl === 0) {
            return 999;
          }

          return 0;
        }

        function fn_goto_55() {
          for (i = 1; i <= n; i = i + 1) {
            sum = 0;
            for (j = 1; j <= n; j = j + 1) {
              sum = sum + dmat[j][i] * amat[j][nvl];
            }
            work[i] = sum;
          }

          l1 = iwzv;
          for (i = 1; i <= n; i = i + 1) {
            work[l1 + i] = 0;
          }
          for (j = nact + 1; j <= n; j = j + 1) {
            for (i = 1; i <= n; i = i + 1) {
              work[l1 + i] = work[l1 + i] + dmat[i][j] * work[j];
            }
          }

          t1inf = true;
          for (i = nact; i >= 1; i = i - 1) {
            sum = work[i];
            l = iwrm + (i * (i + 3)) / 2;
            l1 = l - i;
            for (j = i + 1; j <= nact; j = j + 1) {
              sum = sum - work[l] * work[iwrv + j];
              l = l + j;
            }
            sum = sum / work[l1];
            work[iwrv + i] = sum;
            if (iact[i] < meq) {
              // continue;
              break;
            }
            if (sum < 0) {
              // continue;
              break;
            }
            t1inf = false;
            it1 = i;
          }

          if (!t1inf) {
            t1 = work[iwuv + it1] / work[iwrv + it1];
            for (i = 1; i <= nact; i = i + 1) {
              if (iact[i] < meq) {
                // continue;
                break;
              }
              if (work[iwrv + i] < 0) {
                // continue;
                break;
              }
              temp = work[iwuv + i] / work[iwrv + i];
              if (temp < t1) {
                t1 = temp;
                it1 = i;
              }
            }
          }

          sum = 0;
          for (i = iwzv + 1; i <= iwzv + n; i = i + 1) {
            sum = sum + work[i] * work[i];
          }
          if (Math.abs(sum) <= vsmall) {
            if (t1inf) {
              ierr[1] = 1;
              // GOTO 999
              return 999;
            } else {
              for (i = 1; i <= nact; i = i + 1) {
                work[iwuv + i] = work[iwuv + i] - t1 * work[iwrv + i];
              }
              work[iwuv + nact + 1] = work[iwuv + nact + 1] + t1;
              // GOTO 700
              return 700;
            }
          } else {
            sum = 0;
            for (i = 1; i <= n; i = i + 1) {
              sum = sum + work[iwzv + i] * amat[i][nvl];
            }
            tt = -work[iwsv + nvl] / sum;
            t2min = true;
            if (!t1inf) {
              if (t1 < tt) {
                tt = t1;
                t2min = false;
              }
            }

            for (i = 1; i <= n; i = i + 1) {
              sol[i] = sol[i] + tt * work[iwzv + i];
              if (Math.abs(sol[i]) < vsmall) {
                sol[i] = 0;
              }
            }

            crval[1] = crval[1] + tt * sum * (tt / 2 + work[iwuv + nact + 1]);
            for (i = 1; i <= nact; i = i + 1) {
              work[iwuv + i] = work[iwuv + i] - tt * work[iwrv + i];
            }
            work[iwuv + nact + 1] = work[iwuv + nact + 1] + tt;

            if (t2min) {
              nact = nact + 1;
              iact[nact] = nvl;

              l = iwrm + ((nact - 1) * nact) / 2 + 1;
              for (i = 1; i <= nact - 1; i = i + 1) {
                work[l] = work[i];
                l = l + 1;
              }

              if (nact === n) {
                work[l] = work[n];
              } else {
                for (i = n; i >= nact + 1; i = i - 1) {
                  if (work[i] === 0) {
                    // continue;
                    break;
                  }
                  gc = Math.max(Math.abs(work[i - 1]), Math.abs(work[i]));
                  gs = Math.min(Math.abs(work[i - 1]), Math.abs(work[i]));
                  if (work[i - 1] >= 0) {
                    temp = Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
                  } else {
                    temp = -Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
                  }
                  gc = work[i - 1] / temp;
                  gs = work[i] / temp;

                  if (gc === 1) {
                    // continue;
                    break;
                  }
                  if (gc === 0) {
                    work[i - 1] = gs * temp;
                    for (j = 1; j <= n; j = j + 1) {
                      temp = dmat[j][i - 1];
                      dmat[j][i - 1] = dmat[j][i];
                      dmat[j][i] = temp;
                    }
                  } else {
                    work[i - 1] = temp;
                    nu = gs / (1 + gc);
                    for (j = 1; j <= n; j = j + 1) {
                      temp = gc * dmat[j][i - 1] + gs * dmat[j][i];
                      dmat[j][i] = nu * (dmat[j][i - 1] + temp) - dmat[j][i];
                      dmat[j][i - 1] = temp;

                    }
                  }
                }
                work[l] = work[nact];
              }
            } else {
              sum = -bvec[nvl];
              for (j = 1; j <= n; j = j + 1) {
                sum = sum + sol[j] * amat[j][nvl];
              }
              if (nvl > meq) {
                work[iwsv + nvl] = sum;
              } else {
                work[iwsv + nvl] = -Math.abs(sum);
                if (sum > 0) {
                  for (j = 1; j <= n; j = j + 1) {
                    amat[j][nvl] = -amat[j][nvl];
                  }
                  bvec[nvl] = -bvec[nvl];
                }
              }
              // GOTO 700
              return 700;
            }
          }

          return 0;
        }

        function fn_goto_797() {
          l = iwrm + (it1 * (it1 + 1)) / 2 + 1;
          l1 = l + it1;
          if (work[l1] === 0) {
            // GOTO 798
            return 798;
          }
          gc = Math.max(Math.abs(work[l1 - 1]), Math.abs(work[l1]));
          gs = Math.min(Math.abs(work[l1 - 1]), Math.abs(work[l1]));
          if (work[l1 - 1] >= 0) {
            temp = Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
          } else {
            temp = -Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
          }
          gc = work[l1 - 1] / temp;
          gs = work[l1] / temp;

          if (gc === 1) {
            // GOTO 798
            return 798;
          }
          if (gc === 0) {
            for (i = it1 + 1; i <= nact; i = i + 1) {
              temp = work[l1 - 1];
              work[l1 - 1] = work[l1];
              work[l1] = temp;
              l1 = l1 + i;
            }
            for (i = 1; i <= n; i = i + 1) {
              temp = dmat[i][it1];
              dmat[i][it1] = dmat[i][it1 + 1];
              dmat[i][it1 + 1] = temp;
            }
          } else {
            nu = gs / (1 + gc);
            for (i = it1 + 1; i <= nact; i = i + 1) {
              temp = gc * work[l1 - 1] + gs * work[l1];
              work[l1] = nu * (work[l1 - 1] + temp) - work[l1];
              work[l1 - 1] = temp;
              l1 = l1 + i;
            }
            for (i = 1; i <= n; i = i + 1) {
              temp = gc * dmat[i][it1] + gs * dmat[i][it1 + 1];
              dmat[i][it1 + 1] = nu * (dmat[i][it1] + temp) - dmat[i][it1 + 1];
              dmat[i][it1] = temp;
            }
          }

          return 0;
        }

        function fn_goto_798() {
          l1 = l - it1;
          for (i = 1; i <= it1; i = i + 1) {
            work[l1] = work[l];
            l = l + 1;
            l1 = l1 + 1;
          }

          work[iwuv + it1] = work[iwuv + it1 + 1];
          iact[it1] = iact[it1 + 1];
          it1 = it1 + 1;
          if (it1 < nact) {
            // GOTO 797
            return 797;
          }

          return 0;
        }

        function fn_goto_799() {
          work[iwuv + nact] = work[iwuv + nact + 1];
          work[iwuv + nact + 1] = 0;
          iact[nact] = 0;
          nact = nact - 1;
          iter[2] = iter[2] + 1;

          return 0;
        }

        go = 0;
        while (true) {
          go = fn_goto_50();
          if (go === 999) {
            return;
          }
          while (true) {
            go = fn_goto_55();
            if (go === 0) {
              break;
            }
            if (go === 999) {
              return;
            }
            if (go === 700) {
              if (it1 === nact) {
                fn_goto_799();
              } else {
                while (true) {
                  fn_goto_797();
                  go = fn_goto_798();
                  if (go !== 797) {
                    break;
                  }
                }
                fn_goto_799();
              }
            }
          }
        }

      }

      function solveQP(Dmat, dvec, Amat, bvec, meq, factorized) {
        Dmat = base0to1(Dmat);
        dvec = base0to1(dvec);
        Amat = base0to1(Amat);
        var i, n, q,
          nact, r,
          crval = [], iact = [], sol = [], work = [], iter = [],
          message;

        meq = meq || 0;
        factorized = factorized ? base0to1(factorized) : [undefined, 0];
        bvec = bvec ? base0to1(bvec) : [];

        // In Fortran the array index starts from 1
        n = Dmat.length - 1;
        q = Amat[1].length - 1;

        if (!bvec) {
          for (i = 1; i <= q; i = i + 1) {
            bvec[i] = 0;
          }
        }
        for (i = 1; i <= q; i = i + 1) {
          iact[i] = 0;
        }
        nact = 0;
        r = Math.min(n, q);
        for (i = 1; i <= n; i = i + 1) {
          sol[i] = 0;
        }
        crval[1] = 0;
        for (i = 1; i <= (2 * n + (r * (r + 5)) / 2 + 2 * q + 1); i = i + 1) {
          work[i] = 0;
        }
        for (i = 1; i <= 2; i = i + 1) {
          iter[i] = 0;
        }

        qpgen2(Dmat, dvec, n, n, sol, crval, Amat,
          bvec, n, q, meq, iact, nact, iter, work, factorized);

        message = "";
        if (factorized[1] === 1) {
          message = "constraints are inconsistent, no solution!";
        }
        if (factorized[1] === 2) {
          message = "matrix D in quadratic function is not positive definite!";
        }

        return {
          solution: base1to0(sol),
          value: base1to0(crval),
          unconstrained_solution: base1to0(dvec),
          iterations: base1to0(iter),
          iact: base1to0(iact),
          message: message
        };
      }
      exports.solveQP = solveQP;
    }(numeric));
    /*
Shanti Rao sent me this routine by private email. I had to modify it
slightly to work on Arrays instead of using a Matrix object.
It is apparently translated from http://stitchpanorama.sourceforge.net/Python/svd.py
*/

    numeric.svd= function svd(A) {
      var temp;
//Compute the thin SVD from G. H. Golub and C. Reinsch, Numer. Math. 14, 403-420 (1970)
      var prec= numeric.epsilon; //Math.pow(2,-52) // assumes double prec
      var tolerance= 1.e-64/prec;
      var itmax= 50;
      var c=0;
      var i=0;
      var j=0;
      var k=0;
      var l=0;

      var u= numeric.clone(A);
      var m= u.length;

      var n= u[0].length;

      if (m < n) throw "Need more rows than columns"

      var e = new Array(n);
      var q = new Array(n);
      for (i=0; i<n; i++) e[i] = q[i] = 0.0;
      var v = numeric.rep([n,n],0);
//	v.zero();

      function pythag(a,b)
      {
        a = Math.abs(a);
        b = Math.abs(b);
        if (a > b)
          return a*Math.sqrt(1.0+(b*b/a/a))
        else if (b == 0.0)
          return a
        return b*Math.sqrt(1.0+(a*a/b/b))
      }

      //Householder's reduction to bidiagonal form

      var f= 0.0;
      var g= 0.0;
      var h= 0.0;
      var x= 0.0;
      var y= 0.0;
      var z= 0.0;
      var s= 0.0;

      for (i=0; i < n; i++)
      {
        e[i]= g;
        s= 0.0;
        l= i+1;
        for (j=i; j < m; j++)
          s += (u[j][i]*u[j][i]);
        if (s <= tolerance)
          g= 0.0;
        else
        {
          f= u[i][i];
          g= Math.sqrt(s);
          if (f >= 0.0) g= -g;
          h= f*g-s;
          u[i][i]=f-g;
          for (j=l; j < n; j++)
          {
            s= 0.0;
            for (k=i; k < m; k++)
              s += u[k][i]*u[k][j];
            f= s/h;
            for (k=i; k < m; k++)
              u[k][j]+=f*u[k][i];
          }
        }
        q[i]= g;
        s= 0.0;
        for (j=l; j < n; j++)
          s= s + u[i][j]*u[i][j];
        if (s <= tolerance)
          g= 0.0;
        else
        {
          f= u[i][i+1];
          g= Math.sqrt(s);
          if (f >= 0.0) g= -g;
          h= f*g - s;
          u[i][i+1] = f-g;
          for (j=l; j < n; j++) e[j]= u[i][j]/h;
          for (j=l; j < m; j++)
          {
            s=0.0;
            for (k=l; k < n; k++)
              s += (u[j][k]*u[i][k]);
            for (k=l; k < n; k++)
              u[j][k]+=s*e[k];
          }
        }
        y= Math.abs(q[i])+Math.abs(e[i]);
        if (y>x)
          x=y;
      }

      // accumulation of right hand gtransformations
      for (i=n-1; i != -1; i+= -1)
      {
        if (g != 0.0)
        {
          h= g*u[i][i+1];
          for (j=l; j < n; j++)
            v[j][i]=u[i][j]/h;
          for (j=l; j < n; j++)
          {
            s=0.0;
            for (k=l; k < n; k++)
              s += u[i][k]*v[k][j];
            for (k=l; k < n; k++)
              v[k][j]+=(s*v[k][i]);
          }
        }
        for (j=l; j < n; j++)
        {
          v[i][j] = 0;
          v[j][i] = 0;
        }
        v[i][i] = 1;
        g= e[i];
        l= i;
      }

      // accumulation of left hand transformations
      for (i=n-1; i != -1; i+= -1)
      {
        l= i+1;
        g= q[i];
        for (j=l; j < n; j++)
          u[i][j] = 0;
        if (g != 0.0)
        {
          h= u[i][i]*g;
          for (j=l; j < n; j++)
          {
            s=0.0;
            for (k=l; k < m; k++) s += u[k][i]*u[k][j];
            f= s/h;
            for (k=i; k < m; k++) u[k][j]+=f*u[k][i];
          }
          for (j=i; j < m; j++) u[j][i] = u[j][i]/g;
        }
        else
          for (j=i; j < m; j++) u[j][i] = 0;
        u[i][i] += 1;
      }

      // diagonalization of the bidiagonal form
      prec= prec*x;
      for (k=n-1; k != -1; k+= -1)
      {
        for (var iteration=0; iteration < itmax; iteration++)
        {	// test f splitting
          var test_convergence = false;
          for (l=k; l != -1; l+= -1)
          {
            if (Math.abs(e[l]) <= prec)
            {	test_convergence= true;
              break
            }
            if (Math.abs(q[l-1]) <= prec)
              break
          }
          if (!test_convergence)
          {	// cancellation of e[l] if l>0
            c= 0.0;
            s= 1.0;
            var l1= l-1;
            for (i =l; i<k+1; i++)
            {
              f= s*e[i];
              e[i]= c*e[i];
              if (Math.abs(f) <= prec)
                break
              g= q[i];
              h= pythag(f,g);
              q[i]= h;
              c= g/h;
              s= -f/h;
              for (j=0; j < m; j++)
              {
                y= u[j][l1];
                z= u[j][i];
                u[j][l1] =  y*c+(z*s);
                u[j][i] = -y*s+(z*c);
              }
            }
          }
          // test f convergence
          z= q[k];
          if (l== k)
          {	//convergence
            if (z<0.0)
            {	//q[k] is made non-negative
              q[k]= -z;
              for (j=0; j < n; j++)
                v[j][k] = -v[j][k];
            }
            break  //break out of iteration loop and move on to next k value
          }
          if (iteration >= itmax-1)
            throw 'Error: no convergence.'
          // shift from bottom 2x2 minor
          x= q[l];
          y= q[k-1];
          g= e[k-1];
          h= e[k];
          f= ((y-z)*(y+z)+(g-h)*(g+h))/(2.0*h*y);
          g= pythag(f,1.0);
          if (f < 0.0)
            f= ((x-z)*(x+z)+h*(y/(f-g)-h))/x;
          else
            f= ((x-z)*(x+z)+h*(y/(f+g)-h))/x;
          // next QR transformation
          c= 1.0;
          s= 1.0;
          for (i=l+1; i< k+1; i++)
          {
            g= e[i];
            y= q[i];
            h= s*g;
            g= c*g;
            z= pythag(f,h);
            e[i-1]= z;
            c= f/z;
            s= h/z;
            f= x*c+g*s;
            g= -x*s+g*c;
            h= y*s;
            y= y*c;
            for (j=0; j < n; j++)
            {
              x= v[j][i-1];
              z= v[j][i];
              v[j][i-1] = x*c+z*s;
              v[j][i] = -x*s+z*c;
            }
            z= pythag(f,h);
            q[i-1]= z;
            c= f/z;
            s= h/z;
            f= c*g+s*y;
            x= -s*g+c*y;
            for (j=0; j < m; j++)
            {
              y= u[j][i-1];
              z= u[j][i];
              u[j][i-1] = y*c+z*s;
              u[j][i] = -y*s+z*c;
            }
          }
          e[l]= 0.0;
          e[k]= f;
          q[k]= x;
        }
      }

      //vt= transpose(v)
      //return (u,q,vt)
      for (i=0;i<q.length; i++)
        if (q[i] < prec) q[i] = 0;

      //sort eigenvalues
      for (i=0; i< n; i++)
      {
        //writeln(q)
        for (j=i-1; j >= 0; j--)
        {
          if (q[j] < q[i])
          {
            //  writeln(i,'-',j)
            c = q[j];
            q[j] = q[i];
            q[i] = c;
            for(k=0;k<u.length;k++) { temp = u[k][i]; u[k][i] = u[k][j]; u[k][j] = temp; }
            for(k=0;k<v.length;k++) { temp = v[k][i]; v[k][i] = v[k][j]; v[k][j] = temp; }
//	   u.swapCols(i,j)
//	   v.swapCols(i,j)
            i = j;
          }
        }
      }

      return {U:u,S:q,V:v}
    };
  });

  var performanceNow = createCommonjsModule(function (module) {
// Generated by CoffeeScript 1.12.2
    (function() {
      var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

      if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
        module.exports = function() {
          return performance.now();
        };
      } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
        module.exports = function() {
          return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = process.hrtime;
        getNanoSeconds = function() {
          var hr;
          hr = hrtime();
          return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = process.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
      } else if (Date.now) {
        module.exports = function() {
          return Date.now() - loadTime;
        };
        loadTime = Date.now();
      } else {
        module.exports = function() {
          return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
      }

    }).call(commonjsGlobal);


  });

  var root = typeof window === 'undefined' ? commonjsGlobal : window;
  var vendors = ['moz', 'webkit'];
  var suffix = 'AnimationFrame';
  var raf = root['request' + suffix];
  var caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

  for(var i = 0; !raf && i < vendors.length; i++) {
    raf = root[vendors[i] + 'Request' + suffix];
    caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix];
  }

// Some versions of FF have rAF but not cAF
  if(!raf || !caf) {
    var last = 0
      , id = 0
      , queue = []
      , frameDuration = 1000 / 60;

    raf = function(callback) {
      if(queue.length === 0) {
        var _now = performanceNow()
          , next = Math.max(0, frameDuration - (_now - last));
        last = next + _now;
        setTimeout(function() {
          var cp = queue.slice(0);
          // Clear queue here to prevent
          // callbacks from appending listeners
          // to the current frame's queue
          queue.length = 0;
          for(var i = 0; i < cp.length; i++) {
            if(!cp[i].cancelled) {
              try{
                cp[i].callback(last);
              } catch(e) {
                setTimeout(function() { throw e }, 0);
              }
            }
          }
        }, Math.round(next));
      }
      queue.push({
        handle: ++id,
        callback: callback,
        cancelled: false
      });
      return id
    };

    caf = function(handle) {
      for(var i = 0; i < queue.length; i++) {
        if(queue[i].handle === handle) {
          queue[i].cancelled = true;
        }
      }
    };
  }

  var raf_1 = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return raf.call(root, fn)
  };
  var cancel = function() {
    caf.apply(root, arguments);
  };
  var polyfill = function(object) {
    if (!object) {
      object = root;
    }
    object.requestAnimationFrame = raf;
    object.cancelAnimationFrame = caf;
  };

  raf_1.cancel = cancel;
  raf_1.polyfill = polyfill;

  var promise = createCommonjsModule(function (module) {
    (function (root) {

      // Store setTimeout reference so promise-polyfill will be unaffected by
      // other code modifying setTimeout (like sinon.useFakeTimers())
      var setTimeoutFunc = setTimeout;

      function noop() {}

      // Polyfill for Function.prototype.bind
      function bind(fn, thisArg) {
        return function () {
          fn.apply(thisArg, arguments);
        };
      }

      function Promise(fn) {
        if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
        if (typeof fn !== 'function') throw new TypeError('not a function');
        this._state = 0;
        this._handled = false;
        this._value = undefined;
        this._deferreds = [];

        doResolve(fn, this);
      }

      function handle(self, deferred) {
        while (self._state === 3) {
          self = self._value;
        }
        if (self._state === 0) {
          self._deferreds.push(deferred);
          return;
        }
        self._handled = true;
        Promise._immediateFn(function () {
          var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
          if (cb === null) {
            (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
            return;
          }
          var ret;
          try {
            ret = cb(self._value);
          } catch (e) {
            reject(deferred.promise, e);
            return;
          }
          resolve(deferred.promise, ret);
        });
      }

      function resolve(self, newValue) {
        try {
          // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
          if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
          if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof Promise) {
              self._state = 3;
              self._value = newValue;
              finale(self);
              return;
            } else if (typeof then === 'function') {
              doResolve(bind(then, newValue), self);
              return;
            }
          }
          self._state = 1;
          self._value = newValue;
          finale(self);
        } catch (e) {
          reject(self, e);
        }
      }

      function reject(self, newValue) {
        self._state = 2;
        self._value = newValue;
        finale(self);
      }

      function finale(self) {
        if (self._state === 2 && self._deferreds.length === 0) {
          Promise._immediateFn(function() {
            if (!self._handled) {
              Promise._unhandledRejectionFn(self._value);
            }
          });
        }

        for (var i = 0, len = self._deferreds.length; i < len; i++) {
          handle(self, self._deferreds[i]);
        }
        self._deferreds = null;
      }

      function Handler(onFulfilled, onRejected, promise) {
        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
        this.promise = promise;
      }

      /**
       * Take a potentially misbehaving resolver function and make sure
       * onFulfilled and onRejected are only called once.
       *
       * Makes no guarantees about asynchrony.
       */
      function doResolve(fn, self) {
        var done = false;
        try {
          fn(function (value) {
            if (done) return;
            done = true;
            resolve(self, value);
          }, function (reason) {
            if (done) return;
            done = true;
            reject(self, reason);
          });
        } catch (ex) {
          if (done) return;
          done = true;
          reject(self, ex);
        }
      }

      Promise.prototype['catch'] = function (onRejected) {
        return this.then(null, onRejected);
      };

      Promise.prototype.then = function (onFulfilled, onRejected) {
        var prom = new (this.constructor)(noop);

        handle(this, new Handler(onFulfilled, onRejected, prom));
        return prom;
      };

      Promise.all = function (arr) {
        return new Promise(function (resolve, reject) {
          if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
          var args = Array.prototype.slice.call(arr);
          if (args.length === 0) return resolve([]);
          var remaining = args.length;

          function res(i, val) {
            try {
              if (val && (typeof val === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                  then.call(val, function (val) {
                    res(i, val);
                  }, reject);
                  return;
                }
              }
              args[i] = val;
              if (--remaining === 0) {
                resolve(args);
              }
            } catch (ex) {
              reject(ex);
            }
          }

          for (var i = 0; i < args.length; i++) {
            res(i, args[i]);
          }
        });
      };

      Promise.resolve = function (value) {
        if (value && typeof value === 'object' && value.constructor === Promise) {
          return value;
        }

        return new Promise(function (resolve) {
          resolve(value);
        });
      };

      Promise.reject = function (value) {
        return new Promise(function (resolve, reject) {
          reject(value);
        });
      };

      Promise.race = function (values) {
        return new Promise(function (resolve, reject) {
          for (var i = 0, len = values.length; i < len; i++) {
            values[i].then(resolve, reject);
          }
        });
      };

      // Use polyfill for setImmediate for performance gains
      Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
        function (fn) {
          setTimeoutFunc(fn, 0);
        };

      Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
        if (typeof console !== 'undefined' && console) {
          console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
        }
      };

      /**
       * Set the immediate function to execute callbacks
       * @param fn {function} Function to execute
       * @deprecated
       */
      Promise._setImmediateFn = function _setImmediateFn(fn) {
        Promise._immediateFn = fn;
      };

      /**
       * Change the function to execute on unhandled rejection
       * @param {function} fn Function to execute on unhandled rejection
       * @deprecated
       */
      Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
        Promise._unhandledRejectionFn = fn;
      };

      if ('object' !== 'undefined' && module.exports) {
        module.exports = Promise;
      } else if (!root.Promise) {
        root.Promise = Promise;
      }

    })(commonjsGlobal);
  });

// IE polyfill from MDN
  (function () {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent (event, params) {
      params = params || {bubbles : false, cancelable : false, detail: undefined};
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
  })();

  function emitEvent(eventName, dispatcher) {
    dispatcher = angular.isUndefined(dispatcher) ? document : dispatcher;
    var evt = new CustomEvent(eventName, {'bubbles': true, 'cancelable': true});
    dispatcher.dispatchEvent(evt);
  }

  /**
   * Fast Fourier Transform
   * 1D-FFT/IFFT, 2D-FFT/IFFT (radix-2)
   *
   * @author ryo / github.com/wellflat
   * Based on https://github.com/wellflat/jslib with some tiny optimizations
   */

  function FFT() {

    var _n = 0,          // order
      _bitrev = null,  // bit reversal table
      _cstb = null;    // sin/cos table
    var _tre, _tim;

    this.init = function (n) {
      if(n !== 0 && (n & (n - 1)) === 0) {
        _n = n;
        _setVariables();
        _makeBitReversal();
        _makeCosSinTable();
      } else {
        throw new Error("init: radix-2 required");
      }
    };

    // 1D-FFT
    this.fft1d = function (re, im) {
      fft(re, im, 1);
    };

    // 1D-IFFT
    this.ifft1d = function (re, im) {
      var n = 1/_n;
      fft(re, im, -1);
      for(var i=0; i<_n; i++) {
        re[i] *= n;
        im[i] *= n;
      }
    };

    // 2D-FFT
    this.fft2d = function (re, im) {
      var i = 0;
      // x-axis
      for(var y=0; y<_n; y++) {
        i = y*_n;
        for(var x1=0; x1<_n; x1++) {
          _tre[x1] = re[x1 + i];
          _tim[x1] = im[x1 + i];
        }
        this.fft1d(_tre, _tim);
        for(var x2=0; x2<_n; x2++) {
          re[x2 + i] = _tre[x2];
          im[x2 + i] = _tim[x2];
        }
      }
      // y-axis
      for(var x=0; x<_n; x++) {
        for(var y1=0; y1<_n; y1++) {
          i = x + y1*_n;
          _tre[y1] = re[i];
          _tim[y1] = im[i];
        }
        this.fft1d(_tre, _tim);
        for(var y2=0; y2<_n; y2++) {
          i = x + y2*_n;
          re[i] = _tre[y2];
          im[i] = _tim[y2];
        }
      }
    };

    // 2D-IFFT
    this.ifft2d = function (re, im) {
      var i = 0;
      // x-axis
      for(var y=0; y<_n; y++) {
        i = y*_n;
        for(var x1=0; x1<_n; x1++) {
          _tre[x1] = re[x1 + i];
          _tim[x1] = im[x1 + i];
        }
        this.ifft1d(_tre, _tim);
        for(var x2=0; x2<_n; x2++) {
          re[x2 + i] = _tre[x2];
          im[x2 + i] = _tim[x2];
        }
      }
      // y-axis
      for(var x=0; x<_n; x++) {
        for(var y1=0; y1<_n; y1++) {
          i = x + y1*_n;
          _tre[y1] = re[i];
          _tim[y1] = im[i];
        }
        this.ifft1d(_tre, _tim);
        for(var y2=0; y2<_n; y2++) {
          i = x + y2*_n;
          re[i] = _tre[y2];
          im[i] = _tim[y2];
        }
      }
    };

    // core operation of FFT
    function fft(re, im, inv) {
      var d, h, ik, m, tmp, wr, wi, xr, xi,
        n4 = _n >> 2;
      // bit reversal
      for(var l=0; l<_n; l++) {
        m = _bitrev[l];
        if(l < m) {
          tmp = re[l];
          re[l] = re[m];
          re[m] = tmp;
          tmp = im[l];
          im[l] = im[m];
          im[m] = tmp;
        }
      }
      // butterfly operation
      for(var k=1; k<_n; k<<=1) {
        h = 0;
        d = _n/(k << 1);
        for(var j=0; j<k; j++) {
          wr = _cstb[h + n4];
          wi = inv*_cstb[h];
          for(var i=j; i<_n; i+=(k<<1)) {
            ik = i + k;
            xr = wr*re[ik] + wi*im[ik];
            xi = wr*im[ik] - wi*re[ik];
            re[ik] = re[i] - xr;
            re[i] += xr;
            im[ik] = im[i] - xi;
            im[i] += xi;
          }
          h += d;
        }
      }
    }

    // set variables
    function _setVariables() {
      if(typeof Uint8Array !== 'undefined') {
        _bitrev = new Uint8Array(_n);
      } else {
        _bitrev = new Array(_n);
      }
      if(typeof Float64Array !== 'undefined') {
        _cstb = new Float64Array(_n*1.25);
        _tre = new Float64Array(_n*_n);
        _tim = new Float64Array(_n*_n);
      } else {
        _cstb = new Array(_n*1.25);
        _tre = new Array(_n*_n);
        _tim = new Array(_n*_n);
      }
    }

    // make bit reversal table
    function _makeBitReversal() {
      var i = 0,
        j = 0,
        k = 0;
      _bitrev[0] = 0;
      while(++i < _n) {
        k = _n >> 1;
        while(k <= j) {
          j -= k;
          k >>= 1;
        }
        j += k;
        _bitrev[i] = j;
      }
    }

    // make trigonometric function table
    function _makeCosSinTable() {
      var n2 = _n >> 1,
        n4 = _n >> 2,
        n8 = _n >> 3,
        n2p4 = n2 + n4,
        t = Math.sin(Math.PI/_n),
        dc = 2*t*t,
        ds = Math.sqrt(dc*(2 - dc)),
        c = _cstb[n4] = 1,
        s = _cstb[0] = 0;
      t = 2*dc;
      for(var i=1; i<n8; i++) {
        c -= dc;
        dc += t*c;
        s += ds;
        ds -= t*s;
        _cstb[i] = s;
        _cstb[n4 - i] = c;
      }
      if(n8 !== 0) {
        _cstb[n8] = Math.sqrt(0.5);
      }
      for(var j=0; j<n4; j++) {
        _cstb[n2 - j]  = _cstb[j];
      }
      for(var k=0; k<n2p4; k++) {
        _cstb[k + n2] = -_cstb[k];
      }
    }
  }

  var left_eye_filter = {"real": [1.5419219943717721, 0.40010880110578706, -0.79043641265342957, -1.2685464969238938, 0.39878117336167285, -1.0673489992245377, -0.079880838229404019, -0.45374680224191505, -0.043474097938900787, -0.31125662385352687, 0.17092430376098702, -0.29613086164846153, 0.5616469648110296, -1.559786848789493, 0.64513037997492662, -1.2899747976234162, 1.1761667998175334, -1.2899747976233551, 0.64513037997490474, -1.5597868487894897, 0.56164696481102505, -0.29613086164845964, 0.17092430376099094, -0.31125662385352959, -0.043474097938900787, -0.45374680224191177, -0.079880838229404658, -1.0673489992245357, 0.39878117336167307, -1.2685464969238942, -0.79043641265343012, 0.40010880110578717, -1.3820969331049027, 0.069560471269205768, -1.9786339579213206, -1.9807415717551982, -0.78667274410450883, -1.2217002325587256, -0.19150029104902774, -0.35131617290773243, -0.17646388464205803, -0.16672095020503441, -0.092298612924566523, -0.028899376452253527, -0.1314555696102146, -0.32892265898101813, -0.40987148655061206, 0.11741827111366547, -0.67254330182605138, -0.46007833291519956, -0.67215259521101001, -0.44871907432473013, -0.034749316729184583, 0.0055639281302433969, -0.17675902360981591, -0.26196208085032191, -0.36301254306387037, -0.33546767337818123, -0.6458889740799838, -1.1981932989987978, 0.12372650763830917, -1.4996172161865935, -2.4084298023013888, -2.0505291279591722, -1.7249706159518585, -2.277646289702639, -3.1259631743419591, -2.9656385065342015, -2.8480835086962011, -1.4260964500310189, -0.61792590829173544, -0.2611655301498782, -0.38519889843539723, -0.17511899827006483, -0.32808050503227176, 0.0076800871037463036, -0.18710828510427668, 0.1976534820339281, -0.55444453100465052, 0.14583567590328381, -0.69844971117515287, -0.90188577233526623, -0.53500016384583371, -0.044420751861669799, 0.014727914354086128, -0.28084584584371913, -0.29890408748685848, -0.39431380149336548, -0.39569215798819307, -0.74351999988258299, -0.82502198370631752, -1.851491897104155, -0.74302378668934244, 0.21156442062863762, -3.3061472495599986, -1.7990472945779568, -2.2193764251732282, -2.3438802466919251, -3.3615971067123311, -3.5383249085863708, -2.2639673745086588, -2.0271757806780748, -0.75242583405872232, -0.30143411016839378, -0.3625272253546275, -0.25489431004647689, -0.18928491561467081, -0.1179891518538482, 0.027920290231533224, -0.035472107498143821, -0.29008721857562259, -0.3604588674139817, -0.39156143807433802, -0.82222257402876564, -0.44979914971695928, -0.098136330355476253, 0.065628582466229365, -0.33607304327303128, -0.32161201323497779, -0.41856090178723965, -0.64028425429629054, -0.7766428172010218, -1.3946448661671447, -2.2603422126144683, -0.38769722219534525, -0.95341593939478653, -1.412952994959813, -2.3602336858020432, -1.2756392437278019, -2.0983496132652038, -2.5682454610054268, -2.8791053946930378, -2.1809972632688095, -0.84281293847776861, -0.75998936793718697, -0.18584599820380068, -0.30105748355308259, -0.16098142942852958, -0.13792125740417191, -0.089790022871128708, -0.12321821342876504, -0.1128661923016878, -0.3924098378001975, -0.5780902167586397, -0.48685989567066695, -0.53565359443296234, -0.051036689850526382, -0.0068547033925117689, -0.18963405157839419, -0.22514761090777807, -0.35555823460888908, -0.46670603976585517, -0.56179541485257889, -0.7495095888115163, -1.4772075422260349, -1.5836466114968029, -2.3846549454186694, -1.4884613952536236, -1.8237453905245253, -1.6712324532934877, -1.5169157844507295, -1.6930052820597281, -2.1023566589276004, -2.2062031109308458, -1.7945281756942255, -0.26457398838912649, 0.22038139379151148, -0.43479836723775234, -0.19830827357221226, -0.18018565146479498, -0.097060879184795737, -0.10088329756370379, -0.063069709957272527, -0.17970932516041177, -0.1943040732581543, -0.37970560392277619, -0.47302301606251812, -0.30366967948052181, -0.064732391018915397, -0.08902516330269715, -0.082000200083027344, -0.22965854401457736, -0.32035624605031326, -0.31836783196552437, -0.40132058236311119, -0.65601747033470859, -0.59040483751417483, -1.8503084663080034, -1.8694842425148914, -1.9326778896298584, -1.6301578422923519, -1.4332006785118301, -1.305707665299106, -1.364200787821644, -1.5357935460809622, -1.6161992336951241, -0.74003518668370516, -0.29423824173210689, 0.025934598230976654, -0.043349004411304674, -0.25408021803022468, -0.066965686484977499, -0.075717498698635255, 0.007057189465364498, -0.042171356658338113, -0.036938315661768008, -0.34221561581756049, -0.20400167508805764, -0.37417116097079772, -0.25039909487805356, -0.070874531394524931, -0.0569972852039487, -0.067238206950403182, -0.17397285212300442, -0.20428337307808273, -0.23651154356493315, -0.33356498933276568, -0.07339749754226077, -0.70367959806681601, -0.82403680021595049, -1.6058616381755235, -1.6192427030685497, -1.5705638815427956, -1.4659201063980019, -0.95504179549951018, -0.97237526162739873, -1.0460191987834688, -0.91465668941265721, -0.60548232361398524, 0.01898438364933451, -0.19419044456729498, -0.039627851124307223, 0.0012357796666701798, -0.078110822445325079, 0.0048626364920250518, -0.040449089662379589, -0.0035054269587873454, -0.13387544724730729, -0.10031131456276647, -0.25968674675684189, -0.20555329767005767, -0.26509289948725284, -0.038788452621647145, -0.076999891872251258, -0.071661433038976499, -0.14182240789719938, -0.1654673053291095, -0.19859450279267193, -0.053382326365810369, -0.2156585383674445, -0.045097357284793499, -0.62449818579949512, -0.92624906744917224, -1.0411254782363617, -1.122035196738675, -1.0607692164246043, -0.57723811773534028, -0.63187735896388075, -0.54813311204421922, -0.55320252101738743, -0.30197299587482401, -0.047213249757838388, 0.082808930467383288, -0.067715134483222431, -0.01022881748368659, 0.042038311258956552, -0.063371767399980669, 0.029161890169972702, -0.091396316586836127, -0.0034600735070754811, -0.12424052925006424, -0.24432996418012101, -0.26521664175359499, -0.22745980283820413, -0.14361316535317664, -0.00075904203100577935, -0.020936168457862139, -0.14205665196423617, -0.19024248288823023, -0.079686122362245204, -0.15016133237735926, 0.049598910651295514, -0.11760486834511712, -0.1837522251545049, -0.38594205494114608, -0.53542516436999843, -0.57340991730807989, -0.52753621424018138, -0.23151163972118355, -0.22295096919949259, -0.33704349161770436, -0.26165852514054583, -0.13898866968588663, 0.034596483191139484, -0.012631210076789067, 0.047371310076345617, -0.038651839330751551, -0.0019970761454430018, 0.063048845258375494, -0.1124891762554399, 0.08556992539656616, -0.21043659051868199, -0.19223333969456, -0.39082994830035861, -0.19294368007162721, -0.41025595439938572, -0.17178084419175166, -0.010933041190555012, -0.089512936152074493, -0.21569610281495066, -0.09144756671688016, -0.19525258909505316, -0.029753598134641936, -0.021307245660079924, 0.029087127940551009, 0.037511290653097842, -0.20600990120705839, -0.26967580750352926, -0.21000923681194664, -0.28209018858285628, -0.11925518789339556, -0.24869348141289982, -0.21025892926356746, -0.15567029136726124, -0.040546729108395907, -0.0050266153100547101, 0.030710887069787196, -0.0061104340245858278, 0.0369376092260571, -0.054862661367900321, 0.013297880203253048, 0.19659447375886394, -0.2499491329142558, -0.062959699002865757, -0.53055029095956008, -0.38784811281629444, -0.53891285075962392, -0.41886712861154285, -0.099230097260325875, -0.16474199810952628, -0.28693665642627014, -0.0095667980850221105, -0.32619954993450928, -0.08627491478166284, -0.073253161755714766, 0.015634174038690329, 0.082440536547531792, 0.025411878261881942, -0.11318909242737961, -0.1270560226842935, -0.21657212936164139, -0.13993873549611191, -0.37510275237622831, -0.26472923111076219, -0.24460131567533192, -0.14127652303494026, -0.050428686591045178, 0.041347840374190772, -0.0061780445153000636, 0.0073990345210250153, -0.014062739037014381, 0.14348925152561878, -0.015321787554403667, 0.0017746672356015968, 0.25165135427361052, -0.626463828190993, -0.48167134330805639, -1.045863293770664, -0.69512591788493194, -0.44532127384388254, -0.28479724025368391, -0.39470955087317983, 0.20227228344720469, -0.53909912073488953, -0.12025629051789474, -0.1899243750597305, -0.048474806721595133, 0.060764771353227762, 0.090648151782516159, 0.091608208912697275, 0.0036582478916540977, -0.22492530005263131, -0.27295314658024766, -0.35559738025257359, -0.62902925014412947, -0.57166411974881004, -0.37258895173129181, -0.22157638610464933, 0.022494427132080854, 0.014769425415166171, 0.003526808789406817, -0.011346909674078769, 0.050921170848348289, 0.090308541799219627, 0.37260817254533324, -0.25909871392159911, -0.42379280974334355, -0.095380647808568128, -1.1906083748893519, -0.78599914414892469, -0.95277914352730275, -0.63659778359422337, -0.98026015008952749, 0.48173198285916102, -0.60092009018055192, -0.10265418316164113, -0.39913639006279306, -0.17310908908773887, -0.0194191171632387, 0.054047965289179878, 0.1388529643463832, 0.15661099050145999, -0.10898263774416243, -0.33291231456737602, -0.59569027865888713, -0.69353081584948972, -1.0999707493347484, -0.74392084753736687, -0.49074781214158159, -0.065190556733852961, 0.012289768389229717, 0.024577513704595676, 0.0040302804696096322, 0.036047756292976456, 0.058236765637246286, 0.13893846256790621, 0.036944676036934632, 0.41686279554239464, -0.85232286388185818, -1.2988315127624981, -0.47352779677305168, -0.81763632541546793, -0.77384457803621831, -1.4256240004519281, 0.52588993532360684, -0.89821724022902683, 0.1591911967653899, -0.55046596772346867, -0.30980016041271019, -0.16709614007114884, -0.046029700131955266, 0.044793268150423983, 0.1689242242845459, 0.14412365934528507, -0.0088250071313367359, -0.36778545124666312, -0.79393844517732104, -1.1610479066529615, -0.76523210008850662, -0.63009858032048405, -0.13947023057344932, -0.017173105577524262, 0.039030007688455846, 0.014491273083805401, 0.039792542943837252, 0.054072846696920814, 0.11729310469925348, 0.053609281522667675, 0.0081549498718087084, -0.30910813452845548, 0.25944224899607843, -1.3584842180322938, -1.5885570490138659, -0.65759582794618221, -1.139869490652734, 0.70928264080594694, -1.9674198903133462, 0.37712664425406606, -0.84336038390578949, -0.47788074719428036, -0.18342000086663721, -0.18811394573901796, -0.055050027645985648, 0.045043056834335606, 0.11486303559854361, 0.22023958716404868, 0.14735402009444676, -0.27894427087197998, -0.73080536953129638, -0.76794305693297227, -0.37355919765840223, 0.12353986794322802, 0.090505348376311842, 0.14069908672094206, 0.087373214380278855, 0.023353946735568523, 0.031400559920396587, 0.079550230446202241, 0.084927161382185437, 0.040777158255349423, -0.16274954314482293, -0.41184413435479567, -0.71871288822574875, 0.55302907456342854, -1.5309493464500674, -2.9026104205694736, 0.42043303599508353, -1.7138106264793671, 0.29513888249127102, -1.2517216433630918, -0.66769942176516839, -0.28576739334390183, -0.24127777006787937, -0.10778095858902549, -0.036092425009198861, 0.021519213385077923, 0.13414694961717147, 0.16917378957839613, 0.17307922682581758, 0.076246758829015673, -0.047904835134272621, -0.27544262702406924, 0.61826249566563185, 0.26987423123693399, 0.2085883517320696, 0.26073426210721973, 0.12070625812911842, 0.062945582093309679, 0.083649573916505432, 0.049688095345785867, 0.019564357607843069, -0.046035817476596949, -0.13409074070830324, -0.49027201814294552, -0.47756457321420159, -0.74403675135427549, -0.3080068432033089, -0.043712438842705037, -4.735594317158907, -0.043712438842706695, -0.30800684320330962, -0.74403675135427572, -0.47756457321420304, -0.49027201814294813, -0.13409074070830412, -0.046035817476598156, 0.019564357607843069, 0.049688095345786006, 0.083649573916506056, 0.062945582093310845, 0.12070625812911921, 0.26073426210722073, 0.20858835173207019, 0.26987423123693399, -0.37355919765836759, -0.27544262702403433, -0.047904835134273127, 0.076246758829012523, 0.17307922682581853, 0.16917378957839499, 0.13414694961716844, 0.02151921338507657, -0.036092425009199861, -0.1077809585890261, -0.24127777006787943, -0.2857673933439015, -0.66769942176516905, -1.2517216433630949, 0.29513888249127429, -1.7138106264793713, 0.42043303599507681, -2.902610420569474, -1.5309493464500692, 0.55302907456342232, -0.71871288822575019, -0.41184413435479833, -0.16274954314482265, 0.04077715825534866, 0.08492716138218645, 0.079550230446203143, 0.031400559920398419, 0.023353946735571576, 0.08737321438028138, 0.14069908672095732, 0.090505348376334033, 0.1235398679432393, -0.76523210008847808, -0.76794305693296139, -0.73080536953128505, -0.27894427087197604, 0.1473540200944477, 0.22023958716404682, 0.11486303559854165, 0.045043056834333829, -0.055050027645986453, -0.18811394573901843, -0.18342000086663854, -0.47788074719428042, -0.84336038390579149, 0.37712664425406617, -1.9674198903133469, 0.70928264080593695, -1.1398694906527307, -0.65759582794619398, -1.588557049013867, -1.3584842180322987, 0.25944224899607732, -0.30910813452845781, 0.0081549498718086911, 0.053609281522667279, 0.11729310469925426, 0.054072846696921202, 0.039792542943838709, 0.014491273083807311, 0.039030007688458185, -0.017173105577517028, -0.13947023057343994, -0.63009858032045107, -1.0999707493347308, -1.1610479066529467, -0.79393844517731305, -0.3677854512466584, -0.0088250071313340107, 0.14412365934528559, 0.16892422428454401, 0.044793268150420118, -0.046029700131956147, -0.16709614007115095, -0.30980016041271097, -0.55046596772347045, 0.15919119676539073, -0.8982172402290286, 0.52588993532360329, -1.4256240004519327, -0.77384457803621687, -0.8176363254154656, -0.47352779677305679, -1.2988315127625027, -0.85232286388185829, 0.41686279554239525, 0.036944676036935756, 0.13893846256790574, 0.058236765637246675, 0.036047756292977066, 0.0040302804696111128, 0.02457751370459911, 0.012289768389232913, -0.065190556733844662, -0.49074781214156804, -0.74392084753735632, -0.62902925014412903, -0.69353081584948562, -0.59569027865888302, -0.33291231456737491, -0.10898263774416028, 0.15661099050145985, 0.13885296434638142, 0.054047965289177706, -0.019419117163239467, -0.17310908908773912, -0.39913639006279433, -0.10265418316163986, -0.60092009018055315, 0.48173198285915786, -0.98026015008952594, -0.63659778359422126, -0.9527791435273002, -0.78599914414892458, -1.190608374889349, -0.095380647808570002, -0.42379280974334488, -0.25909871392159683, 0.37260817254533357, 0.09030854179921953, 0.050921170848348372, -0.011346909674079158, 0.0035268087894081549, 0.014769425415168456, 0.022494427132082863, -0.22157638610464575, -0.37258895173129003, -0.5716641197488066, -0.37510275237622537, -0.35559738025257059, -0.27295314658024672, -0.22492530005262792, 0.0036582478916564426, 0.091608208912696387, 0.090648151782514966, 0.060764771353224882, -0.048474806721595647, -0.18992437505973167, -0.12025629051789351, -0.53909912073488875, 0.20227228344720258, -0.39470955087317799, -0.28479724025368247, -0.44532127384387832, -0.69512591788493272, -1.04586329377066, -0.48167134330805861, -0.62646382819099156, 0.25165135427361029, 0.0017746672356018336, -0.0153217875544032, 0.14348925152561842, -0.01406273903701487, 0.0073990345210243587, -0.0061780445152985596, 0.04134784037419488, -0.050428686591041855, -0.1412765230349349, -0.2446013156753272, -0.26472923111076024, -0.11925518789339257, -0.13993873549610955, -0.21657212936163839, -0.1270560226842922, -0.11318909242737903, 0.025411878261882927, 0.082440536547530169, 0.015634174038688685, -0.073253161755715501, -0.086274914781661965, -0.326199549934509, -0.0095667980850238903, -0.28693665642627003, -0.16474199810952764, -0.099230097260324029, -0.41886712861154318, -0.53891285075962314, -0.38784811281629461, -0.53055029095956219, -0.062959699002866631, -0.24994913291425488, 0.1965944737588636, 0.013297880203252755, -0.054862661367901897, 0.036937609226056677, -0.0061104340245862225, 0.030710887069788338, -0.005026615310052167, -0.040546729108393256, -0.15567029136725916, -0.21025892926356554, -0.24869348141289621, -0.23151163972117689, -0.28209018858284918, -0.21000923681193823, -0.26967580750352416, -0.20600990120705304, 0.037511290653099091, 0.029087127940549885, -0.02130724566008323, -0.029753598134642099, -0.19525258909505444, -0.091447566716882075, -0.21569610281495041, -0.089512936152075853, -0.010933041190555782, -0.17178084419175305, -0.41025595439938806, -0.19294368007162768, -0.39082994830036216, -0.19223333969456258, -0.21043659051868269, 0.085569925396567076, -0.11248917625543933, 0.063048845258374231, -0.0019970761454456269, -0.038651839330752197, 0.047371310076345617, -0.012631210076786959, 0.034596483191142599, -0.13898866968588444, -0.26165852514053983, -0.33704349161769737, -0.22295096919948695, -0.57723811773534028, -0.52753621424018138, -0.57340991730807944, -0.53542516436999865, -0.38594205494114614, -0.1837522251545064, -0.11760486834511884, 0.049598910651293758, -0.15016133237735926, -0.07968612236224891, -0.1902424828882312, -0.14205665196423831, -0.020936168457862579, -0.00075904203100844866, -0.14361316535317845, -0.2274598028382093, -0.26521664175359499, -0.24432996418012529, -0.12424052925006639, -0.0034600735070760831, -0.09139631658683596, 0.029161890169972428, -0.063371767399980516, 0.042038311258955005, -0.01022881748368659, -0.067715134483221959, 0.082808930467383746, -0.047213249757837236, -0.3019729958748239, -0.55320252101738743, -0.548133112044219, -0.63187735896388053, -0.95504179549950285, -1.060769216424599, -1.1220351967386673, -1.0411254782363524, -0.92624906744916458, -0.62449818579949246, -0.045097357284792555, -0.21565853836744897, -0.053382326365811708, -0.19859450279267432, -0.16546730532911214, -0.14182240789720132, -0.07166143303897729, -0.076999891872253062, -0.038788452621649434, -0.2650928994872585, -0.20555329767005678, -0.25968674675684078, -0.10031131456276626, -0.13387544724730568, -0.0035054269587865765, -0.040449089662379971, 0.0048626364920241281, -0.078110822445325467, 0.0012357796666695618, -0.039627851124306598, -0.19419044456729473, 0.018984383649339364, -0.60548232361397991, -0.91465668941264988, -1.0460191987834631, -0.97237526162739263, -1.3057076652991049, -1.4659201063979992, -1.5705638815427927, -1.6192427030685486, -1.6058616381755215, -0.82403680021595249, -0.70367959806681868, -0.073397497542269388, -0.33356498933276529, -0.23651154356493967, -0.2042833730780847, -0.17397285212300875, -0.067238206950403417, -0.056997285203952995, -0.070874531394526111, -0.25039909487805306, -0.37417116097079761, -0.20400167508805389, -0.34221561581755761, -0.036938315661763657, -0.042171356658337315, 0.0070571894653653896, -0.075717498698634964, -0.066965686484977194, -0.25408021803022474, -0.043349004411301621, 0.025934598230977574, -0.29423824173210122, -0.74003518668370272, -1.6161992336951192, -1.5357935460809593, -1.3642007878216427, -1.5169157844507262, -1.4332006785118279, -1.6301578422923491, -1.932677889629856, -1.8694842425148879, -1.8503084663080056, -0.59040483751417916, -0.65601747033471336, -0.40132058236311047, -0.31836783196552787, -0.32035624605031593, -0.22965854401457814, -0.082000200083028219, -0.089025163302698024, -0.064732391018913552, -0.30366967948051288, -0.4730230160625184, -0.37970560392275871, -0.19430407325814622, -0.1797093251603995, -0.063069709957271444, -0.10088329756370083, -0.097060879184794432, -0.18018565146479387, -0.19830827357221226, -0.43479836723774673, 0.22038139379151372, -0.26457398838911428, -1.79452817569422, -2.2062031109308391, -2.102356658927595, -1.6930052820597257, -1.2756392437278008, -1.6712324532934884, -1.8237453905245253, -1.4884613952536252, -2.384654945418673, -1.5836466114968115, -1.4772075422260404, -0.74950958881152596, -0.561795414852579, -0.46670603976586306, -0.35555823460889052, -0.22514761090777982, -0.18963405157839525, -0.0068547033925124142, -0.051036689850529192, -0.53565359443295624, -0.48685989567066656, -0.57809021675862349, -0.39240983780018618, -0.11286619230167973, -0.12321821342876334, -0.089790022871127112, -0.13792125740417074, -0.16098142942852883, -0.30105748355308298, -0.18584599820379807, -0.75998936793718352, -0.8428129384777584, -2.1809972632688073, -2.8791053946930352, -2.5682454610054237, -2.0983496132652038, -2.219376425173226, -2.3602336858020396, -1.4129529949598048, -0.95341593939478875, -0.38769722219534936, -2.2603422126144772, -1.394644866167148, -0.77664281720103345, -0.64028425429629032, -0.41856090178724664, -0.3216120132349809, -0.33607304327303461, 0.065628582466230781, -0.098136330355478765, -0.44979914971695495, -0.82222257402878096, -0.39156143807433802, -0.36045886741397631, -0.29008721857562392, -0.035472107498135542, 0.027920290231535812, -0.117989151853845, -0.1892849156146684, -0.25489431004647656, -0.3625272253546275, -0.30143411016838906, -0.75242583405872021, -2.0271757806780628, -2.2639673745086539, -3.5383249085863659, -3.361597106712324, -2.3438802466919229, -1.7249706159518579, -1.7990472945779559, -3.3061472495599995, 0.21156442062862166, -0.74302378668934399, -1.8514918971041745, -0.82502198370632651, -0.74351999988260331, -0.39569215798819279, -0.3943138014933833, -0.29890408748686254, -0.28084584584372846, 0.01472791435408881, -0.04442075186168376, -0.53500016384583715, -0.90188577233528688, -0.69844971117515353, 0.14583567590324595, -0.5544445310046473, 0.1976534820339324, -0.18710828510427244, 0.0076800871037496377, -0.32808050503226982, -0.17511899827005836, -0.38519889843539723, -0.26116553014987143, -0.61792590829173255, -1.4260964500310052, -2.8480835086962002, -2.9656385065341997, -3.1259631743419583, -2.2776462897026373, -1.3820969331049018, -2.0505291279591713, -2.4084298023013879, -1.4996172161865962, 0.12372650763830863, -1.1981932989988076, -0.64588897407998824, -0.33546767337818667, -0.36301254306387043, -0.26196208085033179, -0.17675902360982099, 0.0055639281302357606, -0.034749316729180774, -0.44871907432473696, -0.67215259521100923, -0.46007833291523831, -0.67254330182605182, 0.11741827111366224, -0.409871486550618, -0.32892265898101625, -0.13145556961021479, -0.028899376452251727, -0.092298612924564649, -0.16672095020503341, -0.17646388464205828, -0.35131617290772521, -0.19150029104902661, -1.2217002325587201, -0.7866727441045076, -1.9807415717551959, -1.978633957921319, 0.069560471269209931], "bottom": {"real": [4103.3252596935745, 31959.928439656338, 10854.934870050551, 5174.7646941682715, 2670.3793024702013, 1512.8812431609856, 751.72119813508266, 487.34157279751093, 286.27976884850017, 202.21445228809756, 139.363320073941, 96.326676625874271, 67.416513392704019, 55.036039361563731, 42.617455049491909, 37.327841235406673, 35.198800209060273, 37.327841235406588, 42.617455049491802, 55.036039361563766, 67.416513392704019, 96.326676625874285, 139.36332007394108, 202.21445228809804, 286.27976884850017, 487.34157279751093, 751.72119813508289, 1512.8812431609856, 2670.3793024702018, 5174.7646941682751, 10854.934870050551, 31959.928439656363, 12454.694619943468, 7821.5833902765553, 5473.1790170642225, 2925.2286142376206, 1403.2127508507554, 917.05530556073552, 556.73350878905819, 335.58154911349368, 222.7562369115075, 161.71079893305554, 119.4497628246793, 75.609007514321249, 55.496087080936569, 43.998829489125107, 34.725029965122339, 29.983374804996487, 29.187336608781969, 30.714909872552553, 33.135728528562289, 38.780040560556557, 50.11926248444739, 62.426609296740132, 93.916765363567279, 123.96413175241418, 177.16967383039952, 250.50030243800805, 399.94920918463373, 596.1485322845399, 914.24633406931139, 1871.6210271277439, 4518.4223121248042, 13565.815861293135, 16084.742683461694, 10028.519769850123, 2736.2851033168113, 1377.4551350842332, 614.08174831750455, 382.39730464420114, 237.0105878631189, 156.24359018004319, 129.95938769710136, 95.53783206710068, 72.004092864891931, 47.804301653843083, 38.41781199466849, 32.452048622414502, 26.753427300507923, 23.772936248165699, 23.138404805980134, 23.598476471031617, 24.755859033283485, 28.713323989162731, 33.395537201677122, 40.850586549891439, 58.649881806718739, 74.872968711973769, 93.465129226367807, 123.19419955144703, 174.75706127058839, 262.71291650117263, 321.82068054258934, 657.05253635266399, 2163.5932265202309, 10212.960963472207, 3792.0213246064613, 2759.3366542985627, 1627.1011647050395, 788.44977202016776, 362.8509317865861, 253.90720770691448, 163.04342130809295, 117.95146004773997, 90.766106703902594, 66.207745096840526, 48.204553381452804, 35.429206551568903, 28.049881805648454, 23.25027473117818, 20.778936642061399, 19.004228801577, 17.585642163629327, 17.698181326434501, 18.806836162280465, 20.329571180523736, 23.456998427374465, 27.472702254518477, 37.193120035742723, 49.117252584083957, 59.574829012615233, 73.59994664128709, 112.97176733843995, 181.91972084309376, 284.0343016488693, 486.29648203694052, 857.05287855361007, 2037.977143592303, 2057.7285052573056, 2152.5952706253152, 1395.1090523951752, 736.25297680000074, 343.98700964912916, 189.68478304615005, 127.37774106216496, 91.12789293157843, 73.667255133763959, 55.964360327653644, 39.482567042532949, 28.14219415335706, 21.278934963706885, 18.193385040510105, 16.473354788100497, 15.086583853495943, 14.403945056404867, 14.533202056236952, 15.306988390608382, 16.092687824041843, 18.097466979870337, 20.289280537832838, 26.201109009342694, 34.023571220637564, 41.620492531599325, 50.685682074964014, 82.560701981631325, 127.19888958323958, 237.89761616945128, 410.06312322518994, 1062.2303232610248, 1612.0404058137353, 2295.1409914972487, 1787.3905923922546, 1192.2295048012345, 614.24882525880628, 260.82616895243024, 126.23242010647614, 84.151076288810984, 67.709414992782712, 60.122571559472298, 42.830591238304876, 28.733103940874788, 20.365121706656215, 16.211112474155353, 14.072758594539286, 13.483685068827034, 12.859628868618824, 11.868475605254234, 11.903201306554562, 12.816996745648828, 13.065794209061782, 14.312459824747068, 16.296926608708432, 20.657711991677495, 27.653390070235432, 33.593110413967857, 40.672720076575544, 55.856624618502167, 103.16047843117397, 179.23484372919035, 453.7513605151255, 902.26285048256875, 1683.7179352249004, 1784.083505146898, 1577.4265763170067, 936.66309122894188, 441.20892337587179, 176.43359667751182, 98.093971741535682, 65.995944695036641, 53.240295707495449, 45.85166507919449, 32.407485359783081, 22.496202298890402, 16.965613714417799, 13.731573445856062, 12.28236966845588, 11.747735381447885, 11.213125876643861, 10.807806034266576, 10.840341477375139, 11.066245600125107, 11.119452781179984, 12.424913044930788, 14.610027556462221, 16.887227742677396, 22.29462391228396, 27.978157381323118, 31.991250392971789, 44.052658881876532, 76.109568327798371, 159.13944268405785, 318.39207128278571, 686.00323178071869, 1336.6568589814267, 1043.0649603599104, 984.78746182807288, 618.0395600950327, 289.32426118556657, 132.98214831862998, 71.520048430881175, 52.57629039600819, 41.525598741467476, 33.633912722813989, 27.031255662449681, 19.489513580793098, 14.812681614273632, 12.21137274400836, 10.893625186679536, 10.482989068673637, 10.105487112246305, 9.7116899243817354, 9.9488069804828818, 10.161347795217756, 10.513274350469635, 11.294150924355744, 12.914730156139361, 14.478861048855546, 19.021661277112585, 23.907610167423496, 27.23573455134931, 38.742976413983023, 62.869223125902629, 111.92503010834605, 213.21062569137553, 433.61330953226366, 726.70269845820769, 562.21861410525219, 539.290746631297, 362.9446461846826, 211.46669660189423, 107.79772661917396, 60.676668375567573, 41.743276533116536, 34.42369696468284, 31.26708433258414, 25.313030406949355, 18.452791878453507, 13.956644256748325, 11.043046695375654, 10.111101652499672, 9.4550360444473061, 9.2429593469396529, 8.9521911222399257, 9.2321124164010211, 9.1908041669169815, 9.5662827353227868, 10.506864865879585, 11.825879962774797, 13.52813582962821, 15.999059082232355, 19.794027285196304, 22.478845287715099, 32.163272384867753, 47.951984523863096, 81.309242866655126, 150.93744536633105, 263.84630525991662, 439.27951033199258, 309.78719189559973, 306.63257299287005, 244.19689848939953, 151.98869039704036, 91.330482004276163, 57.352753322013349, 38.709160706067429, 33.087086449001383, 29.826655436967027, 23.987725148031473, 16.89184234468231, 13.041947079601194, 10.535809562752126, 9.5359471621683909, 8.9374483496855426, 8.5672643122912326, 8.4572735895659434, 8.4602804400971099, 8.5543457526330293, 9.3823763336699937, 10.377230417708629, 11.799673812944503, 12.361176855966248, 14.786798351390814, 16.739331260686697, 20.590148031359199, 25.753571174908508, 38.382893067866803, 63.23013835373618, 105.62437218489313, 175.68359833526657, 256.05708017959813, 224.80770864957879, 228.96753655549054, 172.54966320095522, 116.26546821946491, 80.46990226978717, 53.844334876610212, 37.483534347728245, 31.075867215997253, 26.284110672635684, 20.645029038002825, 15.025930043703783, 11.738276392873866, 10.201438772469425, 8.8203445227279982, 8.4945509856995365, 8.1968728409344909, 8.1790777304419588, 7.908377156922052, 8.6785477295074038, 9.6473715156890378, 10.339435934253908, 10.728035799158873, 11.983620383388951, 13.687783504221503, 16.433795900162693, 18.309125668572698, 22.485075799802843, 31.764684376383052, 49.270779583367755, 77.729851956279916, 123.50059845139852, 179.77043479461938, 159.57955623939222, 154.53329869380329, 127.96891349444883, 91.96783661678981, 66.921744646417011, 48.818287955893446, 36.591061653526779, 27.834277069623926, 23.041902152181589, 18.358713894245302, 13.567338391039883, 11.281789781943191, 9.6038295455647198, 8.7333277563772516, 8.338123667351045, 7.8992088061869676, 7.7104322426775909, 7.9983869985641034, 8.5436438490902269, 9.4432158844800043, 9.7870344410918424, 10.423788563863184, 11.253535869282553, 13.327727562718719, 15.178485067808285, 17.337135682195893, 21.668177060872456, 29.324826866357235, 41.492753218636352, 60.042185621507166, 90.318134916215342, 130.8805255687621, 104.24612656823803, 108.8028525877362, 89.555745560157249, 69.785669575239666, 56.746590174428, 44.171218069814536, 32.39838941697333, 25.182252759236459, 21.610810960419155, 16.972539478480535, 13.238333358456819, 10.614964653675054, 9.3806927946307859, 8.7492814832421075, 8.135298996501481, 7.634398163782139, 7.4852869889479292, 7.8316993609624435, 8.3853957415274643, 9.2315742305614634, 9.8389441629514209, 10.386606043801919, 11.354519695989614, 13.10793814373473, 15.240615596988986, 17.58979203150065, 21.461767190818147, 26.661531554562984, 36.123337028978582, 50.320731869274383, 69.065609719997795, 87.442260857354199, 76.677643276575949, 72.689147636714068, 65.50785565022079, 58.297658406357961, 49.558598741148941, 39.192968104211104, 29.954333787314212, 23.9458863540046, 19.99476230299754, 16.735792774046942, 12.901585018586687, 10.289994503175569, 9.3977765822679924, 8.6704196287803228, 7.8828328381527575, 7.5341478839019471, 7.4312929200041102, 7.7985159766257679, 8.1869060912414078, 9.142118635191288, 9.830770779287306, 10.340589147553608, 11.281171263863113, 12.984935438318947, 15.107976469419242, 18.19770629294057, 20.668346478928893, 25.761496132514932, 32.251424266134499, 39.95295492008993, 51.369438078625848, 65.569299562662465, 55.468849468729523, 55.86542097352833, 55.101138782973663, 50.531848368674723, 43.701470536966781, 35.866381440857431, 28.439396618258566, 22.42863349391925, 18.945030358082761, 15.596977301337661, 12.206893729284205, 10.050508612628137, 9.5473939482322869, 8.6463276280830179, 7.910774588392556, 7.2755514089661562, 7.5482842032534565, 7.5443879419641391, 7.9636187803325598, 8.9922015447577355, 9.6351997849989068, 10.0402383165895, 11.706284711344862, 13.336194440398188, 15.639893484781382, 17.791763978880017, 20.83131115781941, 25.6818621728188, 31.387128642704546, 37.143166049555219, 44.038766386780296, 52.904506937405849, 48.059389050535145, 50.072432061388255, 49.115010315515249, 44.160423468831148, 38.440953181308423, 32.35840674752788, 26.251111011761232, 21.081922570464979, 17.515101530242855, 14.10261621013594, 11.438986216849498, 10.422223192105227, 9.76207732514108, 8.7746319169344158, 7.5939451837729885, 7.2605949806802883, 7.4766919496025244, 7.419064545103371, 8.0187357229163059, 8.9266344512172839, 9.6975643711848107, 10.35689464395745, 11.451859179394017, 13.10319606057651, 15.460942026724263, 18.825021564083144, 22.773162722002358, 26.906890973713775, 31.803276985208164, 37.82902190094245, 42.388788349798304, 44.620105679799558, 48.859277780953818, 46.136110292205181, 41.908361785717766, 39.521022744549988, 35.052294933716347, 29.181343166303421, 23.802472557875006, 19.955746539759069, 16.22743816874862, 13.086681034223906, 11.226909204888067, 10.616041272149978, 9.8385492842648201, 8.6563005846195669, 7.8952678290472065, 7.2762149925656852, 7.3094046208482961, 7.276214992565686, 7.8952678290472083, 8.656300584619574, 9.8385492842648219, 10.616041272149991, 11.226909204888063, 13.086681034223904, 16.22743816874862, 19.955746539759044, 23.802472557874989, 29.181343166303414, 35.052294933716361, 39.521022744549988, 41.908361785717766, 46.136110292205167, 48.059389050535053, 44.620105679799494, 42.388788349798226, 37.82902190094255, 31.803276985208186, 26.906890973713825, 22.773162722002368, 18.825021564083173, 15.460942026724263, 13.103196060576508, 11.451859179394024, 10.356894643957441, 9.6975643711848196, 8.9266344512172751, 8.0187357229163005, 7.4190645451033674, 7.4766919496025226, 7.2605949806802919, 7.5939451837729957, 8.7746319169344176, 9.7620773251410817, 10.42222319210523, 11.438986216849505, 14.102616210135931, 17.515101530242841, 21.081922570464972, 26.251111011761218, 32.358406747527845, 38.44095318130838, 44.160423468831063, 49.115010315515164, 50.072432061388007, 55.468849468729232, 52.90450693740565, 44.038766386780239, 37.143166049555234, 31.387128642704567, 25.681862172818796, 20.831311157819414, 17.79176397888002, 15.639893484781378, 13.336194440398192, 11.706284711344864, 10.040238316589498, 9.6351997849989122, 8.9922015447577301, 7.9636187803325527, 7.5443879419641293, 7.5482842032534556, 7.2755514089661553, 7.9107745883925578, 8.6463276280830215, 9.5473939482322869, 10.050508612628141, 12.206893729284213, 15.596977301337661, 18.945030358082761, 22.428633493919239, 28.439396618258566, 35.866381440857388, 43.70147053696676, 50.531848368674645, 55.101138782973628, 55.865420973528131, 76.677643276575822, 65.569299562662337, 51.369438078625784, 39.952954920090001, 32.251424266134514, 25.761496132514949, 20.668346478928903, 18.19770629294057, 15.107976469419244, 12.984935438318949, 11.28117126386311, 10.340589147553612, 9.8307707792872954, 9.1421186351912915, 8.1869060912414096, 7.7985159766257599, 7.4312929200041067, 7.5341478839019365, 7.882832838152761, 8.6704196287803175, 9.3977765822679942, 10.289994503175565, 12.901585018586699, 16.735792774046928, 19.99476230299755, 23.945886354004585, 29.954333787314209, 39.19296810421109, 49.55859874114887, 58.297658406357826, 65.507855650220662, 72.689147636713827, 104.24612656823788, 87.442260857354213, 69.065609719997752, 50.320731869274368, 36.123337028978554, 26.661531554563005, 21.461767190818144, 17.589792031500657, 15.24061559698899, 13.107938143734735, 11.354519695989618, 10.386606043801917, 9.8389441629514156, 9.2315742305614528, 8.3853957415274607, 7.8316993609624372, 7.4852869889479301, 7.6343981637821372, 8.1352989965014757, 8.7492814832421111, 9.3806927946307876, 10.614964653675061, 13.238333358456819, 16.972539478480542, 21.610810960419155, 25.182252759236462, 32.39838941697333, 44.171218069814465, 56.746590174427972, 69.785669575239609, 89.555745560157177, 108.80285258773613, 159.57955623939191, 130.8805255687619, 90.318134916215342, 60.042185621507201, 41.492753218636388, 29.32482686635726, 21.668177060872456, 17.3371356821959, 15.178485067808294, 13.327727562718726, 11.253535869282553, 10.423788563863175, 9.7870344410918424, 9.4432158844800025, 8.5436438490902233, 7.9983869985640963, 7.7104322426775891, 7.8992088061869596, 8.338123667351045, 8.7333277563772533, 9.6038295455647145, 11.281789781943189, 13.567338391039879, 18.358713894245295, 23.041902152181613, 27.834277069623926, 36.591061653526772, 48.818287955893382, 66.921744646416983, 91.967836616789555, 127.96891349444861, 154.53329869380323, 224.80770864957842, 179.77043479461912, 123.50059845139837, 77.729851956279958, 49.27077958336772, 31.764684376383045, 22.485075799802868, 18.309125668572733, 16.433795900162703, 13.6877835042215, 11.983620383388955, 10.72803579915886, 10.339435934253904, 9.6473715156890254, 8.6785477295073967, 7.9083771569220449, 8.1790777304419553, 8.1968728409344909, 8.4945509856995347, 8.8203445227279857, 10.201438772469423, 11.738276392873869, 15.02593004370379, 20.645029038002832, 26.284110672635681, 31.075867215997253, 37.483534347728245, 53.844334876610127, 80.46990226978717, 116.26546821946468, 172.54966320095502, 228.96753655548974, 309.78719189559854, 256.05708017959756, 175.68359833526623, 105.62437218489312, 63.230138353736059, 38.382893067866796, 25.753571174908501, 20.590148031359234, 16.739331260686704, 14.786798351390802, 12.361176855966249, 11.799673812944498, 10.377230417708628, 9.3823763336699955, 8.5543457526330204, 8.4602804400970992, 8.4572735895659417, 8.567264312291222, 8.9374483496855408, 9.5359471621683873, 10.535809562752121, 13.041947079601202, 16.891842344682331, 23.987725148031487, 29.826655436966995, 33.087086449001376, 38.709160706067401, 57.35275332201325, 91.33048200427605, 151.98869039703999, 244.19689848939879, 306.63257299286875, 562.21861410525219, 439.27951033199281, 263.84630525991662, 150.93744536633125, 81.309242866655154, 47.951984523863167, 32.163272384867753, 22.478845287715121, 19.794027285196304, 15.999059082232373, 13.528135829628219, 11.82587996277479, 10.50686486587958, 9.5662827353227868, 9.190804166916978, 9.2321124164010211, 8.9521911222399257, 9.2429593469396458, 9.4550360444473043, 10.111101652499666, 11.043046695375656, 13.956644256748326, 18.452791878453535, 25.313030406949409, 31.26708433258414, 34.423696964682833, 41.743276533116529, 60.676668375567509, 107.79772661917396, 211.46669660189391, 362.94464618468271, 539.29074663129688, 1043.064960359907, 726.70269845820621, 433.61330953226252, 213.21062569137561, 111.92503010834588, 62.869223125902685, 38.742976413983001, 27.235734551349324, 23.907610167423499, 19.021661277112635, 14.478861048855546, 12.91473015613936, 11.29415092435573, 10.513274350469626, 10.161347795217747, 9.9488069804828747, 9.7116899243817407, 10.105487112246305, 10.48298906867363, 10.893625186679529, 12.211372744008356, 14.812681614273641, 19.489513580793123, 27.031255662449723, 33.633912722813953, 41.52559874146754, 52.576290396008147, 71.520048430881019, 132.98214831862995, 289.32426118556515, 618.03956009503077, 984.7874618280689, 1784.0835051468939, 1336.6568589814267, 686.00323178071801, 318.39207128278593, 159.1394426840578, 76.109568327798428, 44.05265888187656, 31.991250392971853, 27.978157381323108, 22.294623912284028, 16.8872277426774, 14.610027556462216, 12.424913044930783, 11.119452781179971, 11.066245600125109, 10.840341477375128, 10.807806034266576, 11.213125876643852, 11.747735381447885, 12.282369668455885, 13.731573445856061, 16.965613714417831, 22.496202298890438, 32.407485359783124, 45.85166507919449, 53.24029570749542, 65.99594469503667, 98.093971741535469, 176.43359667751176, 441.208923375871, 936.66309122894131, 1577.4265763170022, 2295.1409914972464, 1683.7179352249, 902.26285048256875, 453.75136051512629, 179.23484372919026, 103.16047843117398, 55.856624618502074, 40.67272007657553, 33.59311041396785, 27.653390070235471, 20.65771199167747, 16.296926608708404, 14.312459824747059, 13.065794209061782, 12.816996745648842, 11.903201306554557, 11.868475605254236, 12.859628868618808, 13.483685068827036, 14.072758594539282, 16.21111247415536, 20.365121706656261, 28.733103940874788, 42.830591238304876, 60.122571559472277, 67.709414992782641, 84.151076288810941, 126.23242010647601, 260.82616895243001, 614.24882525880446, 1192.2295048012338, 1787.3905923922525, 2057.7285052573061, 1612.0404058137367, 1062.2303232610243, 410.06312322519068, 237.89761616945111, 127.19888958323968, 82.560701981631325, 50.685682074964042, 41.620492531599325, 34.023571220637599, 26.201109009342684, 20.289280537832823, 18.09746697987034, 16.092687824041846, 15.306988390608383, 14.533202056236956, 14.40394505640487, 15.086583853495929, 16.47335478810048, 18.193385040510101, 21.278934963706888, 28.142194153357082, 39.482567042533006, 55.964360327653644, 73.667255133763959, 91.127892931578486, 127.37774106216477, 189.68478304614982, 343.98700964912905, 736.25297679999983, 1395.1090523951759, 2152.5952706253147, 3792.0213246064582, 2037.977143592301, 857.05287855360893, 486.29648203694126, 284.03430164886925, 181.91972084309373, 112.97176733844, 73.599946641287119, 59.574829012615204, 49.117252584084042, 37.193120035742723, 27.472702254518456, 23.456998427374469, 20.329571180523697, 18.806836162280476, 17.698181326434526, 17.585642163629327, 19.004228801577025, 20.77893664206141, 23.250274731178163, 28.04988180564844, 35.429206551568925, 48.204553381452833, 66.207745096840512, 90.766106703902594, 117.95146004774013, 163.04342130809306, 253.90720770691391, 362.85093178658599, 788.44977202016594, 1627.1011647050398, 2759.3366542985605, 16084.742683461691, 10212.960963472211, 2163.5932265202296, 657.05253635266433, 321.82068054258923, 262.71291650117286, 174.75706127058845, 123.19419955144714, 93.465129226367836, 74.87296871197394, 58.649881806718732, 40.850586549891496, 33.395537201677108, 28.713323989162756, 24.755859033283489, 23.59847647103166, 23.138404805980127, 23.77293624816566, 26.753427300507926, 32.452048622414509, 38.417811994668497, 47.804301653843162, 72.004092864892002, 95.537832067100879, 129.95938769710136, 156.24359018004333, 237.01058786311899, 382.39730464420052, 614.08174831750478, 1377.4551350842296, 2736.2851033168104, 10028.51976985012, 12454.694619943462, 13565.815861293133, 4518.4223121248006, 1871.6210271277425, 914.24633406931184, 596.14853228454001, 399.94920918463339, 250.50030243800833, 177.16967383039946, 123.96413175241405, 93.91676536356745, 62.426609296740118, 50.119262484447404, 38.780040560556571, 33.135728528562332, 30.714909872552628, 29.187336608781973, 29.983374804996448, 34.725029965122346, 43.998829489125086, 55.496087080936618, 75.609007514321277, 119.44976282467937, 161.7107989330556, 222.75623691150756, 335.58154911349339, 556.73350878905831, 917.05530556073529, 1403.2127508507556, 2925.2286142376206, 5473.1790170642225, 7821.5833902765453], "imag": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]}, "imag": [0.0, 1.2364045139795619, -1.417097645517349, -0.56399113050110405, 0.44612204752934542, -0.22857396866743723, -0.12233724123958876, -0.22175063370253431, -0.081847654478992143, -0.082144528420219798, -0.016319194688300422, -0.22782269816808789, -0.31553723757062957, -0.34627737582788948, 1.2289873494343531, 0.23714731979244019, 0.0, -0.23714731979246589, -1.2289873494343397, 0.34627737582788415, 0.31553723757063035, 0.2278226981680877, 0.01631919468830003, 0.082144528420217924, 0.081847654478992143, 0.22175063370252604, 0.12233724123959235, 0.22857396866743548, -0.4461220475293452, 0.56399113050110417, 1.4170976455173483, -1.2364045139795607, 1.3606412475160685, 1.4411916754234004, -0.33639737707180672, -0.40059289889731398, 0.077869450453742065, 0.11933000679564014, -0.37020072416606636, -0.12600631152419078, -0.29291723130603109, -0.050683391882318747, -0.2123566898458312, -0.16517843825664788, -0.37438920939802389, 0.24863698196016526, 0.3956337373323095, 0.63308466384569972, -0.42643957249522613, -0.28749903579454716, -0.42301568032975828, 0.27971623762695519, 0.37808744252168813, 0.15296582393741001, 0.10558339349178479, 0.088135922159038316, 0.16705843369252343, 0.44192642538865684, 0.29915225181421068, -0.047649837051313024, -0.91046045526812369, 2.0668504460046964, 1.0236217631956717, 0.095775027331123308, 0.74327388531916394, -0.034562131954570079, 0.86361123753821734, 0.14688086473050152, -0.48040960369964397, 0.72553155869356101, -0.87865322612555963, -0.4386512882244577, -0.48573187070285989, -0.32017932907631874, -0.2830749986604581, -0.26990648117356825, 0.02650526715020339, 0.070485969368273949, 0.54370981678608021, -0.067938463814195812, 0.03776680164210118, -0.5672727000472354, 0.70317235961628322, -0.021133356436660328, 0.38778419454697149, -0.021237638325898506, 0.22272564345822293, -0.028529610958430065, 0.38389116569218468, 0.54015192300945081, 0.60890484535134959, -0.58851980199844323, -0.44257995715790832, -0.31054780878465871, 0.29452233058397137, 1.4203730522981519, 0.55042973333868539, 1.0635980503754177, -0.33223282315731317, 0.34444399750770754, 1.4812987845914649, 0.28203486996779931, -0.50640814880924923, -0.63152717265524028, -0.629560147993244, -0.38143909917016799, -0.26024004494781861, -0.19111004712688462, -0.0074049384249937926, 0.048145781851611912, 0.1775395908501845, -0.010766872600667563, -0.30557543109041663, -0.12790446781789691, 0.26497067484017217, 0.49718432792560446, 0.10847923107858634, 0.18362798444374009, 0.075793328725680426, 0.060915837919074359, 0.19352569039908019, 0.72484131059467238, 0.44769863619371908, 0.65727781823869813, -2.7705947112358387, -1.8545676439466314, 1.2534804319442749, -0.33201271766592177, -0.88179245186152566, -0.49191197464707653, 0.25061306335904526, 0.36434278784189494, 1.1059306596340364, 0.5161851914994362, -0.56259342729123341, -0.79818525223670012, -0.50614275317411506, -0.33450192958610769, -0.24220392956380443, -0.29363217368931438, -0.008975674876931768, 0.015702042401798396, 0.0043287613096781611, 0.11769772351691517, 0.14847974776257877, -0.070404205425901215, 0.15992872157624444, 0.12352253662711207, 0.22950814490677918, 0.17507285276321555, 0.13747467644410705, -0.011397583876153142, 0.1103654239578318, 0.24404333943616102, 1.1434123865171273, -0.60566186502851971, -1.3365493166122577, -1.1338250057068979, -1.8155993788135394, -1.0591766157447149, -0.69010247253016843, -0.46612626705839738, -0.20353239335470796, 0.51663850122650623, 0.2659701357580968, -0.10657803670351902, -0.69730138646619577, -0.60106744735123385, -0.33542800506255299, -0.30564289179799509, -0.26672832014897818, -0.19552146385155383, -0.070818253229817343, 0.24716165183995586, 0.24871001073085031, 0.087906272749659523, -0.066392764898707615, 0.11463822183417864, -0.097387114548935505, 0.203187369929616, 0.14292038700683402, 0.20736891492564988, 0.013685307258532538, -0.024371827339033106, -0.07233585420108031, 0.49291782026044645, 0.048917424863979306, 0.2263553910474094, 0.10839909954530379, -1.1957108711898896, -1.074771579950879, -1.1175823884839045, -0.23901621577757862, -0.12877260884038383, 0.23623861798820722, 0.17111767858219226, 0.46208690546761177, -0.23679486634226876, -0.53178862418379869, -0.34021620386249335, -0.23658495591681358, -0.22275756609764855, -0.20572232603908905, -0.14494733127712761, 0.042569660785953992, 0.077733070765218709, 0.20558191361174552, 0.031719635617051253, -0.031869312918226284, 0.0092446671691655703, 0.056907964871031128, 0.0068114015565279478, 0.20608602740074444, 0.023033890597355222, 0.064944626021130644, -0.089711600875347838, 0.051877409795188095, -0.22207073062343796, 0.24248276916859771, 0.82932242402320455, -0.0013771249391571728, -0.059139017637367147, -0.22067925957890699, -0.040068334939789486, 0.30677005181582889, 0.34490255487274107, 0.22221882441368751, 0.30818729583490434, 0.041656273199714877, 0.04389672863559383, -0.30032839778423015, -0.24246246508902861, -0.17809969240648099, -0.14126159805998126, -0.15553553242798068, -0.11510723629505018, 0.024565620333015844, 0.099324973861333238, 0.11314958231531824, 0.10920785431914558, -0.0027478677647314949, -0.002197448124614016, -0.069940656171551499, 0.14656177726216579, 0.078770189361086429, 0.10241250352514093, -0.021646587213105684, 0.019211160710794505, -0.26281055993233693, -0.055146819140509458, 0.35375643597531126, 0.22411418130009836, 0.3875457037899096, 0.25423051056794166, 0.30581901500051717, 0.085911462662090085, 0.39107302489471046, 0.24699055160378858, 0.29387297238508514, 0.15373347718831995, -0.002984582508486469, -0.017260207971634491, 0.072827255227658205, -0.062089135258224848, -0.11929552297831249, -0.14454547803177953, -0.095268264507681985, -0.10089614648569632, 0.048761457544342565, 0.09609679137720413, 0.10529567915508571, 0.012037966893712556, 0.076343100588013288, -0.20546035926376272, 0.13459193297647368, 0.025732944443593878, 0.15693288111736364, 0.043761647973181578, 0.083479299629684353, -0.15251693996845875, -0.10657849804550705, 0.038641816351084518, -0.10231188547257405, 0.21957600785318707, 0.264774413728534, 0.35686545376814865, 0.29428485506006929, 0.49934135456989248, 0.18285689914378289, 0.23675610338446562, 0.10353827744151976, 0.063107949091445251, 0.03846587209017991, 0.13661717625997899, 0.098122755354854277, -0.0039906200934582137, -0.09009439550122221, -0.16647262366552176, -0.19237746196753996, 0.026647194061990561, 0.048509383863749068, 0.1654716680991411, -0.035914795239386038, 0.099273739290017232, -0.11264804489487676, 0.14792025966567318, -0.093791526140286519, 0.10021979561886898, 0.0080449729031339574, 0.25399382193861558, -0.10951630791791984, -0.033548122233328939, -0.024275040060575473, -0.15565555640319179, -0.035231426543991154, 0.063485173587351437, 0.22814734409189322, 0.10684932807789806, 0.2355554633425988, 0.10407564589066262, 0.015525256999673128, -0.011913601076877599, -0.0039295920043740662, 0.044701593559494178, 0.16547295203389104, 0.15907957720488838, 0.074664630781852093, -0.04243906497357175, -0.11246394245376416, -0.16972427151540079, -0.21530290856092721, -0.15195750501651711, 0.40553391670472716, -0.05507255324487554, 0.18488826926783164, -0.03502892748503212, 0.37001387119519319, -0.15325722566754377, 0.27168929694820759, -0.059701216280397838, 0.48380889084850937, -0.13017614472815323, 0.047673421329954523, 0.071305584258896423, -0.15733503034508964, -0.079593566039511662, -0.075485820780456944, 0.06620598245919887, -0.0012785498169557718, 0.063827392702187832, -0.0024400785561267094, 0.050942947866382475, -0.16777938781510365, -0.092876049496631446, -0.010378011540593757, 0.1594331602275639, 0.19523869399925237, 0.18464942262011227, 0.063285121982437173, -0.077221658551183223, -0.1491589460269398, -0.17912928670535297, -0.11490318286815507, -0.11189726101521234, -0.20487634390276235, 0.76498375921014561, -0.23800865420158882, 0.74083633586796371, -0.083846748018997191, 0.46372256496136105, -0.16834959597660981, 0.80860396068755125, -0.25555617026146216, 0.19463913189037535, 0.30097794980879877, -0.16302064990391507, -0.10690976611351247, -0.13497815095121923, -0.049772201284698683, -0.079451894223961053, 0.040407604161455342, -0.09194915079908203, -0.14731166465811507, -0.26499922119954511, -0.15560186997026057, -0.069496867327866862, 0.16530147427910571, 0.22324548858793775, 0.26718136730575287, 0.19166419512490171, 0.060936923017668537, -0.088626234734120041, -0.14658150061325853, -0.15988330961851069, -0.18630425886720847, 0.20226767939927157, -0.086142375874942501, -0.77766311308853053, 1.4090153420038987, -0.3038886842868152, 1.2888777036518135, -0.074470758177722834, 1.2482190395029773, -0.80123249840125998, 0.47055407026248136, 0.75577199845745624, -0.11037652666672627, -0.054458369263067428, -0.19918107544886771, -0.10899116252888987, -0.15332031366957818, 0.043654486348545761, -0.022154991408309264, -0.15239448898889341, -0.19372066727324463, -0.023769000914279543, 0.24457812931884867, 0.51722906014629877, 0.4305115414461968, 0.4535547011943914, 0.3493581281435395, 0.21076698450898321, 0.063956239140020049, -0.043266091906771414, -0.12307402164456596, -0.17588597679362872, -0.057160335632577657, -0.0784239564694168, 0.14377922602722487, -0.28610637890062873, -1.3867297053543113, 2.7076021550256568, -0.12637740826622818, 2.0046873376560574, -1.442367549533677, 0.41516901914168741, 1.1637625900709285, 0.02187980097289477, 0.2119473473283329, -0.11885489129254229, -0.1159981397382039, -0.18899269201836941, -0.058557612447368006, -0.043992442353640485, -0.026879139952720663, -0.019298206516241499, 0.11425895652801879, -0.10204731321609413, 1.0976378910336273, 0.78083298172023552, 0.7892686156410853, 0.65585934200294294, 0.41963945036689065, 0.21495377802894691, 0.10907743849349204, -0.015003791740152183, -0.098108352324783196, -0.099983461914768382, -0.14074054993981988, -0.049222223079134708, -0.60225632344115432, 0.14822551318702831, -0.20779420774376042, -2.0348285284263787, 4.0251861194251459, -2.7420491756647705, 0.80731183784095106, 1.5256751899261984, -0.015777910213839702, 0.56481061463658855, 0.094745090670160736, 0.032305441115857418, -0.15496296066268442, -0.070898922964745509, -0.15185446167165811, -0.099013378837322308, -0.033839198092832617, 0.20170996830425536, 0.31395340400286426, 0.91804938453195506, 0.90837480132247328, 1.1212514777242175, 0.8111537128593137, 0.65461252772518352, 0.44812018281017851, 0.29338133862249183, 0.080942506543726575, -0.0048876135806632161, -0.042045437831147933, -0.048279129686226115, -0.13748504879992385, -0.22867414001479172, -0.65206021382919555, -1.4414816884582773, 0.34900156189272369, 1.2663064061664397, -4.4519069438082273, 2.3981175155339263, 2.0366543361516527, -0.11574419894478603, 0.9938253915317542, 0.40253059498542132, 0.29787521235777348, -0.048128801274628118, 0.001834095689180732, -0.063578064856638958, -0.14911097873279969, -0.17638384543546787, -0.15061392115741762, -0.13638564133647435, 0.3292785127452974, 0.45646012748955422, 0.0, -0.098380202448484569, 0.2889284460821786, 0.39981384774007012, 0.45036129401449043, 0.22152969012775114, 0.11073273247786891, 0.024117745722163984, -0.0050280129542534689, -0.087106960572679512, -0.083653448195472838, -0.51521426958714545, -0.86124262209127589, -0.78939851130304506, -0.74423225935393889, -1.1208061672534484, 0.0, 1.1208061672534437, 0.74423225935393811, 0.78939851130304262, 0.86124262209127656, 0.51521426958714389, 0.083653448195472491, 0.087106960572679332, 0.0050280129542534689, -0.02411774572216354, -0.11073273247786865, -0.22152969012775126, -0.45036129401449054, -0.39981384774006945, -0.28892844608217838, 0.098380202448484236, -0.90837480132241455, -0.45646012748952708, -0.32927851274525655, 0.13638564133649642, 0.15061392115742586, 0.17638384543547556, 0.14911097873280194, 0.063578064856639402, -0.0018340956891807838, 0.048128801274627743, -0.29787521235777292, -0.40253059498541977, -0.99382539153175098, 0.11574419894478773, -2.0366543361516536, -2.3981175155339201, 4.4519069438082379, -1.2663064061664346, -0.34900156189272086, 1.4414816884582851, 0.65206021382919577, 0.22867414001479336, 0.13748504879992438, 0.048279129686228148, 0.042045437831148495, 0.0048876135806649092, -0.08094250654372509, -0.29338133862248678, -0.44812018281017507, -0.6546125277251672, -0.81115371285928006, -1.1212514777241573, -1.0976378910335893, -0.91804938453192131, -0.31395340400284805, -0.20170996830424559, 0.033839198092839695, 0.09901337883732686, 0.1518544616716597, 0.070898922964745925, 0.15496296066268506, -0.032305441115858605, -0.09474509067015939, -0.56481061463658966, 0.01577791021384034, -1.5256751899262007, -0.80731183784094906, 2.7420491756647789, -4.0251861194251397, 2.0348285284263898, 0.20779420774376556, -0.14822551318702654, 0.60225632344115643, 0.049222223079135728, 0.14074054993982205, 0.099983461914770352, 0.098108352324783543, 0.015003791740153814, -0.10907743849349157, -0.21495377802894516, -0.41963945036688871, -0.65585934200294016, -0.78926861564106898, -0.78083298172020743, -0.24457812931883488, 0.10204731321609872, -0.11425895652800651, 0.019298206516249916, 0.026879139952725083, 0.04399244235364598, 0.058557612447370934, 0.18899269201837068, 0.11599813973820411, 0.11885489129254237, -0.21194734732833254, -0.021879800972893531, -1.1637625900709312, -0.4151690191416833, 1.4423675495336772, -2.0046873376560503, 0.12637740826623128, -2.7076021550256497, 1.3867297053543175, 0.28610637890063351, -0.14377922602722601, 0.078423956469422018, 0.057160335632579121, 0.1758859767936318, 0.12307402164456618, 0.043266091906772712, -0.063956239140019508, -0.21076698450897985, -0.34935812814353639, -0.45355470119438479, -0.43051154144618958, -0.51722906014628944, 0.15560186997025938, 0.02376900091427863, 0.1937206672732435, 0.15239448898889424, 0.022154991408310377, -0.043654486348542874, 0.15332031366958024, 0.10899116252889095, 0.19918107544886771, 0.054458369263066984, 0.11037652666672665, -0.75577199845745313, -0.47055407026248092, 0.80123249840126409, -1.2482190395029769, 0.074470758177730939, -1.2888777036518133, 0.30388868428682408, -1.4090153420038936, 0.77766311308853486, 0.086142375874943722, -0.20226767939927121, 0.18630425886721039, 0.15988330961851227, 0.14658150061325848, 0.088626234734120221, -0.060936923017667906, -0.19166419512490052, -0.26718136730575015, -0.22324548858793625, -0.16530147427910316, 0.069496867327866751, 0.16777938781510615, 0.26499922119954472, 0.14731166465811715, 0.091949150799082904, -0.040407604161453857, 0.07945189422396387, 0.049772201284700876, 0.13497815095122018, 0.10690976611351256, 0.16302064990391416, -0.30097794980879811, -0.19463913189037552, 0.25555617026146371, -0.80860396068754914, 0.16834959597661264, -0.46372256496135666, 0.083846748018996636, -0.7408363358679616, 0.23800865420159104, -0.76498375921014483, 0.20487634390276502, 0.11189726101521356, 0.11490318286815554, 0.17912928670535491, 0.14915894602693922, 0.077221658551183403, -0.063285121982436826, -0.18464942262010964, -0.19523869399925042, -0.15943316022756263, 0.01037801154059478, 0.09287604949663382, -0.015525256999667727, -0.050942947866376924, 0.0024400785561280833, -0.06382739270218761, 0.0012785498169549515, -0.066205982459197621, 0.075485820780458165, 0.079593566039511995, 0.1573350303450895, -0.071305584258897034, -0.047673421329955501, 0.13017614472815361, -0.48380889084851014, 0.05970121628039872, -0.27168929694820493, 0.1532572256675474, -0.37001387119519286, 0.035028927485033709, -0.18488826926782947, 0.055072553244877351, -0.40553391670472771, 0.15195750501651886, 0.21530290856092779, 0.16972427151540051, 0.11246394245376394, 0.042439064973571687, -0.07466463078185144, -0.159079577204887, -0.16547295203388937, -0.044701593559494109, 0.0039295920043746378, 0.011913601076878649, -0.18285689914377989, -0.10407564589066134, -0.23555546334259525, -0.10684932807789757, -0.22814734409189458, -0.063485173587349258, 0.035231426543992535, 0.15565555640319106, 0.02427504006057549, 0.033548122233326282, 0.10951630791791925, -0.25399382193861758, -0.0080449729031340841, -0.10021979561886678, 0.093791526140288961, -0.14792025966567243, 0.11264804489487593, -0.099273739290014568, 0.035914795239387988, -0.16547166809914049, -0.048509383863747611, -0.02664719406199113, 0.19237746196754099, 0.16647262366552154, 0.090094395501221572, 0.0039906200934596249, -0.098122755354853444, -0.1366171762599761, -0.038465872090180271, -0.063107949091446403, -0.10353827744152141, -0.2367561033844639, -0.39107302489471046, -0.4993413545698927, -0.29428485506006952, -0.35686545376814893, -0.26477441372853422, -0.21957600785318782, 0.10231188547257429, -0.038641816351083894, 0.10657849804550705, 0.15251693996845886, -0.083479299629685352, -0.043761647973181945, -0.1569328811173635, -0.025732944443590922, -0.13459193297646968, 0.2054603592637699, -0.076343100588013288, -0.012037966893705314, -0.10529567915508307, -0.096096791377201118, -0.048761457544342024, 0.10089614648569795, 0.095268264507682401, 0.14454547803178003, 0.11929552297831249, 0.062089135258225896, -0.072827255227657164, 0.017260207971635976, 0.0029845825084865137, -0.15373347718831978, -0.29387297238508514, -0.24699055160378858, -0.30677005181583211, -0.085911462662095636, -0.30581901500051922, -0.25423051056794305, -0.38754570378991321, -0.22411418130009808, -0.35375643597530843, 0.055146819140510416, 0.26281055993233621, -0.019211160710796572, 0.021646587213104713, -0.10241250352514171, -0.078770189361086179, -0.14656177726216213, 0.06994065617155748, 0.0021974481246246629, 0.002747867764730379, -0.10920785431913549, -0.11314958231531393, -0.099324973861329505, -0.024565620333014605, 0.11510723629505158, 0.15553553242798132, 0.1412615980599799, 0.1780996924064803, 0.24246246508902825, 0.30032839778422799, -0.043896728635589223, -0.041656273199716369, -0.30818729583490695, -0.22221882441369153, -0.34490255487274391, 0.23901621577757753, 0.040068334939789153, 0.22067925957890494, 0.059139017637366363, 0.0013771249391555669, -0.82932242402320322, -0.24248276916859551, 0.2220707306234446, -0.05187740979518813, 0.089711600875348782, -0.064944626021130755, -0.023033890597353883, -0.20608602740074317, -0.0068114015565181726, -0.056907964871020393, -0.0092446671691440163, 0.031869312918224861, -0.031719635617030659, -0.20558191361174011, -0.077733070765210868, -0.042569660785952056, 0.14494733127713064, 0.20572232603908944, 0.22275756609764749, 0.23658495591681294, 0.34021620386249518, 0.53178862418379935, 0.23679486634227159, -0.4620869054676115, -0.17111767858219507, -0.23623861798820922, 0.12877260884038208, 0.69010247253016699, 1.1175823884838996, 1.0747715799508781, 1.1957108711898863, -0.10839909954530788, -0.2263553910474054, -0.048917424863973949, -0.49291782026044056, 0.072335854201080588, 0.024371827339035017, -0.013685307258532536, -0.20736891492564691, -0.14292038700683141, -0.20318736992960118, 0.09738711454895084, -0.11463822183415182, 0.066392764898706338, -0.087906272749638886, -0.24871001073084317, -0.24716165183994784, 0.070818253229819925, 0.19552146385155544, 0.2667283201489779, 0.30564289179799059, 0.3354280050625516, 0.60106744735122974, 0.69730138646619622, 0.10657803670352221, -0.26597013575809814, -0.51663850122651156, 0.20353239335470413, 0.46612626705839527, 0.88179245186152555, 1.0591766157447142, 1.8155993788135401, 1.1338250057069015, 1.3365493166122591, 0.60566186502852537, -1.1434123865171271, -0.24404333943615408, -0.11036542395783162, 0.011397583876152599, -0.13747467644410641, -0.17507285276321236, -0.22950814490677501, -0.12352253662709391, -0.15992872157622667, 0.070404205425931329, -0.14847974776257952, -0.11769772351689584, -0.0043287613096706385, -0.01570204240179094, 0.0089756748769360926, 0.29363217368931571, 0.24220392956380496, 0.33450192958610414, 0.50614275317411517, 0.79818525223669812, 0.56259342729123207, -0.51618519149943443, -1.105930659634037, -0.36434278784189805, -0.25061306335904537, 0.49191197464707476, -0.55042973333868328, 0.33201271766592266, -1.2534804319442674, 1.8545676439466376, 2.7705947112358396, -0.65727781823869658, -0.44769863619371453, -0.72484131059467105, -0.19352569039907921, -0.06091583791907576, -0.075793328725683354, -0.18362798444373865, -0.10847923107858076, -0.4971843279255892, -0.26497067484015147, 0.12790446781792791, 0.30557543109041591, 0.010766872600696822, -0.17753959085018053, -0.04814578185160058, 0.007404938424997059, 0.19111004712688809, 0.26024004494781799, 0.38143909917016594, 0.62956014799324345, 0.63152717265524094, 0.50640814880924734, -0.28203486996779953, -1.481298784591466, -0.34444399750770943, 0.33223282315731145, -1.0635980503754157, -0.74327388531916416, -1.4203730522981521, -0.29452233058397176, 0.31054780878465887, 0.4425799571579111, 0.58851980199844711, -0.60890484535134703, -0.54015192300944392, -0.38389116569218451, 0.02852961095842791, -0.22272564345822352, 0.021237638325899852, -0.387784194546968, 0.021133356436687064, -0.70317235961626101, 0.56727270004732033, -0.037766801642101375, 0.06793846381428098, -0.54370981678606445, -0.070485969368251203, -0.02650526715020184, 0.26990648117357596, 0.2830749986604576, 0.32017932907632218, 0.48573187070286, 0.4386512882244713, 0.87865322612556163, -0.72553155869355623, 0.48040960369964236, -0.14688086473049994, -0.86361123753821778, 0.034562131954569586, -1.3606412475160699, -0.095775027331125598, -1.0236217631956728, -2.0668504460046977, 0.91046045526812469, 0.047649837051312177, -0.29915225181420874, -0.44192642538866073, -0.16705843369252318, -0.088135922159037081, -0.1055833934917848, -0.15296582393740679, -0.37808744252168625, -0.27971623762694292, 0.42301568032977793, 0.28749903579456393, 0.42643957249522774, -0.63308466384561635, -0.39563373733228846, -0.2486369819601503, 0.37438920939802361, 0.1651784382566546, 0.21235668984583117, 0.050683391882319691, 0.2929172313060312, 0.12600631152419559, 0.37020072416606892, -0.11933000679563836, -0.077869450453742661, 0.40059289889731342, 0.33639737707180556, -1.4411916754233998], "height": 32, "width": 32, "top": {"real": [6327.0074679827858, 12787.448651417644, -8580.1357782693794, -6564.4296251926053, 1064.8969915597925, -1614.7722808334524, -60.048119421842308, -221.12968025641604, -12.445754708845573, -62.940587713583341, 23.820578453457951, -28.525301748952867, 37.864280125154337, -85.844490405627994, 27.493814969643068, -48.151974443362732, 41.399660199307142, -48.151974443360345, 27.493814969642067, -85.844490405627866, 37.864280125154032, -28.525301748952689, 23.820578453458509, -62.940587713584037, -12.445754708845573, -221.12968025641445, -60.048119421842806, -1614.7722808334493, 1064.8969915597932, -6564.4296251926125, -8580.1357782693849, 12787.448651417659, -17213.595236981997, 544.07302669902936, -10829.417860945707, -5794.1219231083051, -1103.8692252742003, -1120.3666800727638, -106.61462896985108, -117.89522553300084, -39.308430893651213, -26.960578056534288, -11.025047422886351, -2.1850531713376355, -7.2952697383625882, -14.472211987615461, -14.23279965231924, 3.5205960317557246, -19.629747734378611, -14.131264529804582, -22.272265924680642, -17.401343902608428, -1.7416101263052008, 0.34733716754184635, -16.60063574625633, -32.47390190466588, -64.31481385096977, -84.034753639409303, -258.32278440436392, -714.30117659130417, 113.1165060355228, -2806.7151144576005, -10882.302955904926, -27817.100568112113, -27745.708494118069, -22841.420845008699, -8553.5264674688351, -4085.033989629072, -1748.9561003744159, -545.33543865452532, -146.45498278007594, -40.805440061891282, -50.060212982262158, -16.730489448484349, -23.62313915150434, 0.36714120063527833, -7.1882909197809326, 6.4142604093545659, -14.833291452397129, 3.4669422259569203, -16.161012153790594, -21.283130178011959, -13.244388638951026, -1.2754674400463286, 0.49184661171499777, -11.472717532816317, -17.530689402649369, -29.523444921912187, -36.983418680226812, -91.597351236026796, -144.17841735614732, -486.41083616652156, -239.1204206916959, 139.00893917602821, -7153.1577950265046, -18373.599790964956, -8415.9227315857388, -6467.5546779833858, -5469.6585676007244, -2789.7914675082047, -821.48267137489768, -514.71454200305448, -122.6780822655295, -35.554593402553344, -32.905184819607861, -16.875977506192179, -9.1243948190511883, -4.1802620318744168, 0.78316084097390803, -0.82473624462572925, -6.0277039354546789, -6.8502427898926159, -6.8858593350514123, -14.551844205848809, -8.4592989146599145, -1.9950695133570466, 1.5394495557011576, -9.232834653609892, -11.961754213185406, -20.558561534905806, -38.14482496917136, -57.160869905334089, -157.5554953403844, -411.20082432868492, -110.11930975746139, -463.64281724562954, -1210.9754315912523, -4810.1023052011815, -2624.9192342435695, -4516.897453633137, -3582.982491421491, -2119.7499173636902, -750.23472664477231, -159.86878938364373, -96.805728919101412, -16.935754226078267, -22.178078450833883, -9.0092227225989756, -5.4454852920506616, -2.5268882566736748, -2.6219523498948458, -2.0534180946008638, -6.4643064804236223, -8.7214065300148622, -7.0127031874072934, -7.7847619200438425, -0.78121801903708787, -0.11031060182209244, -3.4318959866990171, -4.568083040130742, -9.3160200641569482, -15.87900618307528, -23.382201868158507, -37.989404730637517, -121.95929165874175, -201.43809047465336, -567.30372690179445, -610.36312853782476, -1937.2376557226703, -2694.0942422163184, -3481.5355975420739, -3026.0617140239533, -2506.4916383888308, -1355.1576691715959, -468.0599091435185, -33.397814851582154, 18.545331481583979, -29.439943085485314, -11.922803368680741, -7.7174579848963036, -2.7888603302094261, -2.0545006330536419, -1.0224301618297007, -2.5290059501700397, -2.6199349314032494, -4.8828731457816774, -5.6140621268617785, -3.6146413255535528, -0.82967484502750599, -1.1631844631411599, -1.1736245693095499, -3.7427284368684024, -6.6178270656423424, -8.8039498431578131, -13.481606634721874, -26.682014936266803, -32.97802138197703, -190.87870662958537, -335.07671606134033, -876.95522185704988, -1470.8308615232113, -2413.1056871868645, -2329.4915082040015, -2151.9265781424592, -1438.5211303616525, -713.08152385953474, -130.56706965452, -28.862997769748436, 1.7115783105395304, -2.3079138134833856, -11.650001060370576, -2.1701895043697319, -1.7033561682904694, 0.11972955037883275, -0.5790790812653609, -0.45369004788794814, -4.0202584980239315, -2.2874964618085922, -4.0439693313887179, -2.7144116941037568, -0.78431497120559035, -0.63377862148075614, -0.83542887465582039, -2.5417481635934216, -3.4497798452119151, -5.2729359146939485, -9.3325337684514853, -2.3480777220919959, -30.998957295773433, -62.717085150656224, -255.55592612696097, -515.55403813953228, -1077.4118984564277, -1959.4321649356718, -996.17063256475433, -957.58296584245431, -646.48124546709357, -264.63237090275328, -80.518340163143705, 1.3577640380308329, -10.209813205700032, -1.6455702447745924, 0.041564105453412992, -2.1114336115237951, 0.094770419949782359, -0.59915948675603581, -0.042806075220647909, -1.4583889440112543, -1.0515624140257636, -2.6242610725724358, -1.9962698899057387, -2.6373580888952279, -0.39414295752688255, -0.80952098820947449, -0.80935504019781357, -1.8315981280862581, -2.3957781219887311, -3.7775973636187947, -1.2762438485839673, -5.8736187047076989, -1.7472058496177199, -39.26171578474986, -103.67045476207605, -221.97901463800724, -486.52939506954147, -770.86385201715837, -324.53401456188737, -340.76561269504333, -198.94197841299811, -116.98390967138687, -32.552002455687223, -2.8647426984892057, 3.4567160839115996, -2.3310052693731942, -0.31982529888503974, 1.0641170511547686, -1.1693860348016079, 0.40700212695667498, -1.0092937918537679, -0.034985154955161232, -1.1746986822405672, -2.2583319261560799, -2.3742700657768196, -2.0999344700147127, -1.3199204785521135, -0.00726121067659493, -0.21997349279604808, -1.6799449140427334, -2.573626149077699, -1.2749029797075579, -2.9722975102588807, 1.1149262389696764, -3.7825574143705132, -8.8112838568342262, -31.380656277665604, -80.815706494855448, -151.2920880811312, -231.73584987382, -71.719340760371239, -68.364029336894532, -82.304975309081328, -39.769136567332623, -12.693902195545155, 1.9842035662706039, -0.48894354077452629, 1.5673786316984977, -1.1528550937233366, -0.047905313676576855, 1.0650111541187497, -1.4670778837513785, 0.90154843827712783, -2.0067122081730173, -1.7180755446076856, -3.3483434682482898, -1.6317774897434336, -3.4708804264384949, -1.4694727348954268, -0.10257790692130256, -0.92889636381571783, -2.5451436559397584, -1.1303995452351283, -2.8871606625355204, -0.49805533537312113, -0.43871934228158149, 0.74909741969065036, 1.439791857975526, -13.026034555561825, -28.484337861014367, -36.895178406765908, -72.231190035838395, -26.809485534889244, -56.942733796520351, -36.280107429422031, -18.099079313675151, -3.2627913287121535, -0.27065475805048173, 1.1511525903295716, -0.1898870363801409, 0.97087220888025372, -1.1326412370424179, 0.19981301766363371, 2.3076802702931332, -2.5498407756566031, -0.55532623625253041, -4.5067864970337066, -3.1791416623515807, -4.4078100962970312, -3.3125592316970569, -0.86117313527739991, -1.5893272599995412, -2.966763176308445, -0.10263295233944174, -3.9090515756474873, -1.1809123553765606, -1.2038275093350199, 0.28624805719871799, 1.8536817132476691, 0.80720029239974944, -5.5769148242308617, -9.876045833403877, -26.746787584056406, -25.156847324745275, -59.858730768373135, -40.909481344220289, -31.301364606284917, -12.992896188265529, -3.3747756869001191, 2.018530777741562, -0.2260612077575776, 0.20594677690592242, -0.32403225688254972, 2.6342781156582364, -0.20787587650621794, 0.020021422684959465, 2.4168167113542753, -5.4711139391067487, -4.0162352275216753, -8.2614925402209369, -5.3597212899808353, -3.5618518868969149, -2.433206189931258, -3.72732750056158, 1.9796458045760836, -5.6194552495050392, -1.3533084788499918, -2.5312603283156982, -0.73577412998862446, 1.0534870856485199, 1.9641802030644013, 2.686394865901931, 0.15179077698100021, -13.505006616733285, -24.652619118640313, -46.540772018331772, -65.573862825648789, -62.198686950727755, -33.367481359773279, -15.462856466374785, 1.2764820376727259, 0.65238351077916601, 0.11426292455840634, -0.28574074744887695, 1.1004477970868616, 1.5327652909312646, 4.9327112002405187, -2.7503236900904393, -3.9754701567757182, -0.83451213573114202, -9.6859551174636032, -6.0006304228248837, -7.1318253263858704, -4.9856424549649869, -8.2198692881497966, 4.4471445589999075, -5.9124192136821829, -1.066228559248251, -4.5320020023541776, -2.2691032318803455, -0.29595929991781228, 0.95069246916243999, 2.9800299945570488, 4.1754888650460389, -3.9368165535394617, -16.752391317324459, -41.141712299851427, -60.643902512124761, -84.343164732157774, -54.074972316673119, -32.147836838432397, -3.8004568077904586, 0.60906370022349199, 0.96326571070502964, 0.12072436644318041, 0.86319547550846831, 1.1644302862121145, 2.3252453178811563, 0.4766448788746544, 4.2895158747096422, -8.0099398507205173, -11.261414242734404, -3.7327404661807368, -6.1601929909303115, -5.7506657339441176, -11.117751544185502, 4.3054115148233869, -8.2116085703478756, 1.5649721654809707, -5.692142411938895, -3.4949086671880489, -2.1697325908161673, -0.69541562648800392, 0.8151347377023449, 3.4913843961972888, 3.7128410928274609, -0.28461904914440361, -14.694115553922865, -40.784171797776878, -76.129097997930202, -42.446544168449137, -35.20072244442639, -7.6849685309209681, -0.86778876706269803, 1.7056687310546401, 0.51974952798739482, 1.1316759112288739, 1.2127800605381189, 2.2221214293211369, 0.8361427470500683, 0.099546606452808759, -3.1066939683116588, 2.4769973579809332, -11.745899626687375, -12.566716735550758, -4.7843722525441121, -8.6040588700645948, 5.3511034027408684, -15.66778198729919, 3.3911987930307137, -8.1259457896856588, -4.7980365887404339, -2.1471667518999764, -2.5087241573260579, -0.86097656871748596, 0.80139543608377761, 2.3927476350849495, 5.6561627225456101, 4.6250195847240709, -10.360873371570062, -32.183766942993408, -40.627648783043085, -17.95302681367091, 6.1859416444601623, 4.4451711191118575, 6.2133312512745986, 3.3587096432927233, 0.75569650762962715, 0.82429958430179118, 1.6770717987294814, 1.4875078542842981, 0.57506461301516931, -1.8616897808321822, -4.2923314886050523, -7.0161307894352376, 4.8526265686569623, -11.625945416074895, -21.07467865045702, 3.1434482955713889, -12.714871655934468, 2.366640700254353, -11.173661544979289, -6.475058123170597, -2.9596627855411386, -2.7630790459355632, -1.4122750319888788, -0.55802289067111654, 0.40509965601619852, 3.0549503122920978, 4.5519407117959005, 5.5044865911271481, 2.884340309618711, -2.0306279174386637, -12.290279126535582, 30.20785901727286, 12.45094729737127, 8.7415961086741216, 10.304484703022888, 4.2310313602871554, 1.8368366318675937, 1.9910666876255574, 0.99156303676388502, 0.31747940339256003, -0.60245605946597469, -1.5054245711483085, -5.2047479791857727, -4.6985425899868174, -6.4406057657264579, -2.4317965202694718, -0.31806110286890099, -34.614374984304249, -0.31806110286891309, -2.431796520269478, -6.440605765726465, -4.6985425899868325, -5.2047479791858065, -1.5054245711483181, -0.60245605946599046, 0.31747940339256003, 0.99156303676388657, 1.9910666876255707, 1.836836631867627, 4.2310313602871847, 10.304484703022929, 8.7415961086741465, 12.450947297371268, -17.953026813669211, -12.290279126534008, -2.0306279174386814, 2.8843403096185996, 5.504486591127181, 4.5519407117958774, 3.0549503122920303, 0.40509965601617365, -0.55802289067113198, -1.4122750319888866, -2.7630790459355659, -2.9596627855411324, -6.4750581231706095, -11.173661544979305, 2.3666407002543774, -12.714871655934495, 3.1434482955713383, -21.074678650457034, -11.625945416074918, 4.852626568656909, -7.0161307894352527, -4.2923314886050816, -1.8616897808321802, 0.57506461301515821, 1.4875078542843145, 1.6770717987294999, 0.82429958430183881, 0.75569650762972518, 3.3587096432928165, 6.2133312512752603, 4.4451711191129393, 6.1859416444606961, -42.446544168447332, -40.62764878304236, -32.183766942992868, -10.360873371569919, 4.6250195847241038, 5.6561627225455622, 2.3927476350849091, 0.80139543608374619, -0.86097656871749839, -2.5087241573260646, -2.1471667518999924, -4.7980365887404339, -8.1259457896856819, 3.3911987930307128, -15.667781987299181, 5.3511034027407849, -8.6040588700645682, -4.7843722525441965, -12.56671673555077, -11.745899626687423, 2.4769973579809226, -3.1066939683116837, 0.09954660645280862, 0.83614274705006209, 2.2221214293211515, 1.2127800605381271, 1.1316759112289154, 0.51974952798746277, 1.7056687310547414, -0.86778876706233132, -7.6849685309204459, -35.200722444424429, -84.343164732156296, -76.12909799792908, -40.784171797776416, -14.694115553922703, -0.28461904914431585, 3.7128410928274769, 3.4913843961972515, 0.81513473770227451, -0.69541562648801736, -2.1697325908161949, -3.4949086671880569, -5.6921424119389146, 1.5649721654809774, -8.2116085703478952, 4.3054115148233585, -11.117751544185527, -5.7506657339441034, -6.1601929909302848, -3.732740466180779, -11.261414242734437, -8.0099398507205191, 4.2895158747096467, 0.47664487887466933, 2.3252453178811465, 1.164430286212123, 0.86319547550848241, 0.12072436644322472, 0.96326571070516387, 0.60906370022364942, -3.8004568077899661, -32.147836838431445, -54.074972316672174, -65.573862825648646, -60.643902512124406, -41.141712299851122, -16.752391317324395, -3.9368165535393809, 4.1754888650460389, 2.9800299945570101, 0.95069246916240213, -0.29595929991782399, -2.2691032318803499, -4.5320020023541936, -1.0662285592482377, -5.9124192136821918, 4.4471445589998728, -8.2198692881497806, -4.9856424549649665, -7.1318253263858535, -6.0006304228248819, -9.685955117463573, -0.83451213573115879, -3.9754701567757316, -2.7503236900904167, 4.9327112002405231, 1.5327652909312637, 1.1004477970868634, -0.28574074744888678, 0.11426292455844969, 0.65238351077926593, 1.2764820376728394, -15.462856466374522, -33.367481359773095, -62.198686950727343, -59.858730768372553, -46.54077201833131, -24.652619118640224, -13.505006616733089, 0.15179077698109764, 2.6863948659019079, 1.9641802030643754, 1.0534870856484704, -0.73577412998863267, -2.5312603283157147, -1.3533084788499781, -5.6194552495050258, 1.979645804576063, -3.7273275005615623, -2.4332061899312447, -3.561851886896878, -5.3597212899808397, -8.2614925402208979, -4.0162352275216939, -5.471113939106738, 2.4168167113542718, 0.020021422684962133, -0.20787587650621156, 2.6342781156582284, -0.32403225688256132, 0.20594677690590416, -0.22606120775752253, 2.01853077774176, -3.3747756868998953, -12.992896188264998, -31.301364606284267, -40.909481344219984, -26.809485534888527, -25.156847324744817, -26.746787584056008, -9.8760458334037811, -5.576914824230828, 0.80720029239978064, 1.8536817132476344, 0.28624805719868845, -1.2038275093350328, -1.1809123553765482, -3.9090515756474855, -0.10263295233946072, -2.9667631763084428, -1.589327259999552, -0.86117313527738326, -3.3125592316970565, -4.4078100962970224, -3.179141662351582, -4.5067864970337235, -0.5553262362525373, -2.5498407756565928, 2.3076802702931301, 0.19981301766362944, -1.1326412370424508, 0.9708722088802425, -0.18988703638015317, 1.1511525903296145, -0.27065475805034434, -3.2627913287119403, -18.099079313674878, -36.280107429421662, -56.94273379651932, -71.719340760368894, -72.231190035836406, -36.895178406764366, -28.484337861013827, -13.026034555561461, 1.4397918579755735, 0.74909741969062116, -0.43871934228165033, -0.49805533537312413, -2.8871606625355364, -1.1303995452351521, -2.5451436559397544, -0.92889636381573193, -0.10257790692130979, -1.4694727348954375, -3.47088042643851, -1.6317774897434372, -3.3483434682483164, -1.7180755446077083, -2.0067122081730231, 0.90154843827713693, -1.4670778837513718, 1.0650111541187297, -0.047905313676639846, -1.1528550937233546, 1.5673786316984972, -0.48894354077444435, 1.9842035662707793, -12.693902195544938, -39.769136567331614, -82.304975309079381, -68.364029336892514, -324.53401456188737, -231.73584987382011, -151.29208808113108, -80.815706494855604, -31.380656277665615, -8.8112838568343115, -3.7825574143705687, 1.1149262389696379, -2.9722975102588807, -1.2749029797076188, -2.5736261490777141, -1.679944914042758, -0.21997349279605258, -0.0072612106766204651, -1.3199204785521295, -2.0999344700147602, -2.3742700657768196, -2.2583319261561177, -1.1746986822405874, -0.034985154955167297, -1.0092937918537661, 0.40700212695667115, -1.169386034801607, 1.0641170511547318, -0.31982529888503974, -2.3310052693731778, 3.4567160839116182, -2.8647426984891329, -32.552002455687209, -116.98390967138671, -198.94197841299811, -340.7656126950431, -996.17063256474341, -770.86385201715302, -486.52939506953675, -221.97901463800537, -103.67045476207502, -39.261715784749725, -1.7472058496176825, -5.8736187047078241, -1.2762438485839995, -3.7775973636188502, -2.3957781219887693, -1.831598128086283, -0.80935504019782156, -0.8095209882094927, -0.39414295752690548, -2.6373580888952821, -1.9962698899057312, -2.6242610725724247, -1.0515624140257607, -1.4583889440112356, -0.042806075220638506, -0.5991594867560418, 0.09477041994976447, -2.1114336115238088, 0.041564105453392161, -1.645570244774569, -10.20981320570001, 1.3577640380311771, -80.518340163142966, -264.63237090274987, -646.481245467088, -957.58296584244442, -2329.4915082039943, -1959.4321649356684, -1077.4118984564245, -515.55403813953228, -255.55592612696057, -62.717085150656416, -30.998957295773568, -2.3480777220922762, -9.3325337684514711, -5.2729359146941093, -3.4497798452119492, -2.5417481635934838, -0.83542887465582316, -0.63377862148080311, -0.78431497120560345, -2.7144116941037488, -4.0439693313887171, -2.2874964618085487, -4.0202584980238978, -0.45369004788789491, -0.57907908126534979, 0.1197295503788481, -1.7033561682904654, -2.1701895043697248, -11.650001060370577, -2.3079138134832218, 1.7115783105395919, -28.862997769747821, -130.56706965451951, -713.08152385953122, -1438.5211303616488, -2151.926578142451, -3481.535597542063, -2413.1056871868605, -1470.8308615232086, -876.95522185705033, -335.07671606133954, -190.87870662958562, -32.978021381977214, -26.682014936266988, -13.48160663472185, -8.8039498431579233, -6.6178270656423885, -3.7427284368684086, -1.1736245693095617, -1.1631844631411714, -0.82967484502748334, -3.6146413255534444, -5.614062126861783, -4.8828731457814465, -2.619934931403141, -2.5290059501698665, -1.0224301618296836, -2.0545006330535864, -2.7888603302093888, -7.7174579848962566, -11.922803368680738, -29.439943085484902, 18.545331481584157, -33.397814851580577, -468.05990914351662, -1355.1576691715877, -2506.491638388823, -3026.0617140239456, -2624.9192342435676, -2694.0942422163216, -1937.2376557226696, -610.36312853782647, -567.30372690179479, -201.43809047465459, -121.9592916587422, -37.989404730638029, -23.382201868158511, -15.879006183075566, -9.3160200641569801, -4.5680830401307739, -3.4318959866990371, -0.11031060182210287, -0.78121801903713106, -7.7847619200437572, -7.0127031874072889, -8.7214065300146117, -6.4643064804234296, -2.0534180946007163, -2.6219523498948099, -2.5268882566736321, -5.4454852920506234, -9.009222722598933, -22.178078450833912, -16.935754226078039, -96.805728919100844, -159.86878938364163, -750.23472664477129, -2119.7499173636857, -3582.9824914214882, -4516.8974536331352, -8415.9227315857224, -4810.1023052011687, -1210.9754315912437, -463.64281724563131, -110.11930975746253, -411.20082432868651, -157.55549534038482, -57.160869905334962, -38.144824969171324, -20.558561534906186, -11.961754213185522, -9.2328346536099755, 1.5394495557011911, -1.9950695133570939, -8.4592989146598381, -14.5518442058491, -6.8858593350514123, -6.8502427898925227, -6.0277039354547091, -0.82473624462553619, 0.7831608409739802, -4.1802620318743058, -9.1243948190510782, -16.875977506192154, -32.905184819607861, -35.55459340255284, -122.67808226552924, -514.71454200305027, -821.48267137489574, -2789.7914675081947, -5469.6585676007144, -6467.5546779833749, -27745.708494118051, -18373.599790964956, -7153.1577950265018, 139.0089391760178, -239.12042069169632, -486.41083616652713, -144.17841735614894, -91.597351236029397, -36.983418680226798, -29.52344492191359, -17.530689402649603, -11.472717532816715, 0.49184661171508715, -1.2754674400467305, -13.244388638951113, -21.283130178012485, -16.161012153790605, 3.4669422259560148, -14.833291452397047, 6.4142604093547071, -7.1882909197807701, 0.36714120063543831, -23.623139151504223, -16.730489448483766, -50.060212982262158, -40.805440061890259, -146.45498278007528, -545.33543865451918, -1748.9561003744159, -4085.0339896290589, -8553.5264674688297, -22841.42084500867, -17213.595236981979, -27817.100568112102, -10882.302955904914, -2806.7151144576032, 113.11650603552238, -714.3011765913102, -258.32278440436545, -84.034753639410752, -64.314813850969756, -32.473901904667066, -16.600635746256838, 0.34733716754136956, -1.7416101263050108, -17.401343902608698, -22.272265924680649, -14.131264529805808, -19.629747734378629, 3.5205960317556224, -14.232799652319452, -14.472211987615371, -7.2952697383626051, -2.1850531713375001, -11.025047422886134, -26.960578056534132, -39.308430893651277, -117.89522553299832, -106.61462896985047, -1120.3666800727583, -1103.8692252741987, -5794.1219231082987, -10829.417860945698, 544.0730266990613], "imag": [0.0, 39515.399789254865, -15382.502646592808, -2918.5213899411633, 1191.3150820979915, -345.80526987183259, -91.963497561164317, -108.06830259743781, -23.431327605037779, -16.610810822958811, -2.2742971526945692, -21.94540337447156, -21.272420402577179, -19.057735286082725, 52.376313120912741, 8.8521975026144215, 0.0, -8.8521975026153612, -52.376313120912044, 19.05773528608244, 21.272420402577229, 21.945403374471546, 2.2742971526945164, 16.61081082295847, 23.431327605037779, 108.06830259743377, 91.963497561167031, 345.80526987182992, -1191.3150820979911, 2918.521389941166, 15382.502646592799, -39515.399789254865, 16946.371225111547, 11272.400870696511, -1841.1630655848539, -1171.8258105148211, 109.26740577843201, 109.43221584454041, -206.10314812122442, -42.28539321936541, -65.249140172269108, -8.1960517939269071, -25.365956236318521, -12.488977779350739, -20.777136166915728, 10.939736173955986, 13.738393384077787, 18.982014759380824, -12.446635345723246, -8.8305069728752752, -14.016932746731957, 10.847407040619599, 18.949463773817904, 9.5491377266946333, 9.9160507928571491, 10.925693066643545, 29.597688207921799, 110.70270321520633, 119.64570653889598, -28.406380421737747, -832.38513354395832, 3868.3607546707453, 4625.1554139998552, 1299.266384884336, 11955.369188695569, -346.60702359457474, 2363.0865643328202, 202.32180136864196, -295.01076934839688, 277.44131247872377, -208.25011765184485, -68.536452109290167, -63.125416501511275, -30.589238972650307, -20.382558491276782, -12.902690844348575, 1.0182743702449766, 2.2874141051372452, 14.546101055958879, -1.6150967690531892, 0.87386354462209248, -13.38677146472326, 17.407635810762027, -0.60680891034428563, 12.950261495215786, -0.86756998254740836, 13.062832664150156, -2.136096668655318, 35.880437410281019, 66.543583791324124, 106.41042136702396, -154.61175360170367, -142.43138300706809, -204.04622542072212, 637.22651951043269, 14506.214536688893, 2087.241286517743, 2934.8250858413794, -540.57641351250766, 271.57679130866723, 537.49064424335052, 71.610686309506633, -82.566517160157844, -74.489552074506761, -57.142723569279489, -25.254222647826957, -12.544755138678799, -6.7708773337384622, -0.20770764759918051, 1.1194026551973495, 3.6890839097334878, -0.20461611038051675, -5.3737401851528386, -2.2636764639022453, 4.9832600695280087, 10.10754418440443, 2.544597152813191, 5.0447569422202223, 2.8189903732027388, 2.9920185974422946, 11.529259915073515, 53.348281783168488, 50.577306165813702, 119.57179721034167, -786.94393395792213, -901.86972095078409, 1074.2990124084633, -676.63432998511303, -1814.4894639161919, -1058.8873901892568, 349.63255334068964, 268.2484621242063, 380.4257804868011, 97.912476061205965, -71.661879904778658, -72.736940205390937, -37.286147332183255, -18.720186517652358, -9.5628328869678363, -8.2634536416369482, -0.19099280196160889, 0.28567330333833429, 0.071309220847330906, 1.775656575203522, 2.1386941287610384, -1.0231985430634363, 2.4480270844924137, 1.9878096211738889, 4.1535160740617325, 3.5521022242715827, 3.6019889835361654, -0.38778650675348675, 4.5934633035837322, 12.369503115173785, 94.400929285346393, -77.039516694541632, -317.96189631496532, -464.93982303098932, -1928.5847150696218, -1707.435501473529, -1583.8824730375936, -833.14970460709912, -242.65732454029356, 317.34459246185179, 69.371971565542168, -13.453603503282046, -58.678662168810511, -40.697925231357267, -20.16679423742438, -13.090865763493372, -7.6639325468155182, -3.9818184076004774, -1.1480426683317846, 3.4782462601712654, 3.3535274581593777, 1.1304420427842019, -0.78798091056569108, 1.3645618319176871, -1.2482103302418359, 2.6548043613808709, 2.0455422971726147, 3.3794759874708187, 0.28270713586437868, -0.67396364813071052, -2.4299863370655714, 20.048308524208917, 2.7323622379310764, 23.350930435926227, 19.428895667387472, -542.55543458513841, -969.72646934413422, -1881.6935115818319, -426.42488803140975, -203.12933548649579, 221.2759941924873, 75.498646737827528, 81.527654709232138, -23.228148927519229, -35.095892631083601, -18.113211298120703, -10.84781416147373, -7.2190125620904571, -4.6279710639736358, -2.4591204313834965, 0.58454842364750592, 0.9547463106026568, 2.4151219203224654, 0.35567626693527166, -0.34443735246553581, 0.10021534895843374, 0.62975751586612239, 0.075739057981468363, 2.5606009702294732, 0.33652577635989583, 1.0967346902818458, -2.0000864020848046, 1.451434335785166, -7.1043203483245918, 10.682010714917043, 63.119371696969466, -0.21915489532378957, -18.829394319190524, -151.38668525810633, -53.557614725234764, 319.98109193688521, 339.65571159114432, 137.34002448547074, 89.166061674211335, 5.5395407010458548, 3.1394961579749192, -15.790153056071546, -10.068399035154068, -5.990189510359599, -3.8184783724455591, -3.031311871551015, -1.7050468427375405, 0.29997994657424726, 1.0820090369221063, 1.186145834536469, 1.1035985643781976, -0.026686439684276222, -0.021861987241408937, -0.71069133238487792, 1.5408441736495715, 0.88964240698419117, 1.3226298476418663, -0.31341792844049038, 0.36542819178090652, -6.2831724147446009, -1.5019641274621849, 13.705577255286178, 14.08988446983488, 43.376064565045787, 54.204646228028693, 132.60719521227122, 62.432091745032416, 219.86853407025291, 133.19971898528303, 106.65962198554573, 32.509510578136677, -0.32173120932219279, -1.0472919151881939, 3.0400482541159932, -2.1373375769283371, -3.730023177462626, -3.658884080605465, -1.7579654575817145, -1.4081716233776314, 0.53847505259675243, 0.97164442609396484, 0.99557444173589427, 0.11126643861839057, 0.68343802732828218, -1.8968331338371984, 1.2370080984335854, 0.24616862215977253, 1.6488725749132858, 0.51751999590405229, 1.1293193043526017, -2.440127533596657, -2.1096176983280075, 0.86862341139232857, -3.2906850406637935, 10.529105330387669, 21.528607110729595, 53.864359931260871, 77.645971701549371, 219.35042572397626, 56.646725304489401, 72.597133152544643, 25.283726226154087, 9.5916945360518575, 3.5131066387109651, 7.8353712095885921, 3.7982495059531924, -0.1320379920173739, -2.6872144914167868, -3.9932995411602161, -3.2496097582258021, 0.34753129477634409, 0.51108563039490118, 1.5779290838292743, -0.32098662744154494, 0.85050436376706862, -0.95269533500567993, 1.2514468795435802, -0.80232514327112969, 0.9402998385797201, 0.083484537520043395, 2.9970442493787712, -1.3537504507858638, -0.49606931853204594, -0.40634793694041288, -3.2049709482452999, -0.90733505109423707, 2.4367446291982722, 14.425788131967863, 11.285893196605656, 41.383231407558732, 26.64930600456886, 3.49019745229235, -2.7278278900775033, -0.6780497768719117, 5.1972517053508067, 13.315592278460391, 8.5655340270495799, 2.7986942524720009, -1.3188307478897958, -2.9560147101356677, -3.5039625138893249, -3.2351264422424442, -1.7837191938553947, 4.1370294214229899, -0.48575889336608402, 1.5705428299533406, -0.28712766434912351, 3.0263722138472242, -1.2120159426024513, 2.3578685311613299, -0.57595981339550073, 5.0023110313506045, -1.3965343408401143, 0.57130018359553258, 0.97601539997779907, -2.5856117766371072, -1.4572886030272592, -1.697304402058907, 2.1030121366448049, -0.062995146217583023, 4.9612937854964008, -0.301351161950073, 9.1580358876592047, -26.774160253651129, -14.352442298363405, -1.3280628610826339, 14.662722831107068, 13.065714024917916, 9.0142686843581057, 2.3156698002103213, -2.1494090398895276, -3.4369058394752816, -3.2885833247038136, -1.5589303641797962, -1.2624013759488528, -1.9675974847606275, 6.6808538974877765, -1.9845455926326385, 5.8520209082315047, -0.64649466936933941, 3.7090325345277484, -1.4383189901623872, 7.6358217658181289, -2.5011370399824613, 2.0288771570791524, 3.3870661540364408, -2.1726948090167277, -1.6227282885568253, -2.3401345171732064, -1.0784728701462345, -2.329913042321786, 1.6766227476276099, -5.5208279800184377, -13.304914803323909, -34.683237345909106, -16.2208922311743, -7.5614574111833583, 14.803696771258469, 15.579335900760762, 15.161631552742872, 8.4660409590375174, 1.9742581617985508, -2.2318082441740326, -3.1677451000476946, -2.7136257844502993, -2.4663578849843404, 2.1470642674041458, -0.80807516468244989, -6.8039934755458935, 11.462761097859508, -2.3200072133134322, 9.6476195054900042, -0.58323258923086063, 10.466810618341768, -7.3966372849294499, 4.629755222962074, 7.8499060069144697, -1.2532724460122664, -0.71383693570895246, -3.0356422051110532, -1.9171318821546592, -3.2905248775997, 1.1638954652799918, -0.8003122215164804, -7.6686022187651925, -13.379436000591463, -2.0784151782651223, 18.753674553162941, 37.596939514973172, 28.201887912811504, 26.441177038828386, 17.313699289624569, 8.2605837012813357, 1.9157665349814501, -1.0360449197814665, -2.460835808457071, -2.9435912594789997, -0.73745892985465067, -0.80698208098757895, 1.3512050433752707, -2.4806623635392717, -10.931358459008862, 20.399475046734903, -0.93914753929729033, 15.633586230850142, -11.808527677086202, 3.7955244266493091, 11.440683264496995, 0.22625003249094855, 2.3910143241324033, -1.5433230899620785, -1.7524971656611896, -3.4392335008624597, -1.2102890230410412, -1.1333111335531953, -0.86689054652400055, -0.77102037498198228, 5.869418392294464, -6.6911708498309208, 60.884710948918006, 43.621563233816303, 43.489599527484941, 33.141784821271486, 18.338861076357606, 7.7096141949396086, 3.1020965354201242, -0.33651454595896624, -1.858665713174497, -1.559439785993801, -1.7180049365163976, -0.49470837698954684, -5.7499783777067037, 1.2816063498557866, -1.6438131382345036, -14.80449956699707, 30.383248800411909, -20.687082737158004, 6.4291237134149926, 13.719178799652914, -0.15202331710012035, 5.6708331746907428, 1.1091130063870853, 0.43083164420390874, -2.423604198850752, -1.2614169037455483, -3.1633275417854718, -2.5428479485652051, -1.0621152637056996, 7.4921468465754772, 13.826120615216594, 48.56895003285198, 43.655937980459306, 56.143788442077074, 39.839822974553684, 28.907966432346075, 17.226166967005444, 9.493352687280801, 2.1248307248495761, -0.10304029106189502, -0.73643011249607004, -0.68086203692422775, -1.5726895782452095, -2.38329292549688, -6.3654622280486342, -12.648471231222512, 2.6502987300644998, 9.1941379366153466, -33.28553680715055, 17.791788634489134, 16.331392880531652, -1.0332061538290742, 9.6376857080971341, 4.1689669632335153, 3.4112249849533103, -0.63064111926197686, 0.028356847121888181, -1.1968584419289052, -3.3957285823190806, -4.7459408986565164, -4.790016252397657, -5.1593354130915703, 13.957717184896774, 20.367299127198688, 0.0, -4.5388798707327584, 12.10851784859719, 15.801052170121357, 15.786196904526062, 6.4645339091427658, 2.6357128260629894, 0.48128762074186304, -0.08159176932681525, -1.1399410088753745, -0.93916966756638098, -5.4695359499377414, -8.4733779831544798, -6.8332707948903639, -5.8759130146162706, -8.1552266379296245, 0.0, 8.1552266379295908, 5.8759130146162661, 6.8332707948903488, 8.4733779831544869, 5.4695359499377316, 0.93916966756637688, 1.1399410088753721, 0.08159176932681525, -0.48128762074185355, -2.635712826062981, -6.4645339091427667, -15.786196904526072, -15.801052170121331, -12.108517848597181, 4.5388798707327416, -43.655937980456407, -20.367299127197448, -13.957717184895019, 5.1593354130924185, 4.7900162523979217, 4.7459408986567313, 3.395728582319133, 1.1968584419289152, -0.028356847121888983, 0.63064111926197186, -3.4112249849533058, -4.1689669632334958, -9.6376857080971128, 1.0332061538290882, -16.331392880531649, -17.79178863448908, 33.285536807150621, -9.1941379366153146, -2.6502987300644807, 12.648471231222583, 6.3654622280486368, 2.3832929254968982, 1.5726895782452166, 0.68086203692425595, 0.73643011249607926, 0.10304029106193066, -2.1248307248495362, -9.4933526872806269, -17.226166967005291, -28.907966432345297, -39.839822974551964, -56.143788442073777, -60.884710948915583, -48.568950032850019, -13.82612061521586, -7.4921468465751166, 1.0621152637059226, 2.5428479485653219, 3.1633275417855051, 1.261416903745556, 2.4236041988507613, -0.43083164420392467, -1.1091130063870698, -5.6708331746907525, 0.15202331710012659, -13.719178799652925, -6.4291237134149712, 20.687082737158036, -30.383248800411859, 14.804499566997148, 1.6438131382345447, -1.2816063498557717, 5.7499783777067242, 0.49470837698955733, 1.7180049365164254, 1.5594397859938318, 1.8586657131745035, 0.33651454595900265, -3.1020965354201109, -7.7096141949395376, -18.33886107635751, -33.141784821271301, -43.48959952748401, -43.621563233814584, -18.753674553161851, 6.6911708498312086, -5.8694183922938254, 0.77102037498232001, 0.86689054652414343, 1.1333111335533379, 1.2102890230411023, 3.4392335008624833, 1.7524971656611932, 1.5433230899620796, -2.3910143241323984, -0.22625003249093578, -11.440683264497009, -3.7955244266492731, 11.808527677086207, -15.633586230850069, 0.93914753929731287, -20.399475046734821, 10.931358459008916, 2.4806623635393117, -1.3512050433752816, 0.80698208098763236, 0.73745892985467021, 2.943591259479049, 2.4608358084570767, 1.0360449197814969, -1.9157665349814337, -8.2605837012812007, -17.313699289624388, -26.441177038827938, -28.201887912810978, -37.59693951497237, 16.220892231174151, 2.0784151782650429, 13.379436000591378, 7.6686022187652325, 0.80031222151651993, -1.1638954652799158, 3.290524877599744, 1.917131882154679, 3.0356422051110541, 0.71383693570894702, 1.2532724460122711, -7.849906006914436, -4.6297552229620669, 7.3966372849294793, -10.466810618341761, 0.58323258923092358, -9.6476195054900042, 2.3200072133134997, -11.462761097859458, 6.8039934755459344, 0.80807516468246154, -2.1470642674041431, 2.4663578849843657, 2.7136257844503273, 3.1677451000476933, 2.2318082441740374, -1.9742581617985304, -8.4660409590374517, -15.161631552742712, -15.579335900760643, -14.803696771258227, 7.5614574111833424, 26.774160253651477, 34.683237345909006, 13.304914803324097, 5.5208279800184936, -1.6766227476275497, 2.3299130423218712, 1.078472870146282, 2.3401345171732237, 1.6227282885568277, 2.1726948090167162, -3.3870661540364337, -2.0288771570791524, 2.5011370399824764, -7.6358217658181076, 1.4383189901624107, -3.7090325345277098, 0.64649466936933497, -5.8520209082314834, 1.984545592632657, -6.6808538974877711, 1.9675974847606519, 1.2624013759488664, 1.5589303641798025, 3.2885833247038483, 3.4369058394752718, 2.1494090398895325, -2.3156698002103084, -9.0142686843579654, -13.06571402491778, -14.662722831106908, 1.3280628610827629, 14.352442298363767, -3.4901974522911301, -9.158035887658194, 0.30135116195024236, -4.9612937854963866, 0.062995146217542555, -2.1030121366447649, 1.6973044020589363, 1.457288603027268, 2.5856117766371063, -0.97601539997780706, -0.57130018359554458, 1.396534340840117, -5.0023110313506107, 0.5759598133955085, -2.357868531161305, 1.2120159426024788, -3.0263722138472202, 0.28712766434913656, -1.5705428299533217, 0.48575889336609929, -4.1370294214229943, 1.783719193855416, 3.2351264422424548, 3.5039625138893205, 2.956014710135662, 1.3188307478897938, -2.7986942524719765, -8.5655340270494893, -13.315592278460258, -5.1972517053507898, 0.67804977687200962, 2.7278278900777337, -56.64672530448825, -26.649306004568476, -41.383231407558036, -11.285893196605604, -14.42578813196792, -2.4367446291981882, 0.90733505109427226, 3.2049709482452906, 0.40634793694041338, 0.49606931853200609, 1.3537504507858567, -2.9970442493787934, -0.083484537520044699, -0.94029983857969957, 0.80232514327114979, -1.2514468795435723, 0.95269533500567261, -0.85050436376704475, 0.32098662744156231, -1.5779290838292681, -0.51108563039488553, -0.3475312947763517, 3.2496097582258234, 3.9932995411602126, 2.687214491416765, 0.13203799201742056, -3.7982495059531578, -7.8353712095884145, -3.5131066387109939, -9.5916945360520085, -25.283726226154414, -72.597133152543805, -219.86853407025291, -219.35042572397646, -77.645971701549428, -53.864359931260992, -21.52860711072962, -10.52910533038772, 3.2906850406638011, -0.86862341139231525, 2.1096176983280075, 2.4401275335966615, -1.1293193043526162, -0.5175199959040564, -1.6488725749132833, -0.24616862215974425, -1.2370080984335483, 1.8968331338372646, -0.68343802732828218, -0.11126643861832354, -0.99557444173586918, -0.97164442609393387, -0.53847505259674655, 1.408171623377654, 1.757965457581725, 3.6588840806054854, 3.730023177462626, 2.1373375769283727, -3.0400482541159497, 1.0472919151882829, 0.32173120932219762, -32.509510578136599, -106.65962198554575, -133.199718985283, -319.98109193688754, -62.432091745036324, -132.60719521227176, -54.20464622802902, -43.376064565046129, -14.089884469834875, -13.705577255286062, 1.5019641274622118, 6.2831724147445849, -0.36542819178094682, 0.31341792844047633, -1.3226298476418761, -0.88964240698418728, -1.5408441736495315, 0.71069133238493809, 0.021861987241514846, 0.026686439684265401, -1.1035985643780957, -1.1861458345364231, -1.082009036922065, -0.29997994657423205, 1.7050468427375622, 3.031311871551031, 3.818478372445528, 5.9901895103595697, 10.068399035154069, 15.790153056071421, -3.1394961579745826, -5.539540701046052, -89.166061674211662, -137.34002448547281, -339.65571159114575, 426.42488803140685, 53.557614725234323, 151.38668525810476, 18.829394319190286, 0.21915489532353391, -63.119371696969402, -10.682010714916952, 7.1043203483248183, -1.4514343357851665, 2.0000864020848317, -1.0967346902818478, -0.33652577635987613, -2.5606009702294568, -0.075739057981359575, -0.6297575158660037, -0.1002153489582, 0.34443735246552043, -0.35567626693504045, -2.4151219203224019, -0.95474631060256077, -0.58454842364747928, 2.4591204313835524, 4.6279710639736518, 7.2190125620904322, 10.8478141614737, 18.113211298120788, 35.095892631083665, 23.228148927519459, -81.527654709232067, -75.498646737828622, -221.27599419248904, 203.12933548649244, 1583.8824730375886, 1881.6935115818235, 969.72646934413342, 542.55543458513785, -19.428895667388197, -23.350930435925818, -2.7323622379307726, -20.048308524208668, 2.4299863370655803, 0.67396364813076437, -0.28270713586437829, -3.3794759874707645, -2.0455422971725761, -2.6548043613806773, 1.248210330242034, -1.3645618319173671, 0.78798091056567598, -1.130442042783935, -3.3535274581592822, -3.4782462601711517, 1.1480426683318268, 3.9818184076005192, 7.6639325468155093, 13.090865763493181, 20.166794237424288, 40.697925231356948, 58.678662168810511, 13.453603503282435, -69.371971565542452, -317.34459246185418, 242.65732454028887, 833.14970460709446, 1814.4894639161919, 1707.4355014735293, 1928.5847150696216, 464.93982303099165, 317.96189631496537, 77.039516694542414, -94.400929285346379, -12.369503115173439, -4.5934633035837242, 0.38778650675346871, -3.6019889835361467, -3.5521022242715157, -4.1535160740616579, -1.9878096211735969, -2.4480270844921423, 1.0231985430638744, -2.1386941287610495, -1.7756565752032289, -0.071309220847206922, -0.28567330333819857, 0.19099280196170093, 8.2634536416369908, 9.5628328869678718, 18.720186517652159, 37.286147332183262, 72.736940205390795, 71.661879904778388, -97.912476061205524, -380.4257804868011, -268.24846212420823, -349.63255334068992, 1058.8873901892528, -2087.2412865177334, 676.63432998511416, -1074.2990124084556, 901.86972095078841, 786.94393395792224, -119.57179721034137, -50.577306165813212, -53.34828178316841, -11.529259915073451, -2.9920185974423683, -2.8189903732028481, -5.0447569422201788, -2.5445971528130604, -10.107544184404102, -4.9832600695276215, 2.2636764639027978, 5.3737401851528253, 0.20461611038107308, -3.6890839097334074, -1.119402655197085, 0.20770764759927202, 6.7708773337385892, 12.544755138678777, 25.254222647826818, 57.14272356927944, 74.489552074506946, 82.566517160157588, -71.610686309506534, -537.49064424335074, -271.57679130866813, 540.57641351250493, -2934.8250858413712, -11955.369188695569, -14506.214536688902, -637.22651951043315, 204.04622542072232, 142.43138300706894, 154.61175360170483, -106.41042136702355, -66.543583791323357, -35.880437410281012, 2.1360966686551617, -13.062832664150186, 0.86756998254746465, -12.950261495215663, 0.6068089103450538, -17.40763581076148, 13.386771464725289, -0.87386354462209659, 1.6150967690552112, -14.546101055958459, -2.2874141051365076, -1.0182743702449171, 12.902690844348964, 20.382558491276768, 30.589238972650698, 63.125416501511289, 68.536452109292355, 208.25011765184536, -277.4413124787215, 295.01076934839597, -202.32180136863923, -2363.0865643328207, 346.60702359456963, -16946.371225111554, -1299.266384884367, -4625.1554139998561, -3868.3607546707453, 832.38513354395968, 28.40638042173725, -119.64570653889508, -110.70270321520742, -29.597688207921749, -10.925693066643381, -9.9160507928571686, -9.5491377266944308, -18.949463773817815, -10.847407040619126, 14.016932746732627, 8.8305069728758134, 12.446635345723296, -18.982014759378298, -13.73839338407706, -10.939736173955323, 20.777136166915735, 12.48897777935125, 25.365956236318532, 8.1960517939270616, 65.249140172269151, 42.285393219366988, 206.10314812122587, -109.43221584453876, -109.26740577843286, 1171.8258105148195, 1841.1630655848473, -11272.400870696491]}};

  var right_eye_filter = {"real": [1.8229079259010603, 0.097810498648582461, -0.55840092137248587, -0.99970462842356578, 0.18757876559092043, -0.81617694863114465, -0.17457078018685562, 0.13822182613073089, -0.13830885288846723, 0.14088352498892928, -0.11242245121823281, 0.64190144530750459, -0.18081689212517704, 0.84757445423403044, -2.0367692338977426, 2.3450651085370726, -3.2227771639624789, 2.3450651085369945, -2.0367692338977101, 0.84757445423403854, -0.18081689212518082, 0.64190144530750537, -0.11242245121823641, 0.14088352498894169, -0.13830885288846723, 0.13822182613073003, -0.17457078018684977, -0.81617694863113666, 0.18757876559091927, -0.99970462842356267, -0.55840092137248509, 0.097810498648581323, -1.0960340088024074, -1.9119199452512301, -2.4095702665388479, -0.55162352804953241, -0.50505328014021589, -1.3068505835636635, -0.49437187443975589, 0.23127204626685588, 0.043350794355039197, -0.071787406154436809, 0.070854449837205943, 0.17221102955705567, 0.44602122877614064, 0.074148205591900399, -0.015611524439393865, -0.79896724757292914, -0.67155961060437053, -0.49375784053273253, 0.028167647498424205, -0.3191891366103583, 0.53582170174408217, 0.20183473326047152, 0.12710467168208503, -0.071400263514192097, 0.074560604448017792, -0.12451483496807111, 0.051358135035693774, -0.77282398113384443, -0.42160647485916963, -1.1311602269894514, -1.4625324828122208, 0.3337871926813808, -1.77011609742092, -1.4302518240108344, -3.0428213499062116, -0.60631225487833551, -0.13683987631719793, -2.3692424085383519, -0.34105804260324346, -0.25969657852057992, 0.23610433796619859, -0.27685168579683173, 0.16986402710259335, 0.073612585805396993, 0.57704911017089122, -0.059867579479423505, 0.51680219528175042, -1.0666730319382505, -0.0056552094670686828, -0.75809939060745812, -0.064701320250044561, -0.19832318162238824, 0.37732986906226257, 0.20777584924550152, 0.15451076629740465, -0.013991851319401968, 0.13841341497021592, -0.086883949036928532, 0.25261423619714551, -1.1991385138433881, -1.9867837341406693, -2.275962773839737, -3.1079150257531585, -2.3995834975192567, -2.2937692343725722, -2.1872173045799017, -1.3988308931230504, -2.2073957813815439, -1.9667941627002865, -1.6748432066635108, -0.92650772032564344, -0.054197237250052703, -0.18026213329416008, -0.15232124758200827, -0.016555865669302033, 0.31289505893870784, 0.42806542968274719, 0.23124350286854853, -0.087366382764607439, -0.12552132795947232, -0.12547908619418155, -0.38089709050886683, -0.28444076658768042, -0.11944152964360766, 0.12056136689031131, 0.21189843131890268, 0.16581598470154221, 0.13376820638890077, 0.22205496825803592, 0.15120100371874812, 0.12380717441381156, -1.2352596784322261, -2.2222759116849211, -3.3782856809989692, -3.415076124219421, -2.7282977589825297, -1.5576789730825455, -1.6478932560447972, -2.067907968457094, -2.004290735457912, -2.6427456963680775, -1.9309474679838621, -0.16864865516592528, -0.22642518078963322, -0.13321306237600422, -0.20692971953006373, -0.068344938706069003, 0.14493915164047724, 0.46505832474821007, 0.32789481378377733, 0.1852927254910838, -0.1356638873386786, -0.03585192275390197, -0.17203834043005656, -0.15954900238018477, -0.059581713131431221, -0.017228379259871054, 0.12402459410135006, 0.1524538089963059, 0.16271946063708961, 0.24817234249560427, 0.26053579199245763, -0.04769125558408293, -0.81459993031792033, -2.0740660744196808, -3.1544891598954261, -2.9212825837849565, -2.4077419089431702, -1.6411629435379833, -1.576697627349694, -1.8007661961299257, -2.0001525985045707, -1.5107274159689619, -1.2839600483166405, -0.63196711118813498, 0.31071574064221719, -0.21370915949408273, -0.16393119308951343, -0.097481704015839707, 0.13767875532837173, 0.23695911940697742, 0.36158774196732829, -0.00066962538216623158, -0.1026502520704758, -0.18176695609293456, -0.059120611570986824, -0.13702193484548986, -0.0073538013157976303, 0.020281061259494877, 0.15032501459982059, 0.16876214929227357, 0.18780650312631536, 0.16308782299108887, 0.18583847563977354, 0.44907296092364651, -0.020800703185301726, -1.4297091333258476, -2.4259185480628145, -2.4053777736536626, -1.9821307035675879, -1.3372642957080885, -1.2989780551182537, -1.3731553217305845, -1.2269479805895975, -1.2032897772528626, -0.22206046284030648, -0.18415548289109809, -0.23415549346578352, 0.077936325689887453, -0.21633114300736572, -0.059449722211757941, 0.013318329293146938, 0.28775437300883983, 0.21963323601338633, 0.16649953505637383, -0.18974789333555656, -0.17379580132236441, -0.23416130311702454, -0.13478379984035538, -0.13112027137758978, 0.033522350558872455, 0.13259733500476653, 0.171380750952115, 0.15737574769334917, 0.092477162456605533, 0.13448891283084696, 0.41161459424817443, 0.35609170613712005, -0.55316449850203808, -1.540851379466907, -1.8005308506197801, -1.5719273509294158, -0.94040577953316051, -0.83899416480020927, -0.77336416928591256, -0.66562411016509948, -0.4002640865408188, -0.36750971454913561, 0.2414435659750552, -0.065677188177910795, -0.21341675767851534, -0.041369287190265204, -0.087404842921799578, 0.04460147122538273, 0.19583406251777175, 0.1830038441344799, 0.012219595757112435, -0.034593273427629516, -0.14926486203867156, -0.036665364495836496, -0.1306231554860259, -0.086381624051938985, 0.0020423415177502173, 0.11239290885891448, 0.12781279786870536, 0.10954302373131516, 0.14996801038078228, 0.12965098836907352, 0.14324588543961356, 0.0567484033157079, -0.079342592710004017, -0.77145898274835445, -1.1705860882999304, -1.0754357146023004, -0.5463269466436349, -0.37732231762995055, -0.29185933229148303, -0.18245346577017127, -0.15252816280103537, 0.00992307413149221, -0.05334501261419268, 0.10643359538216246, -0.069635302172998029, -0.20853401810086858, 0.03871878333386132, 0.024793140061197767, 0.22215018549405419, 0.19090693911120471, 0.13458393481660855, -0.1226120784542075, -0.060406846903667433, -0.083060383383984554, -0.016925686434954099, -0.033352938195947639, 0.056474422402956102, 0.04873056181166667, 0.092098221631537164, 0.13542751998114597, 0.15540921558269635, 0.10094403852684107, 0.050489672984821425, 0.089840998861512991, 0.018445471788018183, -0.44280324831238471, -0.64559475523542686, -0.64123409592876457, -0.25571779361731761, -0.15489773108593363, -0.10375533557574061, -0.074018947274090252, -0.074021765277388324, -0.034956034554291714, 0.065331700319185393, -0.079299771847393716, 0.035725424097319471, -0.10252861876832269, -0.22107962950770202, 0.20755848067860572, 0.23157078159613848, 0.34013467279608883, 0.23914223921471078, 0.043591964044129211, -0.20186945117744784, 0.04172561648658725, -0.038784831650455286, 0.076248151019351923, -0.060276976551200255, -0.0031358189183758184, 0.13054366560393055, 0.16122088670834137, 0.12129220423951546, 0.064624059271846127, 0.063153633523538075, 0.036868954773612302, 0.025599835220982206, -0.17872521900892777, -0.37577894082797708, -0.33418602947194676, -0.19087946198724595, -0.092430559387195924, -0.15843188266072916, -0.1178716916883143, -0.079832857077627425, -0.038455609721169501, 0.015668866487966955, 0.0052656766019976578, -0.12562510603385343, -0.024970842739258457, -0.030574039563531708, -0.21969881405226874, 0.59191387060782108, 0.39965780946904006, 0.22624763974293111, 0.077143781693831126, 0.078542516808501189, -0.0038697706067326258, 0.21858339549378, 0.083870133819846815, -0.19149929243694441, 0.053673315180545467, 0.22201073984886688, 0.16922848807595664, 0.12511007660405662, 0.095111634855384236, 0.084195395624058103, 0.010195208908487656, -0.016589123313681509, -0.076922699191606214, -0.17023093289451025, -0.26998035777525775, -0.28189859430096476, -0.32749231042729776, -0.240474927671948, -0.27714150491609907, -0.16857870511456344, -0.056310601502134704, 0.026291702225850644, -0.028508101274427284, -0.066307061790986485, -0.27187198211633473, 0.066219257946262391, 0.32825613521942065, -0.21303758386300781, 1.1917438602108388, 0.2807025357241521, 0.23447144426975483, 0.16511529097099151, 0.40113579910945835, 0.017152293761210982, -0.1450564820739392, 0.13833755803781553, 0.2361453534315919, 0.16033553043559276, 0.17442784770871, 0.17988585089228476, 0.143828955260344, 0.07132752932041192, 0.016244981011210025, -0.013577696292888701, -0.024045478766089354, -0.11184718959298219, -0.14666574805211069, 0.0080876817899727359, -0.16842937423863127, -0.43543489379944889, -0.29975286851709859, -0.22753898297998879, -0.069036032916579657, 0.014977564920406507, -0.020420877906038481, -0.13524198281736244, -0.15739380447541659, -0.33401260934309918, 0.46815371603113554, 0.93021729768322625, -0.26733338229185055, 1.4166629302294091, 0.60664479608939625, 0.3603810860087503, 0.4605515924213614, -0.32071019427276837, 0.15916183580862947, 0.55142162929110317, 0.20419289205444074, 0.051921880744650394, 0.24679565757292954, 0.2706202610478356, 0.15590400545853877, 0.081859441051199647, -0.040980231107277158, 0.019596242113331462, 0.094364427919773758, 0.065278519802775978, -0.029838116901178446, 0.15435464918439099, -0.039386655944161249, -0.077796406016204619, -0.28158476919608044, -0.033110128022724852, 0.018548614200940845, 0.067046107651037731, -0.044245201781535203, -0.1525534131110006, -0.22929077462390082, -0.085302710712388263, -0.049302393683332231, 0.85744368463127818, 1.8448220136861364, -0.68744556831975012, 1.810880881855317, 0.66237039703709566, -0.31567909429421087, 0.83232217907475781, 0.97863365922997991, 0.30994126117364096, -0.041163173314528664, 0.17633262873947353, 0.23161854928102976, 0.25087704366702551, 0.19868696729956423, 0.093569887694449877, 0.032362324442922322, -0.0027507666136337679, 0.21821986304703905, 0.37880734420129814, 0.40096920495374666, 0.93561154193066887, 0.61326039955329958, 0.1638528799494483, 0.1009541629695858, 0.056601591846233243, 0.15561323638878471, 0.073000292812971587, -0.0055442453146915694, -0.13817032242271102, -0.11770539535407684, -0.096245457278447424, 0.46442894125096079, 0.45587938373772585, 1.3432089992982477, 2.5059762271849535, -0.93829697639874887, 0.6492144586928863, 0.79782532034480069, 1.3025551528258366, 0.94174974100732234, 0.099921469659734793, 0.28712786266920659, 0.15853680079243379, 0.130717335778855, 0.17042917695126153, 0.19986443324539621, 0.13725228360851915, 0.029723534135295476, 0.098143635338702864, 0.19047751491127032, 0.49335337973435212, 0.78089304412099847, 0.29686587428828037, 0.38131881367791126, 0.40643673652514922, 0.19053499830856688, 0.20033550195294633, 0.13287714582076576, 0.10533560171090586, 0.00085487897815388243, -0.049435296406267468, -0.081309411554979491, 0.057947716710403128, 0.48207744089263116, 1.2538880645112733, 1.2204758332556214, 0.87793863876625744, 1.8796293205435075, -0.45285576127696725, 2.2308682152547137, 1.2382711063757557, -0.035207936995945072, 0.88175672278306683, 0.55916031961657942, 0.18718127547628777, 0.011764673252274449, 0.068747006595272581, 0.13522321325294812, 0.17151312046437606, 0.10315365060575944, -0.0011239413451798732, 0.14993420590829387, 0.38959110228082239, 0.38845862264410469, 0.69716730182732189, 0.51802064393501412, 0.28837767001488912, 0.10583936790249669, 0.071016615670210698, 0.16001776032454934, 0.10715662619027419, 0.056188716759532117, -0.035825840155044517, 0.0061469917968111389, 0.089493877843564718, 0.68387295014825999, 1.1016519558168656, 1.3182383587355595, 0.66635382040153524, 0.54863673632097221, 4.0547770231048936, 0.54863673632097154, 0.66635382040153424, 1.3182383587355562, 1.101651955816866, 0.68387295014826144, 0.089493877843565064, 0.0061469917968106288, -0.035825840155044517, 0.056188716759530431, 0.10715662619027334, 0.16001776032454856, 0.071016615670210018, 0.10583936790249539, 0.28837767001488829, 0.51802064393501346, 0.29686587428830957, 0.38845862264412201, 0.38959110228084654, 0.14993420590831108, -0.001123941345177488, 0.10315365060576374, 0.17151312046437922, 0.13522321325295103, 0.068747006595273552, 0.011764673252275867, 0.18718127547628682, 0.55916031961657786, 0.88175672278306205, -0.035207936995944634, 1.2382711063757532, 2.2308682152547106, -0.45285576127696175, 1.8796293205435037, 0.87793863876625788, 1.2204758332556218, 1.2538880645112747, 0.48207744089263271, 0.057947716710405182, -0.081309411554979547, -0.04943529640626837, 0.0008548789781495917, 0.10533560171090255, 0.13287714582076099, 0.20033550195294705, 0.19053499830855697, 0.40643673652513423, 0.38131881367792647, 0.93561154193068807, 0.78089304412102711, 0.49335337973436416, 0.19047751491127579, 0.098143635338704696, 0.029723534135297252, 0.13725228360851988, 0.19986443324539666, 0.17042917695126267, 0.13071733577885625, 0.15853680079243432, 0.28712786266920415, 0.099921469659732226, 0.94174974100731712, 1.3025551528258328, 0.79782532034480169, 0.64921445869288619, -0.93829697639874454, 2.5059762271849548, 1.3432089992982421, 0.45587938373772335, 0.46442894125096235, -0.096245457278447175, -0.11770539535407766, -0.13817032242271216, -0.0055442453146945193, 0.073000292812969436, 0.15561323638878341, 0.056601591846233208, 0.10095416296958591, 0.16385287994945555, 0.61326039955330602, 0.15435464918440814, 0.40096920495376004, 0.37880734420131523, 0.21821986304704899, -0.0027507666136306606, 0.032362324442924542, 0.093569887694449336, 0.19868696729956342, 0.25087704366702551, 0.23161854928103059, 0.17633262873947425, -0.041163173314526666, 0.30994126117363635, 0.97863365922997669, 0.83232217907475781, -0.31567909429421592, 0.66237039703709699, 1.810880881855315, -0.68744556831974835, 1.8448220136861369, 0.85744368463127729, -0.049302393683329601, -0.085302710712388291, -0.22929077462390179, -0.15255341311100187, -0.044245201781539331, 0.067046107651035594, 0.018548614200940294, -0.033110128022720509, -0.28158476919607578, -0.077796406016200054, -0.039386655944146774, 0.0080876817899761342, -0.029838116901173162, 0.065278519802780599, 0.09436442791977824, 0.019596242113334855, -0.040980231107276652, 0.08185944105119855, 0.15590400545853553, 0.2706202610478356, 0.24679565757292907, 0.051921880744651677, 0.20419289205443947, 0.55142162929109917, 0.15916183580862936, -0.32071019427277109, 0.46055159242136157, 0.36038108600874996, 0.60664479608939803, 1.4166629302294049, -0.2673333822918505, 0.93021729768322625, 0.46815371603113448, -0.3340126093430979, -0.15739380447541709, -0.13524198281736302, -0.020420877906040739, 0.014977564920405115, -0.069036032916578546, -0.22753898297998629, -0.29975286851709465, -0.43543489379944272, -0.16842937423862725, -0.28189859430095965, -0.14666574805210519, -0.1118471895929717, -0.024045478766081197, -0.013577696292883971, 0.016244981011212731, 0.071327529320409616, 0.14382895526034015, 0.1798858508922834, 0.17442784770871067, 0.16033553043559218, 0.23614535343159299, 0.13833755803781575, -0.14505648207394348, 0.017152293761212339, 0.40113579910946001, 0.16511529097099317, 0.23447144426975502, 0.28070253572415382, 1.1917438602108381, -0.21303758386300692, 0.32825613521942509, 0.066219257946262128, -0.27187198211633529, -0.066307061790987387, -0.028508101274429792, 0.026291702225849072, -0.056310601502134003, -0.1685787051145608, -0.27714150491609657, -0.24047492767194564, -0.32749231042729471, -0.19087946198724157, -0.26998035777525148, -0.17023093289450597, -0.076922699191602426, -0.016589123313677224, 0.01019520890848913, 0.084195395624057118, 0.095111634855381461, 0.12511007660405613, 0.1692284880759545, 0.22201073984886613, 0.053673315180547035, -0.19149929243694658, 0.083870133819847037, 0.21858339549377928, -0.0038697706067313737, 0.078542516808500606, 0.077143781693833222, 0.22624763974292969, 0.39965780946904111, 0.59191387060782175, -0.21969881405226852, -0.030574039563530501, -0.024970842739259945, -0.12562510603385371, 0.0052656766019967011, 0.015668866487966397, -0.038455609721168606, -0.079832857077626357, -0.11787169168831266, -0.15843188266072725, -0.092430559387194119, -0.25571779361731145, -0.33418602947193976, -0.37577894082796842, -0.17872521900892277, 0.025599835220983438, 0.036868954773614897, 0.063153633523536298, 0.064624059271844544, 0.12129220423951372, 0.1612208867083402, 0.13054366560393141, -0.0031358189183775171, -0.060276976551199596, 0.076248151019351354, -0.038784831650455917, 0.041725616486585258, -0.20186945117744698, 0.043591964044126186, 0.23914223921470992, 0.34013467279608772, 0.23157078159613964, 0.20755848067860685, -0.22107962950770196, -0.1025286187683216, 0.035725424097318138, -0.079299771847393549, 0.065331700319185088, -0.034956034554288036, -0.074021765277385243, -0.074018947274086908, -0.10375533557573537, -0.15489773108592672, -0.5463269466436349, -0.64123409592876401, -0.64559475523542686, -0.44280324831238616, 0.018445471788017767, 0.089840998861510313, 0.050489672984820259, 0.10094403852683856, 0.15540921558269635, 0.13542751998114574, 0.092098221631536192, 0.04873056181166658, 0.056474422402955825, -0.033352938195949811, -0.016925686434957218, -0.083060383383990535, -0.060406846903667433, -0.1226120784542102, 0.13458393481660744, 0.19090693911120402, 0.22215018549405383, 0.024793140061198739, 0.038718783333861403, -0.20853401810086775, -0.069635302172998029, 0.1064335953821621, -0.053345012614191917, 0.0099230741314936706, -0.15252816280103507, -0.18245346577017069, -0.29185933229148298, -0.3773223176299495, -0.94040577953315341, -1.0754357146022915, -1.1705860882999222, -0.77145898274834734, -0.079342592710004489, 0.05674840331570382, 0.14324588543960787, 0.12965098836906794, 0.14996801038078103, 0.10954302373131049, 0.12781279786870486, 0.11239290885891398, 0.0020423415177517252, -0.086381624051941733, -0.13062315548602732, -0.036665364495841957, -0.14926486203867201, -0.034593273427634852, 0.012219595757109143, 0.18300384413447635, 0.1958340625177715, 0.044601471225384402, -0.08740484292179726, -0.041369287190262873, -0.21341675767851565, -0.065677188177906895, 0.24144356597505726, -0.36750971454912684, -0.40026408654081164, -0.66562411016509171, -0.77336416928590557, -0.83899416480020206, -1.3372642957080858, -1.5719273509294132, -1.8005308506197781, -1.5408513794669076, -0.5531644985020383, 0.35609170613711127, 0.4116145942481696, 0.13448891283084041, 0.092477162456604783, 0.15737574769334561, 0.17138075095211283, 0.13259733500476581, 0.033522350558872378, -0.13112027137759125, -0.13478379984035713, -0.23416130311702804, -0.17379580132236419, -0.18974789333555622, 0.16649953505637016, 0.21963323601338522, 0.28775437300883855, 0.013318329293152468, -0.059449722211754409, -0.21633114300735917, 0.077936325689886982, -0.23415549346577649, -0.18415548289109335, -0.2220604628402971, -1.203289777252857, -1.2269479805895944, -1.3731553217305832, -1.2989780551182524, -1.64116294353798, -1.9821307035675826, -2.4053777736536572, -2.4259185480628087, -1.4297091333258454, -0.020800703185307738, 0.44907296092364196, 0.1858384756397643, 0.16308782299108818, 0.18780650312631128, 0.16876214929227229, 0.15032501459981898, 0.020281061259495404, -0.0073538013157964212, -0.13702193484548603, -0.059120611570979247, -0.18176695609293375, -0.10265025207047287, -0.00066962538216844151, 0.36158774196732713, 0.23695911940697681, 0.13767875532837892, -0.097481704015832935, -0.1639311930895031, -0.2137091594940832, 0.3107157406422304, -0.63196711118812665, -1.2839600483166249, -1.5107274159689543, -2.0001525985045667, -1.8007661961299211, -1.5766976273496909, -1.557678973082544, -2.4077419089431698, -2.9212825837849552, -3.1544891598954266, -2.0740660744196822, -0.81459993031793032, -0.047691255584086843, 0.26053579199245114, 0.24817234249560396, 0.16271946063708537, 0.1524538089963024, 0.12402459410134949, -0.017228379259870755, -0.059581713131428661, -0.15954900238017725, -0.17203834043004781, -0.03585192275390215, -0.13566388733867182, 0.18529272549107739, 0.32789481378377766, 0.46505832474821029, 0.14493915164048596, -0.068344938706060163, -0.20692971953005135, -0.13321306237600447, -0.22642518078961474, -0.16864865516591712, -1.9309474679838514, -2.6427456963680735, -2.0042907354579094, -2.0679079684570931, -1.6478932560447959, -2.2937692343725686, -2.7282977589825266, -3.4150761242194196, -3.3782856809989692, -2.2222759116849189, -1.2352596784322352, 0.12380717441380877, 0.15120100371873849, 0.22205496825803597, 0.13376820638889372, 0.16581598470153905, 0.21189843131890046, 0.1205613668903118, -0.11944152964360859, -0.2844407665876833, -0.38089709050886922, -0.1254790861941803, -0.12552132795948226, -0.087366382764606329, 0.2312435028685467, 0.42806542968274885, 0.31289505893871633, -0.016555865669298363, -0.15232124758199445, -0.18026213329416074, -0.054197237250036744, -0.92650772032563145, -1.6748432066634964, -1.9667941627002861, -2.2073957813815404, -1.3988308931230464, -2.1872173045798968, -1.7701160974209202, -2.3995834975192563, -3.1079150257531603, -2.2759627738397428, -1.9867837341406698, -1.1991385138433992, 0.25261423619714135, -0.086883949036943853, 0.13841341497021575, -0.013991851319408978, 0.15451076629740176, 0.20777584924549833, 0.37732986906226257, -0.1983231816223982, -0.064701320250050057, -0.75809939060751286, -0.0056552094670687921, -1.0666730319382445, 0.5168021952817432, -0.059867579479421881, 0.57704911017089144, 0.073612585805408248, 0.16986402710259826, -0.27685168579682035, 0.23610433796619823, -0.25969657852055217, -0.34105804260323408, -2.3692424085383355, -0.13683987631719494, -0.60631225487832385, -3.0428213499062093, -1.4302518240108333, -1.0960340088024054, 0.33378719268138207, -1.462532482812221, -1.1311602269894572, -0.42160647485916913, -0.77282398113385165, 0.051358135035689895, -0.12451483496808054, 0.074560604448017945, -0.071400263514198398, 0.12710467168208478, 0.20183473326046905, 0.53582170174408328, -0.31918913661037829, 0.028167647498415164, -0.49375784053277538, -0.67155961060436897, -0.79896724757297555, -0.015611524439376389, 0.074148205591898927, 0.44602122877613765, 0.17221102955705844, 0.070854449837212188, -0.07178740615442418, 0.043350794355038948, 0.23127204626685866, -0.49437187443974595, -1.3068505835636535, -0.50505328014021666, -0.55162352804951942, -2.4095702665388461, -1.9119199452512292], "bottom": {"real": [4046.4241509904555, 28839.973879370627, 10191.512031448321, 4381.7455807293263, 2071.9548413915022, 1107.2825867454831, 528.34551553150311, 308.97330299730402, 185.81061014820492, 130.08108126519062, 87.65365496956511, 59.09553675383809, 43.506269455848397, 34.575222311681692, 30.798097452905282, 25.523061346781674, 25.951646714603154, 25.523061346781589, 30.798097452905211, 34.575222311681706, 43.506269455848361, 59.095536753838019, 87.653654969565167, 130.08108126519082, 185.81061014820492, 308.97330299730379, 528.34551553150334, 1107.2825867454833, 2071.9548413915031, 4381.7455807293318, 10191.512031448323, 28839.973879370646, 13493.224333003216, 16392.519951456161, 4871.8353885075767, 1571.3337493887716, 567.64096645153529, 373.6703632325283, 244.24660034041102, 142.79597933554817, 106.13580676907658, 75.858347622710525, 58.061322564190078, 39.854538473021549, 30.569538051408923, 25.094853941398878, 22.929757321982656, 20.808198660555963, 22.04888812794956, 23.622937534136554, 29.138683151168021, 38.082981074479143, 54.39934218587819, 77.826621492011839, 121.61239162949131, 177.63416429867098, 254.30481783551838, 430.47940336338183, 664.63525809030591, 1219.8477670929726, 1935.5749815900854, 3358.0980991141623, 6069.2175916916049, 8660.7039291701622, 15384.540019848313, 11175.737303494303, 2216.879483433469, 674.59859086304846, 308.57630937597452, 222.13525013253278, 144.62539946693838, 89.351789047349641, 66.200283784031811, 53.5880480094322, 38.104835124660447, 27.112718944065261, 23.033311632510099, 19.858863545618888, 19.408029208714364, 19.38215160767772, 20.871711217553681, 24.726583224259915, 29.429525390428484, 39.688247321389746, 54.026677368666491, 71.509189516532359, 109.7023701375058, 145.30501493896827, 183.84765943176359, 237.38092500065588, 353.51632607639505, 531.27032729465725, 719.17065363709912, 1367.9024800373177, 2857.7322293344778, 8625.0149751320059, 3926.8611003464521, 2444.3527388912776, 1028.8359899085383, 585.56166554295623, 332.57137935864864, 180.13762334769046, 105.17011934648103, 61.496465220623485, 45.504823244138095, 37.908460172493172, 30.846794326525625, 21.222093075405745, 18.718288087401802, 17.679602313216872, 17.409839934721365, 17.794391783727544, 18.55926931620083, 21.348409581307148, 24.39997962145603, 30.767061622228063, 38.103008129659166, 44.81251118779231, 61.577721983396955, 87.291485884508717, 106.99539363556599, 134.18057082099898, 169.37440787587974, 269.99443977661724, 364.56248799144709, 674.50839546082307, 1521.022929703357, 2634.7343778883865, 2024.849011267275, 1926.8239401023498, 1491.9478410044117, 611.83627918833088, 316.43682665588744, 155.99683828976544, 89.673379864750018, 50.013293885425135, 37.528009707176061, 32.4518569290627, 24.966146703509182, 19.130394004010906, 15.343856356149828, 14.843145659919786, 14.861292517540363, 15.036681247518919, 15.312687438440403, 17.138709070816013, 19.446116741695533, 22.850207518010233, 27.457440287528367, 32.581505308308088, 40.985078317877736, 54.412823137373685, 75.762437644265901, 94.733059346587339, 128.1467358253355, 182.29010502256293, 275.95498073034861, 527.32695578494008, 1132.5867520786235, 1866.4077869841046, 2266.7457843108455, 2107.8495169895441, 1234.6592459623437, 673.70954283481137, 266.6693703142779, 139.47307538222793, 66.730731113314476, 41.917980917088734, 31.2590211502941, 26.786032891522527, 20.35627716260823, 16.038244917569745, 14.499148814332527, 13.459360575928033, 13.144389071570192, 12.567429683418663, 12.230328765246885, 13.466217665828195, 15.328301760046475, 17.144679989146308, 19.68756841312236, 24.074134044705339, 32.727034612286992, 43.026808431859955, 59.193773906230369, 78.820512563030945, 92.994178544706472, 120.42091176843755, 201.9182636225097, 436.44287859172925, 877.8862778005057, 1439.6385876846614, 1649.9911393469049, 1699.4038415062987, 1039.2560892520887, 495.51661529689329, 235.81544665938515, 113.58561083280532, 60.921551746622946, 35.725757089786256, 25.024628727892466, 22.490208420088727, 17.759823791920191, 13.543616943986416, 12.938917306264663, 11.956364952724385, 11.421939705679733, 11.372903592178258, 11.032765269291394, 11.408229662647633, 12.481114469594095, 13.60275540468532, 14.91952183557448, 17.807798659576154, 23.277252196336814, 31.950664619854233, 47.416694920263616, 56.268912844615144, 64.959626427586997, 85.070809539003847, 130.82046704446515, 257.67571935262418, 627.46721263291658, 1194.1693767483914, 1080.1900960853154, 902.674413704009, 600.04055794738224, 333.23520458041997, 166.5653831933532, 88.946305547571072, 50.717393232745131, 31.897215329939996, 23.060146944216118, 18.579780562544169, 15.572760511446054, 13.273777678692191, 12.224913053368416, 11.68638594982613, 10.392044527527784, 10.422646713468026, 10.113778554702394, 10.225072497047023, 10.776357928238541, 11.471833692521193, 12.585855785544721, 15.131216045563061, 18.856673404562432, 24.858220592568422, 32.657280802203381, 43.037987696240307, 51.536289299313914, 59.08796022590117, 89.418846636419246, 168.44781050782811, 382.14409608709747, 745.27797642375992, 544.93523795856049, 546.63255943550212, 362.69938393816085, 222.4530875664997, 124.78354764285341, 69.155510455436144, 41.705006957506896, 26.952419331651356, 19.778555411511121, 17.743475715717917, 14.471795156401063, 12.765457059373892, 11.899864411981882, 10.85818004844373, 10.325708895539952, 9.5692719745256376, 9.2113480820863387, 9.0680329970290128, 9.7734432560375648, 10.488284402310196, 11.323197140674811, 13.23504887223821, 16.674941080314653, 20.771526297093455, 27.569417818570489, 33.103068481604573, 37.131609415223707, 47.964760430736398, 66.578817507603574, 119.94841754808802, 237.18123750436465, 409.50889944188236, 307.01018353832677, 288.66760291638428, 236.16368190120858, 154.32114106589464, 92.303773245695481, 55.468009578938926, 35.843010431224045, 24.692475316947775, 18.31794202383119, 15.815283825259236, 13.970653175227845, 12.321358605090134, 11.166914874614415, 10.532076178141539, 9.9738582700772742, 9.4395532322934326, 8.8524779931517035, 8.5960325163902862, 8.7233150994257276, 9.4605465058702709, 10.702831587760128, 11.695932356823622, 14.406509159208545, 18.893042693096525, 25.031728162044864, 28.237283751764654, 32.110154440123182, 38.781782989560291, 56.412497176172337, 92.156945934839797, 157.10935603874077, 244.24925081430641, 218.20881258539546, 216.90433976724358, 169.13695858014356, 112.62100758585845, 68.70530790516959, 45.982361360241526, 32.725373555898344, 22.221572369125827, 17.135020014783734, 14.281960328360523, 12.699315839076576, 11.637118060780567, 11.004832210877884, 10.393382355075936, 9.6259602166533789, 8.7652013845999868, 8.5650120282362092, 8.5854476517741869, 8.1851518687531879, 9.1270872628576836, 9.8383977040140795, 11.693775785132257, 13.287947209975439, 16.544820171465705, 21.672488061489553, 27.762087103200397, 29.796933806391767, 35.443188490268959, 51.826480475596476, 76.692136618774384, 114.45554660359461, 172.81330831382385, 150.57608076172548, 151.07347077509746, 119.80060075739978, 84.307080896770614, 55.59442395215062, 38.954469932130465, 27.855857296119165, 21.147383956632677, 16.095362427853317, 14.114901096214023, 12.272097096384341, 11.279235865220194, 10.45557624282722, 10.213403723979409, 9.4352540004127672, 9.059591562681522, 8.4285767722705884, 8.2189676916739653, 8.2483207838968369, 8.7272133851807343, 9.3853417746714207, 10.436988631508529, 11.737372360714012, 14.160123000210135, 18.959579242189701, 24.173697545434358, 27.627516713161423, 33.591531685669004, 45.297439984936638, 65.897539497304663, 88.610944521286385, 122.51594786973793, 102.9717174324289, 99.771144171631136, 80.254636450195903, 61.009511746666256, 44.786912913807178, 34.271024500323179, 25.65851527359349, 19.184194785168692, 15.369946764821139, 13.384363033613122, 12.174478369218367, 10.905903566261369, 10.181651684644681, 9.6408755952533021, 9.5742304532973588, 8.9763308722412098, 8.5493032688069821, 8.0644484764315241, 8.4276865988342919, 8.7290963397981098, 9.1210926884309647, 10.045472592156113, 11.11042960636143, 12.723025686618605, 15.905816263070196, 20.709491045732211, 24.791931496783274, 30.865414152401307, 41.835714185623189, 55.039237230593706, 69.947250962386548, 86.305656954166849, 70.246077416654487, 70.163190967731239, 60.941585457354833, 46.988681551588527, 37.426824229947464, 31.105114654781531, 24.717957509432271, 18.191253220796238, 14.40571246916225, 12.794837539520243, 11.45286867499644, 10.555233980671725, 10.138595490186225, 9.7617939326440126, 9.2945114067021706, 9.1978519570897408, 8.5269704682665068, 8.3694986947733589, 8.3900850601209847, 8.9019780110016278, 9.4993224051697176, 10.189344774081897, 11.038776504531349, 12.139382952337165, 14.296273465828305, 18.325479810549485, 23.245126565071455, 28.658675517780157, 38.227879918404916, 50.026933715114076, 59.913478880080035, 67.142884728350211, 60.673200962744687, 56.006191670589025, 48.952383807337931, 41.877289900824969, 35.563752651142892, 29.381802508508265, 23.323351055229473, 18.385352146785323, 14.386074460433269, 11.971768024825069, 10.813949701229296, 10.104265892334448, 9.7873837360525968, 9.7876450182420029, 9.3736570608881902, 9.1067837514303367, 8.8782742568475381, 8.4108604655156682, 8.5145291911969032, 9.1444638633789328, 9.5903687569174956, 10.050972673200409, 10.599176866339214, 12.029252308933458, 13.885440808202775, 16.933840539652099, 20.949767453800131, 27.392670445772911, 35.246945811604022, 44.844494652773115, 53.527920120533459, 59.511906457614529, 53.048047546158344, 49.667902591204928, 45.161821768091436, 39.040569237963304, 34.153498370766542, 28.812200326236947, 21.915204963295363, 16.825291542921018, 14.194481006765461, 11.707465544074312, 10.438485210613589, 9.8151245648739263, 9.283134914271356, 9.0821420578250009, 9.0470505359514384, 9.0924089982219396, 8.8466944313913523, 8.4735939062643375, 8.4980702515250215, 9.0113445722107848, 9.2898710387292809, 9.9575678866832327, 10.426127211956205, 11.223822839806607, 13.773251241827809, 16.688691177663944, 20.746301629724744, 26.320191080313084, 33.979868436578599, 42.0788988747152, 48.313306819757166, 52.481937610238305, 49.070609767594966, 49.766679020971374, 46.544272852318578, 40.229040805773415, 32.559839637781486, 26.180018982316895, 21.083604085221012, 16.97356072267355, 13.301411970448795, 11.264067238060504, 10.255581922596939, 9.6536213682112031, 9.2153774062964224, 8.7468110761182825, 8.4356542718375049, 8.7323846743622209, 8.8458599078381237, 8.7323846743622209, 8.4356542718375032, 8.7468110761182896, 9.2153774062964278, 9.653621368211212, 10.255581922596944, 11.264067238060512, 13.301411970448795, 16.973560722673543, 21.083604085221008, 26.180018982316881, 32.559839637781494, 40.22904080577338, 46.544272852318571, 49.766679020971331, 53.048047546158344, 52.481937610238198, 48.313306819757052, 42.0788988747152, 33.979868436578577, 26.320191080313087, 20.746301629724748, 16.688691177663959, 13.773251241827822, 11.22382283980661, 10.426127211956201, 9.9575678866832256, 9.2898710387292791, 9.0113445722107919, 8.4980702515250268, 8.4735939062643357, 8.8466944313913505, 9.0924089982219467, 9.0470505359514402, 9.0821420578250063, 9.2831349142713542, 9.815124564873928, 10.438485210613582, 11.707465544074319, 14.194481006765461, 16.825291542921001, 21.915204963295366, 28.81220032623694, 34.153498370766549, 39.040569237963282, 45.161821768091372, 49.667902591204999, 60.67320096274468, 59.511906457614572, 53.527920120533402, 44.844494652773072, 35.246945811604007, 27.392670445772925, 20.949767453800135, 16.933840539652095, 13.88544080820277, 12.029252308933453, 10.599176866339214, 10.0509726732004, 9.5903687569174885, 9.1444638633789328, 8.5145291911969103, 8.4108604655156718, 8.8782742568475346, 9.1067837514303385, 9.3736570608881848, 9.7876450182420012, 9.7873837360526021, 10.10426589233446, 10.813949701229305, 11.971768024825074, 14.386074460433273, 18.385352146785333, 23.323351055229466, 29.381802508508251, 35.563752651142877, 41.877289900824962, 48.952383807337874, 56.006191670588912, 70.246077416654288, 67.142884728350111, 59.913478880079964, 50.026933715114062, 38.227879918404923, 28.658675517780189, 23.24512656507147, 18.325479810549478, 14.296273465828305, 12.139382952337156, 11.038776504531354, 10.189344774081897, 9.4993224051697229, 8.9019780110016331, 8.3900850601209847, 8.3694986947733572, 8.5269704682665068, 9.197851957089739, 9.2945114067021635, 9.7617939326440144, 10.138595490186225, 10.555233980671725, 11.452868674996441, 12.794837539520238, 14.405712469162248, 18.191253220796249, 24.717957509432264, 31.105114654781534, 37.426824229947449, 46.988681551588492, 60.941585457354776, 70.163190967731154, 102.97171743242879, 86.305656954166807, 69.947250962386491, 55.039237230593784, 41.835714185623168, 30.865414152401325, 24.791931496783278, 20.709491045732214, 15.905816263070196, 12.723025686618604, 11.110429606361421, 10.045472592156107, 9.1210926884309735, 8.7290963397981116, 8.4276865988342937, 8.0644484764315258, 8.5493032688069821, 8.9763308722412134, 9.5742304532973623, 9.6408755952533056, 10.181651684644681, 10.905903566261369, 12.174478369218367, 13.384363033613125, 15.369946764821144, 19.184194785168689, 25.658515273593498, 34.271024500323144, 44.78691291380715, 61.009511746666178, 80.25463645019579, 99.771144171631008, 150.57608076172505, 122.51594786973776, 88.610944521286228, 65.897539497304635, 45.297439984936574, 33.591531685669025, 27.627516713161402, 24.173697545434354, 18.959579242189701, 14.160123000210131, 11.737372360714007, 10.436988631508525, 9.3853417746714172, 8.7272133851807325, 8.2483207838968262, 8.2189676916739689, 8.4285767722705902, 9.0595915626815202, 9.4352540004127654, 10.213403723979411, 10.455576242827226, 11.279235865220191, 12.272097096384336, 14.114901096214016, 16.095362427853331, 21.147383956632702, 27.855857296119162, 38.954469932130408, 55.594423952150585, 84.307080896770429, 119.80060075739968, 151.07347077509721, 218.20881258539524, 172.81330831382382, 114.45554660359451, 76.692136618774427, 51.826480475596433, 35.443188490268959, 29.796933806391745, 27.762087103200372, 21.672488061489549, 16.544820171465698, 13.287947209975444, 11.693775785132251, 9.8383977040140866, 9.1270872628576836, 8.1851518687531897, 8.5854476517741798, 8.5650120282362074, 8.7652013845999939, 9.6259602166533789, 10.393382355075921, 11.004832210877884, 11.637118060780562, 12.699315839076572, 14.281960328360505, 17.135020014783741, 22.221572369125806, 32.725373555898322, 45.982361360241477, 68.705307905169562, 112.62100758585837, 169.13695858014344, 216.90433976724287, 307.01018353832563, 244.24925081430612, 157.1093560387404, 92.156945934839754, 56.412497176172316, 38.781782989560298, 32.110154440123168, 28.237283751764654, 25.031728162044857, 18.893042693096504, 14.406509159208543, 11.695932356823613, 10.702831587760132, 9.4605465058702674, 8.7233150994257205, 8.5960325163902844, 8.8524779931517052, 9.4395532322934272, 9.9738582700772813, 10.53207617814155, 11.166914874614413, 12.321358605090143, 13.970653175227838, 15.815283825259229, 18.317942023831186, 24.692475316947778, 35.843010431224023, 55.468009578938812, 92.303773245695368, 154.32114106589427, 236.16368190120789, 288.66760291638354, 544.93523795856049, 409.50889944188282, 237.18123750436465, 119.9484175480882, 66.578817507603574, 47.964760430736455, 37.131609415223693, 33.103068481604559, 27.569417818570489, 20.771526297093434, 16.674941080314646, 13.235048872238199, 11.323197140674804, 10.488284402310184, 9.7734432560375648, 9.068032997029011, 9.2113480820863387, 9.5692719745256465, 10.325708895539957, 10.85818004844373, 11.899864411981884, 12.765457059373892, 14.471795156401072, 17.743475715717903, 19.778555411511121, 26.952419331651342, 41.705006957506882, 69.155510455435987, 124.78354764285341, 222.45308756649936, 362.69938393816079, 546.63255943550212, 1080.190096085312, 745.27797642375788, 382.14409608709587, 168.44781050782805, 89.418846636419218, 59.087960225901135, 51.536289299313893, 43.037987696240307, 32.657280802203374, 24.858220592568383, 18.8566734045624, 15.131216045563052, 12.585855785544725, 11.471833692521184, 10.776357928238532, 10.225072497047019, 10.113778554702403, 10.422646713468026, 10.39204452752778, 11.686385949826136, 12.224913053368411, 13.273777678692191, 15.572760511446033, 18.579780562544141, 23.060146944216122, 31.897215329939918, 50.717393232745025, 88.946305547570788, 166.56538319335294, 333.23520458041884, 600.04055794738088, 902.6744137040065, 1649.9911393469013, 1194.1693767483896, 627.46721263291568, 257.67571935262464, 130.82046704446515, 85.070809539003903, 64.95962642758694, 56.268912844615201, 47.416694920263595, 31.950664619854226, 23.277252196336782, 17.807798659576147, 14.919521835574468, 13.60275540468532, 12.481114469594081, 11.408229662647638, 11.032765269291394, 11.37290359217827, 11.421939705679749, 11.956364952724407, 12.938917306264656, 13.543616943986398, 17.759823791920141, 22.490208420088635, 25.024628727892473, 35.725757089786228, 60.92155174662291, 113.58561083280503, 235.81544665938503, 495.51661529689198, 1039.2560892520876, 1699.403841506296, 2266.7457843108423, 1439.6385876846614, 877.88627780050422, 436.44287859172971, 201.91826362250967, 120.42091176843758, 92.994178544706443, 78.820512563031016, 59.193773906230312, 43.026808431859891, 32.72703461228695, 24.074134044705318, 19.687568413122339, 17.144679989146301, 15.32830176004647, 13.466217665828177, 12.230328765246888, 12.567429683418707, 13.144389071570203, 13.459360575928054, 14.499148814332536, 16.038244917569731, 20.356277162608194, 26.786032891522385, 31.259021150294068, 41.917980917088691, 66.730731113314405, 139.47307538222745, 266.66937031427761, 673.70954283481024, 1234.659245962343, 2107.8495169895405, 2024.849011267276, 1866.4077869841062, 1132.5867520786235, 527.32695578494054, 275.9549807303485, 182.29010502256293, 128.14673582533564, 94.733059346587495, 75.762437644265887, 54.412823137373678, 40.985078317877729, 32.581505308308067, 27.457440287528364, 22.850207518010212, 19.446116741695526, 17.138709070816009, 15.312687438440404, 15.036681247518965, 14.861292517540395, 14.843145659919811, 15.343856356149836, 19.130394004010878, 24.966146703509185, 32.451856929062608, 37.528009707176075, 50.013293885425036, 89.673379864749862, 155.99683828976509, 316.43682665588739, 611.83627918833008, 1491.9478410044112, 1926.8239401023493, 3926.8611003464503, 2634.734377888386, 1521.0229297033557, 674.50839546082398, 364.56248799144686, 269.99443977661741, 169.37440787587963, 134.18057082099915, 106.99539363556599, 87.291485884508702, 61.577721983396906, 44.812511187792317, 38.103008129659166, 30.767061622228066, 24.399979621456033, 21.348409581307155, 18.55926931620083, 17.794391783727576, 17.409839934721397, 17.67960231321689, 18.718288087401788, 21.222093075405763, 30.846794326525586, 37.908460172493079, 45.504823244138095, 61.496465220623335, 105.17011934648093, 180.13762334768973, 332.57137935864853, 585.56166554295532, 1028.8359899085369, 2444.3527388912739, 15384.540019848309, 8625.0149751320096, 2857.732229334476, 1367.9024800373199, 719.17065363709889, 531.27032729465782, 353.51632607639499, 237.38092500065625, 183.84765943176362, 145.3050149389683, 109.70237013750581, 71.509189516532217, 54.026677368666469, 39.688247321389689, 29.429525390428473, 24.726583224260004, 20.871711217553678, 19.382151607677731, 19.408029208714364, 19.858863545618949, 23.033311632510113, 27.11271894406525, 38.10483512466044, 53.588048009431979, 66.200283784031811, 89.351789047349371, 144.62539946693829, 222.13525013253218, 308.57630937597452, 674.59859086304834, 2216.8794834334685, 11175.737303494294, 13493.224333003214, 8660.703929170164, 6069.217591691604, 3358.0980991141591, 1935.5749815900851, 1219.8477670929722, 664.63525809030602, 430.47940336338263, 254.30481783551838, 177.63416429867087, 121.61239162949126, 77.826621492011839, 54.399342185878204, 38.082981074479164, 29.138683151168006, 23.622937534136597, 22.04888812794956, 20.808198660555991, 22.92975732198266, 25.094853941398917, 30.569538051408909, 39.854538473021513, 58.061322564190043, 75.858347622710383, 106.13580676907651, 142.795979335548, 244.24660034041099, 373.67036323252819, 567.64096645153575, 1571.3337493887695, 4871.835388507573, 16392.519951456165], "imag": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]}, "imag": [0.0, -1.343901621327011, 1.7218333249394571, 1.3937858919791224, -0.90478486773452105, 0.99560837280124848, 0.13374486301187097, 0.79781790598886937, 0.081235430122062774, 0.47338465820086184, -0.078534664439216209, 0.29500119331967589, -0.62479162763734286, 0.29517170974740459, -1.8712573358384692, 0.14096520515743682, 0.0, -0.14096520515741828, 1.8712573358384816, -0.29517170974737811, 0.62479162763733731, -0.29500119331966146, 0.078534664439223051, -0.47338465820085962, -0.081235430122062774, -0.79781790598886004, -0.13374486301187369, -0.99560837280124848, 0.90478486773452083, -1.3937858919791226, -1.7218333249394557, 1.3439016213270112, 1.5871307700950068, 0.56370110925886319, 1.2603198064423482, 2.9317402483699255, -0.84090846562801591, 0.28395441021550888, 1.0393523450590114, 0.83104911233799517, 0.57334259680943678, 0.30043904784975134, 0.29266755430531527, 0.082930104064024152, -0.36502835420313379, -0.76213554623438207, -0.54316838647957832, -0.66028179246101926, 0.20250391456576916, -0.059393044635645806, 0.9730252602081445, -0.01782962412134724, 0.18933865423621773, 0.011846708470834844, 0.014269719747672759, -0.16281560265463554, -0.24410560657714067, -0.34963232308526365, -0.32234943120999277, -0.6691127915152365, 0.14162995430492473, -0.96909874957635578, -1.0446282489208472, 1.3612809629252947, 0.70464907960903156, 1.644656498115789, 1.457626495523533, -0.6840361527612806, -0.68147470897196205, 0.73118573872942638, 1.2398159392319572, 1.2736175855463174, 0.65550663858936109, 0.45897332874861019, 0.24948129249627171, 0.22959418801218681, -0.67355449112520815, -0.78917379441405089, -0.83366315887398401, -0.022795944141155908, 0.15753196960053301, 0.50836195321582456, 0.16292155588892338, 0.14047533322536612, -0.029004083819245446, 0.042892010327960466, -0.084780328674450303, -0.13217055914433321, -0.30971168558439593, -0.44061350110378666, -0.59380988893293396, -0.46719027726302742, -1.2068396187631398, -0.94969408752542273, 0.28960616895899027, -0.40038203546320883, 0.55620249274438927, 0.14065731983379595, 1.390858139437829, -0.67833342052765033, -2.0926714021100303, 1.5120873610545131, 1.7251253398279642, 1.0499886203647506, 0.6413261932720733, 0.43315407205712014, 0.32584150801434064, 0.17968537990933128, -0.27887473465086693, -0.72646685328097149, -0.95200274282553721, -0.38747270801185796, 0.31172559850957127, 0.3167238274644899, 0.25925756638025876, 0.20404659434537992, 0.19201780058118942, 0.0025274006864131854, -0.20254250312507205, -0.30146681989018398, -0.45156398868756126, -0.71583959398165176, -0.78636343748881254, -1.3089140888320636, 0.41393919421363429, -0.92308378001125058, -0.96086768695066838, 0.99489496750979101, -0.39381772120025876, -0.59264738582705545, -1.1161873115341066, -0.38954314931717815, 0.15776662530084892, 0.39428020304678685, 1.7089894615168126, 0.92868491010646026, 0.350973234838865, 0.32125288047075679, 0.23669588269358602, 0.19592809956108717, -0.32646969875093118, -0.5617213523679232, -0.76596137582739887, -0.4848448097808058, 0.0035984972735877987, 0.36234031342999445, 0.02584515038201295, 0.38132345964413561, 0.29172235696712762, 0.10460468586389386, -0.14942504329756173, -0.23406484190568319, -0.59702583417138988, -0.64791716309340031, -1.1972380302487249, -0.37081056871520385, 0.31028937719203986, -0.11181138224479611, 0.050224150041196312, -0.59242819035998506, -0.4703174557375312, -0.55567065990801068, -0.18073895078348806, -0.07286620180284567, 0.9080135456055427, 1.3448759333642528, 0.56391746646770735, 0.68824563709365816, 0.27054447491545203, 0.18555506064923469, 0.21628766080629094, 0.089227696371118645, -0.1330464412169812, -0.51044075389216448, -0.57482956329522528, -0.49992842173388902, -0.0088882269741786465, -0.026119953804469152, 0.16649307508904443, 0.18021017930701566, 0.24129551707937363, 0.051414766220490717, -0.054409237913703348, -0.21354052285348152, -0.34065461819243753, -0.83215952955458006, -0.65455151443418824, -0.51711748874533736, -0.34193161983249143, 0.25991967791421511, -0.31922838969311168, -0.25096233231074472, -0.019538834540300996, 0.23386297177233037, 0.39736821511961345, 0.72603823847118543, 0.8168297825020705, 1.0763583447726135, 0.80611388127401196, -0.023349196100613815, 0.09911450222934183, 0.11136104528246665, 0.11912886110102348, 0.1510441091194204, -0.10294245821664937, -0.34339582552474845, -0.46071517851602106, -0.27454988477746128, -0.021291149638310566, 0.035818571775215378, 0.08165077597052256, 0.19593247304969552, 0.16021249355536668, 0.073411101811457824, -0.094413661460628892, -0.14774431296435828, -0.3788677957633147, -0.38953231590523063, -0.62892221563014938, -0.80219655994233319, 0.19764870263775744, -0.28620163890053252, 0.041738811618785537, -0.047502831671303453, 0.42759360787810174, 0.44353340330745888, 0.61232760985457502, 0.70207820166905466, 0.72192603666395361, 0.63928791416871467, 0.32589261306510392, 0.17268517789923485, -0.11832252230060911, 0.049391580905339259, 0.12347320818582375, 0.064697981434016727, -0.0067102091687047593, -0.27370819742589092, -0.26939466873920287, -0.25176222060998998, 0.0081310228529853402, 0.013089808045657288, 0.185105158015618, 0.11713478908555769, 0.20974664985683705, 0.048745778368168922, -0.0069359534603168627, -0.18083894269546222, -0.15907734702039189, -0.30490326972545728, -0.49525043110711681, -0.20633977154543071, -0.28929558460304977, 0.017255660868048289, 0.089250558912840242, 0.34349774583430781, 0.38277205043588519, 0.56772102070325814, 0.48811475177501612, 0.43659704639067964, 0.38858095560717315, 0.35469216713625445, 0.11095078972724678, -0.050354098986562471, 0.010426074631633324, -0.023032548262322892, 0.068558023511485697, 0.1199625535177883, -0.0044347552049944488, -0.14323623171577524, -0.2742488887234425, -0.15059247824174998, -0.18695930341705305, 0.068136880204083733, 0.049162011568203073, 0.16362595169702937, 0.078325720975578078, 0.11153460033842358, -0.10346450949096449, -0.039250261082814021, -0.12027128091306288, -0.23113762225192683, -0.07885965728132803, -0.25982980909746989, -0.11219308206942701, -0.19372413199270677, 0.1843821378255476, 0.22544536191476028, 0.22838873802709003, 0.11856768480607156, 0.20011010622694389, 0.16443500436191505, 0.13441036107213369, 0.15600995797323181, 0.029984980792926118, -0.017950425588896139, -0.095997178609832007, 0.045815559155676679, 0.050600401411128038, 0.062555070152262096, 0.095362679574156284, -0.25884721081868178, -0.19352665675464722, -0.35758313393883445, 0.057241994101256972, -0.074489797691212556, 0.15760636776309309, 0.077110294424560424, 0.21793581355625327, -0.085384156728057797, 0.054278095118519401, -0.063513516552257218, -0.13925876777247995, -0.053090482149624127, -0.088550664314818353, 0.097053178020475875, 0.021982682491266895, -0.032057043772553598, 0.011606155190390474, 0.20297398899260674, 0.087137707937781944, 0.14235450986309658, -0.0066344290522644652, 0.069443551113326479, 0.037974760198136455, 0.02723212012252952, -0.030406089689394462, -0.062891439826322393, -0.033462702565164315, -0.13091343010011852, 0.18662643567548856, 0.14580799486104234, -0.055902479292620696, -0.12813917376287484, -0.43706544906097528, -0.097926711565598012, -0.17130544619864244, 0.30727693305691806, -0.2953735036217468, 0.22056405751825581, -0.16529753202987246, 0.34047455883436423, -0.0020829156573361745, -0.14775664020163451, -0.074518551996532553, -0.14850320507536691, -0.057283952975165524, 0.064665418468806371, 0.23511892751228192, 0.11870789775778592, 0.0625549454189092, -0.031298024311669038, 0.0064402102662661845, -0.079082063664820082, 0.0553675188881671, 0.025089334126077875, 0.063800091749494747, 0.015988824093570549, -0.048545356942180602, -0.11558972094679192, -0.097487343329346582, -0.00049492928166827938, -0.18157168721539482, 0.33942288969170681, 0.30522386319855388, -0.54639589537101751, 0.013830571830100688, -0.38850732372171304, 0.223075916963486, -0.31865288748874443, 0.25745374979707547, -0.81885347149607268, 0.50855168910609783, 0.20195166784419227, -0.069785743671890318, 0.050884179954965268, -0.18377202523753672, -0.17303565260659334, -0.15924096907201105, 0.092146932205194695, 0.26379835890783954, 0.35934781180257075, 0.24329566614587647, 0.18564601960109514, 0.24223475523068938, 0.28967646870392649, 0.15967526911861643, 0.22365254766781259, 0.12185893624650075, 0.070105150765122456, -0.045495054958742086, -0.13016925945874308, -0.12331107551299306, -0.096585989040329473, 0.22919036999990153, -0.39865574246315477, 0.3675558227752026, 0.45597314967635888, -0.93227329954448013, 0.32110784375924512, -0.59160024067907024, 0.39469180639349893, -1.5810043928614619, 0.71926168426275527, -0.095920343398476549, -0.084877145937512208, 0.40399573862898452, -0.041743397742653787, -0.10303861084867461, -0.21220001866353477, -0.17318676777643013, 0.015792824133968684, 0.37994714934071439, 0.4573031649737595, 0.48491463219236358, 0.278045596991639, 0.33099751793182702, 0.073461819418744675, 0.30445717300203839, 0.34815332433352569, 0.27336662525128713, 0.050113511094951838, -0.059405844632707393, -0.16261143474742229, -0.10891422081227681, -0.075070297171157971, 0.15348950297637756, 0.63132994551184463, -0.93604459898777692, 0.42325697055405742, 1.1782712312395338, -1.6700526640562563, 0.67307548012867768, -2.0365876460209691, 0.69665186973993298, -0.3990336398782886, -0.77751104168880314, 0.5628167675812451, 0.044468991083659551, 0.081278132745909976, -0.070993394358423723, -0.091852860366211056, -0.10956166698887557, 0.072941493094735049, 0.35167328896657912, 0.63488067579895824, 0.56199684605205058, 0.60627707274502263, -0.018970197624819329, 0.37668655809680845, 0.22317003729918369, 0.17596357423928666, 0.18202109891962201, 0.038230887694388455, -0.10475039750351335, -0.15123171993121909, -0.11278544639649389, 0.054110895720760221, 0.23852479976301316, 0.30802887330694756, 0.9587111952302938, -1.4503952980081434, -0.061458391503499687, 2.1389978076683529, -3.5142346308062073, 1.6764175122847729, -0.63252660757872936, -1.1970497991660358, 0.46027494328631885, -0.38868529039399474, 0.063066133758830412, 0.085024034480974467, 0.047630852690686495, -0.022775175196356016, 0.011847923870825085, 0.13095780969018636, 0.39870906011464996, 0.54100133271840178, 0.62859642257501991, 0.12859489098386362, -0.17371304193339687, -0.77135662792152559, -0.35696964892202537, -0.15350152251372465, -0.081108427029901481, -0.12890403553126065, -0.14048874638904316, -0.18368108831833277, -0.13143015225876853, 0.037318187986402011, 0.39815350666418903, 0.44685069559938601, 0.29854169122462937, 1.0193515924216456, -2.1696976832709978, -1.5476694374721527, 4.1115013597100623, -1.6066056279080296, -1.1129988398741206, 0.94641351902713078, -0.66464487182371434, -0.22405122030787003, -0.16845135046504239, 0.10281428632219461, 0.12776142939872864, 0.10903691838775739, 0.097477148948306502, 0.19622512970077355, 0.37581890109000032, 0.58152174984392169, 0.57588244896775898, 0.56835821427965394, 0.0, -0.075660591040101741, -0.5319087481065502, -0.49066506338765509, -0.25388521774435541, -0.17759782612549996, -0.17342105765811164, -0.17172379067488869, -0.17163733194043357, -0.0096917261033460274, 0.23320936684713756, 0.61544163247884909, 0.23031783223894131, 0.4504667163321609, -0.25422186154383031, -1.2338903723029762, 0.0, 1.2338903723029679, 0.25422186154382892, -0.45046671633216256, -0.23031783223894184, -0.61544163247884998, -0.2332093668471385, 0.0096917261033450074, 0.17163733194043357, 0.17172379067488885, 0.17342105765811225, 0.17759782612550043, 0.25388521774435546, 0.49066506338765642, 0.53190874810654976, 0.075660591040102837, 0.17371304193345374, -0.56835821427958444, -0.57588244896772234, -0.58152174984391114, -0.37581890108999716, -0.19622512970076919, -0.097477148948305531, -0.10903691838775691, -0.12776142939873006, -0.10281428632219579, 0.16845135046504131, 0.22405122030786861, 0.66464487182371257, -0.94641351902713855, 1.1129988398741191, 1.6066056279080259, -4.1115013597100578, 1.5476694374721462, 2.1696976832709982, -1.0193515924216472, -0.29854169122463242, -0.44685069559938834, -0.39815350666419097, -0.037318187986404149, 0.13143015225876697, 0.18368108831833294, 0.14048874638904385, 0.12890403553126736, 0.081108427029909794, 0.15350152251374438, 0.35696964892206617, 0.77135662792155557, 0.018970197624865574, -0.12859489098383081, -0.62859642257500314, -0.54100133271839856, -0.39870906011464824, -0.13095780969018578, -0.011847923870824886, 0.022775175196357359, -0.047630852690687051, -0.085024034480974689, -0.063066133758832563, 0.38868529039399197, -0.46027494328632251, 1.1970497991660347, 0.63252660757872814, -1.6764175122847713, 3.5142346308062082, -2.1389978076683618, 0.061458391503496308, 1.4503952980081398, -0.95871119523029713, -0.30802887330694667, -0.2385247997630148, -0.054110895720761498, 0.11278544639649313, 0.15123171993121864, 0.1047503975035141, -0.038230887694384028, -0.18202109891961496, -0.17596357423927469, -0.2231700372991606, -0.37668655809676688, -0.33099751793180054, -0.60627707274499654, -0.56199684605203359, -0.63488067579895024, -0.35167328896657507, -0.072941493094733675, 0.1095616669888755, 0.091852860366211805, 0.07099339435842339, -0.08127813274590924, -0.044468991083660724, -0.56281676758124888, 0.77751104168880336, 0.39903363987828711, -0.69665186973992854, 2.0365876460209633, -0.67307548012867546, 1.6700526640562572, -1.17827123123954, -0.42325697055405653, 0.93604459898777859, -0.63132994551184651, -0.15348950297637845, 0.075070297171156097, 0.10891422081227575, 0.16261143474742193, 0.059405844632708517, -0.050113511094947612, -0.27336662525128258, -0.34815332433351742, -0.30445717300202041, -0.073461819418725136, -0.24223475523068566, -0.278045596991634, -0.48491463219235625, -0.45730316497375445, -0.37994714934071183, -0.015792824133968708, 0.17318676777642958, 0.21220001866353638, 0.10303861084867472, 0.04174339774265514, -0.40399573862898636, 0.084877145937511819, 0.095920343398476396, -0.71926168426275106, 1.5810043928614652, -0.39469180639349549, 0.59160024067907002, -0.32110784375924395, 0.93227329954447902, -0.4559731496763611, -0.36755582277520088, 0.39865574246315755, -0.22919036999990147, 0.096585989040328876, 0.12331107551299252, 0.1301692594587433, 0.045495054958742745, -0.070105150765121721, -0.12185893624649984, -0.22365254766781101, -0.15967526911861513, -0.28967646870392255, -0.0064402102662611729, -0.18564601960108706, -0.24329566614587189, -0.35934781180256659, -0.2637983589078372, -0.092146932205193599, 0.15924096907201093, 0.17303565260659445, 0.18377202523753683, -0.05088417995496395, 0.069785743671890568, -0.20195166784419286, -0.50855168910609727, 0.81885347149607191, -0.25745374979707175, 0.3186528874887527, -0.22307591696348483, 0.38850732372171648, -0.013830571830101068, 0.54639589537102196, -0.30522386319855499, -0.33942288969170481, 0.18157168721539607, 0.0004949292816654663, 0.097487343329345874, 0.11558972094679136, 0.04854535694218131, -0.015988824093569717, -0.06380009174949508, -0.025089334126078205, -0.055367518888164394, 0.079082063664820748, -0.087137707937777115, 0.031298024311669809, -0.062554945418906743, -0.1187078977577844, -0.23511892751228033, -0.064665418468805788, 0.057283952975166051, 0.14850320507536743, 0.074518551996532748, 0.14775664020163706, 0.0020829156573371555, -0.34047455883436323, 0.16529753202987046, -0.22056405751825445, 0.29537350362174863, -0.30727693305691484, 0.17130544619864224, 0.097926711565602301, 0.43706544906097711, 0.12813917376287753, 0.055902479292622584, -0.14580799486104357, -0.18662643567548898, 0.13091343010011883, 0.03346270256516358, 0.062891439826322837, 0.030406089689394671, -0.027232120122529239, -0.037974760198136892, -0.069443551113326632, 0.0066344290522653612, -0.14235450986309153, -0.22838873802708684, -0.2029739889926063, -0.011606155190393872, 0.032057043772551565, -0.021982682491265355, -0.097053178020474681, 0.088550664314818187, 0.053090482149624633, 0.13925876777248047, 0.063513516552260146, -0.054278095118517826, 0.08538415672805795, -0.21793581355625447, -0.077110294424558939, -0.15760636776309189, 0.074489797691215873, -0.057241994101257694, 0.35758313393883939, 0.19352665675464989, 0.25884721081868634, -0.095362679574154757, -0.062555070152259029, -0.050600401411129904, -0.04581555915567774, 0.095997178609832215, 0.0179504255888953, -0.029984980792924155, -0.15600995797322956, -0.13441036107213314, -0.16443500436191227, -0.20011010622694014, -0.1185676848060674, -0.38277205043588519, -0.22544536191476122, -0.18438213782554774, 0.19372413199270522, 0.11219308206942717, 0.25982980909746933, 0.078859657281328127, 0.23113762225192824, 0.12027128091306288, 0.03925026108281611, 0.10346450949096535, -0.11153460033842286, -0.078325720975578092, -0.16362595169702793, -0.049162011568201006, -0.06813688020407746, 0.18695930341705305, 0.15059247824175628, 0.27424888872344572, 0.14323623171577923, 0.0044347552049957819, -0.11996255351778637, -0.068558023511484198, 0.023032548262321723, -0.010426074631633324, 0.05035409898656467, -0.11095078972724633, -0.35469216713625396, -0.38858095560717304, -0.43659704639067964, -0.48811475177501651, -0.56772102070325836, -0.42759360787810491, -0.34349774583431025, -0.089250558912845224, -0.017255660868053985, 0.28929558460304938, 0.20633977154543065, 0.49525043110711575, 0.30490326972545867, 0.15907734702039197, 0.18083894269546641, 0.0069359534603191542, -0.048745778368166057, -0.20974664985683683, -0.11713478908555536, -0.18510515801561447, -0.013089808045645399, -0.0081310228529865667, 0.25176222061000281, 0.2693946687392072, 0.27370819742589902, 0.0067102091687078758, -0.064697981434012536, -0.12347320818582255, -0.049391580905336498, 0.11832252230060807, -0.17268517789922963, -0.32589261306509937, -0.639287914168712, -0.72192603666395261, -0.70207820166905555, -0.61232760985457479, -0.44353340330746277, 0.019538834540299969, 0.047502831671299713, -0.041738811618788646, 0.28620163890052958, -0.19764870263775797, 0.80219655994233652, 0.62892221563015416, 0.38953231590523568, 0.37886779576331475, 0.14774431296436413, 0.094413661460632833, -0.073411101811453133, -0.16021249355536557, -0.19593247304968892, -0.081650775970513151, -0.035818571775193361, 0.021291149638310077, 0.27454988477748077, 0.46071517851603194, 0.34339582552475939, 0.10294245821665464, -0.15104410911941546, -0.11912886110102075, -0.1113610452824651, -0.099114502229341719, 0.023349196100618572, -0.80611388127400851, -1.0763583447726097, -0.8168297825020715, -0.72603823847118742, -0.39736821511961523, -0.23386297177233123, 0.4703174557375292, 0.25096233231074278, 0.31922838969310624, -0.25991967791422005, 0.34193161983249054, 0.51711748874534202, 0.65455151443419168, 0.83215952955458772, 0.34065461819243747, 0.21354052285348993, 0.054409237913707532, -0.051414766220484194, -0.24129551707937194, -0.18021017930700467, -0.16649307508903324, 0.02611995380449984, 0.0088882269741778191, 0.49992842173391339, 0.57482956329523827, 0.51044075389218102, 0.13304644121698647, -0.089227696371110179, -0.21628766080628836, -0.18555506064923225, -0.27054447491545125, -0.68824563709364495, -0.56391746646770291, -1.3448759333642519, -0.90801354560554559, 0.072866201802841646, 0.18073895078348665, 0.55567065990800857, 0.39381772120025821, 0.59242819035998318, -0.05022415004119711, 0.11181138224479518, -0.31028937719203997, 0.3708105687152074, 1.1972380302487284, 0.6479171630934083, 0.5970258341713901, 0.23406484190569171, 0.1494250432975659, -0.10460468586388726, -0.29172235696712562, -0.38132345964412656, -0.02584515038199919, -0.36234031342997136, -0.0035984972735878563, 0.484844809780835, 0.76596137582741564, 0.56172135236794307, 0.32646969875093934, -0.19592809956107882, -0.23669588269358457, -0.32125288047075495, -0.35097323483886461, -0.92868491010645182, -1.7089894615168075, -0.39428020304678818, -0.15776662530084981, 0.38954314931717637, 1.1161873115341048, 0.59264738582705467, -0.5562024927443876, -0.99489496750979078, 0.9608676869506646, 0.92308378001124303, -0.4139391942136339, 1.3089140888320632, 0.78636343748881332, 0.71583959398165975, 0.45156398868756092, 0.30146681989019147, 0.20254250312507779, -0.0025274006864056797, -0.19201780058118689, -0.20404659434537004, -0.25925756638025355, -0.31672382746446043, -0.31172559850957088, 0.38747270801190198, 0.95200274282556019, 0.72646685328099436, 0.2788747346508717, -0.17968537990931685, -0.3258415080143367, -0.43315407205711348, -0.64132619327207141, -1.0499886203647348, -1.7251253398279605, -1.5120873610545145, 2.092671402110029, 0.678333420527655, -1.3908581394378237, -0.14065731983379445, -0.704649079609032, 0.40038203546320611, -0.28960616895899161, 0.94969408752542028, 1.2068396187631385, 0.4671902772630277, 0.59380988893293563, 0.44061350110379105, 0.30971168558439566, 0.13217055914433939, 0.084780328674454217, -0.042892010327952576, 0.029004083819250629, -0.14047533322535441, -0.16292155588890503, -0.50836195321575572, -0.15753196960053273, 0.022795944141262008, 0.83366315887402342, 0.78917379441409119, 0.67355449112521315, -0.2295941880121686, -0.24948129249626083, -0.45897332874859181, -0.65550663858936065, -1.2736175855462932, -1.2398159392319503, -0.73118573872941783, 0.68147470897196305, 0.68403615276129381, -1.4576264955235338, -1.6446564981157907, -1.587130770095007, -1.361280962925294, 1.044628248920846, 0.96909874957635356, -0.14162995430492481, 0.66911279151523617, 0.32234943120999365, 0.34963232308526704, 0.244105606577141, 0.16281560265463482, -0.014269719747667968, -0.011846708470826806, -0.18933865423621368, 0.017829624121361812, -0.97302526020811309, 0.059393044635753067, -0.20250391456577049, 0.6602817924610479, 0.54316838647960974, 0.76213554623441593, 0.36502835420313695, -0.082930104064008442, -0.29266755430530383, -0.30043904784973247, -0.57334259680943656, -0.83104911233797829, -1.039352345059011, -0.28395441021550044, 0.84090846562801602, -2.9317402483699175, -1.2603198064423498, -0.5637011092588653], "height": 32, "width": 32, "top": {"real": [7376.2586563979694, 2820.8522261533344, -5690.9497085395169, -4380.4513376296127, 388.6547315083493, -903.73852292232903, -92.233688854560938, 42.706854165930984, -25.699252344104405, 18.326281263011424, -9.8542387499157442, 37.933510453511431, -7.8666684309670254, 29.305075180843883, -62.728617354661907, 59.853240627388928, -83.636374399044939, 59.853240627386725, -62.728617354660756, 29.305075180844177, -7.8666684309671826, 37.933510453511431, -9.8542387499160657, 18.326281263013065, -25.699252344104405, 42.706854165930693, -92.233688854557883, -903.7385229223205, 388.65473150834708, -4380.4513376296045, -5690.9497085395114, 2820.8522261533035, -14789.032757371706, -31341.185848117759, -11739.029695619593, -866.78466658113393, -286.68893204831016, -488.33133225087568, -120.74864963582691, 33.024718339611894, 4.6010715329524166, -5.4456740109959769, 4.1139030671062393, 6.8633911029603265, 13.634662924808397, 1.860738389345556, -0.35796846682150263, -16.625069210775109, -14.807142725465134, -11.664010623894898, 0.82076815557037341, -12.155673848711613, 29.148348103795893, 15.708115389403888, 15.457503110539639, -12.683126140048403, 18.961120931859309, -53.601071866945205, 34.13442733448511, -942.72760774202175, -816.05094481379797, -3798.5470080468217, -8876.4278731043305, 2890.8320511623124, -27232.421940549859, -15984.118662988652, -6745.5682223604126, -409.0173927639226, -42.225544009425754, -526.29225504527119, -49.325655652906178, -23.20435390028933, 15.630174176003303, -14.835941429972856, 6.4726407463551725, 1.9958373496876167, 13.291351981828791, -1.1889020916883648, 10.030112101155916, -20.674418420848429, -0.1180338988714332, -18.745207674116038, -1.9041291470929314, -7.8710994817942428, 20.385879097388031, 14.857882580655026, 16.950197274587541, -2.033086164989526, 25.446982376231624, -20.624592190095939, 89.303256695009566, -637.06671072120571, -1428.8365567175017, -3113.2951228079887, -8881.5889351276946, -20696.443600183225, -9007.3131796291163, -5346.3306090002807, -1439.1675666408983, -1292.5663502582722, -654.09944760377277, -301.70227472838963, -97.440927522083996, -3.3329385156017457, -8.2027965131620153, -5.7742639473870323, -0.51069538319854635, 6.6402880636318233, 8.0126520330591013, 4.0882931682311625, -1.5210347396074151, -2.2335756869246048, -2.3288001542285928, -8.1315470965115093, -6.9403489082507335, -3.6748649027980562, 4.5937507427443531, 9.4957008241539675, 10.21057060635477, 11.676825499792781, 23.758858737501662, 20.288236987689611, 20.969766857125101, -333.51324485695324, -810.1584353673162, -2278.6820540988888, -5194.4090916202094, -7188.339898707115, -3154.0647285180166, -3175.2001764803263, -3085.2108289353805, -1226.2977859942123, -836.26206181721784, -301.22169990911055, -15.123294918373254, -11.324269109892445, -4.9992210979693361, -6.7152536525607003, -1.7063097661780617, 2.7727430774894133, 7.1357881321682148, 4.8669904821248817, 2.7536893948953045, -2.039934630711028, -0.54898928719761031, -2.9485150656567436, -3.1026085263061316, -1.3614545093317587, -0.47304719477880164, 4.0409079710738931, 6.2483313015723709, 8.8540252326547968, 18.802141623354618, 24.681352644731625, -6.1114787305120313, -148.49350684902615, -572.34886359995278, -1663.447165744248, -3308.6059534728529, -4493.8282478995061, -3720.0991836319017, -3323.4413322476125, -2223.3326338682518, -1347.5218927383742, -402.86472873295924, -179.07785660663581, -42.171627369153548, 13.024576486879551, -6.680339136637107, -4.3910663300422375, -1.9843645852297727, 2.2081255979025864, 3.4357055351949564, 4.8667397989738959, -0.0088018165553918268, -1.2900498248809058, -2.2230696316747851, -0.79613102395178958, -2.1003135650570957, -0.12607857026311342, 0.39928478103703097, 3.6189445517483683, 5.5230847011321824, 8.0807144322734796, 9.6537837209938342, 14.647883903859292, 41.761171107733581, -2.5048396429986766, -288.68438568639834, -1058.7748743456032, -2111.6481404168812, -2853.5518466904464, -2206.4742388833251, -2207.4882969003411, -1427.0600295974209, -607.97311048711572, -283.75431628355585, -25.222873313531675, -11.21903778037437, -8.3653822807976148, 1.9503276148055415, -4.8653324939916756, -1.0558165909594248, 0.18037835028025548, 3.7232300368774149, 2.6260151255238955, 1.901747650437611, -2.157984497724208, -1.9174482807780493, -2.671365924063863, -1.6822520344543337, -1.7835969801453151, 0.50013744114287995, 2.3612666445612516, 3.9892729615099713, 5.0282597338489978, 4.3849613992965208, 7.5675449146459712, 26.738330274504211, 30.293009711209869, -72.365238046453968, -397.03998761961856, -1129.7740740979677, -1877.1475049531305, -1015.8170093531105, -757.33856581211364, -464.04986763483271, -221.8093865245269, -66.670140953208971, -32.688631361988044, 12.245388279073117, -2.09491941357581, -4.9214217924247272, -0.76863227802399692, -1.3611346863617457, 0.59203001318831738, 2.3940543871676745, 2.1386535528573569, 0.12698658321630202, -0.36055346759858353, -1.509631760657328, -0.37490601010058217, -1.4076418772333708, -0.9909556252137327, 0.025704615807234758, 1.7006413859335137, 2.4101241863335301, 2.7230446482899899, 4.8975474263529586, 5.5799176422335819, 7.3823613929523022, 3.3531473980019464, -7.0947231292717241, -129.95057654055665, -447.33256260550814, -801.49855315264267, -297.71280467242298, -206.25666421819534, -105.85720001872387, -40.587336797783266, -19.033005269759897, 0.68623525685047748, -2.224754122223199, 2.8686428937153541, -1.3772856826259623, -3.7001182860738422, 0.56033030111271653, 0.31649576481826269, 2.6435570864758695, 2.0729019173667451, 1.3896745329326239, -1.1733083260901866, -0.5564284933709801, -0.75319429727185228, -0.16542223594150865, -0.34981510145177358, 0.63947101827441399, 0.64495136714903334, 1.5357324193076427, 2.8130362926385226, 4.2845415972556511, 3.3415574201637508, 1.8747628167747612, 4.3092019872505318, 1.2280777000161127, -53.113548920223614, -153.12296297306594, -262.59106890839882, -78.507966752468647, -44.713956729763169, -24.503242066462356, -11.422688403833899, -6.8324882374101472, -1.9389416594991726, 2.3416848160301655, -1.9581076589813595, 0.65441624739147974, -1.6215192060328243, -3.0886268279599727, 2.5574024719687731, 2.5859312055320047, 3.582324284715654, 2.3851708003164411, 0.41148866509477899, -1.7870448740379692, 0.35867475608513461, -0.33833230756510146, 0.72134917870519866, -0.6451343286468626, -0.036676325952571386, 1.8806785141996829, 3.0459530955995717, 3.0361534846987768, 1.8248078988499765, 2.0278729258957484, 1.4298438030821454, 1.444150632114136, -16.470770345398158, -59.038387406403551, -81.624687331130716, -41.65158074717607, -20.04858945819673, -26.796686775361913, -13.274828683787613, -5.4849410264677898, -1.7682797425272327, 0.51276950901621554, 0.11701161368370352, -2.1525887062494076, -0.35663258536781867, -0.3882693848937121, -2.5566610369397282, 6.5139128293303541, 4.1537964250038213, 2.1778507792771808, 0.67618078211604771, 0.67271760119275736, -0.033223712968477391, 1.7891382881043305, 0.76549003012129324, -1.8840461990319548, 0.62764371336603419, 2.9500669911593334, 2.7998549031057309, 2.7114466415734606, 2.640497491382968, 2.5087646302130264, 0.3613507110411972, -0.85975587552377708, -5.8993661554875496, -19.483874473281006, -46.656198806892085, -42.447185502078959, -49.475399988407517, -28.809040802191632, -23.364991274814315, -9.3720360014436217, -2.193549633075087, 0.73237790527535407, -0.60287176352488314, -1.0672361910519921, -3.8374461384037328, 0.81264916316705227, 3.7024783733454592, -2.2274307006673761, 12.171761179906976, 2.6484997231173142, 2.1242155181960216, 1.3916869062247985, 3.2969221728544564, 0.14147762112210061, -1.2659388719629114, 1.2983452624583423, 2.4646463691490883, 1.8819178233751466, 2.4699197782172551, 3.4105600445409938, 3.476877662739366, 1.970602508408192, 0.54569379437115284, -0.61503488296082265, -1.584537886719974, -9.9108851118855448, -17.968893142628509, 0.83280248396047341, -16.804391379900096, -34.94566909960443, -18.287776152890835, -10.19076861522101, -2.3659355754892188, 0.38430207827148843, -0.39175809943359002, -2.0786620762717161, -2.1066158183404973, -4.0664292874937455, 5.1056392812224729, 9.4711485160420441, -2.577327881134023, 13.563457368659881, 5.4454444116217209, 3.0810071966308192, 3.71409458782056, -2.7028450063821525, 1.3893389983926554, 5.0295677911697716, 2.0512141006459763, 0.57687440104333121, 3.1399874906463121, 4.3044361492909653, 3.2286926050373941, 2.0294536549063102, -1.2648718051872285, 0.81982278416560761, 5.1937461344056883, 4.5660530070978913, -2.5751982814314349, 10.842808636227273, -2.7634934625905125, -4.7410363255116081, -13.231297049532179, -1.2392069417375811, 0.57695677140757395, 1.6572428400911725, -0.80487566941313171, -2.1976406054664008, -2.9337382106235617, -0.97696074341019468, -0.52039830113476337, 8.6932746740913363, 18.008772340009436, -6.3894706762347742, 16.656214263229323, 5.6480128145892756, -2.6420757676626341, 6.9832538798624686, 8.7117753152913409, 2.944231966553327, -0.4194257648970201, 1.9464964791115495, 2.8117062685871983, 3.586606822562346, 3.6410340078674697, 2.1750438821370093, 0.92746135521083628, -0.10515597578954901, 10.916870623975495, 22.695665816423684, 26.922229107827643, 56.766547106622895, 34.346379481364103, 8.0209890672230593, 4.2276867493724737, 2.0129650120803855, 4.5721973792850843, 1.7026114564114816, -0.10193290249876912, -1.9877285465951933, -1.4091416884493304, -1.0407935339809435, 4.6927135104950821, 4.461866465996299, 13.14685287043932, 23.490161756370188, -8.5448676586843408, 5.7639040157862622, 6.7103974452754578, 11.090643871879529, 8.6117964749879281, 0.95828374077, 2.8859143014026349, 1.6803595914225926, 1.5724318132354216, 2.3664842485474589, 3.3844724421254813, 2.8754034241014996, 0.81420697505183059, 3.4592633965370854, 8.5418678989119741, 26.408180301615612, 46.472433795130719, 15.748155014076561, 18.939305693948317, 18.355423454953527, 7.4385947937208252, 6.8421582395566496, 3.8284829441665011, 2.3084513014265475, 0.014383588041353481, -0.70170837590258439, -0.9519271341888802, 0.60488638387036897, 4.7316501322768225, 11.640012070252736, 11.084534895769892, 7.9427552323827459, 17.090358547431578, -4.0062765415124373, 18.903471314461139, 10.522914852414784, -0.31727085194714888, 8.1914062421872558, 5.5678768421215832, 1.9515757898119943, 0.13204460835173984, 0.94686979396028259, 2.2566984460298456, 3.5582629306092612, 2.7150237945754423, -0.038191379039643265, 6.3090662882758242, 18.822434458740766, 20.387061197767007, 34.210424610695611, 25.78016711295075, 13.422328957688888, 4.2578162502068047, 2.3122896178400203, 4.1892680028045364, 2.2592478817037658, 0.95372259584702335, -0.47653425908969432, 0.069240128911087023, 0.91781179579556105, 6.6018505246928774, 10.152138543237006, 11.530381877152177, 5.6211304516254526, 4.7909070280413646, 35.867989503906792, 4.7909070280413584, 5.6211304516254428, 11.530381877152157, 10.152138543237017, 6.6018505246928978, 0.91781179579556504, 0.069240128911081333, -0.47653425908969432, 0.95372259584699437, 2.2592478817037476, 4.1892680028045142, 2.3122896178399985, 4.2578162502067478, 13.422328957688848, 25.780167112950689, 15.74815501407811, 20.387061197767874, 18.822434458741888, 6.309066288276548, -0.038191379039562191, 2.7150237945755555, 3.5582629306093274, 2.2566984460298958, 0.94686979396029702, 0.1320446083517558, 1.9515757898119841, 5.5678768421215636, 8.1914062421872096, -0.31727085194714522, 10.522914852414772, 18.903471314461111, -4.0062765415123884, 17.090358547431556, 7.9427552323827513, 11.084534895769902, 11.640012070252746, 4.7316501322768385, 0.60488638387038995, -0.9519271341888812, -0.70170837590259716, 0.014383588041281273, 2.3084513014264751, 3.8284829441663635, 6.8421582395566762, 7.4385947937204353, 18.355423454952824, 18.939305693949098, 56.76654710662406, 46.472433795132453, 26.408180301616227, 8.5418678989122103, 3.4592633965371484, 0.81420697505187978, 2.8754034241015152, 3.3844724421254879, 2.3664842485474735, 1.572431813235436, 1.6803595914225982, 2.8859143014026083, 0.95828374076997469, 8.6117964749878801, 11.090643871879506, 6.7103974452754693, 5.7639040157862587, -8.5448676586843018, 23.490161756370185, 13.146852870439265, 4.4618664659962768, 4.6927135104951034, -1.0407935339809418, -1.4091416884493408, -1.9877285465952099, -0.10193290249882341, 1.7026114564114307, 4.5721973792850434, 2.0129650120803833, 4.2276867493724772, 8.0209890672234039, 34.346379481364394, 10.842808636228447, 26.9222291078285, 22.695665816424683, 10.916870623975989, -0.10515597578943024, 0.92746135521090112, 2.1750438821369982, 3.6410340078674537, 3.5866068225623455, 2.8117062685872063, 1.9464964791115584, -0.41942576489699973, 2.9442319665532848, 8.7117753152913178, 6.9832538798624677, -2.6420757676626758, 5.6480128145892872, 16.656214263229302, -6.389470676234752, 18.008772340009443, 8.6932746740913274, -0.52039830113473562, -0.97696074341019512, -2.9337382106235728, -2.1976406054664195, -0.80487566941320732, 1.657242840091119, 0.57695677140755675, -1.2392069417374179, -13.231297049531948, -4.7410363255113248, -2.7634934625894938, 0.83280248396082224, -2.5751982814309775, 4.566053007098211, 5.1937461344059415, 0.81982278416574916, -1.2648718051872136, 2.0294536549062832, 3.2286926050373275, 4.3044361492909653, 3.1399874906463054, 0.57687440104334498, 2.0512141006459621, 5.0295677911697396, 1.3893389983926545, -2.7028450063821756, 3.7140945878205622, 3.0810071966308161, 5.4454444116217395, 13.563457368659845, -2.5773278811340234, 9.4711485160420441, 5.1056392812224614, -4.0664292874937296, -2.1066158183405044, -2.0786620762717254, -0.39175809943363327, 0.38430207827145285, -2.3659355754891784, -10.190768615220893, -18.287776152890569, -34.94566909960389, -16.804391379899673, -42.447185502078064, -17.968893142627813, -9.910885111884598, -1.5845378867194357, -0.61503488296060749, 0.5456937943712441, 1.9706025084081269, 3.4768776627392723, 3.4105600445409681, 2.4699197782172639, 1.881917823375139, 2.4646463691490985, 1.2983452624583438, -1.2659388719629485, 0.1414776211221116, 3.2969221728544715, 1.3916869062248129, 2.1242155181960229, 2.6484997231173293, 12.171761179906973, -2.2274307006673681, 3.702478373345508, 0.81264916316704883, -3.8374461384037382, -1.0672361910520076, -0.60287176352493688, 0.73237790527531033, -2.1935496330750563, -9.3720360014434689, -23.364991274814056, -28.809040802191326, -49.47539998840697, -41.651580747175068, -46.656198806890998, -19.483874473280501, -5.8993661554872627, -0.85975587552355426, 0.36135071104124949, 2.5087646302129953, 2.6404974913828889, 2.7114466415734491, 2.7998549031056945, 2.9500669911593249, 0.62764371336605218, -1.8840461990319775, 0.76549003012129535, 1.789138288104325, -0.033223712968466615, 0.67271760119275215, 0.67618078211606658, 2.1778507792771671, 4.1537964250038266, 6.5139128293303603, -2.5566610369397242, -0.38826938489369667, -0.35663258536783948, -2.1525887062494129, 0.11701161368368215, 0.51276950901619689, -1.7682797425271899, -5.4849410264677143, -13.274828683787417, -26.796686775361572, -20.048589458196275, -78.507966752466459, -81.624687331128925, -59.038387406402052, -16.470770345397689, 1.4441506321142048, 1.429843803082246, 2.0278729258956907, 1.8248078988499317, 3.0361534846987319, 3.045953095599546, 1.8806785141996951, -0.036676325952591224, -0.64513432864685583, 0.72134917870519299, -0.33833230756510668, 0.35867475608511745, -1.7870448740379619, 0.41148866509475018, 2.385170800316434, 3.582324284715646, 2.5859312055320172, 2.5574024719687887, -3.08862682795997, -1.6215192060328063, 0.65441624739145521, -1.9581076589813555, 2.3416848160301531, -1.9389416594989646, -6.8324882374098541, -11.422688403833355, -24.503242066461048, -44.713956729761051, -297.71280467242298, -262.59106890839888, -153.12296297306594, -53.113548920223877, 1.2280777000160852, 4.3092019872504084, 1.8747628167747172, 3.341557420163666, 4.2845415972556511, 2.8130362926385151, 1.5357324193076258, 0.64495136714903156, 0.63947101827441044, -0.34981510145179595, -0.16542223594153913, -0.75319429727190634, -0.5564284933709801, -1.1733083260902135, 1.3896745329326132, 2.0729019173667376, 2.6435570864758655, 0.31649576481827513, 0.56033030111271809, -3.7001182860738244, -1.3772856826259623, 2.8686428937153425, -2.2247541222231662, 0.68623525685057685, -19.033005269759858, -40.587336797783074, -105.85720001872383, -206.25666421819477, -1015.8170093530997, -801.4985531526338, -447.3325626055032, -129.9505765405554, -7.094723129271765, 3.3531473980017035, 7.3823613929520073, 5.5799176422333412, 4.8975474263529168, 2.7230446482898696, 2.4101241863335168, 1.700641385933505, 0.025704615807253747, -0.99095562521376346, -1.4076418772333852, -0.37490601010063784, -1.5096317606573337, -0.36055346759863915, 0.12698658321626774, 2.1386535528573165, 2.3940543871676701, 0.59203001318833959, -1.3611346863617075, -0.7686322780239524, -4.9214217924247352, -2.0949194135756803, 12.245388279073195, -32.688631361987156, -66.670140953207678, -221.8093865245236, -464.04986763482748, -757.33856581210489, -2206.474238883316, -1877.1475049531243, -1129.7740740979648, -397.03998761961947, -72.365238046453996, 30.293009711209137, 26.738330274503873, 7.5675449146456106, 4.3849613992964835, 5.0282597338488833, 3.9892729615099154, 2.3612666445612378, 0.50013744114287839, -1.7835969801453351, -1.6822520344543537, -2.6713659240639043, -1.9174482807780469, -2.1579844977242066, 1.9017476504375719, 2.6260151255238871, 3.7232300368773963, 0.18037835028033014, -1.0558165909593593, -4.8653324939915077, 1.9503276148055297, -8.3653822807973572, -11.219037780374073, -25.222873313530549, -283.75431628355437, -607.97311048711254, -1427.0600295974182, -2207.4882969003352, -3720.099183631889, -2853.5518466904387, -2111.648140416873, -1058.7748743456016, -288.68438568639789, -2.5048396429994018, 41.761171107733141, 14.647883903858578, 9.6537837209937827, 8.0807144322732913, 5.5230847011321327, 3.6189445517483261, 0.3992847810370409, -0.12607857026309263, -2.1003135650570361, -0.79613102395168645, -2.2230696316747758, -1.2900498248808734, -0.0088018165554208834, 4.8667397989738888, 3.4357055351949497, 2.2081255979026997, -1.9843645852296314, -4.3910663300419372, -6.6803391366371141, 13.024576486880093, -42.171627369152944, -179.07785660663302, -402.86472873295685, -1347.5218927383694, -2223.332633868245, -3323.4413322476003, -3154.0647285180148, -4493.8282478995088, -3308.6059534728515, -1663.4471657442498, -572.34886359995289, -148.49350684902797, -6.1114787305125393, 24.681352644731046, 18.802141623354593, 8.8540252326545641, 6.2483313015722262, 4.0409079710738718, -0.47304719477879342, -1.361454509331699, -3.1026085263059842, -2.948515065656593, -0.5489892871976132, -2.0399346307109321, 2.7536893948952148, 4.8669904821248942, 7.1357881321682211, 2.7727430774895763, -1.706309766177841, -6.7152536525602784, -4.9992210979693477, -11.324269109891496, -15.123294918372496, -301.22169990910822, -836.26206181721659, -1226.2977859942089, -3085.2108289353782, -3175.2001764803231, -9007.3131796291, -7188.3398987071041, -5194.4090916202022, -2278.6820540988915, -810.15843536731495, -333.51324485695591, 20.969766857124615, 20.288236987688347, 23.758858737501669, 11.676825499792164, 10.210570606354567, 9.4957008241538698, 4.5937507427443718, -3.6748649027980855, -6.9403489082508045, -8.1315470965115626, -2.3288001542285697, -2.2335756869247856, -1.5210347396073984, 4.088293168231135, 8.0126520330591262, 6.6402880636320099, -0.51069538319843244, -5.7742639473864941, -8.2027965131620455, -3.3329385156007563, -97.440927522082632, -301.70227472838576, -654.09944760377232, -1292.5663502582681, -1439.1675666408923, -5346.3306090002598, -27232.421940549855, -20696.443600183229, -8881.5889351276946, -3113.2951228080024, -1428.8365567175017, -637.0667107212123, 89.303256695008088, -20.624592190099609, 25.446982376231595, -2.0330861649905447, 16.950197274587225, 14.857882580654767, 20.385879097388024, -7.8710994817946256, -1.9041291470930921, -18.745207674117459, -0.11803389887143546, -20.674418420848326, 10.030112101155776, -1.1889020916883362, 13.291351981828802, 1.9958373496879209, 6.472640746355359, -14.835941429972186, 15.63017417600328, -23.204353900286776, -49.325655652904786, -526.29225504526619, -42.22554400942483, -409.0173927639147, -6745.5682223604063, -15984.118662988625, -14789.032757371675, 2890.8320511623242, -8876.4278731043305, -3798.5470080468367, -816.05094481379706, -942.72760774203016, 34.134427334482538, -53.601071866949361, 18.961120931859348, -12.683126140049515, 15.4575031105396, 15.708115389403696, 29.148348103795954, -12.155673848712381, 0.82076815557010951, -11.664010623895932, -14.807142725465098, -16.625069210776097, -0.357968466821102, 1.860738389345522, 13.634662924808296, 6.8633911029604313, 4.1139030671065999, -5.4456740109950088, 4.6010715329523864, 33.024718339612249, -120.74864963582446, -488.33133225087175, -286.68893204831085, -866.78466658111245, -11739.029695619576, -31341.185848117751], "imag": [0.0, -38758.087655514835, 17548.085047269142, 6107.2151726624015, -1874.673387120311, 1102.4198144208276, 70.663498597697227, 246.50443360377355, 15.094404836632346, 61.578388193120794, -6.883850379905633, 17.433253862249003, -27.182352905748338, 10.205627484635695, -57.631165788617082, 3.5978635789949243, 0.0, -3.5978635789944389, 57.631165788617331, -10.205627484634785, 27.182352905748068, -17.433253862248129, 6.883850379906236, -61.578388193120603, -15.094404836632346, -246.50443360377048, -70.663498597698691, -1102.4198144208278, 1874.6733871203112, -6107.2151726624097, -17548.085047269135, 38758.087655514864, 21415.511526704078, 9240.4816801838842, 6140.0706338628515, 4606.7423967050836, -477.33409412636456, 106.10534760670754, 253.85827683649731, 118.670471872242, 60.852179067446961, 22.790809731222598, 16.992665274593527, 3.3051410229913314, -11.158748163655874, -19.125680216300069, -12.454719286949617, -13.739274709476872, 4.4649861577324996, -1.4030381833900449, 28.352674755287939, -0.67900523797834378, 10.299898240809684, 0.92198929608587377, 1.7353747463970652, -28.921613512340663, -62.077231813228479, -150.50951383829744, -214.24479740751684, -816.21574466320703, 274.1353961963593, -3254.3286688062722, -6340.0761451284025, 11789.651384311641, 10840.701965194425, 18380.248977426931, 3231.3822724351476, -461.44982475214084, -210.28695062763435, 162.42212696600188, 179.30887547689923, 113.80000983072934, 43.394725496932487, 24.59548477602943, 9.5064435172576207, 6.2249226907652995, -15.514190495563678, -15.67209469704693, -16.179758937655365, -0.44183444538403649, 3.28796177703477, 12.57005414423841, 4.7947040656811843, 5.5752197676029693, -1.566994278876134, 3.0671728952871886, -9.3006029966239439, -19.205045070959127, -56.939768493357462, -104.59324045979437, -209.92149032340299, -248.20433151041027, -867.92363746103479, -1299.0888976028032, 827.61688284819274, -3453.3010516440099, 2184.1299326736716, 343.81610498084558, 1430.9649107108667, -397.20604751762147, -695.96261474413006, 272.38382351444113, 181.43163787734565, 64.570588674311324, 29.183435066681643, 16.420203889130576, 10.051165980763317, 3.8132998567254699, -5.2200576234926608, -12.843645059741645, -16.574215370008311, -6.8948411718648668, 5.7853993354930253, 6.7615499928711884, 6.3258793363865982, 6.2779141420300757, 7.316455816584333, 0.11325917153592484, -12.472105947256997, -26.315486653091728, -48.315266721271882, -96.05176533673017, -133.18984159990899, -353.39952612993443, 150.90670251969735, -622.62775933130001, -1461.5017842629939, 2621.2839732861958, -797.42142339187535, -1141.9271710506443, -1665.2932495998289, -238.3366310615267, 49.923170262409073, 61.506465075545492, 153.25086116745172, 46.446591336114025, 13.171326963991907, 10.42525251508628, 5.9093841314446687, 3.7481817410606739, -5.009304162269796, -8.3377118534842136, -11.383176063308646, -7.2904568591879206, 0.055102663998529922, 6.2100452165049633, 0.50258781153530074, 8.7133201843540995, 8.0099491969619425, 3.408178127748358, -6.1241971022028396, -12.736128845291272, -45.232132533425755, -61.3791750629996, -153.42214558232837, -67.595097514570796, 85.625899103861244, -58.961155821254636, 56.883206971067992, -1105.7125877167775, -1066.0901100808514, -1171.2701320923616, -223.1510166903665, -49.090655504704266, 242.13940044346495, 187.57398243385657, 37.630624824958112, 28.849867481961542, 8.4569554634773265, 4.9702839577388582, 4.4028115702250554, 1.4310556478305501, -1.929060150422355, -6.8702061592831818, -7.5557834297932249, -6.2828152868831211, -0.10870593803434039, -0.35173698335235887, 2.5520560959229499, 3.0896458550054593, 4.7505220002799033, 1.2377659738692817, -1.7806530124299274, -9.1879671692559626, -20.164632449396379, -65.591240653702698, -60.869480400000917, -62.271759486118263, -69.04223895420877, 113.44009243151515, -280.24622279593513, -361.29505764988915, -32.2389038646619, 397.42763261597736, 412.9673372382922, 359.76401050336045, 192.6210800054142, 122.25882006598455, 49.109708531705785, -0.83416770813231356, 2.4803036198391495, 2.5045331182816137, 2.1157075816863125, 2.0456835555591151, -1.3319639541688315, -4.1057658132159602, -5.2622609905014679, -3.122429370817716, -0.23490025627283884, 0.40862649299968534, 1.0190926814192749, 2.6652215067301066, 2.3902937959311288, 1.3072901204360872, -2.1976906085986245, -4.7205289930149936, -17.964658686821839, -21.918559933832515, -40.854552179344822, -68.24351076369831, 25.856495589804037, -73.74721318359471, 26.189735785049756, -56.726426890704197, 461.88238037931336, 400.36625478870423, 367.42140066372616, 233.95717316464078, 120.24788693419019, 56.86229814651989, 16.528423808469729, 5.5081763037408891, -2.7285347510623343, 0.91768473485835012, 1.922818700657754, 0.85878662181529319, -0.082031723657331246, -3.1986596327501684, -2.7995613930163934, -2.624028681216124, 0.082235364558318216, 0.13384423623927519, 1.9947594371394528, 1.3437508199980643, 2.6398410865992954, 0.73758290379789837, -0.13078900915043976, -4.4953343292506398, -5.1950335909144894, -13.12242317098767, -25.523369493146305, -12.192196214097944, -25.868477512213353, 2.9066782920883432, 34.106574161015573, 256.00130492151595, 208.58597838816522, 310.3347945923577, 177.03891975992664, 97.122360992021001, 48.488510187113192, 24.528917872852549, 4.6272034575157122, -1.3571647909533122, 0.20621269482631011, -0.40867746076362715, 0.99215767258594889, 1.5313768256641691, -0.052772985639764861, -1.5552847934304939, -2.8318141898835965, -1.44106038161314, -1.7221472209588695, 0.61786747800524422, 0.48048213041449506, 1.7161555169971148, 0.88689757979195871, 1.4761658864245926, -1.7252645996654892, -0.81528783024945528, -3.3158091950668926, -7.6513645380807835, -2.9281859927886749, -12.462674546124116, -7.4696827367159715, -23.236903073402107, 43.7319836231637, 92.321882041990349, 70.117668379783737, 34.226649356314077, 47.258739472197036, 25.375797504306092, 12.406583490274283, 8.6535618432690811, 1.0747519793409035, -0.44324044078252567, -1.7584707522262704, 0.72458607165998101, 0.70692065864217946, 0.77076345191259166, 1.0649069250197341, -2.7261985428418192, -1.9302074459527443, -3.3754250277859401, 0.50673349306549698, -0.64031672309299725, 1.374850007673434, 0.72950552648490297, 2.3325303094340692, -0.9986473214357906, 0.78195787446934228, -1.1999635798104886, -3.4858876190620522, -1.4991310089769327, -2.8433755069243221, 3.7638952884372583, 1.2400980139632869, -2.9542792497780144, 1.8234355680479359, 49.576244746235467, 19.014215780516388, 30.877310974744532, -1.1221271518157558, 7.8208026967228905, 2.609067592037944, 1.2521971880796572, -0.99505064345958283, -1.3975466814991453, -0.57338407820284554, -1.8697004151394911, 2.3700280505641378, 1.696784850403636, -0.61519740478736618, -1.3317994275810727, -4.2071746247346917, -0.85834734780410316, -1.4672332071937433, 2.6381100233578914, -2.4176769851497171, 2.0131074000190821, -1.6262628596018911, 3.9814331515508763, -0.027677673297514374, -2.444607041276003, -1.6150024285043403, -4.1227589144067673, -1.7068861549694658, 2.2919486155920237, 12.185386506158462, 9.103962312567619, 7.1597604706792799, -5.4087151249860161, 0.96974162117579055, -11.947201833901593, 6.6330620252490986, 2.1152085218133552, 3.546929348907518, 0.62283616740311709, -1.3522725353705505, -2.4444202103018355, -1.5690941230144015, -0.0069858778603680161, -2.2282653754616524, 3.8284308308873771, 3.1912913728027457, -5.5805618725494135, 0.13049495818795365, -3.5197176720292105, 1.8802124921714005, -2.6189977871286096, 2.1235611153433935, -7.1463089769422359, 4.7729314123471731, 2.1077672614040215, -0.81910125894631813, 0.72052624692713507, -3.4842402749887631, -4.1829115306886377, -4.3994325344570067, 3.0953565929079909, 11.949390330752637, 23.680136621529911, 21.558658775121675, 22.744598059672118, 24.943328767928129, 28.901352722188449, 12.814680673201753, 13.644932734111247, 5.45768556544121, 2.4025753394703617, -1.1673355625318591, -2.4971924284976894, -1.8952846661475429, -1.2927419412763479, 2.7902732019969552, -4.3477010834394934, 3.7423253621601038, 4.3959804108055893, -8.9257994152947724, 2.882370251254919, -5.0577698714645729, 3.1829717367300585, -13.324209534416688, 6.2785045354550411, -0.87489834284363188, -0.85263104321571348, 4.4885662153073236, -0.53110232172652128, -1.6389132121610095, -4.3945543864166812, -4.2936344828625694, 0.48745205753098192, 15.895360345460416, 25.169617383292081, 33.918445473292621, 23.996907911576923, 23.251277269359601, 5.1543156647143702, 18.554102826608389, 16.359265688234956, 10.231244633613841, 1.5587865083621433, -1.4683911434431964, -2.958105786087343, -1.5689869488245065, -0.96051225634847215, 1.7578951205789273, 6.6638352938822507, -9.4901775499106478, 4.1317473271038834, 10.951455398944859, -15.360897164532773, 5.739294741971535, -17.045217645164048, 5.8449684444103616, -3.5521886878464675, -7.3858280585812945, 5.7347340895196259, 0.4908832539545151, 0.98666637905349674, -1.0149409800154179, -1.6832477381822215, -2.5467748158366237, 2.0904065823844138, 13.443724261124899, 31.761133485201317, 33.671186166611122, 40.707191608760652, -1.1509826127936451, 21.096779572504321, 10.924705320167561, 7.3688776104039446, 6.4733533392666498, 1.1232923919614803, -2.4431302941492752, -2.7804484266994756, -1.6225398299131664, 0.6478030911844409, 2.5793951871330139, 3.1124056384095988, 9.3832743597685244, -14.195954313031031, -0.57608988546761064, 19.479390479219269, -31.200338855208866, 14.100113777774123, -5.3856662644378392, -10.946378631138824, 4.4142064356850845, -3.9066652322250062, 0.66844910598604979, 1.0227755630951001, 0.66137538568075327, -0.38567118503773246, 0.24821124990411303, 3.5872841231435211, 14.053276636456639, 24.260931372233497, 33.647459095648763, 7.6529271231588307, -9.2151377078706354, -38.311665858686638, -16.121399661234683, -5.9927868178298498, -2.7701365304211771, -3.7140088945870469, -3.0788396721523017, -3.0904878618769733, -1.8655827999533823, 0.43690140001808947, 4.1561194908680763, 4.3858952392085353, 2.7714027971729753, 9.257895969243517, -19.629364588289473, -14.072043519544888, 36.373196183604975, -13.61372365841147, -9.4583423311161248, 8.5284583277520429, -6.1744651457950592, -2.2310052363098367, -1.75629520897435, 1.1539693350814639, 1.7596902661237352, 1.8196834579374304, 2.022290334087173, 5.1646829084835781, 12.770276815017757, 24.46979490512981, 27.822785449092486, 29.828540342091252, 0.0, -3.7653763488297254, -24.757305904406468, -19.738984856989376, -8.2664619761594462, -4.6495144591838038, -3.656340919703911, -2.9147641885479052, -2.2830188616483764, -0.10916825448095578, 2.3916977668177819, 5.941240494184604, 2.1224657474819093, 3.9401472638367774, -2.1445277323266949, -10.774805376941604, 0.0, 10.774805376941531, 2.1445277323266829, -3.9401472638367951, -2.1224657474819155, -5.9412404941846173, -2.3916977668177926, 0.10916825448094437, 2.2830188616483764, 2.9147641885479065, 3.6563409197039234, 4.6495144591838136, 8.2664619761594498, 19.738984856989411, 24.75730590440644, 3.7653763488297773, 9.2151377078736516, -29.828540342087546, -27.822785449090652, -24.469794905129369, -12.770276815017642, -5.1646829084834636, -2.022290334087153, -1.8196834579374237, -1.7596902661237566, -1.1539693350814775, 1.7562952089743382, 2.2310052363098212, 6.1744651457950415, -8.5284583277521193, 9.4583423311161194, 13.613723658411436, -36.373196183604932, 14.07204351954484, 19.629364588289484, -9.2578959692435348, -2.7714027971730033, -4.3858952392085584, -4.1561194908680932, -0.43690140001811473, 1.8655827999533605, 3.0904878618769729, 3.0788396721523177, 3.7140088945872396, 2.7701365304214618, 5.9927868178306163, 16.121399661236502, 38.31166585868818, 1.1509826127964509, -7.6529271231568821, -33.647459095647825, -24.260931372233326, -14.053276636456571, -3.5872841231435073, -0.24821124990410889, 0.3856711850377551, -0.66137538568076071, -1.0227755630951023, -0.66844910598607266, 3.9066652322249751, -4.4142064356851165, 10.946378631138813, 5.3856662644378339, -14.100113777774116, 31.200338855208855, -19.479390479219351, 0.57608988546757856, 14.195954313030994, -9.3832743597685617, -3.1124056384095939, -2.5793951871330338, -0.64780309118445645, 1.6225398299131557, 2.7804484266994689, 2.4431302941492916, -1.1232923919613498, -6.4733533392663958, -7.368877610403441, -10.924705320166419, -21.096779572501951, -23.251277269357679, -40.707191608758833, -33.671186166610063, -31.761133485200901, -13.443724261124748, -2.0904065823843769, 2.5467748158366237, 1.6832477381822348, 1.0149409800154132, -0.98666637905348697, -0.49088325395452825, -5.734734089519665, 7.3858280585813008, 3.5521886878464564, -5.8449684444103243, 17.045217645163998, -5.7392947419715155, 15.360897164532778, -10.951455398944907, -4.1317473271038754, 9.4901775499106655, -6.6638352938822702, -1.7578951205789377, 0.96051225634844795, 1.5689869488244914, 2.9581057860873381, 1.4683911434432237, -1.5587865083620118, -10.231244633613667, -16.359265688234554, -18.554102826607274, -5.1543156647129926, -24.943328767927714, -23.996907911576475, -33.918445473292081, -25.169617383291836, -15.895360345460304, -0.48745205753098297, 4.2936344828625552, 4.3945543864167149, 1.6389132121610113, 0.53110232172653837, -4.4885662153073405, 0.85263104321570904, 0.87489834284363122, -6.2785045354550046, 13.324209534416719, -3.1829717367300314, 5.0577698714645702, -2.8823702512549096, 8.9257994152947653, -4.3959804108056124, -3.742325362160086, 4.3477010834395236, -2.7902732019969543, 1.2927419412763401, 1.8952846661475349, 2.4971924284976934, 1.1673355625318764, -2.4025753394703346, -5.4576855654411656, -13.644932734111133, -12.814680673201632, -28.901352722188015, -0.96974162117503315, -22.744598059671098, -21.558658775121231, -23.680136621529623, -11.949390330752514, -3.0953565929079563, 4.3994325344570004, 4.1829115306886644, 3.4842402749887649, -0.72052624692711631, 0.81910125894632069, -2.1077672614040264, -4.772931412347166, 7.1463089769422288, -2.1235611153433602, 2.6189977871286789, -1.8802124921713912, 3.5197176720292407, -0.1304949581879572, 5.5805618725494606, -3.191291372802759, -3.8284308308873531, 2.228265375461667, 0.0069858778603283057, 1.5690941230143916, 2.4444202103018267, 1.3522725353705702, -0.62283616740308378, -3.546929348907534, -2.1152085218133783, -6.6330620252487682, 11.947201833901675, -19.014215780515311, 5.4087151249861485, -7.159760470678993, -9.1039623125675071, -12.18538650615837, -2.2919486155920032, 1.7068861549694805, 4.1227589144067789, 1.6150024285043441, 2.4446070412760443, 0.027677673297527423, -3.981433151550863, 1.6262628596018724, -2.0131074000190696, 2.4176769851497326, -2.6381100233578612, 1.4672332071937413, 0.85834734780414157, 4.2071746247347095, 1.3317994275810989, 0.61519740478738694, -1.6967848504036496, -2.3700280505641422, 1.8697004151394931, 0.5733840782028331, 1.397546681499154, 0.99505064345958893, -1.2521971880796428, -2.6090675920379729, -7.8208026967229012, 1.1221271518159068, -30.877310974743335, -70.117668379782501, -49.576244746235311, -1.8234355680484657, 2.9542792497778261, -1.2400980139631994, -3.7638952884372125, 2.8433755069243154, 1.499131008976947, 3.4858876190620642, 1.1999635798105424, -0.78195787446931964, 0.9986473214357916, -2.332530309434083, -0.72950552648488864, -1.3748500076734225, 0.64031672309302556, -0.50673349306550342, 3.375425027785985, 1.930207445952772, 2.7261985428418698, -1.0649069250197167, -0.77076345191255435, -0.7069206586422051, -0.72458607165999755, 1.7584707522262737, 0.44324044078250502, -1.0747519793408324, -8.6535618432689372, -12.406583490274217, -25.375797504305602, -47.258739472196019, -34.226649356312784, -208.58597838816522, -92.321882041990833, -43.731983623163735, 23.236903073401958, 7.4696827367159822, 12.462674546124104, 2.9281859927886771, 7.6513645380808271, 3.3158091950668926, 0.8152878302494978, 1.7252645996655027, -1.4761658864245817, -0.88689757979195827, -1.7161555169970975, -0.48048213041447491, -0.61786747800518715, 1.7221472209588695, 1.4410603816132017, 2.8318141898836315, 1.5552847934305372, 0.05277298563978073, -1.5313768256641445, -0.9921576725859278, 0.40867746076360606, -0.20621269482631011, 1.3571647909533708, -4.6272034575156908, -24.528917872852457, -48.488510187113178, -97.122360992020845, -177.03891975992676, -310.33479459235781, -461.88238037931535, -256.00130492151709, -34.106574161017335, -2.9066782920893011, 25.868477512213314, 12.192196214097933, 25.523369493146241, 13.12242317098773, 5.1950335909144911, 4.4953343292507366, 0.13078900915048275, -0.73758290379785463, -2.6398410865992936, -1.3437508199980366, -1.9947594371394133, -0.13384423623915356, -0.082235364558330679, 2.6240286812162581, 2.7995613930164374, 3.1986596327502643, 0.082031723657369299, -0.85878662181523746, -1.9228187006577324, -0.91768473485829727, 2.7285347510623108, -5.5081763037407097, -16.528423808469462, -56.862298146519464, -120.24788693418984, -233.9571731646403, -367.42140066372525, -400.36625478870656, 32.238903864660138, 56.726426890699642, -26.189735785051667, 73.747213183594084, -25.856495589804108, 68.243510763698637, 40.854552179345092, 21.918559933832821, 17.964658686821831, 4.7205289930151793, 2.1976906085987129, -1.3072901204360032, -2.3902937959311101, -2.6652215067300165, -1.0190926814191563, -0.40862649299943438, 0.23490025627283342, 3.1224293708179411, 5.2622609905015993, 4.1057658132160988, 1.331963954168899, -2.0456835555590454, -2.1157075816862583, -2.504533118281568, -2.4803036198391473, 0.83416770813248287, -49.109708531705543, -122.25882006598383, -192.62108000541431, -359.76401050336045, -412.96733723829362, -397.42763261597815, 1066.0901100808455, 361.29505764988636, 280.2462227959299, -113.44009243151743, 69.042238954208585, 62.271759486118853, 60.869480400001216, 65.591240653703366, 20.164632449396354, 9.1879671692563107, 1.7806530124300617, -1.2377659738691233, -4.7505220002798652, -3.0896458550052697, -2.5520560959227772, 0.35173698335277165, 0.10870593803433028, 6.2828152868834488, 7.5557834297934026, 6.8702061592834163, 1.9290601504224327, -1.4310556478304128, -4.402811570224995, -4.9702839577387659, -8.4569554634772928, -28.849867481960956, -37.630624824957771, -187.57398243385583, -242.13940044346546, 49.090655504701473, 223.15101669036463, 1171.270132092355, 797.42142339187455, 1105.712587716775, -56.883206971068894, 58.961155821254195, -85.625899103861229, 67.595097514571449, 153.42214558232899, 61.379175063000453, 45.232132533425769, 12.736128845291734, 6.1241971022030093, -3.4081781277481404, -8.0099491969618857, -8.7133201843538846, -0.50258781153503296, -6.2100452165045663, -0.055102663998530817, 7.2904568591883807, 11.383176063308918, 8.3377118534845209, 5.009304162269923, -3.7481817410605087, -5.9093841314446331, -10.425252515086191, -13.171326963991898, -46.446591336113507, -153.25086116745101, -61.506465075545563, -49.92317026240935, 238.33663106152528, 1665.2932495998259, 1141.9271710506428, -2184.1299326736644, -2621.2839732861944, 1461.5017842629866, 622.62775933129569, -150.90670251969709, 353.39952612993454, 133.18984159990904, 96.051765336731378, 48.315266721271847, 26.315486653092378, 12.47210594725734, -0.11325917153558851, -7.3164558165842362, -6.2779141420297728, -6.325879336386472, -6.7615499928705614, -5.7853993354930182, 6.8948411718656626, 16.574215370008741, 12.843645059742064, 5.220057623492746, -3.813299856725167, -10.051165980763182, -16.420203889130285, -29.183435066681557, -64.570588674310201, -181.43163787734505, -272.38382351444022, 695.96261474412938, 397.20604751762363, -1430.9649107108592, -343.81610498084137, -10840.70196519443, 3453.3010516439876, -827.61688284819604, 1299.088897602802, 867.92363746103354, 248.20433151041067, 209.92149032340356, 104.5932404597956, 56.939768493357427, 19.205045070960029, 9.3006029966243737, -3.0671728952866175, 1.5669942788764133, -5.5752197676024959, -4.7947040656806426, -12.570054144236753, -3.2879617770347638, 0.44183444538609318, 16.179758937656128, 15.672094697047777, 15.514190495563801, -6.2249226907648021, -9.506443517257205, -24.595484776028343, -43.394725496932452, -113.80000983072682, -179.30887547689812, -162.42212696599955, 210.28695062763467, 461.44982475214965, -3231.3822724351485, -18380.248977426934, -21415.511526704078, -11789.651384311637, 6340.0761451283952, 3254.3286688062612, -274.13539619635947, 816.21574466320624, 214.24479740751747, 150.50951383829917, 62.077231813228565, 28.921613512340514, -1.7353747463964819, -0.92198929608524804, -10.299898240809465, 0.679005237978899, -28.352674755287008, 1.4030381833925814, -4.4649861577325289, 13.739274709477487, 12.454719286950338, 19.12568021630095, 11.158748163655963, -3.3051410229907021, -16.992665274592852, -22.790809731221124, -60.852179067446897, -118.67047187223945, -253.85827683649717, -106.10534760670436, 477.33409412636507, -4606.7423967050645, -6140.0706338628543, -9240.4816801839206]}};

  var mouth_filter = {"real": [4.6340891519992962, 0.7844322938332674, -1.1596739705934982, 3.9933365069793401, 1.0745202382104644, -0.86566739843778528, -0.97931984026536645, -0.55848113024930113, -0.35079784655500912, -0.28441072774545773, -0.088142362922499759, 0.027465161121858393, -0.014037496255053593, -0.0045512610044201119, -0.0097173297219694255, 0.0018722497460425004, 0.00034424707543540862, 0.0018722497460384895, -0.0097173297219602297, -0.0045512610044239907, -0.014037496255053029, 0.02746516112186332, -0.088142362922505241, -0.28441072774544834, -0.35079784655500912, -0.55848113024929857, -0.97931984026536589, -0.86566739843778451, 1.0745202382104642, 3.9933365069793414, -1.1596739705934984, 0.78443229383326629, -0.64146012074713299, -1.4031948309962614, -0.72621528546721359, 2.8301862310857646, 0.22901892606370081, -2.4871893946676962, -0.82292478776907829, -0.038551737265843086, -0.20580868221576679, -0.28505928673030462, -0.18459030185549916, 0.058925447647408556, 0.0086943334915795256, -0.0086001017349623815, -0.0048545170036036192, -0.0004539351773376722, 0.00092194354279838148, 0.0017350493936515445, -0.0021057925479370247, -0.0060275384450162546, -0.01880365799458189, -0.023918178864192268, -0.020757173724755319, -0.18669623657203888, -0.43413705625508531, -0.36480504844763911, -0.32161507141862777, -1.8059188349376913, 0.70639011502857929, 3.4760111666249314, -0.5602942662325473, -0.88313644188618323, -3.1958827705277328, -4.1322391810878196, 0.77904148145098406, 5.0612923845025648, 1.5447671531259652, -2.8176609661232312, -0.63748901957655968, 0.36914599600864362, -0.00037729870766316427, -0.17990982199486863, -0.032569510455235789, 0.0085089063175920673, -0.014523430514595712, -0.012452101483067112, -0.0012625852907501049, 0.00028475514852645983, 0.0011591891684665802, 0.00039450549224649017, -0.002943469227087628, -0.010724474299968166, 0.0061262158881635236, 0.029252238624593387, -0.12159824966625053, -0.31076930784864121, -0.41364470354134941, 0.022306497695738548, 0.074366913048009908, -2.6718092121882169, -0.77719061117874755, 3.9762898076403879, 3.2079354493433021, -4.4012300899429189, -2.5660816993858311, -2.553218193276197, 2.0684625359523285, 4.9974951908094045, 2.143461857355776, -1.7847370377532255, -0.28821333774369001, 0.10766200451394388, 0.18782859841053653, -0.019310891700896299, -0.0062567209274460587, -0.0064371871903130887, 0.0021510630118947156, -0.011505776785749768, -0.0029992319263973479, 0.00030084525589988385, 0.0010941864062154283, 0.00030288821499767468, -0.0032329177128834767, -0.010312595680378463, -0.0068340802376650614, 0.019823041367851263, -0.0078950524544473683, -0.23245655665346024, -0.14923618615195547, 0.056419081419621493, 0.16707514445150673, -2.1849562859013951, -0.54088886065646191, 4.0516538348232194, 4.2406226010125279, -1.7936849281843577, -2.9840428724267536, -3.2115132203593002, -1.9470763746691873, 4.1518693114943472, 2.4862294474678142, -0.30639511041804085, 0.024820417007377235, 0.27577100857260728, 0.055259784589899323, -0.14220319122433717, -0.08642751724431888, 0.023244530667997254, 0.012523451759435138, -0.0058546865987889477, -0.0029976575640192626, -3.5555809550126927e-05, 0.00047377824955015626, 0.00099596206424971642, -0.00098919816572873276, -0.0097580547506740285, -0.020619695697678356, -0.0037015241751264089, -0.003593154009926945, -0.045481667679613515, 0.090305489910112821, 0.19683301699858768, 0.20611623580645685, -0.90233672462032366, 0.065306828187895322, 4.7788333108246484, 2.9026377323781798, -3.2466266324527706, -2.1436478188271333, -2.2561432890218653, -1.9115416020763942, 2.2130343552583907, 1.9915993980953659, -0.056495739083329222, -0.2528646737117784, 0.14962266633073235, -0.0099224078218753502, -0.1479065510292869, -0.07230224268075354, 0.0058318523760505494, 0.0022686064052674618, -0.00013275302826153175, -0.00063102743369309689, 9.1509786481767957e-05, 0.00031972746011452689, 0.00053353867978528325, -0.00058791023420762787, -0.0052408752439335538, -0.0091860766601598153, 0.015159206837947898, 0.016910593952452414, -0.099017880584634829, -0.099839128057652077, 0.28004861021942001, 0.37300273050036969, -0.085260591440202538, 0.41189695036617391, 2.9117111935410587, 0.66045559278765098, -2.6585359534260435, -1.484629636420711, -1.5429215388219939, -1.0057598114385591, 1.6171176031175611, 1.3492912586213337, -0.42857897427067643, -0.50006058673779852, 0.027713169661722398, 0.11528070486941493, -0.039483986090959794, -0.044672910989708811, -0.0092116030206209065, 0.00050303223447250363, 0.00117999940390684, -0.00042184774624830218, 4.668492787763195e-06, 0.00031547415704219679, 0.0001689251312381811, -0.0012866387173093054, -0.0021139867571189981, -0.0022343140961022454, 0.0092259555638931588, -0.0022666885302687536, -0.077537144546569597, -0.14256276290766454, 0.027946173791502729, 0.115246314279082, -0.3242302049719249, 0.30841119378164411, 1.9739342660507115, 0.88921924763931337, -1.5931958725731872, -1.0137169086218167, -0.98220755452462893, -0.55271078229049098, 1.084545546778825, 1.0070569814426842, -0.18251897039350226, -0.37931318856894325, -0.013449845022921075, 0.075764515301197377, -0.035369123979370719, -0.015619619770784467, 0.003123860549792537, 0.0028409863743067009, -0.00016094314378723183, -0.0010442109044203019, -9.8941097057248808e-05, 0.00016280791369542986, 0.00021650467324038706, -0.00047567037374047843, -0.00092328459105976625, -0.0014357330004678133, -0.00013185634410259166, -0.0087980568614916873, -0.057667801386191805, -0.014139365016219003, 0.15150048657312606, -0.063156821697620796, -0.52703545490563852, -0.11064525699952842, 1.3541882686537436, 1.0048741532970387, -0.82641052291163419, -0.55788342432782989, -0.54692805386470211, -0.22545269169536206, 0.6740428991302807, 0.63746360531382218, 0.053213891179403915, -0.16323047770545179, -0.05067162930818387, 0.0058333166986499468, -0.012742844783306895, -0.0071596160198456604, -0.00093377357192446454, 0.0012222061966531139, 0.00017574396951624128, -0.0005642074481669886, -6.0828659546840626e-05, 9.2871290444668044e-05, 0.00015000413209498726, 4.777345737973158e-05, -0.000326961738278439, 0.00024195810565667486, 0.00080694685438762858, 0.0024162562143001782, -0.021930873945379376, -0.011688581845023685, 0.11525275913926007, -0.020751088469611444, -0.33588482906629819, -0.021354414893159417, 0.81277558638075542, 0.72624502554486348, -0.35235216014446363, -0.26240454745464498, -0.25116485949546724, -0.047416949334167319, 0.41581226861132581, 0.36754912691134745, 0.031499405618264475, -0.1182059528936131, -0.027325517544006306, 0.017104517731676545, -0.0028988620733824016, -0.0076630041566265582, -0.0029377702512214019, 0.00085784401988343753, 8.3233018006220044e-05, -6.6626176934615107e-05, 3.0121602117794285e-05, 2.7157707030347298e-05, 5.3948506612911946e-05, 4.1294414526828764e-05, -0.00045536935945395869, -0.00011944277202748304, 0.001701190526917767, 0.00018736852574408679, -0.0020488748359166246, -0.0058560651797691897, 0.014332522459211712, -0.02484159185287883, -0.16044866683911937, 0.063133068421675945, 0.47884903706850868, 0.46922977068813959, -0.1005858110717496, -0.10558450478212159, -0.094572659725636055, 0.030818986514241645, 0.17934859926238414, 0.13718905272203691, -0.010905020288841244, -0.05427060295960378, -0.0073090810457242502, 0.01494907224279079, 0.0034945285778568377, -0.0038412851930084225, -0.0011597829517094804, 0.00044322180186623985, 5.4551216944427788e-05, -9.2794624249969221e-06, 9.5078851906194622e-06, 4.2007998035232393e-06, 4.0012008897297825e-06, -1.1774818209916229e-05, -0.00027037083981188163, -0.00035658526841883775, 0.0010094103856456143, -0.00052904996994269221, -0.0074682098820876806, -0.0022588127195562607, 0.018210634042398671, -0.009508805432907743, -0.085651174753861262, -0.014342078173992242, 0.19289673419785613, 0.23928297364621173, 0.039149520251701771, -0.061014517221157215, -0.057366565922661691, -0.0080064655214225223, 0.076289242121436118, 0.062033108089888676, -0.0026674849249250141, -0.024627343791732099, -0.005372625137310909, 0.0080653113868279242, 0.0030108297249231111, -0.0014118319882570156, -0.00042245914300035952, 0.00026288061895118008, 3.9126968311475854e-05, -2.5576892658974124e-05, -1.3099831737018989e-05, 6.8014805414260688e-07, 6.9755222362157937e-06, 4.1140465083074929e-06, -6.1370755554305661e-05, -0.00013364764935139172, 0.00021919093935820536, -0.00034687380123466822, -0.0034793424266583023, 0.00040352462407419059, 0.01373845906597586, 0.0021423976061818307, -0.037152134230387414, -0.017035854478310443, 0.07316876401329736, 0.093558727298951636, 0.001337949029101016, -0.028771535917646113, -0.027836987718903094, -0.0056044573137369316, 0.030982713752819017, 0.025812139891197732, 0.00074892492781415969, -0.0079187798201619947, -0.002052401353006265, 0.0023870007142673053, 0.00047709621801237946, -0.00019244333515306637, 2.364174882971905e-06, 7.8630073383472148e-05, 1.0976829691696413e-05, -4.9478433448607269e-06, -2.9053042363364555e-06, 2.3830467829361056e-06, 3.9023671373108736e-06, -2.6460791618778472e-06, 1.0608628096643537e-05, 3.3021940418689286e-05, 0.0001912157704189101, 6.7444175547866513e-05, -0.00096115828672010788, 0.00087008244330741215, 0.0067484721896968842, 0.0013604220025846133, -0.013837221190936331, -0.0075049977300193776, 0.030023800478366884, 0.039750958563338108, -0.00010247159736706737, -0.01163043609268417, -0.0096266829589855638, -0.00012449081323135682, 0.0098966622932942921, 0.0080718452892629081, 0.0011587204509509821, -0.0023373825953736087, -0.00080711215646797813, 0.00063105697122019017, 0.00025055042762753488, -0.00015724082609640453, -2.9456254661901335e-05, 2.2436391551144613e-05, 5.7614021056943357e-06, 9.2836238115278777e-08, -2.983219466927386e-07, 3.9469148175242839e-07, -1.897541367332826e-07, 2.3086718690330816e-07, -3.2379878454182751e-06, 2.9136696178544169e-06, 9.1340416066903861e-05, 0.00013720705972618841, -0.00027185621825451397, -0.00025621479435585686, 0.001222650455527893, 8.5193002129657069e-05, -0.004064865703922135, -0.00029221589048634159, 0.011494835522638509, 0.01340946760762054, -0.00054241338513798362, -0.0039904416962682253, -0.0028675934245187911, 0.00011970246178788614, 0.0032259655922311906, 0.0027177896529416603, 0.00029039751533865968, -0.00056045647677372237, -0.00011868935035429348, 8.6932625960108793e-05, 4.0585244752836994e-05, -3.9685399626399569e-05, -3.3675702194659581e-05, 1.8041324860728306e-06, 7.1527415341150131e-07, -2.5874877778097139e-07, -3.5187588582041102e-07, -4.9612975448428711e-07, 4.7392836724258751e-08, -2.7763787498630026e-07, -8.4165778406209883e-07, 3.0761526067769889e-07, 1.927255849211769e-05, 3.5189855392011486e-06, -9.8678053133183447e-05, -6.2632939936424042e-05, 0.00017511504940116496, -9.4816296748496417e-05, -0.0010867114051789507, 0.00038291262596998446, 0.0037605600166853263, 0.0033513976296794821, -0.0010579625982184212, -0.00083900520021582383, -0.00052619171844538041, 0.00055771306950743252, 0.0012835447933515079, 0.00080151927400318277, 6.1491898000095208e-05, -0.00011622895984693472, -2.362760140891841e-05, 3.979172224729024e-05, 7.0290787962574776e-06, -8.7051393881149627e-06, -1.7451721719085544e-06, -1.971994185063341e-06, -7.5103971978779283e-08, -6.3110103076160124e-08, -6.5527443378366647e-08, -1.271443792432593e-07, 9.3246051218088246e-08, 1.5092375607837617e-07, -4.0633606215809979e-07, 4.8842482637076878e-07, 6.2006052053478677e-06, 9.9625085097078631e-06, -8.4218410398305216e-06, -2.1130341683092213e-05, -8.6580287858941996e-06, -0.00010846093496444906, -0.00019573231564846473, 0.00038253737826254207, 0.0014355018795734822, 0.0012361430930244762, -3.8330562655413493e-05, -0.00045693558279248441, -0.00013724958223101865, 0.0005563817789235216, 0.0008124065993596201, 0.00038839544015797694, 5.2654227599481573e-06, -2.0620767185676097e-05, 1.4058588768839616e-05, 2.4456681475752488e-06, -1.3038942789126752e-06, 3.2957272146113247e-06, 2.136839449678527e-06, -3.8521786796247972e-08, -3.9949631386029851e-07, -2.803297067646553e-08, -4.2841831822770929e-08, -2.708778766944344e-08, -4.2841831887488422e-08, -2.8032970597075431e-08, -3.9949631385981395e-07, -3.8521786746470003e-08, 2.1368394496269648e-06, 3.2957272146716597e-06, -1.3038942788497014e-06, 2.4456681475752488e-06, 1.4058588768888149e-05, -2.0620767185710351e-05, 5.2654227597687651e-06, 0.00038839544015800736, 0.00081240659935969219, 0.00055638177892360769, -0.00013724958223097121, -0.00083900520021596553, -3.833056265530287e-05, 0.0012361430930255431, 0.0014355018795735538, 0.00038253737826226555, -0.00019573231564817955, -0.0001084609349642516, -8.6580287858519462e-06, -2.1130341683048624e-05, -8.4218410398544215e-06, 9.9625085095730612e-06, 6.2006052055115093e-06, 4.8842482632655112e-07, -4.0633606237408006e-07, 1.5092375605026055e-07, 9.3246051443898654e-08, -1.2714437924313219e-07, -6.5527443487134095e-08, -6.3110103047252147e-08, -7.510397195070611e-08, -1.9719941850259958e-06, -1.7451721718998097e-06, -8.7051393879504859e-06, 7.0290787963321046e-06, 3.9791722247395916e-05, -2.3627601408864216e-05, -0.0001162289598470872, 6.1491898000005259e-05, 0.00080151927400328501, 0.0012835447933512035, 0.00055771306950693161, -0.00052619171844531059, -0.003990441696267554, -0.0010579625982183091, 0.0033513976296794508, 0.0037605600166856607, 0.00038291262597007754, -0.0010867114051789164, -9.4816296748372926e-05, 0.00017511504940131815, -6.2632939936292583e-05, -9.8678053133139699e-05, 3.5189855391400817e-06, 1.9272558492233388e-05, 3.0761526064323095e-07, -8.4165778419493996e-07, -2.7763787504721638e-07, 4.7392836831470689e-08, -4.9612975448445027e-07, -3.5187588609488416e-07, -2.5874877778167802e-07, 7.152741534536303e-07, 1.804132486106339e-06, -3.3675702194604274e-05, -3.9685399626282394e-05, 4.0585244752900393e-05, 8.6932625960089156e-05, -0.00011868935035428417, -0.0005604564767739365, 0.00029039751533834201, 0.0027177896529417466, 0.0032259655922308689, 0.00011970246178728064, -0.0028675934245188605, -0.011630436092684446, -0.00054241338513798633, 0.013409467607620592, 0.011494835522638138, -0.00029221589048616421, -0.0040648657039219702, 8.5193002129971217e-05, 0.001222650455528094, -0.00025621479435585409, -0.0002718562182545189, 0.00013720705972611116, 9.1340416066969292e-05, 2.9136696178498302e-06, -3.2379878454707733e-06, 2.3086718686225909e-07, -1.8975413675430027e-07, 3.9469148175231827e-07, -2.9832194662415222e-07, 9.2836238091981533e-08, 5.7614021057956332e-06, 2.243639155115928e-05, -2.9456254661848962e-05, -0.00015724082609634113, 0.00025055042762756014, 0.0006310569712201816, -0.00080711215646793249, -0.0023373825953734708, 0.0011587204509510469, 0.0080718452892626774, 0.0098966622932934109, -0.00012449081323185037, -0.0096266829589855153, -0.028771535917645582, -0.00010247159736742938, 0.03975095856333772, 0.030023800478366992, -0.0075049977300190333, -0.013837221190936397, 0.001360422002584686, 0.0067484721896969484, 0.00087008244330749834, -0.00096115828672011482, 6.7444175547800892e-05, 0.00019121577041898859, 3.3021940418677224e-05, 1.0608628096553211e-05, -2.6460791619305373e-06, 3.9023671372462814e-06, 2.3830467829358028e-06, -2.9053042364313164e-06, -4.9478433448600171e-06, 1.0976829691639238e-05, 7.863007338347967e-05, 2.3641748829703282e-06, -0.00019244333515297128, 0.00047709621801239502, 0.0023870007142673287, -0.0020524013530060455, -0.0079187798201617154, 0.00074892492781425889, 0.025812139891197631, 0.030982713752818712, -0.0056044573137374659, -0.027836987718902747, -0.061014517221157166, 0.0013379490291006914, 0.093558727298950733, 0.073168764013296958, -0.017035854478310443, -0.037152134230387518, 0.0021423976061819595, 0.013738459065975945, 0.00040352462407424605, -0.0034793424266582368, -0.00034687380123471886, 0.00021919093935825583, -0.00013364764935140623, -6.1370755554343757e-05, 4.1140465083160657e-06, 6.9755222361877128e-06, 6.8014805414205017e-07, -1.3099831737122968e-05, -2.5576892658968157e-05, 3.9126968311429429e-05, 0.00026288061895118621, -0.00042245914300031615, -0.0014118319882569644, 0.003010829724923217, 0.0080653113868278357, -0.0053726251373106982, -0.024627343791731683, -0.0026674849249247769, 0.06203310808988808, 0.076289242121435036, -0.0080064655214229473, -0.057366565922661421, -0.10558450478212106, 0.039149520251701674, 0.23928297364621154, 0.19289673419785586, -0.014342078173991857, -0.085651174753861178, -0.0095088054329078991, 0.018210634042398706, -0.002258812719556187, -0.0074682098820877006, -0.0005290499699428646, 0.0010094103856456574, -0.00035658526841884875, -0.00027037083981181821, -1.1774818209899307e-05, 4.0012008896968829e-06, 4.2007998035228361e-06, 9.5078851906702469e-06, -9.2794624249821973e-06, 5.45512169444116e-05, 0.0004432218018662688, -0.0011597829517094238, -0.0038412851930083049, 0.0034945285778569305, 0.014949072242790728, -0.0073090810457241244, -0.054270602959603668, -0.01090502028884107, 0.13718905272203655, 0.17934859926238284, 0.030818986514240795, -0.09457265972563568, -0.26240454745464348, -0.1005858110717494, 0.46922977068813976, 0.4788490370685089, 0.063133068421676597, -0.16044866683911846, -0.024841591852878687, 0.014332522459211764, -0.005856065179769227, -0.0020488748359166085, 0.00018736852574399146, 0.0017011905269178167, -0.00011944277202752463, -0.00045536935945402705, 4.1294414526791867e-05, 5.3948506612877123e-05, 2.7157707030347085e-05, 3.0121602117749643e-05, -6.6626176934661782e-05, 8.3233018006250646e-05, 0.0008578440198834165, -0.0029377702512214973, -0.0076630041566264767, -0.0028988620733823725, 0.017104517731676455, -0.027325517544006247, -0.11820595289361274, 0.031499405618264593, 0.36754912691134622, 0.41581226861132453, -0.04741694933416768, -0.2511648594954663, -0.55788342432782989, -0.35235216014446413, 0.72624502554486348, 0.8127755863807552, -0.021354414893159278, -0.33588482906629807, -0.020751088469611285, 0.11525275913925997, -0.011688581845023685, -0.021930873945379303, 0.0024162562143002332, 0.00080694685438767672, 0.00024195810565667153, -0.00032696173827853592, 4.7773457379814068e-05, 0.00015000413209503944, 9.2871290444668044e-05, -6.0828659546917042e-05, -0.00056420744816712695, 0.00017574396951636955, 0.0012222061966531885, -0.00093377357192450466, -0.007159616019845526, -0.01274284478330687, 0.0058333166986499468, -0.050671629308183697, -0.16323047770545204, 0.05321389117940345, 0.63746360531382207, 0.6740428991302817, -0.22545269169536208, -0.54692805386470211, -1.0137169086218165, -0.82641052291163497, 1.0048741532970369, 1.3541882686537434, -0.1106452569995289, -0.52703545490563775, -0.063156821697620685, 0.15150048657312606, -0.014139365016218914, -0.057667801386191833, -0.0087980568614915919, -0.00013185634410271281, -0.0014357330004678901, -0.00092328459105995816, -0.00047567037374023129, 0.00021650467324065207, 0.00016280791369542935, -9.8941097057279613e-05, -0.0010442109044203046, -0.00016094314378705795, 0.0028409863743067928, 0.0031238605497927777, -0.015619619770784359, -0.035369123979370198, 0.075764515301197433, -0.013449845022920601, -0.37931318856894264, -0.18251897039350262, 1.0070569814426831, 1.084545546778823, -0.55271078229049153, -0.9822075545246276, -1.4846296364207112, -1.5931958725731861, 0.88921924763931159, 1.9739342660507089, 0.30841119378164455, -0.32423020497192495, 0.11524631427908204, 0.027946173791502632, -0.14256276290766468, -0.077537144546569833, -0.002266688530268584, 0.0092259555638929507, -0.0022343140961023017, -0.0021139867571188628, -0.0012866387173093869, 0.00016892513123889085, 0.00031547415704219538, 4.668492787631832e-06, -0.00042184774624882054, 0.0011799994039063304, 0.00050303223447267277, -0.0092116030206206324, -0.044672910989708575, -0.03948398609095928, 0.11528070486941518, 0.027713169661722662, -0.5000605867377983, -0.42857897427067776, 1.3492912586213337, 1.6171176031175631, -1.0057598114385595, -1.5429215388219939, -2.143647818827132, -2.6585359534260422, 0.66045559278764887, 2.9117111935410573, 0.41189695036617402, -0.085260591440201997, 0.37300273050036942, 0.28004861021941868, -0.09983912805765198, -0.099017880584635037, 0.016910593952451765, 0.015159206837948214, -0.0091860766601597858, -0.005240875243933095, -0.00058791023420808302, 0.00053353867978554596, 0.00031972746011452689, 9.1509786481807435e-05, -0.00063102743369398116, -0.00013275302826212034, 0.0022686064052679666, 0.0058318523760503612, -0.072302242680752943, -0.14790655102928651, -0.0099224078218752652, 0.14962266633073282, -0.25286467371177851, -0.056495739083330138, 1.9915993980953646, 2.2130343552583911, -1.9115416020763922, -2.2561432890218649, -2.9840428724267536, -3.2466266324527679, 2.902637732378178, 4.7788333108246475, 0.065306828187895516, -0.90233672462032188, 0.20611623580645633, 0.19683301699858602, 0.090305489910112668, -0.045481667679613411, -0.00359315400992807, -0.0037015241751260411, -0.02061969569767819, -0.0097580547506737354, -0.00098919816572940519, 0.00099596206425130282, 0.00047377824955015637, -3.555580955030948e-05, -0.0029976575640203941, -0.0058546865987889858, 0.012523451759435134, 0.023244530667997261, -0.086427517244318533, -0.14220319122433661, 0.05525978458989915, 0.27577100857260672, 0.024820417007377481, -0.30639511041804179, 2.4862294474678128, 4.1518693114943428, -1.947076374669187, -3.2115132203593006, -2.5660816993858284, -1.7936849281843579, 4.2406226010125261, 4.0516538348232221, -0.54088886065646147, -2.1849562859013973, 0.1670751444515067, 0.05641908141962089, -0.1492361861519553, -0.23245655665346052, -0.0078950524544474775, 0.01982304136785135, -0.0068340802376656131, -0.010312595680378572, -0.0032329177128843376, 0.00030288821499861344, 0.0010941864062154279, 0.000300845255900019, -0.0029992319263979755, -0.011505776785751019, 0.0021510630118943804, -0.0064371871903127383, -0.0062567209274463683, -0.019310891700895682, 0.18782859841053667, 0.10766200451394509, -0.28821333774368862, -1.7847370377532281, 2.1434618573557747, 4.9974951908094001, 2.0684625359523268, -2.5532181932761979, -3.1958827705277333, -4.4012300899429215, 3.2079354493433048, 3.9762898076403923, -0.77719061117874688, -2.6718092121882195, 0.074366913048009561, 0.02230649769573629, -0.41364470354134925, -0.31076930784863965, -0.12159824966625225, 0.029252238624593849, 0.0061262158881634976, -0.010724474299966393, -0.0029434692270879645, 0.00039450549224720385, 0.0011591891684665805, 0.00028475514852767235, -0.0012625852907517934, -0.012452101483067435, -0.014523430514596241, 0.0085089063175917082, -0.032569510455234915, -0.17990982199486819, -0.00037729870766311575, 0.36914599600864506, -0.63748901957656057, -2.8176609661232312, 1.5447671531259644, 5.0612923845025639, 0.77904148145098462, -4.1322391810878223, -0.64146012074713366, -0.88313644188618345, -0.56029426623254674, 3.4760111666249305, 0.70639011502857829, -1.805918834937694, -0.32161507141862899, -0.36480504844764006, -0.43413705625508542, -0.1866962365720416, -0.020757173724754961, -0.023918178864192875, -0.018803657994580801, -0.0060275384450154063, -0.002105792547937667, 0.00173504939364955, 0.00092194354279838181, -0.00045393517734262397, -0.0048545170036007057, -0.0086001017349646748, 0.0086943334915797251, 0.058925447647409854, -0.18459030185549863, -0.28505928673030412, -0.20580868221576676, -0.038551737265842712, -0.82292478776907585, -2.4871893946676935, 0.22901892606369992, 2.8301862310857611, -0.72621528546721381, -1.4031948309962614], "bottom": {"real": [5678.1086041894205, 20900.18095010153, 3447.0499761258557, 3006.2920785513897, 1095.893903110946, 386.81104976321694, 202.87465181506209, 112.96922946840166, 74.157579598112093, 62.413315591675342, 46.931213065231809, 32.703444421117119, 23.138509584976408, 18.532485453515367, 13.839857335386801, 11.995391672846374, 11.011316958211436, 11.995391672846273, 13.839857335386798, 18.532485453515342, 23.138509584976408, 32.703444421117176, 46.931213065231873, 62.41331559167557, 74.157579598112093, 112.96922946840168, 202.87465181506209, 386.8110497632174, 1095.8939031109464, 3006.2920785513907, 3447.0499761258566, 20900.180950101545, 11652.541375531215, 6105.9976767437374, 3079.1167046754913, 1776.9919423314705, 759.63591736173282, 370.96222186223144, 186.72550653728851, 104.06222158598892, 72.776226915090177, 54.132047333262229, 40.617443247446026, 26.905297339122829, 20.596051003825067, 16.964451546104712, 12.574490983994691, 10.149549151428955, 9.456590806505238, 9.9768657536093883, 12.029240511903456, 15.043219420350251, 20.838711299344116, 30.553614566731468, 44.40616386235552, 58.565861412331529, 70.132835875061744, 104.51314473208357, 189.56857349608143, 377.16693201205015, 884.12700895693013, 2239.7595640192126, 3145.1913405539117, 6958.5740759503597, 9609.5106426127932, 4992.6608769394197, 1669.5618690661463, 1059.1995113905639, 549.16279790927274, 278.94923830500289, 170.62516999169446, 111.93749936902557, 73.270251985017907, 52.998042263483633, 37.142546768677903, 24.977928698896999, 19.757351140056166, 15.549412568397655, 12.287444953226689, 10.159177492646036, 9.2913516551568005, 9.4707404644445941, 11.366894624691977, 14.908412193461192, 19.162809661823754, 25.525875481280988, 36.846585979626177, 51.022038209027251, 67.247306229462055, 96.043853286628931, 163.05718048491738, 294.76980362823429, 519.23514670394684, 957.57039473443547, 1368.5173470150648, 3871.635585616455, 5303.4798274482118, 3579.2066474003154, 1207.1822867649944, 879.86972928318005, 366.88528484741369, 208.17182668800805, 144.26637111917213, 100.24198689599578, 68.818117171408701, 48.744575666300129, 36.079835978948523, 24.716276003836366, 18.3829469088219, 14.338503983471835, 11.518473012854098, 9.4389981542904859, 8.6855447757572897, 9.3111499128487676, 10.931731847155714, 14.242659983217518, 18.454273027639637, 22.997981877882626, 32.775354054937182, 47.784430534137819, 65.982333636303437, 97.039219839998921, 143.27997074170094, 205.80805308530745, 348.18684046898466, 831.79281380405996, 1177.2730197279227, 2733.3936378292215, 3938.2641458688445, 2819.7837494548567, 820.36462717097368, 471.37587503146102, 271.87929154854345, 194.2701704157619, 144.96617790506966, 97.576794771201833, 61.3119854017338, 44.971290338260182, 31.994561157116021, 22.178882955012892, 16.262756648609532, 13.335771300720145, 10.777277796853795, 9.4872372674219161, 8.4179220667115882, 8.8615504994164276, 10.464447670423642, 13.467380568991793, 17.380860604603019, 22.603085253093905, 31.976099529363569, 44.356708279359708, 58.842492346581366, 84.943606310881933, 129.92857886018368, 172.62888515328848, 240.58003385007751, 441.25082967480506, 690.43324997326704, 1627.6849016299075, 3510.6104569290264, 2572.5928689582997, 734.84965238283041, 346.49155817100205, 245.54955425961745, 154.38419406683067, 123.89126600552243, 73.592832336469911, 51.176815014056707, 38.823519356586488, 27.703018951863196, 20.40402437294096, 15.615914454631133, 12.262838166368205, 10.911393710353273, 9.2831005853774435, 8.0758021716500519, 8.9560352521382285, 10.337739417364297, 12.597356227543543, 15.877991319670912, 20.726370017730709, 27.911545681671033, 37.940376333065345, 53.075877633932322, 72.520382240797787, 117.05897406186033, 158.12669065273971, 212.38391288711696, 299.48678366969477, 458.16531800810117, 1452.4284055535941, 1811.7186422893874, 1492.3389942582992, 530.65233974797684, 291.76966991086613, 187.69065022036725, 128.13046637777484, 90.24516666546559, 62.18605129748434, 41.710267966739593, 31.806783986884078, 25.068630438788546, 18.542553262414661, 14.666394584276578, 11.150365108371181, 9.9606764098368359, 8.5525257374706207, 7.7030138744354231, 8.2863477700222052, 9.8144929913230374, 11.655898242076917, 14.231766288773079, 17.885476571421012, 23.413082960982251, 31.608461656401264, 43.352221767718426, 55.676412685850877, 83.620268450993763, 126.42534521303489, 156.87210807500801, 246.58019931340195, 341.88266569523688, 826.98358454061815, 1404.2471167163787, 1228.1386668678601, 466.96068651596903, 262.22064771032797, 169.28009741248692, 115.01657309947615, 81.656383365816069, 54.579351530742883, 37.960529311280091, 27.270275764980511, 21.626986342929015, 16.174148423485327, 13.175385803191114, 10.818108303701184, 9.0657850663622632, 7.6275792078218663, 7.6107016321135834, 7.1158024527040036, 8.9011265392735677, 10.779707882412266, 12.420331822356596, 16.598306303244669, 21.012033493538478, 26.831312912868523, 33.051774609079132, 46.309734418779385, 65.383201302087031, 99.002477905219891, 128.56748384849996, 196.60807492406175, 298.23398084325686, 608.36256258703634, 1076.3354380676617, 975.85098582002695, 374.17471043828004, 222.04753134206624, 153.76758510324842, 111.73984833658845, 72.541074744398003, 46.502855765338275, 35.062921303265831, 24.451970593539095, 20.281233326031273, 15.065285185027921, 11.707355473726542, 9.7459029487301194, 8.114918006499499, 7.0964681111892807, 6.6796982066891397, 6.5878914508655138, 7.8186051199031059, 9.5427463544095801, 11.594349559722247, 14.318362157023484, 17.836915226678599, 22.844712934499004, 29.434722992970055, 39.992087970322991, 55.284175542844757, 86.773492313502047, 121.99890155292813, 175.66007701025202, 246.61763210131207, 451.54810738357452, 628.04019623528905, 603.29388410781314, 273.42112436269019, 189.28495193605181, 134.97815383583696, 92.537932899584618, 56.665976520174233, 40.654050842358266, 31.171413996879973, 21.026413392061954, 18.00341753039012, 13.721993308218343, 10.669689426212042, 8.356205196082156, 7.3868882398016433, 6.517599896433226, 6.0584998866872368, 6.5638826426931418, 7.1336795088287781, 8.613838618839619, 10.802606348653876, 13.366335355351938, 15.820551075574965, 19.845163015492108, 26.999239022736937, 35.458458280870509, 46.363090584483807, 68.281465328502051, 105.62610076866049, 153.51240187831726, 202.14938057052223, 301.98539336713208, 397.56324291610815, 405.30563382951226, 215.91082743746526, 149.29333201310212, 99.680104111337215, 70.844144712189916, 48.696705114384329, 36.637056536037569, 25.596184359277657, 19.02307727771527, 15.749761366858216, 11.951033594401437, 10.086463061934033, 8.3506293881191844, 7.2022393029757437, 6.0807779602627861, 5.7612683150124271, 6.0273725182896527, 6.6165496542300648, 7.4365452715085159, 8.6783297077665154, 11.615060741665609, 13.833866336064673, 18.575864228781477, 23.246005390172172, 31.555902400033563, 40.677669500589332, 56.667715144820136, 81.408207108224573, 111.98547216305556, 158.44613292857147, 210.62780774515824, 290.55794842865595, 312.25621146691742, 170.30250321119885, 113.87454497096817, 82.354258183333911, 59.818603534093889, 44.07044665600381, 32.893778204904692, 22.496539871033299, 17.094011041557415, 14.588382118274911, 11.200549789992062, 9.5745830477514566, 8.087405619242082, 6.7925999368613024, 5.4961910805963576, 5.1971703023131628, 5.4199426306511533, 5.7678603293099391, 7.0020534104826666, 8.2642952032077304, 10.213916707261937, 12.095005343850676, 15.601004576857186, 19.781090153028195, 26.29348154312569, 36.515567090044549, 48.740864373075503, 65.517726973596552, 85.616867091925073, 121.65124801185172, 164.28464153081055, 206.40983634767443, 220.41852448872194, 129.10563781650259, 92.689146582332683, 70.791066599245255, 51.943563730344891, 38.624038300983216, 28.742887457924869, 20.6631866841911, 16.243037999103294, 13.925007170923269, 11.024255100844002, 8.4139950296861468, 7.0401470253813523, 6.2856888836418143, 5.3560804114466043, 4.9985348214397556, 5.25099810618907, 5.5809638553577701, 6.8223029788192386, 8.5634007206388532, 9.7563203496299558, 11.812088062444902, 14.805264064130581, 17.93575786748271, 22.626272918294738, 31.174402898500958, 43.302312307258802, 56.326841577080955, 74.050997536102813, 101.37453317449018, 126.60409524008277, 162.42301117619624, 177.05193776506522, 115.72813424994953, 82.326066966484547, 61.307330817502205, 44.340846370849256, 33.378870891164695, 24.521965532974615, 18.923945416120109, 15.051214231467789, 12.320737648353592, 9.7999756970991925, 7.7145670626644423, 6.8152552126005839, 5.790991468644493, 5.5254951271344099, 4.9037029711983342, 5.4977261939037048, 5.4210433665926923, 6.2988580763712889, 7.9430787323529524, 9.3778517337478533, 11.242198007971071, 14.240421326197554, 17.651811381705546, 21.659024896488908, 29.131550319460956, 38.485086199887071, 50.092317177842048, 64.493269139882599, 88.474033169854309, 111.97252766350397, 138.89119149223308, 144.08748993083097, 100.36203094373164, 71.130756050186491, 51.595222833795184, 37.837750442044026, 29.957897076201892, 23.307587216478719, 17.870061723923296, 13.548228816751676, 10.730279953947793, 8.7941383608544452, 7.5189392893151066, 6.705955395914339, 5.4286200247646947, 4.999797681915652, 4.6762703758000139, 5.2431836531184182, 5.2308729223806347, 6.1881055124038262, 7.5261510579683444, 8.5830144005603604, 10.380584080562716, 13.063097810243177, 16.764705389876635, 21.077788907239153, 26.946259601518928, 35.064067560413655, 44.053944420107648, 58.895199291399678, 80.480502591809355, 105.53062749300898, 125.53124807748995, 123.85180136306964, 91.386853748724988, 64.043808743881343, 47.377246890606187, 36.917795087421162, 29.986306366154221, 21.922248103539825, 16.586233036173578, 13.010233921941435, 10.477074169109398, 8.6985558893370474, 7.2537351369992162, 6.347024549002974, 5.3569268232459128, 5.0096575514846968, 4.7237151783382343, 5.0872350526917325, 5.223561398000081, 6.2419547006416494, 7.1521863771078822, 7.9320558557880068, 9.974158228854499, 13.174966641491576, 15.965377755431728, 19.871959533459759, 25.954935810295414, 33.854283766819641, 44.113318889386903, 56.699892234383839, 81.033857172535789, 104.09119566434012, 123.77824150517087, 114.20520067738279, 85.229693259738468, 60.295157098692592, 46.590785285134146, 36.201434834295654, 27.092016678743615, 20.190577794974832, 15.811850117592071, 12.818302458338326, 10.737776338076218, 8.4417395277092595, 7.2563660620061432, 6.1723041784468409, 5.4319323269044659, 5.4462365532477222, 4.8064386829859753, 5.4462365532477284, 5.4319323269044641, 6.1723041784468409, 7.2563660620061476, 8.4417395277092666, 10.737776338076216, 12.81830245833833, 15.811850117592071, 20.190577794974825, 27.092016678743608, 36.20143483429564, 46.590785285134125, 60.295157098692549, 85.229693259738468, 114.20520067738286, 125.53124807748999, 104.09119566434013, 81.033857172535832, 56.699892234383839, 44.113318889386896, 33.854283766819655, 25.954935810295371, 19.871959533459762, 15.965377755431739, 13.174966641491576, 9.9741582288545025, 7.9320558557880112, 7.1521863771078893, 6.241954700641652, 5.2235613980000775, 5.0872350526917307, 4.7237151783382378, 5.0096575514846968, 5.3569268232459146, 6.3470245490029713, 7.2537351369992198, 8.6985558893370474, 10.477074169109407, 13.010233921941426, 16.586233036173571, 21.922248103539818, 29.986306366154224, 36.917795087421148, 47.377246890606152, 64.043808743881314, 91.386853748724917, 123.85180136306961, 138.89119149223299, 105.53062749300904, 80.480502591809227, 58.895199291399692, 44.053944420107612, 35.064067560413633, 26.946259601518928, 21.077788907239164, 16.764705389876632, 13.063097810243177, 10.38058408056272, 8.5830144005603639, 7.5261510579683462, 6.1881055124038333, 5.2308729223806383, 5.2431836531184173, 4.6762703758000139, 4.9997976819156502, 5.4286200247646956, 6.7059553959143425, 7.518939289315103, 8.7941383608544399, 10.730279953947782, 13.548228816751662, 17.870061723923293, 23.307587216478719, 29.957897076201906, 37.837750442044026, 51.595222833795212, 71.130756050186449, 100.36203094373161, 144.08748993083097, 162.4230111761963, 111.97252766350395, 88.474033169854323, 64.493269139882642, 50.092317177842069, 38.485086199887057, 29.131550319460946, 21.659024896488901, 17.651811381705546, 14.240421326197549, 11.24219800797108, 9.3778517337478586, 7.9430787323529533, 6.2988580763712898, 5.4210433665926958, 5.4977261939037065, 4.9037029711983324, 5.5254951271344037, 5.7909914686444868, 6.8152552126005865, 7.7145670626644396, 9.7999756970991907, 12.320737648353587, 15.051214231467785, 18.923945416120109, 24.521965532974619, 33.378870891164681, 44.340846370849256, 61.307330817502212, 82.326066966484575, 115.72813424994952, 177.05193776506513, 206.40983634767417, 126.60409524008281, 101.37453317449015, 74.050997536102813, 56.326841577080955, 43.302312307258816, 31.174402898500965, 22.626272918294742, 17.93575786748271, 14.805264064130563, 11.812088062444909, 9.7563203496299522, 8.5634007206388585, 6.8223029788192431, 5.5809638553577683, 5.2509981061890709, 4.9985348214397556, 5.3560804114466061, 6.2856888836418072, 7.0401470253813523, 8.4139950296861485, 11.024255100844005, 13.925007170923264, 16.243037999103286, 20.663186684191096, 28.742887457924876, 38.624038300983237, 51.943563730344863, 70.791066599245227, 92.689146582332697, 129.10563781650256, 220.41852448872183, 290.55794842865578, 164.28464153081066, 121.65124801185169, 85.616867091925073, 65.517726973596524, 48.740864373075532, 36.515567090044541, 26.29348154312569, 19.781090153028192, 15.601004576857186, 12.095005343850689, 10.213916707261948, 8.2642952032077304, 7.0020534104826773, 5.7678603293099435, 5.4199426306511462, 5.1971703023131655, 5.496191080596355, 6.7925999368612997, 8.0874056192420785, 9.574583047751446, 11.20054978999206, 14.588382118274911, 17.094011041557405, 22.496539871033306, 32.893778204904692, 44.07044665600381, 59.818603534093839, 82.35425818333394, 113.87454497096807, 170.30250321119888, 312.25621146691731, 397.56324291610832, 210.62780774515818, 158.44613292857147, 111.98547216305556, 81.408207108224559, 56.66771514482015, 40.677669500589346, 31.555902400033585, 23.246005390172176, 18.575864228781501, 13.833866336064665, 11.615060741665616, 8.6783297077665136, 7.4365452715085221, 6.6165496542300621, 6.0273725182896607, 5.7612683150124271, 6.0807779602627852, 7.2022393029757401, 8.3506293881191827, 10.086463061934035, 11.951033594401432, 15.749761366858216, 19.023077277715267, 25.59618435927765, 36.637056536037541, 48.696705114384315, 70.844144712189944, 99.680104111337187, 149.29333201310209, 215.91082743746531, 405.30563382951209, 628.04019623528882, 301.98539336713219, 202.14938057052214, 153.51240187831741, 105.62610076866049, 68.281465328502051, 46.363090584483821, 35.458458280870502, 26.999239022736958, 19.845163015492105, 15.820551075574963, 13.366335355351934, 10.802606348653876, 8.6138386188396243, 7.1336795088287852, 6.5638826426931312, 6.0584998866872368, 6.5175998964332322, 7.3868882398016451, 8.3562051960821524, 10.669689426212047, 13.721993308218325, 18.003417530390131, 21.026413392061936, 31.171413996879959, 40.654050842358252, 56.665976520174254, 92.537932899584604, 134.97815383583699, 189.28495193605173, 273.42112436269031, 603.29388410781269, 1076.3354380676617, 451.54810738357469, 246.61763210131207, 175.66007701025202, 121.99890155292813, 86.773492313502132, 55.284175542844778, 39.992087970322984, 29.434722992970055, 22.844712934499, 17.836915226678613, 14.318362157023493, 11.594349559722259, 9.5427463544095765, 7.8186051199031059, 6.5878914508655102, 6.6796982066891397, 7.0964681111892833, 8.1149180064994972, 9.7459029487301141, 11.707355473726548, 15.065285185027918, 20.281233326031277, 24.451970593539112, 35.062921303265831, 46.502855765338289, 72.541074744397974, 111.73984833658835, 153.76758510324839, 222.04753134206618, 374.17471043828004, 975.85098582002649, 1404.247116716379, 608.36256258703611, 298.2339808432568, 196.60807492406164, 128.56748384850005, 99.002477905219948, 65.383201302087045, 46.309734418779399, 33.051774609079132, 26.831312912868544, 21.012033493538468, 16.598306303244666, 12.420331822356601, 10.779707882412263, 8.9011265392735623, 7.1158024527040018, 7.6107016321135861, 7.6275792078218707, 9.065785066362265, 10.81810830370118, 13.175385803191121, 16.174148423485349, 21.62698634292904, 27.270275764980493, 37.960529311280098, 54.579351530742926, 81.656383365816112, 115.0165730994761, 169.28009741248692, 262.22064771032797, 466.9606865159688, 1228.1386668678595, 1811.7186422893876, 826.98358454061849, 341.88266569523705, 246.58019931340198, 156.87210807500793, 126.42534521303487, 83.620268450993777, 55.676412685850913, 43.352221767718426, 31.608461656401282, 23.413082960982216, 17.885476571420995, 14.231766288773079, 11.65589824207691, 9.8144929913230339, 8.2863477700222088, 7.7030138744354231, 8.5525257374706172, 9.9606764098368394, 11.150365108371185, 14.666394584276583, 18.542553262414668, 25.068630438788542, 31.806783986884088, 41.710267966739572, 62.186051297484333, 90.245166665465547, 128.13046637777475, 187.69065022036725, 291.76966991086601, 530.65233974797684, 1492.3389942582987, 3510.6104569290255, 1452.4284055535948, 458.16531800810117, 299.48678366969483, 212.38391288711682, 158.12669065273965, 117.05897406186025, 72.520382240797787, 53.07587763393235, 37.940376333065323, 27.91154568167104, 20.726370017730687, 15.877991319670903, 12.597356227543528, 10.337739417364284, 8.9560352521382303, 8.0758021716500537, 9.2831005853774364, 10.911393710353279, 12.262838166368201, 15.615914454631143, 20.404024372940963, 27.703018951863204, 38.823519356586509, 51.176815014056693, 73.592832336469868, 123.89126600552244, 154.38419406683062, 245.54955425961754, 346.491558171002, 734.84965238283075, 2572.5928689582984, 3938.2641458688445, 1627.6849016299093, 690.43324997326704, 441.25082967480483, 240.58003385007751, 172.62888515328839, 129.92857886018368, 84.943606310881961, 58.842492346581359, 44.356708279359744, 31.976099529363548, 22.603085253093905, 17.380860604603011, 13.467380568991784, 10.46444767042364, 8.8615504994164098, 8.4179220667115935, 9.487237267421909, 10.777277796853792, 13.335771300720136, 16.262756648609525, 22.178882955012895, 31.994561157116046, 44.971290338260197, 61.311985401733793, 97.576794771201889, 144.96617790506969, 194.27017041576195, 271.87929154854334, 471.37587503146125, 820.36462717097379, 2819.7837494548558, 5303.4798274482137, 2733.3936378292242, 1177.2730197279232, 831.79281380405973, 348.18684046898477, 205.80805308530728, 143.27997074170079, 97.039219839998907, 65.982333636303451, 47.784430534137826, 32.775354054937196, 22.997981877882619, 18.45427302763963, 14.242659983217516, 10.931731847155714, 9.3111499128487569, 8.6855447757572897, 9.4389981542904824, 11.518473012854098, 14.33850398347184, 18.382946908821911, 24.716276003836377, 36.079835978948545, 48.744575666300136, 68.81811717140873, 100.24198689599579, 144.26637111917196, 208.17182668800794, 366.88528484741386, 879.86972928318096, 1207.1822867649948, 3579.2066474003141, 9609.5106426127932, 3871.635585616455, 1368.5173470150646, 957.5703947344349, 519.23514670394684, 294.76980362823411, 163.05718048491758, 96.043853286628973, 67.247306229462083, 51.022038209027237, 36.846585979626163, 25.525875481280988, 19.162809661823751, 14.908412193461192, 11.366894624691964, 9.4707404644445834, 9.2913516551568005, 10.159177492646041, 12.287444953226698, 15.549412568397658, 19.757351140056148, 24.977928698897006, 37.142546768677924, 52.99804226348364, 73.270251985017907, 111.93749936902559, 170.62516999169443, 278.94923830500301, 549.16279790927297, 1059.1995113905641, 1669.5618690661465, 4992.6608769394161, 11652.54137553122, 6958.5740759503597, 3145.1913405539112, 2239.7595640192112, 884.1270089569299, 377.16693201204993, 189.56857349608163, 104.51314473208359, 70.132835875061716, 58.565861412331529, 44.406163862355506, 30.553614566731444, 20.838711299344109, 15.043219420350246, 12.029240511903463, 9.9768657536093936, 9.4565908065052362, 10.149549151428952, 12.574490983994684, 16.964451546104694, 20.596051003825067, 26.905297339122818, 40.617443247446033, 54.132047333262229, 72.776226915090191, 104.06222158598892, 186.72550653728851, 370.96222186223156, 759.63591736173305, 1776.9919423314723, 3079.1167046754904, 6105.9976767437374], "imag": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]}, "imag": [0.0, -0.027073229785536494, 0.59011929886938141, -0.96446761270548442, -0.6435513043684985, -0.68291153317050746, -0.33645866529024865, 0.1935415439422136, -0.12487037453098428, -0.012369715566745995, 0.0098216569471749459, 0.001542130029622399, 0.020818288300735281, 0.0037303920674802314, -0.0038837652177233549, 0.00060693078338958778, 0.0, -0.00060693078338692346, 0.0038837652177235778, -0.0037303920674795358, -0.020818288300735933, -0.0015421300296204468, -0.0098216569471759191, 0.012369715566746212, 0.12487037453098428, -0.19354154394221409, 0.33645866529024965, 0.68291153317050701, 0.64355130436849806, 0.96446761270548365, -0.59011929886938175, 0.027073229785536425, -2.3563074320989772, 2.5879403475863869, 2.1627258263390448, -3.1655869149224403, -0.41468157127337424, 0.73477199535913751, -1.2119335549119159, -0.10726288955095604, 0.30943623202091536, 0.23604949314849888, -1.983168313462914e-05, -0.015096007795395092, 0.0044172524913437313, 0.0012110563015863107, -0.00040440768488355977, 0.00056775738923005802, -0.00053942936844551652, 0.00087575929197146875, -0.002003234803528005, 0.0042603852180314204, -0.0062087670781442329, 0.017375416518930226, -0.014179868174360925, -0.10125602185153701, -0.15414023444697653, -0.035800396396009702, -0.96211078676818074, -0.96053455050253955, -1.1229487194040586, -2.1710672351706557, 1.4940913514434742, 2.7217236711600989, 1.1141581132568867, -0.84173680321989597, -5.2801379304709686, 1.1933011924316357, 3.2397405202403871, 0.58382335305071387, -1.2090975123731194, 0.11812270190565496, 0.29294962083792114, 0.38808563795590029, 0.017661918975066655, -0.0075287995749033759, -0.018334336057616411, 0.0080668085023426154, 0.0016882901545514294, 0.00017988558455360213, -0.00046271928878641557, -0.00012883481246306377, -0.0015037083336975181, -0.0051624614514164694, 0.0051337344665884242, 0.01635194779532648, -0.020739891572331103, 0.034224425977121886, 0.14660089916526936, 0.2579692221979365, -1.297902949650936, -0.81053000193538005, 2.2824415889165404, 1.3538813012752462, -3.6141509401212817, -1.3641708343500389, -2.525115924658619, -3.1276611078214884, -3.2520008240455529, 1.0086268501795932, 2.5763030038597452, 0.40772972397284202, -0.2975902384778692, -0.049496223745927298, -0.032511080574428759, 0.067130744005831466, -0.0201042966896933, -0.010577484531256129, 0.0093680389241231343, 0.0094203803992774487, 2.0439677469712496e-05, -0.00046042150692956042, 9.7927563908633831e-05, -0.00040743814870436565, -0.00074442767565903077, -0.0053134061063244819, -0.0081457928016647942, -0.016837193889943817, 0.00090322875228200043, 0.15679003542803616, 0.24794675857842086, 0.30815180494462813, -0.65229037787562094, -1.3408717866717259, 2.6508673621629431, 3.2598446139294937, -1.6423378558800314, -3.9986185110220567, 0.17392931664300956, 0.21368421587766026, -1.2315545205448162, -1.7422719766284609, 1.3054063480052003, 1.3750287394245329, -0.35022259842939119, -0.62247639588288617, -0.048937158811492604, 0.046213719349399378, -0.071248172851420807, -0.031638182474279769, 0.0092883221388230762, 0.0058947313405102496, 0.0020720238780862037, 0.00012946526299033534, -7.130655653596095e-05, -0.00038809112868830591, 0.0011018135930776953, 0.0010417550100125584, 0.0072040756024705759, -0.02451231341789871, -0.016921302325211343, 0.019764169882346385, 0.062587439504234885, -0.087282929002583373, -0.10008726366432093, -0.14363219386863416, 1.7469053421591101, 1.042390648919584, -1.364603392172089, -0.68321209765005841, 0.66892838780721486, 0.73208772838799607, -0.32755194356284695, -0.30510623667849596, 1.5181969873975902, 0.34278556022615442, -0.74313584277783451, -0.35705699907666322, 0.1310185858494092, 0.083590457495018811, -0.021674632648672316, -0.02469255214616152, -0.0043034893865322183, 0.0020376676236782713, 0.0021493865206610868, 0.00038855444421157756, -0.00023746053900133829, -0.00029830757497495967, -0.0001970006488720256, -0.00087982491421480442, 0.0074805689709430004, 0.010808720951461402, -0.035798177116234398, -0.091541716420706271, 0.0092010764075083195, -0.19110346978313567, -0.62579430924026735, -0.13482498836119824, 1.785974669626095, 1.1747425146844421, -1.173327779558617, 0.27670322508415535, 0.33562708516576978, 0.27104375713022649, -0.04917488399628335, -0.09917627706172702, 0.47021789966195177, 0.19299106678658604, -0.25337707381982333, -0.21158932458700433, -0.0038282192087294945, 0.079426421106262524, 0.0049276280752214097, -0.012631915096635613, -0.0020857584923047439, 0.0014730403106953706, 0.00056282220383548922, -5.2753025427967662e-05, -0.00011043948472760819, -0.00013701607546798722, 0.00024141713667198109, -0.00017599692518015115, 0.0033313264069332665, -0.0026415953474081991, -0.034551401114022419, -0.067614335954062313, 0.057375162080317274, 0.10414416266224315, -0.4897526648425265, -0.75726357904359276, 0.48971199898009016, 1.1084142254331173, 0.074442669441772358, 0.13102742771679016, -0.24374357403537103, -0.28356643882607668, -0.65203784187591463, -0.36850284921393173, 0.37230089042480646, 0.4991450162764402, 0.031449374349395147, -0.23992875156785609, -0.086092076891526551, 0.032374807759909224, 0.0062294082126362945, -0.0060917930216442444, -0.0010414824560445231, 0.00015455144974867572, -8.9980842426917249e-05, -1.5754152380049444e-05, 2.760348450088792e-07, -8.4925580282278396e-05, -9.538306571273261e-05, 0.0012356709589061894, 0.0019825160649420671, -0.0025172833852348821, -0.028888564425605757, -0.016030883614829267, 0.069260754853324724, 0.010501517567550991, -0.24153406544338693, -0.2847803977366839, 0.37357513895849587, 0.56507750226207965, -0.29338428828582186, -0.55012213491904771, -0.13256769577232769, -0.093306847874868315, -0.26668667634059962, -0.24770054522287138, 0.1944884297335735, 0.33591487261576602, 0.06235746981204858, -0.1546651423691924, -0.03904218756455085, 0.014396528935747412, -0.0017849945305527066, -0.0040798293321671533, -0.0019408045705910123, 0.00084895033746642374, 0.00039593785796133193, 5.5592435290972645e-05, -4.1965636442186823e-06, -6.2852929824007463e-05, -0.00034629566400638584, -4.8241347432061454e-06, 0.00057512008113313117, 0.00033489534843084444, -0.0031901125163299256, -0.010909574115055, 0.016920458777085551, -0.060786209275753178, -0.21998547499285445, 0.011288166830458734, 0.39450427611204475, 0.32156463816915598, -0.16694523801433098, -0.28285607915278405, -0.0086431961771640062, -0.016216948868002824, -0.12426113686156882, -0.13105274525765401, 0.01783418219228005, 0.12470331491202472, 0.037338151491471468, -0.053766563890133817, -0.017697451862990946, 0.0087641985076504225, 0.0020177112398541818, -0.0032903942418034261, -0.00098879884805599711, 0.00072826354344831883, 0.00023394715134995964, 1.1123369888840513e-05, -3.5001088996629374e-05, -3.1388155454884778e-06, -0.00015838596778406701, -0.00033445190756455149, -0.0001142558275417929, -0.00088473043957872045, -0.0055035547036739211, -0.0071882829440315203, 0.0056754664443316848, -0.024165671520133571, -0.12994912866694289, -0.03043154404819853, 0.19383851234462929, 0.16309710351628273, -0.074150026014186132, -0.12085880532211579, -0.044595013287817231, -0.043366337948898985, -0.090257019037460168, -0.073384871025009082, 0.023239798472538018, 0.07639283896145152, 0.011216629301030985, -0.0359133520966744, -0.013573759545388879, 0.0067665755556069575, 0.0030103388508484073, -0.00065141687607212645, -0.00041655443776571915, 0.00013094293222966718, 3.2292215967994378e-05, -1.526253885399206e-05, -1.5127801448997461e-05, -6.4845694559707764e-06, -1.5492547416280305e-05, -9.1308082212917993e-05, 0.00016667120940429337, -0.00041873515724890633, -0.0049027471727904112, -0.003075534798824412, 0.0092738136737237613, 0.0020660684229551027, -0.04064403555503323, -0.033233971766656843, 0.045775294033398174, 0.057167349545223407, -0.02508375199406394, -0.076725145240063103, -0.029192878339710793, -0.027962636418086263, -0.036204190826297326, -0.020723423884568531, 0.024267798198958853, 0.039127433373256276, 0.0066672447446462267, -0.015463651616642567, -0.007692451841204994, 0.0027471626893687531, 0.0010462542577807969, -0.00032293603684165713, -0.00014335933849004065, 2.7664402382146889e-06, 1.3817898707968035e-05, 2.5461973861614876e-06, -2.9451008005958465e-06, -4.0922137159052221e-07, 3.3208780384164378e-06, 2.2930933947507775e-06, 0.00019381368934935658, 0.00021177469863592545, -0.0013059386478791995, -0.00074739544714731232, 0.0074009891423913463, 0.0040508976947942563, -0.024179081541404416, -0.025786109831526915, 0.024427880538049996, 0.049513273245606421, 0.018107593495138536, -0.019155633990847833, -0.010866608608631909, -0.011586446122093948, -0.017758841021731874, -0.007715199561440257, 0.0099083442586334093, 0.016798455246852806, 0.0051385037481195082, -0.0053053978312845055, -0.0034294950764025521, 0.00061169662744445848, 0.00033799731924544067, -0.00024058911609197694, -0.00010154505453872226, 1.9807787751332398e-05, 1.1566718045558844e-05, 2.3526983774034052e-06, -3.1629035250083664e-06, -1.906633619859879e-06, -1.4241006555052951e-05, -3.3020030344899701e-05, 5.2908539732603441e-05, 5.1357289146045035e-05, -0.00039743496113234163, -0.00063432051689119376, 0.0027089055320300356, 0.0013503752362499016, -0.0082884630632301115, -0.0092589342553877248, 0.0088049724290094923, 0.022756702713130291, 0.011156251045765241, -0.0083450930318397683, -0.0049406694317385268, -0.0058001455908667206, -0.0076603598190790028, -0.0053021820779070323, 0.001845870794973378, 0.0051951770049388935, 0.001795161616712868, -0.0014758375936677148, -0.00091174996356954989, 0.00015619540664616496, 0.00011997798601084234, -7.415390708438721e-05, -4.7705175525428954e-05, 1.0498840541001561e-05, 5.7016743603087733e-06, -1.1348311617650734e-06, -1.0392532056220499e-06, -1.5023935068766505e-07, -4.5999439012728934e-06, -1.7083459920844721e-05, -9.6967633574418463e-06, 8.8789075877219231e-06, -0.00012444306086311345, -0.00019783492062566108, 0.00060624989809523425, 0.00033450965931121433, -0.0029572761111825215, -0.0037574725417352365, 0.00099233616545915107, 0.0061280004658490978, 0.0032489106979224094, -0.0026668961742810043, -0.0024385469973046831, -0.0029055731292758351, -0.0035330841487134718, -0.0021581469455770066, 0.00045127797385368442, 0.0018583554775031736, 0.0007285298435105804, -0.00040485086541622897, -0.00029259265207938966, 0.00012119187628647567, 5.7987669870543989e-05, -2.689854721032224e-05, -1.2650266391968962e-05, 1.4661018807957155e-06, 1.5771327546691322e-06, -3.698251896381977e-07, -2.9525581512606399e-07, -1.495621091456335e-07, 1.1697432596209132e-07, -2.2921786679761149e-06, -2.2344957140311543e-07, 9.0079557167444004e-06, -4.7951397864926913e-05, -8.9395111720587663e-05, 0.00025656486918183087, 0.00025588309866116956, -0.00073983779212979841, -0.0015213421071961196, -9.2403301086677145e-05, 0.0017855278470929681, 0.0015458463998575377, -0.00061369027212951951, -0.00026504628413918208, -0.00087036902540521815, -0.0012627180005201106, -0.00080421955077315159, 0.00014616084301033664, 0.00058802678854243985, 0.00023126432473923958, -0.00010449095558686259, -0.00010228145451208669, 1.9325523686774618e-05, 3.0323974870826362e-05, 1.2683141406816166e-06, -1.2058446868057975e-06, 8.8143768771753332e-07, 3.3549731120851134e-07, 9.1056799261659957e-08, 2.0577319091974112e-08, 9.2830259427826791e-08, -6.4704839947157811e-07, -4.5648010846713924e-07, 2.1033881238566881e-06, 7.32796229427314e-06, -2.4374370669839543e-05, -2.5898674317115741e-05, 0.00011257144284409361, 0.00014693728608109456, -0.00023924588800045181, -0.00050123772700090606, -7.4435208380385973e-05, 0.00068444397565025586, 0.00083207770824480598, 0.00048828956300996052, 0.0, -0.00043330868466009542, -0.00064651493374645564, -0.0004135205525089448, 5.8232578355565087e-05, 0.00026030164250996835, 0.00011785219152459624, -5.0479429154057332e-05, -4.1543191833568309e-05, 7.7550355275730399e-06, 8.5787889709012739e-06, 5.074268522214453e-08, -1.5265704867968537e-06, 7.6127420915855944e-07, 3.4322773606588538e-07, -2.4467237539618118e-08, 0.0, 2.4467237179738174e-08, -3.4322773619012653e-07, -7.6127420919217151e-07, 1.526570486753494e-06, -5.0742685069794458e-08, -8.578788970889695e-06, -7.7550355275692266e-06, 4.1543191833568309e-05, 5.0479429154150824e-05, -0.00011785219152460185, -0.00026030164250998353, -5.8232578355579629e-05, 0.00041352055250904981, 0.00064651493374653229, 0.00043330868466019738, 0.00026504628414032808, -0.00048828956301001061, -0.00083207770824431527, -0.00068444397564927856, 7.4435208380627533e-05, 0.00050123772700078214, 0.00023924588800066727, -0.00014693728608088972, -0.000112571442844023, 2.589867431722904e-05, 2.4374370669918344e-05, -7.3279622940927939e-06, -2.1033881238922216e-06, 4.5648010853483173e-07, 6.4704839933564965e-07, -9.2830259571647903e-08, -2.0577319091885375e-08, -9.1056799550122255e-08, -3.3549731127660601e-07, -8.8143768768718392e-07, 1.2058446867643514e-06, -1.2683141406445925e-06, -3.032397487090597e-05, -1.9325523686839914e-05, 0.00010228145451204714, 0.00010449095558694352, -0.00023126432473908535, -0.00058802678854225174, -0.00014616084301019596, 0.00080421955077363764, 0.0012627180005203068, 0.00087036902540495523, 0.0024385469973038903, 0.00061369027212936067, -0.0015458463998569551, -0.0017855278470920858, 9.2403301086626811e-05, 0.0015213421071961089, 0.00073983779212967297, -0.00025588309866126459, -0.00025656486918189489, 8.9395111720511796e-05, 4.795139786497207e-05, -9.0079557166165035e-06, 2.234495713888465e-07, 2.2921786679921674e-06, -1.1697432602157082e-07, 1.4956210883105962e-07, 2.9525581512599554e-07, 3.6982518948350376e-07, -1.5771327547503337e-06, -1.4661018806631417e-06, 1.2650266391950919e-05, 2.6898547210308593e-05, -5.7987669870649895e-05, -0.00012119187628649009, 0.0002925926520794114, 0.00040485086541640515, -0.00072852984351041105, -0.0018583554775031031, -0.00045127797385343153, 0.0021581469455775027, 0.0035330841487132328, 0.0029055731292758334, 0.0049406694317394081, 0.0026668961742812758, -0.0032489106979216591, -0.0061280004658477299, -0.00099233616545883708, 0.0037574725417350639, 0.0029572761111822826, -0.00033450965931128095, -0.00060624989809528011, 0.00019783492062561489, 0.00012444306086323596, -8.8789075876270673e-06, 9.6967633574076482e-06, 1.7083459920778764e-05, 4.5999439011767153e-06, 1.5023935031916601e-07, 1.039253205622084e-06, 1.1348311616083971e-06, -5.7016743603616383e-06, -1.04988405409158e-05, 4.7705175525396455e-05, 7.4153907084401847e-05, -0.00011997798601094042, -0.00015619540664609709, 0.00091174996356957938, 0.0014758375936678126, -0.0017951616167126566, -0.0051951770049386038, -0.0018458707949728875, 0.0053021820779076802, 0.0076603598190795076, 0.0058001455908669262, 0.010866608608631407, 0.0083450930318392878, -0.011156251045764934, -0.022756702713130041, -0.0088049724290099694, 0.0092589342553874195, 0.0082884630632298704, -0.0013503752362499656, -0.0027089055320300547, 0.00063432051689115061, 0.00039743496113240219, -5.135728914582959e-05, -5.2908539732616404e-05, 3.3020030344762441e-05, 1.4241006554950027e-05, 1.9066336197302612e-06, 3.1629035250082296e-06, -2.352698377375767e-06, -1.1566718045553533e-05, -1.9807787751344911e-05, 0.0001015450545386955, 0.00024058911609209111, -0.00033799731924550203, -0.00061169662744447323, 0.0034294950764026141, 0.0053053978312845272, -0.0051385037481194926, -0.016798455246852688, -0.00990834425863296, 0.0077151995614407626, 0.017758841021732009, 0.011586446122093877, 0.029192878339711306, 0.019155633990847316, -0.018107593495138137, -0.049513273245605283, -0.024427880538050034, 0.02578610983152671, 0.024179081541404305, -0.0040508976947941731, -0.0074009891423912162, 0.00074739544714725432, 0.0013059386478792266, -0.00021177469863582771, -0.00019381368934936018, -2.2930933947504607e-06, -3.3208780385072546e-06, 4.0922137139897878e-07, 2.9451008005957237e-06, -2.5461973862464916e-06, -1.3817898708041393e-05, -2.7664402380974939e-06, 0.00014335933849003848, 0.00032293603684169041, -0.0010462542577808741, -0.0027471626893686612, 0.0076924518412050408, 0.015463651616642399, -0.0066672447446463326, -0.039127433373255908, -0.024267798198958437, 0.020723423884568916, 0.036204190826296979, 0.02796263641808593, 0.04459501328781619, 0.076725145240063533, 0.02508375199406461, -0.05716734954522297, -0.045775294033398015, 0.033233971766656642, 0.04064403555503332, -0.0020660684229550407, -0.0092738136737237076, 0.0030755347988242901, 0.0049027471727904398, 0.00041873515724895311, -0.00016667120940430416, 9.1308082212913032e-05, 1.549254741618293e-05, 6.4845694559219288e-06, 1.5127801448997605e-05, 1.5262538853884928e-05, -3.2292215968025048e-05, -0.00013094293222960533, 0.00041655443776571118, 0.00065141687607211561, -0.0030103388508485036, -0.0067665755556069011, 0.013573759545388975, 0.035913352096674386, -0.011216629301031098, -0.076392838961451187, -0.023239798472537657, 0.073384871025009249, 0.090257019037460764, 0.043366337948898895, 0.0086431961771646949, 0.12085880532211546, 0.074150026014186479, -0.16309710351628132, -0.19383851234462879, 0.030431544048198395, 0.12994912866694291, 0.024165671520133634, -0.005675466444331592, 0.0071882829440315836, 0.0055035547036740139, 0.00088473043957880925, 0.00011425582754175175, 0.0003344519075645258, 0.00015838596778393289, 3.138815545460048e-06, 3.5001088996629286e-05, -1.1123369889024881e-05, -0.00023394715134996501, -0.00072826354344829888, 0.00098879884805594702, 0.003290394241803499, -0.0020177112398542039, -0.0087641985076504607, 0.017697451862991015, 0.053766563890133824, -0.037338151491471468, -0.12470331491202422, -0.01783418219227963, 0.13105274525765467, 0.12426113686156864, 0.016216948868002876, 0.13256769577232769, 0.28285607915278405, 0.16694523801433089, -0.32156463816915598, -0.39450427611204497, -0.011288166830458839, 0.21998547499285451, 0.060786209275753553, -0.016920458777085551, 0.010909574115054964, 0.0031901125163300605, -0.00033489534843075342, -0.00057512008113319081, 4.8241347431542723e-06, 0.00034629566400617116, 6.2852929823858467e-05, 4.1965636442186823e-06, -5.5592435290969e-05, -0.00039593785796146729, -0.00084895033746647957, 0.0019408045705911188, 0.0040798293321673848, 0.0017849945305527092, -0.014396528935747516, 0.03904218756455085, 0.15466514236919257, -0.062357469812048469, -0.3359148726157663, -0.19448842973357355, 0.24770054522287124, 0.26668667634059967, 0.093306847874868246, 0.24374357403537067, 0.55012213491904793, 0.2933842882858228, -0.56507750226207876, -0.37357513895849492, 0.28478039773668301, 0.24153406544338699, -0.010501517567550396, -0.069260754853324669, 0.016030883614829131, 0.02888856442560565, 0.0025172833852350443, -0.0019825160649420428, -0.0012356709589064721, 9.5383065712676177e-05, 8.4925580281910716e-05, -2.7603484500895416e-07, 1.575415238022084e-05, 8.9980842426463958e-05, -0.00015455144974887674, 0.0010414824560444731, 0.0060917930216443658, -0.0062294082126362589, -0.032374807759909592, 0.086092076891526537, 0.23992875156785606, -0.031449374349395362, -0.4991450162764392, -0.37230089042480613, 0.36850284921393162, 0.65203784187591551, 0.28356643882607629, -0.33562708516576939, -0.13102742771679063, -0.074442669441771941, -1.108414225433116, -0.48971199898009049, 0.75726357904359165, 0.48975266484252722, -0.10414416266224276, -0.057375162080317302, 0.067614335954062174, 0.034551401114022537, 0.0026415953474081431, -0.0033313264069329894, 0.00017599692518009282, -0.00024141713667201988, 0.00013701607546791344, 0.00011043948472760822, 5.2753025427777066e-05, -0.00056282220383580418, -0.001473040310695623, 0.0020857584923045986, 0.01263191509663575, -0.0049276280752216023, -0.079426421106262579, 0.0038282192087295479, 0.21158932458700425, 0.25337707381982338, -0.19299106678658623, -0.4702178996619516, 0.09917627706172702, 0.049174883996283732, -0.27104375713022683, -0.66892838780721375, -0.27670322508415546, 1.1733277795586157, -1.1747425146844417, -1.7859746696260967, 0.13482498836119791, 0.62579430924026835, 0.19110346978313578, -0.0092010764075083889, 0.091541716420705743, 0.035798177116234828, -0.01080872095146141, -0.0074805689709430082, 0.00087982491421515624, 0.00019700064887198773, 0.00029830757497410965, 0.00023746053900133802, -0.00038855444421207136, -0.0021493865206616879, -0.0020376676236788177, 0.0043034893865325514, 0.024692552146162169, 0.021674632648672077, -0.083590457495018658, -0.13101858584940929, 0.35705699907666349, 0.7431358427778344, -0.3427855602261542, -1.5181969873975907, 0.30510623667849562, 0.32755194356284562, -0.73208772838799718, -0.1739293166430094, 0.68321209765005741, 1.3646033921720888, -1.0423906489195836, -1.7469053421591101, 0.14363219386863219, 0.10008726366432133, 0.087282929002584164, -0.062587439504234912, -0.019764169882346593, 0.016921302325211187, 0.02451231341789838, -0.007204075602470608, -0.0010417550100130558, -0.0011018135930777443, 0.0003880911286887635, 7.1306556535960909e-05, -0.00012946526299007061, -0.0020720238780864522, -0.0058947313405104855, -0.0092883221388232445, 0.031638182474279679, 0.071248172851421404, -0.046213719349399086, 0.048937158811492507, 0.62247639588288617, 0.35022259842939113, -1.375028739424532, -1.3054063480052007, 1.7422719766284596, 1.2315545205448166, -0.21368421587766057, 2.5251159246586199, 3.9986185110220571, 1.6423378558800306, -3.2598446139294928, -2.6508673621629413, 1.3408717866717237, 0.65229037787562116, -0.30815180494462602, -0.24794675857842133, -0.1567900354280353, -0.00090322875228194491, 0.016837193889943952, 0.0081457928016650735, 0.0053134061063229068, 0.00074442767565938834, 0.00040743814870428352, -9.792756390863333e-05, 0.00046042150692909031, -2.0439677469763416e-05, -0.0094203803992774331, -0.0093680389241246331, 0.010577484531255831, 0.020104296689693778, -0.067130744005831841, 0.032511080574428954, 0.049496223745927104, 0.29759023847787003, -0.40772972397284141, -2.5763030038597421, -1.0086268501795939, 3.2520008240455529, 3.127661107821488, -1.1141581132568867, 1.3641708343500387, 3.614150940121283, -1.3538813012752458, -2.2824415889165408, 0.81053000193537672, 1.2979029496509369, -0.25796922219793567, -0.14660089916526964, -0.034224425977123246, 0.020739891572330926, -0.016351947795325953, -0.0051337344665883956, 0.0051624614514157383, 0.0015037083336985342, 0.00012883481245927331, 0.00046271928878641655, -0.00017988558455328343, -0.0016882901545534784, -0.0080668085023415624, 0.018334336057616227, 0.0075287995749028155, -0.017661918975066519, -0.38808563795590117, -0.29294962083792109, -0.11812270190565234, 1.2090975123731191, -0.58382335305071487, -3.2397405202403844, -1.1933011924316363, 5.2801379304709686, 0.84173680321989663, 2.3563074320989759, -2.7217236711600976, -1.4940913514434744, 2.1710672351706584, 1.1229487194040595, 0.96053455050254277, 0.96211078676817896, 0.035800396396013512, 0.15414023444697636, 0.10125602185153926, 0.014179868174359136, -0.01737541651892931, 0.0062087670781442571, -0.0042603852180286457, 0.0020032348035250135, -0.00087575929196809612, 0.00053942936844551738, -0.00056775738923165191, 0.00040440768488539494, -0.0012110563015865644, -0.0044172524913444079, 0.015096007795395007, 1.9831683135784154e-05, -0.23604949314850127, -0.30943623202091552, 0.10726288955095381, 1.2119335549119155, -0.73477199535914062, 0.41468157127337302, 3.1655869149224372, -2.162725826339043, -2.5879403475863874], "height": 32, "width": 32, "top": {"real": [26312.861486548059, 16394.776884218503, -3997.4541326480944, 12005.135907922067, 1177.5601778241692, -334.84971513551272, -198.67917160941846, -63.09118295690562, -26.0143192287494, -17.75101650843531, -4.1366280143888243, 0.89820537026572267, -0.32480674164662798, -0.084346178359567467, -0.13448645703297074, 0.022458369013166949, 0.0037906136595566063, 0.022458369013118644, -0.13448645703284343, -0.084346178359639243, -0.32480674164661494, 0.89820537026588532, -4.1366280143890872, -17.751016508434784, -26.0143192287494, -63.091182956905335, -198.67917160941835, -334.84971513551284, 1177.5601778241696, 12005.135907922073, -3997.4541326480962, 16394.776884218489, -7474.6405977592167, -8567.9043780819939, -2236.1016166727777, 5029.218127936877, 173.97100199359824, -922.65330403810697, -153.6610478382718, -4.01177942588299, -14.977979358030328, -15.430842802070819, -7.4975861096446677, 1.585406689794443, 0.17906893603683641, -0.1458960091743404, -0.061043080293462629, -0.0046072373939513231, 0.0087184428309440426, 0.017310354876342828, -0.025331085027308461, -0.090673583392976279, -0.39184400032069594, -0.73078681815467361, -0.92174645774086517, -10.93402591728189, -30.447262913620346, -38.126922827402865, -60.968110303669619, -681.13286643622507, 624.53857955695969, 7785.4292550857708, -1762.2326743166159, -6145.3703500362362, -30710.86949592911, -20630.868893573344, 1300.6579518513645, 5360.9184206698983, 848.32865192899703, -785.98438030181387, -108.77167233308913, 41.321279695295864, -0.027644771384101652, -9.534868349699865, -1.2097145653165393, 0.21253485530640887, -0.28694451643507407, -0.19362286330376682, -0.015513947258845627, 0.0028928780958250894, 0.010770434199071796, 0.0037362591288644677, -0.033458104535328603, -0.15988488342210658, 0.11739550901211815, 0.74668900068008903, -4.4804803612995503, -15.856083499246324, -27.816492049240171, 2.1424019920280393, 12.12605916297551, -787.56867680882806, -403.54468101232709, 3807.5774006807187, 4390.1153105308758, -17039.959036708919, -13609.16252827678, -9138.4955296375883, 2497.0113342386512, 4397.1447406314655, 786.4046140955403, -371.53196930683333, -41.579492344426484, 10.792253245683401, 12.926010493557772, -0.94130122169806685, -0.22574146482830848, -0.15910329528413825, 0.039542877145191092, -0.16497562627541082, -0.034546572003498262, 0.0028396778151660528, 0.0095036050242090567, 0.0028202375766785176, -0.035341389521162114, -0.14687879382002816, -0.12611798259866741, 0.45588994614236095, -0.25876313947681329, -11.107804183612142, -9.8469518252878121, 5.4748636450494486, 23.93852180867734, -449.68159927787053, -188.33038343684237, 3370.1365438276152, 4992.3705750204963, -4902.8469709692872, -11751.949054213763, -9055.7727899285892, -1597.312584178899, 1957.0910297219173, 675.954300804676, -59.523430315468971, 3.5981209875694646, 26.908851107336638, 3.3880871060788613, -6.3950609995768, -2.7652104861310596, 0.51553772502971873, 0.20366584836429452, -0.078076761518840479, -0.032306588307275633, -0.00033732640143732022, 0.0039882283816162498, 0.00882576812785189, -0.010351412440947377, -0.13141543694038546, -0.35838805663068013, -0.083665866496770311, -0.11489505024575582, -2.0174170653233996, 5.313800098890094, 16.719706304911163, 26.780389598343444, -155.76938280407634, 15.711518936085053, 2108.6641632789715, 2004.0776030609009, -5284.4851508729253, -7525.5124487476332, -5804.138136685775, -1404.695681801157, 766.79772203943867, 489.03634446603957, -8.722049146589729, -31.327724554225572, 11.011155797013167, -0.50779722959414419, -5.7422528468514669, -2.0029903992471274, 0.11899325802032906, 0.035426363555884931, -0.0016279289016664685, -0.0068853887710592244, 0.00084949455245666495, 0.0025820557167290517, 0.004778391224536287, -0.0060776628020400699, -0.066021172391945146, -0.14585644547184912, 0.31419533009862166, 0.4720008156080655, -3.7567756530835696, -5.2990493438664403, 20.309232259116531, 43.66331695464585, -13.481975167534534, 87.480286025038623, 872.01902032865974, 302.59784669978308, -3861.3331359414924, -2689.7311891987174, -2302.5619774650818, -533.70879716435536, 471.82586926866179, 253.24935366729582, -54.914023853010136, -45.128050992983141, 1.7233725901997559, 4.8083890914979186, -1.2558586165362935, -1.1198886962259056, -0.17080663964208292, 0.0073776692393840732, 0.01315742418122162, -0.0042018888945982991, 3.9927404722540691e-05, 0.0024301018087218612, 0.0013997723845362102, -0.01262770667339704, -0.024640414526077212, -0.031798236031438429, 0.16501061208698242, -0.053070166605889257, -2.4508298603470875, -6.1804125133917358, 1.555942705006216, 9.6369277380044327, -40.990915592068667, 48.381114122456317, 486.73310475433823, 304.00864677044143, -1317.5468335758922, -1423.509046098827, -1206.2870766014189, -258.09420634314597, 284.39023574769527, 170.47470391854262, -20.992706500305374, -30.973343141495711, -0.73408381954002189, 2.8760611038460322, -0.96452576448322436, -0.33780530346449972, 0.050525784186614971, 0.037431091543099905, -0.0017411003602284265, -0.0094665916234262064, -0.00075468105471295627, 0.0012390824544828156, 0.0015406044848658253, -0.0042340021876475491, -0.0099527381839567483, -0.017832280274117901, -0.0021885919874408454, -0.18486506545171935, -1.5473028239900652, -0.46733110563156899, 7.0159472975173207, -4.1293951866555583, -52.177815979563, -14.225382292199997, 266.2443485847607, 299.68761898427294, -502.75722346741452, -600.46969991458195, -533.72028053649831, -84.35869563264292, 149.66956177052822, 98.021239180316712, 5.9461121297863162, -11.840914283794969, -2.356375469113162, 0.20453312434178955, -0.31158766591945325, -0.14520584302328118, -0.014067565159284239, 0.014308802406409332, 0.0017127836707298723, -0.0045784971805314283, -0.0004316686427205439, 0.00062035219223615539, 0.00098821093942306776, 0.00037352179846464215, -0.0031201129359879932, 0.0028053468557916969, 0.01155415730259296, 0.043098557260407636, -0.50100451968487536, -0.34405016878893097, 4.6091984823197363, -1.1472068176591008, -29.145899633206373, -2.6052151602709381, 142.77222209569624, 179.10482852523111, -159.1039510457467, -164.80060347644744, -151.52622363641359, -12.964795600796743, 78.707005278515467, 49.611102594467418, 2.9148898834797565, -6.6982557512143011, -1.1108929795277851, 0.53317200343106397, -0.060952672321508208, -0.13796026336886294, -0.040312063728342999, 0.0091529292682895457, 0.00069551217754917558, -0.00049216012286125183, 0.00019632055084333887, 0.00016453496496604428, 0.00035411166615570894, 0.00029458111873911975, -0.0039224781743007692, -0.0012902932474049059, 0.022738683086130741, 0.0029642733314895081, -0.040660255117105054, -0.1581093035213153, 0.50820914967959807, -1.1517329733377961, -10.955670081779706, 6.6684998469426819, 73.509265817506147, 94.854507489855607, -30.375445723654334, -41.976518122871582, -38.330831793041703, 6.6541528790739966, 26.775549975763919, 13.67501905826837, -0.77255683543203624, -2.6427995487036586, -0.26778321549867995, 0.38263920912663341, 0.066476687185755071, -0.060499325131928558, -0.013860605018094061, 0.0044705403327676731, 0.00045553699537380387, -6.6832908987799432e-05, 5.7815338715827767e-05, 2.4201934805748865e-05, 2.4116728282913401e-05, -7.7908669355443089e-05, -0.0020106249903568347, -0.0030945645282710967, 0.011724362942541916, -0.0073188065692862368, -0.13872845280170487, -0.0525083726541943, 0.57465299048466112, -0.38679604474522938, -4.8536563727710194, -1.1675628703507077, 21.601631857858344, 37.913461849891526, 8.2459776248906191, -17.728252948144338, -17.913066539877509, -1.363521120172412, 8.6874027327585566, 5.1086905995493517, -0.15956522315726163, -1.0853380408525961, -0.17672593964480066, 0.18144159918607325, 0.051467156562084934, -0.020596344531497161, -0.004731774665412903, 0.0025169723177923789, 0.00031643566338613672, -0.00017373359946045594, -7.1999178350316855e-05, 3.5348452681660421e-06, 3.7806930339121046e-05, 2.3729245648202859e-05, -0.00042972130823292398, -0.0011045036274546954, 0.0022387979975912117, -0.0041954404795751096, -0.054281237122749564, 0.0079821569677783755, 0.36123191988222408, 0.078230863522083471, -1.8108271356936088, -1.1161504624718657, 6.2644803438069099, 11.381535938317967, 0.21980447663235644, -5.9387280202325705, -6.1357877592112944, -0.72356703610536932, 2.8717612965534967, 1.8272689141068139, 0.038901829717158748, -0.30585525507098987, -0.058991941107951799, 0.049323041374202826, 0.007749491998403548, -0.0026797748220028393, 2.6063267012890291e-05, 0.00066159304663239156, 7.7278494902114205e-05, -3.1100603910792207e-05, -1.5561043109534526e-05, 1.1911742325626112e-05, 2.0491322447673862e-05, -1.4767672160855649e-05, 7.2375275064916669e-05, 0.00028278010837829711, 0.0018655623121081823, 0.00079665654087039228, -0.014230202242318532, 0.015605588027909496, 0.15269277354560382, 0.042410343620558247, -0.5991836734745446, -0.42273281817515368, 2.2232923752479885, 4.029734867596904, -0.01297332387246361, -1.8890504514660771, -1.7044228721383259, -0.014407089546523855, 0.81475328270242842, 0.49486328945653796, 0.051378645502378667, -0.078019191874231134, -0.019791976482152574, 0.011942087677832957, 0.0037710881620078929, -0.0019373229659441914, -0.00028867057981419789, 0.000173087047265503, 3.9265425732721298e-05, 5.3761386290662811e-07, -1.6483764627679784e-06, 1.9354497917760563e-06, -1.043216287920153e-06, 1.251541032126094e-06, -2.0395625891304971e-05, 2.3143507174682374e-05, 0.0008565768791742647, 0.0015425089335333231, -0.0038713470880909978, -0.0045226552231720603, 0.026481416655982141, 0.0024818042284060491, -0.15643670700640799, -0.014637771070647379, 0.7413395210802084, 1.1863896819067066, -0.06073539777241771, -0.55423720177498148, -0.41318433868106841, 0.012013582173996683, 0.22946537156729221, 0.14022496275890783, 0.010987988714373856, -0.01679009744687791, -0.0027663623850498948, 0.0015534913917298809, 0.00054985818249530594, -0.00042583544807556255, -0.00029614878449876606, 1.3565162632662745e-05, 4.7965965686279184e-06, -1.4046487964451716e-06, -1.7593082382469076e-06, -2.320036873447806e-06, 2.4848934678754374e-07, -1.4522884424931378e-06, -5.2082671731122632e-06, 2.3151589195966712e-06, 0.00016541664707348802, 3.6529125267961852e-05, -0.0012890410598031484, -0.0010500227857359876, 0.0036910380457585109, -0.0025549445466396393, -0.038104522129866786, 0.016868811542239164, 0.22147893162995161, 0.26972216562160328, -0.11164745685412412, -0.1053213699265967, -0.065169792191789519, 0.050967642716828229, 0.082203097259608671, 0.037973776532028221, 0.002270145289904118, -0.0034852771985896215, -0.00051797014017785649, 0.00065999477810424847, 9.1449959395068298e-05, -9.1204391021716067e-05, -1.5180477673862282e-05, -1.4304323510152094e-05, -4.7668675387694358e-07, -3.3807620398649656e-07, -3.2827005154992035e-07, -6.0059383407177672e-07, 4.743645802817471e-07, 7.8835950629218593e-07, -2.5363312932279684e-06, 3.4933053894102948e-06, 4.918354682850915e-05, 9.9367636232135646e-05, -0.00011095747475971185, -0.00033735388707191222, -0.00017205199767281925, -0.0028150966049269007, -0.0066263773562998379, 0.016874993354405541, 0.081392801874071885, 0.10016944284496203, -0.0039898740972888948, -0.056558682919194136, -0.015674616081580436, 0.047420248352959368, 0.048984183536402902, 0.018095648558125472, 0.00019061585891928039, -0.00055865816852282587, 0.00028385103022481571, 3.8670538186828884e-05, -1.6713711240799624e-05, 3.5388781701807323e-05, 1.8038642046719724e-05, -2.7952818635613013e-07, -2.4658127673140311e-06, -1.5227319963665806e-07, -2.3332675048126655e-07, -1.3019579049092348e-07, -2.3332675083373355e-07, -1.5227319920541638e-07, -2.4658127673110402e-06, -2.7952818599492315e-07, 1.8038642046284464e-05, 3.5388781702455181e-05, -1.6713711239992412e-05, 3.8670538186828884e-05, 0.0002838510302257955, -0.00055865816852375373, 0.00019061585891278605, 0.01809564855812688, 0.048984183536407218, 0.047420248352966703, -0.01567461608157503, -0.10532136992661453, -0.0039898740972773798, 0.10016944284504853, 0.081392801874075937, 0.016874993354393339, -0.0066263773562901859, -0.0028150966049217711, -0.00017205199767197964, -0.00033735388707121654, -0.00011095747476002673, 9.9367636230791154e-05, 4.9183546829807197e-05, 3.4933053890940453e-06, -2.5363312945761086e-06, 7.8835950614532164e-07, 4.7436458143049758e-07, -6.005938340711767e-07, -3.2827005209480802e-07, -3.3807620383163872e-07, -4.7668675369876225e-07, -1.4304323509881206e-05, -1.5180477673786216e-05, -9.1204391019992904e-05, 9.1449959396039146e-05, 0.00065999477810600097, -0.00051797014017666832, -0.0034852771985941946, 0.0022701452899007964, 0.037973776532033036, 0.082203097259589145, 0.050967642716782412, -0.065169792191780859, -0.55423720177488789, -0.11164745685411237, 0.26972216562160034, 0.22147893162997134, 0.016868811542243251, -0.038104522129865558, -0.0025549445466363117, 0.0036910380457617423, -0.0010500227857337837, -0.0012890410598025771, 3.6529125267327953e-05, 0.00016541664707448109, 2.3151589193372615e-06, -5.2082671739343036e-06, -1.4522884428117831e-06, 2.4848934734967557e-07, -2.3200368734485688e-06, -1.7593082396192173e-06, -1.4046487964490078e-06, 4.7965965689104361e-06, 1.3565162632914686e-05, -0.00029614878449827947, -0.00042583544807430477, 0.0005498581824961642, 0.0015534913917295296, -0.002766362385049678, -0.016790097446884332, 0.010987988714361836, 0.14022496275891236, 0.22946537156726918, 0.012013582173935911, -0.4131843386810784, -1.8890504514661226, -0.060735397772418001, 1.1863896819067115, 0.74133952108018497, -0.014637771070638499, -0.15643670700640161, 0.0024818042284152002, 0.026481416655986481, -0.0045226552231720108, -0.0038713470880910664, 0.0015425089335324559, 0.00085657687917487868, 2.3143507174645941e-05, -2.0395625891635653e-05, 1.2515410319035661e-06, -1.0432162880357027e-06, 1.9354497917755154e-06, -1.648376462389003e-06, 5.3761386277171334e-07, 3.9265425733411684e-05, 0.00017308704726561608, -0.00028867057981368457, -0.0019373229659434092, 0.0037710881620082728, 0.011942087677832796, -0.019791976482151457, -0.078019191874226498, 0.051378645502381547, 0.4948632894565238, 0.81475328270235614, -0.014407089546580973, -1.7044228721383166, -5.9387280202324542, -0.012973323872509449, 4.0297348675968632, 2.2232923752479965, -0.42273281817513425, -0.5991836734745476, 0.042410343620560523, 0.15269277354560529, 0.015605588027911042, -0.014230202242318617, 0.00079665654086961773, 0.0018655623121089473, 0.00028278010837819401, 7.237527506430049e-05, -1.4767672161149705e-05, 2.0491322447334689e-05, 1.1911742325624598e-05, -1.5561043110042614e-05, -3.1100603910787708e-05, 7.7278494901711681e-05, 0.00066159304663245509, 2.6063267012872924e-05, -0.0026797748220015139, 0.0077494919984037978, 0.049323041374203298, -0.058991941107945506, -0.30585525507097922, 0.038901829717163883, 1.8272689141068059, 2.8717612965534687, -0.72356703610543815, -6.1357877592112144, -17.728252948144313, 0.21980447663230326, 11.381535938317855, 6.2644803438068752, -1.1161504624718652, -1.810827135693615, 0.078230863522088162, 0.3612319198822263, 0.0079821569677794718, -0.054281237122748544, -0.0041954404795757263, 0.00223879799759173, -0.0011045036274548153, -0.0004297213082331914, 2.3729245648252329e-05, 3.7806930338968797e-05, 3.5348452681631499e-06, -7.1999178350888311e-05, -0.00017373359946041533, 0.00031643566338576109, 0.0025169723177924353, -0.0047317746654124164, -0.020596344531496415, 0.051467156562086717, 0.18144159918607133, -0.17672593964479372, -1.0853380408525777, -0.1595652231572473, 5.1086905995493037, 8.6874027327584269, -1.3635211201724846, -17.913066539877416, -41.976518122871397, 8.245977624890596, 37.913461849891497, 21.601631857858315, -1.1675628703506762, -4.8536563727710167, -0.38679604474523593, 0.57465299048466256, -0.0525083726541926, -0.13872845280170543, -0.0073188065692886169, 0.011724362942542425, -0.0030945645282711917, -0.002010624990356365, -7.7908669355331091e-05, 2.4116728282715131e-05, 2.4201934805746541e-05, 5.7815338716136568e-05, -6.6832908987693356e-05, 0.00045553699537366862, 0.0044705403327679654, -0.013860605018093377, -0.060499325131926705, 0.066476687185756819, 0.38263920912663169, -0.26778321549867512, -2.6427995487036529, -0.77255683543202414, 13.67501905826833, 26.775549975763717, 6.6541528790738154, -38.33083179304154, -164.80060347644644, -30.375445723654281, 94.854507489855592, 73.509265817506247, 6.6684998469427503, -10.955670081779644, -1.1517329733377899, 0.50820914967959985, -0.15810930352131641, -0.040660255117104735, 0.0029642733314879993, 0.0227386830861314, -0.0012902932474053552, -0.0039224781743013607, 0.00029458111873885689, 0.00035411166615547979, 0.00016453496496604298, 0.00019632055084304811, -0.00049216012286159682, 0.00069551217754943101, 0.0091529292682893254, -0.040312063728344255, -0.13796026336886155, -0.060952672321507556, 0.53317200343106097, -1.1108929795277824, -6.6982557512142833, 2.9148898834797672, 49.611102594467262, 78.707005278515183, -12.964795600796847, -151.52622363641291, -600.46969991458195, -159.10395104574698, 179.10482852523111, 142.77222209569621, -2.6052151602709213, -29.145899633206394, -1.1472068176590924, 4.6091984823197309, -0.34405016878893097, -0.50100451968487369, 0.043098557260408649, 0.011554157302593657, 0.0028053468557916613, -0.003120112935988917, 0.00037352179846528708, 0.00098821093942341102, 0.00062035219223615539, -0.00043166864272108633, -0.0045784971805325507, 0.0017127836707311211, 0.014308802406410212, -0.014067565159284841, -0.14520584302327849, -0.31158766591945286, 0.20453312434178955, -2.3563754691131549, -11.840914283794984, 5.9461121297862585, 98.021239180316684, 149.66956177052836, -84.358695632642934, -533.72028053649808, -1423.509046098827, -502.75722346741475, 299.68761898427243, 266.24434858476053, -14.225382292200068, -52.177815979562951, -4.1293951866555521, 7.0159472975173225, -0.46733110563156605, -1.5473028239900675, -0.18486506545171727, -0.0021885919874428559, -0.017832280274118859, -0.0099527381839588144, -0.0042340021876453469, 0.0015406044848677103, 0.0012390824544828119, -0.00075468105471319154, -0.0094665916234262307, -0.0017411003602265445, 0.037431091543101133, 0.050525784186618933, -0.33780530346449777, -0.96452576448320959, 2.8760611038460344, -0.73408381953999657, -30.973343141495679, -20.992706500305406, 170.47470391854245, 284.39023574769476, -258.09420634314608, -1206.2870766014166, -2689.7311891987179, -1317.5468335758917, 304.00864677044098, 486.73310475433766, 48.38111412245636, -40.990915592068674, 9.636927738004438, 1.5559427050062113, -6.1804125133917411, -2.4508298603470964, -0.053070166605885212, 0.16501061208697854, -0.031798236031439234, -0.024640414526075623, -0.012627706673397836, 0.001399772384542092, 0.0024301018087218504, 3.9927404721417186e-05, -0.0042018888946034633, 0.013157424181215942, 0.0073776692393865565, -0.17080663964207793, -1.1198886962258996, -1.2558586165362777, 4.8083890914979266, 1.7233725901997718, -45.128050992983098, -54.914023853010271, 253.24935366729582, 471.82586926866219, -533.70879716435559, -2302.5619774650809, -7525.5124487476278, -3861.3331359414919, 302.59784669978211, 872.01902032865962, 87.480286025038581, -13.481975167534443, 43.663316954645794, 20.309232259116435, -5.2990493438664386, -3.7567756530835754, 0.47200081560804741, 0.31419533009862788, -0.14585644547184853, -0.066021172391939276, -0.0060776628020447684, 0.0047783912245386402, 0.0025820557167290522, 0.00084949455245703076, -0.0068853887710688764, -0.0016279289016736856, 0.035426363555892841, 0.11899325802032523, -2.0029903992471114, -5.7422528468514553, -0.50779722959413964, 11.011155797013195, -31.327724554225593, -8.7220491465898675, 489.03634446603934, 766.79772203943878, -1404.6956818011561, -5804.1381366857704, -11751.949054213763, -5284.4851508729271, 2004.0776030608997, 2108.6641632789701, 15.711518936085099, -155.76938280407595, 26.780389598343376, 16.719706304911028, 5.3138000988900851, -2.0174170653233965, -0.11489505024579171, -0.083665866496761998, -0.35838805663067708, -0.13141543694038144, -0.010351412440954411, 0.0088257681278659308, 0.0039882283816162533, -0.00033732640143905191, -0.032306588307287817, -0.078076761518840951, 0.20366584836429438, 0.51553772502971895, -2.7652104861310511, -6.3950609995767769, 3.3880871060788507, 26.908851107336602, 3.5981209875695015, -59.523430315469177, 675.95430080467531, 1957.0910297219166, -1597.3125841788988, -9055.7727899285874, -13609.162528276773, -4902.8469709692927, 4992.3705750204963, 3370.1365438276171, -188.33038343684228, -449.68159927787059, 23.938521808677311, 5.474863645049389, -9.8469518252878032, -11.107804183612158, -0.25876313947681701, 0.45588994614236283, -0.12611798259867754, -0.14687879382002969, -0.035341389521171523, 0.002820237576687255, 0.0095036050242090532, 0.002839677815167327, -0.034546572003505492, -0.16497562627542883, 0.039542877145184945, -0.15910329528412964, -0.2257414648283198, -0.94130122169803698, 12.926010493557788, 10.792253245683524, -41.579492344426235, -371.53196930683367, 786.40461409554018, 4397.1447406314655, 2497.0113342386503, -9138.4955296375883, -30710.869495929113, -17039.959036708926, 4390.1153105308786, 3807.5774006807205, -403.54468101232675, -787.5686768088284, 12.126059162975466, 2.1424019920278234, -27.816492049240171, -15.856083499246239, -4.4804803612996116, 0.7466890006801008, 0.11739550901211765, -0.15988488342208015, -0.033458104535332392, 0.0037362591288712223, 0.010770434199071798, 0.0028928780958374094, -0.015513947258866389, -0.19362286330377187, -0.28694451643508428, 0.21253485530639998, -1.2097145653165073, -9.5348683496998436, -0.027644771384098099, 41.321279695296035, -108.77167233308927, -785.98438030181433, 848.32865192899692, 5360.9184206698983, 1300.6579518513656, -20630.868893573341, -7474.6405977592276, -6145.3703500362381, -1762.2326743166138, 7785.4292550857645, 624.53857955695855, -681.13286643622564, -60.968110303669903, -38.126922827402971, -30.447262913620339, -10.93402591728205, -0.92174645774084907, -0.73078681815469149, -0.39184400032067312, -0.090673583392963469, -0.025331085027316205, 0.017310354876322938, 0.0087184428309440443, -0.0046072373940015798, -0.061043080293425964, -0.14589600917437914, 0.17906893603684051, 1.5854066897944772, -7.4975861096446481, -15.430842802070792, -14.977979358030328, -4.0117794258829509, -153.66104783827134, -922.65330403810628, 173.97100199359761, 5029.218127936876, -2236.1016166727782, -8567.9043780819939], "imag": [0.0, -565.83540142139123, 2034.1707150791078, -2899.4713440958676, -705.26395079653423, -264.15772704109196, -68.25893457091972, 21.864239089276673, -9.2600847387275351, -0.77203496144657713, 0.46094227484148159, 0.050432963713891818, 0.4817041633893655, 0.069133436726486502, -0.053750756537428696, 0.0072803724650655878, 0.0, -0.0072803724650335657, 0.053750756537431763, -0.069133436726473527, -0.4817041633893806, -0.050432963713828063, -0.46094227484152789, 0.77203496144659334, 9.2600847387275351, -21.864239089276733, 68.258934570919919, 264.15772704109207, 705.263950796534, 2899.4713440958658, -2034.1707150791096, 565.83540142139009, -27456.969846005039, 15801.95774991386, 6659.2852195136584, -5625.222440567115, -315.00701580725445, 272.57265196057085, -226.29890693046426, -11.162014580405042, 22.51960143730463, 12.777842336107099, -0.00080551226422213157, -0.40616257836882108, 0.090977957608488841, 0.020544905947865743, -0.0050852207874264883, 0.005762481528077454, -0.0051011628064007979, 0.008737332888475351, -0.024097393253454041, 0.064089909650063406, -0.12938270466631999, 0.53088177925581315, -0.6296735496972713, -5.9301461429211297, -10.810291764213344, -3.7416120100021248, -182.38596939283659, -362.28186950461651, -992.82929249872541, -4862.6686041022249, 4699.2031805565066, 18939.315780035107, 10706.514246895442, -4202.5064061160292, -8815.5169521241642, 1263.9440399653656, 1779.1449685952537, 162.85707963816941, -206.3024685851984, 13.222359870031848, 21.464492537709937, 20.567779042237813, 0.65600865155601296, -0.18805381897022255, -0.36223791541012046, 0.1254341335131833, 0.020744772339125268, 0.00182748958184843, -0.0042992876297386403, -0.0012201610716230688, -0.017092494175410845, -0.076964103250570653, 0.098376776437578264, 0.4173977832999109, -0.76419419802802224, 1.7461999698867376, 9.8585155596813561, 24.776358129244393, -211.6323955131393, -238.91976950528434, 1185.1238932642693, 1296.4366520857086, -4946.0282562867787, -5281.5723471297015, -13391.901368395223, -11194.545427930107, -3925.7577913329569, 887.46023361526534, 945.20766142433024, 84.877841434423829, -42.932263785691212, -4.9615998121405198, -2.2373513523401476, 3.2722596307272758, -0.72535972703625207, -0.26143602710083624, 0.17221216218193261, 0.13507416188085969, 0.00023543387332632535, -0.004345917754103765, 0.00085055424110927274, -0.0037937176827999176, -0.0081378837299059311, -0.075677036525131303, -0.15032468438850372, -0.38722147995532397, 0.029603642148641713, 7.4921225563560006, 16.360105748561345, 29.902810744114234, -93.460146257112015, -275.96221185192559, 922.99713133386672, 2711.515323984423, -1933.4800470053665, -10929.798398133844, 684.97959165063389, 602.54327944682984, -1010.3237650874754, -821.26497752603393, 354.91295307862521, 267.12706753457422, -50.770431510290891, -60.739251530981761, -3.0004343666525628, 2.078290590472712, -2.279554023627556, -0.70169954600639106, 0.15105372261757208, 0.07861078903623217, 0.022330776935849336, 0.0012282676678784887, -0.00060025303576528312, -0.0034390891352469423, 0.011529870687322991, 0.014029711179492978, 0.1252130338315626, -0.55405390993532211, -0.54107724731740914, 0.87667351785494574, 3.6828009300200657, -7.4141267588561011, -13.004195929909718, -24.795065499663313, 420.27054634951992, 459.95573868102485, -942.16755498192015, -1112.054015955898, 2348.3469931726836, 1883.3636695028392, -240.70143186447856, -105.71673535442261, 372.79259353377239, 52.920672453261901, -92.068040375826783, -26.276835867611968, 6.7051139314185226, 3.245275744583783, -0.60045275904084205, -0.50382743582039524, -0.067202922116500141, 0.024987588306014712, 0.02345280256265949, 0.0036069899885115028, -0.0019176843365481997, -0.0026716531574556067, -0.0020365413730906823, -0.011083467862231831, 0.11877640918683252, 0.22402554985838732, -0.99918245590032706, -3.4731271711763432, 0.48835520550537315, -13.858896676215748, -73.254839813416254, -21.319429226850428, 379.31228865246607, 351.81985736289278, -537.57809524921299, 401.89162402051699, 608.06184705207306, 404.48916791571293, -26.0947672494631, -28.936629621288695, 88.255503332807123, 24.728035394109561, -22.866056256077933, -13.157904592767515, -0.15967604903152702, 2.526299018978182, 0.12352888715752443, -0.23422795848566569, -0.030590557055647175, 0.016424937283601903, 0.0056060898486765369, -0.00045117160770213557, -0.00085071688314226489, -0.0011353628514113501, 0.0023693867958524341, -0.0020514022508182662, 0.047410658855092408, -0.047246191697244096, -0.80895482070078151, -2.1371851454270119, 2.4873407504647034, 5.7983733792054322, -40.953249308721645, -95.737309397844541, 76.822153629632922, 273.3130006291081, 25.450658270222483, 108.35753184636786, -342.27621105731498, -348.25890814832445, -304.47603827676795, -96.629055803978503, 63.023130997866865, 57.409949251798395, 2.568042168489272, -13.095155674154295, -3.2681008083097729, 0.88286993545095549, 0.13472332633921499, -0.098529564497226177, -0.013721933165641624, 0.0016719543218752051, -0.00081574697753264229, -0.00012016604513092251, 2.100818845429297e-06, -0.00060431365246994741, -0.00084901673761287883, 0.013320171975788974, 0.024623507369733132, -0.041782640680197221, -0.60700748329107235, -0.43012965453926089, 2.2891908586667724, 0.48632248954743251, -15.792270422196429, -28.193965034765785, 48.029615644247542, 111.09879990264463, -87.497164212346334, -334.6737117352032, -142.68730890272883, -91.053579482449521, -99.787409897491159, -55.001294578822431, 29.906016170654414, 37.535076920090127, 4.5234778785073582, -7.1923708075200636, -1.3689331500831903, 0.35202350218593043, -0.0362018905598291, -0.061463792395340174, -0.022721689012942182, 0.0082737875972394501, 0.0032130032530252534, 0.00039450994426574093, -2.8031778648544371e-05, -0.00041406827904942888, -0.0027075490516005737, -4.6035494233911042e-05, 0.0066681432594733418, 0.0047951528835353972, -0.05690176651734323, -0.24922608889607248, 0.498049017017482, -2.4309674287383847, -12.16171561638105, 0.97951365769633958, 48.129088343602525, 56.486069104567768, -41.171639289684258, -127.72312720337817, -5.4282746232061827, -9.7835860709552271, -33.975619755276277, -24.806312587182678, 2.4072249874859208, 11.539786987684712, 2.1158028157224305, -2.1858286220084042, -0.55165459871114553, 0.18427966087195025, 0.036325697906855962, -0.045150767767426783, -0.010550176613753719, 0.0060855196058800442, 0.0017281414610421119, 7.2497674435495387e-05, -0.00021205409372000895, -2.0602816877647228e-05, -0.0011298747328672136, -0.0028809147575241121, -0.0012342607279736744, -0.011825603754497111, -0.087069268286694118, -0.14265264682578704, 0.15323327509603407, -0.85687745542587679, -6.0248432237602145, -2.077910419819851, 20.474406237761055, 25.037428100181106, -14.989381828055835, -36.497593867080774, -17.729338100591551, -17.576621089243332, -19.487467662417078, -10.955871914675358, 2.3165455312690852, 5.4119853383600915, 0.54621288944966873, -1.3157595111644833, -0.34743645177227866, 0.1287210896998103, 0.047412118534244603, -0.0077851049698980206, -0.004201560949808625, 0.0010934558980435574, 0.00023257626702487001, -9.2808109881009371e-05, -8.7155323163908151e-05, -3.9084915731858744e-05, -0.00010250720925033233, -0.00067901668703098609, 0.0014464277080026529, -0.0048636342861169473, -0.067823949067901526, -0.057130716853855026, 0.21557912264683496, 0.06519665350656248, -1.6533046454778435, -1.8832932452039048, 3.7264846171107551, 6.4019126311322827, -3.9744235027987749, -16.160449140843355, -8.4822228391137156, -8.7315069105384708, -6.1656643244543572, -2.3598704650957352, 1.9985565184181031, 2.3405484242614913, 0.29382845386145329, -0.50865792651575648, -0.17305354955167165, 0.046960029345024031, 0.015263156905378368, -0.0036170611596276912, -0.0013726058920436061, 2.237332432783488e-05, 9.385945789129954e-05, 1.3994387363258527e-05, -1.5306190418175455e-05, -2.2179563572570082e-06, 1.915436069625878e-05, 1.6056362425269958e-05, 0.0016017335432058808, 0.0021630491325728405, -0.015795334924840046, -0.011660119791667443, 0.14639963344722604, 0.10651220377116319, -0.88291287420081066, -1.2568372820076821, 1.6004592076355926, 4.2391713347552544, 2.2028113471748907, -3.1469764634818462, -2.242974904561942, -2.5538673583000224, -2.2927664969925643, -0.71511526306228479, 0.70142225830116711, 0.87257163068624521, 0.19846976557711371, -0.15249245278412921, -0.070864296996220155, 0.0099358115635036701, 0.0047066150942456026, -0.0026523157902845263, -0.00085439958417801774, 0.00013944973801692797, 7.2704791039188404e-05, 1.2601241693252589e-05, -1.5809883406608869e-05, -1.0011729527080636e-05, -7.9478542847663604e-05, -0.00022527265138271089, 0.00045307702727412569, 0.00050105816519738884, -0.004694536759989586, -0.0093912827538699273, 0.048586273708375149, 0.030553958637497009, -0.25838788694247888, -0.40093326275917601, 0.49595628709938333, 1.6851565365398353, 1.1309597417418693, -1.056522952990393, -0.80247840632915779, -1.026927016182452, -0.88651914954529398, -0.43650779681426854, 0.11316541147379869, 0.23035854544536424, 0.059920467833033307, -0.036190438604187899, -0.01725390654373966, 0.0023509305274026565, 0.001478217289217426, -0.00072670648727194635, -0.0003680247758271001, 7.1552277723323216e-05, 3.3018347577537154e-05, -6.270504054453194e-06, -5.0961890322362396e-06, -8.2597481363066073e-07, -2.4936495372693928e-05, -0.00010760628949477799, -7.7022154797155748e-05, 8.3265078915305005e-05, -0.0013990135309411168, -0.0028172526227442643, 0.010701408851355284, 0.0072451530391376149, -0.086150037841453433, -0.14460665466238934, 0.049708417947223346, 0.39521478333333182, 0.28744423285388176, -0.29861910565037264, -0.3386926979654547, -0.41865673900782491, -0.35458750065998923, -0.15351062390629316, 0.023283787620964443, 0.070315990790370639, 0.021825222068831439, -0.0094360968553556454, -0.005228648752625107, 0.0016419352706606338, 0.00062222393158804063, -0.00023654954587354915, -9.5116584994877886e-05, 9.8316138184821904e-06, 8.5616544537091567e-06, -1.8490511258670774e-06, -1.3806960215566987e-06, -7.8418160579829819e-07, 6.1187783428882963e-07, -1.4184243450717458e-05, -1.6817152282181301e-06, 7.7315413636427208e-05, -0.00049776351731738936, -0.0011677770881636529, 0.0043012344452256343, 0.0053934499385103812, -0.019935861209744145, -0.053344442429226806, -0.0040707298903069475, 0.10515901839488417, 0.12441049519027374, -0.064763119504183633, -0.033271590846292554, -0.10779677164705558, -0.11539582523941379, -0.051505283097805894, 0.0069246983450398508, 0.021708652485324127, 0.0069347628931926159, -0.0022906766529511625, -0.0016964640398162575, 0.00025142958382895784, 0.00031770653382385736, 1.1032501437955532e-05, -8.7468779744470293e-06, 5.5945066423596016e-06, 1.7972345455397561e-06, 4.5616338203520101e-07, 9.7201394524267242e-08, 4.7224934971170761e-07, -3.3798970421174713e-06, -2.8493281587958699e-06, 1.5043823885218312e-05, 5.8125806227282977e-05, -0.00024311382978972981, -0.00034121417018685452, 0.0017972456094799462, 0.002919931802959911, -0.0062096116659288523, -0.016969044244524348, -0.0032835840838819309, 0.038807899659842743, 0.067426466166360513, 0.050826644444124935, 0.0, -0.049486105286858977, -0.055102269491050557, -0.024933286677064983, 0.0027131015547638831, 0.0094232929485847418, 0.0031928535384108483, -0.0010192088413809152, -0.00065687472267875711, 9.9406390967590554e-05, 9.2117117221092925e-05, 4.2835653158188598e-07, -1.1077354271652886e-05, 4.6988159821331912e-06, 1.8643898350265165e-06, -1.3325436344526307e-07, 0.0, 1.3325436148527189e-07, -1.8643898357013856e-06, -4.698815982340655e-06, 1.1077354271338259e-05, -4.2835653029578673e-07, -9.2117117220968567e-05, -9.9406390967541697e-05, 0.00065687472267875711, 0.0010192088413828024, -0.0031928535384109992, -0.0094232929485852882, -0.0027131015547645593, 0.024933286677071297, 0.055102269491057093, 0.049486105286870655, 0.033271590846436425, -0.050826644444130153, -0.067426466166320781, -0.038807899659787329, 0.0032835840838925869, 0.01696904424452016, 0.0062096116659344346, -0.0029199318029558409, -0.0017972456094788201, 0.00034121417018834725, 0.00024311382979051588, -5.8125806225852501e-05, -1.5043823885472467e-05, 2.8493281592184042e-06, 3.3798970414074387e-06, -4.7224935044335926e-07, -9.7201394523848146e-08, -4.5616338348029835e-07, -1.7972345459045348e-06, -5.5945066421669702e-06, 8.7468779741463935e-06, -1.1032501437633476e-05, -0.00031770653382469171, -0.00025142958382980715, 0.0016964640398156006, 0.0022906766529529358, -0.0069347628931879929, -0.021708652485317177, -0.0069246983450331808, 0.051505283097836994, 0.11539582523943163, 0.10779677164702299, 0.3386926979653444, 0.064763119504166911, -0.12441049519022664, -0.10515901839483223, 0.004070729890304727, 0.053344442429226403, 0.019935861209740766, -0.0053934499385123874, -0.0043012344452267063, 0.0011677770881626617, 0.00049776351731785828, -7.7315413635329507e-05, 1.6817152281107408e-06, 1.4184243450816806e-05, -6.1187783459995966e-07, 7.8418160414892948e-07, 1.3806960215563787e-06, 1.8490511250936381e-06, -8.5616544541499696e-06, -9.8316138175931616e-06, 9.5116584994742171e-05, 0.00023654954587342899, -0.00062222393158917633, -0.0016419352706608273, 0.0052286487526254947, 0.0094360968553597515, -0.021825222068826373, -0.070315990790367974, -0.023283787620951409, 0.15351062390632836, 0.35458750065996514, 0.41865673900782463, 0.80247840632930123, 0.29861910565040301, -0.28744423285381543, -0.39521478333324389, -0.049708417947207637, 0.14460665466238265, 0.086150037841446453, -0.0072451530391390538, -0.010701408851356092, 0.0028172526227436055, 0.0013990135309424952, -8.3265078914415499e-05, 7.7022154796884101e-05, 0.00010760628949436256, 2.4936495372172559e-05, 8.2597481160475411e-07, 5.0961890322364048e-06, 6.270504053587473e-06, -3.3018347577843258e-05, -7.1552277722738763e-05, 0.00036802477582684921, 0.00072670648727208957, -0.0014782172892186336, -0.0023509305274016343, 0.017253906543740219, 0.0361904386041903, -0.059920467833026222, -0.23035854544535139, -0.11316541147376862, 0.436507796814322, 0.88651914954535227, 1.0269270161824879, 2.2429749045618363, 1.0565229529903326, -1.1309597417418378, -1.6851565365398167, -0.49595628709941025, 0.40093326275916286, 0.25838788694247145, -0.030553958637498463, -0.048586273708375489, 0.0093912827538692768, 0.0046945367599903042, -0.00050105816519528668, -0.00045307702727423699, 0.00022527265138177463, 7.9478542847089153e-05, 1.0011729526400015e-05, 1.5809883406608184e-05, -1.2601241693104561e-05, -7.2704791039154929e-05, -0.00013944973801701606, 0.00085439958417779277, 0.0026523157902857862, -0.0047066150942464552, -0.0099358115635039043, 0.070864296996221418, 0.15249245278412987, -0.19846976557711321, -0.87257163068623855, -0.70142225830113492, 0.71511526306233175, 2.2927664969925812, 2.5538673583000056, 8.4822228391138594, 3.1469764634817636, -2.2028113471748418, -4.2391713347551567, -1.6004592076355943, 1.256837282007673, 0.88291287420080655, -0.10651220377116098, -0.14639963344722345, 0.011660119791666538, 0.015795334924840389, -0.0021630491325718448, -0.0016017335432059105, -1.6056362425267762e-05, -1.9154360696782612e-05, 2.2179563562188507e-06, 1.5306190418174822e-05, -1.3994387363725719e-05, -9.3859457891797799e-05, -2.2373324326887067e-05, 0.001372605892043584, 0.0036170611596280633, -0.015263156905379492, -0.046960029345022428, 0.17305354955167276, 0.50865792651575092, -0.29382845386145795, -2.3405484242614674, -1.9985565184180694, 2.3598704650957769, 6.1656643244542986, 8.7315069105383625, 17.729338100591146, 16.16044914084344, 3.9744235027988806, -6.4019126311322339, -3.7264846171107413, 1.8832932452038942, 1.6533046454778479, -0.065196653506560565, -0.21557912264683374, 0.057130716853852841, 0.067823949067901873, 0.0048636342861174938, -0.0014464277080027464, 0.00067901668703094988, 0.00010250720924968801, 3.9084915731564376e-05, 8.7155323163908978e-05, 9.2808109880357901e-05, -0.0002325762670250908, -0.0010934558980430407, 0.0042015609498085452, 0.0077851049698978879, -0.047412118534246123, -0.12872108969980919, 0.347436451772281, 1.3157595111644818, -0.54621288944967405, -5.4119853383600702, -2.3165455312690484, 10.955871914675381, 19.487467662417213, 17.576621089243289, 5.4282746232066126, 36.497593867080688, 14.989381828055899, -25.037428100180914, -20.474406237761002, 2.0779104198198417, 6.0248432237602181, 0.85687745542587901, -0.15323327509603168, 0.14265264682578829, 0.087069268286695561, 0.011825603754498296, 0.0012342607279732299, 0.0028809147575238926, 0.0011298747328662582, 2.0602816877460582e-05, 0.00021205409372000841, -7.2497674436697104e-05, -0.0017281414610421523, -0.006085519605879876, 0.010550176613753189, 0.04515076776742772, -0.036325697906856379, -0.18427966087195091, 0.55165459871114753, 2.1858286220084038, -2.1158028157224313, -11.539786987684664, -2.4072249874858644, 24.806312587182791, 33.975619755276242, 9.783586070955252, 142.68730890272883, 127.72312720337824, 41.171639289684236, -56.486069104567761, -48.129088343602554, -0.9795136576963499, 12.161715616381057, 2.4309674287383989, -0.498049017017482, 0.24922608889607162, 0.05690176651734568, -0.0047951528835340962, -0.00666814325947404, 4.6035494233416009e-05, 0.0027075490515988954, 0.00041406827904844702, 2.8031778648544371e-05, -0.00039450994426571523, -0.0032130032530263515, -0.0082737875972399878, 0.022721689012943438, 0.061463792395343643, 0.036201890559829163, -0.3520235021859332, 1.3689331500831903, 7.1923708075200734, -4.5234778785073484, -37.53507692009012, -29.906016170654418, 55.001294578822382, 99.787409897491187, 91.053579482449422, 342.27621105731453, 334.67371173520326, 87.497164212346618, -111.0987999026444, -48.029615644247457, 28.193965034765707, 15.792270422196436, -0.48632248954740509, -2.2891908586667706, 0.43012965453925761, 0.60700748329106979, 0.041782640680199906, -0.024623507369732841, -0.013320171975792017, 0.00084901673761237609, 0.0006043136524673308, -2.1008188454298679e-06, 0.0001201660451322299, 0.00081574697752853306, -0.0016719543218773789, 0.013721933165640972, 0.098529564497228272, -0.13472332633921438, -0.88286993545096504, 3.2681008083097729, 13.095155674154302, -2.5680421684892911, -57.409949251798253, -63.023130997866808, 96.62905580397846, 304.47603827676824, 348.25890814832377, -608.06184705207238, -108.3575318463683, -25.450658270222359, -273.31300062910782, -76.822153629632936, 95.737309397844399, 40.953249308721709, -5.7983733792054135, -2.4873407504647047, 2.1371851454270088, 0.80895482070078295, 0.047246191697243041, -0.047410658855088467, 0.0020514022508175854, -0.002369386795852814, 0.0011353628514107392, 0.00085071688314226511, 0.00045117160770050525, -0.0056060898486796759, -0.016424937283604724, 0.030590557055645055, 0.23422795848566832, -0.12352888715752926, -2.5262990189781851, 0.15967604903152918, 13.157904592767508, 22.866056256077929, -24.728035394109568, -88.255503332807095, 28.936629621288684, 26.094767249463303, -404.48916791571332, -2348.346993172679, -401.89162402051733, 537.57809524921231, -351.81985736289272, -379.31228865246618, 21.319429226850364, 73.254839813416325, 13.858896676215757, -0.48835520550537709, 3.4731271711763214, 0.99918245590033916, -0.22402554985838727, -0.11877640918683258, 0.011083467862236249, 0.0020365413730902885, 0.0026716531574479938, 0.001917684336548198, -0.0036069899885160838, -0.023452802562666058, -0.024987588306021404, 0.067202922116505387, 0.50382743582040856, 0.6004527590408355, -3.2452757445837785, -6.7051139314185244, 26.276835867611975, 92.068040375826797, -52.920672453261844, -372.79259353377256, 105.71673535442247, 240.70143186447768, -1883.363669502841, -684.97959165063321, 1112.0540159558975, 942.16755498192003, -459.95573868102451, -420.27054634951992, 24.795065499662957, 13.004195929909772, 7.4141267588561703, -3.682800930020067, -0.87667351785495562, 0.54107724731740381, 0.55405390993531467, -0.1252130338315631, -0.014029711179499669, -0.011529870687323501, 0.0034390891352509903, 0.00060025303576528312, -0.0012282676678759762, -0.022330776935852007, -0.078610789036235279, -0.15105372261757474, 0.70169954600638929, 2.2795540236275773, -2.0782905904726996, 3.000434366652557, 60.739251530981811, 50.770431510290891, -267.12706753457417, -354.91295307862521, 821.26497752603382, 1010.3237650874759, -602.54327944683052, 13391.901368395234, 10929.798398133857, 1933.4800470053663, -2711.5153239844217, -922.99713133386661, 275.96221185192491, 93.460146257111958, -29.902810744114028, -16.360105748561381, -7.4921225563559606, -0.029603642148639909, 0.38722147995532696, 0.15032468438850879, 0.075677036525108848, 0.0081378837299098394, 0.0037937176827991482, -0.00085055424110926829, 0.0043459177540993259, -0.00023543387332691185, -0.13507416188085952, -0.17221216218196025, 0.26143602710082897, 0.72535972703626972, -3.2722596307272944, 2.2373513523401622, 4.9615998121405012, 42.932263785691291, -84.877841434423658, -945.20766142432956, -887.46023361526682, 3925.7577913329583, 11194.545427930101, -10706.514246895442, 5281.5723471297006, 4946.0282562867797, -1296.4366520857075, -1185.1238932642696, 238.9197695052832, 211.6323955131397, -24.776358129244326, -9.8585155596813792, -1.7461999698868065, 0.76419419802801547, -0.41739778329989746, -0.098376776437577709, 0.076964103250559746, 0.017092494175422378, 0.0012201610715871689, 0.004299287629738649, -0.0018274895818451932, -0.020744772339150463, -0.12543413351316696, 0.36223791541011652, 0.18805381897020862, -0.65600865155600818, -20.567779042237863, -21.46449253770993, -13.222359870031557, 206.30246858519831, -162.85707963816978, -1779.1449685952532, -1263.9440399653668, 8815.516952124166, 4202.5064061160301, 27456.969846005039, -18939.315780035096, -4699.2031805565066, 4862.6686041022285, 992.82929249872586, 362.28186950461748, 182.38596939283644, 3.7416120100025241, 10.810291764213327, 5.9301461429212612, 0.62967354969719169, -0.53088177925578472, 0.12938270466632043, -0.064089909650021634, 0.024097393253418069, -0.0087373328884417078, 0.0051011628064008057, -0.0057624815280936303, 0.0050852207874495618, -0.020544905947870024, -0.090977957608502774, 0.40616257836881853, 0.00080551226426904543, -12.777842336107227, -22.519601437304647, 11.16201458040481, 226.29890693046417, -272.5726519605721, 315.00701580725359, 5625.222440567115, -6659.2852195136511, -15801.957749913861]}};

  var nose_filter = {"real": [3.0408379415611857, 0.37822261363137938, 1.1747173276627942, 0.87791572866957501, 0.27429578524536991, -0.26015038230887205, -0.04589694540462394, 0.18194913988848616, -0.19035992880648842, -0.050064472206627651, -0.016354960260506177, 0.073013903204916478, 0.15053197342937383, -0.47378158951033317, -0.33333577915227425, -0.30434085338299055, 0.26372284406307878, -0.30434085338299449, -0.33333577915227836, -0.47378158951033028, 0.15053197342937505, 0.073013903204915576, -0.016354960260505706, -0.050064472206628768, -0.19035992880648842, 0.18194913988848541, -0.045896945404624932, -0.2601503823088735, 0.27429578524536952, 0.87791572866957457, 1.1747173276627942, 0.3782226136313796, 1.5638480130127614, -1.0502161590016221, -0.28144140655806793, 0.66007876209063499, 0.25575295594566605, -0.11471557758718753, 0.22751157962613866, -0.29100003355994186, 0.29242994865853178, 0.14950061311078749, -0.02214037256893809, 0.034503572794411914, -0.17412889405901469, 0.060297128338254534, -0.49717312826403576, -0.10585857030501357, 0.082780177430083327, -0.11056584899062352, -0.72499416196392785, -0.15612863751308359, -0.36586758725441215, -0.19718551141955715, -0.043434328775718851, -0.060442748560529294, 0.1383233017601592, -0.071714399164362744, 0.31725814504248484, 0.16801904131477274, 0.58675004339129755, 1.5155025161072819, 0.99232752650122635, -1.0129349058609656, -1.6725083187014358, -0.66077224091757791, 2.2217962254133496, 0.98390492917013095, -0.16319024909703178, 0.67271651276019184, 0.16380771710007475, 0.21989373735679621, -0.12296413131763459, -0.18224776807046256, -0.011168077595514938, 0.10364961453623285, 0.1359801303077682, -0.26339593722715721, 0.039396952561874886, -0.33866696253626483, -0.0043101841409601402, 0.17740469505625342, -0.10830858623812685, -0.33186051211466239, 0.12060535717228799, 0.084703474730635803, -0.086262426064740078, -0.1297477439897661, -0.28426475792188655, 0.21965961682575447, 0.24955999100642301, 0.46804088594167448, -0.46946217188769823, -0.31724338121882617, 1.7716903674840139, 0.56577881124465312, 0.71512595047089234, 0.4910867492003736, 0.92310119575914651, -1.0939934957719639, 0.18102793706565934, 0.35484595526186652, 0.48676804973393767, -0.097923922056211768, -7.8200063684236368e-05, -0.016095705887683227, -0.084263209727683391, 0.0080331646697531477, -0.044853168166469837, 0.0062170702455977547, -0.15890945005602863, 0.22815908460498888, 0.17110516400703918, -0.29052216822588434, -0.18224178792918044, -0.018421573557969844, 0.032535239746583795, -0.08121081614537759, -0.029175915115094032, 0.092929862040843081, 0.16824405476099044, -0.24679227625704581, 0.00030176170486908785, 0.023943010115746295, -0.43281940369171445, -0.57166836623813821, 1.2482467538506352, 0.74385331371246666, 0.54787745216002559, 0.92898941300038174, 0.54473301805335128, -0.4877077226718825, -0.40370312470951597, 0.39096527623299848, 0.12644205243911047, 0.0424168022733412, 0.049219693586430309, -0.077748186566067037, -0.043614575991677208, -0.0041635061718157101, 0.07897222152752259, 0.053944973270972973, 0.11232623315704468, -0.070445625631503542, -0.072057201177642652, 0.12706805404252855, -0.13757198545862262, -0.31639223989443899, -0.029240486244660611, 0.10973045554309782, 0.04102655016489614, 0.01891084247324943, -0.056922369420476487, 0.030805208457151782, -0.1512000567754726, -0.058122663069861934, -0.30506910575481916, -0.79033868813295383, 0.026308878650124864, 1.7521122327973906, 0.64566220514793682, 0.40042515638418263, -0.33461208848408402, -0.55369429571770823, -0.030140868003777126, 0.27230784814155334, 0.008194429787378334, -0.030645866021173498, 0.023928227792328404, 0.090706510487419734, -0.021569631345745226, -0.0064127815367693367, -0.026343653609827326, 0.0079365608693974798, -0.18791450411345401, 0.14319521757460194, 0.17003550871316017, -0.24661106106331201, -0.21167593067635404, -0.098206750946426211, -0.048592759447365123, 0.0028129255950110439, 0.049868939755416952, 0.039023237394102607, -0.0036267311717218496, -0.12930461632538415, -0.067411320951837855, 0.010801205387038189, 0.074931291451028059, 0.0657071501308885, -0.22930577035731903, -0.34894672904561169, 0.37107135970432037, 0.49136473213042475, 0.10645611255411164, -0.27741376367012294, -0.015474080963115254, 0.13417678111594294, -0.00046677178847574514, -0.064152245495751381, 0.038292630722847554, 0.017696001575747813, 0.0052157631901947011, -0.023883294001795573, 0.00060518848897931612, -0.088395093514235953, -0.11757758027246699, -0.019555697374511325, 0.025650630137194243, -0.043746931993730094, -0.08846438922222799, -0.074442233736365312, -0.0099104052825428144, 0.064871673248634965, 0.03524540038796406, -0.0065163090427015676, -0.065286881502250399, 0.023130909787941502, -0.028452880392855154, -0.098638256951482817, -0.23382813425811513, -0.077933249962103476, 0.069575788839216612, 0.86635491100693507, 0.33668792873864722, 0.34253529215971401, -0.019122146869457048, -0.016521364547457899, 0.098161425946316522, -0.011130337821465129, -0.092543539386829035, -0.0046973120649884213, -0.0086885172531639618, 0.041915865623990751, 0.004043623749362439, -0.037907101781325205, -0.03902357631677511, -0.037690963997300889, -0.11419210623041842, -0.076732726183972602, 0.12573571356763677, 0.012633232837618465, -0.098942005293094951, -0.061888601165125671, -0.0090012900880717846, -0.014247675993027883, 0.027023228844142398, -0.0050282774165556453, -0.031667371615742887, -0.033818612421867206, -0.01148054478950835, 0.002410610826462259, 0.084402385062259444, 0.069824545029654947, 0.043930202648898894, 0.078872059827297045, 0.055053359776043469, 0.0133618922103162, 0.068453834537836655, 0.081701490128889276, -0.023034972903402569, -0.042406682273060693, 0.035148729718712253, -0.037569795749083354, -0.0041828274568459145, 0.012961699649937737, -0.015475583648045266, -0.027857672235467607, 0.011169867646763214, -0.052725469767566695, -0.0070148730067698924, 0.053188940442296044, -0.095289423698368528, 0.016377276604450954, -0.015232023889946105, -0.077682201861009353, -0.048207693014304241, 0.014396940553395536, 0.021075876818278678, -0.0024069559974744716, -0.016758259649352489, 0.031865879706987753, 0.032824623168326933, -0.074182732572421473, -0.080036865363297197, 0.055652716802045685, 0.11130862970905192, 0.072952972838101024, 0.035098396968263772, 0.070242479721294437, 0.040747896169172335, -0.022459274904977577, 0.014257984954846613, 0.019887732012022184, -0.040811004345713692, 0.0088191619820225595, 0.012579825412037176, 0.0010521231241174983, 0.006430724322423028, -0.0107697788586532, -0.065313535534231901, -0.062769573271966861, 0.11452944472315789, 0.040092306883550234, 0.12236977033818973, 0.13624403896529741, 0.027359429809611827, -0.0259369720098807, -0.021419082531908291, -0.02797214703330133, 0.0080320798501609496, 0.0013100558771969473, -0.0052561866064455981, -0.0097375289490629017, 0.028455863356249757, 0.056425701741664613, -0.0014166564531825356, -0.032528933027316242, -0.019619112630340951, 0.065700689463789611, -0.027574493612476551, -0.032810042710946841, -0.021337213333243964, 0.019592990080295629, -0.019759750092557201, -0.030135000999364853, 0.031698488621630008, 0.023522054710864718, -0.021766544372719836, -0.0029827434432790761, 0.0078373508878122541, -0.0028057606437618767, -0.033232550782043478, -0.070830818977105636, 0.059080455669844649, 0.36951320092865036, 0.091411128665944044, 0.16404233417264649, 0.062598270207454218, 0.044986403519809939, -0.081510896741027974, -0.042341618007147169, -0.019737461729971092, -0.0048974001169366831, 0.01654258945512711, 0.0088012977267579451, -0.013696041496545335, -0.0020268100930256635, 0.015845305908809133, 0.016458612619479462, 0.00059474001274681517, -0.078529066256991353, -0.013402803779002156, -0.0036013299995064228, 0.037573591582025043, -0.0076636494655425947, -0.0021144243161753088, 0.032140257903604356, 0.0203960516207237, -0.013294834505552555, 0.0021732333351695376, 0.015223562704661827, -0.01560949450401263, 0.015060609589555461, 0.099241248305729085, -0.19173261262163863, 0.2450151004066432, 0.26383919410790774, 0.33963060937430933, 0.34586223870135113, 0.1799263961717959, 0.13137374163691276, -0.036493858716968031, -0.041981936023927684, -0.060258932305754208, -0.0099079010405710068, -0.010024579181759819, 0.016637976300589805, 0.031629106230310143, -0.011441752446030828, -0.010113005489671789, -0.027490450999295705, -0.018258671855796018, 0.061296263921274532, 0.10180457538537498, 0.097647442588889397, 0.063246459754600901, 0.0018146068702083835, -0.012539173975430248, -0.008345642545901014, 0.020763503842579332, 0.035996162307667869, -0.015675575409266479, -0.029662747125522582, 0.021312770128680401, 0.08274253615935892, -0.10682054954404013, -0.033729052458342255, -0.12662108035586636, 0.18053751384272299, 0.70940599530087467, -0.21337246968950196, 0.09763637724258438, 0.15345959634626791, -0.11690110107335749, 0.030098075283007168, 0.034186076429122053, -0.021402902917041923, 0.0046349096026103891, 0.011776544425663813, -0.0089673934626629329, 0.025701507905379287, -0.029333520957471802, 0.0051215906448292756, -9.6207917787476249e-05, -0.027988212781709806, 0.093695296747695708, 0.10174972110658871, 0.1657472048824174, 0.097917377942654052, 0.0075790364114050627, 0.031051039914505564, 0.015692601846482499, -0.015197940538429407, 0.026154427883432859, 0.038178927860434288, 0.07391023019778703, 0.0062621769249755375, 0.14786394857966245, -0.24133125024592791, 0.31944609486771169, 0.50715637065140251, 0.3628700351691248, 1.3060302403517683, -0.51467834215318464, -0.23826829822593068, -0.0093468845104923252, 0.16015106243072727, 0.02805086056222977, -0.0035899004350242064, -0.0055435803643170143, -0.026732920924661639, -0.010772744125100176, -0.024390993371714485, 0.012627431507206405, -0.0087203787935273471, 0.017390054254405412, 0.12375300108425245, 0.24623032442851775, 0.32220608581938742, 0.14931322115435106, -0.030460558403777184, 0.017160725214558258, -0.0094839753900354314, -0.040937983123008212, 0.021461267056132466, 0.052605242734811673, 0.082583919156513017, 0.060994911510484674, 0.19212485777257118, 0.030490864773295545, 0.17592824054988929, 0.2988664581273196, -0.3440942993173739, 1.3210609586317499, 0.059297195869563314, 0.66450815180221101, -0.18837022473974091, 0.34310308052214539, 0.41335445680081984, 0.18880277280085617, -0.0025387166530481263, -0.027056960212979365, -0.014992917126512385, -0.065825070508153574, 0.0059924400617866053, 0.016058491686644451, 0.096318218677932735, 0.11648035795043635, 0.083105673180647682, 0.32671351148908129, 0.21720864831216413, 0.29412476851730657, 0.14853499339159934, 0.018970981025801619, -0.0063191769526926853, -0.01818046447321878, -0.033255690840711123, 0.042088106914846247, 0.11598544099090941, 0.13859711550376397, -0.01128947190338442, 0.086653868373652729, 0.5559656926196751, 0.37680556076813249, 0.88488899182435787, -1.1019114795534606, 1.0072326177374842, -0.25696609936231163, 0.22595605005106759, 0.20124367647634336, 0.25020565573121023, 0.15194580903531119, 0.054188690404279045, -0.031588472981034531, -0.072469006265441768, -0.025752917138555535, -0.0471489088024604, 0.079293556902861981, 0.16429646904639772, 0.19502382977708654, 0.21468548823411557, 0.26510515339808566, 0.4121092848683291, 0.24137856300787749, 0.039245063706659693, 0.01328784964664576, 0.063938494959291103, -0.056808918829038463, -0.039159725623022792, 0.028736615885883075, 0.075674855852819814, 0.10715382591497533, 0.29941075202959372, 0.24751816611443234, -0.14971685838339424, 0.92725020353048182, -0.58030730777587713, 1.4965419400087898, -0.58030730777587824, 0.92725020353048315, -0.1497168583833956, 0.24751816611443228, 0.29941075202959394, 0.10715382591497527, 0.075674855852819592, 0.028736615885883075, -0.039159725623022994, -0.05680891882903847, 0.063938494959291325, 0.013287849646645755, 0.039245063706659422, 0.24137856300787733, 0.41210928486832976, 0.32671351148908501, 0.21468548823411696, 0.19502382977708541, 0.16429646904639761, 0.079293556902861592, -0.047148908802460261, -0.025752917138555938, -0.072469006265442351, -0.031588472981034621, 0.054188690404279302, 0.15194580903531177, 0.25020565573121106, 0.20124367647634361, 0.22595605005106811, -0.25696609936231096, 1.007232617737484, -1.1019114795534584, 0.88488899182435599, 0.37680556076813088, 0.55596569261967799, 0.086653868373653353, -0.011289471903383815, 0.13859711550376486, 0.11598544099090989, 0.042088106914846005, -0.033255690840710936, -0.018180464473218153, -0.0063191769526928735, 0.018970981025801085, 0.14853499339159881, 0.2941247685173069, 0.21720864831216452, 0.24623032442851894, 0.083105673180647877, 0.11648035795043606, 0.096318218677932249, 0.016058491686644111, 0.0059924400617863598, -0.065825070508153657, -0.014992917126512623, -0.027056960212979545, -0.0025387166530475712, 0.18880277280085703, 0.41335445680082034, 0.34310308052214539, -0.18837022473973905, 0.66450815180220979, 0.059297195869561843, 1.3210609586317497, -0.34409429931737384, 0.2988664581273206, 0.17592824054988909, 0.030490864773296485, 0.19212485777257224, 0.06099491151048541, 0.082583919156513072, 0.052605242734811722, 0.021461267056132546, -0.040937983123008163, -0.0094839753900352007, 0.017160725214558203, -0.030460558403777944, 0.14931322115435064, 0.32220608581938709, 0.093695296747697082, 0.1237530010842532, 0.017390054254405134, -0.0087203787935278762, 0.012627431507206037, -0.024390993371714388, -0.010772744125100247, -0.026732920924662094, -0.0055435803643169856, -0.0035899004350241582, 0.028050860562230339, 0.16015106243072863, -0.0093468845104915464, -0.23826829822592965, -0.51467834215318398, 1.3060302403517683, 0.3628700351691248, 0.5071563706514024, 0.31944609486771208, -0.24133125024592691, 0.14786394857966259, 0.0062621769249767058, 0.073910230197787502, 0.038178927860434683, 0.026154427883432977, -0.015197940538429256, 0.015692601846482655, 0.031051039914505491, 0.0075790364114048233, 0.097917377942654316, 0.16574720488241704, 0.10174972110658852, 0.10180457538537414, -0.027988212781709362, -9.6207917787273747e-05, 0.0051215906448293215, -0.029333520957471861, 0.025701507905379183, -0.0089673934626627958, 0.01177654442566399, 0.0046349096026104134, -0.021402902917041607, 0.03418607642912222, 0.030098075283007585, -0.1169011010733573, 0.15345959634626896, 0.097636377242582312, -0.21337246968950468, 0.70940599530087356, 0.18053751384272154, -0.12662108035586525, -0.033729052458342325, -0.1068205495440398, 0.082742536159359198, 0.021312770128680637, -0.02966274712552271, -0.015675575409266458, 0.03599616230766798, 0.020763503842579301, -0.0083456425459010053, -0.012539173975430275, 0.001814606870208027, 0.063246459754600651, 0.097647442588889521, -0.013402803779000846, 0.061296263921273318, -0.018258671855796015, -0.027490450999295389, -0.010113005489671634, -0.011441752446030721, 0.031629106230310081, 0.016637976300589583, -0.010024579181759814, -0.0099079010405707553, -0.060258932305754062, -0.041981936023927795, -0.036493858716967892, 0.13137374163691345, 0.17992639617179582, 0.34586223870135102, 0.3396306093743105, 0.26383919410790552, 0.24501510040664315, -0.19173261262163757, 0.099241248305728891, 0.015060609589555881, -0.015609494504012908, 0.015223562704661735, 0.0021732333351695459, -0.013294834505552418, 0.02039605162072387, 0.032140257903604141, -0.0021144243161752658, -0.0076636494655425496, 0.037573591582025015, -0.0036013299995066783, -0.027574493612477238, -0.078529066256990701, 0.00059474001274650921, 0.016458612619479316, 0.015845305908809258, -0.0020268100930258088, -0.013696041496545191, 0.0088012977267581446, 0.016542589455127047, -0.0048974001169365296, -0.019737461729970797, -0.042341618007146614, -0.081510896741027863, 0.044986403519810654, 0.062598270207453191, 0.16404233417264671, 0.091411128665944058, 0.36951320092864953, 0.059080455669845232, -0.070830818977105567, -0.033232550782043346, -0.0028057606437617323, 0.0078373508878121518, -0.0029827434432791976, -0.021766544372719729, 0.023522054710864829, 0.031698488621629953, -0.030135000999364715, -0.019759750092557201, 0.019592990080295483, -0.021337213333244086, -0.032810042710946043, 0.035098396968265562, 0.065700689463788264, -0.019619112630341284, -0.032528933027315937, -0.001416656453182401, 0.056425701741664544, 0.028455863356249663, -0.0097375289490629503, -0.0052561866064455114, 0.0013100558771970501, 0.0080320798501610554, -0.027972147033301621, -0.021419082531907708, -0.025936972009880058, 0.027359429809612409, 0.13624403896529816, 0.12236977033819048, 0.040092306883550463, 0.11452944472315811, -0.062769573271967, -0.065313535534231998, -0.010769778858653123, 0.0064307243224230766, 0.0010521231241173155, 0.012579825412037126, 0.0088191619820226965, -0.040811004345713484, 0.019887732012021993, 0.014257984954846677, -0.022459274904977573, 0.040747896169171828, 0.070242479721293896, 0.055053359776043469, 0.072952972838101038, 0.11130862970905199, 0.055652716802045553, -0.080036865363297377, -0.074182732572421722, 0.032824623168326919, 0.031865879706987767, -0.016758259649352489, -0.0024069559974744621, 0.021075876818278654, 0.014396940553395566, -0.048207693014304456, -0.077682201861009201, -0.015232023889946197, 0.016377276604451121, -0.095289423698368528, 0.053188940442295753, -0.007014873006770006, -0.052725469767566646, 0.011169867646763318, -0.027857672235467666, -0.015475583648045285, 0.012961699649937817, -0.0041828274568459145, -0.037569795749083312, 0.035148729718712211, -0.042406682273060839, -0.023034972903402475, 0.081701490128889429, 0.068453834537836641, 0.013361892210316275, 0.33668792873864783, 0.078872059827295921, 0.043930202648898596, 0.069824545029654933, 0.084402385062259569, 0.0024106108264623457, -0.011480544789508253, -0.033818612421867275, -0.031667371615742741, -0.00502827741655568, 0.027023228844142416, -0.014247675993027993, -0.0090012900880712381, -0.061888601165125297, -0.098942005293094756, 0.01263323283761883, 0.12573571356763666, -0.076732726183971922, -0.11419210623041808, -0.037690963997301666, -0.039023576316775249, -0.037907101781325052, 0.0040436237493623132, 0.041915865623990772, -0.0086885172531639947, -0.0046973120649884377, -0.092543539386828647, -0.011130337821465186, 0.098161425946316272, -0.016521364547457937, -0.019122146869457519, 0.34253529215971379, 0.37107135970432042, 0.86635491100693385, 0.069575788839216376, -0.077933249962103462, -0.23382813425811527, -0.09863825695148333, -0.028452880392854651, 0.02313090978794155, -0.065286881502250455, -0.0065163090427018816, 0.035245400387964018, 0.064871673248635159, -0.009910405282542379, -0.074442233736364327, -0.088464389222228296, -0.043746931993730226, 0.025650630137194336, -0.019555697374510583, -0.11757758027246727, -0.088395093514236453, 0.00060518848897882292, -0.023883294001795972, 0.0052157631901946491, 0.017696001575747886, 0.038292630722847568, -0.064152245495751242, -0.00046677178847581285, 0.13417678111594261, -0.015474080963115183, -0.27741376367012288, 0.10645611255411111, 0.49136473213042497, 0.64566220514793704, -0.34894672904561197, -0.22930577035731828, 0.065707150130888653, 0.074931291451028587, 0.010801205387038527, -0.067411320951837883, -0.12930461632538409, -0.0036267311717218076, 0.039023237394102503, 0.049868939755416578, 0.0028129255950110478, -0.048592759447364742, -0.098206750946425017, -0.21167593067635238, -0.24661106106331246, 0.17003550871316073, 0.14319521757460188, -0.18791450411345456, 0.0079365608693964147, -0.026343653609827478, -0.0064127815367698198, -0.021569631345745438, 0.090706510487419845, 0.023928227792328456, -0.030645866021173446, 0.0081944297873781744, 0.27230784814155318, -0.030140868003777244, -0.55369429571770845, -0.33461208848408441, 0.40042515638418175, 0.54787745216002603, 1.7521122327973908, 0.02630887865012415, -0.7903386881329546, -0.30506910575481899, -0.058122663069862322, -0.1512000567754718, 0.030805208457151921, -0.056922369420476453, 0.018910842473248434, 0.041026550164896362, 0.10973045554309671, -0.029240486244660805, -0.3163922398944391, -0.13757198545862218, 0.12706805404252669, -0.072057201177643526, -0.070445625631504319, 0.11232623315704422, 0.053944973270972273, 0.078972221527521536, -0.00416350617181658, -0.043614575991677791, -0.077748186566067592, 0.049219693586430378, 0.042416802273341318, 0.12644205243911066, 0.39096527623299887, -0.40370312470951558, -0.48770772267188234, 0.54473301805335006, 0.92898941300038107, 0.71512595047089234, 0.74385331371246577, 1.2482467538506357, -0.57166836623813888, -0.43281940369171401, 0.023943010115746077, 0.00030176170486927514, -0.24679227625704431, 0.16824405476099039, 0.092929862040844205, -0.029175915115095267, -0.081210816145377299, 0.032535239746583337, -0.018421573557966798, -0.18224178792918325, -0.29052216822588622, 0.17110516400703951, 0.22815908460498383, -0.15890945005602886, 0.0062170702455973175, -0.044853168166470177, 0.0080331646697508995, -0.0842632097276826, -0.016095705887684088, -7.820006368420517e-05, -0.097923922056211893, 0.48676804973393806, 0.35484595526186524, 0.18102793706565945, -1.0939934957719641, 0.9231011957591454, 0.49108674920037432, -1.6725083187014362, 0.56577881124465212, 1.7716903674840145, -0.31724338121882639, -0.46946217188769945, 0.46804088594167398, 0.2495599910064237, 0.21965961682575341, -0.28426475792188616, -0.12974774398976752, -0.086262426064739897, 0.084703474730633041, 0.12060535717228706, -0.33186051211466344, -0.10830858623812538, 0.17740469505624151, -0.0043101841409599814, -0.33866696253627121, 0.0393969525618715, -0.26339593722715154, 0.13598013030776659, 0.10364961453623139, -0.011168077595515221, -0.18224776807046214, -0.12296413131763473, 0.21989373735679868, 0.16380771710007386, 0.67271651276019118, -0.16319024909703136, 0.98390492917013062, 2.2217962254133496, -0.66077224091757802, 1.5638480130127614, -1.0129349058609651, 0.99232752650122769, 1.5155025161072819, 0.58675004339129688, 0.16801904131477496, 0.31725814504248523, -0.071714399164359219, 0.13832330176015895, -0.060442748560523389, -0.043434328775720558, -0.19718551141955432, -0.36586758725441343, -0.15612863751307984, -0.72499416196393318, -0.11056584899062098, 0.082780177430082938, -0.10585857030502534, -0.49717312826403764, 0.060297128338251849, -0.1741288940590143, 0.034503572794408806, -0.022140372568936324, 0.14950061311078439, 0.29242994865853189, -0.29100003355994419, 0.22751157962613949, -0.11471557758718894, 0.25575295594566499, 0.66007876209063321, -0.28144140655806837, -1.050216159001623], "bottom": {"real": [5837.242024063461, 16421.190569053251, 8527.2275182117319, 3938.41845467232, 969.21000043764093, 269.87346390668256, 193.53992011404216, 135.14631901451781, 58.523829955616236, 29.311524302602624, 20.863281166035843, 14.808244655557742, 11.401757474781434, 9.6386493936653288, 8.0538591094176777, 7.4714398062124641, 7.2711776175262477, 7.4714398062124241, 8.0538591094176653, 9.638649393665327, 11.401757474781416, 14.808244655557761, 20.863281166035858, 29.311524302602734, 58.523829955616236, 135.14631901451779, 193.53992011404216, 269.87346390668273, 969.21000043764059, 3938.4184546723186, 8527.2275182117301, 16421.190569053259, 14982.474506443205, 4755.1985786680198, 3083.8642011691682, 1502.8058566448747, 596.26851293203197, 262.35520536881347, 201.52671733896852, 108.13603201941604, 57.999252895466505, 28.992297197792773, 19.233600066307524, 13.871180161098291, 10.761421361485239, 8.8506828512506655, 7.8125584926262617, 7.1234501229356377, 6.6618841738486525, 7.1762884709606958, 8.1416889804019927, 8.8663632607744063, 11.328672883224474, 14.773155762512141, 20.058056528572401, 28.688344099071909, 57.995376649220766, 126.94075502116374, 211.30702516808583, 262.54448595536269, 752.96024761972672, 2141.5368023327851, 3891.3661973657881, 5583.5460990085166, 9500.6528086677681, 4225.3848573287933, 1708.1934289355966, 562.9450489663958, 526.41420210821127, 290.26438540271903, 151.34732218304231, 89.304597077577796, 50.161041673414204, 27.913649363990057, 19.253723232543383, 14.310501425792925, 10.622538104620221, 8.6520747616015274, 7.6796432895344049, 6.9311889072641995, 6.5442165971044535, 6.8352472963781299, 7.2531587818267287, 8.8125700197174819, 10.256278085266516, 13.962876672312342, 18.680978544191657, 27.641611280844351, 51.70590284164593, 92.383035108628647, 175.23999552329536, 238.6238705323166, 446.2130896894364, 589.84950644143407, 1459.800700420838, 2983.6421667816849, 6639.6980670311659, 3615.9230624353354, 1045.9683029029898, 541.95698246733389, 551.2292078912385, 269.01748102372522, 121.81702466062521, 78.619304368994548, 46.266475261147157, 26.895860643920866, 18.966790938143397, 14.141216689343503, 10.624588727031869, 8.5120674584469107, 7.5084078178458054, 7.127942028564302, 6.5505226441602824, 6.5976614570745582, 7.5671769464103935, 8.4293753366132105, 10.446992271959362, 13.755112829750516, 18.515159362788847, 25.868606557166544, 43.593025933023839, 76.847860046206122, 125.03651194390009, 241.77755195523335, 523.08499299660048, 633.36555854289827, 855.69476790230692, 2473.0066947172836, 2803.9496552692158, 1850.6397468329815, 645.77314636959022, 447.00563976857688, 381.6372474267435, 196.7755433249871, 93.586816816137713, 72.612365740746853, 43.711482900929944, 27.782222145016455, 18.647268962291367, 13.844325818813939, 10.350953817244738, 8.7140342291788997, 7.3516641952705921, 6.886474159529909, 6.1226840838853605, 6.7186507131414492, 7.0148796268173141, 7.9020046012660439, 9.6536048586555445, 13.744699851401226, 17.872279960942961, 25.025889030797831, 38.775468597625853, 68.228616115874232, 97.806667851841851, 178.52012140604563, 362.80035213144055, 506.96305099601244, 508.39785887877764, 1271.7627571663681, 1970.0713813014595, 1211.9708052435174, 448.82610946730466, 388.91483700385658, 294.26646682781944, 147.68595350614527, 76.563818921604266, 57.53338100926053, 37.094893522892434, 25.168957624787666, 17.405368368923924, 12.931100650610183, 10.211256703797424, 8.3783082007702649, 6.8845647672161352, 6.2954630311895761, 6.1711525716900475, 6.2852637654745882, 7.1318002457288037, 7.8126464614985656, 9.3562580058102185, 12.456351018938477, 17.12365920646733, 22.851195586808732, 34.22708028584924, 57.273965595477058, 82.126801795962663, 114.0182287640494, 248.69630423497404, 396.25330408596494, 382.77662480077174, 646.86127060880278, 1066.1959535576209, 770.74521634546068, 344.77171326148743, 328.21152488387929, 223.6732358532505, 124.39997807543456, 66.042124980023658, 49.833499278727395, 36.080812354502541, 24.010000461569632, 16.241873057458708, 11.94801819096188, 9.663620823552634, 8.1734814269274114, 6.8263151892657215, 6.1094005534487641, 5.5560364128866686, 6.0895161225652297, 6.7371553850929349, 7.5614980494024309, 9.3035460399083956, 11.904089289656403, 15.753116847312391, 22.116186781807659, 33.401673308199264, 45.775772578430164, 60.542807604917392, 91.412240599681226, 164.58197575163385, 289.97996145010069, 367.09809735899603, 433.51729458889321, 538.99714678707312, 436.9735160339028, 214.45700003213321, 226.27353228768246, 190.72528880002966, 104.24105887361294, 63.096291028318397, 44.895692115573439, 34.378771692376986, 22.743616534455565, 14.943130070579064, 11.306154107321404, 9.490726177732828, 8.057539867813432, 6.6249917656310648, 5.80530835366394, 5.6727594087192097, 5.6803994552580717, 6.4512234217242401, 7.3091820969038412, 8.9053168517088785, 11.147020821533502, 13.978280110937801, 19.308076160210224, 27.380246565144393, 39.45337202937899, 53.823906577074318, 70.344986096434994, 125.18491111128095, 220.27402210338624, 239.02095964975129, 253.52805611791149, 337.90351459641266, 301.96557555412664, 163.14862666039761, 176.1964602722083, 155.2640157056349, 91.402170635856464, 57.9223709952281, 44.132906015519367, 31.477476121951593, 19.994026988386896, 14.669539930994308, 10.52228821405147, 8.9499245076841039, 7.4160858759377133, 6.0652235290917815, 5.5336836347972449, 5.3453345499720717, 5.5251998880295652, 6.049359333226362, 7.4989544637904162, 8.6441457110666775, 10.17217183387787, 12.922358897606493, 16.497840703497662, 24.473525343022239, 36.893225695749557, 46.488420049270196, 60.008949681859932, 101.55324863109907, 172.57213254679178, 186.99209153386954, 177.69050334329205, 224.71115213821386, 219.35401697656656, 131.98987419085088, 139.58612051732652, 133.97255559613592, 83.717667146076977, 52.48988401855501, 39.948149447326976, 29.992243301791387, 19.792293237610107, 13.550533437330548, 10.191515700191694, 8.7251285565258279, 7.0130966099588283, 6.0412905020539274, 5.1695609453883042, 5.2335464217738297, 5.2748937601741233, 5.9151189141762242, 6.6404924993384702, 8.2525633194354864, 9.86505065394757, 11.857247340871206, 15.821441128307118, 21.809722446513074, 33.204842604441232, 45.292100524348356, 53.588237099743992, 86.046570865333351, 138.34470513151498, 144.28338780744133, 137.47961624149846, 184.36194031651988, 195.75342807998493, 111.69248606852764, 108.22432115257934, 110.31477193613289, 70.737952758714727, 45.316084199866118, 35.221165127538775, 25.132656234698317, 17.808708328889288, 13.205138111505544, 9.8319756958291311, 8.3851869715659166, 6.6979147774695411, 5.5577949826186863, 5.0640136062157843, 4.915924071395172, 5.1747375238921238, 5.621849200313962, 6.3926522738336189, 7.8838556827841355, 9.5880495388903295, 11.2702077240605, 14.675031755421674, 19.961485602094882, 28.340133288775018, 38.071807302485439, 46.211805942072893, 70.896288173632385, 115.46517347822648, 119.73189294718243, 110.21299532100423, 137.49078682179271, 145.21239507063157, 90.736475500202033, 84.820134662984671, 87.028887735269166, 58.592780926558561, 39.140475702708279, 30.030590426700837, 23.561748558876776, 17.07171690133644, 12.059539847971436, 9.1303469917064106, 7.8824915696444915, 6.5574577163884546, 5.4508327472027114, 4.6319487889521351, 4.8556936697031698, 5.0952139895658046, 5.3626061482546099, 6.0231504777267588, 7.3929124540904754, 8.8697139145390977, 10.839689611405708, 13.484775054138881, 18.125520870461621, 25.51326521840107, 33.814821758723511, 43.000660712963757, 59.289067569698993, 89.523100480006264, 96.002834501641331, 88.248403951505949, 114.22377327036351, 136.39754784126862, 85.133937137494058, 70.757613581150778, 72.941136445046624, 50.417131404641061, 35.29732697897046, 27.270836476117434, 20.337170678571646, 15.328073102208975, 11.227626008224609, 8.8894703399043831, 7.3066732490559749, 6.1117570010797007, 5.2240396800825373, 4.6927944754047974, 4.4462691956761722, 4.8997943453914665, 5.030120352863074, 5.8504059853355139, 6.9021030785339024, 8.6936481048417669, 10.014300550884089, 12.783989981758968, 16.915182814597465, 23.037925870268026, 29.781501040175886, 36.137786628939317, 46.659613314406016, 72.542096884400053, 80.098309124706176, 76.772569487169434, 87.96931966600367, 100.35528192635977, 66.390743706670477, 56.297220892995071, 57.449776912893739, 42.311817158751616, 30.3950154293208, 24.633397231162515, 18.800000277532757, 13.906344724637259, 10.685561612392762, 8.7726633553262534, 7.3765778222647702, 6.0238006847876884, 5.2082074327498917, 4.5886719664559399, 4.6166410353959701, 4.6115148269570563, 4.9920772309179853, 5.6445124723515159, 6.7980683034043956, 7.4975962005340229, 9.6066586869080837, 12.06652313244911, 16.251663826300451, 21.003823940677318, 27.622933573071261, 33.836788273738165, 41.877854423447168, 58.532835369703733, 68.239320296767971, 62.326149739008642, 71.583830955139561, 81.611391861674278, 61.290606958364052, 49.963935495056425, 49.744027747354536, 38.555965139546075, 28.313241453630848, 22.404376161451804, 17.69007471646092, 13.348861556136391, 10.46674681432143, 8.1507364253451371, 6.7804933363165576, 5.7303247473649055, 4.9737961537641029, 4.6591603640435002, 4.3691273542401863, 4.5876440856805019, 4.8775279419312838, 5.5643157824289267, 6.5106424514611394, 7.6517258774697732, 9.3978270674435489, 12.208065227131403, 15.316902707006163, 20.982661610009878, 26.317869298031479, 32.313264556083666, 38.062860113666069, 50.105167484748129, 58.219661124046276, 59.861157680092496, 61.019020366450448, 69.642805168222978, 57.634563900118565, 46.967523109902231, 43.85887184820529, 34.957640557066753, 26.505039983640941, 21.71545909517323, 16.236775633007202, 12.875777825381771, 9.9834739610997616, 7.8930497070448, 6.6829715569803687, 5.6672193704500122, 5.0794246915518446, 4.681264046528276, 4.6186632297539427, 4.6211092904368423, 5.0897865773957403, 5.5691810710797096, 6.5035187317991277, 7.2014326998593701, 9.1703620437944053, 12.475838151915292, 15.6623920524898, 19.528853843427893, 25.077028045409381, 30.833489267211636, 39.113296407386123, 46.770991427918581, 55.937485646720255, 57.570245344451905, 57.637817589030213, 59.860391566610879, 52.776195682327739, 43.839296967027423, 39.833012832197511, 33.598213438023812, 26.072700016436322, 20.276975501521189, 16.195672497297036, 12.239826665071417, 9.6875213487165066, 7.7379543893933631, 6.3786782254807157, 5.5950259327840586, 5.1232903828272987, 4.5786592309737237, 4.5178908466513406, 4.578659230973722, 5.1232903828272978, 5.5950259327840595, 6.3786782254807148, 7.7379543893933684, 9.6875213487165084, 12.239826665071421, 16.195672497297036, 20.276975501521182, 26.072700016436304, 33.598213438023805, 39.833012832197511, 43.839296967027416, 52.776195682327739, 59.860391566610836, 61.019020366450441, 57.570245344451919, 55.937485646720255, 46.770991427918517, 39.113296407386116, 30.833489267211636, 25.077028045409371, 19.528853843427893, 15.662392052489803, 12.475838151915296, 9.1703620437944, 7.2014326998593674, 6.5035187317991294, 5.5691810710797114, 5.0897865773957385, 4.6211092904368405, 4.6186632297539418, 4.6812640465282733, 5.0794246915518446, 5.6672193704500087, 6.6829715569803696, 7.8930497070447982, 9.9834739610997651, 12.875777825381764, 16.236775633007209, 21.715459095173252, 26.505039983640959, 34.957640557066775, 43.858871848205247, 46.967523109902238, 57.634563900118593, 69.642805168222949, 71.583830955139618, 59.861157680092482, 58.21966112404624, 50.105167484748137, 38.062860113666083, 32.313264556083666, 26.317869298031482, 20.982661610009867, 15.316902707006161, 12.208065227131399, 9.3978270674435436, 7.6517258774697732, 6.5106424514611394, 5.5643157824289284, 4.8775279419312856, 4.587644085680501, 4.3691273542401872, 4.6591603640434966, 4.973796153764102, 5.7303247473649037, 6.7804933363165594, 8.1507364253451371, 10.466746814321423, 13.348861556136386, 17.69007471646092, 22.404376161451779, 28.313241453630852, 38.555965139546039, 49.744027747354508, 49.963935495056418, 61.290606958364073, 81.611391861674235, 87.969319666003628, 62.326149739008663, 68.239320296767957, 58.532835369703712, 41.877854423447168, 33.836788273738158, 27.622933573071283, 21.003823940677311, 16.251663826300444, 12.066523132449106, 9.6066586869080837, 7.4975962005340202, 6.7980683034043929, 5.6445124723515194, 4.9920772309179844, 4.6115148269570598, 4.6166410353959719, 4.5886719664559372, 5.2082074327498908, 6.0238006847876866, 7.3765778222647711, 8.7726633553262587, 10.685561612392764, 13.906344724637258, 18.80000027753276, 24.633397231162533, 30.395015429320793, 42.311817158751609, 57.449776912893732, 56.297220892995028, 66.390743706670506, 100.35528192635975, 114.22377327036349, 76.772569487169449, 80.098309124706219, 72.542096884400053, 46.659613314406002, 36.137786628939317, 29.781501040175893, 23.037925870268033, 16.915182814597468, 12.783989981758975, 10.014300550884082, 8.6936481048417651, 6.9021030785339006, 5.8504059853355228, 5.0301203528630678, 4.8997943453914612, 4.4462691956761731, 4.6927944754048019, 5.2240396800825328, 6.1117570010797033, 7.3066732490559732, 8.8894703399043813, 11.227626008224609, 15.32807310220897, 20.337170678571649, 27.270836476117438, 35.297326978970467, 50.417131404641083, 72.941136445046638, 70.757613581150821, 85.133937137494073, 136.39754784126856, 137.49078682179265, 88.248403951506006, 96.002834501641317, 89.523100480006221, 59.289067569698972, 43.000660712963743, 33.814821758723504, 25.51326521840107, 18.125520870461624, 13.484775054138884, 10.839689611405714, 8.8697139145391013, 7.3929124540904745, 6.0231504777267606, 5.362606148254609, 5.0952139895658073, 4.8556936697031734, 4.6319487889521325, 5.4508327472027096, 6.5574577163884502, 7.8824915696444933, 9.1303469917064124, 12.059539847971436, 17.071716901336433, 23.561748558876776, 30.030590426700826, 39.140475702708279, 58.592780926558504, 87.028887735269151, 84.820134662984628, 90.73647550020199, 145.21239507063157, 184.36194031652002, 110.2129953210042, 119.73189294718252, 115.4651734782265, 70.896288173632399, 46.211805942072878, 38.071807302485439, 28.340133288775018, 19.961485602094882, 14.675031755421674, 11.270207724060505, 9.5880495388903277, 7.8838556827841364, 6.3926522738336233, 5.6218492003139611, 5.1747375238921247, 4.9159240713951746, 5.0640136062157861, 5.5577949826186863, 6.697914777469534, 8.3851869715659184, 9.8319756958291471, 13.205138111505548, 17.808708328889303, 25.13265623469832, 35.221165127538775, 45.316084199866097, 70.737952758714712, 110.3147719361329, 108.22432115257941, 111.69248606852767, 195.75342807998487, 224.71115213821398, 137.47961624149852, 144.28338780744139, 138.3447051315149, 86.046570865333337, 53.588237099743992, 45.292100524348342, 33.204842604441232, 21.809722446513071, 15.82144112830712, 11.857247340871208, 9.86505065394757, 8.2525633194354864, 6.640492499338464, 5.9151189141762242, 5.2748937601741233, 5.2335464217738297, 5.1695609453883096, 6.0412905020539247, 7.0130966099588328, 8.725128556525835, 10.191515700191694, 13.550533437330545, 19.792293237610103, 29.992243301791408, 39.948149447327012, 52.489884018555003, 83.717667146076963, 133.97255559613592, 139.58612051732649, 131.98987419085091, 219.35401697656653, 337.90351459641266, 177.69050334329216, 186.99209153386957, 172.57213254679186, 101.55324863109904, 60.008949681859939, 46.488420049270182, 36.893225695749557, 24.473525343022239, 16.497840703497666, 12.922358897606497, 10.172171833877869, 8.6441457110666775, 7.4989544637904126, 6.0493593332263602, 5.5251998880295634, 5.3453345499720717, 5.5336836347972458, 6.0652235290917806, 7.4160858759377133, 8.949924507684111, 10.522288214051471, 14.669539930994311, 19.994026988386889, 31.477476121951593, 44.13290601551936, 57.922370995228107, 91.402170635856407, 155.2640157056349, 176.1964602722083, 163.14862666039767, 301.96557555412653, 538.99714678707278, 253.5280561179116, 239.02095964975135, 220.2740221033861, 125.18491111128091, 70.344986096434923, 53.823906577074332, 39.453372029378947, 27.380246565144397, 19.308076160210238, 13.978280110937792, 11.147020821533506, 8.9053168517088821, 7.3091820969038439, 6.4512234217242392, 5.6803994552580681, 5.6727594087192079, 5.8053083536639392, 6.6249917656310666, 8.0575398678134302, 9.4907261777328298, 11.306154107321403, 14.943130070579077, 22.743616534455558, 34.378771692377001, 44.895692115573446, 63.09629102831839, 104.241058873613, 190.72528880002952, 226.27353228768243, 214.45700003213315, 436.97351603390234, 1066.1959535576209, 433.51729458889332, 367.09809735899597, 289.97996145010086, 164.58197575163376, 91.412240599681198, 60.542807604917364, 45.775772578430157, 33.401673308199264, 22.116186781807642, 15.753116847312398, 11.904089289656401, 9.303546039908392, 7.5614980494024362, 6.7371553850929322, 6.0895161225652297, 5.5560364128866677, 6.1094005534487605, 6.8263151892657268, 8.1734814269274096, 9.6636208235526269, 11.948018190961893, 16.241873057458722, 24.010000461569639, 36.080812354502534, 49.833499278727416, 66.042124980023658, 124.39997807543459, 223.67323585325056, 328.21152488387946, 344.77171326148749, 770.74521634546022, 1970.0713813014588, 646.86127060880301, 382.77662480077169, 396.2533040859646, 248.69630423497387, 114.01822876404945, 82.126801795962692, 57.273965595476994, 34.227080285849233, 22.851195586808739, 17.12365920646733, 12.456351018938475, 9.3562580058102167, 7.8126464614985656, 7.1318002457288037, 6.2852637654745882, 6.1711525716900475, 6.2954630311895787, 6.8845647672161387, 8.3783082007702561, 10.211256703797417, 12.931100650610194, 17.405368368923916, 25.168957624787648, 37.094893522892434, 57.533381009260523, 76.563818921604266, 147.68595350614524, 294.26646682781944, 388.91483700385658, 448.82610946730478, 1211.9708052435162, 2803.9496552692158, 1271.7627571663686, 508.39785887877753, 506.96305099601244, 362.80035213144049, 178.52012140604566, 97.806667851841823, 68.228616115874146, 38.775468597625853, 25.025889030797838, 17.872279960942965, 13.74469985140124, 9.6536048586555427, 7.9020046012660456, 7.0148796268173159, 6.7186507131414386, 6.1226840838853631, 6.8864741595299055, 7.3516641952705939, 8.7140342291789032, 10.350953817244736, 13.844325818813926, 18.64726896229136, 27.782222145016434, 43.711482900929937, 72.612365740746867, 93.586816816137656, 196.7755433249871, 381.63724742674339, 447.00563976857711, 645.77314636959011, 1850.6397468329806, 6639.698067031165, 2473.0066947172841, 855.69476790230704, 633.36555854289816, 523.0849929966007, 241.77755195523349, 125.03651194390012, 76.847860046206094, 43.593025933023853, 25.868606557166554, 18.515159362788847, 13.755112829750496, 10.44699227195936, 8.4293753366132176, 7.5671769464103917, 6.5976614570745609, 6.5505226441602797, 7.1279420285643011, 7.5084078178458018, 8.5120674584469089, 10.624588727031863, 14.141216689343507, 18.966790938143404, 26.895860643920869, 46.266475261147157, 78.619304368994577, 121.81702466062518, 269.01748102372505, 551.22920789123827, 541.95698246733446, 1045.9683029029893, 3615.9230624353345, 9500.6528086677681, 2983.6421667816867, 1459.8007004208382, 589.84950644143373, 446.2130896894364, 238.62387053231652, 175.23999552329542, 92.383035108628548, 51.705902841645944, 27.641611280844312, 18.680978544191667, 13.962876672312348, 10.256278085266519, 8.8125700197175014, 7.2531587818267402, 6.8352472963781254, 6.5442165971044517, 6.9311889072641986, 7.6796432895344058, 8.6520747616015186, 10.622538104620222, 14.310501425792921, 19.253723232543386, 27.913649363990046, 50.161041673414196, 89.304597077577839, 151.34732218304231, 290.26438540271909, 526.41420210821127, 562.94504896639603, 1708.1934289355961, 4225.3848573287914, 14982.474506443201, 5583.5460990085194, 3891.3661973657854, 2141.5368023327842, 752.9602476197266, 262.54448595536314, 211.30702516808589, 126.94075502116375, 57.995376649220773, 28.688344099071898, 20.058056528572401, 14.773155762512143, 11.328672883224492, 8.8663632607744169, 8.1416889804020052, 7.1762884709607109, 6.6618841738486552, 7.1234501229356262, 7.8125584926262608, 8.8506828512506655, 10.761421361485221, 13.871180161098282, 19.233600066307527, 28.992297197792769, 57.999252895466505, 108.13603201941609, 201.52671733896852, 262.35520536881353, 596.26851293203185, 1502.8058566448742, 3083.8642011691672, 4755.1985786680179], "imag": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]}, "imag": [0.0, -0.13871927675086548, -0.55827571496092165, -0.85383263724083092, -0.46701193383615952, 0.047809537946767316, -0.3426920474802197, 0.15831589374137059, 0.20589774809377467, -0.21944378817656213, -0.12654666933988368, -0.19544466487854822, -0.096446269450190733, -0.2265628704083768, 0.10840537931386109, -0.055457499657790024, 0.0, 0.055457499657784036, -0.10840537931384955, 0.22656287040837902, 0.096446269450189581, 0.19544466487854698, 0.1265466693398799, 0.21944378817656165, -0.20589774809377467, -0.15831589374137045, 0.34269204748022014, -0.047809537946767663, 0.46701193383615958, 0.85383263724082981, 0.55827571496092188, 0.13871927675086551, -1.279550584464304, -0.80695903119669909, -0.5066002982483182, -1.4561178571661, -0.13414323846201096, -0.25055297311154978, -0.64027404819684697, -0.19951473048424853, 0.33137912963317689, -0.047498243759329373, -0.24064979253244873, 0.1395435157196932, 0.17789090203786645, -0.044374683774468404, -0.36806933922228663, 0.19528135326361654, 0.32999646269142918, -0.13015393203002068, 0.1959681784626765, 0.28571835588367483, 0.22705801052414751, -0.14508578389537852, 0.23457709892354506, 0.21163882649779878, -0.20150153854805303, 0.060946718066345364, 0.31004041285864392, -0.26258387187077481, 0.13955938857309563, -0.2449447076348287, 0.068510051090992716, -1.1758121586434307, -1.3682011726001491, -1.6899938281650106, -0.75019268688655194, 0.68911282851752931, 0.44086751164178845, -0.23155959034339019, -0.54510315877084203, 0.26585764990704713, 0.2624959582084973, -0.045146091846171167, 0.011517786678353055, -0.057907844320373422, 0.076854124253010955, 0.0035092112107953564, -0.23588030048916386, -0.048277840380711062, -0.21489820671404902, 0.26817287178185911, -0.027468417557455105, 0.29873174456545087, 0.072899207479288589, 0.023829771073631354, 0.0066491170121291982, 0.0048298736467919092, -0.13057930804766787, -0.26946209593128789, 0.39240115086507854, 0.85317721061416651, -0.11752989424299426, 0.99998707389668307, 0.55787436167296656, -1.0314907737559058, -1.5043263157657751, -1.3830149751777026, -0.20446853801739454, -0.28364033101911829, 0.68303147161529054, 0.03902721990981517, -0.18273076418691683, -0.013466871818696777, 0.028891896132398606, -0.068621242214500722, -0.026792869524675422, 0.18842973810535804, 0.068392282535087487, -0.17097210848547728, -0.23288712244734344, -0.31416612358708279, 0.27284169211913839, -0.072438990225411531, 0.1202436118466384, 0.067443262257117789, -0.0040452326400191837, -0.15231382612170316, 0.020438609938141238, 0.10773227995476008, -0.1646961578394999, -0.034526357222664054, 0.34045699686317549, 0.3582562672018631, 0.50203282214727851, -0.90050578840564854, 1.1141651843864948, -1.0547694551235964, 0.15113295529591572, -0.42011997382980693, -1.1306687523196075, 0.59904899563122349, 0.12782476119556421, -0.26469201284371935, -0.0028564673365734715, 0.25878855026626812, 0.00078645201341040851, -0.17181320075266995, 0.013143422355015144, 0.050238396740841747, 0.072156922858987921, 0.041604673982592558, -0.0112715468909201, -0.016101389694688766, -0.31269363662275068, 0.094974334151300396, -0.067869387966968731, 0.14811752790953986, 0.010724993842567176, -0.071495661604357427, -0.037154193600070516, 0.05779163337935353, 0.094937931062917286, -0.1272883333159909, -0.017408469796284951, 0.62003762386212868, 0.074417004563971767, -0.12904495334293709, -1.4636084587609224, -0.036743730082780299, -0.77470195486186, -0.60686918965332004, 0.62872636200456622, -0.46894237369717673, -0.18368617361305525, 0.26816260026693856, 0.13447215443394772, 0.041008154934057489, -0.017107991149299187, -0.0680369475996533, -0.01240601732954733, 0.059356927461924558, 0.12615835751185028, 0.053672308552617974, 0.037749743592242362, -0.10597138547480481, 0.022172258797336697, -0.058681894939636686, 0.12792055300624736, -0.060154323470105943, 0.032298308999269151, -0.015701976416949814, 0.0007367446231764113, 0.07712597645572114, 0.055644084876628218, -0.065981740018919821, -0.14567847379973994, 0.039540586335773356, 0.24917063867041539, -0.6432675339043068, 0.36754664039982821, -0.069649876974948205, 0.2952063874323651, -0.011417685121456805, -1.0450941798657123, -0.17374602795438093, 0.19930768818407893, -0.1556206112582631, 0.055817128538076119, 0.17900936499027481, 0.0052374024484263433, -0.042596098823283683, -0.020834261928533829, 0.036686593450547957, 0.00076880260958178746, 0.061719692477810909, 0.027700064466885506, 0.10661165850403151, -0.13945785164947772, -0.050544258155460708, -0.11937846922953205, 0.034399558837173369, 0.02521789889898339, -0.0047468618190418272, -0.028256857448446509, 0.029239764799856467, 0.046539635523190424, -0.033316423902485758, -0.15842957449053302, 0.14741145606308881, 0.1752194519195491, -0.075629282019522973, -0.91968716746889456, -0.45504702044764878, -0.12177128356890227, -0.10462001130261206, 0.1804016527269576, -0.047005347129142915, -0.19200701617075638, 0.1133507155810588, 0.14315736053243958, -0.067545520465919412, -0.0022066601859379556, 0.0084001340729883862, 0.0049338006978182497, 0.016196236751475263, 0.066419574069183293, -0.012240235365542763, 0.014433128838537781, 0.023674926554515096, -0.017114978073907605, -0.14379898617791109, 0.084303725772385638, 0.0056779923265117766, 0.048321020114327755, 0.022849248448590556, 0.012395399307186424, 0.023865191872962568, -0.0060375152678495622, -0.021897165586045375, -0.092173327221095822, -0.17587869380621102, 0.091992925322100877, 0.014980171338571357, 0.0086063527817299007, 0.098130362913165001, 0.130338354535672, 0.094203305677599436, -0.19730813245926024, -0.10041080102702246, 0.075932042745803577, 0.021134287621881041, -0.059575532325244519, 0.0082992125422013917, 0.015272751179096435, 0.0090248536114060952, -0.019251438395354602, -0.015788972597383853, 0.003250945662643008, 0.032968975479440332, -0.015058032290062954, 0.017643635220692015, -0.068857003169531444, 0.030070570566209365, -0.12793975070954616, -0.043534834876013277, 0.0017423598025251587, 0.028592812647173952, 0.0036967486190428137, 0.0090453167838253218, -0.016259252101333162, -0.0052076817297827191, 0.018046490267575967, -0.026168992315517926, -0.083077034868877908, 0.032798990212655046, -0.027546636940189637, -0.12409557570816734, -0.0088356071822206419, -0.034333260533212014, 0.056177295075322577, 0.057994393113440637, -0.032566171451921935, -0.010465798382464413, 0.020079425427313443, -0.017396471253638312, -0.017870360905994483, 0.010919865739753416, 0.012363627500514531, -0.014313215415815719, 0.034201557920817111, 0.10796975372596095, 0.21064351401911494, -0.046016401957029461, -0.083803307026608195, -0.15128619138644472, -0.070745415327885988, -0.06951503451164355, 0.070638418064815661, -0.0080019035626016123, 0.02654845111893607, 0.019862790828204354, -0.0038698355762961699, -0.020866890117519677, -0.0048084432749845906, -0.0036451640963975299, -0.0026341276434262537, -0.0023099396961399252, 0.043908100663757832, 0.096772033742844044, 0.04918905117971889, 0.070600771528734244, -0.026773628633603139, -0.05973226936448265, 0.013552286601009756, 0.0032289712715403013, -0.023046337829044056, -0.010405151723131599, 0.019427096259341661, 0.018256051683800133, -0.056759870222018213, -0.032960560091393032, -0.017399004273096801, 0.12185282737260948, 0.037984234337547759, -0.12270039394272629, -0.055947445070994896, 0.04621845892784341, -0.1857137618225036, -0.063810892086947277, 0.07053672326645595, 0.03906718120738633, 0.01577517031413787, -0.0047456570119124219, -0.019801411975277249, 0.024637199092487311, 0.019457415538283646, -0.0067710516924983765, -0.028346017012320548, -0.0065098329229195291, -0.0013352981567293612, -0.023151697315085987, -0.06519950655383687, -0.1042256990435297, -0.023224778901070588, 0.0072963544312097499, -0.034708386400909293, -0.0023809918522597964, 0.016167541663812009, -0.0054340236987463174, 0.0027208109883995382, 0.0066841964011560553, -0.023932611476630623, -0.039005803210705049, 0.016396390506166533, 0.058067983872416511, 0.15112210885707694, 0.091953539825334094, -0.30878981646904202, 0.23773808023122034, -0.11496619447060334, -0.15410637679425881, 0.16398523681965352, -0.042160123131605852, -0.0057838899052936009, 0.021159112170606904, -0.00089194024953267548, -0.043632529695206895, 0.025594278576058532, 0.04827977682701759, 0.008656372871138766, -0.025123508323013247, -0.021222695138498154, 0.012727342518660707, 0.0027327273075534982, 0.016727222825244921, -0.062351999721191126, -0.095086485134993501, 0.009789315676701096, 0.020526538310240195, -0.0017729650965628652, 0.0042367342426148282, 0.0096918161659650896, -0.014518052118829046, -0.0045810353743419062, -0.069451504639382974, -0.036289590762181183, 0.22708969966074724, 0.3665342673930222, -0.59625762091850343, 0.36774772058649913, 0.2627894192943519, -0.10703484463450727, -0.13950623949894417, -0.080806137493453625, -0.018761372187400087, -0.14807112835842171, 0.015533054933596769, -0.013156170331620851, 0.033053795814988449, 0.012901798319361097, 0.00377273404398293, -0.0087050725477761486, -0.026200884444946355, -0.069983120002794802, -0.045851102565308888, -0.0080215915074989454, -0.048063119818621811, -0.055909188302307122, 0.015567334119352533, -0.069113723063989038, -0.0072474243428621863, 0.042526562044161449, 0.039806904605142766, -0.027582495505149615, 0.0049261433754253488, -0.04754279011762625, -0.074122351214929355, 0.22223052073714245, -0.0077417273670608014, -0.080825286420915882, 0.62390518555370134, -0.18988737165776209, -0.013310214088767865, -0.13538196037364333, -0.38370084094404533, -0.32853605615928166, -0.23095349816725769, 0.0024573680892555631, -0.060148519255615616, 0.030360401196840837, -0.0084214745912351684, 0.033027304906486414, 0.030739864021722699, 0.0097039926999964547, -0.060698557392036313, -0.04746519227839175, -0.053530300822357386, -0.046174234082698239, 0.0052112044634668644, 0.020596160958060543, -0.15878906772803425, -0.02193329327109424, 0.0079342423803948989, 0.027919450264392773, 0.0070430807013025284, 0.020085011074200358, -0.075935043112063852, -0.041652272773957957, 0.16889959178925665, 0.18647295463827135, 0.014154913289577202, 0.060521107576468509, -0.63637312336837226, 0.90191957381577925, 0.27922666018549325, -0.48673882008850766, -0.33370031357259311, -0.3513559741645329, -0.2622745616761345, -0.17197492325356289, -0.0057315027931728107, -0.04469091820910031, 0.053283308768024513, 0.039465599946438043, -0.014174493080162808, -0.04946368453866596, -0.022857667990750397, -0.16881304090125779, -0.080812526909499666, 0.00058234446045326367, 0.084338425974376116, -0.12518231680881081, -0.040506406338050263, -0.08374410530080309, -0.001350704062862842, 0.030200114248426838, 0.042299889130269351, 0.011310849850443803, 0.081759178445920677, 0.035289563063634108, -0.12268118169149339, 0.058157249768416797, 0.19453030659557169, -0.32019695139960919, 1.2621857571853639, 0.24947885513851267, -0.86827138009746829, -0.26346017480935824, -0.40312000272498982, -0.22820944406317872, 0.0813299683314989, 0.0038871367161771898, -0.10891614598123801, 0.00043800911235750134, -0.043289297526922212, 0.012593343881888895, -0.0042686636670869688, -0.008833188472774969, -0.024141666831206311, -0.03923653338217388, -0.25435751708422283, 0.0, 0.13106581900761921, 0.22441332039311174, -0.094768447018961463, 0.0024812204443016074, 0.036286268392045858, 0.0056698536823630895, -0.010705526315732189, 0.082044918512892334, 0.0010532751265284197, 0.015101105715477795, 0.090653505450224631, 0.27613653682211553, 0.17494988738073455, 0.30956821269851931, 0.034540476362705901, 0.0, -0.034540476362701966, -0.30956821269851847, -0.17494988738073411, -0.27613653682211575, -0.090653505450227129, -0.015101105715478274, -0.0010532751265287738, -0.082044918512892334, 0.010705526315732109, -0.0056698536823632534, -0.036286268392045982, -0.0024812204443015839, 0.094768447018961921, -0.22441332039311199, -0.13106581900761924, -0.00058234446045052997, 0.25435751708422299, 0.039236533382173068, 0.024141666831206714, 0.0088331884727747174, 0.0042686636670865837, -0.012593343881888968, 0.04328929752692242, -0.00043800911235742604, 0.1089161459812379, -0.0038871367161778295, -0.081329968331500163, 0.22820944406317803, 0.40312000272499021, 0.26346017480936107, 0.86827138009747229, -0.24947885513851314, -1.2621857571853632, 0.32019695139960752, -0.19453030659557399, -0.058157249768416672, 0.12268118169149329, -0.035289563063634503, -0.081759178445920649, -0.011310849850443772, -0.042299889130268831, -0.030200114248426623, 0.0013507040628626303, 0.083744105300802674, 0.040506406338050895, 0.12518231680881103, -0.084338425974375644, 0.046174234082696289, 0.08081252690949875, 0.16881304090125832, 0.022857667990750261, 0.04946368453866589, 0.014174493080162815, -0.039465599946438334, -0.053283308768024965, 0.044690918209100129, 0.0057315027931725314, 0.1719749232535624, 0.26227456167613394, 0.3513559741645329, 0.33370031357259339, 0.48673882008850966, -0.27922666018549408, -0.90191957381578058, 0.63637312336837637, -0.060521107576467635, -0.014154913289577215, -0.18647295463827063, -0.16889959178925743, 0.041652272773958374, 0.075935043112064518, -0.020085011074200423, -0.0070430807013025249, -0.02791945026439252, -0.0079342423803949891, 0.021933293271094115, 0.15878906772803389, -0.02059616095805995, -0.0052112044634673969, 0.008021591507499164, 0.05353030082235833, 0.047465192278390397, 0.060698557392036064, -0.0097039926999963107, -0.030739864021722747, -0.033027304906486449, 0.008421474591235165, -0.03036040119684083, 0.060148519255615165, -0.0024573680892551967, 0.23095349816725866, 0.32853605615928261, 0.38370084094404566, 0.13538196037364647, 0.01331021408876858, 0.18988737165776171, -0.62390518555369734, 0.080825286420916714, 0.0077417273670609497, -0.22223052073714233, 0.074122351214929452, 0.047542790117626306, -0.0049261433754249724, 0.027582495505149737, -0.039806904605142586, -0.042526562044161428, 0.0072474243428622999, 0.069113723063988594, -0.015567334119352927, 0.055909188302305984, 0.048063119818621922, -0.0027327273075535455, 0.045851102565308353, 0.069983120002795093, 0.026200884444945973, 0.0087050725477759057, -0.0037727340439829347, -0.012901798319361227, -0.033053795814988754, 0.013156170331620811, -0.015533054933596691, 0.14807112835842184, 0.018761372187400604, 0.080806137493454139, 0.13950623949894433, 0.10703484463450816, -0.26278941929435246, -0.36774772058649907, 0.59625762091850687, -0.36653426739302131, -0.22708969966074771, 0.036289590762181079, 0.069451504639383266, 0.0045810353743422905, 0.014518052118829408, -0.0096918161659651156, -0.0042367342426148941, 0.0017729650965627938, -0.020526538310240098, -0.0097893156767009607, 0.095086485134992974, 0.062351999721190751, -0.01672722282524514, 0.065199506553837216, -0.012727342518659639, 0.021222695138497675, 0.025123508323013449, -0.0086563728711387469, -0.048279776827017555, -0.025594278576058595, 0.04363252969520693, 0.00089194024953267417, -0.021159112170607019, 0.0057838899052937813, 0.042160123131606046, -0.16398523681965352, 0.15410637679425865, 0.11496619447060411, -0.23773808023122042, 0.30878981646904247, -0.091953539825333053, -0.15112210885707561, -0.058067983872415838, -0.016396390506166002, 0.039005803210705077, 0.023932611476630637, -0.006684196401155907, -0.0027208109883995707, 0.0054340236987462662, -0.016167541663812044, 0.0023809918522598732, 0.034708386400909043, -0.0072963544312100569, 0.023224778901069786, 0.10422569904352962, -0.049189051179719279, 0.023151697315084544, 0.0013352981567299367, 0.0065098329229194736, 0.02834601701232067, 0.0067710516924982707, -0.019457415538283694, -0.024637199092487305, 0.019801411975277225, 0.0047456570119127489, -0.015775170314137797, -0.03906718120738624, -0.070536723266456214, 0.063810892086946833, 0.18571376182250354, -0.046218458927843417, 0.055947445070994993, 0.1227003939427266, -0.037984234337547038, -0.12185282737260873, 0.01739900427309727, 0.032960560091392817, 0.056759870222018227, -0.018256051683799891, -0.019427096259341584, 0.010405151723131587, 0.023046337829044038, -0.0032289712715403299, -0.013552286601009622, 0.059732269364482463, 0.026773628633603028, -0.070600771528734632, 0.008835607182220432, -0.096772033742842878, -0.043908100663758234, 0.0023099396961402566, 0.0026341276434262424, 0.0036451640963978101, 0.004808443274984581, 0.020866890117519587, 0.0038698355762962896, -0.019862790828204292, -0.026548451118935872, 0.0080019035626017337, -0.0706384180648158, 0.069515034511643051, 0.070745415327885364, 0.15128619138644453, 0.083803307026608292, 0.046016401957029593, -0.21064351401911435, -0.10796975372596025, -0.034201557920816583, 0.01431321541581594, -0.012363627500514576, -0.010919865739753575, 0.017870360905994497, 0.017396471253638378, -0.02007942542731345, 0.01046579838246435, 0.032566171451921762, -0.05799439311344054, -0.056177295075322847, 0.034333260533212451, -0.130338354535672, 0.12409557570816747, 0.027546636940189641, -0.032798990212655137, 0.083077034868877978, 0.026168992315517999, -0.018046490267575984, 0.005207681729782772, 0.016259252101333162, -0.009045316783825131, -0.0036967486190426836, -0.028592812647173869, -0.0017423598025251908, 0.043534834876013409, 0.12793975070954686, -0.030070570566209584, 0.068857003169531444, -0.017643635220692303, 0.015058032290063167, -0.032968975479440069, -0.0032509456626426633, 0.015788972597383943, 0.019251438395354474, -0.0090248536114061126, -0.015272751179096435, -0.0082992125422014836, 0.059575532325244533, -0.021134287621881149, -0.075932042745803632, 0.10041080102702246, 0.19730813245926007, -0.094203305677599283, 0.12177128356890216, -0.098130362913164085, -0.0086063527817301141, -0.014980171338571052, -0.091992925322100572, 0.17587869380621152, 0.092173327221095724, 0.021897165586045479, 0.0060375152678496429, -0.02386519187296254, -0.012395399307185896, -0.022849248448590303, -0.048321020114327692, -0.0056779923265118269, -0.084303725772385735, 0.1437989861779114, 0.017114978073907855, -0.023674926554513819, -0.014433128838537597, 0.012240235365543381, -0.066419574069182918, -0.016196236751474646, -0.0049338006978182185, -0.0084001340729884851, 0.0022066601859378697, 0.067545520465919467, -0.1431573605324398, -0.11335071558105927, 0.19200701617075636, 0.047005347129143109, -0.18040165272695829, 0.10462001130261284, -0.2952063874323646, 0.45504702044764878, 0.91968716746889512, 0.075629282019523555, -0.17521945191954877, -0.14741145606308895, 0.15842957449053352, 0.033316423902485841, -0.046539635523190549, -0.029239764799856394, 0.028256857448446561, 0.0047468618190423398, -0.025217898898983061, -0.034399558837173737, 0.11937846922953181, 0.050544258155460854, 0.1394578516494776, -0.10661165850403005, -0.027700064466883865, -0.061719692477810832, -0.00076880260958129979, -0.036686593450547596, 0.020834261928534131, 0.042596098823283357, -0.0052374024484263546, -0.17900936499027453, -0.055817128538076279, 0.1556206112582631, -0.19930768818407885, 0.17374602795438115, 1.0450941798657116, 0.011417685121456564, 0.77470195486186011, 0.069649876974948843, -0.36754664039982721, 0.64326753390430735, -0.24917063867041553, -0.039540586335773169, 0.14567847379973992, 0.065981740018920196, -0.055644084876628218, -0.07712597645572139, -0.00073674462317611055, 0.015701976416950342, -0.032298308999268784, 0.060154323470106401, -0.12792055300624763, 0.058681894939637193, -0.022172258797336572, 0.105971385474807, -0.037749743592242278, -0.053672308552617946, -0.12615835751184992, -0.059356927461923663, 0.012406017329547145, 0.068036947599653702, 0.017107991149299284, -0.041008154934057878, -0.13447215443394772, -0.26816260026693878, 0.18368617361305564, 0.46894237369717728, -0.62872636200456533, 0.60686918965331993, -0.15113295529591578, 0.036743730082780514, 1.463608458760923, 0.12904495334293731, -0.074417004563971351, -0.62003762386212891, 0.017408469796284774, 0.1272883333159911, -0.094937931062917147, -0.057791633379354237, 0.037154193600070003, 0.071495661604358593, -0.010724993842566222, -0.14811752790953939, 0.067869387966970118, -0.094974334151300438, 0.31269363662275046, 0.01610138969469304, 0.011271546890921311, -0.0416046739825933, -0.072156922858987255, -0.050238396740841143, -0.013143422355014638, 0.17181320075266959, -0.00078645201341033847, -0.2587885502662679, 0.0028564673365731054, 0.26469201284371935, -0.12782476119556443, -0.59904899563122194, 1.130668752319608, 0.4201199738298067, 1.5043263157657745, 1.0547694551235969, -1.1141651843864939, 0.90050578840564954, -0.50203282214727829, -0.35825626720186354, -0.34045699686317654, 0.034526357222664658, 0.16469615783949973, -0.10773227995476188, -0.020438609938140839, 0.15231382612170388, 0.0040452326400209297, -0.067443262257115694, -0.120243611846639, 0.072438990225412794, -0.27284169211913811, 0.31416612358708496, 0.23288712244734694, 0.17097210848547523, -0.068392282535087695, -0.1884297381053561, 0.026792869524674363, 0.068621242214500999, -0.028891896132398506, 0.01346687181869554, 0.18273076418691644, -0.039027219909814823, -0.68303147161529132, 0.28364033101911773, 0.20446853801739462, 1.3830149751777017, 1.3682011726001495, 1.0314907737559074, -0.55787436167296611, -0.99998707389668362, 0.11752989424299397, -0.85317721061416762, -0.39240115086507799, 0.26946209593128989, 0.13057930804766765, -0.0048298736467919578, -0.0066491170121302217, -0.023829771073630532, -0.072899207479286424, -0.29873174456544577, 0.027468417557455698, -0.26817287178186705, 0.21489820671404794, 0.048277840380711166, 0.23588030048916517, -0.0035092112107956196, -0.076854124253010928, 0.057907844320372041, -0.011517786678353752, 0.045146091846170348, -0.2624959582084973, -0.26585764990704652, 0.54510315877084026, 0.23155959034339049, -0.44086751164178861, -0.68911282851752897, 0.75019268688655205, 1.6899938281650098, 1.2795505844643045, 1.1758121586434311, -0.068510051090992494, 0.24494470763482898, -0.13955938857309558, 0.26258387187077409, -0.31004041285864437, -0.060946718066343622, 0.20150153854805294, -0.21163882649779717, -0.23457709892354675, 0.14508578389537688, -0.22705801052414679, -0.2857183558836735, -0.19596817846267664, 0.13015393203001066, -0.32999646269142935, -0.19528135326362211, 0.36806933922229168, 0.044374683774465004, -0.17789090203786717, -0.13954351571969323, 0.24064979253244634, 0.047498243759330878, -0.33137912963317673, 0.19951473048424839, 0.64027404819684597, 0.25055297311154973, 0.13414323846201037, 1.4561178571660989, 0.50660029824831798, 0.80695903119669876], "height": 32, "width": 32, "top": {"real": [17750.107020847583, 6210.8656159662787, 10017.081922566327, 3457.5995074393513, 265.850218137708, -70.207684810343054, -8.882891147089472, 24.589756503786479, -11.140592103834141, -1.46746599378154, -0.34121813437428317, 1.0812077419156148, 1.7163290532419633, -4.5666146304635689, -2.6846394014203829, -2.2738643666223468, 1.917575640981823, -2.2738643666223641, -2.6846394014204122, -4.5666146304635395, 1.7163290532419744, 1.0812077419156028, -0.34121813437427356, -1.4674659937815784, -11.140592103834141, 24.589756503786372, -8.8828911470896639, -70.20768481034348, 265.8502181377076, 3457.5995074393486, 10017.081922566325, 6210.8656159662851, 23430.31298691556, -4993.9863865787011, -867.92707841112326, 991.9702295167051, 152.49743471969379, -30.096228916888641, 45.849661798659078, -31.467588946689009, 16.960718546454469, 4.334366206560186, -0.42583907131000093, 0.47860527443285728, -1.8738744001784808, 0.5336707597630499, -3.8841941455247579, -0.75407824565303971, 0.55147195392985549, -0.79345242739339283, -5.9026769793174889, -1.384293215600769, -4.1447942145798233, -2.9130522743117342, -0.87120822186396762, -1.7340023689981476, 8.0221119849442548, -9.1034799758133218, 67.038874839272566, 44.112472832699858, 441.79945796279685, 3245.5044122716786, 3861.5097933424754, -5655.7687421695537, -15889.920855591003, -2792.0170209163471, 3795.2577126849956, 553.88440852995757, -85.905664770254234, 195.26564512659746, 24.791859336013662, 19.637521614531401, -6.1680089153590449, -5.0872002952886746, -0.21502707506361318, 1.4832779566036471, 1.4444541156654906, -2.278921340791467, 0.30255454236990775, -2.3473646939882187, -0.02820677859184775, 1.2126049622480428, -0.78557937342030726, -2.9245439997897638, 1.236962081731878, 1.1827041713801927, -1.6114665304853286, -3.5864367039316236, -14.698165954413065, 20.29282209316159, 43.732891706759197, 111.68572777077691, -209.48016621032312, -187.12585183373633, 2586.3148393820152, 1688.0815183011628, 4748.2203910254093, 1775.7319020900284, 965.53459113591498, -592.89741380746352, 99.787886354888371, 95.459765036004825, 59.296635518443523, -7.6987106331430111, -0.0036180413118668542, -0.43290786252066471, -1.598202682681902, 0.11359872229615781, -0.47654646487314006, 0.052920121324431191, -1.1931569571302629, 1.6263047283546588, 1.1208282513608689, -1.916766911729648, -1.3790558562903064, -0.15528235781115707, 0.33989539819890602, -1.1170639390757935, -0.54019671791116586, 2.4039660385463359, 7.3342674422729397, -18.965458306286095, 0.037731231015075362, 5.7888823722245277, -226.40133474887324, -362.07505408372458, 1068.1182163210274, 1839.5542246985658, 1536.2207931138801, 1719.2247320855465, 351.77395499971544, -218.00810259302051, -154.06814929171503, 76.932404651951941, 11.83330919947551, 3.0799843602247936, 2.1514657945922595, -2.1600173905506583, -0.81329272919310069, -0.057640935991259419, 0.81743781787660708, 0.47007834357539929, 0.82578474649026179, -0.485121980563267, -0.44118347877967812, 0.85372587191033056, -0.96505091801449949, -2.5001329354507269, -0.28227610008090631, 1.5082121759974054, 0.73323799037869442, 0.47326064521443867, -2.2071915479661444, 2.1017967421924912, -14.788373732218277, -10.376064867674437, -110.67917899227207, -400.67251265606825, 13.375377575225066, 2228.271084047331, 1272.0006323499422, 485.30359922269918, -150.18264185504094, -215.33992676901764, -8.8694467345951651, 40.216044199991913, 0.62739683840663496, -1.763160286154926, 0.88761506214793773, 2.2829883187502253, -0.37542737915458396, -0.082924323502338942, -0.2690018095258665, 0.066494953017985289, -1.2937095742683771, 0.90148019848405447, 1.049315066873844, -1.5500155662664761, -1.5096304544124948, -0.76725462527686761, -0.45464639460382006, 0.03503878860161394, 0.85393872935961013, 0.89172763012310696, -0.12413241898971583, -7.4057881467564117, -5.5362761946156125, 1.231534306746803, 18.635135255424384, 26.03667534143711, -87.772888824715437, -225.72012452523001, 395.63478219787083, 378.71701677039351, 36.703056312438811, -91.050394397947159, -3.4611377608751717, 16.691588629055683, -0.030826600791664327, -3.1969308796412692, 1.3816292236713215, 0.42488100600164197, 0.084713763632908196, -0.28535803119354425, 0.0058483120842748731, -0.72249565507011926, -0.80262162213105104, -0.11947358836291604, 0.14251583505573939, -0.26639764768858409, -0.59599833623749066, -0.56289480519068613, -0.092201911820288446, 0.77223819072116529, 0.55522491064190738, -0.14411590791637013, -2.1806910872492855, 1.0588352659849944, -1.722617263430356, -9.0167440767821265, -38.483896322518888, -22.599080819691828, 25.541139705127691, 375.57983717352784, 181.47383294778024, 149.67885098073037, -4.1008782517976057, -3.7383475143657869, 18.721866312633942, -1.1602382001305473, -5.8391540939420112, -0.21088907624048864, -0.29870055099180226, 0.95331837446181378, 0.060424395643205529, -0.42858353450158043, -0.37036207729837234, -0.30369644506457261, -0.75652176347658984, -0.44545713631522388, 0.71326845215283508, 0.071761808928956311, -0.63829698193917794, -0.45235505563855871, -0.080159340308425753, -0.15881914095274483, 0.37773826228539636, -0.097086363313521495, -0.86706044290909523, -1.3342582973973045, -0.61792777020441481, 0.16957438507140327, 10.565905071599056, 15.380533375221102, 10.500239194747859, 19.996280010030237, 18.60272375866586, 4.0348314717803326, 11.168149094486143, 14.395513359675057, -3.576502394652771, -3.8760628092228431, 2.0358977627782506, -1.6580642648165547, -0.13166485139511078, 0.2591565726162201, -0.22701969228044258, -0.29312645623416966, 0.099969472199353857, -0.39101661164543228, -0.042546772814251566, 0.29433076927773894, -0.50935384874181677, 0.090487726861141621, -0.092143985882572388, -0.58253529440268437, -0.41671432281001702, 0.14644815319126417, 0.2723500443275419, -0.039709576626662156, -0.41013369223337515, 1.1756350920235048, 1.5259648698081887, -4.4516278662013118, -8.128003687892722, 9.6041080205516938, 20.813833475064627, 12.963050463991683, 7.8870012209429445, 15.407970089260955, 5.3783096889109112, -3.1350030536179672, 1.9101786820520572, 1.6649545288728531, -2.1421648847872561, 0.35230920085802159, 0.37729718445187704, 0.020823929394603979, 0.087139744957248078, -0.10976037032555666, -0.56986899401739111, -0.44020908152219312, 0.69190564661152409, 0.20725962387572397, 0.64042787368671816, 0.71867283099896739, 0.16183428074791173, -0.17223426808716463, -0.17676233483878773, -0.27594664738318686, 0.095238357444986099, 0.020726971935864241, -0.11463597101365795, -0.32333311610982368, 1.2888258236383847, 3.0237538834517612, -0.12189842989060286, -4.5002056479068653, -2.8307120360813536, 9.0325055742836575, -5.0836871456416608, -6.4226783361185662, -2.3832064029645541, 2.1204380507892151, -2.1797923249754283, -2.1316882770768921, 1.4364513793862836, 0.82847417311036753, -0.54705107713687473, -0.053118808001263999, 0.10349330090189141, -0.027586170457780668, -0.27866115184949369, -0.4744187891270259, 0.32835706009268834, 1.8712198771790323, 0.44937016780231559, 0.8488760221500451, 0.35191803530681381, 0.28758243475250972, -0.6426201464805843, -0.40597353100929789, -0.22244529364246871, -0.071869502235051647, 0.33021466122988641, 0.24942995069051274, -0.5214330526633183, -0.093662554700336673, 1.1233733739102922, 1.9003965613191238, 0.07120934753760759, -8.6549236119446178, -1.8427620371931031, -0.52295775466804406, 3.4092952720370122, -0.65003177967723336, -0.1840159964371442, 1.8831870902689825, 0.7983111628921199, -0.39925172982701851, 0.051205177403033819, 0.2598923527237304, -0.18824332097783142, 0.13750859145926242, 0.78226830313090512, -1.2572785001190825, 1.3355363328556911, 1.2220896356262305, 1.6491421999762639, 1.7622421170936717, 0.96487439834416744, 0.79128381470112286, -0.26979590260649117, -0.37236776211072153, -0.65318812250908376, -0.13360581679076858, -0.1817007191765827, 0.4244891020544192, 1.0695325895656689, -0.49200291489349485, -0.59959066580988751, -2.4610304070506381, -1.7528842523917616, 5.4092974592427554, 11.628502736704702, 13.318871722095572, 5.3844201289172418, 0.12839725172390623, -0.91462159985003533, -0.4207633568928546, 0.73289618436063231, 0.98164545606019249, -0.31879685258307294, -0.45467275635234927, 0.23929181220408463, 0.73553732103708702, -0.78050285180289647, -0.20614377250205779, -0.66147354811396541, 0.84722544756444751, 3.1542100241342745, -1.0454812204468338, 0.49112272834774079, 0.89780094097137775, -0.80686344960242362, 0.26166207514350009, 0.34234964401672252, -0.27361449647202374, 0.078400343257288022, 0.27130715748636108, -0.26706243773596255, 0.92879560872659372, -1.3686907450256593, 0.37153092475944227, -0.0077060915391855903, -2.1487270106054996, 8.2423115107991176, 10.211121947580189, 11.004080199445575, 5.512476255300478, 0.43541395104991965, 1.3138259234516578, 0.47697687525002369, -0.37437690637871951, 0.49170325146724819, 0.53092933204425685, 0.78977231856458541, 0.054935970034302541, 1.0907299238052364, -1.4537313504920895, 1.6637415256529431, 2.3271742206176285, 1.6752406948773604, 6.0227778178364675, -2.5693140331095292, -1.3449083811022362, -0.063540759326359386, 1.2007479971921078, 0.26947504329539196, -0.043317616642408706, -0.090092404474960294, -0.56149356452164179, -0.29757479536733583, -0.82531287850485402, 0.52880973840083989, -0.51042849628299192, 1.1866854822445434, 7.7130480762288167, 17.626109919920186, 26.29568713002228, 9.1514979514586194, -1.521929375229722, 0.85364359123771261, -0.365663824522519, -1.1590870007863963, 0.48082630002696519, 0.93059067445638155, 1.1024013035834523, 0.63841829574218301, 1.5659590764611497, 0.20674310541385973, 1.0081259505833966, 1.4865008399227626, -1.6031905208728288, 5.7718835709767413, 0.2720344299284404, 3.2411570780563994, -1.0481514144590243, 2.2338214812745694, 3.1628749936702945, 1.7743358086362808, -0.03099281849361625, -0.41442882712954171, -0.31459130661253104, -1.7323756021672925, 0.19363530105298493, 0.61123212270521721, 4.8260404786904152, 6.7814469674820135, 4.974801806376985, 19.935738411546794, 15.127019575257112, 16.951752765718286, 6.976320734749117, 0.83204582564536733, -0.22090351652873133, -0.48187393778382737, -0.72216259413318939, 0.68337514879437744, 1.4934027691778771, 1.3836806937153638, -0.089108362899698895, 0.57910533764344185, 3.1507795425198797, 1.9139554692796912, 4.1423990225960203, -5.0893580330573318, 4.6545320074577088, -1.3079026033800338, 1.2583901568403451, 1.3087920196200225, 1.8018391908724931, 1.3933980798910508, 0.67604933114803067, -0.49475104816844406, -1.4152366315362725, -0.64580662533466104, -1.4537653735214031, 3.1014323943375786, 7.6843087454063586, 10.909142678924193, 12.359496229531475, 15.280082473470735, 24.669023160454167, 12.739042274822818, 1.7204760023261643, 0.52929508548715176, 2.1482192005482723, -1.481161898887601, -0.79404079710432474, 0.46540881956838565, 0.92624711854277975, 1.0380549761479756, 2.3168267428989626, 1.5788387366050483, -0.83766970523004924, 4.7505720502223729, -2.6570294115495297, 6.7612131323955511, -2.6570294115495336, 4.7505720502223783, -0.83766970523005702, 1.5788387366050476, 2.3168267428989657, 1.0380549761479752, 0.9262471185427773, 0.46540881956838565, -0.79404079710432862, -1.4811618988876001, 2.148219200548279, 0.52929508548715154, 1.7204760023261518, 12.739042274822809, 24.669023160454188, 19.935738411547018, 12.35949622953156, 10.909142678924129, 7.6843087454063417, 3.101432394337563, -1.4537653735213987, -0.64580662533467093, -1.4152366315362839, -0.49475104816844562, 0.67604933114803401, 1.3933980798910552, 1.8018391908724987, 1.3087920196200247, 1.2583901568403484, -1.3079026033800301, 4.6545320074577061, -5.0893580330573203, 4.1423990225960088, 1.913955469279683, 3.1507795425198943, 0.57910533764344618, -0.089108362899694094, 1.3836806937153729, 1.4934027691778826, 0.68337514879437378, -0.72216259413318618, -0.4818739377838111, -0.22090351652873805, 0.83204582564534302, 6.976320734749093, 16.951752765718314, 15.127019575257133, 17.626109919920285, 4.9748018063769956, 6.7814469674819922, 4.8260404786903921, 0.61123212270520444, 0.19363530105297699, -1.7323756021672947, -0.31459130661253587, -0.41442882712954437, -0.030992818493609464, 1.7743358086362877, 3.162874993670298, 2.2338214812745694, -1.0481514144590143, 3.241157078056395, 0.27203442992843363, 5.7718835709767413, -1.6031905208728274, 1.4865008399227673, 1.0081259505833953, 0.20674310541386615, 1.5659590764611582, 0.63841829574219022, 1.1024013035834526, 0.93059067445638244, 0.48082630002696636, -1.1590870007863949, -0.36566382452250978, 0.85364359123770939, -1.5219293752297598, 9.1514979514585963, 26.295687130022237, 8.2423115107992349, 7.7130480762288673, 1.1866854822445243, -0.51042849628302267, 0.52880973840082446, -0.82531287850485058, -0.297574795367338, -0.56149356452165111, -0.090092404474959795, -0.043317616642408116, 0.26947504329539745, 1.2007479971921178, -0.063540759326354057, -1.3449083811022313, -2.5693140331095257, 6.0227778178364719, 1.675240694877361, 2.3271742206176271, 1.6637415256529449, -1.4537313504920832, 1.0907299238052377, 0.054935970034312817, 0.78977231856459063, 0.53092933204426229, 0.49170325146725052, -0.37437690637871607, 0.4769768752500283, 1.3138259234516545, 0.43541395104990577, 5.5124762553004887, 11.004080199445557, 10.211121947580168, 11.628502736704604, -2.1487270106054663, -0.0077060915391693741, 0.37153092475944555, -1.3686907450256616, 0.92879560872659006, -0.26706243773595856, 0.27130715748636525, 0.078400343257288438, -0.27361449647201985, 0.34234964401672396, 0.26166207514350365, -0.80686344960242218, 0.8978009409713853, 0.49112272834772974, -1.045481220446846, 3.1542100241342701, 0.84722544756444151, -0.66147354811395898, -0.20614377250205829, -0.7805028518028938, 0.73553732103708935, 0.23929181220408727, -0.45467275635235105, -0.31879685258307255, 0.98164545606019549, 0.73289618436063131, -0.42076335689285432, -0.91462159985003766, 0.12839725172388108, 5.3844201289172204, 13.318871722095585, -1.8427620371929223, 5.4092974592426515, -1.7528842523917609, -2.4610304070506088, -0.59959066580987819, -0.49200291489348996, 1.0695325895656664, 0.42448910205441354, -0.18170071917658262, -0.13360581679076522, -0.65318812250908243, -0.3723677621107227, -0.26979590260649017, 0.7912838147011273, 0.96487439834416677, 1.7622421170936722, 1.6491421999762705, 1.2220896356262196, 1.3355363328556904, -1.2572785001190749, 0.78226830313090379, 0.13750859145926628, -0.18824332097783478, 0.25989235272372874, 0.051205177403034013, -0.39925172982701423, 0.79831116289212645, 1.8831870902689678, -0.18401599643714045, -0.65003177967722925, 3.4092952720370082, -0.52295775466808114, -5.0836871456417914, -8.654923611944545, 0.071209347537571008, 1.9003965613191072, 1.1233733739103013, -0.093662554700343362, -0.52143305266331286, 0.24942995069051838, 0.33021466122988513, -0.071869502235049398, -0.22244529364246549, -0.40597353100929245, -0.64262014648058341, 0.28758243475251449, 0.35191803530680799, 0.84887602215004632, 0.44937016780231587, 1.8712198771790289, 0.32835706009269156, -0.47441878912702484, -0.27866115184949264, -0.027586170457779294, 0.1034933009018901, -0.053118808001266206, -0.54705107713687218, 0.82847417311037153, 1.4364513793862805, -2.1316882770768819, -2.1797923249754287, 2.1204380507892009, -2.3832064029645679, -6.4226783361184081, 7.8870012209433504, 9.0325055742834763, -2.8307120360814029, -4.5002056479068191, -0.12189842989059124, 3.0237538834517572, 1.2888258236383801, -0.32333311610982529, -0.11463597101365604, 0.020726971935865871, 0.09523835744498739, -0.27594664738318975, -0.17676233483878293, -0.17223426808716019, 0.16183428074791517, 0.71867283099897139, 0.64042787368672205, 0.20725962387572536, 0.69190564661152509, -0.44020908152219435, -0.56986899401739244, -0.10976037032555588, 0.087139744957248716, 0.020823929394600361, 0.37729718445187588, 0.35230920085802736, -2.142164884787245, 1.6649545288728365, 1.9101786820520659, -3.1350030536179658, 5.3783096889108455, 15.40797008926083, 18.60272375866586, 12.963050463991696, 20.813833475064644, 9.604108020551676, -8.1280036878927362, -4.4516278662013278, 1.5259648698081876, 1.1756350920235052, -0.41013369223337515, -0.039709576626662003, 0.27235004432754167, 0.14644815319126442, -0.41671432281001886, -0.58253529440268281, -0.092143985882572915, 0.090487726861142509, -0.50935384874181677, 0.29433076927773738, -0.042546772814252246, -0.39101661164543189, 0.09996947219935487, -0.29312645623417033, -0.22701969228044291, 0.2591565726162216, -0.13166485139511078, -1.6580642648165524, 2.0358977627782484, -3.8760628092228537, -3.5765023946527563, 14.395513359675084, 11.168149094486147, 4.034831471780354, 181.47383294778047, 19.996280010029963, 10.50023919474779, 15.38053337522109, 10.565905071599067, 0.16957438507140921, -0.6179277702044097, -1.3342582973973056, -0.86706044290909146, -0.097086363313522245, 0.37773826228539636, -0.1588191409527461, -0.080159340308420923, -0.45235505563855616, -0.63829698193917661, 0.071761808928958337, 0.71326845215283419, -0.44545713631521988, -0.75652176347658784, -0.30369644506457882, -0.37036207729837373, -0.42858353450157866, 0.060424395643203697, 0.953318374461814, -0.29870055099180354, -0.21088907624048941, -5.8391540939419864, -1.1602382001305538, 18.721866312633882, -3.7383475143657954, -4.100878251797706, 149.67885098073012, 395.63478219787089, 375.57983717352744, 25.541139705127598, -22.599080819691835, -38.483896322518888, -9.0167440767821709, -1.7226172634303247, 1.0588352659849967, -2.1806910872492873, -0.14411590791637696, 0.55522491064190693, 0.77223819072116739, -0.092201911820284366, -0.56289480519067914, -0.59599833623749254, -0.26639764768858487, 0.14251583505573989, -0.11947358836291141, -0.80262162213105359, -0.72249565507012325, 0.0058483120842701027, -0.28535803119354936, 0.084713763632907418, 0.42488100600164375, 1.3816292236713219, -3.1969308796412634, -0.030826600791668796, 16.691588629055648, -3.4611377608751566, -91.050394397947187, 36.703056312438633, 378.71701677039351, 1272.0006323499422, -225.72012452523026, -87.772888824715139, 26.036675341437149, 18.635135255424501, 1.2315343067468421, -5.536276194615616, -7.4057881467564011, -0.12413241898971436, 0.89172763012310496, 0.8539387293596038, 0.035038788601613982, -0.4546463946038164, -0.76725462527685828, -1.509630454412483, -1.550015566266479, 1.0493150668738473, 0.90148019848405436, -1.2937095742683813, 0.066494953017976297, -0.26900180952586789, -0.082924323502345257, -0.37542737915458746, 2.2829883187502267, 0.88761506214793962, -1.7631602861549227, 0.62739683840662275, 40.216044199991877, -8.8694467345952006, -215.33992676901772, -150.18264185504114, 485.3035992226977, 1536.2207931138814, 2228.2710840473319, 13.3753775752247, -400.67251265606865, -110.679178992272, -10.376064867674508, -14.788373732218197, 2.1017967421924983, -2.207191547966143, 0.47326064521441386, 0.73323799037869852, 1.5082121759973919, -0.28227610008090809, -2.5001329354507282, -0.96505091801449672, 0.8537258719103169, -0.44118347877968372, -0.48512198056327205, 0.82578474649025857, 0.47007834357539341, 0.81743781787659597, -0.057640935991271409, -0.81329272919311113, -2.1600173905506721, 2.1514657945922622, 3.0799843602248034, 11.833309199475522, 76.932404651952027, -154.06814929171483, -218.00810259302057, 351.77395499971459, 1719.2247320855445, 4748.2203910254084, 1839.554224698564, 1068.1182163210278, -362.07505408372486, -226.40133474887313, 5.7888823722244789, 0.037731231015098787, -18.965458306285971, 7.3342674422729388, 2.4039660385463657, -0.54019671791118873, -1.1170639390757879, 0.33989539819890108, -0.15528235781113153, -1.3790558562903272, -1.9167669117296613, 1.1208282513608707, 1.6263047283546224, -1.193156957130264, 0.052920121324427458, -0.4765464648731435, 0.11359872229612604, -1.5982026826818876, -0.43290786252068791, -0.0036180413118654109, -7.6987106331430244, 59.296635518443559, 95.459765036004427, 99.787886354888386, -592.89741380746432, 965.53459113591339, 1775.7319020900306, -15889.920855591006, 1688.0815183011607, 2586.3148393820165, -187.12585183373636, -209.48016621032366, 111.68572777077674, 43.732891706759332, 20.292822093161472, -14.698165954413049, -3.5864367039316574, -1.611466530485326, 1.1827041713801545, 1.2369620817318689, -2.9245439997897797, -0.78557937342029793, 1.2126049622479607, -0.028206778591846705, -2.3473646939882631, 0.30255454236988177, -2.278921340791416, 1.4444541156654738, 1.483277956603626, -0.21502707506361871, -5.0872002952886604, -6.168008915359052, 19.637521614531632, 24.791859336013527, 195.26564512659732, -85.905664770254006, 553.88440852995757, 3795.2577126849942, -2792.0170209163462, 23430.312986915553, -5655.7687421695537, 3861.5097933424781, 3245.5044122716772, 441.79945796279628, 44.112472832700512, 67.038874839272665, -9.1034799758128742, 8.0221119849442406, -1.7340023689979776, -0.87120822186400182, -2.9130522743116929, -4.1447942145798446, -1.3842932156007377, -5.9026769793175413, -0.7934524273933764, 0.55147195392985315, -0.75407824565312243, -3.8841941455247726, 0.53367075976302614, -1.8738744001784735, 0.47860527443281381, -0.42583907130996707, 4.3343662065600954, 16.960718546454476, -31.467588946689279, 45.849661798659248, -30.096228916889014, 152.4974347196931, 991.97022951670215, -867.92707841112428, -4993.9863865787029], "imag": [0.0, -2277.9356791272003, -4760.5440393641002, -3362.7502157108247, -452.6326365977277, 12.902525613472081, -66.324591493039264, 21.395810280639775, 12.049924797684376, -6.4322319301924828, -2.6401787430633603, -2.8941924141450355, -1.0996569736184965, -2.1837600734887777, 0.87308165169681873, -0.4143473704962265, 0.0, 0.41434737049617953, -0.87308165169672458, 2.1837600734887985, 1.0996569736184816, 2.8941924141450213, 2.6401787430632839, 6.4322319301924944, -12.049924797684376, -21.395810280639751, 66.32459149303935, -12.902525613472182, 452.63263659772764, 3362.7502157108197, 4760.5440393641011, 2277.9356791272016, -19170.834011440937, -3837.2504381898657, -1562.2865240696121, -2188.2624437144, -79.985389317630222, -65.73387671644744, -129.03232713044309, -21.574731283989859, 19.219741943874205, -1.3770831994436832, -4.6285618656089973, 1.9356332468609161, 1.914358953204174, -0.39274625271235863, -2.8755632420164114, 1.3910769799127469, 2.1983982122300691, -0.93402216187723952, 1.5955119590990243, 2.5332827335358816, 2.5722659267438073, -2.1433748844126024, 4.7051607105169868, 6.0715674792926295, -11.686157623491814, 7.736622407403881, 65.513717323045199, -68.939947660481394, 105.08267177765576, -524.55810593663, 266.59769699529215, -6565.2013915603111, -12998.804313286138, -7140.8743305075541, -1281.4742181751476, 387.93265499317204, 232.0789193763446, -67.213502175129548, -82.499903393484686, 23.742310304940581, 13.167070698799225, -1.2601921779485123, 0.22176027695648487, -0.82869028871129857, 0.81638586337482588, 0.030361957750051641, -1.8114765667849664, -0.33462283171345614, -1.4063404110660631, 1.8330278968089115, -0.19923279402973898, 2.6325944160953934, 0.74767454410312451, 0.33273215463055067, 0.1242120122414053, 0.13350548988021607, -6.7517210150420688, -24.893726268864828, 68.764375920932309, 203.58844824671789, -52.443377241039173, 589.84188198577237, 814.38538391702434, -3077.5993672243876, -9988.2725309741327, -5000.8757444384873, -213.86760970710961, -153.72085790515706, 376.50689706328353, 10.499004391497454, -22.259718007212538, -1.0587560944123571, 1.3367261976572533, -1.845627367813951, -0.50817475490747221, 2.6646257572641145, 0.72663987403826902, -1.4553261209412862, -1.7486114908592469, -2.2393579162674944, 1.7872556824974239, -0.4779279337995983, 0.90990468751900189, 0.56850457149088529, -0.042260514128558184, -2.0950938638350283, 0.37842412015856491, 2.7868839636562086, -7.1796038797667068, -2.6532766677526052, 42.569555354666804, 86.618323256686423, 262.60583525697274, -570.34935164465662, 953.3853188584327, -2608.4519239039555, 423.76919790180068, -777.49072200787271, -730.15551768721184, 267.77827954485849, 48.782690015655945, -52.084914641107339, -0.26732768536918228, 18.791248861451912, 0.034376983736590996, -4.7733525107569852, 0.2450889317389604, 0.69551673309505335, 0.74689297610787508, 0.36254455317814038, -0.082864627703290866, -0.11088180406499534, -1.9145243520823481, 0.63809937787576865, -0.47609558693404908, 1.1704253870693357, 0.1035348526676573, -0.98268640942924379, -0.66403014974353547, 1.4462870038602533, 3.6812627646537175, -8.6847068298461885, -1.7026644231740631, 110.68919188818327, 26.998515460375977, -65.421023262373453, -744.09540667092062, -46.729307478653496, -1526.2181503116453, -735.50774046161519, 282.18880697804167, -182.37864683063907, -54.052681314235201, 39.603849315110104, 10.295701682078779, 2.359337802307917, -0.63461911007383953, -1.7124190510555728, -0.21593130161202514, 0.76755040332111413, 1.2882353738829533, 0.44968314290067118, 0.25989055470659483, -0.66713893962057369, 0.13682839189736165, -0.36883118795348507, 0.91230383136371929, -0.46996446240256329, 0.30219131214854422, -0.19558932994062075, 0.012615763849470061, 1.762420772813289, 1.9045345605049635, -3.7790359077733253, -11.964107143689581, 4.5083476182968525, 61.96781696120042, -254.89688572081204, 140.68826246910922, -45.053807917761794, 314.74785574475101, -8.8001261891015723, -360.31891091191073, -57.025448777424479, 44.579795546563595, -19.359200628613657, 3.6862817789376683, 8.9206630611283089, 0.18896973496668307, -1.0227323524081069, -0.33838743748909134, 0.43833208591156991, 0.0074294169071561673, 0.50446476014305897, 0.1890893708139402, 0.65133332546862077, -0.77483290182744535, -0.30779007494077709, -0.80427129683389309, 0.26011219704759059, 0.23461588343644721, -0.056507066939534729, -0.44513357712322738, 0.64667209976975049, 1.5545017016282721, -1.5250850436867627, -9.5917712473092696, 13.475211488788412, 28.837963587037802, -21.930976284520067, -337.61540934331555, -197.27075321520147, -65.634374404237917, -45.716174186409042, 38.688397244662028, -10.636065931319841, -36.620593610799475, 11.815798616251305, 9.0326984830007095, -3.0325028906240825, -0.075862266735019127, 0.19104942819406223, 0.073726425569811863, 0.18311714867084192, 0.63036999033226249, -0.098626184449280729, 0.095619359707605045, 0.13744024889930673, -0.097089152898782338, -0.81683568275166918, 0.54386217024143169, 0.041501479859297266, 0.43031399471588661, 0.25470104821283102, 0.17326636360277617, 0.46079094226119127, -0.16530865667454481, -0.86391702025516282, -4.9611285532463629, -12.372184270457062, 11.516126179313906, 3.2997425925449804, 2.0570987009733872, 24.878800155519915, 44.041788084316849, 28.446155418037641, -32.190550839656126, -17.692027714058376, 11.789513877445387, 1.9317197634824401, -3.4507560855810171, 0.36626836712779354, 0.48074766055651602, 0.18044316667269442, -0.28240974426973131, -0.16613612027343372, 0.029095718259237995, 0.24450075339721422, -0.091330331747513635, 0.097634295479075664, -0.36806371804963284, 0.16614591312540511, -0.77395352504544712, -0.3264657443238585, 0.015061212014132833, 0.29085100346092985, 0.047770712409502418, 0.14922819541222396, -0.39792121836056477, -0.1921281774085053, 0.83895281997413806, -1.5703737430868945, -8.4367427775736452, 5.6601916863792336, -5.1510032561702124, -22.050605310259861, -1.9854594697574779, -7.5311386138630718, 7.4148341093741337, 8.0952123464619365, -4.3629732153959058, -0.87617222540110651, 1.0539667118389069, -0.69495683349647086, -0.53597221218340763, 0.21612918483653182, 0.16753374785242167, -0.14587335963051168, 0.2984129896925935, 0.75720231383362635, 1.2725586605629424, -0.23788459440434945, -0.43858849762191893, -0.79801858694486538, -0.41846754429723099, -0.46161406526582383, 0.58294801786464678, -0.078939183973068427, 0.31479155143425391, 0.31425797573231379, -0.084400039832661436, -0.69288180199641103, -0.21778449617622889, -0.19533791786522492, -0.22665765093841067, -0.31956792613405932, 6.3352095159571435, 13.304182061875538, 9.0685889178215753, 13.820343051841526, -2.9904131431626517, -6.4644843028741459, 1.4950174056035006, 0.22841081726546483, -1.0443697855595202, -0.36648156701751267, 0.48825453192442753, 0.32511669967392476, -0.74952192547288132, -0.32406742573949188, -0.14589390394899102, 0.81615985313544603, 0.21110858701983537, -0.62135646441400272, -0.27503339195756299, 0.23916839371037824, -1.0440547633891395, -0.40792084439497517, 0.55610134656922072, 0.37457806876122546, 0.17778944632276653, -0.069642667350154328, -0.39526560004564598, 0.69822150614317735, 0.740778974977921, -0.31290252683747921, -2.0096273906801638, -0.75165898775917361, -0.15987777595408992, -2.5516179078608778, -8.9643314564796608, -15.134863386021781, -2.1073345817546003, 0.61887776540407591, -3.0206322635570779, -0.13950893398737912, 0.63280527166495781, -0.16318694006603662, 0.06410706438489891, 0.11411070867346804, -0.2886162817684455, -0.35613651800395313, 0.12924440993745664, 0.38077834891929796, 0.82374133978448782, 0.42592408743381815, -1.4993887570975311, 1.2113263922466315, -0.61651842130949264, -0.92820589700907985, 1.2123284995709924, -0.37394823077908607, -0.062695571319925397, 0.28532586796592635, -0.016166881608109255, -1.1132083022635739, 0.86546596809253507, 2.0760623026361933, 0.51322827606545562, -2.2491343600113889, -2.0374388890600263, 1.1231676638159473, 0.31214242438772172, 2.2815521755579042, -5.3082712246609329, -6.7280927719717081, 0.71404381047788856, 1.0348891792697787, -0.062580928735681385, 0.11553928672311624, 0.19710411955257187, -0.22253376417909151, -0.05143415191355815, -0.61738709055352659, -0.26515618204121805, 1.3879170617746586, 1.9147895569711311, -2.7981144693643607, 1.6351053618238791, 1.2876141106871726, -0.53839815046157202, -0.81616813855627257, -0.55773229035800009, -0.16310476776122179, -1.4828287822897712, 0.19857441865721279, -0.22253902629935005, 0.76149089771667944, 0.38423492006819204, 0.13633825788919049, -0.40617531895308634, -1.9006670978622686, -5.6055295794952666, -3.5201069577585091, -0.70565394755327504, -4.8233879396582013, -3.7118525914264513, 0.87639764763224848, -3.9705679716456896, -0.3066516936670704, 1.2925955094882555, 0.98057929368147423, -0.5185509231518588, 0.068504647941653091, -0.50802141302695303, -0.65025043431383311, 1.6393007306999561, -0.046634622615140439, -0.42095485749155304, 2.8628962346767608, -0.87664183209871016, -0.061380249620325719, -0.67583720185830587, -2.165804182360429, -2.2334105499018988, -1.7315960703588726, 0.023607096501577673, -0.72578349898044647, 0.49340703388266716, -0.17688316963519096, 0.91231104952944475, 1.0401382704665323, 0.40638239361664558, -3.5528586670065754, -3.2389924588328527, -3.336337544628424, -3.3053285670589143, 0.42529364953930032, 1.2623512061316915, -7.9337267372836493, -1.0910503490681764, 0.30591237262721482, 0.79049013658839029, 0.15779582936744363, 0.35530534658354934, -1.0136463777621887, -0.43596379336607172, 1.3766560550226186, 1.2643786263280588, 0.081112249920068616, 0.30101965208538256, -2.9649644331404845, 3.940601481283172, 1.2809925361642973, -2.3740821954043603, -1.8568139214134618, -2.2875531209700912, -2.0068530505793203, -1.6161905886738603, -0.069970559948539499, -0.68452644609555957, 1.1180256373411306, 1.0386505011587546, -0.45802414484767806, -1.8827293053017495, -1.1452872829873149, -9.8282380345909921, -4.8375314158562777, 0.035534088492687292, 5.8735645683280717, -7.2148282372822923, -1.9024855757814658, -3.6729219824305321, -0.04721742712852893, 0.80045523566507781, 0.91856151213872683, 0.18365173124028911, 1.0527130168554166, 0.35231243394437906, -0.96832866520995176, 0.38866324603453256, 1.1024459216780036, -1.6264163010988006, 5.9086248051519128, 1.1522588148293589, -4.0123769411888297, -1.3409560614230069, -2.2450482885496141, -1.484164394238348, 0.58569229342098317, 0.035646451001070931, -1.3588202093923047, 0.006860270440306241, -0.84539036438792836, 0.31580363771161246, -0.13161779536446233, -0.34549511895795371, -1.1291296924180168, -2.1947930228924113, -14.643424663744323, 0.0, 7.8456512467946364, 11.843681310787776, -4.1545820919682566, 0.098834485797376734, 1.2191537903053737, 0.14782839419733967, -0.21707569483499198, 1.3287726303022269, 0.012891904979339022, 0.146292284007916, 0.70147269041246085, 1.7613861146868823, 0.97884915683286033, 1.5860078469473597, 0.15814907094033309, 0.0, -0.158149070940315, -1.5860078469473551, -0.978849156832858, -1.7613861146868832, -0.70147269041248062, -0.14629228400792066, -0.012891904979343359, -1.3287726303022269, 0.21707569483499028, -0.14782839419734384, -1.2191537903053777, -0.098834485797375804, 4.1545820919682752, -11.843681310787789, -7.8456512467946329, -0.035534088492520481, 14.643424663744339, 2.194793022892366, 1.1291296924180338, 0.34549511895794383, 0.13161779536445045, -0.31580363771161418, 0.84539036438793247, -0.0068602704403050632, 1.3588202093923036, -0.035646451001076773, -0.58569229342099216, 1.484164394238344, 2.2450482885496172, 1.3409560614230207, 4.0123769411888466, -1.1522588148293609, -5.9086248051519057, 1.6264163010987922, -1.102445921678016, -0.38866324603453178, 0.96832866520995076, -0.35231243394438311, -1.0527130168554157, -0.18365173124028866, -0.91856151213871651, -0.80045523566507271, 0.047217427128521561, 3.6729219824305099, 1.9024855757814958, 7.21482823728231, -5.8735645683280371, 3.3053285670587775, 4.8375314158562217, 9.828238034591017, 1.1452872829873084, 1.8827293053017478, 0.45802414484767828, -1.0386505011587623, -1.1180256373411397, 0.68452644609555668, 0.069970559948536071, 1.6161905886738546, 2.0068530505793158, 2.2875531209700912, 1.856813921413464, 2.3740821954043709, -1.2809925361643011, -3.9406014812831787, 2.9649644331405014, -0.30101965208537818, -0.081112249920068671, -1.2643786263280541, -1.3766560550226248, 0.43596379336607571, 1.0136463777621971, -0.35530534658355051, -0.15779582936744335, -0.79049013658838307, -0.30591237262721799, 1.0910503490681696, 7.9337267372836298, -1.2623512061316555, -0.42529364953934357, 0.70565394755329391, 3.336337544628484, 3.2389924588327594, 3.5528586670065589, -0.40638239361663953, -1.0401382704665338, -0.91231104952944642, 0.17688316963519082, -0.49340703388266682, 0.72578349898044092, -0.023607096501574151, 1.7315960703588795, 2.2334105499019046, 2.1658041823604322, 0.67583720185832141, 0.061380249620329064, 0.87664183209870872, -2.8628962346767408, 0.4209548574915572, 0.046634622615141327, -1.6393007306999556, 0.65025043431383445, 0.50802141302695369, -0.068504647941647845, 0.51855092315186113, -0.98057929368147057, -1.2925955094882546, 0.30665169366707518, 3.9705679716456634, -0.8763976476322699, 3.7118525914263776, 4.8233879396582111, -0.31214242438772705, 3.5201069577584692, 5.6055295794952924, 1.9006670978622411, 0.40617531895307485, -0.13633825788919066, -0.38423492006819598, -0.76149089771668665, 0.22253902629934941, -0.1985744186572119, 1.4828287822897714, 0.16310476776122626, 0.55773229035800354, 0.8161681385562749, 0.5383981504615758, -1.2876141106871739, -1.6351053618238793, 2.7981144693643794, -1.9147895569711246, -1.3879170617746619, 0.26515618204121727, 0.61738709055352903, 0.051434151913562459, 0.22253376417909698, -0.19710411955257243, -0.11553928672311804, 0.062580928735678887, -1.0348891792697743, -0.71404381047787879, 6.7280927719716743, 5.3082712246609018, -2.2815521755579335, 8.9643314564797052, -1.1231676638158536, 2.0374388890599802, 2.2491343600114058, -0.51322827606545429, -2.0760623026361911, -0.86546596809253695, 1.1132083022635748, 0.016166881608109234, -0.28532586796592802, 0.062695571319927382, 0.37394823077908801, -1.2123284995709924, 0.92820589700907918, 0.61651842130949663, -1.2113263922466326, 1.4993887570975342, -0.42592408743381316, -0.82374133978448039, -0.38077834891929335, -0.12924440993745251, 0.35613651800395341, 0.28861628176844567, -0.11411070867346547, -0.064107064384899673, 0.16318694006603501, -0.63280527166495915, 0.13950893398738348, 3.0206322635570557, -0.61887776540410167, 2.1073345817545266, 15.134863386021769, -9.0685889178216552, 2.5516179078607184, 0.15987777595415892, 0.75165898775916729, 2.0096273906801727, 0.31290252683747422, -0.74077897497792289, -0.69822150614317713, 0.39526560004564548, 0.069642667350159129, -0.1777894463227658, -0.37457806876122451, -0.55610134656922283, 0.40792084439497267, 1.0440547633891391, -0.23916839371037832, 0.2750333919575636, 0.62135646441400449, -0.21110858701983135, -0.81615985313544015, 0.14589390394899499, 0.32406742573949032, 0.74952192547288177, -0.32511669967392071, -0.48825453192442569, 0.36648156701751228, 1.0443697855595189, -0.22841081726546683, -1.4950174056034862, 6.4644843028741308, 2.9904131431626397, -13.820343051841599, 1.9854594697574315, -13.304182061875386, -6.3352095159572039, 0.3195679261341049, 0.22665765093840967, 0.19533791786523994, 0.21778449617622839, 0.69288180199640803, 0.084400039832664031, -0.31425797573231284, -0.31479155143425158, 0.078939183973069621, -0.58294801786464789, 0.46161406526582016, 0.41846754429722727, 0.79801858694486438, 0.43858849762191948, 0.23788459440435036, -1.2725586605629382, -0.75720231383362191, -0.29841298969258917, 0.14587335963051393, -0.16753374785242225, -0.21612918483653495, 0.53597221218340851, 0.69495683349647419, -1.0539667118389073, 0.87617222540110107, 4.3629732153958827, -8.0952123464619206, -7.414834109374171, 7.5311386138631651, -44.041788084316849, 22.050605310259897, 5.1510032561702142, -5.6601916863792514, 8.4367427775736488, 1.5703737430868991, -0.83895281997413862, 0.19212817740850727, 0.39792121836056477, -0.14922819541222082, -0.047770712409500753, -0.2908510034609289, -0.015061212014133111, 0.32646574432385927, 0.77395352504545112, -0.16614591312540627, 0.36806371804963284, -0.097634295479077288, 0.091330331747514912, -0.24450075339721231, -0.029095718259234932, 0.16613612027343472, 0.28240974426972948, -0.18044316667269469, -0.48074766055651602, -0.36626836712779753, 3.4507560855810189, -1.9317197634824488, -11.789513877445398, 17.692027714058376, 32.190550839656112, -28.446155418037584, 65.634374404237818, -24.878800155519698, -2.0570987009734387, -3.2997425925449106, -11.516126179313863, 12.372184270457085, 4.9611285532463585, 0.86391702025516592, 0.16530865667454706, -0.46079094226119116, -0.1732663636027687, -0.25470104821282824, -0.43031399471588622, -0.041501479859297648, -0.54386217024143224, 0.81683568275167029, 0.097089152898783726, -0.13744024889929929, -0.095619359707603865, 0.098626184449285684, -0.63036999033225893, -0.18311714867083492, -0.07372642556981146, -0.19104942819406445, 0.075862266735016198, 3.0325028906240856, -9.0326984830007238, -11.815798616251362, 36.620593610799446, 10.636065931319884, -38.68839724466217, 45.716174186409333, -314.74785574475044, 197.27075321520152, 337.61540934331566, 21.930976284520245, -28.837963587037731, -13.475211488788421, 9.5917712473092944, 1.5250850436867665, -1.5545017016282761, -0.64667209976974838, 0.44513357712322837, 0.056507066939540815, -0.23461588343644407, -0.26011219704759359, 0.8042712968338912, 0.30779007494077798, 0.77483290182744469, -0.65133332546861145, -0.18908937081392915, -0.50446476014305819, -0.0074294169071514489, -0.43833208591156614, 0.3383874374890965, 1.0227323524080993, -0.18896973496668346, -8.9206630611282982, -3.6862817789376785, 19.35920062861366, -44.579795546563581, 57.025448777424586, 360.31891091191056, 8.8001261891013822, 1526.2181503116453, 45.053807917762221, -140.68826246910882, 254.89688572081207, -61.967816961200398, -4.5083476182968329, 11.964107143689583, 3.7790359077733431, -1.9045345605049631, -1.7624207728132955, -0.01261576384946491, 0.19558932994062728, -0.30219131214854072, 0.4699644624025669, -0.91230383136372128, 0.36883118795348824, -0.13682839189736087, 0.66713893962058779, -0.25989055470659439, -0.44968314290067052, -1.2882353738829488, -0.76755040332110314, 0.21593130161202181, 1.7124190510555817, 0.6346191100738432, -2.3593378023079388, -10.295701682078779, -39.603849315110132, 54.052681314235315, 182.3786468306393, -282.18880697804133, 735.50774046161428, -423.76919790180091, 46.72930747865378, 744.09540667092074, 65.421023262373566, -26.998515460375824, -110.68919188818332, 1.7026644231740455, 8.6847068298461902, -3.6812627646537122, -1.4462870038602713, 0.66403014974352648, 0.98268640942926089, -0.10353485266764806, -1.1704253870693322, 0.47609558693405896, -0.63809937787576798, 1.9145243520823476, 0.11088180406502474, 0.082864627703299776, -0.36254455317814699, -0.74689297610786809, -0.69551673309504447, -0.24508893173895085, 4.773352510756971, -0.034376983736587929, -18.791248861451901, 0.26732768536914786, 52.084914641107339, -48.782690015656009, -267.77827954485792, 730.15551768721207, 777.49072200787191, 9988.2725309741272, 2608.4519239039569, -953.38531885843202, 570.34935164465708, -262.60583525697274, -86.61832325668658, -42.569555354666946, 2.6532766677526505, 7.1796038797667014, -2.7868839636562561, -0.37842412015855753, 2.0950938638350354, 0.042260514128576405, -0.56850457149086808, -0.90990468751900622, 0.4779279337996068, -1.7872556824974217, 2.239357916267509, 1.748611490859272, 1.4553261209412682, -0.72663987403827102, -2.6646257572640879, 0.50817475490745234, 1.8456273678139588, -1.3367261976572486, 1.0587560944122603, 22.259718007212488, -10.499004391497355, -376.50689706328382, 153.72085790515695, 213.86760970710961, 5000.8757444384837, 12998.804313286144, 3077.5993672243935, -814.38538391702389, -589.84188198577237, 52.443377241039045, -203.58844824671809, -68.764375920932238, 24.893726268864992, 6.7517210150420599, -0.13350548988021724, -0.12421201224142447, -0.33273215463053935, -0.74767454410310241, -2.6325944160953538, 0.19923279402974362, -1.8330278968089646, 1.4063404110660558, 0.33462283171345686, 1.8114765667849764, -0.030361957750053889, -0.81638586337482577, 0.82869028871127859, -0.22176027695649836, 1.260192177948489, -13.167070698799225, -23.742310304940538, 82.499903393484416, 67.213502175129648, -232.07891937634469, -387.93265499317204, 1281.4742181751474, 7140.8743305075477, 19170.83401144094, 6565.2013915603166, -266.59769699529113, 524.55810593663034, -105.08267177765569, 68.939947660481323, -65.513717323045299, -7.7366224074036598, 11.686157623491809, -6.0715674792925807, -4.7051607105170206, 2.1433748844125784, -2.5722659267438033, -2.5332827335358727, -1.5955119590990279, 0.93402216187716958, -2.1983982122300714, -1.3910769799127845, 2.875563242016451, 0.39274625271232855, -1.9143589532041787, -1.9356332468609148, 4.6285618656089529, 1.3770831994437265, -19.219741943874194, 21.574731283989856, 129.03232713044289, 65.73387671644744, 79.985389317629867, 2188.2624437143977, 1562.286524069611, 3837.2504381898625]}};

  var face_filter = {"real": [2.5919359538538909, 1.3480085770312511, -0.20482945082417442, 2.2477358192448036, 0.93540843887482139, 0.74314370383748074, 0.44299233336869565, 0.53646864525435445, -0.033677232548862526, -0.1522853308878499, -0.0031113453238400149, 0.052610669730581504, -0.0090421776029276455, 0.14571584983663624, 0.44057103654181279, -0.48335213540388067, -1.3567864542305328, -0.48335213540388222, 0.44057103654181745, 0.14571584983663588, -0.0090421776029276386, 0.052610669730583912, -0.0031113453238437146, -0.1522853308878454, -0.033677232548862526, 0.536468645254354, 0.44299233336869559, 0.74314370383748229, 0.9354084388748215, 2.2477358192448023, -0.20482945082417423, 1.3480085770312495, 2.0152106388329991, 0.85611134878653461, -1.3363494489312076, -0.52148568567931619, 1.2207493971968164, 0.88880185549210589, -0.12851357573552111, -0.1350280522901679, 0.041300904967699482, 0.44502243372725686, 0.029355734210915238, -0.51443976319946505, 0.08745222381708008, 1.2148708003194451, 1.1189080727093581, -0.27220544444671846, -0.36088426941083585, -0.093485947527556318, -0.9769818787641994, -0.68349100625395898, 0.024322257871818426, 0.60512811669399713, 0.15343788102432432, -0.4299366545774243, -0.15452787333937706, 0.9156200895039931, 1.19600272916941, 0.72364825206645089, 0.54200011692086325, 2.3400266438502029, -0.033608374945748302, 0.58898161413145322, 2.0269883277253808, 2.818789893714468, -3.5895244227646144, -3.5314332372596891, 2.0122812700890154, 0.93093181995227969, -0.96305400340897007, -0.73612667628472817, -0.053915776695886194, 0.42730242898842419, 0.029936824487282035, -0.35168293029190251, 0.25108420491884947, 0.8544524900293714, 0.16931894270710782, 0.0092385746333500125, 0.68672569869418298, 0.41915906104063394, -1.0984488703050921, -0.63697851900908631, 0.11186355371520935, 0.47269360156783113, 0.15279475225563477, -0.026106440237006989, -0.032262751173084157, 0.14542662300780329, 0.71981331903700141, 1.4137393979172745, 0.60857711312874896, -3.0736342072317173, -2.5537641666010327, 0.6337650914909162, 1.2343577579270657, 0.25345561236901865, -2.0331393954447585, 1.159193858429254, 3.0170447718709359, 0.49021233060315667, -0.684375328954414, -0.32927583863381799, -0.09284792777273311, -0.14740895498043241, -0.19413825853994604, 0.36919608239644319, 0.30546257655082493, -0.55256449500031701, -1.2130125640575424, 0.066961883917897494, -0.13876096422777703, 0.37902224678367341, 0.22718444978554084, 0.19963817528635963, 0.027529920247751867, -0.24231535965414738, -0.016338923407765684, 0.45136614923078927, 0.28975660783972312, -0.73094055491799104, -1.5465072446477164, -0.070769892332079726, 3.1701479989789885, 0.024916786279245037, -2.8717730703729369, -1.1681626968077414, -0.94600410103718435, -0.85872517244177848, 2.9516513032863374, 2.8131952593882126, -1.5261742763882251, -1.0558844683361728, 1.1680212024537544, 0.98450685108739822, 0.064067265719269059, -0.43727283330478184, -0.044395094277671916, 0.6179734700494115, 0.24878996343187737, -0.63891278340523816, -0.75864993025841965, -0.32304619466454659, -0.73387564471571265, -0.043145833390571785, 0.92391812888689884, 0.89946098537045804, 0.14871674926559622, -0.54822828954183223, -0.26728613142127311, 0.309011363128886, 0.21418689978013769, -0.52105157113820344, -1.0686411834884146, -1.3047927124000203, 1.0355627592914096, 2.9672746843849169, 1.9471218128812939, 0.36030875558033187, 0.22471825920653532, 1.3679256644146878, 2.3784795387427549, 0.73776440177250424, -2.2202952003703751, -0.98667153092188797, 0.60944427589951666, 0.29273424438530327, -0.054064553213066489, -0.1955430963609566, 0.13452976853580562, 0.17688857701463095, -0.02907863269662225, -0.037177619339377604, 0.22892611971691484, -0.22870850340942314, -0.41029268509332983, 0.061215349005760457, 0.37818604838169356, 0.34148146887082653, 0.099938245586444027, -0.099254338381423959, -0.11254516916626593, -0.2039622085642743, -0.20060216516957027, 0.30792957356810446, 1.1721236672075155, 0.56136417541067873, -2.3249600877666992, -2.4287881268668112, 2.0674326900187423, 2.8441511789848586, 0.050947133476877834, 0.30280142076825006, 0.23441985585068989, -0.69420211937437837, 0.50017210833819825, 0.9824320425486297, -0.30253127598451673, -0.35217802522066471, -0.25522460504160704, 0.12672156371020879, 0.11584743671788442, -0.27806946703293017, -0.28220471587289919, 0.2622813962834421, 0.46145186677272942, 0.088913779923943934, 0.31552668240292342, 0.083701767363049212, -0.20838882493274438, -0.45028623286649139, -0.21994207603667223, 0.24344265380915428, 0.14566519323380012, -0.26341476824800764, -0.25014860441221609, 0.23269603050324755, 0.65507472733677707, 0.58916939473049168, -1.2014518968451928, -1.4706959472537811, 0.73270160247544736, 1.4639339636380404, 0.46180491918070748, 0.46274052021248863, -1.2522772114725254, -1.0527125117724863, 1.1798416267497167, 0.8831199054956721, 0.0044403719443055645, -0.32008851183583215, -0.088039126814047713, 0.13435677108789251, -0.043849665988197006, -0.30055389900341628, -0.17300527880436442, 0.22268011829576431, 0.14506301721613848, 0.13541851865273877, 0.31252919184011202, 0.13643782704324722, -0.2095508102885523, -0.37861030355575276, -0.25285479563588548, 0.076566684841017141, 0.11737705239518459, 0.013018358464219467, -0.041516874353177323, 0.025396859515453351, -0.19237103418038187, -0.20754469441764836, 0.83543584581843078, 0.96010698083026003, -1.0523257697001149, -1.33376499327856, 0.31064795509136994, 0.20053594173979683, -0.099592610690013544, 0.046946926411794127, -0.26933425983580023, -0.25886956646489134, 0.16667582025681255, 0.16264384177267197, 0.10611595375861864, -0.0098404462838746383, -0.13572606372513804, -0.02258793083641232, 0.1626410940258704, 0.0084042334154625226, -0.31667685877385637, 0.013183667319477316, 0.0095114839461814711, 0.064735813239969756, 0.10654247281867815, 0.21331216355051069, 0.10213744987583113, -0.12973084349572184, -0.098085407735951202, 0.071599991117337544, 0.096012887125637492, -0.070622290324985737, -0.21061961456993025, 0.12811225495378645, 0.61116435171305805, 0.27931012230932523, -0.57076807310688515, -0.50218388849258644, -0.42922119360119421, -0.44865243467955651, 0.48865422280767501, 0.5325596193896186, -0.37999327914266867, -0.37733114800401457, 0.013506411710477314, 0.170066818452864, 0.060998910324659567, -0.13656793547637669, -0.090686593939375684, 0.3743991900961478, 0.47466547775213164, -0.40581229446604228, -0.4933460399621819, -0.38074360867450391, -0.49035943457716413, -0.12412531843683997, 0.30440943973074641, 0.59456571635307864, 0.39877140482842571, -0.17295292843566973, -0.26272159996092964, -0.046183226771098686, 0.047879446168886036, -0.01767919625538646, 0.11122639164092249, 0.28368537020126805, -0.25549013964140954, -0.47047462219224784, 0.42895932921703384, 0.49142711950580215, -0.37646529147307217, -0.2985208724149509, -0.14163512022800509, 0.036248242700393868, 0.16977635036237812, 0.13499908156480836, -0.01898512351822966, -0.069319801425736585, -0.048065151476023839, -0.091445654237596943, 0.063480780271467835, 0.36025783734460454, 0.079528415094702418, -0.1753773206782209, 0.12374069460012149, -0.28367021291499456, -0.3947284775676721, -0.2665809890749859, 0.18834221718468977, 0.27819651942933282, 0.17697914055115227, -0.044718494415980817, -0.10522429653700929, -0.056918990576836789, -0.038574904247242463, 0.0044720036764788907, 0.075029157257001891, -0.012042674487198736, -0.25791041993690383, 0.0094461444749257637, 0.45149640843334832, 0.15522942660639183, 0.16359187166611067, 0.27184060163390095, -0.26140872283435745, -0.36468827084356714, 0.092564696434539948, 0.17076044356298117, -0.081952166134050972, -0.094812402895013512, 0.056872171173511843, 0.14314060902527834, 0.090057378296037091, -0.49752310636724911, -0.90399504476626857, 0.68385321448233993, 1.5206479363861476, 0.97194500124059446, 0.37223376526843088, 0.050885418177567802, -0.35886815857743665, -0.85430361824055856, -0.54314517421482678, 0.35505625397063872, 0.41635160123016829, 0.1097676276443619, 0.0031094617237012487, 0.012467253683817481, -0.13435478466038733, -0.3025207327612856, 0.064227680246281948, 0.26667168729095614, -0.26695175931487575, -0.39070435016787081, 0.46272484969502237, 0.4478152924484996, -0.02777275619946918, -0.36406380803433314, -0.36482553236919035, -0.17145017383338396, -0.0022768560529046471, 0.19648856692552516, 0.19795501524240586, 0.11579620326491886, -0.20236218758832794, -1.3218815146594056, -0.89510126706911786, 0.91685720076146016, 1.0573193754484274, 1.0300227650328617, 1.2681463254528202, 0.54199794330131901, -0.81825453423342154, -1.1158895792994059, -0.48892024147971419, 0.37011029837274972, 0.52557441450178022, 0.12007696462970571, 0.0053871855361874443, 0.0980933520274576, 0.045813676675892742, -0.13973686519943007, -0.1315893019053164, -0.41025099029328865, -0.78307378558342511, -0.43058051319449592, -0.14586342722110873, -0.20332028656079115, -0.50991116383855117, -0.22496834802938576, -0.23147407593468516, -0.0020062182884880236, 0.35659057442027225, 0.21055136817067865, -0.090708657953189512, -0.093236555831976653, -0.39644071531856356, -0.15760046489763799, 0.85217092970404984, -0.006060772398080865, -1.1445855838899712, -0.40779542231222293, 0.57192337467361454, 0.38110042075214373, 0.18372151232217485, 0.45534551448489441, 0.44338161640444884, -0.33392303093222925, -0.30033251173404302, -0.018826279470074956, -0.0031918185582147274, 0.016996498806762936, 0.19478439409652604, 0.14839426734987179, -0.16993496725014728, -0.25233000300477815, -0.17163872305028913, -0.16896259214086029, -0.35048355912402168, -0.56666117156530804, -0.043075182629207294, 0.46189562289598257, 0.12201955959263491, 0.048431387757678836, 0.1008273185138992, -0.19670456422152316, -0.16642026644756419, -0.15046897531292064, 0.1609200706656915, 1.4039223524989202, 1.7178875241186931, -0.079850193819757748, -1.5066376684783904, -1.9250211671886128, -1.0545407692185655, -0.51176749353660089, 1.7285428258292277, 1.5863083779089326, 0.24208315366337785, -0.88837860391849655, -0.80449782923567614, -0.063049218988350142, 0.18072374426616816, 0.041279056588780935, -0.12639978427416398, -0.058413638180600282, 0.18149778190196758, 0.37146508613201623, 0.60005197547104183, 0.38887239681739694, 0.1152103935846736, -0.080081540793911096, 0.79737548580628892, 0.60164673103725985, 0.13967291436025694, -0.17870113794821088, -0.40389823435739103, -0.33510874790612805, -0.062682749064233156, 0.042125181720095217, 0.22750178782369759, 1.0883583281620091, 0.67976518601386504, -0.6792087414350455, -0.67769831799676505, 0.0071297652693774914, -0.21574274789108602, 0.73346137493748143, 0.69884011316820749, 0.12589091429626179, -0.68348492100050939, -0.41285410288550739, -0.18770950063360772, -0.15148842977747803, 0.047869931187020834, 0.21018250411743153, 0.068763639373895541, 0.0098401964213560011, -0.019137710950301583, -0.44014279794733802, -0.21656678437317001, 0.36831896296176964, 0.31965489003799819, 0.24180664285441536, -0.20287221126440233, -0.56181438279878848, -0.15470815549218525, 0.11910006502983214, -0.0029256323011974715, -0.04650506403640628, -0.11603914651892111, -0.15307567360464111, 0.4224212238432043, 0.15967260300989697, -0.83895691770827985, -1.4824802915019837, -0.37969523238638658, 0.89583132075795047, 1.77383273304373, 0.8958313207579488, -0.37969523238638764, -1.4824802915019843, -0.8389569177082784, 0.15967260300989483, 0.42242122384320435, -0.15307567360464003, -0.11603914651892111, -0.046505064036406023, -0.0029256323011973848, 0.11910006502983216, -0.15470815549218528, -0.56181438279878715, -0.20287221126440275, 0.24180664285441561, 0.11521039358467118, 0.36831896296176875, -0.2165667843731702, -0.44014279794733774, -0.019137710950301947, 0.0098401964213558832, 0.068763639373895805, 0.21018250411743131, 0.047869931187020681, -0.15148842977747892, -0.18770950063360678, -0.4128541028855055, -0.68348492100050762, 0.12589091429626098, 0.69884011316820926, 0.73346137493748531, -0.21574274789108297, 0.0071297652693808498, -0.67769831799676439, -0.67920874143504806, 0.6797651860138616, 1.0883583281620088, 0.22750178782369845, 0.042125181720095072, -0.06268274906423292, -0.33510874790612777, -0.40389823435739058, -0.17870113794821069, 0.13967291436025678, 0.6016467310372583, 0.79737548580629014, -0.080081540793910805, -0.35048355912402274, 0.38887239681739855, 0.60005197547104216, 0.37146508613201551, 0.18149778190196694, -0.058413638180600004, -0.12639978427416418, 0.041279056588780526, 0.1807237442661683, -0.063049218988349559, -0.80449782923567681, -0.88837860391849677, 0.24208315366337824, 1.5863083779089293, 1.7285428258292255, -0.51176749353659912, -1.0545407692185644, -1.9250211671886148, -1.506637668478394, -0.079850193819762688, 1.7178875241186904, 1.4039223524989211, 0.160920070665691, -0.15046897531292144, -0.16642026644756441, -0.19670456422152255, 0.10082731851389957, 0.048431387757679002, 0.122019559592635, 0.46189562289598279, -0.043075182629206808, -0.56666117156530804, -0.1458634272211089, -0.16896259214085926, -0.17163872305028846, -0.25233000300477826, -0.16993496725014781, 0.14839426734987166, 0.19478439409652576, 0.016996498806763023, -0.0031918185582146671, -0.01882627947007429, -0.30033251173404329, -0.3339230309322298, 0.44338161640444979, 0.45534551448489619, 0.18372151232217931, 0.38110042075214462, 0.57192337467361187, -0.40779542231222243, -1.1445855838899728, -0.0060607723980816422, 0.85217092970405028, -0.15760046489763638, -0.39644071531856373, -0.093236555831976972, -0.090708657953189803, 0.21055136817067863, 0.35659057442027281, -0.0020062182884879754, -0.23147407593468516, -0.22496834802938495, -0.50991116383855117, -0.20332028656079207, 0.46272484969502153, -0.43058051319449625, -0.78307378558342611, -0.41025099029328771, -0.13158930190531651, -0.13973686519943013, 0.04581367667589293, 0.098093352027458003, 0.0053871855361874036, 0.12007696462970524, 0.52557441450178122, 0.37011029837274845, -0.48892024147971336, -1.1158895792994052, -0.81825453423342154, 0.54199794330131867, 1.2681463254528189, 1.0300227650328604, 1.0573193754484311, 0.91685720076146382, -0.89510126706911664, -1.3218815146594056, -0.20236218758832747, 0.11579620326491913, 0.19795501524240555, 0.19648856692552533, -0.002276856052904625, -0.17145017383338415, -0.36482553236918996, -0.36406380803433286, -0.027772756199469509, 0.44781529244849971, 0.1635918716661118, -0.39070435016787175, -0.26695175931487636, 0.26667168729095614, 0.064227680246282309, -0.30252073276128633, -0.13435478466038722, 0.012467253683817804, 0.0031094617237012916, 0.10976762764436168, 0.41635160123016834, 0.35505625397063934, -0.54314517421482655, -0.85430361824056045, -0.35886815857743842, 0.050885418177567691, 0.3722337652684316, 0.97194500124059191, 1.5206479363861465, 0.68385321448234182, -0.90399504476626835, -0.49752310636725033, 0.09005737829603698, 0.14314060902527884, 0.056872171173512003, -0.094812402895013193, -0.081952166134050861, 0.17076044356298159, 0.092564696434540239, -0.36468827084356803, -0.26140872283435806, 0.27184060163390172, -0.37646529147307173, 0.15522942660639114, 0.45149640843334826, 0.009446144474926697, -0.25791041993690383, -0.012042674487198701, 0.07502915725700196, 0.0044720036764790416, -0.038574904247242366, -0.056918990576836755, -0.10522429653700935, -0.044718494415980962, 0.17697914055115149, 0.2781965194293311, 0.18834221718468852, -0.2665809890749849, -0.39472847756767171, -0.28367021291499434, 0.12374069460012085, -0.17537732067822176, 0.079528415094701682, 0.3602578373446047, 0.063480780271467876, -0.091445654237597165, -0.048065151476023728, -0.06931980142573653, -0.018985123518229702, 0.13499908156480855, 0.16977635036237826, 0.036248242700393465, -0.14163512022800506, -0.29852087241494996, -0.42922119360119487, 0.49142711950580192, 0.428959329217034, -0.47047462219224911, -0.25549013964141071, 0.28368537020126877, 0.111226391640923, -0.017679196255386387, 0.047879446168886071, -0.046183226771098616, -0.26272159996092947, -0.17295292843566987, 0.39877140482842616, 0.59456571635307809, 0.30440943973074525, -0.12412531843683972, -0.49035943457716313, -0.3807436086745018, -0.49334603996218179, -0.40581229446604117, 0.47466547775213147, 0.37439919009614836, -0.090686593939375629, -0.13656793547637694, 0.060998910324659573, 0.17006681845286384, 0.013506411710477128, -0.37733114800401446, -0.37999327914266845, 0.53255961938961804, 0.4886542228076744, -0.44865243467955757, 0.31064795509136994, -0.50218388849258644, -0.57076807310688515, 0.27931012230932423, 0.61116435171305772, 0.12811225495378684, -0.21061961456993031, -0.07062229032498564, 0.096012887125637492, 0.0715999911173376, -0.098085407735951036, -0.12973084349572186, 0.10213744987583084, 0.21331216355051105, 0.10654247281867847, 0.064735813239968978, 0.0095114839461814711, 0.013183667319477904, -0.31667685877385532, 0.0084042334154626214, 0.1626410940258709, -0.022587930836412171, -0.13572606372513854, -0.0098404462838748534, 0.10611595375861864, 0.16264384177267199, 0.16667582025681238, -0.2588695664648914, -0.26933425983580034, 0.046946926411794203, -0.099592610690013642, 0.20053594173979666, 0.46180491918070782, -1.3337649932785616, -1.0523257697001149, 0.96010698083025947, 0.835435845818432, -0.20754469441764875, -0.19237103418038279, 0.025396859515452976, -0.041516874353177122, 0.013018358464219362, 0.11737705239518428, 0.076566684841017002, -0.25285479563588431, -0.37861030355575326, -0.2095508102885513, 0.13643782704324786, 0.31252919184011235, 0.1354185186527376, 0.14506301721613746, 0.22268011829576351, -0.17300527880436414, -0.30055389900341645, -0.043849665988197138, 0.13435677108789171, -0.088039126814047811, -0.32008851183583126, 0.0044403719443063165, 0.8831199054956711, 1.179841626749716, -1.0527125117724856, -1.2522772114725254, 0.46274052021248885, 0.050947133476877821, 1.4639339636380404, 0.73270160247544602, -1.4706959472537806, -1.2014518968451935, 0.58916939473049124, 0.65507472733677696, 0.23269603050324741, -0.25014860441221576, -0.26341476824800797, 0.14566519323380028, 0.24344265380915459, -0.2199420760366726, -0.45028623286649283, -0.20838882493274519, 0.083701767363050281, 0.31552668240292281, 0.088913779923944877, 0.46145186677272854, 0.2622813962834421, -0.28220471587289875, -0.27806946703292978, 0.11584743671788453, 0.12672156371020837, -0.25522460504160699, -0.35217802522066505, -0.30253127598451701, 0.98243204254862915, 0.50017210833819781, -0.69420211937437803, 0.23441985585068889, 0.30280142076825051, 0.2247182592065364, 2.8441511789848586, 2.0674326900187419, -2.4287881268668121, -2.3249600877666978, 0.56136417541067796, 1.1721236672075159, 0.30792957356810535, -0.20060216516957047, -0.2039622085642748, -0.11254516916626582, -0.099254338381423668, 0.0999382455864435, 0.34148146887082625, 0.37818604838169406, 0.061215349005760457, -0.41029268509332922, -0.22870850340942214, 0.22892611971691548, -0.037177619339376564, -0.029078632696622427, 0.17688857701463057, 0.13452976853580567, -0.19554309636095565, -0.054064553213066628, 0.29273424438530188, 0.609444275899516, -0.98667153092188464, -2.2202952003703764, 0.73776440177250102, 2.3784795387427535, 1.367925664414688, -0.94600410103718391, 0.3603087555803301, 1.9471218128812944, 2.9672746843849187, 1.0355627592914098, -1.3047927124000192, -1.068641183488414, -0.52105157113820511, 0.21418689978013775, 0.30901136312888583, -0.26728613142127272, -0.54822828954183234, 0.1487167492655953, 0.89946098537045849, 0.92391812888689973, -0.043145833390572444, -0.73387564471571165, -0.32304619466454804, -0.75864993025841865, -0.63891278340523694, 0.24878996343187765, 0.61797347004941017, -0.044395094277671403, -0.43727283330478151, 0.064067265719269045, 0.98450685108739822, 1.1680212024537535, -1.0558844683361719, -1.5261742763882244, 2.813195259388213, 2.9516513032863356, -0.85872517244177815, 1.2343577579270646, -1.1681626968077381, -2.8717730703729356, 0.024916786279243767, 3.1701479989789867, -0.070769892332079906, -1.5465072446477184, -0.73094055491799181, 0.28975660783972312, 0.45136614923079016, -0.016338923407765823, -0.24231535965414835, 0.027529920247752079, 0.19963817528636058, 0.22718444978554045, 0.37902224678366964, -0.13876096422777742, 0.066961883917898354, -1.213012564057544, -0.55256449500031835, 0.30546257655082465, 0.36919608239644353, -0.1941382585399454, -0.14740895498043313, -0.092847927772733041, -0.32927583863381676, -0.68437532895441289, 0.49021233060315311, 3.0170447718709372, 1.1591938584292596, -2.0331393954447532, 0.25345561236901532, 2.0269883277253808, 0.6337650914909212, -2.5537641666010331, -3.0736342072317178, 0.60857711312874962, 1.4137393979172737, 0.71981331903700019, 0.14542662300780379, -0.032262751173084109, -0.026106440237006333, 0.15279475225563396, 0.47269360156783119, 0.11186355371520969, -0.63697851900908553, -1.0984488703050919, 0.41915906104063416, 0.68672569869418265, 0.0092385746333522867, 0.16931894270710687, 0.85445249002936896, 0.25108420491884997, -0.35168293029190173, 0.029936824487282226, 0.42730242898842274, -0.053915776695886201, -0.7361266762847285, -0.96305400340896929, 0.93093181995227892, 2.0122812700890154, -3.5314332372596846, -3.5895244227646144, 2.8187898937144658, 2.0152106388329991, 0.58898161413145356, -0.033608374945749073, 2.3400266438502024, 0.54200011692086181, 0.72364825206645078, 1.1960027291694086, 0.91562008950399532, -0.15452787333937676, -0.42993665457742386, 0.1534378810243246, 0.60512811669399758, 0.024322257871818742, -0.6834910062539612, -0.9769818787642004, -0.093485947527554653, -0.36088426941083557, -0.27220544444672085, 1.1189080727093528, 1.2148708003194422, 0.087452223817081023, -0.51443976319946561, 0.029355734210916126, 0.44502243372725681, 0.041300904967699399, -0.13502805229016995, -0.12851357573552075, 0.88880185549210555, 1.2207493971968146, -0.52148568567931763, -1.3363494489312078, 0.85611134878653028], "bottom": {"real": [10965.975170394304, 21271.915267962257, 3528.2703051611911, 4104.4756805864381, 1601.0616042188819, 1022.7399974894073, 557.80113750762041, 282.82230522781242, 145.15707521660474, 105.9441201571383, 59.012707266667213, 44.669628432443531, 36.50168205465414, 28.529134449096524, 21.777099980382825, 18.33532892478512, 16.253545459923078, 18.335328924785092, 21.777099980382847, 28.529134449096492, 36.50168205465414, 44.669628432443567, 59.012707266667277, 105.94412015713864, 145.15707521660474, 282.82230522781276, 557.80113750762041, 1022.7399974894074, 1601.0616042188824, 4104.4756805864426, 3528.2703051611911, 21271.91526796226, 12599.263825927621, 3215.125406898348, 5397.5422498759845, 1626.8549963375583, 805.20630634633005, 515.14459200644239, 359.3048107396736, 212.4360242127799, 110.43978615629422, 81.30134061470001, 50.82057050163526, 41.192651249931721, 32.936640633650484, 26.681133724080869, 18.01921088871573, 14.766368476202661, 15.422836018027418, 15.990808141800954, 20.022228188848842, 26.276495829612259, 35.717232769261116, 41.847677620126099, 54.320387908275151, 97.518896272497358, 133.8729941689642, 238.43595357759855, 456.937693043428, 711.66550404730731, 1144.8252089743219, 1902.8385884755523, 5206.768847980471, 3622.9684974910811, 13155.61342681755, 3416.7436429144991, 2812.4738667722154, 1400.147559944327, 383.1327908328127, 252.15177845425933, 197.2081578118225, 171.59960210222519, 82.275357677734092, 60.48297276194193, 40.777478884094478, 35.028553697203044, 28.877176436297923, 21.966647147933095, 16.371866219790679, 15.053935075225828, 14.23277610579999, 14.866315284596761, 18.218896084560566, 25.18211951926569, 33.821722307900131, 38.320413578940517, 45.570220260185515, 72.059479710744441, 97.660119608992957, 168.65094690401955, 268.62846926573025, 329.42984018623156, 467.75549674428515, 1002.4311488284067, 3554.1418329345079, 1764.397059903687, 4621.9583294760141, 1569.7087860062477, 1388.3341571422952, 628.37101334838883, 414.07061143445827, 168.53157442290524, 137.2795663029475, 102.11362429348972, 55.491719795512424, 49.073126751989768, 36.063389145893389, 30.634459542886617, 24.216782409074948, 18.667040937787934, 14.56741780053745, 12.905268434713205, 12.868626938575844, 13.095932326486089, 16.679039087380332, 21.80969609662603, 29.753917874884348, 36.827824955920349, 38.934743351431941, 57.668339838268878, 69.641961050084433, 131.28843074347486, 180.68252449032624, 169.44044949721729, 350.74973626382058, 497.02834719870827, 1746.1261590593115, 796.99783843130319, 3103.2479470123581, 1415.2337173839596, 752.81814346176623, 549.34301727365857, 201.53841636766998, 154.61036627522753, 104.58138455482165, 77.618781225118965, 49.392087964292358, 44.90232542624743, 31.105878831006294, 25.236762604525154, 19.175053589853054, 16.38453446468991, 12.823063914611339, 12.047936614807259, 11.554737628486025, 12.534926448772453, 14.323695266188452, 17.780247836887199, 24.191492945877869, 28.843093953252101, 32.767703049824149, 43.78366744373352, 51.550546699271386, 70.699184140809493, 109.08321361427502, 136.28687846912635, 199.77708080210388, 376.32680369835469, 796.83467383546451, 571.91471358300532, 984.41049770348889, 694.18752080971819, 999.69929532757897, 367.74073917398181, 338.97998181689366, 133.72435362068052, 109.5985079627268, 89.938945070024957, 49.039508255638331, 36.109063293014415, 25.98394571698211, 23.015774601871652, 16.882299112940213, 14.591336257090045, 11.32667094148311, 9.91803607895827, 9.6753965965616064, 10.57555888797221, 12.046190961831451, 14.768605661776913, 18.648763248771505, 21.576487249184964, 27.01336113453004, 36.908082411505312, 45.645009020283105, 60.837630874998482, 99.37203234809671, 111.28266970072299, 252.63182137130968, 273.92630278831501, 775.2357561437575, 815.85074837225181, 1655.1106419436521, 1107.4422783913506, 474.0637368651835, 355.64805874163005, 199.11678861892517, 123.46347336694488, 65.896409871808586, 68.918403190937497, 38.943190919202721, 28.774499596319636, 21.286505123099762, 17.663953414249985, 14.114074884510726, 11.879784189493673, 10.039166730615968, 8.3521719629346443, 8.4814596475391344, 9.0449476750100413, 9.8512979659284881, 12.153630271582001, 15.23168574488512, 19.437247877391961, 22.710514050850847, 28.755794586161894, 38.618352638886485, 59.942241598726909, 92.997872357952332, 88.111783673752711, 166.94308947555163, 243.79773811420219, 532.10468308026691, 428.26170612042944, 835.14389492248984, 575.84605817489046, 602.78945521124672, 339.57693755905132, 168.11833297683242, 117.99279203678798, 52.586639793255571, 42.047895128628383, 28.318592567301817, 25.001453363505657, 19.91641866758216, 16.823078359396845, 11.65888462925604, 10.364401595593858, 8.8573627978869887, 7.4173871264629518, 7.2681515499390361, 7.5915323421249861, 8.6807340620832107, 10.378269159275604, 12.701378035616356, 16.292785679101375, 18.804030398726262, 23.560923080173954, 30.503495373532754, 45.810504396910375, 65.229522054396952, 65.639482430818617, 177.29565831054776, 166.70872880265193, 491.9902921130938, 512.67235981711065, 747.45313809997936, 645.96141219737251, 307.54977114778814, 298.36000265745548, 105.95282903225828, 85.567113182097643, 44.672376324283228, 40.226583433899208, 25.615021546435344, 22.144491394300847, 16.131654569456256, 13.397071796412417, 10.408828566613494, 8.9591957313528034, 8.0604380452509936, 7.0442060411780956, 6.2883229388812003, 6.8496831982856676, 7.336687105800447, 8.4717730733339334, 9.9814777112217854, 13.121694879148574, 16.902165529440683, 20.643784740763845, 24.153222030769193, 29.725858725465727, 41.896421037553992, 52.630934346953957, 103.5859123323665, 116.76781276597193, 376.64744495733714, 306.93195832405218, 356.46238810538262, 374.90366628545218, 271.63698834940317, 203.15162979817489, 85.296077399229702, 77.649689466739304, 35.918272816149603, 33.069491090524735, 22.605820220395913, 17.296816509483932, 13.342699317421832, 11.640978884779956, 9.3586975241911539, 8.2623074625085575, 6.6065851632208821, 6.2827863632965242, 6.0744238279118932, 6.3582342010947102, 6.8252966967815532, 7.8556092062941403, 9.3209224203195777, 10.848369664421165, 14.056179340078513, 17.792540785133639, 21.540972163896267, 26.803938103683681, 40.50313838179877, 43.285550133972045, 91.691889335245591, 100.98276829758987, 225.59390630676836, 290.0678303886524, 373.60823131669014, 414.22422969876749, 141.37671573357548, 158.90321565708931, 63.837661879419102, 61.993039771960156, 32.588562049134531, 28.668162298507095, 18.426404144385732, 14.735821975464789, 11.992469004096597, 11.399293029930492, 8.7163999068023248, 7.2289667101344008, 6.5906881398505739, 5.7472695906024613, 5.6472990693532683, 5.8777570769595933, 6.4024098578192543, 7.4405650580225187, 8.4599769870087567, 10.256048021590846, 12.060831155359036, 13.785151925105749, 18.659998164390426, 22.921744826480442, 31.905227459883474, 34.302795951832735, 59.880411689763747, 69.971045180964353, 160.24793865518117, 163.52979203882799, 147.83029120770976, 178.6357867835558, 118.15132417284869, 114.19776495947795, 53.375296048832148, 57.177884093679019, 32.93952944330524, 24.968491799996325, 17.430516204833694, 13.433899198972929, 11.836714579435053, 10.548598460428181, 8.0486546171077791, 7.1187881891372964, 6.4594660557219088, 5.8159952878399759, 5.4767794038379067, 5.3908701504578147, 5.8976209996629629, 7.1301831132348088, 7.5675834428185693, 8.7517061416953652, 11.338462673842365, 13.133124938105077, 16.059093761394507, 18.849097825959038, 29.651622179353478, 34.09934210997649, 58.700399360289651, 65.261681531847529, 99.214909240790846, 146.35353694510258, 121.37679122991287, 165.76624382852509, 77.65397407030467, 91.338453331354174, 44.07807549608674, 44.566220734037245, 27.026614222359569, 22.147051076612073, 15.399396116974053, 12.432895564123392, 10.640074418564296, 9.3276298749700732, 7.5791206500207364, 6.7828789822837923, 6.1816087593787632, 5.6692811710818027, 5.1651813219751155, 5.3317492648801608, 5.5981461093243494, 6.4057146645582934, 7.2505243651475348, 8.4209913018587468, 10.969854167863348, 12.153630713859068, 14.766764339656312, 18.099354774134348, 25.326013884328763, 29.785949829841531, 46.424831391908171, 52.615859887304801, 82.573269999379406, 99.676304070074508, 86.640078828927244, 116.36860702141186, 64.2413414100685, 71.742693053970697, 38.10988368760168, 36.926827145978287, 25.897290737678322, 19.275080383374728, 14.749844663752917, 11.485010388879966, 9.4576647539678333, 8.8927162237613455, 7.4395778659669922, 6.0444335480941538, 5.7182084691628248, 5.0557935120943966, 5.0760457790692417, 5.2089717500439345, 5.7735220000474632, 5.9406732653680434, 6.7459275777069596, 7.820577383583708, 9.9835305123253484, 11.402400865496325, 14.118008059701465, 15.687873342054864, 23.860535436216686, 29.003043185839516, 40.145342185017675, 49.33744888297236, 59.017178205425914, 84.300643063132256, 70.160964533004119, 106.14414492511058, 57.343364605572859, 60.092652172041127, 35.035164226891368, 31.196728233049463, 22.848135981998073, 17.280291997569737, 14.215425049471765, 11.487894696175578, 9.2019617459917757, 8.157670273889595, 7.4731544987863776, 6.0230042880637562, 5.6300019663774918, 5.2449852175850884, 4.8944187843316493, 5.1794885290485126, 5.4428139254674495, 5.9866966335497871, 6.4988534667021369, 7.0161059288776793, 9.1662091602334215, 10.540688253938185, 13.221652899667433, 17.448751090247555, 21.405199921620568, 24.443644233674171, 34.565403798719835, 43.064932290411342, 53.896764023490427, 75.330615249002037, 57.139048850516261, 75.071278816121492, 44.304162032217924, 48.091094532561691, 33.4913106785217, 27.211025020176507, 22.453521092970409, 17.428281520682297, 14.160857290751922, 10.592079486422294, 9.2001673028330426, 7.5661166243087798, 6.5335689847346243, 5.8073593275643729, 5.7880621018967249, 5.3539074945975891, 5.3978132668570558, 5.2447316758230391, 5.4735425621066245, 5.861789820088422, 6.5375806061336013, 7.5634600669075329, 8.8416380446398435, 10.50698673124036, 13.949036764622399, 16.252252028090993, 22.019876112374043, 25.162704768394917, 31.578176229468394, 41.771493186860923, 42.955938687991988, 69.858651906447136, 50.780163528630226, 74.077510216304077, 43.697387961361706, 40.315818737884314, 29.770652812772006, 26.340522851312056, 22.034594395520614, 16.748599325796118, 12.845516284546591, 10.52499564475608, 9.2455018617556028, 7.4871364359448869, 6.8277975203922185, 5.6646016980044793, 5.288115481792067, 5.2498383547683662, 5.1849512003341403, 5.2498383547683662, 5.2881154817920599, 5.6646016980044767, 6.8277975203922212, 7.4871364359448904, 9.2455018617556082, 10.52499564475608, 12.845516284546591, 16.748599325796118, 22.034594395520603, 26.340522851312063, 29.770652812772006, 40.315818737884321, 43.697387961361706, 74.077510216304077, 57.139048850516232, 69.858651906447136, 42.955938687991953, 41.771493186860937, 31.578176229468383, 25.162704768394924, 22.019876112374046, 16.252252028090997, 13.949036764622383, 10.506986731240358, 8.8416380446398382, 7.5634600669075285, 6.5375806061335977, 5.8617898200884238, 5.4735425621066245, 5.2447316758230373, 5.3978132668570558, 5.3539074945975873, 5.7880621018967231, 5.807359327564372, 6.5335689847346252, 7.5661166243087798, 9.2001673028330391, 10.592079486422293, 14.16085729075192, 17.428281520682305, 22.453521092970401, 27.211025020176521, 33.491310678521693, 48.091094532561655, 44.304162032217938, 75.071278816121534, 70.160964533004076, 75.330615249002022, 53.89676402349037, 43.064932290411342, 34.565403798719814, 24.443644233674185, 21.405199921620568, 17.448751090247544, 13.221652899667435, 10.540688253938189, 9.1662091602334179, 7.0161059288776801, 6.4988534667021369, 5.9866966335497871, 5.4428139254674504, 5.17948852904851, 4.8944187843316449, 5.2449852175850866, 5.6300019663774892, 6.0230042880637509, 7.4731544987863758, 8.157670273889595, 9.2019617459917793, 11.487894696175564, 14.215425049471762, 17.280291997569748, 22.84813598199807, 31.19672823304948, 35.035164226891382, 60.092652172041191, 57.343364605572894, 106.14414492511065, 86.640078828927187, 84.30064306313227, 59.017178205425857, 49.337448882972346, 40.145342185017682, 29.003043185839513, 23.860535436216686, 15.687873342054866, 14.118008059701463, 11.402400865496327, 9.9835305123253519, 7.8205773835837116, 6.7459275777069578, 5.9406732653680443, 5.7735220000474641, 5.2089717500439328, 5.0760457790692435, 5.0557935120943975, 5.7182084691628221, 6.0444335480941556, 7.4395778659669922, 8.8927162237613491, 9.4576647539678262, 11.485010388879974, 14.749844663752919, 19.275080383374736, 25.897290737678308, 36.92682714597828, 38.109883687601666, 71.742693053970726, 64.241341410068529, 116.36860702141172, 121.37679122991284, 99.676304070074451, 82.57326999937942, 52.615859887304801, 46.424831391908185, 29.785949829841556, 25.32601388432877, 18.099354774134348, 14.766764339656312, 12.153630713859069, 10.96985416786335, 8.4209913018587539, 7.250524365147534, 6.4057146645582961, 5.5981461093243476, 5.3317492648801599, 5.1651813219751173, 5.6692811710818027, 6.1816087593787605, 6.7828789822837923, 7.5791206500207382, 9.3276298749700803, 10.640074418564305, 12.432895564123386, 15.399396116974053, 22.147051076612065, 27.026614222359573, 44.566220734037259, 44.078075496086726, 91.338453331354202, 77.653974070304727, 165.76624382852506, 147.83029120770976, 146.35353694510263, 99.214909240790945, 65.261681531847557, 58.700399360289673, 34.099342109976497, 29.651622179353467, 18.849097825959049, 16.059093761394511, 13.133124938105075, 11.338462673842358, 8.7517061416953563, 7.5675834428185675, 7.1301831132348097, 5.8976209996629647, 5.3908701504578165, 5.4767794038379076, 5.8159952878399785, 6.4594660557219132, 7.1187881891372955, 8.0486546171077809, 10.548598460428188, 11.836714579435059, 13.433899198972929, 17.430516204833697, 24.968491799996333, 32.93952944330524, 57.177884093679054, 53.375296048832141, 114.19776495947798, 118.15132417284869, 178.63578678355586, 373.60823131669019, 163.52979203882796, 160.24793865518112, 69.971045180964367, 59.880411689763726, 34.302795951832763, 31.905227459883484, 22.921744826480438, 18.659998164390412, 13.785151925105746, 12.060831155359033, 10.256048021590846, 8.4599769870087602, 7.4405650580225213, 6.4024098578192588, 5.8777570769595933, 5.6472990693532674, 5.7472695906024622, 6.5906881398505668, 7.2289667101344008, 8.7163999068023195, 11.399293029930499, 11.992469004096606, 14.735821975464788, 18.426404144385724, 28.66816229850712, 32.588562049134516, 61.993039771960206, 63.837661879419088, 158.90321565708933, 141.37671573357554, 414.22422969876766, 356.46238810538273, 290.06783038865245, 225.59390630676842, 100.98276829758977, 91.691889335245619, 43.285550133972016, 40.503138381798749, 26.803938103683674, 21.540972163896271, 17.792540785133639, 14.056179340078506, 10.84836966442117, 9.3209224203195813, 7.8556092062941412, 6.8252966967815567, 6.3582342010947119, 6.0744238279118923, 6.2827863632965206, 6.606585163220883, 8.2623074625085593, 9.3586975241911592, 11.640978884779955, 13.342699317421838, 17.296816509483932, 22.60582022039592, 33.069491090524764, 35.918272816149603, 77.649689466739304, 85.296077399229731, 203.15162979817504, 271.63698834940351, 374.90366628545223, 747.45313809997936, 306.93195832405206, 376.64744495733714, 116.76781276597193, 103.58591233236646, 52.630934346953964, 41.896421037553985, 29.725858725465734, 24.153222030769193, 20.643784740763849, 16.902165529440701, 13.121694879148574, 9.9814777112217961, 8.4717730733339316, 7.3366871058004506, 6.8496831982856659, 6.2883229388812003, 7.0442060411780965, 8.0604380452509936, 8.9591957313528034, 10.40882856661349, 13.397071796412414, 16.131654569456249, 22.144491394300825, 25.615021546435344, 40.226583433899208, 44.672376324283235, 85.567113182097643, 105.95282903225828, 298.36000265745565, 307.54977114778819, 645.9614121973724, 835.14389492248984, 512.67235981711053, 491.99029211309386, 166.70872880265185, 177.29565831054779, 65.639482430818575, 65.229522054396938, 45.810504396910396, 30.503495373532761, 23.560923080173971, 18.804030398726255, 16.292785679101371, 12.701378035616358, 10.378269159275604, 8.6807340620832214, 7.5915323421249852, 7.2681515499390352, 7.4173871264629581, 8.8573627978869904, 10.364401595593863, 11.65888462925604, 16.823078359396849, 19.91641866758215, 25.001453363505686, 28.31859256730182, 42.047895128628411, 52.5866397932556, 117.99279203678799, 168.11833297683248, 339.57693755905132, 602.78945521124683, 575.84605817489012, 1655.110641943653, 428.26170612042955, 532.10468308026725, 243.7977381142021, 166.94308947555166, 88.111783673752683, 92.997872357952346, 59.942241598726952, 38.618352638886499, 28.755794586161898, 22.71051405085084, 19.437247877391968, 15.231685744885109, 12.153630271581999, 9.8512979659284898, 9.0449476750100377, 8.4814596475391344, 8.3521719629346407, 10.039166730615969, 11.879784189493675, 14.114074884510734, 17.663953414249978, 21.286505123099776, 28.774499596319639, 38.943190919202728, 68.918403190937497, 65.896409871808544, 123.46347336694488, 199.11678861892523, 355.64805874163045, 474.06373686518356, 1107.4422783913496, 984.41049770348843, 815.85074837225181, 775.23575614375761, 273.92630278831501, 252.63182137130985, 111.28266970072293, 99.372032348096738, 60.83763087499851, 45.645009020283112, 36.908082411505283, 27.013361134530022, 21.576487249184932, 18.648763248771502, 14.768605661776908, 12.046190961831442, 10.575558887972219, 9.6753965965616082, 9.9180360789582664, 11.326670941483108, 14.591336257090044, 16.88229911294021, 23.015774601871662, 25.983945716982106, 36.109063293014408, 49.03950825563831, 89.938945070024914, 109.59850796272681, 133.72435362068057, 338.97998181689348, 367.74073917398209, 999.69929532757897, 694.18752080971819, 3103.247947012359, 571.91471358300578, 796.83467383546474, 376.32680369835435, 199.77708080210391, 136.28687846912629, 109.08321361427504, 70.699184140809436, 51.550546699271379, 43.783667443733499, 32.767703049824149, 28.843093953252076, 24.191492945877858, 17.780247836887195, 14.323695266188444, 12.534926448772453, 11.554737628486032, 12.047936614807259, 12.823063914611335, 16.384534464689928, 19.175053589853043, 25.236762604525165, 31.105878831006304, 44.902325426247451, 49.392087964292365, 77.618781225119008, 104.58138455482161, 154.6103662752277, 201.53841636767004, 549.34301727365869, 752.81814346176634, 1415.2337173839583, 4621.9583294760132, 796.99783843130297, 1746.1261590593119, 497.02834719870856, 350.74973626382069, 169.44044949721726, 180.68252449032624, 131.28843074347478, 69.641961050084447, 57.668339838268842, 38.934743351431905, 36.827824955920356, 29.753917874884323, 21.80969609662602, 16.679039087380357, 13.095932326486084, 12.868626938575838, 12.905268434713202, 14.567417800537427, 18.667040937787927, 24.216782409074952, 30.634459542886628, 36.063389145893439, 49.07312675198979, 55.491719795512452, 102.11362429348968, 137.27956630294753, 168.53157442290532, 414.07061143445821, 628.37101334838928, 1388.3341571422957, 1569.7087860062475, 13155.613426817548, 1764.3970599036886, 3554.1418329345083, 1002.4311488284069, 467.75549674428527, 329.4298401862315, 268.62846926573025, 168.65094690401969, 97.660119608993, 72.05947971074437, 45.570220260185501, 38.320413578940503, 33.821722307900103, 25.182119519265683, 18.218896084560566, 14.866315284596766, 14.232776105799996, 15.053935075225828, 16.371866219790657, 21.966647147933109, 28.877176436297923, 35.028553697203037, 40.777478884094542, 60.482972761941951, 82.275357677734107, 171.59960210222522, 197.20815781182262, 252.15177845425956, 383.13279083281282, 1400.1475599443277, 2812.4738667722154, 3416.7436429144982, 12599.263825927617, 3622.9684974910801, 5206.7688479804747, 1902.8385884755519, 1144.8252089743219, 711.66550404730719, 456.93769304342817, 238.43595357759864, 133.8729941689642, 97.518896272497358, 54.320387908275166, 41.847677620126085, 35.71723276926113, 26.276495829612255, 20.022228188848846, 15.990808141800953, 15.422836018027411, 14.766368476202668, 18.019210888715723, 26.681133724080873, 32.936640633650477, 41.192651249931764, 50.820570501635224, 81.30134061470001, 110.43978615629425, 212.43602421277993, 359.3048107396736, 515.14459200644205, 805.20630634633051, 1626.8549963375588, 5397.5422498759854, 3215.125406898349], "imag": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]}, "imag": [0.0, -0.14902020441330027, -0.67710495110878655, -0.6881801226004951, 0.029443579937724847, -0.20094871849937471, -0.68791245552521774, -0.72827812731264463, 0.078068344484514218, 0.41313375345763731, -0.11919960000393952, -0.71935556472958995, -0.033994075615829664, 0.79310271815610678, 1.0485412757882202, 0.31963459583846549, 0.0, -0.31963459583845072, -1.0485412757882226, -0.79310271815610678, 0.033994075615829379, 0.71935556472959095, 0.11919960000393916, -0.41313375345763476, -0.078068344484514218, 0.72827812731264185, 0.68791245552521862, 0.20094871849937485, -0.029443579937724836, 0.68818012260049433, 0.67710495110878632, 0.14902020441330027, 1.1657398208090677, -0.38761332589064507, -2.5163414932492363, -2.5847428019012222, 1.7065268205659907, -0.26659947141883028, -1.7612103334384195, -0.72822101015527074, 0.12179041297535136, 0.18687402270680736, -0.12109853545440831, -0.38401966930786352, -0.088335680660082488, 0.055468788382486998, -0.088649319780239585, 0.10356786689233256, 1.1808955745571665, -0.062779809082666185, -0.91400202990551882, -0.6085517196782837, 0.0094930924522060312, 0.20081299805530148, -0.06803304935655391, 0.012577652358335469, 0.033553295747053846, -0.13629795514777901, -0.55322476205333171, 0.16665348831683371, 1.6347625123407883, -1.2112325279336729, -2.7678867797785314, -1.1631005581009268, 0.53321212268228979, 0.65777424026102749, -0.0059595089834900304, 0.64333558032637317, -0.013400706408967681, -1.6693935905986217, -0.063469706678883048, 0.54580806133266158, -0.065590467240471795, -0.42286579957171455, -0.20235216162881253, 0.49440559267811185, 0.3198533678523926, -1.0020973416135801, -0.94614545335921363, -0.32112572063647837, 0.67188974240307031, 0.12355783613973209, 0.29355063118446922, 0.63795269671082688, 0.21171161290294277, -0.40654495049723688, -0.14885884441008196, 0.40518645419156046, 0.25176669622887876, -0.4761471503847452, -1.2694305395629708, -0.50115245917544937, 1.7379359185439549, -1.5104148448809891, -1.8127000456147733, 1.3511857905116147, -2.2248814745809709, -2.9260010474168467, 2.8988227737472689, 2.4923883909800804, -1.3958450829260902, -0.082278705724815937, 2.2133069351689647, 1.0491520212286578, -0.079840002578371538, -0.49590260672839781, -0.029646930580498103, 0.78872177906031093, 0.19612727406574681, -0.75096042381039763, -0.61442756278477972, -0.34589242057405933, -0.55827984508264517, -0.057639041847566158, 0.56000672509604699, 1.1779553213485192, 0.34297063731481625, -0.31700999971207366, -0.056952598408498582, 0.1857688253715537, 0.059515398961152523, -0.23070889488422375, -0.067289667533411021, -0.45052222849242474, -0.042895027980831071, 1.6598740406764962, 1.7912379411122816, -0.11630227482832883, -2.003866342355487, -2.7192489258221713, 0.9217002223108024, 0.99386370915341038, -0.45711185122492165, 0.97539351588020684, 0.30440417133895387, -0.076378287793857885, 0.10477257582077601, 0.078900323673397929, 0.2630152461937153, 0.031794382449249342, -0.11240615902951592, 0.23783868068434, 0.44775143101136344, -0.20105686300455952, -1.0552137607230396, -0.51401383512929344, 0.054526011609804782, -0.026488236207787865, 0.16590740229872669, 0.18522424653870803, 0.046314810086569159, -0.24537254610227913, -0.28481464669570439, 0.34829742340973674, 1.0879631977925206, 1.2627265059936403, -0.49634217295171235, 1.3751434251570953, 2.5572924798905374, -2.3835279088157275, -0.34512363817546704, 0.04627556386614428, -0.28363975810469, -0.2387205493926067, 1.1836766662488489, 0.7304559467631897, -1.0994633527727609, -0.56900890379210023, -0.052741079187555495, 0.36596287984784248, 0.15532358639646346, -0.36091327743771645, -0.19067540763230895, 0.71462283256924886, 0.60857599156682896, 0.051411148277875428, -0.20391538842359699, -0.25954108900834599, -0.53918948446164328, -0.5935512086649235, -0.13740024164207204, 0.43579638717256186, 0.22502803407041108, -0.23772213393956157, -0.22688331070114534, 0.42727537166712742, 0.47834844059991255, 0.32734133863952164, -0.52361461628388295, -0.20363203779578987, 0.71022032181918715, 0.2819659388244356, 1.3792526471429849, 1.5283654352438392, -1.3044681939973228, -1.1436891608956035, 1.3490121369222494, 0.71922211831958782, -0.27032254521482335, -0.33653973458463504, -0.15391447881479364, 0.12480482561109964, -0.053989084045087433, -0.18576918773324888, 0.077197958779916712, 0.29699641531309923, -0.11903191000719174, 0.22681336512596068, 0.54520489108855463, 0.040990511598931259, -0.20653728920388259, -0.37081845053148882, -0.07530964105542165, 0.12159159821884764, 0.14350417348960001, 0.043165763689791151, -0.057977138737883523, -0.1379293882828701, -0.37919334928832643, -0.48456288814685777, 0.97887759552535047, 0.57420771517448999, -1.1922323352837048, -0.13841464698630696, 0.7604729654567205, 0.58367944495087776, -0.034817975520708581, 0.18370340800622625, -0.031292542572728878, -0.067318712633041858, 0.33696607725615524, 0.05414244352918586, -0.020415046981723958, -0.074435708294427722, -0.05732302224609874, 0.14754486034992467, 0.17049224676424324, -0.35431714454113261, -0.378008901790788, -0.088220333609354634, 0.20519624064542319, 0.17151350221764664, 0.17699487940227424, 0.19591419189057305, 0.0065199157977709234, -0.1674811218328473, -0.10967941676700359, 0.13440132102674274, 0.069755270915603892, -0.34407110156451998, -0.47647271020395277, 0.24778628953900186, 0.94881647182464612, 0.71445852536721188, -0.69300717410155177, -0.23252823659006602, -0.70126327582172698, -0.73508712834563017, 0.77441038277434426, 0.80063078785779984, -0.29211349969120898, -0.50261897876845574, -0.15844491832687652, 0.10672884533820617, 0.083096171746834438, -0.061219034404081496, 0.041606427790415887, 0.31036717878062553, 0.16259404663751506, -0.36128817330809687, -0.29370929634970039, -0.3179547262684097, -0.4515155411552858, -0.033181026716305836, 0.29522952049075729, 0.48699666134020275, 0.18589909016841552, -0.2294714118021266, -0.20114354017885722, -0.003121578634498275, 0.059620355744470117, -0.08629332168254554, -0.013702104296225414, 0.27636362870999703, -0.20367519268137141, -0.071823375624897781, 0.65390853098071755, 0.57936885621079115, -0.082507324096629489, 0.056565164700343597, 0.30313037910422419, 0.046580925466156033, -0.14205860955679683, -0.10567626674414661, -0.14942985439330783, 0.021649684970292335, 0.030697590171757046, -0.022837521893794246, 0.043322807027412293, 0.15694334998636744, 0.01091806619852779, 0.020198601252688204, 0.29902161442575942, -0.15020855085379564, -0.40608170156430695, -0.21661403238492213, 0.10933934038264595, 0.1999075728830931, 0.14959651238129035, 0.047092746667091859, -0.040888308386862755, -0.1125167716796989, -0.043845680385689492, 0.15335701874304222, 0.24380570184994388, -0.1171131305850218, -0.57195255260213129, -0.37275928254301222, 0.52232110568095647, 0.45087452742355255, 0.45399067647357039, 0.4510373698265433, -0.25445646061023242, -0.54674967268083918, -0.081775771006690631, 0.2737673334004137, 0.18625608494518781, 0.012289477611188196, -0.028787447589128854, -0.055397340673381909, -0.033006645910307206, -0.3893684484392882, -0.59052876986306613, 0.35206862979259157, 0.75972882974271683, 0.47741066022580114, 0.61795462873852247, -0.010739694431020583, -0.30365007670052568, -0.79734464193821375, -0.40014152475128489, 0.35743197872152449, 0.33543159046029042, -0.048324103015847428, -0.1196515677085014, 0.073496444899392971, 0.11953255023805801, -0.055918533770930395, 0.0274579890256498, -0.087565507326424513, -0.47798364115462866, -0.30556827592707503, -0.053529165520136063, -0.064762544527802626, -0.40460920017095653, -0.121109915711457, 0.34242949885797147, 0.25707377311839885, 0.18878454879876447, 0.05963524828049447, -0.042881345638875606, 0.080317301592987653, -0.066661209183029674, -0.78426965250242053, -0.67203925142686172, 0.38802788881902983, 0.13118499909748943, 0.3117062095733994, 0.51892211454846937, 0.28497632977966614, -0.6374756986952439, -0.78570616426150541, -0.55004558199035003, 0.081464209729413414, 0.32078878775035424, 0.10057675741278467, -0.038856958620208222, -0.093816614253325048, -0.12197711394968046, 0.10773217761141921, 0.53279302352225322, 0.49767840692700166, -0.40074591616539607, -0.4686202607911239, -0.47347988353308479, -0.38787976346044234, 0.0026864061776988978, 0.3750647268903417, 0.15775363291879776, -0.12070461118398887, 0.046341940929038844, 0.069762555352500089, 0.036760253935025015, 0.11153094686031426, -0.23193620085952527, -0.025338164060148199, 0.83717158631584143, 0.14069991818818439, -0.80636013277763063, -1.117979830240589, -0.53116916718597551, -0.29647728355917563, 0.43255465109120794, 1.0682488929022527, 0.7439367652619796, -0.27653752308302104, -0.43736635010141273, -0.051946126514290911, 0.075483221784175089, 0.041517261114611535, 0.089698476442270109, 0.18582746405096062, 0.11108661545235869, 0.17635934890910801, 0.26257982919312395, 0.014915731745956722, -0.051592883258874553, -0.15702165108916452, 0.26018009521205254, 0.10187767444835746, -0.5266864552492494, -0.19184365339748963, 0.12365061867406398, -0.0040460672180273232, -0.10695443147688474, -0.38062982787546124, -0.23013531228214942, 1.4911852257492946, 1.8656257067805557, -0.31189832297292175, -1.8409665915911073, -1.3523062385443718, -0.59758078449912422, -0.4109826389978809, 0.64471434504327652, 1.2836469730056959, 1.499792380953558, -0.050007892106663135, -0.70097924672910039, -0.37676357011449496, 0.039596089571393787, 0.16672200998370845, 0.27616851123315678, 0.25535752279806784, -0.25821883180569144, -0.71643423075370694, -0.2869241470876478, 0.19246225810939122, -0.48949334565382685, -0.6758600491934259, -0.60078389394518394, -0.1042403296189125, 0.33526929000920908, 0.41773479752161374, -0.015233071039077716, -0.23129559015563347, -0.27890178606409965, -0.36644166250128341, 0.53421537629701843, 1.5124695265818406, 0.46952715514837384, -1.6086255934377758, -0.58627286749798335, 0.2521262787687128, 0.81274320419200763, 1.0066444599512538, 0.13589799436620603, -0.52681222515518755, -0.80035014449929209, 0.17170214273365031, 0.32102965848797577, 0.015298055895547559, -0.0095152173876638588, -0.05852775349790857, -0.29325388964527122, -0.23187846370788526, 0.12261389073580377, 0.13365949638292357, 0.34550584055022809, 0.32834338818238823, -0.63681653846377151, -0.14332768166025622, -0.050699039849278892, 0.076799367032860139, 0.62304231858822723, 0.13934878438080031, -0.36565795334395523, -0.22525673769874993, 0.058882171297733404, 0.45328032825037023, 0.67278513933730488, -0.62930489911730125, -2.1514876673114358, -0.38381606543972158, 1.7701780351745315, 2.2434589636984619, 1.3655631816809142, 0.67716955795129208, 0.23622587273603302, -1.2645365769339125, -1.1592659817915987, 0.22681074823924935, 1.0532421029439241, 0.47375681144418214, -0.017283859373080118, -0.31852036401253409, -0.42276437548587065, -0.20851072339742521, 0.32537663103197029, 0.67802433082994906, 0.64221455700256691, -0.19334381074242141, 0.0, 0.98534755955725073, 0.93082832187418163, 0.090975734109736334, -0.23547278252877649, -0.42043029453907255, -0.16156648245217306, 0.14891910968678568, 0.27252999755409263, 0.21807537509429559, -0.1793267317851967, -1.3886930910143056, -1.2475969582391058, 0.82617687521947225, 1.688041333210945, 0.93307675660552747, 0.0, -0.93307675660552858, -1.688041333210949, -0.82617687521947558, 1.2475969582391047, 1.3886930910143054, 0.17932673178519704, -0.21807537509429575, -0.27252999755409263, -0.14891910968678598, 0.16156648245217331, 0.42043029453907194, 0.23547278252877635, -0.090975734109735945, -0.93082832187418285, -0.9853475595572504, 0.63681653846377428, 0.19334381074242313, -0.64221455700256724, -0.67802433082995051, -0.32537663103196973, 0.20851072339742566, 0.42276437548587059, 0.31852036401253342, 0.017283859373080232, -0.47375681144418219, -1.0532421029439241, -0.22681074823925124, 1.1592659817916007, 1.2645365769339141, -0.23622587273603313, -0.67716955795129263, -1.3655631816809146, -2.2434589636984619, -1.7701780351745346, 0.38381606543971747, 2.1514876673114336, 0.62930489911730425, -0.67278513933730544, -0.45328032825037173, -0.058882171297733529, 0.22525673769874915, 0.36565795334395551, -0.1393487843807989, -0.6230423185882269, -0.076799367032859514, 0.050699039849279363, 0.14332768166025514, 0.48949334565382807, -0.32834338818238801, -0.34550584055022948, -0.13365949638292388, -0.12261389073580344, 0.23187846370788381, 0.29325388964527066, 0.058527753497908265, 0.0095152173876637894, -0.015298055895547204, -0.32102965848797627, -0.17170214273365259, 0.80035014449929354, 0.52681222515519222, -0.13589799436620179, -1.0066444599512541, -0.81274320419201052, -0.25212627876871579, 0.5862728674979838, 1.6086255934377784, -0.46952715514837307, -1.5124695265818422, -0.53421537629701898, 0.36644166250128374, 0.27890178606409988, 0.23129559015563281, 0.01523307103907798, -0.41773479752161302, -0.33526929000920919, 0.1042403296189123, 0.6007838939451835, 0.67586004919342602, 0.051592883258874796, -0.19246225810939102, 0.28692414708764713, 0.71643423075370816, 0.25821883180569155, -0.25535752279806728, -0.27616851123315733, -0.16672200998370851, -0.039596089571393857, 0.37676357011449418, 0.70097924672910006, 0.05000789210666385, -1.4997923809535563, -1.2836469730056956, -0.64471434504327885, 0.41098263899788057, 0.59758078449912211, 1.352306238544366, 1.8409665915911118, 0.31189832297292347, -1.8656257067805575, -1.4911852257492944, 0.23013531228214901, 0.3806298278754614, 0.10695443147688473, 0.0040460672180278982, -0.12365061867406386, 0.19184365339748918, 0.52668645524924984, -0.10187767444835667, -0.26018009521205249, 0.15702165108916435, 0.47347988353308512, -0.014915731745956694, -0.26257982919312345, -0.17635934890910804, -0.11108661545235819, -0.18582746405096062, -0.089698476442269984, -0.041517261114611431, -0.075483221784175006, 0.051946126514290501, 0.43736635010141267, 0.27653752308302265, -0.74393676526197827, -1.068248892902254, -0.43255465109120911, 0.29647728355917641, 0.53116916718597607, 1.1179798302405872, 0.80636013277763019, -0.14069991818818398, -0.83717158631584188, 0.025338164060147935, 0.2319362008595256, -0.11153094686031419, -0.036760253935025175, -0.069762555352499631, -0.046341940929038775, 0.12070461118398874, -0.15775363291879749, -0.37506472689034165, -0.0026864061776987339, 0.38787976346044295, 0.053529165520136666, 0.46862026079112395, 0.40074591616539496, -0.49767840692700188, -0.53279302352225388, -0.1077321776114199, 0.12197711394968033, 0.093816614253324923, 0.038856958620208139, -0.10057675741278502, -0.32078878775035391, -0.081464209729413262, 0.55004558199034881, 0.78570616426150586, 0.63747569869524534, -0.28497632977966464, -0.51892211454846815, -0.31170620957339795, -0.13118499909748749, -0.38802788881902978, 0.67203925142686127, 0.78426965250242042, 0.06666120918302984, -0.080317301592987847, 0.042881345638875745, -0.05963524828049447, -0.18878454879876405, -0.25707377311839802, -0.34242949885797153, 0.12110991571145559, 0.40460920017095686, 0.064762544527803223, -0.45399067647357122, 0.30556827592707503, 0.47798364115462999, 0.087565507326423986, -0.027457989025650414, 0.055918533770930486, -0.11953255023805759, -0.073496444899393262, 0.11965156770850158, 0.048324103015847719, -0.33543159046028986, -0.35743197872152471, 0.40014152475128417, 0.79734464193821419, 0.30365007670052546, 0.010739694431020585, -0.61795462873852236, -0.4774106602258017, -0.75972882974271716, -0.35206862979259274, 0.59052876986306602, 0.38936844843928831, 0.033006645910306921, 0.055397340673381999, 0.028787447589128854, -0.012289477611188065, -0.18625608494518778, -0.2737673334004137, 0.08177577100669034, 0.54674967268084007, 0.25445646061023275, -0.45103736982654352, 0.082507324096629073, -0.45087452742355144, -0.52232110568095624, 0.37275928254301144, 0.5719525526021314, 0.11711313058502268, -0.24380570184994438, -0.15335701874304256, 0.043845680385689638, 0.11251677167969909, 0.040888308386862651, -0.047092746667091887, -0.14959651238128985, -0.19990757288309219, -0.10933934038264552, 0.21661403238492188, 0.40608170156430567, 0.15020855085379528, -0.29902161442575986, -0.020198601252688145, -0.010918066198527492, -0.15694334998636708, -0.043322807027412154, 0.022837521893794229, -0.030697590171757067, -0.02164968497029204, 0.14942985439330775, 0.10567626674414606, 0.14205860955679689, -0.0465809254661547, -0.30313037910422319, -0.05656516470034452, 0.70126327582172698, -0.57936885621079104, -0.65390853098071722, 0.071823375624897504, 0.20367519268137155, -0.2763636287099972, 0.013702104296225327, 0.086293321682545693, -0.059620355744470117, 0.0031215786344983188, 0.20114354017885719, 0.22947141180212641, -0.1858990901684156, -0.48699666134020314, -0.29522952049075735, 0.033181026716305816, 0.4515155411552858, 0.31795472626840998, 0.29370929634969961, 0.36128817330809659, -0.16259404663751492, -0.3103671787806257, -0.041606427790415977, 0.061219034404081517, -0.083096171746834438, -0.10672884533820629, 0.1584449183268766, 0.50261897876845563, 0.29211349969120898, -0.80063078785779973, -0.77441038277434415, 0.73508712834562984, -0.7604729654567195, 0.23252823659006566, 0.69300717410155133, -0.71445852536721133, -0.94881647182464579, -0.247786289539003, 0.47647271020395332, 0.34407110156452003, -0.06975527091560392, -0.13440132102674238, 0.10967941676700353, 0.16748112183284758, -0.0065199157977711844, -0.19591419189057413, -0.17699487940227479, -0.17151350221764519, -0.20519624064542319, 0.088220333609354384, 0.37800890179078739, 0.35431714454113228, -0.17049224676424349, -0.14754486034992517, 0.05732302224609858, 0.074435708294427874, 0.020415046981723993, -0.054142443529185957, -0.33696607725615474, 0.067318712633042552, 0.031292542572729155, -0.183703408006228, 0.034817975520707763, -0.58367944495087642, -1.3792526471429849, 0.1384146469863056, 1.1922323352837043, -0.57420771517448999, -0.97887759552535036, 0.48456288814685816, 0.37919334928832632, 0.13792938828286982, 0.057977138737883592, -0.043165763689791442, -0.14350417348959951, -0.12159159821884727, 0.0753096410554214, 0.37081845053148832, 0.20653728920388284, -0.040990511598931294, -0.5452048910885553, -0.22681336512596068, 0.11903191000719161, -0.29699641531309889, -0.077197958779916934, 0.18576918773324919, 0.053989084045087239, -0.12480482561109926, 0.15391447881479356, 0.33653973458463499, 0.27032254521482346, -0.71922211831958716, -1.3490121369222496, 1.143689160895601, 1.3044681939973219, -1.5283654352438407, 0.34512363817546499, -0.28196593882443538, -0.71022032181918571, 0.20363203779578934, 0.52361461628388117, -0.32734133863952108, -0.47834844059991177, -0.4272753716671272, 0.22688331070114495, 0.23772213393956154, -0.22502803407041136, -0.43579638717256142, 0.13740024164207254, 0.59355120866492272, 0.53918948446164539, 0.25954108900834527, 0.20391538842359649, -0.051411148277873762, -0.60857599156682773, -0.71462283256924997, 0.19067540763230911, 0.36091327743771712, -0.15532358639646357, -0.36596287984784226, 0.052741079187555578, 0.56900890379209967, 1.0994633527727615, -0.73045594676318792, -1.18367666624885, 0.23872054939260659, 0.28363975810469044, -0.046275563866146709, 2.0038663423554866, 2.3835279088157284, -2.5572924798905374, -1.3751434251570973, 0.49634217295171212, -1.2627265059936426, -1.0879631977925208, -0.34829742340973796, 0.28481464669570433, 0.24537254610228046, -0.046314810086569187, -0.18522424653870898, -0.16590740229872719, 0.026488236207788063, -0.054526011609805532, 0.514013835129293, 1.0552137607230383, 0.20105686300456052, -0.44775143101136289, -0.23783868068434011, 0.11240615902951644, -0.031794382449249259, -0.26301524619371552, -0.078900323673398332, -0.10477257582077593, 0.076378287793858177, -0.30440417133895292, -0.97539351588020617, 0.45711185122492154, -0.99386370915341027, -0.92170022231080229, 2.7192489258221721, 2.2248814745809713, 0.11630227482833386, -1.7912379411122841, -1.6598740406764991, 0.042895027980832189, 0.45052222849242363, 0.067289667533409939, 0.23070889488422444, -0.059515398961152315, -0.18576882537155384, 0.056952598408498437, 0.31700999971207372, -0.3429706373148162, -1.1779553213485197, -0.56000672509604887, 0.057639041847566339, 0.55827984508264517, 0.34589242057405939, 0.6144275627847795, 0.75096042381039751, -0.19612727406574634, -0.78872177906031049, 0.029646930580497943, 0.49590260672839631, 0.079840002578371469, -1.0491520212286569, -2.2133069351689625, 0.082278705724815757, 1.3958450829260909, -2.4923883909800781, -2.8988227737472685, 2.926001047416845, -0.53321212268228979, -1.3511857905116138, 1.8127000456147735, 1.5104148448809913, -1.7379359185439534, 0.50115245917545159, 1.2694305395629717, 0.47614715038474426, -0.25176669622887887, -0.40518645419156096, 0.14885884441008229, 0.4065449504972391, -0.21171161290294366, -0.63795269671082933, -0.29355063118447033, -0.12355783613972898, -0.67188974240307053, 0.32112572063647804, 0.94614545335921341, 1.0020973416135777, -0.3198533678523926, -0.49440559267811113, 0.20235216162881259, 0.42286579957171511, 0.065590467240471767, -0.54580806133266224, 0.063469706678882465, 1.6693935905986201, 0.013400706408968283, -0.64333558032637317, 0.0059595089834898612, -0.65777424026102704, -1.1657398208090681, 1.1631005581009257, 2.7678867797785287, 1.2112325279336758, -1.6347625123407896, -0.16665348831683333, 0.5532247620533326, 0.13629795514777876, -0.033553295747053943, -0.012577652358336237, 0.068033049356555603, -0.20081299805530076, -0.0094930924522065932, 0.60855171967828092, 0.91400202990551482, 0.062779809082669502, -1.1808955745571674, -0.10356786689233179, 0.08864931978023799, -0.055468788382486117, 0.088335680660082266, 0.38401966930786247, 0.12109853545440752, -0.18687402270680636, -0.12179041297535122, 0.72822101015526997, 1.7612103334384188, 0.26659947141883078, -1.7065268205659894, 2.5847428019012186, 2.5163414932492363, 0.3876133258906464], "height": 32, "width": 32, "top": {"real": [28423.105313214044, 28674.724231095144, -722.69366896540907, 9225.7770064733304, 1497.6465357448014, 760.04278979701394, 247.10162746021342, 151.72529893327805, -4.8884885781823266, -16.133735393751934, -0.18360891080128469, 2.3500990684470797, -0.33005469194377962, 4.1571470713537551, 9.5943595112319517, -8.8624203891274274, -22.052590313243808, -8.8624203891274416, 9.5943595112320637, 4.1571470713537408, -0.33005469194377934, 2.3500990684471894, -0.18360891080150321, -16.133735393751511, -4.8884885781823266, 151.72529893327811, 247.10162746021339, 760.04278979701553, 1497.6465357448021, 9225.777006473334, -722.69366896540839, 28674.724231095115, 25390.170503473099, 2752.5053486176007, -7213.0026112046817, -848.38159326591301, 982.95511309135748, 457.86146922204989, -46.175546007130123, -28.684822585718617, 4.5612631126941601, 36.180920465642473, 1.491875160093084, -21.191137754573024, 2.8803824684767365, 32.414130280804258, 20.161840527236397, -4.0194858939287581, -5.5658589086089485, -1.4949158508676244, -19.561354112987054, -17.959748575409641, 0.86872374588173218, 25.323206346284437, 8.3348052170650675, -41.926948021480371, -20.687109086504861, 218.3167491556907, 546.49872794031398, 514.9954980598236, 620.49539711803413, 4452.6929959791041, -174.99103969876961, 2133.8618335997025, 26666.274860226469, 9631.0824500605449, -10095.4436331661, -4944.5276302554494, 770.97093894980139, 234.73611402062764, -189.92210588558362, -126.31904474729288, -4.4359398121268772, 25.844521173618485, 1.2207482283869857, -12.318944408119624, 7.2506028858091991, 18.769456353148023, 2.7720670784771717, 0.13907690271807935, 9.7740131156133714, 6.2313507558256029, -20.012525822291419, -16.040469196891664, 3.7834180501306807, 18.113814308198215, 6.9628905148897537, -1.8812165005783674, -3.1507841384785769, 24.526337675319898, 193.3623500499944, 465.72794392086701, 284.66528985874095, -3081.1066694335791, -9076.4400559658607, 1118.2132640961638, 5705.1501208043383, 397.85150159824235, -2822.6768689275941, 728.40381948841912, 1249.2695734137342, 82.616255878071726, -93.950748347298983, -33.623549275177439, -5.1522911915584819, -7.2338183321331133, -7.001283565832134, 11.310122449566075, 7.3973207504467258, -10.314744048939033, -17.670460817927417, 0.86416108685457238, -1.7856630822843305, 4.9636496941116963, 3.7892183180180301, 4.3540479322804604, 0.81912298615372481, -8.9239476494738241, -0.63615178952006057, 26.029536485331942, 20.179218397178587, -95.964038421947748, -279.42683310552798, -11.991282367617261, 1111.9285745591587, 12.384349101876612, -5014.4780810602624, -931.02314429185174, -2935.685284408914, -1215.2968180059599, 2222.0566542865231, 1545.4091719722733, -307.58274676435752, -163.25068439377958, 122.1532745420013, 76.416221889183532, 3.1644160240378296, -19.634567061108559, -1.3809484232923637, 15.595649759531634, 4.7705608814238305, -10.468288519634084, -9.7282165445191495, -3.892040076973144, -8.4797405266260863, -0.5408298481218079, 13.233921729082965, 15.992639239497516, 3.5976801907925586, -15.812600063085762, -8.7583525837485485, 13.529650759569922, 11.041451779488147, -36.837920974757942, -116.57081449547842, -177.82612582226329, 206.8817050386096, 1116.6649976696201, 1551.5341746851843, 206.06587874917457, 221.21501338856706, 949.59692563201861, 2377.7643188321972, 271.30602644407116, -752.63562664968606, -131.94201270845676, 66.794183325011446, 26.328209125885053, -2.6512991036295719, -7.060878043009799, 3.4956142029525408, 4.0712276182145608, -0.49091417497970008, -0.54247114501895244, 2.5929708279440629, -2.2683391883792092, -3.9697444489461264, 0.64738652825819076, 4.555701357906309, 5.0432051545575858, 1.8637246814391786, -2.1415599665130838, -3.0402232986351168, -7.5278540025228704, -9.1564876386533562, 18.733705732232028, 116.47631097371497, 62.470104114045292, -587.35890158810116, -665.30895184878261, 1602.7477447230021, 2320.4028678586192, 84.3231427941042, 335.33509531572889, 111.12995285997569, -246.89163612982301, 99.59266396905916, 121.29447232003599, -19.935724961316957, -24.271547137145927, -9.9392605214134129, 3.6463495838243953, 2.4659870551932221, -4.9118061115950002, -3.9830584925921726, 3.1158463847663604, 4.6325922286854171, 0.7426231797993057, 2.6761268245222913, 0.75707810610464332, -2.0529004071821726, -5.4726123906428121, -3.3500885842682195, 4.7318552060186496, 3.3081314176561212, -7.5747009667011485, -9.660327017316277, 13.948321679490391, 60.920555877786029, 51.912766255688908, -200.57409151559827, -358.55234539419581, 389.87395397760162, 626.9468569152699, 385.67355889894168, 266.46730452215979, -754.85949807698285, -357.47689087779764, 198.35300746583653, 104.20178335269868, 0.2335042399832746, -13.459048177551795, -2.4931441622280337, 3.3591145464251499, -0.87332830625456936, -5.0562417941567173, -2.0170485858323599, 2.3079461733716489, 1.2848757720394648, 1.0044515769395077, 2.2715095300739048, 1.0357721766880663, -1.8190548566089728, -3.9293196367766434, -3.2116043474898985, 1.2474845862739923, 2.207161661351936, 0.30672454240560637, -1.2664097847556852, 1.1634429445003909, -12.548270616696369, -13.623126322836848, 148.11914826060797, 160.05821428876476, -517.73406283289592, -683.78444654557211, 232.19478887738595, 129.53848012256918, -30.629684625724426, 14.007085088982263, -28.536726784912368, -22.150721493101905, 7.4458049666709201, 6.5426060710782901, 2.7181624419475532, -0.21791167804934167, -2.1894859760859342, -0.30261213114781382, 1.6929032656017511, 0.075295172141104427, -2.5525542005113677, 0.092868468976744334, 0.059811282681573222, 0.44341981227717964, 0.7816687865488906, 1.8071322433818207, 1.0194826794166407, -1.7022885447654383, -1.6578557975757291, 1.4780948040669197, 2.3190205805607031, -2.0993082250693513, -8.8242080507891387, 6.7426676795129614, 63.308016957216438, 32.614432065456008, -214.97833639893088, -154.136284333817, -153.00121169652448, -168.20144264926009, 132.73656142769508, 108.19035464369672, -32.411936148940164, -29.299646468639978, 0.48512698058416193, 5.624023137620874, 1.3789304004393061, -2.3621905210139289, -1.2100039550542188, 4.3583730663879736, 4.4422506314578856, -3.3529459489445013, -3.2593326279479276, -2.3921307524924811, -2.978651033636929, -0.78921784490688773, 2.0776847434633869, 4.6706759151301158, 3.7169173278476082, -1.8762573022143243, -3.6928619255631911, -0.82171694591384903, 1.0313698171467438, -0.47387208215225501, 4.5050179323404294, 12.279477314121408, -23.426373610246564, -47.509829762735897, 96.770610724801742, 142.54719834919302, -140.65053169937673, -123.6545784250871, -20.023908130365463, 5.7599623270112001, 10.838125249555288, 8.3690034326252576, -0.61869787578431057, -1.9872713177733001, -0.88566790635833359, -1.3475268812751358, 0.76129128976144478, 4.1066846542201834, 0.69320146991960074, -1.2677968128954245, 0.81553632831789258, -1.6303291884460738, -2.2291497640151472, -1.5668982951183865, 1.2058440679467928, 2.0699393017293768, 1.4972394562433364, -0.45863502618354141, -1.2690924739742997, -0.78463693252535771, -0.71980764244508078, 0.10250612713533153, 2.393822328408012, -0.41309740564872016, -15.44378212490165, 0.6609566018409474, 72.351368761661817, 25.384635851249769, 24.183834027615426, 48.560459752587064, -30.885786753212521, -41.646585437272115, 4.9406680758638473, 9.7637208498293564, -2.6994657893152145, -2.3673227042220928, 0.99131130124397382, 1.9229365129251841, 1.0659834826624002, -5.2481714738530103, -7.2759438909005807, 4.8682061863604567, 9.822573727789889, 5.6528275472549172, 2.0386422190351761, 0.27431668194701375, -2.1164683881366688, -6.0913412323542273, -4.1102964274349301, 3.1073479985221883, 4.720787089742764, 1.4415919680128015, 0.049935137368385736, 0.23499648430732389, -3.983837312738201, -10.315757961787851, 3.7701904804417365, 17.40344272954281, -26.485594572094836, -57.180963546905772, 56.164057478325546, 74.232658958160258, -2.1566648897744729, -33.253025139779027, -16.080807358669208, -7.6408862919476457, -0.061535710181698199, 4.3516423276699152, 3.0483876930594445, 1.4396821019147403, -2.1531487354432772, -12.330021507307762, -6.784080497103278, 6.2189314368004602, 6.5359347127328817, 5.8394886675864184, 6.5502057137602838, 2.8897971357633669, -4.5807084372558364, -7.1480702421459901, -3.5449281234624839, 3.1166956033252706, 5.7654746814446929, 1.4593710853505601, 0.079551299266885034, 1.7754263793290057, 1.1602778115858083, -4.1621952562095537, -6.1090111539332135, -21.585708623899716, -64.660963126416291, -42.918674159823304, -12.637618832694352, -23.660098526273554, -32.757377164957738, -16.139835139531076, -8.8214501105659302, -0.074083275956097649, 9.2347297800775099, 4.0583945463193585, -1.3379386144670409, -1.0708228123536387, -3.7494033803061741, -1.4014962110675557, 6.3397919866467625, -0.03663393601032304, -6.5449789794813107, -2.0617294503879311, 2.9031092319630374, 1.9851413256277737, 1.0607201932740675, 2.7050589244056695, 2.9910202735510598, -2.6114709035663148, -2.998378794740129, -0.21466478532365837, -0.045062120129980232, 0.26663892053888355, 4.6476599377621559, 4.3038853444793466, -6.8220974094569344, -12.449318624888502, -10.129633105210658, -14.243655171088259, -24.590264561101538, -60.147765518061014, -2.4700759029582726, 27.756533006476555, 4.2749753092209222, 1.5109008418257455, 2.3037162841058008, -3.3991123070026288, -2.3657348243984693, -1.7285717434362748, 1.4807803344279866, 11.452735641829591, 12.838038879276603, -0.48093805977912302, -8.4823730361517384, -10.096707565442667, -5.1613641497068938, -2.6506938623127332, 9.4081369631901755, 9.4967470257992304, 1.5732629424154292, -6.2329583900406389, -7.3741953717279571, -0.66458216201047882, 2.3894666174155379, 0.72026798365788192, -2.7056126524381918, -1.4278421900811593, 6.2735441200134945, 15.997118782527094, 32.340859723792008, 29.293996905608573, 6.5830123071218694, -6.0118236769643065, 35.32705272368031, 28.93384981751958, 4.6778289682139205, -4.8626411358427797, -9.0689375245571853, -5.8403695985513542, -0.88764146409061928, 0.44619327315923196, 2.0930545096716431, 8.2346460399114871, 4.4412927362425512, -3.9444092199360696, -3.9225599509162312, 0.038172103710441746, -1.1645390667947013, 3.8468081061273272, 3.825131103533594, 0.73794607986345129, -4.4683377641176865, -3.1226055206334693, -1.659659462142453, -1.5916869216083986, 0.66773943004769798, 3.4159390288117701, 1.5141668200491456, 0.24760595741359728, -0.60433400901725032, -18.385421885703135, -9.3028295113894721, 25.73026622408986, 16.23212758885586, 17.912434056418146, -8.8649857221999238, -22.650006821252305, -4.6057627844621933, 3.1371579845110453, -0.064465121107319889, -0.7788946841662594, -1.4905827462536891, -1.6111207980069511, 3.9054962114874257, 1.1954905638175628, -5.7282279624444916, -8.3976603765003119, -2.0078722367450874, 4.7029696271178913, 9.1972361583870761, 4.7029696271178825, -2.0078722367450905, -8.3976603765003119, -5.7282279624444836, 1.1954905638175473, 3.9054962114874288, -1.6111207980069395, -1.4905827462536891, -0.77889468416625518, -0.064465121107317946, 3.1371579845110462, -4.6057627844621942, -22.650006821252259, -8.8649857221999415, 17.912434056418164, 6.583012307121729, 25.730266224089799, -9.3028295113894721, -18.385421885703128, -0.60433400901726175, 0.24760595741359434, 1.5141668200491516, 3.415939028811767, 0.66773943004769509, -1.5916869216084077, -1.6596594621424434, -3.1226055206334529, -4.4683377641176723, 0.73794607986344696, 3.8251311035336037, 3.8468081061273467, -1.1645390667946849, 0.038172103710459718, -3.9225599509162259, -3.9444092199360838, 4.4412927362425298, 8.2346460399114854, 2.0930545096716502, 0.44619327315923041, -0.88764146409061584, -5.8403695985513515, -9.0689375245571728, -4.862641135842777, 4.6778289682139134, 28.933849817519487, 35.327052723680374, -6.0118236769642888, -24.590264561101595, 29.293996905608687, 32.340859723791993, 15.997118782527064, 6.2735441200134687, -1.4278421900811535, -2.7056126524381958, 0.72026798365787437, 2.3894666174155401, -0.66458216201047282, -7.3741953717279607, -6.2329583900406416, 1.5732629424154319, 9.4967470257992108, 9.4081369631901666, -2.6506938623127225, -5.1613641497068841, -10.096707565442674, -8.4823730361517544, -0.48093805977915227, 12.83803887927658, 11.452735641829598, 1.4807803344279824, -1.7285717434362824, -2.3657348243984719, -3.3991123070026203, 2.3037162841058088, 1.5109008418257512, 4.2749753092209266, 27.756533006476598, -2.470075902958246, -60.147765518061043, -12.637618832694358, -14.243655171088175, -10.12963310521061, -12.449318624888507, -6.8220974094569566, 4.3038853444793421, 4.6476599377621488, 0.26663892053888499, -0.045062120129979372, -0.21466478532365083, -2.998378794740133, -2.6114709035663206, 2.9910202735510656, 2.7050589244056806, 1.0607201932740935, 1.9851413256277779, 2.9031092319630249, -2.0617294503879293, -6.5449789794813169, -0.036633936010327744, 6.339791986646766, -1.4014962110675422, -3.7494033803061728, -1.0708228123536432, -1.3379386144670453, 4.0583945463193594, 9.2347297800775188, -0.074083275956095859, -8.8214501105659284, -16.139835139531023, -32.757377164957752, -23.660098526273632, 56.164057478325425, -42.918674159823318, -64.660963126416391, -21.585708623899666, -6.1090111539332215, -4.1621952562095581, 1.1602778115858134, 1.775426379329013, 0.079551299266884423, 1.4593710853505546, 5.7654746814447053, 3.1166956033252631, -3.5449281234624781, -7.1480702421459874, -4.5807084372558347, 2.8897971357633647, 6.5502057137602785, 5.8394886675864104, 6.5359347127329022, 6.2189314368004851, -6.78408049710327, -12.330021507307773, -2.1531487354432741, 1.439682101914743, 3.04838769305944, 4.3516423276699179, -0.061535710181697623, -7.6408862919476563, -16.080807358669187, -33.253025139779005, -2.1566648897745, 74.232658958160258, 24.183834027615593, -57.180963546905936, -26.485594572094925, 17.403442729542817, 3.7701904804417596, -10.315757961787877, -3.9838373127381965, 0.23499648430733011, 0.049935137368386437, 1.4415919680127984, 4.7207870897427613, 3.1073479985221901, -4.1102964274349274, -6.0913412323542424, -2.1164683881366799, 0.27431668194701325, 2.0386422190351805, 5.6528275472549048, 9.822573727789889, 4.8682061863604691, -7.2759438909005807, -5.2481714738530263, 1.0659834826623993, 1.9229365129251905, 0.99131130124397682, -2.3673227042220857, -2.699465789315211, 9.7637208498293848, 4.9406680758638624, -41.646585437272229, -30.885786753212596, 48.560459752587221, -140.65053169937659, 25.384635851249651, 72.351368761661789, 0.66095660184101279, -15.443782124901649, -0.41309740564871933, 2.3938223284080151, 0.10250612713533497, -0.71980764244507844, -0.78463693252535704, -1.2690924739742999, -0.45863502618354285, 1.4972394562433307, 2.0699393017293644, 1.2058440679467857, -1.5668982951183805, -2.2291497640151445, -1.6303291884460729, 0.81553632831788769, -1.2677968128954307, 0.69320146991959397, 4.1066846542201878, 0.76129128976144589, -1.3475268812751391, -0.88566790635833126, -1.9872713177733001, -0.61869787578431157, 8.3690034326252771, 10.838125249555295, 5.7599623270111371, -20.023908130365466, -123.65457842508674, -153.00121169652476, 142.547198349193, 96.770610724801799, -47.509829762735976, -23.426373610246678, 12.279477314121431, 4.505017932340448, -0.47387208215225296, 1.0313698171467449, -0.82171694591384781, -3.6928619255631867, -1.8762573022143267, 3.7169173278476135, 4.6706759151301114, 2.0776847434633798, -0.78921784490688629, -2.9786510336369223, -2.3921307524924669, -3.2593326279479267, -3.3529459489444933, 4.4422506314578865, 4.3583730663879798, -1.2100039550542185, -2.3621905210139329, 1.3789304004393068, 5.6240231376208731, 0.48512698058415527, -29.29964646863997, -32.411936148940157, 108.19035464369668, 132.73656142769508, -168.20144264926049, 232.19478887738595, -154.13628433381695, -214.97833639893091, 32.614432065455887, 63.308016957216388, 6.7426676795129818, -8.8242080507891405, -2.0993082250693487, 2.3190205805607031, 1.4780948040669208, -1.657855797575728, -1.7022885447654388, 1.0194826794166389, 1.8071322433818233, 0.78166878654889338, 0.44341981227717431, 0.059811282681573222, 0.092868468976748497, -2.5525542005113593, 0.075295172141105315, 1.6929032656017555, -0.30261213114781177, -2.1894859760859413, -0.21791167804934622, 2.7181624419475532, 6.5426060710782918, 7.4458049666709138, -22.150721493101912, -28.536726784912382, 14.007085088982294, -30.629684625724458, 129.53848012256904, 385.67355889894196, -683.78444654557279, -517.73406283289592, 160.05821428876459, 148.1191482606082, -13.623126322836866, -12.548270616696426, 1.1634429445003742, -1.2664097847556794, 0.30672454240560415, 2.2071616613519298, 1.2474845862739898, -3.2116043474898839, -3.9293196367766487, -1.8190548566089664, 1.0357721766880712, 2.2715095300739065, 1.0044515769394997, 1.2848757720394559, 2.3079461733716413, -2.0170485858323568, -5.0562417941567217, -0.87332830625457158, 3.3591145464251335, -2.4931441622280368, -13.459048177551766, 0.23350423998331427, 104.20178335269858, 198.35300746583647, -357.47689087779742, -754.85949807698285, 266.46730452215979, 84.323142794104228, 626.94685691527002, 389.87395397760116, -358.55234539419558, -200.57409151559838, 51.912766255688851, 60.920555877786029, 13.948321679490393, -9.6603270173162681, -7.5747009667011582, 3.3081314176561238, 4.7318552060186576, -3.3500885842682231, -5.472612390642829, -2.0529004071821806, 0.75707810610465265, 2.676126824522286, 0.74262317979931325, 4.6325922286854091, 3.1158463847663604, -3.9830584925921673, -4.9118061115949914, 2.4659870551932261, 3.6463495838243847, -9.9392605214134129, -24.271547137145948, -19.935724961316961, 121.29447232003592, 99.592663969059103, -246.89163612982315, 111.12995285997523, 335.33509531572906, 221.21501338856802, 2320.4028678586192, 1602.7477447230024, -665.30895184878284, -587.35890158810128, 62.470104114045164, 116.47631097371504, 18.733705732232092, -9.1564876386533669, -7.5278540025228837, -3.0402232986351114, -2.1415599665130745, 1.8637246814391684, 5.0432051545575796, 4.5557013579063117, 0.64738652825819132, -3.9697444489461211, -2.2683391883791986, 2.59297082794407, -0.54247114501893734, -0.49091417497970297, 4.0712276182145537, 3.4956142029525421, -7.0608780430097635, -2.6512991036295777, 26.328209125884918, 66.794183325011389, -131.94201270845636, -752.63562664968617, 271.3060264440702, 2377.7643188321958, 949.59692563201872, -2935.685284408913, 206.06587874917372, 1551.534174685185, 1116.6649976696197, 206.88170503860968, -177.82612582226307, -116.57081449547834, -36.837920974758035, 11.041451779488151, 13.529650759569909, -8.7583525837485361, -15.812600063085752, 3.5976801907925351, 15.992639239497519, 13.233921729082972, -0.54082984812181611, -8.479740526626081, -3.8920400769731613, -9.7282165445191335, -10.468288519634076, 4.7705608814238323, 15.595649759531605, -1.3809484232923479, -19.634567061108552, 3.1644160240378296, 76.416221889183575, 122.15327454200114, -163.25068439377961, -307.58274676435752, 1545.4091719722737, 2222.0566542865222, -1215.2968180059584, 5705.1501208043328, -931.02314429184867, -5014.4780810602606, 12.384349101875989, 1111.9285745591585, -11.991282367617289, -279.42683310552832, -95.964038421947791, 20.179218397178591, 26.029536485331974, -0.63615178952006546, -8.9239476494738614, 0.81912298615373047, 4.354047932280479, 3.7892183180180292, 4.9636496941116457, -1.7856630822843349, 0.86416108685458326, -17.670460817927413, -10.314744048939055, 7.3973207504467204, 11.310122449566087, -7.0012835658321206, -7.2338183321331515, -5.1522911915584801, -33.623549275177297, -93.950748347298841, 82.616255878071172, 1249.2695734137344, 728.4038194884231, -2822.6768689275882, 397.85150159823706, 26666.274860226469, 1118.2132640961736, -9076.4400559658625, -3081.1066694335805, 284.6652898587414, 465.72794392086666, 193.36235004999409, 24.526337675320004, -3.1507841384785733, -1.8812165005783184, 6.9628905148897147, 18.113814308198211, 3.7834180501306891, -16.040469196891639, -20.012525822291416, 6.2313507558256083, 9.7740131156133696, 0.1390769027181136, 2.7720670784771526, 18.76945635314798, 7.2506028858092133, -12.318944408119592, 1.2207482283869953, 25.844521173618411, -4.435939812126878, -126.31904474729296, -189.92210588558356, 234.73611402062767, 770.97093894980162, -4944.5276302554457, -10095.4436331661, 9631.082450060534, 25390.170503473091, 2133.8618335997035, -174.99103969877373, 4452.6929959791023, 620.49539711803243, 514.99549805982349, 546.49872794031364, 218.31674915569133, -20.687109086504822, -41.926948021480328, 8.3348052170650853, 25.323206346284447, 0.86872374588174384, -17.959748575409694, -19.561354112987079, -1.4949158508675975, -5.5658589086089423, -4.0194858939287954, 20.161840527236293, 32.414130280804187, 2.8803824684767667, -21.191137754573067, 1.4918751600931279, 36.180920465642465, 4.5612631126941521, -28.684822585719061, -46.175546007129988, 457.86146922204938, 982.95511309135657, -848.38159326591563, -7213.0026112046844, 2752.5053486175875], "imag": [0.0, -3169.9451614941381, -2389.0092924747519, -2824.6185770767256, 47.140985329040632, -205.51829185355012, -383.71835019762682, -205.9732988135564, 11.332172552374439, 43.76909201728548, -7.034291101336307, -32.133345787281364, -1.2408409398708855, 22.626534078219475, 22.834188196398234, 5.8606054504390173, 0.0, -5.8606054504387375, -22.834188196398308, -22.626534078219454, 1.2408409398708751, 32.133345787281435, 7.0342911013362928, -43.769092017285352, -11.332172552374439, 205.97329881355589, 383.71835019762727, 205.51829185355027, -47.140985329040632, 2824.6185770767256, 2389.009292474751, 3169.9451614941386, 14687.463554763033, -1246.2254521233822, -13582.059524928778, -4205.001741520543, 1374.1061578688877, -137.33727593318653, -632.81134552884873, -154.70037614560013, 13.450507164884565, 15.193108572125329, -6.1542966587055341, -15.818788310912929, -2.909480569030046, 1.479970160345879, -1.5973907882613358, 1.5293212848264928, 18.21275880080945, -1.003899882219808, -18.30035720783934, -15.99060672422979, 0.33906699281555863, 8.403557604549265, -3.6955816316308372, 1.2265587756840484, 4.4918801658948704, -32.498332906337446, -252.78924650714879, 118.6015387642415, 1871.5173348139303, -2304.7799937689852, -14411.746659687838, -4213.8766814139526, 7014.7325605010174, 2247.44595388478, -16.760963274859961, 900.76474301933899, -5.1342500455989466, -420.94056280958415, -12.516743930999253, 93.660446148871657, -5.3964791524595173, -25.576180637452808, -8.2514109979697761, 17.318312851322737, 9.236462137217643, -22.012718711107286, -15.490166786860247, -4.834205749446653, 9.5628562714065293, 1.836849747935801, 5.3481684451070093, 16.065001056209898, 7.1604513809609767, -15.578970641484018, -6.7835303274441205, 29.197525074885235, 24.587565667273296, -80.302667778037872, -341.00518268197084, -165.09457453510524, 812.92907888826301, -1514.0868881615295, -6442.5930626817562, 2384.0282361623322, -10283.309463536394, -4592.9695519937077, 4024.534672295305, 1566.1446188979135, -577.97842695498832, -13.866559817282136, 303.84181615530144, 107.13271532249853, -4.4304590515519831, -24.335491476624799, -1.0691687945057899, 24.162065431216654, 4.7495715205351985, -14.018208973927269, -8.9506230152518427, -4.4638345370409525, -7.1842950536944761, -0.75483699139922611, 9.34037405707282, 25.690847574014661, 10.204720176161787, -11.674788778672609, -2.2174348022320634, 10.712979752882786, 4.1447690963328192, -30.289408767911031, -12.158067002051448, -76.336688904244483, -15.045419751305701, 825.0044509954804, 3127.7274260756976, -92.692661642821449, -6218.4941130018287, -3848.3727657836507, 693.87265018831545, 545.97208874512432, -92.125598598764668, 150.80594875272075, 31.835009702890954, -5.9283896106206289, 5.1749362811852588, 3.5428080098191677, 8.1813203788089979, 0.80238728202918663, -2.1553941232205127, 3.896876060708947, 5.7415452177174027, -2.4223203414509196, -12.192718147122756, -6.4431256169971434, 0.78101397437949727, -0.4709674045364774, 4.0135477523785683, 5.3424403453362856, 1.5176299437256986, -10.74330995836436, -14.68235074512339, 24.624343673414469, 118.67852190927127, 172.09305386209979, -99.157790391266047, 517.50332981617737, 2037.7393191154626, -1363.1746812874464, -339.74333242555031, 32.123918954310476, -283.55446630414355, -87.787271289656218, 401.24269480211609, 97.679749329289763, -120.49954302359174, -51.176060542512822, -2.5863965882294027, 13.214576791319574, 4.0359196374926878, -8.3066986443292503, -3.2190392651304429, 10.42730204701207, 6.8931399993642719, 0.50989762348064183, -1.9729622551402084, -2.7447920706561999, -6.4951794944364067, -8.7659237408433199, -2.5623445767069972, 9.4029551910696547, 6.0787635497373449, -8.7738681104802421, -10.356090763505474, 25.994421343462481, 47.534456712956128, 36.427418067214397, -132.28171420843677, -55.780171242651143, 550.58818821416037, 230.04212220540037, 2282.8157342153072, 1692.5764998210254, -618.40106666814791, -406.75082987636517, 268.61096451191207, 88.797660850068112, -17.813285237066509, -23.19378111787497, -5.993920933714092, 3.5911964041653288, -1.1492389141172172, -3.281418277923168, 1.0895777711511168, 3.5282533189728529, -1.1949811908258732, 1.894384229023907, 4.6241332834085442, 0.37075703258422543, -2.0346603770225924, -4.5067903456406357, -1.1470927861162812, 2.3634060343879923, 3.2590535483912988, 1.2412658338184401, -2.2389815887732318, -8.267796716016413, -35.26417469610022, -42.695700376724766, 163.41685001540142, 139.99054216726472, -634.39240892418218, -59.277692870412778, 635.10435435478166, 336.10950761267088, -20.987908495686451, 62.381440709915225, -5.2608500919337384, -7.9431228598947987, 17.719913727215761, 2.2765757875228916, -0.5781253977177655, -1.861000889502646, -1.1416693103444284, 2.4821587471930475, 1.9877494352069631, -3.6722851782283747, -3.348161983991842, -0.65436436680629395, 1.4913973744886961, 1.3020502991963898, 1.5364454784416322, 2.0332502155623371, 0.082811915307875697, -2.7287340233180468, -2.0624150870013023, 3.1666191865848514, 2.1277795836536475, -15.762070711071239, -31.080087158567022, 16.264563798793048, 168.22104098804192, 119.10647254618513, -340.95280202269214, -119.21079977674056, -524.16143614722125, -474.83791951425451, 238.16973599672059, 238.87620399289383, -30.950251690797295, -43.007655043750781, -7.0781110181685483, 4.2933368018010754, 2.128510229721456, -1.3556643805285902, 0.67118052098401426, 4.1580113773740086, 1.6924135574018535, -3.2368514600901537, -2.3674255865410236, -2.2397386036010594, -2.8392755347081424, -0.22727952120054792, 2.1660066162361877, 4.1257252023454543, 1.8555476250524485, -3.0110538491549583, -3.3997614112807475, -0.064441197381949922, 1.4400236898496321, -2.5651430892865172, -0.57406913069513732, 14.545275998521815, -21.097880653370396, -8.386658477188135, 246.29297742969297, 177.82681762874435, -29.410757783669329, 21.206487630199256, 82.341423257084315, 9.4629909259569072, -12.117042155983494, -8.2057292966872932, -5.3672622769763416, 0.7159440642377497, 0.69394420462213224, -0.39501642572828111, 0.57804318775345176, 1.8269742232979342, 0.10217887910111716, 0.16688705386232044, 1.9755117613475777, -0.94372823495475977, -2.4667123640612325, -1.3772827491468491, 0.74627343874194729, 1.5703957699483431, 1.3943774862563845, 0.51087952435755024, -0.57473339559817926, -2.0019592491226121, -0.94447858069522983, 4.1105720381539621, 9.8748960802998482, -5.0693062852843767, -52.44341015820585, -37.642264259816841, 117.83245857703734, 130.78419594725884, 169.61465367155833, 186.83060708175802, -35.974218698264572, -86.880281148446372, -5.2203740194539208, 16.971669187755321, 6.0698179812651247, 0.35231673872141245, -0.53044914356261097, -0.81632535007713047, -0.39583117800855089, -4.4385250403688277, -5.1472849145985213, 2.545092404453277, 5.0071357876878793, 2.743807769745191, 3.4897745997776024, -0.063125314946314764, -1.9440922443950184, -5.9326946820069502, -3.385188090942465, 3.6658395382201929, 4.0455837767151035, -0.6661551017179177, -2.2326980338070728, 1.6846667556373658, 3.8137132042051891, -1.9181620538698931, 1.6441956870289249, -6.1270500694313146, -76.595893205927055, -49.969516616017785, -7.9132321269474106, -11.568908095829089, -47.805112772715709, -13.830481688679152, 18.277275877397457, 14.698934402888547, 6.2184742035979967, 1.4890022076822711, -0.74744399004349582, 1.078974533533704, -0.78904970661953722, -8.2729456489475783, -5.409011823874466, 2.7622883519807897, 0.8473850486901422, 1.8128818460693508, 2.8420219491550718, 1.5362703897962247, -3.7595900673998903, -5.6022288243818803, -4.1625158390656765, 0.71295082461726678, 3.6372516960945322, 1.3208871209715871, -0.62400754176455042, -1.768358539761187, -3.6168192973638713, 3.6735963806245331, 31.275163257132462, 32.479329698147204, -39.759969700967346, -68.584232650917357, -57.469468975158698, -64.297371445934317, 0.20861011566533649, 34.25783205331058, 6.9534765415767215, -5.3793483456417883, 1.2524657598045081, 1.5450348766267965, 0.56608571170600441, 1.3866526144820828, -2.467818437504425, -0.23634501606433136, 6.3450244574570114, 0.9543505178876851, -4.984602859992024, -6.3381420012322005, -2.7435850611580781, -1.5807425386703018, 2.421504137076397, 6.8428975986621223, 5.3939316426610251, -2.3287200765196823, -4.7978450785431628, -0.63133403867009485, 1.1146429476849253, 0.7514356381637266, 2.2717048597800691, 5.5350475212285941, 5.1571773922734927, 9.2792987920179275, 21.682075132354747, 1.4867450129376456, -4.4700114725605324, -18.272390809448236, 16.714318324621598, 7.3089787270008628, -20.071959549384122, -7.0841774280620697, 3.2022160216960311, -0.077988270864014025, -1.5775612503840553, -4.3715375274672654, -2.1765426316142653, 13.260687049653976, 13.879467714343647, -1.8852486869718339, -10.527030755482089, -6.8369811071974125, -3.0333474188096656, -2.1407969562984661, 3.722272454853548, 7.6257272547055521, 10.117490783509389, -0.39109059001006397, -6.9982476982268125, -4.2960092579610025, 0.55901791170159865, 2.6155137759572247, 6.5895285486459425, 7.4061452615413605, -10.366283361455007, -35.34703723782264, -16.933453520111545, 16.224692124004221, -34.34332526355967, -71.738587010679367, -34.450969879654501, -6.2640778700882249, 11.746214635705909, 13.031958951769729, -0.3480472785242843, -3.9968553356395629, -3.964707435958017, -4.2096432311062548, 4.9158294568057652, 12.338227697160551, 3.5088489717994391, -9.6887588471648289, -3.3007173968474173, 1.3223986051066356, 3.9779056054352555, 5.2139034331477543, 0.73966749617948313, -3.1538649748494341, -5.201358311154781, 1.2046804216345655, 2.9426249963390902, 0.16125203808628796, -0.12580690156457183, -1.0212362026563724, -6.277158135649886, -5.6679546723264744, 4.2381986446151707, 5.7560371617010828, 18.621646756873353, 24.734309444721209, -36.387091300098106, -10.759792351985398, -2.2461784763603254, 3.6933656200181786, 20.866503857704814, 3.7918232583171383, -8.2103085682208885, -3.9258378390443029, 0.83382202471681166, 4.801181266459511, 6.1897358407630447, -4.7613942589703724, -14.056893094185043, -2.2289578077004246, 10.245900399003714, 12.011271759567334, 7.3710550588087713, 3.5515726304902269, 1.2929923686914595, -7.4124476338006691, -7.5787947999111838, 1.7154740370529804, 9.3123854476054735, 4.9777565316787626, -0.24109318982965802, -5.1766732320109883, -9.3092191729240525, -5.246693773893865, 10.274800595678272, 28.322088715789157, 27.586929135138202, -13.506737972920812, 0.0, 72.992093909712537, 40.674766306359388, 3.6677612059140889, -7.0101784555215705, -11.074353780690299, -3.5600519087446321, 2.4941865000982566, 3.5007885216085395, 2.2952423730960096, -1.6579656325825838, -10.397334640078137, -8.5183394179138396, 4.679962930220257, 8.9265575080577193, 4.8985021447705659, 0.0, -4.8985021447705712, -8.9265575080577282, -4.6799629302202739, 8.5183394179138361, 10.397334640078139, 1.6579656325825878, -2.2952423730960114, -3.5007885216085395, -2.4941865000982615, 3.5600519087446361, 11.074353780690284, 7.010178455521566, -3.6677612059140743, -40.674766306359437, -72.992093909712509, 36.387091300098248, 13.506737972920931, -27.586929135138188, -28.322088715789224, -10.274800595678252, 5.2466937738938775, 9.3092191729240525, 5.1766732320109785, 0.24109318982965933, -4.9777565316787626, -9.3123854476054682, -1.7154740370529937, 7.5787947999111918, 7.4124476338006797, -1.2929923686914602, -3.5515726304902286, -7.3710550588087731, -12.011271759567332, -10.245900399003729, 2.2289578077004006, 14.05689309418503, 4.7613942589703955, -6.1897358407630483, -4.8011812664595261, -0.83382202471681333, 3.9258378390442905, 8.2103085682208921, -3.7918232583171019, -20.866503857704799, -3.6933656200181462, 2.2461784763603472, 10.759792351985324, 34.343325263559734, -24.734309444721188, -18.621646756873407, -5.7560371617010961, -4.2381986446151565, 5.6679546723264433, 6.2771581356498745, 1.0212362026563664, 0.12580690156457094, -0.16125203808628427, -2.9426249963390938, -1.2046804216345817, 5.2013583111547899, 3.1538649748494616, -0.73966749617946026, -5.2139034331477525, -3.9779056054352657, -1.322398605106651, 3.3007173968474182, 9.6887588471648343, -3.5088489717994329, -12.338227697160564, -4.9158294568057723, 4.2096432311062539, 3.9647074359580197, 3.9968553356395535, 0.34804727852429029, -13.031958951769711, -11.746214635705918, 6.2640778700882196, 34.450969879654494, 71.738587010679424, 4.4700114725605502, -16.224692124004207, 16.933453520111492, 35.34703723782269, 10.366283361455015, -7.4061452615413437, -6.5895285486459567, -2.615513775957226, -0.55901791170159942, 4.2960092579609945, 6.9982476982268116, 0.39109059001006968, -10.117490783509375, -7.6257272547055521, -3.7222724548535622, 2.1407969562984639, 3.0333474188096563, 6.8369811071973849, 10.527030755482111, 1.8852486869718446, -13.879467714343662, -13.260687049653979, 2.1765426316142595, 4.3715375274672708, 1.5775612503840555, 0.077988270864025142, -3.2022160216960267, 7.0841774280620511, 20.071959549384133, -7.3089787270008086, -16.714318324621601, 18.272390809448193, 57.469468975158712, -1.4867450129376421, -21.682075132354715, -9.2792987920179293, -5.1571773922734714, -5.5350475212285986, -2.2717048597800669, -0.75143563816372472, -1.114642947684924, 0.63133403867008997, 4.7978450785431628, 2.3287200765196983, -5.3939316426610153, -6.842897598662133, -2.4215041370764028, 1.5807425386703056, 2.7435850611580817, 6.3381420012321907, 4.9846028599920196, -0.95435051788768221, -6.3450244574570167, 0.23634501606432906, 2.4678184375044308, -1.3866526144820814, -0.56608571170600686, -1.5450348766267858, -1.2524657598045066, 5.3793483456417848, -6.9534765415767081, -34.25783205331058, -0.20861011566532392, 64.297371445934417, 7.9132321269475003, 68.584232650917386, 39.759969700967275, -32.479329698147232, -31.275163257132508, -3.6735963806245575, 3.616819297363866, 1.7683585397611854, 0.6240075417645492, -1.3208871209715913, -3.6372516960945265, -0.71295082461726456, 4.1625158390656667, 5.6022288243818847, 3.7595900673999001, -1.5362703897962169, -2.842021949155066, -1.8128818460693434, -0.8473850486901302, -2.7622883519807888, 5.4090118238744633, 8.2729456489475819, 0.78904970661953955, -1.0789745335337066, 0.74744399004349849, -1.4890022076822718, -6.2184742035979834, -14.69893440288851, -18.277275877397457, 13.830481688678995, 47.805112772715752, 11.568908095829199, -169.61465367155867, 49.969516616017778, 76.595893205927254, 6.1270500694312791, -1.6441956870289614, 1.918162053869898, -3.8137132042051767, -1.6846667556373722, 2.2326980338070745, 0.66615510171792158, -4.0455837767150955, -3.6658395382201951, 3.3851880909424605, 5.9326946820069546, 1.9440922443950184, 0.063125314946314778, -3.4897745997776015, -2.7438077697451946, -5.0071357876878766, -2.5450924044532854, 5.1472849145985169, 4.4385250403688321, 0.39583117800854778, 0.81632535007713181, 0.53044914356261075, -0.35231673872140901, -6.0698179812651212, -16.971669187755335, 5.2203740194539012, 86.880281148446528, 35.974218698264636, -186.83060708175819, 29.41075778366919, -130.78419594725855, -117.83245857703733, 37.64226425981672, 52.443410158205879, 5.0693062852844104, -9.8748960802998642, -4.1105720381539701, 0.94447858069523327, 2.0019592491226157, 0.57473339559817749, -0.5108795243575508, -1.3943774862563805, -1.570395769948336, -0.74627343874194474, 1.3772827491468478, 2.4667123640612241, 0.94372823495475699, -1.9755117613475803, -0.16688705386232, -0.10217887910111442, -1.8269742232979298, -0.57804318775345009, 0.39501642572828077, -0.69394420462213291, -0.71594406423774049, 5.367262276976339, 8.2057292966872506, 12.117042155983503, -9.4629909259566443, -82.341423257084145, -21.206487630199604, 524.16143614722125, -177.82681762874424, -246.29297742969288, 8.386658477188103, 21.097880653370403, -14.545275998521824, 0.57406913069513366, 2.5651430892865226, -1.4400236898496321, 0.064441197381950838, 3.3997614112807506, 3.0110538491549557, -1.8555476250524514, -4.1257252023454569, -2.1660066162361895, 0.22727952120054773, 2.8392755347081424, 2.2397386036010616, 2.3674255865410174, 3.236851460090151, -1.6924135574018513, -4.1580113773740104, -0.67118052098401537, 1.3556643805285893, -2.128510229721456, -4.2933368018010798, 7.0781110181685527, 43.007655043750773, 30.950251690797295, -238.87620399289392, -238.16973599672059, 474.83791951425417, -635.10435435478075, 119.21079977674036, 340.95280202269191, -119.10647254618499, -168.22104098804189, -16.264563798793112, 31.080087158567054, 15.762070711071249, -2.1277795836536488, -3.1666191865848456, 2.0624150870013005, 2.7287340233180508, -0.082811915307879028, -2.0332502155623482, -1.5364454784416388, -1.3020502991963789, -1.4913973744886957, 0.65436436680629262, 3.3481619839918371, 3.6722851782283725, -1.987749435206966, -2.4821587471930564, 1.1416693103444246, 1.8610008895026517, 0.5781253977177665, -2.2765757875228969, -17.719913727215747, 7.9431228598948822, 5.2608500919337864, -62.381440709915822, 20.987908495685961, -336.10950761266997, -2282.8157342153086, 59.27769287041221, 634.3924089241824, -139.99054216726466, -163.41685001540142, 42.695700376724787, 35.264174696100213, 8.2677967160164005, 2.2389815887732354, -1.2412658338184486, -3.2590535483912864, -2.3634060343879861, 1.1470927861162765, 4.5067903456406286, 2.0346603770225951, -0.37075703258422554, -4.6241332834085505, -1.8943842290239064, 1.1949811908258721, -3.5282533189728493, -1.0895777711511203, 3.281418277923172, 1.1492389141172139, -3.591196404165319, 5.9939209337140893, 23.193781117874966, 17.813285237066506, -88.797660850068027, -268.61096451191219, 406.75082987636472, 618.40106666814768, -1692.5764998210257, 339.74333242554815, -230.04212220540018, -550.58818821415935, 55.780171242650994, 132.2817142084364, -36.427418067214319, -47.534456712956064, -25.994421343462484, 10.356090763505458, 8.773868110480235, -6.0787635497373476, -9.4029551910696316, 2.5623445767070061, 8.7659237408433039, 6.4951794944364281, 2.7447920706561946, 1.972962255140204, -0.50989762348062517, -6.8931399993642568, -10.427302047012086, 3.2190392651304447, 8.3066986443292699, -4.0359196374926896, -13.214576791319564, 2.5863965882294058, 51.176060542512751, 120.49954302359184, -97.679749329289564, -401.24269480211632, 87.787271289656246, 283.554466304144, -32.12391895431216, 6218.4941130018287, 1363.174681287448, -2037.7393191154631, -517.5033298161776, 99.157790391266019, -172.09305386210005, -118.67852190927132, -24.624343673414536, 14.682350745123385, 10.743309958364414, -1.5176299437256995, -5.3424403453363087, -4.013547752378579, 0.47096740453648078, -0.7810139743795077, 6.4431256169971372, 12.192718147122749, 2.4223203414509316, -5.7415452177173938, -3.8968760607089528, 2.1553941232205212, -0.80238728202918486, -8.1813203788090068, -3.5428080098191872, -5.1749362811852562, 5.9283896106206555, -31.835009702890844, -150.80594875272081, 92.125598598764682, -545.97208874512432, -693.87265018831545, 3848.372765783648, 10283.309463536396, 92.692661642825414, -3127.7274260757022, -825.00445099548233, 15.045419751306099, 76.336688904244284, 12.158067002051251, 30.289408767911102, -4.1447690963328059, -10.712979752882784, 2.2174348022320558, 11.674788778672612, -10.204720176161779, -25.690847574014658, -9.3403740570728662, 0.75483699139922822, 7.1842950536944734, 4.4638345370409516, 8.9506230152518249, 14.018208973927262, -4.7495715205351878, -24.162065431216647, 1.0691687945057857, 24.335491476624739, 4.4304590515519813, -107.13271532249837, -303.84181615530116, 13.866559817282113, 577.97842695498844, -1566.1446188979132, -4024.5346722953059, 4592.969551993704, -7014.7325605010174, -2384.0282361623326, 6442.5930626817571, 1514.086888161532, -812.92907888826267, 165.09457453510592, 341.00518268197106, 80.302667778037787, -24.587565667273314, -29.197525074885242, 6.783530327444133, 15.578970641484096, -7.1604513809610006, -16.065001056209955, -5.3481684451070297, -1.8368497479357557, -9.5628562714065364, 4.8342057494466477, 15.490166786860224, 22.012718711107244, -9.236462137217643, -17.318312851322709, 8.2514109979697903, 25.57618063745285, 5.3964791524595155, -93.660446148871785, 12.516743930999144, 420.94056280958409, 5.1342500455991793, -900.76474301933945, 16.760963274859485, -2247.4459538847777, -14687.463554763033, 4213.8766814139472, 14411.746659687837, 2304.7799937689902, -1871.5173348139317, -118.60153876424121, 252.7892465071493, 32.498332906337396, -4.4918801658948837, -1.2265587756841234, 3.6955816316309309, -8.4035576045492331, -0.33906699281557884, 15.990606724229716, 18.300357207839266, 1.0038998822198608, -18.212758800809453, -1.5293212848264821, 1.5973907882613065, -1.4799701603458557, 2.909480569030038, 15.818788310912904, 6.1542966587054897, -15.193108572125247, -13.450507164884552, 154.70037614559999, 632.81134552884851, 137.3372759331867, -1374.1061578688873, 4205.0017415205384, 13582.05952492878, 1246.225452123387]}};

  /*
 * MOSSE correlation filter
 *
 * Optional parameters to constructor:
 *   drawResponse {canvasElement} : draws the correlation filter output on the given canvas element (default is none)
 *   psrThreshold {number} : peak-to-sidelobe-ratio threshold to use when updating filter while tracking (default is 10)
 *   eta {number} : adjusts how much new input affects the mosse filter, when updating filter while tracking
 *     number should be between 0 and 1 (default is 0.1)
 *   convertToGrayscale {boolean} : whether to convert canvas output to grayscale (default is true)
 *     if this is set to false, we assume all channels are equal and only grab values from red channel
 *
 * @author auduno / github.com/auduno
 */

  function mosseFilter(params) {

    var _filter, _top, _bottom;
    var _fft;
    var _w,_h;
    var _im_part;
    var _arrlen;
    var _cc;
    var _image_array;

    this.psr_prev = undefined;
    this.peak_prev = undefined;
    var updateable = false;

    if (!params) params = {};
    // setup of canvas for drawing responses, if given
    if (params.drawResponse === undefined) {
      params.drawResponse = false;
    } else {
      if (params.drawResponse.tagName != 'CANVAS') {
        params.drawResponse = false;
      } else {
        var responseContext = params.drawResponse.getContext('2d');
      }
    }
    if (params.psrThreshold === undefined) params.psrThreshold = 10;
    if (params.eta === undefined) params.eta = 0.10;
    if (params.convertToGrayscale === undefined) params.convertToGrayscale = true;

    this.load = function(filter) {
      // initialize filter width and height
      _w = filter.width;
      _h = filter.height;
      _arrlen = _w*_h;
      _filter = [filter.real, filter.imag];
      // handling top and bottom when they're not present
      if (filter.top && filter.bottom) {
        updateable = true;
        _top = [filter.top.real, filter.top.imag];
        _bottom = [filter.bottom.real, filter.bottom.imag];
      }

      // initialize fft to given width
      _fft = new FFT();
      _fft.init(filter.width);

      // set up temporary variables
      if(typeof Float64Array !== 'undefined') {
        _im_part = new Float64Array(_arrlen);
        _image_array = new Float64Array(_arrlen);
      } else {
        _im_part = new Array(_arrlen);
        _image_array = new Array(_arrlen);
      }
      var canvas = document.createElement("canvas");
      canvas.setAttribute('width', _w);
      canvas.setAttribute('height', _h);
      _cc = canvas.getContext('2d');
    };

    this.init = function(w,h) {
      // initialize filter width and height for a blank filter
      _w = w;
      _h = h;
      _arrlen = _w*_h;

      _filter = [[],[]];
      _top = [[],[]];
      _bottom = [[],[]];
      for (var i = 0;i < _arrlen;i++) {
        _filter[0][i] = 0;
        _filter[1][i] = 0;
        _top[0][i] = 0;
        _top[1][i] = 0;
        _bottom[0][i] = 0;
        _bottom[1][i] = 0;
      }
      updateable = true;

      // initialize fft to given width
      _fft = new FFT();
      _fft.init(w);

      // set up temporary variables
      if(typeof Float64Array !== 'undefined') {
        _im_part = new Float64Array(_arrlen);
      } else {
        _im_part = new Array(_arrlen);
      }
      var canvas = document.createElement("canvas");
      canvas.setAttribute('width', _w);
      canvas.setAttribute('height', _h);
      _cc = canvas.getContext('2d');
    };

    // fft function
    this.fft = function(array) {
      // not in-place

      var cn = new Array(_arrlen);
      for (var i = 0;i < _arrlen;i++) {
        cn[i] = 0.0;
      }

      _fft.fft2d(array,cn);
      return [array, cn];
    };

    // fft function
    this.fft_inplace = function(array) {
      // in-place

      for (var i = 0;i < _arrlen;i++) {
        _im_part[i] = 0.0;
      }

      _fft.fft2d(array,_im_part);
      return [array, _im_part];
    };

    this.ifft = function(rn, cn) {
      // in-place
      _fft.ifft2d(rn, cn);
      return rn;
    };

    // peak to sidelobe ratio function (optional)
    this.psr = function(array) {
      // proper
      var sum = 0;
      var max = 0;
      var maxpos = [0, 0];
      var sdo = 0;
      var val;
      for (var x = 0;x < _w;x++) {
        for (var y = 0;y < _h;y++) {
          val = array[(y*_w)+x];
          sum += val;
          sdo += (val*val);
          if (max < val) {
            max = val;
            maxpos = [x,y];
          }
        }
      }

      // subtract values around peak
      for (var x = -5;x < 6;x++) {
        for (var y = -5;y < 6;y++) {
          if (Math.sqrt(x*x+y*y) < 5) {
            val = array[((maxpos[1]+y)*_w)+(maxpos[0]+x)];
            sdo -= (val*val);
            sum -= val;
          }
        }
      }

      var mean = sum/array.length;
      var sd = Math.sqrt((sdo/array.length)-(mean*mean));

      // get mean/variance of output around peak
      var psr = (max-mean)/sd;
      return psr;
    };

    this.getResponse = function(imageData) {
      // in-place

      // preprocess
      var prepImage = preprocess(imageData);
      prepImage = cosine_window(prepImage);

      // filter
      var res = this.fft_inplace(prepImage);

      // elementwise multiplication with filter
      complex_mult_inplace(res, _filter);

      // do inverse 2d fft
      var filtered = this.ifft(res[0],res[1]);
      return filtered;
    };

    this.track = function(input, left, top, width, height, updateFilter, gaussianPrior, calcPSR) {
      // finds position of filter in input image

      if (!_filter) {
        console.log("Mosse-filter needs to be initialized or trained before starting tracking.");
        return false;
      }

      if (input.tagName == "VIDEO" || input.tagName == "IMG") {
        // scale selection according to original source image
        var videoLeft = Math.round((left/input.width)*input.videoWidth);
        var videoTop = Math.round((top/input.height)*input.videoHeight);
        var videoWidth = Math.round((width/input.width)*input.videoWidth);
        var videoHeight = Math.round((height/input.height)*input.videoHeight);
        _cc.drawImage(input, videoLeft, videoTop, videoWidth, videoHeight, 0, 0, _w, _h);
      } else if (input.tagName == "CANVAS") {
        _cc.drawImage(input, left, top, width, height, 0, 0, _w, _h);
      }

      var image = _cc.getImageData(0,0,_w,_h);
      var id = image.data;

      if (params.convertToGrayscale) {
        // convert to grayscale
        for (var i = 0;i < _arrlen;i++) {
          _image_array[i] = id[(4*i)]*0.3;
          _image_array[i] += id[(4*i)+1]*0.59;
          _image_array[i] += id[(4*i)+2]*0.11;
        }
      } else {
        // use only one channel
        for (var i = 0;i < _arrlen;i++) {
          _image_array[i] = id[(4*i)];
        }
      }

      // preprocess
      var prepImage = preprocess(_image_array);
      prepImage = cosine_window(prepImage);

      // filter
      var res = this.fft_inplace(prepImage);
      // elementwise multiplication with filter
      var nures = complex_mult(res, _filter);
      // do inverse 2d fft
      var filtered = this.ifft(nures[0],nures[1]);

      // find max and min
      var max = 0;
      var min = 0;
      var maxpos = [0, 0];

      //method using centered gaussian prior
      if (gaussianPrior) {
        var prior, dx, dy;
        var variance = 128;
        for (var x = 0;x < _w;x++) {
          for (var y = 0;y < _h;y++) {
            dx = x - _w/2;
            dy = y - _h/2;
            prior = Math.exp(-0.5*((dx*dx)+(dy*dy))/variance);
            if ((filtered[(y*_w)+x]*prior) > max) {
              max = filtered[(y*_w)+x]*prior;
              maxpos = [x,y];
            }
            if (filtered[(y*_w)+x] < min) {
              min = filtered[(y*_w)+x];
            }
          }
        }
      } else {
        for (var x = 0;x < _w;x++) {
          for (var y = 0;y < _h;y++) {
            if (filtered[(y*_w)+x] > max) {
              max = filtered[(y*_w)+x];
              maxpos = [x,y];
            }
            if (filtered[(y*_w)+x] < min) {
              min = filtered[(y*_w)+x];
            }
          }
        }
      }
      this.peak_prev = max;

      if (params.drawResponse) {
        // draw response
        var diff = max-min;
        var dc = document.createElement('canvas');
        dc.setAttribute('width', 32);
        dc.setAttribute('height', 32);
        var dcc = dc.getContext('2d');
        var psci = dcc.createImageData(32, 32);
        var pscidata = psci.data;
        for (var j = 0;j < 32*32;j++) {
          //draw with priors
          //var val = filtered[j]*Math.exp(-0.5*(((j%_w - _w/2)*(j%_w -_w/2))+((Math.floor(j/_h)-(_h/2))*(Math.floor(j/_h)-(_h/2))))/128);
          var val = filtered[j];
          val = Math.round((val+Math.abs(min))*(255/diff));
          pscidata[j*4] = val;
          pscidata[(j*4)+1] = val;
          pscidata[(j*4)+2] = val;
          pscidata[(j*4)+3] = 255;
        }
        dcc.putImageData(psci, 0, 0);
        responseContext.drawImage(dc, left, top, width, width);
      }

      if (calcPSR) {
        this.psr_prev = this.psr(filtered);
      }

      if (updateFilter) {
        if (!updateable) {
          console.log("The loaded filter does not support updating. Ignoring parameter 'updateFilter'.");
        } else {
          if (calcPSR) {
            var psr = this.psr_prev;
          } else {
            var psr = this.psr(filtered);
          }

          if (psr > params.psrThreshold) {
            // create target
            var target = [];
            var nux = maxpos[0];
            var nuy = maxpos[1];
            for (var x = 0;x < _w;x++) {
              for (var y = 0;y < _h;y++) {
                target[(y*_w)+x] = Math.exp(-(((x-nux)*(x-nux))+((y-nuy)*(y-nuy)))/(2*2));
              }
            }

            //fft target
            target = this.fft(target);

            // create filter
            var res_conj = complex_conj(res);
            var fuTop = complex_mult(target,res_conj);
            var fuBottom = complex_mult(res,res_conj);

            // add up
            var eta = params.eta;
            for (var i = 0;i < _arrlen;i++) {
              _top[0][i] = eta*fuTop[0][i] + (1-eta)*_top[0][i];
              _top[1][i] = eta*fuTop[1][i] + (1-eta)*_top[1][i];
              _bottom[0][i] = eta*fuBottom[0][i] + (1-eta)*_bottom[0][i];
              _bottom[1][i] = eta*fuBottom[1][i] + (1-eta)*_bottom[1][i];
            }

            _filter = complex_div(_top,_bottom);
          }
        }
      }

      /*if (psr < 5) {
          maxpos = [_w/2,_h/2];
        }*/

      maxpos[0] = maxpos[0]*(width/_w);
      maxpos[1] = maxpos[1]*(width/_h);

      // check if output is strong enough
      // if not, return false?
      if (max < 0) {
        return false;
      } else {
        return maxpos;
      }
    };

    this.train = function(input, left, top, width, height) {

      if (!updateable) {
        console.log("The loaded filter does not support updating. Unable to do training.");
        return false;
      }

      if (input.tagName == "VIDEO" || input.tagName == "IMG") {
        // scale selection according to original source image
        var videoLeft = Math.round((left/input.width)*input.videoWidth);
        var videoTop = Math.round((top/input.height)*input.videoHeight);
        var videoWidth = Math.round((width/input.width)*input.videoWidth);
        var videoHeight = Math.round((height/input.height)*input.videoHeight);
        _cc.drawImage(input, videoLeft, videoTop, videoWidth, videoHeight, 0, 0, _w, _h);
      } else if (input.tagName == "CANVAS") {
        _cc.drawImage(input, left, top, width, height, 0, 0, _w, _h);
      }

      var image = _cc.getImageData(0,0,_w,_h);
      var id = image.data;

      // convert to grayscale
      for (var i = 0;i < _arrlen;i++) {
        _image_array[i] = id[(4*i)]*0.3;
        _image_array[i] += id[(4*i)+1]*0.59;
        _image_array[i] += id[(4*i)+2]*0.11;
      }

      // preprocess
      var prepImage = preprocess(_image_array);
      prepImage = cosine_window(prepImage);

      // create target
      var target = [];
      var nux = _w/2;
      var nuy = _h/2;
      for (var x = 0;x < _w;x++) {
        for (var y = 0;y < _h;y++) {
          target[(y*_w)+x] = Math.exp(-(((x-nux)*(x-nux))+((y-nuy)*(y-nuy)))/(2*2));
        }
      }

      //fft target
      target = this.fft(target);

      // filter
      var res = this.fft(prepImage);
      // create filter
      var res_conj = complex_conj(res);
      var fuTop = complex_mult(target,res_conj);
      var fuBottom = complex_mult(res,res_conj);

      // add up
      var eta = params.eta;
      for (var i = 0;i < _arrlen;i++) {
        _top[0][i] = eta*fuTop[0][i] + (1-eta)*_top[0][i];
        _top[1][i] = eta*fuTop[1][i] + (1-eta)*_top[1][i];
        _bottom[0][i] = eta*fuBottom[0][i] + (1-eta)*_bottom[0][i];
        _bottom[1][i] = eta*fuBottom[1][i] + (1-eta)*_bottom[1][i];
      }

      _filter = complex_div(_top,_bottom);

      return true;
    };

    var preprocess = function(array) {
      // in-place

      // log adjusting
      for (var i = 0;i < _arrlen;i++) {
        array[i] = Math.log(array[i]+1);
      }

      // normalize to mean 0 and norm 1
      var mean = 0;
      for (var i = 0;i < _arrlen;i++) {
        mean += array[i];
      }
      mean /= _arrlen;

      for (var i = 0;i < _arrlen;i++) {
        array[i] -= mean;
      }
      var norm = 0.0;
      for (var i = 0;i < _arrlen;i++) {
        norm += (array[i]*array[i]);
      }
      norm = Math.sqrt(norm);
      if (norm !== 0) {
        for (var i = 0;i < _arrlen;i++) {
          array[i] /= norm;
        }
      }

      return array;
    };

    var cosine_window = function(array) {
      // calculate rect cosine window (in-place)
      var pos = 0;
      for (var i = 0;i < _w;i++) {
        for (var j = 0;j < _h;j++) {
          //pos = (i%_w)+(j*_w);
          var cww = Math.sin((Math.PI*i)/(_w-1));
          var cwh = Math.sin((Math.PI*j)/(_h-1));
          array[pos] = Math.min(cww,cwh)*array[pos];
          pos++;
        }
      }

      return array;
    };

    var complex_mult = function(cn1, cn2) {
      // not in-place
      var re_part = new Array(_w);
      var im_part = new Array(_w);
      var nucn = [re_part, im_part];
      for (var r = 0;r < _arrlen;r++) {
        nucn[0][r] = (cn1[0][r]*cn2[0][r]) - (cn1[1][r]*cn2[1][r]);
        nucn[1][r] = (cn1[0][r]*cn2[1][r]) + (cn1[1][r]*cn2[0][r]);
      }
      return nucn;
    };

    var complex_mult_inplace = function(cn1, cn2) {
      // in-place
      var temp1, temp2;
      for (var r = 0;r < _arrlen;r++) {
        temp1 = (cn1[0][r]*cn2[0][r]) - (cn1[1][r]*cn2[1][r]);
        temp2 = (cn1[0][r]*cn2[1][r]) + (cn1[1][r]*cn2[0][r]);
        cn1[0][r] = temp1;
        cn1[1][r] = temp2;
      }
    };

    var complex_conj = function(cn) {
      // not in-place (TODO)
      var nucn = [[],[]];
      for (var i = 0;i < _arrlen;i++) {
        nucn[0][i] = cn[0][i];
        nucn[1][i] = -cn[1][i];
      }
      return nucn;
    };

    var complex_div = function(cn1, cn2) {
      // not in-place (TODO)
      var nucn = [[],[]];
      for (var r = 0;r < _arrlen;r++) {
        nucn[0][r] = ((cn1[0][r]*cn2[0][r])+(cn1[1][r]*cn2[1][r])) / ((cn2[0][r]*cn2[0][r]) + (cn2[1][r]*cn2[1][r]));
        nucn[1][r] = ((cn1[1][r]*cn2[0][r])-(cn1[0][r]*cn2[1][r])) / ((cn2[0][r]*cn2[0][r]) + (cn2[1][r]*cn2[1][r]));
      }
      return nucn;
    };
  }

  var mosse = {
    mosseFilter : mosseFilter,
    filters : {
      left_eye_filter : left_eye_filter,
      right_eye_filter : right_eye_filter,
      mouth_filter : mouth_filter,
      nose_filter : nose_filter,
      face_filter : face_filter
    }
  };

  var jsfeat_1 = createCommonjsModule(function (module) {
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     */

// namespace ?
    var jsfeat = jsfeat || { REVISION: 'ALPHA' };
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     */

    (function(global) {
      "use strict";
      //

      // CONSTANTS
      var EPSILON = 0.0000001192092896;
      var FLT_MIN = 1E-37;

      // implementation from CCV project
      // currently working only with u8,s32,f32
      var U8_t = 0x0100,
        S32_t = 0x0200,
        F32_t = 0x0400,
        S64_t = 0x0800,
        F64_t = 0x1000;

      var C1_t = 0x01,
        C2_t = 0x02,
        C3_t = 0x03,
        C4_t = 0x04;

      var _data_type_size = new Int32Array([ -1, 1, 4, -1, 4, -1, -1, -1, 8, -1, -1, -1, -1, -1, -1, -1, 8 ]);

      var get_data_type = (function () {
        return function(type) {
          return (type & 0xFF00);
        }
      })();

      var get_channel = (function () {
        return function(type) {
          return (type & 0xFF);
        }
      })();

      var get_data_type_size = (function () {
        return function(type) {
          return _data_type_size[(type & 0xFF00) >> 8];
        }
      })();

      // color conversion
      var COLOR_RGBA2GRAY = 0;
      var COLOR_RGB2GRAY = 1;
      var COLOR_BGRA2GRAY = 2;
      var COLOR_BGR2GRAY = 3;

      // box blur option
      var BOX_BLUR_NOSCALE = 0x01;
      // svd options
      var SVD_U_T = 0x01;
      var SVD_V_T = 0x02;

      var data_t = (function () {
        function data_t(size_in_bytes, buffer) {
          // we need align size to multiple of 8
          this.size = ((size_in_bytes + 7) | 0) & -8;
          if (typeof buffer === "undefined") {
            this.buffer = new ArrayBuffer(this.size);
          } else {
            this.buffer = buffer;
            this.size = buffer.length;
          }
          this.u8 = new Uint8Array(this.buffer);
          this.i32 = new Int32Array(this.buffer);
          this.f32 = new Float32Array(this.buffer);
          this.f64 = new Float64Array(this.buffer);
        }
        return data_t;
      })();

      var matrix_t = (function () {
        // columns, rows, data_type
        function matrix_t(c, r, data_type, data_buffer) {
          this.type = get_data_type(data_type)|0;
          this.channel = get_channel(data_type)|0;
          this.cols = c|0;
          this.rows = r|0;
          if (typeof data_buffer === "undefined") {
            this.allocate();
          } else {
            this.buffer = data_buffer;
            // data user asked for
            this.data = this.type&U8_t ? this.buffer.u8 : (this.type&S32_t ? this.buffer.i32 : (this.type&F32_t ? this.buffer.f32 : this.buffer.f64));
          }
        }
        matrix_t.prototype.allocate = function() {
          // clear references
          delete this.data;
          delete this.buffer;
          //
          this.buffer = new data_t((this.cols * get_data_type_size(this.type) * this.channel) * this.rows);
          this.data = this.type&U8_t ? this.buffer.u8 : (this.type&S32_t ? this.buffer.i32 : (this.type&F32_t ? this.buffer.f32 : this.buffer.f64));
        };
        matrix_t.prototype.copy_to = function(other) {
          var od = other.data, td = this.data;
          var i = 0, n = (this.cols*this.rows*this.channel)|0;
          for(; i < n-4; i+=4) {
            od[i] = td[i];
            od[i+1] = td[i+1];
            od[i+2] = td[i+2];
            od[i+3] = td[i+3];
          }
          for(; i < n; ++i) {
            od[i] = td[i];
          }
        };
        matrix_t.prototype.resize = function(c, r, ch) {
          if (typeof ch === "undefined") { ch = this.channel; }
          // relocate buffer only if new size doesnt fit
          var new_size = (c * get_data_type_size(this.type) * ch) * r;
          if(new_size > this.buffer.size) {
            this.cols = c;
            this.rows = r;
            this.channel = ch;
            this.allocate();
          } else {
            this.cols = c;
            this.rows = r;
            this.channel = ch;
          }
        };

        return matrix_t;
      })();

      var pyramid_t = (function () {

        function pyramid_t(levels) {
          this.levels = levels|0;
          this.data = new Array(levels);
          this.pyrdown = jsfeat.imgproc.pyrdown;
        }

        pyramid_t.prototype.allocate = function(start_w, start_h, data_type) {
          var i = this.levels;
          while(--i >= 0) {
            this.data[i] = new matrix_t(start_w >> i, start_h >> i, data_type);
          }
        };

        pyramid_t.prototype.build = function(input, skip_first_level) {
          if (typeof skip_first_level === "undefined") { skip_first_level = true; }
          // just copy data to first level
          var i = 2, a = input, b = this.data[0];
          if(!skip_first_level) {
            var j=input.cols*input.rows;
            while(--j >= 0) {
              b.data[j] = input.data[j];
            }
          }
          b = this.data[1];
          this.pyrdown(a, b);
          for(; i < this.levels; ++i) {
            a = b;
            b = this.data[i];
            this.pyrdown(a, b);
          }
        };

        return pyramid_t;
      })();

      var keypoint_t = (function () {
        function keypoint_t(x,y,score,level,angle) {
          if (typeof x === "undefined") { x=0; }
          if (typeof y === "undefined") { y=0; }
          if (typeof score === "undefined") { score=0; }
          if (typeof level === "undefined") { level=0; }
          if (typeof angle === "undefined") { angle=-1.0; }

          this.x = x;
          this.y = y;
          this.score = score;
          this.level = level;
          this.angle = angle;
        }
        return keypoint_t;
      })();


      // data types
      global.U8_t = U8_t;
      global.S32_t = S32_t;
      global.F32_t = F32_t;
      global.S64_t = S64_t;
      global.F64_t = F64_t;
      // data channels
      global.C1_t = C1_t;
      global.C2_t = C2_t;
      global.C3_t = C3_t;
      global.C4_t = C4_t;

      // popular formats
      global.U8C1_t = U8_t | C1_t;
      global.U8C3_t = U8_t | C3_t;
      global.U8C4_t = U8_t | C4_t;

      global.F32C1_t = F32_t | C1_t;
      global.F32C2_t = F32_t | C2_t;
      global.S32C1_t = S32_t | C1_t;
      global.S32C2_t = S32_t | C2_t;

      // constants
      global.EPSILON = EPSILON;
      global.FLT_MIN = FLT_MIN;

      // color convert
      global.COLOR_RGBA2GRAY = COLOR_RGBA2GRAY;
      global.COLOR_RGB2GRAY = COLOR_RGB2GRAY;
      global.COLOR_BGRA2GRAY = COLOR_BGRA2GRAY;
      global.COLOR_BGR2GRAY = COLOR_BGR2GRAY;

      // options
      global.BOX_BLUR_NOSCALE = BOX_BLUR_NOSCALE;
      global.SVD_U_T = SVD_U_T;
      global.SVD_V_T = SVD_V_T;

      global.get_data_type = get_data_type;
      global.get_channel = get_channel;
      global.get_data_type_size = get_data_type_size;

      global.data_t = data_t;
      global.matrix_t = matrix_t;
      global.pyramid_t = pyramid_t;
      global.keypoint_t = keypoint_t;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     */

    (function(global) {
      "use strict";
      //

      var cache = (function() {

        // very primitive array cache, still need testing if it helps
        // of course V8 has its own powerful cache sys but i'm not sure
        // it caches several multichannel 640x480 buffer creations each frame

        var _pool_node_t = (function () {
          function _pool_node_t(size_in_bytes) {
            this.next = null;
            this.data = new jsfeat.data_t(size_in_bytes);
            this.size = this.data.size;
            this.buffer = this.data.buffer;
            this.u8 = this.data.u8;
            this.i32 = this.data.i32;
            this.f32 = this.data.f32;
            this.f64 = this.data.f64;
          }
          _pool_node_t.prototype.resize = function(size_in_bytes) {
            delete this.data;
            this.data = new jsfeat.data_t(size_in_bytes);
            this.size = this.data.size;
            this.buffer = this.data.buffer;
            this.u8 = this.data.u8;
            this.i32 = this.data.i32;
            this.f32 = this.data.f32;
            this.f64 = this.data.f64;
          };
          return _pool_node_t;
        })();

        var _pool_head, _pool_tail;
        var _pool_size = 0;

        return {

          allocate: function(capacity, data_size) {
            _pool_head = _pool_tail = new _pool_node_t(data_size);
            for (var i = 0; i < capacity; ++i) {
              var node = new _pool_node_t(data_size);
              _pool_tail = _pool_tail.next = node;

              _pool_size++;
            }
          },

          get_buffer: function(size_in_bytes) {
            // assume we have enough free nodes
            var node = _pool_head;
            _pool_head = _pool_head.next;
            _pool_size--;

            if(size_in_bytes > node.size) {
              node.resize(size_in_bytes);
            }

            return node;
          },

          put_buffer: function(node) {
            _pool_tail = _pool_tail.next = node;
            _pool_size++;
          }
        };
      })();

      global.cache = cache;
      // for now we dont need more than 30 buffers
      // if having cache sys really helps we can add auto extending sys
      cache.allocate(30, 640*4);

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     */

    (function(global) {
      "use strict";
      //

      var math = (function() {

        var qsort_stack = new Int32Array(48*2);

        return {
          get_gaussian_kernel: function(size, sigma, kernel, data_type) {
            var i=0,x=0.0,t=0.0,sigma_x=0.0,scale_2x=0.0;
            var sum = 0.0;
            var kern_node = jsfeat.cache.get_buffer(size<<2);
            var _kernel = kern_node.f32;//new Float32Array(size);

            if((size&1) == 1 && size <= 7 && sigma <= 0) {
              switch(size>>1) {
                case 0:
                  _kernel[0] = 1.0;
                  sum = 1.0;
                  break;
                case 1:
                  _kernel[0] = 0.25, _kernel[1] = 0.5, _kernel[2] = 0.25;
                  sum = 0.25+0.5+0.25;
                  break;
                case 2:
                  _kernel[0] = 0.0625, _kernel[1] = 0.25, _kernel[2] = 0.375,
                    _kernel[3] = 0.25, _kernel[4] = 0.0625;
                  sum = 0.0625+0.25+0.375+0.25+0.0625;
                  break;
                case 3:
                  _kernel[0] = 0.03125, _kernel[1] = 0.109375, _kernel[2] = 0.21875,
                    _kernel[3] = 0.28125, _kernel[4] = 0.21875, _kernel[5] = 0.109375, _kernel[6] = 0.03125;
                  sum = 0.03125+0.109375+0.21875+0.28125+0.21875+0.109375+0.03125;
                  break;
              }
            } else {
              sigma_x = sigma > 0 ? sigma : ((size-1)*0.5 - 1.0)*0.3 + 0.8;
              scale_2x = -0.5/(sigma_x*sigma_x);

              for( ; i < size; ++i )
              {
                x = i - (size-1)*0.5;
                t = Math.exp(scale_2x*x*x);

                _kernel[i] = t;
                sum += t;
              }
            }

            if(data_type & jsfeat.U8_t) {
              // int based kernel
              sum = 256.0/sum;
              for (i = 0; i < size; ++i) {
                kernel[i] = (_kernel[i] * sum + 0.5)|0;
              }
            } else {
              // classic kernel
              sum = 1.0/sum;
              for (i = 0; i < size; ++i) {
                kernel[i] = _kernel[i] * sum;
              }
            }

            jsfeat.cache.put_buffer(kern_node);
          },

          // model is 3x3 matrix_t
          perspective_4point_transform: function(model, src_x0, src_y0, dst_x0, dst_y0,
                                                 src_x1, src_y1, dst_x1, dst_y1,
                                                 src_x2, src_y2, dst_x2, dst_y2,
                                                 src_x3, src_y3, dst_x3, dst_y3) {
            var t1 = src_x0;
            var t2 = src_x2;
            var t4 = src_y1;
            var t5 = t1 * t2 * t4;
            var t6 = src_y3;
            var t7 = t1 * t6;
            var t8 = t2 * t7;
            var t9 = src_y2;
            var t10 = t1 * t9;
            var t11 = src_x1;
            var t14 = src_y0;
            var t15 = src_x3;
            var t16 = t14 * t15;
            var t18 = t16 * t11;
            var t20 = t15 * t11 * t9;
            var t21 = t15 * t4;
            var t24 = t15 * t9;
            var t25 = t2 * t4;
            var t26 = t6 * t2;
            var t27 = t6 * t11;
            var t28 = t9 * t11;
            var t30 = 1.0 / (t21-t24 - t25 + t26 - t27 + t28);
            var t32 = t1 * t15;
            var t35 = t14 * t11;
            var t41 = t4 * t1;
            var t42 = t6 * t41;
            var t43 = t14 * t2;
            var t46 = t16 * t9;
            var t48 = t14 * t9 * t11;
            var t51 = t4 * t6 * t2;
            var t55 = t6 * t14;
            var Hr0 = -(t8-t5 + t10 * t11 - t11 * t7 - t16 * t2 + t18 - t20 + t21 * t2) * t30;
            var Hr1 = (t5 - t8 - t32 * t4 + t32 * t9 + t18 - t2 * t35 + t27 * t2 - t20) * t30;
            var Hr2 = t1;
            var Hr3 = (-t9 * t7 + t42 + t43 * t4 - t16 * t4 + t46 - t48 + t27 * t9 - t51) * t30;
            var Hr4 = (-t42 + t41 * t9 - t55 * t2 + t46 - t48 + t55 * t11 + t51 - t21 * t9) * t30;
            var Hr5 = t14;
            var Hr6 = (-t10 + t41 + t43 - t35 + t24 - t21 - t26 + t27) * t30;
            var Hr7 = (-t7 + t10 + t16 - t43 + t27 - t28 - t21 + t25) * t30;

            t1 = dst_x0;
            t2 = dst_x2;
            t4 = dst_y1;
            t5 = t1 * t2 * t4;
            t6 = dst_y3;
            t7 = t1 * t6;
            t8 = t2 * t7;
            t9 = dst_y2;
            t10 = t1 * t9;
            t11 = dst_x1;
            t14 = dst_y0;
            t15 = dst_x3;
            t16 = t14 * t15;
            t18 = t16 * t11;
            t20 = t15 * t11 * t9;
            t21 = t15 * t4;
            t24 = t15 * t9;
            t25 = t2 * t4;
            t26 = t6 * t2;
            t27 = t6 * t11;
            t28 = t9 * t11;
            t30 = 1.0 / (t21-t24 - t25 + t26 - t27 + t28);
            t32 = t1 * t15;
            t35 = t14 * t11;
            t41 = t4 * t1;
            t42 = t6 * t41;
            t43 = t14 * t2;
            t46 = t16 * t9;
            t48 = t14 * t9 * t11;
            t51 = t4 * t6 * t2;
            t55 = t6 * t14;
            var Hl0 = -(t8-t5 + t10 * t11 - t11 * t7 - t16 * t2 + t18 - t20 + t21 * t2) * t30;
            var Hl1 = (t5 - t8 - t32 * t4 + t32 * t9 + t18 - t2 * t35 + t27 * t2 - t20) * t30;
            var Hl2 = t1;
            var Hl3 = (-t9 * t7 + t42 + t43 * t4 - t16 * t4 + t46 - t48 + t27 * t9 - t51) * t30;
            var Hl4 = (-t42 + t41 * t9 - t55 * t2 + t46 - t48 + t55 * t11 + t51 - t21 * t9) * t30;
            var Hl5 = t14;
            var Hl6 = (-t10 + t41 + t43 - t35 + t24 - t21 - t26 + t27) * t30;
            var Hl7 = (-t7 + t10 + t16 - t43 + t27 - t28 - t21 + t25) * t30;

            // the following code computes R = Hl * inverse Hr
            t2 = Hr4-Hr7*Hr5;
            t4 = Hr0*Hr4;
            t5 = Hr0*Hr5;
            t7 = Hr3*Hr1;
            t8 = Hr2*Hr3;
            t10 = Hr1*Hr6;
            var t12 = Hr2*Hr6;
            t15 = 1.0 / (t4-t5*Hr7-t7+t8*Hr7+t10*Hr5-t12*Hr4);
            t18 = -Hr3+Hr5*Hr6;
            var t23 = -Hr3*Hr7+Hr4*Hr6;
            t28 = -Hr1+Hr2*Hr7;
            var t31 = Hr0-t12;
            t35 = Hr0*Hr7-t10;
            t41 = -Hr1*Hr5+Hr2*Hr4;
            var t44 = t5-t8;
            var t47 = t4-t7;
            t48 = t2*t15;
            var t49 = t28*t15;
            var t50 = t41*t15;
            var mat = model.data;
            mat[0] = Hl0*t48+Hl1*(t18*t15)-Hl2*(t23*t15);
            mat[1] = Hl0*t49+Hl1*(t31*t15)-Hl2*(t35*t15);
            mat[2] = -Hl0*t50-Hl1*(t44*t15)+Hl2*(t47*t15);
            mat[3] = Hl3*t48+Hl4*(t18*t15)-Hl5*(t23*t15);
            mat[4] = Hl3*t49+Hl4*(t31*t15)-Hl5*(t35*t15);
            mat[5] = -Hl3*t50-Hl4*(t44*t15)+Hl5*(t47*t15);
            mat[6] = Hl6*t48+Hl7*(t18*t15)-t23*t15;
            mat[7] = Hl6*t49+Hl7*(t31*t15)-t35*t15;
            mat[8] = -Hl6*t50-Hl7*(t44*t15)+t47*t15;
          },

          // The current implementation was derived from *BSD system qsort():
          // Copyright (c) 1992, 1993
          // The Regents of the University of California.  All rights reserved.
          qsort: function(array, low, high, cmp) {
            var isort_thresh = 7;
            var t,ta,tb,tc;
            var sp = 0,left=0,right=0,i=0,n=0,m=0,ptr=0,ptr2=0,d=0;
            var left0=0,left1=0,right0=0,right1=0,pivot=0,a=0,b=0,c=0,swap_cnt=0;

            var stack = qsort_stack;

            if( (high-low+1) <= 1 ) return;

            stack[0] = low;
            stack[1] = high;

            while( sp >= 0 ) {

              left = stack[sp<<1];
              right = stack[(sp<<1)+1];
              sp--;

              for(;;) {
                n = (right - left) + 1;

                if( n <= isort_thresh ) {
                  //insert_sort:
                  for( ptr = left + 1; ptr <= right; ptr++ ) {
                    for( ptr2 = ptr; ptr2 > left && cmp(array[ptr2],array[ptr2-1]); ptr2--) {
                      t = array[ptr2];
                      array[ptr2] = array[ptr2-1];
                      array[ptr2-1] = t;
                    }
                  }
                  break;
                } else {
                  swap_cnt = 0;

                  left0 = left;
                  right0 = right;
                  pivot = left + (n>>1);

                  if( n > 40 ) {
                    d = n >> 3;
                    a = left, b = left + d, c = left + (d<<1);
                    ta = array[a],tb = array[b],tc = array[c];
                    left = cmp(ta, tb) ? (cmp(tb, tc) ? b : (cmp(ta, tc) ? c : a))
                      : (cmp(tc, tb) ? b : (cmp(ta, tc) ? a : c));

                    a = pivot - d, b = pivot, c = pivot + d;
                    ta = array[a],tb = array[b],tc = array[c];
                    pivot = cmp(ta, tb) ? (cmp(tb, tc) ? b : (cmp(ta, tc) ? c : a))
                      : (cmp(tc, tb) ? b : (cmp(ta, tc) ? a : c));

                    a = right - (d<<1), b = right - d, c = right;
                    ta = array[a],tb = array[b],tc = array[c];
                    right = cmp(ta, tb) ? (cmp(tb, tc) ? b : (cmp(ta, tc) ? c : a))
                      : (cmp(tc, tb) ? b : (cmp(ta, tc) ? a : c));
                  }

                  a = left, b = pivot, c = right;
                  ta = array[a],tb = array[b],tc = array[c];
                  pivot = cmp(ta, tb) ? (cmp(tb, tc) ? b : (cmp(ta, tc) ? c : a))
                    : (cmp(tc, tb) ? b : (cmp(ta, tc) ? a : c));
                  if( pivot != left0 ) {
                    t = array[pivot];
                    array[pivot] = array[left0];
                    array[left0] = t;
                    pivot = left0;
                  }
                  left = left1 = left0 + 1;
                  right = right1 = right0;

                  ta = array[pivot];
                  for(;;) {
                    while( left <= right && !cmp(ta, array[left]) ) {
                      if( !cmp(array[left], ta) ) {
                        if( left > left1 ) {
                          t = array[left1];
                          array[left1] = array[left];
                          array[left] = t;
                        }
                        swap_cnt = 1;
                        left1++;
                      }
                      left++;
                    }

                    while( left <= right && !cmp(array[right], ta) ) {
                      if( !cmp(ta, array[right]) ) {
                        if( right < right1 ) {
                          t = array[right1];
                          array[right1] = array[right];
                          array[right] = t;
                        }
                        swap_cnt = 1;
                        right1--;
                      }
                      right--;
                    }

                    if( left > right ) break;

                    t = array[left];
                    array[left] = array[right];
                    array[right] = t;
                    swap_cnt = 1;
                    left++;
                    right--;
                  }

                  if( swap_cnt == 0 ) {
                    left = left0, right = right0;
                    //goto insert_sort;
                    for( ptr = left + 1; ptr <= right; ptr++ ) {
                      for( ptr2 = ptr; ptr2 > left && cmp(array[ptr2],array[ptr2-1]); ptr2--) {
                        t = array[ptr2];
                        array[ptr2] = array[ptr2-1];
                        array[ptr2-1] = t;
                      }
                    }
                    break;
                  }

                  n = Math.min( (left1 - left0), (left - left1) );
                  m = (left-n)|0;
                  for( i = 0; i < n; ++i,++m ) {
                    t = array[left0+i];
                    array[left0+i] = array[m];
                    array[m] = t;
                  }

                  n = Math.min( (right0 - right1), (right1 - right) );
                  m = (right0-n+1)|0;
                  for( i = 0; i < n; ++i,++m ) {
                    t = array[left+i];
                    array[left+i] = array[m];
                    array[m] = t;
                  }
                  n = (left - left1);
                  m = (right1 - right);
                  if( n > 1 ) {
                    if( m > 1 ) {
                      if( n > m ) {
                        ++sp;
                        stack[sp<<1] = left0;
                        stack[(sp<<1)+1] = left0 + n - 1;
                        left = right0 - m + 1, right = right0;
                      } else {
                        ++sp;
                        stack[sp<<1] = right0 - m + 1;
                        stack[(sp<<1)+1] = right0;
                        left = left0, right = left0 + n - 1;
                      }
                    } else {
                      left = left0, right = left0 + n - 1;
                    }
                  }
                  else if( m > 1 )
                    left = right0 - m + 1, right = right0;
                  else
                    break;
                }
              }
            }
          },

          median: function(array, low, high) {
            var w;
            var middle=0,ll=0,hh=0,median=(low+high)>>1;
            for (;;) {
              if (high <= low) return array[median];
              if (high == (low + 1)) {
                if (array[low] > array[high]) {
                  w = array[low];
                  array[low] = array[high];
                  array[high] = w;
                }
                return array[median];
              }
              middle = ((low + high) >> 1);
              if (array[middle] > array[high]) {
                w = array[middle];
                array[middle] = array[high];
                array[high] = w;
              }
              if (array[low] > array[high]) {
                w = array[low];
                array[low] = array[high];
                array[high] = w;
              }
              if (array[middle] > array[low]) {
                w = array[middle];
                array[middle] = array[low];
                array[low] = w;
              }
              ll = (low + 1);
              w = array[middle];
              array[middle] = array[ll];
              array[ll] = w;
              hh = high;
              for (;;) {
                do ++ll; while (array[low] > array[ll]);
                do --hh; while (array[hh] > array[low]);
                if (hh < ll) break;
                w = array[ll];
                array[ll] = array[hh];
                array[hh] = w;
              }
              w = array[low];
              array[low] = array[hh];
              array[hh] = w;
              if (hh <= median)
                low = ll;
              else if (hh >= median)
                high = (hh - 1);
            }
            return 0;
          }
        };

      })();

      global.math = math;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     */

    (function(global) {
      "use strict";
      //

      var matmath = (function() {

        return {
          identity: function(M, value) {
            if (typeof value === "undefined") { value=1; }
            var src=M.data;
            var rows=M.rows, cols=M.cols, cols_1=(cols+1)|0;
            var len = rows * cols;
            var k = len;
            while(--len >= 0) src[len] = 0.0;
            len = k;
            k = 0;
            while(k < len)  {
              src[k] = value;
              k = k + cols_1;
            }
          },

          transpose: function(At, A) {
            var i=0,j=0,nrows=A.rows,ncols=A.cols;
            var Ai=0,Ati=0,pAt=0;
            var ad=A.data,atd=At.data;

            for (; i < nrows; Ati += 1, Ai += ncols, i++) {
              pAt = Ati;
              for (j = 0; j < ncols; pAt += nrows, j++) atd[pAt] = ad[Ai+j];
            }
          },

          // C = A * B
          multiply: function(C, A, B) {
            var i=0,j=0,k=0;
            var Ap=0,pA=0,pB=0,p_B=0,Cp=0;
            var ncols=A.cols,nrows=A.rows,mcols=B.cols;
            var ad=A.data,bd=B.data,cd=C.data;
            var sum=0.0;

            for (; i < nrows; Ap += ncols, i++) {
              for (p_B = 0, j = 0; j < mcols; Cp++, p_B++, j++) {
                pB = p_B;
                pA = Ap;
                sum = 0.0;
                for (k = 0; k < ncols; pA++, pB += mcols, k++) {
                  sum += ad[pA] * bd[pB];
                }
                cd[Cp] = sum;
              }
            }
          },

          // C = A * B'
          multiply_ABt: function(C, A, B) {
            var i=0,j=0,k=0;
            var Ap=0,pA=0,pB=0,Cp=0;
            var ncols=A.cols,nrows=A.rows,mrows=B.rows;
            var ad=A.data,bd=B.data,cd=C.data;
            var sum=0.0;

            for (; i < nrows; Ap += ncols, i++) {
              for (pB = 0, j = 0; j < mrows; Cp++, j++) {
                pA = Ap;
                sum = 0.0;
                for (k = 0; k < ncols; pA++, pB++, k++) {
                  sum += ad[pA] * bd[pB];
                }
                cd[Cp] = sum;
              }
            }
          },

          // C = A' * B
          multiply_AtB: function(C, A, B) {
            var i=0,j=0,k=0;
            var Ap=0,pA=0,pB=0,p_B=0,Cp=0;
            var ncols=A.cols,nrows=A.rows,mcols=B.cols;
            var ad=A.data,bd=B.data,cd=C.data;
            var sum=0.0;

            for (; i < ncols; Ap++, i++) {
              for (p_B = 0, j = 0; j < mcols; Cp++, p_B++, j++) {
                pB = p_B;
                pA = Ap;
                sum = 0.0;
                for (k = 0; k < nrows; pA += ncols, pB += mcols, k++) {
                  sum += ad[pA] * bd[pB];
                }
                cd[Cp] = sum;
              }
            }
          },

          // C = A * A'
          multiply_AAt: function(C, A) {
            var i=0,j=0,k=0;
            var pCdiag=0,p_A=0,pA=0,pB=0,pC=0,pCt=0;
            var ncols=A.cols,nrows=A.rows;
            var ad=A.data,cd=C.data;
            var sum=0.0;

            for (; i < nrows; pCdiag += nrows + 1, p_A = pA, i++) {
              pC = pCdiag;
              pCt = pCdiag;
              pB = p_A;
              for (j = i; j < nrows; pC++, pCt += nrows, j++) {
                pA = p_A;
                sum = 0.0;
                for (k = 0; k < ncols; k++) {
                  sum += ad[pA++] * ad[pB++];
                }
                cd[pC] = sum;
                cd[pCt] = sum;
              }
            }
          },

          // C = A' * A
          multiply_AtA: function(C, A) {
            var i=0,j=0,k=0;
            var p_A=0,pA=0,pB=0,p_C=0,pC=0,p_CC=0;
            var ncols=A.cols,nrows=A.rows;
            var ad=A.data,cd=C.data;
            var sum=0.0;

            for (; i < ncols; p_C += ncols, i++) {
              p_A = i;
              p_CC = p_C + i;
              pC = p_CC;
              for (j = i; j < ncols; pC++, p_CC += ncols, j++) {
                pA = p_A;
                pB = j;
                sum = 0.0;
                for (k = 0; k < nrows; pA += ncols, pB += ncols, k++) {
                  sum += ad[pA] * ad[pB];
                }
                cd[pC] = sum;
                cd[p_CC] = sum;
              }
            }
          },

          // various small matrix operations
          identity_3x3: function(M, value) {
            if (typeof value === "undefined") { value=1; }
            var dt=M.data;
            dt[0] = dt[4] = dt[8] = value;
            dt[1] = dt[2] = dt[3] = 0;
            dt[5] = dt[6] = dt[7] = 0;
          },

          invert_3x3: function(from, to) {
            var A = from.data, invA = to.data;
            var t1 = A[4];
            var t2 = A[8];
            var t4 = A[5];
            var t5 = A[7];
            var t8 = A[0];

            var t9 = t8*t1;
            var t11 = t8*t4;
            var t13 = A[3];
            var t14 = A[1];
            var t15 = t13*t14;
            var t17 = A[2];
            var t18 = t13*t17;
            var t20 = A[6];
            var t21 = t20*t14;
            var t23 = t20*t17;
            var t26 = 1.0/(t9*t2-t11*t5-t15*t2+t18*t5+t21*t4-t23*t1);
            invA[0] = (t1*t2-t4*t5)*t26;
            invA[1] = -(t14*t2-t17*t5)*t26;
            invA[2] = -(-t14*t4+t17*t1)*t26;
            invA[3] = -(t13*t2-t4*t20)*t26;
            invA[4] = (t8*t2-t23)*t26;
            invA[5] = -(t11-t18)*t26;
            invA[6] = -(-t13*t5+t1*t20)*t26;
            invA[7] = -(t8*t5-t21)*t26;
            invA[8] = (t9-t15)*t26;
          },
          // C = A * B
          multiply_3x3: function(C, A, B) {
            var Cd=C.data, Ad=A.data, Bd=B.data;
            var m1_0 = Ad[0], m1_1 = Ad[1], m1_2 = Ad[2];
            var m1_3 = Ad[3], m1_4 = Ad[4], m1_5 = Ad[5];
            var m1_6 = Ad[6], m1_7 = Ad[7], m1_8 = Ad[8];

            var m2_0 = Bd[0], m2_1 = Bd[1], m2_2 = Bd[2];
            var m2_3 = Bd[3], m2_4 = Bd[4], m2_5 = Bd[5];
            var m2_6 = Bd[6], m2_7 = Bd[7], m2_8 = Bd[8];

            Cd[0] = m1_0 * m2_0 + m1_1 * m2_3 + m1_2 * m2_6;
            Cd[1] = m1_0 * m2_1 + m1_1 * m2_4 + m1_2 * m2_7;
            Cd[2] = m1_0 * m2_2 + m1_1 * m2_5 + m1_2 * m2_8;
            Cd[3] = m1_3 * m2_0 + m1_4 * m2_3 + m1_5 * m2_6;
            Cd[4] = m1_3 * m2_1 + m1_4 * m2_4 + m1_5 * m2_7;
            Cd[5] = m1_3 * m2_2 + m1_4 * m2_5 + m1_5 * m2_8;
            Cd[6] = m1_6 * m2_0 + m1_7 * m2_3 + m1_8 * m2_6;
            Cd[7] = m1_6 * m2_1 + m1_7 * m2_4 + m1_8 * m2_7;
            Cd[8] = m1_6 * m2_2 + m1_7 * m2_5 + m1_8 * m2_8;
          },

          mat3x3_determinant: function(M) {
            var md=M.data;
            return  md[0] * md[4] * md[8] -
              md[0] * md[5] * md[7] -
              md[3] * md[1] * md[8] +
              md[3] * md[2] * md[7] +
              md[6] * md[1] * md[5] -
              md[6] * md[2] * md[4];
          },

          determinant_3x3: function(M11, M12, M13,
                                    M21, M22, M23,
                                    M31, M32, M33) {
            return  M11 * M22 * M33 - M11 * M23 * M32 -
              M21 * M12 * M33 + M21 * M13 * M32 +
              M31 * M12 * M23 - M31 * M13 * M22;
          }
        };

      })();

      global.matmath = matmath;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     */

    (function(global) {
      "use strict";
      //

      var linalg = (function() {

        var swap = function(A, i0, i1, t) {
          t = A[i0];
          A[i0] = A[i1];
          A[i1] = t;
        };

        var hypot = function(a, b) {
          a = Math.abs(a);
          b = Math.abs(b);
          if( a > b ) {
            b /= a;
            return a*Math.sqrt(1.0 + b*b);
          }
          if( b > 0 ) {
            a /= b;
            return b*Math.sqrt(1.0 + a*a);
          }
          return 0.0;
        };

        var JacobiImpl = function(A, astep, W, V, vstep, n) {
          var eps = jsfeat.EPSILON;
          var i=0,j=0,k=0,m=0,l=0,idx=0,_in=0,_in2=0;
          var iters=0,max_iter=n*n*30;
          var mv=0.0,val=0.0,p=0.0,y=0.0,t=0.0,s=0.0,c=0.0,a0=0.0,b0=0.0;

          var indR_buff = jsfeat.cache.get_buffer(n<<2);
          var indC_buff = jsfeat.cache.get_buffer(n<<2);
          var indR = indR_buff.i32;
          var indC = indC_buff.i32;

          if(V) {
            for(; i < n; i++) {
              k = i*vstep;
              for(j = 0; j < n; j++) {
                V[k + j] = 0.0;
              }
              V[k + i] = 1.0;
            }
          }

          for(k = 0; k < n; k++) {
            W[k] = A[(astep + 1)*k];
            if(k < n - 1) {
              for(m = k+1, mv = Math.abs(A[astep*k + m]), i = k+2; i < n; i++) {
                val = Math.abs(A[astep*k+i]);
                if(mv < val)
                  mv = val, m = i;
              }
              indR[k] = m;
            }
            if(k > 0) {
              for(m = 0, mv = Math.abs(A[k]), i = 1; i < k; i++) {
                val = Math.abs(A[astep*i+k]);
                if(mv < val)
                  mv = val, m = i;
              }
              indC[k] = m;
            }
          }

          if(n > 1) for( ; iters < max_iter; iters++) {
            // find index (k,l) of pivot p
            for(k = 0, mv = Math.abs(A[indR[0]]), i = 1; i < n-1; i++) {
              val = Math.abs(A[astep*i + indR[i]]);
              if( mv < val )
                mv = val, k = i;
            }
            l = indR[k];
            for(i = 1; i < n; i++) {
              val = Math.abs(A[astep*indC[i] + i]);
              if( mv < val )
                mv = val, k = indC[i], l = i;
            }

            p = A[astep*k + l];

            if(Math.abs(p) <= eps) break;

            y = (W[l] - W[k])*0.5;
            t = Math.abs(y) + hypot(p, y);
            s = hypot(p, t);
            c = t/s;
            s = p/s; t = (p/t)*p;
            if(y < 0)
              s = -s, t = -t;
            A[astep*k + l] = 0;

            W[k] -= t;
            W[l] += t;

            // rotate rows and columns k and l
            for (i = 0; i < k; i++) {
              _in = (astep * i + k);
              _in2 = (astep * i + l);
              a0 = A[_in];
              b0 = A[_in2];
              A[_in] = a0 * c - b0 * s;
              A[_in2] = a0 * s + b0 * c;
            }
            for (i = (k + 1); i < l; i++) {
              _in = (astep * k + i);
              _in2 = (astep * i + l);
              a0 = A[_in];
              b0 = A[_in2];
              A[_in] = a0 * c - b0 * s;
              A[_in2] = a0 * s + b0 * c;
            }
            i = l + 1;
            _in = (astep * k + i);
            _in2 = (astep * l + i);
            for (; i < n; i++, _in++, _in2++) {
              a0 = A[_in];
              b0 = A[_in2];
              A[_in] = a0 * c - b0 * s;
              A[_in2] = a0 * s + b0 * c;
            }

            // rotate eigenvectors
            if (V) {
              _in = vstep * k;
              _in2 = vstep * l;
              for (i = 0; i < n; i++, _in++, _in2++) {
                a0 = V[_in];
                b0 = V[_in2];
                V[_in] = a0 * c - b0 * s;
                V[_in2] = a0 * s + b0 * c;
              }
            }

            for(j = 0; j < 2; j++) {
              idx = j == 0 ? k : l;
              if(idx < n - 1) {
                for(m = idx+1, mv = Math.abs(A[astep*idx + m]), i = idx+2; i < n; i++) {
                  val = Math.abs(A[astep*idx+i]);
                  if( mv < val )
                    mv = val, m = i;
                }
                indR[idx] = m;
              }
              if(idx > 0) {
                for(m = 0, mv = Math.abs(A[idx]), i = 1; i < idx; i++) {
                  val = Math.abs(A[astep*i+idx]);
                  if( mv < val )
                    mv = val, m = i;
                }
                indC[idx] = m;
              }
            }
          }

          // sort eigenvalues & eigenvectors
          for(k = 0; k < n-1; k++) {
            m = k;
            for(i = k+1; i < n; i++) {
              if(W[m] < W[i])
                m = i;
            }
            if(k != m) {
              swap(W, m, k, mv);
              if(V) {
                for(i = 0; i < n; i++) {
                  swap(V, vstep*m + i, vstep*k + i, mv);
                }
              }
            }
          }


          jsfeat.cache.put_buffer(indR_buff);
          jsfeat.cache.put_buffer(indC_buff);
        };

        var JacobiSVDImpl = function(At, astep, _W, Vt, vstep, m, n, n1) {
          var eps = jsfeat.EPSILON * 2.0;
          var minval = jsfeat.FLT_MIN;
          var i=0,j=0,k=0,iter=0,max_iter=Math.max(m, 30);
          var Ai=0,Aj=0,Vi=0,Vj=0,changed=0;
          var c=0.0, s=0.0, t=0.0;
          var t0=0.0,t1=0.0,sd=0.0,beta=0.0,gamma=0.0,delta=0.0,a=0.0,p=0.0,b=0.0;
          var seed = 0x1234;
          var val=0.0,val0=0.0,asum=0.0;

          var W_buff = jsfeat.cache.get_buffer(n<<3);
          var W = W_buff.f64;

          for(; i < n; i++) {
            for(k = 0, sd = 0; k < m; k++) {
              t = At[i*astep + k];
              sd += t*t;
            }
            W[i] = sd;

            if(Vt) {
              for(k = 0; k < n; k++) {
                Vt[i*vstep + k] = 0;
              }
              Vt[i*vstep + i] = 1;
            }
          }

          for(; iter < max_iter; iter++) {
            changed = 0;

            for(i = 0; i < n-1; i++) {
              for(j = i+1; j < n; j++) {
                Ai = (i*astep)|0, Aj = (j*astep)|0;
                a = W[i], p = 0, b = W[j];

                k = 2;
                p += At[Ai]*At[Aj];
                p += At[Ai+1]*At[Aj+1];

                for(; k < m; k++)
                  p += At[Ai+k]*At[Aj+k];

                if(Math.abs(p) <= eps*Math.sqrt(a*b)) continue;

                p *= 2.0;
                beta = a - b, gamma = hypot(p, beta);
                if( beta < 0 ) {
                  delta = (gamma - beta)*0.5;
                  s = Math.sqrt(delta/gamma);
                  c = (p/(gamma*s*2.0));
                } else {
                  c = Math.sqrt((gamma + beta)/(gamma*2.0));
                  s = (p/(gamma*c*2.0));
                }

                a=0.0, b=0.0;

                k = 2; // unroll
                t0 = c*At[Ai] + s*At[Aj];
                t1 = -s*At[Ai] + c*At[Aj];
                At[Ai] = t0; At[Aj] = t1;
                a += t0*t0; b += t1*t1;

                t0 = c*At[Ai+1] + s*At[Aj+1];
                t1 = -s*At[Ai+1] + c*At[Aj+1];
                At[Ai+1] = t0; At[Aj+1] = t1;
                a += t0*t0; b += t1*t1;

                for( ; k < m; k++ )
                {
                  t0 = c*At[Ai+k] + s*At[Aj+k];
                  t1 = -s*At[Ai+k] + c*At[Aj+k];
                  At[Ai+k] = t0; At[Aj+k] = t1;

                  a += t0*t0; b += t1*t1;
                }

                W[i] = a; W[j] = b;

                changed = 1;

                if(Vt) {
                  Vi = (i*vstep)|0, Vj = (j*vstep)|0;

                  k = 2;
                  t0 = c*Vt[Vi] + s*Vt[Vj];
                  t1 = -s*Vt[Vi] + c*Vt[Vj];
                  Vt[Vi] = t0; Vt[Vj] = t1;

                  t0 = c*Vt[Vi+1] + s*Vt[Vj+1];
                  t1 = -s*Vt[Vi+1] + c*Vt[Vj+1];
                  Vt[Vi+1] = t0; Vt[Vj+1] = t1;

                  for(; k < n; k++) {
                    t0 = c*Vt[Vi+k] + s*Vt[Vj+k];
                    t1 = -s*Vt[Vi+k] + c*Vt[Vj+k];
                    Vt[Vi+k] = t0; Vt[Vj+k] = t1;
                  }
                }
              }
            }
            if(changed == 0) break;
          }

          for(i = 0; i < n; i++) {
            for(k = 0, sd = 0; k < m; k++) {
              t = At[i*astep + k];
              sd += t*t;
            }
            W[i] = Math.sqrt(sd);
          }

          for(i = 0; i < n-1; i++) {
            j = i;
            for(k = i+1; k < n; k++) {
              if(W[j] < W[k])
                j = k;
            }
            if(i != j) {
              swap(W, i, j, sd);
              if(Vt) {
                for(k = 0; k < m; k++) {
                  swap(At, i*astep + k, j*astep + k, t);
                }

                for(k = 0; k < n; k++) {
                  swap(Vt, i*vstep + k, j*vstep + k, t);
                }
              }
            }
          }

          for(i = 0; i < n; i++) {
            _W[i] = W[i];
          }

          if(!Vt) {
            jsfeat.cache.put_buffer(W_buff);
            return;
          }

          for(i = 0; i < n1; i++) {

            sd = i < n ? W[i] : 0;

            while(sd <= minval) {
              // if we got a zero singular value, then in order to get the corresponding left singular vector
              // we generate a random vector, project it to the previously computed left singular vectors,
              // subtract the projection and normalize the difference.
              val0 = (1.0/m);
              for(k = 0; k < m; k++) {
                seed = (seed * 214013 + 2531011);
                val = (((seed >> 16) & 0x7fff) & 256) != 0 ? val0 : -val0;
                At[i*astep + k] = val;
              }
              for(iter = 0; iter < 2; iter++) {
                for(j = 0; j < i; j++) {
                  sd = 0;
                  for(k = 0; k < m; k++) {
                    sd += At[i*astep + k]*At[j*astep + k];
                  }
                  asum = 0.0;
                  for(k = 0; k < m; k++) {
                    t = (At[i*astep + k] - sd*At[j*astep + k]);
                    At[i*astep + k] = t;
                    asum += Math.abs(t);
                  }
                  asum = asum ? 1.0/asum : 0;
                  for(k = 0; k < m; k++) {
                    At[i*astep + k] *= asum;
                  }
                }
              }
              sd = 0;
              for(k = 0; k < m; k++) {
                t = At[i*astep + k];
                sd += t*t;
              }
              sd = Math.sqrt(sd);
            }

            s = (1.0/sd);
            for(k = 0; k < m; k++) {
              At[i*astep + k] *= s;
            }
          }

          jsfeat.cache.put_buffer(W_buff);
        };

        return {

          lu_solve: function(A, B) {
            var i=0,j=0,k=0,p=1,astep=A.cols;
            var ad=A.data, bd=B.data;
            var t,alpha,d,s;

            for(i = 0; i < astep; i++) {
              k = i;
              for(j = i+1; j < astep; j++) {
                if(Math.abs(ad[j*astep + i]) > Math.abs(ad[k*astep+i])) {
                  k = j;
                }
              }

              if(Math.abs(ad[k*astep+i]) < jsfeat.EPSILON) {
                return 0; // FAILED
              }

              if(k != i) {
                for(j = i; j < astep; j++ ) {
                  swap(ad, i*astep+j, k*astep+j, t);
                }

                swap(bd, i, k, t);
                p = -p;
              }

              d = -1.0/ad[i*astep+i];

              for(j = i+1; j < astep; j++) {
                alpha = ad[j*astep+i]*d;

                for(k = i+1; k < astep; k++) {
                  ad[j*astep+k] += alpha*ad[i*astep+k];
                }

                bd[j] += alpha*bd[i];
              }

              ad[i*astep+i] = -d;
            }

            for(i = astep-1; i >= 0; i--) {
              s = bd[i];
              for(k = i+1; k < astep; k++) {
                s -= ad[i*astep+k]*bd[k];
              }
              bd[i] = s*ad[i*astep+i];
            }

            return 1; // OK
          },

          cholesky_solve: function(A, B) {
            var col=0,row=0,col2=0,cs=0,rs=0,i=0,j=0;
            var size = A.cols;
            var ad=A.data, bd=B.data;
            var val,inv_diag;

            for (col = 0; col < size; col++) {
              inv_diag = 1.0;
              cs = (col * size);
              rs = cs;
              for (row = col; row < size; row++)
              {
                // correct for the parts of cholesky already computed
                val = ad[(rs+col)];
                for (col2 = 0; col2 < col; col2++) {
                  val -= ad[(col2*size+col)] * ad[(rs+col2)];
                }
                if (row == col) {
                  // this is the diagonal element so don't divide
                  ad[(rs+col)] = val;
                  if(val == 0) {
                    return 0;
                  }
                  inv_diag = 1.0 / val;
                } else {
                  // cache the value without division in the upper half
                  ad[(cs+row)] = val;
                  // divide my the diagonal element for all others
                  ad[(rs+col)] = val * inv_diag;
                }
                rs = (rs + size);
              }
            }

            // first backsub through L
            cs = 0;
            for (i = 0; i < size; i++) {
              val = bd[i];
              for (j = 0; j < i; j++) {
                val -= ad[(cs+j)] * bd[j];
              }
              bd[i] = val;
              cs = (cs + size);
            }
            // backsub through diagonal
            cs = 0;
            for (i = 0; i < size; i++) {
              bd[i] /= ad[(cs + i)];
              cs = (cs + size);
            }
            // backsub through L Transpose
            i = (size-1);
            for (; i >= 0; i--) {
              val = bd[i];
              j = (i + 1);
              cs = (j * size);
              for (; j < size; j++) {
                val -= ad[(cs + i)] * bd[j];
                cs = (cs + size);
              }
              bd[i] = val;
            }

            return 1;
          },

          svd_decompose: function(A, W, U, V, options) {
            if (typeof options === "undefined") { options = 0; }
            var at=0,i=0,j=0,_m=A.rows,_n=A.cols,m=_m,n=_n;
            var dt = A.type | jsfeat.C1_t; // we only work with single channel

            if(m < n) {
              at = 1;
              i = m;
              m = n;
              n = i;
            }

            var a_buff = jsfeat.cache.get_buffer((m*m)<<3);
            var w_buff = jsfeat.cache.get_buffer(n<<3);
            var v_buff = jsfeat.cache.get_buffer((n*n)<<3);

            var a_mt = new jsfeat.matrix_t(m, m, dt, a_buff.data);
            var w_mt = new jsfeat.matrix_t(1, n, dt, w_buff.data);
            var v_mt = new jsfeat.matrix_t(n, n, dt, v_buff.data);

            if(at == 0) {
              // transpose
              jsfeat.matmath.transpose(a_mt, A);
            } else {
              for(i = 0; i < _n*_m; i++) {
                a_mt.data[i] = A.data[i];
              }
              for(; i < n*m; i++) {
                a_mt.data[i] = 0;
              }
            }

            JacobiSVDImpl(a_mt.data, m, w_mt.data, v_mt.data, n, m, n, m);

            if(W) {
              for(i=0; i < n; i++) {
                W.data[i] = w_mt.data[i];
              }
              for(; i < _n; i++) {
                W.data[i] = 0;
              }
            }

            if (at == 0) {
              if(U && (options & jsfeat.SVD_U_T)) {
                i = m*m;
                while(--i >= 0) {
                  U.data[i] = a_mt.data[i];
                }
              } else if(U) {
                jsfeat.matmath.transpose(U, a_mt);
              }

              if(V && (options & jsfeat.SVD_V_T)) {
                i = n*n;
                while(--i >= 0) {
                  V.data[i] = v_mt.data[i];
                }
              } else if(V) {
                jsfeat.matmath.transpose(V, v_mt);
              }
            } else {
              if(U && (options & jsfeat.SVD_U_T)) {
                i = n*n;
                while(--i >= 0) {
                  U.data[i] = v_mt.data[i];
                }
              } else if(U) {
                jsfeat.matmath.transpose(U, v_mt);
              }

              if(V && (options & jsfeat.SVD_V_T)) {
                i = m*m;
                while(--i >= 0) {
                  V.data[i] = a_mt.data[i];
                }
              } else if(V) {
                jsfeat.matmath.transpose(V, a_mt);
              }
            }

            jsfeat.cache.put_buffer(a_buff);
            jsfeat.cache.put_buffer(w_buff);
            jsfeat.cache.put_buffer(v_buff);

          },

          svd_solve: function(A, X, B) {
            var i=0,j=0,k=0;
            var pu=0,pv=0;
            var nrows=A.rows,ncols=A.cols;
            var sum=0.0,xsum=0.0,tol=0.0;
            var dt = A.type | jsfeat.C1_t;

            var u_buff = jsfeat.cache.get_buffer((nrows*nrows)<<3);
            var w_buff = jsfeat.cache.get_buffer(ncols<<3);
            var v_buff = jsfeat.cache.get_buffer((ncols*ncols)<<3);

            var u_mt = new jsfeat.matrix_t(nrows, nrows, dt, u_buff.data);
            var w_mt = new jsfeat.matrix_t(1, ncols, dt, w_buff.data);
            var v_mt = new jsfeat.matrix_t(ncols, ncols, dt, v_buff.data);

            var bd = B.data, ud = u_mt.data, wd = w_mt.data, vd = v_mt.data;

            this.svd_decompose(A, w_mt, u_mt, v_mt, 0);

            tol = jsfeat.EPSILON * wd[0] * ncols;

            for (; i < ncols; i++, pv += ncols) {
              xsum = 0.0;
              for(j = 0; j < ncols; j++) {
                if(wd[j] > tol) {
                  for(k = 0, sum = 0.0, pu = 0; k < nrows; k++, pu += ncols) {
                    sum += ud[pu + j] * bd[k];
                  }
                  xsum += sum * vd[pv + j] / wd[j];
                }
              }
              X.data[i] = xsum;
            }

            jsfeat.cache.put_buffer(u_buff);
            jsfeat.cache.put_buffer(w_buff);
            jsfeat.cache.put_buffer(v_buff);
          },

          svd_invert: function(Ai, A) {
            var i=0,j=0,k=0;
            var pu=0,pv=0,pa=0;
            var nrows=A.rows,ncols=A.cols;
            var sum=0.0,tol=0.0;
            var dt = A.type | jsfeat.C1_t;

            var u_buff = jsfeat.cache.get_buffer((nrows*nrows)<<3);
            var w_buff = jsfeat.cache.get_buffer(ncols<<3);
            var v_buff = jsfeat.cache.get_buffer((ncols*ncols)<<3);

            var u_mt = new jsfeat.matrix_t(nrows, nrows, dt, u_buff.data);
            var w_mt = new jsfeat.matrix_t(1, ncols, dt, w_buff.data);
            var v_mt = new jsfeat.matrix_t(ncols, ncols, dt, v_buff.data);

            var id = Ai.data, ud = u_mt.data, wd = w_mt.data, vd = v_mt.data;

            this.svd_decompose(A, w_mt, u_mt, v_mt, 0);

            tol = jsfeat.EPSILON * wd[0] * ncols;

            for (; i < ncols; i++, pv += ncols) {
              for (j = 0, pu = 0; j < nrows; j++, pa++) {
                for (k = 0, sum = 0.0; k < ncols; k++, pu++) {
                  if (wd[k] > tol) sum += vd[pv + k] * ud[pu] / wd[k];
                }
                id[pa] = sum;
              }
            }

            jsfeat.cache.put_buffer(u_buff);
            jsfeat.cache.put_buffer(w_buff);
            jsfeat.cache.put_buffer(v_buff);
          },

          eigenVV: function(A, vects, vals) {
            var n=A.cols,i=n*n;
            var dt = A.type | jsfeat.C1_t;

            var a_buff = jsfeat.cache.get_buffer((n*n)<<3);
            var w_buff = jsfeat.cache.get_buffer(n<<3);
            var a_mt = new jsfeat.matrix_t(n, n, dt, a_buff.data);
            var w_mt = new jsfeat.matrix_t(1, n, dt, w_buff.data);

            while(--i >= 0) {
              a_mt.data[i] = A.data[i];
            }

            JacobiImpl(a_mt.data, n, w_mt.data, vects ? vects.data : null, n, n);

            if(vals) {
              while(--n >= 0) {
                vals.data[n] = w_mt.data[n];
              }
            }

            jsfeat.cache.put_buffer(a_buff);
            jsfeat.cache.put_buffer(w_buff);
          }

        };

      })();

      global.linalg = linalg;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     */

    (function(global) {
      "use strict";
      //

      var motion_model = (function() {

        var sqr = function(x) {
          return x*x;
        };

        // does isotropic normalization
        var iso_normalize_points = function(from, to, T0, T1, count) {
          var i=0;
          var cx0=0.0, cy0=0.0, d0=0.0, s0=0.0;
          var cx1=0.0, cy1=0.0, d1=0.0, s1=0.0;
          var dx=0.0,dy=0.0;

          for (; i < count; ++i) {
            cx0 += from[i].x;
            cy0 += from[i].y;
            cx1 += to[i].x;
            cy1 += to[i].y;
          }

          cx0 /= count; cy0 /= count;
          cx1 /= count; cy1 /= count;

          for (i = 0; i < count; ++i) {
            dx = from[i].x - cx0;
            dy = from[i].y - cy0;
            d0 += Math.sqrt(dx*dx + dy*dy);
            dx = to[i].x - cx1;
            dy = to[i].y - cy1;
            d1 += Math.sqrt(dx*dx + dy*dy);
          }

          d0 /= count; d1 /= count;

          s0 = Math.SQRT2 / d0; s1 = Math.SQRT2 / d1;

          T0[0] = T0[4] = s0;
          T0[2] = -cx0*s0;
          T0[5] = -cy0*s0;
          T0[1] = T0[3] = T0[6] = T0[7] = 0.0;
          T0[8] = 1.0;

          T1[0] = T1[4] = s1;
          T1[2] = -cx1*s1;
          T1[5] = -cy1*s1;
          T1[1] = T1[3] = T1[6] = T1[7] = 0.0;
          T1[8] = 1.0;
        };

        var have_collinear_points = function(points, count) {
          var j=0,k=0,i=(count-1)|0;
          var dx1=0.0,dy1=0.0,dx2=0.0,dy2=0.0;

          // check that the i-th selected point does not belong
          // to a line connecting some previously selected points
          for(; j < i; ++j) {
            dx1 = points[j].x - points[i].x;
            dy1 = points[j].y - points[i].y;
            for(k = 0; k < j; ++k) {
              dx2 = points[k].x - points[i].x;
              dy2 = points[k].y - points[i].y;
              if( Math.abs(dx2*dy1 - dy2*dx1) <= jsfeat.EPSILON*(Math.abs(dx1) + Math.abs(dy1) + Math.abs(dx2) + Math.abs(dy2)))
                return true;
            }
          }
          return false;
        };

        var T0 = new jsfeat.matrix_t(3, 3, jsfeat.F32_t|jsfeat.C1_t);
        var T1 = new jsfeat.matrix_t(3, 3, jsfeat.F32_t|jsfeat.C1_t);
        var AtA = new jsfeat.matrix_t(6, 6, jsfeat.F32_t|jsfeat.C1_t);
        var AtB = new jsfeat.matrix_t(6, 1, jsfeat.F32_t|jsfeat.C1_t);

        var affine2d = (function () {

          function affine2d() {
            // empty constructor
          }

          affine2d.prototype.run = function(from, to, model, count) {
            var i=0,j=0;
            var dt=model.type|jsfeat.C1_t;
            var md=model.data, t0d=T0.data, t1d=T1.data;
            var pt0,pt1,px=0.0,py=0.0;

            iso_normalize_points(from, to, t0d, t1d, count);

            var a_buff = jsfeat.cache.get_buffer((2*count*6)<<3);
            var b_buff = jsfeat.cache.get_buffer((2*count)<<3);

            var a_mt = new jsfeat.matrix_t(6, 2*count, dt, a_buff.data);
            var b_mt = new jsfeat.matrix_t(1, 2*count, dt, b_buff.data);
            var ad=a_mt.data, bd=b_mt.data;

            for (; i < count; ++i) {
              pt0 = from[i];
              pt1 = to[i];

              px = t0d[0]*pt0.x + t0d[1]*pt0.y + t0d[2];
              py = t0d[3]*pt0.x + t0d[4]*pt0.y + t0d[5];

              j = i*2*6;
              ad[j]=px, ad[j+1]=py, ad[j+2]=1.0, ad[j+3]=0.0, ad[j+4]=0.0, ad[j+5]=0.0;

              j += 6;
              ad[j]=0.0, ad[j+1]=0.0, ad[j+2]=0.0, ad[j+3]=px, ad[j+4]=py, ad[j+5]=1.0;

              bd[i<<1] = t1d[0]*pt1.x + t1d[1]*pt1.y + t1d[2];
              bd[(i<<1)+1] = t1d[3]*pt1.x + t1d[4]*pt1.y + t1d[5];
            }

            jsfeat.matmath.multiply_AtA(AtA, a_mt);
            jsfeat.matmath.multiply_AtB(AtB, a_mt, b_mt);

            jsfeat.linalg.lu_solve(AtA, AtB);

            md[0] = AtB.data[0], md[1]=AtB.data[1], md[2]=AtB.data[2];
            md[3] = AtB.data[3], md[4]=AtB.data[4], md[5]=AtB.data[5];
            md[6] = 0.0, md[7] = 0.0, md[8] = 1.0; // fill last row

            // denormalize
            jsfeat.matmath.invert_3x3(T1, T1);
            jsfeat.matmath.multiply_3x3(model, T1, model);
            jsfeat.matmath.multiply_3x3(model, model, T0);

            // free buffer
            jsfeat.cache.put_buffer(a_buff);
            jsfeat.cache.put_buffer(b_buff);

            return 1;
          };

          affine2d.prototype.error = function(from, to, model, err, count) {
            var i=0;
            var pt0,pt1;
            var m=model.data;

            for (; i < count; ++i) {
              pt0 = from[i];
              pt1 = to[i];

              err[i] = sqr(pt1.x - m[0]*pt0.x - m[1]*pt0.y - m[2]) +
                sqr(pt1.y - m[3]*pt0.x - m[4]*pt0.y - m[5]);
            }
          };

          affine2d.prototype.check_subset = function(from, to, count) {
            return true; // all good
          };

          return affine2d;
        })();

        var mLtL = new jsfeat.matrix_t(9, 9, jsfeat.F32_t|jsfeat.C1_t);
        var Evec = new jsfeat.matrix_t(9, 9, jsfeat.F32_t|jsfeat.C1_t);

        var homography2d = (function () {

          function homography2d() {
            // empty constructor
            //this.T0 = new jsfeat.matrix_t(3, 3, jsfeat.F32_t|jsfeat.C1_t);
            //this.T1 = new jsfeat.matrix_t(3, 3, jsfeat.F32_t|jsfeat.C1_t);
            //this.mLtL = new jsfeat.matrix_t(9, 9, jsfeat.F32_t|jsfeat.C1_t);
            //this.Evec = new jsfeat.matrix_t(9, 9, jsfeat.F32_t|jsfeat.C1_t);
          }

          homography2d.prototype.run = function(from, to, model, count) {
            var i=0,j=0;
            var md=model.data, t0d=T0.data, t1d=T1.data;
            var LtL=mLtL.data, evd=Evec.data;
            var x=0.0,y=0.0,X=0.0,Y=0.0;

            // norm
            var smx=0.0, smy=0.0, cmx=0.0, cmy=0.0, sMx=0.0, sMy=0.0, cMx=0.0, cMy=0.0;

            for(; i < count; ++i) {
              cmx += to[i].x;
              cmy += to[i].y;
              cMx += from[i].x;
              cMy += from[i].y;
            }

            cmx /= count; cmy /= count;
            cMx /= count; cMy /= count;

            for(i = 0; i < count; ++i)
            {
              smx += Math.abs(to[i].x - cmx);
              smy += Math.abs(to[i].y - cmy);
              sMx += Math.abs(from[i].x - cMx);
              sMy += Math.abs(from[i].y - cMy);
            }

            if( Math.abs(smx) < jsfeat.EPSILON
              || Math.abs(smy) < jsfeat.EPSILON
              || Math.abs(sMx) < jsfeat.EPSILON
              || Math.abs(sMy) < jsfeat.EPSILON ) return 0;

            smx = count/smx; smy = count/smy;
            sMx = count/sMx; sMy = count/sMy;

            t0d[0] = sMx; 	t0d[1] = 0; 	t0d[2] = -cMx*sMx;
            t0d[3] = 0; 	t0d[4] = sMy; 	t0d[5] = -cMy*sMy;
            t0d[6] = 0; 	t0d[7] = 0; 	t0d[8] = 1;

            t1d[0] = 1.0/smx; 	t1d[1] = 0; 		t1d[2] = cmx;
            t1d[3] = 0; 		t1d[4] = 1.0/smy; 	t1d[5] = cmy;
            t1d[6] = 0; 		t1d[7] = 0; 		t1d[8] = 1;
            //

            // construct system
            i = 81;
            while(--i >= 0) {
              LtL[i] = 0.0;
            }
            for(i = 0; i < count; ++i) {
              x = (to[i].x - cmx) * smx;
              y = (to[i].y - cmy) * smy;
              X = (from[i].x - cMx) * sMx;
              Y = (from[i].y - cMy) * sMy;

              LtL[0] += X*X;
              LtL[1] += X*Y;
              LtL[2] += X;

              LtL[6] += X*-x*X;
              LtL[7] += X*-x*Y;
              LtL[8] += X*-x;
              LtL[10] += Y*Y;
              LtL[11] += Y;

              LtL[15] += Y*-x*X;
              LtL[16] += Y*-x*Y;
              LtL[17] += Y*-x;
              LtL[20] += 1.0;

              LtL[24] += -x*X;
              LtL[25] += -x*Y;
              LtL[26] += -x;
              LtL[30] += X*X;
              LtL[31] += X*Y;
              LtL[32] += X;
              LtL[33] += X*-y*X;
              LtL[34] += X*-y*Y;
              LtL[35] += X*-y;
              LtL[40] += Y*Y;
              LtL[41] += Y;
              LtL[42] += Y*-y*X;
              LtL[43] += Y*-y*Y;
              LtL[44] += Y*-y;
              LtL[50] += 1.0;
              LtL[51] += -y*X;
              LtL[52] += -y*Y;
              LtL[53] += -y;
              LtL[60] += -x*X*-x*X + -y*X*-y*X;
              LtL[61] += -x*X*-x*Y + -y*X*-y*Y;
              LtL[62] += -x*X*-x + -y*X*-y;
              LtL[70] += -x*Y*-x*Y + -y*Y*-y*Y;
              LtL[71] += -x*Y*-x + -y*Y*-y;
              LtL[80] += -x*-x + -y*-y;
            }
            //

            // symmetry
            for(i = 0; i < 9; ++i) {
              for(j = 0; j < i; ++j)
                LtL[i*9+j] = LtL[j*9+i];
            }

            jsfeat.linalg.eigenVV(mLtL, Evec);

            md[0]=evd[72], md[1]=evd[73], md[2]=evd[74];
            md[3]=evd[75], md[4]=evd[76], md[5]=evd[77];
            md[6]=evd[78], md[7]=evd[79], md[8]=evd[80];

            // denormalize
            jsfeat.matmath.multiply_3x3(model, T1, model);
            jsfeat.matmath.multiply_3x3(model, model, T0);

            // set bottom right to 1.0
            x = 1.0/md[8];
            md[0] *= x; md[1] *= x; md[2] *= x;
            md[3] *= x; md[4] *= x; md[5] *= x;
            md[6] *= x; md[7] *= x; md[8] = 1.0;

            return 1;
          };

          homography2d.prototype.error = function(from, to, model, err, count) {
            var i=0;
            var pt0,pt1,ww=0.0,dx=0.0,dy=0.0;
            var m=model.data;

            for (; i < count; ++i) {
              pt0 = from[i];
              pt1 = to[i];

              ww = 1.0/(m[6]*pt0.x + m[7]*pt0.y + 1.0);
              dx = (m[0]*pt0.x + m[1]*pt0.y + m[2])*ww - pt1.x;
              dy = (m[3]*pt0.x + m[4]*pt0.y + m[5])*ww - pt1.y;
              err[i] = (dx*dx + dy*dy);
            }
          };

          homography2d.prototype.check_subset = function(from, to, count) {
            // seems to reject good subsets actually
            //if( have_collinear_points(from, count) || have_collinear_points(to, count) ) {
            //return false;
            //}
            if( count == 4 ) {
              var negative = 0;

              var fp0=from[0],fp1=from[1],fp2=from[2],fp3=from[3];
              var tp0=to[0],tp1=to[1],tp2=to[2],tp3=to[3];

              // set1
              var A11=fp0.x, A12=fp0.y, A13=1.0;
              var A21=fp1.x, A22=fp1.y, A23=1.0;
              var A31=fp2.x, A32=fp2.y, A33=1.0;

              var B11=tp0.x, B12=tp0.y, B13=1.0;
              var B21=tp1.x, B22=tp1.y, B23=1.0;
              var B31=tp2.x, B32=tp2.y, B33=1.0;

              var detA = jsfeat.matmath.determinant_3x3(A11,A12,A13, A21,A22,A23, A31,A32,A33);
              var detB = jsfeat.matmath.determinant_3x3(B11,B12,B13, B21,B22,B23, B31,B32,B33);

              if(detA*detB < 0) negative++;

              // set2
              A11=fp1.x, A12=fp1.y;
              A21=fp2.x, A22=fp2.y;
              A31=fp3.x, A32=fp3.y;

              B11=tp1.x, B12=tp1.y;
              B21=tp2.x, B22=tp2.y;
              B31=tp3.x, B32=tp3.y;

              detA = jsfeat.matmath.determinant_3x3(A11,A12,A13, A21,A22,A23, A31,A32,A33);
              detB = jsfeat.matmath.determinant_3x3(B11,B12,B13, B21,B22,B23, B31,B32,B33);

              if(detA*detB < 0) negative++;

              // set3
              A11=fp0.x, A12=fp0.y;
              A21=fp2.x, A22=fp2.y;
              A31=fp3.x, A32=fp3.y;

              B11=tp0.x, B12=tp0.y;
              B21=tp2.x, B22=tp2.y;
              B31=tp3.x, B32=tp3.y;

              detA = jsfeat.matmath.determinant_3x3(A11,A12,A13, A21,A22,A23, A31,A32,A33);
              detB = jsfeat.matmath.determinant_3x3(B11,B12,B13, B21,B22,B23, B31,B32,B33);

              if(detA*detB < 0) negative++;

              // set4
              A11=fp0.x, A12=fp0.y;
              A21=fp1.x, A22=fp1.y;
              A31=fp3.x, A32=fp3.y;

              B11=tp0.x, B12=tp0.y;
              B21=tp1.x, B22=tp1.y;
              B31=tp3.x, B32=tp3.y;

              detA = jsfeat.matmath.determinant_3x3(A11,A12,A13, A21,A22,A23, A31,A32,A33);
              detB = jsfeat.matmath.determinant_3x3(B11,B12,B13, B21,B22,B23, B31,B32,B33);

              if(detA*detB < 0) negative++;

              if(negative != 0 && negative != 4) {
                return false;
              }
            }
            return true; // all good
          };

          return homography2d;
        })();

        return {

          affine2d:affine2d,
          homography2d:homography2d

        };

      })();

      var ransac_params_t = (function () {
        function ransac_params_t(size, thresh, eps, prob) {
          if (typeof size === "undefined") { size=0; }
          if (typeof thresh === "undefined") { thresh=0.5; }
          if (typeof eps === "undefined") { eps=0.5; }
          if (typeof prob === "undefined") { prob=0.99; }

          this.size = size;
          this.thresh = thresh;
          this.eps = eps;
          this.prob = prob;
        }
        ransac_params_t.prototype.update_iters = function(_eps, max_iters) {
          var num = Math.log(1 - this.prob);
          var denom = Math.log(1 - Math.pow(1 - _eps, this.size));
          return (denom >= 0 || -num >= max_iters*(-denom) ? max_iters : Math.round(num/denom))|0;
        };
        return ransac_params_t;
      })();

      var motion_estimator = (function() {

        var get_subset = function(kernel, from, to, need_cnt, max_cnt, from_sub, to_sub) {
          var max_try = 1000;
          var indices = [];
          var i=0, j=0, ssiter=0, idx_i=0, ok=false;
          for(; ssiter < max_try; ++ssiter)  {
            i = 0;
            for (; i < need_cnt && ssiter < max_try;) {
              ok = false;
              idx_i = 0;
              while (!ok) {
                ok = true;
                idx_i = indices[i] = Math.floor(Math.random() * max_cnt)|0;
                for (j = 0; j < i; ++j) {
                  if (idx_i == indices[j])
                  { ok = false; break; }
                }
              }
              from_sub[i] = from[idx_i];
              to_sub[i] = to[idx_i];
              if( !kernel.check_subset( from_sub, to_sub, i+1 ) ) {
                ssiter++;
                continue;
              }
              ++i;
            }
            break;
          }

          return (i == need_cnt && ssiter < max_try);
        };

        var find_inliers = function(kernel, model, from, to, count, thresh, err, mask) {
          var numinliers = 0, i=0, f=0;
          var t = thresh*thresh;

          kernel.error(from, to, model, err, count);

          for(; i < count; ++i) {
            f = err[i] <= t;
            mask[i] = f;
            numinliers += f;
          }
          return numinliers;
        };

        return {

          ransac: function(params, kernel, from, to, count, model, mask, max_iters) {
            if (typeof max_iters === "undefined") { max_iters=1000; }

            if(count < params.size) return false;

            var model_points = params.size;
            var niters = max_iters, iter=0;
            var result = false;

            var subset0 = [];
            var subset1 = [];
            var found = false;

            var mc=model.cols,mr=model.rows;
            var dt = model.type | jsfeat.C1_t;

            var m_buff = jsfeat.cache.get_buffer((mc*mr)<<3);
            var ms_buff = jsfeat.cache.get_buffer(count);
            var err_buff = jsfeat.cache.get_buffer(count<<2);
            var M = new jsfeat.matrix_t(mc, mr, dt, m_buff.data);
            var curr_mask = new jsfeat.matrix_t(count, 1, jsfeat.U8C1_t, ms_buff.data);

            var inliers_max = -1, numinliers=0;
            var nmodels = 0;

            var err = err_buff.f32;

            // special case
            if(count == model_points) {
              if(kernel.run(from, to, M, count) <= 0) {
                jsfeat.cache.put_buffer(m_buff);
                jsfeat.cache.put_buffer(ms_buff);
                jsfeat.cache.put_buffer(err_buff);
                return false;
              }

              M.copy_to(model);
              if(mask) {
                while(--count >= 0) {
                  mask.data[count] = 1;
                }
              }
              jsfeat.cache.put_buffer(m_buff);
              jsfeat.cache.put_buffer(ms_buff);
              jsfeat.cache.put_buffer(err_buff);
              return true;
            }

            for (; iter < niters; ++iter) {
              // generate subset
              found = get_subset(kernel, from, to, model_points, count, subset0, subset1);
              if(!found) {
                if(iter == 0) {
                  jsfeat.cache.put_buffer(m_buff);
                  jsfeat.cache.put_buffer(ms_buff);
                  jsfeat.cache.put_buffer(err_buff);
                  return false;
                }
                break;
              }

              nmodels = kernel.run( subset0, subset1, M, model_points );
              if(nmodels <= 0)
                continue;

              // TODO handle multimodel output

              numinliers = find_inliers(kernel, M, from, to, count, params.thresh, err, curr_mask.data);

              if( numinliers > Math.max(inliers_max, model_points-1) ) {
                M.copy_to(model);
                inliers_max = numinliers;
                if(mask) curr_mask.copy_to(mask);
                niters = params.update_iters((count - numinliers)/count, niters);
                result = true;
              }
            }

            jsfeat.cache.put_buffer(m_buff);
            jsfeat.cache.put_buffer(ms_buff);
            jsfeat.cache.put_buffer(err_buff);

            return result;
          },

          lmeds: function(params, kernel, from, to, count, model, mask, max_iters) {
            if (typeof max_iters === "undefined") { max_iters=1000; }

            if(count < params.size) return false;

            var model_points = params.size;
            var niters = max_iters, iter=0;
            var result = false;

            var subset0 = [];
            var subset1 = [];
            var found = false;

            var mc=model.cols,mr=model.rows;
            var dt = model.type | jsfeat.C1_t;

            var m_buff = jsfeat.cache.get_buffer((mc*mr)<<3);
            var ms_buff = jsfeat.cache.get_buffer(count);
            var err_buff = jsfeat.cache.get_buffer(count<<2);
            var M = new jsfeat.matrix_t(mc, mr, dt, m_buff.data);
            var curr_mask = new jsfeat.matrix_t(count, 1, jsfeat.U8_t|jsfeat.C1_t, ms_buff.data);

            var numinliers=0;
            var nmodels = 0;

            var err = err_buff.f32;
            var min_median = 1000000000.0, sigma=0.0, median=0.0;

            params.eps = 0.45;
            niters = params.update_iters(params.eps, niters);

            // special case
            if(count == model_points) {
              if(kernel.run(from, to, M, count) <= 0) {
                jsfeat.cache.put_buffer(m_buff);
                jsfeat.cache.put_buffer(ms_buff);
                jsfeat.cache.put_buffer(err_buff);
                return false;
              }

              M.copy_to(model);
              if(mask) {
                while(--count >= 0) {
                  mask.data[count] = 1;
                }
              }
              jsfeat.cache.put_buffer(m_buff);
              jsfeat.cache.put_buffer(ms_buff);
              jsfeat.cache.put_buffer(err_buff);
              return true;
            }

            for (; iter < niters; ++iter) {
              // generate subset
              found = get_subset(kernel, from, to, model_points, count, subset0, subset1);
              if(!found) {
                if(iter == 0) {
                  jsfeat.cache.put_buffer(m_buff);
                  jsfeat.cache.put_buffer(ms_buff);
                  jsfeat.cache.put_buffer(err_buff);
                  return false;
                }
                break;
              }

              nmodels = kernel.run( subset0, subset1, M, model_points );
              if(nmodels <= 0)
                continue;

              // TODO handle multimodel output

              kernel.error(from, to, M, err, count);
              median = jsfeat.math.median(err, 0, count-1);

              if(median < min_median) {
                min_median = median;
                M.copy_to(model);
                result = true;
              }
            }

            if(result) {
              sigma = 2.5*1.4826*(1 + 5.0/(count - model_points))*Math.sqrt(min_median);
              sigma = Math.max(sigma, 0.001);

              numinliers = find_inliers(kernel, model, from, to, count, sigma, err, curr_mask.data);
              if(mask) curr_mask.copy_to(mask);

              result = numinliers >= model_points;
            }

            jsfeat.cache.put_buffer(m_buff);
            jsfeat.cache.put_buffer(ms_buff);
            jsfeat.cache.put_buffer(err_buff);

            return result;
          }

        };

      })();

      global.ransac_params_t = ransac_params_t;
      global.motion_model = motion_model;
      global.motion_estimator = motion_estimator;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     */

    (function(global) {
      "use strict";
      //

      var imgproc = (function() {

        var _resample_u8 = function(src, dst, nw, nh) {
          var xofs_count=0;
          var ch=src.channel,w=src.cols,h=src.rows;
          var src_d=src.data,dst_d=dst.data;
          var scale_x = w / nw, scale_y = h / nh;
          var inv_scale_256 = (scale_x * scale_y * 0x10000)|0;
          var dx=0,dy=0,sx=0,sy=0,sx1=0,sx2=0,i=0,k=0,fsx1=0.0,fsx2=0.0;
          var a=0,b=0,dxn=0,alpha=0,beta=0,beta1=0;

          var buf_node = jsfeat.cache.get_buffer((nw*ch)<<2);
          var sum_node = jsfeat.cache.get_buffer((nw*ch)<<2);
          var xofs_node = jsfeat.cache.get_buffer((w*2*3)<<2);

          var buf = buf_node.i32;
          var sum = sum_node.i32;
          var xofs = xofs_node.i32;

          for (; dx < nw; dx++) {
            fsx1 = dx * scale_x, fsx2 = fsx1 + scale_x;
            sx1 = (fsx1 + 1.0 - 1e-6)|0, sx2 = fsx2|0;
            sx1 = Math.min(sx1, w - 1);
            sx2 = Math.min(sx2, w - 1);

            if(sx1 > fsx1) {
              xofs[k++] = (dx * ch)|0;
              xofs[k++] = ((sx1 - 1)*ch)|0;
              xofs[k++] = ((sx1 - fsx1) * 0x100)|0;
              xofs_count++;
            }
            for(sx = sx1; sx < sx2; sx++){
              xofs_count++;
              xofs[k++] = (dx * ch)|0;
              xofs[k++] = (sx * ch)|0;
              xofs[k++] = 256;
            }
            if(fsx2 - sx2 > 1e-3) {
              xofs_count++;
              xofs[k++] = (dx * ch)|0;
              xofs[k++] = (sx2 * ch)|0;
              xofs[k++] = ((fsx2 - sx2) * 256)|0;
            }
          }

          for (dx = 0; dx < nw * ch; dx++) {
            buf[dx] = sum[dx] = 0;
          }
          dy = 0;
          for (sy = 0; sy < h; sy++) {
            a = w * sy;
            for (k = 0; k < xofs_count; k++) {
              dxn = xofs[k*3];
              sx1 = xofs[k*3+1];
              alpha = xofs[k*3+2];
              for (i = 0; i < ch; i++) {
                buf[dxn + i] += src_d[a+sx1+i] * alpha;
              }
            }
            if ((dy + 1) * scale_y <= sy + 1 || sy == h - 1) {
              beta = (Math.max(sy + 1 - (dy + 1) * scale_y, 0.0) * 256)|0;
              beta1 = 256 - beta;
              b = nw * dy;
              if (beta <= 0) {
                for (dx = 0; dx < nw * ch; dx++) {
                  dst_d[b+dx] = Math.min(Math.max((sum[dx] + buf[dx] * 256) / inv_scale_256, 0), 255);
                  sum[dx] = buf[dx] = 0;
                }
              } else {
                for (dx = 0; dx < nw * ch; dx++) {
                  dst_d[b+dx] = Math.min(Math.max((sum[dx] + buf[dx] * beta1) / inv_scale_256, 0), 255);
                  sum[dx] = buf[dx] * beta;
                  buf[dx] = 0;
                }
              }
              dy++;
            } else {
              for(dx = 0; dx < nw * ch; dx++) {
                sum[dx] += buf[dx] * 256;
                buf[dx] = 0;
              }
            }
          }

          jsfeat.cache.put_buffer(sum_node);
          jsfeat.cache.put_buffer(buf_node);
          jsfeat.cache.put_buffer(xofs_node);
        };

        var _resample = function(src, dst, nw, nh) {
          var xofs_count=0;
          var ch=src.channel,w=src.cols,h=src.rows;
          var src_d=src.data,dst_d=dst.data;
          var scale_x = w / nw, scale_y = h / nh;
          var scale = 1.0 / (scale_x * scale_y);
          var dx=0,dy=0,sx=0,sy=0,sx1=0,sx2=0,i=0,k=0,fsx1=0.0,fsx2=0.0;
          var a=0,b=0,dxn=0,alpha=0.0,beta=0.0,beta1=0.0;

          var buf_node = jsfeat.cache.get_buffer((nw*ch)<<2);
          var sum_node = jsfeat.cache.get_buffer((nw*ch)<<2);
          var xofs_node = jsfeat.cache.get_buffer((w*2*3)<<2);

          var buf = buf_node.f32;
          var sum = sum_node.f32;
          var xofs = xofs_node.f32;

          for (; dx < nw; dx++) {
            fsx1 = dx * scale_x, fsx2 = fsx1 + scale_x;
            sx1 = (fsx1 + 1.0 - 1e-6)|0, sx2 = fsx2|0;
            sx1 = Math.min(sx1, w - 1);
            sx2 = Math.min(sx2, w - 1);

            if(sx1 > fsx1) {
              xofs_count++;
              xofs[k++] = ((sx1 - 1)*ch)|0;
              xofs[k++] = (dx * ch)|0;
              xofs[k++] = (sx1 - fsx1) * scale;
            }
            for(sx = sx1; sx < sx2; sx++){
              xofs_count++;
              xofs[k++] = (sx * ch)|0;
              xofs[k++] = (dx * ch)|0;
              xofs[k++] = scale;
            }
            if(fsx2 - sx2 > 1e-3) {
              xofs_count++;
              xofs[k++] = (sx2 * ch)|0;
              xofs[k++] = (dx * ch)|0;
              xofs[k++] = (fsx2 - sx2) * scale;
            }
          }

          for (dx = 0; dx < nw * ch; dx++) {
            buf[dx] = sum[dx] = 0;
          }
          dy = 0;
          for (sy = 0; sy < h; sy++) {
            a = w * sy;
            for (k = 0; k < xofs_count; k++) {
              sx1 = xofs[k*3]|0;
              dxn = xofs[k*3+1]|0;
              alpha = xofs[k*3+2];
              for (i = 0; i < ch; i++) {
                buf[dxn + i] += src_d[a+sx1+i] * alpha;
              }
            }
            if ((dy + 1) * scale_y <= sy + 1 || sy == h - 1) {
              beta = Math.max(sy + 1 - (dy + 1) * scale_y, 0.0);
              beta1 = 1.0 - beta;
              b = nw * dy;
              if (Math.abs(beta) < 1e-3) {
                for (dx = 0; dx < nw * ch; dx++) {
                  dst_d[b+dx] = sum[dx] + buf[dx];
                  sum[dx] = buf[dx] = 0;
                }
              } else {
                for (dx = 0; dx < nw * ch; dx++) {
                  dst_d[b+dx] = sum[dx] + buf[dx] * beta1;
                  sum[dx] = buf[dx] * beta;
                  buf[dx] = 0;
                }
              }
              dy++;
            } else {
              for(dx = 0; dx < nw * ch; dx++) {
                sum[dx] += buf[dx];
                buf[dx] = 0;
              }
            }
          }
          jsfeat.cache.put_buffer(sum_node);
          jsfeat.cache.put_buffer(buf_node);
          jsfeat.cache.put_buffer(xofs_node);
        };

        var _convol_u8 = function(buf, src_d, dst_d, w, h, filter, kernel_size, half_kernel) {
          var i=0,j=0,k=0,sp=0,dp=0,sum=0,sum1=0,sum2=0,sum3=0,f0=filter[0],fk=0;
          var w2=w<<1,w3=w*3,w4=w<<2;
          // hor pass
          for (; i < h; ++i) {
            sum = src_d[sp];
            for (j = 0; j < half_kernel; ++j) {
              buf[j] = sum;
            }
            for (j = 0; j <= w-2; j+=2) {
              buf[j + half_kernel] = src_d[sp+j];
              buf[j + half_kernel+1] = src_d[sp+j+1];
            }
            for (; j < w; ++j) {
              buf[j + half_kernel] = src_d[sp+j];
            }
            sum = src_d[sp+w-1];
            for (j = w; j < half_kernel + w; ++j) {
              buf[j + half_kernel] = sum;
            }
            for (j = 0; j <= w-4; j+=4) {
              sum = buf[j] * f0,
                sum1 = buf[j+1] * f0,
                sum2 = buf[j+2] * f0,
                sum3 = buf[j+3] * f0;
              for (k = 1; k < kernel_size; ++k) {
                fk = filter[k];
                sum += buf[k + j] * fk;
                sum1 += buf[k + j+1] * fk;
                sum2 += buf[k + j+2] * fk;
                sum3 += buf[k + j+3] * fk;
              }
              dst_d[dp+j] = Math.min(sum >> 8, 255);
              dst_d[dp+j+1] = Math.min(sum1 >> 8, 255);
              dst_d[dp+j+2] = Math.min(sum2 >> 8, 255);
              dst_d[dp+j+3] = Math.min(sum3 >> 8, 255);
            }
            for (; j < w; ++j) {
              sum = buf[j] * f0;
              for (k = 1; k < kernel_size; ++k) {
                sum += buf[k + j] * filter[k];
              }
              dst_d[dp+j] = Math.min(sum >> 8, 255);
            }
            sp += w;
            dp += w;
          }

          // vert pass
          for (i = 0; i < w; ++i) {
            sum = dst_d[i];
            for (j = 0; j < half_kernel; ++j) {
              buf[j] = sum;
            }
            k = i;
            for (j = 0; j <= h-2; j+=2, k+=w2) {
              buf[j+half_kernel] = dst_d[k];
              buf[j+half_kernel+1] = dst_d[k+w];
            }
            for (; j < h; ++j, k+=w) {
              buf[j+half_kernel] = dst_d[k];
            }
            sum = dst_d[(h-1)*w + i];
            for (j = h; j < half_kernel + h; ++j) {
              buf[j + half_kernel] = sum;
            }
            dp = i;
            for (j = 0; j <= h-4; j+=4, dp+=w4) {
              sum = buf[j] * f0,
                sum1 = buf[j+1] * f0,
                sum2 = buf[j+2] * f0,
                sum3 = buf[j+3] * f0;
              for (k = 1; k < kernel_size; ++k) {
                fk = filter[k];
                sum += buf[k + j] * fk;
                sum1 += buf[k + j+1] * fk;
                sum2 += buf[k + j+2] * fk;
                sum3 += buf[k + j+3] * fk;
              }
              dst_d[dp] = Math.min(sum >> 8, 255);
              dst_d[dp+w] = Math.min(sum1 >> 8, 255);
              dst_d[dp+w2] = Math.min(sum2 >> 8, 255);
              dst_d[dp+w3] = Math.min(sum3 >> 8, 255);
            }
            for (; j < h; ++j, dp+=w) {
              sum = buf[j] * f0;
              for (k = 1; k < kernel_size; ++k) {
                sum += buf[k + j] * filter[k];
              }
              dst_d[dp] = Math.min(sum >> 8, 255);
            }
          }
        };

        var _convol = function(buf, src_d, dst_d, w, h, filter, kernel_size, half_kernel) {
          var i=0,j=0,k=0,sp=0,dp=0,sum=0.0,sum1=0.0,sum2=0.0,sum3=0.0,f0=filter[0],fk=0.0;
          var w2=w<<1,w3=w*3,w4=w<<2;
          // hor pass
          for (; i < h; ++i) {
            sum = src_d[sp];
            for (j = 0; j < half_kernel; ++j) {
              buf[j] = sum;
            }
            for (j = 0; j <= w-2; j+=2) {
              buf[j + half_kernel] = src_d[sp+j];
              buf[j + half_kernel+1] = src_d[sp+j+1];
            }
            for (; j < w; ++j) {
              buf[j + half_kernel] = src_d[sp+j];
            }
            sum = src_d[sp+w-1];
            for (j = w; j < half_kernel + w; ++j) {
              buf[j + half_kernel] = sum;
            }
            for (j = 0; j <= w-4; j+=4) {
              sum = buf[j] * f0,
                sum1 = buf[j+1] * f0,
                sum2 = buf[j+2] * f0,
                sum3 = buf[j+3] * f0;
              for (k = 1; k < kernel_size; ++k) {
                fk = filter[k];
                sum += buf[k + j] * fk;
                sum1 += buf[k + j+1] * fk;
                sum2 += buf[k + j+2] * fk;
                sum3 += buf[k + j+3] * fk;
              }
              dst_d[dp+j] = sum;
              dst_d[dp+j+1] = sum1;
              dst_d[dp+j+2] = sum2;
              dst_d[dp+j+3] = sum3;
            }
            for (; j < w; ++j) {
              sum = buf[j] * f0;
              for (k = 1; k < kernel_size; ++k) {
                sum += buf[k + j] * filter[k];
              }
              dst_d[dp+j] = sum;
            }
            sp += w;
            dp += w;
          }

          // vert pass
          for (i = 0; i < w; ++i) {
            sum = dst_d[i];
            for (j = 0; j < half_kernel; ++j) {
              buf[j] = sum;
            }
            k = i;
            for (j = 0; j <= h-2; j+=2, k+=w2) {
              buf[j+half_kernel] = dst_d[k];
              buf[j+half_kernel+1] = dst_d[k+w];
            }
            for (; j < h; ++j, k+=w) {
              buf[j+half_kernel] = dst_d[k];
            }
            sum = dst_d[(h-1)*w + i];
            for (j = h; j < half_kernel + h; ++j) {
              buf[j + half_kernel] = sum;
            }
            dp = i;
            for (j = 0; j <= h-4; j+=4, dp+=w4) {
              sum = buf[j] * f0,
                sum1 = buf[j+1] * f0,
                sum2 = buf[j+2] * f0,
                sum3 = buf[j+3] * f0;
              for (k = 1; k < kernel_size; ++k) {
                fk = filter[k];
                sum += buf[k + j] * fk;
                sum1 += buf[k + j+1] * fk;
                sum2 += buf[k + j+2] * fk;
                sum3 += buf[k + j+3] * fk;
              }
              dst_d[dp] = sum;
              dst_d[dp+w] = sum1;
              dst_d[dp+w2] = sum2;
              dst_d[dp+w3] = sum3;
            }
            for (; j < h; ++j, dp+=w) {
              sum = buf[j] * f0;
              for (k = 1; k < kernel_size; ++k) {
                sum += buf[k + j] * filter[k];
              }
              dst_d[dp] = sum;
            }
          }
        };

        return {
          // TODO: add support for RGB/BGR order
          // for raw arrays
          grayscale: function(src, w, h, dst, code) {
            // this is default image data representation in browser
            if (typeof code === "undefined") { code = jsfeat.COLOR_RGBA2GRAY; }
            var x=0, y=0, i=0, j=0, ir=0,jr=0;
            var coeff_r = 4899, coeff_g = 9617, coeff_b = 1868, cn = 4;

            if(code == jsfeat.COLOR_BGRA2GRAY || code == jsfeat.COLOR_BGR2GRAY) {
              coeff_r = 1868;
              coeff_b = 4899;
            }
            if(code == jsfeat.COLOR_RGB2GRAY || code == jsfeat.COLOR_BGR2GRAY) {
              cn = 3;
            }
            var cn2 = cn<<1, cn3 = (cn*3)|0;

            dst.resize(w, h, 1);
            var dst_u8 = dst.data;

            for(y = 0; y < h; ++y, j+=w, i+=w*cn) {
              for(x = 0, ir = i, jr = j; x <= w-4; x+=4, ir+=cn<<2, jr+=4) {
                dst_u8[jr]     = (src[ir] * coeff_r + src[ir+1] * coeff_g + src[ir+2] * coeff_b + 8192) >> 14;
                dst_u8[jr + 1] = (src[ir+cn] * coeff_r + src[ir+cn+1] * coeff_g + src[ir+cn+2] * coeff_b + 8192) >> 14;
                dst_u8[jr + 2] = (src[ir+cn2] * coeff_r + src[ir+cn2+1] * coeff_g + src[ir+cn2+2] * coeff_b + 8192) >> 14;
                dst_u8[jr + 3] = (src[ir+cn3] * coeff_r + src[ir+cn3+1] * coeff_g + src[ir+cn3+2] * coeff_b + 8192) >> 14;
              }
              for (; x < w; ++x, ++jr, ir+=cn) {
                dst_u8[jr] = (src[ir] * coeff_r + src[ir+1] * coeff_g + src[ir+2] * coeff_b + 8192) >> 14;
              }
            }
          },
          // derived from CCV library
          resample: function(src, dst, nw, nh) {
            var h=src.rows,w=src.cols;
            if (h > nh && w > nw) {
              dst.resize(nw, nh, src.channel);
              // using the fast alternative (fix point scale, 0x100 to avoid overflow)
              if (src.type&jsfeat.U8_t && dst.type&jsfeat.U8_t && h * w / (nh * nw) < 0x100) {
                _resample_u8(src, dst, nw, nh);
              } else {
                _resample(src, dst, nw, nh);
              }
            }
          },

          box_blur_gray: function(src, dst, radius, options) {
            if (typeof options === "undefined") { options = 0; }
            var w=src.cols, h=src.rows, h2=h<<1, w2=w<<1;
            var i=0,x=0,y=0,end=0;
            var windowSize = ((radius << 1) + 1)|0;
            var radiusPlusOne = (radius + 1)|0, radiusPlus2 = (radiusPlusOne+1)|0;
            var scale = options&jsfeat.BOX_BLUR_NOSCALE ? 1 : (1.0 / (windowSize*windowSize));

            var tmp_buff = jsfeat.cache.get_buffer((w*h)<<2);

            var sum=0, dstIndex=0, srcIndex = 0, nextPixelIndex=0, previousPixelIndex=0;
            var data_i32 = tmp_buff.i32; // to prevent overflow
            var data_u8 = src.data;
            var hold=0;

            dst.resize(w, h, src.channel);

            // first pass
            // no need to scale
            //data_u8 = src.data;
            //data_i32 = tmp;
            for (y = 0; y < h; ++y) {
              dstIndex = y;
              sum = radiusPlusOne * data_u8[srcIndex];

              for(i = (srcIndex+1)|0, end=(srcIndex+radius)|0; i <= end; ++i) {
                sum += data_u8[i];
              }

              nextPixelIndex = (srcIndex + radiusPlusOne)|0;
              previousPixelIndex = srcIndex;
              hold = data_u8[previousPixelIndex];
              for(x = 0; x < radius; ++x, dstIndex += h) {
                data_i32[dstIndex] = sum;
                sum += data_u8[nextPixelIndex]- hold;
                nextPixelIndex ++;
              }
              for(; x < w-radiusPlus2; x+=2, dstIndex += h2) {
                data_i32[dstIndex] = sum;
                sum += data_u8[nextPixelIndex]- data_u8[previousPixelIndex];

                data_i32[dstIndex+h] = sum;
                sum += data_u8[nextPixelIndex+1]- data_u8[previousPixelIndex+1];

                nextPixelIndex +=2;
                previousPixelIndex +=2;
              }
              for(; x < w-radiusPlusOne; ++x, dstIndex += h) {
                data_i32[dstIndex] = sum;
                sum += data_u8[nextPixelIndex]- data_u8[previousPixelIndex];

                nextPixelIndex ++;
                previousPixelIndex ++;
              }

              hold = data_u8[nextPixelIndex-1];
              for(; x < w; ++x, dstIndex += h) {
                data_i32[dstIndex] = sum;

                sum += hold- data_u8[previousPixelIndex];
                previousPixelIndex ++;
              }

              srcIndex += w;
            }
            //
            // second pass
            srcIndex = 0;
            //data_i32 = tmp; // this is a transpose
            data_u8 = dst.data;

            // dont scale result
            if(scale == 1) {
              for (y = 0; y < w; ++y) {
                dstIndex = y;
                sum = radiusPlusOne * data_i32[srcIndex];

                for(i = (srcIndex+1)|0, end=(srcIndex+radius)|0; i <= end; ++i) {
                  sum += data_i32[i];
                }

                nextPixelIndex = srcIndex + radiusPlusOne;
                previousPixelIndex = srcIndex;
                hold = data_i32[previousPixelIndex];

                for(x = 0; x < radius; ++x, dstIndex += w) {
                  data_u8[dstIndex] = sum;
                  sum += data_i32[nextPixelIndex]- hold;
                  nextPixelIndex ++;
                }
                for(; x < h-radiusPlus2; x+=2, dstIndex += w2) {
                  data_u8[dstIndex] = sum;
                  sum += data_i32[nextPixelIndex]- data_i32[previousPixelIndex];

                  data_u8[dstIndex+w] = sum;
                  sum += data_i32[nextPixelIndex+1]- data_i32[previousPixelIndex+1];

                  nextPixelIndex +=2;
                  previousPixelIndex +=2;
                }
                for(; x < h-radiusPlusOne; ++x, dstIndex += w) {
                  data_u8[dstIndex] = sum;

                  sum += data_i32[nextPixelIndex]- data_i32[previousPixelIndex];
                  nextPixelIndex ++;
                  previousPixelIndex ++;
                }
                hold = data_i32[nextPixelIndex-1];
                for(; x < h; ++x, dstIndex += w) {
                  data_u8[dstIndex] = sum;

                  sum += hold- data_i32[previousPixelIndex];
                  previousPixelIndex ++;
                }

                srcIndex += h;
              }
            } else {
              for (y = 0; y < w; ++y) {
                dstIndex = y;
                sum = radiusPlusOne * data_i32[srcIndex];

                for(i = (srcIndex+1)|0, end=(srcIndex+radius)|0; i <= end; ++i) {
                  sum += data_i32[i];
                }

                nextPixelIndex = srcIndex + radiusPlusOne;
                previousPixelIndex = srcIndex;
                hold = data_i32[previousPixelIndex];

                for(x = 0; x < radius; ++x, dstIndex += w) {
                  data_u8[dstIndex] = sum*scale;
                  sum += data_i32[nextPixelIndex]- hold;
                  nextPixelIndex ++;
                }
                for(; x < h-radiusPlus2; x+=2, dstIndex += w2) {
                  data_u8[dstIndex] = sum*scale;
                  sum += data_i32[nextPixelIndex]- data_i32[previousPixelIndex];

                  data_u8[dstIndex+w] = sum*scale;
                  sum += data_i32[nextPixelIndex+1]- data_i32[previousPixelIndex+1];

                  nextPixelIndex +=2;
                  previousPixelIndex +=2;
                }
                for(; x < h-radiusPlusOne; ++x, dstIndex += w) {
                  data_u8[dstIndex] = sum*scale;

                  sum += data_i32[nextPixelIndex]- data_i32[previousPixelIndex];
                  nextPixelIndex ++;
                  previousPixelIndex ++;
                }
                hold = data_i32[nextPixelIndex-1];
                for(; x < h; ++x, dstIndex += w) {
                  data_u8[dstIndex] = sum*scale;

                  sum += hold- data_i32[previousPixelIndex];
                  previousPixelIndex ++;
                }

                srcIndex += h;
              }
            }

            jsfeat.cache.put_buffer(tmp_buff);
          },

          gaussian_blur: function(src, dst, kernel_size, sigma) {
            if (typeof sigma === "undefined") { sigma = 0.0; }
            if (typeof kernel_size === "undefined") { kernel_size = 0; }
            kernel_size = kernel_size == 0 ? (Math.max(1, (4.0 * sigma + 1.0 - 1e-8)) * 2 + 1)|0 : kernel_size;
            var half_kernel = kernel_size >> 1;
            var w = src.cols, h = src.rows;
            var data_type = src.type, is_u8 = data_type&jsfeat.U8_t;

            dst.resize(w, h, src.channel);

            var src_d = src.data, dst_d = dst.data;
            var buf,filter,buf_sz=(kernel_size + Math.max(h, w))|0;

            var buf_node = jsfeat.cache.get_buffer(buf_sz<<2);
            var filt_node = jsfeat.cache.get_buffer(kernel_size<<2);

            if(is_u8) {
              buf = buf_node.i32;
              filter = filt_node.i32;
            } else if(data_type&jsfeat.S32_t) {
              buf = buf_node.i32;
              filter = filt_node.f32;
            } else {
              buf = buf_node.f32;
              filter = filt_node.f32;
            }

            jsfeat.math.get_gaussian_kernel(kernel_size, sigma, filter, data_type);

            if(is_u8) {
              _convol_u8(buf, src_d, dst_d, w, h, filter, kernel_size, half_kernel);
            } else {
              _convol(buf, src_d, dst_d, w, h, filter, kernel_size, half_kernel);
            }

            jsfeat.cache.put_buffer(buf_node);
            jsfeat.cache.put_buffer(filt_node);
          },
          hough_transform: function( img, rho_res, theta_res, threshold ) {
            var image = img.data;

            var width = img.cols;
            var height = img.rows;
            var step = width;

            min_theta = 0.0;
            max_theta = Math.PI;

            numangle = Math.round((max_theta - min_theta) / theta_res);
            numrho = Math.round(((width + height) * 2 + 1) / rho_res);
            irho = 1.0 / rho_res;

            var accum = new Int32Array((numangle+2) * (numrho+2)); //typed arrays are initialized to 0
            var tabSin = new Float32Array(numangle);
            var tabCos = new Float32Array(numangle);

            var n=0;
            var ang = min_theta;
            for(; n < numangle; n++ ) {
              tabSin[n] = Math.sin(ang) * irho;
              tabCos[n] = Math.cos(ang) * irho;
              ang += theta_res;
            }

            // stage 1. fill accumulator
            for( var i = 0; i < height; i++ ) {
              for( var j = 0; j < width; j++ ) {
                if( image[i * step + j] != 0 ) {
                  //console.log(r, (n+1) * (numrho+2) + r+1, tabCos[n], tabSin[n]);
                  for(var n = 0; n < numangle; n++ ) {
                    var r = Math.round( j * tabCos[n] + i * tabSin[n] );
                    r += (numrho - 1) / 2;
                    accum[(n+1) * (numrho+2) + r+1] += 1;
                  }
                }
              }
            }

            // stage 2. find local maximums
            //TODO: Consider making a vector class that uses typed arrays
            _sort_buf = new Array();
            for(var r = 0; r < numrho; r++ ) {
              for(var n = 0; n < numangle; n++ ) {
                var base = (n+1) * (numrho+2) + r+1;
                if( accum[base] > threshold &&
                  accum[base] > accum[base - 1] && accum[base] >= accum[base + 1] &&
                  accum[base] > accum[base - numrho - 2] && accum[base] >= accum[base + numrho + 2] ) {
                  _sort_buf.push(base);
                }
              }
            }

            // stage 3. sort the detected lines by accumulator value
            _sort_buf.sort(function(l1, l2) {
              return accum[l1] > accum[l2] || (accum[l1] == accum[l2] && l1 < l2);
            });

            // stage 4. store the first min(total,linesMax) lines to the output buffer
            linesMax = Math.min(numangle*numrho, _sort_buf.length);
            scale = 1.0 / (numrho+2);
            lines = new Array();
            for( var i = 0; i < linesMax; i++ ) {
              var idx = _sort_buf[i];
              var n = Math.floor(idx*scale) - 1;
              var r = idx - (n+1)*(numrho+2) - 1;
              var lrho = (r - (numrho - 1)*0.5) * rho_res;
              var langle = n * theta_res;
              lines.push([lrho, langle]);
            }
            return lines;
          },
          // assume we always need it for u8 image
          pyrdown: function(src, dst, sx, sy) {
            // this is needed for bbf
            if (typeof sx === "undefined") { sx = 0; }
            if (typeof sy === "undefined") { sy = 0; }

            var w = src.cols, h = src.rows;
            var w2 = w >> 1, h2 = h >> 1;
            var _w2 = w2 - (sx << 1), _h2 = h2 - (sy << 1);
            var x=0,y=0,sptr=sx+sy*w,sline=0,dptr=0,dline=0;

            dst.resize(w2, h2, src.channel);

            var src_d = src.data, dst_d = dst.data;

            for(y = 0; y < _h2; ++y) {
              sline = sptr;
              dline = dptr;
              for(x = 0; x <= _w2-2; x+=2, dline+=2, sline += 4) {
                dst_d[dline] = (src_d[sline] + src_d[sline+1] +
                  src_d[sline+w] + src_d[sline+w+1] + 2) >> 2;
                dst_d[dline+1] = (src_d[sline+2] + src_d[sline+3] +
                  src_d[sline+w+2] + src_d[sline+w+3] + 2) >> 2;
              }
              for(; x < _w2; ++x, ++dline, sline += 2) {
                dst_d[dline] = (src_d[sline] + src_d[sline+1] +
                  src_d[sline+w] + src_d[sline+w+1] + 2) >> 2;
              }
              sptr += w << 1;
              dptr += w2;
            }
          },

          // dst: [gx,gy,...]
          scharr_derivatives: function(src, dst) {
            var w = src.cols, h = src.rows;
            var dstep = w<<1,x=0,y=0,x1=0,a,b,c,d,e,f;
            var srow0=0,srow1=0,srow2=0,drow=0;
            var trow0,trow1;

            dst.resize(w, h, 2); // 2 channel output gx, gy

            var img = src.data, gxgy=dst.data;

            var buf0_node = jsfeat.cache.get_buffer((w+2)<<2);
            var buf1_node = jsfeat.cache.get_buffer((w+2)<<2);

            if(src.type&jsfeat.U8_t || src.type&jsfeat.S32_t) {
              trow0 = buf0_node.i32;
              trow1 = buf1_node.i32;
            } else {
              trow0 = buf0_node.f32;
              trow1 = buf1_node.f32;
            }

            for(; y < h; ++y, srow1+=w) {
              srow0 = ((y > 0 ? y-1 : 1)*w)|0;
              srow2 = ((y < h-1 ? y+1 : h-2)*w)|0;
              drow = (y*dstep)|0;
              // do vertical convolution
              for(x = 0, x1 = 1; x <= w-2; x+=2, x1+=2) {
                a = img[srow0+x], b = img[srow2+x];
                trow0[x1] = ( (a + b)*3 + (img[srow1+x])*10 );
                trow1[x1] = ( b - a );
                //
                a = img[srow0+x+1], b = img[srow2+x+1];
                trow0[x1+1] = ( (a + b)*3 + (img[srow1+x+1])*10 );
                trow1[x1+1] = ( b - a );
              }
              for(; x < w; ++x, ++x1) {
                a = img[srow0+x], b = img[srow2+x];
                trow0[x1] = ( (a + b)*3 + (img[srow1+x])*10 );
                trow1[x1] = ( b - a );
              }
              // make border
              x = (w + 1)|0;
              trow0[0] = trow0[1]; trow0[x] = trow0[w];
              trow1[0] = trow1[1]; trow1[x] = trow1[w];
              // do horizontal convolution, interleave the results and store them
              for(x = 0; x <= w-4; x+=4) {
                a = trow1[x+2], b = trow1[x+1], c = trow1[x+3], d = trow1[x+4],
                  e = trow0[x+2], f = trow0[x+3];
                gxgy[drow++] = ( e - trow0[x] );
                gxgy[drow++] = ( (a + trow1[x])*3 + b*10 );
                gxgy[drow++] = ( f - trow0[x+1] );
                gxgy[drow++] = ( (c + b)*3 + a*10 );

                gxgy[drow++] = ( (trow0[x+4] - e) );
                gxgy[drow++] = ( ((d + a)*3 + c*10) );
                gxgy[drow++] = ( (trow0[x+5] - f) );
                gxgy[drow++] = ( ((trow1[x+5] + c)*3 + d*10) );
              }
              for(; x < w; ++x) {
                gxgy[drow++] = ( (trow0[x+2] - trow0[x]) );
                gxgy[drow++] = ( ((trow1[x+2] + trow1[x])*3 + trow1[x+1]*10) );
              }
            }
            jsfeat.cache.put_buffer(buf0_node);
            jsfeat.cache.put_buffer(buf1_node);
          },

          // compute gradient using Sobel kernel [1 2 1] * [-1 0 1]^T
          // dst: [gx,gy,...]
          sobel_derivatives: function(src, dst) {
            var w = src.cols, h = src.rows;
            var dstep = w<<1,x=0,y=0,x1=0,a,b,c,d,e,f;
            var srow0=0,srow1=0,srow2=0,drow=0;
            var trow0,trow1;

            dst.resize(w, h, 2); // 2 channel output gx, gy

            var img = src.data, gxgy=dst.data;

            var buf0_node = jsfeat.cache.get_buffer((w+2)<<2);
            var buf1_node = jsfeat.cache.get_buffer((w+2)<<2);

            if(src.type&jsfeat.U8_t || src.type&jsfeat.S32_t) {
              trow0 = buf0_node.i32;
              trow1 = buf1_node.i32;
            } else {
              trow0 = buf0_node.f32;
              trow1 = buf1_node.f32;
            }

            for(; y < h; ++y, srow1+=w) {
              srow0 = ((y > 0 ? y-1 : 1)*w)|0;
              srow2 = ((y < h-1 ? y+1 : h-2)*w)|0;
              drow = (y*dstep)|0;
              // do vertical convolution
              for(x = 0, x1 = 1; x <= w-2; x+=2, x1+=2) {
                a = img[srow0+x], b = img[srow2+x];
                trow0[x1] = ( (a + b) + (img[srow1+x]*2) );
                trow1[x1] = ( b - a );
                //
                a = img[srow0+x+1], b = img[srow2+x+1];
                trow0[x1+1] = ( (a + b) + (img[srow1+x+1]*2) );
                trow1[x1+1] = ( b - a );
              }
              for(; x < w; ++x, ++x1) {
                a = img[srow0+x], b = img[srow2+x];
                trow0[x1] = ( (a + b) + (img[srow1+x]*2) );
                trow1[x1] = ( b - a );
              }
              // make border
              x = (w + 1)|0;
              trow0[0] = trow0[1]; trow0[x] = trow0[w];
              trow1[0] = trow1[1]; trow1[x] = trow1[w];
              // do horizontal convolution, interleave the results and store them
              for(x = 0; x <= w-4; x+=4) {
                a = trow1[x+2], b = trow1[x+1], c = trow1[x+3], d = trow1[x+4],
                  e = trow0[x+2], f = trow0[x+3];
                gxgy[drow++] = ( e - trow0[x] );
                gxgy[drow++] = ( a + trow1[x] + b*2 );
                gxgy[drow++] = ( f - trow0[x+1] );
                gxgy[drow++] = ( c + b + a*2 );

                gxgy[drow++] = ( trow0[x+4] - e );
                gxgy[drow++] = ( d + a + c*2 );
                gxgy[drow++] = ( trow0[x+5] - f );
                gxgy[drow++] = ( trow1[x+5] + c + d*2 );
              }
              for(; x < w; ++x) {
                gxgy[drow++] = ( trow0[x+2] - trow0[x] );
                gxgy[drow++] = ( trow1[x+2] + trow1[x] + trow1[x+1]*2 );
              }
            }
            jsfeat.cache.put_buffer(buf0_node);
            jsfeat.cache.put_buffer(buf1_node);
          },

          // please note:
          // dst_(type) size should be cols = src.cols+1, rows = src.rows+1
          compute_integral_image: function(src, dst_sum, dst_sqsum, dst_tilted) {
            var w0=src.cols|0,h0=src.rows|0,src_d=src.data;
            var w1=(w0+1)|0;
            var s=0,s2=0,p=0,pup=0,i=0,j=0,v=0,k=0;

            if(dst_sum && dst_sqsum) {
              // fill first row with zeros
              for(; i < w1; ++i) {
                dst_sum[i] = 0, dst_sqsum[i] = 0;
              }
              p = (w1+1)|0, pup = 1;
              for(i = 0, k = 0; i < h0; ++i, ++p, ++pup) {
                s = s2 = 0;
                for(j = 0; j <= w0-2; j+=2, k+=2, p+=2, pup+=2) {
                  v = src_d[k];
                  s += v, s2 += v*v;
                  dst_sum[p] = dst_sum[pup] + s;
                  dst_sqsum[p] = dst_sqsum[pup] + s2;

                  v = src_d[k+1];
                  s += v, s2 += v*v;
                  dst_sum[p+1] = dst_sum[pup+1] + s;
                  dst_sqsum[p+1] = dst_sqsum[pup+1] + s2;
                }
                for(; j < w0; ++j, ++k, ++p, ++pup) {
                  v = src_d[k];
                  s += v, s2 += v*v;
                  dst_sum[p] = dst_sum[pup] + s;
                  dst_sqsum[p] = dst_sqsum[pup] + s2;
                }
              }
            } else if(dst_sum) {
              // fill first row with zeros
              for(; i < w1; ++i) {
                dst_sum[i] = 0;
              }
              p = (w1+1)|0, pup = 1;
              for(i = 0, k = 0; i < h0; ++i, ++p, ++pup) {
                s = 0;
                for(j = 0; j <= w0-2; j+=2, k+=2, p+=2, pup+=2) {
                  s += src_d[k];
                  dst_sum[p] = dst_sum[pup] + s;
                  s += src_d[k+1];
                  dst_sum[p+1] = dst_sum[pup+1] + s;
                }
                for(; j < w0; ++j, ++k, ++p, ++pup) {
                  s += src_d[k];
                  dst_sum[p] = dst_sum[pup] + s;
                }
              }
            } else if(dst_sqsum) {
              // fill first row with zeros
              for(; i < w1; ++i) {
                dst_sqsum[i] = 0;
              }
              p = (w1+1)|0, pup = 1;
              for(i = 0, k = 0; i < h0; ++i, ++p, ++pup) {
                s2 = 0;
                for(j = 0; j <= w0-2; j+=2, k+=2, p+=2, pup+=2) {
                  v = src_d[k];
                  s2 += v*v;
                  dst_sqsum[p] = dst_sqsum[pup] + s2;
                  v = src_d[k+1];
                  s2 += v*v;
                  dst_sqsum[p+1] = dst_sqsum[pup+1] + s2;
                }
                for(; j < w0; ++j, ++k, ++p, ++pup) {
                  v = src_d[k];
                  s2 += v*v;
                  dst_sqsum[p] = dst_sqsum[pup] + s2;
                }
              }
            }

            if(dst_tilted) {
              // fill first row with zeros
              for(i = 0; i < w1; ++i) {
                dst_tilted[i] = 0;
              }
              // diagonal
              p = (w1+1)|0, pup = 0;
              for(i = 0, k = 0; i < h0; ++i, ++p, ++pup) {
                for(j = 0; j <= w0-2; j+=2, k+=2, p+=2, pup+=2) {
                  dst_tilted[p] = src_d[k] + dst_tilted[pup];
                  dst_tilted[p+1] = src_d[k+1] + dst_tilted[pup+1];
                }
                for(; j < w0; ++j, ++k, ++p, ++pup) {
                  dst_tilted[p] = src_d[k] + dst_tilted[pup];
                }
              }
              // diagonal
              p = (w1+w0)|0, pup = w0;
              for(i = 0; i < h0; ++i, p+=w1, pup+=w1) {
                dst_tilted[p] += dst_tilted[pup];
              }

              for(j = w0-1; j > 0; --j) {
                p = j+h0*w1, pup=p-w1;
                for(i = h0; i > 0; --i, p-=w1, pup-=w1) {
                  dst_tilted[p] += dst_tilted[pup] + dst_tilted[pup+1];
                }
              }
            }
          },
          equalize_histogram: function(src, dst) {
            var w=src.cols,h=src.rows,src_d=src.data;

            dst.resize(w, h, src.channel);

            var dst_d=dst.data,size=w*h;
            var i=0,prev=0,hist0,norm;

            var hist0_node = jsfeat.cache.get_buffer(256<<2);
            hist0 = hist0_node.i32;
            for(; i < 256; ++i) hist0[i] = 0;
            for (i = 0; i < size; ++i) {
              ++hist0[src_d[i]];
            }

            prev = hist0[0];
            for (i = 1; i < 256; ++i) {
              prev = hist0[i] += prev;
            }

            norm = 255 / size;
            for (i = 0; i < size; ++i) {
              dst_d[i] = (hist0[src_d[i]] * norm + 0.5)|0;
            }
            jsfeat.cache.put_buffer(hist0_node);
          },

          canny: function(src, dst, low_thresh, high_thresh) {
            var w=src.cols,h=src.rows,src_d=src.data;

            dst.resize(w, h, src.channel);

            var dst_d=dst.data;
            var i=0,j=0,grad=0,w2=w<<1,_grad=0,suppress=0,f=0,x=0,y=0,s=0;
            var tg22x=0,tg67x=0;

            // cache buffers
            var dxdy_node = jsfeat.cache.get_buffer((h * w2)<<2);
            var buf_node = jsfeat.cache.get_buffer((3 * (w + 2))<<2);
            var map_node = jsfeat.cache.get_buffer(((h+2) * (w + 2))<<2);
            var stack_node = jsfeat.cache.get_buffer((h * w)<<2);


            var buf = buf_node.i32;
            var map = map_node.i32;
            var stack = stack_node.i32;
            var dxdy = dxdy_node.i32;
            var dxdy_m = new jsfeat.matrix_t(w, h, jsfeat.S32C2_t, dxdy_node.data);
            var row0=1,row1=(w+2+1)|0,row2=(2*(w+2)+1)|0,map_w=(w+2)|0,map_i=(map_w+1)|0,stack_i=0;

            this.sobel_derivatives(src, dxdy_m);

            if(low_thresh > high_thresh) {
              i = low_thresh;
              low_thresh = high_thresh;
              high_thresh = i;
            }

            i = (3 * (w + 2))|0;
            while(--i>=0) {
              buf[i] = 0;
            }

            i = ((h+2) * (w + 2))|0;
            while(--i>=0) {
              map[i] = 0;
            }

            for (; j < w; ++j, grad+=2) {
              //buf[row1+j] = Math.abs(dxdy[grad]) + Math.abs(dxdy[grad+1]);
              x = dxdy[grad], y = dxdy[grad+1];
              //buf[row1+j] = x*x + y*y;
              buf[row1+j] = ((x ^ (x >> 31)) - (x >> 31)) + ((y ^ (y >> 31)) - (y >> 31));
            }

            for(i=1; i <= h; ++i, grad+=w2) {
              if(i == h) {
                j = row2+w;
                while(--j>=row2) {
                  buf[j] = 0;
                }
              } else {
                for (j = 0; j < w; j++) {
                  //buf[row2+j] =  Math.abs(dxdy[grad+(j<<1)]) + Math.abs(dxdy[grad+(j<<1)+1]);
                  x = dxdy[grad+(j<<1)], y = dxdy[grad+(j<<1)+1];
                  //buf[row2+j] = x*x + y*y;
                  buf[row2+j] = ((x ^ (x >> 31)) - (x >> 31)) + ((y ^ (y >> 31)) - (y >> 31));
                }
              }
              _grad = (grad - w2)|0;
              map[map_i-1] = 0;
              suppress = 0;
              for(j = 0; j < w; ++j, _grad+=2) {
                f = buf[row1+j];
                if (f > low_thresh) {
                  x = dxdy[_grad];
                  y = dxdy[_grad+1];
                  s = x ^ y;
                  // seems ot be faster than Math.abs
                  x = ((x ^ (x >> 31)) - (x >> 31))|0;
                  y = ((y ^ (y >> 31)) - (y >> 31))|0;
                  //x * tan(22.5) x * tan(67.5) == 2 * x + x * tan(22.5)
                  tg22x = x * 13573;
                  tg67x = tg22x + ((x + x) << 15);
                  y <<= 15;
                  if (y < tg22x) {
                    if (f > buf[row1+j-1] && f >= buf[row1+j+1]) {
                      if (f > high_thresh && !suppress && map[map_i+j-map_w] != 2) {
                        map[map_i+j] = 2;
                        suppress = 1;
                        stack[stack_i++] = map_i + j;
                      } else {
                        map[map_i+j] = 1;
                      }
                      continue;
                    }
                  } else if (y > tg67x) {
                    if (f > buf[row0+j] && f >= buf[row2+j]) {
                      if (f > high_thresh && !suppress && map[map_i+j-map_w] != 2) {
                        map[map_i+j] = 2;
                        suppress = 1;
                        stack[stack_i++] = map_i + j;
                      } else {
                        map[map_i+j] = 1;
                      }
                      continue;
                    }
                  } else {
                    s = s < 0 ? -1 : 1;
                    if (f > buf[row0+j-s] && f > buf[row2+j+s]) {
                      if (f > high_thresh && !suppress && map[map_i+j-map_w] != 2) {
                        map[map_i+j] = 2;
                        suppress = 1;
                        stack[stack_i++] = map_i + j;
                      } else {
                        map[map_i+j] = 1;
                      }
                      continue;
                    }
                  }
                }
                map[map_i+j] = 0;
                suppress = 0;
              }
              map[map_i+w] = 0;
              map_i += map_w;
              j = row0;
              row0 = row1;
              row1 = row2;
              row2 = j;
            }

            j = map_i - map_w - 1;
            for(i = 0; i < map_w; ++i, ++j) {
              map[j] = 0;
            }
            // path following
            while(stack_i > 0) {
              map_i = stack[--stack_i];
              map_i -= map_w+1;
              if(map[map_i] == 1) map[map_i] = 2, stack[stack_i++] = map_i;
              map_i += 1;
              if(map[map_i] == 1) map[map_i] = 2, stack[stack_i++] = map_i;
              map_i += 1;
              if(map[map_i] == 1) map[map_i] = 2, stack[stack_i++] = map_i;
              map_i += map_w;
              if(map[map_i] == 1) map[map_i] = 2, stack[stack_i++] = map_i;
              map_i -= 2;
              if(map[map_i] == 1) map[map_i] = 2, stack[stack_i++] = map_i;
              map_i += map_w;
              if(map[map_i] == 1) map[map_i] = 2, stack[stack_i++] = map_i;
              map_i += 1;
              if(map[map_i] == 1) map[map_i] = 2, stack[stack_i++] = map_i;
              map_i += 1;
              if(map[map_i] == 1) map[map_i] = 2, stack[stack_i++] = map_i;
            }

            map_i = map_w + 1;
            row0 = 0;
            for(i = 0; i < h; ++i, map_i+=map_w) {
              for(j = 0; j < w; ++j) {
                dst_d[row0++] = (map[map_i+j] == 2) * 0xff;
              }
            }

            // free buffers
            jsfeat.cache.put_buffer(dxdy_node);
            jsfeat.cache.put_buffer(buf_node);
            jsfeat.cache.put_buffer(map_node);
            jsfeat.cache.put_buffer(stack_node);
          },
          // transform is 3x3 matrix_t
          warp_perspective: function(src, dst, transform, fill_value) {
            if (typeof fill_value === "undefined") { fill_value = 0; }
            var src_width=src.cols|0, src_height=src.rows|0, dst_width=dst.cols|0, dst_height=dst.rows|0;
            var src_d=src.data, dst_d=dst.data;
            var x=0,y=0,off=0,ixs=0,iys=0,xs=0.0,ys=0.0,xs0=0.0,ys0=0.0,ws=0.0,sc=0.0,a=0.0,b=0.0,p0=0.0,p1=0.0;
            var td=transform.data;
            var m00=td[0],m01=td[1],m02=td[2],
              m10=td[3],m11=td[4],m12=td[5],
              m20=td[6],m21=td[7],m22=td[8];

            for(var dptr = 0; y < dst_height; ++y) {
              xs0 = m01 * y + m02,
                ys0 = m11 * y + m12,
                ws  = m21 * y + m22;
              for(x = 0; x < dst_width; ++x, ++dptr, xs0+=m00, ys0+=m10, ws+=m20) {
                sc = 1.0 / ws;
                xs = xs0 * sc, ys = ys0 * sc;
                ixs = xs | 0, iys = ys | 0;

                if(xs > 0 && ys > 0 && ixs < (src_width - 1) && iys < (src_height - 1)) {
                  a = Math.max(xs - ixs, 0.0);
                  b = Math.max(ys - iys, 0.0);
                  off = (src_width*iys + ixs)|0;

                  p0 = src_d[off] +  a * (src_d[off+1] - src_d[off]);
                  p1 = src_d[off+src_width] + a * (src_d[off+src_width+1] - src_d[off+src_width]);

                  dst_d[dptr] = p0 + b * (p1 - p0);
                }
                else dst_d[dptr] = fill_value;
              }
            }
          },
          // transform is 3x3 or 2x3 matrix_t only first 6 values referenced
          warp_affine: function(src, dst, transform, fill_value) {
            if (typeof fill_value === "undefined") { fill_value = 0; }
            var src_width=src.cols, src_height=src.rows, dst_width=dst.cols, dst_height=dst.rows;
            var src_d=src.data, dst_d=dst.data;
            var x=0,y=0,off=0,ixs=0,iys=0,xs=0.0,ys=0.0,a=0.0,b=0.0,p0=0.0,p1=0.0;
            var td=transform.data;
            var m00=td[0],m01=td[1],m02=td[2],
              m10=td[3],m11=td[4],m12=td[5];

            for(var dptr = 0; y < dst_height; ++y) {
              xs = m01 * y + m02;
              ys = m11 * y + m12;
              for(x = 0; x < dst_width; ++x, ++dptr, xs+=m00, ys+=m10) {
                ixs = xs | 0; iys = ys | 0;

                if(ixs >= 0 && iys >= 0 && ixs < (src_width - 1) && iys < (src_height - 1)) {
                  a = xs - ixs;
                  b = ys - iys;
                  off = src_width*iys + ixs;

                  p0 = src_d[off] +  a * (src_d[off+1] - src_d[off]);
                  p1 = src_d[off+src_width] + a * (src_d[off+src_width+1] - src_d[off+src_width]);

                  dst_d[dptr] = p0 + b * (p1 - p0);
                }
                else dst_d[dptr] = fill_value;
              }
            }
          },

          // Basic RGB Skin detection filter
          // from http://popscan.blogspot.fr/2012/08/skin-detection-in-digital-images.html
          skindetector: function(src,dst) {
            var r,g,b,j;
            var i = src.width*src.height;
            while(i--){
              j = i*4;
              r = src.data[j];
              g = src.data[j+1];
              b = src.data[j+2];
              if((r>95)&&(g>40)&&(b>20)
                &&(r>g)&&(r>b)
                &&(r-Math.min(g,b)>15)
                &&(Math.abs(r-g)>15)){
                dst[i] = 255;
              } else {
                dst[i] = 0;
              }
            }
          }
        };
      })();

      global.imgproc = imgproc;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     * This is FAST corner detector, contributed to OpenCV by the author, Edward Rosten.
     */

    /*
The references are:
 * Machine learning for high-speed corner detection,
   E. Rosten and T. Drummond, ECCV 2006
 * Faster and better: A machine learning approach to corner detection
   E. Rosten, R. Porter and T. Drummond, PAMI, 2009
*/

    (function(global) {
      "use strict";
      //
      var fast_corners = (function() {

        var offsets16 = new Int32Array([0, 3, 1, 3, 2, 2, 3, 1, 3, 0, 3, -1, 2, -2, 1, -3, 0, -3, -1, -3, -2, -2, -3, -1, -3, 0, -3, 1, -2, 2, -1, 3]);

        var threshold_tab = new Uint8Array(512);
        var pixel_off = new Int32Array(25);
        var score_diff = new Int32Array(25);

        // private functions
        var _cmp_offsets = function(pixel, step, pattern_size) {
            var k = 0;
            var offsets = offsets16;
            for( ; k < pattern_size; ++k ) {
              pixel[k] = offsets[k<<1] + offsets[(k<<1)+1] * step;
            }
            for( ; k < 25; ++k ) {
              pixel[k] = pixel[k - pattern_size];
            }
          },

          _cmp_score_16 = function(src, off, pixel, d, threshold) {
            var N = 25, k = 0, v = src[off];
            var a0 = threshold,a=0,b0=0,b=0;

            for( ; k < N; ++k ) {
              d[k] = v - src[off+pixel[k]];
            }

            for( k = 0; k < 16; k += 2 ) {
              a = Math.min(d[k+1], d[k+2]);
              a = Math.min(a, d[k+3]);

              if( a <= a0 ) continue;

              a = Math.min(a, d[k+4]);
              a = Math.min(a, d[k+5]);
              a = Math.min(a, d[k+6]);
              a = Math.min(a, d[k+7]);
              a = Math.min(a, d[k+8]);
              a0 = Math.max(a0, Math.min(a, d[k]));
              a0 = Math.max(a0, Math.min(a, d[k+9]));
            }

            b0 = -a0;
            for( k = 0; k < 16; k += 2 ) {
              b = Math.max(d[k+1], d[k+2]);
              b = Math.max(b, d[k+3]);
              b = Math.max(b, d[k+4]);
              b = Math.max(b, d[k+5]);

              if( b >= b0 ) continue;
              b = Math.max(b, d[k+6]);
              b = Math.max(b, d[k+7]);
              b = Math.max(b, d[k+8]);
              b0 = Math.min(b0, Math.max(b, d[k]));
              b0 = Math.min(b0, Math.max(b, d[k+9]));
            }

            return -b0-1;
          };

        var _threshold = 20;

        return {
          set_threshold: function(threshold) {
            _threshold = Math.min(Math.max(threshold, 0), 255);
            for (var i = -255; i <= 255; ++i) {
              threshold_tab[(i + 255)] = (i < -_threshold ? 1 : (i > _threshold ? 2 : 0));
            }
            return _threshold;
          },

          detect: function(src, corners, border) {
            if (typeof border === "undefined") { border = 3; }

            var K = 8, N = 25;
            var img = src.data, w = src.cols, h = src.rows;
            var i=0, j=0, k=0, vt=0, x=0, m3=0;
            var buf_node = jsfeat.cache.get_buffer(3 * w);
            var cpbuf_node = jsfeat.cache.get_buffer(((w+1)*3)<<2);
            var buf = buf_node.u8;
            var cpbuf = cpbuf_node.i32;
            var pixel = pixel_off;
            var sd = score_diff;
            var sy = Math.max(3, border);
            var ey = Math.min((h-2), (h-border));
            var sx = Math.max(3, border);
            var ex = Math.min((w - 3), (w - border));
            var _count = 0, corners_cnt = 0, pt;
            var score_func = _cmp_score_16;
            var thresh_tab = threshold_tab;
            var threshold = _threshold;

            var v=0,tab=0,d=0,ncorners=0,cornerpos=0,curr=0,ptr=0,prev=0,pprev=0;
            var jp1=0,jm1=0,score=0;

            _cmp_offsets(pixel, w, 16);

            // local vars are faster?
            var pixel0 = pixel[0];
            var pixel1 = pixel[1];
            var pixel2 = pixel[2];
            var pixel3 = pixel[3];
            var pixel4 = pixel[4];
            var pixel5 = pixel[5];
            var pixel6 = pixel[6];
            var pixel7 = pixel[7];
            var pixel8 = pixel[8];
            var pixel9 = pixel[9];
            var pixel10 = pixel[10];
            var pixel11 = pixel[11];
            var pixel12 = pixel[12];
            var pixel13 = pixel[13];
            var pixel14 = pixel[14];
            var pixel15 = pixel[15];

            for(i = 0; i < w*3; ++i) {
              buf[i] = 0;
            }

            for(i = sy; i < ey; ++i) {
              ptr = ((i * w) + sx)|0;
              m3 = (i - 3)%3;
              curr = (m3*w)|0;
              cornerpos = (m3*(w+1))|0;
              for (j = 0; j < w; ++j) buf[curr+j] = 0;
              ncorners = 0;

              if( i < (ey - 1) ) {
                j = sx;

                for( ; j < ex; ++j, ++ptr ) {
                  v = img[ptr];
                  tab = ( - v + 255 );
                  d = ( thresh_tab[tab+img[ptr+pixel0]] | thresh_tab[tab+img[ptr+pixel8]] );

                  if( d == 0 ) {
                    continue;
                  }

                  d &= ( thresh_tab[tab+img[ptr+pixel2]] | thresh_tab[tab+img[ptr+pixel10]] );
                  d &= ( thresh_tab[tab+img[ptr+pixel4]] | thresh_tab[tab+img[ptr+pixel12]] );
                  d &= ( thresh_tab[tab+img[ptr+pixel6]] | thresh_tab[tab+img[ptr+pixel14]] );

                  if( d == 0 ) {
                    continue;
                  }

                  d &= ( thresh_tab[tab+img[ptr+pixel1]] | thresh_tab[tab+img[ptr+pixel9]] );
                  d &= ( thresh_tab[tab+img[ptr+pixel3]] | thresh_tab[tab+img[ptr+pixel11]] );
                  d &= ( thresh_tab[tab+img[ptr+pixel5]] | thresh_tab[tab+img[ptr+pixel13]] );
                  d &= ( thresh_tab[tab+img[ptr+pixel7]] | thresh_tab[tab+img[ptr+pixel15]] );

                  if( d & 1 ) {
                    vt = (v - threshold);
                    _count = 0;

                    for( k = 0; k < N; ++k ) {
                      x = img[(ptr+pixel[k])];
                      if(x < vt) {
                        ++_count;
                        if( _count > K ) {
                          ++ncorners;
                          cpbuf[cornerpos+ncorners] = j;
                          buf[curr+j] = score_func(img, ptr, pixel, sd, threshold);
                          break;
                        }
                      }
                      else {
                        _count = 0;
                      }
                    }
                  }

                  if( d & 2 ) {
                    vt = (v + threshold);
                    _count = 0;

                    for( k = 0; k < N; ++k ) {
                      x = img[(ptr+pixel[k])];
                      if(x > vt) {
                        ++_count;
                        if( _count > K ) {
                          ++ncorners;
                          cpbuf[cornerpos+ncorners] = j;
                          buf[curr+j] = score_func(img, ptr, pixel, sd, threshold);
                          break;
                        }
                      }
                      else {
                        _count = 0;
                      }
                    }
                  }
                }
              }

              cpbuf[cornerpos+w] = ncorners;

              if ( i == sy ) {
                continue;
              }

              m3 = (i - 4 + 3)%3;
              prev = (m3*w)|0;
              cornerpos = (m3*(w+1))|0;
              m3 = (i - 5 + 3)%3;
              pprev = (m3*w)|0;

              ncorners = cpbuf[cornerpos+w];

              for( k = 0; k < ncorners; ++k ) {
                j = cpbuf[cornerpos+k];
                jp1 = (j+1)|0;
                jm1 = (j-1)|0;
                score = buf[prev+j];
                if( (score > buf[prev+jp1] && score > buf[prev+jm1] &&
                  score > buf[pprev+jm1] && score > buf[pprev+j] && score > buf[pprev+jp1] &&
                  score > buf[curr+jm1] && score > buf[curr+j] && score > buf[curr+jp1]) ) {
                  // save corner
                  pt = corners[corners_cnt];
                  pt.x = j, pt.y = (i-1), pt.score = score;
                  corners_cnt++;
                }
              }
            } // y loop
            jsfeat.cache.put_buffer(buf_node);
            jsfeat.cache.put_buffer(cpbuf_node);
            return corners_cnt;
          }
        };
      })();

      global.fast_corners = fast_corners;
      fast_corners.set_threshold(20); // set default

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     * Copyright 2007 Computer Vision Lab,
     * Ecole Polytechnique Federale de Lausanne (EPFL), Switzerland.
     * @author Vincent Lepetit (http://cvlab.epfl.ch/~lepetit)
     */

    (function(global) {
      "use strict";
      //

      var yape06 = (function() {

        var compute_laplacian = function(src, dst, w, h, Dxx, Dyy, sx,sy, ex,ey) {
          var y=0,x=0,yrow=(sy*w+sx)|0,row=yrow;

          for(y = sy; y < ey; ++y, yrow+=w, row = yrow) {
            for(x = sx; x < ex; ++x, ++row) {
              dst[row] = -4 * src[row] + src[row+Dxx] + src[row-Dxx] + src[row+Dyy] + src[row-Dyy];
            }
          }
        };

        var hessian_min_eigen_value = function(src, off, tr, Dxx, Dyy, Dxy, Dyx) {
          var Ixx = -2 * src[off] + src[off + Dxx] + src[off - Dxx];
          var Iyy = -2 * src[off] + src[off + Dyy] + src[off - Dyy];
          var Ixy = src[off + Dxy] + src[off - Dxy] - src[off + Dyx] - src[off - Dyx];
          var sqrt_delta = ( Math.sqrt(((Ixx - Iyy) * (Ixx - Iyy) + 4 * Ixy * Ixy) ) )|0;

          return Math.min(Math.abs(tr - sqrt_delta), Math.abs(-(tr + sqrt_delta)));
        };

        return {

          laplacian_threshold: 30,
          min_eigen_value_threshold: 25,

          detect: function(src, points, border) {
            if (typeof border === "undefined") { border = 5; }
            var x=0,y=0;
            var w=src.cols, h=src.rows, srd_d=src.data;
            var Dxx = 5, Dyy = (5 * w)|0;
            var Dxy = (3 + 3 * w)|0, Dyx = (3 - 3 * w)|0;
            var lap_buf = jsfeat.cache.get_buffer((w*h)<<2);
            var laplacian = lap_buf.i32;
            var lv=0, row=0,rowx=0,min_eigen_value=0,pt;
            var number_of_points = 0;
            var lap_thresh = this.laplacian_threshold;
            var eigen_thresh = this.min_eigen_value_threshold;

            var sx = Math.max(5, border)|0;
            var sy = Math.max(3, border)|0;
            var ex = Math.min(w-5, w-border)|0;
            var ey = Math.min(h-3, h-border)|0;

            x = w*h;
            while(--x>=0) {laplacian[x]=0;}
            compute_laplacian(srd_d, laplacian, w, h, Dxx, Dyy, sx,sy, ex,ey);

            row = (sy*w+sx)|0;
            for(y = sy; y < ey; ++y, row += w) {
              for(x = sx, rowx=row; x < ex; ++x, ++rowx) {

                lv = laplacian[rowx];
                if ((lv < -lap_thresh &&
                    lv < laplacian[rowx - 1]      && lv < laplacian[rowx + 1] &&
                    lv < laplacian[rowx - w]     && lv < laplacian[rowx + w] &&
                    lv < laplacian[rowx - w - 1] && lv < laplacian[rowx + w - 1] &&
                    lv < laplacian[rowx - w + 1] && lv < laplacian[rowx + w + 1])
                  ||
                  (lv > lap_thresh &&
                    lv > laplacian[rowx - 1]      && lv > laplacian[rowx + 1] &&
                    lv > laplacian[rowx - w]     && lv > laplacian[rowx + w] &&
                    lv > laplacian[rowx - w - 1] && lv > laplacian[rowx + w - 1] &&
                    lv > laplacian[rowx - w + 1] && lv > laplacian[rowx + w + 1])
                ) {

                  min_eigen_value = hessian_min_eigen_value(srd_d, rowx, lv, Dxx, Dyy, Dxy, Dyx);
                  if (min_eigen_value > eigen_thresh) {
                    pt = points[number_of_points];
                    pt.x = x, pt.y = y, pt.score = min_eigen_value;
                    ++number_of_points;
                    ++x, ++rowx; // skip next pixel since this is maxima in 3x3
                  }
                }
              }
            }

            jsfeat.cache.put_buffer(lap_buf);

            return number_of_points;
          }

        };
      })();

      global.yape06 = yape06;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     * Copyright 2007 Computer Vision Lab,
     * Ecole Polytechnique Federale de Lausanne (EPFL), Switzerland.
     */

    (function(global) {
      "use strict";
      //

      var yape = (function() {

        var precompute_directions = function(step, dirs, R) {
          var i = 0;
          var x, y;

          x = R;
          for(y = 0; y < x; y++, i++)
          {
            x = (Math.sqrt((R * R - y * y)) + 0.5)|0;
            dirs[i] = (x + step * y);
          }
          for(x-- ; x < y && x >= 0; x--, i++)
          {
            y = (Math.sqrt((R * R - x * x)) + 0.5)|0;
            dirs[i] = (x + step * y);
          }
          for( ; -x < y; x--, i++)
          {
            y = (Math.sqrt((R * R - x * x)) + 0.5)|0;
            dirs[i] = (x + step * y);
          }
          for(y-- ; y >= 0; y--, i++)
          {
            x = (-Math.sqrt((R * R - y * y)) - 0.5)|0;
            dirs[i] = (x + step * y);
          }
          for(; y > x; y--, i++)
          {
            x = (-Math.sqrt((R * R - y * y)) - 0.5)|0;
            dirs[i] = (x + step * y);
          }
          for(x++ ; x <= 0; x++, i++)
          {
            y = (-Math.sqrt((R * R - x * x)) - 0.5)|0;
            dirs[i] = (x + step * y);
          }
          for( ; x < -y; x++, i++)
          {
            y = (-Math.sqrt((R * R - x * x)) - 0.5)|0;
            dirs[i] = (x + step * y);
          }
          for(y++ ; y < 0; y++, i++)
          {
            x = (Math.sqrt((R * R - y * y)) + 0.5)|0;
            dirs[i] = (x + step * y);
          }

          dirs[i] = dirs[0];
          dirs[i + 1] = dirs[1];
          return i;
        };

        var third_check = function (Sb, off, step) {
          var n = 0;
          if(Sb[off+1]   != 0) n++;
          if(Sb[off-1]   != 0) n++;
          if(Sb[off+step]   != 0) n++;
          if(Sb[off+step+1] != 0) n++;
          if(Sb[off+step-1] != 0) n++;
          if(Sb[off-step]   != 0) n++;
          if(Sb[off-step+1] != 0) n++;
          if(Sb[off-step-1] != 0) n++;

          return n;
        };

        var is_local_maxima = function(p, off, v, step, neighborhood) {
          var x, y;

          if (v > 0) {
            off -= step*neighborhood;
            for (y= -neighborhood; y<=neighborhood; ++y) {
              for (x= -neighborhood; x<=neighborhood; ++x) {
                if (p[off+x] > v) return false;
              }
              off += step;
            }
          } else {
            off -= step*neighborhood;
            for (y= -neighborhood; y<=neighborhood; ++y) {
              for (x= -neighborhood; x<=neighborhood; ++x) {
                if (p[off+x] < v) return false;
              }
              off += step;
            }
          }
          return true;
        };

        var perform_one_point = function(I, x, Scores, Im, Ip, dirs, opposite, dirs_nb) {
          var score = 0;
          var a = 0, b = (opposite - 1)|0;
          var A=0, B0=0, B1=0, B2=0;
          var state=0;

          // WE KNOW THAT NOT(A ~ I0 & B1 ~ I0):
          A = I[x+dirs[a]];
          if ((A <= Ip)) {
            if ((A >= Im)) { // A ~ I0
              B0 = I[x+dirs[b]];
              if ((B0 <= Ip)) {
                if ((B0 >= Im)) { Scores[x] = 0; return; }
                else {
                  b++; B1 = I[x+dirs[b]];
                  if ((B1 > Ip)) {
                    b++; B2 = I[x+dirs[b]];
                    if ((B2 > Ip)) state = 3;
                    else if ((B2 < Im)) state = 6;
                    else { Scores[x] = 0; return; } // A ~ I0, B2 ~ I0
                  }
                  else/* if ((B1 < Im))*/ {
                    b++; B2 = I[x+dirs[b]];
                    if ((B2 > Ip)) state = 7;
                    else if ((B2 < Im)) state = 2;
                    else { Scores[x] = 0; return; } // A ~ I0, B2 ~ I0
                  }
                  //else { Scores[x] = 0; return; } // A ~ I0, B1 ~ I0
                }
              }
              else { // B0 < I0
                b++; B1 = I[x+dirs[b]];
                if ((B1 > Ip)) {
                  b++; B2 = I[x+dirs[b]];
                  if ((B2 > Ip)) state = 3;
                  else if ((B2 < Im)) state = 6;
                  else { Scores[x] = 0; return; } // A ~ I0, B2 ~ I0
                }
                else if ((B1 < Im)) {
                  b++; B2 = I[x+dirs[b]];
                  if ((B2 > Ip)) state = 7;
                  else if ((B2 < Im)) state = 2;
                  else { Scores[x] = 0; return; } // A ~ I0, B2 ~ I0
                }
                else { Scores[x] = 0; return; } // A ~ I0, B1 ~ I0
              }
            }
            else { // A > I0
              B0 = I[x+dirs[b]];
              if ((B0 > Ip)) { Scores[x] = 0; return; }
              b++; B1 = I[x+dirs[b]];
              if ((B1 > Ip)) { Scores[x] = 0; return; }
              b++; B2 = I[x+dirs[b]];
              if ((B2 > Ip)) { Scores[x] = 0; return; }
              state = 1;
            }
          }
          else // A < I0
          {
            B0 = I[x+dirs[b]];
            if ((B0 < Im)) { Scores[x] = 0; return; }
            b++; B1 = I[x+dirs[b]];
            if ((B1 < Im)) { Scores[x] = 0; return; }
            b++; B2 = I[x+dirs[b]];
            if ((B2 < Im)) { Scores[x] = 0; return; }
            state = 0;
          }

          for(a = 1; a <= opposite; a++)
          {
            A = I[x+dirs[a]];

            switch(state)
            {
              case 0:
                if ((A > Ip)) {
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 < Im)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 0; break; }
                }
                if ((A < Im)) {
                  if ((B1 > Ip)) { Scores[x] = 0; return; }
                  if ((B2 > Ip)) { Scores[x] = 0; return; }
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 > Ip)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 8; break; }
                }
                // A ~ I0
                if ((B1 <= Ip)) { Scores[x] = 0; return; }
                if ((B2 <= Ip)) { Scores[x] = 0; return; }
                B1 = B2; b++; B2 = I[x+dirs[b]];
                if ((B2 > Ip)) { score -= A + B1; state = 3; break; };
                if ((B2 < Im)) { score -= A + B1; state = 6; break; };
              { Scores[x] = 0; return; }

              case 1:
                if ((A < Im)) {
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 > Ip)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 1; break; }
                }
                if ((A > Ip)) {
                  if ((B1 < Im)) { Scores[x] = 0; return; }
                  if ((B2 < Im)) { Scores[x] = 0; return; }
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 < Im)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 9; break; }
                }
                // A ~ I0
                if ((B1 >= Im)) { Scores[x] = 0; return; }
                if ((B2 >= Im)) { Scores[x] = 0; return; }
                B1 = B2; b++; B2 = I[x+dirs[b]];
                if ((B2 < Im)) { score -= A + B1; state = 2; break; };
                if ((B2 > Ip)) { score -= A + B1; state = 7; break; };
              { Scores[x] = 0; return; }

              case 2:
                if ((A > Ip)) { Scores[x] = 0; return; }
                B1 = B2; b++; B2 = I[x+dirs[b]];
                if ((A < Im))
                {
                  if ((B2 > Ip)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 4; break; }
                }
                // A ~ I0
                if ((B2 > Ip)) { score -= A + B1; state = 7; break; };
                if ((B2 < Im)) { score -= A + B1; state = 2; break; };
              { Scores[x] = 0; return; } // A ~ I0, B2 ~ I0

              case 3:
                if ((A < Im)) { Scores[x] = 0; return; }
                B1 = B2; b++; B2 = I[x+dirs[b]];
                if ((A > Ip)) {
                  if ((B2 < Im)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 5; break; }
                }
                // A ~ I0
                if ((B2 > Ip)) { score -= A + B1; state = 3; break; };
                if ((B2 < Im)) { score -= A + B1; state = 6; break; };
              { Scores[x] = 0; return; }

              case 4:
                if ((A > Ip)) { Scores[x] = 0; return; }
                if ((A < Im)) {
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 > Ip)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 1; break; }
                }
                if ((B2 >= Im)) { Scores[x] = 0; return; }
                B1 = B2; b++; B2 = I[x+dirs[b]];
                if ((B2 < Im)) { score -= A + B1; state = 2; break; };
                if ((B2 > Ip)) { score -= A + B1; state = 7; break; };
              { Scores[x] = 0; return; }

              case 5:
                if ((A < Im)) { Scores[x] = 0; return; }
                if ((A > Ip)) {
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 < Im)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 0; break; }
                }
                // A ~ I0
                if ((B2 <= Ip)) { Scores[x] = 0; return; }
                B1 = B2; b++; B2 = I[x+dirs[b]];
                if ((B2 > Ip)) { score -= A + B1; state = 3; break; };
                if ((B2 < Im)) { score -= A + B1; state = 6; break; };
              { Scores[x] = 0; return; }

              case 7:
                if ((A > Ip)) { Scores[x] = 0; return; }
                if ((A < Im)) { Scores[x] = 0; return; }
                B1 = B2; b++; B2 = I[x+dirs[b]];
                // A ~ I0
                if ((B2 > Ip)) { score -= A + B1; state = 3; break; };
                if ((B2 < Im)) { score -= A + B1; state = 6; break; };
              { Scores[x] = 0; return; } // A ~ I0, B2 ~ I0

              case 6:
                if ((A > Ip)) { Scores[x] = 0; return; }
                if ((A < Im)) { Scores[x] = 0; return; }
                B1 = B2; b++; B2 = I[x+dirs[b]];
                // A ~ I0
                if ((B2 < Im)) { score -= A + B1; state = 2; break; };
                if ((B2 > Ip)) { score -= A + B1; state = 7; break; };
              { Scores[x] = 0; return; } // A ~ I0, B2 ~ I0

              case 8:
                if ((A > Ip)) {
                  if ((B2 < Im)) { Scores[x] = 0; return; }
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 < Im)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 9; break; }
                }
                if ((A < Im)) {
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 > Ip)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 1; break; }
                }
              { Scores[x] = 0; return; }

              case 9:
                if ((A < Im)) {
                  if ((B2 > Ip)) { Scores[x] = 0; return; }
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 > Ip)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 8; break; }
                }
                if ((A > Ip)) {
                  B1 = B2; b++; B2 = I[x+dirs[b]];
                  if ((B2 < Im)) { Scores[x] = 0; return; }
                  { score -= A + B1; state = 0; break; }
                }
              { Scores[x] = 0; return; }

              default:
                //"PB default";
                break;
            } // switch(state)
          } // for(a...)

          Scores[x] = (score + dirs_nb * I[x]);
        };

        var lev_table_t = (function () {
          function lev_table_t(w, h, r) {
            this.dirs = new Int32Array(1024);
            this.dirs_count = precompute_directions(w, this.dirs, r)|0;
            this.scores = new Int32Array(w*h);
            this.radius = r|0;
          }
          return lev_table_t;
        })();

        return {

          level_tables: [],
          tau: 7,

          init: function(width, height, radius, pyramid_levels) {
            if (typeof pyramid_levels === "undefined") { pyramid_levels = 1; }
            var i;
            radius = Math.min(radius, 7);
            radius = Math.max(radius, 3);
            for(i = 0; i < pyramid_levels; ++i) {
              this.level_tables[i] = new lev_table_t(width>>i, height>>i, radius);
            }
          },

          detect: function(src, points, border) {
            if (typeof border === "undefined") { border = 4; }
            var t = this.level_tables[0];
            var R = t.radius|0, Rm1 = (R-1)|0;
            var dirs = t.dirs;
            var dirs_count = t.dirs_count|0;
            var opposite = dirs_count >> 1;
            var img = src.data, w=src.cols|0, h=src.rows|0,hw=w>>1;
            var scores = t.scores;
            var x=0,y=0,row=0,rowx=0,ip=0,im=0,abs_score=0, score=0;
            var tau = this.tau|0;
            var number_of_points = 0, pt;

            var sx = Math.max(R+1, border)|0;
            var sy = Math.max(R+1, border)|0;
            var ex = Math.min(w-R-2, w-border)|0;
            var ey = Math.min(h-R-2, h-border)|0;

            row = (sy*w+sx)|0;
            for(y = sy; y < ey; ++y, row+=w) {
              for(x = sx, rowx = row; x < ex; ++x, ++rowx) {
                ip = img[rowx] + tau, im = img[rowx] - tau;

                if (im<img[rowx+R] && img[rowx+R]<ip && im<img[rowx-R] && img[rowx-R]<ip) {
                  scores[rowx] = 0;
                } else {
                  perform_one_point(img, rowx, scores, im, ip, dirs, opposite, dirs_count);
                }
              }
            }

            // local maxima
            row = (sy*w+sx)|0;
            for(y = sy; y < ey; ++y, row+=w) {
              for(x = sx, rowx = row; x < ex; ++x, ++rowx) {
                score = scores[rowx];
                abs_score = Math.abs(score);
                if(abs_score < 5) {
                  // if this pixel is 0, the next one will not be good enough. Skip it.
                  ++x, ++rowx;
                } else {
                  if(third_check(scores, rowx, w) >= 3 && is_local_maxima(scores, rowx, score, hw, R)) {
                    pt = points[number_of_points];
                    pt.x = x, pt.y = y, pt.score = abs_score;
                    ++number_of_points;

                    x += Rm1, rowx += Rm1;
                  }
                }
              }
            }

            return number_of_points;
          }
        };

      })();

      global.yape = yape;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     * Original implementation derived from OpenCV,
     * @authors Ethan Rublee, Vincent Rabaud, Gary Bradski
     */

    (function(global) {
      "use strict";
      //

      var orb = (function() {

        var bit_pattern_31_ = new Int32Array([
          8,-3, 9,5/*mean (0), correlation (0)*/,
          4,2, 7,-12/*mean (1.12461e-05), correlation (0.0437584)*/,
          -11,9, -8,2/*mean (3.37382e-05), correlation (0.0617409)*/,
          7,-12, 12,-13/*mean (5.62303e-05), correlation (0.0636977)*/,
          2,-13, 2,12/*mean (0.000134953), correlation (0.085099)*/,
          1,-7, 1,6/*mean (0.000528565), correlation (0.0857175)*/,
          -2,-10, -2,-4/*mean (0.0188821), correlation (0.0985774)*/,
          -13,-13, -11,-8/*mean (0.0363135), correlation (0.0899616)*/,
          -13,-3, -12,-9/*mean (0.121806), correlation (0.099849)*/,
          10,4, 11,9/*mean (0.122065), correlation (0.093285)*/,
          -13,-8, -8,-9/*mean (0.162787), correlation (0.0942748)*/,
          -11,7, -9,12/*mean (0.21561), correlation (0.0974438)*/,
          7,7, 12,6/*mean (0.160583), correlation (0.130064)*/,
          -4,-5, -3,0/*mean (0.228171), correlation (0.132998)*/,
          -13,2, -12,-3/*mean (0.00997526), correlation (0.145926)*/,
          -9,0, -7,5/*mean (0.198234), correlation (0.143636)*/,
          12,-6, 12,-1/*mean (0.0676226), correlation (0.16689)*/,
          -3,6, -2,12/*mean (0.166847), correlation (0.171682)*/,
          -6,-13, -4,-8/*mean (0.101215), correlation (0.179716)*/,
          11,-13, 12,-8/*mean (0.200641), correlation (0.192279)*/,
          4,7, 5,1/*mean (0.205106), correlation (0.186848)*/,
          5,-3, 10,-3/*mean (0.234908), correlation (0.192319)*/,
          3,-7, 6,12/*mean (0.0709964), correlation (0.210872)*/,
          -8,-7, -6,-2/*mean (0.0939834), correlation (0.212589)*/,
          -2,11, -1,-10/*mean (0.127778), correlation (0.20866)*/,
          -13,12, -8,10/*mean (0.14783), correlation (0.206356)*/,
          -7,3, -5,-3/*mean (0.182141), correlation (0.198942)*/,
          -4,2, -3,7/*mean (0.188237), correlation (0.21384)*/,
          -10,-12, -6,11/*mean (0.14865), correlation (0.23571)*/,
          5,-12, 6,-7/*mean (0.222312), correlation (0.23324)*/,
          5,-6, 7,-1/*mean (0.229082), correlation (0.23389)*/,
          1,0, 4,-5/*mean (0.241577), correlation (0.215286)*/,
          9,11, 11,-13/*mean (0.00338507), correlation (0.251373)*/,
          4,7, 4,12/*mean (0.131005), correlation (0.257622)*/,
          2,-1, 4,4/*mean (0.152755), correlation (0.255205)*/,
          -4,-12, -2,7/*mean (0.182771), correlation (0.244867)*/,
          -8,-5, -7,-10/*mean (0.186898), correlation (0.23901)*/,
          4,11, 9,12/*mean (0.226226), correlation (0.258255)*/,
          0,-8, 1,-13/*mean (0.0897886), correlation (0.274827)*/,
          -13,-2, -8,2/*mean (0.148774), correlation (0.28065)*/,
          -3,-2, -2,3/*mean (0.153048), correlation (0.283063)*/,
          -6,9, -4,-9/*mean (0.169523), correlation (0.278248)*/,
          8,12, 10,7/*mean (0.225337), correlation (0.282851)*/,
          0,9, 1,3/*mean (0.226687), correlation (0.278734)*/,
          7,-5, 11,-10/*mean (0.00693882), correlation (0.305161)*/,
          -13,-6, -11,0/*mean (0.0227283), correlation (0.300181)*/,
          10,7, 12,1/*mean (0.125517), correlation (0.31089)*/,
          -6,-3, -6,12/*mean (0.131748), correlation (0.312779)*/,
          10,-9, 12,-4/*mean (0.144827), correlation (0.292797)*/,
          -13,8, -8,-12/*mean (0.149202), correlation (0.308918)*/,
          -13,0, -8,-4/*mean (0.160909), correlation (0.310013)*/,
          3,3, 7,8/*mean (0.177755), correlation (0.309394)*/,
          5,7, 10,-7/*mean (0.212337), correlation (0.310315)*/,
          -1,7, 1,-12/*mean (0.214429), correlation (0.311933)*/,
          3,-10, 5,6/*mean (0.235807), correlation (0.313104)*/,
          2,-4, 3,-10/*mean (0.00494827), correlation (0.344948)*/,
          -13,0, -13,5/*mean (0.0549145), correlation (0.344675)*/,
          -13,-7, -12,12/*mean (0.103385), correlation (0.342715)*/,
          -13,3, -11,8/*mean (0.134222), correlation (0.322922)*/,
          -7,12, -4,7/*mean (0.153284), correlation (0.337061)*/,
          6,-10, 12,8/*mean (0.154881), correlation (0.329257)*/,
          -9,-1, -7,-6/*mean (0.200967), correlation (0.33312)*/,
          -2,-5, 0,12/*mean (0.201518), correlation (0.340635)*/,
          -12,5, -7,5/*mean (0.207805), correlation (0.335631)*/,
          3,-10, 8,-13/*mean (0.224438), correlation (0.34504)*/,
          -7,-7, -4,5/*mean (0.239361), correlation (0.338053)*/,
          -3,-2, -1,-7/*mean (0.240744), correlation (0.344322)*/,
          2,9, 5,-11/*mean (0.242949), correlation (0.34145)*/,
          -11,-13, -5,-13/*mean (0.244028), correlation (0.336861)*/,
          -1,6, 0,-1/*mean (0.247571), correlation (0.343684)*/,
          5,-3, 5,2/*mean (0.000697256), correlation (0.357265)*/,
          -4,-13, -4,12/*mean (0.00213675), correlation (0.373827)*/,
          -9,-6, -9,6/*mean (0.0126856), correlation (0.373938)*/,
          -12,-10, -8,-4/*mean (0.0152497), correlation (0.364237)*/,
          10,2, 12,-3/*mean (0.0299933), correlation (0.345292)*/,
          7,12, 12,12/*mean (0.0307242), correlation (0.366299)*/,
          -7,-13, -6,5/*mean (0.0534975), correlation (0.368357)*/,
          -4,9, -3,4/*mean (0.099865), correlation (0.372276)*/,
          7,-1, 12,2/*mean (0.117083), correlation (0.364529)*/,
          -7,6, -5,1/*mean (0.126125), correlation (0.369606)*/,
          -13,11, -12,5/*mean (0.130364), correlation (0.358502)*/,
          -3,7, -2,-6/*mean (0.131691), correlation (0.375531)*/,
          7,-8, 12,-7/*mean (0.160166), correlation (0.379508)*/,
          -13,-7, -11,-12/*mean (0.167848), correlation (0.353343)*/,
          1,-3, 12,12/*mean (0.183378), correlation (0.371916)*/,
          2,-6, 3,0/*mean (0.228711), correlation (0.371761)*/,
          -4,3, -2,-13/*mean (0.247211), correlation (0.364063)*/,
          -1,-13, 1,9/*mean (0.249325), correlation (0.378139)*/,
          7,1, 8,-6/*mean (0.000652272), correlation (0.411682)*/,
          1,-1, 3,12/*mean (0.00248538), correlation (0.392988)*/,
          9,1, 12,6/*mean (0.0206815), correlation (0.386106)*/,
          -1,-9, -1,3/*mean (0.0364485), correlation (0.410752)*/,
          -13,-13, -10,5/*mean (0.0376068), correlation (0.398374)*/,
          7,7, 10,12/*mean (0.0424202), correlation (0.405663)*/,
          12,-5, 12,9/*mean (0.0942645), correlation (0.410422)*/,
          6,3, 7,11/*mean (0.1074), correlation (0.413224)*/,
          5,-13, 6,10/*mean (0.109256), correlation (0.408646)*/,
          2,-12, 2,3/*mean (0.131691), correlation (0.416076)*/,
          3,8, 4,-6/*mean (0.165081), correlation (0.417569)*/,
          2,6, 12,-13/*mean (0.171874), correlation (0.408471)*/,
          9,-12, 10,3/*mean (0.175146), correlation (0.41296)*/,
          -8,4, -7,9/*mean (0.183682), correlation (0.402956)*/,
          -11,12, -4,-6/*mean (0.184672), correlation (0.416125)*/,
          1,12, 2,-8/*mean (0.191487), correlation (0.386696)*/,
          6,-9, 7,-4/*mean (0.192668), correlation (0.394771)*/,
          2,3, 3,-2/*mean (0.200157), correlation (0.408303)*/,
          6,3, 11,0/*mean (0.204588), correlation (0.411762)*/,
          3,-3, 8,-8/*mean (0.205904), correlation (0.416294)*/,
          7,8, 9,3/*mean (0.213237), correlation (0.409306)*/,
          -11,-5, -6,-4/*mean (0.243444), correlation (0.395069)*/,
          -10,11, -5,10/*mean (0.247672), correlation (0.413392)*/,
          -5,-8, -3,12/*mean (0.24774), correlation (0.411416)*/,
          -10,5, -9,0/*mean (0.00213675), correlation (0.454003)*/,
          8,-1, 12,-6/*mean (0.0293635), correlation (0.455368)*/,
          4,-6, 6,-11/*mean (0.0404971), correlation (0.457393)*/,
          -10,12, -8,7/*mean (0.0481107), correlation (0.448364)*/,
          4,-2, 6,7/*mean (0.050641), correlation (0.455019)*/,
          -2,0, -2,12/*mean (0.0525978), correlation (0.44338)*/,
          -5,-8, -5,2/*mean (0.0629667), correlation (0.457096)*/,
          7,-6, 10,12/*mean (0.0653846), correlation (0.445623)*/,
          -9,-13, -8,-8/*mean (0.0858749), correlation (0.449789)*/,
          -5,-13, -5,-2/*mean (0.122402), correlation (0.450201)*/,
          8,-8, 9,-13/*mean (0.125416), correlation (0.453224)*/,
          -9,-11, -9,0/*mean (0.130128), correlation (0.458724)*/,
          1,-8, 1,-2/*mean (0.132467), correlation (0.440133)*/,
          7,-4, 9,1/*mean (0.132692), correlation (0.454)*/,
          -2,1, -1,-4/*mean (0.135695), correlation (0.455739)*/,
          11,-6, 12,-11/*mean (0.142904), correlation (0.446114)*/,
          -12,-9, -6,4/*mean (0.146165), correlation (0.451473)*/,
          3,7, 7,12/*mean (0.147627), correlation (0.456643)*/,
          5,5, 10,8/*mean (0.152901), correlation (0.455036)*/,
          0,-4, 2,8/*mean (0.167083), correlation (0.459315)*/,
          -9,12, -5,-13/*mean (0.173234), correlation (0.454706)*/,
          0,7, 2,12/*mean (0.18312), correlation (0.433855)*/,
          -1,2, 1,7/*mean (0.185504), correlation (0.443838)*/,
          5,11, 7,-9/*mean (0.185706), correlation (0.451123)*/,
          3,5, 6,-8/*mean (0.188968), correlation (0.455808)*/,
          -13,-4, -8,9/*mean (0.191667), correlation (0.459128)*/,
          -5,9, -3,-3/*mean (0.193196), correlation (0.458364)*/,
          -4,-7, -3,-12/*mean (0.196536), correlation (0.455782)*/,
          6,5, 8,0/*mean (0.1972), correlation (0.450481)*/,
          -7,6, -6,12/*mean (0.199438), correlation (0.458156)*/,
          -13,6, -5,-2/*mean (0.211224), correlation (0.449548)*/,
          1,-10, 3,10/*mean (0.211718), correlation (0.440606)*/,
          4,1, 8,-4/*mean (0.213034), correlation (0.443177)*/,
          -2,-2, 2,-13/*mean (0.234334), correlation (0.455304)*/,
          2,-12, 12,12/*mean (0.235684), correlation (0.443436)*/,
          -2,-13, 0,-6/*mean (0.237674), correlation (0.452525)*/,
          4,1, 9,3/*mean (0.23962), correlation (0.444824)*/,
          -6,-10, -3,-5/*mean (0.248459), correlation (0.439621)*/,
          -3,-13, -1,1/*mean (0.249505), correlation (0.456666)*/,
          7,5, 12,-11/*mean (0.00119208), correlation (0.495466)*/,
          4,-2, 5,-7/*mean (0.00372245), correlation (0.484214)*/,
          -13,9, -9,-5/*mean (0.00741116), correlation (0.499854)*/,
          7,1, 8,6/*mean (0.0208952), correlation (0.499773)*/,
          7,-8, 7,6/*mean (0.0220085), correlation (0.501609)*/,
          -7,-4, -7,1/*mean (0.0233806), correlation (0.496568)*/,
          -8,11, -7,-8/*mean (0.0236505), correlation (0.489719)*/,
          -13,6, -12,-8/*mean (0.0268781), correlation (0.503487)*/,
          2,4, 3,9/*mean (0.0323324), correlation (0.501938)*/,
          10,-5, 12,3/*mean (0.0399235), correlation (0.494029)*/,
          -6,-5, -6,7/*mean (0.0420153), correlation (0.486579)*/,
          8,-3, 9,-8/*mean (0.0548021), correlation (0.484237)*/,
          2,-12, 2,8/*mean (0.0616622), correlation (0.496642)*/,
          -11,-2, -10,3/*mean (0.0627755), correlation (0.498563)*/,
          -12,-13, -7,-9/*mean (0.0829622), correlation (0.495491)*/,
          -11,0, -10,-5/*mean (0.0843342), correlation (0.487146)*/,
          5,-3, 11,8/*mean (0.0929937), correlation (0.502315)*/,
          -2,-13, -1,12/*mean (0.113327), correlation (0.48941)*/,
          -1,-8, 0,9/*mean (0.132119), correlation (0.467268)*/,
          -13,-11, -12,-5/*mean (0.136269), correlation (0.498771)*/,
          -10,-2, -10,11/*mean (0.142173), correlation (0.498714)*/,
          -3,9, -2,-13/*mean (0.144141), correlation (0.491973)*/,
          2,-3, 3,2/*mean (0.14892), correlation (0.500782)*/,
          -9,-13, -4,0/*mean (0.150371), correlation (0.498211)*/,
          -4,6, -3,-10/*mean (0.152159), correlation (0.495547)*/,
          -4,12, -2,-7/*mean (0.156152), correlation (0.496925)*/,
          -6,-11, -4,9/*mean (0.15749), correlation (0.499222)*/,
          6,-3, 6,11/*mean (0.159211), correlation (0.503821)*/,
          -13,11, -5,5/*mean (0.162427), correlation (0.501907)*/,
          11,11, 12,6/*mean (0.16652), correlation (0.497632)*/,
          7,-5, 12,-2/*mean (0.169141), correlation (0.484474)*/,
          -1,12, 0,7/*mean (0.169456), correlation (0.495339)*/,
          -4,-8, -3,-2/*mean (0.171457), correlation (0.487251)*/,
          -7,1, -6,7/*mean (0.175), correlation (0.500024)*/,
          -13,-12, -8,-13/*mean (0.175866), correlation (0.497523)*/,
          -7,-2, -6,-8/*mean (0.178273), correlation (0.501854)*/,
          -8,5, -6,-9/*mean (0.181107), correlation (0.494888)*/,
          -5,-1, -4,5/*mean (0.190227), correlation (0.482557)*/,
          -13,7, -8,10/*mean (0.196739), correlation (0.496503)*/,
          1,5, 5,-13/*mean (0.19973), correlation (0.499759)*/,
          1,0, 10,-13/*mean (0.204465), correlation (0.49873)*/,
          9,12, 10,-1/*mean (0.209334), correlation (0.49063)*/,
          5,-8, 10,-9/*mean (0.211134), correlation (0.503011)*/,
          -1,11, 1,-13/*mean (0.212), correlation (0.499414)*/,
          -9,-3, -6,2/*mean (0.212168), correlation (0.480739)*/,
          -1,-10, 1,12/*mean (0.212731), correlation (0.502523)*/,
          -13,1, -8,-10/*mean (0.21327), correlation (0.489786)*/,
          8,-11, 10,-6/*mean (0.214159), correlation (0.488246)*/,
          2,-13, 3,-6/*mean (0.216993), correlation (0.50287)*/,
          7,-13, 12,-9/*mean (0.223639), correlation (0.470502)*/,
          -10,-10, -5,-7/*mean (0.224089), correlation (0.500852)*/,
          -10,-8, -8,-13/*mean (0.228666), correlation (0.502629)*/,
          4,-6, 8,5/*mean (0.22906), correlation (0.498305)*/,
          3,12, 8,-13/*mean (0.233378), correlation (0.503825)*/,
          -4,2, -3,-3/*mean (0.234323), correlation (0.476692)*/,
          5,-13, 10,-12/*mean (0.236392), correlation (0.475462)*/,
          4,-13, 5,-1/*mean (0.236842), correlation (0.504132)*/,
          -9,9, -4,3/*mean (0.236977), correlation (0.497739)*/,
          0,3, 3,-9/*mean (0.24314), correlation (0.499398)*/,
          -12,1, -6,1/*mean (0.243297), correlation (0.489447)*/,
          3,2, 4,-8/*mean (0.00155196), correlation (0.553496)*/,
          -10,-10, -10,9/*mean (0.00239541), correlation (0.54297)*/,
          8,-13, 12,12/*mean (0.0034413), correlation (0.544361)*/,
          -8,-12, -6,-5/*mean (0.003565), correlation (0.551225)*/,
          2,2, 3,7/*mean (0.00835583), correlation (0.55285)*/,
          10,6, 11,-8/*mean (0.00885065), correlation (0.540913)*/,
          6,8, 8,-12/*mean (0.0101552), correlation (0.551085)*/,
          -7,10, -6,5/*mean (0.0102227), correlation (0.533635)*/,
          -3,-9, -3,9/*mean (0.0110211), correlation (0.543121)*/,
          -1,-13, -1,5/*mean (0.0113473), correlation (0.550173)*/,
          -3,-7, -3,4/*mean (0.0140913), correlation (0.554774)*/,
          -8,-2, -8,3/*mean (0.017049), correlation (0.55461)*/,
          4,2, 12,12/*mean (0.01778), correlation (0.546921)*/,
          2,-5, 3,11/*mean (0.0224022), correlation (0.549667)*/,
          6,-9, 11,-13/*mean (0.029161), correlation (0.546295)*/,
          3,-1, 7,12/*mean (0.0303081), correlation (0.548599)*/,
          11,-1, 12,4/*mean (0.0355151), correlation (0.523943)*/,
          -3,0, -3,6/*mean (0.0417904), correlation (0.543395)*/,
          4,-11, 4,12/*mean (0.0487292), correlation (0.542818)*/,
          2,-4, 2,1/*mean (0.0575124), correlation (0.554888)*/,
          -10,-6, -8,1/*mean (0.0594242), correlation (0.544026)*/,
          -13,7, -11,1/*mean (0.0597391), correlation (0.550524)*/,
          -13,12, -11,-13/*mean (0.0608974), correlation (0.55383)*/,
          6,0, 11,-13/*mean (0.065126), correlation (0.552006)*/,
          0,-1, 1,4/*mean (0.074224), correlation (0.546372)*/,
          -13,3, -9,-2/*mean (0.0808592), correlation (0.554875)*/,
          -9,8, -6,-3/*mean (0.0883378), correlation (0.551178)*/,
          -13,-6, -8,-2/*mean (0.0901035), correlation (0.548446)*/,
          5,-9, 8,10/*mean (0.0949843), correlation (0.554694)*/,
          2,7, 3,-9/*mean (0.0994152), correlation (0.550979)*/,
          -1,-6, -1,-1/*mean (0.10045), correlation (0.552714)*/,
          9,5, 11,-2/*mean (0.100686), correlation (0.552594)*/,
          11,-3, 12,-8/*mean (0.101091), correlation (0.532394)*/,
          3,0, 3,5/*mean (0.101147), correlation (0.525576)*/,
          -1,4, 0,10/*mean (0.105263), correlation (0.531498)*/,
          3,-6, 4,5/*mean (0.110785), correlation (0.540491)*/,
          -13,0, -10,5/*mean (0.112798), correlation (0.536582)*/,
          5,8, 12,11/*mean (0.114181), correlation (0.555793)*/,
          8,9, 9,-6/*mean (0.117431), correlation (0.553763)*/,
          7,-4, 8,-12/*mean (0.118522), correlation (0.553452)*/,
          -10,4, -10,9/*mean (0.12094), correlation (0.554785)*/,
          7,3, 12,4/*mean (0.122582), correlation (0.555825)*/,
          9,-7, 10,-2/*mean (0.124978), correlation (0.549846)*/,
          7,0, 12,-2/*mean (0.127002), correlation (0.537452)*/,
          -1,-6, 0,-11/*mean (0.127148), correlation (0.547401)*/
        ]);

        var H = new jsfeat.matrix_t(3, 3, jsfeat.F32_t|jsfeat.C1_t);
        var patch_img = new jsfeat.matrix_t(32, 32, jsfeat.U8_t|jsfeat.C1_t);

        var rectify_patch = function(src, dst, angle, px, py, psize) {
          var cosine = Math.cos(angle);
          var sine   = Math.sin(angle);

          H.data[0] = cosine, H.data[1] = -sine,    H.data[2] = (-cosine + sine  ) * psize*0.5 + px,
            H.data[3] = sine,   H.data[4] =  cosine,  H.data[5] = (-sine   - cosine) * psize*0.5 + py;

          jsfeat.imgproc.warp_affine(src, dst, H, 128);
        };

        return {

          describe: function(src, corners, count, descriptors) {
            var DESCR_SIZE = 32; // bytes;
            var i=0,b=0,px=0.0,py=0.0,angle=0.0;
            var t0=0, t1=0, val=0;
            var img = src.data, w = src.cols, h = src.rows;
            var patch_d = patch_img.data;
            var patch_off = 16*32 + 16; // center of patch
            var patt=0;

            if(!(descriptors.type&jsfeat.U8_t)) {
              // relocate to U8 type
              descriptors.type = jsfeat.U8_t;
              descriptors.cols = DESCR_SIZE;
              descriptors.rows = count;
              descriptors.channel = 1;
              descriptors.allocate();
            } else {
              descriptors.resize(DESCR_SIZE, count, 1);
            }

            var descr_d = descriptors.data;
            var descr_off = 0;

            for(i = 0; i < count; ++i) {
              px = corners[i].x;
              py = corners[i].y;
              angle = corners[i].angle;

              rectify_patch(src, patch_img, angle, px, py, 32);

              // describe the patch
              patt = 0;
              for (b = 0; b < DESCR_SIZE; ++b) {

                t0 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                t1 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                val = (t0 < t1)|0;

                t0 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                t1 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                val |= (t0 < t1) << 1;

                t0 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                t1 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                val |= (t0 < t1) << 2;

                t0 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                t1 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                val |= (t0 < t1) << 3;

                t0 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                t1 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                val |= (t0 < t1) << 4;

                t0 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                t1 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                val |= (t0 < t1) << 5;

                t0 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                t1 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                val |= (t0 < t1) << 6;

                t0 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                t1 = patch_d[patch_off + bit_pattern_31_[patt+1] * 32 + bit_pattern_31_[patt]]; patt += 2;
                val |= (t0 < t1) << 7;

                descr_d[descr_off+b] = val;
              }
              descr_off += DESCR_SIZE;
            }
          }
        };
      })();

      global.orb = orb;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     * this code is a rewrite from OpenCV's Lucas-Kanade optical flow implementation
     */

    (function(global) {
      "use strict";
      //
      var optical_flow_lk = (function() {

        // short link to shar deriv
        var scharr_deriv = jsfeat.imgproc.scharr_derivatives;

        return {
          track: function(prev_pyr, curr_pyr, prev_xy, curr_xy, count, win_size, max_iter, status, eps, min_eigen_threshold) {
            if (typeof max_iter === "undefined") { max_iter = 30; }
            if (typeof status === "undefined") { status = new Uint8Array(count); }
            if (typeof eps === "undefined") { eps = 0.01; }
            if (typeof min_eigen_threshold === "undefined") { min_eigen_threshold = 0.0001; }

            var half_win = (win_size-1)*0.5;
            var win_area = (win_size*win_size)|0;
            var win_area2 = win_area << 1;
            var prev_imgs = prev_pyr.data, next_imgs = curr_pyr.data;
            var img_prev=prev_imgs[0].data,img_next=next_imgs[0].data;
            var w0 = prev_imgs[0].cols, h0 = prev_imgs[0].rows,lw=0,lh=0;

            var iwin_node = jsfeat.cache.get_buffer(win_area<<2);
            var deriv_iwin_node = jsfeat.cache.get_buffer(win_area2<<2);
            var deriv_lev_node = jsfeat.cache.get_buffer((h0*(w0<<1))<<2);

            var deriv_m = new jsfeat.matrix_t(w0, h0, jsfeat.S32C2_t, deriv_lev_node.data);

            var iwin_buf = iwin_node.i32;
            var deriv_iwin = deriv_iwin_node.i32;
            var deriv_lev = deriv_lev_node.i32;

            var dstep=0,src=0,dsrc=0,iptr=0,diptr=0,jptr=0;
            var lev_sc=0.0,prev_x=0.0,prev_y=0.0,next_x=0.0,next_y=0.0;
            var prev_delta_x=0.0,prev_delta_y=0.0,delta_x=0.0,delta_y=0.0;
            var iprev_x=0,iprev_y=0,inext_x=0,inext_y=0;
            var i=0,j=0,x=0,y=0,level=0,ptid=0,iter=0;
            var brd_tl=0,brd_r=0,brd_b=0;
            var a=0.0,b=0.0,b1=0.0,b2=0.0;

            // fixed point math
            var W_BITS14 = 14;
            var W_BITS4 = 14;
            var W_BITS1m5 = W_BITS4 - 5;
            var W_BITS1m51 = (1 << ((W_BITS1m5) - 1));
            var W_BITS14_ = (1 << W_BITS14);
            var W_BITS41 = (1 << ((W_BITS4) - 1));
            var FLT_SCALE = 1.0/(1 << 20);
            var iw00=0,iw01=0,iw10=0,iw11=0,ival=0,ixval=0,iyval=0;
            var A11=0.0,A12=0.0,A22=0.0,D=0.0,min_eig=0.0;

            var FLT_EPSILON = 0.00000011920929;
            eps *= eps;

            // reset status
            for(; i < count; ++i) {
              status[i] = 1;
            }

            var max_level = (prev_pyr.levels - 1)|0;
            level = max_level;

            for(; level >= 0; --level) {
              lev_sc = (1.0/(1 << level));
              lw = w0 >> level;
              lh = h0 >> level;
              dstep = lw << 1;
              img_prev = prev_imgs[level].data;
              img_next = next_imgs[level].data;

              brd_r = (lw - win_size)|0;
              brd_b = (lh - win_size)|0;

              // calculate level derivatives
              scharr_deriv(prev_imgs[level], deriv_m);

              // iterate through points
              for(ptid = 0; ptid < count; ++ptid) {
                i = ptid << 1;
                j = i + 1;
                prev_x = prev_xy[i]*lev_sc;
                prev_y = prev_xy[j]*lev_sc;

                if( level == max_level ) {
                  next_x = prev_x;
                  next_y = prev_y;
                } else {
                  next_x = curr_xy[i]*2.0;
                  next_y = curr_xy[j]*2.0;
                }
                curr_xy[i] = next_x;
                curr_xy[j] = next_y;

                prev_x -= half_win;
                prev_y -= half_win;
                iprev_x = prev_x|0;
                iprev_y = prev_y|0;

                // border check
                x = (iprev_x <= brd_tl)|(iprev_x >= brd_r)|(iprev_y <= brd_tl)|(iprev_y >= brd_b);
                if( x != 0 ) {
                  if( level == 0 ) {
                    status[ptid] = 0;
                  }
                  continue;
                }

                a = prev_x - iprev_x;
                b = prev_y - iprev_y;
                iw00 = (((1.0 - a)*(1.0 - b)*W_BITS14_) + 0.5)|0;
                iw01 = ((a*(1.0 - b)*W_BITS14_) + 0.5)|0;
                iw10 = (((1.0 - a)*b*W_BITS14_) + 0.5)|0;
                iw11 = (W_BITS14_ - iw00 - iw01 - iw10);

                A11 = 0.0, A12 = 0.0, A22 = 0.0;

                // extract the patch from the first image, compute covariation matrix of derivatives
                for( y = 0; y < win_size; ++y ) {
                  src = ( (y + iprev_y)*lw + iprev_x )|0;
                  dsrc = src << 1;

                  iptr = (y*win_size)|0;
                  diptr = iptr << 1;
                  for(x = 0 ; x < win_size; ++x, ++src, ++iptr, dsrc += 2) {
                    ival = ( (img_prev[src])*iw00 + (img_prev[src+1])*iw01 +
                      (img_prev[src+lw])*iw10 + (img_prev[src+lw+1])*iw11 );
                    ival = (((ival) + W_BITS1m51) >> (W_BITS1m5));

                    ixval = ( deriv_lev[dsrc]*iw00 + deriv_lev[dsrc+2]*iw01 +
                      deriv_lev[dsrc+dstep]*iw10 + deriv_lev[dsrc+dstep+2]*iw11 );
                    ixval = (((ixval) + W_BITS41) >> (W_BITS4));

                    iyval = ( deriv_lev[dsrc+1]*iw00 + deriv_lev[dsrc+3]*iw01 + deriv_lev[dsrc+dstep+1]*iw10 +
                      deriv_lev[dsrc+dstep+3]*iw11 );
                    iyval = (((iyval) + W_BITS41) >> (W_BITS4));

                    iwin_buf[iptr] = ival;
                    deriv_iwin[diptr++] = ixval;
                    deriv_iwin[diptr++] = iyval;

                    A11 += ixval*ixval;
                    A12 += ixval*iyval;
                    A22 += iyval*iyval;
                  }
                }

                A11 *= FLT_SCALE; A12 *= FLT_SCALE; A22 *= FLT_SCALE;

                D = A11*A22 - A12*A12;
                min_eig = (A22 + A11 - Math.sqrt((A11-A22)*(A11-A22) + 4.0*A12*A12)) / win_area2;

                if( min_eig < min_eigen_threshold || D < FLT_EPSILON )
                {
                  if( level == 0 ) {
                    status[ptid] = 0;
                  }
                  continue;
                }

                D = 1.0/D;

                next_x -= half_win;
                next_y -= half_win;
                prev_delta_x = 0.0;
                prev_delta_y = 0.0;

                for( iter = 0; iter < max_iter; ++iter ) {
                  inext_x = next_x|0;
                  inext_y = next_y|0;

                  x = (inext_x <= brd_tl)|(inext_x >= brd_r)|(inext_y <= brd_tl)|(inext_y >= brd_b);
                  if( x != 0 ) {
                    if( level == 0 ) {
                      status[ptid] = 0;
                    }
                    break;
                  }

                  a = next_x - inext_x;
                  b = next_y - inext_y;
                  iw00 = (((1.0 - a)*(1.0 - b)*W_BITS14_) + 0.5)|0;
                  iw01 = ((a*(1.0 - b)*W_BITS14_) + 0.5)|0;
                  iw10 = (((1.0 - a)*b*W_BITS14_) + 0.5)|0;
                  iw11 = (W_BITS14_ - iw00 - iw01 - iw10);
                  b1 = 0.0, b2 = 0.0;

                  for( y = 0; y < win_size; ++y ) {
                    jptr = ( (y + inext_y)*lw + inext_x )|0;

                    iptr = (y*win_size)|0;
                    diptr = iptr << 1;
                    for( x = 0 ; x < win_size; ++x, ++jptr, ++iptr ) {
                      ival = ( (img_next[jptr])*iw00 + (img_next[jptr+1])*iw01 +
                        (img_next[jptr+lw])*iw10 + (img_next[jptr+lw+1])*iw11 );
                      ival = (((ival) + W_BITS1m51) >> (W_BITS1m5));
                      ival = (ival - iwin_buf[iptr]);

                      b1 += ival * deriv_iwin[diptr++];
                      b2 += ival * deriv_iwin[diptr++];
                    }
                  }

                  b1 *= FLT_SCALE;
                  b2 *= FLT_SCALE;

                  delta_x = ((A12*b2 - A22*b1) * D);
                  delta_y = ((A12*b1 - A11*b2) * D);

                  next_x += delta_x;
                  next_y += delta_y;
                  curr_xy[i] = next_x + half_win;
                  curr_xy[j] = next_y + half_win;

                  if( delta_x*delta_x + delta_y*delta_y <= eps ) {
                    break;
                  }

                  if( iter > 0 && Math.abs(delta_x + prev_delta_x) < 0.01 &&
                    Math.abs(delta_y + prev_delta_y) < 0.01 ) {
                    curr_xy[i] -= delta_x*0.5;
                    curr_xy[j] -= delta_y*0.5;
                    break;
                  }

                  prev_delta_x = delta_x;
                  prev_delta_y = delta_y;
                }
              } // points loop
            } // levels loop

            jsfeat.cache.put_buffer(iwin_node);
            jsfeat.cache.put_buffer(deriv_iwin_node);
            jsfeat.cache.put_buffer(deriv_lev_node);
          }
        };
      })();

      global.optical_flow_lk = optical_flow_lk;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     * this code is a rewrite from https://github.com/mtschirs/js-objectdetect implementation
     * @author Martin Tschirsich / http://www.tu-darmstadt.de/~m_t
     */

    (function(global) {
      "use strict";
      //
      var haar = (function() {

        var _group_func = function(r1, r2) {
          var distance = (r1.width * 0.25 + 0.5)|0;

          return r2.x <= r1.x + distance &&
            r2.x >= r1.x - distance &&
            r2.y <= r1.y + distance &&
            r2.y >= r1.y - distance &&
            r2.width <= (r1.width * 1.5 + 0.5)|0 &&
            (r2.width * 1.5 + 0.5)|0 >= r1.width;
        };

        return {

          edges_density: 0.07,

          detect_single_scale: function(int_sum, int_sqsum, int_tilted, int_canny_sum, width, height, scale, classifier) {
            var win_w = (classifier.size[0] * scale)|0,
              win_h = (classifier.size[1] * scale)|0,
              step_x = (0.5 * scale + 1.5)|0,
              step_y = step_x;
            var i,j,k,x,y,ex=(width-win_w)|0,ey=(height-win_h)|0;
            var w1=(width+1)|0,edge_dens,mean,variance,std;
            var inv_area = 1.0 / (win_w * win_h);
            var stages,stage,trees,tree,sn,tn,fn,found=true,stage_thresh,stage_sum,tree_sum,feature,features;
            var fi_a,fi_b,fi_c,fi_d,fw,fh;

            var ii_a=0,ii_b=win_w,ii_c=win_h*w1,ii_d=ii_c+win_w;
            var edges_thresh = ((win_w*win_h) * 0xff * this.edges_density)|0;
            // if too much gradient we also can skip
            //var edges_thresh_high = ((win_w*win_h) * 0xff * 0.3)|0;

            var rects = [];
            for(y = 0; y < ey; y += step_y) {
              ii_a = y * w1;
              for(x = 0; x < ex; x += step_x, ii_a += step_x) {

                mean =    int_sum[ii_a]
                  - int_sum[ii_a+ii_b]
                  - int_sum[ii_a+ii_c]
                  + int_sum[ii_a+ii_d];

                // canny prune
                if(int_canny_sum) {
                  edge_dens = (int_canny_sum[ii_a]
                    - int_canny_sum[ii_a+ii_b]
                    - int_canny_sum[ii_a+ii_c]
                    + int_canny_sum[ii_a+ii_d]);
                  if(edge_dens < edges_thresh || mean < 20) {
                    x += step_x, ii_a += step_x;
                    continue;
                  }
                }

                mean *= inv_area;
                variance = (int_sqsum[ii_a]
                  - int_sqsum[ii_a+ii_b]
                  - int_sqsum[ii_a+ii_c]
                  + int_sqsum[ii_a+ii_d]) * inv_area - mean * mean;

                std = variance > 0. ? Math.sqrt(variance) : 1;

                stages = classifier.complexClassifiers;
                sn = stages.length;
                found =  true;
                for(i = 0; i < sn; ++i) {
                  stage = stages[i];
                  stage_thresh = stage.threshold;
                  trees = stage.simpleClassifiers;
                  tn = trees.length;
                  stage_sum = 0;
                  for(j = 0; j < tn; ++j) {
                    tree = trees[j];
                    tree_sum = 0;
                    features = tree.features;
                    fn = features.length;
                    if(tree.tilted === 1) {
                      for(k=0; k < fn; ++k) {
                        feature = features[k];
                        fi_a = ~~(x + feature[0] * scale) + ~~(y + feature[1] * scale) * w1;
                        fw = ~~(feature[2] * scale);
                        fh = ~~(feature[3] * scale);
                        fi_b = fw * w1;
                        fi_c =  fh * w1;

                        tree_sum += (int_tilted[fi_a]
                          - int_tilted[fi_a + fw + fi_b]
                          - int_tilted[fi_a - fh + fi_c]
                          + int_tilted[fi_a + fw - fh + fi_b + fi_c]) * feature[4];
                      }
                    } else {
                      for(k=0; k < fn; ++k) {
                        feature = features[k];
                        fi_a = ~~(x + feature[0] * scale) + ~~(y + feature[1] * scale) * w1;
                        fw = ~~(feature[2] * scale);
                        fh = ~~(feature[3] * scale);
                        fi_c = fh * w1;

                        tree_sum += (int_sum[fi_a]
                          - int_sum[fi_a+fw]
                          - int_sum[fi_a+fi_c]
                          + int_sum[fi_a+fi_c+fw]) * feature[4];
                      }
                    }
                    stage_sum += (tree_sum * inv_area < tree.threshold * std) ? tree.left_val : tree.right_val;
                  }
                  if (stage_sum < stage_thresh) {
                    found = false;
                    break;
                  }
                }

                if(found) {
                  rects.push({"x" : x,
                    "y" : y,
                    "width" : win_w,
                    "height" : win_h,
                    "neighbor" : 1,
                    "confidence" : stage_sum});
                  x += step_x, ii_a += step_x;
                }
              }
            }
            return rects;
          },

          detect_multi_scale: function(int_sum, int_sqsum, int_tilted, int_canny_sum, width, height, classifier, scale_factor, scale_min) {
            if (typeof scale_factor === "undefined") { scale_factor = 1.2; }
            if (typeof scale_min === "undefined") { scale_min = 1.0; }
            var win_w = classifier.size[0];
            var win_h = classifier.size[1];
            var rects = [];
            while (scale_min * win_w < width && scale_min * win_h < height) {
              rects = rects.concat(this.detect_single_scale(int_sum, int_sqsum, int_tilted, int_canny_sum, width, height, scale_min, classifier));
              scale_min *= scale_factor;
            }
            return rects;
          },

          // OpenCV method to group detected rectangles
          group_rectangles: function(rects, min_neighbors) {
            if (typeof min_neighbors === "undefined") { min_neighbors = 1; }
            var i, j, n = rects.length;
            var node = [];
            for (i = 0; i < n; ++i) {
              node[i] = {"parent" : -1,
                "element" : rects[i],
                "rank" : 0};
            }
            for (i = 0; i < n; ++i) {
              if (!node[i].element)
                continue;
              var root = i;
              while (node[root].parent != -1)
                root = node[root].parent;
              for (j = 0; j < n; ++j) {
                if( i != j && node[j].element && _group_func(node[i].element, node[j].element)) {
                  var root2 = j;

                  while (node[root2].parent != -1)
                    root2 = node[root2].parent;

                  if(root2 != root) {
                    if(node[root].rank > node[root2].rank)
                      node[root2].parent = root;
                    else {
                      node[root].parent = root2;
                      if (node[root].rank == node[root2].rank)
                        node[root2].rank++;
                      root = root2;
                    }

                    /* compress path from node2 to the root: */
                    var temp, node2 = j;
                    while (node[node2].parent != -1) {
                      temp = node2;
                      node2 = node[node2].parent;
                      node[temp].parent = root;
                    }

                    /* compress path from node to the root: */
                    node2 = i;
                    while (node[node2].parent != -1) {
                      temp = node2;
                      node2 = node[node2].parent;
                      node[temp].parent = root;
                    }
                  }
                }
              }
            }
            var idx_seq = [];
            var class_idx = 0;
            for(i = 0; i < n; i++) {
              j = -1;
              var node1 = i;
              if(node[node1].element) {
                while (node[node1].parent != -1)
                  node1 = node[node1].parent;
                if(node[node1].rank >= 0)
                  node[node1].rank = ~class_idx++;
                j = ~node[node1].rank;
              }
              idx_seq[i] = j;
            }

            var comps = [];
            for (i = 0; i < class_idx+1; ++i) {
              comps[i] = {"neighbors" : 0,
                "x" : 0,
                "y" : 0,
                "width" : 0,
                "height" : 0,
                "confidence" : 0};
            }

            // count number of neighbors
            for(i = 0; i < n; ++i) {
              var r1 = rects[i];
              var idx = idx_seq[i];

              if (comps[idx].neighbors == 0)
                comps[idx].confidence = r1.confidence;

              ++comps[idx].neighbors;

              comps[idx].x += r1.x;
              comps[idx].y += r1.y;
              comps[idx].width += r1.width;
              comps[idx].height += r1.height;
              comps[idx].confidence = Math.max(comps[idx].confidence, r1.confidence);
            }

            var seq2 = [];
            // calculate average bounding box
            for(i = 0; i < class_idx; ++i) {
              n = comps[i].neighbors;
              if (n >= min_neighbors)
                seq2.push({"x" : (comps[i].x * 2 + n) / (2 * n),
                  "y" : (comps[i].y * 2 + n) / (2 * n),
                  "width" : (comps[i].width * 2 + n) / (2 * n),
                  "height" : (comps[i].height * 2 + n) / (2 * n),
                  "neighbors" : comps[i].neighbors,
                  "confidence" : comps[i].confidence});
            }

            var result_seq = [];
            n = seq2.length;
            // filter out small face rectangles inside large face rectangles
            for(i = 0; i < n; ++i) {
              var r1 = seq2[i];
              var flag = true;
              for(j = 0; j < n; ++j) {
                var r2 = seq2[j];
                var distance = (r2.width * 0.25 + 0.5)|0;

                if(i != j &&
                  r1.x >= r2.x - distance &&
                  r1.y >= r2.y - distance &&
                  r1.x + r1.width <= r2.x + r2.width + distance &&
                  r1.y + r1.height <= r2.y + r2.height + distance &&
                  (r2.neighbors > Math.max(3, r1.neighbors) || r1.neighbors < 3)) {
                  flag = false;
                  break;
                }
              }

              if(flag)
                result_seq.push(r1);
            }
            return result_seq;
          }
        };

      })();

      global.haar = haar;

    })(jsfeat);
    /**
     * BBF: Brightness Binary Feature
     *
     * @author Eugene Zatepyakin / http://inspirit.ru/
     *
     * this code is a rewrite from https://github.com/liuliu/ccv implementation
     * @author Liu Liu / http://liuliu.me/
     *
     * The original paper refers to: YEF∗ Real-Time Object Detection, Yotam Abramson and Bruno Steux
     */

    (function(global) {
      "use strict";
      //
      var bbf = (function() {

        var _group_func = function(r1, r2) {
          var distance = (r1.width * 0.25 + 0.5)|0;

          return r2.x <= r1.x + distance &&
            r2.x >= r1.x - distance &&
            r2.y <= r1.y + distance &&
            r2.y >= r1.y - distance &&
            r2.width <= (r1.width * 1.5 + 0.5)|0 &&
            (r2.width * 1.5 + 0.5)|0 >= r1.width;
        };

        var img_pyr = new jsfeat.pyramid_t(1);

        return {

          interval: 4,
          scale: 1.1486,
          next: 5,
          scale_to: 1,

          // make features local copy
          // to avoid array allocation with each scale
          // this is strange but array works faster than Int32 version???
          prepare_cascade: function(cascade) {
            var sn = cascade.stage_classifier.length;
            for (var j = 0; j < sn; j++) {
              var orig_feature = cascade.stage_classifier[j].feature;
              var f_cnt = cascade.stage_classifier[j].count;
              var feature = cascade.stage_classifier[j]._feature = new Array(f_cnt);
              for (var k = 0; k < f_cnt; k++) {
                feature[k] = {"size" : orig_feature[k].size,
                  "px" : new Array(orig_feature[k].size),
                  "pz" : new Array(orig_feature[k].size),
                  "nx" : new Array(orig_feature[k].size),
                  "nz" : new Array(orig_feature[k].size)};
              }
            }
          },

          build_pyramid: function(src, min_width, min_height, interval) {
            if (typeof interval === "undefined") { interval = 4; }

            var sw=src.cols,sh=src.rows;
            var i=0,nw=0,nh=0;
            var new_pyr=false;
            var src0=src,src1=src;
            var data_type = jsfeat.U8_t | jsfeat.C1_t;

            this.interval = interval;
            this.scale = Math.pow(2, 1 / (this.interval + 1));
            this.next = (this.interval + 1)|0;
            this.scale_to = (Math.log(Math.min(sw / min_width, sh / min_height)) / Math.log(this.scale))|0;

            var pyr_l = ((this.scale_to + this.next * 2) * 4) | 0;
            if(img_pyr.levels != pyr_l) {
              img_pyr.levels = pyr_l;
              img_pyr.data = new Array(pyr_l);
              new_pyr = true;
              img_pyr.data[0] = src; // first is src
            }

            for (i = 1; i <= this.interval; ++i) {
              nw = (sw / Math.pow(this.scale, i))|0;
              nh = (sh / Math.pow(this.scale, i))|0;
              src0 = img_pyr.data[i<<2];
              if(new_pyr || nw != src0.cols || nh != src0.rows) {
                img_pyr.data[i<<2] = new jsfeat.matrix_t(nw, nh, data_type);
                src0 = img_pyr.data[i<<2];
              }
              jsfeat.imgproc.resample(src, src0, nw, nh);
            }
            for (i = this.next; i < this.scale_to + this.next * 2; ++i) {
              src1 = img_pyr.data[(i << 2) - (this.next << 2)];
              src0 = img_pyr.data[i<<2];
              nw = src1.cols >> 1;
              nh = src1.rows >> 1;
              if(new_pyr || nw != src0.cols || nh != src0.rows) {
                img_pyr.data[i<<2] = new jsfeat.matrix_t(nw, nh, data_type);
                src0 = img_pyr.data[i<<2];
              }
              jsfeat.imgproc.pyrdown(src1, src0);
            }
            for (i = this.next * 2; i < this.scale_to + this.next * 2; ++i) {
              src1 = img_pyr.data[(i << 2) - (this.next << 2)];
              nw = src1.cols >> 1;
              nh = src1.rows >> 1;
              src0 = img_pyr.data[(i<<2)+1];
              if(new_pyr || nw != src0.cols || nh != src0.rows) {
                img_pyr.data[(i<<2)+1] = new jsfeat.matrix_t(nw, nh, data_type);
                src0 = img_pyr.data[(i<<2)+1];
              }
              jsfeat.imgproc.pyrdown(src1, src0, 1, 0);
              //
              src0 = img_pyr.data[(i<<2)+2];
              if(new_pyr || nw != src0.cols || nh != src0.rows) {
                img_pyr.data[(i<<2)+2] = new jsfeat.matrix_t(nw, nh, data_type);
                src0 = img_pyr.data[(i<<2)+2];
              }
              jsfeat.imgproc.pyrdown(src1, src0, 0, 1);
              //
              src0 = img_pyr.data[(i<<2)+3];
              if(new_pyr || nw != src0.cols || nh != src0.rows) {
                img_pyr.data[(i<<2)+3] = new jsfeat.matrix_t(nw, nh, data_type);
                src0 = img_pyr.data[(i<<2)+3];
              }
              jsfeat.imgproc.pyrdown(src1, src0, 1, 1);
            }
            return img_pyr;
          },

          detect: function(pyramid, cascade) {
            var interval = this.interval;
            var scale = this.scale;
            var next = this.next;
            var scale_upto = this.scale_to;
            var i=0,j=0,k=0,n=0,x=0,y=0,q=0,sn=0,f_cnt=0,q_cnt=0,p=0,pmin=0,nmax=0,f=0,i4=0,qw=0,qh=0;
            var sum=0.0, alpha, feature, orig_feature, feature_k, feature_o, flag = true, shortcut=true;
            var scale_x = 1.0, scale_y = 1.0;
            var dx = [0, 1, 0, 1];
            var dy = [0, 0, 1, 1];
            var seq = [];
            var pyr=pyramid.data, bpp = 1, bpp2 = 2, bpp4 = 4;

            var u8 = [], u8o = [0,0,0];
            var step = [0,0,0];
            var paddings = [0,0,0];

            for (i = 0; i < scale_upto; i++) {
              i4 = (i<<2);
              qw = pyr[i4 + (next << 3)].cols - (cascade.width >> 2);
              qh = pyr[i4 + (next << 3)].rows - (cascade.height >> 2);
              step[0] = pyr[i4].cols * bpp;
              step[1] = pyr[i4 + (next << 2)].cols * bpp;
              step[2] = pyr[i4 + (next << 3)].cols * bpp;
              paddings[0] = (pyr[i4].cols * bpp4) - (qw * bpp4);
              paddings[1] = (pyr[i4 + (next << 2)].cols * bpp2) - (qw * bpp2);
              paddings[2] = (pyr[i4 + (next << 3)].cols * bpp) - (qw * bpp);
              sn = cascade.stage_classifier.length;
              for (j = 0; j < sn; j++) {
                orig_feature = cascade.stage_classifier[j].feature;
                feature = cascade.stage_classifier[j]._feature;
                f_cnt = cascade.stage_classifier[j].count;
                for (k = 0; k < f_cnt; k++) {
                  feature_k = feature[k];
                  feature_o = orig_feature[k];
                  q_cnt = feature_o.size|0;
                  for (q = 0; q < q_cnt; q++) {
                    feature_k.px[q] = (feature_o.px[q] * bpp) + feature_o.py[q] * step[feature_o.pz[q]];
                    feature_k.pz[q] = feature_o.pz[q];
                    feature_k.nx[q] = (feature_o.nx[q] * bpp) + feature_o.ny[q] * step[feature_o.nz[q]];
                    feature_k.nz[q] = feature_o.nz[q];
                  }
                }
              }
              u8[0] = pyr[i4].data; u8[1] = pyr[i4 + (next<<2)].data;
              for (q = 0; q < 4; q++) {
                u8[2] = pyr[i4 + (next<<3) + q].data;
                u8o[0] = (dx[q]*bpp2) + dy[q] * (pyr[i4].cols*bpp2);
                u8o[1] = (dx[q]*bpp) + dy[q] * (pyr[i4 + (next<<2)].cols*bpp);
                u8o[2] = 0;
                for (y = 0; y < qh; y++) {
                  for (x = 0; x < qw; x++) {
                    sum = 0;
                    flag = true;
                    sn = cascade.stage_classifier.length;
                    for (j = 0; j < sn; j++) {
                      sum = 0;
                      alpha = cascade.stage_classifier[j].alpha;
                      feature = cascade.stage_classifier[j]._feature;
                      f_cnt = cascade.stage_classifier[j].count;
                      for (k = 0; k < f_cnt; k++) {
                        feature_k = feature[k];
                        pmin = u8[feature_k.pz[0]][u8o[feature_k.pz[0]] + feature_k.px[0]];
                        nmax = u8[feature_k.nz[0]][u8o[feature_k.nz[0]] + feature_k.nx[0]];
                        if (pmin <= nmax) {
                          sum += alpha[k << 1];
                        } else {
                          shortcut = true;
                          q_cnt = feature_k.size;
                          for (f = 1; f < q_cnt; f++) {
                            if (feature_k.pz[f] >= 0) {
                              p = u8[feature_k.pz[f]][u8o[feature_k.pz[f]] + feature_k.px[f]];
                              if (p < pmin) {
                                if (p <= nmax) {
                                  shortcut = false;
                                  break;
                                }
                                pmin = p;
                              }
                            }
                            if (feature_k.nz[f] >= 0) {
                              n = u8[feature_k.nz[f]][u8o[feature_k.nz[f]] + feature_k.nx[f]];
                              if (n > nmax) {
                                if (pmin <= n) {
                                  shortcut = false;
                                  break;
                                }
                                nmax = n;
                              }
                            }
                          }
                          sum += (shortcut) ? alpha[(k << 1) + 1] : alpha[k << 1];
                        }
                      }
                      if (sum < cascade.stage_classifier[j].threshold) {
                        flag = false;
                        break;
                      }
                    }
                    if (flag) {
                      seq.push({"x" : (x * 4 + dx[q] * 2) * scale_x,
                        "y" : (y * 4 + dy[q] * 2) * scale_y,
                        "width" : cascade.width * scale_x,
                        "height" : cascade.height * scale_y,
                        "neighbor" : 1,
                        "confidence" : sum});
                      ++x;
                      u8o[0] += bpp4;
                      u8o[1] += bpp2;
                      u8o[2] += bpp;
                    }
                    u8o[0] += bpp4;
                    u8o[1] += bpp2;
                    u8o[2] += bpp;
                  }
                  u8o[0] += paddings[0];
                  u8o[1] += paddings[1];
                  u8o[2] += paddings[2];
                }
              }
              scale_x *= scale;
              scale_y *= scale;
            }

            return seq;
          },

          // OpenCV method to group detected rectangles
          group_rectangles: function(rects, min_neighbors) {
            if (typeof min_neighbors === "undefined") { min_neighbors = 1; }
            var i, j, n = rects.length;
            var node = [];
            for (i = 0; i < n; ++i) {
              node[i] = {"parent" : -1,
                "element" : rects[i],
                "rank" : 0};
            }
            for (i = 0; i < n; ++i) {
              if (!node[i].element)
                continue;
              var root = i;
              while (node[root].parent != -1)
                root = node[root].parent;
              for (j = 0; j < n; ++j) {
                if( i != j && node[j].element && _group_func(node[i].element, node[j].element)) {
                  var root2 = j;

                  while (node[root2].parent != -1)
                    root2 = node[root2].parent;

                  if(root2 != root) {
                    if(node[root].rank > node[root2].rank)
                      node[root2].parent = root;
                    else {
                      node[root].parent = root2;
                      if (node[root].rank == node[root2].rank)
                        node[root2].rank++;
                      root = root2;
                    }

                    /* compress path from node2 to the root: */
                    var temp, node2 = j;
                    while (node[node2].parent != -1) {
                      temp = node2;
                      node2 = node[node2].parent;
                      node[temp].parent = root;
                    }

                    /* compress path from node to the root: */
                    node2 = i;
                    while (node[node2].parent != -1) {
                      temp = node2;
                      node2 = node[node2].parent;
                      node[temp].parent = root;
                    }
                  }
                }
              }
            }
            var idx_seq = [];
            var class_idx = 0;
            for(i = 0; i < n; i++) {
              j = -1;
              var node1 = i;
              if(node[node1].element) {
                while (node[node1].parent != -1)
                  node1 = node[node1].parent;
                if(node[node1].rank >= 0)
                  node[node1].rank = ~class_idx++;
                j = ~node[node1].rank;
              }
              idx_seq[i] = j;
            }

            var comps = [];
            for (i = 0; i < class_idx+1; ++i) {
              comps[i] = {"neighbors" : 0,
                "x" : 0,
                "y" : 0,
                "width" : 0,
                "height" : 0,
                "confidence" : 0};
            }

            // count number of neighbors
            for(i = 0; i < n; ++i) {
              var r1 = rects[i];
              var idx = idx_seq[i];

              if (comps[idx].neighbors == 0)
                comps[idx].confidence = r1.confidence;

              ++comps[idx].neighbors;

              comps[idx].x += r1.x;
              comps[idx].y += r1.y;
              comps[idx].width += r1.width;
              comps[idx].height += r1.height;
              comps[idx].confidence = Math.max(comps[idx].confidence, r1.confidence);
            }

            var seq2 = [];
            // calculate average bounding box
            for(i = 0; i < class_idx; ++i) {
              n = comps[i].neighbors;
              if (n >= min_neighbors)
                seq2.push({"x" : (comps[i].x * 2 + n) / (2 * n),
                  "y" : (comps[i].y * 2 + n) / (2 * n),
                  "width" : (comps[i].width * 2 + n) / (2 * n),
                  "height" : (comps[i].height * 2 + n) / (2 * n),
                  "neighbors" : comps[i].neighbors,
                  "confidence" : comps[i].confidence});
            }

            var result_seq = [];
            n = seq2.length;
            // filter out small face rectangles inside large face rectangles
            for(i = 0; i < n; ++i) {
              var r1 = seq2[i];
              var flag = true;
              for(j = 0; j < n; ++j) {
                var r2 = seq2[j];
                var distance = (r2.width * 0.25 + 0.5)|0;

                if(i != j &&
                  r1.x >= r2.x - distance &&
                  r1.y >= r2.y - distance &&
                  r1.x + r1.width <= r2.x + r2.width + distance &&
                  r1.y + r1.height <= r2.y + r2.height + distance &&
                  (r2.neighbors > Math.max(3, r1.neighbors) || r1.neighbors < 3)) {
                  flag = false;
                  break;
                }
              }

              if(flag)
                result_seq.push(r1);
            }
            return result_seq;
          }

        };

      })();

      global.bbf = bbf;

    })(jsfeat);
    /**
     * @author Eugene Zatepyakin / http://inspirit.ru/
     */

    (function(lib) {
      "use strict";

      {
        // in commonjs, or when AMD wrapping has been applied, define its namespaces as exports
        module.exports = lib;
      }
    })(jsfeat);
  });

  var findFaceWorker = function(e) {
    var window = self;

    var jsfeat=jsfeat||{REVISION:"ALPHA"};(function(r){var o=1.192092896e-7;var l=1e-37;var m=256,i=512,h=1024,x=2048,w=4096;var A=1,n=2,b=3,p=4;var z=new Int32Array([-1,1,4,-1,4,-1,-1,-1,8,-1,-1,-1,-1,-1,-1,-1,8]);var y=(function(){return function(B){return(B&65280)}})();var k=(function(){return function(B){return(B&255)}})();var c=(function(){return function(B){return z[(B&65280)>>8]}})();var a=0;var f=1;var e=2;var u=3;var d=1;var s=1;var g=2;var v=(function(){function B(D,C){this.size=((D+7)|0)&-8;if(typeof C==="undefined"){this.buffer=new ArrayBuffer(this.size);}else{this.buffer=C;this.size=C.length;}this.u8=new Uint8Array(this.buffer);this.i32=new Int32Array(this.buffer);this.f32=new Float32Array(this.buffer);this.f64=new Float64Array(this.buffer);}return B})();var q=(function(){function B(F,D,E,C){this.type=y(E)|0;this.channel=k(E)|0;this.cols=F|0;this.rows=D|0;if(typeof C==="undefined"){this.allocate();}else{this.buffer=C;this.data=this.type&m?this.buffer.u8:(this.type&i?this.buffer.i32:(this.type&h?this.buffer.f32:this.buffer.f64));}}B.prototype.allocate=function(){delete this.data;delete this.buffer;this.buffer=new v((this.cols*c(this.type)*this.channel)*this.rows);this.data=this.type&m?this.buffer.u8:(this.type&i?this.buffer.i32:(this.type&h?this.buffer.f32:this.buffer.f64));};B.prototype.copy_to=function(D){var C=D.data,G=this.data;var E=0,F=(this.cols*this.rows*this.channel)|0;for(;E<F-4;E+=4){C[E]=G[E];C[E+1]=G[E+1];C[E+2]=G[E+2];C[E+3]=G[E+3];}for(;E<F;++E){C[E]=G[E];}};B.prototype.resize=function(F,D,C){if(typeof C==="undefined"){C=this.channel;}var E=(F*c(this.type)*C)*D;if(E>this.buffer.size){this.cols=F;this.rows=D;this.channel=C;this.allocate();}else{this.cols=F;this.rows=D;this.channel=C;}};return B})();var t=(function(){function B(C){this.levels=C|0;this.data=new Array(C);this.pyrdown=jsfeat.imgproc.pyrdown;}B.prototype.allocate=function(C,E,F){var D=this.levels;while(--D>=0){this.data[D]=new q(C>>D,E>>D,F);}};B.prototype.build=function(F,E){if(typeof E==="undefined"){E=true;}var H=2,D=F,C=this.data[0];if(!E){var G=F.cols*F.rows;while(--G>=0){C.data[G]=F.data[G];}}C=this.data[1];this.pyrdown(D,C);for(;H<this.levels;++H){D=C;C=this.data[H];this.pyrdown(D,C);}};return B})();var j=(function(){function B(C,G,E,F,D){if(typeof C==="undefined"){C=0;}if(typeof G==="undefined"){G=0;}if(typeof E==="undefined"){E=0;}if(typeof F==="undefined"){F=0;}if(typeof D==="undefined"){D=-1;}this.x=C;this.y=G;this.score=E;this.level=F;this.angle=D;}return B})();r.U8_t=m;r.S32_t=i;r.F32_t=h;r.S64_t=x;r.F64_t=w;r.C1_t=A;r.C2_t=n;r.C3_t=b;r.C4_t=p;r.U8C1_t=m|A;r.U8C3_t=m|b;r.U8C4_t=m|p;r.F32C1_t=h|A;r.F32C2_t=h|n;r.S32C1_t=i|A;r.S32C2_t=i|n;r.EPSILON=o;r.FLT_MIN=l;r.COLOR_RGBA2GRAY=a;r.COLOR_RGB2GRAY=f;r.COLOR_BGRA2GRAY=e;r.COLOR_BGR2GRAY=u;r.BOX_BLUR_NOSCALE=d;r.SVD_U_T=s;r.SVD_V_T=g;r.get_data_type=y;r.get_channel=k;r.get_data_type_size=c;r.data_t=v;r.matrix_t=q;r.pyramid_t=t;r.keypoint_t=j;})(jsfeat);(function(b){var a=(function(){var f=(function(){function g(h){this.next=null;this.data=new jsfeat.data_t(h);this.size=this.data.size;this.buffer=this.data.buffer;this.u8=this.data.u8;this.i32=this.data.i32;this.f32=this.data.f32;this.f64=this.data.f64;}g.prototype.resize=function(h){delete this.data;this.data=new jsfeat.data_t(h);this.size=this.data.size;this.buffer=this.data.buffer;this.u8=this.data.u8;this.i32=this.data.i32;this.f32=this.data.f32;this.f64=this.data.f64;};return g})();var e,c;var d=0;return{allocate:function(g,k){e=c=new f(k);for(var h=0;h<g;++h){var j=new f(k);c=c.next=j;d++;}},get_buffer:function(g){var h=e;e=e.next;d--;if(g>h.size){h.resize(g);}return h},put_buffer:function(g){c=c.next=g;d++;}}})();b.cache=a;a.allocate(30,640*4);})(jsfeat);(function(b){var a=(function(){var c=new Int32Array(48*2);return{get_gaussian_kernel:function(p,m,e,l){var f=0,j=0,o=0,n=0,d=0;var g=0;var h=jsfeat.cache.get_buffer(p<<2);var k=h.f32;if((p&1)==1&&p<=7&&m<=0){switch(p>>1){case 0:k[0]=1;g=1;break;case 1:k[0]=0.25,k[1]=0.5,k[2]=0.25;g=0.25+0.5+0.25;break;case 2:k[0]=0.0625,k[1]=0.25,k[2]=0.375,k[3]=0.25,k[4]=0.0625;g=0.0625+0.25+0.375+0.25+0.0625;break;case 3:k[0]=0.03125,k[1]=0.109375,k[2]=0.21875,k[3]=0.28125,k[4]=0.21875,k[5]=0.109375,k[6]=0.03125;g=0.03125+0.109375+0.21875+0.28125+0.21875+0.109375+0.03125;break}}else{n=m>0?m:((p-1)*0.5-1)*0.3+0.8;d=-0.5/(n*n);for(;f<p;++f){j=f-(p-1)*0.5;o=Math.exp(d*j*j);k[f]=o;g+=o;}}if(l&jsfeat.U8_t){g=256/g;for(f=0;f<p;++f){e[f]=(k[f]*g+0.5)|0;}}else{g=1/g;for(f=0;f<p;++f){e[f]=k[f]*g;}}jsfeat.cache.put_buffer(h);},perspective_4point_transform:function(x,B,r,w,g,A,q,v,f,z,p,u,e,y,o,t,d){var Y=B;var X=z;var W=q;var V=Y*X*W;var U=o;var T=Y*U;var S=X*T;var R=p;var n=Y*R;var m=A;var k=r;var j=y;var i=k*j;var h=i*m;var ax=j*m*R;var aw=j*W;var aq=j*R;var ao=X*W;var am=U*X;var aj=U*m;var ag=R*m;var Q=1/(aw-aq-ao+am-aj+ag);var O=Y*j;var N=k*m;var M=W*Y;var L=U*M;var K=k*X;var I=i*R;var G=k*R*m;var D=W*U*X;var C=U*k;var av=-(S-V+n*m-m*T-i*X+h-ax+aw*X)*Q;var au=(V-S-O*W+O*R+h-X*N+aj*X-ax)*Q;var ar=Y;var ap=(-R*T+L+K*W-i*W+I-G+aj*R-D)*Q;var an=(-L+M*R-C*X+I-G+C*m+D-aw*R)*Q;var al=k;var ai=(-n+M+K-N+aq-aw-am+aj)*Q;var af=(-T+n+i-K+aj-ag-aw+ao)*Q;Y=w;X=u;W=f;V=Y*X*W;U=d;T=Y*U;S=X*T;R=e;n=Y*R;m=v;k=g;j=t;i=k*j;h=i*m;ax=j*m*R;aw=j*W;aq=j*R;ao=X*W;am=U*X;aj=U*m;ag=R*m;Q=1/(aw-aq-ao+am-aj+ag);O=Y*j;N=k*m;M=W*Y;L=U*M;K=k*X;I=i*R;G=k*R*m;D=W*U*X;C=U*k;var ak=-(S-V+n*m-m*T-i*X+h-ax+aw*X)*Q;var ah=(V-S-O*W+O*R+h-X*N+aj*X-ax)*Q;var ae=Y;var ad=(-R*T+L+K*W-i*W+I-G+aj*R-D)*Q;var ac=(-L+M*R-C*X+I-G+C*m+D-aw*R)*Q;var ab=k;var aa=(-n+M+K-N+aq-aw-am+aj)*Q;var Z=(-T+n+i-K+aj-ag-aw+ao)*Q;X=an-af*al;W=av*an;V=av*al;T=ap*au;S=ar*ap;n=au*ai;var l=ar*ai;j=1/(W-V*af-T+S*af+n*al-l*an);h=-ap+al*ai;var at=-ap*af+an*ai;ag=-au+ar*af;var P=av-l;N=av*af-n;M=-au*al+ar*an;var J=V-S;var H=W-T;G=X*j;var F=ag*j;var E=M*j;var s=x.data;s[0]=ak*G+ah*(h*j)-ae*(at*j);s[1]=ak*F+ah*(P*j)-ae*(N*j);s[2]=-ak*E-ah*(J*j)+ae*(H*j);s[3]=ad*G+ac*(h*j)-ab*(at*j);s[4]=ad*F+ac*(P*j)-ab*(N*j);s[5]=-ad*E-ac*(J*j)+ab*(H*j);s[6]=aa*G+Z*(h*j)-at*j;s[7]=aa*F+Z*(P*j)-N*j;s[8]=-aa*E-Z*(J*j)+H*j;},qsort:function(o,J,s,u){var D=7;var v,r,q,p;var C=0,j=0,G=0,B=0,z=0,A=0,e=0,y=0,E=0;var x=0,w=0,h=0,g=0,l=0,I=0,H=0,F=0,f=0;var k=c;if((s-J+1)<=1){return}k[0]=J;k[1]=s;while(C>=0){j=k[C<<1];G=k[(C<<1)+1];C--;for(;;){z=(G-j)+1;if(z<=D){for(e=j+1;e<=G;e++){for(y=e;y>j&&u(o[y],o[y-1]);y--){v=o[y];o[y]=o[y-1];o[y-1]=v;}}break}else{f=0;x=j;h=G;l=j+(z>>1);if(z>40){E=z>>3;I=j,H=j+E,F=j+(E<<1);r=o[I],q=o[H],p=o[F];j=u(r,q)?(u(q,p)?H:(u(r,p)?F:I)):(u(p,q)?H:(u(r,p)?I:F));I=l-E,H=l,F=l+E;r=o[I],q=o[H],p=o[F];l=u(r,q)?(u(q,p)?H:(u(r,p)?F:I)):(u(p,q)?H:(u(r,p)?I:F));I=G-(E<<1),H=G-E,F=G;r=o[I],q=o[H],p=o[F];G=u(r,q)?(u(q,p)?H:(u(r,p)?F:I)):(u(p,q)?H:(u(r,p)?I:F));}I=j,H=l,F=G;r=o[I],q=o[H],p=o[F];l=u(r,q)?(u(q,p)?H:(u(r,p)?F:I)):(u(p,q)?H:(u(r,p)?I:F));if(l!=x){v=o[l];o[l]=o[x];o[x]=v;l=x;}j=w=x+1;G=g=h;r=o[l];for(;;){while(j<=G&&!u(r,o[j])){if(!u(o[j],r)){if(j>w){v=o[w];o[w]=o[j];o[j]=v;}f=1;w++;}j++;}while(j<=G&&!u(o[G],r)){if(!u(r,o[G])){if(G<g){v=o[g];o[g]=o[G];o[G]=v;}f=1;g--;}G--;}if(j>G){break}v=o[j];o[j]=o[G];o[G]=v;f=1;j++;G--;}if(f==0){j=x,G=h;for(e=j+1;e<=G;e++){for(y=e;y>j&&u(o[y],o[y-1]);y--){v=o[y];o[y]=o[y-1];o[y-1]=v;}}break}z=Math.min((w-x),(j-w));A=(j-z)|0;for(B=0;B<z;++B,++A){v=o[x+B];o[x+B]=o[A];o[A]=v;}z=Math.min((h-g),(g-G));A=(h-z+1)|0;for(B=0;B<z;++B,++A){v=o[j+B];o[j+B]=o[A];o[A]=v;}z=(j-w);A=(g-G);if(z>1){if(A>1){if(z>A){++C;k[C<<1]=x;k[(C<<1)+1]=x+z-1;j=h-A+1,G=h;}else{++C;k[C<<1]=h-A+1;k[(C<<1)+1]=h;j=x,G=x+z-1;}}else{j=x,G=x+z-1;}}else{if(A>1){j=h-A+1,G=h;}else{break}}}}}},median:function(k,d,i){var e;var f=0,j=0,g=0,h=(d+i)>>1;for(;;){if(i<=d){return k[h]}if(i==(d+1)){if(k[d]>k[i]){e=k[d];k[d]=k[i];k[i]=e;}return k[h]}f=((d+i)>>1);if(k[f]>k[i]){e=k[f];k[f]=k[i];k[i]=e;}if(k[d]>k[i]){e=k[d];k[d]=k[i];k[i]=e;}if(k[f]>k[d]){e=k[f];k[f]=k[d];k[d]=e;}j=(d+1);e=k[f];k[f]=k[j];k[j]=e;g=i;for(;;){do{++j;}while(k[d]>k[j]);do{--g;}while(k[g]>k[d]);if(g<j){break}e=k[j];k[j]=k[g];k[g]=e;}e=k[d];k[d]=k[g];k[g]=e;if(g<=h){d=j;}else{if(g>=h){i=(g-1);}}}return 0}}})();b.math=a;})(jsfeat);(function(b){var a=(function(){return{identity:function(j,g){if(typeof g==="undefined"){g=1;}var i=j.data;var f=j.rows,h=j.cols,e=(h+1)|0;var c=f*h;var d=c;while(--c>=0){i[c]=0;}c=d;d=0;while(d<c){i[d]=g;d=d+e;}},transpose:function(f,d){var l=0,h=0,k=d.rows,c=d.cols;var n=0,e=0,m=0;var o=d.data,g=f.data;for(;l<k;e+=1,n+=c,l++){m=e;for(h=0;h<c;m+=k,h++){g[m]=o[n+h];}}},multiply:function(l,n,m){var u=0,s=0,o=0;var r=0,t=0,q=0,w=0,g=0;var f=n.cols,e=n.rows,p=m.cols;var v=n.data,d=m.data,h=l.data;var c=0;for(;u<e;r+=f,u++){for(w=0,s=0;s<p;g++,w++,s++){q=w;t=r;c=0;for(o=0;o<f;t++,q+=p,o++){c+=v[t]*d[q];}h[g]=c;}}},multiply_ABt:function(c,g,d){var p=0,n=0,m=0;var r=0,l=0,f=0,u=0;var e=g.cols,o=g.rows,q=d.rows;var v=g.data,t=d.data,h=c.data;var s=0;for(;p<o;r+=e,p++){for(f=0,n=0;n<q;u++,n++){l=r;s=0;for(m=0;m<e;l++,f++,m++){s+=v[l]*t[f];}h[u]=s;}}},multiply_AtB:function(l,n,m){var u=0,s=0,o=0;var r=0,t=0,q=0,w=0,g=0;var f=n.cols,e=n.rows,p=m.cols;var v=n.data,d=m.data,h=l.data;var c=0;for(;u<f;r++,u++){for(w=0,s=0;s<p;g++,w++,s++){q=w;t=r;c=0;for(o=0;o<e;t+=f,q+=p,o++){c+=v[t]*d[q];}h[g]=c;}}},multiply_AAt:function(d,h){var q=0,o=0,n=0;var c=0,r=0,m=0,g=0,e=0,u=0;var f=h.cols,p=h.rows;var t=h.data,l=d.data;var s=0;for(;q<p;c+=p+1,r=m,q++){e=c;u=c;g=r;for(o=q;o<p;e++,u+=p,o++){m=r;s=0;for(n=0;n<f;n++){s+=t[m++]*t[g++];}l[e]=s;l[u]=s;}}},multiply_AtA:function(c,g){var r=0,p=0,n=0;var s=0,m=0,f=0,o=0,d=0,l=0;var e=g.cols,q=g.rows;var u=g.data,h=c.data;var t=0;for(;r<e;o+=e,r++){s=r;l=o+r;d=l;for(p=r;p<e;d++,l+=e,p++){m=s;f=p;t=0;for(n=0;n<q;m+=e,f+=e,n++){t+=u[m]*u[f];}h[d]=t;h[l]=t;}}},identity_3x3:function(e,d){if(typeof d==="undefined"){d=1;}var c=e.data;c[0]=c[4]=c[8]=d;c[1]=c[2]=c[3]=0;c[5]=c[6]=c[7]=0;},invert_3x3:function(s,e){var o=s.data,h=e.data;var n=o[4];var m=o[8];var l=o[5];var k=o[7];var j=o[0];var i=j*n;var v=j*l;var u=o[3];var t=o[1];var r=u*t;var q=o[2];var p=u*q;var g=o[6];var f=g*t;var d=g*q;var c=1/(i*m-v*k-r*m+p*k+f*l-d*n);h[0]=(n*m-l*k)*c;h[1]=-(t*m-q*k)*c;h[2]=-(-t*l+q*n)*c;h[3]=-(u*m-l*g)*c;h[4]=(j*m-d)*c;h[5]=-(v-p)*c;h[6]=-(-u*k+n*g)*c;h[7]=-(j*k-f)*c;h[8]=(i-r)*c;},multiply_3x3:function(r,v,t){var y=r.data,z=v.data,l=t.data;var x=z[0],w=z[1],u=z[2];var s=z[3],q=z[4],p=z[5];var o=z[6],n=z[7],m=z[8];var k=l[0],j=l[1],i=l[2];var h=l[3],g=l[4],f=l[5];var e=l[6],d=l[7],c=l[8];y[0]=x*k+w*h+u*e;y[1]=x*j+w*g+u*d;y[2]=x*i+w*f+u*c;y[3]=s*k+q*h+p*e;y[4]=s*j+q*g+p*d;y[5]=s*i+q*f+p*c;y[6]=o*k+n*h+m*e;y[7]=o*j+n*g+m*d;y[8]=o*i+n*f+m*c;},mat3x3_determinant:function(d){var c=d.data;return c[0]*c[4]*c[8]-c[0]*c[5]*c[7]-c[3]*c[1]*c[8]+c[3]*c[2]*c[7]+c[6]*c[1]*c[5]-c[6]*c[2]*c[4]},determinant_3x3:function(h,g,f,e,d,c,k,j,i){return h*d*i-h*c*j-e*g*i+e*f*j+k*g*c-k*f*d}}})();b.matmath=a;})(jsfeat);(function(b){var a=(function(){var f=function(g,j,i,h){h=g[j];g[j]=g[i];g[i]=h;};var d=function(h,g){h=Math.abs(h);g=Math.abs(g);if(h>g){g/=h;return h*Math.sqrt(1+g*g)}if(g>0){h/=g;return g*Math.sqrt(1+h*h)}return 0};var c=function(H,o,q,r,h,I){var C=jsfeat.EPSILON;var N=0,M=0,L=0,J=0,K=0,D=0,R=0,G=0;var u=0,v=I*I*30;var E=0,U=0,F=0,x=0,z=0,B=0,Q=0,T=0,w=0;var P=jsfeat.cache.get_buffer(I<<2);var S=jsfeat.cache.get_buffer(I<<2);var O=P.i32;var g=S.i32;if(r){for(;N<I;N++){L=N*h;for(M=0;M<I;M++){r[L+M]=0;}r[L+N]=1;}}for(L=0;L<I;L++){q[L]=H[(o+1)*L];if(L<I-1){for(J=L+1,E=Math.abs(H[o*L+J]),N=L+2;N<I;N++){U=Math.abs(H[o*L+N]);if(E<U){E=U,J=N;}}O[L]=J;}if(L>0){for(J=0,E=Math.abs(H[L]),N=1;N<L;N++){U=Math.abs(H[o*N+L]);if(E<U){E=U,J=N;}}g[L]=J;}}if(I>1){for(;u<v;u++){for(L=0,E=Math.abs(H[O[0]]),N=1;N<I-1;N++){U=Math.abs(H[o*N+O[N]]);if(E<U){E=U,L=N;}}K=O[L];for(N=1;N<I;N++){U=Math.abs(H[o*g[N]+N]);if(E<U){E=U,L=g[N],K=N;}}F=H[o*L+K];if(Math.abs(F)<=C){break}x=(q[K]-q[L])*0.5;z=Math.abs(x)+d(F,x);B=d(F,z);Q=z/B;B=F/B;z=(F/z)*F;if(x<0){B=-B,z=-z;}H[o*L+K]=0;q[L]-=z;q[K]+=z;for(N=0;N<L;N++){R=(o*N+L);G=(o*N+K);T=H[R];w=H[G];H[R]=T*Q-w*B;H[G]=T*B+w*Q;}for(N=(L+1);N<K;N++){R=(o*L+N);G=(o*N+K);T=H[R];w=H[G];H[R]=T*Q-w*B;H[G]=T*B+w*Q;}N=K+1;R=(o*L+N);G=(o*K+N);for(;N<I;N++,R++,G++){T=H[R];w=H[G];H[R]=T*Q-w*B;H[G]=T*B+w*Q;}if(r){R=h*L;G=h*K;for(N=0;N<I;N++,R++,G++){T=r[R];w=r[G];r[R]=T*Q-w*B;r[G]=T*B+w*Q;}}for(M=0;M<2;M++){D=M==0?L:K;if(D<I-1){for(J=D+1,E=Math.abs(H[o*D+J]),N=D+2;N<I;N++){U=Math.abs(H[o*D+N]);if(E<U){E=U,J=N;}}O[D]=J;}if(D>0){for(J=0,E=Math.abs(H[D]),N=1;N<D;N++){U=Math.abs(H[o*N+D]);if(E<U){E=U,J=N;}}g[D]=J;}}}}for(L=0;L<I-1;L++){J=L;for(N=L+1;N<I;N++){if(q[J]<q[N]){J=N;}}if(L!=J){f(q,J,L,E);if(r){for(N=0;N<I;N++){f(r,h*J+N,h*L+N,E);}}}}jsfeat.cache.put_buffer(P);jsfeat.cache.put_buffer(S);};var e=function(D,l,h,M,v,T,S,E){var C=jsfeat.EPSILON*2;var q=jsfeat.FLT_MIN;var X=0,V=0,U=0,A=0,u=Math.max(T,30);var K=0,J=0,R=0,Q=0,F=0;var Y=0,O=0,N=0;var H=0,G=0,x=0,I=0,w=0,L=0,aa=0,P=0,Z=0;var z=4660;var B=0,y=0,o=0;var r=jsfeat.cache.get_buffer(S<<3);var g=r.f64;for(;X<S;X++){for(U=0,x=0;U<T;U++){N=D[X*l+U];x+=N*N;}g[X]=x;if(M){for(U=0;U<S;U++){M[X*v+U]=0;}M[X*v+X]=1;}}for(;A<u;A++){F=0;for(X=0;X<S-1;X++){for(V=X+1;V<S;V++){K=(X*l)|0,J=(V*l)|0;aa=g[X],P=0,Z=g[V];U=2;P+=D[K]*D[J];P+=D[K+1]*D[J+1];for(;U<T;U++){P+=D[K+U]*D[J+U];}if(Math.abs(P)<=C*Math.sqrt(aa*Z)){continue}P*=2;I=aa-Z,w=d(P,I);if(I<0){L=(w-I)*0.5;O=Math.sqrt(L/w);Y=(P/(w*O*2));}else{Y=Math.sqrt((w+I)/(w*2));O=(P/(w*Y*2));}aa=0,Z=0;U=2;H=Y*D[K]+O*D[J];G=-O*D[K]+Y*D[J];D[K]=H;D[J]=G;aa+=H*H;Z+=G*G;H=Y*D[K+1]+O*D[J+1];G=-O*D[K+1]+Y*D[J+1];D[K+1]=H;D[J+1]=G;aa+=H*H;Z+=G*G;for(;U<T;U++){H=Y*D[K+U]+O*D[J+U];G=-O*D[K+U]+Y*D[J+U];D[K+U]=H;D[J+U]=G;aa+=H*H;Z+=G*G;}g[X]=aa;g[V]=Z;F=1;if(M){R=(X*v)|0,Q=(V*v)|0;U=2;H=Y*M[R]+O*M[Q];G=-O*M[R]+Y*M[Q];M[R]=H;M[Q]=G;H=Y*M[R+1]+O*M[Q+1];G=-O*M[R+1]+Y*M[Q+1];M[R+1]=H;M[Q+1]=G;for(;U<S;U++){H=Y*M[R+U]+O*M[Q+U];G=-O*M[R+U]+Y*M[Q+U];M[R+U]=H;M[Q+U]=G;}}}}if(F==0){break}}for(X=0;X<S;X++){for(U=0,x=0;U<T;U++){N=D[X*l+U];x+=N*N;}g[X]=Math.sqrt(x);}for(X=0;X<S-1;X++){V=X;for(U=X+1;U<S;U++){if(g[V]<g[U]){V=U;}}if(X!=V){f(g,X,V,x);if(M){for(U=0;U<T;U++){f(D,X*l+U,V*l+U,N);}for(U=0;U<S;U++){f(M,X*v+U,V*v+U,N);}}}}for(X=0;X<S;X++){h[X]=g[X];}if(!M){jsfeat.cache.put_buffer(r);return}for(X=0;X<E;X++){x=X<S?g[X]:0;while(x<=q){y=(1/T);for(U=0;U<T;U++){z=(z*214013+2531011);B=(((z>>16)&32767)&256)!=0?y:-y;D[X*l+U]=B;}for(A=0;A<2;A++){for(V=0;V<X;V++){x=0;for(U=0;U<T;U++){x+=D[X*l+U]*D[V*l+U];}o=0;for(U=0;U<T;U++){N=(D[X*l+U]-x*D[V*l+U]);D[X*l+U]=N;o+=Math.abs(N);}o=o?1/o:0;for(U=0;U<T;U++){D[X*l+U]*=o;}}}x=0;for(U=0;U<T;U++){N=D[X*l+U];x+=N*N;}x=Math.sqrt(x);}O=(1/x);for(U=0;U<T;U++){D[X*l+U]*=O;}}jsfeat.cache.put_buffer(r);};return{lu_solve:function(l,g){var q=0,o=0,n=0,h=1,v=l.cols;var w=l.data,r=g.data;var x,m,u,y;for(q=0;q<v;q++){n=q;for(o=q+1;o<v;o++){if(Math.abs(w[o*v+q])>Math.abs(w[n*v+q])){n=o;}}if(Math.abs(w[n*v+q])<jsfeat.EPSILON){return 0}if(n!=q){for(o=q;o<v;o++){f(w,q*v+o,n*v+o,x);}f(r,q,n,x);h=-h;}u=-1/w[q*v+q];for(o=q+1;o<v;o++){m=w[o*v+q]*u;for(n=q+1;n<v;n++){w[o*v+n]+=m*w[q*v+n];}r[o]+=m*r[q];}w[q*v+q]=-u;}for(q=v-1;q>=0;q--){y=r[q];for(n=q+1;n<v;n++){y-=w[q*v+n]*r[n];}r[q]=y*w[q*v+q];}return 1},cholesky_solve:function(h,g){var l=0,v=0,r=0,s=0,n=0,p=0,o=0;var u=h.cols;var t=h.data,q=g.data;var k,m;for(l=0;l<u;l++){m=1;s=(l*u);n=s;for(v=l;v<u;v++){k=t[(n+l)];for(r=0;r<l;r++){k-=t[(r*u+l)]*t[(n+r)];}if(v==l){t[(n+l)]=k;if(k==0){return 0}m=1/k;}else{t[(s+v)]=k;t[(n+l)]=k*m;}n=(n+u);}}s=0;for(p=0;p<u;p++){k=q[p];for(o=0;o<p;o++){k-=t[(s+o)]*q[o];}q[p]=k;s=(s+u);}s=0;for(p=0;p<u;p++){q[p]/=t[(s+p)];s=(s+u);}p=(u-1);for(;p>=0;p--){k=q[p];o=(p+1);s=(o*u);for(;o<u;o++){k-=t[(s+p)]*q[o];s=(s+u);}q[p]=k;}return 1},svd_decompose:function(t,k,p,l,o){if(typeof o==="undefined"){o=0;}var r=0,z=0,x=0,g=t.rows,D=t.cols,w=g,v=D;var s=t.type|jsfeat.C1_t;if(w<v){r=1;z=w;w=v;v=z;}var q=jsfeat.cache.get_buffer((w*w)<<3);var h=jsfeat.cache.get_buffer(v<<3);var C=jsfeat.cache.get_buffer((v*v)<<3);var u=new jsfeat.matrix_t(w,w,s,q.data);var B=new jsfeat.matrix_t(1,v,s,h.data);var y=new jsfeat.matrix_t(v,v,s,C.data);if(r==0){jsfeat.matmath.transpose(u,t);}else{for(z=0;z<D*g;z++){u.data[z]=t.data[z];}for(;z<v*w;z++){u.data[z]=0;}}e(u.data,w,B.data,y.data,v,w,v,w);if(k){for(z=0;z<v;z++){k.data[z]=B.data[z];}for(;z<D;z++){k.data[z]=0;}}if(r==0){if(p&&(o&jsfeat.SVD_U_T)){z=w*w;while(--z>=0){p.data[z]=u.data[z];}}else{if(p){jsfeat.matmath.transpose(p,u);}}if(l&&(o&jsfeat.SVD_V_T)){z=v*v;while(--z>=0){l.data[z]=y.data[z];}}else{if(l){jsfeat.matmath.transpose(l,y);}}}else{if(p&&(o&jsfeat.SVD_U_T)){z=v*v;while(--z>=0){p.data[z]=y.data[z];}}else{if(p){jsfeat.matmath.transpose(p,y);}}if(l&&(o&jsfeat.SVD_V_T)){z=w*w;while(--z>=0){l.data[z]=u.data[z];}}else{if(l){jsfeat.matmath.transpose(l,u);}}}jsfeat.cache.put_buffer(q);jsfeat.cache.put_buffer(h);jsfeat.cache.put_buffer(C);},svd_solve:function(v,l,s){var E=0,C=0,z=0;var w=0,u=0;var o=v.rows,p=v.cols;var h=0,I=0,x=0;var r=v.type|jsfeat.C1_t;var F=jsfeat.cache.get_buffer((o*o)<<3);var m=jsfeat.cache.get_buffer(p<<3);var H=jsfeat.cache.get_buffer((p*p)<<3);var t=new jsfeat.matrix_t(o,o,r,F.data);var G=new jsfeat.matrix_t(1,p,r,m.data);var D=new jsfeat.matrix_t(p,p,r,H.data);var n=s.data,y=t.data,q=G.data,g=D.data;this.svd_decompose(v,G,t,D,0);x=jsfeat.EPSILON*q[0]*p;for(;E<p;E++,u+=p){I=0;for(C=0;C<p;C++){if(q[C]>x){for(z=0,h=0,w=0;z<o;z++,w+=p){h+=y[w+C]*n[z];}I+=h*g[u+C]/q[C];}}l.data[E]=I;}jsfeat.cache.put_buffer(F);jsfeat.cache.put_buffer(m);jsfeat.cache.put_buffer(H);},svd_invert:function(E,t){var C=0,z=0,y=0;var v=0,s=0,h=0;var n=t.rows,o=t.cols;var l=0,w=0;var q=t.type|jsfeat.C1_t;var D=jsfeat.cache.get_buffer((n*n)<<3);var m=jsfeat.cache.get_buffer(o<<3);var G=jsfeat.cache.get_buffer((o*o)<<3);var u=new jsfeat.matrix_t(n,n,q,D.data);var F=new jsfeat.matrix_t(1,o,q,m.data);var B=new jsfeat.matrix_t(o,o,q,G.data);var r=E.data,x=u.data,p=F.data,g=B.data;this.svd_decompose(t,F,u,B,0);w=jsfeat.EPSILON*p[0]*o;for(;C<o;C++,s+=o){for(z=0,v=0;z<n;z++,h++){for(y=0,l=0;y<o;y++,v++){if(p[y]>w){l+=g[s+y]*x[v]/p[y];}}r[h]=l;}}jsfeat.cache.put_buffer(D);jsfeat.cache.put_buffer(m);jsfeat.cache.put_buffer(G);},eigenVV:function(j,p,r){var k=j.cols,m=k*k;var g=j.type|jsfeat.C1_t;var o=jsfeat.cache.get_buffer((k*k)<<3);var h=jsfeat.cache.get_buffer(k<<3);var l=new jsfeat.matrix_t(k,k,g,o.data);var q=new jsfeat.matrix_t(1,k,g,h.data);while(--m>=0){l.data[m]=j.data[m];}c(l.data,k,q.data,p?p.data:null,k,k);if(r){while(--k>=0){r.data[k]=q.data[k];}}jsfeat.cache.put_buffer(o);jsfeat.cache.put_buffer(h);}}})();b.linalg=a;})(jsfeat);(function(a){var c=(function(){var m=function(p){return p*p};var e=function(z,A,x,w,u){var t=0;var y=0,s=0,q=0,C=0;var v=0,r=0,p=0,B=0;var E=0,D=0;for(;t<u;++t){y+=z[t].x;s+=z[t].y;v+=A[t].x;r+=A[t].y;}y/=u;s/=u;v/=u;r/=u;for(t=0;t<u;++t){E=z[t].x-y;D=z[t].y-s;q+=Math.sqrt(E*E+D*D);E=A[t].x-v;D=A[t].y-r;p+=Math.sqrt(E*E+D*D);}q/=u;p/=u;C=Math.SQRT2/q;B=Math.SQRT2/p;x[0]=x[4]=C;x[2]=-y*C;x[5]=-s*C;x[1]=x[3]=x[6]=x[7]=0;x[8]=1;w[0]=w[4]=B;w[2]=-v*B;w[5]=-r*B;w[1]=w[3]=w[6]=w[7]=0;w[8]=1;};var h=function(x,u){var q=0,p=0,r=(u-1)|0;var w=0,t=0,v=0,s=0;for(;q<r;++q){w=x[q].x-x[r].x;t=x[q].y-x[r].y;for(p=0;p<q;++p){v=x[p].x-x[r].x;s=x[p].y-x[r].y;if(Math.abs(v*t-s*w)<=jsfeat.EPSILON*(Math.abs(w)+Math.abs(t)+Math.abs(v)+Math.abs(s))){return true}}}return false};var k=new jsfeat.matrix_t(3,3,jsfeat.F32_t|jsfeat.C1_t);var i=new jsfeat.matrix_t(3,3,jsfeat.F32_t|jsfeat.C1_t);var o=new jsfeat.matrix_t(6,6,jsfeat.F32_t|jsfeat.C1_t);var n=new jsfeat.matrix_t(6,1,jsfeat.F32_t|jsfeat.C1_t);var j=(function(){function p(){}p.prototype.run=function(D,q,r,t){var G=0,F=0;var B=r.type|jsfeat.C1_t;var J=r.data,v=k.data,E=i.data;var x,w,A=0,z=0;e(D,q,v,E,t);var u=jsfeat.cache.get_buffer((2*t*6)<<3);var y=jsfeat.cache.get_buffer((2*t)<<3);var C=new jsfeat.matrix_t(6,2*t,B,u.data);var H=new jsfeat.matrix_t(1,2*t,B,y.data);var I=C.data,s=H.data;for(;G<t;++G){x=D[G];w=q[G];A=v[0]*x.x+v[1]*x.y+v[2];z=v[3]*x.x+v[4]*x.y+v[5];F=G*2*6;I[F]=A,I[F+1]=z,I[F+2]=1,I[F+3]=0,I[F+4]=0,I[F+5]=0;F+=6;I[F]=0,I[F+1]=0,I[F+2]=0,I[F+3]=A,I[F+4]=z,I[F+5]=1;s[G<<1]=E[0]*w.x+E[1]*w.y+E[2];s[(G<<1)+1]=E[3]*w.x+E[4]*w.y+E[5];}jsfeat.matmath.multiply_AtA(o,C);jsfeat.matmath.multiply_AtB(n,C,H);jsfeat.linalg.lu_solve(o,n);J[0]=n.data[0],J[1]=n.data[1],J[2]=n.data[2];J[3]=n.data[3],J[4]=n.data[4],J[5]=n.data[5];J[6]=0,J[7]=0,J[8]=1;jsfeat.matmath.invert_3x3(i,i);jsfeat.matmath.multiply_3x3(r,i,r);jsfeat.matmath.multiply_3x3(r,r,k);jsfeat.cache.put_buffer(u);jsfeat.cache.put_buffer(y);return 1};p.prototype.error=function(v,w,t,r,u){var s=0;var y,x;var q=t.data;for(;s<u;++s){y=v[s];x=w[s];r[s]=m(x.x-q[0]*y.x-q[1]*y.y-q[2])+m(x.y-q[3]*y.x-q[4]*y.y-q[5]);}};p.prototype.check_subset=function(s,r,q){return true};return p})();var g=new jsfeat.matrix_t(9,9,jsfeat.F32_t|jsfeat.C1_t);var f=new jsfeat.matrix_t(9,9,jsfeat.F32_t|jsfeat.C1_t);var l=(function(){function p(){}p.prototype.run=function(I,r,v,C){var L=0,K=0;var O=v.data,D=k.data,J=i.data;var M=g.data,N=f.data;var H=0,G=0,s=0,q=0;var u=0,t=0,B=0,A=0,z=0,w=0,F=0,E=0;for(;L<C;++L){B+=r[L].x;A+=r[L].y;F+=I[L].x;E+=I[L].y;}B/=C;A/=C;F/=C;E/=C;for(L=0;L<C;++L){u+=Math.abs(r[L].x-B);t+=Math.abs(r[L].y-A);z+=Math.abs(I[L].x-F);w+=Math.abs(I[L].y-E);}if(Math.abs(u)<jsfeat.EPSILON||Math.abs(t)<jsfeat.EPSILON||Math.abs(z)<jsfeat.EPSILON||Math.abs(w)<jsfeat.EPSILON){return 0}u=C/u;t=C/t;z=C/z;w=C/w;D[0]=z;D[1]=0;D[2]=-F*z;D[3]=0;D[4]=w;D[5]=-E*w;D[6]=0;D[7]=0;D[8]=1;J[0]=1/u;J[1]=0;J[2]=B;J[3]=0;J[4]=1/t;J[5]=A;J[6]=0;J[7]=0;J[8]=1;L=81;while(--L>=0){M[L]=0;}for(L=0;L<C;++L){H=(r[L].x-B)*u;G=(r[L].y-A)*t;s=(I[L].x-F)*z;q=(I[L].y-E)*w;M[0]+=s*s;M[1]+=s*q;M[2]+=s;M[6]+=s*-H*s;M[7]+=s*-H*q;M[8]+=s*-H;M[10]+=q*q;M[11]+=q;M[15]+=q*-H*s;M[16]+=q*-H*q;M[17]+=q*-H;M[20]+=1;M[24]+=-H*s;M[25]+=-H*q;M[26]+=-H;M[30]+=s*s;M[31]+=s*q;M[32]+=s;M[33]+=s*-G*s;M[34]+=s*-G*q;M[35]+=s*-G;M[40]+=q*q;M[41]+=q;M[42]+=q*-G*s;M[43]+=q*-G*q;M[44]+=q*-G;M[50]+=1;M[51]+=-G*s;M[52]+=-G*q;M[53]+=-G;M[60]+=-H*s*-H*s+-G*s*-G*s;M[61]+=-H*s*-H*q+-G*s*-G*q;M[62]+=-H*s*-H+-G*s*-G;M[70]+=-H*q*-H*q+-G*q*-G*q;M[71]+=-H*q*-H+-G*q*-G;M[80]+=-H*-H+-G*-G;}for(L=0;L<9;++L){for(K=0;K<L;++K){M[L*9+K]=M[K*9+L];}}jsfeat.linalg.eigenVV(g,f);O[0]=N[72],O[1]=N[73],O[2]=N[74];O[3]=N[75],O[4]=N[76],O[5]=N[77];O[6]=N[78],O[7]=N[79],O[8]=N[80];jsfeat.matmath.multiply_3x3(v,i,v);jsfeat.matmath.multiply_3x3(v,v,k);H=1/O[8];O[0]*=H;O[1]*=H;O[2]*=H;O[3]*=H;O[4]*=H;O[5]*=H;O[6]*=H;O[7]*=H;O[8]=1;return 1};p.prototype.error=function(w,x,u,r,v){var t=0;var z,y,s=0,B=0,A=0;var q=u.data;for(;t<v;++t){z=w[t];y=x[t];s=1/(q[6]*z.x+q[7]*z.y+1);B=(q[0]*z.x+q[1]*z.y+q[2])*s-y.x;A=(q[3]*z.x+q[4]*z.y+q[5])*s-y.y;r[t]=(B*B+A*A);}};p.prototype.check_subset=function(M,s,B){if(B==4){var N=0;var I=M[0],H=M[1],G=M[2],E=M[3];var A=s[0],y=s[1],w=s[2],u=s[3];var L=I.x,K=I.y,J=1;var V=H.x,U=H.y,T=1;var z=G.x,x=G.y,v=1;var t=A.x,r=A.y,q=1;var F=y.x,D=y.y,C=1;var Q=w.x,P=w.y,O=1;var S=jsfeat.matmath.determinant_3x3(L,K,J,V,U,T,z,x,v);var R=jsfeat.matmath.determinant_3x3(t,r,q,F,D,C,Q,P,O);if(S*R<0){N++;}L=H.x,K=H.y;V=G.x,U=G.y;z=E.x,x=E.y;t=y.x,r=y.y;F=w.x,D=w.y;Q=u.x,P=u.y;S=jsfeat.matmath.determinant_3x3(L,K,J,V,U,T,z,x,v);R=jsfeat.matmath.determinant_3x3(t,r,q,F,D,C,Q,P,O);if(S*R<0){N++;}L=I.x,K=I.y;V=G.x,U=G.y;z=E.x,x=E.y;t=A.x,r=A.y;F=w.x,D=w.y;Q=u.x,P=u.y;S=jsfeat.matmath.determinant_3x3(L,K,J,V,U,T,z,x,v);R=jsfeat.matmath.determinant_3x3(t,r,q,F,D,C,Q,P,O);if(S*R<0){N++;}L=I.x,K=I.y;V=H.x,U=H.y;z=E.x,x=E.y;t=A.x,r=A.y;F=y.x,D=y.y;Q=u.x,P=u.y;S=jsfeat.matmath.determinant_3x3(L,K,J,V,U,T,z,x,v);R=jsfeat.matmath.determinant_3x3(t,r,q,F,D,C,Q,P,O);if(S*R<0){N++;}if(N!=0&&N!=4){return false}}return true};return p})();return{affine2d:j,homography2d:l}})();var b=(function(){function e(h,i,f,g){if(typeof h==="undefined"){h=0;}if(typeof i==="undefined"){i=0.5;}if(typeof f==="undefined"){f=0.5;}if(typeof g==="undefined"){g=0.99;}this.size=h;this.thresh=i;this.eps=f;this.prob=g;}e.prototype.update_iters=function(g,i){var h=Math.log(1-this.prob);var f=Math.log(1-Math.pow(1-g,this.size));return(f>=0||-h>=i*(-f)?i:Math.round(h/f))|0};return e})();var d=(function(){var e=function(l,q,r,p,t,m,g){var v=1000;var s=[];var n=0,k=0,u=0,h=0,o=false;for(;u<v;++u){n=0;for(;n<p&&u<v;){o=false;h=0;while(!o){o=true;h=s[n]=Math.floor(Math.random()*t)|0;for(k=0;k<n;++k){if(h==s[k]){o=false;break}}}m[n]=q[h];g[n]=r[h];if(!l.check_subset(m,g,n+1)){u++;continue}++n;}break}return(n==p&&u<v)};var f=function(k,m,p,q,o,g,h,s){var j=0,l=0,n=0;var r=g*g;k.error(p,q,m,h,o);for(;l<o;++l){n=h[l]<=r;s[l]=n;j+=n;}return j};return{ransac:function(E,m,x,i,l,j,y,g){if(typeof g==="undefined"){g=1000;}if(l<E.size){return false}var v=E.size;var A=g,z=0;var q=false;var D=[];var C=[];var r=false;var G=j.cols,w=j.rows;var u=j.type|jsfeat.C1_t;var B=jsfeat.cache.get_buffer((G*w)<<3);var h=jsfeat.cache.get_buffer(l);var t=jsfeat.cache.get_buffer(l<<2);var o=new jsfeat.matrix_t(G,w,u,B.data);var s=new jsfeat.matrix_t(l,1,jsfeat.U8C1_t,h.data);var F=-1,p=0;var n=0;var k=t.f32;if(l==v){if(m.run(x,i,o,l)<=0){jsfeat.cache.put_buffer(B);jsfeat.cache.put_buffer(h);jsfeat.cache.put_buffer(t);return false}o.copy_to(j);if(y){while(--l>=0){y.data[l]=1;}}jsfeat.cache.put_buffer(B);jsfeat.cache.put_buffer(h);jsfeat.cache.put_buffer(t);return true}for(;z<A;++z){r=e(m,x,i,v,l,D,C);if(!r){if(z==0){jsfeat.cache.put_buffer(B);jsfeat.cache.put_buffer(h);jsfeat.cache.put_buffer(t);return false}break}n=m.run(D,C,o,v);if(n<=0){continue}p=f(m,o,x,i,l,E.thresh,k,s.data);if(p>Math.max(F,v-1)){o.copy_to(j);F=p;if(y){s.copy_to(y);}A=E.update_iters((l-p)/l,A);q=true;}}jsfeat.cache.put_buffer(B);jsfeat.cache.put_buffer(h);jsfeat.cache.put_buffer(t);return q},lmeds:function(H,n,z,i,l,j,B,g){if(typeof g==="undefined"){g=1000;}if(l<H.size){return false}var w=H.size;var D=g,C=0;var r=false;var G=[];var F=[];var s=false;var I=j.cols,y=j.rows;var v=j.type|jsfeat.C1_t;var E=jsfeat.cache.get_buffer((I*y)<<3);var h=jsfeat.cache.get_buffer(l);var u=jsfeat.cache.get_buffer(l<<2);var p=new jsfeat.matrix_t(I,y,v,E.data);var t=new jsfeat.matrix_t(l,1,jsfeat.U8_t|jsfeat.C1_t,h.data);var q=0;var o=0;var k=u.f32;var A=1000000000,x=0,m=0;H.eps=0.45;D=H.update_iters(H.eps,D);if(l==w){if(n.run(z,i,p,l)<=0){jsfeat.cache.put_buffer(E);jsfeat.cache.put_buffer(h);jsfeat.cache.put_buffer(u);return false}p.copy_to(j);if(B){while(--l>=0){B.data[l]=1;}}jsfeat.cache.put_buffer(E);jsfeat.cache.put_buffer(h);jsfeat.cache.put_buffer(u);return true}for(;C<D;++C){s=e(n,z,i,w,l,G,F);if(!s){if(C==0){jsfeat.cache.put_buffer(E);jsfeat.cache.put_buffer(h);jsfeat.cache.put_buffer(u);return false}break}o=n.run(G,F,p,w);if(o<=0){continue}n.error(z,i,p,k,l);m=jsfeat.math.median(k,0,l-1);if(m<A){A=m;p.copy_to(j);r=true;}}if(r){x=2.5*1.4826*(1+5/(l-w))*Math.sqrt(A);x=Math.max(x,0.001);q=f(n,j,z,i,l,x,k,t.data);if(B){t.copy_to(B);}r=q>=w;}jsfeat.cache.put_buffer(E);jsfeat.cache.put_buffer(h);jsfeat.cache.put_buffer(u);return r}}})();a.ransac_params_t=b;a.motion_model=c;a.motion_estimator=d;})(jsfeat);(function(b){var a=(function(){var c=function(q,S,O,p){var r=0;var y=q.channel,v=q.cols,J=q.rows;var P=q.data,m=S.data;var I=v/O,H=J/p;var n=(I*H*65536)|0;var x=0,u=0,C=0,A=0,t=0,s=0,G=0,F=0,D=0,B=0;var Q=0,N=0,K=0,o=0,M=0,E=0;var l=jsfeat.cache.get_buffer((O*y)<<2);var g=jsfeat.cache.get_buffer((O*y)<<2);var R=jsfeat.cache.get_buffer((v*2*3)<<2);var L=l.i32;var j=g.i32;var z=R.i32;for(;x<O;x++){D=x*I,B=D+I;t=(D+1-0.000001)|0,s=B|0;t=Math.min(t,v-1);s=Math.min(s,v-1);if(t>D){z[F++]=(x*y)|0;z[F++]=((t-1)*y)|0;z[F++]=((t-D)*256)|0;r++;}for(C=t;C<s;C++){r++;z[F++]=(x*y)|0;z[F++]=(C*y)|0;z[F++]=256;}if(B-s>0.001){r++;z[F++]=(x*y)|0;z[F++]=(s*y)|0;z[F++]=((B-s)*256)|0;}}for(x=0;x<O*y;x++){L[x]=j[x]=0;}u=0;for(A=0;A<J;A++){Q=v*A;for(F=0;F<r;F++){K=z[F*3];t=z[F*3+1];o=z[F*3+2];for(G=0;G<y;G++){L[K+G]+=P[Q+t+G]*o;}}if((u+1)*H<=A+1||A==J-1){M=(Math.max(A+1-(u+1)*H,0)*256)|0;E=256-M;N=O*u;if(M<=0){for(x=0;x<O*y;x++){m[N+x]=Math.min(Math.max((j[x]+L[x]*256)/n,0),255);j[x]=L[x]=0;}}else{for(x=0;x<O*y;x++){m[N+x]=Math.min(Math.max((j[x]+L[x]*E)/n,0),255);j[x]=L[x]*M;L[x]=0;}}u++;}else{for(x=0;x<O*y;x++){j[x]+=L[x]*256;L[x]=0;}}}jsfeat.cache.put_buffer(g);jsfeat.cache.put_buffer(l);jsfeat.cache.put_buffer(R);};var f=function(p,S,N,o){var q=0;var x=p.channel,u=p.cols,I=p.rows;var O=p.data,m=S.data;var H=u/N,G=I/o;var Q=1/(H*G);var v=0,t=0,B=0,z=0,s=0,r=0,F=0,E=0,C=0,A=0;var P=0,M=0,J=0,n=0,L=0,D=0;var l=jsfeat.cache.get_buffer((N*x)<<2);var g=jsfeat.cache.get_buffer((N*x)<<2);var R=jsfeat.cache.get_buffer((u*2*3)<<2);var K=l.f32;var j=g.f32;var y=R.f32;for(;v<N;v++){C=v*H,A=C+H;s=(C+1-0.000001)|0,r=A|0;s=Math.min(s,u-1);r=Math.min(r,u-1);if(s>C){q++;y[E++]=((s-1)*x)|0;y[E++]=(v*x)|0;y[E++]=(s-C)*Q;}for(B=s;B<r;B++){q++;y[E++]=(B*x)|0;y[E++]=(v*x)|0;y[E++]=Q;}if(A-r>0.001){q++;y[E++]=(r*x)|0;y[E++]=(v*x)|0;y[E++]=(A-r)*Q;}}for(v=0;v<N*x;v++){K[v]=j[v]=0;}t=0;for(z=0;z<I;z++){P=u*z;for(E=0;E<q;E++){s=y[E*3]|0;J=y[E*3+1]|0;n=y[E*3+2];for(F=0;F<x;F++){K[J+F]+=O[P+s+F]*n;}}if((t+1)*G<=z+1||z==I-1){L=Math.max(z+1-(t+1)*G,0);D=1-L;M=N*t;if(Math.abs(L)<0.001){for(v=0;v<N*x;v++){m[M+v]=j[v]+K[v];j[v]=K[v]=0;}}else{for(v=0;v<N*x;v++){m[M+v]=j[v]+K[v]*D;j[v]=K[v]*L;K[v]=0;}}t++;}else{for(v=0;v<N*x;v++){j[v]+=K[v];K[v]=0;}}}jsfeat.cache.put_buffer(g);jsfeat.cache.put_buffer(l);jsfeat.cache.put_buffer(R);};var e=function(D,F,m,s,B,t,g,n){var z=0,y=0,x=0,A=0,u=0,l=0,G=0,E=0,C=0,v=t[0],r=0;var q=s<<1,p=s*3,o=s<<2;for(;z<B;++z){l=F[A];for(y=0;y<n;++y){D[y]=l;}for(y=0;y<=s-2;y+=2){D[y+n]=F[A+y];D[y+n+1]=F[A+y+1];}for(;y<s;++y){D[y+n]=F[A+y];}l=F[A+s-1];for(y=s;y<n+s;++y){D[y+n]=l;}for(y=0;y<=s-4;y+=4){l=D[y]*v,G=D[y+1]*v,E=D[y+2]*v,C=D[y+3]*v;for(x=1;x<g;++x){r=t[x];l+=D[x+y]*r;G+=D[x+y+1]*r;E+=D[x+y+2]*r;C+=D[x+y+3]*r;}m[u+y]=Math.min(l>>8,255);m[u+y+1]=Math.min(G>>8,255);m[u+y+2]=Math.min(E>>8,255);m[u+y+3]=Math.min(C>>8,255);}for(;y<s;++y){l=D[y]*v;for(x=1;x<g;++x){l+=D[x+y]*t[x];}m[u+y]=Math.min(l>>8,255);}A+=s;u+=s;}for(z=0;z<s;++z){l=m[z];for(y=0;y<n;++y){D[y]=l;}x=z;for(y=0;y<=B-2;y+=2,x+=q){D[y+n]=m[x];D[y+n+1]=m[x+s];}for(;y<B;++y,x+=s){D[y+n]=m[x];}l=m[(B-1)*s+z];for(y=B;y<n+B;++y){D[y+n]=l;}u=z;for(y=0;y<=B-4;y+=4,u+=o){l=D[y]*v,G=D[y+1]*v,E=D[y+2]*v,C=D[y+3]*v;for(x=1;x<g;++x){r=t[x];l+=D[x+y]*r;G+=D[x+y+1]*r;E+=D[x+y+2]*r;C+=D[x+y+3]*r;}m[u]=Math.min(l>>8,255);m[u+s]=Math.min(G>>8,255);m[u+q]=Math.min(E>>8,255);m[u+p]=Math.min(C>>8,255);}for(;y<B;++y,u+=s){l=D[y]*v;for(x=1;x<g;++x){l+=D[x+y]*t[x];}m[u]=Math.min(l>>8,255);}}};var d=function(D,F,m,s,B,t,g,n){var z=0,y=0,x=0,A=0,u=0,l=0,G=0,E=0,C=0,v=t[0],r=0;var q=s<<1,p=s*3,o=s<<2;for(;z<B;++z){l=F[A];for(y=0;y<n;++y){D[y]=l;}for(y=0;y<=s-2;y+=2){D[y+n]=F[A+y];D[y+n+1]=F[A+y+1];}for(;y<s;++y){D[y+n]=F[A+y];}l=F[A+s-1];for(y=s;y<n+s;++y){D[y+n]=l;}for(y=0;y<=s-4;y+=4){l=D[y]*v,G=D[y+1]*v,E=D[y+2]*v,C=D[y+3]*v;for(x=1;x<g;++x){r=t[x];l+=D[x+y]*r;G+=D[x+y+1]*r;E+=D[x+y+2]*r;C+=D[x+y+3]*r;}m[u+y]=l;m[u+y+1]=G;m[u+y+2]=E;m[u+y+3]=C;}for(;y<s;++y){l=D[y]*v;for(x=1;x<g;++x){l+=D[x+y]*t[x];}m[u+y]=l;}A+=s;u+=s;}for(z=0;z<s;++z){l=m[z];for(y=0;y<n;++y){D[y]=l;}x=z;for(y=0;y<=B-2;y+=2,x+=q){D[y+n]=m[x];D[y+n+1]=m[x+s];}for(;y<B;++y,x+=s){D[y+n]=m[x];}l=m[(B-1)*s+z];for(y=B;y<n+B;++y){D[y+n]=l;}u=z;for(y=0;y<=B-4;y+=4,u+=o){l=D[y]*v,G=D[y+1]*v,E=D[y+2]*v,C=D[y+3]*v;for(x=1;x<g;++x){r=t[x];l+=D[x+y]*r;G+=D[x+y+1]*r;E+=D[x+y+2]*r;C+=D[x+y+3]*r;}m[u]=l;m[u+s]=G;m[u+q]=E;m[u+p]=C;}for(;y<B;++y,u+=s){l=D[y]*v;for(x=1;x<g;++x){l+=D[x+y]*t[x];}m[u]=l;}}};return{grayscale:function(n,r,A,D,g){if(typeof g==="undefined"){g=jsfeat.COLOR_RGBA2GRAY;}var q=0,p=0,z=0,v=0,m=0,u=0;var s=4899,B=9617,C=1868,o=4;if(g==jsfeat.COLOR_BGRA2GRAY||g==jsfeat.COLOR_BGR2GRAY){s=1868;C=4899;}if(g==jsfeat.COLOR_RGB2GRAY||g==jsfeat.COLOR_BGR2GRAY){o=3;}var l=o<<1,k=(o*3)|0;D.resize(r,A,1);var t=D.data;for(p=0;p<A;++p,v+=r,z+=r*o){for(q=0,m=z,u=v;q<=r-4;q+=4,m+=o<<2,u+=4){t[u]=(n[m]*s+n[m+1]*B+n[m+2]*C+8192)>>14;t[u+1]=(n[m+o]*s+n[m+o+1]*B+n[m+o+2]*C+8192)>>14;t[u+2]=(n[m+l]*s+n[m+l+1]*B+n[m+l+2]*C+8192)>>14;t[u+3]=(n[m+k]*s+n[m+k+1]*B+n[m+k+2]*C+8192)>>14;}for(;q<r;++q,++u,m+=o){t[u]=(n[m]*s+n[m+1]*B+n[m+2]*C+8192)>>14;}}},resample:function(l,m,i,k){var j=l.rows,g=l.cols;if(j>k&&g>i){m.resize(i,k,l.channel);if(l.type&jsfeat.U8_t&&m.type&jsfeat.U8_t&&j*g/(k*i)<256){c(l,m,i,k);}else{f(l,m,i,k);}}},box_blur_gray:function(r,J,n,l){if(typeof l==="undefined"){l=0;}var z=r.cols,E=r.rows,s=E<<1,v=z<<1;var D=0,u=0,t=0,m=0;var B=((n<<1)+1)|0;var p=(n+1)|0,H=(p+1)|0;var I=l&jsfeat.BOX_BLUR_NOSCALE?1:(1/(B*B));var C=jsfeat.cache.get_buffer((z*E)<<2);var j=0,G=0,o=0,q=0,k=0;var F=C.i32;var g=r.data;var A=0;J.resize(z,E,r.channel);for(t=0;t<E;++t){G=t;j=p*g[o];for(D=(o+1)|0,m=(o+n)|0;D<=m;++D){j+=g[D];}q=(o+p)|0;k=o;A=g[k];for(u=0;u<n;++u,G+=E){F[G]=j;j+=g[q]-A;q++;}for(;u<z-H;u+=2,G+=s){F[G]=j;j+=g[q]-g[k];F[G+E]=j;j+=g[q+1]-g[k+1];q+=2;k+=2;}for(;u<z-p;++u,G+=E){F[G]=j;j+=g[q]-g[k];q++;k++;}A=g[q-1];for(;u<z;++u,G+=E){F[G]=j;j+=A-g[k];k++;}o+=z;}o=0;g=J.data;if(I==1){for(t=0;t<z;++t){G=t;j=p*F[o];for(D=(o+1)|0,m=(o+n)|0;D<=m;++D){j+=F[D];}q=o+p;k=o;A=F[k];for(u=0;u<n;++u,G+=z){g[G]=j;j+=F[q]-A;q++;}for(;u<E-H;u+=2,G+=v){g[G]=j;j+=F[q]-F[k];g[G+z]=j;j+=F[q+1]-F[k+1];q+=2;k+=2;}for(;u<E-p;++u,G+=z){g[G]=j;j+=F[q]-F[k];q++;k++;}A=F[q-1];for(;u<E;++u,G+=z){g[G]=j;j+=A-F[k];k++;}o+=E;}}else{for(t=0;t<z;++t){G=t;j=p*F[o];for(D=(o+1)|0,m=(o+n)|0;D<=m;++D){j+=F[D];}q=o+p;k=o;A=F[k];for(u=0;u<n;++u,G+=z){g[G]=j*I;j+=F[q]-A;q++;}for(;u<E-H;u+=2,G+=v){g[G]=j*I;j+=F[q]-F[k];g[G+z]=j*I;j+=F[q+1]-F[k+1];q+=2;k+=2;}for(;u<E-p;++u,G+=z){g[G]=j*I;j+=F[q]-F[k];q++;k++;}A=F[q-1];for(;u<E;++u,G+=z){g[G]=j*I;j+=A-F[k];k++;}o+=E;}}jsfeat.cache.put_buffer(C);},gaussian_blur:function(g,s,r,v){if(typeof v==="undefined"){v=0;}if(typeof r==="undefined"){r=0;}r=r==0?(Math.max(1,(4*v+1-1e-8))*2+1)|0:r;var x=r>>1;var t=g.cols,p=g.rows;var u=g.type,n=u&jsfeat.U8_t;s.resize(t,p,g.channel);var m=g.data,j=s.data;var k,i,q=(r+Math.max(p,t))|0;var l=jsfeat.cache.get_buffer(q<<2);var o=jsfeat.cache.get_buffer(r<<2);if(n){k=l.i32;i=o.i32;}else{if(u&jsfeat.S32_t){k=l.i32;i=o.f32;}else{k=l.f32;i=o.f32;}}jsfeat.math.get_gaussian_kernel(r,v,i,u);if(n){e(k,m,j,t,p,i,r,x);}else{d(k,m,j,t,p,i,r,x);}jsfeat.cache.put_buffer(l);jsfeat.cache.put_buffer(o);},pyrdown:function(k,A,s,r){if(typeof s==="undefined"){s=0;}if(typeof r==="undefined"){r=0;}var q=k.cols,t=k.rows;var p=q>>1,l=t>>1;var B=p-(s<<1),u=l-(r<<1);var o=0,n=0,g=s+r*q,m=0,v=0,i=0;A.resize(p,l,k.channel);var z=k.data,j=A.data;for(n=0;n<u;++n){m=g;i=v;for(o=0;o<=B-2;o+=2,i+=2,m+=4){j[i]=(z[m]+z[m+1]+z[m+q]+z[m+q+1]+2)>>2;j[i+1]=(z[m+2]+z[m+3]+z[m+q+2]+z[m+q+3]+2)>>2;}for(;o<B;++o,++i,m+=2){j[i]=(z[m]+z[m+1]+z[m+q]+z[m+q+1]+2)>>2;}g+=q<<1;v+=p;}},scharr_derivatives:function(j,G){var p=j.cols,s=j.rows;var H=p<<1,o=0,m=0,u=0,E,D,C,B,A,z;var v=0,t=0,r=0,i=0;var n,l;G.resize(p,s,2);var F=j.data,g=G.data;var k=jsfeat.cache.get_buffer((p+2)<<2);var q=jsfeat.cache.get_buffer((p+2)<<2);if(j.type&jsfeat.U8_t||j.type&jsfeat.S32_t){n=k.i32;l=q.i32;}else{n=k.f32;l=q.f32;}for(;m<s;++m,t+=p){v=((m>0?m-1:1)*p)|0;r=((m<s-1?m+1:s-2)*p)|0;i=(m*H)|0;for(o=0,u=1;o<=p-2;o+=2,u+=2){E=F[v+o],D=F[r+o];n[u]=((E+D)*3+(F[t+o])*10);l[u]=(D-E);E=F[v+o+1],D=F[r+o+1];n[u+1]=((E+D)*3+(F[t+o+1])*10);l[u+1]=(D-E);}for(;o<p;++o,++u){E=F[v+o],D=F[r+o];n[u]=((E+D)*3+(F[t+o])*10);l[u]=(D-E);}o=(p+1)|0;n[0]=n[1];n[o]=n[p];l[0]=l[1];l[o]=l[p];for(o=0;o<=p-4;o+=4){E=l[o+2],D=l[o+1],C=l[o+3],B=l[o+4],A=n[o+2],z=n[o+3];g[i++]=(A-n[o]);g[i++]=((E+l[o])*3+D*10);g[i++]=(z-n[o+1]);g[i++]=((C+D)*3+E*10);g[i++]=((n[o+4]-A));g[i++]=(((B+E)*3+C*10));g[i++]=((n[o+5]-z));g[i++]=(((l[o+5]+C)*3+B*10));}for(;o<p;++o){g[i++]=((n[o+2]-n[o]));g[i++]=(((l[o+2]+l[o])*3+l[o+1]*10));}}jsfeat.cache.put_buffer(k);jsfeat.cache.put_buffer(q);},sobel_derivatives:function(j,G){var p=j.cols,s=j.rows;var H=p<<1,o=0,m=0,u=0,E,D,C,B,A,z;var v=0,t=0,r=0,i=0;var n,l;G.resize(p,s,2);var F=j.data,g=G.data;var k=jsfeat.cache.get_buffer((p+2)<<2);var q=jsfeat.cache.get_buffer((p+2)<<2);if(j.type&jsfeat.U8_t||j.type&jsfeat.S32_t){n=k.i32;l=q.i32;}else{n=k.f32;l=q.f32;}for(;m<s;++m,t+=p){v=((m>0?m-1:1)*p)|0;r=((m<s-1?m+1:s-2)*p)|0;i=(m*H)|0;for(o=0,u=1;o<=p-2;o+=2,u+=2){E=F[v+o],D=F[r+o];n[u]=((E+D)+(F[t+o]*2));l[u]=(D-E);E=F[v+o+1],D=F[r+o+1];n[u+1]=((E+D)+(F[t+o+1]*2));l[u+1]=(D-E);}for(;o<p;++o,++u){E=F[v+o],D=F[r+o];n[u]=((E+D)+(F[t+o]*2));l[u]=(D-E);}o=(p+1)|0;n[0]=n[1];n[o]=n[p];l[0]=l[1];l[o]=l[p];for(o=0;o<=p-4;o+=4){E=l[o+2],D=l[o+1],C=l[o+3],B=l[o+4],A=n[o+2],z=n[o+3];g[i++]=(A-n[o]);g[i++]=(E+l[o]+D*2);g[i++]=(z-n[o+1]);g[i++]=(C+D+E*2);g[i++]=(n[o+4]-A);g[i++]=(B+E+C*2);g[i++]=(n[o+5]-z);g[i++]=(l[o+5]+C+B*2);}for(;o<p;++o){g[i++]=(n[o+2]-n[o]);g[i++]=(l[o+2]+l[o]+l[o+1]*2);}}jsfeat.cache.put_buffer(k);jsfeat.cache.put_buffer(q);},compute_integral_image:function(g,l,y,u){var t=g.cols|0,w=g.rows|0,o=g.data;var r=(t+1)|0;var B=0,z=0,h=0,x=0,q=0,n=0,A=0,m=0;if(l&&y){for(;q<r;++q){l[q]=0,y[q]=0;}h=(r+1)|0,x=1;for(q=0,m=0;q<w;++q,++h,++x){B=z=0;for(n=0;n<=t-2;n+=2,m+=2,h+=2,x+=2){A=o[m];B+=A,z+=A*A;l[h]=l[x]+B;y[h]=y[x]+z;A=o[m+1];B+=A,z+=A*A;l[h+1]=l[x+1]+B;y[h+1]=y[x+1]+z;}for(;n<t;++n,++m,++h,++x){A=o[m];B+=A,z+=A*A;l[h]=l[x]+B;y[h]=y[x]+z;}}}else{if(l){for(;q<r;++q){l[q]=0;}h=(r+1)|0,x=1;for(q=0,m=0;q<w;++q,++h,++x){B=0;for(n=0;n<=t-2;n+=2,m+=2,h+=2,x+=2){B+=o[m];l[h]=l[x]+B;B+=o[m+1];l[h+1]=l[x+1]+B;}for(;n<t;++n,++m,++h,++x){B+=o[m];l[h]=l[x]+B;}}}else{if(y){for(;q<r;++q){y[q]=0;}h=(r+1)|0,x=1;for(q=0,m=0;q<w;++q,++h,++x){z=0;for(n=0;n<=t-2;n+=2,m+=2,h+=2,x+=2){A=o[m];z+=A*A;y[h]=y[x]+z;A=o[m+1];z+=A*A;y[h+1]=y[x+1]+z;}for(;n<t;++n,++m,++h,++x){A=o[m];z+=A*A;y[h]=y[x]+z;}}}}}if(u){for(q=0;q<r;++q){u[q]=0;}h=(r+1)|0,x=0;for(q=0,m=0;q<w;++q,++h,++x){for(n=0;n<=t-2;n+=2,m+=2,h+=2,x+=2){u[h]=o[m]+u[x];u[h+1]=o[m+1]+u[x+1];}for(;n<t;++n,++m,++h,++x){u[h]=o[m]+u[x];}}h=(r+t)|0,x=t;for(q=0;q<w;++q,h+=r,x+=r){u[h]+=u[x];}for(n=t-1;n>0;--n){h=n+w*r,x=h-r;for(q=w;q>0;--q,h-=r,x-=r){u[h]+=u[x]+u[x+1];}}}},equalize_histogram:function(j,r){var s=j.cols,q=j.rows,o=j.data;r.resize(s,q,j.channel);var l=r.data,t=s*q;var p=0,n=0,k,g;var m=jsfeat.cache.get_buffer(256<<2);k=m.i32;for(;p<256;++p){k[p]=0;}for(p=0;p<t;++p){++k[o[p]];}n=k[0];for(p=1;p<256;++p){n=k[p]+=n;}g=255/t;for(p=0;p<t;++p){l[p]=(k[o[p]]*g+0.5)|0;}jsfeat.cache.put_buffer(m);},canny:function(u,V,E,k){var C=u.cols,L=u.rows,S=u.data;V.resize(C,L,u.channel);var o=V.data;var K=0,H=0,q=0,A=C<<1,R=0,J=0,N=0,z=0,v=0,D=0;var g=0,U=0;var p=jsfeat.cache.get_buffer((L*A)<<2);var m=jsfeat.cache.get_buffer((3*(C+2))<<2);var n=jsfeat.cache.get_buffer(((L+2)*(C+2))<<2);var t=jsfeat.cache.get_buffer((L*C)<<2);var Q=m.i32;var T=n.i32;var r=t.i32;var G=p.i32;var l=new jsfeat.matrix_t(C,L,jsfeat.S32C2_t,p.data);var P=1,O=(C+2+1)|0,M=(2*(C+2)+1)|0,B=(C+2)|0,I=(B+1)|0,F=0;this.sobel_derivatives(u,l);if(E>k){K=E;E=k;k=K;}K=(3*(C+2))|0;while(--K>=0){Q[K]=0;}K=((L+2)*(C+2))|0;while(--K>=0){T[K]=0;}for(;H<C;++H,q+=2){z=G[q],v=G[q+1];Q[O+H]=((z^(z>>31))-(z>>31))+((v^(v>>31))-(v>>31));}for(K=1;K<=L;++K,q+=A){if(K==L){H=M+C;while(--H>=M){Q[H]=0;}}else{for(H=0;H<C;H++){z=G[q+(H<<1)],v=G[q+(H<<1)+1];Q[M+H]=((z^(z>>31))-(z>>31))+((v^(v>>31))-(v>>31));}}R=(q-A)|0;T[I-1]=0;J=0;for(H=0;H<C;++H,R+=2){N=Q[O+H];if(N>E){z=G[R];v=G[R+1];D=z^v;z=((z^(z>>31))-(z>>31))|0;v=((v^(v>>31))-(v>>31))|0;g=z*13573;U=g+((z+z)<<15);v<<=15;if(v<g){if(N>Q[O+H-1]&&N>=Q[O+H+1]){if(N>k&&!J&&T[I+H-B]!=2){T[I+H]=2;J=1;r[F++]=I+H;}else{T[I+H]=1;}continue}}else{if(v>U){if(N>Q[P+H]&&N>=Q[M+H]){if(N>k&&!J&&T[I+H-B]!=2){T[I+H]=2;J=1;r[F++]=I+H;}else{T[I+H]=1;}continue}}else{D=D<0?-1:1;if(N>Q[P+H-D]&&N>Q[M+H+D]){if(N>k&&!J&&T[I+H-B]!=2){T[I+H]=2;J=1;r[F++]=I+H;}else{T[I+H]=1;}continue}}}}T[I+H]=0;J=0;}T[I+C]=0;I+=B;H=P;P=O;O=M;M=H;}H=I-B-1;for(K=0;K<B;++K,++H){T[H]=0;}while(F>0){I=r[--F];I-=B+1;if(T[I]==1){T[I]=2,r[F++]=I;}I+=1;if(T[I]==1){T[I]=2,r[F++]=I;}I+=1;if(T[I]==1){T[I]=2,r[F++]=I;}I+=B;if(T[I]==1){T[I]=2,r[F++]=I;}I-=2;if(T[I]==1){T[I]=2,r[F++]=I;}I+=B;if(T[I]==1){T[I]=2,r[F++]=I;}I+=1;if(T[I]==1){T[I]=2,r[F++]=I;}I+=1;if(T[I]==1){T[I]=2,r[F++]=I;}}I=B+1;P=0;for(K=0;K<L;++K,I+=B){for(H=0;H<C;++H){o[P++]=(T[I+H]==2)*255;}}jsfeat.cache.put_buffer(p);jsfeat.cache.put_buffer(m);jsfeat.cache.put_buffer(n);jsfeat.cache.put_buffer(t);},warp_perspective:function(t,D,A,r){if(typeof r==="undefined"){r=0;}var l=t.cols|0,v=t.rows|0,L=D.cols|0,j=D.rows|0;var H=t.data,q=D.data;var F=0,E=0,G=0,u=0,k=0,C=0,p=0,h=0,O=0,P=0,s=0,R=0,Q=0,N=0,M=0;var i=A.data;var o=i[0],n=i[1],m=i[2],K=i[3],J=i[4],I=i[5],B=i[6],z=i[7],w=i[8];for(var g=0;E<j;++E){h=n*E+m,O=J*E+I,P=z*E+w;for(F=0;F<L;++F,++g,h+=o,O+=K,P+=B){s=1/P;C=h*s,p=O*s;u=C|0,k=p|0;if(C>0&&p>0&&u<(l-1)&&k<(v-1)){R=Math.max(C-u,0);Q=Math.max(p-k,0);G=(l*k+u)|0;N=H[G]+R*(H[G+1]-H[G]);M=H[G+l]+R*(H[G+l+1]-H[G+l]);q[g]=N+Q*(M-N);}else{q[g]=r;}}}},warp_affine:function(k,K,p,J){if(typeof J==="undefined"){J=0;}var u=k.cols,z=k.rows,j=K.cols,v=K.rows;var E=k.data,i=K.data;var o=0,n=0,I=0,q=0,A=0,m=0,w=0,G=0,D=0,h=0,g=0;var l=p.data;var t=l[0],s=l[1],r=l[2],H=l[3],F=l[4],C=l[5];for(var B=0;n<v;++n){m=s*n+r;w=F*n+C;for(o=0;o<j;++o,++B,m+=t,w+=H){q=m|0;A=w|0;if(q>=0&&A>=0&&q<(u-1)&&A<(z-1)){G=m-q;D=w-A;I=u*A+q;h=E[I]+G*(E[I+1]-E[I]);g=E[I+u]+G*(E[I+u+1]-E[I+u]);i[B]=h+D*(g-h);}else{i[B]=J;}}}},skindetector:function(o,p){var n,m,h,k;var l=o.width*o.height;while(l--){k=l*4;n=o.data[k];m=o.data[k+1];h=o.data[k+2];if((n>95)&&(m>40)&&(h>20)&&(n>m)&&(n>h)&&(n-Math.min(m,h)>15)&&(Math.abs(n-m)>15)){p[l]=255;}else{p[l]=0;}}}}})();b.imgproc=a;})(jsfeat);(function(a){var b=(function(){var h=new Int32Array([0,3,1,3,2,2,3,1,3,0,3,-1,2,-2,1,-3,0,-3,-1,-3,-2,-2,-3,-1,-3,0,-3,1,-2,2,-1,3]);var f=new Uint8Array(512);var e=new Int32Array(25);var i=new Int32Array(25);var d=function(l,n,o){var j=0;var m=h;for(;j<o;++j){l[j]=m[j<<1]+m[(j<<1)+1]*n;}for(;j<25;++j){l[j]=l[j-o];}},g=function(j,n,l,r,p){var q=25,o=0,w=j[n];var m=p,t=0,u=0,s=0;for(;o<q;++o){r[o]=w-j[n+l[o]];}for(o=0;o<16;o+=2){t=Math.min(r[o+1],r[o+2]);t=Math.min(t,r[o+3]);if(t<=m){continue}t=Math.min(t,r[o+4]);t=Math.min(t,r[o+5]);t=Math.min(t,r[o+6]);t=Math.min(t,r[o+7]);t=Math.min(t,r[o+8]);m=Math.max(m,Math.min(t,r[o]));m=Math.max(m,Math.min(t,r[o+9]));}u=-m;for(o=0;o<16;o+=2){s=Math.max(r[o+1],r[o+2]);s=Math.max(s,r[o+3]);s=Math.max(s,r[o+4]);s=Math.max(s,r[o+5]);if(s>=u){continue}s=Math.max(s,r[o+6]);s=Math.max(s,r[o+7]);s=Math.max(s,r[o+8]);u=Math.min(u,Math.max(s,r[o]));u=Math.min(u,Math.max(s,r[o+9]));}return -u-1};var c=20;return{set_threshold:function(j){c=Math.min(Math.max(j,0),255);for(var k=-255;k<=255;++k){f[(k+255)]=(k<-c?1:(k>c?2:0));}return c},detect:function(L,H,D){if(typeof D==="undefined"){D=3;}var A=8,t=25;var u=L.data,X=L.cols,ar=L.rows;var ap=0,an=0,al=0,E=0,W=0,aq=0;var B=jsfeat.cache.get_buffer(3*X);var O=jsfeat.cache.get_buffer(((X+1)*3)<<2);var I=B.u8;var F=O.i32;var M=e;var J=i;var y=Math.max(3,D);var Z=Math.min((ar-2),(ar-D));var z=Math.max(3,D);var aa=Math.min((X-3),(X-D));var ah=0,P=0,C;var Q=g;var G=f;var p=c;var Y=0,ao=0,au=0,aw=0,U=0,V=0,av=0,R=0,at=0;var T=0,S=0,o=0;d(M,X,16);var am=M[0];var ak=M[1];var aj=M[2];var ai=M[3];var ag=M[4];var af=M[5];var ae=M[6];var ad=M[7];var ac=M[8];var ab=M[9];var s=M[10];var r=M[11];var q=M[12];var n=M[13];var m=M[14];var l=M[15];for(ap=0;ap<X*3;++ap){I[ap]=0;}for(ap=y;ap<Z;++ap){av=((ap*X)+z)|0;aq=(ap-3)%3;V=(aq*X)|0;U=(aq*(X+1))|0;for(an=0;an<X;++an){I[V+an]=0;}aw=0;if(ap<(Z-1)){an=z;for(;an<aa;++an,++av){Y=u[av];ao=(-Y+255);au=(G[ao+u[av+am]]|G[ao+u[av+ac]]);if(au==0){continue}au&=(G[ao+u[av+aj]]|G[ao+u[av+s]]);au&=(G[ao+u[av+ag]]|G[ao+u[av+q]]);au&=(G[ao+u[av+ae]]|G[ao+u[av+m]]);if(au==0){continue}au&=(G[ao+u[av+ak]]|G[ao+u[av+ab]]);au&=(G[ao+u[av+ai]]|G[ao+u[av+r]]);au&=(G[ao+u[av+af]]|G[ao+u[av+n]]);au&=(G[ao+u[av+ad]]|G[ao+u[av+l]]);if(au&1){E=(Y-p);ah=0;for(al=0;al<t;++al){W=u[(av+M[al])];if(W<E){++ah;if(ah>A){++aw;F[U+aw]=an;I[V+an]=Q(u,av,M,J,p);break}}else{ah=0;}}}if(au&2){E=(Y+p);ah=0;for(al=0;al<t;++al){W=u[(av+M[al])];if(W>E){++ah;if(ah>A){++aw;F[U+aw]=an;I[V+an]=Q(u,av,M,J,p);break}}else{ah=0;}}}}}F[U+X]=aw;if(ap==y){continue}aq=(ap-4+3)%3;R=(aq*X)|0;U=(aq*(X+1))|0;aq=(ap-5+3)%3;at=(aq*X)|0;aw=F[U+X];for(al=0;al<aw;++al){an=F[U+al];T=(an+1)|0;S=(an-1)|0;o=I[R+an];if((o>I[R+T]&&o>I[R+S]&&o>I[at+S]&&o>I[at+an]&&o>I[at+T]&&o>I[V+S]&&o>I[V+an]&&o>I[V+T])){C=H[P];C.x=an,C.y=(ap-1),C.score=o;P++;}}}jsfeat.cache.put_buffer(B);jsfeat.cache.put_buffer(O);return P}}})();a.fast_corners=b;b.set_threshold(20);})(jsfeat);(function(b){var a=(function(){var d=function(e,l,q,i,r,g,p,n,k,j){var m=0,o=0,f=(n*q+p)|0,s=f;for(m=n;m<j;++m,f+=q,s=f){for(o=p;o<k;++o,++s){l[s]=-4*e[s]+e[s+r]+e[s-r]+e[s+g]+e[s-g];}}};var c=function(e,f,k,m,g,l,h){var o=-2*e[f]+e[f+m]+e[f-m];var i=-2*e[f]+e[f+g]+e[f-g];var n=e[f+l]+e[f-l]-e[f+h]-e[f-h];var j=(Math.sqrt(((o-i)*(o-i)+4*n*n)))|0;return Math.min(Math.abs(k-j),Math.abs(-(k+j)))};return{laplacian_threshold:30,min_eigen_value_threshold:25,detect:function(l,A,z){if(typeof z==="undefined"){z=5;}var o=0,n=0;var p=l.cols,B=l.rows,q=l.data;var H=5,f=(5*p)|0;var G=(3+3*p)|0,g=(3-3*p)|0;var e=jsfeat.cache.get_buffer((p*B)<<2);var j=e.i32;var i=0,k=0,m=0,r=0,v;var u=0;var F=this.laplacian_threshold;var D=this.min_eigen_value_threshold;var t=Math.max(5,z)|0;var s=Math.max(3,z)|0;var E=Math.min(p-5,p-z)|0;var C=Math.min(B-3,B-z)|0;o=p*B;while(--o>=0){j[o]=0;}d(q,j,p,B,H,f,t,s,E,C);k=(s*p+t)|0;for(n=s;n<C;++n,k+=p){for(o=t,m=k;o<E;++o,++m){i=j[m];if((i<-F&&i<j[m-1]&&i<j[m+1]&&i<j[m-p]&&i<j[m+p]&&i<j[m-p-1]&&i<j[m+p-1]&&i<j[m-p+1]&&i<j[m+p+1])||(i>F&&i>j[m-1]&&i>j[m+1]&&i>j[m-p]&&i>j[m+p]&&i>j[m-p-1]&&i>j[m+p-1]&&i>j[m-p+1]&&i>j[m+p+1])){r=c(q,m,i,H,f,G,g);if(r>D){v=A[u];v.x=o,v.y=n,v.score=r;++u;++o,++m;}}}}jsfeat.cache.put_buffer(e);return u}}})();b.yape06=a;})(jsfeat);(function(a){var b=(function(){var d=function(l,m,k){var j=0;var h,n;h=k;for(n=0;n<h;n++,j++){h=(Math.sqrt((k*k-n*n))+0.5)|0;m[j]=(h+l*n);}for(h--;h<n&&h>=0;h--,j++){n=(Math.sqrt((k*k-h*h))+0.5)|0;m[j]=(h+l*n);}for(;-h<n;h--,j++){n=(Math.sqrt((k*k-h*h))+0.5)|0;m[j]=(h+l*n);}for(n--;n>=0;n--,j++){h=(-Math.sqrt((k*k-n*n))-0.5)|0;m[j]=(h+l*n);}for(;n>h;n--,j++){h=(-Math.sqrt((k*k-n*n))-0.5)|0;m[j]=(h+l*n);}for(h++;h<=0;h++,j++){n=(-Math.sqrt((k*k-h*h))-0.5)|0;m[j]=(h+l*n);}for(;h<-n;h++,j++){n=(-Math.sqrt((k*k-h*h))-0.5)|0;m[j]=(h+l*n);}for(n++;n<0;n++,j++){h=(Math.sqrt((k*k-n*n))+0.5)|0;m[j]=(h+l*n);}m[j]=m[0];m[j+1]=m[1];return j};var g=function(h,j,i){var k=0;if(h[j+1]!=0){k++;}if(h[j-1]!=0){k++;}if(h[j+i]!=0){k++;}if(h[j+i+1]!=0){k++;}if(h[j+i-1]!=0){k++;}if(h[j-i]!=0){k++;}if(h[j-i+1]!=0){k++;}if(h[j-i-1]!=0){k++;}return k};var c=function(l,m,i,k,j){var h,n;if(i>0){m-=k*j;for(n=-j;n<=j;++n){for(h=-j;h<=j;++h){if(l[m+h]>i){return false}}m+=k;}}else{m-=k*j;for(n=-j;n<=j;++n){for(h=-j;h<=j;++h){if(l[m+h]<i){return false}}m+=k;}}return true};var e=function(s,r,m,u,p,i,l,n){var k=0;var q=0,o=(l-1)|0;var j=0,w=0,v=0,t=0;var h=0;j=s[r+i[q]];if((j<=p)){if((j>=u)){w=s[r+i[o]];if((w<=p)){if((w>=u)){m[r]=0;return}else{o++;v=s[r+i[o]];if((v>p)){o++;t=s[r+i[o]];if((t>p)){h=3;}else{if((t<u)){h=6;}else{m[r]=0;return}}}else{o++;t=s[r+i[o]];if((t>p)){h=7;}else{if((t<u)){h=2;}else{m[r]=0;return}}}}}else{o++;v=s[r+i[o]];if((v>p)){o++;t=s[r+i[o]];if((t>p)){h=3;}else{if((t<u)){h=6;}else{m[r]=0;return}}}else{if((v<u)){o++;t=s[r+i[o]];if((t>p)){h=7;}else{if((t<u)){h=2;}else{m[r]=0;return}}}else{m[r]=0;return}}}}else{w=s[r+i[o]];if((w>p)){m[r]=0;return}o++;v=s[r+i[o]];if((v>p)){m[r]=0;return}o++;t=s[r+i[o]];if((t>p)){m[r]=0;return}h=1;}}else{w=s[r+i[o]];if((w<u)){m[r]=0;return}o++;v=s[r+i[o]];if((v<u)){m[r]=0;return}o++;t=s[r+i[o]];if((t<u)){m[r]=0;return}h=0;}for(q=1;q<=l;q++){j=s[r+i[q]];switch(h){case 0:if((j>p)){v=t;o++;t=s[r+i[o]];if((t<u)){m[r]=0;return}k-=j+v;h=0;break}if((j<u)){if((v>p)){m[r]=0;return}if((t>p)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t>p)){m[r]=0;return}k-=j+v;h=8;break}if((v<=p)){m[r]=0;return}if((t<=p)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t>p)){k-=j+v;h=3;break}if((t<u)){k-=j+v;h=6;break}m[r]=0;return;case 1:if((j<u)){v=t;o++;t=s[r+i[o]];if((t>p)){m[r]=0;return}k-=j+v;h=1;break}if((j>p)){if((v<u)){m[r]=0;return}if((t<u)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t<u)){m[r]=0;return}k-=j+v;h=9;break}if((v>=u)){m[r]=0;return}if((t>=u)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t<u)){k-=j+v;h=2;break}if((t>p)){k-=j+v;h=7;break}m[r]=0;return;case 2:if((j>p)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((j<u)){if((t>p)){m[r]=0;return}k-=j+v;h=4;break}if((t>p)){k-=j+v;h=7;break}if((t<u)){k-=j+v;h=2;break}m[r]=0;return;case 3:if((j<u)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((j>p)){if((t<u)){m[r]=0;return}k-=j+v;h=5;break}if((t>p)){k-=j+v;h=3;break}if((t<u)){k-=j+v;h=6;break}m[r]=0;return;case 4:if((j>p)){m[r]=0;return}if((j<u)){v=t;o++;t=s[r+i[o]];if((t>p)){m[r]=0;return}k-=j+v;h=1;break}if((t>=u)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t<u)){k-=j+v;h=2;break}if((t>p)){k-=j+v;h=7;break}m[r]=0;return;case 5:if((j<u)){m[r]=0;return}if((j>p)){v=t;o++;t=s[r+i[o]];if((t<u)){m[r]=0;return}k-=j+v;h=0;break}if((t<=p)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t>p)){k-=j+v;h=3;break}if((t<u)){k-=j+v;h=6;break}m[r]=0;return;case 7:if((j>p)){m[r]=0;return}if((j<u)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t>p)){k-=j+v;h=3;break}if((t<u)){k-=j+v;h=6;break}m[r]=0;return;case 6:if((j>p)){m[r]=0;return}if((j<u)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t<u)){k-=j+v;h=2;break}if((t>p)){k-=j+v;h=7;break}m[r]=0;return;case 8:if((j>p)){if((t<u)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t<u)){m[r]=0;return}k-=j+v;h=9;break}if((j<u)){v=t;o++;t=s[r+i[o]];if((t>p)){m[r]=0;return}k-=j+v;h=1;break}m[r]=0;return;case 9:if((j<u)){if((t>p)){m[r]=0;return}v=t;o++;t=s[r+i[o]];if((t>p)){m[r]=0;return}k-=j+v;h=8;break}if((j>p)){v=t;o++;t=s[r+i[o]];if((t<u)){m[r]=0;return}k-=j+v;h=0;break}m[r]=0;return;default:break}}m[r]=(k+n*s[r]);};var f=(function(){function h(i,j,k){this.dirs=new Int32Array(1024);this.dirs_count=d(i,this.dirs,k)|0;this.scores=new Int32Array(i*j);this.radius=k|0;}return h})();return{level_tables:[],tau:7,init:function(m,j,h,l){if(typeof l==="undefined"){l=1;}var k;h=Math.min(h,7);h=Math.max(h,3);for(k=0;k<l;++k){this.level_tables[k]=new f(m>>k,j>>k,h);}},detect:function(k,J,G){if(typeof G==="undefined"){G=4;}var A=this.level_tables[0];var i=A.radius|0,q=(i-1)|0;var m=A.dirs;var n=A.dirs_count|0;var v=n>>1;var O=k.data,u=k.cols|0,K=k.rows|0,N=u>>1;var H=A.scores;var s=0,r=0,j=0,l=0,o=0,p=0,z=0,I=0;var F=this.tau|0;var D=0,E;var C=Math.max(i+1,G)|0;var B=Math.max(i+1,G)|0;var M=Math.min(u-i-2,u-G)|0;var L=Math.min(K-i-2,K-G)|0;j=(B*u+C)|0;for(r=B;r<L;++r,j+=u){for(s=C,l=j;s<M;++s,++l){o=O[l]+F,p=O[l]-F;if(p<O[l+i]&&O[l+i]<o&&p<O[l-i]&&O[l-i]<o){H[l]=0;}else{e(O,l,H,p,o,m,v,n);}}}j=(B*u+C)|0;for(r=B;r<L;++r,j+=u){for(s=C,l=j;s<M;++s,++l){I=H[l];z=Math.abs(I);if(z<5){++s,++l;}else{if(g(H,l,u)>=3&&c(H,l,I,N,i)){E=J[D];E.x=s,E.y=r,E.score=z;++D;s+=q,l+=q;}}}}return D}}})();a.yape=b;})(jsfeat);(function(b){var a=(function(){var d=new Int32Array([8,-3,9,5,4,2,7,-12,-11,9,-8,2,7,-12,12,-13,2,-13,2,12,1,-7,1,6,-2,-10,-2,-4,-13,-13,-11,-8,-13,-3,-12,-9,10,4,11,9,-13,-8,-8,-9,-11,7,-9,12,7,7,12,6,-4,-5,-3,0,-13,2,-12,-3,-9,0,-7,5,12,-6,12,-1,-3,6,-2,12,-6,-13,-4,-8,11,-13,12,-8,4,7,5,1,5,-3,10,-3,3,-7,6,12,-8,-7,-6,-2,-2,11,-1,-10,-13,12,-8,10,-7,3,-5,-3,-4,2,-3,7,-10,-12,-6,11,5,-12,6,-7,5,-6,7,-1,1,0,4,-5,9,11,11,-13,4,7,4,12,2,-1,4,4,-4,-12,-2,7,-8,-5,-7,-10,4,11,9,12,0,-8,1,-13,-13,-2,-8,2,-3,-2,-2,3,-6,9,-4,-9,8,12,10,7,0,9,1,3,7,-5,11,-10,-13,-6,-11,0,10,7,12,1,-6,-3,-6,12,10,-9,12,-4,-13,8,-8,-12,-13,0,-8,-4,3,3,7,8,5,7,10,-7,-1,7,1,-12,3,-10,5,6,2,-4,3,-10,-13,0,-13,5,-13,-7,-12,12,-13,3,-11,8,-7,12,-4,7,6,-10,12,8,-9,-1,-7,-6,-2,-5,0,12,-12,5,-7,5,3,-10,8,-13,-7,-7,-4,5,-3,-2,-1,-7,2,9,5,-11,-11,-13,-5,-13,-1,6,0,-1,5,-3,5,2,-4,-13,-4,12,-9,-6,-9,6,-12,-10,-8,-4,10,2,12,-3,7,12,12,12,-7,-13,-6,5,-4,9,-3,4,7,-1,12,2,-7,6,-5,1,-13,11,-12,5,-3,7,-2,-6,7,-8,12,-7,-13,-7,-11,-12,1,-3,12,12,2,-6,3,0,-4,3,-2,-13,-1,-13,1,9,7,1,8,-6,1,-1,3,12,9,1,12,6,-1,-9,-1,3,-13,-13,-10,5,7,7,10,12,12,-5,12,9,6,3,7,11,5,-13,6,10,2,-12,2,3,3,8,4,-6,2,6,12,-13,9,-12,10,3,-8,4,-7,9,-11,12,-4,-6,1,12,2,-8,6,-9,7,-4,2,3,3,-2,6,3,11,0,3,-3,8,-8,7,8,9,3,-11,-5,-6,-4,-10,11,-5,10,-5,-8,-3,12,-10,5,-9,0,8,-1,12,-6,4,-6,6,-11,-10,12,-8,7,4,-2,6,7,-2,0,-2,12,-5,-8,-5,2,7,-6,10,12,-9,-13,-8,-8,-5,-13,-5,-2,8,-8,9,-13,-9,-11,-9,0,1,-8,1,-2,7,-4,9,1,-2,1,-1,-4,11,-6,12,-11,-12,-9,-6,4,3,7,7,12,5,5,10,8,0,-4,2,8,-9,12,-5,-13,0,7,2,12,-1,2,1,7,5,11,7,-9,3,5,6,-8,-13,-4,-8,9,-5,9,-3,-3,-4,-7,-3,-12,6,5,8,0,-7,6,-6,12,-13,6,-5,-2,1,-10,3,10,4,1,8,-4,-2,-2,2,-13,2,-12,12,12,-2,-13,0,-6,4,1,9,3,-6,-10,-3,-5,-3,-13,-1,1,7,5,12,-11,4,-2,5,-7,-13,9,-9,-5,7,1,8,6,7,-8,7,6,-7,-4,-7,1,-8,11,-7,-8,-13,6,-12,-8,2,4,3,9,10,-5,12,3,-6,-5,-6,7,8,-3,9,-8,2,-12,2,8,-11,-2,-10,3,-12,-13,-7,-9,-11,0,-10,-5,5,-3,11,8,-2,-13,-1,12,-1,-8,0,9,-13,-11,-12,-5,-10,-2,-10,11,-3,9,-2,-13,2,-3,3,2,-9,-13,-4,0,-4,6,-3,-10,-4,12,-2,-7,-6,-11,-4,9,6,-3,6,11,-13,11,-5,5,11,11,12,6,7,-5,12,-2,-1,12,0,7,-4,-8,-3,-2,-7,1,-6,7,-13,-12,-8,-13,-7,-2,-6,-8,-8,5,-6,-9,-5,-1,-4,5,-13,7,-8,10,1,5,5,-13,1,0,10,-13,9,12,10,-1,5,-8,10,-9,-1,11,1,-13,-9,-3,-6,2,-1,-10,1,12,-13,1,-8,-10,8,-11,10,-6,2,-13,3,-6,7,-13,12,-9,-10,-10,-5,-7,-10,-8,-8,-13,4,-6,8,5,3,12,8,-13,-4,2,-3,-3,5,-13,10,-12,4,-13,5,-1,-9,9,-4,3,0,3,3,-9,-12,1,-6,1,3,2,4,-8,-10,-10,-10,9,8,-13,12,12,-8,-12,-6,-5,2,2,3,7,10,6,11,-8,6,8,8,-12,-7,10,-6,5,-3,-9,-3,9,-1,-13,-1,5,-3,-7,-3,4,-8,-2,-8,3,4,2,12,12,2,-5,3,11,6,-9,11,-13,3,-1,7,12,11,-1,12,4,-3,0,-3,6,4,-11,4,12,2,-4,2,1,-10,-6,-8,1,-13,7,-11,1,-13,12,-11,-13,6,0,11,-13,0,-1,1,4,-13,3,-9,-2,-9,8,-6,-3,-13,-6,-8,-2,5,-9,8,10,2,7,3,-9,-1,-6,-1,-1,9,5,11,-2,11,-3,12,-8,3,0,3,5,-1,4,0,10,3,-6,4,5,-13,0,-10,5,5,8,12,11,8,9,9,-6,7,-4,8,-12,-10,4,-10,9,7,3,12,4,9,-7,10,-2,7,0,12,-2,-1,-6,0,-11]);var c=new jsfeat.matrix_t(3,3,jsfeat.F32_t|jsfeat.C1_t);var f=new jsfeat.matrix_t(32,32,jsfeat.U8_t|jsfeat.C1_t);var e=function(l,n,k,i,h,j){var m=Math.cos(k);var g=Math.sin(k);c.data[0]=m,c.data[1]=-g,c.data[2]=(-m+g)*j*0.5+i,c.data[3]=g,c.data[4]=m,c.data[5]=(-g-m)*j*0.5+h;jsfeat.imgproc.warp_affine(l,n,c,128);};return{describe:function(j,u,g,B){var r=32;var x=0,A=0,q=0,p=0,z=0;var o=0,m=0,D=0;var C=j.data,n=j.cols,y=j.rows;var t=f.data;var v=16*32+16;var k=0;if(!(B.type&jsfeat.U8_t)){B.type=jsfeat.U8_t;B.cols=r;B.rows=g;B.channel=1;B.allocate();}else{B.resize(r,g,1);}var l=B.data;var s=0;for(x=0;x<g;++x){q=u[x].x;p=u[x].y;z=u[x].angle;e(j,f,z,q,p,32);k=0;for(A=0;A<r;++A){o=t[v+d[k+1]*32+d[k]];k+=2;m=t[v+d[k+1]*32+d[k]];k+=2;D=(o<m)|0;o=t[v+d[k+1]*32+d[k]];k+=2;m=t[v+d[k+1]*32+d[k]];k+=2;D|=(o<m)<<1;o=t[v+d[k+1]*32+d[k]];k+=2;m=t[v+d[k+1]*32+d[k]];k+=2;D|=(o<m)<<2;o=t[v+d[k+1]*32+d[k]];k+=2;m=t[v+d[k+1]*32+d[k]];k+=2;D|=(o<m)<<3;o=t[v+d[k+1]*32+d[k]];k+=2;m=t[v+d[k+1]*32+d[k]];k+=2;D|=(o<m)<<4;o=t[v+d[k+1]*32+d[k]];k+=2;m=t[v+d[k+1]*32+d[k]];k+=2;D|=(o<m)<<5;o=t[v+d[k+1]*32+d[k]];k+=2;m=t[v+d[k+1]*32+d[k]];k+=2;D|=(o<m)<<6;o=t[v+d[k+1]*32+d[k]];k+=2;m=t[v+d[k+1]*32+d[k]];k+=2;D|=(o<m)<<7;l[s+A]=D;}s+=r;}}}})();b.orb=a;})(jsfeat);(function(b){var a=(function(){var c=jsfeat.imgproc.scharr_derivatives;return{track:function(n,u,ap,aL,k,N,R,K,f,q){if(typeof R==="undefined"){R=30;}if(typeof K==="undefined"){K=new Uint8Array(k);}if(typeof f==="undefined"){f=0.01;}if(typeof q==="undefined"){q=0.0001;}var e=(N-1)*0.5;var h=(N*N)|0;var aa=h<<1;var r=n.data,S=u.data;var g=r[0].data,F=S[0].data;var M=r[0].cols,aB=r[0].rows,ay=0,aH=0;var az=jsfeat.cache.get_buffer(h<<2);var s=jsfeat.cache.get_buffer(aa<<2);var t=jsfeat.cache.get_buffer((aB*(M<<1))<<2);var V=new jsfeat.matrix_t(M,aB,jsfeat.S32C2_t,t.data);var w=az.i32;var ac=s.i32;var aA=t.i32;var ab=0,I=0,aM=0,at=0,aI=0,au=0;var am=0,aF=0,aD=0,af=0,ae=0;var E=0,z=0,Y=0,W=0;var p=0,o=0,aE=0,aC=0;var Q=0,P=0,J=0,H=0,ai=0,ak=0,l=0;var d=0,A=0,O=0;var U=0,T=0,aw=0,av=0;var ah=14;var C=14;var Z=C-5;var ax=(1<<((Z)-1));var ad=(1<<ah);var m=(1<<((C)-1));var X=1/(1<<20);var aK=0,aJ=0,ar=0,aq=0,al=0,v=0,B=0;var ao=0,an=0,ag=0,aj=0,aG=0;var G=1.1920929e-7;f*=f;for(;Q<k;++Q){K[Q]=1;}var L=(n.levels-1)|0;ai=L;for(;ai>=0;--ai){am=(1/(1<<ai));ay=M>>ai;aH=aB>>ai;ab=ay<<1;g=r[ai].data;F=S[ai].data;A=(ay-N)|0;O=(aH-N)|0;c(r[ai],V);for(ak=0;ak<k;++ak){Q=ak<<1;P=Q+1;aF=ap[Q]*am;aD=ap[P]*am;if(ai==L){af=aF;ae=aD;}else{af=aL[Q]*2;ae=aL[P]*2;}aL[Q]=af;aL[P]=ae;aF-=e;aD-=e;p=aF|0;o=aD|0;J=(p<=d)|(p>=A)|(o<=d)|(o>=O);if(J!=0){if(ai==0){K[ak]=0;}continue}U=aF-p;T=aD-o;aK=(((1-U)*(1-T)*ad)+0.5)|0;aJ=((U*(1-T)*ad)+0.5)|0;ar=(((1-U)*T*ad)+0.5)|0;aq=(ad-aK-aJ-ar);ao=0,an=0,ag=0;for(H=0;H<N;++H){I=((H+o)*ay+p)|0;aM=I<<1;at=(H*N)|0;aI=at<<1;for(J=0;J<N;++J,++I,++at,aM+=2){al=((g[I])*aK+(g[I+1])*aJ+(g[I+ay])*ar+(g[I+ay+1])*aq);al=(((al)+ax)>>(Z));v=(aA[aM]*aK+aA[aM+2]*aJ+aA[aM+ab]*ar+aA[aM+ab+2]*aq);v=(((v)+m)>>(C));B=(aA[aM+1]*aK+aA[aM+3]*aJ+aA[aM+ab+1]*ar+aA[aM+ab+3]*aq);B=(((B)+m)>>(C));w[at]=al;ac[aI++]=v;ac[aI++]=B;ao+=v*v;an+=v*B;ag+=B*B;}}ao*=X;an*=X;ag*=X;aj=ao*ag-an*an;aG=(ag+ao-Math.sqrt((ao-ag)*(ao-ag)+4*an*an))/aa;if(aG<q||aj<G){if(ai==0){K[ak]=0;}continue}aj=1/aj;af-=e;ae-=e;E=0;z=0;for(l=0;l<R;++l){aE=af|0;aC=ae|0;J=(aE<=d)|(aE>=A)|(aC<=d)|(aC>=O);if(J!=0){if(ai==0){K[ak]=0;}break}U=af-aE;T=ae-aC;aK=(((1-U)*(1-T)*ad)+0.5)|0;aJ=((U*(1-T)*ad)+0.5)|0;ar=(((1-U)*T*ad)+0.5)|0;aq=(ad-aK-aJ-ar);aw=0,av=0;for(H=0;H<N;++H){au=((H+aC)*ay+aE)|0;at=(H*N)|0;aI=at<<1;for(J=0;J<N;++J,++au,++at){al=((F[au])*aK+(F[au+1])*aJ+(F[au+ay])*ar+(F[au+ay+1])*aq);al=(((al)+ax)>>(Z));al=(al-w[at]);aw+=al*ac[aI++];av+=al*ac[aI++];}}aw*=X;av*=X;Y=((an*av-ag*aw)*aj);W=((an*aw-ao*av)*aj);af+=Y;ae+=W;aL[Q]=af+e;aL[P]=ae+e;if(Y*Y+W*W<=f){break}if(l>0&&Math.abs(Y+E)<0.01&&Math.abs(W+z)<0.01){aL[Q]-=Y*0.5;aL[P]-=W*0.5;break}E=Y;z=W;}}}jsfeat.cache.put_buffer(az);jsfeat.cache.put_buffer(s);jsfeat.cache.put_buffer(t);}}})();b.optical_flow_lk=a;})(jsfeat);(function(b){var a=(function(){var c=function(e,d){var f=(e.width*0.25+0.5)|0;return d.x<=e.x+f&&d.x>=e.x-f&&d.y<=e.y+f&&d.y>=e.y-f&&d.width<=(e.width*1.5+0.5)|0&&(d.width*1.5+0.5)|0>=e.width};return{edges_density:0.07,detect_single_scale:function(E,ad,af,q,d,f,D,B){var z=(B.size[0]*D)|0,N=(B.size[1]*D)|0,V=(0.5*D+1.5)|0,U=V;var Z,X,W,Q,O,T=(d-z)|0,R=(f-N)|0;var H=(d+1)|0,w,p,r,S;var e=1/(z*N);var t,o,l,u,s,ae,A,g=true,L,h,n,G,m;var M,K,J,I,v,C;var ac=0,ab=z,aa=N*H,Y=aa+z;var F=((z*N)*255*this.edges_density)|0;var P=[];for(O=0;O<R;O+=U){ac=O*H;for(Q=0;Q<T;Q+=V,ac+=V){p=E[ac]-E[ac+ab]-E[ac+aa]+E[ac+Y];if(q){w=(q[ac]-q[ac+ab]-q[ac+aa]+q[ac+Y]);if(w<F||p<20){Q+=V,ac+=V;continue}}p*=e;r=(ad[ac]-ad[ac+ab]-ad[ac+aa]+ad[ac+Y])*e-p*p;S=r>0?Math.sqrt(r):1;t=B.complexClassifiers;s=t.length;g=true;for(Z=0;Z<s;++Z){o=t[Z];L=o.threshold;l=o.simpleClassifiers;ae=l.length;h=0;for(X=0;X<ae;++X){u=l[X];n=0;m=u.features;A=m.length;if(u.tilted===1){for(W=0;W<A;++W){G=m[W];M=~~(Q+G[0]*D)+~~(O+G[1]*D)*H;v=~~(G[2]*D);C=~~(G[3]*D);K=v*H;J=C*H;n+=(af[M]-af[M+v+K]-af[M-C+J]+af[M+v-C+K+J])*G[4];}}else{for(W=0;W<A;++W){G=m[W];M=~~(Q+G[0]*D)+~~(O+G[1]*D)*H;v=~~(G[2]*D);C=~~(G[3]*D);J=C*H;n+=(E[M]-E[M+v]-E[M+J]+E[M+J+v])*G[4];}}h+=(n*e<u.threshold*S)?u.left_val:u.right_val;}if(h<L){g=false;break}}if(g){P.push({x:Q,y:O,width:z,height:N,neighbor:1,confidence:h});Q+=V,ac+=V;}}}return P},detect_multi_scale:function(e,m,f,h,d,n,i,g,k){if(typeof g==="undefined"){g=1.2;}if(typeof k==="undefined"){k=1;}var o=i.size[0];var j=i.size[1];var l=[];while(k*o<d&&k*j<n){l=l.concat(this.detect_single_scale(e,m,f,h,d,n,k,i));k*=g;}return l},group_rectangles:function(g,l){if(typeof l==="undefined"){l=1;}var y,v,q=g.length;var r=[];for(y=0;y<q;++y){r[y]={parent:-1,element:g[y],rank:0};}for(y=0;y<q;++y){if(!r[y].element){continue}var t=y;while(r[t].parent!=-1){t=r[t].parent;}for(v=0;v<q;++v){if(y!=v&&r[v].element&&c(r[y].element,r[v].element)){var s=v;while(r[s].parent!=-1){s=r[s].parent;}if(s!=t){if(r[t].rank>r[s].rank){r[s].parent=t;}else{r[t].parent=s;if(r[t].rank==r[s].rank){r[s].rank++;}t=s;}var A,d=v;while(r[d].parent!=-1){A=d;d=r[d].parent;r[A].parent=t;}d=y;while(r[d].parent!=-1){A=d;d=r[d].parent;r[A].parent=t;}}}}}var w=[];var o=0;for(y=0;y<q;y++){v=-1;var e=y;if(r[e].element){while(r[e].parent!=-1){e=r[e].parent;}if(r[e].rank>=0){r[e].rank=~o++;}v=~r[e].rank;}w[y]=v;}var m=[];for(y=0;y<o+1;++y){m[y]={neighbors:0,x:0,y:0,width:0,height:0,confidence:0};}for(y=0;y<q;++y){var z=g[y];var k=w[y];if(m[k].neighbors==0){m[k].confidence=z.confidence;}++m[k].neighbors;m[k].x+=z.x;m[k].y+=z.y;m[k].width+=z.width;m[k].height+=z.height;m[k].confidence=Math.max(m[k].confidence,z.confidence);}var h=[];for(y=0;y<o;++y){q=m[y].neighbors;if(q>=l){h.push({x:(m[y].x*2+q)/(2*q),y:(m[y].y*2+q)/(2*q),width:(m[y].width*2+q)/(2*q),height:(m[y].height*2+q)/(2*q),neighbors:m[y].neighbors,confidence:m[y].confidence});}}var p=[];q=h.length;for(y=0;y<q;++y){var z=h[y];var x=true;for(v=0;v<q;++v){var u=h[v];var f=(u.width*0.25+0.5)|0;if(y!=v&&z.x>=u.x-f&&z.y>=u.y-f&&z.x+z.width<=u.x+u.width+f&&z.y+z.height<=u.y+u.height+f&&(u.neighbors>Math.max(3,z.neighbors)||z.neighbors<3)){x=false;break}}if(x){p.push(z);}}return p}}})();b.haar=a;})(jsfeat);(function(a){var b=(function(){var c=function(f,e){var g=(f.width*0.25+0.5)|0;return e.x<=f.x+g&&e.x>=f.x-g&&e.y<=f.y+g&&e.y>=f.y-g&&e.width<=(f.width*1.5+0.5)|0&&(e.width*1.5+0.5)|0>=f.width};var d=new jsfeat.pyramid_t(1);return{interval:4,scale:1.1486,next:5,scale_to:1,prepare_cascade:function(g){var m=g.stage_classifier.length;for(var h=0;h<m;h++){var l=g.stage_classifier[h].feature;var e=g.stage_classifier[h].count;var i=g.stage_classifier[h]._feature=new Array(e);for(var f=0;f<e;f++){i[f]={size:l[f].size,px:new Array(l[f].size),pz:new Array(l[f].size),nx:new Array(l[f].size),nz:new Array(l[f].size)};}}},build_pyramid:function(e,k,s,f){if(typeof f==="undefined"){f=4;}var q=e.cols,m=e.rows;var l=0,n=0,h=0;var p=false;var j=e,g=e;var r=jsfeat.U8_t|jsfeat.C1_t;this.interval=f;this.scale=Math.pow(2,1/(this.interval+1));this.next=(this.interval+1)|0;this.scale_to=(Math.log(Math.min(q/k,m/s))/Math.log(this.scale))|0;var o=((this.scale_to+this.next*2)*4)|0;if(d.levels!=o){d.levels=o;d.data=new Array(o);p=true;d.data[0]=e;}for(l=1;l<=this.interval;++l){n=(q/Math.pow(this.scale,l))|0;h=(m/Math.pow(this.scale,l))|0;j=d.data[l<<2];if(p||n!=j.cols||h!=j.rows){d.data[l<<2]=new jsfeat.matrix_t(n,h,r);j=d.data[l<<2];}jsfeat.imgproc.resample(e,j,n,h);}for(l=this.next;l<this.scale_to+this.next*2;++l){g=d.data[(l<<2)-(this.next<<2)];j=d.data[l<<2];n=g.cols>>1;h=g.rows>>1;if(p||n!=j.cols||h!=j.rows){d.data[l<<2]=new jsfeat.matrix_t(n,h,r);j=d.data[l<<2];}jsfeat.imgproc.pyrdown(g,j);}for(l=this.next*2;l<this.scale_to+this.next*2;++l){g=d.data[(l<<2)-(this.next<<2)];n=g.cols>>1;h=g.rows>>1;j=d.data[(l<<2)+1];if(p||n!=j.cols||h!=j.rows){d.data[(l<<2)+1]=new jsfeat.matrix_t(n,h,r);j=d.data[(l<<2)+1];}jsfeat.imgproc.pyrdown(g,j,1,0);j=d.data[(l<<2)+2];if(p||n!=j.cols||h!=j.rows){d.data[(l<<2)+2]=new jsfeat.matrix_t(n,h,r);j=d.data[(l<<2)+2];}jsfeat.imgproc.pyrdown(g,j,0,1);j=d.data[(l<<2)+3];if(p||n!=j.cols||h!=j.rows){d.data[(l<<2)+3]=new jsfeat.matrix_t(n,h,r);j=d.data[(l<<2)+3];}jsfeat.imgproc.pyrdown(g,j,1,1);}return d},detect:function(G,L){var h=this.interval;var N=this.scale;var m=this.next;var l=this.scale_to;var ab=0,aa=0,Z=0,W=0,S=0,R=0,U=0,B=0,J=0,I=0,V=0,ae=0,M=0,ad=0,w=0,Y=0,g=0;var E=0,X,Q,D,H,F,O=true,o=true;var z=1,v=1;var s=[0,1,0,1];var r=[0,0,1,1];var K=[];var C=G.data,ac=1,u=2,t=4;var A=[],e=[0,0,0];var P=[0,0,0];var T=[0,0,0];for(ab=0;ab<l;ab++){w=(ab<<2);Y=C[w+(m<<3)].cols-(L.width>>2);g=C[w+(m<<3)].rows-(L.height>>2);P[0]=C[w].cols*ac;P[1]=C[w+(m<<2)].cols*ac;P[2]=C[w+(m<<3)].cols*ac;T[0]=(C[w].cols*t)-(Y*t);T[1]=(C[w+(m<<2)].cols*u)-(Y*u);T[2]=(C[w+(m<<3)].cols*ac)-(Y*ac);B=L.stage_classifier.length;for(aa=0;aa<B;aa++){D=L.stage_classifier[aa].feature;Q=L.stage_classifier[aa]._feature;J=L.stage_classifier[aa].count;for(Z=0;Z<J;Z++){H=Q[Z];F=D[Z];I=F.size|0;for(U=0;U<I;U++){H.px[U]=(F.px[U]*ac)+F.py[U]*P[F.pz[U]];H.pz[U]=F.pz[U];H.nx[U]=(F.nx[U]*ac)+F.ny[U]*P[F.nz[U]];H.nz[U]=F.nz[U];}}}A[0]=C[w].data;A[1]=C[w+(m<<2)].data;for(U=0;U<4;U++){A[2]=C[w+(m<<3)+U].data;e[0]=(s[U]*u)+r[U]*(C[w].cols*u);e[1]=(s[U]*ac)+r[U]*(C[w+(m<<2)].cols*ac);e[2]=0;for(R=0;R<g;R++){for(S=0;S<Y;S++){E=0;O=true;B=L.stage_classifier.length;for(aa=0;aa<B;aa++){E=0;X=L.stage_classifier[aa].alpha;Q=L.stage_classifier[aa]._feature;J=L.stage_classifier[aa].count;for(Z=0;Z<J;Z++){H=Q[Z];ae=A[H.pz[0]][e[H.pz[0]]+H.px[0]];M=A[H.nz[0]][e[H.nz[0]]+H.nx[0]];if(ae<=M){E+=X[Z<<1];}else{o=true;I=H.size;for(ad=1;ad<I;ad++){if(H.pz[ad]>=0){V=A[H.pz[ad]][e[H.pz[ad]]+H.px[ad]];if(V<ae){if(V<=M){o=false;break}ae=V;}}if(H.nz[ad]>=0){W=A[H.nz[ad]][e[H.nz[ad]]+H.nx[ad]];if(W>M){if(ae<=W){o=false;break}M=W;}}}E+=(o)?X[(Z<<1)+1]:X[Z<<1];}}if(E<L.stage_classifier[aa].threshold){O=false;break}}if(O){K.push({x:(S*4+s[U]*2)*z,y:(R*4+r[U]*2)*v,width:L.width*z,height:L.height*v,neighbor:1,confidence:E});++S;e[0]+=t;e[1]+=u;e[2]+=ac;}e[0]+=t;e[1]+=u;e[2]+=ac;}e[0]+=T[0];e[1]+=T[1];e[2]+=T[2];}}z*=N;v*=N;}return K},group_rectangles:function(h,m){if(typeof m==="undefined"){m=1;}var z,w,r=h.length;var s=[];for(z=0;z<r;++z){s[z]={parent:-1,element:h[z],rank:0};}for(z=0;z<r;++z){if(!s[z].element){continue}var u=z;while(s[u].parent!=-1){u=s[u].parent;}for(w=0;w<r;++w){if(z!=w&&s[w].element&&c(s[z].element,s[w].element)){var t=w;while(s[t].parent!=-1){t=s[t].parent;}if(t!=u){if(s[u].rank>s[t].rank){s[t].parent=u;}else{s[u].parent=t;if(s[u].rank==s[t].rank){s[t].rank++;}u=t;}var B,e=w;while(s[e].parent!=-1){B=e;e=s[e].parent;s[B].parent=u;}e=z;while(s[e].parent!=-1){B=e;e=s[e].parent;s[B].parent=u;}}}}}var x=[];var p=0;for(z=0;z<r;z++){w=-1;var f=z;if(s[f].element){while(s[f].parent!=-1){f=s[f].parent;}if(s[f].rank>=0){s[f].rank=~p++;}w=~s[f].rank;}x[z]=w;}var o=[];for(z=0;z<p+1;++z){o[z]={neighbors:0,x:0,y:0,width:0,height:0,confidence:0};}for(z=0;z<r;++z){var A=h[z];var l=x[z];if(o[l].neighbors==0){o[l].confidence=A.confidence;}++o[l].neighbors;o[l].x+=A.x;o[l].y+=A.y;o[l].width+=A.width;o[l].height+=A.height;o[l].confidence=Math.max(o[l].confidence,A.confidence);}var k=[];for(z=0;z<p;++z){r=o[z].neighbors;if(r>=m){k.push({x:(o[z].x*2+r)/(2*r),y:(o[z].y*2+r)/(2*r),width:(o[z].width*2+r)/(2*r),height:(o[z].height*2+r)/(2*r),neighbors:o[z].neighbors,confidence:o[z].confidence});}}var q=[];r=k.length;for(z=0;z<r;++z){var A=k[z];var y=true;for(w=0;w<r;++w){var v=k[w];var g=(v.width*0.25+0.5)|0;if(z!=w&&A.x>=v.x-g&&A.y>=v.y-g&&A.x+A.width<=v.x+v.width+g&&A.y+A.height<=v.y+v.height+g&&(v.neighbors>Math.max(3,A.neighbors)||A.neighbors<3)){y=false;break}}if(y){q.push(A);}}return q}}})();a.bbf=b;})(jsfeat);(function(a){if(typeof module==="undefined"||typeof module.exports==="undefined"){window.jsfeat=a;}else{module.exports=a;}})(jsfeat);

    jsfeat.haar.frontalface = 'FRONTALFACE_PLACEHOLDER';

    var imageData = e.data.imageData,
      w = e.data.w,
      h = e.data.h,
      videoWidth = e.data.videoWidth,
      params = e.data.params;

    var img_u8 = new jsfeat.matrix_t(w, h, jsfeat.U8_t | jsfeat.C1_t),
      edg = new jsfeat.matrix_t(w, h, jsfeat.U8_t | jsfeat.C1_t),
      ii_sum = new Int32Array((w+1)*(h+1)),
      ii_sqsum = new Int32Array((w+1)*(h+1)),
      ii_tilted = new Int32Array((w+1)*(h+1)),
      ii_canny = new Int32Array((w+1)*(h+1));

    var classifier = jsfeat.haar.frontalface;

    jsfeat.imgproc.grayscale(imageData.data, w, h, img_u8);

    // possible params
    if (params.equalizeHistogram) {
      jsfeat.imgproc.equalize_histogram(img_u8, img_u8);
    }
    //jsfeat.imgproc.gaussian_blur(img_u8, img_u8, 3);

    jsfeat.imgproc.compute_integral_image(img_u8, ii_sum, ii_sqsum, classifier.tilted ? ii_tilted : null);

    if(params.useCanny) {
      jsfeat.imgproc.canny(img_u8, edg, 10, 50);
      jsfeat.imgproc.compute_integral_image(edg, ii_canny, null, null);
    }

    jsfeat.haar.edgesDensity = params.edgesDensity;
    var rects = jsfeat.haar.detect_multi_scale(ii_sum, ii_sqsum, ii_tilted, params.useCanny? ii_canny : null, img_u8.cols, img_u8.rows, classifier, params.scaleFactor, params.minScale);
    rects = jsfeat.haar.group_rectangles(rects, params.min_neighbors);

    for (var i = rects.length-1;i >= 0;i--) {
      if (rects[i].confidence < params.confidenceThreshold) {
        rects.splice(i,1);
      }
    }

    var rl = rects.length;
    if (rl == 0) {
      self.postMessage({
        faces: []
      });
    } else {
      var best = rects[0];
      for (var i = 1;i < rl;i++) {
        if (rects[i].neighbors > best.neighbors) {
          best = rects[i];
        } else if (rects[i].neighbors == best.neighbors) {
          // if (rects[i].width > best.width) best = rects[i]; // use biggest rect
          if (rects[i].confidence > best.confidence) best = rects[i]; // use most confident rect
        }
      }

      var sc = videoWidth / img_u8.cols;
      best.x = (best.x*sc)|0;
      best.y = (best.y*sc)|0;
      best.width = (best.width*sc)|0;
      best.height = (best.height*sc)|0;

      self.postMessage({
        faces: [best]
      });
    }
  };

// import { drawDetection, drawFacialPoints, drawBoundingBox } from './utils/debugging.js';

  /**
   * this cascade is derived from https://github.com/mtschirs/js-objectdetect implementation
   * @author Martin Tschirsich / http://www.tu-darmstadt.de/~m_t
   */
  jsfeat_1.haar.frontalface = {complexClassifiers:[{simpleClassifiers:[{features:[[3,7,14,4,-1.],[3,9,14,2,2.]],threshold:4.0142e-003,right_val:0.83781,left_val:0.033794},{features:[[1,2,18,4,-1.],[7,2,6,4,3.]],threshold:0.015151,right_val:0.74888,left_val:0.15141},{features:[[1,7,15,9,-1.],[1,10,15,3,3.]],threshold:4.211e-003,right_val:0.63748,left_val:0.090049}],threshold:0.82269},{simpleClassifiers:[{features:[[5,6,2,6,-1.],[5,9,2,3,2.]],threshold:1.6227e-003,right_val:0.71109,left_val:0.069309},{features:[[7,5,6,3,-1.],[9,5,2,3,3.]],threshold:2.2907e-003,right_val:0.66687,left_val:0.17958},{features:[[4,0,12,9,-1.],[4,3,12,3,3.]],threshold:5.0026e-003,right_val:0.6554,left_val:0.16937},{features:[[6,9,10,8,-1.],[6,13,10,4,2.]],threshold:7.966e-003,right_val:0.091415,left_val:0.58663},{features:[[3,6,14,8,-1.],[3,10,14,4,2.]],threshold:-3.5227e-003,right_val:0.60319,left_val:0.14132},{features:[[14,1,6,10,-1.],[14,1,3,10,2.]],threshold:0.036668,right_val:0.79203,left_val:0.36757},{features:[[7,8,5,12,-1.],[7,12,5,4,3.]],threshold:9.3361e-003,right_val:0.20885,left_val:0.61614},{features:[[1,1,18,3,-1.],[7,1,6,3,3.]],threshold:8.6961e-003,right_val:0.63603,left_val:0.28362},{features:[[1,8,17,2,-1.],[1,9,17,1,2.]],threshold:1.1489e-003,right_val:0.58007,left_val:0.22236},{features:[[16,6,4,2,-1.],[16,7,4,1,2.]],threshold:-2.1485e-003,right_val:0.57871,left_val:0.24065},{features:[[5,17,2,2,-1.],[5,18,2,1,2.]],threshold:2.1219e-003,right_val:0.13622,left_val:0.55597},{features:[[14,2,6,12,-1.],[14,2,3,12,2.]],threshold:-0.093949,right_val:0.47177,left_val:0.85027},{features:[[4,0,4,12,-1.],[4,0,2,6,2.],[6,6,2,6,2.]],threshold:1.3778e-003,right_val:0.28345,left_val:0.59937},{features:[[2,11,18,8,-1.],[8,11,6,8,3.]],threshold:0.073063,right_val:0.706,left_val:0.43419},{features:[[5,7,10,2,-1.],[5,8,10,1,2.]],threshold:3.6767e-004,right_val:0.60516,left_val:0.30279},{features:[[15,11,5,3,-1.],[15,12,5,1,3.]],threshold:-6.048e-003,right_val:0.56753,left_val:0.17984}],threshold:6.9566},{simpleClassifiers:[{features:[[5,3,10,9,-1.],[5,6,10,3,3.]],threshold:-0.016511,right_val:0.14249,left_val:0.66442},{features:[[9,4,2,14,-1.],[9,11,2,7,2.]],threshold:2.7052e-003,right_val:0.12885,left_val:0.63254},{features:[[3,5,4,12,-1.],[3,9,4,4,3.]],threshold:2.807e-003,right_val:0.61932,left_val:0.12403},{features:[[4,5,12,5,-1.],[8,5,4,5,3.]],threshold:-1.5402e-003,right_val:0.567,left_val:0.14321},{features:[[5,6,10,8,-1.],[5,10,10,4,2.]],threshold:-5.6386e-004,right_val:0.59052,left_val:0.16574},{features:[[8,0,6,9,-1.],[8,3,6,3,3.]],threshold:1.9254e-003,right_val:0.57388,left_val:0.26955},{features:[[9,12,1,8,-1.],[9,16,1,4,2.]],threshold:-5.0215e-003,right_val:0.57828,left_val:0.18935},{features:[[0,7,20,6,-1.],[0,9,20,2,3.]],threshold:2.6365e-003,right_val:0.56954,left_val:0.23093},{features:[[7,0,6,17,-1.],[9,0,2,17,3.]],threshold:-1.5128e-003,right_val:0.59566,left_val:0.27596},{features:[[9,0,6,4,-1.],[11,0,2,4,3.]],threshold:-0.010157,right_val:0.5522,left_val:0.17325},{features:[[5,1,6,4,-1.],[7,1,2,4,3.]],threshold:-0.011954,right_val:0.5559,left_val:0.13394},{features:[[12,1,6,16,-1.],[14,1,2,16,3.]],threshold:4.8859e-003,right_val:0.61888,left_val:0.36287},{features:[[0,5,18,8,-1.],[0,5,9,4,2.],[9,9,9,4,2.]],threshold:-0.080133,right_val:0.54759,left_val:0.091211},{features:[[8,15,10,4,-1.],[13,15,5,2,2.],[8,17,5,2,2.]],threshold:1.0643e-003,right_val:0.57114,left_val:0.37151},{features:[[3,1,4,8,-1.],[3,1,2,4,2.],[5,5,2,4,2.]],threshold:-1.3419e-003,right_val:0.33181,left_val:0.59533},{features:[[3,6,14,10,-1.],[10,6,7,5,2.],[3,11,7,5,2.]],threshold:-0.054601,right_val:0.56028,left_val:0.18441},{features:[[2,1,6,16,-1.],[4,1,2,16,3.]],threshold:2.9072e-003,right_val:0.61317,left_val:0.35942},{features:[[0,18,20,2,-1.],[0,19,20,1,2.]],threshold:7.4719e-004,right_val:0.34596,left_val:0.59944},{features:[[8,13,4,3,-1.],[8,14,4,1,3.]],threshold:4.3014e-003,right_val:0.69908,left_val:0.41727},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:4.5018e-003,right_val:0.78015,left_val:0.45097},{features:[[0,12,9,6,-1.],[0,14,9,2,3.]],threshold:0.024139,right_val:0.13198,left_val:0.54382}],threshold:9.4985},{simpleClassifiers:[{features:[[5,7,3,4,-1.],[5,9,3,2,2.]],threshold:1.9212e-003,right_val:0.61999,left_val:0.14153},{features:[[9,3,2,16,-1.],[9,11,2,8,2.]],threshold:-1.2749e-004,right_val:0.18849,left_val:0.61911},{features:[[3,6,13,8,-1.],[3,10,13,4,2.]],threshold:5.141e-004,right_val:0.58579,left_val:0.14874},{features:[[12,3,8,2,-1.],[12,3,4,2,2.]],threshold:4.1879e-003,right_val:0.63592,left_val:0.27469},{features:[[8,8,4,12,-1.],[8,12,4,4,3.]],threshold:5.1016e-003,right_val:0.21756,left_val:0.58709},{features:[[11,3,8,6,-1.],[15,3,4,3,2.],[11,6,4,3,2.]],threshold:-2.1448e-003,right_val:0.29796,left_val:0.58809},{features:[[7,1,6,19,-1.],[9,1,2,19,3.]],threshold:-2.8977e-003,right_val:0.58766,left_val:0.23733},{features:[[9,0,6,4,-1.],[11,0,2,4,3.]],threshold:-0.021611,right_val:0.51942,left_val:0.12207},{features:[[3,1,9,3,-1.],[6,1,3,3,3.]],threshold:-4.6299e-003,right_val:0.58174,left_val:0.26312},{features:[[8,15,10,4,-1.],[13,15,5,2,2.],[8,17,5,2,2.]],threshold:5.9394e-004,right_val:0.56985,left_val:0.36386},{features:[[0,3,6,10,-1.],[3,3,3,10,2.]],threshold:0.053879,right_val:0.75594,left_val:0.43035},{features:[[3,4,15,15,-1.],[3,9,15,5,3.]],threshold:1.8887e-003,right_val:0.56134,left_val:0.21226},{features:[[6,5,8,6,-1.],[6,7,8,2,3.]],threshold:-2.3635e-003,right_val:0.26428,left_val:0.56318},{features:[[4,4,12,10,-1.],[10,4,6,5,2.],[4,9,6,5,2.]],threshold:0.024018,right_val:0.27517,left_val:0.57971},{features:[[6,4,4,4,-1.],[8,4,2,4,2.]],threshold:2.0543e-004,right_val:0.57526,left_val:0.27052},{features:[[15,11,1,2,-1.],[15,12,1,1,2.]],threshold:8.479e-004,right_val:0.23349,left_val:0.54356},{features:[[3,11,2,2,-1.],[3,12,2,1,2.]],threshold:1.4091e-003,right_val:0.20632,left_val:0.53194},{features:[[16,11,1,3,-1.],[16,12,1,1,3.]],threshold:1.4643e-003,right_val:0.30689,left_val:0.5419},{features:[[3,15,6,4,-1.],[3,15,3,2,2.],[6,17,3,2,2.]],threshold:1.6353e-003,right_val:0.61129,left_val:0.36954},{features:[[6,7,8,2,-1.],[6,8,8,1,2.]],threshold:8.3173e-004,right_val:0.60252,left_val:0.3565},{features:[[3,11,1,3,-1.],[3,12,1,1,3.]],threshold:-2.0999e-003,right_val:0.53628,left_val:0.1914},{features:[[6,0,12,2,-1.],[6,1,12,1,2.]],threshold:-7.4214e-004,right_val:0.55293,left_val:0.38356},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:3.2655e-003,right_val:0.71019,left_val:0.43129},{features:[[7,15,6,2,-1.],[7,16,6,1,2.]],threshold:8.9135e-004,right_val:0.6392,left_val:0.39848},{features:[[0,5,4,6,-1.],[0,7,4,2,3.]],threshold:-0.015284,right_val:0.54337,left_val:0.23667},{features:[[4,12,12,2,-1.],[8,12,4,2,3.]],threshold:4.8381e-003,right_val:0.32392,left_val:0.58175},{features:[[6,3,1,9,-1.],[6,6,1,3,3.]],threshold:-9.1093e-004,right_val:0.29119,left_val:0.55406},{features:[[10,17,3,2,-1.],[11,17,1,2,3.]],threshold:-6.1275e-003,right_val:0.51966,left_val:0.17753},{features:[[9,9,2,2,-1.],[9,10,2,1,2.]],threshold:-4.4576e-004,right_val:0.55336,left_val:0.30242},{features:[[7,6,6,4,-1.],[9,6,2,4,3.]],threshold:0.022647,right_val:0.69754,left_val:0.44149},{features:[[7,17,3,2,-1.],[8,17,1,2,3.]],threshold:-1.8805e-003,right_val:0.5498,left_val:0.27914},{features:[[10,17,3,3,-1.],[11,17,1,3,3.]],threshold:7.0889e-003,right_val:0.23855,left_val:0.52632},{features:[[8,12,3,2,-1.],[8,13,3,1,2.]],threshold:1.7318e-003,right_val:0.69836,left_val:0.43194},{features:[[9,3,6,2,-1.],[11,3,2,2,3.]],threshold:-6.8483e-003,right_val:0.53909,left_val:0.3082},{features:[[3,11,14,4,-1.],[3,13,14,2,2.]],threshold:-1.5063e-005,right_val:0.31204,left_val:0.55219},{features:[[1,10,18,4,-1.],[10,10,9,2,2.],[1,12,9,2,2.]],threshold:0.029476,right_val:0.17706,left_val:0.54013},{features:[[0,10,3,3,-1.],[0,11,3,1,3.]],threshold:8.1387e-003,right_val:0.1211,left_val:0.51786},{features:[[9,1,6,6,-1.],[11,1,2,6,3.]],threshold:0.020943,right_val:0.33112,left_val:0.52903},{features:[[8,7,3,6,-1.],[9,7,1,6,3.]],threshold:-9.5666e-003,right_val:0.4452,left_val:0.7472}],threshold:18.413},{simpleClassifiers:[{features:[[1,0,18,9,-1.],[1,3,18,3,3.]],threshold:-2.8207e-004,right_val:0.60767,left_val:0.20641},{features:[[12,10,2,6,-1.],[12,13,2,3,2.]],threshold:1.6791e-003,right_val:0.12554,left_val:0.5852},{features:[[0,5,19,8,-1.],[0,9,19,4,2.]],threshold:6.9828e-004,right_val:0.5729,left_val:0.094018},{features:[[7,0,6,9,-1.],[9,0,2,9,3.]],threshold:7.8959e-004,right_val:0.56943,left_val:0.1782},{features:[[5,3,6,1,-1.],[7,3,2,1,3.]],threshold:-2.856e-003,right_val:0.57887,left_val:0.16384},{features:[[11,3,6,1,-1.],[13,3,2,1,3.]],threshold:-3.8122e-003,right_val:0.55086,left_val:0.20854},{features:[[5,10,4,6,-1.],[5,13,4,3,2.]],threshold:1.5897e-003,right_val:0.18572,left_val:0.57028},{features:[[11,3,6,1,-1.],[13,3,2,1,3.]],threshold:0.010078,right_val:0.21898,left_val:0.51169},{features:[[4,4,12,6,-1.],[4,6,12,2,3.]],threshold:-0.063526,right_val:0.40438,left_val:0.71314},{features:[[15,12,2,6,-1.],[15,14,2,2,3.]],threshold:-9.1031e-003,right_val:0.5464,left_val:0.25672},{features:[[9,3,2,2,-1.],[10,3,1,2,2.]],threshold:-2.4035e-003,right_val:0.5591,left_val:0.17007},{features:[[9,3,3,1,-1.],[10,3,1,1,3.]],threshold:1.5226e-003,right_val:0.26191,left_val:0.54106},{features:[[1,1,4,14,-1.],[3,1,2,14,2.]],threshold:0.017997,right_val:0.65352,left_val:0.37324},{features:[[9,0,4,4,-1.],[11,0,2,2,2.],[9,2,2,2,2.]],threshold:-6.4538e-003,right_val:0.55374,left_val:0.26265},{features:[[7,5,1,14,-1.],[7,12,1,7,2.]],threshold:-0.011881,right_val:0.55447,left_val:0.20038},{features:[[19,0,1,4,-1.],[19,2,1,2,2.]],threshold:1.2714e-003,right_val:0.3032,left_val:0.55919},{features:[[5,5,6,4,-1.],[8,5,3,4,2.]],threshold:1.1376e-003,right_val:0.56465,left_val:0.27304},{features:[[9,18,3,2,-1.],[10,18,1,2,3.]],threshold:-4.2652e-003,right_val:0.54618,left_val:0.14059},{features:[[8,18,3,2,-1.],[9,18,1,2,3.]],threshold:-2.9603e-003,right_val:0.54593,left_val:0.1795},{features:[[4,5,12,6,-1.],[4,7,12,2,3.]],threshold:-8.8448e-003,right_val:0.28092,left_val:0.57368},{features:[[3,12,2,6,-1.],[3,14,2,2,3.]],threshold:-6.6431e-003,right_val:0.55038,left_val:0.23707},{features:[[10,8,2,12,-1.],[10,12,2,4,3.]],threshold:3.9998e-003,right_val:0.33043,left_val:0.56082},{features:[[7,18,3,2,-1.],[8,18,1,2,3.]],threshold:-4.1222e-003,right_val:0.5379,left_val:0.16401},{features:[[9,0,6,2,-1.],[11,0,2,2,3.]],threshold:0.015625,right_val:0.22886,left_val:0.52276},{features:[[5,11,9,3,-1.],[5,12,9,1,3.]],threshold:-0.010356,right_val:0.42529,left_val:0.70162},{features:[[9,0,6,2,-1.],[11,0,2,2,3.]],threshold:-8.7961e-003,right_val:0.53558,left_val:0.27673},{features:[[1,1,18,5,-1.],[7,1,6,5,3.]],threshold:0.16227,right_val:0.74426,left_val:0.43422},{features:[[8,0,4,4,-1.],[10,0,2,2,2.],[8,2,2,2,2.]],threshold:4.5543e-003,right_val:0.25821,left_val:0.57265},{features:[[3,12,1,3,-1.],[3,13,1,1,3.]],threshold:-2.1309e-003,right_val:0.5361,left_val:0.21068},{features:[[8,14,5,3,-1.],[8,15,5,1,3.]],threshold:-0.013208,right_val:0.45525,left_val:0.75938},{features:[[5,4,10,12,-1.],[5,4,5,6,2.],[10,10,5,6,2.]],threshold:-0.065997,right_val:0.5344,left_val:0.12525},{features:[[9,6,9,12,-1.],[9,10,9,4,3.]],threshold:7.9143e-003,right_val:0.5601,left_val:0.33154},{features:[[2,2,12,14,-1.],[2,2,6,7,2.],[8,9,6,7,2.]],threshold:0.020894,right_val:0.27688,left_val:0.5506}],threshold:15.324},{simpleClassifiers:[{features:[[4,7,12,2,-1.],[8,7,4,2,3.]],threshold:1.1961e-003,right_val:0.61562,left_val:0.17627},{features:[[7,4,6,4,-1.],[7,6,6,2,2.]],threshold:-1.868e-003,right_val:0.18324,left_val:0.61181},{features:[[4,5,11,8,-1.],[4,9,11,4,2.]],threshold:-1.958e-004,right_val:0.57238,left_val:0.099044},{features:[[3,10,16,4,-1.],[3,12,16,2,2.]],threshold:-8.0256e-004,right_val:0.23773,left_val:0.55799},{features:[[0,0,16,2,-1.],[0,1,16,1,2.]],threshold:-2.4511e-003,right_val:0.58589,left_val:0.22315},{features:[[7,5,6,2,-1.],[9,5,2,2,3.]],threshold:5.0362e-004,right_val:0.57941,left_val:0.2654},{features:[[3,2,6,10,-1.],[3,2,3,5,2.],[6,7,3,5,2.]],threshold:4.0293e-003,right_val:0.24849,left_val:0.58038},{features:[[10,5,8,15,-1.],[10,10,8,5,3.]],threshold:-0.014452,right_val:0.54842,left_val:0.18304},{features:[[3,14,8,6,-1.],[3,14,4,3,2.],[7,17,4,3,2.]],threshold:2.0381e-003,right_val:0.60511,left_val:0.33636},{features:[[14,2,2,2,-1.],[14,3,2,1,2.]],threshold:-1.6155e-003,right_val:0.54412,left_val:0.22866},{features:[[1,10,7,6,-1.],[1,13,7,3,2.]],threshold:3.3458e-003,right_val:0.23923,left_val:0.56259},{features:[[15,4,4,3,-1.],[15,4,2,3,2.]],threshold:1.638e-003,right_val:0.59646,left_val:0.3907},{features:[[2,9,14,6,-1.],[2,9,7,3,2.],[9,12,7,3,2.]],threshold:0.030251,right_val:0.15757,left_val:0.52485},{features:[[5,7,10,4,-1.],[5,9,10,2,2.]],threshold:0.037252,right_val:0.67484,left_val:0.41943},{features:[[6,9,8,8,-1.],[6,9,4,4,2.],[10,13,4,4,2.]],threshold:-0.02511,right_val:0.54735,left_val:0.18825},{features:[[14,1,3,2,-1.],[14,2,3,1,2.]],threshold:-5.3099e-003,right_val:0.52271,left_val:0.134},{features:[[1,4,4,2,-1.],[3,4,2,2,2.]],threshold:1.2086e-003,right_val:0.61096,left_val:0.37621},{features:[[11,10,2,8,-1.],[11,14,2,4,2.]],threshold:-0.021908,right_val:0.5404,left_val:0.26631},{features:[[0,0,5,3,-1.],[0,1,5,1,3.]],threshold:5.4117e-003,right_val:0.22323,left_val:0.53636},{features:[[2,5,18,8,-1.],[11,5,9,4,2.],[2,9,9,4,2.]],threshold:0.069946,right_val:0.24537,left_val:0.53582},{features:[[6,6,1,6,-1.],[6,9,1,3,2.]],threshold:3.452e-004,right_val:0.53769,left_val:0.24097},{features:[[19,1,1,3,-1.],[19,2,1,1,3.]],threshold:1.2628e-003,right_val:0.31557,left_val:0.54259},{features:[[7,6,6,6,-1.],[9,6,2,6,3.]],threshold:0.02272,right_val:0.65979,left_val:0.41584},{features:[[19,1,1,3,-1.],[19,2,1,1,3.]],threshold:-1.8111e-003,right_val:0.55052,left_val:0.28113},{features:[[3,13,2,3,-1.],[3,14,2,1,3.]],threshold:3.347e-003,right_val:0.18915,left_val:0.526},{features:[[8,4,8,12,-1.],[12,4,4,6,2.],[8,10,4,6,2.]],threshold:4.0792e-004,right_val:0.33442,left_val:0.56735},{features:[[5,2,6,3,-1.],[7,2,2,3,3.]],threshold:0.012735,right_val:0.23956,left_val:0.53436},{features:[[6,1,9,10,-1.],[6,6,9,5,2.]],threshold:-7.312e-003,right_val:0.40222,left_val:0.60109},{features:[[0,4,6,12,-1.],[2,4,2,12,3.]],threshold:-0.056949,right_val:0.45432,left_val:0.81992},{features:[[15,13,2,3,-1.],[15,14,2,1,3.]],threshold:-5.0117e-003,right_val:0.53577,left_val:0.22003},{features:[[7,14,5,3,-1.],[7,15,5,1,3.]],threshold:6.0334e-003,right_val:0.71818,left_val:0.44131},{features:[[15,13,3,3,-1.],[15,14,3,1,3.]],threshold:3.9437e-003,right_val:0.27917,left_val:0.54789},{features:[[6,14,8,3,-1.],[6,15,8,1,3.]],threshold:-3.6591e-003,right_val:0.39897,left_val:0.63579},{features:[[15,13,3,3,-1.],[15,14,3,1,3.]],threshold:-3.8456e-003,right_val:0.53007,left_val:0.34937},{features:[[2,13,3,3,-1.],[2,14,3,1,3.]],threshold:-7.1926e-003,right_val:0.52297,left_val:0.11196},{features:[[4,7,12,12,-1.],[10,7,6,6,2.],[4,13,6,6,2.]],threshold:-0.052799,right_val:0.54535,left_val:0.23871},{features:[[9,7,2,6,-1.],[10,7,1,6,2.]],threshold:-7.9538e-003,right_val:0.44394,left_val:0.75869},{features:[[8,9,5,2,-1.],[8,10,5,1,2.]],threshold:-2.7344e-003,right_val:0.54893,left_val:0.25655},{features:[[8,6,3,4,-1.],[9,6,1,4,3.]],threshold:-1.8508e-003,right_val:0.42525,left_val:0.67343},{features:[[9,6,2,8,-1.],[9,10,2,4,2.]],threshold:0.015919,right_val:0.22927,left_val:0.54884},{features:[[7,7,3,6,-1.],[8,7,1,6,3.]],threshold:-1.2688e-003,right_val:0.40224,left_val:0.61043},{features:[[11,3,3,3,-1.],[12,3,1,3,3.]],threshold:6.2884e-003,right_val:0.15362,left_val:0.53109},{features:[[5,4,6,1,-1.],[7,4,2,1,3.]],threshold:-6.226e-003,right_val:0.52416,left_val:0.17291},{features:[[5,6,10,3,-1.],[5,7,10,1,3.]],threshold:-0.012133,right_val:0.43252,left_val:0.65978}],threshold:21.011},{simpleClassifiers:[{features:[[7,3,6,9,-1.],[7,6,6,3,3.]],threshold:-3.9185e-003,right_val:0.14693,left_val:0.61034},{features:[[6,7,9,1,-1.],[9,7,3,1,3.]],threshold:1.5971e-003,right_val:0.58965,left_val:0.26324},{features:[[2,8,16,8,-1.],[2,12,16,4,2.]],threshold:0.01778,right_val:0.17604,left_val:0.58729},{features:[[14,6,2,6,-1.],[14,9,2,3,2.]],threshold:6.5335e-004,right_val:0.55961,left_val:0.15678},{features:[[1,5,6,15,-1.],[1,10,6,5,3.]],threshold:-2.8353e-004,right_val:0.5732,left_val:0.19132},{features:[[10,0,6,9,-1.],[10,3,6,3,3.]],threshold:1.6105e-003,right_val:0.56231,left_val:0.29149},{features:[[6,6,7,14,-1.],[6,13,7,7,2.]],threshold:-0.097751,right_val:0.56482,left_val:0.19435},{features:[[13,7,3,6,-1.],[13,9,3,2,3.]],threshold:5.5182e-004,right_val:0.55046,left_val:0.31346},{features:[[1,8,15,4,-1.],[6,8,5,4,3.]],threshold:-0.012858,right_val:0.57601,left_val:0.25365},{features:[[11,2,3,10,-1.],[11,7,3,5,2.]],threshold:4.153e-003,right_val:0.36598,left_val:0.57677},{features:[[3,7,4,6,-1.],[3,9,4,2,3.]],threshold:1.7092e-003,right_val:0.59189,left_val:0.28432},{features:[[13,3,6,10,-1.],[15,3,2,10,3.]],threshold:7.5217e-003,right_val:0.61831,left_val:0.40524},{features:[[5,7,8,10,-1.],[5,7,4,5,2.],[9,12,4,5,2.]],threshold:2.248e-003,right_val:0.31354,left_val:0.57838},{features:[[4,4,12,12,-1.],[10,4,6,6,2.],[4,10,6,6,2.]],threshold:0.052006,right_val:0.19166,left_val:0.55413},{features:[[1,4,6,9,-1.],[3,4,2,9,3.]],threshold:0.012086,right_val:0.66446,left_val:0.40327},{features:[[11,3,2,5,-1.],[11,3,1,5,2.]],threshold:1.4688e-005,right_val:0.57094,left_val:0.3536},{features:[[7,3,2,5,-1.],[8,3,1,5,2.]],threshold:7.1395e-006,right_val:0.56103,left_val:0.30374},{features:[[10,14,2,3,-1.],[10,15,2,1,3.]],threshold:-4.6002e-003,right_val:0.45803,left_val:0.71811},{features:[[5,12,6,2,-1.],[8,12,3,2,2.]],threshold:2.0059e-003,right_val:0.29537,left_val:0.5622},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:4.505e-003,right_val:0.7619,left_val:0.46154},{features:[[4,11,12,6,-1.],[4,14,12,3,2.]],threshold:0.011747,right_val:0.17725,left_val:0.53438},{features:[[11,11,5,9,-1.],[11,14,5,3,3.]],threshold:-0.058316,right_val:0.53408,left_val:0.16862},{features:[[6,15,3,2,-1.],[6,16,3,1,2.]],threshold:2.3629e-004,right_val:0.60268,left_val:0.37921},{features:[[11,0,3,5,-1.],[12,0,1,5,3.]],threshold:-7.8156e-003,right_val:0.53243,left_val:0.15129},{features:[[5,5,6,7,-1.],[8,5,3,7,2.]],threshold:-0.010876,right_val:0.53199,left_val:0.20818},{features:[[13,0,1,9,-1.],[13,3,1,3,3.]],threshold:-2.7746e-003,right_val:0.52103,left_val:0.40982},{features:[[3,2,4,8,-1.],[3,2,2,4,2.],[5,6,2,4,2.]],threshold:-7.8276e-004,right_val:0.34788,left_val:0.56933},{features:[[13,12,4,6,-1.],[13,14,4,2,3.]],threshold:0.01387,right_val:0.22577,left_val:0.53268},{features:[[3,12,4,6,-1.],[3,14,4,2,3.]],threshold:-0.023675,right_val:0.52007,left_val:0.15513},{features:[[13,11,3,4,-1.],[13,13,3,2,2.]],threshold:-1.4879e-005,right_val:0.38202,left_val:0.55006},{features:[[4,4,4,3,-1.],[4,5,4,1,3.]],threshold:3.6191e-003,right_val:0.66397,left_val:0.42387},{features:[[7,5,11,8,-1.],[7,9,11,4,2.]],threshold:-0.019817,right_val:0.53824,left_val:0.215},{features:[[7,8,3,4,-1.],[8,8,1,4,3.]],threshold:-3.8154e-003,right_val:0.42153,left_val:0.66757},{features:[[9,1,6,1,-1.],[11,1,2,1,3.]],threshold:-4.9776e-003,right_val:0.53863,left_val:0.22673},{features:[[5,5,3,3,-1.],[5,6,3,1,3.]],threshold:2.2441e-003,right_val:0.68557,left_val:0.43087},{features:[[0,9,20,6,-1.],[10,9,10,3,2.],[0,12,10,3,2.]],threshold:0.012282,right_val:0.34675,left_val:0.58366},{features:[[8,6,3,5,-1.],[9,6,1,5,3.]],threshold:-2.8549e-003,right_val:0.43115,left_val:0.70169},{features:[[11,0,1,3,-1.],[11,1,1,1,3.]],threshold:-3.7876e-003,right_val:0.52249,left_val:0.28953},{features:[[4,2,4,2,-1.],[4,3,4,1,2.]],threshold:-1.2201e-003,right_val:0.54816,left_val:0.29756},{features:[[12,6,4,3,-1.],[12,7,4,1,3.]],threshold:0.010161,right_val:0.81827,left_val:0.48888},{features:[[5,0,6,4,-1.],[7,0,2,4,3.]],threshold:-0.016175,right_val:0.524,left_val:0.14815},{features:[[9,7,3,8,-1.],[10,7,1,8,3.]],threshold:0.019292,right_val:0.73782,left_val:0.47863},{features:[[9,7,2,2,-1.],[10,7,1,2,2.]],threshold:-3.248e-003,right_val:0.44706,left_val:0.73742},{features:[[6,7,14,4,-1.],[13,7,7,2,2.],[6,9,7,2,2.]],threshold:-9.3803e-003,right_val:0.5538,left_val:0.34892},{features:[[0,5,3,6,-1.],[0,7,3,2,3.]],threshold:-0.012606,right_val:0.53154,left_val:0.23797},{features:[[13,11,3,4,-1.],[13,13,3,2,2.]],threshold:-0.025622,right_val:0.51388,left_val:0.19647},{features:[[4,11,3,4,-1.],[4,13,3,2,2.]],threshold:-7.5741e-005,right_val:0.33659,left_val:0.55905},{features:[[5,9,12,8,-1.],[11,9,6,4,2.],[5,13,6,4,2.]],threshold:-0.089211,right_val:0.51626,left_val:0.063405},{features:[[9,12,1,3,-1.],[9,13,1,1,3.]],threshold:-2.767e-003,right_val:0.44907,left_val:0.73235},{features:[[10,15,2,4,-1.],[10,17,2,2,2.]],threshold:2.7153e-004,right_val:0.59855,left_val:0.41148}],threshold:23.919},{simpleClassifiers:[{features:[[7,7,6,1,-1.],[9,7,2,1,3.]],threshold:1.4786e-003,right_val:0.66433,left_val:0.26635},{features:[[12,3,6,6,-1.],[15,3,3,3,2.],[12,6,3,3,2.]],threshold:-1.8742e-003,right_val:0.25185,left_val:0.61438},{features:[[0,4,10,6,-1.],[0,6,10,2,3.]],threshold:-1.7151e-003,right_val:0.23975,left_val:0.57663},{features:[[8,3,8,14,-1.],[12,3,4,7,2.],[8,10,4,7,2.]],threshold:-1.8939e-003,right_val:0.25291,left_val:0.5682},{features:[[4,4,7,15,-1.],[4,9,7,5,3.]],threshold:-5.3006e-003,right_val:0.55561,left_val:0.16407},{features:[[12,2,6,8,-1.],[15,2,3,4,2.],[12,6,3,4,2.]],threshold:-0.046663,right_val:0.47628,left_val:0.61232},{features:[[2,2,6,8,-1.],[2,2,3,4,2.],[5,6,3,4,2.]],threshold:-7.9431e-004,right_val:0.28394,left_val:0.57079},{features:[[2,13,18,7,-1.],[8,13,6,7,3.]],threshold:0.014892,right_val:0.60064,left_val:0.40897},{features:[[4,3,8,14,-1.],[4,3,4,7,2.],[8,10,4,7,2.]],threshold:-1.2047e-003,right_val:0.27053,left_val:0.57125},{features:[[18,1,2,6,-1.],[18,3,2,2,3.]],threshold:6.0619e-003,right_val:0.32622,left_val:0.52625},{features:[[9,11,2,3,-1.],[9,12,2,1,3.]],threshold:-2.5287e-003,right_val:0.41993,left_val:0.68538},{features:[[18,1,2,6,-1.],[18,3,2,2,3.]],threshold:-5.901e-003,right_val:0.54348,left_val:0.32663},{features:[[0,1,2,6,-1.],[0,3,2,2,3.]],threshold:5.6703e-003,right_val:0.2319,left_val:0.54684},{features:[[1,5,18,6,-1.],[1,7,18,2,3.]],threshold:-3.0304e-003,right_val:0.27082,left_val:0.55707},{features:[[0,2,6,7,-1.],[3,2,3,7,2.]],threshold:2.9804e-003,right_val:0.58906,left_val:0.37006},{features:[[7,3,6,14,-1.],[7,10,6,7,2.]],threshold:-0.075841,right_val:0.54199,left_val:0.21401},{features:[[3,7,13,10,-1.],[3,12,13,5,2.]],threshold:0.019263,right_val:0.27266,left_val:0.55268},{features:[[11,15,2,2,-1.],[11,16,2,1,2.]],threshold:1.8888e-004,right_val:0.60172,left_val:0.3958},{features:[[2,11,16,4,-1.],[2,11,8,2,2.],[10,13,8,2,2.]],threshold:0.02937,right_val:0.14358,left_val:0.52414},{features:[[13,7,6,4,-1.],[16,7,3,2,2.],[13,9,3,2,2.]],threshold:1.0418e-003,right_val:0.593,left_val:0.33854},{features:[[6,10,3,9,-1.],[6,13,3,3,3.]],threshold:2.6126e-003,right_val:0.30216,left_val:0.54854},{features:[[14,6,1,6,-1.],[14,9,1,3,2.]],threshold:9.6977e-004,right_val:0.5532,left_val:0.33753},{features:[[5,10,4,1,-1.],[7,10,2,1,2.]],threshold:5.9513e-004,right_val:0.33594,left_val:0.56317},{features:[[3,8,15,5,-1.],[8,8,5,5,3.]],threshold:-0.10157,right_val:0.52304,left_val:0.063735},{features:[[1,6,5,4,-1.],[1,8,5,2,2.]],threshold:0.036157,right_val:0.10295,left_val:0.5137},{features:[[3,1,17,6,-1.],[3,3,17,2,3.]],threshold:3.4624e-003,right_val:0.55583,left_val:0.38793},{features:[[6,7,8,2,-1.],[10,7,4,2,2.]],threshold:0.019555,right_val:0.18759,left_val:0.52501},{features:[[9,7,3,2,-1.],[10,7,1,2,3.]],threshold:-2.3121e-003,right_val:0.46796,left_val:0.6672},{features:[[8,7,3,2,-1.],[9,7,1,2,3.]],threshold:-1.8605e-003,right_val:0.43347,left_val:0.71634},{features:[[8,9,4,2,-1.],[8,10,4,1,2.]],threshold:-9.4026e-004,right_val:0.56502,left_val:0.30214},{features:[[8,8,4,3,-1.],[8,9,4,1,3.]],threshold:-5.2418e-003,right_val:0.52503,left_val:0.182},{features:[[9,5,6,4,-1.],[9,5,3,4,2.]],threshold:1.1729e-004,right_val:0.5446,left_val:0.33892},{features:[[8,13,4,3,-1.],[8,14,4,1,3.]],threshold:1.1879e-003,right_val:0.62536,left_val:0.40853},{features:[[4,7,12,6,-1.],[10,7,6,3,2.],[4,10,6,3,2.]],threshold:-0.010881,right_val:0.57001,left_val:0.33784},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:1.7355e-003,right_val:0.6523,left_val:0.42046},{features:[[9,7,3,3,-1.],[9,8,3,1,3.]],threshold:-6.5119e-003,right_val:0.54281,left_val:0.25952},{features:[[7,4,3,8,-1.],[8,4,1,8,3.]],threshold:-1.2136e-003,right_val:0.39779,left_val:0.61651},{features:[[10,0,3,6,-1.],[11,0,1,6,3.]],threshold:-0.010354,right_val:0.52195,left_val:0.1628},{features:[[6,3,4,8,-1.],[8,3,2,8,2.]],threshold:5.5859e-004,right_val:0.55036,left_val:0.31997},{features:[[14,3,6,13,-1.],[14,3,3,13,2.]],threshold:0.0153,right_val:0.61224,left_val:0.4104},{features:[[8,13,3,6,-1.],[8,16,3,3,2.]],threshold:-0.021588,right_val:0.51974,left_val:0.10349},{features:[[14,3,6,13,-1.],[14,3,3,13,2.]],threshold:-0.12835,right_val:0.48931,left_val:0.84939},{features:[[0,7,10,4,-1.],[0,7,5,2,2.],[5,9,5,2,2.]],threshold:-2.2927e-003,right_val:0.54716,left_val:0.31302},{features:[[14,3,6,13,-1.],[14,3,3,13,2.]],threshold:0.079915,right_val:0.6074,left_val:0.48563},{features:[[0,3,6,13,-1.],[3,3,3,13,2.]],threshold:-0.079441,right_val:0.46245,left_val:0.83947},{features:[[9,1,4,1,-1.],[9,1,2,1,2.]],threshold:-5.28e-003,right_val:0.53067,left_val:0.18817},{features:[[8,0,2,1,-1.],[9,0,1,1,2.]],threshold:1.0463e-003,right_val:0.25831,left_val:0.52712},{features:[[10,16,4,4,-1.],[12,16,2,2,2.],[10,18,2,2,2.]],threshold:2.6317e-004,right_val:0.57354,left_val:0.42353},{features:[[9,6,2,3,-1.],[10,6,1,3,2.]],threshold:-3.6173e-003,right_val:0.44954,left_val:0.69344},{features:[[4,5,12,2,-1.],[8,5,4,2,3.]],threshold:0.011422,right_val:0.41382,left_val:0.59009},{features:[[8,7,3,5,-1.],[9,7,1,5,3.]],threshold:-1.9963e-003,right_val:0.43272,left_val:0.64664}],threshold:24.528},{simpleClassifiers:[{features:[[6,4,8,6,-1.],[6,6,8,2,3.]],threshold:-9.9691e-003,right_val:0.24822,left_val:0.61423},{features:[[9,5,2,12,-1.],[9,11,2,6,2.]],threshold:7.3073e-004,right_val:0.2322,left_val:0.5705},{features:[[4,6,6,8,-1.],[4,10,6,4,2.]],threshold:6.4045e-004,right_val:0.58149,left_val:0.21123},{features:[[12,2,8,5,-1.],[12,2,4,5,2.]],threshold:4.5424e-003,right_val:0.58663,left_val:0.29505},{features:[[0,8,18,3,-1.],[0,9,18,1,3.]],threshold:9.2477e-005,right_val:0.57913,left_val:0.2991},{features:[[8,12,4,8,-1.],[8,16,4,4,2.]],threshold:-8.6603e-003,right_val:0.56355,left_val:0.2813},{features:[[0,2,8,5,-1.],[4,2,4,5,2.]],threshold:8.0516e-003,right_val:0.60548,left_val:0.35354},{features:[[13,11,3,4,-1.],[13,13,3,2,2.]],threshold:4.3835e-004,right_val:0.27315,left_val:0.55965},{features:[[5,11,6,1,-1.],[7,11,2,1,3.]],threshold:-9.8169e-005,right_val:0.36386,left_val:0.5978},{features:[[11,3,3,1,-1.],[12,3,1,1,3.]],threshold:-1.1299e-003,right_val:0.54327,left_val:0.27553},{features:[[7,13,5,3,-1.],[7,14,5,1,3.]],threshold:6.4356e-003,right_val:0.70698,left_val:0.43056},{features:[[11,11,7,6,-1.],[11,14,7,3,2.]],threshold:-0.056829,right_val:0.5295,left_val:0.24952},{features:[[2,11,7,6,-1.],[2,14,7,3,2.]],threshold:4.0668e-003,right_val:0.24977,left_val:0.54786},{features:[[12,14,2,6,-1.],[12,16,2,2,3.]],threshold:4.8165e-005,right_val:0.57064,left_val:0.39386},{features:[[8,14,3,3,-1.],[8,15,3,1,3.]],threshold:6.1795e-003,right_val:0.73948,left_val:0.44076},{features:[[11,0,3,5,-1.],[12,0,1,5,3.]],threshold:6.4986e-003,right_val:0.24792,left_val:0.54452},{features:[[6,1,4,9,-1.],[8,1,2,9,2.]],threshold:-1.0211e-003,right_val:0.5339,left_val:0.25448},{features:[[10,3,6,1,-1.],[12,3,2,1,3.]],threshold:-5.4248e-003,right_val:0.53241,left_val:0.27189},{features:[[8,8,3,4,-1.],[8,10,3,2,2.]],threshold:-1.056e-003,right_val:0.55345,left_val:0.31783},{features:[[8,12,4,2,-1.],[8,13,4,1,2.]],threshold:6.6466e-004,right_val:0.65582,left_val:0.42842},{features:[[5,18,4,2,-1.],[5,19,4,1,2.]],threshold:-2.7524e-004,right_val:0.38103,left_val:0.59029},{features:[[2,1,18,6,-1.],[2,3,18,2,3.]],threshold:4.2293e-003,right_val:0.57094,left_val:0.38165},{features:[[6,0,3,2,-1.],[7,0,1,2,3.]],threshold:-3.2868e-003,right_val:0.52595,left_val:0.17477},{features:[[13,8,6,2,-1.],[16,8,3,1,2.],[13,9,3,1,2.]],threshold:1.5612e-004,right_val:0.57256,left_val:0.36017},{features:[[6,10,3,6,-1.],[6,13,3,3,2.]],threshold:-7.3621e-006,right_val:0.30445,left_val:0.54019},{features:[[0,13,20,4,-1.],[10,13,10,2,2.],[0,15,10,2,2.]],threshold:-0.014767,right_val:0.55734,left_val:0.32208},{features:[[7,7,6,5,-1.],[9,7,2,5,3.]],threshold:0.02449,right_val:0.65188,left_val:0.43015},{features:[[11,0,2,2,-1.],[11,1,2,1,2.]],threshold:-3.7652e-004,right_val:0.55982,left_val:0.35646},{features:[[1,8,6,2,-1.],[1,8,3,1,2.],[4,9,3,1,2.]],threshold:7.3658e-006,right_val:0.55619,left_val:0.34908},{features:[[0,2,20,2,-1.],[10,2,10,1,2.],[0,3,10,1,2.]],threshold:-0.0151,right_val:0.53353,left_val:0.17763},{features:[[7,14,5,3,-1.],[7,15,5,1,3.]],threshold:-3.8317e-003,right_val:0.42214,left_val:0.61497},{features:[[7,13,6,6,-1.],[10,13,3,3,2.],[7,16,3,3,2.]],threshold:0.016925,right_val:0.21666,left_val:0.5413},{features:[[9,12,2,3,-1.],[9,13,2,1,3.]],threshold:-3.0478e-003,right_val:0.43546,left_val:0.64495},{features:[[16,11,1,6,-1.],[16,13,1,2,3.]],threshold:3.2141e-003,right_val:0.35232,left_val:0.54002},{features:[[3,11,1,6,-1.],[3,13,1,2,3.]],threshold:-4.0023e-003,right_val:0.53384,left_val:0.27745},{features:[[4,4,14,12,-1.],[11,4,7,6,2.],[4,10,7,6,2.]],threshold:7.4182e-003,right_val:0.37028,left_val:0.56767},{features:[[5,4,3,3,-1.],[5,5,3,1,3.]],threshold:-8.8765e-003,right_val:0.45837,left_val:0.77492},{features:[[12,3,3,3,-1.],[13,3,1,3,3.]],threshold:2.7312e-003,right_val:0.39967,left_val:0.53387},{features:[[6,6,8,3,-1.],[6,7,8,1,3.]],threshold:-2.5082e-003,right_val:0.37775,left_val:0.5612},{features:[[12,3,3,3,-1.],[13,3,1,3,3.]],threshold:-8.0541e-003,right_val:0.51792,left_val:0.29152},{features:[[3,1,4,10,-1.],[3,1,2,5,2.],[5,6,2,5,2.]],threshold:-9.7939e-004,right_val:0.37002,left_val:0.55364},{features:[[5,7,10,2,-1.],[5,7,5,2,2.]],threshold:-5.8746e-003,right_val:0.56794,left_val:0.37544},{features:[[8,7,3,3,-1.],[9,7,1,3,3.]],threshold:-4.4937e-003,right_val:0.44809,left_val:0.70197},{features:[[15,12,2,3,-1.],[15,13,2,1,3.]],threshold:-5.4389e-003,right_val:0.53134,left_val:0.23104},{features:[[7,8,3,4,-1.],[8,8,1,4,3.]],threshold:-7.5095e-004,right_val:0.41293,left_val:0.58649},{features:[[13,4,1,12,-1.],[13,10,1,6,2.]],threshold:1.4529e-005,right_val:0.56196,left_val:0.37324},{features:[[4,5,12,12,-1.],[4,5,6,6,2.],[10,11,6,6,2.]],threshold:0.040758,right_val:0.27205,left_val:0.53121},{features:[[7,14,7,3,-1.],[7,15,7,1,3.]],threshold:6.6506e-003,right_val:0.66935,left_val:0.471},{features:[[3,12,2,3,-1.],[3,13,2,1,3.]],threshold:4.5759e-003,right_val:0.16373,left_val:0.51678},{features:[[3,2,14,2,-1.],[10,2,7,1,2.],[3,3,7,1,2.]],threshold:6.5269e-003,right_val:0.29385,left_val:0.53976},{features:[[0,1,3,10,-1.],[1,1,1,10,3.]],threshold:-0.01366,right_val:0.45322,left_val:0.70865},{features:[[9,0,6,5,-1.],[11,0,2,5,3.]],threshold:0.027359,right_val:0.35892,left_val:0.52065},{features:[[5,7,6,2,-1.],[8,7,3,2,2.]],threshold:6.2198e-004,right_val:0.54411,left_val:0.35071},{features:[[7,1,6,10,-1.],[7,6,6,5,2.]],threshold:-3.3077e-003,right_val:0.40249,left_val:0.58595},{features:[[1,1,18,3,-1.],[7,1,6,3,3.]],threshold:-0.010631,right_val:0.44226,left_val:0.67433},{features:[[16,3,3,6,-1.],[16,5,3,2,3.]],threshold:0.019442,right_val:0.17979,left_val:0.52827}],threshold:27.153},{simpleClassifiers:[{features:[[6,3,7,6,-1.],[6,6,7,3,2.]],threshold:-5.5052e-003,right_val:0.26266,left_val:0.59147},{features:[[4,7,12,2,-1.],[8,7,4,2,3.]],threshold:1.9562e-003,right_val:0.57416,left_val:0.23126},{features:[[0,4,17,10,-1.],[0,9,17,5,2.]],threshold:-8.8925e-003,right_val:0.56267,left_val:0.16565},{features:[[3,4,15,16,-1.],[3,12,15,8,2.]],threshold:0.083638,right_val:0.19573,left_val:0.54234},{features:[[7,15,6,4,-1.],[7,17,6,2,2.]],threshold:1.2282e-003,right_val:0.59925,left_val:0.34179},{features:[[15,2,4,9,-1.],[15,2,2,9,2.]],threshold:5.7629e-003,right_val:0.60799,left_val:0.37196},{features:[[2,3,3,2,-1.],[2,4,3,1,2.]],threshold:-1.6417e-003,right_val:0.55769,left_val:0.25775},{features:[[13,6,7,9,-1.],[13,9,7,3,3.]],threshold:3.4113e-003,right_val:0.55142,left_val:0.29507},{features:[[8,11,4,3,-1.],[8,12,4,1,3.]],threshold:-0.011069,right_val:0.44771,left_val:0.75694},{features:[[0,2,20,6,-1.],[10,2,10,3,2.],[0,5,10,3,2.]],threshold:0.034866,right_val:0.26696,left_val:0.55837},{features:[[3,2,6,10,-1.],[3,2,3,5,2.],[6,7,3,5,2.]],threshold:6.5701e-004,right_val:0.29889,left_val:0.56273},{features:[[13,10,3,4,-1.],[13,12,3,2,2.]],threshold:-0.024339,right_val:0.51089,left_val:0.27712},{features:[[4,10,3,4,-1.],[4,12,3,2,2.]],threshold:5.9435e-004,right_val:0.31203,left_val:0.55807},{features:[[7,5,6,3,-1.],[9,5,2,3,3.]],threshold:2.2972e-003,right_val:0.56791,left_val:0.33303},{features:[[7,6,6,8,-1.],[7,10,6,4,2.]],threshold:-3.7802e-003,right_val:0.53448,left_val:0.29905},{features:[[0,11,20,6,-1.],[0,14,20,3,2.]],threshold:-0.13421,right_val:0.53926,left_val:0.14639},{features:[[4,13,4,6,-1.],[4,13,2,3,2.],[6,16,2,3,2.]],threshold:7.5225e-004,right_val:0.56927,left_val:0.3747},{features:[[6,0,8,12,-1.],[10,0,4,6,2.],[6,6,4,6,2.]],threshold:-0.040546,right_val:0.54843,left_val:0.27547},{features:[[2,0,15,2,-1.],[2,1,15,1,2.]],threshold:1.2573e-003,right_val:0.57561,left_val:0.37446},{features:[[9,12,2,3,-1.],[9,13,2,1,3.]],threshold:-7.425e-003,right_val:0.47282,left_val:0.75139},{features:[[3,12,1,2,-1.],[3,13,1,1,2.]],threshold:5.0908e-004,right_val:0.29323,left_val:0.54049},{features:[[9,11,2,3,-1.],[9,12,2,1,3.]],threshold:-1.2808e-003,right_val:0.42733,left_val:0.61698},{features:[[7,3,3,1,-1.],[8,3,1,1,3.]],threshold:-1.8349e-003,right_val:0.52065,left_val:0.20485},{features:[[17,7,3,6,-1.],[17,9,3,2,3.]],threshold:0.027485,right_val:0.16755,left_val:0.5253},{features:[[7,2,3,2,-1.],[8,2,1,2,3.]],threshold:2.2372e-003,right_val:0.27777,left_val:0.52678},{features:[[11,4,5,3,-1.],[11,5,5,1,3.]],threshold:-8.8635e-003,right_val:0.4812,left_val:0.69546},{features:[[4,4,5,3,-1.],[4,5,5,1,3.]],threshold:4.1754e-003,right_val:0.63492,left_val:0.42919},{features:[[19,3,1,2,-1.],[19,4,1,1,2.]],threshold:-1.7098e-003,right_val:0.53612,left_val:0.29305},{features:[[5,5,4,3,-1.],[5,6,4,1,3.]],threshold:6.5329e-003,right_val:0.74097,left_val:0.44953},{features:[[17,7,3,6,-1.],[17,9,3,2,3.]],threshold:-9.5373e-003,right_val:0.54165,left_val:0.31491},{features:[[0,7,3,6,-1.],[0,9,3,2,3.]],threshold:0.025311,right_val:0.13117,left_val:0.51219},{features:[[14,2,6,9,-1.],[14,5,6,3,3.]],threshold:0.036461,right_val:0.25913,left_val:0.51759},{features:[[0,4,5,6,-1.],[0,6,5,2,3.]],threshold:0.020854,right_val:0.15823,left_val:0.51371},{features:[[10,5,6,2,-1.],[12,5,2,2,3.]],threshold:-8.7208e-004,right_val:0.4399,left_val:0.55743},{features:[[4,5,6,2,-1.],[6,5,2,2,3.]],threshold:-1.5227e-005,right_val:0.37081,left_val:0.55489},{features:[[8,1,4,6,-1.],[8,3,4,2,3.]],threshold:-8.4317e-004,right_val:0.55542,left_val:0.33874},{features:[[0,2,3,6,-1.],[0,4,3,2,3.]],threshold:3.6038e-003,right_val:0.34112,left_val:0.53581},{features:[[6,6,8,3,-1.],[6,7,8,1,3.]],threshold:-6.8058e-003,right_val:0.43459,left_val:0.61252},{features:[[0,1,5,9,-1.],[0,4,5,3,3.]],threshold:-0.047022,right_val:0.51937,left_val:0.23582},{features:[[16,0,4,15,-1.],[16,0,2,15,2.]],threshold:-0.036954,right_val:0.47609,left_val:0.73231},{features:[[1,10,3,2,-1.],[1,11,3,1,2.]],threshold:1.0439e-003,right_val:0.34113,left_val:0.54195},{features:[[14,4,1,10,-1.],[14,9,1,5,2.]],threshold:-2.1051e-004,right_val:0.55549,left_val:0.28217},{features:[[0,1,4,12,-1.],[2,1,2,12,2.]],threshold:-0.080832,right_val:0.46974,left_val:0.91299},{features:[[11,11,4,2,-1.],[11,11,2,2,2.]],threshold:-3.6579e-004,right_val:0.39783,left_val:0.60227},{features:[[5,11,4,2,-1.],[7,11,2,2,2.]],threshold:-1.2546e-004,right_val:0.38455,left_val:0.56132},{features:[[3,8,15,5,-1.],[8,8,5,5,3.]],threshold:-0.068786,right_val:0.53005,left_val:0.22616},{features:[[0,0,6,10,-1.],[3,0,3,10,2.]],threshold:0.012416,right_val:0.58288,left_val:0.40757},{features:[[11,4,3,2,-1.],[12,4,1,2,3.]],threshold:-4.7175e-003,right_val:0.52678,left_val:0.28273},{features:[[8,12,3,8,-1.],[8,16,3,4,2.]],threshold:0.038137,right_val:0.10236,left_val:0.50747},{features:[[8,14,5,3,-1.],[8,15,5,1,3.]],threshold:-2.8168e-003,right_val:0.43597,left_val:0.6169},{features:[[7,14,4,3,-1.],[7,15,4,1,3.]],threshold:8.1304e-003,right_val:0.76061,left_val:0.45244},{features:[[11,4,3,2,-1.],[12,4,1,2,3.]],threshold:6.0056e-003,right_val:0.18597,left_val:0.52404},{features:[[3,15,14,4,-1.],[3,15,7,2,2.],[10,17,7,2,2.]],threshold:0.019139,right_val:0.23321,left_val:0.52094},{features:[[2,2,16,4,-1.],[10,2,8,2,2.],[2,4,8,2,2.]],threshold:0.016446,right_val:0.32642,left_val:0.54507},{features:[[0,8,6,12,-1.],[3,8,3,12,2.]],threshold:-0.037357,right_val:0.45332,left_val:0.6999},{features:[[5,7,10,2,-1.],[5,7,5,2,2.]],threshold:-0.019728,right_val:0.54128,left_val:0.26537},{features:[[9,7,2,5,-1.],[10,7,1,5,2.]],threshold:6.6973e-003,right_val:0.71387,left_val:0.44806},{features:[[13,7,6,4,-1.],[16,7,3,2,2.],[13,9,3,2,2.]],threshold:7.4458e-004,right_val:0.54713,left_val:0.42314},{features:[[0,13,8,2,-1.],[0,14,8,1,2.]],threshold:1.1791e-003,right_val:0.31305,left_val:0.53417},{features:[[13,7,6,4,-1.],[16,7,3,2,2.],[13,9,3,2,2.]],threshold:0.034981,right_val:0.34305,left_val:0.51187},{features:[[1,7,6,4,-1.],[1,7,3,2,2.],[4,9,3,2,2.]],threshold:5.686e-004,right_val:0.54686,left_val:0.35322},{features:[[12,6,1,12,-1.],[12,12,1,6,2.]],threshold:-0.011341,right_val:0.53487,left_val:0.28424},{features:[[9,5,2,6,-1.],[10,5,1,6,2.]],threshold:-6.6228e-003,right_val:0.44927,left_val:0.68836},{features:[[14,12,2,3,-1.],[14,13,2,1,3.]],threshold:-8.016e-003,right_val:0.52243,left_val:0.17099},{features:[[4,12,2,3,-1.],[4,13,2,1,3.]],threshold:1.4207e-003,right_val:0.29934,left_val:0.52908},{features:[[8,12,4,3,-1.],[8,13,4,1,3.]],threshold:-2.7802e-003,right_val:0.44605,left_val:0.64989},{features:[[5,2,2,4,-1.],[5,2,1,2,2.],[6,4,1,2,2.]],threshold:-1.4748e-003,right_val:0.53881,left_val:0.32604},{features:[[5,5,11,3,-1.],[5,6,11,1,3.]],threshold:-0.02383,right_val:0.48012,left_val:0.75289},{features:[[7,6,4,12,-1.],[7,12,4,6,2.]],threshold:6.937e-003,right_val:0.32614,left_val:0.53352},{features:[[12,13,8,5,-1.],[12,13,4,5,2.]],threshold:8.2806e-003,right_val:0.57378,left_val:0.45804},{features:[[7,6,1,12,-1.],[7,12,1,6,2.]],threshold:-0.01044,right_val:0.52338,left_val:0.25923}],threshold:34.554},{simpleClassifiers:[{features:[[1,2,6,3,-1.],[4,2,3,3,2.]],threshold:7.2007e-003,right_val:0.68498,left_val:0.32589},{features:[[9,5,6,10,-1.],[12,5,3,5,2.],[9,10,3,5,2.]],threshold:-2.8594e-003,right_val:0.25378,left_val:0.58389},{features:[[5,5,8,12,-1.],[5,5,4,6,2.],[9,11,4,6,2.]],threshold:6.8581e-004,right_val:0.28124,left_val:0.57081},{features:[[0,7,20,6,-1.],[0,9,20,2,3.]],threshold:7.958e-003,right_val:0.55443,left_val:0.25011},{features:[[4,2,2,2,-1.],[4,3,2,1,2.]],threshold:-1.2124e-003,right_val:0.54334,left_val:0.23854},{features:[[4,18,12,2,-1.],[8,18,4,2,3.]],threshold:7.9426e-003,right_val:0.62208,left_val:0.39551},{features:[[7,4,4,16,-1.],[7,12,4,8,2.]],threshold:2.4631e-003,right_val:0.29924,left_val:0.56397},{features:[[7,6,7,8,-1.],[7,10,7,4,2.]],threshold:-6.0397e-003,right_val:0.54117,left_val:0.21865},{features:[[6,3,3,1,-1.],[7,3,1,1,3.]],threshold:-1.2988e-003,right_val:0.53646,left_val:0.23507},{features:[[11,15,2,4,-1.],[11,17,2,2,2.]],threshold:2.2299e-004,right_val:0.57296,left_val:0.38041},{features:[[3,5,4,8,-1.],[3,9,4,4,2.]],threshold:1.4654e-003,right_val:0.52583,left_val:0.25102},{features:[[7,1,6,12,-1.],[7,7,6,6,2.]],threshold:-8.121e-004,right_val:0.38512,left_val:0.59928},{features:[[4,6,6,2,-1.],[6,6,2,2,3.]],threshold:-1.3836e-003,right_val:0.36366,left_val:0.56814},{features:[[16,4,4,6,-1.],[16,6,4,2,3.]],threshold:-0.027936,right_val:0.53776,left_val:0.14913},{features:[[3,3,5,2,-1.],[3,4,5,1,2.]],threshold:-4.692e-004,right_val:0.55725,left_val:0.36924},{features:[[9,11,2,3,-1.],[9,12,2,1,3.]],threshold:-4.983e-003,right_val:0.45325,left_val:0.67585},{features:[[2,16,4,2,-1.],[2,17,4,1,2.]],threshold:1.8815e-003,right_val:0.29325,left_val:0.5368},{features:[[7,13,6,6,-1.],[10,13,3,3,2.],[7,16,3,3,2.]],threshold:-0.019068,right_val:0.53301,left_val:0.16494},{features:[[7,0,3,4,-1.],[8,0,1,4,3.]],threshold:-4.6907e-003,right_val:0.51194,left_val:0.19639},{features:[[8,15,4,3,-1.],[8,16,4,1,3.]],threshold:5.9777e-003,right_val:0.70084,left_val:0.46712},{features:[[0,4,4,6,-1.],[0,6,4,2,3.]],threshold:-0.033303,right_val:0.51042,left_val:0.11554},{features:[[5,6,12,3,-1.],[9,6,4,3,3.]],threshold:0.090744,right_val:0.13062,left_val:0.51497},{features:[[7,6,6,14,-1.],[9,6,2,14,3.]],threshold:9.3556e-004,right_val:0.54399,left_val:0.36055},{features:[[9,7,3,3,-1.],[10,7,1,3,3.]],threshold:0.014902,right_val:0.76876,left_val:0.48862},{features:[[6,12,2,4,-1.],[6,14,2,2,2.]],threshold:6.1594e-004,right_val:0.32409,left_val:0.53568},{features:[[10,12,7,6,-1.],[10,14,7,2,3.]],threshold:-0.050671,right_val:0.52304,left_val:0.18486},{features:[[1,0,15,2,-1.],[1,1,15,1,2.]],threshold:6.8666e-004,right_val:0.55179,left_val:0.38406},{features:[[14,0,6,6,-1.],[14,0,3,6,2.]],threshold:8.3712e-003,right_val:0.61318,left_val:0.42886},{features:[[5,3,3,1,-1.],[6,3,1,1,3.]],threshold:-1.2953e-003,right_val:0.52807,left_val:0.29137},{features:[[14,0,6,6,-1.],[14,0,3,6,2.]],threshold:-0.041942,right_val:0.4856,left_val:0.75548},{features:[[0,3,20,10,-1.],[0,8,20,5,2.]],threshold:-0.023529,right_val:0.52561,left_val:0.28383},{features:[[14,0,6,6,-1.],[14,0,3,6,2.]],threshold:0.040857,right_val:0.62773,left_val:0.48709},{features:[[0,0,6,6,-1.],[3,0,3,6,2.]],threshold:-0.025407,right_val:0.4575,left_val:0.70997},{features:[[19,15,1,2,-1.],[19,16,1,1,2.]],threshold:-4.1415e-004,right_val:0.54694,left_val:0.40309},{features:[[0,2,4,8,-1.],[2,2,2,8,2.]],threshold:0.021824,right_val:0.67687,left_val:0.4502},{features:[[2,1,18,4,-1.],[11,1,9,2,2.],[2,3,9,2,2.]],threshold:0.014114,right_val:0.37917,left_val:0.54429},{features:[[8,12,1,2,-1.],[8,13,1,1,2.]],threshold:6.7215e-005,right_val:0.58735,left_val:0.42005},{features:[[5,2,10,6,-1.],[10,2,5,3,2.],[5,5,5,3,2.]],threshold:-7.9418e-003,right_val:0.55853,left_val:0.37926},{features:[[9,7,2,4,-1.],[10,7,1,4,2.]],threshold:-7.2144e-003,right_val:0.46035,left_val:0.72531},{features:[[9,7,3,3,-1.],[10,7,1,3,3.]],threshold:2.5817e-003,right_val:0.59002,left_val:0.46933},{features:[[4,5,12,8,-1.],[8,5,4,8,3.]],threshold:0.13409,right_val:0.18088,left_val:0.51492},{features:[[15,15,4,3,-1.],[15,16,4,1,3.]],threshold:2.2963e-003,right_val:0.37179,left_val:0.53997},{features:[[8,18,3,1,-1.],[9,18,1,1,3.]],threshold:-2.1576e-003,right_val:0.51489,left_val:0.24085},{features:[[9,13,4,3,-1.],[9,14,4,1,3.]],threshold:-4.9196e-003,right_val:0.47387,left_val:0.65736},{features:[[7,13,4,3,-1.],[7,14,4,1,3.]],threshold:1.6267e-003,right_val:0.63031,left_val:0.41928},{features:[[19,15,1,2,-1.],[19,16,1,1,2.]],threshold:3.3413e-004,right_val:0.37021,left_val:0.55403},{features:[[0,15,8,4,-1.],[0,17,8,2,2.]],threshold:-0.026698,right_val:0.51014,left_val:0.17109},{features:[[9,3,6,4,-1.],[11,3,2,4,3.]],threshold:-0.030562,right_val:0.51688,left_val:0.19042},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:2.8512e-003,right_val:0.63139,left_val:0.44475},{features:[[3,14,14,6,-1.],[3,16,14,2,3.]],threshold:-0.036211,right_val:0.53773,left_val:0.24907},{features:[[6,3,6,6,-1.],[6,6,6,3,2.]],threshold:-2.4115e-003,right_val:0.36642,left_val:0.53812},{features:[[5,11,10,6,-1.],[5,14,10,3,2.]],threshold:-7.7253e-004,right_val:0.35416,left_val:0.55302},{features:[[3,10,3,4,-1.],[4,10,1,4,3.]],threshold:2.9482e-004,right_val:0.56672,left_val:0.41327},{features:[[13,9,2,2,-1.],[13,9,1,2,2.]],threshold:-6.2335e-003,right_val:0.51987,left_val:0.098787},{features:[[5,3,6,4,-1.],[7,3,2,4,3.]],threshold:-0.026275,right_val:0.50281,left_val:0.091127},{features:[[9,7,3,3,-1.],[10,7,1,3,3.]],threshold:5.3212e-003,right_val:0.62227,left_val:0.47266},{features:[[2,12,2,3,-1.],[2,13,2,1,3.]],threshold:-4.1129e-003,right_val:0.51378,left_val:0.21575},{features:[[9,8,3,12,-1.],[9,12,3,4,3.]],threshold:3.2458e-003,right_val:0.37218,left_val:0.54108},{features:[[3,14,4,6,-1.],[3,14,2,3,2.],[5,17,2,3,2.]],threshold:-0.01636,right_val:0.46853,left_val:0.77879},{features:[[16,15,2,2,-1.],[16,16,2,1,2.]],threshold:3.2166e-004,right_val:0.42404,left_val:0.5479},{features:[[2,15,2,2,-1.],[2,16,2,1,2.]],threshold:6.4452e-004,right_val:0.35013,left_val:0.53306},{features:[[8,12,4,3,-1.],[8,13,4,1,3.]],threshold:-7.891e-003,right_val:0.47266,left_val:0.69235},{features:[[0,7,20,1,-1.],[10,7,10,1,2.]],threshold:0.048336,right_val:0.075749,left_val:0.50559},{features:[[7,6,8,3,-1.],[7,6,4,3,2.]],threshold:-7.5178e-004,right_val:0.55386,left_val:0.37837},{features:[[5,7,8,2,-1.],[9,7,4,2,2.]],threshold:-2.4954e-003,right_val:0.53596,left_val:0.30817},{features:[[9,7,3,5,-1.],[10,7,1,5,3.]],threshold:-2.2385e-003,right_val:0.46493,left_val:0.6634},{features:[[8,7,3,5,-1.],[9,7,1,5,3.]],threshold:-1.7988e-003,right_val:0.43472,left_val:0.65968},{features:[[11,1,3,5,-1.],[12,1,1,5,3.]],threshold:8.7861e-003,right_val:0.23156,left_val:0.52318},{features:[[6,2,3,6,-1.],[7,2,1,6,3.]],threshold:3.6715e-003,right_val:0.29774,left_val:0.52043},{features:[[14,14,6,5,-1.],[14,14,3,5,2.]],threshold:-0.035336,right_val:0.48615,left_val:0.72389},{features:[[9,8,2,2,-1.],[9,9,2,1,2.]],threshold:-6.9189e-004,right_val:0.52298,left_val:0.3105},{features:[[10,7,1,3,-1.],[10,8,1,1,3.]],threshold:-3.3946e-003,right_val:0.52102,left_val:0.3139},{features:[[6,6,2,2,-1.],[6,6,1,1,2.],[7,7,1,1,2.]],threshold:9.8569e-004,right_val:0.65851,left_val:0.45366},{features:[[2,11,18,4,-1.],[11,11,9,2,2.],[2,13,9,2,2.]],threshold:-0.050163,right_val:0.51989,left_val:0.18045},{features:[[6,6,2,2,-1.],[6,6,1,1,2.],[7,7,1,1,2.]],threshold:-2.2367e-003,right_val:0.46514,left_val:0.72557},{features:[[0,15,20,2,-1.],[0,16,20,1,2.]],threshold:7.4326e-004,right_val:0.58985,left_val:0.44129},{features:[[4,14,2,3,-1.],[4,15,2,1,3.]],threshold:-9.3485e-004,right_val:0.5366,left_val:0.35001},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:0.017498,right_val:0.83153,left_val:0.49122},{features:[[8,7,2,3,-1.],[8,8,2,1,3.]],threshold:-1.52e-003,right_val:0.53706,left_val:0.35703},{features:[[9,10,2,3,-1.],[9,11,2,1,3.]],threshold:7.8004e-004,right_val:0.59673,left_val:0.43538}],threshold:39.107},{simpleClassifiers:[{features:[[5,4,10,4,-1.],[5,6,10,2,2.]],threshold:-9.9946e-003,right_val:0.30545,left_val:0.61626},{features:[[9,7,6,4,-1.],[12,7,3,2,2.],[9,9,3,2,2.]],threshold:-1.1085e-003,right_val:0.31556,left_val:0.58183},{features:[[4,7,3,6,-1.],[4,9,3,2,3.]],threshold:1.0364e-003,right_val:0.56929,left_val:0.25521},{features:[[11,15,4,4,-1.],[13,15,2,2,2.],[11,17,2,2,2.]],threshold:6.8211e-004,right_val:0.59349,left_val:0.36851},{features:[[7,8,4,2,-1.],[7,9,4,1,2.]],threshold:-6.8057e-004,right_val:0.54748,left_val:0.23324},{features:[[13,1,4,3,-1.],[13,1,2,3,2.]],threshold:2.6069e-004,right_val:0.56675,left_val:0.32575},{features:[[5,15,4,4,-1.],[5,15,2,2,2.],[7,17,2,2,2.]],threshold:5.1607e-004,right_val:0.58455,left_val:0.37447},{features:[[9,5,4,7,-1.],[9,5,2,7,2.]],threshold:8.5008e-004,right_val:0.55228,left_val:0.34204},{features:[[5,6,8,3,-1.],[9,6,4,3,2.]],threshold:-1.8608e-003,right_val:0.53754,left_val:0.28044},{features:[[9,9,2,2,-1.],[9,10,2,1,2.]],threshold:-1.5034e-003,right_val:0.5499,left_val:0.25791},{features:[[7,15,5,3,-1.],[7,16,5,1,3.]],threshold:2.3479e-003,right_val:0.63137,left_val:0.41752},{features:[[11,10,4,3,-1.],[11,10,2,3,2.]],threshold:-2.888e-004,right_val:0.40527,left_val:0.58652},{features:[[6,9,8,10,-1.],[6,14,8,5,2.]],threshold:8.9405e-003,right_val:0.23187,left_val:0.52111},{features:[[10,11,6,2,-1.],[10,11,3,2,2.]],threshold:-0.019328,right_val:0.52415,left_val:0.27534},{features:[[4,11,6,2,-1.],[7,11,3,2,2.]],threshold:-2.0202e-004,right_val:0.36772,left_val:0.5723},{features:[[11,3,8,1,-1.],[11,3,4,1,2.]],threshold:2.1179e-003,right_val:0.55424,left_val:0.44661},{features:[[6,3,3,2,-1.],[7,3,1,2,3.]],threshold:-1.7744e-003,right_val:0.5301,left_val:0.28133},{features:[[14,5,6,5,-1.],[14,5,3,5,2.]],threshold:4.2234e-003,right_val:0.57954,left_val:0.43997},{features:[[7,5,2,12,-1.],[7,11,2,6,2.]],threshold:-0.014375,right_val:0.52921,left_val:0.29811},{features:[[8,11,4,3,-1.],[8,12,4,1,3.]],threshold:-0.015349,right_val:0.47482,left_val:0.77052},{features:[[4,1,2,3,-1.],[5,1,1,3,2.]],threshold:1.5152e-005,right_val:0.55769,left_val:0.37188},{features:[[18,3,2,6,-1.],[18,5,2,2,3.]],threshold:-9.1294e-003,right_val:0.52868,left_val:0.36152},{features:[[0,3,2,6,-1.],[0,5,2,2,3.]],threshold:2.2512e-003,right_val:0.34863,left_val:0.53647},{features:[[9,12,2,3,-1.],[9,13,2,1,3.]],threshold:-4.9697e-003,right_val:0.46768,left_val:0.69277},{features:[[7,13,4,3,-1.],[7,14,4,1,3.]],threshold:-0.012829,right_val:0.46607,left_val:0.77122},{features:[[18,0,2,6,-1.],[18,2,2,2,3.]],threshold:-9.366e-003,right_val:0.53513,left_val:0.3375},{features:[[0,0,2,6,-1.],[0,2,2,2,3.]],threshold:3.2452e-003,right_val:0.32896,left_val:0.53252},{features:[[8,14,6,3,-1.],[8,15,6,1,3.]],threshold:-0.011724,right_val:0.47543,left_val:0.68377},{features:[[7,4,2,4,-1.],[8,4,1,4,2.]],threshold:2.9258e-005,right_val:0.53605,left_val:0.35721},{features:[[8,5,4,6,-1.],[8,7,4,2,3.]],threshold:-2.2244e-005,right_val:0.35521,left_val:0.55414},{features:[[6,4,2,2,-1.],[7,4,1,2,2.]],threshold:5.0882e-003,right_val:0.12565,left_val:0.50708},{features:[[3,14,14,4,-1.],[10,14,7,2,2.],[3,16,7,2,2.]],threshold:0.02743,right_val:0.16258,left_val:0.52696},{features:[[6,15,6,2,-1.],[6,15,3,1,2.],[9,16,3,1,2.]],threshold:-6.4143e-003,right_val:0.45842,left_val:0.71456},{features:[[14,15,6,2,-1.],[14,16,6,1,2.]],threshold:3.348e-003,right_val:0.34947,left_val:0.53986},{features:[[2,12,12,8,-1.],[2,16,12,4,2.]],threshold:-0.082635,right_val:0.51602,left_val:0.24392},{features:[[7,7,7,2,-1.],[7,8,7,1,2.]],threshold:1.0262e-003,right_val:0.57679,left_val:0.38869},{features:[[0,2,18,2,-1.],[0,3,18,1,2.]],threshold:-1.6307e-003,right_val:0.53477,left_val:0.33895},{features:[[9,6,2,5,-1.],[9,6,1,5,2.]],threshold:2.4547e-003,right_val:0.63872,left_val:0.46014},{features:[[7,5,3,8,-1.],[8,5,1,8,3.]],threshold:-9.9477e-004,right_val:0.41204,left_val:0.57699},{features:[[9,6,3,4,-1.],[10,6,1,4,3.]],threshold:0.015409,right_val:0.70898,left_val:0.48787},{features:[[4,13,3,2,-1.],[4,14,3,1,2.]],threshold:1.1784e-003,right_val:0.28952,left_val:0.52636},{features:[[9,4,6,3,-1.],[11,4,2,3,3.]],threshold:-0.027702,right_val:0.52196,left_val:0.14988},{features:[[5,4,6,3,-1.],[7,4,2,3,3.]],threshold:-0.029505,right_val:0.49998,left_val:0.024893},{features:[[14,11,5,2,-1.],[14,12,5,1,2.]],threshold:4.5159e-004,right_val:0.40297,left_val:0.54646},{features:[[1,2,6,9,-1.],[3,2,2,9,3.]],threshold:7.1773e-003,right_val:0.58663,left_val:0.42711},{features:[[14,6,6,13,-1.],[14,6,3,13,2.]],threshold:-0.074182,right_val:0.4919,left_val:0.68742},{features:[[3,6,14,8,-1.],[3,6,7,4,2.],[10,10,7,4,2.]],threshold:-0.017254,right_val:0.53487,left_val:0.33707},{features:[[16,0,4,11,-1.],[16,0,2,11,2.]],threshold:0.014852,right_val:0.61299,left_val:0.46268},{features:[[3,4,12,12,-1.],[3,4,6,6,2.],[9,10,6,6,2.]],threshold:0.010002,right_val:0.34235,left_val:0.53461},{features:[[11,4,5,3,-1.],[11,5,5,1,3.]],threshold:2.0138e-003,right_val:0.58243,left_val:0.46438},{features:[[4,11,4,2,-1.],[4,12,4,1,2.]],threshold:1.5135e-003,right_val:0.28561,left_val:0.51964},{features:[[10,7,2,2,-1.],[10,7,1,2,2.]],threshold:3.1381e-003,right_val:0.59585,left_val:0.48382},{features:[[8,7,2,2,-1.],[9,7,1,2,2.]],threshold:-5.145e-003,right_val:0.47414,left_val:0.89203},{features:[[9,17,3,2,-1.],[10,17,1,2,3.]],threshold:-4.4737e-003,right_val:0.53373,left_val:0.20339},{features:[[5,6,3,3,-1.],[5,7,3,1,3.]],threshold:1.9628e-003,right_val:0.67259,left_val:0.45716},{features:[[10,0,3,3,-1.],[11,0,1,3,3.]],threshold:5.426e-003,right_val:0.28457,left_val:0.52711},{features:[[5,6,6,2,-1.],[5,6,3,1,2.],[8,7,3,1,2.]],threshold:4.9611e-004,right_val:0.57186,left_val:0.41383},{features:[[12,16,4,3,-1.],[12,17,4,1,3.]],threshold:9.3729e-003,right_val:0.28048,left_val:0.52252},{features:[[3,12,3,2,-1.],[3,13,3,1,2.]],threshold:6.0501e-004,right_val:0.33145,left_val:0.52368},{features:[[9,12,3,2,-1.],[9,13,3,1,2.]],threshold:5.6793e-004,right_val:0.6277,left_val:0.45311},{features:[[1,11,16,4,-1.],[1,11,8,2,2.],[9,13,8,2,2.]],threshold:0.024644,right_val:0.20171,left_val:0.51309},{features:[[12,4,3,3,-1.],[12,5,3,1,3.]],threshold:-0.01029,right_val:0.48766,left_val:0.77866},{features:[[4,4,5,3,-1.],[4,5,5,1,3.]],threshold:2.0629e-003,right_val:0.58813,left_val:0.42886},{features:[[12,16,4,3,-1.],[12,17,4,1,3.]],threshold:-5.0519e-003,right_val:0.5286,left_val:0.3524},{features:[[5,4,3,3,-1.],[5,5,3,1,3.]],threshold:-5.7693e-003,right_val:0.45881,left_val:0.68411},{features:[[9,0,2,2,-1.],[9,1,2,1,2.]],threshold:-4.579e-004,right_val:0.5486,left_val:0.35655},{features:[[8,9,4,2,-1.],[8,10,4,1,2.]],threshold:-7.5919e-004,right_val:0.52542,left_val:0.33688},{features:[[8,8,4,3,-1.],[8,9,4,1,3.]],threshold:-1.7737e-003,right_val:0.5454,left_val:0.34222},{features:[[0,13,6,3,-1.],[2,13,2,3,3.]],threshold:-8.561e-003,right_val:0.44859,left_val:0.65336},{features:[[16,14,3,2,-1.],[16,15,3,1,2.]],threshold:1.7277e-003,right_val:0.39254,left_val:0.53076},{features:[[1,18,18,2,-1.],[7,18,6,2,3.]],threshold:-0.0282,right_val:0.45886,left_val:0.68575},{features:[[16,14,3,2,-1.],[16,15,3,1,2.]],threshold:-1.7781e-003,right_val:0.53699,left_val:0.40379},{features:[[1,14,3,2,-1.],[1,15,3,1,2.]],threshold:3.3177e-004,right_val:0.37058,left_val:0.53998},{features:[[7,14,6,3,-1.],[7,15,6,1,3.]],threshold:2.6385e-003,right_val:0.64527,left_val:0.46654},{features:[[5,14,8,3,-1.],[5,15,8,1,3.]],threshold:-2.1183e-003,right_val:0.40647,left_val:0.59148},{features:[[10,6,4,14,-1.],[10,6,2,14,2.]],threshold:-0.014773,right_val:0.52948,left_val:0.3642},{features:[[6,6,4,14,-1.],[8,6,2,14,2.]],threshold:-0.016815,right_val:0.5145,left_val:0.26642},{features:[[13,5,2,3,-1.],[13,6,2,1,3.]],threshold:-6.337e-003,right_val:0.48521,left_val:0.67795},{features:[[7,16,6,1,-1.],[9,16,2,1,3.]],threshold:-4.456e-005,right_val:0.41531,left_val:0.5614},{features:[[9,12,3,3,-1.],[9,13,3,1,3.]],threshold:-1.0241e-003,right_val:0.45663,left_val:0.59645},{features:[[7,0,3,3,-1.],[8,0,1,3,3.]],threshold:-2.3162e-003,right_val:0.51882,left_val:0.29761},{features:[[4,0,16,18,-1.],[4,9,16,9,2.]],threshold:0.53218,right_val:0.22026,left_val:0.51878},{features:[[1,1,16,14,-1.],[1,8,16,7,2.]],threshold:-0.16643,right_val:0.50603,left_val:0.1866},{features:[[3,9,15,4,-1.],[8,9,5,4,3.]],threshold:0.11254,right_val:0.1185,left_val:0.52121},{features:[[6,12,7,3,-1.],[6,13,7,1,3.]],threshold:9.3047e-003,right_val:0.68261,left_val:0.45899},{features:[[14,15,2,3,-1.],[14,16,2,1,3.]],threshold:-4.6255e-003,right_val:0.5225,left_val:0.30799},{features:[[2,3,16,14,-1.],[2,3,8,7,2.],[10,10,8,7,2.]],threshold:-0.11116,right_val:0.50808,left_val:0.2101},{features:[[16,2,4,18,-1.],[18,2,2,9,2.],[16,11,2,9,2.]],threshold:-0.010888,right_val:0.47905,left_val:0.57654},{features:[[4,15,2,3,-1.],[4,16,2,1,3.]],threshold:5.8564e-003,right_val:0.15636,left_val:0.50651},{features:[[16,2,4,18,-1.],[18,2,2,9,2.],[16,11,2,9,2.]],threshold:0.054854,right_val:0.72305,left_val:0.49669},{features:[[1,1,8,3,-1.],[1,2,8,1,3.]],threshold:-0.011197,right_val:0.50988,left_val:0.2195},{features:[[8,11,4,3,-1.],[8,12,4,1,3.]],threshold:4.4069e-003,right_val:0.67709,left_val:0.47784},{features:[[5,11,5,9,-1.],[5,14,5,3,3.]],threshold:-0.063665,right_val:0.5081,left_val:0.19364},{features:[[16,0,4,11,-1.],[16,0,2,11,2.]],threshold:-9.8081e-003,right_val:0.48103,left_val:0.59991},{features:[[7,0,6,1,-1.],[9,0,2,1,3.]],threshold:-2.1717e-003,right_val:0.52355,left_val:0.33383},{features:[[16,3,3,7,-1.],[17,3,1,7,3.]],threshold:-0.013316,right_val:0.49192,left_val:0.66171},{features:[[1,3,3,7,-1.],[2,3,1,7,3.]],threshold:2.5442e-003,right_val:0.60822,left_val:0.44887},{features:[[7,8,6,12,-1.],[7,12,6,4,3.]],threshold:0.012038,right_val:0.32924,left_val:0.54094},{features:[[0,0,4,11,-1.],[2,0,2,11,2.]],threshold:-0.020701,right_val:0.4595,left_val:0.68191},{features:[[14,0,6,20,-1.],[14,0,3,20,2.]],threshold:0.027608,right_val:0.57673,left_val:0.46308},{features:[[0,3,1,2,-1.],[0,4,1,1,2.]],threshold:1.2371e-003,right_val:0.2635,left_val:0.51654},{features:[[5,5,10,8,-1.],[10,5,5,4,2.],[5,9,5,4,2.]],threshold:-0.037669,right_val:0.5279,left_val:0.25364},{features:[[4,7,12,4,-1.],[4,7,6,2,2.],[10,9,6,2,2.]],threshold:-1.8057e-003,right_val:0.55175,left_val:0.39852}],threshold:50.61},{simpleClassifiers:[{features:[[2,1,6,4,-1.],[5,1,3,4,2.]],threshold:4.4299e-003,right_val:0.63352,left_val:0.2891},{features:[[9,7,6,4,-1.],[12,7,3,2,2.],[9,9,3,2,2.]],threshold:-2.3813e-003,right_val:0.34775,left_val:0.62118},{features:[[5,6,2,6,-1.],[5,9,2,3,2.]],threshold:2.2916e-003,right_val:0.55821,left_val:0.22544},{features:[[9,16,6,4,-1.],[12,16,3,2,2.],[9,18,3,2,2.]],threshold:9.9458e-004,right_val:0.59301,left_val:0.37117},{features:[[9,4,2,12,-1.],[9,10,2,6,2.]],threshold:7.7165e-004,right_val:0.3348,left_val:0.56517},{features:[[7,1,6,18,-1.],[9,1,2,18,3.]],threshold:-1.1386e-003,right_val:0.55086,left_val:0.30691},{features:[[4,12,12,2,-1.],[8,12,4,2,3.]],threshold:-1.6403e-004,right_val:0.3699,left_val:0.57628},{features:[[8,8,6,2,-1.],[8,9,6,1,2.]],threshold:2.9794e-005,right_val:0.54379,left_val:0.26442},{features:[[8,0,3,6,-1.],[9,0,1,6,3.]],threshold:8.5775e-003,right_val:0.17957,left_val:0.50511},{features:[[11,18,3,2,-1.],[11,19,3,1,2.]],threshold:-2.6033e-004,right_val:0.44468,left_val:0.5827},{features:[[1,1,17,4,-1.],[1,3,17,2,2.]],threshold:-6.1405e-003,right_val:0.5347,left_val:0.31139},{features:[[11,8,4,12,-1.],[11,8,2,12,2.]],threshold:-0.023087,right_val:0.53312,left_val:0.32779},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:-0.014244,right_val:0.45881,left_val:0.73817},{features:[[12,3,2,17,-1.],[12,3,1,17,2.]],threshold:0.019487,right_val:0.22745,left_val:0.52566},{features:[[4,7,6,1,-1.],[6,7,2,1,3.]],threshold:-9.6681e-004,right_val:0.3815,left_val:0.55112},{features:[[18,3,2,3,-1.],[18,4,2,1,3.]],threshold:3.1475e-003,right_val:0.25437,left_val:0.54256},{features:[[8,4,3,4,-1.],[8,6,3,2,2.]],threshold:-1.8026e-004,right_val:0.34063,left_val:0.53802},{features:[[4,5,12,10,-1.],[4,10,12,5,2.]],threshold:-6.0266e-003,right_val:0.54206,left_val:0.30358},{features:[[5,18,4,2,-1.],[7,18,2,2,2.]],threshold:4.4463e-004,right_val:0.56601,left_val:0.3991},{features:[[17,2,3,6,-1.],[17,4,3,2,3.]],threshold:2.261e-003,right_val:0.39407,left_val:0.55628},{features:[[7,7,6,6,-1.],[9,7,2,6,3.]],threshold:0.051133,right_val:0.71186,left_val:0.46097},{features:[[17,2,3,6,-1.],[17,4,3,2,3.]],threshold:-0.017786,right_val:0.53221,left_val:0.23162},{features:[[8,0,3,4,-1.],[9,0,1,4,3.]],threshold:-4.968e-003,right_val:0.5122,left_val:0.23308},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:2.0668e-003,right_val:0.64555,left_val:0.46574},{features:[[0,12,6,3,-1.],[0,13,6,1,3.]],threshold:7.4414e-003,right_val:0.23616,left_val:0.51544},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:-3.6277e-003,right_val:0.44767,left_val:0.62198},{features:[[3,12,2,3,-1.],[3,13,2,1,3.]],threshold:-5.3531e-003,right_val:0.51022,left_val:0.18374},{features:[[5,6,12,7,-1.],[9,6,4,7,3.]],threshold:0.14531,right_val:0.15359,left_val:0.5146},{features:[[0,2,3,6,-1.],[0,4,3,2,3.]],threshold:2.4394e-003,right_val:0.36247,left_val:0.53437},{features:[[14,6,1,3,-1.],[14,7,1,1,3.]],threshold:-3.1283e-003,right_val:0.48456,left_val:0.6215},{features:[[2,0,3,14,-1.],[3,0,1,14,3.]],threshold:1.794e-003,right_val:0.58242,left_val:0.42993},{features:[[12,14,5,6,-1.],[12,16,5,2,3.]],threshold:0.036254,right_val:0.14395,left_val:0.52603},{features:[[4,14,5,6,-1.],[4,16,5,2,3.]],threshold:-5.1747e-003,right_val:0.5287,left_val:0.35065},{features:[[11,10,2,2,-1.],[12,10,1,1,2.],[11,11,1,1,2.]],threshold:6.5383e-004,right_val:0.6122,left_val:0.48096},{features:[[5,0,3,14,-1.],[6,0,1,14,3.]],threshold:-0.02648,right_val:0.50456,left_val:0.11394},{features:[[10,15,2,3,-1.],[10,16,2,1,3.]],threshold:-3.0441e-003,right_val:0.47947,left_val:0.63521},{features:[[0,2,2,3,-1.],[0,3,2,1,3.]],threshold:3.6994e-003,right_val:0.24985,left_val:0.51311},{features:[[5,11,12,6,-1.],[5,14,12,3,2.]],threshold:-3.6763e-004,right_val:0.37095,left_val:0.54214},{features:[[6,11,3,9,-1.],[6,14,3,3,3.]],threshold:-0.041382,right_val:0.50817,left_val:0.1895},{features:[[11,10,2,2,-1.],[12,10,1,1,2.],[11,11,1,1,2.]],threshold:-1.0533e-003,right_val:0.47836,left_val:0.64544},{features:[[5,6,1,3,-1.],[5,7,1,1,3.]],threshold:-2.1649e-003,right_val:0.44998,left_val:0.6215},{features:[[4,9,13,3,-1.],[4,10,13,1,3.]],threshold:-5.6748e-004,right_val:0.54193,left_val:0.37126},{features:[[1,7,15,6,-1.],[6,7,5,6,3.]],threshold:0.17376,right_val:0.12157,left_val:0.50236},{features:[[4,5,12,6,-1.],[8,5,4,6,3.]],threshold:-2.905e-003,right_val:0.53819,left_val:0.32403},{features:[[8,10,4,3,-1.],[8,11,4,1,3.]],threshold:1.23e-003,right_val:0.57035,left_val:0.41655},{features:[[15,14,1,3,-1.],[15,15,1,1,3.]],threshold:-5.4329e-004,right_val:0.55475,left_val:0.3854},{features:[[1,11,5,3,-1.],[1,12,5,1,3.]],threshold:-8.3297e-003,right_val:0.50971,left_val:0.22045},{features:[[7,1,7,12,-1.],[7,7,7,6,2.]],threshold:-1.0418e-004,right_val:0.4303,left_val:0.56071},{features:[[0,1,6,10,-1.],[0,1,3,5,2.],[3,6,3,5,2.]],threshold:0.031205,right_val:0.6982,left_val:0.46217},{features:[[16,1,4,3,-1.],[16,2,4,1,3.]],threshold:7.8944e-003,right_val:0.22691,left_val:0.52696},{features:[[5,5,2,3,-1.],[5,6,2,1,3.]],threshold:-4.3645e-003,right_val:0.4538,left_val:0.63592},{features:[[12,2,3,5,-1.],[13,2,1,5,3.]],threshold:7.6793e-003,right_val:0.27405,left_val:0.52748},{features:[[0,3,4,6,-1.],[0,5,4,2,3.]],threshold:-0.025431,right_val:0.50717,left_val:0.20385},{features:[[8,12,4,2,-1.],[8,13,4,1,2.]],threshold:8.2001e-004,right_val:0.61199,left_val:0.45875},{features:[[8,18,3,1,-1.],[9,18,1,1,3.]],threshold:2.9285e-003,right_val:0.20282,left_val:0.50713},{features:[[11,10,2,2,-1.],[12,10,1,1,2.],[11,11,1,1,2.]],threshold:4.5256e-005,right_val:0.54308,left_val:0.48121},{features:[[7,10,2,2,-1.],[7,10,1,1,2.],[8,11,1,1,2.]],threshold:1.3158e-003,right_val:0.67793,left_val:0.46258},{features:[[11,11,4,4,-1.],[11,13,4,2,2.]],threshold:1.587e-003,right_val:0.34315,left_val:0.53863},{features:[[8,12,3,8,-1.],[9,12,1,8,3.]],threshold:-0.02154,right_val:0.50032,left_val:0.025943},{features:[[13,0,6,3,-1.],[13,1,6,1,3.]],threshold:0.014334,right_val:0.15906,left_val:0.52028},{features:[[8,8,3,4,-1.],[9,8,1,4,3.]],threshold:-8.3881e-003,right_val:0.4648,left_val:0.72825},{features:[[5,7,10,10,-1.],[10,7,5,5,2.],[5,12,5,5,2.]],threshold:9.1907e-003,right_val:0.39232,left_val:0.55624},{features:[[3,18,8,2,-1.],[3,18,4,1,2.],[7,19,4,1,2.]],threshold:-5.8453e-003,right_val:0.46291,left_val:0.68034},{features:[[10,2,6,8,-1.],[12,2,2,8,3.]],threshold:-0.054708,right_val:0.52061,left_val:0.25617},{features:[[4,2,6,8,-1.],[6,2,2,8,3.]],threshold:9.1143e-003,right_val:0.30539,left_val:0.51896},{features:[[11,0,3,7,-1.],[12,0,1,7,3.]],threshold:-0.015575,right_val:0.51691,left_val:0.12951},{features:[[7,11,2,1,-1.],[8,11,1,1,2.]],threshold:-1.2051e-004,right_val:0.42308,left_val:0.57351},{features:[[15,14,1,3,-1.],[15,15,1,1,3.]],threshold:1.2274e-003,right_val:0.40798,left_val:0.52899},{features:[[7,15,2,2,-1.],[7,15,1,1,2.],[8,16,1,1,2.]],threshold:-1.2187e-003,right_val:0.45744,left_val:0.65756},{features:[[15,14,1,3,-1.],[15,15,1,1,3.]],threshold:-3.3257e-003,right_val:0.5195,left_val:0.3628},{features:[[6,0,3,7,-1.],[7,0,1,7,3.]],threshold:-0.013288,right_val:0.50435,left_val:0.12843},{features:[[18,1,2,7,-1.],[18,1,1,7,2.]],threshold:-3.384e-003,right_val:0.47575,left_val:0.62922},{features:[[2,0,8,20,-1.],[2,10,8,10,2.]],threshold:-0.21954,right_val:0.5065,left_val:0.14877},{features:[[3,0,15,6,-1.],[3,2,15,2,3.]],threshold:4.9112e-003,right_val:0.56658,left_val:0.42561},{features:[[4,3,12,2,-1.],[4,4,12,1,2.]],threshold:-1.8745e-004,right_val:0.55869,left_val:0.40041},{features:[[16,0,4,5,-1.],[16,0,2,5,2.]],threshold:-5.2179e-003,right_val:0.48127,left_val:0.60091},{features:[[7,0,3,4,-1.],[8,0,1,4,3.]],threshold:-1.1112e-003,right_val:0.52871,left_val:0.35149},{features:[[16,0,4,5,-1.],[16,0,2,5,2.]],threshold:4.4036e-003,right_val:0.59241,left_val:0.46423},{features:[[1,7,6,13,-1.],[3,7,2,13,3.]],threshold:0.12299,right_val:0.069152,left_val:0.50255},{features:[[16,0,4,5,-1.],[16,0,2,5,2.]],threshold:-0.012314,right_val:0.4934,left_val:0.58846},{features:[[0,0,4,5,-1.],[2,0,2,5,2.]],threshold:4.1471e-003,right_val:0.58935,left_val:0.43722},{features:[[14,12,3,6,-1.],[14,14,3,2,3.]],threshold:-3.5503e-003,right_val:0.53963,left_val:0.43276},{features:[[3,12,3,6,-1.],[3,14,3,2,3.]],threshold:-0.019224,right_val:0.50683,left_val:0.19131},{features:[[16,1,4,3,-1.],[16,2,4,1,3.]],threshold:1.4395e-003,right_val:0.42435,left_val:0.53082},{features:[[8,7,2,10,-1.],[8,7,1,5,2.],[9,12,1,5,2.]],threshold:-6.7752e-003,right_val:0.45401,left_val:0.63654},{features:[[11,11,4,4,-1.],[11,13,4,2,2.]],threshold:7.012e-003,right_val:0.30262,left_val:0.51898},{features:[[0,1,4,3,-1.],[0,2,4,1,3.]],threshold:5.4015e-003,right_val:0.25577,left_val:0.51051},{features:[[13,4,1,3,-1.],[13,5,1,1,3.]],threshold:9.0275e-004,right_val:0.58618,left_val:0.46969},{features:[[7,15,3,5,-1.],[8,15,1,5,3.]],threshold:0.011474,right_val:0.15272,left_val:0.50536},{features:[[9,7,3,5,-1.],[10,7,1,5,3.]],threshold:-6.7023e-003,right_val:0.48906,left_val:0.6509},{features:[[8,7,3,5,-1.],[9,7,1,5,3.]],threshold:-2.0463e-003,right_val:0.45146,left_val:0.62418},{features:[[10,6,4,14,-1.],[10,6,2,14,2.]],threshold:-9.9952e-003,right_val:0.5401,left_val:0.34328},{features:[[0,5,5,6,-1.],[0,7,5,2,3.]],threshold:-0.035701,right_val:0.50741,left_val:0.18781},{features:[[9,5,6,4,-1.],[9,5,3,4,2.]],threshold:4.5585e-004,right_val:0.54026,left_val:0.38053},{features:[[0,0,18,10,-1.],[6,0,6,10,3.]],threshold:-0.054261,right_val:0.45951,left_val:0.68437},{features:[[10,6,4,14,-1.],[10,6,2,14,2.]],threshold:6.06e-003,right_val:0.45005,left_val:0.55029},{features:[[6,6,4,14,-1.],[8,6,2,14,2.]],threshold:-6.4792e-003,right_val:0.53108,left_val:0.33689},{features:[[13,4,1,3,-1.],[13,5,1,1,3.]],threshold:-1.4939e-003,right_val:0.47562,left_val:0.64876},{features:[[5,1,2,3,-1.],[6,1,1,3,2.]],threshold:1.4611e-005,right_val:0.54511,left_val:0.40346},{features:[[18,1,2,18,-1.],[19,1,1,9,2.],[18,10,1,9,2.]],threshold:-7.2322e-003,right_val:0.48247,left_val:0.63869},{features:[[2,1,4,3,-1.],[2,2,4,1,3.]],threshold:-4.0646e-003,right_val:0.51573,left_val:0.29864},{features:[[18,1,2,18,-1.],[19,1,1,9,2.],[18,10,1,9,2.]],threshold:0.030463,right_val:0.716,left_val:0.50222},{features:[[1,14,4,6,-1.],[1,14,2,3,2.],[3,17,2,3,2.]],threshold:-8.0545e-003,right_val:0.46193,left_val:0.64925},{features:[[10,11,7,6,-1.],[10,13,7,2,3.]],threshold:0.039505,right_val:0.24506,left_val:0.51506},{features:[[0,10,6,10,-1.],[0,10,3,5,2.],[3,15,3,5,2.]],threshold:8.453e-003,right_val:0.6394,left_val:0.45737},{features:[[11,0,3,4,-1.],[12,0,1,4,3.]],threshold:-1.1688e-003,right_val:0.54837,left_val:0.38655},{features:[[5,10,5,6,-1.],[5,13,5,3,2.]],threshold:2.8071e-003,right_val:0.27015,left_val:0.51286},{features:[[14,6,1,8,-1.],[14,10,1,4,2.]],threshold:4.7365e-004,right_val:0.53875,left_val:0.40516},{features:[[1,7,18,6,-1.],[1,7,9,3,2.],[10,10,9,3,2.]],threshold:0.011741,right_val:0.37194,left_val:0.5296},{features:[[9,7,2,2,-1.],[9,7,1,2,2.]],threshold:3.1833e-003,right_val:0.68951,left_val:0.47894},{features:[[5,9,4,5,-1.],[7,9,2,5,2.]],threshold:7.0242e-004,right_val:0.39181,left_val:0.53845}],threshold:54.62},{simpleClassifiers:[{features:[[7,6,6,3,-1.],[9,6,2,3,3.]],threshold:0.01706,right_val:0.71425,left_val:0.39485},{features:[[1,0,18,4,-1.],[7,0,6,4,3.]],threshold:0.021841,right_val:0.609,left_val:0.33703},{features:[[7,15,2,4,-1.],[7,17,2,2,2.]],threshold:2.452e-004,right_val:0.59879,left_val:0.35006},{features:[[1,0,19,9,-1.],[1,3,19,3,3.]],threshold:8.3273e-003,right_val:0.56972,left_val:0.32675},{features:[[3,7,3,6,-1.],[3,9,3,2,3.]],threshold:5.7148e-004,right_val:0.55317,left_val:0.30446},{features:[[13,7,4,4,-1.],[15,7,2,2,2.],[13,9,2,2,2.]],threshold:6.7374e-004,right_val:0.56726,left_val:0.365},{features:[[3,7,4,4,-1.],[3,7,2,2,2.],[5,9,2,2,2.]],threshold:3.4682e-005,right_val:0.53887,left_val:0.33135},{features:[[9,6,10,8,-1.],[9,10,10,4,2.]],threshold:-5.8563e-003,right_val:0.54988,left_val:0.26979},{features:[[3,8,14,12,-1.],[3,14,14,6,2.]],threshold:8.5102e-003,right_val:0.27629,left_val:0.52694},{features:[[6,5,10,12,-1.],[11,5,5,6,2.],[6,11,5,6,2.]],threshold:-0.069817,right_val:0.52592,left_val:0.29096},{features:[[9,11,2,3,-1.],[9,12,2,1,3.]],threshold:-8.6114e-004,right_val:0.40737,left_val:0.58926},{features:[[9,5,6,5,-1.],[9,5,3,5,2.]],threshold:9.7149e-004,right_val:0.54159,left_val:0.35236},{features:[[9,4,2,4,-1.],[9,6,2,2,2.]],threshold:-1.4727e-005,right_val:0.35032,left_val:0.5423},{features:[[9,5,6,5,-1.],[9,5,3,5,2.]],threshold:0.04842,right_val:0.34112,left_val:0.51939},{features:[[5,5,6,5,-1.],[8,5,3,5,2.]],threshold:1.3257e-003,right_val:0.53354,left_val:0.31578},{features:[[11,2,6,1,-1.],[13,2,2,1,3.]],threshold:1.4922e-005,right_val:0.55366,left_val:0.44513},{features:[[3,2,6,1,-1.],[5,2,2,1,3.]],threshold:-2.7173e-003,right_val:0.52481,left_val:0.30317},{features:[[13,5,2,3,-1.],[13,6,2,1,3.]],threshold:2.922e-003,right_val:0.6606,left_val:0.47815},{features:[[0,10,1,4,-1.],[0,12,1,2,2.]],threshold:-1.9805e-003,right_val:0.52876,left_val:0.31863},{features:[[13,5,2,3,-1.],[13,6,2,1,3.]],threshold:-4.0012e-003,right_val:0.47499,left_val:0.64136},{features:[[8,18,3,2,-1.],[9,18,1,2,3.]],threshold:-4.3492e-003,right_val:0.5099,left_val:0.15075},{features:[[6,15,9,2,-1.],[6,16,9,1,2.]],threshold:1.3491e-003,right_val:0.58812,left_val:0.43162},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:0.018597,right_val:0.90898,left_val:0.47356},{features:[[18,4,2,4,-1.],[18,6,2,2,2.]],threshold:-1.8562e-003,right_val:0.55778,left_val:0.35532},{features:[[5,5,2,3,-1.],[5,6,2,1,3.]],threshold:2.294e-003,right_val:0.65809,left_val:0.45001},{features:[[15,16,3,2,-1.],[15,17,3,1,2.]],threshold:2.9983e-004,right_val:0.39759,left_val:0.56292},{features:[[0,0,3,9,-1.],[0,3,3,3,3.]],threshold:3.5455e-003,right_val:0.36055,left_val:0.53815},{features:[[9,7,3,3,-1.],[9,8,3,1,3.]],threshold:9.6105e-003,right_val:0.17967,left_val:0.5256},{features:[[8,7,3,3,-1.],[8,8,3,1,3.]],threshold:-6.2783e-003,right_val:0.5114,left_val:0.22729},{features:[[9,5,2,6,-1.],[9,5,1,6,2.]],threshold:3.4598e-003,right_val:0.66082,left_val:0.46263},{features:[[8,6,3,4,-1.],[9,6,1,4,3.]],threshold:-1.3112e-003,right_val:0.44369,left_val:0.63175},{features:[[7,6,8,12,-1.],[11,6,4,6,2.],[7,12,4,6,2.]],threshold:2.6876e-003,right_val:0.4054,left_val:0.54211},{features:[[5,6,8,12,-1.],[5,6,4,6,2.],[9,12,4,6,2.]],threshold:3.9118e-003,right_val:0.32735,left_val:0.53585},{features:[[12,4,3,3,-1.],[12,5,3,1,3.]],threshold:-0.014206,right_val:0.49758,left_val:0.77936},{features:[[2,16,3,2,-1.],[2,17,3,1,2.]],threshold:7.1706e-004,right_val:0.35609,left_val:0.52973},{features:[[12,4,3,3,-1.],[12,5,3,1,3.]],threshold:1.6635e-003,right_val:0.58165,left_val:0.46781},{features:[[2,12,6,6,-1.],[2,14,6,2,3.]],threshold:3.3686e-003,right_val:0.34464,left_val:0.52767},{features:[[7,13,6,3,-1.],[7,14,6,1,3.]],threshold:0.0128,right_val:0.74722,left_val:0.48347},{features:[[6,14,6,3,-1.],[6,15,6,1,3.]],threshold:3.3901e-003,right_val:0.64017,left_val:0.45119},{features:[[14,15,5,3,-1.],[14,16,5,1,3.]],threshold:4.7071e-003,right_val:0.35552,left_val:0.53357},{features:[[5,4,3,3,-1.],[5,5,3,1,3.]],threshold:1.4819e-003,right_val:0.57727,left_val:0.42507},{features:[[14,15,5,3,-1.],[14,16,5,1,3.]],threshold:-6.9996e-003,right_val:0.52929,left_val:0.30033},{features:[[5,3,6,2,-1.],[7,3,2,2,3.]],threshold:0.015939,right_val:0.16756,left_val:0.50673},{features:[[8,15,4,3,-1.],[8,16,4,1,3.]],threshold:7.6377e-003,right_val:0.70856,left_val:0.47951},{features:[[1,15,5,3,-1.],[1,16,5,1,3.]],threshold:6.7334e-003,right_val:0.21625,left_val:0.51331},{features:[[8,13,4,6,-1.],[10,13,2,3,2.],[8,16,2,3,2.]],threshold:-0.012859,right_val:0.52514,left_val:0.19388},{features:[[7,8,3,3,-1.],[8,8,1,3,3.]],threshold:-6.2271e-004,right_val:0.41979,left_val:0.56865},{features:[[12,0,5,4,-1.],[12,2,5,2,2.]],threshold:-5.2652e-004,right_val:0.54297,left_val:0.42242},{features:[[0,2,20,2,-1.],[0,2,10,1,2.],[10,3,10,1,2.]],threshold:0.011075,right_val:0.25145,left_val:0.51138},{features:[[1,0,18,4,-1.],[7,0,6,4,3.]],threshold:-0.036728,right_val:0.48496,left_val:0.71947},{features:[[4,3,6,1,-1.],[6,3,2,1,3.]],threshold:-2.8207e-004,right_val:0.53944,left_val:0.38403},{features:[[4,18,13,2,-1.],[4,19,13,1,2.]],threshold:-2.749e-003,right_val:0.45692,left_val:0.59371},{features:[[2,10,3,6,-1.],[2,12,3,2,3.]],threshold:0.010048,right_val:0.28023,left_val:0.51386},{features:[[14,12,6,8,-1.],[17,12,3,4,2.],[14,16,3,4,2.]],threshold:-8.1498e-003,right_val:0.46361,left_val:0.609},{features:[[4,13,10,6,-1.],[4,13,5,3,2.],[9,16,5,3,2.]],threshold:-6.8834e-003,right_val:0.52547,left_val:0.34586},{features:[[14,12,1,2,-1.],[14,13,1,1,2.]],threshold:-1.4039e-005,right_val:0.40821,left_val:0.56931},{features:[[8,13,4,3,-1.],[8,14,4,1,3.]],threshold:1.5498e-003,right_val:0.58065,left_val:0.43505},{features:[[14,12,2,2,-1.],[14,13,2,1,2.]],threshold:-6.7841e-003,right_val:0.51828,left_val:0.14689},{features:[[4,12,2,2,-1.],[4,13,2,1,2.]],threshold:2.1706e-004,right_val:0.34562,left_val:0.52935},{features:[[8,12,9,2,-1.],[8,13,9,1,2.]],threshold:3.1199e-004,right_val:0.59424,left_val:0.46525},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:5.4508e-003,right_val:0.70248,left_val:0.46535},{features:[[11,10,3,6,-1.],[11,13,3,3,2.]],threshold:-2.5819e-004,right_val:0.3769,left_val:0.54973},{features:[[5,6,9,12,-1.],[5,12,9,6,2.]],threshold:-0.017443,right_val:0.54575,left_val:0.39191},{features:[[11,10,3,6,-1.],[11,13,3,3,2.]],threshold:-0.045344,right_val:0.51549,left_val:0.16314},{features:[[6,10,3,6,-1.],[6,13,3,3,2.]],threshold:1.9191e-003,right_val:0.27919,left_val:0.51459},{features:[[5,4,11,3,-1.],[5,5,11,1,3.]],threshold:-6.0178e-003,right_val:0.47563,left_val:0.65176},{features:[[7,1,5,10,-1.],[7,6,5,5,2.]],threshold:-4.0721e-003,right_val:0.40927,left_val:0.55147},{features:[[2,8,18,2,-1.],[2,9,18,1,2.]],threshold:3.9855e-004,right_val:0.52856,left_val:0.31652},{features:[[7,17,5,3,-1.],[7,18,5,1,3.]],threshold:-6.5419e-003,right_val:0.46528,left_val:0.68534},{features:[[5,9,12,1,-1.],[9,9,4,1,3.]],threshold:3.4845e-003,right_val:0.45028,left_val:0.54846},{features:[[0,14,6,6,-1.],[0,14,3,3,2.],[3,17,3,3,2.]],threshold:-0.013697,right_val:0.45726,left_val:0.63958},{features:[[5,9,12,1,-1.],[9,9,4,1,3.]],threshold:-0.017347,right_val:0.51816,left_val:0.27511},{features:[[3,9,12,1,-1.],[7,9,4,1,3.]],threshold:-4.0885e-003,right_val:0.5195,left_val:0.33256},{features:[[14,10,6,7,-1.],[14,10,3,7,2.]],threshold:-9.4688e-003,right_val:0.48518,left_val:0.59423},{features:[[1,0,16,2,-1.],[1,1,16,1,2.]],threshold:1.7085e-003,right_val:0.55198,left_val:0.41671},{features:[[10,9,10,9,-1.],[10,12,10,3,3.]],threshold:9.4809e-003,right_val:0.42085,left_val:0.54339},{features:[[0,1,10,2,-1.],[5,1,5,2,2.]],threshold:-4.739e-003,right_val:0.45607,left_val:0.64072},{features:[[17,3,2,3,-1.],[17,4,2,1,3.]],threshold:6.5761e-003,right_val:0.22582,left_val:0.52146},{features:[[1,3,2,3,-1.],[1,4,2,1,3.]],threshold:-2.1691e-003,right_val:0.51567,left_val:0.31515},{features:[[9,7,3,6,-1.],[10,7,1,6,3.]],threshold:0.01466,right_val:0.66899,left_val:0.48708},{features:[[6,5,4,3,-1.],[8,5,2,3,2.]],threshold:1.7232e-004,right_val:0.52511,left_val:0.35697},{features:[[7,5,6,6,-1.],[9,5,2,6,3.]],threshold:-0.021804,right_val:0.49663,left_val:0.88259},{features:[[3,4,12,12,-1.],[3,4,6,6,2.],[9,10,6,6,2.]],threshold:-0.094736,right_val:0.50611,left_val:0.14462},{features:[[9,2,6,15,-1.],[11,2,2,15,3.]],threshold:5.5826e-003,right_val:0.42381,left_val:0.53965},{features:[[2,2,6,17,-1.],[4,2,2,17,3.]],threshold:1.9517e-003,right_val:0.54978,left_val:0.41704},{features:[[14,10,6,7,-1.],[14,10,3,7,2.]],threshold:0.01215,right_val:0.56643,left_val:0.46984},{features:[[0,10,6,7,-1.],[3,10,3,7,2.]],threshold:-7.517e-003,right_val:0.44631,left_val:0.62678},{features:[[9,2,6,15,-1.],[11,2,2,15,3.]],threshold:-0.071668,right_val:0.5221,left_val:0.3097},{features:[[5,2,6,15,-1.],[7,2,2,15,3.]],threshold:-0.088292,right_val:0.50064,left_val:0.081124},{features:[[17,9,3,6,-1.],[17,11,3,2,3.]],threshold:0.031063,right_val:0.12823,left_val:0.51555},{features:[[6,7,6,6,-1.],[8,7,2,6,3.]],threshold:0.046622,right_val:0.7364,left_val:0.46998},{features:[[1,10,18,6,-1.],[10,10,9,3,2.],[1,13,9,3,2.]],threshold:-0.012189,right_val:0.5519,left_val:0.39205},{features:[[0,9,10,9,-1.],[0,12,10,3,3.]],threshold:0.013016,right_val:0.36851,left_val:0.52607},{features:[[8,15,4,3,-1.],[8,16,4,1,3.]],threshold:-3.4953e-003,right_val:0.47163,left_val:0.63393},{features:[[5,12,3,4,-1.],[5,14,3,2,2.]],threshold:-4.4015e-005,right_val:0.37762,left_val:0.5333},{features:[[3,3,16,12,-1.],[3,9,16,6,2.]],threshold:-0.10966,right_val:0.51983,left_val:0.17653},{features:[[1,1,12,12,-1.],[1,1,6,6,2.],[7,7,6,6,2.]],threshold:-9.028e-004,right_val:0.38389,left_val:0.53242},{features:[[10,4,2,4,-1.],[11,4,1,2,2.],[10,6,1,2,2.]],threshold:7.1127e-004,right_val:0.57552,left_val:0.46479},{features:[[0,9,10,2,-1.],[0,9,5,1,2.],[5,10,5,1,2.]],threshold:-3.125e-003,right_val:0.51668,left_val:0.32367},{features:[[9,11,3,3,-1.],[9,12,3,1,3.]],threshold:2.4145e-003,right_val:0.64597,left_val:0.47874},{features:[[3,12,9,2,-1.],[3,13,9,1,2.]],threshold:4.4391e-004,right_val:0.60103,left_val:0.44093},{features:[[9,9,2,2,-1.],[9,10,2,1,2.]],threshold:-2.2611e-004,right_val:0.54933,left_val:0.40381}],threshold:50.17},{simpleClassifiers:[{features:[[3,4,13,6,-1.],[3,6,13,2,3.]],threshold:-0.046901,right_val:0.37438,left_val:0.66002},{features:[[9,7,6,4,-1.],[12,7,3,2,2.],[9,9,3,2,2.]],threshold:-1.4568e-003,right_val:0.34378,left_val:0.5784},{features:[[1,0,6,8,-1.],[4,0,3,8,2.]],threshold:5.5598e-003,right_val:0.59082,left_val:0.36223},{features:[[9,5,2,12,-1.],[9,11,2,6,2.]],threshold:7.317e-004,right_val:0.28736,left_val:0.55004},{features:[[4,4,3,10,-1.],[4,9,3,5,2.]],threshold:1.3318e-003,right_val:0.5431,left_val:0.26732},{features:[[6,17,8,3,-1.],[6,18,8,1,3.]],threshold:2.4347e-004,right_val:0.57414,left_val:0.3855},{features:[[0,5,10,6,-1.],[0,7,10,2,3.]],threshold:-3.0512e-003,right_val:0.34628,left_val:0.55032},{features:[[13,2,3,2,-1.],[13,3,3,1,2.]],threshold:-6.8657e-004,right_val:0.54295,left_val:0.32912},{features:[[7,5,4,5,-1.],[9,5,2,5,2.]],threshold:1.4668e-003,right_val:0.53518,left_val:0.35884},{features:[[12,14,3,6,-1.],[12,16,3,2,3.]],threshold:3.2022e-004,right_val:0.57002,left_val:0.42968},{features:[[1,11,8,2,-1.],[1,12,8,1,2.]],threshold:7.4122e-004,right_val:0.33669,left_val:0.52822},{features:[[7,13,6,3,-1.],[7,14,6,1,3.]],threshold:3.833e-003,right_val:0.62573,left_val:0.45596},{features:[[0,5,3,6,-1.],[0,7,3,2,3.]],threshold:-0.015456,right_val:0.51295,left_val:0.23501},{features:[[13,2,3,2,-1.],[13,3,3,1,2.]],threshold:2.6797e-003,right_val:0.41551,left_val:0.53294},{features:[[4,14,4,6,-1.],[4,14,2,3,2.],[6,17,2,3,2.]],threshold:2.8297e-003,right_val:0.58045,left_val:0.42731},{features:[[13,2,3,2,-1.],[13,3,3,1,2.]],threshold:-3.9444e-003,right_val:0.52027,left_val:0.29126},{features:[[8,2,4,12,-1.],[8,6,4,4,3.]],threshold:2.718e-003,right_val:0.35857,left_val:0.53077},{features:[[14,0,6,8,-1.],[17,0,3,4,2.],[14,4,3,4,2.]],threshold:5.9078e-003,right_val:0.59416,left_val:0.47038},{features:[[7,17,3,2,-1.],[8,17,1,2,3.]],threshold:-4.224e-003,right_val:0.50888,left_val:0.21416},{features:[[8,12,4,2,-1.],[8,13,4,1,2.]],threshold:4.0726e-003,right_val:0.68411,left_val:0.47664},{features:[[6,0,8,12,-1.],[6,0,4,6,2.],[10,6,4,6,2.]],threshold:0.01015,right_val:0.37485,left_val:0.53608},{features:[[14,0,2,10,-1.],[15,0,1,5,2.],[14,5,1,5,2.]],threshold:-1.8865e-004,right_val:0.38538,left_val:0.57201},{features:[[5,3,8,6,-1.],[5,3,4,3,2.],[9,6,4,3,2.]],threshold:-4.8864e-003,right_val:0.5341,left_val:0.36931},{features:[[14,0,6,10,-1.],[17,0,3,5,2.],[14,5,3,5,2.]],threshold:0.026158,right_val:0.606,left_val:0.49624},{features:[[9,14,1,2,-1.],[9,15,1,1,2.]],threshold:4.8561e-004,right_val:0.60125,left_val:0.44389},{features:[[15,10,4,3,-1.],[15,11,4,1,3.]],threshold:0.011269,right_val:0.18404,left_val:0.52443},{features:[[8,14,2,3,-1.],[8,15,2,1,3.]],threshold:-2.8115e-003,right_val:0.44099,left_val:0.60603},{features:[[3,13,14,4,-1.],[10,13,7,2,2.],[3,15,7,2,2.]],threshold:-5.6113e-003,right_val:0.55892,left_val:0.38912},{features:[[1,10,4,3,-1.],[1,11,4,1,3.]],threshold:8.568e-003,right_val:0.20626,left_val:0.50693},{features:[[9,11,6,1,-1.],[11,11,2,1,3.]],threshold:-3.8173e-004,right_val:0.41926,left_val:0.58822},{features:[[5,11,6,1,-1.],[7,11,2,1,3.]],threshold:-1.768e-004,right_val:0.40034,left_val:0.55336},{features:[[3,5,16,15,-1.],[3,10,16,5,3.]],threshold:6.5113e-003,right_val:0.54442,left_val:0.33101},{features:[[6,12,4,2,-1.],[8,12,2,2,2.]],threshold:-6.5949e-005,right_val:0.39449,left_val:0.54338},{features:[[4,4,12,10,-1.],[10,4,6,5,2.],[4,9,6,5,2.]],threshold:6.9939e-003,right_val:0.41927,left_val:0.56004},{features:[[8,6,3,4,-1.],[9,6,1,4,3.]],threshold:-4.6744e-003,right_val:0.4605,left_val:0.66855},{features:[[8,12,4,8,-1.],[10,12,2,4,2.],[8,16,2,4,2.]],threshold:0.01159,right_val:0.29268,left_val:0.53571},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:0.013008,right_val:0.73075,left_val:0.46798},{features:[[12,2,3,2,-1.],[13,2,1,2,3.]],threshold:-1.1009e-003,right_val:0.54151,left_val:0.39375},{features:[[8,15,3,2,-1.],[8,16,3,1,2.]],threshold:6.0473e-004,right_val:0.5604,left_val:0.42424},{features:[[6,0,9,14,-1.],[9,0,3,14,3.]],threshold:-0.014495,right_val:0.52932,left_val:0.36312},{features:[[9,6,2,3,-1.],[10,6,1,3,2.]],threshold:-5.3057e-003,right_val:0.46218,left_val:0.68605},{features:[[10,8,2,3,-1.],[10,9,2,1,3.]],threshold:-8.1829e-004,right_val:0.54204,left_val:0.39441},{features:[[0,9,4,6,-1.],[0,11,4,2,3.]],threshold:-0.019078,right_val:0.50379,left_val:0.19626},{features:[[6,0,8,2,-1.],[6,1,8,1,2.]],threshold:3.5549e-004,right_val:0.5614,left_val:0.40863},{features:[[6,14,7,3,-1.],[6,15,7,1,3.]],threshold:1.968e-003,right_val:0.59261,left_val:0.44891},{features:[[8,10,8,9,-1.],[8,13,8,3,3.]],threshold:6.9189e-003,right_val:0.37284,left_val:0.53359},{features:[[5,2,3,2,-1.],[6,2,1,2,3.]],threshold:2.9873e-003,right_val:0.29756,left_val:0.51113},{features:[[14,1,6,8,-1.],[17,1,3,4,2.],[14,5,3,4,2.]],threshold:-6.2265e-003,right_val:0.48245,left_val:0.55415},{features:[[0,1,6,8,-1.],[0,1,3,4,2.],[3,5,3,4,2.]],threshold:0.013353,right_val:0.64148,left_val:0.45864},{features:[[1,2,18,6,-1.],[10,2,9,3,2.],[1,5,9,3,2.]],threshold:0.033505,right_val:0.343,left_val:0.53924},{features:[[9,3,2,1,-1.],[10,3,1,1,2.]],threshold:-2.5294e-003,right_val:0.50133,left_val:0.17037},{features:[[13,2,4,6,-1.],[15,2,2,3,2.],[13,5,2,3,2.]],threshold:-1.2802e-003,right_val:0.46974,left_val:0.53055},{features:[[5,4,3,3,-1.],[5,5,3,1,3.]],threshold:7.0687e-003,right_val:0.64365,left_val:0.46155},{features:[[13,5,1,3,-1.],[13,6,1,1,3.]],threshold:9.688e-004,right_val:0.60439,left_val:0.48336},{features:[[2,16,5,3,-1.],[2,17,5,1,3.]],threshold:3.9648e-003,right_val:0.32318,left_val:0.51876},{features:[[13,2,4,6,-1.],[15,2,2,3,2.],[13,5,2,3,2.]],threshold:-0.022058,right_val:0.5201,left_val:0.40793},{features:[[3,2,4,6,-1.],[3,2,2,3,2.],[5,5,2,3,2.]],threshold:-6.6906e-004,right_val:0.38156,left_val:0.53316},{features:[[13,5,1,2,-1.],[13,6,1,1,2.]],threshold:-6.7009e-004,right_val:0.46889,left_val:0.56554},{features:[[5,5,2,2,-1.],[5,6,2,1,2.]],threshold:7.4285e-004,right_val:0.62874,left_val:0.45344},{features:[[13,9,2,2,-1.],[13,9,1,2,2.]],threshold:2.2228e-003,right_val:0.33037,left_val:0.53506},{features:[[5,9,2,2,-1.],[6,9,1,2,2.]],threshold:-5.4131e-003,right_val:0.50054,left_val:0.11137},{features:[[13,17,3,2,-1.],[13,18,3,1,2.]],threshold:-1.452e-005,right_val:0.43251,left_val:0.56287},{features:[[6,16,4,4,-1.],[6,16,2,2,2.],[8,18,2,2,2.]],threshold:2.3369e-004,right_val:0.54478,left_val:0.41658},{features:[[9,16,2,3,-1.],[9,17,2,1,3.]],threshold:4.2895e-003,right_val:0.67786,left_val:0.48604},{features:[[0,13,9,6,-1.],[0,15,9,2,3.]],threshold:5.9103e-003,right_val:0.36121,left_val:0.52623},{features:[[9,14,2,6,-1.],[9,17,2,3,2.]],threshold:0.012901,right_val:0.32503,left_val:0.53194},{features:[[9,15,2,3,-1.],[9,16,2,1,3.]],threshold:4.6983e-003,right_val:0.66659,left_val:0.46182},{features:[[1,10,18,6,-1.],[1,12,18,2,3.]],threshold:0.01044,right_val:0.38836,left_val:0.55057},{features:[[8,11,4,2,-1.],[8,12,4,1,2.]],threshold:3.0443e-003,right_val:0.73018,left_val:0.46979},{features:[[7,9,6,2,-1.],[7,10,6,1,2.]],threshold:-6.1594e-004,right_val:0.5465,left_val:0.38308},{features:[[8,8,2,3,-1.],[8,9,2,1,3.]],threshold:-3.4247e-003,right_val:0.50895,left_val:0.25663},{features:[[17,5,3,4,-1.],[18,5,1,4,3.]],threshold:-9.3539e-003,right_val:0.49408,left_val:0.647},{features:[[1,19,18,1,-1.],[7,19,6,1,3.]],threshold:0.052339,right_val:0.78788,left_val:0.4746},{features:[[9,0,3,2,-1.],[10,0,1,2,3.]],threshold:3.5766e-003,right_val:0.27485,left_val:0.53067},{features:[[1,8,1,6,-1.],[1,10,1,2,3.]],threshold:7.1555e-004,right_val:0.40419,left_val:0.54131},{features:[[12,17,8,3,-1.],[12,17,4,3,2.]],threshold:-0.010517,right_val:0.48153,left_val:0.61585},{features:[[0,5,3,4,-1.],[1,5,1,4,3.]],threshold:7.7348e-003,right_val:0.7029,left_val:0.46958},{features:[[9,7,2,3,-1.],[9,8,2,1,3.]],threshold:-4.3227e-003,right_val:0.53047,left_val:0.28496},{features:[[7,11,2,2,-1.],[7,11,1,1,2.],[8,12,1,1,2.]],threshold:-2.5534e-003,right_val:0.46889,left_val:0.7057},{features:[[11,3,2,5,-1.],[11,3,1,5,2.]],threshold:1.0269e-004,right_val:0.55735,left_val:0.39029},{features:[[7,3,2,5,-1.],[8,3,1,5,2.]],threshold:7.1395e-006,right_val:0.5264,left_val:0.36842},{features:[[15,13,2,3,-1.],[15,14,2,1,3.]],threshold:-1.6712e-003,right_val:0.53873,left_val:0.38492},{features:[[5,6,2,3,-1.],[5,7,2,1,3.]],threshold:4.926e-003,right_val:0.74473,left_val:0.47298},{features:[[4,19,15,1,-1.],[9,19,5,1,3.]],threshold:4.3909e-003,right_val:0.55919,left_val:0.48092},{features:[[1,19,15,1,-1.],[6,19,5,1,3.]],threshold:-0.017794,right_val:0.46769,left_val:0.69037},{features:[[15,13,2,3,-1.],[15,14,2,1,3.]],threshold:2.047e-003,right_val:0.33082,left_val:0.53707},{features:[[5,0,4,15,-1.],[7,0,2,15,2.]],threshold:0.029891,right_val:0.33091,left_val:0.51399},{features:[[9,6,2,5,-1.],[9,6,1,5,2.]],threshold:1.5495e-003,right_val:0.60783,left_val:0.46602},{features:[[9,5,2,7,-1.],[10,5,1,7,2.]],threshold:1.4957e-003,right_val:0.58639,left_val:0.44048},{features:[[16,11,3,3,-1.],[16,12,3,1,3.]],threshold:9.5886e-004,right_val:0.42085,left_val:0.5436},{features:[[1,11,3,3,-1.],[1,12,3,1,3.]],threshold:4.9644e-004,right_val:0.40006,left_val:0.53706},{features:[[6,6,8,3,-1.],[6,7,8,1,3.]],threshold:-2.7281e-003,right_val:0.42596,left_val:0.56594},{features:[[0,15,6,2,-1.],[0,16,6,1,2.]],threshold:2.3026e-003,right_val:0.33509,left_val:0.51617},{features:[[1,0,18,6,-1.],[7,0,6,6,3.]],threshold:0.25152,right_val:0.71473,left_val:0.48697},{features:[[6,0,3,4,-1.],[7,0,1,4,3.]],threshold:-4.6328e-003,right_val:0.50838,left_val:0.27274},{features:[[14,10,4,10,-1.],[16,10,2,5,2.],[14,15,2,5,2.]],threshold:-0.040434,right_val:0.50218,left_val:0.68514},{features:[[3,2,3,2,-1.],[4,2,1,2,3.]],threshold:1.4972e-005,right_val:0.55226,left_val:0.42845},{features:[[11,2,2,2,-1.],[11,3,2,1,2.]],threshold:-2.405e-004,right_val:0.53901,left_val:0.42261},{features:[[2,10,4,10,-1.],[2,10,2,5,2.],[4,15,2,5,2.]],threshold:0.023658,right_val:0.75044,left_val:0.47446},{features:[[0,13,20,6,-1.],[10,13,10,3,2.],[0,16,10,3,2.]],threshold:-8.1449e-003,right_val:0.55384,left_val:0.42451},{features:[[0,5,2,15,-1.],[1,5,1,15,2.]],threshold:-3.6992e-003,right_val:0.45297,left_val:0.59524},{features:[[1,7,18,4,-1.],[10,7,9,2,2.],[1,9,9,2,2.]],threshold:-6.7719e-003,right_val:0.54734,left_val:0.41378},{features:[[0,0,2,17,-1.],[1,0,1,17,2.]],threshold:4.267e-003,right_val:0.5798,left_val:0.44841},{features:[[2,6,16,6,-1.],[10,6,8,3,2.],[2,9,8,3,2.]],threshold:1.7792e-003,right_val:0.44324,left_val:0.56249},{features:[[8,14,1,3,-1.],[8,15,1,1,3.]],threshold:1.6775e-003,right_val:0.63642,left_val:0.46378},{features:[[8,15,4,2,-1.],[8,16,4,1,2.]],threshold:1.1733e-003,right_val:0.59144,left_val:0.45445},{features:[[5,2,8,2,-1.],[5,2,4,1,2.],[9,3,4,1,2.]],threshold:8.6998e-004,right_val:0.38859,left_val:0.53348},{features:[[6,11,8,6,-1.],[6,14,8,3,2.]],threshold:7.6378e-004,right_val:0.37449,left_val:0.53986},{features:[[9,13,2,2,-1.],[9,14,2,1,2.]],threshold:1.5685e-004,right_val:0.56146,left_val:0.43179},{features:[[18,4,2,6,-1.],[18,6,2,2,3.]],threshold:-0.021511,right_val:0.51855,left_val:0.17859},{features:[[9,12,2,2,-1.],[9,13,2,1,2.]],threshold:1.3081e-004,right_val:0.56828,left_val:0.43425},{features:[[18,4,2,6,-1.],[18,6,2,2,3.]],threshold:0.021992,right_val:0.23794,left_val:0.51617},{features:[[9,13,1,3,-1.],[9,14,1,1,3.]],threshold:-8.0137e-004,right_val:0.44664,left_val:0.59868},{features:[[18,4,2,6,-1.],[18,6,2,2,3.]],threshold:-8.2736e-003,right_val:0.52511,left_val:0.41082},{features:[[0,4,2,6,-1.],[0,6,2,2,3.]],threshold:3.6832e-003,right_val:0.33975,left_val:0.51738},{features:[[9,12,3,3,-1.],[9,13,3,1,3.]],threshold:-7.9526e-003,right_val:0.48459,left_val:0.6889},{features:[[3,13,2,3,-1.],[3,14,2,1,3.]],threshold:1.5382e-003,right_val:0.34541,left_val:0.51786},{features:[[13,13,4,3,-1.],[13,14,4,1,3.]],threshold:-0.014044,right_val:0.51887,left_val:0.16784},{features:[[5,4,3,3,-1.],[5,5,3,1,3.]],threshold:1.4316e-003,right_val:0.56558,left_val:0.43683},{features:[[5,2,10,6,-1.],[5,4,10,2,3.]],threshold:-0.034014,right_val:0.49592,left_val:0.78023},{features:[[3,13,4,3,-1.],[3,14,4,1,3.]],threshold:-0.012027,right_val:0.50322,left_val:0.15851},{features:[[3,7,15,5,-1.],[8,7,5,5,3.]],threshold:0.13317,right_val:0.27551,left_val:0.51633},{features:[[3,7,12,2,-1.],[7,7,4,2,3.]],threshold:-1.5222e-003,right_val:0.52146,left_val:0.37283},{features:[[10,3,3,9,-1.],[11,3,1,9,3.]],threshold:-9.3929e-004,right_val:0.45112,left_val:0.58384},{features:[[8,6,4,6,-1.],[10,6,2,6,2.]],threshold:0.02772,right_val:0.73315,left_val:0.47283},{features:[[9,7,4,3,-1.],[9,8,4,1,3.]],threshold:3.103e-003,right_val:0.41016,left_val:0.53022},{features:[[0,9,4,9,-1.],[2,9,2,9,2.]],threshold:0.077861,right_val:0.1273,left_val:0.49983},{features:[[9,13,3,5,-1.],[10,13,1,5,3.]],threshold:-0.015855,right_val:0.51657,left_val:0.050833},{features:[[7,7,6,3,-1.],[9,7,2,3,3.]],threshold:-4.9725e-003,right_val:0.46842,left_val:0.67981},{features:[[9,7,3,5,-1.],[10,7,1,5,3.]],threshold:-9.7677e-004,right_val:0.47889,left_val:0.60108},{features:[[5,7,8,2,-1.],[9,7,4,2,2.]],threshold:-2.4648e-003,right_val:0.52205,left_val:0.33934},{features:[[5,9,12,2,-1.],[9,9,4,2,3.]],threshold:-6.7938e-003,right_val:0.52397,left_val:0.43651},{features:[[5,6,10,3,-1.],[10,6,5,3,2.]],threshold:0.032608,right_val:0.24252,left_val:0.50527},{features:[[10,12,3,1,-1.],[11,12,1,1,3.]],threshold:-5.8514e-004,right_val:0.47586,left_val:0.5734},{features:[[0,1,11,15,-1.],[0,6,11,5,3.]],threshold:-0.029633,right_val:0.52636,left_val:0.38923}],threshold:66.669},{simpleClassifiers:[{features:[[1,0,18,6,-1.],[7,0,6,6,3.]],threshold:0.046551,right_val:0.62405,left_val:0.3277},{features:[[7,7,6,1,-1.],[9,7,2,1,3.]],threshold:7.9537e-003,right_val:0.69429,left_val:0.42565},{features:[[5,16,6,4,-1.],[5,16,3,2,2.],[8,18,3,2,2.]],threshold:6.8222e-004,right_val:0.59007,left_val:0.37115},{features:[[6,5,9,8,-1.],[6,9,9,4,2.]],threshold:-1.9348e-004,right_val:0.53005,left_val:0.20411},{features:[[5,10,2,6,-1.],[5,13,2,3,2.]],threshold:-2.6711e-004,right_val:0.31032,left_val:0.54161},{features:[[7,6,8,10,-1.],[11,6,4,5,2.],[7,11,4,5,2.]],threshold:2.7818e-003,right_val:0.34671,left_val:0.52778},{features:[[5,6,8,10,-1.],[5,6,4,5,2.],[9,11,4,5,2.]],threshold:-4.6779e-004,right_val:0.32945,left_val:0.53082},{features:[[9,5,2,2,-1.],[9,6,2,1,2.]],threshold:-3.0335e-005,right_val:0.38521,left_val:0.57739},{features:[[5,12,8,2,-1.],[5,13,8,1,2.]],threshold:7.8038e-004,right_val:0.61501,left_val:0.43174},{features:[[10,2,8,2,-1.],[10,3,8,1,2.]],threshold:-4.2554e-003,right_val:0.53243,left_val:0.29339},{features:[[4,0,2,10,-1.],[4,0,1,5,2.],[5,5,1,5,2.]],threshold:-2.4736e-004,right_val:0.3843,left_val:0.54688},{features:[[9,10,2,2,-1.],[9,11,2,1,2.]],threshold:-1.4724e-004,right_val:0.57556,left_val:0.42815},{features:[[2,8,15,3,-1.],[2,9,15,1,3.]],threshold:1.1865e-003,right_val:0.54715,left_val:0.37473},{features:[[8,13,4,3,-1.],[8,14,4,1,3.]],threshold:2.3937e-003,right_val:0.61115,left_val:0.45378},{features:[[7,2,3,2,-1.],[8,2,1,2,3.]],threshold:-1.5391e-003,right_val:0.51895,left_val:0.29713},{features:[[7,13,6,3,-1.],[7,14,6,1,3.]],threshold:-7.1969e-003,right_val:0.47265,left_val:0.66991},{features:[[9,9,2,2,-1.],[9,10,2,1,2.]],threshold:-4.15e-004,right_val:0.52603,left_val:0.3385},{features:[[17,2,3,6,-1.],[17,4,3,2,3.]],threshold:4.436e-003,right_val:0.39201,left_val:0.53991},{features:[[1,5,3,4,-1.],[2,5,1,4,3.]],threshold:2.6606e-003,right_val:0.61196,left_val:0.44826},{features:[[14,8,4,6,-1.],[14,10,4,2,3.]],threshold:-1.5287e-003,right_val:0.53403,left_val:0.37112},{features:[[1,4,3,8,-1.],[2,4,1,8,3.]],threshold:-4.7397e-003,right_val:0.44551,left_val:0.60311},{features:[[8,13,4,6,-1.],[8,16,4,3,2.]],threshold:-0.014829,right_val:0.53419,left_val:0.28388},{features:[[3,14,2,2,-1.],[3,15,2,1,2.]],threshold:9.2276e-004,right_val:0.33617,left_val:0.52095},{features:[[14,8,4,6,-1.],[14,10,4,2,3.]],threshold:0.08353,right_val:0.081164,left_val:0.512},{features:[[2,8,4,6,-1.],[2,10,4,2,3.]],threshold:-7.5633e-004,right_val:0.51898,left_val:0.33171},{features:[[10,14,1,6,-1.],[10,17,1,3,2.]],threshold:9.8404e-003,right_val:0.2335,left_val:0.52476},{features:[[7,5,3,6,-1.],[8,5,1,6,3.]],threshold:-1.5954e-003,right_val:0.42956,left_val:0.57501},{features:[[11,2,2,6,-1.],[12,2,1,3,2.],[11,5,1,3,2.]],threshold:3.4766e-005,right_val:0.5564,left_val:0.43424},{features:[[6,6,6,5,-1.],[8,6,2,5,3.]],threshold:0.029863,right_val:0.65792,left_val:0.45791},{features:[[17,1,3,6,-1.],[17,3,3,2,3.]],threshold:0.011326,right_val:0.36739,left_val:0.52743},{features:[[8,7,3,5,-1.],[9,7,1,5,3.]],threshold:-8.7829e-003,right_val:0.46422,left_val:0.71004},{features:[[9,18,3,2,-1.],[10,18,1,2,3.]],threshold:4.364e-003,right_val:0.27059,left_val:0.52792},{features:[[8,18,3,2,-1.],[9,18,1,2,3.]],threshold:4.1805e-003,right_val:0.24491,left_val:0.50725},{features:[[12,3,5,2,-1.],[12,4,5,1,2.]],threshold:-4.5669e-004,right_val:0.55487,left_val:0.42831},{features:[[7,1,5,12,-1.],[7,7,5,6,2.]],threshold:-3.714e-003,right_val:0.41037,left_val:0.55194},{features:[[1,0,18,4,-1.],[7,0,6,4,3.]],threshold:-0.025304,right_val:0.48699,left_val:0.6867},{features:[[4,2,2,2,-1.],[4,3,2,1,2.]],threshold:-3.4454e-004,right_val:0.52877,left_val:0.37289},{features:[[11,14,4,2,-1.],[13,14,2,1,2.],[11,15,2,1,2.]],threshold:-8.3935e-004,right_val:0.46161,left_val:0.60602},{features:[[0,2,3,6,-1.],[0,4,3,2,3.]],threshold:0.01728,right_val:0.18198,left_val:0.50496},{features:[[9,7,2,3,-1.],[9,8,2,1,3.]],threshold:-6.3595e-003,right_val:0.52328,left_val:0.16312},{features:[[5,5,1,3,-1.],[5,6,1,1,3.]],threshold:1.0298e-003,right_val:0.61765,left_val:0.44633},{features:[[10,10,6,1,-1.],[10,10,3,1,2.]],threshold:1.0117e-003,right_val:0.43007,left_val:0.54734},{features:[[4,10,6,1,-1.],[7,10,3,1,2.]],threshold:-0.010309,right_val:0.50009,left_val:0.1167},{features:[[9,17,3,3,-1.],[9,18,3,1,3.]],threshold:5.4682e-003,right_val:0.67192,left_val:0.47693},{features:[[4,14,1,3,-1.],[4,15,1,1,3.]],threshold:-9.1696e-004,right_val:0.51782,left_val:0.34711},{features:[[12,5,3,3,-1.],[12,6,3,1,3.]],threshold:2.3923e-003,right_val:0.62163,left_val:0.47852},{features:[[4,5,12,3,-1.],[4,6,12,1,3.]],threshold:-7.5574e-003,right_val:0.44101,left_val:0.58148},{features:[[9,8,2,3,-1.],[9,9,2,1,3.]],threshold:-7.7024e-004,right_val:0.54657,left_val:0.3878},{features:[[4,9,3,3,-1.],[5,9,1,3,3.]],threshold:-8.7126e-003,right_val:0.49958,left_val:0.16601},{features:[[6,0,9,17,-1.],[9,0,3,17,3.]],threshold:-0.010306,right_val:0.52742,left_val:0.40934},{features:[[9,12,1,3,-1.],[9,13,1,1,3.]],threshold:-2.0941e-003,right_val:0.45723,left_val:0.62062},{features:[[9,5,2,15,-1.],[9,10,2,5,3.]],threshold:6.8099e-003,right_val:0.41556,left_val:0.55678},{features:[[8,14,2,3,-1.],[8,15,2,1,3.]],threshold:-1.0746e-003,right_val:0.4353,left_val:0.56389},{features:[[10,14,1,3,-1.],[10,15,1,1,3.]],threshold:2.155e-003,right_val:0.67498,left_val:0.48263},{features:[[7,1,6,5,-1.],[9,1,2,5,3.]],threshold:0.031742,right_val:0.18832,left_val:0.50484},{features:[[0,0,20,2,-1.],[0,0,10,2,2.]],threshold:-0.078383,right_val:0.52602,left_val:0.23695},{features:[[2,13,5,3,-1.],[2,14,5,1,3.]],threshold:5.7415e-003,right_val:0.27765,left_val:0.50488},{features:[[9,11,2,3,-1.],[9,12,2,1,3.]],threshold:-2.9015e-003,right_val:0.46933,left_val:0.62386},{features:[[2,5,9,15,-1.],[2,10,9,5,3.]],threshold:-2.6428e-003,right_val:0.51698,left_val:0.33141},{features:[[5,0,12,10,-1.],[11,0,6,5,2.],[5,5,6,5,2.]],threshold:-0.1095,right_val:0.51834,left_val:0.238},{features:[[5,1,2,3,-1.],[6,1,1,3,2.]],threshold:7.4076e-005,right_val:0.53622,left_val:0.40696},{features:[[10,7,6,1,-1.],[12,7,2,1,3.]],threshold:-5.0594e-004,right_val:0.43746,left_val:0.55067},{features:[[3,1,2,10,-1.],[3,1,1,5,2.],[4,6,1,5,2.]],threshold:-8.2132e-004,right_val:0.42094,left_val:0.55257},{features:[[13,7,2,1,-1.],[13,7,1,1,2.]],threshold:-6.0277e-005,right_val:0.47483,left_val:0.54555},{features:[[4,13,4,6,-1.],[4,15,4,2,3.]],threshold:6.8065e-003,right_val:0.34246,left_val:0.5158},{features:[[13,7,2,1,-1.],[13,7,1,1,2.]],threshold:1.7203e-003,right_val:0.63313,left_val:0.50132},{features:[[5,7,2,1,-1.],[6,7,1,1,2.]],threshold:-1.3017e-004,right_val:0.42269,left_val:0.55397},{features:[[2,12,18,4,-1.],[11,12,9,2,2.],[2,14,9,2,2.]],threshold:-4.8016e-003,right_val:0.54308,left_val:0.44251},{features:[[5,7,2,2,-1.],[5,7,1,1,2.],[6,8,1,1,2.]],threshold:-2.5399e-003,right_val:0.46976,left_val:0.71458},{features:[[16,3,4,2,-1.],[16,4,4,1,2.]],threshold:-1.4279e-003,right_val:0.53996,left_val:0.40704},{features:[[0,2,2,18,-1.],[0,2,1,9,2.],[1,11,1,9,2.]],threshold:-0.025143,right_val:0.47474,left_val:0.78847},{features:[[1,2,18,4,-1.],[10,2,9,2,2.],[1,4,9,2,2.]],threshold:-3.89e-003,right_val:0.55771,left_val:0.42962},{features:[[9,14,1,3,-1.],[9,15,1,1,3.]],threshold:4.3947e-003,right_val:0.70239,left_val:0.46932},{features:[[2,12,18,4,-1.],[11,12,9,2,2.],[2,14,9,2,2.]],threshold:0.024678,right_val:0.38125,left_val:0.52423},{features:[[0,12,18,4,-1.],[0,12,9,2,2.],[9,14,9,2,2.]],threshold:0.038048,right_val:0.16878,left_val:0.50117},{features:[[11,4,5,3,-1.],[11,5,5,1,3.]],threshold:7.9425e-003,right_val:0.63696,left_val:0.48286},{features:[[6,4,7,3,-1.],[6,5,7,1,3.]],threshold:-1.511e-003,right_val:0.44877,left_val:0.59065},{features:[[13,17,3,3,-1.],[13,18,3,1,3.]],threshold:6.4202e-003,right_val:0.29906,left_val:0.52411},{features:[[8,1,3,4,-1.],[9,1,1,4,3.]],threshold:-2.9802e-003,right_val:0.50785,left_val:0.30415},{features:[[11,4,2,4,-1.],[11,4,1,4,2.]],threshold:-7.458e-004,right_val:0.52568,left_val:0.41281},{features:[[0,17,9,3,-1.],[3,17,3,3,3.]],threshold:-0.010471,right_val:0.44943,left_val:0.58084},{features:[[11,0,2,8,-1.],[12,0,1,4,2.],[11,4,1,4,2.]],threshold:9.3369e-003,right_val:0.26589,left_val:0.52466},{features:[[0,8,6,12,-1.],[0,8,3,6,2.],[3,14,3,6,2.]],threshold:0.027937,right_val:0.70873,left_val:0.4675},{features:[[10,7,4,12,-1.],[10,13,4,6,2.]],threshold:7.4278e-003,right_val:0.37585,left_val:0.54095},{features:[[5,3,8,14,-1.],[5,10,8,7,2.]],threshold:-0.023585,right_val:0.52386,left_val:0.37586},{features:[[14,10,6,1,-1.],[14,10,3,1,2.]],threshold:1.1453e-003,right_val:0.58042,left_val:0.43296},{features:[[0,4,10,4,-1.],[0,6,10,2,2.]],threshold:-4.3469e-004,right_val:0.38731,left_val:0.52806},{features:[[10,0,5,8,-1.],[10,4,5,4,2.]],threshold:0.010649,right_val:0.56813,left_val:0.49021},{features:[[8,1,4,8,-1.],[8,1,2,4,2.],[10,5,2,4,2.]],threshold:-3.9418e-004,right_val:0.43183,left_val:0.55709},{features:[[9,11,6,1,-1.],[11,11,2,1,3.]],threshold:-1.327e-004,right_val:0.43436,left_val:0.56584},{features:[[8,9,3,4,-1.],[9,9,1,4,3.]],threshold:-2.0126e-003,right_val:0.45375,left_val:0.60567},{features:[[18,4,2,6,-1.],[18,6,2,2,3.]],threshold:2.4854e-003,right_val:0.4138,left_val:0.53905},{features:[[8,8,3,4,-1.],[9,8,1,4,3.]],threshold:1.8238e-003,right_val:0.57172,left_val:0.43548},{features:[[7,1,13,3,-1.],[7,2,13,1,3.]],threshold:-0.016657,right_val:0.52161,left_val:0.30109},{features:[[7,13,6,1,-1.],[9,13,2,1,3.]],threshold:8.035e-004,right_val:0.38184,left_val:0.53002},{features:[[12,11,3,6,-1.],[12,13,3,2,3.]],threshold:3.417e-003,right_val:0.42414,left_val:0.5328},{features:[[5,11,6,1,-1.],[7,11,2,1,3.]],threshold:-3.6223e-004,right_val:0.4187,left_val:0.54917},{features:[[1,4,18,10,-1.],[10,4,9,5,2.],[1,9,9,5,2.]],threshold:-0.1163,right_val:0.52265,left_val:0.14407},{features:[[8,6,4,9,-1.],[8,9,4,3,3.]],threshold:-0.014695,right_val:0.47157,left_val:0.77477},{features:[[8,6,4,3,-1.],[8,7,4,1,3.]],threshold:2.1972e-003,right_val:0.33156,left_val:0.53554},{features:[[8,7,3,3,-1.],[9,7,1,3,3.]],threshold:-4.6965e-004,right_val:0.44581,left_val:0.57672},{features:[[14,15,4,3,-1.],[14,16,4,1,3.]],threshold:6.5145e-003,right_val:0.36479,left_val:0.52157},{features:[[5,10,3,10,-1.],[6,10,1,10,3.]],threshold:0.0213,right_val:0.1568,left_val:0.49942},{features:[[8,15,4,3,-1.],[8,16,4,1,3.]],threshold:3.1881e-003,right_val:0.62873,left_val:0.47422},{features:[[0,8,1,6,-1.],[0,10,1,2,3.]],threshold:9.002e-004,right_val:0.39438,left_val:0.5348},{features:[[10,15,1,3,-1.],[10,16,1,1,3.]],threshold:-5.1772e-003,right_val:0.50131,left_val:0.67272},{features:[[2,15,4,3,-1.],[2,16,4,1,3.]],threshold:-4.3765e-003,right_val:0.51288,left_val:0.31067},{features:[[18,3,2,8,-1.],[19,3,1,4,2.],[18,7,1,4,2.]],threshold:2.63e-003,right_val:0.57552,left_val:0.48863},{features:[[0,3,2,8,-1.],[0,3,1,4,2.],[1,7,1,4,2.]],threshold:-2.0459e-003,right_val:0.45581,left_val:0.60258},{features:[[3,7,14,10,-1.],[10,7,7,5,2.],[3,12,7,5,2.]],threshold:0.069483,right_val:0.21853,left_val:0.52407},{features:[[0,7,19,3,-1.],[0,8,19,1,3.]],threshold:0.024049,right_val:0.20906,left_val:0.50119},{features:[[12,6,3,3,-1.],[12,7,3,1,3.]],threshold:3.1095e-003,right_val:0.71085,left_val:0.48667},{features:[[0,6,1,3,-1.],[0,7,1,1,3.]],threshold:-1.2503e-003,right_val:0.51562,left_val:0.34079},{features:[[12,6,3,3,-1.],[12,7,3,1,3.]],threshold:-1.0281e-003,right_val:0.44394,left_val:0.55756},{features:[[5,6,3,3,-1.],[5,7,3,1,3.]],threshold:-8.8894e-003,right_val:0.46204,left_val:0.6402},{features:[[8,2,4,2,-1.],[8,3,4,1,2.]],threshold:-6.1095e-004,right_val:0.54489,left_val:0.37664},{features:[[6,3,4,12,-1.],[8,3,2,12,2.]],threshold:-5.7686e-003,right_val:0.51337,left_val:0.33186},{features:[[13,6,2,3,-1.],[13,7,2,1,3.]],threshold:1.8506e-003,right_val:0.64069,left_val:0.49036},{features:[[0,10,20,4,-1.],[0,12,20,2,2.]],threshold:-0.099799,right_val:0.50156,left_val:0.15361},{features:[[2,0,17,14,-1.],[2,7,17,7,2.]],threshold:-0.35128,right_val:0.51744,left_val:0.058823},{features:[[0,0,6,10,-1.],[0,0,3,5,2.],[3,5,3,5,2.]],threshold:-0.045245,right_val:0.46779,left_val:0.69615},{features:[[14,6,6,4,-1.],[14,6,3,4,2.]],threshold:0.071482,right_val:0.10381,left_val:0.5168},{features:[[0,6,6,4,-1.],[3,6,3,4,2.]],threshold:2.1896e-003,right_val:0.55321,left_val:0.42731},{features:[[13,2,7,2,-1.],[13,3,7,1,2.]],threshold:-5.9243e-004,right_val:0.52764,left_val:0.46389},{features:[[0,2,7,2,-1.],[0,3,7,1,2.]],threshold:1.6788e-003,right_val:0.3932,left_val:0.53016},{features:[[6,11,14,2,-1.],[13,11,7,1,2.],[6,12,7,1,2.]],threshold:-2.2163e-003,right_val:0.4757,left_val:0.56307},{features:[[8,5,2,2,-1.],[8,5,1,1,2.],[9,6,1,1,2.]],threshold:1.1569e-004,right_val:0.55357,left_val:0.43075},{features:[[13,9,2,3,-1.],[13,9,1,3,2.]],threshold:-7.2017e-003,right_val:0.51931,left_val:0.14449},{features:[[1,1,3,12,-1.],[2,1,1,12,3.]],threshold:8.9081e-004,right_val:0.55936,left_val:0.43844},{features:[[17,4,1,3,-1.],[17,5,1,1,3.]],threshold:1.9605e-004,right_val:0.4706,left_val:0.53404},{features:[[2,4,1,3,-1.],[2,5,1,1,3.]],threshold:5.2022e-004,right_val:0.38101,left_val:0.52139},{features:[[14,5,1,3,-1.],[14,6,1,1,3.]],threshold:9.4589e-004,right_val:0.61307,left_val:0.47694},{features:[[7,16,2,3,-1.],[7,17,2,1,3.]],threshold:9.1698e-005,right_val:0.54294,left_val:0.4245},{features:[[8,13,4,6,-1.],[10,13,2,3,2.],[8,16,2,3,2.]],threshold:2.1833e-003,right_val:0.41911,left_val:0.54577},{features:[[5,5,1,3,-1.],[5,6,1,1,3.]],threshold:-8.604e-004,right_val:0.44717,left_val:0.57646},{features:[[16,0,4,20,-1.],[16,0,2,20,2.]],threshold:-0.013236,right_val:0.4695,left_val:0.63728},{features:[[5,1,2,6,-1.],[5,1,1,3,2.],[6,4,1,3,2.]],threshold:4.3377e-004,right_val:0.39458,left_val:0.53179}],threshold:67.699},{simpleClassifiers:[{features:[[5,4,10,4,-1.],[5,6,10,2,2.]],threshold:-0.024847,right_val:0.38733,left_val:0.65555},{features:[[15,2,4,12,-1.],[15,2,2,12,2.]],threshold:6.1349e-003,right_val:0.5974,left_val:0.37481},{features:[[7,6,4,12,-1.],[7,12,4,6,2.]],threshold:6.4498e-003,right_val:0.25488,left_val:0.54255},{features:[[14,5,1,8,-1.],[14,9,1,4,2.]],threshold:6.3491e-004,right_val:0.53873,left_val:0.24624},{features:[[1,4,14,10,-1.],[1,4,7,5,2.],[8,9,7,5,2.]],threshold:1.4024e-003,right_val:0.35287,left_val:0.55943},{features:[[11,6,6,14,-1.],[14,6,3,7,2.],[11,13,3,7,2.]],threshold:3.0044e-004,right_val:0.57659,left_val:0.39585},{features:[[3,6,6,14,-1.],[3,6,3,7,2.],[6,13,3,7,2.]],threshold:1.0042e-004,right_val:0.5535,left_val:0.3699},{features:[[4,9,15,2,-1.],[9,9,5,2,3.]],threshold:-5.0841e-003,right_val:0.55478,left_val:0.37111},{features:[[7,14,6,3,-1.],[7,15,6,1,3.]],threshold:-0.019537,right_val:0.45793,left_val:0.74928},{features:[[6,3,14,4,-1.],[13,3,7,2,2.],[6,5,7,2,2.]],threshold:-7.4533e-006,right_val:0.39041,left_val:0.56498},{features:[[1,9,15,2,-1.],[6,9,5,2,3.]],threshold:-3.6079e-003,right_val:0.52678,left_val:0.33811},{features:[[6,11,8,9,-1.],[6,14,8,3,3.]],threshold:2.0698e-003,right_val:0.37144,left_val:0.55193},{features:[[7,4,3,8,-1.],[8,4,1,8,3.]],threshold:-4.6464e-004,right_val:0.41136,left_val:0.56082},{features:[[14,6,2,6,-1.],[14,9,2,3,2.]],threshold:7.549e-004,right_val:0.53294,left_val:0.35592},{features:[[5,7,6,4,-1.],[5,7,3,2,2.],[8,9,3,2,2.]],threshold:-9.8322e-004,right_val:0.37632,left_val:0.54148},{features:[[1,1,18,19,-1.],[7,1,6,19,3.]],threshold:-0.019941,right_val:0.47053,left_val:0.63479},{features:[[1,2,6,5,-1.],[4,2,3,5,2.]],threshold:3.768e-003,right_val:0.55637,left_val:0.39135},{features:[[12,17,6,2,-1.],[12,18,6,1,2.]],threshold:-9.4529e-003,right_val:0.52151,left_val:0.25549},{features:[[2,17,6,2,-1.],[2,18,6,1,2.]],threshold:2.9561e-003,right_val:0.30639,left_val:0.51747},{features:[[17,3,3,6,-1.],[17,5,3,2,3.]],threshold:9.1079e-003,right_val:0.2886,left_val:0.53884},{features:[[8,17,3,3,-1.],[8,18,3,1,3.]],threshold:1.8219e-003,right_val:0.58522,left_val:0.4336},{features:[[10,13,2,6,-1.],[10,16,2,3,2.]],threshold:0.014689,right_val:0.287,left_val:0.52874},{features:[[7,13,6,3,-1.],[7,14,6,1,3.]],threshold:-0.014388,right_val:0.46474,left_val:0.70194},{features:[[17,3,3,6,-1.],[17,5,3,2,3.]],threshold:-0.018987,right_val:0.5247,left_val:0.29866},{features:[[8,13,2,3,-1.],[8,14,2,1,3.]],threshold:1.1528e-003,right_val:0.59317,left_val:0.43235},{features:[[9,3,6,2,-1.],[11,3,2,2,3.]],threshold:0.010934,right_val:0.31303,left_val:0.52869},{features:[[0,3,3,6,-1.],[0,5,3,2,3.]],threshold:-0.014933,right_val:0.50841,left_val:0.26584},{features:[[8,5,4,6,-1.],[8,7,4,2,3.]],threshold:-2.9971e-004,right_val:0.37407,left_val:0.54635},{features:[[5,5,3,2,-1.],[5,6,3,1,2.]],threshold:4.1678e-003,right_val:0.74357,left_val:0.47035},{features:[[10,1,3,4,-1.],[11,1,1,4,3.]],threshold:-6.3905e-003,right_val:0.52805,left_val:0.20693},{features:[[1,2,5,9,-1.],[1,5,5,3,3.]],threshold:4.503e-003,right_val:0.34835,left_val:0.51826},{features:[[13,6,2,3,-1.],[13,7,2,1,3.]],threshold:-9.204e-003,right_val:0.49324,left_val:0.68038},{features:[[0,6,14,3,-1.],[7,6,7,3,2.]],threshold:0.081327,right_val:0.22531,left_val:0.50584},{features:[[2,11,18,8,-1.],[2,15,18,4,2.]],threshold:-0.15079,right_val:0.52647,left_val:0.29634},{features:[[5,6,2,3,-1.],[5,7,2,1,3.]],threshold:3.3179e-003,right_val:0.70729,left_val:0.46555},{features:[[10,6,4,2,-1.],[12,6,2,1,2.],[10,7,2,1,2.]],threshold:7.7403e-004,right_val:0.56682,left_val:0.47803},{features:[[6,6,4,2,-1.],[6,6,2,1,2.],[8,7,2,1,2.]],threshold:6.82e-004,right_val:0.57222,left_val:0.4287},{features:[[10,1,3,4,-1.],[11,1,1,4,3.]],threshold:5.3672e-003,right_val:0.31146,left_val:0.52993},{features:[[7,1,2,7,-1.],[8,1,1,7,2.]],threshold:9.7019e-005,right_val:0.52695,left_val:0.36746},{features:[[4,2,15,14,-1.],[4,9,15,7,2.]],threshold:-0.12534,right_val:0.52458,left_val:0.23515},{features:[[8,7,3,2,-1.],[9,7,1,2,3.]],threshold:-5.2516e-003,right_val:0.46938,left_val:0.71159},{features:[[2,3,18,4,-1.],[11,3,9,2,2.],[2,5,9,2,2.]],threshold:-7.8342e-003,right_val:0.54091,left_val:0.44627},{features:[[9,7,2,2,-1.],[10,7,1,2,2.]],threshold:-1.131e-003,right_val:0.44177,left_val:0.59456},{features:[[13,9,2,3,-1.],[13,9,1,3,2.]],threshold:1.7601e-003,right_val:0.39735,left_val:0.53532},{features:[[5,2,6,2,-1.],[7,2,2,2,3.]],threshold:-8.1581e-004,right_val:0.52647,left_val:0.37603},{features:[[9,5,2,7,-1.],[9,5,1,7,2.]],threshold:-3.8688e-003,right_val:0.47498,left_val:0.63099},{features:[[5,9,2,3,-1.],[6,9,1,3,2.]],threshold:1.5207e-003,right_val:0.33612,left_val:0.52302},{features:[[6,0,14,18,-1.],[6,9,14,9,2.]],threshold:0.54587,right_val:0.11726,left_val:0.51671},{features:[[2,16,6,3,-1.],[2,17,6,1,3.]],threshold:0.01565,right_val:0.13933,left_val:0.49794},{features:[[9,7,3,6,-1.],[10,7,1,6,3.]],threshold:-0.011732,right_val:0.49212,left_val:0.71297},{features:[[7,8,4,3,-1.],[7,9,4,1,3.]],threshold:-6.1765e-003,right_val:0.50497,left_val:0.22881},{features:[[7,12,6,3,-1.],[7,13,6,1,3.]],threshold:2.2458e-003,right_val:0.60487,left_val:0.46324},{features:[[9,12,2,3,-1.],[9,13,2,1,3.]],threshold:-5.1916e-003,right_val:0.46022,left_val:0.64674},{features:[[7,12,6,2,-1.],[9,12,2,2,3.]],threshold:-0.023828,right_val:0.52261,left_val:0.1482},{features:[[5,11,4,6,-1.],[5,14,4,3,2.]],threshold:1.0285e-003,right_val:0.3376,left_val:0.51355},{features:[[11,12,7,2,-1.],[11,13,7,1,2.]],threshold:-0.010079,right_val:0.53036,left_val:0.27406},{features:[[6,10,8,6,-1.],[6,10,4,3,2.],[10,13,4,3,2.]],threshold:2.6169e-003,right_val:0.39725,left_val:0.53327},{features:[[11,10,3,4,-1.],[11,12,3,2,2.]],threshold:5.4385e-004,right_val:0.40634,left_val:0.53656},{features:[[9,16,2,3,-1.],[9,17,2,1,3.]],threshold:5.3511e-003,right_val:0.6889,left_val:0.46538},{features:[[13,3,1,9,-1.],[13,6,1,3,3.]],threshold:-1.5275e-003,right_val:0.36247,left_val:0.54495},{features:[[1,13,14,6,-1.],[1,15,14,2,3.]],threshold:-0.080624,right_val:0.50003,left_val:0.16561},{features:[[13,6,1,6,-1.],[13,9,1,3,2.]],threshold:0.022192,right_val:0.20028,left_val:0.51327},{features:[[0,4,3,8,-1.],[1,4,1,8,3.]],threshold:7.3101e-003,right_val:0.63665,left_val:0.46179},{features:[[18,0,2,18,-1.],[18,0,1,18,2.]],threshold:-6.4063e-003,right_val:0.48679,left_val:0.59163},{features:[[2,3,6,2,-1.],[2,4,6,1,2.]],threshold:-7.6415e-004,right_val:0.53158,left_val:0.38884},{features:[[9,0,8,6,-1.],[9,2,8,2,3.]],threshold:7.6734e-004,right_val:0.56053,left_val:0.41591},{features:[[6,6,1,6,-1.],[6,9,1,3,2.]],threshold:6.1475e-004,right_val:0.51201,left_val:0.3089},{features:[[14,8,6,3,-1.],[14,9,6,1,3.]],threshold:-5.0105e-003,right_val:0.52073,left_val:0.39722},{features:[[0,0,2,18,-1.],[1,0,1,18,2.]],threshold:-8.6909e-003,right_val:0.46086,left_val:0.62574},{features:[[1,18,18,2,-1.],[10,18,9,1,2.],[1,19,9,1,2.]],threshold:-0.016391,right_val:0.52423,left_val:0.20852},{features:[[3,15,2,2,-1.],[3,16,2,1,2.]],threshold:4.0974e-004,right_val:0.37803,left_val:0.52224},{features:[[8,14,5,3,-1.],[8,15,5,1,3.]],threshold:-2.5242e-003,right_val:0.46119,left_val:0.58039},{features:[[8,14,2,3,-1.],[8,15,2,1,3.]],threshold:5.0945e-004,right_val:0.5846,left_val:0.44013},{features:[[12,3,3,3,-1.],[13,3,1,3,3.]],threshold:1.9656e-003,right_val:0.41846,left_val:0.53223},{features:[[7,5,6,2,-1.],[9,5,2,2,3.]],threshold:5.6299e-004,right_val:0.52346,left_val:0.37418},{features:[[15,5,5,2,-1.],[15,6,5,1,2.]],threshold:-6.7947e-004,right_val:0.53565,left_val:0.4631},{features:[[0,5,5,2,-1.],[0,6,5,1,2.]],threshold:7.2856e-003,right_val:0.23776,left_val:0.50447},{features:[[17,14,1,6,-1.],[17,17,1,3,2.]],threshold:-0.017459,right_val:0.50504,left_val:0.72891},{features:[[2,9,9,3,-1.],[5,9,3,3,3.]],threshold:-0.025422,right_val:0.46781,left_val:0.66671},{features:[[12,3,3,3,-1.],[13,3,1,3,3.]],threshold:-1.5648e-003,right_val:0.53236,left_val:0.43918},{features:[[0,0,4,18,-1.],[2,0,2,18,2.]],threshold:0.011444,right_val:0.568,left_val:0.43464},{features:[[17,6,1,3,-1.],[17,7,1,1,3.]],threshold:-6.7353e-004,right_val:0.52968,left_val:0.44771},{features:[[2,14,1,6,-1.],[2,17,1,3,2.]],threshold:9.3194e-003,right_val:0.74626,left_val:0.47402},{features:[[19,8,1,2,-1.],[19,9,1,1,2.]],threshold:1.3328e-004,right_val:0.47521,left_val:0.53651},{features:[[5,3,3,3,-1.],[6,3,1,3,3.]],threshold:-7.8816e-003,right_val:0.50153,left_val:0.17522},{features:[[9,16,2,3,-1.],[9,17,2,1,3.]],threshold:-5.7986e-003,right_val:0.48962,left_val:0.72712},{features:[[2,6,1,3,-1.],[2,7,1,1,3.]],threshold:-3.8922e-004,right_val:0.53449,left_val:0.40039},{features:[[12,4,8,2,-1.],[16,4,4,1,2.],[12,5,4,1,2.]],threshold:-1.9289e-003,right_val:0.4804,left_val:0.56056},{features:[[0,4,8,2,-1.],[0,4,4,1,2.],[4,5,4,1,2.]],threshold:8.4214e-003,right_val:0.76236,left_val:0.47532},{features:[[2,16,18,4,-1.],[2,18,18,2,2.]],threshold:8.1656e-003,right_val:0.41916,left_val:0.53933},{features:[[7,15,2,4,-1.],[7,17,2,2,2.]],threshold:4.8281e-004,right_val:0.53998,left_val:0.42408},{features:[[4,0,14,3,-1.],[4,1,14,1,3.]],threshold:-2.7187e-003,right_val:0.54249,left_val:0.42446},{features:[[0,0,4,20,-1.],[2,0,2,20,2.]],threshold:-0.012507,right_val:0.45504,left_val:0.58958},{features:[[12,4,4,8,-1.],[14,4,2,4,2.],[12,8,2,4,2.]],threshold:-0.024287,right_val:0.51892,left_val:0.26471},{features:[[6,7,2,2,-1.],[6,7,1,1,2.],[7,8,1,1,2.]],threshold:-2.9676e-003,right_val:0.47497,left_val:0.73477},{features:[[10,6,2,3,-1.],[10,7,2,1,3.]],threshold:-0.012529,right_val:0.51776,left_val:0.2756},{features:[[8,7,3,2,-1.],[8,8,3,1,2.]],threshold:-1.0104e-003,right_val:0.51447,left_val:0.35106},{features:[[8,2,6,12,-1.],[8,8,6,6,2.]],threshold:-2.1349e-003,right_val:0.46673,left_val:0.56379},{features:[[4,0,11,12,-1.],[4,4,11,4,3.]],threshold:0.019564,right_val:0.61376,left_val:0.46146},{features:[[14,9,6,11,-1.],[16,9,2,11,3.]],threshold:-0.097146,right_val:0.51936,left_val:0.29984},{features:[[0,14,4,3,-1.],[0,15,4,1,3.]],threshold:4.5015e-003,right_val:0.30458,left_val:0.50779},{features:[[9,10,2,3,-1.],[9,11,2,1,3.]],threshold:6.3707e-003,right_val:0.68875,left_val:0.4861},{features:[[5,11,3,2,-1.],[5,12,3,1,2.]],threshold:-9.0722e-003,right_val:0.50176,left_val:0.16734},{features:[[9,15,3,3,-1.],[10,15,1,3,3.]],threshold:-5.3537e-003,right_val:0.52426,left_val:0.26928},{features:[[8,8,3,4,-1.],[9,8,1,4,3.]],threshold:-0.010933,right_val:0.4736,left_val:0.71839},{features:[[9,15,3,3,-1.],[10,15,1,3,3.]],threshold:8.2356e-003,right_val:0.23899,left_val:0.5224},{features:[[7,7,3,2,-1.],[8,7,1,2,3.]],threshold:-1.0038e-003,right_val:0.44339,left_val:0.57194},{features:[[2,10,16,4,-1.],[10,10,8,2,2.],[2,12,8,2,2.]],threshold:4.0859e-003,right_val:0.41488,left_val:0.54728},{features:[[2,3,4,17,-1.],[4,3,2,17,2.]],threshold:0.15485,right_val:0.061062,left_val:0.49738},{features:[[15,13,2,7,-1.],[15,13,1,7,2.]],threshold:2.0897e-004,right_val:0.54239,left_val:0.47092},{features:[[2,2,6,1,-1.],[5,2,3,1,2.]],threshold:3.3317e-004,right_val:0.5301,left_val:0.40896},{features:[[5,2,12,4,-1.],[9,2,4,4,3.]],threshold:-0.010813,right_val:0.49573,left_val:0.61044},{features:[[6,0,8,12,-1.],[6,0,4,6,2.],[10,6,4,6,2.]],threshold:0.045656,right_val:0.28667,left_val:0.50697},{features:[[13,7,2,2,-1.],[14,7,1,1,2.],[13,8,1,1,2.]],threshold:1.257e-003,right_val:0.63182,left_val:0.48469},{features:[[0,12,20,6,-1.],[0,14,20,2,3.]],threshold:-0.12015,right_val:0.4981,left_val:0.060526},{features:[[14,7,2,3,-1.],[14,7,1,3,2.]],threshold:-1.0534e-004,right_val:0.4708,left_val:0.53631},{features:[[0,8,9,12,-1.],[3,8,3,12,3.]],threshold:-0.20703,right_val:0.49791,left_val:0.05966},{features:[[3,0,16,2,-1.],[3,0,8,2,2.]],threshold:1.2909e-004,right_val:0.5378,left_val:0.4713},{features:[[6,15,3,3,-1.],[6,16,3,1,3.]],threshold:3.8819e-004,right_val:0.55342,left_val:0.43635},{features:[[8,15,6,3,-1.],[8,16,6,1,3.]],threshold:-2.9244e-003,right_val:0.48252,left_val:0.58112},{features:[[0,10,1,6,-1.],[0,12,1,2,3.]],threshold:8.3882e-004,right_val:0.40381,left_val:0.53117},{features:[[10,9,4,3,-1.],[10,10,4,1,3.]],threshold:-1.9062e-003,right_val:0.526,left_val:0.37707},{features:[[9,15,2,3,-1.],[9,16,2,1,3.]],threshold:8.9514e-003,right_val:0.76822,left_val:0.47662},{features:[[5,7,10,1,-1.],[5,7,5,1,2.]],threshold:0.013083,right_val:0.30622,left_val:0.52645},{features:[[4,0,12,19,-1.],[10,0,6,19,2.]],threshold:-0.21159,right_val:0.46958,left_val:0.67372},{features:[[0,6,20,6,-1.],[10,6,10,3,2.],[0,9,10,3,2.]],threshold:3.1493e-003,right_val:0.4387,left_val:0.56448},{features:[[3,6,2,2,-1.],[3,6,1,1,2.],[4,7,1,1,2.]],threshold:3.9754e-004,right_val:0.58956,left_val:0.45261},{features:[[15,6,2,2,-1.],[16,6,1,1,2.],[15,7,1,1,2.]],threshold:-1.3814e-003,right_val:0.49424,left_val:0.60706},{features:[[3,6,2,2,-1.],[3,6,1,1,2.],[4,7,1,1,2.]],threshold:-5.8122e-004,right_val:0.45083,left_val:0.59982},{features:[[14,4,1,12,-1.],[14,10,1,6,2.]],threshold:-2.3905e-003,right_val:0.52238,left_val:0.42056},{features:[[2,5,16,10,-1.],[2,5,8,5,2.],[10,10,8,5,2.]],threshold:0.027269,right_val:0.35633,left_val:0.52064},{features:[[9,17,3,2,-1.],[10,17,1,2,3.]],threshold:-3.7658e-003,right_val:0.52188,left_val:0.31447},{features:[[1,4,2,2,-1.],[1,5,2,1,2.]],threshold:-1.4903e-003,right_val:0.51244,left_val:0.33802},{features:[[5,0,15,5,-1.],[10,0,5,5,3.]],threshold:-0.017428,right_val:0.49197,left_val:0.583},{features:[[0,0,15,5,-1.],[5,0,5,5,3.]],threshold:-0.015278,right_val:0.46179,left_val:0.61631},{features:[[11,2,2,17,-1.],[11,2,1,17,2.]],threshold:0.031996,right_val:0.17128,left_val:0.51664},{features:[[7,2,2,17,-1.],[8,2,1,17,2.]],threshold:-3.8257e-003,right_val:0.51314,left_val:0.3408},{features:[[15,11,2,9,-1.],[15,11,1,9,2.]],threshold:-8.5186e-003,right_val:0.49979,left_val:0.61055},{features:[[3,11,2,9,-1.],[4,11,1,9,2.]],threshold:9.0642e-004,right_val:0.55823,left_val:0.43273},{features:[[5,16,14,4,-1.],[5,16,7,4,2.]],threshold:0.010345,right_val:0.54524,left_val:0.48557}],threshold:69.23},{simpleClassifiers:[{features:[[1,4,18,1,-1.],[7,4,6,1,3.]],threshold:7.8982e-003,right_val:0.59465,left_val:0.33325},{features:[[13,7,6,4,-1.],[16,7,3,2,2.],[13,9,3,2,2.]],threshold:1.617e-003,right_val:0.55779,left_val:0.34906},{features:[[9,8,2,12,-1.],[9,12,2,4,3.]],threshold:-5.545e-004,right_val:0.32915,left_val:0.55426},{features:[[12,1,6,6,-1.],[12,3,6,2,3.]],threshold:1.5429e-003,right_val:0.5546,left_val:0.36126},{features:[[5,2,6,6,-1.],[5,2,3,3,2.],[8,5,3,3,2.]],threshold:-1.0329e-003,right_val:0.55761,left_val:0.35301},{features:[[9,16,6,4,-1.],[12,16,3,2,2.],[9,18,3,2,2.]],threshold:7.7698e-004,right_val:0.56453,left_val:0.39168},{features:[[1,2,18,3,-1.],[7,2,6,3,3.]],threshold:0.1432,right_val:0.70236,left_val:0.46675},{features:[[7,4,9,10,-1.],[7,9,9,5,2.]],threshold:-7.3866e-003,right_val:0.52893,left_val:0.30737},{features:[[5,9,4,4,-1.],[7,9,2,4,2.]],threshold:-6.2937e-004,right_val:0.4037,left_val:0.56221},{features:[[11,10,3,6,-1.],[11,13,3,3,2.]],threshold:7.8894e-004,right_val:0.35579,left_val:0.52677},{features:[[7,11,5,3,-1.],[7,12,5,1,3.]],threshold:-0.012228,right_val:0.46255,left_val:0.66683},{features:[[7,11,6,6,-1.],[10,11,3,3,2.],[7,14,3,3,2.]],threshold:3.542e-003,right_val:0.38697,left_val:0.55214},{features:[[0,0,10,9,-1.],[0,3,10,3,3.]],threshold:-1.0585e-003,right_val:0.53209,left_val:0.36287},{features:[[13,14,1,6,-1.],[13,16,1,2,3.]],threshold:1.4936e-005,right_val:0.53633,left_val:0.46324},{features:[[0,2,3,6,-1.],[0,4,3,2,3.]],threshold:5.2538e-003,right_val:0.32657,left_val:0.51322},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:-8.2338e-003,right_val:0.47741,left_val:0.66937},{features:[[6,14,1,6,-1.],[6,16,1,2,3.]],threshold:2.1867e-005,right_val:0.54579,left_val:0.40539},{features:[[9,15,2,3,-1.],[9,16,2,1,3.]],threshold:-3.815e-003,right_val:0.47932,left_val:0.6455},{features:[[6,4,3,3,-1.],[7,4,1,3,3.]],threshold:1.1106e-003,right_val:0.35297,left_val:0.52704},{features:[[9,0,11,3,-1.],[9,1,11,1,3.]],threshold:-5.7708e-003,right_val:0.5353,left_val:0.38035},{features:[[0,6,20,3,-1.],[0,7,20,1,3.]],threshold:-3.0158e-003,right_val:0.38871,left_val:0.53394},{features:[[10,1,1,2,-1.],[10,2,1,1,2.]],threshold:-8.5454e-004,right_val:0.52736,left_val:0.35646},{features:[[9,6,2,6,-1.],[10,6,1,6,2.]],threshold:0.011051,right_val:0.68497,left_val:0.46719},{features:[[5,8,12,1,-1.],[9,8,4,1,3.]],threshold:0.042606,right_val:0.07022,left_val:0.51515},{features:[[3,8,12,1,-1.],[7,8,4,1,3.]],threshold:-3.0782e-003,right_val:0.51526,left_val:0.30417},{features:[[9,7,3,5,-1.],[10,7,1,5,3.]],threshold:-5.4816e-003,right_val:0.48972,left_val:0.64303},{features:[[3,9,6,2,-1.],[6,9,3,2,2.]],threshold:3.1882e-003,right_val:0.38262,left_val:0.53075},{features:[[12,9,3,3,-1.],[12,10,3,1,3.]],threshold:3.5947e-004,right_val:0.54219,left_val:0.465},{features:[[7,0,6,1,-1.],[9,0,2,1,3.]],threshold:-4.0705e-003,right_val:0.50791,left_val:0.28497},{features:[[12,9,3,3,-1.],[12,10,3,1,3.]],threshold:-0.014594,right_val:0.51285,left_val:0.29716},{features:[[7,10,2,1,-1.],[8,10,1,1,2.]],threshold:-1.1948e-004,right_val:0.43431,left_val:0.56311},{features:[[6,4,9,13,-1.],[9,4,3,13,3.]],threshold:-6.9345e-004,right_val:0.536,left_val:0.44036},{features:[[6,8,4,2,-1.],[6,9,4,1,2.]],threshold:1.4835e-005,right_val:0.51647,left_val:0.3421},{features:[[16,2,4,6,-1.],[16,2,2,6,2.]],threshold:9.0297e-003,right_val:0.61141,left_val:0.46393},{features:[[0,17,6,3,-1.],[0,18,6,1,3.]],threshold:-8.0641e-003,right_val:0.50755,left_val:0.28202},{features:[[10,10,3,10,-1.],[10,15,3,5,2.]],threshold:0.026062,right_val:0.26888,left_val:0.52089},{features:[[8,7,3,5,-1.],[9,7,1,5,3.]],threshold:0.017315,right_val:0.67385,left_val:0.46637},{features:[[10,4,4,3,-1.],[10,4,2,3,2.]],threshold:0.022667,right_val:0.22127,left_val:0.52093},{features:[[8,4,3,8,-1.],[9,4,1,8,3.]],threshold:-2.1966e-003,right_val:0.45382,left_val:0.60631},{features:[[6,6,9,13,-1.],[9,6,3,13,3.]],threshold:-9.5282e-003,right_val:0.52474,left_val:0.46352},{features:[[6,0,8,12,-1.],[6,0,4,6,2.],[10,6,4,6,2.]],threshold:8.0944e-003,right_val:0.39139,left_val:0.52894},{features:[[14,2,6,8,-1.],[16,2,2,8,3.]],threshold:-0.072877,right_val:0.49902,left_val:0.7752},{features:[[6,0,3,6,-1.],[7,0,1,6,3.]],threshold:-6.901e-003,right_val:0.50481,left_val:0.2428},{features:[[14,2,6,8,-1.],[16,2,2,8,3.]],threshold:-0.011308,right_val:0.48424,left_val:0.57344},{features:[[0,5,6,6,-1.],[0,8,6,3,2.]],threshold:0.059613,right_val:0.2525,left_val:0.50298},{features:[[9,12,6,2,-1.],[12,12,3,1,2.],[9,13,3,1,2.]],threshold:-2.8625e-003,right_val:0.48985,left_val:0.6073},{features:[[8,17,3,2,-1.],[9,17,1,2,3.]],threshold:4.4781e-003,right_val:0.22203,left_val:0.50153},{features:[[11,6,2,2,-1.],[12,6,1,1,2.],[11,7,1,1,2.]],threshold:-1.7513e-003,right_val:0.49339,left_val:0.66144},{features:[[1,9,18,2,-1.],[7,9,6,2,3.]],threshold:0.040163,right_val:0.3741,left_val:0.51809},{features:[[11,6,2,2,-1.],[12,6,1,1,2.],[11,7,1,1,2.]],threshold:3.4769e-004,right_val:0.5818,left_val:0.47204},{features:[[3,4,12,8,-1.],[7,4,4,8,3.]],threshold:2.6552e-003,right_val:0.52213,left_val:0.3805},{features:[[13,11,5,3,-1.],[13,12,5,1,3.]],threshold:-8.7706e-003,right_val:0.52313,left_val:0.29442},{features:[[9,10,2,3,-1.],[9,11,2,1,3.]],threshold:-5.5122e-003,right_val:0.47228,left_val:0.73462},{features:[[14,7,2,3,-1.],[14,7,1,3,2.]],threshold:6.8672e-004,right_val:0.42424,left_val:0.54529},{features:[[5,4,1,3,-1.],[5,5,1,1,3.]],threshold:5.602e-004,right_val:0.56013,left_val:0.43989},{features:[[13,4,2,3,-1.],[13,5,2,1,3.]],threshold:2.4144e-003,right_val:0.61366,left_val:0.47417},{features:[[5,4,2,3,-1.],[5,5,2,1,3.]],threshold:-1.5681e-003,right_val:0.45164,left_val:0.60446},{features:[[9,8,2,3,-1.],[9,9,2,1,3.]],threshold:-3.6827e-003,right_val:0.5295,left_val:0.24525},{features:[[8,9,2,2,-1.],[8,10,2,1,2.]],threshold:-2.9409e-004,right_val:0.52515,left_val:0.37328},{features:[[15,14,1,4,-1.],[15,16,1,2,2.]],threshold:4.2848e-004,right_val:0.40655,left_val:0.54988},{features:[[3,12,2,2,-1.],[3,13,2,1,2.]],threshold:-4.8817e-003,right_val:0.5,left_val:0.21399},{features:[[12,15,2,2,-1.],[13,15,1,1,2.],[12,16,1,1,2.]],threshold:2.7272e-004,right_val:0.58134,left_val:0.46503},{features:[[9,13,2,2,-1.],[9,14,2,1,2.]],threshold:2.0947e-004,right_val:0.55728,left_val:0.43875},{features:[[4,11,14,9,-1.],[4,14,14,3,3.]],threshold:0.048501,right_val:0.32129,left_val:0.5245},{features:[[7,13,4,3,-1.],[7,14,4,1,3.]],threshold:-4.5166e-003,right_val:0.45459,left_val:0.60568},{features:[[15,14,1,4,-1.],[15,16,1,2,2.]],threshold:-0.012292,right_val:0.51522,left_val:0.20409},{features:[[4,14,1,4,-1.],[4,16,1,2,2.]],threshold:4.855e-004,right_val:0.37395,left_val:0.52376},{features:[[14,0,6,13,-1.],[16,0,2,13,3.]],threshold:0.030556,right_val:0.59382,left_val:0.49605},{features:[[4,1,2,12,-1.],[4,1,1,6,2.],[5,7,1,6,2.]],threshold:-1.5105e-004,right_val:0.41452,left_val:0.53513},{features:[[11,14,6,6,-1.],[14,14,3,3,2.],[11,17,3,3,2.]],threshold:2.4937e-003,right_val:0.55149,left_val:0.46934},{features:[[3,14,6,6,-1.],[3,14,3,3,2.],[6,17,3,3,2.]],threshold:-0.012382,right_val:0.46817,left_val:0.67914},{features:[[14,17,3,2,-1.],[14,18,3,1,2.]],threshold:-5.1333e-003,right_val:0.52292,left_val:0.36087},{features:[[3,17,3,2,-1.],[3,18,3,1,2.]],threshold:5.1919e-004,right_val:0.36336,left_val:0.53001},{features:[[14,0,6,13,-1.],[16,0,2,13,3.]],threshold:0.1506,right_val:0.22118,left_val:0.51573},{features:[[0,0,6,13,-1.],[2,0,2,13,3.]],threshold:7.7144e-003,right_val:0.57766,left_val:0.44105},{features:[[10,10,7,6,-1.],[10,12,7,2,3.]],threshold:9.4444e-003,right_val:0.37567,left_val:0.54019},{features:[[6,15,2,2,-1.],[6,15,1,1,2.],[7,16,1,1,2.]],threshold:2.5006e-004,right_val:0.56074,left_val:0.43683},{features:[[6,11,8,6,-1.],[10,11,4,3,2.],[6,14,4,3,2.]],threshold:-3.3077e-003,right_val:0.55182,left_val:0.42448},{features:[[7,6,2,2,-1.],[7,6,1,1,2.],[8,7,1,1,2.]],threshold:7.4049e-004,right_val:0.59006,left_val:0.4497},{features:[[2,2,16,6,-1.],[10,2,8,3,2.],[2,5,8,3,2.]],threshold:0.044092,right_val:0.31564,left_val:0.52935},{features:[[5,4,3,3,-1.],[5,5,3,1,3.]],threshold:3.364e-003,right_val:0.58487,left_val:0.44833},{features:[[11,7,3,10,-1.],[11,12,3,5,2.]],threshold:-3.976e-003,right_val:0.54836,left_val:0.45595},{features:[[6,7,3,10,-1.],[6,12,3,5,2.]],threshold:2.7717e-003,right_val:0.37925,left_val:0.53418},{features:[[10,7,3,2,-1.],[11,7,1,2,3.]],threshold:-2.4123e-004,right_val:0.4577,left_val:0.56672},{features:[[8,12,4,2,-1.],[8,13,4,1,2.]],threshold:4.9426e-004,right_val:0.56288,left_val:0.44212},{features:[[10,1,1,3,-1.],[10,2,1,1,3.]],threshold:-3.8876e-004,right_val:0.53911,left_val:0.42884},{features:[[1,2,4,18,-1.],[1,2,2,9,2.],[3,11,2,9,2.]],threshold:-0.050049,right_val:0.47037,left_val:0.68995},{features:[[12,4,4,12,-1.],[12,10,4,6,2.]],threshold:-0.036635,right_val:0.51918,left_val:0.22178},{features:[[0,0,1,6,-1.],[0,2,1,2,3.]],threshold:2.4274e-003,right_val:0.34974,left_val:0.51362},{features:[[9,11,2,3,-1.],[9,12,2,1,3.]],threshold:1.9558e-003,right_val:0.64084,left_val:0.48262},{features:[[8,7,4,3,-1.],[8,8,4,1,3.]],threshold:-1.7495e-003,right_val:0.52727,left_val:0.39228},{features:[[10,7,3,2,-1.],[11,7,1,2,3.]],threshold:0.013955,right_val:0.84165,left_val:0.50782},{features:[[7,7,3,2,-1.],[8,7,1,2,3.]],threshold:-2.1897e-004,right_val:0.43142,left_val:0.55205},{features:[[9,4,6,1,-1.],[11,4,2,1,3.]],threshold:-1.5131e-003,right_val:0.53826,left_val:0.39346},{features:[[8,7,2,3,-1.],[9,7,1,3,2.]],threshold:-4.3623e-003,right_val:0.47365,left_val:0.73706},{features:[[12,7,8,6,-1.],[16,7,4,3,2.],[12,10,4,3,2.]],threshold:0.065161,right_val:0.32816,left_val:0.51593},{features:[[0,7,8,6,-1.],[0,7,4,3,2.],[4,10,4,3,2.]],threshold:-2.3567e-003,right_val:0.51729,left_val:0.36728},{features:[[18,2,2,10,-1.],[19,2,1,5,2.],[18,7,1,5,2.]],threshold:0.015147,right_val:0.66876,left_val:0.50315},{features:[[0,2,6,4,-1.],[3,2,3,4,2.]],threshold:-0.022851,right_val:0.47096,left_val:0.67675},{features:[[9,4,6,1,-1.],[11,4,2,1,3.]],threshold:4.8868e-003,right_val:0.40599,left_val:0.5258},{features:[[7,15,2,2,-1.],[7,15,1,1,2.],[8,16,1,1,2.]],threshold:1.762e-003,right_val:0.66883,left_val:0.46963},{features:[[11,13,1,6,-1.],[11,16,1,3,2.]],threshold:-1.2943e-003,right_val:0.53443,left_val:0.43207},{features:[[8,13,1,6,-1.],[8,16,1,3,2.]],threshold:0.01093,right_val:0.16375,left_val:0.49977},{features:[[14,3,2,1,-1.],[14,3,1,1,2.]],threshold:2.9958e-005,right_val:0.56332,left_val:0.42824},{features:[[8,15,2,3,-1.],[8,16,2,1,3.]],threshold:-6.5884e-003,right_val:0.47005,left_val:0.67721},{features:[[12,15,7,4,-1.],[12,17,7,2,2.]],threshold:3.2528e-003,right_val:0.45361,left_val:0.53134},{features:[[4,14,12,3,-1.],[4,15,12,1,3.]],threshold:-4.0436e-003,right_val:0.44134,left_val:0.56601},{features:[[10,3,3,2,-1.],[11,3,1,2,3.]],threshold:-1.2524e-003,right_val:0.53565,left_val:0.37319},{features:[[4,12,2,2,-1.],[4,13,2,1,2.]],threshold:1.9247e-004,right_val:0.37388,left_val:0.519},{features:[[10,11,4,6,-1.],[10,14,4,3,2.]],threshold:-0.03859,right_val:0.51888,left_val:0.29564},{features:[[7,13,2,2,-1.],[7,13,1,1,2.],[8,14,1,1,2.]],threshold:1.549e-004,right_val:0.55095,left_val:0.43471},{features:[[4,11,14,4,-1.],[11,11,7,2,2.],[4,13,7,2,2.]],threshold:-0.033764,right_val:0.51955,left_val:0.32303},{features:[[1,18,18,2,-1.],[7,18,6,2,3.]],threshold:-8.2657e-003,right_val:0.45521,left_val:0.59755},{features:[[11,18,2,2,-1.],[12,18,1,1,2.],[11,19,1,1,2.]],threshold:1.4481e-005,right_val:0.54974,left_val:0.47457},{features:[[7,18,2,2,-1.],[7,18,1,1,2.],[8,19,1,1,2.]],threshold:1.4951e-005,right_val:0.54806,left_val:0.43245},{features:[[12,18,8,2,-1.],[12,19,8,1,2.]],threshold:-0.018742,right_val:0.51785,left_val:0.15801},{features:[[7,14,6,2,-1.],[7,15,6,1,2.]],threshold:1.7572e-003,right_val:0.57738,left_val:0.45176},{features:[[8,12,4,8,-1.],[10,12,2,4,2.],[8,16,2,4,2.]],threshold:-3.1391e-003,right_val:0.54608,left_val:0.41496},{features:[[4,9,3,3,-1.],[4,10,3,1,3.]],threshold:6.6657e-005,right_val:0.52931,left_val:0.40391},{features:[[7,10,6,2,-1.],[9,10,2,2,3.]],threshold:6.7743e-003,right_val:0.6122,left_val:0.47677},{features:[[5,0,4,15,-1.],[7,0,2,15,2.]],threshold:-7.3868e-003,right_val:0.51873,left_val:0.35863},{features:[[8,6,12,14,-1.],[12,6,4,14,3.]],threshold:0.014041,right_val:0.55762,left_val:0.47121},{features:[[5,16,3,3,-1.],[5,17,3,1,3.]],threshold:-5.5258e-003,right_val:0.50393,left_val:0.2661},{features:[[8,1,12,19,-1.],[12,1,4,19,3.]],threshold:0.38684,right_val:0.25259,left_val:0.51443},{features:[[3,0,3,2,-1.],[3,1,3,1,2.]],threshold:1.1459e-004,right_val:0.54234,left_val:0.4285},{features:[[10,12,4,5,-1.],[10,12,2,5,2.]],threshold:-0.018468,right_val:0.52131,left_val:0.38858},{features:[[6,12,4,5,-1.],[8,12,2,5,2.]],threshold:-4.5907e-004,right_val:0.42359,left_val:0.54126},{features:[[11,11,2,2,-1.],[12,11,1,1,2.],[11,12,1,1,2.]],threshold:1.2528e-003,right_val:0.66241,left_val:0.48993},{features:[[0,2,3,6,-1.],[0,4,3,2,3.]],threshold:1.4911e-003,right_val:0.40401,left_val:0.52868},{features:[[11,11,2,2,-1.],[12,11,1,1,2.],[11,12,1,1,2.]],threshold:-7.5436e-004,right_val:0.47951,left_val:0.6033},{features:[[7,6,4,10,-1.],[7,11,4,5,2.]],threshold:-6.9479e-003,right_val:0.53735,left_val:0.40844},{features:[[11,11,2,2,-1.],[12,11,1,1,2.],[11,12,1,1,2.]],threshold:2.8093e-004,right_val:0.57594,left_val:0.48461},{features:[[2,13,5,2,-1.],[2,14,5,1,2.]],threshold:9.6074e-004,right_val:0.3555,left_val:0.51647},{features:[[11,11,2,2,-1.],[12,11,1,1,2.],[11,12,1,1,2.]],threshold:-2.6884e-004,right_val:0.47318,left_val:0.56776},{features:[[7,11,2,2,-1.],[7,11,1,1,2.],[8,12,1,1,2.]],threshold:2.1599e-003,right_val:0.70706,left_val:0.47315},{features:[[14,13,3,3,-1.],[14,14,3,1,3.]],threshold:5.6235e-003,right_val:0.27818,left_val:0.52402},{features:[[3,13,3,3,-1.],[3,14,3,1,3.]],threshold:-5.0244e-003,right_val:0.50623,left_val:0.2837},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:-9.7612e-003,right_val:0.49346,left_val:0.74007},{features:[[8,7,3,3,-1.],[8,8,3,1,3.]],threshold:4.1515e-003,right_val:0.3407,left_val:0.51191},{features:[[13,5,3,3,-1.],[13,6,3,1,3.]],threshold:6.2465e-003,right_val:0.65791,left_val:0.49238},{features:[[0,9,5,3,-1.],[0,10,5,1,3.]],threshold:-7.0597e-003,right_val:0.50328,left_val:0.24347},{features:[[13,5,3,3,-1.],[13,6,3,1,3.]],threshold:-2.0588e-003,right_val:0.46951,left_val:0.59003},{features:[[9,12,2,8,-1.],[9,12,1,4,2.],[10,16,1,4,2.]],threshold:-2.4146e-003,right_val:0.51892,left_val:0.36473},{features:[[11,7,2,2,-1.],[12,7,1,1,2.],[11,8,1,1,2.]],threshold:-1.4818e-003,right_val:0.49401,left_val:0.60349},{features:[[0,16,6,4,-1.],[3,16,3,4,2.]],threshold:-6.3016e-003,right_val:0.45604,left_val:0.5819},{features:[[10,6,2,3,-1.],[10,7,2,1,3.]],threshold:3.4763e-003,right_val:0.3484,left_val:0.52175},{features:[[9,5,2,6,-1.],[9,7,2,2,3.]],threshold:-0.022251,right_val:0.50321,left_val:0.23607},{features:[[12,15,8,4,-1.],[12,15,4,4,2.]],threshold:-0.030613,right_val:0.49149,left_val:0.64992},{features:[[0,14,8,6,-1.],[4,14,4,6,2.]],threshold:0.013057,right_val:0.56838,left_val:0.44133},{features:[[9,0,3,2,-1.],[10,0,1,2,3.]],threshold:-6.0096e-004,right_val:0.53335,left_val:0.43597},{features:[[4,15,4,2,-1.],[6,15,2,2,2.]],threshold:-4.1514e-004,right_val:0.43261,left_val:0.55041},{features:[[12,7,3,13,-1.],[13,7,1,13,3.]],threshold:-0.013776,right_val:0.52015,left_val:0.40641},{features:[[5,7,3,13,-1.],[6,7,1,13,3.]],threshold:-0.032297,right_val:0.49772,left_val:0.047352},{features:[[9,6,3,9,-1.],[9,9,3,3,3.]],threshold:0.053557,right_val:0.66669,left_val:0.48817},{features:[[4,4,7,12,-1.],[4,10,7,6,2.]],threshold:8.189e-003,right_val:0.42408,left_val:0.54},{features:[[12,12,2,2,-1.],[13,12,1,1,2.],[12,13,1,1,2.]],threshold:2.1055e-004,right_val:0.55639,left_val:0.4802},{features:[[6,12,2,2,-1.],[6,12,1,1,2.],[7,13,1,1,2.]],threshold:-2.4383e-003,right_val:0.47737,left_val:0.73878},{features:[[8,9,4,2,-1.],[10,9,2,1,2.],[8,10,2,1,2.]],threshold:3.2836e-003,right_val:0.31713,left_val:0.52885},{features:[[3,6,2,2,-1.],[3,6,1,1,2.],[4,7,1,1,2.]],threshold:2.373e-003,right_val:0.70602,left_val:0.47508},{features:[[16,6,3,2,-1.],[16,7,3,1,2.]],threshold:-1.4542e-003,right_val:0.53307,left_val:0.38117}],threshold:79.249},{simpleClassifiers:[{features:[[0,7,19,4,-1.],[0,9,19,2,2.]],threshold:0.055755,right_val:0.6806,left_val:0.40192},{features:[[10,2,10,1,-1.],[10,2,5,1,2.]],threshold:2.473e-003,right_val:0.59657,left_val:0.33511},{features:[[9,4,2,12,-1.],[9,10,2,6,2.]],threshold:-3.5032e-004,right_val:0.34823,left_val:0.55577},{features:[[12,18,4,1,-1.],[12,18,2,1,2.]],threshold:5.4168e-004,right_val:0.56934,left_val:0.42609},{features:[[1,7,6,4,-1.],[1,7,3,2,2.],[4,9,3,2,2.]],threshold:7.7194e-004,right_val:0.54337,left_val:0.34942},{features:[[12,0,6,13,-1.],[14,0,2,13,3.]],threshold:-1.5999e-003,right_val:0.54844,left_val:0.40285},{features:[[2,0,6,13,-1.],[4,0,2,13,3.]],threshold:-1.1832e-004,right_val:0.54255,left_val:0.38069},{features:[[10,5,8,8,-1.],[10,9,8,4,2.]],threshold:3.2909e-004,right_val:0.54295,left_val:0.26201},{features:[[8,3,2,5,-1.],[9,3,1,5,2.]],threshold:2.9518e-004,right_val:0.53993,left_val:0.37998},{features:[[8,4,9,1,-1.],[11,4,3,1,3.]],threshold:9.0467e-005,right_val:0.54402,left_val:0.44336},{features:[[3,4,9,1,-1.],[6,4,3,1,3.]],threshold:1.5007e-005,right_val:0.54091,left_val:0.37197},{features:[[1,0,18,10,-1.],[7,0,6,10,3.]],threshold:0.13936,right_val:0.4479,left_val:0.55254},{features:[[7,17,5,3,-1.],[7,18,5,1,3.]],threshold:1.6462e-003,right_val:0.57722,left_val:0.42645},{features:[[7,11,6,1,-1.],[9,11,2,1,3.]],threshold:4.9984e-004,right_val:0.56859,left_val:0.43595},{features:[[2,2,3,2,-1.],[2,3,3,1,2.]],threshold:-1.0971e-003,right_val:0.52054,left_val:0.33901},{features:[[8,12,4,2,-1.],[8,13,4,1,2.]],threshold:6.692e-004,right_val:0.59807,left_val:0.45575},{features:[[6,10,3,6,-1.],[6,13,3,3,2.]],threshold:8.6471e-004,right_val:0.2944,left_val:0.51348},{features:[[11,4,2,4,-1.],[11,4,1,4,2.]],threshold:-2.7183e-004,right_val:0.53772,left_val:0.39066},{features:[[7,4,2,4,-1.],[8,4,1,4,2.]],threshold:3.0249e-005,right_val:0.52257,left_val:0.36796},{features:[[9,6,2,4,-1.],[9,6,1,4,2.]],threshold:-8.5226e-003,right_val:0.48924,left_val:0.72931},{features:[[6,13,8,3,-1.],[6,14,8,1,3.]],threshold:1.6706e-003,right_val:0.56961,left_val:0.43453},{features:[[9,15,3,4,-1.],[10,15,1,4,3.]],threshold:-7.1434e-003,right_val:0.52256,left_val:0.25913},{features:[[9,2,2,17,-1.],[10,2,1,17,2.]],threshold:-0.016319,right_val:0.46516,left_val:0.69223},{features:[[7,0,6,1,-1.],[9,0,2,1,3.]],threshold:4.8034e-003,right_val:0.32863,left_val:0.53523},{features:[[8,15,3,4,-1.],[9,15,1,4,3.]],threshold:-7.5422e-003,right_val:0.50345,left_val:0.20405},{features:[[7,13,7,3,-1.],[7,14,7,1,3.]],threshold:-0.014363,right_val:0.48891,left_val:0.68049},{features:[[8,16,3,3,-1.],[9,16,1,3,3.]],threshold:8.9064e-004,right_val:0.38955,left_val:0.53107},{features:[[6,2,8,10,-1.],[6,7,8,5,2.]],threshold:-4.406e-003,right_val:0.43724,left_val:0.57416},{features:[[2,5,8,8,-1.],[2,9,8,4,2.]],threshold:-1.8863e-004,right_val:0.50982,left_val:0.28318},{features:[[14,16,2,2,-1.],[14,17,2,1,2.]],threshold:-3.7979e-003,right_val:0.52466,left_val:0.33725},{features:[[4,16,2,2,-1.],[4,17,2,1,2.]],threshold:1.4627e-004,right_val:0.39117,left_val:0.53067},{features:[[10,11,4,6,-1.],[10,14,4,3,2.]],threshold:-4.9165e-005,right_val:0.39427,left_val:0.54625},{features:[[6,11,4,6,-1.],[6,14,4,3,2.]],threshold:-0.033583,right_val:0.50482,left_val:0.21578},{features:[[10,14,1,3,-1.],[10,15,1,1,3.]],threshold:-3.5339e-003,right_val:0.48727,left_val:0.64653},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:5.0144e-003,right_val:0.62481,left_val:0.46177},{features:[[10,0,4,6,-1.],[12,0,2,3,2.],[10,3,2,3,2.]],threshold:0.018817,right_val:0.20001,left_val:0.52207},{features:[[0,3,20,2,-1.],[0,4,20,1,2.]],threshold:-1.3434e-003,right_val:0.53016,left_val:0.40145},{features:[[12,0,8,2,-1.],[16,0,4,1,2.],[12,1,4,1,2.]],threshold:1.7558e-003,right_val:0.56532,left_val:0.4794},{features:[[2,12,10,8,-1.],[2,16,10,4,2.]],threshold:-0.095637,right_val:0.50067,left_val:0.20342},{features:[[17,7,2,10,-1.],[18,7,1,5,2.],[17,12,1,5,2.]],threshold:-0.022241,right_val:0.50463,left_val:0.76725},{features:[[1,7,2,10,-1.],[1,7,1,5,2.],[2,12,1,5,2.]],threshold:-0.015576,right_val:0.47559,left_val:0.74903},{features:[[15,10,3,6,-1.],[15,12,3,2,3.]],threshold:5.3599e-003,right_val:0.40047,left_val:0.53653},{features:[[4,4,6,2,-1.],[6,4,2,2,3.]],threshold:-0.021763,right_val:0.49642,left_val:0.074015},{features:[[0,5,20,6,-1.],[0,7,20,2,3.]],threshold:-0.16562,right_val:0.52181,left_val:0.28591},{features:[[0,0,8,2,-1.],[0,0,4,1,2.],[4,1,4,1,2.]],threshold:1.6461e-004,right_val:0.53808,left_val:0.41916},{features:[[1,0,18,4,-1.],[7,0,6,4,3.]],threshold:-8.9078e-003,right_val:0.48774,left_val:0.62732},{features:[[1,13,6,2,-1.],[1,14,6,1,2.]],threshold:8.6346e-004,right_val:0.3671,left_val:0.51599},{features:[[10,8,3,4,-1.],[11,8,1,4,3.]],threshold:-1.3752e-003,right_val:0.45791,left_val:0.58844},{features:[[6,1,6,1,-1.],[8,1,2,1,3.]],threshold:-1.4081e-003,right_val:0.51399,left_val:0.35605},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:-3.9343e-003,right_val:0.46643,left_val:0.59943},{features:[[1,6,18,2,-1.],[10,6,9,2,2.]],threshold:-0.031967,right_val:0.51442,left_val:0.33455},{features:[[15,11,1,2,-1.],[15,12,1,1,2.]],threshold:-1.5089e-005,right_val:0.44141,left_val:0.55827},{features:[[6,5,1,2,-1.],[6,6,1,1,2.]],threshold:5.1994e-004,right_val:0.6169,left_val:0.46237},{features:[[13,4,1,3,-1.],[13,5,1,1,3.]],threshold:-3.422e-003,right_val:0.49748,left_val:0.65571},{features:[[2,15,1,2,-1.],[2,16,1,1,2.]],threshold:1.7723e-004,right_val:0.39019,left_val:0.52695},{features:[[12,4,4,3,-1.],[12,5,4,1,3.]],threshold:1.5717e-003,right_val:0.57905,left_val:0.46334},{features:[[0,0,7,3,-1.],[0,1,7,1,3.]],threshold:-8.9041e-003,right_val:0.50536,left_val:0.26896},{features:[[9,12,6,2,-1.],[9,12,3,2,2.]],threshold:4.0678e-004,right_val:0.43299,left_val:0.54566},{features:[[5,4,2,3,-1.],[5,5,2,1,3.]],threshold:6.7605e-003,right_val:0.66898,left_val:0.4649},{features:[[18,4,2,3,-1.],[18,5,2,1,3.]],threshold:2.91e-003,right_val:0.33778,left_val:0.53097},{features:[[3,0,8,6,-1.],[3,2,8,2,3.]],threshold:1.3885e-003,right_val:0.53491,left_val:0.40747},{features:[[0,2,20,6,-1.],[10,2,10,3,2.],[0,5,10,3,2.]],threshold:-0.076764,right_val:0.52282,left_val:0.19922},{features:[[4,7,2,4,-1.],[5,7,1,4,2.]],threshold:-2.2688e-004,right_val:0.42531,left_val:0.54385},{features:[[3,10,15,2,-1.],[8,10,5,2,3.]],threshold:-6.3094e-003,right_val:0.53789,left_val:0.42592},{features:[[3,0,12,11,-1.],[9,0,6,11,2.]],threshold:-0.11007,right_val:0.47217,left_val:0.69042},{features:[[13,0,2,6,-1.],[13,0,1,6,2.]],threshold:2.862e-004,right_val:0.55483,left_val:0.45249},{features:[[0,19,2,1,-1.],[1,19,1,1,2.]],threshold:2.9425e-005,right_val:0.42365,left_val:0.53704},{features:[[16,10,4,10,-1.],[18,10,2,5,2.],[16,15,2,5,2.]],threshold:-0.024887,right_val:0.49693,left_val:0.64236},{features:[[4,8,10,3,-1.],[4,9,10,1,3.]],threshold:0.033149,right_val:0.16138,left_val:0.49885},{features:[[14,12,3,3,-1.],[14,13,3,1,3.]],threshold:7.8492e-004,right_val:0.4223,left_val:0.5416},{features:[[0,10,4,10,-1.],[0,10,2,5,2.],[2,15,2,5,2.]],threshold:4.7087e-003,right_val:0.60276,left_val:0.45763},{features:[[18,3,2,6,-1.],[18,5,2,2,3.]],threshold:2.4144e-003,right_val:0.44225,left_val:0.5309},{features:[[6,6,1,3,-1.],[6,7,1,1,3.]],threshold:1.9523e-003,right_val:0.66633,left_val:0.47056},{features:[[7,7,7,2,-1.],[7,8,7,1,2.]],threshold:1.3032e-003,right_val:0.5527,left_val:0.44061},{features:[[0,3,2,6,-1.],[0,5,2,2,3.]],threshold:4.4735e-003,right_val:0.33015,left_val:0.5129},{features:[[11,1,3,1,-1.],[12,1,1,1,3.]],threshold:-2.6653e-003,right_val:0.5175,left_val:0.31355},{features:[[5,0,2,6,-1.],[6,0,1,6,2.]],threshold:1.3667e-004,right_val:0.53069,left_val:0.41194},{features:[[1,1,18,14,-1.],[7,1,6,14,3.]],threshold:-0.017126,right_val:0.48366,left_val:0.61778},{features:[[4,6,8,3,-1.],[8,6,4,3,2.]],threshold:-2.6601e-004,right_val:0.51697,left_val:0.36543},{features:[[9,12,6,2,-1.],[9,12,3,2,2.]],threshold:-0.022932,right_val:0.5164,left_val:0.34909},{features:[[5,12,6,2,-1.],[8,12,3,2,2.]],threshold:2.3317e-003,right_val:0.37094,left_val:0.51663},{features:[[10,7,3,5,-1.],[11,7,1,5,3.]],threshold:0.016926,right_val:0.8054,left_val:0.50147},{features:[[7,7,3,5,-1.],[8,7,1,5,3.]],threshold:-8.9859e-003,right_val:0.4657,left_val:0.64708},{features:[[13,0,3,10,-1.],[14,0,1,10,3.]],threshold:-0.011875,right_val:0.52588,left_val:0.32464},{features:[[4,11,3,2,-1.],[4,12,3,1,2.]],threshold:1.9351e-004,right_val:0.38396,left_val:0.51919},{features:[[17,3,3,6,-1.],[18,3,1,6,3.]],threshold:5.8713e-003,right_val:0.6187,left_val:0.49181},{features:[[1,8,18,10,-1.],[1,13,18,5,2.]],threshold:-0.24839,right_val:0.49882,left_val:0.18368},{features:[[13,0,3,10,-1.],[14,0,1,10,3.]],threshold:0.012256,right_val:0.3632,left_val:0.52271},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:8.399e-004,right_val:0.57741,left_val:0.44903},{features:[[16,3,3,7,-1.],[17,3,1,7,3.]],threshold:2.5407e-003,right_val:0.58583,left_val:0.48048},{features:[[4,0,3,10,-1.],[5,0,1,10,3.]],threshold:-0.014822,right_val:0.50235,left_val:0.2521},{features:[[16,3,3,7,-1.],[17,3,1,7,3.]],threshold:-5.7974e-003,right_val:0.48537,left_val:0.59967},{features:[[0,9,1,2,-1.],[0,10,1,1,2.]],threshold:7.2662e-004,right_val:0.36718,left_val:0.51537},{features:[[18,1,2,10,-1.],[18,1,1,10,2.]],threshold:-0.017233,right_val:0.49947,left_val:0.66217},{features:[[0,1,2,10,-1.],[1,1,1,10,2.]],threshold:7.8624e-003,right_val:0.62561,left_val:0.46334},{features:[[10,16,3,4,-1.],[11,16,1,4,3.]],threshold:-4.7344e-003,right_val:0.52819,left_val:0.36156},{features:[[2,8,3,3,-1.],[3,8,1,3,3.]],threshold:8.3048e-004,right_val:0.5551,left_val:0.44429},{features:[[11,0,2,6,-1.],[12,0,1,3,2.],[11,3,1,3,2.]],threshold:7.6602e-003,right_val:0.26134,left_val:0.51629},{features:[[7,0,2,6,-1.],[7,0,1,3,2.],[8,3,1,3,2.]],threshold:-4.1048e-003,right_val:0.5019,left_val:0.27896},{features:[[16,3,3,7,-1.],[17,3,1,7,3.]],threshold:4.8513e-003,right_val:0.56617,left_val:0.4969},{features:[[1,3,3,7,-1.],[2,3,1,7,3.]],threshold:9.9896e-004,right_val:0.55518,left_val:0.44456},{features:[[14,1,6,16,-1.],[16,1,2,16,3.]],threshold:-0.27024,right_val:0.51513,left_val:0.029388},{features:[[0,1,6,16,-1.],[2,1,2,16,3.]],threshold:-0.013091,right_val:0.44475,left_val:0.56994},{features:[[2,0,16,8,-1.],[10,0,8,4,2.],[2,4,8,4,2.]],threshold:-9.4343e-003,right_val:0.54879,left_val:0.43055},{features:[[6,8,5,3,-1.],[6,9,5,1,3.]],threshold:-1.5482e-003,right_val:0.51281,left_val:0.36803},{features:[[9,7,3,3,-1.],[10,7,1,3,3.]],threshold:5.3746e-003,right_val:0.61016,left_val:0.48389},{features:[[8,8,4,3,-1.],[8,9,4,1,3.]],threshold:1.5787e-003,right_val:0.41185,left_val:0.53252},{features:[[9,6,2,4,-1.],[9,6,1,4,2.]],threshold:3.6856e-003,right_val:0.62523,left_val:0.48109},{features:[[0,7,15,1,-1.],[5,7,5,1,3.]],threshold:9.3887e-003,right_val:0.36294,left_val:0.52002},{features:[[8,2,7,9,-1.],[8,5,7,3,3.]],threshold:0.012793,right_val:0.6738,left_val:0.49617},{features:[[1,7,16,4,-1.],[1,7,8,2,2.],[9,9,8,2,2.]],threshold:-3.3661e-003,right_val:0.52836,left_val:0.40603},{features:[[6,12,8,2,-1.],[6,13,8,1,2.]],threshold:3.9771e-004,right_val:0.59008,left_val:0.46741},{features:[[8,11,3,3,-1.],[8,12,3,1,3.]],threshold:1.4868e-003,right_val:0.60821,left_val:0.45191},{features:[[4,5,14,10,-1.],[11,5,7,5,2.],[4,10,7,5,2.]],threshold:-0.088687,right_val:0.5181,left_val:0.28079},{features:[[4,12,3,2,-1.],[4,13,3,1,2.]],threshold:-7.4296e-005,right_val:0.40876,left_val:0.52956},{features:[[9,11,6,1,-1.],[11,11,2,1,3.]],threshold:-1.4933e-005,right_val:0.45385,left_val:0.54614},{features:[[4,9,7,6,-1.],[4,11,7,2,3.]],threshold:5.9162e-003,right_val:0.41921,left_val:0.53292},{features:[[7,10,6,3,-1.],[7,11,6,1,3.]],threshold:1.1142e-003,right_val:0.57062,left_val:0.4512},{features:[[9,11,2,2,-1.],[9,12,2,1,2.]],threshold:8.9249e-005,right_val:0.58976,left_val:0.45778},{features:[[0,5,20,6,-1.],[0,7,20,2,3.]],threshold:2.532e-003,right_val:0.33576,left_val:0.52996},{features:[[6,4,6,1,-1.],[8,4,2,1,3.]],threshold:0.012426,right_val:0.13466,left_val:0.49591},{features:[[9,11,6,1,-1.],[11,11,2,1,3.]],threshold:0.028336,right_val:6.1044e-004,left_val:0.51171},{features:[[5,11,6,1,-1.],[7,11,2,1,3.]],threshold:6.6166e-003,right_val:0.70116,left_val:0.47363},{features:[[10,16,3,4,-1.],[11,16,1,4,3.]],threshold:8.0469e-003,right_val:0.32828,left_val:0.52164},{features:[[8,7,3,3,-1.],[9,7,1,3,3.]],threshold:-1.1194e-003,right_val:0.45637,left_val:0.58099},{features:[[2,12,16,8,-1.],[2,16,16,4,2.]],threshold:0.013278,right_val:0.41039,left_val:0.53984},{features:[[0,15,15,2,-1.],[0,16,15,1,2.]],threshold:4.8795e-004,right_val:0.54106,left_val:0.42493},{features:[[15,4,5,6,-1.],[15,6,5,2,3.]],threshold:0.011243,right_val:0.34382,left_val:0.527},{features:[[9,5,2,4,-1.],[10,5,1,4,2.]],threshold:-8.9897e-004,right_val:0.44566,left_val:0.56331},{features:[[8,10,9,6,-1.],[8,12,9,2,3.]],threshold:6.6677e-003,right_val:0.43627,left_val:0.53129},{features:[[2,19,15,1,-1.],[7,19,5,1,3.]],threshold:0.028947,right_val:0.65758,left_val:0.47018},{features:[[10,16,3,4,-1.],[11,16,1,4,3.]],threshold:-0.0234,right_val:0.51374,left_val:0.},{features:[[0,15,20,4,-1.],[0,17,20,2,2.]],threshold:-0.089117,right_val:0.49424,left_val:0.023745},{features:[[10,16,3,4,-1.],[11,16,1,4,3.]],threshold:-0.014055,right_val:0.51175,left_val:0.31273},{features:[[7,16,3,4,-1.],[8,16,1,4,3.]],threshold:8.1239e-003,right_val:0.252,left_val:0.5009},{features:[[9,16,3,3,-1.],[9,17,3,1,3.]],threshold:-4.9965e-003,right_val:0.49278,left_val:0.63871},{features:[[8,11,4,6,-1.],[8,14,4,3,2.]],threshold:3.1254e-003,right_val:0.36805,left_val:0.51368},{features:[[9,6,2,12,-1.],[9,10,2,4,3.]],threshold:6.767e-003,right_val:0.43636,left_val:0.55098},{features:[[8,17,4,3,-1.],[8,18,4,1,3.]],threshold:-2.3711e-003,right_val:0.45869,left_val:0.61623},{features:[[9,18,8,2,-1.],[13,18,4,1,2.],[9,19,4,1,2.]],threshold:-5.3523e-003,right_val:0.49205,left_val:0.61855},{features:[[1,18,8,2,-1.],[1,19,8,1,2.]],threshold:-0.015969,right_val:0.49833,left_val:0.13826},{features:[[13,5,6,15,-1.],[15,5,2,15,3.]],threshold:4.7676e-003,right_val:0.549,left_val:0.46881},{features:[[9,8,2,2,-1.],[9,9,2,1,2.]],threshold:-2.4715e-003,right_val:0.5004,left_val:0.23685},{features:[[9,5,2,3,-1.],[9,5,1,3,2.]],threshold:-7.1034e-004,right_val:0.47215,left_val:0.58564},{features:[[1,5,6,15,-1.],[3,5,2,15,3.]],threshold:-0.14118,right_val:0.49616,left_val:0.0869},{features:[[4,1,14,8,-1.],[11,1,7,4,2.],[4,5,7,4,2.]],threshold:0.10652,right_val:0.1741,left_val:0.51388},{features:[[2,4,4,16,-1.],[2,4,2,8,2.],[4,12,2,8,2.]],threshold:-0.052745,right_val:0.47729,left_val:0.73536},{features:[[12,4,3,12,-1.],[12,10,3,6,2.]],threshold:-4.7432e-003,right_val:0.52927,left_val:0.38844},{features:[[4,5,10,12,-1.],[4,5,5,6,2.],[9,11,5,6,2.]],threshold:9.9677e-004,right_val:0.40034,left_val:0.52235},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:8.0284e-003,right_val:0.7213,left_val:0.49591},{features:[[5,4,2,3,-1.],[5,5,2,1,3.]],threshold:8.6026e-004,right_val:0.55385,left_val:0.44449},{features:[[12,2,4,10,-1.],[14,2,2,5,2.],[12,7,2,5,2.]],threshold:9.3192e-004,right_val:0.41632,left_val:0.53984},{features:[[6,4,7,3,-1.],[6,5,7,1,3.]],threshold:-2.5082e-003,right_val:0.45625,left_val:0.58543},{features:[[2,0,18,2,-1.],[11,0,9,1,2.],[2,1,9,1,2.]],threshold:-2.1379e-003,right_val:0.52803,left_val:0.46081},{features:[[0,0,18,2,-1.],[0,0,9,1,2.],[9,1,9,1,2.]],threshold:-2.1546e-003,right_val:0.5256,left_val:0.37911},{features:[[13,13,4,6,-1.],[15,13,2,3,2.],[13,16,2,3,2.]],threshold:-7.6214e-003,right_val:0.49521,left_val:0.59986},{features:[[3,13,4,6,-1.],[3,13,2,3,2.],[5,16,2,3,2.]],threshold:2.2055e-003,right_val:0.55885,left_val:0.44842},{features:[[10,12,2,6,-1.],[10,15,2,3,2.]],threshold:1.2587e-003,right_val:0.44238,left_val:0.54507},{features:[[5,9,10,10,-1.],[5,9,5,5,2.],[10,14,5,5,2.]],threshold:-5.0927e-003,right_val:0.5263,left_val:0.41183},{features:[[11,4,4,2,-1.],[13,4,2,1,2.],[11,5,2,1,2.]],threshold:-2.5096e-003,right_val:0.49985,left_val:0.57879},{features:[[7,12,6,8,-1.],[10,12,3,8,2.]],threshold:-0.077328,right_val:0.48111,left_val:0.83979},{features:[[12,2,4,10,-1.],[14,2,2,5,2.],[12,7,2,5,2.]],threshold:-0.041486,right_val:0.5177,left_val:0.24086},{features:[[8,11,2,1,-1.],[9,11,1,1,2.]],threshold:1.0356e-004,right_val:0.54171,left_val:0.43554},{features:[[10,5,1,12,-1.],[10,9,1,4,3.]],threshold:1.3256e-003,right_val:0.48941,left_val:0.5454},{features:[[0,11,6,9,-1.],[3,11,3,9,2.]],threshold:-8.0599e-003,right_val:0.45779,left_val:0.5771},{features:[[12,2,4,10,-1.],[14,2,2,5,2.],[12,7,2,5,2.]],threshold:0.019059,right_val:0.34005,left_val:0.51699},{features:[[4,2,4,10,-1.],[4,2,2,5,2.],[6,7,2,5,2.]],threshold:-0.035058,right_val:0.50005,left_val:0.22032},{features:[[11,4,4,2,-1.],[13,4,2,1,2.],[11,5,2,1,2.]],threshold:5.7296e-003,right_val:0.65976,left_val:0.50434},{features:[[0,14,6,3,-1.],[0,15,6,1,3.]],threshold:-0.011648,right_val:0.49967,left_val:0.21863},{features:[[11,4,4,2,-1.],[13,4,2,1,2.],[11,5,2,1,2.]],threshold:1.4544e-003,right_val:0.55037,left_val:0.50077},{features:[[6,1,3,2,-1.],[7,1,1,2,3.]],threshold:-2.5031e-004,right_val:0.52417,left_val:0.41298},{features:[[11,4,4,2,-1.],[13,4,2,1,2.],[11,5,2,1,2.]],threshold:-8.2907e-004,right_val:0.49745,left_val:0.54129},{features:[[5,4,4,2,-1.],[5,4,2,1,2.],[7,5,2,1,2.]],threshold:1.0862e-003,right_val:0.58792,left_val:0.46055},{features:[[13,0,2,12,-1.],[14,0,1,6,2.],[13,6,1,6,2.]],threshold:2.0001e-004,right_val:0.47052,left_val:0.52789},{features:[[6,0,3,10,-1.],[7,0,1,10,3.]],threshold:2.9213e-003,right_val:0.37555,left_val:0.51296},{features:[[3,0,17,8,-1.],[3,4,17,4,2.]],threshold:0.025387,right_val:0.57908,left_val:0.48227},{features:[[0,4,20,4,-1.],[0,6,20,2,2.]],threshold:-3.1968e-003,right_val:0.39628,left_val:0.52484}],threshold:87.696},{simpleClassifiers:[{features:[[0,3,8,2,-1.],[4,3,4,2,2.]],threshold:5.8032e-003,right_val:0.5962,left_val:0.3499},{features:[[8,11,4,3,-1.],[8,12,4,1,3.]],threshold:-9.0003e-003,right_val:0.44786,left_val:0.68166},{features:[[5,7,6,4,-1.],[5,7,3,2,2.],[8,9,3,2,2.]],threshold:-1.155e-003,right_val:0.35783,left_val:0.55857},{features:[[8,3,4,9,-1.],[8,6,4,3,3.]],threshold:-1.107e-003,right_val:0.30504,left_val:0.5365},{features:[[8,15,1,4,-1.],[8,17,1,2,2.]],threshold:1.0308e-004,right_val:0.53446,left_val:0.36391},{features:[[4,5,12,7,-1.],[8,5,4,7,3.]],threshold:-5.0985e-003,right_val:0.55043,left_val:0.28592},{features:[[4,2,4,10,-1.],[4,2,2,5,2.],[6,7,2,5,2.]],threshold:8.2572e-004,right_val:0.3476,left_val:0.52365},{features:[[3,0,17,2,-1.],[3,1,17,1,2.]],threshold:9.9783e-003,right_val:0.62196,left_val:0.47503},{features:[[2,2,16,15,-1.],[2,7,16,5,3.]],threshold:-0.037403,right_val:0.52781,left_val:0.33434},{features:[[15,2,5,2,-1.],[15,3,5,1,2.]],threshold:4.8548e-003,right_val:0.37004,left_val:0.51922},{features:[[9,3,2,2,-1.],[10,3,1,2,2.]],threshold:-1.8664e-003,right_val:0.50919,left_val:0.29298},{features:[[4,5,16,15,-1.],[4,10,16,5,3.]],threshold:0.016889,right_val:0.54312,left_val:0.36868},{features:[[7,13,5,6,-1.],[7,16,5,3,2.]],threshold:-5.8373e-003,right_val:0.52213,left_val:0.36322},{features:[[10,7,3,2,-1.],[11,7,1,2,3.]],threshold:-1.4714e-003,right_val:0.47007,left_val:0.58707},{features:[[8,3,3,1,-1.],[9,3,1,1,3.]],threshold:-1.1523e-003,right_val:0.5141,left_val:0.31959},{features:[[9,16,3,3,-1.],[9,17,3,1,3.]],threshold:-4.256e-003,right_val:0.48149,left_val:0.63019},{features:[[0,2,5,2,-1.],[0,3,5,1,2.]],threshold:-6.7378e-003,right_val:0.50258,left_val:0.1977},{features:[[12,5,4,3,-1.],[12,6,4,1,3.]],threshold:0.011383,right_val:0.6867,left_val:0.49541},{features:[[1,7,12,1,-1.],[5,7,4,1,3.]],threshold:5.1795e-003,right_val:0.33506,left_val:0.51644},{features:[[7,5,6,14,-1.],[7,12,6,7,2.]],threshold:-0.11744,right_val:0.52344,left_val:0.23152},{features:[[0,0,8,10,-1.],[0,0,4,5,2.],[4,5,4,5,2.]],threshold:0.028703,right_val:0.67225,left_val:0.46643},{features:[[9,1,3,2,-1.],[10,1,1,2,3.]],threshold:4.8231e-003,right_val:0.27235,left_val:0.52209},{features:[[8,1,3,2,-1.],[9,1,1,2,3.]],threshold:2.6799e-003,right_val:0.29069,left_val:0.50793},{features:[[12,4,3,3,-1.],[12,5,3,1,3.]],threshold:8.0504e-003,right_val:0.6395,left_val:0.4886},{features:[[7,4,6,16,-1.],[7,12,6,8,2.]],threshold:4.8055e-003,right_val:0.36567,left_val:0.51973},{features:[[12,4,3,3,-1.],[12,5,3,1,3.]],threshold:-2.242e-003,right_val:0.47637,left_val:0.61535},{features:[[2,3,2,6,-1.],[2,5,2,2,3.]],threshold:-0.013758,right_val:0.50309,left_val:0.26373},{features:[[14,2,6,9,-1.],[14,5,6,3,3.]],threshold:-0.10338,right_val:0.51825,left_val:0.22875},{features:[[5,4,3,3,-1.],[5,5,3,1,3.]],threshold:-9.4432e-003,right_val:0.46949,left_val:0.69533},{features:[[9,17,3,2,-1.],[10,17,1,2,3.]],threshold:8.0271e-004,right_val:0.42688,left_val:0.54507},{features:[[5,5,2,3,-1.],[5,6,2,1,3.]],threshold:-4.1946e-003,right_val:0.45716,left_val:0.60914},{features:[[13,11,3,6,-1.],[13,13,3,2,3.]],threshold:0.010942,right_val:0.32845,left_val:0.52411},{features:[[3,14,2,6,-1.],[3,17,2,3,2.]],threshold:-5.7841e-004,right_val:0.41794,left_val:0.53879},{features:[[14,3,6,2,-1.],[14,4,6,1,2.]],threshold:-2.0889e-003,right_val:0.53017,left_val:0.42927},{features:[[0,8,16,2,-1.],[0,9,16,1,2.]],threshold:3.2384e-003,right_val:0.52207,left_val:0.37923},{features:[[14,3,6,2,-1.],[14,4,6,1,2.]],threshold:4.9075e-003,right_val:0.41268,left_val:0.52373},{features:[[0,0,5,6,-1.],[0,2,5,2,3.]],threshold:-0.032278,right_val:0.49945,left_val:0.19477},{features:[[12,5,4,3,-1.],[12,6,4,1,3.]],threshold:-8.9711e-003,right_val:0.4929,left_val:0.60113},{features:[[4,11,3,6,-1.],[4,13,3,2,3.]],threshold:0.015321,right_val:0.20398,left_val:0.50098},{features:[[12,5,4,3,-1.],[12,6,4,1,3.]],threshold:2.0856e-003,right_val:0.57217,left_val:0.48622},{features:[[9,5,1,3,-1.],[9,6,1,1,3.]],threshold:5.0615e-003,right_val:0.18018,left_val:0.50002},{features:[[12,5,4,3,-1.],[12,6,4,1,3.]],threshold:-3.7175e-003,right_val:0.48976,left_val:0.55301},{features:[[6,6,8,12,-1.],[6,12,8,6,2.]],threshold:-0.012171,right_val:0.53837,left_val:0.41786},{features:[[12,5,4,3,-1.],[12,6,4,1,3.]],threshold:4.6248e-003,right_val:0.57613,left_val:0.49972},{features:[[5,12,9,2,-1.],[8,12,3,2,3.]],threshold:-2.104e-004,right_val:0.40977,left_val:0.53318},{features:[[12,5,4,3,-1.],[12,6,4,1,3.]],threshold:-0.014642,right_val:0.50518,left_val:0.57559},{features:[[4,5,4,3,-1.],[4,6,4,1,3.]],threshold:3.3199e-003,right_val:0.60318,left_val:0.4577},{features:[[6,6,9,2,-1.],[9,6,3,2,3.]],threshold:3.7237e-003,right_val:0.54159,left_val:0.43804},{features:[[4,11,1,3,-1.],[4,12,1,1,3.]],threshold:8.2951e-004,right_val:0.37022,left_val:0.5163},{features:[[14,12,6,6,-1.],[14,12,3,6,2.]],threshold:-0.011408,right_val:0.48626,left_val:0.60729},{features:[[7,0,3,7,-1.],[8,0,1,7,3.]],threshold:-4.532e-003,right_val:0.5089,left_val:0.32925},{features:[[9,8,3,3,-1.],[10,8,1,3,3.]],threshold:5.1276e-003,right_val:0.61227,left_val:0.48298},{features:[[8,8,3,3,-1.],[9,8,1,3,3.]],threshold:9.8583e-003,right_val:0.65562,left_val:0.46607},{features:[[5,10,11,3,-1.],[5,11,11,1,3.]],threshold:0.036986,right_val:0.16905,left_val:0.52048},{features:[[5,7,10,1,-1.],[10,7,5,1,2.]],threshold:4.6491e-003,right_val:0.37252,left_val:0.51673},{features:[[9,7,3,2,-1.],[10,7,1,2,3.]],threshold:-4.2665e-003,right_val:0.49873,left_val:0.64065},{features:[[8,7,3,2,-1.],[9,7,1,2,3.]],threshold:-4.7957e-004,right_val:0.44649,left_val:0.58973},{features:[[11,9,4,2,-1.],[11,9,2,2,2.]],threshold:3.6827e-003,right_val:0.34727,left_val:0.54416},{features:[[5,9,4,2,-1.],[7,9,2,2,2.]],threshold:-0.01006,right_val:0.50048,left_val:0.21432},{features:[[14,10,2,4,-1.],[14,12,2,2,2.]],threshold:-3.0362e-004,right_val:0.45903,left_val:0.53864},{features:[[7,7,3,2,-1.],[8,7,1,2,3.]],threshold:-1.4545e-003,right_val:0.44971,left_val:0.57512},{features:[[14,17,6,3,-1.],[14,18,6,1,3.]],threshold:1.6515e-003,right_val:0.42385,left_val:0.54219},{features:[[4,5,12,12,-1.],[4,5,6,6,2.],[10,11,6,6,2.]],threshold:-7.8469e-003,right_val:0.52582,left_val:0.40779},{features:[[6,9,8,8,-1.],[10,9,4,4,2.],[6,13,4,4,2.]],threshold:-5.126e-003,right_val:0.54795,left_val:0.42293},{features:[[0,4,15,4,-1.],[5,4,5,4,3.]],threshold:-0.036891,right_val:0.46747,left_val:0.65964},{features:[[13,2,4,1,-1.],[13,2,2,1,2.]],threshold:2.4036e-004,right_val:0.55732,left_val:0.42511},{features:[[4,12,2,2,-1.],[4,13,2,1,2.]],threshold:-1.515e-005,right_val:0.40741,left_val:0.52592},{features:[[8,13,4,3,-1.],[8,14,4,1,3.]],threshold:2.2108e-003,right_val:0.58864,left_val:0.46717},{features:[[9,13,2,3,-1.],[9,14,2,1,3.]],threshold:-1.1569e-003,right_val:0.44872,left_val:0.57111},{features:[[13,11,2,3,-1.],[13,12,2,1,3.]],threshold:4.9996e-003,right_val:0.28983,left_val:0.52642},{features:[[7,12,4,4,-1.],[7,12,2,2,2.],[9,14,2,2,2.]],threshold:-1.4656e-003,right_val:0.51979,left_val:0.38917},{features:[[10,11,2,2,-1.],[11,11,1,1,2.],[10,12,1,1,2.]],threshold:-1.1975e-003,right_val:0.4928,left_val:0.57959},{features:[[8,17,3,2,-1.],[9,17,1,2,3.]],threshold:-4.4954e-003,right_val:0.50126,left_val:0.23776},{features:[[10,11,2,2,-1.],[11,11,1,1,2.],[10,12,1,1,2.]],threshold:1.4997e-004,right_val:0.56176,left_val:0.48766},{features:[[0,17,6,3,-1.],[0,18,6,1,3.]],threshold:2.6392e-003,right_val:0.37655,left_val:0.51681},{features:[[10,11,2,2,-1.],[11,11,1,1,2.],[10,12,1,1,2.]],threshold:-2.9368e-004,right_val:0.48746,left_val:0.54466},{features:[[8,11,2,2,-1.],[8,11,1,1,2.],[9,12,1,1,2.]],threshold:1.4212e-003,right_val:0.66913,left_val:0.46879},{features:[[12,5,8,4,-1.],[12,5,4,4,2.]],threshold:0.079428,right_val:0.27329,left_val:0.51934},{features:[[0,5,8,4,-1.],[4,5,4,4,2.]],threshold:0.079938,right_val:0.17821,left_val:0.49717},{features:[[13,2,4,1,-1.],[13,2,2,1,2.]],threshold:0.011089,right_val:0.32095,left_val:0.5166},{features:[[3,2,4,1,-1.],[5,2,2,1,2.]],threshold:1.6561e-004,right_val:0.53073,left_val:0.40585},{features:[[10,0,4,2,-1.],[12,0,2,1,2.],[10,1,2,1,2.]],threshold:-5.3354e-003,right_val:0.51581,left_val:0.34451},{features:[[7,12,3,1,-1.],[8,12,1,1,3.]],threshold:1.1287e-003,right_val:0.60755,left_val:0.45949},{features:[[8,11,4,8,-1.],[10,11,2,4,2.],[8,15,2,4,2.]],threshold:-0.021969,right_val:0.52286,left_val:0.16804},{features:[[9,9,2,2,-1.],[9,10,2,1,2.]],threshold:-2.1775e-004,right_val:0.52157,left_val:0.38616},{features:[[3,18,15,2,-1.],[3,19,15,1,2.]],threshold:2.02e-004,right_val:0.4363,left_val:0.5518},{features:[[2,6,2,12,-1.],[2,6,1,6,2.],[3,12,1,6,2.]],threshold:-0.021733,right_val:0.47899,left_val:0.79995},{features:[[9,8,2,3,-1.],[9,9,2,1,3.]],threshold:-8.44e-004,right_val:0.53748,left_val:0.4086},{features:[[7,10,3,2,-1.],[8,10,1,2,3.]],threshold:-4.3895e-004,right_val:0.43661,left_val:0.54704},{features:[[11,11,3,1,-1.],[12,11,1,1,3.]],threshold:1.5092e-003,right_val:0.58421,left_val:0.4989},{features:[[6,11,3,1,-1.],[7,11,1,1,3.]],threshold:-3.5548e-003,right_val:0.4721,left_val:0.67537},{features:[[9,2,4,2,-1.],[11,2,2,1,2.],[9,3,2,1,2.]],threshold:4.8191e-004,right_val:0.43571,left_val:0.54159},{features:[[4,12,2,3,-1.],[4,13,2,1,3.]],threshold:-6.0264e-003,right_val:0.49919,left_val:0.22585},{features:[[2,1,18,3,-1.],[8,1,6,3,3.]],threshold:-0.011668,right_val:0.49275,left_val:0.62566},{features:[[5,1,4,14,-1.],[7,1,2,14,2.]],threshold:-2.8718e-003,right_val:0.52458,left_val:0.39478},{features:[[8,16,12,3,-1.],[8,16,6,3,2.]],threshold:0.017051,right_val:0.57942,left_val:0.47525},{features:[[1,17,18,3,-1.],[7,17,6,3,3.]],threshold:-0.013352,right_val:0.45445,left_val:0.60411},{features:[[9,14,2,6,-1.],[9,17,2,3,2.]],threshold:-3.9302e-004,right_val:0.55449,left_val:0.42583},{features:[[9,12,1,8,-1.],[9,16,1,4,2.]],threshold:3.0483e-003,right_val:0.37803,left_val:0.52334},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:-4.3579e-003,right_val:0.48387,left_val:0.63719},{features:[[9,6,2,12,-1.],[9,10,2,4,3.]],threshold:5.6661e-003,right_val:0.41637,left_val:0.53747},{features:[[12,9,3,3,-1.],[12,10,3,1,3.]],threshold:6.0677e-005,right_val:0.53116,left_val:0.46388},{features:[[0,1,4,8,-1.],[2,1,2,8,2.]],threshold:0.036738,right_val:0.64665,left_val:0.46887},{features:[[9,1,6,2,-1.],[12,1,3,1,2.],[9,2,3,1,2.]],threshold:8.6528e-003,right_val:0.21887,left_val:0.52043},{features:[[1,3,12,14,-1.],[1,10,12,7,2.]],threshold:-0.15371,right_val:0.49588,left_val:0.16304},{features:[[8,12,4,2,-1.],[10,12,2,1,2.],[8,13,2,1,2.]],threshold:-4.156e-004,right_val:0.46965,left_val:0.57745},{features:[[1,9,10,2,-1.],[1,9,5,1,2.],[6,10,5,1,2.]],threshold:-1.264e-003,right_val:0.52172,left_val:0.39772},{features:[[8,15,4,3,-1.],[8,16,4,1,3.]],threshold:-3.5473e-003,right_val:0.48083,left_val:0.60465},{features:[[6,8,8,3,-1.],[6,9,8,1,3.]],threshold:3.0019e-005,right_val:0.52282,left_val:0.39967},{features:[[9,15,5,3,-1.],[9,16,5,1,3.]],threshold:1.3113e-003,right_val:0.5766,left_val:0.47122},{features:[[8,7,4,3,-1.],[8,8,4,1,3.]],threshold:-1.3375e-003,right_val:0.52532,left_val:0.41096},{features:[[7,7,6,2,-1.],[7,8,6,1,2.]],threshold:0.020877,right_val:0.1758,left_val:0.5203},{features:[[5,7,8,2,-1.],[5,7,4,1,2.],[9,8,4,1,2.]],threshold:-7.5498e-003,right_val:0.4695,left_val:0.65666},{features:[[12,9,3,3,-1.],[12,10,3,1,3.]],threshold:0.024189,right_val:0.33702,left_val:0.51287},{features:[[4,7,4,2,-1.],[4,8,4,1,2.]],threshold:-2.9359e-003,right_val:0.46945,left_val:0.65808},{features:[[14,2,6,9,-1.],[14,5,6,3,3.]],threshold:0.057558,right_val:0.27753,left_val:0.51464},{features:[[4,9,3,3,-1.],[5,9,1,3,3.]],threshold:-1.1343e-003,right_val:0.51927,left_val:0.38366},{features:[[12,9,3,3,-1.],[12,10,3,1,3.]],threshold:0.016817,right_val:0.61773,left_val:0.50856},{features:[[0,2,6,9,-1.],[0,5,6,3,3.]],threshold:5.0535e-003,right_val:0.36848,left_val:0.51388},{features:[[17,3,3,6,-1.],[18,3,1,6,3.]],threshold:-4.5875e-003,right_val:0.48352,left_val:0.59897},{features:[[0,3,3,6,-1.],[1,3,1,6,3.]],threshold:1.6882e-003,right_val:0.57231,left_val:0.45095},{features:[[17,14,1,2,-1.],[17,15,1,1,2.]],threshold:-1.6554e-003,right_val:0.52433,left_val:0.34968},{features:[[4,9,4,3,-1.],[6,9,2,3,2.]],threshold:-0.019374,right_val:0.49687,left_val:0.11205},{features:[[12,9,3,3,-1.],[12,10,3,1,3.]],threshold:0.010374,right_val:0.43952,left_val:0.51482},{features:[[5,9,3,3,-1.],[5,10,3,1,3.]],threshold:1.4973e-004,right_val:0.52699,left_val:0.4085},{features:[[9,5,6,8,-1.],[12,5,3,4,2.],[9,9,3,4,2.]],threshold:-0.042982,right_val:0.50185,left_val:0.63941},{features:[[5,5,6,8,-1.],[5,5,3,4,2.],[8,9,3,4,2.]],threshold:8.3066e-003,right_val:0.66984,left_val:0.47076},{features:[[16,1,4,6,-1.],[16,4,4,3,2.]],threshold:-4.1286e-003,right_val:0.53236,left_val:0.45414},{features:[[1,0,6,20,-1.],[3,0,2,20,3.]],threshold:1.7399e-003,right_val:0.54399,left_val:0.4334},{features:[[12,11,3,2,-1.],[13,11,1,2,3.]],threshold:1.174e-004,right_val:0.55434,left_val:0.45797},{features:[[5,11,3,2,-1.],[6,11,1,2,3.]],threshold:1.8586e-004,right_val:0.54268,left_val:0.43246},{features:[[9,4,6,1,-1.],[11,4,2,1,3.]],threshold:5.5588e-003,right_val:0.35506,left_val:0.52572},{features:[[0,0,8,3,-1.],[4,0,4,3,2.]],threshold:-7.9852e-003,right_val:0.46306,left_val:0.6043},{features:[[15,0,2,5,-1.],[15,0,1,5,2.]],threshold:6.0594e-004,right_val:0.55332,left_val:0.45983},{features:[[4,1,3,2,-1.],[5,1,1,2,3.]],threshold:-2.2983e-004,right_val:0.53225,left_val:0.41308},{features:[[7,0,6,15,-1.],[9,0,2,15,3.]],threshold:4.374e-004,right_val:0.54093,left_val:0.4043},{features:[[6,11,3,1,-1.],[7,11,1,1,3.]],threshold:2.9482e-004,right_val:0.56289,left_val:0.4495},{features:[[12,0,3,4,-1.],[13,0,1,4,3.]],threshold:0.010313,right_val:0.27043,left_val:0.51775},{features:[[5,4,6,1,-1.],[7,4,2,1,3.]],threshold:-7.7241e-003,right_val:0.49806,left_val:0.1988},{features:[[12,7,3,2,-1.],[12,8,3,1,2.]],threshold:-4.6797e-003,right_val:0.50183,left_val:0.66448},{features:[[0,1,4,6,-1.],[0,4,4,3,2.]],threshold:-5.0755e-003,right_val:0.51853,left_val:0.38983},{features:[[12,7,3,2,-1.],[12,8,3,1,2.]],threshold:2.248e-003,right_val:0.56603,left_val:0.48018},{features:[[2,16,3,3,-1.],[2,17,3,1,3.]],threshold:8.3327e-004,right_val:0.39572,left_val:0.52109},{features:[[13,8,6,10,-1.],[16,8,3,5,2.],[13,13,3,5,2.]],threshold:-0.041279,right_val:0.50071,left_val:0.61545},{features:[[0,9,5,2,-1.],[0,10,5,1,2.]],threshold:-5.093e-004,right_val:0.52284,left_val:0.39759},{features:[[12,11,2,2,-1.],[13,11,1,1,2.],[12,12,1,1,2.]],threshold:1.2569e-003,right_val:0.59392,left_val:0.49791},{features:[[3,15,3,3,-1.],[3,16,3,1,3.]],threshold:8.0048e-003,right_val:0.16334,left_val:0.49845},{features:[[12,7,3,2,-1.],[12,8,3,1,2.]],threshold:-1.1879e-003,right_val:0.49426,left_val:0.5905},{features:[[5,7,3,2,-1.],[5,8,3,1,2.]],threshold:6.1949e-004,right_val:0.53287,left_val:0.41996},{features:[[9,5,9,9,-1.],[9,8,9,3,3.]],threshold:6.683e-003,right_val:0.49059,left_val:0.54186},{features:[[5,0,3,7,-1.],[6,0,1,7,3.]],threshold:-3.7062e-003,right_val:0.5138,left_val:0.37259},{features:[[5,2,12,5,-1.],[9,2,4,5,3.]],threshold:-0.039739,right_val:0.50503,left_val:0.6479},{features:[[6,11,2,2,-1.],[6,11,1,1,2.],[7,12,1,1,2.]],threshold:1.4085e-003,right_val:0.63779,left_val:0.46823},{features:[[15,15,3,2,-1.],[15,16,3,1,2.]],threshold:3.9323e-004,right_val:0.41505,left_val:0.54585},{features:[[2,15,3,2,-1.],[2,16,3,1,2.]],threshold:-1.898e-003,right_val:0.51497,left_val:0.36902},{features:[[14,12,6,8,-1.],[17,12,3,4,2.],[14,16,3,4,2.]],threshold:-0.01397,right_val:0.48114,left_val:0.60506},{features:[[2,8,15,6,-1.],[7,8,5,6,3.]],threshold:-0.10101,right_val:0.49924,left_val:0.20171},{features:[[2,2,18,17,-1.],[8,2,6,17,3.]],threshold:-0.017347,right_val:0.48995,left_val:0.57131},{features:[[5,1,4,1,-1.],[7,1,2,1,2.]],threshold:1.562e-004,right_val:0.53926,left_val:0.42154},{features:[[5,2,12,5,-1.],[9,2,4,5,3.]],threshold:0.13439,right_val:0.37676,left_val:0.51362},{features:[[3,2,12,5,-1.],[7,2,4,5,3.]],threshold:-0.024582,right_val:0.47479,left_val:0.70274},{features:[[4,9,12,4,-1.],[10,9,6,2,2.],[4,11,6,2,2.]],threshold:-3.8554e-003,right_val:0.54277,left_val:0.43174},{features:[[5,15,6,2,-1.],[5,15,3,1,2.],[8,16,3,1,2.]],threshold:-2.3165e-003,right_val:0.46186,left_val:0.59427},{features:[[10,14,2,3,-1.],[10,15,2,1,3.]],threshold:-4.8518e-003,right_val:0.48849,left_val:0.61916},{features:[[0,13,20,2,-1.],[0,13,10,1,2.],[10,14,10,1,2.]],threshold:2.47e-003,right_val:0.40172,left_val:0.52567},{features:[[4,9,12,8,-1.],[10,9,6,4,2.],[4,13,6,4,2.]],threshold:0.045497,right_val:0.26858,left_val:0.52379},{features:[[8,13,3,6,-1.],[8,16,3,3,2.]],threshold:-0.02032,right_val:0.49797,left_val:0.21304},{features:[[10,12,2,2,-1.],[10,13,2,1,2.]],threshold:2.6995e-004,right_val:0.55431,left_val:0.4814},{features:[[9,12,2,2,-1.],[9,12,1,1,2.],[10,13,1,1,2.]],threshold:-1.8233e-003,right_val:0.471,left_val:0.64826},{features:[[4,11,14,4,-1.],[11,11,7,2,2.],[4,13,7,2,2.]],threshold:-6.3016e-003,right_val:0.53062,left_val:0.45819},{features:[[8,5,4,2,-1.],[8,6,4,1,2.]],threshold:-2.4139e-004,right_val:0.40518,left_val:0.52321},{features:[[10,10,6,3,-1.],[12,10,2,3,3.]],threshold:-1.033e-003,right_val:0.47892,left_val:0.55562},{features:[[2,14,1,2,-1.],[2,15,1,1,2.]],threshold:1.8041e-004,right_val:0.40118,left_val:0.52294},{features:[[13,8,6,12,-1.],[16,8,3,6,2.],[13,14,3,6,2.]],threshold:-0.061408,right_val:0.50107,left_val:0.62987},{features:[[1,8,6,12,-1.],[1,8,3,6,2.],[4,14,3,6,2.]],threshold:-0.069544,right_val:0.47732,left_val:0.72283},{features:[[10,0,6,10,-1.],[12,0,2,10,3.]],threshold:-0.070543,right_val:0.51825,left_val:0.22695},{features:[[5,11,8,4,-1.],[5,11,4,2,2.],[9,13,4,2,2.]],threshold:2.4424e-003,right_val:0.40982,left_val:0.52371},{features:[[10,16,8,4,-1.],[14,16,4,2,2.],[10,18,4,2,2.]],threshold:1.5494e-003,right_val:0.5468,left_val:0.47738},{features:[[7,7,6,6,-1.],[9,7,2,6,3.]],threshold:-0.023914,right_val:0.47838,left_val:0.7147},{features:[[10,2,4,10,-1.],[10,2,2,10,2.]],threshold:-0.012454,right_val:0.52411,left_val:0.26353},{features:[[6,1,4,9,-1.],[8,1,2,9,2.]],threshold:-2.076e-004,right_val:0.51136,left_val:0.36238},{features:[[12,19,2,1,-1.],[12,19,1,1,2.]],threshold:2.9781e-005,right_val:0.54328,left_val:0.47059}],threshold:90.253},{simpleClassifiers:[{features:[[1,2,4,9,-1.],[3,2,2,9,2.]],threshold:0.011773,right_val:0.64212,left_val:0.38605},{features:[[7,5,6,4,-1.],[9,5,2,4,3.]],threshold:0.027038,right_val:0.6754,left_val:0.43857},{features:[[9,4,2,4,-1.],[9,6,2,2,2.]],threshold:-3.642e-005,right_val:0.34233,left_val:0.54871},{features:[[14,5,2,8,-1.],[14,9,2,4,2.]],threshold:1.9995e-003,right_val:0.54003,left_val:0.32305},{features:[[7,6,5,12,-1.],[7,12,5,6,2.]],threshold:4.5278e-003,right_val:0.2935,left_val:0.50916},{features:[[14,6,2,6,-1.],[14,9,2,3,2.]],threshold:4.7891e-004,right_val:0.53441,left_val:0.41782},{features:[[4,6,2,6,-1.],[4,9,2,3,2.]],threshold:1.1721e-003,right_val:0.51321,left_val:0.28992},{features:[[8,15,10,4,-1.],[13,15,5,2,2.],[8,17,5,2,2.]],threshold:9.5306e-004,right_val:0.55608,left_val:0.42801},{features:[[6,18,2,2,-1.],[7,18,1,2,2.]],threshold:1.5099e-005,right_val:0.54048,left_val:0.40449},{features:[[11,3,6,2,-1.],[11,4,6,1,2.]],threshold:-6.0818e-004,right_val:0.55035,left_val:0.42718},{features:[[2,0,16,6,-1.],[2,2,16,2,3.]],threshold:3.3225e-003,right_val:0.53697,left_val:0.39627},{features:[[11,3,6,2,-1.],[11,4,6,1,2.]],threshold:-1.1037e-003,right_val:0.52377,left_val:0.47272},{features:[[4,11,10,3,-1.],[4,12,10,1,3.]],threshold:-1.435e-003,right_val:0.42235,left_val:0.5603},{features:[[11,3,6,2,-1.],[11,4,6,1,2.]],threshold:2.0767e-003,right_val:0.47327,left_val:0.52259},{features:[[3,3,6,2,-1.],[3,4,6,1,2.]],threshold:-1.6413e-004,right_val:0.54327,left_val:0.39991},{features:[[16,0,4,7,-1.],[16,0,2,7,2.]],threshold:8.8302e-003,right_val:0.60273,left_val:0.46784},{features:[[0,14,9,6,-1.],[0,16,9,2,3.]],threshold:-0.010552,right_val:0.5214,left_val:0.3494},{features:[[9,16,3,3,-1.],[9,17,3,1,3.]],threshold:-2.2732e-003,right_val:0.47491,left_val:0.61858},{features:[[4,6,6,2,-1.],[6,6,2,2,3.]],threshold:-8.4786e-004,right_val:0.38435,left_val:0.52853},{features:[[15,11,1,3,-1.],[15,12,1,1,3.]],threshold:1.2081e-003,right_val:0.34473,left_val:0.53606},{features:[[5,5,2,3,-1.],[5,6,2,1,3.]],threshold:2.6513e-003,right_val:0.6194,left_val:0.45583},{features:[[10,9,2,2,-1.],[10,10,2,1,2.]],threshold:-1.1012e-003,right_val:0.53276,left_val:0.36802},{features:[[3,1,4,3,-1.],[5,1,2,3,2.]],threshold:4.9562e-004,right_val:0.52749,left_val:0.39606},{features:[[16,0,4,7,-1.],[16,0,2,7,2.]],threshold:-0.043902,right_val:0.49928,left_val:0.70204},{features:[[0,0,20,1,-1.],[10,0,10,1,2.]],threshold:0.03469,right_val:0.27666,left_val:0.50492},{features:[[15,11,1,3,-1.],[15,12,1,1,3.]],threshold:-2.7442e-003,right_val:0.5275,left_val:0.26726},{features:[[0,4,3,4,-1.],[1,4,1,4,3.]],threshold:3.3317e-003,right_val:0.60011,left_val:0.45795},{features:[[16,3,3,6,-1.],[16,5,3,2,3.]],threshold:-0.020045,right_val:0.52357,left_val:0.31716},{features:[[1,3,3,6,-1.],[1,5,3,2,3.]],threshold:1.3492e-003,right_val:0.40343,left_val:0.52654},{features:[[6,2,12,6,-1.],[12,2,6,3,2.],[6,5,6,3,2.]],threshold:2.9702e-003,right_val:0.4572,left_val:0.53325},{features:[[8,10,4,3,-1.],[8,11,4,1,3.]],threshold:6.304e-003,right_val:0.60346,left_val:0.45933},{features:[[4,2,14,6,-1.],[11,2,7,3,2.],[4,5,7,3,2.]],threshold:-0.012937,right_val:0.5373,left_val:0.4438},{features:[[9,11,2,3,-1.],[9,12,2,1,3.]],threshold:4.0149e-003,right_val:0.64378,left_val:0.46803},{features:[[15,13,2,3,-1.],[15,14,2,1,3.]],threshold:-2.6402e-003,right_val:0.53143,left_val:0.37096},{features:[[8,12,4,3,-1.],[8,13,4,1,3.]],threshold:0.013918,right_val:0.71308,left_val:0.47236},{features:[[15,11,1,3,-1.],[15,12,1,1,3.]],threshold:-4.5088e-004,right_val:0.53704,left_val:0.44924},{features:[[7,13,5,2,-1.],[7,14,5,1,2.]],threshold:2.5384e-004,right_val:0.55144,left_val:0.44069},{features:[[7,12,6,3,-1.],[7,13,6,1,3.]],threshold:2.271e-003,right_val:0.5968,left_val:0.46824},{features:[[5,11,4,4,-1.],[5,13,4,2,2.]],threshold:2.4121e-003,right_val:0.30186,left_val:0.50794},{features:[[11,4,3,3,-1.],[12,4,1,3,3.]],threshold:-3.6026e-005,right_val:0.44711,left_val:0.5601},{features:[[6,4,3,3,-1.],[7,4,1,3,3.]],threshold:-7.4906e-003,right_val:0.49899,left_val:0.22075},{features:[[16,5,3,6,-1.],[17,5,1,6,3.]],threshold:-0.017513,right_val:0.50176,left_val:0.65312},{features:[[3,6,12,7,-1.],[7,6,4,7,3.]],threshold:0.14282,right_val:0.14821,left_val:0.4968},{features:[[16,5,3,6,-1.],[17,5,1,6,3.]],threshold:5.5345e-003,right_val:0.59542,left_val:0.48989},{features:[[3,13,2,3,-1.],[3,14,2,1,3.]],threshold:-9.6324e-004,right_val:0.51961,left_val:0.39271},{features:[[16,5,3,6,-1.],[17,5,1,6,3.]],threshold:-2.037e-003,right_val:0.48849,left_val:0.56133},{features:[[1,5,3,6,-1.],[2,5,1,6,3.]],threshold:1.6615e-003,right_val:0.55789,left_val:0.44729},{features:[[1,9,18,1,-1.],[7,9,6,1,3.]],threshold:-3.1188e-003,right_val:0.53975,left_val:0.38405},{features:[[0,9,8,7,-1.],[4,9,4,7,2.]],threshold:-6.4001e-003,right_val:0.45332,left_val:0.5844},{features:[[12,11,8,2,-1.],[12,12,8,1,2.]],threshold:3.132e-004,right_val:0.42347,left_val:0.54392},{features:[[0,11,8,2,-1.],[0,12,8,1,2.]],threshold:-0.018222,right_val:0.49584,left_val:0.12885},{features:[[9,13,2,3,-1.],[9,14,2,1,3.]],threshold:8.7969e-003,right_val:0.71535,left_val:0.49513},{features:[[4,10,12,4,-1.],[4,10,6,2,2.],[10,12,6,2,2.]],threshold:-4.2395e-003,right_val:0.51949,left_val:0.39466},{features:[[9,3,3,7,-1.],[10,3,1,7,3.]],threshold:9.7086e-003,right_val:0.60649,left_val:0.48975},{features:[[7,2,3,5,-1.],[8,2,1,5,3.]],threshold:-3.9934e-003,right_val:0.50608,left_val:0.32454},{features:[[9,12,4,6,-1.],[11,12,2,3,2.],[9,15,2,3,2.]],threshold:-0.016785,right_val:0.52038,left_val:0.1582},{features:[[8,7,3,6,-1.],[9,7,1,6,3.]],threshold:0.018272,right_val:0.6627,left_val:0.46809},{features:[[15,4,4,2,-1.],[15,5,4,1,2.]],threshold:5.6873e-003,right_val:0.35122,left_val:0.52117},{features:[[8,7,3,3,-1.],[9,7,1,3,3.]],threshold:-1.0739e-003,right_val:0.45298,left_val:0.57684},{features:[[14,2,6,4,-1.],[14,4,6,2,2.]],threshold:-3.7094e-003,right_val:0.53136,left_val:0.45078},{features:[[7,16,6,1,-1.],[9,16,2,1,3.]],threshold:-2.1111e-004,right_val:0.43334,left_val:0.54608},{features:[[15,13,2,3,-1.],[15,14,2,1,3.]],threshold:1.067e-003,right_val:0.40784,left_val:0.53719},{features:[[8,7,3,10,-1.],[9,7,1,10,3.]],threshold:3.5943e-003,right_val:0.56438,left_val:0.44713},{features:[[11,10,2,6,-1.],[11,12,2,2,3.]],threshold:-5.1776e-003,right_val:0.52803,left_val:0.44994},{features:[[6,10,4,1,-1.],[8,10,2,1,2.]],threshold:-2.5414e-004,right_val:0.44077,left_val:0.55162},{features:[[10,9,2,2,-1.],[10,10,2,1,2.]],threshold:6.3523e-003,right_val:0.24652,left_val:0.51942},{features:[[8,9,2,2,-1.],[8,10,2,1,2.]],threshold:-4.4205e-004,right_val:0.51397,left_val:0.38307},{features:[[12,7,2,2,-1.],[13,7,1,1,2.],[12,8,1,1,2.]],threshold:7.4489e-004,right_val:0.59748,left_val:0.48911},{features:[[5,7,2,2,-1.],[5,7,1,1,2.],[6,8,1,1,2.]],threshold:-3.5116e-003,right_val:0.47688,left_val:0.74137},{features:[[13,0,3,14,-1.],[14,0,1,14,3.]],threshold:-0.012541,right_val:0.52528,left_val:0.36488},{features:[[4,0,3,14,-1.],[5,0,1,14,3.]],threshold:9.4932e-003,right_val:0.36296,left_val:0.51005},{features:[[13,4,3,14,-1.],[14,4,1,14,3.]],threshold:0.012961,right_val:0.43336,left_val:0.52324},{features:[[9,14,2,3,-1.],[9,15,2,1,3.]],threshold:4.7209e-003,right_val:0.63311,left_val:0.46481},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:-2.3119e-003,right_val:0.45311,left_val:0.59303},{features:[[4,2,3,16,-1.],[5,2,1,16,3.]],threshold:-2.8262e-003,right_val:0.52571,left_val:0.38705},{features:[[7,2,8,10,-1.],[7,7,8,5,2.]],threshold:-1.4311e-003,right_val:0.45619,left_val:0.55225},{features:[[6,14,7,3,-1.],[6,15,7,1,3.]],threshold:1.9378e-003,right_val:0.5737,left_val:0.45462},{features:[[9,2,10,12,-1.],[14,2,5,6,2.],[9,8,5,6,2.]],threshold:2.6344e-004,right_val:0.45719,left_val:0.53457},{features:[[6,7,8,2,-1.],[6,8,8,1,2.]],threshold:7.8258e-004,right_val:0.52202,left_val:0.39678},{features:[[8,13,4,6,-1.],[8,16,4,3,2.]],threshold:-0.01955,right_val:0.52435,left_val:0.28296},{features:[[6,6,1,3,-1.],[6,7,1,1,3.]],threshold:4.3915e-004,right_val:0.58991,left_val:0.45901},{features:[[16,2,4,6,-1.],[16,4,4,2,3.]],threshold:0.021452,right_val:0.28554,left_val:0.52314},{features:[[6,6,4,2,-1.],[6,6,2,1,2.],[8,7,2,1,2.]],threshold:5.8974e-004,right_val:0.55064,left_val:0.43973},{features:[[16,2,4,6,-1.],[16,4,4,2,3.]],threshold:-0.026158,right_val:0.51892,left_val:0.31351},{features:[[0,2,4,6,-1.],[0,4,4,2,3.]],threshold:-0.01396,right_val:0.50407,left_val:0.32133},{features:[[9,6,2,6,-1.],[9,6,1,6,2.]],threshold:-6.3699e-003,right_val:0.48495,left_val:0.63875},{features:[[3,4,6,10,-1.],[3,9,6,5,2.]],threshold:-8.5614e-003,right_val:0.5032,left_val:0.27591},{features:[[9,5,2,6,-1.],[9,5,1,6,2.]],threshold:9.6623e-004,right_val:0.58349,left_val:0.46856},{features:[[3,13,2,3,-1.],[3,14,2,1,3.]],threshold:7.655e-004,right_val:0.38964,left_val:0.51752},{features:[[13,13,3,2,-1.],[13,14,3,1,2.]],threshold:-8.1833e-003,right_val:0.52081,left_val:0.20691},{features:[[2,16,10,4,-1.],[2,16,5,2,2.],[7,18,5,2,2.]],threshold:-9.3977e-003,right_val:0.46412,left_val:0.61341},{features:[[5,6,10,6,-1.],[10,6,5,3,2.],[5,9,5,3,2.]],threshold:4.8029e-003,right_val:0.43952,left_val:0.54541},{features:[[7,14,1,3,-1.],[7,15,1,1,3.]],threshold:-3.5681e-003,right_val:0.46811,left_val:0.63445},{features:[[14,16,6,3,-1.],[14,17,6,1,3.]],threshold:4.0733e-003,right_val:0.40156,left_val:0.52927},{features:[[5,4,3,3,-1.],[5,5,3,1,3.]],threshold:1.2568e-003,right_val:0.54528,left_val:0.4393},{features:[[7,4,10,3,-1.],[7,5,10,1,3.]],threshold:-2.9065e-003,right_val:0.48634,left_val:0.58988},{features:[[0,4,5,4,-1.],[0,6,5,2,2.]],threshold:-2.4409e-003,right_val:0.52474,left_val:0.40694},{features:[[13,11,3,9,-1.],[13,14,3,3,3.]],threshold:0.024831,right_val:0.36825,left_val:0.51827},{features:[[4,11,3,9,-1.],[4,14,3,3,3.]],threshold:-0.048854,right_val:0.49613,left_val:0.13076},{features:[[9,7,2,1,-1.],[9,7,1,1,2.]],threshold:-1.611e-003,right_val:0.48727,left_val:0.6421},{features:[[5,0,6,17,-1.],[7,0,2,17,3.]],threshold:-0.097009,right_val:0.4951,left_val:0.047769},{features:[[10,3,6,3,-1.],[10,3,3,3,2.]],threshold:1.1209e-003,right_val:0.53547,left_val:0.46163},{features:[[2,2,15,4,-1.],[7,2,5,4,3.]],threshold:-1.3064e-003,right_val:0.46388,left_val:0.62619},{features:[[8,2,8,2,-1.],[12,2,4,1,2.],[8,3,4,1,2.]],threshold:4.5772e-004,right_val:0.46466,left_val:0.53844},{features:[[8,1,3,6,-1.],[8,3,3,2,3.]],threshold:-6.315e-004,right_val:0.51303,left_val:0.3804},{features:[[9,17,2,2,-1.],[9,18,2,1,2.]],threshold:1.4506e-004,right_val:0.56645,left_val:0.45543},{features:[[0,0,2,14,-1.],[1,0,1,14,2.]],threshold:-0.016475,right_val:0.47159,left_val:0.6597},{features:[[12,0,7,3,-1.],[12,1,7,1,3.]],threshold:0.01337,right_val:0.3036,left_val:0.51955},{features:[[1,14,1,2,-1.],[1,15,1,1,2.]],threshold:1.0272e-004,right_val:0.41071,left_val:0.52292},{features:[[14,12,2,8,-1.],[15,12,1,4,2.],[14,16,1,4,2.]],threshold:-5.5312e-003,right_val:0.49609,left_val:0.63529},{features:[[1,0,7,3,-1.],[1,1,7,1,3.]],threshold:-2.6187e-003,right_val:0.5141,left_val:0.38245},{features:[[14,12,2,8,-1.],[15,12,1,4,2.],[14,16,1,4,2.]],threshold:5.0834e-003,right_val:0.62208,left_val:0.49504},{features:[[6,0,8,12,-1.],[6,0,4,6,2.],[10,6,4,6,2.]],threshold:0.079818,right_val:0.13225,left_val:0.49523},{features:[[6,1,8,9,-1.],[6,4,8,3,3.]],threshold:-0.099227,right_val:0.50084,left_val:0.75427},{features:[[5,2,2,2,-1.],[5,3,2,1,2.]],threshold:-6.5174e-004,right_val:0.51301,left_val:0.36993},{features:[[13,14,6,6,-1.],[16,14,3,3,2.],[13,17,3,3,2.]],threshold:-0.018997,right_val:0.49212,left_val:0.66892},{features:[[0,17,20,2,-1.],[0,17,10,1,2.],[10,18,10,1,2.]],threshold:0.017347,right_val:0.18592,left_val:0.49833},{features:[[10,3,2,6,-1.],[11,3,1,3,2.],[10,6,1,3,2.]],threshold:5.5082e-004,right_val:0.55221,left_val:0.45744},{features:[[5,12,6,2,-1.],[8,12,3,2,2.]],threshold:2.0056e-003,right_val:0.38565,left_val:0.51317},{features:[[10,7,6,13,-1.],[10,7,3,13,2.]],threshold:-7.7688e-003,right_val:0.54343,left_val:0.43617},{features:[[5,15,10,5,-1.],[10,15,5,5,2.]],threshold:0.050878,right_val:0.68406,left_val:0.46827},{features:[[10,4,4,10,-1.],[10,4,2,10,2.]],threshold:-2.2902e-003,right_val:0.53061,left_val:0.43292},{features:[[5,7,2,1,-1.],[6,7,1,1,2.]],threshold:-1.5715e-004,right_val:0.43782,left_val:0.53701},{features:[[10,3,6,7,-1.],[10,3,3,7,2.]],threshold:0.10519,right_val:0.067361,left_val:0.51373},{features:[[4,3,6,7,-1.],[7,3,3,7,2.]],threshold:2.7199e-003,right_val:0.52557,left_val:0.41121},{features:[[1,7,18,5,-1.],[7,7,6,5,3.]],threshold:0.048338,right_val:0.4439,left_val:0.54046},{features:[[3,17,4,3,-1.],[5,17,2,3,2.]],threshold:9.5704e-004,right_val:0.53995,left_val:0.4356},{features:[[8,14,12,6,-1.],[14,14,6,3,2.],[8,17,6,3,2.]],threshold:-0.025371,right_val:0.5031,left_val:0.59952},{features:[[0,13,20,4,-1.],[0,13,10,2,2.],[10,15,10,2,2.]],threshold:0.052458,right_val:0.13984,left_val:0.49503},{features:[[4,5,14,2,-1.],[11,5,7,1,2.],[4,6,7,1,2.]],threshold:-0.012366,right_val:0.49641,left_val:0.63973},{features:[[1,2,10,12,-1.],[1,2,5,6,2.],[6,8,5,6,2.]],threshold:-0.1459,right_val:0.49463,left_val:0.10017},{features:[[6,1,14,3,-1.],[6,2,14,1,3.]],threshold:-0.015909,right_val:0.52083,left_val:0.33123},{features:[[8,16,2,3,-1.],[8,17,2,1,3.]],threshold:3.9486e-004,right_val:0.54261,left_val:0.44064},{features:[[9,17,3,2,-1.],[10,17,1,2,3.]],threshold:-5.2454e-003,right_val:0.519,left_val:0.27996},{features:[[5,15,4,2,-1.],[5,15,2,1,2.],[7,16,2,1,2.]],threshold:-5.0422e-003,right_val:0.47521,left_val:0.69876},{features:[[10,15,1,3,-1.],[10,16,1,1,3.]],threshold:2.9812e-003,right_val:0.63075,left_val:0.49833},{features:[[8,16,4,4,-1.],[8,16,2,2,2.],[10,18,2,2,2.]],threshold:-7.2884e-003,right_val:0.50269,left_val:0.29823},{features:[[6,11,8,6,-1.],[6,14,8,3,2.]],threshold:1.5094e-003,right_val:0.3833,left_val:0.53084},{features:[[2,13,5,2,-1.],[2,14,5,1,2.]],threshold:-9.3341e-003,right_val:0.49698,left_val:0.2038},{features:[[13,14,6,6,-1.],[16,14,3,3,2.],[13,17,3,3,2.]],threshold:0.028667,right_val:0.6928,left_val:0.50257},{features:[[1,9,18,4,-1.],[7,9,6,4,3.]],threshold:0.1702,right_val:0.14764,left_val:0.49601},{features:[[13,14,6,6,-1.],[16,14,3,3,2.],[13,17,3,3,2.]],threshold:-3.2614e-003,right_val:0.48261,left_val:0.56031},{features:[[0,2,1,6,-1.],[0,4,1,2,3.]],threshold:5.5769e-004,right_val:0.41296,left_val:0.52056},{features:[[5,0,15,20,-1.],[5,10,15,10,2.]],threshold:0.36258,right_val:0.37686,left_val:0.52217},{features:[[1,14,6,6,-1.],[1,14,3,3,2.],[4,17,3,3,2.]],threshold:-0.011615,right_val:0.46375,left_val:0.60227},{features:[[8,14,4,6,-1.],[10,14,2,3,2.],[8,17,2,3,2.]],threshold:-4.0795e-003,right_val:0.53375,left_val:0.40704},{features:[[7,11,2,1,-1.],[8,11,1,1,2.]],threshold:5.7204e-004,right_val:0.59004,left_val:0.46018},{features:[[9,17,3,2,-1.],[10,17,1,2,3.]],threshold:6.7543e-004,right_val:0.43454,left_val:0.53983},{features:[[8,17,3,2,-1.],[9,17,1,2,3.]],threshold:6.3296e-004,right_val:0.40514,left_val:0.52016},{features:[[12,14,4,6,-1.],[14,14,2,3,2.],[12,17,2,3,2.]],threshold:1.2435e-003,right_val:0.55474,left_val:0.46424},{features:[[4,14,4,6,-1.],[4,14,2,3,2.],[6,17,2,3,2.]],threshold:-4.7364e-003,right_val:0.46726,left_val:0.61986},{features:[[13,14,2,6,-1.],[14,14,1,3,2.],[13,17,1,3,2.]],threshold:-6.4658e-003,right_val:0.5019,left_val:0.68373},{features:[[5,14,2,6,-1.],[5,14,1,3,2.],[6,17,1,3,2.]],threshold:3.5017e-004,right_val:0.53636,left_val:0.43448},{features:[[7,0,6,12,-1.],[7,4,6,4,3.]],threshold:1.5755e-004,right_val:0.5732,left_val:0.47601},{features:[[0,7,12,2,-1.],[4,7,4,2,3.]],threshold:9.9774e-003,right_val:0.3635,left_val:0.5091},{features:[[10,3,3,13,-1.],[11,3,1,13,3.]],threshold:-4.1465e-004,right_val:0.45938,left_val:0.55701},{features:[[7,3,3,13,-1.],[8,3,1,13,3.]],threshold:-3.5889e-004,right_val:0.43391,left_val:0.53568},{features:[[10,8,6,3,-1.],[10,9,6,1,3.]],threshold:4.0463e-004,right_val:0.54368,left_val:0.44398},{features:[[3,11,3,2,-1.],[4,11,1,2,3.]],threshold:-8.2185e-004,right_val:0.51763,left_val:0.40423},{features:[[13,12,6,8,-1.],[16,12,3,4,2.],[13,16,3,4,2.]],threshold:5.9467e-003,right_val:0.56338,left_val:0.49277},{features:[[7,6,6,5,-1.],[9,6,2,5,3.]],threshold:-0.021753,right_val:0.48008,left_val:0.80063},{features:[[17,11,2,7,-1.],[17,11,1,7,2.]],threshold:-0.01454,right_val:0.51822,left_val:0.39461},{features:[[3,13,8,2,-1.],[7,13,4,2,2.]],threshold:-0.040511,right_val:0.49358,left_val:0.021325},{features:[[6,9,8,3,-1.],[6,10,8,1,3.]],threshold:-5.8458e-004,right_val:0.5314,left_val:0.40128},{features:[[4,3,4,3,-1.],[4,4,4,1,3.]],threshold:5.5152e-003,right_val:0.58963,left_val:0.46424},{features:[[11,3,4,3,-1.],[11,4,4,1,3.]],threshold:-6.0626e-003,right_val:0.50165,left_val:0.65022},{features:[[1,4,17,12,-1.],[1,8,17,4,3.]],threshold:0.094536,right_val:0.41268,left_val:0.52647},{features:[[11,3,4,3,-1.],[11,4,4,1,3.]],threshold:4.7315e-003,right_val:0.58924,left_val:0.48792},{features:[[4,8,6,3,-1.],[4,9,6,1,3.]],threshold:-5.2571e-004,right_val:0.51894,left_val:0.39173},{features:[[12,3,5,3,-1.],[12,4,5,1,3.]],threshold:-2.5464e-003,right_val:0.49857,left_val:0.58376},{features:[[1,11,2,7,-1.],[2,11,1,7,2.]],threshold:-0.026076,right_val:0.49558,left_val:0.1262},{features:[[15,12,2,8,-1.],[16,12,1,4,2.],[15,16,1,4,2.]],threshold:-5.478e-003,right_val:0.50103,left_val:0.57225},{features:[[4,8,11,3,-1.],[4,9,11,1,3.]],threshold:5.1338e-003,right_val:0.42264,left_val:0.52733},{features:[[9,13,6,2,-1.],[12,13,3,1,2.],[9,14,3,1,2.]],threshold:4.7945e-004,right_val:0.58196,left_val:0.44501},{features:[[6,13,4,3,-1.],[6,14,4,1,3.]],threshold:-2.1114e-003,right_val:0.45117,left_val:0.57577},{features:[[9,12,3,3,-1.],[10,12,1,3,3.]],threshold:-0.01318,right_val:0.51607,left_val:0.18844},{features:[[5,3,3,3,-1.],[5,4,3,1,3.]],threshold:-4.7968e-003,right_val:0.47361,left_val:0.65898},{features:[[9,4,2,3,-1.],[9,5,2,1,3.]],threshold:6.7483e-003,right_val:0.33564,left_val:0.52594},{features:[[0,2,16,3,-1.],[0,3,16,1,3.]],threshold:1.4623e-003,right_val:0.42641,left_val:0.53553},{features:[[15,12,2,8,-1.],[16,12,1,4,2.],[15,16,1,4,2.]],threshold:4.7645e-003,right_val:0.57868,left_val:0.50344},{features:[[3,12,2,8,-1.],[3,12,1,4,2.],[4,16,1,4,2.]],threshold:6.8067e-003,right_val:0.66778,left_val:0.47566},{features:[[14,13,3,6,-1.],[14,15,3,2,3.]],threshold:3.6609e-003,right_val:0.43115,left_val:0.53696},{features:[[3,13,3,6,-1.],[3,15,3,2,3.]],threshold:0.02145,right_val:0.18888,left_val:0.49686},{features:[[6,5,10,2,-1.],[11,5,5,1,2.],[6,6,5,1,2.]],threshold:4.1679e-003,right_val:0.58154,left_val:0.49307},{features:[[2,14,14,6,-1.],[2,17,14,3,2.]],threshold:8.6468e-003,right_val:0.41326,left_val:0.52052},{features:[[10,14,1,3,-1.],[10,15,1,1,3.]],threshold:-3.6114e-004,right_val:0.48009,left_val:0.54836},{features:[[4,16,2,2,-1.],[4,16,1,1,2.],[5,17,1,1,2.]],threshold:1.0809e-003,right_val:0.60414,left_val:0.46899},{features:[[10,6,2,3,-1.],[10,7,2,1,3.]],threshold:5.772e-003,right_val:0.30533,left_val:0.51711},{features:[[0,17,20,2,-1.],[0,17,10,1,2.],[10,18,10,1,2.]],threshold:1.5721e-003,right_val:0.41788,left_val:0.522},{features:[[13,6,1,3,-1.],[13,7,1,1,3.]],threshold:-1.9308e-003,right_val:0.48129,left_val:0.58604},{features:[[8,13,3,2,-1.],[9,13,1,2,3.]],threshold:-7.8926e-003,right_val:0.49717,left_val:0.17493},{features:[[12,2,3,3,-1.],[13,2,1,3,3.]],threshold:-2.2225e-003,right_val:0.52128,left_val:0.43426},{features:[[3,18,2,2,-1.],[3,18,1,1,2.],[4,19,1,1,2.]],threshold:1.9012e-003,right_val:0.68921,left_val:0.47652},{features:[[9,16,3,4,-1.],[10,16,1,4,3.]],threshold:2.7576e-003,right_val:0.43375,left_val:0.52622},{features:[[6,6,1,3,-1.],[6,7,1,1,3.]],threshold:5.1787e-003,right_val:0.78437,left_val:0.48041},{features:[[13,1,5,2,-1.],[13,2,5,1,2.]],threshold:-9.0273e-004,right_val:0.53534,left_val:0.41208},{features:[[7,14,6,2,-1.],[7,14,3,1,2.],[10,15,3,1,2.]],threshold:5.1798e-003,right_val:0.6426,left_val:0.47404},{features:[[11,3,3,4,-1.],[12,3,1,4,3.]],threshold:-0.010114,right_val:0.5175,left_val:0.24688},{features:[[1,13,12,6,-1.],[5,13,4,6,3.]],threshold:-0.018617,right_val:0.4629,left_val:0.57563},{features:[[14,11,5,2,-1.],[14,12,5,1,2.]],threshold:5.9226e-003,right_val:0.32143,left_val:0.51696},{features:[[2,15,14,4,-1.],[2,15,7,2,2.],[9,17,7,2,2.]],threshold:-6.2945e-003,right_val:0.51416,left_val:0.3872},{features:[[3,7,14,2,-1.],[10,7,7,1,2.],[3,8,7,1,2.]],threshold:6.5353e-003,right_val:0.63105,left_val:0.4853},{features:[[1,11,4,2,-1.],[1,12,4,1,2.]],threshold:1.0878e-003,right_val:0.37233,left_val:0.51173},{features:[[14,0,6,14,-1.],[16,0,2,14,3.]],threshold:-0.022542,right_val:0.48871,left_val:0.56927},{features:[[4,11,1,3,-1.],[4,12,1,1,3.]],threshold:-3.0066e-003,right_val:0.5004,left_val:0.2556},{features:[[14,0,6,14,-1.],[16,0,2,14,3.]],threshold:7.4741e-003,right_val:0.56759,left_val:0.48109},{features:[[1,10,3,7,-1.],[2,10,1,7,3.]],threshold:0.026162,right_val:0.17772,left_val:0.49712},{features:[[8,12,9,2,-1.],[8,13,9,1,2.]],threshold:9.4353e-004,right_val:0.54913,left_val:0.494},{features:[[0,6,20,1,-1.],[10,6,10,1,2.]],threshold:0.033363,right_val:0.27907,left_val:0.50076},{features:[[8,4,4,4,-1.],[8,4,2,4,2.]],threshold:-0.015119,right_val:0.4973,left_val:0.70596},{features:[[0,0,2,2,-1.],[0,1,2,1,2.]],threshold:9.8649e-004,right_val:0.37768,left_val:0.51286}],threshold:104.75},{simpleClassifiers:[{features:[[5,3,10,9,-1.],[5,6,10,3,3.]],threshold:-0.095151,right_val:0.40173,left_val:0.64708},{features:[[15,2,4,10,-1.],[15,2,2,10,2.]],threshold:6.2702e-003,right_val:0.57464,left_val:0.39998},{features:[[8,2,2,7,-1.],[9,2,1,7,2.]],threshold:3.0018e-004,right_val:0.55388,left_val:0.35588},{features:[[7,4,12,1,-1.],[11,4,4,1,3.]],threshold:1.1757e-003,right_val:0.53826,left_val:0.42565},{features:[[3,4,9,1,-1.],[6,4,3,1,3.]],threshold:4.4235e-005,right_val:0.55899,left_val:0.36829},{features:[[15,10,1,4,-1.],[15,12,1,2,2.]],threshold:-2.9937e-005,right_val:0.40204,left_val:0.54525},{features:[[4,10,6,4,-1.],[7,10,3,4,2.]],threshold:3.0073e-003,right_val:0.33178,left_val:0.52391},{features:[[15,9,1,6,-1.],[15,12,1,3,2.]],threshold:-0.010514,right_val:0.5308,left_val:0.43207},{features:[[7,17,6,3,-1.],[7,18,6,1,3.]],threshold:8.3477e-003,right_val:0.64533,left_val:0.45046},{features:[[14,3,2,16,-1.],[15,3,1,8,2.],[14,11,1,8,2.]],threshold:-3.1492e-003,right_val:0.53705,left_val:0.43134},{features:[[4,9,1,6,-1.],[4,12,1,3,2.]],threshold:-1.4436e-005,right_val:0.3818,left_val:0.53266},{features:[[12,1,5,2,-1.],[12,2,5,1,2.]],threshold:-4.2855e-004,right_val:0.5382,left_val:0.43052},{features:[[6,18,4,2,-1.],[6,18,2,1,2.],[8,19,2,1,2.]],threshold:1.5062e-004,right_val:0.5545,left_val:0.4236},{features:[[2,4,16,10,-1.],[10,4,8,5,2.],[2,9,8,5,2.]],threshold:0.07156,right_val:0.26788,left_val:0.53031},{features:[[6,5,1,10,-1.],[6,10,1,5,2.]],threshold:8.4095e-004,right_val:0.52054,left_val:0.35571},{features:[[4,8,15,2,-1.],[9,8,5,2,3.]],threshold:0.062987,right_val:0.28614,left_val:0.52254},{features:[[1,8,15,2,-1.],[6,8,5,2,3.]],threshold:-3.3799e-003,right_val:0.52017,left_val:0.36242},{features:[[9,5,3,6,-1.],[9,7,3,2,3.]],threshold:-1.1811e-004,right_val:0.39599,left_val:0.54745},{features:[[5,7,8,2,-1.],[9,7,4,2,2.]],threshold:-5.4506e-004,right_val:0.52157,left_val:0.37404},{features:[[9,11,2,3,-1.],[9,12,2,1,3.]],threshold:-1.8455e-003,right_val:0.45844,left_val:0.58931},{features:[[1,0,16,3,-1.],[1,1,16,1,3.]],threshold:-4.3832e-004,right_val:0.53854,left_val:0.40846},{features:[[11,2,7,2,-1.],[11,3,7,1,2.]],threshold:-2.4001e-003,right_val:0.52936,left_val:0.37775},{features:[[5,1,10,18,-1.],[5,7,10,6,3.]],threshold:-0.098796,right_val:0.50701,left_val:0.29636},{features:[[17,4,3,2,-1.],[18,4,1,2,3.]],threshold:3.1798e-003,right_val:0.67264,left_val:0.48776},{features:[[8,13,1,3,-1.],[8,14,1,1,3.]],threshold:3.2406e-004,right_val:0.55611,left_val:0.43669},{features:[[3,14,14,6,-1.],[3,16,14,2,3.]],threshold:-0.032547,right_val:0.53086,left_val:0.31282},{features:[[0,2,3,4,-1.],[1,2,1,4,3.]],threshold:-7.7561e-003,right_val:0.46399,left_val:0.65602},{features:[[12,1,5,2,-1.],[12,2,5,1,2.]],threshold:0.016027,right_val:0.31419,left_val:0.51727},{features:[[3,1,5,2,-1.],[3,2,5,1,2.]],threshold:7.1002e-006,right_val:0.53363,left_val:0.40844},{features:[[10,13,2,3,-1.],[10,14,2,1,3.]],threshold:7.3423e-003,right_val:0.66035,left_val:0.49669},{features:[[8,13,2,3,-1.],[8,14,2,1,3.]],threshold:-1.697e-003,right_val:0.45002,left_val:0.59082},{features:[[14,12,2,3,-1.],[14,13,2,1,3.]],threshold:2.4118e-003,right_val:0.35997,left_val:0.53152},{features:[[7,2,2,3,-1.],[7,3,2,1,3.]],threshold:-5.5301e-003,right_val:0.49968,left_val:0.2334},{features:[[5,6,10,4,-1.],[10,6,5,2,2.],[5,8,5,2,2.]],threshold:-2.6479e-003,right_val:0.46847,left_val:0.58809},{features:[[9,13,1,6,-1.],[9,16,1,3,2.]],threshold:0.011296,right_val:0.18846,left_val:0.49838},{features:[[10,12,2,2,-1.],[11,12,1,1,2.],[10,13,1,1,2.]],threshold:-6.6953e-004,right_val:0.4799,left_val:0.58721},{features:[[4,12,2,3,-1.],[4,13,2,1,3.]],threshold:1.4411e-003,right_val:0.3501,left_val:0.51312},{features:[[14,4,6,6,-1.],[14,6,6,2,3.]],threshold:2.4638e-003,right_val:0.41176,left_val:0.53394},{features:[[8,17,2,3,-1.],[8,18,2,1,3.]],threshold:3.3115e-004,right_val:0.53982,left_val:0.43134},{features:[[16,4,4,6,-1.],[16,6,4,2,3.]],threshold:-0.033557,right_val:0.51792,left_val:0.26753},{features:[[0,4,4,6,-1.],[0,6,4,2,3.]],threshold:0.018539,right_val:0.23172,left_val:0.49739},{features:[[14,6,2,3,-1.],[14,6,1,3,2.]],threshold:-2.9698e-004,right_val:0.46437,left_val:0.55297},{features:[[4,9,8,1,-1.],[8,9,4,1,2.]],threshold:-4.5577e-004,right_val:0.44692,left_val:0.56296},{features:[[8,12,4,3,-1.],[8,13,4,1,3.]],threshold:-0.010159,right_val:0.49259,left_val:0.67062},{features:[[5,12,10,6,-1.],[5,14,10,2,3.]],threshold:-2.2414e-005,right_val:0.39129,left_val:0.52394},{features:[[11,12,1,2,-1.],[11,13,1,1,2.]],threshold:7.2035e-005,right_val:0.55018,left_val:0.47994},{features:[[8,15,4,2,-1.],[8,16,4,1,2.]],threshold:-6.9267e-003,right_val:0.46981,left_val:0.693},{features:[[6,9,8,8,-1.],[10,9,4,4,2.],[6,13,4,4,2.]],threshold:-7.6998e-003,right_val:0.54809,left_val:0.40996},{features:[[7,12,4,6,-1.],[7,12,2,3,2.],[9,15,2,3,2.]],threshold:-7.3131e-003,right_val:0.50579,left_val:0.32835},{features:[[10,11,3,1,-1.],[11,11,1,1,3.]],threshold:1.9651e-003,right_val:0.63982,left_val:0.4978},{features:[[9,7,2,10,-1.],[9,7,1,5,2.],[10,12,1,5,2.]],threshold:7.1648e-003,right_val:0.62221,left_val:0.46612},{features:[[8,0,6,6,-1.],[10,0,2,6,3.]],threshold:-0.024079,right_val:0.52222,left_val:0.23346},{features:[[3,11,2,6,-1.],[3,13,2,2,3.]],threshold:-0.021028,right_val:0.49382,left_val:0.11837},{features:[[16,12,1,2,-1.],[16,13,1,1,2.]],threshold:3.6017e-004,right_val:0.41167,left_val:0.5325},{features:[[1,14,6,6,-1.],[1,14,3,3,2.],[4,17,3,3,2.]],threshold:-0.01722,right_val:0.46643,left_val:0.62788},{features:[[13,1,3,6,-1.],[14,1,1,6,3.]],threshold:-7.8672e-003,right_val:0.52497,left_val:0.34034},{features:[[8,8,2,2,-1.],[8,9,2,1,2.]],threshold:-4.4777e-004,right_val:0.50863,left_val:0.36104},{features:[[9,9,3,3,-1.],[10,9,1,3,3.]],threshold:5.5486e-003,right_val:0.62035,left_val:0.48843},{features:[[8,7,3,3,-1.],[8,8,3,1,3.]],threshold:-6.9461e-003,right_val:0.50111,left_val:0.26259},{features:[[14,0,2,3,-1.],[14,0,1,3,2.]],threshold:1.357e-004,right_val:0.56283,left_val:0.43408},{features:[[1,0,18,9,-1.],[7,0,6,9,3.]],threshold:-0.04588,right_val:0.46963,left_val:0.6508},{features:[[11,5,4,15,-1.],[11,5,2,15,2.]],threshold:-0.021583,right_val:0.52876,left_val:0.38265},{features:[[5,5,4,15,-1.],[7,5,2,15,2.]],threshold:-0.02021,right_val:0.50745,left_val:0.32334},{features:[[14,0,2,3,-1.],[14,0,1,3,2.]],threshold:5.8497e-003,right_val:0.44897,left_val:0.51776},{features:[[4,0,2,3,-1.],[5,0,1,3,2.]],threshold:-5.7476e-005,right_val:0.52464,left_val:0.40209},{features:[[11,12,2,2,-1.],[12,12,1,1,2.],[11,13,1,1,2.]],threshold:-1.1513e-003,right_val:0.49052,left_val:0.63151},{features:[[7,12,2,2,-1.],[7,12,1,1,2.],[8,13,1,1,2.]],threshold:1.9863e-003,right_val:0.64972,left_val:0.47025},{features:[[12,0,3,4,-1.],[13,0,1,4,3.]],threshold:-5.272e-003,right_val:0.52277,left_val:0.36504},{features:[[4,11,3,3,-1.],[4,12,3,1,3.]],threshold:1.2663e-003,right_val:0.38776,left_val:0.51661},{features:[[12,7,4,2,-1.],[12,8,4,1,2.]],threshold:-6.2919e-003,right_val:0.50238,left_val:0.73759},{features:[[8,10,3,2,-1.],[9,10,1,2,3.]],threshold:6.736e-004,right_val:0.54956,left_val:0.44232},{features:[[9,9,3,2,-1.],[10,9,1,2,3.]],threshold:-1.0523e-003,right_val:0.48596,left_val:0.59764},{features:[[8,9,3,2,-1.],[9,9,1,2,3.]],threshold:-4.4216e-004,right_val:0.43989,left_val:0.59559},{features:[[12,0,3,4,-1.],[13,0,1,4,3.]],threshold:1.1748e-003,right_val:0.46051,left_val:0.53499},{features:[[5,0,3,4,-1.],[6,0,1,4,3.]],threshold:5.2457e-003,right_val:0.29416,left_val:0.50492},{features:[[4,14,12,4,-1.],[10,14,6,2,2.],[4,16,6,2,2.]],threshold:-0.02454,right_val:0.52186,left_val:0.25502},{features:[[8,13,2,3,-1.],[8,14,2,1,3.]],threshold:7.3793e-004,right_val:0.54908,left_val:0.44249},{features:[[10,10,3,8,-1.],[10,14,3,4,2.]],threshold:1.4234e-003,right_val:0.40814,left_val:0.53195},{features:[[8,10,4,8,-1.],[8,10,2,4,2.],[10,14,2,4,2.]],threshold:-2.4149e-003,right_val:0.5239,left_val:0.40877},{features:[[10,8,3,1,-1.],[11,8,1,1,3.]],threshold:-1.2165e-003,right_val:0.49081,left_val:0.56746},{features:[[9,12,1,6,-1.],[9,15,1,3,2.]],threshold:-1.2439e-003,right_val:0.52561,left_val:0.41294},{features:[[10,8,3,1,-1.],[11,8,1,1,3.]],threshold:6.1943e-003,right_val:0.73137,left_val:0.50602},{features:[[7,8,3,1,-1.],[8,8,1,1,3.]],threshold:-1.6607e-003,right_val:0.45964,left_val:0.59796},{features:[[5,2,15,14,-1.],[5,9,15,7,2.]],threshold:-0.027316,right_val:0.53088,left_val:0.41744},{features:[[2,1,2,10,-1.],[2,1,1,5,2.],[3,6,1,5,2.]],threshold:-1.5846e-003,right_val:0.45195,left_val:0.56158},{features:[[14,14,2,3,-1.],[14,15,2,1,3.]],threshold:-1.5515e-003,right_val:0.53608,left_val:0.40762},{features:[[2,7,3,3,-1.],[3,7,1,3,3.]],threshold:3.8447e-004,right_val:0.54304,left_val:0.43473},{features:[[17,4,3,3,-1.],[17,5,3,1,3.]],threshold:-0.014672,right_val:0.51461,left_val:0.16593},{features:[[0,4,3,3,-1.],[0,5,3,1,3.]],threshold:8.1609e-003,right_val:0.18847,left_val:0.49618},{features:[[13,5,6,2,-1.],[16,5,3,1,2.],[13,6,3,1,2.]],threshold:1.1122e-003,right_val:0.60938,left_val:0.48683},{features:[[4,19,12,1,-1.],[8,19,4,1,3.]],threshold:-7.2604e-003,right_val:0.46904,left_val:0.62843},{features:[[12,12,2,4,-1.],[12,14,2,2,2.]],threshold:-2.4046e-004,right_val:0.4046,left_val:0.5575},{features:[[3,15,1,3,-1.],[3,16,1,1,3.]],threshold:-2.3348e-004,right_val:0.52528,left_val:0.41158},{features:[[11,16,6,4,-1.],[11,16,3,4,2.]],threshold:5.5736e-003,right_val:0.56901,left_val:0.47301},{features:[[2,10,3,10,-1.],[3,10,1,10,3.]],threshold:0.030624,right_val:0.17401,left_val:0.49719},{features:[[12,8,2,4,-1.],[12,8,1,4,2.]],threshold:9.2075e-004,right_val:0.43549,left_val:0.53721},{features:[[6,8,2,4,-1.],[7,8,1,4,2.]],threshold:-4.3551e-005,right_val:0.43473,left_val:0.53669},{features:[[10,14,2,3,-1.],[10,14,1,3,2.]],threshold:-6.6453e-003,right_val:0.51605,left_val:0.34355},{features:[[5,1,10,3,-1.],[10,1,5,3,2.]],threshold:0.043222,right_val:0.72937,left_val:0.47668},{features:[[10,7,3,2,-1.],[11,7,1,2,3.]],threshold:2.2332e-003,right_val:0.56332,left_val:0.50293},{features:[[5,6,9,2,-1.],[8,6,3,2,3.]],threshold:3.183e-003,right_val:0.51921,left_val:0.40161},{features:[[9,8,2,2,-1.],[9,9,2,1,2.]],threshold:-1.8028e-004,right_val:0.54179,left_val:0.40883},{features:[[2,11,16,6,-1.],[2,11,8,3,2.],[10,14,8,3,2.]],threshold:-5.2935e-003,right_val:0.52436,left_val:0.40757},{features:[[12,7,2,2,-1.],[13,7,1,1,2.],[12,8,1,1,2.]],threshold:1.2751e-003,right_val:0.6387,left_val:0.49133},{features:[[9,5,2,3,-1.],[9,6,2,1,3.]],threshold:4.3385e-003,right_val:0.29473,left_val:0.50317},{features:[[9,7,3,2,-1.],[10,7,1,2,3.]],threshold:8.5251e-003,right_val:0.63089,left_val:0.49498},{features:[[5,1,8,12,-1.],[5,7,8,6,2.]],threshold:-9.4266e-004,right_val:0.42856,left_val:0.53284},{features:[[13,5,2,2,-1.],[13,6,2,1,2.]],threshold:1.361e-003,right_val:0.59415,left_val:0.49915},{features:[[5,5,2,2,-1.],[5,6,2,1,2.]],threshold:4.4783e-004,right_val:0.58545,left_val:0.45735},{features:[[12,4,3,3,-1.],[12,5,3,1,3.]],threshold:1.336e-003,right_val:0.58491,left_val:0.46044},{features:[[4,14,2,3,-1.],[4,15,2,1,3.]],threshold:-6.0968e-004,right_val:0.52294,left_val:0.39694},{features:[[12,4,3,3,-1.],[12,5,3,1,3.]],threshold:-2.3657e-003,right_val:0.48984,left_val:0.58083},{features:[[5,4,3,3,-1.],[5,5,3,1,3.]],threshold:1.0734e-003,right_val:0.547,left_val:0.43512},{features:[[9,14,2,6,-1.],[10,14,1,3,2.],[9,17,1,3,2.]],threshold:2.1923e-003,right_val:0.38429,left_val:0.53551},{features:[[8,14,3,2,-1.],[9,14,1,2,3.]],threshold:5.4969e-003,right_val:0.28272,left_val:0.50181},{features:[[9,5,6,6,-1.],[11,5,2,6,3.]],threshold:-0.075369,right_val:0.51488,left_val:0.12251},{features:[[5,5,6,6,-1.],[7,5,2,6,3.]],threshold:0.025134,right_val:0.70254,left_val:0.47318},{features:[[13,13,1,2,-1.],[13,14,1,1,2.]],threshold:-2.9359e-005,right_val:0.46561,left_val:0.54305},{features:[[0,2,10,2,-1.],[0,3,10,1,2.]],threshold:-5.8356e-004,right_val:0.51901,left_val:0.4031},{features:[[13,13,1,2,-1.],[13,14,1,1,2.]],threshold:-2.6639e-003,right_val:0.51618,left_val:0.43081},{features:[[5,7,2,2,-1.],[5,7,1,1,2.],[6,8,1,1,2.]],threshold:-1.3804e-003,right_val:0.46955,left_val:0.62198},{features:[[13,5,2,7,-1.],[13,5,1,7,2.]],threshold:1.2313e-003,right_val:0.44258,left_val:0.53794},{features:[[6,13,1,2,-1.],[6,14,1,1,2.]],threshold:-1.4644e-005,right_val:0.42225,left_val:0.52816},{features:[[11,0,3,7,-1.],[12,0,1,7,3.]],threshold:-0.012819,right_val:0.51799,left_val:0.25821},{features:[[0,3,2,16,-1.],[0,3,1,8,2.],[1,11,1,8,2.]],threshold:0.022852,right_val:0.76093,left_val:0.47787},{features:[[11,0,3,7,-1.],[12,0,1,7,3.]],threshold:8.2306e-004,right_val:0.46717,left_val:0.5341},{features:[[6,0,3,7,-1.],[7,0,1,7,3.]],threshold:0.01277,right_val:0.14724,left_val:0.49658},{features:[[11,16,8,4,-1.],[11,16,4,4,2.]],threshold:-0.050052,right_val:0.50166,left_val:0.6415},{features:[[1,16,8,4,-1.],[5,16,4,4,2.]],threshold:0.015775,right_val:0.56854,left_val:0.45223},{features:[[13,5,2,7,-1.],[13,5,1,7,2.]],threshold:-0.018502,right_val:0.5138,left_val:0.27647},{features:[[5,5,2,7,-1.],[6,5,1,7,2.]],threshold:2.4626e-003,right_val:0.37954,left_val:0.51419},{features:[[18,6,2,14,-1.],[18,13,2,7,2.]],threshold:0.062916,right_val:0.65804,left_val:0.50606},{features:[[6,10,3,4,-1.],[6,12,3,2,2.]],threshold:-2.1649e-005,right_val:0.40199,left_val:0.51954},{features:[[14,7,1,2,-1.],[14,8,1,1,2.]],threshold:2.1181e-003,right_val:0.59545,left_val:0.49624},{features:[[0,1,18,6,-1.],[0,1,9,3,2.],[9,4,9,3,2.]],threshold:-0.016635,right_val:0.51754,left_val:0.37579},{features:[[14,7,1,2,-1.],[14,8,1,1,2.]],threshold:-2.8899e-003,right_val:0.50572,left_val:0.6624},{features:[[0,6,2,14,-1.],[0,13,2,7,2.]],threshold:0.076783,right_val:0.80477,left_val:0.47958},{features:[[17,0,3,12,-1.],[18,0,1,12,3.]],threshold:3.9171e-003,right_val:0.57199,left_val:0.49379},{features:[[0,6,18,3,-1.],[0,7,18,1,3.]],threshold:-0.072671,right_val:0.49439,left_val:0.053895},{features:[[6,0,14,16,-1.],[6,8,14,8,2.]],threshold:0.5404,right_val:0.11433,left_val:0.51298},{features:[[0,0,3,12,-1.],[1,0,1,12,3.]],threshold:2.951e-003,right_val:0.56986,left_val:0.45283},{features:[[13,0,3,7,-1.],[14,0,1,7,3.]],threshold:3.4508e-003,right_val:0.42187,left_val:0.53577},{features:[[5,7,1,2,-1.],[5,8,1,1,2.]],threshold:-4.2078e-004,right_val:0.46379,left_val:0.59162},{features:[[14,4,6,6,-1.],[14,6,6,2,3.]],threshold:3.3051e-003,right_val:0.4382,left_val:0.52734},{features:[[5,7,7,2,-1.],[5,8,7,1,2.]],threshold:4.7735e-004,right_val:0.51819,left_val:0.40465},{features:[[8,6,6,9,-1.],[8,9,6,3,3.]],threshold:-0.025929,right_val:0.50894,left_val:0.74522},{features:[[5,4,6,1,-1.],[7,4,2,1,3.]],threshold:-2.973e-003,right_val:0.50588,left_val:0.32954},{features:[[13,0,6,4,-1.],[16,0,3,2,2.],[13,2,3,2,2.]],threshold:5.8508e-003,right_val:0.5793,left_val:0.48571},{features:[[1,2,18,12,-1.],[1,6,18,4,3.]],threshold:-0.045968,right_val:0.53807,left_val:0.43127},{features:[[3,2,17,12,-1.],[3,6,17,4,3.]],threshold:0.15586,right_val:0.16847,left_val:0.51962},{features:[[5,14,7,3,-1.],[5,15,7,1,3.]],threshold:0.015165,right_val:0.6735,left_val:0.47358},{features:[[10,14,1,3,-1.],[10,15,1,1,3.]],threshold:-1.0604e-003,right_val:0.47757,left_val:0.58229},{features:[[3,14,3,3,-1.],[3,15,3,1,3.]],threshold:6.6476e-003,right_val:0.23195,left_val:0.49992},{features:[[14,4,6,6,-1.],[14,6,6,2,3.]],threshold:-0.012231,right_val:0.5263,left_val:0.47509},{features:[[0,4,6,6,-1.],[0,6,6,2,3.]],threshold:5.6529e-003,right_val:0.35618,left_val:0.50698},{features:[[12,5,4,3,-1.],[12,6,4,1,3.]],threshold:1.2978e-003,right_val:0.56191,left_val:0.48757},{features:[[4,5,4,3,-1.],[4,6,4,1,3.]],threshold:0.010782,right_val:0.67823,left_val:0.47508},{features:[[18,0,2,6,-1.],[18,2,2,2,3.]],threshold:2.8655e-003,right_val:0.42907,left_val:0.53055},{features:[[8,1,4,9,-1.],[10,1,2,9,2.]],threshold:2.8663e-003,right_val:0.55394,left_val:0.45185},{features:[[6,6,8,2,-1.],[6,6,4,2,2.]],threshold:-5.1983e-003,right_val:0.54342,left_val:0.41491},{features:[[6,5,4,2,-1.],[6,5,2,1,2.],[8,6,2,1,2.]],threshold:5.374e-003,right_val:0.65077,left_val:0.47179},{features:[[10,5,2,3,-1.],[10,6,2,1,3.]],threshold:-0.014642,right_val:0.51618,left_val:0.21722},{features:[[9,5,1,3,-1.],[9,6,1,1,3.]],threshold:-1.5043e-005,right_val:0.42988,left_val:0.53374},{features:[[9,10,2,2,-1.],[9,11,2,1,2.]],threshold:-1.1876e-004,right_val:0.55824,left_val:0.46046},{features:[[0,8,4,3,-1.],[0,9,4,1,3.]],threshold:0.016996,right_val:0.07388,left_val:0.49459},{features:[[6,0,8,6,-1.],[6,3,8,3,2.]],threshold:-0.035096,right_val:0.49776,left_val:0.70055},{features:[[1,0,6,4,-1.],[1,0,3,2,2.],[4,2,3,2,2.]],threshold:2.4217e-003,right_val:0.54777,left_val:0.44663},{features:[[13,0,3,7,-1.],[14,0,1,7,3.]],threshold:-9.634e-004,right_val:0.53133,left_val:0.47141},{features:[[9,16,2,2,-1.],[9,17,2,1,2.]],threshold:1.6391e-004,right_val:0.53422,left_val:0.43315},{features:[[11,4,6,10,-1.],[11,9,6,5,2.]],threshold:-0.021141,right_val:0.52045,left_val:0.26447},{features:[[0,10,19,2,-1.],[0,11,19,1,2.]],threshold:8.7775e-004,right_val:0.41527,left_val:0.52083},{features:[[9,5,8,9,-1.],[9,8,8,3,3.]],threshold:-0.027944,right_val:0.50188,left_val:0.63441},{features:[[4,0,3,7,-1.],[5,0,1,7,3.]],threshold:6.7297e-003,right_val:0.35009,left_val:0.50504},{features:[[8,6,4,12,-1.],[10,6,2,6,2.],[8,12,2,6,2.]],threshold:0.023281,right_val:0.69687,left_val:0.49663},{features:[[0,2,6,4,-1.],[0,4,6,2,2.]],threshold:-0.011645,right_val:0.50496,left_val:0.33003},{features:[[8,15,4,3,-1.],[8,16,4,1,3.]],threshold:0.015764,right_val:0.73212,left_val:0.49916},{features:[[8,0,3,7,-1.],[9,0,1,7,3.]],threshold:-1.3611e-003,right_val:0.51607,left_val:0.39117},{features:[[9,5,3,4,-1.],[10,5,1,4,3.]],threshold:-8.1522e-004,right_val:0.49497,left_val:0.56289},{features:[[8,5,3,4,-1.],[9,5,1,4,3.]],threshold:-6.0066e-004,right_val:0.45506,left_val:0.58536},{features:[[7,6,6,1,-1.],[9,6,2,1,3.]],threshold:4.9716e-004,right_val:0.54436,left_val:0.42715},{features:[[7,14,4,4,-1.],[7,14,2,2,2.],[9,16,2,2,2.]],threshold:2.3475e-003,right_val:0.38877,left_val:0.51431},{features:[[13,14,4,6,-1.],[15,14,2,3,2.],[13,17,2,3,2.]],threshold:-8.9262e-003,right_val:0.49717,left_val:0.60445},{features:[[7,8,1,8,-1.],[7,12,1,4,2.]],threshold:-0.01392,right_val:0.50004,left_val:0.25832},{features:[[16,0,2,8,-1.],[17,0,1,4,2.],[16,4,1,4,2.]],threshold:1.021e-003,right_val:0.55604,left_val:0.48574},{features:[[2,0,2,8,-1.],[2,0,1,4,2.],[3,4,1,4,2.]],threshold:-2.7442e-003,right_val:0.46458,left_val:0.59369},{features:[[6,1,14,3,-1.],[6,2,14,1,3.]],threshold:-0.0162,right_val:0.51935,left_val:0.3163},{features:[[7,9,3,10,-1.],[7,14,3,5,2.]],threshold:4.3332e-003,right_val:0.34589,left_val:0.50612},{features:[[9,14,2,2,-1.],[9,15,2,1,2.]],threshold:5.8498e-004,right_val:0.58702,left_val:0.4779},{features:[[7,7,6,8,-1.],[7,11,6,4,2.]],threshold:-2.2466e-003,right_val:0.53748,left_val:0.42979},{features:[[9,7,3,6,-1.],[9,10,3,3,2.]],threshold:2.3146e-003,right_val:0.4641,left_val:0.54387},{features:[[7,13,3,3,-1.],[7,14,3,1,3.]],threshold:8.7679e-003,right_val:0.67718,left_val:0.47269},{features:[[9,9,2,2,-1.],[9,10,2,1,2.]],threshold:-2.2448e-004,right_val:0.5428,left_val:0.42292},{features:[[0,1,18,2,-1.],[6,1,6,2,3.]],threshold:-7.4336e-003,right_val:0.46837,left_val:0.60989},{features:[[7,1,6,14,-1.],[7,8,6,7,2.]],threshold:-2.3189e-003,right_val:0.44242,left_val:0.56894},{features:[[1,9,18,1,-1.],[7,9,6,1,3.]],threshold:-2.1042e-003,right_val:0.51871,left_val:0.37622},{features:[[9,7,2,2,-1.],[9,7,1,2,2.]],threshold:4.6035e-004,right_val:0.57712,left_val:0.46994},{features:[[9,3,2,9,-1.],[10,3,1,9,2.]],threshold:1.0548e-003,right_val:0.56017,left_val:0.44652},{features:[[18,14,2,3,-1.],[18,15,2,1,3.]],threshold:8.7149e-004,right_val:0.39147,left_val:0.54498},{features:[[7,11,3,1,-1.],[8,11,1,1,3.]],threshold:3.3365e-004,right_val:0.56457,left_val:0.4564},{features:[[10,8,3,4,-1.],[11,8,1,4,3.]],threshold:-1.4853e-003,right_val:0.46928,left_val:0.57474},{features:[[7,14,3,6,-1.],[8,14,1,6,3.]],threshold:3.0252e-003,right_val:0.37628,left_val:0.51662},{features:[[10,8,3,4,-1.],[11,8,1,4,3.]],threshold:5.0281e-003,right_val:0.61515,left_val:0.50021},{features:[[7,8,3,4,-1.],[8,8,1,4,3.]],threshold:-5.8165e-004,right_val:0.43908,left_val:0.53946},{features:[[7,9,6,9,-1.],[7,12,6,3,3.]],threshold:0.045142,right_val:0.2063,left_val:0.51883},{features:[[0,14,2,3,-1.],[0,15,2,1,3.]],threshold:-1.0796e-003,right_val:0.51379,left_val:0.39047},{features:[[11,12,1,2,-1.],[11,13,1,1,2.]],threshold:1.5996e-004,right_val:0.54275,left_val:0.48953},{features:[[4,3,8,3,-1.],[8,3,4,3,2.]],threshold:-0.019359,right_val:0.47735,left_val:0.69752},{features:[[0,4,20,6,-1.],[0,4,10,6,2.]],threshold:0.20726,right_val:0.3035,left_val:0.52336},{features:[[9,14,1,3,-1.],[9,15,1,1,3.]],threshold:-4.1953e-004,right_val:0.44602,left_val:0.54194},{features:[[8,14,4,3,-1.],[8,15,4,1,3.]],threshold:2.2582e-003,right_val:0.60274,left_val:0.48158},{features:[[0,15,14,4,-1.],[0,17,14,2,2.]],threshold:-6.7811e-003,right_val:0.51833,left_val:0.39803},{features:[[1,14,18,6,-1.],[1,17,18,3,2.]],threshold:0.011154,right_val:0.41888,left_val:0.54312},{features:[[0,0,10,6,-1.],[0,0,5,3,2.],[5,3,5,3,2.]],threshold:0.043162,right_val:0.6523,left_val:0.47382}],threshold:105.76}],size:[20,20],tilted:false};

  var faceDetection = function(pdmModel, params) {

    // processes an image, detects a face and returns the initial face parameters for clmtrackr
    //   calls a callback function when it's done
    //   optionally uses web workers

    if (params === undefined) params = {};
    if (params.workSize === undefined) params.workSize = 200;
    if (params.minScale === undefined) params.minScale = 2;
    if (params.scaleFactor === undefined) params.scaleFactor = 1.15;
    if (params.useCanny === undefined) params.useCanny = false;
    if (params.edgesDensity === undefined) params.edgesDensity = 0.13;
    if (params.equalizeHistogram === undefined) params.equalizeHistogram = false;
    if (params.min_neighbors === undefined) params.min_neighbors = 2;
    if (params.confidenceThreshold === undefined) params.confidenceThreshold = 106.1;
    if (params.useWebWorkers === undefined) params.useWebWorkers = true;

    // disable web workers if not exists
    if (!window.Worker) params.useWebWorkers = false;

    var msxmin, msymin, msymax;
    var msmodelheight;
    var element;

    var model = pdmModel;

    var mosseFilter = mosse.mosseFilter;
    var left_eye_filter = mosse.filters.left_eye_filter;
    var right_eye_filter = mosse.filters.right_eye_filter;
    var nose_filter = mosse.filters.nose_filter;

    var mossef_lefteye, mossef_righteye, mossef_nose;
    var right_eye_position = [0.0,0.0];
    var left_eye_position = [0.0,0.0];
    var nose_position = [0.0,0.0];

    if (model.hints && mosseFilter && left_eye_filter && right_eye_filter && nose_filter) {
      mossef_lefteye = new mosseFilter();
      mossef_lefteye.load(left_eye_filter);
      mossef_righteye = new mosseFilter();
      mossef_righteye.load(right_eye_filter);
      mossef_nose = new mosseFilter();
      mossef_nose.load(nose_filter);
    } else {
      console.log('MOSSE filters not found, using rough approximation for initialization.');
    }

    // load mean shape
    var meanShape = model.shapeModel.meanShape;
    var numPatches = model.patchModel.numPatches;

    // get max and mins, width and height of meanshape
    msymax = 0;
    msxmin = msymin = 1000000;
    for (var i = 0;i < numPatches;i++) {
      if (meanShape[i][0] < msxmin) msxmin = meanShape[i][0];
      if (meanShape[i][1] < msymin) msymin = meanShape[i][1];
      if (meanShape[i][1] > msymax) msymax = meanShape[i][1];
    }
    msmodelheight = msymax-msymin;

    var jf = new jsfeat_face(params);

    this.init = function(video) {
      element = video;

      jf.init(element);
    };

    var getBoundingBox = function(box) {
      return new Promise(function(resolve, reject) {
        if (box) {
          resolve({x : box[0], y : box[1], width : box[2], height : box[3]});
        } else {
          resolve(jf.findFace());
        }
      });
    };

    var getFinegrainedPosition = function(candidate) {
      var translateX, translateY, scaling, rotation;
      var x = candidate.x;
      var y = candidate.y;
      var w = candidate.width;
      var h = candidate.height;

      // var debugCC = document.getElementById('overlay2').getContext('2d')
      if (model.hints && mosseFilter && left_eye_filter && right_eye_filter && nose_filter) {
        var noseFilterWidth = w * 4.5/10;
        var eyeFilterWidth = w * 6/10;

        // detect position of eyes and nose via mosse filter
        var nose_result = mossef_nose.track(element, Math.round(x+(w/2)-(noseFilterWidth/2)), Math.round(y+h*(5/8)-(noseFilterWidth/2)), noseFilterWidth, noseFilterWidth, false);
        var right_result = mossef_righteye.track(element, Math.round(x+(w*3/4)-(eyeFilterWidth/2)), Math.round(y+h*(2/5)-(eyeFilterWidth/2)), eyeFilterWidth, eyeFilterWidth, false);
        var left_result = mossef_lefteye.track(element, Math.round(x+(w/4)-(eyeFilterWidth/2)), Math.round(y+h*(2/5)-(eyeFilterWidth/2)), eyeFilterWidth, eyeFilterWidth, false);
        right_eye_position[0] = Math.round(x+(w*3/4)-(eyeFilterWidth/2))+right_result[0];
        right_eye_position[1] = Math.round(y+h*(2/5)-(eyeFilterWidth/2))+right_result[1];
        left_eye_position[0] = Math.round(x+(w/4)-(eyeFilterWidth/2))+left_result[0];
        left_eye_position[1] = Math.round(y+h*(2/5)-(eyeFilterWidth/2))+left_result[1];
        nose_position[0] = Math.round(x+(w/2)-(noseFilterWidth/2))+nose_result[0];
        nose_position[1] = Math.round(y+h*(5/8)-(noseFilterWidth/2))+nose_result[1];

        // drawDetection(debugCC, candidate, [left_eye_position, right_eye_positions, nose_position]);

        // get eye and nose positions of model
        var lep = model.hints.leftEye;
        var rep = model.hints.rightEye;
        var mep = model.hints.nose;

        // get scaling, rotation, etc. via procrustes analysis
        var procrustes_params = procrustes([left_eye_position, right_eye_position, nose_position], [lep, rep, mep]);
        translateX = procrustes_params[0];
        translateY = procrustes_params[1];
        scaling = procrustes_params[2];
        rotation = procrustes_params[3];

        // drawFacialPoints(debugCC, [lep, rep, mep], procrustes_params);
      } else {
        // drawBoundingBox(debugCC, [x,y,w,h]);
        scaling = w/msmodelheight;
        rotation = 0;
        translateX = x-(msxmin*scaling)+0.1*w;
        translateY = y-(msymin*scaling)+0.25*h;
      }

      return [scaling, rotation, translateX, translateY];
    };

    // get initial starting point for model
    this.getInitialPosition = function(box) {
      return new Promise(function(resolve, reject) {
        getBoundingBox(box)
          .then(getFinegrainedPosition)
          .then(resolve)
          .catch(reject);
      });
    };

    // procrustes analysis
    function procrustes(template, shape) {
      // assume template and shape is a vector of x,y-coordinates
      //i.e. template = [[x1,y1], [x2,y2], [x3,y3]];
      var templateClone = [];
      var shapeClone = [];
      for (var i = 0;i < template.length;i++) {
        templateClone[i] = [template[i][0], template[i][1]];
      }
      for (var i = 0;i < shape.length;i++) {
        shapeClone[i] = [shape[i][0], shape[i][1]];
      }
      shape = shapeClone;
      template = templateClone;

      // calculate translation
      var templateMean = [0.0, 0.0];
      for (var i = 0;i < template.length;i++) {
        templateMean[0] += template[i][0];
        templateMean[1] += template[i][1];
      }
      templateMean[0] /= template.length;
      templateMean[1] /= template.length;

      var shapeMean = [0.0, 0.0];
      for (var i = 0;i < shape.length;i++) {
        shapeMean[0] += shape[i][0];
        shapeMean[1] += shape[i][1];
      }
      shapeMean[0] /= shape.length;
      shapeMean[1] /= shape.length;

      var translationX = templateMean[0] - shapeMean[0];
      var translationY = templateMean[1] - shapeMean[1];

      // centralize
      for (var i = 0;i < shape.length;i++) {
        shape[i][0] -= shapeMean[0];
        shape[i][1] -= shapeMean[1];
      }
      for (var i = 0;i < template.length;i++) {
        template[i][0] -= templateMean[0];
        template[i][1] -= templateMean[1];
      }

      // scaling

      var scaleS = 0.0;
      for (var i = 0;i < shape.length;i++) {
        scaleS += ((shape[i][0])*(shape[i][0]));
        scaleS += ((shape[i][1])*(shape[i][1]));
      }
      scaleS = Math.sqrt(scaleS/shape.length);

      var scaleT = 0.0;
      for (var i = 0;i < template.length;i++) {
        scaleT += ((template[i][0])*(template[i][0]));
        scaleT += ((template[i][1])*(template[i][1]));
      }
      scaleT = Math.sqrt(scaleT/template.length);

      var scaling = scaleT/scaleS;

      for (var i = 0;i < shape.length;i++) {
        shape[i][0] *= scaling;
        shape[i][1] *= scaling;
      }

      // rotation

      var top = 0.0;
      var bottom = 0.0;
      for (var i = 0;i < shape.length;i++) {
        top += (shape[i][0]*template[i][1] - shape[i][1]*template[i][0]);
        bottom += (shape[i][0]*template[i][0] + shape[i][1]*template[i][1]);
      }
      var rotation = Math.atan(top/bottom);

      translationX += (shapeMean[0]-(scaling*Math.cos(-rotation)*shapeMean[0])-(scaling*shapeMean[1]*Math.sin(-rotation)));
      translationY += (shapeMean[1]+(scaling*Math.sin(-rotation)*shapeMean[0])-(scaling*shapeMean[1]*Math.cos(-rotation)));

      return [translationX, translationY, scaling, rotation];
    }
  };

// simple wrapper for jsfeat face detector that can run as a webworker
  var jsfeat_face = function(parameters) {

    var params = parameters;
    var maxWorkSize = params.workSize;
    var useWebWorkers = params.useWebWorkers;

    var work_canvas = document.createElement('canvas');
    var work_ctx = work_canvas.getContext('2d');

    var videoWidth, videoHeight, scale, video, w, h;
    var img_u8, edg, ii_sum, ii_sqsum, ii_tilted, ii_canny, classifier;
    var worker;

    if (useWebWorkers) {
      Worker.createURL = function(func_or_string) {
        var str = (typeof func_or_string === 'function')?func_or_string.toString():func_or_string;
        str = str.replace("'FRONTALFACE_PLACEHOLDER'", JSON.stringify(jsfeat_1.haar.frontalface));
        var blob = new Blob(['\'use strict\';\nself.onmessage ='+str], { type: 'text/javascript' });
        return window.URL.createObjectURL(blob);
      };

      Worker.create = function(func_or_string) {
        return new Worker(Worker.createURL(func_or_string));
      };

      worker = Worker.create(findFaceWorker);
    }

    this.init = function(element) {
      video = element;
      videoWidth = video.width;
      videoHeight = video.height;

      // scale down canvas we do detection on (to reduce noisy detections)
      scale = Math.min(maxWorkSize/videoWidth, maxWorkSize/videoHeight);
      w = (videoWidth*scale)|0;
      h = (videoHeight*scale)|0;

      work_canvas.height = h;
      work_canvas.width = w;

      if (!useWebWorkers) {
        img_u8 = new jsfeat_1.matrix_t(w, h, jsfeat_1.U8_t | jsfeat_1.C1_t);
        edg = new jsfeat_1.matrix_t(w, h, jsfeat_1.U8_t | jsfeat_1.C1_t);
        ii_sum = new Int32Array((w+1)*(h+1));
        ii_sqsum = new Int32Array((w+1)*(h+1));
        ii_tilted = new Int32Array((w+1)*(h+1));
        ii_canny = new Int32Array((w+1)*(h+1));
        classifier = jsfeat_1.haar.frontalface;
      }
    };

    this.findFace = function () {
      work_ctx.drawImage(video, 0, 0, work_canvas.width, work_canvas.height);
      var imageData = work_ctx.getImageData(0, 0, work_canvas.width, work_canvas.height);

      return new Promise(function(resolve, reject) {
        if (useWebWorkers) {
          worker.addEventListener('message', function (e) {
            if (e.data.faces.length > 0) {
              resolve(e.data.faces[0]);
            } else {
              reject();
            }
          }.bind(this), false);

          worker.postMessage({
            w: work_canvas.width,
            h: work_canvas.height,
            videoWidth: videoWidth,
            imageData:imageData,
            params: params
          });
        } else {
          jsfeat_1.imgproc.grayscale(imageData.data, work_canvas.width, work_canvas.height, img_u8);

          // possible params
          if(params.equalizeHistogram) {
            jsfeat_1.imgproc.equalize_histogram(img_u8, img_u8);
          }
          //jsfeat.imgproc.gaussian_blur(img_u8, img_u8, 3);

          jsfeat_1.imgproc.compute_integral_image(img_u8, ii_sum, ii_sqsum, classifier.tilted ? ii_tilted : null);

          if(params.useCanny) {
            jsfeat_1.imgproc.canny(img_u8, edg, 10, 50);
            jsfeat_1.imgproc.compute_integral_image(edg, ii_canny, null, null);
          }

          jsfeat_1.haar.edgesDensity = params.edgesDensity;
          var rects = jsfeat_1.haar.detect_multi_scale(ii_sum, ii_sqsum, ii_tilted, params.useCanny? ii_canny : null, img_u8.cols, img_u8.rows, classifier, params.scaleFactor, params.minScale);
          rects = jsfeat_1.haar.group_rectangles(rects, params.min_neighbors);

          for (var i = rects.length-1;i >= 0;i--) {
            if (rects[i].confidence < params.confidenceThreshold) {
              rects.splice(i,1);
            }
          }

          var rl = rects.length;
          if (rl == 0) {
            reject();
          } else {
            var best = rects[0];
            for (var i = 1; i < rl; i++) {
              if (rects[i].neighbors > best.neighbors) {
                best = rects[i];
              } else if (rects[i].neighbors == best.neighbors) {
                // if (rects[i].width > best.width) best = rects[i]; // use biggest rect
                if (rects[i].confidence > best.confidence) best = rects[i]; // use most confident rect
              }
            }

            var sc = videoWidth / img_u8.cols;
            best.x = (best.x*sc)|0;
            best.y = (best.y*sc)|0;
            best.width = (best.width*sc)|0;
            best.height = (best.height*sc)|0;

            resolve(best);
          }
        }
      });
    };
  };

  /**
   * Fast Fourier Transform
   * 1D-FFT/IFFT, 2D-FFT/IFFT (radix-2)
   *
   * @author ryo / github.com/wellflat
   * Based on https://github.com/wellflat/javascript-labs with some tiny optimizations
   */

  function FFT$1() {

    var _n = 0,          // order
      _bitrev = null,  // bit reversal table
      _cstb = null;    // sin/cos table
    var _tre, _tim;

    this.init = function (n) {
      if(n !== 0 && (n & (n - 1)) === 0) {
        _n = n;
        _setVariables();
        _makeBitReversal();
        _makeCosSinTable();
      } else {
        throw new Error('init: radix-2 required');
      }
    };

    // 1D-FFT
    this.fft1d = function (re, im) {
      fft(re, im, 1);
    };

    // 1D-IFFT
    this.ifft1d = function (re, im) {
      var n = 1/_n;
      fft(re, im, -1);
      for(var i=0; i<_n; i++) {
        re[i] *= n;
        im[i] *= n;
      }
    };

    // 2D-FFT
    this.fft2d = function (re, im) {
      var i = 0;
      // x-axis
      for(var y=0; y<_n; y++) {
        i = y*_n;
        for(var x1=0; x1<_n; x1++) {
          _tre[x1] = re[x1 + i];
          _tim[x1] = im[x1 + i];
        }
        this.fft1d(_tre, _tim);
        for(var x2=0; x2<_n; x2++) {
          re[x2 + i] = _tre[x2];
          im[x2 + i] = _tim[x2];
        }
      }

      // y-axis
      for(var x=0; x<_n; x++) {
        for(var y1=0; y1<_n; y1++) {
          i = x + y1*_n;
          _tre[y1] = re[i];
          _tim[y1] = im[i];
        }
        this.fft1d(_tre, _tim);
        for(var y2=0; y2<_n; y2++) {
          i = x + y2*_n;
          re[i] = _tre[y2];
          im[i] = _tim[y2];
        }
      }
    };

    // 2D-IFFT
    this.ifft2d = function (re, im) {
      var i = 0;
      // x-axis
      for(var y=0; y<_n; y++) {
        i = y*_n;
        for(var x1=0; x1<_n; x1++) {
          _tre[x1] = re[x1 + i];
          _tim[x1] = im[x1 + i];
        }
        this.ifft1d(_tre, _tim);
        for(var x2=0; x2<_n; x2++) {
          re[x2 + i] = _tre[x2];
          im[x2 + i] = _tim[x2];
        }
      }
      // y-axis
      for(var x=0; x<_n; x++) {
        for(var y1=0; y1<_n; y1++) {
          i = x + y1*_n;
          _tre[y1] = re[i];
          _tim[y1] = im[i];
        }
        this.ifft1d(_tre, _tim);
        for(var y2=0; y2<_n; y2++) {
          i = x + y2*_n;
          re[i] = _tre[y2];
          im[i] = _tim[y2];
        }
      }
    };

    // 2D-IFFT, real-valued
    // only outputs the real valued part
    this.real_ifft2d = function (re, im) {
      var i2;
      var i = 0;
      // x-axis
      for(var y=0; y<_n; y++) {
        i = y*_n;
        for(var x1=0; x1<_n; x1++) {
          _tre[x1] = re[x1 + i];
          _tim[x1] = im[x1 + i];
        }
        this.ifft1d(_tre, _tim);
        for(var x2=0; x2<_n; x2++) {
          re[x2 + i] = _tre[x2];
          im[x2 + i] = _tim[x2];
        }
      }
      // y-axis
      var halfn = _n/2;
      var rowIdx = 0;
      for(var x=0; x<_n; x+=2) {
        //untangle
        i = x;
        i2 = x+1;
        _tre[0] = re[0 + i];
        _tim[0] = re[0 + i2];
        _tre[_n/2] = re[(halfn*_n) + i];
        _tim[_n/2] = re[(halfn*_n) + i2];
        for (var x2=1;x2<halfn;x2++) {
          rowIdx = x2*_n;
          _tre[x2] = re[rowIdx+i] - im[rowIdx + i2];
          _tre[_n - x2] = re[rowIdx+i] + im[rowIdx + i2];
          _tim[x2] = im[rowIdx+i] + re[rowIdx+i2];
          _tim[_n - x2] = re[rowIdx+i2] - im[rowIdx+i];
        }
        this.ifft1d(_tre, _tim);
        for(var y2=0; y2<_n; y2++) {
          i = x + y2*_n;
          i2 = (x + 1) + y2*_n;
          re[i] = _tre[y2];
          re[i2] = _tim[y2];
        }
      }
    };

    // 2D-FFT, real-valued only
    // ignores the imaginary input
    //   see:
    // http://www.inf.fu-berlin.de/lehre/SS12/SP-Par/download/fft1.pdf
    // http://cnx.org/content/m12021/latest/
    // http://images.apple.com/acg/pdf/g4fft.pdf
    // http://www.ti.com/lit/an/spra291/spra291.pdf
    this.real_fft2d = function (re, im) {
      var i = 0, i2 = 0;
      // x-axis
      for(var y=0; y<_n; y += 2) {
        i = y*_n;
        i2 = (y+1)*_n;
        // tangle
        for(var x1=0; x1<_n; x1++) {
          _tre[x1] = re[x1 + i];
          _tim[x1] = re[x1 + i2];
        }
        this.fft1d(_tre, _tim);
        // untangle
        re[0 + i] = _tre[0];
        re[0 + i2] = _tim[0];
        im[0 + i] = 0;
        im[0 + i2] = 0;
        re[_n/2 + i] = _tre[_n/2];
        re[_n/2 + i2] = _tim[_n/2];
        im[_n/2 + i] = 0;
        im[_n/2 + i2] = 0;
        for(var x2=1;x2<(_n/2);x2++) {
          re[x2 + i] = 0.5 * (_tre[x2] + _tre[_n - x2]);
          im[x2 + i] = 0.5 * (_tim[x2] - _tim[_n - x2]);
          re[x2 + i2] = 0.5 * (_tim[x2] + _tim[_n - x2]);
          im[x2 + i2] = -0.5 * (_tre[x2] - _tre[_n - x2]);
          re[(_n-x2) + i] = re[x2 + i];
          im[(_n-x2) + i] = -im[x2 + i];
          re[(_n-x2) + i2] = re[x2 + i2];
          im[(_n-x2) + i2] = -im[x2 + i2];
        }
      }
      // y-axis
      for(var x=0; x<_n; x++) {
        for(var y1=0; y1<_n; y1++) {
          i = x + y1*_n;
          _tre[y1] = re[i];
          _tim[y1] = im[i];
        }
        this.fft1d(_tre, _tim);
        for(var y2=0; y2<_n; y2++) {
          i = x + y2*_n;
          re[i] = _tre[y2];
          im[i] = _tim[y2];
        }
      }
    };

    // core operation of FFT
    function fft(re, im, inv) {
      var d, h, ik, m, tmp, wr, wi, xr, xi,
        n4 = _n >> 2;
      // bit reversal
      for(var l=0; l<_n; l++) {
        m = _bitrev[l];
        if(l < m) {
          tmp = re[l];
          re[l] = re[m];
          re[m] = tmp;
          tmp = im[l];
          im[l] = im[m];
          im[m] = tmp;
        }
      }
      // butterfly operation
      //butfly(re,im,inv,n4);
      for(var k=1; k<_n; k<<=1) {
        h = 0;
        d = _n/(k << 1);
        for(var j=0; j<k; j++) {
          wr = _cstb[h + n4];
          wi = inv*_cstb[h];
          for(var i=j; i<_n; i+=(k<<1)) {
            ik = i + k;
            xr = wr*re[ik] + wi*im[ik];
            xi = wr*im[ik] - wi*re[ik];
            re[ik] = re[i] - xr;
            re[i] += xr;
            im[ik] = im[i] - xi;
            im[i] += xi;
          }
          h += d;
        }
      }
    }

    function _setVariables() {
      if(typeof Uint8Array !== 'undefined') {
        _bitrev = new Uint8Array(_n);
      } else {
        _bitrev = new Array(_n);
      }
      if(typeof Float64Array !== 'undefined') {
        _cstb = new Float64Array(_n*1.25);
        _tre = new Float64Array(_n);
        _tim = new Float64Array(_n);
      } else {
        _cstb = new Array(_n*1.25);
        _tre = new Array(_n);
        _tim = new Array(_n);
      }
    }

    // make bit reversal table
    function _makeBitReversal() {
      var i = 0,
        j = 0,
        k = 0;
      _bitrev[0] = 0;
      while(++i < _n) {
        k = _n >> 1;
        while(k <= j) {
          j -= k;
          k >>= 1;
        }
        j += k;
        _bitrev[i] = j;
      }
    }

    // make trigonometric function table
    function _makeCosSinTable() {
      var n2 = _n >> 1,
        n4 = _n >> 2,
        n8 = _n >> 3,
        n2p4 = n2 + n4,
        t = Math.sin(Math.PI/_n),
        dc = 2*t*t,
        ds = Math.sqrt(dc*(2 - dc)),
        c = _cstb[n4] = 1,
        s = _cstb[0] = 0;
      t = 2*dc;
      for(var i=1; i<n8; i++) {
        c -= dc;
        dc += t*c;
        s += ds;
        ds -= t*s;
        _cstb[i] = s;
        _cstb[n4 - i] = c;
      }
      if(n8 !== 0) {
        _cstb[n8] = Math.sqrt(0.5);
      }
      for(var j=0; j<n4; j++) {
        _cstb[n2 - j]  = _cstb[j];
      }
      for(var k=0; k<n2p4; k++) {
        _cstb[k + n2] = -_cstb[k];
      }
    }
  }

  var svmFilter = function() {

    var _fft, fft_filters, responses, biases;
    var fft_size, filterLength, filter_width, search_width, num_patches;
    var temp_imag_part, temp_real_part;

    // fft function
    this.fft_inplace = function(array, _im_part) {
      // in-place

      if (typeof _im_part == 'undefined') {
        _im_part = temp_imag_part;
      }

      for (var i = 0;i < filterLength;i++) {
        _im_part[i] = 0.0;
      }

      _fft.real_fft2d(array,_im_part);

      return [array, _im_part];
    };

    this.ifft = function(rn, cn) {
      // in-place
      _fft.real_ifft2d(rn, cn);
      return rn;
    };

    var complex_mult_inplace = function(cn1, cn2) {
      // in-place, cn1 is the one modified
      var temp1, temp2;
      for (var r = 0;r < filterLength;r++) {
        temp1 = (cn1[0][r]*cn2[0][r]) - (cn1[1][r]*cn2[1][r]);
        temp2 = (cn1[0][r]*cn2[1][r]) + (cn1[1][r]*cn2[0][r]);
        cn1[0][r] = temp1;
        cn1[1][r] = temp2;
      }
    };

    this.init = function(filter_input, bias_input, numPatches, filterWidth, searchWidth) {
      // calculate needed size of fft (has to be power of two)
      fft_size = upperPowerOfTwo(filterWidth-1+searchWidth);
      filterLength = fft_size*fft_size;
      _fft = new FFT$1();
      _fft.init(fft_size);
      fft_filters = Array(numPatches);
      var fft_filter;
      var edge = (filterWidth-1)/2;

      for (var i = 0;i < numPatches;i++) {
        var flar_fi0 = new Float64Array(filterLength);
        var flar_fi1 = new Float64Array(filterLength);

        // load filter
        var xOffset, yOffset;
        for (var j = 0;j < filterWidth;j++) {
          for (var k = 0;k < filterWidth;k++) {
            // TODO : rotate filter

            xOffset = k < edge ? (fft_size-edge) : (-edge);
            yOffset = j < edge ? (fft_size-edge) : (-edge);
            flar_fi0[k+xOffset+((j+yOffset)*fft_size)] = filter_input[i][(filterWidth-1-j)+((filterWidth-1-k)*filterWidth)];

            /*xOffset = k < edge ? (fft_size-edge) : (-edge);
					yOffset = j < edge ? (fft_size-edge) : (-edge);
					flar_fi0[k+xOffset+((j+yOffset)*fft_size)] = filter_input[i][k+(j*filterWidth)];*/

            //console.log(k + ','+ j+':' + (k+xOffset+((j+yOffset)*fft_size)))
          }
        }

        // fft it and store
        fft_filter = this.fft_inplace(flar_fi0, flar_fi1);
        fft_filters[i] = fft_filter;

      }

      // set up biases
      biases = new Float64Array(numPatches);
      for (var i = 0;i < numPatches;i++) {
        biases[i] = bias_input[i];
      }

      responses = Array(numPatches);
      temp_imag_part = Array(numPatches);
      for (var i = 0;i < numPatches;i++) {
        responses[i] = new Float64Array(searchWidth*searchWidth);
        temp_imag_part[i] = new Float64Array(searchWidth*searchWidth);
      }
      temp_real_part = new Float64Array(filterLength);

      num_patches = numPatches;
      filter_width = filterWidth;
      search_width = searchWidth;
    };

    this.getResponses = function(patches) {
      var response, edge;
      var patch_width = filter_width-1+search_width;
      for (var i = 0;i < num_patches;i++) {
        // reset zeroes in temp_real_part
        for (var j = 0;j < fft_size*fft_size;j++) {
          temp_real_part[j] = 0.0;
        }

        // normalize patches to 0-1
        patches[i] = normalizePatches(patches[i]);

        // patch must be padded (with zeroes) to match fft size
        for (var j = 0;j < patch_width;j++) {
          for (var k = 0;k < patch_width;k++) {
            temp_real_part[j + (fft_size*k)] = patches[i][k + (patch_width*j)];
          }
        }

        //drawData(document.getElementById('sketch').getContext('2d'), temp_real_part, 32, 32, false, 0, 0);

        // fft it
        response = this.fft_inplace(temp_real_part);

        // multiply pointwise with filter
        complex_mult_inplace(response, fft_filters[i]);

        // inverse fft it
        response = this.ifft(response[0], response[1]);

        // crop out edges
        edge = (filter_width-1)/2;
        for (var j = 0;j < search_width;j++) {
          for (var k = 0;k < search_width;k++) {
            responses[i][j + (k*search_width)] = response[edge + k + ((j+edge)*(fft_size))];
          }
        }

        // add bias
        for (var j = 0;j < search_width*search_width;j++) {
          responses[i][j] += biases[i];
        }

        // logistic transformation
        responses[i] = logisticResponse(responses[i]);

        /*responses[i] = new Float64Array(32*32)
			for (var j = 0;j < 32;j++) {
				for (var k = 0;k < 32;k++) {
					responses[i][k + (j*(32))] = response[k + (j*(32))]
				}
			}*/

        // normalization?
        inplaceNormalizeFilterMatrix(responses[i]);
      }

      return responses;
    };

    var normalizePatches = function(patch) {
      var patch_width = filter_width-1+search_width;
      var max = 0;
      var min = 1000;
      var value;
      for (var j = 0;j < patch_width;j++) {
        for (var k = 0;k < patch_width;k++) {
          value = patch[k + (patch_width*j)];
          if (value < min) {
            min = value;
          }
          if (value > max) {
            max = value;
          }
        }
      }
      var scale = max-min;
      for (var j = 0;j < patch_width;j++) {
        for (var k = 0;k < patch_width;k++) {
          patch[k + (patch_width*j)] = (patch[k + (patch_width*j)]-min)/scale;
        }
      }
      return patch;
    };

    var logisticResponse = function(response) {
      // create probability by doing logistic transformation
      for (var j = 0;j < search_width;j++) {
        for (var k = 0;k < search_width;k++) {
          response[j + (k*search_width)] = 1.0/(1.0 + Math.exp(- (response[j + (k*search_width)] - 1.0 )));
        }
      }
      return response;
    };

    var upperPowerOfTwo = function(x) {
      x--;
      x |= x >> 1;
      x |= x >> 2;
      x |= x >> 4;
      x |= x >> 8;
      x |= x >> 16;
      x++;
      return x;
    };

    var inplaceNormalizeFilterMatrix = function(response) {
      // normalize responses to lie within [0,1]
      var msize = response.length;
      var max = 0;
      var min = 1;

      for (var i = 0;i < msize;i++) {
        max = response[i] > max ? response[i] : max;
        min = response[i] < min ? response[i] : min;
      }
      var dist = max-min;

      if (dist == 0) {
        //console.log('a patchresponse was monotone, causing normalization to fail. Leaving it unchanged.');
      } else {
        for (var i = 0;i < msize;i++) {
          response[i] = (response[i]-min)/dist;
        }
      }
    };
  };

  var webglUtils = createCommonjsModule(function (module, exports) {
// This code is based on webgl-utils.js authored by Gregg Tavares, license below:
    /*
 * Copyright (c) 2011, Gregg Tavares
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * * Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 *  * Neither the name of greggman.com nor the names of its contributors
 *   may be used to endorse or promote products derived from this software
 *   without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
 * IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
 * THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
 * PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
 * PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
    (function(){

      var LOGGING_ENABLED = true;

      /**
       * Wrapped logging function.
       * @param {string} msg The message to log.
       */
      const log = function (msg) {
        if (!LOGGING_ENABLED) { return; }
        if (window.console && window.console.log) {
          window.console.log(msg);
        }
      };

      /**
       * Wrapped logging function.
       * @param {string} msg The message to log.
       */
      const error = function (msg) {
        if (!LOGGING_ENABLED) { return; }
        if (window.console) {
          if (window.console.error) {
            window.console.error(msg);
          } else if (window.console.log) {
            window.console.log(msg);
          }
        }
        throw msg;
      };

      /**
       * Turn off all logging.
       */
      const loggingOff = function () {
        LOGGING_ENABLED = false;
      };

      /**
       * Check if the page is embedded.
       * @return {boolean} True of we are in an iframe
       */
      const isInIFrame = function () {
        return window !== window.top;
      };

      /**
       * Converts a WebGL enum to a string
       * @param {!WebGLContext} gl The WebGLContext to use.
       * @param {number} value The enum value.
       * @return {string} The enum as a string.
       */
      const glEnumToString = function (gl, value) {
        for (var p in gl) {
          if (gl[p] === value) {
            return p;
          }
        }
        return '0x' + value.toString(16);
      };


      /**
       * Creates the HTLM for a failure message
       * @param {string} canvasContainerId id of container of th
       *        canvas.
       * @return {string} The html.
       */
      const makeFailHTML = function (msg) {
        return '' +
          '<table style="background-color: #8CE; width: 100%; height: 100%;"><tr>' +
          '<td align="center">' +
          '<div style="display: table-cell; vertical-align: middle;">' +
          '<div style="">' + msg + '</div>' +
          '</div>' +
          '</td></tr></table>';
      };


      /**
       * Mesasge for getting a webgl browser
       * @type {string}
       */
// const GET_A_WEBGL_BROWSER = '' +
//   'This page requires a browser that supports WebGL.<br/>' +
//   '<a href="http://get.webgl.org">Click here to upgrade your browser.</a>';


      /**
       * Mesasge for need better hardware
       * @type {string}
       */
// const OTHER_PROBLEM = '' +
//   "It doesn't appear your computer can support WebGL.<br/>" +
//   '<a href="http://get.webgl.org/troubleshooting/">Click here for more information.</a>';


      /**
       * Creates a webgl context. If creation fails it will
       * change the contents of the container of the <canvas>
       * tag to an error message with the correct links for WebGL.
       * @param {Element} canvas. The canvas element to create a
       *     context from.
       * @param {WebGLContextCreationAttirbutes} optAttribs Any
       *     creation attributes you want to pass in.
       * @return {WebGLRenderingContext} The created context.
       */
      const setupWebGL = function (canvas, optAttribs) {
        // const showLink = function (str) {
        //   var container = canvas.parentNode;
        //   if (container) {
        //     container.innerHTML = makeFailHTML(str);
        //   }
        // };

        if (!window.WebGLRenderingContext) {
          // showLink(GET_A_WEBGL_BROWSER);
          return null;
        }

        var context = create3DContext(canvas, optAttribs);
        if (!context) {
          // showLink(OTHER_PROBLEM);
          return null;
        }
        return context;
      };


      /**
       * Creates a webgl context.
       * @param {!Canvas} canvas The canvas tag to get context
       *     from. If one is not passed in one will be created.
       * @return {!WebGLContext} The created context.
       */
      const create3DContext = function (canvas, optAttribs) {
        var names = ['webgl', 'experimental-webgl'];
        var context = null;
        for (var ii = 0; ii < names.length; ++ii) {
          try {
            context = canvas.getContext(names[ii], optAttribs);
          } catch (e) {}
          if (context) {
            break;
          }
        }
        return context;
      };

      const updateCSSIfInIFrame = function () {
        if (isInIFrame()) {
          document.body.className = 'iframe';
        }
      };

      /**
       * Gets a WebGL context.
       * makes its backing store the size it is displayed.
       */
      const getWebGLContext = function (canvas) {
        if (isInIFrame()) {
          updateCSSIfInIFrame();

          // make the canvas backing store the size it's displayed.
          canvas.width = canvas.clientWidth;
          canvas.height = canvas.clientHeight;
        }

        var gl = setupWebGL(canvas);
        return gl;
      };


      /**
       * Loads a shader.
       * @param {!WebGLContext} gl The WebGLContext to use.
       * @param {string} shaderSource The shader source.
       * @param {number} shaderType The type of shader.
       * @param {function(string): void) optErrorCallback callback for errors.
       * @return {!WebGLShader} The created shader.
       */
      const loadShader = function (gl, shaderSource, shaderType, optErrorCallback) {
        var errFn = optErrorCallback || error;
        // Create the shader object
        var shader = gl.createShader(shaderType);

        // Load the shader source
        gl.shaderSource(shader, shaderSource);

        // Compile the shader
        gl.compileShader(shader);

        // Check the compile status
        var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
        if (!compiled) {
          // Something went wrong during compilation; get the error
          var lastError = gl.getShaderInfoLog(shader);
          errFn("*** Error compiling shader '" + shader + "':" + lastError);
          gl.deleteShader(shader);
          return null;
        }

        return shader;
      };


      /**
       * Creates a program, attaches shaders, binds attrib locations, links the
       * program and calls useProgram.
       * @param {!Array.<!WebGLShader>} shaders The shaders to attach
       * @param {!Array.<string>} optAttribs The attribs names.
       * @param {!Array.<number>} optLocations The locations for the attribs.
       */
      const loadProgram = function (gl, shaders, optAttribs, optLocations) {
        var program = gl.createProgram();
        for (var i = 0; i < shaders.length; ++i) {
          gl.attachShader(program, shaders[i]);
        }
        if (optAttribs) {
          for (var i = 0; i < optAttribs.length; ++i) {
            gl.bindAttribLocation(
              program,
              optLocations ? optLocations[i] : i,
              optAttribs[i]);
          }
        }
        gl.linkProgram(program);

        // Check the link status
        const linked = gl.getProgramParameter(program, gl.LINK_STATUS);
        if (!linked) {
          // something went wrong with the link
          const lastError = gl.getProgramInfoLog(program);
          error('Error in program linking:' + lastError);

          gl.deleteProgram(program);
          return null;
        }
        return program;
      };


      /**
       * Loads a shader from a script tag.
       * @param {!WebGLContext} gl The WebGLContext to use.
       * @param {string} scriptId The id of the script tag.
       * @param {number} optShaderType The type of shader. If not passed in it will
       *     be derived from the type of the script tag.
       * @param {function(string): void) optErrorCallback callback for errors.
       * @return {!WebGLShader} The created shader.
       */
      const createShaderFromScript = function (
        gl, scriptId, optShaderType, optErrorCallback
      ) {
        var shaderSource = '';
        var shaderType;
        var shaderScript = document.getElementById(scriptId);
        if (!shaderScript) {
          throw new Error('*** Error: unknown script element' + scriptId);
        }
        shaderSource = shaderScript.text;

        if (!optShaderType) {
          if (shaderScript.type === 'x-shader/x-vertex') {
            shaderType = gl.VERTEX_SHADER;
          } else if (shaderScript.type === 'x-shader/x-fragment') {
            shaderType = gl.FRAGMENT_SHADER;
          } else if (
            shaderType !== gl.VERTEX_SHADER &&
            shaderType !== gl.FRAGMENT_SHADER
          ) {
            throw new Error('*** Error: unknown shader type');
          }
        }

        return loadShader(
          gl,
          shaderSource,
          optShaderType || shaderType,
          optErrorCallback
        );
      };

      {
        module.exports = {
          setupWebGL : setupWebGL,
          createProgram : loadProgram,
          createShaderFromScript : createShaderFromScript,
          getWebGLContext : getWebGLContext,
          loadShader : loadShader
        };
      }

    }());
  });

  var webglUtils_1 = webglUtils.setupWebGL;
  var webglUtils_2 = webglUtils.createProgram;
  var webglUtils_5 = webglUtils.loadShader;

  var webglFilter = function() {

    /*
	 * Textures:
	 * 0 : raw filter
	 * 1 : patches
	 * 2 : finished response
	 * 3 : grad/lbp treated patches
	 * 4 : sobel filter
	 * 5 : lbp filter
	 *
	 * Routing:
	 *         (              )  0/4/5 --\
	 *         (              )          _\|
	 * 1 ----> ( ---------->3 ) ----------> 2
	 *         lbpResponse/      patchResponse
	 *         gradientResponse
	 */

    var gl, canvas;
    var filterWidth, filterHeight, patchWidth, patchHeight, numPatches, canvasWidth, canvasHeight;
    var patchResponseProgram, patchDrawProgram;
    var fbo, numBlocks, patchTex;
    var drawRectBuffer, drawLayerBuffer, drawImageBuffer, rttTexture;
    var texCoordBuffer, texCoordLocation, apositionBuffer;
    var newCanvasWidth, newCanvasBlockHeight, newCanvasHeight;
    var drawOutRectangles, drawOutImages, drawOutLayer;
    var patchCells, textureWidth, textureHeight, patchSize, patchArray;
    var biases;

    var lbpResponseProgram;
    var lbpTexCoordLocation, lbpTexCoordBuffer, lbpPositionLocation, lbpAPositionBuffer;

    var gradientResponseProgram;
    var gbo, gradTexCoordLocation, gradTexCoordBuffer, gradPositionLocation, gradAPositionBuffer;

    var lbpInit = false;
    var sobelInit = false;
    var rawInit = false;

    var lbpResponseVS = [
      'attribute vec2 a_texCoord;',
      'attribute vec2 a_position;',
      '',
      'varying vec2 v_texCoord;',
      '',
      'void main() {',
      '   // transform coordinates to regular coordinates',
      '   gl_Position = vec4(a_position,0.0,1.0);',
      ' ',
      '   // pass the texCoord to the fragment shader',
      '   v_texCoord = a_texCoord;',
      '}'
    ].join('\n');
    var lbpResponseFS;

    var gradientResponseVS = [
      'attribute vec2 a_texCoord;',
      'attribute vec2 a_position;',
      '',
      'varying vec2 v_texCoord;',
      '',
      'void main() {',
      '   // transform coordinates to regular coordinates',
      '   gl_Position = vec4(a_position,0.0,1.0);',
      ' ',
      '   // pass the texCoord to the fragment shader',
      '   v_texCoord = a_texCoord;',
      '}'
    ].join('\n');
    var gradientResponseFS;

    var patchResponseVS;
    var patchResponseFS;

    var drawResponsesVS = [
      'attribute vec2 a_texCoord_draw;',
      'attribute vec2 a_position_draw;',
      'attribute float a_patchChoice_draw;',
      '',
      'uniform vec2 u_resolutiondraw;',
      '',
      'varying vec2 v_texCoord;',
      'varying float v_select;',
      '',
      'void main() {',
      '   // convert the rectangle from pixels to 0.0 to 1.0',
      '   vec2 zeroToOne = a_position_draw / u_resolutiondraw;',
      '',
      '   // convert from 0->1 to 0->2',
      '   vec2 zeroToTwo = zeroToOne * 2.0;',
      '',
      '   // convert from 0->2 to -1->+1 (clipspace)',
      '   vec2 clipSpace = zeroToTwo - 1.0;',
      '   ',
      '   // transform coordinates to regular coordinates',
      '   gl_Position = vec4(clipSpace * vec2(1.0, 1.0), 0, 1);',
      '',
      '   // pass the texCoord to the fragment shader',
      '   v_texCoord = a_texCoord_draw;',
      '   ',
      '   v_select = a_patchChoice_draw;',
      '}'
    ].join('\n');

    var drawResponsesFS = [
      'precision mediump float;',
      '',
      '// our responses',
      'uniform sampler2D u_responses;',
      '',
      '// the texCoords passed in from the vertex shader.',
      'varying vec2 v_texCoord;',
      'varying float v_select;',
      '',
      'const vec4 bit_shift = vec4(256.0*256.0*256.0, 256.0*256.0, 256.0, 1.0);',
      'const vec4 bit_mask  = vec4(0.0, 1.0/256.0, 1.0/256.0, 1.0/256.0);',
      '',
      '// packing code from here http://stackoverflow.com/questions/9882716/packing-float-into-vec4-how-does-this-code-work',
      'void main() {',
      '  vec4 colorSum = texture2D(u_responses, v_texCoord);',
      '  float value = 0.0;',
      '  if (v_select < 0.1) {',
      '    value = colorSum[0];',
      '  } else if (v_select > 0.9 && v_select < 1.1) {',
      '    value = colorSum[1];',
      '  } else if (v_select > 1.9 && v_select < 2.1) {',
      '    value = colorSum[2];',
      '  } else if (v_select > 2.9 && v_select < 3.1) {',
      '    value = colorSum[3];',
      '  } else {',
      '    value = 1.0;',
      '  }',
      '  ',
      '  vec4 res = fract(value * bit_shift);',
      '  res -= res.xxyz * bit_mask;',
      '  ',
      '  //gl_FragColor = vec4(value, value, value, value);',
      '  //gl_FragColor = vec4(1.0, value, 1.0, 1.0);',
      '  gl_FragColor = res;',
      '}'
    ].join('\n');

    this.init = function(filters, bias, nP, pW, pH, fW, fH) {
      // we assume filterVector goes from left to right, rowwise, i.e. row-major order

      if (fW != fH) {
        alert('filter width and height must be same size!');
        return;
      }

      // if filter width is not odd, alert
      if (fW % 2 == 0 || fH % 2 == 0) {
        alert('filters used in svm must be of odd dimensions!');
        return;
      }

      // setup variables
      biases = bias;
      filterWidth = fW;
      filterHeight = fH;
      patchWidth = pW;
      patchHeight = pH;
      numPatches = nP;
      numBlocks = Math.floor(numPatches / 4) + Math.ceil((numPatches % 4)/4);
      canvasWidth = patchWidth;
      canvasHeight = patchHeight*numBlocks;
      newCanvasWidth = patchWidth-filterWidth+1;
      newCanvasBlockHeight = patchHeight-filterWidth+1;
      newCanvasHeight = newCanvasBlockHeight*numPatches;
      patchCells = (Math.floor(numPatches / 4) + Math.ceil((numPatches % 4)/4));
      textureWidth = patchWidth;
      textureHeight = patchHeight*patchCells;
      patchSize = patchWidth*patchHeight;
      patchArray = new Float32Array(patchSize*patchCells*4);
      var opp = [1/patchWidth, 1/(patchHeight*numBlocks)];

      // write out shaders
      patchResponseFS = [
        'precision mediump float;',
        '',
        'const vec2 u_onePixelPatches = vec2('+(1/patchWidth).toFixed(10)+','+(1/(patchHeight*numBlocks)).toFixed(10)+');',
        'const vec2 u_onePixelFilters = vec2('+(1/filterWidth).toFixed(10)+','+(1/(filterHeight*numBlocks)).toFixed(10)+');',
        'const float u_halffilterwidth = '+((filterWidth-1.0)/2).toFixed(1)+';',
        'const float u_halffilterheight = '+((filterHeight-1.0)/2).toFixed(1)+';',
        '',
        '// our patches',
        'uniform sampler2D u_patches;',
        '// our filters',
        'uniform sampler2D u_filters;',
        '',
        '// the texCoords passed in from the vertex shader.',
        'varying vec2 v_texCoord;',
        'varying vec2 v_texCoordFilters; // this should give us correct filter',
        '',
        'void main() {',
        '  vec4 colorSum = vec4(0.0, 0.0, 0.0, 0.0);',
        '  vec4 maxn = vec4(0.0, 0.0, 0.0, 0.0);',
        '  vec4 minn = vec4(256.0, 256.0, 256.0, 256.0);',
        '  vec4 scale = vec4(0.0, 0.0, 0.0, 0.0);',
        '  vec4 patchValue = vec4(0.0, 0.0, 0.0, 0.0);',
        '  vec4 filterValue = vec4(0.0, 0.0, 0.0, 0.0);',
        '  vec4 filterTemp = vec4(0.0, 0.0, 0.0, 0.0);',
        '  for (int w = 0;w < '+filterWidth+';w++) {',
        '    for (int h = 0;h < '+filterHeight+';h++) {',
        '      patchValue = texture2D(u_patches, v_texCoord + u_onePixelPatches * vec2(float(w)-u_halffilterwidth, float(h)-u_halffilterheight));',
        '      filterValue = texture2D(u_filters, v_texCoordFilters + u_onePixelFilters * vec2(float(w)-u_halffilterwidth, float(h)-u_halffilterheight));',
        '      maxn = max(patchValue, maxn);',
        '      minn = min(patchValue, minn);',
        '      colorSum += patchValue*filterValue;',
        '      filterTemp += filterValue;',
        '    } ',
        '  }',
        '  scale = maxn-minn;',
        '  colorSum = (colorSum-(minn*filterTemp))/scale;',
        '  // logistic transformation',
        '  colorSum = 1.0/(1.0 + exp(- (colorSum) ));',
        '  gl_FragColor = colorSum;',
        '}'
      ].join('\n');

      patchResponseVS = [
        'attribute vec2 a_texCoord;',
        'attribute vec2 a_position;',
        '',
        'const vec2 u_resolution = vec2('+canvasWidth.toFixed(1)+','+canvasHeight.toFixed(1)+');',
        'const float u_patchHeight = '+(1/numBlocks).toFixed(10)+';',
        'const float u_filterHeight = '+(1/numBlocks).toFixed(10)+';',
        'const vec2 u_midpoint = vec2(0.5 ,'+(1/(numBlocks*2)).toFixed(10)+');',
        '',
        'varying vec2 v_texCoord;',
        'varying vec2 v_texCoordFilters;',
        '',
        'void main() {',
        '   // convert the rectangle from pixels to 0.0 to 1.0',
        '   vec2 zeroToOne = a_position / u_resolution;',
        '',
        '   // convert from 0->1 to 0->2',
        '   vec2 zeroToTwo = zeroToOne * 2.0;',
        '',
        '   // convert from 0->2 to -1->+1 (clipspace)',
        '   vec2 clipSpace = zeroToTwo - 1.0;',
        '   ',
        '   // transform coordinates to regular coordinates',
        '   gl_Position = vec4(clipSpace * vec2(1.0, 1.0), 0, 1);',
        ' ',
        '   // pass the texCoord to the fragment shader',
        '   v_texCoord = a_texCoord;',
        '   ',
        '   // set the filtertexture coordinate based on number filter to use',
        '   v_texCoordFilters = u_midpoint + vec2(0.0, u_filterHeight * floor(a_texCoord[1]/u_patchHeight));',
        '}'
      ].join('\n');

      if ('lbp' in filters) {
        // lbpResponseFragment
        lbpResponseFS = [
          'precision mediump float;',
          '',
          'uniform vec2 u_onePixelPatches;',
          '',
          '// our patches',
          'uniform sampler2D u_patches;',
          '',
          '// the texCoords passed in from the vertex shader.',
          'varying vec2 v_texCoord;',
          '',
          'void main() {',
          '  vec4 topLeft = texture2D(u_patches, v_texCoord + vec2(-'+opp[0].toFixed(5)+', -'+opp[1].toFixed(5)+'));',
          '  vec4 topMid = texture2D(u_patches, v_texCoord + vec2(0.0, -'+opp[1].toFixed(5)+'));',
          '  vec4 topRight = texture2D(u_patches, v_texCoord + vec2('+opp[0].toFixed(5)+', -'+opp[1].toFixed(5)+'));',
          '  vec4 midLeft = texture2D(u_patches, v_texCoord + vec2(-'+opp[0].toFixed(5)+', 0.0));',
          '  vec4 midMid = texture2D(u_patches, v_texCoord);',
          '  vec4 midRight = texture2D(u_patches, v_texCoord + vec2('+opp[0].toFixed(5)+', 0.0));',
          '  vec4 bottomLeft = texture2D(u_patches, v_texCoord + vec2(-'+opp[0].toFixed(5)+', '+opp[1].toFixed(5)+'));',
          '  vec4 bottomMid = texture2D(u_patches, v_texCoord + vec2(0.0, '+opp[1].toFixed(5)+'));',
          '  vec4 bottomRight = texture2D(u_patches, v_texCoord + vec2('+opp[0].toFixed(5)+', '+opp[1].toFixed(5)+'));',
          '  vec4 lbp = step(midMid, midRight)*1.0 + step(midMid, topRight)*2.0 + step(midMid, topMid)*4.0;',
          '  lbp = lbp + step(midMid, topLeft)*8.0 + step(midMid, midLeft)*16.0 + step(midMid, bottomLeft)*32.0;',
          '  lbp = lbp + step(midMid, bottomMid)*64.0 + step(midMid, bottomRight)*128.0;',
          '  gl_FragColor = lbp;',
          '}'
        ].join('\n');
      }

      if ('sobel' in filters) {
        // gradResponseFragment
        gradientResponseFS = [
          'precision mediump float;',
          '',
          'uniform vec2 u_onePixelPatches;',
          '',
          '// our patches',
          'uniform sampler2D u_patches;',
          '',
          '// the texCoords passed in from the vertex shader.',
          'varying vec2 v_texCoord;',
          '',
          'void main() {',
          '  vec4 bottomLeft = texture2D(u_patches, v_texCoord + vec2(-'+opp[0].toFixed(5)+', '+opp[1].toFixed(5)+'));',
          '  vec4 bottomRight = texture2D(u_patches, v_texCoord + vec2('+opp[0].toFixed(5)+', '+opp[1].toFixed(5)+'));',
          '  vec4 topLeft = texture2D(u_patches, v_texCoord + vec2(-'+opp[0].toFixed(5)+', -'+opp[1].toFixed(5)+'));',
          '  vec4 topRight = texture2D(u_patches, v_texCoord + vec2('+opp[0].toFixed(5)+', -'+opp[1].toFixed(5)+'));',
          '  vec4 dx = (',
          '    bottomLeft +',
          '    (texture2D(u_patches, v_texCoord + vec2(-'+opp[0].toFixed(5)+', 0.0))*vec4(2.0,2.0,2.0,2.0)) +',
          '    topLeft -',
          '    bottomRight -',
          '    (texture2D(u_patches, v_texCoord + vec2('+opp[0].toFixed(5)+', 0.0))*vec4(2.0,2.0,2.0,2.0)) -',
          '    topRight)/4.0;',
          '  vec4 dy = (',
          '    bottomLeft +',
          '    (texture2D(u_patches, v_texCoord + vec2(0.0, '+opp[1].toFixed(5)+'))*vec4(2.0,2.0,2.0,2.0)) +',
          '    bottomRight -',
          '    topLeft -',
          '    (texture2D(u_patches, v_texCoord + vec2(0.0, -'+opp[1].toFixed(5)+'))*vec4(2.0,2.0,2.0,2.0)) -',
          '    topRight)/4.0;',
          '  vec4 gradient = sqrt((dx*dx) + (dy*dy));',
          '  gl_FragColor = gradient;',
          '}'
        ].join('\n');
      }

      //create webglcanvas
      canvas = document.createElement('canvas');
      canvas.setAttribute('width', (patchWidth-filterWidth+1)+'px');
      canvas.setAttribute('height', ((patchHeight-filterHeight+1)*numPatches)+'px');
      canvas.setAttribute('id', 'renderCanvas');
      canvas.setAttribute('style', 'display:none;');
      //document.body.appendChild(canvas);
      gl = webglUtils_1(canvas, {
        premultipliedAlpha: false,
        preserveDrawingBuffer : true,
        antialias : false
      });


      // check for float textures support and fail if not
      if (!gl.getExtension('OES_texture_float')) {
        alert('Your graphics card does not support floating point textures! :(');
        return;
      }

      /** insert filters into textures **/
      if ('raw' in filters) {
        insertFilter(filters['raw'], gl.TEXTURE0);
        rawInit = true;
      }
      if ('sobel' in filters) {
        insertFilter(filters['sobel'], gl.TEXTURE4);
        sobelInit = true;
      }
      if ('lbp' in filters) {
        insertFilter(filters['lbp'], gl.TEXTURE5);
        lbpInit = true;
      }

      /** calculate vertices for calculating responses **/

        // vertex rectangles to draw out
      var rectangles = [];
      var halfFilter = (filterWidth-1)/2;
      var yOffset;
      for (var i = 0;i < numBlocks;i++) {
        yOffset = i*patchHeight;
        //first triangle
        rectangles = rectangles.concat([
          halfFilter, yOffset+halfFilter,
          patchWidth-halfFilter, yOffset+halfFilter,
          halfFilter, yOffset+patchHeight-halfFilter
        ]);
        //second triangle
        rectangles = rectangles.concat([
          halfFilter, yOffset+patchHeight-halfFilter,
          patchWidth-halfFilter, yOffset+halfFilter,
          patchWidth-halfFilter, yOffset+patchHeight-halfFilter
        ]);
      }
      rectangles = new Float32Array(rectangles);

      // image rectangles to draw out
      var irectangles = [];
      for (var i = 0;i < rectangles.length;i++) {
        if (i % 2 == 0) {
          irectangles[i] = rectangles[i]/canvasWidth;
        } else {
          irectangles[i] = rectangles[i]/canvasHeight;
        }
      }
      irectangles = new Float32Array(irectangles);

      if ('lbp' in filters || 'sobel' in filters) {
        var topCoord = 1.0 - 2/(patchHeight*numBlocks);
        var bottomCoord = 1.0 - 2/numBlocks + 2/(patchHeight*numBlocks);
        var yOffset;
        // calculate position of vertex rectangles for gradient/lbp program
        var gradRectangles = [];
        for (var i = 0;i < numBlocks;i++) {
          yOffset = i * (2/numBlocks);
          //first triangle
          gradRectangles = gradRectangles.concat([
            -1.0, topCoord - yOffset,
            1.0, topCoord - yOffset,
            -1.0, bottomCoord - yOffset
          ]);
          //second triangle
          gradRectangles = gradRectangles.concat([
            -1.0, bottomCoord - yOffset,
            1.0, topCoord - yOffset,
            1.0, bottomCoord - yOffset
          ]);
        }
        gradRectangles = new Float32Array(gradRectangles);

        topCoord = 1.0 - 1/(patchHeight*numBlocks);
        bottomCoord = 1.0 - 1/numBlocks + 1/(patchHeight*numBlocks);
        // calculate position of image rectangles to draw out
        var gradIRectangles = [];
        for (var i = 0;i < numBlocks;i++) {
          yOffset = i * (1/numBlocks);
          //first triangle
          gradIRectangles = gradIRectangles.concat([
            0.0, topCoord - yOffset,
            1.0, topCoord - yOffset,
            0.0, bottomCoord - yOffset
          ]);
          //second triangle
          gradIRectangles = gradIRectangles.concat([
            0.0, bottomCoord - yOffset,
            1.0, topCoord - yOffset,
            1.0, bottomCoord - yOffset
          ]);
        }
        gradIRectangles = new Float32Array(gradIRectangles);
      }

      // vertices for drawing out responses

      // drawOutRectangles
      drawOutRectangles = new Float32Array(12*numPatches);
      var yOffset, indexOffset;
      for (var i = 0;i < numPatches;i++) {
        yOffset = i*newCanvasBlockHeight;
        indexOffset = i*12;

        //first triangle
        drawOutRectangles[indexOffset] = 0.0;
        drawOutRectangles[indexOffset+1] = yOffset;
        drawOutRectangles[indexOffset+2] = newCanvasWidth;
        drawOutRectangles[indexOffset+3] = yOffset;
        drawOutRectangles[indexOffset+4] = 0.0;
        drawOutRectangles[indexOffset+5] = yOffset+newCanvasBlockHeight;

        //second triangle
        drawOutRectangles[indexOffset+6] = 0.0;
        drawOutRectangles[indexOffset+7] = yOffset+newCanvasBlockHeight;
        drawOutRectangles[indexOffset+8] = newCanvasWidth;
        drawOutRectangles[indexOffset+9] = yOffset;
        drawOutRectangles[indexOffset+10] = newCanvasWidth;
        drawOutRectangles[indexOffset+11] = yOffset+newCanvasBlockHeight;
      }

      // images
      drawOutImages = new Float32Array(numPatches*12);
      var halfFilterWidth = ((filterWidth-1)/2)/patchWidth;
      var halfFilterHeight = ((filterWidth-1)/2)/(patchHeight*patchCells);
      var patchHeightT = patchHeight / (patchHeight*patchCells);
      for (var i = 0;i < numPatches;i++) {
        yOffset = Math.floor(i / 4)*patchHeightT;
        indexOffset = i*12;

        //first triangle
        drawOutImages[indexOffset] = halfFilterWidth;
        drawOutImages[indexOffset+1] = yOffset+halfFilterHeight;
        drawOutImages[indexOffset+2] = 1.0-halfFilterWidth;
        drawOutImages[indexOffset+3] = yOffset+halfFilterHeight;
        drawOutImages[indexOffset+4] = halfFilterWidth;
        drawOutImages[indexOffset+5] = yOffset+patchHeightT-halfFilterHeight;

        //second triangle
        drawOutImages[indexOffset+6] = halfFilterWidth;
        drawOutImages[indexOffset+7] = yOffset+patchHeightT-halfFilterHeight;
        drawOutImages[indexOffset+8] = 1.0-halfFilterWidth;
        drawOutImages[indexOffset+9] = yOffset+halfFilterHeight;
        drawOutImages[indexOffset+10] = 1.0-halfFilterWidth;
        drawOutImages[indexOffset+11] = yOffset+patchHeightT-halfFilterHeight;
      }

      // layer
      drawOutLayer = new Float32Array(numPatches*6);
      var layernum;
      for (var i = 0;i < numPatches;i++) {
        layernum = i % 4;
        indexOffset = i*6;
        drawOutLayer[indexOffset] = layernum;
        drawOutLayer[indexOffset+1] = layernum;
        drawOutLayer[indexOffset+2] = layernum;
        drawOutLayer[indexOffset+3] = layernum;
        drawOutLayer[indexOffset+4] = layernum;
        drawOutLayer[indexOffset+5] = layernum;
      }

      /** set up programs and load attributes etc **/

      if ('sobel' in filters) {
        var grVertexShader = webglUtils_5(gl, gradientResponseVS, gl.VERTEX_SHADER);
        var grFragmentShader = webglUtils_5(gl, gradientResponseFS, gl.FRAGMENT_SHADER);
        gradientResponseProgram = webglUtils_2(gl, [grVertexShader, grFragmentShader]);
        gl.useProgram(gradientResponseProgram);

        // set up vertices with rectangles
        gradPositionLocation = gl.getAttribLocation(gradientResponseProgram, 'a_position');
        gradAPositionBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, gradAPositionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, gradRectangles, gl.STATIC_DRAW);
        gl.enableVertexAttribArray(gradPositionLocation);
        gl.vertexAttribPointer(gradPositionLocation, 2, gl.FLOAT, false, 0, 0);

        // set up texture positions
        gradTexCoordLocation = gl.getAttribLocation(gradientResponseProgram, 'a_texCoord');
        gradTexCoordBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, gradTexCoordBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, gradIRectangles, gl.STATIC_DRAW);
        gl.enableVertexAttribArray(gradTexCoordLocation);
        gl.vertexAttribPointer(gradTexCoordLocation, 2, gl.FLOAT, false, 0, 0);

        // set up patches texture in gradientResponseProgram
        gl.uniform1i(gl.getUniformLocation(gradientResponseProgram, 'u_patches'), 1);
      }
      if ('lbp' in filters) {
        var lbpVertexShader = webglUtils_5(gl, lbpResponseVS, gl.VERTEX_SHADER);
        var lbpFragmentShader = webglUtils_5(gl, lbpResponseFS, gl.FRAGMENT_SHADER);
        lbpResponseProgram = webglUtils_2(gl, [lbpVertexShader, lbpFragmentShader]);
        gl.useProgram(lbpResponseProgram);

        // set up vertices with rectangles
        lbpPositionLocation = gl.getAttribLocation(lbpResponseProgram, 'a_position');
        lbpAPositionBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, lbpAPositionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, gradRectangles, gl.STATIC_DRAW);
        gl.enableVertexAttribArray(lbpPositionLocation);
        gl.vertexAttribPointer(lbpPositionLocation, 2, gl.FLOAT, false, 0, 0);

        // set up texture positions
        gradTexCoordLocation = gl.getAttribLocation(lbpResponseProgram, 'a_texCoord');
        lbpTexCoordBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, lbpTexCoordBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, gradIRectangles, gl.STATIC_DRAW);
        gl.enableVertexAttribArray(lbpTexCoordLocation);
        gl.vertexAttribPointer(lbpTexCoordLocation, 2, gl.FLOAT, false, 0, 0);

        // set up patches texture in lbpResponseProgram
        gl.uniform1i(gl.getUniformLocation(lbpResponseProgram, 'u_patches'), 1);
      }

      // setup patchdraw program
      var drVertexShader = webglUtils_5(gl, drawResponsesVS, gl.VERTEX_SHADER);
      var drFragmentShader = webglUtils_5(gl, drawResponsesFS, gl.FRAGMENT_SHADER);
      patchDrawProgram = webglUtils_2(gl, [drVertexShader, drFragmentShader]);
      gl.useProgram(patchDrawProgram);

      // set the resolution/dimension of the canvas
      var resolutionLocation = gl.getUniformLocation(patchDrawProgram, 'u_resolutiondraw');
      gl.uniform2f(resolutionLocation, newCanvasWidth, newCanvasHeight);

      // set u_responses
      var responsesLocation = gl.getUniformLocation(patchDrawProgram, 'u_responses');
      gl.uniform1i(responsesLocation, 2);

      // setup patchresponse program
      var prVertexShader = webglUtils_5(gl, patchResponseVS, gl.VERTEX_SHADER);
      var prFragmentShader = webglUtils_5(gl, patchResponseFS, gl.FRAGMENT_SHADER);
      patchResponseProgram = webglUtils_2(gl, [prVertexShader, prFragmentShader]);
      gl.useProgram(patchResponseProgram);

      // set up vertices with rectangles
      var positionLocation = gl.getAttribLocation(patchResponseProgram, 'a_position');
      apositionBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, apositionBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, rectangles, gl.STATIC_DRAW);
      gl.enableVertexAttribArray(positionLocation);
      gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

      // set up texture positions
      texCoordLocation = gl.getAttribLocation(patchResponseProgram, 'a_texCoord');
      texCoordBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, irectangles, gl.STATIC_DRAW);
      gl.enableVertexAttribArray(texCoordLocation);
      gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);

      if ('lbp' in filters || 'sobel' in filters) {
        // set up gradient/lbp buffer (also used for lbp)
        gl.activeTexture(gl.TEXTURE3);
        var gradients = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, gradients);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, patchWidth, patchHeight*numBlocks, 0, gl.RGBA, gl.FLOAT, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);

        // set up gradient/lbp framebuffer
        gbo = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, gbo);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, gradients, 0);
      }

      // set up buffer to draw to
      gl.activeTexture(gl.TEXTURE2);
      rttTexture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, rttTexture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, patchWidth, patchHeight*numBlocks, 0, gl.RGBA, gl.FLOAT, null);

      // set up response framebuffer
      fbo = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, rttTexture, 0);

      gl.viewport(0, 0, patchWidth, patchHeight*numBlocks);

      /* initialize some textures and buffers used later on */

      patchTex = gl.createTexture();
      drawRectBuffer = gl.createBuffer();
      drawImageBuffer = gl.createBuffer();
      drawLayerBuffer = gl.createBuffer();
    };

    this.getRawResponses = function(patches) {
      // TODO: check patches correct length/dimension

      insertPatches(patches);

      // switch to correct program
      gl.useProgram(patchResponseProgram);

      // set u_patches to point to texture 1
      gl.uniform1i(gl.getUniformLocation(patchResponseProgram, 'u_patches'), 1);

      // set u_filters to point to correct filter
      gl.uniform1i(gl.getUniformLocation(patchResponseProgram, 'u_filters'), 0);

      // set up vertices with rectangles
      var positionLocation = gl.getAttribLocation(patchResponseProgram, 'a_position');
      gl.bindBuffer(gl.ARRAY_BUFFER, apositionBuffer);
      gl.enableVertexAttribArray(positionLocation);
      gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

      // set up texture positions
      var texCoordLocation = gl.getAttribLocation(patchResponseProgram, 'a_texCoord');
      gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
      gl.enableVertexAttribArray(texCoordLocation);
      gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);

      // set framebuffer to the original one if not already using it
      gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);

      gl.viewport(0, 0, patchWidth, patchHeight*numBlocks);

      gl.clearColor(0.0, 0.0, 0.0, 1.0);
      gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER);

      // draw to framebuffer
      gl.drawArrays(gl.TRIANGLES, 0, patchCells*6);

      //gl.finish();

      var responses = drawOut('raw');

      return responses;
    };

    this.getSobelResponses = function(patches) {
      // check that it is initialized
      if (!sobelInit) return;

      insertPatches(patches);

      /* do sobel filter on patches */

      // switch to correct program
      gl.useProgram(gradientResponseProgram);

      // set up vertices with rectangles
      var gradPositionLocation = gl.getAttribLocation(gradientResponseProgram, 'a_position');
      gl.bindBuffer(gl.ARRAY_BUFFER, gradAPositionBuffer);
      gl.enableVertexAttribArray(gradPositionLocation);
      gl.vertexAttribPointer(gradPositionLocation, 2, gl.FLOAT, false, 0, 0);

      // set up texture positions
      var gradTexCoordLocation = gl.getAttribLocation(gradientResponseProgram, 'a_texCoord');
      gl.bindBuffer(gl.ARRAY_BUFFER, gradTexCoordBuffer);
      gl.enableVertexAttribArray(gradTexCoordLocation);
      gl.vertexAttribPointer(gradTexCoordLocation, 2, gl.FLOAT, false, 0, 0);

      // set framebuffer to the original one if not already using it
      gl.bindFramebuffer(gl.FRAMEBUFFER, gbo);

      gl.viewport(0, 0, patchWidth, patchHeight*numBlocks);

      gl.clearColor(0.0, 0.0, 0.0, 1.0);
      gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER);

      // draw to framebuffer
      gl.drawArrays(gl.TRIANGLES, 0, patchCells*6);

      /* calculate responses */

      gl.useProgram(patchResponseProgram);

      // set patches and filters to point to correct textures
      gl.uniform1i(gl.getUniformLocation(patchResponseProgram, 'u_filters'), 4);
      gl.uniform1i(gl.getUniformLocation(patchResponseProgram, 'u_patches'), 3);

      var positionLocation = gl.getAttribLocation(patchResponseProgram, 'a_position');
      gl.bindBuffer(gl.ARRAY_BUFFER, apositionBuffer);
      gl.enableVertexAttribArray(positionLocation);
      gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

      // set up texture positions
      var texCoordLocation = gl.getAttribLocation(patchResponseProgram, 'a_texCoord');
      gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
      gl.enableVertexAttribArray(texCoordLocation);
      gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);

      gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
      gl.viewport(0, 0, patchWidth, patchHeight*numBlocks);

      gl.clearColor(0.0, 0.0, 0.0, 1.0);
      gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER);

      // draw to framebuffer
      gl.drawArrays(gl.TRIANGLES, 0, patchCells*6);

      /* get the responses */

      var responses = drawOut('sobel');

      return responses;
    };

    this.getLBPResponses = function(patches) {
      // check that it is initialized
      if (!lbpInit) return;

      insertPatches(patches);

      /* do sobel filter on patches */

      // switch to correct program
      gl.useProgram(lbpResponseProgram);

      // set up vertices with rectangles
      var lbpPositionLocation = gl.getAttribLocation(lbpResponseProgram, 'a_position');
      gl.bindBuffer(gl.ARRAY_BUFFER, lbpAPositionBuffer);
      gl.enableVertexAttribArray(lbpPositionLocation);
      gl.vertexAttribPointer(lbpPositionLocation, 2, gl.FLOAT, false, 0, 0);

      // set up texture positions
      var lbpTexCoordLocation = gl.getAttribLocation(lbpResponseProgram, 'a_texCoord');
      gl.bindBuffer(gl.ARRAY_BUFFER, lbpTexCoordBuffer);
      gl.enableVertexAttribArray(lbpTexCoordLocation);
      gl.vertexAttribPointer(lbpTexCoordLocation, 2, gl.FLOAT, false, 0, 0);

      // set framebuffer to the original one if not already using it
      gl.bindFramebuffer(gl.FRAMEBUFFER, gbo);

      gl.viewport(0, 0, patchWidth, patchHeight*numBlocks);

      gl.clearColor(0.0, 0.0, 0.0, 1.0);
      gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER);

      // draw to framebuffer
      gl.drawArrays(gl.TRIANGLES, 0, patchCells*6);

      /* calculate responses */

      gl.useProgram(patchResponseProgram);

      gl.uniform1i(gl.getUniformLocation(patchResponseProgram, 'u_filters'), 5);
      gl.uniform1i(gl.getUniformLocation(patchResponseProgram, 'u_patches'), 3);

      var positionLocation = gl.getAttribLocation(patchResponseProgram, 'a_position');
      gl.bindBuffer(gl.ARRAY_BUFFER, apositionBuffer);
      gl.enableVertexAttribArray(positionLocation);
      gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

      // set up texture positions
      var texCoordLocation = gl.getAttribLocation(patchResponseProgram, 'a_texCoord');
      gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
      gl.enableVertexAttribArray(texCoordLocation);
      gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);

      gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
      gl.viewport(0, 0, patchWidth, patchHeight*numBlocks);

      gl.clearColor(0.0, 0.0, 0.0, 1.0);
      gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER);

      // draw to framebuffer
      gl.drawArrays(gl.TRIANGLES, 0, patchCells*6);

      /* get the responses */

      var responses = drawOut('lbp');

      return responses;
    };

    var insertPatches = function(patches) {
      // pass patches into texture, each patch in either r, g, b or a
      var patchArrayIndex = 0;
      var patchesIndex1 = 0;
      var patchesIndex2 = 0;
      for (var i = 0;i < patchCells;i++) {
        for (var j = 0;j < patchHeight;j++) {
          for (var k = 0;k < patchWidth;k++) {
            patchesIndex1 = i*4;
            patchesIndex2 = (j*patchWidth) + k;
            patchArrayIndex = ((patchSize*i) + patchesIndex2)*4;

            //set r with first patch
            if (patchesIndex1 < numPatches) {
              patchArray[patchArrayIndex] = patches[patchesIndex1][patchesIndex2];
            } else {
              patchArray[patchArrayIndex] = 0;
            }
            //set g with 2nd patch
            if (patchesIndex1+1 < numPatches) {
              patchArray[patchArrayIndex + 1] = patches[patchesIndex1+1][patchesIndex2];
            } else {
              patchArray[patchArrayIndex + 1] = 0;
            }
            //set b with 3rd patch
            if (patchesIndex1+2 < numPatches) {
              patchArray[patchArrayIndex + 2] = patches[patchesIndex1+2][patchesIndex2];
            } else {
              patchArray[patchArrayIndex + 2] = 0;
            }
            //set a with 4th patch
            if (patchesIndex1+3 < numPatches) {
              patchArray[patchArrayIndex + 3] = patches[patchesIndex1+3][patchesIndex2];
            } else {
              patchArray[patchArrayIndex + 3] = 0;
            }
          }
        }
      }

      // pass texture into an uniform
      gl.activeTexture(gl.TEXTURE1);
      gl.bindTexture(gl.TEXTURE_2D, patchTex);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, textureWidth, textureHeight, 0, gl.RGBA, gl.FLOAT, patchArray);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    };

    var insertFilter = function(filter, textureNum) {
      var filterSize = filterWidth*filterHeight;
      var filterArray = new Float32Array(filterSize*(numBlocks)*4);
      for (var i = 0;i < numBlocks;i++) {
        for (var j = 0;j < filterHeight;j++) {
          for (var k = 0;k < filterWidth;k++) {
            //set r with first filter
            if (i*4 < filter.length) {
              filterArray[((filterSize*i) + (j*filterWidth) + k)*4] = filter[i*4][(j*filterWidth) + k];
            } else {
              filterArray[((filterSize*i) + (j*filterWidth) + k)*4] = 0;
            }
            //set g with 2nd filter
            if ((i*4 + 1) < filter.length) {
              filterArray[((filterSize*i) + (j*filterWidth) + k)*4 + 1] = filter[(i*4)+1][(j*filterWidth) + k];
            } else {
              filterArray[((filterSize*i) + (j*filterWidth) + k)*4 + 1] = 0;
            }
            //set b with 3rd filter
            if ((i*4 + 2) < filter.length) {
              filterArray[((filterSize*i) + (j*filterWidth) + k)*4 + 2] = filter[(i*4)+2][(j*filterWidth) + k];
            } else {
              filterArray[((filterSize*i) + (j*filterWidth) + k)*4 + 2] = 0;
            }
            //set a with 4th filter
            if ((i*4 + 3) < filter.length) {
              filterArray[((filterSize*i) + (j*filterWidth) + k)*4 + 3] = filter[(i*4)+3][(j*filterWidth) + k];
            } else {
              filterArray[((filterSize*i) + (j*filterWidth) + k)*4 + 3] = 0;
            }
          }
        }
      }

      gl.activeTexture(textureNum);
      var filterTexture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, filterTexture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, filterWidth, filterHeight*numBlocks, 0, gl.RGBA, gl.FLOAT, filterArray);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    };

    var drawOut = function(type) {
      // switch programs
      gl.useProgram(patchDrawProgram);

      // bind canvas buffer
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.viewport(0, 0, newCanvasWidth, newCanvasHeight);

      gl.clearColor(0.0, 0.0, 0.0, 1.0);
      gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER);

      gl.bindBuffer(gl.ARRAY_BUFFER, drawRectBuffer);
      gl.bufferData(
        gl.ARRAY_BUFFER,
        drawOutRectangles,
        gl.STATIC_DRAW);
      var positionLocation = gl.getAttribLocation(patchDrawProgram, 'a_position_draw');
      gl.enableVertexAttribArray(positionLocation);
      gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

      gl.bindBuffer(gl.ARRAY_BUFFER, drawImageBuffer);
      gl.bufferData(
        gl.ARRAY_BUFFER,
        drawOutImages,
        gl.STATIC_DRAW);
      var textureLocation = gl.getAttribLocation(patchDrawProgram, 'a_texCoord_draw');
      gl.enableVertexAttribArray(textureLocation);
      gl.vertexAttribPointer(textureLocation, 2, gl.FLOAT, false, 0, 0);

      gl.bindBuffer(gl.ARRAY_BUFFER, drawLayerBuffer);
      gl.bufferData(
        gl.ARRAY_BUFFER,
        drawOutLayer,
        gl.STATIC_DRAW);
      var layerLocation = gl.getAttribLocation(patchDrawProgram, 'a_patchChoice_draw');
      gl.enableVertexAttribArray(layerLocation);
      gl.vertexAttribPointer(layerLocation, 1, gl.FLOAT, false, 0, 0);

      // draw out
      gl.drawArrays(gl.TRIANGLES, 0, numPatches*6);

      var responses = getOutput();
      responses = unpackToFloat(responses);
      responses = splitArray(responses, numPatches);
      responses = addBias(responses, biases[type]);

      // normalize responses to lie within [0,1]
      var rl = responses.length;
      for (var i = 0;i < rl;i++) {
        responses[i] = normalizeFilterMatrix(responses[i]);
      }

      return responses;
    };

    var addBias = function(responses, bias) {
      // do a little trick to add bias in the logit function
      var biasMult;
      for (var i = 0;i < responses.length;i++) {
        biasMult = Math.exp(bias[i]);
        for (var j = 0;j < responses[i].length;j++) {
          responses[i][j] = 1/(1+((1-responses[i][j])/(responses[i][j]*biasMult)));
        }
      }
      return responses;
    };

    var splitArray = function(array, parts) {
      var sp = [];
      var al = array.length;
      var splitlength = al/parts;
      var ta = [];
      for (var i = 0;i < al;i++) {
        if (i % splitlength == 0) {
          if (i != 0) {
            sp.push(ta);
          }
          ta = [];
        }
        ta.push(array[i]);
      }
      sp.push(ta);
      return sp;
    };

    var getOutput = function() {
      // get data
      var pixelValues = new Uint8Array(4*canvas.width*canvas.height);
      gl.readPixels(0, 0, canvas.width, canvas.height, gl.RGBA, gl.UNSIGNED_BYTE, pixelValues);
      return pixelValues;
    };

    var unpackToFloat = function(array) {
      // convert packed floats to proper floats : see http://stackoverflow.com/questions/9882716/packing-float-into-vec4-how-does-this-code-work
      var newArray = [];
      var al = array.length;
      for (var i = 0;i < al;i+=4) {
        newArray[(i / 4) >> 0] = ((array[i]/(256*256*256*256))+(array[i+1]/(256*256*256))+(array[i+2]/(256*256))+(array[i+3]/256));
      }
      return newArray;
    };

    var normalizeFilterMatrix = function(response) {
      // normalize responses to lie within [0,1]
      var msize = response.length;
      var max = 0;
      var min = 1;

      for (var i = 0;i < msize;i++) {
        max = response[i] > max ? response[i] : max;
        min = response[i] < min ? response[i] : min;
      }
      var dist = max-min;

      if (dist == 0) {
        //console.log('a patchresponse was monotone, causing normalization to fail. Leaving it unchanged.');
        response = response.map(function() {return 1});
      } else {
        for (var i = 0;i < msize;i++) {
          response[i] = (response[i]-min)/dist;
        }
      }

      return response;
    };
  };

  var mosseFilterResponses = function() {

    var filters = [];
    var responses = [];
    var num_Patches = 0;

    this.init = function(filter_input, numPatches, filterWidth, filterHeight) {
      // load filters, make fft ready

      for (var i = 0;i < numPatches;i++) {
        var temp = {};
        temp.width = filterWidth;
        temp.height = filterHeight;
        var filterLength = filterWidth*filterHeight;
        var flar_fi0 = new Float64Array(filterLength);
        var flar_fi1 = new Float64Array(filterLength);
        for (var j = 0;j < filterLength;j++) {
          flar_fi0[j] = filter_input[i][0][j];
          flar_fi1[j] = filter_input[i][1][j];
        }
        temp.real = flar_fi0;
        temp.imag = flar_fi1;
        filters[i] = new mosse.mosseFilter();
        filters[i].load(temp);
      }

      num_Patches = numPatches;
    };

    this.getResponses = function(patches) {
      for (var i = 0;i < num_Patches;i++) {
        responses[i] = filters[i].getResponse(patches[i]);
        //responses[i] = logisticResponse(responses[i]);
        responses[i] = normalizeFilterMatrix(responses[i]);
      }

      return responses;
    };

    var logisticResponse = function(response) {
      // create probability by doing logistic transformation
      var filter_size = response.length;
      for (var j = 0;j < filter_size;j++) {
        response[j] = 1.0/(1.0 + Math.exp(- (response[j]-1.0) ));
      }
      return response;
    };

    var normalizeFilterMatrix = function(response) {
      // normalize responses to lie within [0,1]
      var msize = response.length;
      var max = 0;
      var min = 1;

      for (var i = 0;i < msize;i++) {
        max = response[i] > max ? response[i] : max;
        min = response[i] < min ? response[i] : min;
      }
      var dist = max-min;

      if (dist == 0) {
        console.log('a patchresponse was monotone, causing normalization to fail. Leaving it unchanged.');
        response = response.map(function() {return 1});
      } else {
        for (var i = 0;i < msize;i++) {
          response[i] = (response[i]-min)/dist;
        }
      }

      return response;
    };
  };

  var model_pca_20_svm = createCommonjsModule(function (module, exports) {
    (function (global) {
      'use strict';

      var pModel = {
        "scoring": {
          "size": [20, 22],
          "bias": -1.3971,
          "coef": [-0.019443, -0.0084627, -0.005644, -0.0030633, 0.0050582, 0.0038672, 0.0073781, 0.0084088, 0.002108, 0.0088022, 0.0084634, 0.0091342, 0.0021678, 0.0057906, 0.010027, 0.010018, 0.011075, -0.00061696, -0.006084, -0.0094488, -0.012441, -0.003865, -0.0003105, 0.0031879, 0.0078183, 0.01096, 0.012101, 0.012289, 0.012872, 0.01342, 0.012863, 0.01257, 0.014429, 0.013339, 0.013248, 0.012998, 0.0080562, 0.001467, -0.011928, -0.0097909, -0.019951, -0.014602, -0.013175, -0.0060515, -0.0010407, 0.0054651, 0.010449, 0.014061, 0.015918, 0.016361, 0.021757, 0.017301, 0.014195, 0.012452, 0.010454, 0.0040883, -0.0014194, -0.0038499, -0.01077, -0.011758, -0.0046927, -0.0022134, -0.0039804, -0.012187, -0.011887, -0.0081984, 0.0028354, 0.007082, 0.012238, 0.016348, 0.02098, 0.017313, 0.011865, 0.0072371, 0.0028788, -0.0074673, -0.012293, -0.014834, -0.0083886, -0.0012772, -0.0043238, -0.00079996, -0.0090447, -0.015715, -0.016374, -0.018048, -0.012034, -0.007243, 0.00051252, 0.013092, 0.01857, 0.013099, 0.00085916, -0.0064555, -0.014574, -0.018222, -0.01806, -0.016666, -0.016743, -0.012862, -0.037409, -0.02683, -0.036693, -0.034788, -0.021885, -0.024485, -0.028069, -0.018632, 0.00033863, 0.015591, 0.021179, 0.015184, 0.0029429, -0.014375, -0.025568, -0.025718, -0.023219, -0.043064, -0.042245, -0.040561, -0.029282, -0.037097, -0.050209, -0.043175, -0.038799, -0.037913, -0.024597, -0.013392, 0.0026176, 0.01616, 0.02195, 0.018825, 0.0069274, -0.00671, -0.018259, -0.03115, -0.030987, -0.033628, -0.043437, -0.034535, -0.0027688, -0.0045493, -0.0029637, -0.0034067, -0.0058159, -0.0050003, -0.0052189, -0.0035094, 0.0048076, 0.01523, 0.017877, 0.01506, 0.0068301, -0.00074735, -0.0047129, -0.0020172, -0.0028734, -3.2165e-05, 0.0052576, 0.0043529, 0.016946, 0.015931, 0.013752, 0.01013, 0.0080481, 0.006654, 0.0068325, 0.0069577, 0.0040399, 0.011715, 0.01744, 0.014274, 0.0061486, 0.0064501, 0.0064155, 0.0087973, 0.0085371, 0.0087282, 0.011783, 0.016747, 0.022118, 0.020836, 0.018312, 0.015898, 0.017833, 0.015566, 0.014049, 0.0092416, 0.0081518, 0.011231, 0.012568, 0.012112, 0.0098382, 0.0073612, 0.0095541, 0.011728, 0.018126, 0.019469, 0.017399, 0.021144, 0.021132, 0.019499, 0.019593, 0.020281, 0.017451, 0.014159, 0.0062291, 0.0038367, 0.0070206, 0.0096561, 0.011406, 0.0073274, 0.0046726, 0.0052536, 0.00018758, 0.0081524, 0.01276, 0.0216, 0.023303, 0.023746, 0.018231, 0.020013, 0.019842, 0.0188, 0.010638, 0.00047498, -0.0071779, -0.0013493, 0.0015382, 0.0026092, 0.00054047, -0.00049664, -0.00046203, -0.005244, -0.0052152, -0.010003, 0.0014386, 0.012845, 0.020828, 0.023738, 0.015717, 0.016381, 0.014903, 0.007373, 0.0019356, -0.0062, -0.0091165, -0.008811, -0.01485, -0.0020888, 0.0052141, 0.0010527, -0.010322, -0.016208, -0.012439, -0.013087, -0.002797, 0.0023632, 0.011157, 0.018369, 0.0095224, 0.010552, 0.0065611, -0.0015315, -0.0032492, -0.003133, -0.00092774, -0.0020969, -0.0027526, 0.00094388, 5.9164e-05, -0.0017255, -0.0034421, -0.0045774, -0.0025305, -0.00038216, 0.00057079, 0.0031326, 0.0060238, 0.011585, 0.0016263, 0.0032288, 0.0012533, 0.00062748, 0.0023767, 0.0028182, 0.0023771, -0.0033403, -0.0048954, 0.0030747, 0.0062649, 0.0050231, 0.00044658, -0.0048271, -0.0040237, 0.0024988, 0.005458, 0.007288, 0.003601, 0.010569, -0.0045837, 0.00057936, 0.0010299, 0.0030015, 0.0036675, 0.0044718, 0.0068927, 0.0039124, 0.0071394, 0.010304, 0.012609, 0.0089589, 0.0086038, 0.0055408, 0.0046722, 0.0047921, 0.0058818, 0.0056047, 0.0054112, 0.0073265, -0.0027342, -0.0027247, -0.00349, -0.0079957, -0.0040761, -0.0020778, -0.0028479, -0.0039663, -0.0026161, 0.00092611, 0.0017427, 0.00055187, -0.0013723, -0.0045996, -0.0042015, -0.0054722, -0.0023417, -0.0025441, -0.0078778, 5.3403e-05, 0.0046873, 0.0021888, 0.0013036, -0.0013698, -0.015805, -0.016268, -0.018901, -0.017659, -0.011813, -0.0034436, -0.0023483, -0.0050111, -0.0050922, -0.015031, -0.020198, -0.021621, -0.018586, -0.018724, -0.0055723, 0.006448, 0.0026823, 0.006001, 0.0039986, 0.0050813, -0.0059114, -0.027746, -0.029251, -0.023067, -0.01721, -0.015963, -0.021075, -0.023667, -0.020006, -0.019063, -0.017792, -0.025323, -0.020971, -0.0034366, 0.0043351, 0.0084557, -0.0063213, -0.0012841, -0.001235, 0.004021, 0.0092275, 0.0045265, 0.0041316, 0.00077108, 0.0017581, -0.0011577, -0.0036195, -0.003732, -0.0016662, 0.0031111, 0.0014907, 0.0048443, 0.0059991, 0.0084751, 0.0055827, 0.0025145, -0.0046319, -0.0076183, -0.0046594, -0.0031254, 0.0074653, 0.010126, 0.0094747, 0.0035658, 0.0057834, 0.0038881, 0.001996, 0.0015056, 0.0011132, 0.0054877, 0.0047366, 0.0072106, 0.010078, 0.003857, -0.0031188, 8.695e-05, -0.021441, -0.0072103, -0.0078359, -0.0059407, -0.00161, 0.005345, 0.0071049, 0.010197, 0.0057578, 0.0074571, 0.0062731, 0.0076242, 0.0068437, 0.0070021, 0.0087251, 0.0089996, 0.0034314, -0.0019892, -0.0078966, -0.010925]
        },
        "path": {
          "normal": [
            [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
            [15, 16, 17, 18],
            [19, 20, 21, 22],
            [23, 63, 24, 64, 25, 65, 26, 66, 23],
            [28, 67, 29, 68, 30, 69, 31, 70, 28],
            [34, 35, 36, 42, 37, 43, 38, 39, 40],
            [33, 41, 62],
            [44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 44, 56, 57, 58, 50, 59, 60, 61, 44],
            27, 32
          ],
          "vertices": [
            // jawline
            [0,1,23,0],
            [1,23,66,1],
            [1,2,66,1],
            [2,66,26,2],
            [2,26,35,2],
            [2,35,36,2],
            [2,36,3,2],
            [36,44,45,36],
            [3,4,44,3],
            [3,44,36,3],
            [4,44,55,4],
            [4,5,55,4],
            [5,55,54,5],
            [5,6,54,5],
            [6,53,54,6],
            [6,7,53,6],
            [7,8,53,7],
            [8,52,53,8],
            [8,9,52,8],
            [9,51,52,9],
            [9,10,51,9],
            [10,50,51,10],
            [10,11,50,10],
            [11,38,50,11],
            [11,12,38,11],
            [12,38,39,12],
            [12,31,39,12],
            [12,31,70,12],
            [12,13,70,12],
            [13,28,70,13],
            [13,14,28,13],
            // right eyebrow
            [14,15,28,14],
            [15,28,67,15],
            [15,16,67,15],
            [16,67,29,16],
            [16,17,29,16],
            [17,68,29,17],
            [17,18,68,17],
            [18,68,30,18],
            [18,30,33,18],
            // below eyes
            [30,40,69,30],
            [39,40,69,39],
            [39,31,69,39],
            [26,65,35,26],
            [34,35,65,34],
            [25,34,65,25],
            // left eyebrow
            [22,25,33,22],
            [22,25,64,22],
            [21,22,64,21],
            [21,24,64,21],
            [20,21,24,20],
            [20,24,63,20],
            [19,20,63,19],
            [19,23,63,19],
            [19,23,0,19],
            // below nose
            [36,45,46,36],
            [36,42,46,36],
            [42,37,46,42],
            [37,46,47,37],
            [46,37,47,46],
            [37,47,48,37],
            [38,48,49,38],
            [37,43,48,37],
            [43,38,48,43],
            [38,49,50,38],
            // nose region
            [22,18,33,22],
            [40,41,30,40],
            [25,33,41,25],
            [33,41,30,33],
            [25,34,41,25],
            [41,40,62,41],
            [34,41,62,34],
            [34,35,62,34],
            [35,36,62,35],
            [36,42,62,36],
            [42,37,62,42],
            [37,43,62,37],
            [43,38,62,43],
            [38,39,62,38],
            [39,40,62,39],
            // mouth
            [44,45,61,44],
            [45,46,61,45],
            [46,47,61,46],
            [47,61,60,47],
            [47,59,60,47],
            [47,48,59,47],
            [48,49,59,48],
            [49,50,59,49],
            [50,51,58,50],
            [51,52,58,51],
            [52,57,58,52],
            [52,53,57,52],
            [53,54,57,53],
            [54,56,57,54],
            [54,55,56,54],
            [44,55,56,44],
            // left eye
            [23,63,27,23],
            [63,24,27,63],
            [24,64,27,24],
            [64,25,27,64],
            [25,65,27,25],
            [65,26,27,65],
            [26,66,27,26],
            [66,23,27,66],
            // right eye
            [28,67,32,28],
            [67,29,32,67],
            [29,68,32,29],
            [68,30,32,68],
            [30,69,32,30],
            [69,31,32,69],
            [31,70,32,31],
            [28,32,70,28]
          ]
        },
        "patchModel": {
          "patchType": "SVM",
          "bias": {
            "raw": [-0.96431, -1.0357, -0.87499, -0.91633, -0.84504, -0.8443, -0.73852, -0.80871, -0.72654, -0.84368, -0.86982, -0.91726, -0.87371, -1.0267, -0.98146, -0.87301, -1.0204, -1.058, -1.2212, -0.88168, -1.0332, -1.0513, -1.2405, -1.1638, -1.067, -1.2392, -1.1877, -1.1235, -1.1355, -1.0802, -1.2402, -1.167, -1.112, -0.72954, -1.1239, -1.3005, -1.3147, -1.0871, -1.3362, -1.3247, -1.1149, -0.76288, -1.1216, -1.0986, -1.2995, -1.2784, -1.0059, -0.91233, -0.96292, -1.2527, -1.2946, -1.1523, -1.0005, -0.88771, -1.0142, -1.1965, -1.0387, -0.86719, -1.0089, -1.1238, -0.95069, -1.1224, -0.88922, -1.1176, -1.2249, -1.247, -1.2452, -1.0982, -1.2104, -1.2217, -1.1773],
            "sobel": [-0.83935, -0.62721, -0.55884, -0.69956, -0.71112, -0.80041, -0.8006, -1.1137, -0.80072, -0.80019, -0.71985, -0.69966, -0.58347, -0.65659, -0.82586, -0.77759, -0.77233, -0.85808, -0.81938, -0.76428, -0.79996, -0.86702, -0.82302, -0.74264, -1.0086, -0.71718, -0.79528, -0.88281, -0.7815, -0.99671, -0.71226, -0.81128, -0.961, -1.2055, -0.86243, -0.75576, -0.78897, -0.96273, -0.78559, -0.78317, -0.89144, -1.0805, -0.81895, -0.82399, -0.61098, -0.70637, -0.83608, -0.86537, -0.86189, -0.70686, -0.60467, -0.63896, -0.60021, -0.60121, -0.60027, -0.66659, -0.70694, -0.80643, -0.70127, -0.69741, -0.85141, -0.69645, -1.0096, -0.88808, -0.88378, -0.80101, -0.80271, -0.90248, -0.8675, -0.82653, -0.82836],
            "lbp": [-1.2775, -0.80122, -0.80009, -0.80001, -0.70684, -0.77174, -0.76476, -0.66899, -0.72273, -0.66941, -0.59957, -0.79986, -0.80009, -0.80015, -0.80045, -0.7709, -0.6573, -0.59981, -0.58309, -0.95297, -0.76546, -0.79994, -0.72741, -1.3172, -1.1408, -1.3378, -1.4003, -1.2901, -1.2837, -1.1569, -1.2168, -1.4004, -1.2905, -0.92838, -0.9268, -0.92117, -0.91104, -0.84307, -0.86336, -0.97589, -0.89165, -1.1977, -0.99448, -0.97474, -0.79614, -0.7713, -0.91142, -0.92086, -0.8659, -0.84975, -0.80661, -1.0506, -1.2192, -1.3183, -1.3092, -0.60808, -0.93976, -1.1058, -1.0279, -0.91383, -0.87452, -0.81875, -1.0651, -1.1856, -1.1889, -1.3461, -1.3969, -1.1909, -1.1383, -1.3736, -1.3913]
          },
          "weights": {
            "raw": [
              [-0.0064193, 0.029809, -0.026784, -0.022626, -0.067697, -0.33308, 0.028197, 0.18245, 0.015034, 0.067853, 0.066708, 0.043758, -0.049432, 0.028765, -0.02378, -0.019044, -0.14598, 0.076748, 0.10031, 0.022404, 0.039489, -0.069173, 0.064454, -0.035681, 0.029478, 0.01367, -0.040087, -0.16484, 0.06074, 0.13421, 0.024223, -0.023179, -0.023938, 0.00080564, -0.020188, 0.035394, 0.020506, 0.028993, -0.15876, 0.08638, 0.069612, -0.0051496, -0.086213, -0.11615, -0.10172, 0.050444, -0.010945, -0.001994, -0.082496, -0.19805, 0.14503, 0.10473, -0.054504, 0.058559, 0.02151, 0.017305, 0.054797, 0.08145, -0.015927, -0.026646, -0.29396, 0.26045, -0.014751, 0.013566, -0.052044, -0.068508, 0.026715, 0.01503, -0.0036696, 0.0038326, -0.029296, -0.21686, 0.23218, -0.0032704, 0.0010938, 0.022865, -0.0024711, 0.027139, -0.016799, 0.052897, 0.0068774, -0.11535, -0.20003, 0.26777, -0.012991, 0.014507, -0.028377, 0.0061822, 0.088922, -0.029269, 0.023549, 0.005012, -0.10302, -0.11265, 0.23622, -0.02319, 0.0035723, -0.034182, 0.05063, 0.010945, -0.0026519, -0.025155, 0.02853, -0.13116, -0.093256, 0.16421, -0.010547, 0.03555, -0.020259, 0.022467, 0.03417, 0.11908, -0.0015743, -0.06402, -0.22057, -0.07231, 0.30205, 0.023274, 0.063584, 0.042979, 0.11846],
              [0.16668, -0.061056, 0.0069211, 0.017085, -0.22608, -0.37345, 0.079941, 0.16478, 0.022649, 0.052894, 0.029322, -0.065687, -0.017175, 0.053426, 0.13197, -0.038916, -0.22142, 0.17019, 0.037969, 0.032433, 0.013114, -0.004714, 0.014494, 0.016836, -0.035383, 0.064594, -0.16864, -0.18184, 0.22011, 0.017098, 0.044439, -0.065745, 0.10209, 0.012977, 0.019776, -0.020715, 0.037536, 0.073188, -0.25739, 0.1791, -0.012201, -0.012489, -0.027938, 0.09084, 0.056062, -0.029592, 0.083797, 0.026909, 0.028447, -0.26724, 0.17602, 0.057474, -0.021754, -0.016094, 0.034961, -0.066136, -0.086822, 0.021268, 0.024914, 0.083351, -0.21234, 0.14528, 0.052103, 0.0060527, 0.0041058, 0.073743, -0.063151, 0.071707, 0.050277, 0.059474, 0.041093, -0.23159, 0.039824, 0.035168, -0.039327, -0.046713, -0.029439, 0.030373, 0.010642, 0.035443, -0.064897, -0.032864, -0.15394, 0.011778, 0.17418, -0.054758, 0.047924, 0.054346, -0.0033549, 0.02359, -0.0246, 0.060655, 0.13657, -0.093663, -0.047444, 0.062873, -0.022728, -0.027266, 0.12949, -0.016065, -0.029023, -0.055703, -0.084011, 0.067583, -0.021201, -0.12022, 0.094859, -0.023786, -0.031181, -0.0045461, -0.00096878, 0.075436, 0.010017, 0.06898, 0.077148, 0.016059, -0.19045, -0.010877, 0.12221, -0.035116, 0.061957],
              [0.0011017, -0.10083, 8.5948e-05, -0.004422, -0.09674, -0.13241, 0.13984, -0.0031379, 0.0684, 0.041645, 0.12466, 0.057469, 0.073611, -0.010864, 0.0048406, 0.016396, -0.021671, 0.044733, 0.067922, -0.015872, -0.055943, 0.019702, 0.018616, -0.005659, 0.034038, 0.034411, -0.10871, -0.08096, 0.067428, -0.01988, -0.013665, 0.03579, 0.066231, -0.045918, -0.0042019, 0.021127, 0.040188, -0.036664, -0.030093, 0.0088117, 0.002416, -0.038593, -0.031144, 0.035042, -0.018244, 0.018916, 0.0008242, 0.092475, 0.073297, -0.024312, -0.0027452, 0.067921, 0.0011866, -0.028294, 0.042812, -0.022453, 0.02261, -0.028251, 0.043263, 0.092532, -0.15324, 0.050211, 0.01393, -0.00089781, -0.063661, 0.0048486, 0.07858, 0.025758, -0.032352, 0.028485, 0.023621, -0.21175, 0.10461, 0.047598, -0.013273, -0.060312, 0.021931, -0.054666, 0.02459, -0.053143, 0.049928, -0.024453, -0.1367, 0.013882, 0.10709, -0.030277, 0.045489, 0.021159, 0.0045505, 0.05215, -0.031125, -0.025892, 0.051506, -0.15851, -0.077434, 0.14442, 0.025521, -0.01336, -0.032691, -0.050761, 0.0067267, 0.053583, -0.066091, 0.028319, -0.023395, -0.1219, 0.12641, 0.04107, -0.038345, -0.0051038, 0.011158, -0.025558, -0.015803, -0.01457, 0.058582, 0.048613, -0.29657, -0.067646, 0.13109, 0.05457, 0.062524],
              [-0.025233, 0.022349, -0.072259, -0.18573, 0.061154, 0.16053, 0.035735, 0.032646, 0.049973, -0.017745, 0.12328, -0.0020676, 0.017463, 0.062789, -0.11705, -0.065255, 0.094525, 0.04495, -0.028764, -0.007559, -0.018043, -0.042767, 0.0064727, -0.024499, 0.015096, 0.01148, -0.22512, 0.1375, 0.042174, -0.00097974, 0.0053459, 0.0066959, 0.052939, 0.028663, 0.0083788, 0.00039142, 0.058936, -0.2056, 0.079503, 0.10224, -0.041138, 0.02733, -0.010752, -0.0022307, -0.0079242, -0.0082795, -0.032085, 0.086123, -0.12113, -0.12791, 0.13903, 0.008854, -0.035846, 0.0045791, -0.043587, -0.02644, 0.012179, 0.074042, 0.012884, 0.063138, -0.30013, 0.19885, 0.063816, 0.049735, -0.059942, 0.066082, 0.01826, 0.01778, -0.030632, -0.05294, 0.12681, -0.2386, -0.072937, 0.12737, 0.063566, -0.051173, 0.0097791, -0.0043407, -0.016156, -0.0091924, 0.050666, 0.0060985, 0.017308, -0.20368, 0.12046, 0.012913, -0.0092052, 0.035363, 0.030748, -0.0068483, 0.06077, -0.024831, 0.032205, 0.088513, -0.20132, 0.0025484, 0.14012, 0.019619, 0.03077, -0.044844, 0.010829, -0.018605, 0.0048701, -0.053836, 0.065656, -0.087834, -0.1002, 0.019099, 0.032626, 0.013786, 0.014593, -0.022453, 0.023627, 0.044568, 0.05182, 0.058961, 0.011809, -0.24303, -0.10331, 0.043122, 0.044784],
              [-0.11132, -0.14268, -0.1132, 0.16617, 0.21669, 0.1458, 0.015659, 0.0813, -0.024809, 0.04021, 0.11478, 0.01893, -0.080897, -0.059337, -0.10482, 0.10574, 0.063141, 0.059506, -0.10686, 0.034082, -0.044929, -0.023391, -0.021034, 0.011729, -0.12519, -0.24525, 0.075036, 0.16915, -0.011043, 0.018698, 0.0089194, -0.0095742, 0.074951, 0.052516, 0.00076256, 0.14447, -0.16117, -0.29435, 0.21098, 0.15322, -0.031397, -0.073199, -0.00058139, 0.038374, 0.071661, -0.025228, 0.094356, -0.0055066, -0.31677, -0.17018, 0.20181, 0.038951, 0.020699, 0.0073525, 0.019251, 0.027713, 0.022208, 0.017802, 0.16127, -0.0097927, -0.39692, -0.016345, 0.084335, 0.12332, 0.046852, 0.0026368, -0.015618, -0.0094365, -0.026158, 0.093092, 0.015837, -0.036104, -0.25195, 0.066519, 0.088769, -0.054177, 0.11363, -0.074336, 0.026412, -0.0069935, -0.011837, 0.20496, 0.040653, -0.10952, -0.19526, -0.02669, 0.025635, 0.084142, 0.081561, 0.0339, -0.041778, -0.0095017, 0.014147, -0.0083457, 0.066156, -0.13608, -0.0752, -0.099487, 0.097955, -0.068031, -0.028817, 0.062117, -0.05651, -0.016458, 0.078179, -0.011548, 0.054587, -0.017563, -0.072691, -0.034856, 0.058574, -0.060289, -0.012303, 0.052155, 0.075228, 0.053727, 0.0021832, -0.0023449, 0.069002, -0.05515, -0.18138],
              [-0.23224, 0.079035, 0.20679, 0.17117, 0.060393, 0.070072, -0.061905, 0.10747, 0.014332, -0.032562, 0.096137, -0.11702, -0.18648, -0.072636, 0.12519, 0.070887, -0.032713, -0.014133, 0.0038162, 0.065966, 0.020457, 0.051334, -0.0011168, -0.086504, -0.17856, -0.024882, 0.17292, 0.076636, 0.095776, -0.076644, -0.054109, -0.03761, 0.10647, 0.005106, 0.056304, -0.028155, -0.31729, -0.058091, 0.11556, 0.065723, 0.030551, 0.041747, -0.069588, 0.092461, 0.052299, -0.010486, 0.011062, -0.045253, -0.23598, -0.070893, 0.10681, 0.11991, -0.020183, 0.00057273, 0.096563, 0.084394, 0.0061097, 0.052438, 0.012128, -0.025706, -0.37426, -0.12769, 0.057044, 0.11342, 0.089909, 0.088759, -0.017367, 0.058574, 0.0024242, 0.0811, 0.071615, -0.015636, -0.21764, -0.20281, -0.10017, 0.076481, 0.072072, 0.074832, -0.071669, 0.0033343, -0.020106, 0.12485, 0.088742, 0.012539, -0.080372, -0.20668, -0.042825, -0.041961, -0.011319, 0.0087351, -0.0073466, -0.014035, 0.060981, 0.0044957, 0.060136, 0.12863, -0.043407, -0.17199, -0.12412, -0.067878, -0.014543, 0.013304, 0.086616, -0.050869, 0.059037, -0.030082, -0.039151, -0.01341, 0.082024, -0.1843, 0.04382, 0.031005, 0.010111, -0.0064174, 0.024543, 0.0033265, 0.04021, 0.1055, 0.066466, 0.049202, -0.093932],
              [-0.12203, -0.03698, 0.12683, 0.10063, 0.082154, 0.031377, 0.076193, 0.029644, 0.067195, 0.014606, 0.21693, -0.091991, -0.11496, -0.057854, 0.026983, 0.053704, -0.027394, 0.062051, -0.014065, -0.030464, 0.050223, 0.069522, -0.047915, -0.076313, -0.10543, -0.069963, 0.063888, 0.047704, 0.049626, 7.9371e-07, 0.066938, 0.022331, -0.013204, -0.051208, 0.017252, -0.16856, -0.081718, -0.051493, 0.044258, 0.079861, 0.040257, 0.061168, -0.044454, 0.076059, 0.024485, 0.023739, 0.022211, -0.039096, -0.26994, -0.1381, 0.10638, 0.074165, 0.13611, 0.08862, 0.023943, 0.059455, 0.018811, 0.13333, 0.019081, 0.040954, -0.19369, -0.33097, -0.31537, -0.051012, 0.10153, 0.10646, 0.014631, -0.0037912, -0.031174, 0.12574, 0.082747, 0.1391, 0.015618, -0.09701, -0.25737, -0.2389, -0.39201, 0.014632, -0.0049577, 0.032249, 0.019906, 0.0090031, 0.026111, 0.062898, 0.14639, 0.10175, -0.0083665, -0.22695, 0.016645, 0.01064, -0.033903, -0.05887, 0.022391, 0.010862, 0.028661, -0.0089732, 0.052004, 0.030893, -0.066299, -0.045463, -0.036534, 0.058255, -0.090301, 0.087529, -0.048367, -0.02187, -0.061935, 0.022843, 0.087099, -0.038226, 0.042583, 0.046404, 0.038044, 0.01328, -0.024476, 0.042648, 0.021205, 0.023541, -0.0073299, 0.0090777, 0.072704],
              [0.076135, 0.075929, 0.10248, 0.12142, 0.061859, 0.025464, 0.048676, 0.030286, 0.11129, 0.19455, 0.11003, 0.074607, 0.013898, -0.012869, 0.03812, 0.0071485, -0.03739, 0.027892, -0.0040181, 0.051192, -0.051415, -0.065948, -0.077216, 0.078792, -0.01494, -0.042428, -0.022774, 0.0095521, 0.089225, 0.0026288, 0.027795, -0.011245, 0.002779, -0.084646, 0.10851, 0.064787, 0.071775, 0.10157, 0.13539, 0.022702, 0.081383, 0.10182, 0.13415, -0.067255, -0.252, -0.13138, -0.16366, -0.018741, -0.062883, -0.022204, -0.072308, -0.060022, -0.15902, -0.23762, -0.27876, -0.040264, -0.080156, -0.054339, -0.19775, -0.28232, -0.23354, -0.28871, -0.14102, -0.10254, -0.091079, -7.6022e-05, 0.084334, 0.025777, 0.027111, 0.12587, 0.17095, 0.12108, 0.23254, 0.022508, 0.10869, 0.10336, -0.0044697, -0.019044, -0.038539, 0.059623, -0.028373, -0.02936, 0.00087517, -0.065918, -0.069356, 0.02358, 0.021727, 0.039571, -0.029877, 0.038706, 0.054323, -0.04361, -0.014678, -0.039397, 0.028347, 0.13841, -0.090661, 0.036896, -0.037229, -0.0098949, -0.045239, -0.027745, 0.04194, 0.010554, -0.12123, -0.0087493, -0.022343, -0.036723, -0.074235, 0.13503, 0.046152, -0.00089713, 0.055905, 0.072801, -0.014134, 0.047446, 0.085859, 0.05507, 0.022279, 0.064172, -0.070766],
              [0.118, 0.07821, 0.12816, -0.020597, 0.014337, 0.11621, 0.089056, 0.054438, 0.040501, 0.077089, -0.16589, 0.098328, -0.028103, -0.026588, 0.024055, 0.072814, -0.012894, 0.081294, -0.019639, -0.059461, -0.070719, -0.12759, 0.029993, 0.0019697, 0.026357, 0.077456, -0.0065799, 0.034984, -0.011141, 0.037206, -0.078048, -0.042937, -0.12754, 0.028459, -0.025141, 0.032111, 0.042952, 0.11294, 0.020048, 0.051516, -0.23573, -0.072308, -0.019056, 0.0030321, 0.096971, 0.07581, 0.11716, 0.10957, -0.0024781, -0.064158, -0.26848, -0.059754, 0.061911, -0.021664, 0.08611, 0.053234, 0.17175, 0.028047, -0.085903, -0.33611, -0.28144, -0.008033, 0.10514, -0.016383, 0.068947, 0.032998, -0.25751, -0.14537, -0.35542, -0.31544, -0.015389, 0.25816, 0.089607, 0.024874, 0.06881, 0.03489, 0.0094402, -0.3317, -0.084022, 0.051, 0.11407, 0.12381, 0.061542, 0.024538, -0.051413, -0.037969, -0.083159, 0.060974, -0.069683, 0.013137, 0.054335, 0.086376, 0.025768, -0.030285, 0.0046746, 0.014048, 0.0039043, -0.013244, -0.010235, -0.034349, 0.089307, 0.023673, -0.074064, -0.039416, -0.051468, 0.0066514, -0.0056021, 0.03753, 0.022918, -0.028514, 0.047001, 0.011664, 0.031577, 0.036743, 0.0001679, -0.032413, 0.061177, -0.014966, 0.027964, 0.049596, 0.017494],
              [0.095112, -0.061598, -0.027849, 0.16285, 0.011485, 0.088228, 0.033477, 0.21312, 0.12563, 0.0056585, -0.19669, 0.12202, 0.065004, -0.064638, 0.0076011, -0.014993, -0.013714, 0.06519, 0.060502, -0.0073205, -0.15837, -0.11375, -0.01122, -0.037241, -0.0035346, 0.014184, -0.018805, 0.0022003, 0.086304, 0.05073, -0.19348, -0.024337, -0.022104, 0.11856, -0.0040747, -0.021636, 0.032835, 0.080034, 0.18177, 0.040195, -0.27027, -0.046765, 0.0088521, -0.0095398, 0.073838, 0.0022341, 0.080947, 0.064911, 0.068853, 0.052927, -0.41011, -0.0033883, -0.07662, 0.028027, 0.076992, 0.135, 0.0010836, -0.0094522, 0.11898, -0.10886, -0.31839, -0.079537, 0.088035, -0.019948, 0.055031, 0.017356, 0.11549, 0.047319, 0.0035589, -0.1909, -0.16923, -0.10344, 0.11611, 0.03014, 0.092038, -0.00052811, -0.0199, 0.11041, -0.11355, -0.13266, -0.16828, -0.036676, 0.078177, 0.065049, 0.061266, -0.045421, 0.038674, 0.026641, -0.10482, -0.10701, -0.065259, 0.1028, 0.025141, 0.078995, 0.055586, -0.028237, -0.0025877, 0.033127, -0.028093, -0.19115, -0.084372, 0.032752, 0.044573, 0.07857, -0.076168, -0.011918, 0.038863, -0.044585, -0.041775, 0.066544, -0.20856, 0.16839, 0.028096, 0.029747, -0.028107, 0.040207, -0.0050223, 0.061683, 0.11123, 0.002529, -0.021203],
              [0.090436, -0.042297, 0.079436, 0.038426, 0.018479, 0.15189, 0.24325, 0.11802, -0.080157, -0.21178, -0.13219, 0.018475, 0.092018, -0.050722, -0.068375, -0.015375, 0.03148, 0.087358, -0.068354, -0.14664, -0.00015826, 0.015682, 0.051709, 0.0087471, -0.082976, 0.061059, 0.055713, 0.11256, 0.1201, -0.2412, -0.014823, -0.021321, -0.0064827, 0.011517, -0.0029379, -0.036512, 0.040278, 0.051444, 0.17561, -0.1656, -0.17724, 0.066641, 0.025444, 0.011885, 0.028951, -0.06227, 0.008151, 0.074139, 0.15952, -0.023426, -0.39782, -0.10909, 0.19811, -0.039694, 0.074717, 0.067657, 0.0023721, 0.050106, 0.11669, 0.10445, -0.18066, -0.13733, 0.12306, 0.037249, 0.040395, -0.013511, -0.012464, -0.011253, 0.057264, 0.064124, -0.18291, -0.28694, 0.16662, 0.052134, -0.03452, -0.0020693, 0.067413, 0.069379, 0.017341, 0.1125, -0.12114, -0.16394, 0.042619, 0.0082442, 0.032212, 0.0013431, 0.059794, -0.041854, 0.16142, 0.02529, -0.092772, -0.2216, -0.01754, 0.044685, 0.076526, 0.056282, -0.038323, -0.024136, -0.063727, 0.10195, -0.11144, -0.13769, 0.050856, 0.011876, 0.075788, -0.07629, -0.081411, 0.072942, 0.068768, -0.033998, -0.1679, -0.13094, 0.030093, -0.020742, 0.00030251, 0.088643, 0.052492, 0.087008, 0.024693, -0.11263, 0.075664],
              [0.10662, -0.024041, 0.023732, 0.012547, 0.0662, 0.072881, 0.14196, -0.18846, -0.10001, -0.030399, 0.0065084, 0.035396, -0.016756, 0.039963, -0.032921, -0.0052279, 0.14555, -0.045218, -0.15713, 0.019388, 0.069073, -0.029885, -0.013668, 0.035507, -0.033905, -0.066398, 0.069367, 0.099068, -0.16177, -0.049744, 0.049417, 0.11584, -0.0099765, -0.0058946, 0.024852, -0.022954, 0.035365, 0.070911, 0.16507, -0.20261, 0.0040823, -0.020995, -0.01738, -0.068169, -0.016583, 0.016335, 0.017415, -0.06551, 0.17533, -0.077798, -0.16426, 0.067991, 0.015164, 0.0078509, 0.023953, -0.022724, 0.006469, -0.0046863, 0.023956, 0.17797, -0.14584, -0.064279, 0.0072859, 0.10176, -0.053758, 0.03183, -0.0069311, 0.011744, -0.02288, 0.061704, 0.073774, -0.20953, 0.022857, 0.054729, -0.019112, -0.03021, 0.0030313, 0.015874, -0.0064523, -0.02938, 0.17845, -0.071105, -0.12963, 0.074504, 0.028226, 0.028593, -0.019591, 0.026275, 0.049329, -0.0025258, 0.015184, 0.079378, -0.19506, -0.034582, 0.039284, -0.060962, 0.032105, 0.0010087, -0.0029092, 0.0013445, 0.0050237, 0.10379, 0.022548, -0.11489, -0.022121, 0.043655, 0.0067757, 0.025228, -0.019274, 0.021907, 0.076111, 0.017668, -0.015509, -0.23798, -0.10029, 0.068962, -0.0095808, 0.071808, 0.0096925, 0.0089571, -0.0082775],
              [0.14712, 0.048704, 0.038282, 0.073332, 0.092603, -0.069406, -0.18039, 0.030462, -0.076528, -0.02846, 0.0039885, 0.091531, -0.097047, -0.021416, 0.022881, 0.1163, -0.11091, 0.0052601, -0.0013446, 0.019773, -0.010681, 0.087902, -0.0062328, -0.022953, -0.011871, 0.0057627, 0.09059, -0.032591, -0.02872, 0.018765, 0.034198, 0.092483, -0.039036, 0.046061, -0.03192, 0.035976, -0.02143, 0.087312, -0.10752, 0.0015208, 0.010464, 0.017721, -0.05437, -0.041949, 0.025353, -0.033214, -0.021243, -0.0008824, 0.12799, -0.14588, 0.0049155, 0.11545, 0.024394, 0.026837, -0.007026, -0.020081, 0.023705, 0.02295, -0.053385, 0.083134, -0.19191, 0.028256, 0.051623, 0.026883, 0.0083776, -0.005671, -0.015188, -0.052822, 0.0039064, 0.0052812, 0.10528, -0.15535, 0.012627, 0.033272, -0.016016, 0.047323, 0.029676, 0.062672, 0.02036, -0.056328, 0.062032, 0.13944, -0.16288, -0.062736, 0.0089074, -0.0034475, -0.016188, -0.058358, -0.038566, -0.0077422, -0.045255, 0.13887, 0.084802, -0.19493, 0.067962, -0.039669, -0.042999, 0.056923, 0.02131, 0.023652, 0.005385, -0.031872, 0.12124, -0.096718, -0.094641, 0.050053, -0.041096, 0.067669, -0.01302, -0.017936, 0.030885, 0.017941, 0.12318, 0.082612, -0.19694, -0.084587, -0.0036588, 0.046191, -0.015214, -0.037797, -0.03766],
              [0.02879, 0.024919, 0.046184, 0.11407, 0.12089, -0.33168, -0.30199, 0.075505, 0.015981, -0.030246, 0.070778, 0.021705, -0.014784, -0.092797, 0.073387, 0.21513, -0.13136, -0.04101, 0.0027233, 0.10444, 0.019235, 0.026668, 0.077454, 0.037705, 0.028346, -0.0099782, 0.16392, -0.12998, -0.16954, 0.044202, 0.022535, -0.08057, 0.028323, 0.030852, -0.057281, -0.030642, 0.02744, 0.19419, -0.21394, -0.10823, 0.078776, -0.054726, -0.0018936, 0.027554, 0.12724, -0.053402, 0.032579, -0.0053669, 0.14926, -0.15555, 0.0070015, 0.047597, 0.15763, -0.0017752, -0.07848, 0.047381, -0.054017, -0.01081, 0.03169, 0.23863, -0.17968, -0.0025415, -0.0044923, -0.03345, 0.073251, -0.0025313, 0.04727, -0.018764, -0.085707, 0.037456, 0.24243, -0.25409, 0.043294, 0.040148, 0.013087, -0.019853, -0.023226, 0.030177, 0.030922, -0.040953, -0.0059331, 0.059824, -0.2284, 0.053836, 0.039215, -0.019168, 0.036601, 0.0071217, 0.0055195, 0.017118, -0.010329, 0.022892, 0.10731, -0.081072, -0.052731, 0.020939, 0.027473, 0.0087321, -0.011973, 0.029541, 0.025438, -0.0032417, 0.092169, -0.063485, -0.084864, -0.0055455, 0.04783, -0.038729, 0.021656, -0.048404, 0.081106, -0.050253, 0.062539, 0.050009, -0.066834, -0.22863, 0.13881, 0.081957, -0.036534, -0.019724, 0.074253],
              [0.080975, 0.05653, 0.032548, 0.10153, 0.046435, -0.21467, -0.20895, -0.014893, 0.020894, -0.0067217, 0.035252, -0.0060355, -0.027461, 0.010096, 0.054592, 0.16829, -0.17463, 0.021868, -0.041396, 0.01938, 0.012675, -0.027695, -0.041244, 0.016052, -0.0010187, 0.14438, 0.078408, -0.21215, -0.057681, 0.12665, -0.12395, 0.071773, 0.0075741, -0.051866, 0.038445, -0.11282, -0.013662, 0.21925, -0.14332, -0.054997, 0.0029603, 0.047503, -0.028486, 0.020467, -0.10612, 0.011156, 0.013002, 0.023296, 0.26377, -0.25931, -0.081091, -0.00039674, 0.042663, -0.0029479, -0.026706, -0.08931, -0.0050439, -0.005502, -0.045367, 0.23013, -0.090116, -0.21359, 0.069011, 0.019878, 0.0044609, 0.029591, -0.035017, -0.01693, -0.028665, -0.014127, 0.23223, 0.020022, -0.25101, 0.089307, -0.0077045, 0.033183, 0.0097764, 0.034273, 0.020165, -0.010043, 0.0084138, 0.23503, -0.02443, -0.16832, 0.00052901, -0.023488, 0.096816, -0.036178, 0.0026701, 0.0060485, -0.03295, -0.029843, 0.14656, 0.035391, -0.20847, -0.057892, -0.01027, 0.076538, 0.082782, 0.11259, -0.016599, -0.093948, -0.025158, 0.13711, 0.13285, -0.2231, -0.12554, 0.02511, -0.030215, -0.011749, 0.144, 0.043164, 0.085941, 0.035185, 0.17622, 0.19444, -0.23633, -0.077389, 0.014639, 0.0228, 0.083546],
              [0.12261, 0.16705, 0.19069, 0.064201, -0.00016272, -0.065943, -0.0079351, -0.057893, -0.054006, -0.10459, -0.05418, 0.06699, -0.09922, 0.062446, 0.090945, 0.028278, -0.047069, -0.007151, -0.050253, -0.014707, 0.09548, -0.11062, -0.14256, 0.026859, -0.19465, 0.18485, 0.1789, 0.15499, -0.028242, 0.044796, -0.058444, 0.013625, -0.079693, -0.1145, -0.12378, -0.065906, -0.15742, 0.12985, 0.20266, 0.038497, -0.025654, 0.075726, -0.022083, -0.085487, 0.032081, -0.16479, -0.22038, -0.22297, -0.38061, 0.12776, 0.3174, -0.015834, 0.055459, 0.011929, 0.024193, 0.090971, 0.16123, 0.0089118, -0.017295, -0.35854, -0.48144, 0.033786, 0.12099, -0.022527, 0.049459, -0.029491, 0.25613, 0.11469, 0.12808, 0.11403, 0.30507, -0.19905, -0.20054, 0.039641, -0.043767, 0.03361, 0.0098997, 0.11272, 0.18547, 0.15244, 0.061145, 0.11826, 0.12075, -0.019667, -0.00048386, -0.12176, 0.036172, -0.11869, -0.12502, 0.035905, 0.01784, 0.060859, 0.096352, -0.049212, -0.045373, -0.055897, -0.0023764, -0.038383, 0.0064116, -0.17559, 0.002325, -0.051727, -0.057791, 0.013791, 0.13645, -0.010155, -0.017626, 0.073653, 0.00069329, -0.050008, -0.31928, -0.18353, -0.085538, -0.073096, 0.09019, 0.10661, 0.090351, 0.13292, -0.011857, 0.052935, 0.043013],
              [0.063687, -0.027474, 0.040793, 0.033944, 0.067494, -0.084203, -0.024907, 0.0091584, -0.06882, 0.0031107, -0.097109, 0.11878, 0.0371, -0.089403, 0.021829, 0.050693, 0.01234, -0.023686, -0.02684, 0.034846, -0.016166, -0.027865, 0.12116, 0.0037369, 0.13532, 0.021592, 0.018171, 0.015073, 0.070401, 0.0022894, -0.038532, 0.073413, -0.029637, 0.14797, 0.12294, 0.068355, 0.16847, 0.092089, 0.12471, 0.06941, 0.0028282, 0.028941, -0.082406, -0.09934, -0.0023105, -0.044478, 0.00088096, -0.085099, -0.0064586, -0.044295, 0.10096, 0.14859, 0.1447, 0.078676, 0.041103, -0.18575, -0.17065, -0.17155, -0.25171, -0.27337, -0.21265, -0.17173, 0.027527, 0.05618, 0.12158, 0.079338, -0.12195, -0.13969, -0.026572, -0.07417, -0.14513, -0.115, -0.18279, -0.24715, -0.13748, -0.068393, 0.098672, -0.1674, 0.075274, -0.0044961, 0.1326, 0.31234, 0.15518, 0.06646, -0.015468, -0.030267, -0.05626, -0.038216, 0.067129, 0.12319, 0.18469, 0.086525, 0.095784, 0.15931, 0.07563, 0.11757, -0.076016, -0.011817, -0.051957, 0.17489, 0.14148, 0.086957, 0.081058, 0.046959, 0.049182, 0.003411, 0.015581, 0.026515, -0.062879, -0.056347, -0.093781, -0.23964, -0.13259, -0.084366, -0.12791, -0.070084, -0.044962, 0.049251, 0.072447, -0.016197, 0.10029],
              [0.022795, 0.031855, 0.024367, -0.088291, 0.072323, -0.062925, -0.0040861, -7.973e-05, 0.013966, -0.025131, 0.017076, 0.043144, -0.077791, 0.048534, 0.007217, -0.035475, 0.035692, -0.0053752, 0.043054, 0.036426, 0.026332, 0.018922, 0.034425, -0.043307, -0.023769, 0.080994, 0.0014023, 0.068008, 0.095105, 0.10798, 0.024411, 0.043708, 0.05651, 0.038013, -0.016919, 0.13076, 0.11446, 0.21239, 0.28796, 0.092687, 0.096764, 0.070116, 0.046945, -0.02811, 0.18644, 0.077871, 0.11792, -0.035608, -0.036649, -0.13441, -0.12092, -0.15624, -0.17026, -0.12518, -0.14934, 0.15932, 0.04839, -0.10848, -0.12256, -0.19726, -0.15716, -0.21753, -0.20063, -0.092267, -0.020573, -0.071637, 0.063398, -0.10021, -0.1558, -0.14944, -0.11921, -0.081202, -0.11695, -0.0067284, -0.046838, -0.0077863, 0.019981, -0.12167, -0.11523, -0.057472, -0.052229, -0.046891, 0.061574, 0.11811, 0.17402, 0.13372, 0.19273, 0.13838, -0.043682, -0.035941, 0.011031, 0.066035, 0.16274, 0.10016, 0.15019, 0.051561, 0.058406, 0.020233, 0.080342, -0.066884, 0.043092, 0.061076, 0.043765, 0.031379, -0.0054635, 0.039411, -0.017169, -0.027826, -0.0047149, 0.036104, 0.054667, 0.04624, -0.045456, 0.049402, -0.047668, -0.014225, -0.059509, -0.13174, -0.010384, -0.087812, -0.077603],
              [-0.032356, 0.018327, 0.017296, -0.027671, -0.0076809, -0.041377, -0.015062, -0.043781, 0.036477, 0.044229, 0.18106, 0.042891, -0.020853, -0.024082, 0.041552, -0.014679, -0.040842, 0.017432, 0.0070217, 0.1293, 0.15511, 0.2479, 0.015244, -0.016083, -0.051589, -0.092487, 0.045744, 0.057517, 0.1687, 0.26355, 0.13879, 0.14252, -0.078456, 0.0045618, -0.049966, 0.080369, 0.050147, 0.067477, 0.13152, 0.16709, 0.014141, -0.095378, -0.20288, -0.39934, 0.018783, 0.055848, -0.005273, 0.094884, 0.092662, 0.026342, -0.086839, -0.21346, -0.28211, -0.14896, -0.15888, 0.014524, 0.064105, 0.015209, 0.094836, 0.056563, -0.16636, -0.24132, -0.25962, -0.13982, -0.15532, 0.011695, 0.032011, -0.037561, 0.066608, -0.0076642, -0.04071, -0.04226, -0.090012, 0.069267, 0.15115, 0.15845, 0.15654, 0.057963, -0.031603, -0.0055733, -0.063345, 0.014275, 0.031681, 0.03982, 0.093416, 0.11919, 0.039897, 0.1715, 0.0032917, 0.0044847, -0.021099, 0.02581, -0.13673, -1.2468e-05, 0.045304, -0.052655, 0.020909, 0.08479, -0.063339, 0.091377, 0.072522, -0.07921, -0.067294, -0.04391, 0.029396, 0.023947, 0.017167, 0.030553, -0.058622, -0.0098427, 0.20196, -0.023669, -0.014002, -0.037283, -0.023078, 0.01559, -0.013169, -0.031499, -0.039786, 0.054516, -0.040513],
              [-0.11875, -0.082293, -0.095608, -0.020578, -0.051846, -0.010859, -0.022717, 0.12821, 0.20208, 0.10327, 0.19572, 0.018529, -0.062344, 0.036177, 0.04107, 0.0079762, -0.10314, 0.0064955, 0.12399, 0.024168, 0.030885, -0.074999, -0.0404, -0.026348, -0.0040063, -0.098214, -0.033436, 0.11941, 0.25556, 0.03896, -0.072604, -0.080306, -0.10381, -0.05732, 0.015516, 0.062556, -0.073829, 0.092347, 0.19891, 0.16973, -0.044618, -0.17459, -0.16856, -0.12959, 0.0028653, 0.039282, 0.051811, 0.05423, 0.13871, 0.27288, -0.31439, -0.4393, -0.14064, -0.11423, 0.047797, -0.065062, -0.0042604, 0.029463, 0.025105, 0.14743, -0.34598, -0.42017, 0.035073, 0.079596, 0.13323, 0.1334, -0.061958, 0.06892, -0.038536, 0.047215, -0.14334, -0.21161, 0.14176, 0.17098, 0.14175, 0.037859, 0.31086, -0.029229, 0.01515, 0.034324, -0.011782, -0.077397, 0.00082481, 0.042535, 0.049854, 0.13021, 0.20732, 0.070042, -0.037027, -0.031792, -0.064806, -0.082587, -0.074375, 0.013859, 0.15057, 0.13055, 0.023194, -0.079371, -0.076747, -0.056515, 0.070663, -0.082981, 0.038591, 0.036885, 0.10304, 0.028582, -0.11389, -0.023276, -0.020208, -0.1467, 0.023731, -0.018263, 0.11113, 0.01781, 0.20204, 0.050785, 0.06147, -0.0075508, 0.00039041, -0.14722, -0.3692],
              [-0.11817, 0.050808, 0.027086, -0.058324, -0.069752, -0.021027, -0.0010775, 0.07435, -0.0083997, 0.024897, 0.087436, -0.019099, -0.046098, -0.039781, 0.0088895, 0.0075569, -0.019311, 0.055368, 0.044256, 0.0032692, -0.010373, 0.072601, -0.0081004, -0.024375, -0.0051757, -0.0076083, -0.038608, 0.092478, 0.00029774, 0.041278, 0.081716, 0.02474, 0.18486, -0.025645, -0.025676, -0.069747, 0.054381, 0.049825, 0.13027, 0.1711, 0.059608, 0.089855, 0.095437, 0.15876, -0.059134, 0.090977, 0.095109, 0.11556, 0.17971, 0.033055, -0.035525, -0.10878, -0.050794, -0.076391, -0.056758, 0.13477, 0.12869, 0.13014, 0.0063887, -0.089729, -0.31295, -0.28325, -0.22477, -0.21457, -0.13308, -0.26981, 0.0050166, -0.080398, -0.085216, -0.18399, -0.23965, -0.12035, -0.076984, -0.01802, -0.023775, -0.10766, -0.167, 0.015041, 0.04251, -0.12958, 0.029351, -0.019786, 0.12164, 0.19449, 0.18157, 0.13918, 0.036259, -0.05933, -0.053816, -0.058012, -0.024991, -0.039656, 0.16051, 0.14621, 0.076529, 0.20618, 0.08613, 0.23683, 0.178, -0.031569, -0.011339, 0.0075929, 0.036795, 0.033074, 0.024137, 0.025796, 0.012497, -0.019553, 0.05285, 0.090518, -0.012948, 0.077672, 0.03561, 0.077328, -0.037094, -0.0047151, -0.059217, -0.13706, -0.084998, -0.20364, -0.1024],
              [0.0032467, -0.0050619, -0.021818, 0.020874, -0.023531, 0.032369, 0.02328, -0.069079, 0.028859, -0.022912, 0.03505, 0.021373, 0.043177, 0.031001, -0.022728, -0.04113, -0.011957, -0.0073658, 0.019513, 0.056489, -0.018007, 0.023594, -0.060975, 0.13275, -0.020289, 0.093323, 0.18376, 0.093308, 0.017002, 0.029001, -0.03262, -0.077144, -0.026313, -0.036376, 0.030017, 0.081068, 0.17134, 0.14545, 0.14412, 0.2509, 0.18953, 0.10962, 0.11869, 0.097649, 0.017539, -0.16077, -0.089442, -0.16627, -0.19946, -0.12054, -0.099975, -0.0030788, 0.17592, 0.0094048, 0.24138, -0.10617, -0.041295, -0.18663, -0.10129, -0.15612, -0.19263, -0.26517, -0.21075, -0.1524, -0.016384, 0.10147, 0.0087661, 0.033117, 0.022842, -0.12277, -0.10457, -0.046811, -0.05131, -0.12955, -0.085883, -0.21065, 0.067424, 0.07409, 0.082147, 0.095757, 0.12801, 0.19242, -0.010488, 0.002463, -0.014173, -0.069939, -0.071938, -0.073642, 0.031404, 0.11052, 0.082629, 0.072224, 0.081941, 0.14731, 0.13688, 0.093928, 0.026163, -0.034217, -0.096254, 0.052569, 0.058021, -0.069487, 0.10387, 0.016885, 0.0057524, -0.033858, 0.0992, 0.0027588, 0.028883, 0.0077988, -0.02613, -0.10093, -0.059725, -0.16032, -0.026296, -0.081817, 0.019856, 0.011593, 0.033536, -0.03719, 0.039209],
              [0.15106, 0.0077706, 0.040428, -0.0017943, -0.041654, -0.068591, 0.0062988, 0.026863, -0.032304, -0.019033, 0.007998, 0.27836, 0.068631, 0.10034, 0.09688, -0.0033598, 0.054326, -0.055942, -0.0054187, -0.0077552, 0.0045759, -0.00017646, -0.009476, 0.20486, 0.23126, 0.16314, 0.098539, -0.0099257, 0.053672, -0.088889, 0.023933, 0.012746, 0.013848, -0.39204, -0.21351, -0.17917, 0.010687, 0.16695, 0.2016, 0.16449, 0.011415, -0.026561, 0.0072565, -0.0063508, -0.16007, -0.15189, -0.22446, -0.21975, -0.14908, -0.011673, 0.10656, 0.16673, 0.027289, -0.0080445, 0.075809, 0.023838, -0.060319, -0.15809, -0.1508, -0.21785, -0.18411, -0.034762, -0.0030781, 0.14435, 0.098192, 0.0189, 0.14331, 0.13334, 0.10003, -0.011991, -0.081184, -0.091853, -0.059061, -0.030702, 0.0091318, 0.030031, -0.029166, 0.11125, 0.10479, 0.060406, 0.13088, 0.094447, 0.046888, -0.099894, 0.00043867, -0.079159, -0.030958, 0.051181, 0.036532, -0.026314, 0.048772, -0.019627, 0.041812, 0.020275, -0.035311, -0.0357, 0.037776, -0.01539, 0.10246, -0.004495, 0.0051588, 0.038344, 0.052952, -0.020141, 0.038911, -0.02581, -0.054107, -0.059081, -0.019798, 0.051849, -0.073763, -0.038341, -0.06688, -0.018986, 0.04871, -0.019809, 0.010562, -0.024563, -0.015141, -0.047958, 0.21089],
              [-0.12519, -0.11688, -0.058961, 0.042235, 0.027385, 0.073378, 0.1997, 0.18078, 0.17754, -0.12636, 0.08321, 0.029824, -0.0015425, -0.016459, 0.077534, 0.00013268, 0.09375, -0.044727, -0.19635, -0.22782, 0.11588, 0.28944, -0.068772, 0.010802, -0.0078676, 0.079851, 0.21293, -0.0089784, -0.068418, 0.022956, -0.026211, 0.057828, -0.079483, -0.016172, 0.062689, -0.021796, 0.12691, -0.047525, -0.049301, 0.048206, -0.21716, 0.02813, 0.12406, -0.086131, 0.076895, 0.038135, 0.011629, 0.070698, 0.0084135, -0.11267, -0.39755, 0.073041, 0.16994, -0.11001, -0.24501, -0.01654, 0.037589, 0.12221, 0.04684, -0.19362, -0.50341, -0.46225, 0.30127, 0.38513, -0.19299, -0.50883, 0.057766, 0.085916, 0.0025825, -0.15402, -0.081067, 0.13999, 0.1736, -0.0082113, 0.034164, 0.033688, -0.15384, -0.0035718, 0.011347, -0.017873, 0.039147, 0.10637, 0.076248, 0.13996, -0.12176, -0.064375, 0.022872, 0.20474, 0.014948, -0.039363, 0.024752, 0.06253, 0.0078273, 0.08754, -0.034543, 0.058746, -0.075126, 0.076597, 0.19454, 0.021682, -0.073489, -0.058083, 0.012328, 0.076039, -0.036913, -0.018863, -0.079317, 0.016094, -0.18419, 0.049227, -0.061457, 0.028283, 0.10422, 0.018037, 0.062905, 0.072053, 0.012388, 0.09073, 0.11439, 0.10143, 0.19506],
              [-0.037472, 0.079003, -0.11809, -0.011576, -0.047355, -0.04382, -0.022041, -0.015582, -0.06045, 0.0056711, 0.087342, -0.047485, 0.055578, 0.014641, 0.10885, 0.072561, 0.053636, -0.017556, 0.042134, -0.029061, -0.12502, -0.017197, -0.013398, 0.011501, 0.027702, 0.027412, 0.029975, 0.073364, 0.010914, 0.07541, 0.13044, 0.023411, -0.0048254, 0.074978, 0.054355, 0.042047, -0.015464, 0.022631, -0.063888, -0.040446, -0.11272, -0.077312, 0.018981, 0.079484, 0.042423, -0.00069404, -0.069229, 0.07743, 0.20474, 0.28719, 0.30504, 0.3255, 0.14073, -0.015201, -0.04186, 0.17136, 0.15274, 0.15944, -0.046361, -0.22277, -0.34374, -0.38756, -0.37353, -0.17546, 0.024942, 0.038533, 0.12622, -0.29897, -0.47417, -0.40534, -0.044667, 0.12588, 0.18503, 0.074482, -0.10022, -0.34732, -0.099282, -0.29838, -0.18662, 0.035652, 0.4013, 0.060801, -0.020916, -0.017432, 0.0064527, 0.31447, 0.27814, -0.042857, -0.10711, 0.12305, 0.34204, 0.11781, -0.098208, -0.22534, -0.17337, 0.025185, -0.11168, 0.2142, -0.04395, -0.023907, -0.065585, 0.092041, -0.03531, -0.13397, -0.038995, -0.12154, -0.13006, -0.17042, 0.11042, 0.092651, 0.13111, 0.058002, -0.0026521, 0.15722, 0.066071, 0.039488, 0.039274, 0.19072, 0.10773, -0.028126, 0.057979],
              [0.14781, -0.039386, -0.022921, 0.053882, 0.12599, 0.028203, 0.034607, -0.042381, 0.03885, 0.03641, 0.1629, 0.089845, -0.046053, -0.082096, -0.22397, -0.11679, 0.10054, -0.0082322, -0.010907, -0.029538, 0.0049451, 0.10219, 0.18664, 0.21337, 0.096928, 0.082225, -0.042534, -0.052259, -0.020309, -0.10672, -0.088221, -0.15579, 0.23093, -0.079956, -0.13801, -0.056966, -0.28523, -0.0068234, 0.26377, 0.035257, -0.00096948, -0.13355, -0.095292, 0.10809, -0.22622, 0.13751, 0.30589, 0.4709, -0.26226, -0.24292, 0.22232, 0.090544, 0.043301, -0.055195, 0.01245, -0.48339, -0.41102, 0.015183, 0.26867, -0.18588, -0.65746, -0.3708, 0.26182, 0.20686, -0.062913, -0.0046315, -0.34603, -0.057876, -0.080074, -0.060733, -0.063132, 0.33223, 0.16004, 0.084047, -0.02977, 0.045421, 0.034504, 0.37536, 0.088936, 0.18256, 0.079936, 0.23524, 0.11129, 0.10974, -0.047221, -0.11616, -0.06731, 0.034599, 0.23286, 0.1319, -0.041749, -0.18972, -0.070314, -0.04434, -0.052799, -0.12426, 0.045488, -0.13703, 0.059172, -0.056679, -0.074185, -0.096952, -0.021836, -0.065731, 0.021349, -0.083419, 0.052566, -0.0026602, 0.038735, 0.068176, 0.22646, 0.08289, 0.035399, 0.067321, 0.1424, 0.085139, 0.05037, 0.0010888, -0.01828, -0.017226, 0.08422],
              [0.11801, 0.048642, -0.10679, 0.0052911, 0.23136, 0.17221, 0.17682, 0.20045, 0.052122, -0.14026, 0.022439, -0.019828, -0.13731, 0.092577, 0.20996, -0.16372, -0.15701, -0.17369, -0.058054, -0.015724, 0.019399, -0.04931, -0.11375, -0.014247, 0.070739, -0.088328, -0.13682, -0.078888, 0.053145, -0.19438, -0.00017069, 0.13425, 0.0093321, -0.18143, 0.12021, 0.29639, -0.0090975, 0.039856, -0.084631, 0.036932, -0.14789, 0.19687, 0.40664, -0.14336, -0.18437, -0.038752, 0.29571, 0.053689, -0.19565, -0.34486, -0.50121, -0.40626, 0.13382, -0.00028762, -0.20092, 0.11021, -0.18696, -0.23952, -0.1882, -0.020408, -0.10626, 0.10776, 0.19942, -0.058277, 0.027522, 0.18135, 0.068695, 0.01411, 0.019796, -0.069519, 0.085999, 0.25122, 0.24992, 0.20675, 0.093802, -0.071506, 0.083957, 0.042664, -0.044898, 0.075633, 0.18471, 0.092312, 0.16477, 0.067407, -0.035391, -0.10051, -0.14948, -0.085912, 0.119, 0.022232, -0.059604, -0.083714, -0.12267, -0.071818, -0.061365, -0.037122, -0.024043, -0.0077183, -0.027903, -0.070229, 0.067283, -0.022097, 0.030069, 0.016509, 0.007991, 0.053658, -0.016975, 0.037888, -0.1034, 0.093947, 0.17569, 0.053193, 0.083328, -0.012242, 0.11153, 8.8778e-05, -0.0059795, 0.079576, -0.011219, 0.13063, 0.13094],
              [0.14423, -0.010081, 0.0073771, 0.065269, 0.055849, 0.052364, -0.022519, -0.0099854, 0.0074881, -0.007637, 0.095115, 0.0074869, 0.01523, 0.040218, -0.085367, -0.17283, 0.011588, -0.058982, -0.091214, -0.055486, -0.085056, -0.012889, 0.082192, -0.088216, -0.1761, 0.020768, 0.29732, 0.34473, 0.35075, 0.16758, -0.084317, -0.08765, -0.029301, 0.0082198, -0.14179, 0.20164, 0.30623, -0.089834, -0.32991, -0.2377, 0.14059, 0.22935, -0.069549, 0.13057, -0.031497, 0.0079274, 0.084812, -0.29146, -0.12913, 0.070966, -0.089487, -0.076857, -0.031867, -0.094906, -0.076821, -0.28838, 0.0878, 0.20019, -0.17097, 0.015334, -0.28908, -0.029527, -0.31385, 0.04304, 0.45577, -0.18071, -0.13847, 0.042623, 0.27232, -0.19148, -0.11016, -0.1177, -0.20542, -0.34623, 0.23755, 0.286, -0.077963, 0.034879, -0.026162, 0.12712, 0.14403, -0.034149, -0.088551, -0.027746, 0.12772, 0.10002, -0.18643, 0.041461, 0.057714, -0.083882, -0.083313, 0.026147, 0.057512, 0.098777, 0.20838, 0.081416, -0.031359, 0.010864, 0.054168, 0.036336, -0.037734, -0.05846, -0.050706, 0.0721, 0.077237, 0.032034, 0.083688, -0.018741, -0.068237, -0.067252, 0.12643, 0.092411, -0.032832, 0.10361, -0.020642, 0.050396, 0.014052, -0.024231, -0.050094, 0.029354, 0.10979],
              [0.060638, 0.011634, 0.11414, 0.11755, 0.020855, 0.10975, -0.04499, -0.011033, -0.053613, -0.044758, -0.10039, 0.13435, -0.024159, -0.084524, -0.09196, 0.10789, 0.045998, 0.055275, 0.064359, 0.01579, 0.02093, 0.040827, 0.13163, 0.059409, -0.026657, -0.14317, -0.10542, 0.073237, 0.082434, 0.062596, -0.0031044, -0.08584, -0.052855, -0.058037, 0.029722, 0.092669, -0.14987, -0.13354, 0.050258, 0.014996, 0.11314, 0.052153, 0.010578, 0.013768, -0.23145, -0.067587, 0.14188, 0.21502, -0.237, -0.2807, 0.024433, 0.017266, 0.017658, 0.026414, 0.088078, -0.19379, -0.33747, 0.1001, 0.36813, -0.034259, -0.51529, -0.21456, -0.029064, 0.029684, 0.11428, 0.035997, -0.31781, -0.038939, 0.17083, -0.019832, -0.015435, 0.21067, -0.06212, -0.026936, -0.055531, -0.02588, -0.056537, 0.082252, 0.13249, -0.050895, -0.023069, -0.0065804, -0.029029, 0.16671, 0.037287, 0.032007, 0.022986, 0.033098, 0.25107, 0.055248, -0.078427, -0.06518, 0.001903, 0.015118, 0.031629, 0.074471, 0.032408, 0.033763, -0.055109, 0.029518, -0.0055725, -0.022572, 0.0049783, -0.034893, 0.030152, -0.046318, 0.017217, -0.090595, 0.010987, 0.014754, 0.11881, -0.018854, 0.05457, 0.05288, 0.083388, 0.068291, 0.063598, 0.051887, 0.083087, 0.021603, -0.059861],
              [0.090807, 0.044777, -0.0060042, -0.050363, -0.038872, -0.12117, 0.022973, -0.031712, 0.038054, 0.0045987, -0.03566, -0.035675, -0.09299, -0.039163, -0.0069044, 0.013836, 0.030661, 0.070549, 0.02941, -0.012522, 0.051323, -0.0037635, -0.070014, 0.010861, 0.032727, 0.13749, 0.058184, 0.13751, 0.07872, 0.10379, -0.028949, 0.062082, -0.036945, 0.1129, 0.034426, 0.044915, -0.057007, -0.15438, -0.082871, -0.12982, -0.043612, 0.065964, 0.036324, 0.063714, 0.021735, -0.078259, -0.036957, 0.13355, 0.28201, 0.32487, 0.33827, 0.18538, 0.073223, 0.019788, 0.13765, 0.078068, 0.08518, -0.069126, -0.090879, -0.22904, -0.33514, -0.34107, -0.35148, -0.14298, 0.075348, 0.14776, -0.045856, -0.24152, -0.21753, -0.13094, 0.020511, 0.097672, 0.14601, -0.12507, -0.37252, -0.40824, -0.045906, -0.16008, 0.079378, 0.3144, 0.19158, 0.029031, -0.11483, 0.076726, 0.30135, 0.27546, -0.0068621, -0.36522, -0.067019, 0.2062, 0.0525, -0.13265, -0.07895, -0.20642, -0.24381, -0.086798, 0.23653, 0.22019, -0.036973, -0.049162, 0.14626, 0.14505, -0.22743, -0.082066, -0.12119, -0.043182, -0.098016, 0.02947, 0.13747, 0.0062917, 0.16322, -0.091364, 0.073288, 0.11423, 0.08521, 0.15332, -0.072661, 0.20467, 0.026701, 0.036011, 0.078828],
              [0.18112, 0.073306, 0.040736, -0.030592, -0.014723, -0.0097177, 0.12725, 0.030397, -0.058889, -0.026611, 0.066681, 0.066608, -0.071919, -0.0083165, -0.017286, 0.038603, 0.067084, -0.070282, -0.069691, -0.025275, -0.11015, 0.24938, 0.13938, -0.057198, -0.073331, -0.14479, 0.05242, -0.12935, 0.030685, 0.061611, -0.10213, 0.22393, 0.11686, 0.16687, -0.11111, -0.17122, 0.056582, -0.048939, 0.15918, 0.19178, -0.34144, -0.00029347, -0.046901, -0.19494, 0.045412, -0.0095034, -0.029117, 0.04141, 0.2315, 0.052449, -0.56727, 0.30029, 0.46091, 0.068319, -0.37008, 0.042656, -0.13943, 0.11478, 0.26741, -0.10449, -0.66828, -0.28238, 0.17754, 0.1737, -0.17216, -0.47505, 0.054836, -0.030162, 0.068493, 0.14671, 0.0071732, 0.29966, 0.2025, -0.17784, -0.11562, -0.13324, -0.097222, -0.028986, -0.035807, -0.10615, -0.13902, 0.016241, 0.1731, 0.19619, 0.11532, 0.085863, 0.16627, 0.31074, 0.046359, -0.0066806, -0.1195, 0.04915, -0.11685, -0.077622, -0.15566, -0.042823, -0.075959, -0.047232, 0.18267, 0.10711, -0.031804, 0.0641, -0.08334, 0.088606, -0.049002, -0.060791, -0.011939, -0.028966, -0.020443, 0.03072, 0.060614, -0.039898, 0.063701, 0.047369, 0.029398, 0.10606, 0.087013, 0.067144, -0.017892, 0.069808, 0.20794],
              [-0.036185, -0.068424, 0.033948, 0.25798, 0.055755, 0.14929, 0.20629, 0.22367, -0.046034, -0.10955, 0.12202, 0.033686, -0.11812, 0.12834, -0.12897, -0.056304, -0.29473, -0.025196, -0.049804, 0.052954, -0.067019, -0.068227, -0.047831, 0.026913, 0.088734, -0.19263, -0.011955, 0.086306, -0.16802, -0.083379, 0.087896, 0.12512, -0.12768, -0.2193, 0.40485, 0.21682, -0.072674, -0.087649, -0.11089, 0.015296, -0.1123, 0.29574, 0.080991, -0.1695, -0.097181, -0.07649, 0.24096, -0.24206, -0.33279, -0.40824, -0.16983, -0.11497, 0.28958, 0.028529, -0.048023, 0.063, -0.030722, -0.066963, -0.011014, 0.075932, -0.080862, -0.16771, 0.101, -0.24229, -0.31555, 0.037389, 0.1555, -0.021451, 0.078024, 0.2267, 0.30002, 0.24804, 0.095539, -0.038035, -0.028632, 0.0083028, 0.096554, -0.093656, -0.17003, -0.046728, 0.054387, -0.011591, 0.19039, 0.080097, 0.18123, 0.11932, 0.021024, 0.0092452, 0.067406, 0.017941, -0.04075, -0.082441, -0.11871, -0.13318, -0.054036, -0.081002, -0.026664, -0.010407, 0.076209, 0.011612, -0.0056684, -0.030538, 0.020575, 0.053928, 0.047349, -0.038219, 0.034337, -0.00018566, -0.026357, 0.080691, 0.12907, 0.054592, 0.056561, 0.048194, -0.032352, 0.015293, 0.016805, 0.13319, 0.0038584, 0.11728, 0.10129],
              [0.087039, -0.086031, 0.023999, -0.055001, -0.045275, 0.028719, 0.023279, 0.0072154, 0.079227, -0.032632, 0.15267, 0.044269, 0.10052, -0.11766, 0.067446, -0.016435, 0.030053, 0.10106, -0.1017, -0.066477, 0.012013, 0.0062465, -0.05766, -0.11952, -0.014951, -0.030954, 0.18712, 0.21588, 0.18761, 0.095823, -0.040222, -0.07325, 0.0042778, 0.055782, 0.082192, -0.012446, 0.17705, 0.1158, -0.24107, -0.085837, 0.15007, 0.28498, -0.14535, 0.010094, 0.095917, -0.29873, 0.17875, -0.22302, -0.17488, -0.043713, -0.1162, -0.23807, 0.0043004, 0.054212, -0.11568, -0.29339, 0.121, 0.4419, -0.15497, -0.022722, -0.21405, -0.020547, -0.27084, -0.095044, 0.2806, -0.27074, -0.13687, 0.17055, 0.3386, -0.2711, -0.35586, -0.26535, 0.082943, -0.35847, 0.34731, 0.15494, -0.1054, 0.094828, -0.10941, 0.019909, 0.13262, -0.049725, -0.10697, -0.25439, 0.17441, 0.1069, -0.077671, -0.0093719, 0.11752, 0.025752, 0.068028, 0.10986, 0.19781, 0.2037, 0.17359, 0.16858, -0.071588, -0.027858, 0.026995, -0.047967, -0.17448, -0.096432, -0.070821, 0.12976, 0.10169, -0.012905, -0.0072145, -0.076309, -0.074777, 0.049862, 0.13897, -0.01642, 0.087861, -0.035559, -0.034266, -0.041158, 0.11153, 0.021064, 0.066654, 0.031123, 0.21873],
              [0.024272, 0.21153, 0.10969, 0.059161, -0.04225, -0.08748, -0.010603, 0.082455, 0.12208, 0.17548, 0.048487, -0.10566, 0.0072713, 0.0048265, -0.037108, 0.036969, 0.059266, -0.091124, 0.016032, -0.026239, -0.059022, -0.088673, -0.077264, 0.056275, -0.051047, 0.023388, -0.017324, 0.012251, 0.025666, -0.020853, 0.0066968, 0.073686, -0.099903, -0.12413, -0.018049, -0.018586, -0.044793, 0.017308, 0.10244, 0.000328, 0.0064671, -0.10225, -0.025294, -0.034442, -0.12789, -0.022149, 0.014835, 0.12138, 0.031883, 0.03247, 0.0090957, -0.063479, 0.10607, -0.099169, -0.16382, -0.14343, -0.032183, -0.058018, 0.022916, 0.04015, 0.10591, 0.11703, 0.051143, 0.024664, 0.022331, -0.14794, -0.046226, -0.052976, 0.017633, -0.083088, 0.039154, 0.083559, 0.074372, -0.010152, 0.0052221, -0.094777, -0.071077, -0.01963, -0.040408, -0.046653, -0.012629, 0.026326, 0.057107, 0.091724, -0.0027242, -0.15414, 0.044172, -0.03748, -0.058582, -0.10282, -0.030064, -0.030479, 0.092608, 0.044945, 0.045404, -0.010357, 0.0060041, -0.074053, -0.041777, -0.00050145, -0.034991, -0.036126, -0.0451, 0.025861, -0.053218, 0.012117, 0.12779, -0.16438, -0.01274, 0.019185, 0.084771, 0.019614, -0.034807, -0.0017216, 0.15755, 0.005375, 0.039444, 0.14283, -0.047934, -0.10056, 0.083257],
              [-0.12767, -0.062412, -0.094141, -0.064796, -0.01781, -0.0691, -0.023075, -0.017484, -0.066453, -0.036872, 0.24167, -0.043101, 0.088798, 0.074579, 0.041306, 0.0411, 0.054755, 0.084087, -0.0097248, -0.049453, -0.081133, 0.064803, 0.058334, 0.048858, 0.003069, -0.037722, 0.054194, 0.0081354, 0.012382, -0.0081329, -0.053456, -0.091653, 0.06463, -0.0018238, 0.079983, -0.085168, 0.078834, -0.036841, 0.14405, 0.015137, -0.15092, -0.035986, 0.070901, 0.0031645, 0.012722, 0.017055, 0.03574, 0.020664, 0.288, -0.043946, -0.069905, -0.028876, 0.013241, -0.093933, 0.0073548, 0.021223, 0.088674, 0.15572, 0.18554, 0.051416, -0.30814, -0.1535, 0.015614, 0.033258, 0.007274, 0.068546, 0.15638, 0.027911, 0.18476, 0.017477, -0.32883, -0.27338, -0.082442, 0.040346, -0.010355, 0.048333, 0.10853, 0.20223, 0.060164, -0.016735, -0.16834, -0.29914, 0.034354, 0.045518, 0.020288, 5.4206e-05, 0.055521, 0.078561, 0.1685, -0.070184, -0.079489, -0.2965, 0.10263, 0.11174, 0.13931, 0.026571, 0.081658, 0.081828, 0.083098, 0.11143, -0.13933, -0.22918, -0.064352, 0.16181, 0.25167, 0.042481, 0.088318, 0.10703, 0.097667, 0.24657, 0.00077544, -0.20365, -0.12891, 0.074372, 0.25016, -0.0027412, -0.09113, -0.23136, -0.30385, -0.14846, -0.10313],
              [0.0047306, -0.025051, -0.005842, 0.023077, -0.0021831, 0.093205, 0.16892, 0.13474, -0.019109, -0.10105, 0.062619, 0.01684, 0.01172, -0.0013488, 0.038407, 0.054231, 0.20955, 0.051311, -0.17892, -0.15157, -0.10803, 0.021082, 0.050527, 0.037029, 0.084086, 0.097194, 0.1163, 0.10292, -0.16563, -0.29211, -0.054203, -0.025851, 0.13698, -0.071433, 0.10358, -0.058267, 0.041899, 0.12303, -0.12859, -0.32801, -0.028641, 0.13915, 0.070612, 0.17863, 0.03674, 0.082604, 0.0015218, 0.093696, -0.11859, -0.24264, -0.17082, 0.31937, 0.10806, -0.025076, 0.28906, 0.16912, -0.0059925, 0.11217, -0.11767, -0.055105, -0.35075, 0.075522, 0.29102, 0.032924, 0.073925, 0.13286, 0.11032, 0.017466, -0.0088771, -0.12337, -0.02645, -0.032574, -0.17412, 0.27115, 0.13019, -0.072333, -0.22304, -0.0049243, 0.062008, -0.054843, -0.077837, 0.062096, 0.21463, -0.092882, -0.28273, -0.2134, -0.17286, -0.2332, 0.10998, -0.0075162, -0.11007, -0.003427, 0.078591, 0.1035, 0.25431, -0.15927, -0.27034, -0.10635, 0.048935, -0.021263, -0.12239, 0.0070055, -0.042365, 0.067623, -0.048467, 0.15103, 0.22133, 0.039738, -0.08448, 0.051462, -7.7552e-07, -0.0097437, -0.011729, 0.091255, 0.03032, -0.0098684, -0.0043867, -0.063745, 0.18972, 0.083907, 0.081622],
              [0.35397, 0.22349, 0.057984, -0.17548, -0.28193, -0.035047, -0.061419, 0.073064, 0.061645, 0.077309, 0.17389, 0.092585, -0.19128, -0.21873, -0.15487, 0.14902, 0.20523, 0.089398, 0.029361, 0.18968, 0.069481, 0.22548, 0.093546, -0.13281, -0.17716, -0.13346, 0.26005, 0.18501, 0.053589, -0.04795, -0.068454, 0.090671, 0.11836, 0.067374, -0.079589, 0.00040371, -0.18012, 0.09018, 0.17516, 0.066704, -0.32349, -0.43602, -0.15344, 0.078031, 0.0026002, -0.0068308, 0.25009, 0.086593, -0.2945, -0.28058, -0.21672, 0.0075954, -0.057357, 0.050786, -0.13228, 0.063816, -0.02493, 0.1032, 0.27362, 0.10838, -0.10089, -0.36636, -0.099771, 0.16157, 0.055579, -0.12792, -0.097782, 0.03895, -0.011347, -0.0057841, 0.1616, 0.22732, 0.17202, 0.11473, -0.02501, -0.012533, -0.18287, 0.005862, 0.087637, -0.037285, -0.028907, -0.012641, 0.029752, 0.023716, 0.018978, -0.068872, 0.062344, -0.029721, -0.027412, 0.092857, -0.017031, -0.040569, 0.028207, -0.066991, 0.018046, 0.027421, 0.026029, -0.012257, 0.071946, 0.13443, -0.055826, 0.029494, 0.067669, -0.096084, 0.029157, -0.00057045, -0.10127, -0.024999, 0.1115, 0.06808, -0.0045362, -0.029235, -0.10839, -0.030881, -0.021536, 0.034917, -0.055573, 0.14693, 0.057093, 0.070054, 0.09283],
              [0.090302, -0.032234, 0.086011, 0.057656, 0.085002, -0.018557, 0.10988, 0.15414, 0.039386, 0.047347, 0.13261, 0.17209, 0.087977, 0.10798, 0.063005, -0.025038, 0.0015666, 0.042298, -0.010857, 0.038565, 0.09115, 0.070429, -0.33965, -0.21627, -0.079793, 0.052482, 0.11737, 0.12356, 0.14986, 0.15132, -0.020854, -0.27884, -0.36994, -0.23348, -0.35031, -0.21236, -0.0096203, 0.16879, 0.10884, 0.1951, -0.02216, -0.13795, -0.3823, -0.15708, 0.2465, 0.21041, 0.0038882, -0.15092, -0.14973, -0.27658, -0.13643, -0.20644, -0.10322, 0.20312, 0.24972, 0.098784, 0.050022, 0.11216, 0.0082125, -0.15896, -0.24966, -0.2242, -0.081867, 0.16097, 0.13085, 0.089777, 0.0095536, -0.045308, -0.023385, 0.05727, 0.11323, 0.14404, 0.076514, 0.16611, 0.0012914, -0.061225, 0.023338, 0.046303, 0.046502, 0.05308, -0.02208, -0.016463, -0.02459, 0.036155, 0.016853, 0.038351, -0.031623, -0.015009, -0.00256, -0.044171, 0.020136, 0.038923, 0.023164, 0.01893, 0.016295, -0.02645, -0.031756, 0.037952, 0.04783, 0.039081, 0.012653, 0.019182, 0.052408, 0.067772, 0.071084, -0.036646, 0.13604, 0.010095, 0.020674, 0.050958, -0.017289, -0.021564, -0.011485, -0.076477, 0.0025912, -0.03506, 0.022443, -0.022651, -0.013427, -0.084684, -0.02786],
              [0.22047, 0.13488, -0.0045314, -0.027832, 0.0031928, -0.11096, -0.14951, -0.26497, -0.0046697, 0.18623, 0.43027, 0.08365, 0.057113, 0.1422, 0.10169, 0.097731, 0.21612, 0.15447, -0.1386, -0.29659, -0.17497, 0.19818, 0.16783, 0.035357, -0.028903, -0.021291, 0.087221, 0.16959, 0.29274, -0.061147, -0.1512, -0.14884, -0.03919, 0.045408, -0.078471, -0.273, -0.38646, -0.05976, 0.17696, 0.1589, -0.090045, -0.0058036, -0.029934, 0.053751, 0.037133, 0.040635, -0.04802, -0.2107, -0.1441, -0.18667, -0.28265, -0.0036369, 0.22241, 0.039353, -0.0086786, -0.15038, -0.012859, 0.15635, 0.042299, -0.29268, -0.40523, 0.096518, 0.23155, 0.13543, 0.012292, -0.052369, -0.13532, -0.033103, 0.073328, 0.044657, 0.086151, 0.27385, 0.16267, 0.061526, -0.019745, 0.10503, -0.019421, -0.10477, -0.0051748, -0.069612, 0.013175, 0.080847, 0.064601, -0.021748, -0.0094289, -0.016282, -0.036344, 0.030459, 0.056434, 0.11018, -0.043666, -0.0042556, -0.073124, 0.029157, -0.045782, -0.018178, -0.026034, 0.062742, 0.057057, 0.11269, -0.014281, 0.066092, -0.026887, 0.015276, 0.0076592, -0.048903, -0.10792, 0.09321, 0.028853, 0.032763, -0.011491, 0.17616, 0.1057, 0.021853, -0.0058603, 0.0052496, 0.020608, 0.026462, -0.082618, -0.079352, -0.012265],
              [0.024463, -0.027352, -0.023265, 0.11579, 0.12541, 0.071656, 0.059076, -0.021125, -0.05219, -0.0033401, -0.0084537, 0.080912, -0.057403, -0.16721, -0.158, 0.063754, 0.19561, 0.071414, 0.11892, 0.037161, 0.077087, 0.035863, 0.1314, -0.1115, -0.040614, -0.26028, -0.18926, 0.066083, 0.13274, 0.034849, 0.019788, 0.014095, 0.062232, 0.14344, 0.042856, 0.10733, 0.0098224, -0.23834, -0.21249, 0.084274, 0.0088423, 0.032948, 0.071734, 0.0063217, 0.194, 0.014862, 0.10869, 0.19643, 0.010298, -0.29226, -0.080019, -0.013688, 0.11311, 0.012928, 0.1563, 0.25797, 0.0068688, 0.15136, 0.20517, 0.22377, -0.37619, -0.13386, -0.020441, -0.013775, 0.040573, 0.055189, -0.12709, -0.05821, -0.008442, 0.17523, 0.03337, -0.18113, 0.034219, -0.1109, -0.1463, -0.0069699, 0.094796, -0.23705, -0.15881, -0.22841, -0.054433, -0.17474, 0.067644, 0.085915, 0.063464, -0.020901, -0.038395, 0.071986, -0.052571, -0.092667, -0.13827, -0.249, 0.047883, 0.31224, 0.088266, -0.06281, 0.034915, -0.069708, -0.0018865, 0.098095, -0.055813, -0.060679, 0.056062, 0.17983, 0.074314, -0.027045, -0.00044359, -0.067458, -0.045453, 0.042969, 0.079381, 0.058881, 0.16904, 0.010963, 0.042321, -0.071452, 0.043646, 0.077058, 0.080224, -0.017561, -0.044482],
              [0.084549, 0.014073, -0.12307, -0.061069, 0.03087, -0.093121, -0.025168, 0.015404, -0.056966, -0.10833, -0.16715, 0.12222, 0.013801, -0.10225, 0.0023687, 0.087394, 0.049218, 0.029334, -0.00088026, 0.11339, 0.07953, 0.064893, 0.076669, -0.063082, 0.037023, -0.059661, 0.0166, 0.091314, -0.011486, -0.099932, 0.06516, -0.037572, 0.014463, 0.067622, 0.0025458, 0.015803, -0.10994, -0.069419, 0.021295, 0.060596, 0.026424, 0.0099006, 0.06539, 0.043328, 0.0095511, -0.076475, -0.034131, -0.075099, -0.049787, -0.0042179, 0.20028, -0.0015735, 0.11546, -0.0078019, 0.04754, 0.0074074, -0.0035661, 0.050506, 0.075847, -0.14426, -0.24271, -0.046073, 0.24353, 0.10855, 0.021319, 0.18208, 0.070465, 0.030956, 0.021331, 0.016481, 0.0086198, -0.29742, -0.41813, -0.16138, 0.14572, 0.16943, 0.15423, 0.11273, 0.046495, -0.023985, 0.1262, 0.029741, -0.012888, -0.11865, -0.25933, -0.10806, 0.041596, 0.18022, 0.1017, 0.018289, 0.13184, -0.004466, 0.052209, 0.17237, 0.14892, -0.1153, -0.2924, -0.13274, 0.14349, 0.12546, 0.1197, 0.096606, 0.083929, 0.24096, 0.18159, 0.21526, 0.094817, -0.17303, -0.16751, 0.053189, -0.014843, -0.13263, -0.2276, -0.28474, -0.2675, -0.11356, 0.12872, 0.2094, 0.038068, -0.18389, -0.098722],
              [-0.29332, -0.076674, -0.03075, 0.12028, 0.12711, 0.051897, 0.13914, 0.1154, -0.068125, -0.0090238, -0.29102, -0.061269, -0.054506, 0.051034, 0.012541, -0.0064693, 0.017938, -0.05423, 0.011336, -0.025654, 0.0483, -0.11406, -0.024236, 0.09794, -0.043137, -0.070786, -0.068497, 0.096858, -0.061432, -0.038064, 0.057071, -0.035895, 0.015329, 0.056504, -0.010336, 0.027054, -0.034953, -0.012868, 0.076343, 0.047322, -0.037463, -0.0093979, -0.014027, 0.064562, 0.053722, -0.06759, 0.013911, -0.016445, -0.019462, 0.01044, 0.099418, -0.092003, -0.01811, -0.069116, 0.090085, 0.05416, -0.0018643, 0.0040598, -0.085946, 0.10862, 0.0271, 0.099142, 0.00066682, -0.057661, 0.024057, 0.068221, 0.036722, -0.0013717, -0.028206, -0.04576, 0.053362, 0.052631, 0.0098104, -0.012204, -0.16439, -0.021002, 0.10557, 0.13827, -0.0070213, -0.16276, -0.18906, 0.059904, 0.10226, 0.07404, 0.0042852, -0.18459, -0.069684, 0.14111, 0.12749, -0.10699, -0.058973, -0.027184, 0.092294, 0.042731, 0.029014, 0.091553, -0.075057, -0.13843, 0.0049805, 0.0097377, -0.17763, -0.053056, 0.0051213, -0.03116, 0.018286, -0.062989, 0.0087673, 0.045406, -0.15525, -0.10424, -0.33859, 0.00092931, 0.071524, 0.24813, 0.17765, 0.054742, 0.12449, 0.21578, 0.11743, 0.1181, -0.27756],
              [0.23861, 0.03722, 0.03191, -0.14966, -0.09855, -0.095091, -0.030803, -0.040663, 0.017507, 0.028514, 0.08306, 0.0012191, -0.033229, -0.063142, 0.035545, -0.023608, 0.022431, -0.018828, 0.052736, 0.041581, 0.031034, -0.020525, -0.074378, -0.058852, -0.018417, -0.020185, 0.056556, -0.0026618, 0.052188, 0.12532, 0.019468, 0.096993, 0.052629, -0.095668, -0.1078, 0.047013, 0.12881, 0.1185, 0.046939, 0.011552, -0.10252, 0.034819, 0.089993, 0.11884, -0.026071, -0.10859, -0.028993, 0.12481, 0.24007, 0.40869, 0.26105, 0.050072, -0.0099467, -0.032287, -0.037881, -0.042541, 0.18047, 0.10729, 0.056245, -0.45229, -0.83931, -0.32647, 0.14836, 0.15629, 0.1474, 0.048456, 0.083157, 0.096331, -0.042531, 0.024992, -0.13245, -0.1692, -0.46441, -0.34745, -0.04738, 0.014762, 0.056736, 0.036695, 0.013279, -0.054248, -0.014839, 0.16411, 0.28499, 0.3327, 0.077933, -0.21058, -0.18028, -0.28799, 0.04902, -0.037058, 0.0052055, -0.017126, -0.0034699, 0.11284, 0.050042, 0.03923, 0.083779, 0.03011, -0.10733, 0.052781, 0.030826, 0.048218, -1.218e-05, 0.037878, -0.11301, 0.025972, -0.040362, 0.060663, -0.0029176, 0.019233, -0.023247, -0.024268, -0.048051, -0.039101, 0.055724, 0.019594, 0.001931, 0.052875, 0.11053, 0.059716, 0.065829],
              [0.067034, 0.026573, 0.061903, -0.050613, -0.071247, -0.061282, -0.13244, -0.077383, -0.032986, 0.050994, 0.23206, -0.017426, 0.016764, -0.0045263, 0.07268, 0.072143, -0.025652, 0.011719, 0.015719, -0.14235, -0.012766, -0.055815, 0.062228, 0.11099, 0.12777, 0.039054, -0.010543, 0.052522, 0.0455, 0.0047552, 0.040037, -0.04187, -0.077744, 0.036623, 0.026947, 0.0048713, 0.01145, -0.012158, 0.024207, 0.083283, 0.079838, 0.073616, -0.072412, -0.039881, 0.090275, -0.0059398, -0.079683, -0.055949, 0.16965, 0.46194, 0.27437, 0.17637, 0.0055755, -0.040969, -0.048391, 0.025695, 0.099983, 0.12605, 0.27677, -0.090382, -0.72367, -0.66542, -0.093851, 0.125, 0.090998, 0.018067, 0.023896, 0.1111, 0.033726, -0.22605, -0.55798, -0.23541, -0.094805, -0.091208, 0.0077773, 0.13248, 0.03986, -0.25216, -0.2025, -0.17881, -0.11431, 0.29677, 0.22717, 0.2741, 0.049649, -0.056866, -0.064785, 0.037313, -0.11707, -0.052502, 0.047053, 0.024036, 0.13017, 0.056206, -0.040238, 0.048845, -0.010397, 0.0059061, 0.038086, -0.010127, -0.011702, -0.036779, 0.010231, 0.010569, -0.0050323, 0.0022982, 0.017051, 0.01618, 0.046103, 0.010502, 0.092567, 0.079401, 0.1057, 0.10683, 0.057219, -0.049671, 0.042693, -0.038684, -0.039504, -0.02074, 0.014244],
              [0.062853, 0.070715, 0.0043518, -0.026667, 0.044525, 0.0088609, -0.059432, 0.12209, 0.10824, -0.025643, 0.055453, -0.03091, 0.0048755, -0.11083, -0.028824, -0.0050464, -0.0020802, 0.065154, 0.0042318, -0.016502, 0.039369, 0.1447, 0.036147, -0.025105, -0.0029753, -0.027231, -0.0265, 0.052084, 0.15939, 0.029111, 0.005888, 0.070684, -0.10502, -0.012995, -0.027731, -0.038084, -0.02885, 0.088899, 0.12716, 0.093878, 0.12446, -0.060464, -0.12926, 0.058859, 0.16395, 0.066259, 0.040324, -0.035531, 0.074783, 0.027442, -0.034548, -0.15238, -0.13605, 0.065147, -0.0074265, 0.004604, 0.078352, 0.12973, 0.095682, 0.10648, -0.47116, -0.76254, -0.35821, -0.013246, -0.13303, -0.10815, 0.012183, 0.014157, -0.026232, -0.04006, 0.013821, 0.24427, 0.3074, 0.050528, -0.023096, 0.032938, 0.085879, 0.041108, -0.0006755, 0.0383, -0.054725, -0.032597, 0.078231, 0.16873, 0.085156, -0.075477, 0.075846, -0.065616, 0.026372, -0.012261, 0.018816, -0.046021, 0.063677, 0.0091643, 0.021381, 0.010299, 0.025836, -0.0032034, 0.09386, -0.044507, -0.0094275, 0.014357, 0.00037736, -0.047078, -0.00096697, -0.010147, 0.0099517, -0.00041656, -0.03546, 0.013201, -0.034598, -0.040736, 0.051474, -0.030682, 0.033804, 0.043771, 0.089867, 0.0076302, 0.042986, 0.0073348, 0.089498],
              [0.15589, 0.01563, 0.077531, 0.035199, 0.098615, 0.06922, -0.051016, 0.013532, -0.16689, -0.077939, 0.021709, 0.051428, -0.064349, -0.015228, 0.012759, -0.012492, -0.052545, -0.06904, 0.050431, 0.036664, 0.10485, 0.086416, 0.050032, 0.056994, -0.002549, -0.0007908, 0.0014992, -0.18329, -0.0010931, -0.051995, 0.0076178, 0.05014, 0.083661, -0.028368, -0.057671, -0.024747, -0.17552, -0.053854, -0.049492, 0.028096, 0.16657, 0.17516, 0.11078, 0.23647, -0.019601, 0.0020069, -0.10476, -0.053073, 0.078984, 0.28337, 0.35166, 0.20796, -0.0051423, -0.066194, -0.049047, -0.035658, -0.053202, 0.076803, 0.29382, 0.27042, 0.32595, -0.14797, -0.18679, -0.049879, -0.099671, -0.040296, 0.022962, 0.11787, -0.072577, 0.15221, -0.11057, -0.27509, -0.22644, -0.21712, -0.065674, -0.05204, -0.09196, 0.052341, -0.029014, -0.026487, -0.099176, -0.11757, -0.13254, -0.076327, 0.079955, -0.17744, 0.080376, -0.073856, 0.08774, -0.13915, 0.0099844, -0.05868, -0.057029, -0.079794, 0.0015768, -0.0041526, 0.034597, 0.0086646, 0.057269, -0.026265, 0.048094, 0.021793, -0.11755, 0.00049937, -0.09137, 0.17327, 0.031573, 0.022297, 0.0028041, 0.12055, 0.22973, 0.053206, -0.01461, 0.11664, 0.082758, -0.089172, 0.061309, -0.041124, 0.0013241, -0.022405, 0.066514],
              [0.10641, 0.094792, -0.031529, -0.068663, -0.045583, -0.044171, -0.062373, -0.040882, 0.036681, -0.031891, -0.088635, 0.072486, 0.0017913, 0.071618, -0.10841, 0.055537, 0.020791, 0.052668, -0.011258, -0.084503, -0.055355, 0.069471, -0.028455, -0.092204, -0.059139, -0.0088604, 0.013756, 0.013008, 0.11917, -0.0054767, -0.0046385, 0.10607, 0.1319, 0.033045, -0.0059853, -0.063203, 0.04293, -0.07752, 0.10193, -0.12768, -0.091567, -0.057976, -0.13595, -0.048452, 0.011192, -0.0068851, -0.096621, 0.081772, -0.049007, 0.19762, 0.18536, 0.054459, -0.085416, -0.1103, 0.26784, -0.042453, 0.07976, 0.15028, 0.27327, 0.23584, 0.029238, 0.14907, 0.31049, 0.40128, 0.38541, 0.27327, 0.15637, 0.14855, 0.13417, -0.1554, -0.21625, -0.28189, -0.25441, -0.24392, -0.045056, -0.13584, -0.36047, 0.05411, -0.27378, -0.087569, -0.027321, -0.039262, 0.17563, 0.0038011, -0.11816, -0.14962, -0.071035, -0.11256, -0.067348, 0.043317, -0.10302, -0.15125, -0.045348, -0.22755, 0.0502, -0.02991, -0.10883, -0.0018045, -0.14576, 0.0095245, 0.017125, -0.0035127, -0.058373, 0.08984, -0.043367, 0.096739, 0.037002, 0.086995, 0.019892, 0.021145, -0.093457, 0.027113, -0.10194, 0.083879, 0.075076, 0.050127, 0.088653, 0.020525, 0.086116, -0.0054914, 0.1418],
              [-0.023176, -0.024545, -0.032358, 0.061548, -0.028032, -0.11117, -0.028557, 0.034625, -0.076973, -0.011746, -0.0099598, -0.054284, 0.047969, -0.058235, 0.032203, 0.031829, -0.0085909, -0.01854, 0.059493, 0.032667, 0.011822, 0.011903, -0.091303, 0.010421, 0.047574, -0.010086, -0.082131, -0.035238, -0.0095366, -0.0021083, -0.011205, -0.10622, 0.0088673, 0.080682, -0.090533, 0.0092003, 0.04758, -0.0034736, -0.26095, -0.19924, 0.12708, 0.076817, 0.0089468, -0.01743, 0.27183, 0.29541, 0.24001, 0.32835, 0.30453, 0.15738, 0.27144, 0.27187, 0.31738, 0.17968, 0.34964, 0.17948, -0.19852, -0.23132, -0.30349, -0.018142, 0.32802, 0.10088, -0.27373, -0.34405, -0.10799, -0.028605, -0.19185, -0.027746, -0.010639, -0.062358, -0.22873, -0.17307, -0.10579, -0.12595, 0.0052134, -0.033021, -0.071929, -0.084042, 0.037289, -0.14901, -0.051878, -0.06245, -0.14709, 0.018449, 0.0039521, -0.079257, -0.068342, -0.12332, -0.099563, -0.12283, -0.0063814, 0.15237, 0.056225, -0.0045107, -0.057588, 0.098403, 0.027092, -0.0051265, -0.17882, 0.012717, 0.014254, 0.10921, 0.12698, -0.041269, 0.08552, 0.043847, 0.024665, 0.12247, 0.1344, 0.0562, -0.070487, 0.050115, -0.00030554, -0.0023067, 0.054046, -0.05889, 0.056482, -0.074701, 0.054307, -0.0024485, -0.12796],
              [-0.0087719, -0.087903, -0.055052, -0.053895, -0.021765, -0.032496, -0.053937, -0.059602, 0.018682, -0.024042, 0.1808, 0.013387, -0.01946, 0.085841, -0.04296, 0.05614, -0.0074823, 0.072638, -0.045773, -0.0079074, -0.039618, 0.062009, 0.069674, -0.0017891, -0.017923, -0.017329, 0.10429, -0.075337, -0.019898, 0.066497, -0.04193, -0.017542, -0.049375, 0.047055, -0.11658, -0.050368, -0.087745, 0.10297, 0.0010435, -0.1119, -0.058552, -0.093602, -0.058917, 0.12428, 0.20422, -0.086927, -0.15846, -0.044231, 0.14028, 0.20301, 0.20997, 0.078368, 0.023616, 0.046474, -0.10919, 0.34228, 0.40922, 0.32978, 0.35276, 0.17348, 0.049654, 0.046853, 0.1854, 0.23487, 0.074066, 0.090895, -0.35637, -0.1789, 0.067024, -0.14509, -0.24145, -0.31352, -0.20854, -0.16942, -0.05073, 0.070839, 0.11262, -0.055654, -0.18253, -0.095111, -0.20811, -0.085216, -0.037808, 0.20963, -0.087519, -0.0083271, -0.18306, 0.012319, -0.16489, 0.074234, -0.11014, 0.00018777, 0.0033474, 0.10044, -0.2401, -0.055214, -0.098806, -0.014982, -0.12541, -0.035863, 0.046214, -0.11768, 0.075697, 0.25102, -0.15062, 0.10274, -0.14457, -0.0084316, 0.073822, 0.034203, 0.12998, 0.064947, 0.10038, -0.042683, 0.034386, 0.133, 0.084681, 0.1675, -0.14489, 0.097226, -0.17222],
              [-0.032221, 0.0081917, -0.080282, -0.081381, -0.063842, -0.015615, 0.10709, 0.080651, 0.054345, 0.027074, 0.16813, 0.13415, 0.038631, -0.0055507, 0.042335, -0.028374, 0.0039599, -0.063597, 0.056588, -0.027555, -0.0017875, 0.0041026, 0.092719, 0.0086585, 0.10684, -0.074196, -0.063057, -0.021523, 0.0092341, -0.1461, 0.014751, -0.0052165, 0.0032642, 0.097807, 0.12927, 0.062698, 0.27475, 0.092446, -0.12769, -0.14806, -0.019825, -0.0086315, 0.014481, -0.0089874, 0.10471, -0.11054, 0.0075036, 0.060006, 0.3171, 0.32324, 0.1072, -0.058102, -0.031761, -0.11429, -0.031551, 0.0017247, -0.032141, -0.013131, -0.14824, -0.10766, 0.10594, 0.40021, 0.19725, 0.083748, -0.030751, -0.02833, -0.099874, -0.26039, -0.025979, -0.074314, -0.14254, -0.27784, -0.10552, -0.011203, 0.12856, -0.00039207, 0.071697, -0.060715, 0.079555, -0.04445, -0.036239, -0.05495, -0.075878, -0.13219, -0.11464, -0.014322, 0.054633, -0.0021866, 0.047599, 0.071591, -0.061807, -0.098703, -0.17721, -0.050445, -0.088158, 0.17306, -0.18012, -0.1379, 0.069655, 0.1066, 0.042995, 0.13247, 0.10692, 0.063925, 0.084949, -0.14825, -0.17982, 0.079887, 0.0099879, 0.091659, 0.0039476, -0.022988, -0.025004, 0.022313, 0.032106, 0.0060978, -0.0091098, 0.13842, 0.057218, 0.034249, 0.14166],
              [0.077403, 0.0027903, 0.085849, 0.081622, 0.044687, -0.010721, 0.00076693, 0.10466, -0.015222, 0.00096215, 0.1025, 0.10103, -0.02864, -0.050144, 0.08803, -0.039184, 0.027942, -0.10922, -0.091551, 0.038578, -0.047089, 0.0082249, -0.016698, 0.14191, 0.023165, 0.072603, 0.11867, 0.014093, 0.0047639, -0.012687, -0.03666, -0.077417, 0.049268, -0.044394, -0.17872, 0.028784, -0.010362, 0.15181, 0.2186, 0.1163, -0.09258, -0.019701, -0.045861, 0.029997, 0.022719, 0.025102, -0.085651, -0.12411, -0.18246, 0.091966, 0.087081, 0.10736, 0.02811, 0.11508, 0.038288, -0.074858, 0.00036462, -0.075728, -0.25812, -0.60692, -0.57736, -0.12302, 0.10818, 0.016913, 0.13529, 0.090044, -0.017374, 0.016143, 0.0074706, 0.038153, 0.13808, 0.23128, 0.062212, -0.00078106, -0.0088352, 0.015948, -0.00050225, 0.11232, 0.010962, -0.063962, 0.042698, 0.075698, 0.18797, -0.034271, -0.07601, 0.040711, 0.0039277, -0.0081139, -0.015998, -0.060356, 0.025952, 0.042163, 0.082426, 0.1426, -0.042849, -0.063341, 0.0092863, 0.029864, 0.0060824, 0.059612, 0.030082, -0.027239, -0.0073659, -0.015225, 0.044419, -0.0053691, 0.022425, -0.0082636, -0.040837, -0.015422, 0.061348, -0.052846, 0.094366, 0.014526, 0.0037072, 0.044123, 0.045795, -0.030931, 0.017194, -0.019463, 0.0012436],
              [0.084114, -0.025621, -0.023222, 0.053008, 0.17224, 0.012469, 0.075122, 0.040763, 0.098101, 0.041479, 0.12636, 0.070298, -0.050007, -0.0054841, 0.030405, -0.089755, -0.21541, 0.01723, -0.13557, 0.095618, -0.1106, 0.10125, -0.076498, -0.00028541, -0.026246, -0.01948, -0.39778, -0.062144, -0.024341, -0.012827, -0.014662, -0.11255, 0.16096, -0.11228, -0.068533, -0.16356, -0.19654, 0.031038, 0.13193, -0.083423, -0.040716, 0.01381, 0.039666, 0.0099888, -0.047953, 0.00061003, 0.10343, 0.24891, 0.35782, -0.20933, -0.039926, 0.1942, 0.032188, -0.040504, -0.0032348, 0.17053, 0.35048, 0.24646, -0.12389, 0.01723, -0.20275, 0.13927, -0.014868, -0.11606, 0.050407, 0.052285, 0.21799, -0.056957, -0.20647, -0.045779, -0.17472, 0.05274, 0.099134, 0.094364, -0.060202, -0.043716, 0.05637, -0.008589, -0.096057, 0.019767, 0.0089128, -0.043515, 0.071434, 0.036366, 0.013984, 0.073848, 0.06407, -0.12431, -0.077473, -0.003077, 0.012412, -0.077233, 0.052213, 0.098481, -0.044983, 0.0093175, -0.014436, -0.018575, -0.016642, -0.20214, 0.023, -0.056258, -0.017621, 0.01913, 0.020008, 0.034833, -0.066635, 0.019123, 0.10428, 0.026511, 0.16287, 0.027933, 0.049607, 0.050049, 0.10194, -0.02588, 0.058534, -0.061181, 0.17253, -0.1346, -0.090408],
              [-0.027551, 0.20557, 0.082132, -0.04257, 0.015868, 0.0093698, -0.11463, 0.044712, -0.15996, 0.11866, 0.067392, -0.13863, -0.24992, -0.12742, -0.048942, -0.10909, -0.015852, 0.030011, -0.15749, -0.053421, -0.025663, -0.011093, 0.058389, 0.088245, -0.053728, -0.068366, 0.0026508, 0.097818, 0.016896, 0.0291, 0.15597, -0.017163, -0.047858, -0.066641, -0.04105, -0.029342, 0.18068, 0.23841, 0.1072, 0.0032504, -0.16876, -0.055652, 0.037864, 0.14497, 0.30165, 0.21781, 0.24781, 0.20611, -0.030505, -0.22355, -0.22058, 0.026161, -0.01449, -0.0013993, -0.032143, 0.069858, 0.12952, 0.062134, -0.09585, -0.15006, -0.04869, 0.027626, 0.087752, 0.059382, -0.15548, -0.008993, -0.21696, -0.20895, -0.17492, -0.10306, -0.08326, 0.10865, 0.060745, 0.050196, 0.059347, 0.08055, 0.096041, -0.17922, -0.08636, -0.19862, -0.085306, 0.073404, -0.00060916, 0.017865, 0.01523, -0.028739, -0.030631, 0.083547, -0.015199, 0.0079197, 0.10542, 0.04588, -0.016177, -0.064404, 0.05645, -0.0011676, 0.0019962, 0.067417, -0.0068873, 0.034856, 0.017611, -0.064975, 0.072135, -0.038534, -0.01402, 0.0002936, 0.12282, -0.084526, 0.072734, -0.026199, 0.26228, 0.056467, 0.026818, 0.093992, 0.035828, 0.18171, -0.015152, -0.017616, -0.0031862, -0.021179, -0.15214],
              [-0.13775, 0.038746, -0.00070857, 0.049355, -0.088279, 0.3385, -0.064155, 0.013423, -0.019629, -0.074514, -0.090356, 0.096941, -0.11911, -0.15101, -0.013947, -0.28748, -0.37904, -0.20281, -0.11304, 0.025054, -0.081019, 0.092552, 0.00082246, 0.24246, 0.12844, 0.13562, 0.089595, 0.23077, 0.17282, 0.1512, 0.2108, 0.13274, -0.11297, -0.23426, -0.15389, 0.04755, 0.13676, 0.14971, -0.014599, 0.024524, 0.15008, 0.02197, -0.017209, -0.12567, 0.057462, -0.12423, 0.027718, 0.07647, 0.15084, 0.16363, 0.10314, 0.098604, -0.077889, -0.1661, -0.015524, 0.033968, -0.0064288, -0.077784, -0.13139, -0.16493, -0.13708, -0.24997, -0.099387, -0.041816, 0.063393, 0.084657, 0.073596, 0.0096743, -0.056184, -0.097826, -0.20167, -0.035743, -0.053854, -0.094089, -0.11121, -0.037672, 0.031541, 0.092726, -0.024057, 0.0060108, 0.026069, 0.052952, -0.00074539, -0.039415, 0.00012582, -0.074806, 0.010524, 0.062406, 0.015814, -0.064838, 0.031266, 0.027508, 0.000127, 0.050797, 0.07897, 0.098318, 0.054193, -0.013031, 0.049683, 0.083509, 0.011784, 0.091872, -0.0066227, -0.047956, -0.01709, -0.078741, -0.046731, 0.018514, 0.0715, 0.064737, -0.032651, 0.061364, -0.039888, 0.06941, 0.077977, 0.066134, 0.055982, 0.072595, -0.053845, 0.096086, -0.028806],
              [0.044235, 0.034525, -0.13043, -0.035392, 0.017969, 0.035178, -0.010788, -0.0016502, 0.03915, 0.21473, -0.0948, -0.028715, 0.05486, -0.039324, -0.071941, -0.11931, 0.0078118, -0.13497, -0.22468, -0.041964, -0.1884, -0.12848, 0.032762, -0.0022056, 0.10278, 0.0012177, 0.077763, 0.014833, 0.25493, -0.14123, -0.028129, -0.090593, 0.078746, -0.013335, -0.013098, -0.085997, 0.0011501, -0.096292, 0.16218, -0.026281, 0.40592, 0.22426, 0.088915, 0.087381, 0.043236, 0.10435, -0.029683, -0.096107, -0.16573, -0.17367, -0.030961, 0.059506, 0.049326, 0.12757, 0.2398, 0.124, -0.27712, 0.1032, 0.071367, 0.066139, -0.017571, -0.21849, -0.096326, -0.013237, 0.141, 0.048656, 0.030847, 0.12063, 0.03194, 0.012664, 0.053035, 0.023359, 0.073601, -0.10515, -0.16524, -0.25669, -0.26897, 0.018566, 0.09359, 0.028128, 0.018697, -0.015875, -0.0079379, 0.03061, -0.015794, -0.095236, -0.029087, -0.13652, -0.073683, 0.054902, -0.060991, 0.09317, -0.0023871, -0.026191, -0.047989, 0.019892, 0.053632, 0.021996, -0.058485, -0.0082972, 0.085923, 0.007835, 0.0074973, 0.033528, 0.034259, 0.040069, 0.016642, 0.033377, 0.009459, 0.052065, -0.084929, -0.091861, -0.072335, 0.017511, 0.083823, 0.029829, 0.022676, 0.092824, 0.027105, 0.049933, 0.25204],
              [0.045017, 0.049864, 0.082321, 0.11789, 0.11184, -0.12533, 0.073011, 0.077004, -0.037179, 0.1153, 0.0573, 0.097849, -0.030605, -0.0069899, -0.043815, -0.041086, -0.10157, -0.030984, 0.062242, -0.08566, -0.031199, 0.094664, 0.18696, -0.16613, -0.0090085, -0.12607, 0.061744, -0.10059, -0.32554, -0.093973, -0.0841, -0.19413, -0.073753, 0.093207, 0.053699, -0.03051, 0.035499, -0.088218, 0.14082, -0.015418, -0.14008, -0.021416, 0.073018, -0.17727, 0.049671, 0.034513, 0.10331, -0.039224, 0.032001, -0.3171, 0.36395, 0.15239, 0.12007, 0.012633, 0.13528, -0.043263, -0.041986, 0.069839, 0.0010106, -0.0011775, -0.011795, -0.14349, 0.022137, -0.039688, 0.26218, 0.19437, 0.11018, 0.022791, -0.097375, -0.016626, 0.15981, 0.079561, -0.075452, -0.028024, -0.12778, -0.070601, 0.075855, -0.061104, -0.034255, 0.047001, 0.085957, 0.042827, 0.035824, -0.0061232, -0.038509, 0.052491, -0.012429, 0.027802, -0.045634, 0.05733, -0.074158, 0.001283, 0.047032, 0.024833, 0.037205, -0.028766, 0.04836, -0.05327, -0.12254, 0.03712, -0.089284, 0.064955, 0.077539, -0.027112, 0.095663, -0.024484, -0.036212, -0.093916, -0.01732, -0.10222, -0.088399, 0.018021, 0.014346, -0.0045931, -0.041331, 0.037071, 0.032109, 0.13273, 0.07511, 0.025628, 0.14213],
              [0.15729, -0.052979, -0.0026258, 0.078995, 0.082044, -0.13536, -0.013649, -0.013141, 0.011513, 0.051596, 0.02555, -0.039487, -0.034658, 0.072491, -0.11567, 0.067864, 0.068651, 0.073986, -0.16154, 0.040446, 0.071466, -0.11469, 0.054051, -0.041043, 0.14997, -0.25422, 0.19697, 0.11291, -0.020531, 0.1289, -0.10368, 0.096092, 0.15325, 0.05149, 0.03356, -0.2083, 0.022894, -0.2625, 0.019209, 0.23588, 0.012602, 0.20972, 0.092569, 0.10591, 0.074214, 0.028278, -0.034766, 0.025387, -0.21115, -0.18143, -0.036903, 0.074542, -0.073943, -0.12923, -0.10287, -0.0020479, 0.0070328, 0.041659, -0.030914, 0.20126, -0.36149, -0.59189, -0.34765, -0.29918, -0.043195, -0.30777, -0.054571, 0.035677, 0.033779, -0.11152, 0.11791, 0.50742, 0.23856, 0.10489, 0.074815, -0.010758, 0.098422, 0.068012, 0.040081, -0.17816, 0.015218, -0.043045, 0.069479, 0.26248, 0.13062, 0.15898, 0.098913, 0.16691, -0.045456, -0.051218, 0.088652, -0.024238, -0.12061, -0.13933, -0.098448, 0.084104, 0.036095, 0.064677, 0.019557, 0.054585, 0.011804, 0.049628, 0.03158, -0.042128, -0.037247, -0.00090228, 0.051276, 0.017591, 0.020608, 0.12021, 0.039022, 0.021712, 0.047172, 0.11458, 0.065529, 0.057133, -0.064146, -0.079154, -0.084204, -0.13318, -0.097193],
              [0.016239, 0.0039663, -0.0045547, 0.013554, 0.042874, -0.15275, -0.027275, 0.0096628, 0.00030503, 0.032218, -0.036021, -0.042601, -0.041216, 0.070225, 0.088251, -0.11944, 0.016009, -0.025892, 0.043719, 0.04635, -0.04552, 0.057802, 0.032998, -0.074789, 0.085613, -0.082967, 0.12226, 0.056996, 0.22311, -0.12892, 0.028712, -0.082295, 0.074671, 0.024026, 0.070656, 0.052863, 0.13163, 0.08385, 0.019373, 0.068601, 0.16045, 0.14512, 0.090972, -0.11721, -0.1096, -0.2299, -0.040375, -0.2017, 0.21032, 0.028437, 0.064869, -0.18349, -0.17888, -0.24993, -0.12182, -0.032695, -0.0037869, -0.24886, -0.15602, -0.42476, -0.4236, -0.3608, -0.18904, -0.056628, 0.0019947, 0.0099847, 0.10753, 0.21965, 0.18511, 0.1994, 0.23706, 0.15855, 0.23756, 0.24027, 0.14806, 0.22744, 0.12507, -0.12208, 0.041225, 0.12974, 0.13877, 0.092819, 0.041457, 0.12811, 0.086282, 0.046482, 0.035985, -0.15, -0.061995, -0.12775, -0.055469, -0.072056, -0.0312, -0.021698, -0.02032, -0.011808, -0.10717, -0.082342, -0.019256, 0.066679, -0.041537, -0.040688, 0.044725, -0.068305, 0.035585, 0.026946, -0.011423, 0.061366, -0.049741, 0.054485, 0.14247, 0.03771, 0.014815, -0.12197, -0.040853, -0.0048073, -0.093844, -0.11067, -0.013085, 0.020004, 0.11572],
              [0.02862, 0.054226, 0.017679, -0.054622, 0.00068166, -0.061011, 0.02545, 0.039249, -0.017614, 0.086689, 0.12902, -0.059156, -0.033658, -0.11303, -0.0094407, 0.0383, -0.024382, 0.13095, -0.17637, -0.042536, 0.024839, 0.025341, 0.073379, 0.1249, 0.052335, 0.019594, 0.01441, 0.069392, 0.10115, -0.017834, -0.0052539, -0.04945, -0.018515, 0.027327, 0.097636, 0.13398, 0.028129, 0.10346, 0.1456, -0.062226, -0.043205, -0.13615, 0.0094596, 0.077643, -0.018838, 0.040125, 0.046083, 0.11596, 0.041671, -0.035255, -0.2421, 0.13413, -0.12174, -0.002494, 0.019159, -0.28596, -0.064486, -0.31594, -0.32104, -0.52704, -0.52371, -0.22197, 0.078178, 0.037153, 0.079429, 0.054711, -0.030973, -0.17109, 0.096072, 0.023265, 0.1823, 0.50842, 0.36327, -0.17443, -0.075941, 0.084583, -0.082641, 0.24079, 0.12328, 3.0311e-05, 0.20734, 0.13349, 0.14204, -0.016683, 0.0026274, -0.0506, -0.093502, 0.049347, 0.02717, 0.0088067, 0.29974, -0.017371, 0.060473, -0.083275, -0.048734, -0.12259, 0.074538, 0.0016868, -0.046678, 0.10226, 0.096413, -0.085168, 0.011075, -0.058526, -0.032743, -0.17221, 0.10626, 0.045123, 0.063157, -0.023657, -0.086189, -0.097156, -0.11779, -0.0018161, -0.018375, -0.022155, 0.069073, 0.061843, 0.057417, 0.030372, 0.089788],
              [-0.0016376, -0.015234, 0.033084, 0.01043, 0.026387, -0.055493, -0.089868, 0.031318, -0.060212, 0.060345, 0.033638, 0.074908, 0.067344, 0.045409, -0.016588, 0.11809, 0.10675, 0.014357, -0.00029905, 0.03249, -0.079691, 0.0021152, 0.12843, 0.027686, 0.051037, 0.0095028, -0.088577, 0.072415, 0.18759, -0.04626, 0.032834, 0.00027334, -0.0056259, 0.051335, -0.028998, 0.010804, 0.039279, 0.059935, -0.036673, 0.0020456, 0.084205, 0.078722, 0.072928, 0.0029102, -0.014711, 0.061979, -0.0058614, -0.0065096, 0.15462, 0.10999, 0.05512, 0.057246, 0.084674, 0.045416, -0.027011, -0.41691, -0.23816, -0.26803, -0.42974, -0.47129, -0.47538, -0.23333, -0.028661, -0.046786, -0.013911, 0.063557, 0.20817, 0.1268, 0.19585, 0.24121, 0.34248, 0.22, 0.036994, -0.24941, -0.12912, 0.0067608, -0.01638, 0.023976, 0.17281, 0.067747, 0.099348, 0.035398, -0.034632, 0.11009, 0.0053132, -0.18523, -0.015871, 0.008623, 0.038924, -0.014894, -0.015236, 0.0015905, -0.025942, -0.048033, 0.056968, -0.005355, 0.070041, -0.019904, 0.10013, -0.030663, 0.014936, -0.053377, -0.046191, -0.049737, -0.032035, -0.026289, -0.0073802, -0.0085777, -0.067451, 0.036965, 0.012119, -0.012732, -0.014068, 0.011209, -0.0034198, 0.12162, -0.090967, 0.062061, -0.023761, 0.11195, 0.10944],
              [-0.061429, -0.024855, 0.037534, 0.053055, -0.02909, -0.076608, -0.05625, 0.038513, 0.0094111, 0.027628, -0.040484, 0.062572, 0.018534, 0.099954, -0.011584, -0.027052, -0.0059961, -0.021254, -0.031552, 0.13842, 0.0044655, 0.079159, 0.093307, 0.021057, -0.020072, 0.0078349, 0.10646, 0.11394, 0.095624, -0.00037973, -0.010567, -0.021229, 0.11951, 0.15659, 0.051157, -0.061499, 0.080078, -0.060313, 0.10862, 0.090833, 0.03775, 0.12669, 0.019289, 0.11166, -0.11612, -0.038271, -0.013962, 0.057456, 0.035911, 0.11685, 0.020811, 0.042275, -0.11787, -0.20632, -0.1034, -0.032371, -0.14327, -0.25192, -0.43351, -0.32253, -0.3976, -0.39288, -0.39114, -0.2467, -0.087921, -0.088613, -0.15981, 0.18786, 0.19151, 0.46364, 0.15919, 0.19353, 0.23198, 0.41944, 0.29117, 0.13265, -0.041281, 0.024461, -0.058649, -0.048431, 0.074459, 0.038048, -0.04011, 0.05987, 0.052512, -0.0090562, 0.023537, -0.068198, -0.058682, -0.031438, 0.05729, 0.096319, -0.010632, -0.072423, 0.026755, 0.018666, -0.035083, 0.0033659, -0.026, 0.051531, -0.095878, -0.072904, -0.067948, 0.0043261, -0.0040118, -0.0054864, -0.0070406, -0.023664, -0.021349, -0.055765, 0.076203, 0.057795, 0.0049914, -0.014554, -0.029744, -0.057165, -0.0010086, -0.035362, -0.0047531, -0.011301, 0.11501],
              [0.15174, -0.014179, 0.016877, -0.077205, 0.078108, -0.13113, 0.0027535, 0.051911, 0.028948, 0.050209, -0.0045795, -0.10685, 0.011155, 0.065186, -0.13027, -0.080144, 0.10736, 0.04888, 0.015759, 0.12191, 0.096985, -0.0080833, 0.020705, -0.081938, 0.0046465, 0.056148, 0.16628, 0.046183, 0.077658, -0.019961, -0.096538, 0.079466, 0.25805, 0.0077622, 0.06952, 0.0095238, 0.26152, 0.086788, -0.037402, 0.069486, 0.071695, 0.13258, -0.021458, 0.056046, -0.00039375, 0.032222, 0.18458, -0.04254, -0.012964, 0.1701, -0.023562, 0.051153, -0.13166, 0.020665, -0.24023, 0.038647, -0.025858, -0.081456, -0.11687, 0.044401, -0.35731, -0.6458, -0.40588, -0.30571, -0.12682, -0.33498, 0.015693, -0.078712, -0.043104, -0.15482, -0.23546, 0.11117, 0.45545, 0.18491, 0.29247, 0.19673, 0.19711, 0.073292, 0.0082412, -0.11507, -0.0097699, -0.10086, 0.06842, -0.054338, 0.077438, 0.17116, 0.001288, 0.13426, 0.1106, -0.073247, 0.037258, -0.012267, 0.073659, 0.043783, -0.10715, 0.086654, -0.068763, -0.058722, 0.044547, -0.055318, 0.033045, 0.057546, 0.0013722, 0.024826, -0.12204, -0.1019, 0.054773, -0.079578, -0.038229, 0.036495, 0.13217, 0.057211, -0.025832, -0.054716, 0.013914, 0.12333, 0.0048703, 0.0051744, 0.02839, -0.021508, -0.034672],
              [-0.0056384, -0.034135, -0.022985, -0.060425, 0.054919, 0.068881, -0.0070135, -0.0064886, -0.074997, -0.0025759, 0.023015, 0.0083653, -0.031176, 0.042573, -0.066109, 0.029356, -0.013292, 0.056362, 0.034219, -0.012595, -0.014012, -0.062381, -0.07114, 0.0024196, -0.035945, 0.045638, -0.0047184, 0.066745, 0.0453, -0.044479, 0.089641, -0.096496, -0.027741, -0.0057168, 0.015013, -0.024603, 0.0013274, -0.035627, 0.017129, -0.045973, 0.0070037, -0.043147, -0.029564, -0.020695, -0.079785, 0.026834, -0.0019309, 0.083258, 0.10733, 0.074877, 0.048498, 0.091698, 0.048185, 0.052096, 0.0076798, 0.10519, 0.02253, 0.12672, 0.059197, 0.073166, 0.11595, 0.056154, 0.12933, 0.088424, 0.030087, 0.069156, 0.12092, -0.089932, -0.019015, -0.044735, 0.11876, 0.0019622, 0.098963, -0.014936, -0.058157, -0.030281, 0.039004, -0.084991, -0.046013, -0.014914, 0.021156, 0.064216, -0.02398, 0.028088, -0.015711, 0.055355, -0.10472, -0.089683, -0.28534, -0.18319, -0.080774, 0.0051665, 0.057863, 0.064364, 0.089305, 0.033738, -0.12463, -0.15877, -0.35595, 0.095129, -0.14725, -0.20316, -0.084143, -0.2132, -0.18019, -0.21194, -0.10023, -0.021533, -0.037309, 0.12624, 0.22035, 0.1891, 0.15893, 0.012004, 0.054019, -0.028528, 0.0032336, -0.0066272, 0.084693, 0.11629, 0.19103],
              [-0.08632, -0.042516, -0.0087762, 0.021241, 0.0047851, -0.035472, 0.0066937, -0.00018714, 0.0082764, 0.03874, -0.068078, -0.050242, 0.0053628, -0.046723, 0.094159, 0.025987, 0.028403, 0.12799, 0.052174, 0.031742, 0.043517, 0.1003, 0.009888, -0.035094, -0.0070136, 0.069061, 0.096711, 0.081381, 0.057645, 0.011067, -0.018381, -0.082602, -0.052684, -0.01996, 0.019919, 0.074764, 0.0037734, -0.0014401, -0.10891, -0.057902, 0.062403, 0.10607, 0.093356, 0.16322, -0.044312, -0.0066519, 0.024113, 0.064553, 0.15171, 0.30458, 0.087042, -0.13006, -0.11938, 0.02659, -0.061874, 0.099973, 0.06382, 0.11767, 0.10413, -0.064651, -0.64839, -0.57719, -0.036256, 0.17484, -0.082879, -0.052896, 0.093451, 0.13223, -0.0031159, -0.20504, -0.56713, -0.17042, 0.51278, 0.080572, -0.069035, -0.076494, -0.0087908, 0.063359, -0.019296, -0.26311, -0.26432, 0.00439, 0.41748, 0.23966, -0.073562, -0.09551, -0.23475, 0.028298, 0.061075, -0.16177, -0.0028367, 0.094222, 0.12827, 0.14707, 0.071302, -0.074737, -0.23885, -0.085022, -0.07147, 0.0091791, -0.00092606, 0.084224, 0.07315, -0.027624, -0.10044, -0.0028873, 0.084866, 0.01031, -0.00054869, 0.084218, 0.005403, 0.095305, 0.021416, 0.032093, 0.095158, -0.064421, 0.028975, -0.0069886, 0.15811, 0.077388, 0.22282],
              [0.076468, 0.094525, 0.013417, -0.065411, 0.0022049, -0.19543, -0.010363, 0.0006824, -0.025036, 0.1071, 0.17509, 0.14614, 0.053718, 0.033399, 0.058514, 0.10089, 0.12393, 0.00030037, -0.072506, -0.053549, -0.068975, 0.068143, -0.0032047, -0.023764, -0.033057, -0.046769, -0.12086, 0.13198, 0.010909, 0.11806, 0.00055654, -0.0058049, 0.035993, -0.0082657, 0.068351, 0.0301, 0.113, 0.049423, -0.18769, -0.089816, 0.12209, 0.065398, -0.23088, 0.013401, -0.096887, 0.096593, 0.089715, -0.0038843, 0.12013, 0.37404, 0.21211, -0.011527, -0.049284, 0.018755, -0.082645, 0.10818, -0.058116, -0.049761, 0.038468, -0.27345, -0.84643, -0.29645, 0.088276, 0.11387, -0.043246, 0.0080367, -0.10745, -0.31047, -0.044148, -0.17805, 0.27176, 0.52375, -0.34603, -0.25553, 0.041699, 0.17631, 0.089, -0.034972, 0.015214, -0.16155, -0.0044616, -0.19608, 0.52391, 0.38353, -0.18308, -0.36866, -0.0516, 0.18508, -0.03906, -0.11294, -0.29448, -0.24258, -0.020336, 0.1646, 0.042029, -0.034579, -0.080621, 0.0023781, 0.09709, 0.25587, -0.25284, 0.061611, 0.09607, -0.053049, -0.016158, -0.051428, 0.15564, 0.18886, 0.0084349, -0.048989, 0.17712, 0.19164, 0.18133, 0.13612, 0.1653, -0.029342, -0.042788, -0.053546, 0.043048, 0.00043498, 0.043392],
              [-0.067392, 0.15604, 0.33006, 0.17019, -0.0097699, -0.11247, -0.09464, -0.024494, -0.0039792, 0.10994, 0.034233, 0.17574, -0.058308, -0.086036, -0.089378, 0.13061, 0.083343, 0.045589, -0.0215, -0.039618, -0.040283, -0.054908, -0.029621, 0.033422, -0.18107, 0.062628, -0.15452, 0.16302, -0.19246, 0.025899, 0.13802, 0.042581, -0.10232, -0.047879, -0.084652, -0.10421, -0.11475, -0.077448, 0.17513, 0.31631, -0.21234, -0.13718, 0.032256, 0.16117, 0.12437, -0.19602, -0.10317, -0.17989, -0.030777, 0.36723, 0.26823, -0.14256, -0.34284, -0.16863, 0.20718, -0.04361, -0.21591, -0.35645, -0.35914, -0.35654, -0.22838, -0.25415, -0.027038, 0.1043, 0.070313, 0.19633, 0.011469, 0.056101, 0.20979, 0.31383, 0.36266, 0.15633, 0.043118, 0.15942, 0.138, 0.082457, -0.097363, 0.017536, 0.18875, 0.1323, 0.09316, 0.10016, 0.041772, -0.16461, -0.01027, -0.016122, -0.10278, -0.093043, -0.049187, 0.011398, -0.00027008, 0.0074397, -0.20028, -0.11833, 0.015078, -0.018453, -0.036365, -0.020538, 0.067467, 0.098981, -0.0055674, -0.092027, -0.011441, 0.040493, 0.072107, 0.047545, -0.010628, 0.010379, -0.037361, 0.049441, 0.23173, 0.066224, 0.053604, 0.070224, 0.00044744, -0.024041, 0.017027, 0.082502, 0.044118, 0.094446, 0.02607],
              [-0.014874, 0.0064653, 0.18058, 0.1064, 0.14624, -0.18549, -0.11947, 0.13337, 0.14316, 0.21268, 0.074573, -0.023663, 0.00030163, 0.034924, 0.00049764, -0.27861, 0.019649, 0.22429, 0.10635, -0.055747, -0.17203, 0.14652, 0.083678, 0.08006, 0.12677, -0.2096, -0.11993, 0.079651, -7.05e-05, -0.1316, -0.12186, -0.12212, -0.063472, 0.11592, -0.00031212, -0.16159, -0.2051, -0.015211, 0.33419, -0.021198, 0.051574, -0.081191, -0.024248, 0.031953, 0.08989, -0.055348, -0.19027, -0.20571, -0.00342, 0.42337, 0.27261, -0.084998, -0.27009, -0.26985, -0.17357, 0.049621, -0.003575, 0.036593, 0.0086359, -0.27033, -0.39995, -0.17184, -0.24084, -0.20002, -0.25264, 0.04389, -0.06426, 0.074044, -0.01414, 0.12916, 0.13074, 0.027929, 0.018943, 0.12691, 0.28765, 0.28887, 0.29998, -0.037028, 0.049534, -0.018197, 0.19754, -0.0048382, -0.067002, 0.095329, -0.077329, 0.097922, 0.11727, 0.051206, 0.014744, 0.074516, 0.076595, -0.10213, -0.010104, 0.053405, 0.025968, 0.042843, -0.03165, -0.10112, -0.062004, 0.080997, -0.096227, 0.0027223, 0.0032193, 0.028018, -0.080393, -0.068244, -0.0065763, -0.10139, 0.005777, -0.0019333, -0.028478, 0.078148, 0.0046718, 0.086526, 0.07515, 0.080912, 0.14299, 0.058255, 0.060032, 0.069309, 0.13734],
              [-0.026403, -0.020918, -0.035102, -0.014307, -0.0042972, -0.058078, 0.038179, -0.0028112, -0.0038941, 0.0018813, -0.10079, 0.021583, 0.073512, 0.054528, 0.18988, 0.13986, 0.072941, 0.059257, 0.031091, -0.015845, -0.023618, -0.064937, 0.075643, -0.079466, -0.020769, -0.10404, -0.033013, 0.072788, 0.10548, 0.0019405, -0.0070426, -0.028399, 0.045186, -0.019186, 0.10715, 0.11823, 0.038571, -0.027458, -0.098265, 0.056391, 0.040157, 0.12887, -0.031556, -0.02314, 0.069122, 0.025102, 0.029789, -0.070653, 0.016315, 0.28689, 0.17026, 0.012541, 0.070851, 0.0048605, 0.033198, -0.091329, -0.15097, -0.024121, -0.02457, -0.41481, -0.77687, -0.27461, 0.13786, 0.13545, 0.13314, 0.082653, 0.089238, -0.044081, -0.076883, 0.126, 0.40959, 0.087069, -0.46621, -0.43761, -0.10812, 0.017686, 0.1273, -0.064747, -0.10763, -0.085248, -0.2315, 0.15315, 0.5562, 0.23775, -0.16669, -0.17716, -0.16977, 0.025009, 0.060378, -0.20713, -0.18646, -0.080662, -0.0061085, 0.13479, 0.056632, 0.17463, 0.017491, -0.015088, -0.051792, 0.086679, -0.043885, 0.048343, -0.11503, 0.1406, -0.062258, -0.11335, -0.064954, 0.027741, 0.11898, 0.030261, 0.17154, 0.057333, 0.16205, 0.098609, 0.073912, -0.090816, -0.010371, 0.092276, 0.1103, -0.0058808, 0.03315],
              [0.2655, -0.0011966, -0.022917, 0.04243, -0.13812, -0.037431, -0.04056, -0.023934, 0.079259, -0.034522, 0.1745, 0.041791, -0.022741, -0.001354, -0.10139, -0.053306, 0.058909, 0.093373, 0.05014, 0.0084539, 0.021167, 0.10388, 0.0076348, 0.013139, -0.075217, 0.015069, 0.24056, 0.064464, -0.061521, -0.084694, -0.068058, -0.010292, -0.035799, -0.047138, -0.030265, 0.025114, 0.16953, -0.081754, -0.16484, -0.090216, 0.19964, 0.18826, 0.045615, 0.10861, -0.028329, -0.10352, 0.075322, -0.034013, -0.058696, 0.44091, 0.084019, -0.01285, -0.042461, 0.13376, -0.12951, 0.0026411, 0.044978, -0.090312, 0.055734, 0.060061, -0.71528, -0.28235, 0.031272, 0.11881, -0.0042768, -0.011348, 0.0023675, 0.00043486, 0.18959, -0.08576, -0.45258, 0.15962, 0.31737, -0.062412, -0.33746, -0.24412, -0.061413, 0.13079, 0.20848, -0.20955, -0.28813, 0.14444, 0.46815, 0.085139, -0.22659, -0.027717, -0.16856, -0.13754, 0.1506, 0.00078477, -0.17891, -0.067289, 0.11814, 0.1094, 0.10648, -0.07785, -0.24214, -0.15597, 0.018452, -0.0653, 0.042694, 0.11064, 0.1346, 0.030738, -0.01497, 0.039307, 0.041005, -0.028334, 0.015742, 0.11427, 0.021003, 0.0077222, -0.00084806, 0.056397, -0.1125, -0.064031, 0.026888, 0.12622, 0.25062, 0.11068, 0.26257],
              [0.072041, -0.022942, 0.20655, 0.0021518, -0.14297, 0.00060653, -0.058092, 0.13818, 0.17792, 0.12334, 0.0044529, -0.04606, -0.071586, -0.10074, -0.07374, -0.018046, -0.11863, 0.17618, 0.14978, -0.060747, -0.0027956, 0.16786, -0.10698, 0.083, 0.12903, 0.047203, -0.030334, 0.099121, -0.051747, -0.20798, -0.0060523, -0.2464, 0.002543, 0.056676, 0.13754, -0.079126, -0.17639, 0.055182, 0.29993, -0.12375, -0.15473, -0.015286, -0.0054135, -0.08584, 0.22138, -0.1313, -0.33147, -0.21124, 0.24712, 0.46372, 0.0027062, -0.24161, -0.10142, -0.18323, 0.11158, 0.1676, 0.029994, 0.025682, -0.11959, -0.33142, -0.15445, -0.16382, -0.18307, -0.40205, -0.26594, -0.15682, -0.0002612, -0.028756, 0.27425, 0.21593, 0.25487, 0.097667, 0.20034, 0.19879, 0.30686, 0.17247, 0.018739, -0.031064, 0.026366, -0.18777, -0.15481, -0.037429, -0.11875, 0.10726, 0.17942, 0.11733, 0.0052779, 0.23972, 0.0079701, -0.051503, 0.05532, -0.040008, -0.092708, -0.031471, -0.098759, -0.09293, 0.055518, -0.037796, -0.0063426, 0.024883, 0.034983, 0.071931, -0.031592, -0.08635, -0.0090017, 0.071457, -0.060722, -0.14319, -0.048321, 0.081485, -0.028272, 0.063684, 0.005548, 0.11811, 0.14065, 0.00406, -0.013719, 0.12724, 0.099627, 0.13232, 0.13873],
              [-0.027796, 0.19015, 0.097864, 0.12603, -0.033269, -0.089501, 0.04756, 0.073741, 0.10899, 0.010866, -0.057266, 0.17803, -0.063867, 0.018021, 0.025919, 0.052576, -0.021274, -0.13049, 0.029636, 0.021721, 0.074926, 0.05983, -0.076901, -0.026485, -0.15053, -0.13725, 0.087833, 0.066023, -0.091947, -0.2149, -0.020022, 0.061471, 0.041399, 0.031512, -0.0153, 0.026068, -0.033971, -0.056572, 0.18971, 0.088995, -0.15964, -0.16587, -0.11188, 0.12235, -0.052308, -0.37845, -0.096614, -0.069048, 0.066169, 0.45011, 0.11905, -0.089093, -0.12905, -0.036526, 0.054822, 0.02481, -0.29747, -0.29999, -0.30525, 0.020997, -0.24089, -0.24201, -0.089791, 0.040398, 0.02526, 0.027389, 0.27071, 0.36232, 0.17799, 0.14461, 0.039188, -0.12174, 0.06238, 0.053787, 0.077565, 0.089143, -0.082913, 0.047936, 0.032228, 0.13504, 0.01206, -0.0045403, 0.048158, 0.081652, 0.042006, 0.0009472, 0.013452, 0.046158, -0.08677, -0.01951, -0.011155, 0.027566, 0.061728, 0.012115, -0.023208, -0.031607, 0.059643, -0.036766, -0.015929, 0.0064081, -0.081899, -0.02977, -0.088821, -0.028071, -0.023692, -0.019599, 0.057438, -0.038196, -0.011284, 0.039955, 0.099448, 0.06855, 0.073048, 0.062483, 0.026346, 0.051335, 0.055075, 0.054677, 0.024906, 0.045384, 0.032908]
            ],
            "sobel": [
              [0.021622, -0.039044, -0.037054, -0.070222, -0.14277, 0.010719, 0.23521, 0.042586, -0.066839, -0.035786, -0.040592, -0.04765, 0.015366, -0.0089413, -0.018094, -0.041156, 0.059194, 0.03497, 0.0085535, -0.012133, 0.037119, 0.011104, 0.013667, 0.057116, -0.039502, 0.0017173, -0.10081, 0.037478, 0.16095, -0.067174, -0.034198, 0.04378, -0.02895, -0.075339, -0.037953, 0.015621, -0.0062937, -0.11864, 0.049183, 0.1707, -0.019043, -0.042438, -0.017632, -0.075732, 0.0095324, 0.03293, -0.014258, -0.0098967, -0.080728, 0.076951, 0.1301, -0.11441, 0.020647, 0.0074901, 0.029524, -0.012759, -0.0093581, -0.0058362, 0.064104, -0.1647, 0.094418, 0.13507, -0.044142, -0.052786, -0.010841, -0.006663, -0.023002, 0.028816, 0.041661, -0.032028, -0.061565, 0.13252, 0.13007, -0.12915, 0.0036202, 0.036105, -0.012106, 0.0040582, -0.061908, 0.0076004, 0.03672, -0.14106, 0.20292, 0.060389, -0.09659, 0.054589, -0.10019, 0.041123, -0.036635, 0.116, -0.072959, 0.0058381, -0.080459, 0.15241, 0.064258, -0.09976, -0.038509, 0.0044402, -0.027742, -0.034369, -0.015116, 0.0058884, 0.046096, -0.057577, 0.10123, 0.074735, -0.08287, 0.016464, -0.035808, -0.034751, -0.0037474, -0.026826, 0.0056597, -0.06777, 0.056803, 0.22043, 0.017122, -0.14459, -0.079001, -0.0448, -0.099982],
              [-0.039422, -0.057937, 0.074729, -0.048045, -0.037188, 0.052703, 0.26143, -0.061949, -0.10675, 0.031812, -0.051385, -0.006001, -0.00075896, -0.0050347, -0.041065, -0.017209, -0.0095906, 0.13126, -0.051458, -8.2457e-05, -0.063001, 0.0066233, 0.0045051, -0.0083206, 0.034913, 0.012367, -0.059277, 0.052288, 0.1547, -0.051592, -0.045779, -0.007896, -0.018757, -0.094971, 0.065529, -0.029159, 0.046869, -0.070025, 0.062731, 0.12066, -0.068658, -0.019059, 0.0074337, -0.067123, 0.02053, 0.013044, 0.0035088, -0.01203, -0.097183, 0.028502, 0.15192, -0.07064, -0.075749, 0.031913, -0.031982, -0.023049, -0.030048, -0.0032721, 0.060009, -0.10611, 0.0716, 0.029747, -0.055757, 0.010541, -0.038579, -0.013056, -0.046604, 0.045825, -0.011912, -0.011527, -0.095327, 0.05184, 0.069492, -0.078788, -0.022076, 0.055685, -0.02869, -0.01075, -0.034159, -0.03803, 0.057879, -0.13134, 0.085608, 0.12614, -0.044827, -0.049757, -0.024712, -0.071507, -0.024192, 0.01363, 0.048434, 0.024359, -0.0051155, -0.10514, 0.14444, -0.0088548, -0.068772, 0.041549, -0.034167, -0.021582, 0.030183, -0.0040015, -0.0083662, 0.026868, -0.022178, 0.083314, 0.01001, -0.030072, 0.037843, -0.070384, -0.083549, -0.036392, -0.016616, 0.062408, -0.091602, -0.006843, 0.095086, 0.048339, -0.027514, -0.13109, -0.096684],
              [0.026522, -0.045758, -0.0065412, -0.085061, 0.14723, 0.047881, -0.019734, -0.051042, -0.066675, -0.018868, -0.041408, -0.11352, 0.064944, 0.026472, -0.00090233, 0.012634, 0.016737, 0.006623, -0.027195, -0.013684, -0.053134, -0.037127, -0.022633, -0.0018942, 0.033462, -0.11825, 0.020164, 0.11023, -0.034399, -0.0040491, 0.015541, -0.018763, 0.031383, -0.034906, 0.0084091, -0.044335, -0.0185, -0.036774, 0.11925, -0.066557, -0.015722, 0.008805, -0.073061, 0.02431, -0.0022227, -0.027085, 0.11301, -0.089658, -0.069331, 0.15228, -0.11814, 0.041523, -0.055859, 0.035897, -0.02284, -0.062359, 0.017954, -0.0023517, 0.024292, -0.020141, 0.16616, -0.060547, -0.095994, -0.035172, 0.00017003, -0.054487, 0.0051047, -0.024971, -0.026949, 0.13212, -0.015913, 0.14877, 0.079641, -0.1123, -0.0092442, 0.058819, -0.07792, -0.090482, 0.11103, 0.042626, -0.0021955, -0.036122, 0.047147, 0.18616, -0.063269, -0.063506, -0.029535, -0.029987, -0.016003, -0.030794, 0.0070419, -0.030444, -0.12719, 0.041134, 0.20405, -0.029811, -0.087053, -0.016364, -0.037892, -0.026402, -0.013779, -0.013032, -0.053538, -0.05678, -0.079377, 0.18237, 0.04188, -0.046827, -0.01942, -0.032796, -0.17044, -0.054026, -0.012647, -0.067306, -0.10224, -0.34972, 0.21799, 0.33122, -0.020319, -0.12057, -0.11657],
              [-0.034746, 0.011922, -0.098449, 0.18031, 0.17477, -0.046518, -0.10946, -0.075727, -0.0042795, -0.017697, -0.093984, -0.0108, -0.0045569, -0.031379, -0.11851, 0.2367, -0.014786, -0.063302, 0.022537, -0.025072, -0.0027915, -0.020335, -0.026008, 0.010703, -0.04303, -0.047196, 0.12322, 0.071786, -0.065282, -0.067638, -0.030062, 0.0027285, -0.030746, 0.0343, -0.015485, 0.00061797, -0.12212, 0.050023, 0.1468, -0.084455, -0.010416, 0.017746, -0.037889, -0.0042453, -0.074445, -0.011522, 0.0065318, -0.093068, 0.00025768, 0.23352, -0.004984, -0.070961, -0.040406, 0.0038935, -0.063088, 0.0028549, -0.011365, -0.0051872, -0.011323, -0.15258, 0.10053, 0.12368, -0.077847, -0.059471, 0.028026, 0.048886, -0.019665, -0.017241, -0.041027, 0.001151, -0.082242, 0.078605, 0.16229, -0.010524, -0.030966, -0.041504, -0.039719, -0.038749, 0.05147, 0.030039, -0.051469, -0.060313, -0.081418, 0.17732, 0.02522, -0.012728, -0.064523, -0.013167, -0.013895, -0.049376, 0.01418, 0.00062313, 0.0072845, -0.10894, 0.027785, 0.19202, -0.085036, 0.023989, -0.022828, -0.014372, -0.026342, -0.0055468, -0.019471, -0.033932, -0.0091537, -0.036739, 0.10446, 0.02097, 0.024776, -0.07883, -0.053245, -0.010433, -0.010211, -0.051308, 0.037884, -0.099324, -0.12671, 0.083829, 0.12485, -0.019875, 0.021159],
              [-0.073813, 0.045554, 0.21318, 0.054486, -0.10982, -0.10268, -0.046501, -0.055664, -0.020863, -0.001624, -0.0026296, 0.0099974, -0.10344, -0.0080814, 0.20537, 0.061264, -0.059836, -0.03879, -0.053678, 0.019924, 0.00067537, -0.035726, -0.035441, -0.024734, -0.1508, 0.10616, 0.18685, -0.06407, -0.067087, -0.0055311, -0.086093, 0.061426, -0.035219, -0.039575, 0.049802, -0.033981, -0.11534, 0.1808, 0.1276, -0.083274, 0.0040506, -0.0099809, -0.067759, 0.0026836, -0.0080343, 0.023532, 0.043117, -0.14059, -0.0016268, 0.15585, 0.069627, -0.12437, -0.02648, 0.020383, -0.028769, -0.0062858, -0.028321, -0.011687, -0.029153, -0.094922, 0.052872, 0.11088, 0.054252, -0.053297, -0.027559, -0.038545, 0.011349, -0.026962, -0.005885, 0.0020657, -0.062056, 0.027107, 0.07672, 0.0095546, 0.062121, -0.03263, -0.021507, -0.052784, 0.0030423, -0.0080316, -0.063925, -0.00021021, -0.10025, 0.10155, 0.064158, -0.069916, 0.082103, -0.046503, -0.0048848, -0.027586, -0.014081, 0.019043, -0.033131, -0.0089136, -0.054256, 0.11973, -0.018269, -0.023884, 0.049232, -0.014578, 0.046128, -0.07511, 0.046627, -0.041747, -0.032515, -0.054339, 0.017222, 0.11677, -0.026438, -0.032103, -0.055241, 0.056236, 0.0099623, -0.032474, -0.019767, -0.029422, -0.050974, -0.086443, 0.012599, 0.066122, 0.012114],
              [0.00046674, 0.0005485, -0.00013619, -0.00013253, -0.00080157, -2.6911e-05, -0.00065764, -3.658e-05, -5.466e-05, 0.00014605, -0.00016962, -0.00015906, 0.00011235, 0.00050518, 0.00015356, -0.00031324, -0.00044301, 0.000532, 2.3645e-05, -8.4832e-05, -0.000272, 0.00022416, -7.1195e-05, -0.00019212, 0.00057396, 0.00035815, 0.00031159, -4.6937e-05, -0.00065506, -0.00011996, -4.2348e-05, 0.00010587, -7.9323e-05, -2.3722e-05, -0.0001704, -0.00057593, 0.00065222, 0.00026654, 0.00035667, -7.7692e-05, -3.8173e-05, 0.00010049, -0.00012168, -4.0491e-05, -4.816e-05, -0.00023287, -5.0225e-05, -0.00080183, 0.0010439, 6.197e-05, 0.00028902, 0.00010579, -0.00027248, -0.00018248, -9.7894e-05, 5.6122e-05, -2.4109e-05, -8.2564e-05, 1.2276e-05, -0.0011837, 0.0010388, -0.00030106, -8.2943e-05, 0.00046305, -3.4942e-05, 0.00026048, 8.0063e-05, -0.00023204, 0.00028043, -0.00017993, 0.00024111, -0.00077707, 0.00087259, -0.00047311, -4.8904e-05, 0.00030165, 0.00015237, -0.00032147, 0.000145, -0.00014869, -8.4069e-05, -1.1489e-05, -7.3104e-05, -0.00027258, 0.0010046, -0.00060634, -0.00030284, 0.00023946, 4.0874e-05, 0.00020669, 4.6264e-05, 0.0002212, -0.00025433, -6.9621e-05, -0.00011541, -0.00025522, 0.00090808, -0.00014796, -0.00027357, -0.00019226, 0.00015027, -0.00010411, -0.00012272, 0.00033767, -0.00040885, 1.4065e-05, -6.0894e-05, -1.227e-05, 0.00046367, 0.00018272, -3.3562e-05, -0.00018615, 0.00024748, -0.0002204, -0.00026552, -4.8267e-05, -0.00013654, -0.00016522, -9.9852e-05, -7.3085e-05, 7.6497e-05],
              [0.00014192, -1.085e-05, 0.00016776, -0.00011605, 6.6756e-05, -0.00015563, 6.4164e-05, -0.00016144, -1.1567e-05, -2.939e-05, -0.00018546, -0.00014193, 0.00015689, -0.00022987, 0.00050602, 1.1479e-05, -3.5358e-05, 5.4151e-05, 0.00011627, 3.7186e-05, 5.9554e-05, 3.1315e-05, 1.2057e-05, -9.6696e-05, 0.00010448, -0.00015507, 0.00022023, 8.3867e-05, -0.00012962, -6.7578e-05, -1.3556e-05, -3.5738e-05, -4.5809e-05, -6.3549e-06, -0.00015612, 7.0085e-05, 0.00029764, -0.00010577, 0.0001273, 1.2399e-05, 1.8646e-05, 0.00024213, -0.00015873, 8.3707e-05, -0.00032598, 0.00041133, -8.8688e-05, -0.00049296, 0.00020605, 9.3561e-05, 0.00024763, 0.00036524, -0.00023689, 0.00033172, 1.2629e-05, 0.0002408, -0.00040064, -5.9563e-05, 0.00028034, -0.00028346, 0.00013392, 3.0494e-06, -0.00034838, 0.00059746, -9.9846e-05, 0.00041454, -0.00023074, 0.00034209, -0.00016581, 3.9766e-05, -0.0002783, 0.00012538, 1.4736e-05, 0.00027567, -0.00048884, 8.7213e-06, -2.0493e-05, 0.000205, -0.00032258, 0.00032033, -0.00024322, 2.9087e-05, -0.00028867, 3.0825e-05, -3.6798e-05, 0.00029228, 0.00052891, -0.00024059, -0.00029899, 0.0002319, -0.00024299, 0.00012632, 6.8366e-05, 0.0001055, -7.3226e-05, -0.00010182, -7.6342e-05, -0.00040021, 0.00051869, 0.00045282, -0.00025642, -5.3312e-05, -0.00015072, 0.00026346, 1.5723e-05, -0.00010612, 0.00010031, -0.00022901, 0.00029515, -0.0003781, -0.00048427, 0.00022179, -6.5522e-05, 0.00033674, -0.00046179, 0.00010507, -8.1386e-05, -8.5409e-05, -8.8996e-05, -7.5853e-05, 2.6564e-05],
              [-0.010683, -0.026204, -0.035349, -0.0089039, -0.078265, 0.014533, -0.039735, 0.0028868, 0.0082563, -0.036876, 0.0019618, 0.052924, 0.035479, 0.021452, -0.012058, 0.032416, 0.0081487, -0.0082878, -0.011302, 0.045192, 0.044327, 0.019364, 0.11357, -0.032979, 0.075698, 0.019097, 0.0083418, -0.0060608, -0.024521, -0.0062564, -0.019425, 0.042618, 0.11771, 0.14807, 0.072421, 0.058253, 0.036447, 0.06185, 0.049705, 0.055431, 0.070267, 0.10792, 0.053117, 0.12943, -0.037521, 0.09371, 0.067577, 0.068725, 0.076127, 0.12312, 0.083411, 0.039387, 0.056425, 0.014238, 0.056634, -0.0075863, -0.083041, -0.03313, -0.027636, -0.047769, -0.063296, -0.062579, -0.046277, -0.0014999, 0.035908, -0.15153, -0.06746, 0.052979, -0.025619, 0.037942, 0.064911, 0.022302, 0.055271, 0.092705, 0.018963, -0.053973, 0.0083301, -0.021218, -0.030571, -0.0021454, -0.026876, -0.049043, 0.0051261, -0.0069455, -0.055541, -0.024578, 0.015168, -0.068003, -0.00048112, -0.05652, 0.04967, 0.016316, -0.034086, 0.063067, -0.0080033, 0.033386, -0.044576, -0.023441, -0.044509, -0.037162, 0.007319, -0.073158, -0.011373, 0.072031, -0.018016, -0.00013859, 0.028374, -0.025567, -0.013903, 0.052808, -0.038318, -0.022987, 0.0062782, 0.029734, -0.090237, 0.0094684, -0.067607, -0.012207, 0.0039499, 0.0017681, -0.13205],
              [-0.00048966, -9.6134e-05, 9.5024e-05, -9.4831e-06, -0.00027318, -1.286e-05, -0.00018753, 0.0002536, 0.00013593, 0.00010672, 0.00025208, 0.00030575, -1.8677e-05, -0.00013599, -1.8597e-07, 0.00018716, -2.9456e-05, 1.7404e-05, 0.00029171, -1.6893e-05, 0.00029143, 9.82e-06, -0.00012202, -0.00018215, 5.8728e-06, -2.3871e-05, -0.00016916, -7.7176e-05, 0.00053888, -7.5954e-05, 0.00047546, -0.00048533, 0.00025243, -5.289e-05, 0.00026631, -5.7069e-06, 9.4805e-06, 0.00012584, 0.00045285, -3.7921e-05, 0.00010519, -0.00021575, 0.00013059, -0.00055512, 0.00014299, -1.537e-06, 8.0654e-05, 0.00040678, 0.00038999, 3.6877e-05, -2.6107e-05, -8.5584e-05, -0.00015584, -0.00011966, -3.6535e-05, 0.00054094, 0.00037631, 0.0005227, 0.00013112, -0.0004006, -0.00026994, -4.3073e-05, -4.6583e-05, 0.00011704, -0.00025562, -9.7989e-06, 0.00028045, -0.00016084, -0.00025724, -0.00046505, 0.00040393, 0.00034091, -0.00019371, -0.00012426, 0.0001461, 4.8875e-05, -0.00016903, -0.00037192, -0.0002158, 0.00039962, 0.00079813, 6.5351e-05, -0.00066373, 1.4202e-05, -3.0669e-05, -0.00013015, 1.1834e-06, -6.0453e-05, 0.00046003, 0.00029649, -9.7422e-05, -0.00054615, -0.00054555, 0.00030505, -0.00012282, 3.1042e-05, 0.00012688, -1.1536e-05, -0.00017687, 0.00011095, -0.00059224, 0.00021684, -0.00045799, 0.00057995, -0.00013937, -0.00021221, -5.4137e-05, 3.6609e-05, 4.5939e-05, 0.00021479, -0.000327, 0.0001269, -0.0003423, 0.00034768, -0.00067549, -4.1513e-05, 0.00018063, -0.00018814, 2.8973e-06, 1.3507e-05, -0.00041261],
              [-0.00013437, 0.00012211, -8.2414e-05, -5.7302e-05, -0.00030739, -2.2492e-05, -0.00017176, -7.7102e-05, 4.7108e-05, 0.00017636, 0.00032836, 4.1088e-05, 4.9949e-05, -0.00011876, -0.00023944, 6.1006e-05, -5.4786e-05, -0.00036632, 0.0001673, 0.00025493, 2.2227e-05, -4.4608e-05, 4.8917e-05, 4.1964e-05, -6.1314e-05, 0.00022686, -8.9248e-05, -0.00019302, 0.00023805, 5.5691e-05, 0.000167, 0.00017966, -0.0003835, 3.1919e-05, -0.00021914, 0.00033657, -0.00015381, -0.0001264, 7.8444e-05, -2.5921e-05, 0.00038528, -1.4539e-05, -0.00049288, 0.00010287, -6.4383e-05, 0.0002381, -0.00031386, 0.00014008, -5.8913e-05, 0.00032747, 0.00039023, -7.4475e-05, -0.00041729, -5.226e-06, 0.00012736, 3.6629e-05, 6.5629e-05, 0.00021839, -0.00011813, 0.00021698, 9.6288e-05, -0.0002608, -0.00039654, 0.00011671, -4.0163e-05, -9.6609e-05, 0.00019201, 3.5895e-05, -0.00013216, -2.2031e-05, -9.3108e-05, 0.00025392, -4.0757e-06, -0.00012808, -0.00015139, 0.00022617, -0.00010183, -2.1483e-05, 0.00028357, -0.00028491, -4.2892e-05, 0.00041456, -0.00012604, -0.00039707, 7.6033e-05, 0.00029654, -0.00021374, 2.3271e-06, 9.5164e-05, -0.00068015, 0.00037026, 0.00019251, 0.00013551, -0.00031121, 9.685e-05, -0.00011268, -0.00023013, 0.00015402, 6.4205e-05, -0.00034974, 0.00064853, -4.473e-05, 0.00021225, -0.00034308, -3.7734e-05, -3.8868e-05, 8.6499e-05, 0.00014457, -0.00014733, -2.7613e-05, 0.00026354, -9.6315e-05, -8.0324e-05, -0.00018999, -5.9127e-05, 0.00014091, -0.00012997, -5.0352e-06, -0.00015232, 0.000231, -0.00021588],
              [-0.011114, -0.032645, 0.032393, -0.053019, -0.05229, -0.14091, -0.10663, 0.076743, 0.19184, 0.090513, -0.098345, -0.011357, 0.036593, -0.053861, 0.021336, -0.047044, -0.079543, 0.069135, 0.16071, 0.0038457, -0.086696, -0.030081, 0.022665, -0.023073, -0.018331, 0.0011058, -0.10917, -0.046906, 0.1088, 0.17215, -0.16345, 0.047387, -0.050131, -0.029615, -0.038382, 0.0016627, -0.03478, -0.070943, 0.07791, 0.2302, -0.14284, -0.033306, -0.012579, 0.0084163, -0.032994, -0.048339, -0.019525, -0.069845, 0.014727, 0.14997, 0.078032, -0.15724, -0.0040331, 0.020646, -0.010654, -0.068656, 0.024298, -0.0024877, -0.030228, 0.090227, 0.080843, -0.086655, 0.01296, 0.018917, -0.045623, -0.032739, -0.036379, -0.052935, 0.0072628, 0.025316, 0.065355, 0.05083, -0.051373, 0.012063, -0.053921, 0.0041695, -0.0082265, -0.01122, -0.0075849, 0.059, -0.039921, 0.11126, -0.021519, -0.057332, 0.005526, -0.0042105, 0.0091544, -0.029534, -0.0046619, 0.086827, -0.087906, 0.060049, 0.08224, -0.067951, -0.052837, -0.081788, 0.043806, -0.035919, 0.030943, 0.048874, -0.078419, 0.036039, 0.15302, -0.0020635, -0.062144, -0.0042183, 0.018343, -0.0063008, -0.011523, -0.047258, -0.028718, 0.078802, 0.069202, -0.08006, -0.14107, -0.025482, -0.020509, -0.015509, -0.0094705, 0.014878, -0.0034915],
              [-0.049718, -0.035759, -0.022243, -0.035623, -0.068946, -0.14441, 0.23465, 0.15847, -0.065972, -0.018536, -0.024797, -0.0076368, 0.0066228, -0.017527, -0.010789, -0.040286, -0.0056962, 0.13973, -0.042841, -0.030913, -0.050613, -0.014451, -0.033321, -0.053283, 0.0084957, -0.033399, -0.10205, 0.030196, 0.21111, -0.085712, -0.030767, 0.0065006, -0.032108, 0.010381, 0.037671, -0.056206, -0.032604, -0.1561, 0.15115, 0.087468, -0.079714, 0.018202, -0.0045105, 0.026833, -0.043426, -0.026067, -0.02529, -0.042097, -0.070926, 0.2353, 0.011521, -0.095817, -0.018725, -0.037049, -0.026822, -0.019582, 0.044677, 0.02881, -0.058262, 0.024777, 0.1255, -0.035929, -0.087119, -0.0026901, 0.0046237, -0.01805, 0.016779, -0.012651, -0.089945, -0.061953, 0.10991, 0.15038, -0.090164, -0.035134, 0.019258, -0.02301, -0.026283, -0.066215, 0.0036082, -0.019206, -0.020172, 0.19898, -0.024159, -0.048082, -0.027408, -0.075525, 0.064454, -0.058575, -0.0086368, -0.0086036, -0.060077, 0.045972, 0.12618, 0.022411, -0.1105, 0.0069619, -0.0094113, 0.015503, -0.048438, -0.046829, -0.00022239, 0.0014118, 0.089525, 0.079141, -0.092462, -0.018049, 0.0014867, 0.0047595, -0.0017288, -0.027305, -0.032111, -0.017611, 0.073416, 0.11602, -0.044348, -0.098407, -0.0088183, -0.04299, -0.039403, 0.014837, -0.050635],
              [-0.068701, -0.032924, -0.028685, -0.027347, -0.012438, 0.045308, 0.14147, -0.024737, 0.021872, -0.029614, 0.0014704, 0.00061449, -0.065002, 0.036644, -0.03221, -0.01372, 0.0042619, 0.043979, -0.046108, -0.020623, 0.092668, -0.085227, -0.047327, 0.056896, -0.038868, -0.091733, -0.0024676, 0.054788, 0.092325, -0.083977, -0.022272, -0.015279, -0.037661, 0.007948, 0.03556, -0.051925, 0.0048635, -0.051612, 0.069927, 0.019604, -0.05813, 0.03412, -0.022789, 0.0056804, -0.011191, -0.04521, 0.042702, -0.027746, -0.083076, 0.15661, -0.028534, -0.064019, 0.0071637, 0.010947, -0.026172, -0.039177, -0.052625, -0.032611, -0.024151, -0.029592, 0.14367, -0.017566, -0.05466, 0.057155, 0.029811, -0.06134, 0.040778, 0.011699, -0.0088244, -0.13868, 0.0070548, 0.1384, 0.034596, 0.011188, 0.048424, 0.010038, -0.0018498, -0.037856, -0.043326, 0.0080412, -0.1369, 0.15427, 0.053186, -0.062849, 0.098908, 0.024336, 0.0012518, -0.020851, -0.010459, -0.013998, -0.062995, -0.12718, 0.18117, 0.12558, -0.13692, -0.022944, -0.023608, -0.0059309, -0.029009, -0.11053, 0.016766, -0.029906, -0.010995, 0.17826, 0.052695, -0.15857, 0.018373, -0.062619, 0.025193, -0.0018929, -0.067841, -0.050794, -0.10117, 0.13362, 0.34075, -0.12172, -0.2107, -0.083359, -0.078476, -0.029252, -0.22249],
              [-0.065571, 0.057388, -0.13425, -0.095897, 0.24651, 0.14475, -0.10963, 0.025485, -0.006675, 0.018031, -0.072827, 0.030726, -0.044557, -0.015541, -0.056845, 0.085633, 0.10033, -0.037429, -0.062462, -0.033927, 0.014833, -0.031364, -0.023246, -0.032758, 0.029612, -0.098209, 0.077944, 0.095671, -0.083246, 0.020906, 0.050811, -0.039132, 0.038704, -0.040633, 0.00067528, 0.013989, -0.13054, 0.045164, 0.11112, -0.063736, 0.037782, 0.017424, 0.061583, -0.063674, -0.085358, 0.034715, -0.0030215, -0.074515, 0.12039, 0.11915, -0.066498, -0.05749, 0.021248, -0.043396, 0.056092, -0.050906, 0.030755, -0.017042, -0.086373, 0.043707, 0.071729, -0.046172, -0.12569, 0.062778, -0.054878, 0.0098493, 0.042535, -0.025427, 0.0048504, -0.034534, 0.057141, 0.071824, -0.078857, 0.046187, 0.014022, -0.0059724, -0.059074, -0.052311, -0.018659, 0.016795, -0.048576, 0.0056966, 0.17001, -0.14025, -0.01492, -0.024501, 0.06768, -0.052642, -0.077081, 0.042505, -0.035988, -0.048451, 0.047675, 0.055033, -0.064761, 0.020293, 0.0052681, -0.0087241, -0.060607, -0.069111, 0.024796, -0.027098, -0.0012387, 0.015077, 0.055874, -0.027944, 0.0052288, -0.048321, 0.085962, -0.0020463, -0.11994, -0.049601, -0.092974, -0.03198, 0.15102, 0.082755, -0.058126, 0.041661, -0.037047, 0.00087627, -0.080283],
              [-0.034049, -0.013918, -0.065488, -0.04731, 0.23782, 0.10577, -0.16564, -0.010855, -0.078836, -0.05002, -0.082312, 0.0046222, 0.02797, 0.0058953, -0.040404, 0.085254, 0.028249, -0.056799, -0.03836, 0.064562, -0.0049545, -0.0026872, 0.015598, -0.018252, -0.05971, -0.057151, 0.13138, 0.056842, -0.023477, -0.047153, 0.0008577, 0.011009, 0.0056124, -0.055915, -0.028097, 0.048625, -0.096117, 0.13044, 0.12721, -0.12259, -0.022446, 0.0076033, -0.0078139, -0.040903, -0.00098022, 0.010152, -0.055309, -0.092262, 0.07871, 0.14964, -0.059601, -0.07591, 0.069756, -0.012391, 0.016172, -0.01017, -0.0099409, 0.057863, -0.0535, 0.0023151, 0.24268, -0.16271, 0.003039, -0.0019135, -0.031935, 0.031241, -0.013448, 0.018763, -0.027194, -0.063835, -0.019315, 0.17296, 0.004778, -0.046724, 0.0006375, 0.012018, -0.049906, 0.063102, -0.059113, -0.0019439, -0.014409, -0.015148, 0.15803, -0.0095471, -0.14208, 0.10783, -0.029316, 0.0049959, -0.02723, -0.027548, 0.011938, -0.05422, -0.092135, 0.23666, 0.043819, -0.041978, -0.0056029, -0.027255, 0.0096145, -0.04155, -0.034068, -0.012401, -0.041538, -0.049314, 0.16482, 0.042083, -0.10972, 0.066034, -0.007725, 0.0029249, -0.080851, -0.05769, -0.037836, -0.09375, -0.14353, 0.17091, 0.14407, -0.019807, -0.03718, -0.013199, -0.047378],
              [-0.089356, -0.043599, -0.040685, -0.056315, -0.064317, -0.036306, 0.087125, -0.025232, 0.060763, -0.016932, -0.040975, 0.0011693, -0.02347, 0.03936, -0.0044332, -0.014202, -0.070464, 0.013142, 0.003362, -0.010206, 0.03951, 0.020167, 0.056938, 0.034174, -0.062667, 0.0839, -0.0039051, -0.12024, -0.019127, 0.068195, 0.0042397, -0.024727, 0.013195, 0.10092, 0.083733, 0.093601, -0.028064, 0.15309, 0.019081, -0.13459, -0.041819, 0.023908, -0.0036808, 0.0078939, 0.064007, -0.027475, -0.014962, 0.019431, -0.10422, 0.18788, 0.0038647, -0.021851, -0.07162, -0.0073304, 0.023479, -0.032992, 0.074772, 0.11997, 0.16653, -0.043451, -0.19633, -0.01512, 0.015596, -0.041436, 0.075827, -0.0062698, -0.13523, -0.13543, -0.0794, 0.013399, 0.29846, 0.12613, -0.082085, 0.034499, -0.060887, 0.028444, -0.036122, 0.0051284, -0.046056, -0.18431, -0.20981, -0.12018, 0.095624, 0.012102, -0.022525, -0.045282, -0.012822, 0.043771, 0.080442, 0.053685, 0.040662, -0.010274, -0.10557, -0.073596, 0.038444, -0.019075, 0.012246, -0.0015394, -0.021037, 0.055182, 0.044094, 0.02839, 0.0097436, -0.041473, -0.055378, -0.016991, -0.0081618, 0.0076016, -0.0066457, 0.040565, 0.081751, 0.05078, 0.11557, 0.055483, -0.057897, -0.11059, -0.071829, 0.061971, -0.030281, 0.019305, 0.054297],
              [-0.24374, -0.072314, -0.041972, -0.143, 0.061523, -0.030205, -0.020865, -0.047648, -0.0041297, 0.040277, 0.0059092, -0.061426, -0.049228, -0.070004, -0.064273, -0.026634, -0.065741, -0.05105, 0.0043411, -0.016116, -0.031515, 0.037031, -0.12281, -0.030326, -0.047122, 0.0069455, -0.1202, 0.03392, -0.036501, -0.023249, -0.1156, 0.038387, -0.0026533, 0.061601, 0.10392, 0.10819, 0.068685, 0.11776, 0.017679, -0.058902, -0.020291, 0.00014691, -0.12261, -0.010208, 0.25552, 0.13824, 0.14468, 0.13523, 0.19144, 0.31527, 0.11572, 0.11682, 0.032566, -0.050278, -0.13474, 0.0088966, -0.066686, -0.10871, -0.18659, -0.34157, -0.34638, -0.011264, 0.029142, 0.12461, 0.10801, -0.02281, -0.047432, -0.016066, -0.012088, 0.13024, 0.16586, 0.082232, -0.18073, -0.23906, -0.0034761, -0.0025529, -0.0080703, 0.035855, 0.06089, 0.052805, -0.003316, 0.12385, 0.18824, 0.2921, 0.11943, -0.074494, -0.037462, -0.023738, 0.072599, -0.00045486, 0.00074298, -0.0015929, -0.17247, -0.15444, -0.13465, 0.032777, 0.07086, -0.00047705, -0.032344, -0.039986, -0.074752, -0.069852, -0.082819, 0.032778, -0.0042938, -0.015013, 0.018193, -5.6098e-05, 0.01986, 0.033074, 0.016572, 0.091964, 0.073377, 0.098478, 0.036105, 0.05087, 0.010385, 0.040242, -0.070135, 0.0028041, -0.10929],
              [-0.076119, -0.019269, -0.031755, -0.046456, -0.040704, -0.050843, -0.021974, -0.025543, -0.074161, -0.013171, -0.11347, -0.057228, -0.029591, -0.034244, 0.0061905, -0.0094645, -0.044626, -0.10437, -0.028686, -0.04109, -0.046152, 0.0098326, -0.067696, -0.028013, -0.071397, -0.075353, -0.10566, -0.075523, -0.026284, -0.031035, 0.045982, -0.029752, 0.011393, -0.10394, -0.034764, -0.037846, 0.00012124, 0.091279, 0.14577, 0.11042, 0.1887, 0.10738, 0.13269, 0.010378, -0.052734, 0.07628, 0.13003, 0.24686, 0.21184, 0.24704, 0.22868, 0.036921, -0.028737, -0.070385, 0.0055155, 0.11568, 0.1066, 0.19512, 0.045422, -0.075768, -0.18362, -0.31804, -0.19549, -0.077995, -0.031296, -0.077328, 0.12871, 0.041487, -0.13922, -0.20396, -0.15728, -0.072167, 0.086564, 0.10758, 0.081809, 0.066724, 0.047445, 0.017639, -0.10582, -0.056754, 0.048224, 0.14307, 0.12359, 0.071727, -0.018593, 0.069247, 0.0029738, -0.0012684, 0.0058617, -0.039955, 0.069868, 0.014017, -0.046601, -0.047068, -0.046682, -0.024441, -0.037553, -0.059138, 0.03927, -0.033803, -0.016677, -0.036287, -0.033653, -0.081055, 0.022449, -0.051865, -0.0022565, 0.0065501, 0.019614, 0.035675, -0.088138, -0.049861, -0.046523, 0.015603, 0.070303, 0.025612, 0.068457, 0.035739, 0.0148, 0.028994, 0.026774],
              [-0.05879, -0.039923, -0.010605, -0.018499, -0.0048651, -0.060301, 0.00031834, -0.12557, -0.080004, -0.13698, -0.22799, -0.025563, 0.031597, 0.034181, -0.05038, -0.036901, -0.020123, -0.11426, -0.08245, -0.12939, -0.015453, 0.16526, 0.0054734, -0.021933, -0.058345, 0.022962, -0.037437, -0.12779, -0.028891, -0.0028919, 0.26949, 0.17558, 0.34734, -0.099006, -0.032826, -0.065174, -0.028457, -0.062602, 0.032022, 0.15695, 0.34154, 0.2028, 0.12458, -0.093376, -0.072239, 0.0090947, -0.044389, -0.052575, 0.02948, 0.26925, 0.22827, -0.0022877, -0.11146, -0.13529, -0.15036, -0.085843, -0.024537, 0.0086891, 0.021944, 0.16653, 0.08152, -0.14405, -0.1499, -0.11121, 0.001073, 0.098095, -0.034221, 0.0040176, -0.018013, 0.07321, -0.0072272, -0.015973, -0.061004, 0.054833, 0.067576, 0.074127, -0.042424, -0.037337, 0.022891, -0.0034269, 0.043776, -0.005555, -0.060685, -0.045928, -0.0088831, -0.077575, -0.073069, -0.0075845, -0.058704, 0.03243, 0.1114, -0.061069, -0.022957, -0.081457, 0.013486, -0.10699, 0.026815, -0.046958, -0.0095644, -0.0078126, 0.021326, 0.027801, 0.056729, -0.07589, 0.0018496, 0.022934, 0.013436, -0.03088, -0.0049469, 0.0040992, -0.0091408, 0.10872, 0.020712, -0.030869, -0.0019258, -0.011927, -0.081406, 0.063922, -0.010456, 0.037077, 0.088835],
              [-0.036641, -0.022319, 0.024522, 0.03344, 0.088325, -0.078447, -0.047208, -0.047259, -0.025216, -0.015415, -0.092115, 0.044024, -0.0091154, 0.0048974, 0.030834, -0.020765, -0.020724, -0.012244, -0.04629, 0.018593, 0.0051453, 0.034378, -0.060076, 0.057462, -0.029605, -0.032985, 0.019794, -0.091802, -0.039565, 0.14253, -0.018064, 0.012289, 0.04912, 0.057131, -0.0053969, -0.027773, -0.0045553, -0.016294, -0.10181, 0.21508, -0.039234, -0.013888, 0.045507, 0.12177, -0.0049585, 0.012483, 0.00022151, -0.0047489, -0.05636, 0.1752, -0.055694, -0.082197, 0.064538, 0.047484, -0.0028928, -0.015339, 0.0027033, 0.0067498, -0.040248, 0.078968, -0.10963, -0.17063, 0.2286, 0.07852, 0.008033, -0.011424, -0.015146, -0.023533, 0.009966, -0.026743, -0.042415, -0.049676, 0.29646, 0.025691, -0.048511, -0.10024, -0.16647, 0.026747, 0.034919, -0.012381, 0.031329, -0.038088, 0.13554, -0.038601, -0.15955, -0.1865, -0.057062, -0.01277, 0.014754, -0.034539, 0.0060587, -0.0098109, 0.069117, -0.071244, -0.13193, -0.031816, 0.027198, 0.044916, 0.13642, 0.051541, -0.023023, -0.0075025, 0.0075302, -0.059348, -0.044235, -0.011581, 0.0014665, 0.047136, 0.015656, 0.066013, 0.0582, -0.015587, 0.0052092, 0.014817, 0.018388, -0.086676, -0.067044, -0.0035215, 0.064161, 0.065318, 0.067259],
              [0.004506, 0.045655, -0.0064831, -0.0032628, -0.01041, -0.037024, -0.036963, -0.091094, -0.11865, -0.06429, -0.19248, -0.0017368, -0.0097469, 0.0016448, -0.040873, -0.014221, -0.035843, 0.016147, -0.039843, -0.09313, -0.0023747, -0.1383, 0.028428, -0.013697, -0.11157, -0.0089864, -0.080753, 0.012804, -0.062406, -0.010726, -0.03342, -0.013381, -0.12601, -0.0011651, -0.096303, -0.033961, -0.072716, 0.035903, -0.050367, 0.039466, 0.089595, 0.080324, 0.15694, 0.13047, -0.10542, -0.05508, -0.0081043, 0.049795, 0.08505, 0.33221, 0.25591, 0.1717, 0.11686, 0.11406, 0.22947, -0.012136, 0.083665, 0.13744, 0.2076, 0.02481, -0.25485, -0.37635, -0.27149, -0.10308, -0.073758, 0.006322, -0.0071614, 0.024395, -0.030595, -0.22377, -0.21688, -0.060604, 0.18641, 0.14118, 0.071716, 0.013664, -0.059638, -0.079133, 0.051501, -0.10958, 0.040358, 0.24552, 0.1985, 0.13276, -0.0033278, 0.095717, 0.0060755, 0.070214, -0.060296, 0.023306, 0.036242, 0.094785, -0.051031, -0.048582, -0.1362, -0.042785, -0.055491, 0.0010026, 0.011273, -0.0070417, -0.026903, 0.012495, -0.0049653, 0.014208, -0.058316, 0.020101, -0.055566, -0.058258, -0.12155, 0.036277, -0.11927, 0.11091, -0.087205, -0.0029129, -0.025028, 0.012107, 0.068614, 0.071374, 0.098125, 0.14037, -0.002956],
              [-0.086667, -0.065565, -0.023817, -0.020441, -0.07197, 0.00028669, -0.048728, -0.02516, -0.071502, 0.009494, -0.072387, -0.025154, 0.02346, -0.059503, -0.045615, -0.08352, -0.085543, 0.01373, -0.021149, -0.0073163, -0.037713, -0.074774, 0.034622, -0.025474, 0.030186, -0.019963, -0.049692, -0.11327, -0.074519, -0.12604, -0.037064, -0.024954, -0.083736, 0.02475, 0.05933, 0.062205, 0.17133, 0.16122, 0.16387, 0.058308, 0.025831, -0.04348, -0.041636, -0.12914, -0.040109, 0.020146, -0.0014665, 0.091342, 0.11972, 0.2388, 0.30998, 0.24622, 0.18587, 0.12053, -0.0034211, -0.03053, -0.032291, -0.076194, -0.19607, -0.20015, -0.19677, -0.18309, -0.00055713, 0.13744, 0.12949, 0.2056, 0.023511, 0.016947, 0.073624, 0.065649, 0.062699, -0.050179, -0.092252, -0.22545, -0.14499, 0.019198, 0.082962, -0.019486, 0.011993, 0.04133, 0.076363, 0.031762, 0.15907, 0.10336, 0.039866, 0.021912, -0.15923, -0.013829, 0.076214, -0.018094, -0.022784, -0.075767, -0.0047947, -0.12287, 0.031159, -0.051655, 0.096187, 0.0095671, -0.031624, -0.052568, -0.003142, 0.023309, -0.0023387, -0.0094488, -0.045824, -0.005481, -0.081258, -0.053087, -0.0010084, -0.103, 0.050103, 0.039084, 0.0007826, 0.066585, 0.019513, 0.07854, 0.012933, 0.061861, -0.037749, -0.044014, -0.058653],
              [-0.23766, -0.10644, -0.14205, -0.03341, -0.051747, -0.049029, -0.010143, -0.0458, 0.034452, -0.037463, -0.052618, 0.10955, -0.1361, -0.0095472, -0.12706, -0.092229, 0.021264, -0.080028, -0.010055, -0.021203, 0.016576, -0.02837, 0.33291, 0.2809, 0.12848, 0.033793, -0.023904, -0.16851, -0.0060729, -0.023245, -0.056641, -0.012011, -0.098774, -0.064504, 0.10266, 0.25554, 0.24277, 0.21967, 0.11091, -0.10184, -0.08746, -0.0029721, -0.00012925, -0.02508, -0.086435, -0.18088, -0.11352, 0.03289, 0.15787, 0.23051, 0.1488, 0.032438, -0.057059, -0.069308, -0.082356, 0.042285, 0.043413, -0.072265, -0.16689, -0.16026, 0.028475, 0.18131, 0.041853, 0.0049307, -0.0008325, -0.047832, 0.0010252, 0.017498, 0.074032, 0.054063, -0.0048789, -0.10176, 0.018693, 0.007621, 0.0085935, 0.02913, -0.076722, -0.044435, -0.041904, -0.042182, -0.027448, 0.043453, -0.014281, -0.11364, 0.021624, 0.059888, 0.04825, -0.025918, 0.028058, -0.035965, 0.010591, -0.061233, -0.057899, -0.088443, 0.0012601, 0.015192, 0.014316, 0.039038, -0.01107, 0.0044676, 0.0051525, -0.076856, 0.024632, -0.046934, -0.0043118, -0.041969, -0.015695, 0.013526, 0.048797, 0.00035467, 0.071901, 0.016275, 0.070923, -0.0088248, 0.043458, -0.014639, -0.013192, -0.037524, 0.024709, 0.057087, 0.0058576],
              [-0.024542, 0.032672, 0.11773, -0.034174, -0.071743, -0.16175, 0.014165, 0.019531, -0.054978, -0.0038957, -0.090196, 0.064812, -0.047234, -0.019134, -0.080948, -0.11018, 0.10727, 0.11986, -0.13898, 0.02947, -0.069941, 0.10165, 0.0042591, -0.049348, -0.083661, -0.087656, 0.020522, 0.080192, -0.15728, -0.028886, 0.073544, 0.20706, 0.066144, -0.069632, -0.055387, -0.0099159, -0.039718, 0.14583, -0.022727, 0.017713, 0.28062, 0.075763, -0.1576, 0.12669, -0.0065958, -0.023039, -0.016204, 0.011444, 0.031045, 0.09939, -0.050473, -0.030751, -0.15956, 0.012868, -0.16705, -0.047964, -0.077403, 0.025311, 0.040895, 0.090109, -0.31175, 0.059979, 0.17392, 0.068215, 0.22655, -0.11278, 0.015118, -0.0629, -0.069945, -0.04491, 0.14433, 0.29233, 0.19559, -0.057851, -0.014726, 0.088841, 0.26941, -0.054034, 0.011159, 0.024544, -0.0050103, 0.1229, -0.042268, -0.045072, -0.023986, -0.018777, -0.064872, 0.17923, 0.017718, 0.012677, -0.084142, 0.092705, -0.14742, -0.077405, -0.041954, -0.018945, 0.060652, -0.044563, -0.046249, 0.033354, -0.0018617, -0.067678, -0.023334, 0.013622, -0.012602, 0.056142, -0.019617, -0.093416, 0.025936, -0.21076, 0.040245, -0.077189, 0.014213, -0.11507, -0.08021, -0.12404, -0.034792, -0.051307, -0.044479, -0.042402, -0.074817],
              [0.01158, 0.076463, 0.00079803, 0.048838, 0.12248, 0.013744, 0.018861, 0.011586, 0.04539, 0.031693, 0.07499, -0.0098663, -0.1034, -0.071572, 0.0043787, -0.077789, -0.019559, 0.01204, 0.0018615, 0.017977, -0.047083, -0.0071368, -0.17556, -0.080029, -0.0318, -0.057597, -0.022591, -0.024016, 0.020306, 0.0070647, -0.049746, 0.010918, -0.007976, -0.057844, 0.040415, 0.050513, -0.02868, -0.088878, -0.11596, -0.14727, -0.12186, -0.013719, 0.0032338, -0.10004, -0.017784, -0.043427, 0.0025162, 0.03118, 0.092565, 0.021359, 0.17682, 0.066269, -0.056798, 0.020215, -0.08873, -0.019043, 0.12149, 0.039671, 0.12659, 0.25102, 0.31362, 0.22184, 0.13597, 0.10116, -0.24302, 0.0097296, 0.18357, -0.026127, 0.034417, -0.0047517, -0.19722, -0.30262, -0.31482, -0.1434, 0.093247, 0.26018, -0.15232, -0.11886, -7.9502e-05, 0.14995, -0.077373, -0.015999, 0.25216, 0.22726, 0.051762, -0.070376, 0.039304, 0.046344, -0.018432, 0.22509, 0.059918, 0.046243, 0.1184, -0.19507, -0.14026, 0.057466, 0.11019, -0.013542, 0.047028, 0.024668, -0.0058191, -0.087337, 0.089096, 0.06501, -0.043338, -0.019093, 0.14833, 0.078021, 0.070724, -0.031358, -0.072959, -0.13113, -0.086264, -0.072841, 0.077043, 0.077563, 0.10315, -0.053458, -0.045827, -0.029004, -0.22848],
              [-0.069051, -0.13696, -0.0056563, 0.017174, 0.054751, -0.059932, -0.015331, -0.0068192, 0.0012622, -0.01923, -0.059761, 0.078693, 0.10894, -0.075681, -0.20953, -0.0053129, 0.10045, -0.1164, 0.024356, -0.0012586, 0.050691, 6.7084e-05, 0.20191, -0.045181, 0.10144, 0.11705, -0.22633, 0.018469, -0.0013542, -0.12018, 0.016842, 0.052652, 0.083146, 0.05733, -0.040375, -0.11575, 0.11708, 0.069673, -0.13864, -0.079608, -0.022217, 0.033594, -0.11363, 0.1027, -0.24155, 0.018757, 0.27956, 0.039218, 0.073588, -0.044889, 0.13769, 0.0032477, 0.022429, -0.038466, 0.031155, -0.16442, 0.23625, -0.081428, -0.011107, -0.062666, -0.17075, 0.27269, 0.031157, -0.05547, -0.0069529, -0.053436, 0.42537, 0.018283, 0.13284, -0.015069, 0.10328, 0.44999, -0.0011929, -0.16087, -0.12774, -0.042099, -0.0018649, 0.24606, 0.074298, 6.9784e-05, -0.052136, -0.086745, -0.22499, -0.045345, 0.033108, 0.032026, -0.0537, 0.033624, -0.12434, -0.13435, -0.10102, -0.10334, -0.072744, 0.030026, -0.027686, 0.0035345, -0.059592, 0.031353, -0.031956, -0.18986, -0.066674, -0.030282, 0.015288, 0.01068, 0.044317, -0.0092002, 0.044711, 0.032936, -0.028902, -0.019832, -0.10833, 0.017001, -0.016581, -0.047452, 0.019644, -0.043525, 0.022794, -0.031968, -0.11913, -0.012952, -0.077946],
              [-0.004218, -0.17785, 0.10345, 0.14692, 0.032856, 0.069906, -0.0063945, 0.012859, -0.031362, 0.048788, -0.21008, -0.14262, 0.27351, 0.13676, -0.29667, 0.13073, 0.052879, 0.20819, 0.054692, -0.070712, -0.0072303, -0.037876, 0.016205, 0.032611, -0.21237, 0.19488, -0.050184, -0.10106, -0.19452, -0.09757, 0.14803, -0.11936, 0.090357, 0.0059923, 0.025456, -0.019228, 0.084192, -0.10884, -0.1971, -0.084654, -0.086888, 0.36809, 0.10964, -0.064538, 0.015796, 0.037226, 0.043018, 0.11953, 0.10395, 0.045531, 0.054413, 0.24913, 0.0022231, -0.10581, 0.090088, 0.16662, -0.15731, -0.091249, -0.053758, 0.022179, 0.27116, 0.33867, 0.1404, -0.051937, 0.013903, -0.065676, -0.12826, 0.19223, 0.066177, 0.073804, 0.1457, 0.07116, -0.0095457, -0.1049, -0.081458, -0.078985, -0.11642, 0.022713, -0.040784, -0.0056623, 0.0036836, -0.06678, -0.12713, -0.15866, -0.063329, -0.05576, -0.037458, -0.022461, -0.022029, -0.011882, -0.046973, -0.14701, -0.037218, -0.082831, -0.0016296, -0.021759, 0.059907, -0.013177, 0.064519, -0.040907, -0.027245, -0.014615, 0.11053, 0.027445, 0.022162, 0.0024547, -0.016091, -0.058967, 0.021584, 0.032765, -0.17163, 0.038526, -0.1009, -0.082755, -0.12651, -0.031347, -0.051126, -0.088046, -0.0031872, -0.02711, -0.11431],
              [-0.066924, 0.041699, -0.10386, 0.055675, -0.07426, -0.09119, -0.04579, -0.053409, 0.0016411, -0.010002, 0.021792, -0.051951, -0.070201, 0.09728, -0.15049, 0.1215, 0.015843, 0.01783, 0.028679, -0.13093, -0.0032724, -0.076393, 0.023828, -0.10049, 0.057648, 0.1477, -0.058573, 0.036566, -0.038113, -0.03595, 0.13215, -0.11751, -0.02731, -0.15554, 0.18384, 0.10898, -0.055055, 0.23295, 0.16692, 0.34351, -0.061819, -0.024812, 0.079963, -0.18727, 0.077134, 0.20555, -0.025109, -0.016911, 0.027522, -0.18467, -0.1287, 0.27051, -0.2357, 0.16007, 0.060773, -0.040057, 0.0061977, -0.21241, 0.22776, -0.2446, -0.1111, -0.32901, -0.065957, 0.38918, -0.037062, -0.013214, 0.11362, -0.13116, 0.26149, 0.1311, -0.025593, -0.1077, -0.029542, 0.21031, 0.20084, -0.15455, 0.098486, 0.053759, 0.082713, -0.24255, 0.025734, 0.17681, 0.23331, 0.27753, 0.17726, -0.16259, -0.17145, 0.083644, 0.016995, -0.071477, 0.074912, -0.075655, 0.021347, 0.12285, 0.031741, -0.079712, -0.010976, 0.020719, -0.14947, -0.059126, 0.025068, -0.076954, 0.0107, -0.035726, 0.010453, -0.020801, -0.10029, -0.053471, -0.048791, -0.043407, -0.10411, -0.0096116, -0.040122, -0.046812, -0.064058, -0.14541, -0.07568, -0.032467, 0.0079791, -0.075814, 0.020303],
              [-7.0957e-06, -0.095051, -0.087882, 0.0047062, -0.098027, -0.0027617, -0.097227, -0.063001, 0.11834, 0.054457, -0.0099414, -0.070139, 0.058249, 0.032891, -0.077909, 0.12061, 0.041917, -0.12019, 0.024991, -0.15611, 0.027447, 0.0061692, 0.22278, 0.077772, 0.15814, -0.017009, -0.14312, 0.17959, 0.051526, -0.11409, 0.0087348, -0.11632, 0.014926, 0.035969, -0.053626, -0.023997, 0.19965, 0.036097, -0.049211, 0.12246, 0.060611, -0.095797, -0.069519, -0.05025, -0.0058375, -0.012563, -0.1478, 0.031772, 0.13403, -0.15157, 0.12631, -0.005289, -0.0019668, 0.05403, -0.063631, -0.3492, 0.086316, 0.14981, -0.019588, 0.12206, -0.19934, -0.048029, 0.052601, 0.038693, -0.093007, -0.025563, 0.17735, 0.22164, 0.094681, 0.037985, 0.0088876, 0.33249, 0.16505, -0.0078676, -0.0040894, -0.073882, -0.023509, 0.3813, -0.019292, -0.086843, -0.040173, -0.046443, -0.10186, 0.16439, 0.0026682, 0.076749, -0.067948, -0.0010387, -0.10714, -0.030577, 0.032786, -0.0055511, 0.020069, -0.01711, -0.14366, -0.016712, -0.069886, 0.01136, 0.0048981, -0.071131, -0.065545, -0.079795, -0.069728, 0.057019, -0.021993, 0.015178, -0.00020471, -0.025514, -0.026883, -0.045298, -0.15833, -0.031429, -0.0062888, -0.0057808, -0.087719, -0.014851, -0.09857, -0.11786, -0.058162, 0.025496, -0.027501],
              [0.033386, 0.029449, 0.050373, 0.03376, 0.043978, 0.08318, 0.071687, 0.026806, -0.040213, 0.074456, -0.015557, -0.005235, -0.019242, 0.055812, -0.061556, 0.022157, -0.0375, -0.091842, 0.0021346, -0.077528, -0.07034, -0.021844, -0.028323, 0.00011165, -0.063044, 0.031228, -0.027815, -0.023586, 0.014275, -0.0099113, -0.039422, -0.036125, -0.14335, -0.030906, 0.026457, -0.055732, -0.099791, -0.113, -0.096702, -0.14135, -0.095762, 0.012997, 0.061453, -0.10846, -0.095955, -0.026482, -0.093422, 0.025975, 0.048412, 0.13855, 0.0089878, 0.14129, 0.018874, 0.0068619, 0.066029, -0.069577, -0.13631, 0.053261, 0.17933, 0.20451, 0.25418, 0.42794, 0.080448, 0.060808, 0.050979, 0.068725, -0.079585, 0.16947, 0.07175, -0.17603, -0.2061, -0.27585, -0.45996, 0.041977, 0.14013, -0.10129, 0.042032, 0.0010701, 0.03327, 0.045261, 0.18493, 0.11251, 0.079146, 0.27604, -0.29337, -0.032405, 0.24483, -0.1173, -0.00039308, -0.082855, 0.14722, -0.050887, -0.11314, -0.045972, -0.12976, 0.36521, -0.091822, 0.085864, 0.076513, 0.10292, 0.0027326, 0.070587, 0.10534, 0.11196, -0.072148, 0.049586, -0.031051, 0.14407, -0.085588, 0.087229, -0.17191, -0.11561, -0.092875, 0.029309, 0.039975, 0.12186, 0.10737, -0.039137, -0.080754, -0.053377, -0.1975],
              [-0.078857, 0.02861, 0.028066, -0.021834, -0.071732, 0.041944, 0.0034421, 0.099852, -0.072054, -0.14404, -0.099453, 0.030831, 0.029895, 0.0015406, 0.050637, -0.061536, 0.022595, 0.058299, -0.21505, -0.10742, 0.13531, 0.12926, -0.023229, 0.081512, 0.00055799, -0.098024, -0.066934, 0.030281, -0.19701, -0.074522, 0.29428, -0.019357, 0.097886, 0.08682, -0.043231, -0.018464, 0.062745, 0.0092971, -0.24864, 0.010777, 0.23163, -0.08533, -0.11445, 0.083801, 0.075831, -0.014033, 0.049485, -0.021591, 0.015442, 0.086162, -0.044103, 0.12334, 0.073164, 0.10887, -0.15317, -0.078737, -0.017285, -0.039704, -0.056906, 0.1866, -0.023527, 0.0097119, -0.11069, -0.0033322, 0.22171, -0.14381, -0.044159, 0.056899, -0.062536, -0.096716, -0.042463, 0.33605, 0.12772, 0.029306, 0.052961, 0.018388, 0.58364, 0.07837, -0.14774, 0.079311, -0.13568, 0.033726, -0.19372, -0.048923, -0.079048, -0.093458, 0.0084688, 0.024467, 0.024073, 0.045654, -0.049521, 0.11131, -0.082672, -0.012817, -0.058436, -0.090027, -0.061292, -0.12267, -0.10084, -0.038686, -0.034858, -0.00069532, -0.05712, 0.065895, 0.076844, -0.0099222, 0.038383, -0.0018487, -0.035019, -0.16441, -0.082791, -0.066047, -0.081933, -0.010547, -0.051038, -0.025579, 0.0095973, 0.0049533, -0.061063, 0.033454, -0.12571],
              [-0.079439, -0.097075, 0.069014, -0.074506, 0.075012, 0.15666, -0.081194, 0.092119, 0.16895, -0.064301, -0.1065, -0.20662, 0.14032, -0.1386, 0.15068, 0.081866, -0.014125, 0.15934, -0.056123, -0.14962, 0.26418, 0.00014355, -0.0073547, 0.079307, 0.020929, -0.10994, -0.17371, -0.023791, -0.086918, -0.004335, -0.085955, -0.029421, -0.00905, 0.041531, -0.069424, 0.24688, 0.20546, -0.17599, -0.24389, -0.19015, 0.22071, 0.077211, 0.014425, 0.0067033, 0.14558, -0.10028, -0.046264, 0.17807, 0.23207, 0.068919, 0.13997, 0.088433, -0.06619, 0.039955, 0.044429, -0.081011, 0.068411, -0.048059, -0.0052523, 0.19319, 0.2292, 0.086101, 0.031256, -0.01777, -0.081515, 0.052572, 0.0065147, -0.17665, -0.019857, 0.081102, 0.043278, 0.11772, 0.11137, -0.00073262, 0.091978, 0.082389, 0.034023, -0.053098, 0.099288, -0.10855, -0.17742, -0.17887, -0.14115, -0.064005, -0.053085, -0.0016597, -0.070677, -0.098804, -0.055945, -0.0052752, 0.032008, 0.05763, -0.01971, -0.057824, -0.068257, 0.027891, -0.076656, -0.023632, 0.019706, 0.06278, 0.0043081, -0.0068539, -0.069585, 0.056699, 0.042173, -0.025984, -0.033098, 0.0095922, 0.041801, -0.050819, -0.1069, -0.015848, -0.060765, -0.0062175, -0.085347, -0.097475, -0.059282, -0.035577, -0.075014, -0.060536, -0.11818],
              [-0.024906, -0.002084, 0.036006, 0.040388, 0.0046368, -0.050097, -0.019439, -0.099398, -0.039682, -0.0028158, 0.0035982, -0.054099, 0.098752, -0.13208, -0.18035, -0.0043732, 0.052329, -0.043358, 0.17087, -0.087789, -0.04498, -0.031635, 0.070377, -0.22835, -0.053229, 0.20062, -0.010254, 0.015916, 0.11152, -0.12243, 0.20444, -0.11371, -0.079914, -0.15288, 0.01301, 0.24934, -0.15784, 0.14724, 0.12654, 0.087845, 0.15842, 0.04809, 0.30801, -0.11761, -0.098389, 0.21454, -0.14234, -0.0057875, 0.14715, 0.037047, -0.050841, 0.14409, -0.20385, 0.12419, 0.16468, 0.012861, -0.06026, 0.07515, 0.32707, -0.4003, -0.26936, -0.27608, -0.11368, 0.18759, -0.1163, 0.01136, 0.091042, -0.02393, 0.027146, 0.26868, -0.040944, -0.051185, -0.062555, 0.14722, 0.17279, -0.045587, 0.040778, 0.077307, -0.045918, -0.14679, 0.058857, 0.30473, 0.26833, 0.20924, 0.21225, -0.22492, -0.10536, 0.1013, -0.0587, -0.056962, -0.053785, -0.064199, -0.023276, 0.14635, 0.17298, -0.1728, -0.028271, 0.054369, -0.10107, -0.14024, 0.018314, -0.037984, -0.065302, -0.01295, -0.094604, -0.11534, 0.0076675, 0.066322, -0.050401, 0.007422, 0.02887, -0.01598, 0.0047547, -0.023242, -0.10363, -0.080832, -0.038314, -0.08684, -0.01954, 0.031333, -0.15194],
              [0.2663, 0.030128, -0.11791, -0.11737, -0.062861, -0.096766, -0.082199, -0.08602, -0.075247, -0.029807, 0.24281, 0.067042, -0.0073446, 0.019074, 0.024028, -0.022037, -0.041361, -0.021552, -0.020935, 0.0016784, 0.044654, 0.04733, 0.070321, 0.0049339, 0.068284, 0.0027796, -0.04669, -0.055778, -0.053408, -0.00010746, 0.053647, 0.01417, 0.029054, 0.023032, 0.00066727, -0.00051463, 0.0056491, -0.0020259, -0.016498, -0.022443, -0.035029, 0.063846, 0.044687, 0.058668, -0.045157, 0.060419, 0.040369, 0.099232, 0.048066, -0.046325, -0.00080888, 0.11409, -0.00033137, 0.037356, -0.0079674, -0.049741, 0.13611, 0.023766, 0.053498, 0.015733, -0.063825, 0.033331, 0.027844, 0.081692, 0.097146, -0.064828, 0.014374, -0.047331, 0.044197, 0.1063, 0.073543, -0.044426, 0.049684, 0.068365, 0.081523, -0.015087, -0.0019638, 0.039052, -0.017851, 0.023708, 0.062011, 0.073784, -0.091845, 0.010697, 0.086037, 0.094596, -0.074055, 0.027916, -0.037642, -0.040193, 0.0024469, 0.1275, 0.0093404, -0.040375, -0.090115, 0.10326, 0.029177, -0.0077046, -0.030227, -0.026938, 0.032996, 0.037655, 0.060384, -0.011607, -0.088459, -0.0089621, 0.041335, 0.025265, 0.032067, 0.02383, -0.079346, -0.11618, 0.035621, 0.10014, -0.048809, -0.11447, -0.095813, 0.016306, 0.11708, -0.0632, -0.16223],
              [0.056794, 0.10168, -0.016504, 0.0046764, -0.015979, -0.04792, -0.055022, -0.10379, -0.049718, 0.10568, -0.031174, 0.083705, -0.091368, 0.057269, 0.018685, -0.032113, -0.001737, -0.07208, -0.099356, -0.024667, 0.086176, 0.04004, -0.15099, -0.00067872, -0.015247, -0.052524, 0.042551, -0.14444, -0.0065487, -0.071843, -0.01285, 0.014123, -0.0033943, -0.03964, -0.0031248, -0.045858, 0.0019021, -0.12416, 0.073896, -0.045016, -0.042377, -0.018876, 0.0662, -0.038229, -0.081068, -0.039458, -0.021574, -0.087538, 0.033366, 0.13641, -0.063205, -0.0012659, 0.0057983, -0.011527, -0.0079257, -0.14126, -0.034965, -0.054177, 0.098663, 0.31744, 0.039452, -0.12302, 0.090308, -0.018427, 0.007607, -0.063786, -0.13635, 0.021706, 0.088489, 0.24007, -0.038574, -0.20904, -0.028548, 0.088543, -0.021391, 0.044285, -0.026993, -0.064466, 0.12945, 0.19089, -0.03048, -0.11057, -0.030936, 0.11335, -0.035129, -0.086018, -0.0072169, -0.10753, 0.043123, 0.16933, 0.040455, -0.23665, 0.11812, 0.07594, -0.10352, -0.030301, 0.086878, 0.020132, -0.023337, 0.19293, 0.022201, -0.099101, 0.1551, 0.063728, -0.25368, -0.11399, -0.060714, 0.014445, -0.078061, 0.019868, 0.0081798, -0.058442, -0.12525, -0.04273, -0.10579, 0.082762, 0.22611, 0.19472, 0.13771, 0.25213, 0.073498],
              [-0.091381, -0.05808, -0.076531, -0.019935, -0.11699, -0.049621, -0.077133, 0.15067, -0.050781, -0.020686, -0.077499, -0.096759, 0.0077572, -0.0095979, -0.099566, 0.00516, -0.052062, 0.21008, 0.065151, -0.071318, 0.018812, -0.00086442, -0.046564, 0.013464, -0.04976, -0.07512, -0.016206, 0.20371, 0.21632, -0.2164, -0.010174, -0.080744, 0.00065763, -0.10941, 0.005192, -0.061527, -0.018847, 0.21787, 0.22243, -0.15575, -0.10816, 0.0051882, 0.031786, -0.1182, -0.091955, -0.065886, 0.045741, 0.16229, 0.1837, -0.081324, -0.096899, 0.11221, -0.12652, -0.056954, 0.0037198, -0.040599, 0.0393, 0.11791, 0.0326, -0.021777, -0.040529, 0.018542, -0.085733, -0.0042515, 0.031088, 0.10947, -0.03052, 0.024589, 0.031028, -0.026059, -0.03474, 0.042016, -0.15814, 0.098811, 0.17665, 0.1206, 0.28366, -0.0098819, 0.02072, 0.041373, -0.021038, -0.095203, 0.14911, -0.025722, -0.1282, -0.023631, -0.031597, 0.10824, -0.091173, 0.063567, 0.021728, -0.10569, -0.031654, -0.0087472, 0.14636, 0.13717, 0.040902, -0.017771, 0.03856, 0.039245, 0.056815, -0.11184, 0.064818, -0.081432, -0.034074, -0.11203, 0.15241, 0.13534, 0.068634, -0.036633, -0.046693, -0.033281, 0.0071095, -0.024377, -0.086464, -0.048462, -0.085872, -0.17119, -0.12548, -0.10026, -0.067724],
              [-0.11049, 0.1773, 0.16552, 0.034404, -0.089589, -0.0098957, -0.09267, -0.062034, -0.13028, -0.027741, -0.033783, 0.068486, 0.07599, -0.036571, -0.027073, 0.051359, -0.12487, -0.11938, 0.0002767, 0.039243, -0.065342, -0.032591, 0.0094874, 0.077229, -0.11979, 0.065176, -0.0045331, -0.093211, 0.2083, 0.034408, 0.20901, 0.1806, 0.080546, 0.011692, -0.10363, 0.08944, -0.1829, -0.17449, 0.20464, 0.16205, 0.12484, -0.033921, 0.0050539, 0.011335, -0.0018538, -0.13334, 0.13244, 0.13163, -0.09595, -0.14906, -0.13717, 0.078007, 0.22398, 0.060077, 0.080459, -0.044227, -0.026417, -0.021047, -0.022108, 0.27081, 0.20244, 0.052508, -0.081687, -0.028, -0.069004, -0.019947, -0.065109, 0.087305, -0.077077, -0.18137, -0.11404, 0.13449, 0.23245, 0.055125, -0.066464, -0.091452, 0.018849, -0.024654, -0.024966, -0.091425, 0.072528, -0.065216, -0.11922, -0.17338, -0.057219, 0.0067423, 0.011249, 0.068048, 0.049615, -0.097276, 0.0082359, -0.015023, -0.053933, 0.022182, -0.078603, -0.09699, 0.053342, 0.038593, 0.073274, -0.0027339, 0.0087236, -0.056655, 0.0089929, -0.047992, -0.07247, 0.013557, -0.0027079, -0.020809, -0.023686, -0.082885, -0.024582, 0.011676, 0.010269, 0.00027727, -0.10403, -0.031329, -0.048763, 0.01387, 0.0097769, -0.0016097, -0.11085],
              [-0.30333, -0.098154, 0.0015411, 0.045929, -0.065356, -0.13987, -0.083089, 0.082669, 0.061905, -0.11069, -0.2829, 0.22673, 0.18594, 0.071854, -0.030529, 0.028577, 0.031061, -0.043862, -0.044105, 0.02216, 0.21655, 0.30278, 0.012214, 0.086127, 0.18984, 0.17497, -0.084862, -0.081457, 0.018326, 0.13673, 0.27284, 0.094612, -0.07614, 0.062933, -0.097444, -0.068404, 0.0096656, 0.095041, 0.15937, 0.072995, 0.031253, -0.16547, -0.16678, 0.1267, 0.22205, 0.18736, -0.037622, -0.15711, -0.17299, -0.082555, -0.14455, -0.22415, 0.042542, 0.10381, 0.20625, -0.15881, -0.075659, -0.021486, 0.10892, 0.091093, -0.010417, 0.069544, 0.16543, 0.065217, -0.014818, -0.20522, -0.14265, 0.019756, 0.0058041, 0.039643, 0.15659, 0.22865, 0.14255, 0.057073, -0.053152, -0.034477, -0.077598, -0.066726, -0.06423, -0.089991, 0.02829, -0.066129, -0.11896, -0.082558, 0.012811, -0.024384, 0.015088, -0.13601, -0.075237, 0.039014, 0.028154, -0.055014, -0.0082541, 0.0026559, -0.021125, -0.023747, -0.042683, -0.059496, -0.019043, -0.12936, -0.026222, -0.025813, -0.041704, -0.066191, -0.097506, -0.058396, -0.089961, -0.0037007, 0.001118, -0.1009, 0.06414, 0.010238, 0.064404, 0.076685, 0.039151, -0.025803, -0.00019836, 0.071841, 0.13125, 0.046057, 0.053499],
              [-0.12966, -0.03758, -0.06761, -0.10397, -0.050147, -0.11662, -0.013409, -0.0038121, 0.14552, 0.20961, -0.11573, 0.0382, 0.053737, -0.03378, -0.013778, -0.12296, -0.19078, 0.063623, 0.07272, -0.18712, 0.13565, 0.10042, 0.066387, 0.075875, 0.10518, 0.14542, 0.12359, -0.033751, -0.11681, 0.047363, -0.078115, -0.0068073, 0.022331, 0.043345, 0.0061773, 0.10019, 0.12543, 0.29106, 0.15951, -0.041017, -0.24665, 0.10244, -0.022249, -0.039981, -0.054513, 0.10149, 0.12491, 0.024443, -0.17156, 0.0098209, -0.099464, 0.10893, 0.10795, -0.030383, -0.052094, 0.081082, -0.096274, -0.036267, 0.075185, 0.096808, 0.020286, 0.33291, 0.017339, -0.16522, -0.0040897, -0.051775, 0.06567, -0.032773, -0.085059, -0.1193, 0.092456, 0.25655, -0.13119, -0.099868, -0.033239, -0.014474, 0.022015, -0.0068706, 0.030439, 0.038215, -9.8671e-06, -0.13107, -0.1103, -0.056513, -0.035091, -0.021025, -0.037797, 0.0024114, 0.066873, 0.062798, 0.01586, -0.066418, -0.044395, -0.056739, -0.074491, -0.0017445, -0.0018562, -0.031297, -0.080379, -0.032933, -0.039466, 0.026869, 0.05272, 0.017821, -0.081279, -0.0098243, -0.035827, -0.018665, -0.030415, -0.025398, -0.127, -0.05127, -0.059493, -0.012978, -0.040201, -0.0063003, -0.059572, -0.060873, 0.025501, 0.056765, 0.012716],
              [-0.053343, 0.0052457, -0.047375, 0.094781, -0.040977, -0.096553, -0.074882, -0.046658, -0.091331, -0.040718, -0.093077, 0.0037318, 0.001298, -0.072971, 0.057699, 0.21678, 0.062692, -0.04409, -0.02313, -0.021606, -0.016754, -0.089115, -0.018012, -0.048665, -0.038883, -0.16008, 0.12324, 0.16214, 0.081891, -0.026691, -0.078939, -0.035178, -0.070559, -0.08145, 0.041254, -0.0082409, -0.064104, -0.19223, 0.19699, 0.075458, 0.10168, -0.011408, -0.027454, -0.096909, -0.027763, -0.099432, -0.065805, 0.0079576, -0.031079, -0.025255, 0.13286, 0.10025, 0.065637, -0.003144, -0.044384, 0.055436, 0.059891, -0.0098526, -0.15355, 0.17006, -0.18443, 0.068014, 0.029876, 0.108, 0.085618, -0.10414, 0.24465, 0.10562, 0.15464, 0.11487, -0.16275, -0.101, 0.095139, -0.10761, 0.017873, 0.11424, -0.0018412, 0.086874, 0.16367, 0.044733, -0.094762, -0.14398, 0.21757, -0.034529, -0.12834, 0.039442, 0.052147, -0.0027754, 0.092487, -0.10001, 0.021968, 0.076096, 0.26484, -0.068779, -0.13151, 0.0011599, -0.068093, -0.027604, 0.0055121, -0.074849, 0.031134, 0.10058, 0.16474, -0.021659, -0.084825, -0.016801, 0.022993, 0.017167, -0.056374, -0.032324, -0.018054, -0.050024, -0.1409, -0.13965, -0.1187, -0.062036, -0.041018, -0.050867, -0.058573, 0.021581, -0.042699],
              [0.019903, 0.15562, -0.028017, -0.17651, -0.039198, -0.060229, 0.040414, 0.0039325, 0.035475, 0.086187, 0.066211, -0.011483, 0.021711, 0.011538, -0.031843, -0.084914, -0.023265, -0.11448, 0.039181, -0.056999, -0.064777, 0.063734, -0.043075, 0.056384, 0.025731, -0.10729, -0.043118, -0.053658, 0.015845, 0.013291, 0.0102, -0.0031794, -0.11412, 0.030884, 0.021462, 0.03497, -0.079456, -0.085032, 0.11503, -0.10994, -0.089573, -0.0039431, -0.045788, -0.029069, -0.029313, -0.0022282, -0.015461, 0.080169, -0.096417, 0.06817, 0.14489, -0.02062, -0.12128, 0.0035403, -0.1086, -0.025759, -0.015908, -0.019318, 0.027712, -0.010692, -0.11262, 0.22919, 0.19547, 0.062577, -0.032438, -0.17049, -0.054888, -0.0086607, -0.03247, 0.050118, 0.03841, -0.15182, -0.17239, 0.178, 0.15775, 0.11239, -0.1155, -0.10514, 0.029627, 0.010047, -0.035952, 0.015687, 0.10711, -0.041276, -0.23138, 0.10814, 0.20399, -0.014741, -0.062683, -0.049411, -0.035968, 0.041871, -0.072185, -0.083864, 0.098734, 0.11032, -0.22003, 0.1278, 0.14219, -0.0011896, 0.079367, 0.043589, -0.035425, -0.054609, -0.16493, -0.17557, 0.15889, 0.0041503, -0.10135, 0.19024, 0.08466, 0.1151, 0.16224, 0.17764, 0.22134, 0.14596, 0.028871, -0.10379, -0.067206, -0.088716, -0.041102],
              [0.1592, 0.060407, 0.058122, 0.0047701, 0.019787, 0.087204, 0.030264, 0.017305, 0.085575, 0.023959, 0.12885, 0.0686, -0.045567, 0.06496, -0.057218, -0.025448, 0.090949, -0.079769, 0.036731, -0.03848, 0.0060765, 0.062316, 0.002068, 0.006558, -0.0043518, 0.009629, 0.029116, 0.014264, 0.02969, -0.081627, 0.046851, 0.0062149, 0.018397, -0.012562, -0.040552, 0.028504, -0.011487, -0.059191, 0.022429, 0.078039, -0.015416, 0.019965, -0.066504, -0.0013193, -0.10842, -0.036973, -0.020534, 0.040748, 0.053337, -0.0011671, -0.0095602, 0.016299, 0.0077278, 0.00037444, -0.19228, -0.13238, -0.030125, -0.015888, 0.025014, 0.027519, 0.024199, -0.047761, 0.12256, -0.055852, 0.065026, -0.12853, -0.059058, -0.032314, -0.050141, 0.080141, 0.035776, -0.052897, 0.0028742, 0.082628, -0.021869, -0.069854, -0.068576, -0.064585, -0.0069314, -0.063836, 0.065184, 0.08558, -0.089783, 0.024132, 0.12237, -0.0081031, -0.10893, -0.041048, -0.040486, -0.018772, 0.024153, 0.10036, 0.06874, -0.10245, -0.016349, 0.007038, 0.12266, -0.043113, 0.01337, 0.016729, -0.039289, 0.057728, 0.041013, -0.049979, -0.032348, -0.088175, 0.09987, 0.0656, -0.01536, -0.028529, -0.037199, 0.15245, 0.18336, 0.054288, -0.046369, -0.11191, -0.11519, -0.022732, 0.11225, 0.2856, -0.067985],
              [0.058959, -0.021876, 0.037612, -0.099005, -0.11655, 0.021079, 0.015957, 0.059648, -0.065506, -0.083395, -0.18214, 0.084305, -0.025711, -0.0014531, 0.062922, 0.010829, 0.077505, -0.066208, -0.055003, -0.061511, 0.0689, -0.055539, -0.020785, 0.089398, 0.12883, -0.12817, -0.0096792, -0.11505, 0.073196, 0.013391, 0.063157, -0.11664, -0.087677, 0.064069, 0.089552, -0.012366, -0.084842, -0.30993, -0.31591, -0.19715, 0.020969, 0.14194, 0.061843, 0.073936, -0.013043, -0.074977, -0.20604, -0.070946, 0.28309, 0.57742, 0.31262, -0.083662, -0.0039167, -0.0070082, 0.040088, -0.049395, -0.029191, -0.081164, 0.19269, 0.21145, -0.29773, 0.12406, 0.36605, 0.093082, -0.024581, 0.10111, -0.062911, -0.0034613, 0.029116, 0.0020626, 0.10964, 0.064159, -0.21854, -0.12925, -0.079675, -0.018112, 0.035958, -0.046726, -0.06093, 0.011191, 0.023534, 0.072568, 0.23271, 0.3317, -0.057956, -0.12546, -0.039267, -0.056155, -0.046609, 0.060499, -0.043017, 0.024842, -0.099368, -0.16432, -0.15146, -0.0017544, 0.17032, 0.064868, 0.15234, -0.032911, -0.0071732, -0.0081381, -0.050724, 0.011173, -0.062102, -0.052309, 0.00051655, -0.0075192, 0.039092, 0.071466, 0.006336, -0.09563, -0.025392, -0.10042, -0.097928, -0.027282, -0.038112, 0.012061, -0.035597, -0.052822, -0.11313],
              [-0.15324, -0.061966, -0.020865, -0.00042811, 0.073055, -0.061348, -0.031466, -0.10328, 0.057558, 0.011198, 0.045234, -0.064711, -0.067011, -0.0057205, -0.028643, -0.037131, 0.053749, -0.054199, 0.021887, 0.01619, -0.019017, 0.1138, -0.11165, -0.0087496, -0.014474, -0.026252, -0.0027102, -0.03099, -0.041275, -0.11453, 0.047907, 0.038422, 0.015083, 0.02877, 0.016845, 0.094727, 0.20594, -0.1516, -0.24555, -0.27708, -0.18049, -0.011308, 0.11441, -0.014636, 0.079198, 0.012007, 0.0072429, -0.1864, 0.16781, 0.56826, 0.34086, 0.15391, -0.22202, -0.093194, -0.0050051, 0.080167, -0.0010856, 0.033973, 0.29561, 0.36483, -0.31466, 0.062497, 0.21969, -0.026684, -0.054686, -0.15194, 0.054278, 0.074098, 0.0050038, -0.11139, -0.29694, -0.0028084, 0.085921, 0.054283, 0.04116, -0.040069, 0.020584, -0.032968, -0.124, -0.1269, -0.087864, 0.25943, 0.25469, 0.11149, 0.016197, -0.035512, 0.062529, -0.061876, 0.042654, 0.14569, 0.10027, 0.049106, -0.16921, -0.15021, -0.036438, -0.094175, 0.052143, -0.024438, -0.043904, 0.097322, 0.025963, 0.044958, 0.015316, 0.028567, -0.099805, -0.056575, -0.0025488, -0.066924, 0.010194, -0.0061766, -0.10526, -0.064591, -0.0082274, -0.028938, -0.0021874, 0.0064021, -0.082474, -0.10584, -0.016047, -0.065096, -0.076611],
              [-0.039511, -0.0080173, -0.016552, 0.075617, -0.029722, -0.025035, -0.072171, -0.092474, -0.075212, -0.04436, -0.069349, -0.022491, -0.0057147, 0.052051, -0.054608, -0.058373, -0.060777, -0.077337, -0.045477, 0.030773, -0.11621, 0.10798, -0.027779, 0.042776, -0.029085, 0.070665, -0.1067, -0.12973, -0.061185, 0.022941, -0.011978, 0.16487, -0.048341, -0.026936, -0.048056, 0.032474, -0.13513, -0.11295, 0.028315, 0.10779, 0.13719, 0.094828, -0.029662, 0.13211, -0.11093, 0.029167, -0.065793, -0.082565, 0.024708, 0.22294, 0.23882, 0.084903, 0.040208, 0.076546, -0.061238, 0.0063284, -0.051374, 0.062827, -0.036988, 0.22359, 0.048437, -0.25353, -0.19261, -0.019422, -0.062848, -0.036853, -0.12965, 0.044459, -0.12227, -0.075999, -0.066285, 0.28526, 0.39167, 0.21584, -0.00059672, 0.028282, 0.1415, 0.029358, -0.0073653, -0.018182, 0.0045057, -0.11281, -0.12216, -0.045822, 0.027683, 0.044114, 0.01296, -0.01033, 0.017525, -0.026815, -0.038434, -0.023176, 0.018238, -0.10609, -0.0078365, -0.16927, 0.05523, -0.038599, -0.030083, 0.033499, 0.064549, -0.054456, -0.00056162, -0.12306, -0.052312, -0.006256, 0.066659, -0.083661, -0.0050757, -0.053946, -0.00027041, -0.029193, 0.060243, -0.018407, -0.03151, -0.023054, -0.14523, -0.083398, 0.0083801, -0.054527, 0.0051809],
              [-0.065849, -0.053261, 0.035474, -0.043773, -0.042949, -0.03584, -0.03671, -0.03589, 0.0084303, 0.07096, -0.039991, 0.0006292, 0.023016, -0.012094, 0.023508, -0.0043853, -0.017755, -0.098393, -0.025599, -0.093254, -0.060085, -0.0067733, 0.0047322, 0.0098855, -0.0079343, -0.048435, -0.01181, -0.044468, 0.029162, -0.052373, -0.012794, -0.074, -0.11229, 0.00053719, 0.054814, -0.058612, 0.031705, -0.0076502, -0.10569, -0.19589, -0.12316, -0.011443, 0.11926, 0.0010364, -0.099823, -0.010169, -0.077188, -0.066005, -0.28363, -0.0933, 0.035262, 0.13156, 0.091981, -0.0081161, 0.12425, -0.04316, -0.010051, -0.025512, -0.0548, 0.020004, 0.31672, 0.27826, 0.1379, 0.048834, -0.033553, -0.043105, -0.046987, -0.0079366, 0.048609, 0.09188, 0.23511, 0.016599, -0.12372, -0.063235, -0.08997, 0.010187, 0.072231, 0.013954, 0.061917, -0.043803, 0.043711, 0.034238, -0.14965, -0.021063, -0.0065215, 0.10037, 0.025703, -0.023339, 0.039961, -0.062023, 0.019839, 0.12567, -0.12436, 0.051042, 0.053957, -0.016946, 0.043321, 0.038185, 0.067065, -0.092508, 0.13191, 0.078819, -0.087287, 0.13682, 0.022366, -0.0032544, 0.11493, -0.070293, -0.0097662, 0.07912, -0.13763, -0.026908, -0.12733, 0.086009, 0.01195, -0.0089316, -0.049144, -0.044693, 0.017728, 0.012377, -0.085355],
              [-0.15926, 0.084897, 0.010353, 0.024131, -0.0099025, 0.016913, 0.073092, 0.08237, 0.0043022, 0.083855, 0.032979, -0.034178, -0.029839, -0.10512, -0.0089746, 0.036814, -0.020708, -0.010091, -0.072879, -0.0016778, -0.076743, 0.036399, -0.022292, -0.079821, -0.03117, -0.02395, -0.090007, 0.049464, -0.011624, -0.01219, -0.038313, -0.013831, -0.049168, -0.08738, 0.036253, -0.13555, 0.023838, 0.050095, -0.053272, -0.085012, 0.0061676, 0.0016709, -0.013993, -0.062743, -0.056305, -0.080727, -0.04239, -0.14777, -0.097021, -0.070734, -0.015527, -0.22588, -0.12301, -0.11675, -0.16926, -0.11924, -0.012361, -0.053243, 0.030546, 0.11824, 0.18358, 0.16423, 0.1323, -0.066627, 0.034499, 0.23003, -0.10642, 0.095721, 0.18784, 0.11359, 0.025588, -0.06744, -0.047658, 0.10205, 0.3059, 0.12074, -0.019907, 0.079053, 0.091497, 0.053535, -0.0018597, -0.036332, -0.067753, -0.038232, 0.0085334, -0.16437, -0.041481, -0.024498, 0.10684, 0.011813, -0.11759, -0.012837, 0.0010457, 0.072147, 0.12615, -0.055282, -0.0069995, 0.060201, 0.019191, -0.00068959, -0.015095, 0.082565, 0.029353, 0.020528, -0.031246, -0.059333, 0.096753, 0.03723, 0.025529, 0.056861, -0.023451, -0.023607, 0.019542, 0.019438, 0.044548, 0.038281, 0.061662, -0.088155, 0.079304, -0.051664, 0.077758],
              [-0.061708, 0.04717, 0.012297, 0.0048086, 0.089273, 0.0323, 0.0099211, 0.077315, 0.007219, -0.0057896, -0.027111, -0.13989, -0.056493, 0.043741, -0.0011463, -0.087114, -0.049879, -0.044601, 0.037027, -0.019658, 0.0018227, -0.13718, -0.023654, 0.023929, -0.06122, -0.029673, 0.020848, 0.078336, -0.040876, -0.039874, -0.055584, 0.080912, -0.15786, -0.10649, -0.1323, -0.04331, -0.10794, -0.087527, -0.10889, -0.0942, -0.068306, -0.044226, -0.13935, -0.17046, -0.21417, 0.055183, 0.11437, 0.20663, -0.10572, -0.17195, -0.070754, 0.056465, 0.14099, 0.19461, -0.08266, 0.18248, 0.11507, -0.012084, 0.071742, 0.19215, 0.19213, 0.17145, 0.15448, -0.010182, -0.075106, 0.17627, 0.07293, -0.085363, -0.10189, -0.093911, 0.0033217, -0.0056859, 0.010933, -0.12951, -0.046961, 0.0032455, -0.0090718, 0.0068371, 0.052015, 0.018357, 0.01267, -0.074411, -0.063974, -0.029665, 0.058059, -0.018533, 0.010602, 0.081067, 0.020393, -0.022919, 0.12127, 0.0071001, 0.12313, 0.13042, 0.046877, 0.042704, 0.068078, 0.046054, -0.0067836, 0.045065, 0.032495, -0.043798, 0.039504, -0.050502, -0.029414, -0.072356, 0.010415, -0.037595, -0.024336, 0.025902, -0.0063118, 0.028123, 0.027432, 0.008822, 0.01083, 0.021828, 0.043521, 0.0035936, 0.056884, 0.040877, 0.015957],
              [-0.0083507, 0.061639, 0.063043, -0.015296, 0.10245, 0.0039986, 0.077652, 0.030021, -0.021836, 0.056397, -0.15007, 0.010033, 0.0050164, -0.018546, 0.015951, -0.0011365, 0.011707, -0.058604, 0.0015384, -0.092476, -0.06129, -0.064372, -0.036227, -0.027816, -0.024541, -0.036651, 0.017808, -0.13331, 0.093825, -0.063647, -0.050293, 0.040498, -0.093307, -0.051282, -0.013633, 0.0051773, 0.028088, -0.069494, 0.02917, -0.065715, -0.00958, -0.0075632, -0.046689, -0.036037, -0.16326, -0.06809, -0.090402, -0.18958, -0.10039, -0.08141, -0.053688, -0.1623, -0.053231, -0.075002, -0.12647, 0.18341, 0.016324, -0.095199, 0.046462, 0.13805, 0.26953, 0.10024, 0.053013, 0.043485, -0.012146, -0.056649, 0.022123, 0.14925, 0.20113, 0.15088, 0.08159, -0.0944, -0.001998, 0.10065, 0.14323, 0.13389, -0.013346, -0.027656, -0.098837, -0.015846, -0.029293, -0.12585, -0.076534, -0.025134, -0.078349, -0.025744, 0.038564, 0.084352, 0.034972, 0.021598, -0.0096451, -0.024148, 0.035439, 0.094839, 0.013834, 0.047416, -0.052763, 0.099287, -0.042716, 0.065424, 0.012165, 0.048081, 0.046868, 0.043736, 0.033547, -0.046382, 0.062765, 0.024133, -0.097569, 0.13229, 0.04396, 0.0069924, 0.029835, -0.028421, -0.042759, 0.05049, 0.050638, 0.044202, 0.015928, 0.050284, -0.094579],
              [-0.0093002, 0.066421, -0.057988, 0.030468, -0.088943, -0.014873, -0.06903, -0.059773, -0.02475, 0.076981, -0.11219, -0.00026099, -0.10643, 0.046966, -0.10537, -0.073429, -0.017259, -0.0097549, 0.028937, 0.05832, -0.10852, 0.0093034, 0.0032395, -0.11758, -0.030717, -0.012968, -0.072433, -0.029515, -0.030307, -0.010562, 0.00059348, 0.045902, 0.0099592, -0.14727, 0.10666, -0.058289, -0.081332, -0.10523, -0.092706, -0.080449, -0.054722, 0.035004, 0.018234, -0.064682, 0.082552, 0.043969, 0.10735, 0.17551, 0.028146, -0.093032, -0.080992, -0.17305, -0.083976, -0.082187, 0.026086, -0.024523, 0.061837, -0.0031533, 0.013887, 0.22791, 0.17839, 0.16803, -0.022424, -0.070479, 0.075631, -0.13497, 0.061914, -0.013965, -0.040287, 0.0049442, -0.14235, 0.13423, 0.0044641, 0.17884, 0.033152, -0.084186, 0.022682, 0.069503, -0.10838, 0.025867, 0.062726, 0.051958, -0.15685, 0.13621, -0.077636, 0.027664, 0.099426, -0.024066, 0.018369, 0.11491, 0.017998, -0.024584, -0.072971, 0.070923, -0.084294, 0.14549, -0.081489, -0.046883, 0.065571, 0.082578, -0.036743, 0.05491, -0.024501, 0.196, -0.047414, 0.0027762, 0.030268, 0.14718, 0.043112, -0.045243, -0.056667, 0.011024, -0.03747, 0.034539, -0.09347, -0.030232, 0.092526, 0.0033731, -0.074955, -0.05631, -0.12735],
              [-0.074008, 0.059418, -0.16186, -0.095114, -0.054157, -0.095247, -0.0277, 0.13096, -0.082898, 0.043236, -0.073266, -0.010407, -0.17908, 0.11214, 0.011254, -0.072132, 0.011243, -0.12961, 0.017388, 0.052082, -0.016141, -0.0031876, 0.060476, 0.12063, -0.11552, 0.053113, -0.11176, -0.085345, -0.10342, -0.077512, 0.022696, -0.061166, -0.026801, -0.013513, 0.072872, 0.21356, -0.061052, 0.23221, -0.0060496, -0.11934, -0.048735, -0.0037697, 0.0015807, -0.059016, 0.16916, -0.10636, 0.013868, 0.13029, 0.17375, 0.36097, 0.072557, -0.050622, -0.061397, 0.012028, -0.059739, -0.1592, 0.073526, 0.010664, -0.12349, -0.20863, -0.24386, 0.2227, 0.046982, -0.10969, 0.046794, -0.067828, 0.15296, -0.074195, 0.042911, -0.014765, 0.3796, 0.41758, 0.021898, -0.11238, -0.043153, -0.0018388, -0.065449, -0.010369, 0.043815, -0.0090643, 0.10572, -0.04497, -0.060017, -0.12352, 0.072888, -0.073016, 0.024489, -0.046995, 0.0061026, 0.032989, -0.055861, 0.033549, -0.1025, -0.08537, -0.091447, -0.071753, 0.0060016, 0.004878, 0.091778, -0.063911, -0.10839, 0.1405, -0.16291, 0.049227, -0.053957, -0.025757, -0.059499, 0.029022, 0.037106, -0.043182, 0.0044686, 0.037891, -0.12462, -0.015316, -0.099422, -0.057912, -0.070463, -0.069349, 0.036225, -0.0096669, 0.0072113],
              [0.00054, 0.019228, -0.0041211, 0.010352, 0.0060644, 0.030583, 0.018243, -0.011485, -0.012454, -0.013983, -0.073495, 0.00061004, -0.035457, 0.0091981, -0.0079306, -0.031347, 0.056361, 0.022269, 0.020976, 0.021593, 0.022292, -0.036376, -0.0048934, 0.018804, 0.021642, 0.022979, 0.057279, -0.062847, 0.0080146, 0.0017411, 0.023316, -0.0019692, -0.0097664, 0.026553, 0.019312, -0.040479, 0.042963, -0.0055572, 0.040029, 0.039092, -0.014761, 0.039287, -0.028686, -0.013543, 0.042797, 0.0093265, 0.071105, -0.012855, 0.0048121, -0.019345, -0.0068647, 0.060027, -0.05171, -0.0088038, 0.0085937, 0.011217, 0.004366, -0.052365, 0.018586, -0.043301, 0.017257, 0.033163, -0.063372, 0.022236, -0.010283, -0.029097, -0.072929, -0.0065264, 0.021708, -0.01287, -0.036092, 0.049588, 0.0037686, -0.035449, -0.0175, 0.0017065, 0.027703, 0.010552, -0.01511, 0.010755, -0.042385, 0.055156, -0.046342, -0.025334, -0.031804, 0.0074468, 0.014823, -0.041502, 0.05566, -0.015163, -0.033479, -0.038074, 0.018025, -0.042188, -0.068459, 0.032543, -0.043, -0.017042, 0.031344, -0.079988, 0.016716, 0.032905, 0.07075, -0.026522, 0.0097949, -0.0083591, -0.022132, -0.010267, 0.027387, -0.019457, 0.047471, 0.0064639, -0.036821, -0.014924, -0.048381, -0.035401, -0.0011684, -0.054013, 0.079191, -0.046041, 0.010261],
              [-0.00015691, -0.00010973, 8.6821e-05, 0.00028959, 0.00013337, -0.00020448, 0.00046365, -0.00019524, 0.00033248, 0.0002625, -9.9023e-05, 0.00023043, 0.0003325, 0.00015431, -0.00017518, 0.00017581, -2.7858e-05, 0.00010573, -0.00016548, -0.00010017, -9.3139e-05, 7.6297e-05, 8.4225e-05, -9.3287e-05, -0.0002872, 0.0002135, -0.00031506, 0.00045189, -0.00054957, 0.00054579, 4.2927e-05, 0.00052308, -0.00068598, 0.00018155, -0.00019968, 0.00023652, 8.502e-06, 0.00049096, -0.00041196, 0.00037236, -0.00014793, -0.00020788, -0.00031632, 0.00035097, -0.00053025, 0.00019205, -0.00035924, -0.0001448, -8.2206e-05, -0.00026762, -0.00032866, -0.00013873, 0.00019338, -2.8931e-05, -0.00021531, 0.00050076, 1.287e-05, 0.00028779, 2.1517e-05, -0.00038504, 0.00026924, 0.0002012, 7.127e-05, 0.00025511, -0.00054975, 7.0801e-05, -0.00031443, 7.2728e-05, -6.7647e-05, -0.00010597, 0.00020425, -2.266e-05, -0.00046406, 0.00029312, -0.00057911, 0.00046348, -0.00018921, -6.8311e-05, -0.00011583, 0.00024261, -0.00013789, 0.00046582, -0.00037782, 0.00087162, -0.00063643, 0.00019146, -0.00030214, 0.00015481, 0.00035948, 0.00034065, -0.00013397, 0.0006282, -0.00026282, 0.000629, -0.00083565, 0.00055501, -0.00039222, 3.0416e-05, -0.00021896, -0.00025051, 7.5792e-05, 0.00032481, -0.0002841, 5.0197e-05, -7.605e-05, 0.00029723, -0.00059771, 4.8138e-05, -0.00014383, 0.00046738, -0.00043149, -2.2305e-05, -0.00053506, -0.00011828, -0.00021778, -0.0001084, -0.0008066, 0.00028972, -0.00013991, 0.00043598, -0.00043607],
              [0.00079929, -3.012e-05, -9.6683e-07, 0.00086495, 0.00050305, -3.4862e-05, 0.00042196, 0.00065682, 0.00012928, -0.00026826, 0.00070486, -0.00045054, 0.00062842, 0.00021811, -0.00022767, -0.00057437, 0.0001667, -0.00045505, -0.00051896, 0.00016279, 0.00078468, -0.00020117, 0.00081332, -0.00054661, -4.6455e-05, 0.00039251, 0.00089045, 0.00044803, 0.00067252, 0.00034324, 2.9706e-05, -0.00033408, 0.00020838, -0.0014686, 0.0013211, 0.0003623, -0.00042101, -0.0010662, -0.00047869, -0.0011025, -0.00011142, 0.00036055, 0.00080537, -0.0010504, 0.001246, -0.0012889, -0.0001035, -0.00032599, 0.0008196, -0.0003287, 0.00078428, -0.00031028, -0.000132, -0.0012038, 0.00056967, -0.0015831, 0.0012384, -0.00020329, 0.00054442, -0.00047971, 0.00036398, 3.0136e-06, 0.0003463, -0.00016208, 0.00076531, -0.00043743, 0.00035576, -0.0002401, 0.00021525, -0.00065505, 0.00036035, -0.00028137, -0.0001437, -0.00019791, -0.00050362, 0.00056145, -0.00023162, -0.00041906, -4.5824e-05, -7.5822e-05, 0.00080031, 0.0005584, 2.2266e-05, 0.00089773, -9.8581e-05, 0.001173, -0.0005277, -0.00056096, 0.0001046, 0.00047498, 0.00073709, -5.6914e-05, -0.00031024, 0.00087524, -0.00044804, 0.00049556, -0.00070265, 0.00085456, 0.00012342, -0.00093547, 0.00037822, -0.00032902, 0.00056647, 0.00025216, -0.00037243, 0.00061577, -0.00048528, 0.00051398, -0.00076369, -0.00027176, -0.00036518, -0.0012782, -0.00037035, -0.0012045, -0.00051116, -0.00047597, -0.00072161, -0.00037669, -0.00075399, 0.00013433, -0.00059059],
              [-0.0002515, 0.00020005, 0.00019417, -5.7923e-05, 0.00055864, -0.00029405, 0.00046419, 0.0001692, -0.00013657, 0.00014341, -2.7246e-05, -0.00017463, 0.00043209, -0.00024872, 0.0003385, -0.00042825, 0.00045275, -0.00033818, -0.00015837, 0.00037188, 4.0013e-05, 0.00029638, -1.1758e-06, -0.00017447, 0.00012685, -0.00025761, 0.00047736, -0.00015834, 0.00011916, 0.00015943, 9.365e-05, 0.0001324, 2.5813e-05, 7.7539e-06, -0.00041105, 0.00045452, -4.0405e-05, -0.00042519, 2.9496e-05, 0.00022369, -0.00022326, -5.9697e-05, 9.59e-05, -0.000218, -6.6286e-05, 0.00063835, -0.00035776, -0.00043585, 0.0005552, -0.00046868, -0.00036668, 0.00044105, -0.00016743, -0.00015286, -0.00042268, 0.00017696, -0.00087955, 0.00041466, 0.0003045, 6.8465e-06, 0.00021324, 5.5444e-05, -0.00045539, 0.00036257, 5.8126e-05, 0.00048701, -0.0010395, 0.0011089, -0.00047447, -0.0002164, -0.00030265, -0.00031877, 0.00018257, 0.00022085, -0.00045708, -0.00016765, -0.00038681, 0.00023465, -0.00089059, 2.7029e-05, -0.00019392, 0.0004316, 0.00014665, 0.00020277, -0.00016624, 3.3773e-05, -6.9001e-06, 0.00031733, 0.00013184, -0.00026275, 0.00030497, -0.00022988, -0.00034411, 0.00033974, -9.437e-05, 0.0001593, 0.00022083, 0.00023299, 0.00026685, -0.00042236, 0.0010172, -0.00066561, 0.00023103, -5.1105e-05, -0.00025247, 0.00027604, -0.00017761, -0.00010325, 8.8215e-05, -0.00022473, -9.1083e-05, -0.00032299, 0.00049768, 8.6189e-05, -0.00027279, -0.00012651, -0.00052227, -5.2141e-05, -0.00031611, 0.00017884, -0.00037941],
              [-0.17867, -0.010046, -0.04259, -0.065935, 0.052273, 0.033122, 0.02795, 0.034597, 0.040653, -0.0060289, 0.0121, -0.0058231, -0.075829, 0.11467, 0.020114, 0.068302, 0.053668, -0.0019151, 0.0032162, -0.022868, -0.036064, 0.0030444, 0.0050268, -0.016159, 0.013434, 0.046278, -0.019864, 0.033082, -0.011511, -0.023361, 0.048031, 0.072163, -0.034707, 0.015743, -0.043658, 0.05299, -0.00057783, 0.053685, 0.05641, 0.031927, 0.076208, 0.035085, 0.016017, 0.097829, -0.010933, -0.057605, -0.046117, 0.11587, 0.01663, -0.072381, -0.027211, 0.104, -0.049864, 0.013157, 0.068758, -0.086093, 0.10551, -0.051926, -0.084577, -0.023869, 0.11535, -0.029928, -0.098805, 0.081749, -0.10609, 0.031317, -0.028082, 0.079442, -0.093214, -0.069858, 0.10703, -0.071548, 0.064465, -0.099165, -0.01347, 0.034352, -0.10594, -0.035787, -0.011064, 0.018378, -0.039254, -0.14017, -0.037213, 0.011543, 0.0046565, -0.076081, 0.021617, 0.0056964, -0.054225, 0.039976, -0.014192, -0.056039, -0.085955, 0.022657, -0.0022048, 0.002352, -0.0086408, -0.064881, -0.0055523, 0.079596, -0.01119, 0.019694, -0.0090802, 0.0030333, -0.11173, -0.037769, 0.14408, 0.0085418, 0.051063, -0.013809, -0.018804, -0.074726, 0.062213, -0.031173, 0.023266, -0.01323, -0.088087, -0.16851, 0.014989, -0.04579, 0.038302],
              [-0.12472, 0.016332, 0.010132, 0.0072417, -0.059929, 0.014889, -0.052419, 0.022431, -0.043702, 0.021372, -0.066552, -0.076752, 0.031454, 0.00050699, 0.048209, -0.043606, -0.026402, 0.11495, -0.00084488, 0.041763, 0.016621, 0.095744, 0.016932, -0.031217, 0.021554, -0.061228, 0.081696, -0.0551, -0.095302, -0.031352, -0.035125, -0.028837, -0.047885, 0.060702, 0.080685, -0.039628, 0.06471, 0.013113, 0.16301, 0.12825, 0.074636, -0.016897, 0.010567, 0.0033568, -0.041216, 0.083781, 0.10219, -0.048555, 0.095493, -0.12105, -0.14934, -0.038947, 0.053671, 0.10886, 0.062398, -0.064005, -0.0011642, -0.017989, 0.10376, -0.021666, 0.20636, 0.067516, 0.022595, -0.10875, -0.15368, -0.10156, -0.056219, 0.0048936, 0.080509, -0.048987, -0.054674, 0.034417, 0.13789, 0.17934, 0.22694, 0.16715, 0.28888, -0.0045505, 0.12854, -0.14688, 0.039804, 0.0011617, -0.19134, -0.11486, -0.040556, -0.077014, -0.064919, -0.17402, -0.069452, -0.1707, 0.097553, -0.012417, 0.00878, 0.033808, -0.040324, -0.12351, -0.071104, -0.032842, -0.025257, -0.13558, 0.13027, -0.098979, 0.01654, -0.055394, -0.017478, 0.082533, -0.0052693, 0.023715, -0.025128, -0.054494, -0.0065251, -0.19552, 0.00051533, -0.1247, -0.010402, -0.040854, -0.050091, 0.0061714, -0.022234, 0.025005, 0.053772],
              [-0.069531, -0.027855, 0.018198, 0.015264, -0.021355, -0.060615, 0.007426, 0.044909, -0.02229, -0.045038, -0.055531, 0.090244, -0.0038081, 0.001819, -0.023995, 0.022637, 0.034386, -0.0041323, -0.01524, 0.059723, 0.0035447, 0.10857, 0.015828, 0.0089879, 0.021417, -0.026, -0.072054, 0.0067502, -0.043797, -0.086222, 0.0012469, 0.013968, -0.0188, 0.091106, 0.071483, 0.053141, 0.0091481, 0.0032189, 0.10532, 0.013069, 0.11322, 0.024085, 0.10571, 0.097249, -0.040357, -0.052072, 0.0094838, 0.023225, 0.048982, -0.077047, -0.016369, -0.048399, -0.017519, -0.048725, -0.090696, 0.14585, 0.020202, 0.052473, -0.005921, 0.0022813, 0.011431, 0.098602, 0.035391, 0.11802, 0.014488, 0.14986, -0.083365, 0.026042, 0.057536, 0.1029, 0.13376, 0.098599, 0.11296, 0.066812, -0.030392, 0.037677, -0.080465, -0.013433, -0.07905, -0.086928, -0.13723, -0.16181, -0.15594, -0.15634, -0.15766, -0.019054, -0.066428, -0.040315, -0.1553, 0.12102, 0.0073739, -0.039042, 0.044864, -0.031074, -0.037869, 0.026936, -0.025703, 0.030655, -0.0083295, 0.030464, -0.016822, 0.010026, 0.023942, 0.0037369, -0.0062061, 0.040478, 0.0152, 0.035362, 0.035114, -0.10029, -0.1061, -0.0521, -0.0037985, 0.02929, 0.020763, 0.037574, 0.050568, 0.0025948, -0.034033, -0.031897, -0.072553],
              [-0.074151, -0.00066986, -0.038515, -0.023181, -0.032101, -0.016814, -0.043281, -0.034097, 0.010157, 0.030027, -0.1357, 0.05532, 0.041423, 0.054238, 0.075158, -0.0045612, 0.0049337, -0.027804, 0.037859, -0.010636, 0.043039, -0.031109, -0.026843, -0.03367, 0.0053082, -0.03972, -0.011433, 0.0018727, -0.030625, -0.0029381, -0.0095989, -0.013588, -0.0090228, 0.013981, -0.027132, -0.066722, 0.029996, 0.10811, 0.073933, 0.094597, 0.021327, 0.0051895, 0.090626, -0.0014968, 0.095692, 0.071033, 0.093121, 0.08641, -0.082912, -0.063317, 0.058041, 0.094123, 0.048289, 0.0065601, -0.017979, -0.10529, -0.099505, -0.11641, -0.16337, -0.030663, 0.037327, 0.021716, -0.036984, 0.10584, -0.038901, 0.042389, 0.15761, 0.14948, 0.15123, 0.26083, 0.2455, 0.20845, 0.014092, -0.081544, -0.12046, 0.19947, -0.12279, 0.043147, -0.0039359, 0.041945, -0.14663, -0.16842, -0.21746, -0.14594, 0.12454, -0.018239, -0.096476, 0.096745, -0.16116, -0.10959, -0.18407, 0.028717, 0.01794, 0.067713, 0.070427, -0.11003, 0.093084, 0.01548, -0.15557, -0.014144, 0.032512, 0.055568, -0.017473, -0.029534, -0.038828, -0.030212, 0.045497, -0.15438, 0.1342, -0.20134, 0.062249, 0.024284, -0.036965, 0.0046654, 0.019888, -0.083468, -0.016567, -0.08316, 0.0045192, -0.15566, -0.091842],
              [-0.066489, -0.047719, -0.094104, -0.0136, -0.045531, -0.085062, -0.063094, -0.053821, -0.12222, 0.047518, -0.10544, -0.12135, 0.020629, 0.038231, -0.043392, 0.0044225, -0.038085, -0.07983, -0.028986, -0.065506, -0.088403, 0.0075686, 0.0146, -0.0022052, 0.018239, 0.066199, 0.014133, -0.018585, 0.0097275, -0.013373, -0.13952, -0.099454, 0.0024537, 0.023326, 0.052273, -0.0078434, -0.019449, -0.037936, 0.0060267, 0.04031, 0.061324, 0.12961, -0.052464, -0.092317, 0.12501, -0.023511, 0.0687, 0.081178, 0.081636, 0.13285, 0.11443, 0.031137, 0.039574, 0.064207, -0.026586, -0.069602, -0.0068827, -0.086642, -0.12201, -0.087603, -0.097081, -0.14353, -0.032404, 0.016665, -0.028878, 0.046661, 0.16769, 0.081857, 0.13298, 0.15797, 0.15421, 0.23508, 0.10845, -0.026636, 0.10226, 0.074816, -0.067484, 0.014559, -0.031797, -0.060628, -0.091575, -0.021837, -0.18286, 0.094502, 0.013465, 0.017063, 0.047282, 0.10222, 0.0032627, 0.014577, 0.0537, 0.048468, 0.0033061, 0.10215, -0.077242, 0.018935, 0.00098413, 0.047212, -0.042524, -0.059479, -0.043645, 0.007226, -0.045364, 0.0015258, 0.033942, -0.062869, -0.011162, -0.026182, 0.11833, -0.11894, 0.0030267, -0.019807, -0.020185, -0.0019915, -0.028349, -0.051936, -0.11455, 0.016935, -0.037825, -0.013759, -0.14177],
              [-0.12379, -0.022793, -0.056572, -0.039201, -0.014506, -0.14164, -0.066773, -0.016892, 0.018395, -0.060257, -0.11708, -0.16992, 0.022682, -0.037432, 0.027836, -0.10392, -0.024896, -0.10241, 0.027892, 0.03703, 0.025269, -0.18055, -0.13784, 0.032154, 0.10446, 0.042116, 0.0035951, 0.065347, 0.022453, -0.0013755, -0.030524, 0.030664, -0.098775, 0.21125, 0.031923, -0.034705, 0.036622, -0.010853, -0.007389, 0.0056783, 0.029567, 0.096434, 0.029158, 0.29857, -0.079196, 0.00025704, 0.030976, -0.077561, 0.10471, 0.14285, 0.099402, -0.040837, -0.11174, -0.067308, -0.18342, 0.1398, -0.041935, -0.092866, 0.019653, -0.09039, -0.20734, -0.072878, 0.0027433, 0.0061246, 0.094598, 0.15506, 0.041295, 0.0060989, 0.20247, 0.18773, 0.14967, 0.2906, 0.18823, 0.15999, 0.11916, 0.056018, -0.027929, 0.056676, 0.014382, -0.043592, -0.1069, -0.062248, -0.17877, -0.092288, -0.18023, -0.061399, 0.066683, 0.095797, -0.07561, 0.033484, 0.009071, 0.0023841, 0.01285, 0.0037372, 0.056508, 0.071821, 0.074187, -0.027905, -0.084135, 0.10542, 0.028027, 0.065445, 0.064162, 0.032941, 0.0054021, 0.035715, 0.007712, -0.035146, 0.095731, 0.068293, -0.17431, -0.053416, -0.043073, -0.075042, -0.0026001, -0.026745, -0.014015, -0.037147, -0.029554, -0.052553, -0.20455],
              [-0.080337, 0.031543, -0.080333, -0.1658, -0.012897, -0.10179, -0.017891, -0.047932, -0.069573, -0.013085, -0.06403, -0.047389, -0.048253, 0.010624, -0.088304, -0.0248, -0.017016, -0.073112, 0.017958, 0.020032, 0.026271, -0.10027, -0.055354, -0.019203, -0.17887, -0.047929, -0.015477, -0.036581, -0.0013978, -0.02438, -0.013239, -0.016219, 0.033456, 0.031282, -0.11781, 0.08676, 0.096838, 0.007578, 0.040208, 0.039797, -0.0079643, 0.057675, 0.065973, 0.076369, -0.094338, 0.027582, 0.17673, 0.0080282, 0.079734, 0.14711, 0.066918, 0.050334, 0.0011558, 0.013615, 0.0030149, -0.001561, 0.13349, -0.080527, 0.050307, -0.13744, -0.073796, -0.03188, -0.057867, -0.065217, -0.066794, -0.088251, 0.0096845, -0.042764, 0.094638, -0.066202, 0.13555, 0.15163, 0.11508, 0.091266, 0.14084, 0.12799, 0.20636, 0.028581, 0.14482, -0.064493, 0.14635, -0.039325, -0.049278, -0.080228, 0.016308, -0.064651, -0.077927, -0.029574, -0.024416, -0.13305, 0.13699, -0.022414, -0.0058687, 0.0049992, 0.07054, -0.00037991, -0.011859, 0.094751, 0.032189, -0.084875, 0.14236, -0.035525, -0.025841, -0.078953, 0.048318, -0.082027, 0.043364, 0.0027046, -0.027921, -0.071951, -0.09968, -0.12072, 0.027686, -0.065397, 0.041932, -0.06347, 0.015318, -0.088955, -0.0024259, -0.055982, 0.025023],
              [-0.16063, -0.05068, -0.017603, -0.002472, 0.025627, 0.0064475, 0.040905, -0.019412, 0.010908, -0.057, -0.16989, -0.047848, 0.045771, 0.036605, -0.0347, -0.038814, 0.059925, -0.045042, 0.0044791, 0.010086, 0.017233, -0.014699, -0.031159, 0.054786, -0.045019, 0.027938, -0.050948, -0.058028, -0.018143, -0.073467, 0.029761, 0.020105, -0.03083, 0.0089385, 0.0094918, 0.031257, -0.074325, 0.047502, -0.087203, 0.019497, 0.018802, -0.020783, 0.037407, 0.012029, -0.08564, -0.012501, -0.027084, 0.012926, -0.020812, -0.14056, -0.11375, 0.017925, -0.028517, 0.045859, -0.13118, -0.17389, 0.053714, 0.0323, 0.05752, 0.059047, -0.11509, 0.043566, 0.059537, 0.076599, 0.014207, -0.11994, 0.003483, 0.083083, 0.068673, 0.066345, 0.084013, 0.10863, 0.036022, 0.1238, 0.043237, 0.0594, 0.042445, 0.12789, 0.014244, 0.067136, 0.086699, 0.059557, 0.018099, 0.010713, -0.0005958, 0.061343, -0.00013986, 0.22413, 0.088014, -0.058215, -0.0012261, 0.042306, 0.052067, 0.075415, 0.077471, 0.045711, 0.017695, -0.0030659, -0.029624, 0.12897, 0.042184, -0.039395, -0.041007, -0.1339, -0.0425, -0.058195, -0.0952, -0.049991, -0.035359, 0.1586, -0.11702, 0.02205, 0.048193, -0.0056565, 0.055322, 0.0039771, 0.0088791, 0.030973, 0.036137, 0.077637, -0.11747],
              [0.0032106, 0.088885, 0.10096, 0.022293, -0.071525, 0.0057431, 0.065381, 0.0082641, -0.052298, 0.055063, 0.042136, -0.0027337, 0.061071, -0.10701, -0.055828, -0.065033, -0.011795, -0.16487, 0.021281, 0.011339, 0.015608, -0.08575, 0.0043087, -0.0028334, -0.075705, -0.095024, -0.024443, -0.0048743, 0.053736, -0.046164, -0.093394, -0.089492, -0.070094, -0.034765, -0.11037, -0.041699, 0.048555, 0.037317, -0.0091258, -0.024838, -0.10812, -0.011196, 0.062001, -0.030909, -0.20817, 0.028408, -0.034229, 0.015547, 0.042038, 0.149, -0.077828, 0.33344, 0.36268, 0.18381, 0.18802, -0.02676, 0.001051, 0.040988, 0.14355, 0.1472, -0.22199, 0.31512, -0.097934, -0.34109, -0.17922, -0.075038, -0.0606, -0.019191, 0.16686, -0.012989, -0.34657, 0.14668, -0.053558, -0.24973, 0.24117, 0.067441, 0.11114, -0.17424, 0.12201, -0.092747, -0.065791, 0.35856, 0.22608, -0.1116, 0.30572, -0.10906, -0.15714, 0.068396, -0.040922, 0.0013632, 0.10794, 0.11371, 0.05701, -0.082634, 0.046328, 0.056397, 0.020212, -0.029754, 0.054467, -0.014207, 0.093989, 0.044572, -0.073566, -0.15318, -0.061212, 0.026711, 0.036455, 0.1388, 0.2398, 0.111, -0.12734, -0.070921, -0.084031, -0.052911, 0.008027, -0.048337, -0.040315, -0.089109, -0.1026, -0.0918, -0.21141],
              [-0.070542, 0.055085, 0.10153, 0.023622, 0.029956, -0.02606, 0.11064, 0.024489, 0.02197, 0.020457, -0.041117, -0.024812, 0.0095704, -0.048146, -0.041543, -0.0045487, -0.022901, -0.10096, -0.032652, 0.037091, 0.014636, -0.01092, -0.026208, -0.14215, -0.13289, -0.033251, 0.0054752, 0.091854, 0.036012, -0.080267, -0.02962, 0.026873, 0.024976, -0.10102, 0.10924, 0.070655, -0.10936, -0.32088, -0.20437, 0.050939, 0.046306, -0.052625, -0.10829, 0.090883, 0.19174, 0.12934, 0.1186, 0.26211, 0.4376, -0.07386, -0.076584, 0.10681, -0.089974, -0.061555, -0.092351, 0.02414, 0.029438, -0.015638, -0.14953, -0.10876, 0.19098, -0.049896, -0.16239, 0.04671, -0.033452, 0.0046311, 0.0064217, -0.12477, -0.031314, 0.0042103, -0.025366, 0.063684, 0.13395, -0.065578, 0.057464, 0.17257, -0.11824, 0.060334, 0.0037599, -0.0382, 0.066276, 0.25634, -0.093935, 0.1365, 0.0034795, -0.072762, 0.029458, -0.015678, 0.19132, -0.12071, -0.049397, 0.077176, -0.030486, 0.049783, -0.057533, 0.14083, 0.17409, 0.0093446, -0.12819, 0.097922, 0.14847, 0.2172, 0.044316, 0.11562, 0.079277, -0.12049, -0.049673, -0.032827, 0.0090016, -0.13279, -0.20143, -0.012865, -0.052263, -0.059203, -0.11793, -0.18199, -0.00074838, -0.13714, -0.061325, 0.01995, -0.062147],
              [0.051025, -0.019224, -0.0091745, -0.022468, 0.021118, -0.017504, -0.22285, 0.022525, -0.0024245, -0.096691, -0.025361, 0.073435, 0.15109, 0.11522, 0.1297, -0.078929, 0.097198, 0.21131, -0.24961, -0.011818, 0.064528, -0.085348, 0.049274, -0.061577, 0.063001, -0.043023, 0.069051, -0.096092, -0.061694, 0.18034, -0.16664, -0.051094, 0.069176, -0.11904, -0.08579, -0.20469, -0.037006, 0.034799, 0.063283, 0.1479, -0.066933, 0.13701, 0.0071805, -0.062055, 0.22476, -0.073222, -0.080358, -0.11456, 0.20483, 0.10476, 0.10684, -0.10692, 0.018058, 0.12869, -0.071027, 0.04413, 0.12003, 0.14237, 0.21905, 0.069723, -0.082454, -0.10618, 0.079817, 0.17122, 0.11078, -0.1575, -0.026069, 0.17501, 0.19358, 0.15583, 0.13145, 0.10803, -0.015809, -0.066108, -0.14853, -0.054745, -0.065217, -0.026932, 0.017929, -0.025775, -0.12464, -0.13002, -0.23174, -0.0669, -0.037099, -0.030813, 0.11265, -0.03528, -0.066288, -0.094886, -0.13366, -0.07721, -0.094369, 0.053336, 0.041074, -0.044715, 0.14383, -0.054988, -0.0022013, 0.021969, 0.032944, -0.0067769, 0.055703, 0.051114, -0.0071487, -0.050493, 0.11606, -0.10774, -0.017707, -0.029669, -0.16641, -0.048752, -0.07477, -0.066227, -0.10651, -0.00092592, -0.0045899, -0.041813, -0.029842, 0.04003, -0.11835],
              [-0.14161, -0.061297, 0.0081528, 0.095805, -0.12141, -0.15258, 0.14459, 0.10275, -0.076911, 0.010478, -0.064039, -0.084813, 0.025051, 0.087181, -0.20873, 0.0040299, 0.39083, -0.018288, -0.19371, 0.21355, 0.19219, 0.051337, -0.099999, 0.065604, -0.033197, 0.077857, 0.22273, -0.096602, -0.13245, 0.22635, -0.02376, -0.16636, 0.024376, 0.011185, 0.0090203, 0.017388, -0.04308, -0.064752, -0.15373, 0.10303, -0.086296, -0.18748, -0.083188, -0.037066, -0.091363, 0.043056, -0.0076223, -0.0723, 0.18949, 0.091583, 0.09321, 0.078433, -0.086071, -0.16936, 0.21392, -0.07688, 0.14025, 0.18839, 0.11529, -0.16631, -0.13317, -0.019452, 0.013015, 0.28544, 0.23882, 0.23929, -0.025478, 0.011733, -0.03133, 0.026406, 0.17735, 0.15387, 0.022878, 0.15423, 0.10953, 0.19865, -0.10958, 0.0040964, -0.0032427, -0.06496, 0.002359, -0.082444, -0.087193, 0.0056234, -0.024094, -0.12474, -0.14739, -0.13843, -0.094737, 0.043476, -0.022122, -0.058009, 0.074104, 0.027468, -0.068146, -0.086381, -0.072755, 0.01616, -0.095064, -0.055944, 0.02497, -0.092156, 0.020486, -0.049538, 0.062127, 0.010981, 0.028107, -0.023413, -0.011846, -0.04146, -0.12376, -0.0075478, -0.035061, -0.054382, -0.12788, -0.063113, -0.07867, -0.0052472, -0.027462, -0.048145, -0.097095],
              [0.035456, 0.01281, 0.01818, -0.0038058, -0.047339, 0.0086152, -0.046294, 0.016896, 0.073403, 0.057854, 0.046801, 0.017573, -0.023834, -0.028005, -0.061704, 0.0041493, -0.099934, -0.074151, -0.097134, -0.05064, -0.051916, 0.04634, -0.10129, -0.010697, -0.13071, 0.065224, 0.035157, 0.078444, 0.02087, -0.083009, -0.041877, -0.032514, -0.065939, -0.081372, -0.042073, 0.11944, -0.19373, -0.14791, -0.091871, -0.02184, 0.047336, 0.060397, -0.079535, -0.046692, 0.19615, 0.15002, 0.22469, 0.4337, 0.17627, 0.085003, 0.17628, -0.089798, -0.10576, -0.0049048, -0.064592, -0.076504, -0.048693, -0.19598, -0.27569, 0.26255, -0.056874, -0.10876, 0.27052, 0.20636, -0.0015736, -0.17759, -0.0015426, 0.050842, 0.092668, 0.030409, -0.43179, 0.36702, -0.059156, -0.34465, 0.10849, 0.10613, -0.049251, 0.16014, -0.12372, -0.15509, 0.1045, 0.1609, -0.14487, 0.43189, 0.11981, -0.13833, 0.011269, -0.081012, 0.17513, -0.046057, 0.033711, -0.015269, 0.18262, -0.10025, -0.097021, 0.066111, 0.15775, 0.10256, -0.065278, 0.019465, 0.18821, 0.076081, 0.20711, -0.0097133, -0.067601, -0.045104, -0.047138, -0.04305, 0.029932, 0.0056791, -0.17631, -0.030884, -0.020628, -0.10197, -0.11425, -0.020674, -0.024768, -0.074425, -0.055049, -0.037227, -0.16216],
              [-0.070049, 0.085301, 0.0028141, 0.010033, 0.089868, 0.052913, -0.050136, -0.022286, 0.045302, -0.030119, 0.021823, -0.0060856, 0.023126, 0.014529, -0.0015684, -0.027996, -0.16608, 0.07873, 0.036994, -0.016142, 0.068801, -0.043417, 0.038981, -0.06654, 0.0031039, -0.013009, -0.092595, 0.12644, 0.040773, -0.085448, -0.13739, -0.13311, -0.11021, 0.070763, 0.080261, -0.16878, -0.05206, 0.13425, -0.10535, -0.33738, -0.070808, 0.057004, 0.09228, -0.011615, -0.050913, -0.16069, -0.048848, 0.071389, -0.043639, -0.13394, 0.30516, 0.23788, 0.20977, 0.12056, 0.25283, -0.0023562, -0.035137, 0.049605, -0.10416, -0.14206, 0.25292, -0.038235, -0.053227, -0.16541, -0.014617, 0.028801, -0.10097, 0.10738, 0.12267, -0.05807, 0.073527, 0.01054, -0.051688, -0.072825, 0.11389, -0.099763, -0.099681, -0.0083155, 0.028782, -0.016644, -0.10306, 0.17422, -0.012649, 0.26026, 0.13061, -0.13681, -0.055878, 0.09867, -0.1397, 0.029745, 0.073907, 0.16843, 0.089063, -0.081254, 0.0080562, 0.15433, 0.061775, -0.050386, 0.19951, -0.095579, -0.078848, 0.066657, -0.07773, -0.059688, -0.0023501, -0.0046282, 0.075461, 0.11777, 0.24713, -0.021968, -0.093774, -0.011643, -0.055253, -0.067446, -0.09786, -0.067747, -0.11419, -0.15448, -0.053914, -0.072083, -0.10186],
              [-0.014135, -0.083516, 0.025062, 0.075977, -0.15437, -0.042405, -0.034524, 0.13187, -0.018957, -0.0026675, 0.10306, 0.04033, -0.10561, 0.017365, -0.15937, 0.032279, 0.1053, 0.075028, -0.11928, 0.10401, 0.14421, 0.0071286, -0.079992, 0.014275, -0.03873, -0.13695, 0.18645, -0.065111, -0.14101, 0.22619, -0.0019016, -0.049331, 0.014048, -0.033852, -0.028526, 0.08623, 0.10756, -0.040378, 0.040168, 0.25442, -0.34992, -0.11829, -0.11322, -0.03604, 0.0091419, 0.015128, 0.048542, -0.11506, 0.081696, 0.17251, 0.15416, 0.10511, -0.21705, -0.14597, 0.19709, -0.12399, 0.10066, 0.12172, 0.12481, -0.055988, -0.21829, 0.080538, 0.23046, 0.31883, 0.20522, 0.0081843, -0.054335, -0.11191, -0.0056947, -0.043056, -0.04046, 0.10031, -0.060037, 0.14527, 0.25791, 0.16199, 0.049309, 0.0040739, 0.11099, -0.020691, -0.11144, -0.081095, -0.11639, -0.038956, -0.12985, -0.22365, -0.0058588, -0.036087, -0.077144, -0.047407, 0.027429, 0.099597, 0.040004, -0.073007, -0.017636, -0.072072, -0.0031646, -0.065567, -0.10478, 0.0094405, 0.025832, -0.03882, 0.027512, 0.036751, 0.040562, -0.0038665, 0.012356, -0.053858, -0.00065956, -0.0026598, -0.11896, 0.022143, -0.046808, -0.07491, 0.018173, -0.066413, -0.033129, -0.12809, 0.0050881, -0.088215, -0.1122],
              [-0.036364, 0.056084, -0.054615, 0.12841, 0.034695, -0.099269, 0.035218, 0.001705, -0.053721, -0.1047, -0.057794, -0.0079505, 0.079079, 0.17476, -0.073746, 0.14079, 0.17945, -0.028798, -0.053414, 0.088642, 0.0067588, -0.13125, 0.03217, -0.075938, -0.045683, 0.098321, -0.11055, -0.085252, 0.1988, 0.020722, 0.022471, 0.082376, -0.11576, 0.032843, -0.083484, -0.077332, -0.11177, 0.024984, -0.030403, -0.029025, -0.10372, 0.011701, 0.0093278, 0.0024312, 0.15007, -0.21395, -0.11854, -0.0019534, 0.18178, 0.054955, 0.15511, 0.030061, -0.019865, 0.070851, -0.00048596, 0.17946, 0.30639, 0.14694, 0.10068, -0.073081, -0.083394, -0.13131, 0.026088, 0.1539, 0.14966, -0.12432, -0.055198, 0.23539, 0.23071, 0.17815, 0.032433, 0.08525, 0.10099, 0.076039, -0.013732, 0.01869, -0.032925, -0.22859, -0.12676, -0.11187, -0.12231, -0.022443, 0.014664, -0.049709, -0.031971, -0.03212, 0.044761, -0.048497, -0.0359, -0.059853, -0.046859, -0.054269, -0.025597, -0.05982, -0.029519, 0.0036297, -0.020509, -0.001523, -0.090003, -0.026576, -0.010829, -0.0095883, -0.0089047, 0.0029522, 0.0038042, 0.061866, 0.03369, -0.066066, -0.024372, -0.034185, -0.10894, 0.0071168, -0.094013, -0.018408, -0.057182, -0.026056, -0.08889, -0.10212, -0.04305, -0.085051, -0.026051]
            ], "lbp": [
              [-0.0279, -0.0060442, -0.029118, -0.012328, 0.061854, 0.095671, 0.045972, 0.015531, -0.012023, -0.040293, -0.033222, -0.0035958, -0.013857, -0.034504, 0.017543, 0.036808, 0.08477, 0.060825, -0.0093584, -0.048193, -0.0065947, -0.030168, -0.0073362, -0.049812, -0.028526, -0.0089851, 0.037543, 0.07585, 0.040464, -0.020222, -0.010643, -0.025973, -0.029295, -0.049586, -0.016454, -0.013482, -0.034207, 0.069169, 0.043415, 0.066515, -0.028014, -0.0028085, 0.012846, -0.020229, 0.026364, -0.024003, -0.071419, 0.019799, 0.047962, 0.090396, 0.05487, -0.015562, -0.0052397, -0.013383, -0.0017451, 0.00097397, -0.034245, -0.029304, -0.015763, 0.012324, 0.11024, 0.0052691, -0.0082711, 0.029191, 0.010482, 0.0048675, -0.0043579, -0.02572, -0.065308, 0.016283, 0.042681, 0.074985, 0.016473, 0.013771, 0.0024093, 0.024024, 0.033111, -0.056875, -0.027797, -0.033811, 0.015079, 0.04821, 0.11415, -0.0050453, -0.024537, -0.0046878, 0.030699, 0.036164, -0.01766, -0.02759, -0.023776, -0.0031654, 0.043854, 0.093522, -0.0015599, -0.019099, 0.041501, -0.0029953, 0.020048, -0.025806, -0.014023, -0.052045, -0.0089677, 0.059688, 0.082792, 0.021693, -0.0122, -0.0040159, 0.048254, 0.0050565, -0.02978, -0.045802, -0.022217, -0.026806, 0.080558, 0.11125, 0.024835, 0.013031, 0.026214, 0.0092541, 0.054743],
              [-8.7334e-05, 3.7445e-05, -1.6719e-05, 2.645e-05, 0.00026446, 0.00018012, 0.00013079, -8.9234e-05, 8.7778e-05, -2.863e-05, 0.00019466, 4.0175e-05, -2.447e-05, -5.5303e-05, -9.4642e-05, 0.00013992, 0.00025974, 0.00010837, -2.8508e-05, 2.0612e-06, -5.4547e-05, 0.00011548, -0.0001789, 1.0106e-06, -1.6477e-05, -5.4462e-05, 4.6057e-05, 0.00020887, -5.986e-06, 3.9147e-05, -0.00015654, -5.0893e-05, 8.3829e-05, -3.926e-05, 2.9023e-06, -5.5656e-05, -3.9745e-05, 8.2728e-05, 0.00021615, 0.00016965, -0.00015047, -3.9212e-05, -4.1804e-05, 9.8943e-05, -3.77e-05, -2.1777e-05, -0.00010842, -0.0001125, -2.8089e-05, 0.000245, 0.00011698, 0.000137, -0.00011632, 3.8759e-05, -5.0384e-05, -5.6491e-05, 4.1859e-05, 0.0001051, -9.5909e-05, -8.2666e-05, 0.00014673, 0.00017377, -6.6786e-05, 7.6118e-05, -0.00016836, 0.00012437, 2.5725e-05, -6.2337e-05, -0.00015377, -2.7483e-05, -2.8455e-05, 0.00012458, 0.00015628, -2.4737e-05, -2.0912e-05, 4.3221e-05, -1.0155e-05, -9.9849e-05, 0.00014167, -9.9759e-05, -5.3681e-05, 2.4697e-05, 1.825e-05, 0.00019364, -7.2709e-05, 3.8335e-05, -1.9411e-05, -3.2116e-05, 5.1948e-05, -3.8287e-05, 9.7189e-05, -0.00011816, -0.0001609, 0.00011624, 4.9146e-05, 0.00010182, -1.4288e-05, 4.3292e-05, -1.9967e-05, -1.7368e-05, -1.9583e-05, -3.2833e-05, -5.3814e-05, -5.6208e-05, -5.3242e-05, 0.00024615, 9.7553e-05, 2.1844e-05, 3.0258e-05, -5.3699e-05, -2.5231e-05, -5.8324e-05, -4.705e-05, 3.6195e-05, -2.9441e-05, -6.9517e-05, 0.00012457, -3.5054e-05, 2.1987e-05, -1.5332e-05, -2.3047e-05],
              [-3.6084e-05, -1.9307e-05, 6.647e-05, -6.9627e-05, 5.3718e-05, 8.6337e-05, 8.2142e-05, -8.1711e-05, 4.0206e-05, 7.8479e-05, -4.904e-05, 5.7454e-05, -0.00010018, -2.6148e-05, 7.1198e-05, 2.5683e-05, 0.00011929, 2.7861e-05, 3.2654e-06, -5.5574e-05, -2.4041e-05, -3.7016e-05, -0.00013309, 1.9238e-05, -2.7446e-05, -1.1994e-05, 3.5032e-05, 9.489e-05, 4.1828e-05, -3.4147e-05, 3.1692e-05, -0.00012748, -1.5841e-05, 4.7074e-05, -5.4219e-05, -2.7058e-05, 1.9573e-06, -4.2885e-06, 5.1784e-05, 9.7614e-05, 2.6206e-05, -3.8407e-05, -4.3621e-05, 6.1283e-05, -4.1485e-05, -1.8992e-05, -3.8766e-05, 2.4842e-05, 1.9431e-05, 5.7022e-05, 3.6943e-05, -2.2802e-05, 5.8533e-05, -3.8134e-05, -0.00010733, -2.1349e-05, 2.0213e-05, -1.0308e-05, -0.00013178, 9.2793e-06, -6.4061e-06, 0.00010489, -3.6972e-05, 1.9206e-05, -2.512e-05, 6.6678e-06, -5.3173e-05, 1.5596e-05, 4.2064e-05, -0.00011209, -8.0476e-05, 8.6804e-05, 8.6344e-05, 2.8719e-05, -5.3155e-05, -5.4571e-05, 2.774e-05, 3.129e-06, 1.8897e-06, -0.00012179, 6.684e-05, -0.00010634, 3.586e-05, 0.00015372, 9.3482e-05, -5.1253e-05, -1.1146e-05, -1.9744e-05, -7.8769e-05, -7.5893e-05, 1.3246e-07, -0.00019713, -1.3375e-05, -3.2244e-05, 4.5963e-05, 1.3631e-06, 6.1091e-05, -3.7064e-05, 5.3774e-05, 2.8715e-05, 4.3069e-06, -5.9399e-05, 9.4064e-05, -0.00012586, 5.0461e-05, 0.00013218, 9.0391e-05, -6.4299e-05, 6.1429e-05, 7.2397e-07, -6.3668e-05, 4.8759e-05, 1.3706e-06, -9.7973e-05, 2.9715e-05, -0.00017065, 5.6129e-07, 0.0001305, 3.9513e-05, -3.0858e-05, -8.0773e-05],
              [-0.00010042, -7.5004e-05, 7.7579e-05, 0.0001506, 0.00010273, -1.3456e-06, -8.5138e-05, 9.5278e-06, -5.1251e-05, 2.1937e-06, -2.9907e-05, -1.7823e-05, 1.5921e-05, -4.262e-07, 7.5622e-05, 0.00012391, -3.7227e-05, -5.1852e-05, -8.036e-05, 7.6557e-06, -2.9341e-05, 8.2155e-05, -6.0163e-07, -9.0231e-05, -0.00014678, 5.8459e-05, 0.0001292, 6.8728e-05, -5.0835e-05, -4.9058e-05, 1.4667e-05, 2.2867e-06, -4.0793e-05, 3.1833e-05, -4.614e-05, -0.00013109, -4.5015e-06, 0.00013512, 8.2693e-05, 3.7213e-05, -0.00021402, 1.2161e-05, 9.9526e-07, -4.0751e-05, -5.3363e-05, 1.3589e-05, -3.4576e-05, -8.6226e-05, 0.00012833, 0.0001795, -7.6588e-05, -5.9447e-06, -3.3934e-05, 5.9031e-05, -2.0159e-05, 6.848e-06, -3.508e-05, -0.00010776, -6.0092e-05, -2.1592e-05, 0.00020857, 0.00013308, -0.00019039, -4.8312e-05, -4.4977e-05, 9.0492e-06, -5.3993e-05, 3.1276e-05, -3.2915e-06, -0.00013006, -6.2666e-05, 5.4667e-05, 0.00011703, 1.0892e-05, -0.00019162, 1.7056e-05, 2.9742e-05, 1.5551e-05, -4.5024e-05, -6.5835e-06, -0.00012256, -3.9207e-05, 5.772e-05, 0.00026173, 0.00011301, -5.0802e-05, -0.00012439, -0.00011512, -3.3744e-05, -3.5132e-05, -4.6346e-05, 1.503e-05, -7.9108e-05, -0.00013976, 0.00019174, 0.00023315, -3.2682e-05, -2.2277e-05, -0.0001316, -5.3704e-05, 4.6652e-06, -2.973e-06, -7.4267e-05, -5.3893e-05, -1.3168e-05, -7.309e-05, 0.00020791, 0.00015787, -6.9607e-05, -7.3262e-05, -1.4507e-05, 1.322e-05, -6.5931e-05, 8.7111e-05, -6.5268e-05, -9.1013e-05, -5.1961e-05, 0.00012231, 0.00015993, 5.6612e-07, -6.6483e-05],
              [-0.01852, 0.033336, 0.06082, 0.040323, -0.049048, -0.063471, -0.041691, -0.04404, 0.011259, -0.02554, 0.043104, -0.028504, 0.02179, 0.044813, 0.072343, -0.0054581, -0.068821, -0.027964, -0.043244, -0.0078419, 0.02404, -0.035356, -0.00086043, 0.0096468, 0.029019, 0.067023, 0.05703, -0.043874, -0.075663, -0.046868, -0.018265, -0.0074627, -0.021262, -0.0082441, 0.0029956, -0.0089729, 0.061101, 0.099636, 0.012468, -0.10296, -0.052371, -0.027535, -0.029446, -0.014438, -0.020598, -0.0069193, -0.0068354, 0.046889, 0.095419, 0.11953, -0.07176, -0.097543, -0.038582, -0.011359, 0.0096414, -0.019378, -0.027302, -0.018977, -0.0097874, 0.052494, 0.13674, 0.079523, -0.12204, -0.086659, -0.050788, -0.0095706, -0.031867, 0.0065403, -0.013821, -0.025842, 0.039928, 0.078784, 0.14509, 0.015223, -0.15795, -0.078115, -0.035586, -0.0074434, -0.0031399, -0.0037907, -0.01703, -0.028687, 0.033231, 0.078113, 0.14322, -0.019232, -0.14759, -0.079879, -0.0083759, -0.0013328, -0.0069555, -0.013966, -0.0084517, -0.030636, 0.062565, 0.097484, 0.098393, -0.075766, -0.1345, 0.014089, -0.011156, -0.013224, 0.016021, -0.0092009, -0.026044, -0.0089943, 0.040512, 0.13766, 0.019532, -0.11369, -0.014675, 0.010069, -0.0027238, -0.029504, 0.023985, -0.030692, 0.00075273, 0.016509, 0.052598, 0.093807, -0.010161],
              [0.02242, -0.01264, -0.054968, -0.096784, -0.029279, -0.02714, -0.0090863, -0.014365, -0.0036875, 0.046401, 0.069449, 0.046438, 0.054029, -0.014721, -0.062916, -0.098776, -0.045678, -0.010326, 0.0033233, -0.0034084, 0.018489, 0.06168, 0.030027, 0.056348, 0.02544, -0.0079353, -0.09041, -0.1292, -0.034537, -0.018949, -0.0010619, 0.013098, 0.032364, 0.050549, 0.03199, 0.050349, 0.05595, -0.021494, -0.10945, -0.097342, -0.069734, 0.00046789, 0.0088096, 0.021994, 0.002741, 0.039372, 0.046871, 0.065601, 0.050121, -0.016483, -0.12612, -0.1119, -0.047332, -0.017261, 0.012597, -0.007535, 0.0038006, 0.051789, 0.056093, 0.084082, 0.077149, 0.01105, -0.12129, -0.12084, -0.053177, -0.02708, -0.0075679, -0.016071, -0.019008, 0.030912, 0.061183, 0.067858, 0.11649, 0.051234, -0.062048, -0.12296, -0.11728, -0.00044317, -0.0022492, -0.027298, -0.0037413, 0.018339, 0.014062, 0.042777, 0.12122, 0.043922, -0.060791, -0.14711, 0.016829, 0.0097743, -0.026557, 0.01411, 0.0015912, 0.0048096, 0.029094, 0.022041, 0.11057, 0.028481, -0.10628, -0.035908, 0.013354, -0.0026337, 0.0037218, 0.012118, -0.017185, 0.03754, 0.021333, 0.037077, 0.034944, 0.0038125, -0.011495, -0.002531, 0.017794, -0.0060676, 0.0061802, 0.023088, -0.0090738, 0.039517, 0.034463, 0.032449, 0.034403],
              [0.0068337, -0.018869, -0.059136, -0.028733, -0.048296, -0.013674, 0.02159, -0.011046, -9.2586e-05, -0.019605, -0.043554, -0.0067654, -0.020683, -0.030702, -0.028849, -0.017813, -0.045032, -0.06082, -0.010178, 0.015937, -0.016985, -0.040648, 0.062809, 0.03329, 0.0086341, -0.010323, -0.059033, -0.063911, -0.040962, -0.027001, -0.03499, -0.028182, -0.042998, 0.06917, 0.043704, 0.052829, 0.047981, -0.062747, -0.078758, -0.075128, -0.067144, -0.066726, -0.041696, -0.06075, 0.024188, 0.068641, 0.041599, 0.078907, 0.083979, -0.0038264, -0.12006, -0.11316, -0.13579, -0.093038, -0.094331, 0.039375, 0.0018503, 0.00098404, 0.043251, 0.1029, 0.10139, 0.098296, 0.0015172, -0.091353, -0.14409, -0.17601, 0.0027217, 0.005046, 0.013052, -0.022684, 0.0018963, 0.058561, 0.10082, 0.12841, 0.081889, 0.020432, -0.041168, -0.0055029, -0.0065943, 0.014863, 0.003731, -0.0055734, -0.0095154, -0.0085635, 0.013253, 0.048733, 0.069683, 0.046721, 0.01748, 0.01314, 0.0057339, -0.012004, 0.023956, -0.030001, 0.047563, 0.007726, 0.033238, 0.017011, 0.061534, 0.020213, 0.017305, 0.0022898, 0.0016835, 0.0010206, 0.017475, -0.01795, 0.0165, -0.011803, 0.0071376, 0.020111, 0.0066511, -0.035355, 0.027934, 0.0035907, -0.011547, 0.022731, 0.0063451, 0.063988, 0.03377, 0.019839, 0.040068],
              [-0.091836, -0.046604, -0.041677, -0.03393, -0.035176, -0.0080454, -0.0090217, -0.021214, -0.062925, -0.05369, -0.061859, -0.06938, -0.020604, -0.034831, -0.019889, -0.011468, -0.0094848, -0.02506, -0.013132, -0.034374, -0.029389, -0.054679, -0.040921, -0.079026, -0.031301, -0.0071872, 0.0034458, -0.042066, -0.021032, -0.0012771, -0.005576, -0.049905, -0.067836, -0.02538, -0.060497, -0.095684, -0.066898, -0.065214, -0.042634, -0.077401, -0.069225, -0.046597, -0.048532, -0.039853, 0.058792, 0.01903, -0.024286, -0.032536, -0.054851, -0.02916, -0.01714, -0.025126, -0.021866, 0.028553, 0.039992, 0.097746, 0.075003, 0.074305, 0.046933, 0.098597, 0.06983, 0.076648, 0.055005, 0.03235, 0.096666, 0.010919, 0.022114, 0.052323, -0.012178, -0.010456, -0.01888, 0.00472, 0.002689, 0.018985, -0.0023285, 0.0062287, 0.029915, 0.035545, 0.031167, 0.023817, -0.02707, 0.012571, -0.010192, 0.038028, 0.021584, 0.004171, 0.0055754, 0.017283, 0.012313, 0.014889, 0.0026556, 0.0041491, 0.0089248, -0.035192, 0.014939, 0.014097, 0.0038995, 0.0038989, 0.017267, 0.034244, 0.049764, -0.0052189, 0.026331, 0.0018007, 0.040202, 0.008388, 0.0089671, 0.021012, 0.0053809, 0.011463, -0.0066134, 0.045841, 0.047592, -0.011382, -0.00070927, 0.0074075, 0.0019847, -0.030303, 0.018518, 0.026217, 0.034368],
              [-0.027531, -0.04099, -0.026966, -0.012312, -0.039448, -0.036665, -0.037447, -0.022588, -0.062582, -0.033424, -0.0076373, -0.033316, -0.0039483, -0.016274, -0.012993, -0.034373, -0.034351, -0.051089, -0.046268, 0.0338, -0.0073587, 0.019133, -0.058298, -0.031083, 0.0083773, -0.037071, -0.023704, -0.039292, -0.048264, -0.012347, 0.035773, 0.037157, 0.02657, -0.037942, -0.024177, -0.031307, -0.054205, -0.067683, -0.053316, -0.010339, 0.029943, 0.014711, 0.049806, 0.052372, -0.10703, -0.045011, -0.092731, -0.085093, -0.06361, -0.0095235, 0.042742, 0.043444, 0.046036, 0.028779, 0.047907, -0.12009, -0.11013, -0.078798, -0.018737, 0.031174, 0.095075, 0.060365, 0.019221, 0.01389, -0.0076667, 0.016337, -0.0089402, -0.0095031, 0.069645, 0.10401, 0.05246, -0.026938, 0.0042842, -0.010856, 0.016053, -0.028949, 0.00023294, 0.10368, 0.050069, 0.036853, 0.0065038, 0.0055476, -0.0010844, -0.0013257, -0.0055543, 0.04533, 0.0065356, 0.00060779, 0.072039, 0.028969, 0.013967, -0.0072271, 0.0072232, 0.0088564, -0.012818, 0.0018159, -0.011049, 0.0081952, 0.01255, 0.030697, 0.067976, -0.02221, 0.017374, -0.0058382, -0.016933, -0.020607, -0.0037044, 0.0029398, 0.0096079, 0.0041619, 0.051669, 0.0039989, 0.031118, 0.026295, 0.017533, 0.025534, 0.015159, -0.0079481, 0.0038965, -0.0053933, 0.021361],
              [0.012976, 0.019239, 0.015861, -0.050084, -0.01483, -0.042429, -0.054637, -0.087876, -0.026659, -0.01559, 0.036899, 0.024659, 0.0020171, 0.017922, -0.027324, -0.01318, -0.055753, -0.049085, -0.02237, -0.0042862, 0.041589, 0.026715, 0.03305, 0.0089521, -0.017401, 0.0075428, -0.059296, -0.055869, -0.05766, -0.042846, 0.014164, 0.016126, 0.045832, -0.034399, 0.024141, -0.034808, -0.040343, -0.071211, -0.066221, -0.021197, 0.040154, 0.026898, 0.041076, 0.013103, -0.054802, -0.036158, -0.02565, -0.031709, -0.071922, 0.0018536, 0.061357, -0.0047183, 0.040749, 0.013386, 0.022021, -0.071345, -0.032751, -0.061368, -0.077484, 0.040235, 0.068103, 0.052652, 0.03711, -0.0069502, 0.0099627, -0.013836, -0.10765, -0.055495, -0.03497, 0.011212, 0.071812, 0.073453, 0.011483, 0.0046876, -0.018293, 0.034171, -0.010281, -0.11953, -0.027929, 0.039183, 0.054784, 0.058364, 0.010348, 0.024383, -0.037225, 0.018329, -0.021362, 0.016318, -0.036989, 0.025345, 0.049929, 0.046243, -0.0049605, 0.003492, -0.044847, 0.0083152, -0.0013348, -0.031795, 0.0084112, 0.042995, 0.01037, 0.032727, 0.017614, -0.01788, 0.013044, 0.0031246, 0.017806, -0.0083911, 0.0067982, -0.013767, 0.056008, 0.046171, -0.0067631, -0.011002, 0.021424, 0.024102, 0.034702, 0.021782, -0.020309, -0.016831, -0.0089978],
              [-0.00053289, 0.011812, -0.0097595, -0.0329, -0.040055, -0.087664, -0.054682, -0.012138, 0.0081353, 0.05825, 0.030708, -0.015345, -0.017994, 0.0049204, -0.013879, -0.030835, -0.057101, -0.032671, -0.003775, 0.046975, 0.027796, 0.0092523, -0.018921, -0.017058, -0.0026666, -0.03212, -0.044974, -0.055384, -0.0091233, 0.042053, 0.0059455, 0.0522, 0.013922, -0.019418, -0.0042121, -0.016059, -0.019873, -0.063211, -0.061902, 0.010728, 0.048801, 0.037393, 0.0072674, 0.01281, -0.0034511, 0.016898, -0.02259, -0.062363, -0.060955, 0.018029, 0.071601, 0.039035, 0.020919, 0.016562, -0.023867, -0.027629, -0.029462, -0.055111, -0.068953, -0.031776, 0.038109, 0.032616, -0.0056891, 0.0095691, -0.019287, 0.0062446, -0.028641, -0.044572, -0.056247, -0.03575, 0.073366, 0.067655, 0.026481, -0.022367, -0.0069125, 0.0098899, -0.013395, -0.059838, -0.055071, -0.057235, 0.026937, 0.056778, 0.045512, 0.01049, -0.021873, 0.00025674, -0.0091984, -0.003236, -0.098454, -0.056634, 0.040879, 0.053708, 0.021417, 0.03366, -0.024267, -0.039721, 0.025845, -0.0036737, -0.0019563, -0.092076, 0.0071538, 0.048235, 0.031954, 0.0039891, 0.013124, 0.011507, 0.0048599, -0.02807, -0.013715, 0.0044504, 0.011633, 0.016825, 0.04401, 0.043599, 0.010462, -0.011714, 0.02335, 0.025825, -0.040209, 0.022222, -0.018984],
              [-0.00012902, -6.2039e-06, 3.2702e-05, -3.1071e-05, -7.8012e-05, -1.2261e-06, -9.3429e-06, 7.5834e-05, 1.8838e-05, 3.8242e-05, -5.8627e-05, 1.2707e-05, -2.0943e-05, 7.2618e-05, -0.0001086, -2.8985e-05, -0.00016736, 5.8134e-05, 0.00011172, 1.7755e-05, -9.4519e-05, 2.1444e-05, 4.6865e-05, -4.6388e-05, -8.9561e-06, 2.9043e-05, -8.1943e-05, -6.1236e-05, -1.1153e-05, 0.00010189, -2.2193e-05, -2.2869e-05, -0.0001151, -4.9758e-05, -1.9393e-05, -9.4734e-05, -3.0802e-05, -1.1207e-05, -8.8749e-05, 0.00013301, -3.5925e-05, 0.00013742, -0.00011808, 2.2415e-05, 2.3854e-05, -4.5322e-05, 3.4573e-05, -4.6143e-05, -7.5349e-05, 8.1388e-05, 3.3797e-05, 8.4447e-05, -9.0275e-06, 7.0081e-05, -6.146e-05, -5.3968e-05, 2.2718e-05, -0.00015616, -5.6949e-05, -7.4116e-05, -6.3488e-05, 7.5446e-05, 4.4607e-05, -0.0001045, 9.5752e-05, -4.4579e-05, 9.0415e-05, 7.3014e-06, -6.6094e-05, -0.00017393, 0.00014376, 0.00014113, -1.417e-06, 9.806e-06, 6.5253e-05, -0.00013048, 3.4993e-05, -0.00010216, -8.422e-05, -9.7025e-06, -8.5183e-05, -1.8575e-05, 3.8638e-05, 7.925e-05, -9.6774e-05, -6.2754e-05, 0.00014663, 1.7007e-05, 5.5151e-06, -5.1712e-05, -0.00014949, 4.8591e-05, 3.882e-05, 4.357e-05, 1.1474e-05, 7.3157e-05, -3.8172e-06, -6.3708e-05, 7.266e-05, -0.00010594, -6.3345e-05, -5.4025e-05, 8.3061e-05, 0.00010798, -1.84e-05, -4.9804e-05, 3.6573e-05, -4.7482e-05, 1.7943e-05, 4.769e-05, -1.2466e-05, -0.00019635, 2.4802e-06, 0.00015032, 9.532e-05, 2.4342e-05, 8.4135e-06, -1.0238e-05, 1.764e-05, -4.9212e-05, -6.478e-06],
              [-2.1082e-05, -8.3621e-05, -7.9324e-05, -5.637e-05, -2.5225e-05, 6.7038e-05, 1.8979e-05, -3.6384e-05, 6.3535e-05, 5.8201e-05, 4.158e-05, -8.0246e-05, -7.7025e-05, 8.0153e-05, -0.00014514, -2.5225e-05, 0.00016502, 2.6271e-05, 2.5316e-05, -6.7103e-05, -1.1804e-05, -3.7281e-05, 5.2411e-06, 1.9188e-06, -4.1461e-05, 2.4848e-05, -0.00010693, 2.6295e-05, 0.00024743, -1.3795e-05, 5.7822e-05, -6.3546e-05, 7.9185e-06, -2.9438e-05, -5.1192e-05, -5.2297e-05, -0.00015826, 4.471e-05, 0.00010007, -1.5725e-05, 0.00011394, -1.2177e-05, -6.2006e-06, 1.6735e-05, -3.2321e-05, 7.0455e-05, -1.1204e-05, -3.7759e-05, -9.6707e-05, 8.528e-05, 0.00010626, -7.906e-05, 8.7526e-05, -6.0073e-05, 2.9006e-06, -2.2316e-05, -6.2577e-05, 5.1835e-05, -7.8179e-05, 2.8747e-05, 9.1197e-05, -8.5285e-05, 1.5505e-05, -4.3118e-05, 5.1102e-05, -2.5996e-05, 9.5403e-06, 5.4456e-05, -0.00012492, -8.4469e-05, -9.0009e-05, 4.6173e-05, 7.1313e-05, -0.00011471, -1.4347e-05, 9.7454e-05, -4.1038e-05, 4.6701e-05, -3.9864e-05, 2.8496e-05, -9.0668e-05, -4.4743e-05, 2.8884e-05, 0.00010541, 3.8505e-05, -0.00015699, 7.3335e-06, 4.9803e-05, 4.7615e-05, 2.1925e-05, -6.863e-05, -0.00015531, -3.1002e-05, 6.3968e-05, -3.1107e-05, 9.1935e-05, 2.6946e-05, -5.4283e-05, 4.0195e-05, -2.9248e-05, 2.7238e-05, 9.8186e-05, -4.2389e-05, 4.3793e-05, 1.6481e-05, 9.6248e-05, -3.3119e-05, 6.7699e-06, 1.8953e-05, 2.9371e-05, 1.8804e-05, -0.00019186, -5.3615e-05, -6.4625e-05, 6.2102e-05, 0.00011143, 2.7598e-05, -2.5795e-05, 6.4102e-06, 4.3683e-06, -6.8056e-06],
              [8.7288e-05, -0.00016058, 4.24e-05, -5.4107e-05, 3.0344e-05, 8.8236e-05, 0.00018665, -1.0618e-05, 4.8858e-05, 2.5609e-05, -0.00010411, 7.9334e-05, 0.00011912, -0.00017618, -0.00011562, -0.00015415, 0.00014088, 0.00016468, 0.00011508, -0.0001571, 0.00010763, -9.1181e-05, -5.5087e-05, 5.9474e-06, -8.6291e-05, -0.0001242, -0.00010347, 9.36e-05, 0.00026255, 6.4223e-06, 7.2573e-05, -4.0335e-05, 6.7906e-05, -2.9378e-05, -2.3486e-05, -8.391e-05, -0.00020864, -6.7756e-05, 0.00015157, 0.00017534, 9.5333e-05, -7.862e-05, -1.9996e-05, -3.9619e-05, -0.00010062, -4.9007e-05, -3.336e-05, -6.023e-05, -0.00015274, 5.8063e-05, 0.00017946, -1.3679e-05, -7.8757e-05, 2.3928e-06, -2.3839e-05, -9.2483e-05, 2.977e-05, -0.00014104, -4.8579e-05, -0.00017751, 0.00018735, 0.00010606, 0.00010934, 4.3269e-06, -7.1744e-05, 7.0321e-05, -8.9326e-05, -3.4592e-05, -0.00011019, -0.00019881, 5.2019e-07, 8.541e-05, 0.00020005, -2.2823e-05, -6.6226e-05, -1.4683e-05, -9.083e-05, -7.0533e-05, -4.3155e-06, -6.6612e-05, -0.00012963, -8.4206e-05, 0.00019016, 4.6518e-05, 6.503e-05, 2.5248e-05, 4.9507e-05, 5.4034e-05, -8.5821e-05, -9.1441e-05, -0.00013512, -6.0564e-05, 2.1194e-05, 0.0001521, 0.00017075, -9.0845e-05, 5.4303e-05, 0.0001018, -6.0323e-05, -9.4463e-05, -3.224e-05, -0.0001201, -0.00012404, 4.4631e-05, 5.2507e-05, 0.00017357, -7.696e-06, -2.871e-06, -3.4926e-05, 6.2447e-05, -0.00017904, -2.0437e-05, -0.00018575, -0.00012522, -2.4217e-05, 0.00014052, -8.2035e-07, 8.7476e-05, 2.4935e-05, 6.4846e-05, -6.3934e-05],
              [3.5395e-05, -6.8076e-05, -6.0927e-05, -0.00015316, 7.348e-05, 9.7564e-05, -1.245e-05, -1.4501e-05, -7.3971e-05, -4.034e-06, -3.8655e-05, 1.4379e-05, 3.4687e-06, -0.00015845, -7.2931e-05, -0.00011775, 7.4048e-05, 0.00013239, 4.7082e-06, 8.9098e-05, -3.4631e-06, 5.0421e-05, 2.6443e-05, 8.6583e-06, -3.7941e-05, -0.00013987, 4.0145e-05, -5.4758e-05, 2.3031e-05, 1.5356e-05, -7.6915e-07, 2.645e-05, 3.4036e-06, 3.9163e-05, 0.00015363, 3.3088e-05, -0.00016826, -0.00014952, 3.5498e-05, 4.8879e-06, 4.927e-05, 3.2068e-06, 6.9986e-07, -5.7017e-05, 0.00012398, 2.8576e-05, 4.4997e-05, -7.6582e-05, -0.00017982, 7.7914e-05, 9.1821e-05, 2.0136e-05, 5.9721e-05, -9.1171e-06, 2.2421e-05, 9.2992e-05, 1.5505e-05, 7.2487e-05, -8.918e-05, -0.00025973, 3.0932e-05, 9.1342e-05, 2.3131e-05, 1.2247e-05, 4.2369e-05, 5.3252e-05, 0.00012343, 8.7665e-05, 1.294e-05, -8.4931e-05, -0.00012908, -1.2682e-06, 0.00010437, 0.00013645, 1.6058e-05, -4.4318e-05, -7.4065e-05, 8.9411e-05, 4.046e-05, 4.7208e-06, -1.2597e-05, -0.00010568, -9.4992e-05, 2.7651e-05, 7.6097e-05, -1.9995e-06, 6.7764e-05, 3.5255e-05, 3.2643e-05, 2.144e-05, 3.8888e-05, -0.00012811, -0.00019783, -7.7663e-05, 0.00014427, -2.1274e-05, 0.0001232, 1.0103e-05, -1.6055e-05, 5.7715e-05, -5.6047e-05, -1.7521e-05, 2.7609e-05, -0.00021782, -0.00010669, 0.00020792, 0.00011484, 1.3285e-06, 3.8059e-05, -1.2194e-05, 3.8422e-05, 0.00012682, -4.4552e-05, -3.6963e-05, -0.00019868, -7.997e-05, 3.4789e-05, 0.0001943, -9.2258e-06, -2.1814e-07, 7.6669e-05],
              [-0.040989, -0.072593, -0.020478, -0.025778, 0.022398, 0.003098, -0.025475, 0.0014983, 0.013473, 0.015344, 0.013699, -0.042586, -0.041387, -0.088633, -0.058018, 0.015074, 0.0039592, -0.0024599, 0.018532, -0.0072521, 0.039351, -0.010584, 0.031659, 0.004946, -0.023228, -0.098922, -0.083752, -0.038393, -0.0084343, 0.0076729, 0.048785, 0.017104, 0.020754, 0.049112, 0.05764, 0.019839, -0.0027111, -0.10015, -0.13202, -0.062978, 0.025824, 0.01588, 0.023625, -0.0046384, 0.026114, 0.091319, 0.15889, 0.077891, 0.095775, -0.1244, -0.14161, -0.07551, -0.02844, 0.021985, 0.015549, -0.0023889, 0.034888, 0.071073, 0.14647, 0.20035, 0.16005, -0.08676, -0.13618, -0.015931, 0.005888, 0.008444, -0.095816, -0.069713, -0.017803, 0.02785, 0.099568, 0.18576, 0.10917, -0.064365, -0.053216, -0.029503, -0.0098623, -0.10681, -0.14826, -0.11347, -0.064061, 0.0027157, 0.09181, 0.11261, 0.043784, -0.02707, -0.022521, -0.010411, -0.062429, -0.078463, -0.099127, -0.097932, -0.053659, 0.020027, 0.097468, 0.045269, 3.4983e-05, 0.00096206, -0.0042047, 0.012971, -0.018376, -0.044257, -0.07615, -0.03979, -0.032111, 0.060509, 0.066025, 0.043696, -0.0062411, 0.0065601, 0.070877, 0.055992, 0.017987, -0.0038242, 0.01131, -0.010488, 0.020902, -0.0025447, 0.059004, -0.013398, 0.0035443],
              [0.030346, 0.0060729, -0.039343, 0.015518, 0.026091, 0.057075, -0.007681, -0.0080709, 0.016419, 0.002842, -0.013731, -0.019522, -0.016221, 0.014954, -0.034022, -0.013762, 0.024753, 0.03953, 0.0045833, 0.0083765, 0.036851, 0.055084, -0.056976, -0.029318, -0.025595, -0.020946, -0.05804, -0.013577, -0.010021, -0.0018451, 0.020025, -0.0075917, 0.015631, -0.082666, -0.080551, -0.050441, -0.072777, -0.062636, -0.071289, -0.044269, -0.01929, -0.00063644, 0.035648, 0.0080666, -0.069973, -0.072406, -0.062813, -0.060859, -0.10297, -0.074727, -0.077151, -0.089632, -0.060208, -0.036005, 0.03058, 0.018237, 0.02174, 0.026791, 0.078395, 0.079774, 0.048845, -0.011284, -0.042893, -0.060469, -0.077717, -0.041768, 0.11045, 0.084453, 0.058717, 0.11797, 0.15001, 0.14682, 0.13949, 0.071901, 0.022952, -0.037573, -0.064497, 0.10514, 0.014296, 0.047946, -0.018433, -0.0048603, 0.039432, 0.090925, 0.075278, 0.081171, 0.0073834, 0.00032987, 0.022814, -0.0086828, -0.048521, -0.019109, -0.065561, -0.080183, 0.0032263, -0.00099659, 0.052424, 0.022386, 0.03912, -0.031164, -0.06394, -0.079117, -0.078917, -0.058881, -0.10111, -0.051141, 0.014884, -0.014461, 0.036092, 0.039866, -0.028625, 0.023879, -0.025206, -0.023467, -0.076188, -0.040233, -0.051996, -0.040468, -0.026854, 0.027, 0.070256],
              [-0.002803, 0.040759, 4.1768e-06, 0.02026, -0.0059647, 0.05181, 0.026346, 0.012265, -0.010147, -0.033548, -0.019732, -0.0022578, -0.016262, -0.017314, 0.014344, 0.03797, -0.013837, 0.016742, -0.030123, -0.027736, -0.0022683, -0.019176, -0.015693, 0.013114, -0.036321, -0.063043, 0.0049614, -0.036805, -0.037438, -0.023603, -0.0072298, -0.059869, -0.041756, -0.034104, -0.037695, -0.019866, -0.037321, -0.029615, -0.062379, -0.077726, -0.06433, -0.067627, -0.066911, -0.051814, -0.064044, -0.040498, -0.068571, -0.064782, -0.077465, -0.059301, -0.045729, -0.033973, -0.014237, -0.0051404, -0.015748, -0.12091, -0.11592, -0.046036, -0.026967, -0.0013909, 0.070814, 0.069292, 0.071817, 0.074605, 0.095415, 0.10749, -0.095996, -0.0040976, 0.045306, 0.075554, 0.11846, 0.084776, 0.084264, 0.10125, 0.073977, 0.080838, 0.054211, 0.020058, 0.071877, 0.073614, 0.09027, 0.047956, 0.043147, -0.0011986, -0.013094, -0.030256, -0.0095367, 0.016709, 0.061142, 0.081217, 0.010386, 0.037778, -0.018148, -0.02519, -0.047772, -0.061855, -0.053653, -0.051552, -0.034374, 0.019703, 0.040215, 0.0094463, -0.022748, 0.006918, -0.015913, -0.027028, -0.014329, -0.027715, -0.062068, -0.062015, -0.021184, -0.039143, 0.02283, 0.0032039, 0.000343, -0.012231, -0.0032112, -0.025263, -0.0022995, -0.02705, -0.039549],
              [0.065221, 0.025071, 0.019912, 0.019313, 0.022457, 0.038123, 0.0055997, -0.012446, -0.020127, -0.019608, -0.05192, -0.0038021, 0.02754, -0.031394, -0.018499, -0.028503, 0.010984, -0.0021915, -0.019643, -0.042421, -0.081508, -0.072244, -0.0017842, -0.010893, -0.00948, -0.0041071, -0.031711, -0.025317, -0.048905, -0.039098, -0.066267, -0.05717, -0.12354, 0.001926, 0.010455, -0.047326, -0.014954, -0.014952, -0.060399, -0.051482, -0.056999, -0.056279, -0.0082532, -0.004728, -0.024889, -0.046325, -0.02707, -0.035511, -0.041562, -0.042411, -0.058674, 0.022288, 0.042564, 0.091511, 0.10753, -0.02319, -0.016617, -0.083807, -0.058259, -0.070742, 0.025574, 0.11914, 0.12549, 0.12136, 0.11708, 0.086423, -0.00030667, -0.03844, -0.049405, -0.092975, -0.03285, 0.10353, 0.14958, 0.086084, 0.035831, 0.024743, 0.036726, -0.0024422, 0.00040113, -0.052519, -0.04457, -0.034619, 0.049819, 0.0024548, 0.026916, 0.00043142, 0.012654, -0.051856, 0.030047, 0.00061641, -0.031155, -0.044323, 0.0045373, -0.0071958, 0.0063658, 0.018539, -0.030331, -0.031774, -0.0088228, -0.015163, -0.058176, -0.0040183, 0.018492, 0.0022898, -0.02563, -0.031897, 0.020493, -0.0060867, 0.0079195, -0.020677, -0.031625, -0.028354, -0.05878, 0.016741, 0.026376, 0.015891, 0.04844, -0.0032501, 0.0044459, -0.016656, 0.0096496],
              [0.038712, 0.012491, 0.025252, -0.00063429, 0.035928, 0.023763, 0.040775, -0.023415, -0.04864, -0.050013, -0.064429, 0.02178, 0.049862, -0.018289, 0.03589, 0.020066, 0.049563, 0.0077522, -0.055571, -0.068511, -0.057717, -0.034901, 0.021956, 0.035415, 0.026124, 0.0017095, 0.034316, -0.027522, -0.099289, -0.072699, -0.040034, -0.0025525, -0.0029101, 0.021515, 0.040227, 0.036476, 0.031515, -0.0086616, -0.13841, -0.11459, 0.01045, -0.0035536, 0.071253, 0.042724, 0.0093417, -0.01287, 0.032546, -0.015625, -0.11666, -0.14109, 0.067348, 0.076093, 0.11562, 0.050225, 0.042124, 0.021445, -0.0084783, -0.0121, -0.030956, -0.11121, 0.082861, 0.1479, 0.10501, 0.046748, 0.019903, 0.03052, 0.018229, -0.010089, 0.0013081, -0.046366, 0.04446, 0.10594, 0.079519, 0.01936, -0.0052888, -0.072262, -0.063107, -0.0032667, 0.03186, 0.018646, -0.012065, 0.084958, 0.048023, 0.0056015, -0.071195, -0.070333, -0.10991, -0.11771, 0.019377, 0.026707, 0.073584, 0.054153, 0.025448, 0.0040382, -0.054679, -0.089933, -0.071996, -0.06277, -0.065226, 0.038396, 0.016152, 0.027023, 0.082904, 0.047187, -0.00079516, -0.095891, -0.049462, -0.072305, -0.01168, -0.030194, 0.014156, 0.05086, 0.03919, 0.061499, 0.022736, 0.015951, 0.015999, -0.043223, -0.024248, 0.040112, 0.060525],
              [0.0024769, 0.023654, 0.0065905, 0.029715, 0.016982, 0.035002, 0.01506, 0.0023775, 0.015463, 0.0082508, 0.045204, 0.029099, 0.037371, 0.048547, 0.039675, 0.025868, 0.014832, -0.0075821, -0.02093, -0.032499, -0.001802, 0.043938, 0.028726, 0.0010439, 0.042588, 0.017848, 0.0022798, -0.0045873, -0.0088422, -0.040477, -0.084833, -0.075254, -0.04364, 0.048831, 0.031624, 0.01249, -0.044447, -0.023794, -0.094393, -0.072032, -0.064708, -0.064217, -0.11171, -0.09873, 0.034791, -0.0062696, -0.037764, -0.066032, -0.085655, -0.056461, -0.067826, -0.060588, -0.060359, -0.075101, -0.11166, -0.049683, -0.032238, -0.086484, -0.054274, 0.010713, 0.051484, 0.072737, 0.066174, 0.047053, 0.014573, -0.037236, -0.038926, -0.045893, 0.01037, 0.11284, 0.12481, 0.11598, 0.11519, 0.1144, 0.11283, 0.072652, 0.069633, 0.012081, -0.012907, 0.078197, 0.084842, 0.025449, 0.033318, -0.0032467, -0.00077916, 0.019237, 0.040468, 0.081825, 0.032173, 0.0072246, 0.035146, 0.032218, -0.004157, -0.032284, -0.048064, -0.036308, -0.0088796, -0.050648, -0.00021, 0.029706, 0.032099, 0.00779, -0.0059912, -0.037978, -0.032943, -0.074828, -0.086594, -0.070295, -0.021598, -0.034675, 0.03915, 0.016075, 0.0072486, -0.021666, -0.015742, -0.057129, -0.069826, -0.043047, -0.00021744, 0.0031614, -0.005484],
              [0.0078584, 0.010418, 0.015826, 0.0278, 0.037504, 0.02189, 0.038405, 0.033824, -0.015111, 0.020273, 0.032943, -0.0012524, -0.020725, -0.012427, 0.015268, 0.015474, 0.021472, 0.031768, 0.012185, 0.0036407, -0.0025327, 0.0078854, -0.042336, -0.056683, -0.026575, -0.028598, -0.042658, -0.041424, -0.036798, -0.038263, 0.0019027, 0.0093814, 0.0084716, -0.045038, -0.075792, -0.059375, -0.061832, -0.043299, -0.043801, -0.051618, -0.065611, -0.047247, -0.057968, -0.0096927, -0.00097814, -0.0011438, -0.032865, -0.035434, -0.072329, -0.040236, -0.06695, -0.082126, -0.062804, -0.081492, -0.067532, 0.094558, 0.05016, 0.085679, 0.046323, 0.055993, 0.048912, 0.031195, -0.0026454, -0.040344, -0.097033, -0.10039, 0.073981, 0.044681, 0.04953, 0.11289, 0.077053, 0.087639, 0.090661, 0.083978, 0.064049, 0.024327, -0.04232, -0.0021389, 0.0059539, 0.0021759, -0.0093588, 0.02429, 0.026077, 0.078773, 0.091982, 0.064361, 0.081984, 0.028646, -0.042605, -0.039659, -0.023542, -0.044811, -0.037047, -0.027701, 0.003355, -0.0131, 0.059271, 0.046282, 0.087355, -0.05379, -0.052156, -0.056795, -0.021944, -0.031144, -0.032409, -0.013571, -0.031194, -0.024378, 0.029149, 0.030673, -0.022978, -0.011077, -0.0055112, -0.016195, -0.010223, -0.0017694, -0.016982, 0.02312, -0.0046449, -0.0051817, -0.022733],
              [-0.0090421, 0.017453, -0.017832, -0.0037291, 0.039065, 0.023173, 0.017934, 0.013098, 0.045168, 0.042194, 0.040022, -0.12965, -0.098696, -0.057792, -0.036039, -0.028194, -0.0054252, -0.0069512, 0.0207, -0.027659, 0.015383, 0.029921, -0.10604, -0.13745, -0.10216, -0.082045, -0.062542, -0.0060266, -0.034856, -0.019904, 0.00031968, -0.03239, 0.024398, 0.10509, -0.013047, -0.077744, -0.12223, -0.1125, -0.074496, -0.056697, -0.041104, -0.03665, -0.010932, -0.01645, 0.15622, 0.096727, 0.054042, -0.003099, -0.046208, -0.065923, -0.065579, -0.059507, 0.0088063, -0.037443, -0.017903, 0.092956, 0.14429, 0.15461, 0.10488, 0.07465, 0.031359, -0.044524, -0.028003, -0.074286, -0.017952, -0.023443, 0.00067037, 0.048256, 0.064112, 0.12606, 0.11963, 0.10488, 0.033679, -0.06098, -0.043664, -0.023617, 0.010589, -0.042281, -0.020904, 0.0042455, -0.00023867, 0.036855, 0.064226, 0.058947, -0.0015714, -0.0095707, -0.013148, 0.01221, -0.05139, -0.055206, -0.033651, -0.030728, -0.0069396, -0.011576, 0.0073686, 0.069747, -0.013521, 0.006596, -0.019525, -0.017644, -0.036983, -0.032526, -0.059542, -0.021433, -0.036208, 0.00082772, 0.048327, 0.057951, 0.0015733, 0.0068908, 0.044822, -0.0029222, 0.0015559, 0.015954, -0.0256, 0.047827, 0.0062289, 0.021267, 0.057036, 0.018964, -0.042249],
              [0.082567, 0.055833, 0.037656, -0.025001, -0.028413, -0.050162, -0.064109, -0.085323, -0.013537, 0.013709, 0.018599, 0.075347, 0.062559, -0.031285, -0.042803, -0.031429, -0.073827, -0.024222, 0.0076413, 0.024212, -0.059471, -0.03088, 0.067967, 0.040823, 0.010014, -0.076238, -0.0682, -0.03367, 0.0026546, -0.046483, -0.013765, -0.027635, -0.061826, 0.031594, 0.021366, -0.013394, -0.094758, -0.049119, -0.045552, -9.1106e-05, 0.0079383, 0.011255, -0.0065767, -0.047662, 0.044446, -0.00093206, -0.0095391, -0.050733, -0.086831, 0.032526, 0.092702, 0.0094084, -0.023484, 0.0092934, 0.022791, 0.039003, -0.0086098, -0.034768, -0.031884, 0.066429, 0.15091, 0.13216, -0.059201, -0.13696, 0.048045, 0.098721, 0.012407, 0.015257, 0.05201, 0.10321, 0.042459, 0.088724, 0.068939, 0.017008, -0.085318, -0.018126, 0.11519, -0.025017, 0.019451, 0.022495, 0.0526, 0.033867, 0.032217, 0.05936, 0.014141, -0.025091, -0.026683, 0.040958, -0.050856, 0.0049324, -0.00049817, 0.016553, -0.005958, 0.045307, 0.057898, 0.042726, -0.0017969, -0.014382, -0.037002, 0.025111, -0.00016282, 0.024515, 0.021259, 0.024401, 0.036876, 0.039423, 0.040371, -0.00092562, -0.0052629, 0.009327, -0.011241, 0.0019913, -0.025005, -0.0056086, 0.014352, 0.050873, 0.10004, 0.064681, 0.046196, 0.069301, 0.02951],
              [0.031888, 0.017285, 0.042745, 0.031228, 0.025514, 0.023254, 0.017245, 0.0091144, 0.061255, 0.028608, -0.017058, 0.03126, -0.022799, -0.027838, -0.031938, -0.0079427, 0.0022782, -0.0029791, 0.014262, -0.011888, 0.1018, 0.01749, -0.02166, -0.0295, -0.017844, -0.0065925, -0.055318, -0.0090733, 0.00041947, -0.056493, -0.073202, -0.046645, 0.062082, -0.031339, -0.06541, -0.02626, -0.028514, 0.010511, 0.026139, 0.033081, 0.01041, 0.0083594, -0.066648, -0.061127, -0.06066, -0.029413, -0.014383, -0.061113, -0.086766, -0.11103, -0.095559, -0.069648, -0.044428, 0.025756, 0.006956, -0.081588, -0.10519, -0.071336, 0.00057042, 0.013813, 0.02671, 0.049812, 0.093582, -0.021925, -0.055498, 0.006515, -0.054554, 0.0083049, 0.13185, 0.12213, 0.011707, -0.025907, -0.02482, 0.054011, 0.13634, 0.12397, -0.0094684, 0.08236, 0.12982, 0.038245, -0.028863, -0.012402, -0.029029, 0.0060992, -0.0040297, -0.046885, -0.0033331, 0.055326, 0.13031, 0.014467, -0.059527, -0.024457, -0.0011607, 0.049887, -0.021189, 0.0053423, 0.019767, -0.075051, 0.055581, 0.11044, 0.071965, -0.090663, -0.035117, 0.048069, 0.041134, 0.083494, 0.029111, 0.031267, -0.039508, 0.027491, 0.092284, 0.066698, 0.0046771, -0.057628, 0.035842, 0.082678, 0.097332, 0.050682, -0.010181, -0.033101, 0.0060053],
              [-0.017681, 0.0050575, 0.025216, -0.0050258, -0.057033, -0.052107, -0.045597, -0.0066502, -0.004089, -0.0036027, 0.054265, -0.041055, -0.0014473, 0.034597, 0.060836, 0.029247, -0.07214, -0.079673, 0.0063944, -0.00075079, -0.0024171, 0.00014142, -0.071901, -0.07131, -0.070947, -0.033682, 0.059046, 0.098589, -0.0012454, -0.018862, 0.070385, -0.0038593, -0.035716, -0.028904, 0.022169, -0.005638, 0.015212, -0.077801, -0.029804, 0.019462, 0.066876, 0.074347, 0.075531, -0.047355, 0.038231, -0.014508, -0.088435, -0.10062, 0.067343, 0.024924, -0.092546, -0.014998, 0.02795, 0.066064, 0.02189, 0.13086, 0.090325, -0.051344, -0.10634, 0.041577, 0.18956, 0.15362, -0.1177, -0.063931, 0.053765, 0.012821, 0.16702, 0.091883, 0.046064, 0.02516, 0.071125, 0.035423, -0.0028389, -0.062881, -0.078524, 0.0060489, 0.031324, 0.0578, 0.035259, -0.015526, -0.051491, -0.070998, -0.08834, -0.063258, 0.00058158, -0.016399, 0.063472, 0.059448, -0.072023, -0.020115, 0.01927, 0.043045, 0.00016106, 0.009692, 0.0068556, 0.049381, -0.0045235, 0.032978, 0.031253, 0.0569, 0.028263, 0.035152, 0.035462, 0.039852, 0.019659, 0.033958, -0.01984, 0.059037, 0.009726, -0.014938, 0.019067, 0.070682, 0.067102, 0.069013, 0.010045, -0.0063893, 0.0050956, -0.045818, 0.058781, 0.015059, 0.0093869],
              [-0.059247, 0.0021433, 0.0030538, 0.0058555, -0.08563, -0.071756, -0.04245, -0.042689, -0.01111, -0.0079405, 0.027079, -0.027547, 0.039878, -0.032474, -0.046922, 0.033618, -0.034288, -0.043372, 0.041614, -0.043095, -0.010111, 0.022895, 0.075387, 0.009213, -0.088278, 0.037398, -0.0022263, 0.0099245, -0.02003, 0.056811, 0.0073928, -0.078186, -0.0081464, 0.079204, -0.049194, -0.10782, -0.041094, 0.036883, 0.037669, 0.01322, 0.053408, -0.026734, -0.12858, 0.021075, 0.12904, 0.017327, -0.14567, -0.082472, 0.058957, 0.11486, 0.1286, 0.095519, -0.061066, -0.0067977, 0.11055, 0.11156, 0.11891, 0.017852, 0.00062817, -0.0056022, 0.077625, 0.060407, 0.059517, 0.027002, -0.044412, -0.02565, 0.068363, 0.063021, 0.059444, 0.010334, 0.042111, 0.015415, 0.0023344, -0.027063, -0.053547, 0.024499, -0.052268, 0.088857, 0.023558, -0.013779, -0.023579, -0.062755, -0.078234, -0.044287, -0.055979, 0.032155, 0.054401, 0.04823, 0.045141, 0.038705, 0.085911, 0.0043579, 0.012844, 0.010883, 0.028932, 0.064841, 0.008315, 0.028737, 0.052023, 0.033414, -0.001552, 0.042607, 0.022302, 0.022174, -0.019436, -0.00050396, -0.005214, 0.030174, -0.004641, 0.049756, 0.0048322, 0.052626, -0.004347, 0.024476, -0.0014551, 0.0025588, 0.023351, 0.00075945, 0.067061, 0.06672, -0.03618],
              [-0.057112, -0.031889, -0.020365, 0.0031374, 0.013437, 0.0059513, 0.0080221, -0.0033222, -0.0048278, -0.026659, -0.062783, -0.076967, -0.033637, 0.02637, 0.0139, 0.041921, 0.05048, 0.040062, 0.044565, 0.0069941, 0.030937, -0.0062436, -0.046321, 0.011237, 0.036259, 0.0082963, -0.10315, -0.12978, -0.10762, -0.028238, 0.077775, 0.057645, 0.020682, 0.015699, 0.023615, -0.041772, -0.12747, -0.031283, -0.012702, -0.031003, -0.053233, -0.11695, 0.019915, 0.030434, 0.034287, -0.042572, -0.084216, 0.069861, -0.012205, -0.018891, 0.01964, 0.077725, -0.080366, -0.015106, 0.034588, 0.11598, -0.02265, -0.10542, 0.064909, -0.0032238, 0.10106, 0.028245, 0.13831, -0.029406, -0.1748, 0.10111, 0.10656, 0.0077236, -0.14344, 0.050109, 0.086716, 0.09309, 0.1245, 0.12884, -0.07042, -0.12323, 0.070753, 0.12051, 0.010234, -0.097733, -0.059331, 0.058783, 0.085326, 0.076776, 0.029787, -0.018648, -0.021041, -0.00034305, 0.084298, 0.056835, 0.053326, -0.039639, -0.0050146, 0.013779, -0.010486, -0.0072346, -0.01195, -0.0025969, -0.039482, 0.09283, 0.042943, -0.0075415, 0.018317, -0.03913, -0.041539, -0.027052, -0.042059, 0.051858, -0.038626, 0.089622, 0.071389, 0.086449, 0.055651, 0.013639, 0.017996, -0.018016, 0.063459, 0.053364, 0.074742, 0.070779, 0.038021],
              [0.016782, 0.022184, -0.01761, -0.083789, -0.061012, -0.049437, -0.016011, -0.0012931, 0.0181, 0.042203, 0.091115, -0.030973, -0.0032195, 0.001676, -0.014121, -0.048982, -0.010745, -0.097652, -0.082419, -0.0086676, 0.038493, 0.038422, -0.023684, -0.042571, 0.027674, -0.0045846, -0.029036, -0.014288, -0.036492, -0.073188, -0.058474, 0.061157, 0.037513, -0.044263, 0.03708, 0.008866, 0.00080273, -0.029635, -0.06189, 0.0038986, -0.055589, -0.064826, -0.040454, 0.071936, 0.051468, 0.01663, -0.040009, -0.019116, 0.091905, 0.068371, -0.035382, -0.031696, -0.023951, -0.0394, 0.037638, 0.11971, 0.089542, -0.048322, -0.10362, 0.03196, 0.22708, 0.096993, 0.02671, -0.043789, -0.030431, -0.036199, 0.11281, 0.058354, -0.064975, -0.065781, -0.0084482, 0.091242, 0.12718, 0.076435, 0.052637, -0.011144, -0.036138, 0.069125, 0.013399, 0.029824, -0.0037613, 0.0021896, 0.063412, 0.05214, 0.050386, 0.035325, -0.02123, -0.041481, -0.023404, 0.025149, -0.0071054, 0.029758, 0.0085265, 0.049979, 0.047608, 0.0073875, 0.023178, -0.034372, -0.022118, -0.032551, -0.0095361, 0.023952, 0.0097167, 0.033562, 0.04459, 0.040596, 0.032654, 0.0057649, -0.015195, -0.044827, 0.071208, 0.041893, 0.048927, 0.073828, 0.065245, -0.0017293, 0.05839, 0.046492, -0.044449, 0.0032058, -0.083492],
              [-0.021979, 0.04175, 0.036317, 0.019304, 0.043331, 0.039532, -0.036476, 0.012807, 0.022714, 0.026792, 0.017781, 0.021847, 0.035543, 0.022495, -0.019212, 0.046687, 0.032073, -0.028687, -0.068123, 0.0012941, -0.034564, 0.050972, 0.017345, 0.035613, -0.047699, -0.033623, -0.032521, -0.0013901, -0.038202, -0.031763, -0.046961, -0.04907, 0.017435, -0.030703, -0.057162, -0.0037112, 0.0060696, 0.038135, 0.011369, 0.043812, -0.034218, -0.053541, -0.039937, -0.06177, -0.03524, 0.001645, -0.019801, -0.07722, -0.075502, -0.087592, -0.11013, -0.061233, -0.03823, -0.064265, -0.052615, -0.023206, 0.011035, -0.0009788, 0.015272, 0.010027, 0.057985, 0.070841, 0.019039, -0.041762, -0.15551, -0.076282, 0.017047, 0.093015, 0.093581, 0.043403, 0.0066461, -0.028933, 0.071469, 0.099203, 0.16738, 0.069044, -0.077497, 0.099573, 0.048571, -0.064145, -0.017709, -0.033773, -0.03677, 0.021125, -0.032531, 0.01618, 0.090578, 0.10585, 0.10394, -0.039147, -0.030448, -0.0058756, 0.0049201, 0.065015, 0.02356, 0.0086862, -0.066304, -0.0023589, 0.10485, 0.041244, -0.0046939, -0.050266, 0.079897, 0.051812, 0.059364, 0.063039, -0.0096554, -0.069243, -0.047052, 0.071058, -0.034427, 0.033352, -0.038713, 0.040541, 0.067514, 0.082806, 0.10708, 0.017928, 0.0011601, -0.043674, 0.12867],
              [-0.051872, -0.019281, -0.054683, 0.00094479, -0.013017, -0.01289, -0.035617, 0.0014515, 0.042883, -0.01052, 0.0075578, -0.022058, -0.029115, 0.0012529, 0.023269, -0.067475, -0.039425, 0.047183, 0.018571, -0.031453, -0.0042628, -0.065391, -0.06231, -0.00018351, 0.034076, 0.020712, -0.015816, 0.036106, -0.0057176, -0.0078035, 0.022002, -0.075063, -0.056833, -0.078488, 0.053315, 0.089792, 0.06558, -0.020138, -0.069355, -0.0129, 0.067494, 0.0052092, -0.0050446, -0.034013, -0.049221, 0.036993, 0.073527, 0.023627, -0.12669, -0.04993, 0.13709, -0.043083, -0.11283, -0.022958, -0.01638, -0.06148, 0.083723, 0.026146, -0.1093, 0.093485, 0.21229, 0.12152, -0.0085143, -0.11195, 0.008757, 0.11393, -0.058279, -0.0080422, -0.0037128, -0.090611, -0.02375, -0.0033262, 0.051599, 0.11795, 0.052188, 0.05104, 0.13056, -0.012214, 0.036432, 0.036671, -0.0078012, -0.080637, -0.098442, -0.035088, -0.032649, -0.016985, -0.027536, 0.061159, -0.0051669, 0.054347, 0.045747, 0.064739, 0.049553, 0.018862, 0.048983, 0.062542, 0.0072515, -0.023347, -0.075602, -0.057354, -0.017631, 0.022946, 0.090873, 0.0042985, 0.028246, 0.0087607, 0.074352, 0.035005, 0.031603, 0.034524, -0.07659, -0.017921, 0.0062989, -0.013815, 0.080616, 0.019782, 0.075648, 0.04319, 0.074149, 0.0477, 0.08084],
              [0.026722, 0.011659, -0.030401, -0.078934, -0.025083, -0.051258, -0.063738, -0.045361, -0.0072455, -0.0016165, -0.089855, 0.0097208, 0.032567, -0.063546, 0.0040587, -0.01178, 0.046622, -0.0061913, -0.00040806, -0.038285, -0.045803, 0.00013567, 0.071841, -0.0035185, -0.054904, 0.029242, -0.016896, -0.018745, 0.075717, 0.019648, -0.043886, -0.018293, 0.029237, 0.079481, -0.10679, -0.13519, -0.0021618, 0.057839, 0.046853, 0.010614, 0.03944, -0.092858, -0.054138, 0.041015, 0.063451, 0.04747, -0.11151, 0.024333, 0.10457, 0.11493, 0.064349, 0.02496, -0.12313, -0.035728, 0.056358, 0.035122, 0.040853, 0.0048171, -0.018878, 0.063834, 0.099594, 0.10457, -0.0059324, 0.051541, 0.043792, 0.066822, -0.022981, 0.012624, -0.027434, -0.03732, -0.040761, 0.0054311, 0.077857, 0.061026, 0.062914, 0.039279, 0.051551, 0.068228, 0.053793, 0.033116, -0.087231, -0.062413, -0.082179, -0.049408, -0.05136, 0.017042, 0.0083053, 0.057973, 0.049273, 0.050549, 0.05419, 0.076357, -0.02016, -0.014968, -0.0083188, 0.032399, 0.029725, 0.081168, 0.0010767, 0.0031321, 0.039599, 0.032665, -0.0076124, 0.01439, -0.024144, 0.015901, 0.036463, 0.0059983, 0.0073771, 0.068758, 0.001845, 0.058983, 0.061023, 0.019189, 0.052229, 0.022904, 0.0093546, -0.022264, 0.028743, 0.031821, 0.031025],
              [-0.024932, 0.0067371, -0.0073915, 0.017497, 0.023423, -0.0094929, -0.02194, 0.00025349, -0.041633, -0.04628, -0.067789, -0.024674, -0.029908, -0.0063449, 0.038828, 0.068463, 0.027205, 0.034295, 0.020017, -0.044148, -0.059872, -0.051482, 0.011124, 0.016763, 0.050887, 0.025498, -0.093955, -0.092391, -0.032479, 0.034463, 0.059969, 0.025585, -0.054354, -0.021502, 0.051547, -0.034008, -0.10294, -0.068214, -0.036091, -0.035862, -0.06695, -0.078867, 0.01349, -0.0092992, 0.051242, 0.063155, -0.057574, 0.01889, -0.042698, 0.0063897, 0.035994, 0.10789, -0.06818, -0.075882, -0.019748, 0.10736, -0.038698, -0.15857, 0.077712, 0.0027822, 0.033503, 0.044529, 0.1147, 0.037629, -0.11802, 0.089816, 0.14095, -0.021945, -0.18628, 0.057227, 0.17885, 0.12351, 0.032873, 0.13094, -0.079054, -0.098874, 0.071037, 0.024172, 0.04436, -0.051013, -0.039066, 0.10491, 0.12042, 0.1636, -0.0083142, -0.029805, -0.023079, 0.05985, -0.035424, -0.02533, -0.034243, -0.063442, -0.046964, 0.00071816, 0.022784, 0.0091086, 0.017544, 0.028538, 0.080903, 0.062288, 0.04819, 0.021557, -0.022313, -0.091204, -0.048678, -0.018881, 0.023198, 0.011883, 0.040745, 0.055218, 0.075292, 0.12951, 0.034067, 0.055263, 0.00092956, 0.0025829, -0.012623, 0.045045, 0.035721, 0.073251, 0.09494],
              [-0.054694, -0.036142, 0.01214, -0.015154, 0.0068463, -0.0093137, -0.048684, -0.04943, -0.041065, -0.077254, -0.05266, 0.02644, -0.035826, 0.00018949, 0.020886, -0.00065949, 0.022071, 0.0040314, -0.035333, -0.028227, -0.018098, -0.020234, 0.015321, -0.0014404, 0.01118, 0.01148, 0.050415, 0.011826, -0.0058862, -0.010693, -0.052712, -0.039587, -0.015153, 0.021776, 0.018485, 0.017271, 0.025545, 0.0035527, -0.0072077, -0.016928, 0.010103, -0.011397, -0.054136, -0.0087759, 0.045429, 0.026079, 0.018401, -0.010305, 0.031175, -0.022965, 0.0073488, -0.033665, 0.0040173, 0.00073106, 0.00092921, 0.038456, 0.051027, 0.032164, 0.0030919, -0.018051, -0.037581, -0.042983, -0.032974, 0.0034357, -0.0029191, 0.049102, 0.045968, 0.037533, 0.053552, 0.0025191, -0.047509, -0.072789, -0.064427, -0.041221, -0.026781, 0.045893, 0.043427, 0.063353, 0.057676, 0.04031, 0.041067, -0.051029, -0.081223, -0.10623, -0.040384, 0.012699, 0.02785, 0.073423, 0.013872, 0.086837, 0.078231, 0.025402, -0.0085959, -0.10094, -0.079771, -0.089308, 0.015198, 0.061289, 0.065949, 0.041036, 0.059558, 0.080006, 0.074883, -0.014113, -0.032421, -0.11385, -0.10292, -0.012981, 0.05222, 0.12083, 0.10605, 0.086255, 0.083214, 0.048515, 0.044244, -0.042579, -0.1003, -0.1041, -0.086308, 0.033369, 0.16061],
              [0.12274, 0.042815, 0.018062, 0.0053062, 0.035824, 0.010649, 0.016551, 0.0149, 0.067444, 0.0014206, 0.017061, 0.10626, 0.03566, 0.0027511, -0.012308, -0.013786, -0.051328, -0.086, 0.051803, 0.039048, 0.047854, -0.026266, 0.030741, 0.039407, -0.0082192, 0.009945, -0.011589, -0.069863, -0.071219, 0.02673, 0.064361, 0.049962, -0.024026, 0.063809, -0.014374, 0.023605, -0.042857, -0.030014, -0.098897, -0.043739, 0.034309, 0.071348, 0.037614, -0.0008217, 0.020111, -0.0023311, -0.015928, -0.024232, -0.12213, -0.077412, 0.003285, -0.010022, 0.084367, 0.068284, 0.02711, -0.034521, 0.0059706, -0.054405, -0.058783, -0.10071, 0.0067298, 0.052326, 0.021602, 0.033366, 0.06045, 0.028672, -0.069276, -0.046529, -0.071031, -0.068872, 0.046654, 0.13894, 0.088207, 0.009134, 0.033848, 0.047381, 0.043418, -0.099683, -0.072929, -0.076421, 0.030782, 0.14194, 0.10541, 0.050344, 0.042628, 0.0019869, 0.0029129, 0.033418, -0.10626, -0.089797, -0.012631, 0.10656, 0.081787, 0.015706, -0.0081475, 0.017962, -0.0076821, -0.018533, -0.025747, -0.068636, -0.016417, 0.052027, 0.084415, -0.031666, -0.081385, -0.042068, 0.00053002, -0.034028, -0.036058, -0.094127, -0.028724, 0.036956, 0.11399, 0.047784, -0.084618, -0.1042, -0.096931, -0.038842, -0.019078, -0.04597, -0.10436],
              [0.065758, 0.074778, 0.018293, 0.028173, -0.0089483, -0.052546, -0.10879, -0.039787, 0.003021, 0.043862, 0.020559, 0.044706, 0.012785, 0.016258, -0.038127, -0.037498, -0.11769, -0.048823, 0.039098, 0.067056, 0.0755, 0.076146, -0.041032, 0.015972, -0.037661, -0.038829, -0.10585, -0.049772, 0.0044956, 0.11402, 0.09097, 0.082806, 0.059837, -0.013125, -0.02906, -0.0085932, -0.055642, -0.085865, -0.010732, 0.12911, 0.033631, 0.034969, 0.022613, 0.023084, -0.026127, -0.036556, -0.034549, -0.0096972, -0.039485, 0.044564, 0.10334, -0.022991, -0.068462, -0.026651, -0.042353, -0.063143, -0.03867, -0.032191, 0.0024621, 0.033854, 0.10018, 0.03905, -0.14322, -0.067922, -0.083174, -0.086986, -0.049997, -0.069642, -0.017581, 0.045667, 0.064475, 0.066381, 0.049759, -0.16688, -0.10148, -0.045652, -0.025089, -0.04692, -0.063091, 0.0092457, 0.038333, 0.061578, 0.05623, 0.077373, 0.043186, -0.038313, 0.011392, 0.029086, -0.087358, -0.045745, 0.035034, 0.038753, 0.010285, -0.017746, 0.011579, 0.10678, 0.12921, 0.062105, 0.031615, -0.035992, -0.035806, 0.032429, 0.01335, -0.00025562, -0.0075837, -0.05781, -0.02738, 0.077504, 0.13304, 0.070152, -0.018705, -0.015887, -0.012406, -0.036315, -0.05746, -0.034056, -0.071575, -0.0683, 0.0017292, 0.060839, 0.15051],
              [-0.12025, -0.096169, -0.017372, 0.11248, 0.14311, 0.082528, 0.041, -0.0022277, 0.010468, 0.02376, -0.028258, -0.084469, -0.063106, 0.034558, 0.08054, 0.030927, -0.055932, -0.023595, -0.021308, -0.063108, -0.073253, -0.058339, -0.045166, 0.026985, 0.084702, 0.041281, -0.12024, -0.10043, -0.049765, -0.027095, -0.010458, -0.089462, -0.12894, -0.010214, 0.05398, 0.069469, 0.12953, -0.14182, -0.14285, -0.052861, 0.063969, 0.053939, -0.022029, -0.10819, 0.016492, 0.038639, 0.024021, 0.065593, 0.16113, 0.023615, 0.043352, 0.0076979, 0.043112, 0.00071988, -0.045961, -0.0069127, -0.0077205, -0.031892, -0.017037, 0.035037, 0.16303, 0.17418, 0.057001, 0.022916, -0.010513, -0.052886, -0.004313, -0.0018885, -0.04479, -0.03232, -0.048961, -0.0094053, 0.052253, 0.14016, 0.040657, 0.024408, 0.029986, -0.033973, -0.017547, -0.037345, -0.061376, -0.039373, -0.054467, 0.037877, 0.098581, 0.089151, 0.012958, 0.027625, -0.0058828, -0.057087, 0.00032845, -0.03784, -0.033696, 0.025913, -0.017025, 0.067748, 0.06453, 0.059856, -0.0040795, -0.064492, -0.022927, -0.068257, -0.038787, 0.015689, 5.5172e-05, 0.032388, 0.053502, 0.062621, 0.011267, -0.03949, -0.094319, -0.047548, -0.0091541, -0.048201, -0.012241, 0.0012541, 0.016596, 0.020434, 0.0367, -0.0026055, -0.03918],
              [-0.039044, -0.014032, -0.017175, -0.041782, -0.059374, -0.0085344, -0.0163, -0.037295, -0.01755, -0.078448, -0.02004, -0.056769, -0.059967, -0.049253, -0.069472, -0.071903, -0.044718, -0.036365, -0.0034412, -0.046411, -0.02859, -0.083768, 0.095116, 0.062452, -0.024834, -0.097859, -0.1128, -0.088068, -0.088836, -0.068545, 0.0011511, 0.068272, 0.080894, 0.13533, 0.18058, 0.089393, -0.037713, -0.18005, -0.1676, -0.11135, -0.046002, 0.067488, 0.16041, 0.16021, 0.032243, 0.072927, 0.12673, 0.076775, -0.027586, -0.060585, -0.065958, 0.046189, 0.064053, 0.066545, 0.046954, 0.0044609, 0.0091618, 0.04196, 0.090849, 0.099019, 0.090334, 0.067826, 0.012714, -0.0052083, 0.011532, 0.046913, -0.0026789, 0.028085, 0.027041, 0.015104, 0.059853, 0.032101, 0.025279, -0.0455, -0.0092655, 0.032696, 0.0058023, -0.0018139, -0.0029109, 0.010427, -9.6032e-05, 0.021289, 0.04108, 0.016357, -0.032396, -0.0096468, -0.015147, 0.013413, -0.0013428, 0.038224, -0.013377, 0.026456, 0.0224, 0.0083204, 0.0021987, -0.014294, -0.011198, -0.025765, -0.0044403, 0.026453, -0.016392, -0.011847, -0.030835, 0.0092711, 0.0079232, 0.015034, -0.027786, -0.033709, -0.015542, 0.00048635, -0.026695, -0.012725, -0.013287, -0.042306, -0.033424, 0.0087293, -0.030243, -0.013051, -0.037604, -0.048538, -0.061784],
              [-0.064896, -0.020224, 0.015905, 0.013552, 0.082226, 0.052591, 0.042258, 0.070648, -0.0011992, -0.034367, -0.072361, -0.056224, -0.046255, -0.030585, -0.034996, -0.043018, -0.074117, -0.058193, 0.099175, 0.085979, 0.026079, -0.090336, -0.10363, -0.05683, -0.032955, -0.035953, -0.08367, -0.14307, -0.17021, 0.05656, 0.13539, 0.11265, 0.011674, -0.065806, -0.015917, 0.049372, 0.032602, -0.023482, -0.14885, -0.14122, 0.038948, 0.090755, 0.11462, 0.049233, -0.020681, 0.0059189, 0.048036, 0.048757, 0.01503, -0.0045823, 0.044145, 0.050072, 0.009451, 0.024379, 0.052749, 0.006439, -0.0002812, -0.0064547, 0.067242, 0.14642, 0.12089, 0.045524, -0.027904, -0.020728, 0.011973, 0.02314, 0.062288, 0.0030853, -0.010563, 0.054746, 0.10799, 0.014816, -0.067729, -0.069429, -0.039673, 0.0072945, 0.031666, 0.077903, 0.033144, -0.01109, 0.025953, 0.040729, 0.015524, -0.02128, -0.074601, -0.032635, -0.040767, 0.029069, 0.050404, 0.016601, 0.0082563, 0.040076, 0.031009, 0.021258, -0.0026365, -0.025393, -0.0401, -0.051105, -0.067993, -0.00046433, -0.0039876, 0.022729, 0.039556, 0.05383, -0.0014414, 0.037268, -0.022232, -0.03405, -0.073952, -0.043558, 0.0063279, -0.079884, -0.051796, -0.012968, 0.01677, 0.039339, -0.014907, -0.021083, 0.00037446, -0.082723, -0.10307],
              [-0.037003, -0.051801, -0.060853, -0.009415, -0.034328, 0.0033826, 0.012447, 0.028264, 0.051241, 0.029467, 0.094296, 0.017996, 0.074495, 0.018562, 0.0011775, -0.033436, -0.035846, -0.0247, -0.024949, -0.024856, 0.022655, 0.01397, -0.015621, 0.084344, 0.12526, 0.058408, 0.045127, -0.043164, -0.1024, -0.096781, 0.0053916, -0.033844, -0.012658, 0.0013785, 0.011573, 0.068403, 0.052981, 0.12667, 0.035046, -0.06896, -0.060072, -0.062721, -0.03001, -0.0092089, -0.053346, -0.051522, -0.019671, -0.055874, 0.041979, 0.16389, 0.0010636, -0.05391, -0.068154, -0.055293, -0.039462, -0.095726, -0.092291, -0.11339, -0.13838, -0.035746, 0.22607, 0.12814, -0.0024482, -0.033611, -0.051839, -0.084236, -0.029032, -0.058899, -0.11075, -0.15312, -0.020725, 0.16843, 0.12744, 0.080332, 0.021566, -0.082353, -0.069018, 0.049857, 0.040106, -0.055334, -0.042096, 0.066709, 0.04242, 0.069012, 0.079984, 0.034372, -0.017332, -0.083009, 0.042454, 0.051061, 0.073169, 0.10111, 0.015416, -0.074122, 0.037506, 0.056372, 0.069803, 0.02283, -0.088476, 0.056381, 0.11797, 0.08516, 0.0057507, -0.05215, 0.00071341, -0.033052, 0.042466, 0.066153, 0.041059, -0.074912, 0.059833, 0.050036, 0.073439, -0.035055, -0.043214, -0.028434, -0.049723, -0.042469, 0.0058212, 0.0033814, -0.06458],
              [-0.052049, -0.057238, -0.0083906, 0.0062458, 0.035747, 0.078399, 0.078852, 0.065079, 0.051674, 0.056599, 0.11124, -0.049452, -0.033113, -0.044704, -0.0069392, -0.023795, 0.010055, 0.051862, 0.032051, 0.0034551, 0.060343, 0.071821, -0.011974, -0.026068, -0.020183, -0.01395, -0.050699, -0.020356, 0.029015, 0.044993, 0.041705, 0.033988, 0.042094, -0.031293, 0.022301, -0.017436, 0.0086405, -0.033429, -0.059144, 0.0055853, 0.0041508, 0.049461, 0.05086, 0.079934, 0.0095959, 0.025688, 0.00556, 0.013382, -0.058014, -0.0895, -0.071592, -0.019107, -0.0082745, 0.032585, 0.046701, -0.0096068, -0.020513, -0.0038438, 0.014614, 0.068186, -0.01831, -0.11323, -0.096406, -0.052403, 0.027222, 0.030318, 0.019657, -0.00966, -0.018627, 0.0081908, 0.1218, 0.15081, 0.075807, -0.062761, -0.10013, -0.068245, -0.022266, 0.00065584, -0.015209, 0.018867, 0.0052685, 0.065684, 0.10987, 0.14929, 0.059435, -0.060186, -0.089355, -0.066217, -0.023536, -0.054962, -0.059013, 0.01999, 0.0054003, 0.032463, 0.045867, 0.10506, 0.055756, -0.05989, -0.092316, -0.071619, -0.075031, -0.062254, -0.046947, -0.048116, -0.036582, -0.061107, 0.036505, 0.10111, 0.051178, -0.044432, -0.10159, -0.077159, -0.030393, -0.050071, -0.074596, -0.073459, -0.078358, -0.030279, 0.084454, 0.12337, 0.062469],
              [0.11115, 0.051561, -0.019027, -0.053735, -0.0071101, -0.060332, -0.012734, -0.083914, -0.0068743, 0.03645, 0.057484, 0.10199, 0.082977, 0.018624, -0.020037, -0.058992, -0.0043094, -0.061801, -0.032137, -0.019998, 0.029478, 0.093322, 0.070136, 0.05702, 0.0539, -0.0026388, -0.0087945, -0.044887, -0.031767, -0.042174, -0.032508, 0.034115, 0.093106, 0.018637, 0.046736, 0.021858, 0.027569, -0.0019748, -0.020011, -0.038263, -0.041761, -0.030815, 0.028817, 0.071787, -0.0097081, 0.040408, 0.047903, 0.049152, 0.016182, -0.017239, -0.040469, -0.045703, -0.016282, 0.0034546, 0.034807, -0.018386, 0.019694, 0.067999, 0.064831, -0.014465, 0.011125, -0.06123, -0.076621, -0.023624, -0.0028778, 0.037589, -0.069263, 0.003136, 0.057378, 0.052692, 0.0174, -0.01857, -0.046214, -0.066633, 0.0049373, -0.0038829, 0.025714, -0.083379, 0.0056691, 0.11608, 0.073533, 0.038227, -0.077119, -0.055463, -0.043043, -0.019189, 0.017298, -0.023171, -0.097271, 0.026385, 0.084669, 0.092505, 0.016711, -0.044363, -0.045451, -0.049551, 0.013625, 0.020562, -0.030007, -0.063981, 0.075872, 0.05312, 0.065924, 0.031466, -0.012256, -0.031399, -0.018769, -0.040221, -0.0015619, -0.0069604, 0.060783, 0.075569, 0.052256, 0.07814, 0.038095, 0.052435, 0.048884, -0.055026, -0.045282, -0.041013, 0.099044],
              [-0.11204, -0.039742, 0.01106, 0.068772, 0.091947, 0.063013, 0.053208, 0.020539, 0.038057, 0.038787, 0.028122, -0.04492, -0.028946, 0.03825, 0.064449, 0.074567, 0.056118, 0.057712, -0.019732, 0.012263, 0.0040348, 0.043114, 0.0036262, 0.040929, 0.05322, 0.046769, -0.017166, 0.0054891, -0.020481, -0.022929, -0.019377, -0.050393, -0.028341, 0.044369, 0.034906, -0.011072, -0.065544, -0.057326, -0.098654, -0.021151, -0.038971, -0.051955, -0.065697, -0.076669, 0.057537, 0.0059026, -0.046204, -0.082611, -0.084852, -0.079141, -0.097004, -0.076062, -0.063164, -0.083321, -0.057461, 0.027801, -0.018768, -0.029692, -0.014541, 0.083906, 0.20739, 0.0467, -0.060572, -0.13038, -0.13805, -0.12359, 0.0074711, -0.022238, -0.0067832, 0.00050857, 0.12335, 0.15023, 0.24256, 0.13265, -0.036349, -0.096342, -0.1238, -0.0059223, 0.0092529, -0.0086414, 0.014912, -0.006971, 0.062192, 0.048857, 0.099736, 0.10383, -0.0017267, -0.03338, -0.041016, 0.028075, -0.024175, 0.00037852, 0.02829, -0.017178, 0.012211, 0.021091, 0.048801, 0.058893, 0.041186, -0.050228, -0.063589, -0.016279, -0.0047557, 0.019166, -0.004286, 0.072221, 0.027668, 0.0076072, 0.046252, 0.045328, -0.058087, -0.052569, -0.044762, -0.023156, -0.00017763, 0.05236, 0.017613, 0.026754, -0.0071592, 0.02145, 0.026061],
              [0.074443, 0.02501, -0.0072387, -0.034581, 0.0075069, 0.050532, 0.097729, 0.10515, -0.0020886, -0.064607, -0.071901, 0.06271, 0.04811, -0.0061288, -0.048708, -0.028878, 0.049283, 0.10301, 0.091885, 0.10831, -0.0069202, -0.07108, -0.032385, -0.041457, -0.037318, -0.037271, -0.040336, -0.030542, 0.027846, 0.051126, 0.039458, 0.061534, -0.0088597, -0.058003, -0.036151, -0.039854, -0.04856, -0.058763, -0.083102, -0.091876, -0.077267, 0.00086207, 0.064568, 0.051764, -0.087357, -0.053385, -0.019429, -0.023415, -0.08563, -0.12611, -0.086692, -0.12449, -0.055126, 0.030267, 0.083602, -0.12584, -0.091278, -0.07353, -0.085046, 0.01189, 0.13738, 0.12692, -0.020512, -0.083332, -0.045688, 0.094722, -0.11768, -0.11561, -0.06055, 0.081985, 0.17044, 0.11966, 0.11254, 0.074741, -0.025738, -0.033587, 0.034114, 0.051553, -0.020223, 0.04569, 0.056071, 0.020998, 0.044562, 0.029391, 0.026725, 0.013325, -0.019773, 0.0027476, 0.12423, 0.04555, 0.018947, 0.005724, -0.0058699, 0.005037, 0.043724, 0.019509, -0.0018888, -0.0096177, -0.0132, 0.10144, 0.085182, -0.01332, 0.0029189, 0.010088, 0.0094933, 0.01793, 0.031407, 0.011734, -0.050901, -0.015736, 0.029231, 0.048512, 0.013899, -0.031158, -0.040662, -0.0083011, 0.043045, -0.010968, -0.0012439, -0.022627, -0.11766],
              [-0.039873, 0.00012185, 0.018432, -0.060305, 0.014643, 0.012981, -0.0070294, -0.055625, -0.011913, 0.0084125, 0.010421, 0.014232, 0.0046832, 0.03282, 0.013207, -0.023534, -0.011405, -0.042582, -0.018915, -0.049511, -0.018366, -0.0058433, 0.022316, 0.021335, 0.034666, 0.06001, -0.034246, -0.047005, -0.047922, -0.041049, -0.026714, -0.03879, -0.018331, 0.037977, 0.028814, 0.01977, 0.037289, -0.066963, -0.10295, -0.090035, -0.060416, -0.030822, 0.024013, -0.023616, 0.014618, 0.0051973, -0.0053409, 0.019717, -0.078767, -0.029297, -0.02328, -0.014403, -0.0092264, -0.033409, -0.020726, -0.035932, -0.02301, -0.039252, -0.016761, 0.053608, 0.1333, 0.1649, 0.090281, 0.04523, 0.017404, 0.013598, -0.047298, -0.067622, -0.027196, 0.065506, 0.022326, 0.046886, 0.043069, 0.12018, 0.084303, 0.020672, 0.020185, -0.071051, -0.079542, -0.016269, 0.033355, 0.028706, -0.012012, -0.015403, 0.031358, 0.10477, 0.0025587, 0.021109, -0.039308, -0.093768, -0.022121, 0.023658, 0.0016241, 0.011496, -0.039667, 0.01091, 0.063816, 0.062965, 0.011666, -0.024049, -0.0027909, -0.053242, -0.014763, -0.009588, -0.031087, -0.030645, 0.010272, 0.037482, 0.060317, 0.024907, -0.0456, -0.020358, -0.062106, 0.036987, -0.038453, -0.044857, -0.034311, -0.011784, 0.018763, 0.061657, 0.040804],
              [-0.030967, -0.034705, -0.030029, -0.073209, -0.048949, -0.038641, 0.051475, 0.074237, 0.11135, 0.076704, 0.047486, -0.068456, -0.035129, -0.0025322, -0.057134, -0.053441, 0.017149, 0.05211, 0.058782, 0.047057, 0.040322, 0.007803, -0.056083, -0.046847, -0.0065577, 0.015471, 0.0066615, 0.05262, 0.00019301, 0.077547, 0.050314, -0.024569, 0.034663, -0.004403, -0.038893, 0.018694, 0.035428, 0.060686, 0.058741, 0.0014872, -0.045756, -0.047945, -0.092818, -0.021044, 0.0075622, 0.0087803, 0.024403, -0.018245, 0.0056819, -0.12201, -0.11278, -0.054719, -0.090167, -0.032775, -0.07964, -0.0081433, 0.036416, -0.029719, -0.083432, -0.09701, -0.078382, -0.061852, -0.023646, -0.040448, -0.078556, -0.035219, -0.027449, -0.0024222, -0.0086514, -0.069056, -0.046264, -0.026684, 0.0085151, 0.015105, 0.031314, 0.036056, 0.025591, 0.0051354, -0.023005, 0.021047, -0.014202, -0.043602, 0.014084, 0.047988, 0.0040769, 0.04007, 0.031368, 0.041402, 0.0083542, 0.053524, 0.038347, -0.0075355, 0.033837, 0.037702, 0.023171, 0.00063875, 0.022457, 0.058804, 0.033466, 0.011934, -0.0031203, 0.016069, 0.037622, -0.010943, 0.046299, -0.0027638, 4.2317e-06, -0.0038944, 0.0096576, -0.01851, -0.054006, 0.017238, 0.0091597, 0.028997, 0.033953, 0.070753, 0.003781, 0.0272, 0.009142, 0.027115, 0.01271],
              [-0.059222, -0.0013807, 0.027613, 0.10527, 0.056162, 0.063382, 0.0052814, 0.022701, 0.023071, 0.011641, 0.037101, -0.096537, -0.037975, 0.00038733, 0.050625, 0.065087, 0.0010273, 0.010303, 0.0050328, 0.050959, 0.053162, 0.030888, -0.021359, -0.030127, 0.014336, 0.044082, 0.045143, 0.013943, -0.07448, -0.021195, 0.010166, 0.028012, -0.022729, -0.03377, 0.0042314, 0.022687, 0.046542, 0.1131, -0.0045052, 0.072384, 0.037892, 0.04464, 0.053305, 0.055298, -0.02526, 0.023523, 0.029551, -0.057104, -0.037228, -0.040335, -0.066002, 0.051806, 0.090921, 0.015823, -0.038665, 0.0092907, -0.028826, -0.074981, -0.057874, -0.10796, -0.046546, -0.11182, -0.10192, -0.085702, -0.093906, -0.14398, -0.056829, -0.066264, -0.071883, -0.05541, -0.0092823, 0.0018364, -0.0066183, -0.011825, -0.09252, -0.088262, 0.0069521, -0.025393, -0.0063947, -0.043362, -0.022174, 0.0077219, -0.025334, -0.0083153, 0.037371, 0.012799, 0.015685, -0.0096592, -0.0057849, -0.010757, 0.017757, 0.04453, 0.0041941, 0.054645, 0.03971, 0.033911, 0.065272, 0.03489, 0.095387, 0.012474, -0.0089935, 0.04438, 0.030765, 0.018887, 0.031788, 0.031674, 0.020197, -0.0012983, 0.046204, 0.043617, 0.05228, 0.035529, 0.048753, -0.010956, -0.010948, 0.0023335, 0.0008262, -0.028699, 0.014222, -0.0098069, -0.035273],
              [0.062947, 0.064519, 0.032897, -0.045712, 0.020599, 0.063655, 0.014616, -0.027441, 0.035616, 0.0094036, 0.056507, 0.031273, -0.011035, 0.038887, -0.021343, -0.016083, 0.03398, 0.052626, -0.025295, -0.026549, 0.030681, 0.027583, 0.080967, 0.035373, 0.0349, -0.012799, 0.043192, 0.022703, 0.050265, 0.00034374, -0.012567, 0.07343, 0.0065301, 0.017282, 0.049276, -0.027253, -0.0086521, 0.047527, 0.17862, 0.086809, -0.019355, -0.04187, -0.055305, 0.078291, -0.12691, -0.09628, -0.092541, -0.10217, -0.041913, -0.0061569, -0.023942, -0.051812, -0.12531, -0.097862, -0.10634, -0.088742, -0.060959, -0.031993, -0.036846, -0.092274, -0.11353, -0.036147, 0.011597, -0.013144, -0.063917, -0.11042, -0.012416, -0.061287, -0.019684, -0.023518, -0.0066523, -0.014485, 0.018028, 0.0080843, 0.036972, -0.018618, -0.10924, 0.030523, 0.012989, 0.04012, 0.061496, 0.04845, 0.019214, 0.02151, 0.072093, 0.03741, 0.04916, -0.013141, 0.060643, 0.022195, 0.051299, 0.013218, 0.041766, 0.010616, -0.010208, -0.0005756, 0.076314, 0.01751, 0.060847, 0.033003, 0.048985, -0.0064822, -0.0021063, 0.010623, 0.028539, 0.028618, -0.023485, -0.0028276, 0.044106, 0.022575, -0.025473, 0.026401, -0.02986, -0.035148, -0.028004, -0.010875, -0.025206, -0.031473, -0.013822, -0.010973, 0.076092],
              [0.036904, 0.056002, -0.010952, 0.040331, -0.0037441, 0.049112, 0.007917, 0.11344, 0.00075633, -0.037483, -0.018736, 0.011745, 0.036506, 0.0534, 0.023086, 0.0044153, -0.0036749, 0.049657, 0.004597, 0.040393, -0.029098, -0.074894, 0.0016705, -0.032136, 0.03675, 0.03203, -0.02511, 0.022111, -0.011119, 0.027124, 0.061095, -0.024784, -0.059956, 0.013712, 0.036558, 0.08411, 0.05595, -0.020007, 0.020789, 0.049866, 0.039022, 0.088846, 0.012344, -0.055388, -0.028389, 0.025833, 0.10642, 0.052723, -0.054784, -0.1019, -0.049794, -0.0069086, 0.018753, 0.0082098, 0.013268, -0.18181, -0.12596, -0.094587, -0.027565, -0.06434, -0.091631, -0.092278, -0.07557, -0.11648, 0.0033702, 0.029872, -0.04912, -0.1095, -0.082986, -0.020757, 0.03284, 0.027499, -0.051265, -0.028727, -0.074363, -0.078828, -0.048211, 0.024175, 0.0074473, -0.0074232, -0.00077866, 0.056675, 0.02248, -0.022053, -0.025989, 0.0064103, -0.020235, -0.064838, 0.08154, 0.05056, 0.027641, 0.056668, 0.031151, 0.039877, 0.032444, 0.042983, -0.0018216, 0.0070638, -0.005843, 0.067604, 0.030913, 0.028072, -0.001085, 0.015535, 0.043687, 0.019384, 0.03294, 0.05737, 0.0076083, 0.0044987, -0.011422, -0.029081, -0.0036106, -0.0032691, -0.063552, -0.022937, 0.0091467, -0.011391, 0.068188, 0.0038844, 0.071449],
              [0.09367, -0.0060186, 0.064975, 0.057205, 0.032039, 0.017361, -0.05431, -0.074304, -0.022134, -0.034414, 0.0044163, 0.028938, 0.016585, 0.025525, 0.035894, 0.0076747, -0.0019368, 0.0066708, -0.10424, -0.00055455, 0.0022381, -0.028409, -0.0040177, -0.013989, 0.025428, 0.064148, 0.077486, 0.034007, 0.046771, 0.054056, -0.068292, -0.011916, -0.082369, -0.034027, -0.093927, -0.028299, -0.083188, 0.006867, 0.07996, 0.063772, 0.00087634, 0.020692, -0.012739, -0.018539, -0.082159, -0.035509, -0.090379, -0.072582, -0.10221, -0.10665, 0.00090251, 0.015335, 0.046228, 0.038103, -0.0062461, -0.067246, -0.053326, -0.0029145, -0.055346, -0.055246, -0.11557, -0.12679, -0.01865, 0.020112, 0.0072375, 0.013539, 0.039109, 0.051642, 0.0078965, 0.023871, -0.017458, 0.018892, -0.10505, -0.08968, -0.042725, 0.026725, 0.011636, 0.084889, 0.034195, 0.065857, 0.0042427, -0.012401, 0.042723, 0.033509, -0.0086453, -0.09177, 0.02075, 0.019877, 0.010695, 0.047156, 0.044111, -0.014435, 0.071374, 0.034756, 0.040578, -0.0071663, 0.025408, 0.043339, 0.01048, -0.0087307, -0.013411, -0.020395, 0.0060122, 0.024188, 0.041668, 0.041183, 0.10243, -0.029406, 0.0031099, 0.0030509, -0.017382, 0.0048264, -0.026782, 0.011942, 0.0024678, 0.040929, 0.080623, 0.029179, 0.043039, 0.0055502, 0.0002791],
              [-0.033397, 0.0096415, -0.018237, -0.034139, -0.0024439, 0.0055087, -0.0026268, -0.028241, 0.005216, -0.021235, -0.047074, -0.026122, -0.027138, -0.048107, -0.040211, -0.030102, -0.0032793, 0.059679, 0.0067584, 0.030667, 0.0095436, -0.016919, 0.0038233, -0.058996, -0.030891, -0.05815, -0.081535, -0.006358, -0.017081, 0.043337, 0.062984, 0.040401, 0.0072034, 0.011593, -0.0033021, -0.057817, -0.037813, -0.12426, -0.10986, -0.093813, 0.065001, 0.034844, 0.056616, -0.014925, -0.021165, -0.0032162, -0.01231, -0.017827, 0.035551, -0.070468, -0.034864, -0.017196, 0.028479, -0.022807, 0.032134, 0.026469, 0.0095896, 0.035119, 0.13551, 0.13689, 0.16248, 0.015875, -0.020831, -0.0011812, -0.019841, -0.088082, 0.030458, 0.026063, 0.047026, 0.070569, 0.062917, 0.049799, 0.085486, 0.035142, -0.020167, -0.061685, -0.092848, -0.0015897, 0.016609, 0.055002, 0.070868, 0.013235, -0.00082084, 0.038005, 0.073573, -0.035372, -0.031698, -0.086249, 0.01039, 0.020134, 0.013596, 0.055295, 0.0095627, -0.021797, -0.0091913, 0.042724, 0.028966, -0.048329, -0.097, -0.035392, -0.0091231, 0.047734, 0.0249, 0.040202, -0.042437, -0.0088865, 0.0034761, -0.012834, -0.011082, -0.086374, 0.010907, 0.0015854, 0.059934, 0.039391, 0.025936, 0.018352, -0.066655, -0.036969, 3.6891e-05, -0.037622, -0.087739],
              [-0.0096923, -0.014831, -0.020109, -0.04153, -0.079113, -0.02844, -0.047215, 0.01792, -0.043731, -0.0083078, 0.0080638, -0.042848, 0.015733, -0.035877, -0.020275, 0.0060017, -0.011038, -0.0079322, 0.0024669, -0.047175, 0.019485, 0.038912, 0.039176, 0.0053798, 0.011395, 0.022135, 0.10262, 0.060645, -0.0049047, -0.026338, -0.0003105, 0.021471, -0.029131, 0.049021, 0.048247, 0.087541, 0.072996, 0.019711, 0.053346, 0.068713, 0.0089235, -0.0091036, 0.005913, -0.012742, 0.056215, 0.063791, -0.020641, -0.030947, -0.016712, 0.11272, 0.026897, -0.013567, -0.01709, 0.014777, -0.010782, -0.0069221, -0.089428, -0.067233, -0.026911, 0.035337, 0.16957, -0.0065458, -0.024077, 0.032167, -0.017459, -0.040089, -0.099301, -0.011985, -0.027641, 0.012259, 0.09947, 0.030179, 0.017807, -0.031244, 0.036953, -0.062248, -0.018967, -0.066056, -0.026801, -0.012533, 0.024585, 0.05625, 0.041206, -0.010337, -0.044756, -0.072391, -0.0056601, -0.022192, -0.02598, -0.0048569, 0.0022456, 0.048042, 0.021878, -0.031094, 0.031079, 0.02862, -0.059947, 0.016802, -0.0025822, 0.084439, -0.0032539, 0.021756, 0.044396, -0.0081787, 0.043428, -0.012816, 0.014791, -0.028622, -0.048855, -0.035405, 0.070881, 0.054725, 0.086069, 0.04987, 0.024135, 0.016045, 0.021408, -0.0019594, -0.052757, -0.046484, -0.068063],
              [-0.044332, -0.05433, -0.051769, -0.015254, -0.010701, 0.0092805, -0.006241, 0.020072, 0.063349, -0.049922, -0.024848, 0.061077, 0.073127, 0.03427, 0.035888, 0.065559, 0.0050894, -0.017425, 0.064103, 0.063691, 0.011937, 0.0065559, 0.059352, 0.036171, 0.073145, 0.043276, -0.0077362, -0.022749, 0.004669, -0.00069003, 0.06394, -0.014967, 0.0030728, 0.026663, 0.05282, 0.017109, -0.022409, -0.087085, -0.09757, 0.021721, 0.051712, 0.032757, 0.01782, -0.037826, -0.099907, -0.11008, -0.06304, -0.11066, -0.056464, 0.026811, 0.07562, 0.073184, 0.035501, -0.023905, -0.017845, -0.11757, -0.12168, -0.083114, -0.034921, 0.046766, 0.058774, 0.010496, -0.002213, 0.0511, 0.024775, 0.023471, 0.015632, 0.01797, 0.0019336, 0.030515, -0.03111, 0.033605, 0.036258, -0.022201, -0.023003, 0.014758, -0.0070368, 0.1179, 0.049474, 0.062413, 0.052777, 0.0094326, 0.032164, -0.0071376, 0.0032749, 0.0067896, 0.022973, -0.030044, 0.095055, 0.077918, 0.025171, 0.032486, 0.0054809, 0.046288, -0.0048347, 0.010141, 0.006405, -0.016193, -0.02077, 0.071543, 0.041812, -0.0011514, -0.0069609, 0.01636, 0.025003, 0.020552, -0.0015891, 0.036688, -0.059255, -0.0045241, -0.022765, 0.055697, 0.058835, -0.017696, 0.014345, -0.020606, 0.02101, -0.022475, -0.040297, -0.040552, -0.03658],
              [0.04868, -0.0052211, 0.01119, -0.014771, -0.034142, -0.028004, 0.0059494, 0.015102, 0.019901, 0.039961, 0.0038194, 0.01389, 0.075503, 0.059891, 0.075512, 0.073756, 0.10697, 0.068741, 0.048031, 0.042366, -4.2027e-05, -0.012109, -0.011319, -0.037382, -0.021548, 0.018482, -0.0052013, 0.027477, -0.013858, 0.043728, -0.025032, -0.029687, -0.019073, 0.033492, -0.065964, -0.062342, -0.075624, -0.053586, -0.028774, 0.0066218, -0.10036, -0.089046, -0.04614, 0.072975, 0.087251, 0.045168, -0.053337, -0.082409, -0.091444, -0.074426, -0.092126, -0.037675, -0.0056525, 0.067513, 0.093934, 0.0092897, 0.018516, 0.037298, -0.021567, -0.034819, -0.021783, -0.025809, -0.036853, 0.0050072, -0.0054865, 0.036889, 0.020304, 0.06235, 0.038517, 0.067308, 0.058616, -0.0042178, 0.054673, 0.039231, 0.031392, 0.043919, 0.043293, 0.018805, 0.017383, 0.059662, 0.033699, 0.013342, 0.08421, 0.025431, 0.012904, 0.065431, 0.011197, 0.029136, 0.062541, 0.045383, -0.0053463, -0.017267, 0.02042, 0.013123, 0.015259, -0.01873, 0.023824, 0.052818, 0.015447, -0.01249, 0.014684, -0.026853, 0.028989, -0.0048952, 0.024942, 0.080075, 0.013283, -0.03042, -0.0077059, 0.0057615, -0.022997, -0.031813, -0.0074071, 0.0074686, 0.066652, -0.04319, 0.0087486, 0.035607, 0.0093449, -0.060326, -0.029897],
              [-0.021247, -0.022204, 0.086827, -0.025228, 0.046972, -0.032033, -0.018785, -0.0043159, -0.041827, -0.069289, -0.0081667, -0.017438, -0.024335, 0.028654, 0.072066, 0.016591, 0.024633, 0.07814, 0.056622, 0.037503, 0.03784, 0.032, 0.013106, 0.012369, -0.028706, 0.0050659, 0.013853, 0.00055953, 0.020323, 0.075276, 0.091913, 0.11099, 0.078217, 0.015546, -0.011745, 0.051738, -0.012734, 0.016769, -0.044366, -0.099554, -0.0501, -0.057248, 0.016222, 0.0676, -0.0086481, -0.0032869, 0.0085923, 0.046768, 0.072794, 0.045295, -0.084825, -0.14861, -0.051316, -0.12479, -0.085079, -0.0057128, 0.044163, -0.001048, 0.030855, 0.035139, 0.072277, 0.053918, -0.044672, -0.082685, -0.106, -0.15447, -0.011133, 0.028928, 0.0038564, 0.016248, 0.017416, -0.021407, 0.026964, 0.028131, 0.025158, 0.037924, -0.004685, -0.027697, -0.041379, 0.0087612, 0.0052052, 0.0439, 0.07761, 0.023416, 0.06086, 0.035574, 0.071928, 0.064071, 0.013358, -0.048366, 0.029793, 0.0052255, 0.0017724, 0.043271, 0.061872, 0.06025, 0.0059221, 0.067275, 0.1015, -0.030662, 0.00089429, -0.057645, 0.033295, 0.024006, 0.0049161, -0.018549, 0.028088, 0.023382, 0.034065, 0.076788, -0.05767, -0.034528, 0.02176, -0.072334, -0.00053618, 0.029546, 0.0043528, 0.0050097, 0.045672, 0.027025, 0.047575],
              [8.4608e-05, -0.00051459, -0.00065583, 0.00020679, -0.0011087, 1.7283e-05, -0.00069139, -0.00067753, 7.4613e-06, -0.00070527, 0.00036511, -0.00022613, 0.00083733, -0.00038556, -0.00020677, 0.00010704, 0.00015849, -0.00023179, -0.00023816, -0.00042063, -0.00035892, -0.0010411, -0.00070995, 0.000723, -0.00024736, 0.00048919, 0.00024924, 0.00060669, 0.0014982, 0.0005362, 0.00050087, 0.00089807, 0.00023875, 0.0001569, -5.4315e-05, 0.00056173, -0.00015464, 0.0003081, 0.0010477, 0.00054031, 0.0020028, 0.00073696, 0.00041838, 0.0011534, -0.0014158, -1.7385e-05, -0.0003327, 0.00025909, -6.7895e-05, 0.0020025, -0.00060121, -0.00063729, 0.00088529, 0.00051385, 0.00080077, -0.00021374, -0.00012764, -0.00032299, -5.5464e-05, -0.00038413, 0.00098096, 0.0016769, -0.00023683, -0.00047131, -0.0011834, 0.00011653, -0.00069781, -0.00081516, 0.00031472, 3.2978e-05, -0.00074268, 9.2834e-05, 0.0016276, 0.00052039, 0.00032858, -0.00090914, -0.00066274, -0.00049429, 0.00081787, -0.00028647, -0.00047775, -0.0011287, -0.00014959, 0.00067728, 0.0018427, 0.00042127, -0.0011898, -0.0021021, 0.00025863, -0.00028165, -6.7871e-06, 0.00010673, -0.00081947, -0.00050656, -0.00045739, 0.0012233, 0.0012483, 0.00023367, -0.00049654, -0.00060431, 0.00048856, -0.00039402, -0.00030283, -0.00048298, -0.0004503, 6.8065e-05, 0.00029381, 0.0008075, 0.0010027, 0.0012118, -0.000315, -0.00096615, -0.00016521, -0.0002593, 0.00070445, -0.00051525, -4.9951e-05, 0.0002327, 0.00098128, 0.0017427, 0.0012749],
              [-0.092167, 0.0056729, -0.0093745, -0.013062, 0.026811, 0.049001, -0.021651, 0.037001, 0.0042183, 0.0018621, -0.0002865, 0.0053573, -0.024952, -0.053963, 0.022201, -0.013351, 0.012385, -0.018031, 0.025522, 0.012537, -0.011992, 0.045187, -0.0094335, -0.0044184, -0.013784, 0.025926, -0.041054, -0.038893, -0.039896, 0.035441, 0.023677, -0.041022, -0.057696, -0.017627, -0.020217, 0.027628, -0.018841, -0.015264, -0.042663, -0.076632, -0.057529, -0.014905, -0.066898, -0.06533, -0.0076506, -0.048587, 0.085982, 0.023145, 0.069503, 0.023607, -0.037011, -0.086464, 0.0048593, -0.047933, -0.065202, -0.0083087, 0.0036049, -0.014176, 0.086525, 0.025019, 0.18351, 0.17731, 0.052646, 0.046296, 0.017268, 0.091744, -0.011477, -0.0031098, -0.044721, 0.035195, 0.035162, -0.085226, 0.059126, 0.14804, 0.094894, 0.10021, 0.0948, 0.016819, -0.0016208, 0.0056984, 0.02466, -0.0017441, -0.031929, -0.082346, -0.036632, -0.00060561, -0.0084924, 0.029093, 0.021734, -0.019869, 0.0049377, 0.035446, 0.03566, 0.057302, -0.038292, -0.061604, -0.062082, -0.043689, -0.019287, -0.015927, 0.020688, 0.0061875, 0.0079545, 0.03821, 0.017747, 0.018299, -0.071994, -0.048806, -0.041478, -0.074196, -0.04357, -0.02427, 0.048012, -0.0022007, -0.012801, 0.052876, 0.06225, 0.025342, 0.0028709, -0.041475, -0.016771],
              [0.020792, -0.026685, 0.0052684, -0.034939, 0.021609, 0.07276, 0.041389, -0.022051, -0.037669, -0.038136, 0.056138, 0.018701, 0.024053, -0.044522, -0.0072803, 0.025522, 0.055898, 0.020086, 0.022258, -0.043113, 0.025461, -0.042, -0.022104, 0.020437, -0.0089104, -0.040754, -0.044989, 0.014514, -0.024973, 0.041776, -0.020618, -0.027452, -0.058121, -0.019728, -0.064864, -0.065429, -0.034021, -0.070154, -0.047186, -0.066865, -0.066928, -0.045242, -0.041527, 0.0090972, 0.066567, 0.092179, 0.035601, -0.031646, -0.084854, -0.078072, -0.058064, 0.027433, 0.038431, 0.093545, 0.02082, 0.053868, 0.080127, 0.12823, 0.10909, 0.12328, 0.10908, 0.1275, 0.08982, 0.13207, 0.040999, 0.05859, -0.028141, 0.011014, 0.010818, 0.057563, 0.043454, 0.063805, 0.039305, 0.014669, 0.031073, -0.064254, -0.058945, 0.011933, -0.088116, -0.1313, -0.083772, -0.057942, -0.054054, -0.052884, -0.09094, -0.054181, -0.048566, 0.041762, 0.052504, 0.04064, -0.017347, -0.07672, -0.061855, -0.020823, -0.062266, -0.047703, -0.040227, 0.046901, 0.057527, 0.025438, 0.069957, -0.0081337, -0.020792, -0.040002, -0.057585, -0.023269, -0.043727, -0.025274, 0.047882, 0.055113, 0.04126, 0.030578, 0.040162, 0.077326, 0.049074, 0.020718, 0.052627, 0.057604, 0.051058, 0.023973, 0.10154],
              [0.038642, -0.0050245, 0.0046137, -0.0067584, 0.031421, 0.043864, -0.0015665, -0.080588, 0.023011, -0.031974, -0.045853, 0.0073322, 0.024538, 0.026494, 0.012817, 0.015873, 0.010885, -0.025022, 0.037514, -0.046295, 0.011215, -0.028657, -0.015741, 0.010582, -0.0060245, -0.0021638, -0.012232, -0.038573, -0.034197, 0.021759, 0.0040701, 0.033019, -0.051704, -0.053297, -0.087987, -0.036089, -0.024714, -0.045558, -0.063234, -0.0079876, -0.001269, 0.047525, 0.014455, -0.018257, -0.027678, -0.073305, -0.062178, -0.056046, -0.061583, -0.013982, 0.036486, -0.018427, 0.072797, -0.0075591, -0.024644, 0.061682, 0.060669, 0.037714, 0.078055, 0.14419, 0.1556, 0.067522, 0.019946, 0.026659, -0.01207, 0.0057426, 0.083145, 0.11628, 0.053997, 0.07441, 0.067029, -0.054231, 0.003903, 0.062433, 0.025821, -0.026727, -0.010193, 0.020416, 0.060395, 0.011092, -0.046966, -0.070524, -0.072562, -0.027651, 0.06845, 0.033, 0.041736, 0.011928, -0.054917, -0.051654, -0.028774, -0.037453, -0.08234, 0.012375, -0.0058925, 0.11105, 0.016941, 0.033194, -0.0018374, -0.095054, -0.058966, -0.040233, -0.046409, 0.0083077, 0.044775, 0.06359, -0.010509, 0.066094, -0.0027753, -0.010076, -0.050324, -0.0068444, -0.0041476, -0.0038945, 0.028367, 0.032085, 0.0293, 0.0032286, 0.071386, 0.023726, -0.071251],
              [0.10873, 0.014278, 0.012274, -0.0081393, 0.057053, 0.042322, 0.033324, -0.0094696, 0.022832, -0.060308, -0.029388, 0.047863, -0.010046, -0.018988, -0.039886, -0.040504, -0.014329, 0.066888, 0.054681, 0.036468, 0.027426, -0.041157, -0.071084, -0.038858, -0.052405, -0.03744, -0.072142, -0.064832, -0.093371, 0.012493, -0.012993, 0.012828, 0.028496, -0.088967, -0.059145, -0.073604, 0.0014228, -0.061366, -0.054663, -0.10168, -0.086349, -0.013058, -0.020967, -0.024969, -0.0086781, -0.050928, -0.012321, -0.009796, -0.060386, -0.073566, -0.098901, -0.095045, -0.05081, -0.020639, 0.0068009, 0.15286, 0.097545, 0.11068, 0.11229, 0.18428, 0.11307, -0.0045716, 0.0064434, -0.052854, -0.020146, 0.0036235, 0.055737, 0.046046, 0.022877, 0.019702, -0.04451, 0.02626, 0.0012791, 0.11283, 0.045956, -0.036756, 0.013793, -0.00031411, -0.024157, -0.0076891, -0.018311, -0.036925, 0.015877, -0.00074296, 0.044351, 0.09355, 0.034107, 0.0074667, -0.055729, -0.024915, -0.040394, -0.014479, -0.021786, 0.034463, 0.019018, 0.019996, 0.057264, 0.040807, -0.028383, 0.012261, 0.036427, -0.022903, 0.006834, -0.0095408, 0.021714, -0.0024252, 0.026187, 0.062738, 0.0131, 0.021845, -0.0064556, -0.01806, -0.011501, 0.011069, -0.0076556, -0.060373, 0.018731, 0.010879, 0.039313, 0.050533, 0.0308],
              [0.040803, 0.065104, 0.015718, -0.042967, 0.053812, 0.074783, 0.057112, -0.0020897, -0.031444, 0.036659, 0.079578, -0.014495, 0.023854, -0.08596, 0.016421, 0.053099, 0.044587, 0.075787, -0.020575, -0.052303, -0.0027126, -0.025365, -0.075564, -0.039845, -0.035504, -0.031983, 0.016275, -0.014983, 0.0085163, -0.010415, -0.080245, -0.068934, -0.082117, -0.10868, -0.11517, -0.05217, -0.078003, -0.084743, -0.090079, -0.045561, -0.099138, -0.089931, -0.071757, -0.1012, -0.026109, -0.028956, -0.052953, -0.040651, -0.062404, -0.062531, -0.04764, 0.02155, 0.042012, -0.0014168, -0.060018, 0.050239, 0.094413, 0.14253, 0.12071, 0.11698, 0.098976, 0.12841, 0.10926, 0.10934, 0.037269, 0.02278, 0.044474, -0.0060598, 0.0061609, -0.0064769, 0.03487, 0.03938, -0.0013958, -0.028963, 0.0046569, 0.043728, -0.006941, 0.018088, 0.0082024, -0.0099195, -0.060301, -0.049617, 0.032033, -0.017011, -0.040659, -0.017714, -0.017211, 0.05557, 0.064732, 0.014251, -0.026793, -0.03762, -0.035454, -0.0033597, -0.0018842, -0.035139, 0.0012996, -0.020445, 0.037428, 0.021313, 0.054608, 0.044538, -0.025503, -0.045072, 0.014586, -0.031781, 0.0068856, 0.0054809, 0.010448, 0.036007, 0.072978, 0.0081452, 0.018678, 0.002222, 0.038134, -0.022256, 0.018473, -0.019159, 0.053864, 0.0041179, 0.042052],
              [-0.11959, 0.00046909, -0.017807, 0.060029, 0.010483, 0.11341, 0.060972, 0.0095573, 0.024172, 0.011559, 0.074094, -0.001533, -0.042434, 0.0093888, 0.054397, 0.049821, 0.0059163, 0.02311, -0.025328, -0.071392, 0.0028116, 0.04064, 0.023985, 0.00080593, -0.017294, 0.019318, -0.051786, -0.060402, -0.051631, -0.02641, -0.025387, -0.086705, -0.031667, -0.032597, 0.0060778, -0.03085, -0.1089, -0.059264, -0.058027, -0.065551, -0.076388, -0.014694, -0.1161, -0.13336, -0.013872, -0.071355, -0.046296, -0.046341, -0.059804, -0.05569, -0.088752, -0.0092767, -0.010766, -0.01369, -0.058954, 0.018927, -0.027282, -0.039857, 0.012549, 0.010688, 0.080319, 0.15262, 0.086961, 0.15253, 0.069464, 0.11198, 0.017371, 0.015813, 0.032806, 0.017747, 0.073545, -0.03211, 0.019567, 0.029618, 0.038786, 0.032628, 0.069817, -0.0062508, 0.051458, 0.030409, 0.046777, 0.040002, -0.020088, -0.012635, -0.04525, -0.034254, -0.021876, -0.045999, -0.024164, 0.0075637, -0.00091422, 0.035703, 0.088575, -0.013735, -0.0098033, -0.042826, -0.0012702, 0.0127, -0.043166, -0.032268, -0.0035433, 0.006758, -0.0053454, 0.023288, 0.074293, 0.019467, -0.017988, -0.0012524, 0.022264, 0.0012391, 0.0013565, -0.0046713, 0.016578, 0.036584, 0.0010972, 0.011357, 0.05343, -0.00068444, -0.038448, -0.0005839, 0.003291],
              [0.0087137, 0.021185, 0.044118, 0.040648, 0.032447, -0.013324, -0.020142, -0.025882, -0.0024841, -0.01901, -0.0021128, 0.0091018, 0.039626, 0.01797, 0.03736, 0.019343, 0.014757, -0.0010528, -0.025962, -0.010286, -0.011165, -0.0019599, 0.0087082, 0.034494, 0.028652, 0.0403, 0.033374, 0.05035, 0.0063626, -0.024012, -0.042233, 0.022058, 0.053376, 0.02062, 0.02954, 0.057652, 0.067979, 0.062647, 0.04924, 0.02117, 0.011454, 0.010299, -0.0018357, 0.05593, -0.011232, 0.032042, 0.015713, -0.0070039, -0.0091016, 0.016511, -0.019705, -0.039092, -0.045771, -0.0077692, 0.049862, -0.067365, -0.076963, -0.040595, -0.030389, -0.092514, -0.057212, -0.00095436, -0.045682, -0.036819, -0.068244, -0.027588, -0.041645, -0.043031, -0.054498, -0.068638, -0.097786, -0.065713, -0.052882, -0.013397, -0.019034, -0.023493, -0.036063, 0.027782, 0.012907, -0.017337, -0.064488, -0.099835, -0.1029, -0.064664, -0.064124, 0.010795, 0.02495, 0.01812, 0.10433, 0.10219, 0.013337, -0.0236, -0.089888, -0.10446, -0.11164, -0.051552, 0.045267, 0.069677, 0.13697, 0.064483, 0.098551, 0.093606, 0.037819, -0.0035166, -0.0028484, -0.031609, 0.0046812, 0.017172, 0.10537, 0.082514, 0.01027, 0.047236, 0.079023, 0.073711, 0.040152, 0.077665, 0.044443, 0.014455, 0.0224, 0.017225, 0.064739],
              [0.086172, 0.043276, 0.030057, -0.012273, -0.0084498, 0.033192, -0.034726, 0.018177, -0.0097128, 0.0085166, 0.030227, 0.052416, 0.051669, -0.01391, -0.014893, -0.030204, -0.023349, -0.039154, -0.020299, -0.02687, -0.021027, -0.048342, 0.050216, 0.0017508, 0.017848, -0.035663, -0.055701, -0.034566, -0.00014494, -0.011843, -0.030725, 0.037181, -0.014335, 0.026403, -0.021572, -0.050785, -0.0067591, -0.057082, 0.0016645, -0.0041547, -0.028756, -0.037141, -0.058967, -0.016029, -0.0031722, 0.0023078, -0.048022, -0.093376, -0.055543, -0.11398, -0.027457, 0.016614, 0.0027741, -0.016349, -0.072147, 0.0015395, -0.052683, -0.060379, -0.068267, -0.036772, 0.11935, 0.10245, 0.027543, -0.03207, -0.022385, 0.05629, -0.034119, -0.069687, -0.049956, 0.029733, 0.20069, 0.11621, -0.04341, -0.0030594, 0.00063196, -0.0015553, 0.065277, 0.010466, -0.020041, 0.061756, 0.12137, 0.078247, -0.080725, -0.075077, 0.012154, 0.036822, 0.024721, 0.040716, 0.021623, 0.038658, 0.052579, 0.083631, 0.047882, -0.075157, -0.050688, -0.008839, 0.091035, 0.078447, 0.062276, 0.060595, 0.016938, 0.064081, -0.014548, 0.065658, 0.018129, -0.087985, -0.026622, 0.060886, 0.077751, 0.066438, 0.019422, 0.048505, 0.070414, 0.035827, 0.083548, 0.060028, -0.0054325, -0.0020892, -0.030512, -0.00047303, -0.023512],
              [-0.019836, -0.0017613, 0.020981, 0.032445, 0.035482, 0.051464, 0.013871, 0.012773, -0.0056081, -0.011615, -0.044318, -0.060123, -0.014777, -0.0053583, -0.05438, -0.041378, -0.048977, 0.076953, 0.026914, -0.0014017, 0.0097461, 0.0046964, -0.006913, -0.040628, 0.034129, 0.011114, 0.026924, -0.034902, -0.083572, -0.017956, -0.013806, -0.062394, -0.0041427, -0.037637, -0.037725, -0.013775, -0.057705, 0.0048236, 0.072282, 0.032162, -0.065745, -0.043635, 0.00026056, -0.019143, -0.028408, -0.057929, -0.050766, 0.034536, -0.092192, -0.10533, -0.012076, 0.047513, 0.0020512, -0.026305, 0.059014, -0.041219, -0.037909, -0.035254, -0.0037642, 0.10583, 0.15061, -0.044965, -0.038673, 0.032859, 0.036836, 0.091521, 0.06793, 0.0016575, 0.011255, 0.019715, -0.04603, -0.005182, 0.13027, 0.076244, -0.062532, -0.073584, 0.077175, 0.049433, 0.035864, 0.03572, 0.020318, 0.028617, -0.18445, -0.027969, 0.14692, 0.1481, -0.032906, -0.022817, 0.081643, 0.073319, 0.096552, 0.057497, 0.019593, -0.060101, -0.05529, 0.077753, 0.082231, 0.043013, -0.084999, 0.047227, 0.11708, 0.073958, 0.068482, -0.025788, -0.042548, -0.028797, -0.028665, -0.050465, 0.0099283, 0.0074795, 0.035767, 0.013423, 0.059917, -0.017252, 0.00014025, -0.028233, -0.037232, 0.038073, 0.017201, 0.048124, 0.082875],
              [0.0081889, -0.058862, -0.043961, -0.063177, -0.018314, 0.034878, 0.035304, 0.014294, -0.027457, -0.068368, 0.0016691, -0.040968, -0.039439, -0.021638, -0.037684, -0.017748, -0.042289, -0.0018177, 0.030934, 0.011733, 0.02709, 0.0017191, 0.043276, -0.072533, -0.030224, 0.021072, -0.0074147, -0.043925, 0.020289, -0.034527, 3.0471e-05, 0.026067, 0.08854, 0.014139, 0.022766, -0.0018481, 0.042676, 0.017054, -0.096746, -0.10757, 0.070755, 0.015756, 0.0096692, -0.003229, -0.015101, 0.057926, 0.050109, 0.034385, 0.054202, -0.15713, -0.10755, 0.054216, 0.15266, 0.055888, -0.095941, 0.033287, 0.093531, 0.14384, 0.12025, 0.055497, 0.036285, 0.066833, 0.042161, 0.047588, 0.021868, -0.056412, 0.067603, 0.031338, 0.050713, 0.052148, 0.018648, -0.050759, -0.044588, -0.039313, -0.059936, -0.055185, -0.019957, 0.050193, -7.1757e-05, -0.033092, -0.034428, -0.034413, -0.023267, 0.031902, 0.020239, 0.0042221, 0.015602, 0.060847, 0.041402, -0.0034146, -0.007456, -0.015894, 0.056392, 0.063355, 0.0087304, 0.013014, -0.0020131, 0.045232, 0.035378, 0.0826, 0.033716, 0.016513, 0.015814, -0.016537, 0.022388, -0.012153, 0.02454, 0.023109, 0.0067064, 0.01196, 0.018086, 0.022565, 0.02924, 0.0070031, 0.042819, 0.063646, 0.071445, 0.025002, -0.029884, -0.044839, 0.0048106],
              [0.0076044, -0.031647, -0.063172, -0.074495, -0.018994, 0.052827, 0.03289, -0.01363, -0.064808, -0.029394, -0.036471, -0.0098222, -0.035121, -0.039435, -0.028818, 0.038501, -0.0049329, -0.027625, -0.067847, -0.0011073, -0.051841, -0.055931, -0.017412, -0.057527, -0.055499, 0.028375, 0.035911, -0.014961, 0.011607, -0.0075877, -0.0045075, -0.0082003, 0.01378, -0.050073, -0.049085, 0.070063, 0.041211, 0.044222, -0.09251, -0.017246, 0.0054614, 0.0057318, 0.033493, 0.0086141, 0.019265, 0.0091442, 0.058445, 0.11213, 0.0075004, -0.14041, -0.13224, 0.046901, 0.043119, 0.08258, 0.068684, 0.041318, 0.085515, 0.023787, 0.088925, 0.13629, 0.0054698, -0.086543, 0.025965, 0.10588, 0.09446, 0.081346, 0.041592, 0.0066818, 0.077674, 0.0056684, 0.042096, 0.032191, 0.030453, -0.025984, 0.025271, 0.034212, -0.011964, 0.037077, 0.045086, 0.0051588, 0.028807, 0.0386, 0.024876, -0.013892, 0.021756, -0.065358, -0.061058, -0.024592, -0.0075328, 0.019987, 0.040909, 0.040437, 0.040035, 0.018813, -0.030276, -0.030271, -0.016191, 0.0068099, 0.037916, -0.038319, 0.010307, 0.015829, 0.0408, 0.056154, 0.047863, 0.034288, 0.060681, 0.0032703, 0.0013153, 0.060955, -0.040792, 0.016183, 0.019528, 0.028894, -0.0012919, 0.034618, 0.043406, 0.029089, 0.0088268, 0.01826, 0.075373],
              [0.027451, 0.041263, -0.013145, 0.012208, 0.0092477, -0.012849, 0.0045636, 0.010876, 0.028905, 0.026392, 0.010733, 0.015032, -0.029908, 0.021412, -0.057537, -0.053416, -0.048866, -0.03557, -0.018461, -0.0029791, 0.032112, 0.051478, -0.0057662, -0.017767, -0.028238, 0.023529, -0.04216, -0.041032, -0.06681, -0.039632, -0.022227, -0.0041149, 0.032302, -0.013891, -0.034276, -0.0051503, -0.021066, 0.022152, -0.0022992, -0.06277, -0.019724, -0.057691, -0.042379, 0.028983, -0.019396, -0.029332, -0.010746, -0.013921, -0.029609, -0.12538, -0.095617, -0.035129, -0.039982, 0.0090953, -0.022087, 0.029136, -0.032594, -0.020184, 0.061602, 0.15458, 0.16957, -0.040428, -0.14425, -0.071643, -0.042253, -0.027875, 0.058879, -0.00047065, -0.04392, 0.054967, -0.069297, 0.11119, 0.23666, 0.12148, -0.011434, -0.048195, -0.079328, 0.0017254, 0.037709, 0.042182, 0.03583, -0.073358, -0.14576, 0.04829, 0.1488, 0.10065, 0.063705, -0.030693, 0.056256, 0.10255, 0.078604, 0.016466, -0.0056464, -0.13298, -0.028765, 0.059394, 0.14023, 0.01141, 0.01604, 0.032382, 0.10196, 0.061382, 0.082412, -0.063666, -0.018779, -0.038366, 0.077993, 0.037853, 0.040997, 0.011083, -0.0056645, -0.014755, 0.018865, 0.0075268, 0.014018, -0.010121, 0.019767, 0.039941, 0.099261, 0.052915, 0.022179],
              [-0.097161, 0.021642, 0.029135, 0.013999, 0.059317, 0.033067, 0.0085646, 0.010286, -0.0083818, 0.018754, -0.030375, -0.041904, -0.055862, -0.010903, 0.068265, 0.026036, -0.0012924, -0.0017623, 0.0054685, -0.021756, -0.049506, -0.066112, -0.022252, -0.0081983, -0.037367, 0.012775, -0.062951, -0.045045, 0.048001, 0.030007, -0.0018969, -0.015723, -0.05512, -0.012097, 0.0026362, -0.072633, -0.068873, 0.017773, 0.072339, 0.018535, -0.045281, -0.011332, -0.02728, -0.058723, 0.026328, -0.010818, -0.030611, -0.028513, 0.0012489, -0.11197, -0.05527, 0.011156, 0.0082229, -0.032306, -0.015024, 0.049383, 0.015328, 0.037662, -0.035013, -0.02945, 0.12073, 0.02286, -0.023256, -0.083648, 0.0074002, 0.010004, 0.099372, -0.025222, -0.096641, 0.053094, 0.15894, 0.033387, -0.048085, -0.010054, 0.037824, 0.0397, 0.054256, -0.024015, -0.029043, 0.046139, 0.16217, 0.01609, -0.091199, -0.076361, 0.031988, 0.036455, 0.025465, 0.074147, -0.046979, -0.049629, 0.079772, 0.087758, 0.049829, -0.030455, -0.024452, 0.067009, 0.11752, 0.11427, 0.074067, 0.0062338, -0.043366, -0.03995, -0.03541, -0.035864, 0.017813, -0.024727, -0.022276, 0.076761, 0.062045, 0.069838, 0.073013, 0.060191, -0.025406, 0.023373, 0.030478, -0.00023012, -0.026087, -0.01902, -0.036715, 0.058818, 0.068381],
              [-0.011512, -0.033324, -0.0776, 0.030092, 0.03689, 0.015053, 0.028017, -0.01019, -0.078318, -0.059233, -0.018527, 0.053961, -0.026974, -0.018041, 0.044307, 0.015819, -0.031954, -0.027401, -0.046791, -0.020608, -0.026272, -0.080187, 0.083846, 0.0014068, -0.049854, -0.021417, 0.066537, -0.0073245, -0.018145, -0.015182, -0.045131, 0.029948, 0.0064481, 0.042275, -0.074359, -0.014177, 0.077655, -0.010551, -0.12638, -0.033587, 0.062817, 0.0053909, 0.025795, 0.059722, -0.082995, 0.0042617, 0.10585, 0.071364, -0.026422, -0.16101, -0.05472, 0.048999, 0.075435, 0.010536, -0.048017, -0.08034, 0.039577, 0.036637, 0.12099, 0.13549, 0.051195, 0.018226, 0.085661, 0.18622, 0.10338, 0.023906, -0.0041823, -0.10643, -0.078125, -0.073469, -0.04842, 0.015109, -0.032646, 0.036236, 0.0080905, 0.11268, 0.10279, 0.044282, 0.010681, 0.048923, 0.054874, -0.018065, -0.018189, -0.071125, -0.10261, -0.05249, 0.024032, 0.019694, 0.049637, 0.032196, 0.008328, 0.070139, 0.06755, 0.057434, 0.020438, 0.0032421, -0.050695, -0.015384, 0.020203, -0.015663, 0.031709, 0.012506, 0.028623, 0.059463, 0.011987, 0.029656, -0.0016058, 0.032925, 0.031881, 0.050423, 0.015557, 0.021386, 0.0099933, 0.014351, 0.039479, 0.066852, 0.040297, 0.0099526, -0.0023558, 0.018149, 0.059119],
              [-0.015757, -0.049129, -0.023998, -0.021003, -0.0015358, 0.0021065, -0.037107, -0.042352, -0.061163, -0.034051, -0.02272, -0.06074, -0.026757, 0.00055934, -0.022616, 0.0070862, 0.013566, -0.0028115, -0.03858, -0.014823, -0.034836, -0.026656, -0.019478, -0.012107, 0.0042484, 0.016085, 0.00066552, 0.0016008, 0.020524, 0.061833, 0.0036079, -0.069862, -0.027833, -0.032569, 0.045124, -0.020542, 0.006226, -0.017204, -0.067138, -0.02151, 0.10815, 0.03721, -0.0060277, -0.016395, 0.027666, 0.073069, 0.050576, 0.042568, -0.040728, -0.18025, -0.051804, 0.068699, 0.10469, 0.046931, -0.024345, 0.081519, 0.13438, 0.12767, 0.058828, -0.065397, -0.010972, 0.015965, 0.064316, 0.092048, 0.079924, 0.0045625, -0.018287, 0.01743, 0.076145, 0.042835, 0.080207, 0.036117, 0.047379, -0.019875, 0.037658, 0.026116, 0.071588, -0.057638, -0.083807, -0.020457, -0.0066816, -0.010482, 0.0098189, -0.018911, 0.027174, 0.0048187, 0.0084831, 0.046647, 0.074896, -0.0027052, -0.052391, -0.035811, -0.010963, 0.036472, 0.015668, 0.03188, 0.028321, 0.029977, -0.0029437, 0.03462, 0.085725, 0.014662, 0.057456, -0.007795, 0.056967, 0.039174, -4.3951e-05, 0.039525, 0.033815, -0.053148, 0.046135, 0.034368, 0.025851, 0.043642, 0.028915, -0.0046553, 0.040695, 0.050442, 0.023379, -0.0043674, -0.067829]
            ]
          },
          "numPatches": 71,
          "patchSize": [11, 11],
          "canvasSize": [114, 102]
        },
        "shapeModel": {
          "eigenVectors": [
            [-0.25918, -0.049312, -0.13804, -0.050836, 0.00068527, -0.019144, 0.023319, -0.016196, 0.0036094, -0.23833, 0.020658, -0.015932, 0.064262, -0.090635, 0.022056, -0.093726, 0.055118, -0.053233, 0.0062574, -0.094495],
            [-0.015371, -0.27559, 0.043057, -0.017592, -0.095867, 0.037459, 0.028918, 0.13017, 0.063869, 0.093354, 0.031861, 0.020242, 0.27294, -0.13041, -0.0031444, 0.065211, 0.23797, -0.14727, 0.036057, -0.12952],
            [-0.27439, -0.039853, -0.1345, -0.029787, -0.079526, -0.11665, 0.035666, 0.0024172, 0.071, -0.194, 0.047707, -0.060782, 0.075256, -0.086537, -0.010494, 0.0038623, 0.019089, -0.010833, 0.01729, -0.048709],
            [-6.0611e-05, -0.29074, 0.061165, -0.040564, -0.096174, -0.006241, 0.098422, 0.12645, 0.05234, 0.14549, 0.019045, 0.11593, 0.11304, -0.22654, -0.026029, 0.14284, 0.10353, -0.031496, -0.047636, -0.031406],
            [-0.28061, -0.0285, -0.13348, -0.048224, -0.11476, -0.16358, 0.04864, 0.010323, 0.044309, -0.1123, 0.056897, -0.04627, -0.037397, -0.13318, -0.010864, 0.039312, -0.010946, -0.012651, 0.011106, 0.030546],
            [0.014069, -0.25865, 0.065608, -0.045936, -0.077032, -0.012717, 0.12471, 0.11892, -0.01367, 0.12043, 0.011009, 0.19013, -0.032169, -0.17265, -0.036627, 0.11829, -0.077253, 0.049108, -0.088365, 0.034692],
            [-0.2649, -0.016038, -0.15478, -0.054519, -0.11072, -0.13807, 0.083151, -0.00084689, -0.066659, -0.014543, 0.052714, 0.027388, -0.14574, -0.06911, 0.0058712, 0.038653, 0.035449, -0.027971, -0.0058316, -0.01235],
            [0.046354, -0.20341, 0.067449, -0.041981, -0.01392, -0.04931, 0.10476, 0.16149, -0.057377, 0.068718, -0.055875, 0.29988, -0.16587, -0.018902, -0.021824, 0.01015, -0.1561, 0.13122, -0.13142, 0.13137],
            [-0.20187, 0.0034527, -0.14527, -0.054549, -0.07767, -0.099693, 0.11163, -0.027564, -0.17, 0.052817, 0.0046486, 0.13801, -0.22662, 0.025099, 0.05739, -0.010585, 0.062813, -0.066384, 0.029034, -0.11015],
            [0.059919, -0.17456, 0.045547, -0.021382, 0.056054, -0.055753, 0.05095, 0.14366, -0.058304, -0.039882, -0.029734, 0.2412, -0.1539, 0.099337, -0.0079106, -0.091413, -0.17109, 0.079536, -0.07008, 0.10305],
            [-0.11407, 0.0077005, -0.097128, -0.048798, -0.034682, -0.034999, 0.086921, -0.095836, -0.20896, 0.08204, -0.038157, 0.17097, -0.22949, 0.12077, 0.083445, -0.06885, 0.10657, -0.11112, 0.14357, -0.1473],
            [0.050549, -0.13771, -0.008012, -0.0015715, 0.11898, -0.070033, 0.016791, 0.11156, -0.08231, -0.17681, 0.031785, 0.13575, -0.030875, 0.14057, 0.011927, -0.12276, -0.089723, 0.026135, -0.012285, 0.045456],
            [-0.01028, -0.0013954, -0.0425, -0.040684, -3.7807e-05, 0.035049, 0.013909, -0.16422, -0.15344, 0.06372, -0.032069, 0.09303, -0.10431, 0.21548, 0.062045, -0.0975, 0.082375, -0.15218, 0.21188, -0.078833],
            [0.020507, -0.080792, -0.076178, 0.048751, 0.16094, -0.0849, 0.019596, 0.042554, -0.092199, -0.29635, 0.068277, 0.016317, 0.097753, 0.078154, 0.043343, -0.075376, 0.033023, 0.059878, 0.024112, -0.088306],
            [0.040972, -0.0012967, -0.0020002, 0.0014908, 0.0030003, -0.0021443, 0.00056119, -0.19612, -0.0017679, -0.0059159, 0.0012463, 0.02461, 0.0022007, 0.22488, -0.00058423, -0.082013, 0.00042633, 0.0033161, 0.27617, -0.0016609],
            [-0.00080695, -0.065839, -0.10156, 0.075695, 0.15234, -0.10888, 0.028494, 0.0038627, -0.089766, -0.30037, 0.063282, -0.0004847, 0.11174, -0.004429, -0.029664, 0.0016153, 0.021647, 0.16837, -0.0054392, -0.084329],
            [-0.011079, -0.0017869, 0.039468, 0.042572, 0.0063749, -0.038365, -0.013127, -0.16577, 0.14969, -0.07534, 0.034732, 0.092316, 0.10808, 0.21223, -0.060291, -0.094457, -0.081011, 0.15442, 0.21076, 0.075295],
            [-0.020086, -0.080784, -0.077792, 0.047112, 0.16082, -0.083454, 0.020128, -0.036055, -0.09817, -0.29361, 0.066961, -0.019967, 0.09357, -0.086578, 0.045752, 0.079157, 0.036241, 0.053839, -0.032436, -0.091341],
            [-0.11597, -0.013117, 0.096737, 0.048698, 0.03934, 0.032214, -0.086192, -0.10015, 0.20556, -0.088938, 0.039379, 0.1655, 0.2281, 0.11514, -0.082911, -0.063962, -0.11002, 0.11206, 0.14394, 0.14898],
            [-0.046018, -0.1373, -0.01183, -0.0034917, 0.11752, -0.071357, 0.0202, -0.1077, -0.090474, -0.17344, 0.030258, -0.14237, -0.039887, -0.14521, 0.015204, 0.12538, -0.085457, 0.02174, 0.0066221, 0.03962],
            [-0.20407, -0.010324, 0.14695, 0.053665, 0.079817, 0.097421, -0.10953, -0.0332, 0.16757, -0.054347, -0.0058158, 0.12841, 0.22039, 0.021169, -0.057657, -0.0069775, -0.069501, 0.069464, 0.031771, 0.11412],
            [-0.051924, -0.17429, 0.039791, -0.023513, 0.052953, -0.059636, 0.055306, -0.14246, -0.064953, -0.037771, -0.029527, -0.24645, -0.1627, -0.10025, -0.0056447, 0.091759, -0.16848, 0.07686, 0.068882, 0.098631],
            [-0.26652, 0.0080164, 0.15732, 0.052824, 0.11009, 0.13602, -0.078962, -0.0072047, 0.064348, 0.017238, -0.054873, 0.015559, 0.13909, -0.068312, -0.006726, 0.038223, -0.041568, 0.033116, -0.0006524, 0.017514],
            [-0.035888, -0.20388, 0.061302, -0.044095, -0.018269, -0.054708, 0.10796, -0.16133, -0.059957, 0.068092, -0.053756, -0.30073, -0.17148, 0.021608, -0.021576, -0.011664, -0.15458, 0.13002, 0.13155, 0.13078],
            [-0.28095, 0.018294, 0.13596, 0.046378, 0.11163, 0.16295, -0.043692, 0.005633, -0.044813, 0.11695, -0.056419, -0.053721, 0.036101, -0.12627, 0.0094131, 0.034624, 0.0078958, 0.014575, 0.014576, -0.029157],
            [-0.0030095, -0.25957, 0.060302, -0.047799, -0.081491, -0.019148, 0.12653, -0.11923, -0.011915, 0.11592, 0.013241, -0.18816, -0.033617, 0.17776, -0.037026, -0.11975, -0.077625, 0.048572, 0.08786, 0.035868],
            [-0.27417, 0.028374, 0.13681, 0.028167, 0.075677, 0.11631, -0.031763, -0.0025636, -0.068884, 0.19958, -0.04692, -0.0653, -0.070747, -0.07755, 0.009461, -0.0017651, -0.014997, 0.0095846, 0.019152, 0.047435],
            [0.010865, -0.29209, 0.055821, -0.041705, -0.099231, -0.010829, 0.09975, -0.12644, 0.055095, 0.13774, 0.020908, -0.11345, 0.11591, 0.22977, -0.026422, -0.14288, 0.1042, -0.031898, 0.046918, -0.033299],
            [-0.25838, 0.038423, 0.13963, 0.050104, -0.0044595, 0.020604, -0.022162, -0.021309, -0.0010918, 0.24182, -0.019387, -0.016717, -0.053465, -0.08543, -0.022163, -0.096221, -0.045705, 0.047393, 0.0048329, 0.089322],
            [0.025564, -0.27732, 0.037589, -0.01958, -0.095765, 0.036676, 0.029814, -0.12944, 0.063961, 0.083898, 0.03265, -0.019599, 0.27526, 0.13388, -0.0022735, -0.06147, 0.23995, -0.14925, -0.036275, -0.13314],
            [-0.041104, 0.03824, 0.089308, 0.10752, -0.15824, -0.20816, -0.05678, 0.031965, -0.036292, -0.010284, -0.22616, 0.0035659, 0.061195, -0.077357, 0.10906, -0.32123, -0.062437, 0.045061, -0.13893, -0.075947],
            [-0.00058626, -0.028013, 0.033925, 0.096976, 0.12885, -0.13433, -0.054635, -0.18671, 0.12024, -0.016776, -0.37344, 0.16617, -0.043638, -0.021519, 0.08833, -0.099975, 0.11085, -0.017708, -0.082914, -0.0077089],
            [0.02714, 0.023191, 0.068434, 0.071893, -0.1454, -0.16792, -0.070781, 0.066657, -0.076045, -0.03488, -0.278, 0.06132, 0.0723, -0.023705, -0.044019, -0.27111, -0.046476, 0.0004387, -0.12313, -0.15561],
            [0.0076812, 0.027031, 0.05186, 0.093607, 0.237, -0.11818, 0.012899, -0.13978, 0.10628, 0.053512, -0.10841, 0.14453, -0.046948, -0.028787, -0.027495, 0.054014, 0.070313, -0.07865, -0.03377, 0.11646],
            [0.059719, 0.019365, 0.039768, 0.02943, -0.099503, -0.095192, -0.037385, 0.08759, -0.063224, -0.023056, -0.11334, 0.070632, 0.04052, -0.01614, -0.20119, -0.13465, -0.11306, -0.21055, -0.043694, -0.053042],
            [0.0041645, 0.070452, 0.057003, 0.12331, 0.23821, -0.13581, 0.032581, -0.092174, 0.027564, 0.12746, 0.12379, 0.10986, -0.021826, -0.040456, -0.0041165, 0.063285, -0.0047004, -0.052424, -0.01813, -0.030724],
            [0.072669, 0.016043, 0.026274, 0.0035342, -0.059453, -0.049835, -0.02393, 0.10364, -0.062651, -0.008958, 0.013307, 0.06849, 0.042477, -0.012887, -0.32345, -0.10205, -0.17377, -0.23316, -0.011128, 0.0081902],
            [0.00094691, 0.086262, 0.056562, 0.14777, 0.20316, -0.15155, 0.024606, -0.059728, -0.081607, 0.20453, 0.2079, 0.061226, 0.028169, -0.036131, 0.026537, 0.039991, -0.049029, -0.014036, -0.0096336, -0.23759],
            [-0.041049, -0.039313, -0.087903, -0.10361, 0.16319, 0.20271, 0.054585, 0.039292, 0.040999, 0.0096154, 0.21128, -0.0029798, -0.062866, -0.076449, -0.10549, -0.31704, 0.066753, -0.045723, -0.13556, 0.075584],
            [0.0022043, -0.026486, 0.037416, 0.10113, 0.12252, -0.14242, -0.056828, 0.1853, 0.11872, -0.017168, -0.38206, -0.16618, -0.041195, 0.024548, 0.092556, 0.11255, 0.10831, -0.01592, 0.08832, -0.010693],
            [0.026817, -0.022109, -0.066339, -0.068152, 0.15462, 0.16314, 0.071234, 0.072109, 0.080171, 0.03696, 0.27352, 0.055582, -0.074092, -0.022553, 0.042902, -0.27302, 0.049209, -0.0035352, -0.12171, 0.16007],
            [-0.0087439, 0.027923, 0.054514, 0.096365, 0.23109, -0.1247, 0.010102, 0.13705, 0.1032, 0.052097, -0.11927, -0.14683, -0.044065, 0.029698, -0.029207, -0.043298, 0.068429, -0.078571, 0.038592, 0.11024],
            [0.059509, -0.016576, -0.037493, -0.024552, 0.10881, 0.089771, 0.038639, 0.091151, 0.06426, 0.028057, 0.11812, 0.066252, -0.041348, -0.014535, 0.20087, -0.13704, 0.11279, 0.20832, -0.042946, 0.051792],
            [-0.0065127, 0.071159, 0.058524, 0.12437, 0.23411, -0.13946, 0.031083, 0.088654, 0.025053, 0.12646, 0.11923, -0.11255, -0.020213, 0.041061, -0.012035, -0.057934, -0.0091486, -0.060674, 0.019836, -0.032789],
            [0.072575, -0.012634, -0.024026, 0.002287, 0.067406, 0.043829, 0.02488, 0.10591, 0.059389, 0.017004, -0.005111, 0.066026, -0.041334, -0.011454, 0.32424, -0.10355, 0.1717, 0.23243, -0.01074, -0.017539],
            [-0.0038075, 0.086827, 0.057553, 0.1478, 0.20067, -0.1534, 0.023645, 0.0556, -0.084011, 0.20402, 0.20827, -0.063875, 0.029819, 0.036611, 0.013781, -0.035941, -0.055833, -0.023206, 0.010064, -0.23708],
            [-0.023504, -0.039048, -0.085567, -0.07915, 0.12465, 0.13892, 0.024301, 0.066995, -0.036811, -0.0058879, -0.090783, -0.0042989, 0.043496, 0.062508, -0.078226, 0.043009, -0.006916, -0.04268, -0.019029, -0.015975],
            [-0.0073613, -0.021107, 0.039763, 0.055626, -0.049656, 0.08481, -0.11232, 0.126, -0.023632, -0.057175, -0.0059589, -0.12646, -0.034427, 0.013453, 0.017897, -0.076871, 0.010909, -0.022518, 0.0081303, -0.034046],
            [0.016949, -0.021935, -0.063152, -0.0528, 0.10435, 0.10825, 0.033041, 0.086335, -0.015563, 0.0087724, -0.09103, 0.0052611, 0.0074128, 0.12677, -0.010974, 0.12218, -0.032293, -0.041308, 0.0097002, -0.04612],
            [-0.0066832, 0.0080822, 0.046932, 0.080999, -0.021246, 0.077223, -0.1208, 0.097572, -0.098662, -0.081072, -0.00075065, -0.10368, -0.10332, 0.018814, -0.010497, -0.061596, 0.18741, -0.10374, 0.0019642, 0.19297],
            [0.0011333, -0.011109, -0.044177, -0.026938, 0.058203, 0.06766, 0.012523, 0.086955, 0.014537, -0.0024289, -0.067247, 0.010136, -0.021704, 0.059668, 0.090059, 0.058504, -0.095515, -0.060413, -0.017229, -0.065438],
            [0.001501, 0.012001, 0.026456, 0.050506, -0.059044, 0.092763, -0.059216, 0.051446, -0.033728, -0.013303, 0.052355, -0.072966, -0.013674, 0.030573, -0.00012695, -0.036559, -0.077239, 0.00060169, 0.005698, -0.095808],
            [0.0045411, -0.02974, -0.061285, -0.051929, 0.095879, 0.10777, 0.018083, 0.11657, -0.018095, 0.0028619, -0.11164, -0.0016145, 0.018507, 0.085963, -0.0049371, 0.10297, -0.034909, -0.032022, 0.026463, -0.058609],
            [-0.003894, 0.012492, 0.035153, 0.021732, -0.075237, 0.11222, -0.12233, 0.089598, -0.025863, -0.0013533, 0.037452, -0.095172, -0.025294, 0.0092337, 0.045198, -0.060782, -0.10825, 0.10079, -0.015705, -0.15393],
            [-0.0022817, -0.024061, -0.064375, -0.051684, 0.082587, 0.108, 0.011766, 0.13476, -0.02204, 0.0027266, -0.078308, -0.0085373, 0.018275, 0.14969, 0.011605, 0.20993, -0.039923, -0.056634, 0.061774, -0.1028],
            [-0.0045582, -0.00066199, 0.030116, 0.052015, -0.057149, 0.10832, -0.12177, 0.094733, -0.053777, -0.066174, 0.026678, -0.096802, -0.073708, 0.014543, 0.0079362, -0.062351, 0.011446, -0.022934, -0.0045563, -0.014346],
            [-0.023196, 0.038186, 0.087067, 0.081279, -0.12651, -0.13547, -0.028704, 0.061982, 0.035852, 0.003632, 0.090478, 0.00068386, -0.044818, 0.06193, 0.07887, 0.046002, 0.0073402, 0.04176, -0.019334, 0.014622],
            [0.008281, -0.022628, 0.036363, 0.052466, -0.04471, 0.090214, -0.11127, -0.12854, -0.025063, -0.057363, -0.0095288, 0.12653, -0.032687, -0.015904, 0.014803, 0.075118, 0.010628, -0.024181, -0.0073747, -0.034648],
            [0.017199, 0.022236, 0.064951, 0.055948, -0.10511, -0.10512, -0.037772, 0.082426, 0.011666, -0.011958, 0.09093, 0.0093392, -0.011475, 0.12593, 0.010552, 0.12451, 0.039647, 0.037191, 0.0096153, 0.053682],
            [0.0060107, 0.0072123, 0.044409, 0.078858, -0.017121, 0.081425, -0.11941, -0.1009, -0.099198, -0.080664, -0.0043344, 0.10339, -0.10295, -0.023791, -0.010921, 0.056737, 0.186, -0.10529, -0.0023446, 0.191],
            [0.0010733, 0.011572, 0.045184, 0.028906, -0.060482, -0.063955, -0.014845, 0.084862, -0.015854, 0.0019032, 0.069256, 0.013001, 0.021149, 0.058418, -0.089994, 0.059899, 0.0924, 0.06039, -0.01744, 0.061615],
            [-0.0015445, 0.011555, 0.024696, 0.049406, -0.056706, 0.095356, -0.058677, -0.05483, -0.03313, -0.013389, 0.049667, 0.072511, -0.014518, -0.032899, 0.0034192, 0.034227, -0.08094, -0.0017775, -0.0050152, -0.09831],
            [0.0046909, 0.030208, 0.062622, 0.052744, -0.098767, -0.10326, -0.022886, 0.11295, 0.017063, -0.0029129, 0.11303, 0.0021341, -0.019489, 0.085533, 0.0067129, 0.10528, 0.030619, 0.035966, 0.027061, 0.052503],
            [0.0037122, 0.011312, 0.032713, 0.019671, -0.071403, 0.11638, -0.12153, -0.094118, -0.026556, -0.0012395, 0.033028, 0.095162, -0.024546, -0.012611, 0.044968, 0.056681, -0.10954, 0.099453, 0.014651, -0.15612],
            [-0.0021004, 0.024016, 0.065511, 0.053692, -0.084773, -0.10365, -0.016552, 0.13092, 0.019906, -0.00533, 0.079298, -0.0047191, -0.021163, 0.149, -0.011283, 0.21223, 0.040343, 0.055687, 0.061906, 0.10216],
            [0.0046445, -0.0016089, 0.027558, 0.04994, -0.053853, 0.11249, -0.12121, -0.099966, -0.054603, -0.066015, 0.023574, 0.097064, -0.072931, -0.020425, 0.008387, 0.054036, 0.0098649, -0.025146, 0.0021205, -0.018382],
            [0.081811, 0.0013429, 0.00052034, 0.001415, -5.5785e-05, 0.00050437, 0.000145, 0.053461, -0.0023341, -0.00054674, 0.002414, 0.050804, 0.0020717, -0.043036, -0.0041825, -0.048411, -0.0026617, -0.002868, 0.023711, -0.00077901],
            [-0.0016113, 0.068182, 0.02642, 0.071844, -0.0028325, 0.025609, 0.0073621, -0.0010529, -0.11851, -0.02776, 0.12257, -0.0010006, 0.10519, 0.0008476, -0.21236, 0.00095346, -0.13514, -0.14562, -0.00046699, -0.039553],
            [0.093167, -0.014401, -0.024259, -0.036742, 0.00078129, 0.019454, -0.0039861, -0.020993, -0.038747, 0.022799, -0.026621, 0.0015937, 0.056985, -0.12003, -0.024168, -0.0052872, -0.066418, 0.13427, 0.12116, 0.017717],
            [-0.0043277, 0.10938, 0.025032, -0.053334, -0.076358, 0.041667, 0.122, 0.019619, -0.0087275, -0.027906, -0.0020209, -0.03718, 0.085757, -0.0043895, 0.18879, -0.013536, -0.080459, -0.096481, 0.0087288, 0.10539],
            [0.068926, -0.0038995, -0.038483, -0.053422, 0.020614, -0.024275, -0.033835, -0.0013678, -0.040894, -0.0036977, -0.022243, -0.0092916, 0.047029, -0.13509, 0.039419, -0.023948, -0.17002, -0.072578, 0.12021, 0.10088],
            [-0.0035851, 0.098585, 0.036485, -0.07837, -0.060738, 0.024631, 0.11531, 0.025281, 0.020332, -0.017891, -0.012565, -0.029379, 0.056813, 0.016355, 0.1716, -0.027596, -0.057953, -0.014689, 0.0048945, 0.096282],
            [0.082029, -0.0074757, -0.024317, -0.059451, 0.015388, -0.017755, -0.03101, 0.014233, -0.045998, 0.014614, -0.029813, -0.025341, 0.057084, -0.13354, 0.028972, -0.022875, -0.15035, -0.014709, 0.11573, 0.087448],
            [0.0031065, 0.097355, 0.048803, -0.089657, -0.053981, 0.016189, 0.10551, 0.02838, 0.022379, -0.012573, -0.023347, -0.037642, 0.067804, 0.010192, 0.14003, -0.02179, -0.031733, 0.0074466, 0.0062393, 0.027541],
            [0.13874, 0.0029894, 0.00093656, -0.00071957, -0.00088727, 0.00037084, 0.0039663, 0.011515, -0.0016058, -0.00059454, -0.00015463, -0.021428, 0.0017942, -0.18743, 0.00028053, -0.061963, 0.001006, -0.00058912, 0.18355, 0.0011045],
            [-0.0027325, 0.15179, 0.047553, -0.036535, -0.045051, 0.018829, 0.20139, -0.0002268, -0.081533, -0.030187, -0.0078511, 0.00042203, 0.091097, 0.0036914, 0.014244, 0.0012204, 0.051077, -0.029912, -0.003615, 0.05608],
            [0.081843, 0.011303, 0.02622, 0.055874, -0.017502, 0.018379, 0.03514, 0.013104, 0.046843, -0.015097, 0.028871, -0.023839, -0.05437, -0.13383, -0.023436, -0.021999, 0.14899, 0.014991, 0.1154, -0.086296],
            [-0.006334, 0.096985, 0.047808, -0.091928, -0.053334, 0.015477, 0.10421, -0.028918, 0.02055, -0.011988, -0.024503, 0.038611, 0.069999, -0.0049259, 0.14106, 0.022674, -0.037629, 0.0068616, -0.010791, 0.030963],
            [0.069014, 0.0077782, 0.03989, 0.050294, -0.02299, 0.025226, 0.038349, -0.0023622, 0.041663, 0.0029904, 0.021731, -0.0081276, -0.044755, -0.13563, -0.032631, -0.022843, 0.1676, 0.071943, 0.11993, -0.097015],
            [0.00086837, 0.098355, 0.034941, -0.080413, -0.059879, 0.023656, 0.11389, -0.025207, 0.018706, -0.018023, -0.013432, 0.029722, 0.05862, -0.011023, 0.17302, 0.028518, -0.064602, -0.017535, -0.009624, 0.10018],
            [0.093265, 0.018696, 0.025226, 0.034614, -0.0037873, -0.017798, 0.0087869, -0.021749, 0.038373, -0.02388, 0.026521, 0.0030565, -0.053564, -0.11976, 0.031583, -0.0047501, 0.063198, -0.13797, 0.12073, -0.013554],
            [0.00065588, 0.10873, 0.024058, -0.05474, -0.076268, 0.042401, 0.12175, -0.018777, -0.010246, -0.026986, -0.0030676, 0.037088, 0.087934, 0.0091122, 0.1877, 0.013734, -0.083011, -0.091119, -0.013493, 0.106],
            [0.15198, 0.0028006, 0.00074601, 0.00047878, -0.00028276, 0.00046544, 0.002781, 0.014577, -0.0023714, -7.4399e-05, 0.00042809, 0.032335, 0.0025661, -0.11258, -0.0019629, -0.068299, -0.00085204, -0.0010859, 0.1352, 0.00036773],
            [-0.0029933, 0.1422, 0.037878, 0.024309, -0.014357, 0.023632, 0.1412, -0.0002871, -0.1204, -0.0037776, 0.021736, -0.00063685, 0.13029, 0.0022173, -0.099666, 0.0013452, -0.043261, -0.055136, -0.0026627, 0.018671],
            [0.13164, -0.023622, -0.010986, -0.039968, 0.011571, 0.033206, -0.05117, -0.014142, -0.040076, 0.014048, -0.038612, -0.0061341, 0.01909, -0.16518, 0.030389, -0.0032825, -0.11074, -0.013924, 0.17523, 0.020528],
            [-0.013331, 0.15174, 0.050439, -0.032634, -0.024682, 0.04785, 0.19726, 0.024422, -0.12826, -0.0096122, -0.051464, -0.034671, 0.12765, 0.0036732, 0.043964, -0.02446, 0.038083, 0.0069073, -0.0048465, 0.038265],
            [0.13206, 0.029579, 0.012963, 0.038652, -0.012533, -0.031296, 0.058898, -0.015093, 0.034995, -0.014415, 0.036556, -0.0047642, -0.014049, -0.1652, -0.028634, -0.0023168, 0.11215, 0.014185, 0.17529, -0.019005],
            [0.0081372, 0.15069, 0.049967, -0.034182, -0.024207, 0.04912, 0.1951, -0.023846, -0.12974, -0.0090517, -0.052945, 0.034885, 0.1283, 0.0028336, 0.045127, 0.02457, 0.033693, 0.0063537, -0.0020569, 0.039043],
            [-0.0038309, -0.0063276, -0.052088, -0.1806, 0.06685, -0.12575, -0.21251, -0.073443, -0.16678, 0.074329, 0.013077, -0.062465, 0.12875, 0.012954, 0.029467, 0.0018815, 0.016686, -0.033447, -0.18253, 0.065849],
            [0.0040364, 0.0054285, -0.044557, -0.17696, 0.004967, -0.10595, -0.15417, 0.058039, 0.23028, -0.0065144, 0.086591, -0.058097, -0.016971, 0.018176, 0.14783, -0.078001, -0.097636, -0.23239, 0.02167, 0.025891],
            [0.066275, 0.010935, 0.014806, -0.12124, 0.028556, -0.036048, -0.10364, -0.075579, -0.14633, 0.0464, -0.037991, -0.052857, 0.077592, -0.036722, -0.060381, 0.04572, 0.040593, 0.17851, -0.11244, 0.010952],
            [0.00064918, 0.075926, 0.017475, -0.19376, 0.0040828, -0.031841, -0.044577, 0.030139, 0.14151, -0.02134, 0.010565, -0.049083, -0.090521, 0.019608, -0.10736, -0.03545, 0.0033882, -0.0017409, 0.013727, -0.052914],
            [0.10399, 0.0025553, 0.0092925, -0.039069, 0.0011162, -0.0035913, -0.04118, -0.062868, -0.065948, 0.030965, -0.014729, -0.042241, 0.06468, -0.073966, -0.027365, 0.0526, 0.011956, 0.12005, -0.032601, -0.0051692],
            [-0.0023093, 0.11195, 0.046232, -0.16547, 0.0046114, -0.010781, 0.051679, 0.01146, 0.089804, -0.034391, -0.051201, -0.020257, -0.083425, 0.0026742, -0.23595, -0.023521, 0.05601, 0.075817, 0.0087274, -0.033058],
            [0.11206, 0.002208, 0.00098929, -0.003301, 0.00025018, -0.00015106, 0.00091684, -0.06328, 0.0017043, -0.00032172, -0.0013785, -0.052335, -0.0015449, -0.053192, -0.0044537, 0.059986, 0.001468, 0.0015596, -0.0197, -0.0008542],
            [-0.0022071, 0.11211, 0.05023, -0.16761, 0.012703, -0.0076701, 0.046552, 0.0012463, 0.086533, -0.016335, -0.069993, 0.0010307, -0.07844, 0.0010476, -0.22613, -0.0011814, 0.074535, 0.079185, 0.000388, -0.043371],
            [0.104, 0.0018546, -0.007465, 0.032523, -0.00093374, 0.003164, 0.043183, -0.063271, 0.069433, -0.032295, 0.012701, -0.041411, -0.067914, -0.074014, 0.018054, 0.053485, -0.0097409, -0.11697, -0.032919, 0.0038635],
            [-0.001787, 0.11196, 0.046562, -0.16688, 0.0046517, -0.010914, 0.050018, -0.008976, 0.087138, -0.033145, -0.051741, 0.021904, -0.080814, 0.00024026, -0.23685, 0.021431, 0.056437, 0.080485, -0.007437, -0.033236],
            [0.066198, -0.0079373, -0.014107, 0.11351, -0.028373, 0.034766, 0.1018, -0.076707, 0.15179, -0.047204, 0.038378, -0.050883, -0.081096, -0.037466, 0.056107, 0.047081, -0.040428, -0.17844, -0.11289, -0.013027],
            [-0.0032582, 0.076298, 0.018045, -0.19838, 0.005204, -0.033236, -0.048623, -0.02714, 0.13564, -0.019497, 0.0090612, 0.051126, -0.087396, -0.018147, -0.10965, 0.033622, 0.004984, 0.0052893, -0.0092889, -0.052441],
            [-0.0039869, 0.0065364, 0.050294, 0.17349, -0.066602, 0.12149, 0.20627, -0.075671, 0.17571, -0.074528, -0.0096575, -0.060129, -0.12932, 0.012229, -0.023623, 0.0049513, -0.020517, 0.024271, -0.18324, -0.064778],
            [-0.0038824, 0.0051751, -0.046574, -0.18393, 0.0075954, -0.11082, -0.16242, -0.055103, 0.22354, -0.0035826, 0.087039, 0.060512, -0.011888, -0.018672, 0.14888, 0.077867, -0.096904, -0.23352, -0.014466, 0.028463],
            [0.03097, 0.0047092, -0.0075287, 0.16358, -0.05269, 0.089604, 0.14219, -0.10514, 0.1452, -0.054725, -0.029364, -0.050839, -0.06189, 0.044141, -0.050418, 0.025015, -0.016424, 0.044951, -0.20678, -0.068404],
            [-0.0061911, 0.02549, -0.17773, -0.011649, -0.033779, -0.037805, -0.10673, -0.042821, 0.11269, 0.08733, 0.0073968, 0.043681, 0.017818, -0.025762, 0.053617, 0.053929, -0.045882, -0.054494, -0.01829, 0.050792],
            [0.072542, 0.0064767, -0.026271, 0.11039, -0.034052, 0.048185, 0.068957, -0.088822, 0.083965, -0.032426, -0.026028, -0.062976, -0.033734, 0.05017, -0.0071563, 0.036377, -0.027785, 0.045788, -0.16057, -0.044454],
            [-0.004648, 0.046087, -0.27901, 0.098064, -0.061904, 0.015661, -0.064718, -0.035866, 0.014465, 0.15614, -0.056402, 0.02919, 0.064899, -0.012066, 0.018025, 0.032618, 0.022591, 0.098127, -0.011371, 0.053108],
            [0.092348, 0.0010952, -0.0059954, 0.002549, -0.0015526, 0.0006001, -0.00090017, -0.096894, -0.00043212, 0.0031098, -0.0013362, -0.068512, 0.0017058, 0.027411, -0.00020316, 0.051833, 0.00062915, 0.0030024, -0.12667, 0.0010261],
            [-0.0018188, 0.055608, -0.30441, 0.12942, -0.078831, 0.03047, -0.045705, 0.0019083, -0.021941, 0.1579, -0.067846, 0.0013494, 0.08661, -0.00053986, -0.010315, -0.0010209, 0.031945, 0.15244, 0.0024948, 0.052101],
            [0.072669, -0.004657, 0.015264, -0.10645, 0.031588, -0.047531, -0.071452, -0.087341, -0.083331, 0.038549, 0.023787, -0.064076, 0.036263, 0.050607, 0.0078605, 0.035065, 0.028653, -0.041889, -0.16, 0.046511],
            [0.001788, 0.046306, -0.27983, 0.10233, -0.063197, 0.017546, -0.061952, 0.039336, 0.01776, 0.15474, -0.057383, -0.026688, 0.06352, 0.010081, 0.017729, -0.034025, 0.02148, 0.099853, 0.017685, 0.051316],
            [0.03119, -0.0037019, 0.00052469, -0.16391, 0.051319, -0.091023, -0.14628, -0.10337, -0.14065, 0.058121, 0.029632, -0.052519, 0.062544, 0.045122, 0.05249, 0.022872, 0.014605, -0.047062, -0.2059, 0.070351],
            [0.0049668, 0.025656, -0.17789, -0.0051996, -0.035828, -0.034248, -0.10105, 0.046928, 0.11832, 0.085108, 0.0062349, -0.041646, 0.015367, 0.024004, 0.05159, -0.054872, -0.046494, -0.052681, 0.026418, 0.04806],
            [0.057822, 0.0015819, -0.0086989, -0.10254, 0.025957, -0.056268, -0.10132, -0.10023, -0.11389, 0.058429, 0.015547, -0.071095, 0.062314, 0.036858, -0.0011, 0.026105, 0.061097, 0.077304, -0.18756, 0.047389],
            [0.0013806, 0.02828, -0.2478, 0.092947, -0.038758, 0.0028008, 0.012529, 0.044697, 0.077377, 0.071988, 0.010779, -0.031046, 0.0010044, 0.0066662, -0.12623, -0.045084, -0.044808, 0.017776, 0.016228, 0.056646],
            [0.087439, 0.00080255, -0.0057786, 0.0027137, -0.00091803, 0.00011138, 0.00064189, -0.10812, 0.00033514, 0.0014623, -0.00028756, -0.059024, 0.0006845, 0.025379, -0.0033296, 0.027242, 2.5402e-05, 0.0016213, -0.13466, 0.0019404],
            [-0.0017221, 0.040749, -0.29341, 0.13778, -0.046612, 0.0056551, 0.032591, 0.0021294, 0.017016, 0.074246, -0.014601, 0.0011625, 0.034755, -0.00049985, -0.16906, -0.00053653, 0.0012898, 0.082323, 0.0026522, 0.09852],
            [0.057723, -0.00046713, -0.0010648, 0.10612, -0.027463, 0.056335, 0.10173, -0.10192, 0.11685, -0.055549, -0.01511, -0.069818, -0.062226, 0.036567, -0.0038711, 0.02786, -0.062814, -0.076544, -0.18805, -0.045122],
            [-0.0036563, 0.02832, -0.24795, 0.088838, -0.037706, 0.00058311, 0.0085301, -0.040715, 0.072832, 0.074233, 0.011382, 0.033821, 0.0034572, -0.0081124, -0.12617, 0.044021, -0.042368, 0.020806, -0.0088305, 0.058468],
            [0.066328, 0.00050249, 0.0006879, 0.099053, -0.027081, 0.043963, 0.085986, -0.064402, 0.11345, -0.045255, -0.0033627, -0.065527, -0.065674, -0.020838, 0.024403, 0.015466, -0.049327, -0.099549, -0.11056, -0.052035],
            [-0.0034585, 0.08173, 0.042051, -0.20674, -0.019187, -0.017709, -0.062969, -0.020673, 0.1043, 0.0046453, 0.0023477, 0.04001, -0.060975, 0.0036578, -0.017463, 0.02278, 0.078178, 0.099432, -0.0024519, -0.126],
            [0.097129, 0.0021092, 0.0011488, -0.0036647, -0.00020402, -0.00029506, 0.0001578, -0.08265, 0.0016066, -0.00015594, -5.4728e-05, -0.048474, -0.0013576, -0.037546, -0.0016562, 0.026719, 0.0026343, 0.0026627, -0.042088, -0.0029948],
            [-0.001913, 0.10709, 0.058329, -0.18607, -0.010359, -0.014982, 0.0080122, 0.0016278, 0.081574, -0.0079178, -0.0027788, 0.00095469, -0.068929, 0.00073948, -0.08409, -0.00052623, 0.13375, 0.13519, 0.00082892, -0.15206],
            [0.066413, 0.002716, 0.00096838, -0.10712, 0.026305, -0.044627, -0.088399, -0.063538, -0.10925, 0.045403, 0.0034526, -0.067051, 0.063222, -0.020966, -0.025072, 0.014557, 0.052367, 0.10339, -0.11038, 0.047034],
            [0.00084414, 0.081687, 0.042045, -0.20268, -0.020238, -0.015965, -0.059534, 0.023193, 0.10869, 0.0028598, 0.0022134, -0.037398, -0.063514, -0.0028345, -0.016489, -0.023372, 0.076175, 0.095435, 0.0068033, -0.12795],
            [0.20704, 0.0040955, 0.00091829, -0.00029318, -0.00055128, -0.00022805, 0.0051995, -0.007065, -0.0025938, -0.00022702, -0.00086173, 0.0039241, 0.0027605, -0.18349, -0.00045015, -0.021589, 0.00096281, -0.00018548, 0.23464, 0.001533],
            [-0.0040776, 0.20795, 0.046625, -0.014886, -0.027991, -0.011579, 0.264, 0.00013915, -0.1317, -0.011527, -0.043754, -7.7284e-05, 0.14016, 0.0036138, -0.022856, 0.00042519, 0.048886, -0.0094174, -0.0046213, 0.077836],
            [0.0016001, -0.029891, -0.0731, -0.058468, 0.1186, 0.12935, 0.032158, 0.082573, -0.0411, -0.0057089, -0.11638, -0.00536, 0.0098026, 0.099419, -0.049008, 0.096627, 0.019637, -0.043652, 0.0051687, 0.0072429],
            [-0.0084656, -0.0046796, 0.045349, 0.07574, -0.034638, 0.082185, -0.12097, 0.11907, -0.077533, -0.078919, -0.012654, -0.1158, -0.086081, 0.014701, -0.0022791, -0.072634, 0.13958, -0.08019, 0.0020189, 0.12988],
            [0.014244, -0.0142, -0.056192, -0.043173, 0.080962, 0.084431, 0.022293, 0.081954, 0.02152, 0.023645, -0.069978, 0.010578, 0.0055638, 0.10754, 0.047817, 0.10989, -0.10152, -0.038776, 0.0098529, -0.1048],
            [-0.0019268, 0.0089254, 0.038396, 0.072665, -0.035316, 0.085966, -0.095828, 0.067001, -0.079359, -0.060241, 0.02296, -0.082724, -0.073347, 0.034409, -0.038908, -0.046993, 0.098013, -0.061029, 0.00076322, 0.10757],
            [0.0059814, -0.019987, -0.05216, -0.04447, 0.076646, 0.092444, 0.004678, 0.10415, 0.0046581, 0.0051388, -0.096442, 0.0059707, -0.0081662, 0.083068, 0.047686, 0.097271, -0.082539, -0.026822, 0.0086197, -0.097325],
            [-0.0021943, 0.014673, 0.029772, 0.032615, -0.070295, 0.11259, -0.099269, 0.067977, -0.030442, -0.007886, 0.04335, -0.085123, -0.024236, 0.010448, 0.034458, -0.043729, -0.1042, 0.051653, -0.0020921, -0.13234],
            [-0.004206, -0.036745, -0.07115, -0.055276, 0.11733, 0.12551, 0.026702, 0.098002, -0.032058, -0.004739, -0.10681, 0.00206, 0.030173, 0.081617, -0.060518, 0.076499, 0.010561, -0.048468, 0.0058355, -0.010407],
            [-0.0044632, -0.00045295, 0.035713, 0.033808, -0.072124, 0.10251, -0.12265, 0.11181, -0.025714, -0.01886, 0.019241, -0.11285, -0.030121, 0.016747, 0.051984, -0.066147, -0.080512, 0.05543, -0.0091079, -0.1189],
            [0.0019322, 0.029684, 0.074829, 0.061405, -0.11987, -0.12601, -0.036896, 0.077821, 0.038016, 0.0025971, 0.11579, -0.0007963, -0.013184, 0.098763, 0.04888, 0.099412, -0.014125, 0.04046, 0.0050852, -0.0021232],
            [0.008396, -0.0058529, 0.042436, 0.073379, -0.029941, 0.087214, -0.11961, -0.12223, -0.079091, -0.079083, -0.017226, 0.11592, -0.085628, -0.018604, -0.004207, 0.068773, 0.14025, -0.081846, -0.0022209, 0.13007],
            [0.014309, 0.014541, 0.05766, 0.046001, -0.08229, -0.08098, -0.026049, 0.079252, -0.024628, -0.025998, 0.070828, 0.013827, -0.0084475, 0.1061, -0.049312, 0.11165, 0.1053, 0.036343, 0.0098152, 0.10895],
            [0.0013644, 0.0083593, 0.036153, 0.070909, -0.032101, 0.089224, -0.094876, -0.070176, -0.07845, -0.059264, 0.020187, 0.082243, -0.073071, -0.038616, -0.036995, 0.04263, 0.093939, -0.062508, -0.0011506, 0.10336],
            [0.0060632, 0.020549, 0.053291, 0.04572, -0.079355, -0.087939, -0.0085831, 0.1014, -0.0058532, -0.0054453, 0.098074, 0.0093178, 0.0072056, 0.082593, -0.046292, 0.098917, 0.078372, 0.028835, 0.0086953, 0.092038],
            [0.0019571, 0.013874, 0.027695, 0.030838, -0.067223, 0.11615, -0.099008, -0.072025, -0.030235, -0.0076776, 0.039519, 0.084822, -0.024539, -0.013711, 0.036309, 0.039865, -0.10737, 0.050557, 0.0017511, -0.13607],
            [-0.004027, 0.036698, 0.072501, 0.056564, -0.12008, -0.12138, -0.031511, 0.093524, 0.031021, 0.0039927, 0.10749, 0.0065019, -0.031336, 0.080895, 0.062517, 0.079044, -0.013723, 0.050613, 0.0061896, 0.0057174],
            [0.0046253, -0.0018994, 0.032883, 0.031605, -0.067448, 0.10737, -0.1215, -0.11558, -0.026956, -0.019032, 0.01502, 0.11268, -0.02891, -0.019948, 0.04956, 0.063084, -0.080034, 0.053478, 0.0088711, -0.11922]
          ],
          "numEvalues": 20,
          "eigenValues": [
            448.26,
            152.88,
            77.079,
            38.34,
            27.754,
            15.293,
            13.086,
            10.197,
            7.2365,
            6.5965,
            5.7389,
            5.6223,
            4.6227,
            4.3931,
            3.9714,
            3.5791,
            3.4264,
            3.0788,
            2.6396,
            2.4414
          ],
          "numPtsPerSample": 71,
          "nonRegularizedVectors": [0],
          "meanShape": [
            [25.011, 34.815],
            [24.382, 45.627],
            [25.831, 56.165],
            [28.675, 66.696],
            [33.598, 75.549],
            [40.333, 82.562],
            [48.359, 88],
            [57.764, 89.783],
            [67.091, 87.631],
            [74.897, 81.881],
            [81.35, 74.609],
            [85.921, 65.568],
            [88.348, 54.934],
            [89.382, 44.347],
            [88.327, 33.568],
            [81.567, 27.445],
            [76.62, 25.173],
            [69.154, 25.747],
            [63.337, 27.341],
            [31.525, 28.43],
            [36.379, 25.966],
            [43.862, 26.245],
            [49.736, 27.609],
            [35.982, 35.443],
            [41.743, 32.491],
            [48.057, 35.383],
            [41.828, 37.011],
            [41.961, 34.611],
            [77.389, 34.628],
            [71.516, 31.905],
            [65.321, 35.043],
            [71.61, 36.424],
            [71.382, 34.031],
            [56.646, 33.009],
            [50.194, 46.941],
            [47.457, 51.771],
            [50.073, 55.035],
            [57.101, 56.145],
            [64.081, 54.759],
            [66.566, 51.395],
            [63.641, 46.676],
            [56.826, 42.172],
            [52.142, 53.256],
            [61.943, 53.063],
            [45.091, 66.457],
            [49.307, 63.536],
            [54.022, 62.36],
            [57.236, 62.972],
            [60.423, 62.234],
            [65.181, 63.223],
            [69.509, 65.977],
            [66.693, 69.861],
            [62.797, 72.43],
            [57.439, 73.279],
            [52.051, 72.642],
            [48.057, 70.228],
            [51.313, 68.335],
            [57.355, 69.042],
            [63.365, 68.097],
            [63.303, 65.106],
            [57.283, 65.373],
            [51.258, 65.343],
            [56.997, 50.867],
            [38.345, 33.38],
            [45.432, 33.213],
            [45.103, 36.388],
            [38.617, 36.562],
            [74.947, 32.659],
            [67.858, 32.771],
            [68.312, 35.931],
            [74.8, 35.849]
          ]
        },
        "hints": {
          "rightEye": [71.382, 34.031],
          "leftEye": [41.961, 34.611],
          "nose": [56.997, 50.867]
        }
      };

      // CommonJS and Node.js module support
      {
        // Support Node.js specific `module.exports` (which can be a function)
        if ('object' !== 'undefined' && module.exports) {
          exports = module.exports = pModel;
        }
        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
        exports.pModel = pModel;
      }
    })(commonjsGlobal);
  });

// webgl setup tests

  /*
 * Test whether we can render to floating point texture
 */
  var canRenderToFloatTexture = function(webGLContext) {
    var renderingSupported = false;
    var gl = webGLContext;

    // setup the texture
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 2, 2, 0, gl.RGBA, gl.FLOAT, null);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);

    // setup the framebuffer
    var framebuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);

    // check the framebuffer
    var check = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    if (check == gl.FRAMEBUFFER_COMPLETE) {
      renderingSupported = true;
    }

    // cleanup
    gl.deleteTexture(texture);
    gl.deleteFramebuffer(framebuffer);
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);

    return renderingSupported
  };

  var version = "1.1.2";

  /**
   * clmtrackr library (https://www.github.com/auduno/clmtrackr/)
   *
   * Copyright (c) 2013, Audun Mathias Øygard
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   */

//import { drawPatches } from './utils.debugging.js';

  var DEFAULT_MODEL = model_pca_20_svm;

// polyfills
  raf_1.polyfill();
  if (!window.Promise) window.Promise = promise;

  var clm = {
    tracker : function(params) {

      if (!params) params = {};
      if (params.constantVelocity === undefined) params.constantVelocity = true;
      if (params.searchWindow === undefined) params.searchWindow = 11;
      if (params.useWebGL === undefined) params.useWebGL = true;
      if (params.scoreThreshold === undefined) params.scoreThreshold = 0.5;
      if (params.stopOnConvergence === undefined) params.stopOnConvergence = false;
      if (params.weightPoints === undefined) params.weightPoints = undefined;
      if (params.sharpenResponse === undefined) params.sharpenResponse = false;
      if (params.faceDetection === undefined) params.faceDetection = {};
      if (params.eventDispatcher === undefined) params.eventDispatcher = document;
      if (params.maxIterationsPerAnimFrame === undefined) params.maxIterationsPerAnimFrame = 3;

      /** @type {Number} Minimum convergence before firing `clmtrackrConverged` event. */
      var convergenceThreshold = 0.5;

      var numPatches, patchSize, numParameters, patchType;
      var gaussianPD;
      var eigenVectors, eigenValues;
      var sketchCC, sketchW, sketchH, sketchCanvas;
      var weights, model, biases;

      var sobelInit = false;
      var lbpInit = false;

      var currentParameters = [];
      var currentPositions = [];
      var previousParameters = [];
      var previousPositions = [];

      var patches = [];
      var responses = [];
      var meanShape = [];

      var responseMode = 'single';
      var responseList = ['raw'];
      var responseIndex = 0;

      /*
		It's possible to experiment with the sequence of variances used for the finding the maximum in the KDE.
		This sequence is pretty arbitrary, but was found to be okay using some manual testing.
		*/
      var varianceSeq = [10,5,1];
      //var varianceSeq = [3,1.5,0.75];
      //var varianceSeq = [6,3,0.75];
      var PDMVariance = 0.7;

      var relaxation = 0.1;

      var first = true;
      var detectingFace = false;

      var convergenceLimit = 0.01;

      var searchWindow;
      var modelWidth, modelHeight;
      var halfSearchWindow, vecProbs, responsePixels;

      if(typeof Float64Array !== 'undefined') {
        var updatePosition = new Float64Array(2);
        var vecpos = new Float64Array(2);
      } else {
        var updatePosition = new Array(2);
        var vecpos = new Array(2);
      }
      var pw, pl, pdataLength;

      var facecheck_count = 0;

      var webglFi, svmFi, mosseCalc;

      var scoringCanvas = document.createElement('canvas');
      var scoringContext = scoringCanvas.getContext('2d');
      var msxmin, msymin, msxmax, msymax;
      var msmodelwidth, msmodelheight;
      var scoringWeights, scoringBias;
      var scoringHistory = [];
      var meanscore = 0;

      var runnerTimeout, runnerElement, runnerBox;

      var pointWeights;

      var halfPI = Math.PI/2;

      var faceDetector;

      /*
		 *	load model data, initialize filters, etc.
		 *
		 *	@param	<Object>	pdm model object
		 */
      this.init = function(pdmmodel) {
        // default model is pca 20 svm model
        if (pdmmodel === undefined) pdmmodel = DEFAULT_MODEL;

        model = pdmmodel;

        // load from model
        patchType = model.patchModel.patchType;
        numPatches = model.patchModel.numPatches;
        patchSize = model.patchModel.patchSize[0];
        if (patchType == 'MOSSE') {
          searchWindow = patchSize;
        } else {
          searchWindow = params.searchWindow;
        }
        numParameters = model.shapeModel.numEvalues;
        modelWidth = model.patchModel.canvasSize[0];
        modelHeight = model.patchModel.canvasSize[1];

        // set up canvas to work on
        sketchCanvas = document.createElement('canvas');
        sketchCC = sketchCanvas.getContext('2d');

        sketchW = sketchCanvas.width = modelWidth + (searchWindow-1) + patchSize-1;
        sketchH = sketchCanvas.height = modelHeight + (searchWindow-1) + patchSize-1;

        // load eigenvectors
        eigenVectors = numeric1_2_6.rep([numPatches*2,numParameters],0.0);
        for (var i = 0;i < numPatches*2;i++) {
          for (var j = 0;j < numParameters;j++) {
            eigenVectors[i][j] = model.shapeModel.eigenVectors[i][j];
          }
        }

        // load mean shape
        for (var i = 0; i < numPatches;i++) {
          meanShape[i] = [model.shapeModel.meanShape[i][0], model.shapeModel.meanShape[i][1]];
        }

        // get max and mins, width and height of meanshape
        msxmax = msymax = 0;
        msxmin = msymin = 1000000;
        for (var i = 0;i < numPatches;i++) {
          if (meanShape[i][0] < msxmin) msxmin = meanShape[i][0];
          if (meanShape[i][1] < msymin) msymin = meanShape[i][1];
          if (meanShape[i][0] > msxmax) msxmax = meanShape[i][0];
          if (meanShape[i][1] > msymax) msymax = meanShape[i][1];
        }
        msmodelwidth = msxmax-msxmin;
        msmodelheight = msymax-msymin;

        // get scoringweights if they exist
        if (model.scoring) {
          scoringWeights = new Float64Array(model.scoring.coef);
          scoringBias = model.scoring.bias;
          scoringCanvas.width = model.scoring.size[0];
          scoringCanvas.height = model.scoring.size[1];
        }

        // load eigenvalues
        eigenValues = model.shapeModel.eigenValues;

        weights = model.patchModel.weights;
        biases = model.patchModel.bias;

        // precalculate gaussianPriorDiagonal
        gaussianPD = numeric1_2_6.rep([numParameters+4, numParameters+4],0);
        // set values and append manual inverse
        for (var i = 0;i < numParameters;i++) {
          if (model.shapeModel.nonRegularizedVectors.indexOf(i) >= 0) {
            gaussianPD[i+4][i+4] = 1/10000000;
          } else {
            gaussianPD[i+4][i+4] = 1/eigenValues[i];
          }
        }

        for (var i = 0;i < numParameters+4;i++) {
          currentParameters[i] = 0;
        }

        if (patchType == 'SVM') {
          var webGLContext;
          var webGLTestCanvas = document.createElement('canvas');
          if (window.WebGLRenderingContext) {
            webGLContext = webGLTestCanvas.getContext('webgl') || webGLTestCanvas.getContext('experimental-webgl');
            if (!webGLContext || !webGLContext.getExtension('OES_texture_float')) {
              webGLContext = null;
            } else {
              // test whether it's possible to render to float texture
              if (!canRenderToFloatTexture(webGLContext)) {
                webGLContext = null;
              }
            }
          }

          if (webGLContext && params.useWebGL && (typeof(webglFilter) !== 'undefined')) {
            webglFi = new webglFilter();
            try {
              webglFi.init(weights, biases, numPatches, searchWindow+patchSize-1, searchWindow+patchSize-1, patchSize, patchSize);
              if ('lbp' in weights) lbpInit = true;
              if ('sobel' in weights) sobelInit = true;
            }
            catch(err) {
              console.error(err);
              alert('There was a problem setting up webGL programs, falling back to slightly slower javascript version. :(');
              webglFi = undefined;
              svmFi = new svmFilter();
              svmFi.init(weights['raw'], biases['raw'], numPatches, patchSize, searchWindow);
            }
          } else if (typeof(svmFilter) !== 'undefined') {
            // use fft convolution if no webGL is available
            svmFi = new svmFilter();
            svmFi.init(weights['raw'], biases['raw'], numPatches, patchSize, searchWindow);
          } else {
            throw new Error('Could not initiate filters, please make sure that svmfilter.js or svmfilter_conv_js.js is loaded.');
          }
        } else if (patchType == 'MOSSE') {
          mosseCalc = new mosseFilterResponses();
          mosseCalc.init(weights, numPatches, patchSize, patchSize);
        }

        if (patchType == 'SVM') {
          pw = pl = patchSize+searchWindow-1;
        } else {
          pw = pl = searchWindow;
        }
        pdataLength = pw*pl;
        halfSearchWindow = (searchWindow-1)/2;
        responsePixels = searchWindow*searchWindow;
        if(typeof Float64Array !== 'undefined') {
          vecProbs = new Float64Array(responsePixels);
          for (var i = 0;i < numPatches;i++) {
            patches[i] = new Float64Array(pdataLength);
          }
        } else {
          vecProbs = new Array(responsePixels);
          for (var i = 0;i < numPatches;i++) {
            patches[i] = new Array(pdataLength);
          }
        }

        if (params.weightPoints) {
          // weighting of points
          pointWeights = [];
          for (var i = 0;i < numPatches;i++) {
            if (i in params.weightPoints) {
              pointWeights[(i*2)] = params.weightPoints[i];
              pointWeights[(i*2)+1] = params.weightPoints[i];
            } else {
              pointWeights[(i*2)] = 1;
              pointWeights[(i*2)+1] = 1;
            }
          }
          pointWeights = numeric1_2_6.diag(pointWeights);
        }

        faceDetector = new faceDetection(model, params.faceDetection);
      };

      /*
		 *	starts the tracker to run on a regular interval
		 */
      this.start = function(element, box) {
        // check if model is initalized, else return false
        if (typeof(model) === 'undefined') {
          console.log('tracker needs to be initalized before starting to track.');
          return false;
        }
        //check if a runnerelement already exists, if not, use passed parameters
        if (typeof(runnerElement) === 'undefined') {
          runnerElement = element;
          runnerBox = box;
        }

        faceDetector.init(element);

        // start named timeout function
        runnerTimeout = requestAnimationFrame(runnerFunction);
      };

      var runnerFunction = function() {
        runnerTimeout = requestAnimationFrame(runnerFunction);
        // schedule as many iterations as we can during each request
        var startTime = (new Date()).getTime();
        var run_counter = 0;

        while ((((new Date()).getTime() - startTime) < 16)
        && run_counter < params.maxIterationsPerAnimFrame) {
          var tracking = this.track(runnerElement, runnerBox);
          if (!tracking) break;
          run_counter++;
        }
      }.bind(this);

      /*
		 *	stop the running tracker
		 */
      this.stop = function() {
        // stop the running tracker if any exists
        cancelAnimationFrame(runnerTimeout);
      };

      /*
		 *  element : canvas or video element
		 *  TODO: should be able to take img element as well
		 */
      this.track = function(element, box) {
        emitEvent('clmtrackrBeforeTrack', params.eventDispatcher);

        var scaling, translateX, translateY, rotation;
        var ptch, px, py;

        if (first) {
          if (!detectingFace) {
            detectingFace = true;

            // this returns a Promise
            faceDetector.getInitialPosition(box)
              .then(function (result) {
                scaling = result[0];
                rotation = result[1];
                translateX = result[2];
                translateY = result[3];

                currentParameters[0] = (scaling*Math.cos(rotation))-1;
                currentParameters[1] = (scaling*Math.sin(rotation));
                currentParameters[2] = translateX;
                currentParameters[3] = translateY;

                currentPositions = calculatePositions(currentParameters, true);

                first = false;
                detectingFace = false;
              })
              .catch(function (error) {
                // send an event on no face found
                emitEvent('clmtrackrNotFound', params.eventDispatcher);

                detectingFace = false;
              });
          }

          return false;
        } else {
          facecheck_count += 1;

          if (params.constantVelocity) {
            // calculate where to get patches via constant velocity prediction
            if (previousParameters.length >= 2) {
              for (var i = 0;i < currentParameters.length;i++) {
                currentParameters[i] = (relaxation)*previousParameters[1][i] + (1-relaxation)*((2*previousParameters[1][i]) - previousParameters[0][i]);
                //currentParameters[i] = (3*previousParameters[2][i]) - (3*previousParameters[1][i]) + previousParameters[0][i];
              }
            }
          }

          // change translation, rotation and scale parameters
          rotation = halfPI - Math.atan((currentParameters[0]+1)/currentParameters[1]);
          if (rotation > halfPI) {
            rotation -= Math.PI;
          }
          scaling = currentParameters[1] / Math.sin(rotation);
          translateX = currentParameters[2];
          translateY = currentParameters[3];
        }

        // copy canvas to a new dirty canvas
        sketchCC.save();

        // clear canvas
        sketchCC.clearRect(0, 0, sketchW, sketchH);

        sketchCC.scale(1/scaling, 1/scaling);
        sketchCC.rotate(-rotation);
        sketchCC.translate(-translateX, -translateY);

        sketchCC.drawImage(element, 0, 0, element.width, element.height);

        sketchCC.restore();
        //	get cropped images around new points based on model parameters (not scaled and translated)
        var patchPositions = calculatePositions(currentParameters, false);

        // check whether tracking is ok
        if (scoringWeights && (facecheck_count % 10 == 0)) {
          if (!checkTracking()) {
            // reset all parameters
            resetParameters();

            // send event to signal that tracking was lost
            emitEvent('clmtrackrLost', params.eventDispatcher);

            return false;
          }
        }


        var pdata, pmatrix, grayscaleColor;
        for (var i = 0; i < numPatches; i++) {
          px = patchPositions[i][0]-(pw/2);
          py = patchPositions[i][1]-(pl/2);
          ptch = sketchCC.getImageData(Math.round(px), Math.round(py), pw, pl);
          pdata = ptch.data;

          // convert to grayscale
          pmatrix = patches[i];
          for (var j = 0;j < pdataLength;j++) {
            grayscaleColor = pdata[j*4]*0.3 + pdata[(j*4)+1]*0.59 + pdata[(j*4)+2]*0.11;
            pmatrix[j] = grayscaleColor;
          }
        }

        // draw weights for debugging
        //drawPatches(sketchCC, weights, patchSize, patchPositions, function(x) {return x*2000+127});

        // draw patches for debugging
        //drawPatches(sketchCC, patches, pw, patchPositions, false, [27,32,44,50]);

        if (patchType == 'SVM') {
          if (typeof(webglFi) !== 'undefined') {
            responses = getWebGLResponses(patches);
          } else if (typeof(svmFi) !== 'undefined') {
            responses = svmFi.getResponses(patches);
          } else {
            throw new Error('SVM-filters do not seem to be initiated properly.');
          }
        } else if (patchType == 'MOSSE') {
          responses = mosseCalc.getResponses(patches);
        }

        // option to increase sharpness of responses
        if (params.sharpenResponse) {
          for (var i = 0;i < numPatches;i++) {
            for (var j = 0;j < responses[i].length;j++) {
              responses[i][j] = Math.pow(responses[i][j], params.sharpenResponse);
            }
          }
        }

        // draw responses for debugging
        //drawPatches(sketchCC, responses, searchWindow, patchPositions, function(x) {return x*255});

        // iterate until convergence or max 10, 20 iterations?:
        var originalPositions = currentPositions;
        var jac;
        var meanshiftVectors = [];

        for (var i = 0; i < varianceSeq.length; i++) {

          // calculate jacobian
          jac = createJacobian(currentParameters, eigenVectors);

          // for debugging
          //var debugMVs = [];

          var opj0, opj1;

          for (var j = 0;j < numPatches;j++) {
            opj0 = originalPositions[j][0]-((searchWindow-1)*scaling/2);
            opj1 = originalPositions[j][1]-((searchWindow-1)*scaling/2);

            // calculate PI x gaussians
            var vpsum = gpopt(searchWindow, currentPositions[j], updatePosition, vecProbs, responses, opj0, opj1, j, varianceSeq[i], scaling);

            // calculate meanshift-vector
            gpopt2(searchWindow, vecpos, updatePosition, vecProbs, vpsum, opj0, opj1, scaling);
            //var debugMatrixMV = gpopt2(searchWindow, vecpos, updatePosition, vecProbs, vpsum, opj0, opj1);

            meanshiftVectors[j] = [vecpos[0] - currentPositions[j][0], vecpos[1] - currentPositions[j][1]];

            //debugMVs[j] = debugMatrixMV;
          }

          // draw meanshiftVector for debugging
          //drawPatches(sketchCC, debugMVs, searchWindow, patchPositions, function(x) {return x*255*500});

          var meanShiftVector = numeric1_2_6.rep([numPatches*2, 1],0.0);
          for (var k = 0;k < numPatches;k++) {
            meanShiftVector[k*2][0] = meanshiftVectors[k][0];
            meanShiftVector[(k*2)+1][0] = meanshiftVectors[k][1];
          }

          // compute pdm parameter update
          //var prior = numeric.mul(gaussianPD, PDMVariance);
          var prior = numeric1_2_6.mul(gaussianPD, varianceSeq[i]);
          var jtj;
          if (params.weightPoints) {
            jtj = numeric1_2_6.dot(numeric1_2_6.transpose(jac), numeric1_2_6.dot(pointWeights, jac));
          } else {
            jtj = numeric1_2_6.dot(numeric1_2_6.transpose(jac), jac);
          }
          var cpMatrix = numeric1_2_6.rep([numParameters+4, 1],0.0);
          for (var l = 0;l < (numParameters+4);l++) {
            cpMatrix[l][0] = currentParameters[l];
          }
          var priorP = numeric1_2_6.dot(prior, cpMatrix);
          var jtv;
          if (params.weightPoints) {
            jtv = numeric1_2_6.dot(numeric1_2_6.transpose(jac), numeric1_2_6.dot(pointWeights, meanShiftVector));
          } else {
            jtv = numeric1_2_6.dot(numeric1_2_6.transpose(jac), meanShiftVector);
          }
          var paramUpdateLeft = numeric1_2_6.add(prior, jtj);
          var paramUpdateRight = numeric1_2_6.sub(priorP, jtv);

          var paramUpdate = numeric1_2_6.dot(numeric1_2_6.inv(paramUpdateLeft), paramUpdateRight);
          //var paramUpdate = numeric.solve(paramUpdateLeft, paramUpdateRight, true);

          var oldPositions = currentPositions;

          // update estimated parameters
          for (var k = 0;k < numParameters+4;k++) {
            currentParameters[k] -= paramUpdate[k];
          }

          // clipping of parameters if they're too high
          var clip;
          for (var k = 0;k < numParameters;k++) {
            clip = Math.abs(3*Math.sqrt(eigenValues[k]));
            if (Math.abs(currentParameters[k+4]) > clip) {
              if (currentParameters[k+4] > 0) {
                currentParameters[k+4] = clip;
              } else {
                currentParameters[k+4] = -clip;
              }
            }

          }

          // update current coordinates
          currentPositions = calculatePositions(currentParameters, true);

          // check if converged
          // calculate norm of parameterdifference
          var positionNorm = 0;
          var pnsq_x, pnsq_y;
          for (var k = 0;k < currentPositions.length;k++) {
            pnsq_x = (currentPositions[k][0]-oldPositions[k][0]);
            pnsq_y = (currentPositions[k][1]-oldPositions[k][1]);
            positionNorm += ((pnsq_x*pnsq_x) + (pnsq_y*pnsq_y));
          }

          // if norm < limit, then break
          if (positionNorm < convergenceLimit) {
            break;
          }

        }

        if (params.constantVelocity) {
          // add current parameter to array of previous parameters
          previousParameters.push(currentParameters.slice());
          if (previousParameters.length == 3) {
            previousParameters.shift();
          }
        }

        // store positions, for checking convergence
        if (previousPositions.length == 10) {
          previousPositions.shift();
        }
        previousPositions.push(currentPositions.slice(0));

        // send an event on each iteration
        emitEvent('clmtrackrIteration', params.eventDispatcher);

        // we must get a score before we can say we've converged
        if (scoringHistory.length >= 5 && this.getConvergence() < convergenceThreshold) {
          if (params.stopOnConvergence) {
            this.stop();
          }

          emitEvent('clmtrackrConverged', params.eventDispatcher);
        }

        // return new points
        return currentPositions;
      };

      function resetParameters() {
        first = true;
        scoringHistory = [];
        previousParameters = [];
        currentPositions = [];
        previousPositions = [];
        for (var i = 0;i < currentParameters.length;i++) {
          currentParameters[i] = 0;
        }
      }

      /*
		 *	reset tracking, so that track() will start a new detection
		 */
      this.reset = function() {
        resetParameters();
        runnerElement = undefined;
        runnerBox = undefined;
      };

      /*
		 *	draw model on given canvas
		 */
      this.draw = function(canvas, pv, path) {
        // if no previous points, just draw in the middle of canvas

        var params;
        if (pv === undefined) {
          params = currentParameters.slice(0);
        } else {
          params = pv.slice(0);
        }

        var cc = canvas.getContext('2d');
        cc.fillStyle = 'rgb(200,200,200)';
        cc.strokeStyle = 'rgb(130,255,50)';
        //cc.lineWidth = 1;

        var paths;
        if (path === undefined) {
          paths = model.path.normal;
        } else {
          paths = model.path[path];
        }

        for (var i = 0;i < paths.length;i++) {
          if (typeof(paths[i]) == 'number') {
            drawPoint(cc, paths[i], params);
          } else {
            drawPath(cc, paths[i], params);
          }
        }
      };

      /*
		 * 	get the score of the current model fit
		 *	(based on svm of face according to current model)
		 */
      this.getScore = function() {
        return meanscore;
      };

      /*
		 *	calculate positions based on parameters
		 */
      this.calculatePositions = function(parameters) {
        return calculatePositions(parameters, true);
      };

      /*
		 *	get coordinates of current model fit
		 */
      this.getCurrentPosition = function() {
        if (first) {
          return false;
        } else {
          return currentPositions;
        }
      };

      /*
		 *	get parameters of current model fit
		 */
      this.getCurrentParameters = function() {
        return currentParameters;
      };

      /*
		 *	Get the average of recent model movements
		 *	Used for checking whether model fit has converged
		 */
      this.getConvergence = function() {
        if (previousPositions.length < 10) return 999999;

        var prevX = 0.0;
        var prevY = 0.0;
        var currX = 0.0;
        var currY = 0.0;

        // average 5 previous positions
        for (var i = 0;i < 5;i++) {
          for (var j = 0;j < numPatches;j++) {
            prevX += previousPositions[i][j][0];
            prevY += previousPositions[i][j][1];
          }
        }
        prevX /= 5;
        prevY /= 5;

        // average 5 positions before that
        for (var i = 5;i < 10;i++) {
          for (var j = 0;j < numPatches;j++) {
            currX += previousPositions[i][j][0];
            currY += previousPositions[i][j][1];
          }
        }
        currX /= 5;
        currY /= 5;

        // calculate difference
        var diffX = currX-prevX;
        var diffY = currY-prevY;
        var msavg = ((diffX*diffX) + (diffY*diffY));
        msavg /= previousPositions.length;
        return msavg;
      };

      /*
		 * Set response mode (only useful if webGL is available)
		 * mode : either "single", "blend" or "cycle"
		 * list : array of values "raw", "sobel", "lbp"
		 */
      this.setResponseMode = function(mode, list) {
        // clmtrackr must be initialized with model first
        if (typeof(model) === 'undefined') {
          console.log('Clmtrackr has not been initialized with a model yet. No changes made.');
          return;
        }
        // must check whether webGL or not
        if (typeof(webglFi) === 'undefined') {
          console.log('Responsemodes are only allowed when using webGL. In pure JS, only "raw" mode is available.');
          return;
        }
        if (['single', 'blend', 'cycle'].indexOf(mode) < 0) {
          console.log('Tried to set an unknown responsemode : "'+mode+'". No changes made.');
          return;
        }
        if (!(list instanceof Array)) {
          console.log('List in setResponseMode must be an array of strings! No changes made.');
          return;
        } else {
          for (var i = 0;i < list.length;i++) {
            if (['raw', 'sobel', 'lbp'].indexOf(list[i]) < 0) {
              console.log('Unknown element in responsemode list : "'+list[i]+'". No changes made.');
            }
            // check whether filters are initialized
            if (list[i] == 'sobel' && sobelInit == false) {
              console.log('The sobel filters have not been initialized! No changes made.');
            }
            if (list[i] == 'lbp' && lbpInit == false) {
              console.log('The LBP filters have not been initialized! No changes made.');
            }
          }
        }
        // reset index
        responseIndex = 0;
        responseMode = mode;
        responseList = list;
      };


      var getWebGLResponsesType = function(type, patches) {
        if (type == 'lbp') {
          return webglFi.getLBPResponses(patches);
        } else if (type == 'raw') {
          return webglFi.getRawResponses(patches);
        } else if (type == 'sobel') {
          return webglFi.getSobelResponses(patches);
        }
      };

      var getWebGLResponses = function(patches) {
        if (responseMode == 'single') {
          return getWebGLResponsesType(responseList[0], patches);
        } else if (responseMode == 'cycle') {
          var response = getWebGLResponsesType(responseList[responseIndex], patches);
          responseIndex++;
          if (responseIndex >= responseList.length) responseIndex = 0;
          return response;
        } else {
          // blend
          var responses = [];
          for (var i = 0;i < responseList.length;i++) {
            responses[i] = getWebGLResponsesType(responseList[i], patches);
          }
          var blendedResponses = [];
          var searchWindowSize = searchWindow * searchWindow;
          for (var i = 0;i < numPatches;i++) {
            var response = Array(searchWindowSize);
            for (var k = 0;k < searchWindowSize;k++) response[k] = 0;
            for (var j = 0;j < responseList.length;j++) {
              for (var k = 0;k < searchWindowSize;k++) {
                response[k] += (responses[j][i][k]/responseList.length);
              }
            }
            blendedResponses[i] = response;
          }
          return blendedResponses;
        }
      };

      // generates the jacobian matrix used for optimization calculations
      var createJacobian = function(parameters, eigenVectors) {

        var jacobian = numeric1_2_6.rep([2*numPatches, numParameters+4],0.0);
        var j0,j1;
        for (var i = 0;i < numPatches;i ++) {
          // 1
          j0 = meanShape[i][0];
          j1 = meanShape[i][1];
          for (var p = 0;p < numParameters;p++) {
            j0 += parameters[p+4]*eigenVectors[i*2][p];
            j1 += parameters[p+4]*eigenVectors[(i*2)+1][p];
          }
          jacobian[i*2][0] = j0;
          jacobian[(i*2)+1][0] = j1;
          // 2
          j0 = meanShape[i][1];
          j1 = meanShape[i][0];
          for (var p = 0;p < numParameters;p++) {
            j0 += parameters[p+4]*eigenVectors[(i*2)+1][p];
            j1 += parameters[p+4]*eigenVectors[i*2][p];
          }
          jacobian[i*2][1] = -j0;
          jacobian[(i*2)+1][1] = j1;
          // 3
          jacobian[i*2][2] = 1;
          jacobian[(i*2)+1][2] = 0;
          // 4
          jacobian[i*2][3] = 0;
          jacobian[(i*2)+1][3] = 1;
          // the rest
          for (var j = 0;j < numParameters;j++) {
            j0 = parameters[0]*eigenVectors[i*2][j] - parameters[1]*eigenVectors[(i*2)+1][j] + eigenVectors[i*2][j];
            j1 = parameters[0]*eigenVectors[(i*2)+1][j] + parameters[1]*eigenVectors[i*2][j] + eigenVectors[(i*2)+1][j];
            jacobian[i*2][j+4] = j0;
            jacobian[(i*2)+1][j+4] = j1;
          }
        }

        return jacobian;
      };

      // calculate positions from parameters
      var calculatePositions = function(parameters, useTransforms) {
        var x, y, a, b;
        var numParameters = parameters.length;
        var positions = [];
        for (var i = 0;i < numPatches;i++) {
          x = meanShape[i][0];
          y = meanShape[i][1];
          for (var j = 0;j < numParameters-4;j++) {
            x += model.shapeModel.eigenVectors[(i*2)][j]*parameters[j+4];
            y += model.shapeModel.eigenVectors[(i*2)+1][j]*parameters[j+4];
          }
          if (useTransforms) {
            a = parameters[0]*x - parameters[1]*y + parameters[2];
            b = parameters[0]*y + parameters[1]*x + parameters[3];
            x += a;
            y += b;
          }
          positions[i] = [x,y];
        }

        return positions;
      };

      // part one of meanshift calculation
      var gpopt = function(responseWidth, currentPositionsj, updatePosition, vecProbs, responses, opj0, opj1, j, variance, scaling) {
        var pos_idx = 0;
        var vpsum = 0;
        var dx, dy;
        for (var k = 0;k < responseWidth;k++) {
          updatePosition[1] = opj1+(k*scaling);
          for (var l = 0;l < responseWidth;l++) {
            updatePosition[0] = opj0+(l*scaling);

            dx = currentPositionsj[0] - updatePosition[0];
            dy = currentPositionsj[1] - updatePosition[1];
            vecProbs[pos_idx] = responses[j][pos_idx] * Math.exp(-0.5*((dx*dx)+(dy*dy))/(variance*scaling));

            vpsum += vecProbs[pos_idx];
            pos_idx++;
          }
        }

        return vpsum;
      };

      // part two of meanshift calculation
      var gpopt2 = function(responseWidth, vecpos, updatePosition, vecProbs, vpsum, opj0, opj1, scaling) {
        //for debugging
        //var vecmatrix = [];

        var pos_idx = 0;
        var vecsum = 0;
        vecpos[0] = 0;
        vecpos[1] = 0;
        for (var k = 0;k < responseWidth;k++) {
          updatePosition[1] = opj1+(k*scaling);
          for (var l = 0;l < responseWidth;l++) {
            updatePosition[0] = opj0+(l*scaling);
            vecsum = vecProbs[pos_idx]/vpsum;

            //vecmatrix[k*responseWidth + l] = vecsum;

            vecpos[0] += vecsum*updatePosition[0];
            vecpos[1] += vecsum*updatePosition[1];
            pos_idx++;
          }
        }
        //return vecmatrix;
      };

      // calculate score of current fit
      var checkTracking = function() {
        var trackingImgW = 20;
        var trackingImgH = 22;

        scoringContext.drawImage(sketchCanvas, Math.round(msxmin+(msmodelwidth/4.5)), Math.round(msymin-(msmodelheight/12)), Math.round(msmodelwidth-(msmodelwidth*2/4.5)), Math.round(msmodelheight-(msmodelheight/12)), 0, 0, trackingImgW, trackingImgH);
        // getImageData of canvas
        var imgData = scoringContext.getImageData(0,0,trackingImgW,trackingImgH);
        // convert data to grayscale
        var trackingImgSize = trackingImgW * trackingImgH;
        var scoringData = new Array(trackingImgSize);
        var scdata = imgData.data;
        var scmax = 0;
        for (var i = 0;i < trackingImgSize;i++) {
          scoringData[i] = scdata[i*4]*0.3 + scdata[(i*4)+1]*0.59 + scdata[(i*4)+2]*0.11;
          scoringData[i] = Math.log(scoringData[i]+1);
          if (scoringData[i] > scmax) scmax = scoringData[i];
        }

        if (scmax > 0) {
          // normalize & multiply by svmFilter
          var mean = 0;
          for (var i = 0;i < trackingImgSize;i++) {
            mean += scoringData[i];
          }
          mean /= trackingImgSize;
          var sd = 0;
          for (var i = 0;i < trackingImgSize;i++) {
            sd += (scoringData[i]-mean)*(scoringData[i]-mean);
          }
          sd /= trackingImgSize;
          sd = Math.sqrt(sd);

          var score = 0;
          for (var i = 0;i < trackingImgSize;i++) {
            scoringData[i] = (scoringData[i]-mean)/sd;
            score += (scoringData[i])*scoringWeights[i];
          }
          score += scoringBias;
          score = 1/(1+Math.exp(-score));

          if (scoringHistory.length == 5) {
            scoringHistory.shift();
          }
          scoringHistory.push(score);

          if (scoringHistory.length > 4) {
            // get average
            meanscore = 0;
            for (var i = 0;i < 5;i++) {
              meanscore += scoringHistory[i];
            }
            meanscore /= 5;
            // if below threshold, then reset (return false)
            if (meanscore < params.scoreThreshold) return false;
          }
        }
        return true;
      };

      // draw a parametrized line on a canvas
      var drawPath = function(canvasContext, path, dp) {
        canvasContext.beginPath();
        var i, x, y, a, b;
        for (var p = 0;p < path.length;p++) {
          i = path[p]*2;
          x = meanShape[i/2][0];
          y = meanShape[i/2][1];
          for (var j = 0;j < numParameters;j++) {
            x += model.shapeModel.eigenVectors[i][j]*dp[j+4];
            y += model.shapeModel.eigenVectors[i+1][j]*dp[j+4];
          }
          a = dp[0]*x - dp[1]*y + dp[2];
          b = dp[0]*y + dp[1]*x + dp[3];
          x += a;
          y += b;

          if (i == 0) {
            canvasContext.moveTo(x,y);
          } else {
            canvasContext.lineTo(x,y);
          }
        }
        canvasContext.moveTo(0,0);
        canvasContext.closePath();
        canvasContext.stroke();
      };

      // draw a point on a canvas
      function drawPoint(canvasContext, point, dp) {
        var i, x, y, a, b;
        i = point*2;
        x = meanShape[i/2][0];
        y = meanShape[i/2][1];
        for (var j = 0;j < numParameters;j++) {
          x += model.shapeModel.eigenVectors[i][j]*dp[j+4];
          y += model.shapeModel.eigenVectors[i+1][j]*dp[j+4];
        }
        a = dp[0]*x - dp[1]*y + dp[2];
        b = dp[0]*y + dp[1]*x + dp[3];
        x += a;
        y += b;
        canvasContext.beginPath();
        canvasContext.arc(x, y, 1, 0, Math.PI*2, true);
        canvasContext.closePath();
        canvasContext.fill();
      }

      return true;
    },
    version : version
  };

  return clm;

})));
/*
 * jQuery treetable Plugin 3.2.0
 * http://ludo.cubicphuse.nl/jquery-treetable
 *
 * Copyright 2013, Ludo van den Boom
 * Dual licensed under the MIT or GPL Version 2 licenses.
 */
(function($) {
  var Node, Tree, methods;

  Node = (function() {
    function Node(row, tree, settings) {
      var parentId;

      this.row = row;
      this.tree = tree;
      this.settings = settings;

      // TODO Ensure id/parentId is always a string (not int)
      this.id = this.row.data(this.settings.nodeIdAttr);

      // TODO Move this to a setParentId function?
      parentId = this.row.data(this.settings.parentIdAttr);
      if (parentId != null && parentId !== "") {
        this.parentId = parentId;
      }

      this.treeCell = $(this.row.children(this.settings.columnElType)[this.settings.column]);
      this.expander = $(this.settings.expanderTemplate);
      this.indenter = $(this.settings.indenterTemplate);
      this.children = [];
      this.initialized = false;
      this.treeCell.prepend(this.indenter);
    }

    Node.prototype.addChild = function(child) {
      return this.children.push(child);
    };

    Node.prototype.ancestors = function() {
      var ancestors, node;
      node = this;
      ancestors = [];
      while (node = node.parentNode()) {
        ancestors.push(node);
      }
      return ancestors;
    };

    Node.prototype.collapse = function() {
      if (this.collapsed()) {
        return this;
      }

      this.row.removeClass("expanded").addClass("collapsed");

      this._hideChildren();
      this.expander.attr("title", this.settings.stringExpand);

      if (this.initialized && this.settings.onNodeCollapse != null) {
        this.settings.onNodeCollapse.apply(this);
      }

      return this;
    };

    Node.prototype.collapsed = function() {
      return this.row.hasClass("collapsed");
    };

    // TODO destroy: remove event handlers, expander, indenter, etc.

    Node.prototype.expand = function() {
      if (this.expanded()) {
        return this;
      }

      this.row.removeClass("collapsed").addClass("expanded");

      if (this.initialized && this.settings.onNodeExpand != null) {
        this.settings.onNodeExpand.apply(this);
      }

      if ($(this.row).is(":visible")) {
        this._showChildren();
      }

      this.expander.attr("title", this.settings.stringCollapse);

      return this;
    };

    Node.prototype.expanded = function() {
      return this.row.hasClass("expanded");
    };

    Node.prototype.hide = function() {
      this._hideChildren();
      this.row.hide();
      return this;
    };

    Node.prototype.isBranchNode = function() {
      if(this.children.length > 0 || this.row.data(this.settings.branchAttr) === true) {
        return true;
      } else {
        return false;
      }
    };

    Node.prototype.updateBranchLeafClass = function(){
      this.row.removeClass('branch');
      this.row.removeClass('leaf');
      this.row.addClass(this.isBranchNode() ? 'branch' : 'leaf');
    };

    Node.prototype.level = function() {
      return this.ancestors().length;
    };

    Node.prototype.parentNode = function() {
      if (this.parentId != null) {
        return this.tree[this.parentId];
      } else {
        return null;
      }
    };

    Node.prototype.removeChild = function(child) {
      var i = $.inArray(child, this.children);
      return this.children.splice(i, 1)
    };

    Node.prototype.render = function() {
      var handler,
        settings = this.settings,
        target;

      if (settings.expandable === true && this.isBranchNode()) {
        handler = function(e) {
          $(this).parents("table").treetable("node", $(this).parents("tr").data(settings.nodeIdAttr)).toggle();
          return e.preventDefault();
        };

        this.indenter.html(this.expander);
        target = settings.clickableNodeNames === true ? this.treeCell : this.expander;

        target.off("click.treetable").on("click.treetable", handler);
        target.off("keydown.treetable").on("keydown.treetable", function(e) {
          if (e.keyCode == 13) {
            handler.apply(this, [e]);
          }
        });
      }

      this.indenter[0].style.paddingLeft = "" + (this.level() * settings.indent) + "px";

      return this;
    };

    Node.prototype.reveal = function() {
      if (this.parentId != null) {
        this.parentNode().reveal();
      }
      return this.expand();
    };

    Node.prototype.setParent = function(node) {
      if (this.parentId != null) {
        this.tree[this.parentId].removeChild(this);
      }
      this.parentId = node.id;
      this.row.data(this.settings.parentIdAttr, node.id);
      return node.addChild(this);
    };

    Node.prototype.show = function() {
      if (!this.initialized) {
        this._initialize();
      }
      this.row.show();
      if (this.expanded()) {
        this._showChildren();
      }
      return this;
    };

    Node.prototype.toggle = function() {
      if (this.expanded()) {
        this.collapse();
      } else {
        this.expand();
      }
      return this;
    };

    Node.prototype._hideChildren = function() {
      var child, _i, _len, _ref, _results;
      _ref = this.children;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        child = _ref[_i];
        _results.push(child.hide());
      }
      return _results;
    };

    Node.prototype._initialize = function() {
      var settings = this.settings;

      this.render();

      if (settings.expandable === true && settings.initialState === "collapsed") {
        this.collapse();
      } else {
        this.expand();
      }

      if (settings.onNodeInitialized != null) {
        settings.onNodeInitialized.apply(this);
      }

      return this.initialized = true;
    };

    Node.prototype._showChildren = function() {
      var child, _i, _len, _ref, _results;
      _ref = this.children;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        child = _ref[_i];
        _results.push(child.show());
      }
      return _results;
    };

    return Node;
  })();

  Tree = (function() {
    function Tree(table, settings) {
      this.table = table;
      this.settings = settings;
      this.tree = {};

      // Cache the nodes and roots in simple arrays for quick access/iteration
      this.nodes = [];
      this.roots = [];
    }

    Tree.prototype.collapseAll = function() {
      var node, _i, _len, _ref, _results;
      _ref = this.nodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        node = _ref[_i];
        _results.push(node.collapse());
      }
      return _results;
    };

    Tree.prototype.expandAll = function() {
      var node, _i, _len, _ref, _results;
      _ref = this.nodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        node = _ref[_i];
        _results.push(node.expand());
      }
      return _results;
    };

    Tree.prototype.findLastNode = function (node) {
      if (node.children.length > 0) {
        return this.findLastNode(node.children[node.children.length - 1]);
      } else {
        return node;
      }
    };

    Tree.prototype.loadRows = function(rows) {
      var node, row, i;

      if (rows != null) {
        for (i = 0; i < rows.length; i++) {
          row = $(rows[i]);

          if (row.data(this.settings.nodeIdAttr) != null) {
            node = new Node(row, this.tree, this.settings);
            this.nodes.push(node);
            this.tree[node.id] = node;

            if (node.parentId != null && this.tree[node.parentId]) {
              this.tree[node.parentId].addChild(node);
            } else {
              this.roots.push(node);
            }
          }
        }
      }

      for (i = 0; i < this.nodes.length; i++) {
        node = this.nodes[i].updateBranchLeafClass();
      }

      return this;
    };

    Tree.prototype.move = function(node, destination) {
      // Conditions:
      // 1: +node+ should not be inserted as a child of +node+ itself.
      // 2: +destination+ should not be the same as +node+'s current parent (this
      //    prevents +node+ from being moved to the same location where it already
      //    is).
      // 3: +node+ should not be inserted in a location in a branch if this would
      //    result in +node+ being an ancestor of itself.
      var nodeParent = node.parentNode();
      if (node !== destination && destination.id !== node.parentId && $.inArray(node, destination.ancestors()) === -1) {
        node.setParent(destination);
        this._moveRows(node, destination);

        // Re-render parentNode if this is its first child node, and therefore
        // doesn't have the expander yet.
        if (node.parentNode().children.length === 1) {
          node.parentNode().render();
        }
      }

      if(nodeParent){
        nodeParent.updateBranchLeafClass();
      }
      if(node.parentNode()){
        node.parentNode().updateBranchLeafClass();
      }
      node.updateBranchLeafClass();
      return this;
    };

    Tree.prototype.removeNode = function(node) {
      // Recursively remove all descendants of +node+
      this.unloadBranch(node);

      // Remove node from DOM (<tr>)
      node.row.remove();

      // Remove node from parent children list
      if (node.parentId != null) {
        node.parentNode().removeChild(node);
      }

      // Clean up Tree object (so Node objects are GC-ed)
      delete this.tree[node.id];
      this.nodes.splice($.inArray(node, this.nodes), 1);

      return this;
    }

    Tree.prototype.render = function() {
      var root, _i, _len, _ref;
      _ref = this.roots;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        root = _ref[_i];

        // Naming is confusing (show/render). I do not call render on node from
        // here.
        root.show();
      }
      return this;
    };

    Tree.prototype.sortBranch = function(node, sortFun) {
      // First sort internal array of children
      node.children.sort(sortFun);

      // Next render rows in correct order on page
      this._sortChildRows(node);

      return this;
    };

    Tree.prototype.unloadBranch = function(node) {
      // Use a copy of the children array to not have other functions interfere
      // with this function if they manipulate the children array
      // (eg removeNode).
      var children = node.children.slice(0),
        i;

      for (i = 0; i < children.length; i++) {
        this.removeNode(children[i]);
      }

      // Reset node's collection of children
      node.children = [];

      node.updateBranchLeafClass();

      return this;
    };

    Tree.prototype._moveRows = function(node, destination) {
      var children = node.children, i;

      node.row.insertAfter(destination.row);
      node.render();

      // Loop backwards through children to have them end up on UI in correct
      // order (see #112)
      for (i = children.length - 1; i >= 0; i--) {
        this._moveRows(children[i], node);
      }
    };

    // Special _moveRows case, move children to itself to force sorting
    Tree.prototype._sortChildRows = function(parentNode) {
      return this._moveRows(parentNode, parentNode);
    };

    return Tree;
  })();

  // jQuery Plugin
  methods = {
    init: function(options, force) {
      var settings;

      settings = $.extend({
        branchAttr: "ttBranch",
        clickableNodeNames: false,
        column: 0,
        columnElType: "td", // i.e. 'td', 'th' or 'td,th'
        expandable: false,
        expanderTemplate: "<a href='#'>&nbsp;</a>",
        indent: 19,
        indenterTemplate: "<span class='indenter'></span>",
        initialState: "collapsed",
        nodeIdAttr: "ttId", // maps to data-tt-id
        parentIdAttr: "ttParentId", // maps to data-tt-parent-id
        stringExpand: "Expand",
        stringCollapse: "Collapse",

        // Events
        onInitialized: null,
        onNodeCollapse: null,
        onNodeExpand: null,
        onNodeInitialized: null
      }, options);

      return this.each(function() {
        var el = $(this), tree;

        if (force || el.data("treetable") === undefined) {
          tree = new Tree(this, settings);
          tree.loadRows(this.rows).render();

          el.addClass("treetable").data("treetable", tree);

          if (settings.onInitialized != null) {
            settings.onInitialized.apply(tree);
          }
        }

        return el;
      });
    },

    destroy: function() {
      return this.each(function() {
        return $(this).removeData("treetable").removeClass("treetable");
      });
    },

    collapseAll: function() {
      this.data("treetable").collapseAll();
      return this;
    },

    collapseNode: function(id) {
      var node = this.data("treetable").tree[id];

      if (node) {
        node.collapse();
      } else {
        throw new Error("Unknown node '" + id + "'");
      }

      return this;
    },

    expandAll: function() {
      this.data("treetable").expandAll();
      return this;
    },

    expandNode: function(id) {
      var node = this.data("treetable").tree[id];
      if (node) {
        if (!node.initialized) {
          node._initialize();
        }

        node.expand();
      } else {
        throw new Error("Unknown node '" + id + "'");
      }

      return this;
    },

    loadBranch: function(node, rows) {
      var settings = this.data("treetable").settings,
        tree = this.data("treetable").tree;

      // TODO Switch to $.parseHTML
      rows = $(rows);

      if (node == null) { // Inserting new root nodes
        this.append(rows);
      } else {
        var lastNode = this.data("treetable").findLastNode(node);
        rows.insertAfter(lastNode.row);
      }

      this.data("treetable").loadRows(rows);

      // Make sure nodes are properly initialized
      rows.filter("tr").each(function() {
        tree[$(this).data(settings.nodeIdAttr)].show();
      });

      if (node != null) {
        // Re-render parent to ensure expander icon is shown (#79)
        node.render().expand();
      }

      return this;
    },

    move: function(nodeId, destinationId) {
      var destination, node;

      node = this.data("treetable").tree[nodeId];
      destination = this.data("treetable").tree[destinationId];
      this.data("treetable").move(node, destination);

      return this;
    },

    node: function(id) {
      return this.data("treetable").tree[id];
    },

    removeNode: function(id) {
      var node = this.data("treetable").tree[id];

      if (node) {
        this.data("treetable").removeNode(node);
      } else {
        throw new Error("Unknown node '" + id + "'");
      }

      return this;
    },

    reveal: function(id) {
      var node = this.data("treetable").tree[id];

      if (node) {
        node.reveal();
      } else {
        throw new Error("Unknown node '" + id + "'");
      }

      return this;
    },

    sortBranch: function(node, columnOrFunction) {
      var settings = this.data("treetable").settings,
        prepValue,
        sortFun;

      columnOrFunction = columnOrFunction || settings.column;
      sortFun = columnOrFunction;

      if ($.isNumeric(columnOrFunction)) {
        sortFun = function(a, b) {
          var extractValue, valA, valB;

          extractValue = function(node) {
            var val = node.row.find("td:eq(" + columnOrFunction + ")").text();
            // Ignore trailing/leading whitespace and use uppercase values for
            // case insensitive ordering
            return $.trim(val).toUpperCase();
          }

          valA = extractValue(a);
          valB = extractValue(b);

          if (valA < valB) return -1;
          if (valA > valB) return 1;
          return 0;
        };
      }

      this.data("treetable").sortBranch(node, sortFun);
      return this;
    },

    unloadBranch: function(node) {
      this.data("treetable").unloadBranch(node);
      return this;
    }
  };

  $.fn.treetable = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments);
    } else {
      return $.error("Method " + method + " does not exist on jQuery.treetable");
    }
  };

  // Expose classes to world
  this.TreeTable || (this.TreeTable = {});
  this.TreeTable.Node = Node;
  this.TreeTable.Tree = Tree;
})(jQuery);
/**
 * angular-treetable
 * @version v0.3.1 - 2014-12-07
 * @link http://github.com/garrettheel/angular-treetable
 * @author Garrett Heel (garrettheel@gmail.com)
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
!function () {
  "use strict";
  angular.module("ngTreetable", []).factory("ngTreetableParams", ["$log", function (a) {
    var b = function (b) {
      var c = this;
      this.getNodes = function () {
      }, this.getTemplate = function () {
      }, this.options = {}, this.refresh = function () {
      }, angular.isObject(b) && angular.forEach(b, function (b, d) {
        ["getNodes", "getTemplate", "options"].indexOf(d) > -1 ? c[d] = b : a.warn('ngTreetableParams - Ignoring unexpected property "' + d + '".')
      })
    };
    return b
  }]).controller("TreetableController", ["$scope", "$element", "$compile", "$templateCache", "$q", "$http", function (a, b, c, d, e, f) {
    var g = a.ttParams, h = b;
    a.compileElement = function (b, e, h) {
      var i = (g.getTemplate(b), f.get(g.getTemplate(b), {cache: d}).then(function (a) {
        return a.data
      }));
      return i.then(function (d) {
        var f = a.$parent.$new();
        return angular.extend(f, {node: b, parentNode: h}), f._ttParentId = e, c(d)(f).get(0)
      })
    }, a.addChildren = function (c, d) {
      var f = c ? c.scope().node : null, i = c ? c.data("ttId") : null;
      c && (c.scope().loading = !0), e.when(g.getNodes(f)).then(function (g) {
        var j = [];
        angular.forEach(g, function (b) {
          j.push(a.compileElement(b, i, f))
        }), e.all(j).then(function (e) {
          var f = null != i ? h.treetable("node", i) : null;
          b.treetable("loadBranch", f, e), d && angular.forEach(e, function (b) {
            a.addChildren($(b), d)
          }), c && (c.scope().loading = !1)
        })
      })
    }, a.onNodeExpand = function () {
      this.row.scope().loading || (h.treetable("unloadBranch", this), a.addChildren(this.row, a.shouldExpand()))
    }, a.onNodeCollapse = function () {
      this.row.scope().loading || h.treetable("unloadBranch", this)
    }, a.refresh = function () {
      for (var b = h.data("treetable").nodes; b.length > 0;) h.treetable("removeNode", b[0].id);
      a.addChildren(null, a.shouldExpand())
    }, g.refresh = a.refresh, a.getOptions = function () {
      var b = angular.extend({
        expandable: !0,
        onNodeExpand: a.onNodeExpand,
        onNodeCollapse: a.onNodeCollapse
      }, g.options);
      return g.options && angular.forEach(["onNodeCollapse", "onNodeExpand"], function (c) {
        g.options[c] && (b[c] = function () {
          a[c].apply(this, arguments), g.options[c].apply(this, arguments)
        })
      }), b
    }, a.shouldExpand = function () {
      return "expanded" === a.options.initialState
    }, a.options = a.getOptions(), h.treetable(a.options), a.addChildren(null, a.shouldExpand())
  }]).directive("ttTable", [function () {
    return {restrict: "AC", scope: {ttParams: "="}, controller: "TreetableController"}
  }]).directive("ttNode", [function () {
    var a = 0;
    return {
      restrict: "AC", scope: {isBranch: "=", parent: "="}, link: function (b, c) {
        var d = angular.isDefined(b.isBranch) ? b.isBranch : !0,
          e = angular.isDefined(b.parent) ? b.parent : b.$parent._ttParentId;
        c.attr("data-tt-id", a++), c.attr("data-tt-branch", d), c.attr("data-tt-parent-id", e)
      }
    }
  }])
}();
(function () {
  'use strict';
  angular
    .module('app.sidenav', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function SideNav($mdSidenav, $timeout, $compile, $http, $templateCache, $rootScope, $q, $controller) {

    var vm = this;

    var content = '<md-sidenav id="md-general-side-nav" class="md-sidenav-right"></md-sidenav>';

    var _constructor = function () {
      if (!vm.isInBody()) {
        vm.body = angular.element('body');
        vm.side = angular.element(content);
        vm.side.attr('md-component-id', 'md-general-side-nav');
        vm.side.attr('md-disable-close-events', true);
        vm.side.css({'width': vm.options.width, 'max-width': '1000px', 'min-width': '300px'});
        vm.scope = $rootScope.$new();
        angular.extend(vm.scope, []);

        vm.side = angular.element($compile(vm.side)(vm.scope));
        vm.body.prepend(vm.side);
        setSlideCloseCallBack();
      }
    };

    var setSlideCloseCallBack = function () {
      // Callback happens BEFORE the close action occurs.
      $mdSidenav(vm.side.attr('md-component-id'))
        .onClose(function () {
          $timeout(function () {
            vm.scope.$destroy();
            vm.side.remove();
          }, 500)
        });
    };


    /**
     * Executa abertura de side nav
     * @param url - Url do template html
     * @param controller - Nome do controlador
     * @param controllerAs - Alias do controlador
     * @param data - Dados extendidos
     */
    vm.open = function (url, controller, controllerAs, data) {
      var deferred = $q.defer();
      // Caching the template for future calls
      $http.get(url, {cache: $templateCache})

        .then(function (response) {
          // Wrapping the template with some extra markup
          vm.side.html(response.data);
          // The important part
          $compile(vm.side)(vm.scope);
          $controller(controller + ' as ' + controllerAs, {$scope: vm.scope, $element: vm.side, SideExtra: data}, data);

          $timeout(function () {
            $mdSidenav(vm.side.attr('md-component-id')).open()
              .then(function () {
                deferred.resolve(true);
              })
          });
        });
      return deferred.promise;
    };

    vm.close = function () {
      var deferred = $q.defer();
      $mdSidenav('sidenav-global').close();
      $mdSidenav(vm.side.attr('md-component-id')).close()
        .then(function () {
          vm.scope.$destroy();
          vm.side.remove();
          deferred.resolve(true);
        });
      return deferred.promise;
    };


    vm.isInBody = function () {
      return angular.element('#md-general-side-nav').length > 0;
    };

    /**
     * Configura as opções do serviço
     * @param options - (JSON)
     * @returns {{width: string}}
     */
    var setOptions = function (options) {
      return {
        width: angular.isUndefined(options) ? 'auto' : options.width
      }
    };


    return function (options) {
      vm.options = setOptions(options);
      _constructor();
      return vm;
    };
  }


  angular
    .module('app.sidenav')
    .factory('$a4Sidenav', SideNav);
})();

(function (){
  'use strict';

  /** @ngInject */
  function UploadImageService(Restangular) {

    var postImage = function () {
    };

    return {
      postImage: postImage
    };

  }

  angular
    .module('app.a4-upload-image')
    .factory('UploadImageService', UploadImageService);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4UploadImage() {

    /**
     * @param {array} items - Dados de listagem
     * @returns {}
     */
    return {
      restrict: 'EA',
      require: 'ngModel',
      controller: 'a4UploadImageController',
      controllerAs: 'vm',
      link: function (scope, element, attrs, ngModel) {

        element.bind('click', function () {
        });

      }
    }
  }

  angular
    .module('app.a4-upload-image')
    .directive('a4UploadImage', a4UploadImage)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4UploadImageController($scope, $mdDialog, ModalFactory, UploadImageService) {

    var vm = this;
    vm.myImage = '';
    vm.myCroppedImage = '';
    vm.base64 = '/assets/images/avatars/profile.jpg';

    vm.closeDialog = function () {
      $mdDialog.hide();
      vm.myImage = '';
      vm.myCroppedImage = '';
    };


    vm.editImage = function (ev) {
      ModalFactory.customClean(
        'app/components/a4-upload-image/view/modals/edit-image.html',
        /** @ngInject */
        function ($rootScope, $mdDialog, ModalExtra) {
          var vm = this;
          vm.base64 = '/assets/images/avatars/profile.jpg';

          vm.handleFileSelect = function (event) {
            var file = event.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function (event) {
              $scope.$apply(function ($scope) {
                vm.myImage = event.target.result;
              });
            };

            reader.readAsDataURL(file);
          };

          vm.selectImage = function (event) {
            vm.handleFileSelect(event);

          };
          vm.closeModal = function () {
            $rootScope.$broadcast('ModalFactory.close');
          };
        },
        'vm',
        false,
        {}
      );

      // $mdDialog.show({
      //   scope: $scope,
      //   preserveScope: true,
      //   controller: 'a4UploadImageController',
      //   templateUrl: 'app/components/a4-upload-image/view/modals/edit-image.html',
      //   parent: angular.element(document.body),
      //   clickOutsideToClose: true,
      //   fullscreen: false,
      //   bindToController: true,
      //   targetEvent: ev
      // }).then(function (answer) {
      //   $scope.status = 'You said the information was "' + answer + '".';
      // }, function () {
      //   $scope.status = 'You cancelled the dialog.';
      // });
    };

    vm.handleFileSelect = function (event) {
      var file = event.currentTarget.files[0];
      var reader = new FileReader();
      reader.onload = function (event) {
        $scope.$apply(function ($scope) {
          vm.myImage = event.target.result;
        });
      };

      reader.readAsDataURL(file);
    };

    vm.selectImage = function (event) {
      vm.handleFileSelect(event);

    };

    vm.uploadImage = function () {
      UploadImageService.postImage()
        .then(function () {
          //$mdDialog.hide();
        })
        .catch(function () {
        });
    }
  }

  angular
    .module('app.a4-upload-image')
    .controller('a4UploadImageController', a4UploadImageController);

})();

(function () {
    'use strict';

    angular
        .module('app.a4-upload-drag', []);
})();
(function () {
    'use strict';

    /** @ngInject */
    function a4UploadDrag($http, Common) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
          list: '=',
          title: '@?',
          extra: '=?'
        },
        templateUrl: 'app/components/a4-upload-drag/index.html',
        link: function(scope, element, attrs) {

            element.on('dragover', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });

            element.on('dragenter', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });

            element.on('drop', function(e) {
                e.preventDefault();
                e.stopPropagation();
                if (e.originalEvent.dataTransfer){
                    if (e.originalEvent.dataTransfer.files.length > 0) {
                        upload(e.originalEvent.dataTransfer.files);
                      Common.Toast.warning('Upload em processo..');
                      scope.showLoader = true;
                    }
                }
                return false;
            });

            var upload = function(files) {
                var data = new FormData();
                angular.forEach(files, function(value){
                    data.append(attrs.name, value);
                });

                data.append('extra', scope.extra);

                $http({
                    method: 'POST',
                    url: attrs.to,
                    data: data,
                    withCredentials: false,
                    headers: {'Content-Type': undefined },
                    transformRequest: angular.identity
                }).then(function (response) {
                  var headers = response.headers();
                  var status = response.status;
                  var data = response.data;

                  scope.showLoader = false;
                  Common.Toast.success('Upload realizado.');

                  if (attrs.name.indexOf('[]') > -1){
                    angular.forEach(data, function (item) {
                      scope.list.push(item);
                    });
                  }else{
                    scope.list = data;
                  }

                }, function (error) {

                });
            };

        }
    };

    }

    angular
        .module('app.a4-upload-drag')
        .directive('a4UploadDrag', a4UploadDrag)
})();
(function () {
    'use strict';
    angular
      .module('app.a4-ui-tree', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4UiTree() {
    return {
      restrict: 'EA',
      transclude: true,
      scope: {
        list: '=',
        template: '@',
        actions: '=?',
        actionsGroup: '=?',
        actionAdd: '&?',
        actionDelete: '&?',
        actionSelect: '&?',
        maxNodes: '=?',
        insertNodes: '=?',
        dragEnable: '=?',
        nodropEnable: '=?',
        cloneEnable: '=?',
        timeDelay: '=?',
        haveSearch: '=?',
        haveSubNodes: '=?',
        onlyGroup: '=?',
        changeName: '=?',
        onlyChildren: '=?'
      },
      templateUrl: 'app/components/a4-ui-tree/index.html',
      link: function (scope) {

        scope.init = function () {
          if (scope.insertNodes) {
            scope.allowInsertNodes(scope);
          }

          scope.options();

          if (angular.isDefined(scope.onlyGroup)) {
            scope.options(scope.onlyGroup);
          }

          if (angular.isDefined(scope.actionSelect)) {
            scope.Delay = 100;
          }

        };

        /**
         * Permite que o objeto possua filhos
         */
        scope.allowInsertNodes = function (scope) {
          angular.forEach(scope.list, function (item) {
            if (angular.isUndefined(item.nodes)) {
              item.nodes = [];
            }
          });
        };

        /**
         * Remoção do item
         * @param scope
         */
        scope.delete = function (scope) {
          if (angular.isDefined(scope.actionDelete)) {
            scope.rm(scope);
          } else {
            scope.remove();
          }
        };

        /**
         * Abre e fecha o item para
         * exibição dos subitens
         * @param scope
         */
        scope.toggle = function (scope) {
          scope.toggle();
        };

        /**
         * Movimento dos itens
         */
        scope.moveLastToTheBeginning = function () {
          var a = scope.data.pop();
          scope.data.splice(0, 0, a);
        };

        /**
         * Executa externamente o click do elemento
         * @param item
         */
        scope.nodeSelect = function (item) {
          if (angular.isDefined(scope.actionSelect)) {
            scope.actionSelect({item: item});
          }
        };

        /**
         * Executa externamente a remoção do elemento
         * @param item
         */
        scope.rm = function (item) {
          scope.actionDelete({item: item});
        };

        /**
         * Adição de um subitem
         * @param scope
         */
        scope.newSubItem = function (scope) {
          var nodeData = scope.$parent.$parent.$modelValue;
          var item = {};

          if (angular.isUndefined(scope.$parent.$parent.$modelValue.nodes)) {
            scope.$parent.$parent.$modelValue.nodes = [];
          }

          /** Verifica se há subitens */
          if (angular.isDefined(scope.haveSubNodes)) {
            if (!scope.haveSubNodes) {
              item = {
                id: nodeData.id * 10 + nodeData.nodes.length,
                name: nodeData.name + '.' + (nodeData.nodes.length + 1),
                parent: (angular.isDefined(nodeData.confirm_id)) ? nodeData.id : false,
                seq: nodeData.nodes.length
              };
            }
          } else {
            item = {
              id: nodeData.id * 10 + nodeData.nodes.length,
              name: nodeData.name + '.' + (nodeData.nodes.length + 1),
              parent: (angular.isDefined(nodeData.confirm_id)) ? nodeData.id : false,
              nodes: []
            };


          }

          /** Captura o evento de adição de subitens externamente */
          if (angular.isDefined(scope.actionAdd)) {
            scope.actionAdd({item: item});
          }

          /** Adiciona o subitem */
          nodeData.nodes.push(item);

        };


        /**
         * Tratamento dos eventos do componente
         */
        scope.options = function (value) {
          scope.treeOptions = {
            beforeDrop: function (e) {

              /**
               * Permite somente agrupar pelo valor definido
               */
              if (angular.isDefined(value)) {
                if (angular.isDefined(e.dest.nodesScope.$parent.$modelValue)) {
                  var srctype = e.source.cloneModel[value];
                  var dsttype = e.dest.nodesScope.$parent.$modelValue[value];
                  if (srctype === dsttype) {
                    return true;
                  }
                }
              }

              /**
               * Permite somente inserir filhos aos objetos existentes
               */
              if (scope.onlyChildren) {
                if (e.dest.nodesScope.$parent.$type !== "uiTreeNode") {
                  return false;
                }
              }

            },
            dragStart: function (event) {
              scope.nodeSelect(event.source.nodeScope.$modelValue);
            }

          };
        };


        /**
         * Objeto da busca
         */
        scope.findNodes = function (query) {
          scope.query = query;
        };

        /**
         * Exibe os itens da busca
         * @param item
         * @returns {boolean}
         */
        scope.visible = function (item) {
          return !(scope.query && scope.query.length > 0
          && item.name.indexOf(scope.query) === -1);
        };

        /**
         * Evento de fechamento de todos os itens
         * @param scope
         */
        scope.collapseAll = function () {
          scope.$broadcast('angular-ui-tree:collapse-all');
        };

        /**
         * Evento de abertura de todos os itens
         * @param scope
         */
        scope.expandAll = function () {
          scope.$broadcast('angular-ui-tree:expand-all');
        };

        scope.init();

      }
    }
  }

  angular
    .module('app.a4-ui-tree')
    .directive('a4UiTree', a4UiTree)
})();
(function () {
  angular
    .module('a4TreeGrid', [])
    .directive('compile', [
      '$compile',
      function ($compile) {
        return {
          restrict: 'A',
          link: function (scope, element, attrs) {
            scope.cellTemplateScope = scope.$eval(attrs.cellTemplateScope);

            // Watch for changes to expression.
            scope.$watch(attrs.compile, function (new_val) {
              /*
               * Compile creates a linking function
               * that can be used with any scope.
               */
              var link = $compile(new_val);

              /*
               * Executing the linking function
               * creates a new element.
               */
              var new_elem = link(scope);

              // Which we can then append to our DOM element.
              element.append(new_elem);
            });
          }
        };
      }])
    .directive('a4TreeGrid', [
      '$timeout',
      'treegridTemplate',
      function ($timeout,
                treegridTemplate) {

        return {
          restrict: 'E',
          templateUrl: function (tElement, tAttrs) {
            return tAttrs.templateUrl || treegridTemplate.getPath();
          },
          replace: true,
          scope: {
            treeData: '=',
            colDefs: '=',
            expandOn: '=',
            onSelect: '&',
            onClick: '&',
            initialSelection: '@',
            treeControl: '=',
            expandTo: '=',
            classSelected: '='
          },
          link: function (scope, element, attrs) {
            var error, expandingProperty, expand_all_parents, expand_level, for_all_ancestors, for_each_branch,
              get_parent, n, on_treeData_change, select_branch, selected_branch, tree;
            error = function (s) {
              debugger;
              return void 0;
            };

            attrs.iconExpand = attrs.iconExpand ? attrs.iconExpand : 'icon-plus';
            attrs.iconCollapse = attrs.iconCollapse ? attrs.iconCollapse : 'icon-minus';
            attrs.iconLeaf = attrs.iconLeaf ? attrs.iconLeaf : 'icon-file';
            attrs.sortedAsc = attrs.sortedAsc ? attrs.sortedAsc : 'icon-up';
            attrs.sortedDesc = attrs.sortedDesc ? attrs.sortedDesc : 'icon-down';
            attrs.expandLevel = attrs.expandLevel ? attrs.expandLevel : '0';
            expand_level = parseInt(attrs.expandLevel, 10);

            if (!scope.treeData) {
              alert('No data was defined for the tree, please define treeData!');
              return;
            }

            var getExpandingProperty = function getExpandingProperty() {
              if (attrs.expandOn) {
                expandingProperty = scope.expandOn;
                scope.expandingProperty = scope.expandOn;
              } else {
                if (scope.treeData.length) {
                  var _firstRow = scope.treeData[0],
                    _keys = Object.keys(_firstRow);
                  for (var i = 0, len = _keys.length; i < len; i++) {
                    if (typeof (_firstRow[_keys[i]]) === 'string') {
                      expandingProperty = _keys[i];
                      break;
                    }
                  }
                  if (!expandingProperty) expandingProperty = _keys[0];
                  scope.expandingProperty = expandingProperty;
                }
              }
            };

            getExpandingProperty();

            if (!attrs.colDefs) {
              if (scope.treeData.length) {
                var _col_defs = [],
                  _firstRow = scope.treeData[0],
                  _unwantedColumn = ['children', 'level', 'expanded', 'icons', expandingProperty];
                for (var idx in _firstRow) {
                  if (_unwantedColumn.indexOf(idx) === -1) {
                    _col_defs.push({
                      field: idx
                    });
                  }
                }
                scope.colDefinitions = _col_defs;
              }
            } else {
              scope.colDefinitions = scope.colDefs;
            }

            for_each_branch = function (f) {
              var do_f, root_branch, _i, _len, _ref, _results;
              do_f = function (branch, level) {
                var child, _i, _len, _ref, _results;
                f(branch, level);
                if (branch.children != null) {
                  _ref = branch.children;
                  _results = [];
                  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    child = _ref[_i];
                    _results.push(do_f(child, level + 1));
                  }
                  return _results;
                }
              };
              _ref = scope.treeData;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                root_branch = _ref[_i];
                _results.push(do_f(root_branch, 1));
              }
              return _results;
            };
            selected_branch = null;
            select_branch = function (branch) {
              if (!branch) {
                if (selected_branch != null) {
                  selected_branch.selected = false;
                }
                selected_branch = null;
                return;
              }
              if (branch !== selected_branch) {
                if (selected_branch != null) {
                  selected_branch.selected = false;
                }
                branch.selected = true;
                selected_branch = branch;
                expand_all_parents(branch);
                if (branch.onSelect != null) {
                  return $timeout(function () {
                    return branch.onSelect(branch);
                  });
                } else {
                  if (scope.onSelect != null) {
                    return $timeout(function () {
                      return scope.onSelect({
                        branch: branch
                      });
                    });
                  }
                }
              }
            };
            scope.on_user_click = function (branch) {
              if (scope.onClick) {
                scope.onClick({
                  branch: branch
                });
              }
            };
            scope.user_clicks_branch = function (branch) {
              if (branch !== selected_branch) {
                return select_branch(branch);
              }
            };

            /* sorting methods */
            scope.sortBy = function (col) {
              if (col.sortDirection === "asc") {
                sort_recursive(scope.treeData, col, true);
                col.sortDirection = "desc";
                col.sortingIcon = attrs.sortedDesc;
              } else {
                sort_recursive(scope.treeData, col, false);
                col.sortDirection = "asc";
                col.sortingIcon = attrs.sortedAsc;
              }
              col.sorted = true;
              resetSorting(col);
            };

            var sort_recursive = function (elements, col, descending) {
              elements.sort(sort_by(col, descending));
              for (var i = 0; i < elements.length; i++) {
                sort_recursive(elements[i].children, col, descending);
              }
            };

            var sort_by = function (col, descending) {

              var direction = !descending ? 1 : -1;

              if (col.sortingType === "custom" && typeof col.sortingFunc === "function") {
                return function (a, b) {
                  return col.sortingFunc(a, b) * direction;
                };
              }

              var key = function (x) {
                return (x[col.field] === null ? "" : x[col.field].toLowerCase());
              };

              switch (col.sortingType) {
                case "number":
                  key = function (x) {
                    return parseFloat(x[col.field]);
                  };
                  break;
                case "date":
                  key = function (x) {
                    return new Date(x[col.field]);
                  };
                  break;
              }

              return function (a, b) {
                return a = key(a), b = key(b), direction * ((a > b) - (b > a));
              };
            }

            var resetSorting = function (sortedCol) {
              var arraySize = scope.colDefinitions.length;
              for (var i = 0; i < arraySize; i++) {
                var col = scope.colDefinitions[i];
                if (col.field != sortedCol.field) {
                  col.sorted = false;
                  col.sortDirection = "none";
                }
              }
            }

            /* end of sorting methods */

            get_parent = function (child) {
              var parent;
              parent = void 0;
              if (child.parent_uid) {
                for_each_branch(function (b) {
                  if (b.uid === child.parent_uid) {
                    return parent = b;
                  }
                });
              }
              return parent;
            };
            for_all_ancestors = function (child, fn) {
              var parent;
              parent = get_parent(child);
              if (parent != null) {
                fn(parent);
                return for_all_ancestors(parent, fn);
              }
            };
            expand_all_parents = function (child) {
              return for_all_ancestors(child, function (b) {
                return b.expanded = true;
              });
            };

            scope.tree_rows = [];

            on_treeData_change = function () {
              getExpandingProperty();
              var add_branch_to_list, root_branch, _i, _len, _ref, _results;
              for_each_branch(function (b, level) {
                if (!b.uid) {
                  return b.uid = "" + Math.random();
                }
              });
              for_each_branch(function (b) {
                var child, _i, _len, _ref, _results;
                if (angular.isArray(b.children)) {
                  _ref = b.children;
                  _results = [];
                  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    child = _ref[_i];
                    _results.push(child.parent_uid = b.uid);
                  }
                  return _results;
                }
              });
              scope.tree_rows = [];
              for_each_branch(function (branch) {
                var child, f;
                if (branch.children) {
                  if (branch.children.length > 0) {
                    f = function (e) {
                      if (typeof e === 'string') {
                        return {
                          label: e,
                          children: []
                        };
                      } else {
                        return e;
                      }
                    };
                    return branch.children = (function () {
                      var _i, _len, _ref, _results;
                      _ref = branch.children;
                      _results = [];
                      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                        child = _ref[_i];
                        _results.push(f(child));
                      }
                      return _results;
                    })();
                  }
                } else {
                  return branch.children = [];
                }
              });
              add_branch_to_list = function (level, branch, visible) {
                var child, child_visible, tree_icon, _i, _len, _ref, _results;
                if (branch.expanded == null) {
                  branch.expanded = false;
                }
                if (!branch.children || branch.children.length === 0) {
                  tree_icon = branch.icons && branch.icons.iconLeaf || attrs.iconLeaf;
                } else {
                  if (branch.expanded) {
                    tree_icon = branch.icons && branch.icons.iconCollapse || attrs.iconCollapse;
                  } else {
                    tree_icon = branch.icons && branch.icons.iconExpand || attrs.iconExpand;
                  }
                }
                branch.level = level;
                scope.tree_rows.push({
                  level: level,
                  branch: branch,
                  label: branch[expandingProperty],
                  tree_icon: tree_icon,
                  visible: visible
                });
                if (branch.children != null) {
                  _ref = branch.children;
                  _results = [];
                  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    child = _ref[_i];
                    child_visible = visible && (branch.expanded || branch.level < expand_level);
                    if(scope.tree_rows[0].branch.name === "TOTAL"){
                      scope.tree_rows[0].level = 0
                    }
                      _results.push(add_branch_to_list(level + 1, child, child_visible));
                  }
                  return _results;
                }
              };
              _ref = scope.treeData;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                root_branch = _ref[_i];
                _results.push(add_branch_to_list(1, root_branch, true));
              }
              return _results;
            };

            scope.$watch('treeData', on_treeData_change, true);

            on_expandTo_change = function () {
              if (angular.isDefined((scope.expandTo))) {
                for_each_branch(function (b) {
                  b.expanded = false;
                  if (b[expandingProperty.field] === scope.expandTo || b[expandingProperty] === scope.expandTo) {
                    return $timeout(function () {
                      return select_branch(b);
                    });
                  }
                });
              }
            };

            scope.$watch('expandTo', on_expandTo_change, true);

            if (attrs.initialSelection != null) {
              for_each_branch(function (b) {
                if (b.label === attrs.initialSelection) {
                  return $timeout(function () {
                    return select_branch(b);
                  });
                }
              });
            }
            n = scope.treeData.length;
            for_each_branch(function (b, level) {
              b.level = level;
              return b.expanded = b.level < expand_level;
            });
            if (scope.treeControl != null) {
              if (angular.isObject(scope.treeControl)) {
                tree = scope.treeControl;
                tree.expand_all = function () {
                  return for_each_branch(function (b, level) {
                    return b.expanded = true;
                  });
                };
                tree.collapse_all = function () {
                  return for_each_branch(function (b, level) {
                    return b.expanded = false;
                  });
                };
                tree.get_first_branch = function () {
                  n = scope.treeData.length;
                  if (n > 0) {
                    return scope.treeData[0];
                  }
                };
                tree.select_first_branch = function () {
                  var b;
                  b = tree.get_first_branch();
                  return tree.select_branch(b);
                };
                tree.get_selected_branch = function () {
                  return selected_branch;
                };
                tree.get_parent_branch = function (b) {
                  return get_parent(b);
                };
                tree.select_branch = function (b) {
                  select_branch(b);
                  return b;
                };
                tree.get_children = function (b) {
                  return b.children;
                };
                tree.select_parent_branch = function (b) {
                  var p;
                  if (b == null) {
                    b = tree.get_selected_branch();
                  }
                  if (b != null) {
                    p = tree.get_parent_branch(b);
                    if (p != null) {
                      tree.select_branch(p);
                      return p;
                    }
                  }
                };
                tree.add_branch = function (parent, new_branch) {
                  if (parent != null) {
                    parent.children.push(new_branch);
                    parent.expanded = true;
                  } else {
                    scope.treeData.push(new_branch);
                  }
                  return new_branch;
                };
                tree.add_root_branch = function (new_branch) {
                  tree.add_branch(null, new_branch);
                  return new_branch;
                };
                tree.expand_branch = function (b) {
                  if (b == null) {
                    b = tree.get_selected_branch();
                  }
                  if (b != null) {
                    b.expanded = true;
                    return b;
                  }
                };
                tree.collapse_branch = function (b) {
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    b.expanded = false;
                    return b;
                  }
                };
                tree.get_siblings = function (b) {
                  var p, siblings;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    p = tree.get_parent_branch(b);
                    if (p) {
                      siblings = p.children;
                    } else {
                      siblings = scope.treeData;
                    }
                    return siblings;
                  }
                };
                tree.get_next_sibling = function (b) {
                  var i, siblings;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    siblings = tree.get_siblings(b);
                    n = siblings.length;
                    i = siblings.indexOf(b);
                    if (i < n) {
                      return siblings[i + 1];
                    }
                  }
                };
                tree.get_prev_sibling = function (b) {
                  var i, siblings;
                  if (b == null) {
                    b = selected_branch;
                  }
                  siblings = tree.get_siblings(b);
                  n = siblings.length;
                  i = siblings.indexOf(b);
                  if (i > 0) {
                    return siblings[i - 1];
                  }
                };
                tree.select_next_sibling = function (b) {
                  var next;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    next = tree.get_next_sibling(b);
                    if (next != null) {
                      return tree.select_branch(next);
                    }
                  }
                };
                tree.select_prev_sibling = function (b) {
                  var prev;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    prev = tree.get_prev_sibling(b);
                    if (prev != null) {
                      return tree.select_branch(prev);
                    }
                  }
                };
                tree.get_first_child = function (b) {
                  var _ref;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    if (((_ref = b.children) != null ? _ref.length : void 0) > 0) {
                      return b.children[0];
                    }
                  }
                };
                tree.get_closest_ancestor_next_sibling = function (b) {
                  var next, parent;
                  next = tree.get_next_sibling(b);
                  if (next != null) {
                    return next;
                  } else {
                    parent = tree.get_parent_branch(b);
                    return tree.get_closest_ancestor_next_sibling(parent);
                  }
                };
                tree.get_next_branch = function (b) {
                  var next;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    next = tree.get_first_child(b);
                    if (next != null) {
                      return next;
                    } else {
                      next = tree.get_closest_ancestor_next_sibling(b);
                      return next;
                    }
                  }
                };
                tree.select_next_branch = function (b) {
                  var next;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    next = tree.get_next_branch(b);
                    if (next != null) {
                      tree.select_branch(next);
                      return next;
                    }
                  }
                };
                tree.last_descendant = function (b) {
                  var last_child;
                  if (b == null) {
                    debugger;
                  }
                  n = b.children.length;
                  if (n === 0) {
                    return b;
                  } else {
                    last_child = b.children[n - 1];
                    return tree.last_descendant(last_child);
                  }
                };
                tree.get_prev_branch = function (b) {
                  var parent, prev_sibling;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    prev_sibling = tree.get_prev_sibling(b);
                    if (prev_sibling != null) {
                      return tree.last_descendant(prev_sibling);
                    } else {
                      parent = tree.get_parent_branch(b);
                      return parent;
                    }
                  }
                };
                return tree.select_prev_branch = function (b) {
                  var prev;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    prev = tree.get_prev_branch(b);
                    if (prev != null) {
                      tree.select_branch(prev);
                      return prev;
                    }
                  }
                };
              }
            }
          }
        };
      }
    ])

    .provider('treegridTemplate', function () {
      var templatePath = 'app/components/a4-tree-grid/template.html';

      this.setPath = function (path) {
        templatePath = path;
      };

      this.$get = function () {
        return {
          getPath: function () {
            return templatePath;
          }
        };
      };
    })

    .filter('searchFor', function () {
      return function (arr, filterString, expandingProperty, colDefinitions, expand) {
        var filtered = [];
        //only apply filter for strings 3 characters long or more
        if (!filterString || filterString.length < 3) {
          for (var i = 0; i < arr.length; i++) {
            var item = arr[i];
            if (item.visible) {
              filtered.push(item);
            }
          }
        } else {
          var ancestorStack = [];
          var currentLevel = 0;
          for (var i = 0; i < arr.length; i++) {
            var item = arr[i];
            while (currentLevel >= item.level) {
              throwAway = ancestorStack.pop();
              currentLevel--;
            }
            ancestorStack.push(item);
            currentLevel = item.level;
            if (include(item, filterString, expandingProperty, colDefinitions)) {
              for (var ancestorIndex = 0; ancestorIndex < ancestorStack.length; ancestorIndex++) {
                ancestor = ancestorStack[ancestorIndex];
                if (ancestor.visible) {
                  if (expand)
                    ancestor.branch.expanded = true;
                  filtered.push(ancestor);
                }
              }
              ancestorStack = [];
            }
          }
        }
        return filtered;
      };

      function include(item, filterString, expandingProperty, colDefinitions) {
        var includeItem = false;
        var filterApplied = false;
        //first check the expandingProperty
        if (expandingProperty.filterable) {
          filterApplied = true;
          if (checkItem(item, filterString, expandingProperty)) {
            includeItem = true;
          }
        }
        //then check each of the other columns
        var arraySize = colDefinitions.length;
        for (var i = 0; i < arraySize; i++) {
          var col = colDefinitions[i];
          if (col.filterable) {
            filterApplied = true;
            if (checkItem(item, filterString, col)) {
              includeItem = true;
            }
          }
        }
        if (filterApplied) {
          return includeItem;
        } else {
          return true;
        }
      }

      function checkItem(item, filterString, col) {
        if (col.sortingType === "number") {
          if (item.branch[col.field] != null
            && parseFloat(item.branch[col.field]) === parseFloat(filterString)) {
            return true;
          }
        } else {
          if (item.branch[col.field] != null
            && item.branch[col.field].toLowerCase().indexOf(filterString.toLowerCase()) !== -1) {
            return true;
          }
        }
      }
    });
}).call(window);

(function () {
  'use strict';

  angular
    .module('app.a4-table-installments', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function InfoCheckController(BillReceiptService, BillPaymentService, ModalExtra, $mdDialog, Common, $filter, $scope, $rootScope) {

    var vm = this;
    vm.readed = false;
    vm.currentItem = ModalExtra.currentItem;
    vm.itemIndex = ModalExtra.item.idx;
    vm.listItem = ModalExtra.item;
    vm.check = vm.listItem;


    vm.init = function () {
      vm.getBanks();
    };

    /**
     * Devolve o objeto do modal para a chamada.
     * @param answer - resposta
     * @param form
     */
    vm.answer = function (answer, form) {
      if (form.$valid) {
        $mdDialog.hide(answer);
      }
    };

    vm.closeModal = function () {
      $mdDialog.cancel();
    };


    vm.getBanks = function () {
      BillPaymentService.getAllBanks()
        .then(function (response) {
          if (response != null) {
            vm.banks = response;
          }
        })
        .catch(function () {
          Common.Toast.error('Erro');
        });
    };


    /**
     * Monta o objeto com os dados do cheque.
     * @param barcode - Codigo do cheque.
     */
    vm.prepareObjectCheck = function (barcode) {
      vm.checkObject = {
        bank_code: barcode.substring(0, 3),
        branch: barcode.substring(3, 7),
        compensation: barcode.substring(8, 11),
        number: barcode.substring(11, 17),
        check_type: barcode[17],
        account: barcode.substring(23, 30)
      };
      return vm.checkObject;
    };


    /**
     * Espera leitura do codigo do cheque.
     * @param barcode - String com o numero do cheque.
     */
    vm.readCheckNumber = function (barcode) {

      if (typeof barcode == 'string' && barcode.length == 30) {
        var check = vm.prepareObjectCheck(barcode);
        check.debit_credit = vm.currentItem.debit_credit.toLowerCase();
        vm.readed = true;
        BillReceiptService.verifyCheckNumber(check)
          .then(function (response) {
            if (typeof response != 'string') {
              if (response.message == 'RECEIVABLE_CHECK') {
                vm.check = check;
                vm.check.idx = vm.itemIndex;
                vm.check.bank = response.bank;
                return;
              }
              Common.Toast.warning('Cheque '
                + vm.getStatusOfCheque(response['status'])
                + '. Não vai ser possível utilizar este cheque para pagamento.');
            }
          })
          .catch(function (response) {
            switch (response) {
              case 'IS_OWN_CURRENT_ACCOUNT':
                vm.toastWarn('IS_OWN_CURRENT_ACCOUNT');
                break;
              case 'IS_ONE_CHECK_THIRD_PERSON_REGISTRADO':
                vm.toastWarn('IS_ONE_CHECK_THIRD_PERSON_REGISTRADO');
                break;
              case 'IS_OWN_CURRENT_ACCOUNT_AND_HAS_ALREADY_BEEN_USED':
                vm.toastWarn('IS_OWN_CURRENT_ACCOUNT_AND_HAS_ALREADY_BEEN_USED');
                break;
            }
          });
      }
    };

    vm.getStatusOfCheque = function (status_id) {
      var status_names = [
        {id: 0, name: 'Em mãos'},
        {id: 1, name: 'Em custódia'},
        {id: 2, name: 'Depositado'},
        {id: 5, name: 'Devolvido'},
        {id: 6, name: 'Reapresentado'},
        {id: 10, name: 'Sacado'},
        {id: 11, name: 'Compensado'},
        {id: 12, name: 'Resgatado'},
        {id: 13, name: 'Descontado'},
        {id: 14, name: 'Utilizado para pagamento'},
        {id: 90, name: 'Extraviado'}
      ];
      return $filter('filter')(status_names, {id: status_id})[0].name;
    };


    vm.querySearch = function (query, list) {
      if (list != undefined && list.length > 0) {
        return query ? list.filter(vm.createFilterFor(query)) : list;
      }
    };

    /**
     * Create filter function for a query string
     */
    vm.createFilterFor = function (query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        var lower = angular.lowercase(item.name);
        return (item.number_bank.indexOf(lowercaseQuery) !== -1) || (lower.indexOf(lowercaseQuery) !== -1);
      };
    };

    vm.waitCheck = function () {
    };

    /**
     * CHEQUE RECEBIMENTO
     * Verifica e sugestiona composição de cheque pelo bano
     * @param bank
     */
    vm.verifyCheckByBank = function (bank) {

      var checkUsed = false;

      angular.forEach(vm.paymentslist, function (item) {
        if (item.bank == bank) {
          vm.check.branch = item.branch;
          vm.check.account = item.account;
          vm.check.number = parseInt(item.number) + 1;
          checkUsed = true;
        }
      });

      if (!checkUsed) {
        // vm.checkSugestion(bank.id, null, null);
      }
      return true;

    };

    /**
     * CHEQUE RECEBIMENTO
     * Requisição ao banco para verificar se há algum cheque utilizado
     * @param bank_id
     * @param branch
     * @param account
     */
    vm.checkSugestion = function (bank_id, branch, account) {

      BillReceiptService.getLastCheckUsedForBankBranch({bank_id: bank_id, branch: branch, account: account})
        .then(function (response) {
          if (angular.equals({}, response)) {
            if (!bank_id) {
              vm.check.bank = {};
              vm.check.bank.id = response.bank_id;
              vm.check.bank.name = response.name;
              vm.check.bank.number_bank = response.number_bank;
            }
            vm.check.branch = response.branch;
            vm.check.account = response.account;
            vm.check.number = parseInt(response.number) + 1;
          }

        })
        .catch(function (response) {
          vm.toastWarn('Problemas na verificação do cheque');
        });
    };

    var ltn = $rootScope.$on('CUSTOM.opened', function () {
      var elem = angular.element('[name=barcodeField]');
      elem.focus();
    });

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });

    vm.init();

  }


  angular
    .module('app.a4-table-installments')
    .controller('InfoCheckController', InfoCheckController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4TableInstallments(a4Moment, Common, $filter, $mdDialog, angularMomentConfig,
                               ModalFactory, BillReceiptService, Utils) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        totalAmount: '=?',
        disabled: '=?',
        list: '=',
        currentItem: '=',
        modeReceipt: '@',
        frequencyQty: '=?',
        frequency: '=?',
        block: '=',
        quantity: '=?',
        isRecurrence: '=?',
        initialQty: "=?",
        isNegotiation: '@?',
        interestValue: '=?',
        invoke: '=?'
      },
      controller: 'a4TableInstallmentsController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-table-installments/templates/index.html',
      link: function (scope, element, attrs, ctrl) {
        scope.disabled = true;
        scope.interestValue = 0;
        scope.quantity = angular.isDefined(scope.initialQty) ? scope.initialQty : 1;
        scope.payment = {id: null, amount: null};
        scope.installment = null;
        scope.list = [];
        scope.edit_mode = false;
        scope.date_first = a4Moment().add(1, 'month');
        scope.finalValue = 0;
        scope.isRecurrence = angular.isUndefined(scope.isRecurrence) ? false : scope.isRecurrence;

        scope.frequency_options = [
          {id: 1, name: 'Dia(s)', value: 'day'},
          {id: 2, name: 'Mês(s)', value: 'month'},
          {id: 3, name: 'Ano(s)', value: 'year'},
          {id: 4, name: 'Livre', value: false}
        ];

        scope.init = function () {
          scope.disabled = true;
          // ctrl.final_value = scope.totalAmount;
          /** edit mode */
          if (scope.currentItem && scope.currentItem.payment_installments
            && !angular.isUndefined(scope.currentItem.payment_installments)) {
            scope.list = ctrl.parseDates(scope.currentItem.payment_installments);
          }

          scope.invoke = scope.calculateInterestValue;
        };

        scope.isDisabled = ctrl.isDisabled;

        scope.openModalConfig = function (item, index) {
          item.idx = index;
          ModalFactory.customClean("app/components/a4-table-installments/templates/checkConfig.html",
            'InfoCheckController', "vm", false, {
              currentItem: scope.currentItem,
              item: item
            })
            .then(function (resp) {
              if (resp.reply) {
                scope.incrementCheckNumberReply(scope.list, resp);
              } else {
                scope.incrementCheckNumber(scope.list, resp);
              }
              scope.isDuplicatedCheck(scope.list);
            })
            .catch(function (resp) {
            });
        };


        scope.incrementCheckNumber = function (list, resp) {
          var value = list[resp.idx];
          value.number = resp.number;
          if (ctrl.verifyIfCheckNumberGreaterThenMax(value.number)) return;
          value.account = resp.account;
          value.branch = resp.branch;
          value.bank_number = resp.bank.number_bank;
          value.bank_id = resp.bank.id;
          value.bank = resp.bank;
          value.check_identify = value.bank_number + '-' + value.branch + '-' + value.account + '-' + value.number;
        };

        scope.incrementCheckNumberReply = function (list, resp) {
          var old_number = 0;
          scope.incrementCheckNumber(list, resp);
          angular.forEach(list, function (value) {
            if (value.idx > resp.idx) {
              value.number = parseInt(old_number) == 0 ? parseInt(resp.number) + 1 : parseInt(old_number) + 1;
              if (ctrl.verifyIfCheckNumberGreaterThenMax(value.number)) return;
              old_number = value.number;
              value.account = resp.account;
              value.branch = resp.branch;
              value.bank_number = resp.bank.number_bank;
              value.bank_id = resp.bank.id;
              value.bank = resp.bank;
              value.check_identify = value.bank_number + '-' + value.branch + '-' + value.account + '-' + value.number;
            }
          });
        };

        scope.isDuplicatedCheck = function (list) {
          BillReceiptService.verifyListOfCheckNumber({'check_list': list})
            .then(function (response) {
              angular.forEach(list, function (value) {
                var filter = $filter('filter')(response, {idx: value.idx})[0];
                value.duplicated = filter.duplicated;
              });
            });
        };


        /**
         * cria e adiciona ao array uma nova parcela
         */
        scope.createBlankInstallment = function () {
          scope.list.push(ctrl.getBlankInstallment());
          scope.enumerateInstallments();
        };

        /**
         * cria sequencia de parcelas basada na quantidade selecionada pelo usuário
         */
        scope.createBatchInstallments = function (with_interest) {
          if (ctrl.isValid()) {
            if (scope.list.length > 0) {
              var title = 'As parcelas serão removidas.';
              var msg = 'Todas as parcelas existentes serão apagadas e substituídas pela nova criação. Deseja continuar?';

              var confirm = $mdDialog.confirm().title(title).htmlContent(msg)
                .ariaLabel('gerar novas parcelas').ok('GERAR').cancel('CANCELAR');

              $mdDialog.show(confirm)
                .then(function () {
                  scope.interestValue = 0;
                  scope.batchInstallments(with_interest);
                });

            } else {
              scope.interestValue = 0;
              scope.batchInstallments(with_interest);
            }
          }
        };

        /**
         * batchInstallments
         * geração de novas parcelas
         */
        scope.batchInstallments = function (with_interest) {
          if (scope.hasOwnProperty('quantity')) {

            if (scope.isRecurrence) {
              scope.installment = Utils.roundFloat(parseFloat(ctrl.negotiate_value));
            } else {
              var remainder = Utils.roundFloat(parseFloat(ctrl.negotiate_value)) % scope.quantity;

              scope.installment = Utils.roundFloat(parseFloat(ctrl.negotiate_value));

              // caso o tipo de valor na recorrencia for 'Divide o valor do titulo nas parcelas', divide o valor pela quantidade de parcelas
              if (scope.currentItem.recurrency_on_value === '2' || scope.isNegotiation) {
                scope.installment = scope.installment / scope.quantity;
              }
            }
            scope.entry_portion = [];
            if (ctrl.entry_value > 0) {
              scope.entry_portion = [{
                due_date: a4Moment().format('YYYY-MM-DD'),
                index: 0,
                status: 1,
                amount: ctrl.entry_value,
                document: ''
              }];
            }

            scope.list = [];

            var difference_between_date_first_and_today = scope.getDifferenceBetweenDateFirstAndToday();

            for (var i = 0; i < scope.quantity; i++) {
              var portion = Utils.roundFloat(parseFloat(scope.installment));
              if (remainder > 0 && (i + 1) === scope.quantity && !(with_interest)) {
                var totalRounded = Utils.roundFloat(portion * scope.quantity);
                var diff = Utils.roundFloat(totalRounded - ctrl.negotiate_value);
                if (!scope.isRecurrence) {
                  portion = portion - diff;
                }
              }
              portion = Utils.roundFloat(parseFloat(portion));
              scope.createBlankInstallment();
              if (with_interest) {
                var previous_portion = parseFloat(angular.copy(portion));
                portion = Utils.roundFloat(parseFloat(((portion * scope.quantity)) * (0.01 / (1 - Math.pow(1 + 0.01, -scope.quantity)))));
                scope.interestValue = Utils.roundFloat(parseFloat(scope.interestValue) + parseFloat((previous_portion - portion)));

                portion = scope.calculateInterestValue(portion, previous_portion, difference_between_date_first_and_today);
              } else {
                scope.interestValue = 0;
              }
              scope.list[i].amount = isNaN(portion) ? 0 : portion;

              scope.list[i].idx = i;
            }

            if (with_interest) {
              scope.vm.final_value = (portion * scope.quantity) + ctrl.entry_value;
              scope.currentItem.amount = scope.vm.final_value;
            }
            scope.list = scope.entry_portion.concat(scope.list);
            scope.$applyAsync();
          }

          if (scope.hasOwnProperty('maxvalue')) {
            if (scope.isRecurrence) {
              scope.installment = Utils.roundFloat(parseFloat(ctrl.negotiate_value));
            } else {
              var remainder = (parseInt(ctrl.negotiate_value) / parseInt(scope.installment) - scope.maxvalue) * parseInt(scope.installment);
              scope.installment = Math.ceil(Utils.roundFloat(parseFloat(ctrl.negotiate_value)) / scope.maxvalue);
            }

            scope.list = [];

            for (var j = 0; j < scope.installment; j++) {
              var portion = Utils.roundFloat(parseFloat(scope.maxvalue));
              if ((j + 1) === scope.installment) {
                var totalRounded = portion * scope.installment;
                var diff = totalRounded - ctrl.negotiate_value;
                if (!scope.isRecurrence) {
                  portion = portion - diff;
                }
              }
              scope.createBlankInstallment();
              scope.list[j].amount = isNaN(portion) ? 0 : portion;
              scope.list[j].idx = j;
            }
          }



          // Verifica se existe algum centavo pendente e redistribui entre as parcelas
          var pending_difference = Utils.roundFloat(ctrl.negotiate_value - (scope.installment * scope.quantity));

          if (pending_difference !== 0 && pending_difference < scope.quantity / 100 && !with_interest){
            var limit = Math.trunc(pending_difference * 100);
            if(pending_difference > 0) {
              for (var i = scope.list.length - 1; i > scope.list.length - 1 - limit; --i) {
                if (scope.currentItem.recurrency_on_value == 0) {
                  scope.list[i].amount = scope.totalAmount;
                } else {
                  scope.list[i].amount += 0.01;
                }
              }

            }else{
              limit *= -1;

              for (var i = scope.list.length - 1; i > scope.list.length - 1 - limit; --i) {
                if (scope.currentItem.recurrency_on_value == 0) {
                  scope.list[i].amount = scope.totalAmount;
                } else {
                  // scope.list[i].amount -= 0.01;
                }
              }

            }
          }

          scope.enumerateInstallments()
        };

        scope.getDifferenceBetweenDateFirstAndToday = function () {
          return scope.date_first.diff(a4Moment().startOf('day'), 'months');
        };

        /**
         * Enumera as parcelas
         */
        scope.enumerateInstallments = function () {
          for (var i = 0; i < scope.list.length; i++) {
            scope.list[i].index = (i + 1) + '/' + scope.list.length;
          }
        };

        /**
         * Calcula valor da parcela + juros de acordo com a diferença entre a data de início da negociação e a data atual
         * @param instalment
         * @param previous_instalment
         * @param difference_between_date_first_and_today
         * @returns {*}
         */
        scope.calculateInterestValue = function (instalment, previous_instalment, difference_between_date_first_and_today) {
          if (difference_between_date_first_and_today < 1) {
            instalment = instalment - ((previous_instalment) * 0.01);
          } else if (difference_between_date_first_and_today >= 2) {
            var dif = difference_between_date_first_and_today / 100;
            instalment = instalment + ((previous_instalment) * (dif - 0.01));
          }
          return Utils.roundFloat(instalment);
        };


        /**
         * remove parcela da lista
         * @param item
         * @param id
         */
        scope.removeInstallment = function (item, id) {
          if (scope.list.length > 1) {
            if (scope.list.indexOf(item) !== -1) {
              scope.list.splice(id, 1);

              //calculo automatico sem o item deletado
              scope.quantity = scope.list.length;
              scope.batchInstallments();
            }
          }
          scope.enumerateInstallments();
        };

        scope.test = function () {
        };

        var round = function (value, decimals) {
          return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
        };

        /**
         * retorna objeto com a soma total, valor a distribuir e diferença pendente
         * @returns object
         */
        scope.getTotal = function () {
          var result_total = parseFloat(scope.sumInstallments());
          /*
                    if (result_total !== scope.totalAmount) {
                      result_total = scope.totalAmount;
                    }
          */
          var difference_between_date_first_and_today = scope.getDifferenceBetweenDateFirstAndToday();
          var currentItem_amount_value = round(ctrl.negotiate_value + ctrl.entry_value + -(scope.interestValue), 2);

/*          currentItem_amount_value = scope.calculateInterestValue(currentItem_amount_value, (scope.totalAmount - ctrl.entry_value), difference_between_date_first_and_today);*/
          if (scope.interestValue !== 0) {
            currentItem_amount_value = scope.vm.final_value;
          }
          var pending_difference = (currentItem_amount_value - result_total);
          scope.currentItem.pending_difference = isNaN(pending_difference) ? 0 : Utils.roundFloat(pending_difference);

          return {
            total: scope.applyMask(result_total),
            pending_difference: scope.currentItem.pending_difference
          };
        };

        /**
         * Soma o valor das parcelas
         * @returns {string}
         */
        scope.sumInstallments = function () {
          var result = 0;
          angular.forEach(scope.list, function (item) {
            if (item.amount != '') {
              item.amount = item.amount == null ? 0 : parseFloat(item.amount);
              result = Utils.roundFloat(result + parseFloat(item.amount));
            }
          });
          return Utils.roundFloat(result);
        };

        /**
         * Aplica mascara financeira no padrão (R$ 0,00)
         * @param value
         * @returns {string}
         */
        scope.applyMask = function (value) {
          if (value == 0 || value == null) {
            var currency = $filter('currency')(0, 'R$ ', 2);
            return currency.replace(".", ",").replace(",", ".");
          } else if (value > 0) {
            var currency = $filter('currency')(value, 'R$ ', 2);
            return currency.replace(".", ",").replace(",", ".");
          }
        };

        /**
         * Seta valor incremental para a numeração do cheque pré-datado
         * @param index
         */
        scope.setInstallmentDocumentName = function (index) {

          if (scope.list.length > 0 && index == 0) {
            var target = parseInt(scope.list[0].document);
            angular.forEach(scope.list, function (item, i) {
              if (i > 0 && !isNaN(target)) {
                scope.list[i].document = target + i;
              }
            });
          }

        };

        /**
         * Watchs
         */
        scope.$watch(function () {
          if (scope.currentItem != null) {
            if (scope.currentItem.id != null) {
              scope.edit_mode = true;
            }
          }
        }, true);

        scope.$watch('list', function () {
          scope.updateRecurrence();
        }, true);

        /** update da recorrência */
        scope.updateRecurrence = function () {

          if (scope.list != null && scope.list.length > 0) {
            scope.currentItem.quantity = scope.list.length;
            scope.currentItem.date_first = scope.date_first;
            scope.currentItem.date_end = scope.list[scope.list.length - 1].date;
          }

        };

        scope.changeRecurrence = function (end_of_recurrence, currentItem) {
          if (end_of_recurrence == 1 && currentItem.hasOwnProperty('quantity')) {
            delete currentItem.quantity;
          }
          if (end_of_recurrence == 0 && currentItem.hasOwnProperty('maxvalue')) {
            delete currentItem.maxvalue;
          }
        };


        scope.init();
      }
    }
  }

  angular
    .module('app.a4-table-installments')
    .directive('a4TableInstallments', a4TableInstallments)
})();

(function () {
  'use strict';

  function a4TableInstallmentsController($scope, a4Moment, angularMomentConfig, $filter, Common, $timeout, Utils) {

    var vm = this;
    vm.frequency_options = [
      {id: 1, name: 'Dia(s)', value: 'day'},
      {id: 2, name: 'Mês(s)', value: 'month'},
      {id: 3, name: 'Ano(s)', value: 'year'},
      {id: 4, name: 'Livre', value: false}
    ];
    vm.entry_value = 0;

    vm.init = function () {
      $timeout(function () {
        vm.final_value = $scope.totalAmount;
        vm.negotiate_value = $scope.totalAmount;
      }, 4000);
    };

    $scope.$watch('totalAmount', function () {
      vm.final_value = Utils.roundFloat($scope.totalAmount - ($scope.interestValue));
      vm.negotiate_value = Utils.roundFloat($scope.totalAmount - vm.entry_value);
    }, true);

    $scope.$watch('interestValue', function () {
      if ($scope.interestValue === 0) {
        vm.final_value = Utils.roundFloat($scope.totalAmount);
        $scope.currentItem.amount = vm.final_value;
      }
    }, true);

    $scope.$watch('vm.final_value', function () {
    });

    vm.isDisabled = function (item) {
      return !((vm.statusIsValid(item) || ($scope.currentItem.id !== undefined && $scope.currentItem.id === item.bill_id) || $scope.disabled) === false ||
        (vm.statusIsValid(item) || ($scope.currentItem.id !== undefined && $scope.currentItem.id === item.bill_id) || $scope.disabled) === "false" || !$scope.isRecurrence);
    };

    /**
     * Define o valor a ser parcelado (valor total dos títulos menos o valor da entrade)
     */
    vm.adjustNegotiateValue = function () {
      vm.negotiate_value = Utils.roundFloat(vm.final_value - vm.entry_value - (-$scope.interestValue));
    };

    vm.statusIsValid = function (item) {
      var result = false;
      if (item.status === 10 || vm.isInstallmentDue(item)) {
        result = true;
      }
      return result;
    };

    /**
     * Valida o tipo de parcela
     * @param item
     * @returns {boolean}
     */
    vm.isInstallmentDue = function (item) {
      var result = false;
      var date = a4Moment(item.date).valueOf();
      var today = a4Moment().subtract(1, 'days').valueOf();
      if (item.status === 1 && date < today) {
        result = true;
      }
      return result;
    };

    /**
     * retorna objeto da parcela
     * @returns {{date: string, status: number, amount: number}}
     */
    vm.getBlankInstallment = function () {
      return {
        due_date: vm.getDateOfSequence(),
        status: 1,
        amount: 0,
        document: ''
      };
    };


    /**
     * retorna uma data baseada na sequencia e nas validacoes para meses
     * @returns {string}
     */
    vm.getDateOfSequence = function () {
      var len = $scope.list == null ? 0 : $scope.list.length;
      var lastDate = len === 0 ? $scope.date_first : $scope.list[len - 1].due_date;
      lastDate = lastDate === '' || lastDate == null ? $scope.date_first : lastDate;
      var due_date = a4Moment(lastDate);
      $scope.frequencyQty = ($scope.frequencyQty != null) ? $scope.frequencyQty : 1;
      var frequency_value = $filter('filter')(vm.frequency_options, {id: $scope.frequency})[0].value;
    
      if (len > 0) {
        due_date.add($scope.frequencyQty, 'month');
    
        var originalDay = a4Moment($scope.date_first).date(); // Armazena o dia original
        var lastDayOfMonth = due_date.clone().endOf('month').date(); // Último dia do mês
    
        if (due_date.date() < originalDay) {
          // Ajusta o dia para o original, mas se não for válido, usa o último dia do mês
          due_date.date(Math.min(originalDay, lastDayOfMonth));
        }
      }
    
      return due_date.format('YYYY-MM-DD');
    };
    


    /**
     * Converte as datas para um objeto do tipo Date
     * @param arr
     * @returns {Array}
     */
    vm.parseDates = function (arr) {
      var result = [];
      angular.forEach(arr, function (item) {
        item.date = a4Moment(item.date);
        result.push(item);
      });
      return result;
    };

    vm.verifyIfCheckNumberGreaterThenMax = function (number) {
      return number > 999999;
    };


    /**
     * Validação para as regras de criação de parcelas
     * @returns {boolean}
     */
    vm.isValid = function () {
      var result = true;
      if ($scope.hasOwnProperty('quantity')) {
        if ($scope.currentItem != null) {

          if ($scope.quantity === 0) {
            result = false;
            Common.Toast.warning('Adicione um valor maior que zero a quantidade de parcelas.');
          } else if ($scope.date_first === '' || $scope.date_first == null) {
            result = false;
            Common.Toast.warning('Adicione uma data para o primeiro vencimento.');
          } else if ($scope.currentItem.amount === 0 || $scope.currentItem.amount == null) {
            result = false;
            Common.Toast.warning('Adicione um valor para a despesa antes de criar as parcelas.');
          }
        } else {
          result = false;
          Common.Toast.warning('Item inválido.');
        }
      }
      return result;
    };

    vm.init();

  }

  angular
    .module('app.a4-table-installments')
    .controller('a4TableInstallmentsController', a4TableInstallmentsController)

})();
(function () {
  'use strict';
  angular
    .module('app.a4-table-fixed', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4TableFixed() {
    return {
      restrict: 'C',
      link: function (scope, element) {

        /**
         * Elementos da tabela e o contexto
         */
        var thead = element.find('thead');
        var tbody = element.find('tbody');
        var content = element.closest('md-content');

        scope.init = function () {
          /**
           * Verifica se a primeira coluna possui o checkbox com select all
           */
          if(element.find('thead th:nth-child(1)').hasClass('select-all'))
            element.addClass('with-select');
          /**
           * Define a largura da tabela de acordo com a janela
           */
          thead.css('width', content.innerWidth()+'px');
          tbody.css('width', 'calc(' + content.innerWidth() + 'px  - 30px');

          /**
           * Realiza a fixação do cabeçalho e coluna
           * de acordo com o scroll
           */
          tbody.scroll(function(e) {
            thead.css('left', -tbody.scrollLeft());
            if(element.find('thead th:nth-child(1)').hasClass('select-all')){
              element.find('thead th:nth-child(2)').css('left', tbody.scrollLeft());
              element.find('tbody td:nth-child(2)').css('left', tbody.scrollLeft());
              shadow();
            }else{
              element.find('thead th:nth-child(1)').css('left', tbody.scrollLeft());
              element.find('tbody td:nth-child(1)').css('left', tbody.scrollLeft());
              shadow();
            }
          });

        };

        /**
         * Define a largura da tabela de acordo com a janela
         * ao escutar o evento
         */
        scope.$watch
        (
          function () {
            return {
              w:content.width(),
              h:content.height()
            };
          },
          function (newValue, oldValue) {
            if (newValue.w !== oldValue.w || newValue.h !== oldValue.h) {
              thead.css('width', content.innerWidth()+'px');
              tbody.css('width', 'calc(' + content.innerWidth() + 'px  - 30px');
            }
          },
          true
        );

        /**
         * Adiciona ou remove classe de sombra
         */
        var shadow = function () {

          /** Adiciona a sombra ao cabeçalho */
          if(tbody.scrollTop() > 0){
            element.find('thead').addClass('add-shadow');
          }else{
            element.find('thead').removeClass('add-shadow');
          }

          /** Adiciona a sombra na primeira coluna */
          if(tbody.scrollLeft() > 0){
            element.find('thead th:nth-child(1)').addClass('add-shadow');
            element.find('tbody td:nth-child(1)').addClass('add-shadow');
          }else{
            element.find('thead th:nth-child(1)').removeClass('add-shadow');
            element.find('tbody td:nth-child(1)').removeClass('add-shadow');
          }
        };

        scope.init();

      }
    }
  }

  angular
    .module('app.a4-table-fixed')
    .directive('a4TableFixed', a4TableFixed)
})();
(function () {
  'use strict';

  angular
    .module('app.a4-table-expandable', []);

})();
(function () {
  'use strict';
  function A4Table() {
    var provide = this;



    provide.$get = {

    };

    return provide;

  }

  angular
    .module('app.a4-table-expandable')
    .provider('A4TableExpandable', A4Table);
})();
(function () {
  'use strict';

  angular
    .module('app.a4-table', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DataFilter() {
    return function (list_idx, filter_list) {

      /**
       * Filtra a lista de indices
       * @type {Array}
       */

      var result = [];

      if (filter_list != null && filter_list.length > 0) {

        angular.forEach(filter_list, function (item) {

          var map = list_idx.map(function (e) {
            return e;
          }).indexOf(item);

          if (map != -1) {
            result.push(item);
          }

        });

      } else {
        result = list_idx;
      }

      return result;
    };
  }

  angular
    .module('app.a4-table')
    .filter('dataFilter', DataFilter)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4Table($filter) {

    /**
     * @param {array} items - Dados de listagem
     * @param {array} filter - Filtragem de colunas da lista;
     * @param {array} menuGroup - Agrupamento de menu para cada item;
     * @param {string} sidebarTemplateCreate - url para template do sidebar;
     * @param {string} sidebarTemplateEdit - url para template do sidebar;
     * @param {boolean} withLeftSideNav - default: false, Menu de agrupamento ao lado esquedo da lista;
     * @param {boolean} withListCheckBox - default: true, Define visibilidade do checkbox;
     * @param {function} onDelete - ao clicar no item excluir, o onDelete é rastreado para uma função fora do scopo;
     * @param {function} onSubmit;
     * @param {function} includeScope - Objeto de configuração da diretiva;
     * @returns {}
     */
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/a4-table-expandable/view/a4-table-expandable-index.html',
      scope: {
        items: '=',
        filter: '=',
        menuGroup: '=',
        sidebarTemplateCreate: '@',
        sidebarTemplateEdit: '@',
        sidebarTemplateNegotiate: '@',
        sidebarTemplatePayment: '@',
        sidebarTemplateReverse: '@',
        withLeftSideNav: '=?',
        withListCheckBox: '=?',
        withListOrderBy: '=?',
        withoutMenuOptions: '=?',
        onChange: '&',
        onDelete: '&',
        onSubmit: '&',
        changeStatus: '&',
        undoChangeStatus: '&',
        includeScope: '='
      },
      controller: 'a4TableExpandableController',
      controllerAs: 'vm',
      link: function (scope) {

        scope.withLeftSideNav = !scope.withLeftSideNav ? false : scope.withLeftSideNav;
        scope.withListCheckBox = scope.withListCheckBox === undefined || scope.withListCheckBox ? true : scope.withListCheckBox;
        scope.withListOrderBy = scope.withListOrderBy === undefined;

        var variables = {
          header_main_height: 48,
          easing_swiftOut: [0.4, 0, 0.2, 1],
          bez_easing_swiftOut: [0.4, 0, 0.2, 1],
          none: 0
        };

        var $billbox = angular.element('#bill-box');

        // $billbox.on('ifChanged', '.select_message', function () {
        //   /** Ternário */
        //   angular.element(this).is(':checked') ?
        //     angular.element(this).closest('li').addClass('md-card-list-item-selected')
        //     : angular.element(this).closest('li').removeClass('md-card-list-item-selected');
        // });
        //
        // $billbox.on('click', '.md-card-list ul > li', function (e) {
        //
        //   if (!angular.element(e.target).closest('.md-card-list-item-menu').length
        //     && !angular.element(e.target).closest('.md-card-list-item-select').length) {
        //
        //     var $this = angular.element(this);
        //
        //     if (!$this.hasClass('item-shown')) {
        //       // get height of clicked message
        //       var el_min_height = $this.height();
        //
        //       // hide opened message
        //       $billbox.find('.item-shown').velocity("reverse", {
        //         begin: function (elements) {
        //           angular.element(elements).removeClass('item-shown')
        //             .children('.md-card-list-item-content-wrapper')
        //             .hide().velocity("reverse");
        //         }
        //       });
        //
        //       // show message
        //       $this.velocity({
        //         marginTop: 40,
        //         marginBottom: 40,
        //         marginLeft: 0,
        //         marginRight: 0,
        //         minHeight: el_min_height
        //       }, {
        //         duration: 300,
        //         easing: variables.none,
        //         begin: function (elements) {
        //           angular.element(elements).addClass('item-shown');
        //         },
        //         complete: function (elements) {
        //           // show: message content, reply form
        //           angular.element(elements).children('.md-card-list-item-content-wrapper').show().velocity({
        //             opacity: 1
        //           });
        //
        //           var container = angular.element('#content-container #content'),
        //             scrollTo = angular.element(elements);
        //
        //           container
        //             .animate({
        //               scrollTop: scrollTo
        //                 .prop('offsetTop') + 220
        //             }, 300);
        //
        //         }
        //       });
        //     }
        //   }
        // });
        //
        // // hide message on: outside click, esc button
        // angular.element(document).on('click keydown', function (e) {
        //   if (
        //     ( !angular.element(e.target).closest('li.item-shown').length ) || e.which == 27
        //   ) {
        //     $billbox.find('.item-shown').velocity("reverse", {
        //       begin: function (elements) {
        //         angular.element(elements).removeClass('item-shown').children('.md-card-list-item-content-wrapper').hide().velocity("reverse");
        //       }
        //     });
        //   }
        // });
        //
        //
        // if (angular.element('#floating').length) {
        //   var floating = angular.element('#floating');
        //   var originalY = floating.prop('offsetTop');
        //   var startFloat = 200;
        //   floating.css('position', 'relative');
        //
        //   angular.element('#content-container #content').bind("scroll", function (event) {
        //     var scrollTop = angular.element('#content-container #content').scrollTop();
        //     floating.stop(false, false)
        //       .animate({top: scrollTop < startFloat ? 0 : scrollTop - originalY - startFloat}, 300);
        //
        //     scope.scrolled = (scrollTop != originalY);
        //     scope.$apply();
        //
        //   });
        // }

        /**
         * Dynamic content
         * Retorna os indices baseado no array 'data' e filtra esses valores pelo array 'filter'
         * @param index
         * @returns {Array}
         */
        scope.getKeys = function (index) {
          if (scope.filter && data && data.length > 0) {
            return $filter('dataFilter')(Object.keys(data[index]), scope.filter);
          }
        };

      }
    }
  }

  angular
    .module('app.a4-table-expandable')
    .directive('a4TableExpandable', a4Table)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4TableExpandableController($scope, $mdSidenav, msUtils, $mdDialog,
                                       $filter, ModalFactory, $rootScope, $timeout,
                                       BillReceiptService, $a4Sidenav, a4Moment, Toast, PoliciesService) {

    var vm = this;

    vm.editable = true;
    vm.currentItem = {
      frequency_type: 0
    };
    vm.listLength = 0;
    vm.listCheckBills = [];
    vm.onDemand = false;
    vm.items = [];
    vm.user = [];
    vm.filterIds = null;
    vm.listType = 'all';
    vm.listOrder = 'name';
    vm.listOrderAsc = false;
    vm.selectedItems = [];
    vm.newGroupName = '';
    vm.toggle = {};
    vm.disable_neg_undo = false;

    $scope.isSidenavOpen = false;

    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;

    vm.frequency_options = BillReceiptService.getFrequencyOptions();
    vm.months = BillReceiptService.getCompetenceMonths();

    vm.years = [
      {id: 2010, label: 2010},
      {id: 2011, label: 2011},
      {id: 2012, label: 2012},
      {id: 2013, label: 2013},
      {id: 2014, label: 2014},
      {id: 2015, label: 2015},
      {id: 2016, label: 2016},
      {id: 2017, label: 2017},
      {id: 2018, label: 2018},
      {id: 2019, label: 2019},
      {id: 2020, label: 2020},
      {id: 2021, label: 2021}
    ];

    vm.init = function () {
      $timeout(function () {
        $mdSidenav('sidenav-edit-form' || 'sidenav-create-form').onClose(function () {
          vm.currentItem = {};
        });
      }, 200);

      /* Verifica a permissão "Desfazer negociação" para dasabilitar o botão "Desfazer negociação" */
      if(vm.checkPolicies('neg_undo')){
        vm.disable_neg_undo = true;
      }

    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    $scope.$watch('items', function () {
      vm.items = [];
      vm.items = $scope.items;
    }, true);

    vm.toggleInfo = function () {
      angular.element('#infosc').slideToggle("slow");
      angular.element('#infos').slideToggle("slow");
    };


    /**
     * Fornece um array com 30 numeros para a informar o dia de vencimento e o dia de fechamento
     * no formulario
     * @param {type} n - Quantidade de posições se não passado retornará null.
     * @returns {Array} - Todas as posições
     */
    vm.range = function (n) {
      if (typeof n !== 'undefined' && n !== null) {
        vm.arr = [];
        for (var i = 1; i <= n; i++) {
          vm.arr.push({id: i});
        }
      } else {
        return null;
      }
    };

    /**
     * Verifica as variabilidades da aba de recorrência
     */
    vm.checkVariabilites = function (status) {
      if (status == 1) {
        return false;
      }

      var sobDemanda = 2;
      var end_date = 1;

      if (parseInt(vm.currentItem.frequency_type) == sobDemanda) {
        vm.currentItem.end_of_recurrence = end_date;
        vm.onDemand = true;
      } else {
        vm.currentItem.end_of_recurrence = end_date;
        vm.onDemand = false;
      }
    };

    /**
     * Faz o request para a API e retorna a despesa por id
     * @param {Int} id - identificador do titulo
     * @param {Int} edit_expense - identificador do titulo
     * @param sidebar_id
     */
    vm.getBillById = function (id, edit_expense, sidebar_id) {
      vm.currentItem = null;
      BillReceiptService.getBillById(id, {'edit_expense': edit_expense})
        .then(function (response) {

          $scope.elementById = response;

          vm.currentItem = response;
          vm.currentItems = response;

          if (vm.currentItem.amount != null) {
            vm.currentItem.amount = parseFloat(vm.currentItem.amount);
          }

          if (vm.currentItem.issue_date != null) {
            vm.currentItem.issue_date = a4Moment(response.issue_date);
          }

          if (vm.currentItem.due_date != null) {
            vm.currentItem.due_date = a4Moment(response.due_date);
            vm.currentItem.issue_date = a4Moment(response.due_date);
          }

          if (vm.currentItem.payment_installments != undefined) {
            vm.currentItem.hasPaid = vm.getIfInstallmentHasOnePaid(vm.currentItem.payment_installments);
          }

          if (vm.currentItem != undefined) {

            if (vm.currentItem.next_adjustment_date) {
              vm.currentItem.next_adjustment_date = a4Moment(vm.currentItem.next_adjustment_date);
            }

            if (vm.currentItem.date_end) {
              vm.currentItem.end_of_recurrence = 1;
              vm.currentItem.date_end = a4Moment(vm.currentItem.date_end);
            }

            if (vm.currentItem.date_first) {
              vm.currentItem.date_first = a4Moment(vm.currentItem.date_first);
            }

            if (vm.currentItem.quantity > 0) {
              vm.currentItem.end_of_recurrence = 0;
            }

            if (angular.isArray(vm.currentItem.discounts_rules) && vm.currentItem.discounts_rules.length > 0) {
              vm.currentItem.discounts_rules.forEach(function (value, key) {
                value.end_date = a4Moment(value.end_date);
                value.start_date = a4Moment(value.start_date);
              })
            }

            if (vm.currentItem.tags != null && vm.currentItem.tags.length > 0) {
              vm.currentItem.tags = vm.currentItem.tags.filter(function (item, i, ar) {
                return ar.indexOf(item) === i;
              });
            }

            vm.currentItem.frequency = response.frequency;
            vm.currentItem.frequency_qty = response.frequency_qty;
            vm.currentItem.frequency_type = response.frequency_type;
            vm.currentItem.idAside = sidebar_id;


            $a4Sidenav().open(
              'app/finance/bill-receipt/views/form.html',
              'BillReceiptCreateController',
              'vm',
              vm.currentItem
            );
          }

        })
        .catch(function (response) {

        });
    };

    /**
     * Verifica se algum installments está pago.
     * @param payment_installments - Lista de parcelas.
     * @returns {boolean}
     */
    vm.getIfInstallmentHasOnePaid = function (payment_installments) {
      for (var i = 0, len = payment_installments.length; i < len; i++) {
        if (payment_installments[i].status == 1) {
          return true
        }
      }
    };

    /**
     * Após a seleção de vários cards vai para a página da ação selecionada
     * @param {number} idChange - id da acção
     * @param {int} bill_id identificador do titulo (apenas em caso de não ser ação conjunta.)
     * @returns {String}
     */
    vm.goToViewSelected = function (idChange, bill_id) {
      var selected = "";
      if (vm.listCheckBills != "") {
        for (var i = 0; i < vm.listCheckBills.length; i++) {

          if (vm.listCheckBills[i].status == 1) {
            selected = selected + i + '=' + vm.listCheckBills[i].bill_id + '&';
          } else if (vm.listCheckBills[i].status == 10) {
            Toast.warning("Não pode fazer esta ação com titulos PAGOS");
            return false;
          } else if (vm.listCheckBills[i].status == 2) {
            Toast.warning("Não pode fazer esta ação com titulos CANCELADOS");
            return false;
          } else if (vm.listCheckBills[i].status == 3) {
            Toast.warning("Não pode fazer esta ação com titulos DISPENSADOS");
            return false;
          } else if (vm.listCheckBills[i].status == 9) {
            Toast.warning("Não pode fazer esta ação com titulos EXCLUÍDOS");
            return false;
          } else if (vm.listCheckBills[i].status == 5) {
            Toast.warning("Não pode fazer esta ação com titulos DUVIDOSOS");
            return false;
          } else if (vm.listCheckBills[i].status == 6) {
            Toast.warning("Não pode fazer esta ação com titulos em PREJUÍZO");
            return false;
          }

          /*if (idChange == 4 && vm.isDifferentPerson(vm.listCheckBills)) {
           Toast.warning("Não pode fazer esta ação para dois fornecedores diferentes.");
           return "";
           }*/
        }
      } else {
        selected = selected + 0 + '=' + bill_id + '&';
      }
      window.location.href = '/bill/viewSelected?0=' + btoa(selected) + '&idChange=' + idChange;
    };

    /**
     * Checa de existem dois persons diferentes para negociar um grupo de despesas
     * @param list
     * @returns {boolean}
     */
    vm.isDifferentPerson = function (list) {
      if (list.length > 0) {
        var person = list[0].person_id;
        var result = false;
        for (var i = 0; i < list.length; i++) {
          if (person != list[i].person_id) {
            result = true;
            break;
          }
        }
      }
      return result;
    };

    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
    };

    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };


    vm.closeTableItem = function (idAside) {
      $mdSidenav(idAside)
        .close()
        .then(function () {
        });
    };


    vm.editBill = function (index) {
      $a4Sidenav({width: '700px'}).open(
        'app/finance/bill-receipt/views/form.html',
        'BillReceiptCreateController', 'vm', {
          bill: vm.items[index],
          edit: true
        });
    };

    /**
     * Open new item dialog
     *
     * @param ev
     * @param index
     */
    vm.openTableItem = function (ev, index) {

      if (index != null) {
        vm.currentItem = angular.copy(vm.items[index]);
        if (vm.currentItem.bill_serie_id !== undefined
          && vm.currentItem.bill_serie_id !== "" &&
          vm.currentItem.frequency !== 0 &&
          vm.currentItem.frequency !== null) {
          vm.openEditBill();
        } else {
          var id = vm.currentItem.id;
          var edit_expense = vm.currentItem.was_paid === 3 ? 4 : null;
          /**parcelas livres ou despesa simples*/

          vm.currentItem = null;
          vm.getBillById(id, edit_expense, 'sidenav-edit-form');
        }

      }
    };


    vm.openEditBill = function () {
      ModalFactory.custom("app/components/a4-table-expandable/view/a4-table-expandable-options.html", vm.currentItem)
        .then(function (resp) {

          vm.currentItem.edit_expense = resp.edit_expense;
          //vm.getBillById(vm.currentItem.id, vm.currentItem.edit_expense, resp.sidenav);
          $a4Sidenav({width: '700px'}).open('app/finance/bill-receipt/views/form.html', 'BillReceiptCreateController', 'vm', {
            bill: vm.currentItem,
            edit: true
          });

        });
    };

    vm.setPayment = function (ev, item, idAside) {
      var title = '';
      if (item.debit_credit == "C") {
        title = "Realizer recebimento";
      } else {
        title = "Realizar pagamento"
      }
      $a4Sidenav({width: '700px'}).open('app/finance/bill-payment/views/form-payment.html', 'BillPaymentController', 'vm', {
        item: item,
        title: title
      });
    };

    vm.setPaymentMultiple = function (ev, item, idAside) {
      var title = '';
      if (item[0].debit_credit === "C") {
        title = "Realizer recebimento";
      } else {
        title = "Realizar pagamento"
      }
      $a4Sidenav({width: '700px'}).open('app/finance/bill-payment/views/form-payment.html', 'BillPaymentController', 'vm', {
        item: item,
        title: title
      });
    };

    vm.undoPayment = function (ev, item, idAside) {
      $a4Sidenav({width: '700px'}).open('app/finance/bill-reverse/views/form-reverse.html', 'BillReverseController', 'vm', {item: item});
    };

    vm.setNegotiate = function (ev, item, idAside) {
      $a4Sidenav({width: '700px'}).open('app/finance/bill-negotiate/views/form-negotiate.html', 'BillNegotiateController', 'vm', {
        item: item,
        undonegotiate: false
      });
    };

    vm.undoNegotiate = function (ev, item, idAside) {
      $a4Sidenav({width: '700px'}).open('app/finance/bill-negotiate/views/form-negotiate.html', 'BillNegotiateController', 'vm', {
        item: item,
        undonegotiate: true
      });
    };

    vm.setNegotiateMultiple = function (ev, item, idAside) {
      if (vm.isDifferentPerson(items)) {
        Toast.warning("Não pode fazer esta ação para dois fornecedores diferentes.");
      } else {
        $a4Sidenav({width: '700px'}).open('app/finance/bill-negotiate/views/form-negotiate.html', 'BillNegotiateController', 'vm', {
          item: item,
          undonegotiate: false
        });
      }
    };

    /**
     * Aplica mascara financeira no padrão (R$ 0,00)
     * @param value
     * @returns {string}
     */
    vm.applyMask = function (value) {
      var currency = 0;
      if (value == 0 || value == null) {
        currency = $filter('currency')(0, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      } else if (value > 0) {
        currency = $filter('currency')(value, 'R$ ', 2);
        return currency.replace(".", ",").replace(",", ".");
      }
    };

    /**
     * Retorna o detalhamento para a despesa (juros, multa, abono...)
     * @param bill
     * @returns {string}
     */
    vm.getDetailOfBill = function (bill) {

      var result = [];


      if (bill != null) {
        var obj = {
          amount: bill.amount != null ? bill.amount : 0,
          calc_discount_cond_value: bill.calc_discount_cond_value != null ? bill.calc_discount_cond_value : 0,
          discount_fixed_value: bill.discount_fixed_value != null ? bill.discount_fixed_value : 0,
          actual_allowence: bill.actual_allowence != null ? bill.actual_allowence : 0,
          actual_discount: bill.actual_discount != null ? bill.actual_discount : 0,
          calc_interest_value: bill.calc_interest_value != null ? bill.calc_interest_value : 0,
          calc_fine_value: bill.calc_fine_value != null ? bill.calc_fine_value : 0,
          calc_discount_prom_value: bill.calc_discount_prom_value != null ? bill.calc_discount_prom_value : 0,
        };

        if (bill.debit_credit.toLowerCase() == 'd') {

          result = {
            amount: vm.applyMask(obj.amount),
            actual_discount: vm.applyMask(obj.actual_discount),
            calc_interest_value: vm.applyMask(obj.calc_interest_value),
            calc_fine_value: vm.applyMask(obj.calc_fine_value),
            calc_final_value: ''
          }


        } else if (bill.debit_credit.toLowerCase() == 'c') {

          result = {
            amount: vm.applyMask(obj.amount),
            discount_fixed_value: vm.applyMask(obj.discount_fixed_value),
            calc_discount_cond_value: vm.applyMask(obj.calc_discount_cond_value),
            calc_discount_prom_value: vm.applyMask(obj.calc_discount_prom_value),
            actual_allowence: vm.applyMask(obj.actual_allowence),
            calc_interest_value: vm.applyMask(obj.calc_interest_value),
            calc_fine_value: vm.applyMask(obj.calc_fine_value)
          }

        }
      }

      return result;

    };


    /**
     * Delete Item Confirm Dialog
     */
    vm.deleteItemConfirm = function (ev, index) {
      var item = vm.items[index];
      var confirm = $mdDialog.confirm()
        .title('Deseja remover o item selecionado?')
        .htmlContent('<b>' + item.name + '</b>' + ' será removido.')
        .ariaLabel('delete item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCELAR');

      $mdDialog.show(confirm)
        .then(function () {
          vm.deleteItem(item);
          vm.selectedItems = [];
        });
    };

    /**
     * Delete Item
     */
    vm.deleteItem = function (item) {
      vm.items.splice(vm.items.indexOf(item), 1);
    };

    /**
     * Delete Selected Items
     */
    vm.deleteSelectedItems = function (ev) {

      var confirm = $mdDialog.confirm()
        .title('Tem certeza de que deseja excluir os items selecionados?')
        .htmlContent('<b>' + vm.selectedItems.length + ' selected</b>' + ' será deletado.')
        .ariaLabel('delete contacts')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        vm.selectedItems.forEach(function (contact) {
          vm.deleteItem(contact);
        });

        vm.selectedItems = [];

      });

    };

    /**
     * Toggle selected status of the item
     *
     * @param item
     * @param event
     */
    vm.toggleSelectItem = function (item, event) {

      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedItems.indexOf(item) > -1) {
        vm.selectedItems.splice(vm.selectedItems.indexOf(item), 1);
      }
      else {
        vm.selectedItems.push(item);
      }

    };

    /**
     * Deselect items
     */
    vm.deselectItems = function () {
      vm.selectedItems = [];
    };

    /**
     * Select all items
     */
    vm.selectAllItems = function () {
      vm.selectedItems = $scope.filteredContacts;
    };

    /**
     *
     */
    vm.addNewGroup = function () {
      if (vm.newGroupName === '') {
        return;
      }

      var newGroup = {
        'id': msUtils.guidGenerator(),
        'name': vm.newGroupName,
        'contactIds': []
      };

      vm.user.groups.push(newGroup);
      vm.newGroupName = '';
    };

    /**
     * Delete Group
     */
    vm.deleteGroup = function (ev) {

      var item = vm.listType;

      var confirm = $mdDialog.confirm()
        .title('Tem certeza de que deseja excluir o grupo?')
        .htmlContent('<b>' + group.name + '</b>' + ' será deletado.')
        .ariaLabel('delete item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        vm.user.groups.splice(vm.user.groups.indexOf(item), 1);
        filterChange('all');

      });

    };

    /**
     * Toggle sidenav
     * @param sidenavId
     */
    vm.toggleSidenav = function (sidenavId) {
      if (sidenavId != undefined) {
        $mdSidenav(sidenavId).toggle();
      }

      if ($scope.includeScope && ($scope.includeScope.item && $scope.includeScope.editable)) {
        $scope.includeScope.item = null;
        $scope.includeScope.editable = false;
      }
    };

    /**
     * getTranslateValue
     * @param i
     * @param idx
     * @returns {string}
     */
    vm.getTranslateValue = function (i, idx) {
      var result = '';
      if (idx != undefined && vm.items[i] != undefined) {
        result = $filter('translate')(vm.items[i][idx]);
      }
      return result;
    };


    /**
     * Mascara para valores
     * @param i
     * @param idx
     * @returns {string}
     */
    vm.getAmountFormat = function (i, idx) {
      var result = '';
      if (idx != undefined && vm.items[i] != undefined) {
        result = $filter('currency')(vm.items[i][idx], 'R$ ', 2);
      }
      return result;
    };

    /**
     * checkVariabilites
     * @param status
     */
    vm.checkVariabilites = function (status) {
      if (status != 1) {
        var sob_demanda = 2;
        var end_date = 1;
        if (parseInt(vm.currentItem.frequency_type) == sob_demanda) {
          vm.currentItem.end_of_recurrence = end_date;
          vm.onDemand = false;
        } else {
          vm.currentItem.end_of_recurrence = end_date;
          vm.onDemand = true;
        }
      }
    };


    /**
     * template initial
     */
    vm.getBillTemplate = function () {
      return {
        'id': null,
        'debit_credit': $scope.includeScope.debit_credit,
        'tags': [],
        'end_of_recurrence': 0,
        'description': "",
        'document_reference': "",
        'frequency_type': 0,
        'frequency_qty': 1,
        'frequency': 2,
        'accrual_month': a4Moment().format('M'),
        'accrual_year': a4Moment().format('Y'),
        'discounts_rules': [],
        'files': [],
        'date_first': a4Moment(),
        'date_end': a4Moment(),
        'issue_date': a4Moment(),
        'was_paid': 1,
        'bill_details': []
      };
    };


    var ltn = $scope.$watch('items', function () {
      vm.items = [];
      vm.items = $scope.items;
    }, true);

    /**
     * open sidenav
     */
    var listener = $rootScope.$on('a4-table-expandable.open.sidenav', function (ev, data) {
      vm.openTableItem(null, null, data.idASide);
    });

    /**
     * close sidenav
     */
    var listener2 = $rootScope.$on('a4-table-expandable.close.sidenav', function (ev, data) {
      vm.closeTableItem(data.idASide);
    });


    /**
     * Destroy events
     */
    $scope.$on('$destroy', function () {
      [listener, listener2, ltn].forEach(function (fn) {
        fn();
      });
    });


    vm.init();
  }

  angular
    .module('app.a4-table')
    .controller('a4TableExpandableController', a4TableExpandableController);

})();

(function () {
  'use strict';

  angular
    .module('app.a4-table-check', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DataFilter() {
    return function (list_idx, filter_list) {

      /**
       * Filtra a lista de indices
       * @type {Array}
       */

      var result = [];

      if (filter_list != null && filter_list.length > 0) {

        angular.forEach(filter_list, function (item) {

          var map = list_idx.map(function (e) {
            return e;
          }).indexOf(item);

          if (map != -1) {
            result.push(item);
          }

        });

      } else {
        result = list_idx;
      }

      return result;
    };
  }

  angular
    .module('app.a4-table-check')
    .filter('dataFilter', DataFilter)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4TableCheck($filter) {

    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/a4-table-check/view/index.html',
      scope: {
        items: '=',
        sidebarTemplate: '@?',
        withLeftSideNav: '=?',
        withListCheckBox: '=?',
        withListOrderBy: '=?',
        withoutMenuOptions: '=?',
        onSubmit: '&',
        addCheckDescription: '&?',
        changeDueDate: '&?',
        getOperationOrigin: '&?',
        includeScope: '=?',
        selected: '=?'
      },
      controller: 'a4TableCheckController',
      controllerAs: 'vm',
      link: function (scope, element, attrs) {

        scope.withLeftSideNav = !scope.withLeftSideNav ? false : scope.withLeftSideNav;
        scope.withListCheckBox = scope.withListCheckBox === undefined || scope.withListCheckBox ? true : scope.withListCheckBox;
        scope.withListOrderBy = scope.withListOrderBy === undefined;

        var variables = {
          header_main_height: 48,
          easing_swiftOut: [0.4, 0, 0.2, 1],
          bez_easing_swiftOut: [0.4, 0, 0.2, 1]
        };

        var $billbox = angular.element('#bill-box');

        $billbox.on('ifChanged', '.select_message', function () {
          angular.element(this).is(':checked') ? angular.element(this).closest('li').addClass('md-card-list-item-selected') : angular.element(this).closest('li').removeClass('md-card-list-item-selected');
        });

        $billbox.on('click', '.md-card-list ul > li', function (e) {

          if (!angular.element(e.target).closest('.md-card-list-item-menu').length
            && !angular.element(e.target).closest('.md-card-list-item-select').length) {

            var $this = angular.element(this);

            if (!$this.hasClass('item-shown')) {
              // get height of clicked message
              var el_min_height = $this.height();

              // hide opened message
              $billbox.find('.item-shown').velocity("reverse", {
                begin: function (elements) {
                  angular.element(elements)
                    .removeClass('item-shown')
                    .children('.md-card-list-item-content-wrapper')
                    .hide()
                    .velocity("reverse");
                }
              });

              // show message
              $this.velocity({
                marginTop: 40,
                marginBottom: 40,
                marginLeft: -20,
                marginRight: -20,
                minHeight: el_min_height
              }, {
                duration: 300,
                easing: variables.easing_swiftOut,
                begin: function (elements) {
                  angular.element(elements).addClass('item-shown');
                },
                complete: function (elements) {
                  // show: message content, reply form
                  angular.element(elements).children('.md-card-list-item-content-wrapper').show().velocity({
                    opacity: 1
                  });

                  var container = angular.element('#content-container #content'),
                    scrollTo = angular.element(elements);

                  container
                    .animate({
                      scrollTop: scrollTo
                        .prop('offsetTop') + 220
                    }, 300);

                }
              });
            }
          }
        });

        // hide message on: outside click, esc button
        angular.element(document).on('click keydown', function (e) {
          if (
            ( !angular.element(e.target).closest('li.item-shown').length ) || e.which == 27) {
            $billbox.find('.item-shown').velocity("reverse", {
              begin: function (elements) {
                angular.element(elements).removeClass('item-shown').children('.md-card-list-item-content-wrapper').hide().velocity("reverse");
              }
            });
          }
        });


        if (angular.element('#floating').length) {
          var floating = angular.element('#floating');
          var originalY = floating.prop('offsetTop');
          var startFloat = 200;
          floating.css('position', 'relative');

          angular.element('#content-container #content').bind("scroll", function (event) {
            var scrollTop = angular.element('#content-container #content').scrollTop();
            floating.stop(false, false)
              .animate({top: scrollTop < startFloat ? 0 : scrollTop - originalY - startFloat}, 300);

            scope.scrolled = (scrollTop != originalY);
            scope.$apply();

          });
        }

        var data = [];

        // scope.$watch('items', function () {
        //   data = scope.items;
        // }, true);

        /**
         * Dynamic content
         * Retorna os indices baseado no array 'data' e filtra esses valores pelo array 'filter'
         * @param index
         * @returns {Array}
         */
        scope.getKeys = function (index) {
          if (scope.filter && data && data.length > 0) {
            return $filter('dataFilter')(Object.keys(data[index]), scope.filter);
          }
        };

      }
    }
  }

  angular
    .module('app.a4-table-check')
    .directive('a4TableCheck', a4TableCheck)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4TableCheckController($scope, $mdSidenav, msUtils, $mdDialog,
                                  $filter, $rootScope, PoliciesService) {
    var vm = this;

    vm.editable = true;
    vm.currentItem = {
      frequency_type: 0
    };
    vm.listLength = 0;
    vm.listCheckBills = [];
    vm.onDemand = false;
    vm.items = [];
    vm.user = [];
    vm.filterIds = null;
    vm.listType = 'all';
    vm.listOrder = 'name';
    vm.listOrderAsc = false;
    vm.selectedItems = [];
    vm.newGroupName = '';
    vm.toggle = {};
    vm.exists = msUtils.exists;
    vm.toggleInArray = msUtils.toggleInArray;

    vm.init = function () {
      /*$timeout(function () {
       $mdSidenav('sidenav-edit-form' || 'sidenav-create-form').onClose(function () {
       vm.currentItem = {};
       });
       }, 200);*/
    };

    $scope.$watch('items', function () {
      vm.items = [];
      vm.items = $scope.items;
    }, true);

    vm.toggleInfo = function () {
      angular.element('#infosc').slideToggle("slow");
      angular.element('#infos').slideToggle("slow");
    };

    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
      $scope.selected = list;
    };

    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    vm.disableRecurrenceFields = function () {
      vm.disableRadio = true;
    };

    /**
     * open sidenav
     */
    var listener = $rootScope.$on('a4-table-expandable.open.sidenav', function (ev, data) {
      vm.openTableItem(null, null, data.idASide);
    });

    /**
     * close sidenav
     */
    var listener2 = $rootScope.$on('a4-table-expandable.close.sidenav', function (ev, data) {
      vm.closeTableItem(data.idASide);
    });

    vm.closeTableItem = function (idAside) {
      $mdSidenav(idAside)
        .close()
        .then(function () {
        });
    };

    /**
     * Open new item dialog
     * @param ev
     * @param item
     */
    vm.openTableItem = function (ev, index, idAside) {
      vm.openCreateForm(idAside);
    };

    /**
     * Delete Item Confirm Dialog
     */
    vm.deleteItemConfirm = function (ev, index) {
      var item = vm.items[index];
      var confirm = $mdDialog.confirm()
        .title('Deseja remover o item selecionado?')
        .htmlContent('<b>' + item.name + '</b>' + ' será removido.')
        .ariaLabel('delete item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCELAR');

      $mdDialog.show(confirm)
        .then(function () {
          vm.deleteItem(item);
          vm.selectedItems = [];
        });
    };

    /**
     * Delete Item
     */
    vm.deleteItem = function (item) {
      vm.items.splice(vm.items.indexOf(item), 1);
    };

    /**
     * Delete Selected Items
     */
    vm.deleteSelectedItems = function (ev) {

      var confirm = $mdDialog.confirm()
        .title('Tem certeza de que deseja excluir os items selecionados?')
        .htmlContent('<b>' + vm.selectedItems.length + ' selected</b>' + ' será deletado.')
        .ariaLabel('delete contacts')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        vm.selectedItems.forEach(function (contact) {
          vm.deleteItem(contact);
        });

        vm.selectedItems = [];

      });

    };

    /**
     * Toggle selected status of the item
     *
     * @param item
     * @param event
     */
    vm.toggleSelectItem = function (item, event) {

      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedItems.indexOf(item) > -1) {
        vm.selectedItems.splice(vm.selectedItems.indexOf(item), 1);
      }
      else {
        vm.selectedItems.push(item);
      }

    };

    /**
     * Deselect items
     */
    vm.deselectItems = function () {
      vm.selectedItems = [];
    };

    /**
     * Toggle sidenav
     * @param sidenavId
     */
    vm.toggleSidenav = function (sidenavId) {
      if (sidenavId != undefined) {
        $mdSidenav(sidenavId).toggle();
      }

      if ($scope.includeScope && ($scope.includeScope.item && $scope.includeScope.editable)) {
        $scope.includeScope.item = null;
        $scope.includeScope.editable = false;
      }
    };

    /**
     * getTranslateValue
     * @param i
     * @param idx
     * @returns {string}
     */
    vm.getTranslateValue = function (i, idx) {
      var result = '';
      if (idx != undefined && vm.items[i] != undefined) {
        result = $filter('translate')(vm.items[i][idx]);
      }
      return result;
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Destroy events
     */
    $scope.$on('$destroy', function () {
      [listener, listener2].forEach(function (fn) {
        fn();
      });
    });

    vm.init();
  }

  angular
    .module('app.a4-table-check')
    .controller('a4TableCheckController', a4TableCheckController);

})();

(function(){
  'use strict';

  angular
    .module('app.a4-table-advanced', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4TableAdvanced($filter, $rootScope, BillReverseService) {
    return {
      restrict: "E",
      scope: {
        list: '=',
        bill: '=',
        addsource: '=',
        totalcurrency: '=',
        waspaid: '=',
        edit: '=',
        block: "@",
        type: "=",
        disablecategory: "=",
        hidecategory: "=",
        disabledescription: "=",
        hidedescription: "=",
        disablevalue: "=",
        readonly: "=",
        hidevalue: "=",
        hideadditem: "="
      },
      template: '<div ng-include="getContentUrl()"></div>',
      link: function (scope, element, attrs, ctrl) {

        scope.readonly = !!(scope.readonly);

        if (typeof scope.hidecategory === undefined) {
          scope.hidecategory = false;
        }
        if (typeof scope.hidedescription === undefined) {
          scope.hidedescription = false;
        }
        if (typeof scope.hidevalue === undefined) {
          scope.hidevalue = false;
        }
        if (typeof scope.block === undefined) {
          scope.block = false;
        }
        if (typeof scope.disabledescription === undefined) {
          scope.disabledescription = false;
        }
        if (typeof scope.disablevalue === undefined) {
          scope.disablevalue = false;
        }
        if (typeof scope.disablecategory === undefined) {
          scope.disablecategory = false;
        }
        if (typeof scope.hideadditem === undefined) {
          scope.hideadditem = false;
        }

        $rootScope.$on('advanceTable.hideFields', function (e, value) {

          if (value != null && value.length > 0) {
            for (var i = 0, len = value.length; i < len; i++) {
              switch (value[i]) {
                case 'description':
                  if (typeof scope.hidedescription === undefined) {
                    scope.hidedescription = true;
                  }
                  break;
                case 'value':
                  if (typeof scope.hidevalue === undefined) {
                    scope.hidevalue = true;
                  }
                  break;
                case 'category':
                  if (typeof scope.hidecategory === undefined) {
                    scope.hidecategory = true;
                  }
                  break;
                case 'additem':
                  if (typeof scope.hideadditem === undefined) {
                    scope.hideadditem = true;
                  }
                  break;
              }
            }
          }
        });

        $rootScope.$on('advanceTable.disableFields', function (e, value) {

          if (value != null && value.length > 0) {
            for (var i = 0, len = value.length; i < len; i++) {
              switch (value[i]) {
                case 'description':
                  if (typeof scope.disabledescription === undefined) {
                    scope.disabledescription = true;
                  }
                  break;
                case 'value':
                  if (typeof scope.disablevalue === undefined) {
                    scope.disablevalue = true;
                  }
                  break;
                case 'category':
                  if (typeof scope.disablecategory === undefined) {
                    scope.disablecategory = true;
                  }
                  break;

              }
            }
          }
        });

        /**
         * Ouvinte para o broadcast 'advanceTable.enableFields'
         * para ativar os campos desabilitados inicialmente
         */
        $rootScope.$on('advanceTable.enableFields', function (e, value) {
          if (value.length !== undefined) {
            for (var i = 0, len = value.length; i < len; i++) {
              switch (value[i]) {
                case 'description':
                  scope.disabledescription = false;
                  break;
                case 'value':
                  scope.disablevalue = false;
                  break;
                case 'category':
                  scope.disablecategory = false;
                  break;

              }
            }
          }
        });

        scope.getContentUrl = function () {
          return '/app/components/a4-table-advanced/view/' + attrs.templatename + '.html';
        };
        var listener = $rootScope.$on('UpdateTotalAmountPayment', function (event, value) {
          scope.totalcurrencyPayment = value;

        });

        scope.diference = {
          error: false,
          allowPayDiff: false,
          diff: 0,
          message: ''
        };

        scope.payment_method = [
          {id: 1, name: "Dinheiro"},
          {id: 2, name: "Cheque"},
          {id: 5, name: "Cheque de terceiros"},
          {id: 10, name: "Boleto"},
          {id: 11, name: "Depósito"},
          {id: 12, name: "Transferência"},
          {id: 20, name: "Cartão de débito"},
          {id: 21, name: "Cartão de crédito"},
          {id: 22, name: "Débito automático"}
        ];

        scope.getPaymentsMethod = function () {
          BillReverseService.getAllMovementsType()
            .then(function (response) {
              scope.payment_method = response;
            });
        };

        scope.getCurrentAccounts = function () {
          BillReverseService.getAllCurrentAccounts()
            .then(function (response) {
              scope.currentAccounts = response;
            })
            .catch(function (response) {

            });
        };

        scope.getBillCategories = function (type) {
          BillReverseService.getCategoriesByType('D')
            .then(function (response) {
              scope.billCategories = response;
            })
            .catch(function (response) {

            });
        };

        scope.clearListener = function () {
          $rootScope.$$listeners.UpdateTotalAmountPayment = null;
          listener();
        };

        /**
         *
         * @returns {void}
         */
        scope.calcAmount = function () {
          scope.totalcurrency = 0;
          angular.forEach(scope.list, function (value, key) {
            scope.totalcurrency += value.amount;
          });
        };
        /**
         * Faz o update do
         * @returns {void}
         */
        scope.setValuePayment = function ($index, item) {
          $rootScope.$broadcast('UpdateTotalAmountPayment', scope.totalcurrency);
          var totalAteAgora = scope.paidUntilNow();
          angular.forEach(scope.list, function (value, key) {
            if (key == $index &&
              (scope.list[key].amount == undefined ||
                isNaN(scope.list[key].amount) ||
                scope.list[key].amount == 0)) {
              if (totalAteAgora > scope.totalcurrencyPayment) {
                scope.list[key].amount = 0;
              } else {
                scope.list[key].amount = scope.totalcurrencyPayment - totalAteAgora;
              }
            }
          });
          scope.calcAmountPayment();
        };

        scope.paidUntilNow = function () {
          var totalAteAgora = 0;
          angular.forEach(scope.list, function (value, key) {
            if (scope.list[key].amount != undefined && !isNaN(scope.list[key].amount)) {
              totalAteAgora += parseFloat(scope.list[key].amount);
            }
          });
          return totalAteAgora;
        }


        /**
         *
         * @returns {undefined}
         */
        scope.setPaymentMethod = function (current_account_id) {
          var CONTA_BANCO = 1;
          var CARTAO_DE_CREDITO = 5;
          var selected = $filter('filter')(scope.currentAccounts, {id: current_account_id})[0];
          switch (selected.current_account_type_id) {
            case CONTA_BANCO:
              break;
            case CARTAO_DE_CREDITO:
              break;
            default :
              scope.payment_method = scope.payment_method;
              break;
          }
        };
        scope.payWithDiff = function (payment_with_difference) {
          if (payment_with_difference) {
            scope.diference.message = $filter('translate')('MSG_PAY_WITH_DIFFERENCE')
              + scope.applyMask(scope.diference.diff) +
              $filter('translate')('MSG_PAY_WITH_DIFFERENCE_1');
          } else {
            scope.calcAmountPayment();
          }
        }


        /**
         *
         * @returns {undefined}
         */
        scope.calcAmountPayment = function () {
          scope.totalcurrencyPayment = 0;
          scope.is_diference = false;
          angular.forEach(scope.list, function (value, key) {
            scope.totalcurrencyPayment += parseFloat(value.amount);
          });

          if (scope.totalcurrencyPayment > scope.totalcurrency) {
            scope.is_diference = true;
            var diff = scope.totalcurrencyPayment - scope.totalcurrency;
            scope.diference.allowPayDiff = false;
            scope.diference.diff = diff;
            scope.diference.error = true;
            scope.bill.error = scope.diference.error
            scope.diference.message = $filter('translate')('MSG_EXISTS_R$')
              + scope.applyMask(diff) +
              $filter('translate')('MSG_EXISTS_R$_1');
            scope.bill.payment_with_difference = false;

          }
          if (scope.totalcurrencyPayment < scope.totalcurrency) {
            scope.is_diference = true;
            var diff = scope.totalcurrency - scope.totalcurrencyPayment;
            scope.diference.allowPayDiff = true;
            scope.diference.error = true;
            scope.bill.error = scope.diference.error
            scope.diference.diff = diff;
            scope.diference.message = $filter('translate')('MSG_STILL_EXISTS')
              + scope.applyMask(diff) +
              $filter('translate')('MSG_STILL_EXISTS_1');

          }
          if ((scope.totalcurrencyPayment < scope.totalcurrency) && (scope.verifySupliers(scope.bill))) {
            scope.is_diference = true;
            var diff = scope.totalcurrency - scope.totalcurrencyPayment;
            scope.diference.allowPayDiff = true;
            scope.diference.error = true;
            scope.bill.error = scope.diference.error
            scope.diference.diff = diff;
            scope.diference.message = $filter('translate')('MSG_STILL_EXISTS')
              + scope.applyMask(diff) +
              $filter('translate')('MSG_STILL_EXISTS_2');

          }
          if ((scope.totalcurrencyPayment === scope.totalcurrency) && (scope.totalcurrency != 0)) {
            scope.is_diference = false;
            scope.diference.allowPayDiff = false;
            scope.diference.error = false;
            scope.bill.error = scope.diference.error;
            scope.diference.diff = 0;
            scope.diference.message = "";
            scope.bill.payment_with_difference = false;

          }
        };
        scope.applyMask = function (value) {
          if (value > 0) {
            var currency = $filter('currency')(value, 'R$', 2);
            return currency.replace(".", ",").replace(",", ".");
          }
        };
        scope.remove = function (index) {
          var response = confirm($filter('translate')('MSG_REMOVE_CONFIRMATION'));

          if (response) {
            scope.list.splice(index, 1);
            if (attrs.templatename == 'payment_form') {
              scope.calcAmountPayment();
            } else {
              scope.calcAmount();
            }

          }
        };


        scope.addBlankItem = function (status) {
          if (typeof scope.list == 'undefined' && status == undefined) {
            scope.list = [];
            scope.inserted = {
              idx: scope.list.length + 1
            };
            scope.list.push(scope.inserted);
          }
          if (status == 'edit') {
            scope.inserted = {
              idx: scope.list.length + 1
            };
            scope.list.push(scope.inserted);
          }
          if (attrs.templatename == 'payment_form') {
            scope.setValuePayment(scope.list.length - 1);
          }

        };

        /**
         * Verifica se há mais de um fornecedor para ações, se sim, não é permitivo
         * fazer um pagamento com diferença.
         * @param {type} bills - Lista de titulos
         * @returns {Boolean} Se True existe mais de um fornecedor na lista;
         */
        scope.verifySupliers = function (bills) {
          if (bills.length == undefined || bills.length == 1) {
            return false;
          } else {
            var any_person = bills[0].person_name;
            for (var i = 0; i < bills.length; i++) {
              if (bills[i].person_name != any_person) {
                return true;
              }
            }
          }
          return false;
        }


        scope.addBlankItem();
        scope.getCurrentAccounts();
        scope.getBillCategories(scope.type);
        scope.getPaymentsMethod();
      }
    };
  }

  angular
    .module('app.a4-table-advanced')
    .directive('a4TableAdvanced', a4TableAdvanced);
})();

(function () {
  'use strict';

  /** @ngInject */
  function DataFilter() {
    return function (list_idx, filter_list) {

      /**
       * Filtra a lista de indices
       * @type {Array}
       */

      var result = [];

      if (filter_list != null && filter_list.length > 0) {

        angular.forEach(filter_list, function (item) {

          var map = list_idx.map(function (e) {
            return e;
          }).indexOf(item);

          if (map != -1) {
            result.push(item);
          }

        });

      } else {
        result = list_idx;
      }

      return result;
    };
  }

  angular
    .module('app.a4-table')
    .filter('dataFilter', DataFilter)
})();

(function () {
  'use strict';
  function A4Table() {
    var provide = this;



    provide.$get = {

    };

    return provide;

  }

  angular
    .module('app.a4-table')
    .provider('A4Table', A4Table);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4Table($filter) {

    /**
     * @param {array} items - Dados de listagem
     * @param {array} filter - Filtragem de colunas da lista;
     * @param {array} menuGroup - Agrupamento de menu para cada item;
     * @param {string} sidebarTemplate - url para template do sidebar;
     * @param {boolean} withLeftSideNav - default: false, Menu de agrupamento ao lado esquedo da lista;
     * @param {boolean} withListCheckBox - default: true, Define visibilidade do checkbox;
     * @param {function} onDelete - ao clicar no item excluir, o onDelete é rastreado para uma função fora do scopo;
     * @param {function} onSubmit;
     * @param {function} includeScope - Objeto de configuração da diretiva;
     * @returns {}
     */
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/a4-table/view/index.html',
      scope: {
        items: '=',
        filter: '=',
        menuGroup: '=',
        sidebarTemplate: '@',
        withLeftSideNav: '=?',
        withListCheckBox: '=?',
        withListOrderBy: '=?',
        withoutMenuOptions: '=?',
        onChange: '&',
        onDelete: '&',
        onSubmit: '&',
        includeScope: '='
      },
      controller: 'a4TableController',
      controllerAs: 'vm',
      link: function (scope, element, attrs) {

        scope.withLeftSideNav = !scope.withLeftSideNav ? false : scope.withLeftSideNav;
        scope.withListCheckBox = scope.withListCheckBox === undefined || scope.withListCheckBox ? true : scope.withListCheckBox;
        scope.withListOrderBy = scope.withListOrderBy === undefined ? true : false;

        var data = [];

        scope.$watch('items', function () {
          data = scope.items;
        }, true);

        /**
         * Dynamic content
         * Retorna os indices baseado no array 'data' e filtra esses valores pelo array 'filter'
         * @param index
         * @returns {Array}
         */
        scope.getKeys = function (index) {
          if (scope.filter && data && data.length > 0) {
            return $filter('dataFilter')(Object.keys(data[index]), scope.filter);
          }
        };

      }
    }
  }

  angular
    .module('app.a4-table')
    .directive('a4Table', a4Table)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4TableController($scope, $mdSidenav, msUtils, $mdDialog, $filter, $log, $rootScope, $timeout, $state,
                             $a4Sidenav, PoliciesService) {

    var vm = this;

    vm.editable = true;
    vm.currentItem = null;

    vm.items = [];
    vm.user = [];
    vm.filterIds = null;
    vm.listType = 'all';
    vm.listOrder = 'name';
    vm.listOrderAsc = false;
    vm.selectedItems = [];
    vm.newGroupName = '';

    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;

    $scope.$watch('items', function () {
      vm.items = [];
      vm.items = $scope.items;
    }, true);

    /**
     * open sidenav
     */
    var listener = $rootScope.$on('a4.table.open.sidenav', function (ev, params) {
      vm.openTableItem(null, null, 'sidenav-form', params);
    });

    /**
     * close sidenav
     */
    var listener2 = $rootScope.$on('a4.table.close.sidenav', function () {
      vm.closeTableItem();
    });

    vm.init = function () {
      $timeout(function () {
        $mdSidenav('sidenav-form').onClose(function () {
          vm.currentItem = {};
        });
      }, 200);
    };

    /**
     * Change Items List Filter
     * @param type
     */
    vm.filterChange = function () {

      vm.listType = type;

      if (type === 'all') {
        vm.filterIds = null;
      }
      else if (angular.isObject(type)) {
        vm.filterIds = type.contactIds;
      }
      vm.selectedItems = [];
    };

    vm.closeTableItem = function () {
      $mdSidenav('sidenav-form')
        .close()
        .then(function () {
          $log.debug('closed');
        });
    };

    /**
     * Open new item dialog
     *
     * @param ev
     * @param item
     */
    vm.openTableItem = function (ev, index, idAside, params) {
      if (index != null) {
        //edit

          if(params.hasOwnProperty('templateSrc')){
            vm.editA4Sidenav(index,params);
          }else{
            vm.currentItem = angular.copy(vm.items[index]);
          }

      } else {
        //create
        vm.currentItem = angular.isDefined(params) ? params : null;
      }
      if(params != undefined && params.profile){
        $state.go('private.finance.person-profile', {person: vm.currentItem, id: vm.currentItem.id});
      } else {
        $mdSidenav(idAside).toggle()
          .then(function () {
            $rootScope.$broadcast('a4-table.toggled', vm.currentItem);
          });
      }

    };

    vm.editA4Sidenav  = function(index, includeScope){
      vm.currentItem = angular.copy(vm.items[index]);
      var name = includeScope.itemName;

      $a4Sidenav({width:'700px'}).open(
        includeScope.templateSrc,
        includeScope.controller,
        includeScope.controllerAs,
        {
          objectName: vm.currentItem,
          edit: true
        }
      );
    };


    /**
     * Delete Item Confirm Dialog
     */
    vm.deleteItemConfirm = function (ev, index) {
      var item = vm.items[index];
      var confirm = $mdDialog.confirm()
        .title('Deseja remover o item selecionado?')
        .htmlContent('<b>' + item.name + '</b>' + ' será removido.')
        .ariaLabel('delete item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCELAR');

      $mdDialog.show(confirm)
        .then(function () {

          vm.deleteItem(item);
          vm.selectedItems = [];

        });
    };

    /**
     * Delete Item
     */
    vm.deleteItem = function (item) {
      vm.items.splice(vm.items.indexOf(item), 1);
    };

    /**
     * Delete Selected Items
     */
    vm.deleteSelectedItems = function (ev) {

      var confirm = $mdDialog.confirm()
        .title('Tem certeza de que deseja excluir os items selecionados?')
        .htmlContent('<b>' + vm.selectedItems.length + ' selected</b>' + ' será deletado.')
        .ariaLabel('delete contacts')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        vm.selectedItems.forEach(function (contact) {
          vm.deleteItem(contact);
        });

        vm.selectedItems = [];

      });

    };

    /**
     * Toggle selected status of the item
     *
     * @param item
     * @param event
     */
    vm.toggleSelectItem = function (item, event) {

      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedItems.indexOf(item) > -1) {
        vm.selectedItems.splice(vm.selectedItems.indexOf(item), 1);
      }
      else {
        vm.selectedItems.push(item);
      }

    };

    /**
     * Deselect items
     */
    vm.deselectItems = function () {
      vm.selectedItems = [];
    };

    /**
     * Select all items
     */
    vm.selectAllItems = function () {
      vm.selectedItems = $scope.filteredContacts;
    };

    /**
     *
     */
    vm.addNewGroup = function () {
      if (vm.newGroupName === '') {
        return;
      }

      var newGroup = {
        'id': msUtils.guidGenerator(),
        'name': vm.newGroupName,
        'contactIds': []
      };

      vm.user.groups.push(newGroup);
      vm.newGroupName = '';
    };

    /**
     * Delete Group
     */
    vm.deleteGroup = function (ev) {
      var item = vm.listType;

      var confirm = $mdDialog.confirm()
        .title('Tem certeza de que deseja excluir o grupo?')
        .htmlContent('<b>' + group.name + '</b>' + ' será deletado.')
        .ariaLabel('delete item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        vm.user.groups.splice(vm.user.groups.indexOf(item), 1);
        filterChange('all');

      });

    };

    /**
     * Toggle sidenav
     * @param sidenavId
     */
    vm.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();

      if ($scope.includeScope && ($scope.includeScope.item && $scope.includeScope.editable)) {
        $scope.includeScope.item = null;
        $scope.includeScope.editable = false;
      }
    };

    /**
     * getTranslateValue
     * @param i
     * @param idx
     * @returns {string}
     */
    vm.getTranslateValue = function (i, idx) {
      var result = '';
      if (idx != undefined && vm.items[i] != undefined) {
        result = $filter('translate')(vm.items[i][idx]);
      }
      return result;
    };

    vm.getAmountFormat = function (i, idx) {
      var result = '';
      if (idx != undefined && vm.items[i] != undefined) {
        result = $filter('currency')(vm.items[i][idx], 'R$ ', 2);
      }
      return result;
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Destroy events
     */
    $scope.$on('$destroy', function () {
      [listener, listener2].forEach(function (fn) {
        fn();
      });
    });

    vm.init();
  }

  angular
    .module('app.a4-table')
    .controller('a4TableController', a4TableController);

})();

(function () {
  'use strict';
  angular.module('app.a4-switch-button', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4SwitchButton($filter, $timeout) {
    return {
      restrict: 'E',
      required: 'ngModel',
      scope: {
        states: "=",
        model: "=ngModel",
        change: "&?",
        onClick: "&?",
        item: "=?",
        formatString: "=?"
      },
      controller: 'a4SwitchButtonController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-switch-button/a4-switch-button.html',
      link: function (scope, elem, attrs, ctrl) {
        /** Executa a verificação de itens obrigatórios no objeto */
        ctrl.verifyObject(scope.states);
        ctrl.setDefaultProperties(scope.states);

        scope.init = function () {
          scope.selected_button = {};
          scope.selected_id = 1;
          /** Define o primeiro botão a aparecer */
          if (angular.isDefined(scope.states) && angular.isArray(scope.states) && scope.states.length > 0 && scope.formatString) {
            scope.selected_button = $filter('filter')(scope.states, {$$id: 1})[0];
          } else if (!scope.formatString) {
            scope.selected_id = scope.model;
          }

          if (angular.isDefined(scope.model) && scope.model !== null) {
            scope.selected_button = $filter('filter')(scope.states, {value: scope.model})[0];
          } else {
            scope.model = scope.selected_button.value;
          }
        };

        /**
         * Executa a mudança de botão
         */
        scope.changeItem = function () {
          scope.selected_id = scope.selected_id + 1;
          if (scope.selected_id <= scope.states.length) {
            scope.selected_button = $filter('filter')(scope.states, {$$id: scope.selected_id})[0];
          } else {
            scope.selected_id = 1;
            scope.selected_button = $filter('filter')(scope.states, {$$id: scope.selected_id})[0];
          }

          scope.model = scope.selected_button.value;
          if (scope.$$phase) {
            scope.$apply();
          }

          $timeout(function () {
            if (angular.isDefined(scope.item) && scope.formatString) {
              scope.formatString(scope.item, scope.model);
            }
          }, 20);

        };

        scope.init();
      }
    }
  }

  angular
    .module('app.a4-switch-button')
    .directive('a4SwitchButton', a4SwitchButton);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4SwitchButtonController() {
    var vm = this;

    /**
     * Insere propriedades padrão
     * @param list - Lista de botões
     */
    vm.setDefaultProperties = function (list) {
      list.forEach(function (value, key) {
        value.$$id = (key + 1);
      });
    };

    /**
     * Verifica os parametros obrigatórios do objeto
     * @param list
     */
    vm.verifyObject = function (list) {
      var error = {};
      error.exists = false;
      error.message = 'Atributo(s) ';

      list.forEach(function (value) {
        if (angular.isUndefined(value.textButton)) {
          error.exists = true;
          error.message += ', textButton'
        }
        if (angular.isUndefined(value.background)) {
          error.exists = true;
          error.message += ', background'
        }

        if (angular.isUndefined(value.color)) {
          error.exists = true;
          error.message += ', color'
        }

        if (angular.isUndefined(value.value)) {
          error.exists = true;
          error.message += ', value'
        }
        /** se a flag de erro for positiva, então o erro é enviado a tela */
        if (error.exists) {
          error.message += ' é/são obrigatório(s) no objeto. ' + JSON.stringify(value);
          throw new Error(error.message);
        }
      });
    }
  }

  angular
    .module('app.a4-switch-button')
    .controller('a4SwitchButtonController', a4SwitchButtonController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function SubjectsStudentsDependencyController($document, StudentsService, CONFIG, $rootScope, $scope, $state, EnrolmentService, Common, ModalFactory,
                                                EducationalService, Session, CoordinatorsService, a4Moment, SubjectService) {

    var vm = this;
    vm.person_id = $state.params.id;
    vm.course_id = $state.params.course_id;
    vm.group_id = $state.params.group_id;
    vm.course_equivalence_id = $state.params.course_equivalence_id;
    vm.enrolment_period_id = $state.params.enrolment_period_id;
    vm.data = [];
    vm.years = [];
    vm.group = {name: null};
    vm.dependency_year = null;
    vm.selected_subjects = [];
    vm.WEB_CONST = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.coursesAndGroups = [];
    vm.show_loader = false;

    vm.col_defs_services = [
      {}
    ];
    vm.expanding_property = {
      field: "text",
      displayName: "Cursos e turmas",
      cellTemplate: "<span>{{row.branch[expandingProperty.field]}}</span>"
    };

    vm.init = function () {
      vm.show_loader = true;
      for (var i2 = 1; i2 <= 10; i2++) {
        var momentVar3 = a4Moment().subtract('year', i2);
        vm.years.push({id: momentVar3.year(), name: momentVar3.format('YYYY')});
      }
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      CoordinatorsService.getTree({course_equivalence_id: vm.course_equivalence_id})
        .then(function (response) {
          vm.show_loader = false;
          vm.coursesAndGroups = response.plain();
        });
    };

    vm.selectGroup = function (item) {
      vm.show_loader = true;
      vm.group = item;
      SubjectService.getSubjectsGroup({group_id: item.group_id})
        .then(function (resp) {
          vm.show_loader = false;
          vm.subjects_list = resp.plain();
        })
    };

    /**
     * Realiza a matrícula nas dependências
     */
    vm.enrolmentDependency = function () {
      EnrolmentService.enrolmentDependency({
        subjects: vm.selected_subjects,
        group_id: vm.group.group_id,
        year: vm.dependency_year,
        enrolment_period_id: vm.enrolment_period_id
      })
        .then(function (resp) {
          vm.closeModal(resp);
          Common.Toast.success('Matrícula em dependência realizada com sucesso.');
        })
        .catch(function () {
          Common.Toast.error('Erro ao realizar matrícula em dependência.');
        })
    };

    vm.closeModal = function (response) {
      $rootScope.$broadcast('ModalFactory.close', response);
    };

    vm.init();
  }

  angular
    .module('app.educational.students.subjects')
    .controller('SubjectsStudentsDependencyController', SubjectsStudentsDependencyController);
})();
(function () {
  'use strict';
  angular.module('app.a4-subject-grid', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4SubjectGrid($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        personId: '=?',
        courseId: '=?',
        groupId: '=?',
        courseEquivalenceId: '=?',
        courseEnrolmentSystemId: '=?',
        enrolmentPeriodId: '=?',
        matrixPeriod: '=?',
        isEnrolment: '=?'
      },
      controller: 'a4SubjectGridController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-subject-grid/views/subjects.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4-subject-grid')
    .directive('a4SubjectGrid', a4SubjectGrid);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4SubjectGridController($document, StudentsService, CONFIG, $rootScope, $scope, $state, EnrolmentService, Common, ModalFactory,
                                   EducationalService, Session, ReportsService) {

    var vm = this;
    vm.person_id = $scope.personId;
    vm.course_id = $scope.courseId;
    vm.group_id = $scope.groupId;
    vm.school_period = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
    vm.course_equivalence_id = $scope.courseEquivalenceId;
    vm.course_enrolment_system_id = $scope.courseEnrolmentSystemId;
    vm.enrolment_period_id = $scope.enrolmentPeriodId;
    vm.matrix_period = $scope.matrixPeriod;
    vm.data = [];
    vm.WEB_CONST = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.current_profile = Session.getCurrentProfile();
    vm.is_student = 1;


    vm.init = function () {
      vm.profile = Session.getProfile();
      vm.getEnrolmentMatrix();
      vm.getSchoolPeriod();
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
          vm.conf.current_school_period_id = vm.school_period;
        });
    };

    /**
     * Resgata os períodos letivos
     */
    vm.getSchoolPeriod = function () {
      EducationalService.getSchoolsPeriod()
        .then(function (periods) {
          vm.school_periods = periods.list;
          vm.current_school_period_id = angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod().id : Session.getCurrentSchoolPeriod();
          vm.school_period_default_enrolment_id = periods.default_enrolment[0].id;
          vm.school_period_default_enrolment_name = periods.default_enrolment[0].name;
        })
    };

    /**
     * Retorna todas as classes do aluno
     */
    vm.getEnrolmentMatrix = function () {
      $rootScope.show_loader = true;
      StudentsService.getEnrolmentMatrix({
        person_id: vm.person_id,
        course_id: vm.course_id,
        enrolment_period_id: vm.enrolment_period_id
      })
        .then(function (response) {
          vm.data = response.plain();
          $rootScope.show_loader = false;
        }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao buscar disciplinas.');
      });
    };

    vm.modalDetailsStatus = function (item, status, title) {
      ModalFactory.customClean(
        'app/components/a4-subject-grid/views/modal-details-item.html',
        /** @ngInject */
        function ($rootScope, $mdDialog, ModalExtra, CollaboratorsService) {
          var vm = this;
          vm.scope = ModalExtra;
          vm.getFormInfos = function () {
            CollaboratorsService.getInfos()
              .then(function (response) {
                vm.person_educational_level = response.person.person_educational_level_id;
              })
          };
          vm.answer = function () {
            $mdDialog.hide(vm.scope.item);
          };
          vm.closeModal = function () {
            $mdDialog.cancel();
          };
          vm.getFormInfos();
        }, 'vm', false, {
          item: angular.copy(item),
          title: title,
          school_periods: vm.school_periods
        }
      ).then(function (data) {
        vm.changeStatus(data, status);
      });
    };

    /**
     * Modifica o status de uma matrícula em disciplina
     * @param item
     * @param status
     */
    vm.changeStatus = function (item, status) {
      $rootScope.show_loader = true;
      EnrolmentService.changeStatusEnrolmentSubject({
        enrolment_period_id: item.enrolment_period_id !== null ? item.enrolment_period_id : vm.enrolment_period_id,
        enrolment_status_id: item.enrolment_status_id,
        subject_id: item.subject_id,
        group_id: item.group_id,
        matrix_period: item.matrix_period,
        person_id: vm.person_id,
        status: status,
        external_school_period: angular.isDefined(item.external_school_period) ? item.external_school_period : null,
        teacher_name: angular.isDefined(item.teacher_name) ? item.teacher_name : null,
        person_educational_level_id: angular.isDefined(item.person_educational_level_id) ? item.person_educational_level_id : null,
        final_grade: angular.isDefined(item.final_grade) ? item.final_grade : null
      }).then(function () {
        vm.getEnrolmentMatrix();
        Common.Toast.success('Situação atualizada com sucesso!');
      }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao atualizar situação.');
      });
    };

    vm.getGroupsEnrolment = function (item) {
      EnrolmentService.getGroupsEnrolment({
        subject_id: item.subject_id,
        course_id: vm.course_id,
        group_id: vm.group_id,
        person_id: vm.person_id
      })
        .then(function (response) {
          $rootScope.show_loader = false;
          ModalFactory.customClean(
            'app/components/a4-subject-grid/views/select-group-enrolment.html',
            /** @ngInject */
            function ($rootScope, $mdDialog, ModalExtra, $filter) {
              var vm = this;
              vm.groups = ModalExtra.groups;
              if (ModalExtra.group_enrolled === null) {
                vm.filtered = $filter('filter')(vm.groups, {'group_order': 1, 'subject_id': ModalExtra.subject_id})[0];
              } else {
                vm.filtered = $filter('filter')(vm.groups, {
                  'group_order': 1,
                  'subj_group_id': ModalExtra.subject_id + '_' + ModalExtra.group_enrolled + '_' + ModalExtra.matrix_period
                })[0];
              }
              vm.group_id = angular.isDefined(vm.filtered) ? vm.filtered.subj_group_id : null;
              vm.subject_name = ModalExtra.subject_name;
              vm.submit = function (group_id) {
                $mdDialog.hide($filter('filter')(vm.groups, {'subj_group_id': group_id})[0]);
              };
              vm.closeModal = function () {
                $mdDialog.cancel();
              };
            }, 'vm', false, {
              groups: response.plain(), subject_name: item.subject_name, group_enrolled: item.group_id,
              subject_id: item.subject_id, group_id: vm.group_id, matrix_period: item.matrix_period
            }
          ).then(function (group) {
            vm.doEnrolment(group);
          })
        }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao atualizar situação.');
      });
    };

    /**
     * Adiciona uma dependência para aluno de ensino básico
     */
    vm.addDependency = function () {
      ModalFactory.customClean(
        'app/components/a4-subject-grid/views/add-dependency.html',
        'SubjectsStudentsDependencyController',
        'vm', false, {}
      )
        .then(function () {
          vm.getEnrolmentMatrix();
        });
    };

    vm.printHistory = function () {
      $rootScope.show_loader = true;
      EnrolmentService.getSchoolRecordsObservation({
        enrolment_period_id: vm.enrolment_period_id
      }).then(function (notes) {
        ModalFactory.custom('app/components/a4-subject-grid/views/modal-print-records.html', {
          history_superior_option: 1,
          recordsCheckbox: 2,
          repeat_pendent_subjects: false,
          include_subjects_without_enrolment: false,
          not_include_teacher_column: false,
          individual_observation: angular.isUndefined(notes) ? null : notes,
          course_observation: null,
          print_complementar_on_another_page: true,
          only_approved_or_on_course: false,
          order_by: 1
        }).then(function (response) {
          EnrolmentService.saveSchoolRecordsObservation({
            enrolment_period_id: vm.enrolment_period_id,
            school_records_notes: response.individual_observation
          }).then(function () {
            $rootScope.show_loader = false;
            var href = vm.WEB_CONST + 'api/superiorschoolrecords/report/' + vm.person_id
              + '?token=' + vm.conf.token
              + '&current_school_period=' + vm.school_period
              + '&user_id=' + vm.conf.user_id
              + '&student_group_id=' + vm.group_id
              + '&company=' + vm.conf.current_company
              + '&connection=' + vm.conf.current_connection
              + '&history_option=' + response.history_superior_option
              + '&observation=' + response.individual_observation
              + '&repeat_pendent_subjects=' + response.repeat_pendent_subjects
              + '&include_subjects_without_enrolment=' + response.include_subjects_without_enrolment
              + '&not_include_teacher_column=' + response.not_include_teacher_column
              + '&only_approved_or_on_course=' + response.only_approved_or_on_course
              + '&order_by=' + response.order_by
              + '&print_complementar_on_another_page=' + response.print_complementar_on_another_page;
            var element = document.createElement('a');
            element.setAttribute('href', href);
            element.setAttribute('target', '_blank');
            return element.click();
          });
        }).catch(function () {
          $rootScope.show_loader = false;
        });
      });
    };

    /**
     * Realiza a matrícula em disciplina
     * @param item
     */
    vm.doEnrolment = function (item) {
      $rootScope.show_loader = true;
      EnrolmentService.doEnrolmentSubject({
        person_id: vm.person_id,
        enrolment_period_id: vm.enrolment_period_id,
        subject_id: item.subj_group_id.split('_')[0],
        group_id: item.subj_group_id.split('_')[1],
        matrix_period: item.matrix_period
      }).then(function () {
        vm.getEnrolmentMatrix();
        Common.Toast.success('Matrícula realizada com sucesso!');
      }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao realizar matrícula.');
      });
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    vm.getBackgroundColor = function (subject_item) {
      if (subject_item.school_period_id !== null
        && (subject_item.enrolment_status_id === 10 && subject_item.academic_status_id < 10)
        && subject_item.school_period_id < vm.school_period_default_enrolment_id) {
        return 'rgb(255, 254, 236)';
      }
      if (subject_item.enrolment_status_id >= 30 && subject_item.enrolment_status_id <= 32) {
        return 'rgb(245, 243, 243)'
      }
      if ((subject_item.school_period_id !== null
        && (subject_item.enrolment_status_id === 10
          && (subject_item.academic_status_id >= 10 && subject_item.academic_status_id <= 19)))
        || (subject_item.enrolment_status_id >= 40 && subject_item.enrolment_status_id <= 42)) {
        return 'rgb(229, 242, 255)';
      }
    };

    vm.init();
  }

  angular
    .module('app.a4-subject-grid')
    .controller('a4SubjectGridController', a4SubjectGridController)
    .filter('dayOfWeek', function () {
      /** day - número do dia da semana de 1 a 7 (dom a sab)*/
      return function (day) {
        day = parseInt(day);
        // Ensure that we are working with a number
        if (isNaN(day)) {
          return '';
        } else {
          switch (day) {
            case 1:
              return 'Dom';
            case 2:
              return 'Seg';
            case 3:
              return 'Ter';
            case 4:
              return 'Qua';
            case 5:
              return 'Qui';
            case 6:
              return 'Sex';
            case 7:
              return 'Sab';
          }
        }
      }
    });
})();

(function () {
  'use strict';
  angular.module('app.a4studentresponsiblesform', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4StudentResponsiblesForm($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        personId: '=?',
        groupId: '=?',
        matrixPeriod: '=?',
        student: '=?',
        hasPayee: '=?',
        hasResponsible: '=?',
        hasGuarantor: '=?',
        isEnrolment: '=?'
      },
      controller: 'a4StudentResponsiblesFormController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-student-responsibles-form/a4-student-responsibles-form.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4studentresponsiblesform')
    .directive('a4StudentResponsiblesForm', a4StudentResponsiblesForm);
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4StudentResponsiblesFormController($scope, a4Moment, StudentsService, $window, $filter,
                                               EducationalService, SysTableColumn, PersonService, $stateParams,
                                               $state, $rootScope, Common, ModalFactory, ResponsiblesService) {
    var vm = this;
    vm.grid = {
      rows: [],
      info: {}
    };
    vm.originatorEv = null;
    vm.is_national_id_number_required = true;

    vm.init = function () {
      $rootScope.show_loader = true;
      vm.person_id = angular.isDefined($state.params.id) && $state.params.id !== null ? $state.params.id : $scope.personId;
      vm.payee = angular.isDefined($state.params.person_id_payee) && $state.params.person_id_payee !== null ?
        $state.params.person_id_payee : $scope.person_id_payee;
      vm.group_id = angular.isDefined($state.params.group_id) && $state.params.group_id !== null ? $state.params.group_id : $scope.groupId;
      vm.matrix_period = angular.isDefined($state.params.matrix_period) && $state.params.matrix_period !== null ? $state.params.matrix_period : $scope.matrixPeriod;
      vm.getStudentParents(vm.person_id);
      EducationalService.hasNationalIdNumberRequired().then(function (response) {
        var obj = response.plain();
        vm.is_national_id_number_required = obj.is_national_id_number_required;
      });
      vm.required_fields_responsible = SysTableColumn.getColumnsByScope('RESPONSIBLE');
      vm.required_fields_payee = SysTableColumn.getColumnsByScope('PAYEE');
    };

    vm.verifyFatherAndMother = function () {
      var has_father = false;
      var has_mother = false;
      for (var i = 0; i < vm.grid.rows.length; i++) {
        if ((vm.grid.rows[i].prt_id === 1 &&
          vm.grid.rows[i].person_sex_id === 'F') || $scope.student.is_mother_not_declared) {
          has_mother = true;
        }
        if ((vm.grid.rows[i].prt_id === 1 &&
          vm.grid.rows[i].person_sex_id === 'M') || $scope.student.is_father_not_declared) {
          has_father = true;
        }
      }
      vm.has_mother = has_mother;
      vm.has_father = has_father;
    };

    vm.openMenu = function ($mdMenu, ev) {
      vm.originatorEv = ev;
      $mdMenu.open(ev);
    };

    /**
     * Executa uma função desejada na lista de opções do grid
     * @param option
     */
    vm.clickActions = function (responsible, option) {
      switch (option) {
        case 'change-responsible':
          vm.changeResponsible(responsible);
          break;
        case 'edit-relationship':
          vm.changeRelationship(responsible);
          break;
        case 'change-payee':
          vm.changePayee(responsible);
          break;
        default:
      }
    };

    /***
     * Vai para a página do responsável
     * @param item
     */
    vm.seeParent = function (item) {
      if (item.id !== vm.person_id) {
        var url = $state.href('private.educational.responsibles.edit', {id: item.id});
        $window.open(url, '_blank');
      }
    };

    /**
     * Adiciona um novo responsável ao aluno
     */
    vm.addParent = function () {
      var parents_ids = [];
      for (var i = 0; i < vm.grid.rows.length; i++) {
        parents_ids.push(vm.grid.rows[i].id);
      }
      ModalFactory.customClean(
        'app/educational/students/parents/views/responsibles-wizard.html',
        'ParentsAssistantController',
        'vm', false, {
          student_id: vm.person_id,
          responsibles_ids: parents_ids,
          group_id: vm.group_id,
          matrix_period: vm.matrix_period,
          confirmation: $stateParams.confirmation
        }
      ).then(function (response) {
        if (angular.isDefined(response.update_not_declared.is_mother_not_declared) && response.update_not_declared.is_mother_not_declared === false) {
          $scope.student.is_mother_not_declared = false;
        }
        if (angular.isDefined(response.update_not_declared.is_father_not_declared) && response.update_not_declared.is_father_not_declared === false) {
          $scope.student.is_father_not_declared = false;
        }
        vm.getStudentParents(vm.person_id);
      });
    };

    /**
     * Retorna a lista de responsáveis pelo aluno
     * @param student_id
     */
    vm.getStudentParents = function (student_id) {
      StudentsService.getStudentParents({
        student_id: student_id, matrix_period: $scope.student.matrix_period,
        group_id: vm.group_id,
        enrolment_school_period: $scope.enrolmentSchoolPeriod,
        confirmation: $scope.confirmation
      })
        .then(function (response) {
          var data = response.plain();
          /**
           * Filtra os registros, formatando no grid os dados para apresentar os responsáveis financeiros e pedagógicos
           */
          for (var i = 0; i < data.length; i++) {
            if (angular.isDefined(data[i].person_id_payee) && data[i].person_id_payee === data[i].id) {
              data[i].is_payee = true;
              vm.payee = data[i].id;
              $scope.hasPayee = true;
            } else {
              data[i].is_payee = false;
            }
            if (angular.isDefined(data[i].person_id_responsible) && data[i].person_id_responsible === data[i].id) {
              data[i].is_responsible = true;
              vm.responsible = data[i].id;
              $scope.hasResponsible = true;
            } else {
              data[i].is_responsible = false;
            }
            if (angular.isDefined(data[i].person_id_guarantor) && data[i].person_id_guarantor === data[i].id) {
              data[i].is_guarantor = true;
              vm.guarantor = data[i].id;
              $scope.hasGuarantor = true;
            } else {
              data[i].is_guarantor = false;
            }
          }
          $scope.hasPayee = $filter('filter')(data, {'is_payee': true}).length > 0;
          $scope.hasResponsible = $filter('filter')(data, {'is_responsible': true}).length > 0;
          console.log(data);
          vm.grid.rows = data;
          vm.verifyFatherAndMother();
          $rootScope.show_loader = false;
        })
    };

    $scope.$on('$destroy', function () {
      vm.floatButton.destroy(vm.floatButton.options.scope.$id);
    });

    /**
     * Abre o modal de alteração do responsável pedagógico do aluno
     * @param responsible - id do novo responsável
     */
    vm.changeResponsible = function (responsible) {
      var obj = [];
      obj.push({
        responsible_id: responsible.id, student_id: vm.person_id, group_id: vm.group_id,
        matrix_period: $scope.student.matrix_period
      });
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Você deseja definir esta pessoa como responsável pedagógica do aluno?',
        'Confirmar',
        'Cancelar',
        'educational',
        vm.changePedagogicResponsibleProcess,
        obj
      ).then(function () {
        Common.Toast.success('Responsável pedagógico alterado com sucesso!');
        $scope.student.person_id_responsible = responsible.id;
        vm.getStudentParents(vm.person_id);
      })
    };

    /**
     * Abre o modal de alteração do responsável pedagógico do aluno
     * @param responsible - id do novo responsável
     */
    vm.changeGuarantor = function (responsible) {
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Você deseja definir esta pessoa como fiador do aluno?',
        'Confirmar',
        'Cancelar',
        'educational',
        function (responsible) {
          return StudentsService.defineGuarantor({person_id: vm.person_id, parent: responsible});
        },
        responsible
      ).then(function () {
        Common.Toast.success('Fiador alterado com sucesso!');
        $scope.student.person_id_guarantor = responsible.id;
        vm.getStudentParents(vm.person_id);
      })
    };

    /**
     * Realiza o processo de alteração do responsável pedagógico
     * @param responsible
     * @returns {void|*}
     */
    vm.changePedagogicResponsibleProcess = function (obj) {
      return StudentsService.changeResponsible(
        {
          data: obj
        })
    };

    /**
     * Altera o relacionamento de parentesco entre o aluno e o responsável
     * @param responsible
     */
    vm.changeRelationship = function (responsible) {
      ModalFactory.customClean('app/educational/students/parents/views/modal_change_relationship.html',
        /** @ngInject */
        function (StudentsService, EnrolmentService, $mdDialog, ModalExtra, $scope) {
          var vm = this;
          vm.previous_relation = angular.copy(responsible.prt_id);
          vm.responsible = angular.copy(responsible);
          vm.getPersonRelationLegal = function () {
            EnrolmentService.getPersonRelationLegal()
              .then(function (list) {
                vm.person_relations = list.plain();
                $rootScope.show_loader = false;
              });
          };
          /**
           * Altera o relacionamento de parentesco entre o aluno e o responsável
           */
          vm.saveRelationship = function () {
            StudentsService.changeRelationship({
              student_id: ModalExtra.student_id,
              responsible_id: vm.responsible.id,
              person_relation_type_id: vm.responsible.prt_id
            }).then(function (response) {
              $rootScope.show_loader = true;
              $mdDialog.hide(response);
              Common.Toast.success('Relacionamento alterado com sucesso!');
            })
          };
          vm.close = function () {
            $mdDialog.cancel();
          };
          vm.getPersonRelationLegal();
        }, 'vm', false, {responsible: responsible, student_id: vm.person_id})
        .then(function (response) {
          if (angular.isDefined(response.update_not_declared.is_mother_not_declared) && response.update_not_declared.is_mother_not_declared === false) {
            $scope.student.is_mother_not_declared = false;
          }
          if (angular.isDefined(response.update_not_declared.is_father_not_declared) && response.update_not_declared.is_father_not_declared === false) {
            $scope.student.is_father_not_declared = false;
          }
          vm.getStudentParents(vm.person_id);
        });
    };

    /**
     * Abre o modal de confirmação para a deleção de responsável.
     * @param responsible
     */
    vm.delete = function (responsible) {
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Você deseja excluir esse responsável?',
        'Excluir',
        'Cancelar',
        'educational'
      ).then(function () {
          $rootScope.show_loader = true;
          vm.deleteResponsibleProcess(responsible).then(function () {
            Common.Toast.success('Responsável excluído com sucesso!');
            vm.getStudentParents(vm.person_id);
          });
        }
      ).catch(function () {
        Common.Toast.error('Erro na exclusão do responsável!');
        $rootScope.show_loader = false;
      });
    };

    /**
     * Deleta o responsável
     * @param responsible
     * @returns {void|*}
     */
    vm.deleteResponsibleProcess = function (responsible) {
      return StudentsService.deleteResponsible(
        {
          student_id: vm.person_id,
          responsible: responsible
        })
    };


    /**
     * Inicia o processo de alteração do responsável financeiro.
     * @param responsible
     */
    vm.changePayee = function (responsible, is_independent_change) {
      if (angular.isUndefined(is_independent_change)) {
        is_independent_change = true;
      }
      var count_required = 0;
      PersonService.verifyFieldsRequired({person_id: responsible.id, scope: 'PAYEE'})
        .then(function (resp) {
          count_required = resp.count_required;
          if (count_required > 0) {
            vm.saveCPF(responsible, false, is_independent_change);
          } else {
            /**
             * Verifica se o responsável financeiro também é o responsável pedagógico.
             * Se for, mostra modal de confirmação
             */
            if (vm.responsible === vm.payee && angular.isUndefined(is_independent_change)) {
              ModalFactory.confirm(null, 'Alteração de responsável financeiro e pedagógico',
                'O responsável financeiro deste aluno também é seu responsável pedagógico, ' +
                'deseja tornar a pessoa selecionada responsável financeira e pedagógica?',
                'Tornar ambos', 'Tornar financeiro', 'educational').then(function () {
                  vm.checkDependents(responsible, 1, is_independent_change);
                }
              ).catch(function () {
                vm.checkDependents(responsible, 0, is_independent_change);
              })
            } else if (angular.isDefined(is_independent_change) && is_independent_change) {
              vm.checkDependents(responsible, 1, is_independent_change);
            } else {
              vm.checkDependents(responsible, 0, is_independent_change);
            }
          }
        });
    };
    /**
     * Verifica se o responsável possui mais dependentes
     * @param responsible
     * @param change_educational 0 - Alterar apenas financeiro  1 - Alterar responsável pedagógico e financeiro
     */
    vm.checkDependents = function (responsible, change_educational, is_independent_change) {
      StudentsService.getAnotherDependents({
        student_id: vm.person_id,
        responsible_id: responsible.id
      }).then(function (data) {
        vm.dependents = data.plain();
        vm.names = '';
        for (var i = 0; i < vm.dependents.length; i++) {
          vm.names += " - " + vm.dependents[i].person_name + "\n";
        }
        if (vm.dependents.length > 0) {
          ModalFactory.confirm(null, 'Responsável possui outros dependentes', 'Esta pessoa é responsável também pelo(s) seguinte(s) aluno(s): \n' +
            '\n ' + vm.names + '. Deseja efetuar a alteração de responsável também para esses alunos?', 'Sim',
            'Não, apenas para o selecionado', 'educational').then(function () {
            /** Muda responsável de todos os dependentes */
            vm.dependents.push({person_id: vm.person_id, group_id: vm.group_id, matrix_period: vm.matrix_period});
            vm.changePayeeProcess(responsible, vm.dependents, change_educational, is_independent_change)

          }).catch(function () {
            /** Muda responsável do aluno selecionado */
            vm.changePayeeProcess(responsible, [{
              person_id: vm.person_id
            }], change_educational, is_independent_change)
          })
        } else {
          /** Muda responsável do aluno selecionado */
          vm.changePayeeProcess(responsible, [{
            person_id: vm.person_id
          }], change_educational, is_independent_change)
        }
      });
    };

    /**
     * Processo de alteração do responsável financeiro
     * @param responsible
     * @param students
     * @param change_educational
     * @param is_independent_change
     */
    vm.changePayeeProcess = function (responsible, students, change_educational, is_independent_change) {
      ModalFactory.custom('app/educational/students/parents/views/modal-change-payee.html', null, false, null).then(function (object) {
        $rootScope.show_loader = true;
        if (object.date !== null) {
          object.date = a4Moment(object.date).format('YYYY-MM-DD');
        }
        StudentsService.verifyBankSlipsForPayee({
          person_id_payee: vm.payee,
          date: object.option === 2 ? object.date : null,
          students: students
        }).then(function (active_bank_slips) {
          $rootScope.show_loader = false;
          if (active_bank_slips > 0) {
            var text = 'Encontramos ' + active_bank_slips + ' boletos bancários gerados para o responsável financeiro anterior. Ao confirmar' +
              ' a troca, estes boletos serão cancelados. Para cobrança bancária, você deverá gerar novos boletos para o novo' +
              ' responsável. O registro desses boletos implicará na cobrança de novas tarifas bancárias. ';
            vm.confirmPayeeChange(object, students, responsible, change_educational, text, 'ATENÇÃO aos boletos bancários', is_independent_change)
          } else {
            vm.confirmPayeeChange(object, students, responsible, change_educational, null, null, is_independent_change)
          }
        })
      })
    };

    /**
     * Abre modal de confirmação de senha
     * @param object
     * @param students
     * @param responsible
     * @param change_educational
     */
    vm.confirmPayeeChange = function (object, students, responsible, change_educational, text, subtitle, is_independent) {
      if (is_independent) {
        students[0].matrix_period = $scope.student.matrix_period;
      }

      var group_id = null;
      if (is_independent) {
        group_id = vm.group_id;
      }
      ModalFactory.open('require_password', null, null, {
          password: '',
          responsible: responsible,
          students: students,
          option: object.option,
          date: object.date,
          change_educational: change_educational,
          is_student: is_independent,
          group_id: group_id
        }, null, 'educational', vm.executePayeeChange,
        'Alteração de responsável financeiro', text === null ? 'Confirme a senha para alterar o responsável' : text, subtitle)
        .then(function (answer) {
          if (answer) {
            if (angular.isDefined(is_independent) && is_independent) {
              $scope.student.person_id_payee = vm.person_id;
              $scope.student.person_id_responsible = vm.person_id;
            } else {
              $scope.student.person_id_payee = responsible.id;
            }
            Common.Toast.success('Responsável alterado com sucesso!');
            vm.getStudentParents(vm.person_id);
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });

    };

    /**
     * Salva CPF de responsável
     * @param responsible
     * @param is_independent
     * @param student
     */
    vm.saveCPF = function (responsible, is_independent, student) {
      ModalFactory.customClean('app/educational/enrolment/enrolment-steps/responsibles/responsible-cpf.html',
        /** @ngInject */
        function ($state, ModalExtra, $window, PersonService, $mdDialog, Common) {
          var vm = this;
          vm.responsible = ModalExtra;
          vm.openForm = function () {
            var url = $state.href('private.educational.responsibles.edit', {id: vm.responsible.id, is_payee: true});
            $window.open(url, '_blank');
          };
          vm.closeModal = function () {
            $mdDialog.cancel();
          };
          vm.submit = function () {
            var count_required = 0;
            PersonService.verifyFieldsRequired({person_id: vm.responsible.id, scope: 'PAYEE'})
              .then(function (resp) {
                count_required = resp.count_required;
                if (count_required > 0) {
                  Common.Toast.warning('Ainda existem campos requeridos em branco.');
                } else {
                  $mdDialog.hide();
                }
              })
          }
        }, 'vm', false, responsible)
        .then(function (object) {
          // $rootScope.show_loader = true;
          /**
           * Salva o novo CPF do responsável.
           */
          // ResponsiblesService.saveResponsibleCPF({data: object, person_id: responsible.id})
          //   .then(function () {
          //     $rootScope.show_loader = false;
          //     Common.Toast.success('CPF atualizado com sucesso!');
          //     responsible.cpf = object;
          //     responsible.national_id_number = object.national_id_number;
          //     responsible.phone_mobile = object.phone_mobile;
          if (angular.isDefined(is_independent) && is_independent) {
            //       $scope.student.cpf = object;
            //       $scope.student.national_id_number = object;
            vm.defineIndependent();
          } else if ($scope.isEnrolment) {
            vm.definePayee(responsible);
          } else {
            vm.changePayee(responsible, student);
          }
          // }).catch(function () {
          // $rootScope.show_loader = false;
          // vm.getStudentParents(vm.person_id);
          // Common.Toast.error('Erro ao cadastrar o CPF. Contate o suporte.');
          // })
        }).catch(function () {
        vm.getStudentParents(vm.person_id);
      })
    };

    /**
     * Executa alteração do responsável
     * @param data
     * @returns {void|*}
     */
    vm.executePayeeChange = function (data) {
      return StudentsService.changePayee({
        responsible_id: data.responsible.id,
        students: data.students,
        option: data.option,
        date: data.date,
        change_educational: data.change_educational,
        is_student: data.student,
        group_id: data.group_id,
        enrolment_period_id: data.enrolment_period_id
      })
    };

    /**
     * Define o aluno como o próprio responsável
     */
    vm.defineIndependent = function () {
      var count_required = 0;
      $rootScope.show_loader = true;
      vm.has_national_number = $scope.student.national_id_number;
      console.log($scope.student.national_id_number)
      //PersonService.verifyFieldsRequired({person_id: vm.person_id, scope: 'PAYEE'})
        //.then(function (resp) {
          $rootScope.show_loader = false;
          //count_required = resp.count_required;
          //if (count_required > 0) {
          //  vm.saveCPF($scope.student, true);
          //} else {
          if(angular.isDefined(vm.has_national_number) && vm.has_national_number !== null ||
            (angular.isDefined($scope.student.no_cpf_check) && $scope.student.no_cpf_check == true)) {
            $rootScope.show_loader = true;
            StudentsService.defineIndependent(
              {
              person_id: vm.person_id, 
              group_id: vm.group_id, 
              enrolment_school_period: $scope.enrolmentSchoolPeriod,
              confirmation: $scope.confirmation
            }).then(function () {
                $scope.student.person_id_payee = vm.person_id;
                $scope.student.person_id_responsible = vm.person_id;
                vm.getStudentParents(vm.person_id);
                $rootScope.show_loader = false;
              })
              .catch(function () {
                Common.Toast.error('Erro ao definir aluno como independente.');
                $rootScope.show_loader = false;
              })
            } else {
              Common.Toast.error('CPF é necessário para que o aluno seja definido como próprio responsável.')
              $rootScope.show_loader = false;
            }
        //  }
        //});
    };

    vm.defineNotDeclared = function (parent) {
      $rootScope.show_loader = true;
      StudentsService.defineNotDeclared({person_id: vm.person_id, parent: parent})
        .then(function (resp) {
          $scope.student[resp] = true;
          vm.getStudentParents(vm.person_id);
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao realizar ação.');
          $rootScope.show_loader = false;
        })
    };

    vm.defineResponsible = function (parent) {
      $rootScope.show_loader = true;
      StudentsService.defineResponsible({person_id: vm.person_id, parent: parent})
        .then(function () {
          $scope.student.person_id_responsible = parent.id;
          vm.getStudentParents(vm.person_id);
          // vm.verifyFatherAndMother();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao realizar ação.');
          $rootScope.show_loader = false;
        })
    };

    vm.ManageCoResponsable = function (parent, is_co_responsable) {
      $rootScope.show_loader = true;
      StudentsService.ManageCoResponsable({person_id: vm.person_id,
         parent: parent,
         is_co_responsable: is_co_responsable
        })
        .then(function () {
          // $scope.student.person_id_responsible = parent.id;
          vm.getStudentParents(vm.person_id);
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao realizar ação.');
          $rootScope.show_loader = false;
        })
    };

    vm.definePayee = function (parent) {
      parent.confirmation = angular.isDefined($stateParams.confirmation) ? $stateParams.confirmation : null;
      var count_required = 0;
      PersonService.verifyFieldsRequired({person_id: parent.id, scope: 'PAYEE'})
        .then(function (resp) {
          count_required = resp.count_required;
          if (count_required == 1 && (parent.cpf == null && parent.foreign_id_or_passport != null)) {
            //Caso só o campo obrigatório de cpf esteja vazio, porém o id estrangeiro esteja informado, então permite que ele seja um responsável financeiro 
            ModalFactory.confirm(null, 'Atenção',
              'Não há um CPF informado para esse responsável, porém há um passaporte/id estrangeira.' + 
              ' Nesse caso o responsável pode ser definido como responsável financeiro, porém não será possível gerar boletos de pagamento para ele.' +
              '\nDeseja continuar o procedimento?',
              'Confirmar', 'Cancelar', 'educational').then(function () {
              $rootScope.show_loader = true;
              StudentsService.definePayee({person_id: vm.person_id, parent: parent})
                .then(function () {
                  $scope.student.person_id_payee = parent.id;
                  vm.getStudentParents(vm.person_id);
                  $rootScope.show_loader = false;
                })
            })
          } else if (count_required > 0 ) {
            vm.saveCPF(parent);
          } else {
            $rootScope.show_loader = true;
            StudentsService.definePayee({person_id: vm.person_id, parent: parent})
              .then(function () {
                $scope.student.person_id_payee = parent.id;
                vm.getStudentParents(vm.person_id);
                $rootScope.show_loader = false;
              })
              .catch(function () {
                Common.Toast.error('Erro ao realizar ação.');
                $rootScope.show_loader = false;
              })
          }
        });
    };

    vm.defineGuarantor = function (parent) {
      $rootScope.show_loader = true;
      StudentsService.defineGuarantor({person_id: vm.person_id, parent: parent})
        .then(function () {
          $scope.student.person_id_guarantor = parent.id;
          vm.getStudentParents(vm.person_id);
          // vm.verifyFatherAndMother();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error('Erro ao realizar ação.');
          $rootScope.show_loader = false;
        })
    };

    vm.removeGuarantor = function () {
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Você deseja remover esta pessoa como fiador do aluno?',
        'Confirmar',
        'Cancelar',
        'educational',
        function () {
          return StudentsService.removeGuarantor({person_id: vm.person_id})
        }
      ).then(function () {
        Common.Toast.success('Fiador removido com sucesso!');
        $scope.student.person_id_guarantor = null;
        vm.getStudentParents(vm.person_id);
      })
    };

    vm.init();
  }

  angular.module('app.a4studentresponsiblesform')
    .controller('a4StudentResponsiblesFormController', a4StudentResponsiblesFormController);
})
();

(function () {
  'use strict';
  angular.module('app.a4studentform', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4StudentForm($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        student: '=?',
        isEnabled: '=?',
        studentForm: '=?',
        blockFormEmail: '=?',
        isEnrolment: '=?'
      },
      require: ['^form'],
      controller: 'a4StudentFormController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-student-form/a4-student-form.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4studentform')
    .directive('a4StudentForm', a4StudentForm);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4StudentFormController($scope, $rootScope, Common, StudentsService,
                                   ModalFactory, SysTableColumn, Session) {
    var vm = this;
    $scope.searchTerm = '';
    vm.list = {};
    vm.entrance_modes = [];
    vm.company_id = Session.get('current_company', "sessionStorage");

    vm.getFormInfos = function () {
      $rootScope.show_loader = true;
      vm.list = {};
      StudentsService.getInfos()
        .then(function (response) {
          vm.list.person = response.person;
          vm.list.person_student = response.person_student;
          vm.getPersonPcd()
          vm.required_fields_student = SysTableColumn.getColumnsByScope('STUDENT');
          $rootScope.show_loader = false;
        });
    };

    $scope.$watch('isEnabled', function(newValue) {
      vm.getFormInfos();
    })

    vm.getSelectedPcdText = function() {
      if (!student.person_pcd_ids || student.person_pcd_ids.length === 0) {
        return 'Selecione as deficiências';
      }
      console.log('teste')
      // Busca os nomes das deficiências selecionadas para exibição no campo do formulário
      var selectedNames = [];
      student.person_pcd_ids.forEach(function(pcdId) {
        var pcd = vm.list.person.person_pcd.find(function(item) {
          return item.id === pcdId;
        });
        if (pcd) {
          selectedNames.push(pcd.name);
        }
      });
      
      // Retornar até 3 nomes, ou quantidade se for mais
      if (selectedNames.length <= 3) {
        return selectedNames.join(', ');
      } else {
        return selectedNames.length + ' deficiências selecionadas';
      }
    };
    

    vm.createNewSchoolOrigin = function () {
      ModalFactory.customClean('app/components/a4-student-form/modal-school-origin.html',
        /** @ngInject */
        function ModalSchoolOriginController($mdDialog, $q, ModalExtra, PersonService, StudentsService) {
          var vm = this;
          vm.states = [];
          vm.cities = [];
          vm.school_origin = {
            name: null,
            state_id: null,
            city: null
          };
          vm.states = ModalExtra.states;
          vm.closeModal = function () {
            $mdDialog.cancel();
          };
          vm.changeState = function (state) {
            PersonService.getCities(state)
              .then(function (response) {
                vm.cities = response.plain();
              })
          };
          vm.submit = function (school_origin) {
            StudentsService.createSchoolOrigin({school_origin: school_origin})
              .then(function (school) {
                $mdDialog.hide(school.id);
              })
          }
        }, 'vm', true, {
          states: vm.list.person.address_state
        }).then(function (school_origin_id) {
        if (school_origin_id !== null) {
          Common.Toast.success("Escola de origem criada com sucesso!");
          vm.getFormInfos();
          $scope.student.school_origin_id = school_origin_id;
        }
      })
    };

    // Função para carregar as deficiências
    vm.getPersonPcd = function() {
      StudentsService.getPersonPcd().then(function(response) {
        vm.list.person.person_pcd = response.plain();
      });
    }

    vm.init = function () {

      // Converter string para array na inicialização
      if ($scope.student.person_pcd_ids && typeof $scope.student.person_pcd_ids === 'string') {
          // Remove chaves e espaços, depois split por vírgula
          var cleanString = $scope.student.person_pcd_ids.replace(/{|}| /g, '');
          if (cleanString) {
            $scope.student.person_pcd_ids = cleanString.split(',').map(function(id) {
              return parseInt(id, 10); // Converte para número
            });
          }
      }

      $scope.$watch('isEnabled', function (newValue) {
        if (newValue === true) {
          vm.getFormInfos();
        } else {
          vm.list.person = {};
          vm.list.person.address_state = [{ id: $scope.student.id_state }];
          vm.list.person.person_sex_id = [
            { id: $scope.student.person_sex_id == 'M' ? $scope.student.person_sex_id : 'M', name:'Masculino' },
            { id: $scope.student.person_sex_id == 'F' ? $scope.student.person_sex_id : 'F', name: 'Feminino' }
          ];
          vm.list.person.person_color_id = [{ id: $scope.student.person_color_id, name: $scope.student.person_color_name }];
          vm.list.person.school_origins = [{ id: $scope.student.school_origin_id, name: $scope.student.school_origin_name}];
        }
      });
      
    };

    vm.init();
  }

  angular.module('app.a4studentform')
    .controller('a4StudentFormController', a4StudentFormController);
})();
(function () {
  'use strict';
  angular.module('app.a4studentdocuments', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4StudentDocuments($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        selectedDocuments: '=?',
        documentsList: '=?',
        student: '=?'
      },
      controller: 'a4StudentDocumentsController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-student-documents/a4-student-documents.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4studentdocuments')
    .directive('a4StudentDocuments', a4StudentDocuments);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4StudentDocumentsController($scope, $rootScope, $mdDialog, Common, Session,
                                        CONFIG, CourseDocumentsService, ModalFactory) {
    var vm = this;
    vm.student = angular.copy($scope.student);
    vm.school_period_id = Session.getCurrentSchoolPeriod().id;
    vm.CONFIG = CONFIG;

    $scope.$watchCollection('selectedDocuments', function () {
      vm.verifyDocumentsWithFiles();
    });

    vm.verifyDocumentsWithFiles = function () {
      vm.school_period = Session.getCurrentSchoolPeriod().id;
      $scope.documentsList.forEach(function (document) {
        if (document.file_reference !== null) {
          var already_selected = false;
          $scope.selectedDocuments.forEach(function (selected_document) {
            if (selected_document.id === document.id) {
              already_selected = true;
            }
          });
          if (!already_selected) {
            $scope.selectedDocuments.push(document);
          }
          $scope.$applyAsync();
        }
      });
    };

    /**
    * Função que verifica se o documento está marcado
    * @param person_id
    * @returns {boolean}
    */
    vm.isChecked = function (document) {
      return $scope.selectedDocuments.some(function(doc) {
        return doc.visualization_id === document.visualization_id
      })
    };

    /** Função responsável por selecionar ou descelecionar um documento */
    vm.selectedDocument = function(document) {

      var index = $scope.selectedDocuments.findIndex(function(doc) {
        return doc.visualization_id === document.visualization_id;
      });
    
      if (index === -1) {
        $scope.selectedDocuments.push(document);
      } else {
        $scope.selectedDocuments.splice(index, 1);
      }
    };

    vm.editFile = function (document) {
      if (angular.isUndefined(document.artifact_id)) {
        document.artifact_id = null;
      }
      ModalFactory.customClean('app/components/a4-student-documents/a4-student-document-upload.html',
        /** @ngInject */
        function (CONFIG, Common, CourseDocumentsService, DropzoneService, ModalExtra,
                  $mdDialog, $rootScope, LocalStorage, $document) {
          var vm = this;
          vm.document = ModalExtra.document;
          vm.document.file = null;
          vm.CONFIG = CONFIG;
          vm.closeModal = function (addAnother) {
            $rootScope.$broadcast('ModalFactory.close', addAnother);
          };
          var connection = $document[0].domain.split('.')[0];
          var company = LocalStorage.get('current_company', "sessionStorage");

          /** Define as configurações para o upload */
          vm.dzOptions = {
            url: CONFIG.webApiUri + 'api/document/uploadfiles?company=' + company + '&connection=' + connection,
            paramName: 'file',
            maxFilesize: '100',
            acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'JPEG']),
            uploadMultiple: false,
            parallelUploads: 3,
            maxFiles: 1,
            autoProcessQueue: true
          };

          vm.dzCallbacks = {
            'addedfile': function (file) {
              DropzoneService.getBase64(file)
                .then(function (base64) {
                  vm.document.file = {name: file.name, base64: base64, size: file.size};
                });
            },
            'dragenter': function (file) {
              DropzoneService.getBase64(file)
                .then(function (base64) {
                  vm.document.file = {name: file.name, base64: base64, size: file.size};
                });
            }, 'success': function (file, xhr) {
              if (xhr) {
                vm.dzMethods.removeAllFiles(true);
              }
            },
            'error': function (file, errorMessage) {
              Common.Toast.error(errorMessage);
            }
          };

          vm.deleteDocument = function () {
            vm.submit({option: 'delete_file', document: vm.document})
          };

          vm.submit = function (obj) {
            $mdDialog.hide(
              obj
            );
          }

        }, 'vm', false, {document: document})
        .then(function (response) {
          if (response && angular.isDefined(response.option)) {
            switch (response.option) {
              case 'delete_file':
                ModalFactory.confirm(null,
                  "Remover arquivo",
                  "Confirma a exclusão desse arquivo? Esta exclusão não é reversível",
                  "Confirmar", "Cancelar", "educational")
                  .then(function () {
                    CourseDocumentsService.deleteDocumentFile({artifact_id: response.document.artifact_id})
                      .then(function () {
                        Common.Toast.success('Arquivo deletado com sucesso!');
                        $scope.$emit('refresh-student-documents', true);
                      });
                  }).catch(function () {
                  vm.editFile(response.document);
                });
                break;
              case 'save':
                vm.saveFile(response.document);
            }
          }
        }).catch(function (error) {
      })
    };

    vm.saveFile = function (document) {
      
      if(document.file.name) {
      //divide o nome do documento em pedaços a partir de '.' para ter a informação de todas as extensões.
      const parts = document.file.name.split('.');

      // Validar o tamanho de cada extensão antes de enviar.
      for (let i = 1; i < parts.length; i++) {
        if (parts[i].length >= 10) {
          Common.Toast.error('A extensão ' + parts[i] + 'do documento em anexo excede o tamanho de 9 caracteres! A pontuação "." é interpretada como separador entre o nome e as extensões do arquivo, caso o ponto seja necessário reduza o conteúdo após ele em até 9 caracteres');
          return;
        }
      }}

      $rootScope.show_loader = true;
      CourseDocumentsService.saveDocumentFile({
        document: document,
        student: vm.student
      })
        .then(function (file_reference) {
          Common.Toast.success('Arquivo salvo com sucesso!');
          document.file_reference = file_reference;
          $scope.selectedDocuments.push(document);
          $scope.$emit('refresh-student-documents', true);
          $rootScope.show_loader = false;
        }).catch(function (error) {
        Common.Toast.error(error.data.message);
      })
    };


  }

  angular.module('app.a4studentdocuments')
    .controller('a4StudentDocumentsController', a4StudentDocumentsController);
})();
(function () {
  'use strict';
  angular.module('app.a4studentcontactform', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4StudentContactForm() {
    {
      return {
        restrict: 'E',
        scope: {
          student: '=?',
          isEnabled: '=?',
          studentContactForm: '=?'
        },
        controller: 'a4StudentContactFormController',
        controllerAs: 'vm',
        templateUrl: 'app/components/a4-student-contact-form/a4-student-contact-form.html',
        link: function (scope) {
        }
      }
    }
  }

  angular.module('app.a4studentcontactform')
    .directive('a4StudentContactForm', a4StudentContactForm);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4StudentContactFormController($rootScope, $scope, $timeout, $filter, Common, EnrolmentService, PersonService, $q, $window) {
    var vm = this;
    vm.cep_error = false;
    vm.list = {};
    vm.waiting_city = false;
    vm.group_id = $scope.student.group_id;
    vm.student_id = $scope.student.id;
    vm.getParentsToAddress = function () {
      EnrolmentService.getPersonResponsableLegal({
        id: vm.student_id,
        group_id: vm.group_id,

      }).then(function (response) {
        vm.responsibles = response.plain().data;
      })
    };
    vm.setParentToLive = function (parent_id) {
      if (parent_id !== null) {
        for (var i = vm.responsibles.length; i--;) {
          if (vm.responsibles[i].id === parent_id) {
            var parent = vm.responsibles[i];
          }
        }
        $scope.student.address_postal_code = parent.address_postal_code !== null ? parent.address_postal_code.replace('-', '') : null;
        $scope.student.address_street = parent.address_street !== null ? parent.address_street : null;
        $scope.student.address_house_number = parent.address_house_number !== null ? parent.address_house_number : null;
        $scope.student.address_line2 = parent.address_line2 !== null ? parent.address_line2 : null;
        $scope.student.address_district = parent.address_district !== null ? parent.address_district : null;
        $scope.student.address_state = parent.address_state !== null ? parent.address_state : null;
        vm.searchText_address_state = parent.address_state !== null ? parent.address_state : null;
        $scope.student.address_city = parent.address_city !== null ? parent.address_city : null;
        vm.searchText_address_city = parent.address_city !== null ? parent.address_city : null;
        $scope.student.phone_landline = parent.phone_landline !== null ? parent.phone_landline : null;
        $scope.student.phone_landline_2 = parent.phone_landline_2 !== null ? parent.phone_landline_2 : null;
        // $scope.student.phone_mobile = parent.phone_mobile !== null ? parent.phone_mobile : null;
      }
    };

    /**
     * Busca informações necessarias para o form
     */
    vm.getFormInfo = function () {
      $rootScope.show_loader = true;
      EnrolmentService.getEnrolmentFormInfo()
        .then(function (response) {
          var resp = response.plain();
          vm.list = resp.person;
          if (angular.isDefined($scope.student.address_postal_code) &&
            $scope.student.address_postal_code !== null) {
            vm.getAddressByCep($scope.student.address_postal_code);
          }
          $rootScope.show_loader = false;
        });
    };


    /**
     * Realiza a troca dos dados do select de cidade baseada no estado selecionado
     * @param address_state_id - estado item selecionado
     * @param city - cidade retornada pelo consulta a partir do cep
     */
    vm.changeAddressState = function (address_state_id, city) {
      vm.waiting_city = true;
      if (angular.isDefined(address_state_id) && angular.isDefined(address_state_id.id)) {
        $scope.student.address_state = address_state_id.id;
      } else if (vm.searchText_address_state !== null && vm.searchText_address_state !== '' && vm.searchText_address_state.length === 2) {
        $scope.student.address_state = vm.searchText_address_state;
      }
      var state = $scope.student.address_state;
      PersonService.getCities(state)
        .then(function (response) {
          vm.waiting_city = false;
          vm.list.address_city = response.plain();
          var city = $window.document.getElementById('autocomplete_address_city');
          if (city !== null && angular.isDefined(city)) {
            city.focus();
          }
        })
        .catch(function () {
          vm.waiting_city = false;
        })
    };

    /**
     * Resgata o endereço através do CEP informado
     * @param CEP
     */
    vm.getAddressByCep = function (CEP) {
      vm.cep_error = false;
      $rootScope.show_loader = true;
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          $rootScope.show_loader = false;
          if (angular.isDefined(address) && angular.isObject(address) && angular.isDefined(address.uf)) {
            if (angular.isDefined(address.erro) && address.erro) {
              Common.Toast.error(address.erro);
              return;
            }
            $scope.student.address_postal_code = address.cep;
            $scope.student.address_state = address.uf;
            vm.searchText_address_state = address.uf;
            $scope.student.address_city = address.localidade;
            vm.searchText_address_city = address.localidade;
            $scope.student.address_street = address.logradouro;
            $scope.student.address_district = address.bairro;
            $scope.$applyAsync();
            vm.changeAddressState(address.uf, address.localidade);
            angular.element('#number').focus();
          } else {
            vm.cep_error = true;
            if (angular.isDefined($scope.student.address_state) && $scope.student.address_state !== null) {
              vm.changeAddressState($scope.student.address_state);
            }
          }
        })
    };

    /**
     * Busca de estado de nascimento
     * @param filterText
     * @returns {*}
     */
    vm.getAddressState = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        filteredItems = vm.list.address_state.filter(function (item) {
          return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
        });
      } else {
        filteredItems = vm.list.address_state;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Busca de cidade de nascimento
     * @param filterText
     * @returns {*}
     */
    vm.getAddressCity = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        filteredItems = vm.list.address_city.filter(function (item) {
          return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
        });
      } else {
        filteredItems = vm.list.address_city;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Define a cidade de nascimento
     * @param item
     */
    vm.setAddressCity = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.name)) {
        $scope.student.address_city = item.name;
      }
    };


    vm.init = function () {
      if (angular.isDefined($scope.student) && angular.isUndefined($scope.student.person_id_address)) {
        $scope.student.person_id_address = null;
      }
      $timeout(function () {
        $scope.$watch('isEnabled', function (newValue) {
          if (newValue === true) {
            vm.getParentsToAddress();
          }
        });
      }, 4000);
    };

    vm.init();
  }

  angular.module('app.a4studentcontactform')
    .controller('a4StudentContactFormController', a4StudentContactFormController);
})();
(function () {
  'use strict';
  angular.module('app.a4stocktransactions', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4StockTransactions($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        type: '=?',
      },
      controller: 'a4StockTransactionsController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-stock-transactions/index.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4stocktransactions')
    .directive('a4StockTransactions', a4StockTransactions);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4StockTransactionsController($a4FloatButton, Common, StockService, $filter, $log, $timeout, $scope, $q, $rootScope,
                                         PoliciesService, TransactionsService, ModalFactory, ReportsService) {

    var vm = this;
    vm.grid = {};
    vm.selected_date = null;
    vm.selected_transaction_type ='';
    vm.selected_transaction_period ='';
    
    vm.getInfoForTransaction = function () {
      TransactionsService.getInfoForTransaction().then(function (response) {
        var infos = response.plain();
        vm.stock_transaction_types = infos.stock_transaction_types;
        vm.products = infos.products;
      });
    }

    vm.init = function () {
      vm.estoque_alt = vm.checkPolicies('estoque_alt');
      if(!vm.checkPolicies('estoque_alt')) {
        vm.floatButton = $a4FloatButton({
          scope: $scope,
          theme: 'stock',
          label: 'Adicionar transação',
          icon: 'add',
          onClick: 'vm.createTransaction()'
        });
      }
      vm.paginate();
      vm.getInfoForTransaction();
    };

    vm.clear_selected_transaction_period = function() {
      vm.selected_transaction_period.startDate = null;
      vm.selected_transaction_period.endDate = null;
      vm.paginate();
    };

    vm.selected_date = null;
    vm.selected_transaction_type ='';
    vm.selected_transaction_period ='';
    
    vm.getInfoForTransaction = function () {
      TransactionsService.getInfoForTransaction().then(function (response) {
        var infos = response.plain();
        vm.stock_transaction_types = infos.stock_transaction_types;
        vm.products = infos.products;
      });
    }

    vm.init = function () {
      vm.estoque_alt = vm.checkPolicies('estoque_alt');
      if(!vm.checkPolicies('estoque_alt')) {
        vm.floatButton = $a4FloatButton({
          scope: $scope,
          theme: 'stock',
          label: 'Adicionar transação',
          icon: 'add',
          onClick: 'vm.createTransaction()'
        });
      }
      vm.paginate();
      vm.getInfoForTransaction();
    };

    vm.clear_selected_transaction_period = function() {
      vm.selected_transaction_period.startDate = null;
      vm.selected_transaction_period.endDate = null;
      vm.paginate();
    };

    vm.paginate = function (limit, page) {
      $rootScope.show_loader = true;
      limit = angular.isUndefined(limit) ? 20 : vm.grid.per_page;
      page = angular.isUndefined(page) ? 1 : vm.grid.current_page;

      vm.transactionPromise = TransactionsService.getAllTransactions({
          limit: limit,
          page: page,
          type: $scope.type,
          selected_transaction_type: vm.selected_transaction_type !== null ? vm.selected_transaction_type : null,
          selected_transaction_startDate: (angular.isUndefined(vm.selected_transaction_period) || vm.selected_transaction_period === null) ? null : vm.selected_transaction_period.startDate,
          selected_transaction_endDate: (angular.isUndefined(vm.selected_transaction_period) || vm.selected_transaction_period === null) ? null : vm.selected_transaction_period.endDate
        }
      ).then(function (response) {
        vm.grid = response
        vm.transactions = vm.grid.data       
        $rootScope.show_loader = false;
      }).catch(function () {
        $rootScope.show_loader = false;
      })
    };

    vm.createTransaction = function () {
      ModalFactory.custom('app/components/a4-stock-transactions/modal-transaction-option.html', {})
        .then(function (response) {
          ModalFactory.customClean(
            'app/stock/transactions/views/form.html',
            'TransactionCreateEditController',
            'vm', false, {
              type: $scope.type === 'stock' ? 2 : 1,
              is_buy: response
            }
          ).then(function () {
            vm.paginate(20, 1);
          });
        });
    };

    vm.editTransaction = function (item) {
      if(!vm.checkPolicies('estoque_alt')) {

      $rootScope.show_loader = true;
      TransactionsService.getTransactionById(item).then(function (response) {
        $rootScope.show_loader = false;
        var transaction = response.plain();
        transaction.type = $scope.type === 'stock' ? 2 : 1;
        transaction.deleted_movements = [];
        ModalFactory.customClean(
          'app/stock/transactions/views/form.html',
          'TransactionCreateEditController',
          'vm', false, transaction
        ).then(function () {
          vm.paginate(20, 1);
        });
      });
      
    }
    };

    vm.printTransactions = function() {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET',
        'api/reports/printtransactions', {
          type: $scope.type,
          selected_transaction_type: vm.selected_transaction_type !== null ? vm.selected_transaction_type : null,
          selected_transaction_startDate: (angular.isUndefined(vm.selected_transaction_period) || vm.selected_transaction_period === null) ? null : vm.selected_transaction_period.startDate,
          selected_transaction_endDate: (angular.isUndefined(vm.selected_transaction_period) || vm.selected_transaction_period === null) ? null : vm.selected_transaction_period.endDate
        })
        .then(function () {
          $rootScope.show_loader = false;
        })
        .catch( function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message)
        })
    }

    vm.print = function (transaction) {
      ReportsService.reportFactory('GET', 'api/reports/printstocktransaction', {transaction_id: transaction.id});
    };

    vm.deleteTransaction = function (item) {
      ModalFactory.confirm(null,
        'Transação do tipo ' + item.type + ', feita na data ' + item.date,
        'Tem certeza que quer excluir essa transação?',
        'confirmar',
        'cancelar',
        'stock').then(function () {
        $rootScope.show_loader = true;
        StockService.deleteTransaction(item.id)
          .then( function () {
            Common.Toast.success("Transação excluída com sucesso!")
            vm.paginate();
            $rootScope.show_loader = false;
          })
          .catch( function () {
            Common.Toast.error('Não é possível excluir uma transação vinculada a uma conta!')
            $rootScope.show_loader = false;
          })
      })
    }

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    $scope.$on('$destroy', function () {
      if (vm.floatButton == null) {
        vm.floatButton.destroy();
      }
    });
    vm.init();


  }

  angular
    .module('app.a4stocktransactions')
    .controller('a4StockTransactionsController', a4StockTransactionsController);

})();


(function () {
  'use strict';
  angular.module('app.a4-socket', []);

})();
(function () {
  'use strict';

  function a4Socket(socketFactory, CONFIG) {
    var listener = null;


    return {
      connect: function (channel) {
        var socket = io(CONFIG.webApiSocket, {
          query: {
            channel: channel
          }
        });

        listener = socketFactory({
          ioSocket: socket
        });
        this.disconnect = listener.removeListener;
        return listener;
      },
      disconnect: null
    }

  }

  angular.module('app.a4-socket')
    .factory('a4Socket', a4Socket);

})();
(function () {
  'use strict';
  angular.module('app.a4searchfield', []);
})();
(function () {
  'use strict';

  /** @ngInject   */
  function a4SearchFieldService(Restangular) {
    var vm = this;
    vm.method = {
      POST: 'POST',
      GET: 'GET'
    };


    return {
      /**
       * Executa a chamada a uma URL passada pela diretiva
       * @param url String - Url do request
       * @param method String - Metodos HTTP {POST, GET}
       * @param params String - Objeto com parametros do request
       */
      request: function (url, method, params) {
        var m = method.toUpperCase();
        var request = Restangular;
        switch (vm.method[m]) {
          case vm.method.POST:
            return request.all(url).post(params);
            break;
          case vm.method.GET:
            return request.one(url).get(params);
            break;
        }
      }
    }
  }

  angular
    .module('app.a4searchfield')
    .factory('a4SearchFieldService', a4SearchFieldService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function SearchField() {
    return {
      restrict: 'E',
      scope: {
        placeholder: "@",
        icon: "@?",
        onChange: "&",
        url: "@",
        method: "@",
        params: "=?",
        isDisabled: '=?',
        selectedItem: "=?",
        predefinedList: "=?",
        predefinedListData: "=?",
        predefinedListSelected: "=?",
        studentPage: "=?",
        legendText: "@?"
      },
      controller: 'a4SearchFieldController',
      controllerAs: 'aSFC',
      templateUrl: 'app/components/a4-search-field/a4-search-field.html',
      link: function (scope) {
        /**
         * Define o foco no input de auto-complete
         */
        scope.setFocus = function () {
          angular.element('.a4-search-field > md-autocomplete-wrap > input').focus();
        };

        /**
         * Função disparada a partir da mudança de item selecionado no auto-complete
         * @param item - novo item selecionado
         */
        scope.onChangeItem = function (item) {
          scope.predefinedListSelected = item;
          scope.onChange({item: item});
        }
      }
    }
  }

  angular
    .module('app.a4searchfield')
    .directive('a4SearchField', SearchField);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4SearchFieldController($scope, a4SearchFieldService) {

    var vm = this;
    /**
     * Busca do auto-complete
     * @param query
     * @returns {*}
     */
    vm.querySearch = function (query) {
      angular.isDefined($scope.params) ? $scope.params.query = query : $scope.params = {query: query};
      $scope.method = angular.isDefined($scope.method) ? $scope.method : 'GET';
      if (angular.isDefined($scope.url) && $scope !== '') {
        return a4SearchFieldService.request($scope.url, $scope.method, $scope.params);
      }
    };
  }

  angular
    .module('app.a4searchfield')
    .controller('a4SearchFieldController', a4SearchFieldController);
})();
(function () {
  'use strict';
  angular.module('app.a4schoolrecordconfig', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4SchoolRecordConfig($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        config: '=?',
      },
      controller: 'a4SchoolRecordConfigController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-school-record-config/a4-school-record-config.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4schoolrecordconfig')
    .directive('a4SchoolRecordConfig', a4SchoolRecordConfig);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4SchoolRecordConfigController($scope, $rootScope) {
    var vm = this;


  }

  angular.module('app.a4schoolrecordconfig')
    .controller('a4SchoolRecordConfigController', a4SchoolRecordConfigController);
})();
(function () {
  'use strict';
  angular.module('app.a4responsibleform', []);
})();
(function () {
  'use strict';
  /** @ngInject */
  function a4ResponsibleForm()
  {
    return {
      restrict: 'E',
      scope: {
        person: '=?',
        isEnabled: '=?',
        responsibleForm: '=?',
        cpfForm: '=?',
        blockFormEmail: '=?',
        isExternalEdit: '=?'
      },
      controller: 'a4ResponsibleFormController',
      controllerAs: 'vm',
      require: ['^form'],
      templateUrl: 'app/components/a4-responsible-form/a4-responsible-form.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4responsibleform')
    .directive('a4ResponsibleForm', a4ResponsibleForm);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4ResponsibleFormController(CONFIG, $scope, $state, $timeout, $a4FloatButton, CollaboratorsService, Common, LocalStorage, ResponsiblesService,
                                       $rootScope, PersonService, SysTableColumn, $window, $q, Session) {
    var vm = this;
    vm.BRASIL = 76;
    vm.list = {};
    vm.company_id = Session.get('current_company', "sessionStorage");
    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      $rootScope.show_loader = true;
      ResponsiblesService.getPersonInfo()
        .then(function (response) {
          vm.list.person = response.person;

          console.log($scope.person)
          vm.list.person.type = [
            {'id': 1, 'name': 'Física'},
            {'id': 2, 'name': 'Jurídica'}
          ];
          vm.required_fields_responsible = SysTableColumn.getColumnsByScope('RESPONSIBLE');
          vm.required_fields_payee = SysTableColumn.getColumnsByScope('PAYEE');
          vm.list.person.id_issuer = CollaboratorsService.getListIdIssuer();
          $rootScope.show_loader = false;
          $timeout(function () {
            if ($scope.person.person_profession_id !== null) {
              for (var i = vm.list.person.person_profession_id.length; i--;) {
                if (vm.list.person.person_profession_id[i].id === $scope.person.person_profession_id) {
                  $scope.person.selected_profession = vm.list.person.person_profession_id[i];
                }
              }
            }
            $rootScope.show_loader = false;
          }, 3000);
          //vm.list.person_employee = response.person_employee;
        })
    };

    //verifica se o campo "Pessoa falecida" foi marcada.
    $scope.$watch('person.is_deceased', function(newValue, oldValue) {
      if(newValue !== oldValue) {
        $rootScope.$broadcast('isDecease', newValue)
      }
    });

    $scope.$watch('isEnabled', function(newValue) {
      vm.getFormInfos();
    })

    vm.getProfessions = function (query) {
      $scope.person.new_profession_name = query;
      return ResponsiblesService.getProfessionsByQuery({query: query});
    };

    vm.changeProfession = function (item) {
      $scope.person.person_profession_id = angular.isUndefined(item) || item === null ? null : item.id;
    };

    vm.getPlaceOfBirth = function (query) {
      return PersonService.getPlaceOfBirth({query: query});
    };

    vm.getCnpjCaptcha = function (cnpj, person) {
      vm.waiting_cnpj = true;
      PersonService.getCnpjCaptcha(cnpj)
        .then(function (response) {
          vm.waiting_cnpj = false;
          if (angular.isDefined(response.status) && response.status === 'ERROR') {
            Common.Toast.warning(response.message);
            return;
          }
          person.name = response.fantasia === '' ? response.nome : response.fantasia;
          person.corporate_name = response.nome;
          person.address_postal_code = response.cep.replace(/[^\w\s]/gi, '');
          person.address_street = response.logradouro;
          person.address_line2 = response.complemento;
          person.address_state = response.uf;
          person.address_city = response.municipio;
          person.phone_landline = response.telefone.replace(/[^\w\s]/gi, '');
          person.address_house_number = response.numero;
          person.address_district = response.bairro;
          person.email = response.email;
        })
        .catch(function () {
          vm.waiting_cnpj = false;
        });
    };


    vm.init = function () {
      vm.getFormInfos();

      console.log($scope.person)
      // Watcher para garantir que 'person' esteja sincronizado com 'vm.list.person'
      $scope.$watch('vm.list.person', function(newPerson) {
        if (newPerson) {
          $scope.person = $scope.person; // Atualiz a $scope.person quando vm.list.person muda
          $scope.$broadcast('personUpdated', $scope.person); // Comunica com os filhos
        }
      });
    };

    vm.init();
  }

  angular.module('app.a4responsibleform')
    .controller('a4ResponsibleFormController', a4ResponsibleFormController);
})();

(function () {
  'use strict';

  angular.module('app.a4responsiblecontactform', [])
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4ResponsibleContactForm() {
    return {
      restrict: 'E',
      scope: {
        person: '=?',
        isEnabled: '=?',
        responsibleForm: '=?'
      },
      controller: 'a4ResponsibleContactFormController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-responsible-contact-form/a4-responsible-contact-form.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4responsiblecontactform')
    .directive('a4ResponsibleContactForm', a4ResponsibleContactForm);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4ResponsibleContactFormController($scope, $rootScope, StudentsService, $q, $timeout, $window,
                                              Common, PersonService, ResponsiblesService, CollaboratorsService) {
    var vm = this;

    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    vm.getAddressByCep = function (CEP) {
      vm.waiting_cep = true;
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          $scope.person.address_street = address.logradouro;
          $scope.person.address_district = address.bairro;
          $scope.person.address_state = address.uf;
          vm.searchText_address_state = address.uf;
          $scope.person.address_city = address.localidade;
          vm.searchText_address_city = address.localidade;
          // vm.changeAddressState($scope.person.address_state, address.localidade);
          angular.element('#number').focus();
          vm.waiting_cep = false;
        });
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     * @param city
     */
    vm.changeAddressState = function (address_state_id, city) {
      vm.waiting_city_address_city = true;
      if (angular.isDefined(address_state_id) && angular.isDefined(address_state_id.id)) {
        $scope.person.address_state = address_state_id.id;
      } else if (vm.searchText_address_state !== null && vm.searchText_address_state !== '' && vm.searchText_address_state.length === 2) {
        $scope.person.address_state = vm.searchText_address_state;
      }
      var state = $scope.person.address_state;
      PersonService.getCities(state)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
          vm.waiting_city_address_city = false;
          var city = $window.document.getElementById('autocomplete_address_city');
          if (city !== null && angular.isDefined(city)) {
            city.focus();
          }
        })
        .catch(function () {
          vm.waiting_city_address_city = false;
        })
    };

    /**
     * Busca de estado de nascimento
     * @param filterText
     * @returns {*}
     */
    vm.getStateBirth = function (filterText) {
      var d = $q.defer();

      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        filteredItems = vm.list.person.address_state.filter(function (item) {
          return (item.id.toLowerCase()).indexOf(searchStrLower) > -1;
        });
      } else {
        filteredItems = vm.list.person.address_state;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Busca de cidade do endereço
     * @param filterText
     * @returns {*}
     */
    vm.getAddressCity = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        if (angular.isDefined(vm.list.person.address_city)) {
          filteredItems = vm.list.person.address_city.filter(function (item) {
            return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
          });
        }
      } else {
        filteredItems = vm.list.person.address_city;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Define a cidade do endereço
     * @param item
     */
    vm.setAddressCity = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.name)) {
        $scope.person.address_city = item.name;
      }
    };

  }

  angular.module('app.a4responsiblecontactform')
    .controller('a4ResponsibleContactFormController', a4ResponsibleContactFormController);
})();
(function () {
  'use strict';

  angular.module('app.a4question', [])
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4Question($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        questions: '=?',
        question: '=?',
        questionScales: '=?',
        questionnaireAnswerType: '=?',
        questionnaireType: '=?',
        questionTypes: '=?',
        addSubQuestion: '&?',
        onlineQuestionnaireDone: '=?',
        questionnaire: '=?'
      },
      controller: 'a4QuestionController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-question/a4-question.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4question')
    .directive('a4Question', a4Question);
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4QuestionController($scope, $rootScope, $mdConstant, QuestionnairesService, CONFIG, Common, ModalFactory,
                                $filter, PoliciesService, Session, DocumentsService, $sce) {
    var vm = this;
    vm.URI = CONFIG.webApiUri;
    vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    vm.show_search = false;
    vm.isDisabled = angular.isDefined($scope.question.isDisabled) ? $scope.question.isDisabled : true;
    vm.originalAnwser = null;
    vm.alternatives = {};
    vm.isAtLeastOneChecked = angular.isDefined($scope.questionnaire) ? true : null;
    $scope.selected_question = '';
    $scope.question.tags = angular.isDefined($scope.question.tags) ? $scope.question.tags : [];
    $scope.question.stem = angular.isDefined($scope.question.stem) && $scope.question.stem !== '' ? $scope.question.stem : '';
    if ($scope.question && $scope.question.items && angular.isArray($scope.question.items)) {
    $scope.question.right_answer = $scope.question.right_answer >= $scope.question.items.length ? null : $scope.question.right_answer;
    } else {
      $scope.question.right_answer = null;
    }

    vm.company_id = Session.get('current_company', "sessionStorage");

    vm.getPreview = function () {
      $rootScope.show_loader = true;

      // CHAMADA PARA RENDERIZAR O PREVIEW
      QuestionnairesService.getPreview({question_id: $scope.question.id, questionnaire_id: $scope.questionnaire, URI: vm.URI, company: vm.company_id})
        .then(function (response) {
          $scope.question.preview_html = $sce.trustAsHtml(response.html);
          $rootScope.show_loader = false;
        })
    }

    vm.addFirstOption = function () {
      if ($scope.question.items.length == 0) {
        $scope.question.items.push({'name': '', 'is_right_answer': false, 'ord': 0});
      }
    };

    vm.manageMedia = function (question) {
      if (angular.isUndefined(question.artifact_id)) {
        question.artifact_id = null;
      }
      ModalFactory.customClean('app/components/a4-question/views/file-modal.html',
        /** @ngInject */
        function (CONFIG, Common, CourseDocumentsService, DropzoneService, ModalExtra,
          $mdDialog, $rootScope, ModalFactory) {
          var vm = this;
          vm.question = ModalExtra.question;
          vm.question.file = null;
          vm.CONFIG = CONFIG;
          vm.closeModal = function (addAnother) {
            $rootScope.$broadcast('ModalFactory.close', addAnother);
          };
          vm.dzOptions = {
            url: CONFIG.webApiUri,
            paramName: 'file',
            maxFilesize: '100',
            acceptedFiles: DropzoneService.getMimeTypes(['JPG', 'PNG', 'JPEG']),
            uploadMultiple: false,
            parallelUploads: 3,
            maxFiles: 1,
            autoProcessQueue: false
          };

          vm.dzCallbacks = {
            'addedfile': function (file) {
              DropzoneService.getBase64(file)
                .then(function (base64) {
                  vm.question.file = { name: file.name, base64: base64, size: file.size };
                });
            },
            'dragenter': function (file) {
              DropzoneService.getBase64(file)
                .then(function (base64) {
                  vm.question.file = { name: file.name, base64: base64, size: file.size };
                });
            }, 'success': function (file, xhr) {
              if (xhr) {
                vm.dzMethods.removeAllFiles(true);
              }
            },
            'error': function (file, errorMessage) {
              Common.Toast.error(errorMessage);
            }
          };

          vm.deleteFile = function () {
            vm.submit({ option: 'delete_file', file: vm.question })
          };

          vm.submit = function (obj) {
            $mdDialog.hide(
              obj
            );
          }

        }, 'vm', false, { question: question })
        .then(function (response) {
          if (response && angular.isDefined(response.option)) {
            switch (response.option) {
              case 'delete_file':
                ModalFactory.confirm(null,
                  "Remover arquivo",
                  "Confirma a exclusão desse arquivo? Esta exclusão não é reversível",
                  "Confirmar", "Cancelar", "evaluations")
                  .then(function () {
                    $rootScope.show_loader = true;
                    QuestionnairesService.deleteQuestionFile({ artifact_id: response.file.artifact_id })
                      .then(function () {
                        Common.Toast.success('Arquivo deletado com sucesso!');
                        $rootScope.show_loader = false;
                        question.artifact_id = null;
                        $scope.$applyAsync();
                      });
                  });
                break;
              case 'save':
                vm.saveFile(response.file);
            }
          }
        }).catch(function (error) {
        })
    };

    vm.blank_answer = function () {
      vm.isAtLeastOneChecked = false;
      $scope.question.right_answer = null;
      if ($scope.question.question_type_id === 'QM') {
        $scope.question.items.forEach(function (item) {
          item.is_right_answer = false
        });
        vm.confirmMulitipleOption($scope.question.items);
      }
    };

    vm.saveFile = function (question) {
      $rootScope.show_loader = true;
      QuestionnairesService.saveQuestionFile({
        question: question
      })
        .then(function (file) {
          Common.Toast.success('Arquivo salvo com sucesso!');
          question.file_reference = file.file_reference;
          question.artifact_id = file.id;
          $scope.$applyAsync();
          $rootScope.show_loader = false;
        }).catch(function (error) {
          Common.Toast.error(error.data.message);
        })
    };

    vm.setRightAnswer = function () {
      $scope.question.items.forEach(function (question, ord) {
        vm.originalAnwser = $scope.question.right_answer;
        question.is_right_answer = angular.isDefined(question.is_right_answer) ? question.is_right_answer : false;
        question.ord = ord;
        if (question.ord === $scope.question.right_answer) {
          question.is_right_answer = true;
        }
      });
    };

    vm.applyEdit = function () {
      if (vm.isDisabled) {
        return vm.isDisabled = false;
      } else {
        return vm.isDisabled = true;
      };

    };

    vm.confirmOption = function () {
      ModalFactory.confirm(null,
        'Confirmar resposta',
        ' Atenção! resposta de questão modificada',
        'Confirmar',
        'Cancelar',
        'evaluations').catch(function () {
          $scope.question.right_answer = vm.originalAnwser;
          $scope.$applyAsync();

        })
    };

    vm.confirmMulitipleOption = function (items) {
      var hasChecked = items.some(function (item) {
        return item.is_right_answer;
      });

      /**
       * verificação de questão de multipla escolha, o valor de vm.isAtLeastOneChecked
       * compreende se tem pelo menos uma questão marcada, e se tiver deixa o form invalido até marcar uma
       */
      vm.isAtLeastOneChecked = hasChecked;
      if (!vm.isAtLeastOneChecked) {
        vm.formQuest.$setValidity('atLeastOneChecked', null);
      } else {
        vm.formQuest.$setValidity('atLeastOneChecked', true);
      }
    };

    vm.openSearch = function () {
      vm.show_search = !vm.show_search;
    };

    vm.loadTags = function (query) {
      return QuestionnairesService.getQuestionTags({ query: query });
    };

    vm.getQuestionTags = function (query) {
      return QuestionnairesService.getQuestionTags({ query: query });
    };

    vm.subQuestionLines = function (event) {
      event.preventDefault();

      vm.clipboard = event.originalEvent.clipboardData || window.clipboardData;
      vm.alternativeText = vm.clipboard.getData('text/plain');
      vm.alternatives = vm.alternativeText.split('\n');


      /**
       * Caso o ultimo item seja vazio, ele é retirado do array para impedir opções vazias fantasmas
       */


      // $scope.question.items = ($scope.question.items[0].name === '' || !angular.isDefined($scope.question.items[0].name)) ? [] : $scope.question.items;

      if ($scope.question.items[$scope.question.items.length - 1].name === '') {
        $scope.question.items.pop()
      }
      vm.alternatives.forEach(function (alternative) {
        if (alternative !== '') {
          $scope.question.items.push({ 'question_id': $scope.question.id, 'ord': $scope.question.items.length, 'name': alternative, 'is_right_answer': false });
        }
      });


    };

    vm.transformChip = function (tag) {
      // $timeout(function () {
      if (!angular.isObject(tag)) {
        vm.show_load_tag = true;
        QuestionnairesService.createTag({ tag: tag })
          .then(function (resp) {
            tag = resp.plain();
            $scope.question.tags.pop();
            $scope.question.tags.push(tag);
            $scope.question.tags = $filter('unique')($scope.question.tags, 'name');
            vm.show_load_tag = false;
          })
          .catch(function () {
            vm.show_load_tag = false;
            Common.Toast.error('Erro ao criar etiqueta');
          });
        return undefined;
      } else {
        $scope.question.tags.push(tag)
        $scope.question.tags = $filter('unique')($scope.question.tags, 'name');
        return null;
      }
      // }, 3000);
    };


    /**
     * Verifica Políticas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };


    vm.onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };


    // configurações do campo do editor de HTML para a questão editável.
    vm.tinymceEditableQuestion = {
      inline: false,
      entity_encoding: "raw",
      plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks ' +
        'visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc ' +
        'insertdatetime advlist lists wordcount imagetools textpattern noneditable charmap emoticons textcolor',
      skin: 'lightgray',
      theme: 'modern',
      fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
      menubar: 'file edit view format tools help forecolor backcolor',
      toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | ' +
        'alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | removeformat | ' +
        'pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ' +
        'ltr rtl | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | ' +
        'tableinsertcolbefore tableinsertcolafter tabledeletecol | forecolor backcolor',
      toolbar_sticky: true,
      color_cols: 5,
      file_picker_callback: function (cb, value, meta) {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.onchange = function () {
          var file = this.files[0];
          var reader = new FileReader();
          reader.onload = function (event) {
            DocumentsService.uploadFile({
              file: {
                photo: event.target.result,
                format: file.type.split('/')[1]
              }
            }).then(function (response) {
              cb(response.upload, {title: file.name});
            });
          };
          reader.readAsDataURL(file);
        };

        input.click();
      },
      color_map: [
        '#BFEDD2', 'Light Green',
        '#FBEEB8', 'Light Yellow',
        '#F8CAC6', 'Light Red',
        '#ECCAFA', 'Light Purple',
        '#C2E0F4', 'Light Blue',

        '#2DC26B', 'Green',
        '#F1C40F', 'Yellow',
        '#E03E2D', 'Red',
        '#B96AD9', 'Purple',
        '#3598DB', 'Blue',

        '#169179', 'Dark Turquoise',
        '#E67E23', 'Orange',
        '#BA372A', 'Dark Red',
        '#843FA1', 'Dark Purple',
        '#236FA1', 'Dark Blue',

        '#ECF0F1', 'Light Gray',
        '#CED4D9', 'Medium Gray',
        '#95A5A6', 'Gray',
        '#7E8C8D', 'Dark Gray',
        '#34495E', 'Navy Blue',

        '#000000', 'Black',
        '#ffffff', 'White'
      ],
    };

    //Array de fontes possíveis para o editor HTML para a questão editável.
    vm.font_styles = [
      "'Arial', sans-serif",
      "'Sans-Serif'",
      "'Comic Sans MS', cursive, sans-serif",
      "'Times New Roman', Times, serif",
      "'Courier New', Courier, monospace",
      "'Verdana', Geneva, sans-serif",
      "'Trebuchet MS', Helvetica, sans-serif",
      "'Arial Black', Gadget, sans-serif",
      "'Impact', Charcoal, sans-serif",
      "'Bookman', serif",
      "'Garamond', serif",
      "'Palatino', 'Palatino Linotype', 'Book Antiqua', serif",
      "'Georgia', serif"
    ];

    //Array do tamanho das fontes possíveis para o editor HTML para a questão editável
    vm.font_sizes = [
      '8', '9', '10', '11', '12', 
      '14', '16', '18', '20', '22', 
      '24', '26', '28', '36', '48', 
      '72'
    ];

    //faz duas cópias das configurações, uma para ser usada no conteúdo e outra pra ser usada na resposta
    vm.tinymceContent = angular.copy(vm.tinymceEditableQuestion);
    vm.tinymceContent.height = 500
    vm.tinymceAnswer = angular.copy(vm.tinymceEditableQuestion);
    vm.tinymceAnswer.height = 100

    vm.getPreview();
  }



  angular.module('app.a4question')
    .controller('a4QuestionController', a4QuestionController);
})();

(function () {
  'use strict';

  angular.module('app.a4-promise-queue', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4PromiseQueue($http, $q) {
    var vm = this;
    vm.logs = [];
    vm.promiseStack = [];

    vm.postPath = 'http://posttestserver.com/post.php?dir=angular-promise-queue';

    vm.setData = function (queue) {
      vm.logs.push("Building the Promise stack...");
      vm.promiseStack = queue;
      // Begin the queue
      return vm.fire();
    };

    // Fire the first promise in the queue
    vm.fire = function () {
      // If the queue has remaining items...
      // Remove the first promise from the array
      var f = vm.promiseStack.shift();
      if (vm.promiseStack.length && f) {

        // When that promise resolves, fire the next
        // promise in our queue
        // and execute it
        f().then(function (data) {
          // Log success
          vm.logs.push("OK, 200: Server received item: " + vm.promiseStack.length);
          // Pop and execute the next item off the stack
          return vm.fire();
        });
      } else {
        return false;
      }
    };

    vm.beginQueue = function () {
      vm.logs.push("Setting up the data queue.");

      vm.setData({
        a: 0,
        b: 1,
        c: 2,
        d: 3,
        e: 4,
        f: 5,
        g: 6,
        h: 7,
        i: 8,
        j: 9,
        k: 10,
        l: 11,
        m: 12,
        n: 13,
        o: 14,
        p: 15,
        q: 16,
        r: 17,
        s: 18,
        t: 19,
        u: 20,
        v: 21,
        w: 22,
        x: 23,
        y: 24,
        z: 25
      }).then(function () {

        vm.logs.push("Congrats! All data was saved sequentially.");

      }).catch(function (reason) {

        vm.logs.push("Oh dear! Something went terribly, horribly wrong.");
      });
    };

  }

  angular.module('app.a4-promise-queue')
    .service('A4PromiseQueue', A4PromiseQueue)

})();
(function () {
  'use strict';
  angular.module('app.a4productgroupconfig', []);
})();
(function () {
  'use strict';
  /** @ngInject */
  function a4ProductGroupConfig()
  {
    return {
      restrict: 'E',
      scope: {
        productGroup: '=?',
        companies: '=?',
        categories: '=?',
        currentForm: '=?'
      },
      controller: 'a4ProductGroupConfigController',
      controllerAs: 'vm',
      require: ['^form'],
      templateUrl: 'app/components/a4-product-group-config/a4-product-group-config.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4productgroupconfig')
    .directive('a4ProductGroupConfig', a4ProductGroupConfig);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4ProductGroupConfigController($scope, $q, $timeout) {
    var vm = this;

    vm.createFilterFor = function (query) {
      return function filterFn(item) {
        return (item.name.indexOf(query) === 0);
      };
    };

    vm.querySearch = function (query) {
      var results = query ? $scope.categories.filter(vm.createFilterFor(query)) : $scope.categories,
        deferred;
      if (vm.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () {
          deferred.resolve(results);
        }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    };

    vm.parseCategories = function (list) {
      var result = [];
      if (list != null && list.length > 0) {
        angular.forEach(list, function (item) {
          if (item.nodes.length > 0) {
            angular.forEach(item.nodes, function (cat) {
              result.push(cat);
              if (cat.id === $scope.productGroup.bill_category_id) {
                vm.bill_category = cat;
              }
              if (cat.nodes.length > 0) {
                angular.forEach(cat.nodes, function (child) {
                  result.push(child);
                  if (child.id === $scope.productGroup.bill_category_id) {
                    vm.bill_category = child;
                  }
                })
              }
            });
          }
        });
      } else {
        result = list;
      }
      return result;
    };

    vm.init = function () {
      $scope.categories = vm.parseCategories($scope.categories.nodes);
    };

    vm.init();

  }

  angular.module('app.a4productgroupconfig')
    .controller('a4ProductGroupConfigController', a4ProductGroupConfigController);
})();

(function () {
  'use strict';

  angular
    .module('app.a4-process-list', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function a4ProcessList() {
    return {
      templateUrl: 'app/components/a4-process-list/a4-process-list.html',
      restrict: 'E',
      scope: {
        boardCards: '=ngModel',
        orderBy: '=',
        editModal: '&',
        reorderFunction: '&',
        filterProcess: '='
      },
      controller: 'a4ProcessListController',
      controllerAs: 'vm',
      link: function () {
      }
    }
  }

  angular
    .module('app.a4-process-list')
    .directive('a4ProcessList', a4ProcessList)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4ProcessListController($scope, $timeout, a4Moment) {
    var vm = this;

    vm.openCardDialog = function (card) {
      $scope.editModal({
        card: card
      });
    }

    vm.reorder = function (order){
      var direction = 'asc';
      var order_by = null;
      if ((angular.isUndefined($scope.orderBy) || $scope.orderBy === null) && angular.isDefined(order)) {
        direction = order.substring(0, 1) === '-' ? 'desc' : 'asc';
      } else if (angular.isDefined($scope.orderBy) && $scope.orderBy !== null) {
        direction = $scope.orderBy.substring(0, 1) === '-' ? 'desc' : 'asc';
      }
      if(angular.isUndefined(order)){
        order_by = (angular.isUndefined($scope.orderBy) || $scope.orderBy === null) ? null :
          ($scope.orderBy.substring(0, 1) === '-' ? $scope.orderBy.substring(1) : $scope.orderBy);
      }else{
        order_by = (order.substring(0, 1) === '-' ? order.substring(1) : order);
      }

      $scope.orderBy = order;

      $scope.$emit('orderChanged', {
        direction: direction,
        order_by: order_by
      });

      return vm.promise = $scope.reorderFunction({
        order_by: order_by,
        direction: direction
      })
    }

    /**
     * Verifica se a data passou do prazo para mudar a cor do badge
     * @param date
     * @returns {boolean}
     */
    vm.isOverdue = function (date) {
      return a4Moment() > a4Moment(date);
    }
  }

  angular
    .module('app.a4-process-list')
    .controller('a4ProcessListController', a4ProcessListController)
})();

(function () {
  'use strict';

  angular
    .module('app.a4-process-filter', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function a4ProcessFilter() {
    return {
      templateUrl: 'app/components/a4-process-filter/a4-process-filter.html',
      restrict: 'E',
      required: 'ngModel',
      scope: {
        filterPerson: '=',
        filterProcessType: '=',
        filterDate: '=',
        filterStatus: '=',
        viewGrid: '=',
        title: '=',
        filterFunction: '&',
        changeView: '&',
        filterPersonResponsible: '='
      },
      controller: 'a4ProcessFilterController',
      controllerAs: 'vm',
      link: function () {
      }
    }
  }

  angular
    .module('app.a4-process-filter')
    .directive('a4ProcessFilter', a4ProcessFilter)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4ProcessFilterController($scope, LocalStorage, ProcessCrudService, CollaboratorsService,
                                     ProcessToSolveService, PoliciesService,  $rootScope,  ReportsService,a4Moment) {
    var vm = this;
    vm.view_grid = angular.isDefined(LocalStorage.get('process_view_grid')) ? LocalStorage.get('process_view_grid') : false;
    $scope.viewGrid = vm.view_grid;
    vm.date_range = {
      startDate: undefined,
      endDate: undefined
    };

    vm.init = function () {
      vm.getProcessType();
      vm.getCollaborators();
      vm.getProcessStatus();
      vm.getAllProcessPersonResponsibles();
    };

    vm.filterFunction = function () {
      $scope.$applyAsync();
      $scope.filterFunction({
        person: $scope.filterPerson,
        process_type: $scope.filterProcessType,
        status: $scope.filterStatus,
        date: vm.date_range,
        view_grid: vm.view_grid,
        person_responsible: $scope.filterPersonResponsible,
      }).then(function () {
        vm.init();
      });
    };

    vm.changeView = function () {
      LocalStorage.add('process_view_grid', vm.view_grid);
      $scope.viewGrid = vm.view_grid;
      vm.filterFunction();
    };

    vm.clearFilters = function () {
      $scope.filterPerson = null;
      $scope.filterProcessType = null;
      $scope.filterStatus = null;
      $scope.filterPersonResponsible = null;
      vm.date_range = '';
      vm.filterFunction();
    };

    vm.getProcessType = function () {
      ProcessCrudService.getProcessType()
        .then(function (resp) {
          var process_types = resp.plain();
          vm.process_types = process_types.filter(function (type) {
            return !vm.checkPolicies("process_type_" + type.id);
          })
        })
    };

    vm.getCollaborators = function () {
      ProcessToSolveService.getProcessCollaborators(
        {
          person_id_responsible: $scope.filterPersonResponsible, 
          status: $scope.filterStatus
        })
        .then(function (response) {
          vm.collaborators = response.plain();
        })
    };

    vm.getProcessStatus = function () {
      vm.process_status = ProcessToSolveService.getProcessStatus();
    };

    vm.printList = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory('GET', 'api/process/reports/printList',
        {
          process_type_id: $scope.filterProcessType,
          start_date: vm.date_range.startDate,
          end_date: vm.date_range.endDate
        }).then(function () {
        $rootScope.show_loader = false;
      })
    };

    vm.printListForFilters = function () {
      $rootScope.show_loader = true;
      ReportsService.reportFactory ('GET', 'api/process/reports/printListForFilters',
        {
          owner_id: $scope.filterPerson,
          process_type: $scope.filterProcessType,
          status: $scope.filterStatus,
          start_date: vm.date_range.startDate,
          end_date: vm.date_range.endDate,
          responsible_id: $scope.filterPersonResponsible
        })
        .then(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.getAllProcessPersonResponsibles = function () {
      ProcessToSolveService.getPersonResponsibles({person_id_owner: $scope.filterPerson})
        .then(function (response) {
          vm.person_responsibles = response.plain();
        })
    };

    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular
    .module('app.a4-process-filter')
    .controller('a4ProcessFilterController', a4ProcessFilterController)
})();

(function () {
  'use strict';

  angular.module('app.a4-persons', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4Persons() {
    return {
      restrict: 'E',
      scope: {
        isEducational: '=?',
        role: '=?'
      },
      controller: 'A4PersonsController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-persons/index.html',
      link: function (scope, elem, attrs, ctrl) {
      }
    }
  }

  angular.module('app.a4-persons')
    .directive('a4Persons', A4Persons);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4PersonsController($stateParams, $window, $scope, $rootScope, CONFIG, PoliciesService, Session, RolesService,
                               $mdDialog, $mdMenu, Common, ModalFactory, PersonService, $state, $a4FloatButton) {

    var vm = this;
    vm.is_educational = $scope.isEducational;
    vm.items = [];
    vm.captcha = null;
    vm.cnpjParams = [];
    vm.sex = [
      {value: 'm', name: 'Masculino'},
      {value: 'f', name: 'Feminino'}
    ];
    vm.grid = {};
    vm.search = '';
    vm.selected_tab = 0;

    $rootScope.$on('refresh-persons', function (event, data) {
      vm.getAllPersons();
    });

    $rootScope.$on('query-persons', function (event, query) {
      vm.getAllPersons(1, 15, query);
    });

    /**
     * Executa funções ao iniciar.
     */
    vm.init = function () {
      vm.getAllPersons();
      vm.current_school_period = Session.getCurrentSchoolPeriod().id;
      vm.current_company = Session.current_company;
    };

    vm.createPerson = function () {
      ModalFactory.custom(
        'app/finance/person/views/select-type.html',
        {types: vm.types},
        true
      ).then(function (type) {
        vm.personTypeSelected(type);
      });
    };

    vm.delete = function (id) {
      ModalFactory.confirm(null, "Deseja excluir essa pessoa?",
        "A pessoa será removida do sistema",
        "Confirmar", "Cancelar", "finance").then(function () {
        $rootScope.show_loader = true;
        PersonService.deletePerson(id).then(function () {
          Common.Toast.success('Persoa excluída com sucesso.');
          vm.getAllPersons();
        });
      });

    };

    /**
     * Retorna todas as pessoas.
     * @param page - (Opcional) Pagina de destino
     * @param limit - limite de registros
     */
    vm.getAllPersons = function (page, limit, query) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 15;
      page = angular.isDefined(page) ? page : 1;
      vm.search = angular.isDefined(query) ? query : vm.search;
      PersonService.getAllPersons({limit: limit, page: page, role: $scope.role, query: vm.search})
        .then(function (response) {
          vm.grid.rows = [];
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [15, 25, 50, 100, {
              label: 'Todas',
              value: function () {
                return response.total;
              }
            }],
            limit: limit,
            page: page,
            total: response.total
          };
          $rootScope.show_loader = false;
        }).catch(function () {
        Common.Toast.error('Erro ao buscar pessoas');
        $rootScope.show_loader = false;
      });
    };

    vm.changeCompany = function (new_company_id) {
      Session.set('current_company', parseInt(new_company_id), "sessionStorage");
      var user = Session.getUser();
      $rootScope.show_loader = true;
      RolesService.getUserRoleModule(user.id, Session.get(CONFIG.storage.profile))
        .then(function (response) {
          $rootScope.show_loader = false;
          Session.set(CONFIG.storage.roles, response.roles);
          Session.set(CONFIG.storage.school_period_default, response.school_period_default, "sessionStorage");
          Session.set(CONFIG.storage.current_school_period, response.school_period_default, "sessionStorage");
          // $window.location.reload();
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data.message)
        });
      $rootScope.$broadcast('$switch-header-company');
    };

    vm.goToProfile = function (person, profile) {
      if (vm.is_educational) {
        if (parseInt(person.company_id) !== vm.current_company){
          vm.changeCompany(person.company_id);
        }
        switch (profile) {
          case 'employee':
            $state.go('private.educational.collaborators.edit', {id: person.id});
            break;
          case 'student':
            if (person.last_student === vm.current_school_period) {
              $state.go('private.educational.students.edit', {
                id: person.id,
                course_id: person.course_id,
                group_id: person.group_id,
                course_equivalence_id: person.course_equivalence_id,
                matrix_period: person.matrix_period,
                enrolment_period_id: person.enrolment_period_id
              });
            } else {
              /**
               * Caso o aluno seja de outro período, envia parâmetro para alterar o período letivo do educacional
               */
              $state.go('private.educational.students.edit', {
                id: person.id,
                course_id: person.course_id,
                group_id: person.group_id,
                course_equivalence_id: person.course_equivalence_id,
                matrix_period: person.matrix_period,
                change_school_period: person.last_student.toString().replace(/\D/g, ''),
                enrolment_period_id: person.enrolment_period_id

              });
            }
            break;
          case 'responsible':
            var last_school_period = null;
            if (person.last_payee !== null && person.last_responsible !== null) {
              last_school_period = Math.max(parseInt(person.last_payee), parseInt(person.last_responsible));
            } else {
              last_school_period = person.last_payee !== null ? person.last_payee : person.last_responsible;
            }

            if (last_school_period === vm.current_school_period) {
              $state.go('private.educational.responsibles.edit', {id: person.id});
            } else {
              $state.go('private.educational.responsibles.edit', {
                id: person.id,
                change_school_period: last_school_period
              });

            }
            break;
        }
      }
    };

    /**
     * Consulta para realizar a filtragem da lista a partir da pesquisa por nome
     * @param query
     */
    vm.listAll = function (query) {
      $rootScope.show_loader = true;
      PersonService.getAllPersons({query: query, role: vm.selected_tab})
        .then(function (response) {
          vm.grid.rows = response.data;
          vm.grid.info = {
            limit_options: [15, 25, 50, 100, {
              label: 'Todas',
              value: function () {
                return response.total;
              }
            }],
            limit: response.per_page,
            page: response.current_page,
            total: response.total
          };
          $rootScope.show_loader = false;
        }).catch(function () {
        Common.Toast.error('Erro ao buscar pessoas');
        $rootScope.show_loader = false;
      })
    };

    /**
     * Define os tipos de pessoas disponíveis.
     */
    vm.types = [
      {value: 1, name: 'Pessoa', icon: 'person'},
      {value: 2, name: 'Empresa', icon: 'business'}
    ];

    vm.editPerson = function (item) {
      if (!vm.is_educational) {
        $state.go('private.finance.person-profile', {person: item, id: item.id});
      } else {
        var main_profile = vm.returnMainProfile(item);
        if (main_profile === null || main_profile === 'supplier') {
          vm.goToProfile(item, main_profile);
        }
      }
    };

    vm.returnMainProfile = function (person) {
      if (person.is_employee === 1 || person.roles_id !== null || person.is_employee === -1) {
        return 'employee';
      }

      if (person.is_student !== null) {
        return 'student';
      }

      if (person.is_employee === 2 || person.is_employee === 3 || person.is_employee === -2 || person.is_employee === -3) {
        return 'employee';
      }

      if (person.is_responsible === 1 || person.is_payee === 1) {
        return 'responsible';
      }

      if (person.is_supplier === 1) {
        return 'supplier';
      }

      return null;
    };

    /**
     * Abre o modal para criação e define um tipo de pessoa
     * selecionada para o formulário.
     */
    vm.personTypeSelected = function (value) {
      $rootScope.$broadcast('ModalFactory.close');
      $stateParams.type = value;
      ModalFactory.customClean(
        'app/finance/person/person-profile/view/create.html',
        'PersonProfileCreateController',
        'vm', false, {type: value, is_supplier: true}
      ).then(function (resp) {
        vm.getAllPersons();
        $rootScope.show_loader = false;
      });
    };

    /**
     * Redireciona para ficha financeira externa
     * @param person
     */
    vm.getExternalFinancialStatement = function (person) {
      $rootScope.show_loader = true;
      PersonService.getExternalFinancialStatementLink({person_id: person.id})
        .then(function (link) {
          $rootScope.show_loader = false;
          var element = document.createElement('a');
          element.setAttribute('href', link);
          element.setAttribute('target', '_blank');
          return element.click();
        })
    };

    vm.clickAction = function (item, option) {
      switch (option) {
        case "turn-collaborator":
          vm.setCollaborator(item);
          break;

        case "external-financial-statement":
          vm.getExternalFinancialStatement(item);
          break;
      }

    };

    /**
     * Torna um usuário colaborador
     * @param person
     */
    vm.setCollaborator = function (person) {
      /** Verifica se o usuário é colaborador ativo em outra empresa */
      PersonService.verifyCollaborator(person).then(function (response) {
        if (response === true) {
          ModalFactory.confirm(null, "Deseja continuar?",
            "A pessoa é colaboradora ativa em outra empresa",
            "Continuar", "Cancelar", "finance").then(function () {
            $rootScope.show_loader = true;
            PersonService.setCollaborator(person).then(function (response) {
              if (response) {
                Common.Toast.success("Colaborador criado com sucesso!");
              } else {
                Common.Toast.error("Erro");
              }
              vm.getAllPersons();
            })
          })
        } else {
          $rootScope.show_loader = true;
          PersonService.setCollaborator(person).then(function (response) {
            if (response) {
              Common.Toast.success("Colaborador criado com sucesso!");
            } else {
              Common.Toast.error("Erro");
            }
            vm.getAllPersons();
          })
        }
      })
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    vm.init();
  }

  angular
    .module('app.a4-persons')
    .controller('A4PersonsController', A4PersonsController)
    .filter('makeUppercase', function () {
      return function (item) {
        return item.toUpperCase();
      };
    });
})();

(function () {
  'use strict';
  angular.module('app.a4persondocuments', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4PersonDocuments() {
    return {
      restrict: 'E',
      scope: {
        personId: '=?'
      },
      controller: 'a4PersonDocumentsController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-person-documents/a4-person-documents.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4persondocuments')
    .directive('a4PersonDocuments', a4PersonDocuments);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4PersonDocumentsController($scope, $rootScope, $mdDialog, Common,
                                       CONFIG, CollaboratorsService, ModalFactory) {
    var vm = this;
    vm.person_id = angular.copy($scope.personId);
    vm.CONFIG = CONFIG;

    vm.init = function () {
      vm.getDocuments();
    }

    vm.getDocuments = function () {
      $rootScope.show_loader = true;
      CollaboratorsService.getDocuments({person_id: vm.person_id})
        .then(function (resp) {
          $rootScope.show_loader = false;
          vm.documentsList = resp.plain();
        }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Erro ao buscar documentos');
      })
    }

    vm.editFiles = function (document) {
      if (angular.isUndefined(document.artifact_id)) {
        document.artifact_id = null;
      }
      ModalFactory.customClean('app/components/a4-person-documents/a4-person-document-upload.html',
        'A4PersonDocumentsUploadController', 'vm', false, {document: document})
        .then(function (response) {
          if (response && angular.isDefined(response.option)) {
            switch (response.option) {
              case 'delete_file':
                vm.deleteFile(response.document);
                break;
              case 'save':
                vm.saveFile(response.document);
            }
          }
        }).catch(function (error) {
      })
    };

    vm.addOtherFile = function (document) {
      var new_document = angular.copy(document);
      if (angular.isDefined(document.artifact_id)) {
        new_document.artifact_id = null;
        new_document.notes = null;
        new_document.file_reference = null;
        new_document.artifact_name = null;
      }
      ModalFactory.customClean('app/components/a4-person-documents/a4-person-document-upload.html',
        'A4PersonDocumentsUploadController', 'vm', false, {document: new_document})
        .then(function (response) {
          if (response && angular.isDefined(response.option)) {
            switch (response.option) {
              case 'save':
                vm.saveFile(response.document);
            }
          }
        });
    }

    vm.deleteFile = function (document) {
      ModalFactory.confirm(null,
        "Remover arquivo",
        "Confirma a exclusão desse arquivo? Esta exclusão não é reversível",
        "Confirmar", "Cancelar", "educational")
        .then(function () {
          $rootScope.show_loader = true;
          CollaboratorsService.deleteDocumentFile({
            artifact_id: document.artifact_id,
            person_id: vm.person_id
          })
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Arquivo excluído com sucesso!');
              vm.getDocuments();
            }).catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.error('Erro ao excluir documento');
          });
        }).catch(function () {
        vm.editFiles(document);
      });
    }

    vm.saveFile = function (document) {
      $rootScope.show_loader = true;
      CollaboratorsService.uploadDocuments({
        document: document,
        person_id: vm.person_id
      })
        .then(function (file_reference) {
          Common.Toast.success('Arquivo salvo com sucesso!');
          document.file_reference = file_reference;
          $rootScope.show_loader = false;
          vm.getDocuments();
        }).catch(function (error) {
        $rootScope.show_loader = false;
        Common.Toast.error(error.data.message);
      })
    };

    vm.init();
  }

  angular.module('app.a4persondocuments')
    .controller('a4PersonDocumentsController', a4PersonDocumentsController);
})();

(function (){
  /** @ngInject */
  function A4PersonDocumentsUploadController(CONFIG, Common, CourseDocumentsService, DropzoneService, ModalExtra,
            $mdDialog, $rootScope, $document, LocalStorage) {
    var vm = this;
    vm.document = ModalExtra.document;
    vm.document.file = null;
    vm.CONFIG = CONFIG;
    vm.closeModal = function (addAnother) {
      $rootScope.$broadcast('ModalFactory.close', addAnother);
    };
    var connection = $document[0].domain.split('.')[0];
    var company = LocalStorage.get('current_company', "sessionStorage");

    /** Define as configurações para o upload */
    vm.dzOptions = {
      url: CONFIG.webApiUri + 'api/document/uploadfiles?company=' + company + '&connection=' + connection,
      paramName: 'file',
      maxFilesize: '100',
      acceptedFiles: DropzoneService.getMimeTypes(['PDF', 'DOC', 'DOCX', 'JPG', 'PNG', 'JPEG']),
      uploadMultiple: false,
      parallelUploads: 1,
      maxFiles: 1,
      autoProcessQueue: true
    };

    vm.dzCallbacks = {
      'addedfile': function (file) {
        DropzoneService.getBase64(file)
          .then(function (base64) {
            vm.document.file = {name: file.name, base64: base64, size: file.size};
          });
      },
      'success': function (file, xhr) {
        if (xhr) {
          vm.dzMethods.removeAllFiles(true);
        }
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      }
    };

    vm.deleteDocument = function () {
      vm.submit({option: 'delete_file', document: vm.document})
    };

    vm.submit = function (obj) {
      $mdDialog.hide(
        obj
      );
    }

  }

  angular.module('app.a4persondocuments')
    .controller('A4PersonDocumentsUploadController', A4PersonDocumentsUploadController);
})();

(function () {
  'use strict';

  angular.module('app.a4pendentgrades', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4PendentGrades($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        for: '=?',
        pendentGrades: '=?'
      },
      controller: 'a4PendentGradesController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-pendent-grades/a4-pendent-grades.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4pendentgrades')
    .directive('a4PendentGrades', a4PendentGrades);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4PendentGradesController($scope, $rootScope, a4Moment) {
    var vm = this;
    vm.today = a4Moment();


  }

  angular.module('app.a4pendentgrades')
    .controller('a4PendentGradesController', a4PendentGradesController);
})();
(function () {
  'use strict';

  angular
    .module('app.a4-payments-grid', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4PaymentService(BillReceiptService, $filter, $q, LocalStorage, Utils, Restangular, a4Moment) {
    /**
     * Busca as configurações de acordo com a empresa;
     */
    var getConfig = function () {
      var deferred = $q.defer();
      BillReceiptService.getConfig()
        .then(function (response) {
          deferred.resolve({
            bill_category_id: response.bill_category_id_check_interest,
            check_interest_per_month: response.check_interest_per_month
          });
        })
        .catch(function (response) {
          deferred.reject(response);
        });
      return deferred.promise;
    };

    /**
     * Calcula o valor pendente
     * @returns {string}
     */
    var getRemainingAmount = function (amount, paymentslist) {
      var remaningAmount = amount;
      if (paymentslist != null && paymentslist.length > 0) {
        angular.forEach(paymentslist, function (item) {
          remaningAmount = remaningAmount - item.amount;
        });
      }

      if (remaningAmount < 0) {
        remaningAmount = 0;
      }

      return remaningAmount;
    };

    /**
     * Retorna todas as contas ativas a partir do tipo
     * @param type - Tipo de pagamento;
     * @param account_list - lista de contas correntes disponíveis;
     * @returns {Array}
     */
    var getAccountByType = function (type, account_list) {
      var allAccount = [];
      if (typeof(type) == "object") {
        angular.forEach(account_list, function (value, key) {
          for (var j = 0; j < type.length; j++) {
            if (value.current_account_type_id == type[j]) {
              allAccount.push(value);
            }
          }
        });
      } else if (account_list != null && account_list.length > 0) {
        allAccount = $filter('filter')(account_list, {
          current_account_type_id: type,
          is_inactive: false
        })
      }
      return allAccount;
    };


    /**
     * Calcula o juros
     * @param amount - Valor total do pagamento
     * @param check - Cheque em questão
     * @param checkInterest - Percentual do juro
     * @param interestValue - valor do juro;
     * @returns {*}
     */
    var calcInterest = function (amount, check, checkInterest, interestValue) {
      if (typeof check != 'undefined') {
        var localjuros = LocalStorage.get('Juros_' + check.guid);
        localjuros == null ? localjuros = {amount: 0} : localjuros;
        var localPayment = LocalStorage.get('payment_' + check.guid);
        localPayment == null ? localPayment = {amount: 0} : localPayment;
        var acrex = 0;
        if (checkInterest) {
          acrex = ((amount * checkInterest) / 100).toFixed(2);
          interestValue = acrex;
          localjuros.amount = interestValue;
          if (check.amount != null) {
            localPayment.amount = check.amount;
          } else {
            localPayment.amount = 0;
          }
        }

      } else {
        acrex = 0;
        if (checkInterest) {
          acrex = ((amount * checkInterest) / 100).toFixed(2);
          interestValue = acrex;
        }
      }

      return {amount: parseFloat(amount), interest_value: parseFloat(interestValue)};
    };


    /**
     * Comparar datas para saber se deve aplicar juros
     * @param date
     * @returns {boolean}
     */
    var dateComparasion = function (date) {
      var now = a4Moment();
      return now.isBefore(a4Moment(date));
    };


    /**
     * Retorna o valor dos títulos baseado na data passada
     */
    var getValueOfBillsByDate = function (obj) {
      return Restangular.one('bill').one('getvalueofbillsdate').get(obj);
    };

    return {
      calcInterest: calcInterest,
      getAccountByType: getAccountByType,
      getRemainingAmount: getRemainingAmount,
      getConfig: getConfig,
      dateComparasion: dateComparasion,
      getValueOfBillsByDate: getValueOfBillsByDate
    };
  }

  angular.module('app.a4-payments-grid')
    .factory('A4PaymentService', A4PaymentService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4PaymentsGrid($rootScope, $filter, Toast, ModalFactory, PAYMENT_TYPES, Common, a4Moment,
                          angularMomentConfig, BillReceiptService, $q, PaymentControl, PoliciesService,
                          A4PaymentService, LocalStorage, Utils, $timeout) {

    return {
      restrict: "E",
      scope: {
        currentaccountlist: "=",
        debitcredit: '=',
        amount: '=',
        checklist: '=',
        movementtypes: '=',
        paymentslist: '=',
        billsselected: '=',
        banks: '=',
        checkinterest: '=',
        ispartialpayment: '=',
        paymentwithdifference: '=',
        haslessdifference: '=',
        hasmoredifference: '=',
        datedifference: '=',
        date: '=',
        suggestedDate: '=',
        checkPad: '=',
        totalFine: '=',
        totalInterest: '=',
        amountCalc: '=',
        creditAmount: '=?',
        creditPerson: '=?',
        paymentTax: '=?',
        difference: '='
      },
      templateUrl: 'app/components/a4-payments-grid/templates/payments.html',
      controller: 'A4PaymentsController',
      controllerAs: 'vm',
      link: function (scope, element, attrs, ctrl) {
        ctrl.directive = scope;
        var today = a4Moment();

        scope.creditAmount = angular.isDefined(scope.creditAmount) ? scope.creditAmount : 0;
        scope.haslessdifference = false;
        scope.hasmoredifference = false;
        scope.paymentwithdifference = false;
        scope.barcode = '';
        scope.isOpen = false;
        scope.paymentslist = [];

        /**
         * init
         */
        scope.initPayment = function () {

          // if (angular.isArray(scope.currentaccountlist) && scope.currentaccountlist.length === 0) {
          //   Toast.warning("PaymentsGrid: The model 'currentaccountlist' is required.");
          // }

          scope.date = today;
          scope.suggestedDate = today;
          scope.datedifference = angular.isUndefined(scope.datedifference) ? a4Moment() : scope.datedifference;

          PaymentControl.setItemsSelected(scope.billsselected);
          PaymentControl.setPaymentDate(scope.date);
          if (!scope.checkPad) {
            scope.setPaymentDate(scope.date);
          }
          scope.setPaymentSuggestedDate(scope.suggestedDate);
        };

        /**
         * Define se é pagamentos parciais
         * @param valueCheck
         */
        scope.setPartialPayment = function (valueCheck) {
          scope.ispartialpayment = valueCheck;
        };

        scope.setPaymentWithDifference = function (valueCheck) {
          scope.paymentwithdifference = valueCheck;
        };

        scope.setDateDifference = function (date) {
          scope.datedifference = date;
        };

        scope.separeId = function (items) {
          var ids = [];
          items.forEach(function (item) {
            if (angular.isUndefined(item.product_group_id)) {
              ids.push(item.id);
            }
          });
          return ids;
        };

        /**
         * @param date Variavel do tipo Date (new Date())
         */
        scope.setPaymentDate = function (date) {
          if (date !== scope.date) {
            scope.date = a4Moment(date).format('YYYY-MM-DD');
            var ids = scope.separeId(scope.billsselected);
            A4PaymentService.getValueOfBillsByDate({date: scope.date, ids: ids.toString()})
              .then(function (resp) {
                var items = resp.plain();
                items.forEach(function (item) {
                  var oldItem = PaymentControl.getItemAndIndexById(item.id);
                  item.calc_final_value = item.final_value;
                  oldItem.item.difference = isNaN(oldItem.item.difference) ? 0 : oldItem.item.difference;
                  item.final_value = item.partial_payment_msg !== null ? item.calc_final_value - (oldItem.item.difference * -1) : item.calc_final_value;
                  item.allowance = oldItem.item.allowance;
                  item.difference = oldItem.item.difference;
                  item.is_partial_payment = oldItem.item.is_partial_payment;
                  PaymentControl.updateItemOnList(item, oldItem.index);
                  $rootScope.$broadcast('BILL_LIST.change', PaymentControl.getItemsSelected());
                });
                scope.updateAmount(scope.billsselected);
              })
          }
        };

        scope.checkPolicies = function (policy) {
          return !PoliciesService.checkPolicyFromMenu(policy);
        };

        /**
         * Atualiza valores dos titulos
         * @param list
         */
        scope.updateAmount = function (list) {
          var totalAmount = 0;
          var totalFine = 0;
          var totalInterest = 0;
          angular.forEach(list, function (value) {
            totalAmount += parseFloat(value.final_value);
            totalFine += parseFloat(value.calc_fine_value);
            totalInterest += parseFloat(value.calc_interest_value);
          });
          scope.totalFine = totalFine;
          scope.totalInterest = totalInterest;
          /** Se o total calculado for igual ao total ou se for 0, coloca o valor calculado na função, senão mantém o valor anterior */
          scope.amountCalc = ((scope.amountCalc === scope.amount) || (scope.amountCalc === 0)) ? totalAmount : scope.amountCalc;
          scope.amount = totalAmount;
        };

        /**
         * Sugestiona a data
         * @param date
         */
        scope.setPaymentSuggestedDate = function (date) {
          scope.suggestedDate = (angular.isObject(date) && angular.isDefined(date) && date !== null) ?
            date.toISOString().substring(0, 10) : date;
        };

        /**
         * Abre o modal para os tipos de pagamento
         * @param type
         */
        scope.getModal = function (type) {
          var obj = {
            checkInterest: scope.checkinterest,
            currentAccountList: scope.currentaccountlist,
            paymentslist: scope.paymentslist,
            amount: scope.amount,
            debitcredit: scope.debitcredit,
            banks: scope.banks,
            date: scope.date
          };
          if (type === PAYMENT_TYPES.MONEY) {
            scope.callModalMoney();
          } else if (type === PAYMENT_TYPES.BANK) {
            scope.callBankPaymentModal(PAYMENT_TYPES.BANK);
          } else if (type === PAYMENT_TYPES.CHECK) {

            if (scope.debitcredit.toLowerCase() === 'd') {
              ctrl.callModalPayCheck(PAYMENT_TYPES.BANK, PAYMENT_TYPES.MONEY, '', false, obj);
            } else {
              ctrl.callModalReceiveCheck(PAYMENT_TYPES.BANK, PAYMENT_TYPES.MONEY, '', false, obj);
            }

          } else if (type === PAYMENT_TYPES.CARD_DEBIT) {
            scope.callModalDebitCard()
          } else if (type === PAYMENT_TYPES.CARD_CREDIT) {
            scope.callModalCreditCard()
          } else if (type === PAYMENT_TYPES.CARD_CREDIT_RECEIVING) {
            scope.callModalCreditCardReceiving()
          } else if (type === PAYMENT_TYPES.CARD_DEBIT_RECEIVING) {
            scope.callModalDebitCardReceiving()
          } else if (type === PAYMENT_TYPES.CREDIT) {
            scope.callModalCreditReceiving()
          } else if (type === PAYMENT_TYPES.TAX) {
            scope.callModalReceivingTax()
          }
        };

        scope.callModalReceivingTax = function () {
          scope.obj = {
            movement_type_id: 10020,
            type: scope.debitcredit.toLowerCase(),
            amount: 0,
            suggested_date: (angular.isObject(scope.suggestedDate)) ? scope.suggestedDate.toISOString().substring(0, 10) : scope.suggestedDate,
            date: (angular.isObject(scope.date)) ? scope.date.toISOString().substring(0, 10) : scope.date
          };
          ModalFactory.custom("app/finance/bill-payment/modals/PaymentTax.html", scope);
        }

        /**
         * Abre a modal de pagamento em cartão de débito
         */
        scope.callModalDebitCard = function () {
          scope.suggestedDate = today;
          var list = scope.getAllDebitCardAccounts();

          scope.obj = {
            movement_type_id: 20,
            type: scope.debitcredit.toLowerCase(),
            amount: scope.getRemainingAmount(),
            suggested_date: (angular.isObject(scope.suggestedDate)) ? scope.suggestedDate.toISOString().substring(0, 10) : scope.suggestedDate,
            date: (angular.isObject(scope.date)) ? scope.date.toISOString().substring(0, 10) : scope.date,
            current_account: list[0],
            debitCard: list[0].cards[0],
            listAllCards: scope.getAllCard(list),
            currentAccountlist: list,
            current_account_id: list[0].id,
          };

          ModalFactory.custom("app/finance/bill-payment/modals/DebitCardPayment.html", scope);
        };

        /**
         * Abre a modal de pagamento em cartão de crédito
         */
        scope.callModalCreditCard = function () {
          var list = scope.getAllCreditCardAccounts();

          scope.obj = {
            movement_type_id: 21,
            type: scope.debitcredit.toLowerCase(),
            amount: scope.getRemainingAmount(),
            date: (angular.isObject(scope.date)) ? scope.date.toISOString().substring(0, 10) : scope.date,
            current_account: list,
            suggested_date: null,
            creditCard: angular.isDefined(list[0]) ? list[0].cards[0] : null,
            listAllCards: scope.getAllCard(list),
            currentAccountlist: list,
            current_account_id: angular.isDefined(list[0]) ? list[0].current_account_id : null
          };

          ModalFactory.custom("app/finance/bill-payment/modals/CreditCardPayment.html", scope);
        };

        /**
         * Abre a modal de recebimento em cartão de crédito
         */
        scope.callModalCreditCardReceiving = function () {
          var list = scope.getAllCreditCardReceivingAccounts();
          scope.obj = {
            movement_type_id: 21,
            type: scope.debitcredit.toLowerCase(),
            amount: scope.getRemainingAmount(),
            date: (angular.isObject(scope.date)) ? scope.date.toISOString().substring(0, 10) : scope.date,
            current_account: list[0],
            currentAccountlist: list,
            current_account_id: angular.isDefined(list[0]) ? list[0].id : null
          };
          ModalFactory.custom("app/finance/bill-payment/modals/CreditCardReceiving.html", scope);
        };

        scope.setTax = function (obj) {
          if (obj.current_account.card_taking_percent > 0) {
            obj.paymentTax = parseFloat(obj.current_account.card_taking_percent * obj.amount);
          } else{
            obj.paymentTax = 0;
          }
          obj.current_account_id = obj.current_account.id;
        }

        /**
         * Abre a modal de recebimento em cartão de débito
         */
        scope.callModalDebitCardReceiving = function () {
          var list = scope.getAllDebitCardReceivingAccounts();

          scope.obj = {
            movement_type_id: 20,
            type: scope.debitcredit.toLowerCase(),
            amount: scope.getRemainingAmount(),
            date: (angular.isObject(scope.date)) ? scope.date.toISOString().substring(0, 10) : scope.date,
            current_account: list,
            currentAccountlist: list,
            current_account_id: angular.isDefined(list[0]) ? list[0].id : null
          };
          ModalFactory.custom("app/finance/bill-payment/modals/DebitCardReceiving.html", scope);
        };

        scope.getAllCard = function (list) {
          var allCards = [];

          angular.forEach(list, function (item) {
            if (item.cards.length)
              angular.forEach(item.cards, function (card) {
                allCards.push(card);
              });
          });

          return allCards;
        };
        /**
         * Abre a modal de pagamento em dinheiro
         */
        scope.callModalMoney = function () {

          var money_type = 1;
          scope.moneyAccountList = A4PaymentService.getAccountByType(money_type, scope.currentaccountlist);


          if (scope.moneyAccountList.length) {
            var current_account_id = angular.isDefined($filter('filter')(scope.moneyAccountList, {is_main: true})[0]) ?
              $filter('filter')(scope.moneyAccountList, {is_main: true})[0].id : scope.moneyAccountList[0].id;

            scope.money = {
              movement_type_id: 1,
              current_account_id: current_account_id,
              debit_credit: scope.billsselected[0].debit_credit,
              date: (angular.isObject(scope.date)) ? scope.date.toISOString().substring(0, 10) : scope.date,
              amount: scope.getRemainingAmount()
            };

            ModalFactory.custom("app/finance/bill-payment/modals/MoneyPayment.html", scope);

          } else {
            scope.toastWarn('Não existem contas caixa cadastradas no sistema.');
          }
        };

        /**
         * Abre a modal de pagamento com crédito
         */
        scope.callModalCreditReceiving = function () {
          var amount = parseFloat(scope.getRemainingAmount()) > scope.creditAmount ? scope.creditAmount : scope.getRemainingAmount();
          scope.obj = {
            movement_type_id: 57, //uso no caixa
            type: 'd',
            amount: amount,
            balance: scope.creditAmount,
            date: (angular.isObject(scope.date)) ? scope.date.toISOString().substring(0, 10) : scope.date,
            current_account: [],
            currentAccountlist: [],
            current_account_id: angular.isDefined(scope.creditPerson) ? scope.creditPerson : null,
            person_id: angular.isDefined(scope.creditPerson) ? scope.creditPerson : null
          };
          ModalFactory.custom("app/finance/bill-payment/modals/CreditPayment.html", scope);
        };

        /**
         * Retorna todas as contas ativas do tipo cartão de débito
         * @returns {Array}
         */
        scope.getAllDebitCardAccounts = function () {
          var result = [];
          if (scope.currentaccountlist !== null && scope.currentaccountlist.length > 0) {
            angular.forEach(scope.currentaccountlist, function (item) {
              if (item.current_account_type_id === 2) {
                result.push(item);
              }
            });
          }
          return result;
        };

        /**
         * Retorna todas as contas ativas do tipo cartão de débito recebíveis
         * @returns {Array}
         */
        scope.getAllDebitCardReceivingAccounts = function () {
          var result = [];
          if (scope.currentaccountlist !== null && scope.currentaccountlist.length > 0) {
            angular.forEach(scope.currentaccountlist, function (item) {
              if (item.current_account_type_id === 6) {
                result.push(item);
              }
            });
          }
          return result;
        };

        scope.getAccountIdByCard = function (card) {
          scope.obj.current_account_id = card.current_account_id;
        };

        /**
         * Retorna todas as contas ativas do tipo cartão de crédito de pagamento
         * @returns {Array}
         */
        scope.getAllCreditCardAccounts = function () {
          var result = [];
          if (scope.currentaccountlist !== null && scope.currentaccountlist.length > 0) {
            angular.forEach(scope.currentaccountlist, function (item) {
              if (item.current_account_type_id === 5) {
                result.push(item);
              }
            });
          }
          return result;
        };

        /**
         * Retorna todas as contas ativas do tipo cartão de crédito de recebimento
         * @returns {Array}
         */
        scope.getAllCreditCardReceivingAccounts = function () {
          var result = [];
          if (scope.currentaccountlist !== null && scope.currentaccountlist.length > 0) {
            angular.forEach(scope.currentaccountlist, function (item) {
              if (item.current_account_type_id === 4) {
                result.push(item);
              }
            });
          }
          return result;
        };

        /** CHEQUE
         * Abre a modal de pagamento em cheque
         * @param type_bank - Tipo da conta corrente.
         * @param number_check (opcional) - Número do cheque
         * @param is_own (opcional) - Número do cheque
         * Seta valores iniciais
         */
        scope.callModalPayCheck = function (type_bank, number_check, is_own) {

          scope.bankAccounts = A4PaymentService.getAccountByType(type_bank, scope.currentaccountlist);

          if (scope.bankAccounts.length) {

            var lastCheck = scope.getLastCheckForSupplier();
            var document = '';
            var current_account_id = angular.isDefined($filter('filter')(scope.bankAccountList, {is_main: true})[0]) ?
              $filter('filter')(scope.bankAccountList, {is_main: true})[0].id : scope.bankAccountList[0].id;


            if (!angular.equals({}, lastCheck)) {
              document = (parseInt(lastCheck.document) + 1).toString();
              current_account_id = lastCheck.current_account_id;
            }

            scope.check = {
              movement_type_id: 2,
              is_third_party_check: false,
              expected_date: a4Moment().format('DD/MM/YYYY'),
              document: document,
              current_account_id: current_account_id,
              amount: scope.getRemainingAmount()
            };

            if (number_check !== undefined && number_check !== '') {
              scope.check.document = number_check;
              if (angular.element('#modal_check_input_check_number').length) {
                $timeout(function () {
                  angular.element('#modal_check_input_check_number').attr('disabled', true);
                }, 500);
              }
              scope.check.readed = true;
              if (is_own !== undefined && number_check !== '') {
                scope.check.movement_type_id = 2;
              }
            }

            ModalFactory.custom("app/finance/bill-payment/modals/CheckPayment.html", scope);

          } else if (scope.checklist.length) {
            scope.check = {
              movement_type_id: 5,
              is_third_party_check: true,
              expected_date: Utils.convertDateToInterface(scope.checklist[0].date),
              detail: scope.checklist[0].detail,
              document: scope.checklist[0].number,
              amount: scope.checklist[0].amount,
              check_id: scope.checklist[0].id
            };
            return ModalFactory.custom("app/finance/bill-payment/modals/CheckPayment.html", scope);
          } else {
            scope.toastWarn('Não é possivel realizar esta ação com cheque');
          }
        };

        /**
         * Preenche os campos de acordo com o cheque item selecionado
         * @param check_id
         */
        scope.setCheckDateValue = function (check_id) {

          var selectedCheck = scope.checklist.filter(function (item) {
            return item.id === check_id
          })[0];

          if (selectedCheck) {
            scope.check.amount = selectedCheck.amount;
            scope.check.expected_date = Utils.convertDateToInterface(selectedCheck.date);
            scope.check.document = selectedCheck.number;
            scope.check.detail = selectedCheck.detail;
            scope.check.current_account_id = selectedCheck.current_account_id;
            scope.check.blocked = false;
          }
        };

        /**
         * Altera os dados da visão entre cheque terceiros e próprio
         * @param movement_type
         */
        scope.checkOriginChanged = function (movement_type) {
          if (movement_type === PAYMENT_TYPES.TYPE_CHECK) {
            scope.check.current_account_id = scope.bankAccounts[0].id;
            scope.check.expected_date = a4Moment().format('DD/MM/YYYY');
            scope.check.amount = scope.getRemainingAmount();
            scope.check.document = "";
            scope.check.is_third_party_check = false;
          } else if (movement_type === PAYMENT_TYPES.TYPE_CHECK_THIRD_PARTY) {
            scope.check.is_third_party_check = true;
            scope.check.check_id = scope.checklist[0].id;
            scope.check.amount = scope.checklist[0].amount;
            scope.check.expected_date = Utils.convertDateToInterface(scope.checklist[0].date);
            scope.check.document = scope.checklist[0].number;
            scope.check.detail = scope.checklist[0].detail;
            scope.check.current_account_id = scope.checklist[0].current_account_id;
            scope.check.blocked = false;
          }
        };

        /**
         * Cria modal de pagamento com Banco
         */
        scope.callBankPaymentModal = function (type_bank) {
          scope.bankAccountList = A4PaymentService.getAccountByType(type_bank, scope.currentaccountlist);

          if (scope.bankAccountList.length) {

            switch (scope.debitcredit.toUpperCase()) {
              case "D":
                scope.bank = {
                  obj: {idx: null},
                  movement_type_id: 10,
                  debit_credit: scope.billsselected[0].debit_credit,
                  date: (angular.isObject(scope.date)) ? scope.date.toISOString().substring(0, 10) : scope.date,
                  current_account_id: angular.isDefined($filter('filter')(scope.bankAccountList, {is_main: true})[0]) ?
                    $filter('filter')(scope.bankAccountList, {is_main: true})[0].id : scope.bankAccountList[0].id,
                  amount: A4PaymentService.getRemainingAmount(scope.amount, scope.paymentslist)
                };
                break;
              case "C":
                scope.bank = {
                  obj: {idx: null},
                  movement_type_id: 12,
                  debit_credit: scope.billsselected[0].debit_credit,
                  date: (angular.isObject(scope.date)) ? scope.date.toISOString().substring(0, 10) : scope.date,
                  current_account_id: angular.isDefined($filter('filter')(scope.bankAccountList, {is_main: true})[0]) ?
                    $filter('filter')(scope.bankAccountList, {is_main: true})[0].id : scope.bankAccountList[0].id,
                  amount: A4PaymentService.getRemainingAmount(scope.amount, scope.paymentslist)
                };
                break;
            }

            scope.bank.bankAccountList = scope.bankAccountList;
            scope.bank.addPaymentList = scope.addPaymentList;
            ModalFactory.custom("app/finance/bill-payment/modals/BankPayment.html", scope);
          } else {
            scope.toastWarn('Não existem contas bancárias cadastradas no sistema.');
          }


        };

        /**
         * Calcula o valor pendente
         * @returns {string}
         */
        scope.getRemainingAmount = function () {
          var remaningAmount = scope.amount;
          if (scope.paymentslist !== null && scope.paymentslist.length > 0) {
            angular.forEach(scope.paymentslist, function (item) {
              remaningAmount = remaningAmount - item.amount;
            });
          }
          remaningAmount = remaningAmount - scope.paymentTax;
          if (remaningAmount < 0) {
            remaningAmount = 0;
          }

          return remaningAmount;
        };

        /**
         * Checa se existe o tipo de currentAccount cadastrado no sistema.
         * @param type
         * @returns {boolean}
         */
        scope.existCurrentAccountType = function (type) {
          var result = false;

          if (scope.currentaccountlist !== null && scope.currentaccountlist.length > 0) {
            angular.forEach(scope.currentaccountlist, function (value, key) {
              if (type === value.type_name)
                result = true;
            });
          }

          return result;
        };


        /*
         ---------------FUNÇÕES PARA VERIFICAÇÃO DE CHEQUE DUPLICADO---------------
         */
        /**
         *
         * @param obj
         * @returns {boolean}
         */
        scope.verifyCheckisUsed = function (obj) {

          var checkUsed = false;
          if (scope.debitcredit.toLowerCase() === 'd') {
            if (obj.movement_type_id === PAYMENT_TYPES.TYPE_CHECK_THIRD_PARTY) {

              angular.forEach(scope.paymentslist, function (item) {
                if (item.check_id === obj.check_id &&
                  item.movement_type_id === obj.movement_type_id) {
                  checkUsed = true;
                }
              });

            } else if (obj.movement_type_id === PAYMENT_TYPES.TYPE_CHECK) {

              angular.forEach(scope.paymentslist, function (item) {
                if (item.document === obj.document &&
                  item.current_account_id === obj.current_account_id &&
                  item.movement_type_id === obj.movement_type_id) {
                  checkUsed = true;
                }
              });
            }

          } else {
            angular.forEach(scope.paymentslist, function (item) {
              if (item.movement_type_id === 2 || item.movement_type_id === 5) {
                if (typeof item.bank !== undefined && item.bank.id === obj.bank.id &&
                  item.number === obj.number &&
                  item.branch === obj.branch &&
                  item.account === obj.account) {

                  checkUsed = true;
                }
              }
            });
          }
          return checkUsed;
        };

        /**
         * Verifica se Cheque já foi utilizado
         * @param check
         * @param show_message
         * @returns {*}
         */
        scope.verifyDuplicateCheck = function (check, show_message) {

          var blocked;
          var deffered = $q.defer();
          var checkUsedFromScreen = scope.verifyCheckisUsed(check);
          if (!checkUsedFromScreen) {
            check.debit_credit = scope.debitcredit.toLowerCase();
            if ((check.account && check.branch && check.number && check.debit_credit === 'c') ||
              (check.current_account_id && check.document && check.movement_type_id && check.debit_credit === 'd')) {

              BillReceiptService.verifyDuplicatedCheck(check)
                .then(function (response) {
                  if (response) {
                    if (show_message) {
                      scope.toastWarn('Cheque já utilizado');
                    }
                    blocked = true;
                  } else {
                    blocked = false;
                  }
                  deffered.resolve(blocked);
                })
                .catch(function () {
                  scope.toastWarn('Problemas na verificação do cheque');
                  deffered.reject(false);
                });
            } else {
              if (check.debit_credit === 'd' && check.movement_type_id === 5 && check.check_id) {
                scope.check.blocked = false;
                deffered.resolve(false);
              } else {
                scope.check.blocked = true;
                deffered.resolve(true);
              }
            }
          } else {
            scope.check.blocked = true;
            if (show_message) {
              scope.toastWarn('Cheque já utilizado');
            }
            deffered.resolve(true);
          }

          return deffered.promise;

        };

        /*
         -------------FUNÇÕES PARA SUGESTÃO DE CHEQUE-------------
         */


        /**
         * CHEQUE PAGAMENTO
         * Sugestão de cheque para pagamento
         * @param account_id
         */
        scope.accountSugestion = function (account_id) {
          BillReceiptService.getLastAccountAndCheck({account_id: account_id})
            .then(function (response) {
              if (!angular.equals({}, response)) {
                if (account_id) {
                  scope.check.document = parseInt(response.document) + 1;
                } else {
                  scope.check.current_account_id = response.current_account_id;
                  scope.check.document = parseInt(response.document) + 1;
                }
              }
            })
            .catch(function () {
              scope.toastWarn('Problemas na verificação do cheque');
            });
        };

        /**
         * CHEQUE RECEBIMENTO
         * Verifica e sugestiona composição de cheque pelo bano
         * @param bank
         */
        scope.verifyCheckByBank = function (bank) {

          var checkUsed = false;

          angular.forEach(scope.paymentslist, function (item) {
            if (item.bank === bank) {
              scope.check.branch = item.branch;
              scope.check.account = item.account;
              scope.check.number = parseInt(item.number) + 1;
              checkUsed = true;
            }
          });

          if (!checkUsed) {
            scope.checkSugestion(bank.id, null, null);
          }

          return true;
        };


        /* END
         -------------FUNÇÕES PARA SUGESTÃO DE CHEQUE-------------
         */


        /**
         * Verifica e sugestiona composição de cheque
         * @param bank
         */
        scope.verifyCheckByBank = function (bank) {
          var checkUsed = false;

          angular.forEach(scope.paymentslist, function (item) {
            if (item.bank === bank) {
              scope.check.branch = item.branch;
              scope.check.account = item.account;
              scope.check.number = parseInt(item.number) + 1;
              checkUsed = true;
            }
          });

          if (!checkUsed) {
            scope.checkSugestion(bank.id, null);
          }
        };

        /**
         * Limpa valore ao alterar o numero da agencia
         */
        scope.clearAccountAndCheck = function () {
          scope.check.account = null;
          scope.check.number = null;
        };

        /**
         * Validação de dados após usuário apertar no botão de OK
         * para adicionar na lista de pagamentos
         * @param obj
         * @returns {boolean}
         */
        scope.postValidation = function (obj) {
          if (obj.amount <= 0) {
            scope.toastWarn('O valor deve ser maior que zero');
            return false;
          }
          return true;
        };

        /**
         * Pegar último cheque e conta utilizados para
         * dar sugestão para o usuário
         * @returns {{}}
         */
        scope.getLastCheckForSupplier = function () {

          var documentAndAccount = {};
          angular.forEach(scope.paymentslist, function (item) {
            if (item.movement_type_id === PAYMENT_TYPES.TYPE_CHECK) {
              documentAndAccount.document = item.document;
              documentAndAccount.current_account_id = item.current_account_id;
            }
          });

          if (angular.equals({}, documentAndAccount)) {
            scope.accountSugestion();
          }

          return documentAndAccount;
        };


        /**
         * Adiciona cheques recebidos na lista de formas de pagamento- retorno da modal
         * Caso no número do cheque seja passado o código de quantidade de cheques.... (continuar)
         * @param obj
         */
        scope.addPaymentList = function (obj) {

          // INSERE CHEQUES NA LISTA DE FORMAS DE PAGAMENTO
          if (obj.movement_type_id !== null && (obj.movement_type_id === PAYMENT_TYPES.TYPE_CHECK
            || obj.movement_type_id === PAYMENT_TYPES.TYPE_CHECK_THIRD_PARTY)) {

            var newCheck = [];
            var newNumber;
            var newDate;

            // Este código foi criado por David e Guilherme para resolver um problema que a lista de cheques
            // estava acumulando informações inúteis recursivamente. Devido ao tempo limitado,
            // foi mais simples eliminar as informações a mais do que identificar a raiz do problema
            newCheck.push( angular.copy(obj) );
            newCheck[0].banks = null;
            newCheck[0].currentAccountList = null;
            newCheck[0].payments_list = null;
            newCheck[0].debit_credit = 'C';

            // Verifica se foi passado o comando de múltiplos cheques, caso contrário, determina a quantidade como 1
            var checkQty = 1;
            try {
              checkQty = newCheck[0].number.split('#')[1];
              newCheck[0].number = newCheck[0].number.split('#')[0];
            }
            catch (e) {
              checkQty = 1;
            }

            var newamount = 0;
            checkQty = parseInt(checkQty);
            if (checkQty > 1 && checkQty <= 32) {
              newamount = (((newCheck[0].amount * 100) / checkQty) | 0) / 100;
              newCheck[0].amount = newCheck[0].amount - (newamount * (checkQty-1));
            } else {
              checkQty = 1;
            }

            // Faz o loop incluindo.... (continuar)
            for (var bloblo = 0; bloblo <= (checkQty - 1); bloblo++) {

              // A partir do segundo cheque incrementa o número do cheque e o mês da data

              if (bloblo > 0) {
                //newCheck = angular.copy(newCheck);
                newCheck.push(angular.copy(newCheck[0]));

                newNumber = parseInt(newCheck[bloblo-1].number);
                newNumber++;
                newCheck[bloblo].number = String(newNumber);
                newDate = new Date(newCheck[0].date);

                newDate.setMonth(newDate.getMonth() + bloblo);
                newCheck[bloblo].date = String(newDate);
                newCheck[bloblo].amount = newamount;
              }

              // if (scope.postValidation( angular.copy(newCheck[bloblo]) )) {
              //   var show_message = false;
              //   scope.verifyDuplicateCheck( angular.copy(newCheck[bloblo]) , show_message)
              //     .then(function (checkUsed) {
              //         if (!checkUsed) {




                        scope.paymentslist.push( angular.copy(newCheck[bloblo]) );
                        if (A4PaymentService.dateComparasion( newCheck[bloblo].date)) {
                          newCheck[bloblo].idx = scope.paymentslist.length - 1;

                          if (parseInt( newCheck[bloblo].interest_decision) === parseInt(PAYMENT_TYPES.ADD_INTEREST_ON_CHECK)) {
                            billInterest.first_value = billInterest.amount - billInterest.interest_value;
                            scope.insertBillInList( newCheck[bloblo] );
                            scope.amount = ctrl.calcAmountCards(scope.billsselected);
                          } else if (parseInt( newCheck[bloblo].interest_decision) === parseInt(PAYMENT_TYPES.DEBIT_INTEREST_ON_CHECK)) {
                            scope.insertBillInList( newCheck[bloblo] );
                          }
                        }

                        PaymentControl.addPaymentWay( angular.copy(newCheck[bloblo]) );
                        scope.closeModal();




              //         } else {
              //           Common.Toast.warning('Este cheque já foi recebido');
              //         }
              //       }
              //     );
              // }

            }

          // INSERE OS OUTROS TIPOS DE FORMA DE PAGAMENTO QUE NÃO SÃO CHEQUES
          } else if (obj.movement_type_id !== null) {

            scope.paymentslist.push(obj);
            PaymentControl.addPaymentWay(obj);
            scope.closeModal();
          }
        };

        /**
         * Adiciona titulo de juros a lista de titulos
         * @param billInterest
         * @returns {{amount: *, interest_decision: number, current_account_id: *, status_name: string, due_date: *, description: string, bill_category_id: *, status_id: number, index: *, person_id: *, person_name: *}}
         */
        scope.insertBillInList = function (billInterest) {
          if (!isNaN(billInterest.interest_value) && billInterest.interest_value > 0) {

            var nBill = {
              amount: billInterest.interest_value,
              interest_decision: billInterest.interest_decision,
              current_account_id: billInterest.current_account_id,
              status_name: "A_VENCER",
              due_date: billInterest.date,
              description: 'Juros',
              bill_category_id: scope.bill_category_id,
              status_id: -9999, //Juros,
              index: billInterest.idx,
              person_id: scope.billsselected[0].person_id,
              person_name: scope.billsselected[0].person_name
              // atributo index -> Referência a tupla da forma de pagamento a qual este juros esta ligado;
            };
            LocalStorage.add("Juros_" + billInterest.guid, nBill);
            PaymentControl.addItem(nBill);
            scope.billsselected.push(nBill);
            return nBill;
          }
        };

        /**
         * Edição de pagamentos adicionados
         * @param billInterest
         */
        var editBillInterest = function (billInterest) {

          var billJuros = PaymentControl.getItemByGuid(billInterest.guid);
          var billJurosFirstMoment = billJuros;
          var paymentLocal = LocalStorage.get('payment_' + billInterest.guid);

          if (angular.isUndefined(billJuros) || billJuros === null) {
            billJuros = scope.insertBillInList(billInterest);
          }

          if (!angular.isUndefined(billJuros)) {
            var index = scope.returnIndexOfFromArray(billJuros.index);
          }

          switch (parseInt(billInterest.interest_decision)) {
            case parseInt(PAYMENT_TYPES.ADD_INTEREST_ON_CHECK):

              if (parseInt(billInterest.old.interest_decision) !== parseInt(billInterest.interest_decision)) {
                if (parseInt(billInterest.old.interest_decision) === 0) {
                  var juros = $filter('filter')(scope.billsselected, {description: 'Juros'})[0];
                  if (angular.isUndefined(juros)) {
                    billJuros = scope.insertBillInList(billInterest);
                  }
                }
                billJuros.amount = parseFloat(billInterest.interest_value);
                scope.billsselected[index] = billJuros;
                scope.amount = ctrl.calcAmountCards(scope.billsselected);

              } else {
                if (parseFloat(billInterest.old.amount) !== parseFloat(billInterest.amount)
                  && (billJurosFirstMoment === null || billJurosFirstMoment === undefined)) {

                  billJuros.amount = parseFloat(billInterest.interest_value);
                  scope.billsselected[index] = billJuros;
                  scope.amount = ctrl.calcAmountCards(scope.billsselected);

                } else {
                  billJuros.amount = parseFloat(billInterest.interest_value);
                  scope.billsselected[index] = billJuros;
                  scope.amount = ctrl.calcAmountCards(scope.billsselected);
                }

              }
              break;
            case parseInt(PAYMENT_TYPES.DEBIT_INTEREST_ON_CHECK):
              if (parseInt(billInterest.old.interest_decision) !== parseInt(billInterest.interest_decision)) {

                if (parseInt(billInterest.old.interest_decision) !== 0) {

                  if (typeof billJuros.index === 'undefined') {
                    billJuros = scope.insertBillInList(billInterest);
                  } else {
                    billInterest.amount = paymentLocal.amount;
                    billJuros.amount = parseFloat(billInterest.interest_value);
                    scope.billsselected[index] = billJuros;
                    LocalStorage.add('Juros_' + billInterest.guid, billJuros);
                  }
                } else {
                  billJuros.amount = billInterest.interest_value;
                  scope.billsselected[index] = billJuros;
                  var bill_juros = $filter('filter')(scope.billsselected, {description: 'Juros'})[0];
                  if (bill_juros === undefined) {
                    billJuros = scope.insertBillInList(billInterest);
                  }
                  LocalStorage.add('Juros_' + billInterest.guid, billJuros);
                }
              }

              scope.amount = ctrl.calcAmountCards(scope.billsselected);
              break;
            case 0:
              if (angular.isDefined(index) && index !== -1) {
                scope.billsselected.splice(index, 1);
                scope.amount = ctrl.calcAmountCards(scope.billsselected);
              }
              break;
          }
        };

        /**
         *
         * @param index
         * @returns {number}
         */
        scope.returnIndexOfFromArray = function (index) {
          for (var i = 0, len = scope.billsselected.length; i < len; i++) {
            if (scope.billsselected[i].index === index) {
              return i;
            }
          }
          return 1;
        };


        scope.hasBillJuros = function (index) {
          var juros = $filter('filter')(scope.billsselected, {index: index, status_id: -9999})[0];
          if (angular.isUndefined(juros) || angular.isUndefined(juros.index)) {
            return false;
          }
          return true;
        };

        /**
         * Atualiza o objeto no array de pagamentos
         * @param obj
         */
        scope.updatePaymentList = function (obj) {
          if ((obj.movement_type_id === 2 || obj.movement_type_id === 5) && scope.debitcredit.toLowerCase() === 'c') {
            if (obj.interest_decision !== 0) {
              scope.amount = obj.amount;
            }
          }

          if (obj.movement_type_id != null) {
            scope.paymentslist[obj.idx] = obj;
          }
          if (A4PaymentService.dateComparasion(obj.date)) {
            editBillInterest(obj);
          }

          scope.closeModal();
        };

        /**
         * Fecha o modal
         */
        scope.closeModal = function () {
          scope.obj = null;
          $rootScope.$broadcast('CUSTOM.close');
          scope.isOpen = false;
          scope.barcode = '';
          scope.checkObject = {};
          scope.check = {};
          scope.check.readed = false;
        };

        /**
         * Retorna a soma total dos pagamentos
         * @returns object
         */
        scope.getTotal = function () {
          var result = 0;
          var tax = 0;
          for (var i = 0; i < scope.paymentslist.length; i++) {
            if (angular.isDefined(scope.paymentslist[i].paymentTax) && scope.paymentslist[i].paymentTax > 0) {
              // scope.paymentslist[i].amount = parseFloat(scope.paymentslist[i].amount) + parseFloat(scope.paymentslist[i].paymentTax);
              tax = parseFloat(parseFloat(tax + scope.paymentslist[i].paymentTax).toFixed(2));
            }
            result = parseFloat(result) + parseFloat(scope.paymentslist[i].amount);
          }

          scope.diff = parseFloat(parseFloat((parseFloat(result) + tax) - parseFloat(scope.amount)).toFixed(2));
          scope.difference = scope.diff;
          result = parseFloat(result);
          scope.amount = parseFloat(scope.amount).toFixed(2);
          var result_tax = parseFloat(parseFloat(parseFloat(result) + tax).toFixed(2));
          if (result_tax < parseFloat(scope.amount)) {
            scope.haslessdifference = true;
            scope.hasmoredifference = false;
          } else if (result_tax > parseFloat(scope.amount)) {
            scope.haslessdifference = false;
            scope.hasmoredifference = true;
          } else if (parseFloat(scope.diff) === 0) {
            scope.haslessdifference = false;
            scope.hasmoredifference = false;
          }
          if (tax > 0) {
            result += tax;
            $rootScope.$broadcast('PAYMENT_TAX.change', {tax: tax});
          }
          return result;
        };

        /**
         * Concatena a string de detalhes para mostrar no grid
         * @param item
         * @returns {string}
         */
        scope.detailByMovement = function (item) {
          return Utils.detailByMovement(item, scope.debitcredit);
        };

        scope.calcAmountItem = function (item) {
          return (angular.isDefined(item.paymentTax) && item.paymentTax > 0) ? (item.paymentTax + item.amount) : item.amount;
        }

        /**
         * Retorna o nome do currrentAccount pelo seu id
         * @param id
         * @returns {string}
         */
        scope.getCurrentAccountNameById = function (id) {
          if (angular.isDefined(id)) {
            var result = $filter('filter')(scope.currentaccountlist, {id: id})[0];
            return result != null ? result.name : '';
          }
          return '';
        };

        /**
         * Retorna o nome do tipo de movimento pelo seu id
         * @param id
         * @returns {string}
         */
        scope.getMovimentTypeNameById = function (id) {
          if (id === 10020) {
            return 'Taxa de pagamento';
          }
          var result = scope.movementtypes.find(function (item) {
            return item.id === id;
          });
          return result != null ? result.name : '';
        };

        /**
         * Retorna o nome do tipo de movimento pelo seu id
         * @param is_third_party_check
         * @returns {string}
         */
        scope.getMovimentTypeCreditById = function (is_third_party_check) {
          if (is_third_party_check) {
            return "Cheque de terceiros";
          } else {
            return "Cheque";
          }
        };

        /**
         * Aplica mascara financeira no padrão (R$ 0,00)
         * @param value
         * @returns {string}
         */
        scope.applyMask = function (value) {
          var currency = 0;
          if (value === 0 || value == null) {
            currency = $filter('currency')(0, 'R$ ', 2);
            return currency.replace(".", ",").replace(",", ".");
          } else if (value > 0) {
            currency = $filter('currency')(value, 'R$ ', 2);
            return currency.replace(".", ",").replace(",", ".");
          }
        };

        /**
         * Edita o item da lista de pagamentos
         * @param item - item clicado
         * @param idx - identificador do item na lista.
         */
        scope.editItem = function (item, idx) {
          scope.obj = item;
          scope.obj.idx = idx;
          if (item.movement_type_id === 20) {
            ModalFactory.custom("app/finance/bill-payment/modals/DebitCardPayment.html", scope);
          } else if (item.movement_type_id === 21) {
            if (scope.debitcredit.toLowerCase() === 'c') {
              ModalFactory.custom("app/finance/bill-payment/modals/CreditCardReceiving.html", scope);
            } else {
              ModalFactory.custom("app/finance/bill-payment/modals/CreditCardPayment.html", scope);
            }
          } else if (item.movement_type_id >= 10 && item.movement_type_id <= 15) {
            scope.bank = item;
            ModalFactory.custom("app/finance/bill-payment/modals/BankPayment.html", scope);
          } else if ((item.movement_type_id === 2 || item.movement_type_id === 5) && item.debit_credit.toLowerCase() === 'd') {
            scope.check = angular.copy(item);
            ModalFactory.custom("app/finance/bill-payment/modals/CheckPayment.html", scope);
          } else if (item.movement_type_id === 1) {
            scope.money = item;
            ModalFactory.custom("app/finance/bill-payment/modals/MoneyPayment.html", scope);
          } else if (item.movement_type_id === 10020) {
            scope.obj = item;
            ModalFactory.custom("app/finance/bill-payment/modals/PaymentTax.html", scope);
          } else if ((item.movement_type_id === 2 || item.movement_type_id === 5) && item.debit_credit.toLowerCase() === 'c') {
            var checkr = angular.copy(item);
            if (typeof checkr.old == 'undefined'
              || parseInt(checkr.old.interest_decision) !== parseInt(checkr.interest_decision)) {
              checkr.old = angular.copy(item);
            }
            scope.check = checkr;
            if (typeof checkr.date == 'string') {
              scope.check.date = a4Moment(checkr.date);
            }
            scope.check.idx = idx;
            ModalFactory.customClean("app/finance/bill-payment/modals/CheckReceiving.html", "A4PaymentsCheckReceivedController", 'vm', false, scope.check);
          }
        };

        /**
         * Remove item do lista de pagamentos
         * @param item
         * @param id
         */
        scope.removeItem = function (item, id) {

          if (typeof item.idx != 'undefined' && scope.hasBillJuros(item.idx)) {
            var billJuros = LocalStorage.get('Juros_' + item.guid);
            var index = scope.returnIndexOfFromArray(billJuros.index);
            scope.billsselected.splice(index, 1);
            if (scope.paymentslist.indexOf(item) !== -1) {
              scope.paymentslist.splice(id, 1);
            }
            scope.amount = ctrl.calcAmountCards(item);
            LocalStorage.remove('payment_' + item.guid);
            LocalStorage.remove('Juros_' + item.guid);

          } else {
            if (scope.paymentslist.indexOf(item) !== -1) {
              scope.paymentslist.splice(id, 1);
            }
          }

        };

        /**
         * Função para reaproveiar o toast
         * @param {String} msg
         * @returns {undefined}]
         */
        scope.toastWarn = function (msg) {
          Toast.warning(msg);
        };

        scope.waitCheck = function () {
          var include = {};
          include.readCheckNumber = scope.readCheckNumber;
          include.setFocusOnCheckField = scope.setFocusOnCheckField;
          ModalFactory.custom("app/finance/bill-payment/modals/waitread.html", include);
          $rootScope.$on('CUSTOM.opened', function () {
            var elem = angular.element('[name=barcodeField]');
            elem.focus();
          });

        };

        /**
         * Espera leitura do codigo do cheque.
         * @param barcode - String com o numero do cheque.
         */
        scope.readCheckNumber = function (barcode) {
          var obj = {
            checkInterest: scope.checkinterest,
            currentAccountList: scope.currentaccountlist,
            paymentslist: scope.paymentslist,
            amount: scope.amount,
            debitcredit: scope.debitcredit,
            banks: scope.banks,
            date: scope.date
          };

          if (typeof barcode === 'string' && barcode.length === 30) {
            var check = scope.prepareObjectCheck(barcode);
            check.debit_credit = scope.debitcredit.toLowerCase();
            BillReceiptService.verifyCheckNumber(check)
              .then(function (response) {
                if (typeof response !== 'string') {
                  if (response.message === 'RECEIVABLE_CHECK') {
                    check.bank = response.bank;
                    scope.closeModal();
                    ctrl.callModalReceiveCheck(PAYMENT_TYPES.BANK, check, '', true, obj);
                    return;
                  }
                  Toast.warning('Cheque '
                    + getStatusOfCheque(response['status'])
                    + '. Não vai ser possível utilizar este cheque para pagamento.');
                } else {
                  switch (response) {
                    case 'IS_OWN_CURRENT_ACCOUNT_AND_HAVENT_USED'
                    || 'THIRD_PERSON_PENDING_ACCOUNT_BOX':
                      scope.closeModal();
                      if (scope.debitcredit.toLowerCase() === 'd') {
                        scope.callModalPayCheck(PAYMENT_TYPES.BANK, check.number);
                      } else {
                        ctrl.callModalReceiveCheck(PAYMENT_TYPES.BANK, check, '', true, obj);
                      }
                      break;
                    case 'UNKWOWN_CHECK':
                      Toast.warning('Este cheque é desconhecido você não pode fazer um pagameno com ele.');
                      break;
                    default:
                      scope.closeModal();
                      if (scope.debitcredit.toLowerCase() === 'd') {
                        scope.callModalPayCheck(PAYMENT_TYPES.BANK, check.number);
                      } else {
                        ctrl.callModalReceiveCheck(PAYMENT_TYPES.BANK, check, '', true, obj);
                      }
                  }
                }
              })
              .catch(function (response) {
                switch (response) {
                  case 'IS_OWN_CURRENT_ACCOUNT':
                    scope.toastWarn('IS_OWN_CURRENT_ACCOUNT');
                    break;
                  case 'IS_ONE_CHECK_THIRD_PERSON_REGISTRADO':
                    scope.toastWarn('IS_ONE_CHECK_THIRD_PERSON_REGISTRADO');
                    break;
                  case 'IS_OWN_CURRENT_ACCOUNT_AND_HAS_ALREADY_BEEN_USED':
                    scope.toastWarn('IS_OWN_CURRENT_ACCOUNT_AND_HAS_ALREADY_BEEN_USED');
                    break;
                }

              });
          }
        };

        var getStatusOfCheque = function (status_id) {
          var status_names = [
            {id: 0, name: 'Em mãos'},
            {id: 1, name: 'Em custódia'},
            {id: 2, name: 'Depositado'},
            {id: 5, name: 'Devolvido'},
            {id: 6, name: 'Reapresentado'},
            {id: 10, name: 'Sacado'},
            {id: 11, name: 'Compensado'},
            {id: 12, name: 'Resgatado'},
            {id: 13, name: 'Descontado'},
            {id: 14, name: 'Utilizado para pagamento'},
            {id: 90, name: 'Extraviado'}
          ];
          return $filter('filter')(status_names, {id: status_id})[0].name;
        };

        /**
         * Mantém o foco no campo da leitura do numero do check até que o model seja fechado.
         * @author Israel Brito <israel.brito@simetrianet.com.br>
         */
        scope.setFocusOnCheckField = function () {
          var elem = angular.element('[name=barcodeField]');
          elem.focus();
        };

        /**
         * Monta o objeto com os dados do cheque.
         * @param barcode - Codigo do cheque.
         */
        scope.prepareObjectCheck = function (barcode) {
          scope.checkObject = {
            bank_code: barcode.substring(0, 3),
            branch: barcode.substring(3, 7),
            compensation: barcode.substring(8, 11),
            number: barcode.substring(11, 17),
            check_type: barcode[17],
            account: barcode.substring(23, 30)
          };
          return scope.checkObject;
        };


        scope.initPayment();

      }
    };
  }

  angular
    .module('app.a4-payments-grid')
    .directive("a4PaymentsGrid", a4PaymentsGrid);
})();

(function () {
  'use strict';

  /** @ngInject */
  function A4PaymentsController($filter, $scope, A4PaymentService, LocalStorage, ModalFactory, CURRENT_ACCOUNT_TYPES, Toast, PoliciesService,
                                $rootScope, a4Moment) {
    var vm = this;

    vm.check = {};
    vm.option_difference = null;

    /**
     * Retorna o valor total de todos os titulos + juros + multa + disconto
     */
    vm.calcAmountCards = function (billsSelected) {
      var totalAmount = 0;
      for (var i = 0; i < billsSelected.length; i++) {
        var amount = vm.addAccrualsDiscounts(i, billsSelected[i].amount);
        totalAmount = parseFloat(totalAmount) + parseFloat(amount);
      }
      return totalAmount;
    };

    /**
     * Retorna valor total do titulo (apenas para o html)
     * @param id
     * @param amount
     * @returns {string}
     */
    vm.addAccrualsDiscounts = function (id, amount) {
      var result = amount;
      if (id !== null && amount !== null) {
        if (angular.isDefined(vm.directive.accrualsDiscounts) && vm.directive.accrualsDiscounts[id] !== null) {
          var interest = vm.directive.accrualsDiscounts[id].interest;
          var fine = vm.directive.accrualsDiscounts[id].fine;
          var discount = vm.directive.accrualsDiscounts[id].discount;
          var accruals = (interest + fine) - discount;
          accruals = vm.applyAllowenceIfExist(vm.directive.accrualsDiscounts[id], accruals);
          result = isNaN(accruals) ? result : parseFloat(result) + accruals;
        }
      }
      return parseFloat(result).toFixed(2);
    };

    vm.applyAllowenceIfExist = function (data, amount) {
      if (data.allowence !== null) {
        var allowence = parseFloat(data.allowence);
        if (!isNaN(allowence)) {
          amount = amount - parseFloat(data.allowence);
        }
      }
      return amount;
    };

    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * MODAL para recebimento de cheque
     * @param type_bank - integer
     * @param check - object
     * @param is_own - boolean
     * @param is_readed boolean - Cheque lido pela opção Ler cheque;
     * @param extra object - Objeto com dados para uso interno;
     * @returns {*}
     */
    vm.callModalReceiveCheck = function (type_bank, check, is_own, is_readed, extra) {
      vm.check.bankAccounts = A4PaymentService.getAccountByType(CURRENT_ACCOUNT_TYPES.CONTA_CAIXA, extra.currentAccountList);
      if (vm.check.bankAccounts.length > 0) {
        A4PaymentService.getConfig()
          .then(function (resp) {
            var config = resp;
            if (check !== undefined && check !== '') {
              vm.check = {bank: check.bank, bankAccounts: vm.check.bankAccounts};
              vm.check.number = check.number;
              vm.check.account = check.account;
              vm.check.branch = check.branch;
              vm.check.readed = is_readed;

              if (is_own !== undefined && check !== '') {
                vm.check.movement_type_id = 2;
              }
            } else {
              vm.check = {bank: vm.banks[0], hasInterest: false, bankAccounts: vm.check.bankAccounts};
              vm.getlastCheck();
            }

            if (vm.check.bankAccounts.length > 0) {
              vm.check.current_account_id = $filter('filter')(vm.check.bankAccounts, {is_main: true})[0].id;
            }
            var remainingAmount = A4PaymentService.getRemainingAmount(extra.amount, extra.paymentslist);
            // vm.check.paymentslist = $scope.paymentslist;
            vm.check.interest_value = A4PaymentService.calcInterest(remainingAmount).interest_value;
            vm.check.date = a4Moment(); //check.date
            vm.check.payment_date = extra.date;
            vm.check.movement_type_id = 2;
            vm.check.is_third_party_check = false;
            vm.check.amount = remainingAmount;
            vm.check.interest_decision = 0;
            vm.check.banks = extra.banks;
            vm.check.payments_list = angular.copy($scope.paymentslist);
            vm.check.bill_category_id = config.bill_category_id;
            vm.check.check_interest_per_month = config.check_interest_per_month;
            vm.check.addPaymentList = vm.directive.addPaymentList;
            vm.check.updatePaymentList = vm.directive.updatePaymentList;
            vm.check.guid = Math.random().toString(36).substring(7);
            vm.check.type = 'ReceiveCheck';
            LocalStorage.add('payment_' + vm.check.guid, vm.check);
            ModalFactory.customClean("app/finance/bill-payment/modals/CheckReceiving.html", "A4PaymentsCheckReceivedController", 'vm', false, vm.check);
          });
      } else {
        Toast.warning('Não há conta do tipo caixa disponivel')
      }
    };

    /** CHEQUE
     * Abre a modal de pagamento em cheque
     * @param type_bank - Tipo da conta corrente.
     * @param check
     * @param is_own (opcional) - Número do cheque
     * Seta valores iniciais
     * @param is_readed
     * @param extra
     */
    vm.callModalPayCheck = function (type_bank, check, is_own, is_readed, extra) {


      if (check !== undefined && check !== '') {
        vm.check = {bank: check.bank};
        vm.check.number = check.number;
        vm.check.account = check.account;
        vm.check.branch = check.branch;
        vm.check.readed = is_readed;
        vm.check.addPaymentList = vm.directive.addPaymentList;
        vm.check.updatePaymentList = vm.directive.updatePaymentList;

        if (is_own !== undefined && check !== '') {
          vm.check.movement_type_id = 2;
        }
      } else {
        vm.check = {bank: vm.banks[0], hasInterest: false};
        vm.getlastCheck();
      }

      vm.check.bankAccounts = A4PaymentService.getAccountByType(CURRENT_ACCOUNT_TYPES.CONTA_BANCO, extra.currentAccountList);

      if (vm.check.bankAccounts.length > 0) {
        vm.check.current_account_id = vm.check.bankAccounts[0].id;
      }

      var remainingAmount = A4PaymentService.getRemainingAmount(extra.amount, extra.paymentslist);
      vm.check.is_third_party_check = false;
      vm.check.date = new Date();
      vm.check.amount = remainingAmount;
      vm.check.banks = extra.banks;
      vm.check.type = 'PayCheck';

      ModalFactory.customClean("app/finance/bill-payment/modals/CheckPayment.html", "A4PaymentsCheckReceivedController", 'vm', false, vm.check);
    };

    vm.updateAmounts = function () {
      $rootScope.$broadcast('PAYMENT_DIFFERENCE.change', {option: vm.option_difference, difference: $scope.diff, debitcredit: $scope.debitcredit});
      vm.option_difference = null;
    };

  }

  angular
    .module('app.a4-payments-grid')
    .controller('A4PaymentsController', A4PaymentsController)
})();
/* global malarkey:false, a4Moment:false */
(function () {
  'use strict';

  var PAYMENT_CONSTANTS = {
    MONEY: 1,
    BANK: 2,
    CHECK: 3,
    CARD_DEBIT: 4,
    CARD_CREDIT: 5,
    CARD_CREDIT_RECEIVING: 6,
    CARD_DEBIT_RECEIVING: 7,
    ADD_INTEREST_ON_CHECK: 1,
    CHECK_INTEREST_WAIVED: 0,
    DEBIT_INTEREST_ON_CHECK: 2,
    TYPE_CHECK: 2,
    TYPE_CHECK_THIRD_PARTY: 5,
    CREDIT: 8,
    TAX: 9
  };

  angular
    .module('app.a4-payments-grid')
    .constant('PAYMENT_TYPES', PAYMENT_CONSTANTS);

})();

(function () {
  'use strict';

  function A4PaymentsCheckReceivedController($scope, $rootScope, $mdDialog, PoliciesService,
                                             A4PaymentService, BillReceiptService, PAYMENT_TYPES,
                                             ModalExtra, LocalStorage, a4Moment) {
    var vm = this;
    vm.load_check = false;

    vm.init = function () {
      vm.check = ModalExtra;
      vm.getlastCheck();
    };

    vm.answer = function (answer) {
      $mdDialog.hide(answer);
    };

    vm.closeModal = function () {
      $mdDialog.cancel();
    };

    var ltn = $rootScope.$on('CUSTOM.close', function () {
      vm.closeModal();
    });

    /**
     * CHEQUE RECEBIMENTO
     * Sugestiona cheque logo ao iniciar a modal de cheque
     * @returns {{}}
     */
    vm.getlastCheck = function () {
      var check = {};
      var found = false;
      angular.forEach(vm.check.payments_list, function (item) {
        if (item.movement_type_id === PAYMENT_TYPES.TYPE_CHECK) {
          check = item;
          found = true;
        }
      });

      if (found) {
        vm.check.current_account = check.current_account;
        vm.check.current_account_id = check.current_account_id;
        vm.check.bank = check.bank;
        vm.check.branch = check.branch;
        vm.check.number = parseInt(check.number) + 1;
        vm.check.account = check.account;
      }
    };

    /**
     * CHEQUE RECEBIMENTO
     * Requisição ao banco para verificar se há algum cheque utilizado
     * @param bank_id
     * @param branch
     * @param account
     */
    vm.checkSugestion = function (bank_id, branch, account) {
      BillReceiptService.getLastCheckUsedForBankBranch({bank_id: bank_id, branch: branch, account: account})
        .then(function (response) {
          if (!bank_id) {
            vm.check.bank = {};
            vm.check.bank.id = angular.isDefined(response.bank_id) ? response.bank_id : null;
            vm.check.bank.name = angular.isDefined(response.name) ? response.name : null;
            vm.check.bank.number_bank = angular.isDefined(response.number_bank) ? response.number_bank : null;
          }
          vm.check.branch = angular.isDefined(response.branch) && response.branch != null ? response.branch : branch;
          vm.check.account = angular.isDefined(response.account) && response.account != null ? response.account : account;
          vm.check.number = angular.isDefined(response.number) && response.number != null ? parseInt(response.number) + 1 : null;
          vm.load_check = false;
        })
        .catch(function () {
          vm.toastWarn('Problemas na verificação do cheque');
        });
    };

    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Limpa valore ao alterar o numero da agencia
     */
    vm.clearAccountAndCheck = function () {
      vm.check.account = null;
      vm.check.number = null;
    };


    vm.modifyType = function (is_third_party_check) {
      if (is_third_party_check) {
        vm.check.movement_type_id = 5;
      } else {
        vm.check.movement_type_id = 2;
      }
    };


    /**
     * CHEQUE RECEBIMENTO
     * Verifica e sugestiona composição de cheque por conta
     * @param branch
     * @param bank
     * @param account
     */
    vm.checkByAccount = function (branch, bank, account) {
      vm.load_check = true;
      if (account && bank && branch) {
        var checkUsed = false;
        angular.forEach(vm.check.payments_list, function (item) {
          if (item.branch === branch
            && item.bank.id === bank.id
            && item.account === account) {
            vm.check.number = parseInt(item.number) + 1;
            checkUsed = true;
            vm.load_check = false;
          }
        });

        if (!checkUsed) {
          if (vm.check.bank) {
            vm.checkSugestion(vm.check.bank.id, branch, account);
          }
        }
      }
    };


    vm.querySearch = function (query, list) {
      return query ? list.filter(vm.createFilterFor(query)) : list;
    };

    /**
     * CHEQUE RECEBIMENTO
     * Verifica e sugestiona composição de cheque por agência
     * @param branch
     * @param bank
     */
    vm.checkByBranch = function (branch, bank) {


      if (branch && bank) {
        var checkUsed = false;
        angular.forEach(vm.check.paymentslist, function (item) {
          if (item.branch === branch
            && item.bank.id === bank.id) {
            vm.check.account = item.account;
            vm.check.number = parseInt(item.number) + 1;
            checkUsed = true;
          }
        });

        if (!checkUsed) {
          vm.checkSugestion(scope.check.bank.id, branch, null);
        }
      }

    };


    $scope.$watchGroup(['vm.check.interest_decision', 'vm.check.date'], function (nVal) {
      if (typeof vm.check !== 'undefined') {
        vm.check.date = nVal[1];
        var billJuros = LocalStorage.get('payment_' + vm.check.guid);
        vm.calcInterestTaxByDate(vm.check.date, billJuros.amount);
      }
    });

    /**
     * Calcula o juros com base na data;
     * @param date - data do pagamento ou recebimento
     * @param amount - valor do montante para calculo do juros.
     */
    vm.calcInterestTaxByDate = function (date, amount) {
      var calcInterest = 0;
      vm.check.checkinterest = 0;
      var paymentDate = a4Moment(vm.check.payment_date);
      var checkDate = a4Moment(date);

      var qtdDays = checkDate.diff(paymentDate, 'days', true);
      if (qtdDays > 0) {
        if (qtdDays > 0 && qtdDays < 1) {
          qtdDays = 1;
        }
        if (vm.check.check_interest_per_month !== null) {
          calcInterest = vm.calculatedPercentInterest(vm.check.check_interest_per_month, qtdDays);
          vm.check.interest_value = parseFloat(calcInterest.toFixed(2));
          switch (parseInt(vm.check.interest_decision)) {
            case PAYMENT_TYPES.ADD_INTEREST_ON_CHECK:
              vm.check.amount = vm.check.first_value === null ? parseFloat(amount) : parseFloat(vm.check.first_value);
              var resp = A4PaymentService.calcInterest(vm.check.amount, vm.check, calcInterest, vm.check.interest_value);
              vm.check.amount = resp.amount + resp.interest_value;
              vm.check.interest_value = resp.interest_value;
              break;
            case PAYMENT_TYPES.DEBIT_INTEREST_ON_CHECK:
              vm.check.amount = vm.check.first_value === null ? parseFloat(amount) : parseFloat(vm.check.first_value);
              vm.check.interest_value = vm.calcInterestDebitOnCheck(vm.check.amount, vm.check.interest_value);
              break;
            case PAYMENT_TYPES.CHECK_INTEREST_WAIVED:
              vm.check.amount = angular.isUndefined(vm.check.first_value) || vm.check.first_value === null ? vm.check.amount : vm.check.first_value;
              break;
          }
          vm.check.bill_category_id = vm.bill_category_id;
        }
      } else {
        vm.check.checkinterest = null;
      }
    };

    /**
     * Calcula a porcentagem do juros para ser aplicada no cheque opção A
     * @param check_interest_per_month - Juros por mês
     * @param qtyDays - quantidade de dias;
     * @returns {number}
     */
    vm.calculatedPercentInterest = function (check_interest_per_month, qtyDays) {
      return ((parseFloat(check_interest_per_month) * 100) / 30) * parseInt(qtyDays);
    };


    /**
     * Calcula a porcentagem do juros para ser aplicada no cheque opção B
     * @param amount - Valor
     * @param calculatedPercentInterest - Juros para aplicação, calculada na função calculatedPercentInterest();
     * @returns {number}
     */
    vm.calcInterestDebitOnCheck = function (amount, calculatedPercentInterest) {
      return (parseFloat(amount) - (parseFloat(amount) / (1 + (parseFloat(calculatedPercentInterest) / 100))));
    };


    /**
     * Create filter function for a query string
     */
    vm.createFilterFor = function (query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        var lower = angular.lowercase(item.name);
        return (item.number_bank.indexOf(lowercaseQuery) !== -1) || (lower.indexOf(lowercaseQuery) !== -1);
      };
    };

    vm.init();

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });
  }

  angular.module('app.a4-payments-grid')
    .controller('A4PaymentsCheckReceivedController', A4PaymentsCheckReceivedController)
})();
/* global malarkey:false, a4Moment:false */
(function () {
  'use strict';

  /** @ngInject */
  function PaymentControl(a4Moment, $filter) {
    var vm = this;
    vm.items = [];
    vm.payment_ways = [];
    vm.payment_date = null;

    /**
     * Retorna os titulos selecionados
     * @return {Array}
     */
    vm.getItemsSelected = function () {
      return vm.items;
    };

    /**
     * Retorna o titulo pelo identificador GUID, caso tenha
     * @param guid
     * @return {*}
     */
    vm.getItemByGuid = function (guid) {
      return $filter('filter')(vm.getItemsSelected(), {guid: guid})[0];
    };

    /**
     * Retorna o item e o seu index pelo id
     * @param id
     * @return {*}
     */
    vm.getItemAndIndexById = function (id) {
      var item = $filter('filter')(vm.getItemsSelected(), {id: id})[0];
      var index = vm.getItemsSelected().indexOf(item);
      return {index: index, item: item};
    };

    /**
     * Retorna os titulos selecionados
     * @return {Array}
     */
    vm.addItem = function (bill) {
      vm.items.push(bill);
    };

    /**
     * Define o conjunto de titulos a serem pagos
     * @param bills - Lista de titulos
     */
    vm.setItemsSelected = function (bills) {
      vm.items = bills;
    };

    /**
     * Atualiza um item da lista de itens selecionados baseado no index
     * @param item
     * @param index
     */
    vm.updateItemOnList = function (item, index) {
      vm.items[index] = item;
    };

    /**
     * Retorna o conjunto de titulos a serem pagos
     */
    vm.getPaymentDate = function () {
      return vm.payment_date;
    };

    /**
     * Define a Data do pagamento/recebimento dos titulos
     * @param payment_date - Data do pagamento/recebimento
     */
    vm.setPaymentDate = function (payment_date) {
      vm.payment_date = a4Moment(payment_date);
    };

    /**
     * Adiciona uma forma de pagamento/recebimento a lista de formas de pagamento/recebimento
     * @param payment_way - Forma de pagamento
     */
    vm.addPaymentWay = function (payment_way) {
      vm.payment_ways.push(payment_way);
    };

    /**
     * Retorna as formas de pagamento
     * @return {Array}
     */
    vm.getPaymentWays = function () {
      return vm.payment_ways;
    };


    /**
     * Calcula todos os bills selecionados
     */
    vm.getTotalAmount = function () {
      var totalAmount = 0;
      angular.forEach(vm.items, function (value) {
        totalAmount += parseFloat(value.final_value);
      });
      /** Se o total calculado for igual ao total ou se for 0, coloca o valor calculado na função, senão mantém o valor anterior */
      // vm.totalAmountCalc = (parseFloat(vm.totalAmountCalc) === parseFloat(vm.totalAmount) || vm.totalAmountCalc === 0) ? totalAmount : vm.totalAmountCalc;
      return totalAmount;
    };

    /**
     * Limpa todos os dados da factory
     */
    vm.clear = function () {
      vm.items = [];
      vm.payment_ways = [];
      vm.payment_date = null;
    };

    return vm;
  }

  angular
    .module('app.a4-payments-grid')
    .factory('PaymentControl', PaymentControl);

})();

(function () {
  'use strict';
  angular.module('app.a4optionsmovement', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4OptionsMovement($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        currentAccount: '=?',
        movementType: '=?'
      },
      controller: 'a4OptionsMovementController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-options-movement/a4-options-movement.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4optionsmovement')
    .directive('a4OptionsMovement', a4OptionsMovement);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4OptionsMovementController($scope, $filter, $rootScope, BankSlipService, BillPaymentService) {
    var vm = this;
    vm.originalMovementTypes = [];

    vm.init = function () {
      vm.getAllCurrentAccount();
      vm.getAllMovementsType();
    };

    /**
     * Retorna todas as contas
     */
    vm.getAllCurrentAccount = function () {
      vm.current_accounts = [];
      BankSlipService.getAllCurrentAccounts()
        .then(function (response) {
          var current_accounts = response.plain();
          vm.all_current_accounts = $filter('filter')(current_accounts, {is_inactive: false});
        });
    };

    vm.filterMovements = function () {
      var current_account = $filter('filter')(vm.all_current_accounts, {id: $scope.currentAccount})[0];
      var movements = [];
      if (current_account.type_name === 'CONTA_CAIXA') {
        movements = vm.originalMovementTypes.filter(function (item) {
          return item.id === 1;
        });

        vm.movementTypes = movements;
        $scope.movementType = 1;
      }
      if (current_account.type_name === 'CONTA_BANCO' ||
          current_account.type_name === 'CONTA_INVESTIMENTO' ||
          current_account.type_name === 'CONTA_CARTAO_DE_CREDITO_RECEBIVEL' ||
          current_account.type_name === 'CONTA_CARTAO_DE_CREDITO_PAGAMENTO' ||
          current_account.type_name === 'CONTA_CARTAO_DE_DEBITO_RECEBIVEL' ||
          current_account.type_name === 'CONTA_CARTAO_DE_DEBITO_PAGAMENTO') {
        movements = vm.originalMovementTypes.filter(function (item) {
          return item.id !== 1;
        });
        vm.movementTypes = movements;
      }
    };

    /**
     * Carrega todos os tipos de movimentos
     */
    vm.getAllMovementsType = function () {
      BillPaymentService
        .getAllMovementsType()
        .then(function (response) {
          if (response.plain() !== null) {
            vm.movementTypes = response;
            vm.movementTypes = vm.movementTypes.filter(function (item) {
              return item.id >= 1 && item.id <= 22;
            });
            vm.originalMovementTypes = angular.copy(vm.movementTypes);
          }
        });
    };

    vm.init();
  }

  angular.module('app.a4optionsmovement')
    .controller('a4OptionsMovementController', a4OptionsMovementController);
})();
(function () {
  'use strict';
  angular.module('app.a4-negotiation-details', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4NegotiationDetails($window) {

    return {
      templateUrl: 'app/components/a4-negotiation-details/a4-negotiation-details.html',
      restrict: 'E',
      controller: 'A4NegotiationDetailsController',
      controllerAs: 'vm',
      scope: {
        negotiationData: '=?'
      },
      link: function (scope, element, attrs, ctrl) {
      }
    }
  }

  angular.module('app.a4-negotiation-details')
    .directive('a4NegotiationDetails', a4NegotiationDetails)

})();
(function () {
  'use strict';

  /** @ngInject */
  function A4NegotiationDetailsController($rootScope, $scope)
  {
    var vm = this;
  }

  angular.module('app.a4-negotiation-details')
    .controller('A4NegotiationDetailsController', A4NegotiationDetailsController);

})();
(function () {
  'use strict';

  angular
    .module('app.a4-negotiation', []);
})();
(function () {
  'use strict';

  function A4NegotiationService(Restangular, $http, Common, CONFIG) {

    return {
      getNegotiations: function (obj) {
        return Restangular.one('contract').one('getnegotiations').get(obj);
      },
      getNegotiationDetails: function (obj) {
        return Restangular.one('contract').one('getnegotiationdetails').get(obj);
      },
      printNegotiationPaymentBook: function (obj) {
        var deffered = Common.$q.defer();
        $http({
          method: 'GET',
          url: CONFIG.webApiUri + 'api/contract/printpaymentbooknegotiation?bill_serie_id='
            + obj.bill_serie_result,
          responseType: 'arraybuffer'
        }).then(function (response) {
          var headers = response.headers();
          var status = response.status;
          var data = response.data;
          var contentType = headers['content-type'];
          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], {type: contentType});
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute('target', '_blank');
            var clickEvent = new MouseEvent("click", {
              "view": window, "bubbles": true, "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
            deffered.resolve(true);
          } catch (ex) {
            deffered.reject(ex);
          }
        }, function (error) {

        });
        return deffered.promise;
      },
      printNegotiationContract: function (obj) {
        var deffered = Common.$q.defer();
        $http({
          method: 'GET',
          url: CONFIG.webApiUri + 'api/reports/printnegotiationcontract?bill_action_id_origin='
            + obj.bill_action_id_origin + '&bill_serie_result=' + obj.bill_serie_result +
            '&person_id=' + obj.person_id + '&current_school_period=' + obj.school_period_id,
          responseType: 'arraybuffer'
        }).then(function (response) {
          var headers = response.headers();
          var status = response.status;
          var data = response.data;
          var contentType = headers['content-type'];
          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], {type: contentType});
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute('target', '_blank');
            var clickEvent = new MouseEvent("click", {
              "view": window, "bubbles": true, "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
            deffered.resolve(true);
          } catch (ex) {
            deffered.reject(ex);
          }
        }).error(function (data) {
          deffered.reject(data);
        });
        return deffered.promise;
      }
    }

  }

  angular
    .module('app.a4-negotiation')
    .factory('A4NegotiationService', A4NegotiationService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4NegotiationDirective() {
    return {
      restrict: 'E',
      scope: {
        personId: '=?',
        search: '='
      },
      controller: 'A4NegotiationController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-negotiation/index.html',
      link: function (scope, elem, attrs, ctrl) {
        if (angular.isUndefined(scope.personId)) {
          scope.personId = null;
        }

        ctrl.personId = scope.personId;
      }
    }
  }

  angular.module('app.a4-negotiation')
    .directive('a4Negotiation', A4NegotiationDirective);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4NegotiationController($document, $scope, $rootScope, $stateParams, a4Moment, StudentsService, BillReceiptService, Common,
                                   EnrolmentService, ModalFactory, A4ContractService, PoliciesService, Session, ReportsService, CONFIG,
                                   A4NegotiationService) {
    var vm = this;

    vm.init = function () {
      $rootScope.show_loader = true;
      vm.person_id = $scope.personId;
      vm.getNegotiations();
    };

    $scope.$watch('search', function (search) {
      vm.getNegotiations();
    });

    $rootScope.$on('UPDATE_NEGOTIATIONS_LIST', function () {
      vm.getNegotiations();
    });

    vm.getNegotiations = function (page, qty) {
      page = angular.isUndefined(page) ? 1 : page;
      qty = angular.isUndefined(qty) ? 20 : qty;
      $rootScope.show_loader = true;
      A4NegotiationService.getNegotiations({person_id: $scope.personId, page: page, qty: qty, search: $scope.search})
        .then(function (resp) {
          $rootScope.show_loader = false;
          vm.negotiations = $scope.personId === null ? resp.data : resp.plain();
          $scope.paginate = resp.plain();
          $rootScope.show_loader = false;
        });
    };

    /**
     * Retorna os contratos para o estudante
     */
    vm.getStudentContracts = function () {
      $rootScope.show_loader = true;
      StudentsService.getStudentContracts({
        id: $scope.vm.student.id,
        withSchoolPeriod: true,
        canceled: true
      })
        .then(function (response) {
          vm.student_contracts = response.plain();
          $rootScope.show_loader = false;
          vm.getPaymentPlansForGroup();
        })
    };

    vm.showDetails = function (item) {
      A4NegotiationService.getNegotiationDetails({
        bill_action_id_origin: item.bill_action_id_origin,
        bill_serie_id: item.bill_serie_id
      }).then(function (resp) {
        resp = resp.plain();
        if (angular.isDefined(resp.origin_negotiation[0])) {
          resp.origin_negotiation[0].settlement_date = item.date;
        }
        resp.result_negotiation[0].total_negotiation = item.total_amount;
        resp.total_origin = item.sum_negociated;
        ModalFactory.customClean(
          'app/components/a4-negotiation/negotiation-modal.html',
          'A4NegotiationModalController',
          'vm', false, resp
        ).then(function () {
          vm.getNegotiations();
        }).catch(function () {
          vm.getNegotiations();
        })
      })
    };

    /**
     * Retornar para o modal anterior
     */
    vm.openContractModal = function (data) {
      ModalFactory.customClean(
        'app/components/a4-negotiation/negotiation-modal.html',
        'A4NegotiationModalController',
        'vm', false, data
      )
        .then(function () {
          vm.getStudentContracts();
        });
    };

    /**
     * Busca os responsáveis do aluno, e adiciona ao contrato
     */
    vm.getStudentParents = function () {
      StudentsService.getStudentParents({student_id: vm.student.id})
        .then(function (response) {
          vm.student_responsible = response.plain();
        });
    };

    /**
     * Modifica o dia preferêncial de pagamento
     */
    vm.changePreferentialDay = function (bill_serie_id) {
      ModalFactory.prompt(null, 'Modificar dia preferencial de vencimento',
        'Escreva o dia no campo abaixo, entre 1 e 30', 'Dia Preferêncial', null,
        'Modificar', 'Cancelar', 'educational', null, true
      ).then(function (response) {
        if (response < 1 || response > 30) {
          Common.Toast.warning('Dia preferêncial deve ser entre 1 e 30');
          return;
        } else {
          $rootScope.show_loader = true;
          A4ContractService.updatePreferentialDay(bill_serie_id, response)
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Dia preferêncial alterado com sucesso!');
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.error(error.message);
            });
        }
      });
    };

    vm.printEnrolmentContract = function (bill_serie_id) {
      $rootScope.show_loader = true;
      EnrolmentService.printEnrolmentContract({
        person_id: $scope.personId,
        bill_serie_id: bill_serie_id,
        is_finance: true
      })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    vm.printPaymentBook = function (bill_serie_id) {

    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });


    vm.init();

  }

  angular.module('app.a4-negotiation')
    .controller('A4NegotiationController', A4NegotiationController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function A4NegotiationModalController($scope, $state, $rootScope, $filter, $mdDialog, A4ContractService,
                                        $document, CONFIG, ReportsService, Session,
                                        a4Moment, A4NegotiationService, ModalExtra, BillReceiptService,
                                        Common, ModalFactory, EnrolmentService, ProductService, BillNegotiateService, PoliciesService) {

    var vm = this;
    vm.hasPaymentPlan = true;
    vm.payment_installments = [];
    vm.payment_plans = [];
    vm.contract = {};
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.frequency_options = BillReceiptService.getFrequencyOptions();
    vm.preferencial_due_day_list = BillReceiptService.range();
    vm.vinculated_services = [];
    vm.disable = false;
    vm.disable_undo = true;
    vm.school_period_id = Session.getCurrentSchoolPeriod().id;
    vm.disable_neg_undo = false;

    vm.init = function () {
      vm.negotiationData = ModalExtra;
      vm.negotiationData.result_negotiation.forEach(function (item) {
        if (item.status === 1) {
          vm.disable_undo = false;
        }
      });
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });

      /* Verifica a permissão "Negociações>Desfazer negociação" para dasabilitar o botão "Desfazer negociação" */
      if(vm.checkPolicies('neg_undo')){
        vm.disable_neg_undo = true;
      }

    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.reopenModal = function () {
      ModalFactory.customClean(
        'app/components/a4-negotiation/negotiation-modal.html',
        'A4NegotiationModalController',
        'vm', false, ModalExtra
      );
    };

    vm.printNegotiationPaymentBook = function () {
      $rootScope.show_loader = true;
      vm.disable = true;
      A4NegotiationService.printNegotiationPaymentBook({
        bill_serie_result: vm.negotiationData.result_negotiation[0].bill_serie_id
      }).then(function () {
        $rootScope.show_loader = false;
        vm.disable = false;
      });
    }

    vm.printNegotiationContract = function () {
      $rootScope.show_loader = true;
      vm.disable = true;
      A4NegotiationService.printNegotiationContract({
        bill_action_id_origin: vm.negotiationData.origin_negotiation[0].bill_action_id,
        bill_serie_result: vm.negotiationData.result_negotiation[0].bill_serie_id,
        person_id: vm.negotiationData.origin_negotiation[0].person_id_serie,
        school_period_id: vm.school_period_id
      }).then(function () {
        $rootScope.show_loader = false;
        vm.disable = false;
      });
      /*var href = vm.webLink + 'api/reports/printnegotiationcontract?token=' + vm.conf.token + '&company=' + vm.conf.current_company + '&connection=' + vm.conf.current_connection
        + '&bill_action_id_origin=' + vm.negotiationData.origin_negotiation[0].bill_action_id + '&bill_serie_result=' + vm.negotiationData.result_negotiation[0].bill_serie_id
        + '&person_id=' + vm.negotiationData.origin_negotiation[0].person_id_serie + '&current_school_period=' + vm.school_period_id;
      var element = document.createElement('a');
      element.setAttribute('href', href);
      element.setAttribute('target', '_blank');
      return element.click();*/
    };


    vm.undoNegotiate = function () {
      vm.disable = true;
      ModalFactory.custom('app/components/a4-negotiation/undo-modal.html', {
        notes: null,
        date_end: a4Moment(),
        today: a4Moment()
      }).then(function (data_cancel) {
        $rootScope.show_loader = true;
        BillNegotiateService.undoNegociationById({
          bill_id: vm.negotiationData.result_negotiation[0].bill_id,
          notes: data_cancel.notes,
          date_end: data_cancel.date_end.format('YYYY-MM-DD')
        }).then(function () {
          Common.Toast.success('Negociação desfeita com sucesso!');
          $rootScope.$emit('UPDATE_NEGOTIATIONS_LIST');
          $rootScope.$emit('UPDATE_BILL_LIST');
          $rootScope.$emit('UPDATE_CREDITS_LIST');
          $rootScope.show_loader = false;
          $mdDialog.hide(true);
        }).catch(function () {
          Common.Toast.error('Erro ao desfazer negociação!');
        })
      }).catch(function () {
        $rootScope.show_loader = false;
        Common.Toast.error('Não foi possível desfazer a negociação!');
        vm.reopenModal();
      });
    };

    /**
     * Fecha modal
     * @param data
     */
    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    vm.init();

  }

  angular.module('app.a4-negotiation')
    .controller('A4NegotiationModalController', A4NegotiationModalController);

})();

(function () {
    'use strict';
    angular.module('app.a4-move-reports-to-folder', []);
  })();
(function () {
    'use strict';
  
    /** @ngInject */
    function MoveToFolderDialogController($scope, $mdDialog, ModalExtra, CentralReportsService, Common) {
      var dialog = this;
  
      // Dados passados pelo modal
      dialog.reportItem = ModalExtra.reportItem;
      dialog.folders = ModalExtra.folders;
      dialog.selectedFolder = null;
  
      /**
       * Confirma a movimentação do relatório
       */
      dialog.confirmMove = function() {
        if (dialog.selectedFolder && dialog.selectedFolder.id !== dialog.reportItem.parent_id) {
          $mdDialog.hide(dialog.selectedFolder);
        }
      };
  
      /**
       * Fecha o modal
       */
      dialog.closeModal = function() {
        $mdDialog.cancel();
      };
  
      // Inicialização
      dialog.init = function() {
        // Filtra pastas que não são a pasta atual do relatório
        dialog.folders = dialog.folders.filter(function(folder) {
          return folder.id !== dialog.reportItem.parent_id;
        });
      };
  
      dialog.init();
    }
  
    angular
      .module('app.a4-move-reports-to-folder')
      .controller('MoveToFolderDialogController', MoveToFolderDialogController);
  })();
(function () {
  'use strict';
  
  angular
    .module('app.a4-menu-system', []);
})();
(function () {
  'use strict';
  
  /** @ngInject */
  function a4MenuSystemProvider() {
    var vm = this;
    vm.setControll = true;
    
    vm.toggleA4MenuSystem = function () {
      if (vm.setControll) {
        angular.element('a4-menu-system-toggle').fadeIn();
        vm.setControll = false;
      } else {
        angular.element('a4-menu-system-toggle').fadeOut();
        vm.setControll = true;
      }
    };
    
    vm.hideA4MenuSystem = function () {
      angular.element('a4-menu-system-toggle').fadeOut();
      vm.setControll = true;
    };
    
    vm.$get = function () {
      return {
        toggleA4MenuSystem: vm.toggleA4MenuSystem,
        hideA4MenuSystem: vm.hideA4MenuSystem
      }
      
    }
    
  }
  
  angular
    .module('app.a4-menu-system')
    .provider('a4MenuSystemProvider', a4MenuSystemProvider);
})();
(function () {
  'use strict';
  
  /** @ngInject */
  function a4MenuSystem(a4MenuSystemProvider) {
    
    return {
      restrict: 'E',
      templateUrl: 'app/components/a4-menu-system/templates/menu.html',
      scope: {},
      controller: 'a4MenuSystemController as vm',
      link: function ($scope, element) {
        $scope.$watch(
          function () {
            return element[0].ownerDocument.body.className;
          }, function (newer) {
            var n = newer + '';
            if(n.search('ms-navigation-folded-open') == -1){
              a4MenuSystemProvider.hideA4MenuSystem();
            }
          })
        
      }
    }
  }
  
  angular
    .module('app.a4-menu-system')
    .directive('a4MenuSystem', a4MenuSystem)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4MenuSystemController(LocalStorage, $document) {
    var current_connection = $document[0].domain.split('.')[0];
    var vm = this;
    vm.menu = [
      {
        name: 'Educacional',
        image: 'assets/images/logos/a4educational.png',
        uisref: 'private.educational.dashboard',
        policy: 'educational',
        conditional: true
      },
      {
        name: 'Financeiro',
        image: 'assets/images/logos/a4finance.png',
        uisref: 'private.finance.dashboard',
        policy: 'financeiro',
        conditional: LocalStorage.get('has_app_finance')
      },
      {
        name: 'Relacionamento',
        image: 'assets/images/logos/a4crm.jpg',
        uisref: 'private.crm.dashboard',
        policy: 'crm',
        conditional: true
      },
      {
        name: 'Estoque',
        image: 'assets/images/logos/a4stock.png',
        uisref: 'private.stock.dashboard',
        policy: 'estoque_menu',
        conditional: true
      },
      {
        name: 'Avaliações',
        image: 'assets/images/logos/a4evaluations.png',
        uisref: 'private.evaluations.dashboard',
        policy: 'evaluations',
        conditional: true
      },
      {
        name: 'Solicitações',
        image: 'assets/images/logos/a4process.png',
        uisref: 'private.process.dashboard',
        policy: 'process',
        conditional: current_connection === 'portaldosaber' || current_connection === 'a4simetria' || current_connection === 'labs'
      }
    ];
  }

  angular
    .module('app.a4-menu-system')
    .controller('a4MenuSystemController', a4MenuSystemController)
})();
(function(){
  'use strict';

  angular
    .module('app.a4-md-dialog', []);

})();
(function () {
  'use strict';

    /** @ngInject */
  function a4MdDialogService($mdDialog) {

    function confirmBoxResponse(title, content, confirmText, successCb, successCbParam) {
      var confirm = $mdDialog.confirm()
        .title(title)
        .textContent(content)
        .ariaLabel('Lucky day')
        .ok(confirmText)
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function () {
        successCb(successCbParam);
      }, function () {
        //pressed cancel
      });
    }

      return {
        confirmBoxResponse: confirmBoxResponse
      };


  }

  angular
    .module('app.a4-md-dialog')
    .factory('a4MdDialogService', a4MdDialogService);

})();
/*
 * jstree.directive [http://www.jstree.com]
 * http://arvindr21.github.io/jsTree-Angular-Directive
 *
 * Copyright (c) 2014 Arvind Ravulavaru
 * Licensed under the MIT license.
 */

var ngJSTree = angular.module('app.jsTree.directive', []);
ngJSTree.directive('jsTree', ['$http', function ($http) {

  var treeDir = {
    restrict: 'EA',
    fetchResource: function (url, cb) {
      return $http.get(url).then(function (data) {
        if (cb) cb(data.data);
      });
    },

    managePlugins: function (s, e, a, config) {
      if (a.treePlugins) {
        config.plugins = a.treePlugins.split(',');
        config.core = config.core || {};
        config.core.check_callback = config.core.check_callback || true;

        if (config.plugins.indexOf('state') >= 0) {
          config.state = config.state || {};
          config.state.key = a.treeStateKey;
        }

        if (config.plugins.indexOf('search') >= 0) {
          var to = false;
          if (e.next().attr('class') !== 'ng-tree-search') {
            e.after('<input type="text" placeholder="Search Tree" class="ng-tree-search"/>')
              .next()
              .on('keyup', function (ev) {
                if (to) {
                  clearTimeout(to);
                }
                to = setTimeout(function () {
                  treeDir.tree.jstree(true).search(ev.target.value);
                }, 250);
              });
          }
        }

        if (config.plugins.indexOf('checkbox') >= 0) {
          config.checkbox = config.checkbox || {};
          config.checkbox.keep_selected_style = angular.isUndefined(config.checkbox.keep_selected_style) ? false : config.checkbox.keep_selected_style;
        }

        if (config.plugins.indexOf('contextmenu') >= 0) {
          if (a.treeContextmenu) {
            config.contextmenu = config.contextmenu || {};

            if (a.treeContextmenuaction != undefined) {
              config.contextmenu.items = function (e) {
                return s.$eval(a.treeContextmenuaction)(e);
              }
            } else {
              config.contextmenu.items = function () {
                return s[a.treeContextmenu];
              }
            }
          }
        }

        if (config.plugins.indexOf('types') >= 0) {
          if (a.treeTypes) {
            config.types = s[a.treeTypes];
          }
        }

        if (config.plugins.indexOf('dnd') >= 0) {
          if (a.treeDnd) {
            config.dnd = s[a.treeDnd];
          }
        }
      }
      return config;
    },
    manageEvents: function (s, e, a) {
      if (a.treeEvents) {
        var evMap = a.treeEvents.split(';');
        for (var i = 0; i < evMap.length; i++) {
          if (evMap[i].length > 0) {
            // plugins could have events with suffixes other than '.jstree'
            var evt = evMap[i].split(':')[0];
            if (evt.indexOf('.') < 0) {
              evt = evt + '.jstree';
            }
            var cb = evMap[i].split(':')[1];
            treeDir.tree.on(evt, s[cb]);
          }
        }
      }
    },
    link: function (s, e, a) { // scope, element, attribute \O/
      $(function () {
        var config = {};
        // users can define 'core'
        config.core = {};
        if (a.treeCore) {
          config.core = $.extend(config.core, s[a.treeCore]);
        }

        if (s.checkbox) {
          config.checkbox = s.checkbox;
        }

        // clean Case
        a.treeData = a.treeData ? a.treeData.toLowerCase() : '';
        a.treeSrc = a.treeSrc ? a.treeSrc.toLowerCase() : '';

        if (a.treeData == 'html') {
          treeDir.fetchResource(a.treeSrc, function (data) {
            e.html(data);
            treeDir.init(s, e, a, config);
          });
        } else if (a.treeData == 'json') {
          treeDir.fetchResource(a.treeSrc, function (data) {
            config.core.data = data;
            treeDir.init(s, e, a, config);
          });
        } else if (a.treeData == 'scope') {
          s.$watch(a.treeModel, function (n, o) {
            if (n) {
              config.core.data = s[a.treeModel];
              $(e).jstree('destroy');
              treeDir.init(s, e, a, config);
            }
          }, true);
          // Trigger it initally
          // Fix issue #13
          config.core.data = s[a.treeModel];
          treeDir.init(s, e, a, config);
        } else if (a.treeAjax) {
          config.core.data = {
            'url': a.treeAjax,
            'data': function (node) {
              return {
                'id': node.id != '#' ? node.id : 1
              };
            }
          };
          treeDir.init(s, e, a, config);
        }
      });

    },
    init: function (s, e, a, config) {
      treeDir.managePlugins(s, e, a, config);
      this.tree = $(e).jstree(config);
      treeDir.manageEvents(s, e, a);
    }
  };

  return treeDir;

}]);

(function(){
  'use strict';

  angular
    .module('app.a4-infinite-scroll', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4InfiniteScroll() {

    return {
      restrict: 'E',
      templateUrl: 'app/components/a4-infinite-scroll/templates/infinite-scroll.html',
      scope: { items: "="
      },
      controller: 'a4InfiniteScrollController',
      controllerAs: 'vm',
      link: function (scope, element, attr, ctl) {


      }
    }
  }

  angular
    .module('app.a4-infinite-scroll')
    .directive('a4InfiniteScroll', a4InfiniteScroll)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4InfiniteScrollController($scope) {
    var vm = this;

    vm.items = $scope.items;



  }

  angular
    .module('app.a4-infinite-scroll')
    .controller('a4InfiniteScrollController', a4InfiniteScrollController)
})();
(function () {
  'use strict';

  angular.module('app.a4-guide-button', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4GuideButton() {
    return {
      restrict: 'E',
      scope: {
        guide: '=?',
        buttonTheme: '=?'
      },
      controller: 'a4GuideButtonController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-guide-button/a4-guide-button.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4-guide-button')
    .directive('a4GuideButton', a4GuideButton);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4GuideButtonController($scope) {
    var vm = this;
    vm.guides = {
      negotiation: {
        title: "Exibir manual da negociação",
        link: "https://a4tecnologia.atlassian.net/wiki/spaces/A4/pages/1649836033/Negocia%2Bo"
      },
      discounts: {
        title: "Exibir manual dos descontos",
        link: "https://a4tecnologia.atlassian.net/wiki/spaces/A4/pages/1584431109/Descontos"
      }
    };

    vm.init = function () {
      vm.guide = vm.guides[$scope.guide];
    };

    vm.init();

  }

  angular.module('app.a4-guide-button')
    .controller('a4GuideButtonController', a4GuideButtonController);
})();
(function () {
  'use strict';

  angular.module('app.a4-guest-check-pad-report', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4GuestCheckPadReportDirective(a4Moment) {
    return {
      restrict: 'E',
      scope: {
        personId: '=?'
      },
      templateUrl: 'app/components/a4-guest-check-pad-report/index.html',
      controller: 'a4GuestCheckPadReportController',
      controllerAs: 'vm',
      link: function (scope, elem, attrs, ctrl) {
        scope.filter_date = {
          startDate: a4Moment().startOf('month').format('YYYY-MM-DD'),
          endDate: a4Moment().endOf('month').format('YYYY-MM-DD')
        };
        ctrl.personId = scope.personId;
        ctrl.getAllGuestCheckPadReport(1, 15, scope.filter_date);
      }
    }
  }

  angular.module('app.a4-guest-check-pad-report')
    .directive('a4GuestCheckPadReport', a4GuestCheckPadReportDirective);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4GuestCheckPadReportController($document, $rootScope, a4Moment, Common, GuestCheckPadService,
                                           CONFIG, CashierManagementService, Session, $window, ModalFactory, ReportsService) {
    var vm = this;

    vm.webLink = CONFIG.webApiUri + 'api/cashiersession/guestcheckpad/report/';
    vm.subdomain = $document[0].domain.split('.')[0];

    vm.filter_date = {
      startDate: a4Moment().startOf('month').format('YYYY-MM-DD'),
      endDate: a4Moment().endOf('month').format('YYYY-MM-DD')
    };

    CashierManagementService.getToken().then(function (response) {
      vm.token = response;
    });

    /**
     * Retorna a paginação de recibos
     */
    vm.getAllGuestCheckPadReport = function (page, qty, date) {
      $rootScope.show_loader = true;
      page = (angular.isUndefined(page) || page === null) ? 1 : page;
      qty = (angular.isUndefined(qty) || qty === null) ? 15 : qty;
      date = (angular.isUndefined(date) || date === null) ? undefined : date;
      var person_id = angular.isDefined(vm.personId) ? vm.personId : null;

      vm.promise = GuestCheckPadService.getGuestCheckPadReport({
        initialDate: angular.isUndefined(date) ? null : date.startDate,
        endDate: angular.isUndefined(date) ? null : date.endDate,
        page: page, qtd: qty,
        person_id: person_id
      }).then(function (response) {
        vm.guest_check_pad_reports = response.plain();
        $rootScope.show_loader = false;
      })
    };

    /**
     * Imprime recibo da comanda
     * @param item - Comanda
     * @param type 0 - PDF | 1 - Impressora não-fiscal
     */
    vm.printReport = function (item, type, date) {
/*      var url = vm.webLink + '?token=' + vm.token + "&company=" + Session.get('current_company', "sessionStorage") +
        "&connection=" + vm.subdomain + "&bill_action_id=" + item.bill_action_id + "&second_way=true" + "&type=" + type +
        "&school_period=" + date.slice(0, 4) + "&person_id=" + vm.personId;

      $window.open(url); */
      ReportsService.reportFactory('GET',
        'api/guestcheckpad/report',
        {
          connection: vm.subdomain,
          bill_action_id: item.bill_action_id,
          second_way: true,
          type: type,
          school_period: date.slice(0,4),
          person_id: vm.personId
        })
    };

    /**
     * Abre modal de confirmação do desfazimento da comanda
     * @param item
     */
    vm.undoGuestCheckPad = function (item) {
      if (item.close_datetime === null) {
        ModalFactory.open('require_password', null, null, {bill_action_id: item.bill_action_id}, null, 'finance',
          vm.executeUndoGuestCheckPad, 'Desfazimento de recibo de caixa', 'Confirme sua senha para desfazer todos os movimentos ' +
          'deste recibo de caixa', null).then(function () {
          Common.Toast.success('Comanda desfeita com sucesso!');
          vm.getAllGuestCheckPadReport(1, 15, vm.filter_date);
        })
      } else {
        ModalFactory.alert(
          "Comanda não pode ser desfeita", "Esta comanda faz parte de uma sessão de caixa que já foi encerrada, não podendo ser desfeita.",
          "modal", "Ok", "false", "finance"
        );
      }
    };

    /**
     * Execução do desfazimento de comanda
     * @param bill_action_id
     * @returns {void|*}
     */
    vm.executeUndoGuestCheckPad = function (bill_action_id) {
      return GuestCheckPadService.undoGuestCheckPad(bill_action_id);
    }


  }

  angular.module('app.a4-guest-check-pad-report')
    .controller('a4GuestCheckPadReportController', a4GuestCheckPadReportController);

})();

(function () {
  'use strict';

  angular.module('app.a4-groups', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4Groups() {
    return {
      restrict: 'E',
      scope: {
        showGroupCompleted: '=?',
        showCourse: '=?',
        courseId: '=?',
        isWithoutSchoolPeriod: '=?',
        query: '=?'
      },
      controller: 'a4GroupsController',
      controllerAs: 'vm',
      require: ['^form'],
      templateUrl: 'app/components/a4-groups/a4-groups.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4-groups')
    .directive('a4Groups', a4Groups);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4GroupsController($rootScope, $timeout, $scope, $state, $a4FloatButton, Common, CourseService, GroupsService,
                              PoliciesService, EvaluationCriteriaService, ModalFactory, MatrixService, $stateParams, GroupService) {
    var vm = this;

    vm.grid = {
      rows: [],
      info: {}
    };
    vm.courses = [];
    vm.form = {};
    vm.show_group_completed = false;

    vm.group = {name: ''};

    vm.init = function () {
      vm.paginate(1, 20, $scope.courseId);
      vm.getCourses();
      // vm.floatButton = $a4FloatButton({scope: $scope, uiSref: 'private.educational.groups.create'});
    };

    $scope.$watch('query', function () {
      $timeout(function () {
        vm.paginate(1, 20, $scope.courseId, $scope.query)
      }, 1000);
    });

    $scope.$watch('courseId', function () {
      vm.paginate(1, 20, $scope.courseId);
    });

    $scope.$watch('showGroupCompleted', function () {
      vm.show_group_completed = $scope.showGroupCompleted;
      vm.paginate(1, 20, $scope.courseId);
    });

    /**
     * Retorna todos os grupos de curso disponíveis
     * @param page - pagina corrente da paginação
     * @param limit - limite de registros por pagina
     * @param course_id - Identificador do curso para filtro
     */
    vm.paginate = function (page, limit, course_id, query) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 20;
      page = angular.isDefined(page) ? page : 1;
      course_id = $scope.courseId !== null ? $scope.courseId : null;
      vm.show_group_completed = (angular.isDefined(vm.show_group_completed) ? vm.show_group_completed : false);

      vm.promise = GroupsService.getAll({
        limit: limit,
        page: page,
        course_id: course_id,
        show_group_completed: vm.show_group_completed,
        query: query
      })
        .then(function (response) {
          vm.grid = response;

          if (vm.grid.data.length > 0 && vm.grid.data[0].school_period_id === 0) {
            $scope.isWithoutSchoolPeriod = true;
          }
          $rootScope.show_loader = false;
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.message || error.data.message);
        });
    };

    /**
     * Retorna todos os cursos
     */
    vm.getCourses = function () {
      CourseService.getCoursesWithGroups()
        .then(function (response) {
          vm.courses = response
        })
        .catch(function (error) {
          Common.Toast.error(error.message || error.data.message);
        });
    };

    /**
     * Executa uma função desejada na lista de opções do grid
     * @param group
     * @param option
     */
    vm.clickActions = function (group, option) {
      switch (option) {
        case 'conditional-group-enrollment':
          vm.conditionalGroupEnrollment(group);
          break;
        default:
      }
    };

    /**
     * Exclui turma
     * @param item
     */
    vm.deleteGroup = function (item) {
      ModalFactory.confirm(null, "Confirmar exclusão",
        "Deseja realmente excluir esta turma?",
        'Confirmar', 'Cancelar', 'educational')
        .then(function () {
          $rootScope.show_loader = true;
          GroupsService.deleteGroup(item.id, {matrix_period: item.matrix_period}).then(function () {
            Common.Toast.success('Turma excluída com sucesso!');
            vm.paginate();
            $rootScope.show_loader = false;
          }).catch(function (errors) {
            $rootScope.show_loader = false;
            ModalFactory.custom('app/components/modal/Templates/operationError.html', {
              reasons: errors.data,
              name: 'Exclusão de turma',
              message: 'Esta turma não poderá ser excluída porque:',
              theme: 'educational'
            }, false);
          })
        });
    };

    vm.recalculateNotes = function (group) {
      ModalFactory.open('require_password', null, null, group, null, 'educational', vm.doRecalc,
        'Confirmação de recálculo de notas da turma ' + group.name, 'Confirme sua senha para recalcular as notas dos alunos desta turma', null)
        .then(function () {
          Common.Toast.success("Notas recalculadas com sucesso!");
        })

    };

    vm.doRecalc = function (data) {
      return GroupsService.recalculateGroup(data);
    };


    /**
     * Abre o modal para a matrícula em grupo condicional
     */
    vm.conditionalGroupEnrollment = function (group) {
      $rootScope.show_loader = true;
      ModalFactory.customClean(
        'app/educational/groups/views/forms/conditional-group-enrollment-dialog.html',
        'ConditionalGroupEnrollmentController',
        'vm', false, group
      ).then(function () {
        $rootScope.show_loader = false;
        vm.paginate();
      }).catch(function () {
        $rootScope.show_loader = false;
      });
    };

    vm.changeMatrix = function (group) {
      vm.course_id = parseInt(group.course_id);
      vm.course_equivalence_id = group.course_equivalence_id;
      $rootScope.show_loader = true;
      MatrixService.getMatrixOfCourse({course_id: vm.course_id})
        .then(function (response) {
          $rootScope.show_loader = false;
          ModalFactory.customClean(
            'app/educational/course/group/views/change-matrix.html',
            /** @ngInject */
            function (ModalExtra, GroupService, $mdDialog) {
              var vm = this;
              vm.selected_matrix = null;
              vm.matrix = ModalExtra.matrix;
              vm.submit = function () {
                $mdDialog.hide({
                  matrix_id: vm.selected_matrix,
                  group_id: ModalExtra.group_id,
                  course_equivalence_id: ModalExtra.course_equivalence_id,
                  matrix_period: ModalExtra.matrix_period
                });
              };
              vm.close = function () {
                $mdDialog.cancel();
              };
            },
            'vm', false, {
              matrix: response,
              group_id: group.id,
              matrix_period: group.matrix_period,
              course_equivalence_id: vm.course_equivalence_id
            }
          ).then(function (data) {
            ModalFactory.open('require_password', null, null, data, null, 'educational', vm.change,
              'Confirmação de troca de grade da turma', 'Confirme sua senha para trocar a grade', null)
              .then(function () {
                vm.paginate(1, 20);
                Common.Toast.success('Grade trocada com sucesso!');
                $rootScope.show_loader = false;
              });
          });
        })
    };

    vm.changeGradeRule = function (group) {
      EvaluationCriteriaService.getAll().then(function (grade_rules) {
        ModalFactory.custom('app/components/a4-groups/change-grade-rule.html', {
          grade_rules: grade_rules.plain().data,
          grade_rule_id: angular.copy(group.grade_rule_id),
          grade_rule_id_old: angular.copy(group.grade_rule_id),
        }).then(function (grade_rule_id) {
          $rootScope.show_loader = true;
          GroupsService.changeGradeRuleGroup({
            group_id: group.id,
            matrix_period: group.matrix_period,
            grade_rule_id: grade_rule_id
          }).then(function () {
            Common.Toast.success('Critério de avaliação atualizado com sucesso!');
            vm.paginate(1, 20);
          })
        });
      });
    };

    /**
     * Realiza a troca de grade da turma
     * @param data
     */
    vm.change = function (data) {
      return GroupService.changeMatrix(data);
    };
    /**
     * Chamada do serviço de retorna todos os grupos de curso da API
     */
    vm.getAll = function () {
      GroupsService.getAll()
        .then(function (response) {
          vm.grid.rows = response;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Realiza a busca e o resultado é posto no grid
     * @param query - string escrita
     */
    vm.filterGroupsList = function (query) {
      GroupsService.getAll({query: query})
        .then(function (response) {
          vm.grid.rows = response;
        })
    };
    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Edição de turmas
     * @param item - item a ser editado
     */
    vm.editGroup = function (item) {
      $state.go('private.educational.groups.edit', {id: item.group_id, matrix_period: item.matrix_period});
    };


    vm.init();
  }

  angular.module('app.a4-groups')
    .controller('a4GroupsController', a4GroupsController);
})();

(function () {
  'use strict';
  angular.module('app.a4formdicdata', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4GridDicData($templateRequest, $compile, $timeout, a4FormDicDataService,CONFIG,
                         a4FormDicDataUtilsService, $rootScope, PoliciesService) {
    return {
      restrict: 'E',
      scope: {
        fieldsSchema: '@',
        fields: '=?',
        bind: '=?',
        list: '=?',
        onClickActions: '&?',
        onClickItem: '&?',
        onPaginate: '&?',
        onDelete: '&?',
        policies: '=?',
      },
      link: function (scope, element) {
        scope.stepSelected = 0;
        scope.stepProgress = 1;
        scope.maxStep = 3;
        scope.showBusyText = false;
        scope.CONFIG = CONFIG;

        scope.loading = false;
        var templateLoading = null;
        /**
         * Inicia o processo de geração.
         */
        a4FormDicDataService.init(scope.fieldsSchema)
          .then(function (response) {
            /** Caso não haja o bind, é colocado um vazio */
            angular.isUndefined(scope.bind) ? scope.bind = {} : scope.bind;

            /** schema de campos json */
            scope.form = response.fieldsSchema;
            var dataBaseSchema = response.dataBaseSchema;
            scope.form.items = a4FormDicDataService.mergeListJson(scope.form.items, dataBaseSchema.dd);
            scope.table = scope.form.items[0].table;
            scope.fields = scope.form.items;
            scope.getTemplateUrl(scope.form.type);
          });

        /**
         * Função para checar as políticas de segurança em relação ao grid
         */
        scope.checkPolicies = function (key) {
          if (angular.isDefined(scope.policies) && angular.isDefined(scope.policies[key])) {
            return !PoliciesService.checkPolicyFromMenu(scope.policies[key]);
          } else {
            return false;
          }
        };

        /**
         * Função que permite passar parametro para o controlado desejado
         */
        scope.clickActions = function (item, option) {
          scope.onClickActions({item: item, option: option});
        };

        /**
         * Resgata o template da diretiva de acordo com o objeto de formulário em JSON, ou seja
         * o json tem uma propriedade no objeto principal, chamado type, onde o mesmo é passado para
         * a função e após isso é selecionado o template correto.
         * Tipos disponíveis : {form, grid, material-grid, form-wizard}
         * @returns {string}
         */
        scope.getTemplateUrl = function (form_type) {
          switch (form_type) {
            default:
              $templateRequest('app/components/a4-form-dic-data/a4-form-dic-data.grid.html')
                .then(function (html) {
                  scope.loading = true;
                  var template = angular.element(html);
                  element.append(template);
                  var t = $compile(template)(scope);
                  t.ready(function () {
                    $rootScope.$broadcast('a4-grid-dic-data.loaded')
                  });
                });
              break;
          }
        };

        /**
         * Esculta para loading de carremento de formulário.
         */
        // var ltn = scope.$watch('loading', function (newValue) {
        //   if (newValue) {
        //
        //     angular.element(document.querySelector('.box-loading')).addClass('loading-show');
        //     templateLoading.remove();
        //
        //   } else {
        //     templateLoading = angular.element(''
        //       // +
        //       // '<md-dialog-content id="space-loading" layout="row" layout-margin layout-padding layout-align="center center" aria-label="wait">' +
        //       // '<div class="box-loading" layout="row" layout-align="center center">' +
        //       // '<md-progress-circular md-mode="indeterminate" ng-disabled="scope.loading" md-diameter="35"></md-progress-circular>' +
        //       // '<strong> Carregando...</strong>' +
        //       // '</div></md-dialog-content>' +
        //       // '</md-dialog>'
        //     );
        //     element.append(templateLoading);
        //     $compile(templateLoading)(scope);
        //
        //     angular.element(document.querySelector('.box-loading')).addClass('loading-show');
        //
        //   }
        // });
        //
        // scope.$on('$destroy', function () {
        //   [ltn].forEach(function (fn) {
        //     fn();
        //   })
        // })

      },
      controllerAs: "vm"
    }
  }

  angular.module('app.a4formdicdata')
    .directive('a4GridDicData', a4GridDicData)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4FormDicDataService(Restangular, $http, $filter, $rootScope, Common, LocalStorage) {
    var vm = this;
    var CONST_DD = 'dData';

    vm.fieldsType = function () {
      return {
        AGGREGATE_FIELD: "aggregate_field",
        FORM_WIZARD: "form-wizard",
        AUTOCOMPLETE: "autocomplete",
        BOOLEAN: "boolean",
        CHECK: "check",
        TIME: "time",
        INPUT: "input",
        RADIO: "radio",
        SELECT: "select",
        TEXTAREA: "textarea",
        LIST: "list",
        GRID_LIST: "grid_list",
        INPUT_SEARCH: "input_search"
      }
    };

    /**
     * Resgata o esquema de banco de dados em JSON da API, mas em caso de já haver no localstorage
     * é resgatado de lá.
     */
    vm.getDataSchema = function () {
      var ddata = Common.$q.defer();
      if (LocalStorage.has(CONST_DD)) {
        ddata.resolve(LocalStorage.get(CONST_DD));
      } else {
        Restangular.one('data').one('structure').get()
          .then(function (dd) {
            LocalStorage.add(CONST_DD, dd);
            ddata.resolve(LocalStorage.get(CONST_DD));
          });
      }
      return ddata.promise;
    };
    vm.getFieldSchema = function (path) {
      return $http.get(path);
    };
    /**
     * Executa a separação da composição de NomeTabela.NomeColuna
     * @param composition
     */
    vm.separeClassToName = function (composition) {
      var comp = {};
      if (typeof composition !== 'string') {
        return false;
      }
      var slitted = composition.split('.');
      comp.table = slitted[0];
      comp.column = slitted[1];
      return comp;
    };
    /**
     * Retorna as propriedades da tabela pedida.
     * @param table - Nome da tabela para o conjunto de dados
     * @param column - Nome da coluna para o conjunto de dados
     * @param dd - Lista do dicionário de dados.
     */
    vm.getPropertiesFromDD = function (table, column, dd) {
      var transObject = {};
      if (column === '*') {
        var array = [];
        transObject = dd[table].properties;
        angular.forEach(transObject, function (value, key) {
          value.$$id = table + "." + key;
          value.reference = key;
          value.table = table;
          array.push(value);
        });
        transObject = array;
      } else {
        transObject = dd[table];
        if (angular.isDefined(transObject)) {
          transObject = angular.isDefined(transObject.properties[column]) ? transObject.properties[column] : {};
          transObject.$$id = table + "." + column;
          transObject.reference = column;
          transObject.table = table;
        } else {
          transObject = {};
          transObject.$$id = table + "." + column;
          transObject.reference = column;
          transObject.table = table;
        }
      }
      return transObject;
    };
    /**
     * Executa o merge entre as propriedades do json de campos e o json do data dictionary
     * @param list - lista de campos
     * @param props - propriedades de uma propriedade do data dictionary
     */
    vm.mergeObjPropWithOwnProp = function (list, props) {
      var c = {};
      var search = [];
      if (angular.isObject(props)) {
        c = vm.separeClassToName(props.id);
        search = c.column === '*' ? c.table : props.id;
      } else {
        c = vm.separeClassToName(props);
        search = c.column === '*' ? c.table : props;
        props = {
          "id": props,
          "show": true,
          "required": false,
          "placeholder": props,
          "maxlength": 45,
          "minlength": 2
        }
      }
      var fields = $filter('filter')(list, {$$id: search});
      angular.forEach(fields, function (value) {
        angular.extend(value, props);
      });

      return list;
    };


    vm.getInfos = function (path) {
      var deferred = Common.$q.defer();
      Common.$q.all([vm.getDataSchema(), vm.getFieldSchema(path)])
        .then(function (schema) {
          deferred.resolve({
            dataBaseSchema: schema[0],
            fieldsSchema: schema[1].data
          });
        });
      return deferred.promise;
    };

    /**
     * Realiza das comparações de esquema
     * @param formFieldSchemaItens - Schema de campos
     * @param databaseSchema - Schema de comparação de banco de dados.
     */
    vm.mergeListJson = function (formFieldSchemaItens, databaseSchema) {
      var fields = [];
      formFieldSchemaItens.forEach(function (value) {
        var cobject = {};
        var tableProp = [];
        if (angular.isObject(value)) {

          cobject = vm.separeClassToName(value.id);

        } else if (angular.isString(value)) {

          cobject = vm.separeClassToName(value);

        }

        /** Busca as propriedades do DD */
        tableProp = vm.getPropertiesFromDD(cobject.table, cobject.column, databaseSchema);

        if (angular.isArray(tableProp)) {
          fields = fields.concat(tableProp);
        } else {
          fields.push(tableProp);
        }
        /** Executa o merge entre as propriedades do DD e do JSON configurado pelo programador */
        fields = vm.mergeObjPropWithOwnProp(fields, value);
      });
      return fields;
    };


    /**
     * Realiza das comparações de esquema
     * @param formFieldSchemaItens - Schema de campos
     * @param databaseSchema - Schema de comparação de banco de dados.
     */
    vm.merge = function (formFieldSchemaItens, databaseSchema) {
      var fields = [];
      formFieldSchemaItens.forEach(function (value) {
        var cobject = {};
        var tableProp = [];
        if (angular.isObject(value)) {
          /**
           * Em caso de campo do tipo "agreggate_field", é necessário modificar o fluxo de
           * montagem pois esse campo se comporta de uma maneira diferente.
           */
          switch (value.type) {
            case vm.fieldsType().AGGREGATE_FIELD:
              /**
               * Atributo "fields" é obrigatório para campos do tipo agreggate_field.
               */
              if (angular.isUndefined(value.fields)) {
                return false;
              }

              value.fields = vm.mergeAgreggateFields(databaseSchema, value);
              fields.push(value);
              /**
               * Aqui é o encerramento do loop para este tipo de campo, pois,
               * não há mais o que fazer após esta linha
               */
              return;
            case vm.fieldsType().LIST:
              cobject = vm.separeClassToName(value.id);
              if (angular.isDefined(value.fields) && value.fields.length > 0) {
                value.fields = vm.mergeAgreggateFields(databaseSchema, value);
              }
              break;
            default:
              cobject = vm.separeClassToName(value.id);
              break;
          }
        } else if (angular.isString(value)) {
          cobject = vm.separeClassToName(value);
        }

        /** Busca as propriedades do DD */
        tableProp = vm.getPropertiesFromDD(cobject.table, cobject.column, databaseSchema);

        if (angular.isArray(tableProp)) {
          fields = fields.concat(tableProp);
        } else {
          fields.push(tableProp);
        }
        /** Executa o merge entre as propriedades do DD e do JSON configurado pelo programador */
        fields = vm.mergeObjPropWithOwnProp(fields, value);
      });
      return fields;
    };

    /**
     * Realiza o merge de atributos em caso de campo de tipo agreggate_field
     * @param databaseSchema - Schema do banco de dados
     * @param value - item do tipo 'agreggate_field'
     * @returns {Array}
     */
    vm.mergeAgreggateFields = function (databaseSchema, value) {
      var attr_agreggate = {};
      var field_attr_agreggate = [];
      value.fields.forEach(function (val) {
        attr_agreggate = vm.separeClassToName(val.id);
        var props = vm.getPropertiesFromDD(attr_agreggate.table, attr_agreggate.column, databaseSchema);
        if (angular.isArray(props)) {
          field_attr_agreggate = fields.concat(props);
        } else {
          field_attr_agreggate.push(props);
        }
        field_attr_agreggate = vm.mergeObjPropWithOwnProp(field_attr_agreggate, val);
      });
      return field_attr_agreggate;
    };


    /**
     * Inicializa o processo de retorno de informação.
     * @param path - path do .json onde estão as informações do que será compilado.
     */
    vm.init = function (path) {
      return vm.getInfos(path);
    };


    return vm;
  }

  angular.module('app.a4formdicdata')
    .factory('a4FormDicDataService', a4FormDicDataService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4FormDicData($templateRequest, $compile, $timeout,
                         a4FormDicDataService, a4FormDicDataUtilsService,
                         $rootScope, PoliciesService) {
    return {
      restrict: 'E',
      scope: {
        fieldsSchema: '@',
        fields: '=?',
        bind: '=?',
        list: '=?',
        stepSelected: '=?',
        onSubmit: '&?',
        onClickActions: '&?',
        onFinishWizard: '&?',
        onClose: '&?',
        onClickItem: '&?',
        onProcessSelected: '&?',
        onPaginate: '&?',
        onDelete: '&?',
        policies: '=?',
        onSaveAndReplicate: '&?',
        onSaveAndContinue: '&?',
        onSaveAndAddMore: '&?'
      },
      link: function (scope, element) {
        scope.stepSelected = 0;
        scope.stepProgress = 1;
        scope.maxStep = 3;
        scope.showBusyText = false;

        scope.loading = false;
        var templateLoading = null;
        /**
         * Inicia o processo de geração.
         */
        a4FormDicDataService.init(scope.fieldsSchema)
          .then(function (response) {

            /** Caso não haja o bind, é colocado um vazio */
            angular.isUndefined(scope.bind) ? scope.bind = {} : scope.bind;
            scope.bind.show_cancel = angular.isUndefined(scope.bind.show_cancel) ? true : scope.show_cancel;
            /** schema de campos json */
            scope.form = response.fieldsSchema;
            var dataBaseSchema = response.dataBaseSchema;
            /** Importação e comparação de JSON's */
            if (a4FormDicDataService.fieldsType().FORM_WIZARD === scope.form.type) {
              angular.forEach(scope.form.items, function (value, key) {
                value.id = key;
                value.fields = a4FormDicDataService.merge(value.fields, dataBaseSchema.dd);
              });
              scope.table = scope.form.items[0].fields.table;
            } else {
              scope.form.items = a4FormDicDataService.merge(scope.form.items, dataBaseSchema.dd);
              scope.table = scope.form.items[0].table;
            }
            scope.fields = scope.form.items;
            scope.getTemplateUrl(scope.form.type);
          });

        /**
         * Função para checar as políticas de segurança em relação ao grid
         */
        scope.checkPolicies = function (key) {
          if (angular.isDefined(scope.policies) && angular.isDefined(scope.policies[key])) {
            return !PoliciesService.checkPolicyFromMenu(scope.policies[key]);
          } else {
            return false;
          }
        };

        /**
         * Função intermediária para tratamento de objeto de saida.
         * @param object
         */
        scope.submit = function (object) {
          var object_final = a4FormDicDataUtilsService.copy(object.item);
          var result = a4FormDicDataUtilsService.clearObject(object_final);

          /**
           * A função copy acima, sela o objeto para que seja possivel realizar as transformações sem nenhum erro
           * O codigo abaixo foi colocado para que o objeto que foi selado volte a seu estado normal
           */
          var unSealedObject = {};
          for (var i in object.item) {
            unSealedObject[i] = object.item[i];
          }
          object.item = unSealedObject;
          $rootScope.show_loader = true;
          scope.onSubmit({item: result, form: object.form, wizardItem: object.wizardItem});
        };

        /**
         * Função que submita o final do wizard
         */
        scope.finishWizard = function (form) {
          scope.onFinishWizard({form: form});
        };

        /**
         * Função que permite passar parametro para o controlado desejado
         */
        scope.clickActions = function (item, option) {
          scope.onClickActions({item: item, option: option});
        };

        /**
         * Resgata o template da diretiva de acordo com o objeto de formulário em JSON, ou seja
         * o json tem uma propriedade no objeto principal, chamado type, onde o mesmo é passado para
         * a função e após isso é selecionado o template correto.
         * Tipos disponíveis : {form, grid, material-grid, form-wizard}
         * @returns {string}
         */
        scope.getTemplateUrl = function (form_type) {
          switch (form_type) {
            case "form":
              $templateRequest('app/components/a4-form-dic-data/a4-form-dic-data.form.html')
                .then(function (html) {
                  scope.loading = true;
                  var template = angular.element(html);
                  element.append(template);
                  var t = $compile(template)(scope);
                  t.ready(function () {
                    $rootScope.$broadcast('a4-form-dic-data.form.loaded')
                  });
                });
              break;
            case "grid":
              $templateRequest('app/components/a4-form-dic-data/a4-form-dic-data.grid.html')
                .then(function (html) {
                  scope.loading = true;
                  var template = angular.element(html);
                  element.append(template);
                  var t = $compile(template)(scope);
                  t.ready(function () {
                    $rootScope.$broadcast('a4-form-dic-data.grid.loaded')
                  });
                });
              break;
            case "grid-select":
              $templateRequest('app/components/a4-form-dic-data/a4-form-dic-data.grid-select.html')
                .then(function (html) {
                  scope.loading = true;
                  var template = angular.element(html);
                  element.append(template);
                  var t = $compile(template)(scope);
                  t.ready(function () {
                    $rootScope.$broadcast('a4-form-dic-data.grid.loaded')
                  });
                });
              break;
            case "material-grid":
              $templateRequest('app/components/a4-form-dic-data/a4-form-dic-data.material-grid.html')
                .then(function (html) {
                  scope.loading = true;
                  var template = angular.element(html);
                  element.append(template);
                  var t = $compile(template)(scope);
                  t.ready(function () {
                    $rootScope.$broadcast('a4-form-dic-data.material-grid.loaded')
                  });
                });
              break;
            case "form-wizard":
              $templateRequest('app/components/a4-form-dic-data/a4-form-dic-data.form-wizard.html')
                .then(function (html) {
                  scope.loading = true;
                  var template = angular.element(html);
                  element.append(template);
                  var t = $compile(template)(scope);
                  t.ready(function () {
                    $rootScope.$broadcast('a4-form-dic-data.wizard.loaded')
                  });
                });
              break;
          }
        };

        // /**
        //  * Esculta para loading de carremento de formulário.
        //  */
        // var ltn = scope.$watch('loading', function (newValue) {
        //   if (newValue) {
        //
        //     angular.element(document.querySelector('.box-loading')).addClass('loading-show');
        //     templateLoading.remove();
        //
        //   } else {
        //     templateLoading = angular.element('' +
        //       '<md-dialog-content id="space-loading" layout="row" layout-margin layout-padding layout-align="center center" aria-label="wait">' +
        //       '<div class="box-loading" layout="row" layout-align="center center">' +
        //       '<md-progress-circular md-mode="indeterminate" ng-disabled="scope.loading" md-diameter="35"></md-progress-circular>' +
        //       '<strong> Carregando...</strong>' +
        //       '</div></md-dialog-content>' +
        //       '</md-dialog>');
        //     element.append(templateLoading);
        //     $compile(templateLoading)(scope);
        //
        //     angular.element(document.querySelector('.box-loading')).addClass('loading-show');
        //
        //   }
        // });
        //
        // scope.$on('$destroy', function () {
        //   [ltn].forEach(function (fn) {
        //     fn();
        //   })
        // })

      },
      controller: function ($scope) {
        var vm = this;
        vm.isAbleFinished = false;

        /**
         * Funções do form de tipo form-wizard --------------------------------------------------
         */

        vm.enableNextStep = function (maxStep) {
          /** não pode exceder o maximo de passos */
          if ($scope.stepSelected >= maxStep) {
            return;
          }
          /** So incrementa até o maximo possível */
          if ($scope.stepSelected === $scope.stepProgress - 1) {
            $scope.stepProgress = $scope.stepProgress + 1;
          }
          /** Selecionado recebe o proximo step */
          $scope.stepSelected = $scope.stepSelected + 1;
        };

        /**
         * Move o wizard para sua tela anterior
         */
        vm.moveToPreviousStep = function () {
          if ($scope.stepSelected > 0) {
            $scope.stepSelected = $scope.stepSelected - 1;
          }
          $rootScope.$emit('form-wizard-previous');
        };

        /**
         * Executa o submit do step corrente
         * @param stepData - dados para submissão
         * @param isSkip - se deve ser passado ou não
         * @param bind - dados para evento
         * @param form - dados referente ao formulário
         * @param table - dados de tabela
         * @param $index - Indice do item submitado
         */
        vm.submitCurrentStep = function (stepData, isSkip, bind, form, table, $index) {
          vm.showBusyText = true;
          bind.stepSelected = $scope.stepSelected;
          var stepAux = 0;
          if (!stepData.completed && !isSkip) {
            /** move to next step when success */
            $timeout(function () {
              vm.showBusyText = false;
              stepData.completed = true;
              vm.enableNextStep(stepData.length - 1);
              angular.element('md-step-content.md-active select:first, md-step-content.md-active input[type="text"]:first').focus();
            }, 300);
          } else {
            vm.showBusyText = false;
            vm.enableNextStep(stepData.length - 1);
          }
          $scope.submit({item: bind, form: form, table: table, wizardItem: stepData});
          /** Liberação do proximo nivel do assistente */
          if (angular.isDefined(form.items[$index + 1]) && !stepData.completed && stepAux == 0 && !isSkip) {
            form.items[$index + 1].disabled = false;
            stepAux = 1;
          }
          /** Aqui é a verificação para liberação do botão finalizar */
          angular.forEach(form.items, function (value) {
            if (angular.isDefined(value.completed) && !value.completed) {
              return false;
            } else {
              /**
               *  Como no ultimo step o stepSelected não é incrementado, então a comparação
               *  é feita com o decremento de duas unidades no total de item do array.
               */
              if (($scope.stepSelected) == (form.items.length - 2)) {
                vm.isAbleFinished = true;
              }
            }
          });
        };

        /** Função que submita o final do wizard */
        vm.wFinish = function (form) {
          $scope.finishWizard(form);
        }

      },
      controllerAs: "vm"
    }
  }

  angular.module('app.a4formdicdata')
    .directive('a4FormDicData', a4FormDicData)
})();
(function () {
  'use strict';

  function a4FormDicDataUtilsService(moment) {

    var constants = [
      'block_delete',
      'message_block_delete',
      'mode_edit',
      'hide_message'
    ];

    /**
     * Verifica se um determinado campo está na lista de remoção do objeto;
     * @param field String - Indice do objeto
     * @returns {string}
     */
    var isProhibitField = function (field) {
      return constants.find(function (value) {
        return field === value;
      });
    };

    var copy = function (obj) {
      var copy = {};
      Object.seal(obj);
      angular.forEach(obj, function (value, key) {
        copy[key] = value;
      });
      return copy;
    };

    /**
     * Realiza um clear no objeto de saida;
     * @param object - Objeto de saida
     */
    var clearObject = function (object) {
      var result = {};
      /** itera em cada atributo do objeto inicial, para realizar uma transformação de dados */
      angular.forEach(object, function (value, key) {
        if (!angular.isArray(value)) {
          /** Caso valor seja nulo, é definido um objeto vazio de saida, com seu valor original */
          if (value === null) {
            var merge = {};
            merge[key] = value;
            angular.merge(result, merge);
          } else {
            /** Caso não seja nulo, o objeto/array é iterado para que seja tratado seu resultado de saida. */
            angular.forEach(value, function (item, attr) {
              if (!angular.isArray(item) && !angular.isDate(item) && (angular.isObject(item) && angular.isDefined(item.id))) {
                value[attr] = item.id;
              } else {
                if(moment.isMoment(item)){
                  value[attr] = item.format('YYYY-MM-DD HH:mm:ss');
                } else {
                  value[attr] = item;
                }
              }
            });
            angular.merge(result, value);
          }
        } else {
          result[key] = value
        }
      });

      /** Caso exista attributos que não devam ser retornados para o submit, ele são removidos aqui */
      angular.forEach(result, function (value, key) {
        if (isProhibitField(key)) {
          delete result[key];
        }
      });

      return result;
    };

    return {
      isProhibitField: isProhibitField,
      clearObject: clearObject,
      copy: copy
    }

  }

  angular
    .module('app.a4formdicdata')
    .factory('a4FormDicDataUtilsService', a4FormDicDataUtilsService)

})();
(function () {
  "use strict";

  /** @ngInject */
  function a4FormDicDataItemService(LocalStorage) {

    return {
      /** CRIADO APENAS PARA O ASSISTENTE DE MATRICULA */
      accordion: function (form, item) {
        var field = this.system_setup(item);
        var a4FormDicDataItemService = this;
        var parent = angular.element("<md-content ng-cloak layout-padding></md-content>");
        var parentAccordion = angular.element("<v-accordion class='vAccordion--default' multiple></v-accordion>");
        var pane = angular.element("<v-pane></v-pane>");
        var paneHeader = angular.element("<v-pane-header></v-pane-header>");
        var paneBody = angular.element("<v-pane-content></v-pane-content>");
        /** Definição de header */
        pane.attr({
          'ng-repeat': "item in list." + field.table + "." + field.reference + " track by $index",
          'expanded': "item.expanded",
          'ng-disabled': "item.disabled"
        });
        paneHeader.append('<span>{{item.name}}</span><br /><small style="font-style: italic" >{{item.text_badge}}</small>');

        /** Definição de corpo do accordion */
        var div = angular.element("<div></div>");
        div.attr({
          "ng-repeat": "item in item.children track by $index"
        });
        item.stringName = true;
        item.internImplementation = true;
        div.append(a4FormDicDataItemService.check(form, item));
        paneBody.append(div);

        pane.prepend(paneHeader);
        pane.append(paneBody);
        parentAccordion.append(pane);
        parent.append(parentAccordion);
        return parent;
      },
      aggregateField: function (form, item, func) {
        var item = this.system_setup(item);
        var a4FormDicDataItemService = this;
        var table = item.fields[0].table;
        var parent =
          angular.element("<div layout='row' layout-wrap ng-init='bind." + table + ".length == 0 ? bind." + table + " = [{}] : bind." + table + "'></div>");
        var repeater =
          angular.element("<div flex='100' layout='row' ng-repeat='item in bind." + table + " track by $index' ></div>");

        /** Montagem dos campos internos */
        item.fields.forEach(function (value) {
          value.ngModel = "item." + value.reference;
          value.aggregateFlex = value.flex;
          var input = a4FormDicDataItemService[value.type](form, value, func);
          repeater.append(input);
        });

        /** VISIBLE */
        if (angular.isDefined(item.visible) && item.visible) {
          var strVisible = item.visible;

          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ !(', 'field.show = !(bind.');
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('|| ', '|| bind.');
            strVisible = strVisible.replace('}}', '');
          }
          parent.attr("ng-if", strVisible);
        }

        /** Montagem dos botoes de ação */
        var actions = angular.isUndefined(item.actions) ? true : item.actions;
        if (actions) {
          var buttonADD = angular.element("<md-button flex='5' class='md-icon-button'></md-button>");
          var del = angular.element("<md-icon md-font-icon='icon-trash'></md-icon>");
          var add = angular.element("<md-icon md-font-icon='icon-plus-circle'></md-icon>");

          buttonADD.attr({
            "name": item.name,
            "type": 'button',
            "ng-disabled": "!bind.mode_edit || $root.show_loader",
            "ng-click": "aFDIC.addItem(item, '" + table + "');"
          });
          buttonADD.append(add);
          repeater.append(buttonADD);

          var buttonDEL = angular.element("<md-button flex='5' class='md-icon-button'></md-button>");
          buttonDEL.attr({
            "name": item.name,
            "type": 'button',
            "ng-disabled": "!bind.mode_edit || $root.show_loader || $index == 0",
            "ng-click": "aFDIC.removeItem(item, $index, '" + table + "'); form_dynamic.$pristine = true;"
          });
          buttonDEL.append(del);
          repeater.append(buttonDEL);
        }

        parent.append(repeater);
        return parent;

      },
      autocomplete: function (form, field, func) {

        var field = this.system_setup(field);
        var parent = angular.element("<md-input-container md-no-float class='md-block' flex-gt-sm flex-xs flex-sm flex-md flex></md-input-container>");
        var autocomplete = angular.element("<md-autocomplete md-autofocus></md-autocomplete>");
        var a = angular.element("<a style='color:#000;'></a>");
        a.attr({
          "ng-click": "$emit('" + field.not_found_event + "', autocomplete.selected_text)"
        });
        a.append(field.not_found_event_title);

        autocomplete.attr({
          "md-no-cache": 'false',
          "md-selected-item": "bind." + field.table + "." + field.reference,
          "md-search-text": "autocomplete.selected_text",
          "md-match-case-insensitive": 'true',
          "md-items": "item in func.querySearch(autocomplete.selected_text)",
          "md-item-text": "item.name",
          "md-clear-button": 'false',
          "md-min-length": 0,
          "md-escape-options": "none",
          "md-input-name": field.name,
          "ng-disabled": "!bind.mode_edit",
          "md-search-text-change": "func.textChange(autocomplete.selected_text);",
          "md-selected-item-change": "func.itemChange(item);"
        });

        /** monta o md-item-template */
        var template = angular.element('<md-item-template></md-item-template>');
        var span = angular.element('<span class="item-title" md-highlight-text="autocomplete.selected_text"></span>');
        span.append("{{item.name}}");
        template.append(span);

        /** insere o md-not-found */
        var not_found = angular.element("<md-not-found></md-not-found>");
        not_found.append("Sem registros encontrados para {{autocomplete.selected_text}} " + field.notFoundMsgComp);
        not_found.append(a);

        /** FLEX REPEAT */
        if (angular.isDefined(field.aggregateFlex) && field.aggregateFlex) {
          parent.attr({"flex": field.aggregateFlex});
        }
        /** NGMODEL */
        if (angular.isDefined(field.ngModel) && field.ngModel) {
          autocomplete.attr({"md-selected-item": field.ngModel});
        }
        /** PLACEHOLDER */
        if (angular.isDefined(field.placeholder) && field.placeholder) {
          autocomplete.attr("placeholder", field.placeholder);
        }
        /** MD-DELAY */
        if (angular.isDefined(field.mdDelay) && field.mdDelay) {
          autocomplete.attr("md-delay", field.mdDelay);
        }
        /** floating-label */
        if (angular.isDefined(field.mdFloatingLabel) && field.mdFloatingLabel) {
          autocomplete.attr("md-floating-label", field.mdFloatingLabel);
        }
        /** VISIBLE */
        if (angular.isDefined(field.visible) && field.visible) {
          var strVisible = field.visible;

          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('|| ', '|| bind.');
            strVisible = strVisible.replace('}}', '');
          }
          parent.attr("ng-if", strVisible);
        }

        autocomplete.append(template);
        autocomplete.append(not_found);
        parent.append(autocomplete);
        return parent;

      },
      boolean: function (form, field) {

        var field = this.system_setup(field);
        var parent = angular.element("<div class='md-block' flex-gt-sm flex-xs flex-sm flex-md flex></div>");
        var boolean = angular.element("<md-switch></md-switch>");

        boolean.attr({
          "name": field.name,
          "aria-label": field.placeholder,
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-disabled": "!bind.mode_edit || $root.show_loader"
        });

        /** NGMODEL */
        if (angular.isDefined(field.ngModel) && field.ngModel) {
          boolean.attr({"ng-model": field.ngModel});
        }
        /** REQUIRED */
        if (angular.isDefined(field.disabled) && field.disabled) {
          boolean.attr("ng-disabled", true);
        }
        /** VISIBLE */
        if (angular.isDefined(field.visible) && field.visible) {
          var strVisible = field.visible;

          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('|| ', '|| bind.');
            strVisible = strVisible.replace('}}', '');
          }
          parent.attr("ng-if", strVisible);
        }

        boolean.append(field.placeholder);
        parent.append(boolean);
        return parent;

      },
      check: function (form, field) {

        var field = this.system_setup(field);
        var parent = angular.element("<md-content  flex-gt-sm flex-xs flex-sm flex-md flex></md-content>");
        if (angular.isDefined(field.class) && field.class) {
          parent.addClass(field.class);
        }

        var checkbox = angular.element("<md-checkbox></md-checkbox>")
        checkbox.attr({
          "name": field.name,
          "aria-label": field.placeholder,
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-disabled": "!bind.mode_edit || $root.show_loader"
        });
        if (angular.isDefined(field.class) && field.class) {
          checkbox.addClass(field.class);
        }

        /** NGMODEL */
        if (angular.isDefined(field.ngModel) && field.ngModel) {
          checkbox.attr({"ng-model": field.ngModel});
        }
        /** REQUIRED */
        if (angular.isDefined(field.disabled) && field.disabled) {
          checkbox.attr("ng-disabled", true);
        }

        /** NG-CLICK */
        if (angular.isDefined(field.ngClick) && field.ngClick) {
          if (angular.isDefined(field.internImplementation) && field.internImplementation) {
            checkbox.attr('ng-init', 'item.checked = false');
            checkbox.attr('ng-model', 'item.checked');
            checkbox.attr('ng-disabled', 'item.disabled');
            checkbox.attr('ng-click', '$emit("' + field.checked_event + '", item);');
          } else {
            checkbox.attr("ng-click", '$emit("' + field.checked_event + '", bind.' + field.table + "." + field.reference + ');');
          }
        }
        /** VISIBLE */
        if (angular.isDefined(field.visible) && field.visible) {
          var strVisible = field.visible;

          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('|| ', '|| bind.');
            strVisible = strVisible.replace('}}', '');
          }
          parent.attr("ng-if", strVisible);
        }
        /** Caso queira que o nome do checkbox venha atravez do objeto de iteração */
        if (angular.isDefined(field.stringName) && field.stringName) {
          checkbox.append("{{item.name}}");
        } else {
          checkbox.append(field.placeholder);
        }
        parent.append(checkbox);
        return parent;

      },
      date: function (form, field) {

        var datepicker = angular.element("<date-picker is-gerador='true'></date-picker>");

        datepicker.attr({
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-disabled": "!bind.mode_edit || $root.show_loader"
        });

        if (angular.isDefined(field.isMinDate) && field.isMinDate) {
          datepicker.attr({
            "min-date": "list." + field.table + ".min_date"
          });
        }


        /** NGMODEL */
        if (angular.isDefined(field.ngModel) && field.ngModel) {
          datepicker.attr({"ng-model": field.ngModel});
          datepicker.attr({"ng-init": field.ngModel});
        }
        /** REQUIRED */
        if (angular.isDefined(field.required) && field.required) {
          // datepicker.attr("ng-required", field.required);
        }

        /** PLACEHOLDER */
        if (angular.isDefined(field.placeholder) && field.placeholder) {
          datepicker.attr("placeholder", field.placeholder);
        }
        /** LABEL */
        if (angular.isDefined(field.label) && field.label) {
          datepicker.attr("label", field.label);
        }
        /** VISIBLE */
        if (angular.isDefined(field.visible) && field.visible) {
          var strVisible = field.visible;

          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('|| ', '|| bind.');
            strVisible = strVisible.replace('}}', '');
          }
          datepicker.attr("ng-if", strVisible);
        }

        return datepicker;
      },
      grid_list: function (form, field) {
        var field = this.system_setup(field);
        var a4FormDicDataItemService = this;
        var parent = angular.element("<md-content ng-cloak layout-padding></md-content>");
        parent.attr({
          "style": angular.isDefined(field.style) ? field.style : "height: 425px;padding-top: 0px;"
        });

        var searchInput = angular.element("<input ng-model='searchGridList' name='search_in_grid' style='width: 100%;' />");
        var progress = angular.element("<md-progress-circular md-mode='indeterminate'></md-progress-circular>");
        progress.attr({
          'md-diameter': '20px',
          'style': 'position: absolute;right: 20px; top: 10px;',
          'ng-show': '$root.show_loader'
        });

        var add_option = angular.element('<span class="search-event"><md-icon md-font-icon="icon-plus-circle"></md-icon></span>');
        add_option.attr({
          "ng-if": "searchGridList",
          'style': 'right: 7px; top: 7px;',
          "ng-click": '$emit("' + field.add_item_event + '", searchGridList, bind);'
        });

        if (angular.isDefined(field.search_event) && field.search_event) {
          searchInput.attr({
            "ng-change": '$emit("' + field.search_event + '", searchGridList, bind);',
            "ng-model-options": "{debounce: 500}"
          });
        }

        searchInput.attr('placeholder', angular.isDefined(field.placeholder) ? field.placeholder : 'Procurar...');
        var mdGridList = angular.element("<md-grid-list></md-grid-list>");
        var mdGridTile = angular.element("<md-grid-tile md-ink-ripple='#888888' ></md-grid-tile>");
        var mdGridTileFooter = angular.element("<md-grid-tile-footer></md-grid-tile-footer>");

        mdGridList.attr({
          "md-cols-gt-md": angular.isDefined(field.mdColsGtMd) ? field.mdColsGtMd : "12",
          "md-cols": angular.isDefined(field.mdCols) ? field.mdCols : "1",
          "md-cols-md": angular.isDefined(field.mdColsMd) ? field.mdColsMd : "8",
          "md-row-height-gt-md": angular.isDefined(field.mdRowHeightGtMd) ? field.mdRowHeightGtMd : "1:1",
          "md-row-height": angular.isDefined(field.mdRowHeight) ? field.mdRowHeight : "fit",
          "md-gutter-gt-md": angular.isDefined(field.mdGutterGtMd) ? field.mdGutterGtMd : "16px",
          "md-gutter-md": angular.isDefined(field.mdGutterMd) ? field.mdGutterMd : "8px",
          "md-gutter": angular.isDefined(field.mdGutter) ? field.mdGutter : "1px"
        });

        /** Determina os valores de cor padrão do grid list */
        if (angular.isUndefined(field.itemColor)) {
          field.itemColor = "white";
          field.textColor = "black";
        }

        mdGridTile.attr({
          "flex": '100',
          "ng-repeat": "item in list." + field.table + "." + field.reference + " track by $index",
          "ng-style": "{'background': " + field.itemColor + ", 'cursor': 'pointer'}",
          "md-colspan-gt-sm": "{{angular.isDefined(item.colspan) ? item.colspan : 12}}",
          "md-rowspan-gt-sm": "{{angular.isDefined(item.rowspan) ? item.rowspan : 1}}"
        });

        if (angular.isDefined(field.click_event) && field.click_event) {
          mdGridTile.attr({
            "ng-click": '$emit("' + field.click_event + '", item, bind);'
          });
        }

        if (angular.isDefined(field.mdGridTileFooter) && field.mdGridTileFooter) {
          mdGridTileFooter.append('<h4><md-truncate>{{item.name}}</md-truncate></h4>');
          mdGridTile.append(mdGridTileFooter);
        } else {
          if (angular.isDefined(field.accordion) && field.accordion) {
            var accordion = a4FormDicDataItemService.accordion(form, field);
            mdGridList.append(accordion);
          } else {
            mdGridTile.append('<h4><md-truncate style="color: ' + field.textColor + '">{{item.name}}</md-truncate></h4>');
            mdGridList.append(mdGridTile);
          }
        }
        parent.prepend(searchInput);
        parent.prepend(progress);
        if (angular.isDefined(field.add_item_event) && field.add_item_event) {
          parent.prepend(add_option);
        }
        parent.append(mdGridList);

        return parent;

      },
      time: function (form, field) {

        var field = this.system_setup(field);
        var parent = angular.element("<md-input-container md-no-float class='md-input-has-placeholder' flex-gt-sm flex-xs flex-sm flex-md flex><label>" + field.placeholder + "</label></md-input-container>");
        var icon = angular.element("<md-icon>access_time</md-icon>");
        var input = angular.element("<input/>");

        input.attr({
          "type": "time",
          "name": field.name,
          "value": field.value,
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-disabled": "!bind.mode_edit || $root.show_loader"
        });

        /** NGMODEL */
        if (angular.isDefined(field.ngModel) && field.ngModel) {
          input.attr({"ng-model": field.ngModel});
          input.attr({"ng-init": field.ngModel});
        }

        /** REQUIRED */
        if (angular.isDefined(field.required) && field.required) {
          input.attr("required", true);
        }

        parent.append(icon);
        parent.append(input);
        return parent;
      },
      input: function (form, field) {
        var field = this.system_setup(field);

        var parent = angular.element("<md-input-container style='margin: 10px 0 !important;' class='md-block md-input-has-placeholder' flex-gt-sm flex-xs flex-sm flex-md flex><label>" + field.label + "</label></md-input-container>");
        var input = angular.element("<input />");
        input.attr({
          "name": field.name,
          "type": "text",
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-init": "bind." + field.table + "." + field.reference + " = '" + angular.isUndefined(field.default) ? '' : field.default + "'",
          "ng-disabled": "!bind.mode_edit || $root.show_loader"
        });

        if (angular.isDefined(field.disabled) && field.disabled) {
          input.attr("ng-disabled", field.disabled)
        }

        /** Máscara */
        if (angular.isDefined(field.mask)) {
          input.attr(field.mask, field.mask);
          /** Número de casas decimais*/
          if ((field.mask === "ui-number-mask" || field.mask === "ui-percentage-mask" || field.mask === "ui-money-mask") && angular.isDefined(field.mask_option.decimal)) {
            input.attr(field.mask, field.mask_option.decimal);
          }
          if (field.mask === "ui-number-mask") {
            /** Numero negativo */
            if (angular.isDefined(field.mask_option.negative)) input.attr(field.mask_option.negative, field.mask_option.negative);
            /** Para esconder os separadores de milhares*/
            if (angular.isDefined(field.mask_option.hide_group_dep)) input.attr(field.mask_option.hide_group_dep, field.mask_option.hide_group_dep)
          }
          if (field.mask === "ui-date-mask") {
            if (angular.isDefined(field.mask_option.date_mask)) input.attr(field.mask, field.mask_option.date_mask);
          }

          if (field.mask === "ui-time-mask") {
            if (angular.isDefined(field.mask_option.time_mask)) input.attr(field.mask, field.mask_option.time_mask);
          }
        }

        /** NGMODEL */
        if (angular.isDefined(field.ngModel) && field.ngModel) {
          input.attr({"ng-model": field.ngModel});
        }

        /** STYLE */
        if (angular.isDefined(field.style) && field.style) {
          input.attr({"style": field.style});
        }

        /** NGBLUR */
        if (angular.isDefined(field.ngBlurEvent) && field.ngBlurEvent) {
          input.attr({"ng-blur": '$emit("' + field.ngBlurEvent + '", bind.' + field.table + "." + field.reference + '); ngBlur = true;'});
        }

        /** EVENT REQUEST */
        if (angular.isDefined(field.ngBlurEvent) && field.ngBlurEvent) {
          parent.attr({"ng-init": "ngBlur = false;"});
          parent.append("<md-progress-circular ng-if='ngBlur' ng-show='$root.show_loader' class='md-hue-2 ngEventField' md-diameter='15px'></md-progress-circular>");
        }

        /** MINLENGTH */
        if (angular.isDefined(field.minlength) && field.minlength) {
          input.attr({"md-minlength": field.minlength});
        }
        /** MAXLENGTH */
        if (angular.isDefined(field.maxlength) && field.maxlength) {
          input.attr("md-maxlength", field.maxlength);
        }

        /** REQUIRED */
        if (angular.isDefined(field.required) && field.required) {
          var strRequired = field.required;

          if (angular.isString(strRequired)) {
            strRequired = strRequired.replace('{{ (', '(bind.');
            strRequired = strRequired.replace('&& ', '&& bind.');
            strRequired = strRequired.replace('|| ', '|| bind.');
            strRequired = strRequired.replace('}}', '');
          }

          input.attr("ng-required", strRequired);
        }
        /** PATTERN */
        if (angular.isDefined(field.pattern) && field.pattern) {
          input.attr("ng-pattern", field.pattern);
        }
        /** FLEX REPEAT */
        if (angular.isDefined(field.aggregateFlex) && field.aggregateFlex) {
          parent.attr({"flex": field.aggregateFlex});
        }
        /** PLACEHOLDER */
        if (angular.isDefined(field.placeholder) && field.placeholder) {
          input.attr("placeholder", field.placeholder);
        } else {
          if (angular.isDefined(field.required) && !field.required) {
            input.attr("placeholder", '(Opcional)');
          }
        }
        /** VISIBLE */
        if (angular.isDefined(field.visible) && field.visible) {
          var strVisible = field.visible;

          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('}}', '');
          }
          parent.attr("ng-if", strVisible);
        }
        /** MESSAGES */
        if (angular.isDefined(field.messages) && field.messages) {
          var messages = this.messages(form, field);
          parent.append(messages);
        }

        parent.append(input);
        return parent;

      },
      input_search: function (form, field) {
        var field = this.system_setup(field);

        var parent = angular.element("<md-input-container md-no-float class='md-block md-input-has-placeholder' flex-gt-sm flex-xs flex-sm flex-md flex><label>" + field.label + "</label></md-input-container>");

        var parent_1 = angular.element("<div class='select-static' flex><label>" + field.label + "</label></div>");

        var label = angular.element("<div class='select-option'></div>");

        var p = angular.element("<p class='select-name'> </p>");

        p.append("{{bind." + field.table + "." + field.show_name + "}}");
        label.append(p);

        var parent_2 = angular.element("<div class='select-mask' flex></div>");

        var select = angular.element("<md-select aria-label='" + field.table + "" + field.reference + "' />");
        select.attr({
          "name": field.name,
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-disabled": "!bind.mode_edit || $root.show_loader",
          "ng-change": "bind." + field.table + "." + field.show_name + " = bind." + field.table + "." + field.reference + ".name;"
        });

        var header = angular.element("<md-select-header class='demo-select-header'></md-select-header>");
        var input_search = angular.element("<input>");
        input_search.attr({
          "ng-model": "bind." + field.table + ".search.$index",
          "type": "search",
          "placeholder": "Buscar por " + field.placeholder,
          "ng-model-options": "{ debounce: 500 }",
          "class": "demo-header-searchbox md-text",
          "ng-keydown": "$event.stopPropagation();"
        });

        /** Input search change */
        if (angular.isDefined(field.event) && field.event) {
          input_search.attr({"ng-change": '$emit("' + field.event + '", bind.' + field.table + ".search.$index);"});
        }

        header.append(input_search);
        select.append(header);

        /** REQUIRED */
        if (angular.isDefined(field.required) && field.required) {
          select.attr("required", true);
        }
        /** VISIBLE */
        if (angular.isDefined(field.visible) && field.visible) {
          var strVisible = field.visible;
          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('|| ', '|| bind.');
            strVisible = strVisible.replace('}}', '');
          }
          parent.attr("ng-if", strVisible);
        }

        var add_option = angular.element('<span class="search-event"><md-icon md-font-icon="icon-plus-circle"></md-icon></span>');
        add_option.attr({
          "ng-if": "bind." + field.table + ".search.$index",
          "ng-click": '$emit("' + field.search_event + '", bind.' + field.table + ".search.$index" + ', bind);'
        });
        select.append(add_option);
        var option = angular.element('<md-option>');
        option.attr({
          "ng-value": "item",
          "ng-repeat": "item in list." + field.table + "." + field.reference + " track by $index | filter: bind." + field.table + ".search.$index",
          "ng-disabled": "item.disabled"
        });

        option.append("{{item.name}}");

        parent_1.append(label);
        select.append(option);
        parent_2.append(select);
        parent_1.append(parent_2);
        parent.append(parent_1);
        //if(angular.is_defined)


        return parent;
      },
      radio: function (form, field) {
        var field = this.system_setup(field);
        var parent = angular.element("<div class='md-block' flex-gt-sm flex-xs flex-sm flex-md flex><label ng-if='field.label'>{{field.label}}</label></div>");
        var radio = angular.element("<md-radio-group/>");

        var tooltip = angular.element("<md-tooltip></md-tooltip>");

        radio.attr({
          "name": field.name,
          "aria-label": field.name,
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-init": "bind." + field.table + ".selected = " + field.default,
          "ng-disabled": "!bind.mode_edit || $root.show_loader",
          "layout": angular.isDefined(field.layout) ? field.layout : "column"
        });
        var option = angular.element('<md-radio-button>');
        option.attr({
          "value": "{{item.id}}",
          "ng-repeat": "item in list." + field.table + "." + field.reference + " track by $index"
        });
        option.append("{{item.name}}");

        if (angular.isDefined(field.tooltip) && field.tooltip.show) {
          tooltip.attr({
            "md-direction": "{{field.tooltip.direction}}"
          });
          tooltip.append("{{item.description}}");
          option.append(tooltip);
        }

        /** NG-CLICK */
        if (angular.isDefined(field.ngClick) && field.ngClick) {
          if (angular.isDefined(field.internImplementation) && field.internImplementation) {
            option.attr('ng-init', 'item.checked = false');
            option.attr('ng-model', 'item.checked');
            option.attr('ng-click', '$emit("' + field.checked_event + '", item, item);');
          } else {
            option.attr("ng-click", '$emit("' + field.checked_event + '", bind.' + field.table + "." + field.reference + ', bind);');
          }
        }
        /** NGMODEL */
        if (angular.isDefined(field.ngModel) && field.ngModel) {
          radio.attr({"ng-model": field.ngModel});
          radio.attr({"ng-init": field.ngModel});
        }

        /** REQUIRED */
        if (angular.isDefined(field.required) && field.required) {
          radio.attr("required", true);
        }
        /** VISIBLE */
        if (angular.isDefined(field.visible) && field.visible) {
          var strVisible = field.visible;

          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('|| ', '|| bind.');
            strVisible = strVisible.replace('}}', '');
          }
          parent.attr("ng-if", strVisible);
        }

        radio.append(option);
        parent.append(radio);
        return parent;

      },
      select: function (form, field) {

        var field = this.system_setup(field);
        var parent = angular.element("<md-input-container style='margin: 10px 0 !important;'  md-no-float class='md-block md-input-has-placeholder' flex-gt-sm flex-xs flex-sm flex-md flex><label>" + field.label + "</label></md-input-container>");
        var select = angular.element("<md-select aria-label='" + field.table + "" + field.reference + "' />");
        var label = angular.element("<label class='label-select'></label>");

        if (angular.isDefined(field.class) && field.class) {
          parent.addClass(field.class);
        }

        select.attr({
          "name": field.name,
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-disabled": "(!bind.mode_edit || $root.show_loader)",
          "ng-change": "changeValue = false;"
        });

        if (field.disabled) {
          select.attr({
            "ng-disabled": field.disabled
          });
        }

        if (angular.isDefined(field.multiple) && field.multiple) {
          select.attr({"multiple": field.multiple})
        }

        var select_header = angular.element('<md-select-header></md-select-header>');
        select_header.attr({
          "class": "demo-select-header"
        });

        var add_option = angular.element('<span class="search-event"><md-icon md-font-icon="icon-plus-circle"></md-icon></span>');
        add_option.attr({
          "ng-if": "bind." + field.table + ".search.$index",
          "ng-click": '$emit("' + field.search_event + '", bind.' + field.table + ".search.$index" + ', bind);'
        });

        var input_search = angular.element('<input flex="85">');
        input_search.attr({
          "ng-model": "bind." + field.table + ".search.$index",
          "type": "search",
          "placeholder": "Buscar por " + field.placeholder,
          "ng-model-options": "{ debounce: 500 }",
          "class": "demo-header-searchbox md-text",
          "ng-keydown": "$event.stopPropagation();"
        });

        /** onKeyDown */
        if (angular.isDefined(field.onKeyDown) && field.onKeyDown) {
          input_search.attr({"ng-keydown": '$event.stopPropagation(); $emit("' + field.onKeyDown + '", bind.' + field.table + ".search.$index" + '); changeValue = true;'});
        }

        /** Input search change */
        if (angular.isDefined(field.searchChange) && field.searchChange) {
          input_search.attr({"ng-change": '$emit("' + field.searchChange + '", bind.' + field.table + ".search.$index);"});
        }

        /** Event Request */
        if (angular.isDefined(field.event) && field.event) {
          parent.attr({"ng-init": "changeValue = true;"});
          parent.append("<md-progress-circular ng-if='changeValue' ng-show='$root.show_loader' class='md-hue-2 ngEventField ngEventSelect' md-diameter='15px'></md-progress-circular>");
        }

        var option = angular.element('<md-option>');
        option.attr({
          "ng-value": "item.id",
          "ng-repeat": "item in list." + field.table + "." + field.reference + " | filter: bind." + field.table + ".search.$index",
          "ng-disabled": "item.disabled"
        });

        option.append("{{item.name}} <span class='badge text-right'>{{item.text_badge}}</span>");

        /** NGMODEL */
        if (angular.isDefined(field.ngModel) && field.ngModel) {
          select.attr({"ng-model": field.ngModel});
          select.attr({"ng-init": field.ngModel});
        }
        /** Emissão de evento na troca de valores */
        if (angular.isDefined(field.event) && field.event) {
          select.attr("ng-change", '$emit("' + field.event + '", bind.' + field.table + "." + field.reference + '|| item.id )');
        }
        /** MINLENGTH */
        if (angular.isDefined(field.minlength) && field.minlength) {
          select.attr({"md-minlength": field.minlength});
        }
        /** MAXLENGTH */
        if (angular.isDefined(field.maxlength) && field.maxlength) {
          select.attr("md-maxlength", field.maxlength);
        }
        /** REQUIRED */
        if (angular.isDefined(field.required) && field.required) {
          select.attr("required", true);
        }
        /** VISIBLE */
        if (angular.isDefined(field.visible) && field.visible) {
          var strVisible = field.visible;
          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('|| ', '|| bind.');
            strVisible = strVisible.replace('}}', '');
          }
          parent.attr("ng-if", strVisible);
        }
        /** MESSAGES */
        if (angular.isDefined(field.messages) && field.messages) {
          var messages = this.messages(form, field);
          parent.append(messages);
        }
        /** Exibe a opção de busca */
        if (angular.isDefined(field.search) && field.search) {
          select.attr({
            "md-on-close": "bind." + field.table + ".search.$index = ''"
          });
          select_header.append(input_search);
          select.append(select_header);
        }
        /** Exibe a opção de adicionar evento ao lado da busca */
        if (angular.isDefined(field.search_event) && field.search_event) {
          select.append(add_option);
        }

        parent.append(label);
        select.append(option);
        parent.append(select);
        return parent;

      },
      select_group: function (form, field) {
        var field = this.system_setup(field);

        var parent = angular.element("<md-input-container md-no-float class='md-block md-input-has-placeholder' flex-gt-sm flex-xs flex-sm flex-md flex><label>" + field.label + "</label></md-input-container>");

        var label = angular.element("<label></label>");

        var select = angular.element('<md-select aria-label="' + field.table + '' + field.reference + '" ng-change="$emit(' + field.event + ', bind.' + field.table + '.' + field.reference + ')"></md-select>'
        );
        select.attr({
          "name": field.name,
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-disabled": "!bind.mode_edit || $root.show_loader"
        });

        var optgroup = angular.element('<md-optgroup></md-optgroup>');
        optgroup.attr({
          "label": "{{currentGroup}}",
          "ng-repeat": "currentGroup in list." + field.table + "." + field.groups + " track by $index"
        });

        var option = angular.element('<md-option></md-option>');
        option.attr({
          "ng-value": "item.id",
          "ng-repeat": "item in list." + field.table + "." + field.reference + " track by $index | filter: {" + field.filter + ": currentGroup}"
        });
        option.append("{{item.group_name}}");

        /** Emissão de evento na troca de valores */
        if (angular.isDefined(field.event) && field.event) {
          select.attr("ng-change", '$emit("' + field.event + '", bind.' + field.table + "." + field.reference + ')');
        }

        optgroup.append(option);
        select.append(optgroup);
        parent.append(label);
        parent.append(select);
        return parent;
      },
      /** CRIADO APENAS PARA O ASSISTENTE DE MATRICULA */
      schedule_table: function (form, field) {
        var field = this.system_setup(field);
        var daysOfWeek = [
          {id: 1, name: 'Seg'}, {id: 2, name: 'Ter'}, {id: 3, name: 'Qua'},
          {id: 4, name: 'Qui'}, {id: 5, name: 'Sex'}, {id: 6, name: 'Sab'}
        ];

        var parent = angular.element("<md-content flex-gt-sm flex-xs flex-sm flex-md flex></md-content>");
        var table = angular.element("<table class='simple school-records'></table>");
        var thead = angular.element("<thead></thead>");
        var tbody = angular.element("<tbody></tbody>");
        var header = angular.element("<tr></tr>");


        /** Espaço para mensagens */
        var card = angular.element('<md-card style="box-shadow: none;background-color: #ffe3a3;margin: 0;" ></md-card>');
        card.attr({
          "ng-init": "bind." + field.table + ".hide_message = true",
          "ng-hide": "bind." + field.table + ".hide_message == true"
        });
        var cardHeader = angular.element('<md-card-header></md-card-header>');
        var cardHeaderText = angular.element('<md-card-header-text></md-card-header-text>');
        var closeButton = angular.element('<md-button class="md-icon-button" ><md-icon md-font-icon="icon-close"></md-icon></md-button>');
        closeButton.attr({
          "ng-click": "bind." + field.table + ".hide_message = true",
          "style": "margin: 0;padding: 0;min-height: 20px !important;height: 20px;"
        });
        var cardHeaderTextSubTitle = angular.element('<span class="md-subhead" id="alert-card-schedule-subheader">Idem</span>');

        cardHeaderText.prepend(cardHeaderTextSubTitle);
        cardHeader.append(cardHeaderText);
        cardHeader.append(closeButton);
        card.prepend(cardHeader);


        /** Definição do cabeçalio da tabela */
        daysOfWeek.forEach(function (item, key) {
          /** adiciona uma posição no começo da tabela para realizar a interseção dos eixos x e y */
          if (key == 0) {
            var menuid = angular.element("<th></th>");
            header.append(menuid);
          }
          var headerMenu = angular.element("<th>" + item.name + "</th>");
          header.append(headerMenu);
        });

        /** Definição do corpo da tabela */
        var body = angular.element("<tr></tr>");
        body.attr({
          "name": field.name,
          "ng-repeat": "item in bind." + field.table + "." + field.reference + " track by $index"
        });

        var schedule_cel = angular.element("<td  style='text-align: center' id='0_0'>{{item.initial_time + ' - ' + item.final_time}}</td>");
        /** Definição das celulas dos dias das semanas */
        var subject_cel = angular.element("<td  style='text-align: center' >{{sub.alias}}</td>");
        subject_cel.attr({
          "ng-repeat": "sub in item.schedule_subject track by $index | orderBy:'day_of_week'",
          "id": '{{sub.day_of_week}}_{{item.id}}'
        });


        body.append(schedule_cel);
        body.append(subject_cel);

        tbody.append(body);
        table.append(tbody);

        thead.prepend(header);
        table.prepend(thead);

        parent.prepend(table);
        parent.append(card);

        return parent;

      },
      /** END CRIADO APENAS PARA O ASSISTENTE DE MATRICULA */
      list: function (form, field) {

        var field = this.system_setup(field);
        var a4FormDicDataItemService = this;
        /** Declaração de elementos em html */
        var parent = angular.element("<md-content ng-cloak></md-content>");
        var mdList = angular.element("<md-list flex ></md-list>");
        var mdListItem = angular.element("<md-list-item ></md-list-item>");
        var mdSubHeader = angular.element("<md-subheader class='md-primary'>" + field.textSubHeader + "</md-subheader>");
        //var h3 = angular.element("<h3 flex>{{item.name}}</h3>");

        /** Inserção de botão em cada linha do item da lista; */
        if (angular.isDefined(field.hasButton) && field.hasButton) {
          var buttonIcon = angular.element("<md-button><md-icon md-font-icon='icon-close'> </md-icon></md-button>");
          buttonIcon.attr({
            'class': 'md-icon-button',
            'ng-click': '$emit("' + field.buttonClickEvent + '", item);'
          });
        }

        /** Inserção de botão em cada linha do item da lista; */
        if (angular.isDefined(field.hasButtonAdd) && field.hasButtonAdd) {
          var buttonIconAdd = angular.element("<md-button style='float: right; position: relative; top: -20px !important;'><md-icon md-font-icon='icon-plus'> </md-icon></md-button>");
          buttonIconAdd.attr({
            'class': 'md-icon-button',
            'layout-align': 'end center',
            'ng-click': '$emit("' + field.buttonClickEventAdd + '", item);'
          });
        }

        /** Inserção de parametros dinamicos aos htmls */
        parent.attr({
          "style": angular.isDefined(field.style) ? field.style : "height: 425px"
        });

        /** Essa class desabilita o comportamento de botão do item da lista */
        if (angular.isDefined(field.mdNoProxy) && field.mdNoProxy) {
          mdListItem.addClass('md-no-proxy');
        }

        mdListItem.attr({
          "ng-repeat": "item in bind." + field.table + "." + field.reference + " track by $index"
        });

        //if (angular.isDefined())
        //mdListItem.append(h3);
        /** Montagem dos campos internos */
        field.fields.forEach(function (value) {
          value.ngModel = "item." + value.reference;
          var input = a4FormDicDataItemService[value.type](form, value);
          mdListItem.append(input);
        });

        mdSubHeader.append(buttonIconAdd);
        mdListItem.append(buttonIcon);

        mdList.append(mdListItem);
        parent.prepend(mdSubHeader);
        parent.append(mdList);

        return parent;
      },
      textarea: function (form, field) {

        var field = this.system_setup(field);
        var parent = angular.element("<md-input-container style='margin: 10px 0 !important;' md-no-float ng-init='bind." + field.table + "." + field.reference + " = " + field.default + "' class='md-block md-input-has-placeholder' flex-gt-sm flex-xs flex-sm flex-md flex><label>" + field.label + "</label></md-input-container>");
        var input = angular.element("<textarea />");
        input.attr({
          "name": field.name,
          "type": "text",
          "value": field.default,
          "ng-model": "bind." + field.table + "." + field.reference,
          "ng-disabled": "!bind.mode_edit || $root.show_loader"
        });

        /** NGMODEL */
        if (angular.isDefined(field.ngModel) && field.ngModel) {
          input.attr({"ng-model": field.ngModel});
          input.attr({"ng-init": field.ngModel});
        }
        /** MINLENGTH */
        if (angular.isDefined(field.minlength) && field.minlength) {
          input.attr({"md-minlength": field.minlength});
        }
        /** MAXLENGTH */
        if (angular.isDefined(field.maxlength) && field.maxlength) {
          input.attr("md-maxlength", field.maxlength);
        }
        /** REQUIRED */
        if (angular.isDefined(field.required) && field.required) {
          input.attr("required", true);
        }
        /** FLEX REPEAT */
        if (angular.isDefined(field.aggregateFlex) && field.aggregateFlex) {
          parent.attr({"flex": field.aggregateFlex});
        }
        /** PLACEHOLDER */
        if (angular.isDefined(field.placeholder) && field.placeholder) {
          input.attr("placeholder", field.placeholder);
        } else {
          if (angular.isDefined(field.required) && !field.required) {
            input.attr("placeholder", '(Opcional)');
          }
        }
        /** VISIBLE */
        if (angular.isDefined(field.visible) && field.visible) {
          var strVisible = field.visible;
          if (angular.isString(strVisible)) {
            strVisible = strVisible.replace('{{ (', 'field.show = (bind.');
            strVisible = strVisible.replace('&& ', '&& bind.');
            strVisible = strVisible.replace('|| ', '|| bind.');
            strVisible = strVisible.replace('}}', '');
          }
          parent.attr("ng-if", strVisible);
        }
        /** MESSAGES */
        if (angular.isDefined(field.messages) && field.messages) {
          var messages = this.messages(form, field);
          parent.append(messages);
        }


        parent.append(input);
        return parent;

      },
      messages: function (form, field) {

        var messages;
        var parent = angular.element('<div></div>');

        if (field.messages.hasOwnProperty('required')) {
          messages = '<div ng-show="form_dynamic.' + field.name + '.$error.required">' + field.messages.required + '</div>';
        }
        parent.append(messages);


        //var required = angular.element("<div ng-message='required' >" + field.messages.required + "</div>");
        // var max = angular.element("<div ng-message='md-minlength' >" + field.messages.minlength + "</div>");
        // var min = angular.element("<div ng-message='md-maxlength' >" + field.messages.maxlength + "</div>");
        //parent.append(required);
        // parent.append(max);
        // parent.append(min);
        return parent;

      },
      system_setup: function (field) {
        for (var key in field) {
          var setupField = field[key];
          if (typeof (setupField) === 'string' && setupField.indexOf("@conf.") >= 0) {
            var arParts = setupField.match(/@(.*?)#/g), i = 0, item;
            while (item = arParts[i++]) {
              var nameValue = item.split('@conf.').pop().split('#').shift();
              var access = "LocalStorage.get('system_setup')[0][0]";
              var final = eval(access + '.' + nameValue);
              field[key] = setupField.replace(item, final);
            }
          }
        }

        return field;
      }
    }

  }

  angular.module("app.a4formdicdata")
    .factory("a4FormDicDataItemService", a4FormDicDataItemService);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4FormDicDataItem($compile, $rootScope, Restangular) {
    return {
      restrict: 'E',
      scope: {
        field: "=",
        form: "=",
        bind: "=",
        list: "="
      },
      controller: 'a4FormDicDataItemController',
      controllerAs: 'aFDIC',
      link: function (scope, element, attrs, a4FormDicDataItemController) {
        var AUTO_COMPLETE = 'autocomplete';
        scope.simulateQuery = false;
        scope.func = {};
        scope.form.disabled = true;

        var ltn1 = $rootScope.$on('add.field.list', function () {
          scope.form.disabled = false;
        });

        /**
         * Em caso de campo do tipo autocomplete ele realiza a inicialização de algumas funções necessárias para
         * o funcionamento do autocomplete.
         */
        if (angular.isDefined(scope.field) && scope.field.type === AUTO_COMPLETE) {
          var table = scope.field.table;
          var field = scope.field.reference;
          var autocompleteSelected = scope.bind[table][field];
          var autocompleteList = scope.list[table][field];

          /**
           * Modificação de texto no autocomplete
           * @param data
           */
          scope.func.itemChange = function (data) {
            if (!angular.isNumber(data))
              $rootScope.$broadcast(table + '-' + field + '-' + 'autocomplete-item-change', data);
          };

          /**
           * Modificação de texto no autocomplete
           * @param data
           */
          scope.func.textChange = function (data) {
            $rootScope.$broadcast(table + '-' + field + '-' + 'autocomplete-text-change', data);
          };

          scope.func.querySearch = function (query) {
            /** Caso seja definido um ajax para o campo de autocomplete */
            if (angular.isDefined(scope.field.urlAjax) && scope.field.urlAjax !== null) {
              return Restangular.one(scope.field.urlAjax).get({query: query});
            }
            /** Caso não seja definida uma busca ajax, irá acontecer a busca na propria lista */
            autocompleteList = scope.list[table][field];
            autocompleteList.map(function (repo) {
              repo.value = repo.name.toLowerCase();
              return repo;
            });
            return query ? autocompleteList.filter(scope.func.createFilterFor(query)) : autocompleteList;
          };

          scope.func.createFilterFor = function (query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
              return item.value.indexOf(lowercaseQuery) === 0;
            };
          };

          angular.forEach(autocompleteList, function (item) {
            if (item.id === autocompleteSelected) {
              autocompleteSelected = item.name;
            }
          });

        }

        /**
         * Renderização dos campos no html, dinâmicamente.
         */
        a4FormDicDataItemController.fields(scope.field, scope.form, scope.func)
          .then(function (html) {
            if (html !== "") {
              var template = angular.element(html);
              element.html(template);
              $compile(element.contents())(scope);
            }
          });

        scope.$on('$destroy', function () {
          [ltn1].forEach(function (fn) {
            fn();
          })
        });

      }
    }
  }

  angular.module('app.a4formdicdata')
    .directive('a4FormDicDataItem', a4FormDicDataItem)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4FormDicDataItemController($q, a4FormDicDataItemService, $scope, $rootScope) {
    var vm = this;
    vm.fields = function (field, form, func) {
      var deferred = $q.defer();
      switch (field.type) {
        case "aggregate_field": // Aggregate_field - Campos de adição e remoção dinâmica
          var aggregate_field = a4FormDicDataItemService.aggregateField(form, field, func);
          deferred.resolve(aggregate_field);
          return deferred.promise;
        case "autocomplete": // Autocomplete
          var autocomplete = a4FormDicDataItemService.autocomplete(form, field, func);
          deferred.resolve(autocomplete);
          return deferred.promise;
        case "serial": // Serial
          var serial = a4FormDicDataItemService.autocomplete(form, field, func);
          deferred.resolve(serial);
          return deferred.promise;
        case "boolean": // Switch
          var Switch = a4FormDicDataItemService.boolean(form, field);
          deferred.resolve(Switch);
          return deferred.promise;
        case "check": // Checkbox
          var check = a4FormDicDataItemService.check(form, field);
          deferred.resolve(check);
          return deferred.promise;
        case "decimal": // Datepicker
          var decimal = a4FormDicDataItemService.input(form, field);
          deferred.resolve(decimal);
          return deferred.promise;
        case "date": // Datepicker
          var date = a4FormDicDataItemService.date(form, field);
          deferred.resolve(date);
          return deferred.promise;
        case "grid_list":
          var grid_list = a4FormDicDataItemService.grid_list(form, field);
          deferred.resolve(grid_list);
          return deferred.promise;
        case "time": // Time
          var time = a4FormDicDataItemService.time(form, field);
          deferred.resolve(time);
          return deferred.promise;
        case "integer": // Input
          var integer = a4FormDicDataItemService.input(form, field);
          deferred.resolve(integer);
          return deferred.promise;
        case "input": // Input
          var input = a4FormDicDataItemService.input(form, field);
          deferred.resolve(input);
          return deferred.promise;
        case "radio": // Radio Button
          var radio = a4FormDicDataItemService.radio(form, field);
          deferred.resolve(radio);
          return deferred.promise;
        case "smallint": // Input
          var smallint = a4FormDicDataItemService.input(form, field);
          deferred.resolve(smallint);
          return deferred.promise;
        case "text": //Text Area
          var text = a4FormDicDataItemService.textarea(form, field);
          deferred.resolve(text);
          return deferred.promise;
        case "list": //list item
          var table = a4FormDicDataItemService.list(form, field);
          deferred.resolve(table);
          return deferred.promise;
        case "list_value": //Select box
          var value_list = a4FormDicDataItemService.select(form, field);
          deferred.resolve(value_list);
          return deferred.promise;
        case "group_list_value": //Select group box
          var group_list_value = a4FormDicDataItemService.select_group(form, field);
          deferred.resolve(group_list_value);
          return deferred.promise;
        case "schedule_table": //Select group box
          var schedule_table = a4FormDicDataItemService.schedule_table(form, field);
          deferred.resolve(schedule_table);
          return deferred.promise;
        case "varchar": // Input Text
          var varchar = a4FormDicDataItemService.input(form, field);
          deferred.resolve(varchar);
          return deferred.promise;
        default:
          deferred.resolve("");
          return deferred.promise;
      }
    };

    vm.init = function () {

    };


    /** Funções do campo de tipo agreggate_field */
    /**
     * Adiciona itens a lista do campo campo agreggate_field
     * @param item
     * @param table
     */
    vm.addItem = function (item, table) {
      var newItem = angular.copy(item);
      $scope.bind[table].push(vm.createItemList(newItem));
    };

    /**
     * Remove itens da lista do campo agreggate_field
     * @param item - item a ser removido da lista
     * @param id - indice do item no vetor
     * @param table - nome da tabela referente ao modelo do item
     */
    vm.removeItem = function (item, id, table) {
      $rootScope.$emit('add.field.list');
      if ($scope.bind[table].indexOf(item) !== -1) {
        $scope.bind[table].splice(id, 1);
      }
    };

    /**
     * Cria o objeto padrão para a lista
     * @returns object
     */
    vm.createItemList = function () {
      return {};
    };

    vm.init();
  }

  angular.module('app.a4formdicdata')
    .controller('a4FormDicDataItemController', a4FormDicDataItemController)
})();
(function () {
  'use strict';
  angular
    .module('app.a4-float-button', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function FloatButtonService($compile, $q) {

    var vm = this;
    var rand_id = 0;
    var old_rand_id = 0;
    var $scope;

    var _constructor = function (scope) {
      $scope = scope;
      old_rand_id = getRandId();

      $scope.$on('$destroy', function () {

        if (old_rand_id == 0) {
          vm.destroy(getRandId());
          setRandId(0);
        }

        if (getRandId() == 0) {
          vm.destroy(old_rand_id);
          old_rand_id = 0
        }

        if (old_rand_id == getRandId()) {
          vm.destroy();
        } else {
          old_rand_id = 0
        }

      });

      if (isInBody()) {
        removeButton(getRandId())
          .then(function () {
            newButton(scope);
          });
      } else {
        newButton(scope);
      }

    };

    /**
     * Estrutura do novo botão
     * @param scope - Escopo do controlador
     */
    var newButton = function (scope) {
      setRandId(Math.floor((Math.random() * 1000000) + 1));

      if (angular.isDefined(vm.options.type) && vm.options.type === 'menu') {
        var button = createButtonMenu();
      } else {
        var button = createButton();
      }

      button = angular.element($compile(button)(scope));
      vm.body.append(button);
    };

    var createButtonMenu = function () {
      vm.options.icon = (angular.isDefined(vm.options.icon)) ? vm.options.icon : 'menu';
      vm.options.label = (angular.isDefined(vm.options.label)) ? vm.options.label : 'Menu';
      vm.options.position = (angular.isDefined(vm.options.position)) ? vm.options.position : 'right';

      var content = angular.element('<div id="a4-float-button_' + getRandId() + '" ng-show="!$root.show_loader"></div>');

      var fab_speed = '<md-fab-speed-dial md-direction="up" md-open="false" class="md-fling a4-float-buttom-speed-dial"></md-fab-speed-dial>';

      vm.body = angular.element('#main');
      fab_speed = angular.element(fab_speed);

      var fab_trigger = '<md-fab-trigger>' +
        '<md-button class="md-fab md-' + vm.options.theme + '-theme" ' +
        'aria-label="' + vm.options.label + '" ' +
        'ng-if="' + vm.options.conditional + '" ' +
        'md-theme="vm.options.theme">' +
        '   <md-tooltip md-direction="left">' + vm.options.label + '</md-tooltip>' +
        '   <md-icon>' + vm.options.icon + '</md-icon>' +
        ' </md-button>' +
        '</md-fab-trigger> ';

      fab_speed.append(fab_trigger);

      var fab_actions = '<md-fab-actions></md-fab-actions>';

      fab_actions = angular.element(fab_actions);

      fab_speed.append(fab_actions);

      if (angular.isDefined(vm.options.items) && vm.options.items.length > 0) {
        var button = '';
        vm.options.items.forEach(function (item) {
          if (item.conditional) {
            button =
              '<md-button aria-label="item" class="md-fab md-raised md-mini correction-height">' +
              '            <md-icon>' + item.icon + '</md-icon>' +
              '            <md-tooltip md-direction="left">' + item.label + '</md-tooltip>' +
              '</md-button>';
            button = angular.element(button);
            if (angular.isDefined(item.onClick)) {
              button.attr('ng-click', item.onClick);
            }
            fab_actions.append(button);
          }
        })
      }

      if (angular.isDefined(vm.options.onClick)) {
        fab_speed.attr('ng-click', vm.options.onClick);
      }

      if (angular.isDefined(vm.options.uiSref)) {
        fab_speed.attr('ui-sref', vm.options.uiSref);
      }

      fab_speed.addClass('md-primary');
      // content.css({
      //   'position': 'fixed',
      //   'right': "0",
      //   'bottom': "1px",
      //   'z-index': 9999999
      //   // 'margin-right': '30px',
      // });
      content.css({
        'position': 'fixed',
        'right': "-25px",
        'bottom': "10px",
        'margin-right': '30px',
        // 'margin-right': '30px',
        'z-index': 9999999
      });

      content.append(fab_speed);

      return content;
    };

    /**
     * Criação do botão para inserção no DOM
     * @returns {string}
     */
    var createButton = function () {

      vm.options.icon = (angular.isDefined(vm.options.icon)) ? vm.options.icon : 'add';
      vm.options.label = (angular.isDefined(vm.options.label)) ? vm.options.label : 'Adicionar';
      vm.options.position = (angular.isDefined(vm.options.position)) ? vm.options.position : 'right';

      var content = angular.element('<div id="a4-float-button_' + getRandId() + '" ng-show="!$root.show_loader"></div>');

      var button = '' +
        '<md-button ' +
        'class="md-fab md-fab-bottom-' + vm.options.position + ' md-' + vm.options.theme + '-theme" ' +
        'aria-label="' + vm.options.label + '" ' +
        'ng-if="' + vm.options.conditional + '" ' +
        'md-theme="vm.options.theme">' +
        '   <md-tooltip md-direction="left">' + vm.options.label + '</md-tooltip>' +
        '   <md-icon>' + vm.options.icon + '</md-icon>' +
        ' </md-button>';


      vm.body = angular.element('#main');
      button = angular.element(button);

      if (angular.isDefined(vm.options.onClick)) {
        button.attr('ng-click', vm.options.onClick);
      }

      if (angular.isDefined(vm.options.uiSref)) {
        button.attr('ui-sref', vm.options.uiSref);
      }

      button.addClass('md-primary');
      content.css({
        'position': 'fixed',
        'right': "-30px",
        'bottom': "1px",
        'margin-right': '30px',
      });

      content.append(button);

      return content;
    };

    /**
     * Define as opções para uso interno do serviço
     * @param options
     * @returns {{scope: Array, onClick: string, uiSref: string}}
     */
    var setOptions = function (options) {
      return {
        scope: angular.isUndefined(options) ? [] : options.scope,
        conditional: angular.isUndefined(options) ? true : angular.isUndefined(options.conditional) ? true : options.conditional,
        onClick: angular.isUndefined(options) ? '' : options.onClick,
        theme: angular.isUndefined(options) ? 'finance' : options.theme,
        uiSref: angular.isUndefined(options) ? '' : options.uiSref,
        icon: angular.isUndefined(options) ? '' : options.icon,
        label: angular.isUndefined(options) ? '' : options.label,
        type: angular.isUndefined(options) ? '' : options.type,
        items: angular.isUndefined(options) ? '' : options.items
      }
    };

    /**
     * Define o número randômico
     * @param id - Número randômico
     */
    var setRandId = function (id) {
      rand_id = id;
    };


    /**
     * Retorna o número definido
     * @returns {number|*}
     */
    var getRandId = function () {
      return rand_id;
    };

    /**
     * Remove o botão do DOM
     */
    var removeButton = function (id) {
      var deferred = $q.defer();
      var floatid = angular.isDefined(id) ? id : getRandId();
      //angular.element('#a4-float-button_' + floatid).remove();
      angular.element('[id*=a4-float-button_]').remove();
      deferred.resolve(true);
      return deferred.promise;
    };


    /**
     * Verifica a existência de um botão no DOM
     * @returns {boolean}
     */
    var isInBody = function () {
      return angular.element('#a4-float-button_' + getRandId()).length > 0;
    };


    /**
     * Executa a destruição do botão e do escopo do botão
     */
    vm.destroy = function (id) {
      if (isInBody()) {
        vm.options.scope.$destroy;
        removeButton(id);
      }
    };

    return function (options) {
      var scope = options.scope;
      vm.options = setOptions(options);
      _constructor(scope);
      return vm;
    };
  }

  angular
    .module('app.a4-float-button')
    .factory('$a4FloatButton', FloatButtonService);
})();
(function () {
  'use strict';

  angular.module('app.a4-filter', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function A4FilterService() {
    var vm = this;

    return vm;

  }

  angular.module('app.a4-filter')
    .controller('A4FilterService', A4FilterService);

})();
(function () {
  'use strict';

  /** @ngInject */
  function A4FilterDirective() {

    return {
      controller: 'A4FilterController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-filter/index.html',
      link: function () {

      }
    }
  }

  angular.module('app.a4-filter')
    .directive('a4Filter', A4FilterDirective);

})();
(function () {
  'use strict';

  /** @ngInject */
  function A4FilterController() {
    var vm = this;

  }

  angular.module('app.a4-filter')
    .controller('A4FilterController', A4FilterController);

})();
(function () {
  'use strict';

  angular
    .module('app.a4-file-upload', []);

})();
(function () {
  'use strict';

  function DropzoneService(Common) {

    /**
     * Informa o índice do tipo de arquivo
     * @param type
     * @returns {number}
     */
    var getIndex = function (type) {
      var index = mimeTypes.indexOf(mimeTypes.filter(function (i) {
          return i.type === type
        })[0]
      );

      if (index >= 0) {
        return index
      }
    };

    /**
     * Retorna o Base64 de um arquivo
     * @param file - Objeto do tipo FILE!
     * @return {*}
     */
    var getBase64 = function (file) {
      var deffered = Common.$q.defer();
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        deffered.resolve(reader.result);
      };
      reader.onerror = function (error) {
        deffered.reject(error);
      };
      return deffered.promise;
    };

    /**
     * Armazena os tipos de arquivo e seus mimetypes
     */
    var mimeTypes = [
      {
        type: 'mp3',
        mimetype: 'audio/mp3, audio/mpeg3, audio/mpg, audio/x-mp3, audio/x-mpeg, audio/x-mpeg3, audio/x-mpg, audio/mpeg'
      },
      {
        type: 'zip',
        mimetype: 'application/zip, application/x-zip-compressed'
      },
      {
        type: 'rar',
        mimetype: 'application/x-rar-compressed, application/octet-stream'
      },
      {type: 'pdf', mimetype: 'application/pdf'},
      {type: 'doc', mimetype: 'application/msword'},
      {type: 'docx', mimetype: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'},
      {type: 'dotx', mimetype: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template'},
      {type: 'docm', mimetype: 'application/vnd.ms-word.document.macroEnabled.12'},
      {type: 'dotm', mimetype: 'application/vnd.ms-word.template.macroEnabled.12'},
      {
        type: 'xls',
        mimetype: 'application/excel, application/vnd.ms-excel, application/x-excel, application/x-msexcel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel.sheet.binary.macroEnabled.12'
      },
      {type: 'xlt', mimetype: 'application/vnd.ms-excel'},
      {type: 'xla', mimetype: 'application/vnd.ms-excel'},
      {type: 'xlsx', mimetype: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
      {type: 'xltx', mimetype: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'},
      {type: 'xlsm', mimetype: 'application/vnd.ms-excel.sheet.macroEnabled.12'},
      {type: 'xltm', mimetype: 'application/vnd.ms-excel.template.macroEnabled.12'},
      {type: 'xlam', mimetype: 'application/vnd.ms-excel.addin.macroEnabled.12'},
      {
        type: 'ppt',
        mimetype: 'application/mspowerpoint, application/powerpoint, application/vnd.ms-powerpoint, application/x-mspowerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation'
      },
      {type: 'pptx', mimetype: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'},
      {
        type: 'docx',
        mimetype: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      },
      {type: 'pot', mimetype: 'application/vnd.ms-powerpoint'},
      {type: 'pps', mimetype: 'application/vnd.ms-powerpoint'},
      {type: 'png', mimetype: 'image/png'},
      {type: 'jpg', mimetype: 'image/jpeg, image/pjpeg'},
      {type: 'gif', mimetype: 'image/gif'},
      {
        type: 'wmf',
        mimetype: 'application/octet-stream, application/x-msmetafile, application/wmf, application/x-wmf, image/wmf, image/x-wmf, image/x-win-metafile, zz-application/zz-winassoc-wmf, application/wmf, application/x-msmetafile, application/x-wmf, image/wmf, image/x-win-metafile'
      },
      {
        type: 'avi',
        mimetype: 'video/mp4, application/x-troff-msvideo, image/avi, video/msvideo, video/x-msvideo, video/xmpg2, video/avi'
      },
      {type: 'mpeg', mimetype: 'video/mpeg'},
      {type: 'wmv', mimetype: 'video/x-ms-wmv'},
      {type: 'mp4', mimetype: 'video/mp4, application/mp4, audio/mp4, video/mpeg4, video/x-m4v'}
    ];

    /**
     * Verifica se um determinado campo está na lista de remoção do objeto;
     * @param list Array - Indice do objeto
     * @returns {string}
     */
    var getMimeTypes = function (list) {
      var result = '';
      /** Percorre a lista de arquivos */
      angular.forEach(list, function (type) {
        /** Busca o arquivo */
        mimeTypes.find(function (value) {
          /** Se encontra retorne o mimetype*/
          if (type.toLowerCase() === value.type) {
            var index = getIndex(value.type);
            type = mimeTypes[index].mimetype;
            result = type + ',' + result;
          }
        });
      });

      /** Remove a última ',' */
      result = result.slice(0, -1);
      /** Retorna todos os tipos como string */
      return String(result);
    };


    /**
     * Verifica se um determinado campo está na lista de remoção do objeto;
     * @param list Array - Indice do objeto
     * @returns {string}
     */
    var getTypes = function (list) {
      var result = [];
      /** Percorre a lista de arquivos */
      angular.forEach(list, function (type) {
        /** Busca o arquivo */
        mimeTypes.forEach(function (mime) {
          if (mime.mimetype.search(type) > -1 && result.indexOf(mime.type) === -1) {
            result.push(mime.type);
          }
        });
      });
      /** Retorna todos os tipos como string */
      return result.toString();
    };


    return {
      getMimeTypes: getMimeTypes,
      getTypes: getTypes,
      getBase64: getBase64
    }

  }

  angular
    .module('app.a4-file-upload')
    .factory('DropzoneService', DropzoneService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4FileUploadFactory() {
    return {};
  }

  angular
    .module('app.a4-file-upload')
    .factory('a4FileUploadService', a4FileUploadFactory);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4FileUpload(DropzoneService) {
    return {
      restrict: "E",
      scope: {
        options: "=",
        methods: "=",
        callbacks: "=",
      },
      templateUrl: 'app/components/a4-file-upload/a4-file-upload.html',
      controller: "a4FileUploadController",
      controllerAs: "vm",
      link: function (scope, element, attrs, ctl) {
        ctl.acceptedtypes = DropzoneService.getTypes(scope.options.acceptedFiles.split(','));
      }
    };
  }

  angular
    .module('app.a4-file-upload')
    .directive('a4FileUpload', a4FileUpload);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4FileUploadController(Common) {
    var vm = this;
    /**
     * Define o comportamento após o upload
     */
    vm.dzCallbacks = {
      'successmultiple': function (file, xhr) {
        if (xhr) {
          angular.forEach(xhr, function (item) {
            vm.artefacts.splice(0, 0, item);
          });
          vm.btnMultipleFiles = false;
          vm.submitOnlyFile(vm.lesson, vm.artefacts);
          vm.dzMethods.removeAllFiles(true);
        }
      },
      'error': function (file, errorMessage) {
        Common.Toast.error(errorMessage);
      },
      'errormultiple': function (files, message, xhr) {
        Common.Toast.error(message);
      }
    };

  }

  angular
    .module('app.a4-file-upload')
    .controller('a4FileUploadController', a4FileUploadController);
})();
(function () {
  'use strict';

  angular.module('app.a4emailserrors', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4EmailsErrors($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        errors: '=?',
        report: '=?'
      },
      controller: 'a4EmailsErrorsController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-emails-errors/index.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4emailserrors')
    .directive('a4EmailsErrors', a4EmailsErrors);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4EmailsErrorsController($scope, $rootScope, ModalFactory) {
    var vm = this;
    vm.showEmailsDetails = function () {
      ModalFactory.customClean('app/components/a4-emails-errors/emails-errors-details.html',
        /** @ngInject */
        function ($scope, $rootScope, ModalExtra, GridService, Common, $timeout, $mdDialog) {
          var vm = this;
          vm.loader = false;
          vm.report = ModalExtra.report;

          vm.allowEdit = function (item) {
            if (angular.isUndefined(item.edit) || item.edit == null){
              item.edit = true;
            } else {
              item.edit = !item.edit;
            }
          };
          vm.adjustEmail = function (person, index) {
            vm.loader = true;
            GridService.adjustEmail(person)
              .then(function () {
                vm.loader = false;
                Common.Toast.success('Email ajustado com sucesso!');
                $timeout(function () {
                  vm.report.splice(index, 1);
                }, 1000);
              })
          };

          vm.close = function () {
            $mdDialog.hide(true);
          }

        }, 'vm', true, {report: $scope.report});
    };


  }

  angular.module('app.a4emailserrors')
    .controller('a4EmailsErrorsController', a4EmailsErrorsController);
})();
(function () {
  'use strict';

  angular.module('app.a4emailwarning', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4EmailWarning($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        personId: '=?',
        person: '=?',
      },
      controller: 'a4EmailWarningController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-email-warning/warning.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4emailwarning')
    .directive('a4EmailWarning', a4EmailWarning);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4EmailWarningController($scope, $rootScope, PersonService) {
    var vm = this;
    vm.has_email_error = false;
    vm.email_error = null;

    vm.init = function () {
      vm.email_error = $scope.person.email_error
      /*PersonService.verifyEmailError({person_id: $scope.personId}).then(function (email_error) {
        if (email_error !== null && angular.isDefined(email_error.error) && email_error.error !== null) {
          vm.email_error = email_error.error;
          vm.has_email_error = true;
        }
      })*/
    };

    vm.init();


  }

  angular.module('app.a4emailwarning')
    .controller('a4EmailWarningController', a4EmailWarningController);
})();
(function () {
  'use strict';

  angular.module('app.a4email', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4email() {
    return {
      restrict: 'E',
      scope: {
        model: '=?',
        isEnabled: '=?',
        personId: '=?',
        isRequired: '=?',
        notRequired: '=?',
        blockForm: '=?',
        showOwner: '=?',
        doCheck: '=?',
        labelCustom: '=?'
      },
      controller: 'a4EmailController',
      controllerAs: 'vm',
      require: ['^form'],
      templateUrl: 'app/components/a4-email/a4-email.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4email')
    .directive('a4email', a4email);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4EmailController($scope, PersonService, Session) {
    var vm = this;
    vm.email_error = false;
    vm.email_error_message = null;
    vm.company_id = Session.getCurrentCompany();
    if (angular.isDefined($scope.labelCustom) && $scope.labelCustom !== null)
    {
      vm.label = $scope.labelCustom;
    } else {
      vm.label = 'Email';
    }

    vm.verifyEmail = function (email) {
      vm.showLoader = true;
      vm.email_error = false;
      vm.email_error_message = null;
      if (email === '') {
        vm.showLoader = false;
        $scope.blockForm = false;
        return;
      }
      if (angular.isDefined(email) && email !== null && email !== '' && vm.verifyMask(email)) {
        PersonService.verifyEmail({email: email, person_id: $scope.personId})
          .then(function (response) {
            vm.showLoader = false;
            if (angular.isDefined(response)) {
              vm.email_error = true;
              var owner_message = ', pertence ao usuário ' + response;
              vm.email_error_message = 'Este email já existe no sistema';
              if ($scope.showOwner !== false) {
                vm.cpf_error_message += owner_message;
              }
              $scope.blockForm = true;
            } else {
              $scope.blockForm = false;
            }
          })
          .catch(function () {
            vm.showLoader = false;
          })
      } else {
        vm.showLoader = false;
        vm.email_error = true;
        vm.email_error_message = 'Por favor, digite um email válido.';
      }
    };

    /**
     * Validação de e-mail
     * @param email
     * @returns {boolean}
     */
    vm.verifyMask = function (email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    }
  }

  angular.module('app.a4email')
    .controller('a4EmailController', a4EmailController);
})();
(function () {
  'use strict';

  angular
    .module('app.a4-edit-table', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4EditTable($rootScope, $document) {

    return {
      restrict: 'E',
      transclude: true,
      template: '<ng-include src="template"/>',
      scope: {
        type: '@',
        template: '@',
        items: '=',
        currentAccount: '=',
        bankColletions: '=',
      },
      link: function (scope, element, attrs) {

        scope.edit_mode = [];

        /**
         * addNewItem
         * Adiciona novos itens ao array
         */
        scope.addNewItem = function () {
          scope.disableEditMode();

          if (scope.items == null) {
            scope.items = [];
          }

          scope.items.push({});

          //edit mode open
          var len = scope.items.length - 1;
          scope.edit_mode[len] = true;
        };

        /**
         * editItem
         * Edita itens do array
         */
        scope.editItem = function (item, idx) {
          if (!scope.edit_mode[idx]) {
            scope.disableEditMode();
          }
          scope.edit_mode[idx] = !scope.edit_mode[idx];
        };

        /**
         * removeItem
         * Remove itens do array
         */
        scope.removeItem = function (item, idx) {
          if (scope.items.indexOf(item) !== -1) {
            scope.items.splice(idx, 1);
            $rootScope.$broadcast('a4-edit-table.remove-item', {
              type: scope.type,
              item: item,
              current_account_id: scope.currentAccount.id
            });

          }
        };

        /**
         * Label de status para o item
         * @param status
         * @returns {string}
         */
        scope.checkItemStatus = function (status, idx, label) {

          if (scope.items[idx][label] == null) {
            scope.items[idx][label] = true;
            status = true;
          }

          return status ? 'ATIVO' : 'INATIVO';
        };

        /**
         * disableEditMode
         */
        scope.disableEditMode = function () {
          scope.edit_mode = [];
        };

        /**
         * disable editable mode
         */
        var scopeExpression = attrs.outsideClick,
          onDocumentClick = function (event) {
            var parent = event.target;

            while (parent && parent !== element[0]) {
              parent = parent.parentNode;
            }

            if (!parent) {
              scope.disableEditMode();
              scope.$apply();
            }
          };

        $document.on("click", onDocumentClick);

        element.on('$destroy', function () {
          $document.off("click", onDocumentClick);
        });

      }
    }
  }

  angular
    .module('app.a4-edit-table')
    .directive('a4EditTable', a4EditTable)
})();

(function () {
  'use strict';

  angular.module('app.a4-discounts', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4DiscountsGrid(){
    return {
      templateUrl: 'app/components/a4-discounts/discounts-grid.html',
      restrict: 'E',
      controller: 'A4DiscountsGridController',
      controllerAs: 'vm',
      scope: {
        discounts: '=?',
        onlyPaymentPlanDiscount: '=?',
        onlyIndividualDiscount: '=?',
        showDelete: '=?',
        deleteFunction: '&',
        reopenFunction: '&',
        isFinanceEnrolment: '=?'
      },
      link: function (scope, element, attrs, ctrl) {

      }
    }
  }

  angular.module('app.a4-discounts')
    .directive('a4DiscountsGrid', a4DiscountsGrid);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4DiscountsController($rootScope, $mdDialog, a4Moment, ModalExtra, IndividualDiscountsService, moment) {
    var vm = this;
    vm.reasons = [];
    vm.behaviors = [];
    vm.reason_name = null;
    vm.is_edit = false;
    if (angular.isDefined(ModalExtra.discount) && ModalExtra.discount !== null) {
      vm.form = ModalExtra.discount;
      vm.is_edit = true;
    } else {
      vm.form = {
        type: 'F',
        format: 'P',
        behavior: 1,
        scope: 'C',
        is_excluded_first_installment: false,
        start_date: null,
        end_date: null,
        notes:null
      };
    }

    vm.theme = ModalExtra.theme;

    vm.set_discount_reason = function () {
      vm.form.name = vm.form.discount_reason.name;
      vm.form.discount_reason_id = vm.form.discount_reason.id;
      vm.getSuggestion(vm.form.discount_reason_id.id);
    };

    vm.getSuggestion = function (discount_reason_id) {
      IndividualDiscountsService.getSuggestion({discount_reason_id: discount_reason_id})
        .then(function (response) {
          var suggestion = response.plain();
          if (!(angular.equals(suggestion, {}))) {
            if (suggestion.format === 'P') {
              suggestion.value_percent_1 = suggestion.value_percent_1 / 100;
              suggestion.value_percent_2 = suggestion.value_percent_2 !== null ? suggestion.value_percent_2 / 100 : null;
              suggestion.value_percent_3 = suggestion.value_percent_2 !== null ? suggestion.value_percent_2 / 100 : null;
            }
            Object.assign(vm.form, suggestion);
          }
        })
    };

    vm.submit = function (form) {
      var result = angular.copy(vm.form);
      if (!vm.is_edit) {
        if (typeof result.start_date !== "object") {
          result.start_date = null;
        }
        if (typeof result.end_date !== "object") {
          result.end_date = null;
        }
      }
      result.discount_reason_id = result.discount_reason.id;
      $mdDialog.hide(result);
    };

    vm.close = function () {
      $mdDialog.hide('canceled');
    };

    var discount_validation = [];
    vm.init = function () {
      // vm.getDiscountsReasons();
      vm.getBehaviors();
    };

    vm.getDiscountsReasons = function (query) {
      return IndividualDiscountsService.getDiscountsReasons({query: query, limit: 15});
    };

    vm.getBehaviors = function () {
      IndividualDiscountsService.getBehaviors().then(function (response) {
        vm.behaviors = response.plain();
        //verificar se é um desconto novo
        if (!(angular.isDefined(ModalExtra.discount) && ModalExtra.discount !== null)) {
          vm.form.discount_behavior_id=1;
        }
      })
    };

    /**
     * Validacao dos descontos
     * @param val1
     * @param val2
     * @param grp
     * @param id
     * @returns {boolean}
     */
    vm.validateValue = function (val1, val2, grp, id) {
      if (val1 != null && val2 != null) {
        val1 = round(parseFloat(val1).toFixed(4), 2);
        val2 = round(parseFloat(val2).toFixed(4), 2);
        var result = val1 != 0 && val2 != 0 ? val2 <= val1 : false;
        return vm.checkIsValidDiscount(result, grp, id);
      }
    };

    /**
     * Checa a validacao para os descontos
     * @param result
     * @param grp
     * @param id
     * @returns {boolean}
     */
    vm.checkIsValidDiscount = function (result, grp, id) {

      discount_validation[grp] = discount_validation[grp] == null ? [] : discount_validation[grp];

      if (result) {
        discount_validation[grp][id] = true;
      } else {
        discount_validation[grp][id] = false;
      }

      return discount_validation[grp][id];

    };


    vm.init();
  }

  angular.module('app.a4-discounts')
    .controller('A4DiscountsController', A4DiscountsController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function A4DiscountsGridController($scope, IndividualDiscountsService, ModalFactory, a4Moment, Common) {
    var vm = this;
    vm.behaviors = [];
    vm.convertType = function (format) {
      switch (format) {
        case 'F':
          return 'Fixo';
        case 'C':
          return 'Condicional';
        case 'P':
          return 'Promocional';
      }
    };

    vm.getBehaviors = function () {
      IndividualDiscountsService.getBehaviors().then(function (response) {
        vm.behaviors = response.plain();
      })
    };

    vm.getBehavior = function (discount) {
      var behavior_name = '';
      if (angular.isDefined(discount.discount_behavior) && discount.discount_behavior !== null) {
        return discount.discount_behavior;
      }
      vm.behaviors.forEach(function (item) {
        if (item.id === discount.behavior) {
          behavior_name = item.name;
        }
      });
      return behavior_name;
    };

    vm.editDiscount = function (discount) {
      var discount_copy = angular.copy(discount);
      if (discount_copy.format === 'P') {
        discount_copy.value_percent_1 = discount_copy.value_percent_1 / 100;
        discount_copy.value_percent_2 = discount_copy.value_percent_2 !== null ? discount_copy.value_percent_2 / 100 : null;
        discount_copy.value_percent_3 = discount_copy.value_percent_3 !== null ? discount_copy.value_percent_3 / 100 : null;
      }
      discount_copy.discount_reason = {
        id: discount_copy.discount_reason_id,
        name: discount_copy.name
      };

      ModalFactory.customClean(
        'app/components/a4-discounts/modal.html',
        'A4DiscountsController', 'vm', false, {
          theme: 'finance',
          discount: discount_copy,
          is_edit: true
        }
      ).then(function (discount) {
        discount.start_date = discount.start_date !== '' ? a4Moment(discount.start_date).format('YYYY-MM-DD') : null;
        discount.end_date = discount.end_date !== '' ? a4Moment(discount.end_date).format('YYYY-MM-DD') : null;
        IndividualDiscountsService.update({discount: discount})
          .then(function () {
          if (discount_copy.bill_serie_id !== null) {
            $scope.reopenFunction({discount: discount_copy.bill_serie_id});
          } else {
            $scope.reopenFunction({discount: discount_copy.payment_plan_id});
          }
          Common.Toast.success("Desconto editado com sucesso");
        })
          .catch(function (){
            Common.Toast.error('Erro ao editar desconto');
          })
      })
    };

    vm.init = function () {
      vm.is_finance_enrolment = angular.isDefined($scope.isFinanceEnrolment) ? $scope.isFinanceEnrolment : null;

      if (Array.isArray($scope.discounts)) {
        $scope.discounts.forEach(function (discount, index) {
            discount.index = index; // Adiciona o índice ao item de desconto
        });
      }
      
      //console.log($scope)
      vm.getBehaviors();
    };

    vm.init();

  }

  angular.module('app.a4-discounts')
    .controller('A4DiscountsGridController', A4DiscountsGridController);
})();

(function () {
  'use strict';

  angular.module('app.a4-digital-sign', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('public.a4-digital-sign-valida', {
        url: '/valida',
        public: true,
        controller: 'A4DigitalSignValidateController',
        controllerAs: 'vm',
        templateUrl: 'app/components/a4-digital-sign/valida.html',
        params: {token: null}
      });

  }

  angular
    .module('app.a4-digital-sign')
    .config(routerConfig);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4DigitalSignService(Restangular) {

    var saveSign = function (obj) {
      return Restangular.all('digitalsign').post(obj);
    };

    var getActualEvent = function (obj) {
      return Restangular.one('digitalsign').one('getactualevent').get(obj);
    };

    var submitToken = function (obj) {
      return Restangular.one('digitalsign').all('submittoken').post(obj);
    };

    var sendTokenWithSMS = function (obj) {
      return Restangular.one('digitalsign').all('sendtokenwithsms').post(obj);
    };

    return {
      saveSign: saveSign,
      getActualEvent: getActualEvent,
      submitToken: submitToken,
      sendTokenWithSMS: sendTokenWithSMS
    };

  }

  angular
    .module('app.a4-digital-sign')
    .factory('a4DigitalSignService', a4DigitalSignService)

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4DigitalSign() {
    return {
      restrict: 'E',
      scope: {
        person: '=?',
        student: '=?',
        isEnabled: '=?',
        personId: '=?',
        isRequired: '=?',
        showOwner: '=?'
      },
      controller: 'a4DigitalSignController',
      controllerAs: 'vm',
      require: [],
      templateUrl: 'app/components/a4-digital-sign/a4-digital-sign.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4-digital-sign')
    .directive('a4DigitalSign', a4DigitalSign);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4DigitalSignController(PersonService, EducationalService, Common, $rootScope, Utils,
                                   $scope, a4DigitalSignService, a4Moment, $mdDialog, $interval) {
    var vm = this;
    vm.person = $scope.person;
    vm.student = $scope.student;
    vm.determinateValue = 0;
    vm.counter = 120;
    vm.sign = {};
    vm.event = null;
    vm.sign_confirmed = false;

    vm.init = function () {
      vm.hided_email = Utils.hideEmail(vm.person.email);
      if (vm.person.phone_mobile !== null) {
        vm.hided_phone = Utils.hidePhone(vm.person.phone_mobile);
      } else {
        vm.hided_phone = null;
      }
      vm.getActualEvent();
    };

    /**
     * Recupera o último evento em aberto para um contrato
     */
    vm.getActualEvent = function () {
      $rootScope.show_loader = true;
      a4DigitalSignService.getActualEvent({enrolment_period_id: vm.student.enrolment_period_id})
        .then(function (resp) {
          vm.event = resp.plain();
          vm.diff = a4Moment().diff(a4Moment(vm.event.date_time), 'minutes', true);
          if (vm.event.artifact_id !== null && vm.event.is_confirmed === false && vm.diff <= 60) {
            vm.runCounter();
          }
          $rootScope.show_loader = false;
        })
        .catch(function (resp) {
          $rootScope.show_loader = false;
          Common.Toast.warning(resp.data.message);
        });
    };

    vm.sendSMS = function () {
      $rootScope.show_loader = true;
      a4DigitalSignService.sendTokenWithSMS({person_id: vm.person.id})
        .then(function (response) {
          Common.Toast.success('Token enviado com sucesso')
        })
    };

    vm.submit = function (is_sms) {
      $rootScope.show_loader = true;
      if (!(vm.event.artifact_id !== null && vm.event.is_confirmed === false && vm.diff <= 60)) {
        var name_typed = vm.sign.name.toLowerCase().split(' ');
        var origin_name = vm.person.name.toLowerCase().split(' ');
        var count_name = 0;
        name_typed.forEach(function (item) {
          if (origin_name.includes(item)) {
            count_name += 1;
          }
        });

        // console.log('count_name:', count_name, 'vm.sign.national_id_number: ', vm.sign.national_id_number, 'vm.person.national_id_number: ', vm.person.national_id_number, 'vm.sign.email.toLowerCase(): ', vm.sign.email.toLowerCase(), 'vm.person.email.toLowerCase(): ', vm.person.email.toLowerCase());
        if (count_name === 0 || vm.sign.national_id_number !== vm.person.national_id_number || vm.sign.email.toLowerCase() !== vm.person.email.toLowerCase()) {
          Common.Toast.warning('Por favor, confira os dados inseridos e tente novamente. Os dados não conferem com os cadastrados na escola.');
          $rootScope.show_loader = false;
          return;
        }
      } else {
        vm.sign = {};
      }
      vm.sign.bill_serie_id = vm.student.bill_serie_id;
      vm.sign.group_id = vm.student.group_id;
      vm.sign.student_id = vm.student.student_id;
      vm.sign.school_period_id = vm.student.school_period_id;
      vm.sign.person_id = vm.person.id;
      vm.sign.document_id = vm.person.document_id;
      vm.sign.enrolment_period_id = vm.person.enrolment_period_id;
      vm.sign.form = vm.student.form;
      vm.sign.is_sms = is_sms;
      if (angular.isUndefined(vm.sign.national_id_number) || vm.sign.national_id_number === null) {
        vm.sign.national_id_number = vm.person.national_id_number;
        vm.sign.name = vm.person.name;
      }
      a4DigitalSignService.saveSign(vm.sign)
        .then(function (response) {
          vm.event = response.plain();
          vm.sign_confirmed = false;
          vm.diff = a4Moment().diff(a4Moment(vm.event.date_time), 'minutes', true);
          vm.runCounter();
          $rootScope.show_loader = false;
        })
        .catch(function (resp) {
          $rootScope.show_loader = false;
          Common.Toast.warning(resp.data.message);
        });
    };

    vm.runCounter = function () {
      vm.counter = 120;
      vm.determinateValue = 0;
      vm.counter_loading = $interval(function () {
        vm.determinateValue += 1;
        $scope.$applyAsync();
        if (vm.determinateValue > 100) {
          vm.determinateValue = 0;
          $interval.cancel(vm.counter_loading);
        }
      }, 1200);
      vm.counter_value = $interval(function () {
        if (vm.counter > 0) {
          vm.counter -= 1;
        } else {
          $interval.cancel(vm.counter_value);
        }
        $scope.$applyAsync();
      }, 1000);
    };

    vm.submitValidationCode = function () {
      $rootScope.show_loader = true;
      a4DigitalSignService.submitToken({token: vm.sign.validation_code, event_id: vm.event.id})
        .then(function () {
          vm.sign_confirmed = true;
          $rootScope.show_loader = false;
          Common.Toast.success('Documento assinado com sucesso.');
        })
        .catch(function (resp) {
          $rootScope.show_loader = false;
          Common.Toast.warning(resp.data.message);
        })
    };

    vm.closeModal = function () {
      $mdDialog.hide();
    };

    vm.init();
  }

  angular.module('app.a4-digital-sign')
    .controller('a4DigitalSignController', a4DigitalSignController).filter('counter', [function () {
    return function (seconds) {
      return new Date(1970, 0, 1).setSeconds(seconds);
    };
  }]);
})();

(function () {
  'use strict';

  /** @ngInject */
  function A4DigitalSignValidateController(PersonService, EducationalService, Common,
                                   $scope, a4DigitalSignService, a4Moment,$mdDialog) {
    var vm = this;
    vm.person = $scope.person;
    vm.student = $scope.student;
    vm.sign = {};
    vm.event = null;

    vm.init = function () {
      vm.getActualEvent();
    };

    /**
     * Recupera o último evento em aberto para um contrato
     */
    vm.getActualEvent = function () {
      a4DigitalSignService.getActualEvent({bill_serie_id: vm.student.bill_serie_id})
        .then(function (resp) {
          vm.event = resp.plain();
          vm.diff = a4Moment().diff(a4Moment(vm.event.date_time), 'minutes', true);
        })
    };

    vm.submit = function () {
      var name_typed = vm.sign.name.split(' ');
      var origin_name = vm.person.name.split(' ');
      var count_name = 0;
      name_typed.forEach(function (item) {
        if (origin_name.includes(item)) {
          count_name += 1;
        }
      });
      vm.sign.bill_serie_id = vm.student.bill_serie_id;
      vm.sign.group_id = vm.student.group_id;
      vm.sign.student_id = vm.student.student_id;
      vm.sign.school_period_id = vm.student.school_period_id;
      vm.sign.person_id = vm.person.id;
      a4DigitalSignService.saveSign(vm.sign)
        .then(function (response) {
          vm.event = response.plain();
          vm.diff = a4Moment().diff(a4Moment(vm.event.date_time), 'minutes', true);
        });
    };

    vm.submitValidationCode = function () {
      a4DigitalSignService.submitToken({token: vm.sign.validation_code, event_id: vm.event.id})
        .then(function (resp) {
          Common.Toast.success('Documento assinado com sucesso.');
          $mdDialog.cancel();
        })
        .catch(function (resp) {
          Common.Toast.warning(resp.data.message);
        })
    };

    vm.init();

  }

  angular.module('app.a4-digital-sign')
    .controller('A4DigitalSignValidateController', A4DigitalSignValidateController);
})();
(function () {
  'use strict';

  angular
    .module('app.a4-detail-grid', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4DetailGrid($timeout, a4Moment) {

    return {
      restrict: 'E',
      transclude: true,
      scope: {
        list: "=",
        currentItem: "=",
        debitCredit: "@",
        edit: "=",
        categories: "=",
        totalAmount: "=?",
        hasBlock: '=?'
      },
      templateUrl: 'app/components/a4-detail-grid/templates/index.html',
      link: function (scope, element, attrs) {

        /**
         * lista de itens
         */
        scope.$watch('currentItem', function () {

          if (scope.currentItem != null && scope.edit) {

            if (scope.currentItem.bill_details != null) {
              var bill_detail = scope.currentItem.bill_details;
              // modo de edição
              // se não existe bill_details para o titulo, preencher com informação de bill_gategory_id e amount
              if (bill_detail.length === 0) {
                scope.list = [];
                scope.list.push({
                  'bill_category_id': scope.currentItem.bill_category_id,
                  'amount': scope.currentItem.amount
                });
              }
            }

          } else {
            // modo de criação
            // adiciona um novo item
            if (scope.list == null || angular.isUndefined(scope.list) || scope.list.length === 0) {
              scope.list = [];
              scope.addNewItem();
            }
          }
          // update para o valor total
          scope.calcAmount();
          if (scope.currentItem != null) {
            scope.totalAmount = scope.calcAmountCategory(scope.list);
            scope.currentItem.amount = scope.totalAmount;
          }

        }, true);


        /**
         * addNewItem
         * Adiciona novos itens ao array
         */
        scope.addNewItem = function () {
          if (!scope.edit) {
            scope.list.push({'bill_category_id': null, 'amount': 0});
          }
        };

        scope.getCategory = function (obj, id) {
          angular.forEach(scope.categories, function (item, i) {
            if (item.id == id) {
              obj.category = item;
            }
          });
        };

        /**
         * removeItem
         * Remove itens do array
         */
        scope.removeItem = function (item, idx) {
          if (!scope.edit && (idx != 0 || scope.list.length > 1) && scope.list.indexOf(item) !== -1) {
            scope.list.splice(idx, 1);
          }
        };

        /**
         * calcAmount
         */
        scope.calcAmount = function () {
          if (scope.currentItem !== null && scope.isValid()) {
            var tmp = 0;
            angular.forEach(scope.list, function (value, key) {
              if (value && value.amount !== null) {
                tmp += parseFloat(value.amount);
              }
            });

            scope.$applyAsync(function () {
              if (scope.currentItem !== null) {
                scope.currentItem.amount = parseFloat(tmp);
              }
            });
          }
        };


        /**
         *
         * @param list
         * @returns {number}
         */
        scope.calcAmountCategory = function (list) {
          var amount = 0;
          angular.forEach(list, function (value, key) {
            amount += angular.isDefined(value.amount) ? value.amount : 0;
          });
          return scope.amount_total_category = amount;
        };

        /**
         * checkStatus
         * Retorno só é verdadeiro se a despesa ainda não foi paga
         * @param currentItem
         * @returns {boolean}
         */
        scope.checkBillStatus = function (currentItem) {
          return (currentItem.hasOwnProperty('status')) ? currentItem.status != 10 || currentItem.status != 11 || currentItem.status != 12 : false;
        };

        /**
         * checkDate
         * Retorno só é verdadeiro se a data da despesa ainda nao estiver vencida
         * @param currentItem
         * @returns {boolean}
         */
        scope.checkDate = function (currentItem) {
          if (currentItem !== null && currentItem.due_date !== null) {
            var result = true;
            var curr_date = angular.copy(currentItem.due_date);
            var date = a4Moment(curr_date);
            var today = a4Moment();

            if (a4Moment(date).diff(today, 'days') < 0) {
              result = false;
            }
            return result;
          }
          return false;
        };

        /**
         * isValid
         * @returns {boolean}
         */
        scope.isValid = function () {
          return (scope.checkBillStatus(scope.currentItem) === true && scope.checkDate(scope.currentItem) === true);
        };


      }
    }
  }

  angular
    .module('app.a4-detail-grid')
    .directive('a4DetailGrid', a4DetailGrid)
})();

(function () {
  'use strict';

  angular
    .module('app.a4-crud-table', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function a4CrudTable($mdEditDialog, ModalFactory) {

    return {
      restrict: 'E',
      transclude: true,
      scope: {
        items: "=?",
        columns: "=?",
        createItem: "&?",
        saveItem: "&?",
        theme: "=?"
      },
      templateUrl: 'app/components/a4-crud-table/templates/index.html',
      link: function (scope) {
        /**
         * Form de criação
         */
        scope.openModalAddItem = function () {
          ModalFactory.custom(
            'app/components/a4-crud-table/templates/modal-add-item.html',
            {columns: scope.columns,
              theme: scope.theme},
            true
          ).then(function (item) {
            scope.createNewItem(item);
          });
        };

        /**
         * Criação de item
         * @param data
         */
        scope.createNewItem = function (data) {
          scope.createItem({item: data});
        };

        /**
         * Edição de item
         * @param id
         * @param column
         * @param data
         */
        scope.editItem = function (id, column, data) {
          var obj = {id: id};
          obj[column] = data;
          scope.saveItem({item: obj});
        };

        /**
         * Remove o filtro da lista
         */
        scope.removeFilter = function () {
          scope.filter.show = false;
          scope.query_filter = '';
        };

        /**
         * Exclui um motivo de cancelamento
         * @param id
         * @param name
         */
        scope.delete = function (id, name) {
          // ModalFactory.confirm(null, 'Excluir item', 'Confirma a exclusão do item ' + name + '?',
          //   'Confirmar', 'Cancelar', 'educational')
          //   .then(function () {
          //     $rootScope.show_loader = true;
          //     EducationalTablesService.delete({id: id, table: vm.table.id})
          //       .then(function () {
          //         $rootScope.show_loader = false;
          //         Common.Toast.success('Item excluído com sucesso!');
          //         vm.changeTable(vm.table);
          //       })
          //       .catch(function () {
          //         $rootScope.show_loader = false;
          //         Common.Toast.error('Não foi possível excluir o item');
          //       })
          //   })
        };

        /**
         * Abre o input para edição do item
         * @param event
         * @param item
         * @param column
         */
        scope.editComment = function (event, item, column) {
          event.stopPropagation();
          var promise = $mdEditDialog.small({
            modelValue: item[column],
            placeholder: 'Add a comment',
            save: function (input) {
              scope.editItem(item.id, column, input.$modelValue);
              item[column] = input.$modelValue;
            },
            targetEvent: event,
            validators: {
              'md-maxlength': 100
            }
          });
          promise.then(function (ctrl) {
            var input = ctrl.getInput();
            input.$viewChangeListeners.push(function () {
              // dessert.name = input.$modelValue;
              input.$setValidity('test', input.$modelValue !== 'test');
              // input.$setViewValue('aberto');
            });
          });
        };

      }
    }
  }

  angular
    .module('app.a4-crud-table')
    .directive('a4CrudTable', a4CrudTable)
})();

(function () {
  'use strict';

  angular.module('app.a4crmcontactgrid', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CrmContactGrid($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        type: '=?',
      },
      controller: 'a4CrmContactGridController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-crm-contact-grid/views/index.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4crmcontactgrid')
    .directive('a4CrmContactGrid', a4CrmContactGrid);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CrmContactGridController($rootScope, $scope, $a4FloatButton, a4Moment, Common, ChargeService, ModalFactory) {
    var vm = this;
    vm.is_edit = false;
    vm.searchOccurrence = null;
    vm.searchResponsible = null;
    vm.option = null;
    vm.type = $scope.type;

    /**
     * Busca todos os eventos de cobrança
     * @param page
     * @param limit
     */
    vm.getAll = function (page, limit, searchOccurrence, searchResponsible, option) {
      $rootScope.show_loader = true;
      limit = angular.isDefined(limit) ? limit : 50;
      page = angular.isDefined(page) ? page : 1;
      ChargeService.getAll({
        limit: limit, page: page,
        searchOccurrence: searchOccurrence,
        searchResponsible: searchResponsible,
        option: option,
        type: vm.type
      }).then(function (response) {
        vm.charges = response;
        $rootScope.show_loader = false;
      })
    };

    /**
     * Abre modal de criação de evento de cobrança
     */
    vm.openCreateModal = function () {
      ModalFactory.customClean('app/crm/charge/charge-modal.html',
        'ChargeModalController', 'vm', false, {
          type: $scope.type
        }).then(function (response) {
        if (response) {
          vm.getAll();
        }
      })
    };

    /**
     * Abre modal de edição de evento de cobrança
     * @param item
     */
    vm.editCharge = function (item) {
      var charge = angular.copy(item);
      charge.person_id_contacts = JSON.parse(charge.person_id_contacts);
      ModalFactory.customClean('app/crm/charge/charge-modal.html',
        'ChargeModalEditController', 'vm', false, {
          type: $scope.type,
          form: charge,
          responsible_name: angular.copy(item.responsible_name),
          person_event_name: angular.copy(item.person_event_name)
        }).then(function (response) {
        if (response) {
          vm.getAll();
        }
      })
    };

    /**
     * Exclui evento de cobrança
     * @param item
     */
    vm.delete = function (item) {
      ModalFactory.confirm(
        null,
        'Confirmação',
        'Você deseja excluir esse evento de cobrança?',
        'Excluir',
        'Cancelar',
        'crm'
      ).then(function () {
          $rootScope.show_loader = true;
          ChargeService.deleteCharge(item).then(function () {
            Common.Toast.success('Evento excluído com sucesso!');
            vm.getAll();
          }).catch(function () {
            Common.Toast.error('Erro na remoção do evento!');
            $rootScope.show_loader = false;
          });
        }
      )
    };

    vm.init = function () {
      vm.getAll();
      vm.floatButton = $a4FloatButton({
        scope: $scope, onClick: 'vm.openCreateModal()', label: 'Criar nova ocorrência', theme: 'crm'
      });

    };

    vm.init();
  }

  angular.module('app.a4crmcontactgrid')
    .controller('a4CrmContactGridController', a4CrmContactGridController);
})();
(function () {
  'use strict';

  angular
    .module('app.a4creditsperson', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CreditsPerson($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        personId: '=?',
        balance: '=?'
      },
      controller: 'A4CreditsPersonController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-credits-person/index.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4creditsperson')
    .directive('a4CreditsPerson', a4CreditsPerson);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4CreditsPersonController($scope, $state, $document, CONFIG, ReportsService, Session, $rootScope, CreditsService, ModalFactory, Common) {
    var vm = this;
    vm.credits = [];
    vm.webLink = CONFIG.webApiUri;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.actual_balance = 0;

    $rootScope.$on('UPDATE_CREDITS_LIST', function () {
      vm.getMovements();
    });

    vm.getMovements = function () {
      CreditsService.getCreditsPerson({person_id: $scope.personId})
        .then(function (response) {
          vm.movements = response.plain();
          if (vm.movements.length > 0){
            vm.actual_balance = vm.movements[vm.movements.length - 1].balance;
            $scope.balance = vm.actual_balance;
          }
        })
    };

    vm.printCreditCheckpad = function (data) {
      ReportsService.reportFactory('GET',
        'api/reports/creditcheckpad',
        {
          amount: data.amount,
          user_id: vm.conf.user_id,
          person_id: vm.movements[0].person_id,
          movement_type_id: data.movement_type_id,
          current_account_id: data.current_account_id,
          movement_id: data.movement_id,
          notes: (angular.isDefined(data.notes) ? data.notes : null)
        }).catch(function () {
        Common.Toast.error("Registro não encontrado");
      })
    };

    vm.printCreditCheckpadSecondWay = function (movement_id) {
      $rootScope.show_loader = true;
      CreditsService.getRefundInfo({movement_id: movement_id}).then(function (response) {
        $rootScope.show_loader = false;
        var data = response.plain();
        data.movement_id = data.id;
        vm.printCreditCheckpad(data);
      })
    };

    vm.refund = function () {
      var credit = {};
      ModalFactory.custom('app/components/a4-credits-person/refund.html', {
        movement_type: null, current_account: null,
        amount: angular.copy(vm.movements[vm.movements.length - 1].balance),
        max_amount: angular.copy(vm.movements[vm.movements.length - 1].balance)
      }).then(function (data) {
        credit.movement_type_id = data.movement_type_id;
        credit.current_account_id = data.current_account_id;
        credit.notes = data.notes;
        credit.amount = data.amount;
        credit.person_id = vm.movements[0].person_id;
        $rootScope.show_loader = true;
        CreditsService.refundCredit(credit).then(function (response) {
          Common.Toast.success('Crédito reembolsado com sucesso!');
          $rootScope.show_loader = false;
          ModalFactory.custom('app/components/a4-credits-person/refund-print-checkpad.html', {}).then(function (print_checkpad) {
            if (print_checkpad) {
              data.movement_id = response.id;
              vm.printCreditCheckpad(data);
            }
          });
          vm.getMovements();
        })
      })
    };

    vm.init = function () {
      vm.getMovements();
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      vm.conf.user_id = Session.user.id;
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
    };

    vm.init();

  }

  angular.module('app.a4creditsperson')
    .controller('A4CreditsPersonController', A4CreditsPersonController);
})();

(function () {
  'use strict';

  angular.module('app.a4cpf', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4cpf() {
    return {
      restrict: 'E',
      scope: {
        model: '=?',
        classes: '=?',
        isEnabled: '=?',
        personId: '=?',
        isRequired: '=?',
        doCheck: '=?',
        showOwner: '=?',
        isPreEnrolment: '=?'
      },
      controller: 'a4CPFController',
      controllerAs: 'vm',
      require: ['^form'],
      templateUrl: 'app/components/a4-cpf/a4-cpf.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4cpf')
    .directive('a4cpf', a4cpf);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CPFController(PersonService, EducationalService,
                           $scope, $timeout, $rootScope, ModalFactory, $window) {
    var vm = this;
    vm.cpf_error = false;
    vm.cpf_error_message = null;
    vm.is_national_id_number_required = true;

    vm.verifyCPF = function (cpf) {
      $timeout(function () {
        vm.cpf_error = false;
        vm.cpf_error_message = null;
        if (angular.isDefined(cpf) && cpf !== null && cpf !== '' && angular.isUndefined($scope.isPreEnrolment)) {
          $rootScope.show_loader = true;
          PersonService.verifyCPF({cpf: cpf, person_id: $scope.personId})
            .then(function (response) {
              $rootScope.show_loader = false;
              if (angular.isDefined(response)) {
                vm.cpf_error = true;
                var owner_message = ', pertence ao usuário ' + response;
                vm.cpf_error_message = 'Este CPF já existe no sistema';
                if ($scope.showOwner !== false) {
                  vm.cpf_error_message += owner_message;
                }
                $rootScope.$broadcast('cpfErrorChanged', vm.cpf_error);
              } else {
                vm.cpf_error = false
                $rootScope.$broadcast('cpfErrorChanged', vm.cpf_error);
              }
            })
        } else if (angular.isDefined(cpf) && cpf !== null && cpf !== '' && angular.isDefined($scope.isPreEnrolment) && $scope.isPreEnrolment === true) {
          $rootScope.show_loader = true;
          PersonService.preEnrolmentVerifyCPF({cpf: cpf})
            .then(function (response) {
              $rootScope.show_loader = false;
              if (angular.isDefined(response.name)) {
                vm.cpf_error = true;
                ModalFactory.confirm(null,'Atenção',
                  'Já existe uma conta registrada para esse CPF em nome de ' + response.name + ' para continuar a partir dessa conta pressione o botão "Confirmar".', 
                  'Confirmar', 'Cancelar', 'educational'
                ).then(function () {
                  $rootScope.isHiddenInformation = true;

                  var responsible = angular.copy(response);
                  delete responsible.confirmation_link;
                  $rootScope.currentResponsibleAccount = responsible;

                  $window.location.replace(response.confirmation_link)
                })
              } else {
                vm.cpf_error = false
                $rootScope.$broadcast('cpfErrorChanged', vm.cpf_error);
              }
            })
        } else if ($scope.isRequired && vm.is_national_id_number_required){
          vm.cpf_error = true;
          vm.cpf_error_message = 'Por favor, digite um CPF válido.';
          $rootScope.$broadcast('cpfErrorChanged', vm.cpf_error);
        }
      }, 300);
      $rootScope.show_loader = false;
    };

    vm.init = function () {
      /*EducationalService.hasNationalIdNumberRequired().then(function (response) {
        var obj = response.plain();
        vm.is_national_id_number_required = obj.is_national_id_number_required;
      });*/
    };

    $scope.$watch('isEnabled', function (newValue) {
      if (newValue === true) {
        EducationalService.hasNationalIdNumberRequired().then(function (response) {
          var obj = response.plain();
          vm.is_national_id_number_required = obj.is_national_id_number_required;
        });
      }
    })

    vm.init();

  }

  angular.module('app.a4cpf')
    .controller('a4CPFController', a4CPFController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function createContractController($rootScope, ModalExtra, $filter, a4Moment, Common, PersonService, ContractService,
                                    ProductService, BillReceiptService, ModalFactory, $scope) {

    var vm = this;
    vm.payment_plans = [];
    vm.frequency_options = BillReceiptService.getFrequencyOptions();
    vm.preferencial_due_day_list = BillReceiptService.range();
    vm.block_fields = {date: false, amount: false};
    vm.contract = {};
    vm.contract.person_beneficiary = null;

    /**
     *
     */
    vm.init = function () {
      vm.contract = angular.isDefined(ModalExtra.contract) ? ModalExtra.contract : vm.contract;
      vm.selectedService = angular.isDefined(ModalExtra.selectedService) ? ModalExtra.selectedService : null;
      vm.payment_plans = angular.isDefined(ModalExtra.payment_plans) ? ModalExtra.payment_plans : [];
      vm.contract.individual_discounts = angular.isDefined(ModalExtra.individual_discounts) ? ModalExtra.individual_discounts : [];
      vm.payment_installments = angular.isDefined(ModalExtra.payment_installments) ? ModalExtra.payment_installments : [];
      vm.reopen = angular.isDefined(ModalExtra.reopen);
      if (!vm.reopen && angular.isDefined(vm.contract.payment_plan_id)) {
        vm.setPaymentPlan(vm.contract.payment_plan_id)
      }
    };

    /**
     * Retorna serviços possíveis para um contrato, excluindo serviços associados à turmas do educacional
     */
    vm.getServices = function (query) {
      return ContractService.getServices({search: query});
    };

    /**
     * Retorna a lista de pessoas filtrada pela consulta para o auto complete
     * @param query - nome pesquisado
     * @returns {Void}
     */
    vm.listAllPersons = function (query) {
      return PersonService.listAll({query: query, all_companies: false});
    };

    /**
     * Retorna a lista de pessoas filtrada pela consulta para o auto complete
     * do beneficiário
     * @param query - nome pesquisado
     * @returns {Void}
     */
    vm.listAllPersonsForBeneficiary = function (query) {
      return PersonService.listAll({query: query, all_companies: true});
    };

    vm.setItem = function (item) {
      vm.getPaymentPlansForProduct(item.id);
    };

    /**
     * Busca os planos de aula para o serviço
     */
    vm.getPaymentPlansForProduct = function (product_id) {
      ProductService.getById(product_id)
        .then(function (response) {
          vm.clearPaymentPlan();
          vm.payment_plans = response.selectedPaymentPlans;
          if (vm.payment_plans.length === 1) {
            vm.setPaymentPlan(vm.payment_plans[0].payment_plan_id);
          }
        })
    };

    /**
     * Limpa as informações relativas ao plano de pagamento
     */
    vm.clearPaymentPlan = function () {
      vm.contract.payment_plan_id = null;
      vm.contract.quantity = null;
      vm.contract.bank_slip_rule_id = null;
      vm.contract.frequency = null;
      vm.contract.frequency_qty = null;
      vm.contract.product_id = null;
      vm.contract.date_end = null;
      vm.contract.amount = null;
      vm.contract.date_first = null;
      vm.contract.first_installment_date = null;
      vm.contract.first_installment_date_type = null;
      vm.contract.first_installment_date_days = null;

      $scope.$applyAsync();
    };

    /**
     * Seta as informações relacionadas ao plano de pagamento escolhido
     * @param payment_plan_id
     */
    vm.setPaymentPlan = function (payment_plan_id) {
      vm.clearPaymentPlan();
      var selected = $filter('filter')(vm.payment_plans, {payment_plan_id: payment_plan_id}, true)[0];
      vm.contract.payment_plan_id = payment_plan_id;
      vm.contract.quantity = selected.quantity;
      vm.contract.bank_slip_rule_id = selected.bank_slip_rule_id;
      vm.contract.frequency = selected.frequency;
      vm.contract.frequency_qty = selected.frequency_qty;
      vm.contract.recurrence_on_value = selected.recurrence_on_value;
      vm.contract.product_id = selected.product_id;
      vm.contract.debit_credit = 'C';
      vm.contract.first_installment_date_type = selected.first_installment_date_type;
      vm.contract.first_installment_date_days = selected.first_installment_date_days;
      vm.contract.date_end = angular.isDefined(selected.date_end) ? selected.date_end : null;
      vm.contract.amount = selected.recurrence_on_value === 2 ? (selected.price / selected.quantity) : selected.price;
      vm.contract.date_first = selected.date_first === null || selected.date_first === '' ? '' : a4Moment(selected.date_first).format('YYYY-MM-DD');
      vm.block_fields.date = (selected.date_first !== null && selected.date_first !== '');
      vm.block_fields.amount = (vm.contract.amount > 0);
      if (vm.contract.date_first !== null) {
        vm.setFirstInstallmentDate(a4Moment(vm.contract.date_first));
      }
      if (vm.contract.recurrence_on_value === 1) {
        vm.generateInstalmentsByPaymentPlan(selected);
      }
    };

    vm.reopenModal = function (discount) {
      var amount = vm.contract.amount;
      var individual_discounts = [];
      if (discount !== 'canceled') {
        discount.start_date = discount.start_date !== null ? a4Moment(discount.start_date).format('YYYY-MM-DD') : null;
        discount.end_date = discount.end_date !== null ? a4Moment(discount.end_date).format('YYYY-MM-DD') : null;
        individual_discounts.push(discount);
      }

      angular.forEach(vm.contract.individual_discounts, function (item) {
        individual_discounts.push(item)
      });
      vm.openContractModal({
        contract: vm.contract,
        payment_plans: vm.payment_plans,
        individual_discounts: individual_discounts,
        payment_installments: vm.contract.payment_installments,
        amount: amount,
        reopen: true,
        vinculated_services: vm.vinculated_services,
        selectedService: vm.selectedService
      });
    };

    /**
     * Criação de desconto individual
     */
    vm.createNewIndividualDiscount = function () {
      ModalFactory.customClean(
        'app/components/a4-discounts/modal.html',
        'A4DiscountsController', 'vm', false, {theme: 'educational'}
      ).then(function (discount) {
        vm.reopenModal(discount);
      });
    };

    /**
     * Retornar para o modal anterior
     */
    vm.openContractModal = function (data) {
      ModalFactory.customClean(
        'app/components/a4-contract-grid/create-contract-modal.html',
        'CreateContractController',
        'vm', false, data
      );
    };

    /**
     * Remove um desconto da lista
     */
    vm.removeItemDesconto = function (index) {
      vm.contract.individual_discounts.splice(index, 1);
    };

    /**
     * Submissão do formulário de criação de contrato
     * @param contract - Dados do contrato
     * @param form - Objeto do formulário
     */
    vm.submitContract = function (contract, form) {
      if (form.$valid) {
        contract.date_first = a4Moment(contract.date_first).format('YYYY-MM-DD');
        vm.show_loading = true;
        ContractService.create(contract)
          .then(function () {
            vm.show_loading = false;
            Common.Toast.success('Contrato criado com sucesso');
            vm.close();
          })
          .catch(function (error) {
            vm.show_loading = false;
            Common.Toast.success(error.message);
          })
      }
    };

    /**
     * Gera as parcelas da recorrência no caso da seleção de um plano de pagamento
     * @param payment_plan
     */
    vm.generateInstalmentsByPaymentPlan = function (payment_plan) {
      vm.contract.payment_installments = [];
      var copy_plan = angular.copy(payment_plan);
      if (copy_plan.frequency > 0) {
        var qty = copy_plan.quantity > 0 ? copy_plan.quantity : vm.defineQtyByDates(copy_plan.date_first, copy_plan.date_end);
        for (var i = 1; i <= qty; i++) {
          var obj = {
            portion_name: i + '/' + qty,
            due_date: vm.getNextDate(copy_plan),
            amount: payment_plan.recurrence_on_value === 2 ? (copy_plan.amount / qty) : copy_plan.amount
          };
          vm.contract.payment_installments.push(obj);
        }
      } else {
        var obj = {
          portion_name: '1/1',
          due_date: copy_plan.date_first,
          amount: copy_plan.amount
        };
        vm.contract.payment_installments.push(obj);
      }
    };

    /**
     * Devolve a próxima data de vencimento para as parcelas
     * @param payment_plan
     * @returns {*}
     */
    vm.getNextDate = function (payment_plan) {
      var copy_plan = angular.copy(payment_plan);
      var len = vm.contract.payment_installments.length;
      var last_date = len > 0 ? vm.contract.payment_installments[len - 1].due_date : copy_plan.date_first;
      var frequency_value = $filter('filter')(vm.frequency_options, {id: copy_plan.frequency})[0].value;
      var date = a4Moment(last_date);

      if (len > 0) {
        date.add(copy_plan.frequency_qty, frequency_value)
      }

      return date;
    };

    /**
     * Define a quantidade de parcelas do contrato a partir das datas inicial e final
     * @param date_first
     * @param date_end
     * @returns {*}
     */
    vm.defineQtyByDates = function (date_first, date_end) {
      var qty = a4Moment(date_end).diff(a4Moment(date_first), 'months');
      return qty + 1;
    };

    /**
     * Define a data da primeira parcela do contrato baseada no di corrente
     * @param date moment
     */
    vm.setFirstInstallmentDate = function () {
      if (vm.contract.first_installment_date_type > 0 && angular.isDefined(vm.contract.first_installment_date_days)) {
        vm.contract.first_installment_date = a4Moment().add(vm.contract.first_installment_date_days, 'days').format('YYYY-MM-DD');
      }
      /*$scope.$apply();*/
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular.module('app.finance.contract.modal-edit')
    .controller('CreateContractController', createContractController)
})();
(function () {
  'use strict';
  angular.module('app.a4-contract-grid', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4ContractGrid(A4BillInfiniteControl) {
    return {
      templateUrl: 'app/components/a4-contract-grid/a4-contract-grid.html',
      restrict: 'E',
      controller: 'a4ContractGridController',
      controllerAs: 'vm',
      scope: {
        groupId: '=?',
        courseId: '=?',
        matrixPeriod: '=?',
        contractType: '=?',
        /** Variável verifica se oa diretiva esta dentro do fluxo de matrícula financeira */
        inFlow: '=?',
        withSchoolPeriod: '=',
        canEdit: '=?',
        paginate: '=ngModel',
        paginateFunction: '&',
        person_id: '=?',
        debitCredit: '@?', //"C" ou "D"
        withFilter: '=?',
        showLoader: '=?',
        studentData: '=?'
      },
      link: function (scope, element, attrs, ctrl) {
        scope.makeSearch = function (search) {
          ctrl.search = search;
          ctrl.internPaginate(scope.paginate.page, scope.paginate.per_page, search);
        };
        scope.inFlow = angular.isUndefined(scope.inFlow) ? false : scope.inFlow;
        scope.canEdit = angular.isUndefined(scope.canEdit) ? true : scope.canEdit;

        ctrl.groupId = scope.groupId;
        ctrl.inFlow = scope.inFlow;
        ctrl.courseId = scope.courseId;
        ctrl.withSchoolPeriod = scope.withSchoolPeriod;
        ctrl.matrixPeriod = scope.matrixPeriod;
        ctrl.contractType = scope.contractType;
      }
    }
  }

  angular.module('app.a4-contract-grid')
    .directive('a4ContractGrid', a4ContractGrid)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4ContractGridController($rootScope, $scope, $mdMenu, $a4FloatButton, a4Moment, A4BillInfiniteControl, PoliciesService,
                                    CONFIG, Session, ReportsService, $document, EnrolmentService, Utils, StudentsService,
                                    A4ContractService, BillReceiptService, ContractService, ModalFactory, BillExpenseService,
                                    Common, SettingsService, $filter, $timeout, FinanceReportsService) {
    var vm = this;
    vm.haveUpdate = false;
    vm.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    vm.WEB_CONST = CONFIG.webApiUri;
    vm.studentsResponsibles = [];

    vm.init = function () {
      vm.verifyIfHaveUpdate();
      vm.getLimitDates();
      if (angular.isDefined($scope.studentData) && $scope.studentData !== null) {
        vm.getStudentParents($scope.studentData.person_id, $scope.studentData.matrix_period, $scope.studentData.group_id);
      }
      vm.conf.current_company = Session.get('current_company', "sessionStorage");
      vm.conf.current_connection = $document[0].domain.split('.')[0];
      vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
      ReportsService.getToken()
        .then(function (token) {
          vm.conf.token = token;
        });
      vm.school_period_id = Session.getCurrentSchoolPeriod().id;

      $scope.paginateFunction({
        page: vm.page,
        qtd: vm.qtd,
        person_id: angular.isDefined($scope.person_id) ? $scope.person_id : undefined,
        search_name: ''
      });
    };

    vm.changePersonPayee = function (item) {
      console.log(item);
      if (vm.studentsResponsibles.length === 0) {
        $rootScope.show_loader = true;
        vm.getStudentParents(item.person_id_beneficiary, item.matrix_period, item.group_id);
        $timeout(function () {
          $rootScope.show_loader = false;
          vm.openChangePayeeModal(item);
        }, 6000);
      } else {
        vm.openChangePayeeModal(item);
      }
    };

    vm.openChangePayeeModal = function (item) {
      ModalFactory.custom('app/components/a4-contract-grid/edit-payee.html', {
        studentsResponsibles: vm.studentsResponsibles,
        person_payee: $filter('filter')(vm.studentsResponsibles, {is_payee: true})[0].id,
        product_name: item.product_name,
        contract_id: item.serie_id
      }, false).then(function (data) {
        $rootScope.show_loader = true;
        ContractService.updatePersonPayee(data)
          .then(function (resp) {
            $rootScope.show_loader = false;
            Common.Toast.success("Responsável financeiro atualizado com sucesso");
            $scope.paginateFunction({
              page: vm.page,
              qtd: vm.qtd,
              person_id: angular.isDefined($scope.person_id) ? $scope.person_id : undefined,
              search_name: ''
            });
          })
          .catch(function () {
            $rootScope.show_loader = false;
            Common.Toast.error("Erro ao atualizar contrato");
          });
      });
    }

    /**
     * Retorna a lista de responsáveis pelo aluno
     */
    vm.getStudentParents = function (person_id, matrix_period, group_id) {
      if (matrix_period === null) {
        matrix_period = 1;
      }
      StudentsService.getStudentParents({
        student_id: person_id,
        matrix_period: matrix_period,
        group_id: group_id
      })
        .then(function (response) {
          var data = response.plain();
          /**
           * Filtra os registros, formatando no grid os dados para apresentar os responsáveis financeiros e pedagógicos
           */
          for (var i = 0; i < data.length; i++) {
            if (angular.isDefined(data[i].person_id_payee) && data[i].person_id_payee === data[i].id) {
              data[i].is_payee = true;
              vm.payee = data[i].id;
            } else {
              data[i].is_payee = false;
            }
            if (angular.isDefined(data[i].person_id_responsible) && data[i].person_id_responsible === data[i].id) {
              data[i].is_responsible = true;
              vm.responsible = data[i].id;
            } else {
              data[i].is_responsible = false;
            }
          }
          vm.studentsResponsibles = data;
          $rootScope.show_loader = false;
        })
    };

    /**
     * Atualiza todos os contragtos
     */
    vm.updateContracts = function () {
      $rootScope.show_loader = true;
      BillReceiptService.updateContracts()
        .then(function () {
          Common.Toast.success("Contratos atualizados com sucesso");
          $rootScope.show_loader = false;
          vm.verifyIfHaveUpdate();
        })
        .catch(function () {
          Common.Toast.error("Erro ao atualizar contrato");
          $rootScope.show_loader = false;
        })
    };

    /**
     * Busca data limite de geração de títulos
     */
    vm.getLimitDates = function () {
      SettingsService.getLimitDates().then(function (response) {
        var limits = response.plain();
        if (limits[0].debit_limit !== null) {
          vm.debit_limit = a4Moment(limits[0].debit_limit).format('DD/MM/YYYY');
        }
        if (limits[0].credit_limit !== null) {
          vm.credit_limit = a4Moment(limits[0].credit_limit).format('DD/MM/YYYY');
        }
      })
    };

    /**
     * Abre modal para alterar data limite de criação de títulos, para contratos
     * sem prazo determinado.
     */
    vm.openChangeLimitDatesModal = function () {
      ModalFactory.customClean('app/components/a4-contract-grid/change-limit-date-modal.html',
        /** @ngInject */
        function ($rootScope, a4Moment, Common, ModalExtra, SettingsService, NFSEService) {
          var vm = this;
          vm.show_loading = false;
          vm.month_year = [
            {
              name: '01/19',
              value: '2019-01-31'
            }, {
              name: '02/19',
              value: '2019-02-28'
            }, {
              name: '03/19',
              value: '2019-03-31'
            }, {
              name: '04/19',
              value: '2019-04-30'
            }, {
              name: '05/19',
              value: '2019-05-31'
            }, {
              name: '06/19',
              value: '2019-06-30'
            }, {
              name: '07/19',
              value: '2019-07-31'
            }, {
              name: '08/19',
              value: '2019-08-30'
            }, {
              name: '09/19',
              value: '2019-09-31'
            }, {
              name: '10/19',
              value: '2019-10-30'
            }, {
              name: '11/19',
              value: '2019-11-31'
            }, {
              name: '12/19',
              value: '2019-12-30'
            }, {
              name: '01/20',
              value: '2020-01-31'
            }, {
              name: '02/20',
              value: '2020-02-28'
            }, {
              name: '03/20',
              value: '2020-03-31'
            }, {
              name: '04/20',
              value: '2020-04-30'
            }, {
              name: '05/20',
              value: '2020-05-31'
            }, {
              name: '06/20',
              value: '2019-06-30'
            }, {
              name: '07/20',
              value: '2020-07-31'
            }, {
              name: '08/20',
              value: '2020-08-30'
            }, {
              name: '09/20',
              value: '2020-09-31'
            }, {
              name: '10/20',
              value: '2020-10-30'
            }, {
              name: '11/20',
              value: '2020-11-31'
            }, {
              name: '12/20',
              value: '2020-12-30'
            }, {
              name: '01/21',
              value: '2021-01-31'
            }, {
              name: '02/21',
              value: '2021-02-28'
            }, {
              name: '03/21',
              value: '2021-03-31'
            }, {
              name: '04/21',
              value: '2021-04-30'
            }, {
              name: '05/21',
              value: '2021-05-31'
            }, {
              name: '06/21',
              value: '2021-06-30'
            }, {
              name: '07/21',
              value: '2021-07-31'
            }, {
              name: '08/21',
              value: '2021-08-30'
            }, {
              name: '09/21',
              value: '2021-09-31'
            }, {
              name: '10/21',
              value: '2021-10-30'
            }, {
              name: '11/21',
              value: '2021-11-31'
            }, {
              name: '12/21',
              value: '2021-12-30'
            }, {
              name: '01/22',
              value: '2022-01-31'
            }, {
              name: '02/22',
              value: '2022-02-28'
            }, {
              name: '03/22',
              value: '2022-03-31'
            }, {
              name: '04/22',
              value: '2022-04-30'
            }, {
              name: '05/22',
              value: '2022-05-31'
            }, {
              name: '06/22',
              value: '2022-06-30'
            }, {
              name: '07/22',
              value: '2022-07-31'
            }, {
              name: '08/22',
              value: '2022-08-30'
            }, {
              name: '09/22',
              value: '2022-09-31'
            }, {
              name: '10/22',
              value: '2022-10-30'
            }, {
              name: '11/22',
              value: '2022-11-31'
            }, {
              name: '12/22',
              value: '2022-12-30'
            }, {
              name: '01/23',
              value: '2023-01-31'
            }, {
              name: '02/23',
              value: '2023-02-28'
            }, {
              name: '03/23',
              value: '2023-03-31'
            }, {
              name: '04/23',
              value: '2023-04-30'
            }, {
              name: '05/23',
              value: '2023-05-31'
            }, {
              name: '06/23',
              value: '2023-06-30'
            }, {
              name: '07/23',
              value: '2023-07-31'
            }, {
              name: '08/23',
              value: '2023-08-30'
            }, {
              name: '09/23',
              value: '2023-09-31'
            }, {
              name: '10/23',
              value: '2023-10-30'
            }, {
              name: '11/23',
              value: '2023-11-31'
            }, {
              name: '12/23',
              value: '2023-12-30'
            }
          ];
          vm.init = function () {
            vm.getCurrentCompany().then(function (response) {
              vm.company = response.plain();
            })
          };
          /**
           * Busca os dados da empresa corrente
           */
          vm.getCurrentCompany = function () {
            return NFSEService.getCurrentCompany();
          };

          vm.changeLimitDates = function () {
            vm.show_loading = true;
            SettingsService.changeLimitDates(vm.company).then(function (response) {
              if (response) {
                vm.close();
                Common.Toast.success('Datas limites alteradas com sucesso!');
              }
            })
          };

          vm.close = function () {
            $rootScope.$broadcast('ModalFactory.close');
          };

          vm.init();
        }, 'vm', false, {}).then(function () {
        vm.getLimitDates();
      })
    };
    /**
     * Verifica se existem contratos para serem atualizados
     */
    vm.verifyIfHaveUpdate = function () {
      BillReceiptService.haveContracts()
        .then(function (response) {
          vm.haveUpdate = response;
          $rootScope.show_loader = false;
        })
    };

    vm.printEnrolmentContract = function (bill_serie_id, beneficiary_id, group_id, artifact_id, is_group_contract, is_confirmed) {
      $rootScope.show_loader = true;
      // if (!is_group_contract) {
      //   ContractService.printServiceContract(bill_serie_id)
      //     .then(function () {
      //       $rootScope.show_loader = false;
      //       Common.Toast.success('Download concluído');
      //     })
      //     .catch(function (error) {
      //       $rootScope.show_loader = false;
      //       Common.Toast.warning(error.message);
      //     });
      // } else { 
      
        if (artifact_id !== null && is_confirmed) {
          ContractService.printDocument(bill_serie_id, artifact_id)
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Download concluído');
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.warning(error.data.message);
            });
        } else {
          EnrolmentService.printEnrolmentContract({
            person_id: beneficiary_id,
            bill_serie_id: bill_serie_id,
            is_finance: true,
            group_id: group_id
          })
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Download concluído');
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.warning(error.data.message);
            })
        }
      // }
    };

    vm.internPaginate = function (page, qtd, search) {
      $rootScope.show_loader = true;
      vm.qtd = angular.isUndefined($scope.paginate) ? qtd : $scope.paginate.per_page;
      vm.page = angular.isUndefined($scope.page) ? page : $scope.paginate.current_page;
      /** Flag para notificar a possível mudança do filtro */
      $scope.paginateFunction({
        page: vm.page,
        qtd: vm.qtd,
        person_id: vm.qtd,
        search_name: search
      });
      $rootScope.show_loader = false;
    };

    /**
     * Realiza o cancelamento de um contrato
     * @param item
     */
    vm.cancelContract = function (item) {
      if (angular.isDefined(item.external_id) && item.external_id !== null && false) {
        ModalFactory.alert(
          "Contrato não pode ser cancelado", "Este contrato está associado a uma matrícula do sistema pedagógico. Para cancelá-lo, realize o processo" +
          " de cancelamento de matrícula. ",
          "modal", "Ok", "false", "finance"
        );
        return;
      }

      ModalFactory.custom('app/components/a4-contract-grid/cancel-contract-date.html', null, false, null)
        .then(function (object) {
          $rootScope.show_loader = true;
          object.date = a4Moment(object.date).format('YYYY-MM-DD');
          ModalFactory.open('require_password', null, null, {bill_serie_id: item.serie_id, date: object.date},
            null, 'finance', vm.executeCancelContract, 'Cancelamento de contrato', 'Confirme a senha para cancelar o contrato', null)
            .then(function () {
              Common.Toast.success('Contrato cancelado com sucesso!');
              vm.internPaginate();
              $rootScope.show_loader = false;
            });
        });
    };

    /**
     * Executa o cancelamento do contrato
     * @param obj
     * @returns {void|*}
     */
    vm.executeCancelContract = function (obj) {
      return ContractService.cancelContract(obj);
    };

    /**
     * Desfaz o cancelamento de um contrato
     * @param serie_id
     */
    vm.undoCancelContract = function (serie_id) {
      ModalFactory.open('require_password', null, null, {bill_serie_id: serie_id},
        null, 'finance', vm.executeUndoCancelContract, 'Desfazimento de cancelamento de contrato',
        'Confirme a senha para desfazer o cancelamento do contrato', null).then(function () {
        Common.Toast.success('Contrato descancelado com sucesso!');
        vm.internPaginate();
        $rootScope.show_loader = false;
      })
    };

    /**
     * Executa o desfazimento do cancelamento de um contrato
     * @param obj
     * @returns {void|*}
     */
    vm.executeUndoCancelContract = function (obj) {
      return ContractService.undoCancelContract(obj);
    };

    /**
     * Adiciona nova parcela ao contrato
     * @param serie_id
     */
    vm.addInstallment = function (serie_id) {
      ContractService.getNextDueDate(serie_id).then(function (data) {
        ModalFactory.custom('app/components/a4-contract-grid/add-installments-modal.html', {
          due_date: a4Moment(data.due_date).add('month', 1),
          quantity: 1,
          amount: data.amount
        }).then(function (data) {
          ContractService.addInstallment({serie_id: serie_id, data: data})
            .then(function () {
              Common.Toast.success('Parcela adicionada com sucesso!');
              vm.internPaginate();
            })
        })
      })
    };

    /**
     * Realiza a exclusão de um contrato
     * @param serie_id
     */
    vm.deleteContract = function (serie_id) {
      ModalFactory.confirm(null,
        "Exclusão de contrato",
        "Deseja realmente excluir este contrato?",
        'Excluir', 'Não',
        'finance'
      ).then(function () {
        $rootScope.show_loader = true;
        ContractService.deleteContract({bill_serie_id: serie_id})
          .then(function () {
            Common.Toast.success('Contrato excluído com sucesso!');
            vm.internPaginate();
            $rootScope.show_loader = false;
          })
          .catch(function (response) {
            $rootScope.show_loader = false;
            if (angular.isDefined(response.data.message)) {
              ModalFactory.alert(
                "Ação não realizada", response.data.message,
                "modal", "Ok", "false", "finance"
              );
            } else {
              Common.Toast.error('Erro ao excluir contrato');
            }
          })
      });
    };

    vm.deleteSignedContract = function (artifact_id,bill_serie_id) {
      ModalFactory.confirm(null,
        "Exclusão de contrato",
        "Deseja realmente excluir este contrato assinado?",
        'Excluir', 'Não',
        'finance'
      ).then(function () {
        $rootScope.show_loader = true;
        ContractService.deleteSignedContract({
          artifact_id: artifact_id,
          bill_serie_id: bill_serie_id})
          .then(function () {
            Common.Toast.success('Contrato excluído com sucesso!');
            vm.internPaginate();
            $rootScope.show_loader = false;
          })
          .catch(function (response) {
            $rootScope.show_loader = false;
            if (angular.isDefined(response.data.message)) {
              /** olhar como esse erro personalizado funciona
               * na exclusao normal de contrato
               */
              ModalFactory.alert(
                "Ação não realizada", response.data.message,
                "modal", "Ok", "false", "finance"
              );
            } else {
              Common.Toast.error('Erro ao excluir contrato');
            }
          })
      });
    }

    vm.defineType = function (item) {
      if (item.portion_amount == null) {
        return "Recorrência";
      } else {
        return "Parcelamento";
      }
    };

    vm.defineAmount = function (item) {
      return item.next_amount;
    };

    vm.defineFrequency = function (item) {
      switch (item.frequency) {
        case 0:
          return "Título parcelado";
        case 1:
          return "A cada " + item.frequency_qty + " dia(s)";
        case 2:
          return "A cada " + item.frequency_qty + " mês(es)";
        case 3:
          return "A cada " + item.frequency_qty + "ano(s)";
        case 20:
          return "Datas irregulares";
        case 30:
          return "Sob demanda";
      }
    };

    vm.defineSituation = function (item) {
      if (item.amount_late > 0) {
        return 'INADIMPLENTE';
      }
      if (item.amount_open > 0) {
        return 'EM_DIA';
      }
      return 'LIQUIDADO';
    };

    vm.defineTooltip = function (item) {
      if (item.amount_late > 0) {
        var qty_bills = item.qty_late;
        var value_open = Utils.realMask(item.amount_late);
        return 'Existe um total de ' + qty_bills + " títulos inadimplentes, somando um total de " + value_open;
      }
      if (item.amount_open > 0) {
        return 'O contrato está em dia, com um total de ' + item.qty_open + ' títulos ainda em aberto.';
      }
      return 'Todas as parcelas do contrato foram pagas.';
    };

    vm.getCategories = function () {
      BillExpenseService.getCategories(vm.debit_credit)
        .then(function (response) {
          if (response) {
            vm.categories = response;
            $rootScope.show_loader = false;
          }
        })
        .catch(function (response) {
          vm.apiErrorMessageByStatusCode(response);
        });
    };

    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista.');
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor.');
          break;
      }
    };

    /**
     * Modifica o dia preferêncial de pagamento
     */
    vm.changePreferentialDay = function (bill_serie_id) {
      ModalFactory.prompt(null, 'Modificar dia preferencial de vencimento',
        'Escreva o dia no campo abaixo, entre 1 e 31', 'Dia Preferêncial', null,
        'Modificar', 'Cancelar', 'finance', null, true
      ).then(function (response) {
        if (response < 1 || response > 31) {
          Common.Toast.warning('Dia preferêncial deve ser entre 1 e 31');
          return false;
        } else {
          $rootScope.show_loader = true;
          A4ContractService.updatePreferentialDay(bill_serie_id, response)
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Dia preferêncial alterado com sucesso!');
              vm.internPaginate(vm.page, vm.qtd, vm.search);
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.error(error.message);
            });
        }
      });
    };

    /**
     * Abre o modal de descontos individuais
     * @param bill_serie
     */
    vm.getIndividualDiscounts = function (bill_serie) {
      ModalFactory.customClean(
        'app/components/a4-contract/individual-discounts/discounts.html',
        'A4ContractIndividualDiscountsController',
        'vm', false, {
          bill_serie_id: bill_serie.serie_id, theme: 'finance',
          contract_name: bill_serie.product_name
        })
    };

    /**
     * Criação de um contrato
     */
    vm.openCreateModal = function () {
      ModalFactory.customClean('app/components/a4-contract-grid/create-contract-modal.html',
        'CreateContractController', 'vm', true, {'categories': vm.categories})
        .then(function () {
          vm.internPaginate(vm.page, vm.qtd, vm.search);
        });
    };

    /**
     * Edição de contrato
     */
    vm.editContract = function (bill_serie_id) {
      if (!vm.checkPolicies('contrato_alt')) {
        ModalFactory.customClean(
          'app/components/a4-contract-grid/edit-contract-modal.html',
          'EditContractController',
          'vm', false, {bill_serie_id: bill_serie_id, theme: 'finance'}
        )
          .then(function () {
            vm.internPaginate(vm.page, vm.qtd, vm.search);
          });
      }
    };

    /**
     * Modificação de plano de pagamento
     */
    vm.changePaymentPlan = function (bill_serie_id) {
      ModalFactory.customClean(
        'app/components/a4-contract-grid/change-payment-plan.html',
        'ContractChangePlanController',
        'vm', false, {bill_serie_id: bill_serie_id, theme: 'finance'}
      )
        .then(function () {
          vm.internPaginate(vm.page, vm.qtd, vm.search);
        });
    };

    vm.printPaymentBook = function(bill_serie_id) {
      ReportsService.reportFactory('GET', 'api/contract/printpaymentbookcontract',
        {
          bill_serie_id: bill_serie_id
        })
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    vm.init();

  }

  angular.module('app.a4-contract-grid')
    .controller('a4ContractGridController', a4ContractGridController)
})();

(function () {
  'use strict';

  /** @ngInject */
  function EditContractController($rootScope, ModalExtra, $filter, a4Moment, Common, PersonService, ContractService) {

    var vm = this;
    vm.maxdate = null;
    vm.contract = {
      date_end: null,
      validity_date: a4Moment()
    };

    vm.init = function () {
      vm.bill_serie_id = ModalExtra.bill_serie_id;
      vm.mindate = a4Moment();
      vm.getContract(ModalExtra.bill_serie_id);
    };

    /**
     * Retorna o contrato
     * @param bill_serie_id
     */
    vm.getContract = function (bill_serie_id) {
      ContractService.getById(bill_serie_id)
        .then(function (contract) {
          vm.contract = contract.plain();
          vm.contract.validity_date = a4Moment();
          vm.contract.date_end = contract.date_end == null ? a4Moment(null) : a4Moment(contract.date_end);
          vm.maxdate = contract.date_end == null ? undefined : a4Moment(contract.date_end);
        })
    };

    /**
     * Modificação de plano de pagamento
     */
    vm.changePlan = function (bill_serie_id) {
      ContractService.changePaymentPlan(bill_serie_id)
        .then(function () {
          vm.show_loading = false;
          Common.Toast.success('Plano alterado com sucesso');
          vm.close();
        })
        .catch(function (error) {
          vm.show_loading = false;
          Common.Toast.error(error.message || error.data.message);
        })
    };

    /**
     * Submissão do formulário de criação de contrato
     * @param contract - Dados do contrato
     * @param form - Objeto do formulário
     */
    vm.updateContract = function (contract, form) {
      if (form.$valid) {
        vm.show_loading = true;
        var contractsend = angular.copy(contract);
        contractsend.date_end = contractsend.date_end == null ? undefined : a4Moment(contractsend.date_end).format('YYYY-MM-DD');
        contractsend.validity_date = contractsend.validity_date.format('YYYY-MM-DD');
        ContractService.update(contractsend, vm.bill_serie_id)
          .then(function () {
            vm.show_loading = false;
            Common.Toast.success('Contrato atualizado com sucesso');
            vm.close();
          })
          .catch(function (error) {
            vm.show_loading = false;
            Common.Toast.error(error.message || error.data.message);
          })
      }
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular.module('app.finance.contract.modal-edit')
    .controller('EditContractController', EditContractController)
})();
(function () {
  'use strict';

  /** @ngInject */
  function ContractChangePlanController($rootScope, ModalExtra, $filter, a4Moment, Common, ProductService,
                                        PersonService, ContractService, BillReceiptService, $scope, ModalFactory) {

    var vm = this;
    vm.frequency_options = BillReceiptService.getFrequencyOptions();
    vm.preferencial_due_day_list = BillReceiptService.range();
    vm.payment_plans = [];
    vm.can_change = null;
    vm.block_fields = {date: false, amount: false};
    vm.contract = {
      date_end: null,
      validity_date: a4Moment()
    };

    vm.init = function () {
      vm.bill_serie_id = ModalExtra.bill_serie_id;
      vm.changeCheck(vm.bill_serie_id)
        .then(function (can_change) {
          vm.can_change = can_change;
          vm.getContract(ModalExtra.bill_serie_id);
        })
        .catch(function (cant_change) {
          vm.can_change = cant_change;
        })
    };

    /**
     * Verifica a possibilidade a alteração do plano de pagamento para o contrato
     */
    vm.changeCheck = function (bill_serie_id) {
      var deffered = Common.$q.defer();
      ContractService.changePlanCheck(bill_serie_id)
        .then(function (can_change) {
          console.log(can_change.has_paid_bill)
          if (can_change) {
            deffered.resolve(can_change);
          } else {
            deffered.reject(can_change);
          }
        })
        .catch(function (error) {
          Common.Toast.error(error.message || error.data.message);
        });
      return deffered.promise;
    };

    /**vm.payment_plans
     * Retorna o contrato
     * @param bill_serie_id
     */
    vm.getContract = function (bill_serie_id) {
      ContractService.getById(bill_serie_id)
        .then(function (contract) {
          vm.contract = contract.plain();
          vm.contract.validity_date = a4Moment();
          vm.contract.date_end = contract.date_end == null ? a4Moment(null) : a4Moment(contract.date_end);
          vm.maxdate = contract.date_end == null ? undefined : a4Moment(contract.date_end);
          vm.getPaymentPlansForProduct(vm.contract.service.id);
        })
    };

    /**
     * Busca os planos de aula para o serviço
     */
    vm.getPaymentPlansForProduct = function (product_id) {
      ProductService.getById(product_id)
        .then(function (response) {
          vm.payment_plans = response.selectedPaymentPlans;
          if (vm.payment_plans.length === 1) {
            vm.setPaymentPlan(vm.payment_plans[0].payment_plan_id);
          }
        })
    };

    /**
     * Seta as informações relacionadas ao plano de pagamento escolhido
     * @param payment_plan_id
     */
    vm.setPaymentPlan = function (payment_plan_id) {
      var selected = $filter('filter')(vm.payment_plans, {payment_plan_id: payment_plan_id}, true)[0];
      vm.selected_paymentplan = selected;
      vm.contract.payment_plan_id = payment_plan_id;
      vm.contract.quantity = selected.quantity;
      vm.contract.bank_slip_rule_id = selected.bank_slip_rule_id;
      vm.contract.frequency = selected.frequency;
      vm.contract.frequency_qty = selected.frequency_qty;
      vm.contract.product_id = selected.product_id;
      vm.contract.amount = selected.recurrence_on_value === 2 ? (selected.price / selected.quantity) : selected.price;
      vm.contract.date_first = ((selected.date_first === null || selected.date_first === '') ?
        (angular.isDefined(vm.contract.date_first) ? vm.contract.date_first : null) : a4Moment(selected.date_first).format('YYYY-MM-DD'));
      vm.contract.date_end = selected.date_end === null || selected.date_end === '' ? '' : a4Moment(selected.date_end).format('YYYY-MM-DD');
      vm.block_fields.date = (selected.date_first !== null && selected.date_first !== '');
      vm.block_fields.amount = (vm.contract.amount > 0);
      $scope.$applyAsync();
    };


    /**
     * Modificação de plano de pagamento
     */
    vm.changePlan = function (obj, form) {
      if (form.$valid) {
        obj.date_first = (obj.date_first === null || obj.date_first === '') ? null : a4Moment(obj.date_first).format('YYYY-MM-DD');
        obj.date_end = obj.date_end === null || obj.date_end === '' ? '' : a4Moment(obj.date_end).format('YYYY-MM-DD');
        obj.date_change = (obj.date_change === null || obj.date_change === '') ? null : a4Moment(obj.date_change).format('YYYY-MM-DD');
        obj.can_change = vm.can_change;

        console.log(obj.can_change.has_paid_bill)
        vm.show_loading = true;
        if (obj.can_change.has_paid_bill === 0 && obj.can_change.has_bank_slip_sent === 0) {
        ContractService.changePaymentPlan(obj, vm.bill_serie_id)
          .then(function () {
            vm.show_loading = false;
            Common.Toast.success('Plano alterado com sucesso');
            vm.close();
          })
          .catch(function (error) {
            vm.show_loading = false;
            Common.Toast.error(error.message || error.data.message);
          })
        } else {
          ModalFactory.confirm(null, null,
            'Esse procedimento irá substituir o contrato anterior por um novo. Deseja continuar?',
            'confirmar',
            'cancelar',
            'financie').then(function () {
            $rootScope.show_loader = true;
            ContractService.changePaymentPlan(obj, vm.bill_serie_id)
              .then( function () {
                Common.Toast.success("Modificação feita com sucesso!")
                $rootScope.show_loader = false;
                vm.close();
                $rootScope.$broadcast('UPDATE_CONTRACT_LIST');
              })
              .catch( function () {
                Common.Toast.error(error.message || error.data.message);
                $rootScope.show_loader = false;
              })
          })
        }
      }
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular.module('app.a4-contract-grid')
    .controller('ContractChangePlanController', ContractChangePlanController)
})();
(function () {
  'use strict';

  function A4ContractService(Restangular) {

    return {
      updatePreferentialDay: function (bill_serie_id, day) {
        return Restangular.one('contract', bill_serie_id).all('updatepreferentialday').post({day: day});
      },
      addIndividualDiscount: function (bill_serie_id, obj) {
        return Restangular.one('contract', bill_serie_id).all('addindividualdiscount').post(obj);
      },
      removeIndividualDiscount: function (bill_serie_id, bill_serie_discount_id) {
        return Restangular.one('contract', bill_serie_id).one('removeindividualdiscount')
          .remove({bill_serie_discount_id: bill_serie_discount_id});
      },
      getIndividualDiscounts: function (bill_serie_id) {
        return Restangular.one('contract', bill_serie_id).one('getindividualdiscountsfromcontract').get();
      },
      verifyVinculatedService: function (obj) {
        return Restangular.one('contract').one('verifyvinculatedservice').get(obj);
      }
    }

  }

  angular
    .module('app.a4-contract')
    .factory('A4ContractService', A4ContractService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4ContractDirective() {
    return {
      restrict: 'E',
      scope: {
        groupId: '=?',
        personId: '=',
        courseId: '=?',
        matrixPeriod: '=?',
        contractType: '=?',
        /** Variável verifica se oa diretiva esta dentro do fluxo de matrícula financeira */
        inFlow: '=?',
        withSchoolPeriod: '=',
        lastEnrolmentData: '=?',
        payeeHasDependents: '=?',
        canEdit: '=?',
        isFinanceEnrolment: '=?'
      },
      controller: 'A4ContractController',
      controllerAs: 'enrolment',
      templateUrl: 'app/components/a4-contract/index.html',
      link: function (scope, elem, attrs, ctrl) {
        scope.inFlow = angular.isUndefined(scope.inFlow) ? false : scope.inFlow;
        scope.canEdit = angular.isUndefined(scope.canEdit) ? true : scope.canEdit;

        if (angular.isUndefined(scope.personId)) {
          throw new Error('person-id é obrigatório...')
        }

        ctrl.groupId = scope.groupId;
        ctrl.inFlow = scope.inFlow;
        ctrl.personId = scope.personId;
        ctrl.courseId = scope.courseId;
        ctrl.withSchoolPeriod = scope.withSchoolPeriod;
        ctrl.matrixPeriod = scope.matrixPeriod;
        ctrl.contractType = scope.contractType;
        ctrl.lastEnrolmentData = scope.lastEnrolmentData;
        ctrl.payeeHasDependents = scope.payeeHasDependents;
        ctrl.isFinanceEnrolment = scope.isFinanceEnrolment;


      }
    }
  }

  angular.module('app.a4-contract')
    .directive('a4Contract', A4ContractDirective);

})();
(function () {
  'use strict';

  /** @ngInject */
  function A4ContractController($document, $scope, $rootScope, $stateParams, a4Moment, StudentsService, BillReceiptService, Common,
                                EnrolmentService, ModalFactory, A4ContractService, PoliciesService, Session, ReportsService, CONFIG,
                                $filter) {
    var enrolment = this;
    enrolment.student = {};
    enrolment.hasPaymentPlan = true;
    enrolment.stepSelected = 0;
    enrolment.contract = {};
    enrolment.steps = {
      payment_plan: {id: 0, completed: false, disabled: false},
      end: {id: 1, completed: false, disabled: false}
    };
    enrolment.student_responsible = [];
    enrolment.frequency_options = BillReceiptService.getFrequencyOptions();
    enrolment.preferencial_due_day_list = BillReceiptService.range();
    enrolment.conf = {
      token: null,
      current_company: null,
      current_connection: null
    };
    enrolment.WEB_CONST = CONFIG.webApiUri;

    enrolment.policies = {
      preferential_due_day: '',
      individual_discounts: ''
    };

    var ltn = $rootScope.$on('A4CONTRACTLIST.update', function () {
      enrolment.getStudentContracts();
    });

    enrolment.init = function () {
      enrolment.policies.individual_discounts = enrolment.checkPolicies('individ_discount');
      enrolment.policies.preferential_due_day = enrolment.checkPolicies('vend_diff');
      enrolment.conf.current_company = Session.get('current_company', "sessionStorage");
      enrolment.conf.current_connection = $document[0].domain.split('.')[0];
      enrolment.conf.user_settings = angular.fromJson(Session.user.settings_json);
      ReportsService.getToken()
        .then(function (token) {
          enrolment.conf.token = token;
        });
      enrolment.student.id = $scope.personId;
      enrolment.student.group_id = $scope.groupId;
      enrolment.student.course_id = $scope.courseId;
      enrolment.student.contract_type = $scope.contractType;
      enrolment.student.matrix_period = $scope.matrixPeriod;
      $rootScope.show_loader = false;
      StudentsService.getById(enrolment.student.id, false, enrolment.student.matrix_period, $scope.groupId)
        .then(function (person) {
          enrolment.student.name = person.person.name;
          enrolment.student.national_id_number = person.national_id_number;
          enrolment.student.dob = a4Moment(person.person.dob, 'YYYY-MM-DD');
          enrolment.student.person_id_payee = person.person.person_id_payee;
          enrolment.conf.school_period_id = person.person.school_period_id;
          enrolment.payee_has_dependents = person.person.payee_has_dependents;
          enrolment.getStudentParents();
          enrolment.getStudentContracts();
          enrolment.getLastEnrolmentData();
        });
    };

    enrolment.getLastEnrolmentData = function(){
      StudentsService.getLastEnrolmentData(enrolment.student.id)
        .then(function (resp) {
          enrolment.last_enrolment_data = resp.plain();
        })
    };

    /**
     * Busca os planos de aula para a turma do aluno sendo matriculado
     */
    enrolment.getPaymentPlansForGroup = function () {
      EnrolmentService.getPaymentPlansForGroup({
        group_id: enrolment.student.group_id,
        matrix_period: enrolment.student.matrix_period
      })
        .then(function (response) {
          enrolment.payment_plans = response.plain();
          var has_enrolment_contract = false;
          if ($scope.contractType !== 'U') {
            enrolment.principal_contract = $filter('filter')(enrolment.student_contracts,
              {external_id: enrolment.student.group_id, matrix_period: enrolment.student.matrix_period, is_deleted: false});
          } else {
            enrolment.principal_contract = $filter('filter')(enrolment.student_contracts,
              {external_id: enrolment.student.group_id, is_deleted: false});
          }
          if (enrolment.payment_plans.length === 0 && enrolment.principal_contract.length === 0) {
            enrolment.hasPaymentPlan = false;   
            $rootScope.$broadcast("ENROLMENT.HAS_PAYMENT_PLAN", enrolment.hasPaymentPlan);
          }
          if (angular.isDefined($stateParams.contract_type) && enrolment.payment_plans.length >= 1 && enrolment.principal_contract.length === 0 && enrolment.inFlow) {
            enrolment.openContractModal({enrolment: enrolment, is_first: true, in_flow: $scope.inFlow});
          }

        })
    };

    /**
     * Retorna os contratos para o estudante
     */
    enrolment.getStudentContracts = function () {
      $rootScope.show_loader = true;
      StudentsService.getStudentContracts({
        id: $scope.enrolment.student.id,
        withSchoolPeriod: true,
        canceled: true,
        group_id: $stateParams.group_id,
        verify_contract_type: true,
        is_financial_contract: true
      })
        .then(function (response) {
          enrolment.student_contracts = response.plain();
          $rootScope.show_loader = false;
          enrolment.getPaymentPlansForGroup();
        })
    };


    /**
     * Retornar para o modal anterior
     */
    enrolment.openContractModal = function (data) {
      ModalFactory.customClean(
        'app/components/a4-contract/contract-modal.html',
        'A4ContractModalController',
        'vm', false, data
      )
        .then(function () {
          enrolment.getStudentContracts();
        });
    };

    /**
     * Busca os responsáveis do aluno, e adiciona ao contrato
     */
    enrolment.getStudentParents = function () {
      StudentsService.getStudentParents({student_id: enrolment.student.id, group_id: enrolment.student.group_id, matrix_period: enrolment.student.matrix_period})
        .then(function (response) {
          enrolment.student_responsible = response.plain();
        });
    };

    /**
     * Modifica o dia preferêncial de pagamento
     */
    enrolment.changePreferentialDay = function (bill_serie_id) {
      ModalFactory.prompt(null, 'Modificar dia preferencial de vencimento',
        'Escreva o dia no campo abaixo, entre 1 e 31', 'Dia Preferêncial', null,
        'Modificar', 'Cancelar', 'educational', null, true
      ).then(function (response) {
        if (response < 1 || response > 31) {
          Common.Toast.warning('Dia preferêncial deve ser entre 1 e 31');
          return;
        } else {
          $rootScope.show_loader = true;
          A4ContractService.updatePreferentialDay(bill_serie_id, response)
            .then(function () {
              $rootScope.show_loader = false;
              Common.Toast.success('Dia preferêncial alterado com sucesso!');
            })
            .catch(function (error) {
              $rootScope.show_loader = false;
              Common.Toast.error(error.message);
            });
        }
      });
    };

    /**
     * Abre o modal de descontos individuais
     * @param bill_serie
     */
    enrolment.getIndividualDiscounts = function (bill_serie) {
      ModalFactory.customClean(
        'app/components/a4-contract/individual-discounts/discounts.html',
        'A4ContractIndividualDiscountsController',
        'vm', false, {
          bill_serie_id: bill_serie.bill_serie_id,
          contract_name: bill_serie.description
        }
      )
        .then(function () {
        });

    };

    enrolment.printEnrolmentContract = function (bill_serie_id) {
      $rootScope.show_loader = true;
      EnrolmentService.printEnrolmentContract({
        person_id: $scope.personId,
        bill_serie_id: bill_serie_id,
        is_finance: true
      })
        .then(function () {
          $rootScope.show_loader = false;
          Common.Toast.success('Download concluído');
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.data.message);
        })
    };

    enrolment.printPaymentBook = function (bill_serie_id) {

    };


    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    enrolment.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    enrolment.openMenu = function ($mdMenu) {
      $mdMenu.open();
    };

    $scope.$on('$destroy', function () {
      [ltn].forEach(function (fn) {
        fn();
      })
    });


    enrolment.init();

  }

  angular.module('app.a4-contract')
    .controller('A4ContractController', A4ContractController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function A4ContractModalController($scope, $state, $stateParams, $rootScope, $filter, $mdDialog, A4ContractService, a4Moment, ModalExtra, BillReceiptService,
                                     Common, ModalFactory, EnrolmentService, ProductService, CourseService,
                                     IndividualDiscountsService) {

    var vm = this;
    vm.hasPaymentPlan = true;
    vm.payment_installments = [];
    vm.payment_plans = [];
    vm.contract = {};
    vm.frequency_options = BillReceiptService.getFrequencyOptions();
    vm.preferencial_due_day_list = BillReceiptService.range();
    vm.vinculated_services = [];

    vm.init = function () {
      if (angular.isUndefined(ModalExtra.payment_plans)) {
        ModalExtra.payment_plans = ModalExtra.enrolment.payment_plans;
      }
      vm.contract_type = angular.isDefined(ModalExtra.contractType) ? Object.assign(vm.contract_type,ModalExtra.contractType) : null;
      vm.matrix_period = angular.isDefined(ModalExtra.matrixPeriod) ? angular.copy(ModalExtra.matrixPeriod) : $stateParams.matrix_period;
      vm.is_first = angular.isDefined(ModalExtra.is_first) ? angular.copy(ModalExtra.is_first) : false;
      vm.contract = angular.isDefined(ModalExtra.contract) ? angular.copy(ModalExtra.contract) : vm.contract;
      vm.date_first = vm.contract.date_first;
      vm.enrolment = angular.isDefined(ModalExtra.enrolment) ? angular.copy(ModalExtra.enrolment) : null;
      vm.payment_plans = angular.isDefined(ModalExtra.payment_plans) ? angular.copy(ModalExtra.payment_plans) : [];
      vm.vinculated_services = angular.isDefined(ModalExtra.vinculated_services) ? angular.copy(ModalExtra.vinculated_services) : [];
      vm.last_enrolment_data = angular.isDefined(ModalExtra.enrolment.last_enrolment_data) ? angular.copy(ModalExtra.enrolment.last_enrolment_data) : [];
      vm.payee_has_dependents = angular.isDefined(ModalExtra.enrolment.payee_has_dependents) ? angular.copy(ModalExtra.enrolment.payee_has_dependents) : 0;
      vm.studentsResponsibles = angular.isDefined(ModalExtra.studentsResponsibles) ? angular.copy(ModalExtra.studentsResponsibles) : [null];
      if (vm.is_first && angular.isUndefined(vm.contract.payment_plan_id)) {
        vm.getCourseAndGroup();
      } else {
        vm.courses = angular.isDefined(ModalExtra.courses) ? angular.copy(ModalExtra.courses) : [];
        vm.selectedCourse = angular.isDefined(ModalExtra.selectedCourse) ? angular.copy(ModalExtra.selectedCourse) : null;
        vm.groups = angular.isDefined(ModalExtra.groups) ? angular.copy(ModalExtra.groups) : [];
        if (angular.isDefined(vm.contract.payment_plan_id)) {
          vm.setPaymentPlan(vm.contract.payment_plan_id);
        }
      }
      vm.contract.individual_discounts = angular.isDefined(ModalExtra.individual_discounts) ? angular.copy(ModalExtra.individual_discounts) : [];
      vm.contract.payment_installments = angular.isDefined(ModalExtra.payment_installments) ? angular.copy(ModalExtra.payment_installments) : [];
      vm.getBehaviors();
    };

    vm.getBehaviors = function () {
      IndividualDiscountsService.getBehaviors().then(function (response) {
        vm.behaviors = response.plain();
      })
    };

    vm.getBehavior = function (behavior_id) {
      var behavior = '';
      vm.behaviors.forEach(function (item) {
        if (item.id === behavior_id) {
          behavior = item.name;
        }
      });
      return behavior;
    };

    /**
     * Limpa as informações relativas ao plano de pagamento
     */
    vm.clearPaymentPlan = function () {
      vm.contract.payment_plan_id = null;
      vm.contract.quantity = null;
      vm.contract.bank_slip_rule_id = null;
      vm.contract.frequency = null;
      vm.contract.frequency_qty = null;
      vm.contract.product_id = null;
      vm.contract.date_end = null;
      vm.contract.amount = null;
      vm.contract.date_first = null;
      /*vm.contract.payment_installments = null;*/
      vm.contract.first_installment_date = null;
      vm.contract.first_installment_date_type = null;
      vm.contract.first_installment_date_days = null;

      $scope.$applyAsync();
    };
    /**
     * Retorna curso e turma do estudante
     */
    vm.getCourseAndGroup = function (query) {
      var deferred = Common.$q.defer();

      if (!angular.isDefined(query)) {
        vm.contract.group_id = vm.enrolment.student.group_id;
        vm.contract.course_id = vm.enrolment.student.course_id;
      }

      CourseService.getCoursesAndExtraServices({
        course_id: vm.contract.course_id, group_id: vm.contract.group_id, query: query,
        contract_type: vm.contract_type, matrix_period: vm.matrix_period
      }).then(function (response) {
        vm.courses = response.plain();

        if (!Array.isArray(vm.courses)) {
          vm.selectedCourse = vm.courses;
          vm.groups = vm.courses.groups;
        }
        deferred.resolve(vm.courses);
      }).catch(function () {
        deferred.reject(false);
      });

      return deferred.promise;
    };

    /**
     * Seta as informações relacionadas ao plano de pagamento escolhido
     * @param payment_plan_id
     */
    vm.setPaymentPlan = function (payment_plan_id) {
      vm.clearPaymentPlan();
      var selected = $filter('filter')(vm.payment_plans, {payment_plan_id: payment_plan_id}, true)[0];
      if (angular.isDefined(selected)) {
        vm.contract.payment_plan_id = payment_plan_id;
        vm.contract.quantity = selected.quantity;
        vm.contract.bank_slip_rule_id = selected.bank_slip_rule_id;
        vm.contract.frequency = selected.frequency;
        vm.contract.frequency_qty = selected.frequency_qty;
        vm.contract.recurrence_on_value = selected.recurrence_on_value;
        vm.contract.product_id = selected.product_id;
        vm.contract.date_end = selected.date_end;
        vm.contract.first_installment_date_type = selected.first_installment_date_type;
        vm.contract.first_installment_date_days = selected.first_installment_date_days;
        vm.contract.amount = selected.recurrence_on_value === 2 ? (selected.price / selected.quantity) : selected.price;
        vm.contract.date_first = (angular.isDefined(vm.date_first) && vm.date_first !== null) ? vm.date_first : (selected.date_first === null || selected.date_first === '' ? a4Moment(null)
          : a4Moment(selected.date_first).format('YYYY-MM-DD'));
        vm.disable_date_first = selected.date_first !== null && selected.date_first !== '';
        vm.disable_amount = selected.price !== null && selected.price !== '';
      }
      vm.debit_credit = 'C';
      /** Verificação para evitar que sejam buscados os serviços vinculados após a
       * reabertura do modal depois da adição de descontos individuais.
       * Verifica se o plano setado é o mesmo que foi retornado pelo modal dos descontos.
       * Após a primeira verificação seta a variável ModalExtra para null, evitando bugs */
      if ((ModalExtra === null || angular.isUndefined(ModalExtra.contract)) || ModalExtra.contract.payment_plan_id !== payment_plan_id) {
        A4ContractService.verifyVinculatedService({
          product_id: vm.contract.group_id,
          payment_plan_id: payment_plan_id,
          matrix_period: vm.matrix_period
        }).then(function (response) {
          vm.vinculated_services = response.plain();
          ModalExtra = null;
        });
        if (vm.contract.recurrence_on_value === 1) {
          vm.generateInstalmentsByPaymentPlan(selected);
        }
      }
      if (vm.contract.date_first !== null) {
        vm.setFirstInstallmentDate(a4Moment(vm.contract.date_first));
      }
      // vm.defineFirstInstallmentDate(selected);

      if (ModalExtra.amount !== null && angular.isDefined(ModalExtra.amount)) {
        vm.contract.amount = angular.copy(ModalExtra.amount);
        ModalExtra.amount = null;
      }
    };

    /**
     * Define a data da primeira parcela do contrato
     * @param date moment
     */
    vm.setFirstInstallmentDate = function () {
      if (vm.contract.first_installment_date_type > 0 && angular.isDefined(vm.contract.first_installment_date_days)) {
        vm.contract.first_installment_date = a4Moment().add(vm.contract.first_installment_date_days, 'days').format('YYYY-MM-DD');
        $scope.$applyAsync();
      }
    };

    /**
     * Realiza a atualização das parcelas após a mudança da data inicial
     */
    vm.changeDateFirst = function () {
      vm.generateInstalmentsByPaymentPlan(vm.contract);
    };

    /**
     * Realiza a atualização das parcelas após a mudança do valor
     */
    vm.changeAmount = function () {
      vm.generateInstalmentsByPaymentPlan(vm.contract);
    };

    /**
     * Gera as parcelas da recorrência no caso da seleção de um plano de pagamento
     * @param payment_plan
     */
    vm.generateInstalmentsByPaymentPlan = function (payment_plan) {
      vm.contract.payment_installments = [];
      var copy_plan = angular.copy(payment_plan);
      if (copy_plan.frequency > 0) {
        var qty = copy_plan.quantity > 0 ? copy_plan.quantity : vm.defineQtyByDates(copy_plan.date_first, copy_plan.date_end);
        for (var i = 1; i <= qty; i++) {
          var obj = {
            portion_name: i + '/' + qty,
            due_date: vm.getNextDate(copy_plan, i === 1),
            amount: copy_plan.amount
          };
          vm.contract.payment_installments.push(obj);
        }
        if (angular.isDefined(copy_plan.preferential_due_day) && copy_plan.preferential_due_day !== null) {
          vm.contract.payment_installments.forEach(function (item) {
            item.due_date.set('date', copy_plan.preferential_due_day);
          });
        }
        if (copy_plan.first_installment_date_type > 0) {
          vm.contract.payment_installments[0].due_date = a4Moment(copy_plan.first_installment_date);
        }
      } else {
        var object = {
          portion_name: '1/1',
          due_date: copy_plan.date_first,
          amount: copy_plan.amount
        };
        vm.contract.payment_installments.push(object);
      }
    };

    /**
     * Define a quantidade de parcelas do contrato a partir das datas inicial e final
     * @param date_first
     * @param date_end
     * @returns {*}
     */
    vm.defineQtyByDates = function (date_first, date_end) {
      var qty = a4Moment(date_end).diff(a4Moment(date_first), 'months');
      return qty + 1;
    };


    /**
     * Busca os planos de aula para a turma do aluno sendo matriculado
     */
    vm.getPaymentPlansForGroup = function (group_id) {
      EnrolmentService.getPaymentPlansForGroup({group_id: group_id, matrix_period: vm.enrolment.student.matrix_period})
        .then(function (response) {
          vm.clearPaymentPlan();
          vm.payment_plans = response.plain();
          if (vm.payment_plans.length === 1) {
            vm.setPaymentPlan(vm.payment_plans[0].payment_plan_id);
          }
        })
    };

    /**
     * Busca os planos de aula para o serviço
     */
    vm.getPaymentPlansForProduct = function (product_id) {
      if (ModalExtra.in_flow !== true) {
        ProductService.getById(product_id)
          .then(function (response) {
            vm.clearPaymentPlan();
            vm.payment_plans = response.selectedPaymentPlans;
            if (vm.payment_plans.length === 1) {
              vm.setPaymentPlan(vm.payment_plans[0].payment_plan_id);
            }
          })
      }
    };

    /**
     * Devolve a próxima data de vencimento para as parcelas
     * @param payment_plan
     * @returns {*}
     */
    vm.getNextDate = function (payment_plan) {
      var copy_plan = angular.copy(payment_plan);
      var len = vm.contract.payment_installments.length;
      var last_date = len > 0 ? vm.contract.payment_installments[len - 1].due_date : copy_plan.date_first;
      var frequency_value = $filter('filter')(vm.frequency_options, {id: copy_plan.frequency})[0].value;
      var date = a4Moment(last_date);
      // if (is_first_installment) {
      //   return a4Moment(copy_plan.first_installment_date);
      // } else
      if (len > 0 && date !== null) {
        date.add(copy_plan.frequency_qty, frequency_value);
        // if(angular.isDefined(copy_plan.preferential_due_day) && copy_plan.preferential_due_day !== null){
        //   date.set('day', copy_plan.preferential_due_day);
        // }
      }
      return date;
    };

    /**
     * Realiza o salvamento do contrato financeiro
     */
    vm.submitContract = function (contract, form) {
      if (form.$valid) {
        vm.show_loading = true;
        var contract_copy = angular.copy(contract);
        contract_copy.person_id_beneficiary = vm.enrolment.student.id;
        contract_copy.student_id = vm.enrolment.student.id;
        contract_copy.group_id = vm.enrolment.student.group_id;
        contract_copy.debit_credit = 'C';
        contract_copy.status = 1;

        /**
         * Define o tipo de recorrência
         */
        if (contract_copy.date_end != null) {
          contract_copy.end_of_recurrence = 1;
        } else if (contract_copy.quantity === 0) {
          contract_copy.end_of_recurrence = 2;
        } else {
          contract_copy.end_of_recurrence = 0;
        }


        contract_copy.type = 1;
        contract_copy.due_date = vm.contract.date_first;
        contract_copy.bank_slip_rule_id = vm.contract.bank_slip_rule_id;
        contract_copy.course_id = vm.enrolment.student.course_id;
        contract_copy.group_id = vm.enrolment.student.group_id;
        contract_copy.name = vm.enrolment.student.name;
        contract_copy.matrix_period = vm.matrix_period;
        contract_copy.dob = vm.enrolment.student.dob;
        contract_copy.national_id_number = vm.enrolment.student.national_id_number;
        contract_copy.person_id = vm.enrolment.student.person_id_payee;
        contract_copy.vinculated_services = vm.vinculated_services;
        contract_copy.is_first = vm.is_first;
        EnrolmentService.storeContract(contract_copy)
          .then(function (response) {
            contract_copy.bill_serie_id = response.bill_serie.id;
            if (response) {
              Common.Toast.success("Contrato criado com sucesso");
              vm.close();
              $rootScope.$broadcast('A4CONTRACTLIST.update');
            }
            vm.show_loading = false;
          })
          .catch(function (error) {
            vm.show_loading = false;
            Common.Toast.error(error.data.message);
          });
      } else {
        Common.Toast.warning('Existem campos obrigatórios no formulário que não foram preenchidos.')
      }
    };

    vm.convertType = function (format) {
      switch (format) {
        case 'F':
          return 'Fixo';
        case 'C':
          return 'Condicional';
        case 'P':
          return 'Promocional';
      }
    };

    vm.reopenModal = function (discount) {
      var amount = vm.contract.amount;
      var individual_discounts = [];
      if (discount !== 'canceled') {
        discount.start_date = discount.start_date !== null ? a4Moment(discount.start_date).format('YYYY-MM-DD') : discount.start_date;
        discount.end_date = discount.end_date !== null ? a4Moment(discount.end_date).format('YYYY-MM-DD') : discount.end_date;
        individual_discounts.push(discount);
      }

      angular.forEach(vm.contract.individual_discounts, function (item) {
        individual_discounts.push(item)
      });
      vm.openContractModal({
        contract: vm.contract,
        payment_plans: vm.payment_plans,
        individual_discounts: individual_discounts,
        payment_installments: vm.contract.payment_installments,
        enrolment: vm.enrolment,
        person_payee: vm.enrolment.student.person_id_payee,
        studentsResponsibles: vm.studentsResponsibles,
        is_first: vm.is_first,
        courses: vm.courses,
        groups: vm.groups,
        selectedCourse: vm.selectedCourse,
        amount: amount,
        vinculated_services: vm.vinculated_services
      });
    };

    /**
     * Criação de desconto individual
     */
    vm.createNewIndividualDiscount = function () {
      ModalFactory.customClean(
        'app/components/a4-discounts/modal.html',
        'A4DiscountsController', 'vm', false, {theme: 'educational'}
      ).then(function (discount) {
        vm.reopenModal(discount);
      })
    };

    /**
     * Retornar para o modal anterior
     */
    vm.openContractModal = function (data) {
      ModalFactory.customClean(
        'app/components/a4-contract/contract-modal.html',
        'A4ContractModalController',
        'vm', false, data
      );
    };


    /**
     * Seta as turmas do curso;
     * @param selectedItem
     */
    vm.setItem = function (selectedItem) {
      if (selectedItem !== undefined && selectedItem !== null) {
        vm.selectedCourse = selectedItem;
        vm.groups = selectedItem.groups;
        vm.getPaymentPlansForProduct(selectedItem.id);
      }
    };


    /**
     * Remove um desconto da lista
     */
    vm.removeItemDesconto = function (discount_id, discount_index) {
      var index = null;
       if (angular.isDefined(discount_id)) {
        for (var i = 0; i < vm.contract.individual_discounts.length; i++) {
          if (vm.contract.individual_discounts[i].id === discount_id) {
            index = i;
          }
        }

        if (index !== null) {
          vm.contract.individual_discounts.splice(index, 1);
        }
      } else {
        vm.contract.individual_discounts.splice(discount_index, 1);
      }
    };

    /**
     * Fecha modal
     * @param data
     */
    vm.close = function (data) {
      $rootScope.$broadcast('ModalFactory.close', data);
    };

    /**
     * Volta para listagem de matricula financeira
     * @param data
     */
    vm.goBack = function () {
      $mdDialog.hide('canceled');
      $state.go('private.educational.finance-enrolment.list');
    };

    vm.init();

  }

  angular.module('app.a4-contract')
    .controller('A4ContractModalController', A4ContractModalController);

})();

/*!
 * Compressor.js v1.0.7
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2020-11-28T07:13:17.754Z
 */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Compressor=t()}(this,function(){"use strict";function n(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function l(){return(l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r,a=arguments[t];for(r in a)Object.prototype.hasOwnProperty.call(a,r)&&(e[r]=a[r])}return e}).apply(this,arguments)}function t(t,e){var r,a=Object.keys(t);return Object.getOwnPropertySymbols&&(r=Object.getOwnPropertySymbols(t),e&&(r=r.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),a.push.apply(a,r)),a}function i(a){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?t(Object(n),!0).forEach(function(e){var t,r;t=a,e=n[r=e],r in t?Object.defineProperty(t,r,{value:e,enumerable:!0,configurable:!0,writable:!0}):t[r]=e}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(n)):t(Object(n)).forEach(function(e){Object.defineProperty(a,e,Object.getOwnPropertyDescriptor(n,e))})}return a}var e,r,U=(function(e){var t,n,l,s,c,u,i;"undefined"!=typeof window&&(n=(t=window).HTMLCanvasElement&&t.HTMLCanvasElement.prototype,l=t.Blob&&function(){try{return Boolean(new Blob)}catch(e){return!1}}(),s=l&&t.Uint8Array&&function(){try{return 100===new Blob([new Uint8Array(100)]).size}catch(e){return!1}}(),c=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||t.MSBlobBuilder,u=/^data:((.*?)(;charset=.*?)?)(;base64)?,/,i=(l||c)&&t.atob&&t.ArrayBuffer&&t.Uint8Array&&function(e){var t,r,a,n,i,o=e.match(u);if(!o)throw new Error("invalid data URI");for(t=o[2]?o[1]:"text/plain"+(o[3]||";charset=US-ASCII"),a=!!o[4],o=e.slice(o[0].length),r=(a?atob:decodeURIComponent)(o),a=new ArrayBuffer(r.length),n=new Uint8Array(a),i=0;i<r.length;i+=1)n[i]=r.charCodeAt(i);return l?new Blob([s?n:a],{type:t}):((o=new c).append(a),o.getBlob(t))},t.HTMLCanvasElement&&!n.toBlob&&(n.mozGetAsFile?n.toBlob=function(e,t,r){var a=this;setTimeout(function(){r&&n.toDataURL&&i?e(i(a.toDataURL(t,r))):e(a.mozGetAsFile("blob",t))})}:n.toDataURL&&i&&(n.msToBlob?n.toBlob=function(e,t,r){var a=this;setTimeout(function(){(t&&"image/png"!==t||r)&&n.toDataURL&&i?e(i(a.toDataURL(t,r))):e(a.msToBlob(t))})}:n.toBlob=function(e,t,r){var a=this;setTimeout(function(){e(i(a.toDataURL(t,r)))})})),e.exports?e.exports=i:t.dataURLtoBlob=i)}(r={path:e,exports:{},require:function(e,t){return function(){throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs")}(null==t&&r.path)}},r.exports),r.exports),o={strict:!0,checkOrientation:!0,maxWidth:1/0,maxHeight:1/0,minWidth:0,minHeight:0,width:void 0,height:void 0,quality:.8,mimeType:"auto",convertSize:5e6,beforeDraw:null,drew:null,success:null,error:null},s="undefined"!=typeof window&&void 0!==window.document?window:{},c=Array.prototype.slice;var a=/^image\/.+$/;function B(e){return a.test(e)}var d=String.fromCharCode;var u=s.btoa;function h(e,t){for(var r,a=[],n=new Uint8Array(e);0<n.length;)a.push(d.apply(null,(r=n.subarray(0,8192),Array.from?Array.from(r):c.call(r)))),n=n.subarray(8192);return"data:".concat(t,";base64,").concat(u(a.join("")))}function f(e){var t,r,a,n,i,o,l=new DataView(e);try{if(255===l.getUint8(0)&&216===l.getUint8(1))for(var s=l.byteLength,c=2;c+1<s;){if(255===l.getUint8(c)&&225===l.getUint8(c+1)){r=c;break}c+=1}if(r&&(n=r+10,"Exif"===function(e,t,r){var a,n="";for(r+=t,a=t;a<r;a+=1)n+=d(e.getUint8(a));return n}(l,r+4,4)&&(!(o=18761===(i=l.getUint16(n)))&&19789!==i||42!==l.getUint16(n+2,o)||8<=(i=l.getUint32(n+4,o))&&(a=n+i))),a)for(var u,h=l.getUint16(a,o),f=0;f<h;f+=1)if(u=a+12*f+2,274===l.getUint16(u,o)){u+=8,t=l.getUint16(u,o),l.setUint16(u,1,o);break}}catch(e){t=1}return t}var m=/\.\d*(?:0|9){12}\d*$/;function O(e,t){t=1<arguments.length&&void 0!==t?t:1e11;return m.test(e)?Math.round(e*t)/t:e}var b=s.ArrayBuffer,p=s.FileReader,g=s.URL||s.webkitURL,y=/\.\w+$/,w=s.Compressor;return function(){function r(e,t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,r),this.file=e,this.image=new Image,this.options=i(i({},o),t),this.aborted=!1,this.result=null,this.init()}var e,t,a;return e=r,a=[{key:"noConflict",value:function(){return window.Compressor=w,r}},{key:"setDefaults",value:function(e){l(o,e)}}],(t=[{key:"init",value:function(){var a,e,n,i=this,o=this.file,t=this.options;e=o,"undefined"!=typeof Blob&&(e instanceof Blob||"[object Blob]"===Object.prototype.toString.call(e))?B(a=o.type)?g&&p?(b||(t.checkOrientation=!1),g&&!t.checkOrientation?this.load({url:g.createObjectURL(o)}):(e=new p,n=t.checkOrientation&&"image/jpeg"===a,(this.reader=e).onload=function(e){var t=e.target.result,r={};n?1<(e=f(t))||!g?(r.url=h(t,a),1<e&&l(r,function(e){var t=0,r=1,a=1;switch(e){case 2:r=-1;break;case 3:t=-180;break;case 4:a=-1;break;case 5:t=90,a=-1;break;case 6:t=90;break;case 7:t=90,r=-1;break;case 8:t=-90}return{rotate:t,scaleX:r,scaleY:a}}(e))):r.url=g.createObjectURL(o):r.url=t,i.load(r)},e.onabort=function(){i.fail(new Error("Aborted to read the image with FileReader."))},e.onerror=function(){i.fail(new Error("Failed to read the image with FileReader."))},e.onloadend=function(){i.reader=null},n?e.readAsArrayBuffer(o):e.readAsDataURL(o))):this.fail(new Error("The current browser does not support image compression.")):this.fail(new Error("The first argument must be an image File or Blob object.")):this.fail(new Error("The first argument must be a File or Blob object."))}},{key:"load",value:function(e){var t=this,r=this.file,a=this.image;a.onload=function(){t.draw(i(i({},e),{},{naturalWidth:a.naturalWidth,naturalHeight:a.naturalHeight}))},a.onabort=function(){t.fail(new Error("Aborted to load the image."))},a.onerror=function(){t.fail(new Error("Failed to load the image."))},s.navigator&&/(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(s.navigator.userAgent)&&(a.crossOrigin="anonymous"),a.alt=r.name,a.src=e.url}},{key:"draw",value:function(e){var t=this,r=e.naturalWidth,a=e.naturalHeight,n=e.rotate,i=void 0===n?0:n,o=e.scaleX,l=void 0===o?1:o,s=e.scaleY,c=void 0===s?1:s,u=this.file,h=this.image,f=this.options,d=document.createElement("canvas"),m=d.getContext("2d"),b=r/a,p=Math.abs(i)%180==90,g=Math.max(f.maxWidth,0)||1/0,y=Math.max(f.maxHeight,0)||1/0,w=Math.max(f.minWidth,0)||0,n=Math.max(f.minHeight,0)||0,o=Math.max(f.width,0)||r,e=Math.max(f.height,0)||a;p&&(g=(s=[y,g])[0],y=s[1],w=(s=[n,w])[0],n=s[1],o=(s=[e,o])[0],e=s[1]),g<1/0&&y<1/0?g<y*b?y=g/b:g=y*b:g<1/0?y=g/b:y<1/0&&(g=y*b),0<w&&0<n?w<n*b?n=w/b:w=n*b:0<w?n=w/b:0<n&&(w=n*b),o<e*b?e=o/b:o=e*b;w=-(o=Math.floor(O(Math.min(Math.max(o,w),g))))/2,g=-(e=Math.floor(O(Math.min(Math.max(e,n),y))))/2,n=o,y=e;p&&(o=(v=[e,o])[0],e=v[1]),d.width=o,d.height=e,B(f.mimeType)||(f.mimeType=u.type);var v="transparent";u.size>f.convertSize&&"image/png"===f.mimeType&&(v="#fff",f.mimeType="image/jpeg"),m.fillStyle=v,m.fillRect(0,0,o,e),f.beforeDraw&&f.beforeDraw.call(this,m,d),this.aborted||(m.save(),m.translate(o/2,e/2),m.rotate(i*Math.PI/180),m.scale(l,c),m.drawImage(h,w,g,n,y),m.restore(),f.drew&&f.drew.call(this,m,d),this.aborted||(m=function(e){t.aborted||t.done({naturalWidth:r,naturalHeight:a,result:e})},d.toBlob?d.toBlob(m,f.mimeType,f.quality):m(U(d.toDataURL(f.mimeType,f.quality)))))}},{key:"done",value:function(e){var t=e.naturalWidth,r=e.naturalHeight,a=e.result,n=this.file,i=this.image,e=this.options;g&&!e.checkOrientation&&g.revokeObjectURL(i.src),!a||e.strict&&a.size>n.size&&e.mimeType===n.type&&!(e.width>t||e.height>r||e.minWidth>t||e.minHeight>r)?a=n:(r=new Date,a.lastModified=r.getTime(),a.lastModifiedDate=r,a.name=n.name,a.name&&a.type!==n.type&&(a.name=a.name.replace(y,("jpeg"===(n=B(n=a.type)?n.substr(6):"")&&(n="jpg"),".".concat(n))))),this.result=a,e.success&&e.success.call(this,a)}},{key:"fail",value:function(e){var t=this.options;if(!t.error)throw e;t.error.call(this,e)}},{key:"abort",value:function(){this.aborted||(this.aborted=!0,this.reader?this.reader.abort():this.image.complete?this.fail(new Error("The compression process has been aborted.")):(this.image.onload=null,this.image.onabort()))}}])&&n(e.prototype,t),a&&n(e,a),r}()});
/*!
 * Compressor.js v1.0.7
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2020-11-28T07:13:17.754Z
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Compressor = factory());
}(this, (function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function createCommonjsModule(fn, basedir, module) {
  	return module = {
  		path: basedir,
  		exports: {},
  		require: function (path, base) {
  			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
  		}
  	}, fn(module, module.exports), module.exports;
  }

  function commonjsRequire () {
  	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
  }

  var canvasToBlob = createCommonjsModule(function (module) {
    if (typeof window === 'undefined') {
      return;
    }

    (function (window) {

      var CanvasPrototype = window.HTMLCanvasElement && window.HTMLCanvasElement.prototype;

      var hasBlobConstructor = window.Blob && function () {
        try {
          return Boolean(new Blob());
        } catch (e) {
          return false;
        }
      }();

      var hasArrayBufferViewSupport = hasBlobConstructor && window.Uint8Array && function () {
        try {
          return new Blob([new Uint8Array(100)]).size === 100;
        } catch (e) {
          return false;
        }
      }();

      var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
      var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;

      var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window.atob && window.ArrayBuffer && window.Uint8Array && function (dataURI) {
        var matches, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i, bb; // Parse the dataURI components as per RFC 2397

        matches = dataURI.match(dataURIPattern);

        if (!matches) {
          throw new Error('invalid data URI');
        } // Default to text/plain;charset=US-ASCII


        mediaType = matches[2] ? matches[1] : 'text/plain' + (matches[3] || ';charset=US-ASCII');
        isBase64 = !!matches[4];
        dataString = dataURI.slice(matches[0].length);

        if (isBase64) {
          // Convert base64 to raw binary data held in a string:
          byteString = atob(dataString);
        } else {
          // Convert base64/URLEncoded data component to raw binary:
          byteString = decodeURIComponent(dataString);
        } // Write the bytes of the string to an ArrayBuffer:


        arrayBuffer = new ArrayBuffer(byteString.length);
        intArray = new Uint8Array(arrayBuffer);

        for (i = 0; i < byteString.length; i += 1) {
          intArray[i] = byteString.charCodeAt(i);
        } // Write the ArrayBuffer (or ArrayBufferView) to a blob:


        if (hasBlobConstructor) {
          return new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], {
            type: mediaType
          });
        }

        bb = new BlobBuilder();
        bb.append(arrayBuffer);
        return bb.getBlob(mediaType);
      };

      if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
        if (CanvasPrototype.mozGetAsFile) {
          CanvasPrototype.toBlob = function (callback, type, quality) {
            var self = this;
            setTimeout(function () {
              if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
                callback(dataURLtoBlob(self.toDataURL(type, quality)));
              } else {
                callback(self.mozGetAsFile('blob', type));
              }
            });
          };
        } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
          if (CanvasPrototype.msToBlob) {
            CanvasPrototype.toBlob = function (callback, type, quality) {
              var self = this;
              setTimeout(function () {
                if ((type && type !== 'image/png' || quality) && CanvasPrototype.toDataURL && dataURLtoBlob) {
                  callback(dataURLtoBlob(self.toDataURL(type, quality)));
                } else {
                  callback(self.msToBlob(type));
                }
              });
            };
          } else {
            CanvasPrototype.toBlob = function (callback, type, quality) {
              var self = this;
              setTimeout(function () {
                callback(dataURLtoBlob(self.toDataURL(type, quality)));
              });
            };
          }
        }
      }

      if ( module.exports) {
        module.exports = dataURLtoBlob;
      } else {
        window.dataURLtoBlob = dataURLtoBlob;
      }
    })(window);
  });

  var isBlob = function isBlob(value) {
    if (typeof Blob === 'undefined') {
      return false;
    }

    return value instanceof Blob || Object.prototype.toString.call(value) === '[object Blob]';
  };

  var DEFAULTS = {
    /**
     * Indicates if output the original image instead of the compressed one
     * when the size of the compressed image is greater than the original one's
     * @type {boolean}
     */
    strict: true,

    /**
     * Indicates if read the image's Exif Orientation information,
     * and then rotate or flip the image automatically.
     * @type {boolean}
     */
    checkOrientation: true,

    /**
     * The max width of the output image.
     * @type {number}
     */
    maxWidth: Infinity,

    /**
     * The max height of the output image.
     * @type {number}
     */
    maxHeight: Infinity,

    /**
     * The min width of the output image.
     * @type {number}
     */
    minWidth: 0,

    /**
     * The min height of the output image.
     * @type {number}
     */
    minHeight: 0,

    /**
     * The width of the output image.
     * If not specified, the natural width of the source image will be used.
     * @type {number}
     */
    width: undefined,

    /**
     * The height of the output image.
     * If not specified, the natural height of the source image will be used.
     * @type {number}
     */
    height: undefined,

    /**
     * The quality of the output image.
     * It must be a number between `0` and `1`,
     * and only available for `image/jpeg` and `image/webp` images.
     * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
     * @type {number}
     */
    quality: 0.8,

    /**
     * The mime type of the output image.
     * By default, the original mime type of the source image file will be used.
     * @type {string}
     */
    mimeType: 'auto',

    /**
     * PNG files over this value (5 MB by default) will be converted to JPEGs.
     * To disable this, just set the value to `Infinity`.
     * @type {number}
     */
    convertSize: 5000000,

    /**
     * The hook function to execute before draw the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.fillStyle = '#fff';
     * }
     */
    beforeDraw: null,

    /**
     * The hook function to execute after drew the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.filter = 'grayscale(100%)';
     * }
     */
    drew: null,

    /**
     * The hook function to execute when success to compress the image.
     * @type {Function}
     * @param {File} file - The compressed image File object.
     * @example
     * function (file) {
     *   console.log(file);
     * }
     */
    success: null,

    /**
     * The hook function to execute when fail to compress the image.
     * @type {Function}
     * @param {Error} err - An Error object.
     * @example
     * function (err) {
     *   console.log(err.message);
     * }
     */
    error: null
  };

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};

  var slice = Array.prototype.slice;
  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */

  function toArray(value) {
    return Array.from ? Array.from(value) : slice.call(value);
  }
  var REGEXP_IMAGE_TYPE = /^image\/.+$/;
  /**
   * Check if the given value is a mime type of image.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given is a mime type of image, else `false`.
   */

  function isImageType(value) {
    return REGEXP_IMAGE_TYPE.test(value);
  }
  /**
   * Convert image type to extension.
   * @param {string} value - The image type to convert.
   * @returns {boolean} Returns the image extension.
   */

  function imageTypeToExtension(value) {
    var extension = isImageType(value) ? value.substr(6) : '';

    if (extension === 'jpeg') {
      extension = 'jpg';
    }

    return ".".concat(extension);
  }
  var fromCharCode = String.fromCharCode;
  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */

  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    var i;
    length += start;

    for (i = start; i < length; i += 1) {
      str += fromCharCode(dataView.getUint8(i));
    }

    return str;
  }
  var btoa = WINDOW.btoa;
  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */

  function arrayBufferToDataURL(arrayBuffer, mimeType) {
    var chunks = [];
    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);

    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }

    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
  }
  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */

  function resetAndGetOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation; // Ignores range error when the image does not have correct Exif information

    try {
      var littleEndian;
      var app1Start;
      var ifdStart; // Only handle JPEG image (start by 0xFFD8)

      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;

        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }

          offset += 1;
        }
      }

      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;

        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;

          if (littleEndian || endianness === 0x4D4D
          /* bigEndian */
          ) {
              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

                if (firstIFDOffset >= 0x00000008) {
                  ifdStart = tiffOffset + firstIFDOffset;
                }
              }
            }
        }
      }

      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);

        var _offset;

        var i;

        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;

          if (dataView.getUint16(_offset, littleEndian) === 0x0112
          /* Orientation */
          ) {
              // 8 is the offset of the current tag's value
              _offset += 8; // Get the original orientation value

              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value

              dataView.setUint16(_offset, 1, littleEndian);
              break;
            }
        }
      }
    } catch (e) {
      orientation = 1;
    }

    return orientation;
  }
  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */

  function parseOrientation(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;

    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;
      // Rotate left 180°

      case 3:
        rotate = -180;
        break;
      // Flip vertical

      case 4:
        scaleY = -1;
        break;
      // Flip vertical and rotate right 90°

      case 5:
        rotate = 90;
        scaleY = -1;
        break;
      // Rotate right 90°

      case 6:
        rotate = 90;
        break;
      // Flip horizontal and rotate right 90°

      case 7:
        rotate = 90;
        scaleX = -1;
        break;
      // Rotate left 90°

      case 8:
        rotate = -90;
        break;
    }

    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }
  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
  /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */

  function normalizeDecimalNumber(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
  }

  var ArrayBuffer$1 = WINDOW.ArrayBuffer,
      FileReader = WINDOW.FileReader;
  var URL = WINDOW.URL || WINDOW.webkitURL;
  var REGEXP_EXTENSION = /\.\w+$/;
  var AnotherCompressor = WINDOW.Compressor;
  /**
   * Creates a new image compressor.
   * @class
   */

  var Compressor = /*#__PURE__*/function () {
    /**
     * The constructor of Compressor.
     * @param {File|Blob} file - The target image file for compressing.
     * @param {Object} [options] - The options for compressing.
     */
    function Compressor(file, options) {
      _classCallCheck(this, Compressor);

      this.file = file;
      this.image = new Image();
      this.options = _objectSpread2(_objectSpread2({}, DEFAULTS), options);
      this.aborted = false;
      this.result = null;
      this.init();
    }

    _createClass(Compressor, [{
      key: "init",
      value: function init() {
        var _this = this;

        var file = this.file,
            options = this.options;

        if (!isBlob(file)) {
          this.fail(new Error('The first argument must be a File or Blob object.'));
          return;
        }

        var mimeType = file.type;

        if (!isImageType(mimeType)) {
          this.fail(new Error('The first argument must be an image File or Blob object.'));
          return;
        }

        if (!URL || !FileReader) {
          this.fail(new Error('The current browser does not support image compression.'));
          return;
        }

        if (!ArrayBuffer$1) {
          options.checkOrientation = false;
        }

        if (URL && !options.checkOrientation) {
          this.load({
            url: URL.createObjectURL(file)
          });
        } else {
          var reader = new FileReader();
          var checkOrientation = options.checkOrientation && mimeType === 'image/jpeg';
          this.reader = reader;

          reader.onload = function (_ref) {
            var target = _ref.target;
            var result = target.result;
            var data = {};

            if (checkOrientation) {
              // Reset the orientation value to its default value 1
              // as some iOS browsers will render image with its orientation
              var orientation = resetAndGetOrientation(result);

              if (orientation > 1 || !URL) {
                // Generate a new URL which has the default orientation value
                data.url = arrayBufferToDataURL(result, mimeType);

                if (orientation > 1) {
                  _extends(data, parseOrientation(orientation));
                }
              } else {
                data.url = URL.createObjectURL(file);
              }
            } else {
              data.url = result;
            }

            _this.load(data);
          };

          reader.onabort = function () {
            _this.fail(new Error('Aborted to read the image with FileReader.'));
          };

          reader.onerror = function () {
            _this.fail(new Error('Failed to read the image with FileReader.'));
          };

          reader.onloadend = function () {
            _this.reader = null;
          };

          if (checkOrientation) {
            reader.readAsArrayBuffer(file);
          } else {
            reader.readAsDataURL(file);
          }
        }
      }
    }, {
      key: "load",
      value: function load(data) {
        var _this2 = this;

        var file = this.file,
            image = this.image;

        image.onload = function () {
          _this2.draw(_objectSpread2(_objectSpread2({}, data), {}, {
            naturalWidth: image.naturalWidth,
            naturalHeight: image.naturalHeight
          }));
        };

        image.onabort = function () {
          _this2.fail(new Error('Aborted to load the image.'));
        };

        image.onerror = function () {
          _this2.fail(new Error('Failed to load the image.'));
        }; // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.


        if (WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent)) {
          // Fix the `The operation is insecure` error (#57)
          image.crossOrigin = 'anonymous';
        }

        image.alt = file.name;
        image.src = data.url;
      }
    }, {
      key: "draw",
      value: function draw(_ref2) {
        var _this3 = this;

        var naturalWidth = _ref2.naturalWidth,
            naturalHeight = _ref2.naturalHeight,
            _ref2$rotate = _ref2.rotate,
            rotate = _ref2$rotate === void 0 ? 0 : _ref2$rotate,
            _ref2$scaleX = _ref2.scaleX,
            scaleX = _ref2$scaleX === void 0 ? 1 : _ref2$scaleX,
            _ref2$scaleY = _ref2.scaleY,
            scaleY = _ref2$scaleY === void 0 ? 1 : _ref2$scaleY;
        var file = this.file,
            image = this.image,
            options = this.options;
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var aspectRatio = naturalWidth / naturalHeight;
        var is90DegreesRotated = Math.abs(rotate) % 180 === 90;
        var maxWidth = Math.max(options.maxWidth, 0) || Infinity;
        var maxHeight = Math.max(options.maxHeight, 0) || Infinity;
        var minWidth = Math.max(options.minWidth, 0) || 0;
        var minHeight = Math.max(options.minHeight, 0) || 0;
        var width = Math.max(options.width, 0) || naturalWidth;
        var height = Math.max(options.height, 0) || naturalHeight;

        if (is90DegreesRotated) {
          var _ref3 = [maxHeight, maxWidth];
          maxWidth = _ref3[0];
          maxHeight = _ref3[1];
          var _ref4 = [minHeight, minWidth];
          minWidth = _ref4[0];
          minHeight = _ref4[1];
          var _ref5 = [height, width];
          width = _ref5[0];
          height = _ref5[1];
        }

        if (maxWidth < Infinity && maxHeight < Infinity) {
          if (maxHeight * aspectRatio > maxWidth) {
            maxHeight = maxWidth / aspectRatio;
          } else {
            maxWidth = maxHeight * aspectRatio;
          }
        } else if (maxWidth < Infinity) {
          maxHeight = maxWidth / aspectRatio;
        } else if (maxHeight < Infinity) {
          maxWidth = maxHeight * aspectRatio;
        }

        if (minWidth > 0 && minHeight > 0) {
          if (minHeight * aspectRatio > minWidth) {
            minHeight = minWidth / aspectRatio;
          } else {
            minWidth = minHeight * aspectRatio;
          }
        } else if (minWidth > 0) {
          minHeight = minWidth / aspectRatio;
        } else if (minHeight > 0) {
          minWidth = minHeight * aspectRatio;
        }

        if (height * aspectRatio > width) {
          height = width / aspectRatio;
        } else {
          width = height * aspectRatio;
        }

        width = Math.floor(normalizeDecimalNumber(Math.min(Math.max(width, minWidth), maxWidth)));
        height = Math.floor(normalizeDecimalNumber(Math.min(Math.max(height, minHeight), maxHeight)));
        var destX = -width / 2;
        var destY = -height / 2;
        var destWidth = width;
        var destHeight = height;

        if (is90DegreesRotated) {
          var _ref6 = [height, width];
          width = _ref6[0];
          height = _ref6[1];
        }

        canvas.width = width;
        canvas.height = height;

        if (!isImageType(options.mimeType)) {
          options.mimeType = file.type;
        }

        var fillStyle = 'transparent'; // Converts PNG files over the `convertSize` to JPEGs.

        if (file.size > options.convertSize && options.mimeType === 'image/png') {
          fillStyle = '#fff';
          options.mimeType = 'image/jpeg';
        } // Override the default fill color (#000, black)


        context.fillStyle = fillStyle;
        context.fillRect(0, 0, width, height);

        if (options.beforeDraw) {
          options.beforeDraw.call(this, context, canvas);
        }

        if (this.aborted) {
          return;
        }

        context.save();
        context.translate(width / 2, height / 2);
        context.rotate(rotate * Math.PI / 180);
        context.scale(scaleX, scaleY);
        context.drawImage(image, destX, destY, destWidth, destHeight);
        context.restore();

        if (options.drew) {
          options.drew.call(this, context, canvas);
        }

        if (this.aborted) {
          return;
        }

        var done = function done(result) {
          if (!_this3.aborted) {
            _this3.done({
              naturalWidth: naturalWidth,
              naturalHeight: naturalHeight,
              result: result
            });
          }
        };

        if (canvas.toBlob) {
          canvas.toBlob(done, options.mimeType, options.quality);
        } else {
          done(canvasToBlob(canvas.toDataURL(options.mimeType, options.quality)));
        }
      }
    }, {
      key: "done",
      value: function done(_ref7) {
        var naturalWidth = _ref7.naturalWidth,
            naturalHeight = _ref7.naturalHeight,
            result = _ref7.result;
        var file = this.file,
            image = this.image,
            options = this.options;

        if (URL && !options.checkOrientation) {
          URL.revokeObjectURL(image.src);
        }

        if (result) {
          // Returns original file if the result is greater than it and without size related options
          if (options.strict && result.size > file.size && options.mimeType === file.type && !(options.width > naturalWidth || options.height > naturalHeight || options.minWidth > naturalWidth || options.minHeight > naturalHeight)) {
            result = file;
          } else {
            var date = new Date();
            result.lastModified = date.getTime();
            result.lastModifiedDate = date;
            result.name = file.name; // Convert the extension to match its type

            if (result.name && result.type !== file.type) {
              result.name = result.name.replace(REGEXP_EXTENSION, imageTypeToExtension(result.type));
            }
          }
        } else {
          // Returns original file if the result is null in some cases.
          result = file;
        }

        this.result = result;

        if (options.success) {
          options.success.call(this, result);
        }
      }
    }, {
      key: "fail",
      value: function fail(err) {
        var options = this.options;

        if (options.error) {
          options.error.call(this, err);
        } else {
          throw err;
        }
      }
    }, {
      key: "abort",
      value: function abort() {
        if (!this.aborted) {
          this.aborted = true;

          if (this.reader) {
            this.reader.abort();
          } else if (!this.image.complete) {
            this.image.onload = null;
            this.image.onabort();
          } else {
            this.fail(new Error('The compression process has been aborted.'));
          }
        }
      }
      /**
       * Get the no conflict compressor class.
       * @returns {Compressor} The compressor class.
       */

    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Compressor = AnotherCompressor;
        return Compressor;
      }
      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */

    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        _extends(DEFAULTS, options);
      }
    }]);

    return Compressor;
  }();

  return Compressor;

})));

(function () {
  'use strict';

  angular.module('app.a4collaboratorform', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CollaboratorForm() {
    return {
      restrict: 'E',
      scope: {
        person: '=?',
        isEnabled: '=?',
        formCollaborator: '=?'
      },
      controller: 'a4CollaboratorFormController',
      controllerAs: 'vm',
      require: ['^form'],
      templateUrl: 'app/components/a4-collaborator-form/a4-collaborator-form.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4collaboratorform')
    .directive('a4CollaboratorForm', a4CollaboratorForm);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CollaboratorFormController(CONFIG, $scope, $state, $timeout, $a4FloatButton, CollaboratorsService, Common, LocalStorage, ResponsiblesService,
                                        $rootScope, PersonService, PoliciesService, $window, $q, SysTableColumn, Session) {
    var vm = this;
    vm.list = {};
    vm.company_id = Session.get('current_company', "sessionStorage");

    /**
     * Reune todas informações necessárias para o formulário
     */
    vm.getFormInfos = function () {
      $rootScope.show_loader = true;
      ResponsiblesService.getPersonInfo()
        .then(function (response) {
          vm.list.person = response.person;
          vm.list.person.type = [
            {'id': 1, 'name': 'Pessoa Física'},
            {'id': 2, 'name': 'Pessoa Jurídica'}
          ];
          vm.list.person.id_issuer = CollaboratorsService.getListIdIssuer();
          vm.required_fields_employee = SysTableColumn.getColumnsByScope('EMPLOYEE');
          $rootScope.show_loader = false;
          $timeout(function () {
            if ($scope.person.person_profession_id !== null) {
              for (var i = vm.list.person.person_profession_id.length; i--;) {
                if (vm.list.person.person_profession_id[i].id === $scope.person.person_profession_id) {
                  vm.selected_profession = vm.list.person.person_profession_id[i];
                }
              }
            }
            $rootScope.show_loader = false;
          }, 3000);
          //vm.list.person_employee = response.person_employee;
        })
    };

    $scope.$watch('isEnabled', function(newValue) {
      vm.getFormInfos();
    })

    vm.getProfessions = function (query) {
      $scope.person.new_profession_name = query;
      return ResponsiblesService.getProfessionsByQuery({query: query});
    };

    vm.changeProfession = function (item) {
      $scope.person.person_profession_id = angular.isUndefined(item) || item === null ? null : item.id;
    };

    vm.getPlaceOfBirth = function (query) {
      return PersonService.getPlaceOfBirth({query: query});
    };

    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    vm.getAddressByCep = function (CEP) {
      vm.waiting_cep = true;
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          $scope.person.address_street = address.logradouro;
          $scope.person.address_district = address.bairro;
          $scope.person.address_state = address.uf;
          vm.searchText_address_state = address.uf;
          $scope.person.address_city = address.localidade;
          vm.searchText_address_city = address.localidade;
          // vm.changeAddressState($scope.person.address_state, address.localidade);
          angular.element('#number').focus();
          vm.waiting_cep = false;
        });
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     * @param city
     */
    vm.changeAddressState = function (address_state_id, city) {
      vm.waiting_city_address_city = true;
      if (angular.isDefined(address_state_id) && angular.isDefined(address_state_id.id)) {
        $scope.person.address_state = address_state_id.id;
      } else if (vm.searchText_address_state !== null && vm.searchText_address_state !== '' && vm.searchText_address_state.length === 2) {
        $scope.person.address_state = vm.searchText_address_state;
      }
      var state = $scope.person.address_state;
      PersonService.getCities(state)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
          vm.waiting_city_address_city = false;
          var city = $window.document.getElementById('autocomplete_address_city');
          if (city !== null && angular.isDefined(city)) {
            city.focus();
          }
        })
        .catch(function () {
          vm.waiting_city_address_city = false;
        })
    };

    /**
     * Busca de estado de nascimento
     * @param filterText
     * @returns {*}
     */
    vm.getStateBirth = function (filterText) {
      var d = $q.defer();

      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        filteredItems = vm.list.person.address_state.filter(function (item) {
          return (item.id.toLowerCase()).indexOf(searchStrLower) > -1;
        });
      } else {
        filteredItems = vm.list.person.address_state;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Busca de cidade do endereço
     * @param filterText
     * @returns {*}
     */
    vm.getAddressCity = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        if (angular.isDefined(vm.list.person.address_city)) {
          filteredItems = vm.list.person.address_city.filter(function (item) {
            return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
          });
        }
      } else {
        filteredItems = vm.list.person.address_city;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Define a cidade do endereço
     * @param item
     */
    vm.setAddressCity = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.name)) {
        $scope.person.address_city = item.name;
      }
    };


    vm.init = function () {
      vm.getFormInfos();
    };

    vm.init();
  }

  angular.module('app.a4collaboratorform')
    .controller('a4CollaboratorFormController', a4CollaboratorFormController);
})();

(function () {
  'use strict';

  angular.module('app.a4collaboratorcontactform', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CollaboratorContactForm() {
    return {
      restrict: 'E',
      scope: {
        person: '=?',
        isEnabled: '=?',
        formCollaboratorContact: '=?'
      },
      controller: 'a4CollaboratorContactFormController',
      controllerAs: 'vm',
      require: ['^form'],
      templateUrl: 'app/components/a4-collaborator-contact-form/a4-collaborator-contact-form.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4collaboratorcontactform')
    .directive('a4CollaboratorContactForm', a4CollaboratorContactForm);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CollaboratorContactFormController($scope, $rootScope, StudentsService, $q, $timeout, $window,
                                               Common, PersonService, ResponsiblesService, CollaboratorsService) {
    var vm = this;
    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    vm.getAddressByCep = function (CEP) {
      vm.waiting_cep = true;
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          $scope.person.address_street = address.logradouro;
          $scope.person.address_district = address.bairro;
          $scope.person.address_state = address.uf;
          vm.searchText_address_state = address.uf;
          $scope.person.address_city = address.localidade;
          vm.searchText_address_city = address.localidade;
          // vm.changeAddressState($scope.person.address_state, address.localidade);
          angular.element('#number').focus();
          vm.waiting_cep = false;
        });
    };

    /**
     * Realiza a escuta do campo de auto-complete
     * @param address_state_id - novo item selecionado
     * @param city
     */
    vm.changeAddressState = function (address_state_id, city) {
      vm.waiting_city_address_city = true;
      if (angular.isDefined(address_state_id) && angular.isDefined(address_state_id.id)) {
        $scope.person.address_state = address_state_id.id;
      } else if (vm.searchText_address_state !== null && vm.searchText_address_state !== '' && vm.searchText_address_state.length === 2) {
        $scope.person.address_state = vm.searchText_address_state;
      }
      var state = $scope.person.address_state;
      PersonService.getCities(state)
        .then(function (response) {
          vm.list.person.address_city = response.plain();
          vm.waiting_city_address_city = false;
          var city = $window.document.getElementById('autocomplete_address_city');
          if (city !== null && angular.isDefined(city)) {
            city.focus();
          }
        })
        .catch(function () {
          vm.waiting_city_address_city = false;
        })
    };

    /**
     * Busca de estado de nascimento
     * @param filterText
     * @returns {*}
     */
    vm.getStateBirth = function (filterText) {
      var d = $q.defer();

      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        filteredItems = vm.list.person.address_state.filter(function (item) {
          return (item.id.toLowerCase()).indexOf(searchStrLower) > -1;
        });
      } else {
        filteredItems = vm.list.person.address_state;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Busca de cidade do endereço
     * @param filterText
     * @returns {*}
     */
    vm.getAddressCity = function (filterText) {
      var d = $q.defer();
      var filteredItems = [];
      var searchStrLower = filterText.toLowerCase();

      if (angular.isDefined(searchStrLower) && searchStrLower.length > 0) {
        if (angular.isDefined(vm.list.person.address_city)) {
          filteredItems = vm.list.person.address_city.filter(function (item) {
            return (item.name.toLowerCase()).indexOf(searchStrLower) > -1;
          });
        }
      } else {
        filteredItems = vm.list.person.address_city;
      }

      $timeout(function () {
        d.resolve(filteredItems);
      }, Math.random() * 1000, false);

      return d.promise;
    };

    /**
     * Define a cidade do endereço
     * @param item
     */
    vm.setAddressCity = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.name)) {
        $scope.person.address_city = item.name;
      }
    };

  }

  angular.module('app.a4collaboratorcontactform')
    .controller('a4CollaboratorContactFormController', a4CollaboratorContactFormController);
})();
(function () {
  'use strict';

  angular.module('app.a4checks', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4Checks($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        personId: '=?',
      },
      controller: 'a4ChecksController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-checks/index.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4checks')
    .directive('a4Checks', a4Checks);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4ChecksController($scope, $rootScope, PersonService) {
    var vm = this;
    vm.cnpjParams = [];
    vm.items = {
      expenses: [],
      receipts: [],
      checks: []
    };

    vm.count = 0;

    vm.init = function () {
      vm.getListOfChecksFromPerson($scope.personId);
    };

    vm.getListOfChecksFromPerson = function (person_id) {
      PersonService.getChecksFromPerson({person_id: person_id})
        .then(function (response) {
          vm.items.checks = response.checks;
          vm.count = response.count;
        })
    };

    vm.init();
  }

  angular.module('app.a4checks')
    .controller('a4ChecksController', a4ChecksController);
})();
(function () {
  'use strict';

  angular
    .module('app.a4-charts-bar', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4ChartsBar(a4Moment, $filter) {

    return {
      restrict: 'AE',
      transclude: true,
      templateUrl: 'app/components/a4-charts-bar/templates/index.html',
      scope: {
        filterDate: '=?',
        selectedAccount: '=?',
        allMovements: '=?',
        series: '=?',
        labels: '=?',
        data: '=?',
        colors: '=?',
        options: '=?',
        type: '=?',
        educational: '=?',
        customAxis: '=?',
        totals: '=?'

      },
      link: function (scope) {

        scope.options = angular.isDefined(scope.options) ? scope.options : {
          legend: {
            reverse: true,
            display: true
          },
          tooltips: {
            enabled: true,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              // Tooltip do título (label do eixo X)
              title: function(tooltipItems, data) {
                var index = tooltipItems[0].index;
                return data.labels[index];
              },
              // Tooltip dos labels (séries)
              label: function(tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var label = dataset.label || '';
                var value = $filter('currency')(dataset.data[tooltipItem.index], 'R$ ', 2);
                return label + ': ' + value;
              },
              afterBody: function(tooltipItems, data) {
                if (scope.totals && scope.totals.length > 0) {
                  var index = tooltipItems[0].index;
                  var total = scope.totals[index];
                  return [
                    '---',
                    'TOTAL: ' + $filter('currency')(total, 'R$ ', 2)
                  ];
                }
                return [];
              }
            }
          },
          scales: {
            xAxes: [{
              stacked: true,
            }],
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                display: true,
                stacked: true,
                position: 'left',
                scaleLabel: {
                  display: true,
                  labelString: 'Valor'
                },
                ticks: {
                  // Include a dollar sign in the ticks
                  callback: function (value, index, values) {
                    if(scope.customAxis === undefined) {
                      return $filter('currency')(value, 'R$ ', 2);
                    } else {
                      return value;
                    }
                  }
                }
              }
            ]
          },
          elements: {
            line: {
              fill: false
            }
          }
        };


        // scope.labels = null;
        // scope.series = null;
        //scope.data = null;

        /**
         * update of data
         */
        scope.$watch('allMovements', function () {
          scope.init();
        }, true);

        /**
         * init
         */
        scope.init = function () {
          // if(angular.isDefined(scope.educational) && scope.educational){
          //
          // } else
          if ((angular.isDefined(scope.filterDate) && scope.filterDate !== null) &&
            (angular.isDefined(scope.allMovements) && scope.allMovements !== null)) {

            var dateStart = a4Moment(scope.filterDate.initDate);
            var dateEnd = a4Moment(scope.filterDate.endDate);
            var result = dateStart;
            var saldo = [];
            var options = null;

            scope.labels = [];
            scope.series = ['Saldo'];

            if (scope.allMovements.movements.length > 0) {

              var value = 0;
              var len = scope.allMovements.movements.length;
              var date = null;

              for (var i = len; i > 0; i--) {
                var movement = scope.allMovements.movements[i - 1];

                if (date !== movement.date) {
                  scope.labels.push(a4Moment(scope.parseDate(movement.date)).format('DD MMMM'));
                  saldo.push(movement.saldo);
                }

                date = movement.date;

              }

              scope.labels = scope.labels.reverse();
              saldo = saldo.reverse();

              // sem movements para a conta
              if (scope.allMovements.movements.length === 0) {
                scope.labels = [dateStart.format('DD MMMM'), dateEnd.format('DD MMMM')];
                saldo = [parseInt(scope.allMovements.last_balance), parseInt(scope.allMovements.last_balance)];
              }

              scope.data = [
                saldo
              ];

              if (scope.allMovements.total_balance < 0) {
                scope.colors = ['#ff0000']; // saldo negativo
              } else {
                scope.colors = ['#949FB1']; // saldo positivo
              }

            } else {
              scope.data = [
                saldo = [0]
              ];
              scope.labels = [a4Moment().format('DD MMMM'), a4Moment().format('DD MMMM')];
            }
          }

        };

        /**
         * onClick
         * @param points
         * @param evt
         */
        scope.onClick = function (points, evt) {
        };

        scope.parseDate = function (date) {
          if (date !== undefined) {
            if (date.indexOf('/') > -1) {
              var dateconverted = date.split('/');
              return dateconverted[2] + "-" + dateconverted[1] + "-" + dateconverted[0];
            } else {
              return date;
            }
          }
        };

      }
    }
  }

  angular
    .module('app.a4-charts-bar')
    .directive('a4ChartsBar', a4ChartsBar)
})
();

(function () {
  'use strict';

  angular
    .module('app.a4-charts', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4Charts(a4Moment) {

    return {
      restrict: 'AE',
      transclude: true,
      templateUrl: 'app/components/a4-charts/templates/index.html',
      scope: {
        filterDate: '=?',
        selectedAccount: '=?',
        allMovements: '=?',
        series: '=?',
        labels: '=?',
        data: '=?',
        colors: '=?',
        options: '=?',
        educational: '=?',
        labelString: '=?',
        withPrinter: '=?'
      },
      link: function (scope) {
        // scope.labelString = angular.isDefined(scope.labelString) ? scope.labelString : '';
        scope.options = angular.isDefined(scope.options) ? scope.options : {
          legend: {
            reverse: false,
            display: true
          },
          scales: {
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                display: true,
                position: 'left',
                scaleLabel: {
                  display: true,
                  labelString: angular.isDefined(scope.labelString) ? scope.labelString : ''
                }
              }
            ]
          },
          elements: {
            line: {
              fill: false
            }
          }
        };

        scope.datasetOverride = [
          {yAxisID: 'y-axis-1'}
        ];

        // scope.labels = null;
        // scope.series = null;
        //scope.data = null;

        /**
         * update of data
         */
        scope.$watch('allMovements', function () {
          scope.init();
        }, true);

        /**
         * init
         */
        scope.init = function () {
          // if(angular.isDefined(scope.educational) && scope.educational){
          //
          // } else
          if ((angular.isDefined(scope.filterDate) && scope.filterDate !== null) &&
            (angular.isDefined(scope.allMovements) && scope.allMovements !== null)) {

            var dateStart = a4Moment(scope.filterDate.initDate);
            var dateEnd = a4Moment(scope.filterDate.endDate);
            var result = dateStart;
            var saldo = [];
            var options = null;

            scope.labels = [];
            scope.series = ['Saldo'];

            if (scope.allMovements.movements.length > 0) {

              var value = 0;
              var len = scope.allMovements.movements.length;
              var date = null;

              for (var i = len; i > 0; i--) {
                var movement = scope.allMovements.movements[i - 1];

                if (date !== movement.date) {
                  scope.labels.push(a4Moment(scope.parseDate(movement.date)).format('DD MMMM'));
                  saldo.push(movement.saldo);
                }

                date = movement.date;

              }

              scope.labels = scope.labels.reverse();
              saldo = saldo.reverse();

              // sem movements para a conta
              if (scope.allMovements.movements.length === 0) {
                scope.labels = [dateStart.format('DD MMMM'), dateEnd.format('DD MMMM')];
                saldo = [parseInt(scope.allMovements.last_balance), parseInt(scope.allMovements.last_balance)];
              }

              scope.data = [
                saldo
              ];

              if (scope.allMovements.total_balance < 0) {
                scope.colors = ['#ff0000']; // saldo negativo
              } else {
                scope.colors = ['#949FB1']; // saldo positivo
              }

            } else {
              scope.data = [
                saldo = [0]
              ];
              scope.labels = [a4Moment().format('DD MMMM'), a4Moment().format('DD MMMM')];
            }
          }

        };

        scope.printChart = function () {
          var dataUrl = document.getElementById('line').toDataURL();

          var windowContent = '<!DOCTYPE html>';
          windowContent += '<html>';
          windowContent += '<head><title>Gráfico A4Cloud</title></head>';
          windowContent += '<body>';
          windowContent += '<img src="' + dataUrl + '">';
          windowContent += '</body>';
          windowContent += '</html>';

          var printWin = window.open('', '', 'width=600,height=300');
          printWin.document.open();
          printWin.document.write(windowContent);

          printWin.document.addEventListener('load', function () {
            printWin.focus();
            printWin.print();
            printWin.document.close();
            printWin.close();
          }, true);

        };

        /**
         * onClick
         * @param points
         * @param evt
         */
        scope.onClick = function (points, evt) {
        };

        scope.parseDate = function (date) {
          if (date !== undefined) {
            if (date.indexOf('/') > -1) {
              var dateconverted = date.split('/');
              return dateconverted[2] + "-" + dateconverted[1] + "-" + dateconverted[0];
            } else {
              return date;
            }
          }
        };

      }
    }
  }

  angular
    .module('app.a4-charts')
    .directive('a4Charts', a4Charts)
})
();

(function () {
  'use strict';
  angular
    .module('app.a4-charts')
    .config(['ChartJsProvider', function (ChartJsProvider) {

      ChartJsProvider.setOptions({
        responsive: true
      });

    }])
})();

(function () {
  'use strict';
  angular.module('app.a4-card-message', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CardMessage() {
    return {
      templateUrl: 'app/components/a4-card-message/message-card.html',
      // controller: '',
      // controllerAs: '',
      scope: {
        message1: '@',
        message2: '@',
        message3: '@',
      },
      link: function (scope, element, attr, ctrl) {
        scope.message1 = (scope.message1 === '') ? null : scope.message1;
        scope.message2 = (scope.message2 === '') ? null : scope.message2;
        scope.message3 = (scope.message3 === '') ? null : scope.message3;
      }
    }
  }

  angular.module('app.a4-card-message')
    .directive('a4CardMessage', a4CardMessage)

})();
(function () {
  'use strict';

  angular.module('app.a4-card-controls', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CardControls($compile, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        array: '=?',
        type: '=?',
        item: '=?',
        subItemIndex: '=?',
        canDelete: '=?'
      },
      controller: 'a4CardControlsController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-card-controls/a4-card-controls.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4-card-controls')
    .directive('a4CardControls', a4CardControls);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CardControlsController($scope, $rootScope, QuestionnairesService, ModalFactory) {
    var vm = this;
    /**
     * Move elemento de um array para uma posição acima
     * @param type
     * @param item
     * @param updown
     * @param sub_item_index
     */
    vm.move = function (type, item, updown, sub_item_index) {
      var question = item;
      var array = [];
      var index = 0;
      switch (type) {
        case 'questions':
          array = $scope.array;
          index = array.indexOf(item);
          break;
        case 'events':
          array = $scope.array;
          index = array.indexOf(item);
          break;
        case 'subquestions':
          array = $scope.array[$scope.array.indexOf(item)].items;
          index = sub_item_index;
          item = array[index];
          /**
           * ajusta as notas baseadas no valor de sub_item_index e updown
           * sendo sub_item_index o valor da opção que foi mudada
           * e updown a direção que ela foi, fazendo o valor ser ou +1 ou -1
           * apenas se for o item com a respota certa
           */
          if(question.right_answer === sub_item_index ) {
          switch (updown) {
            case 'up':
              if (index !== 0) {
                question.right_answer = sub_item_index - 1;
              } else {
                question.right_answer = array.length - 1;
              }
              break;
            case 'down':
              question.right_answer = Math.min(array.length - 1, sub_item_index + 1);
              break;
          }
      }
      }
      array.splice(index, 1);
      switch (updown) {
        case 'up':
          if (index !== 0) {
            array.splice(index - 1, 0, item);
          } else {
            array.splice(array.length, 0, item);
          }
          break;
        case 'down':
          array.splice(index + 1, 0, item);
          break;
      }

      vm.reorder();
    };

    vm.reorder = function () {
      var question_number_ptr = 0;
      $scope.array.forEach(function (item, index) {
        item.ord = index + 1;
        item.items.forEach(function (option, i) {
          option.ord = i;
        });

        item.question_number = (item.question_type_id == 'SP') ? null : ++question_number_ptr;

      });
      $scope.$applyAsync();
    };

    /** Verifica se o item excluído tem resposta e caso tenha abre o card de 
     * confirmação, caso não exclui diretamente. */
    vm.checkQuestionsWithAnswer = function (item) {
      $rootScope.show_loader = true;
      if ($scope.type !== 'subquestions') {
        vm.removed_sub_item = item.id;
      } else {
        vm.removed_sub_item = $scope.item.items[$scope.subItemIndex]  ;
      }

      if (!vm.removed_sub_item || typeof vm.removed_sub_item.id === 'undefined') {
        vm.delete(item);
        $rootScope.show_loader = false;
        return;
      }

      QuestionnairesService.checkQuestionWithAnswer({
        removed_sub_item_id: vm.removed_sub_item.id
      })
      .then(function (response) {
        $rootScope.show_loader = false;
        if (response.length > 0) {
          ModalFactory.prompt(
            null,
            'Atenção!',
            'Excluir esse item excluirá as respostas ligadas a ela! Se quiser continuar digite "Excluir" no campo abaixo e clique em confirmar, do contrário a exclusão não será realizada',
            '',
            '', 
            'Confirmar',
            'Cancelar',
            'educational'
          ).then(function (text) {
            if(text == 'excluir' || text == 'Excluir') {
              vm.delete(item)
            }
          });
        } else {
          vm.delete(item)
        }
      })
    }

    vm.delete = function (item) {
      if ($scope.type !== 'subquestions') {
        // Exclui a questão da array
        $scope.array.splice($scope.array.indexOf(item), 1);

        // Recalcula os números das questões e a ordenação
        // Considerando que a ordenação é sequencial incluíndo separadores
        // e que separadores não têm números de questão,
        // então a contagem do índice é diferente para cada um deles
        let question_number_ptr = 0;
        $scope.array.forEach(function (option, index) {
          option.ord = index + 1
          option.question_number = (option.question_type_id === 'SP') ? null : ++question_number_ptr;
        });

      } else {
        if ($scope.subItemIndex == $scope.item.right_answer) {
          $scope.item.right_answer = undefined;
        }
        $scope.item.items.splice($scope.subItemIndex, 1);
        $scope.item.items.forEach(function (option, index) {
          option.ord = index
        });

        if(item.right_answer > (item.items.length - 1)) {
          $scope.item.right_answer = (item.items.length - 1);
        }
      }
    };


  }

  angular.module('app.a4-card-controls')
    .controller('a4CardControlsController', a4CardControlsController);
})();

(function () {
  'use strict';

  angular
    .module('app.a4-calendar', ['ui.calendar']);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4Calendar() {
    return {
      templateUrl: 'app/components/a4-calendar/a4-calendar-template.html',
      restrict: 'E',
      required: 'ngModel',
      scope: {
        uiCalendarConfig: '=',
        events: '&',
        eventClick: '&?',
        eventDrop: '&?',
        eventResize: '&?',
        eventRender: '&?',
        personId: '=?'
      },
      controller: 'a4CalendarController',
      controllerAs: 'vm'
    }
  }

  angular
    .module('app.a4-calendar')
    .directive('a4Calendar', a4Calendar)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4CalendarController($scope, $timeout, ModalFactory) {
    /* configrações do calendário */
    var vm = this;
    /** Evento inicial para não ocorrer erro na renderização por conta do atraso no retorno do callback */
    $scope.event = [];
    $scope.uiConfig = {};

    var events_calendar = function (start, end, timezone, callback) {
      // Converter para datas locais sem hora
      var startDate = start.clone().local().startOf('day');
      var endDate = end.clone().local().startOf('day');
      
      console.log('Normalized dates:', startDate.format(), 'to', endDate.format());
      
      var personId = $scope.personId;
      $scope.events({
        id: personId, 
        start: startDate.toISOString(),
        end: endDate.toISOString()
      })
      .then(function (response) {
        callback(response.plain ? response.plain() : response);
      })
      .catch(function(error) {
        console.error('Error loading events:', error);
        callback([]);
      });
    };
    vm.eventsSources = [events_calendar];
    $scope.onClick = function (date, jsEvent, view) {
      // ModalFactory.open("calendarDetails", jsEvent, a4CalendarController, date);
    };

    /* config object */
    vm.lastView = 'agendaDay';
    $scope.uiConfig = {
      calendar: {
        defaultView: 'agendaDay',
        locale: 'pt-br',
        monthNames: [
          'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
          'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ],
        monthNamesShort: [
          'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
        ],
        dayNames: [
          'Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado'
        ],
        dayNamesShort: [
          'Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'
        ],
        axisFormat: 'HH:mm', timeFormat: 'HH:mm', buttonText: {
          today: "Hoje",
          month: "Mês",
          week: "Semana",
          day: "Dia"
        },
        navLinks: true, // can click day/week names to navigate views
        editable: false,
        eventLimit: true, // allow "more" link when too many events
        eventLimitText: 'evento(s)',
        allDayText: 'Durante o dia',
        displayEventEnd: true,
        minTime: '06:00:00',
        header: {
          left: 'today prev,next',
          center: 'title',
          right: 'month,agendaDay'
        },
        views: {
          month: {
            columnFormat: 'ddd'
          },
          day: {
            columnFormat: 'dddd'
          }
        },
        eventClick: $scope.onClick,
        viewRender: function (view, element) {
            angular.element('#calendar').fullCalendar('refetchEvents');
          vm.lastView = view.name;
        },
      }
    };
    $timeout(function () {
      angular.element('#calendar').fullCalendar('refetchEvents')
    }, 1000);
  }

  angular
    .module('app.a4-calendar')
    .controller('a4CalendarController', a4CalendarController)
})();

(function () {
  'use strict';

  angular
    .module('app.a4-board-list', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BoardList() {
    return {
      templateUrl: 'app/components/a4-board-list/a4-board-list.html',
      restrict: 'E',
      required: 'ngModel',
      scope: {
        boardName: '=',
        boardCards: '=',
        editModal: '&'
      },
      controller: 'a4BoardListController',
      controllerAs: 'vm',
      link: function () {
      }
    }
  }

  angular
    .module('app.a4-board-list')
    .directive('a4BoardList', a4BoardList)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4BoardListController($scope, $timeout, a4Moment) {
    var vm = this;

    vm.openCardDialog = function (card) {
      $scope.editModal({
        card: card
      });
    }

    /**
     * Verifica se a data passou do prazo para mudar a cor do badge
     * @param date
     * @returns {boolean}
     */
    vm.isOverdue = function (date) {
      return a4Moment() > a4Moment(date);
    }
  }

  angular
    .module('app.a4-board-list')
    .controller('a4BoardListController', a4BoardListController)
})();
(function () {
  'use strict';

  angular.module('app.a4-block-message', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BlockMessage(LoginService, LocalStorage, a4Moment, Session, ModalFactory, $window) {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/components/a4-block-message/a4-block-message.html',
      link: function (scope) {
        scope.profile_selected = Session.getCurrentProfile();
        scope.show_message = true;
        LoginService.getDaysToBlock()
          .then(function (resp) {
            scope.days_to_block = resp.days_to_block;
            if (a4Moment(resp.last_date_before_block) !== null) {
              scope.last_date_before_block = a4Moment(resp.last_date_before_block).format('DD/MM/YYYY');
            }
            var day_close = a4Moment(LocalStorage.get('day_close_block_message'));
            scope.show_message = a4Moment().diff(day_close, 'days') !== 0;
          })
          .catch(function (err) {
            if (err.data === 'SYSTEM_BLOCK') {
              ModalFactory.open('block-access', null, null, null, null, 'controlpanel')
                .catch(function () {
                  $window.location.reload();
                });
            }
          });

        scope.closeMessage = function () {
          scope.show_message = false;
          LocalStorage.add('day_close_block_message', a4Moment());
        }
      }
    }
  }

  angular.module('app.a4-block-message')
    .directive('a4BlockMessage', a4BlockMessage);
})();
(function () {
  'use strict';

  angular.module('app.a4birthinformations', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BirthInformations() {
    return {
      restrict: 'E',
      scope: {
        person: '=?',
        isEnabled: '=?',
        listCountries: '=?',
        notRequired: '=?',
        formScope: '=?'
      },
      controller: 'a4BirthInformationsController',
      controllerAs: 'vm',
      require: ['^form'],
      templateUrl: 'app/components/a4-birth-informations/a4-birth-informations.html',
      link: function (scope) {
      }
    }
  }

  angular.module('app.a4birthinformations')
    .directive('a4BirthInformations', a4BirthInformations);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BirthInformationsController($scope, $rootScope, $timeout, Session,
                                         EducationalService, SysTableColumn,
                                         BillReceiptService, PersonService) {
    var vm = this;
    vm.BRASIL = 76;
    vm.is_bilingual_school = false;
    vm.is_national_id_number_required = true;
    vm.company = Session.getCurrentCompany();


    // Flags para controle
    var isProcessing = false;
    var hasInitialized = false;
    var hasAddedNoNationalityOption = false;

    vm.$onInit = function () {
      if (hasInitialized) return;
      hasInitialized = true;
      $scope.$on('personUpdated', function(event, updatedPerson) {
        if (updatedPerson) {
          $scope.person = updatedPerson
          console.log('Dados recebidos via evento:', updatedPerson);
          vm.initializePlaceOfBirth(updatedPerson); // Atualiza lógica interna
        }
      });

      // Watch para atualizar dados quando isEnabled mudar
      $scope.$watch('isEnabled', function(newValue) {
        if (newValue === true) {
          // Carregar configurações quando componente estiver habilitado
          BillReceiptService.getConfig()
            .then(function (response) {
              var config = response.plain();
              vm.is_bilingual_school = config.is_bilingual_school;
              vm.company_city = config.address_city;
              vm.company_state = config.address_state_code;

              // Inicializar local de nascimento após carregar dados da empresa
              initializePlaceOfBirth();

              return EducationalService.hasNationalIdNumberRequired();
            })
            .then(function (response) {
              var obj = response.plain();
              vm.is_national_id_number_required = obj.is_national_id_number_required;
            })
            .catch(function (error) {
              console.error('Erro ao carregar configurações:', error);
              // Definir valores padrão em caso de erro
              vm.is_bilingual_school = false;
              vm.is_national_id_number_required = true;
            });
        } else if (newValue === false && $scope.person) {
          // Atualizar listCountries quando isEnabled for false
          updateCountriesList();
        } else {
          $scope.listCountries = vm.list_of_nationalities;
        }
      });

      // Watcher para atualizar as alterações em country_id_nationality.
      $scope.$watch('person.country_id_nationality', function(newVal, oldVal) {
        if (newVal !== oldVal && newVal !== undefined) {
          $rootScope.$emit('countryNationalityChanged', newVal);
        }
      });

      // Verificação da variável $scope.listCountries
      $scope.$watch('listCountries', function (newVal) {
        if (angular.isDefined(newVal) && !hasAddedNoNationalityOption) {
          // Adiciona uma opção nula à lista de nacionalidades apenas uma vez
          $scope.listCountries.unshift({
            id: null,
            iso_alpha3: null,
            name: "Sem nacionalidade",
            name_second_language: null,
            nationality: "Sem Nacionalidade",
            nationality_second_language: null
          });
          hasAddedNoNationalityOption = true;
        }
      });

      // Watch para as propriedades relevantes do objeto person
      $scope.$watchGroup(['person.place_of_birth', 'person.state_of_birth', 'person.id'], function() {
        if ($scope.person.id) {
          initializePlaceOfBirth();
        }
      });

      // Inicializar campos necessários com base no escopo do formulário
      initializeRequiredFields();
    };

    // Função para atualizar a lista de países
    function updateCountriesList() {
      if (!$scope.person) return;

      if ($scope.person.country_id_of_birth != $scope.person.country_id_nationality) {
        $scope.listCountries = [
          {
            id: $scope.person.country_id_of_birth,
            name: $scope.person.country_of_birth,
            nationality: $scope.person.country_birth_nationality
          },
          {
            id: $scope.person.country_id_nationality,
            name: $scope.person.country_nationality_name,
            nationality: $scope.person.country_nationality
          }
        ];
      } else {
        $scope.listCountries = [
          {
            id: $scope.person.country_id_of_birth,
            name: $scope.person.country_of_birth,
            nationality: $scope.person.country_birth_nationality
          }
        ];
      }

      // Reset flag para permitir adicionar a opção "Sem nacionalidade"
      hasAddedNoNationalityOption = false;
    }

    // Inicializar campos necessários com base no escopo do formulário
    function initializeRequiredFields() {
      if (angular.isDefined($scope.formScope) && $scope.formScope !== '') {
        switch ($scope.formScope) {
          case 'EMPLOYEE':
            vm.required_fields_employee = SysTableColumn.getColumnsByScope('EMPLOYEE');
            break;
          case 'RESPONSIBLE':
            vm.required_fields_responsible = SysTableColumn.getColumnsByScope('RESPONSIBLE');
            vm.required_fields_payee = SysTableColumn.getColumnsByScope('PAYEE');
            break;
          case 'STUDENT':
            vm.required_fields_student = SysTableColumn.getColumnsByScope('STUDENT');
            break;
        }
      }
    }

    // Função auxiliar para inicializar o place_of_birth
    function initializePlaceOfBirth() {
      // Evita reprocessamento e verifica se o objeto person existe
      if (isProcessing || !$scope.person) return;

      isProcessing = true;

      console.log('Inicializando place_of_birth');

      if (angular.isDefined($scope.person.place_of_birth) &&
        $scope.person.place_of_birth !== null) {
        if (angular.isDefined($scope.person.state_of_birth) &&
           $scope.person.state_of_birth !== null) {

          vm.place_of_birth = {
            name: $scope.person.place_of_birth + '/' + $scope.person.state_of_birth,
            state_id: $scope.person.state_of_birth
          }

        } else {
          vm.place_of_birth = {
            name: $scope.person.place_of_birth,
            state_id: null
          }
        }

      } else {
        // local de nascimento não definido
        if (angular.isUndefined($scope.person.id) || $scope.person.id === null) {
          if (vm.company_city && vm.company_state) {
            // usando valores default da empresa para local de nascimento
            vm.place_of_birth = {
              name: vm.company_city + '/' + vm.company_state,
              state_id: vm.company_state
            };
            $scope.person.place_of_birth = vm.company_city;
            $scope.person.state_of_birth = vm.company_state;
          }
        } else {
          vm.place_of_birth = null;
        }
      }

      // Inicializar país de nascimento e nacionalidade se necessário
      if ($scope.person &&
        (angular.isUndefined($scope.person.id) || $scope.person.id === null) &&
        $scope.person.country_id_of_birth == null) {
        $scope.person.country_id_of_birth = vm.BRASIL;
        $scope.person.country_id_nationality = vm.BRASIL;
      }

      isProcessing = false;
    }

    // Atualiza a nacionalidade quando o país de nascimento mudar
    vm.countryOfBirthChange = function (country_id_of_birth) {
      if (!$scope.person) return;

      // Corrigido para usar country_id_nationality em vez de person_id_nationality
      if ($scope.person.country_id_nationality === null) {
        $scope.person.country_id_nationality = country_id_of_birth;
      }
    };

    // Busca locais de nascimento baseado na consulta
    vm.getPlaceOfBirth = function (query) {
      return PersonService.getPlaceOfBirth({query: query});
    };

    // Trata o evento de blur no campo de local de nascimento
    vm.handleBlur = function(countryId, inputText) {
      // Verifica se o país é o Brasil e se tem texto de entrada
      if ((countryId === vm.BRASIL || countryId === null) && inputText) {
        // Cria um objeto temporário se o usuário não selecionou da lista
        var placeObj = vm.place_of_birth || { name: inputText };
        vm.changePlaceOfBirth(countryId, placeObj);
      }
    };

    // Processa a mudança no local de nascimento
    vm.changePlaceOfBirth = function (country_id_of_birth, place_of_birth) {
      if (!$scope.person) return;

      // Lista de UFs do Brasil
      var ufs = [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
        'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
        'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
      ];

      if (place_of_birth !== null) {
        if (country_id_of_birth === null || country_id_of_birth === vm.BRASIL) {
          var name = place_of_birth.name || '';

          var array = name.split("/");

          if (array.length > 1) {
            // Verificar se o que vem após a "/" é uma UF válida
            var possibleUF = array[1].trim().toUpperCase();

            if (ufs.includes(possibleUF)) {
              // É uma UF válida, separar cidade e estado
              $scope.person.place_of_birth = array[0].trim();
              $scope.person.state_of_birth = possibleUF;
            } else {
              // Não é uma UF válida, considerar tudo como cidade
              $scope.person.place_of_birth = name;
              $scope.person.state_of_birth = null;
            }
          } else {
            // Não há separador "/", considerar tudo como cidade
            $scope.person.place_of_birth = name;
            $scope.person.state_of_birth = null;
          }
        } else {
          // Para outros países
          $scope.person.place_of_birth = place_of_birth.name || '';
          $scope.person.state_of_birth = null;
        }
      } else {
        // Se place_of_birth for nulo
        $scope.person.place_of_birth = null;
        $scope.person.state_of_birth = null;
      }
    };
  }

  angular.module('app.a4birthinformations')
    .controller('a4BirthInformationsController', a4BirthInformationsController);
})();

(function () {
  'use strict';

  angular.module('app.a4billsoperation', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BillsOperation() {
    return {
      restrict: 'E',
      scope: {
        bills: '=',
        currentItem: '=',
        updateBills: '&',
        showDescription: '=?',
        showEdit: '=?',
        disableFinalValue: '=?',
        futureDiscounts: '=?',
        type: '=?'
      },
      controller: 'a4BillsOperationController',
      controllerAs: 'vm',
      require: [],
      templateUrl: 'app/components/a4-bills-operation/a4-bills-operation.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4billsoperation')
    .directive('a4BillsOperation', a4BillsOperation);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BillsOperationController($scope, ModalFactory, $rootScope, CreditsService, $filter, Utils, a4Moment, PoliciesService, Session) {
    var vm = this;
    vm.currentItem = $scope.currentItem;
    vm.bills = $scope.bills;
    vm.show_edit = angular.isDefined($scope.showEdit) ? $scope.showEdit : false;
    vm.disable_final_value = angular.isDefined($scope.disableFinalValue) ? $scope.disableFinalValue : false;
    vm.show_description = angular.isDefined($scope.showDescription) ? $scope.showDescription : true;
    vm.show_future_discounts = angular.isDefined($scope.futureDiscounts) ? $scope.futureDiscounts : true;
    vm.company = Session.getCurrentCompany();
    vm.selected_option = 'a';
    vm.list_edit = [];
    vm.allowance_all = 0;
    vm.creditAmount = 0;    
    vm.today = a4Moment();
    vm.show_allowance_payment = true;
    vm.show_deduct_fine_and_interest = true;
    vm.show_give_disc = true;

    if (vm.company !== 101390) {
      vm.disable_mov_retroativo = false;
    } else{
      vm.disable_mov_retroativo = true;
    }

    $rootScope.$on('BILL_LIST.change', function () {
      vm.calcTotalAmount(vm.currentItem.currentItemList);
    });
    $rootScope.$on('PAYMENT_TAX.change', function (ev, data) {
      if (data.tax > 0 && vm.currentItem.paymentTax !== data.tax) {
        vm.currentItem.totalAmount = parseFloat(vm.originalTotalAmount) + parseFloat(data.tax);
        vm.currentItem.paymentTax = data.tax;
      }
    });

    $rootScope.$on('PAYMENT_DIFFERENCE.change', function (ev, data) {
      var difference = data.difference * -1;
      if (data.debitcredit === 'D') {
        var amount = vm.currentItem.currentItemList[0].partial_payment_msg !== null ? parseFloat(vm.currentItem.currentItemList[0].difference) : parseFloat(vm.currentItem.currentItemList[0].amount);
        if (data.option === 1) {
          vm.currentItem.currentItemList[0].value_paid = amount - difference;
          // if (vm.currentItem.currentItemList[0].partial_payment_value > 0) {
          //   vm.currentItem.currentItemList[0].partial_payment_value -= difference;
          // } else {
          //   vm.currentItem.currentItemList[0].partial_payment_value = (vm.currentItem.currentItemList[0].amount - difference);
          // }
          vm.currentItem.currentItemList[0].is_partial_payment = 1;
          // vm.currentItem.currentItemList[0].selected_option = 'c';
        }
        if (data.option === 4) {
          amount = amount - difference;
          vm.currentItem.currentItemList[0].amount = amount;
          vm.currentItem.currentItemList[0].value_paid = amount;
        }
        if (data.option === 6) {
          amount = amount + difference;
          vm.currentItem.currentItemList[0].amount = amount;
          vm.currentItem.currentItemList[0].value_paid = amount;
        }
        if (data.option === 5) {
          vm.currentItem.currentItemList[0].calc_discount_cond_value = (vm.currentItem.currentItemList[0].calc_discount_cond_value !== null ? parseFloat(vm.currentItem.currentItemList[0].calc_discount_cond_value) : 0) + difference;
          vm.currentItem.currentItemList[0].value_paid = amount - vm.currentItem.currentItemList[0].calc_discount_cond_value
            + (vm.currentItem.currentItemList[0].calc_interest_value !== null ? parseFloat(vm.currentItem.currentItemList[0].calc_interest_value) : 0)
            + (vm.currentItem.currentItemList[0].calc_fine_value !== null ? parseFloat(vm.currentItem.currentItemList[0].calc_fine_value) : 0);
        }
        vm.currentItem.currentItemList[0].final_value = vm.currentItem.currentItemList[0].value_paid;
      } else {

        if (data.option === 1) {
          if (vm.currentItem.currentItemList[0].partial_payment_value > 0) {
            vm.currentItem.currentItemList[0].partial_payment_value -= difference;
          } else {
            vm.currentItem.currentItemList[0].partial_payment_value = (vm.currentItem.currentItemList[0].final_value - difference) - vm.currentItem.currentItemList[0].allowance_value;
          }
          vm.currentItem.currentItemList[0].allowance_value = 0;
          vm.currentItem.currentItemList[0].is_partial_payment = 1;
          vm.currentItem.currentItemList[0].selected_option = 'c';
        }
        if (data.option === 2) {
          vm.currentItem.currentItemList[0].allowance_value += difference;
          vm.currentItem.currentItemList[0].partial_payment_value = 0;
          vm.currentItem.currentItemList[0].is_partial_payment = 0;
          vm.currentItem.currentItemList[0].selected_option = 'b';
        }
        if (data.option === 3) {
          var total_amount = 0;
          vm.currentItem.currentItemList.forEach(function (value) {
            if (value.partial_payment_value === 0) {
              total_amount += parseFloat(value.final_value);
            }
          });
          vm.currentItem.currentItemList.forEach(function (item) {
            if (item.partial_payment_value === 0) {
              item.allowance_value += (((item.final_value * 100) / total_amount) * difference) / 100;
              item.selected_option = 'b';
            }
          });
          // vm.allowance_all = parseFloat(difference);
        }
      }
      vm.calcTotalAmount(vm.currentItem.currentItemList);
    });

    vm.init = function () {
      vm.today = a4Moment();
      vm.calcTotalAmount(vm.currentItem.currentItemList);
      vm.getCreditsFromPersons();

      /* Verifica a permissão "Entrada/Saida retroativa" para bloquear "Data da ação" */
      if(vm.checkPolicies('mov_retroativo')){
        vm.disable_mov_retroativo = false;
      }

      /* Verifica a permissão "Negociações>Abater juros/multa" para dasabilitar os checkboxs "Abater juros/multa" da sidenav de pagamento de negociação*/
      if(vm.checkPolicies('neg_clear_fines')){
        vm.show_deduct_fine_and_interest = false;
      }

      /* Verifica a permissão "Caixa>Abono" para dasabilitar os checkboxs "Abater juros/multa" da sidenav de pagamento do caixa */
      if(vm.checkPolicies('allowance')){
        vm.show_allowance_payment = false;
      }

      /* Verifica a permissão "Negociações>Concerder descontos vencidos/futuros" para dasabilitar o checkbox "Conceder descontos vencidos/futuros" */
      if(vm.checkPolicies('neg_give_disc')){
        vm.show_give_disc = false;
      }

      /* Verifica a permissão "Negociações>Alterar valor final" para dasabilitar o input "Valor final" */
      if(vm.checkPolicies('neg_change_final_value')){
        vm.disable_final_value = true;
      }

    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.getCreditsFromPersons = function () {
      var ids = [];
      vm.currentItem.currentItemList.forEach(function (item) {
        if (ids.indexOf(item.person_id) < 0) {
          ids.push(item.person_id);
        }
      });
      CreditsService.getLastCreditFromPersons({person_id: ids.join(',')})
        .then(function (response) {
          var credits = response.plain();
          vm.currentItem.creditAmount = 0;
          vm.use_credit = $filter('orderBy')(credits, 'balance')[0];
          vm.currentItem.creditAmount = angular.isDefined(vm.use_credit) ? parseFloat(vm.use_credit.balance) : 0;
          vm.currentItem.creditPerson = angular.isDefined(vm.use_credit) ? vm.use_credit.person_id : null;
        })
    };

    vm.abbreviate = function (string) {
      if (angular.isDefined(string)) {
        return Utils.abbreviateString(string, 35);
      }
    };

    /**
     * Atualiza os valores da lista de títulos de acordo com a data selecionada
     */
    vm.updateBills = function () {
      $scope.updateBills();
    }

    /**
     * Remove o bill selecionado
     */
    vm.removeItem = function (item) {
      var index = vm.currentItem.currentItemList.indexOf(item);
      vm.currentItem.currentItemList.splice(index, 1);
      vm.calcTotalAmount(vm.currentItem.currentItemList);
    };

    /**
     * Atualiza o cálculo dos bills selecionados
     */
    vm.updateCalc = function () {
      vm.calcTotalAmount(vm.billList);
      vm.currentItem.amount = vm.currentItem.totalAmount;
      vm.currentItem.currentItemList = vm.billList;
    };

    /**
     *
     * @param value - Valor a ser subtraído ou adicionado
     * @param bool - true: realiza a operação - false: desfaz a operação
     */
    vm.changeFinalValue = function (value, bool) {
      /*vm.calcTotalAmount(vm.billList);*/
      // if (bool) {
      //   vm.currentItem.totalAmount = parseFloat(vm.currentItem.totalAmount) - value;
      //   vm.currentItem.totalAllowanceFineInterest = parseFloat(vm.currentItem.totalAllowanceFineInterest) + value;
      //   vm.currentItem.amount = vm.currentItem.totalAmount;
      // } else {
      //   vm.currentItem.totalAmount = parseFloat(vm.currentItem.totalAmount) + value;
      //   vm.currentItem.totalAllowanceFineInterest = parseFloat(vm.currentItem.totalAllowanceFineInterest) - value;
      //   vm.currentItem.amount = vm.currentItem.totalAmount;
      // }
      vm.calcTotalAmount(vm.currentItem.currentItemList);
      // vm.currentItem.currentItemList.forEach(function (item) {
      //   vm.calcAllowance(item);
      // });
      $scope.$applyAsync();
    };

    vm.changeTotalAmount = function () {
      vm.currentItem.amount = vm.currentItem.totalAmount;
    };

    /**
     * Calcula todos os bills selecionados
     */
    vm.calcTotalAmount = function (list) {
      vm.currentItem.totalAmount = 0;
      vm.currentItem.totaldiscounts = 0;
      vm.currentItem.totalMulta = 0;
      vm.currentItem.totalJuros = 0;
      vm.currentItem.totalMissedDiscounts = 0;
      vm.currentItem.futureDiscounts = 0;
      vm.currentItem.totalAllowanceFineInterest = 0;
      vm.currentItem.totalOtherAllowance = 0;
      vm.currentItem.giveOtherAllowance = false;
      vm.currentItem.checkPaymentTax = true;
      vm.allowance_all = 0;
      vm.other_allowances = 0;
      angular.forEach(list, function (value) {
        value.show_final_value = angular.copy(value.final_value);
        value.show_current_value = angular.copy(value.final_value);
        vm.currentItem.totalMulta += value.calc_fine_value !== null ? parseFloat(value.calc_fine_value) : 0;
        vm.currentItem.totalJuros += value.calc_interest_value !== null ? parseFloat(value.calc_interest_value) : null;
        vm.currentItem.totalMissedDiscounts += value.missed_discount !== null ? parseFloat(value.missed_discount) : 0;
        vm.calcAllowance(value);
        if (angular.isUndefined(value.partial_payment_value) || value.partial_payment_value === 0) {
          vm.currentItem.totaldiscounts += parseFloat(value.discount_fixed_value) + parseFloat(value.calc_discount_cond_value) + parseFloat(value.calc_discount_prom_value);
          var futureDiscount = (parseFloat(value.calc_discount_cond_value) + parseFloat(value.calc_discount_prom_value))
            - parseFloat(value.missed_discount);
          vm.currentItem.futureDiscounts += angular.isDefined(futureDiscount) && !isNaN(futureDiscount) && futureDiscount > 0 ? futureDiscount : 0;
          if (angular.isDefined(value.allowance_value) && value.allowance_value > 0) {
            vm.currentItem.totalOtherAllowance += parseFloat(value.allowance_value);
            // vm.currentItem.totalAmount -= parseFloat(value.allowance_value);
            value.is_partial_payment = 0;
            vm.currentItem.giveOtherAllowance = true;
          }
          value.show_final_value -= value.allowance;
          vm.currentItem.totalAmount += parseFloat(value.show_final_value);
        } else {
          vm.currentItem.totalAmount += parseFloat(value.partial_payment_value);
          value.is_partial_payment = 1;
          value.show_final_value = value.partial_payment_value;
        }
      });
      // if (vm.allowance_all > 0) {
      // vm.currentItem.totalOtherAllowance += parseFloat(vm.other_allowances);
      // vm.currentItem.totalAmount -= parseFloat(vm.allowance_all);
      // }
      if (vm.currentItem.paymentTax > 0) {
        vm.currentItem.totalAmount = vm.currentItem.totalAmount + parseFloat(vm.currentItem.paymentTax);
      }
      vm.currentItem.totalAmountCalc = vm.currentItem.totalAmount;
      vm.originalTotalAmount = angular.copy(vm.currentItem.totalAmount);
      vm.show_table = true;
      // $scope.$applyAsync();
    };

    /**
     * Calcula o valor do abono para um título baseado no valor definido para ele e se os checkboxes estão marcados
     * Os valores de multa, juros e descontos perdidos são somados ao abono definido no título
     * @param item
     */
    vm.calcAllowance = function (item) {
      item.allowance = 0;
      if (angular.isDefined(item.allowance_value) && item.allowance_value > 0) {
        item.allowance += parseFloat(item.allowance_value);
        vm.other_allowances += parseFloat(item.allowance_value);
      }
      if (vm.currentItem.allowanceFine) {
        if (item.calc_fine_value !== null) {
          item.allowance += parseFloat(item.calc_fine_value);
          vm.allowance_all += parseFloat(item.calc_fine_value);
        }
      }
      if (vm.currentItem.allowanceInterest) {
        if (item.calc_interest_value !== null) {
          item.allowance += parseFloat(item.calc_interest_value);
          vm.allowance_all += parseFloat(item.calc_interest_value);
        }
      }
      if (vm.currentItem.giveLostedDiscounts) {
        if (item.missed_discount !== null) {
          item.allowance += parseFloat(item.missed_discount);
          vm.allowance_all += parseFloat(item.missed_discount);
        }
      }
    };

    /**
     * Abre o modal para edição do valor, desconto, multa e juros
     * @param item
     */
    vm.editItem = function (item) {
      var index = vm.currentItem.currentItemList.indexOf(item);
      if (angular.isDefined(item.productDiscount)) {
        item.totalDiscount = parseFloat(item.productDiscount);
      } else {
        item.totalDiscount = parseFloat(item.calc_discount_cond_value) + parseFloat(item.calc_discount_prom_value) + parseFloat(item.discount_fixed_value) + parseFloat(item.discount);
      }
      item.value_paid = item.final_value;
      ModalFactory.customClean(
        'app/finance/bill-payment/modals/EditBillValues.html',
        'BillPaymentEditItemController',
        'vm',
        false,
        item
      ).then(function (value) {
        vm.currentItem.currentItemList[index] = value;
        vm.calcTotalAmount(vm.currentItem.currentItemList);
      }).catch(function () {
      });
    };

    vm.init();
  }

  angular.module('app.a4billsoperation')
    .controller('a4BillsOperationController', a4BillsOperationController)
})();

(function () {
  'use strict';
  angular.module('app.a4-bill-grid', []);
})();
(function () {
  'use strict';

  function BillExpenseActionsService($a4Sidenav, $mdDialog, $rootScope, a4Moment, $state,
                                     BillReceiptService, Common, ModalFactory, BillExpenseService) {
    var vm = this;
    /**
     * changeStatus
     * Troca o status do titulo
     * @param id - identificador do titulo
     * @param status - Para qual status será modificado
     * @param is_multiple - Se é uma operação sobre múltiplos títulos
     */
    vm.changeStatus = function (id, status, is_multiple) {
      var deferred = Common.$q.defer();

      ModalFactory.prompt(
        null,
        'Justificativa',
        'Digite o motivo para essa ação:',
        '',
        '',
        'Confirmar',
        'Cancelar',
        'finance')
        .then(function (text) {
          if (text != null) {
            var obj;
            if (is_multiple) {
              obj = {bills: id, status: status, notes: text};
              BillExpenseService.changeStatusMultipleBills(obj).then(function (response) {
                if (response) {
                  // $state.go($state.current, {}, {reload: true});
                  deferred.resolve(true);
                  return true;
                }
              }).catch(function (response) {
                vm.apiErrorMessageByStatusCode(response);
                deferred.reject(false)
              });
            } else {
              obj = {bill_id: id, idStatus: status, justification: text};
              BillExpenseService.changeStatusOfBill(obj)
                .then(function (response) {
                  if (response) {
                    // $state.go($state.current, {}, {reload: true});
                    deferred.resolve(true);
                    return true;
                  }
                })
                .catch(function (response) {
                  vm.apiErrorMessageByStatusCode(response);
                  deferred.reject(false)
                });
            }
          } else {
            Common.Toast.warning('Justifique a ação.');
          }
        });

      return deferred.promise;
    };

    /**
     * Abre side nav de desfazer recebimento
     * @param item
     */
    vm.undoPayment = function (item) {
      $a4Sidenav({width: '700px'})
        .open('app/finance/bill-reverse/views/form-reverse.html', 'BillReverseController', 'vm', {item: item});
    };

    /**
     * Abre side nav de extornar
     * @param item
     */
    vm.chargeback = function (item) {
      $a4Sidenav({width: '700px'})
        .open('app/finance/bill-chargeback/views/chargeback-index.html', 'BillChargeBackController', 'vm', {item: item});
    };

    /**
     * Abre side nav de fazer negociação
     * @param item
     */
    vm.setNegotiate = function (item) {
      var current_itemCopy = angular.copy(item);
      $a4Sidenav({width: '700px'})
        .open('app/finance/bill-negotiate/views/form-negotiate.html', 'BillNegotiateController', 'vm', {
          item: current_itemCopy, undonegotiate: false
        });
    };

    /**
     * Abre side nav de desfazer negociação
     * @param item
     */
    vm.undoNegotiate = function (item) {
      var current_itemCopy = angular.copy(item);
      $a4Sidenav({width: '700px'})
        .open('app/finance/bill-negotiate/views/form-negotiate.html', 'BillNegotiateController', 'vm', {
          item: current_itemCopy, undonegotiate: true
        });
    };

    /**
     * Abre slide de pagamento
     * @param item
     */
    vm.setPayment = function (item) {
      var current_itemCopy = angular.copy(item);
      var title = "Realizar pagamento";
      $a4Sidenav({width: '805px'})
        .open('app/finance/bill-payment/views/form-payment.html', 'BillPaymentController', 'vm', {
          item: current_itemCopy, title: title,
          is_manual_payment: true
        });
    };

    /**
     * Faz o request para a API e retorna a despesa por id
     * @param id - identificador do titulo
     * @param edit_expense - identificador do titulo
     */
    vm.getBillById = function (id, edit_expense) {
      vm.currentItem = null;
      BillReceiptService.getBillById(id, {'edit_expense': edit_expense})
        .then(function (response) {
          $rootScope.show_loader = false;
          vm.currentItem = response;
          vm.currentItems = response;

          vm.currentItem.amount = parseFloat(vm.currentItem.amount);
          vm.currentItem.issue_date = a4Moment(response.issue_date);

          vm.currentItem.due_date = a4Moment(response.due_date);
          vm.currentItem.issue_date = a4Moment(response.due_date);

          if (vm.currentItem.payment_installments !== undefined) {
            vm.currentItem.hasPaid = vm.getIfInstallmentHasOnePaid(vm.currentItem.payment_installments);
          }

          if (vm.currentItem !== undefined) {

            vm.currentItem.next_adjustment_date = a4Moment(vm.currentItem.next_adjustment_date);

            if (vm.currentItem.date_end) {
              vm.currentItem.end_of_recurrence = 1;
              vm.currentItem.date_end = a4Moment(vm.currentItem.date_end);
            }

            if (vm.currentItem.date_first) {
              vm.currentItem.date_first = a4Moment(vm.currentItem.date_first);
            }

            if (vm.currentItem.quantity > 0) {
              vm.currentItem.end_of_recurrence = 0;
            }

            if (angular.isArray(vm.currentItem.discounts_rules) && vm.currentItem.discounts_rules.length > 0) {
              vm.currentItem.discounts_rules.forEach(function (value) {
                value.end_date = a4Moment(value.end_date);
                value.start_date = a4Moment(value.start_date);
              })
            }

            if (vm.currentItem.tags != null && vm.currentItem.tags.length > 0) {
              vm.currentItem.tags = vm.currentItem.tags.filter(function (item, i, ar) {
                return ar.indexOf(item) === i;
              });
            }

            vm.currentItem.frequency = response.frequency;
            vm.currentItem.frequency_qty = response.frequency_qty;
            vm.currentItem.frequency_type = response.frequency_type;
            vm.currentItem.edit_expense = null;
            if (vm.currentItem.debit_credit === "C") {
              $a4Sidenav({width: '800px'}).open('app/finance/bill-receipt/views/form-edit.html', 'BillReceiptEditController', 'vm', {bill: vm.currentItem});
            } else if (vm.currentItem.debit_credit === "D") {
              $a4Sidenav({width: '800px'}).open('app/finance/bill-expense/views/new-form.html', 'BillExpenseEditController', 'vm', {bill: vm.currentItem});
            }
          }

        })
    };

    /**
     * Verifica se algum installments está pago.
     * @param payment_installments - Lista de parcelas.
     * @returns {boolean}
     */
    vm.getIfInstallmentHasOnePaid = function (payment_installments) {
      for (var i = 0, len = payment_installments.length; i < len; i++) {
        if (payment_installments[i].status === 1) {
          return true
        }
      }
    };


    /**
     * SIDE NAVS
     * Editar um titulo
     * @param item
     */
    vm.edit = function (item) {
      vm.getBillById(item.id, 1);
    };


    /**
     * Remove um titulo
     * @param item
     */
    vm.delete = function (item) {
      var bill = {bill_id: item.id};
      var deferred = Common.$q.defer();

      ModalFactory.prompt(
        null,
        'Justificativa',
        'Digite o motivo para essa ação de exclusão:',
        '',
        '',
        'Confirmar',
        'Cancelar',
        'finance')
        .then(function (text) {
          if (text !== '' && text !== undefined) {
            BillExpenseService.deleteBill({bill: bill, justification: text})
              .then(function () {
                deferred.resolve(true);
              })
              .catch(function (response) {
                if (response.data.message === 'FAILED_TO_DELETE' && item.bill_serie_id !== null) {
                  Common.Toast.error('Não é possível excluir! Existe algum título na recorrência que não está em aberto.');
                }
                vm.apiErrorMessageByStatusCode(response);
                deferred.reject(true);
              });
          } else {
            Common.Toast.warning('Por favor, digite uma justificativa.');
          }
        });
      return deferred.promise;
    };
    /**
     * Remove um titulo
     * @param array
     */
    vm.deleteMultiple = function (array) {
      var deferred = Common.$q.defer();

      ModalFactory.prompt(
        null,
        'Justificativa',
        'Digite o motivo para essa ação de exclusão:',
        '',
        '',
        'Confirmar',
        'Cancelar',
        'finance')
        .then(function (resp) {
          if (resp !== '' && resp !== undefined) {
            $rootScope.show_loader = true;
            BillExpenseService.deleteMultipleBill({bills: array, justification: resp})
              .then(function () {
                deferred.resolve(true);
              })
              .catch(function (response) {
                if (response.data.message === 'FAILED_TO_DELETE' && item.bill_serie_id !== null) {
                  Common.Toast.error('Não é possível excluir! Existe algum título na recorrência que não está em aberto.');
                }
                vm.apiErrorMessageByStatusCode(response);
                deferred.reject(true);
              });
          } else {
            Common.Toast.warning('Por favor, digite uma justificativa.');
          }
        });
      return deferred.promise;
    };


    /**
     * undoChangeStatus
     * Desfaz a mudança de status
     * @param id - identificador do titulo
     * @param status - e para qual status vai
     */
    vm.undoChangeStatus = function (id, status) {
      if ((status === 2 || status === 3 || status === 5 || status === 6)) {
        var deferred = Common.$q.defer();

        ModalFactory.prompt(
          null,
          'Justificativa',
          'Digite o motivo para desfazer:',
          '',
          '',
          'Confirmar',
          'Cancelar',
          'finance')
          .then(function (text) {
            if (text != null) {
              var obj = {bill_id: id, idStatus: 99, justification: text};

              BillExpenseService.changeStatusOfBill(obj).then(function (response) {
                if (response) {
                  deferred.resolve(true);
                }
              }).catch(function (response) {
                vm.apiErrorMessageByStatusCode(response);
                deferred.reject(true);
              });
            } else {
              Common.Toast.warning('Justifique a ação.');
            }
          });
      }
      return deferred.promise;
    };

    /**
     * Abre a sidenav para pagamento de múltiplos títulos
     * @param ev
     * @param item
     */
    vm.setPaymentMultiple = function (ev, item) {
      var title = '';
      if (item[0].debit_credit === "C") {
        title = "Realizer recebimento";
      } else {
        title = "Realizar pagamento"
      }
      $a4Sidenav({width: '805px'}).open('app/finance/bill-payment/views/form-payment.html', 'BillPaymentController', 'vm', {
        item: item,
        title: title,
        is_manual_payment: true
      });
    };

    /**
     *
     * @param response
     */
    vm.apiErrorMessageByStatusCode = function (response) {
      switch (parseInt(response.status)) {
        case 400:
          Common.Toast.error('Sem autorização para visualizar a lista.');
          break;
        case 500:
          Common.Toast.error('Não foi possivel comunicar com o servidor.');
          break;
      }
    };

    return vm;
  }

  angular.module('app.a4-bill-grid')
    .service('BillExpenseActionsService', BillExpenseActionsService)
})();
(function () {
  'use strict';

  function A4BillInfiniteControl() {
    var vm = this;

    vm.page = 1;
    vm.block = false;
    vm.hasDataToLoad = false;

    /**
     * Retorna o numero atual da pagina
     * @return {number|*}
     */
    vm.getPage = function () {
      vm.block = false;
      return vm.page;
    };
    /**
     * Retorna o numero atual da pagina
     * @return {number|*}
     */
    vm.getHasDataToLoad = function () {
      return vm.hasDataToLoad;
    };

    /**
     * Incrementa o número da page e retorna
     * @return {number|*}
     */
    vm.increment = function () {
      if (!vm.block) {
        vm.block = true;
        vm.page = vm.page + 1;
      }
      return vm.page;
    };

    vm.blockIncrement = function () {
      vm.block = true;
    };

    vm.unblockIncrement = function () {
      vm.block = true;
    };
    /**
     * Coloca a classe com os valores padrão
     */
    vm.default = function () {
      vm.page = 1;
      vm.block = false;
    };


    return vm;

  }

  angular.module('app.a4-bill-grid')
    .factory('A4BillInfiniteControl', A4BillInfiniteControl)
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BillGrid($window) {

    return {
      templateUrl: 'app/components/a4-bill-grid/a4-bill-grid.html',
      restrict: 'E',
      controller: 'A4BillGridController',
      controllerAs: 'vm',
      scope: {
        paginate: '=ngModel',
        paginateFunction: '&',
        debitCredit: '@', //"C" ou "D"
        withFilter: '=?',
        showLoader: '=?',
        showCreateButton: '=?',
        onPrintGrid: '&?',
        showPrinter: '=?',
        heightGrid: '=?',
        showButtonMore: '=?',
        isStudent: '=?',
        isFinance: '=?',
        personId: '=?',
        personIdPayee: '=?'
      },
      link: function (scope, element, attrs) {
        scope.width = $window.innerWidth;
        scope.showLoader = angular.isUndefined(scope.showLoader) ? false : scope.showLoader;
        scope.personIdPayee = angular.isUndefined(scope.personIdPayee) ? null : scope.personIdPayee;
        scope.height = $window.innerHeight;
        scope.outerheight = $window.outerHeight;
        scope.fullHeight = angular.element('#page-material-table').height();
        scope.showCreateButton = angular.isUndefined(scope.showCreateButton) ? false : scope.showCreateButton;
        scope.getOnlySelectedStudent = true;

        if (angular.isUndefined(attrs.debitCredit) || attrs.debitCredit == null) {
          throw new Error('atributo debit-credit é obrigatório, com valor "C" ou "D"');
        }

      }
    }
  }

  angular.module('app.a4-bill-grid')
    .directive('a4BillGrid', a4BillGrid)

})();
(function () {
    'use strict';

    /** @ngInject */
    function A4BillGridController($rootScope, $scope, $a4FloatButton, BillReceiptService, PoliciesService, $state,
                                  $stateParams,
                                  A4BillInfiniteControl, Session, CashierSessionService, a4Moment, BillExpenseService,
                                  BillExpenseActionsService, $a4Sidenav, Common, BillGridService, ModalFactory, $document,
                                  A4NegotiationService, $timeout, ChargeService, GuestCheckPadService, CONFIG, ReportsService) {
      var vm = this;
      var RECEBIMENTO = "C";
      var PAGAMENTO = "D";
      vm.current_page = 2;
      vm.show_only_student = false;
      vm.show_only_group = false;
      vm.years = [];
      vm.conf = {
        token: null,
        current_company: null,
        current_connection: null
      };
      vm.showWarningLED = false;
      vm.webLink = CONFIG.webApiUri;
      vm.current_school_period_id = Session.getCurrentSchoolPeriod().id;

      vm.tableItemsSelected = [];
      vm.status_filter = BillReceiptService.getFilterStatus();
      vm.filter_date = null;
      vm.disableNegotiate = false;
      vm.is_responsible = Session.get('is_responsible');

      var on = $rootScope.$on('UPDATE_BILL_LIST', function () {
        vm.internPaginate(1, 15);
      });

      var on2 = $rootScope.$on('open-undo-negotiate', function (ev, bill) {
        vm.internPaginate(1, 15);
        $timeout(function () {
          vm.tableItemsSelected = [];
          vm.undoNegotiate(bill);
        }, 2000);
      });

      /**
       * Inicializador
       */
      vm.init = function () {
        vm.is_parent = PoliciesService.isParent();
        vm.context = Session.getContext();
        vm.profile_selected = PoliciesService.currentProfile();
        vm.conf.current_company = Session.get('current_company', "sessionStorage");
        vm.conf.current_connection = $document[0].domain.split('.')[0];
        vm.conf.user_settings = angular.fromJson(Session.user.settings_json);
        vm.conf.user_id = Session.user.id;
        ReportsService.getToken()
          .then(function (token) {
            vm.conf.token = token;
          });
        for (var i2 = 0; i2 <= 10; i2++) {
          var momentVar = a4Moment().subtract(i2, 'year');
          vm.years.push(momentVar.format('YYYY'));
        }

        /* Verifica a permissão "Negociar" para dasabilitar o botão "Negociar" */
        if(vm.checkPolicies('neg_make')){
          vm.disableNegotiate = true;
        }

      };

      /**
       * Verifica Politicas de acesso
       * @param policy - Identificador da politica de acesso
       * @returns {boolean}
       */
      vm.checkPolicies = function (policy) {
        return !PoliciesService.checkPolicyFromMenu(policy);
      };

      vm.verifyDisableButton = function () {
        var bills = angular.copy(vm.tableItemsSelected);
        bills.forEach(function (item) {
          if (item.status !== 1 && item.partial_payment_msg === null) {
            vm.disablePayment = true;
            vm.disableNegotate = true;
          } else {
            vm.disablePayment = false;
            vm.disableNegotate = false;
          }
          if (item.type !== 1 || (item.status !== 1 && item.status !== 6 && item.status !== 5)) {
            vm.disabledDelete = true;
            vm.disabledCancel = true;
          } else {
            vm.disabledDelete = false;
            vm.disabledCancel = false;
          }
          if (item.status !== 1 && item.status !== 6 && item.status !== 5 && item.partial_payment_msg === null) {
            vm.disabledDismiss = true;
          } else {
            vm.disabledDismiss = false;
          }
        });
      };

      /**
       * Exclui títulos em grupo
       * @param bills
       */
      vm.deleteMultipleBills = function (bills) {
        BillExpenseActionsService.deleteMultiple(bills)
          .then(function () {
            $rootScope.show_loader = false;
            vm.internPaginate(1, 15);
            Common.Toast.success('Título excluído com sucesso!')
            $rootScope.$emit('UPDATE_BILL_LIST');
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      };

      /**
       * Verifica se a diferença entre dois números é maior que 1
       * @param x
       * @param y
       * @returns {boolean}
       */
      vm.differenceBetweenTwoNumbers = function (x, y) {
        return x - y <= 1;
      };

      /**
       * Paginador da tabela
       * @param page - Pagina corrente
       * @param qtd - Quantidade de registros por pagina
       */
      vm.internPaginate = function (page, qtd) {
        qtd = angular.isUndefined($scope.paginate) ? qtd : $scope.paginate.per_page;
        vm.current_page = vm.current_page + 1;
        /** Flag para notificar a possível mudança do filtro */
        return vm.promise = $scope.paginateFunction({
          page: page,
          qtd: qtd,
          date: vm.filter_date,
          person_id: null,
          status: vm.selected_status,
          flag: true,
          order: $scope.paginate.order,
          show_only_student: vm.show_only_student
        });
      };

      /**
       * Emite evento de mudança no checkbox para mostrar somente títulos do aluno
       */
      vm.emitShowOnlyStudentChange = function () {
        $scope.$emit('change-show-only-student',
          vm.show_only_student
        );
      };

      vm.emitShowOnlyGroupChange = function () {
        $scope.$emit('change-show-only-group',
          vm.show_only_group
        );
      };
      vm.emitShowAllPeriods = function () {
        $scope.$emit('change-show-all-periods',
          vm.show_all_school_periods
        );
      };



      /**
       * Paginador da tabela
       * @param order - direção de ordem dos registros
       */
      vm.internReorder = function (order) {
        /** Flag para notificar a possível mudança do filtro */
        return vm.promise = $scope.paginateFunction({
          page: 1,
          qtd: 20,
          date: vm.filter_date,
          person_id: null,
          status: vm.selected_status,
          flag: true,
          order: order
        });
      };

      /**
       * Edita observações do título
       * @param bill
       */
      vm.editNotes = function (bill) {
        var obj = angular.copy(bill);
        ModalFactory.custom('app/components/a4-bill-grid/a4-bill-grid-edit-notes.html', obj, false, null).then(function (object) {
          BillGridService.editNotes(object).then(function () {
            Common.Toast.success('Observações adicionadas com sucesso!');
            $rootScope.$emit('UPDATE_BILL_LIST');
            vm.internPaginate();
          })
        })
      };

      /**
       * Edita observações de múltiplos títulos
       * @param array
       */
      vm.editObservationsMultiple = function (array) {
        ModalFactory.custom('app/components/a4-bill-grid/a4-bill-grid-edit-notes.html', {notes: null}, false, null).then(function (object) {
          BillGridService.editNotesMultiple({notes: object.notes, bills: array}).then(function () {
            Common.Toast.success('Observações adicionadas com sucesso!');
            $rootScope.$emit('UPDATE_BILL_LIST');
            vm.internPaginate();
          })
        })
      };

      vm.editBillChargeStatus = function (bill) {
        var obj = angular.copy(bill);
        BillGridService.getBillChargeStatus().then(function (response) {
          ModalFactory.custom('app/components/a4-bill-grid/a4-bill-grid-edit-bill-charge.html',
            {
              bill_charge_status: response.plain(),
              bill_charge_status_id: bill.bill_charge_status_id,
              id: obj.id
            }, false, null).then(function (object) {
            BillGridService.editBillChargeStatus(object).then(function () {
              Common.Toast.success('Status de cobrança adicionado com sucesso!');
              $rootScope.$emit('UPDATE_BILL_LIST');
              vm.internPaginate();
            })
          })
        })
      };


      /**
       * Disparada quando o status do filtro muda
       */
      vm.changeStatusList = function () {
        /** sempre que o status muda o paginador volta para 1 */
        A4BillInfiniteControl.default();
      };

      /**
       * Retorna o detalhamento do titulo
       * @param bill_id - Identificador do titulo
       */
      vm.getDetailsFromBill = function (bill_id) {
        BillGridService.openDetailsModal(bill_id);
      };

      /**
       * Realiza pagamento de um titulo
       */
      vm.payments = function (item) {
        BillExpenseActionsService.setPayment(item)
        .then(function () {
          $rootScope.show_loader = false;
        });;
      };

      /**
       * Imprime recibo de pagamento do título
       * @param bill_action_id
       */
      vm.printReceipt = function (bill_action_id) {
        CashierSessionService.printGuestCheckPadReport(bill_action_id, false);
      };

      /**
       * Realiza pagamento de um titulo
       */
      vm.changeStatus = function (id, status, current_page, is_multiple) {
        $rootScope.show_loader = true;
        BillExpenseActionsService.changeStatus(id, status, is_multiple)
          .then(function () {
            Common.Toast.success('Operação realizada com sucesso!');
            $rootScope.$emit('UPDATE_BILL_LIST');
            // $state.go($state.current, {}, {reload: true});
            $rootScope.show_loader = false;
          });

      };

      vm.printIncomeTaxReport = function () {
        ModalFactory.custom('app/components/a4-bill-grid/print-income-tax.html', {
          years: vm.years,
          year: a4Moment().format('YYYY')
        }).then(function (year) {
          return ReportsService.reportFactory('GET', 'api/reports/printincometax', {
            person_id: $scope.personIdPayee !== null ? $scope.personIdPayee : $scope.personId,
            user_id: vm.conf.user_id, year: year
          })

        })
      };

      /**
       * Desfaz pagamento de um titulo
       */
      vm.undoPayment = function (item) {
        // if (item.cashier_session_id === null) {
        //   BillExpenseActionsService.undoPayment(item);
        // } else {
          if (item.close_datetime === null) {
            ModalFactory.open('require_password', null, null, {bill_action_id: item.bill_action_id}, null, 'finance',
              vm.executeUndoGuestCheckPad, 'Desfazimento de recibo de caixa',
              'O pagamento deste título foi realizado na comanda número ' + item.bill_action_id +
              '. Ao confirmar, irá desfazer o pagamento de todos os títulos associados à comanda. Preencha sua senha para desfazer todos os movimentos ' +
              'deste recibo de caixa.', null).then(function () {
              Common.Toast.success('Comanda desfeita com sucesso!');
              $rootScope.$emit('UPDATE_BILL_LIST');
              vm.internPaginate(1, 15);
            })
          } else {
            ModalFactory.alert(
              "Pagamento não pode ser desfeito", "A comanda de pagamento deste título faz parte de uma sessão de caixa que já foi encerrada, não podendo ser desfeita.",
              "modal", "Ok", "false", "finance"
            );
          }
        // }
      };
      /**
       * Execução do desfazimento de comanda
       * @param bill_action_id
       * @returns {void|*}
       */
      vm.executeUndoGuestCheckPad = function (bill_action_id) {
        return GuestCheckPadService.undoGuestCheckPad(bill_action_id);
      };

      /**
       * Extorna pagamento de um titulo
       */
      vm.chargeback = function (item) {
        BillExpenseActionsService.chargeback(item)
        .then(function () {
          $rootScope.show_loader = false;
        });
      };

      /**
       * Negocia um titulo
       */
      vm.setNegotiate = function (item) {
        BillExpenseActionsService.setNegotiate(item);
      };

      /**
       * Desfaz qualquer status
       */
      vm.undoChangeStatus = function (id, status) {
        BillExpenseActionsService.undoChangeStatus(id, status)
          .then(function () {
            var qtd = angular.isUndefined($scope.paginate.per_page) ? 20 : $scope.paginate.per_page;
            var page = angular.isUndefined($scope.paginate.current_page) ? 1 : $scope.paginate.current_page;
            $scope.paginateFunction({
              page: page,
              qtd: qtd,
              date: null,
              person_id: null,
              status: vm.selected_status,
              flag: false
            });
          });
      };

      /**
       * Desfaz negociação de um titulo
       */
      vm.undoNegotiate = function (item) {
        $rootScope.show_loader = true;
        BillGridService.getNegotiationInfo({bill_id: item.id})
          .then(function (response) {
            $rootScope.show_loader = false;
            response = response.plain();
            A4NegotiationService.getNegotiationDetails({
              bill_action_id_origin: response.bill_action_id_origin,
              bill_serie_id: response.bill_serie_id
            }).then(function (resp) {
              resp = resp.plain();
              resp.origin_negotiation[0].settlement_date = item.settlement_date;
              resp.result_negotiation[0].total_negotiation = response.total_amount;
              resp.total_origin = item.amount_paid;
              ModalFactory.customClean(
                'app/components/a4-negotiation/negotiation-modal.html',
                'A4NegotiationModalController',
                'vm', false, resp
              )
            })
          })
      };
      /**
       * Desfaz negociação de um titulo
       */
      vm.delete = function (item) {
        $rootScope.show_loader = true;
        BillExpenseActionsService.delete(item)
          .then(function () {
            $rootScope.show_loader = false;
            vm.internPaginate(1, 15);
            Common.Toast.success('Título excluído com sucesso!')
            $rootScope.$emit('UPDATE_BILL_LIST');
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      };

      /**
       * Editar um titulo
       */
      vm.editSideNav = function (item) {
        BillExpenseActionsService.edit(item);
      };


      vm.createBill = function () {
        if ($scope.debitCredit === PAGAMENTO) {
          $a4Sidenav({width: '800px'}).open('app/finance/bill-expense/views/new-form.html', 'BillExpenseCreateController', 'vm', {});
        } else if ($scope.debitCredit === RECEBIMENTO) {
          $a4Sidenav({width: '800px'}).open('app/finance/bill-receipt/views/form.html', 'BillReceiptCreateController', 'vm', {
            is_create: true
          });
        }
        $rootScope.show_loader = false;
      };

      var ltn = $scope.$watch(function () {
        return vm.tableItemsSelected.length;
      }, function (newer) {
        if (newer >= 2) {
          if (angular.isDefined(vm.floatButton)) {
            vm.floatButton.destroy(vm.floatButton.options.scope.$id);
          }

          if ($scope.showCreateButton) {
            vm.floatButton = $a4FloatButton({
              scope: $scope,
              conditional: !vm.checkPolicies('ctsrec_alt') || !vm.checkPolicies('ctspag_alt'),
              type: 'menu',
              theme: 'finance',
              items: [
                {
                  label: $scope.debitCredit === RECEBIMENTO ? 'Receber' : 'Pagar',
                  icon: 'attach_money',
                  conditional: !vm.checkPolicies('ctsrec_alt') || !vm.checkPolicies('ctspag_alt'),
                  onClick: 'vm.setPayment(vm.tableItemsSelected)'
                },
                {label: 'Excluir', icon: 'delete_forever', conditional: true, onClick: ''},
                {label: 'Cancelar', icon: 'cancel', conditional: true, onClick: ''},
                {
                  label: 'Negociar',
                  icon: 'done_all',
                  conditional: true,
                  onClick: 'vm.setNegotiate(vm.tableItemsSelected)'
                },
                {label: 'Dispensar', icon: 'done', conditional: true, onClick: ''},
                {label: 'Marcar como "duvidoso"', icon: 'announcement', conditional: true, onClick: ''},
                {label: 'Marcar como "prejuízo"', icon: 'report', conditional: true, onClick: ''}
              ]
            });
          }

        } else if (newer < 2) {
          if (angular.isDefined(vm.floatButton)) {
            vm.floatButton.destroy(vm.floatButton.options.scope.$id);
          }

          if ($scope.showCreateButton) {
            vm.floatButton = $a4FloatButton({
              scope: $scope, onClick: 'vm.createBill()', theme: 'finance',
              label: $scope.debitCredit === RECEBIMENTO ? 'Criar nova entrada' : 'Criar nova saida',
              conditional: !vm.checkPolicies('ctsrec_alt') || !vm.checkPolicies('ctspag_alt')
            });
          }
        }
      });

      /**
       * Abre a sidenav para pagamento de múltiplos títulos
       * @param ev
       * @param item
       * @param idSide
       */
      vm.setPaymentMultiple = function (ev, item, idSide) {
        BillExpenseActionsService.setPaymentMultiple(ev, angular.copy(item), idSide);
      };

      vm.hasNegoatiationBill = function (list) {
        var hasNegotiationBill = false;
        list.forEach(function (bill) {
          if (bill.type === 4 || bill.status === 4) {
            hasNegotiationBill = true;
          }
        });
        return hasNegotiationBill;
      };
      /**
       * Seta os parâmetros para uma negociação com mais de um título
       * @param ev - evento
       * @param items - títulos
       */
      vm.setNegotiateMultiple = function (ev, items) {
        if (vm.isDifferentPerson(items)) {
          Common.Toast.warning("Não pode fazer esta ação para duas pessoas diferentes.");
        } else if (vm.hasNegoatiationBill(items)) {
          Common.Toast.warning("Não pode fazer esta ação para título negociado.");
        } else {
          $a4Sidenav({width: '700px'}).open('app/finance/bill-negotiate/views/form-negotiate.html', 'BillNegotiateController', 'vm', {
            item: items,
            undonegotiate: false
          });
        }
      };

      /**
       * Abre modal para visualização de ocorrências de cobrança
       */
      vm.getChargeOccurrences = function () {
        $rootScope.show_loader = true;
        ChargeService.getAll({
          limit: 50, page: 1, person_id: $scope.personId
        }).then(function (response) {
          $rootScope.show_loader = false;
          vm.charges = response;
          if (vm.charges.data.length === 0) {
            Common.Toast.warning('Não existem ocorrências para esta pessoa');
          } else {
            ModalFactory.custom(
              'app/components/a4-bill-grid/charge-occurrences-modal.html', vm.charges);
          }
        })
      };

      /**
       * Abre modal de reprogramação de título
       * @param bill
       */
      vm.reprogramBill = function (bill) {
        ModalFactory.customClean(
          'app/components/a4-bank-slip/bank_slip_second_way.html',
          'a4BankSlipSecondController',
          'vm',
          false,
          bill).then(function () {
          $scope.paginateFunction({
            page: 1,
            qtd: 20,
            date: null,
            person_id: null,
            status: vm.selected_status,
            flag: false
          });
        })
      };

      /**
       * Desfaz reprogramação de título
       * @param bill
       */
      vm.undoReprogrammedBill = function (bill) {
        ModalFactory.confirm(null, 'Confirmação',
          'Deseja realmente desfazer esta reprogramação? ' +
          'Caso existam boletos gerados, eles serão cancelados.',
          'Confirmar', 'Cancelar', 'finance').then(function () {
          $rootScope.show_loader = true;
          BillGridService.undoReprogrammedBill(bill).then(function () {
            Common.Toast.success('Reprogramação desfeita com sucesso!');
            $scope.paginateFunction({
              page: 1,
              qtd: 20,
              date: null,
              person_id: null,
              status: vm.selected_status,
              flag: false
            });
            $rootScope.show_loader = false;
          })
        });

      };

      /**
       * Checa de existem dois persons diferentes para negociar um grupo de títulos
       * @param list - lista de títulos
       * @returns {boolean}
       */
      vm.isDifferentPerson = function (list) {
        if (list.length > 0) {
          var person = list[0].person_id;
          var result = false;
          for (var i = 0; i < list.length; i++) {
            if (person !== list[i].person_id) {
              result = true;
              break;
            }
          }
        }
        return result;
      };

      vm.init();

      $scope.$on('$destroy', function () {
        [ltn, on, on2].forEach(function (fn) {
          fn();
        })
      })
    }


    angular.module('app.a4-bill-grid')
      .controller('A4BillGridController', A4BillGridController)
  }

)();

(function () {
  'use strict';

  /** @ngInject */
  function BillGridService($rootScope, Restangular, Common, ModalFactory) {
    var vm = this;

    vm.getDetails = function (bill_id) {
      return Restangular.one('bill', bill_id).one('details').get();
    };

    /**
     * Abre modal de detalhamento do título
     * @param bill_id
     */
    vm.openDetailsModal = function (bill_id) {
      $rootScope.show_loader = true;
      vm.getDetails(bill_id)
        .then(function (response) {
          var details = response.plain();
          $rootScope.show_loader = false;
          ModalFactory.customClean('app/components/a4-bill-grid/a4-bill-grid-details.html',
            'A4BillGridDetailsController', 'vm', true, {'bill': details});
        })
        .catch(function (error) {
          Common.Toast.error(error.data.message);
        });
    };

    /**
     * Desfaz um pagamento parcial
     * @param obj
     * @returns {*}
     */
    vm.undoPartialPayment = function (obj) {
      return Restangular.one('bill').all('undopartialpayment').post(obj);
    };

    vm.editNotes = function (obj) {
      return Restangular.one('bill').all('editnotes').post(obj);
    };

    vm.editNotesMultiple = function (obj) {
      return Restangular.one('bill').all('editnotesmultiple').post(obj);
    };

    vm.getBillChargeStatus = function (obj) {
      return Restangular.one('bill').one('getallbillchargestatus').get(obj);
    };

    vm.editBillChargeStatus = function (obj) {
      return Restangular.one('bill').all('editbillchargestatus').post(obj);
    };

    vm.doSecond = function (obj) {
      return Restangular.one('bill').all('dosecond').post(obj);
    };

    vm.undoReprogrammedBill = function (obj) {
      return Restangular.one('bill').all('undoreprogrammedbill').post(obj);
    };

    vm.getNegotiationInfo = function (obj) {
      return Restangular.one('bill').one('getnegotiationinfo').get(obj);
    };

    vm.generateCredit = function (obj) {
      return Restangular.one('bill').all('generatecredit').post(obj);
    };

    return vm;

  }

  angular.module('app.a4-bill-grid')
    .service('BillGridService', BillGridService)
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4BillGridDetailsController($rootScope, BillGridService, Common, ModalFactory, ModalExtra,
                                       CashierSessionService, BillNegotiateService, BillReverseService, a4Moment) {
    var vm = this;
    vm.bill = ModalExtra.bill;

    vm.init = function () {
      vm.discount_list = angular.fromJson(vm.bill.discount_list);
      if (vm.discount_list !== null) {
        vm.discount_list.forEach(function (item) {
          if (item.discount_date !== null && vm.bill.settlement_date !== null && vm.bill.partial_payment_msg !== null
            && a4Moment(item.discount_date).diff(a4Moment(), 'days') < 0 && vm.bill.due_date_reschedule === null) {
            item.is_lost = true;
          } else if (item.discount_date !== null && vm.bill.settlement_date === null && vm.bill.status === 1
            && a4Moment(item.discount_date).diff(a4Moment(), 'days') < 0 && vm.bill.due_date_reschedule === null) {
            item.is_lost = true;
          } else if (item.discount_date !== null && (vm.bill.status === 10 || vm.bill.status === 4)
            && a4Moment(item.discount_date).diff(a4Moment(vm.bill.settlement_date), 'days') < 0 && vm.bill.due_date_reschedule === null) {
            item.is_lost = true;
          } else {
            item.is_lost = false;
          }
        });
      }
      if (angular.isDefined(vm.bill.details.partial_paid)) {
        for (var i = 0; i < vm.bill.details.partial_paid.length; i++) {
          if (i === 0) {
            vm.bill.details.partial_paid[i].canUndoPayment = true;
          } else {
            vm.bill.details.partial_paid[i].canUndoPayment = false;
          }
        }
      }
      vm.bill.calc_discount = vm.bill.status === 10 ?
        parseFloat(vm.bill.discount_cond_value) + parseFloat(vm.bill.discount_prom_value) :
        parseFloat(vm.bill.calc_discount_cond_value) + parseFloat(vm.bill.calc_discount_prom_value);
    };


    /**
     * Imprime recibo de pagamento do título
     * @param bill_action_id
     */
    vm.printReceipt = function (bill_action_id) {
      CashierSessionService.printGuestCheckPadReport(bill_action_id, false);
    };

    /**
     * retorna o valor total de pagamento
     */
    vm.getAmountPaidTotal = function () {
      var total = 0;
      vm.bill.details.partial_paid.forEach(function (item) {
        total += parseFloat(item.amount_paid);
      });
      vm.bill.details.residual_paid.forEach(function (item) {
        total += parseFloat(item.amount_paid);
      });
      return total;
    };


    /**
     * Desfaz um pagamento parcial
     * @param item
     */
    vm.undoPartialPayment = function (item) {
      ModalFactory.confirm(
        null,
        'Desfazer pagamento parcial',
        'Você está desfazendo o pagamento parcial de valor R$' + item.amount_paid +
        '.\n Deseja desfazer este título de pagamento parcial?',
        'Confirmar',
        'Cancelar',
        'finance'
      ).then(function (response) {
        if (response) {
          BillGridService.undoPartialPayment(item).then(function () {
            vm.close();
          })
        }
      }).catch(function () {
        BillGridService.openDetailsModal(vm.bill.id);
      });
    };

    /**
     * Abre o modal com o detalhamento da negociação
     */
    vm.showNegotiationDetails = function () {
      $rootScope.show_loader = true;
      vm.close();
      BillNegotiateService.getExpensesNegociation({bill_id: vm.bill.id})
        .then(function (response) {
          $rootScope.show_loader = false;
          ModalFactory.customClean('app/components/a4-bill-grid/a4-bill-grid-negotiation-details.html',
            /**@ngInject*/
            function ($mdDialog, ModalExtra, BillGridService) {
              var vm = this;
              vm.negotiation = ModalExtra.negotiation;
              vm.close = function () {
                $mdDialog.cancel();
                BillGridService.openDetailsModal(ModalExtra.bill_id);
              };
            }, 'vm', true, {'negotiation': response.plain(), 'bill_id': vm.bill.id});
        })
        .catch(function () {
          Common.Toast.error('Erro ao buscar os itens relacionados');
          BillGridService.openDetailsModal(ModalExtra.bill_id);
        });
    };

    /**
     * Abre o modal com o detalhamento do pagamento
     */
    vm.showPaymentDetails = function () {
      $rootScope.show_loader = true;
      vm.close();
      BillReverseService.getRelatedExpenses({bill_id: vm.bill.id, status: 10})
        .then(function (response) {
          $rootScope.show_loader = false;
          ModalFactory.customClean('app/components/a4-bill-grid/a4-bill-grid-payment-details.html',
            /**@ngInject*/
            function ($mdDialog, ModalExtra, BillGridService) {
              var vm = this;
              vm.payment = ModalExtra.payment;
              vm.amount_paid = ModalExtra.amount_paid;
              vm.settlement_date = ModalExtra.settlement_date;
              vm.is_paid_by_bank_file_received = ModalExtra.is_paid_by_bank_file_received;
              vm.close = function () {
                $mdDialog.cancel();
                BillGridService.openDetailsModal(ModalExtra.bill_id);
              };
            }, 'vm', true, {
              'payment': response.plain(),
              'bill_id': vm.bill.id,
              'is_paid_by_bank_file_received': vm.bill.is_paid_by_bank_file_received,
              'amount_paid': vm.bill.amount_paid,
              'settlement_date': vm.bill.settlement_date
            });
        })
        .catch(function () {
          $rootScope.show_loader = true;
          Common.Toast.error('Erro ao buscar os itens relacionados');
          BillGridService.openDetailsModal(ModalExtra.bill_id);
        });
    };

    /**
     * Fecha o modal
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();


  }

  angular.module('app.a4-bill-grid')
    .controller('A4BillGridDetailsController', A4BillGridDetailsController);
})();
(function () {
  'use strict';

  angular.module('app.a4-bank-slip', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function A4BankSlipService($document, $http, CONFIG, Common, a4Moment, Restangular, ModalFactory, Utils) {
    var vm = this;
    vm.subdomain = $document[0].domain.split('.')[0];

    /**
     * Segunda via de boleto
     */
    vm.doSecond = function (obj) {
      var deffered = Common.$q.defer();
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/bankslip/second',
        data: obj,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];

        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          var filename = 'boletos' + a4Moment().format('DD/MM/YYYY') + '.pdf';
          linkElement.setAttribute("download", filename);

          var clickEvent = new MouseEvent("click", {"view": window, "bubbles": true, "cancelable": true});
          linkElement.dispatchEvent(clickEvent);
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }, function (error) {

      });

      return deffered.promise;
    };

    /**
     * Cancela um boleto
     * @param obj
     * @returns {*}
     */
    vm.cancelBankSlip = function (obj) {
      return Restangular.one('bankslip').all('cancel').post(obj);
    };

    /**
     * Retorna detalhes de um boleto, seus títulos associados e ações de arquivo retorno
     * @param id
     * @returns {*}
     */
    vm.getDetailsByBankSlipId = function (id) {
      return Restangular.one('bankslip').one('getdetailsbybankslipid', id).get();
    };

    vm.doRefund = function (obj) {
      return Restangular.one('bankslip').all('refund').post(obj);
    };

    /**
     * Registra boleto no A4 PAg
     * @param option
     * @param due_date
     * @param bill_ids
     * @param bank_slip_id
     * @returns {*}
     */
    vm.getBankSlipA4Pag = function (option, due_date, bill_ids, bank_slip_id, person_id) {
      var deffered = Common.$q.defer();
      var new_due_date = null;
      if (bank_slip_id === null && a4Moment(due_date).diff(a4Moment(), 'days') < 0) {
        new_due_date = a4Moment().format('YYYY-MM-DD');
      }
      $http({
        method: 'POST',
        url: CONFIG.webApiUri + 'api/bankslip/getbankslip',
        data: {
          bill_ids: bill_ids, bank_slip_id: bank_slip_id, option: option,
          new_due_date: new_due_date,person_id: angular.isUndefined(person_id) ? null : person_id
        },
        responseType: 'arraybuffer'
      }).then(function (response) {
        var headers = response.headers();
        var status = response.status;
        var data = response.data;

        var contentType = headers['content-type'];
        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([data], {type: contentType});

          if (option === 'barcode_number' || option === 'qrcode') {
            var reader = new FileReader();
            reader.addEventListener('loadend', function (e) {
              var text = angular.fromJson(e.srcElement.result);

              if (option === 'qrcode') {

                Utils.copyToClipboard(text.qrcode_emv);
                ModalFactory.alert(
                  "Pix copia e cola", text.qrcode_emv,
                  "modal", "Ok", "false", "educational"
                );
                Common.Toast.success('PIX copia e cola copiado para a área de transferência.')

              } else {

                Utils.copyToClipboard(text.barcode);
                ModalFactory.alert(
                  "Linha digitável", text.barcode,
                  "modal", "Ok", "false", "educational"
                );
                Common.Toast.success('Linha digitável copiada para a área de transferência.')

              }

            });
            reader.readAsText(blob);

          } else {
            var url = window.URL.createObjectURL(blob);
            linkElement.setAttribute('href', url);
            linkElement.setAttribute('target', '_blank');
            var clickEvent = new MouseEvent("click", {
              "view": window, "bubbles": true, "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          }
          deffered.resolve(true);
        } catch (ex) {
          deffered.reject(ex);
        }
      }).catch(function (response) {
        var decoder = new TextDecoder("utf-8");
        var domString = decoder.decode(response.data);
        var json = angular.fromJson(domString);
        deffered.reject(json);
      });
      return deffered.promise;
    };
    return vm;
  }

  angular.module('app.a4-bank-slip')
    .factory('A4BankSlipService', A4BankSlipService);

})();

(function () {
  'use strict';

  /** @ngInject */
  function a4BankSlipDirective() {
    return {
      restrict: 'E',
      scope: {
        personId: '=?',
        status: '=?',
        currentAccountFilter: '=?',
        canEdit: '=?'
      },
      templateUrl: 'app/components/a4-bank-slip/index.html',
      controller: 'A4BankSlipController',
      controllerAs: 'vm',
      link: function (scope, elem, attrs, ctrl) {
        var BANK_SLIP_STATUS_WAITING_FILE_SEND = 0;
        var BANK_SLIP_STATUS_TO_REGISTER = 1;
        var BANK_SLIP_STATUS_SENT = 2;
        var BANK_SLIP_STATUS_REGISTERED = 3;
        var BANK_SLIP_STATUS_DONE = 5;
        var BANK_SLIP_STATUS_PAID = 6;
        scope.currentAccountFilter = angular.isDefined(scope.currentAccountFilter);
        scope.canEdit = angular.isUndefined(scope.canEdit) ? true : scope.canEdit;
        ctrl.personId = scope.personId;
        var bank_slip_status = [BANK_SLIP_STATUS_WAITING_FILE_SEND, BANK_SLIP_STATUS_TO_REGISTER, BANK_SLIP_STATUS_SENT,
          BANK_SLIP_STATUS_REGISTERED, BANK_SLIP_STATUS_DONE, BANK_SLIP_STATUS_PAID];
        ctrl.getAllBankSlipPaginate(1, 15, angular.isUndefined(scope.status) ? bank_slip_status : scope.status);
      }
    }
  }

  angular.module('app.a4-bank-slip')
    .directive('a4BankSlip', a4BankSlipDirective);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BankSlipController($document, $rootScope, a4Moment, BankFileSendService, ModalFactory, CONFIG, Session,
                                Utils, PoliciesService, A4BankSlipService, Common, $scope) {
    var vm = this;
    /** Constantes de status do boleto */
    vm.BANK_SLIP_STATUS_NOT_GENERATED = -1;
    vm.BANK_SLIP_STATUS_WAITING_FILE_SEND = 0;
    vm.BANK_SLIP_STATUS_TO_REGISTER = 1;
    vm.BANK_SLIP_STATUS_SENT = 2;
    vm.BANK_SLIP_STATUS_REGISTERED = 3;
    vm.BANK_SLIP_STATUS_DONE = 5;
    vm.BANK_SLIP_STATUS_PAID = 6;
    vm.RESPONSIBLE = 2;
    vm.is_labs = ($document[0].domain.split('.')[0] === 'labs');
    vm.current_profile = Session.getCurrentProfile();

    vm.NOT_CANCELED = 0;
    vm.CANCELED_PENDING_SEND_FILE = 1;
    vm.CANCELED_NOT_PENDING_SEND_FILE = 2;
    vm.CANCELED_REFUND = 3;

    vm.webLink = CONFIG.webApiUri + 'api/bankslip/generate/print';
    vm.webLink_register = CONFIG.webApiUri + 'api/bankslip/register';
    vm.subdomain = $document[0].domain.split('.')[0];

    vm.status = [vm.BANK_SLIP_STATUS_WAITING_FILE_SEND,
      vm.BANK_SLIP_STATUS_TO_REGISTER,
      vm.BANK_SLIP_STATUS_SENT, vm.BANK_SLIP_STATUS_REGISTERED, vm.BANK_SLIP_STATUS_DONE, vm.BANK_SLIP_STATUS_PAID];

    if (vm.current_profile !== vm.RESPONSIBLE) {
      vm.filter_date = {
        startDate: a4Moment().startOf('year').format('YYYY-MM-DD'),
        endDate: a4Moment().endOf('year').format('YYYY-MM-DD')
      };
    }

    var on = $rootScope.$on('UPDATE_BANK_SLIP_LIST', function () {
      vm.getAllBankSlipPaginate(1, 25, vm.status, vm.filter_date);
    });

    vm.init = function () {
      vm.labs_user = Session.getLabsUser();
    };

    /**
     * Formata a string de beneficiarios do boleto
     * @param beneficiaries
     */
    vm.formatBeneficiaries = function (beneficiaries) {
      return angular.fromJson(beneficiaries.replace('{', '[').replace('}', ']'));
    };

    /**
     * Formata a string de beneficiarios do boleto
     * @param services
     */
    vm.formatServices = function (services) {
      return angular.fromJson(services.replace('{', '[').replace('}', ']'));
    };

    /**
     * Formata string com aspas duplas
     * @param name
     * @returns {*}
     */
    vm.formatName = function (name) {
      return Utils.removeDoubleQuotes(name);
    };

    /**
     * Segunda via de boleto
     */
    vm.newBankSlip = function (bank_slip_id, amount, due_date, fine_max_value, interest_day_value) {
      var is_expired = a4Moment(due_date).diff(a4Moment(), 'days');
      ModalFactory.customClean(
        'app/components/a4-bank-slip/bank_slip_second_way.html',
        'a4BankSlipSecondController',
        'vm',
        false,
        {
          bank_slip_id: bank_slip_id,
          is_expired: is_expired < 0,
          amount: amount,
          due_date: due_date,
          fine_max_value: fine_max_value,
          interest_day_value: interest_day_value
        }
      ).then(function () {
        vm.getAllBankSlipPaginate(1, 25, vm.status, vm.filter_date);
      });
    };

    /**
     * Cancela um boleto
     */
    vm.confirmCancelBankSlip = function (bank_slip) {
      $rootScope.show_loader = true;
      var password = '';
      ModalFactory.open('require_password', null, null, {
          password: password,
          bank_slip_id: bank_slip.bank_slip_id
        }, null, 'finance', vm.cancelBankSlip, 'Cancelamento de boleto',
        'Ao cancelar este boleto será necessário gerar um novo a partir do menu de boletos. ' +
        'Para realizar o cancelamento do boleto com data de vencimento ' + a4Moment(bank_slip.due_date).format('DD/MM/YYYY')
        + ' e valor R$' + bank_slip.amount + ', confirme sua senha')
        .then(function () {
          Common.Toast.success('Boleto cancelado com sucesso');
          vm.getAllBankSlipPaginate(1, 25, vm.status, vm.filter_date);
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.cancelBankSlip = function (data) {
      return A4BankSlipService.cancelBankSlip(data);
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };


    /**
     * Retorna a paginação de titulos
     */
    vm.getAllBankSlipPaginate = function (page, qty, status, date) {
      $rootScope.show_loader = true;
      page = (angular.isUndefined(page) || page === null) ? 1 : page;
      qty = (angular.isUndefined(qty) || qty === null) ? 25 : qty;
      status = angular.isUndefined(status) ? vm.status : status;
      date = (angular.isUndefined(date) || date === null) ? vm.filter_date : date;
      var person_id = angular.isDefined(vm.personId) ? vm.personId : null;

      if (vm.current_profile === vm.RESPONSIBLE) {
        status = [vm.BANK_SLIP_STATUS_REGISTERED, vm.BANK_SLIP_STATUS_PAID].join();
      } else {
        status = status.join();
      }

      vm.promise = BankFileSendService.getAllBankSlipPaginate({
        initialDate: angular.isUndefined(date) ? null : date.startDate,
        endDate: angular.isUndefined(date) ? null : date.endDate,
        status: status, page: page, qtd: qty,
        service_group: vm.service_group,
        service: vm.service,
        person_id: person_id
      }).then(function (response) {
        vm.bank_slip_paginate = response.plain();
        $rootScope.show_loader = false;
      })
    };

    /**
     * Registra boleto no A4 PAg
     * @param option - se é para gerar pdf ou linha digitável
     * @param due_date
     * @param bill_ids
     * @param bank_slip_id
     * @returns {*}
     */
    vm.getBankSlipA4Pag = function (option, due_date, bill_ids, bank_slip_id) {
      $rootScope.show_loader = true;
      A4BankSlipService.getBankSlipA4Pag(option, due_date, bill_ids, bank_slip_id)
        .then(function () {
          $rootScope.show_loader = false;
          vm.getAllBankSlipPaginate(1, 25, vm.status, vm.filter_date);
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.message);
        })
    };

    /**
     * Retorna detalhes de um boleto, seus títulos associados e ações de arquivo retorno
     * @param bank_slip
     */
    vm.getDetailsByBankSlipId = function (bank_slip) {
      $rootScope.show_loader = true;
      A4BankSlipService.getDetailsByBankSlipId(bank_slip.bank_slip_id)
        .then(function (resp) {
          $rootScope.show_loader = false;
          ModalFactory.customClean('app/components/a4-bank-slip/a4-bank-slip-details.html',
            'A4BankSlipDetailsController', 'vm', true, {'bills': resp.bills, 'bank_slip_id': bank_slip.bank_slip_id});
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.warning(error.message);
        })
    };

    $scope.$on('$destroy', function () {
      [on].forEach(function (fn) {
        fn();
      });
    });

    vm.init();
  }

  angular.module('app.a4-bank-slip')
    .controller('A4BankSlipController', a4BankSlipController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BankSlipSecondController($rootScope, a4Moment, A4BankSlipService, BillGridService, Common, ModalExtra) {
    var vm = this;
    vm.show_loader = false;
    vm.is_bill = false;
    vm.bank_slip = {
      bank_slip_id: ModalExtra.bank_slip_id,
      amount: null,
      due_date: ModalExtra.due_date,
      is_expired: ModalExtra.is_expired,
      second_due_date: a4Moment().format('YYYY-MM-DD'),
      operation: 1,
      fine_max_value: parseFloat(ModalExtra.fine_max_value),
      interest_day_value: parseFloat(ModalExtra.interest_day_value),
      is_conditional_reschedule: true
    };

    vm.init = function () {
      vm.limit_date = a4Moment().format('YYYY-MM-DD');
      vm.days_fine = parseInt(a4Moment(vm.bank_slip.second_due_date).diff(vm.bank_slip.due_date, 'days'));
      vm.final_value = (vm.bank_slip.amount + (vm.bank_slip.fine_max_value + (vm.bank_slip.interest_day_value * vm.days_fine)));
      if (angular.isDefined(ModalExtra.bill_serie_id)) {
        vm.is_bill = true;
        vm.bank_slip.bill_id = ModalExtra.id;
        vm.bank_slip.old_amount = angular.copy(ModalExtra.final_value);
      }
    };

    /**
     * Fecha Modal;
     */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    /**
     * Faz a verificação de data de vencimento, não é possível colocar uma nova data de vencimento anterior a hoje;
     * @param date
     */
    vm.changeDueDate = function (date) {
      var new_date = a4Moment(date);
      var valid_date = a4Moment();
      if (new_date.isSame(valid_date) || new_date.isAfter(valid_date)) {
        vm.bank_slip.second_due_date = new_date.format('YYYY-MM-DD');
      } else {
        vm.bank_slip.second_due_date = a4Moment().format('YYYY-MM-DD');
      }
      vm.days_fine = parseInt(a4Moment(vm.bank_slip.second_due_date).diff(vm.bank_slip.due_date, 'days'));
      vm.final_value = (vm.bank_slip.amount + (vm.bank_slip.fine_max_value + (vm.bank_slip.interest_day_value * vm.days_fine)));
    };

    /**
     * Chama o serviço de criação de segunda via
     */
    vm.doSecondBankSlip = function () {
      vm.show_loader = true;
      if (!vm.is_bill) {
        A4BankSlipService.doSecond(vm.bank_slip)
          .then(function () {
            vm.show_loader = false;
            vm.close();
            Common.Toast.success('Segunda via gerada com sucesso.');
          })
          .catch(function (error) {
            vm.show_loader = false;
            if (error.message.contains('bank_slip_partial_unique')) {
              Common.Toast.error("Já existe um boleto para este título/conjunto de títulos.");
            } else {
              Common.Toast.error(error.message || error.data.message);
            }
          });
      } else {
        BillGridService.doSecond(vm.bank_slip)
          .then(function () {
            vm.show_loader = false;
            vm.close();
            Common.Toast.success('Reprogramação realizada com sucesso.');
          })
      }
    };


    vm.init();

  }

  angular.module('app.a4-bank-slip')
    .controller('a4BankSlipSecondController', a4BankSlipSecondController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4BankSlipDetailsController($document, $rootScope, a4Moment, BankFileSendService, ModalExtra, CONFIG, Session,
                                       Utils, PoliciesService, BankSlipService, $filter, BillPaymentService, ModalFactory,
                                       Common, A4BankSlipService) {
    var vm = this;
    /** Constantes de status do boleto */
    vm.BANK_SLIP_STATUS_NOT_GENERATED = -1;
    vm.BANK_SLIP_STATUS_WAITING_FILE_SEND = 0;
    vm.BANK_SLIP_STATUS_TO_REGISTER = 1;
    vm.BANK_SLIP_STATUS_SENT = 2;
    vm.BANK_SLIP_STATUS_REGISTERED = 3;
    vm.BANK_SLIP_STATUS_DONE = 5;
    vm.BANK_SLIP_STATUS_PAID = 6;
    vm.current_profile = Session.getCurrentProfile();
    vm.current_account = null;
    vm.movement_type = null;
    vm.NOT_CANCELED = 0;
    vm.CANCELED_PENDING_SEND_FILE = 1;
    vm.CANCELED_NOT_PENDING_SEND_FILE = 2;

    vm.status = [vm.BANK_SLIP_STATUS_WAITING_FILE_SEND,
      vm.BANK_SLIP_STATUS_TO_REGISTER,
      vm.BANK_SLIP_STATUS_SENT, vm.BANK_SLIP_STATUS_REGISTERED, vm.BANK_SLIP_STATUS_DONE, vm.BANK_SLIP_STATUS_PAID];

    vm.init = function () {
      vm.bills = ModalExtra.bills;
      vm.bank_slip_id = ModalExtra.bank_slip_id;
      vm.labs_user = Session.getLabsUser();
      vm.getAllCurrentAccount();
      vm.getAllMovementsType();
    };

    /**
     * Retorna todas as contas
     */
    vm.getAllCurrentAccount = function () {
      vm.current_accounts = [];
      BankSlipService.getAllCurrentAccounts()
        .then(function (response) {
          var current_accounts = response.plain();
          vm.all_current_accounts = $filter('filter')(current_accounts, {is_inactive: false});
        });
    };

    /**
     * Carrega todos os tipos de movimentos
     */
    vm.getAllMovementsType = function () {
      BillPaymentService
        .getAllMovementsType()
        .then(function (response) {
          if (response.plain() !== null) {
            vm.movementTypes = response;
            vm.movementTypes = vm.movementTypes.filter(function (item) {
              return item.id < 100 && item.id > 0 && item.id !== 98;
            });
          }
        });
    };

    vm.confirm = function () {
      ModalFactory.open('require_password', null, null, {
          current_account_id: vm.current_account,
          movement_type_id: vm.movement_type,
          bank_slip_id: vm.bank_slip_id
        }, null, 'finance', vm.execute,
        'Confirmação de reembolso de boleto', 'Confirme sua senha para prosseguir', null)
        .then(function () {
          $rootScope.$broadcast('UPDATE_BANK_SLIP_LIST');
          Common.Toast.success('Reembolso executado com sucesso');
        });
    };

    vm.execute = function (data) {
      return A4BankSlipService.doRefund(data);
    };

    /**
     * retorna o valor total dos títulos
     */
    vm.getAmountTotal = function () {
      var total = 0;
      vm.bills.forEach(function (item) {
        total += parseFloat(item.amount);
      });
      return total;
    };

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    vm.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    vm.init();
  }

  angular.module('app.a4-bank-slip')
    .controller('A4BankSlipDetailsController', a4BankSlipDetailsController);

})();
(function () {
  'use strict';

  /** @ngInject */
  function DateRangeTranslate($translateProvider) {

    $translateProvider.translations('pt', {});

  }

  angular
    .module('app.date-picker')
    .config(DateRangeTranslate);
})();

(function () {
  'use strict';

  angular
    .module('app.a4-autocomplete', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4Autocomplete($rootScope, a4Moment) {

    return {
      restrict: 'E',
      templateUrl: 'app/components/a4-autocomplete/autocomplete.html',
      required: '[^ngModel]',
      scope: {
        selectedItem: '=ngModel',
        label: '@',
        inputId: '@',
        searchFunction: '&',
        selectedItemChange: '&',
        searchText: '=',
        itemText: '@',
        showLoader: '=?',
        disabled: '=ngDisabled',
        ngChange: '&?',
        required: '=ngRequired'
      },
      controller: 'A4AutocompleteController',
      controllerAs: 'vm',
      link: function ($scope, element) {
        $scope.format = 'YYYY-MM-DD';
        $scope.options = {
          'minDate': $scope.minDate,
          'maxDate': $scope.maxDate
        };

        $scope.withoutIcon = $scope.withoutIcon === 'true';

        element.on('apply.daterangepicker', function (ev, picker) {
          if (angular.isDefined($scope.ngChange)) {
            $scope.ngChange({date: picker.endDate.format('YYYY-MM-DD')});
          }
        });

        if (angular.isUndefined($scope.value) || $scope.value === null) {
          $scope.value = '';
        }

        $scope.updateDate = function () {
          $scope.value = a4Moment($scope.date).format($scope.format);
          $rootScope.$broadcast('DATERANGEPICKER.change', $scope.value);
        };

        $scope.changeOnDatePicker = function (newer) {
          if (angular.isDefined($scope.ngChange)) {
            $scope.ngChange({date: newer});
          }
          if (angular.isUndefined($scope.value) || $scope.value === '') {
            $scope.value = a4Moment(null);
          } else {
            $scope.value = newer.endDate;
          }
          $scope.change = newer;
          $rootScope.$broadcast('DATEPICKER.change', $scope.value);
        };
      }
    }
  }

  angular
    .module('app.a4-autocomplete')
    .directive('a4Autocomplete', a4Autocomplete);
})();

(function () {
  'use strict';

  /** @ngInject */
  function A4AutocompleteController($scope) {
    var vm = this;

    vm.internSearch = function (text) {
      return $scope.searchFunction({
        text: text
      });
    };
    vm.internSelectedItemChange = function (item) {
      return $scope.selectedItemChange({
        item: item
      });
    };
  }

  angular.module('app.a4-autocomplete')
    .controller('A4AutocompleteController', A4AutocompleteController)
})();
(function () {
  'use strict';

  /** @ngInject*/
  function dateRange($mdDateLocaleProvider, moment) {
    $mdDateLocaleProvider.formatDate = function (date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    };

    $mdDateLocaleProvider.parseDate = function (dateString) {
      var m = moment(dateString, 'DD/MM/YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };
  }

  angular
    .module('app.date-picker')
    .config(dateRange);

})();
(function () {
  'use strict';

  angular.module('app.a4-app-log', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4AppLogDirective() {
    return {
      restrict: 'E',
      scope: {
        personId: '=',
        timeline: '=ngModel',
        timelineFunction: '&'
      },
      controller: 'A4AppLogController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-app-log/index.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4-app-log')
    .directive('a4AppLog', A4AppLogDirective);
})();
(function () {
  'use strict';

  /** @ngInject */
  function A4AppLogController($document, $q, $scope, ModalFactory) {
    var vm = this;
    vm.current_connection = $document[0].domain.split('.')[0];

    vm.item_module_app =
      {
        1: 'badgeFin',
        2: 'badgeGeneral',
        51: 'badgeEdu',
        148: 'badgeCRM'
      };

    vm.loadNextPage = function () {
      var deferred = $q.defer();
      deferred.resolve();
    };

    vm.editLog = function (item) {
      if (vm.current_connection === 'labs' || vm.current_connection === 'a4simetria' || vm.current_connection === 'a4tecnologia') {
        ModalFactory.customClean(
          'app/controlpanel/app-log/views/form.html',
          'AppLogCreateEditController',
          'vm', false, item
        ).then(function () {
          $scope.timelineFunction({limit: 4});
        });
      }
    };

    /**
     * Retorna classe CSS e título do badge baseado no tipo do log
     * @param type
     */
    vm.defineTypeBadge = function (type) {
      var badge = {};
      switch (type) {
        case 1:
          badge.cssClass = 'badgeNew';
          badge.title = 'Novo';
          break;
        case 2:
          badge.cssClass = 'badgeImprovement';
          badge.title = 'Melhoria';
          break;
        case 3:
          badge.cssClass = 'badgeAdjustment';
          badge.title = 'Correção';
          break;
        case 4:
          badge.cssClass = 'badgeSmallAdjustment';
          badge.title = 'Correção menor';
          break;
      }
      return badge;

    }


  }

  angular.module('app.a4-app-log')
    .controller('A4AppLogController', A4AppLogController);
})();
(function () {
  'use strict';

  angular.module('app.a4address', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4Address() {
    return {
      restrict: 'E',
      scope: {
        model: '=?',
        isEnabled: '=?',
        hasOwner: '=?',
        formCopy: '=?',
        showPhone: '=?',
        formScope: '=?'
      },
      controller: 'a4AddressController',
      controllerAs: 'vm',
      templateUrl: 'app/components/a4-address/a4-address.html',
      link: function () {
      }
    }
  }

  angular.module('app.a4address')
    .directive('a4Address', a4Address);
})();
(function () {
  'use strict';

  /** @ngInject */
  function a4AddressController($scope, $rootScope, StudentsService, $q, $timeout, $window,
                               EducationalService, SysTableColumn, $document,
                               Common, PersonService) {
    var vm = this;
    vm.list = {};
    vm.cep_error = false;
    vm.is_postcode_required = true;
    vm.states = [];
    vm.cities = [];
    vm.searchText = null;
    vm.isListVisible = false;
    vm.filteredCities = [],
    vm.selectedCity = '',


    $scope.$watch('isEnabled', function (newValue) {
      if(newValue === true) {
        $scope.$watch('model.address_state', function (address_state) {
          if (angular.isDefined(address_state)) {
            vm.changeState(address_state);
          }
        });
      }
    })

    // Filtra as cidades e atualiza a lista de sugestões
    vm.filterCities = function(item) {
      vm.filteredCities = vm.cities.filter(function(city) {
        return city.name.toLowerCase().startsWith(item.toLowerCase());
      });

      vm.isListVisible = true;
    },

    // Quando o usuário clica em uma cidade da lista, a atribuia como valor
    vm.selectCity = function(city) {
      console.log(city)
      $scope.model.address_city = city.name;
      vm.searchText = city.name;
      vm.filteredCities = [];

      vm.isListVisible = false;
    }

    // Função para impedir a propagação do evento para que o clique dentro da lista não feche a lista
    $scope.stopPropagation = function(event) {
      event.stopPropagation();
    };

    // Ouvir cliques fora da md-list para fechar a lista
    $document.on('click', function(event) {
      var listElement = document.querySelector('md-list');
      if (listElement && !listElement.contains(event.target)) {
        $scope.$apply(function() {
          vm.isListVisible = false;
        });
      }
    });


    /**
     * Escuta o evento blur do input de CEP
     * @type {*}
     */
    vm.getAddressByCep = function (CEP) {
      vm.cep_error = false;
      vm.waiting_cep = true;
      PersonService.getAddressByCep(CEP)
        .then(function (address) {
          vm.waiting_cep = false;
          if (angular.isDefined(address) && angular.isObject(address) && angular.isDefined(address.uf)) {
            if (angular.isDefined(address.erro) && address.erro) {
              Common.Toast.error(address.erro);
              return;
            }
            $scope.model.address_postal_code = address.cep;
            $scope.model.address_state = address.uf;
            vm.searchText_address_state = address.uf;
            $scope.model.address_city = address.localidade;
            vm.searchText_address_city = address.localidade;
            $scope.model.address_street = address.logradouro;
            $scope.model.address_district = address.bairro;
            /*vm.changeAddressState(address.uf, address.localidade);*/
            angular.element('#number').focus();
            $scope.$applyAsync();
          } else {
            /*vm.cep_error = true;*/
            if (angular.isDefined($scope.model.address_state) && $scope.model.address_state !== null) {
              /*vm.changeAddressState($scope.model.address_state);*/
            }
          }
        });
    };

    vm.getStatesAndCities = function () {
      PersonService.getStatesAndCities().then(function (response) {
        var data = response.plain();
        vm.states = data.states;
        vm.cities = data.cities;
        if ($scope.model.address_state !== null) {
          vm.cities = vm.cities.filter(function (item) {
            return item.state_id === $scope.model.address_state;
          })
        };
      })
    };

    vm.handleCitySelection = function(item) {
      console.log(item)
      if (!item) {
        $scope.model.address_city = vm.searchText;
      }
    };

    vm.handleCityBlur = function(item) {
      console.log(item)
     if (typeof item === 'object' || typeof item === 'string') {
        if (!item) {
          $scope.model.address_city = vm.searchText;
        }
      }
    };

    vm.changeState = function (state) {
      PersonService.getCities(state)
        .then(function (response) {
          vm.cities = response.plain();
        })
    };
    vm.options = {matcher: vm.ignoreAccents};
    vm.removeAccents = function (value) {
      return value
        .replace(/á/g, 'a')
        .replace(/é/g, 'e')
        .replace(/í/g, 'i')
        .replace(/ó/g, 'o')
        .replace(/ú/g, 'u');
    };

    vm.ignoreAccents = function (item) {
      // if (!$scope.search) return true;
      // return;
      var text = vm.removeAccents(item.toLowerCase());
      var search = vm.removeAccents($scope.search.toLowerCase());
      return text.indexOf(search) > -1;
    };

    /**
     * Busca de estado de nascimento
     * @param filterText
     * @returns {*}
     */
    vm.getStateBirth = function (filterText) {
      return PersonService.getStatesByQuery({query: filterText});
    };

    /**
     * Busca de cidade do endereço
     * @param filterText
     * @returns {*}
     */
    vm.getAddressCity = function (filterText) {
      return PersonService.getCitiesByQuery({query: filterText});
    };

    /**
     * Define a cidade do endereço
     * @param item
     */
    vm.setAddressCity = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.name)) {
        $scope.model.address_city = item.name;
      }
    };
    /**
     * Define a cidade do endereço
     * @param item
     */
    vm.setAddressState = function (item) {
      if (angular.isDefined(item) && angular.isDefined(item.id)) {
        $scope.model.address_state = item.id;
      }
    };

    vm.init = function () {
      $timeout(function () {
        //vm.getStatesAndCities();
        if (angular.isDefined($scope.formScope) && $scope.formScope !== '') {
          switch ($scope.formScope) {
            case 'EMPLOYEE':
              vm.required_fields_employee = SysTableColumn.getColumnsByScope('EMPLOYEE');
              break;
            case 'RESPONSIBLE':
              vm.required_fields_responsible = SysTableColumn.getColumnsByScope('RESPONSIBLE');
              vm.required_fields_payee = SysTableColumn.getColumnsByScope('PAYEE');
              break;
            case 'STUDENT':
              vm.required_fields_student = SysTableColumn.getColumnsByScope('STUDENT');
              break;
          }
        }
        $scope.$applyAsync();
      }, 3500);
    };

    $scope.$watch('isEnabled', function (newValue) {
      if (newValue === true) {
        EducationalService.hasPostCodeRequired().then(function (response) {
          var obj = response.plain();
          vm.is_postcode_required = obj.is_postcode_required;
        });

        vm.getStatesAndCities();
      } else {
        if (!vm.states || vm.states.length === 0) {
          vm.states = [{ id: $scope.model.address_state || '', name: $scope.model.state_name || 'Selecione um estado' }];
        }

        if (!vm.cities || vm.cities.length === 0) {
          vm.cities = [{ name: $scope.model.address_city || '', name_src: $scope.model.address_city || 'Selecione uma cidade' }];
        }
      }
    })

    vm.init();
  }

  angular.module('app.a4address')
    .controller('a4AddressController', a4AddressController);
})();

(function () {
  'use strict';

  angular
    .module('app.a4-accounts-grid', []);

})();
(function () {
  'use strict';

  /** @ngInject */
  function a4AccountsGrid($filter) {

    /**
     * @param {array} items - Dados de listagem
     * @param {array} filter - Filtragem de colunas da lista;
     * @param {array} menuGroup - Agrupamento de menu para cada item;
     * @param {string} sidebarTemplate - url para template do sidebar;
     * @param {boolean} withLeftSideNav - default: false, Menu de agrupamento ao lado esquedo da lista;
     * @param {boolean} withListCheckBox - default: true, Define visibilidade do checkbox;
     * @param {function} onDelete - ao clicar no item excluir, o onDelete é rastreado para uma função fora do scopo;
     * @param {function} onSubmit;
     * @param {function} includeScope - Objeto de configuração da diretiva;
     * @returns {}
     */
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/a4-accounts-grid/templates/index.html',
      scope: {
        items: '=',
        filter: '=',
        menuGroup: '=',
        sidebarCreateEdit: '@',
        sidebarEntry: '@',
        sidebarTransference: '@',
        sidebarOutput: '@',
        withLeftSideNav: '=?',
        withListCheckBox: '=?',
        changeCurrentAccount: '&',
        onDelete: '&',
        onSubmit: '&',
        addCard: '&',
        editCard: '&',
        removeCard: '&',
        addConfigs: '&',
        removeConfigs: '&',
        checkStatus: '&',
        includeScope: '='
      },
      controller: 'a4AccountsGridController',
      controllerAs: 'vm',
      link: function (scope) {

        scope.current_line = null;

        scope.withLeftSideNav = !scope.withLeftSideNav ? false : scope.withLeftSideNav;
        scope.withListCheckBox = angular.isUndefined(scope.withListCheckBox) || scope.withListCheckBox ? true : scope.withListCheckBox;

        var data = [];

        scope.$watch('items', function () {
          data = scope.items;
        }, true);

        /**
         * change current line
         * @param idx
         */
        scope.changeCurrentLine = function (idx) {
          if (idx != null) {
            scope.current_line = idx;
            scope.changeCurrentAccount({idx: idx});
          }
        };

        /**
         * Dynamic content
         * Retorna os indices baseado no array 'data' e filtra esses valores pelo array 'filter'
         * @param index
         * @returns {Array}
         */
        scope.getKeys = function (index) {
          return $filter('dataFilter')(Object.keys(data[index]), scope.filter);
        };

        /**
         * applyMask
         * @param value
         * @param isNegative
         * @returns {string}
         */
        scope.applyMask = function (value, isNegative) {

          var currency = 0;
          if (value != null && value != undefined && value != '') {

            var currencyValue = null;

            if (value < 0) {

              //quando o saldo for menor que zero
              value = (-1 * value);
              currency = $filter('currency')(value, 'R$ ', 2);
              currencyValue = currency.replace(".", ",").replace(",", ".");
              currencyValue = "- " + currencyValue;

              return currencyValue;

            } else {

              currency = $filter('currency')(value, 'R$ ', 2);
              currencyValue = currency.replace(".", ",").replace(",", ".");

              if (isNegative) {
                currencyValue = "- " + currencyValue;
              }

              return currencyValue;
            }
          }
        };

      }
    }
  }

  angular
    .module('app.a4-accounts-grid')
    .directive('a4AccountsGrid', a4AccountsGrid)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4AccountsGridController($scope, $rootScope, $mdSidenav, msUtils, $mdDialog, $filter, $log,
                                    CurrentAccountService, a4Moment, $a4Sidenav) {

    var vm = this;

    vm.editable = true;
    vm.currentItem = {};
    vm.currentIdx = null;
    vm.items = [];
    vm.user = [];
    vm.filterIds = null;
    vm.listType = 'all';
    vm.listOrder = 'name';
    vm.listOrderAsc = false;
    vm.selectedItems = [];
    vm.bankColletions = [];
    vm.newGroupName = '';
    vm.sidebarTemplate = null;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;

    vm.init = function () {
      vm.getBanks();
    };

    $scope.$watch('items', function () {
      vm.items = $scope.items;
    }, true);

    /**
     * open sidenav
     */
    var listener = $rootScope.$on('a4.table.open.sidenav', function (evt, params) {
      if (params == null) {
        vm.openTableItem(null, null, 'sidenav-form');
      } else if (params.template === 'create-entry') {
        vm.openTableItem(null, params.index, 'sidenav-create-entry');
      } else if (params.template === 'create-output') {
        vm.openTableItem(null, params.index, 'sidenav-create-output');
      } else if (params.template === 'create-transference') {
        vm.openTableItem(null, null, 'sidenav-create-transf');
      }
    });

    /**
     * close sidenav
     */
    var listener2 = $rootScope.$on('a4.table.close.sidenav', function ($event, obj) {
      vm.closeTableItem(obj.template);
      vm.categorized = false;
      vm.currentItem = {};
    });

    /**
     * getBanks
     * Retorna lista de bancos
     * Retorna a lista de bancos
     */
    vm.getBanks = function () {
      CurrentAccountService.getBanks()
        .then(function (response) {
          vm.banks = response;
        });
    };

    /**
     * Change Items List Filter
     * @param type
     */
    vm.filterChange = function (type) {

      vm.listType = type;

      if (type === 'all') {
        vm.filterIds = null;
      }
      else if (angular.isObject(type)) {
        vm.filterIds = type.contactIds;
      }
      vm.selectedItems = [];

    };

    vm.closeTableItem = function (idAside) {
      $mdSidenav(idAside)
        .close()
        .then(function () {
          $log.debug('closed');
        });
    };

    /**
     * Open new item dialog
     * @param ev
     * @param index
     * @param idAside
     */
    vm.openTableItem = function (ev, index) {

      vm.currentItem.current_account = null;

      if (index != null && index != undefined) {
        var id = vm.items[index].id;
        vm.getAccountById(id);
      } else {
        vm.currentItem = {
          initial_balance_date: a4Moment()
        };
      }


      // if (idAside == 'sidenav-create-output' || idAside == 'sidenav-create-entry') {
      //   vm.currentItem.current_account = $scope.includeScope.selected_account;
      // }
      // $mdSidenav(idAside).toggle();
    };

    /**
     * getById
     * Retorna uma conta pelo id
     * @param id
     */
    vm.getAccountById = function (id) {
      CurrentAccountService.getById(id)
        .then(function (response) {
          vm.currentItem = response;
          vm.getBankColletionOptions();
          // instancia da classe Date para o datepicker
          vm.currentItem.initial_balance_date = a4Moment(vm.currentItem.initial_balance_date);
          $a4Sidenav().open(
            'app/finance/current-account/views/sidenavs/form.create.edit.html',
            'CurrentAccountCreateEditController',
            'vm',
            vm.currentItem
          );
        });
    };

    /**
     * Busca as carteiras a partir do identificador do banco;
     */
    vm.getBankColletionOptions = function () {
      if (vm.currentItem != null && vm.currentItem.bank != null) {
        var id = vm.currentItem.bank.id;
        CurrentAccountService.getBankColletionByBankId(id)
          .then(function (response) {
            if (response) {
              vm.bankColletions = response;
            }
          });
      }
    };


    /**
     * Delete Item Confirm Dialog
     */
    vm.deleteItemConfirm = function (ev, index) {
      var item = vm.items[index];
      var confirm = $mdDialog.confirm()
        .title('Deseja remover o item selecionado?')
        .htmlContent('<b>' + item.name + '</b>' + ' será removido.')
        .ariaLabel('delete item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCELAR');

      $mdDialog.show(confirm)
        .then(function () {

          vm.deleteItem(item);
          vm.selectedItems = [];

        });
    };

    /**
     * Delete Item
     */
    vm.deleteItem = function (item) {
      vm.items.splice(vm.items.indexOf(item), 1);
    };

    /**
     * Delete Selected Items
     */
    vm.deleteSelectedItems = function (ev) {

      var confirm = $mdDialog.confirm()
        .title('Tem certeza de que deseja excluir os items selecionados?')
        .htmlContent('<b>' + vm.selectedItems.length + ' selected</b>' + ' será deletado.')
        .ariaLabel('delete contacts')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        vm.selectedItems.forEach(function (contact) {
          vm.deleteItem(contact);
        });

        vm.selectedItems = [];

      });

    };

    /**
     * Toggle selected status of the item
     *
     * @param item
     * @param event
     */
    vm.toggleSelectItem = function (item, event) {

      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedItems.indexOf(item) > -1) {
        vm.selectedItems.splice(vm.selectedItems.indexOf(item), 1);
      }
      else {
        vm.selectedItems.push(item);
      }

    };

    /**
     * Deselect items
     */
    vm.deselectItems = function () {
      vm.selectedItems = [];
    };

    /**
     * Select all items
     */
    vm.selectAllItems = function () {
      vm.selectedItems = $scope.filteredContacts;
    };

    /**
     *
     */
    vm.addNewGroup = function () {
      if (vm.newGroupName === '') {
        return;
      }

      var newGroup = {
        'id': msUtils.guidGenerator(),
        'name': vm.newGroupName,
        'contactIds': []
      };

      vm.user.groups.push(newGroup);
      vm.newGroupName = '';
    };

    /**
     * Delete Group
     */
    // vm.deleteGroup = function (ev) {
    //   var item = vm.listType;
    //
    //   var confirm = $mdDialog.confirm()
    //     .title('Tem certeza de que deseja excluir o grupo?')
    //     .htmlContent('<b>' + group.name + '</b>' + ' será deletado.')
    //     .ariaLabel('delete item')
    //     .targetEvent(ev)
    //     .ok('OK')
    //     .cancel('CANCEL');
    //
    //   $mdDialog.show(confirm).then(function () {
    //
    //     vm.user.groups.splice(vm.user.groups.indexOf(item), 1);
    //     vm.filterChange('all');
    //
    //   });
    //
    // };

    /**
     * Toggle sidenav
     * @param sidenavId
     */
    vm.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();
      if ($scope.includeScope && ($scope.includeScope.item && $scope.includeScope.editable)) {
        $scope.includeScope.item = null;
        $scope.includeScope.editable = false;
      }
    };

    vm.getDays = function () {
      var arr = [];
      for (var i = 1; i <= 31; i++) {
        arr.push(i);
      }
      return arr;
    };

    /**
     * getTranslateValue
     * @param i
     * @param idx
     * @returns {string}
     */
    vm.getTranslateValue = function (i, idx) {
      var result = '';
      if (idx != undefined) {
        result = $filter('translate')(vm.items[i][idx]);
      }
      return result;
    };

    /**
     * Verifica se é a conta principal
     * @param i
     * @param idx
     * @returns {string}
     */
    vm.verifyMain = function (i, idx) {
      var result = false;
      if (angular.isDefined(idx)) {
        result = vm.items[i]['is_main'];
      }
      return result;
    };

    /**
     * Destroy events
     */
    $scope.$on('$destroy', function () {
      [listener, listener2].forEach(function (fn) {
        fn();
      });
    });

    vm.init();
  }

  angular
    .module('app.a4-accounts-grid')
    .controller('a4AccountsGridController', a4AccountsGridController);

})();

(function () {
  'use strict';
  angular
    .module('app.stock', [
      'app.stock.dashboard',
      'app.stock.stocklist',
      'app.stock.warehouselist',
      'app.stock.transactions',
      'app.stock.warehouse-transactions'
    ]);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run() {
  }

  angular
    .module('app.stock')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.stock', {
        url: '/stock',
        abstract: true,
        public: false,
        auth: 'ctl_dash',
        templateUrl: 'app/stock/stock.html',
        controller: 'StockController',
        controllerAs: 'stock'
      });
  }

  angular
    .module('app.stock')
    .config(routerConfig);

})();






(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('stock', {
      title: 'Geral',
      group: true,
      weight: 1
    });

  }

  angular
    .module('app.stock')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function StockController($mdSidenav, $state, $translate, $rootScope, $timeout,
                         a4MenuSystemProvider, LocalStorage, $scope, CONFIG,ModalFactory,
                         LockService, LoginService, EducationalService, Session, SysTableColumn,
                         RolesService, Common, $window) {
    var stock = this;
    stock.menu_able = false;
    stock.change_company_able = false;
    stock.toolbar = 'app/stock/toolbar.html';
    stock.userLocal = {name: ''};
    stock.companies = [];
    stock.students = [];
    stock.languages = {
      pt: {
        'title': 'Português',
        'translation': 'TOOLBAR.PORTUGUESE',
        'code': 'pt',
        'flag': 'pt'
      }
    };

    stock.system = {
      name: "Stock",
      icon: 'assets/images/logos/a4stock.png'
    };

    stock.folded = false;
    stock.msScrollOptions = {suppressScrollX: true};


    /**
     * Evento do toggle do menu
     * @type {*}
     */
    var ltn = $rootScope.$on('$toggleNavigationMenu', function () {
      stock.toggleMsNavigationFolded();
    });


    /**
     * Este evento acontece antes da view ser renderizada
     * @type {*}
     */
    var ltn1 = $rootScope.$on('$viewContentLoading', function () {
      stock.context = Session.getContext();
      stock.profile_selected = Session.getCurrentProfile();
      $rootScope.$broadcast(CONFIG.events.side_menu.update);
    });

    /**
     * Executa a tranca da tela
     */
    stock.lockScreen = function () {
      LockService.lockSystem()
        .then(function () {
          $state.go('private.lockscreen');
        });
    };

    /**
     * Confirmação de senha para que o usuário tenha acesso a página de troca de senha 
     */
    stock.confirmPassword = function () {
      ModalFactory.open('require_password', null, null, null, null, 'educational', stock.changePassword, 'Deseja trocar de senha?',
      'Por questões de segurança, por favor insira sua senha para continuar com o procedimento.')
    }

    /**
     * Caso o usuário informe sua senha corretamente, redireciona a página para a página de troca de senha
     */
    stock.changePassword = function () {
      $state.go('public.changepassword')

      $rootScope.$broadcast('ModalFactory.close');
    }

    /**
     * Função de inicialização do controller
     */
    stock.init = function () {
      stock.selectedLanguage = stock.languages[$translate.preferredLanguage()];

      if (SysTableColumn.getScopes().length <= 0) {
        SysTableColumn.getAll();
      }

      if (Session.getUser()) {
        stock.userLocal.name = Session.getUser().person.name;
        stock.companies = Session.getCompanies();
      }

      if (angular.isUndefined(Session.getCurrentProfile()) || Session.getCurrentProfile() === null) {
        stock.verifyProfile(stock.context);
      }

      stock.defineMenuContext();

      stock.companySelected = angular.isDefined(Session.getCurrentCompany()) && Session.getCurrentCompany() !== null ? Session.getCurrentCompany() : stock.companies[0].id;
      Session.set('current_company', parseInt(stock.companySelected), "sessionStorage");
      $translate.use(stock.languages.pt.code);
      $rootScope.$broadcast("CHANGE.THEME", "stock");
    };


    /**
     * Define comportamento do menu do educacional
     */
    stock.defineMenuContext = function () {
      switch (Session.getCurrentProfile()) {
        case (CONFIG.profile.student):
          stock.menu_able = false;
          stock.change_company_able = false;
          stock.show_school_period = false;
          break;
        case (CONFIG.profile.parent):
          stock.menu_able = true;
          stock.change_company_able = true;
          stock.show_school_period = false;
          break;
        case (CONFIG.profile.is_employee):
          stock.menu_able = true;
          stock.change_company_able = true;
          stock.show_school_period = true;
          break;
        case (CONFIG.profile.teacher):
          stock.menu_able = true;
          stock.change_company_able = true;
          stock.show_school_period = false;
          break;
        case (CONFIG.profile.general_coordinator):
          stock.menu_able = true;
          stock.change_company_able = true;
          stock.show_school_period = true;
          break;
        case (CONFIG.profile.group_coordinator):
          stock.menu_able = true;
          stock.change_company_able = true;
          stock.show_school_period = false;
          break;
        default:
          stock.menu_able = true;
          stock.change_company_able = true;
          stock.show_school_period = true;
          break;
      }
    };

    /**
     * Permite selecionar os perfis disponíveis
     * @param profiles
     */
    stock.verifyProfile = function (profiles) {
      /** Se houver mais que uma opção abre o modal para a escolha */
      if (profiles.length > 1) {
        stock.switchProfile(profiles);
      } else {
        LocalStorage.add(CONFIG.storage.profile, profiles);
        $state.reload($state.current.name);
      }
    };

    /**
     * Abre o modal para a escolha de perfil para exibição do sistema
     */
    stock.switchProfile = function (profiles) {
      ModalFactory.customClean(
        'app/controlpanel/switch-profile.html',
        'SwitchProfileControlPanel',
        'vm', false, profiles
      );
    };

    /**
     * Executa o logoff do sistema
     */
    stock.logout = function () {
      if(angular.isDefined(LocalStorage.get('sys_session_id'))) {
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }else {
        LocalStorage.add('sys_session_id', 0)
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Controle do menu lateral de empresas
     */
    stock.toggleA4MenuSystem = function () {
      a4MenuSystemProvider.toggleA4MenuSystem();
    };


    stock.toggleMsNavigationFolded = function () {
      stock.folded = !stock.folded;
    };

    // Methods
    stock.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();
    };

    stock.changeLanguage = function (lang) {
      stock.selectedLanguage = lang;
      $translate.use(lang.code);
    };

    /**
     * Modificação de empresa
     * @param idSelected - identificador da empresa
     */
    stock.changeCompany = function (idSelected) {
      Session.set('current_company', parseInt(idSelected), "sessionStorage");
      var user = Session.getUser();
      $rootScope.show_loader = true;
      RolesService.getUserRoleModule(user.id, Session.get(CONFIG.storage.profile))
        .then(function (response) {
          $rootScope.show_loader = false;
          Session.set(CONFIG.storage.roles, response.roles);
          Session.set(CONFIG.storage.school_period_default, response.school_period_default, "sessionStorage");
          Session.set(CONFIG.storage.current_school_period, response.school_period_default, "sessionStorage");
          $timeout(function () {
            $state.go('private.controlpanel.dashboard');
            $timeout(function () {
              $window.location.reload();
            }, 300)
          }, 300);
          stock.close();
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data.message)
        });
      $rootScope.$broadcast('$switch-header-company');
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      })
    });

    stock.init();
  }

  angular
    .module('app.stock')
    .controller('StockController', StockController);

})();

(function() {
  'use strict';

  angular
    .module('app.config', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  function SysTableColumn(localStorageService, Restangular, Session) {

    var vm = this;
    vm.scopes = [];

    function getAll() {
      if (Session.getUser() !== null) {
        Restangular.one('systablecolumn').get()
          .then(function (resp) {
            vm.scopes = resp.plain();
          })
      }
    }

    function getScopes(){
      return vm.scopes;
    }

    function getColumnsByScope(scope) {
      return vm.scopes[scope];
    }

    return {
      getAll: getAll,
      getColumnsByScope: getColumnsByScope,
      getScopes: getScopes
    };
  }

  angular
    .module('app.config')
    .factory('SysTableColumn', SysTableColumn)
})();
(function () {
  'use strict';

  /** @ngInject */
  function LocalStorage(localStorageService, CryptService) {

    function isSupported() {
      return !!localStorageService.isSupported;
    }

    function add(key, value, type) {
      type = angular.isDefined(type) ? type : 'localStorage';
      if (isSupported()) {
        value = CryptService.encrypt(JSON.stringify(value), CryptService.getSecret()).toString();
        return localStorageService.set(key, value, type);
      } else {
        alert('Browser não suporta LocalStorage');
      }
    }

    function has(key) {
      return get(key) != null;
    }

    function get(key, type) {
      type = angular.isDefined(type) ? type : 'localStorage';
      if (isSupported()) {
        if (key) {
          return CryptService.decrypt(localStorageService.get(key, type), CryptService.getSecret());
        }
      } else {
        alert('Browser não suporta LocalStorage');
      }
    }

    function remove(key) {

      if (isSupported()) {
        return localStorageService.remove(key);
      } else {
        alert('Browser não suporta LocalStorage');
      }
    }

    //...
    function removeAll() {

      if (isSupported()) {
        return localStorageService.clearAll();
      } else {
        alert('Browser não suporta LocalStorage');
      }

    }

    function getLength() {
      if (isSupported()) {
        return localStorageService.length();
      } else {
        alert('Browser não suporta LocalStorage');
      }
    }

    return {
      isSupported: isSupported,
      add: add,
      get: get,
      has: has,
      remove: remove,
      removeAll: removeAll,
      getLength: getLength
    };
  }

  angular
    .module('app.config')
    .factory('LocalStorage', LocalStorage)
})();

(function() {
  'use strict';

  angular
    .module('app.services', []);

})();

(function () {
    'use strict';

    /** @ngInject */
    function sessionFilterService($q, Session) {
        
        var vm = {};

        /**
         * Carrega filtros da sessão
         * @param {string} storageKey - Chave para buscar no storage
         * @returns {Object|null} - Objeto com os filtros ou null
         */
        vm.loadFilters = function(storageKey) {
            try {
                var filters = Session.get(storageKey, 'sessionStorage');
                return filters ? (typeof filters === 'string' ? JSON.parse(filters) : filters) : null;
            } catch (error) {
                console.error('Erro ao carregar filtros:', error);
                return null;
            }
        };

        /**
         * Salva filtros na sessão
         * @param {Object} filters - Objeto com os filtros a serem salvos
         * @param {string} storageKey - Chave para salvar no storage
         * @returns {boolean} - true se salvou com sucesso, false caso contrário
         */
        vm.saveFilters = function(filters, storageKey) {
            try {
                Session.set(storageKey, filters, 'sessionStorage');
                return true;
            } catch (error) {
                console.error('Erro ao salvar filtros:', error);
                return false;
            }
        };

        /**
         * Processamento padrão de inicialização com filtros
         * @param {Object} config - Objeto de configuração com callbacks
         * @returns {Promise} - Promise que resolve com boolean indicando se tinha filtros salvos
         */
        vm.initializeWithFilters = function(config) {
            var filters = vm.loadFilters(config.storageKey);
            var hasSavedFilters = !!filters;
            
            if (hasSavedFilters && config.onFiltersLoaded) {
                config.onFiltersLoaded(filters);
            }
            
            // Executa callback padrão se fornecido
            if (config.onInitialized) {
                return config.onInitialized(hasSavedFilters, filters);
            }
            
            return $q.resolve(hasSavedFilters);
        };

        /**
         * Configura watchers para propriedades de filtro automaticamente
         * @param {Object} scope - Escopo do controller
         * @param {Array} filterProperties - Array com nomes das propriedades a observar
         * @param {string} storageKey - Chave para salvar os filtros
         * @param {number} [delay=300] - Delay para o debounce (ms)
         */
        vm.setupFilterWatchers = function(scope, filterProperties, storageKey, delay) {
            delay = delay || 300;
            var saveTimeout = null;
            
            filterProperties.forEach(function(prop) {
                scope.$watch(prop, function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (saveTimeout) {
                            clearTimeout(saveTimeout);
                        }
                        
                        saveTimeout = setTimeout(function() {
                            var filters = {};
                            filterProperties.forEach(function(filterProp) {
                                filters[filterProp] = scope[filterProp];
                            });
                            
                            vm.saveFilters(filters, storageKey);
                        }, delay);
                    }
                }, true);
            });
        };

        return vm;
    }

    angular
        .module('app.services')
        .service('sessionFilterService', sessionFilterService);

})();
(function () {
  'use strict';

  /** @ngInject */
  function RestangularPolicies(Restangular, CONFIG) {
    return Restangular.withConfig(function (RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(CONFIG.webApiUriLocal + 'api/');
      RestangularConfigurer.setRequestSuffix('.json');
    });
  }

  angular
    .module('app.services')
    .factory('RestangularPolicies', RestangularPolicies);

})();

(function () {
  'use strict';
  
  /** @ngInject */
  function RestangularToken(CONFIG, Restangular) {
    return Restangular.withConfig(function (RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(CONFIG.webApiUri);
    });
  }
  
  angular
    .module('app.services')
    .factory('RestangularToken', RestangularToken);
  
})();

(function () {
  'use strict';

  /** @ngInject */
  function Interceptor($document, $q, LocalStorage, $rootScope, Session, $window, a4IdleMinutesToBlock, $injector) {

    return {

      responseError: function (response) {
        // $rootScope.show_loader = false;
        switch (parseInt(response.status)) {
          case 401:
            // if(response.data.error == 'Token expired') {
            //   var LockService = $injector.get('LockService'); // Obtém LockService dinamicamente
            //   var $state = $injector.get('$state');
            //   LockService.lockSystem()
            //   .then(function () {
            //     $state.go('private.lockscreen');
            //     $rootScope.show_loader = false;
            //   })
            //   .catch(function () {
            //     $rootScope.show_loader = false;
            //   });
            // } else {
              $window.location.href = '#/login';
              Session.destroy();
            // }
            break;
        }
        return $q.reject(response);
      },

      response: function (response) {
        // $rootScope.show_loader = false;
        a4IdleMinutesToBlock.startMonitoring();
        return response;
      },

      requestError: function (response) {
        $rootScope.show_loader = false;
        return $q.reject(response);
      },

      request: function (request) {
        if (request.url.search('http') !== -1 && request.url.search('a4') !== -1) {
          // $rootScope.show_loader = true;
          var current_school_period = Session.getCurrentSchoolPeriod();
          if (angular.isDefined(current_school_period) && current_school_period !== null){
            current_school_period = angular.isDefined(current_school_period.id) ? current_school_period.id : current_school_period;
          }
          var subdomain = $document[0].domain.split('.')[0];
          request.headers['X-Requested-With'] = 'XMLHttpRequest';
          var token = LocalStorage.get('token');
          if (!!token && request.url.search('api') !== -1) {
            token = angular.fromJson(token);
            request.headers['Authorization'] = token.token_type + " " + token.access_token;
          }

          if (angular.isDefined(request.data) && typeof request.data != "number" && typeof request.data != "string") {
            request.data.connection = subdomain;
            request.data.company = Session.getCurrentCompany();
            request.data.current_school_period = current_school_period;
            request.data.labs_user = Session.getLabsUser() || undefined;
            request.data.labs_pass = Session.getLabsPass() || undefined;
            request.data.profile = Session.getCurrentProfile()
          } else {
            request.data = {
              connection: subdomain,
              labs_user: Session.getLabsUser() || undefined,
              labs_pass: Session.getLabsPass() || undefined,
              company: Session.getCurrentCompany(),
              current_school_period: current_school_period,
              profile: Session.getCurrentProfile()
            };
          }
          if (angular.isDefined(request.params)) {
            request.params.connection = subdomain;
            request.params.labs_user = Session.getLabsUser() || undefined;
            request.params.labs_pass = Session.getLabsPass() || undefined;
            request.params.company = Session.getCurrentCompany();
            request.params.current_school_period = current_school_period;
            request.params.profile = Session.getCurrentProfile();
          } else {
            request.params = {
              connection: subdomain,
              labs_user: Session.getLabsUser() || undefined,
              labs_pass: Session.getLabsPass() || undefined,
              company: Session.getCurrentCompany(),
              current_school_period: current_school_period,
              profile: Session.getCurrentProfile()
            }
          }
        }

        return request;
      }
    };

  }

  angular
    .module('app.config')
    .factory('a4Interceptor', Interceptor)
})();

(function() {
  'use strict';
  
  /** @ngInject */
  function RequestInterceptorConfig($httpProvider) {
    $httpProvider.interceptors.push('a4Interceptor');
    $httpProvider.defaults.useXDomain = true;
  }
  
  angular
    .module('app.services')
    .config(RequestInterceptorConfig);
  
})();

(function () {
  /* global MobileDetect */
  'use strict';

  angular
    .module('app.core')
    .factory('msUtils', msUtils);

  /** @ngInject */
  function msUtils($window) {
    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent),
      browserInfo = null;

    return {
      exists: exists,
      detectBrowser: detectBrowser,
      guidGenerator: guidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray
    };

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser() {
      // If we already tested, do not test again
      if (browserInfo) {
        return browserInfo;
      }

      var browserData = [
        {
          string: $window.navigator.userAgent,
          subString: 'Edge',
          versionSearch: 'Edge',
          identity: 'Edge'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Chrome',
          identity: 'Chrome'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'OmniWeb',
          versionSearch: 'OmniWeb/',
          identity: 'OmniWeb'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Apple',
          versionSearch: 'Version',
          identity: 'Safari'
        },
        {
          prop: $window.opera,
          identity: 'Opera'
        },
        {
          string: $window.navigator.vendor,
          subString: 'iCab',
          identity: 'iCab'
        },
        {
          string: $window.navigator.vendor,
          subString: 'KDE',
          identity: 'Konqueror'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Firefox',
          identity: 'Firefox'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Camino',
          identity: 'Camino'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Netscape',
          identity: 'Netscape'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'MSIE',
          identity: 'Explorer',
          versionSearch: 'MSIE'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Trident/7',
          identity: 'Explorer',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Gecko',
          identity: 'Mozilla',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Mozilla',
          identity: 'Netscape',
          versionSearch: 'Mozilla'
        }
      ];

      var osData = [
        {
          string: $window.navigator.platform,
          subString: 'Win',
          identity: 'Windows'
        },
        {
          string: $window.navigator.platform,
          subString: 'Mac',
          identity: 'Mac'
        },
        {
          string: $window.navigator.platform,
          subString: 'Linux',
          identity: 'Linux'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPhone',
          identity: 'iPhone'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPod',
          identity: 'iPod'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPad',
          identity: 'iPad'
        },
        {
          string: $window.navigator.platform,
          subString: 'Android',
          identity: 'Android'
        }
      ];

      var versionSearchString = '';

      function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;

          versionSearchString = data[i].versionSearch || data[i].identity;

          if (dataString) {
            if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;

            }
          }
          else if (dataProp) {
            return data[i].identity;
          }
        }
      }

      function searchVersion(dataString) {
        var index = dataString.indexOf(versionSearchString);

        if (index === -1) {
          return;
        }

        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }

      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();

      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };

      return browserInfo;
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator() {
      var S4 = function () {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4() + S4() + S4() + S4() + S4() + S4());
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile() {
      return mobileDetect.mobile();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      }
      else {
        array.splice(array.indexOf(item), 1);
      }
    }
  }
}());
(function () {
  'use strict';

  angular
    .module('app.config')
    .config(function (dropzoneOpsProvider, LocalStorageProvider) {

      var objToken = LocalStorageProvider.$get().get('token');
      if (angular.isDefined(objToken)){
        var token = angular.fromJson(objToken);
        var Authorization = token.token_type + ' ' + token.access_token;

        dropzoneOpsProvider.setOptions({
          headers: {
            'Authorization': Authorization,
            'Content-Type': null,
            'Cache-Control': null,
            'X-Requested-With': null
          },
          addRemoveLinks: false,
          dictDefaultMessage: 'Clique para adicionar ou soltar arquivos',
          dictFallbackMessage: "Seu navegador não suporta carregamentos de arquivos do drag'n'drop.",
          dictFallbackText: "Por favor, use o formulário de retorno abaixo para fazer o upload de seus arquivos como nos dia, anteriores.",
          dictFileTooBig: "O arquivo é muito grande ({{filesize}} MiB). Tamanho máximo do arquivo: {{maxFilesize}} MiB.",
          dictInvalidFileType: "Você não pode carregar arquivos deste tipo.",
          dictResponseError: "O servidor respondeu com o código {{statusCode}}.",
          dictCancelUpload: "Cancelar upload",
          dictCancelUploadConfirmation: "Tem certeza de que deseja cancelar este upload?",
          dictRemoveFile: "Remover arquivo",
          dictMaxFilesExceeded: "Você não pode carregar mais arquivos."
        });
      }

    });

})();

(function () {
  'use strict';

  /** @ngInject */
  function Common($q, Toast) {
    var self = {};
    self.$q = $q;
    self.Toast = Toast;

    return self;
  }

  angular.module('app.services')
    .factory('Common', Common);

})();

(function () {
  'use strict';

  /** @ngInject */
  function AppLog($document, moment, LocalStorage, CONFIG, Session, Restangular, $filter, $timeout, ModalFactory,
                  AppLogService, a4Moment) {

    var vm = {};
    vm.user = Session.getUser();
    vm.unread_logs = [];

    vm.getUnreadLogs = function () {
      Restangular.one('applog').one('getunreadlogs').get({user_id: vm.user.id})
        .then(function (resp) {
          vm.unread_logs = resp.plain();
        })
    };

    vm.icon_type = {
      1: 'a4educational.png',
      51: 'a4finance.png',
      148: 'a4crm.jpg'
    };

    vm.checkUnreadLog = function (sys_module_id) {
      var array = [];
      var ids = [];
      var last_day_check = a4Moment(LocalStorage.get('last_day_check_app_log_' + sys_module_id));
      LocalStorage.add('last_day_check_app_log_' + sys_module_id, a4Moment());
      if (a4Moment().diff(last_day_check, 'days') !== 0) {
        AppLogService.getAll({sys_module_id: sys_module_id, user_id: vm.user.id})
          .then(function (response) {
            vm.logs = response.plain();
            vm.logs.forEach(function (item) {
              var icon = vm.icon_type[item.sys_module_id_app];
              var scopes = vm.defineScopes(item.scope);
              var obj = {
                event: item.name,
                time: item.launch_date !== null ? a4Moment(item.launch_date).format('DD/MM/YYYY') : item.launch_date,
                icon: "assets/images/logos/" + icon,
                type: item.type,
                module: item.sys_module,
                sys_module_app: item.sys_module_id_app,
                card: {
                  title: item.name,
                  text: item.description,
                  subtitle: "Its' time!",
                  scopes: scopes,
                  template: "app/controlpanel/app-log/templates/template-9.html",
                  media: {
                    image: {
                      src: item.file_reference !== null ? vm.webLink + item.file_reference :
                        "https://earth.org/wp-content/uploads/2020/07/800px-Great_white_shark_south_africa.jpg",
                      alt: "Andrew Ryan"
                    }
                  }
                }
              };
              array.push(obj);
              ids.push(item.id);
            });
            vm.timeline = array;
            if (vm.timeline.length > 0) {
              ModalFactory.custom(
                'app/educational/app-log/views/log-list.html', {timeline: vm.timeline}, false
              ).then(function () {
                LocalStorage.add('last_day_check_app_log_' + sys_module_id, a4Moment());
                Restangular.one('applog').all('setreadlogs').post({logs: ids, user_id: vm.user.id})
                  .then(function () {
                    // vm.unread_logs = resp.plain();
                  })
              });
            }
          });
      }


      vm.defineScopes = function (scopes) {
        if (scopes !== null) {
          var regex1 = /{/gi;
          var regex2 = /}/gi;

          scopes = scopes.replaceAll(regex1, '').replaceAll(regex2, '').split(',')
            .map(function (scope) {
              return vm.convertScope(scope);
            });
        }
        return scopes;
      };


      // $timeout(function () {
      //   var logs = $filter('filter')(vm.unread_logs, {sys_module_id: sys_module_id});
      //   console.log(logs);
      //   if (logs.length > 0) {
      //     ModalFactory.customClean(
      //       'app/educational/app-log/views/log-list.html',
      //       /** @ngInject */
      //       function (ModalFactory, ModalExtra, $mdDialog, AppLogService) {
      //         var vm = this;
      //         vm.form = {};
      //         vm.sys_module_id = ModalExtra.sys_module_id;
      //         /**
      //          * Fecha o modal
      //          */
      //         vm.close = function (obj) {
      //           $mdDialog.hide(obj);
      //         };
      //
      //         vm.init = function () {
      //         }
      //         vm.init();
      //       }, 'vm', false, {sys_module_id: sys_module_id}
      //     ).then(function () {
      //       console.log('resposta ok!');
      //       Restangular.one('applog').all('setreadlogs').post({logs: logs, user_id: vm.user.id})
      //         .then(function (resp) {
      //           console.log(resp);
      //           // vm.unread_logs = resp.plain();
      //         })
      //     });
      //   }
      // }, 5000);
    };


    return vm;
  }

  angular.module('app.services')
    .factory('AppLog', AppLog);

})();

(function () {
  'use strict';

  /** @ngInject*/
  function a4MomentService(moment) {
    return function (date, format) {
      moment.locale('pt-br');
      moment.locale('en', {
        months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
          'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        weekdays: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
        weekdaysshort: ['dom', 'seg', 'ter', 'quar', 'qui', 'sex', 'sab'],
        relativeTime : {
          future: "em %s",
          past:   "%s atrás",
          s  : 'alguns segundos',
          ss : '%d segundos',
          m:  "um minuto",
          mm: "%d minutos",
          h:  "uma hora",
          hh: "%d hora",
          d:  "um dia",
          dd: "%d dias",
          w:  "uma semana",
          ww: "%d semana",
          M:  "um mês",
          MM: "%d meses",
          y:  "um ano",
          yy: "%d anos"
        }
      });
      if (angular.isUndefined(date)) {
        return moment();
      } else if (date === null) {
        return null;
      } else {
        if (angular.isDefined(format)) {
          return moment(date, format);
        } else {
          return moment(date);
        }
      }
    };
  }

  angular.module('app.services')
    .service('a4Moment', a4MomentService)
})();

(function () {
  'use strict';

  /** @ngInject */
  function a4IdleMinutesToBlock($interval, $injector, LocalStorage, $rootScope) {
    var vm = this;
    var monitor_interval = null; // Controla o intervalo local
    var modal_shown = false; // Evita múltiplos modais na mesma aba

    // Verifica se o BroadcastChannel está disponível
    if (typeof BroadcastChannel !== 'undefined') {
      // Usa BroadcastChannel se disponível
      vm.channel = new BroadcastChannel('contador');
    } else {
      // Fallback para localStorage com eventos
      vm.useLocalStorageFallback = true;
    }

    /**
     * Inicia o monitoramento do contador baseado no valor de idle_minutes_to_block.
     */
    vm.startMonitoring = function () {
      var idle_minutes_to_block = parseInt(LocalStorage.get('idle_minutes_to_block'), 10) || 0;

      if (idle_minutes_to_block > 0) {
        var countdown_time = idle_minutes_to_block * 60 * 1000; // Converte minutos para milissegundos
        var end_time = Date.now() + countdown_time;

        // Salva o tempo final no LocalStorage para sincronização entre abas
        LocalStorage.add('idle_block_end_time', end_time);

        // Notifica outras abas para iniciar o monitoramento
        if (vm.useLocalStorageFallback) {
          // Usa localStorage para sincronização
          LocalStorage.add('sync_event', JSON.stringify({ type: 'start', end_time: end_time }));
        } else {
          // Usa BroadcastChannel
          vm.channel.postMessage({ type: 'start', end_time: end_time });
        }

        // Inicia o monitoramento local
        monitorCountdown();
      }
    };

    /**
     * Monitora o contador em tempo real usando o valor sincronizado no LocalStorage.
     */
    function monitorCountdown() {
      if (monitor_interval) return; // Evita múltiplas instâncias do monitoramento

      monitor_interval = $interval(function () {
        var end_time = parseInt(LocalStorage.get('idle_block_end_time'), 10) || 0;
        var time_left = end_time - Date.now();

        // Quando faltar 1 minuto, exibe o modal (sincronizado entre abas)
        if (time_left <= 60000 && time_left > 0 && !modal_shown) {
          modal_shown = true; // Marca o modal como exibido na aba atual
          if (vm.useLocalStorageFallback) {
            // Usa localStorage para sincronização
            LocalStorage.add('sync_event', JSON.stringify({ type: 'open_modal' }));
          } else {
            // Usa BroadcastChannel
            vm.channel.postMessage({ type: 'open_modal' });
          }
          openModal();
        }

        // Para o monitoramento local se o tempo expirar
        if (time_left <= 0) {
          vm.stopMonitoring();
        }
      }, 1000); // Verifica a cada segundo
    }

    /**
     * Abre o modal quando faltar 1 minuto (sincronizado entre abas).
     */
    function openModal() {
      // var modalFactory = $injector.get('ModalFactory'); // Obtém ModalFactory dinamicamente
      // modalFactory.customClean(
      //   'app/controlpanel/idle-minutes-to-block/views/confirm-idle-modal.html',
      //   'IdleMinutesToBlockController',
      //   'vm',
      //   false,
      //   {}
      // ).then(function () {
      //   console.log("funcionou em todas as abas");
      //   vm.stopMonitoring();
      //   vm.startMonitoring();
      // });
    }

    /**
     * Para o monitoramento do contador.
     */
    vm.stopMonitoring = function () {
      if (monitor_interval) {
        $interval.cancel(monitor_interval);
        monitor_interval = null;
        modal_shown = false; // Permite que o modal seja exibido novamente em um novo ciclo
      }
    };

    /**
     * Escuta mensagens do BroadcastChannel ou eventos do localStorage para sincronização entre abas.
     */
    if (vm.useLocalStorageFallback) {
      // Escuta eventos de localStorage
      $rootScope.$on('LocalStorage:changed', function (event, key, newValue) {
        if (key === 'sync_event') {
          var message = JSON.parse(newValue);
          if (message.type === 'start') {
            LocalStorage.add('idle_block_end_time', message.end_time);
            monitorCountdown();
          } else if (message.type === 'open_modal' && !modal_shown) {
            modal_shown = true;
            openModal();
          }
        }
      });
    } else {
      // Escuta mensagens do BroadcastChannel
      vm.channel.onmessage = function (event) {
        var message = event.data;
        if (message.type === 'start') {
          LocalStorage.add('idle_block_end_time', message.end_time);
          monitorCountdown();
        } else if (message.type === 'open_modal' && !modal_shown) {
          modal_shown = true;
          openModal();
        }
      };
    }

    return vm;
  }

  angular.module('app.services')
    .service('a4IdleMinutesToBlock', a4IdleMinutesToBlock);
})();
(function () {
  'use strict';

  /** @ngInject */
  function RegisterService(Restangular) {
    var self = {};

    /** Pega os dados do usuário a partir do token */
    self.getDataForUserByRegisterToken = function (obj) {
      return Restangular.one('register').one('getdatauser').get(obj);
    };

    self.getLoginType = function (obj) {
      return Restangular.one('register').one('getlogintype').get(obj);
    };

    /** Atualiza os dados do usuário */
    self.updateUser = function (obj){
      return Restangular.one('register').all('updateuser').post(obj);
    };

    /** Realiza a confirmação da conta */
    self.confirmAccount = function (obj) {
      return Restangular.one('register').all('confirmaccount').post(obj);
    };

    self.createNoEmailPerson = function (obj) {
      return Restangular.one('register').all('createnoemailperson').post(obj);
    };

    return self;
  }

  angular.module('app.register')
    .factory('RegisterService', RegisterService);


})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('public.register', {
        url: '/register/:token',
        public: true,
        controller: 'RegisterController',
        controllerAs: 'vm',
        templateUrl: 'app/register/views/index.html'

      })
      .state('public.raiodesolregister', {
        url: '/register/raiodesol/:token',
        public: true,
        controller: 'RegisterController',
        controllerAs: 'vm',
        templateUrl: 'app/register/views/raiodesolregister.html'
      })

      .state('public.confirmation', {
        url: '/confirmation/:base64',
        public: true,
        controller: 'ConfirmationController',
        controllerAs: 'vm',
        templateUrl: 'app/register/views/confirmation.html'
      });
  }

  angular
    .module('app.register')
    .config(routerConfig);

})();

(function () {
  'use strict';

  /** @ngInject */
  function RegisterController($stateParams, $state, $timeout, $rootScope, RegisterService, Common, ModalFactory, $document) {
    var vm = this;
    vm.windowHeight = angular.element("body").height();
    vm.token = null;
    vm.form = {};
    vm.noEmail = false;
    $rootScope.show_loader = false;
    vm.disable_button = false;
    vm.current_connection = $document[0].domain.split('.')[0];


    vm.init = function () {
      vm.getLoginType();
      vm.token = $stateParams.token === '' ? null : $stateParams.token;
      if (vm.token !== null) {
        vm.getDataForUserByRegisterToken(vm.token);
      }
    };

    vm.getLoginType = function() {
      RegisterService.getLoginType()
        .then(function (response) {
          console.log(response);
          vm.login_type = response;
        })
    };

    vm.toggleForm = function() {
      vm.noEmail = !vm.noEmail;
    };

    /**
     * Retorna os dados do usuário a partir do token
     * @param token
     */
    vm.getDataForUserByRegisterToken = function (token) {
      $rootScope.show_loader = true;
      RegisterService.getDataForUserByRegisterToken({token: token})
        .then(function (response) {
          vm.form.name = response.name.split(' ')[0];
          vm.form.email = response.email;
          vm.has_national_id_number = response.has_national_id_number;
          vm.has_dob = response.has_dob;
          vm.form.token = vm.token;
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Salva os dados do registro da nova conta, e envia um e-mail para o novo usuário,
     * para que ele confirm a criação. Caso seja uma criação de conta sem email, leva para a função de criação
     * @param obj
     */
    vm.createAccount = function (obj) {
      vm.disable_button = true;
      if (angular.isDefined(obj.confirm_email) && obj.email !== obj.confirm_email) {
        Common.Toast.warning('E-mails precisam ser iguais');
        vm.disable_button = false;
        return;
      }
      if (obj.password !== obj.password_confirm) {
        Common.Toast.warning('Senhas precisam ser iguais');
        vm.disable_button = false;
        return;
      }

      if(!vm.noEmail) {
        RegisterService.updateUser(obj)
          .then(function () {
            ModalFactory.confirm(
              null,
              'Atenção',
              'Um e-mail lhe foi enviado para que possa confirmar o registro da sua conta!',
              'Confirmar',
              'false',
              'controlpanel'
            ).then(function () {
              $timeout(function () {
                $state.go('public.login');
              }, 1000);
            });
          })
          .catch(function (response) {
            Common.Toast.error(response.data.message);
          })
      } else {
        vm.form.company = vm.current_connection;
        RegisterService.createNoEmailPerson(obj)
          .then(function () {
            ModalFactory.confirm(
              null,
              'Atenção',
              'Conta criada com sucesso, você será redirecionado para pagina de login',
              'Confirmar',
              'false',
              'controlpanel'
            ).then(function () {
                $state.go('public.login');
            })
          }).catch(function (err){
          ModalFactory.confirm(
            null,
            'Atenção',
            err.data.message,
            'Confirmar',
            'false',
            'controlpanel'
          )
        })
      }

    };

    vm.init();

  }

  angular
    .module('app.register')
    .controller('RegisterController', RegisterController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function ConfirmationController($rootScope, $stateParams, RegisterService, Common) {
    var vm = this;
    vm.windowHeight = angular.element("body").height();

    vm.init = function () {
      vm.base64 = $stateParams.base64;
      vm.confirmAccount(vm.base64);
    };

    vm.confirmAccount = function (base64) {
      $rootScope.show_loader = true;
      RegisterService.confirmAccount({base64: base64})
        .then(function () {
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
          Common.Toast.error('Erro ao confirmar conta');
        });
    };

    vm.init();
  }

  angular
    .module('app.register')
    .controller('ConfirmationController', ConfirmationController);
})();

(function () {
  'use strict';
  angular
    .module('app.process', [
      'app.process.dashboard',
      'app.process.process-crud',
      'app.process.process-to-solve',
      'app.process.location',
      'app.process.stock',
      'app.process.process-person'
    ]);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run() {
  }

  angular
    .module('app.process')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.process', {
        url: '/process',
        abstract: true,
        public: false,
        auth: 'ctl_dash',
        templateUrl: 'app/process/process.html',
        controller: 'ProcessController',
        controllerAs: 'process'
      });
  }

  angular
    .module('app.process')
    .config(routerConfig);

})();






(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('process', {
      title: 'Geral',
      group: true,
      weight: 1
    });

  }

  angular
    .module('app.process')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ProcessController($mdSidenav, $state, $translate, $rootScope, $timeout,ModalFactory,
                         a4MenuSystemProvider, LocalStorage, $scope, CONFIG,
                         LockService, LoginService, EducationalService, Session, SysTableColumn,
                         RolesService, Common, $window) {
    var process = this;
    process.menu_able = false;
    process.change_company_able = false;
    process.toolbar = 'app/process/toolbar.html';
    process.userLocal = {name: ''};
    process.companies = [];
    process.students = [];
    process.languages = {
      pt: {
        'title': 'Português',
        'translation': 'TOOLBAR.PORTUGUESE',
        'code': 'pt',
        'flag': 'pt'
      }
    };

    process.system = {
      name: "Solictações",
      icon: 'assets/images/logos/a4process.jpg'
    };

    process.folded = false;
    process.msScrollOptions = {suppressScrollX: true};


    /**
     * Evento do toggle do menu
     * @type {*}
     */
    var ltn = $rootScope.$on('$toggleNavigationMenu', function () {
      process.toggleMsNavigationFolded();
    });


    /**
     * Este evento acontece antes da view ser renderizada
     * @type {*}
     */
    var ltn1 = $rootScope.$on('$viewContentLoading', function () {
      process.context = Session.getContext();
      process.profile_selected = Session.getCurrentProfile();
      $rootScope.$broadcast(CONFIG.events.side_menu.update);
    });

    /**
     * Executa a tranca da tela
     */
    process.lockScreen = function () {
      LockService.lockSystem()
        .then(function () {
          $state.go('private.lockscreen');
        });
    };

    /**
     * Confirmação de senha para que o usuário tenha acesso a página de troca de senha 
     */
    process.confirmPassword = function () {
      ModalFactory.open('require_password', null, null, null, null, 'educational', process.changePassword, 'Deseja trocar de senha?',
      'Por questões de segurança, por favor insira sua senha para continuar com o procedimento.')
    }

    /**
     * Caso o usuário informe sua senha corretamente, redireciona a página para a página de troca de senha
     */
    process.changePassword = function () {
      $state.go('public.changepassword')

      $rootScope.$broadcast('ModalFactory.close');
    }

    /**
     * Função de inicialização do controller
     */
    process.init = function () {
      process.selectedLanguage = process.languages[$translate.preferredLanguage()];

      if (SysTableColumn.getScopes().length <= 0) {
        SysTableColumn.getAll();
      }

      if (Session.getUser()) {
        process.userLocal.name = Session.getUser().person.name;
        process.companies = Session.getCompanies();
      }

      if (angular.isUndefined(Session.getCurrentProfile()) || Session.getCurrentProfile() === null) {
        process.verifyProfile(process.context);
      }

      process.defineMenuContext();

      process.companySelected = angular.isDefined(Session.getCurrentCompany()) && Session.getCurrentCompany() !== null ? Session.getCurrentCompany() : process.companies[0].id;
      Session.set('current_company', parseInt(process.companySelected), "sessionStorage");
      $translate.use(process.languages.pt.code);
      $rootScope.$broadcast("CHANGE.THEME", "process");
    };


    /**
     * Define comportamento do menu do educacional
     */
    process.defineMenuContext = function () {
      switch (Session.getCurrentProfile()) {
        case (CONFIG.profile.student):
          process.menu_able = false;
          process.change_company_able = false;
          process.show_school_period = false;
          break;
        case (CONFIG.profile.parent):
          process.menu_able = true;
          process.change_company_able = true;
          process.show_school_period = false;
          break;
        case (CONFIG.profile.is_employee):
          process.menu_able = true;
          process.change_company_able = true;
          process.show_school_period = true;
          break;
        case (CONFIG.profile.teacher):
          process.menu_able = true;
          process.change_company_able = true;
          process.show_school_period = false;
          break;
        case (CONFIG.profile.general_coordinator):
          process.menu_able = true;
          process.change_company_able = true;
          process.show_school_period = true;
          break;
        case (CONFIG.profile.group_coordinator):
          process.menu_able = true;
          process.change_company_able = true;
          process.show_school_period = false;
          break;
        default:
          process.menu_able = true;
          process.change_company_able = true;
          process.show_school_period = true;
          break;
      }
    };

    /**
     * Permite selecionar os perfis disponíveis
     * @param profiles
     */
    process.verifyProfile = function (profiles) {
      /** Se houver mais que uma opção abre o modal para a escolha */
      if (profiles.length > 1) {
        process.switchProfile(profiles);
      } else {
        LocalStorage.add(CONFIG.storage.profile, profiles);
        $state.reload($state.current.name);
      }
    };

    /**
     * Abre o modal para a escolha de perfil para exibição do sistema
     */
    process.switchProfile = function (profiles) {
      ModalFactory.customClean(
        'app/controlpanel/switch-profile.html',
        'SwitchProfileControlPanel',
        'vm', false, profiles
      );
    };

    /**
     * Executa o logoff do sistema
     */
    process.logout = function () {
      if(angular.isDefined(LocalStorage.get('sys_session_id'))) {
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }else {
        LocalStorage.add('sys_session_id', 0)
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Controle do menu lateral de empresas
     */
    process.toggleA4MenuSystem = function () {
      a4MenuSystemProvider.toggleA4MenuSystem();
    };


    process.toggleMsNavigationFolded = function () {
      process.folded = !process.folded;
    };

    // Methods
    process.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();
    };

    process.changeLanguage = function (lang) {
      process.selectedLanguage = lang;
      $translate.use(lang.code);
    };

    /**
     * Modificação de empresa
     * @param idSelected - identificador da empresa
     */
    process.changeCompany = function (idSelected) {
      Session.set('current_company', parseInt(idSelected), "sessionStorage");
      var user = Session.getUser();
      $rootScope.show_loader = true;
      RolesService.getUserRoleModule(user.id, Session.get(CONFIG.storage.profile))
        .then(function (response) {
          $rootScope.show_loader = false;
          Session.set(CONFIG.storage.roles, response.roles);
          Session.set(CONFIG.storage.school_period_default, response.school_period_default, "sessionStorage");
          Session.set(CONFIG.storage.current_school_period, response.school_period_default, "sessionStorage");
          $timeout(function () {
            $state.go('private.controlpanel.dashboard');
            $timeout(function () {
              $window.location.reload();
            }, 300)
          }, 300);
          process.close();
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data.message)
        });
      $rootScope.$broadcast('$switch-header-company');
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      })
    });

    process.init();
  }

  angular
    .module('app.process')
    .controller('ProcessController', ProcessController);

})();

(function() {
  'use strict';

  angular
    .module('app.policies', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  function policyAccess(PoliciesService) {
    return {
      restrict: 'A',
      link: function($scope, element, attrs){
         PoliciesService.checkPolicy(attrs.policyAccess)
          .catch(function () {
            //element.remove();
            element.hide();
          });
      }
    };
  }

  angular
    .module('app.policies')
    .directive('policyAccess', policyAccess);

})();

(function () {
  'use strict';

  /** @ngInject */
  function PoliciesService($q, Session, MenuPolicies,Restangular) {
    var vm = {};
    /**
     * Retorna as regra de usuário de storage e incapsula em uma promise.
     */
    vm.getAll = function () {
      var deferred = $q.defer();
      var roles = Session.getRoles();
      deferred.resolve(roles);
      return deferred.promise;
    };

    /**
     * Retorna as regras de usuário do storage diretamente
     */
    vm.getContext = function () {
      return Session.getContext();
    };

    /**
     * Retorna as regras de usuário do storage diretamente
     */
    vm.getRoles = function () {
      return Session.getRoles();
    };

    /**
     * Executa o check-in de policy para o menu
     * @returns {Boolean}
     */
    vm.checkPolicyFromMenu = function (role) {
      var policies = Session.getRoles();
      var policyExists = false;
      if (angular.isUndefined(role)) {
        policyExists = true;
      } else {
        if (angular.isDefined(policies) && policies !== null && angular.isDefined(policies[role])) {
          policyExists = true;
        }
      }
      return policyExists;
    };


    /**
     * Executa o check-in de policy para elementos da tela
     * @param role
     * @returns {Promise}
     */
    vm.checkPolicy = function (role) {
      var deferred = $q.defer();
      vm.getAll().then(function (policies) {
        var policyExists = null;

        if (angular.isUndefined(role)) {
          policyExists = true;
        } else {
          policyExists = angular.isDefined(policies) && policies[role] !== null && angular.isDefined(policies[role]);
        }

        if (policyExists) {
          return deferred.resolve(true);
        }

        deferred.reject(false);
      }).catch(function () {
        deferred.reject(false);
      });
      return deferred.promise;
    };


    /**
     * Verifica o acesso do usuário pela politica e perfil selecionado
     * @param role - Regra do menu em relação ao usuário
     * @param path - Nome do menu
     */
    vm.checkPolicyAndProfile = function (role, path) {
      if (vm.checkPolicyFromMenu(role)) {
        return MenuPolicies[path]();
      } else {
        return false;
      }
    };


    /**
     * Verifica qual o atual perfil do usuário
     */
    vm.currentProfile = function () {
      return Session.getProfile();
    };

    /**
     * Verifica se o usuário é um coordenador geral
     * @returns {boolean}
     */
    vm.isGeneralCoordinator = function () {
      return MenuPolicies.isGeneralCoordinator();
    };

    /**
     * Verifica se o usuário é um coordenador de turma
     * @returns {boolean}
     */
    vm.isGroupCoordinator = function () {
      return MenuPolicies.isGroupCoordinator();
    };


    /**
     * Verifica se o usuário é um aluno
     * @returns {boolean}
     */
    vm.isStudent = function () {
      return MenuPolicies.isStudent();
    };

    /**
     * Verifica se o usuário é um responsável
     * @returns {boolean}
     */
    vm.isParent = function () {
      return MenuPolicies.isParent();
    };

    /**
     * Verifica se o usuário é um professor
     * @returns {boolean}
     */
    vm.isTeacher = function () {
      return MenuPolicies.isTeacher();
    };

    /**
     * Retorna a quantidade de empresas
     * @returns {integer}*/
    vm.companyQty = function (){
      return Restangular.one('company').one("getCompanyQty").get();
    };

    return vm;
  }

  angular.module('app.policies')
    .factory('PoliciesService', PoliciesService);

})();

(function () {
  'use strict';

  function MenuPolicies(Session, CONFIG) {
    return {

      /**
       * Verifica se o usuário é um coordenador geral
       * @returns {boolean}
       */
      isGeneralCoordinator: function () {
        var current_profile = Session.getCurrentProfile();
        return (angular.isDefined(current_profile)) && (current_profile === CONFIG.profile.general_coordinator);
      },

      /**
       * Verifica se o usuário é um coordenador de turma
       * @returns {boolean}
       */
      isGroupCoordinator: function () {
        var current_profile = Session.getCurrentProfile();
        return (angular.isDefined(current_profile)) && (current_profile === CONFIG.profile.group_coordinator);
      },

      /**
       * Verifica se o usuário é um aluno
       * @returns {boolean}
       */
      isStudent: function () {
        var current_profile = Session.getCurrentProfile();
        return (angular.isDefined(current_profile)) && (current_profile === CONFIG.profile.student);
      },

      /**
       * Verifica se o usuário é um responsável
       * @returns {boolean}
       */
      isParent: function () {
        var current_profile = Session.getCurrentProfile();
        return (angular.isDefined(current_profile)) && (current_profile === CONFIG.profile.parent);
      },

      /**
       * Verifica se o usuário é um professor
       * @returns {boolean}
       */
      isTeacher: function () {
        var current_profile = Session.getCurrentProfile();
        return (angular.isDefined(current_profile)) && (current_profile === CONFIG.profile.teacher);
      },

      /** Regras Gerais para Menu *************************************/
      //CALENDARIO ACADEMICO
      "coordination.academic-calendar": function () {
        return true;
      },
      /** ALUNOS */
      "secretary.students": function () {
        return true;
      },
      "educational.students": function () {
        return true;
      },
      /** PAIS, RESPONSÁVEIS E FIADORES */
      "secretary.responsibles": function () {
        return true;
      },
      "educational.responsibles": function () {
        return true;
      },
      "educational.financial-situation": function () {
        return true;
      },
      /** GRUPOS DE CURSO */
      "coordination.class-grouping": function () {
        return true;
      },
      /** Class Release */
      "educational.class-release": function () {
        return true;
      },
      /** Boletins dependentes */
      "educational.school-reports": function () {
        return true;
      },
      /**CLASSES */
      "config.classes": function () {
        return true;
      },
      /**MATRÍCULA FINANCEIRA */
      "educational.financeenrolment": function () {
        return true;
      },
      /**COORDENADORES DE CURSOS */
      "coordination.coordinators": function () {
        return true;
      },
      /** COLABORADORES */
      "secretary.collaborators": function () {
        return true;
      },
      /** MATRICULA FINANCEIRA */
      "secretary.finance-enrolment": function () {
        return true;
      },
      /** ALTERAÇÕES PELO RESPONSÁVEL */
      "secretary.responsible-changes": function () {
        return true;
      },
      /** ESTATISTICAS */
      "secretary.statistics": function () {
        return true;
      },
      /** CURSO */
      "config.course": function () {
        return true;
      },
      /** GRUPO DE CURSO */
      "config.course-group": function () {
        return true;
      },
      /** TURMAS */
      "config.groups": function () {
        return true;
      },
      /** BOLETIM INFORMATIVO */
      "secretary.informative-report": function () {
        return true;
      },
      /** LANÇAMENTO DE NOTA */
      "secretary.note-release": function () {
        return true;
      },
      /** PLANO DE AULA */
      "coordination.lesson-plan": function () {
        return true;
      },
      /** QUESTIONÁRIOS */
      "coordination.questionnaires": function () {
        return true;
      },
      /** RELATÓRIOS */
      "educational.reports": function () {
        return true;
      },
      /** PERIODOS LETIVOS */
      "config.school-period": function () {
        return true;
      },
      /** DISCIPLINAS */
      "config.subject": function () {
        return true;
      },
      /** MENSAGENS DOS BOLETINS */
      "educational.students-records-messages": function () {
        return true;
      },
      /** CONFIGURACOES */
      "config.settings": function () {
        return true;
      },
      /** CONTAS CORRENTES */
      "finance.current-account": function () {
        return true;
      },
      /** A4PAG */
      "finance.a4pag": function () {
        return true;
      },
      /** CRÉDITOS */
      "finance.credits": function () {
        return true;
      },
      /** NEGOCIAÇÕES */
      "finance.negotiation": function () {
        return true;
      },
      /** PESSOAS */
      "finance.person": function () {
        return true;
      },
      /** A RECEBER */
      "finance.bill-receipt": function () {
        return true;
      },
      /** A PAGAR */
      "finance.bill-expense": function () {
        return true;
      },
      /** CHEQUES RECEBIDOS */
      "finance.check-received": function () {
        return true;
      },
      /** CHEQUES RECEBIDOS */
      "finance.difference-analysis": function () {
        return true;
      },
      /** FINANCE CARNÊS */
      "finance.payment-book": function () {
        return true;
      },
      /** FINANCE COBRANÇA */
      "finance.bankcharges": function () {
        return true;
      },
      /** FINANCE BOLETOS */
      "finance.bankcharges.bankslip": function () {
        return true;
      },
      /** FINANCE NOTAS FISCAIS */
      "finance.nfse": function () {
        return true;
      },
      /** FINANCE NOTAS FISCAIS */
      "finance.daily-balance": function () {
        return true;
      },
      /** FINANCE NOTAS FISCAIS */
      "finance.reports": function () {
        return true;
      },
      /** FINANCE NOTAS FISCAIS */
      "finance.settings": function () {
        return true;
      },
      /** FINANCE NOTAS FISCAIS */
      "finance.cashier-session": function () {
        return true;
      },
      /** FINANCE NOTAS FISCAIS */
      "stock.stocklist": function () {
        return true;
      },
      /** FINANCE NOTAS FISCAIS */
      "finance.contract": function () {
        return true;
      },
      /** AVALIAÇÕES CONHECIMENTO */
      "knowledge.knowledge-config": function () {
        return true;
      },
      /** AVALIAÇÕES QUESTIONÁRIOS */
      "questionnaire.questionnaires-config": function () {
        return true;
      },
      /** SOLICITAÇÕES LISTA */
      "process.process-to-solve": function () {
        return true;
      },
      /** SOLICITAÇÕES RECURSOS TECNOLÓGICOS */
      "process.technology-resources": function () {
        return true;
      },
      /** SOLICITAÇÔES MARIAL ESCOLAR */
      "process.school-supplies": function () {
        return true;
      },
      /** SOLICITAÇÔES PERMISSÕES */
      "process.process-person": function () {
        return true;
      },
      /** SOLICITAÇÔES LOCAIS */
      "process.location": function () {
        return true;
      }
    }

  }

  angular
    .module('app.policies')
    .factory('MenuPolicies', MenuPolicies);

})();

(function () {
  'use strict';

  /** @ngInject */
  function Session($document, moment, LocalStorage, CONFIG) {

    var vm = {};
    vm.user = null;
    vm.current_company = null;
    vm.current_student = null;
    vm.current_school_period = null;
    vm.token = null;
    vm.roles = null;
    vm.context = null;
    vm.is_blocked = false;
    vm.profile = null;
    vm.has_app_finance = true;
    vm.has_app_educational = true;
    vm.timezone = moment.tz.guess();

    vm.isLabs = function () {
      return $document[0].domain.split('.')[0] === 'labs';
    };
    /**
     * Criação de uma nova sessão
     * @param user - Usuário
     * @param token - Token de connexão
     * @param roles - permissões de usuário
     */
    vm.create = function (user, token, roles) {
      moment.tz.setDefault(vm.timezone);
      moment.locale('pt-br');
      vm.user = user;
      vm.token = token;
      vm.roles = roles;
      vm.companies = roles;
      vm.current_company = user.current_company;
      vm.current_student = user.current_student;
      vm.current_school_period = null;
      // return;
      if (angular.isDefined(roles)) {
        roles.forEach(function (item) {
          if (item.id === vm.current_company) {
            vm.current_school_period = item.school_period_default;
          }
        });
      } else if (user.current_school_period !== null) {
        vm.current_school_period = user.current_school_period.id;
      }
      vm.context = user.am_i;
      LocalStorage.add('day_close_block_message', null);
      LocalStorage.add(CONFIG.storage.user, user);
      LocalStorage.add(CONFIG.storage.token, token);
      LocalStorage.add(CONFIG.storage.roles, roles);
      LocalStorage.add(CONFIG.storage.context, user.am_i);
      LocalStorage.add(CONFIG.storage.current_company, vm.current_company, 'sessionStorage');
      LocalStorage.add(CONFIG.storage.current_school_period, vm.current_school_period, 'sessionStorage');
      LocalStorage.add(CONFIG.storage.current_student, user.current_student);
      LocalStorage.add(CONFIG.storage.has_app_finance, user.has_app_finance);
      LocalStorage.add(CONFIG.storage.has_app_educational, vm.has_app_educational);
      LocalStorage.add(CONFIG.storage.days_to_block, user.days_to_block);
      LocalStorage.add(CONFIG.storage.last_date_before_block, user.last_date_before_block);
      LocalStorage.add(CONFIG.storage.system_setup, user.system_setup);
      LocalStorage.add(CONFIG.storage.is_blocked, vm.is_blocked);
      LocalStorage.add(CONFIG.storage.profile, vm.profile);
      LocalStorage.add(CONFIG.storage.companies, vm.companies);

    };

    vm.setLabsUser = function (email, pass) {
      vm.labs_user = email;
      vm.labs_pass = pass;
      LocalStorage.add(CONFIG.storage.labs.user, email);
      LocalStorage.add(CONFIG.storage.labs.pass, pass);
    };

    vm.getLabsUser = function () {
      return vm.labs_user;
    };

    vm.getLabsPass = function () {
      return vm.labs_pass;
    };

    /**
     * Destruição da sessão completa
     */
    vm.destroy = function () {
      vm.user = null;
      vm.token = null;
      vm.roles = null;
      vm.labs_user = null;
      vm.labs_pass = null;
      vm.is_blocked = null;
      vm.current_company = null;
      vm.current_school_period = null;
      vm.companies = null;
      vm.current_student = null;
      vm.system_setup = null;
      vm.profile = null;
      LocalStorage.removeAll();
    };

    /**
     * Executa a restauração das variáveis de sessão
     */
    vm.restore = function () {
      vm.user = LocalStorage.get(CONFIG.storage.user);
      vm.labs_user = LocalStorage.get(CONFIG.storage.labs.user);
      vm.labs_pass = LocalStorage.get(CONFIG.storage.labs.pass);
      vm.token = LocalStorage.get(CONFIG.storage.token);
      vm.roles = LocalStorage.get(CONFIG.storage.roles);
      vm.context = LocalStorage.get(CONFIG.storage.context);
      vm.current_company = LocalStorage.get(CONFIG.storage.current_company, 'sessionStorage');
      vm.school_period_default = LocalStorage.get(CONFIG.storage.school_period_default, 'sessionStorage');
      vm.current_school_period = LocalStorage.get(CONFIG.storage.current_school_period, 'sessionStorage');
      vm.companies = LocalStorage.get(CONFIG.storage.companies);
      vm.current_student = LocalStorage.get(CONFIG.storage.current_student);
      vm.system_setup = LocalStorage.get(CONFIG.storage.system_setup);
      vm.is_blocked = LocalStorage.get(CONFIG.storage.is_blocked);
      vm.profile = LocalStorage.get(CONFIG.storage.profile);
      vm.has_app_educational = LocalStorage.get(CONFIG.storage.has_app_educational);
      vm.has_app_finance = LocalStorage.get(CONFIG.storage.has_app_finance);
      vm.days_to_block = LocalStorage.get(CONFIG.storage.days_to_block);
      vm.last_date_before_block = LocalStorage.get(CONFIG.storage.last_date_before_block);
      // console.log(vm.school_period_default + '============');
      // console.log(vm.current_school_period + '-----------------');
      return true;
    };

    /**
     * Verifica a autenticação do usuário
     * @returns {boolean}
     */
    vm.isAuthenticated = function () {
      return !!(vm.user && vm.token);
    };

    /**
     * Retorna o valor de bloqueado ou não
     * @returns {boolean|null|*}
     */
    vm.getCurrentCompany = function () {
      return vm.current_company;
    };

    /**
     * Retorna o valor de bloqueado ou não
     * @returns {boolean|null|*}
     */
    vm.getCurrentSchoolPeriod = function () {
      return vm.current_school_period;
    };

    /**
     * Retorna school_period padrão
     * @returns {*}
     */
    vm.getSchoolPeriodDefault = function () {
      if (angular.isDefined(vm.school_period_default) && vm.school_period_default !== null) {
        return vm.school_period_default;
      } else {
        var school_period_default = null;
        vm.companies.forEach(function (item) {
          if (item.id === vm.current_company){
            school_period_default = item.school_period_default;
          }
        });
        return school_period_default;
      }
    };

    /**
     * Retorna o valor de bloqueado ou não
     * @returns {boolean|null|*}
     */
    vm.getIsBlocked = function () {
      return vm.is_blocked || null;
    };

    /**
     * Retorna objeto salvo no localstorage a partir da chave
     * @param index - Chave no local storage
     */
    vm.get = function (index, type) {
      type = angular.isDefined(type) ? type : 'localStorage';
      return LocalStorage.get(index, type);
    };

    /**
     * Retorna objeto salvo no localstorage a partir da chave
     * @param index - Chave no local storage
     * @param value - Valor a ser inserido na sessão
     * @param type - se é par o valor ser salvo no sessionStorage (aba)
     */
    vm.set = function (index, value, type) {
      // if (angular.isDefined(toSessionStorage) && toSessionStorage) {
      //   LocalStorage.add(index, value, "sessionStorage");
      // } else {
      type = angular.isDefined(type) ? type : 'localStorage';
      LocalStorage.add(index, value, type);
      // }
      return vm.restore();
    };

    /**
     * Retorna todas as regras de um usuários
     * @returns {null|*}
     */
    vm.getContext = function () {
      return vm.context || null;
    };

    /**
     * Retorna todas as empresas disponíveis ao usuário
     * @returns {*|null}
     */
    vm.getCompanies = function () {
      return vm.companies || null;
    };

    /**
     * Retorna todas as regras de um usuários
     * @returns {null|*}
     */
    vm.getUser = function () {
      return vm.user || null;
    };
    /**
     * Retorna todas as regras de um usuários
     * @returns {null|*}
     */
    vm.getRoles = function () {
      return vm.roles || null;
    };

    /**
     * Retorna o perfil selecionado
     * @returns {null|*}
     */
    vm.getProfile = function () {
      return angular.isDefined(vm.profile) ? vm.profile : null;
    };

    /**
     * Retorna o perfil selecionado
     * @returns {null|*}
     */
    vm.getCurrentProfile = function () {
      return angular.isDefined(vm.profile) ? vm.profile : null;
    };

    vm.restore();
    return vm;


  }

  angular.module('app.login')
    .factory('Session', Session);

})();

(function () {
  'use strict';

  /** @ngInject */
  function RecoveryWarningController($rootScope, $state, LoginService, ModalExtra) {
    var vm = this;

    vm.init = function () {
      vm.user = ModalExtra;
    };

    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();

  }

  angular
    .module('app.login')
    .controller('RecoveryWarningController', RecoveryWarningController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function LoginService($q, CONFIG, Restangular, RestangularToken, Session, LocalStorage) {
    var vm = {};

    /**
     * Refresh token
     * @param refreshToken
     */
    vm.refreshToken = function (refreshToken) {
      return Restangular.all('token').post(
        [
          'grant_type=refresh_token',
          'refresh_token=' + refreshToken,
          'client_id=' + CONFIG.clientId,
          'client_secret=' + CONFIG.clientSecret
        ].join('&'), {}, {'Content-Type': 'application/x-www-form-urlencoded'});
    };

    /**
     * verifica se a conta é migrada ou não
     */
    vm.askRecoveryAccount = function (params) {
      return Restangular.one('login').all('verify').post(params);
    };

    /**
     * verifica se a conta é migrada ou não
     */
    vm.getAvailableDatabase = function (obj) {
      return Restangular.one('databases').one('available').get(obj);
    };

    /**
     * verifica se a conta é migrada ou não
     */
    vm.executeReDatabase = function (obj) {
      return Restangular.one('databases').all('execute').post(obj);
    };

    vm.getLoginType = function () {
      return Restangular.one('login').one('getlogintype').get();
    };

    /**
     * Realiza o login
     * @param obj
     */
    vm.doLogin = function (obj) {
      var deferred = $q.defer();

      if (Session.isLabs()) {
        var user = obj.user.usermail.split('>');
        var userSupport = user[0];
        obj.user.usermail = user[1];
        Session.setLabsUser(userSupport, obj.user.password);
      }

      var params = {
        grant_type: "password", client_id: CONFIG.clientId,
        client_secret: CONFIG.clientSecret, username: obj.user.usermail,
        password: obj.user.password, scope: '*', resolution: obj.resolution
      };

      // Adiciona o token se fornecido
      if (obj.user.supportToken) {
        params.supportToken = obj.user.supportToken;
      }

      RestangularToken.one('oauth/token').customPOST(params)
        .then(function (response) {
          var accessObj = {
            token_type: response.token_type,
            access_token: response.access_token,
            refresh_token: response.refresh_token,
            expires_in: response.expires_in
          };

          var key = JSON.stringify(accessObj);
          Session.set(CONFIG.storage.current_company, null, "sessionStorage");
          Restangular.all('login/auth').post(obj)
            .then(function (response) {
              Session.create(response.user, key, response.user.roles);
              LocalStorage.add('idle_minutes_to_block', response.user.idle_minutes_to_block);
              deferred.resolve(response);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
        })
        .catch(function (response) {
          deferred.reject(response);
        });
      return deferred.promise;
    };

    vm.doLogout = function () {
      return Restangular.one('/logout', LocalStorage.get('sys_session_id')).get();
    };

    vm.getLogo = function (subdomain) {
      return RestangularToken.one('login').one('schoolimage', subdomain).get();
    };

    /** Email para trocar a senha */
    vm.sendChangePassword = function (obj) {
      return Restangular.one('register').all('sendchangepassword').post(obj);
    };

    /** Troca a senha de usuário */
    vm.changePassword = function (obj) {
      return Restangular.one('register').all('changepassword').post(obj);
    };

    /** Verifica a validade do link do usuário */
    vm.checkData = function (obj) {
      return Restangular.one('register').all('checkdatachangepassword').post(obj);
    };

    vm.getDaysToBlock = function () {
      return Restangular.one('config').one('getdaysblock').get();
    };

    vm.getCompanys = function () {
      return Restangular.one('get-company-external').get();
    }
    return vm;
  }

  angular.module('app.login')
    .factory('LoginService', LoginService);


})();

(function () {
  'use strict';

  /** @ngInject */
  function run($rootScope, $state, AUTH_EVENTS, Common, CONFIG, Session, PoliciesService) {

    var lstnrClb2 = $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
      Session.destroy();
      Common.Toast.error('Sessão encerrada.');
      $state.go('public.login');
    });

    /**
     * Retorna todas as rotas publicas
     * @returns {Array}
     */
    var getPublicRoutes = function () {
      var routes = $state.get();
      var newRoutes = [];

      for (var key in routes) {
        if (routes[key].public) {
          newRoutes.push(routes[key].name);
        }
      }
      return newRoutes;
    };

    /**
     * Verifica as trocas de rota.
     * @type {any}
     */
    var lstnrClb3 = $rootScope.$on('$stateChangeStart', function (event, next, toParams, fromState) {
      if (next.name === 'public.login' || fromState.name === 'public.login') {
        if (Session.getUser()) {
          /** Caso seja um estudante acessando o sistema */
          if (Session.getCurrentProfile() === CONFIG.profile.student) {
            $state.go('private.educational.dashboard.students', null, {
              notify: false,
              id: Session.getUser().id
            }).then(function () {
              $rootScope.$broadcast('$stateChangeSuccess',
                'private.educational.dashboard.students', {id: Session.getUser().id}, '/', null);
            });
            event.preventDefault();
            return;
            /** Caso seja um responsável ou professor acessando o sistema */
          } else if (
            Session.getCurrentProfile() === CONFIG.profile.parent ||
            Session.getCurrentProfile() === CONFIG.profile.teacher) {

            $state.go('private.educational.dashboard', null, {notify: false}).then(function () {
              $rootScope.$broadcast('$stateChangeSuccess',
                'private.educational.dashboard', null, '/', null);
            });

            event.preventDefault();
            return;
            /** Caso seja um colaborador ou coordenador acessando o sistema */
          } else {

            /** Se tiver acesso ao educacional e financeiro */
            $state.go('private.controlpanel.dashboard', null, {notify: false}).then(function () {
              $rootScope.$broadcast('$stateChangeSuccess',
                'private.controlpanel.dashboard', null, '/', null);
            });

            event.preventDefault();
            return;
            // if (PoliciesService.checkPolicyFromMenu('financeiro') && PoliciesService.checkPolicyFromMenu('educational')) {
            //   $state.go('private.controlpanel.dashboard', null, {notify: false}).then(function () {
            //     $rootScope.$broadcast('$stateChangeSuccess',
            //       'private.controlpanel.dashboard', null, '/', null);
            //   });
            // } else
            // /** Se tiver acesso ao educacional */
            // if (PoliciesService.checkPolicyFromMenu('educational')) {
            //   $state.go('private.educational.dashboard', null, {notify: false}).then(function () {
            //     $rootScope.$broadcast('$stateChangeSuccess',
            //       'private.educational.dashboard', null, '/', null);
            //   });
            // } else
            // /** Se tiver acesso ao financeiro */
            // if (PoliciesService.checkPolicyFromMenu('financeiro')) {
            //   $state.go('private.finance.dashboard', null, {notify: false}).then(function () {
            //     $rootScope.$broadcast('$stateChangeSuccess',
            //       'private.finance.dashboard', null, '/', null);
            //   });
            // }
            //
            // event.preventDefault();
            // return;
          }
        }
      }

      // if (next.name !== 'public.login' || fromState.name !== 'public.login') {
      //   if (Session.getIsBlocked()) {
      //     $state.go('private.lockscreen');
      //     event.preventDefault();
      //     return;
      //   }
      // }

      /**
       * Caso seja uma rota publica então passa
       */
      if (getPublicRoutes().indexOf(next.name) > -1) return;

      /**
       * A cada troca de rota verifica se o usuário está autenticado
       */
      PoliciesService.checkPolicy(next.auth)
        .catch(function () {
          /**
           * Se não estiver autenticado, ele derruba a sessão
           * Se estiver autenticado e não puder acessar a rota, então, volta para a que o
           * usuário estava
           */
          if (!Session.isAuthenticated()) {
            $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
          } else {
            // if (fromState.name !== '') {
            //   $state.go(fromState.name)
            // }
          }
          event.preventDefault();
        });
    });

    $rootScope.$on('$destroy', function () {
      [lstnrClb2, lstnrClb3].forEach(function (fn) {
        fn();
      });
    });
  }

  angular
    .module('app.login')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('public.login', {
        url: '/login',
        public: true,
        controller: 'LoginController',
        controllerAs: 'vm',
        templateUrl: 'app/login/views/login.html'

      })
      .state('public.forgot', {
        url: '/forgotpassword/:email',
        public: true,
        controller: 'ForgotPasswordController',
        controllerAs: 'vm',
        templateUrl: 'app/login/views/forgot.html'
      })
      .state('public.changepassword', {
        url: '/changepassword/:base64',
        public: true,
        controller: 'ChangePasswordController',
        controllerAs: 'vm',
        templateUrl: 'app/login/views/change-password.html'
      });

  }

  angular
    .module('app.login')
    .config(routerConfig);

})();

(function () {
  'use strict';

  /** @ngInject */
  function Login($document, $rootScope, $filter, $state,
                 ModalFactory, LoginService, Common, Session, RolesService,
                 CONFIG, $timeout, $window, LocalStorage) {
    var vm = this;
    vm.screen_image = "";
    vm.access_token = "";
    vm.token_type = "";
    vm.refresh_token = "";
    vm.expires_in = "";
    vm.determinateValue = 30;
    vm.loginProcess = false;
    vm.latitude = undefined;
    vm.longitude = undefined;
    vm.is_labs = false;
    vm.showSupportTokenField = false;
    vm.url_background = 'url(../assets/images/backgrounds/' + new Date().toLocaleString('en-US', {'month': 'long'}).toLowerCase() + '.jpg)  no-repeat';
    vm.connection = new URL($window.location.href).hostname.split('.')[0];

    vm.init = function () {
      vm.getLogo();
      vm.is_labs = Session.isLabs();
      /** TODO Fazer requisição de subdominio para tela customizada. */
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          vm.latitude = position.coords.latitude;
          vm.longitude = position.coords.longitude;
        })
      }

      vm.route = vm.connection === 'raiodesol' ? 'public.raiodesolregister' : 'public.register';
      vm.login_placeholder = vm.connection === 'raiodesol' ? 'cpf ou Matrícula' : 'Email'
    };

    /**
     * Realiza Log In no sistema
     * @param auth
     */
    vm.login = function (auth) {
      if (auth) {

        var resolution = {width: screen.width, height: screen.height};
        var user = {resolution: resolution, latitude: vm.latitude, longitude: vm.longitude, user: auth};
        /** se a conta for migrada com status 11 então pedirá a recuperação da senha*/
        vm.loginProcess = true;
            LoginService.doLogin(user)
              .then(function (res) {
                LocalStorage.add('sys_session_id', res.user.sys_login.original[0].id);
                Session.set('is_blocked', false, "sessionStorage");
                LocalStorage.add('is_blocked', false);
                vm.company_roles = res.user.company_roles;
                $rootScope.days_to_block = res.user.days_to_block;
                if (res.user.days_to_block !== null && res.user.days_to_block < 0) {
                  Session.destroy();
                  vm.loginProcess = false;
                  Common.Toast.error('Sistema bloqueado, por favor, entre em contato com o suporte.');
                }
                if (!res.user.can_access) {
                  Session.destroy();
                  vm.loginProcess = false;
                  Common.Toast.error($filter('translate')('invalid_enrollment'));
                } else if (res.result) {
                  $rootScope.$broadcast('msSplashScreen::active');
                  vm.verifyProfile(Session.getContext(), vm.company_roles);
                }
              })
              .catch(function (err) {
                vm.loginProcess = false;
                switch (err.status) {
                  case 310:
                    vm.showSupportTokenField = true;
                    Common.Toast.info('Digite o token de autenticação para continuar');
                    break;
                  case 404:
                    Common.Toast.error('Usuário não encontrado');
                    break;
                  case 406:
                    Common.Toast.error($filter('translate')(err.data.message));
                    break;
                  case 408:
                    Common.Toast.error($filter('translate')(err.data.message));
                    break;
                  case 401:
                    if (err.data.message === 'SYSTEM_BLOCK') {
                      ModalFactory.open('block-access', null, null, null, null, 'controlpanel')
                        .catch(function () {
                          $window.location.reload();
                        });
                    } else {
                      Common.Toast.error('Ops!, Senha ou E-mail incorretos');
                    }
                    break;
                  default:
                    Common.Toast.error($filter('translate')(err.data.message));
                    break;
                }
              });
      }
    };

    /**
     * Retorna a logo da Escola
     */
    vm.getLogo = function () {
      var subdomain = $document[0].domain.split('.')[0];
      LoginService.getLogo(subdomain)
        .then(function (response) {
          vm.screen_image = response.image;
        })
    };

    /**
     * Envia para o ambiente do educacional
     */
    vm.goToEnvironment = function (sys_user_role_id) {
      var user = Session.getUser();
      RolesService.getUserRoleModule(user.id, sys_user_role_id)
        .then(function (response) {
          Session.set(CONFIG.storage.roles, response.roles);
          LocalStorage.add(CONFIG.storage.companies, response.companies);
          if (response.companies.length === 1) {
            Session.set(CONFIG.storage.current_company, response.companies[0].id, "sessionStorage");
          }
          /*LocalStorage.add(CONFIG.storage.school_period_default, response.school_period_default);*/
          Session.set(CONFIG.storage.current_school_period, response.school_period_default, "sessionStorage");
          Session.set(CONFIG.storage.school_period_default, response.school_period_default, "sessionStorage");
          $timeout(function () {
            $state.go('private.controlpanel.dashboard');
            $window.location.reload();
          }, 300);
        })
        .catch(function (error) {
          Common.Toast.error(error.data.message)
        });
    };

    /**
     * Permite selecionar os perfis disponíveis
     * @param profiles
     */
    vm.verifyProfile = function (profiles, company_roles) {
      /** Se houver mais que uma opção abre o modal para a escolha */
      if (profiles.user_profiles > 1) {
        vm.switchProfile(profiles, company_roles);
      } else {
        Session.set(CONFIG.storage.profile, vm.defineProfile(profiles));
        if (profiles.is_responsible !== null || profiles.is_payee !== null) {
          Session.set(CONFIG.storage.is_responsible, true);
        } else {
          Session.set(CONFIG.storage.is_responsible, false);
        }
        vm.goToEnvironment(vm.defineProfile(profiles));
      }
    };

    /**
     * Retorna os bancos de dados labs;
     */
    vm.labsDatabase = function () {
      ModalFactory.customClean(
        'app/login/labscontrol/labs-database-modal.html',
        'LabsDatabase',
        'vm', false, []
      );
    };

    /**
     * Abre o modal para a escolha de perfil para exibição do sistema
     */
    vm.switchProfile = function (profiles, company_roles) {
      ModalFactory.customClean(
        'app/controlpanel/switch-profile.html',
        'SwitchProfileControlPanel',
        'vm', false, {profiles: profiles, company_roles: company_roles}
      );
    };

    vm.defineProfile = function (profile) {
      if (profile.is_employee === 2 || profile.is_employee === 3) {
        return 7;
      } else if (profile.is_student === 1) {
        return 1;
      } else if (profile.is_responsible === 1 || profile.is_payee === 1) {
        return 2;
      } else if (profile.is_coordinator !== null) {
        return 4;
      } else if (profile.is_employee === 1 || profile.roles_id !== null) {
        return 0;
      } else if (profile.is_supplier !== null) {
        return 200;
      }
    };

    vm.init();

  }

  angular
    .module('app.login')
    .controller('LoginController', Login);
})();

(function () {
  'use strict';

  /** @ngInject */
  function ForgotPasswordController($rootScope, $state, $stateParams, LoginService, ModalFactory, Common) {
    var vm = this;
    vm.form = {};
    vm.in_process = false;
    vm.init = function () {
      vm.form.email = $stateParams.email;
    };

    /**
     * Realiza o pedido de troca de senha
     * @param item
     */
    vm.changePassword = function (item) {
      vm.in_process = true;
      LoginService.sendChangePassword(item)
        .then(function () {
          vm.in_process = false;
          ModalFactory.alert(
            "Atenção", "Um e-mail lhe foi enviado para que possa prosseguir com a ação de troca de senha",
            "modal", "Ok", "false", "controlpanel"
          );
          $state.go('public.login');
        })
        .catch(function (warning) {
          vm.in_process = false;
          if (angular.isObject(warning.data)) {
            angular.forEach(warning.data, function (value) {
              //console.log(value)
              switch (value) {
                case 'USER_NOT_FOUND':
                  Common.Toast.error('Usuário não encontrado');
                  break;
                case 'INACTIVE_USER':
                  Common.Toast.error('Não é possível atualizar senha de usuários inativos');
                  break;
                case 'BLOCKED_USER':
                  Common.Toast.error('Não é possível atualizar senha de usuários bloqueados');
                  break;
              }
            })
          } else {
            Common.Toast.error('Falha ao finalizar a solicitação');
          }
        })
    };

    vm.init();

  }

  angular
    .module('app.login')
    .controller('ForgotPasswordController', ForgotPasswordController);
})();

(function () {
  'use strict';

  /** @ngInject */
  function ChangePasswordController($rootScope, $state, LoginService, Common, Session) {
    var vm = this;
    vm.form = {};
    vm.in_process = false;
    vm.user = Session.getUser();

    vm.init = function () {
      if ($state.params.base64 !== '') {
        vm.checkData($state.params.base64);
      } 
      else {
        vm.form.email = vm.user.email
      }
    };

    /**
     * Verifica a validade do link do usuário
     * @param token
     */
    vm.checkData = function (token) {
      LoginService.checkData({token: token})
        .then(function (response) {
          vm.form.email = response.email;
          vm.form.token = token;
        })
        .catch(function (response) {
          Common.Toast.error(response.data);
          $state.go('public.login');
        });
    };

    /**
     * Submissão dos dados para a troca de senha
     * @param item
     */
    vm.submit = function (item) {
      vm.in_process = true;
      if (item.password !== item.password_confirm) {
        Common.Toast.warning('Senhas precisam ser iguais');
        vm.in_process = false;
        return;
      }
      LoginService.changePassword(item)
        .then(function () {
          vm.in_process = false;
          Common.Toast.success('Senha alterada com sucesso');
          $state.go('public.login');
        })
        .catch(function (response) {
          vm.in_process = false;
          Common.Toast.error(response.data.message);
        })
    };

    vm.init();

  }

  angular
    .module('app.login')
    .controller('ChangePasswordController', ChangePasswordController);
})();

(function() {
  'use strict';

  var AUTH_EVENTS = {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    sessionTimeout: 'auth-session-timeout',
    notAuthenticated: 'auth-not-authenticated',
    notAuthorized: 'auth-not-authorized',
    alreadyAuthenticated: 'already-authenticated',
    sessionBlocked: 'session-blocked'
  };

  angular
    .module('app.login')
    .constant('AUTH_EVENTS', AUTH_EVENTS);

})();


(function () {
  'use strict';
  /** @ngInject*/
  function LogService(Restangular) {
    var self = {};

    self.setDataPerPage = function (obj) {
      return Restangular.one("log").get(obj);
    };

    self.getById = function (id) {
      return Restangular.one("log", id).get();
    };

    self.sendSearch = function (search) {
      return Restangular.one("log/search").customGET('', {search: search});
    };

    self.getInfoButtons = function () {
      return Restangular.one("log").customGET('', {info: true});
    };

    self.getAllFinanceResouces = function (obj) {
      return Restangular.one('usergroup').one('getfinanceresources').get(obj);
    };

    self.getSysSession = function (obj) {
      return Restangular.one("log").one('getsyssession').get(obj);
    };

    return self;

  }

  angular.module('app.log')
    .factory('LogService', LogService);

})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.log', {
        url: '/log',
        public: false,
        views: {
          '': {
            templateUrl: 'app/log/views/index.html',
            controller: 'LogController',
            controllerAs: 'vm'
          },
          'syslogin@private.finance.log': {
            templateUrl: 'app/log/views/syslogin.html',
            controller: 'LogController',
            controllerAs: 'vm'
          }
        }

      });
  }

  angular
    .module('app.log')
    .config(routerConfig);


})();

(function () {
  'use strict';

  /** @ngInject*/
  function LogController($rootScope, LogService, $scope, RolesService, a4Moment, ModalFactory, Common, ReportsService) {
    var vm = this;

    vm.logData = [];
    vm.buttons = [];
    vm.search = '';
    vm.query = {
      order: 'login_timestamp',
      limit: 10,
      page: 1
    };

    vm.filter_date = {
      startDate: null,
      endDate: null
    };
    vm.selected_operations = null;
    vm.selected_users = [];
    vm.selected_specific_modules = [];
    vm.filter_names = '';
    vm.sysSession = [];
    vm.person_ids = [];

    var ltn1 = $scope.$watch('vm.selected_operations', function (newer) {
      if (newer !== 'null' && newer !== null) {
        vm.selected_specific_modules = [];
        vm.getResourcesByModule(newer);
      }
    });

    var ltn2 = $scope.$watch('vm.selected_specific_modules', function (newer) {
      if (angular.isDefined(newer)) {
        vm.filter_names = newer.join(',');
      }
    });

    vm.init = function () {
      $rootScope.show_loader = true;
      vm.setDataPerPage(vm.query.page);
      vm.allData = vm.sendSearch();
      // vm.getAllUsers();
      vm.getAllLogUsers();
      vm.getSys();
      vm.getAllResources();
    };

    vm.setDataPerPage = function (page, paginate) {
      if (angular.isUndefined(paginate)) {
        paginate = vm.query.limit;
      }

      if (vm.filter_names.length <= 0 && vm.selected_operations !== null && vm.selected_operations !== 'null') {
        Common.Toast.warning("Módulo selecionado, escolha pelo menos uma operação");
        return;
      }

      var users = vm.selected_users.map(function (user) {
        return user.id;
      });
      if (angular.isDefined(users)) {
        users = users.join(',');
      }

      var obj = {
        page: page,
        paginate: paginate,
        startDate: vm.filter_date.startDate,
        endDate: vm.filter_date.endDate,
        operations: vm.selected_operations,
        users: users,
        filter_names: vm.filter_names
      };
      /**
       * Retorna as informações do activity_log
       */
      LogService.setDataPerPage(obj)
        .then(function (request) {
          vm.logData = request.data;
          vm.query = {
            limit_options: [10, 20, 50],
            limit: paginate,
            page: page,
            total: request.total
          };
          vm.logData.forEach(function (t) {
            t.timestamp = a4Moment(t.timestamp).format('DD/MM/YYYY HH:mm:ss');
          });
          angular.element('[name=udt-toolbar-pagination]').remove();
          angular.element('[name=udt-toolbar-results]').remove();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    /**
     * Retorna as informações do sys_session
     */
    vm.getSys = function (page, qty) {


      var users = vm.selected_users.map(function (user) {
        return user.id;
      });
      if (angular.isDefined(users)) {
        users = users.join(',');
      }

      var obj = {
        page: page,
        paginate: qty,
        startDate: vm.filter_date.startDate,
        endDate: vm.filter_date.endDate,
        users: users,
        filter_names: vm.filter_names
      };

      LogService.getSysSession(obj)
        .then(function (request) {
          vm.sysSession = request.data;
          vm.query = {
            limit_options: [10, 20, 50],
            limit: paginate,
            page: page,
            total: request.total
          };
        });
    };


    /**
     * Retorna a árvore de recursos do financeiro
     */
    vm.getAllResources = function () {
      LogService.getAllFinanceResouces()
        .then(function (response) {
          vm.operations_filter = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.getResourcesByModule = function (module) {
      LogService.getAllFinanceResouces({module: module})
        .then(function (response) {
          vm.module_specific_filter = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        })
    };

    vm.sendSearch = function (search) {
      LogService.sendSearch(search)
        .then(function (request) {
          if (angular.isUndefined(search)) {
            vm.allData = request.data
          } else {
            vm.logData = request.data;
          }
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    vm.openDetails = function (item) {
      LogService.getById(item.id)
        .then(function (response) {
          var data = response.plain();
          data.properties = angular.fromJson(data.properties);
          ModalFactory.custom('app/log/views/details.html', data, true);
          $rootScope.show_loader = false;
        });
    };

    vm.openSysDetails = function (item) {
      console.log(item);
      ModalFactory.custom('app/log/views/sysdetail.html', item, true);
      $rootScope.show_loader = false;
    };

    vm.printSysLogin = function () {
      vm.selected_users.forEach(function (item) {
        vm.person_ids.push(item.id)
      });
      ReportsService.reportFactory('GET', 'api/reports/printsyssession',
        {
          users: vm.person_ids.join(','),
          start_date: vm.filter_date.startDate,
          end_date: vm.filter_date.endDate,
          limit: vm.query.limit
        }).then(function () {
        vm.person_ids = [];
      })
    };

    /**
     * Retorna todos os usuários disponíveis
     */
    vm.getAllUsers = function () {
      RolesService.getAllUsers()
        .then(function (response) {
          vm.users_filter = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error("Erro ao listar usuários.", 'A4 Web');
          $rootScope.show_loader = false;
        })
    };

    vm.getAllLogUsers = function () {
      RolesService.getAllLogUsers()
        .then(function (response) {
          vm.users_filter = response.plain();
          $rootScope.show_loader = false;
        })
        .catch(function () {
          Common.Toast.error("Erro ao listar usuários.", 'A4 Web');
          $rootScope.show_loader = false;
        })
    };

    vm.init();

    var ltn3 = $scope.$watch('vm.search', function (newer) {
      if (newer !== '' && newer != null) {
        vm.sendSearch(newer);
      } else {
        vm.init();
      }
    });

    $scope.$on('$destroy', function () {
      // vm.floatButton.destroy(vm.floatButton.options.scope.$id);
      [ltn1, ltn2, ltn3].forEach(function (t) {
        t();
      })
    });
  }

  angular
    .module('app.log')
    .controller('LogController', LogController);
})();

(function () {
  'use strict';
  angular
    .module('app.lock', []);
})();

(function () {
  'use strict';
  
  /** @ngInject */
  function LockService(Common, LocalStorage, Restangular, Session, $state) {

    var vm = this;
    vm.lockSystem = function () {
      console.log();
      var deferred = Common.$q.defer();
      vm.email = Session.user.email;
      Restangular.one('lockandunlock').customPOST({email: vm.email, lock: 1})
        .then(function () {
          LocalStorage.add('is_blocked', true);
          $state.go('private.lockscreen');
          Session.set('is_blocked', true, "sessionStorage");
          deferred.resolve(true);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };
  
    vm.unlockSystem = function (user) {
      var deferred = Common.$q.defer();
      Restangular.one('lockandunlock').customPOST({user: user, lock: 0})
        .then(function () {
          LocalStorage.add('is_blocked', false);
          Session.set('is_blocked', false, "sessionStorage");
          deferred.resolve(true);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };
    
    
    return {
      lockSystem: vm.lockSystem,
      unlockSystem: vm.unlockSystem
    }
  }
  
  angular
    .module('app.lock')
    .factory('LockService', LockService);
  
})();

(function () {
  'use strict';
  
  /** @ngInject */
  function routerConfig($stateProvider) {
    
    $stateProvider
      .state('private.lockscreen', {
        url: '/locked',
        controller: 'LockController',
        controllerAs: 'vm',
        templateUrl: 'app/lock/lock.html'
      });
  }
  
  angular
    .module('app.lock')
    .config(routerConfig);
  
})();





(function () {
  'use strict';

  /** @ngInject */
  function LockController($state, Common, LocalStorage, LockService, LoginService, Session, $rootScope, a4IdleMinutesToBlock) {
    var vm = this;


    vm.init = function () {
      a4IdleMinutesToBlock.stopMonitoring();
      if (angular.isDefined(LocalStorage.get('user'))) {
        vm.user = {
          name: LocalStorage.get('user').person.name,
          image: '/assets/images/avatars/profile.jpg'
        };
        vm.form = {
          usermail: Session.user.email
        }
      }
    };

    vm.unLockSystem = function (data) {
      LockService.unlockSystem(data)
        .then(function () {
          a4IdleMinutesToBlock.startMonitoring();
          // $state.go('private.controlpanel.dashboard');
          $rootScope.go_to_previous_state();
        })
        .catch(function () {
          Common.Toast.error('Desculpe, senha incorreta!');
        });
    };

    vm.logout = function () {
      if(angular.isDefined(LocalStorage.get('sys_session_id'))) {
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }else {
        LocalStorage.add('sys_session_id', 0)
            LoginService.doLogout(LocalStorage.get('sys_session_id'))
              .then(function () {
                Session.destroy();
                $state.go('public.login');
                $rootScope.show_loader = false;
              })
              .catch(function () {
                $rootScope.show_loader = false;
              });
      }
    };


    vm.init();

  }

  angular
    .module('app.lock')
    .controller('LockController', LockController);

})();

(function () {
  'use strict';
  /** @ngInject*/
  function FMDService(Restangular) {

    var self = {};

    self.sendFile = function (file) {
      return Restangular.all("fmd").post(file);
     // return Restangular.one("fmd").customPOST(file);
    };


    return self;
  }

  angular.module('app.fmd')
    .factory('FMDService', FMDService);
})();
(function() {
  'use strict';


  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance.fmd', {
        url: '/fmd',
        public: false,
        templateUrl: 'app/fmd/views/index.html',
        controller: 'FMDController',
        controllerAs: 'vm'
      });
  }

  angular
    .module('app.fmd')
    .config(routerConfig);


})();

(function () {
  'use strict';

  function fileRead() {
    return {
      required: ["ngModel"],
      scope: {ngModel: "=", applyFunction: "&?"},
      link: function (scope, element) {
        element.bind("change", function (changeEvent) {
          var name_splited = element.val().split('\\');
          var name_file = name_splited[name_splited.length - 1];
          var reader = new FileReader();
          reader.onload = function (loadEvent) {
            scope.$apply(function () {
              scope.ngModel = {'file': loadEvent.target.result, 'name': name_file};
              if (angular.isDefined(scope.applyFunction)) {
                scope.applyFunction({file: scope.ngModel});
              }
            });
          };
          reader.readAsDataURL(changeEvent.target.files[0]);
        });
      }
    }
  }

  angular
    .module('app.fmd')
    .directive('fileRead', fileRead)
})();
(function () {
  'use strict';
  /** @ngInject*/
  function FMDController(FMDService, Common) {

    var vm = this;

    vm.file = null;
    vm.success = null;

    vm.sendFile = function (file) {
        FMDService.sendFile(file)
          .then(function (response) {
            vm.errors = response.errors;
            vm.success = response.success;
            Common.Toast.success("Arquivo processado!");
        })
          .catch(function () {
            Common.Toast.error("Erro ao processar arquivo!");
          })
    };

    vm.init = function () {

    };

    vm.init();

  }

  angular.module('app.fmd')
    .controller('FMDController', FMDController);
})();
(function () {
  'use strict';

  /** @ngInject */
  function run() {

  }

  angular
    .module('app.finance')
    .run(run);

})();

(function () {
  'use strict';
  
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.finance', {
        url: '/finance',
        templateUrl: 'app/finance/finance.html',
        controller: 'FinanceController',
        controllerAs: 'finance',
        public: false
      });
  }
  
  angular
    .module('app.finance')
    .config(routerConfig);
  
})();






(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('finance', {
      title: 'Geral',
      group: true,
      weight: 1
    });

  }

  angular
    .module('app.finance')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function FinanceController($mdSidenav, $state, $translate, $rootScope,ModalFactory,
                             $window, a4MenuSystemProvider, LocalStorage, SysTableColumn,
                             CONFIG, LockService, LoginService, Session, RolesService, Common, $timeout) {
    var vm = this;
    vm.toolbar = 'app/finance/toolbar.html';
    vm.userLocal = {
      name: ''
    };

    vm.companies = [];
    vm.languages = {
      pt: {
        'title': 'Português',
        'translation': 'TOOLBAR.PORTUGUESE',
        'code': 'pt',
        'flag': 'pt'
      }
    };

    vm.system = {
      name: "Finance",
      icon: 'assets/images/logos/a4finance.png'
    };

    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    vm.lockScreen = function () {
      LockService.lockSystem()
        .then(function () {
          $state.go('private.lockscreen');
        });
    };

    /**
     * Confirmação de senha para que o usuário tenha acesso a página de troca de senha 
     */
    vm.confirmPassword = function () {
      ModalFactory.open('require_password', null, null, null, null, 'educational', vm.changePassword, 'Deseja trocar de senha?',
      'Por questões de segurança, por favor insira sua senha para continuar com o procedimento.')
    }

    /**
     * Caso o usuário informe sua senha corretamente, redireciona a página para a página de troca de senha
     */
    vm.changePassword = function () {
      $state.go('public.changepassword')

      $rootScope.$broadcast('ModalFactory.close');
    }

    vm.init = function () {
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
      if (SysTableColumn.getScopes().length <= 0) {
        SysTableColumn.getAll();
      }
      if (Session.getUser()) {
        vm.userLocal.name = Session.getUser().person.name;
        vm.companies = Session.getCompanies();
      }

      if (angular.isUndefined(Session.getCurrentProfile()) || Session.getCurrentProfile() === null) {
        vm.verifyProfile(Session.getContext());
      }

      vm.companySelected = angular.isDefined(Session.getCurrentCompany()) && Session.getCurrentCompany() !== null ? Session.getCurrentCompany() : vm.companies[0].id;
      Session.set('current_company', parseInt(vm.companySelected), "sessionStorage");
      vm.school_period_selected = angular.isDefined(Session.getCurrentSchoolPeriod()) && Session.getCurrentSchoolPeriod() !== null ?
        Session.getCurrentSchoolPeriod() : Session.getSchoolPeriodDefault();
      Session.set('current_school_period', vm.school_period_selected, "sessionStorage");
      vm.getDateNow();
      $translate.use(vm.languages.pt.code);
      $rootScope.$broadcast("CHANGE.THEME", "finance");
    };

    /**
     * Disponibiliza o nome do carpo do perfil selecionado
     * @param profile
     * @returns {string}
     */
    vm.listProfileName = {
      is_student: 'Aluno',
      is_parent: 'Responsável',
      is_employee: 'Colaborador',
      is_teacher: 'Professor',
      is_general_coordinator: 'Coordenador Geral',
      is_group_coordinator: 'Coordenador de Turma',
      is_principal: 'Diretor'
    };

    /**
     * Permite selecionar os perfis disponíveis
     * @param profiles
     */
    vm.verifyProfile = function (profiles) {
      var any_profiles = 0;
      var possibleProfiles = [];
      angular.forEach(profiles, function (item, key) {
        if (item === true) {
          any_profiles = any_profiles + 1;
          possibleProfiles.push(key);
        }
      });

      /** Se houver mais que uma opção abre o modal para a escolha */
      if (any_profiles > 1) {
        vm.switchProfile(profiles);
      } else {
        LocalStorage.add(CONFIG.storage.profile, possibleProfiles[0]);
        $window.location.reload();
      }
    };

    /**
     * Abre o modal para a escolha de perfil para exibição do sistema
     */
    vm.switchProfile = function (profiles) {
      ModalFactory.customClean(
        'app/controlpanel/switch-profile.html',
        'SwitchProfileControlPanel',
        'vm', false, profiles
      );
    };


    vm.logout = function () {
      if(angular.isDefined(LocalStorage.get('sys_session_id'))) {
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }else {
        LocalStorage.add('sys_session_id', 0)
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }
    };


    vm.toggleA4MenuSystem = function () {
      a4MenuSystemProvider.toggleA4MenuSystem();
    };


    vm.getDateNow = function () {
      var now = new Date();
      vm.year = now.getFullYear();
    };

    vm.toggleMsNavigationFolded = function () {
      vm.folded = !vm.folded;
    };

    // Methods
    vm.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();
    };

    vm.changeLanguage = function (lang) {
      vm.selectedLanguage = lang;
      $translate.use(lang.code);
    };

    /**
     * Modificação de empresa
     * @param idSelected - identificador da empresa
     */
    vm.changeCompany = function (idSelected) {
      Session.set('current_company', parseInt(idSelected), "sessionStorage");
      var user = Session.getUser();
      $rootScope.show_loader = true;
      RolesService.getUserRoleModule(user.id, Session.get(CONFIG.storage.profile))
        .then(function (response) {
          $rootScope.show_loader = false;
          Session.set(CONFIG.storage.roles, response.roles);
          Session.set(CONFIG.storage.school_period_default, response.school_period_default, "sessionStorage");
          Session.set(CONFIG.storage.current_school_period, response.school_period_default, "sessionStorage");
          $timeout(function () {
            $state.go('private.controlpanel.dashboard');
            $timeout(function () {
              $window.location.reload();
            }, 300)
          }, 300);
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data.message)
        });
      $rootScope.$broadcast('$switch-header-company');
    };

    vm.init();

  }

  angular
    .module('app.finance')
    .controller('FinanceController', FinanceController);

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate(a4Moment)
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return a4Moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return a4Moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return a4Moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return a4Moment(value).calendar();
            }

        };
    }

})();

(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    msNavigationService.saveItem('secretary', {
      title: 'SECRETARIA',
      group: false,
      weight: 2,
      hidden: function () {
        return PoliciesService.isParent();
      }
    });

  }

  angular
    .module('app.educational')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function EducationalService(Restangular) {

    var getSchoolsPeriod = function () {
      return Restangular.one("schoolperiod").get();
    };

    var saveSettings = function (settings) {
      return Restangular.one("settings").all('save').post(settings);
    };

    var getGradeRuleItems = function (obj) {
      return Restangular.one('graderule').one('getgraderulesforrecord').get(obj);
    };

    var hasFinance = function () {
      return Restangular.one('config').one('hasfinance').get();
    };

    var hasPostCodeRequired = function () {
      return Restangular.one('config').one('haspostcoderequired').get();
    };

    var hasNationalIdNumberRequired = function () {
      return Restangular.one('config').one('hasnationalidnumberrequired').get();
    };

    var getAcademicTypeOfCompany = function () {
      return Restangular.one('config').one('getacademictype').get();
    };

    var isCapacityLimit = function () {
      return Restangular.one('config').one('isCapacityLimit').get();
    };

    var getGradeRuleByGroup = function (obj) {
      return Restangular.one('graderule').one('getgraderulebygroup').get(obj);
    };

    var getStatisticsForCourse = function (obj) {
      return Restangular.one('statistics').one('getstatisticsforcourse').get(obj);
    };

    var getStatisticsForGroup = function (obj) {
      return Restangular.one('statistics').one('getstatisticsforgroup').get(obj);
    };

    var getStatisticsForSubject = function (obj) {
      return Restangular.one('statistics').one('getstatisticsforsubject').get(obj);
    };

    var getStatisticsForEvent = function (obj) {
      return Restangular.one('statistics').one('getstatisticsforevent').get(obj);
    };

    var getGradeRuleFromActiveGroups = function () {
      return Restangular.one('graderule').one('getgraderulefromactivegroups').get();
    };

    var getEventByGradeRule = function (obj) {
      return Restangular.one('graderule').one('geteventbygraderule').get(obj);
    };

    var getGradeRangeAnalyses = function () {
      return Restangular.one('statistics').one('getgraderangeanalyses').get();
    };

    var submitGradeRangeAnalyses = function (obj) {
      return Restangular.one('statistics').all('submitgraderangeanalyses').post(obj);
    };


    return {
      getSchoolsPeriod: getSchoolsPeriod,
      getAcademicTypeOfCompany: getAcademicTypeOfCompany,
      hasFinance: hasFinance,
      hasPostCodeRequired: hasPostCodeRequired,
      isCapacityLimit: isCapacityLimit,
      hasNationalIdNumberRequired: hasNationalIdNumberRequired,
      saveSettings: saveSettings,
      getGradeRuleItems: getGradeRuleItems,
      getGradeRuleByGroup: getGradeRuleByGroup,
      getStatisticsForCourse: getStatisticsForCourse,
      getStatisticsForGroup: getStatisticsForGroup,
      getStatisticsForSubject: getStatisticsForSubject,
      getStatisticsForEvent: getStatisticsForEvent,
      getGradeRuleFromActiveGroups: getGradeRuleFromActiveGroups,
      getEventByGradeRule: getEventByGradeRule,
      getGradeRangeAnalyses: getGradeRangeAnalyses,
      submitGradeRangeAnalyses: submitGradeRangeAnalyses
    }

  }

  angular
    .module('app.educational')
    .factory('EducationalService', EducationalService);

})();

(function () {
  'use strict';

  /** @ngInject */
  function run() {
  }

  angular
    .module('app.educational')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.educational', {
        url: '/educational',
        templateUrl: 'app/educational/educational.html',
        controller: 'EducationalController',
        controllerAs: 'educational',
        public: false
      });
  }

  angular
    .module('app.educational')
    .config(routerConfig);

})();






(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('educational', {
      title: 'GERAL',
      group: false,
      weight: 1
    });

  }

  angular
    .module('app.educational')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function EducationalController($mdSidenav, $state, $scope, $translate, $rootScope,$document,
                                 a4MenuSystemProvider, EducationalService, CONFIG, LocalStorage,
                                 LockService, LoginService, Session, ModalFactory, SysTableColumn,
                                 RolesService, Common, $window, $timeout, $filter, AppLog, PoliciesService) {
    var educational = this;
    educational.menu_able = false;
    educational.change_company_able = false;
    educational.show_school_period = false;
    educational.company_id = Session.getCurrentCompany();
    educational.subdomain = $document[0].domain.split('.')[0];
    educational.toolbar = 'app/educational/toolbar.html';
    educational.userLocal = {name: ''};
    educational.companies = [];
    educational.students = [];
    educational.languages = {
      pt: {
        'title': 'Português',
        'translation': 'TOOLBAR.PORTUGUESE',
        'code': 'pt',
        'flag': 'pt'
      }
    };

    educational.system = {
      name: "Educational",
      icon: 'assets/images/logos/a4educational.png'
    };
    educational.school_period = {selected: null};
    educational.folded = false;
    educational.msScrollOptions = {suppressScrollX: true};
    /**
     * Evento do toggle do menu
     * @type {*}
     */
    var ltn = $rootScope.$on('$toggleNavigationMenu', function () {
      educational.toggleMsNavigationFolded();
    });

    /**
     * Ouve evento de mudança do período letivo
     */
    $scope.$on('change-school-period', function (event, school_period_id) {
      school_period_id = school_period_id.replace(/\D/g, '');
      if (school_period_id !== educational.school_period.selected.id) {
        for (var i = 0; i < educational.school_period.list.length; i++) {
          if (educational.school_period.list[i].id == school_period_id) {
            educational.school_period.selected = educational.school_period.list[i];
            educational.schoolPeriodChange(educational.school_period.list[i]);
            break;
          }
        }
      }
      // educational.school_period.selected
    });

    /**
     * Verifica Politicas de acesso
     * @param policy - Identificador da politica de acesso
     * @returns {boolean}
     */
    educational.checkPolicies = function (policy) {
      return !PoliciesService.checkPolicyFromMenu(policy);
    };

    /**
     * Este evento acontece antes da view ser renderizada
     * @type {*}
     */
    var ltn1 = $rootScope.$on('$viewContentLoading', function () {
      educational.context = Session.getContext();
      educational.profile_selected = Session.getCurrentProfile();
      if (educational.profile_selected == 1 && Session.getUser().companies.length > 1) {
        educational.companies = Session.getUser().companies;
      }
      $rootScope.$broadcast(CONFIG.events.side_menu.update);
    });

    /**
     * Identifica a modificação de periodo letivo, e salva a nova configuração
     * @param selected - identificador do novo periodo selecionado.
     */
    educational.schoolPeriodChange = function (selected) {
      /*EducationalService.saveSettings({school_period: selected, change: true})
        .then(function () {
        })*/
      educational.school_period.selected = selected;
      Session.set('current_school_period', selected, "sessionStorage");
      $timeout(function () {
        $state.go($state.current.name, {}, {reload: true});
      }, 1000);
    };

    /**
     * Executa a tranca da tela
     */
    educational.lockScreen = function () {
      LockService.lockSystem()
        .then(function () {
          $state.go('private.lockscreen');
        });
    };

    /**
     * Confirmação de senha para que o usuário tenha acesso a página de troca de senha 
     */
    educational.confirmPassword = function () {
      ModalFactory.open('require_password', null, null, null, null, 'educational', educational.changePassword, 'Deseja trocar de senha?',
      'Por questões de segurança, por favor insira sua senha para continuar com o procedimento.')
    }

    /**
     * Caso o usuário informe sua senha corretamente, redireciona a página para a página de troca de senha
     */
    educational.changePassword = function () {
      $state.go('public.changepassword')

      $rootScope.$broadcast('ModalFactory.close');
    }

    /**
     * Função de inicialização do controller
     */
    educational.init = function () {
      AppLog.getUnreadLogs();
      if (SysTableColumn.getScopes().length <= 0) {
        SysTableColumn.getAll();
      }
      educational.school_period = {selected: null};
      educational.selectedLanguage = educational.languages[$translate.preferredLanguage()];
      if (Session.getUser()) {
        educational.userLocal.name = Session.getUser().person.name;
        educational.companies = Session.getCompanies();
      }

      if (angular.isUndefined(Session.getCurrentProfile()) || Session.getCurrentProfile() === null) {
        educational.verifyProfile(educational.context);
      }

      EducationalService.hasFinance().then(function (response) {
        var obj = response.plain();
        LocalStorage.add(CONFIG.storage.has_app_finance, obj.has_finance);
      });

      educational.defineMenuContext();
      educational.companySelected = angular.isDefined(Session.getCurrentCompany())
      && Session.getCurrentCompany() !== null ? Session.getCurrentCompany() : educational.companies[0].id;
      Session.set('current_company', parseInt(educational.companySelected), "sessionStorage");
      educational.getDateNow();
      educational.getSchoolPeriod();
      $translate.use(educational.languages.pt.code);
      $rootScope.$broadcast("CHANGE.THEME", "educational");

    };

    /**
     * Resgata todos os periodos letivos.
     */
    educational.getSchoolPeriod = function () {
      /*listagem de todos os períodos letivos */
      educational.school_period.list = educational.getPeriodsOfCompany(educational.companySelected);
      if (angular.isUndefined($filter('filter')(educational.school_period.list, {id: Session.getCurrentSchoolPeriod()}))) {
        educational.logout();
      }
      /**Definição do período letivo utilizado pela sessão (no educacional),
       * Primeiro, verifica se Session.getCurrentSchoolPeriod é definido,
       * Se não, ele define deterninado valor,
       * Se sim, será iniciado outro ternário que verifica se getCurrentSchoolPeriod difere de NULL.
       *
       * Modificação para a pendência AM-4937:
       * 1.Originalmente, caso Session.getCurrentSchoolPeriod() não fosse definido ele definia para "selected" o primeiro
       * valor da lista de PLs, nesse caso era possível que no login de um aluno, o sistema retornasse o ultímo PL
       * registrado, o que não é, necessariamente, o PL definido como padrão.
       * 2.Para resolver isso, o valor a ser definido caso Session.getCurrentSchoolPeriod() não fosse definido foi mudado para
       * o PL da lista em que "is_default" for igual a TRUE.
       * */
      educational.school_period.selected = angular.isDefined(Session.getCurrentSchoolPeriod()) ?
        (angular.isObject(Session.getCurrentSchoolPeriod()) ? Session.getCurrentSchoolPeriod() :
          (Session.getCurrentSchoolPeriod() !== null ?
            $filter('filter')(educational.school_period.list, {id: Session.getCurrentSchoolPeriod()})[0]
            : Session.getSchoolPeriodDefault())) : $filter('filter')(educational.school_period.list, {is_default: true})[0];
      Session.set('current_school_period', educational.school_period.selected, "sessionStorage");
    };

    educational.getPeriodsOfCompany = function (company_id) {
      var school_periods = [];
      educational.companies.forEach(function (item) {
        if (item.id === company_id) {
          school_periods = item.school_periods;
        }
      });
      return school_periods;
    };

    /**
     * Define comportamento do menu do educacional
     */
    educational.defineMenuContext = function () {
      switch (Session.getCurrentProfile()) {
        case (CONFIG.profile.student):
          educational.menu_able = false;
          educational.change_company_able = false;
          educational.show_school_period = false;
          break;
        case (CONFIG.profile.parent):
          educational.menu_able = true;
          educational.change_company_able = true;
          educational.show_school_period = false;
          break;
        case (CONFIG.profile.is_employee):
          educational.menu_able = true;
          educational.change_company_able = true;
          educational.show_school_period = true;
          break;
        case (CONFIG.profile.teacher):
          educational.menu_able = true;
          educational.change_company_able = true;
          educational.show_school_period = false;
          break;
        case (CONFIG.profile.general_coordinator):
          educational.menu_able = true;
          educational.change_company_able = true;
          educational.show_school_period = true;
          break;
        case (CONFIG.profile.group_coordinator):
          educational.menu_able = true;
          educational.change_company_able = true;
          educational.show_school_period = false;
          break;
        default:
          educational.menu_able = true;
          educational.change_company_able = true;
          educational.show_school_period = true;
          break;
      }
    };

    /**
     * Permite selecionar os perfis disponíveis
     * @param profiles
     */
    educational.verifyProfile = function (profiles) {
      /** Se houver mais que uma opção abre o modal para a escolha */
      if (profiles.user_profiles > 1) {
        educational.switchProfile(profiles);
      } else {
        LocalStorage.add(CONFIG.storage.profile, profiles);
        $state.reload($state.current.name);
      }
    };

    /**
     * Abre o modal para a escolha de perfil para exibição do sistema
     */
    educational.switchProfile = function (profiles) {
      ModalFactory.customClean(
        'app/controlpanel/switch-profile.html',
        'SwitchProfileControlPanel',
        'vm', false, profiles
      );
    };

    /**
     * Executa o logoff do sistema
     */
    educational.logout = function () {
      if(angular.isDefined(LocalStorage.get('sys_session_id'))) {
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }else {
        LocalStorage.add('sys_session_id', 0)
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Controle do menu lateral de empresas
     */
    educational.toggleA4MenuSystem = function () {
      if (educational.profile_selected !== 2) {
        a4MenuSystemProvider.toggleA4MenuSystem();
      };
    }


    educational.getDateNow = function () {
      var now = new Date();
      educational.year = now.getFullYear();
    };

    educational.toggleMsNavigationFolded = function () {
      educational.folded = !educational.folded;
    };

    // Methods
    educational.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();
    };

    educational.changeLanguage = function (lang) {
      educational.selectedLanguage = lang;
      $translate.use(lang.code);
    };

    /**
     * Modificação de empresa
     * @param idSelected - identificador da empresa
     */
    educational.changeCompany = function (idSelected) {
      Session.set('current_company', parseInt(idSelected), "sessionStorage");
        var user = Session.getUser();
        $rootScope.show_loader = true;
        RolesService.getUserRoleModule(user.id, Session.get(CONFIG.storage.profile))
          .then(function (response) {
            $rootScope.show_loader = false;
            Session.set(CONFIG.storage.roles, response.roles);
            Session.set(CONFIG.storage.school_period_default, response.school_period_default, "sessionStorage");
            Session.set(CONFIG.storage.current_school_period, response.school_period_default, "sessionStorage");
            educational.getSchoolPeriod();
            $timeout(function () {
              if (educational.profile_selected !== 1 && educational.profile_selected !== 2) {
                $state.go('private.controlpanel.dashboard');
              } else if(educational.profile_selected == 2) { 
                $state.go('private.educational.dashboard');
              } else {
                $state.go('private.educational.dashboard.students');
              }
              $timeout(function () {
                $window.location.reload();
              }, 300)
            }, 300);
          })
          .catch(function (error) {
            $rootScope.show_loader = false;
            Common.Toast.error(error.data.message)
          });
        $rootScope.$broadcast('$switch-header-company');
        educational.getSchoolPeriod();
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      })
    });

    educational.init();

  }

  angular
    .module('app.educational')
    .controller('EducationalController', EducationalController);

})();


(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    msNavigationService.saveItem('coordination', {
      title: 'COORDENAÇÃO',
      group: false,
      weight: 3,
      hidden: function () {
        return PoliciesService.isParent();
      }
    });

  }

  angular
    .module('app.educational')
    .run(run);

})();


(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, PoliciesService) {
    msNavigationService.saveItem('config', {
      title: 'CONFIGURAÇÕES',
      group: false,
      weight: 4,
      hidden: function () {
        return PoliciesService.isParent();
      }
    });

  }

  angular
    .module('app.educational')
    .run(run);

})();

(function () {
  'use strict';
  angular
    .module('app.evaluations', [
      'app.evaluations.dashboard',
      'app.evaluations.questionnaires',
      'app.evaluations.question-scales',
      'app.evaluations.device-register',
      'app.evaluations.questionnaire-events',
      'app.evaluations.answer-questionnaire',
      'app.evaluations.exit'
    ]);
})();


(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('questionnaire', {
      title: 'QUESTIONÁRIO',
      group: true,
      weight: 1,
      hidden: function () {
        return false;
      }
    });

  }

  angular
    .module('app.evaluations')
    .run(run);

})();


(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('knowledge', {
      title: 'CONHECIMENTO',
      group: true,
      weight: 1,
      hidden: function () {
        return false;
      }
    });

  }

  angular
    .module('app.evaluations')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function run() {
  }

  angular
    .module('app.evaluations')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.evaluations', {
        url: '/evaluations',
        abstract: true,
        public: false,
        auth: 'ctl_dash',
        templateUrl: 'app/evaluations/evaluations.html',
        controller: 'EvaluationsController',
        controllerAs: 'evaluations'
      });
  }

  angular
    .module('app.evaluations')
    .config(routerConfig);

})();






(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('evaluations', {
      title: 'Geral',
      group: true,
      weight: 1
    });

  }

  angular
    .module('app.evaluations')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function EvaluationsController($mdSidenav, $state, $translate, $rootScope, $timeout,ModalFactory,
                           a4MenuSystemProvider, LocalStorage, $scope, CONFIG,
                           LockService, LoginService, EducationalService, Session, SysTableColumn,
                           RolesService, Common, $window) {
    var evaluations = this;
    evaluations.menu_able = false;
    evaluations.change_company_able = false;
    evaluations.toolbar = 'app/evaluations/toolbar.html';
    evaluations.userLocal = {name: ''};
    evaluations.companies = [];
    evaluations.students = [];
    evaluations.languages = {
      pt: {
        'title': 'Português',
        'translation': 'TOOLBAR.PORTUGUESE',
        'code': 'pt',
        'flag': 'pt'
      }
    };

    evaluations.system = {
      name: "evaluations",
      icon: 'assets/images/logos/a4evaluations.png'
    };

    evaluations.folded = false;
    evaluations.msScrollOptions = {suppressScrollX: true};


    /**
     * Evento do toggle do menu
     * @type {*}
     */
    var ltn = $rootScope.$on('$toggleNavigationMenu', function () {
      evaluations.toggleMsNavigationFolded();
    });


    /**
     * Este evento acontece antes da view ser renderizada
     * @type {*}
     */
    var ltn1 = $rootScope.$on('$viewContentLoading', function () {
      evaluations.context = Session.getContext();
      evaluations.profile_selected = Session.getCurrentProfile();
      $rootScope.$broadcast(CONFIG.events.side_menu.update);
    });

    /**
     * Executa a tranca da tela
     */
    evaluations.lockScreen = function () {
      LockService.lockSystem()
        .then(function () {
          $state.go('private.lockscreen');
        });
    };

    /**
     * Confirmação de senha para que o usuário tenha acesso a página de troca de senha 
     */
    evaluations.confirmPassword = function () {
      ModalFactory.open('require_password', null, null, null, null, 'educational', evaluations.changePassword, 'Deseja trocar de senha?',
      'Por questões de segurança, por favor insira sua senha para continuar com o procedimento.')
    }

    /**
     * Caso o usuário informe sua senha corretamente, redireciona a página para a página de troca de senha
     */
    evaluations.changePassword = function () {
      $state.go('public.changepassword')

      $rootScope.$broadcast('ModalFactory.close');
    }

    /**
     * Função de inicialização do controller
     */
    evaluations.init = function () {
      evaluations.selectedLanguage = evaluations.languages[$translate.preferredLanguage()];

      if (SysTableColumn.getScopes().length <= 0) {
        SysTableColumn.getAll();
      }

      if (Session.getUser()) {
        evaluations.userLocal.name = Session.getUser().person.name;
        evaluations.companies = Session.getCompanies();
      }

      if (angular.isUndefined(Session.getCurrentProfile()) || Session.getCurrentProfile() === null) {
        evaluations.verifyProfile(evaluations.context);
      }

      evaluations.defineMenuContext();

      evaluations.companySelected = angular.isDefined(Session.getCurrentCompany()) && Session.getCurrentCompany() !== null ? Session.getCurrentCompany() : evaluations.companies[0].id;
      Session.set('current_company', parseInt(evaluations.companySelected), "sessionStorage");
      $translate.use(evaluations.languages.pt.code);
      $rootScope.$broadcast("CHANGE.THEME", "evaluations");
    };


    /**
     * Define comportamento do menu do educacional
     */
    evaluations.defineMenuContext = function () {
      switch (Session.getCurrentProfile()) {
        case (CONFIG.profile.student):
          evaluations.menu_able = false;
          evaluations.change_company_able = false;
          evaluations.show_school_period = false;
          break;
        case (CONFIG.profile.parent):
          evaluations.menu_able = true;
          evaluations.change_company_able = true;
          evaluations.show_school_period = false;
          break;
        case (CONFIG.profile.is_employee):
          evaluations.menu_able = true;
          evaluations.change_company_able = true;
          evaluations.show_school_period = true;
          break;
        case (CONFIG.profile.teacher):
          evaluations.menu_able = true;
          evaluations.change_company_able = true;
          evaluations.show_school_period = false;
          break;
        case (CONFIG.profile.general_coordinator):
          evaluations.menu_able = true;
          evaluations.change_company_able = true;
          evaluations.show_school_period = true;
          break;
        case (CONFIG.profile.group_coordinator):
          evaluations.menu_able = true;
          evaluations.change_company_able = true;
          evaluations.show_school_period = false;
          break;
        default:
          evaluations.menu_able = true;
          evaluations.change_company_able = true;
          evaluations.show_school_period = true;
          break;
      }
    };

    /**
     * Permite selecionar os perfis disponíveis
     * @param profiles
     */
    evaluations.verifyProfile = function (profiles) {
      /** Se houver mais que uma opção abre o modal para a escolha */
      if (profiles.length > 1) {
        evaluations.switchProfile(profiles);
      } else {
        LocalStorage.add(CONFIG.storage.profile, profiles);
        $state.reload($state.current.name);
      }
    };

    /**
     * Abre o modal para a escolha de perfil para exibição do sistema
     */
    evaluations.switchProfile = function (profiles) {
      ModalFactory.customClean(
        'app/controlpanel/switch-profile.html',
        'SwitchProfileControlPanel',
        'vm', false, profiles
      );
    };

    /**
     * Executa o logoff do sistema
     */
    evaluations.logout = function () {
      if(angular.isDefined(LocalStorage.get('sys_session_id'))) {
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }else {
        LocalStorage.add('sys_session_id', 0)
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Controle do menu lateral de empresas
     */
    evaluations.toggleA4MenuSystem = function () {
      a4MenuSystemProvider.toggleA4MenuSystem();
    };


    evaluations.toggleMsNavigationFolded = function () {
      evaluations.folded = !evaluations.folded;
    };

    // Methods
    evaluations.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();
    };

    evaluations.changeLanguage = function (lang) {
      evaluations.selectedLanguage = lang;
      $translate.use(lang.code);
    };

    /**
     * Modificação de empresa
     * @param idSelected - identificador da empresa
     */
    evaluations.changeCompany = function (idSelected) {
      Session.set('current_company', parseInt(idSelected), "sessionStorage");
      var user = Session.getUser();
      $rootScope.show_loader = true;
      RolesService.getUserRoleModule(user.id, Session.get(CONFIG.storage.profile))
        .then(function (response) {
          $rootScope.show_loader = false;
          Session.set(CONFIG.storage.roles, response.roles);
          Session.set(CONFIG.storage.school_period_default, response.school_period_default, "sessionStorage");
          Session.set(CONFIG.storage.current_school_period, response.school_period_default, "sessionStorage");
          $timeout(function () {
            $state.go('private.controlpanel.dashboard');
            $timeout(function () {
              $window.location.reload();
            }, 300)
          }, 300);
          evaluations.close();
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data.message)
        });
      $rootScope.$broadcast('$switch-header-company');
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      })
    });

    evaluations.init();
  }

  angular
    .module('app.evaluations')
    .controller('EvaluationsController', EvaluationsController);

})();

(function () {
  'use strict';

  angular.module('app.evaluations.exit', []);
})();
(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService, LoginService, LocalStorage, Session, $state, $rootScope) {
    var role = 'questionnaires';
    var path = 'evaluations.exit';
    var windowWidth = angular.element("body").width();


    msNavigationService.saveItem(path, {
      title: 'Sair',
      icon: 'icon-close',
      state: 'public.login',
      weight: 19,
      auth: role,
      hidden: function () {
       return  (windowWidth > 1000);
      },
      // action: function () {
      //   console.log('teste');
      //   // LoginService.doLogout(LocalStorage.get('sys_session_id'))
      //   //   .then(function () {
      //   //     Session.destroy();
      //   //     $state.go('public.login');
      //   //     $rootScope.show_loader = false;
      //   //   })
      //   //   .catch(function () {
      //   //     $rootScope.show_loader = false;
      //   //   });
      // }
    });
  }

  angular
    .module('app.evaluations.exit')
    .run(run);

})();


(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('eval-configurations', {
      title: 'CONFIGURAÇÕES',
      group: true,
      weight: 3,
      hidden: function () {
        return false;
      }
    });
  }

  angular
    .module('app.evaluations')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function configProvider($provide) {
    $provide.decorator('Toast', ['$delegate', 'PoliciesService', function ($delegate) {

      var originalSuccess = $delegate.success;

      $delegate.success = function (message) {
        originalSuccess.apply($delegate, [message]);
      };

      return $delegate;

    }]);
  }

  angular
    .module('app')
    .config(configProvider);

})();
// (function () {
//   'use strict';
//
//   /** @ngInject */
//   function jsTreeDecorator($delegate) {
//     var original = $delegate;
//
//
//     original.apply($delegate, arguments);
//
//
//     return $delegate;
//   }
//   angular.module('app.decorators')
//     .decorator('jsTree', jsTreeDecorator);
// })();
//
//

(function () {
	'use strict';
	angular
		.module('app.controlpanel', [
			'app.controlpanel.dashboard',
			'app.controlpanel.profile',
			'app.roles',
			'app.controlpanel.app-log',
			'app.controlpanel.central-reports',
			'app.controlpanel.unification',
			'app.controlpanel.import-data'
		]);
})();

(function () {
  'use strict';

  /** @ngInject */
  function SwitchProfileControlPanel($rootScope, $state, $window, $timeout, Common, ModalExtra, Session, LocalStorage, CONFIG, RolesService) {
    var vm = this;

    vm.init = function () {
      vm.profiles = ModalExtra.profiles;
      vm.company_roles = ModalExtra.company_roles;
      $rootScope.$broadcast('msSplashScreen::active');
    };

    /**
     * Define o perfil desejado no sistema
     * @param sys_user_role_id
     * @param company_id
     */
    vm.profileSelected = function (sys_user_role_id, company_id) {
      LocalStorage.add(CONFIG.storage.profile, sys_user_role_id);
      var user = Session.getUser();
      Session.set('current_company', parseInt(company_id), "sessionStorage");
      RolesService.getUserRoleModule(user.id, sys_user_role_id, company_id)
        .then(function (response) {
          Session.set(CONFIG.storage.roles, response.roles);
          LocalStorage.add(CONFIG.storage.companies, response.companies);
          if (response.companies.length === 1) {
            Session.set(CONFIG.storage.current_company, response.companies[0].id, "sessionStorage");
            Session.set(CONFIG.storage.current_school_period, response.companies[0].school_period_default.id, 'sessionStorage');
            Session.set(CONFIG.storage.school_period_default, response.companies[0].school_period_default, "sessionStorage");
          }
          $timeout(function () {
            $state.go('private.controlpanel.dashboard');
            $window.location.reload();
          }, 300);
          vm.close();
        })
        .catch(function (error) {
          Common.Toast.error(error.data.message)
        });

    };

    /** Realiza o fechamento do modal */
    vm.close = function () {
      $rootScope.$broadcast('ModalFactory.close');
    };

    vm.init();
  }

  angular
    .module('app.controlpanel')
    .controller('SwitchProfileControlPanel', SwitchProfileControlPanel);

})();
(function () {
  'use strict';

  /** @ngInject */
  function run() {
  }

  angular
    .module('app.controlpanel')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.controlpanel', {
        url: '/controlpanel',
        public: false,
        auth: 'ctl_dash',
        templateUrl: 'app/controlpanel/controlpanel.html',
        controller: 'ControlPanelController',
        controllerAs: 'controlpanel'
      });
  }

  angular
    .module('app.controlpanel')
    .config(routerConfig);

})();





(function () {
  'use strict';

  /** @ngInject */
  function ControlPanelController($mdSidenav, $state, $translate, $rootScope, $timeout,
                                  a4MenuSystemProvider, LocalStorage, $scope, CONFIG, SysTableColumn,
                                  LockService, LoginService, Session, PoliciesService, ModalFactory,
                                  RolesService, Common, $window, EducationalService) {
    var vm = this;
    vm.toolbar = 'app/controlpanel/toolbar.html';
    $rootScope.show_loader = false;
    vm.userLocal = {
      name: ''
    };
    vm.days_to_block = 5;
    vm.companies = [];

    vm.companies = [];
    vm.languages = {
      pt: {
        'title': 'Português',
        'translation': 'TOOLBAR.PORTUGUESE',
        'code': 'pt',
        'flag': 'pt'
      }
    };

    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    vm.lockScreen = function () {
      LockService.lockSystem()
        .then(function () {
          $state.go('private.lockscreen');
          $rootScope.show_loader = false;
        })
        .catch(function () {
          $rootScope.show_loader = false;
        });
    };

    /**
     * Confirmação de senha para que o usuário tenha acesso a página de troca de senha 
     */
    vm.confirmPassword = function () {
      ModalFactory.open('require_password', null, null, null, null, 'educational', vm.changePassword, 'Deseja trocar de senha?',
      'Por questões de segurança, por favor insira sua senha para continuar com o procedimento.')
    }

    /**
     * Caso o usuário informe sua senha corretamente, redireciona a página para a página de troca de senha
     */
    vm.changePassword = function () {
      $state.go('public.changepassword')

      $rootScope.$broadcast('ModalFactory.close');
    }

    /**
     * Inicializador do controlador
     */
    vm.init = function () {
      // vm.days_to_block = angular.isDefined($rootScope.days_to_block) ? $rootScope.days_to_block : LocalStorage.get(CONFIG.storage.days_to_block);
      if (SysTableColumn.getScopes().length <= 0) {
        SysTableColumn.getAll();
      }

      LoginService.getDaysToBlock()
        .then(function (resp) {
          vm.days_to_block = resp.days_to_block;
        });
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
      if (Session.getUser()) {
        vm.userLocal.name = Session.getUser().person.name;
        vm.companies = Session.getCompanies();
      }

      console.log(Session.getUser())
      vm.companySelected = angular.isDefined(Session.getCurrentCompany()) && Session.getCurrentCompany() !== null ? Session.getCurrentCompany() : vm.companies[0].id;
      Session.set('current_company', parseInt(vm.companySelected), "sessionStorage");
      vm.school_period_selected = angular.isDefined(Session.getCurrentSchoolPeriod()) && Session.getCurrentSchoolPeriod() !== null ?
        Session.getCurrentSchoolPeriod() : Session.getSchoolPeriodDefault();
      Session.set('current_school_period', vm.school_period_selected, "sessionStorage");
      vm.getDateNow();
      $translate.use(vm.languages.pt.code);
      $rootScope.$broadcast("CHANGE.THEME", "controlpanel");
      $rootScope.show_loader = false;
      $timeout(function () {
        EducationalService.hasFinance().then(function (response) {
          var obj = response.plain();
          LocalStorage.add(CONFIG.storage.has_app_finance, obj.has_finance);
          $rootScope.$broadcast('msSplashScreen::remove');
        });
      }, 3000);
    };


    vm.logout = function () {
      if(angular.isDefined(LocalStorage.get('sys_session_id'))) {
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }else {
        LocalStorage.add('sys_session_id', 0)
            LoginService.doLogout(LocalStorage.get('sys_session_id'))
              .then(function () {
                Session.destroy();
                $state.go('public.login');
                $rootScope.show_loader = false;
              })
              .catch(function () {
                $rootScope.show_loader = false;
              });
      }
    };


    vm.toggleA4MenuSystem = function () {
      a4MenuSystemProvider.toggleA4MenuSystem();
    };


    vm.getDateNow = function () {
      var now = new Date();
      vm.year = now.getFullYear();
    };

    vm.toggleMsNavigationFolded = function () {
      vm.folded = !vm.folded;
    };

    // Methods
    vm.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();
    };

    /**
     * Modifica
     * @param lang
     */
    vm.changeLanguage = function (lang) {
      vm.selectedLanguage = lang;
      $translate.use(lang.code);
    };

    /**
     * Modificação de empresa
     * @param idSelected - identificador da empresa
     */
    vm.changeCompany = function (idSelected) {
      Session.set('current_company', parseInt(idSelected), "sessionStorage");
      var user = Session.getUser();
      RolesService.getUserRoleModule(user.id, Session.get(CONFIG.storage.profile))
        .then(function (response) {
          Session.set(CONFIG.storage.roles, response.roles);
          Session.set(CONFIG.storage.school_period_default, response.school_period_default, "sessionStorage");
          Session.set(CONFIG.storage.current_school_period, response.school_period_default, "sessionStorage");
          $timeout(function () {
            $state.go('private.controlpanel.dashboard');
            $timeout(function () {
              $window.location.reload();
            }, 300)
          }, 300);
        })
        .catch(function (error) {
          Common.Toast.error(error.data.message)
        });
      $rootScope.$broadcast('$switch-header-company');
    };

    vm.init();

  }

  angular
    .module('app.controlpanel')
    .controller('ControlPanelController', ControlPanelController);

})();

(function () {
  'use strict';
  angular
    .module('app.crm', [
      'app.crm.dashboard',
      'app.crm.activities',
      'app.crm.charge',
      'app.crm.reports',
      'app.crm.charge-report',
      'app.crm.emailmanagement',
      'app.crm.leads',
      'app.crm.prospects'
    ]);
})();

(function () {
  'use strict';

  /** @ngInject */
  function run() {
  }

  angular
    .module('app.crm')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('private.crm', {
        url: '/crm',
        abstract: true,
        public: false,
        auth: 'ctl_dash',
        templateUrl: 'app/crm/crm.html',
        controller: 'CRMController',
        controllerAs: 'crm'
      });
  }

  angular
    .module('app.crm')
    .config(routerConfig);

})();






(function () {
  'use strict';

  /** @ngInject */
  function run(msNavigationService) {
    msNavigationService.saveItem('crm', {
      title: 'Geral',
      group: true,
      weight: 1
    });

  }

  angular
    .module('app.crm')
    .run(run);

})();

(function () {
  'use strict';

  /** @ngInject */
  function CRMController($mdSidenav, $state, $translate, $rootScope, $timeout,ModalFactory,
                         a4MenuSystemProvider, LocalStorage, $scope, CONFIG,
                         LockService, LoginService, EducationalService, Session, SysTableColumn,
                         RolesService, Common, $window) {
    var crm = this;
    crm.menu_able = false;
    crm.change_company_able = false;
    crm.toolbar = 'app/crm/toolbar.html';
    crm.userLocal = {name: ''};
    crm.companies = [];
    crm.students = [];
    crm.languages = {
      pt: {
        'title': 'Português',
        'translation': 'TOOLBAR.PORTUGUESE',
        'code': 'pt',
        'flag': 'pt'
      }
    };

    crm.system = {
      name: "C.R.M",
      icon: 'assets/images/logos/a4crm.jpg'
    };

    crm.folded = false;
    crm.msScrollOptions = {suppressScrollX: true};


    /**
     * Evento do toggle do menu
     * @type {*}
     */
    var ltn = $rootScope.$on('$toggleNavigationMenu', function () {
      crm.toggleMsNavigationFolded();
    });


    /**
     * Este evento acontece antes da view ser renderizada
     * @type {*}
     */
    var ltn1 = $rootScope.$on('$viewContentLoading', function () {
      crm.context = Session.getContext();
      crm.profile_selected = Session.getCurrentProfile();
      $rootScope.$broadcast(CONFIG.events.side_menu.update);
    });

    /**
     * Executa a tranca da tela
     */
    crm.lockScreen = function () {
      LockService.lockSystem()
        .then(function () {
          $state.go('private.lockscreen');
        });
    };

    /**
     * Confirmação de senha para que o usuário tenha acesso a página de troca de senha 
     */
    crm.confirmPassword = function () {
      ModalFactory.open('require_password', null, null, null, null, 'educational', crm.changePassword, 'Deseja trocar de senha?',
      'Por questões de segurança, por favor insira sua senha para continuar com o procedimento.')
    }

    /**
     * Caso o usuário informe sua senha corretamente, redireciona a página para a página de troca de senha
     */
    crm.changePassword = function () {
      $state.go('public.changepassword')

      $rootScope.$broadcast('ModalFactory.close');
    }

    /**
     * Função de inicialização do controller
     */
    crm.init = function () {
      crm.selectedLanguage = crm.languages[$translate.preferredLanguage()];

      if (SysTableColumn.getScopes().length <= 0) {
        SysTableColumn.getAll();
      }

      if (Session.getUser()) {
        crm.userLocal.name = Session.getUser().person.name;
        crm.companies = Session.getCompanies();
      }

      if (angular.isUndefined(Session.getCurrentProfile()) || Session.getCurrentProfile() === null) {
        crm.verifyProfile(crm.context);
      }

      crm.defineMenuContext();

      crm.companySelected = angular.isDefined(Session.getCurrentCompany()) && Session.getCurrentCompany() !== null ? Session.getCurrentCompany() : crm.companies[0].id;
      Session.set('current_company', parseInt(crm.companySelected), "sessionStorage");
      $translate.use(crm.languages.pt.code);
      $rootScope.$broadcast("CHANGE.THEME", "crm");
    };


    /**
     * Define comportamento do menu do educacional
     */
    crm.defineMenuContext = function () {
      switch (Session.getCurrentProfile()) {
        case (CONFIG.profile.student):
          crm.menu_able = false;
          crm.change_company_able = false;
          crm.show_school_period = false;
          break;
        case (CONFIG.profile.parent):
          crm.menu_able = true;
          crm.change_company_able = true;
          crm.show_school_period = false;
          break;
        case (CONFIG.profile.is_employee):
          crm.menu_able = true;
          crm.change_company_able = true;
          crm.show_school_period = true;
          break;
        case (CONFIG.profile.teacher):
          crm.menu_able = true;
          crm.change_company_able = true;
          crm.show_school_period = false;
          break;
        case (CONFIG.profile.general_coordinator):
          crm.menu_able = true;
          crm.change_company_able = true;
          crm.show_school_period = true;
          break;
        case (CONFIG.profile.group_coordinator):
          crm.menu_able = true;
          crm.change_company_able = true;
          crm.show_school_period = false;
          break;
        default:
          crm.menu_able = true;
          crm.change_company_able = true;
          crm.show_school_period = true;
          break;
      }
    };

    /**
     * Permite selecionar os perfis disponíveis
     * @param profiles
     */
    crm.verifyProfile = function (profiles) {
      /** Se houver mais que uma opção abre o modal para a escolha */
      if (profiles.length > 1) {
        crm.switchProfile(profiles);
      } else {
        LocalStorage.add(CONFIG.storage.profile, profiles);
        $state.reload($state.current.name);
      }
    };

    /**
     * Abre o modal para a escolha de perfil para exibição do sistema
     */
    crm.switchProfile = function (profiles) {
      ModalFactory.customClean(
        'app/controlpanel/switch-profile.html',
        'SwitchProfileControlPanel',
        'vm', false, profiles
      );
    };

    /**
     * Executa o logoff do sistema
     */
    crm.logout = function () {
      if(angular.isDefined(LocalStorage.get('sys_session_id'))) {
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }else {
        LocalStorage.add('sys_session_id', 0)
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login');
            $rootScope.show_loader = false;
          })
          .catch(function () {
            $rootScope.show_loader = false;
          });
      }
    };

    /**
     * Controle do menu lateral de empresas
     */
    crm.toggleA4MenuSystem = function () {
      a4MenuSystemProvider.toggleA4MenuSystem();
    };


    crm.toggleMsNavigationFolded = function () {
      crm.folded = !crm.folded;
    };

    // Methods
    crm.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();
    };

    crm.changeLanguage = function (lang) {
      crm.selectedLanguage = lang;
      $translate.use(lang.code);
    };

    /**
     * Modificação de empresa
     * @param idSelected - identificador da empresa
     */
    crm.changeCompany = function (idSelected) {
      Session.set('current_company', parseInt(idSelected), "sessionStorage");
      var user = Session.getUser();
      $rootScope.show_loader = true;
      RolesService.getUserRoleModule(user.id, Session.get(CONFIG.storage.profile))
        .then(function (response) {
          $rootScope.show_loader = false;
          Session.set(CONFIG.storage.roles, response.roles);
          Session.set(CONFIG.storage.school_period_default, response.school_period_default, "sessionStorage");
          Session.set(CONFIG.storage.current_school_period, response.school_period_default, "sessionStorage");
          $timeout(function () {
            $state.go('private.controlpanel.dashboard');
            $timeout(function () {
              $window.location.reload();
            }, 300)
          }, 300);
          crm.close();
        })
        .catch(function (error) {
          $rootScope.show_loader = false;
          Common.Toast.error(error.data.message)
        });
      $rootScope.$broadcast('$switch-header-company');
    };

    $scope.$on('$destroy', function () {
      [ltn, ltn1].forEach(function (fn) {
        fn();
      })
    });

    crm.init();
  }

  angular
    .module('app.crm')
    .controller('CRMController', CRMController);

})();

(function() {
  'use strict';

  angular
    .module('app.constants', []);

})();

(function () {
  'use strict';
  var CONFIG = {
    clientId: 1,
    clientSecret: 'nlTrHqQvBjl1QYIWVxNmq786ZBHXILwIkhJTE9wr',
    webApiUriLocal: 'http://a4simetria.a4net.local:3000/',

    // webApiSocket: 'http://localhost:3030/',                // LOCAL
    // webApiSocket: 'https://apilabs.a4cloud.com.br:3030/',    // HOMOLOGACAO
    webApiSocket: 'https://api.a4cloud.com.br:3030/',            // PRODUÇÃO
    // webApiSocket: 'https://apibeta.a4cloud.com.br:3030/',  // BETA

    // webApiUri: 'http://api.a4net.local/',          // LOCAL
    // webApiUri: 'https://apilabs.a4cloud.com.br/',    // HOMOLOGACAO
    webApiUri: 'https://api.a4cloud.com.br/',         // PRODUÇÃO
    // webApiUri: 'https://apibeta.a4cloud.com.br/',  // BETA

    storage: {
      user: 'user',
      token: 'token',
      roles: 'roles',
      context: 'context',
      companies: 'companies',
      classes_current_tab: 'classes_current_tab',
      students_current_tab: 'students_current_tab',
      current_company: 'current_company',
      current_student: 'current_student',
      current_school_period: 'current_school_period',
      system_setup: 'system_setup',
      has_app_finance: 'has_app_finance',
      has_app_educational: 'has_app_educational',
      is_blocked: 'is_blocked',
      dData: 'dData',
      profile: 'profile',
      is_responsible: 'is_responsible',
      labs: {
        user: 'labs_user',
        pass: 'labs_pass'
      }
    },
    profile: {
      student: 1,
      parent: 2,
      administrador: 3,
      group_coordinator: 4,
      general_coordinator: 5,
      employee: 6,
      teacher: 7
    },
    events: {
      side_menu: {
        update: 'SideMenuList.update'
      }
    },
    nota_fiscal: {
      producao: 'https://nfse.salvador.ba.gov.br/site/contribuinte/nota/notaprint.aspx',
      homologacao: 'https://notahml.salvador.ba.gov.br/site/contribuinte/nota/notaprint.aspx',
      token_plugnotas: '5cf55542-3134-4051-bcde-10400a4e1441',
      url_plugnotas: 'https://api.plugnotas.com.br/nfse/pdf/'
    },
    socket: {
      /** Atualização lista de matricula financeira */
      mat_fin_updated: '_mat_fin_updated',
      stream_a4_backup: '_stream_a4_backup'
    }
  };

  angular
    .module('app.constants')
    .constant('CONFIG', CONFIG);

})();

(function () {
  'use strict';

  /** @ngInject */
  function configRestangular(CONFIG, RestangularProvider) {
    RestangularProvider.setDefaultHeaders({'Content-Type': 'application/json; charset=utf-8'});
    RestangularProvider.setBaseUrl(CONFIG.webApiUri + 'api/');
  }

  angular
    .module('app.config')
    .config(configRestangular);

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
  'use strict';
  
  /** @ngInject */
  function mdDateConfig($mdDateLocaleProvider, moment) {
    $mdDateLocaleProvider.formatDate = function (date) {
      return moment(date).format('DD/MM/YYYY');
    };
  }
  
  angular
    .module('app.config')
    .config(mdDateConfig);
  
})();
(function () {
    'use strict';
  
    /** @ngInject */
    function sessionInterceptor($q, $rootScope, $location, Session) {
      var redirecting = false; // Flag para controlar o redirecionamento
  
      // Intercepta a mudança de URL
      $rootScope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {
        var isBlocked = Session.is_blocked;
  
        if (isBlocked && !newUrl.includes('/locked')) {
          // Marca que estamos redirecionando para evitar novas requisições
          redirecting = true;
  
          // Evita a mudança de URL
          event.preventDefault();
  
          // Redireciona para a página de bloqueio
          $location.path('/locked');
        }
      });
  
      return {
        request: function(config) {
          var isBlocked = Session.is_blocked;
  
          if (isBlocked && !redirecting) {
            console.log(isBlocked);
  
            // Marca que estamos redirecionando para evitar novas requisições
            redirecting = true;
  
            // Redireciona para a página específica
            $location.path('/locked');
  
            // Cancela a requisição
            return $q.reject('Ação bloqueada devido à sessão');
          }
  
          return config;
        },
        responseError: function(rejection) {
          // Lógica para lidar com erros de resposta, se necessário
          return $q.reject(rejection);
        }
      };
    }
  
    /** @ngInject */
    function config($httpProvider) {
      $httpProvider.interceptors.push('sessionInterceptor');
    }
  
    angular
      .module('app')
      .factory('sessionInterceptor', sessionInterceptor)
      .config(config);
  
  })();
  
(function () {
  'use strict';

  /** @ngInject */
  function IndexService() {

    var vm = this;
    vm.stopPropagation = false;

    return {
      isStopPropagation: function () {
        return vm.stopPropagation;
      },
      setStopPropagation: function (prop) {
        vm.stopPropagation = prop;
      }
    }

  }

  angular
    .module('app')
    .factory('IndexService', IndexService);

})();

(function () {
	'use strict';

	angular
		.module('app')
		.run(runBlock);

	/** @ngInject */
	function runBlock($rootScope, moment, editableThemes, $state) {
		$rootScope.show_loader = false;

		/** bloco de funcionamento sistema de voltar para o ultimo
		 *  state acessado
		 */
		$rootScope.previous_state = null;

		$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
			// Armazena o estado anterior no $rootScope
			$rootScope.previous_state = fromState.name || null;
		});

		/** vai para o ultimo state, porem como existem situações
		 *  em que não tem um, nessas situações volta para a tela
		 *  principal
		 */
		$rootScope.go_to_previous_state = function () {
			if($rootScope.previous_state) {
				$state.go($rootScope.previous_state);
			} else {
			$state.go('private.controlpanel.dashboard');
			}
		};


		/*************** */
    moment.locale('pt-br')
		editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
		editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

	}

})();

(function () {
  'use strict';

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.hashPrefix('');


    //class='view-animate-superior'
    $stateProvider
      .state('public', {
        abstract: true,
        template: "<div ui-view />"
      });

    //class='view-animate-superior'
    $stateProvider
      .state('private', {
        abstract: true,
        template: "<div ui-view />"
      });

    $urlRouterProvider.otherwise('/login');
  }

  angular
    .module('app')
    .config(routerConfig);

})();

(function () {
  'use strict';

  /** @ngInject */
  function IndexTranslate($translateProvider) {

    $translateProvider.translations('pt', {
      ADD: 'Adicionar',
      DELETE_SUCCESS: 'Apagado com sucesso.',
      DELETE: 'Excluir',
      EDIT: 'Editar',
      UPDATE: 'Atualizar',
      ADD_CONTINUE: 'Adicionar e continuar',
      ON: ' em ',
      UPDATE_ERROR: 'Falha ao atualizar lista, desculpe tente novamente.',
      UPDATE_SUCCESS: 'Atualizado com sucesso.',
      SEARCH_FOR_ANYONE: "Pesquisar"
    });

  }

  angular
    .module('app')
    .config(IndexTranslate);
})();

(function () {
  'use strict';

  /** @ngInject */
  function IndexController($rootScope, $scope, $filter, $window, Session, CONFIG, ModalFactory, LocalStorage, SysTableColumn,
                           LoginService, $state, a4IdleMinutesToBlock) {
    var vm = this;
    vm.possibleProfiles = [];
    vm.context = Session.getContext();
    vm.profile_selected = Session.getCurrentProfile();

    vm.init = function () {
      /** aciona a função de ociosidade apenas se 
       * for um usuário logado
       */
      if(angular.isDefined(Session.user)) {
      a4IdleMinutesToBlock.startMonitoring();
      }
      LocalStorage.add('day_close_block_message', null);
      vm.setCompanyOnHeader();
      SysTableColumn.getAll();
      vm.theme = {
        active: "finance"
      };
    };

    vm.setCompanyOnHeader = function () {
      var user = Session.getUser();
      if (user !== null && angular.isArray(user.companies) && user.companies.length > 0) {
        vm.current_company_obj = $filter('filter')(user.companies, {id: Session.getCurrentCompany()})[0];
      }
    };

    /**
     * Permite selecionar os perfis disponíveis
     * @param profiles
     */
    vm.verifyProfile = function (profiles) {
      /** Se houver mais que uma opção abre o modal para a escolha */
      if (profiles.length > 1) {
        vm.switchProfile(profiles);
      } else {
        LocalStorage.add(CONFIG.storage.profile, profiles);
        $window.location.reload();
      }
    };

    /**
     * Abre o modal para a escolha de perfil para exibição do sistema
     */
    vm.switchProfile = function (profiles) {
      ModalFactory.customClean(
        'app/controlpanel/switch-profile.html',
        'SwitchProfileControlPanel',
        'vm', false, profiles
      )
    };

    vm.logoutToSwitchProfile = function () {
      ModalFactory.confirm(null, 'Atenção',
        'Por motivos de segurança, é preciso encerrar a sessão para realizar a troca de perfil.' +
        '\nDeseja continuar o procedimento?',
        'Confirmar', 'Cancelar', 'educational').then(function () {
        $rootScope.show_loader = true;
        LoginService.doLogout(LocalStorage.get('sys_session_id'))
          .then(function () {
            Session.destroy();
            $state.go('public.login')
          });
        $rootScope.show_loader = false;
      })
    }

    // Remove the splash screen
    var on3 = $scope.$on('$viewContentAnimationEnded', function () {
      $rootScope.$broadcast('msSplashScreen::remove');
    });

    var on2 = $scope.$on('$switch-header-company', function () {
      vm.setCompanyOnHeader();
    });

    var on = $rootScope.$on("CHANGE.THEME", function (e, v) {
      vm.theme.active = v;
    });

    $scope.$on('$destroy', function () {
      [on, on2, on3].forEach(function (fn) {
        fn();
      });
    });

    vm.init();
  }

  angular
    .module('app')
    .controller('IndexController', IndexController);

})();

(function() {
  'use strict';

  angular
    .module('app');

})();

(function () {
  'use strict';

  angular
    .module('app')
    .config(config)
    .constant('angularMomentConfig', {
      timezone: 'America/Bahia'
    });

  /** @ngInject */
  function config($logProvider, $translateProvider, angularMomentConfig,
                  toastrConfig, $mdThemingProvider, $mdDateLocaleProvider,
                  moment, $httpProvider) {
    // Enable log
    moment.tz.setDefault(angularMomentConfig.timezone);
    $logProvider.debugEnabled(true);

    /** Configura o datepicker para aceitar o campo vazio  */
    $mdDateLocaleProvider.formatDate = function (date) {
      var m = moment(date);
      return m.isValid() ? m.format('DD/MM/YYYY') : '';
    };

    /** Configura um interceptor para redirecionar qualquer
     *  movimentacao para a tela de bloqueio de sessao a
     *  partir da variavel Session.is_blocked */
    $httpProvider.interceptors.push('sessionInterceptor');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
    $translateProvider.preferredLanguage('pt');
    $mdThemingProvider.alwaysWatchTheme(true);

    $mdThemingProvider.definePalette('a4PaletteControlPanel', {
      '50': '#e0e0e0',
      '100': '#b3b3b3',
      '200': '#808080',
      '300': '#4d4d4d',
      '400': '#262626',
      '500': '#000000',
      '600': '#000000',
      '700': '#000000',
      '800': '#000000',
      '900': '#000000',
      'A100': '#a6a6a6',
      'A200': '#8c8c8c',
      'A400': '#737373',
      'A700': '#666666',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', 'A100', 'A200'],
      'contrastLightColors': ['300', '400', '500', '600', '700', '800', '900', 'A400', 'A700']
    });

    $mdThemingProvider.definePalette('a4PaletteFinance', {
      '50': '#5bf9b3',
      '100': '#42f8a7',
      '200': '#2af79c',
      '300': '#11f690',
      '400': '#09e483',
      '500': '#08cc75',
      '600': '#07b367',
      '700': '#069b59',
      '800': '#05824b',
      '900': '#046a3d',
      'A100': '#07b367',
      'A200': '#07b367',
      'A400': '#08cc75',
      'A700': '#05824b',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'],
      'contrastLightColors': ['50', '100', '200', '300', '400', 'A100']
    });

    $mdThemingProvider.definePalette('a4PaletteEducational', {
      '50': "#E1F5FE",
      '100': "#B3E5FC",
      '200': "#81D4FA",
      '300': "#4FC3F7",
      '400': "#29B6F6",
      '500': "#03A9F4",
      '600': "#039BE5",
      '700': "#0288D1",
      '800': "#0277BD",
      '900': "#01579B",
      'A100': "#80D8FF",
      'A200': "#40C4FF",
      'A400': "#00B0FF",
      'A700': "#0091EA",
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'],
      'contrastLightColors': undefined
    });

    $mdThemingProvider.definePalette('a4PaletteCRM', {
      '50': "#E1F5FE",
      '100': "#aca4fc",
      '200': "#b9a4fa",
      '300': "#aa7df7",
      '400': "#6f3ccc",
      '500': "#7800f4",
      '600': "#6700e5",
      '700': "#7400b4",
      '800': "#73009f",
      '900': "#4f0076",
      'A100': "#b98aff",
      'A200': "#904cff",
      'A400': "#9000ff",
      'A700': "#9d00ea",
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'],
      'contrastLightColors': undefined
    });

    $mdThemingProvider.definePalette('a4PaletteStock', {
      '50': "#E1F5FE",
      '100': "#fc6e7d",
      '200': "#f1303d",
      '300': "#db2c37",
      '400': "#ae0000",
      '500': "#8f0000",
      '600': "#c02631",
      '700': "#e01823",
      '800': "#a90000",
      '900': "#9c0000",
      'A100': "#e43825",
      'A200': "#ff2435",
      'A400': "#a70000",
      'A700': "#ea0802",
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'],
      'contrastLightColors': undefined
    });

    $mdThemingProvider.definePalette('a4PaletteEvaluations', {
      '50': "#E1F5FE",
      '100': "#FFF9C4",
      '200': "#FFF59D",
      '300': "#FFF176",
      '400': "#FFEE58",
      '500': "#d5c531",
      '600': "#FDD835",
      '700': "#FBC02D",
      '800': "#F9A825",
      '900': "#F57F17",
      'A100': "#FFFF8D",
      'A200': "#d5c531",
      'A400': "#FFEA00",
      'A700': "#FFD600",
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'],
      'contrastLightColors': undefined
    });

    $mdThemingProvider.definePalette('a4PaletteProcess', {
      '50': "#E0F2F1",
      '100': "#B2DFDB",
      '200': "#80CBC4",
      '300': "#4DB6AC",
      '400': "#26A69A",
      '500': "#009688",
      '600': "#00897B",
      '700': "#00796B",
      '800': "#00695C",
      '900': "#004D40",
      'A100': "#A7FFEB",
      'A200': "#80CBC4",
      'A400': "#1DE9B6",
      'A700': "#00BFA5",
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'],
      'contrastLightColors': undefined
    });

    $mdThemingProvider.theme('educational')
      .primaryPalette('a4PaletteEducational')
      .accentPalette('a4PaletteEducational');

    $mdThemingProvider.theme('controlpanel')
      .primaryPalette('a4PaletteControlPanel')
      .accentPalette('a4PaletteControlPanel');

    $mdThemingProvider.theme('finance')
      .primaryPalette('a4PaletteFinance')
      .accentPalette('a4PaletteFinance');

    $mdThemingProvider.theme('crm')
      .primaryPalette('a4PaletteCRM')
      .accentPalette('a4PaletteCRM');

    $mdThemingProvider.theme('stock')
      .primaryPalette('a4PaletteStock')
      .accentPalette('a4PaletteStock');

    $mdThemingProvider.theme('evaluations')
      .primaryPalette('a4PaletteEvaluations')
      .accentPalette('a4PaletteEvaluations');

    $mdThemingProvider.theme('process')
      .primaryPalette('a4PaletteProcess')
      .accentPalette('a4PaletteProcess');



  }

})();

(function () {
  'use strict';
  angular.module('app.finance.finance-reports.designed-realized-report', []);
})();
(function(){
  'use strict';

  angular
    .module('app.educational.students.classrooms', []);

})();
(function () {
  'use strict';
  angular
    .module('clmtrackr', []);
})();
(function () {
  'use strict';
  angular
    .module('a4-compress', []);
})();
(function () {
  'use strict';
  angular.module('app.decorators', []);
})();



angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/controlpanel/controlpanel.html","<div class=\"progress-div-alfa\" ng-show=\"$root.show_loader\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando, por favor aguarde...</p></md-card-content></md-card></div></div></div><div id=\"main\" class=\"animate-slide-up\" ui-view=\"main\" layout=\"column\"><div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"account-selection simplified\" aria-label=\"Current Company\" ng-change=\"controlpanel.changeCompany(controlpanel.companySelected)\" ng-model=\"controlpanel.companySelected\"><md-option ng-repeat=\"company in controlpanel.companies\" value=\"{{company.id}}\" ng-selected=\"controlpanel.companySelected == company.id\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img class=\"avatar\" src=\"assets/images/avatars/default-building.jpg\"></div><span class=\"companyname\" hide-sm=\"\">{{ company.name || company.corporate_name }}</span></div></md-option></md-select><div layout=\"row\" layout-align=\"end center\" class=\"ng-scope layout-align-start-center layout-row\" ng-include=\"controlpanel.toolbar\"></div></md-toolbar><a4-block-message></a4-block-message><md-content id=\"content\" class=\"md-hue-2\" ms-scroll=\"\" flex=\"\" ui-view=\"\"></md-content></div></div></div>");
$templateCache.put("app/controlpanel/switch-profile.html","<md-dialog aria-label=\"Edit Cell\" md-theme=\"educational\"><form name=\"enrollmentForm\" ng-submit=\"vm.submit(vm.form.selected_group, enrollmentForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Escolha de perfil</h2></div></md-toolbar><md-dialog-content><strong class=\"group-field\"><small>Selecione o perfil desejado para exibição do sistema</small></strong><div layout=\"row\" layout-align=\"center center\"><md-list flex=\"\" layout=\"column\" layout-align=\"center center\" layout-wrap=\"\" class=\"switch-profile\" ng-repeat=\"roles in vm.company_roles\"><md-list-item flex=\"50\" ng-if=\"roles.is_student !== null\"><div class=\"md-grid-item-content\" ng-click=\"vm.profileSelected(1, roles.company_id)\"><div class=\"md-grid-text\">Aluno em {{roles.name}}</div></div></md-list-item><md-list-item flex=\"50\" ng-if=\"roles.is_employee > 0 && roles.is_employee_with_privilege == true\"><div class=\"md-grid-item-content\" ng-click=\"vm.profileSelected(0, roles.company_id)\"><div class=\"md-grid-text\">Colaborador em {{roles.name}}</div></div></md-list-item><md-list-item flex=\"50\" ng-if=\"roles.is_responsible !== null || roles.is_payee !== null\"><div class=\"md-grid-item-content\" ng-click=\"vm.profileSelected(2, roles.company_id)\"><div class=\"md-grid-text\">Responsável em {{roles.name}}</div></div></md-list-item><md-list-item flex=\"50\" ng-if=\"roles.is_employee === 3 || roles.roles_ids === \'{7}\'\"><div class=\"md-grid-item-content\" ng-click=\"vm.profileSelected(7, roles.company_id)\"><div class=\"md-grid-text\">Professor em {{roles.name}}</div></div></md-list-item><md-list-item flex=\"50\" ng-if=\"roles.is_coordinator !== null\"><div class=\"md-grid-item-content\" ng-click=\"vm.profileSelected(4, roles.company_id)\"><div class=\"md-grid-text\">Coordenador de curso em {{roles.name}}</div></div></md-list-item><md-list-item flex=\"50\" ng-if=\"roles.is_supplier !== null\"><div class=\"md-grid-item-content\" ng-click=\"vm.profileSelected(10, roles.company_id)\"><div class=\"md-grid-text\">Fornecedor em {{roles.name}}</div></div></md-list-item></md-list></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/controlpanel/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm=\"\">{{ controlpanel.userLocal.name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.PREFERENCES\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"controlpanel.confirmPassword()\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.CHANGE_PASSWORD\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"controlpanel.lockScreen()\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.LOCK_SCREEN\' | translate }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"controlpanel.logout()\">{{ \'TOOLBAR.LOG_OUT\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/crm/crm.html","<div class=\"board-list a4-center-all\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"crm.reload_page != null\"><div class=\"board-list-item\" layout=\"column\" layout-align=\"center center\"><div class=\"show-system\"><div><img ng-src=\"{{crm.system.icon}}\" alt=\"\"></div><div class=\"board-name\"><b>{{crm.system.name}}</b></div></div></div></div><div class=\"progress-div-alfa\" ng-show=\"$root.show_loader\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando, por favor aguarde...</p></md-card-content></md-card></div></div></div><div id=\"main\" class=\"animate-slide-up\" ui-view=\"main\" layout=\"column\" ng-if=\"crm.reload_page == null\"><div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-sidenav-left cursor-pointer\" md-component-id=\"navigation\" md-is-open=\"true\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=\"4\"><md-toolbar class=\"navigation-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools md-toolbar-tools-top logo layout-row\" layout=\"row\" layout-align=\"start center\" ng-click=\"crm.toggleA4MenuSystem()\"><span class=\"logo-image md-accent\">A4</span> <span class=\"logo-text\">Relacionamento</span> <span class=\"logo-text\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16 hide-sm md-font material-icons icon-chevron-down\" hide-sm=\"\" aria-hidden=\"true\"></md-icon></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"crm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><a4-menu-system></a4-menu-system><ms-navigation class=\"scrollable\" folded=\"crm.folded\" root=\"crm\" ms-scroll=\"crm.msScrollOptions\"></ms-navigation></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"crm.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon ng-scope md-default-theme md-font material-icons icon-menu\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></md-button></div><md-select class=\"account-selection simplified\" aria-label=\"Current Company\" ng-change=\"crm.changeCompany(crm.companySelected)\" ng-model=\"crm.companySelected\"><md-option ng-repeat=\"company in crm.companies\" value=\"{{company.id}}\" ng-selected=\"crm.companySelected == company.id\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img class=\"avatar\" src=\"assets/images/avatars/default-building.jpg\"></div><span class=\"companyname\" hide-sm=\"\">{{ company.name || company.corporate_name }}</span></div></md-option></md-select><div layout=\"row\" layout-align=\"end center\" class=\"ng-scope layout-align-start-center layout-row\" ng-include=\"crm.toolbar\"></div></md-toolbar><a4-block-message></a4-block-message><md-content id=\"content\" class=\"md-hue-2\" ms-scroll=\"\" flex=\"\" ui-view=\"\" style=\"background-color: whitesmoke !important;\"></md-content><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav><md-sidenav ui-view=\"sidenav\" id=\"sidenav-global\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-global\" ms-scroll=\"\"></md-sidenav></div></div></div>");
$templateCache.put("app/crm/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{crm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{crm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in crm.languages\"><md-button ng-click=\"crm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm=\"\">{{ crm.userLocal.name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.PREFERENCES\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"crm.confirmPassword()\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.CHANGE_PASSWORD\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.dashboard\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button>{{ \'Painel de Controle\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"crm.lockScreen()\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.LOCK_SCREEN\' | translate }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"crm.logout()\">{{ \'TOOLBAR.LOG_OUT\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/educational/educational.html","<div class=\"board-list a4-center-all\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"educational.reload_page != null\"><div class=\"board-list-item\" layout=\"column\" layout-align=\"center center\"><div class=\"show-system\"><div><img ng-src=\"{{educational.system.icon}}\" alt=\"\"></div><div class=\"board-name\"><b>{{educational.system.name}}</b></div></div></div></div><div class=\"progress-div-alfa\" ng-show=\"$root.show_loader\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando, por favor aguarde...</p></md-card-content></md-card></div></div></div><div id=\"main\" class=\"animate-slide-up\" ui-view=\"main\" layout=\"column\" ng-if=\"educational.reload_page == null\"><div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav ng-if=\"educational.menu_able && educational.profile_selected != null\" id=\"vertical-navigation\" class=\"md-sidenav-left cursor-pointer\" md-component-id=\"navigation\" md-is-open=\"true\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=\"4\"><md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo layout-row\" layout=\"row\" layout-align=\"start center\" style=\"padding: 0 16px !important;\" ng-click=\"educational.toggleA4MenuSystem()\"><span class=\"logo-image md-accent-bg\">A4</span> <span class=\"logo-text\">Educacional</span> <span class=\"logo-text\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16 hide-sm md-font material-icons icon-chevron-down\" hide-sm=\"\" aria-hidden=\"true\"></md-icon></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"educational.toggleMsNavigationFolded()\"></md-icon></md-toolbar><a4-menu-system></a4-menu-system><div class=\"md-padding\" ng-if=\"educational.show_school_period\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\" style=\"background-color: #2d323e !important; margin-bottom: 0;\"><label class=\"select-text-index\">Periodo Letivo</label><md-select ng-model=\"educational.school_period.selected\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-disabled=\"educational.company_id == 20 && educational.checkPolicies(\'troca_periodo_letivo\')\" ng-change=\"educational.schoolPeriodChange(educational.school_period.selected)\" class=\"select-text-index\"><md-option ng-value=\"period\" ng-repeat=\"period in educational.school_period.list\">{{period.name}}</md-option></md-select></md-input-container></div><ms-navigation class=\"flex-scrollable\" folded=\"educational.folded\" root=\"educational\" ms-scroll=\"educational.msScrollOptions\"></ms-navigation><ms-navigation class=\"scrollable\" folded=\"educational.folded\" root=\"secretary\" ms-scroll=\"educational.msScrollOptions\"></ms-navigation><ms-navigation class=\"scrollable\" folded=\"educational.folded\" root=\"coordination\" ms-scroll=\"educational.msScrollOptions\"></ms-navigation><ms-navigation class=\"scrollable\" folded=\"educational.folded\" root=\"config\" ms-scroll=\"educational.msScrollOptions\"></ms-navigation></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><style>\n        @media screen and (max-width: 500px) {\n          #toolbar {\n            font-size: 13px;\n          }\n\n          #toolbar md-select {\n            max-width: 42%;\n          }\n        }\n      </style><md-toolbar id=\"toolbar\" class=\"md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"educational.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon ng-scope md-default-theme md-font material-icons icon-menu\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></md-button></div><md-select class=\"account-selection simplified\" aria-label=\"Current Company\" ng-if=\"educational.change_company_able || (( educational.companySelected == 101330 || educational.companySelected == 101329 || educational.companySelected == 127252 || educational.companySelected == 101258 || educational.companySelected == 733 ) && (educational.profile_selected == 1 && educational.companies.length > 1))\" ng-change=\"educational.changeCompany(educational.companySelected)\" ng-model=\"educational.companySelected\" style=\"color: black;\"><md-option ng-repeat=\"company in educational.companies\" value=\"{{company.id}}\" ng-selected=\"educational.companySelected == company.id\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img class=\"avatar\" ng-src=\"https://api.a4cloud.com.br/upload/brands/{{educational.subdomain}}.png\"></div><span class=\"companyname\" hide-sm=\"\">{{ company.name || company.corporate_name }}</span></div></md-option></md-select><div layout=\"row\" layout-align=\"end center\" class=\"ng-scope layout-align-start-center layout-row\" ng-include=\"educational.toolbar\"></div></md-toolbar><a4-block-message></a4-block-message><md-content id=\"content\" class=\"md-hue-2\" ms-scroll=\"\" flex=\"\" ui-view=\"\" ng-if=\"educational.profile_selected != null\" style=\"background-color: whitesmoke !important;\"></md-content></div></div></div>");
$templateCache.put("app/educational/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{educational.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{educational.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in educational.languages\"><md-button ng-click=\"educational.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm=\"\">{{ educational.userLocal.name }}</span> <span class=\"profile-current\" translate=\"{{TOOLBAR}}\"></span> <small class=\"profile-current\">{{educational.listProfileName[educational.profile_selected]}}</small><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-if=\"index.context.user_profiles > 1\" ng-click=\"index.logoutToSwitchProfile()\"><md-icon md-font-icon=\"icon-swap-horizontal\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.CHANGE_PROFILE\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"educational.confirmPassword()\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.CHANGE_PASSWORD\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.dashboard\" policy-access=\"control_panel\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button>{{ \'Painel de Controle\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"educational.lockScreen()\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.LOCK_SCREEN\' | translate }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"educational.logout()\">{{ \'TOOLBAR.LOG_OUT\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/evaluations/evaluations.html","<div class=\"board-list a4-center-all\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"evaluations.reload_page != null\"><div class=\"board-list-item\" layout=\"column\" layout-align=\"center center\"><div class=\"show-system\"><div><img ng-src=\"{{evaluations.system.icon}}\" alt=\"\"></div><div class=\"board-name\"><b>{{evaluations.system.name}}</b></div></div></div></div><div class=\"progress-div-alfa\" ng-show=\"$root.show_loader\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando, por favor aguarde...</p></md-card-content></md-card></div></div></div><div id=\"main\" class=\"animate-slide-up\" ui-view=\"main\" layout=\"column\" ng-if=\"evaluations.reload_page == null\"><div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-sidenav-left cursor-pointer\" md-component-id=\"navigation\" md-is-open=\"true\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=\"4\"><md-toolbar class=\"navigation-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools md-toolbar-tools-top logo layout-row\" layout=\"row\" layout-align=\"start center\" ng-click=\"evaluations.toggleA4MenuSystem()\"><span class=\"logo-image md-accent\">A4</span> <span class=\"logo-text\">Avaliações</span> <span class=\"logo-text\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16 hide-sm md-font material-icons icon-chevron-down\" hide-sm=\"\" aria-hidden=\"true\"></md-icon></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"evaluations.toggleMsNavigationFolded()\"></md-icon></md-toolbar><a4-menu-system></a4-menu-system><ms-navigation class=\"scrollable\" folded=\"evaluations.folded\" root=\"evaluations\" ms-scroll=\"evaluations.msScrollOptions\"></ms-navigation><ms-navigation class=\"scrollable\" folded=\"evaluations.folded\" root=\"knowledge\" ms-scroll=\"evaluations.msScrollOptions\"></ms-navigation><ms-navigation class=\"scrollable\" folded=\"evaluations.folded\" root=\"questionnaire\" ms-scroll=\"evaluations.msScrollOptions\"></ms-navigation><ms-navigation class=\"scrollable\" folded=\"evaluations.folded\" root=\"eval-configurations\" ms-scroll=\"evaluations.msScrollOptions\"></ms-navigation></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"evaluations.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon ng-scope md-default-theme md-font material-icons icon-menu\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></md-button></div><md-select class=\"account-selection simplified\" aria-label=\"Current Company\" ng-change=\"evaluations.changeCompany(evaluations.companySelected)\" ng-model=\"evaluations.companySelected\"><md-option ng-repeat=\"company in evaluations.companies\" value=\"{{company.id}}\" ng-selected=\"evaluations.companySelected == company.id\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img class=\"avatar\" src=\"assets/images/avatars/default-building.jpg\"></div><span class=\"companyname\" hide-sm=\"\">{{ company.name || company.corporate_name }}</span></div></md-option></md-select><div layout=\"row\" layout-align=\"end center\" class=\"ng-scope layout-align-start-center layout-row\" ng-include=\"evaluations.toolbar\"></div></md-toolbar><a4-block-message></a4-block-message><md-content id=\"content\" class=\"md-hue-2\" ms-scroll=\"\" flex=\"\" ui-view=\"\" style=\"background-color: whitesmoke !important;\"></md-content><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav><md-sidenav ui-view=\"sidenav\" id=\"sidenav-global\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-global\" ms-scroll=\"\"></md-sidenav></div></div></div>");
$templateCache.put("app/evaluations/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{evaluations.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{evaluations.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in evaluations.languages\"><md-button ng-click=\"evaluations.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm=\"\">{{ evaluations.userLocal.name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.PREFERENCES\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"evaluations.confirmPassword()\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.CHANGE_PASSWORD\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.dashboard\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button>{{ \'Painel de Controle\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"evaluations.lockScreen()\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.LOCK_SCREEN\' | translate }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"evaluations.logout()\">{{ \'TOOLBAR.LOG_OUT\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/finance/finance.html","<div class=\"board-list a4-center-all\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"finance.reload_page != null\"><div class=\"board-list-item\" layout=\"column\" layout-align=\"center center\"><div class=\"show-system\"><div><img ng-src=\"{{finance.system.icon}}\" alt=\"\"></div><div class=\"board-name\"><b>{{finance.system.name}}</b></div></div></div></div><div class=\"progress-div-alfa\" ng-show=\"$root.show_loader\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando, por favor aguarde...</p></md-card-content></md-card></div></div></div><div id=\"main\" class=\"animate-slide-up\" ui-view=\"main\" layout=\"column\" ng-if=\"finance.reload_page == null\"><div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-sidenav-left cursor-pointer\" md-component-id=\"navigation\" md-is-open=\"true\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=\"4\"><md-toolbar class=\"navigation-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools md-toolbar-tools-top logo layout-row\" layout=\"row\" layout-align=\"start center\" ng-click=\"finance.toggleA4MenuSystem()\"><span class=\"logo-image md-accent\">A4</span> <span class=\"logo-text\">Financeiro</span> <span class=\"logo-text\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16 hide-sm md-font material-icons icon-chevron-down\" hide-sm=\"\" aria-hidden=\"true\"></md-icon></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"finance.toggleMsNavigationFolded()\"></md-icon></md-toolbar><a4-menu-system></a4-menu-system><ms-navigation class=\"scrollable\" folded=\"finance.folded\" root=\"finance\" ms-scroll=\"finance.msScrollOptions\"></ms-navigation></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"finance.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon ng-scope md-default-theme md-font material-icons icon-menu\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></md-button></div><md-select class=\"account-selection simplified\" aria-label=\"Current Company\" ng-change=\"finance.changeCompany(finance.companySelected)\" ng-model=\"finance.companySelected\"><md-option ng-repeat=\"company in finance.companies\" value=\"{{company.id}}\" ng-selected=\"finance.companySelected == company.id\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img class=\"avatar\" src=\"assets/images/avatars/default-building.jpg\"></div><span class=\"companyname\" hide-sm=\"\">{{ company.name || company.corporate_name }}</span></div></md-option></md-select><div layout=\"row\" layout-align=\"end center\" class=\"ng-scope layout-align-start-center layout-row\" ng-include=\"finance.toolbar\"></div></md-toolbar><a4-block-message></a4-block-message><md-content id=\"content\" class=\"md-hue-2\" ms-scroll=\"\" flex=\"\" ui-view=\"\" style=\"background-color: whitesmoke !important;\"></md-content><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav><md-sidenav ui-view=\"sidenav\" id=\"sidenav-global\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-global\" ms-scroll=\"\"></md-sidenav></div></div></div>");
$templateCache.put("app/finance/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{finance.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{finance.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in finance.languages\"><md-button ng-click=\"finance.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm=\"\">{{ finance.userLocal.name }}</span> <small class=\"profile-current\">{{finance.listProfileName[finance.profile_selected]}}</small><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-if=\"index.context.user_profiles > 1\" ng-click=\"index.switchProfile(index.context)\"><md-icon md-font-icon=\"icon-swap-horizontal\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.CHANGE_PROFILE\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.PREFERENCES\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"finance.confirmPassword()\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.CHANGE_PASSWORD\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.dashboard\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button>{{ \'Painel de Controle\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"finance.lockScreen()\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.LOCK_SCREEN\' | translate }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"finance.logout()\">{{ \'TOOLBAR.LOG_OUT\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"lock-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\" style=\"padding: 10px 32px 15px 32px !important;\"><h4 style=\"text-align: center\">{{vm.user.name}}</h4><div layout=\"row\" layout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img class=\"avatar big\" ng-src=\"{{ vm.user.image }}\"><md-icon md-font-icon=\"icon-lock\" class=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex=\"\" layout=\"column\" layout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title\">{{ \'LOCK.TITLE\' | translate }}</div><div class=\"subtitle\">{{ \'LOCK.SUBTITLE\' | translate }}</div></div></div><form name=\"lockForm\" novalidate=\"\" ng-submit=\"vm.unLockSystem(vm.form)\" layout=\"column\"><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><input ng-model=\"vm.form.usermail\" placeholder=\"Username\" translate=\"\" translate-attr-placeholder=\"{{ \'LOCK.USERNAME\' | translate }}\" disabled=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"{{ \'LOCK.PASSWORD\' | translate }}\" required=\"\"><div ng-messages=\"lockForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'LOCK.ERRORS.PASSWORD_REQUIRED\' | translate }}</span></div></div></md-input-container><div flex=\"\"><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" ng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate-attr-aria-label=\"{{ \'LOCK.UNLOCK\' | translate }}\">{{ \'LOCK.UNLOCK\' | translate }}</md-button><md-button md-theme=\"educational\" ng-click=\"vm.logout()\" style=\"margin-top: -30px;\" class=\"md-raised md-accent submit-button\">Sair</md-button></div></form></div></div></div>");
$templateCache.put("app/process/process.html","<div class=\"board-list a4-center-all\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"process.reload_page != null\"><div class=\"board-list-item\" layout=\"column\" layout-align=\"center center\"><div class=\"show-system\"><div><img ng-src=\"{{process.system.icon}}\" alt=\"\"></div><div class=\"board-name\"><b>{{process.system.name}}</b></div></div></div></div><div class=\"progress-div-alfa\" ng-show=\"$root.show_loader\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando, por favor aguarde...</p></md-card-content></md-card></div></div></div><div id=\"main\" class=\"animate-slide-up\" ui-view=\"main\" layout=\"column\" ng-if=\"process.reload_page == null\"><div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-sidenav-left cursor-pointer\" md-component-id=\"navigation\" md-is-open=\"true\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=\"4\"><md-toolbar class=\"navigation-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools md-toolbar-tools-top logo layout-row\" layout=\"row\" layout-align=\"start center\" ng-click=\"process.toggleA4MenuSystem()\"><span class=\"logo-image md-accent\">A4</span> <span class=\"logo-text\">Solictações</span> <span class=\"logo-text\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16 hide-sm md-font material-icons icon-chevron-down\" hide-sm=\"\" aria-hidden=\"true\"></md-icon></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"process.toggleMsNavigationFolded()\"></md-icon></md-toolbar><a4-menu-system></a4-menu-system><ms-navigation class=\"scrollable\" folded=\"process.folded\" root=\"process\" ms-scroll=\"process.msScrollOptions\"></ms-navigation></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"process.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon ng-scope md-default-theme md-font material-icons icon-menu\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></md-button></div><md-select class=\"account-selection simplified\" aria-label=\"Current Company\" ng-change=\"process.changeCompany(process.companySelected)\" ng-model=\"process.companySelected\"><md-option ng-repeat=\"company in process.companies\" value=\"{{company.id}}\" ng-selected=\"process.companySelected == company.id\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img class=\"avatar\" src=\"assets/images/avatars/default-building.jpg\"></div><span class=\"companyname\" hide-sm=\"\">{{ company.name || company.corporate_name }}</span></div></md-option></md-select><div layout=\"row\" layout-align=\"end center\" class=\"ng-scope layout-align-start-center layout-row\" ng-include=\"process.toolbar\"></div></md-toolbar><a4-block-message></a4-block-message><md-content id=\"content\" class=\"md-hue-2\" ms-scroll=\"\" flex=\"\" ui-view=\"\" style=\"background-color: whitesmoke !important;\"></md-content><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav><md-sidenav ui-view=\"sidenav\" id=\"sidenav-global\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-global\" ms-scroll=\"\"></md-sidenav></div></div></div>");
$templateCache.put("app/process/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{process.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{process.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in process.languages\"><md-button ng-click=\"process.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm=\"\">{{ process.userLocal.name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.PREFERENCES\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"process.confirmPassword()\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.CHANGE_PASSWORD\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.dashboard\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button>{{ \'Painel de Controle\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"process.lockScreen()\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.LOCK_SCREEN\' | translate }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"process.logout()\">{{ \'TOOLBAR.LOG_OUT\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/stock/stock.html","<div class=\"board-list a4-center-all\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"stock.reload_page != null\"><div class=\"board-list-item\" layout=\"column\" layout-align=\"center center\"><div class=\"show-system\"><div><img ng-src=\"{{stock.system.icon}}\" alt=\"\"></div><div class=\"board-name\"><b>{{stock.system.name}}</b></div></div></div></div><div class=\"progress-div-alfa\" ng-show=\"$root.show_loader\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando, por favor aguarde...</p></md-card-content></md-card></div></div></div><div id=\"main\" class=\"animate-slide-up\" ui-view=\"main\" layout=\"column\" ng-if=\"stock.reload_page == null\"><div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-sidenav-left cursor-pointer\" md-component-id=\"navigation\" md-is-open=\"true\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=\"4\"><md-toolbar class=\"navigation-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools md-toolbar-tools-top logo layout-row\" layout=\"row\" layout-align=\"start center\" ng-click=\"stock.toggleA4MenuSystem()\"><span class=\"logo-image md-accent\">A4</span> <span class=\"logo-text\">Estoque</span> <span class=\"logo-text\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16 hide-sm md-font material-icons icon-chevron-down\" hide-sm=\"\" aria-hidden=\"true\"></md-icon></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"stock.toggleMsNavigationFolded()\"></md-icon></md-toolbar><a4-menu-system></a4-menu-system><ms-navigation class=\"scrollable\" folded=\"stock.folded\" root=\"stock\" ms-scroll=\"stock.msScrollOptions\"></ms-navigation></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"stock.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon ng-scope md-default-theme md-font material-icons icon-menu\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></md-button></div><md-select class=\"account-selection simplified\" aria-label=\"Current Company\" ng-change=\"stock.changeCompany(stock.companySelected)\" ng-model=\"stock.companySelected\"><md-option ng-repeat=\"company in stock.companies\" value=\"{{company.id}}\" ng-selected=\"stock.companySelected == company.id\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img class=\"avatar\" src=\"assets/images/avatars/default-building.jpg\"></div><span class=\"companyname\" hide-sm=\"\">{{ company.name || company.corporate_name }}</span></div></md-option></md-select><div layout=\"row\" layout-align=\"end center\" class=\"ng-scope layout-align-start-center layout-row\" ng-include=\"stock.toolbar\"></div></md-toolbar><a4-block-message></a4-block-message><md-content id=\"content\" class=\"md-hue-2\" ms-scroll=\"\" flex=\"\" ui-view=\"\" style=\"background-color: whitesmoke !important;\"></md-content><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav><md-sidenav ui-view=\"sidenav\" id=\"sidenav-global\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-global\" ms-scroll=\"\"></md-sidenav></div></div></div>");
$templateCache.put("app/stock/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{stock.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{stock.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in stock.languages\"><md-button ng-click=\"stock.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm=\"\">{{ stock.userLocal.name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.PREFERENCES\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"stock.confirmPassword()\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.CHANGE_PASSWORD\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"private.controlpanel.dashboard\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button>{{ \'Painel de Controle\' | translate }}</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"stock.lockScreen()\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\"></md-icon><md-button>{{ \'TOOLBAR.LOCK_SCREEN\' | translate }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"stock.logout()\">{{ \'TOOLBAR.LOG_OUT\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/components/a4-address/a4-address.html","<md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" ng-class=\"{\'show_error\': vm.cep_error}\"><label class=\"isEnabled\" ng-style=\"vm.cep_error && {\'color\': \'red\'}\">CEP</label> <input ng-model=\"model.address_postal_code\" ui-br-cep-mask=\"\" ng-blur=\"vm.getAddressByCep(model.address_postal_code)\" ng-disabled=\"!isEnabled || (model.person_id_address !== null && hasOwner)\" ng-class=\"{\'ng-invalid\': vm.cep_error}\" ng-required=\"((formScope == \'EMPLOYEE\' && vm.required_fields_employee.address_postal_code.is_mandatory) || (formScope == \'RESPONSIBLE\' && ((model.am_i.is_responsible && vm.required_fields_responsible.address_postal_code.is_mandatory) || (model.am_i.is_payee && vm.required_fields_payee.address_postal_code.is_mandatory))) || (formScope == \'STUDENT\' && vm.required_fields_student.address_postal_code.is_mandatory)) || model.is_payee\"><div class=\"md-input-message-animation\" ng-if=\"vm.cep_error\">CEP não encontrado ou inválido!</div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" layout=\"row\" flex-gt-xs=\"\" ng-disabled=\"!isEnabled\" style=\"margin-bottom: 0 !important;\"><label class=\"isEnabled\">Endereço</label><md-progress-circular ng-show=\"vm.waiting_cep\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-progress-circular ng-show=\"vm.waiting_address\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><input ng-model=\"model.address_street\" ng-disabled=\"!isEnabled || (model.person_id_address !== null && hasOwner)\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin-bottom: 25px !important;\"><label class=\"isEnabled\">Número</label> <input ng-model=\"model.address_house_number\" id=\"number\" ng-disabled=\"!isEnabled || (model.person_id_address !== null && hasOwner)\" maxlength=\"30\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin-bottom: 5px;\"><label class=\"isEnabled\">Complemento</label> <input ng-model=\"model.address_line2\" ng-disabled=\"!isEnabled || (model.person_id_address !== null && hasOwner)\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin-bottom: 0;\"><label class=\"isEnabled\">Bairro</label><md-progress-circular ng-show=\"vm.waiting_address\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><input ng-model=\"model.address_district\" ng-disabled=\"!isEnabled || (model.person_id_address !== null && hasOwner)\"></md-input-container><div layout=\"column\" style=\"width: 100%; margin-right: 3px;\"><label for=\"select-state\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Estado</span></label><select2 ng-model=\"model.address_state\" ng-disabled=\"!isEnabled || (model.person_id_address !== null && hasOwner)\" s2-options=\"val.id as val.name for val in vm.states\" id=\"select-state\"><md-option ng-if=\"vm.states.length === 0\" value=\"null\">{{model.state_name}}</md-option></select2></div><div layout=\"column\" style=\"width: 100%;\"><md-input-container style=\"width: 100%;\"><label style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Cidade</label><input type=\"text\" ng-model=\"model.address_city\" ng-change=\"vm.filterCities(model.address_city)\" ng-disabled=\"!isEnabled || (model.person_id_address !== null && hasOwner)\" ng-blur=\"vm.handleCityBlur()\" placeholder=\"Digite o nome da cidade\" style=\"width: 100%; border-bottom:1px solid #cececeef;\"><md-list ng-show=\"vm.isListVisible && vm.filteredCities.length > 0\" ng-click=\"stopPropagation($event)\"><md-list-item ng-repeat=\"item in vm.filteredCities\" ng-click=\"vm.selectCity(item)\"><span>{{item.name}}</span></md-list-item></md-list></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"showPhone !== false\"><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\"><label class=\"isEnabled\">Telefone (DDD obrigatório)</label> <input ng-model=\"model.phone_landline\" type=\"text\" ui-br-phone-number=\"\" name=\"responsible_phone_landline\" ng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 2000, \'blur\': 0} }\" ng-disabled=\"!isEnabled || (model.person_id_address !== null && hasOwner)\" minlength=\"11\"><div ng-messages=\"formCopy.responsible_phone_landline.$error\"><div ng-message=\"minlength\">Insira o telefone no formato <b>(XX) XXXX-XXXX</b> ou <b>(XX) XXXXX-XXXX</b></div></div></md-input-container><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\"><label class=\"isEnabled\">Telefone 2 (DDD obrigatório)</label> <input ng-model=\"model.phone_landline_2\" type=\"text\" ui-br-phone-number=\"\" name=\"responsible_phone_landline_2\" ng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 2000, \'blur\': 0} }\" ng-disabled=\"!isEnabled || (model.person_id_address !== null && hasOwner)\" minlength=\"11\"><div ng-messages=\"formCopy.responsible_phone_landline_2.$error\"><div ng-message=\"minlength\">Insira o telefone no formato <b>(XX) XXXX-XXXX</b> ou <b>(XX) XXXXX-XXXX</b></div></div></md-input-container></div>");
$templateCache.put("app/components/a4-app-log/index.html","<div id=\"timeline\" class=\"timeline-right\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item=\"\" layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in timeline\"><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><img ng-src=\"{{timelineItem.icon}}\" style=\"border-radius: 50%\"></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\"><span class=\"badge badgeLog badgeRight\" ng-class=\"vm.item_module_app[timelineItem.sys_module_app]\">{{timelineItem.module}}</span> <span class=\"badge badgeLog badgeRight\" ng-class=\"vm.defineTypeBadge(timelineItem.type).cssClass\">{{vm.defineTypeBadge(timelineItem.type).title}}</span></div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/components/a4-autocomplete/autocomplete.html","<div layout=\"row\"><md-progress-circular ng-show=\"showLoader\" class=\"md-hue-2 submit-loading\" style=\"margin-top: 20px;\" md-diameter=\"15px\"></md-progress-circular><md-autocomplete flex=\"\" style=\"padding-top: 6px;\" md-input-id=\"{{inputId}}\" ng-disabled=\"showLoader || disabled\" md-no-cache=\"true\" ng-required=\"required\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-selected-item-change=\"vm.internSelectedItemChange(item);\" md-search-text-change=\"vm.internSelectedItemChange(item);\" md-items=\"item in vm.internSearch(searchText)\" md-item-text=\"item[itemText]\" md-input-minlength=\"1\" md-min-length=\"0\" md-delay=\"1000\" md-mode=\"standard\" md-floating-label=\"{{label}}\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item[itemText]}}</span></md-item-template></md-autocomplete></div>");
$templateCache.put("app/components/a4-bank-slip/a4-bank-slip-details.html","<md-dialog aria-label=\"Detalhamento do boleto\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"detailment\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">Detalhes do boleto</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-padding\" layout=\"column\"><div style=\"margin-bottom: 20px;\" flex=\"100\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Títulos</b></div></div><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Beneficiário</th><th md-column=\"\">Data de vencimento</th><th md-column=\"\" md-numeric=\"\">Valor Princiapl</th><th md-column=\"\" md-numeric=\"\">Desconto</th><th md-column=\"\" md-numeric=\"\">Multa</th><th md-column=\"\" md-numeric=\"\">Juros</th><th md-column=\"\" md-numeric=\"\">Diferença</th><th md-column=\"\" md-numeric=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.bills\"><td md-cell=\"\">{{item.beneficiary_name}}</td><td md-cell=\"\">{{item.due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.amount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.discount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.interest | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.fine | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.difference | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"><b>Total</b></td><td md-cell=\"\">{{vm.getAmountTotal() | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td></tr></tbody></table></md-table-container></div><div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"\" style=\"width: 50%;margin: 5px;\"><label for=\"select-account\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Conta corrente de saída*</span></label><select2 ng-model=\"vm.current_account\" s2-options=\"val.id as val.name for val in vm.all_current_accounts\" id=\"select-account\" required=\"\"></select2></div><div layout=\"column\" flex=\"\" style=\"width: 50%;margin: 5px;\"><label for=\"select-movement\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Forma de saída*</span></label><select2 ng-model=\"vm.movement_type\" s2-options=\"val.id as val.name for val in vm.movementTypes\" id=\"select-movement\" required=\"\"></select2></div></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Ao realizar o reembolso do boleto, será criado um movimento de saída na conta corrente selecionada<br>e os títulos relacionados serão cancelados. Porém, o boleto continuará com status liquidado<br>e uma observação informando que foi reembolsado.</b></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><div layout=\"row\"><span flex=\"\"></span><md-button type=\"submit\" ng-click=\"vm.confirm()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\" ng-disabled=\"vm.movement_type == null || vm.current_account == null\">Confirmar reembolso</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-bank-slip/bank_slip_second_way.html","<md-dialog aria-label=\"Segunda via de boleto\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"second_way\" ng-submit=\"vm.doSecondBankSlip()\"><md-toolbar><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"space-between\" flex=\"90\"><h3>Vencimento: {{vm.bank_slip.due_date | date:\'dd/MM/yyyy\'}}</h3></div><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 5px;\" flex=\"\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Reprogramação de <span ng-if=\"!vm.is_bill\">boleto</span><span ng-if=\"vm.is_bill\">título</span></b> <small ng-if=\"!vm.is_bill\">Ao pedir reprogramação de um boleto, o anterior é cancelado e este se o torna o valido</small></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 5px; margin-top: 15px;\" flex=\"\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Reprogramação do vencimento (opcional)</b> <small>Você pode reprogramar apenas o valor. Ao deixar a data de reprogramação em branco, a data de vencimento original será mantida.</small></div></div><div flex=\"\"><date-picker placeholder=\"Nova data de vencimento\" flex=\"\" name=\"second_due_date\" min-date=\"vm.limit_date\" ng-change=\"vm.changeDueDate(vm.bank_slip.second_due_date)\" ng-model=\"vm.bank_slip.second_due_date\"></date-picker></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-top: 15px;\" flex=\"\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Reprogramação do valor (opcional)</b> <small>Ao reprogramar o valor, este novo valor será mantido até a data de vencimento sem aplicação de descontos.</small></div></div><div flex=\"\"><md-input-container><md-icon md-font-icon=\"icon-currency-usd\" class=\"s20 name\"></md-icon><input ng-model=\"vm.bank_slip.amount\" ui-money-mask=\"\"></md-input-container></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\" flex=\"\" ng-if=\"vm.bank_slip.is_expired\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Acrescimos e Descontos</b> <small>Abaixo se encontram opções de manipulação de acrescimos e descontos.</small></div></div><div flex=\"\" ng-if=\"vm.bank_slip.is_expired\"><md-radio-group ng-model=\"vm.bank_slip.operation\" class=\"md-primary\"><md-radio-button ng-value=\"0\">Apenas altera a data de vencimento, {{ vm.bank_slip.amount | currency }}<br></md-radio-button><md-radio-button ng-value=\"1\">Inclui valor dos acrescimos calculados até o novo vencimento. {{ vm.final_value | currency }}<br></md-radio-button></md-radio-group></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-top: 5px;\" flex=\"\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Reprogramação condicional</b> <small>Ao especificar como condicional, a reprogramação só será válida até a data de vencimento. Caso o título não seja liquidado até a data de vencimento, a reprogramação perde o efeito e o título retorna para as condições originais.</small></div></div><div flex=\"\"><md-input-container ng-if=\"vm.is_bill\"><md-checkbox ng-model=\"vm.bank_slip.is_conditional_reschedule\">Reprogramação condicional</md-checkbox></md-input-container></div></div></md-dialog-content><md-dialog-actions style=\"background-color: whitesmoke;\"><md-button type=\"submit\" class=\"md-raised\" ng-disabled=\"vm.show_loader\"><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" ng-if=\"vm.show_loader\" md-mode=\"indeterminate\"></md-progress-circular>Reprogramar <span ng-if=\"!vm.is_bill\">boleto</span><span ng-if=\"vm.is_bill\">título</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-bank-slip/index.html","<md-content style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" layout=\"column\"><md-content layout=\"column\"><md-content layout=\"row\" style=\"overflow: hidden\"><date-range-picker flex=\"25\" ng-model=\"vm.filter_date\" label=\"Datas\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker><md-input-container flex=\"\" ng-if=\"currentAccountFilter\"><label style=\"margin: 0 !important;\">{{ \'BANK_SLIP.FORM_ACCOUNT\' | translate }}</label><md-icon md-font-icon=\"icon-bank\"></md-icon><md-select name=\"current_account\" ng-model=\"vm.current_account\"><md-option ng-value=\"account.id\" ng-repeat=\"account in vm.current_accounts\">{{ account.name }}</md-option></md-select><div ng-messages=\"formPerson.sex.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'BANK_SLIP.FORM_ACCOUNT_REQUIRED\' | translate }}</span></div></div></md-input-container><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Buscar\" flex=\"5\" ng-click=\"vm.getAllBankSlipPaginate(1, 25, vm.status, vm.filter_date);\"><md-tooltip md-direction=\"bottom\">Consultar</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-table-pagination flex=\"\" style=\"border-top: none\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.bank_slip_paginate.per_page\" md-page=\"vm.bank_slip_paginate.current_page\" md-on-paginate=\"vm.getAllBankSlipPaginate\" md-limit-options=\"[15, 25, 50, 75, 100]\" md-total=\"{{vm.bank_slip_paginate.total}}\"></md-table-pagination></md-content><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.status != vm.BANK_SLIP_STATUS_PAID && canEdit\"><div class=\"md-toolbar-tools\" layout-align=\"space-between\"><div style=\"color: #08cc75; padding-top: 20px;\">Boletos selecionados {{vm.selected_bank_slip.length}}</div><div ng-if=\"vm.status == vm.BANK_SLIP_STATUS_SENT || vm.status == vm.BANK_SLIP_STATUS_DONE\"><md-button class=\"md-icon-button\" aria-label=\"Imprimir boletos selecionados\" ng-disabled=\"vm.selected_bank_slip.length < 1\" ng-click=\"vm.printBankSlip()\" style=\"padding-top: 20px;\" title=\"Selecione pelo menos 2 (Dois) boletos.\"><md-tooltip md-direction=\"top\">Ver boletos selecionados</md-tooltip><md-icon ng-class=\"{\'print-and-slip\': vm.selected_bank_slip.length > 1}\" md-font-icon=\"icon-printer\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Enviar lista de e-mails com boletos\" style=\"padding-top: 20px;\" ng-disabled=\"vm.selected_bank_slip.length <= 1\" ng-click=\"vm.sendMail();\"><md-tooltip md-direction=\"top\">Enviar por email boletos selecionados</md-tooltip><md-icon ng-class=\"{\'print-and-slip\': vm.selected_bank_slip.length > 1}\" md-font-icon=\"icon-email\"></md-icon></md-button></div></div></md-toolbar><md-table-container style=\"padding-left: 10px; padding-right: 10px\"><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"vm.selected_bank_slip\" md-row-select=\"\" multiple=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Serviços</span></th><th md-column=\"\">Boletos</th><th md-column=\"\">Vencimento</th><th md-column=\"\">Status</th><th md-column=\"\" md-numeric=\"\">Valor Original</th><th md-column=\"\" style=\"text-align: center\">Ações</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"bank_slip\" md-select-id=\"bill_ids\" md-on-select=\"vm.generateLink()\" md-on-deselect=\"vm.generateLink()\" ng-repeat=\"bank_slip in vm.bank_slip_paginate.data\"><td md-cell=\"\"><b>{{bank_slip.name}}</b><br><small class=\"td-second-line\" ng-repeat=\"beneficiaries in vm.formatBeneficiaries(bank_slip.beneficiaries) | unique\">{{ vm.formatName(beneficiaries) }}<br></small></td><td md-cell=\"\"><span class=\"td-second-line\" ng-repeat=\"service in vm.formatServices(bank_slip.services) | unique\">{{ vm.formatName(service) }}<br></span></td><td md-cell=\"\">{{bank_slip.bank_slip_description}}</td><td md-cell=\"\">{{bank_slip.due_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\">{{bank_slip.status}} <span ng-if=\"(bank_slip.bank_slip_cancel_status_id === vm.CANCELED_REFUND)\" style=\"background-color: #ff7e00;color: white;padding: 4px;border-radius: 6px\">Reembolsado</span> <span ng-if=\"(bank_slip.bank_slip_cancel_status_id !== null && bank_slip.bank_slip_cancel_status_id !== vm.NOT_CANCELED) && bank_slip.bank_slip_cancel_status_id !== vm.CANCELED_REFUND\" style=\"background-color: red;color: white;padding: 4px;border-radius: 6px\">Cancelado</span> <span ng-if=\"(bank_slip.paid_bill_id !== null)\" style=\"background-color: #279312;color: white;padding: 4px;border-radius: 6px\">Possui título pago</span></td><td md-cell=\"\" md-numeric=\"\">{{ (bank_slip.amount - bank_slip.discount_fixed_value) | currency }}</td><td md-cell=\"\" style=\"text-align: center\"><md-button class=\"md-button\" ng-if=\"bank_slip.bank_slip_status_id == 6 && bank_slip.bank_slip_cancel_status_id !== vm.CANCELED_REFUND\" ng-click=\"vm.getDetailsByBankSlipId(bank_slip);\" policy-access=\"cobanc_bol_cancel\"><md-icon md-menu-origin=\"\">money_off</md-icon>Reembolso</md-button><div><md-button class=\"md-icon-print md-icon-button\" ng-if=\"(bank_slip.bank_number == null && bank_slip.number == 1 && bank_slip.current_account_type_id == 8) || (bank_slip.bank_number != null && ((bank_slip.bank_slip_cancel_status_id === vm.NOT_CANCELED) && bank_slip.bank_slip_status_id < 4))\" aria-label=\"Gerar boleto PDF\" ng-click=\"vm.getBankSlipA4Pag(\'pdf\',bank_slip.due_date, bank_slip.bill_ids_array, bank_slip.bank_slip_id)\"><md-tooltip md-direction=\"left\">Gerar boleto PDF</md-tooltip><md-icon md-font-icon=\"icon-file-pdf\"></md-icon></md-button><md-button class=\"md-icon-print md-icon-button\" ng-if=\"(bank_slip.bank_number == null && bank_slip.number == 1 && bank_slip.current_account_type_id == 8) || (bank_slip.bank_number != null && ((bank_slip.bank_slip_cancel_status_id === vm.NOT_CANCELED) && bank_slip.bank_slip_status_id < 4))\" aria-label=\"Linha digitável\" ng-click=\"vm.getBankSlipA4Pag(\'barcode_number\',bank_slip.due_date, bank_slip.bill_ids_array, bank_slip.bank_slip_id)\"><md-tooltip md-direction=\"left\">Linha digitável</md-tooltip><md-icon md-font-icon=\"icon-barcode\"></md-icon></md-button></div><div ng-if=\"bank_slip.bank_number != null && ((bank_slip.bank_slip_cancel_status_id === vm.NOT_CANCELED) || bank_slip.bank_slip_status_id < 4)\"><md-button class=\"md-icon-print md-icon-button\" policy-access=\"cobanc_bol\" aria-label=\"Reprogramação de boleto\" ng-if=\"bank_slip.bank_slip_status_id !== vm.BANK_SLIP_STATUS_PAID && bank_slip.paid_bill_id === null\" ng-click=\"vm.newBankSlip(bank_slip.bank_slip_id, bank_slip.amount, bank_slip.due_date, bank_slip.fine_max_value, bank_slip.interest_day_value)\"><md-tooltip md-direction=\"left\">Reprogramação de boleto</md-tooltip><md-icon md-font-icon=\"icon-rotate-3d\"></md-icon></md-button><md-button class=\"md-icon-print md-icon-button\" aria-label=\"Cancelar boleto\" policy-access=\"cobanc_bol_cancel\" ng-if=\"bank_slip.bank_slip_status_id !== vm.BANK_SLIP_STATUS_PAID && bank_slip.paid_bill_id === null && bank_slip.bank_slip_cancel_status_id === vm.NOT_CANCELED\" ng-click=\"vm.confirmCancelBankSlip(bank_slip)\"><md-tooltip md-direction=\"left\">Cancelar boleto</md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></td></tr><tr md-row=\"\" ng-if=\"vm.bank_slip_paginate.data.length == 0\"><td md-cell=\"\"></td><td md-cell=\"\">Não há boletos</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></md-content></md-card></md-content>");
$templateCache.put("app/components/a4-bill-grid/a4-bill-grid-details.html","<md-dialog aria-label=\"Detalhamento do titulo\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"detailment\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Título\"><md-dialog-content><div class=\"md-padding\"><md-table-container style=\"margin-top: 15px; margin-bottom: 15px\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"><b>Pessoa:</b></td><td md-cell=\"\">{{vm.bill.name || item.name}}<br><small ng-if=\"vm.bill.beneficiary_name != null\">{{vm.bill.beneficiary_name}}</small></td><td md-cell=\"\"><b>Descrição:</b></td><td md-cell=\"\"><span ng-if=\"vm.bill.product_name !== null\">{{vm.bill.product_name}} -</span>{{vm.bill.description}}</td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"><b>Data de Vencimento:</b></td><td md-cell=\"\">{{vm.bill.due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\"><b>Conta corrente:</b></td><td md-cell=\"\">{{vm.bill.current_account_name}}</td><td md-cell=\"\"><b>Nosso número:</b></td><td md-cell=\"\" md-numeric=\"\">{{vm.bill.bank_number}}</td></tr></tbody></table></md-table-container><div style=\"margin-bottom: 20px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Valores e histórico</b></div></div><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Data de pagamento</th><th md-column=\"\" md-numeric=\"\">Valor A Pagar/Pago</th><th md-column=\"\" md-numeric=\"\">Principal</th><th md-column=\"\" md-numeric=\"\">Desconto</th><th md-column=\"\" md-numeric=\"\">Desconto Cond.</th><th md-column=\"\" md-numeric=\"\">Multa</th><th md-column=\"\" md-numeric=\"\">Juros</th><th md-column=\"\" md-numeric=\"\">Abono</th><th md-column=\"\" md-numeric=\"\">Diferença</th><th md-column=\"\" md-numeric=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.bill.details.partial_paid\"><td md-cell=\"\">{{item.date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.amount_paid | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.amount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.discount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">0,00</td><td md-cell=\"\" md-numeric=\"\">{{item.interest | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.fine | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.allowance | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.difference | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.showPaymentDetails()\"><md-tooltip md-direction=\"right\">Visualizar detalhes</md-tooltip><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.printReceipt(item.bill_action_id)\" ng-if=\"item.cashier_session_id == null\"><md-tooltip md-direction=\"right\">Imprimir recibo</md-tooltip><md-icon md-menu-origin=\"\">receipt</md-icon></md-button></td></tr><tr md-row=\"\" ng-repeat=\"item in vm.bill.details.residual_paid\" ng-if=\"vm.bill.details.partial_paid.length > 0\"><td md-cell=\"\">{{item.date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.amount_paid | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.amount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.discount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">0,00</td><td md-cell=\"\" md-numeric=\"\">{{item.interest | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.fine | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.allowance | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.difference | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.showPaymentDetails()\"><md-tooltip md-direction=\"right\">Visualizar detalhes</md-tooltip><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.printReceipt(1)\" ng-if=\"item.cashier_session_id == null\"><md-tooltip md-direction=\"right\">Imprimir recibo</md-tooltip><md-icon md-menu-origin=\"\">receipt</md-icon></md-button></td></tr><tr md-row=\"\"><td md-cell=\"\" ng-if=\"vm.bill.settlement_date != null && vm.bill.status === 10\">{{vm.bill.settlement_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" ng-if=\"vm.bill.settlement_date == null || vm.bill.status !== 10\">Em aberto</td><td md-cell=\"\" md-numeric=\"\"><span>{{vm.bill.final_value | currency:\' \'}}</span></td><td md-cell=\"\" md-numeric=\"\"><span ng-if=\"vm.bill.partial_payment_msg === null\">{{vm.bill.amount - vm.bill.discount_fixed_value | currency:\' \'}}</span> <span ng-if=\"vm.bill.partial_payment_msg !== null\">{{-(vm.bill.difference) | currency:\' \'}}</span></td><td md-cell=\"\" md-numeric=\"\">{{(vm.bill.status == 10) ? vm.bill.discount : vm.bill.discount_fixed_value | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{vm.bill.calc_discount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{ parseInt(vm.bill.calc_fine_value) < parseInt(vm.bill.fine) ? vm.bill.fine : vm.bill.calc_fine_value | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{(vm.bill.status == 10) ? vm.bill.interest : vm.bill.calc_interest_value | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{vm.bill.allowance | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\"><span ng-if=\"vm.bill.partial_payment_msg === null\">{{vm.bill.difference | currency:\' \'}}</span> <span ng-if=\"vm.bill.partial_payment_msg !== null\">0,00</span></td><td md-cell=\"\"></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-if=\"vm.bill.status == 4\" ng-click=\"vm.showNegotiationDetails()\"><md-tooltip md-direction=\"right\">Visualizar detalhes da negociação</md-tooltip><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-if=\"vm.bill.status == 10\" ng-click=\"vm.showPaymentDetails()\"><md-tooltip md-direction=\"right\">Visualizar detalhes do pagamento</md-tooltip><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.printReceipt(vm.bill.details.residual_paid[vm.bill.details.residual_paid.length - 1].bill_action_id)\" ng-if=\"vm.bill.status == 10 && vm.bill.details.residual_paid[vm.bill.details.residual_paid.length - 1].cashier_session_id === null\"><md-tooltip md-direction=\"right\">Imprimir recibo</md-tooltip><md-icon md-menu-origin=\"\">receipt</md-icon></md-button></td></tr><tr md-row=\"\"><td md-cell=\"\" md-numeric=\"\"><b>Total pago:</b></td><td md-cell=\"\">{{vm.getAmountPaidTotal() | currency:\' \'}}</td><td md-cell=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td></tr></tbody></table></md-table-container></div><div style=\"margin-bottom: 20px;\" ng-if=\"vm.discount_list !== null\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Descontos</b></div></div><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Razão</th><th md-column=\"\" md-numeric=\"\">Valor</th><th md-column=\"\" md-numeric=\"\">Percentual</th><th md-column=\"\">Validade</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.discount_list\"><td md-cell=\"\" style=\"{{item.is_lost ? \'text-decoration: line-through\' : \'\'}}\">{{item.discount_reason}}</td><td md-cell=\"\" md-numeric=\"\" style=\"{{item.is_lost ? \'text-decoration: line-through\' : \'\'}}\">{{item.discount_amount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\" style=\"{{item.is_lost ? \'text-decoration: line-through\' : \'\'}}\">{{(item.discount_amount * 100) / vm.bill.amount | currency:\' \'}}%</td><td md-cell=\"\" style=\"{{item.is_lost ? \'text-decoration: line-through\' : \'\'}}\">{{item.discount_date === null ? \'Fixo\' : item.discount_date | date:\'dd/MM/yyyy\'}}</td></tr></tbody></table></md-table-container></div><div ng-if=\"vm.bill.notes !== \'\' && vm.bill.notes !== null\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103);\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Observações</b> <small>Abaixo se encontram as observações adicionadas ao titulo</small></div></div><div class=\"row\" style=\"margin-top: 15px;margin-left: 10px; margin-bottom: 20px;\"><md-input-container><textarea name=\"notes\" cols=\"70\" rows=\"3\" ng-disabled=\"true\" ng-model=\"vm.bill.notes\"></textarea></md-input-container></div></div></div></md-dialog-content></md-tab><md-tab label=\"Produtos\" ng-if=\"vm.bill.products_detail.length > 0\"><div class=\"md-padding\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Produtos</b> <small>Abaixo se encontram os dados detalhados dos produtos do título</small></div></div><md-table-container style=\"margin-top: 15px; margin-bottom: 15px\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\" md-numeric=\"\">Quantidade</th><th md-column=\"\" md-numeric=\"\">Preço</th><th md-column=\"\" md-numeric=\"\">Desconto</th><th md-column=\"\" md-numeric=\"\">Valor pago</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"product in vm.bill.products_detail\"><td md-cell=\"\">{{product.product_name}}</td><td md-cell=\"\" md-numeric=\"\">{{product.quantity}}</td><td md-cell=\"\" md-numeric=\"\">{{product.unit_price | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{product.discount | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{(product.unit_price * product.quantity) - product.discount | currency: \' \'}}</td></tr></tbody></table></md-table-container></div></md-tab><md-tab label=\"Negociação\" ng-if=\"vm.bill.negotiation_detail.result_negotiation.length > 0\"><a4-negotiation-details negotiation-data=\"vm.bill.negotiation_detail\"></a4-negotiation-details></md-tab></md-tabs></form></md-dialog>");
$templateCache.put("app/components/a4-bill-grid/a4-bill-grid-edit-bill-charge.html","<md-dialog aria-label=\"Alteração de responsável financeiro\" md-theme=\"finance\" style=\"width: 550px;\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-menu-origin=\"\">receipt</md-icon><h2 style=\"margin-left: 5px;\">Status de cobrança</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><div style=\"padding: 15px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Status de cobrança do título</b> <small>Selecione abaixo o status de cobrança do título</small></div></div><div layout=\"column\"><md-input-container><md-select ng-model=\"vm.scope.bill_charge_status_id\"><md-option ng-value=\"null\">Nenhum</md-option><md-option ng-repeat=\"status in vm.scope.bill_charge_status\" ng-value=\"status.id\">{{((status.name).replace(\'_\', \' \')).replace(\'_\', \' \')}}</md-option></md-select></md-input-container></div></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; width: 100%\"><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(vm.scope)\">Salvar</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-bill-grid/a4-bill-grid-edit-notes.html","<md-dialog aria-label=\"Alteração de responsável financeiro\" md-theme=\"finance\" style=\"width: 550px;\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-menu-origin=\"\">info</md-icon><h2 style=\"margin-left: 5px\">Observações do título</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><div style=\"padding: 15px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Observações do título</b> <small>Digite abaixo observações relativas ao título selecionado</small></div></div><div layout=\"column\"><md-input-container><textarea type=\"text\" rows=\"4\" ng-model=\"vm.scope.notes\" placeholder=\"Digite aqui as observações\"></textarea></md-input-container></div></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; width: 100%\"><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(vm.scope)\">Salvar</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-bill-grid/a4-bill-grid-negotiation-details.html","<md-dialog aria-label=\"Detalhamento do titulo\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"detailment\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">Detalhamento da Negociação</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-table-container style=\"margin-top: 15px; margin-bottom: 15px\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" md-numeric=\"\"><b>Valor negociado(R$):</b></td><td md-cell=\"\" md-numeric=\"\">{{vm.negotiation.total | currency:\' \'}}</td><td md-cell=\"\"><b>Data da negociação:</b></td><td md-cell=\"\">{{vm.negotiation.negotiation_date | date:\'dd/MM/yyyy\'}}</td></tr></tbody></table></md-table-container><div style=\"margin-bottom: 20px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Títulos Principais</b> <small>Títulos a partir dos quais a negociação foi gerada</small></div></div><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Pessoa</th><th md-column=\"\">Descrição</th><th md-column=\"\" md-numeric=\"\">Vencimento</th><th md-column=\"\" md-numeric=\"\">Valor</th><th md-column=\"\" md-numeric=\"\">Abono</th><th md-column=\"\" md-numeric=\"\">Diferença</th><th md-column=\"\" md-numeric=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"bill in vm.negotiation.related_installments\"><td md-cell=\"\">{{bill.person_name}}</td><td md-cell=\"\">{{bill.product_name + \' - \' + bill.description}}</td><td md-cell=\"\">{{bill.due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.amount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.allowance | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.difference | currency:\' \'}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"><b>Total:</b></td><td md-cell=\"\">{{vm.negotiation.total | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td></tr></tbody></table></md-table-container><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Títulos Gerados</b> <small>Títulos das parcelas da negociação</small></div></div><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Vencimento</th><th md-column=\"\">Status</th><th md-column=\"\" md-numeric=\"\">Valor</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.negotiation.generated_installments\"><td md-cell=\"\">{{item.due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\"><span class=\"bill-status {{ item.status_name }}\">{{(item.status_name).replace(\'_\', \' \')}}</span></td><td md-cell=\"\" md-numeric=\"\">{{item.amount | currency:\' \'}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" md-numeric=\"\"><b>Total pago:</b></td><td md-cell=\"\">{{vm.negotiation.total_portion | currency:\' \'}}</td></tr></tbody></table></md-table-container></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/a4-bill-grid/a4-bill-grid-payment-details.html","<md-dialog aria-label=\"Detalhamento do titulo\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"detailment\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">Detalhamento do Pagamento</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-table-container style=\"margin-top: 15px; margin-bottom: 15px\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"><b>Valor pago(R$):</b></td><td md-cell=\"\" md-numeric=\"\" ng-if=\"vm.payment.action_id !== null\">{{vm.payment.total_payed | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\" ng-if=\"vm.payment.action_id == null\">{{vm.amount_paid | currency:\' \'}}</td><td md-cell=\"\"><b>Data do pagamento:</b></td><td md-cell=\"\" ng-if=\"vm.payment.action_id !== null\">{{vm.payment.payment_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" ng-if=\"vm.payment.action_id == null\">{{vm.settlement_date | date:\'dd/MM/yyyy\'}}</td></tr><tr md-row=\"\"><td md-cell=\"\"><b>Observações:</b></td><td md-cell=\"\" colspan=\"5\">{{vm.payment.notes}}</td></tr></tbody></table></md-table-container><h4 ng-if=\"vm.is_paid_by_bank_file_received\">Liquidado por arquivo retorno</h4><div style=\"margin-bottom: 20px;\" ng-if=\"!vm.is_paid_by_bank_file_received\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Títulos Liquidados</b></div></div><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Pessoa</th><th md-column=\"\">Descrição</th><th md-column=\"\" md-numeric=\"\">Vencimento</th><th md-column=\"\" md-numeric=\"\">Valor pago</th><th md-column=\"\" md-numeric=\"\">Abono</th><th md-column=\"\" md-numeric=\"\">Diferença</th><th md-column=\"\" md-numeric=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"bill in vm.payment.bills\"><td md-cell=\"\">{{bill.person_name}}</td><td md-cell=\"\">{{bill.product_name + \' - \' + bill.description}}</td><td md-cell=\"\">{{bill.date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.amount_paid | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.allowance | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.difference | currency:\' \'}}</td></tr></tbody></table></md-table-container><div layout=\"row\" style=\"margin-top: 15px; border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Formas de Pagamento</b></div></div><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Forma</th><th md-column=\"\">Conta</th><th md-column=\"\">Detalhes</th><th md-column=\"\" md-numeric=\"\">Valor</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.payment.payments\"><td md-cell=\"\">{{item.movement_type_name}}</td><td md-cell=\"\">{{item.current_account_name}}</td><td md-cell=\"\">{{(item.document)}}</td><td md-cell=\"\" md-numeric=\"\">{{item.amount | currency:\' \'}}</td></tr></tbody></table></md-table-container><h4 ng-if=\"vm.payment.action_id == null\">Baixa manual - Sem detalhamento</h4></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/a4-bill-grid/a4-bill-grid.html","<div><md-card md-theme=\"finance\" style=\"margin-bottom: 0;\"><md-card-content layout=\"column\" layout-padding=\"\"><style>\n        .container {\n          display: flex;\n          flex-wrap: wrap;\n          justify-content: flex-start;\n          align-items: center;\n          display: flex;\n          gap: 0;\n        }\n\n        .container-button {\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          gap: 8px;\n        }\n\n        .button {\n          flex: 0 1 auto;\n          margin: 0;\n          text-align: center;\n        }\n\n        .search, .date-range, .checkbox, .button {\n          flex: 0 0 auto;\n        }\n\n        .search, .date-range {\n          width: 20%;\n        }\n\n        .checkbox {\n          padding-top: 20px;\n        }\n\n        .search-button {\n          margin-right: 2%;\n          margin-left: 0px;\n        }\n\n        .button span {\n          height: 10px;\n          white-space: normal;\n          word-wrap: break-word;\n          overflow-wrap: break-word;\n          font-size: 11px;\n        }\n\n        @media (max-width: 768px) {\n          .search, .date-range, .checkbox {\n            width: 100%;\n          }\n         .button .search-button {\n           width: 25%;\n           margin-right: 0;\n         }\n        }\n\n      </style><md-content layout=\"row\" style=\"padding-top: 0;padding-bottom: 0;\" class=\"container\"><md-input-container class=\"md-input-has-placeholder search\" style=\"padding-top: 0px;\"><label for=\"status-filter\" style=\"margin-left: 30px; margin-bottom: 2px; font-size: 15px;\">Filtro por status</label><md-icon md-font-icon=\"icon-filter-outline\"></md-icon><select-dropdown id=\"status-filter\" placeholder=\"Procure um status\" ng-change=\"vm.changeStatusList()\" selected-items=\"vm.selected_status\" ng-model=\"vm.status_filter\"></select-dropdown></md-input-container><div style=\"margin: 0px 0;\" class=\"date-range\"><date-range-picker ng-model=\"vm.filter_date\" label=\"Período\"></date-range-picker></div><div class=\"checkbox\" layout=\"row\"><md-checkbox ng-model=\"vm.show_only_student\" ng-change=\"vm.emitShowOnlyStudentChange()\" ng-if=\"isStudent || isFinance\">Apresenta títulos apenas do aluno selecionado</md-checkbox><md-checkbox ng-model=\"vm.show_only_group\" ng-change=\"vm.emitShowOnlyGroupChange()\" ng-if=\"isStudent\">Apresenta títulos apenas da turma selecionada</md-checkbox><md-checkbox ng-model=\"vm.show_all_school_periods\" ng-change=\"vm.emitShowAllPeriods()\" ng-if=\"isFinance\">Apresenta títulos de todos períodos</md-checkbox></div><div layout=\"row\" layout-align=\"start center\"><div style=\"margin-top: 12px;\" class=\"search-button\"><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Buscar\" ng-disabled=\"showLoader\" layout=\"row\" ng-click=\"vm.internPaginate(1, 20, vm.filter_date, vm.selected_status)\"><md-tooltip md-direction=\"bottom\">Buscar</md-tooltip><md-icon md-font-icon=\"icon-magnify\" ng-show=\"!showLoader\"></md-icon><md-progress-circular md-diameter=\"15\" ng-show=\"showLoader\" md-mode=\"indeterminate\"></md-progress-circular></md-button></div></div></md-content><md-content layout=\"row\" style=\"padding-top: 0;padding-bottom: 0;\" class=\"container-button\"><div ng-if=\"showPrinter === true\" class=\"button\"><md-button class=\"md-primary\" ng-disabled=\"showLoader\" ng-click=\"onPrintGrid({date: vm.filter_date, status: vm.selected_status, all_bills: 0})\"><md-icon md-font-icon=\"icon-printer\"></md-icon><span md-direction=\"bottom\">Imprimir</span></md-button></div><div ng-if=\"showPrinter === true\" class=\"button\"><md-button class=\"md-primary\" ng-disabled=\"showLoader\" ng-click=\"onPrintGrid({date: vm.filter_date, status: \'\', all_bills: 1})\"><md-icon md-font-icon=\"icon-file-document\"></md-icon><span md-direction=\"bottom\">Imprimir ficha financeira completa</span></md-button></div><div ng-if=\"personId != null && personId != undefined\" class=\"button\"><md-button class=\"md-primary\" ng-disabled=\"showLoader\" policy-access=\"ctsrec_ocor\" ng-click=\"vm.getChargeOccurrences()\"><md-icon md-font-icon=\"icon-square-inc-cash\"></md-icon><span md-direction=\"bottom\">Ocorrências de cobrança</span></md-button></div><div ng-if=\"personId != null && personId != undefined\" class=\"button\"><md-button class=\"md-primary\" ng-disabled=\"showLoader\" policy-access=\"{{vm.is_responsible ? \'ctsrec_print\' : \'ctsrec_income_tax\' }}\" ng-click=\"vm.printIncomeTaxReport()\"><md-icon md-font-icon=\"icon-cash-multiple\"></md-icon><span md-direction=\"bottom\">Imprimir relatório de imposto de renda</span></md-button></div></md-content></md-card-content></md-card><md-card layout=\"row\" style=\"padding: 0;background: none;box-shadow: none\" ng-show=\"vm.tableItemsSelected.length >= 2\"><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-if=\"!vm.disablePayment\" style=\"margin-left: 0;\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_liquid\' : \'ctsrec_liquid\' }}\" ng-click=\"vm.setPaymentMultiple($emit(\'setpayment\'), vm.tableItemsSelected, \'sidenav-payment-form\');\"><md-icon>attach_money</md-icon><div ng-if=\"paginate.data[0].debit_credit == \'D\'\">Pagar</div><div ng-if=\"paginate.data[0].debit_credit == \'C\'\">Receber</div></md-card><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-if=\"!vm.disabledDelete\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_alt\' : \'ctsrec_alt\' }}\" style=\"margin-left: 0;\" ng-click=\"vm.deleteMultipleBills(vm.tableItemsSelected)\"><md-icon>delete_forever</md-icon><div>Excluir</div></md-card><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-if=\"!vm.disabledCancel\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_cancel\' : \'ctsrec_cancel\' }}\" style=\"margin-left: 0;\" ng-click=\"vm.changeStatus(vm.tableItemsSelected, 5, vm.bills.current_page, true)\"><md-icon>cancel</md-icon><div>Cancelar</div></md-card><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-if=\"!vm.disableNegotiate\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_neg\' : \'ctsrec_neg\' }}\" style=\"margin-left: 0;\" ng-click=\"vm.setNegotiateMultiple($emit(\'setnegotiate\'), vm.tableItemsSelected, \'sidenav-negotiate-form\');\"><md-icon>done_all</md-icon><div flex=\"100\">Negociar</div></md-card><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-if=\"!vm.disabledDismiss\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_disp\' : \'ctsrec_disp\' }}\" ng-click=\"vm.changeStatus(vm.tableItemsSelected, 6, vm.bills.current_page, true)\" style=\"margin-left: 0;\"><md-icon>done</md-icon><div>Dispensar</div></md-card><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_alt\' : \'ctsrec_alt\' }}\" style=\"margin-left: 0;\" ng-click=\"vm.editObservationsMultiple(vm.tableItemsSelected)\"><md-icon>info</md-icon><div>Adicionar observações</div></md-card></md-card><md-card md-theme=\"finance\" style=\"margin-top: -18px;\"><md-card-content layout=\"column\" layout-padding=\"\"><md-content layout=\"column\" flex=\"\"><div class=\"progress-div-alfa\" ng-show=\"showLoader\" style=\"display: grid; height: 98%;\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\" style=\"top: 25%;\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando lista, por favor aguarde...</p></md-card-content></md-card></div></div></div><div ng-style=\"{height: heightGrid}\" style=\"overflow: auto;\"><table md-table=\"\" md-row-select=\"!(vm.is_parent && vm.profile_selected == 2)\" md-progress=\"vm.promisse\" multiple=\"{{!(vm.is_parent && vm.profile_selected == 2)}}\" ng-model=\"vm.tableItemsSelected\" width=\"100%\" md-on-select=\"vm.verifyDisableButton()\" md-on-deselect=\"vm.verifyDisableButton()\"><thead md-head=\"\" fix-head=\"\" md-order=\"paginate.order\" md-on-reorder=\"vm.internReorder\"><tr md-row=\"\"><th md-column=\"\"><span></span></th><th md-column=\"\"><span>Pessoa</span></th><th md-column=\"\"><span>Descrição</span></th><th md-column=\"\" md-order-by=\"due_date\"><span>Vencimento</span></th><th md-column=\"\" md-numeric=\"\"><span>Valor original (R$)</span></th><th md-column=\"\"><span>Status</span></th><th md-column=\"\"><span>Data pag.</span></th><th md-column=\"\" md-numeric=\"\"><span>A Pagar/Pago (R$)</span></th><th md-column=\"\" style=\"text-align: right;\" ng-if=\"!(vm.is_parent && vm.profile_selected == 2)\"><span>Ações</span></th></tr></thead><tbody md-body=\"\" ng-style=\"{height: newheight - 510}\"><tr md-row=\"\" ng-repeat=\"item in paginate.data\" md-select=\"item\" md-select-id=\"id\" ng-disabled=\"(item.status == 2 || item.status == 10 || item.status == 4)\" class=\"a4-grid-tr-hover-ripple\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\"><div style=\"color: white; border-radius: 20px; padding: 6px; width: 25px; height: 27px; text-align: center;\" ng-style=\"{\'background-color\':item.color}\"><md-tooltip md-direction=\"top\">{{item.tooltip}}</md-tooltip>{{item.icon}}</div></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\" ng-if=\"item.company_id !== 684\"><span class=\"td-first-line\">{{ item.person_name }}</span> <span class=\"td-second-line\">{{ item.name_second_line }}</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\" ng-if=\"item.company_id === 684\"><span class=\"td-first-line\">{{ item.name_second_line }}</span> <span class=\"td-second-line\">{{ item.person_name }}</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\" ng-if=\"item.product_name != null\"><span class=\"td-first-line\">{{ item.product_name }} <span style=\"padding: 3px;background-color: rgb(8,204,117);color: white;border-radius: 5px;font-size: 11px;\" ng-if=\"item.instalment_name != null && item.instalment_name != \'\'\">{{item.instalment_name}}</span></span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\" ng-if=\"item.product_name == null && item.description != null\"><span class=\"td-first-line\">{{item.description}} <span style=\"padding: 3px;background-color: rgb(8,204,117);color: white;border-radius: 5px;font-size: 11px;\" ng-if=\"item.instalment_name != null && item.instalment_name != \'\'\">{{item.instalment_name}}</span></span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\" ng-if=\"item.product_name === null && item.type !== 9 && item.tooltip !== \'Negociado\' && item.bill_description === null\"><span class=\"td-first-line\">Sem descrição</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\" ng-if=\"item.product_name === null && item.type !== 9 && item.tooltip !== \'Negociado\' && item.bill_description !== null\"><span class=\"td-first-line\">{{item.bill_description}} <span style=\"padding: 3px;background-color: rgb(8,204,117);color: white;border-radius: 5px;font-size: 11px;\" ng-if=\"item.instalment_name != null && item.instalment_name != \'\'\">{{item.instalment_name}}</span></span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\" ng-if=\"item.product_name === null && item.type !== 9 && item.tooltip == \'Negociado\'\"><span class=\"td-first-line\" ng-if=\"item.bill_description === null\">Título negociado</span> <span class=\"td-first-line\" ng-if=\"item.bill_description !== null\">{{item.bill_description}} <span style=\"padding: 3px;background-color: rgb(8,204,117);color: white;border-radius: 5px;font-size: 11px;\" ng-if=\"item.instalment_name != null && item.instalment_name != \'\'\">{{item.instalment_name}}</span></span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\" ng-if=\"item.product_name === null && item.type === 9\"><span class=\"td-first-line\">Produtos de caixa</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\"><span class=\"td-first-line\">{{ item.due_date | date:\"dd/MM/yyyy\" }}</span> <span class=\"td-second-line\" style=\"text-decoration: line-through;\" ng-if=\"( ( item.due_date_before_reschedule !== null && item.due_date !== item.due_date_before_reschedule ) || (item.amount_before_reschedule !== null) )\">{{item.due_date_before_reschedule | date:\"dd/MM/yyyy\"}}</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\"><span ng-if=\"item.is_inaccurate_amount_view\" class=\"td-first-line\">~ {{(item.amount-item.discount_fixed_value) | currency:\"\" }}</span> <span ng-if=\"!item.is_inaccurate_amount_view\" class=\"td-first-line\">{{(item.amount-item.discount_fixed_value) | currency:\"\" }}</span> <span class=\"td-second-line\" style=\"text-decoration: line-through;\" ng-if=\"item.amount_before_reschedule !== null && (item.amount_before_reschedule - item.discount_fixed_value) != item.amount\">{{(item.amount_before_reschedule - item.discount_fixed_value) | currency:\"\" }}</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-card-list-item-avatar-wrapper md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\"><span class=\"bill-status {{ item.status_name }}\" ng-if=\"(item.bill_charge_status_id === null || item.status_name === \'NEGOCIADO\' || item.status_name === \'PARCIALMENTE_PAGO\')\"><md-tooltip ng-if=\"item.status_msg || item.is_paid_by_bank_file_received\" md-direction=\"right\">{{ item.is_paid_by_bank_file_received ? \'por arquivo retorno\' : item.status_msg}}</md-tooltip><md-tooltip ng-if=\"item.status_name === \'ISENTO\'\" md-direction=\"right\">100% de desconto</md-tooltip>{{(item.status_name).replace(\'_\', \' \')}}</span> <span class=\"bill-status {{ item.bill_charge_status }}\" ng-if=\"(item.status_name === \'VENCIDO\' || item.status_name === \'A_VENCER\') && (item.bill_charge_status_id !== null)\"><md-tooltip ng-if=\"item.status_msg || item.is_paid_by_bank_file_received\" md-direction=\"right\">{{ item.is_paid_by_bank_file_received ? \'por arquivo retorno\' : item.status_msg}}</md-tooltip>{{((item.bill_charge_status).replace(\'_\', \' \')).replace(\'_\', \' \')}}</span> <span class=\"bill-status PARCIALMENTE_PAGO\" ng-if=\"item.partial_payment_msg != null\" style=\"margin-left: 3px\"><md-tooltip md-direction=\"top\">{{item.partial_payment_msg}}</md-tooltip>PP</span><span class=\"bill-status REPROGRAMADO\" style=\"margin-left: 3px\" ng-if=\"( ( item.due_date_before_reschedule !== null && item.due_date !== item.due_date_before_reschedule ) || (item.amount_before_reschedule !== null) )\"><md-tooltip md-direction=\"top\">Este título foi reprogramado <span ng-if=\"item.is_conditional_reschedule && item.status == 1\">, tendo seu valor e vencimento fixados condicional até a data do novo vencimento.</span><br>Vencimento original: {{item.due_date_before_reschedule | date:\"dd/MM/yyyy\"}}<br><span ng-if=\"item.amount_before_reschedule !== null\">Valor original: {{item.amount_before_reschedule | currency:\"\"}}</span></md-tooltip>REPROG.</span> <span class=\"md-icon\" ng-if=\"item.bill_action_notes != null && item.bill_action_notes != \'\'\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip>{{item.bill_action_notes ? \'Obs do pagamento: \' + item.bill_action_notes : \'\'}}</md-tooltip></span><span class=\"md-icon\" ng-if=\"item.notes !== null && item.notes !== \'\'\"><md-icon>info</md-icon><md-tooltip>{{\'Obs do título: \' + item.notes}}</md-tooltip></span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\">{{ (item.partial_payment_msg === null || item.status != 1) ? item.settlement_date : null | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\" class=\"md-table-menu\" ng-click=\"vm.getDetailsFromBill(item.id)\"><span class=\"badge\" ng-if=\"item.difference > 0\"><md-tooltip md-direction=\"top\">Diferença a maior {{item.is_difference_exempted ? \'dispensada\' : \'\'}} {{item.bill_id_fix_difference ? \'em título\' : \'\'}}</md-tooltip><span class=\"\" ng-style=\'{ \"text-decoration\": item.is_difference_exempted ? \"line-through\" : \"none\" }\' ng-class=\"{\'título\': item.bill_id_fix_difference !== null,\'positivo\': item.bill_id_fix_difference === null}\" style=\"padding: 3px; color: white;border-radius: 5px;font-size: 11px; margin-right: 3px;\">+{{item.difference | currency:\"\"}}</span></span> <span class=\"badge\" ng-if=\"item.difference < 0 && item.partial_payment_msg == null\"><md-tooltip md-direction=\"top\">Diferença a menor {{item.is_difference_exempted ? \'dispensada\' : \'\'}} {{item.bill_id_fix_difference ? \'em título\' : \'\'}}</md-tooltip><span class=\"\" ng-style=\'{ \"text-decoration\": item.is_difference_exempted ? \"line-through\" : \"none\" }\' ng-class=\"{\'título\': item.bill_id_fix_difference !== null,\'negativo\': item.bill_id_fix_difference === null}\" style=\"padding: 3px; color: white;border-radius: 5px;font-size: 11px; margin-right: 3px;\">{{item.difference > 0 ? \'+\' : \'\' }} {{item.difference | currency:\"\"}}</span></span> <span ng-style=\'{ \"text-decoration\": item.is_difference_exempted == 3 ? \"line-through\" : \"none\" }\'><md-tooltip md-direction=\"top\">{{item.amount_description}}</md-tooltip>{{item.status == 10 ? item.amount_paid : item.final_value | currency:\"\"}}</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" style=\"text-align: right;\" ng-if=\"!(vm.is_parent && vm.profile_selected == 2)\"><md-button flex=\"\" aria-label=\"comment\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_liquid\' : \'ctsrec_liquid\' }}\" style=\"width: 20px !important; padding: 0 !important; margin: 0 !important;\" class=\"md-icon-button md-mini fast-pay\" ng-if=\"(item.status == 1) && vm.tableItemsSelected.length == 0\" ng-click=\"vm.payments(item);$event.stopPropagation();$event.preventDefault();\"><md-icon><i class=\"material-icons\">attach_money</i></md-icon><md-tooltip md-direction=\"left\">Pagar</md-tooltip></md-button><md-menu ng-show=\"vm.tableItemsSelected.length == 0 && !item.is_paid_by_bank_file_received\"><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" style=\"width: 20px !important; padding: 0 !important; margin: 0 !important;\" ng-click=\"$mdMenu.open(event);$event.stopPropagation();$event.preventDefault();\"><md-icon md-menu-origin=\"\">more_vert</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item class=\"md-in-menu-bar\" ng-if=\"item.status == 1 && item.due_date_before_reschedule === null\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_alt\' : \'ctsrec_alt\' }}\"><md-button class=\"md-button\" ng-click=\"vm.editSideNav(item);\"><md-icon md-menu-origin=\"\">mode_edit</md-icon>Editar</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-if=\"item.status == 10 || (item.partial_payment_msg !== null && item.status == 1)\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_estn\' : \'ctsrec_estn\' }}\"><md-button class=\"md-button\" ng-click=\"vm.chargeback(item);\"><md-icon md-menu-origin=\"\">money_off</md-icon>Estornar</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-if=\"item.status == 10 || (item.partial_payment_msg !== null && item.status == 1)\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_desfaz\' : \'ctsrec_desfaz\' }}\"><md-button class=\"md-button\" ng-click=\"vm.undoPayment(item);\"><md-icon md-menu-origin=\"\">money_off</md-icon>Desfazer Pagamento</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_desfaz\' : \'ctsrec_desfaz\' }}\" ng-if=\"item.status == 2 || item.status == 3 || item.status == 5 || item.status == 6\"><md-button class=\"md-button\" ng-click=\"vm.undoChangeStatus(item.id, item.status)\"><md-icon md-menu-origin=\"\">restore</md-icon>Desfazer</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_alt\' : \'ctsrec_alt\' }}\" ng-if=\"item.type == 1 && (item.status == 1 || item.status == 6 || item.status == 5)\"><md-button class=\"md-button\" ng-click=\"vm.delete(item)\"><md-icon md-menu-origin=\"\">delete_forever</md-icon>Excluir</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_cancel\' : \'ctsrec_cancel\' }}\" ng-if=\"item.type == 1 && (item.status == 1 || item.status == 6 || item.status == 5)\"><md-button class=\"md-button\" ng-click=\"vm.changeStatus(item.id, 5, vm.bills.current_page, false)\"><md-icon md-menu-origin=\"\">cancel</md-icon>Cancelar</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-if=\"item.status == 1 && item.type !== 4 && item.tooltip !== \'Negociado\' && !vm.disableNegotiate\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_neg\' : \'ctsrec_neg\' }}\"><md-button class=\"md-button\" ng-click=\"vm.setNegotiate(item);\"><md-icon md-menu-origin=\"\">done_all</md-icon>Negociar</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-if=\"(item.status == 1 || item.status == 7) && ((item.due_date_before_reschedule === null) && (item.amount_before_reschedule === null))\" policy-access=\"bill_reprogram\"><md-button class=\"md-button\" ng-click=\"vm.reprogramBill(item);\"><md-icon md-font-icon=\"icon-rotate-3d\"></md-icon>Reprogramar título</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-if=\"((item.due_date_before_reschedule !== null && item.due_date !== item.due_date_before_reschedule) || (item.amount_before_reschedule !== null)) && item.status === 1\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_neg\' : \'ctsrec_neg\' }}\"><md-button class=\"md-button\" ng-click=\"vm.undoReprogrammedBill(item);\"><md-icon md-menu-origin=\"\">restore</md-icon>Desfazer reprogramação de título</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-if=\"item.status == 4\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_neg\' : \'ctsrec_neg\' }}\"><md-button class=\"md-button\" ng-click=\"vm.undoNegotiate(item);\"><md-icon md-menu-origin=\"\">restore</md-icon>Desfazer Negociação</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_disp\' : \'ctsrec_disp\' }}\" ng-if=\"item.status == 1 || item.status == 6 || item.status == 5\"><md-button class=\"md-button\" ng-click=\"vm.changeStatus(item.id, 6, vm.bills.current_page, false)\"><md-icon md-menu-origin=\"\">done</md-icon>Dispensar</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_addobs\' : \'ctsrec_addobs\' }}\"><md-button class=\"md-button\" ng-click=\"vm.editNotes(item)\"><md-icon md-menu-origin=\"\">info</md-icon><span ng-if=\"item.notes !== null && item.notes !== \'\'\">Editar</span> <span ng-if=\"item.notes === null || item.notes === \'\'\">Adicionar</span> observações</md-button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" policy-access=\"{{ debitCredit == \'D\' ? \'ctspag_addstcob\' : \'ctsrec_addstcob\' }}\" ng-if=\"item.status_name === \'VENCIDO\' || item.status_name === \'A_VENCER\'\"><md-button class=\"md-button\" ng-click=\"vm.editBillChargeStatus(item)\"><md-icon md-menu-origin=\"\">receipt</md-icon>Adicionar status de cobrança</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><md-button style=\"width: 98%\" ng-if=\"showButtonMore\" ng-click=\"vm.internPaginate(vm.current_page, 20)\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon>Carregar mais</md-button></div></md-content></md-card-content></md-card></div>");
$templateCache.put("app/components/a4-bill-grid/charge-occurrences-modal.html","<md-dialog aria-label=\"Mensagem de cobrança\" md-theme=\"crm\" style=\"min-width: 650px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Ocorrências de cobrança</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" colspan=\"4\">Forma</th><th md-column=\"\" colspan=\"1\">Data</th><th md-column=\"\" colspan=\"1\">Hora</th><th md-column=\"\" colspan=\"1\">Origem</th><th md-column=\"\" colspan=\"1\">Tipo</th><th md-column=\"\" colspan=\"1\">Agente</th><th md-column=\"\" colspan=\"1\">Responsável</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.scope.data\"><td md-cell=\"\" colspan=\"4\" style=\"padding-top: 15px; padding-bottom: 15px\"><md-icon md-font-icon=\"icon-phone\" ng-if=\"item.format === \'Telefonema\'\"><md-tooltip md-direction=\"right\">Telefonema</md-tooltip></md-icon><md-icon md-font-icon=\"icon-people\" ng-if=\"item.format === \'Visita\'\"><md-tooltip md-direction=\"right\">Visita</md-tooltip></md-icon><md-icon md-font-icon=\"icon-printer\" ng-if=\"item.format === \'Fax\'\"><md-tooltip md-direction=\"right\">Fax</md-tooltip></md-icon><md-icon md-font-icon=\"icon-file-document\" ng-if=\"item.format === \'Correspondência\'\"><md-tooltip md-direction=\"right\">Correspondência</md-tooltip></md-icon><md-icon md-font-icon=\"icon-message-text-outline\" ng-if=\"item.format === \'Email\'\"><md-tooltip md-direction=\"right\">Email</md-tooltip></md-icon><md-icon md-font-icon=\"icon-question-mark-circle\" ng-if=\"item.format === \'Não especificado\'\"><md-tooltip md-direction=\"right\">Não especificado</md-tooltip></md-icon><md-icon md-font-icon=\"icon-school\" ng-if=\"item.format === \'Ocorrência interna\'\"><md-tooltip md-direction=\"right\">Ocorrência interna</md-tooltip></md-icon><br><hr><span ng-if=\"item.date_done !== null\"><b>Realizado:</b> {{item.notes_done}}</span> <span ng-if=\"item.date_done === null\" style=\"color: red !important;\"><b>Programado:</b> {{item.notes_scheduled}}</span></td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{(item.date_done | date:\'dd/MM/yyyy\') || (item.date_scheduled | date:\'dd/MM/yyyy\')}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.time_done !== null ? item.time_done : item.time_scheduled}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.origin}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.type}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.person_event_name}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.responsible_name}}</td></tr></tbody></table></md-dialog-content></md-dialog>");
$templateCache.put("app/components/a4-bill-grid/chargeback-option.html","<md-dialog aria-label=\"Transaction option\" md-theme=\"finance\" style=\"width: 800px\"><form ng-cloak=\"\"><div layout=\"row\" layout-align=\"end center\" style=\"padding: 0\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div><md-dialog-content><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.answer(\'credit\')\"><md-icon md-font-icon=\"icon-cash-usd\"></md-icon><div>Gerar crédito com o valor pago</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.answer(\'charge-back\')\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle\"></md-icon><div>Realizar estorno</div></a></md-card></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/a4-bill-grid/print-income-tax.html","<md-dialog aria-label=\"Print Income Tax\" md-theme=\"finance\" style=\"min-width: 350px; min-height: 150px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Relatório de imposto de renda</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div style=\"padding: 40px; width: 90%;\"><md-select ng-model=\"vm.scope.year\" placeholder=\"Ano do relatório\"><label>Ano do relatório</label><md-option ng-value=\"year\" ng-repeat=\"year in vm.scope.years\">{{ year }}</md-option></md-select></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.answer(vm.scope.year)\" style=\"padding: 1px;\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-bills-operation/a4-bills-operation.html","<input type=\"hidden\" name=\"id\" ng-model=\"vm.currentItem.id\"><div layout=\"row\" flex=\"\"><md-container flex=\"25\"><date-picker placeholder=\"Data da ação\" ng-change=\"vm.updateBills(vm.currentItem.currentItemList)\" ng-model=\"vm.currentItem.date\" required=\"\" disabled=\"vm.disable_mov_retroativo\" max-date=\"vm.today\"></date-picker></md-container><md-input-container flex=\"75\" class=\"input-a4\" style=\"margin-top: 18px !important;\" ng-if=\"vm.show_description\"><label>Descrição</label> <input type=\"text\" ng-model=\"vm.currentItem.description\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"input-a4\" flex=\"\"><label>Observações</label><md-icon style=\"color: #757575;\" class=\"md-icon-button\" md-font-icon=\"icon-alert-circle\"></md-icon><input type=\"text\" ng-model=\"vm.currentItem.notes\"></md-input-container></div><div id=\"bill-negotiate-toggle\" class=\"simple-table-container\" ng-init=\"vm.toggle.list1 = true\"><md-list-item class=\"show-in-bg-white\" ng-click=\"vm.toggle.list1 = !vm.toggle.list1\"><span flex=\"90\">Selecionados</span> <span flex=\"10\"><md-icon ng-show=\"!vm.toggle.list1\">expand_more</md-icon><md-icon ng-show=\"vm.toggle.list1\">expand_less</md-icon></span></md-list-item><div ng-show=\"vm.toggle.list1\" class=\"ms-responsive-table-wrapper\"><table md-table=\"\" class=\"simple\" ms-responsive-table=\"\" id=\"bill-negotiate-list\"><thead md-head=\"\"><tr md-row=\"\"><th md-cell=\"\" style=\"padding-left: 8px !important;\">Vencimento</th><th md-cell=\"\" colspan=\"2\">Pessoa - Descrição</th><th md-cell=\"\" class=\"text-right\">Multa</th><th md-cell=\"\" class=\"text-right\">Juros</th><th md-cell=\"\" class=\"text-right\">Valor original</th><th md-cell=\"\" class=\"text-right\">Valor atualizado</th><th md-cell=\"\"></th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"item\" class=\"{{ item.status_name }}\" ng-repeat-start=\"item in vm.currentItem.currentItemList\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\">{{item.due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" colspan=\"2\"><span class=\"td-first-line\" ng-if=\"item.name !== null && item.name !== undefined && item.person_name == undefined\">{{item.name}}</span> <span class=\"td-first-line\">{{ item.name_second_line !== null ? vm.abbreviate(item.name_second_line) : item.person_name }}</span> <span ng-if=\"item.type === 3\" class=\"td-second-line\">Título de crédito</span> <span ng-if=\"item.description !== null && !(item.name !== null && item.name !== undefined)\" class=\"td-second-line\">{{item.description }}</span> <span ng-if=\"item.instalment_name !== null\" class=\"td-second-line\">{{item.instalment_name }}</span> <span ng-if=\"item.quantity !== null && item.quantity !== undefined\" class=\"td-second-line\">{{item.name !== null ? \' x \' : \'\'}}{{item.quantity }}</span> <span ng-if=\"item.quantity !== null && item.quantity !== undefined\" class=\"td-second-line\">{{item.beneficiary_name !== null ? \'-\' : \'\'}} {{item.beneficiary_name}}</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu text-right\">{{item.calc_fine_value | currency}}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu text-right\">{{item.calc_interest_value | currency}}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu text-right\">{{item.debit_credit == \'D\' ? item.amount : item.show_current_value | currency}}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu text-right\">{{item.show_final_value | currency}}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" aria-label=\"Editar\" ng-click=\"vm.editItem(item)\" flex=\"\" ng-if=\"item.debit_credit == \'D\' && vm.show_edit\"><md-tooltip md-direction=\"bottom\">Editar valores</md-tooltip><md-icon class=\"material-icons\">edit</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Editar\" ng-click=\"item.edit_item = !item.edit_item\" flex=\"\" ng-if=\"item.debit_credit == \'C\' && vm.show_edit && (item.bill_serie_id !== null && item.bill_serie_id !== undefined)\"><md-tooltip md-direction=\"bottom\">Editar abono ou pagamento parcial</md-tooltip><md-icon class=\"material-icons\">edit</md-icon></md-button></td></tr><tr class=\"{{ item.status_name }}\" ng-repeat-end=\"\" ng-if=\"item.edit_item\"><td colspan=\"7\"><div layout=\"column\" flex=\"\"><md-radio-group ng-model=\"item.selected_option\" aria-labelledby=\"selectedUser\" layout=\"row\" ng-change=\"item.partial_payment_value = 0;item.allowance_value = 0\"><div flex=\"\" layout=\"row\"><div flex=\"\" layout=\"column\" layout-align=\"start start\"><md-radio-button flex=\"\" ng-value=\"\'a\'\" class=\"md-primary\" style=\"margin-bottom: 3px;\">Manter o valor</md-radio-button></div><div flex=\"\" layout=\"column\" layout-align=\"start start\" policy-access=\"allowance\"><md-radio-button flex=\"\" ng-value=\"\'b\'\" class=\"md-primary\" style=\"margin-bottom: 3px;\">Conceder abono</md-radio-button></div><div flex=\"\" layout=\"column\" layout-align=\"start start\" ng-if=\"!vm.checkPolicies(\'pagamento_parcial\')\"><md-radio-button flex=\"\" ng-value=\"\'c\'\" class=\"md-primary\" style=\"margin-bottom: 8px;\">Pagamento parcial</md-radio-button></div></div></md-radio-group><div flex=\"\" style=\"margin-left: 30px; text-align: initial\" layout=\"column\" ng-if=\"item.selected_option == \'c\'\"><md-input-container flex=\"\" style=\"max-width: 40%; margin-top: 15px;\"><label>Valor do pagamento parcial</label> <input ng-model=\"item.partial_payment_value\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" ui-negative-number=\"\" thousands-delimiter=\".\" autocomplete=\"off\"></md-input-container></div><div flex=\"\" style=\"margin-left: 30px; text-align: initial\" layout=\"column\" policy-access=\"allowance\" ng-if=\"item.selected_option == \'b\'\"><span>Este valor de abono será somado aos abonos de juros, multa ou concessão de descontos vencidos.</span><md-input-container flex=\"\" style=\"max-width: 40%; margin-top: 15px;\"><label>Valor do abono</label> <input ng-model=\"item.allowance_value\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" ui-negative-number=\"\" thousands-delimiter=\".\" autocomplete=\"off\"></md-input-container></div><div flex=\"\" layout=\"row\" layout-align=\"end end\"><span flex=\"\"></span><md-button class=\"md-raised md-button\" ng-click=\"item.edit_item = !item.edit_item\">Cancelar</md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.edit_item = !item.edit_item; vm.removeItem(item)\" ng-if=\"vm.currentItem.currentItemList.length > 1\">Remover</md-button><md-button class=\"md-raised md-primary\" ng-click=\"item.edit_item = !item.edit_item; vm.calcTotalAmount(vm.currentItem.currentItemList)\">Salvar</md-button></div></div></td></tr><tr class=\"{{ item.status_name }}\"><td class=\"text-left\" colspan=\"3\">Descontos: {{vm.currentItem.totaldiscounts | currency}} Abono: {{vm.currentItem.totalOtherAllowance | currency}} Taxas: {{vm.currentItem.paymentTax | currency}}</td><td class=\"text-left\">{{vm.currentItem.totalMulta | currency}}</td><td class=\"text-left\">{{vm.currentItem.totalJuros | currency}}</td><td class=\"text-right\" colspan=\"2\">Total: {{vm.currentItem.totalAmount | currency}}</td><td></td></tr></tbody></table></div></div><div layout=\"column\"><md-checkbox ng-if=\"vm.currentItem.totalMulta > 0 && ((vm.show_deduct_fine_and_interest && type == \'negotiate\') || (vm.show_allowance_payment && type == \'payment\'))\" ng-model=\"vm.currentItem.allowanceFine\" ng-change=\"vm.changeFinalValue(vm.currentItem.totalMulta, vm.currentItem.allowanceFine)\">Abater multa {{vm.currentItem.totalMulta | currency}}</md-checkbox><md-checkbox ng-if=\"vm.currentItem.totalJuros > 0 && ((vm.show_deduct_fine_and_interest && type == \'negotiate\') || (vm.show_allowance_payment && type == \'payment\'))\" ng-model=\"vm.currentItem.allowanceInterest\" ng-change=\"vm.changeFinalValue(vm.currentItem.totalJuros, vm.currentItem.allowanceInterest)\">Abater juros {{vm.currentItem.totalJuros | currency}}</md-checkbox><md-checkbox ng-if=\"vm.currentItem.totalMissedDiscounts > 0 && ((vm.show_give_disc && type == \'negotiate\') || (vm.show_allowance_payment && type == \'payment\'))\" ng-model=\"vm.currentItem.giveLostedDiscounts\" ng-change=\"vm.changeFinalValue(vm.currentItem.totalMissedDiscounts, vm.currentItem.giveLostedDiscounts)\">Conceder descontos vencidos {{vm.currentItem.totalMissedDiscounts | currency}}</md-checkbox><md-checkbox ng-if=\"vm.currentItem.futureDiscounts > 0 && vm.show_future_discounts && ((vm.show_give_disc && type == \'negotiate\') || (vm.show_allowance_payment && type == \'payment\'))\" ng-model=\"vm.currentItem.giveFutureDiscounts\" ng-change=\"vm.changeFinalValue(vm.currentItem.futureDiscounts, vm.currentItem.giveFutureDiscounts)\">Conceder descontos futuros {{vm.currentItem.futureDiscounts | currency}}</md-checkbox><md-checkbox ng-if=\"vm.currentItem.giveOtherAllowance\" policy-access=\"allowance\" ng-model=\"vm.currentItem.giveOtherAllowance\" ng-disabled=\"true\">Outros abonos {{vm.currentItem.totalOtherAllowance | currency}}</md-checkbox><md-checkbox ng-if=\"vm.currentItem.paymentTax > 0\" policy-access=\"allowance\" ng-model=\"vm.currentItem.checkPaymentTax\" ng-disabled=\"true\">Taxas de cartão {{vm.currentItem.paymentTax | currency}}</md-checkbox><div flex=\"\"><md-input-container class=\"md-input-has-placeholder\" flex=\"25\"><label>Valor final</label> <input ng-model=\"vm.currentItem.totalAmount\" ui-money-mask=\"\" ng-change=\"vm.changeTotalAmount()\" ng-disabled=\"vm.disable_final_value\"></md-input-container></div></div>");
$templateCache.put("app/components/a4-birth-informations/a4-birth-informations.html","<div layout-gt-xs=\"row\"><date-picker ng-class=\"{show_bottom: !isEnabled}\" ng-model=\"person.dob\" placeholder=\"{{(((formScope == \'EMPLOYEE\' && vm.required_fields_employee.dob.is_mandatory) || (formScope == \'RESPONSIBLE\' && ((person.am_i.is_responsible && vm.required_fields_responsible.dob.is_mandatory) || (person.am_i.is_payee && vm.required_fields_payee.dob.is_mandatory))) || (formScope == \'STUDENT\' && vm.required_fields_student.dob.is_mandatory)) && person.type == 1 && !notRequired) || person.is_payee ? \'Data de nascimento*\' : \'Data de nascimento\'}}\" flex-gt-xs=\"\" style=\"margin-bottom: 7px;\" ng-disabled=\"!isEnabled || notRequired\" ng-required=\"(((formScope == \'EMPLOYEE\' && vm.required_fields_employee.dob.is_mandatory) || (formScope == \'RESPONSIBLE\' && ((person.am_i.is_responsible && vm.required_fields_responsible.dob.is_mandatory) || (person.am_i.is_payee && vm.required_fields_payee.dob.is_mandatory))) || (formScope == \'STUDENT\' && vm.required_fields_student.dob.is_mandatory)) && person.type == 1 && !notRequired) || person.is_payee\" class=\"md-block\" without-icon=\"true\"></date-picker><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-left: 2px;\"><label for=\"select-country\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">País de nascimento</span></label><select2 ng-model=\"person.country_id_of_birth\" s2-options=\"val.id as val.name for val in listCountries\" ng-change=\"vm.countryOfBirthChange(person.country_id_of_birth)\" id=\"select-country\" ng-disabled=\"!isEnabled || notRequired\" flex-gt-xs=\"\"></select2></div></div><div layout-gt-xs=\"row\"><md-autocomplete class=\"md-block\" md-input-name=\"placeofbirth\" md-input-minlength=\"2\" md-no-cache=\"false\" md-delay=\"1000\" md-selected-item=\"vm.place_of_birth\" md-search-text=\"searchPlaceOfBirth\" md-search-text-change=\"\" md-items=\"item in vm.getPlaceOfBirth(searchPlaceOfBirth)\" md-selected-item-change=\"vm.changePlaceOfBirth(person.country_id_of_birth, vm.place_of_birth)\" md-item-text=\"item.name\" md-floating-label=\"Cidade de nascimento/UF\" ng-disabled=\"!isEnabled || notRequired\" ng-required=\"vm.company == 713 || vm.company == 127342\" flex-gt-xs=\"\" ng-class=\"{show_bottom: !isEnabled}\" ng-if=\"person.country_id_of_birth === null || person.country_id_of_birth === vm.BRASIL\" md-input-value=\"{{vm.place_of_birth ? (vm.place_of_birth.name || \'\') : (person.place_of_birth && person.state_of_birth ? person.place_of_birth + \'/\' + person.state_of_birth : \'\')}}\" ng-blur=\"vm.handleBlur(person.country_id_of_birth, searchPlaceOfBirth)\"><md-item-template class=\"isEnabled\"><span md-highlight-text=\"searchPlaceOfBirth\">{{item.name}}</span></md-item-template></md-autocomplete><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"person.country_id_of_birth !== null && person.country_id_of_birth !== vm.BRASIL\" style=\"margin-top: 13px; margin-bottom: 1px;\"><label class=\"isEnabled\">Cidade de nascimento/UF</label> <input ng-model=\"person.place_of_birth\" ng-disabled=\"!isEnabled || notRequired\"></md-input-container><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-top: -5px !important; margin-left: 2px;\"><label for=\"select-nacionality\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Nacionalidade *</span></label><select2 ng-model=\"person.country_id_nationality\" s2-options=\"val.id as val.nationality for val in listCountries\" id=\"select-nacionality\" ng-disabled=\"!isEnabled\" flex-gt-xs=\"\"></select2></div></div><div layout-gt-xs=\"row\" ng-if=\"vm.is_bilingual_school\"><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-bottom: 5px; margin-top: 0;\"><label for=\"select-nacionality2\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Nacionalidade 2</span></label><select2 ng-model=\"person.country_id_nationality_2\" s2-options=\"val.id as val.nationality for val in listCountries\" id=\"select-nacionality2\" ng-disabled=\"!isEnabled || notRequired\" flex-gt-xs=\"\"></select2></div><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-left: 4px; margin-bottom: 5px; margin-top: 0;\"><label for=\"select-nacionality3\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Nacionalidade 3</span></label><select2 ng-model=\"person.country_id_nationality_3\" s2-options=\"val.id as val.nationality for val in listCountries\" id=\"select-nacionality3\" ng-disabled=\"!isEnabled || notRequired\" flex-gt-xs=\"\"></select2></div></div>");
$templateCache.put("app/components/a4-block-message/a4-block-message.html","<md-toolbar class=\"md-hue-2\" style=\"background-color: rgb(216,67,21)\" ng-if=\"days_to_block != null && show_message == true && profile_selected == 0\"><div class=\"md-toolbar-tools\"><h2 flex=\"\" md-truncate=\"\">Ops, você precisa revalidar a sua conta com a A4 Tecnologia.<br>Entre em contato com a equipe de suporte {{days_to_block == 1 ? \'até HOJE\' : \'até o dia \' + last_date_before_block }} e evite a interrupção no funcionamento do sistema.</h2><md-button class=\"md-icon-button\" aria-label=\"More\" ng-click=\"closeMessage()\"><md-icon><i class=\"material-icons\" aria-hidden=\"true\">close</i></md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/components/a4-board-list/a4-board-list.html","<div class=\"list-wrapper\"><div class=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span>{{boardName}}</span></div></div><div class=\"list-content\" layout=\"column\"><div class=\"list-cards\" ms-scroll=\"\"><div ng-if=\"card\" class=\"list-card md-whiteframe-2dp\" ng-repeat=\"card in boardCards track by $index\" ng-click=\"vm.openCardDialog(card)\"><div class=\"list-card-details\"><div class=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" class=\"icon s16\"></md-icon></div><div class=\"list-card-name\"><b>{{card.process_type}}</b><br>{{card.description}}</div><div ng-if=\"card.date\" class=\"list-card-badges\" layout=\"row\" layout-align=\"start center\"><span class=\"badge due-date\" ng-class=\"{\'overdue\': vm.isOverdue(card.date)}\" ng-if=\"card.date\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-clock s16\"></i> {{card.date | date:\'mediumDate\'}} {{card.time != null ? \' | \' : \'\'}} {{card.time.substring(0,5)}} {{card.time_end != null ? \' as \' : \'\'}} {{card.time_end.substring(0,5)}}</span></div><div class=\"list-card-members\" layout=\"row\"><div class=\"list-card-member\" flex=\"\"><div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"\"><span>Solicitante</span> <small>{{card.person_owner_name}}</small></div><div layout=\"column\" flex=\"\" style=\"text-align: right\"><span>Atendente</span> <small>{{card.person_responsible_name}}</small></div></div><div class=\"list-card-print\" layout=\"row\"><div class=\"list-card-print\" flex=\"\"><div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"\"><span>Tipo de impressão</span> <small>{{card.print_color}}</small></div></div></div></div><div class=\"list-card-qty\" layout=\"row\"><div class=\"list-card-qty\" flex=\"\"><div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"\"><span>Quantidade</span> <small>{{card.object_qty}}</small></div></div></div></div></div></div></div><div class=\"list-card-footer\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\" layout-align=\"end center\"><span class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">{{card.artifact_qty}}</span></span><span class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"value\">{{card.comment_qty}}</span></span></div></div></div></div></div></div></div>");
$templateCache.put("app/components/a4-calendar/a4-calendar-template.html","<div ui-calendar=\"uiConfig.calendar\" id=\"calendar\" class=\"span8 calendar\" ng-model=\"vm.eventsSources\" calendar=\"agendaDirective\"></div>");
$templateCache.put("app/components/a4-card-controls/a4-card-controls.html","<span><md-icon md-font-icon=\"icon-chevron-up\" style=\"cursor: pointer;\" ng-click=\"vm.move(type, item, \'up\', subItemIndex)\"></md-icon><md-icon md-font-icon=\"icon-chevron-down\" style=\"cursor: pointer;\" ng-click=\"vm.move(type, item, \'down\', subItemIndex)\"></md-icon><md-icon md-font-icon=\"icon-delete\" style=\"cursor: pointer;\" ng-if=\"canDelete !== false\" ng-click=\"vm.checkQuestionsWithAnswer(item)\"></md-icon></span>");
$templateCache.put("app/components/a4-card-message/message-card.html","<md-card layout=\"row\" class=\"md-padding\" style=\"padding: 0;\"><div style=\"background-color: rgb(8,204,117); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;margin-top: 23px;\"><i class=\"icon icon-close-circle\" style=\"color: #fff;font-size: 60px !important;\"></i><br><span style=\"font-size: 25px; color: #fff;\" ng-if=\"message1 !== null\">{{message1}}</span></p><p ng-if=\"message2 !== null\"><span style=\"font-size: 18px; color: #fff;\">{{message2}}</span></p><p ng-if=\"message3 !== null\"><span style=\"font-size: 15px; color: #fff;\">{{message3}}</span></p></div></md-card>");
$templateCache.put("app/components/a4-checks/index.html","<div class=\"content\" layout=\"row\" style=\"z-index: 999999999\"><md-content flex=\"\" style=\"z-index: 999999999\"><div><div class=\"page-layout simple left-sidenav inner-sidenav\"><md-list class=\"contacts-list\" flex=\"\"><div class=\"main scrollable\" ms-scroll=\"\"><div class=\"md-card-list-wrapper\" id=\"bill-box2\"><div class=\"uk-width-large-8-10 uk-container-center\"><div class=\"md-card-list\"><ul hierarchical-slide=\"\"><li ng-repeat=\"item in vm.items.checks\" on-last-repeat=\"\" class=\"{{ item.status_name }}\"><div layout=\"row\"><span flex=\"25\" flex-xs=\"25\" flex-md=\"15\" flex-sm=\"20\" class=\"md-card-list-item\"><span>{{item.check_status_name}}</span></span> <span flex=\"15\" flex-xs=\"15\" flex-md=\"15\" flex-sm=\"15\" class=\"md-card-list-item-date\">{{item.date | date:\'dd/MM/yyyy\'}}</span><div flex=\"15\" flex-xs=\"15\" flex-md=\"15\" flex-sm=\"15\" class=\"md-card-list-item-date\"><span><b>N.º {{item.number}}</b></span></div><span flex=\"25\" flex-xs=\"25\" flex-md=\"15\" flex-sm=\"20\" class=\"md-card-list-item\">{{item.bank_name}}</span><div flex=\"10\" flex-sm=\"10\" flex-xs=\"10\" class=\"md-card-list-item-avatar-wrapper md-card-list-item-amount\"><strong>{{item.final_value | currency}}</strong></div></div></li></ul></div></div></div></div></md-list></div></div></md-content></div>");
$templateCache.put("app/components/a4-collaborator-contact-form/a4-collaborator-contact-form.html","<div class=\"md-dialog-content new-material-inputs\"><a4-address model=\"person\" is-enabled=\"isEnabled\" has-owner=\"false\"></a4-address></div>");
$templateCache.put("app/components/a4-collaborator-form/a4-collaborator-form.html","<div class=\"md-dialog-content new-material-inputs\"><a4cpf model=\"person.national_id_number\" classes=\"show_bottom\" is-enabled=\"isEnabled\" person-id=\"person.person_id\" is-required=\"vm.required_fields_employee.national_id_number.is_mandatory\"></a4cpf><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\"><label class=\"isEnabled\">Nome</label> <input ng-model=\"person.name\" ng-disabled=\"!isEnabled\" ng-required=\"true\" name=\"collaborator_name\"><div ng-messages=\"formCollaborator.collaborator_name.$error\"><div ng-message=\"required\">Você <b>precisa</b> preencher o nome do colaborador</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\"><label class=\"isEnabled\">Apelido</label> <input ng-model=\"person.alias_name\" ng-disabled=\"!isEnabled\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\" style=\"margin-bottom: 5px;\"><label class=\"isEnabled\" style=\"margin-bottom: 25px;\"><small class=\"isEnabled\">Sexo *</small></label><md-radio-group ng-model=\"person.person_sex_id\" layout=\"row\" style=\"margin-top: 5px;\" ng-disabled=\"!isEnabled\" ng-required=\"true\"><md-radio-button ng-repeat=\"sex in vm.list.person.person_sex_id\" class=\"md-primary\" ng-value=\"sex.id\">{{sex.name}}</md-radio-button></md-radio-group></md-input-container><a4-birth-informations person=\"person\" list-countries=\"vm.list.person.country_id_of_birth\" is-enabled=\"isEnabled\" form-scope=\"\'EMPLOYEE\'\"></a4-birth-informations><div layout-gt-xs=\"row\" ng-show=\"person.type === 1 && person.country_id_nationality != 76\"><md-input-container class=\"md-block md-input-has-placeholder\" style=\"margin-bottom: 2px; margin-top: 15px;\" flex-gt-xs=\"\"><label class=\"isEnabled\">Passaporte/Id estrangeira</label> <input rows=\"1\" ng-model=\"person.foreign_id_or_passport\" ng-disabled=\"!isEnabled\"></md-input-container></div><div layout-gt-xs=\"row\"><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-bottom: 3px !important; margin-left: 2px;\"><label for=\"select-civil-state\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Estado civil</span></label><select2 ng-model=\"person.person_marital_status_id\" s2-options=\"val.id as val.name for val in vm.list.person.person_marital_status_id\" id=\"select-civil-state\" ng-disabled=\"!isEnabled\" flex-gt-xs=\"\"></select2></div><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-left: 4px;\"><label for=\"select-color\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Cor/Raça</span></label><select2 ng-model=\"person.person_color_id\" s2-options=\"val.id as val.name for val in vm.list.person.person_color_id\" id=\"select-color\" ng-disabled=\"!isEnabled\" flex-gt-xs=\"\"></select2></div></div><div layout-gt-xs=\"row\"><md-autocomplete flex=\"\" md-input-name=\"profession\" md-input-minlength=\"3\" md-no-cache=\"true\" md-delay=\"1000\" md-selected-item=\"vm.selected_profession\" md-selected-item-change=\"vm.changeProfession(vm.selected_profession)\" md-search-text=\"vm.searchTextProfession\" md-items=\"item in vm.getProfessions(vm.searchTextProfession)\" md-item-text=\"item.name\" md-floating-label=\"Profissão\" ng-disabled=\"!isEnabled\" flex-gt-xs=\"\" ng-class=\"{show_bottom: !isEnabled}\" style=\"margin-top: 5px; margin-bottom: 0;\"><md-item-template><span md-highlight-text=\"vm.searchTextProfession\">{{item.name}}</span></md-item-template><md-not-found>Profissão não encontrada, ela será criada.</md-not-found></md-autocomplete><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-bottom: 0 !important; margin-left: 2px;\"><label for=\"select-educational-level\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Nível educacional</span></label><select2 ng-model=\"person.person_educational_level_id\" s2-options=\"val.id as val.name for val in vm.list.person.person_educational_level_id\" id=\"select-educational-level\" ng-disabled=\"!isEnabled\" flex-gt-xs=\"\"></select2></div></div><div layout-gt-xs=\"row\" flex=\"\"><a4email model=\"person.email\" is-enabled=\"isEnabled\" person-id=\"person.person_id\" is-required=\"false\" flex=\"66\"></a4email><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" style=\"margin-bottom: 2px;\" flex=\"33\"><label class=\"isEnabled\">Celular (DDD obrigatório)</label> <input ng-model=\"person.phone_mobile\" ng-disabled=\"!isEnabled\" ui-br-phone-number=\"\"></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"vm.company_id == 733 || vm.company_id == 101258 || vm.company_id == 18\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 0 !important;\"><label class=\"isEnabled\">RG</label> <input ng-model=\"person.id_number\" ng-disabled=\"!isEnabled\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 0 !important;\"><label class=\"isEnabled\">Órgão expedidor RG</label> <input ng-model=\"person.id_issuer\" ng-disabled=\"!isEnabled\"></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"vm.company_id == 733 || vm.company_id == 101258\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\"><label class=\"isEnabled\">UF expedição RG</label> <input ng-model=\"person.id_state\" ng-disabled=\"!isEnabled\"></md-input-container><date-picker ng-model=\"person.id_date_issue\" placeholder=\"Data expedição RG\" ng-disabled=\"!isEnabled\" flex-gt-xs=\"\" without-icon=\"true\" ng-class=\"{show_bottom: !isEnabled}\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\"><label class=\"isEnabled\">Complemento RG</label> <input ng-model=\"person.id_complement\" ng-disabled=\"!isEnabled\"></md-input-container></div></div>");
$templateCache.put("app/components/a4-contract/contract-modal.html","<md-dialog aria-label=\"Contrato\" md-theme=\"educational\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submitContract(vm.contract, contractformfinance)\" name=\"contractformfinance\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Contrato</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-if=\"!vm.is_first\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0;\"><div class=\"md-padding\"><md-card style=\"margin: 0 0 5px;\" ng-if=\"vm.last_enrolment_data.length > 0\"><md-card-title style=\"padding: 0 16px 12px !important;background-color: rgb(186,120,255); color: white;\"><md-card-title-text><span class=\"md-subhead\" ng-if=\"vm.last_enrolment_data[0].preferential_due_day != null\">Dia preferencial de vencimento: {{vm.last_enrolment_data[0].preferential_due_day}}</span> <span class=\"md-subhead\" ng-repeat=\"discount in vm.last_enrolment_data\" ng-if=\"discount.format != null\">Razão do desconto: {{discount.discount_reason}} | {{discount.format == \'V\' ? \'Valor\' : \'Percentual\'}}: {{discount.format == \'V\' ? \'R$ \' + discount.value_percent_1 : discount.value_percent_1 + \'%\'}} | Tipo: {{discount.type == \'F\' ? \'fixo\' : \'condicional\'}}</span></md-card-title-text></md-card-title></md-card><md-card style=\"margin: 0 0 5px;\" ng-if=\"vm.payee_has_dependents > 0\"><md-card-title style=\"padding: 0 16px 12px !important;background-color: rgb(0,210,255); color: white;\"><md-card-title-text><span class=\"md-subhead\">Responsável possui mais {{vm.payee_has_dependents}} dependente(s).</span></md-card-title-text></md-card-title></md-card><md-card style=\"margin: 0 0 30px;\"><md-card-title style=\"padding: 0 16px 12px !important;background-color: rgb(3,169,244); color: white;\"><md-card-title-text><span class=\"md-subhead\">Ao finalizar este contrato, o aluno já vai estar matriculado no serviço.</span></md-card-title-text></md-card-title></md-card><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Serviço contratado</b></div></div><hr><md-content layout=\"row\" class=\"md-padding\"><md-icon md-font-icon=\"icon-school\"></md-icon><md-autocomplete flex=\"\" class=\"md-input-has-placeholder\" md-input-name=\"autocompleteField\" md-selected-item=\"vm.selectedCourse\" md-selected-item-change=\"vm.setItem(vm.selectedCourse)\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getCourseAndGroup(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" ng-disabled=\"vm.is_first\" md-floating-label=\"Serviço\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template></md-autocomplete><md-input-container flex=\"50\" class=\"md-block md-input-has-placeholder\" ng-if=\"vm.hasPaymentPlan && vm.groups.length > 0\"><label>Turma</label><md-icon md-font-icon=\"icon-chair-school\"></md-icon><md-select name=\"grouplist\" ng-model=\"vm.contract.group_id\" ng-change=\"vm.getPaymentPlansForGroup(vm.contract.group_id)\" required=\"\" ng-disabled=\"vm.is_first\" aria-label=\"turmas\"><md-option ng-repeat=\"group in vm.groups track by $index\" ng-value=\"group.id\">{{group.name}}</md-option></md-select><div ng-messages=\"contractformfinance.grouplist.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar a turma.</div></div></md-input-container><md-input-container flex=\"\" class=\"md-block\" ng-if=\"vm.studentsResponsibles.length > 0 && vm.groups.length <= 0\"><label>Responsável financeiro</label><md-select name=\"person_payee\" required=\"\" ng-model=\"vm.enrolment.student.person_id_payee\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.studentsResponsibles\">{{ item.name }}</md-option></md-select></md-input-container></md-content><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\" ng-if=\"enrolment.policies.preferential_due_day\"><b>Definição de contrato</b> <small>Abaixo preencha as informações para a formulação do contrato</small></div></div><hr><md-card ng-show=\"vm.payment_plans.length == 0\"><md-card-title style=\"padding: 0 16px 12px !important;background-color: rgb(3,169,244); color: white;\"><md-card-title-text><span class=\"md-subhead\">Sem plano de pagamento, não é possível continuar com o contrato</span></md-card-title-text></md-card-title></md-card><md-content ng-show=\"vm.payment_plans.length > 0\" class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-if=\"vm.hasPaymentPlan\" flex=\"\"><label>Plano de pagamento</label><md-icon md-font-icon=\"icon-view-carousel\"></md-icon><md-select ng-model=\"vm.contract.payment_plan_id\" required=\"\" name=\"paymentplan\" aria-label=\"plano de pagamento\" ng-change=\"vm.setPaymentPlan(vm.contract.payment_plan_id)\"><md-option ng-value=\"payment.payment_plan_id\" ng-repeat=\"payment in vm.payment_plans track by $index\">{{payment.name}}</md-option></md-select><div ng-messages=\"contractformfinance.paymentplan.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar o plano de pagamento.</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-if=\"vm.hasPaymentPlan\" flex=\"\"><label>Dia diferenciado de vencimento</label><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-select ng-model=\"vm.contract.preferential_due_day\" aria-label=\"dia diferenciado de pagamento\" ng-disabled=\"vm.enrolment.policies.preferential_due_day\"><md-tooltip ng-if=\"vm.contract.preferential_due_day\">Você não tem permissão para modificar esse campo</md-tooltip><md-option ng-value=\"day.id\" ng-repeat=\"day in vm.preferencial_due_day_list track by $index\">{{day.id}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"100\"><date-picker flex=\"25\" required=\"\" disabled=\"vm.disable_date_first\" ng-change=\"vm.setFirstInstallmentDate(vm.contract.date_first)\" placeholder=\"Data de início\" ng-model=\"vm.contract.date_first\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\" ng-if=\"vm.contract.first_installment_date_type === 2\"><label>Venc. 1ª parcela</label><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><input ng-value=\"vm.contract.first_installment_date | date:\'dd/MM/yyyy\'\" required=\"\" ng-disabled=\"true\"></md-input-container><date-picker flex=\"25\" required=\"\" ng-if=\"vm.contract.first_installment_date_type == 1\" placeholder=\"Venc. 1ª parcela\" ng-model=\"vm.contract.first_installment_date\"></date-picker><date-picker flex=\"25\" disabled=\"vm.hasPaymentPlan\" required=\"\" placeholder=\"Data final\" ng-model=\"vm.contract.date_end\" ng-if=\"vm.contract.date_end != null\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\" ng-if=\"vm.contract.date_end == null\"><label>Quantidade de parcelas</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"vm.contract.quantity\" required=\"\" ng-disabled=\"vm.hasPaymentPlan\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Valor</label><md-icon md-font-icon=\"icon-coin\"></md-icon><input ng-model=\"vm.contract.amount\" required=\"\" ui-money-mask=\"\" aria-label=\"valor\" ng-disabled=\"vm.disable_amount\"></md-input-container></div></div></md-content><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\" ng-if=\"vm.contract.recurrence_on_value === 1\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Parcelas</b> <small>O plano de pagamento selecionado permite que se altere o valor e data de vencimento das parcelas. Caso haja alguma informação em branco, preencha e clique no botão ao lado para recalcular as parcelas.</small></div><div flex=\"10\"><md-button class=\"md-icon-button\" ng-click=\"vm.generateInstalmentsByPaymentPlan(vm.contract)\"><md-tooltip md-direction=\"left\">Recalcular parcelas</md-tooltip><md-icon md-font-icon=\"icon-reload\"></md-icon></md-button></div></div><md-content ng-if=\"vm.contract.recurrence_on_value === 1\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">#</th><th md-column=\"\">Vencimento</th><th md-column=\"\">Valor (R$)</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.contract.payment_installments\"><td md-cell=\"\">{{ item.portion_name }}</td><td md-cell=\"\"><date-picker flex=\"25\" required=\"\" ng-model=\"item.due_date\" without-icon=\"true\"></date-picker></td><td md-cell=\"\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><input ng-model=\"item.amount\" required=\"\" ui-money-mask=\"\" aria-label=\"valor parcela\"></md-input-container></td></tr></tbody></table></md-table-container></md-content><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\" ng-if=\"vm.vinculated_services.length > 0\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Serviços vinculados</b> <small>Abaixo estão os serviços vinculados ao contratos e que terão seus contratos criados</small></div></div><hr><md-content ng-show=\"vm.vinculated_services.length > 0\" class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\" ng-repeat=\"service in vm.vinculated_services\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"25\"><label>Serviço</label><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><input ng-disabled=\"true\" ng-model=\"service.service_name\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Valor</label><md-icon md-font-icon=\"icon-coin\"></md-icon><input ng-model=\"service.price\" ui-money-mask=\"\" aria-label=\"valor\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Plano de pagamento</label><md-icon md-font-icon=\"icon-view-carousel\"></md-icon><input ng-disabled=\"true\" ng-model=\"service.payment_plan_name\"></md-input-container></div><div layout=\"row\"><date-picker ng-model=\"service.date_first\" placeholder=\"Data de início\" flex=\"25\"></date-picker><date-picker ng-model=\"service.date_end\" placeholder=\"Data final\" ng-if=\"service.quantity == null\" ng-disabled=\"true\" flex=\"25\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\" ng-if=\"service.date_end == null\"><label>Quantidade de parcelas</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"service.quantity\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><md-tooltip ng-if=\"vm.contract.preferential_due_day\">Você não tem permissão para modificar esse campo</md-tooltip><label>Dia diferenciado de vencimento</label><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-select ng-model=\"service.preferential_due_day\" aria-label=\"dia diferenciado de pagamento\" ng-disabled=\"vm.enrolment.policies.preferential_due_day\"><md-tooltip ng-if=\"vm.enrolment.policies.preferential_due_day\">Você não tem permissão para acessar esse campo</md-tooltip><md-option ng-value=\"day.id\" ng-repeat=\"day in vm.preferencial_due_day_list track by $index\">{{day.id}}</md-option></md-select></md-input-container></div><md-input-container ng-if=\"service.is_mandatory === false\"><md-checkbox ng-model=\"service.create_contract\">Este serviço não é obrigatório. Selecione para criar o contrato.</md-checkbox></md-input-container></md-content><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><md-tooltip ng-if=\"vm.enrolment.policies.individual_discounts\">Você não tem permissão para modificar esse campo</md-tooltip><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Descontos Individuais</b> <small>Descontos do contrato principal</small></div><div flex=\"10\"><md-button class=\"md-icon-button\" ng-click=\"vm.createNewIndividualDiscount()\" ng-disabled=\"vm.enrolment.policies.individual_discounts\"><md-tooltip md-direction=\"left\" ng-if=\"false\">Novo desconto individual</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><hr><md-content><a4-discounts-grid discounts=\"vm.contract.individual_discounts\" delete-function=\"vm.removeItemDesconto(discount_id, discount_index)\" show-delete=\"true\" is-finance-enrolment=\"vm.enrolment.isFinanceEnrolment\"></a4-discounts-grid></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.goBack()\" ng-show=\"vm.is_first\">Cancelar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"vm.show_loading || contractformfinance.$invalid\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Salvar Contrato</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-contract/index.html","<md-card ng-if=\"!enrolment.hasPaymentPlan\" flex=\"\" layout=\"row\"><div flex=\"\" style=\"background-color: rgb(3,169,244); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 60px;\"></i><br><span style=\"font-size: 25px; color: #fff;\">Sem planos de pagamento para esta turma</span></p><p><span style=\"font-size: 18px; color: #fff;\">Para criar um novo Plano de Pagamento para esta turma, consulte a área financeira.</span></p></div></md-card><md-content class=\"md-padding\" flex=\"\" ng-if=\"enrolment.hasPaymentPlan\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"canEdit\"><md-button type=\"button\" ng-if=\"!enrolment.checkPolicies(\'contrato_alt\')\" ng-click=\"enrolment.openContractModal({enrolment: enrolment, is_first: false})\" class=\"md-primary\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Novo contrato</md-button></div><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Descrição</th><th md-column=\"\">Data inicial</th><th md-column=\"\">Primeiro vencimento</th><th md-column=\"\">Valor</th><th md-column=\"\" ng-if=\"canEdit\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in enrolment.student_contracts\"><td md-cell=\"\">{{item.description}} {{(item.service_type == 11 && item.bill_description != null && item.bill_description != \'\') ? \' (\' + item.bill_description + \')\' : \'\'}} <span ng-if=\"item.is_deleted\" style=\"color: #890c0d\">[Contrato excluído]</span></td><td md-cell=\"\">{{item.date_first | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{item.due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{item.amount | currency:\' \'}}</td><td md-cell=\"\" ng-if=\"canEdit\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"enrolment.openMenu($mdMenu, $event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><div policy-access=\"contrato_dia_diff\"><md-menu-item policy-access=\"contrato_dia_diff\"><md-button ng-click=\"enrolment.changePreferentialDay(item.bill_serie_id)\"><md-icon md-font-icon=\"icon-sort-numeric\" md-menu-align-target=\"\"></md-icon>Modificar dia diferenciado de pagamento</md-button></md-menu-item></div><div policy-access=\"contrato_desc_indiv\"><md-menu-divider></md-menu-divider><md-menu-item policy-access=\"contrato_desc_indiv\"><md-button ng-click=\"enrolment.getIndividualDiscounts(item)\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon>Gerenciar descontos</md-button></md-menu-item></div><div policy-access=\"contrato_carne\"><md-menu-divider></md-menu-divider><md-menu-item><md-button target=\"_blank\" href=\"{{enrolment.WEB_CONST}}api/contract/printpaymentbookcontract?token={{enrolment.conf.token}} &company={{enrolment.conf.current_company}}&connection={{enrolment.conf.current_connection}} &bill_serie_id={{item.bill_serie_id}}&school_period_id={{enrolment.conf.school_period_id}}\"><md-icon md-font-icon=\"icon-barcode\"></md-icon>Imprimir Carnê</md-button></md-menu-item></div><md-menu-item ng-if=\"item.service_type == 1\"><md-button ng-click=\"enrolment.printEnrolmentContract(item.bill_serie_id)\"><md-icon>assignment</md-icon>Imprimir contrato</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-content>");
$templateCache.put("app/components/a4-contract-grid/a4-contract-grid.html","<md-card layout=\"row\" style=\"background-color: rgb(8,204,117)\" ng-if=\"vm.haveUpdate && !vm.checkPolicies(\'contrato\')\"><div flex=\"40\"><p style=\"font-size: 15px; color: white; padding-left: 10px\">Existem contratos desatualizados, por favor aperte no botão \"GERAR TÍTULOS\" para atualizar</p></div><md-button flex=\"10\" class=\"md-raised\" ng-click=\"vm.updateContracts()\">Gerar títulos</md-button></md-card><md-card layout=\"row\" style=\"background-color: rgb(8,204,117)\" ng-if=\"person_id === null && !vm.checkPolicies(\'contrato\')\"><div flex=\"\"><p style=\"font-size: 15px; color: white; padding-left: 10px\">Os títulos a receber sem prazo determinado estão sendo gerados até o dia {{vm.credit_limit}}<br>Os títulos a pagar sem prazo determinado estão sendo gerados até o dia {{vm.debit_limit}}</p></div><md-button flex=\"10\" class=\"md-raised\" ng-click=\"vm.openChangeLimitDatesModal()\">Alterar datas</md-button></md-card><md-card class=\"md-padding\" ng-if=\"!vm.checkPolicies(\'contrato\')\"><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container md-no-float=\"\" flex=\"\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input id=\"search_person_contract\" placeholder=\"{{ \'PERSON.SEARCH\' | translate }}\" type=\"text\" ng-change=\"makeSearch(search)\" ng-model-options=\"{debounce: 1000}\" ng-model=\"search\" translate=\"\" translate-attr-placeholder=\"Pesquisar\"></md-input-container><md-table-pagination md-limit=\"paginate.per_page\" md-limit-options=\"[5, 10, 15, 20, 25, 50]\" md-page=\"paginate.current_page\" flex=\"\" style=\"border: none\" md-total=\"{{paginate.total}}\" md-on-paginate=\"vm.internPaginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Pessoa</th><th md-column=\"\">Produto</th><th md-column=\"\">Próx. vcto.</th><th md-column=\"\" md-numeric=\"\">Valor (R$)</th><th md-column=\"\">Situação</th><th md-column=\"\">Tipo</th><th md-column=\"\">Frequência</th><th md-column=\"\" md-numeric=\"\">Qtd parcs.</th><th md-column=\"\" md-numeric=\"\">Vl. Total</th><th md-column=\"\" md-numeric=\"\">Dia pgto. pref.</th><th md-column=\"\">Data Inicial</th><th md-column=\"\">Data Final</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in paginate.data\" ng-click=\"vm.editContract(item.serie_id)\" style=\"cursor: pointer;\"><td md-cell=\"\"><b>{{item.person_name}}</b><br><small>{{item.beneficiary_name}}</small> <span class=\"badge\" ng-if=\"item.closed\">Encerrado</span></td><td md-cell=\"\"><md-tooltip md-direction=\"right\"><span ng-if=\"item.payment_plan\">Plano.Pag:</span> {{item.payment_plan}} <span ng-if=\"item.document_title && item.payment_plan\"><br></span> <span ng-if=\"item.document_title\">Doc.Contrato:</span> {{item.document_title}}</md-tooltip><span>{{item.product_name}}</span></td><td md-cell=\"\">{{item.next_due_date | date: \'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.next_amount | currency:\" \"}}</td><td md-cell=\"\"><md-tooltip md-direction=\"right\">{{vm.defineTooltip(item)}}</md-tooltip><span class=\"contract-status {{ vm.defineSituation(item) }}\">{{(vm.defineSituation(item)).replace(\'_\', \' \')}}</span></td><td md-cell=\"\">{{vm.defineType(item)}}</td><td md-cell=\"\">{{vm.defineFrequency(item)}}</td><td md-cell=\"\" md-numeric=\"\">{{item.quantity}}</td><td md-cell=\"\" md-numeric=\"\">{{item.total_amount | currency:\" \"}}</td><td md-cell=\"\" md-numeric=\"\">{{item.preferential_due_day}}</td><td md-cell=\"\">{{item.date_first | date: \'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{item.date_end | date: \'dd/MM/yyyy\'}}</td><td md-cell=\"\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event);$event.stopPropagation()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"6\"><md-menu-item policy-access=\"contrato_plano\"><md-button ng-click=\"vm.changePaymentPlan(item.serie_id)\"><md-icon md-font-icon=\"icon-view-carousel\" md-menu-align-target=\"\"></md-icon>Modificar plano de pagamento</md-button></md-menu-item><md-menu-item policy-access=\"contrato_carne\"><md-button ng-click=\"vm.printPaymentBook(item.serie_id)\"><md-icon md-font-icon=\"icon-barcode\"></md-icon>Imprimir Carnê</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.printEnrolmentContract(item.serie_id, item.person_id_beneficiary, item.external_id, item.artifact_id, item.external_id !== null, item.is_confirmed)\"><md-icon>assignment</md-icon>Imprimir contrato</md-button></md-menu-item><md-menu-item policy-access=\"contrato_dia_diff\"><md-button ng-click=\"vm.changePreferentialDay(item.serie_id)\"><md-icon md-font-icon=\"icon-sort-numeric\" md-menu-align-target=\"\"></md-icon>Modificar dia diferenciado de pagamento</md-button></md-menu-item><md-menu-item policy-access=\"contrato_desc_indiv\"><md-button ng-click=\"vm.getIndividualDiscounts(item)\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon>Gerenciar descontos</md-button></md-menu-item><md-menu-item policy-access=\"contrato_add_parc\"><md-button ng-click=\"vm.addInstallment(item.serie_id)\"><md-icon md-font-icon=\"icon-plus-one\"></md-icon>Adicionar parcelas</md-button></md-menu-item><md-menu-item ng-if=\"item.external_id === null\"><md-button ng-click=\"vm.changePersonPayee(item)\"><md-icon>assignment</md-icon>Modificar responsável financeiro</md-button></md-menu-item><md-menu-item policy-access=\"contrato_cancel\" ng-if=\"(item.date_end === null || item.is_date_end_before_today === false)\"><md-button ng-click=\"vm.cancelContract(item)\"><md-icon md-menu-origin=\"\">cancel</md-icon>Cancelar</md-button></md-menu-item><md-menu-item policy-access=\"contrato_undo_cancel\" ng-if=\"(item.date_end !== null && item.is_date_end_before_today === true)\"><md-button ng-click=\"vm.undoCancelContract(item.serie_id)\"><md-icon md-menu-origin=\"\">cancel</md-icon>Desfazer cancelamento</md-button></md-menu-item><md-menu-item policy-access=\"contrato_excluir\"><md-button ng-click=\"vm.deleteContract(item.serie_id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Excluir</md-button></md-menu-item><md-menu-item policy-access=\"contrato_excluir\" ng-if=\"item.artifact_id != null\"><md-button ng-click=\"vm.deleteSignedContract(item.artifact_id, item.serie_id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Excluir contrato assinado</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/components/a4-contract-grid/add-installments-modal.html","<md-dialog aria-label=\"Adicionar parcela ao contrato\" md-theme=\"finance\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar parcelas ao contrato</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><div style=\"padding: 15px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(43,168,18)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Observações</b> <small>Ao definir a data de vencimento da primeira parcela, as próximas parcelas serão criadas mês a mês no mesmo dia de vencimento.</small></div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"100\"><date-picker flex=\"40\" required=\"\" placeholder=\"Vencimento da primeira parcela\" ng-model=\"vm.scope.due_date\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label>Qtd de parcelas</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"vm.scope.quantity\" required=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label>Valor</label><md-icon md-font-icon=\"icon-coin\"></md-icon><input ng-model=\"vm.scope.amount\" required=\"\" ui-money-mask=\"\"></md-input-container></div></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; width: 100%\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(vm.scope)\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-contract-grid/cancel-contract-date.html","<md-dialog aria-label=\"Cancelar contrato\" md-theme=\"finance\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Cancelar contrato</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><div style=\"padding: 15px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(43,168,18)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Cancelamento de contrato</b> <small>Selecione a data do cancelamento do contrato</small></div></div><div layout=\"row\"><date-picker ng-model=\"vm.object.date\" style=\"width: 100%\"></date-picker></div></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; margin-top: 25px; margin-bottom: -5px; width: 100%\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Voltar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(vm.object)\" ng-disabled=\"angular.isUndefined(vm.object.date) || vm.object.date === \'\'\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-contract-grid/change-limit-date-modal.html","<md-dialog aria-label=\"Alterar datas limite\" md-theme=\"finance\" style=\"width: 600px;\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Modificação de data limite</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"\"><md-input-container flex=\"\"><label>Mês/ano limite para recorrências de títulos a receber</label><md-select ng-model=\"vm.company.credit_bill_generation_limit_date\" placeholder=\"Mês/ano limite para recorrências de títulos a receber\" style=\"width: 95%\"><md-option ng-value=\"item.value\" ng-repeat=\"item in vm.month_year\">{{ item.name }}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container flex=\"\"><label>Mês/ano limite para recorrências de títulos a pagar</label><md-select ng-model=\"vm.company.debit_bill_generation_limit_date\" placeholder=\"Mês/ano limite para recorrências de títulos a pagar\" style=\"width: 95%\"><md-option ng-value=\"item.value\" ng-repeat=\"item in vm.month_year\">{{ item.name }}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.changeLimitDates()\" class=\"md-primary md-raised\" ng-disabled=\"vm.show_loading\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Modificar datas</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-contract-grid/change-payment-plan.html","<md-dialog aria-label=\"Contrato\" md-theme=\"finance\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.changePlan(vm.contract, contractformeditfinance)\" name=\"contractformeditfinance\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Modificação de plano de pagamento</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-if=\"!vm.is_first\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-card layout=\"row\" class=\"md-padding\" ng-if=\"vm.can_change !== null && (vm.can_change.has_paid_bill > 0 || vm.can_change.has_bank_slip_sent > 0)\" style=\"padding: 0;\"><div style=\"background-color:rgb(212, 209, 214); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;margin-top: 23px;\"><i class=\"icon icon-close-circle\" style=\"color: #fff;font-size: 60px !important;\"></i><br><span style=\"font-size: 13px; color: #020202;\"><b>Atenção!</b> Há titulos <b>PAGOS</b> no contrato ou boletos <strong>ENVIADOS</strong> ou <strong>REGISTRADOS</strong>.</span></p><p><span style=\"font-size: 18px; color: #fff;\"></span></p></div></md-card><div class=\"md-padding\"><div layout=\"row\"><div layout=\"column\" flex=\"50\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Contratante</b> <small>Abaixo a pessoa que está contratando o serviço</small></div></div><md-content layout=\"row\" class=\"md-padding\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"90\"><md-icon md-font-icon=\"icon-account\"></md-icon><input ng-value=\"vm.contract.person.name\" ng-disabled=\"true\"></md-input-container></md-content></div><div layout=\"column\" flex=\"45\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Serviço contratado</b> <small>Abaixo o serviço relacionado contratado</small></div></div><md-content layout=\"row\" class=\"md-padding\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"90\"><md-icon md-font-icon=\"icon-school\"></md-icon><input ng-value=\"vm.contract.service.name\" ng-disabled=\"true\"></md-input-container></md-content></div></div><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Plano de pagamento</b> <small>Abaixo se encontram as informações para modificação de plano</small></div></div><hr><md-content class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\"><md-card ng-show=\"vm.payment_plans.length == 0\"><md-card-title style=\"padding: 0 16px 12px !important;background-color: rgb(8, 204,117); color: white;\"><md-card-title-text><span class=\"md-subhead\">Sem plano de pagamento, não é possível continuar com o modificação.</span></md-card-title-text></md-card-title></md-card><div layout=\"row\"><md-content ng-show=\"vm.payment_plans.length > 0\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Plano de pagamento</label><md-icon md-font-icon=\"icon-view-carousel\"></md-icon><md-select ng-model=\"vm.contract.payment_plan_id\" required=\"\" name=\"paymentplan\" aria-label=\"plano de pagamento\" ng-change=\"vm.setPaymentPlan(vm.contract.payment_plan_id)\"><md-option ng-value=\"payment.payment_plan_id\" ng-repeat=\"payment in vm.payment_plans track by $index\">{{payment.name}}</md-option></md-select><div ng-messages=\"contractformfinance.paymentplan.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar o plano de pagamento.</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Dia diferenciado de vencimento</label><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-select ng-model=\"vm.contract.preferential_due_day\" aria-label=\"dia diferenciado de pagamento\" ng-change=\"\"><md-option ng-value=\"day.id\" ng-repeat=\"day in vm.preferencial_due_day_list track by $index\">{{day.id}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"100\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" ng-if=\"vm.block_fields.date\" flex=\"25\"><label>Data de início</label><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><input ng-value=\"vm.contract.date_first | date:\'dd/MM/yyyy\'\" required=\"\" ng-disabled=\"true\"></md-input-container><date-picker flex=\"25\" required=\"true\" ng-if=\"!vm.block_fields.date\" placeholder=\"Data de início\" ng-model=\"vm.contract.date_first\"></date-picker><date-picker flex=\"25\" required=\"true\" ng-if=\"vm.contract.date_end\" placeholder=\"Data Final\" ng-model=\"vm.contract.date_end\" disabled=\"vm.selected_paymentplan.date_end !== null\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\" ng-if=\"!vm.contract.date_end\"><label>Quantidade de parcelas</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"vm.contract.quantity\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Valor</label><md-icon md-font-icon=\"icon-coin\"></md-icon><input ng-model=\"vm.contract.amount\" name=\"installment_amount\" required=\"\" ui-money-mask=\"\" ng-disabled=\"vm.block_fields.amount\"><div ng-messages=\"contractformeditfinance.installment_amount.$error\"><div ng-message=\"required\">Você <b>deve</b> informar o valor da parcela.</div></div></md-input-container></div></div><div><date-picker flex=\"25\" required=\"true\" placeholder=\"Data de modificação\" ng-model=\"vm.contract.date_change\"></date-picker></div></md-content></div></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"vm.show_loading\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Modificar Plano</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-contract-grid/create-contract-modal.html","<md-dialog aria-label=\"Contrato\" md-theme=\"finance\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submitContract(vm.contract, contractformfinance)\" name=\"contractformfinance\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Contrato</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-if=\"!vm.is_first\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\"><div layout=\"column\" flex=\"50\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Pessoa</b> <small>Selecione abaixo a pessoa que está contratando o serviço</small></div></div><md-content layout=\"row\" class=\"md-padding\"><md-icon md-font-icon=\"icon-account\"></md-icon><md-autocomplete flex=\"\" required=\"\" md-input-name=\"autocompletepessoa\" class=\"md-input-has-placeholder\" md-no-cache=\"false\" md-selected-item=\"vm.contract.person\" md-search-text=\"vm.searchTextPerson\" md-items=\"item in vm.listAllPersons(vm.searchTextPerson)\" md-item-text=\"item.name\" md-min-length=\"3\" md-delay=\"500\" md-require-match=\"\" input-aria-describedby=\"Selecione a Pessoa contratante\" md-floating-label=\"Pessoa\"><md-item-template><span md-highlight-text=\"vm.searchTextPerson\">{{item.name}}</span></md-item-template><div ng-messages=\"contractformfinance.autocompletepessoa.$error\"><div ng-message=\"required\">Você <b>DEVE</b> selecionar uma pessoa.</div></div></md-autocomplete></md-content></div><div layout=\"column\" flex=\"45\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Serviço contratado</b> <small>Selecione abaixo o serviço relacionado ao contrato</small></div></div><md-content layout=\"row\" class=\"md-padding\"><md-icon md-font-icon=\"icon-school\"></md-icon><md-autocomplete flex=\"\" required=\"\" md-input-name=\"autocompletservice\" class=\"md-input-has-placeholder\" md-selected-item=\"vm.selectedService\" md-selected-item-change=\"vm.setItem(vm.selectedService)\" md-search-text=\"vm.searchText\" md-no-cache=\"true\" md-items=\"item in vm.getServices(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-floating-label=\"Serviço\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><div ng-messages=\"contractformfinance.autocompletservice.$error\"><div ng-message=\"required\">Você <b>DEVE</b> selecionar um serviço.</div></div></md-autocomplete></md-content></div></div><div layout=\"row\"><div layout=\"column\" flex=\"100\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Beneficiário</b> <small>Selecione abaixo, caso exista, o beneficiário do contrato</small></div></div><md-content layout=\"row\" class=\"md-padding\"><md-icon md-font-icon=\"icon-account\"></md-icon><md-autocomplete flex=\"\" md-input-name=\"autocompletepessoabeneficiario\" class=\"md-input-has-placeholder\" md-no-cache=\"false\" md-selected-item=\"vm.contract.person_beneficiary\" md-search-text=\"vm.searchTextPersonBeneficiary\" md-items=\"item in vm.listAllPersonsForBeneficiary(vm.searchTextPersonBeneficiary)\" md-item-text=\"item.name\" md-min-length=\"3\" md-delay=\"500\" md-require-match=\"\" input-aria-describedby=\"Selecione o beneficiário\" md-floating-label=\"Beneficiário\"><md-item-template><span md-highlight-text=\"vm.searchTextPersonBeneficiary\">{{item.name}}</span></md-item-template></md-autocomplete></md-content></div></div><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Definição de contrato</b> <small>Abaixo preencha as informações para a formulação do contrato</small></div></div><hr><md-card ng-show=\"vm.payment_plans.length == 0\"><md-card-title style=\"padding: 0 16px 12px !important;background-color: rgb(8, 204,117); color: white;\"><md-card-title-text><span class=\"md-subhead\">Sem plano de pagamento, não é possível continuar com o contrato</span></md-card-title-text></md-card-title></md-card><md-content ng-show=\"vm.payment_plans.length > 0\" class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Plano de pagamento</label><md-icon md-font-icon=\"icon-view-carousel\"></md-icon><md-select ng-model=\"vm.contract.payment_plan_id\" required=\"\" name=\"paymentplan\" aria-label=\"plano de pagamento\" ng-change=\"vm.setPaymentPlan(vm.contract.payment_plan_id)\"><md-option ng-value=\"payment.payment_plan_id\" ng-repeat=\"payment in vm.payment_plans track by $index\">{{payment.name}}</md-option></md-select><div ng-messages=\"contractformfinance.paymentplan.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar o plano de pagamento.</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Dia diferenciado de vencimento</label><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-select ng-model=\"vm.contract.preferential_due_day\" aria-label=\"dia diferenciado de pagamento\" ng-change=\"\"><md-option ng-value=\"day.id\" ng-repeat=\"day in vm.preferencial_due_day_list track by $index\">{{day.id}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"100\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" ng-if=\"vm.block_fields.date\" flex=\"25\"><label>Data de início</label><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><input ng-value=\"vm.contract.date_first | date:\'dd/MM/yyyy\'\" required=\"\" ng-disabled=\"true\"></md-input-container><date-picker flex=\"25\" required=\"\" ng-if=\"!vm.block_fields.date\" ng-change=\"vm.setFirstInstallmentDate(vm.contract.date_first)\" placeholder=\"Data de início\" ng-model=\"vm.contract.date_first\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\" ng-if=\"vm.contract.first_installment_date_type === 2\"><label>Venc. 1ª parcela</label><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><input type=\"text\" ng-value=\"vm.contract.first_installment_date | date:\'dd/MM/yyyy\'\" required=\"\" ng-disabled=\"true\"></md-input-container><date-picker flex=\"25\" required=\"\" ng-if=\"vm.contract.first_installment_date_type == 1\" placeholder=\"Venc. 1ª parcela\" ng-model=\"vm.contract.first_installment_date\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\" ng-if=\"vm.contract.date_end == null\"><label>Quantidade de parcelas</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"vm.contract.quantity\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" ng-if=\"vm.contract.date_end != null\" flex=\"25\"><label>Data final</label><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><input ng-value=\"vm.contract.date_end | date:\'dd/MM/yyyy\'\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Valor</label><md-icon md-font-icon=\"icon-coin\"></md-icon><input ng-model=\"vm.contract.amount\" required=\"\" ui-money-mask=\"\" ng-disabled=\"vm.block_fields.amount\"></md-input-container></div></div></md-content><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\" ng-if=\"vm.contract.recurrence_on_value === 1\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Parcelas</b> <small>O plano de pagamento selecionado permite que se altere o valor e data de vencimento das parcelas. Caso haja alguma informação em branco, preencha e clique no botão ao lado para recalcular as parcelas.</small></div><div flex=\"10\"><md-button class=\"md-icon-button\" ng-click=\"vm.generateInstalmentsByPaymentPlan(vm.contract)\"><md-tooltip md-direction=\"left\">Recalcular parcelas</md-tooltip><md-icon md-font-icon=\"icon-reload\"></md-icon></md-button></div></div><md-content ng-if=\"vm.contract.recurrence_on_value === 1\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">#</th><th md-column=\"\">Vencimento</th><th md-column=\"\">Valor (R$)</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.contract.payment_installments\"><td md-cell=\"\">{{ item.portion_name }}</td><td md-cell=\"\"><date-picker flex=\"25\" required=\"\" ng-model=\"item.due_date\" without-icon=\"true\"></date-picker></td><td md-cell=\"\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><input ng-model=\"item.amount\" required=\"\" ui-money-mask=\"\"></md-input-container></td></tr></tbody></table></md-table-container></md-content><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Descontos Individuais</b> <small>Descontos do contrato principal</small></div><div flex=\"10\"><md-button class=\"md-icon-button\" ng-click=\"vm.createNewIndividualDiscount()\"><md-tooltip md-direction=\"left\">Novo desconto individual</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><hr><md-content><a4-discounts-grid discounts=\"vm.contract.individual_discounts\" delete-function=\"vm.removeItemDesconto(discount_id)\" show-delete=\"true\"></a4-discounts-grid></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.goBack()\" ng-show=\"vm.is_first\">Cancelar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"vm.show_loading\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Salvar Contrato</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-contract-grid/edit-contract-modal.html","<md-dialog aria-label=\"Contrato\" md-theme=\"finance\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.updateContract(vm.contract, contractformeditfinance)\" name=\"contractformeditfinance\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Contrato</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-if=\"!vm.is_first\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\"><div layout=\"column\" flex=\"50\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Contratante</b> <small>Abaixo a pessoa que está contratando o serviço</small></div></div><md-content layout=\"row\" class=\"md-padding\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"90\"><md-icon md-font-icon=\"icon-account\"></md-icon><input ng-value=\"vm.contract.person.name\" ng-disabled=\"true\"></md-input-container></md-content></div><div layout=\"column\" flex=\"45\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Serviço contratado</b> <small>Abaixo o serviço relacionado contratado</small></div></div><md-content layout=\"row\" class=\"md-padding\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"90\"><md-icon md-font-icon=\"icon-school\"></md-icon><input ng-value=\"vm.contract.service.name\" ng-disabled=\"true\"></md-input-container></md-content></div></div><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Plano de pagamento</b> <small>Abaixo se encontra o plano de pagamento do contrato</small></div></div><hr><md-content class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><md-select ng-disabled=\"true\" ng-model=\"vm.contract.payment_plan_id\"><md-option ng-value=\"vm.contract.payment_plan_id\">{{vm.contract.payment_plan == null ? \'O contrato não possui plano de pagamento\' : vm.contract.payment_plan.name}}</md-option></md-select></md-input-container></md-content><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Definição de contrato</b> <small>Abaixo se encontram as informações possíveis de alteração do contrato</small></div></div><hr><md-content class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label>Valor da parcela do contrato</label><md-icon md-font-icon=\"icon-cash-usd\"></md-icon><input ng-model=\"vm.contract.amount\" name=\"installment_amount\" ui-money-mask=\"2\" autocomplete=\"off\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label>Mês de reajuste</label><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><md-select ng-model=\"vm.contract.next_adjustment_month\" name=\"next_adjustment_month\" aria-label=\"Mês de reajuste\"><md-option ng-value=\"1\">Janeiro</md-option><md-option ng-value=\"2\">Fevereiro</md-option><md-option ng-value=\"3\">Março</md-option><md-option ng-value=\"4\">Abril</md-option><md-option ng-value=\"5\">Maio</md-option><md-option ng-value=\"6\">Junho</md-option><md-option ng-value=\"7\">Julho</md-option><md-option ng-value=\"8\">Agosto</md-option><md-option ng-value=\"9\">Setembro</md-option><md-option ng-value=\"10\">Outubro</md-option><md-option ng-value=\"11\">Novembro</md-option><md-option ng-value=\"12\">Dezembro</md-option></md-select></md-input-container></div></md-content><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Data de validade das alterações e justificativa</b> <small>Defina a partir de qual data as alterações irão ter efeito e explique o porquê da alteração</small></div></div><hr><md-content class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\"><div layout=\"row\"><date-picker flex=\"\" placeholder=\"Data de validade da alteração\" required=\"true\" name=\"validity_date\" ng-model=\"vm.contract.validity_date\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label for=\"justification_text\">Justificativa</label><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><input ng-model=\"vm.contract.justification_text\" required=\"\" name=\"justification_text\" id=\"justification_text\" autocomplete=\"off\"><div ng-messages=\"contractformeditfinance.justification_text.$error\"><div ng-message=\"required\">Você <b>deve</b> informar o motivo da mudança.</div></div></md-input-container></div></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"vm.show_loading\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Salvar Contrato</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-contract-grid/edit-payee.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" md-theme=\"educational\"><form name=\"indexForm\" class=\"md-inline-form\" novalidate=\"\" ng-submit=\"vm.answer(vm.scope)\"><md-toolbar><div class=\"md-toolbar-tools\"><h4>Trocar responsável financeiro do contrato do serviço {{vm.scope.product_name}}</h4><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(28,130,204)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Atenção</b> <small>Ao definir um novo responsável financeiro, os boletos gerados que ainda não foram registrados serão cancelados. <b>Apenas os títulos em aberto terão seu responsável alterado.</b></small></div></div><md-input-container flex=\"\" class=\"md-block\" style=\"margin-top: 30px; margin-bottom: 0;\"><label>Responsável financeiro</label><md-select name=\"person_payee\" required=\"\" ng-model=\"vm.scope.person_payee\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.scope.studentsResponsibles\">{{ item.name }}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions style=\"background-color: whitesmoke; margin-top: 25px; width: 100%\"><span flex=\"\"></span><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-warm\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button><md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-cpf/a4-cpf.html","<md-input-container class=\"md-block md-input-has-placeholder {{classes}}\" ng-class=\"{\'show_error\': vm.cpf_error}\" flex-gt-xs=\"\"><label class=\"isEnabled\" ng-style=\"vm.cpf_error && {\'color\': \'red\'}\">CPF</label> <input ng-model=\"model\" name=\"CPF\" ng-blur=\"doCheck != false ? vm.verifyCPF(model) : \'\'\" ng-change=\"doCheck != false ? vm.verifyCPF(model) : \'\'\" ui-br-cpf-mask=\"\" ng-disabled=\"!isEnabled\" ng-class=\"{\'ng-invalid\': vm.cpf_error}\" ng-required=\"isRequired && vm.is_national_id_number_required\"><div class=\"md-input-message-animation\" ng-if=\"vm.cpf_error_message !== null\">{{vm.cpf_error_message}}</div></md-input-container>");
$templateCache.put("app/components/a4-credits-person/index.html","<md-button flex=\"\" style=\"width: 100%\" class=\"md-primary\" ng-click=\"vm.refund()\" ng-if=\"vm.actual_balance > 0\"><md-icon md-menu-origin=\"\">money_off</md-icon>Reembolsar valor</md-button><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Descrição</th><th md-column=\"\">Origem</th><th md-column=\"\" style=\"text-align: right\">Valor</th><th md-column=\"\" style=\"text-align: right\">Saldo</th><th md-column=\"\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"movement in vm.movements\"><td md-cell=\"\">{{movement.date | date: \'dd/MM/yyyy\'}}</td><td md-cell=\"\"><span ng-if=\"movement.debit_credit == \'C\'\">{{movement.movement_type}}</span> <span ng-if=\"movement.debit_credit == \'D\'\"><span ng-if=\"movement.movement_type == \'Uso no caixa\'\">Crédito utilizado no caixa</span> <span ng-if=\"movement.movement_type !== \'Uso no caixa\'\">Reembolso</span></span></td><td md-cell=\"\" md-truncate=\"\" class=\"md-table-menu\"><span ng-if=\"movement.movement_type == \'Pagamento a maior\'\">Boleto com vencimento em {{movement.bank_slip_due_date}} e nosso número {{movement.bank_number}}</span> <span ng-if=\"movement.movement_type == \'Pagamento indevido\'\"><span ng-if=\"movement.debit_credit == \'C\'\"><span><b>{{movement.student_name}}</b></span><br><span><small>{{movement.bill_info}}</small></span></span></span> <span ng-if=\"movement.movement_type == \'Estorno\'\"><span ng-if=\"movement.debit_credit == \'C\'\"><span><b>{{movement.student_name}}</b></span><br><span><small>{{movement.bill_info}}</small></span></span></span> <span ng-if=\"movement.movement_type != \'Estorno\' && movement.movement_type != \'Pagamento a maior\' && movement.movement_type != \'Pagamento indevido\'\">Comanda {{movement.bill_action_id}} de {{movement.bill_action_creation}}</span></td><td md-cell=\"\" style=\"text-align: right\"><span ng-style=\'{ \"color\": movement.debit_credit == \"D\" ? \"red\" : \"black\" }\'>{{movement.amount | currency: \"\"}}</span></td><td md-cell=\"\" style=\"text-align: right\">{{movement.balance | currency: \"\"}}</td><td md-cell=\"\" style=\"text-align: right\"><span ng-if=\"movement.debit_credit === \'D\'\"><md-button class=\"md-icon-button\" ng-click=\"vm.printCreditCheckpadSecondWay(movement.movement_id)\"><md-icon md-font-icon=\"icon-receipt\"></md-icon><md-tooltip md-direction=\"top\">Imprimir recibo do reembolso</md-tooltip></md-button></span></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/components/a4-credits-person/refund-print-checkpad.html","<md-dialog aria-label=\"Mango (Fruit)\" md-theme=\"finance\" style=\"width: 800px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Recibo de reembolso</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Reembolso realizado com sucesso</b> <small>Abaixo você pode realizar a impressão em PDF do recibo</small></div></div><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.answer(true)\" target=\"_blank\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><div>Imprimir recibo em PDF</div></a></md-card></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/a4-credits-person/refund.html","<md-dialog aria-label=\"Reembolsar crédito\" md-theme=\"finance\" style=\"min-width: 700px\"><form name=\"form_refund\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">Reembolso de crédito</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><a4-options-movement current-account=\"vm.scope.current_account_id\" movement-type=\"vm.scope.movement_type_id\"></a4-options-movement><div flex=\"\" style=\"width: 100%\" layout=\"row\"><md-input-container flex=\"50\" style=\"width: 48%\"><label>Valor</label> <input ng-model=\"vm.scope.amount\" flex=\"\" ui-money-mask=\"\" min=\"0.01\" max=\"{{vm.scope.max_amount}}\" required=\"\"></md-input-container><md-input-container flex=\"50\" style=\"width: 48%\"><label>Observações</label> <input ng-model=\"vm.scope.notes\" type=\"text\" flex=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button ng-click=\"vm.answer(vm.scope)\" ng-disabled=\"vm.scope.current_account_id === null || vm.scope.movement_type_id === null || form_refund.$invalid\" class=\"md-raised md-primary\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-digital-sign/a4-digital-sign.html","<style>\n  @font-face {\n    font-family: \'Freestyle Script\';\n    font-style: normal;\n    font-weight: normal;\n    src: url(\'app/font/freestyle-script.ttf\') format(\'truetype\');\n  }\n</style><div flex=\"100\" layout=\"row\"><form name=\"sign_contract\" layout=\"column\" flex=\"\" ng-if=\"(vm.event.token == undefined || vm.event.token == null) && !vm.sign_confirmed\"><div><div style=\"font-size: 18px;\" align=\"justify\">Preenchendo este formulário você declara concordar integralmente com este documento apresentado.<br>Para realizar a assinatura eletrônica, confirme seus dados abaixo de acordo com o que está registrado no sistema.<br><br><br></div></div><a4cpf model=\"vm.sign.national_id_number\" classes=\"show_bottom\" is-enabled=\"true\" do-check=\"false\" person-id=\"vm.person.id\" is-required=\"true\" show-owner=\"false\" flex-gt-xs=\"\"></a4cpf><a4email model=\"vm.sign.email\" is-enabled=\"true\" person-id=\"person.person_id\" show-owner=\"false\" is-required=\"true\" flex=\"\" block-form=\"blockFormEmail\" flex-gt-xs=\"\" do-check=\"false\"></a4email><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin-top: 40px;\"><label class=\"isEnabled\">Assine o seu primeiro e último nome</label> <input ng-model=\"vm.sign.name\" ng-required=\"true\" name=\"sign_name\" style=\"font-family: Freestyle Script; background-color: whitesmoke; font-size: 50px; height: 50px !important; padding-top: 15px !important;\" type=\"text\"></md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"vm.submit(false)\" ng-disabled=\"sign_contract.$invalid || $root.show_loader\" type=\"submit\" flex=\"\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular>Assinar</md-button></form><form name=\"confirm_sign\" layout=\"column\" flex=\"\" ng-if=\"vm.event.token != null && !vm.sign_confirmed\"><div><div style=\"font-size: 18px;\" align=\"justify\">Nós te enviamos um token (código) por e-mail, para o endereço {{vm.hided_email}}. Por favor, digite este código aqui para confirmar sua assinatura.<br><br></div></div><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin-top: 20px;\"><label class=\"isEnabled\">Token</label> <input ng-model=\"vm.sign.validation_code\" ng-required=\"true\" name=\"validation_code\"></md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"vm.submit(true)\" ng-disabled=\"sign_contract.$invalid || $root.show_loader\" type=\"submit\" flex=\"\" ng-if=\"!(vm.counter > 0)\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon>chat</md-icon>Reenviar token por SMS para o número {{vm.hided_phone}}</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.submit(false)\" ng-disabled=\"sign_contract.$invalid || $root.show_loader\" type=\"submit\" flex=\"\" ng-if=\"!(vm.counter > 0)\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon>mail</md-icon>Reenviar token por e-mail</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.submitValidationCode()\" ng-disabled=\"confirm_sign.$invalid || $root.show_loader\" type=\"submit\" flex=\"\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon>done</md-icon>Confirmar assinatura</md-button><div ng-if=\"vm.counter > 0\">Em 2 minutos, caso não tenha chegado o seu e-mail, uma nova opção de envio será disponibilizada.<md-progress-linear md-mode=\"determinate\" value=\"{{vm.determinateValue}}\"></md-progress-linear><span>{{vm.counter | counter | date: \'mm:ss\'}}</span></div></form><div ng-if=\"vm.sign_confirmed\" layout=\"column\" flex=\"\"><div style=\"font-size: 18px;\" align=\"justify\">Ótimo, sua assinatura foi confirmada!<br>Te enviamos um e-mail com o link para acessar o documento assinado.<br><br><br></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.closeModal()\" type=\"submit\" flex=\"\">Fechar</md-button></div></div>");
$templateCache.put("app/components/a4-digital-sign/valida.html","<md-content id=\"content\" class=\"externalFinancialStatement\" layout=\"row\" layout-align=\"center start\" md-theme=\"controlpanel\" ng-style=\"{height: vm.windowHeight + \'px\'}\" style=\"overflow: auto;\"><div layout=\"column\" layout-align=\"start center\" class=\"statementBackground\" style=\"width: 100%; overflow: auto\" ng-style=\"{\'height\': vm.windowHeight + \'px\', \'background\': vm.url_background}\"><md-card class=\"presentationCard md-whiteframe-7dp md-padding\" style=\"border-radius: 7px; width: 75%; text-align: center\" ng-style=\"vm.cpf_verify === false && vm.windowWidth < 1000 && {\'margin-top\': \'50%\'}\" layout=\"row\" layout-align=\"center start\"><div id=\"login-v2-form\" style=\"width: 40%\" ng-style=\"{width: vm.cpfFormWidth + \'%\'}\"><div style=\"width: 115px;line-height: 74px;font-size: 50px;font-weight: 500; margin: 2px auto 32px auto;color: #FFFFFF;border-radius: 2px;display: table;\"><div style=\"display: table-cell; vertical-align: middle;\"><img align=\"middle\" ng-src=\"{{vm.screen_image}}\" alt=\"\"></div></div><span class=\"headerSpan\">{{vm.data.company_name.split(\'(\')[0]}}</span><form name=\"formCPF\" novalidate=\"\" ng-if=\"!vm.cpf_verify\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" name=\"Codigo\" ng-model=\"vm.external_id\" placeholder=\"Código do documento\" required=\"\"></md-input-container><div layout=\"column\"><md-button class=\"md-raised md-accent submit-button\" aria-label=\"Validar\" ng-click=\"vm.validate()\" ng-disabled=\"formCPF.$invalid || vm.loading\">Confirmar</md-button></div></form></div></md-card></div></md-content>");
$templateCache.put("app/components/a4-discounts/discounts-grid.html","<table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Razão</th><th md-column=\"\" style=\"text-align: right\">Desconto</th><th md-column=\"\">Validade</th><th md-column=\"\">Comportamento</th><th md-column=\"\">De</th><th md-column=\"\">Até</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in discounts\" ng-if=\"(onlyPaymentPlanDiscount !== true && onlyIndividualDiscount !== true) || (onlyIndividualDiscount === true && item.bill_serie_id !== null) || (onlyPaymentPlanDiscount === true && item.payment_plan_id !== null)\"><td md-cell=\"\">{{ item.name }}</td><td md-cell=\"\" style=\"text-align: right\">{{ item.format == \'P\' ? (item.id != undefined ? item.value_percent_1 : item.value_percent_1*100) +\" %\" : \"R$ \" + item.value_percent_1 }}</td><td md-cell=\"\">{{ vm.convertType(item.type) }}</td><td md-cell=\"\">{{ vm.getBehavior(item) }}</td><td md-cell=\"\"><span ng-if=\"item.start_date !== null\">{{ item.start_date | date:\"dd/MM/yyyy\" }}</span></td><td md-cell=\"\"><span ng-if=\"item.end_date !== null\">{{ item.end_date | date:\"dd/MM/yyyy\" }}</span></td><td md-cell=\"\" flex=\"\" layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.editDiscount(item)\" ng-hide=\"vm.is_finance_enrolment == true\" policy-access=\"contrato_del_desc_indiv\" ng-if=\"showDelete\" flex=\"50\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"deleteFunction({discount_id: item.id, discount_index: item.index})\" policy-access=\"contrato_del_desc_indiv\" ng-if=\"showDelete\" flex=\"50\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr><tr md-row=\"\" ng-if=\"angular.isUndefined(discounts[0].name)\"><td md-cell=\"\"></td><td md-cell=\"\">Não há descontos</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table>");
$templateCache.put("app/components/a4-discounts/modal.html","<md-dialog aria-label=\"Mango (Fruit)\" md-theme=\"{{vm.theme}}\" style=\"width: 700px; overflow: hidden\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2><span ng-if=\"!vm.is_edit\">Criar</span> <span ng-if=\"vm.is_edit\">Editar</span> desconto</h2><a4-guide-button guide=\"\'discounts\'\" button-theme=\"\'financeButton\'\"></a4-guide-button></div></md-toolbar><form ng-cloak=\"\" name=\"newDiscount\" ng-submit=\"vm.submit(newDiscount)\" novalidate=\"\"><div class=\"modal-a4\"><md-dialog-content style=\"padding-top: 0;padding-bottom: 0; overflow: scroll\"><div class=\"md-dialog-content\" layout=\"column\"><md-autocomplete flex=\"\" class=\"md-input-has-placeholder\" md-input-name=\"autocompleteField\" md-selected-item=\"vm.form.discount_reason\" md-selected-item-change=\"vm.set_discount_reason()\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getDiscountsReasons(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-min-length=\"0\" md-floating-label=\"Razão de desconto\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template></md-autocomplete><md-input-container><strong class=\"group-field\"><small>Validade do desconto</small></strong><md-radio-group ng-model=\"vm.form.type\"><md-radio-button ng-value=\"\'F\'\" style=\"margin-bottom: 0px !important;\">Fixo</md-radio-button><span style=\"font-size: 14px; color: #919191\">O desconto é incondicionalmente válido independente da data que o título for pago.</span><md-radio-button ng-value=\"\'C\'\" style=\"margin-bottom: 0px !important; margin-top: 15px !important;\">Condicional ao vencimento</md-radio-button><span style=\"font-size: 14px; color: #919191\">O desconto é válido apenas se o título for pago até a data de vencimento.</span><md-radio-button ng-value=\"\'P\'\" style=\"margin-bottom: 0px !important; margin-top: 15px !important;\">Promocional por antecipação</md-radio-button><span style=\"font-size: 14px; color: #919191\">Um ou mais descontos válidos para pagamento antecipado.</span></md-radio-group></md-input-container><md-input-container><strong class=\"group-field\"><small>Formato do desconto</small></strong><md-radio-group ng-model=\"vm.form.format\"><md-radio-button ng-value=\"\'P\'\">Em percentual</md-radio-button><md-radio-button ng-value=\"\'V\'\">Em valor monetário</md-radio-button></md-radio-group></md-input-container><strong class=\"group-field\" ng-if=\"vm.form.type == \'P\'\"><small>Desconto Promocional</small></strong> <strong class=\"group-field\" ng-if=\"vm.form.type !== \'P\'\"><small>Desconto</small></strong><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"vm.form.type == \'P\'\"><div flex=\"\"><label>Desconto 1</label><md-input-container ng-if=\"vm.form.format === \'P\'\" class=\"md-block\"><input type=\"text\" tabindex=\"1\" ng-model=\"vm.form.value_percent_1\" ui-percentage-mask=\"\" placeholder=\"Percentual\" required=\"\"></md-input-container><md-input-container ng-if=\"vm.form.format === \'V\'\" class=\"md-block\"><input tabindex=\"1\" ng-model=\"vm.form.value_percent_1\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" placeholder=\"Valor\" required=\"\"></md-input-container><md-input-container class=\"md-block\"><input tabindex=\"2\" ng-model=\"vm.form.validity_days_1\" maxlength=\"2\" placeholder=\"Dias de Antecipação\"></md-input-container></div><div flex=\"\"><label>Desconto 2 <small>(opcional)</small></label><md-input-container ng-if=\"vm.form.format === \'P\'\" class=\"md-block\"><input tabindex=\"3\" max=\"vm.form.value_percent_1\" ng-class=\"{\'error\': vm.validateValue(vm.form.value_percent_2, vm.form.value_percent_1, 0, 0)}\" ng-if=\"vm.form.format === \'P\'\" ng-model=\"vm.form.value_percent_2\" ng-disabled=\"vm.form.validity_days_1 == null || vm.form.validity_days_1 == \'\'\" ui-percentage-mask=\"\" placeholder=\"Percentual\"></md-input-container><md-input-container ng-if=\"vm.form.format === \'V\'\" class=\"md-block\"><input tabindex=\"3\" max=\"vm.form.value_percent_1\" ng-class=\"{\'error\': vm.validateValue(vm.form.value_percent_2, vm.form.value_percent_1, 0, 0)}\" ng-if=\"vm.form.format === \'V\'\" ng-model=\"vm.form.value_percent_2\" ng-disabled=\"vm.form.validity_days_1 == null || vm.form.validity_days_1 == \'\'\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" placeholder=\"Valor\"></md-input-container><md-input-container class=\"md-block\"><input tabindex=\"4\" max=\"vm.form.validity_days_1\" ng-model=\"vm.form.validity_days_2\" ng-disabled=\"vm.form.validity_days_1 == null || vm.form.validity_days_1 == \'\'\" maxlength=\"2\" placeholder=\"Dias de Antecipação\"></md-input-container></div><div flex=\"\"><label>Desconto 3 <small>(opcional)</small></label><md-input-container ng-if=\"vm.form.format === \'P\'\" class=\"md-block\"><input tabindex=\"5\" max=\"vm.form.value_percent_2\" ng-class=\"{\'error\': vm.validateValue(vm.form.value_percent_3, vm.form.value_percent_2, 1, 0)}\" ng-if=\"vm.form.format === \'P\'\" ng-model=\"vm.form.value_percent_3\" ng-disabled=\"vm.form.validity_days_2 == null || vm.form.validity_days_2 == \'\'\" ui-percentage-mask=\"\" placeholder=\"Percentual\"></md-input-container><md-input-container ng-if=\"vm.form.format === \'V\'\" class=\"md-block\"><input tabindex=\"5\" max=\"vm.form.value_percent_2\" ng-class=\"{\'error\': vm.validateValue(vm.form.value_percent_3, vm.form.value_percent_2, 1, 0)}\" ng-if=\"vm.form.format === \'V\'\" ng-model=\"vm.form.value_percent_3\" ng-disabled=\"vm.form.validity_days_2 == null || vm.form.validity_days_2 == \'\'\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" id=\"exampleInputEmail3\" placeholder=\"Valor\"></md-input-container><md-input-container class=\"md-block\"><input tabindex=\"6\" max=\"vm.form.validity_days_2\" ng-model=\"vm.form.validity_days_3\" ng-disabled=\"vm.form.validity_days_2 == null || vm.form.validity_days_2 == \'\'\" id=\"exampleInputEmail3\" maxlength=\"2\" placeholder=\"Dias de Antecipação\"></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"vm.form.type == \'F\' || vm.form.type == \'C\'\"><md-input-container ng-if=\"vm.form.format === \'P\'\" flex=\"\"><input type=\"text\" ng-model=\"vm.form.value_percent_1\" name=\"role_name\" placeholder=\"Percentual\" ui-percentage-mask=\"\" required=\"\"></md-input-container><md-input-container ng-if=\"vm.form.format === \'V\'\" flex=\"\"><input type=\"text\" ng-model=\"vm.form.value_percent_1\" placeholder=\"Valor\" name=\"role_name\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" required=\"\"></md-input-container></div><md-input-container><strong class=\"group-field\"><small>Comportamento</small></strong><md-select ng-model=\"vm.form.discount_behavior_id\" required=\"\" ng-disabled=\"vm.is_edit\"><md-option ng-repeat=\"behavior in vm.behaviors\" ng-if=\"(behavior.for_percent && vm.form.format === \'P\') || (behavior.for_value && vm.form.format === \'V\')\" ng-value=\"behavior.id\">{{behavior.name}}</md-option></md-select></md-input-container><md-input-container><strong class=\"group-field\"><small>Exclusão</small></strong><md-checkbox ng-model=\"vm.form.is_excluded_first_installment\">Não aplica desconto na primeira parcela do contrato</md-checkbox></md-input-container><strong class=\"group-field\"><small>Vigência do desconto</small></strong> <span style=\"font-size: 14px; color: #919191\">Ao informar uma data inicial, apenas as parcelas com vencimento a partir desta data sofrerão o desconto. Ao informar uma data final, apenas as parcelas com vencimento anterior à esta data sofrerão o desconto.</span><div layout=\"column\"><date-picker flex=\"\" ng-model=\"vm.form.start_date\" placeholder=\"{{ \'Data inicial\' | translate}}\"></date-picker><date-picker flex=\"\" ng-model=\"vm.form.end_date\" placeholder=\"{{ \'Data Final\' | translate}}\"></date-picker></div><md-input-container><strong class=\"group-field\"><small>Observações</small></strong> <textarea name=\"notes\" cols=\"70\" rows=\"3\" ng-model=\"vm.form.notes\"></textarea></md-input-container></div></md-dialog-content></div></form><md-dialog-actions layout=\"row\" layout-align=\"end center\" style=\"background-color: whitesmoke\"><md-button ng-click=\"vm.close()\" class=\"md-raised md-button\">Cancelar</md-button><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.submit(newDiscount)\" ng-disabled=\"newDiscount.$invalid\"><span ng-if=\"!vm.is_edit\">Criar</span> <span ng-if=\"vm.is_edit\">Atualizar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-email/a4-email.html","<md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin-bottom: 1px;\" ng-class=\"{\'show_error\': vm.email_error}\"><label class=\"isEnabled\" ng-style=\"vm.email_error && {\'color\': \'red\'}\">{{vm.label}}</label><md-progress-circular ng-show=\"vm.showLoader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><input ng-model=\"model\" name=\"email\" type=\"email\" ng-change=\"model = model.toLowerCase(); doCheck != false ? vm.verifyEmail(model) : \'\'\" ng-disabled=\"!isEnabled || notRequired\" ng-class=\"{\'ng-invalid\': vm.email_error}\" ng-model-options=\"{ debounce: 500 }\" ng-required=\"isRequired || (vm.company_id == 713 || vm.company_id == 127342)\" ng-blur=\"model = model.toLowerCase()\"><div class=\"md-input-message-animation\" ng-if=\"vm.email_error_message !== null\">{{vm.email_error_message}}</div></md-input-container>");
$templateCache.put("app/components/a4-email-warning/warning.html","<md-card flex=\"\" layout=\"row\" ng-if=\"person.email_error\" policy-access=\"info_gerenciais\"><div flex=\"\" style=\"background-color: #f57c00; width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p><md-icon md-font-icon=\"icon-alert\" style=\"color: #fff;font-size: 60px;line-height: normal;\"></md-icon><span style=\"font-size: 18px; color: #fff;\">O e-mail desta pessoa está com o seguinte problema: {{person.email_error}}</span></p></div></md-card>");
$templateCache.put("app/components/a4-emails-errors/emails-errors-details.html","<md-dialog md-theme=\"controlpanel\" style=\"width: 2000px\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-account-box\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Endereços de e-mail com problemas</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Pessoa</th><th md-column=\"\">Papel</th><th md-column=\"\">Telefone</th><th md-column=\"\">Celular</th><th md-column=\"\">Erro</th><th md-column=\"\">E-mail</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"error in vm.report track by $index\"><td md-cell=\"\">{{error.person_name}}</td><td md-cell=\"\">{{error.role}}</td><td md-cell=\"\">{{error.phone_landline}}</td><td md-cell=\"\">{{error.phone_mobile}}</td><td md-cell=\"\">{{error.bounce_description}}</td><td md-cell=\"\" layout=\"row\" layout-align=\"space-around center\" flex=\"\"><span ng-if=\"error.edit !== true\">{{error.recipient}}</span><md-input-container flex=\"80\" ng-if=\"error.edit == true\"><input ng-model=\"error.recipient\" type=\"email\"></md-input-container><span flex=\"20\"><md-button class=\"md-icon-button\" ng-click=\"vm.allowEdit(error)\" ng-if=\"!vm.loader && error.edit !== true\" flex=\"\" style=\"text-align: right; right: 0 !important;\"><md-icon>edit</md-icon><md-tooltip md-direction=\"right\">Editar</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.adjustEmail(error, $index)\" ng-if=\"!vm.loader && error.edit == true\" flex=\"\" style=\"text-align: right\"><md-icon>check</md-icon><md-tooltip md-direction=\"right\">Ajustar endereço de e-mail</md-tooltip></md-button><md-progress-circular md-diameter=\"15\" md-mode=\"indeterminate\" ng-if=\"vm.loader\" flex=\"\"></md-progress-circular></span></td></tr></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised\" ng-click=\"vm.close()\">Fechar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-emails-errors/index.html","<ms-widget layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\" flex=\"\"><div class=\"h3 p-16\" layout=\"row\" layout-align=\"space-between center\"><span>{{report.length}} endereços de e-mail com problemas</span><md-button ng-click=\"vm.showEmailsDetails()\"><span>Clique aqui para expandir<md-icon>zoom_in</md-icon></span></md-button></div><md-divider></md-divider><div class=\"p-16\"><h2 ng-repeat=\"error in errors\" ng-style=\'{ \"color\": error.type == \"hard\" ? \"#ab0000\" : \"#dea947\" }\' style=\"margin-left: 15px !important;\">{{error.counter}} {{error.bounce_description}}</h2></div></ms-widget-front></ms-widget>");
$templateCache.put("app/components/a4-file-upload/a4-file-upload.html","<div class=\"dropzone-container\" layout=\"row\"><div class=\"dropzone md-block\" ng-dropzone=\"\" options=\"options\" callbacks=\"callbacks\" methods=\"methods\" flex=\"100\"></div></div><div class=\"dropzone-info bottom\" layout=\"row\" layout-align=\"start center\"><small style=\"margin-right: 20px\"><strong>Arquivos permitidos:</strong>{{vm.acceptedtypes | uppercase}}</small> <small><strong>Tamanho máximo:</strong> {{options.maxFilesize}}MB</small></div>");
$templateCache.put("app/components/a4-filter/index.html","<div style=\"padding: 0; margin: 0;\" layout=\"row\" flex=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>Curso</label><md-select ng-model=\"ctrl.userState\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"state.abbrev\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Turma</label><md-select ng-model=\"ctrl.userState\"><md-option ng-repeat=\"group in vm.groups\" ng-value=\"state.abbrev\">{{state.abbrev}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/components/a4-form-dic-data/a4-form-dic-data.form-wizard.html","<md-steppers md-busy-text=\"\'Aguarde...\'\" md-busy=\"vm.showBusyText\" md-dynamic-height=\"\" md-stretch-steppers=\"always\" md-selected=\"stepSelected\"><md-step ng-repeat=\"item in form.items track by $index\" label=\"{{item.label}}\" md-complete=\"item.completed\" ng-disabled=\"item.disabled\"><form id=\"{{form.id}}\" name=\"form_dynamic\"><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><a4-form-dic-data-item field=\"field\" ng-repeat=\"field in item.fields track by $index\" bind=\"bind\" list=\"list\" form=\"form\" ng-show=\"field.show\" flex=\"{{field.flex || auto}}\" flex-xs=\"100\"></a4-form-dic-data-item></md-content><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"stepSelected > 0\" ng-click=\"vm.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>{{ (item.text_button_previous || \'Anterior\') | translate}}</md-button><md-button type=\"button\" ng-show=\"stepSelected == 0\" class=\"invisibled\"></md-button><md-button type=\"button\" ng-show=\"stepSelected < form.items.length - 1\" ng-click=\"vm.submitCurrentStep(item, null, bind, form, table, $index)\" class=\"md-primary md-raised\" ng-disabled=\"form_dynamic.$pristine || form_dynamic.$invalid || $root.show_loader\">{{ (item.text_button_next || \'Próximo\') | translate}}<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button><md-button type=\"button\" ng-click=\"vm.wFinish(bind, form);\" ng-disabled=\"!vm.isAbleFinished\" class=\"md-primary md-raised\" ng-show=\"stepSelected == form.items.length - 1\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-check\"></md-icon>{{ (item.text_button_finish || \'Finalizar\') | translate}}</md-button></div></md-step-actions></form></md-step></md-steppers>");
$templateCache.put("app/components/a4-form-dic-data/a4-form-dic-data.form.html","<form id=\"{{form.id}}\" name=\"form_dynamic\" ng-submit=\"submit({item: bind, form: form_dynamic, table: table})\" ng-class=\"$root.show_loader == true ? \'eventLoading\' : \'\'\" novalidate=\"\"><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><a4-form-dic-data-item field=\"item\" ng-repeat=\"item in form.items\" bind=\"bind\" list=\"list\" form=\"form\" ng-show=\"item.show\" flex=\"{{item.flex || auto}}\" flex-xs=\"100\"></a4-form-dic-data-item></md-content><md-content layout=\"row\" layout-xs=\"column\" class=\"md-padding\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" layout-align=\"end center\"><md-button ng-show=\"bind.mode_edit\" ng-if=\"form.show_cancel\" ng-click=\"onClose();\" class=\"md-raised\"><md-icon md-font-icon=\"icon-close\"></md-icon>Cancelar</md-button><md-button ng-show=\"bind.mode_edit\" type=\"{{btn.type}}\" class=\"{{btn.class}}\" ng-if=\"!checkPolicies(\'cud\') && (btn.type != \'submit\' && btn.type_special == \'delete\')\" ng-class=\"btn.type == \'submit\' ? \'md-raised submit-button\' : \'\'\" ng-repeat=\"btn in form.actions track by $index\" ng-click=\"onDelete({item: bind})\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"{{btn.icon}}\"></md-icon>{{btn.id}}</md-button><md-button ng-show=\"bind.mode_edit\" type=\"{{btn.type}}\" class=\"{{btn.class}}\" ng-if=\"!checkPolicies(\'cud\') && (btn.type == \'submit\' && btn.type_special != \'save-and-replicate\' && btn.type_special != \'save-and-continue\' && btn.type_special != \'save-and-add-more\')\" ng-class=\"btn.type == \'submit\' ? \'md-raised submit-button\' : \'\'\" ng-disabled=\"$root.show_loader\" ng-repeat=\"btn in form.actions track by $index\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"{{btn.icon}}\"></md-icon>{{btn.id}}</md-button><md-button ng-show=\"bind.mode_edit\" type=\"{{btn.type}}\" class=\"{{btn.class}}\" ng-if=\"!checkPolicies(\'cud\') && (btn.type == \'submit\' && btn.type_special == \'save-and-replicate\')\" ng-class=\"btn.type == \'submit\' ? \'md-raised submit-button\' : \'\'\" ng-disabled=\"form.disabled && form_dynamic.$pristine || form_dynamic.$invalid || $root.show_loader\" ng-repeat=\"btn in form.actions track by $index\" ng-click=\"onSaveAndReplicate({replicate: true})\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"{{btn.icon}}\"></md-icon>{{btn.id}}</md-button><md-button ng-show=\"bind.mode_edit\" type=\"{{btn.type}}\" class=\"{{btn.class}}\" ng-if=\"!checkPolicies(\'cud\') && (btn.type == \'submit\' && btn.type_special == \'save-and-continue\')\" ng-class=\"btn.type == \'submit\' ? \'md-raised submit-button\' : \'\'\" ng-disabled=\"form.disabled && form_dynamic.$pristine || form_dynamic.$invalid || $root.show_loader\" ng-repeat=\"btn in form.actions track by $index\" ng-click=\"onSaveAndContinue({continue: true})\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"{{btn.icon}}\"></md-icon>{{btn.id}}</md-button><md-button ng-show=\"bind.mode_edit\" type=\"{{btn.type}}\" class=\"{{btn.class}}\" ng-if=\"!checkPolicies(\'cud\') && (btn.type == \'submit\' && btn.type_special == \'save-and-add-more\')\" ng-class=\"btn.type == \'submit\' ? \'md-raised submit-button\' : \'\'\" ng-disabled=\"form.disabled && form_dynamic.$pristine || form_dynamic.$invalid || $root.show_loader\" ng-repeat=\"btn in form.actions track by $index\" ng-click=\"onSaveAndAddMore({add: true})\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"{{btn.icon}}\"></md-icon>{{btn.id}}</md-button></md-content></form>");
$templateCache.put("app/components/a4-form-dic-data/a4-form-dic-data.grid-select.html","<md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"bind.selected.length\" ng-if=\"bind.title.show\"><div class=\"md-toolbar-tools\"><span>{{bind.title.name}}</span></div></md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"bind.selected.length\"><div class=\"md-toolbar-tools\"><span>{{bind.selected.length}} {{bind.selected.length > 1 ? \'items\' : \'item\'}} selecionado<span ng-show=\"bind.selected.length > 1\">s</span></span><div flex=\"\"></div><md-button class=\"md-icon-button\" ng-click=\"onProcessSelected()\"><md-icon>edit</md-icon></md-button></div></md-toolbar><md-table-container flex=\"\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"bind.selected\" md-progress=\"bind.promise\"><thead md-head=\"\" md-order=\"bind.info.order\" md-on-reorder=\"onPaginate({page:page, limit:limit})\" ng-class=\"(form.groupBy) ? \'notAll\' : \'\'\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"\" ng-repeat=\"(index, item) in form.items track by index\" ng-if=\"item.show\"><span>{{item.column_name}}</span></th><th md-column=\"\" md-order-by=\"\" class=\"text-{{item.align}} md-column\" ng-if=\"form.actions_custom\" ng-repeat=\"(index, item) in form.actions_custom track by index\"><span>{{item.id}}</span></th><th md-column=\"\" md-order-by=\"\" class=\"text-center md-column\" ng-if=\"form.actions\"><span>Actions</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-select-id=\"{{bind.selected_column}}\" ng-disabled=\"checkPolicies(\'show\') || (bind.selected[0][form.groupBy] && item[form.groupBy] != bind.selected[0][form.groupBy])\" ng-repeat=\"(index, item) in bind.rows track by index\" ng-click=\"onClickItem({item:item, option:\'edit\'})\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" ng-if=\"column.show\" ng-class=\"(item.is_inactive) ? \'is_inactive\' : \'\'\" ng-repeat=\"(index, column) in form.items track by index\"><span ng-hide=\"column.hidden_text\" flex=\"\">{{::item[column.reference] }}</span> <span ng-repeat=\"(index, badge) in form.badges track by index\" class=\"badge\" ng-class=\"(column.hidden_text) ? \'alone\' : \'\'\" ng-if=\"form.badges.length && badge.column == column.reference\"><span ng-if=\"badge.type == \'text\'\" class=\"{{ badge.field }} {{ item[badge.field_name] }}\" ng-show=\"item[badge.field]\"><span ng-show=\"badge.field_name\">{{ item[badge.field_name] }}</span> <span ng-hide=\"badge.field_name\">{{ badge.name }}</span></span><md-icon class=\"material-icons\" ng-if=\"badge.type == \'icon\'\" ng-show=\"item[badge.field]\">{{badge.icon}}</md-icon></span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"text-{{custom.align}} md-cell\" ng-if=\"form.actions_custom\" ng-repeat=\"(index, custom) in form.actions_custom track by index\"><md-button class=\"md-icon-button\" ui-sref=\"{{::custom.uiSref}}({{::custom.uiSrefParam}})\" ng-if=\"custom.uiSref\"><md-tooltip md-direction=\"left\">{{custom.message}}</md-tooltip><md-icon>{{custom.icon}}</md-icon></md-button><div class=\"badge-content\" ng-if=\"custom.badge\" ng-hide=\"custom.show_with_null != true && item[custom.badge_field] == null || item[custom.badge_field] == 0\"><div class=\"badge-btn\" ng-hide=\"item[custom.badge_field] == null || item[custom.badge_field] == 0\">{{item[custom.badge_field] }}</div><md-button class=\"md-fab md-mini\" ng-click=\"ClickActions(item, custom.option); $event.stopPropagation()\"><md-icon>{{custom.icon}}</md-icon><md-tooltip md-direction=\"top\">{{custom.message}}</md-tooltip></md-button></div></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"text-right md-cell\" ng-if=\"form.actions\"><md-menu aria-label=\"menu\"><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event); $event.stopPropagation()\"><md-icon md-menu-origin=\"\">more_vert</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"(index, action) in form.list_actions track by index\"><md-button aria-label=\"{{action.name}}\" ng-disabled=\"{{action.disabled}}\" ng-click=\"ClickActions(item, action.option)\"><md-icon md-menu-align-target=\"\">{{action.icon}}</md-icon>{{action.name}}</md-button></md-menu-item><div ng-repeat=\"(index, btn) in form.actions track by index\"><md-menu-divider ng-if=\"!checkPolicies(\'cud\') && btn.type_option == \'delete\'\"></md-menu-divider><md-menu-item ng-if=\"!checkPolicies(\'cud\') && btn.type_option == \'delete\'\"><md-button ng-class=\"(!checkPolicies(\'cud\') && (item.block_delete && btn.type_option == \'delete\')) ? \'button-disable\' : \'\'\" ng-click=\"onDelete({index: item.id}); $event.stopPropagation()\"><md-icon md-menu-align-target=\"\">{{btn.icon}}</md-icon>{{item.message_block_delete ? item.message_block_delete : \'Excluir\' }}</md-button></md-menu-item><md-menu-divider ng-if=\"!btn.type_option == \'delete\'\"></md-menu-divider><md-menu-item ng-if=\"!btn.type_option == \'delete\'\"><md-button aria-label=\"{{btn.id}}\" ng-click=\"onClickItem({item:item, option:btn.type_option}); $event.stopPropagation()\"><md-icon>{{btn.icon}}</md-icon></md-button></md-menu-item></div></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"bind.info.limit\" md-limit-options=\"bind.info.limit_options\" md-page=\"bind.info.page\" md-total=\"{{bind.info.total}}\" md-on-paginate=\"onPaginate({page:page, limit:limit})\" md-page-select=\"\" flex=\"\"></md-table-pagination>");
$templateCache.put("app/components/a4-form-dic-data/a4-form-dic-data.grid.html","<md-table-pagination style=\"border-top: none\" ng-if=\"onPaginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"bind.info.limit\" md-limit-options=\"bind.info.limit_options\" md-page=\"bind.info.page\" md-total=\"{{bind.info.total}}\" md-on-paginate=\"onPaginate({page:page, limit:limit})\" md-page-select=\"\" flex=\"\"></md-table-pagination><md-table-container flex=\"\" class=\"table-float-button\"><table md-table=\"\" md-progress=\"bind.promise\"><thead md-head=\"\" md-order=\"bind.info.order\" md-on-reorder=\"onPaginate({page:page, limit:limit})\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"\" ng-repeat=\"(index, item) in ::form.items track by index\" ng-if=\"item.show\"><span>{{::item.column_name}}</span></th><th md-column=\"\" md-order-by=\"\" class=\"text-{{item.align}} md-column\" ng-if=\"form.actions_custom\" ng-repeat=\"(index, item) in form.actions_custom track by $index\"><span>{{item.id}}</span></th><th md-column=\"\" md-order-by=\"\" class=\"text-center md-column md-numeric\" ng-if=\"form.actions\"><span>Ações</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"(index, item) in bind.rows track by $index\" class=\"a4-grid-tr-hover-ripple\" ng-click=\"onClickItem({item:item, option:\'edit\'})\" ng-disabled=\"checkPolicies(\'show\')\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" ng-if=\"column.show\" ng-class=\"(item.is_inactive) ? \'is_inactive\' : \'\'\" ng-repeat=\"(index, column) in ::form.items track by $index\" style=\"word-wrap: break-word; white-space: normal;\"><img style=\"max-width: 39px;\" ng-src=\"{{CONFIG.webApiUri + item.photo}}\" ng-if=\"column.photo && item.photo\" class=\"avatar md-avatar\" alt=\"photo\"> <span ng-hide=\"column.hidden_text\">{{item[column.reference] }}</span><md-tooltip ng-repeat=\"(index, tip) in form.tooltips track by $index\" ng-if=\"form.tooltips.length && tip.column == column.reference && item[tip.field]\" md-direction=\"{{tip.direction}}\">{{angular.isDefined(tip.type) && tip.type == \'text\' ? tip.text : item[tip.field]}}</md-tooltip><span ng-repeat=\"(index, badge) in form.badges track by $index\" class=\"badge\" ng-class=\"(column.hidden_text) ? \'alone\' : \'\'\" ng-if=\"form.badges.length && badge.column == column.reference && ((badge.type == \'text\' || badge.type == \'icon\') && item[badge.field_name] != \'\' && item[badge.field_name] != null)\"><span ng-if=\"badge.type == \'text\' && item[badge.field] != false\" class=\"{{ badge.field }} {{ badge.field_name }} {{ item[badge.field_name] }}\"><span ng-show=\"badge.field\">{{ item[badge.field_name] }}</span> <span ng-hide=\"badge.field\">{{ badge.name }}</span></span><md-icon class=\"material-icons\" ng-if=\"badge.type == \'icon\'\" ng-show=\"item[badge.field]\">{{::badge.icon}}</md-icon></span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"text-{{custom.align}} md-cell\" ng-if=\"form.actions_custom\" ng-repeat=\"(index, custom) in form.actions_custom track by index\"><md-button class=\"md-icon-button\" ui-sref=\"{{::custom.uiSref}}({{::custom.uiSrefParam}})\" ng-if=\"custom.uiSref\"><md-tooltip md-direction=\"left\">{{custom.message}}</md-tooltip><md-icon>{{custom.icon}}</md-icon></md-button><div class=\"badge-content\" ng-if=\"custom.badge\" ng-hide=\"custom.show_with_null != true && item[custom.badge_field] == null || item[custom.badge_field] == 0\"><div class=\"badge-btn\" ng-hide=\"item[custom.badge_field] == null || item[custom.badge_field] == 0\">{{item[custom.badge_field] }}</div><md-button class=\"md-fab md-mini\" ng-click=\"ClickActions(item, custom.option); $event.stopPropagation()\"><md-icon>{{custom.icon}}</md-icon><md-tooltip md-direction=\"top\">{{custom.message}}</md-tooltip></md-button></div></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"text-right\" ng-if=\"form.actions\"><md-menu aria-label=\"menu\"><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event); $event.stopPropagation()\"><md-icon md-menu-origin=\"\">more_vert</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"(index, action) in ::form.list_actions track by $index\" ng-if=\"!checkPolicies(action.role)\"><md-button aria-label=\"{{action.name}}\" ng-disabled=\"{{action.disabled}}\" ng-click=\"clickActions(item, action.option)\"><md-icon md-menu-align-target=\"\">{{action.icon}}</md-icon>{{action.name}}</md-button></md-menu-item><div ng-repeat=\"(index, btn) in ::form.actions track by $index\"><md-menu-divider ng-if=\"!checkPolicies(\'cud\') && btn.type_option == \'delete\'\"></md-menu-divider><md-menu-item ng-if=\"btn.type_option != \'delete\'\"><md-button aria-label=\"{{btn.id}}\" ng-disabled=\"{{btn.disabled}}\" ng-click=\"clickActions(item, btn.type_option); $event.stopPropagation()\"><md-icon>{{btn.icon}}</md-icon>{{btn.name}}</md-button></md-menu-item><md-menu-divider ng-if=\"btn.type_option != \'delete\'\"></md-menu-divider><md-menu-item ng-if=\"!checkPolicies(\'cud\') && btn.type_option == \'delete\'\"><md-button ng-class=\"(!checkPolicies(\'cud\') && (item.block_delete && btn.type_option == \'delete\')) ? \'button-disable\' : \'\'\" ng-click=\"onDelete({index: item.id, item: item}); $event.stopPropagation()\" ng-disabled=\"{{btn.disabled}}\"><md-icon md-menu-align-target=\"\">{{::btn.icon}}</md-icon>{{item.message_block_delete ? item.message_block_delete : \'Excluir\' }}</md-button></md-menu-item></div></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/components/a4-form-dic-data/a4-form-dic-data.material-grid-group.html","<md-list class=\"contacts-list\"><md-list-item><div ng-if=\"item.show\" ng-repeat=\"item in form.items\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><b>{{item.column_name}}</b></div><div ng-if=\"angular.isDefined(form.actions) && form.actions.length > 0\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><span><b>Actions</b></span></div></md-list-item><md-list-item ng-repeat=\"item in bind.rows track by $index\" ng-click=\"onClickItem({item:item, option: \'edit\'})\"><div ng-if=\"column.show\" ng-repeat=\"column in form.items track by $index\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\">{{item[column.reference] }}</div><div ng-if=\"angular.isDefined(form.actions) && form.actions.length > 0\" class=\"actions\" layout=\"row\" layout-align=\"start center\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><md-button class=\"md-icon-button\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"onDelete({index: $index})\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/components/a4-form-dic-data/a4-form-dic-data.material-grid.html","<style>\n  .list-style {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .list-column {\n    border-bottom: 1px solid #ddd;\n  }\n</style><md-list class=\"contacts-list\"><md-list-item class=\"list-column\"><div ng-if=\"item.show\" ng-repeat=\"item in form.items\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"{{item.flex || auto}}\"><b>{{item.column_name}}</b></div><div ng-if=\"form.actions.length > 0\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><span></span></div></md-list-item><md-list-item ng-repeat=\"item in bind.rows track by $index\" ng-click=\"onClickItem({item:item, option: \'edit\'})\" class=\"list-style\"><div ng-if=\"column.show\" ng-repeat=\"column in form.items track by $index\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"{{column.flex || auto}}\">{{item[column.reference] }} <span ng-repeat=\"(index, badge) in form.badges track by $index\" class=\"badge\" ng-class=\"(column.hidden_text) ? \'alone\' : \'\'\" ng-if=\"form.badges.length && badge.column == column.reference && ((badge.type == \'text\' || badge.type == \'icon\') && item[badge.field_name] != \'\' && item[badge.field_name] != null)\"><span ng-if=\"badge.type == \'text\' && item[badge.field] != false\" class=\"{{ badge.field }} {{ badge.field_name }} {{ item[badge.field_name] }}\"><span ng-show=\"badge.field\">{{ item[badge.field_name] }}</span> <span ng-hide=\"badge.field\">{{ badge.name }}</span></span><md-icon class=\"material-icons\" ng-if=\"badge.type == \'icon\'\" ng-show=\"item[badge.field]\">{{::badge.icon}}</md-icon></span></div><div ng-if=\"form.actions.length > 0\" class=\"actions\" layout=\"row\" layout-align=\"end start\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"{{item.flex || auto}}\"><md-button class=\"md-icon-button\" ng-repeat=\"button in form.actions track by $index\" ng-if=\"!item.block_delete\"><md-tooltip md-direction=\"left\">{{item.message_block_delete}}</md-tooltip><md-icon md-font-icon=\"{{button.icon}}\" ng-click=\"onDelete({index: item.id})\"></md-icon></md-button><md-button class=\"md-icon-button button-disable\" ng-repeat=\"button in form.actions track by $index\" ng-if=\"item.block_delete\"><md-tooltip md-direction=\"left\">{{item.message_block_delete}}</md-tooltip><md-icon md-font-icon=\"{{button.icon}}\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/components/a4-groups/a4-groups.html","<div class=\"there-are-no\" layout-align=\"center center\" layout=\"column\" flex=\"\" ng-if=\"vm.grid.data.length === 0\"><div><md-icon>info_outline</md-icon></div><div class=\"preview-scale\"><strong>Não há registros ;(</strong></div></div><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 30, 50, 75, 100]\" md-page=\"vm.grid.current_page\" style=\"border: none;\" flex=\"\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.paginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-if=\"showCourse\">Curso</th><th md-column=\"\">Turma</th><th md-column=\"\" md-numeric=\"\">Período</th><th md-column=\"\" md-numeric=\"\">Matrículas/Capacidade</th><th md-column=\"\" ng-if=\"isWithoutSchoolPeriod\">Status</th><th md-column=\"\">Turno</th><th md-column=\"\">Grade curricular</th><th md-column=\"\">Critério de avaliação</th><th md-column=\"\" ng-if=\"isWithoutSchoolPeriod\">Data inicial</th><th md-column=\"\" ng-if=\"isWithoutSchoolPeriod\">Data final</th><th md-column=\"\" style=\"text-align: right\">Ações</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" style=\"cursor: pointer\" ng-repeat=\"item in vm.grid.data\" ng-click=\"vm.editGroup(item)\"><td md-cell=\"\" ng-if=\"showCourse\">{{ item.course_alias }}</td><td md-cell=\"\">{{ item.name }}</td><td md-cell=\"\"><span class=\"badge\"><span class=\"periodo\">{{ item.period_qty > 1 ? item.matrix_period + \'/\' + item.period_qty : \'Único\'}}</span></span></td><td md-cell=\"\" ng-if=\"item.group_capacity !== null\">{{item.enrolment_qty}}/{{item.group_capacity}}</td><td md-cell=\"\" ng-if=\"item.group_capacity == null\">{{item.enrolment_qty}}</td><td md-cell=\"\" ng-if=\"isWithoutSchoolPeriod\"><span class=\"badge\"><span class=\"group_status_{{item.group_status_id}}\">{{ item.group_status_name }}</span></span></td><td md-cell=\"\">{{ item.shift_name }}</td><td md-cell=\"\">{{ item.matrix_name }}</td><td md-cell=\"\">{{ item.grade_rule_name }}</td><td md-cell=\"\" ng-if=\"isWithoutSchoolPeriod\">{{ item.initial_date | date: \"dd/MM/yyyy\" }}</td><td md-cell=\"\" ng-if=\"isWithoutSchoolPeriod\">{{ item.final_date | date: \"dd/MM/yyyy\" }}</td><td md-cell=\"\" style=\"text-align: right\"><md-menu policy-access=\"turma_hor_alt\"><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"item.course_equivalence_id < 300 || item.matrix_period > 1\"><md-button class=\"realize_lesson\" ng-click=\"vm.conditionalGroupEnrollment(item)\"><md-icon>assignment_returned</md-icon>Matrícula condicional</md-button></md-menu-item><md-menu-item><md-button class=\"realize_lesson\" ng-click=\"vm.changeMatrix(item)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Trocar grade</md-button></md-menu-item><md-menu-item><md-button class=\"realize_lesson\" ng-click=\"vm.changeGradeRule(item)\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon>Trocar critério de avaliação</md-button></md-menu-item><md-menu-item><md-button class=\"realize_lesson\" ng-click=\"vm.recalculateNotes(item)\"><md-icon md-font-icon=\"icon-backup-restore\"></md-icon>Recalcular notas</md-button></md-menu-item><md-menu-item><md-button class=\"realize_lesson\" ng-click=\"vm.deleteGroup(item)\"><md-icon>delete</md-icon>Excluir</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.grid.current_page\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.paginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination>");
$templateCache.put("app/components/a4-groups/change-grade-rule.html","<md-dialog aria-label=\"Exclusão de matrícula\" md-theme=\"educational\"><form ng-cloak=\"\" novalidate=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-clipboard-text\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Alteração de critério de avaliação</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content><div class=\"md-padding\" flex=\"\"><md-input-container style=\"width: 100%\"><label>Critério</label><md-select ng-model=\"vm.scope.grade_rule_id\"><md-option ng-repeat=\"grade_rule in vm.scope.grade_rules\" ng-value=\"grade_rule.id\">{{grade_rule.name}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button ng-click=\"vm.answer(vm.scope.grade_rule_id)\" ng-disabled=\"vm.scope.grade_rule_id === vm.scope.grade_rule_id_old\" class=\"md-primary md-raised\" layout=\"row\"><span flex=\"95\">Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-guest-check-pad-report/index.html","<md-content style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" layout=\"column\"><md-content layout=\"column\"><md-content layout=\"row\" style=\"overflow: hidden\"><date-range-picker flex=\"25\" ng-model=\"vm.filter_date\" label=\"Datas\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Buscar\" flex=\"5\" ng-click=\"vm.getAllGuestCheckPadReport(1, 15, vm.filter_date);\"><md-tooltip md-direction=\"bottom\">Consultar</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-table-pagination flex=\"\" style=\"border-top: none\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.guest_check_pad_reports.per_page\" md-page=\"vm.guest_check_pad_reports.current_page\" md-on-paginate=\"vm.getAllBankSlipPaginate\" md-limit-options=\"[15, 25, 50, 75, 100]\" md-total=\"{{vm.guest_check_pad_reports.total}}\"></md-table-pagination></md-content><md-table-container style=\"padding-left: 10px; padding-right: 10px\"><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"vm.selected_bank_slip\" md-row-select=\"\" multiple=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Formas de pagamento</span></th><th md-column=\"\">Recebido por</th><th md-column=\"\">Nº Recibo</th><th md-column=\"\" style=\"text-align: center\">Ações</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"bank_slip\" md-select-id=\"bill_ids\" md-on-select=\"vm.generateLink()\" md-on-deselect=\"vm.generateLink()\" ng-repeat=\"guest_check_pad_report in vm.guest_check_pad_reports.data\"><td md-cell=\"\">{{guest_check_pad_report.date | date : \'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{guest_check_pad_report.payment_methods}}</td><td md-cell=\"\">{{guest_check_pad_report.person_name}}</td><td md-cell=\"\">{{guest_check_pad_report.bill_action_id}}</td><td md-cell=\"\" style=\"text-align: center\"><md-button class=\"md-icon-print md-icon-button\" aria-label=\"Imprimir\" ng-click=\"vm.printReport(guest_check_pad_report, 0, guest_check_pad_report.date)\"><md-icon md-font-icon=\"icon-file-pdf\"><md-tooltip>Imprimir segunda via em PDF</md-tooltip></md-icon></md-button><md-button class=\"md-icon-print md-icon-button\" aria-label=\"Imprimir\" ng-click=\"vm.printReport(guest_check_pad_report, 1, guest_check_pad_report.date)\"><md-icon><i class=\"material-icons\">print</i><md-tooltip>Imprimir segunda via para impressora não-fiscal</md-tooltip></md-icon></md-button><md-button class=\"md-icon-print md-icon-button\" aria-label=\"Imprimir\" ng-click=\"vm.undoGuestCheckPad(guest_check_pad_report)\" policy-access=\"desfaz_comanda\"><md-icon><i class=\"material-icons\">settings_backup_restore</i><md-tooltip>Desfazer comanda</md-tooltip></md-icon></md-button></td></tr><tr md-row=\"\" ng-if=\"vm.guest_check_pad_reports.data.length == 0\"><td md-cell=\"\"></td><td md-cell=\"\">Não existem recibos de caixa para este cliente</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></md-content></md-card></md-content>");
$templateCache.put("app/components/a4-guide-button/a4-guide-button.html","<md-button class=\"md-fab guideButton {{buttonTheme}}\" href=\"{{vm.guide.link}}\" target=\"_blank\"><md-icon>help</md-icon><md-tooltip md-direction=\"left\">{{vm.guide.title}}</md-tooltip></md-button>");
$templateCache.put("app/components/a4-move-reports-to-folder/a4-move-reports-to-folder.html","<md-dialog aria-label=\"Mover Relatório\" class=\"move-folder-dialog\"><form name=\"moveFolderForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Mover Relatório</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"dialog.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 0; margin: 0;\"><div class=\"md-dialog-content\" layout=\"column\" layout-padding=\"\"><p><strong>Relatório:</strong> {{dialog.reportItem.name}}</p><p>Selecione a pasta de destino:</p><md-radio-group ng-model=\"dialog.selectedFolder\" layout=\"column\"><md-radio-button ng-repeat=\"folder in dialog.folders\" ng-value=\"folder\" ng-disabled=\"folder.id === dialog.reportItem.parent_id\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" style=\"margin-right: 8px;\"></md-icon><span>{{folder.name}}</span> <span ng-if=\"folder.id === dialog.reportItem.parent_id\" style=\"margin-left: 8px; color: #666; font-style: italic;\">(pasta atual)</span></div></md-radio-button></md-radio-group><div ng-if=\"dialog.folders.length === 0\" class=\"no-folders-message\"><p>Não existem pastas disponíveis para mover o relatório.</p></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"dialog.closeModal()\">Cancelar</md-button><md-button class=\"md-primary md-raised\" ng-click=\"dialog.confirmMove()\" ng-disabled=\"!dialog.selectedFolder || dialog.selectedFolder.id === dialog.reportItem.parent_id\">Mover</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-negotiation/index.html","<md-card class=\"md-padding\" flex=\"\"><md-table-pagination md-limit=\"paginate.per_page\" md-limit-options=\"[5, 10, 15, 20, 25, 50]\" md-page=\"paginate.current_page\" flex=\"\" style=\"border: none\" ng-if=\"personId == null\" md-total=\"{{paginate.total}}\" md-on-paginate=\"vm.getNegotiations\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-if=\"personId == null\">Pessoa</th><th md-column=\"\">Data</th><th md-column=\"\">Descrição</th><th md-column=\"\">Observações</th><th md-column=\"\">Qtd tít. origem</th><th md-column=\"\">Qtd tít. gerados</th><th md-column=\"\" md-numeric=\"\">Valor total (R$)</th><th md-column=\"\" md-numeric=\"\">Valor negociado (R$)</th><th md-column=\"\">Situação</th><th md-column=\"\">Próx. venc.</th><th md-column=\"\" md-numeric=\"\">Valor (R$)</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.negotiations\" ng-click=\"vm.showDetails(item)\" style=\"cursor: pointer\"><td md-cell=\"\" ng-if=\"personId == null\"><b>{{item.person_name}}</b><br><small ng-if=\"item.person_name != item.name_second_line\">{{item.name_second_line}}</small></td><td md-cell=\"\">{{item.date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{item.description}}</td><td md-cell=\"\">{{item.notes}}</td><td md-cell=\"\">{{item.qty_negociated}}</td><td md-cell=\"\">{{item.qty_bills}}</td><td md-cell=\"\" md-numeric=\"\">{{item.sum_negociated | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.total_amount | currency:\' \'}}</td><td md-cell=\"\">{{item.qty_open == 0 ? (item.date_end == null ?\'Liquidado\' : \'Negociação desfeita\') : (item.qty_late > 0 ? \'Inadimplente\' : \'Em dia\')}}<br><small ng-if=\"item.qty_late > 0\">{{item.qty_late}} - R${{item.amount_late | currency:\' \'}}</small></td><td md-cell=\"\">{{item.next_due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.next_amount | currency:\' \'}}</td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/components/a4-negotiation/negotiation-modal.html","<md-dialog aria-label=\"Contrato\" md-theme=\"finance\" style=\"width: 800px;\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Negociação</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><a4-negotiation-details negotiation-data=\"vm.negotiationData\"></a4-negotiation-details></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised negotiationCancel\" layout=\"row\" ng-disabled=\"vm.disable_undo || vm.disable || $rootScope.show_loader || vm.disable_neg_undo\" ng-click=\"vm.undoNegotiate()\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.disable\" flex=\"5\" md-diameter=\"15\"></md-progress-circular>Desfazer negociação</md-button><md-button class=\"md-raised md-primary\" layout=\"row\" ng-disabled=\"vm.disable || $rootScope.show_loader\" ng-click=\"vm.printNegotiationPaymentBook()\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.disable\" flex=\"5\" md-diameter=\"15\"></md-progress-circular>Imprimir carnê</md-button><md-button class=\"md-raised md-primary\" layout=\"row\" ng-disabled=\"vm.disable || $rootScope.show_loader\" ng-click=\"vm.printNegotiationContract()\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.disable\" flex=\"5\" md-diameter=\"15\"></md-progress-circular>Imprimir termo</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\">Fechar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-negotiation/undo-modal.html","<md-dialog aria-label=\"Reembolsar crédito\" md-theme=\"finance\" style=\"min-width: 400px\"><form name=\"form_refund\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">Desfazimento de negociação</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><small>Ao desfazer essa negociação, os títulos negociados voltarão a ficar em aberto e os títulos originados na negociação serão cancelados e não aparecerão mais na ficha financeira. Caso um ou mais títulos originados na negociação estiverem pagos, esses valores pagos serão estornados e ficarão como crédito para o cliente.</small></div></div><div flex=\"\"><date-picker ng-model=\"vm.scope.date_end\" placeholder=\"Data de cancelamento\" max-date=\"vm.scope.today\" required=\"\"></date-picker></div><div flex=\"\"><md-input-container flex=\"100\" style=\"width: 100%\"><label>Observações</label> <textarea ng-model=\"vm.scope.notes\" rows=\"2\" flex=\"\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button ng-click=\"vm.answer(vm.scope)\" ng-disabled=\"vm.scope.date_end === null || form_refund.$invalid\" class=\"md-raised md-primary\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-negotiation-details/a4-negotiation-details.html","<div class=\"md-padding\"><div layout=\"row\"><div flex=\"\" layout=\"column\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data da negociação</th><th md-column=\"\">Descrição</th><th md-column=\"\" md-numeric=\"\">Valor total negociado</th><th md-column=\"\" md-numeric=\"\">Valor final da negociação</th><th md-column=\"\">Regra de boleto</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">{{negotiationData.origin_negotiation[0].settlement_date | date: \'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{negotiationData.result_negotiation[0].description}}</td><td md-cell=\"\" md-numeric=\"\">{{negotiationData.total_origin | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{negotiationData.result_negotiation[0].total_negotiation | currency: \' \'}}</td><td md-cell=\"\">{{negotiationData.result_negotiation[0].bank_slip_rule}}</td></tr></tbody></table></md-table-container></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Títulos negociados</b></div></div><md-table-container style=\"margin-top: 15px; margin-bottom: 15px\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Descrição</th><th md-column=\"\">Data de vencimento</th><th md-column=\"\" md-numeric=\"\">Valor negociado</th><th md-column=\"\" md-numeric=\"\">Desconto</th><th md-column=\"\" md-numeric=\"\">Multa</th><th md-column=\"\" md-numeric=\"\">Juros</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"bill in negotiationData.origin_negotiation\"><td md-cell=\"\">{{bill.product_name}}</td><td md-cell=\"\">{{bill.due_date | date: \'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.amount_paid | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.discount | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.fine | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.interest | currency: \' \'}}</td></tr></tbody></table></md-table-container><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Títulos gerados na negociação</b></div></div><md-table-container style=\"margin-top: 15px; margin-bottom: 15px\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data de vencimento</th><th md-column=\"\" md-numeric=\"\">Valor</th><th md-column=\"\">Data de pagamento</th><th md-column=\"\" md-numeric=\"\">Valor pago</th><th md-column=\"\" md-numeric=\"\">Multa</th><th md-column=\"\" md-numeric=\"\">Juros</th><th md-column=\"\" md-numeric=\"\">Abono</th><th md-column=\"\" md-numeric=\"\">Diferença</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"bill in negotiationData.result_negotiation\"><td md-cell=\"\">{{bill.due_date | date: \'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.amount | currency: \' \'}}</td><td md-cell=\"\">{{bill.settlement_date | date: \'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.amount_paid | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.fine | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.interest | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.allowance | currency: \' \'}}</td><td md-cell=\"\" md-numeric=\"\">{{bill.difference | currency: \' \'}}</td></tr></tbody></table></md-table-container><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103);\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Observações</b></div></div><div class=\"row\" style=\"margin-left: 10px; margin-bottom: 5px;\"><md-input-container><textarea name=\"notes\" cols=\"70\" rows=\"3\" ng-disabled=\"true\" ng-model=\"negotiationData.result_negotiation[0].notes\"></textarea></md-input-container></div></div>");
$templateCache.put("app/components/a4-options-movement/a4-options-movement.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"\" style=\"width: 50%;margin: 5px;\"><label for=\"select-account\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Conta corrente de saída*</span></label><select2 ng-model=\"currentAccount\" s2-options=\"val.id as val.name for val in vm.all_current_accounts\" ng-change=\"vm.filterMovements()\" id=\"select-account\" required=\"\"></select2></div><div layout=\"column\" flex=\"\" style=\"width: 50%;margin: 5px;\"><label for=\"select-movement\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Forma de saída*</span></label><select2 ng-model=\"movementType\" s2-options=\"val.id as val.name for val in vm.movementTypes\" id=\"select-movement\" required=\"\"></select2></div></div>");
$templateCache.put("app/components/a4-pendent-grades/a4-pendent-grades.html","<table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-if=\"for === \'teacher\'\"><span>Turma</span></th><th md-column=\"\" ng-if=\"for === \'class\' || for === \'group\'\">Professor</th><th md-column=\"\" ng-if=\"for === \'teacher\' || for === \'group\'\">Disciplina</th><th md-column=\"\">Evento</th><th md-column=\"\">Dt. abertura</th><th md-column=\"\">Dt. limite</th><th md-column=\"\" style=\"text-align: right\">Notas pendentes</th><th md-column=\"\" style=\"text-align: right\">% pendente</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"pendence in pendentGrades\"><td md-cell=\"\" ng-if=\"for === \'teacher\'\">{{ pendence.course_name + \' \' + pendence.group_name}}</td><td md-cell=\"\" ng-if=\"for === \'class\' || for === \'group\'\">{{pendence.teacher_name}}</td><td md-cell=\"\" ng-if=\"for === \'teacher\' || for === \'group\'\">{{pendence.subject_name}}</td><td md-cell=\"\">{{pendence.event_name}}</td><td md-cell=\"\">{{pendence.open_typing_date | date: \"dd/MM/yyyy\"}}</td><td md-cell=\"\">{{pendence.close_typing_date | date: \"dd/MM/yyyy\"}} <span ng-if=\"pendence.close_typing_date !== null && vm.today.isAfter(pendence.close_typing_date)\"><md-icon md-font-icon=\"icon-alert-circle\" style=\"color: red;\"></md-icon><md-tooltip md-direction=\"right\">Prazo para lançamento expirado</md-tooltip></span></td><td md-cell=\"\" style=\"text-align: right\">{{pendence.without_notes}}</td><td md-cell=\"\" style=\"text-align: right\">{{((pendence.without_notes / (pendence.with_notes + pendence.without_notes)) * 100).toFixed(2)}}%</td></tr></tbody></table>");
$templateCache.put("app/components/a4-person-documents/a4-person-document-upload.html","<md-dialog md-theme=\"educational\" aria-label=\"{{ \'UPLOAD_IMAGE.EDIT\' | translate }}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Documento: {{vm.document.artifact_type_name}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"form-wrapper\" style=\"padding-top: 0\" ng-if=\"vm.document.artifact_id !== null\"><md-table-container style=\"width: 100%;\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Ver</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">{{vm.document.artifact_name}}</td><td md-cell=\"\"><a target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + vm.document.file_reference}}\">Ver arquivo</a></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteDocument()\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div><div layout=\"column\" class=\"form-wrapper\" ng-if=\"vm.document.artifact_id === null\"><div flex=\"100\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div><div layout=\"column\" class=\"form-wrapper\"><md-input-container><textarea type=\"text\" rows=\"4\" ng-model=\"vm.document.notes\" placeholder=\"Observações\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.submit({option: \'save\', document: vm.document})\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-person-documents/a4-person-documents.html","<md-table-container class=\"table-float-button\"><table md-table=\"\" class=\"dataTable row-border hover\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"padding: 15px !important;\"><span style=\"margin-left: 5px; !important;\">Nome</span></th><th md-column=\"\" style=\"padding: 15px !important;\"><span style=\"margin-left: 5px; !important;\">Observações</span></th><th md-column=\"\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.documentsList\"><td md-cell=\"\" style=\"padding: 15px !important;\"><span style=\"margin-left: 5px;\" ng-style=\"{color: item.file_reference === null ? \'rgb(161 161 161)\' : \'rgba(0, 0, 0, 0.87)\'}\">{{ item.artifact_type_name }}</span><md-icon class=\"md-color-green\" ng-if=\"item.file_reference !== null\">done</md-icon></td><td md-cell=\"\" style=\"padding: 15px !important;\"><span style=\"margin-left: 5px;\">{{ item.notes }}</span></td><td md-cell=\"\" style=\"text-align: right\"><md-button class=\"md-icon-button\" ng-if=\"item.file_reference !== null\" target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + item.file_reference}}\"><md-icon>visibility</md-icon><md-tooltip md-direction=\"left\">Visualizar arquivo</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"item.file_reference !== null\" ng-click=\"vm.editFiles(item)\"><md-icon>edit</md-icon><md-tooltip md-direction=\"left\">Editar arquivo</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.editFiles(item)\" ng-if=\"item.file_reference === null\"><md-icon>publish</md-icon><md-tooltip md-direction=\"left\">Enviar arquivo</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"item.file_reference !== null\" ng-click=\"vm.addOtherFile(item)\"><md-icon>add</md-icon><md-tooltip md-direction=\"left\">Adicionar outro arquivo</md-tooltip></md-button></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/components/a4-persons/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"isEducational\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"PERSON.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Pessoas</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'PERSON.SEARCH\' | translate }}\" type=\"text\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.listAll(vm.search)\" ng-model=\"vm.search\" translate=\"\" translate-attr-placeholder=\"Pesquisar\"></md-input-container></div></md-toolbar><md-content style=\"background-color: whitesmoke !important\"><md-card layout-padding=\"\"><md-table-pagination md-limit=\"vm.grid.info.limit\" md-limit-options=\"[20, 30, 50, 75, 100]\" md-page=\"vm.grid.info.page\" style=\"border: none;\" flex=\"\" md-total=\"{{vm.grid.info.total}}\" md-on-paginate=\"vm.getAllPersons\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\"></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"person in vm.grid.rows\" ng-click=\"vm.editPerson(person)\" style=\"cursor: pointer\"><td md-cell=\"\">{{person.name}}</td><td md-cell=\"\"><span class=\"badge person_badge\" style=\"background-color: #0c856f;\" ng-click=\"vm.goToProfile(person, \'employee\'); $event.stopPropagation()\" ng-if=\"person.is_employee === 1 || person.roles_id !== null\">Colaborador<md-tooltip md-direction=\"right\" ng-if=\"vm.is_educational\">Clique para acessar a página de colaborador</md-tooltip></span> <span class=\"badge person_badge\" style=\"background-color: #bead33;\" ng-click=\"vm.goToProfile(person, \'employee\'); $event.stopPropagation()\" ng-if=\"person.is_supplier === 1\">Fornecedor<md-tooltip md-direction=\"right\" ng-if=\"vm.is_educational\">Clique para acessar a página de colaborador</md-tooltip></span> <span class=\"badge person_badge\" style=\"background-color: #0c856f;\" ng-click=\"vm.goToProfile(person, \'employee\'); $event.stopPropagation()\" ng-if=\"person.is_employee === -1\">Ex-colaborador<md-tooltip md-direction=\"right\" ng-if=\"vm.is_educational\">Clique para acessar a página de colaborador</md-tooltip></span> <span class=\"badge person_badge\" style=\"background-color: #607abf;\" ng-click=\"vm.goToProfile(person, \'student\'); $event.stopPropagation()\" ng-if=\"person.is_student !== null\">Aluno <b ng-if=\"person.last_student !== null && person.last_student != vm.current_school_period\">em {{person.last_student}}</b><md-tooltip md-direction=\"right\" ng-if=\"vm.is_educational\">Clique para acessar a página do aluno</md-tooltip></span> <span class=\"badge person_badge\" style=\"background-color: #bf391a;\" ng-click=\"vm.goToProfile(person, \'employee\'); $event.stopPropagation()\" ng-if=\"person.is_employee === 2 || person.is_employee === 3\">Professor<md-tooltip md-direction=\"right\" ng-if=\"vm.is_educational\">Clique para acessar a página do professor</md-tooltip></span> <span class=\"badge person_badge\" style=\"background-color: #bf391a;\" ng-click=\"vm.goToProfile(person, \'employee\'); $event.stopPropagation()\" ng-if=\"person.is_employee === -2 || person.is_employee === -3\">Ex-professor<md-tooltip md-direction=\"right\" ng-if=\"vm.is_educational\">Clique para acessar a página do professor</md-tooltip></span> <span class=\"badge person_badge\" style=\"background-color: #29a456;\" ng-click=\"vm.goToProfile(person, \'responsible\'); $event.stopPropagation()\" ng-if=\"person.is_responsible === 1 || person.is_payee === 1\">Responsável <b ng-if=\"(person.last_payee !== null && person.last_payee != vm.current_school_period) || (person.last_responsible !== null && person.last_responsible != vm.current_school_period)\">em {{person.last_responsible !== null ? person.last_responsible : person.last_payee}}</b><md-tooltip md-direction=\"right\" ng-if=\"vm.is_educational\">Clique para acessar a página do responsável</md-tooltip></span> <span class=\"badge person_badge\" style=\"background-color: silver\" ng-if=\"vm.returnMainProfile(person) === null\">Sem papel</span></td><td md-cell=\"\" style=\"text-align: right\"><md-tooltip md-direction=\"top\" ng-if=\"person.has_email > 0\">Existem e-mails enviados</md-tooltip><span ng-if=\"vm.returnMainProfile(person) === null\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete(person.id); $event.stopPropagation()\" ng-disabled=\"person.has_email > 0\"><md-icon>delete</md-icon></md-button></span></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/components/a4-process-filter/a4-process-filter.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" style=\"padding: 16px;\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-trello\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{title}}</span></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-right: 35px;\"><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"filter_person\"><md-icon md-font-icon=\"icon-account\"></md-icon></label><md-input-container class=\"m-0\" md-no-float=\"\" flex=\"\" id=\"filter_person_responsible\"><md-tooltip md-direction=\"top\">Atendente</md-tooltip><md-select ng-model=\"filterPersonResponsible\" placeholder=\"Atendente\" ng-change=\"vm.filterFunction()\"><md-option ng-value=\"null\"><em>Atendente</em></md-option><md-option ng-repeat=\"responsible in vm.person_responsibles\" ng-value=\"responsible.id\">{{responsible.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"filter_person\"><md-icon md-font-icon=\"icon-account\"></md-icon></label><md-input-container class=\"m-0\" md-no-float=\"\" flex=\"\" id=\"filter_person\"><md-tooltip md-direction=\"top\">Solicitante</md-tooltip><md-select ng-model=\"filterPerson\" ng-change=\"vm.filterFunction()\" placeholder=\"Solicitante\"><md-select-header class=\"demo-select-header\"></md-select-header><md-option ng-value=\"null\"><em>Solicitante</em></md-option><md-option ng-repeat=\"collaborator in vm.collaborators\" ng-value=\"collaborator.id\">{{collaborator.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"filter_person\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon></label><md-input-container class=\"m-0\" md-no-float=\"\" flex=\"\" id=\"filter_status\"><md-tooltip md-direction=\"top\">Status</md-tooltip><md-select ng-model=\"filterStatus\" ng-change=\"vm.filterFunction()\" placeholder=\"Status\"><md-option ng-value=\"null\"><em>Status</em></md-option><md-option ng-repeat=\"status in vm.process_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"group\"><md-icon md-font-icon=\"icon-relative-scale\"></md-icon></label><md-input-container id=\"group\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-tooltip md-direction=\"top\">Tipo de solicitação</md-tooltip><md-select ng-model=\"filterProcessType\" ng-change=\"vm.filterFunction()\" placeholder=\"Tipo de solicitação\"><md-option ng-value=\"null\"><em>Tipo de solicitação</em></md-option><div ng-repeat=\"process_type in vm.process_types\"><md-option ng-value=\"process_type.id\">{{process_type.name}}</md-option><md-optgroup label=\"Impressão por cor\" ng-if=\"process_type.id === 3\"><md-option ng-value=\"3001\">Preto e branco</md-option><md-option ng-value=\"3002\">Colorido</md-option></md-optgroup></div></md-select></md-input-container></div><div style=\"height: 52px;\"><date-range-picker class=\"search-input-wrapper\" ng-model=\"vm.date_range\" ng-change=\"vm.filterFunction()\"></date-range-picker></div></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.clearFilters()\"><md-tooltip md-direction=\"top\">Limpar filtros</md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div><md-button class=\"md-raised md-primary\" ng-click=\"vm.printListForFilters()\" ng-if=\"title == \'Administrar Solicitações\'\"><md-icon>print</md-icon><md-tooltip md-direction=\"top\">Imprimir lista de solicitações</md-tooltip></md-button></div><div><md-button class=\"md-raised md-primary\" ng-click=\"vm.printList()\" ng-if=\"title == \'Administrar Solicitações\' && (filterProcessType == 4 || filterProcessType == 6)\"><md-icon>print</md-icon><md-tooltip md-direction=\"top\">Imprimir detalhes das solicitações</md-tooltip></md-button></div><div layout=\"row\"><md-tooltip md-direction=\"top\">Forma de visualização</md-tooltip><md-icon md-font-icon=\"icon-trello\"><md-tooltip md-direction=\"top\">Quadro</md-tooltip></md-icon><md-switch ng-model=\"vm.view_grid\" aria-label=\"Switch view\" ng-change=\"vm.changeView()\"></md-switch><md-icon md-font-icon=\"icon-grid\"><md-tooltip md-direction=\"top\">Tabela</md-tooltip></md-icon></div></md-toolbar>");
$templateCache.put("app/components/a4-process-list/a4-process-list.html","<md-card class=\"md-padding\"><table md-table=\"\"><thead md-head=\"\" md-order=\"orderBy\" md-on-reorder=\"vm.reorder\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"process_id\"><span>Nº</span></th><th md-column=\"\" md-order-by=\"process_type\" ng-if=\"filterProcess.filter_process_type === null\"><span>Tipo</span></th><th md-column=\"\" md-order-by=\"description\"><span>Descrição</span></th><th md-column=\"\" md-order-by=\"location_name\" ng-if=\"filterProcess.filter_process_type === 1 || filterProcess.filter_process_type === 2 || filterProcess.filter_process_type === 5 || filterProcess.filter_process_type === 10 || filterProcess.filter_process_type === 11 || filterProcess.filter_process_type === null\"><span>Local</span></th><th md-column=\"\" md-order-by=\"created_at\"><span>Data de criação</span></th><th md-column=\"\" md-order-by=\"datetime\" style=\"min-width: 185px;\"><span>Data</span></th><th md-column=\"\" md-order-by=\"person_owner_name\"><span>Solicitante</span></th><th md-column=\"\" md-order-by=\"group_name\"><span>Turma</span></th><th md-column=\"\" md-order-by=\"print_color\" ng-if=\"filterProcess.filter_process_type === 3 || filterProcess.filter_process_type === 3001 || filterProcess.filter_process_type === 3002\"><span>Tipo de impressão</span></th><th md-column=\"\" md-order-by=\"qty\" ng-if=\"filterProcess.filter_process_type === 3 || filterProcess.filter_process_type === 3001 || filterProcess.filter_process_type === 3002\"><span>Quantidade</span></th><th md-column=\"\" md-order-by=\"process_flow_id\" style=\"min-width: 110px;\"><span>Status</span></th><th md-column=\"\" md-order-by=\"person_responsible_name\"><span>Atendente</span></th><th md-column=\"\" style=\"text-align: right\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"card in boardCards\" ng-click=\"vm.openCardDialog(card)\" style=\"cursor: pointer\"><td md-cell=\"\">{{card.id}}</td><td md-cell=\"\" ng-if=\"filterProcess.filter_process_type === null\">{{card.process_type}}</td><td md-cell=\"\">{{card.description}}</td><td md-cell=\"\" ng-if=\"filterProcess.filter_process_type === 1 || filterProcess.filter_process_type === 2 || filterProcess.filter_process_type === 5 || filterProcess.filter_process_type === 10 || filterProcess.filter_process_type === null\">{{card.location_name}}</td><td md-cell=\"\">{{card.created_at.split(\' \')[0] | date: \'dd/MM/yyyy\'}} às {{card.created_at.split(\' \')[1].substring(0, 5)}}</td><td md-cell=\"\"><span class=\"badge\"><span class=\"due-date\" ng-class=\"{\'overdue\': vm.isOverdue(card.date)}\"><i class=\"icon-clock s15\"></i> {{card.date | date:\'mediumDate\'}} {{card.time != null ? \' | \' : \'\'}} {{card.time.substring(0, 5)}} {{card.time_end != null ? \' as \' : \'\'}} {{card.time_end.substring(0, 5)}}</span></span></td><td md-cell=\"\">{{card.person_owner_name}}</td><td md-cell=\"\">{{card.group_name}}</td><td md-cell=\"\" ng-if=\"filterProcess.filter_process_type === 3 || filterProcess.filter_process_type === 3001 || filterProcess.filter_process_type === 3002\">{{card.print_color}}</td><td md-cell=\"\" ng-if=\"filterProcess.filter_process_type === 3 || filterProcess.filter_process_type === 3001 || filterProcess.filter_process_type === 3002\">{{card.object_qty}}</td><td md-cell=\"\"><span class=\"badge\"><md-tooltip ng-if=\"card.process_flow_id == 5\">Motivo do cancelamento:<br>{{card.notes_done}}</md-tooltip><span class=\"{{card.process_flow_name.replace(\' \', \'_\')}}\">{{card.process_flow_name}}</span></span></td><td md-cell=\"\">{{card.person_responsible_name}}</td><td md-cell=\"\" md-numeric=\"\"><div layout=\"row\"><span class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">{{card.artifact_qty}}</span></span><span class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"value\">{{card.comment_qty}}</span></span></div></td></tr></tbody></table></md-card>");
$templateCache.put("app/components/a4-product-group-config/a4-product-group-config.html","<div layout-gt-xs=\"row\"><md-autocomplete flex=\"\" md-input-name=\"autoCategories\" md-selected-item=\"vm.bill_category\" md-no-cache=\"true\" md-search-text=\"vm.searchText\" md-selected-item-change=\"productGroup.bill_category_id = item.id\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Categoria\"><md-item-template><span class=\"item-title\"><span><strong>{{item.name}}</strong></span></span> <span class=\"item-metadata\"><span>{{item.path}}</span></span></md-item-template></md-autocomplete></div><div layout-gt-xs=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Descrição da nota fiscal</label> <input ng-model=\"productGroup.nfse_descricao\" type=\"text\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Código nota fiscal</label> <input ng-model=\"productGroup.nfse_codigo_item\" type=\"text\" maxlength=\"5\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>CNAE</label> <input ng-model=\"productGroup.nfse_cnae\" type=\"text\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Código de tributação ISS (CTISS)</label> <input ng-model=\"productGroup.nfse_ctiss\" type=\"text\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Alíquota nota fiscal (%)</label> <input ng-model=\"productGroup.nfse_aliquota\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Classificação tributária</label> <input ng-model=\"productGroup.nfse_classificacao_tributaria\" type=\"text\" maxlength=\"6\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Nome.Bras.Serviços (NBS)</label> <input ng-model=\"productGroup.nfse_nbs\" type=\"text\" maxlength=\"9\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Indicador da Operação</label> <input ng-model=\"productGroup.nfse_indop\" type=\"text\" maxlength=\"6\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\" ng-if=\"companies.length > 1\"><label>Empresa</label><md-select ng-model=\"productGroup.company_id_company\"><md-option ng-repeat=\"company in companies\" ng-value=\"company.id\">{{company.name}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/components/a4-question/a4-question.html","<span><strong ng-if=\"question.question_type_id != \'SP\'\">#{{ question.question_number }}</strong> <strong ng-if=\"question.question_type_id == \'SP\'\">Separador</strong></span> <span><md-button class=\"md-icon-button\" ng-click=\"vm.applyEdit()\"><md-icon>edit</md-icon><md-tooltip md-direction=\"left\" ng-if=\"!onlineQuestionnaireDone\">Editar</md-tooltip><md-tooltip md-direction=\"left\" ng-if=\"onlineQuestionnaireDone && questionnaireType < 20\">não é permitido editar um questionário com respostas já salvas</md-tooltip></md-button><md-button ng-if=\"question.question_type_id != \'SP\' && question.question_type_id !== \'QE\'\" class=\"md-icon-button\" ng-click=\"vm.manageMedia(question)\"><md-icon>perm_media</md-icon><md-tooltip md-direction=\"left\">Adicionar/editar imagem</md-tooltip></md-button></span><div ng-if=\"!vm.isDisabled\"><md-card-title><md-card-title-text><div layout=\"row\" layout-align=\"space-between center\"><a4-card-controls item=\"question\" array=\"questions\" sub-item-index=\"null\" type=\"\'questions\'\"></a4-card-controls></div><div class=\"stem-{{question.ord}}\"><md-input-container style=\"width: 100%\" flex=\"\" ng-if=\"question.question_type_id !== \'QE\'\"><textarea ng-disabled=\"(vm.isDisabled || onlineQuestionnaireDone) && questionnaireType < 20\" rows=\"1\" style=\"font-size: 20px;\" ng-model=\"question.stem\" placeholder=\"Enunciado\" required=\"\"></textarea></md-input-container></div><md-input-container ng-if=\"question.question_type_id != \'SP\' && question.question_type_id !== \'QE\'\"><input type=\"text\" style=\"font-size: 15px;\" ng-model=\"question.notes\" ng-disabled=\"onlineQuestionnaireDone && questionnaireType < 20\" placeholder=\"Orientação complementar\"></md-input-container><md-input-container ng-if=\"questionnaireType === 2\"><input type=\"text\" style=\"font-size: 15px;\" ng-model=\"question.points\" ng-disabled=\"(vm.isDisabled || questionnaireAnswerType == 0) && (vm.company_id !== 683 && vm.company_id !== 101224 && vm.company_id !== 101321)\" placeholder=\"Valor da questão\"><md-checkbox ng-disabled=\"vm.isDisabled\" ng-model=\"question.is_canceled\">Anular Questão</md-checkbox></md-input-container></md-card-title-text></md-card-title><div ng-if=\"question.artifact_id !== null\" style=\"text-align: center !important; max-width: 575px; margin-left: auto; margin-right: auto;\"><img ng-src=\"{{ vm.URI + question.file_reference }}\" ng-style=\"{ \'object-fit\': \'contain\', \'max-width\': question.image_size + \'px\', \'max-height\': question.image_size + \'px\'}\"></div><md-radio-group ng-model=\"question.image_size\" layout=\"row\" style=\"margin-left: 100px;\" ng-if=\"question.artifact_id !== null\" ng-init=\"question.image_size = question.image_size || \'400\'\"><md-radio-button flex=\"\" ng-value=\"\'200\'\" class=\"md-primary\" style=\"margin-bottom: 3px;\">P</md-radio-button><md-radio-button flex=\"\" ng-value=\"\'400\'\" class=\"md-primary\" style=\"margin-bottom: 3px;\">M</md-radio-button><md-radio-button flex=\"\" ng-value=\"\'600\'\" class=\"md-primary\" style=\"margin-bottom: 3px;\">G</md-radio-button></md-radio-group><md-checkbox flex=\"\" ng-model=\"question.image_checkbox\" class=\"md-primary\" layout=\"row\" ng-if=\"question.artifact_id !== null\" style=\"margin-left: 18px; margin-bottom: 3px;\">Acima das alternativas</md-checkbox><md-card-content layout=\"column\" layout-align=\"center center\"><md-input-container style=\"width: 100%;\" ng-if=\"question.question_type_id != \'SP\'\"><label>Tipo da questão</label><md-select ng-model=\"question.question_type_id\" ng-change=\"vm.blank_answer()\" ng-disabled=\"(angular.isDefined(question.id) && question.id !== null || vm.isDisabled) || onlineQuestionnaireDone\"><md-option ng-repeat=\"question_type in questionTypes\" ng-value=\"question_type.id\" ng-if=\"question_type.id !== \'XI\' && question_type.id != \'SP\' && (questionnaireType >= 20 || (question_type.id !== \'XM\' && question_type.id !== \'XU\')) && !(questionnaireAnswerType === 10 && question_type.id === \'QE\')\">{{question_type.name}}</md-option></md-select></md-input-container><div class=\"question-{{question.ord}}\" style=\"width: 100%;\"><div ng-if=\"question.question_type_id == \'XM\' || question.question_type_id == \'XU\'\" ng-include=\"\'app/components/a4-question/templates/matrix-multiple-unique.html\'\"></div><div ng-if=\"question.question_type_id == \'SP\'\"></div><div ng-if=\"question.question_type_id == \'QU\'\" ng-include=\"\'app/components/a4-question/templates/unique-option.html\'\"></div><div ng-if=\"question.question_type_id == \'QM\'\" ng-include=\"\'app/components/a4-question/templates/multiple-option.html\'\"></div><div ng-if=\"question.question_type_id == \'NU\' || question.question_type_id == \'TU\'\" ng-include=\"\'app/components/a4-question/templates/one-line-text-number.html\'\"></div><div ng-if=\"question.question_type_id == \'TM\'\" ng-include=\"\'app/components/a4-question/templates/multiple-line-text.html\'\"></div><div ng-if=\"question.question_type_id == \'QE\'\" ng-include=\"\'app/components/a4-question/templates/editable-question.html\'\"></div></div><md-card style=\"width: 60%; background-color: #fffdf0; padding: 5px; text-align: center\" ng-click=\"addSubQuestion({question: question})\" ng-if=\"(question.question_type_id == \'QM\' || question.question_type_id == \'QU\' || question.question_type_id == \'XM\' || question.question_type_id == \'XU\') && !vm.isDisabled\"><a flex=\"\" class=\"btn-check-evaluations\"><span ng-if=\"(question.question_type_id == \'QM\' || question.question_type_id == \'QU\') && !onlineQuestionnaireDone\">ADICIONAR ALTERNATIVA</span> <span ng-if=\"question.question_type_id == \'XM\' || question.question_type_id == \'XU\'\">ADICIONAR ITEM DA MATRIZ</span><md-icon><i class=\"material-icons\">add_circle_outline</i></md-icon></a></md-card><md-chips ng-if=\"question.question_type_id != \'SP\'\" flex=\"\" ng-model=\"question.tags\" md-enable-chip-edit=\"true\" style=\"width: 100%;\" placeholder=\"Adicionar tag\" delete-hint=\"Pressione delete para remover\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"false\" md-separator-keys=\"vm.customKeys\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getQuestionTags(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"420\" input-aria-describedby=\"autocompleteTitle\" placeholder=\"Inclua etiquetas\"><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-autocomplete><md-chip-template><span><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" md-mode=\"indeterminate\" ng-if=\"vm.show_load_tag\"></md-progress-circular>{{$chip.name}}</span></md-chip-template></md-chips></md-card-content></div><div ng-if=\"vm.isDisabled\"><div style=\"margin-top: 20px; border-top: 1px solid #ccc; padding-top: 10px;\"><div ng-bind-html=\"question.preview_html\"></div></div></div>");
$templateCache.put("app/components/a4-responsible-contact-form/a4-responsible-contact-form.html","<div class=\"md-dialog-content new-material-inputs\"><a4-address model=\"person\" is-enabled=\"isEnabled\" has-owner=\"false\" form-copy=\"responsibleForm\" form-scope=\"\'RESPONSIBLE\'\"></a4-address></div>");
$templateCache.put("app/components/a4-responsible-form/a4-responsible-form.html","<div class=\"md-dialog-content new-material-inputs\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"\" style=\"margin-right: 0; margin-bottom: 7px !important;\" ng-class=\"{show_bottom: isEnabled}\" ng-if=\"isExternalEdit != true\"><label class=\"isEnabled\" style=\"margin-bottom: 25px;\"><small class=\"isEnabled\">Tipo de pessoa*</small></label><md-radio-group ng-model=\"person.type\" layout=\"row\" style=\"margin-top: 5px; padding-right: 0;\" ng-disabled=\"!isEnabled\" ng-required=\"true\"><md-radio-button ng-repeat=\"type in vm.list.person.type\" class=\"md-primary\" ng-value=\"type.id\">{{type.name}}</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" style=\"margin-right: 0; margin-bottom: 7px !important;\"><md-checkbox ng-model=\"person.is_deceased\" style=\"margin: 0\" ng-if=\"isExternalEdit != true\">Pessoa falecida?</md-checkbox></md-input-container><md-input-container class=\"md-block\" style=\"margin-right: 0; margin-bottom: 7px !important;\"><md-checkbox ng-model=\"person.is_alumni\" style=\"margin: 0\" ng-if=\"isExternalEdit != true\">Ex-aluno?</md-checkbox></md-input-container></div><a4cpf model=\"person.national_id_number\" classes=\"show_bottom\" is-enabled=\"isEnabled\" person-id=\"person.person_id\" ng-if=\"person.type === 1 && isExternalEdit != true\"></a4cpf><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"person.type === 1\" style=\"margin-top: 20px;\"><label class=\"isEnabled\">Nome</label> <input ng-model=\"person.name\" ng-disabled=\"!isEnabled || isExternalEdit\" ng-required=\"true\" name=\"responsible_name\"><div ng-messages=\"responsibleForm.responsible_name.$error\"><div ng-message=\"required\">Você <b>precisa</b> preencher o nome do responsável</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"person.type === 2\"><label class=\"isEnabled\">Nome fantasia</label> <input ng-model=\"person.name\" ng-disabled=\"!isEnabled\" required=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"person.type === 1 && isExternalEdit != true\" style=\"margin-top: 23px;\"><label class=\"isEnabled\">Apelido</label> <input ng-model=\"person.alias_name\" ng-disabled=\"!isEnabled\"></md-input-container><div layout=\"row\" flex=\"\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"person.type === 2\" flex=\"80\"><label class=\"isEnabled\">CNPJ</label> <input name=\"CPF\" ng-model=\"person.national_id_number\" placeholder=\"Ex: 00.000.000/0000-00\" ui-br-cnpj-mask=\"\" ng-disabled=\"!isEnabled\" required=\"\"></md-input-container><md-input-container flex=\"20\" class=\"md-block md-input-has-placeholder\" ng-if=\"person.type === 2\" ng-class=\"{show_bottom: isEnabled}\"><md-button style=\"margin: 0\" ng-click=\"vm.getCnpjCaptcha(person.national_id_number, person)\">Pesquisar</md-button></md-input-container></div><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"person.type === 2\"><label class=\"isEnabled\">Razão social</label> <input ng-model=\"person.corporate_name\" ng-disabled=\"!isEnabled\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"person.type === 2\"><label class=\"isEnabled\">Inscrição estadual</label> <input ng-model=\"person.state_registration_number\" ng-disabled=\"!isEnabled\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"person.type === 2\"><label class=\"isEnabled\">Inscrição municipal</label> <input ng-model=\"person.municipal_registration_number\" ng-disabled=\"!isEnabled\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"person.type === 2\"><label class=\"isEnabled\">Pessoa de contato</label> <input ng-model=\"person.main_contact_name\" ng-disabled=\"!isEnabled\"></md-input-container><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"\" ng-if=\"person.type === 1 && isExternalEdit != true\" ng-class=\"{show_bottom: isEnabled}\" style=\"margin-bottom: 5px !important;\"><label class=\"isEnabled\" style=\"margin-bottom: 25px;\"><small class=\"isEnabled\">Sexo*</small></label><md-radio-group ng-model=\"person.person_sex_id\" layout=\"row\" style=\"margin-top: 5px;\" ng-disabled=\"!isEnabled\" ng-required=\"true\"><md-radio-button ng-repeat=\"sex in vm.list.person.person_sex_id\" class=\"md-primary\" ng-value=\"sex.id\">{{sex.name}}</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-xs=\"\" style=\"margin-bottom: 2px; margin-top: 15px;\" ng-if=\"isExternalEdit != true\"><label class=\"isEnabled\">Instagram</label> <input ng-model=\"person.instagram\" ng-disabled=\"!isEnabled\"></md-input-container></div><div ng-if=\"isExternalEdit != true\"><a4-birth-informations person=\"person\" list-countries=\"vm.list.person.country_id_of_birth\" form-scope=\"\'RESPONSIBLE\'\" is-enabled=\"isEnabled\" not-required=\"person.is_deceased\"></a4-birth-informations></div><div layout-gt-xs=\"row\" ng-show=\"person.type === 1 && person.country_id_nationality != 76\"><md-input-container class=\"md-block md-input-has-placeholder\" style=\"margin-bottom: 2px; margin-top: 15px;\" flex-gt-xs=\"\"><label class=\"isEnabled\">Passaporte/Id estrangeira</label> <input rows=\"1\" ng-model=\"person.foreign_id_or_passport\" ng-disabled=\"!isEnabled || person.is_deceased\"></md-input-container></div><div layout-gt-xs=\"row\"><div layout=\"column\" flex-gt-xs=\"\" ng-if=\"person.type === 1\" style=\"margin-bottom: 3px; margin-left: 2px;\"><label for=\"select-civil-state\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Estado civil</span></label><select2 ng-model=\"person.person_marital_status_id\" s2-options=\"val.id as val.name for val in vm.list.person.person_marital_status_id\" id=\"select-civil-state\" ng-disabled=\"!isEnabled || person.is_deceased\" flex-gt-xs=\"\"></select2></div><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-left: 4px;\" ng-if=\"isExternalEdit != true\"><label for=\"select-color\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\" ng-if=\"vm.company_id != 713 && vm.company_id != 127342\">Cor/Raça</span> <span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\" ng-if=\"vm.company_id == 713 || vm.company_id == 127342\">Cor/Raça *</span></label><select2 ng-model=\"person.person_color_id\" ng-required=\"vm.company_id == 713 || vm.company_id == 127342\" s2-options=\"val.id as val.name for val in vm.list.person.person_color_id\" id=\"select-color\" ng-disabled=\"!isEnabled || person.is_deceased\" flex-gt-xs=\"\"></select2><div ng-show=\"studentForm.$submitted && (vm.company_id == 713 || vm.company_id == 127342) && !student.person_color_id\" style=\"color: #f55347; font-size: 12px; margin-top: 5px;\">Campo \"Cor/Raça\" é obrigatório para salvar</div></div></div><div layout-gt-xs=\"row\"><md-autocomplete class=\"md-block\" md-input-name=\"profession\" md-input-minlength=\"3\" md-no-cache=\"true\" md-delay=\"1000\" md-selected-item=\"person.selected_profession\" md-selected-item-change=\"vm.changeProfession(vm.selected_profession)\" md-search-text=\"person.selected_profession\" md-items=\"item in vm.getProfessions(vm.searchTextProfession)\" md-item-text=\"item.name\" md-floating-label=\"Profissão\" ng-disabled=\"!isEnabled || person.is_deceased\" flex-gt-xs=\"\" ng-class=\"{show_bottom: !isEnabled}\" ng-if=\"person.type === 1\" style=\"margin-top: 5px; margin-bottom: 12px;\"><md-item-template><span md-highlight-text=\"person.selected_profession\">{{item.name}}</span></md-item-template><md-not-found>Profissão não encontrada, ela será criada.</md-not-found></md-autocomplete><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-bottom: 6px; margin-left: 2px;\"><label for=\"select-educational-level\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Nível educacional</span></label><select2 ng-model=\"person.person_educational_level_id\" s2-options=\"val.id as val.name for val in vm.list.person.person_educational_level_id\" id=\"select-educational-level\" ng-disabled=\"!isEnabled || person.is_deceased\" flex-gt-xs=\"\"></select2></div></div><div layout-gt-xs=\"row\" ng-if=\"person.type === 1 && isExternalEdit != true\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 0; margin-top: 1px;\"><label class=\"isEnabled\">RG</label> <input ng-model=\"person.id_number\" ng-disabled=\"!isEnabled || person.is_deceased\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 0; margin-top: 1px;\"><label class=\"isEnabled\">Órgão expedidor RG</label> <input ng-model=\"person.id_issuer\" ng-disabled=\"!isEnabled || person.is_deceased\" maxlength=\"10\"></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"person.type === 1 && isExternalEdit != true\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 2px;\"><label class=\"isEnabled\">UF expedição RG</label><select2 ng-model=\"student.id_state\" s2-options=\"val.id as val.id for val in vm.list.person.address_state\" style=\"width: 100%\" ng-disabled=\"!isEnabled || person.is_deceased\"></select2></md-input-container><date-picker ng-model=\"person.id_date_issue\" placeholder=\"Data expedição RG\" ng-disabled=\"!isEnabled || person.is_deceased\" flex-gt-xs=\"\" without-icon=\"true\" ng-class=\"{show_bottom: !isEnabled}\" style=\"margin-bottom: 2px;\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 2px;\"><label class=\"isEnabled\">Complemento RG</label> <input ng-model=\"person.id_complement\" ng-disabled=\"!isEnabled || person.is_deceased\"></md-input-container></div><div layout-gt-xs=\"row\" flex=\"\"><a4email model=\"person.email\" is-enabled=\"isEnabled\" person-id=\"person.person_id\" is-required=\"false\" not-required=\"person.is_deceased\" flex=\"66\" block-form=\"blockFormEmail\"></a4email><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\" style=\"margin-bottom: 1px;\" flex=\"33\"><label class=\"isEnabled\">Celular (DDD obrigatório)</label> <input ng-model=\"person.phone_mobile\" ng-disabled=\"!isEnabled || person.is_deceased\" type=\"text\" name=\"responsible_phone_mobile\" ng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 2000, \'blur\': 0} }\" ng-required=\"(person.am_i.is_responsible && vm.required_fields_responsible.phone_mobile.is_mandatory) || (person.am_i.is_payee && vm.required_fields_payee.phone_mobile.is_mandatory) || (vm.required_fields_responsible.phone_mobile.is_mandatory && vm.required_fields_payee.phone_mobile.is_mandatory) || (vm.company_id == 713 || vm.company_id == 127342)\" ui-br-phone-number=\"\" minlength=\"11\"><div ng-messages=\"responsibleForm.responsible_phone_mobile.$error\"><div ng-message=\"minlength\">Insira o celular no formato <b>(XX) XXXXX-XXXX</b></div></div></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"person.type === 1 && isExternalEdit != true\"><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\" style=\"margin-bottom: 2px;\"><label class=\"isEnabled\">Nome do pai</label> <input ng-model=\"person.father_name\" ng-disabled=\"!isEnabled || person.is_deceased\"></md-input-container><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\" style=\"margin-bottom: 2px;\"><label class=\"isEnabled\">Nome da mãe</label> <input ng-model=\"person.mother_name\" ng-disabled=\"!isEnabled || person.is_deceased\"></md-input-container></div><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"isExternalEdit != true\"><label class=\"isEnabled\">Observações</label> <textarea rows=\"1\" ng-model=\"person.notes\" ng-disabled=\"!isEnabled || person.is_deceased\"></textarea></md-input-container></div>");
$templateCache.put("app/components/a4-school-record-config/a4-school-record-config.html","<md-input-container style=\"width: 100%\" class=\"md-input-has-placeholder\"><textarea rows=\"2\" ng-model=\"config.individual_observation\" placeholder=\"Observação específica do aluno\"></textarea></md-input-container><div layout=\"row\"><md-input-container><md-radio-group layout=\"column\" ng-model=\"config.history_superior_option\"><md-radio-button ng-value=\"1\" class=\"md-primary\">Imprime todos os registros das disciplinas</md-radio-button><md-radio-button ng-value=\"2\" class=\"md-primary\">Imprime apenas o último registro de cada disciplina</md-radio-button><md-radio-button ng-value=\"3\" class=\"md-primary\">Imprime apenas os registros conclusivos de cada disciplina</md-radio-button><md-radio-button ng-value=\"4\" class=\"md-primary\">Imprime apenas os registros de aprovação de cada disciplina</md-radio-button></md-radio-group></md-input-container><md-input-container><md-radio-group ng-model=\"config.order_by\"><md-radio-button ng-value=\"1\">Ordena por período letivo realizado</md-radio-button><md-radio-button ng-value=\"2\">Ordena por período de matrícula</md-radio-button></md-radio-group></md-input-container></div><md-input-container layout=\"column\" style=\"margin-top: -30px;\"><md-checkbox ng-model=\"config.print_complementar_on_another_page\" style=\"margin-left: 0\">Imprime atividades complementares em outra página</md-checkbox><md-checkbox ng-model=\"config.repeat_pendent_subjects\" style=\"margin-left: 0\">Repete as disciplinas pendentes como \"A cursar\"</md-checkbox><md-checkbox ng-model=\"config.include_subjects_without_enrolment\" style=\"margin-left: 0\">Inclui as disciplinas sem matrícula como \"A cursar\"</md-checkbox><md-checkbox ng-model=\"config.not_include_teacher_column\">Não incluir as colunas Professor e Titulação</md-checkbox><md-checkbox ng-model=\"config.only_approved_or_on_course\" ng-if=\"config.history_superior_option == 2\">Apenas disciplinas aprovadas ou em curso</md-checkbox></md-input-container>");
$templateCache.put("app/components/a4-search-field/a4-search-field.html","<div layout=\"row\"><label class=\"logo-icon\" ng-if=\"!studentPage\"><md-icon style=\"padding: 3px ;\" md-font-icon=\"{{icon}}\" class=\"s24\"></md-icon></label><md-select ng-if=\"predefinedList\" ng-model=\"selectedItem\" style=\"width: 100%; margin: 0\" ng-change=\"onChangeItem(selectedItem)\" placeholder=\"{{placeholder}}\"><md-option ng-value=\"item\" ng-repeat=\"item in predefinedListData\">{{ item.name }}</md-option></md-select><div flex=\"\" layout=\"column\"><md-autocomplete style=\"margin-top: 9px;\" ng-if=\"!predefinedList\" id=\"autocomplete-content\" class=\"a4-search-field\" ng-disabled=\"isDisabled\" md-no-cache=\"true\" md-selected-item=\"aSFC.selected\" md-search-text=\"aSFC.search_text\" md-items=\"item in aSFC.querySearch(aSFC.search_text)\" md-item-text=\"item.name\" md-selected-item-change=\"onChangeItem(item)\" md-autoselect=\"true\" md-min-length=\"0\" md-delay=\"500\" md-autofocus=\"\" placeholder=\"{{placeholder}}\" md-menu-class=\"autocomplete-custom-template\"><md-item-template><span class=\"item-title\"><span>{{item.name}}</span></span> <span class=\"item-metadata\" ng-show=\"item.group_name\"><span><strong>{{item.course_name}}</strong> | <strong>{{item.group_name}}</strong></span></span></md-item-template><md-not-found>Nenhum registro encontrado para \"{{aSFC.search_text}}\".</md-not-found></md-autocomplete><h4 ng-if=\"studentPage && selectedItem.school_period_id == 0\" class=\"subtitle-student\" ng-class=\"predefinedList ? \'select-student\' : \'search-student\'\" style=\"margin-left: 0;\">{{selectedItem.course_name}} | {{selectedItem.group_name}} | {{selectedItem.matrix_period}} {{selectedItem.cancel_date != null ? \' | Motivo do cancelamento: \' + selectedItem.enrolment_cancel_reason_name : \'\'}} {{selectedItem.cancel_date != null ? selectedItem.cancel_date : \'\' | date:\"dd/MM/yyyy\"}}</h4><h4 ng-if=\"studentPage && selectedItem.school_period_id != 0\" class=\"subtitle-student\" ng-class=\"predefinedList ? \'select-student\' : \'search-student\'\" style=\"margin-left: 0;\">{{selectedItem.course_name}} | {{selectedItem.group_name}} | {{selectedItem.enrolment_number}} {{selectedItem.cancel_date != null ? \' | Motivo do cancelamento: \' + selectedItem.enrolment_cancel_reason_name : \'\'}} {{selectedItem.cancel_date != null ? selectedItem.cancel_date : \'\' | date:\"dd/MM/yyyy\"}}</h4></div><md-button ng-click=\"setFocus()\" style=\"margin:8px !important;\" class=\"md-icon-button btn-edit\" aria-label=\"search\" ng-if=\"!predefinedList\" ng-hide=\"isDisabled\"><md-tooltip><span ng-show=\"!vm.form.mode_edit\">Buscar e Trocar</span></md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div>");
$templateCache.put("app/components/a4-stock-transactions/index.html","<div layout=\"row\"><md-input-container flex=\"\" style=\"max-width: 15%; margin-right: 1%\"><date-range-picker flex=\"25\" ng-model=\"vm.selected_transaction_period\" label=\"Filtrar por Data\" placeholder=\"vm.selected_transaction_period\" ng-change=\"vm.paginate()\"></date-range-picker><button class=\"md-button\" ng-click=\"vm.clear_selected_transaction_period()\">Limpar Data</button></md-input-container><md-input-container flex=\"\" style=\"max-width: 15%; margin-right: 1%; margin-top: 30px\"><md-icon>search</md-icon><label>Filtrar por Tipo</label><md-select ng-model=\"vm.selected_transaction_type\" flex=\"\" ng-change=\"vm.paginate()\"><md-option ng-value=\"null\">Todos os tipos</md-option><md-option ng-value=\"transaction_type.id\" ng-repeat=\"transaction_type in vm.stock_transaction_types | orderBy:\'id\'\">{{transaction_type.name}}</md-option></md-select></md-input-container><div style=\"margin-right: auto; margin-top: 15px\"><button class=\"md-stock-theme md-primary md-button ng-scope md-ink-ripple md-vm.options.theme-theme\" ng-click=\"vm.printTransactions()\">Imprimir relatório</button></div></div><md-table-pagination flex=\"\" md-limit=\"vm.grid.per_page\" md-page=\"vm.grid.current_page\" style=\"border: none;\" md-limit-options=\"[20, 30, 50, 75, 100]\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.paginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container style=\"padding-bottom: 0;\"><table md-table=\"\" md-progress=\"vm.transactionPromise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Estoque</th><th md-column=\"\">Tipo</th><th md-column=\"\" style=\"text-align: right\">Quantidade de itens</th><th md-column=\"\" style=\"text-align: right\">Valor total</th><th md-column=\"\" md-numeric=\"\"><span style=\"padding-right: 12px;\">Ações</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"transaction in vm.transactions\" ng-click=\"vm.editTransaction(transaction)\" style=\"cursor: pointer\"><td md-cell=\"\">{{transaction.date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\">{{transaction.inventory}}</td><td md-cell=\"\">{{transaction.stock_transaction_type}}</td><td md-cell=\"\" style=\"text-align: right\">{{transaction.items}}</td><td md-cell=\"\" style=\"text-align: right\">{{transaction.total_value | currency: \"\"}}</td><td md-cell=\"\" flex=\"\" md-numeric=\"\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\" ng-disabled=\"vm.estoque_alt\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.print(transaction)\"><md-icon md-font-icon=\"icon-printer\"></md-icon>Imprimir</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteTransaction(transaction)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>Excluir</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/components/a4-stock-transactions/modal-transaction-option.html","<md-dialog aria-label=\"Transaction option\" md-theme=\"stock\" style=\"width: 800px\"><form ng-cloak=\"\"><md-dialog-content><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check-stock md-ink-ripple\" ng-click=\"vm.answer(false)\"><md-icon md-font-icon=\"icon-swap-horizontal\"></md-icon><div>Realizar transação</div></a> <a flex=\"\" class=\"text-center btn-check-stock md-ink-ripple\" ng-click=\"vm.answer(true)\"><md-icon md-font-icon=\"icon-cash-usd\"></md-icon><div>Realizar compra</div></a></md-card></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/a4-student-contact-form/a4-student-contact-form.html","<div class=\"md-inline-form new-material-inputs\" style=\"width: 100%;\"><md-input-container class=\"md-block\" ng-class=\"{show_bottom: isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 0;\"><label class=\"isEnabled\">Mora com</label><md-select ng-model=\"student.person_id_address\" ng-change=\"vm.setParentToLive(student.person_id_address)\" ng-disabled=\"!isEnabled\" required=\"\"><md-option ng-repeat=\"responsible in vm.responsibles\" ng-value=\"responsible.id\">{{responsible.name}}</md-option><md-option ng-if=\"(!vm.responsibles || vm.responsibles.length === 0) && student.person_id_address && !isEnabled\" ng-value=\"student.person_id_address\">{{ student.person_id_address ? student.person_name_address : \'Outro\' }}</md-option><md-option ng-value=\"null\">Outro</md-option></md-select></md-input-container><a4-address model=\"student\" is-enabled=\"isEnabled\" has-owner=\"true\"></a4-address></div>");
$templateCache.put("app/components/a4-student-documents/a4-student-document-upload.html","<md-dialog md-theme=\"educational\" aria-label=\"{{ \'UPLOAD_IMAGE.EDIT\' | translate }}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Documento: {{vm.document.name}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"form-wrapper\" style=\"padding-top: 0\" ng-if=\"vm.document.artifact_id !== null\"><md-table-container style=\"width: 100%;\"><table md-table=\"\" ng-model=\"selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Ver</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">{{vm.document.filename}}</td><td md-cell=\"\"><a target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + vm.document.file_reference}}\">Ver arquivo</a></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteDocument()\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div><div layout=\"row\" class=\"form-wrapper\" ng-if=\"vm.document.artifact_id === null\"><div flex=\"\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.submit({option: \'save\', document: vm.document})\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-student-documents/a4-student-documents.html","<md-table-container class=\"table-float-button\"><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"selectedDocuments\" md-row-select=\"\" multiple=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\" style=\"padding: 15px !important;\"><span style=\"margin-left: 5px; !important; text-align: left;\">Nome</span></th><th md-column=\"\" style=\"padding: 15px !important;\"><span style=\"margin-left: 5px; !important; text-align: center;\">Entregue em</span></th><th md-column=\"\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in documentsList track by item.visualization_id\"><td md-cell=\"\" style=\"padding: 0; text-align: left !important;\"><md-checkbox ng-click=\"vm.selectedDocument(item); $event.stopPropagation();\" ng-checked=\"vm.isChecked(item)\" ng-if=\"item.special_type != 1 && item.artifact_id == null\" aria-label=\"checkbox\" style=\"margin-left: -20px;\"></md-checkbox></td><td md-cell=\"\" style=\"padding: 15px !important;\"><span style=\"margin-left: 5px;\">{{ item.name }} <span ng-if=\"item.special_type == 1 && item.artifact_id != null\"><md-icon style=\"color: forestgreen\">assignment</md-icon><md-tooltip md-direction=\"right\">Contrato de matrícula</md-tooltip></span></span></td><td><span style=\"margin-left: 25px; padding: 2px 5px; border-radius: 3px; text-transform: none; transform: translate(-50%, -50%); text-align: center;\" ng-style=\"{ \'background-color\': item.school_period_id && item.school_period_id == vm.school_period ? \'#607abf\' : \'#f1c40f\', \'color\': \'white\' }\" ng-if=\"item.school_period_id && item.school_period_id != 0\">{{item.school_period_id}}</span></td><td md-cell=\"\" style=\"text-align: right\"><md-button class=\"md-icon-button\" ng-if=\"item.file_reference !== null\" target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + item.file_reference}}\"><md-icon>visibility</md-icon><md-tooltip md-direction=\"left\">Visualizar arquivo</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.editFile(item)\" ng-disabled=\"item.special_type == 1 && (item.school_period_id != null && item.school_period_id != vm.school_period_id)\"><md-icon>publish</md-icon><md-tooltip md-direction=\"left\">Adicionar/visualizar arquivo</md-tooltip></md-button></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/components/a4-student-form/a4-student-form.html","<div class=\"md-inline-form new-material-inputs\" style=\"width: 100%\"><a4cpf model=\"student.national_id_number\" classes=\"show_bottom\" is-enabled=\"isEnabled\" person-id=\"student.person_id\" is-required=\"false\"></a4cpf><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\"><label class=\"isEnabled\">Nome</label> <input ng-model=\"student.name\" ng-disabled=\"!isEnabled\" name=\"student_name\" ng-required=\"true\"><div ng-messages=\"studentForm.student_name.$error\"><div ng-message=\"required\">Você <b>precisa</b> preencher o nome do aluno</div></div></md-input-container><div layout-gt-xs=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\"><label class=\"isEnabled\">Apelido</label> <input ng-model=\"student.alias_name\" ng-disabled=\"!isEnabled\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" ng-if=\"vm.required_fields_student.id_external.is_visible\"><label class=\"isEnabled\">ID externo</label> <input ng-model=\"student.id_external\" ng-disabled=\"!isEnabled\" maxlength=\"50\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-top: 0; margin-bottom: 5px;\"><label class=\"isEnabled\" style=\"margin-bottom: 25px;\"><small class=\"isEnabled\">Sexo *</small></label><md-radio-group ng-model=\"student.person_sex_id\" layout=\"row\" style=\"margin: 0;\" ng-disabled=\"!isEnabled\" ng-required=\"true\"><md-radio-button ng-repeat=\"sex in vm.list.person.person_sex_id\" class=\"md-primary\" ng-value=\"sex.id\">{{sex.name}}</md-radio-button></md-radio-group></md-input-container><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-top: -17px !important;\" class=\"md-block\"><label for=\"select-color\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\" ng-if=\"vm.company_id != 713 && vm.company_id != 127342\">Cor/Raça</span> <span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\" ng-if=\"vm.company_id == 713 || vm.company_id == 127342\">Cor/Raça *</span></label><select2 ng-model=\"student.person_color_id\" ng-required=\"vm.company_id == 713 || vm.company_id == 127342\" s2-options=\"val.id as val.name for val in vm.list.person.person_color_id\" id=\"select-color\" ng-disabled=\"!isEnabled\" flex-gt-xs=\"\"></select2><div ng-show=\"studentForm.$submitted && (vm.company_id == 713 || vm.company_id == 127342) && !student.person_color_id\" style=\"background-color: #f44336; font-size: 12px; margin-top: 5px;\">Campo \"Cor/Raça\" é obrigatório para salvar</div></div></div><a4-birth-informations person=\"student\" list-countries=\"vm.list.person.country_id_of_birth\" is-enabled=\"isEnabled\"></a4-birth-informations><div layout-gt-xs=\"row\" ng-show=\"student.type === 1 && student.country_id_nationality != 76\"><md-input-container class=\"md-block md-input-has-placeholder\" style=\"margin-bottom: 2px; margin-top: 15px;\" flex-gt-xs=\"\"><label class=\"isEnabled\">Passaporte/Id estrangeira</label> <input rows=\"1\" ng-model=\"student.foreign_id_or_passport\" ng-disabled=\"!isEnabled\"></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"vm.company_id == 733 || vm.company_id == 101258 || vm.company_id == 18\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 2px; margin-top: 15px;\"><label class=\"isEnabled\">RG</label> <input ng-model=\"student.id_number\" ng-disabled=\"!isEnabled\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 2px; margin-top: 15px;\"><label class=\"isEnabled\">Órgão exped. RG</label> <input ng-model=\"student.id_issuer\" ng-disabled=\"!isEnabled\"></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"vm.company_id == 733 || vm.company_id == 101258\"><div layout=\"column\" flex-gt-xs=\"\"><label for=\"select-uf-rg\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">UF. exped. RG</span></label><select2 ng-model=\"student.id_state\" s2-options=\"val.id as val.id for val in vm.list.person.address_state\" id=\"select-uf-rg\" ng-disabled=\"!isEnabled\" flex-gt-xs=\"\"></select2></div><date-picker ng-model=\"student.id_date_issue\" placeholder=\"Data expedição RG\" :disabled=\"!isEnabled\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" without-icon=\"true\" style=\"margin-bottom: 4px; margin-left: 1px;\"></date-picker></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 2px; margin-top: 15px;\"><label class=\"isEnabled\">Certidão de nascimento</label> <input ng-model=\"student.birth_certificate\" ng-disabled=\"!isEnabled\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 2px; margin-top: 15px;\"><label class=\"isEnabled\">Cartório da certidão</label> <input ng-model=\"student.birth_certificate_registry\" ng-disabled=\"!isEnabled\"></md-input-container></div><div layout-gt-xs=\"row\" flex=\"\"><a4email model=\"student.email\" is-enabled=\"isEnabled\" person-id=\"student.person_id\" is-required=\"false\" flex=\"66\" block-form=\"blockFormEmail\"></a4email><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\" style=\"margin-bottom: 1px;\" flex=\"33\"><label class=\"isEnabled\">Celular (DDD obrigatório)</label><input ng-model=\"student.phone_mobile\" ng-disabled=\"!isEnabled\" ng-required=\"vm.company_id == 713 || vm.company_id == 127342\" ng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 2000, \'blur\': 0} }\" ui-br-phone-number=\"\" minlength=\"11\"><div ng-messages=\"studentForm.phone_mobile.$error\"><div ng-message=\"minlength\">Insira o celular no formato <b>(XX) XXXXX-XXXX</b></div></div></md-input-container></div><div layout-gt-xs=\"row\"><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-left: 2px; margin-top: 0px !important;\" ng-if=\"student.course_equivalence_id >= 300\"><label for=\"select-marital\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Estado civil</span></label><select2 ng-model=\"student.person_marital_status_id\" s2-options=\"val.id as val.name for val in vm.list.person.person_marital_status_id\" id=\"select-marital\" ng-disabled=\"!isEnabled\" flex-gt-xs=\"\"></select2></div><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-xs=\"\" style=\"margin-bottom: 2px; margin-top: 15px;\"><label class=\"isEnabled\">Instagram</label> <input ng-model=\"student.instagram\" ng-disabled=\"!isEnabled\"></md-input-container></div><div layout-gt-xs=\"row\" style=\"margin-bottom: 0px !important;\"><md-input-container ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-top: 0; margin-bottom: 5px;\"><label for=\"select-schools\" style=\"margin-bottom: 7px;\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">{{student.course_equivalence_id >= 300 ? \'Escola de conclusão do ensino médio\' : \'Escola de origem\'}}</span></label><div layout=\"row\" style=\"margin-top: 20px\"><select2 ng-model=\"student.school_origin_id\" s2-options=\"val.id as val.name for val in vm.list.person.school_origins\" style=\"width: 100%\" options=\"{ language: \'pt-BR\', locale: \'pt-BR\', locales: \'pt-BR\' }\" id=\"select-schools\" ng-disabled=\"!isEnabled\"></select2><span ng-if=\"isEnabled\"><md-button class=\"md-icon-button md-primary\" style=\"margin-left: 0 !important; margin-right: 0 !important; margin-top: -7px !important; padding: 0 !important;\" ng-click=\"vm.createNewSchoolOrigin()\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip>Criar nova escola de origem</md-tooltip></md-icon></md-button></span></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\" style=\"margin-bottom: 0px;\"><label class=\"isEnabled\">Observações</label> <textarea rows=\"1\" ng-model=\"student.notes\" ng-disabled=\"!isEnabled\"></textarea></md-input-container></div><div class=\"md-inline-form new-material-inputs\" style=\"width: 100%;\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !isEnabled}\" flex-gt-xs=\"\"><md-label ng-style=\"{\'font-size\': \'12px\', \'color\': \'#969696\'}\" class=\"isEnabled\">Deficiências (PCD)<md-select ng-model=\"student.person_pcd_ids\" multiple=\"\" ng-disabled=\"!isEnabled\" md-selected-text=\"{{getSelectedPcdText()}}\"><md-option ng-repeat=\"pcd in vm.list.person.person_pcd\" ng-value=\"pcd.id\">{{pcd.name}}</md-option></md-select></md-label></md-input-container></div></div>");
$templateCache.put("app/components/a4-student-form/modal-school-origin.html","<md-dialog aria-label=\"Cadastro de nova escola de origem\" md-theme=\"educational\" style=\"width: 700px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Cadastro de nova escola de origem</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"new-material-inputs\"><form name=\"form\" ng-cloak=\"\"><md-dialog-content layout=\"row\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 50%\"><label class=\"isEnabled\">Nome da escola</label> <input ng-model=\"vm.school_origin.name\" style=\"height: 27px; margin-top: 3px\" required=\"\"></md-input-container><div layout=\"column\" style=\"width: 25%; margin-right: 3px;\"><label for=\"select-state\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Estado</span></label><select2 ng-model=\"vm.school_origin.state_id\" s2-options=\"val.id as val.name for val in vm.states\" ng-change=\"vm.changeState(vm.school_origin.state_id)\" id=\"select-state\"></select2></div><div layout=\"column\" style=\"width: 25%\"><label for=\"select-city\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Cidade</span></label><select2 ng-model=\"vm.school_origin.city\" s2-options=\"val.name as val.name for val in vm.cities\" id=\"select-city\"></select2></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.submit(vm.school_origin)\" ng-disabled=\"form.$invalid\">Salvar</md-button></md-dialog-actions></form></div></md-dialog>");
$templateCache.put("app/components/a4-student-responsibles-form/a4-student-responsibles-form.html","<md-content class=\"md-padding\" layout-xs=\"column\" layout=\"column\"><div layout=\"row\" layout-align=\"end center\"><md-card style=\"width: 80%; background-color: #b5112a\" class=\"md-padding\" ng-if=\"vm.grid.rows.length > 0 && (!vm.has_mother || !vm.has_father)\"><span style=\"color: white; font-size: 20px;\">ATENÇÃO: O aluno está sem pai e/ou sem mãe</span></md-card><md-button ng-click=\"vm.addParent()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar responsável</md-button><md-menu><md-button aria-label=\"ações\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-font-icon=\"icon-arrange-send-to-back\"></md-icon>Ações</md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.defineIndependent()\" ng-if=\"isEnrolment\" ng-disabled=\"vm.person_id == vm.payee && vm.person_id == vm.responsible\">Definir aluno como próprio responsável</md-button><md-button ng-click=\"vm.changePayee(student, true)\" ng-if=\"!isEnrolment\" ng-disabled=\"vm.person_id == vm.payee && vm.person_id == vm.responsible\">Definir aluno como próprio responsável</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.defineNotDeclared(\'father\')\" ng-disabled=\"vm.has_father\">Definir \"Pai não declarado\"</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.defineNotDeclared(\'mother\')\" ng-disabled=\"vm.has_mother\">Definir \"Mãe não declarada\"</md-button></md-menu-item></md-menu-content></md-menu></div><md-table-container flex=\"\"><table md-table=\"\"><thead md-head=\"\" fix-head=\"\"><tr md-row=\"\"><th md-column=\"\">Relacionamento</th><th md-column=\"\">Nome</th><th md-column=\"\" style=\"text-align: right\">Ações</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"!vm.has_father\"><td md-cell=\"\">Pai</td><td md-cell=\"\"><span class=\"badge\" style=\"margin: 0; padding: 0\"><span>NÃO DECLARADO</span></span></td><td md-cell=\"\" style=\"text-align: right\"></td></tr><tr md-row=\"\" ng-if=\"!vm.has_mother\"><td md-cell=\"\">Mãe</td><td md-cell=\"\"><span class=\"badge\" style=\"margin: 0; padding: 0\"><span>NÃO DECLARADA</span></span></td><td md-cell=\"\" style=\"text-align: right\"></td></tr><tr md-row=\"\" ng-repeat=\"parent in vm.grid.rows\" ng-click=\"parent.id == vm.person_id ? \'\' : vm.seeParent(parent)\" ng-style=\"{cursor: parent.id == vm.person_id ? \'default\' : \'pointer\'}\"><td md-cell=\"\">{{parent.relation}}</td><td md-cell=\"\">{{parent.name}} <span class=\"badge\"><span class=\"is_payee\" ng-if=\"parent.is_payee\">Resp. Financeiro</span> <span class=\"is_responsible\" ng-if=\"parent.is_responsible\">Resp. Pedagógico</span> <span class=\"is_co_responsible\" ng-if=\"parent.is_co_responsible\">Co-resp. Pedagógico</span> <span class=\"is_guarantor\" ng-if=\"parent.is_guarantor\">Fiador</span> <span class=\"is_deceased\" ng-if=\"parent.is_deceased\">Falecid{{parent.parent.person_sex_id=\'F\' ? \'a\' : \'o\'}}</span></span></td><td md-cell=\"\" style=\"text-align: right\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event);$event.stopPropagation()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"6\"><md-menu-item><md-button ng-click=\"vm.delete(parent)\" ng-disabled=\"parent.is_payee || parent.is_responsible || parent.is_guarantor\"><md-icon>delete</md-icon>{{parent.is_payee ? \'Não é possível excluir responsável financeiro\' : (parent.is_responsible ? \'Não é possível excluir responsável pedagógico\' : (parent.is_guarantor ? \'Não é possível excluir fiador\' : \'Excluir\'))}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.changeResponsible(parent)\" ng-if=\"!isEnrolment\" ng-disabled=\"parent.id == vm.person_id\"><md-icon>swap_horiz</md-icon>Definir como responsável pedagógico</md-button><md-button ng-click=\"vm.defineResponsible(parent)\" ng-if=\"isEnrolment\" ng-disabled=\"parent.id == vm.person_id\"><md-icon>swap_horiz</md-icon>Definir como responsável pedagógico</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.ManageCoResponsable(parent, true)\" ng-if=\"!isEnrolment && !parent.is_co_responsible\" ng-disabled=\"(parent.is_payee || parent.is_responsible)\"><md-icon>swap_horiz</md-icon>Definir como co-responsável pedagógico</md-button><md-button ng-click=\"vm.ManageCoResponsable(parent, false)\" ng-if=\"!isEnrolment && parent.is_co_responsible\" ng-disabled=\"(parent.is_payee || parent.is_responsible)\"><md-icon>swap_horiz</md-icon>Remover como co-responsável pedagógico</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.changePayee(parent)\" ng-if=\"!isEnrolment\" ng-disabled=\"parent.id == vm.person_id || parent.is_guarantor\"><md-icon>attach_money</md-icon>Definir como responsável financeiro</md-button><md-button ng-click=\"vm.definePayee(parent)\" ng-if=\"isEnrolment\" ng-disabled=\"parent.id == vm.person_id || parent.is_guarantor\"><md-icon>attach_money</md-icon>Definir como responsável financeiro</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.changeGuarantor(parent)\" ng-if=\"!isEnrolment\" ng-disabled=\"parent.id == vm.person_id || parent.is_payee || parent.is_guarantor\"><md-icon md-font-icon=\"icon-bank\"></md-icon>Definir como fiador</md-button><md-button ng-click=\"vm.defineGuarantor(parent)\" ng-if=\"isEnrolment\" ng-disabled=\"parent.id == vm.person_id || parent.is_payee|| parent.is_guarantor\"><md-icon md-font-icon=\"icon-bank\"></md-icon>Definir como fiador</md-button></md-menu-item><md-menu-item ng-if=\"parent.is_guarantor\"><md-button ng-click=\"vm.removeGuarantor(parent)\"><md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>Remover de fiador</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.changeRelationship(parent)\" ng-disabled=\"parent.id == vm.person_id\"><md-icon>edit</md-icon>Editar relacionamento</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-content>");
$templateCache.put("app/components/a4-student-responsibles-form/modal-school-origin.html","<md-dialog aria-label=\"Cadastro de nova escola de origem\" md-theme=\"educational\" style=\"width: 700px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Cadastro de nova escola de origem</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"new-material-inputs\"><form name=\"form\" ng-cloak=\"\"><md-dialog-content layout=\"row\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 50%\"><label class=\"isEnabled\">Nome da escola</label> <input ng-model=\"vm.school_origin.name\" style=\"height: 27px; margin-top: 3px\" required=\"\"></md-input-container><div layout=\"column\" style=\"width: 25%; margin-right: 3px;\"><label for=\"select-state\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Estado</span></label><select2 ng-model=\"vm.school_origin.state_id\" s2-options=\"val.id as val.name for val in vm.states\" ng-change=\"vm.changeState(vm.school_origin.state_id)\" id=\"select-state\" required=\"\"></select2></div><div layout=\"column\" style=\"width: 25%\"><label for=\"select-city\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Cidade</span></label><select2 ng-model=\"vm.school_origin.city\" s2-options=\"val.name as val.name for val in vm.cities\" id=\"select-city\" required=\"\"></select2></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.submit(vm.school_origin)\" ng-disabled=\"form.$invalid\">Salvar</md-button></md-dialog-actions></form></div></md-dialog>");
$templateCache.put("app/components/a4-switch-button/a4-switch-button.html","<md-button ng-click=\"changeItem(selected_button)\" class=\"md-primary\" ng-class=\"(selected_button.icon) ? \'md-fab\' : \'md-raised\'\" style=\"background-color: {{selected_button.background}}; color: {{selected_button.color}}; min-height: {{selected_button.height}};\" aria-label=\"{{selected_button.textButton}}\"><span ng-if=\"selected_button.icon\"><md-tooltip md-direction=\"top\">{{selected_button.textButton}}</md-tooltip><md-icon>{{selected_button.icon}}</md-icon></span> <span ng-if=\"!selected_button.icon\">{{selected_button.textButton}}</span></md-button>");
$templateCache.put("app/components/a4-tree-grid/template.html","<div class=\"table-responsive\" flex=\"\"><table md-table=\"\" class=\"tree-grid\"><thead md-head=\"\"><tr><th ng-style=\"classSelected !== \'report\' && {\'border-bottom\' : \'1px solid #ddd\'}\"><a ng-if=\"expandingProperty.sortable\" ng-click=\"sortBy(expandingProperty)\">{{expandingProperty.displayName || expandingProperty.field || expandingProperty}}</a> <span ng-if=\"!expandingProperty.sortable\">{{expandingProperty.displayName || expandingProperty.field || expandingProperty}}</span> <i ng-if=\"expandingProperty.sorted\" class=\"{{expandingProperty.sortingIcon}} pull-right\"></i></th><th ng-repeat=\"col in colDefinitions\" ng-style=\"classSelected !== \'report\' && {\'border-bottom\' : \'1px solid #ddd\'}\"><div ng-if=\"col.headTemplate\" compile=\"col.headTemplate\" cell-template-scope=\"col.headTemplateScope\"></div><div ng-if=\"!col.headTemplate\"><a ng-if=\"col.sortable\" ng-click=\"sortBy(col)\">{{col.displayName || col.field}}</a> <span ng-if=\"!col.sortable\">{{col.displayName || col.field}}</span></div><i ng-if=\"col.sorted\" class=\"{{col.sortingIcon}} pull-right\"></i></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"row in tree_rows | searchFor:$parent.filterString:expandingProperty:colDefinitions track by row.branch.uid\" class=\"{{\'level-\' + row.level }} {{ classSelected (row.branch.selected ? \' active\':\'\')}}\"><td md-cell=\"\" class=\"{{\'td-level-\' + row.level}} {{classSelected}}\" ng-style=\"classSelected !== \'report\' && {\'border-bottom\' : \'1px solid #ddd\'}\"><a ng-click=\"user_clicks_branch(row.branch)\"><i ng-class=\"{{row.tree_icon}}\" ng-click=\"row.branch.expanded = !row.branch.expanded\" class=\"indented tree-icon\"></i></a> <span ng-if=\"expandingProperty.cellTemplate\" class=\"indented tree-label\" ng-click=\"on_user_click(row.branch)\" compile=\"expandingProperty.cellTemplate\"></span> <span ng-if=\"!expandingProperty.cellTemplate\" class=\"indented tree-label\" ng-click=\"on_user_click(row.branch)\">{{row.branch[expandingProperty.field] || row.branch[expandingProperty]}}</span><div class=\"badge-container {{\'level-\' + row.level}}\" ng-if=\"row.branch.qtd\"><span class=\"custom-badge\">{{ row.branch.qtd }}</span></div></td><td md-cell=\"\" ng-repeat=\"col in colDefinitions\" class=\"{{\'td-level-\' + row.level}} {{classSelected}}\" ng-style=\"classSelected !== \'report\' && {\'border-bottom\' : \'1px solid #ddd\'}\"><div ng-if=\"col.cellTemplate\" compile=\"col.cellTemplate\" cell-template-scope=\"col.cellTemplateScope\"></div><div ng-if=\"!col.cellTemplate\">{{row.branch[col.field]}}</div></td></tr></tbody></table></div>");
$templateCache.put("app/components/a4-ui-tree/index.html","<div layout=\"row\"><div ng-if=\"actionsGroup\"><md-button ng-click=\"expandAll()\"><md-icon class=\"material-icons\" ng-hide=\"collapsed\">keyboard_arrow_down</md-icon>Expandir todos</md-button><md-button ng-click=\"collapseAll()\"><md-icon class=\"material-icons\" ng-hide=\"collapsed\">keyboard_arrow_right</md-icon>Contrair todos</md-button></div><md-input-container class=\"have-search\" ng-if=\"haveSearch\"><input ng-model=\"query\" ng-change=\"findNodes(query)\" placeholder=\"Pesquisar\"></md-input-container></div><div ui-tree=\"treeOptions\" id=\"tree-root\" data-clone-enabled=\"cloneEnable\" data-nodrop-enabled=\"nodropEnable\" data-drag-enabled=\"dragEnable\" data-max-depth=\"maxNodes\" data-drag-delay=\"timeDelay\" data-empty-placeholder-enabled=\"TRUE\"><ol ui-tree-nodes=\"\" ng-model=\"list\" ng-class=\"{hidden: collapsed}\"><li ng-repeat=\"node in list\" ui-tree-node=\"\" ng-include=\"\'app/components/a4-ui-tree/templates/\' + template + \'.html\'\" ng-show=\"visible(node)\" ng-if=\"node.show !== false\"></li></ol></div>");
$templateCache.put("app/components/a4-upload-drag/index.html","<div class=\"a4-upload-drag\"><span ng-show=\"!title\">Arraste o arquivos para aqui</span> <span ng-show=\"title\">{{title}}</span><md-progress-linear ng-show=\"show_loader\" md-mode=\"indeterminate\"></md-progress-linear></div>");
$templateCache.put("app/components/date-picker/date-picker.html","<md-input-container flex=\"\" class=\"md-input-has-placeholder\" layout=\"row\" style=\"margin-bottom: 0; {{isGerador ? \'margin: 10px 0;\' : \'\'}}\"><label class=\"isEnabled\">{{placeholder}}</label><md-icon md-font-icon=\"icon-calendar-select\" class=\"s20 name\" ng-if=\"!withoutIcon\"></md-icon><input date-range-picker=\"\" ng-required=\"required\" ng-disabled=\"disabled\" placeholder=\"{{label}}\" class=\"a4-date-picker\" type=\"text\" ng-change=\"changeOnDatePicker(value)\" autocomplete=\"off\" ng-readonly=\"readOnly\" ng-model=\"value\" options=\"vm.options\"></md-input-container>");
$templateCache.put("app/components/date-range-picker/date-range-picker.html","<form name=\"myForm\" flex-gt-xs=\"\"><div layout=\"row\"><md-input-container class=\"md-input-has-placeholder\" flex=\"\" style=\"margin-top: 15px;\" ng-style=\"disabled ? {\'pointer-events\':\'none\'} : {}\"><label style=\"margin: 0 !important;\">{{label}}</label><md-icon md-font-icon=\"icon-calendar-select\" class=\"s20 name\"></md-icon><input date-range-picker=\"\" ng-disabled=\"disabled\" autocomplete=\"off\" class=\"a4-date-range-picker\" type=\"text\" ng-change=\"changeOnDatePicker(value)\" ng-model=\"value\" options=\"vm.options\"></md-input-container></div></form>");
$templateCache.put("app/components/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex=\"\" ng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll=\"\" ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div ng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button class=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">Click to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div class=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" layout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target=\"\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex=\"\" ng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" ng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll=\"\"><div class=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" ng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" ng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" ng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" md-ink-ripple=\"\"><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" class=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div><md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" ng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin=\"\" md-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/components/nested-list/nodes_renderer.html","<div id=\"{{node.id}}\" data-nodrag=\"{{node.id > 0 && node.id <= 6}}\" class=\"pull-left tree-handle tree-node color-nested-level-{{node.debit_credit}}-{{node.identing_level}}\" ui-tree-handle=\"\"><span tooltip-hint=\"MOVE\" placement=\"bottom\" class=\"glyphicon glyphicon-list\" style=\"font-size: 13px;\"></span></div><div class=\"tree-node-content color-nested-level-{{node.debit_credit}}-{{node.identing_level}}\"><a class=\"btn flat-button btn-xs\" ng-if=\"node.nodes && node.nodes.length > 0\" data-nodrag=\"\" ng-click=\"toggle(this)\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\': collapsed, \'glyphicon-chevron-down\': !collapsed}\"></span></a> <span>{{ node.name | translate}}</span> <button class=\"pull-right btn nested-btn-trash btn-xs\" tooltip-hint=\"DELETE\" placement=\"bottom\" data-nodrag=\"\" ng-disabled=\"node.have_account || node.id > 0 && node.id <= 6\" ng-click=\"vm.remove(node)\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"pull-right btn nested-btn-edit btn-xs\" tooltip-hint=\"EDIT\" placement=\"bottom\" data-nodrag=\"\" ng-disabled=\"node.id > 0 && node.id <= 6\" ng-click=\"vm.editLeafOnTree(this, node)\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"pull-right btn nested-btn-add btn-xs\" tooltip-hint=\"ADD\" placement=\"left\" data-nodrag=\"\" ng-disabled=\"node.have_account || node.identing_level == 4\" ng-click=\"vm.newLeafOnTree(this, node)\"><span class=\"glyphicon glyphicon-plus\"></span></button> <span class=\"glyphicon glyphicon-ban-circle\" style=\"font-size: 15px;top: 3px;position:relative;\" ng-if=\"node.have_account\" tooltip-hint=\"HAS_MOVEMENTS\" placement=\"right\"></span> <span class=\"glyphicon glyphicon-remove-circle\" style=\"font-size: 15px;top: 3px;position:relative;\" ng-if=\"node.id > 0 && node.id <= 6\" tooltip-hint=\"CANT_BE_MOVE_IS_DEFAULT\" placement=\"right\"></span></div><ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\" style=\"list-style-type:none\"><li ng-repeat=\"node in node.nodes| orderBy:\'node_position\'\" ui-tree-node=\"\" ng-include=\"\'app/components/nested-list/nodes_renderer.html\'\"></li></ol>");
$templateCache.put("app/components/nested-list/templateNestedList.html","<div class=\"col-sm-12\" style=\"\"><div ui-tree=\"treeOptions\" data-max-depth=\"3\" id=\"tree-root\"><div class=\"\"><div class=\"tree-node-content color-nested-level-{{parent.debit_credit}}-{{parent.identing_level}}\"><a class=\"btn flat-button btn-xs\" data-nodrag=\"\" ng-click=\"vm.toggle(this)\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': !collapsed}\"></span></a> <span>{{ parent.name | translate}}</span> <button class=\"pull-right btn nested-btn-trash btn-xs\" tooltip-hint=\"DELETE\" placement=\"bottom\" data-nodrag=\"\" ng-disabled=\"parent.have_account || parent.id > 0 && parent.id <= 6\" ng-click=\"vm.remove(node)\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"pull-right btn nested-btn-edit btn-xs\" tooltip-hint=\"EDIT\" placement=\"bottom\" data-nodrag=\"\" ng-disabled=\"parent.id > 0 && parent.id <= 6\" ng-click=\"vm.editLeafOnTree($event, node)\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"pull-right btn nested-btn-add btn-xs\" tooltip-hint=\"ADD\" placement=\"left\" data-nodrag=\"\" ng-disabled=\"parent.have_account || parent.identing_level == 4\" ng-click=\"vm.newLeafOnTree($event, parent)\"><span class=\"glyphicon glyphicon-plus\"></span></button> <span class=\"glyphicon glyphicon-ban-circle\" style=\"font-size: 15px;top: 3px;position:relative;\" ng-if=\"parent.have_account\" tooltip-hint=\"HAS_MOVEMENTS\" placement=\"right\"></span> <span class=\"glyphicon glyphicon-remove-circle\" style=\"font-size: 15px;top: 3px;position:relative;\" ng-if=\"parent.id > 0 && parent.id <= 6\" tooltip-hint=\"CANT_BE_MOVE_IS_DEFAULT\" placement=\"right\"></span></div></div><ol ui-tree-nodes=\"\" style=\"margin-left: 30px;list-style-type:none\" ng-model=\"nodes\"><li ng-repeat=\"node in nodes| orderBy:\'node_position\'\" id=\"{{node.id}}\" ui-tree-node=\"\" ng-include=\"\'app/components/nested-list/nodes_renderer.html\'\"></li></ol></div></div><div class=\"row\"><div class=\"col-md-12\"><hr></div></div>");
$templateCache.put("app/controlpanel/central-reports/ask-fields.html","<md-dialog aria-label=\"Processar arquivo retorno\" md-theme=\"vm.theme\" style=\"min-width: 700px;\"><form ng-submit=\"vm.confirm()\" novalidate=\"\" name=\"params_form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Parametros do relatório</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" style=\"color: #fff;\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content><div layout=\"column\"><md-divider></md-divider><div layout=\"column\" ng-repeat=\"(key, item) in vm.itens\"><div layout=\"row\"><md-input-container flex=\"\">{{item.operator}}</md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>{{item.name}}</label><input ng-if=\"item.type == \'date\' && (item.operator !== \'Número do mês\' && item.operator !== \'Número do dia\' && item.operator !== \'Número do ano\')\" tabindex=\"{{key + 1}}\" autocomplete=\"off\" name=\"{{item.column}}\" ng-model=\"vm.model[item.column].start\" type=\"date\" required=\"\"><md-select ng-if=\"item.type == \'date\' && item.operator === \'Número do mês\'\" ng-model=\"vm.model[item.column].start\" required=\"\" name=\"{{item.column}}\"><md-option ng-repeat=\"item in vm.months\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><input ng-if=\"item.type == \'double\' || item.type == \'float\'\" ui-money-mask=\"2\" tabindex=\"{{key + 1}}\" autocomplete=\"off\" name=\"{{item.column}}\" ng-model=\"vm.model[item.column].start\" required=\"\"><input ng-if=\"item.type == \'number\' || item.type == \'numeric\'|| item.type == \'integer\' || (item.type == \'date\' && (item.operator == \'Número do ano\' || item.operator == \'Número do dia\'))\" type=\"number\" tabindex=\"{{key + 1}}\" autocomplete=\"off\" name=\"{{item.column}}\" ng-model=\"vm.model[item.column].start\" required=\"\"><input ng-if=\"item.type == \'text\'\" type=\"text\" tabindex=\"{{key + 1}}\" autocomplete=\"off\" name=\"{{item.column}}\" ng-model=\"vm.model[item.column].start\" required=\"\"><md-select ng-if=\"(item.type == \'list\' || item.type == \'list_name\')\" ng-model=\"vm.model[item.column].start\" required=\"\" name=\"{{item.column}}\" ng-init=\"vm.getDataFromRequestRoute(item)\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model-options=\"{ debounce: 1000 }\" ng-model=\"searchItem\" placeholder=\"Pesquise o item\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"option in item.data_list | filter: searchItem\" ng-value=\"option.id\" ng-if=\"item.type == \'list\'\">{{option.name}}</md-option><md-option ng-repeat=\"option in item.data_list | filter: searchItem\" ng-value=\"option.name\" ng-if=\"item.type == \'list_name\'\">{{option.name}}</md-option></md-select><div ng-messages=\"params_form[item.column].$error\" role=\"alert\"><div ng-message=\"required\"><span>{{item.name}} é obrigatório(a)</span></div></div></md-input-container><md-input-container flex=\"15\" ng-if=\"item.is_two\" align=\"center\">até</md-input-container><md-input-container flex=\"\" ng-if=\"item.is_two\"><input ng-if=\"item.type == \'date\' && item.is_two\" tabindex=\"{{key + 1}}\" autocomplete=\"off\" name=\"{{item.column}}\" ng-model=\"vm.model[item.column].end\" type=\"date\" required=\"\"><input ng-if=\"(item.type == \'double\' || item.type == \'float\') && item.is_two\" ui-money-mask=\"2\" tabindex=\"{{key + 1}}\" autocomplete=\"off\" name=\"{{item.column}}\" ng-model=\"vm.model[item.column].end\" required=\"\"><input ng-if=\"(item.type == \'number\' || item.type == \'numeric\') && item.is_two\" type=\"number\" tabindex=\"{{key + 1}}\" autocomplete=\"off\" name=\"{{item.column}}\" ng-model=\"vm.model[item.column].end\" required=\"\"><input ng-if=\"item.type == \'text\' && item.is_two\" type=\"text\" tabindex=\"{{key + 1}}\" autocomplete=\"off\" name=\"{{item.column}}\" ng-model=\"vm.model[item.column].end\" required=\"\"><md-select ng-if=\"(item.type == \'list\' || item.type == \'list_name\') && item.is_two\" ng-model=\"vm.model[item.column].start\" required=\"\" name=\"{{item.column}}\" ng-init=\"vm.getDataFromRequestRoute(item)\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model-options=\"{ debounce: 1000 }\" ng-model=\"searchItem\" placeholder=\"Pesquise o item\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"option in item.data_list | filter: searchItem\" ng-value=\"option.id\" ng-if=\"item.type == \'list\'\">{{option.name}}</md-option><md-option ng-repeat=\"option in item.data_list | filter: searchItem\" ng-value=\"option.name\" ng-if=\"item.type == \'list_name\'\">{{option.name}}</md-option></md-select></md-input-container></div><md-divider></md-divider></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-disabled=\"vm.loading_return || params_form.$invalid\" aria-label=\"Add Task\"><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" ng-if=\"vm.loading_return\" md-mode=\"indeterminate\"></md-progress-circular>{{\"FMD.SEND\" | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/controlpanel/central-reports/central-reports.html","<div id=\"page-material-table\" style=\"background-color: whitesmoke\" class=\"doc-page material-docs doc-template page-layout simple tabbed ng-scope layout-column\"><md-content id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" style=\"box-shadow: 0 7px 8px #ccc\"><md-toolbar class=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb text-truncate\" layout=\"row\" layout-align=\"start center\" style=\"background-color: transparent;\"><md-button class=\"md-icon-button\" ui-sref=\"private.controlpanel.dashboard\" ng-if=\"withbackward\"><md-tooltip md-direction=\"top\">Voltar para o painel de controle</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"underline_breadcrumb\" ng-click=\"vm.navigateTo(vm.breadCrumb[0], -1, true)\">Central de Relatórios</span><md-icon md-font-icon=\"icon-chevron-right\" ng-if=\"vm.breadCrumb.length > 0\" class=\"icon separator\"></md-icon><span data-ng-repeat=\"breadCrumb in vm.breadCrumb\"><span class=\"underline_breadcrumb\" ng-click=\"vm.navigateTo(breadCrumb, $index)\">{{breadCrumb.clicked.name}}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"icon separator\"></md-icon></span></div></div><div id=\"file-uploader\"><md-button class=\"add-file-button md-fab md-primary\" aria-label=\"Add file\" translate=\"\" ng-click=\"vm.openModalCreate(vm.breadCrumb[vm.breadCrumb.length - 1].clicked)\" ng-if=\"vm.checkPolicies(\'report-create\')\" translate-attr-aria-label=\"FM.ADD_FILE\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></md-toolbar><md-content class=\"content\" layout=\"row\" flex=\"\" ms-scroll=\"\" style=\"background-color: whitesmoke !important;\"><table class=\"simple list-view\" flex=\"\"><thead><tr><th></th><th translate=\"FM.NAME\">Name</th><th hide=\"\" show-gt-sm=\"\" translate=\"FM.TYPE\">Type</th><th hide-xs=\"\" translate=\"FM.OWNER\">Owner</th><th hide=\"\" show-gt-md=\"\" translate=\"FM.LAST_MODIFIED\">Last Modified</th><th show-gt-md=\"\"></th><th hide-gt-md=\"\"></th></tr></thead><tbody><tr ng-click=\"vm.select(null)\" ng-dblclick=\"vm.goBack()\" ng-if=\"vm.showBack()\" ng-class=\"{\'selected\' : vm.selected === null}\"><td class=\"file-icon\"><i class=\"icon-dots-horizontal\"></i></td><td class=\"name\">Voltar</td><td class=\"type\" hide=\"\" show-gt-sm=\"\"></td><td class=\"owner\" hide-xs=\"\"></td><td class=\"last-modified\" hide=\"\" show-gt-md=\"\"></td><td class=\"last-modified\" hide=\"\" show-gt-md=\"\"></td></tr><tr ng-repeat=\"item in vm.items | filter:global.search\" ng-click=\"vm.select(item)\" ng-dblclick=\"vm.goForward(item, vm.items)\" ng-class=\"{\'selected\' : vm.selected.id === item.id}\"><td class=\"file-icon\"><i class=\"icon-folder\" ng-if=\"item.type == 1\"></i> <i class=\"icon-file-document\" ng-if=\"item.type == 2\"></i> <i class=\"icon-file-word\" ng-if=\"item.type == 3\"></i> <i class=\"icon-file-excel\" ng-if=\"item.type == 4\"></i></td><td class=\"name\">{{item.name}}</td><td class=\"type\" hide=\"\" show-gt-sm=\"\">{{vm.getReportType(item.type).name}}</td><td class=\"owner\" hide-xs=\"\">{{item.owner}}</td><td class=\"last-modified\" hide=\"\" show-gt-md=\"\">{{item.updated_at | date:\"dd/MM/yyyy H:i:s\"}}</td><td class=\"last-modified\" hide=\"\" show-gt-md=\"\"><div layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"Download\" ng-click=\"vm.generateReport(item)\" ng-disabled=\"item.type == 1\" ng-if=\"vm.checkPolicies(\'report-visualize\')\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-file-pdf\" style=\"color: black;\" ng-if=\"item.type == 2\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"FM.GENERATE\">Visualizar relatório</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" ng-disabled=\"item.type == 1\" ng-click=\"vm.defineDetails(item, false)\" ng-if=\"vm.checkPolicies(\'report-edit\')\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-pencil\" style=\"color: black;\" ng-if=\"item.type == 2\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"FM.DEFINE\">Editar relatório</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" ng-disabled=\"item.type == 1\" ng-click=\"vm.duplicateReport(item)\" ng-if=\"vm.checkPolicies(\'report-create\')\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon>library_books</md-icon><md-tooltip md-direction=\"top\"><span>Duplicar relatório</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removerItem(item)\" ng-if=\"vm.checkPolicies(\'report-delete\')\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip md-direction=\"right\">Remover</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Mover para pasta\" ng-click=\"vm.openMoveToFolderModal(item)\" ng-if=\"item.type == 2 && vm.checkPolicies(\'report-edit\')\" translate=\"\" translate-attr-aria-label=\"FM.MOVE_TO_FOLDER\"><md-icon md-font-icon=\"icon-folder-move\" style=\"color: black;\"></md-icon><md-tooltip md-direction=\"top\"><span>Mover para pasta</span></md-tooltip></md-button></div></td></tr></tbody></table></md-content></div></md-content></div>");
$templateCache.put("app/controlpanel/central-reports/list-view.html","");
$templateCache.put("app/controlpanel/dashboard/dashboard.html","<md-content class=\"board md-accent-bg\" layout=\"column\" flex=\"\" md-theme=\"controlpanel\"><div class=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1>Aplicações</h1><div class=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList track by $index\" ng-if=\"board.is_show\" ng-click=\"vm.stateGo(board.state)\" layout=\"column\" layout-align=\"center center\"><div><img ng-src=\"{{board.icon}}\" alt=\"\"></div><div class=\"board-name\"><b>{{board.name}}</b></div></div></div></div><div class=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1>Mais Configurações</h1><div class=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-repeat=\"board in vm.configMenu track by $index\" ng-click=\"vm.stateGo(board.state)\" ng-if=\"board.is_show\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"{{board.icon}}\" class=\"icon s64\" style=\"color: #000;\"></md-icon><div class=\"board-name\"><b>{{board.name}}</b></div></div></div></div></md-content>");
$templateCache.put("app/controlpanel/import-data/index.html","<div id=\"page-material-table\" style=\"background-color: whitesmoke\" class=\"doc-page material-docs doc-template page-layout simple tabbed ng-scope layout-column\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.controlpanel.dashboard\"><md-tooltip md-direction=\"top\">Voltar para o painel de controle</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Migração de dados</span></div></div></md-toolbar><md-content layout-xs=\"column\" layout=\"column\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" flex=\"\"><div layout=\"row\" fle=\"\" ng-if=\"vm.file_processed\"><form><md-input-container><label>Datas:</label><md-select ng-model=\"vm.data_patterns.date\"><md-option ng-repeat=\"date_pattern in vm.date_patterns\" ng-value=\"date_pattern\">{{date_pattern}}</md-option></md-select></md-input-container><md-input-container><label>Números:</label><md-select ng-model=\"vm.data_patterns.numeric\"><md-option ng-repeat=\"numeric_pattern in vm.numeric_patterns\" ng-value=\"numeric_pattern\">{{numeric_pattern}}</md-option></md-select></md-input-container></form></div><md-input-container><input type=\"file\" id=\"new_csv\" aria-label=\"selecionar_arquivo\" name=\"new_csv\" file-read=\"\" ng-model=\"vm.file\" apply-function=\"vm.newCsv(file)\" style=\"display: none;\" ng-change=\"vm.newCsv()\"></md-input-container><span flex=\"\"></span><md-input-container flex=\"15\"><label>Planilha</label><md-select ng-model=\"vm.selectedSpreadsheet\" ng-change=\"vm.changeJson(vm.selectedSpreadsheet.columns);\"><md-option ng-repeat=\"spreadsheet in vm.spreadSheets\" ng-value=\"spreadsheet\">{{spreadsheet.name}}</md-option></md-select></md-input-container><md-input-container flex=\"15\"><label>Sistema</label><md-select ng-model=\"vm.selectedSystem\" ng-change=\"vm.setMapping(vm.selectedSystem)\" ng-disabled=\"!vm.selectedSpreadsheet\"><md-option ng-repeat=\"system in vm.systems\" ng-value=\"system.id\">{{system.name}}</md-option></md-select></md-input-container><md-button flex=\"10\" class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-disabled=\"!vm.selectedSystem\" onclick=\"document.getElementById(\'new_csv\').click();\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Migrar CSV</md-button><md-button flex=\"10\" class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-if=\"vm.file != null || vm.map_first_line !== null\" ng-click=\"vm.saveMapping()\"><md-icon md-font-icon=\"icon-code-array\"></md-icon>Salvar colunas</md-button><md-button flex=\"10\" class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-if=\"vm.file != null\" ng-click=\"vm.submitCsv()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Salvar dados</md-button><md-button flex=\"10\" class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-if=\"vm.file != null\" ng-click=\"vm.validateFields()\"><md-icon md-font-icon=\"icon-cloud-check\"></md-icon>Validar dados</md-button></div></md-toolbar></md-card><div layout=\"row\" flex=\"\"><md-card class=\"md-padding\" ng-if=\"vm.mandatory_not_found.length > 0\" flex=\"20\" style=\"max-height: 300px !important; overflow-y: scroll\"><h4>Existem colunas obrigatórias não localizadas no arquivo:</h4><span ng-repeat=\"item in vm.mandatory_not_found track by $index\">{{$index == 0 ? item.name : \' - \' + item.name}}</span></md-card><md-card class=\"md-padding\" ng-if=\"vm.errors.length > 0\" flex=\"40\" style=\"max-height: 300px !important; overflow-y: scroll\"><h4>Erros criticados na importação:</h4><md-table-container flex=\"\"><table md-table=\"\" md-progress=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Linha</th><th md-column=\"\">Coluna</th><th md-column=\"\">Valor</th><th md-column=\"\">Tipo de erro</th><th md-column=\"\">Erro</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"error in vm.errors\"><td md-cell=\"\">{{error.line}}</td><td md-cell=\"\">{{error.column_name}}</td><td md-cell=\"\">{{error.column_value}}</td><td md-cell=\"\">{{error.error_type}}</td><td md-cell=\"\">{{error.error_info}}</td></tr></tbody></table></md-table-container></md-card><md-card class=\"md-padding\" ng-if=\"vm.uploadedFiles.length > 0\" flex=\"40\" style=\"max-height: 300px !important; overflow-y: scroll\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Caminho do arquivo</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"file in vm.uploadedFiles\"><td md-cell=\"\">{{file.name}}</td><td md-cell=\"\">{{file.path}}</td><td md-cell=\"\"><md-icon md-font-icon=\"icon-delete\" style=\"cursor: pointer\" ng-click=\"vm.deleteFile(file)\"></md-icon></td></tr></tbody></table></md-table-container></md-card></div><md-card class=\"md-padding\" flex=\"\"><div layout=\"row\" class=\"md-padding\"><md-table-container flex=\"50\"><table md-table=\"\" md-progress=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Coluna</span></th><th md-column=\"\"><span>Referência</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"column in vm.map_first_line track by $index\"><td md-cell=\"\"><span>{{column.origin}}</span></td><td md-cell=\"\"><md-select name=\"variables\" ng-model=\"column.to\" aria-label=\"selecionar_coluna\" ng-change=\"vm.changeColumn(column, \'{{column.to}}\')\"><md-select-header class=\"demo-select-header\"><input type=\"search\" aria-label=\"buscar_coluna\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchVariable\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"null\"></md-option><md-option ng-value=\"item.name\" ng-repeat=\"item in vm.json_option | filter: searchVariable\" aria-label=\"{{item.name}}\">{{item.name}}</md-option></md-select></td></tr></tbody></table></md-table-container></div></md-card></md-content></div>");
$templateCache.put("app/controlpanel/import-data/modal-option-csv.html","<md-dialog aria-label=\"Migração\" md-theme=\"controlpanel\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Opção de migração</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" flex=\"\"><md-button class=\"md-raised\" ng-click=\"vm.answer(true)\" flex=\"50\">Criar nova tabela temporária</md-button><md-button class=\"md-raised\" ng-click=\"vm.answer(false)\" flex=\"50\">Reutilizar tabela temporária</md-button></div></md-dialog>");
$templateCache.put("app/controlpanel/unification/index.html","<div id=\"page-material-table\" style=\"background-color: whitesmoke\" class=\"doc-page material-docs doc-template page-layout simple tabbed ng-scope layout-column\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.controlpanel.dashboard\"><md-tooltip md-direction=\"top\">Voltar para o painel de controle</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Unificação</span></div></div></md-toolbar><div layout=\"row\" layout-align=\"center center\"><md-card layout=\"row\" style=\"padding: 0;\" flex=\"25\" layout-align=\"center center\"><a flex=\"\" class=\"text-center btn-check-controlpanel md-ink-ripple\" ng-click=\"vm.verifyDuplicated()\"><md-icon md-font-icon=\"icon-account-switch\"></md-icon><div>Verificar duplicatas</div></a></md-card></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-card flex=\"45\" ng-repeat=\"item in vm.duplicated track by $index\"><md-card-title><md-card-title-text><div class=\"md-headline\" layout=\"row\" layout-align=\"start end\"><div flex=\"\">{{item.names.replace(\'{\', \'\').replace(\'}\', \'\').split(\',\')[0]}}</div><div flex=\"10\"><md-button flex=\"\" class=\"md-icon-button\" ng-click=\"vm.unificate(item, $index)\"><md-icon md-font-icon=\"icon-account-switch\"></md-icon><md-tooltip>Unificar</md-tooltip></md-button></div></div></md-card-title-text></md-card-title><md-card-content><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\">CPF</th><th md-column=\"\">Data Nasc.</th><th md-column=\"\">Celular</th><th md-column=\"\">Endereço</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"detail in item.details\"><td md-cell=\"\">{{detail.name}}</td><td md-cell=\"\">{{detail.national_id_number}}</td><td md-cell=\"\">{{detail.dob}}</td><td md-cell=\"\">{{detail.phone_mobile}}</td><td md-cell=\"\">{{detail.address_street}}</td></tr></tbody></table></md-table-container></md-card-content></md-card></div></div>");
$templateCache.put("app/crm/charge/charge-modal.html","<md-dialog aria-label=\"Mensagem de cobrança\" md-theme=\"crm\" style=\"min-width: 650px; max-width: 650px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.is_edit\">Criar novo evento de {{vm.event}}</h2><h2 ng-if=\"vm.is_edit\">Editar evento de {{vm.event}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close(false)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form ng-cloak=\"\" name=\"formEvent\"><div class=\"md-padding\" style=\"margin-bottom: -20px;\"><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div layout=\"row\" style=\"border-left: solid 4px #6700e5; font-size: 16px;\" required=\"\" ng-if=\"vm.type === \'charge\'\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Origem do evento</b> <small>Selecione quem originou o evento</small></div></div><md-input-container><md-radio-group ng-model=\"vm.form.event_origin_id\" required=\"\" ng-if=\"vm.type === \'charge\'\"><div layout=\"row\"><md-radio-button value=\"0\">Não especificado</md-radio-button><md-radio-button value=\"1\" style=\"margin-left: 10px;\">Originado pela escola</md-radio-button><md-radio-button value=\"2\" style=\"margin-left: 10px;\">Originado pela outra parte</md-radio-button></div></md-radio-group><md-radio-group ng-model=\"vm.form.event_origin_id\" required=\"\" ng-if=\"vm.type === \'prospects\'\"><div layout=\"row\"><md-radio-button value=\"1\" style=\"margin-left: 10px;\">Por nós (outbound)</md-radio-button><md-radio-button value=\"2\" style=\"margin-left: 10px;\">Por eles (inbound)</md-radio-button><md-radio-button value=\"0\">Não especificado</md-radio-button></div></md-radio-group></md-input-container></md-dialog-content></div><div class=\"md-padding input-charge-form\"><md-input-container style=\"width: 100%\" class=\"md-input-has-placeholder\"><div layout=\"row\" style=\"width: 100%\"><label>Formato do evento</label><md-select ng-model=\"vm.form.event_format_id\" style=\"width: 100%\" required=\"\"><md-option ng-repeat=\"format in vm.event_formats\" ng-value=\"format.id\" style=\"width: 100%\">{{format.name}}</md-option></md-select></div></md-input-container></div><div class=\"md-padding input-charge-form\"><md-input-container style=\"width: 100%\" class=\"md-input-has-placeholder\"><div layout=\"row\"><label>Tipo do evento</label><md-select ng-model=\"vm.form.event_type_id\" style=\"width: 100%\" required=\"\"><md-option ng-repeat=\"type in vm.event_types\" ng-value=\"type.id\" style=\"width: 100%\">{{type.name}}</md-option></md-select></div></md-input-container></div><div class=\"md-padding input-charge-form\" ng-if=\"!vm.withResponsible\"><md-autocomplete flex=\"\" md-input-name=\"responsible\" md-input-minlength=\"2\" md-no-cache=\"false\" md-delay=\"1000\" md-selected-item=\"vm.responsible\" md-selected-item-change=\"vm.changeResponsible(vm.responsible)\" md-search-text=\"searchTextResponsible\" md-items=\"item in vm.getResponsibles(searchTextResponsible)\" md-item-text=\"item.name\" md-floating-label=\"{{vm.type === \'charge\' ? \'Responsável\' : \'Empresa\'}}\" required=\"\"><md-item-template><span md-highlight-text=\"searchTextResponsible\">{{item.name}} {{vm.type === \'prospects\' ? \' - \' + item.address_city + \'/\' + item.address_state : \'\'}}</span></md-item-template></md-autocomplete></div><div class=\"md-padding input-charge-form\" ng-if=\"vm.type === \'prospects\'\"><md-input-container style=\"width: 100%\" class=\"md-input-has-placeholder\"><div layout=\"row\" style=\"width: 100%\"><label>Contatos</label><md-select multiple=\"\" ng-model=\"vm.form.person_id_contacts\" style=\"width: 100%;\"><md-option ng-repeat=\"contact in vm.event_contacts\" ng-value=\"contact.id\" style=\"width: 100%;\" flex=\"\">{{contact.name}} <small>[{{contact.roles_names}}]</small> <small ng-if=\"contact.phone_landline !== null\">Tel: {{contact.phone_landline}}</small> <small ng-if=\"contact.phone_mobile\">Cel: {{contact.phone_mobile}}</small></md-option></md-select></div></md-input-container></div><div class=\"md-padding input-charge-form\"><md-autocomplete flex=\"\" md-input-name=\"charger\" md-input-minlength=\"2\" md-no-cache=\"false\" md-delay=\"1000\" md-selected-item=\"vm.charger\" md-search-text=\"searchTextCharger\" md-items=\"item in vm.getCollaborators(searchTextCharger)\" md-item-text=\"item.name\" md-floating-label=\"Agente\" required=\"\"><md-item-template><span md-highlight-text=\"searchTextCharger\">{{item.name}}</span></md-item-template></md-autocomplete></div><div class=\"md-padding input-charge-form\" ng-if=\"!vm.is_edit\"><md-checkbox ng-model=\"vm.is_programated\">É um evento programado?</md-checkbox></div><div class=\"md-padding input-charge-form\" ng-if=\"vm.is_programated || vm.is_edit\"><div layout=\"row\" style=\"border-left: solid 4px #6700e5; font-size: 16px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Programação do evento</b> <small>Insira os detalhes da programação do evento</small></div></div><div layout=\"row\" flex=\"\" style=\"margin-top: 15px\"><date-picker ng-model=\"vm.form.date_scheduled\" placeholder=\"Data programada\" flex=\"35\" ng-change=\"vm.date_scheduled_change()\"></date-picker><md-input-container flex=\"65\" class=\"md-input-has-placeholder\"><label>Hora programada</label><md-icon md-font-icon=\"icon-timer\"></md-icon><input type=\"time\" ng-model=\"vm.form.time_scheduled\" ng-change=\"vm.time_scheduled_change()\"></md-input-container></div><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><textarea type=\"text\" rows=\"2\" ng-model=\"vm.form.notes_scheduled\" placeholder=\"Digite aqui o texto\" ng-disabled=\"!vm.is_programated && !vm.is_edit\"></textarea></md-input-container></div><div class=\"md-padding\" ng-if=\"!vm.is_programated\"><div layout=\"row\" style=\"border-left: solid 4px #6700e5; font-size: 16px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Realização do evento</b> <small>Insira os detalhes da realização do evento</small></div></div><div layout=\"row\" flex=\"\" style=\"margin-top: 15px\"><date-picker ng-model=\"vm.form.date_done\" placeholder=\"Data da realização\" flex=\"35\" ng-change=\"vm.date_done_change()\"></date-picker><md-input-container flex=\"65\" class=\"md-input-has-placeholder\"><label>Hora da realização</label><md-icon md-font-icon=\"icon-timer\"></md-icon><input type=\"time\" ng-model=\"vm.form.time_done\"></md-input-container></div><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><textarea type=\"text\" rows=\"2\" ng-model=\"vm.form.notes_done\" placeholder=\"Digite aqui o texto\"></textarea></md-input-container></div><div layout=\"row\" style=\"border-left: solid 4px #6700e5; font-size: 16px; background-color: whitesmoke\" ng-if=\"vm.is_edit\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Criador do evento:</b> <small>{{vm.form.owner_name}}</small></div></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; margin-top: 55px;\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close(false)\" ng-disabled=\"vm.loader\">Cancelar</md-button><md-button flex=\"20\" layout=\"row\" class=\"md-raised md-primary\" ng-click=\"vm.save()\" ng-disabled=\"vm.loader || formEvent.$invalid\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loader\" flex=\"5\" md-diameter=\"15\"></md-progress-circular><span flex=\"\">Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/crm/charge/charge.html","<a4-crm-contact-grid type=\"\'charge\'\"></a4-crm-contact-grid>");
$templateCache.put("app/crm/dashboard/dashboard.html","<div><md-button policy-access=\"private.finance.dashboard.create\" class=\"md-primary\">Access</md-button></div>");
$templateCache.put("app/educational/dashboard/dashboard.html","<div ng-if=\"vm.checkProfile(1)\"><div ui-view=\"students\"></div></div><div ng-if=\"!vm.checkProfile(1)\" id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-window-restore\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Mural</span></div></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Mural\"><div layout-xs=\"column\" layout=\"row\"><div flex-xs=\"\" flex-gt-xs=\"33\" layout=\"column\"></div><div flex-xs=\"\" flex-gt-xs=\"33\" layout=\"column\"><md-card class=\"md-card-image\" ng-if=\"vm.checkProfile(vm.CONFIG.profile.parent) && vm.person.email == null\"><md-card-title style=\"margin-left: 35%\"><md-title-text class=\"md-headline\"><b>ATENÇÃO.</b></md-title-text></md-card-title><md-card-content style=\"font-family: inherit; font-size: large\">Nenhum email foi informado ainda para essa conta. É recomendado que um email seja informado para operações futuras, para fazer isso agora, basta escrever o email de sua preferência abaixo.</md-card-content><md-card-actions layout=\"row\"><md-input-container style=\"width: 80%;\"><label>Email</label> <input type=\"email\" ng-model=\"vm.user_email\" required=\"\"></md-input-container><md-button class=\"md-primary\" ng-click=\"vm.saveResponsibleEmail(vm.user_email)\" style=\"box-shadow: 0 4px 8px rgba(82, 80, 80, 0.2); margin-left: 15px;\">Salvar</md-button></md-card-actions></md-card><md-card ng-repeat=\"document in vm.documents\"><img ng-if=\"document.file_reference !== null\" ng-src=\"{{vm.url}}{{document.file_reference}}\" ng-click=\"vm.openImage( vm.url + document.file_reference, document.title )\" style=\"cursor: pointer\" class=\"md-card-image\"><md-card-title><md-card-title-text><span class=\"md-headline\">{{document.title}}</span> <span class=\"a4-subhead\">{{document.date | date:\'dd/MM/yyyy\'}}</span></md-card-title-text></md-card-title><md-card-content><pre style=\"font-family: inherit;\" ng-bind-html=\"document.content\"></pre></md-card-content></md-card></div><div flex-xs=\"\" flex-gt-xs=\"33\" layout=\"column\"></div></div></md-tab><md-tab label=\"Dashboard\" ng-if=\"vm.show_dashboard\" md-on-select=\"vm.loadCharts()\"><div layout-xs=\"column\" layout=\"row\" flex=\"100\" policy-access=\"info_gerenciais\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">Matrículas por curso</div><md-divider></md-divider><div class=\"p-16\"><a4-charts-bar flex=\"\" options=\"vm.enrolment_by_course_chart.options\" educational=\"true\" label-string=\"Quantidade\" labels=\"vm.enrolment_by_course_chart.labels\" series=\"vm.enrolment_by_course_chart.series\" data=\"vm.enrolment_by_course_chart.data\" colors=\"vm.enrolment_by_course_chart.colors\"></a4-charts-bar></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">Evolução das matrículas<md-button ng-click=\"vm.printChart(selectedTab)\"><md-icon>print</md-icon><md-tooltip>Imprimir</md-tooltip></md-button></div><md-divider></md-divider><div class=\"p-16\"><a4-charts flex=\"\" options=\"vm.enrolment_evolution_chart.options\" educational=\"true\" label-string=\"Quantidade\" labels=\"vm.enrolment_evolution_chart.labels\" series=\"vm.enrolment_evolution_chart.series\" data=\"vm.enrolment_evolution_chart.data\" colors=\"vm.enrolment_evolution_chart.colors\"></a4-charts></div></ms-widget-front></ms-widget></div><div layout-xs=\"column\" layout=\"row\" flex=\"100\" policy-access=\"info_gerenciais\"><div flex=\"50\"><a4-emails-errors errors=\"vm.emails_errors\" report=\"vm.emails_report\"></a4-emails-errors></div></div></md-tab></md-tabs></div>");
$templateCache.put("app/educational/dashboard/show-image.html","<md-dialog aria-label=\"confirmar matricula\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_loader\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><img src=\"{{vm.url}}\" alt=\"Imagem\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/finance-enrolment/finance-enrolment-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cash-usd\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Assistente de Matrícula Financeira | {{enrolment.student.name}}</span></div></div></md-toolbar><md-card layout-padding=\"\" class=\"with-btn-add\"><md-steppers md-busy-text=\"\'Aguarde...\'\" md-busy=\"enrolment.showBusyText\" md-dynamic-height=\"\" md-stretch-steppers=\"always\" md-selected=\"enrolment.stepSelected\"><md-step label=\"Contratos\" md-complete=\"enrolment.steps.payment_plan.completed\"><div ui-view=\"finance-enrolment-payment_plan\" ng-if=\"enrolment.stepSelected == 0\"></div></md-step><md-step label=\"Finalização\" md-complete=\"enrolment.steps.end.completed\" ng-disabled=\"enrolment.steps.end.disabled\"><div ui-view=\"finance-enrolment-end\" ng-if=\"enrolment.stepSelected == 1\"></div></md-step></md-steppers></md-card></div>");
$templateCache.put("app/educational/re-enrollment/confirm-enrolment.html","<md-dialog aria-label=\"confirmar matricula\" md-theme=\"educational\" style=\"min-width: 450px; max-width: 700px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Confirmação de matrícula on-line</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" ng-if=\"vm.scope.notes.company_id != 696\"><div ng-if=\"vm.scope.notes.enrolment_online_is_electronic_signature == false\"><h1>Prezado responsável,</h1><div style=\"font-size: 18px;\" align=\"justify\">A seguir você deverá imprimir e assinar o contrato e a ficha de matrícula.<br>Será disponibilizado também o boleto para pagamento da primeira parcela.<br>A matricula, a partir dessa confirmação, permanecerá como pendente.<br>Ela será efetivada após a entrega dos documentos, devidamente assinados, na secretaria da escola e a confirmação do pagamento do boleto pela rede bancária.<br><br></div></div><div ng-if=\"vm.scope.notes.enrolment_online_is_electronic_signature == true\"><h1>Prezado responsável,</h1><div style=\"font-size: 18px;\" align=\"justify\">A seguir você deverá ler e assinar digitalmente o contrato e imprimir a ficha de matrícula.<br>Será disponibilizado também o boleto para pagamento da primeira parcela.<br>A matricula, a partir dessa confirmação, permanecerá como pendente.<br>Ela será efetivada após a confirmação do pagamento do boleto pela rede bancária.<br><br></div></div><md-checkbox ng-model=\"vm.confirm\">Confirmo que li e aceito os termos da matrícula on-line</md-checkbox></div><div class=\"md-dialog-content\" ng-if=\"vm.scope.notes.company_id == 696\"><div style=\"font-size: 18px;\" align=\"justify\">Prezado pai e/ou responsável,<br><br><br>Em 2024, ofertaremos exclusivamente o desconto de 20% na pontualidade, sendo este o desconto padrão da escola.<br>Após confirmado o pedido de matrícula on-line, aguarde o boleto da mensalidade de Janeiro/{{(vm.scope.year + 1).toString().slice(2)}} que será disponibilizado via AGENDA EDU.<br>A matrícula somente será efetivada após a confirmação do pagamento do boleto da mensalidade de Janeiro/{{(vm.scope.year + 1).toString().slice(2)}}.<br>Matrículas realizadas e confirmadas até dia 31/10/{{(vm.scope.year).toString().slice(2)}} ofertaremos 20% de desconto na mensalidade de Janeiro/{{(vm.scope.year + 1).toString().slice(2)}}.<br>Dúvidas, estaremos à disposição no telefone 3013.9615 (WhatsAppp).<br>Atenciosamente;<br>A direção<br><br></div><md-checkbox ng-model=\"vm.confirm\">Confirmo que li e aceito os termos da matrícula on-line</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button ng-click=\"vm.answer(vm.confirm)\" ng-disabled=\"!vm.confirm\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/re-enrollment/confirm-message.html","<md-dialog aria-label=\"conclusao\" md-theme=\"educational\" style=\"min-width: 450px; max-width: 700px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Processo concluído com sucesso</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div><div style=\"font-size: 18px;\" align=\"justify\" ng-if=\"vm.scope.enrolment_online_is_electronic_signature == false\">Sua solicitação foi encaminhada com sucesso!<br>A matricula ficará pendente aguardando a confirmação do pagamento e a entrega dos documentos na secretaria da escola.</div><div style=\"font-size: 18px;\" align=\"justify\" ng-if=\"vm.scope.enrolment_online_is_electronic_signature == true\">Sua solicitação foi encaminhada com sucesso!<br>A matricula ficará pendente aguardando a confirmação do pagamento.</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.answer()\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/re-enrollment/contract.html","<md-dialog aria-label=\"confirmar matricula\" md-theme=\"educational\" style=\"width: 1000px; min-height: 287px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Assinatura de contrato</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_loader\" ng-if=\"!vm.show_sign\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-sm=\"column\" ng-if=\"vm.show_loader\" layout-align=\"space-around\"><div style=\"margin-left: 420px\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><p style=\"text-align: center;\">Carregando contrato, por favor, aguarde.</p></div><div flex=\"\" layout=\"column\" layout-xs=\"column\" ng-if=\"!vm.show_loader\"><div flex=\"100\" ng-if=\"!vm.show_sign\" layout=\"column\" layout-align=\"start stretch\" layout-wrap=\"\"><div style=\"height: 420px; width: 100%; margin-bottom: 10px;\"><iframe ng-if=\"!vm.isAndroid && vm.student.content != null\" ng-src=\"{{vm.student.content}}\" type=\"application/pdf\" width=\"100%\" height=\"100%\"></iframe><div ng-if=\"vm.isAndroid\" id=\"pdf-container-android\" style=\"width: 100%; height: 100%; overflow: auto; background-color: #f5f5f5;\"><div ng-if=\"!vm.pdfLoaded\" style=\"text-align: center; padding-top: 120px;\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular><p>Carregando PDF...</p></div></div></div><div layout=\"row\" flex=\"\" style=\"margin-top: 10px;\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.closeModal()\" ng-if=\"vm.config.enrolment_online_is_electronic_signature == false\" ng-disabled=\"sign_contract.$invalid || $root.show_loader\" flex=\"\">Confirmar matrícula</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.printEnrolmentContract()\" ng-if=\"vm.config.enrolment_online_is_electronic_signature == true\" ng-disabled=\"sign_contract.$invalid || $root.show_loader || vm.loading\" flex=\"\">Download</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.show_sign = true\" ng-if=\"vm.config.enrolment_online_is_electronic_signature == true\" ng-disabled=\"sign_contract.$invalid || $root.show_loader\" flex=\"\">Assinar</md-button></div></div><div ng-if=\"vm.show_sign\"><a4-digital-sign person=\"vm.person\" student=\"vm.student\"></a4-digital-sign></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/re-enrollment/print-documents.html","<md-dialog aria-label=\"confirmar matricula\" md-theme=\"educational\" style=\"min-width: 531px; min-height: 287px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Impressão de documentos</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_loader\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-sm=\"column\" ng-if=\"vm.show_loader\" layout-align=\"space-around\"><div style=\"margin-left: 194px\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><p style=\"text-align: center;\">Gerando documento solicitado, por favor, aguarde.</p></div><div class=\"md-dialog-content\" ng-if=\"!vm.show_loader\"><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" ng-click=\"vm.printEnrolmentContract()\" ng-if=\"vm.config.enrolment_online_contract_type\"><md-icon>assignment</md-icon><div>Imprimir contrato</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" ng-click=\"vm.printEnrolmentForm()\" ng-if=\"vm.config.enrolment_online_enrolment_form_type\"><md-icon md-font-icon=\"icon-note-text\"></md-icon><div>Imprimir ficha de matrícula</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" ng-click=\"vm.printBankSlip()\" ng-if=\"vm.config.enrolment_online_bank_slip_type\"><md-icon md-font-icon=\"icon-barcode\"></md-icon><div>Imprimir boleto</div></a></md-card></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/re-enrollment/re-enrollment.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-school\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Matrícula online</span></div></div></md-toolbar><md-content layout-padding=\"\" layout=\"row\" class=\"with-btn-add\" style=\"background-color: whitesmoke !important;\"><div style=\"background-color: #00B0FF; width: 100%; height: auto;text-align: center;\" ng-if=\"vm.has_pendences.length > 0 && vm.allow_enrolment\"><i class=\"icon-alert\" style=\"color: #fff;font-size: 60px;\"></i><br><h1 style=\"color: #fff;\">Prezado Responsável,</h1><span style=\"font-size: 25px; color: #fff;\">Identificamos a ocorrência de pendências em nossos registros.<br>O processo de matrícula pela web não estará disponível até a regularização de possíveis pendências. Favor entrar em contato com a secretaria.</span></div><div style=\"background-color: #00B0FF; width: 100%; height: auto;text-align: center;\" ng-if=\"!vm.allow_enrolment\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-school\" style=\"color: #fff;font-size: 60px;\"></i><br><span style=\"font-size: 25px; color: #fff;\">Periodo de matrícula online ainda não iniciado</span></p></div><md-card class=\"md-padding\" flex=\"\" ng-if=\"vm.allow_enrolment && vm.has_pendences <= 0\"><md-list flex=\"\"><md-list-item class=\"noright\" flex=\"\"><span flex=\"30\">Aluno</span> <span flex=\"30\">Curso/Turma</span> <span flex=\"10\">Ano</span> <span flex=\"20\">Status</span> <span flex=\"10\">Ações</span></md-list-item><md-list-item ng-repeat=\"student in vm.students\" class=\"noright\" flex=\"\"><span flex=\"30\">{{student.student_name}}</span> <span flex=\"30\">{{student.course_name}} / {{student.group_name}}</span> <span flex=\"10\">{{student.school_period_id}}</span> <span flex=\"20\" md-truncate=\"\">{{student.status_name}}</span> <span flex=\"10\"><md-button class=\"md-icon-button\" flex=\"\" ng-if=\"student.status_id == vm.MATRICULA_CONDICIONAL || student.status_id == vm.AGUARDANDO_ASSINATURA_ONLINE\" ng-click=\"vm.confirmEnrolment(student)\"><md-tooltip md-direction=\"top\">Confirmar matrícula</md-tooltip><md-icon md-font-icon=\"icon-check-circle\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-if=\"student.status_id != vm.MATRICULA_CONDICIONAL && student.status_id != vm.AGUARDANDO_ASSINATURA_ONLINE\" ng-click=\"vm.openModal(student)\" flex=\"\"><md-tooltip md-direction=\"top\">Imprimir documentos</md-tooltip><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></span></md-list-item></md-list></md-card></md-content></div>");
$templateCache.put("app/educational/re-enrollment/view.html","<div ui-view=\"reEnrollment\"></div>");
$templateCache.put("app/educational/report-generation/all.html","<central-reports-generate-directive withbackward=\"false\" is-educational=\"true\"></central-reports-generate-directive>");
$templateCache.put("app/educational/report-generation/index.html","<div ui-view=\"report-generation\"></div>");
$templateCache.put("app/educational/statistics/index.html","<div id=\"page-material-table\" class=\"bill-receipt page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke !important;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-poll\" class=\"s24\"></md-icon></span> <span class=\"logo-text md-primary md-hue-1\">Estatísticas</span></div></div><div layout-align=\"start end\"><md-button ng-click=\"vm.openChartsConfig()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-tooltip>Configuracao das esteatisticas</md-tooltip></md-button></div></md-toolbar><md-tabs md-selected=\"selectedTab\" md-center-tabs=\"\" md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab id=\"course\" label=\"Por Curso\" ng-click=\"vm.blankOptions(selectedTab)\"></md-tab><md-tab id=\"group\" label=\"Por Turma\" ng-click=\"vm.blankOptions(selectedTab)\"></md-tab><md-tab id=\"subject\" label=\"Por Diciplina\" ng-click=\"vm.blankOptions(selectedTab)\"></md-tab><md-tab id=\"event\" label=\"Por Evento\" ng-click=\"vm.blankOptions(selectedTab)\"></md-tab></md-tabs><md-card layout-padding=\"\"><md-input-container style=\"width: 45%; margin-left: 7px; margin-top: 10px\" ng-if=\"selectedTab > 1\"><label>Curso</label><md-select ng-model=\"vm.course_selected\" ng-change=\"vm.getGroupsBycourse(vm.course_selected.id, selectedTab)\"><md-option ng-value=\"0\" ng-if=\"(vm.courses[0] !== undefined || vm.courses[1] !== undefined) && selectedTab > 1\">Todos os cursos</md-option><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container style=\"width: 45%; margin-left: 7px; margin-top: 10px\" ng-if=\"selectedTab > 1\"><label>Turma</label><md-select ng-model=\"vm.group_selected\" ng-change=\"vm.getGradeOrSubjects(vm.group_selected.id, selectedTab)\"><md-option ng-value=\"0\" ng-if=\"vm.groups[1] !== undefined || vm.course_selected == 0\">Todas as turmas</md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group\">{{group.name}}</md-option></md-select></md-input-container><md-input-container style=\"width: 45%; margin-left: 7px; margin-top: 10px\" ng-if=\"selectedTab !== 3\"><label>Critério</label><md-select ng-model=\"vm.grade_rule_selected\" ng-change=\"vm.getEventByGradeRule()\"><md-option ng-repeat=\"grade_rule in vm.grade_rules\" ng-value=\"grade_rule\">{{grade_rule.name}}</md-option></md-select></md-input-container><md-input-container style=\"width: 45%; margin-left: 7px; margin-top: 10px\" ng-if=\"selectedTab !== 3\"><label>Evento</label><md-select ng-model=\"vm.event_selected\"><md-option ng-repeat=\"event in vm.grade_rule_items\" ng-value=\"event\">{{event.name}}</md-option></md-select></md-input-container><md-input-container style=\"width: 45%; margin-left: 7px; margin-top: 10px\" ng-if=\"selectedTab !== 2\"><label>Diciplina</label><md-select ng-model=\"vm.subject_selected\" ng-change=\"vm.getEventBySubject(vm.subject_selected.id)\"><md-option ng-value=\"0\">Todas as diciplinas</md-option><md-option ng-repeat=\"subject in vm.subjects\" ng-value=\"subject\">{{subject.name}}</md-option></md-select></md-input-container></md-card><md-card layout-padding=\"\"><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.submit(selectedTab)\"><md-icon>search</md-icon>Aplicar</md-button></div></md-card><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" ng-if=\"vm.data_view\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\" flex=\"\" layout-align=\"center center\" style=\"margin-left: 35%\">{{vm.title}}<md-button ng-click=\"vm.printChart(selectedTab)\"><md-icon>print</md-icon><md-tooltip>Imprimir</md-tooltip></md-button></div><md-divider></md-divider><a4-charts-bar flex=\"\" educational=\"true\" labels=\"vm.chart.labels\" data=\"vm.data_view\" series=\"vm.series\" colors=\"vm.colors\" custom-axis=\"true\"></a4-charts-bar></ms-widget-front></ms-widget></div>");
$templateCache.put("app/educational/statistics/statistics-config-modal.html","<md-dialog aria-label=\"Upload\" style=\"width: 500px;\" md-theme=\"educational\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span>Configuracoes</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content>Intervalos percentuais:<div layout=\"row\" style=\"width: 100%;\" layout-aling=\"space-between\"><div layout=\"column\"><div style=\"width: 30px; height: 15px; border: solid #8c0000; background-color: #E8CCCC; text-align: center;\"></div><div style=\"text-align: center\">De</div><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin: 10px; padding:0\"><input type=\"text\" ng-model=\"vm.ranges[0].limit_from\" ng-change=\"vm.checkLimit(\'vm.ranges[0].limit_from\')\" ui-percentage-mask=\"2\" max=\"100\"> <span ng-show=\"vm.limitError\" class=\"error-message\">Valor deve ser um número até 100 com no máximo 2 decimais.</span></md-input-container><div style=\"text-align: center\">a</div><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin: 10px; padding:0\"><input type=\"text\" ng-model=\"vm.ranges[0].limit_to\" ng-change=\"vm.checkLimit(\'vm.ranges[0].limit_to\')\" ui-percentage-mask=\"2\" max=\"100\"></md-input-container></div><div><div style=\"width: 30px; height: 15px; border: solid #000a9a; background-color: #cccee8; text-align: center;\"></div><div style=\"text-align: center\">De</div><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin: 10px; padding:0\"><input type=\"text\" ng-model=\"vm.ranges[1].limit_from\" ng-change=\"vm.checkLimit(\'vm.ranges[1].limit_from\')\" ui-percentage-mask=\"2\" max=\"100\" min=\"0\"></md-input-container><div style=\"text-align: center\">a</div><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin: 10px; padding:0\"><input type=\"text\" ng-model=\"vm.ranges[1].limit_to\" ng-change=\"vm.checkLimit(\'vm.ranges[1].limit_to\')\" ui-percentage-mask=\"2\" max=\"100\" min=\"0\"></md-input-container></div><div><div style=\"width: 30px; height: 15px; border: solid #009a00; background-color: #cce8cc; text-align: center;\"></div><div style=\"text-align: center\">De</div><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin: 10px; padding:0\"><input type=\"text\" ng-model=\"vm.ranges[2].limit_from\" ng-change=\"vm.checkLimit(\'vm.ranges[2].limit_from\')\" ui-percentage-mask=\"\" max=\"100\"></md-input-container><div style=\"text-align: center\">a</div><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\" style=\"margin: 10px; padding:0\"><input type=\"text\" ng-model=\"vm.ranges[2].limit_to\" ng-change=\"vm.checkLimit(\'vm.ranges[2].limit_to\')\" ui-percentage-mask=\"2\" max=\"100\"></md-input-container></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.submit()\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/evaluations/dashboard/dashboard.html","<div><md-button policy-access=\"private.evaluations.dashboard.create\" class=\"md-primary\">Access</md-button></div>");
$templateCache.put("app/finance/a4pag/index.html","<style>\n  .content-card-a4pag > p {\n    font-size: 17px;\n    width: 80%;\n    margin: 0 auto;\n    text-align: justify;\n  }\n</style><div layout=\"column\" ng-style=\"{height: vm.windowHeight}\" ng-if=\"!vm.has_a4pag_account\"><div layout=\"row\" flex=\"\" style=\"background-image: url(\'../assets/images/backgrounds/wallpaperpag.jpg\'); background-size: cover; background-position:center; width: 100%; height: 500px;\"></div><div layout=\"row\" flex=\"\" style=\"width: 100%;\"><md-card style=\"margin: 0 auto;margin-top: -166px;z-index: 9999;max-width: 980px;text-align: center;margin-bottom: 40px;height: 750px;\"><img ng-src=\"{{vm.imagePath}}\" class=\"md-card-image\" alt=\"Washed Out\"><md-card-title><md-card-title-text><span class=\"md-headline\">Bem vindo ao <b>A4Pag</b></span></md-card-title-text></md-card-title><md-card-content class=\"content-card-a4pag\"><p>Mais facilidade e economia para gerenciar a sua cobrança.</p><br><p>O <b>A4Pag</b> é um serviço de intermediação de recebimentos operado diretamente pela A4 Tecnologia. Ao utilizar essa plataforma de cobrança, você simplesmente emite seus boletos e o sistema cuida de todo o resto.</p><br><p>Em poucos minutos os boletos estarão registrados e disponíveis para pagamento através da compensação bancária. Com acompanhamento em tempo real, o A4Pag atualiza o sistema financeiro da escola com os dados de recebimentos. <b>Você terá CONTROLE total e os valores da cobrança são creditados diretamente em sua conta corrente.</b> Tudo isso sem precisar contratar uma carteira de cobrança no seu banco.</p><br><p><b>Além de tarifas MENORES</b>, você também vai economizar pela redução no tempo gasto nas rotinas de cobrança e nos possiveis erros é desconfortos com seus clientes.</p><br><p>Se você deseja realizar matrículas e cobranças on line, essa deve ser a sua escolha. Não perca mais tempo e dinheiro com o modelo tradicional de cobrança bancária!</p><br><p>Clique no botão abaixo e aguarde o contato do nosso representante. Ele irá esclarecer todas as dúvidas e preparar o ambiente A4Pag para você começar a economizar...</p><br></md-card-content><md-card-actions layout=\"row\" layout-align=\"center center\"><md-button style=\"background-color: #069b59; color: white; padding: 10px; margin-bottom: 20px; width: 300px; font-size: 20px;\" ng-disabled=\"vm.loading\" ng-click=\"vm.membership()\">Solicitar adesão</md-button></md-card-actions></md-card></div></div><div ng-if=\"vm.has_a4pag_account\"><div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-window-restore\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Painel de Controle A4Pag</span></div></div></md-toolbar><md-content style=\"background-color: whitesmoke !important;\"><md-card ng-click=\"vm.openModalBankSlipsProblems()\" style=\"cursor: pointer\"><md-content layout=\"row\"><div style=\"background-color: rgb(113, 0, 216); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 30px;\"></i> <span style=\"font-size: 18px; color: #fff;\"><br>Existem boletos com informações pendentes que impedem seu registro: <span ng-if=\"vm.data.count_error_national_id_number > 0\"><br>- Sem CPF/CNPJ: {{vm.data.count_error_national_id_number}}</span> <span ng-if=\"vm.data.count_error_address_postal_code > 0\"><br>- Sem CEP no endereço: {{vm.data.count_error_address_postal_code}}</span> <span ng-if=\"vm.data.count_error_address_postal_code_invalid > 0\"><br>- CEP do endereço inválido: {{vm.data.count_error_address_postal_code_invalid}}</span> <span ng-if=\"vm.data.count_error_address_house_number > 0\"><br>- Sem número no endereço: {{vm.data.count_error_address_house_number}}</span> <span ng-if=\"vm.data.count_error_address_street > 0\"><br>- Sem logradouro no endereço: {{vm.data.count_error_address_street}}</span> <span ng-if=\"vm.data.count_error_address_district > 0\"><br>- Sem bairro no endereço: {{vm.data.count_error_address_district}}</span> <span ng-if=\"vm.data.count_error_address_city > 0\"><br>- Sem cidade no endereço: {{vm.data.count_error_address_city}}</span> <span ng-if=\"vm.data.count_error_address_state > 0\"><br>- Sem estado no endereço: {{vm.data.count_error_address_state}}</span><br>Existem boletos com informações pendentes: <span ng-if=\"vm.data.count_alert_fine_value > 0\"><br>- Sem valor de multa definido: {{vm.data.count_alert_fine_value}}</span> <span ng-if=\"vm.data.count_alert_interest_value > 0\"><br>- Sem valor de juros definido: {{vm.data.count_alert_interest_value}}</span> <span ng-if=\"vm.data.count_alert_discounts > 0\"><br>- Sem valor de desconto definido: {{vm.data.count_alert_discounts}}</span></span></p></div></md-content></md-card><div flex-xs=\"\" flex-gt-xs=\"33\" layout=\"column\"></div></md-content></div></div>");
$templateCache.put("app/finance/contract/contract.html","<a4-contract-grid ng-model=\"vm.allContracts\" paginate-function=\"vm.getAllContracts(page, qtd, search_name)\" debit-credit=\"C\"></a4-contract-grid>");
$templateCache.put("app/finance/contract/modal-edit.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\" style=\"min-width: 700px\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Contrato</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\"><div class=\"alert alert-warning\" ng-if=\"vm.contract.update_type == 0\"><strong>ATENÇÃO!</strong> As alterações feitas irão afetar todos os títulos do contrato, <b>EXCETO</b> os <b>PAGOS</b>.</div></div><form novalidate=\"\" name=\"bill_form\" ng-submit=\"vm.submit(bill_form, vm.contract, files, $event)\"><div class=\"form-wrapper md-padding\" ng-init=\"vm.init();\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"GERAL\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 30px; margin-top: 10px\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Dados Gerais</b> <small>Abaixo encontram-se os dados gerais do contrato</small></div></div><div layout=\"column\" layout-align=\"start\" flex=\"\"><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Produto</label> <input type=\"text\" ng-value=\"vm.contract.product_name\" ng-disabled=\"true\" maxlength=\"150\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Contratante</label> <input type=\"text\" ng-value=\"vm.contract.person_name\" ng-disabled=\"true\" maxlength=\"150\"></md-input-container><date-picker ng-model=\"vm.contract.date_first\" disabled=\"true\" placeholder=\"Inicio do contrato\"></date-picker></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>{{ \'BILL_RECEIPT.REFERENCE\' | translate}}</label> <input type=\"text\" ng-model=\"vm.currentItem.document_reference\" maxlength=\"20\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Dia preferêncial de vencimento</label><md-select ng-model=\"vm.contract.preferential_due_day\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.days\">{{ item.label }}</md-option></md-select></md-input-container></div></div></md-tab><md-tab label=\"DESCONTOS INDIVIDUAIS\"><md-content><md-table-container><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Razão</th><th md-column=\"\">Desconto</th><th md-column=\"\">F/C</th><th md-column=\"\">De</th><th md-column=\"\">Até</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.contract.individual_discounts\"><td md-cell=\"\">{{ item.discount_reason.name }}</td><td md-cell=\"\">{{ item.value_type == 1 ? \"% \" + item.amount : \"R$ \" + item.amount }}</td><td md-cell=\"\">{{ item.is_fixed ? \'F\' : \'C\' }}</td><td md-cell=\"\">{{ item.start_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\">{{ item.end_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeItemDesconto($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-button class=\"md-primary\" aria-label=\"Novo Desconto\" style=\"margin-left: 15px\" ng-click=\"vm.createNewIndividualDiscount()\">Adicionar desconto<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-content></md-tab></md-tabs><div layout=\"row\" layout-align=\"start\" flex=\"\"><div flex=\"50\"><upload-files files=\"vm.currentItem.files\"></upload-files></div><div flex=\"20\"><md-button type=\"submit\" class=\"md-raized md-primary fileinput-upload fileinput-upload-button\">Salvar</md-button></div><div flex=\"20\"><md-button type=\"button\" class=\"btn md-primary md-raized default bt-cancel\">Cancelar</md-button></div></div><div class=\"md-api-table\" ng-if=\"vm.currentItem.files.length > 0\"><table class=\"table\"><thead><tr ng-if=\"vm.artifact!=0\"><th>Nome</th><th>Ações</th></tr></thead><tbody><tr ng-repeat=\"file in vm.currentItem.files\" ng-if=\"file.origin == 2 && (vm.currentItem.edit_expense == 3)\" ng-init=\"vm.artifact = 1\"><td>{{file.name}}.{{file.extension}}</td><td><a type=\"button\" class=\"btn btn-default btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Visualizar\" placement=\"top\" href=\"{{file.file_reference{{\" target=\"_blank\"><i class=\"fa fa-eye\"></i></a> <a type=\"button\" class=\"btn btn-info btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Baixar\" placement=\"top\" href=\"{{file.file_reference{{\" download=\"\"><i class=\"fa fa-download\"></i></a> <span ng-if=\"vm.currentItem.edit_expense != \'undefined\'\"><a type=\"button\" class=\"btn btn-danger btn-circle\" data-toggle=\"tooltip\" ng-if=\"file.origin == 2 && (vm.currentItem.edit_expense == 3)\" tooltip-hint=\"Apagar\" placement=\"top\" ng-click=\"vm.deleteArtifact(file)\"><i class=\"fa fa-trash\"></i></a></span></td></tr><tr ng-repeat=\"file in vm.currentItem.files\" ng-if=\"(vm.currentItem.edit_expense == 1)\" ng-init=\"vm.artifact = 2\"><td>{{file.name}}.{{file.extension}}</td><td><a type=\"button\" class=\"btn btn-default btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Visualizar\" placement=\"top\" href=\"{{file.file_reference{{\" target=\"_blank\"><i class=\"fa fa-eye\"></i></a> <a type=\"button\" class=\"btn btn-info btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Baixar\" placement=\"top\" href=\"{{file.file_reference{{\" download=\"\"><i class=\"fa fa-download\"></i></a> <span ng-if=\"vm.currentItem.edit_expense !=\'undefined\'\"><a type=\"button\" class=\"btn btn-danger btn-circle\" data-toggle=\"tooltip\" ng-if=\"file.origin == 2 && (vm.currentItem.edit_expense == 3)\" tooltip-hint=\"Apagar\" placement=\"top\" ng-click=\"vm.deleteArtifact(file)\"><i class=\"fa fa-trash\"></i></a> <a type=\"button\" class=\"btn btn-danger btn-circle\" data-toggle=\"tooltip\" ng-if=\"file.origin == 1 && (vm.currentItem.edit_expense == 1)\" tooltip-hint=\"Apagar\" placement=\"top\" ng-click=\"vm.deleteArtifact(file)\"><i class=\"fa fa-trash\"></i></a></span></td></tr><tr ng-repeat=\"file in vm.currentItem.files\" ng-if=\"(vm.currentItem.edit_expense == 4)\" ng-init=\"vm.artifact = 2\"><td>{{file.name}}.{{file.extension}}</td><td><md-button class=\"md-raised\" href=\"{{file.file_reference}}\"><i class=\"fa fa-eye\"></i></md-button><a type=\"button\" class=\"btn btn-default btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Visualizar\" placement=\"top\" href=\"{{file.file_reference}}\" target=\"_blank\"><i class=\"fa fa-eye\"></i></a> <a type=\"button\" class=\"btn btn-info btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Baixar\" placement=\"top\" href=\"{{file.file_reference}}\" download=\"\"><i class=\"fa fa-download\"></i></a> <span ng-if=\"vm.currentItem.edit_expense !=\'undefined\'\"><a type=\"button\" class=\"btn btn-danger btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Apagar\" placement=\"top\" ng-click=\"vm.deleteArtifact(file)\"><i class=\"fa fa-trash\"></i></a></span></td></tr></tbody></table></div></div></form></md-dialog>");
$templateCache.put("app/finance/dashboard/dashboard.html","<div flex=\"\"><div class=\"widget-group\" layout=\"column\" flex=\"100\" layout-wrap=\"\" policy-access=\"info_gerenciais\"><div layout=\"row\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">Situação dos títulos por mês de vencimento</div><md-divider></md-divider><div class=\"p-16\"><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.date_range\" label=\"Faixa de datas do gráfico\" ng-change=\"vm.init()\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker><a4-charts-bar flex=\"\" educational=\"true\" labels=\"vm.chart_billingDefault.labels\" series=\"vm.chart_billingDefault.series\" data=\"vm.chart_billingDefault.data\" colors=\"vm.chart_billingDefault.colors\"></a4-charts-bar></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">Recebimentos por mês</div><md-divider></md-divider><div class=\"p-16\"><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.date_range\" label=\"Faixa de datas do gráfico\" ng-change=\"vm.init()\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker><a4-charts-bar flex=\"\" educational=\"true\" labels=\"vm.chart_receiptsPerMonth.labels\" series=\"vm.chart_receiptsPerMonth.series\" data=\"vm.chart_receiptsPerMonth.data\" colors=\"vm.chart_receiptsPerMonth.colors\" totals=\"vm.chart_receiptsPerMonth.totals\"></a4-charts-bar></div></ms-widget-front></ms-widget></div><div layout=\"row\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"65\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">Recebimentos por dia</div><md-divider></md-divider><md-input-container><label>Selecione o mês</label><md-select ng-model=\"vm.selectedMonth\" ng-change=\"vm.receiptsPerDay()\"><md-option ng-repeat=\"month in vm.months\" ng-value=\"month.id\">{{month.name}}</md-option></md-select></md-input-container><div class=\"p-16\"><a4-charts-bar flex=\"\" educational=\"true\" labels=\"vm.chart_receiptsPerDay.labels\" series=\"vm.chart_receiptsPerDay.series\" data=\"vm.chart_receiptsPerDay.data\" colors=\"vm.chart_receiptsPerDay.colors\"></a4-charts-bar></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/finance/main/main.html","<div ui-view=\"\"></div>");
$templateCache.put("app/finance/nfse/alertTownHall.html","<md-dialog aria-label=\"Consultando SEFAZ\" md-theme=\"finance\" style=\"width: 500px; max-width: 500px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color: #fff;\">Estabelecendo comunicação...</h2></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><h2>Aguarde a finalização do processo de comunicação com a SEFAZ</h2></div><md-progress-linear md-mode=\"query\"></md-progress-linear></md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/nfse/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-view-carousel\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Nota fiscal eletrônica</span></div></div></md-toolbar><md-card ng-if=\"(vm.currentCompany.nfse_certificate_exists && !vm.currentCompany.nfse_em_producao) && vm.show_contents\"><md-content layout=\"row\"><div style=\"background-color: rgb(8,204,117); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 60px;\"></i><br><span style=\"font-size: 25px; color: #fff;\">Seu NFS-e está configurado em modo de homologação.</span></p><p><span style=\"font-size: 18px; color: #fff;\">As notas fiscais emitidas neste modo, serão apenas para efeito de TESTE</span></p><p><span style=\"font-size: 18px; color: #fff;\">Favor contatar a A4/Simetria para ativar o modo de produção</span></p></div></md-content></md-card><md-card layout=\"row\" class=\"md-padding\" ng-if=\"!vm.currentCompany.nfse_certificate_exists && vm.show_contents\" style=\"background-color: whitesmoke; padding: 0;\"><div style=\"background-color: rgb(8,204,117); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;margin-top: 23px;\"><i class=\"icon icon-close-circle\" style=\"color: #fff;font-size: 60px !important;\"></i><br><span style=\"font-size: 25px; color: #fff;\">Não identificamos a presença de um Certificado Digital A1 no sistema.</span></p><p><span style=\"font-size: 18px; color: #fff;\">Para o importar um Certificado Digital, no menu lateral, vá em Configurações > Configurações da Empresa > Importar Certificado A1</span></p></div></md-card><md-card ng-if=\"(vm.currentCompany.nfse_certificate_exists && vm.currentCompany.nfse_em_producao) && vm.show_contents && vm.currentCompany.nfse_certificate_days_to_expire <= 30\"><md-content layout=\"row\"><div style=\"background-color: rgb(8,204,117); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 60px;\"></i><br><span style=\"font-size: 25px; color: #fff;\" ng-if=\"vm.currentCompany.nfse_certificate_days_to_expire > 0\">Faltam {{vm.currentCompany.nfse_certificate_days_to_expire}} dias para expirar o certificado digital</span> <span style=\"font-size: 25px; color: #fff;\" ng-if=\"vm.currentCompany.nfse_certificate_days_to_expire < 0\">Seu certificado expirou à {{vm.currentCompany.nfse_certificate_days_to_expire * (-1)}} dias.</span></p><p><span style=\"font-size: 18px; color: #fff;\">Por favor, procure o pessoal responsável para a emissão de um novo.</span></p><p><span style=\"font-size: 18px; color: #fff;\">Lembre-se, sem ele não é possível emitir as notas fiscais</span></p></div></md-content></md-card><md-card><div layout=\"column\" class=\"md-padding\" ng-if=\"vm.currentCompany.nfse_certificate_exists && vm.show_contents\" style=\"background-color: #fff\"><div flex=\"\" ng-if=\"vm.currentCompany.nfse_certificate_days_to_expire <= 300\"></div><div layout=\"row\"><md-input-container flex=\"\"><label>Competência</label><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-select ng-model=\"vm.competence\" ng-change=\"vm.changeListNfe(vm.competence.month, vm.competence.year, vm.service.id);vm.product_groups=[];vm.product_group=null;vm.selected_products=null\"><md-option ng-repeat=\"item in vm.competences\" ng-value=\"item\">{{item.competence_text}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Pesquisar por Nome/Razão Social</label><md-icon md-font-icon=\"icon-account\"></md-icon><input type=\"text\" ng-model=\"vm.search\" autocomplete=\"off\" ng-change=\"vm.changeListNfe(vm.competence.month, vm.competence.year, vm.selected_products)\" translate=\"\" ng-model-options=\"{debounce: 1000}\"></md-input-container><md-button class=\"md-accent md-raised\" ng-click=\"vm.storeNfseByFilter(vm.competence.month, vm.competence.year, vm.selected_products)\" ng-if=\"vm.selected.length <= 0\" ng-disabled=\"$rootScope.show_loader || (vm.product_group.id != null && vm.selected_products == null)\">Emitir todas as {{vm.bill_list.total}} NF\'s {{(vm.search != null && vm.search != \'\') || vm.selected_products != null ? \' do filtro\' : \'\'}}</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.sendData(vm.selected)\" ng-if=\"vm.selected.length > 0\" ng-disabled=\"$rootScope.show_loader || (vm.product_group.id != null && vm.selected_products == null)\">Enviar {{vm.selected.length}} NF\'s selecionadas</md-button></div><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Curso e Turma</b> <small><b>ATENÇÃO</b> o período letivo selecionado no educacional interfere na busca de notas fiscais utilizando as opções abaixo. Período letivo selecionado: <b>{{vm.school_period.name}}</b></small></div></div><div flex=\"\" layout=\"row\" class=\"md-padding\"><md-input-container flex=\"30\" class=\"md-block md-input-has-placeholder\" ng-required=\"vm.bankslipgroup.bank_slip_rule_id === null\"><label>Curso</label><md-icon md-font-icon=\"icon-group\"></md-icon><md-select name=\"group_service_list\" ng-model=\"vm.product_group\" aria-label=\"Curso\" md-on-open=\"vm.allProductGroups()\" ng-change=\"vm.getProductsByGroup(vm.product_group); vm.selected_products = null\"><md-optgroup label=\"Curso\"><md-option ng-repeat=\"product_group in vm.product_groups track by $index\" ng-value=\"product_group\">{{product_group.name}}</md-option></md-optgroup></md-select><div ng-messages=\"bankslipform.group_service_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um grupo de serviço.</div></div></md-input-container><md-input-container flex=\"50\" class=\"md-block md-input-has-placeholder\"><label>Turma</label><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><md-select name=\"service_list\" ng-model=\"vm.selected_products\" multiple=\"\" ng-disabled=\"vm.product_group.id == null\" ng-change=\"vm.changeListNfe(vm.competence.month, vm.competence.year, vm.selected_products)\" aria-label=\"turmas\"><md-optgroup label=\"Turmas\"><md-option ng-repeat=\"product in vm.products track by $index\" ng-value=\"product.product_id\">{{product.product_name}}</md-option></md-optgroup></md-select><div ng-messages=\"bankslipform.service_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um ou mais turmas.</div></div></md-input-container></div></div><div class=\"content layout-column\" ng-if=\"vm.currentCompany.nfse_certificate_exists && vm.show_contents\" layout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><form><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-swipe-content=\"true\" md-selected=\"vm.selected_tab\"><md-tab label=\"Emissão de notas\" policy-access=\"nf_alt\" md-active=\"vm.active_first\" md-on-select=\"vm.getBillstoNfse()\"><md-content class=\"md-padding\"><md-table-container><table md-table=\"\" md-row-select=\"vm.today.diff(vm.competence.last_day, \'days\') <= 4 && vm.today.diff(vm.competence.last_day, \'days\') > -31\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Tomador</th><th md-column=\"\">Serviço</th><th md-column=\"\" md-numeric=\"\">Valor</th><th md-column=\"\">Data de Vencimento</th><th md-column=\"\">Data de Pagamento</th><th md-column=\"\">Avisos</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-select-id=\"bill_id_event\" md-auto-select=\"\" ng-disabled=\"item.note !== \'\'\" style=\"cursor: pointer\" ng-init=\"bill_id_event = item.bill_id + \'_\' + item.bill_event_id\" ng-repeat=\"item in vm.bill_list.data\"><td md-cell=\"\">{{item.name_display || item.name}}<br><small ng-if=\"item.name_display != null\">{{item.name}}</small></td><td md-cell=\"\">{{item.product_name}}</td><td md-cell=\"\" md-numeric=\"\">{{item.nfse_amount | currency}}</td><td md-cell=\"\">{{item.due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{item.settlement_date | date:\'dd/MM/yyyy\'}} <span class=\"bill-status PARCIALMENTE_PAGO\" ng-if=\"item.is_partial_payment == 1\" style=\"margin-left: 3px\"><md-tooltip md-direction=\"top\">Pago parcial</md-tooltip>PP</span> <span class=\"bill-status A_VENCER\" ng-if=\"item.is_partial_payment == 2\" style=\"margin-left: 3px\"><md-tooltip md-direction=\"top\">Pagamento final (PP)</md-tooltip>PF</span></td><td md-cell=\"\"><div ng-if=\"item.note !== \'\'\" style=\"color: red\">{{item.note}}</div></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.bill_list.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.bill_list.current_page\" md-total=\"{{vm.bill_list.total}}\" md-on-paginate=\"vm.paginateRequest\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></md-content></md-tab><md-tab label=\"Consulta de Notas\" md-on-select=\"vm.getAllInvoices(1, 20, vm.competence.month, vm.competence.year, undefined, vm.search)\"><md-content class=\"md-padding\"><md-table-container><table md-table=\"\" md-progress=\"vm.promiseNFSE\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Tomador</th><th md-column=\"\">Serviço</th><th md-column=\"\" md-numeric=\"\">Valor da Nota</th><th md-column=\"\">Data de Vencimento</th><th md-column=\"\">Data de Pagamento</th><th md-column=\"\" md-numeric=\"\">Número Nota</th><th md-column=\"\">Status</th><th md-column=\"\"><md-button class=\"md-raised md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.printInvoiceReport(vm.competence.month, vm.competence.year)\" aria-label=\"add\" translate=\"\"><md-tooltip md-direction=\"left\">{{ \'REPORTS.PRINT\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-printer\" style=\"color: green\"></md-icon></md-button></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.invoices.data\" ng-disabled=\"item.national_id_number == null || vm.checkPolicies(\'nf\')\"><td md-cell=\"\">{{item.name_display || item.name}}<br><small ng-if=\"item.name_display != null\">{{item.name}}</small></td><td md-cell=\"\">{{item.product_name}}</td>\'<td md-cell=\"\" md-numeric=\"\">{{item.nfse_amount | currency}}</td><td md-cell=\"\">{{item.due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{item.settlement_date | date:\'dd/MM/yyyy\'}} <span class=\"bill-status PARCIALMENTE_PAGO\" ng-if=\"item.is_partial_payment == 1\" style=\"margin-left: 3px\"><md-tooltip md-direction=\"top\">Pago parcial</md-tooltip>PP</span> <span class=\"bill-status A_VENCER\" ng-if=\"item.is_partial_payment == 2\" style=\"margin-left: 3px\"><md-tooltip md-direction=\"top\">Pagamento final (PP)</md-tooltip>PF</span></td><td md-cell=\"\" md-numeric=\"\">{{item.nf_number}}</td><td md-cell=\"\"><span class=\"badge\"><span class=\"{{item.invoice_status}}\" title=\"{{item.error_message ? item.error_message : \'\'}}\">{{item.invoice_status}}{{item.invoice_status == \'Emitindo\' || item.invoice_status == \'Cancelando\' ? \'...\' : \'\'}}</span></span></td><td md-cell=\"\"><md-button target=\"_blank\" href=\"{{vm.CONFIG.nota_fiscal[vm.currentCompany.nfse_em_producao ? \'producao\': \'homologacao\']}}?nf={{item.nf_number}}&inscricao={{item.municipal_registration_number}}&verificacao={{item.nf_code}}\" ng-if=\"vm.currentCompany.city_id != 921 && (item.invoice_batch_status == 4 || item.invoice_batch_status == 5)\">Ver nota</md-button><md-button ng-click=\"vm.printInvoice(item)\" ng-disabled=\"item.invoice_status == \'Emitindo\'\" ng-if=\"vm.currentCompany.city_id == 921 && (item.invoice_batch_status == 4 || item.invoice_batch_status == 5 || item.invoice_batch_status == 6) && item.invoice_status_id == 1\">Ver nota</md-button><span ng-if=\"item.invoice_batch_status == 0\">Status 0 - ENVIADO SEM RESPOSTA</span> <span ng-if=\"item.invoice_batch_status == 1\">Status 1 - RECEBIDO_COM_ERRO</span> <span ng-if=\"item.invoice_batch_status == 2\">Status 2 - RECEBIDO_COM_SUCESSO</span> <span ng-if=\"item.invoice_batch_status == 9\">Status 9 - RECEBIDO_COM_MENSAGEM_DESCONHECIDA</span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.invoices.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.invoices.current_page\" md-total=\"{{vm.invoices.total}}\" md-on-paginate=\"vm.getAllInvoices\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></md-content></md-tab></md-tabs></md-content></form></div></div></md-card></div>");
$templateCache.put("app/finance/report-generation/all.html","<central-reports-generate-directive withbackward=\"false\" is-finance=\"true\"></central-reports-generate-directive>");
$templateCache.put("app/finance/report-generation/index.html","<div ui-view=\"report-generation\"></div>");
$templateCache.put("app/fmd/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-server\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FMD.TITLE\"></span></div></div></md-toolbar><div class=\"content layout-column\"><form enctype=\"multipart/form-data\" ng-submit=\"vm.sendFile(vm.file)\"><div class=\"alert alert-warning\" ng-if=\"vm.success == false\">Ocorreu algum <strong>erro</strong> durante o processo</div><div class=\"alert alert-success\" ng-if=\"vm.success == true\">Migração realizada com <strong>sucesso!</strong></div><div layout=\"row\"><div flex=\"50\"><md-input-container flex=\"\" class=\"md-block\" md-no-float=\"\"><input type=\"file\" file-read=\"\" ng-model=\"vm.file\"></md-input-container></div><div flex=\"25\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">{{\"FMD.SEND\" | translate}}</md-button></div></div></form><md-content><div ng-if=\"vm.errors.length > 0\"><md-table-container><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Mensagem de Erro</span></th><th md-column=\"\"><span>Nome no Registro</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"error in vm.errors\"><td md-cell=\"\">{{error.code_message}}</td><td md-cell=\"\">{{error.item.pessoa_nome}}</td></tr></tbody></table></md-table-container></div></md-content></div></div>");
$templateCache.put("app/log/views/details.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Detalhamento</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 100px; min-width: 400px;\" layout=\"column\" flex=\"\"><div flex=\"100\" layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-desktop-tower\"></md-icon><label>Nome do usuário</label> <input ng-model=\"vm.scope.person_name\"></md-input-container></div><div flex=\"100\" layout=\"row\"><md-input-container flex=\"50\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-desktop-tower\"></md-icon><label>IP de acesso</label> <input ng-model=\"vm.scope.ip\"></md-input-container><md-input-container flex=\"50\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-cellphone-link\"></md-icon><label>Nome do computador</label> <input ng-model=\"vm.scope.computer_name\"></md-input-container><md-input-container flex=\"50\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-map-marker-radius\"></md-icon><label>Latitude</label> <input ng-model=\"vm.scope.latitude\"></md-input-container><md-input-container flex=\"50\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-map-marker-radius\"></md-icon><label>Longitude</label> <input ng-model=\"vm.scope.longitude\"></md-input-container></div><md-card flex=\"100\" ng-if=\"vm.scope.log_name != \'login\' && (vm.scope.log_name != \'ctspag_liquid\' && vm.scope.log_name != \'ctsrec_liquid\')\"><md-card-title style=\"padding: 6px 16px 0px;\"><md-card-title-text><span class=\"md-headline\" style=\"font-size: 20px\">Detalhes do log</span></md-card-title-text></md-card-title><md-table-container layout-padding=\"\"><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Campo</th><th md-column=\"\">Valor atual</th><th md-column=\"\" ng-if=\"vm.scope.properties.old != null\">Valor anterior</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"(index, value) in vm.scope.properties.attributes\"><td md-cell=\"\">{{index}}</td><td md-cell=\"\">{{vm.scope.properties.attributes[index]}}</td><td md-cell=\"\" ng-if=\"vm.scope.properties.old != null\">{{vm.scope.properties.old[index]}}</td></tr></tbody></table></md-table-container></md-card><md-card ng-if=\"vm.scope.log_name == \'ctspag_liquid\' || vm.scope.log_name == \'ctsrec_liquid\'\"><md-card-title style=\"padding: 6px 16px 0px;\"><md-card-title-text><span class=\"md-headline\" style=\"font-size: 20px\">Detalhes do log</span></md-card-title-text></md-card-title><md-table-container layout-padding=\"\"><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Campo</th><th md-column=\"\">Valor</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"(index, value) in vm.scope.properties.attributes\"><td md-cell=\"\">{{index == 0 ? \'Título\' : index}}</td><td md-cell=\"\"><pre>{{vm.scope.properties.attributes[index] | json}}</pre></td></tr></tbody></table></md-table-container></md-card></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/log/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"LOG.TITLE\"></span></div></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Logs de atividade\" md-on-select=\"vm.init()\"><md-content style=\"background-color: whitesmoke !important;\"><md-card layout=\"column\" layout-padding=\"\"><md-content layout=\"row\" style=\"padding-top: 0;padding-bottom: 0;\"><md-input-container class=\"md-input-has-placeholder\" flex=\"20\" flex-sm=\"35\" flex-md=\"30\" flex-xs=\"100\" style=\"height: 36px;margin-top: 30px\"><md-icon md-font-icon=\"icon-account-outline\"></md-icon><select-dropdown title=\"Usuários\" placeholder=\"Procure um usuário\" selected-items=\"vm.selected_users\" ng-model=\"vm.users_filter\"></select-dropdown></md-input-container><div flex=\"25\" flex-sm=\"70\" flex-md=\"70\" flex-xs=\"100\" style=\"margin: 18px 0;\"><date-range-picker ng-model=\"vm.filter_date\" label=\"Datas\" time-picker=\"true\"></date-range-picker></div><div flex=\"5\" style=\"margin: 18px 0;\"><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Buscar\" ng-click=\"vm.setDataPerPage(1, 10)\"><md-tooltip md-direction=\"bottom\">Buscar</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></md-content><md-table-container layout-padding=\"\"><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Data/Hora</th><th md-column=\"\"><span>Usuário</span></th><th md-column=\"\">Operação</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"log in vm.logData\" ng-click=\"vm.openDetails(log)\"><td md-cell=\"\">{{log.timestamp }}</td><td md-cell=\"\">{{log.person_name}}</td><td md-cell=\"\">{{log.description}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"vm.query.limit_options\" md-page=\"vm.query.page\" md-total=\"{{vm.query.total}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></md-card></md-content></md-tab><md-tab label=\"Logins\"><md-content ui-view=\"syslogin\" class=\"table-float-button\" style=\"background-color: whitesmoke !important;\"></md-content></md-tab></md-tabs></div>");
$templateCache.put("app/log/views/sysdetail.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Detalhamento</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 100px; min-width: 400px;\" layout=\"column\" flex=\"\"><div flex=\"100\" layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-desktop-tower\"></md-icon><label>Nome do usuário</label> <input ng-model=\"vm.scope.name\"></md-input-container></div><div flex=\"100\" layout=\"row\"><md-input-container flex=\"50\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-desktop-tower\"></md-icon><label>IP de acesso</label> <input ng-model=\"vm.scope.ip\"></md-input-container><md-input-container flex=\"50\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-cellphone-link\"></md-icon><label>Browser</label> <input ng-model=\"vm.scope.browser\"></md-input-container><md-input-container flex=\"50\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-arrow-up\"></md-icon><label>Login</label> <input ng-model=\"vm.scope.login_timestamp\"></md-input-container><md-input-container flex=\"50\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon><label>Logout</label> <input ng-model=\"vm.scope.logout_timestamp\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/log/views/syslogin.html","<md-card layout=\"column\" layout-padding=\"\"><md-content layout=\"row\" style=\"padding-top: 0;padding-bottom: 0;\"><md-input-container class=\"md-input-has-placeholder\" flex=\"20\" flex-sm=\"35\" flex-md=\"30\" flex-xs=\"100\" style=\"height: 36px;margin-top: 30px\"><md-icon md-font-icon=\"icon-account-outline\"></md-icon><select-dropdown title=\"Usuários\" placeholder=\"Procure um usuário\" selected-items=\"vm.selected_users\" ng-model=\"vm.users_filter\"></select-dropdown></md-input-container><div flex=\"25\" flex-sm=\"70\" flex-md=\"70\" flex-xs=\"100\" style=\"margin: 18px 0;\"><date-range-picker ng-model=\"vm.filter_date\" label=\"Datas\" time-picker=\"true\"></date-range-picker></div><div flex=\"5\" style=\"margin: 18px 0;\"><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Buscar\" ng-click=\"vm.getSys(1, 10)\"><md-tooltip md-direction=\"bottom\">Buscar</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Imprimir\" ng-click=\"vm.printSysLogin()\" style=\"margin-top: 22px;\"><md-tooltip md-direction=\"bottom\">Imprimir</md-tooltip><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></div></md-content><md-table-container layout-padding=\"\"><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Usuário</th><th md-column=\"\"><span>login</span></th><th md-column=\"\">logout</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"sys in vm.sysSession\" ng-click=\"vm.openSysDetails(sys)\"><td md-cell=\"\">{{sys.name}}</td><td md-cell=\"\">{{sys.login_timestamp}}</td><td md-cell=\"\" ng-if=\"sys.logout_timestamp !== null\">{{sys.logout_timestamp}}</td><td md-cell=\"\" ng-if=\"sys.logout_timestamp == null\">Usuário não fez logout</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"vm.query.limit_options\" md-page=\"vm.query.page\" md-total=\"{{vm.query.total}}\" md-on-paginate=\"vm.getSys\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></md-card>");
$templateCache.put("app/login/labscontrol/labs-database-modal.html","<md-dialog aria-label=\"Edit Cell\" md-theme=\"controlpanel\" style=\"max-width: 800px;min-width:800px\"><md-dialog-content><strong class=\"group-field\"><small>Selecione o banco desejado para re-estruturação</small></strong><div layout=\"row\"><md-input-container flex=\"\"><md-icon md-font-icon=\"icon-account\"></md-icon><input ng-model=\"vm.labslogin\" type=\"text\" placeholder=\"E-mail\"></md-input-container><md-input-container flex=\"\"><md-icon md-font-icon=\"icon-lock\"></md-icon><input ng-model=\"vm.labspassword\" type=\"password\" placeholder=\"Senha\"></md-input-container></div><div layout=\"column\" style=\"max-width: 800px;\"><md-input-container flex=\"\" ng-if=\"vm.databases.length > 0\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.alias\" placeholder=\"Buscar\"></md-input-container><md-radio-group flex=\"\" ng-model=\"vm.database_selected\" layout=\"row\" layout-align=\"start\" layout-wrap=\"\"><md-radio-button flex=\"30\" class=\"md-primary\" ng-repeat=\"database in vm.databases | filter:vm.alias:false track by $index\" ng-value=\"database.alias\" ng-if=\"database.support_view\">{{ database.name }}</md-radio-button></md-radio-group></div><md-content style=\"padding: 10px\"><div layout=\"column\" layout-align=\"center center\"><div flex=\"\">{{vm.stream_message}}</div><md-progress-linear flex=\"\" md-mode=\"determinate\" value=\"{{vm.barvalue}}\"></md-progress-linear></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><md-button md-autofocus=\"\" ng-click=\"vm.close()\">Sair</md-button><span flex=\"\"></span><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.database_selected !== null\"><md-button ng-click=\"vm.executeReDatabase(vm.labslogin, vm.labspassword, vm.database_selected, false)\" ng-disabled=\"vm.loading\" layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\" flex=\"10\" md-diameter=\"15\"></md-progress-circular><span flex=\"\">Cópia completa</span></md-button><md-button ng-click=\"vm.executeReDatabase(vm.labslogin, vm.labspassword, vm.database_selected, true)\" ng-disabled=\"vm.loading\" layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\" flex=\"10\" md-diameter=\"15\"></md-progress-circular><span flex=\"\">Cópia simples</span></md-button><span class=\"md-caption\" style=\"background-color: #2196F3; color: white; padding: 4px 8px; border-radius: 12px; margin-left: 8px; font-size: 12px;\" ng-if=\"vm.loading || vm.completionTime\">{{vm.timerDisplay}}</span></div><form name=\"databaseform\" ng-submit=\"vm.getDatabases(vm.labslogin, vm.labspassword)\" ng-if=\"vm.databases.length == 0\"><md-button type=\"submit\" layout=\"row\" ng-disabled=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\" flex=\"10\" md-diameter=\"15\"></md-progress-circular><span flex=\"\">Buscar bancos disponíveis</span></md-button></form></md-dialog-actions></md-dialog>");
$templateCache.put("app/login/views/change-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>A4</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recupere sua senha</div><form name=\"forgotPasswordForm\" novalidate=\"\" ng-submit=\"vm.submit(vm.form)\"><md-input-container class=\"md-block md-input-has-placeholder\" md-no-float=\"\" ng-if=\"$state.params.base64 != null\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-disabled=\"true\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" md-no-float=\"\" ng-if=\"$state.params.base64 == null\"><input ng-model=\"vm.form.email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.password_confirm\" placeholder=\"Password (Confirm)\" onpaste=\"return false\" ondrop=\"return false\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-button type=\"submit\" flex=\"\" layout=\"row\" layout-align=\"center center\" class=\"md-raised md-block md-accent\" aria-label=\"CHANGE PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine || vm.in_process\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.in_process\" flex=\"10\" md-diameter=\"15\"></md-progress-circular><span flex=\"\">{{\'FORGOTPASSWORD.CHANGE_PASSWORD\' | translate}}</span></md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"public.login\" translate=\"FORGOTPASSWORD.GO_BACK\">Voltar para login</a></div></div></div></div>");
$templateCache.put("app/login/views/forgot.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>A4</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recupere sua senha</div><form name=\"forgotPasswordForm\" novalidate=\"\" ng-submit=\"vm.changePassword(vm.form)\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Endereço de email\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><div layout=\"row\"><md-button type=\"submit\" flex=\"\" layout=\"row\" layout-align=\"center center\" class=\"md-raised md-block md-accent\" aria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || vm.in_process\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.in_process\" flex=\"10\" md-diameter=\"15\"></md-progress-circular><span flex=\"\">{{ \'FORGOTPASSWORD.SEND_RESET_LINK\' | translate}}</span></md-button></div></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"public.login\" style=\"color: black\" translate=\"FORGOTPASSWORD.GO_BACK\">Voltar para login</a></div></div></div></div>");
$templateCache.put("app/login/views/login.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\" style=\"height: 100%; background: {{vm.url_background}} no-repeat; background-size: cover; position: fixed; width: 100%;\"><div id=\"login-v2-intro\" flex=\"\" hide=\"\" show-gt-sm=\"\"><div class=\"logo md-accent-bg\"><span>A4</span></div><div class=\"title\" translate=\"LOGIN_V2.INTRO_TITLE\">Welcome to the FUSE!</div><div class=\"description\" translate=\"LOGIN_V2.INTRO_DESCRIPTION\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.</div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll=\"\"><div id=\"login-v2-form\"><div style=\"width: 140px;line-height: 128px;font-size: 86px;font-weight: 500; margin: 2px auto 32px auto;color: #FFFFFF;border-radius: 2px;display: table;\"><div style=\"display: table-cell; vertical-align: middle;\"><img align=\"middle\" ng-src=\"{{vm.screen_image}}\" alt=\"\"></div></div><form name=\"loginForm\" novalidate=\"\" ng-submit=\"vm.login(vm.form)\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" name=\"email\" ng-model=\"vm.form.usermail\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"LOGIN_V2.EMAIL\" ng-if=\"vm.is_labs\" required=\"\"> <input type=\"text\" name=\"email\" ng-model=\"vm.form.usermail\" placeholder=\"{{vm.login_placeholder}}\" ng-if=\"!vm.is_labs\" required=\"\"><div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required=\"\"><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-show=\"vm.showSupportTokenField\"><input type=\"text\" name=\"supportToken\" ng-model=\"vm.form.supportToken\" placeholder=\"Token de Autenticação de Suporte\"></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"vm.form.remember\" aria-label=\"Remember Me\"><span translate=\"LOGIN_V2.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"public.forgot\" class=\"forgot-password md-accent-color\" translate=\"LOGIN_V2.FORGOT_PASSWORD\">Forgot Password?</a></div><div layout=\"column\"><md-button flex=\"\" type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine || vm.loginProcess\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\"><md-progress-circular style=\"float: left; top: 8px;left: 100px;\" ng-show=\"vm.loginProcess\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'LOGIN_V2.LOG_IN\' | translate }}</md-button><a flex=\"\" class=\"md-raised md-block md-accent md-button\" aria-label=\"LOG IN\" ng-if=\"vm.connection != \'raiodesol\'\" ui-sref=\"public.register\" ng-disabled=\"vm.loginProcess\" style=\"margin: 6px 0;\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\">{{ \'Criar minha conta\' | translate }}</a><md-button flex=\"\" class=\"md-raised md-block md-warn md-button\" aria-label=\"LABS\" ng-if=\"vm.is_labs\" style=\"margin: 6px 0;\" ng-click=\"vm.labsDatabase()\">{{ \'Definir banco de dados labs\' | translate }}</md-button></div></form></div></div></div>");
$templateCache.put("app/login/views/password-recovery-warning.html","<md-dialog aria-label=\"Recuperar senha\"><form ng-cloak=\"\"><md-toolbar style=\"background-color: white\"><div class=\"md-toolbar-tools\"><h1 style=\"color:black\">Primeiro acesso</h1><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" style=\"padding: 0 !important\"><p>Olá, {{vm.user.name.split(\' \')[0]}} tudo bem? Vimos que é seu primeiro acesso no nosso novo sistema.</p><p>Por questões de segurança, utilize o nosso recurso de recuperação, e crie uma nova senha para sua conta.</p></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ui-sref=\"public.forgot({email: vm.user.email})\" ng-click=\"vm.close()\">Ir para recuperação de senha</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/process/dashboard/dashboard.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Dashboard</span></div></div></md-toolbar><div id=\"board\" ui-sortable=\"vm.sortableListOptions\" ng-model=\"vm.board.lists\" layout=\"row\"></div></div>");
$templateCache.put("app/register/views/confirmation.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\" ng-style=\"{height: vm.windowHeight}\"><div id=\"register-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>A4</span></div><div class=\"title\">Conta confirmada com sucesso</div><a flex=\"\" class=\"md-raised md-block md-accent md-button\" aria-label=\"LOG IN\" ui-sref=\"public.login\" style=\"margin: 6px 0;\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\">Login</a></div></div></div>");
$templateCache.put("app/register/views/index.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\" ng-style=\"{height: vm.windowHeight}\"><div id=\"register-v2-intro\" flex=\"\" hide=\"\" show-gt-sm=\"\"><div class=\"logo md-accent-bg\"><span>A4</span></div><div class=\"title\">{{\'REGISTER_V2.INTRO_TITLE\' | translate}}<span ng-if=\"vm.token != null\">, {{vm.form.name}}!</span></div><div class=\"description\">{{\'REGISTER_V2.INTRO_DESCRIPTION\' | translate}}</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm=\"\"><span>F</span></div><div layout=\"row\"><md-button class=\"md-icon-button\" ui-sref=\"public.login\" style=\"padding: 5px 0; margin: 0 !important;\"><md-tooltip md-direction=\"top\">Voltar para login</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\" style=\"margin: 0\"></md-icon></md-button><div><div class=\"title\" translate=\"REGISTER_V2.TITLE\"></div></div></div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\"></div><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"!vm.noEmail\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\"></span></div><div ng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"confirm_email\" ng-model=\"vm.form.confirm_email\" placeholder=\"Confirmar Email\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.CONFIRM_EMAIL\" onpaste=\"return false\" ondrop=\"return false\" ng-if=\"!vm.noEmail\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.confirm_email.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.CONFIRM_EMAIL_REQUIRED\"></span></div><div ng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"vm.token === null && !vm.noEmail\"><input type=\"text\" name=\"token\" ng-model=\"vm.form.token\" placeholder=\"Código de ativação\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.TOKEN\" required=\"\" ng-disabled=\"vm.token !== null\"><div ng-messages=\"registerForm.token.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.TOKEN_REQUIRED\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" ng-model=\"vm.form.person_name\" placeholder=\"Nome completo\" ng-if=\"vm.noEmail\" required=\"\"><div ng-messages=\"registerForm.confirm_email.$error\" role=\"alert\" multiple=\"\"></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"vm.noEmail\"><md-radio-group layout=\"row\" style=\"color: #A5A5A5;\" ng-model=\"vm.form.person_sex_id\"><md-radio-button style=\"color: #A5A5A5;\" value=\"M\">Masculino</md-radio-button><md-radio-button style=\"color: #A5A5A5;\" value=\"F\">Feminino</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"vm.has_national_id_number || vm.token === null\"><input type=\"text\" name=\"national_id_number\" ng-model=\"vm.form.national_id_number\" placeholder=\"CPF\" ui-br-cpf-mask=\"\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.NATIONAL_ID_NUMBER\" ng-required=\"vm.has_national_id_number\"><div ng-messages=\"registerForm.national_id_number.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.NATIONAL_ID_NUMBER_REQUIRED\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"(!vm.has_national_id_number && vm.has_dob) || vm.token === null\"><input type=\"text\" name=\"dob\" ng-model=\"vm.form.dob\" placeholder=\"Data de Nascimento\" ui-date-mask=\"\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.DOB\" ng-required=\"!vm.has_national_id_number && vm.has_dob\"><div ng-messages=\"registerForm.dob.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.DOB_REQUIRED\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"!vm.noEmail\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"!vm.noEmail\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.password_confirm\" placeholder=\"Password (Confirm)\" onpaste=\"return false\" ondrop=\"return false\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine || vm.disable_button\" ng-click=\"vm.createAccount(vm.form)\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"column\" layout-sm=\"column\" layout-align=\"center center\"><md-button ng-click=\"vm.toggleForm()\" ng-if=\"vm.login_type == \'enrolment_number\'\"><p ng-if=\"!vm.noEmail\">Não possui um e-mail?</p><p ng-if=\"vm.noEmail\">Possui um e-mail?</p></md-button></div></div></div></div>");
$templateCache.put("app/register/views/raiodesolregister.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\" ng-style=\"{height: vm.windowHeight}\"><div id=\"register-v2-intro\" flex=\"\" hide=\"\" show-gt-sm=\"\"><div class=\"logo md-accent-bg\"><span>A4</span></div><div class=\"title\">{{\'REGISTER_V2.INTRO_TITLE\' | translate}}<span ng-if=\"vm.token != null\">, {{vm.form.name}}!</span></div><div class=\"description\">{{\'REGISTER_V2.INTRO_DESCRIPTION\' | translate}}</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm=\"\"><span>F</span></div><div layout=\"row\"><md-button class=\"md-icon-button\" ui-sref=\"public.login\" style=\"padding: 5px 0; margin: 0 !important;\"><md-tooltip md-direction=\"top\">Voltar para login</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\" style=\"margin: 0\"></md-icon></md-button><div><div class=\"title\" translate=\"REGISTER_V2.TITLE\"></div></div></div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\"></div><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"number\" name=\"login\" ng-model=\"vm.form.enrolment\" translate=\"\" placeholder=\"Matrícula\" ng-maxlength=\"6\" required=\"\"><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.ENROLMENT_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" name=\"dob\" ng-model=\"vm.form.dob\" placeholder=\"Data de Nascimento\" ui-date-mask=\"\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.DOB\" required=\"\"><div ng-messages=\"registerForm.dob.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.DOB_REQUIRED\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.password_confirm\" placeholder=\"Password (Confirm)\" onpaste=\"return false\" ondrop=\"return false\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"confirm_phone\" ng-model=\"vm.form.phone\" placeholder=\"Número de celular\" ui-br-phone-number=\"\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine || vm.disable_button\" ng-click=\"vm.createAccount(vm.form)\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"REGISTER_V2.LOGIN\">Log in</a></div></div></div></div>");
$templateCache.put("app/stock/dashboard/dashboard.html","<div><md-button policy-access=\"private.stock.dashboard.create\" class=\"md-primary\">Access</md-button></div>");
$templateCache.put("app/components/a4-accounts-grid/templates/index.html","<div id=\"table-material\" style=\"clear: both\"><div ng-show=\"vm.selectedItems.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedItems =[]\"><md-button layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span translate=\"TABLE.BACK\"></span></md-button></div><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>{{vm.selectedItems.length}}</span> <span translate=\"TABLE.SELECTED\">selected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate=\"\" translate-attr-aria-label=\"TABLE.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllItems()\" translate=\"TABLE.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectItems()\" translate=\"TABLE.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedItems($event)\" aria-label=\"delete selected\" translate=\"\" translate-attr-label=\"TABLE.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg=\"\" layout=\"row\" layout-align=\"start start\"><div class=\"main scrollable\" ms-scroll=\"\"><md-list class=\"contacts-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" translate=\"TABLE.ALL_ITEMS\"></span> <span ng-if=\"filteredContacts.length\" class=\"secondary-text contacts-count\">({{filteredContacts.length}})</span></div><div class=\"edit-group-form\" ng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span ng-show=\"editGroupForm.$visible\" editable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup()\"></span><md-button class=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" aria-label=\"edit group name\" translate=\"\" translate-attr-label=\"TABLE.EDIT_GROUP_NAME\"><md-icon md-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button class=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup($event)\" ng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate=\"\" translate-attr-label=\"TABLE.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button></div><div flex=\"\"></div></div></md-subheader><md-list-item ng-class=\"{\'sel-line\': current_line == $index}\" class=\"contact-item md-white-bg\" md-ink-ripple=\"\" ng-repeat=\"item in vm.items | filter: vm.search | filter: global.search | filterByIds:vm.filterIds | orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContacts track by item.id\" ng-click=\"changeCurrentLine($index)\" ng-style=\"{\'transform\': \'translate3d(0px, \'+ $index * 100 +\'%, 0px)\', \'z-index\': filteredContacts.length - $index}\"><div ng-repeat=\"idx in getKeys($index)\" class=\"dynamic-div\" ng-show=\"idx != \'id\'\"><p class=\"text-truncate show-gt-sm accounts-title {{idx}}\"><span ng-class=\"{\'red\': idx == \'balance\' && vm.getTranslateValue($parent.$index, idx) < 0, \'hide-data\': idx == \'type_name\'}\"><span ng-show=\"idx == \'balance\'\">{{applyMask(vm.getTranslateValue($parent.$index, idx))}}</span> <span ng-show=\"idx != \'balance\'\">{{vm.getTranslateValue($parent.$index, idx)}}</span> <span ng-show=\"idx == \'name\'\" class=\"badge\" ng-if=\"vm.verifyMain($parent.$index, idx)\">Principal</span></span></p></div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.openTableItem($event, $index,\'sidenav-form\')\">{{ \'TABLE.EDIT\' | translate }}</md-button></md-menu-item><md-divider><md-menu-item><md-button ng-click=\"onDelete({index: $index})\">{{ \'TABLE.DELETE_ITEM\' | translate }}</md-button></md-menu-item></md-divider><md-divider ng-if=\"vm.user.groups\"></md-divider><md-subheader class=\"md-no-sticky\" ng-if=\"vm.user.groups\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" ng-click=\"vm.toggleInArray(item.id,group.contactIds)\"><p class=\"pl-8\" ng-style=\"vm.exists(contact.id,group.contactIds) && {\'font-weight\':\'500\'}\">{{group.name}}</p></md-list-item></md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p translate=\"TABLE.NO_RESULTS\">No results..</p></md-list-item></div><md-sidenav md-component-id=\"sidenav-form\" class=\"md-sidenav-right md-whiteframe-4dp\" ms-scroll=\"\" ng-include=\"sidebarCreateEdit\"></md-sidenav><md-sidenav md-component-id=\"sidenav-create-entry\" class=\"md-sidenav-right md-whiteframe-4dp\" ms-scroll=\"\" ng-include=\"sidebarEntry\"></md-sidenav><md-sidenav md-component-id=\"sidenav-create-output\" class=\"md-sidenav-right md-whiteframe-4dp\" ms-scroll=\"\" ng-include=\"sidebarOutput\"></md-sidenav><md-sidenav md-component-id=\"sidenav-create-transf\" class=\"md-sidenav-right md-whiteframe-4dp\" ms-scroll=\"\" ng-include=\"sidebarTransference\"></md-sidenav></div></div>");
$templateCache.put("app/components/a4-charts/templates/index.html","<md-card md-theme=\"default\" class=\"chart-container\"><div ng-cloak=\"\"><div layout=\"row\" layout-align=\"end end\" ng-if=\"withPrinter\"><md-button class=\"md-icon-button\" ng-click=\"printChart()\"><md-icon>print</md-icon><md-tooltip>Imprimir</md-tooltip></md-button></div><div class=\"charts\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"data\" chart-labels=\"labels\" chart-series=\"series\" chart-options=\"options\" chart-dataset-override=\"datasetOverride\" chart-colors=\"colors\" chart-click=\"onClick\"></canvas></div></div></md-card>");
$templateCache.put("app/components/a4-charts-bar/templates/index.html","<md-card md-theme=\"default\" class=\"chart-container\"><div ng-cloak=\"\"><div class=\"charts\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"data\" chart-labels=\"labels\" chart-series=\"series\" chart-options=\"options\" chart-colors=\"colors\"></canvas></div></div></md-card>");
$templateCache.put("app/components/a4-contract/individual-discounts/discounts.html","<md-dialog aria-label=\"Descontos Individuais\" md-theme=\"{{vm.theme}}\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submitDiscounts(vm.contract, contractformfinance)\" name=\"contractformfinance\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Descontos <span>{{vm.contract_name}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-if=\"!vm.is_first\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Descontos individuais</b> <small>Abaixo encontram-se os descontos individuais deste contrato</small></div></div><md-table-container style=\"padding-top: 0;\"><a4-discounts-grid discounts=\"vm.discounts\" delete-function=\"vm.removeItem(discount_id)\" reopen-function=\"vm.reopenModal(discount)\" only-individual-discount=\"true\" show-delete=\"true\"></a4-discounts-grid></md-table-container><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117); margin-top: 5px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Descontos do plano de pagamento</b> <small>Abaixo encontram-se os descontos associados ao plano de pagamento deste contrato</small></div></div><md-table-container><a4-discounts-grid discounts=\"vm.discounts\" only-payment-plan-discount=\"true\" show-delete=\"false\"></a4-discounts-grid></md-table-container><md-button class=\"md-primary\" aria-label=\"Novo Desconto\" style=\"margin-left: 15px\" ng-click=\"vm.createNewDiscount()\">Adicionar desconto individual<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/a4-crm-contact-grid/views/contact-item-icon.html","<md-icon md-font-icon=\"icon-phone\" ng-if=\"item.format === \'Telefonema\'\"><md-tooltip md-direction=\"right\">Telefonema</md-tooltip></md-icon><md-icon md-font-icon=\"icon-people\" ng-if=\"item.format === \'Visita\'\"><md-tooltip md-direction=\"right\">Visita</md-tooltip></md-icon><md-icon md-font-icon=\"icon-printer\" ng-if=\"item.format === \'Fax\'\"><md-tooltip md-direction=\"right\">Fax</md-tooltip></md-icon><md-icon md-font-icon=\"icon-file-document\" ng-if=\"item.format === \'Correspondência\'\"><md-tooltip md-direction=\"right\">Correspondência</md-tooltip></md-icon><md-icon md-font-icon=\"icon-message-text-outline\" ng-if=\"item.format === \'Email\'\"><md-tooltip md-direction=\"right\">Email</md-tooltip></md-icon><md-icon md-font-icon=\"icon-question-mark-circle\" ng-if=\"item.format === \'Não especificado\'\"><md-tooltip md-direction=\"right\">Não especificado</md-tooltip></md-icon><md-icon md-font-icon=\"icon-school\" ng-if=\"item.format === \'Ocorrência interna\'\"><md-tooltip md-direction=\"right\">Ocorrência interna</md-tooltip></md-icon>");
$templateCache.put("app/components/a4-crm-contact-grid/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-square-inc-cash\" class=\"s24\" ng-if=\"vm.type === \'charge\'\"></md-icon><md-icon md-font-icon=\"icon-account-search\" class=\"s24\" ng-if=\"vm.type === \'prospects\'\"></md-icon></span> <span class=\"logo-text\"><span ng-if=\"vm.type === \'charge\'\">Cobrança</span> <span ng-if=\"vm.type === \'prospects\'\">Prospects</span></span></div></div><div layout=\"row\" layout-align=\"start right\" style=\"margin-left: 650px;\"><md-input-container md-no-float=\"\" style=\"width: 300px;\" class=\"m-0\"><md-select ng-model=\"vm.option\" ng-change=\"vm.getAll(undefined, undefined, vm.searchOccurrence, vm.searchResponsible, vm.option)\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-value=\"0\">Realizados</md-option><md-option ng-value=\"1\">Não realizados</md-option></md-select></md-input-container></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start right\"><label for=\"searchResponsible\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"searchResponsible\" placeholder=\"{{vm.type === \'prospects\' ? \'Busca por empresa\' : \'Busca por responsável\'}}\" type=\"text\" ng-model=\"vm.searchResponsible\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.getAll(undefined, undefined, vm.searchOccurrence, vm.searchResponsible, vm.option)\"></md-input-container></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start right\"><label for=\"searchOccurrence\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"searchOccurrence\" placeholder=\"Busca por ocorrência\" type=\"text\" ng-model=\"vm.searchOccurrence\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.getAll(undefined, undefined, vm.searchOccurrence, vm.searchResponsible, vm.option)\"></md-input-container></div></md-toolbar><md-content layout-xs=\"column\" layout=\"row\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><md-table-container><md-table-pagination md-limit=\"vm.charges.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.charges.current_page\" md-on-paginate=\"vm.getAll\" style=\"border: none\" md-total=\"{{vm.charges.total}}\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" colspan=\"4\">Forma</th><th md-column=\"\" colspan=\"1\">Data</th><th md-column=\"\" colspan=\"1\">Hora</th><th md-column=\"\" colspan=\"1\">Origem</th><th md-column=\"\" colspan=\"1\">Tipo</th><th md-column=\"\" colspan=\"1\">Agente</th><th md-column=\"\" colspan=\"1\"><span ng-if=\"vm.type === \'charge\'\">Responsável</span> <span ng-if=\"vm.type === \'prospects\'\">Empresa</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.charges.data\" ng-click=\"vm.editCharge(item);\" style=\"cursor: pointer\"><td md-cell=\"\" colspan=\"4\" style=\"padding-top: 15px; padding-bottom: 15px\"><span ng-include=\"\'app/components/a4-crm-contact-grid/views/contact-item-icon.html\'\"></span><br><hr><span ng-if=\"item.date_done !== null\"><b>Realizado:</b> {{item.notes_done}}</span> <span ng-if=\"item.date_done === null\" style=\"color: red !important;\"><b>Programado:</b> {{item.notes_scheduled}}</span></td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{(item.date_done | date:\'dd/MM/yyyy\') || (item.date_scheduled | date:\'dd/MM/yyyy\')}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.time_done !== null ? item.time_done : item.time_scheduled}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.origin}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.type}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.person_event_name}}</td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\">{{item.responsible_name}}<hr ng-if=\"vm.type === \'prospects\'\"><span ng-if=\"vm.type === \'prospects\'\">{{item.address_city !== null ? item.address_city : \'\'}}{{item.address_state !== null ? \'/\' + item.address_state : \'\'}}</span></td><td md-cell=\"\" colspan=\"1\" style=\"padding-top: 15px; padding-bottom: 15px\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete(item); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip>Excluir cobrança</md-tooltip></md-icon></md-button></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/components/a4-crud-table/templates/index.html","<md-content layout-xs=\"column\" layout=\"row\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"!vm.filter.show\"><div class=\"md-toolbar-tools\"><md-button class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-click=\"openModalAddItem()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar</md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.filter.show && vm.selected.length <= 0\" aria-hidden=\"true\"><div class=\"md-toolbar-tools\"><md-icon class=\"material-icons\">search</md-icon><input flex=\"\" type=\"text\" ng-model=\"vm.query_filter\" ng-model-options=\"vm.filter.options\" placeholder=\"Busca por nome\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"><button class=\"md-icon-button md-primary\" type=\"button\" ng-click=\"vm.removeFilter()\" aria-label=\"close\"><md-tooltip>Cancelar</md-tooltip><md-icon class=\"material-icons\" style=\"color: black;\">close</md-icon></button></div></md-toolbar><md-table-container><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-repeat=\"column in columns\"><span>{{column.name}}</span></th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in items | filter : vm.query_filter : false\" style=\"cursor: pointer\"><td md-cell=\"\" ng-repeat=\"column in columns\" ng-click=\"editComment($event, item, column.id)\">{{item[column.id]}}</td><td md-cell=\"\" style=\"text-align: right\"><span flex=\"\"></span></td></tr></tbody></table></md-table-container></md-card></md-content>");
$templateCache.put("app/components/a4-crud-table/templates/modal-add-item.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"{{vm.scope.theme}}\" style=\"min-width: 300px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar novo</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container ng-repeat=\"column in vm.scope.columns\"><input flex=\"\" type=\"text\" ng-model=\"vm.item[column.id]\" placeholder=\"{{column.name}}\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.answer(vm.item);\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-crud-table/templates/modal-change-table.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"{{theme}}\" style=\"min-width: 300px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Selecionar tabela</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container><label>Tabelas disponíveis</label><md-select ng-model=\"vm.table\"><md-option ng-repeat=\"(key, table) in vm.scope.tables\" ng-value=\"table\">{{table.name}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.answer(vm.table);\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-detail-grid/templates/index.html","<div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Categoria do titulo</b> <small>Abaixo pode-se adicionar uma ou mais categorias para o titulo</small></div></div><hr><div style=\"margin-bottom: 30px;\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-repeat=\"item in list\" style=\"margin-top: 15px;\"><div layout=\"column\" flex=\"\"><div layout=\"row\"><md-input-container class=\"input-a4\" flex=\"30\"><label>Categoria</label><md-select class=\"select\" ng-disabled=\"hasBlock\" name=\"category_{{$index}}\" aria-label=\"category_{{$index}}\" placeholder=\"Selecione a categoria\" ng-change=\"getCategory(item, item.bill_category_id)\" ng-model=\"item.bill_category_id\" required=\"\"><md-option ng-repeat=\"category in categories\" ng-value=\"category.id\" ng-selected=\"item.bill_category_id == category.id\">{{category.name | translate}}</md-option></md-select></md-input-container><md-input-container class=\"input-a4\" flex=\"30\"><label>Valor</label><md-icon class=\"md-icon-button\" style=\"color: #757575\" md-font-icon=\"icon-cash\"></md-icon><input type=\"text\" class=\"amount\" name=\"amount_{{$index}}\" aria-label=\"amount_{{$index}}\" ng-model=\"item.amount\" ui-money-mask=\"2\" autocomplete=\"off\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" ng-disabled=\"hasBlock\" required=\"\"></md-input-container><md-checkbox flex=\"\" ng-model=\"currentItem.is_inaccurate_amount\" ng-if=\"$index == 0\" style=\"margin-left: 10px\">É aproximado</md-checkbox><div layout=\"row\" flex=\"\" align=\"left\" layout-align=\"end end\"></div></div></div></div><div flex=\"\" layout=\"row\" layout-align=\"start\" ng-if=\"list.length > 1\" style=\"background-color: whitesmoke;\"><strong flex=\"30\"></strong><md-input-container flex=\"30\" style=\"margin-bottom: 0\"><label>Valor Total</label><md-icon class=\"md-icon-button\" style=\"color: #757575\" md-font-icon=\"icon-cash\"></md-icon><input type=\"text\" ng-disabled=\"true\" class=\"amount\" aria-label=\"amount_total\" ng-model=\"amount_total_category\" ng-value=\"calcAmountCategory(list)\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\"></md-input-container></div></div>");
$templateCache.put("app/components/a4-edit-table/templates/cards.html","<strong class=\"group-field\"><small ng-show=\"currentAccount.current_account_type_id == 2\">Cartões de débito</small> <small ng-show=\"currentAccount.current_account_type_id == 5\">Cartões de crédito</small><md-button class=\"md-fab md-mini md-raised bt-edit-add\" aria-label=\"Adicionar cartão\" ng-click=\"addNewItem()\"><i class=\"icon-plus add-bt\"></i></md-button></strong><div layout=\"row\"><table class=\"simple a4-edit-table\" ms-responsive-table=\"true\" ng-show=\"items.length\"><thead><tr><th>Identificação</th><th>Status</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in items\" ng-class=\"{\'edit-line\': edit_mode[$index]}\"><td><span class=\"label_name\" ng-show=\"!edit_mode[$index]\">{{item.name == null ? \' --- \' : item.name}}</span> <input type=\"text\" class=\"input_name\" placeholder=\"Identificação\" ng-show=\"edit_mode[$index]\" ng-model=\"item.name\"></td><td><span ng-bind=\"checkItemStatus(item.is_inactive, $index, \'is_inactive\')\" ng-class=\"{\'label-success\' : !item.is_inactive, \'label-danger\' : item.is_inactive}\" ng-show=\"!edit_mode[$index]\" class=\"label label-sm ng-binding label-success\"></span><md-switch ng-show=\"edit_mode[$index]\" aria-label=\"Status\" class=\"md-primary\" md-no-ink=\"\" md-invert=\"true\" ng-model=\"item.is_inactive\"></md-switch></td><td flex=\"\"><div class=\"bt_action\" ng-click=\"removeItem(item, $index);\"><i class=\"icon-delete icon\"></i></div><div class=\"bt_action\" ng-click=\"editItem(item, $index);\"><i class=\"icon-pencil icon\" ng-show=\"!edit_mode[$index]\"></i> <i class=\"icon-check icon\" ng-show=\"edit_mode[$index]\"></i></div></td></tr></tbody></table></div>");
$templateCache.put("app/components/a4-edit-table/templates/collection_configs.html","<div><strong class=\"group-field\"><small>Configuração de cobrança</small><md-button class=\"md-fab md-mini md-raised bt-edit-add\" aria-label=\"Adicionar configuração\" ng-click=\"addNewItem()\"><i class=\"icon-plus add-bt\"></i></md-button></strong><div layout=\"row\"><table class=\"simple a4-edit-table\" ms-responsive-table=\"true\"><thead><tr><th>Nome</th><th>Código da Carteira</th><th>Variação da Carteira</th><th>Convênio</th><th>CNAB</th><th>Status</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in items\" ng-class=\"{\'edit-line\': edit_mode[$index]}\"><td><span class=\"label_name\" ng-show=\"!edit_mode[$index]\">{{item.company_name == null ? \' --- \' : item.company_name}}</span> <input type=\"text\" placeholder=\"\" class=\"input_name\" ng-show=\"edit_mode[$index]\" ng-model=\"item.company_name\"></td><td><span class=\"label_name\" ng-show=\"!edit_mode[$index]\">{{item.wallet_code == null ? \' --- \' : item.wallet_code}}</span> <input type=\"text\" placeholder=\"\" class=\"input_name\" ng-show=\"edit_mode[$index]\" ng-model=\"item.wallet_code\"></td><td><span class=\"label_name\" ng-show=\"!edit_mode[$index]\">{{item.wallet_variation == null ? \' --- \' : item.wallet_variation}}</span> <input type=\"text\" placeholder=\"\" class=\"input_name\" ng-show=\"edit_mode[$index]\" ng-model=\"item.wallet_variation\"></td><td><span class=\"label_name\" ng-show=\"!edit_mode[$index]\">{{item.contract_number == null ? \' --- \' : item.contract_number}}</span> <input type=\"text\" placeholder=\"\" class=\"input_name\" ng-show=\"edit_mode[$index]\" ng-model=\"item.contract_number\"></td><td><span class=\"label_name\" ng-show=\"!edit_mode[$index]\">{{item.cnab == null ? \' --- \' : item.cnab}}</span> <input type=\"text\" placeholder=\"\" class=\"input_name\" ng-show=\"edit_mode[$index]\" ng-model=\"item.cnab\"></td><td><span ng-bind=\"checkItemStatus(item.is_active, $index, \'is_active\')\" ng-class=\"{\'label-success\' : item.is_active, \'label-danger\' : !item.is_active}\" ng-show=\"!edit_mode[$index]\" class=\"label label-sm ng-binding label-success\"></span><md-switch ng-show=\"edit_mode[$index]\" aria-label=\"Status\" ng-model=\"item.is_active\"></md-switch></td><td><div class=\"bt_action\" ng-click=\"removeItem(item, $index);\"><i class=\"icon-delete icon\"></i></div><div class=\"bt_action\" ng-click=\"editItem(item, $index);\"><i class=\"icon-pencil icon\" ng-show=\"!edit_mode[$index]\"></i> <i class=\"icon-check icon\" ng-show=\"edit_mode[$index]\"></i></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/a4-infinite-scroll/templates/infinite-scroll.html","<md-virtual-repeat-container><div md-virtual-repeat=\"item in vm.items\" md-on-demand=\"\">{{item}}</div></md-virtual-repeat-container>");
$templateCache.put("app/components/a4-md-dialog/templates/view.html","<md-dialog aria-label=\"vm.dialogTitle\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-bind=\"vm.dialogTitle\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\"><i class=\"material-icons\">close</i></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" ng-include=\"vm.dialogTemplateUrl\"></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.dialogFunction\">{{ vm.dialogFunctionLabel }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-menu-system/templates/menu.html","<a4-menu-system-toggle class=\"menu-system-container\" style=\"display: none\"><div class=\"menu-system-menu-itens\" layout=\"row\" layout-wrap=\"\"><div flex=\"50\" class=\"menu-system-item\" ng-repeat=\"item in vm.menu\" ui-sref=\"{{item.uisref}}\" ng-cloak=\"\" policy-access=\"{{item.policy}}\" ng-if=\"item.conditional\"><div class=\"menu-system-logo\" style=\"background-image: url({{item.image}});\"></div><div class=\"menu-system-title-item\">{{item.name}}</div></div></div></a4-menu-system-toggle>");
$templateCache.put("app/components/a4-negotiation/individual-discounts/discounts.html","<md-dialog aria-label=\"Descontos Individuais\" md-theme=\"{{vm.theme}}\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submitDiscounts(vm.contract, contractformfinance)\" name=\"contractformfinance\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Descontos individuais <span>{{vm.contract_name}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-if=\"!vm.is_first\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Razão</th><th md-column=\"\">Desconto</th><th md-column=\"\">F/C</th><th md-column=\"\">De</th><th md-column=\"\">Até</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.discounts\"><td md-cell=\"\">{{ item.name }}</td><td md-cell=\"\">{{ item.value_type == 1 ? \"% \" + item.amount : \"R$ \" + item.amount }}</td><td md-cell=\"\">{{ item.is_fixed ? \'F\' : \'C\' }}</td><td md-cell=\"\">{{ item.start_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\">{{ item.end_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeItem(item.id)\" policy-access=\"contrato_del_desc_indiv\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr><tr md-row=\"\" ng-if=\"vm.discounts.length == 0\"><td md-cell=\"\"></td><td md-cell=\"\">Não há descontos para este contrato</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container><md-button class=\"md-primary\" aria-label=\"Novo Desconto\" style=\"margin-left: 15px\" ng-click=\"vm.createNewIndivialDiscount()\">Adicionar desconto<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/a4-payments-grid/templates/payments.html","<div class=\"col-md-12 payments-grid\" ng-if=\"currentaccountlist != null\"><strong class=\"group-field\"><small ng-show=\"debitcredit == \'D\'\">Métodos de pagamento</small> <small ng-show=\"debitcredit == \'C\'\">Métodos de recebimento</small></strong><div layout=\"row\" class=\"group-row\"><md-button class=\"md-raised md-primary\" ng-click=\"getModal(1)\">Dinheiro</md-button><md-button class=\"md-raised md-primary\" ng-click=\"getModal(2)\">Banco</md-button><div ng-if=\"debitcredit == \'D\'\"><md-button class=\"md-raised md-primary\" ng-click=\"getModal(4)\" ng-if=\"existCurrentAccountType(\'CONTA_CARTAO_DE_DEBITO_PAGAMENTO\')\">C. Débito</md-button><md-button class=\"md-raised md-primary\" ng-click=\"getModal(5)\" ng-if=\"existCurrentAccountType(\'CONTA_CARTAO_DE_CREDITO_PAGAMENTO\')\">C.Crédito</md-button></div><div ng-if=\"debitcredit == \'C\'\"><md-button class=\"md-raised md-primary\" ng-click=\"getModal(7)\" ng-if=\"existCurrentAccountType(\'CONTA_CARTAO_DE_DEBITO_RECEBIVEL\')\">C. Débito</md-button><md-button class=\"md-raised md-primary\" ng-click=\"getModal(6)\" ng-if=\"existCurrentAccountType(\'CONTA_CARTAO_DE_CREDITO_RECEBIVEL\')\">C.Crédito</md-button></div><md-button class=\"md-raised md-primary\" ng-click=\"getModal(8)\" ng-if=\"creditAmount > 0\">Crédito</md-button><md-button class=\"md-raised md-primary\" ng-click=\"getModal(3)\">Cheque</md-button><md-button class=\"md-raised ms-navigation-button\" ng-click=\"waitCheck()\">Ler o cheque</md-button></div><div ng-if=\"paymentslist.length\"><div class=\"row\"><hr></div><div class=\"row\"><table class=\"simple\"><thead><tr><th class=\"text-center\"><strong>Forma</strong></th><th class=\"text-center\"><strong>Conta</strong></th><th class=\"text-center\"><strong>Detalhes</strong></th><th class=\"text-center\"><strong>Valor</strong></th><th class=\"text-center\"><strong>Opções</strong></th></tr></thead><tbody><tr ng-repeat=\"item in paymentslist track by $index\"><td class=\"text-center\">{{getMovimentTypeNameById(item.movement_type_id)}}</td><td class=\"text-center\">{{getCurrentAccountNameById(item.current_account_id)}}</td><td class=\"text-center\">{{detailByMovement(item)}}</td><td class=\"text-center\">{{calcAmountItem(item) | currency}}</td><td class=\"text-center\"><md-button class=\"md-icon-button\" aria-label=\"Edit\" ng-click=\"editItem(item, $index);\"><md-icon>mode_edit</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Edit\" ng-click=\"removeItem(item, $index);\"><md-icon>delete_forever</md-icon></md-button></td></tr></tbody></table></div></div><div class=\"alert alert-warning\" style=\"text-align: left !important;\" ng-if=\"paymentslist.length > 0 && haslessdifference\" ng-init=\"paymentwithdifferenceConfirm = false\"><p ng-if=\"!paymentwithdifferenceConfirm && haslessdifference\">Diferença de <strong>{{ ((diff < 0) ? diff * (-1) : diff) | currency}}</strong> a menos.<br>Inclua mais uma forma de pagamento ou selecione uma das opções abaixo:</p><div ng-if=\"debitcredit == \'C\'\"><div layout=\"column\"><md-radio-group ng-model=\"vm.option_difference\" ng-if=\"billsselected.length == 1 && (billsselected[0].allowance_value == 0) && (billsselected[0].partial_payment_value == 0)\"><md-radio-button ng-value=\"1\">Fazer pagamento parcial do título</md-radio-button><md-radio-button policy-access=\"allowance\" ng-value=\"2\">Conceder abono de {{ ((diff < 0) ? diff * (-1) : diff) | currency}}</md-radio-button></md-radio-group><md-radio-group ng-model=\"vm.option_difference\" ng-if=\"billsselected.length == 1 && billsselected[0].allowance_value > 0\"><md-radio-button ng-value=\"1\">Remover abonos e fazer pagamento parcial do título</md-radio-button><md-radio-button policy-access=\"allowance\" ng-value=\"2\">Acrescentar {{ ((diff < 0) ? diff * (-1) : diff) | currency}} ao abono do título</md-radio-button></md-radio-group><md-radio-group ng-model=\"vm.option_difference\" ng-if=\"billsselected.length == 1 && billsselected[0].partial_payment_value > 0\"><md-radio-button ng-value=\"1\">Ajustar o valor do pagamento parcial</md-radio-button></md-radio-group><md-radio-group ng-model=\"vm.option_difference\" ng-if=\"billsselected.length > 1 && (billsselected[0].allowance_value == 0) && (billsselected[0].partial_payment_value == 0)\"><md-radio-button ng-value=\"1\" ng-if=\"((diff < 0) ? diff * (-1) : diff) < billsselected[0].final_value\">Pagar parcial o primeiro título da lista</md-radio-button><md-radio-button policy-access=\"allowance\" ng-value=\"2\" ng-if=\"((diff < 0) ? diff * (-1) : diff) < billsselected[0].final_value\">Conceder abono de {{ ((diff < 0) ? diff * (-1) : diff) | currency}} ao primeiro título da lista</md-radio-button><md-radio-button policy-access=\"allowance\" ng-value=\"3\">Distribuir {{ ((diff < 0) ? diff * (-1) : diff) | currency}} como abono aos títulos da lista</md-radio-button></md-radio-group><md-radio-group ng-model=\"vm.option_difference\" ng-if=\"billsselected.length > 1 && (billsselected[0].allowance_value > 0)\"><md-radio-button policy-access=\"allowance\" ng-value=\"2\" ng-if=\"((diff < 0) ? diff * (-1) : diff) < billsselected[0].final_value\">Acrescentar {{ ((diff < 0) ? diff * (-1) : diff) | currency}} ao abono do primeiro título da lista</md-radio-button><md-radio-button policy-access=\"allowance\" ng-value=\"3\">Distribuir {{ ((diff < 0) ? diff * (-1) : diff) | currency}} acrescentando ao abono dos títulos da lista</md-radio-button></md-radio-group><md-radio-group ng-model=\"vm.option_difference\" ng-if=\"billsselected.length > 1 && (billsselected[0].partial_payment_value > 0)\"><md-radio-button ng-value=\"1\" ng-if=\"((diff < 0) ? diff * (-1) : diff) < billsselected[0].final_value\">Ajustar o valor do pagamento parcial do primeiro título da lista</md-radio-button><md-radio-button policy-access=\"allowance\" ng-value=\"3\">Distribuir {{ ((diff < 0) ? diff * (-1) : diff) | currency}} como abono aos títulos da lista</md-radio-button></md-radio-group></div></div><div ng-if=\"debitcredit == \'D\'\"><md-radio-group ng-model=\"vm.option_difference\" ng-if=\"billsselected.length == 1 && (billsselected[0].partial_payment_value == 0)\"><md-radio-button ng-value=\"4\">Alterar valor do título</md-radio-button><md-radio-button ng-value=\"1\">Fazer pagamento parcial</md-radio-button><md-radio-button ng-value=\"5\">Conceder desconto</md-radio-button></md-radio-group></div><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.option_difference == null\" ng-click=\"vm.updateAmounts()\">Ok</md-button></div><div class=\"alert alert-warning-credit\" style=\"text-align: left !important;\" ng-if=\"paymentslist.length > 0 && hasmoredifference\" ng-init=\"paymentwithdifferenceConfirm = false\"><p ng-if=\"debitcredit == \'C\'\">Diferença de <strong>{{ ((diff < 0) ? diff * (-1) : diff) | currency}}</strong> a maior.<br>Ajuste os valores das formas de pagamento, ou, se desejar, deixe assim para gerar valor de crédito para esse cliente utilizar no futuro.</p><div ng-if=\"debitcredit == \'D\'\"><p>Diferença de <strong>{{ ((diff < 0) ? diff * (-1) : diff) | currency}}</strong> a maior.<br>Ajuste os valores das formas de pagamento, ou, se desejar, selecione abaixo para alterar o valor do título.</p><md-radio-group ng-model=\"vm.option_difference\" ng-if=\"billsselected.length == 1\"><md-radio-button ng-value=\"4\">Alterar valor do título</md-radio-button></md-radio-group><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.option_difference == null\" ng-click=\"vm.updateAmounts()\">Ok</md-button></div></div><div layout=\"row\"><div flex=\"70\"></div><div flex=\"30\"><h3 ng-show=\"debitcredit == \'D\'\">Total a pagar: {{ getTotal() | currency:\" \" }}</h3><h3 ng-show=\"debitcredit == \'C\'\">Total a receber: {{ getTotal() | currency:\" \" }}</h3></div></div></div>");
$templateCache.put("app/components/a4-question/templates/editable-question.html","<div layout=\"column\"><md-card><md-card-content><div><div layout=\"row\" layout-align=\"space-between center\" class=\"editor-header\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Conteúdo</b> <small>Escreva aqui o conteúdo da questão.</small></div></div></div><div class=\"compact-editor\"><textarea ui-tinymce=\"vm.tinymceContent\" ng-model=\"question.stem\"></textarea></div></div><br><div><div layout=\"row\" layout-align=\"space-between center\" class=\"editor-header\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>respostas</b> <small>Escreva aqui a(s) resposta(s) da questão.</small></div></div></div><div class=\"compact-editor\"><textarea ui-tinymce=\"vm.tinymceAnswer\" ng-model=\"question.right_answer\"></textarea></div></div></md-card-content></md-card></div>");
$templateCache.put("app/components/a4-question/templates/matrix-multiple-unique.html","<md-input-container style=\"width: 50%\" ng-init=\"vm.addFirstOption()\"><label>Escala da questão</label><md-select ng-model=\"question.question_scale_id\" required=\"\"><md-option ng-repeat=\"scale in questionScales\" ng-value=\"scale.id\">{{scale.name}}</md-option></md-select></md-input-container><div layout=\"column\"><span ng-repeat=\"subitem in question.items\"><md-input-container style=\"width: 85%\"><input type=\"text\" id=\"subitem-{{question.ord}}\" ng-model=\"subitem.name\" required=\"\" maxlength=\"1000\"></md-input-container><a4-card-controls item=\"question\" array=\"questions\" sub-item-index=\"question.items.indexOf(subitem)\" type=\"\'subquestions\'\"></a4-card-controls></span></div>");
$templateCache.put("app/components/a4-question/templates/multiple-line-text.html","<div ng-if=\"questionnaireType < 20\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%\"><label>Resposta certa</label> <textarea rows=\"3\" ng-model=\"question.right_answer\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container></div>");
$templateCache.put("app/components/a4-question/templates/multiple-option.html","<div layout=\"column\" ng-init=\"vm.addFirstOption()\"><span ng-repeat=\"subitem in question.items track by $index\"><md-input-container ng-if=\"questionnaireType < 20\"><md-checkbox ng-model=\"subitem.is_right_answer\" ng-change=\"vm.confirmMulitipleOption(question.items)\" ng-disabled=\"vm.isDisabled\" ng-required=\"!vm.isAtLeastOneChecked\"></md-checkbox></md-input-container><md-input-container><input ng-model=\"subitem.name\" style=\"width: 530px;\" ng-disabled=\"vm.isDisabled\" required=\"\" maxlength=\"1000\" ng-paste=\"vm.subQuestionLines($event)\"></md-input-container><a4-card-controls item=\"question\" array=\"questions\" sub-item-index=\"question.items.indexOf(subitem)\" type=\"\'subquestions\'\" ng-if=\"!vm.isDisabled\"></a4-card-controls></span><div ng-if=\"!vm.isAtLeastOneChecked\"><div>É necessário ter ao menos uma resposta marcada</div></div></div>");
$templateCache.put("app/components/a4-question/templates/one-line-text-number.html","<div ng-if=\"questionnaireType < 20\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%\"><label>Resposta certa</label> <input type=\"text\" ng-model=\"question.right_answer\" ng-disabled=\"vm.isDisabled\"></md-input-container></div>");
$templateCache.put("app/components/a4-question/templates/unique-option.html","<div layout=\"column\" ng-init=\"vm.addFirstOption(); vm.setRightAnswer();\"><md-radio-group ng-model=\"question.right_answer\" ng-change=\"vm.confirmOption()\" ng-if=\"questionnaireType < 20\" required=\"\" ng-repeat=\"subitem in question.items track by $index\" style=\"margin-bottom: 16px; height: 70px\"><div style=\"display: flex; text-justify: center; margin: 0; padding: 0\"><md-radio-button class=\"md-primary md-radio-interactive\" ng-value=\"subitem.ord\" ng-disabled=\"vm.isDisabled\"></md-radio-button><md-input-container style=\"margin: 0; padding: 0\"><input ng-model=\"subitem.name\" style=\"width: 530px;\" required=\"\" ng-disabled=\"vm.isDisabled\" ng-paste=\"vm.subQuestionLines($event)\"></md-input-container><a4-card-controls item=\"question\" array=\"questions\" sub-item-index=\"question.items.indexOf(subitem)\" ng-if=\"!vm.isDisabled\" type=\"\'subquestions\'\"></a4-card-controls></div></md-radio-group><span ng-repeat=\"subitem in question.items track by $index\" ng-if=\"questionnaireType >= 20\"><md-input-container ng-value=\"subitem.ord\"><input ng-model=\"subitem.name\" style=\"width: 560px;\" ng-disabled=\"vm.isDisabled\" maxlength=\"1000\"></md-input-container><a4-card-controls item=\"question\" array=\"questions\" sub-item-index=\"question.items.indexOf(subitem)\" type=\"\'subquestions\'\" style=\"margin: 0; padding: 0\"></a4-card-controls></span></div>");
$templateCache.put("app/components/a4-question/views/file-modal.html","<md-dialog md-theme=\"evaluations\" aria-label=\"{{ \'UPLOAD_IMAGE.EDIT\' | translate }}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar/editar imagem da questão</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"form-wrapper\" style=\"padding-top: 0\" ng-if=\"vm.question.artifact_id !== null\"><md-table-container style=\"width: 100%;\"><table md-table=\"\" ng-model=\"selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Ver</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">{{vm.question.filename}}</td><td md-cell=\"\"><a target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + vm.question.file_reference}}\">Ver arquivo</a></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteFile()\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div><div layout=\"row\" class=\"form-wrapper\" ng-if=\"vm.question.artifact_id === null\"><div flex=\"\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.submit({option: \'save\', file: vm.question})\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-subject-grid/views/add-dependency.html","<md-dialog aria-label=\"Create Subject\" style=\"max-width: 1000px;width: 1000px;\" md-theme=\"educational\"><div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Matrícula em Dependência</span></div><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal(false)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-card style=\"height: 630px;\" ng-if=\"vm.show_loader\"><div style=\"margin: 25% auto 0px 45%\" ng-if=\"true\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"70\"></md-progress-circular></div></md-card><md-card layout-padding=\"\" class=\"with-btn-add\" ng-if=\"!vm.show_loader\"><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-content ng-cloak=\"\" style=\"height: 540px;\" flex=\"40\"><md-subheader class=\"md-primary\">Turmas disponíveis</md-subheader><a4-tree-grid tree-data=\"vm.coursesAndGroups\" col-defs=\"vm.col_defs_services\" expand-on=\"vm.expanding_property\" expand-level=\"1\" on-click=\"vm.selectGroup(branch)\" icon-leaf=\'row.branch.children.length <= 0 && row.level == 2 ? \"no-icon\" : \"no-icon\"\' icon-expand=\'row.branch.children.length > 0 && !row.branch.expanded ? \"icon-chevron-right\" : \"icon-chevron-down\"\' icon-collapse=\'row.branch.children.length > 0 && row.branch.expanded ? \"icon-chevron-down\" : \"icon-chevron-right\"\'></a4-tree-grid></md-content><md-content ng-cloak=\"\" flex=\"60\" style=\"height: 540px;padding-left: 5px;\"><md-subheader class=\"md-primary\">Disciplinas | Turma: {{vm.group.text}}</md-subheader><form><div layout=\"column\" flex-gt-xs=\"\" class=\"md-block\"><label for=\"select-year\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Ano</span></label><select2 ng-model=\"vm.dependency_year\" s2-options=\"year.id as year.name for year in vm.years\" id=\"select-year\" ng-disabled=\"false\" flex-gt-xs=\"\"></select2></div></form><md-table-container><table md-table=\"\" md-progress=\"vm.promise\" multiple=\"\" ng-model=\"vm.selected_subjects\" md-row-select=\"\"><thead md-head=\"\"><tr md-row=\"\" style=\"height: 28px !important;\"><th md-column=\"\" style=\"padding-left: 10px !important;\">Nome</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" style=\"cursor: pointer; height: 28px !important;\" md-auto-select=\"\" ng-repeat=\"item in vm.subjects_list\" md-select=\"item\" md-select-id=\"id\"><td md-cell=\"\" style=\"padding-left: 10px !important;\">{{ item.name }}</td></tr></tbody></table></md-table-container></md-content></md-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.selected_subjects.length <= 0 || vm.dependency_year == null\" ng-click=\"vm.enrolmentDependency()\">Matricular</md-button></md-dialog-actions></md-card></div></md-dialog>");
$templateCache.put("app/components/a4-subject-grid/views/modal-details-item.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"min-width: 500px;\"><form ng-cloak=\"\" name=\"extra_grade_form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.scope.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\" flex=\"\"><div layout=\"column\" flex=\"100\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"number\" step=\"0.1\" ng-model=\"vm.scope.item.final_grade\" placeholder=\"Nota\" required=\"\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" maxlength=\"10\" ng-model=\"vm.scope.item.external_school_period\" placeholder=\"Período Letivo\" required=\"\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder isEnabled\" flex-gt-xs=\"\"><label class=\"isEnabled\">Professor</label> <input ng-model=\"vm.scope.item.teacher_name\" name=\"collaborator_name\"></md-input-container><div layout=\"column\" flex-gt-xs=\"\" style=\"margin-bottom: 0 !important; margin-left: 2px;\"><label for=\"select-educational-level\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Nível educacional</span></label><select2 ng-model=\"vm.scope.item.person_educational_level_id\" s2-options=\"val.id as val.name for val in vm.person_educational_level\" id=\"select-educational-level\" flex-gt-xs=\"\"></select2></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.answer();\" ng-disabled=\"extra_grade_form.$invalid\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-subject-grid/views/modal-print-records.html","<md-dialog aria-label=\"Print Records\" md-theme=\"educational\"><md-dialog-content><a4-school-record-config config=\"vm.scope\"></a4-school-record-config></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-click=\"vm.answer(vm.scope);\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-subject-grid/views/select-group-enrolment.html","<md-dialog md-theme=\"educational\" aria-label=\"{{vm.subject_name}}\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\"><h1>{{vm.subject_name}}</h1><span flex=\"\"></span><md-button class=\"md-icon-button md-button ng-scope md-ink-ripple md-default-theme\" ng-click=\"vm.closeModal();\"><md-icon aria-label=\"Close dialog\"><i class=\"material-icons\">close</i></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" style=\"border-left: solid 4px #1c82cc\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Turmas disponíveis</b> <small>Selecione a turma desejada para matrícula</small></div></div><br><md-radio-group ng-model=\"vm.group_id\" layout=\"column\"><md-radio-button ng-repeat=\"group in vm.groups\" flex=\"\" value=\"{{group.subj_group_id}}\" class=\"md-primary\">{{group.course_name}} | {{group.group_name}} | {{group.matrix_period}}<md-icon md-font-icon=\"icon-alert\" ng-if=\"group.clash.length > 0\" class=\"md-warn\"><md-tooltip md-direction=\"top\"><span>CHOQUE DE HORÁRIO<br></span> <span ng-repeat=\"item in group.clash\" ng-if=\"item.day_of_week != null\">{{item.subject_alias}} ({{item.day_of_week == null ? \'\' : item.day_of_week | dayOfWeek}} {{item.initial_time.slice(0,-3)}} - {{item.final_time.slice(0,-3)}})<br></span></md-tooltip></md-icon><span ng-if=\"group.timetable.length > 0 && group.timetable[0].day_of_week != null\" ng-repeat=\"item in group.timetable track by $index\">({{item.day_of_week == null ? \'\' : item.day_of_week | dayOfWeek}} {{item.initial_time.slice(0,-3)}} - {{item.final_time.slice(0,-3)}})</span> <small ng-if=\"group.subject_name !== vm.subject_name\"><br>{{group.subject_name}}</small></md-radio-button></md-radio-group></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-primary\" ng-click=\"vm.submit(vm.group_id)\">Matricular</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/a4-subject-grid/views/subjects.html","<md-content layout=\"column\" layout-align=\"center center\"><md-card flex=\"100\" layout=\"row\" ng-if=\"vm.school_period_default_enrolment_id !== vm.current_school_period_id\"><div flex=\"\" style=\"background-color: #f57c00; width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p><span style=\"font-size: 18px; color: #fff; padding: 15px\">Período letivo selecionado diferente do padrão para matrículas: {{vm.school_period_default_enrolment_name}}.</span></p></div></md-card><div flex=\"100\" style=\"width: 70%;\"><table class=\"simple\"><thead><tr><th>Apelido</th><th colspan=\"2\">Nome</th><th style=\"text-align: center !important;\">Obrigatoriedade</th><th style=\"text-align: center !important;\">Situação</th><th style=\"text-align: center !important;\" ng-if=\"vm.current_school_period_id != 0\">PL</th><th style=\"text-align: center !important;\">Turma</th><th style=\"text-align: center !important;\"><md-button class=\"md-icon-button\" ng-click=\"vm.printHistory()\" ng-if=\"vm.course_equivalence_id >= 300\"><md-icon md-font-icon=\"icon-printer\" style=\"color: #7291e0\"></md-icon><md-tooltip md-direction=\"right\">Imprimir histórico</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.addDependency()\" ng-if=\"vm.course_equivalence_id < 300\"><md-icon md-font-icon=\"icon-plus\" style=\"color: #7291e0\"></md-icon><md-tooltip md-direction=\"right\">Adicionar dependência</md-tooltip></md-button></th></tr></thead><tfoot></tfoot><tbody><tr ng-repeat-start=\"item in vm.data track by $index\" class=\"group-table\" style=\"background-color: rgb(225, 225, 225) !important;\"><td><strong>{{vm.data.length > 1 ? item.matrix_period + \'º Periodo\' : \'Disciplinas da grade\'}}</strong></td><td></td><td></td><td></td><td></td><td ng-if=\"vm.current_school_period_id != 0\"></td><td></td><td></td></tr><tr ng-repeat-start=\"subject_item in item.children track by $index\" ng-style=\"{\'background-color\': vm.getBackgroundColor(subject_item)}\"><td>{{ subject_item.subject_alias }}</td><td colspan=\"2\">{{ subject_item.subject_name }} {{subject_item.dependency_year !== null ? \' (DEP - \'+subject_item.dependency_year+\')\' : \'\'}}</td><td align=\"center\" ng-if=\"subject_item.how_required == 1\">Obrigatória</td><td align=\"center\" ng-if=\"subject_item.how_required == 2\">Optativa</td><td align=\"center\" ng-if=\"subject_item.how_required == 3\">Eletiva</td><td align=\"center\"><span class=\"badge\" style=\"padding: 0;margin-left: 0;\"><span ng-if=\"(subject_item.is_not_available == true &&subject_item.academic_status_id == null) && vm.course_equivalence_id >= 300\" class=\"sem-resultado\">Sem turmas</span> <span ng-if=\"subject_item.restrictions_str != null\" class=\"sem-resultado\">Req. não atendido<md-tooltip md-direction=\"top\"><span ng-repeat=\"item in subject_item.restrictions_str.split(\'|\')\">{{item}}<br></span></md-tooltip></span> <span ng-if=\"(subject_item.school_period_id != 0 && (subject_item.school_period_id !== null && (subject_item.enrolment_status_id == 10 && subject_item.academic_status_id < 10) && subject_item.school_period_id >= vm.school_period_default_enrolment_id)) || (subject_item.school_period_id == 0 && subject_item.enrolment_period_matrix_period >= vm.matrix_period && (subject_item.enrolment_status_id == 10 && subject_item.academic_status_id < 10))\" class=\"matriculado\">Matriculado</span> <span ng-if=\"(subject_item.school_period_id != 0 && (subject_item.school_period_id !== null && (subject_item.enrolment_status_id == 10 && subject_item.academic_status_id < 10) && subject_item.school_period_id < vm.school_period_default_enrolment_id)) || (subject_item.school_period_id == 0 && subject_item.enrolment_period_matrix_period < vm.matrix_period && (subject_item.enrolment_status_id == 10 && subject_item.academic_status_id < 10))\" class=\"sem-resultado\">Sem resultado</span> <span ng-if=\"subject_item.school_period_id !== null && (subject_item.enrolment_status_id == 10 && (subject_item.academic_status_id >= 10 && subject_item.academic_status_id <= 19))\" class=\"concluido\">{{subject_item.academic_status_name}}{{subject_item.final_grade != null ? \' - \' + (subject_item.final_grade | number: 1) : \'\'}}</span> <span ng-if=\"subject_item.school_period_id !== null && (subject_item.enrolment_status_id == 10 && (subject_item.academic_status_id >= 20 && subject_item.academic_status_id <= 29))\" class=\"reprovado\">{{subject_item.academic_status_name}}{{subject_item.final_grade != null ? \' - \' + (subject_item.final_grade | number: 1) : \'\'}}</span> <span ng-if=\"subject_item.enrolment_status_id >= 30 && subject_item.enrolment_status_id <= 32\" class=\"trancado\">{{subject_item.enrolment_status_name}}</span> <span ng-if=\"subject_item.enrolment_status_id >= 40 && subject_item.enrolment_status_id <= 42\" class=\"aproveitado\">{{subject_item.enrolment_status_name}}{{subject_item.final_grade != null ? \' - \' + (subject_item.final_grade | number: 1) : \'\'}}</span></span><md-icon md-font-icon=\"icon-alert\" ng-if=\"((subject_item.school_period_id !== null && (subject_item.enrolment_status_id == 10 && subject_item.academic_status_id < 10) && subject_item.school_period_id >= vm.school_period_default_enrolment_id) && subject_item.clash.length > 0 && subject_item.clash[0].day_of_week != null) && vm.course_equivalence_id >= 300\" class=\"md-warn\"><md-tooltip md-direction=\"top\"><span>CHOQUE DE HORÁRIO<br></span><span ng-repeat=\"item in subject_item.clash\" ng-if=\"item.day_of_week != null\">{{item.subject_alias}} ({{item.day_of_week == null ? \'\' : item.day_of_week | dayOfWeek}} {{item.initial_time.slice(0,-3)}} - {{item.final_time.slice(0,-3)}})<br></span></md-tooltip></md-icon></td><td align=\"center\" ng-if=\"vm.current_school_period_id != 0\">{{ subject_item.school_period_name }}</td><td align=\"center\" ng-if=\"subject_item.enrolment_status_id >= 40 && subject_item.enrolment_status_id <= 42\"></td><td align=\"center\" ng-if=\"!(subject_item.enrolment_status_id >= 40 && subject_item.enrolment_status_id <= 42)\">{{ subject_item.group_name }} {{subject_item.school_period_id == 0 ? \' | \' + subject_item.enrolment_subject_matrix_period : \'\'}}</td><td style=\"padding: 0; text-align: center !important;\"><md-menu ng-if=\"vm.profile !== 1 && vm.current_profile !== vm.is_student\"><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event);$event.stopPropagation()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"6\"><md-menu-item ng-show=\"vm.course_equivalence_id >= 300\"><md-button ng-click=\"vm.getGroupsEnrolment(subject_item)\" ng-disabled=\"subject_item.enrolment_status_id !== null || subject_item.restrictions_str != null || subject_item.is_not_available == true\"><md-icon>done</md-icon>Matricular</md-button></md-menu-item><md-menu-item ng-show=\"vm.course_equivalence_id >= 300 && subject_item.enrolment_status_id === 10\"><md-button ng-click=\"vm.getGroupsEnrolment(subject_item)\" ng-disabled=\"subject_item.academic_status_id > 9\"><md-icon>edit</md-icon>Editar matrícula</md-button></md-menu-item><md-menu-item ng-show=\"vm.course_equivalence_id >= 300\"><md-button ng-click=\"vm.modalDetailsStatus(subject_item, 40, \'Estudos Aproveitados\')\" ng-disabled=\"subject_item.enrolment_status_id !== null\"><md-icon>done</md-icon>Estudos Aproveitados</md-button></md-menu-item><md-menu-item ng-show=\"vm.course_equivalence_id >= 300\"><md-button ng-click=\"vm.modalDetailsStatus(subject_item, 42, \'Aproveitamento Extraordinário\')\" ng-disabled=\"subject_item.enrolment_status_id !== null\"><md-icon>done_all</md-icon>Aproveitamento Extraordinário</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.changeStatus(subject_item, 41)\" ng-disabled=\"( subject_item.enrolment_status_id !== 10 || ( subject_item.enrolment_status_id === 10 && subject_item.academic_status_id !== 0 ) )\"><md-icon>remove</md-icon>Dispensa</md-button></md-menu-item><md-menu-item ng-show=\"vm.course_equivalence_id >= 300\"><md-button ng-click=\"vm.changeStatus(subject_item, 30)\" ng-disabled=\"subject_item.enrolment_status_id !== 10 || subject_item.academic_status_id > 9\"><md-icon>lock</md-icon>Trancamento</md-button></md-menu-item><md-menu-item ng-show=\"vm.course_equivalence_id >= 300\"><md-button ng-click=\"vm.changeStatus(subject_item, 32)\" ng-disabled=\"subject_item.enrolment_status_id !== 10 || subject_item.academic_status_id > 9\"><md-icon>cancel_presentation</md-icon>Cancelamento</md-button></md-menu-item><md-menu-item ng-show=\"vm.course_equivalence_id >= 300\"><md-button ng-click=\"vm.changeStatus(subject_item, 31)\" ng-disabled=\"subject_item.enrolment_status_id !== 10 || subject_item.academic_status_id > 9\"><md-icon>exit_to_app</md-icon>Abandono</md-button></md-menu-item><md-menu-item ng-show=\"( subject_item.enrolment_status_id == 30 || subject_item.enrolment_status_id == 31 || subject_item.enrolment_status_id == 32 || subject_item.enrolment_status_id == 41 )\"><md-button ng-click=\"vm.changeStatus(subject_item, 10)\"><md-icon>undo</md-icon>Desfazer</md-button></md-menu-item><md-menu-item ng-show=\"( subject_item.enrolment_status_id == 10 && vm.course_equivalence_id >= 300 ) || subject_item.enrolment_status_id == 40 || subject_item.enrolment_status_id == 42 || subject_item.dependency_year != null\"><md-button ng-click=\"vm.changeStatus(subject_item, 99)\" ng-disabled=\"subject_item.academic_status_id >= 10 && subject_item.academic_status_id <= 29\"><md-icon>undo</md-icon>Desfazer</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr ng-repeat-end=\"\" ng-hide=\"true\"></tr><tr ng-repeat-end=\"\" ng-hide=\"true\"></tr></tbody></table></div></md-content>");
$templateCache.put("app/components/a4-table/sidenavs/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}</span></div><md-divider></md-divider><div ms-scroll=\"\" class=\"content scrollable\"><md-list><md-list-item ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"PERSON.ALL_PERSONS\">All contacts</p></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\">{{ \'PERSON.GROUPS\' | translate }}</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" ng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">{{group.name}}</p></md-list-item></md-list></div>");
$templateCache.put("app/components/a4-table/view/index.html","<div id=\"table-material\" style=\"clear: both\"><div ng-show=\"vm.selectedItems.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedItems =[]\"><md-button layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span translate=\"TABLE.BACK\"></span></md-button></div><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>{{vm.selectedItems.length}}</span> <span translate=\"TABLE.SELECTED\">selected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate=\"\" translate-attr-aria-label=\"TABLE.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllItems()\" translate=\"TABLE.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectItems()\" translate=\"TABLE.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedItems($event)\" aria-label=\"delete selected\" translate=\"\" translate-attr-label=\"TABLE.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg=\"\" layout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll=\"\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ng-if=\"withLeftSideNav\" ms-sidenav-helper=\"\" ng-include=\"\'app/components/a4-table/sidenavs/main-sidenav.html\'\"></md-sidenav><div class=\"main scrollable\" ms-scroll=\"\"><md-list class=\"contacts-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" translate=\"TABLE.ALL_ITEMS\"></span> <span ng-if=\"filteredContacts.length\" class=\"secondary-text contacts-count\">({{filteredContacts.length}})</span></div><div class=\"edit-group-form\" ng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span ng-show=\"editGroupForm.$visible\" editable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup()\"></span><md-button class=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" aria-label=\"edit group name\" translate=\"\" translate-attr-label=\"TABLE.EDIT_GROUP_NAME\"><md-icon md-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button class=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup($event)\" ng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate=\"\" translate-attr-label=\"TABLE.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button></div><div flex=\"\"></div><md-menu ng-show=\"withListOrderBy\"><md-button class=\"md-icon-button\" aria-label=\"Sort\" translate=\"\" translate-attr-aria-label=\"TABLE.SORT\"><md-icon md-font-icon=\"icon-sort-alphabetical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.listOrder = \'name\';vm.listOrderAsc = false\" ng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span translate=\"TABLE.FIRST_NAME\">First Name</span> <small translate=\"TABLE.A_TO_Z\">(A to Z)</small></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'name\'; vm.listOrderAsc = true\" ng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span translate=\"TABLE.FIRST_NAME\">First Name</span> <small translate=\"TABLE.Z_TO_A\">(Z to A)</small></md-button></md-menu-item></md-menu-content></md-menu></div></md-subheader><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple=\"\" ng-disabled=\"vm.checkPolicies(\'estoque\')\" ng-repeat=\"item in vm.items | filter: vm.search | filter: global.search | filterByIds:vm.filterIds | orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContacts track by item.id\" ng-click=\"vm.openTableItem($event, $index,\'sidenav-form\', includeScope)\" ng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContacts.length - $index}\" ng-class=\"{\'selected\': vm.isSelected(item)}\"><md-checkbox ng-checked=\"vm.exists(item, vm.selectedItems)\" ng-click=\"vm.toggleSelectItem(item, $event)\" ng-if=\"withListCheckBox\" aria-label=\"{{vm.exists(item, vm.selectedItems) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div ng-repeat=\"idx in getKeys($index)\" class=\"dynamic-div\" ng-show=\"idx != \'id\'\"><p class=\"{{idx}} text-truncate show-gt-sm\"><span ng-if=\"idx != \'amount\' && idx != \'price\'\">{{vm.getTranslateValue($parent.$parent.$index, idx)}}</span><span ng-if=\"idx == \'amount\'\">{{vm.getAmountFormat($parent.$parent.$index, idx)}}</span> <span ng-if=\"idx == \'price\'\">{{vm.getAmountFormat($parent.$parent.$index, idx)}}</span></p></div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" ng-hide=\"withoutMenuOptions\" translate=\"\" ng-disabled=\"vm.checkPolicies(\'estoque_alt\')\" translate-attr-aria-label=\"TABLE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"onDelete({index: $index})\" ng-disabled=\"vm.checkPolicies(\'estoque_alt\')\">{{ \'TABLE.DELETE_ITEM\' | translate }}</md-button></md-menu-item><md-divider ng-if=\"vm.user.groups\"></md-divider><md-subheader class=\"md-no-sticky\" ng-if=\"vm.user.groups\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" ng-click=\"vm.toggleInArray(item.id,group.contactIds)\"><p class=\"pl-8\" ng-style=\"vm.exists(contact.id,group.contactIds) && {\'font-weight\':\'500\'}\">{{group.name}}</p></md-list-item></md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p translate=\"TABLE.NO_RESULTS\">No results..</p></md-list-item></div><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-form\" ms-scroll=\"\" ng-include=\"sidebarTemplate\"></md-sidenav></div></div>");
$templateCache.put("app/components/a4-table-advanced/view/categories.html","<style>\n    .link-style {\n        text-decoration: none !important;\n    }\n\n    .link-style:hover {\n        color: #9B0000;\n    }\n</style><div class=\"col-md-12\"><div class=\"section\"><div class=\"col-md-12 padding-left-right0\"><div class=\"panel ice-background-a4\"><div class=\"panel-body\"><div class=\"form-horizontal\" role=\"form\"><div class=\"form-group\" ng-repeat=\"item in list\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\"><div class=\"form-group form-md-line-input form-md-floating-label\"><div class=\"input-group left-addon right-addon\"><span class=\"input-group-btn btn-left\"><i class=\"material-icons\">settings_applications</i></span><ui-select ng-model=\"item.category\" search-enabled=\"true\" id=\"bill_categories\" ng-show=\"!hidecategory\" ng-disabled=\"disablecategory\"><ui-select-match placeholder=\"@ \'CATEGORY\' | translate @\">@$select.selected.name | translate@</ui-select-match><ui-select-choices repeat=\"category in billCategories | filter: $select.search\"><span ng-bind-html=\"category.name | translate | highlight: $select.search\"></span><br><small ng-bind-html=\"category.path | translate | highlight: $select.search\" class=\"font-sm color-grey\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group form-md-line-input form-md-floating-label\" ng-show=\"!hidevalue\"><div class=\"input-group left-addon right-addon\"><span class=\"input-group-btn btn-left\"><i class=\"material-icons\">attach_money</i></span> <input type=\"text\" class=\"categoryAmount\" id=\"category_amount\" ng-disabled=\"edit != 2 && disablevalue\" ng-model=\"item.amount\" name=\"categoryAmount\" ng-keyup=\"calcAmount(item.amount)\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\"> <label ng-if=\"edit != 4 && !hidevalue\">@ \'AMOUNT\' | translate @</label> <label ng-if=\"edit == 4 && !hidevalue\">@ \'AMOUNT_PORTION\' | translate @</label> <span class=\"input-group-addon\"><input tooltip-hint=\"INACCURATE_VALUE\" ng-disabled=\"edit != 2 && !item.is_inaccurate_amount\" data-toggle=\"tooltip\" data-placement=\"top\" type=\"checkbox\" name=\"is_inaccurate_amount\" ng-model=\"item.is_inaccurate_amount\"></span></div></div></div><div class=\"col-md-1 col-md-1 col-sm-1 col-xs-1 padding0 font-grey-cascade\" ng-if=\"$index >= 1\"><i class=\"material-icons rm\" ng-click=\"remove($index)\">remove_circle_outline</i></div></div></div><a class=\"font-grey-cascade\" ng-click=\"addBlankItem(\'edit\')\" ng-if=\"!edit && !hideadditem\"><i class=\"material-icons\">note_add</i> <span class=\"caption-subject bold uppercase\">Adicionar item</span></a><div class=\"text-danger\"></div></div></div></div></div></div>");
$templateCache.put("app/components/a4-table-advanced/view/payment_form.html","<strong class=\"group-field\"><small>Formas de Pagamento</small></strong><div class=\"pretty-small\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-repeat=\"item in list\"><md-input-container flex=\"25\"><label>Conta</label><md-select ng-model=\"item.current_account_id\" ng-change=\"setValuePayment($index); setPaymentMethod(item.current_account_id)\" placeholder=\"Conta\" ng-disabled=\"readonly\"><md-option ng-value=\"caccounts.id\" ng-repeat=\"caccounts in currentAccounts\" ng-disabled=\"bill.status == 10\">{{ caccounts.name }}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Forma de Pagamento</label><md-select ng-model=\"item.movement_type_id\" ng-change=\"setValuePayment($index); setPaymentMethod(item.current_account_id)\" placeholder=\"Forma de Pagamento\" ng-disabled=\"readonly\"><md-option ng-value=\"pm.id\" ng-repeat=\"pm in payment_method\" ng-disabled=\"bill.status == 10\">{{ pm.name }}</md-option></md-select></md-input-container><md-input-container flex=\"20\"><input type=\"text\" ng-model=\"item.document\" ng-disabled=\"bill.status == 10 || readonly == true\" placeholder=\"N. Documento\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" ng-disabled=\"bill.status == 10 || readonly == true\" ng-model=\"item.amount\" ng-keyup=\"calcAmountPayment()\" ng-blur=\"calcAmountPayment()\" ng-click=\"verifySupliers(bill)\" ng-value=\"applyMask(totalcurrencyPayment)\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" placeholder=\"Valor\"></md-input-container><div flex=\"5\" ng-if=\"waspaid == 0 && block == false\"><md-button class=\"md-icon-button\" aria-label=\"Adicionar item\" ng-click=\"addBlankItem(\'edit\')\"><md-tooltip>Adicionar</md-tooltip><md-icon md-font-icon=\"icon-plus-circle\" class=\"s20\"></md-icon></md-button></div><div flex=\"5\" ng-if=\"$index >= 1 && block == false\"><md-button class=\"md-icon-button\" ng-click=\"remove($index);\"><md-tooltip>Deletar</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></div></div><div class=\"alert\" ng-if=\"diference.error && !readonly\"><div class=\"col-md-8 alert alert-danger\" ng-if=\"diference.error\"><span class=\"text-danger\">{{diference.message}}</span> <input type=\"checkbox\" name=\"payment_with_difference\" ng-if=\"diference.allowPayDiff && !verifySupliers(bill)\" ng-change=\"payWithDiff(bill.payment_with_difference)\" ng-model=\"bill.payment_with_difference\"> <label class=\"control-label\" ng-if=\"diference.allowPayDiff && !verifySupliers(bill)\">Realizar Pagamento com Diferença</label></div></div><div ng-if=\"bill.payment_with_difference\"><datepicker date=\"bill.diff_date\"></datepicker></div></div>");
$templateCache.put("app/components/a4-table-check/sidenavs/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}</span></div><md-divider></md-divider><div ms-scroll=\"\" class=\"content scrollable\"><md-list><md-list-item ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"PERSON.ALL_PERSONS\">All contacts</p></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\">{{ \'PERSON.GROUPS\' | translate }}</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" ng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">{{group.name}}</p></md-list-item></md-list></div>");
$templateCache.put("app/components/a4-table-check/view/index.html","<div id=\"table-material\" style=\"clear: both\"><div ng-show=\"vm.selectedItems.length\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedItems =[]\"><md-button layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span translate=\"TABLE.BACK\"></span></md-button></div><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>{{vm.selectedItems.length}}</span> <span translate=\"TABLE.SELECTED\">selected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate=\"\" translate-attr-aria-label=\"TABLE.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllItems()\" translate=\"TABLE.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectItems()\" translate=\"TABLE.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedItems($event)\" aria-label=\"delete selected\" translate=\"\" translate-attr-label=\"TABLE.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg=\"\" layout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll=\"\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ng-if=\"withLeftSideNav\" ms-sidenav-helper=\"\" ng-include=\"\'app/components/a4-table/sidenavs/main-sidenav.html\'\"></md-sidenav><div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" flex=\"100\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div class=\"main scrollable\" ms-scroll=\"\" style=\"margin-bottom: 50px; !important;\"><md-list class=\"contacts-list\" flex=\"\"><div class=\"main scrollable\" ms-scroll=\"\"><div class=\"md-card-list-wrapper\" id=\"bill-box\"><div class=\"uk-width-large-8-10 uk-container-center\"><div class=\"md-card-list\"><ul hierarchical-slide=\"\"><li ng-repeat=\"item in vm.items track by $index\" on-last-repeat=\"\" class=\"{{ item.status_name }}\"><div layout=\"row\"><div class=\"md-card-list-item-select\" ng-if=\"withListCheckBox\"><md-checkbox md-no-ink=\"\" aria-label=\"Selecione\" class=\"md-primary\" ng-checked=\"vm.exists(item, vm.listCheckBills)\" ng-click=\"vm.toggle(item, vm.listCheckBills)\"></md-checkbox></div><span flex=\"15\" flex-xs=\"20\" flex-md=\"25\" class=\"md-card-list-item-avatar-wrapper\"><span class=\"status label-{{item.check_status_id}}\">{{item.check_status_name}}</span></span> <span flex=\"10\" flex-xs=\"10\" flex-md=\"10\" flex-sm=\"10\" class=\"md-card-list-item-date\">{{item.date | date:\'dd/MM/yyyy\'}}</span><div flex=\"10\" flex-xs=\"10\" flex-md=\"10\" flex-sm=\"10\" class=\"md-card-list-item\"><span><b>{{item.person_name}}</b></span></div><div flex=\"10\" flex-xs=\"10\" flex-md=\"10\" flex-sm=\"10\" class=\"md-card-list-item-date\"><span><b>N.º {{item.number}}</b></span></div><span flex=\"20\" flex-xs=\"25\" flex-md=\"15\" flex-sm=\"20\" class=\"md-card-list-item\">{{item.bank_name}}</span><div flex=\"20\" flex-xs=\"25\" flex-md=\"15\" flex-sm=\"20\" class=\"md-card-list-item-date\"><span>{{item.current_account_name | uppercase}}</span></div><div flex=\"10\" flex-sm=\"10\" flex-xs=\"10\" class=\"md-card-list-item-avatar-wrapper md-card-list-item-amount\"><strong>{{item.amount | currency}}</strong></div><div flex=\"15\" flex-md=\"30\" flex-sm=\"20\" flex-xs=\"25\" policy-access=\"cheq_alt\"><div class=\"md-card-list-item-menu\" ng-hide=\"vm.listCheckBills.length >= 2\" layout=\"row\"><md-button flex=\"\" aria-label=\"comment\" class=\"md-icon-button md-mini fast-pay\" ng-if=\"item.status == 1 && item.debit_credit == \'D\'\" ng-click=\"vm.setPayment($emit(\'setpayment\'), item, \'sidenav-payment-form\');\"><md-icon><i class=\"material-icons\">attach_money</i></md-icon><md-tooltip md-direction=\"bottom\">Pagar</md-tooltip></md-button><md-button flex=\"\" aria-label=\"comment\" class=\"md-icon-button md-mini\" ng-if=\"item.status == 10\" ng-click=\"vm.undoPayment($emit(\'undopayment\'), item, \'sidenav-reverse-form\');\"><md-icon><i class=\"material-icons\">money_off</i></md-icon><md-tooltip md-direction=\"bottom\">Estornar</md-tooltip></md-button><md-menu-bar><md-menu><button ng-click=\"$mdMenu.open()\"><md-icon><i class=\"material-icons\">more_vert</i></md-icon><md-tooltip md-direction=\"bottom\">Opções</md-tooltip></button><md-menu-content><md-menu-item class=\"md-in-menu-bar\" ng-show=\"item.check_status_id == 0 || item.check_status_id == 5\"><button class=\"md-button\" ng-click=\"addCheckDescription({id: item.check_id})\"><md-icon md-menu-origin=\"\">track_changes</md-icon>Adicionar observação</button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-show=\"item.check_status_id == 0 || item.check_status_id == 5\"><button class=\"md-button\" ng-click=\"changeDueDate({id: item.check_id})\"><md-icon md-menu-origin=\"\">receipt</md-icon>Reprogramar data de vencimento</button></md-menu-item><md-menu-item class=\"md-in-menu-bar\"><button class=\"md-button\" ng-click=\"getOperationOrigin({id: item.check_id})\"><md-icon md-menu-origin=\"\">pageview</md-icon>Visualizar a operação de origem</button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></div><div class=\"md-card-list-item-content-wrapper\" layout=\"column\" ng-if=\"!vm.checkPolicies(\'cheq\')\"><div class=\"md-card-list-item-content\"><table class=\"md-api-table\"><thead><tr></tr></thead><tbody><tr><td>Banco</td><td>{{item.bank_number}} | {{item.bank_name}}</td></tr><tr><td>Agencia</td><td>{{item.account}}</td></tr><tr><td>Conta</td><td>{{item.branch}}</td></tr><tr><td>Bom para</td><td>{{item.date | date:\'dd/MM/yyyy\'}}</td></tr><tr ng-if=\"item.issuer_name != null\"><td>Responsável</td><td>{{item.issuer_name}}</td></tr><tr><td>Localização</td><td>{{item.current_account_name}}</td></tr><tr><td>Status</td><td>{{item.check_status_name}}</td></tr><tr><td>Valor</td><td>{{item.amount | currency}}</td></tr><tr><td>Notas</td><td>{{item.notes}}</td></tr></tbody></table></div></div></li></ul></div></div></div></div></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p translate=\"TABLE.NO_RESULTS\">No results..</p></md-list-item></div></div><md-sidenav flex=\"20\" id=\"floating\" ng-class=\"vm.scrolled ? \'floating-true\' : \'floating-false\'\" ng-show=\"vm.listCheckBills.length >= 2\" class=\"sidenav main-sidenav md-white-bg\" ms-scroll=\"\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" md-component-id=\"sidenav\"><md-list flex=\"\"><md-list-item ng-click=\"vm.toggle.multiples = !vm.toggle.multiples\" ng-show=\"vm.listCheckBills.length >= 2\"><md-icon>settings</md-icon><span flex=\"100\">Opções</span><md-icon ng-show=\"!vm.toggle.multiples\">expand_more</md-icon><md-icon ng-show=\"vm.toggle.multiples\">expand_less</md-icon></md-list-item><md-list-item ng-show=\"vm.listCheckBills.length >= 2 && vm.toggle.multiples\" ng-click=\"vm.accountDeposite(vm.listCheckBills)\"><md-icon>attach_money</md-icon><span flex=\"100\">Depósito em conta</span></md-list-item><md-list-item ng-show=\"vm.listCheckBills.length >= 2 && vm.toggle.multiples\" ng-click=\"vm.sendToBank(vm.listCheckBills)\"><md-icon md-font-icon=\"icon-bank\"></md-icon><span flex=\"100\">Custódia</span></md-list-item><md-list-item ng-show=\"vm.listCheckBills.length >= 2 && vm.toggle.multiples\" ng-click=\"vm.bankDiscount(vm.listCheckBills)\"><md-icon md-font-icon=\"icon-chevron-double-down\"></md-icon><span flex=\"100\">Descontar</span></md-list-item><md-list-item ng-show=\"vm.listCheckBills.length >= 2 && vm.toggle.multiples\" ng-click=\"vm.checkTransfer(vm.listCheckBills)\"><md-icon md-font-icon=\"icon-transfer\"></md-icon><span flex=\"100\">Transferência</span></md-list-item><md-list-item ng-show=\"vm.listCheckBills.length >= 2 && vm.toggle.multiples\" ng-click=\"vm.retrieveCheck(vm.listCheckBills)\"><md-icon md-font-icon=\"icon-backup-restore\"></md-icon><span flex=\"100\">Resgate</span></md-list-item></md-list></md-sidenav></div></div>");
$templateCache.put("app/components/a4-table-expandable/sidenavs/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}</span></div><md-divider></md-divider><div ms-scroll=\"\" class=\"content scrollable\"><md-list><md-list-item ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"PERSON.ALL_PERSONS\">All contacts</p></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\">{{ \'PERSON.GROUPS\' | translate }}</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" ng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">{{group.name}}</p></md-list-item></md-list></div>");
$templateCache.put("app/components/a4-table-expandable/view/a4-table-expandable-index.html","<div class=\"container-fliters\" layout=\"row\" style=\"padding: 0px;\" ng-show=\"vm.listCheckBills.length >= 2\"><a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-show=\"vm.listCheckBills.length >= 2\" ng-click=\"vm.setPaymentMultiple($emit(\'setpayment\'), vm.listCheckBills, \'sidenav-payment-form\');\"><md-icon>attach_money</md-icon><div ng-if=\"vm.items[0].debit_credit == \'D\'\">Pagar</div><div ng-if=\"vm.items[0].debit_credit == \'C\'\">Receber</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-show=\"vm.listCheckBills.length >= 2\"><md-icon>delete_forever</md-icon><div>Excluir</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-show=\"vm.listCheckBills.length >= 2\"><md-icon>cancel</md-icon><div>Cancelar</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-show=\"vm.listCheckBills.length >= 2\" ng-click=\"vm.setNegotiateMultiple($emit(\'setnegotiate\'), vm.listCheckBills, \'sidenav-negotiate-form\');\"><md-icon>done_all</md-icon><div flex=\"100\">Negociar</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-show=\"vm.listCheckBills.length >= 2\"><md-icon>done</md-icon><div>Dispensar</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-show=\"vm.listCheckBills.length >= 2\"><md-icon>announcement</md-icon><div>Marcar como \"duvidoso\"</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-show=\"vm.listCheckBills.length >= 2\"><md-icon>report</md-icon><div>Marcar como \"prejuízo\"</div></a></div><div id=\"table-material\" ng-init=\"vm.toggle.bill_detail = true\" class=\"container-fliters\"><div ng-show=\"vm.selectedItems.length\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedItems =[]\"><md-button layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span translate=\"TABLE.BACK\"></span></md-button></div><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>{{vm.selectedItems.length}}</span> <span translate=\"TABLE.SELECTED\">selected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate=\"\" translate-attr-aria-label=\"TABLE.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllItems()\" translate=\"TABLE.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectItems()\" translate=\"TABLE.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedItems($event)\" aria-label=\"delete selected\" translate=\"\" translate-attr-label=\"TABLE.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div md-background-bg=\"\" layout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll=\"\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ng-if=\"withLeftSideNav\" ms-sidenav-helper=\"\" ng-include=\"\'app/components/a4-table/sidenavs/main-sidenav.html\'\"></md-sidenav><div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" flex=\"100\"><md-list class=\"contacts-list\" flex=\"\"><div class=\"main scrollable\" ms-scroll=\"\"><div class=\"md-card-list-wrapper\" id=\"bill-box\"><div class=\"uk-width-large-8-10 uk-container-center\"><div class=\"md-card-list\"><ul hierarchical-slide=\"\"><li><div layout=\"row\"><div class=\"md-card-list-item-select\"><div style=\"width: 30px; height: 20px;\"></div></div><span flex=\"10\" flex-md=\"15\" flex-sm=\"20\" flex-xs=\"25\" class=\"md-card-list-item-date\"><strong style=\"color: #000;\">Vencimento</strong></span><div flex=\"20\" flex-md=\"0\" flex-sm=\"0\" class=\"md-card-list-item-sender\"><strong>Pessoa</strong></div><div flex=\"20\" flex-sm=\"20\" flex-xs=\"0\" class=\"md-card-list-item-subject\"><span><strong>Descrição</strong></span></div><span flex=\"10\" flex-sm=\"20\" flex-xs=\"25\" style=\"text-align: right\" class=\"md-card-list-item-date\"><strong style=\"color: #000;\">Valor (R$)</strong></span> <span flex=\"10\" flex-sm=\"20\" flex-xs=\"25\" style=\"text-align: center;\" class=\"md-card-list-item-date\"><strong style=\"color: #000;\">Status</strong></span> <span flex=\"10\" flex-sm=\"20\" flex-xs=\"25\" style=\"text-align: center;\" class=\"md-card-list-item-date\"><strong style=\"color: #000;\">Data pag.</strong></span> <span flex=\"10\" flex-sm=\"20\" flex-xs=\"25\" style=\"text-align: right\" class=\"md-card-list-item-date\"><strong style=\"color: #000;\">Pago (R$)</strong></span><div flex=\"\" flex-md=\"30\" flex-sm=\"20\" flex-xs=\"25\"></div></div></li><li ng-repeat=\"item in vm.items\" on-last-repeat=\"\" class=\"{{ item.status_name }}\"><div layout=\"row\"><div class=\"md-card-list-item-select\"><md-checkbox md-no-ink=\"\" aria-label=\"Selecione\" class=\"md-primary\" ng-checked=\"vm.exists(item, vm.listCheckBills)\" style=\"margin: 0\" ng-click=\"vm.toggle(item, vm.listCheckBills)\" ng-disabled=\"item.status != 1 && item.status != 5 && item.status != 6\"></md-checkbox></div><div flex=\"10\" flex-md=\"15\" flex-sm=\"20\" flex-xs=\"25\" class=\"md-card-list-item-date\"><span>{{item.due_date | date:\'dd/MM/yyyy\'}}</span></div><div flex=\"20\" flex-md=\"0\" flex-sm=\"0\" class=\"md-card-list-item-sender\"><span>{{item.person_name}}</span></div><div flex=\"20\" flex-sm=\"20\" flex-xs=\"0\" class=\"md-card-list-item-subject\"><span>{{item.description}}</span></div><div flex=\"10\" flex-sm=\"20\" flex-xs=\"25\" class=\"md-card-list-item-amount\"><span style=\"float: right\">{{item.final_value}}</span></div><div flex=\"10\" flex-sm=\"20\" flex-xs=\"25\" class=\"md-card-list-item-avatar-wrapper\"><span class=\"bill-status {{ item.status_name }}\">{{(item.status_name).replace(\'_\', \' \')}}</span></div><div flex=\"10\" flex-md=\"15\" flex-sm=\"20\" flex-xs=\"25\" class=\"md-card-list-item-date\"><span ng-if=\"item.status == 10 && item.settlement_date !== null\">{{item.settlement_date | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"item.status == 10 && item.settlement_date === null\">{{item.due_date | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"item.status != 10\"></span></div><div flex=\"10\" flex-sm=\"20\" flex-xs=\"25\" class=\"md-card-list-item-avatar-wrapper md-card-list-item-amount\"><span style=\"float: right\">{{item.amount_paid}}</span></div><div flex=\"\" flex-md=\"30\" flex-sm=\"20\" flex-xs=\"25\"><div class=\"md-card-list-item-menu\" ng-hide=\"vm.listCheckBills.length >= 2\" layout=\"row\"><md-button flex=\"\" aria-label=\"comment\" class=\"md-icon-button md-mini fast-pay\" ng-if=\"item.status == 1 && item.debit_credit == \'D\'\" ng-click=\"vm.setPayment($emit(\'setpayment\'), item, \'sidenav-payment-form\');\"><md-icon><i class=\"material-icons\">attach_money</i></md-icon><md-tooltip md-direction=\"bottom\">Pagar</md-tooltip></md-button><md-button flex=\"\" aria-label=\"comment\" class=\"md-icon-button md-mini\" ng-if=\"item.status == 10\" ng-click=\"vm.undoPayment($emit(\'undopayment\'), item, \'sidenav-reverse-form\');\"><md-icon><i class=\"material-icons\">money_off</i></md-icon><md-tooltip md-direction=\"bottom\">Estornar</md-tooltip></md-button><md-button flex=\"\" aria-label=\"comment\" class=\"md-icon-button md-mini\" ng-if=\"item.status == 2 || item.status == 3 || item.status == 5 || item.status == 6\" ng-click=\"undoChangeStatus({index: $index, status: item.status})\"><md-icon><i class=\"material-icons\">restore</i></md-icon><md-tooltip md-direction=\"bottom\">Desfazer</md-tooltip></md-button><md-button flex=\"\" aria-label=\"comment\" class=\"md-icon-button md-mini\" ng-if=\"item.status == 4\" ng-click=\"vm.undoNegotiate($emit(\'undonegotiate\'), item, \'sidenav-negotiate-form\');\"><md-icon><i class=\"material-icons\">restore</i></md-icon><md-tooltip md-direction=\"bottom\" ng-disabled=\"vm.disable_neg_undo\">Desfazer Negociação</md-tooltip></md-button><md-button flex=\"\" aria-label=\"comment\" class=\"md-icon-button md-mini\" ng-if=\"item.status == 1 && item.debit_credit == \'C\'\" ng-hide=\"vm.listCheckBills.length >= 2\" ng-click=\"vm.setPayment($emit(\'setpayment\'), item, \'sidenav-payment-form\');\"><md-icon><i class=\"material-icons\">attach_money</i></md-icon><md-tooltip md-direction=\"bottom\">Receber</md-tooltip></md-button><md-menu-bar flex=\"\" ng-if=\"item.status == 1\"><md-menu><button ng-click=\"$mdMenu.open()\"><md-icon><i class=\"material-icons\">more_vert</i></md-icon><md-tooltip md-direction=\"bottom\">Opções</md-tooltip></button><md-menu-content><md-menu-item class=\"md-in-menu-bar\"><button class=\"md-button\" ng-click=\"vm.openTableItem($event, $index)\"><md-icon md-menu-origin=\"\">mode_edit</md-icon>Editar</button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-if=\"item.type == 1 || item.status == 1 || item.status == 6 || item.status == 5\"><button class=\"md-button\" ng-click=\"onDelete({index: $index})\"><md-icon md-menu-origin=\"\">delete_forever</md-icon>Excluir</button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-if=\"item.type == 1 || item.status == 1 || item.status == 6 || item.status == 5\"><button class=\"md-button\" ng-click=\"changeStatus({index: $index, status: 2})\"><md-icon md-menu-origin=\"\">cancel</md-icon>Cancelar</button></md-menu-item><md-menu-item class=\"md-in-menu-bar\"><button class=\"md-button\" ng-click=\"vm.setNegotiate($emit(\'setnegotiate\'), item, \'sidenav-negotiate-form\');\"><md-icon md-menu-origin=\"\">done_all</md-icon>Negociar</button></md-menu-item><md-menu-item class=\"md-in-menu-bar\" ng-if=\"item.status == 1 || item.status == 6 || item.status == 5\"><button class=\"md-button\" ng-click=\"changeStatus({index: $index, status: 3})\"><md-icon md-menu-origin=\"\">done</md-icon>Dispensar</button></md-menu-item><md-menu-item class=\"md-in-menu-bar\"><button class=\"md-button\" ng-click=\"changeStatus({index: $index, status: 5})\"><md-icon md-menu-origin=\"\">announcement</md-icon>Marcar como \"duvidoso\"</button></md-menu-item><md-menu-item class=\"md-in-menu-bar\"><button class=\"md-button\" ng-click=\"changeStatus({index: $index, status: 6})\"><md-icon md-menu-origin=\"\">report</md-icon>Marcar como \"prejuízo\"</button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu-bar ng-hide=\"item.status == 4 || item.status == 10\" ng-if=\"item.status != 1\"><md-menu><button ng-click=\"$mdMenu.open()\"><md-icon><i class=\"material-icons\">more_vert</i></md-icon><md-tooltip md-direction=\"bottom\">Opções</md-tooltip></button><md-menu-content><md-menu-item class=\"md-in-menu-bar\"><button class=\"md-button\" ng-click=\"changeStatus({index: $index, status: 5})\"><md-icon>announcement</md-icon>Marcar como \"duvidoso\"</button></md-menu-item><md-menu-item class=\"md-in-menu-bar\"><button class=\"md-button\" ng-click=\"changeStatus({index: $index, status: 6})\"><md-icon md-menu-origin=\"\">report</md-icon>Marcar como \"prejuízo\"</button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></div></li><li ng-if=\"vm.items.length == 0\"><div flex=\"100\" class=\"md-card-list-item-avatar-wrapper md-card-list-item-amount\"><strong>Nenhum registro encontrado</strong></div></li></ul></div></div></div></div></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p translate=\"TABLE.NO_RESULTS\">No results..</p></md-list-item></div></div><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-edit-form\" ms-scroll=\"\" ng-include=\"sidebarTemplateEdit\"></md-sidenav><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-create-form\" ms-scroll=\"\" ng-include=\"sidebarTemplateCreate\"></md-sidenav><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-negotiate-form\" ms-scroll=\"\" ng-include=\"sidebarTemplateNegotiate\" md-is-open=\"isSidenavOpen\"></md-sidenav><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-payment-form\" ms-scroll=\"\" ng-include=\"sidebarTemplatePayment\"></md-sidenav><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"sidenav-reverse-form\" ms-scroll=\"\" ng-include=\"sidebarTemplateReverse\"></md-sidenav></div>");
$templateCache.put("app/components/a4-table-expandable/view/a4-table-expandable-options.html","<md-dialog aria-label=\"Mango (Fruit)\" flex-auto=\"\" style=\"width: 600px; max-width: 600px !important;\" md-theme=\"finance\"><form ng-cloak=\"\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h4>Parcela {{vm.scope.instalment_name}} de uma titulo recorrente. O que você deseja fazer?</h4><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-button flex=\"\" ng-click=\"vm.answer({edit_expense: 1, sidenav: \'sidenav-edit-form\'})\" class=\"md-accent md-raised\">Alterar apenas esta parcela</md-button><md-button flex=\"\" ng-click=\"vm.answer({edit_expense: 2, sidenav: \'sidenav-edit-form\'})\" class=\"md-accent md-raised\">Alterar as parcelas a partir desta. ({{vm.scope.instalment_name}})</md-button><md-button flex=\"\" ng-click=\"vm.answer({edit_expense: 3, sidenav: \'sidenav-edit-form\'})\" class=\"md-accent md-raised\">Alterar todas as parcelas.</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/a4-table-installments/templates/checkConfig.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" md-theme=\"finance\"><form name=\"checkForm\" class=\"md-inline-form\" novalidate=\"\" ng-submit=\"vm.answer(vm.check, checkForm)\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Informações de Cheque</span></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container flex=\"\" class=\"md-icon-float md-block\"><label>Entre com o número do cheque</label> <input name=\"name\" ng-model=\"vm.check_number\" type=\"text\" md-autofocus=\"\" ng-change=\"vm.readCheckNumber(vm.check_number, event)\" maxlength=\"30\" ng-maxlength=\"30\" number-only=\"\"></md-input-container><div layout=\"column\" flex=\"\"><div layout=\"row\" flex=\"\"><div layout=\"row\"><md-input-container flex=\"\" style=\"margin: 0;\"><md-autocomplete flex=\"\" required=\"\" ng-disabled=\"vm.readed\" md-input-name=\"bank\" md-selected-item=\"vm.check.bank\" md-no-cache=\"false\" md-search-text=\"searchText\" md-selected-item-change=\"vm.verifyCheckByBank(vm.check.bank)\" md-items=\"item in vm.querySearch(searchText, vm.banks)\" md-item-text=\"item.number_bank +\' - \'+ item.name\" md-require-match=\"\" md-floating-label=\"{{\'BILL_PAYMENT.BANK\' | translate}}\"><md-item-template><span>{{ item.number_bank +\' - \'+ item.name}}</span></md-item-template><div ng-messages=\"received.bank.$error\" ng-if=\"received.bank.$touched\"><div ng-message=\"required\">Você <b>deve</b> escolher um banco.</div></div><md-not-found>Não encontramos um banco para este nome: \"{{searchText}}\" .</md-not-found></md-autocomplete></md-input-container></div><md-input-container flex=\"\" class=\"md-icon-float md-block\"><label>Agência</label> <input ng-model=\"vm.check.branch\" required=\"\" ng-disabled=\"vm.readed\" maxlength=\"4\" type=\"text\"></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container flex=\"\" class=\"md-icon-float md-block\"><label>Conta</label> <input name=\"name\" ng-model=\"vm.check.account\" required=\"\" ng-disabled=\"vm.readed\" maxlength=\"7\" type=\"text\" md-autofocus=\"\"></md-input-container><md-input-container flex=\"\" class=\"md-icon-float md-block\"><label>Cheque</label> <input ng-model=\"vm.check.number\" ng-disabled=\"vm.readed\" maxlength=\"6\" required=\"\" type=\"text\"></md-input-container></div></div><div layout=\"row\" flex=\"\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.check.reply\">Replicar o cheque sequencialmente para os títulos seguintes. Numero será incrementado.</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/a4-table-installments/templates/index.html","<div layout=\"row\"><strong class=\"group-field\"><small flex=\"70\">Geração das parcelas</small></strong></div><div layout=\"row\" ng-show=\"payment.id == 2\"><div class=\"alert alert-warning a-text\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Atenção!</strong>Você deve informar os numeros dos cheques na tabela das parcelas.</div></div><div class=\"group-field\" ng-hide=\"edit_mode\"><div layout=\"row\" ng-show=\"modeReceipt\"><md-input-container ng-show=\"isNegotiation\" flex=\"\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.entry_value\" placeholder=\"Valor Entrada\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" ng-change=\"vm.adjustNegotiateValue()\" decimal-delimiter=\",\" thousands-delimiter=\".\"></md-input-container><md-input-container ng-show=\"end_of_recurrence == 0 || isNegotiation\" flex=\"\"><input type=\"text\" name=\"quantity\" number-only=\"\" autocomplete=\"off\" ng-model=\"quantity\" placeholder=\"Parcelas\" ng-value=\"0\" ng-blur=\"option_selected = (end_of_recurrence == 0) ? quantity : maxvalue\"></md-input-container><md-input-container ng-show=\"isNegotiation\" flex=\"\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.negotiate_value\" placeholder=\"Valor a parcelar\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" disabled=\"true\" decimal-delimiter=\",\" thousands-delimiter=\".\"></md-input-container><md-input-container ng-show=\"end_of_recurrence == 1\" flex=\"\"><input type=\"text\" name=\"maxvalue\" ng-model=\"maxvalue\" ng-value=\"0\" placeholder=\"R$\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" ng-blur=\"option_selected = (end_of_recurrence == 0) ? quantity : maxvalue\"></md-input-container><date-picker flex=\"\" name=\"date_first\" placeholder=\"Data de Inicio\" ng-model=\"date_first\"></date-picker></div><div ng-show=\"modeReceipt\" layout=\"row\" layout-align=\"end start\"><md-button class=\"md-raised md-accent\" ng-click=\"createBatchInstallments(true)\" ng-if=\"isNegotiation\" ng-disabled=\"option_selected == 0 || date_first == null || date_first == undefined\">Gerar parcelas com juros</md-button><md-button class=\"md-raised md-accent\" style=\"background-color: #0a6aa1 !important;\" ng-click=\"createBatchInstallments(false)\" ng-disabled=\"option_selected == 0 || date_first == null || date_first == undefined\">Gerar parcelas sem juros</md-button></div><div ng-show=\"!modeReceipt\" layout=\"row\"><md-input-container flex=\"40\"><label class=\"control-label\">Quantidade de parcelas:</label><input type=\"text\" name=\"quantity\" number-only=\"\" autocomplete=\"off\" ng-model=\"quantity\"></md-input-container><date-picker flex=\"40\" name=\"date_first\" ng-model=\"date_first\" placeholder=\"Primeiro vencimento\"></date-picker><div flex=\"20\"><md-button class=\"md-raised md-accent\" ng-click=\"createBatchInstallments()\" ng-disabled=\"(quantity == 0 || initialQty == 0) || (initialQty == null || quantity == null) || date_first == null || date_first == undefined\">Gerar parcelas</md-button></div></div></div><div layout=\"row\" ng-show=\"list.length\"><strong class=\"group-field\"><small flex=\"70\">Parcelas</small></strong></div><div ng-show=\"list.length\" layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-repeat=\"item_install in list track by $index\"><md-input-container flex=\"20\"><input type=\"text\" ng-value=\"item_install.index\" placeholder=\"Parcela\" ng-disabled=\"true\"></md-input-container><date-picker disabled=\"disabled\" flex=\"30\" required=\"true\" ng-if=\"isRecurrence\" ng-model=\"item_install.due_date\" placeholder=\"Vencimento\"></date-picker><date-picker disabled=\"isDisabled(item_install)\" flex=\"30\" required=\"true\" ng-if=\"!isRecurrence\" ng-model=\"item_install.due_date\" placeholder=\"Vencimento\"></date-picker><md-input-container flex=\"20\" ng-if=\"isRecurrence\"><input type=\"text\" ng-model=\"item_install.amount\" ng-value=\"applyMask(item_install.amount)\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" ng-disabled=\"disabled\" placeholder=\"Valor\"></md-input-container><md-input-container flex=\"20\" ng-if=\"!isRecurrence\"><input type=\"text\" ng-model=\"item_install.amount\" ng-value=\"applyMask(item_install.amount)\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" ng-disabled=\"isDisabled(item_install)\" placeholder=\"Valor\"></md-input-container><md-input-container ng-show=\"currentItem.collection_type == 4 || currentItem.payment == 2\" flex=\"\"><input type=\"text\" ng-value=\"item_install.check_identify\" placeholder=\"Cheque (Bco-Ag-CC-Cheque)\"></md-input-container><div flex=\"\" ng-if=\"!isRecurrence\"><md-button class=\"md-icon-button\" aria-label=\"Adicionar item_install\" ng-click=\"createBlankInstallment()\"><md-tooltip>Adicionar</md-tooltip><md-icon md-font-icon=\"icon-plus-circle\" class=\"s20\"></md-icon></md-button></div><div ng-hide=\"$index == 0 || list.length <= 1\" flex=\"\" ng-if=\"!isRecurrence\"><md-button ng-disabled=\"isDisabled(item_install)\" class=\"md-icon-button\" aria-label=\"Delete\" ng-click=\"removeInstallment(item_install, $index)\"><md-tooltip>Deletar</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></div><div flex=\"\" ng-if=\"!isRecurrence\"><md-button ng-disabled=\"isDisabled(item_install)\" class=\"md-icon-button\" ng-click=\"openModalConfig(item_install, $index)\"><md-tooltip>Informações</md-tooltip><md-icon md-font-icon=\"icon-information-outline\" class=\"s20\"></md-icon></md-button></div></div><div layout=\"row\" layout-align=\"space-between center\" ng-hide=\"list.length <= 1\" style=\"margin-bottom: 20px;margin-top: 0;padding: 4px;background: #fafafa;\"><strong flex=\"\"><small>Valor <span ng-if=\"!isRecurrence\">total:</span><span ng-if=\"isRecurrence\">da parcela:</span></small><br>{{applyMask(vm.final_value)}}</strong> <strong flex=\"\"><small>Valor <span ng-if=\"!isRecurrence\">nas parcelas:</span><span ng-if=\"isRecurrence\">total da recorrência:</span></small><br>{{getTotal().total}}</strong> <strong flex=\"\" ng-hide=\"currentItem.was_paid == 2\"><small>Valor pendente:</small><br>R$ {{getTotal().pending_difference}}</strong></div>");
$templateCache.put("app/components/a4-ui-tree/templates/nodes_renderer.html","<div ui-tree-handle=\"\" class=\"tree-node tree-node-content\"><div class=\"ui-tree-content\" layout=\"row\" layout-align=\"start center\"><span flex=\"5\"><div ng-if=\"node.nodes && node.nodes.length > 0\" data-nodrag=\"\" ng-click=\"toggle(this)\"><i class=\"material-icons\" ng-show=\"collapsed\">keyboard_arrow_right</i> <i class=\"material-icons\" ng-hide=\"collapsed\">keyboard_arrow_down</i></div></span><div flex=\"75\"><span ng-if=\"!changeName\">{{node.name}}</span> <span ng-if=\"changeName\">{{ changeName }}</span> <span ng-if=\"node.description\">| {{ node.description }}</span></div><div layout=\"row\" layout-align=\"end center\" ng-if=\"actions\"><div layout=\"row\" layout-align=\"center center\"><md-button flex=\"\" class=\"md-icon-button\" data-nodrag=\"\" ng-click=\"delete(this)\"><md-tooltip md-direction=\"bottom\">Remover item</md-tooltip><i class=\"material-icons\">delete</i></md-button><md-button flex=\"\" class=\"md-icon-button\" data-nodrag=\"\" ng-if=\"node.nodes\" ng-click=\"newSubItem(this)\"><md-tooltip md-direction=\"bottom\">Adicionar item</md-tooltip><i class=\"material-icons\">playlist_add</i></md-button></div></div></div></div><ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-hide=\"collapsed\" ng-click=\"nodeSelect(node)\"><li ng-repeat=\"node in node.nodes\" ui-tree-node=\"\" ng-include=\"\'app/components/a4-ui-tree/templates/\' + template + \'.html\'\" ng-show=\"visible(node)\"></li></ol>");
$templateCache.put("app/components/modal/Templates/ConfirmJustifyModal.html","<div class=\"modal-a4\"><form name=\"modal_justification\"><div class=\"modal-header\"><h4 class=\"modal-title\">A4 Web</h4></div><div class=\"modal-body\"><p class=\"text-center\">@msg@</p><input required=\"\" autocomplete=\"off\" name=\"justification\" type=\"text\" ng-model=\"justification\" placeholder=\"Justificativa\"></div><div class=\"modal-footer\"><div class=\"btn btn-primary\" ng-disabled=\"modal_justification.justification.$invalid\" ng-click=\"confirmModal(true);\">OK</div><div class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"confirmModal(false);\">Cancelar</div></div></form></div>");
$templateCache.put("app/components/modal/Templates/ConfirmModal.html","<div class=\"modal-a4\"><div class=\"modal-header\"><h4 class=\"modal-title\">A4 Web</h4></div><div class=\"modal-body\"><p class=\"text-center\">{{msg}}</p></div><div class=\"modal-footer\"><div class=\"btn btn-primary\" ng-click=\"confirmModal(true);\">OK</div><div class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"confirmModal(false);\">Cancelar</div></div></div>");
$templateCache.put("app/components/modal/Templates/EditAccountCategory.html","<div class=\"modal-a4\"><form name=\"form_category\" novalidate=\"\" ng-submit=\"vm.submit(form_category, vm.category)\"><div class=\"modal-header\"><h4 class=\"modal-title\">A4 Web - {{ \'EDIT_CATEGORY\' | translate }} : {{node.name | translate}}</h4></div><div class=\"modal-body\"><div class=\"modal-info\" ng-init=\"vm.category.bill_category_model_id = node.bill_category_model_id\"><div class=\"col-md-12\" ng-init=\"vm.category.id = node.id\"><input type=\"hidden\" name=\"order\" ng-model=\"node.order\" ng-init=\"vm.category = node\"> <input autocomplete=\"off\" name=\"name\" type=\"text\" ng-value=\"node.name\" ng-model=\"vm.category.name\" placeholder=\"{{ \'NAME_OF_NEW_CATEGORY\' | translate }}\" required=\"true\"> <span class=\"help-block help-block-error\" id=\"error_msg\" style=\"color:red;\"></span></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn green\"><i class=\"fa fa-pencil-square-o\"></i>{{ \'EDIT\' | translate }}</button></div></form></div>");
$templateCache.put("app/components/modal/Templates/NewAccountCategory.html","<form name=\"form_category\" novalidate=\"\" ng-submit=\"vm.submit(form_category, vm.category)\"><div class=\"modal-a4\"><div class=\"modal-header\"><h4 class=\"modal-title\">A4 Web - {{ \'CREATE_NEW_CATEGORY\' | translate }} {{\'ON\' |translate}} {{node.name | translate}}</h4></div><div class=\"modal-body\"><div class=\"modal-info\"><input type=\"hidden\" name=\"id_parent\" ng-init=\"vm.category.id_parent = node.id\" ng-model=\"vm.category.id_parent\"> <input type=\"hidden\" name=\"type\" ng-init=\"vm.category.debit_credit = node.debit_credit\" ng-model=\"vm.category.debit_credit\"> <input autocomplete=\"off\" name=\"name\" type=\"text\" ng-model=\"vm.category.name\" placeholder=\"{{\'NAME_OF_NEW_CATEGORY\' | translate }}\" required=\"true\" ng-minlength=\"3\"> <span class=\"help-block help-block-error\" id=\"error_msg\" style=\"color:red;\"></span></div></div><div class=\"modal-footer\"><span class=\"loading-a4\" style=\"left: 280px;margin-top: 7px;\"></span> <button type=\"submit\" ng-disabled=\"form_category.$invalid\" class=\"btn green\"><i class=\"fa fa-plus\"></i> {{ \'ADD\' | translate }}</button></div></div></form>");
$templateCache.put("app/components/modal/Templates/SearchCNPJ.html","<div class=\"modal_search_cnpj_top col-md-12\"><div class=\"title\">Buscar por CNPJ</div></div><div class=\"modal_search_cnpj\"><div class=\"form-group\"><div class=\"col-md-12\"><input autocomplete=\"off\" name=\"cnpj\" type=\"text\" ng-model=\"pc.person.cnpj\" placeholder=\"@\'NATION_ID_NUMBER_CNPJ\' | translate @\" validate-cnpj=\"\" ui-br-cnpj-mask=\"\"> <span class=\"help-block help-block-error\" id=\"duplicated-cnpj\" style=\"color:red;\"></span></div></div><div><div class=\"form-group\" ng-init=\"pc.getCnpjCaptcha()\"><div class=\"col-md-7\"><div class=\"captcha-img\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\" ng-if=\"pc.cnpjParams.captchaBase64 == null\"></i> <img ng-src=\"@pc.cnpjParams.captchaBase64@\"></div><a class=\"padding-fix large fa fa-refresh col FontBig reload_captcha\" ng-click=\"pc.getCnpjCaptcha()\"></a></div></div></div><div class=\"form-group\"><div class=\"last\"><label class=\"col-md-12 control-label\"></label><div class=\"col-md-6\"><input autocomplete=\"off\" type=\"text\" ng-model=\"pc.captcha\" placeholder=\"@\'CAPTCHA\' | translate @\"></div></div><div class=\"last\"><div class=\"col-md-5\"><div ng-click=\"pc.postCnpjInfo(pc.person.cnpj, pc.captcha)\" class=\"btn green btn-block\">@ \'FIND\' | translate @ <i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\" ng-show=\"pc.$cnpj_preload\"></i></div></div></div></div></div>");
$templateCache.put("app/components/modal/Templates/adjustmentRules.html","<div class=\"modal-header\"><h4 class=\"modal-title\">@ \'Regra de reajuste\' | translate@</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12\"><div class=\"form-group\"><div class=\"row\"><strong>Nome:</strong></div><div class=\"row\"><input type=\"text\" id=\"name\" placeholder=\"Nome\" ng-model=\"adj.rule.name\"></div></div></div><div class=\"col-md-12 pad-top-1\"><div class=\"form-group\"><div class=\"row\"><strong>Índice:</strong></div><div class=\"row\"><select ng-options=\"i.id as i.name for i in adj.allIndex\" ng-model=\"adj.rule.index_id\" ng-selected=\"adj.rule.index_id == i.id\"></select></div></div></div><div class=\"col-md-12 pad-top-1\"><div class=\"form-group\"><div class=\"row\"><strong>Tipo:</strong></div><div class=\"row\"><div class=\"col-md-7\"><input type=\"radio\" ng-model=\"adj.rule.type\" id=\"type1\" style=\"width: 20px;float: left;height: 14px;\" ng-value=\"1\"> <label for=\"type1\">Por data de aniversário</label></div><div class=\"col-md-5\"><input type=\"radio\" ng-model=\"adj.rule.type\" id=\"type2\" style=\"width: 20px;float: left;height: 14px;\" ng-value=\"2\"> <label for=\"type2\">Data base</label></div></div></div></div><div class=\"col-md-12\" ng-show=\"adj.rule.type == 2\"><div class=\"form-group\"><div class=\"row\"><strong>Mês da data base:</strong></div><div class=\"row\"><select ng-model=\"adj.rule.month\" ng-options=\"item.id as item.name for item in adj.months\" ng-selected=\"adj.rule.month == item.id\"></select></div></div></div><div class=\"col-md-12 pad-top-1 clear-padding\"><div class=\"form-group\"><div class=\"col-md-3 clear-padding\"><label ng-show=\"adj.rule.is_inactive\">Regra inativa</label> <label ng-show=\"!adj.rule.is_inactive\">Regra ativa</label></div><div class=\"col-md-9 clear-padding\"><div class=\"reverse-switch\"><switch id=\"enabled\" ng-model=\"adj.rule.is_inactive\" class=\"md-primary\" md-no-ink=\"\" md-invert=\"true\"></switch></div></div></div></div><div class=\"col-md-12 pad-top-2\"><button type=\"button\" class=\"btn btn-green\" ng-show=\"adj.rule.id == 0\" ng-click=\"adj.create(adj.rule)\"><i class=\"fa fa-save\"></i> @\'Salvar\'| translate@</button> <button type=\"button\" class=\"btn btn-green\" ng-show=\"adj.rule.id != 0\" ng-click=\"adj.update(adj.rule)\"><i class=\"fa fa-save\"></i> @\'Atualizar\'| translate@</button> <button type=\"button\" class=\"btn btn-cancel-a4\" ng-click=\"adj.closeModal()\"><i class=\"fa fa-times\"></i> @\'Cancelar\'| translate@</button></div></div></div></div>");
$templateCache.put("app/components/modal/Templates/alert.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/components/modal/Templates/askEdit.html","<div class=\"modal-header\"><h4 class=\"modal-title\" ng-if=\"itemSelected.frequency == 0\">@ \'ASK_PHRASE_1\' | translate@ @itemSelected.instalment_name@ @ \'ASK_PHRASE_2\' | translate@</h4><h4 class=\"modal-title\" ng-if=\"itemSelected.frequency == 20 || itemSelected.frequency != 0 && itemSelected.frequency != 20\">@ \'ASK_PHRASE_1\' | translate@ @itemSelected.instalment_name@ @ \'ASK_PHRASE_2_1\' | translate@</h4></div><div class=\"modal-footer\"><div class=\"form-group col-md-12\"><div class=\"padding10\"><a class=\"btn btn-primary col-md-12\" ng-href=\"/bill/@itemSelected.id@?edit_expense=1\">@ \'EDIT_ONLY_THIS_PORTION\' | translate@</a></div><div class=\"padding10\"><a class=\"btn btn-primary col-md-12\" ng-href=\"/bill/@itemSelected.id@?edit_expense=2\">@ \'EDIT_FROM_THIS\' | translate@ @itemSelected.instalment_name@</a></div><div class=\"padding10\"><a class=\"btn btn-primary col-md-12\" ng-href=\"/bill/@itemSelected.id@?edit_expense=3\">@ \'EDIT_ALL_PORTIONS\' | translate@</a></div></div></div>");
$templateCache.put("app/components/modal/Templates/block-access.html","<md-dialog class=\"contact-dialog\" md-theme=\"{{vm.theme}}\" aria-label=\"New Task\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\" style=\"background-color: rgb(216,67,21); color: white\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Sem acesso</span></div></md-toolbar><md-dialog-content ms-scroll=\"\"><h2>Ops!<br>A sua conta de acesso está temporariamente suspensa. Entre em contato com a nossa equipe para reativarmos o seu login o quanto antes.</h2></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\" flex=\"\"><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">Ok</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/modal/Templates/calendarDetails.html","<div class=\"modal-a4\"><div class=\"modal-header\"><h4 class=\"modal-title\">A4 Web</h4></div><div class=\"modal-body\">{{vm.scope}}<p class=\"text-center\">{{msg}}</p></div><div class=\"modal-footer\"><div class=\"btn btn-primary\" ng-click=\"closeModal();\">OK</div></div></div>");
$templateCache.put("app/components/modal/Templates/confirm.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" md-theme=\"{{vm.theme}}\" style=\"\"><div class=\"modal-a4\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Confirmação</span></div></md-toolbar><md-card style=\"background-color: rgba(253,0,4,0.2); padding: 10px; position: relative; width: 97%\" ng-if=\"vm.fatal_error\"><span style=\"color: black;\"><md-icon>error</md-icon>{{vm.error_message}}</span></md-card><div flex=\"\" layout=\"row\" style=\"padding-left: 3px; padding-top: 3px;\"><md-card style=\"padding: 5px; width: 96%\" flex=\"\"><div layout=\"column\" flex=\"100\"><div layout=\"row\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><span style=\"font-size: 15px\"><b>{{vm.subtitle === null ? \'Confirmação\' : vm.subtitle}}</b></span> <span style=\"font-size: 15px\">{{vm.text}}</span></div></div></div></md-card></div></div><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"column\"><span>{{vm.user_name}}</span> <span>{{vm.date}} às {{vm.hour}}</span></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeModal()\" ng-disabled=\"vm.show_loading\" class=\"md-raised md-button\" ng-if=\"vm.cancelText !== \'false\'\" aria-label=\"Add Task\"><div ng-if=\"!vm.fatal_error\">{{vm.cancelText}}</div><div ng-if=\"vm.fatal_error\">Fechar</div></md-button><md-button type=\"submit\" ng-click=\"vm.answer(true)\" ng-disabled=\"vm.show_loading\" ng-if=\"!vm.fatal_error\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" md-diameter=\"15px\"></md-progress-circular>{{vm.okText}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/modal/Templates/confirmChangeStatus.html","<div class=\"modal-header\"><h4 class=\"modal-title\" ng-if=\"idStatus == 2\">Digite o motivo para essa ação de cancelamento:</h4><h4 class=\"modal-title\" ng-if=\"idStatus == 3\">Digite o motivo para essa ação de dispensa:</h4><h4 class=\"modal-title\" ng-if=\"idStatus == 5\">Digite o motivo para essa ação:</h4><h4 class=\"modal-title\" ng-if=\"idStatus == 6\">Digite o motivo para essa ação:</h4><h4 class=\"modal-title\" ng-if=\"idStatus == 9\">Digite o motivo para essa ação de exclusão:</h4></div><div class=\"modal-body\"><input required=\"\" autocomplete=\"off\" name=\"justificativa\" type=\"text\" ng-model=\"justification\" placeholder=\"Justificativa\"></div><div class=\"modal-footer\" ng-show=\"pc != undefined\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"pc.updateStatus(bill_id, idStatus, justification)\">Confirmar</button></div><div class=\"modal-footer\" ng-show=\"bc != undefined\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"bc.updateStatus(bill_id, idStatus, justification)\">Confirmar</button></div>");
$templateCache.put("app/components/modal/Templates/confirmDelete.html","<div class=\"modal-header\"><h4 class=\"modal-title\">Digite o motivo para essa ação de exclusão:</h4></div><div class=\"modal-body\"><input required=\"\" autocomplete=\"off\" name=\"justificativa\" type=\"text\" ng-model=\"justification\" placeholder=\"Justificativa\"></div><div class=\"modal-footer\" ng-show=\"pc != undefined\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"pc.deleteBill(bill_id, justification)\">Confirmar</button></div><div class=\"modal-footer\" ng-show=\"bc != undefined\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"bc.deleteBill(bill_id, justification)\">Confirmar</button></div>");
$templateCache.put("app/components/modal/Templates/confirmUndoStatus.html","<div class=\"modal-header\"><h4 class=\"modal-title\">Deseja realmente desfazer o status?</h4></div><div class=\"modal-body\"><input required=\"\" autocomplete=\"off\" name=\"justificativa\" type=\"text\" ng-model=\"justification\" placeholder=\"Justificativa\"></div><div class=\"modal-footer\" ng-show=\"pc != undefined\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"pc.updateStatus(bill_id, 1, justification)\">Confirmar</button></div><div class=\"modal-footer\" ng-show=\"bc != undefined\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"bc.updateStatus(bill_id, 1, justification)\">Confirmar</button></div>");
$templateCache.put("app/components/modal/Templates/discountRoles.html","<div class=\"modal-header\"><h4 class=\"modal-title\">@ \'Regra de Descontos\' | translate@</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label for=\"role_name\">Nome</label> <input type=\"text\" id=\"role_name\" placeholder=\"Nome da regra\" ng-model=\"role.name\"></div><div class=\"form-group\"><div class=\"form-inline\" style=\"padding: 20px 0px 20px 0px;\"><table class=\"\"><thead><tr><th>Formato do Desconto</th></tr></thead><tbody><tr><td><div class=\"col-md-12\"><input type=\"radio\" id=\"discount_form\" name=\"form_discount\" ng-model=\"role.format\" style=\"width: 20px;float: left;height: 14px;\" ng-value=\"0\"> <label for=\"discount_form\">Em percentual</label></div></td></tr><tr><td><div class=\"col-md-12\"><input type=\"radio\" id=\"discount_form2\" name=\"form_discount\" ng-model=\"role.format\" style=\"width: 20px;float: left;height: 14px;\" ng-value=\"1\"> <label for=\"discount_form2\">Em Valor</label></div></td></tr></tbody></table></div><div><table class=\"\"><thead><tr><th>Validade do Desconto</th></tr></thead><tbody><tr><td><div class=\"col-md-12\"><input type=\"radio\" ng-model=\"role.type\" id=\"due_discount\" name=\"validate_discount\" style=\"width: 20px;float: left;height: 14px;\" ng-value=\"\'f\'\"> <label for=\"due_discount\">Fixo</label></div></td></tr><tr><td><div class=\"col-md-12\"><input type=\"radio\" id=\"due_discount2\" ng-model=\"role.type\" name=\"validate_discount\" style=\"width: 20px;float: left;height: 14px;\" ng-value=\"\'p\'\"> <label for=\"due_discount2\">Promocional</label></div></td></tr><tr><td><div class=\"col-md-12\"><input type=\"radio\" id=\"due_discount3\" ng-model=\"role.type\" name=\"validate_discount\" style=\"width: 20px;float: left;height: 14px;\" ng-value=\"\'c\'\"> <label for=\"due_discount3\">Condicional ao vencimento</label></div></td></tr></tbody></table></div><div ng-if=\"role.type == \'p\'\"><div class=\"form-inline\"><div class=\"form-group col-lg-4 col-md-12 col-sm-12 col-xs-12\"><label class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 padding0\" for=\"email\"><b>Desconto 1</b></label><div ng-if=\"!role.format\"><input type=\"text\" tabindex=\"1\" class=\"col-md-12\" ng-model=\"role.value_percent_1\" id=\"exampleInputEmail3\" ui-percentage-mask=\"\" placeholder=\"Percentual\"></div><div ng-if=\"role.format\"><input type=\"text\" tabindex=\"1\" ng-model=\"role.value_percent_1\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" id=\"exampleInputEmail3\" placeholder=\"Valor\"></div><div style=\"padding-bottom:10px;\"><input type=\"text\" style=\"margin-top: 10px;\" tabindex=\"2\" ng-model=\"role.validity_days_1\" id=\"exampleInputEmail3\" maxlength=\"2\" placeholder=\"Dias de Antecipação\"></div></div><div class=\"form-group col-lg-4 col-md-12 col-sm-12 col-xs-12\"><label class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 padding0\" for=\"pwd\"><b>Desconto 2 <small>(opcional)</small></b></label><div ng-if=\"!role.format\"><input type=\"text\" tabindex=\"3\" ng-class=\"{\'error\': cc.validateValue(role.value_percent_2, role.value_percent_1, 0, 0)}\" ng-if=\"!role.format\" ng-model=\"role.value_percent_2\" ng-disabled=\"role.validity_days_1 == null || role.validity_days_1 == \'\'\" id=\"exampleInputEmail3\" ui-percentage-mask=\"\" placeholder=\"Percentual\"></div><div ng-if=\"role.format\"><input type=\"text\" tabindex=\"3\" ng-class=\"{\'error\': cc.validateValue(role.value_percent_2, role.value_percent_1, 0, 0)}\" ng-if=\"role.format\" ng-model=\"role.value_percent_2\" ng-disabled=\"role.validity_days_1 == null || role.validity_days_1 == \'\'\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" id=\"exampleInputEmail3\" placeholder=\"Valor\"></div><div style=\"padding-top:10px;padding-bottom:10px;\"><input type=\"text\" tabindex=\"4\" ng-class=\"{\'error\': cc.validateValue(role.validity_days_2, role.validity_days_1, 0, 1)}\" ng-model=\"role.validity_days_2\" ng-disabled=\"role.validity_days_1 == null || role.validity_days_1 == \'\'\" id=\"exampleInputEmail3\" maxlength=\"2\" placeholder=\"Dias de Antecipação\"></div></div><div class=\"form-group col-lg-4 col-md-12 col-sm-12\"><label class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 padding0 col-xs-12\"><b>Desconto 3 <small>(opcional)</small></b></label><div ng-if=\"!role.format\"><input type=\"text\" tabindex=\"5\" ng-class=\"{\'error\': cc.validateValue(role.value_percent_3, role.value_percent_2, 1, 0)}\" ng-if=\"!role.format\" ng-model=\"role.value_percent_3\" ng-disabled=\"role.validity_days_2 == null || role.validity_days_2 == \'\'\" id=\"exampleInputEmail3\" ui-percentage-mask=\"\" placeholder=\"Percentual\"></div><div ng-if=\"role.format\"><input type=\"text\" tabindex=\"5\" ng-class=\"{\'error\': cc.validateValue(role.value_percent_3, role.value_percent_2, 1, 0)}\" ng-if=\"role.format\" ng-model=\"role.value_percent_3\" ng-disabled=\"role.validity_days_2 == null || role.validity_days_2 == \'\'\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" id=\"exampleInputEmail3\" placeholder=\"Valor\"></div><div style=\"padding-top:10px;padding-bottom:10px;\"><input type=\"text\" tabindex=\"6\" ng-class=\"{\'error\': cc.validateValue(role.validity_days_3, role.validity_days_2, 1, 1)}\" ng-model=\"role.validity_days_3\" ng-disabled=\"role.validity_days_2 == null || role.validity_days_2 == \'\'\" id=\"exampleInputEmail3\" maxlength=\"2\" placeholder=\"Dias de Antecipação\"></div></div></div></div><div class=\"row\" ng-if=\"role.type == \'f\' || role.type == \'c\'\"><div class=\"col-md-12\" style=\"margin-bottom: 20px;margin-top: 20px;\"><label for=\"role_name\" class=\"col-md-2\" ng-if=\"!role.format\" style=\"float: left\">Percentual</label> <label for=\"role_name\" class=\"col-md-2\" ng-if=\"role.format\" style=\"float: left\">Valor</label><div class=\"col-md-3\"><div class=\"input-group\" ng-if=\"!role.format\"><input type=\"TEXT\" id=\"discount_form2\" ng-model=\"role.value_percent_1\" name=\"role_name\" placeholder=\"Percentual\" ui-percentage-mask=\"\"></div><div class=\"input-group\" ng-if=\"role.format\"><input type=\"TEXT\" id=\"discount_form2\" ng-model=\"role.value_percent_1\" placeholder=\"Valor\" name=\"role_name\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"role.is_excluded_first_installment\" id=\"check1\" placeholder=\"nome da regra\" style=\"width: 20px;float: left;height: 14px;\"> <label for=\"check1\">Não aplica este desconto sobre a primeira parcela da recorrência</label></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"role.is_excluded_multiple_discount\" id=\"check2\" placeholder=\"nome da regra\" style=\"width: 20px;float: left;height: 14px;\"> <label for=\"check2\">Não aplica este desconto para quem tiver algum outro desconto</label></div><div class=\"col-md-12\" ng-hide=\"role.type == \'c\' && role.format == 1\" ng-if=\"!role.format\"><input type=\"checkbox\" ng-model=\"role.is_over_main_value\" id=\"check3\" placeholder=\"nome da regra\" style=\"width: 20px;float: left;height: 14px;\"> <label for=\"check3\">Calcula este desconto sobre o valor principal</label></div></div><div class=\"col-md-12\" style=\"padding-bottom: 10px;\"><label ng-show=\"role.is_inactive\" style=\"float: left; padding: 5px;\">Regra inativa</label> <label ng-show=\"!role.is_inactive\" style=\"float: left; padding: 5px;\">Regra ativa</label><div style=\"float: left;\"><switch id=\"enabled\" name=\"is_inactive\" ng-model=\"role.is_inactive\" class=\"md-primary\" md-no-ink=\"\" md-invert=\"true\"></switch></div></div></div><button type=\"button\" class=\"btn btn-green\" ng-if=\"role.type_form == \'create\'\" ng-click=\"cc.creatediscountRole(role)\"><i class=\"fa fa-save\"></i> @\'Salvar\'| translate@</button> <button type=\"button\" class=\"btn btn-green\" ng-if=\"role.type_form == \'edit\'\" ng-click=\"cc.updatediscountRole(role)\"><i class=\"fa fa-save\"></i> @\'Salvar\'| translate@</button> <button type=\"button\" class=\"btn btn-cancel-a4\" ng-click=\"cc.closeModal()\"><i class=\"fa fa-times\"></i> @\'Cancelar\'| translate@</button></div>");
$templateCache.put("app/components/modal/Templates/email-exists.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" md-theme=\"{{vm.theme}}\" style=\"\"><div class=\"modal-a4\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">E-mail já utilizado por outra pessoa</span></div></md-toolbar><div flex=\"\" layout=\"row\" style=\"padding-left: 3px; padding-top: 3px;\"><md-card style=\"padding: 5px; width: 96%\" flex=\"\"><div layout=\"column\" flex=\"100\"><div layout=\"row\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px; text-align: center\">Este endereço de e-mail já está em uso para <b ng-repeat=\"item in vm.scope.persons\">{{item.name}}<br></b><div ng-hide=\"vm.scope.show_button\">Deseja passar a utilizar para <b>{{vm.scope.selected}}?</b><br>Se confirmar esta operação, este endereço de e-mail será removido da pessoa anterior e o usuário não terá mais acesso ao portal.</div></div></div></div></md-card></div></div><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"column\"><span>{{vm.user_name}}</span> <span>{{vm.date}} às {{vm.hour}}</span></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeModal()\" ng-disabled=\"vm.show_loading\" class=\"md-raised md-button\" aria-label=\"Add Task\"><div>Cancelar</div></md-button><md-button type=\"submit\" ng-click=\"vm.answer(true)\" ng-disabled=\"vm.show_loading\" ng-hide=\"vm.scope.show_button\" class=\"send-button md-accent md-raised md-button\" aria-label=\"Add Task\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" md-diameter=\"15px\"></md-progress-circular>Confirmar</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/modal/Templates/operationError.html","<md-dialog aria-label=\"{{vm.scope.name}}\" md-theme=\"{{vm.scope.theme}}\"><form ng-cloak=\"\" novalidate=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-delete\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>{{vm.scope.name}}</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\"><md-icon md-font-icon=\"icon-close\" style=\"color: red;\"></md-icon><h3>{{vm.scope.message}}</h3></div><div><ul><li ng-repeat=\"reason in vm.scope.reasons\">{{reason}}</li></ul></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\" class=\"md-primary md-raised\" layout=\"row\"><span flex=\"95\">Ok</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/modal/Templates/require_password.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" md-theme=\"{{vm.theme}}\"><div class=\"modal-a4\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span></div></md-toolbar><md-card style=\"background-color: rgba(253,0,4,0.2); padding: 10px; position: relative; width: 97%\" ng-if=\"vm.error || vm.fatal_error\"><span style=\"color: black;\"><md-icon>error</md-icon>{{vm.error_message}}</span></md-card><div flex=\"\" layout=\"row\" ng-if=\"vm.title !== null && vm.text !== null\" style=\"padding-left: 3px; padding-top: 3px;\"><md-card style=\"padding: 5px; width: 96%\"><div layout=\"column\" flex=\"100\"><div layout=\"row\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><span style=\"font-size: 15px\"><b>{{vm.subtitle === null ? \'Confirmação de senha\' : vm.subtitle}}</b></span> <span style=\"font-size: 15px\">{{vm.text}}</span></div></div></div></md-card></div><form name=\"password_form\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-icon-float md-block\"><label>Digite sua senha para confirmar esta operação</label> <input ng-model=\"vm.scope.password\" name=\"password\" type=\"password\" ng-change=\"vm.error = false\" required=\"\" md-autofocus=\"\"><div ng-messages=\"password_form.password.$valid\"><div ng-message=\"required\">Campo requerido.</div></div></md-input-container></md-dialog-content></form></div><md-dialog-actions layout=\"row\" layout-align=\"space-between end\"><div layout=\"column\"><span>{{vm.user_name}}</span> <span>{{vm.date}} às {{vm.hour}}</span></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button\" aria-label=\"Add Task\"><div ng-if=\"!vm.fatal_error\">Cancelar</div><div ng-if=\"vm.fatal_error\">Fechar</div></md-button><md-button type=\"submit\" ng-click=\"vm.confirmPassword(vm.scope.password)\" ng-disabled=\"!password_form.$valid || vm.show_loading\" ng-if=\"!vm.fatal_error\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular>Confirmar</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-horizontal-nested.html\"><div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\"> <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\" ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </div> <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren && !vm.isHidden()\"> <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/components/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\"><div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\"> <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </div> <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren && !vm.isHidden()\"> <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/components/multi-select-tree/src/multi-select-tree.tpl.html","<div class=\"tree-control\"><div class=\"tree-input\" ng-click=\"onControlClicked($event)\"><span ng-if=\"selectedItems.length == 0\" class=\"selected-items\"><span ng-bind=\"defaultLabel\"></span></span> <span ng-if=\"selectedItems.length > 0\" class=\"selected-items\"><span ng-repeat=\"selectedItem in selectedItems\" class=\"selected-item\">{{selectedItem.name}} <span class=\"selected-item-close\" ng-click=\"deselectItem(selectedItem, $event)\"></span></span> <span class=\"caret\"></span></span></div><div class=\"tree-view\" ng-show=\"showTree\"><div class=\"helper-container\"><div class=\"line\" data-ng-if=\"switchView\"><button type=\"button\" ng-click=\"switchCurrentView($event);\" class=\"helper-button\">{{switchViewLabel}}</button></div><div class=\"line\"><input placeholder=\"Search...\" type=\"text\" ng-model=\"filterKeyword\" ng-click=\"onFilterClicked($event)\" class=\"input-filter\"> <span class=\"clear-button\" ng-click=\"clearFilter($event)\"><span class=\"item-close\"></span></span></div></div><ul class=\"tree-container\"><tree-item class=\"top-level\" ng-repeat=\"item in inputModel\" item=\"item\" ng-show=\"!item.isFiltered\" use-callback=\"useCallback\" can-select-item=\"canSelectItem\" multi-select=\"multiSelect\" item-selected=\"itemSelected(item)\" on-active-item=\"onActiveItem(item)\" select-only-leafs=\"selectOnlyLeafs\"></tree-item></ul></div></div>");
$templateCache.put("app/components/multi-select-tree/src/tree-item.tpl.html","<li><div class=\"item-container\" ng-class=\"{active: item.isActive, selected: item.selected}\" ng-click=\"clickSelectItem(item, $event)\" ng-mouseover=\"onMouseOver(item, $event)\"><span ng-if=\"showExpand(item)\" class=\"expand\" ng-class=\"{\'expand-opened\': item.isExpanded}\" ng-click=\"onExpandClicked(item, $event)\"></span><div class=\"item-details\"><input class=\"tree-checkbox\" type=\"checkbox\" ng-if=\"showCheckbox()\" ng-checked=\"item.selected\">{{item.name}}</div></div><ul ng-repeat=\"child in item.children\" ng-if=\"item.isExpanded\"><tree-item item=\"child\" item-selected=\"subItemSelected(item)\" use-callback=\"useCallback\" can-select-item=\"canSelectItem\" multi-select=\"multiSelect\" on-active-item=\"activeSubItem(item, $event)\"></tree-item></ul></li>");
$templateCache.put("app/components/select-dropdown/templates/index.html","<div class=\"select-dropdown\" style=\"margin-left: 28px;\"><div><label>{{title}}</label><md-select ng-model=\"selectedItems\" md-on-close=\"clearSearchTerm()\" ng-change=\"ngChange(selectedItems)\" data-md-container-class=\"select-dropdown-container\" multiple=\"\"><md-select-header class=\"select-header\"><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"{{placeholder}}\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=\"items\"><md-option ng-value=\"item\" ng-disabled=\"item.disabled\" ng-repeat=\"item in value | filter:searchTerm\" ng-selected=\"isContained(item.id)\">{{item.name}}</md-option></md-optgroup></md-select></div></div>");
$templateCache.put("app/components/select-grid/templates/single.html","<div layout=\"row\"><table class=\"simple group-field\" ms-responsive-table=\"true\" ng-show=\"list.length\"><thead><tr><th>Plano de pagamento*</th><th>Valor</th><th>Data de início</th><th>Documento</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in list\"><td><md-input-container class=\"md-block\"><md-select ng-model=\"item.payment_plan_id\" multiple=\"false\" aria-label=\"plano de pagamento\"><md-option md-selected-text=\"item.payment_plan_id == payment.id\" ng-value=\"payment.id\" ng-disabled=\"payment.is_inactive\" ng-repeat=\"payment in paymentplans\">{{payment.name}}</md-option></md-select></md-input-container></td><td><md-input-container class=\"md-block md-input-has-placeholder\"><label></label> <input type=\"text\" aria-label=\"price\" ng-model=\"item.price\" ui-money-mask=\"2\"></md-input-container></td><td><date-picker ng-model=\"item.date_first\"></date-picker></td><td><md-select ng-model=\"item.document_id\"><md-option ng-repeat=\"document in documents\" ng-value=\"document.id\">{{document.title}}</md-option><p ng-if=\"documents == null\">Sem serviços vinculados</p></md-select></td><td class=\"bt-delete\"><div ng-click=\"removeItem(item, $index)\"><md-icon md-font-icon=\"icon-delete {{$index == 0 || list.length <= 1 ? \'disabled\' : \'\'}}\"></md-icon></div></td></tr></tbody></table></div><div layout=\"row\"><div class=\"bt-add-detail\" ng-click=\"addItem()\"><span class=\"text-add\">Adicionar Plano de Pagamento</span><md-button class=\"md-fab md-mini md-raised bt-edit-add\" aria-label=\"Adicionar item\"><i class=\"icon-plus add-bt\"></i></md-button></div></div>");
$templateCache.put("app/components/select-rules/template/discount.html","<div ng-repeat=\"item in list\" layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\" class=\"a4-input\"><label>Regra de Descontos</label><md-select ng-model=\"item.discounts_rule_id\"><md-option ng-repeat=\"item in alldiscounts\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container><date-picker name=\"start_date\" flex=\"\" ng-model=\"item.start_date\" placeholder=\"Início\" ng-disabled=\"disableInitialDate\" ng-required=\"disableInitialDate\"></date-picker><date-picker name=\"date_end\" flex=\"\" placeholder=\"Fim\" ng-model=\"item.end_date\" ng-change=\"verifyIfEndDateSmallerThanInitialDate(item.end_date, item.start_date, $index)\" ng-required=\"disableInitialDate\"></date-picker><div flex=\"5\" ng-if=\"isAddItem\"><md-button class=\"md-icon-button\" aria-label=\"Adicionar item\" ng-click=\"addBlankItem(\'edit\')\"><md-tooltip>Adicionar</md-tooltip><md-icon md-font-icon=\"icon-plus-circle\" class=\"s20\"></md-icon></md-button></div><div flex=\"5\" ng-if=\"$index == list.length - 1 && $index > 0\"><md-button class=\"md-icon-button\" ng-click=\"remove($index);\"><md-tooltip>Deletar</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></div></div>");
$templateCache.put("app/components/select-rules/template/fines.html","<div class=\"form-horizontal\" role=\"form\" style=\"padding: 10px\"><div class=\"form-group\" style=\"margin-bottom:0px;\"><label class=\"col-md-5\">@ titleFirstField | translate @:</label> <label class=\"col-md-3\">@ \'Data Inicial\' | translate @:</label> <label class=\"col-md-3\">@ \'Data Final\' | translate @:</label></div><div class=\"form-group\" ng-repeat=\"item in list\"><div class=\"col-md-5\"><select type=\"text\" ng-model=\"item.fines_rule_id\" ng-options=\"i.id as i.name | translate for i in alladditions\"></select></div><div class=\"col-md-3\"><input type=\"text\" ng-model=\"item.start_date\" placeholder=\"Data do Contrato\" ng-disabled=\"disableInitialDate\"></div><div class=\"col-md-3\"><div class=\"input-group input-medium\"><datepicker date=\"item.end_date\" on-change=\"changeAdditionDateFinal($index)\"></datepicker></div></div><div class=\"col-sm-1\" ng-if=\"$index == list.length - 1 && $index > 0\"><div class=\"fa fa-times remove\" style=\"margin-left: 26px;font-size: 22px !important;position: relative !important;top: 11px !important;background-color: transparent;padding: 0px !important; color: #9B0000 !important;\" ng-click=\"remove($index)\"></div></div></div><a class=\"link-style\" ng-if=\"isAddItem\" ng-click=\"addBlankItem(\'edit\')\">(+) Adicionar regra de acréscimos</a></div>");
$templateCache.put("app/components/tree-view/templates/treeview.html","<js-tree tree-plugins=\"{{plugins}}\" tree-types=\"typesConfig\" tree-events=\"changed:changeCB;\" tree-data=\"scope\" tree-model=\"data\"></js-tree>");
$templateCache.put("app/components/widget-component/view/widget-component.html","<md-content layout=\"row\" style=\"height: 100%\" class=\"horizontal-scrollbar\"><ms-widget flippable=\"true\" layout=\"column\" ng-repeat=\"evaluation in questionnaire\" style=\"padding: 5px;\" class=\"ms-widget\" flex=\"33\" flex-xl=\"25\" flex-lg=\"33\" flex-md=\"50\" flex-sm=\"50\" flex-xs=\"100\" ng-if=\"actionStatus.includes(evaluation.qp_status)\"><ms-widget-front class=\"white-bg ms-widget-front\" style=\"box-shadow: 0 0 12px #ccc; cursor: pointer; border-left: 3px rgb(3,169,244) solid;\"><div class=\"p-16 border-bottom\" layout=\"row\" layout-align=\"start center\"><div flex=\"\" class=\"h4 hover-class-name secondary-text text-truncate\" style=\"cursor: pointer;color: #999999;\"><strong>{{evaluation.name}}</strong><br><small>Tipo de avaliação: {{evaluation.questionnaire_type}}</small><br><small>Disciplina: {{evaluation.subject_name}}</small></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div flex=\"\" class=\"h4 hover-class-name secondary-text text-truncate\" style=\"cursor: pointer;color: #999999;\"><div ng-if=\"evaluation.application_date !== null\">Data de entrega: {{evaluation.application_date}} <span></span></div><div ng-if=\"evaluation.answer_max_time_minutes !== null && evaluation.execution_time !== null\">Hora de início: {{evaluation.answer_max_time_minutes}}<br>Hora de término: {{evaluation.execution_time}}</div><strong>Número total de questões:</strong><span>{{evaluation.number_of_questions}}</span><br><br><span class=\"badge\" style=\"padding-top: 7px !important; margin-left: -5px !important;\" ng-if=\"evaluation.qp_status === null || evaluation.qp_status === 0 || evaluation.qp_status === 12 || evaluation.qp_status === 13 || evaluation.qp_status === 14\"><span class=\"aval_pendente\">PENDENTE</span></span><span class=\"badge\" style=\"padding-top: 7px !important; margin-left: -5px !important;\" ng-if=\"evaluation.qp_status === 1\"><span class=\"aval_em_andamento\">EM ANDAMENTO</span></span><span class=\"badge\" style=\"padding-top: 7px !important; margin-left: -5px !important;\" ng-if=\"evaluation.qp_status === 10 || evaluation.qp_status === 11 || evaluation.qp_status === 20\"><span class=\"aval_concluida\">CONCLUÍDA</span></span></div><div flex=\"\" class=\"flip-to-front\" style=\"margin-top: 5px !important;\"><md-button class=\"md-icon-button\" ng-if=\"evaluation.qp_status === 20\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-tooltip md-direction=\"left\">Girar para visualizar tipos de questões</md-tooltip><md-icon md-font-icon=\"icon-flip-to-front\" class=\"s16\"></md-icon></md-button></div></div><div flex=\"\" layout=\"row\" layout-align=\"space between\" class=\"p-16 grey-50-bg border-top\" style=\"padding: 2px 0;\"><div class=\"p-16 grey-50-bg\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\" style=\"color: #999999;\">Evento:</span> <span class=\"h4 ml-8 text-truncate\" style=\"color: #999999;\">{{evaluation.grade_rule_item_name}}</span></div><div class=\"p-16 grey-50-bg\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.evaluationAction(evaluation)\">{{ vm.ACTION_STATUS[evaluation.qp_status] }}</md-button></div></div></ms-widget-front><ms-widget-back class=\"white-bg ms-widget-back\" style=\"box-shadow: 0 0 12px #ccc\"><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div flex=\"\" class=\"h4 hover-class-name secondary-text\" style=\"cursor: pointer;color: #999999;\"><div><span>Número total de questões:</span> <span>{{evaluation.number_of_questions}}</span><hr></div><div><span>Acertos:</span> <span>{{evaluation.right_answers}}</span><hr></div><div><span>Erros:</span> <span>{{evaluation.number_of_questions - evaluation.right_answers}}</span><hr></div><div><span>Nota:</span> <span>{{evaluation.points}}</span><hr></div></div><div flex=\"\" class=\"flip-to-front\" style=\"margin-top: 5px !important;\"><md-button class=\"md-icon-button\" ng-disabled=\"evaluation.qp_status !== 20\" ng-click=\"flipWidget();\" aria-label=\"Flip widget\"><md-tooltip md-direction=\"left\">Informações adicionais</md-tooltip><md-icon md-font-icon=\"icon-flip-to-front\" class=\"s16\"></md-icon></md-button></div></div></ms-widget-back></ms-widget></md-content>");
$templateCache.put("app/controlpanel/app-log/templates/template-1.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div class=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/controlpanel/app-log/templates/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\" style=\"width: 100% !important;\"><div class=\"info\"><div class=\"title secondary-text\"><strong>{{card.event_format}}</strong></div><div class=\"event h4\" style=\"text-align: justify !important;\"><span ng-if=\"card.notes_done === null\">{{card.notes_scheduled}}</span> <span ng-if=\"card.notes_done !== null\">{{card.notes_done}}</span></div><div ng-if=\"card.contacts_names !== null\"><hr><span class=\"badge\" style=\"padding: 0 !important; margin: 0 !important;\"><span class=\"EventoContact\" ng-repeat=\"contact_name in card.contacts_names.split(\',\')\" style=\"margin-left: 3px\">{{contact_name}}</span></span></div></div></div>");
$templateCache.put("app/controlpanel/app-log/templates/template-9.html","<div class=\"template-9\"><div ng-click=\"card.edit(card.logInfo)\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div class=\"info\"><div class=\"title\" ng-if=\"card.title\"><b style=\"font-size: 17px\">{{card.title}}</b></div><div class=\"subtitle secondary-text\"><span ng-repeat=\"scope in card.scopes\" class=\"badge badgeLog badgeLeft\" ng-class=\"scope.cssClass\">{{scope.title}}</span></div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\" ng-bind-html=\"card.text\"></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\" ng-if=\"card.media.image.src !== null\"></div></div><div style=\"background-color: whitesmoke; margin-top: 5px;\"><span style=\"margin-left: 5px; padding: 3px\">O quanto eu gostei dessa novidade?</span><div class=\"buttons m-8\"><span class=\"badge badgeLog badgeOptions\" ng-repeat=\"button in card.buttons\" ng-class=\"{optionAnimation: !card.has_button_selected, buttonDisabled: card.has_button_selected && !button.selected, buttonSelected: card.has_button_selected && button.selected}\" ng-style=\"{\'background-color\': button.color}\" ng-click=\"card.clicked(card, button);$event.stopPropagation();$event.preventDefault();\">{{button.title}}</span></div><div class=\"buttons m-8\"><md-input-container style=\"width: 100%\"><textarea ng-model=\"card.feedback\" rows=\"2\" placeholder=\"Adicione um comentário\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"end start\"><md-button class=\"md-raised md-primary\" ng-click=\"card.save(card)\">Salvar</md-button></div></div></div>");
$templateCache.put("app/controlpanel/app-log/views/form.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.form.app_log_history.id\">Criar Log</h2><h2 ng-if=\"vm.form.app_log_history.id\">Editar Log</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><div flex=\"100\" layout=\"row\"><treeview data=\"vm.data\" response=\"vm.sys_module_id\" plugins=\"\'types,changed\'\" flex=\"50\"></treeview><div layout=\"row\" flex=\"50\"><md-input-container><input type=\"file\" file-read=\"\" ng-model=\"vm.log_image\" id=\"app_log_image\"><span ng-if=\"vm.img_load == true\">Imagem carregada</span></md-input-container></div></div><div flex=\"100\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" on-paginate=\"vm.paginate\" fields-schema=\"app/controlpanel/app-log/form.json\"></a4-form-dic-data></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/controlpanel/app-log/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ui-sref=\"private.controlpanel.dashboard\" style=\"margin-right: 10px; !important;\"><md-tooltip md-direction=\"top\">Voltar para o painel de controle</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"DISCOUNTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-elevation-rise\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Relatório de mudanças</span></div></div></md-toolbar><a4-app-log ng-model=\"vm.timeline\" timeline-function=\"vm.getAllLog()\"></a4-app-log></div>");
$templateCache.put("app/controlpanel/central-reports/define-details-wizard/index.html","<md-dialog aria-label=\"Criar relatório\" md-theme=\"details.item.theme\" style=\"min-width: 1100px; min-height: 300px;max-width: 1500px !important;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Definir Relatório</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"details.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0 !important;\"><div layout=\"column\"><md-steppers md-busy-text=\"\'Aguarde...\'\" md-busy=\"details.data.showBusyText\" md-theme=\"details.item.theme\" style=\"min-height: 400px\" md-dynamic-height=\"\" md-stretch-steppers=\"always\" md-selected=\"details.data.stepSelected\"><md-step label=\"Descrição\" md-complete=\"details.data.steps.description.completed\" ng-disabled=\"details.data.steps.description.disabled\"><div ng-controller=\"WizardDescriptionController as vm\" ng-if=\"details.data.stepSelected == 0\"><div ng-include=\"\'app/controlpanel/central-reports/define-details-wizard/steps/description/description.html\'\"></div></div></md-step><md-step label=\"Colunas\" md-complete=\"details.data.steps.columns.completed\" ng-disabled=\"details.data.steps.columns.disabled\"><div ng-controller=\"WizardColumnsController as vm\" ng-if=\"details.data.stepSelected == 1\"><div ng-include=\"\'app/controlpanel/central-reports/define-details-wizard/steps/columns/columns.html\'\"></div></div></md-step><md-step label=\"Ordenação\" md-complete=\"details.data.steps.classification.completed\" ng-disabled=\"details.data.steps.classification.disabled\"><div ng-controller=\"WizardClassificationController as vm\" ng-if=\"details.data.stepSelected == 2\"><div ng-include=\"\'app/controlpanel/central-reports/define-details-wizard/steps/classification/classification.html\'\"></div></div></md-step><md-step label=\"Agrupamentos\" md-complete=\"details.data.steps.grouping.completed\" ng-disabled=\"details.data.steps.grouping.disabled\"><div ng-controller=\"WizardGroupingController as vm\" ng-if=\"details.data.stepSelected == 3\"><div ng-include=\"\'app/controlpanel/central-reports/define-details-wizard/steps/grouping/grouping.html\'\"></div></div></md-step><md-step label=\"Filtro\" md-complete=\"details.data.steps.filter.completed\" ng-disabled=\"details.data.steps.filter.disabled\"><div ng-controller=\"WizardFilterController as vm\" ng-if=\"details.data.stepSelected == 4\"><div ng-include=\"\'app/controlpanel/central-reports/define-details-wizard/steps/filter/filter.html\'\"></div></div></md-step></md-steppers></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between\" style=\"background-color: whitesmoke !important;\"><md-button type=\"button\" ng-click=\"details.moveToPreviousStep()\" ng-disabled=\"$root.show_loader || details.current_step == 0\" class=\"md-primary md-raised\"><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"button\" class=\"md-primary md-raised\" ng-if=\"details.isLastStep || details.current_step >= 1\" ng-click=\"details.finishWizard()\" ng-disabled=\"$root.show_loader\"><span>Concluir e Visualizar</span><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-check\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"details.moveToNextStep()\" ng-disabled=\"$root.show_loader || details.isLastStep\"><span>Próximo</span><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/controlpanel/central-reports/modals/create.html","<md-dialog aria-label=\"Criar relatório\" md-theme=\"vm.folder.theme\"><form ng-cloak=\"\" ng-submit=\"vm.submit(vm.report)\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar Item</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><md-input-container class=\"md-input-has-placeholder\"><label>Nome</label> <input type=\"text\" ng-model=\"vm.report.name\" required=\"\"></md-input-container><md-input-container class=\"md-input-has-placeholder\"><md-radio-group layout=\"row\" required=\"\" ng-model=\"vm.report.type\"><md-radio-button ng-value=\"1\">Pasta</md-radio-button><md-radio-button ng-value=\"2\">Relatório</md-radio-button></md-radio-group></md-input-container></div></md-dialog-content><md-dialog-actions><md-button type=\"submit\" ng-disabled=\"form.$invalid || vm.show_progress\" class=\"md-raised\"><md-progress-circular ng-show=\"vm.show_progress\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/controlpanel/central-reports/modals/report.html","<style>\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    border: 1px solid #ddd;\n  }\n\n  th, td {\n    text-align: left;\n    padding: 10px;\n  }\n\n  tr:nth-child(even) {\n    background-color: #f2f2f2\n  }\n</style><md-dialog aria-label=\"Report\" style=\"width: 1200px\" md-theme=\"vm.data.theme\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.data.report_data.name}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-card style=\"background-color: whitesmoke; padding: 0; margin: 0;\"><p style=\"padding: 5px\">Estamos mostrando apenas os <b>20 primeiros</b> registro do relatório. Para ter todo o conteúdo gere um <b>PDF</b> nas opções na parte de baixo da caixa.</p></md-card><md-table-pagination ng-if=\"vm.data.report_array.breaks.length > 0\" md-limit=\"vm.data.report_array.breaksData.per_page\" md-limit-options=\"[20, 50, 75, 100]\" md-page=\"vm.data.report_array.breaksData.current_page\" md-total=\"{{vm.data.report_array.breaksData.total}}\" md-on-paginate=\"vm.getReportPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-pagination ng-if=\"vm.report_paginate.data.length > 0\" md-limit=\"vm.report_paginate.per_page\" md-limit-options=\"[20, 50, 75, 100]\" md-page=\"vm.report_paginate.current_page\" md-total=\"{{vm.report_paginate.total}}\" md-on-paginate=\"vm.getReportPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-repeat=\"item in vm.report.cols\" ng-attr-md-numeric=\"(item.type === \'double\')\">{{item.presentation}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"vm.data.report_array.breaks.length > 0\" ng-repeat-start=\"(key, breakItems) in vm.data.report_array.breaksData.data\"><td md-cell=\"\" ng-repeat=\"(key2 , column) in vm.report.cols\" ng-if=\"key2 == 0\"><span ng-if=\"angular.isNumber(key)\"><b>{{ key | currency:\" \"}}</b></span> <span ng-if=\"angular.isDate(key)\"><b>{{ key | date:\'dd/MM/yyyy\'}}</b></span> <span ng-if=\"!angular.isDate(key) && !angular.isNumber(key)\"><b>{{ key }}</b></span></td><td md-cell=\"\" ng-repeat=\"(key4 , column) in vm.report.cols\" ng-if=\"key4 > 0\"></td></tr><tr ng-repeat=\"breakItem in breakItems\" ng-if=\"breakItems[0] !== undefined\"><td md-cell=\"\" ng-repeat=\"column in vm.report.cols\"><span ng-if=\"(column.type === \'double\')\">{{ breakItem[column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')] | currency:\" \" }}</span> <span ng-if=\"(column.type === \'date\')\">{{ breakItem[column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')] | date:\'dd/MM/yyyy\' }}</span> <span ng-if=\"(column.type !== \'double\' && column.type !== \'date\')\">{{ breakItem[column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')] }}</span></td></tr><tr ng-repeat-start=\"(keyBreak2, break2Items) in breakItems\" ng-if=\"breakItems[0] === undefined\"><td md-cell=\"\" ng-repeat=\"(key2 , column) in vm.report.cols\" ng-if=\"key2 == 0\"><span ng-if=\"angular.isNumber(keyBreak2)\"><b>{{ keyBreak2 | currency:\" \"}}</b></span> <span ng-if=\"!angular.isNumber(keyBreak2)\"><b>{{ keyBreak2 | date:\'dd/MM/yyyy\'}}</b></span></td><td md-cell=\"\" ng-repeat=\"(key4 , column) in vm.report.cols\" ng-if=\"key4 > 0\"></td></tr><tr ng-repeat=\"breakItem2 in break2Items\" ng-if=\"breakItems[0] === undefined\"><td md-cell=\"\" ng-repeat=\"column in vm.report.cols\"><span ng-if=\"(column.type === \'double\')\">{{ breakItem2[column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')] | currency:\" \" }}</span> <span ng-if=\"(column.type === \'date\')\">{{ breakItem2[column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')] | date:\'dd/MM/yyyy\' }}</span> <span ng-if=\"(column.type !== \'double\' && column.type !== \'date\')\">{{ breakItem2[column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')] }}</span></td></tr><tr ng-repeat-end=\"\"></tr><tr ng-repeat-end=\"\"><td md-cell=\"\" ng-repeat=\"column in vm.report.cols\"><span ng-if=\"(column.type === \'double\')\">{{vm.getGroupedTotal(vm.data.report_array.breaksData.data, (column.index_data || column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')), key) | currency:\" \"}}</span></td></tr><tr md-row=\"\" ng-if=\"vm.report_paginate.data.length > 0\" ng-repeat=\"item in vm.report_paginate.data\"><td md-cell=\"\" ng-repeat=\"column in vm.report.cols\"><span ng-if=\"(column.type === \'double\')\">{{ item[column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')] | currency:\" \" }}</span> <span ng-if=\"(column.type === \'date\')\">{{ item[column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')] | date:\'dd/MM/yyyy\' }}</span> <span ng-if=\"(column.type !== \'double\' && column.type !== \'date\')\">{{ item[column.representation.split(\" AS \")[1].replace(\"\\}\\}\", \'\')] }}</span></td></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><div style=\"background-color: whitesmoke; margin: 0;padding: 5px 0 0;\" ng-if=\"vm.block_button\">Dependendo da quantidade de registros a geração do relatório pode demorar alguns minutos.</div><md-button class=\"md-raised md-warm\" ng-click=\"vm.getXLSX()\" ng-disabled=\"vm.block_button || (vm.data.report_array.breaksData > 0 || vm.report_paginate.data > 0)\"><md-progress-circular ng-show=\"vm.block_button\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon md-font-icon=\"icon-file-excel\"></md-icon>Gerar Excel XLSX</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.getCSV()\" ng-disabled=\"vm.block_button || (vm.data.report_array.breaksData > 0 || vm.report_paginate.data > 0)\"><md-progress-circular ng-show=\"vm.block_button\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon md-font-icon=\"icon-file-excel\"></md-icon>Gerar CSV</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.getPDF(\'portrait\')\" ng-disabled=\"vm.block_button || (vm.data.report_array.breaksData > 0 || vm.report_paginate.data > 0)\"><md-progress-circular ng-show=\"vm.block_button\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon>insert_drive_file</md-icon>Gerar PDF (Formato vertical)</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.getPDF(\'landscape\')\" ng-disabled=\"vm.block_button || (vm.data.report_array.breaksData > 0 || vm.report_paginate.data > 0)\"><md-progress-circular ng-show=\"vm.block_button\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon>insert_drive_file</md-icon>Gerar PDF (Formato horizontal)</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/controlpanel/idle-minutes-to-block/views/confirm-idle-modal.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" md-theme=\"educational\"><div class=\"modal-a4\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Ainda está aí?</span></div></md-toolbar><div flex=\"\" layout=\"row\" style=\"padding-left: 3px; padding-top: 3px;\"><md-card style=\"padding: 5px; width: 96%\" flex=\"\"><div layout=\"column\" flex=\"100\"><div layout=\"row\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><span style=\"font-size: 15px\"><b>{{vm.subtitle === null ? \'Confirmação\' : vm.subtitle}}</b></span> <span style=\"font-size: 15px\">Sua sessão será bloqueada em {{vm.count}} segundos</span></div></div></div></md-card></div></div><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeModal()\" ng-disabled=\"vm.show_loading\" class=\"md-raised md-button\" aria-label=\"Add Task\"><div>Continuar</div></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/controlpanel/idle-minutes-to-block/views/modal.html","<md-dialog md-theme=\"controlpanel\" style=\"width: 600px;\"><form name=\"inactivityTimeForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"title\">Gerenciar Tempo ocioso no sistema</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container><md-checkbox ng-model=\"vm.has_idle_minutes_to_block\">Definir tempo limite de ociosidade antes que a tela seja bloqueada</md-checkbox></md-input-container><div ng-if=\"vm.has_idle_minutes_to_block\" style=\"width: 100% !important;\"><md-input-container style=\"width: 100% !important;\"><md-icon md-font-icon=\"icon-lock\"></md-icon><input ng-model=\"vm.idle_minutes_to_block\" ng-value=\"vm.idle_minutes_to_block\" type=\"number\" placeholder=\"tempo limite em minutos\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.submit()\" ng-disabled=\"vm.block_button\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/controlpanel/ip-block/views/modal.html","<md-dialog aria-label=\"modal form ip block\" md-theme=\"controlpanel\" style=\"width: 600px;\"><form name=\"ipForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"title\">Gerenciar IPs para acesso</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container><md-checkbox ng-model=\"vm.has_block_ip\">Permitir acesso ao sistema apenas a determinados endereços de IP</md-checkbox></md-input-container><div ng-if=\"vm.has_block_ip\" style=\"width: 100% !important;\"><md-list flex=\"\"><md-subheader>Lista de endereços</md-subheader><md-list-item ng-repeat=\"ip in vm.ips track by $index\"><md-input-container flex=\"100\"><md-icon md-font-icon=\"icon-laptop-windows\"></md-icon><input ng-model=\"ip.address\" ng-value=\"ip.address\" type=\"text\"><md-icon md-font-icon=\"icon-delete\" style=\"cursor: pointer\" ng-click=\"vm.ips.splice($index, 1)\"></md-icon></md-input-container></md-list-item><md-list-item><md-button class=\"md-raised md-ink-ripple\" flex=\"100\" style=\"text-align: left\" ng-click=\"vm.addItem()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar novo endereço de IP</md-button></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.submit()\" ng-disabled=\"vm.block_button\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/controlpanel/person-unification/views/modal.html","<md-dialog aria-label=\"modal form ip block\" md-theme=\"controlpanel\" style=\"width: 600px;\"><form name=\"ipForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"title\">Unificação de pessoas</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><h2>A unificação segue os seguintes critérios:</h2><p>Pessoas que têm o nome muito similar, isto é, o mesmo nome mas com algum possível erro de digitação, e uma das seguintes informações deve estar coincidindo:</p><ul><li>CPF / CNPJ</li><li>Data de nascimento</li><li>Primeira linha do endereço</li><li>Telefone residencial</li><li>Telefone celular</li><li>Caso haja coincidência com CPF / CNPJ e também com data de nascimento, também ocorrerá a unificação, mesmo que haja diferenças mais significativas no nome.</li></ul><div style=\"text-align: center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.unificate()\" ng-disabled=\"vm.disable\"><md-icon md-font-icon=\"icon-account-multiple-outline\"></md-icon>Realizar unificação</md-button></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.disable\"></md-progress-linear></md-dialog-content></form></md-dialog>");
$templateCache.put("app/controlpanel/profile/views/index.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header header-inner md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><a4-upload-image class=\"edit-image\" ng-model=\"page.profile.image\"><md-button class=\"md-fab md-mini change-image\" aria-label=\"{{ \'PROFILE.EDIT_AVATAR\' | translate }}\"><md-icon ng-click=\"page.editImage();\"><i class=\"material-icons\">mode_edit</i></md-icon></md-button><img class=\"profile-image avatar huge\" src=\"{{ page.profile.image }}\"></a4-upload-image><div class=\"name\">{{ page.profile.name }}</div></div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"></div></div><md-content class=\"content md-padding\" style=\"padding-left: 100px; padding-right: 100px\" flex=\"\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><form name=\"formProfile\" ng-submit=\"page.submitProfile();\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"form-title\" translate=\"PROFILE.FORM\"></div><div class=\"more secondary-text\"><md-switch ng-model=\"page.editable\" aria-label=\"Switch 1\"><span translate=\"PROFILE.EDITABLE\"></span></md-switch></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><label>{{ \'PROFILE.FORM_CATEGORY\' | translate }}</label><md-select name=\"category\" ng-model=\"page.profile.category\" ng-disabled=\"!page.editable\"><md-option><em>None</em></md-option></md-select><div ng-messages=\"formProfile.category.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_CATEGORY_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"page.profile.name\" placeholder=\"{{ \'PROFILE.FORM_NAME\' | translate }}\" ng-disabled=\"!page.editable\" required=\"\"><div ng-messages=\"formProfile.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"national_id_number\" ng-model=\"page.profile.national_id_number\" placeholder=\"{{ \'PROFILE.FORM_NATIONAL_ID\' | translate }}\" ng-disabled=\"!page.editable\" required=\"\"><div ng-messages=\"formProfile.national_id_number.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_NATIONAL_ID_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><md-datepicker name=\"dob\" ng-model=\"page.profile.dob\" placeholder=\"{{ \'PROFILE.FORM_DOB\' | translate }}\" ng-disabled=\"!page.editable\"></md-datepicker><div ng-messages=\"formProfile.dob.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_DOB_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><label>{{ \'PROFILE.FORM_SEX\' | translate }}</label><md-select name=\"sex\" ng-model=\"page.profile.sex\" ng-disabled=\"!page.editable\"><md-option><em>None</em></md-option></md-select><div ng-messages=\"formProfile.sex.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_SEX_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"email\" ng-model=\"page.profile.email\" placeholder=\"{{ \'PROFILE.FORM_EMAIL\' | translate }}\" ng-disabled=\"!page.editable\" ng-change=\"page.profile.email = page.profile.email.toLowerCase();\" required=\"\"><div ng-messages=\"formProfile.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_EMAIL_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"phone_landline\" ng-model=\"page.profile.phone_landline\" placeholder=\"{{ \'PROFILE.FORM_PHONE_LANDLINE\' | translate }}\" ng-disabled=\"!page.editable\"><div ng-messages=\"formProfile.phone_landline.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_PHONE_LANDLINE_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"phone_mobile\" ng-model=\"page.profile.phone_mobile\" placeholder=\"{{ \'PROFILE.FORM_PHONE_MOBILE\' | translate }}\" ng-disabled=\"!page.editable\"><div ng-messages=\"formProfile.phone_mobile.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_PHONE_MOBILE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_street\" ng-model=\"page.profile.address_street\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_STREET\' | translate }}\" ng-disabled=\"!page.editable\"><div ng-messages=\"formProfile.address_street.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_STREET_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_line2\" ng-model=\"page.profile.address_line2\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_LINE2\' | translate }}\" ng-disabled=\"!page.editable\"><div ng-messages=\"formProfile.address_line2.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_LINE2_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_house_number\" ng-model=\"page.profile.address_house_number\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_HOUSE_NUMBER\' | translate }}\" ng-disabled=\"!page.editable\" required=\"\"><div ng-messages=\"formProfile.address_house_number.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_HOUSE_NUMBER_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_postal_code\" ng-model=\"page.profile.address_postal_code\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_POSTAL_CODE\' | translate }}\" ng-disabled=\"!page.editable\" required=\"\"><div ng-messages=\"formProfile.address_postal_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_POSTAL_CODE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_district\" ng-model=\"page.profile.address_district\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_DISTRICT\' | translate }}\" ng-disabled=\"!page.editable\" required=\"\"><div ng-messages=\"formProfile.address_district.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_DISTRICT_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_city\" ng-model=\"page.profile.address_city\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_CITY\' | translate }}\" ng-disabled=\"!page.editable\" required=\"\"><div ng-messages=\"formProfile.address_city.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_CITY_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_state\" ng-model=\"page.profile.address_state\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_STATE\' | translate }}\" ng-disabled=\"!page.editable\" required=\"\"><div ng-messages=\"formProfile.address_state.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_STATE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><footer layout=\"row\" layout-align=\"space-between center\" class=\"layout-align-space-between-center layout-row\"><div layout=\"row\" layout-align=\"start center\" class=\"layout-align-start-center layout-row\"></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'PROFILE.FORM_SUBMIT\' | translate }}\" ng-disabled=\"formProfile.$invalid || formProfile.$pristine\"><md-progress-circular style=\"float: left; top: 8px;left: 100px;\" ng-show=\"page.loginProcess\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'PROFILE.FORM_SUBMIT\' | translate }}</md-button></footer></form></div></div></md-content></div>");
$templateCache.put("app/controlpanel/roles/views/changePassword.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"userForm\" class=\"md-inline-form\" novalidate=\"\" ng-submit=\"vm.answer(vm.scope.user)\"><md-toolbar class=\"md-tall _md md-controlpanel-theme _md-toolbar-transitions\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\"ROLES.CHANGE_PASSWORD\" | translate}}</span></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\"><div flex=\"\"><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.PASSWORD\" | translate}}</label> <input ng-model=\"vm.scope.user.password\" name=\"password\" required=\"\" type=\"password\"><div ng-messages=\"userForm.password.$error\"><div ng-message=\"required\">Campo requerido.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.CONFIRM_PASSWORD\" | translate}}</label> <input ng-model=\"vm.scope.user.repeat_password\" name=\"repeat_password\" required=\"\" type=\"password\"><div ng-messages=\"userForm.repeat_password.$error\"><div ng-message=\"required\">Campo requerido.</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-disabled=\"!userForm.$valid\" class=\"send-button md-accent md-raised _md md-controlpanel-theme _md-toolbar-transitions\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple _md md-controlpanel-theme _md-toolbar-transitions\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/controlpanel/roles/views/create-person-company-modal.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-tall _md md-controlpanel-theme _md-toolbar-transitions\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Criar perfil em outra empresa</span></div></md-toolbar><md-dialog-content><md-input-container class=\"md-input-has-placeholder\" flex=\"100\"><md-icon md-font-icon=\"icon-clipboard-outline\"></md-icon><div class=\"select-dropdown\" style=\"margin-left: 28px;\"><div><label>Empresas disponíveis</label><md-select ng-model=\"vm.selectedCompany\" required=\"\"><md-option ng-repeat=\"company in vm.userCompanys\" value=\"{{company.id}}\">{{company.corporate_name}}</md-option><md-option value=\"null\" ng-if=\"vm.userCompanys.length == 0\" disabled=\"\">Nenhuma empresa disponível</md-option></md-select></div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account-outline\"></md-icon><md-select ng-model=\"vm.itensSelected\" multiple=\"\" required=\"\"><md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Papeis de usuário\"></md-select-header><md-option ng-value=\"item\" ng-repeat=\"item in vm.roles | filter:searchTerm\" ng-selected=\"vm.isContained(vm.user.user_role, item.id)\">{{item.name}}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.submit()\" ng-disabled=\"vm.selectedCompany == null || vm.itensSelected.length == 0\" class=\"send-button md-accent md-raised _md md-controlpanel-theme _md-toolbar-transitions\"><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" ng-if=\"vm.loader\" md-mode=\"indeterminate\"></md-progress-circular>{{\"ROLES.SAVE\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.closeModal(false)\" class=\"md-raised md-button md-ink-ripple_md md-controlpanel-theme_md-toolbar-transitions\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/controlpanel/roles/views/editUser.html","<md-dialog aria-label=\"modal form user\" md-theme=\"controlpanel\" style=\"width: 500px;\"><form name=\"roleForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"title\">Usuário</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\"><div flex=\"\"><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.NAME\" | translate}}</label> <input ng-model=\"vm.user.name\" type=\"text\" ng-required=\"\" md-autofocus=\"\" autocomplete=\"off\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.EMAIL\" | translate}}</label> <input ng-model=\"vm.user.email\" type=\"text\" ng-disabled=\"!vm.editable || vm.user.status === 10\" ng-change=\"vm.user.email = vm.user.email.toLowerCase();\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Nova senha</label> <input ng-model=\"vm.user.password\" show-password=\"vm.show_password\"><md-icon style=\"cursor: pointer\" ng-click=\"vm.show_password = !vm.show_password;\">visibility</md-icon></md-input-container><div ng-if=\"vm.user.is_employee\"><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"vm.companyEdit\" ng-change=\"vm.changeCompany()\"><md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Empresas\"></md-select-header><md-option ng-value=\"company.id\" ng-repeat=\"company in vm.companys | filter:searchTerm\">{{company.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" ng-if=\"vm.user.is_employee\"><md-select ng-model=\"vm.itensSelected\" multiple=\"\" ng-disabled=\"!vm.editable\"><md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Papeis de usuário\"></md-select-header><md-option ng-value=\"item\" ng-repeat=\"item in vm.roles | filter:searchTerm\" ng-selected=\"vm.isContained(vm.user.user_role, item.id)\" ng-if=\"(item.id !== 7 && item.id !== 4 && item.id !== 1 && item.id !== 2) || vm.isContained(vm.user.user_role, item.id)\">{{item.name}}</md-option></md-select></md-input-container><md-card><md-content layout=\"row\"><div style=\"background-color: #212121bf; width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 30px;\"></i><br><span style=\"font-size: 16px; color: #fff;\">Atenção! Ao alterar os papéis em uma empresa é necessário salvar antes de alterar os papéis em outra.</span></p></div></md-content></md-card></div><md-input-container class=\"md-icon-float md-block\"><md-checkbox ng-model=\"vm.blocked\" ng-if=\"vm.user.status === 10 || vm.user.status === 20\" ng-disabled=\"!(vm.editable)\">Bloquear conta</md-checkbox></md-input-container><md-input-container class=\"md-icon-float md-block\" ng-if=\"!vm.blocked\"><md-checkbox ng-model=\"vm.is_active\">Usuário ativo</md-checkbox></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\" ng-if=\"vm.editable\">{{\"ROLES.CANCEL\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\" ng-if=\"!vm.editable\">FECHAR</md-button><md-button type=\"submit\" ng-click=\"vm.update(vm.user, true)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\" ng-if=\"vm.editable\">{{\"ROLES.SAVE_CLOSE\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.update(vm.user, false)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\" ng-if=\"vm.editable\">{{\"ROLES.SAVE\" | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/controlpanel/roles/views/index.html","<div id=\"page-material-table\" style=\"background-color: whitesmoke\" class=\"doc-page material-docs doc-template page-layout simple tabbed ng-scope layout-column\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.controlpanel.dashboard\"><md-tooltip md-direction=\"top\">Voltar para o painel de controle</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"ROLES.MANAGE_USERS\"></span></div></div></md-toolbar><div layout=\"row\"><md-card flex=\"\"><div layout=\"row\" class=\"md-padding\"><md-input-container class=\"md-icon-float md-block\" flex=\"\"><md-icon md-font-icon=\"icon-folder-account\"></md-icon><label>Filtro por perfis/papéis</label><md-select ng-model=\"vm.roleSelected\" ng-change=\"vm.getAllUsers(1, 50)\"><md-option ng-value=\"null\">Todos</md-option><md-optgroup label=\"Perfis\"><md-option ng-value=\"profile.id\" ng-repeat=\"profile in vm.profiles\">{{profile.name}}</md-option></md-optgroup><md-optgroup label=\"Papéis\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.roles\">{{item.name}}</md-option></md-optgroup></md-select><md-checkbox ng-model=\"vm.check\" ng-change=\"vm.getAllUsers(1, 50)\">Exibir todos</md-checkbox><md-button ng-click=\"vm.changepasswordforraiodesol()\" ng-if=\"vm.is_suport\">incorporar alunos sem e-mail</md-button><md-button ng-click=\"vm.activeUsers()\" ng-if=\"vm.is_suport\">Disparar rotina de ativação de usuários</md-button></md-input-container><md-input-container class=\"md-icon-float md-block md-input-has-placeholder\" flex=\"\"><md-icon md-font-icon=\"icon-account-search\"></md-icon><label>Filtro por nome/e-mail</label> <input type=\"text\" ng-model=\"search\" ng-change=\"vm.getAllUsers(1, 50)\" ng-model-options=\"{debounce: 1000}\"></md-input-container><md-input-container class=\"md-icon-float md-block md-input-has-placeholder\" flex=\"\"><md-icon md-font-icon=\"icon-account-search\"></md-icon><label>Filtro por período letivo</label><md-select ng-model=\"vm.school_period_selected\" ng-change=\"vm.getAllUsers(1, 50)\"><md-option ng-value=\"\'null\'\">Todos</md-option><md-option ng-repeat=\"school_period in vm.school_periods.list\" ng-value=\"school_period.id\">{{school_period.id}}</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-input-has-placeholder\" flex=\"\"><md-icon md-font-icon=\"icon-account-search\"></md-icon><label>Filtro por status</label><md-select ng-model=\"vm.user_status_selected\" ng-change=\"vm.getAllUsers(1, 50)\"><md-option ng-value=\"\'null\'\">Todos</md-option><md-option ng-repeat=\"status in vm.userStatus\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.printUsers();\">Imprimir lista de usuários</md-button><md-table-pagination md-limit=\"vm.users.per_page\" md-limit-options=\"[50]\" md-page=\"vm.users.current_page\" style=\"border: none;\" md-total=\"{{vm.users.total}}\" md-on-paginate=\"vm.getAllUsers\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Usuário</th><th md-column=\"\">E-mail</th><th md-column=\"\">Perfil/Papel</th><th md-column=\"\">Status</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"user in vm.users.data\" ng-click=\"vm.updateUser($event, user);\" ng-disabled=\"vm.doubleclick\"><td md-cell=\"\"><div layout=\"row\" layout-align=\"start center\">{{user.name}}</div></td><td md-cell=\"\">{{user.email}}</td><td md-cell=\"\"><span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"user.is_student == 1\"><span class=\"is_student\">Estudante</span></span> <span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"user.is_payee >= 1\"><span class=\"is_payee\">Responsável financeiro</span></span> <span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"user.is_responsible >= 1\"><span class=\"is_responsible\">Responsável pedagógico</span></span> <span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"user.is_employee > 0\"><span class=\"Papeis\">Colaborador</span></span> <span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"user.is_coordinator == 1\"><span class=\"Papeis\">Coordenador de curso</span></span> <span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"user.is_supplier == 1\"><span class=\"Papeis\">Fornecedor</span></span> <span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"user.is_employee == 2 || user.is_employee == 3\"><span class=\"is_teacher\">Professor</span></span> <span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"user.roles !== \'{}\'\"></span></td><td md-cell=\"\" align=\"left\" width=\"10%\"><span class=\"badge\" style=\"padding: 0;margin-left: 0;\"><span class=\"{{user.status_name}}\">{{user.status_name}}</span></span></td><td md-cell=\"\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\" ng-disabled=\"user.status != 10\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.editEmail(user)\" ng-disabled=\"user.status != 10\"><md-icon>swap_horiz</md-icon>Trocar email</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-card></div></div>");
$templateCache.put("app/controlpanel/roles/views/manage.html","<link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css\" integrity=\"sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u\" crossorigin=\"anonymous\"><link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap-theme.min.css\" integrity=\"sha384-rHyoN1iRsVXV4nD0JutlnGaslCJuC7uwjduW9SVrLvRYooPp2bWYgmgJQIXwl/Sp\" crossorigin=\"anonymous\"><div id=\"page-material-table\" style=\"background-color: whitesmoke\" class=\"doc-page material-docs doc-template page-layout simple tabbed ng-scope layout-column\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.controlpanel.dashboard\"><md-tooltip md-direction=\"top\">Voltar para o painel de controle</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Gerenciar papéis de usuário</span></div></div></md-toolbar><div layout=\"row\"><md-card flex=\"\"><md-table-pagination md-limit=\"vm.users.per_page\" md-limit-options=\"[50, 75, 100]\" md-page=\"vm.users.current_page\" md-total=\"{{vm.users.total}}\" md-on-paginate=\"vm.paginateRequest\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\">Descrição</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"role in vm.roles\" ng-click=\"vm.openModalRole($event, role)\"><td md-cell=\"\"><div>{{role.name}}</div></td><td md-cell=\"\"><span ng-if=\"role.description == \'\' || role.description == null\">Sem descrição</span> <span ng-if=\"role.description !== null\">{{role.description}}</span></td><td md-cell=\"\"><md-button class=\"md-secondary\" aria-label=\"remove role\" ng-hide=\"role.is_special\" ng-click=\"$event.stopPropagation();vm.roleHasUser(role)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></md-table-container></md-card></div></div>");
$templateCache.put("app/controlpanel/roles/views/newUser.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" md-theme=\"controlpanel\"><form name=\"userForm\" class=\"md-inline-form\" novalidate=\"\" ng-submit=\"vm.saveNewUser(vm.user, userForm)\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\"ROLES.NEW_USER\" | translate}}</span></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\"><div flex=\"\"><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.NAME\" | translate}}</label> <input ng-model=\"vm.user.name\" name=\"name\" type=\"text\" required=\"\" md-autofocus=\"\"><div ng-messages=\"userForm.name.$error\"><div ng-message=\"required\">Você <b>deve</b> definir seu nome.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.EMAIL\" | translate}}</label> <input ng-model=\"vm.user.email\" name=\"email\" type=\"email\" required=\"\"><div ng-messages=\"userForm.email.$error\"><div ng-message=\"required\">Você <b>deve</b> definir o e-mail.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.PASSWORD\" | translate}}</label> <input ng-model=\"vm.user.password\" name=\"password\" type=\"password\" ng-minlength=\"6\" required=\"\"><div ng-messages=\"userForm.password.$error\"><div ng-message=\"required\">Você <b>deve</b> definir sua senha.</div><div ng-message=\"minlength\">Minimo de 6 caracteres.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.CONFIRM_PASSWORD\" | translate}}</label> <input ng-model=\"vm.user.repeat_password\" name=\"repeat_password\" type=\"password\" ng-minlength=\"6\" required=\"\"><div ng-messages=\"userForm.repeat_password.$error\"><div ng-message=\"required\">Você <b>deve</b> definir sua senha.</div><div ng-message=\"minlength\">Minimo de 6 caracteres.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"vm.itensSelected\" multiple=\"\"><md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Papeis de usuário\"></md-select-header><md-option ng-value=\"item\" ng-disabled=\"item.disabled\" ng-repeat=\"item in vm.roles | filter:searchTerm\" ng-selected=\"vm.isContained(vm.user.user_role, item.id)\">{{item.name}}</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-disabled=\"vm.loading\" class=\"md-accent md-raised\" aria-label=\"Add Task\"><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" ng-if=\"vm.loading\" md-mode=\"indeterminate\"></md-progress-circular>{{\"ROLES.SAVE\" | translate}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/crm/activities/views/activities.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\" translate=\"\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-outline\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Atividades</span></div></div></md-toolbar><md-content layout-row=\"\"><md-card class=\"md-padding\" flex=\"\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"\"><div><md-button class=\"md-icon-button\" ng-click=\"vm.previousDate()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span ng-if=\"vm.selectedFilter === \'day\'\">{{vm.selectedDate.format(\'dddd\')}}, {{vm.selectedDate.format(\'D\')}} de {{vm.selectedDate.format(\'MMMM\').toLowerCase()}} de {{vm.selectedDate.format(\'YYYY\')}}</span> <span ng-if=\"vm.selectedFilter === \'week\'\">De {{vm.selectedDate.startOf(\'week\').format(\'D\').toLowerCase()}} de {{vm.selectedDate.startOf(\'week\').format(\'MMMM\').toLowerCase()}} de {{vm.selectedDate.startOf(\'week\').format(\'YYYY\')}} até {{vm.selectedDate.endOf(\'week\').format(\'D\').toLowerCase()}} de {{vm.selectedDate.endOf(\'week\').format(\'MMMM\').toLowerCase()}} de {{vm.selectedDate.endOf(\'week\').format(\'YYYY\')}}</span> <span ng-if=\"vm.selectedFilter === \'month\'\">{{vm.selectedDate.format(\'MMMM\').toLowerCase()}} de {{vm.selectedDate.format(\'YYYY\')}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.nextDate()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div><md-button ng-repeat=\"(key, value) in vm.options\" ng-class=\"{\'md-primary\': vm[key]}\" ng-click=\"vm.setVisualization(key)\">{{value}}</md-button></div></div></md-card><md-card class=\"md-padding\"><table md-table=\"\" class=\"activities-table\"><tr md-row=\"\" ng-repeat=\"item in vm.activities\" style=\"cursor: pointer;\" ng-click=\"vm.goToLead(item)\" ng-style=\'{\"background-color\": item.date_done !== null ? \"rgba(91,222,124,0.18)\" : \"none\"}\'><td><span ng-include=\"\'app/components/a4-crm-contact-grid/views/contact-item-icon.html\'\"></span></td><td><strong>{{item.type}}</strong><br><span ng-if=\"vm.selectedFilter !== \'day\'\"><span ng-if=\"item.date_done !== null\">{{item.date_done | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"item.date_done == null\">{{item.date_scheduled | date:\'dd/MM/yyyy\'}}</span></span> {{item.time_order}}</td><td><strong>{{item.responsible_name}}</strong><br><span>{{item.address_city !== null ? item.address_city : \'\'}}{{item.address_state !== null ? \'/\' + item.address_state : \'\'}}</span></td><td>{{item.contacts_names}}</td><td>{{item.person_event_name}}</td></tr></table></md-card></md-content></div>");
$templateCache.put("app/crm/email-management/grouped/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-email\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">E-mails agrupados</span></div></div></md-toolbar><md-content layout-xs=\"column\" layout=\"column\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de envio dos e-mails\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-change=\"vm.getAll()\"></date-range-picker><md-table-container><md-table-pagination md-limit=\"vm.emails.per_page\" md-limit-options=\"[15, 30, 50]\" md-page=\"vm.emails.current_page\" md-on-paginate=\"vm.getAll\" style=\"border: none\" md-total=\"{{vm.emails.total}}\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Assunto</th><th md-column=\"\">Destinatários</th><th md-column=\"\" style=\"text-align: right\">Total</th><th md-column=\"\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"mails in vm.emails.data\"><td md-cell=\"\">{{mails.date}}</td><td md-cell=\"\">{{mails.subject}}</td><td md-cell=\"\">{{mails.receivers}}</td><td md-cell=\"\" style=\"text-align: right\">{{mails.total}}</td><td md-cell=\"\" style=\"text-align: right;\" class=\"item-mail-grid\"><span>{{mails.enviados}}<md-icon style=\"font-size: 22px; color: rgb(89, 226, 168);\">send</md-icon><md-tooltip md-direction=\"left\">Enviados</md-tooltip></span> <span>{{mails.entregues}}<md-icon style=\"font-size: 22px; color: rgb(63,157,238);\">mail</md-icon><md-tooltip md-direction=\"left\">Entregues</md-tooltip></span> <span>{{mails.abertos}}<md-icon style=\"font-size: 22px; color: rgb(255,194,81);\" md-font-icon=\"icon-email-open\"></md-icon><md-tooltip md-direction=\"left\">Abertos</md-tooltip></span> <span>{{mails.erros}}<md-icon style=\"font-size: 22px; color: rgb(171,0,0);\">error</md-icon><md-tooltip md-direction=\"left\">Erros</md-tooltip></span></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/crm/email-management/individual/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-email\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">E-mails individuais</span></div></div><div layout=\"row\" layout-align=\"start right\"><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start right\"><label for=\"searchSubject\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"searchSubject\" placeholder=\"Busca por assunto\" type=\"text\" ng-model=\"vm.searchSubject\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.getAll(undefined, undefined, vm.searchSubject, vm.searchDestinatary)\"></md-input-container></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start right\"><label for=\"searchDestinatary\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"searchDestinatary\" placeholder=\"Busca por destinatário\" type=\"text\" ng-model=\"vm.searchDestinatary\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.getAll(undefined, undefined, vm.searchSubject, vm.searchDestinatary)\"></md-input-container></div></div></md-toolbar><md-content layout-xs=\"column\" layout=\"column\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de envio dos e-mails\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-change=\"vm.getAll(undefined, undefined, vm.searchSubject, vm.searchDestinatary)\"></date-range-picker><md-table-container><md-table-pagination md-limit=\"vm.emails.per_page\" md-limit-options=\"[15, 30, 50]\" md-page=\"vm.emails.current_page\" md-on-paginate=\"vm.getAll\" style=\"border: none\" md-total=\"{{vm.emails.total}}\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Destinatário (nome)</th><th md-column=\"\">Destinatário (e-mail)</th><th md-column=\"\">Remetente (nome)</th><th md-column=\"\">Data/Hora envio</th><th md-column=\"\">Assunto</th><th md-column=\"\">Status</th><th md-column=\"\">Data/Hora abertura</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.emails.data\" style=\"cursor: pointer\"><td md-cell=\"\">{{item.destinatary}}</td><td md-cell=\"\">{{item.recipient}}</td><td md-cell=\"\">{{item.send_name}}</td><td md-cell=\"\">{{item.sent_at}}</td><td md-cell=\"\">{{item.subject}}</td><td md-cell=\"\">{{item.status}}</td><td md-cell=\"\">{{item.opened_at}}</td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/crm/leads/views/leads.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\" translate=\"\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-network\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Leads</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'PERSON.SEARCH\' | translate }}\" type=\"text\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.getLeads()\" ng-model=\"vm.search\" translate=\"\" translate-attr-placeholder=\"Pesquisar\"></md-input-container></div></md-toolbar><md-content layout-row=\"\"><md-table-pagination md-limit=\"vm.leads.per_page\" md-limit-options=\"[15, 30, 60]\" md-page=\"vm.leads.current_page\" style=\"border: none;\" flex=\"\" md-total=\"{{vm.leads.total}}\" md-on-paginate=\"vm.getLeads\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome fantasia</th><th md-column=\"\">UF</th><th md-column=\"\">Cidade</th><th md-column=\"\">Status</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"lead in vm.leads.data\" style=\"cursor: pointer\" ng-click=\"vm.editLead(lead.id); $event.preventDefault();\"><td md-cell=\"\">{{lead.name}}</td><td md-cell=\"\">{{lead.address_state}}</td><td md-cell=\"\">{{lead.address_city}}</td><td md-cell=\"\">{{lead.sales_stage}}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.goToLeadPage(lead);$event.stopPropagation();$event.preventDefault();\"><md-icon md-font-icon=\"icon-clipboard-outline\"></md-icon></md-button></td></tr></tbody></table></md-content></div>");
$templateCache.put("app/crm/leads/views/modal.html","<md-dialog aria-label=\"Lead\" md-theme=\"crm\" style=\"width: 650px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.lead.id\">Criar novo lead</h2><h2 ng-if=\"vm.lead.id\">Editar lead</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close(false)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-toolbar style=\"background-color: white !important;\"><div layout=\"row\" flex=\"\"><md-tabs md-center-tabs=\"\" md-selected=\"currentTab\" flex=\"100\"><md-tab id=\"company\" label=\"empresa\"></md-tab><md-tab id=\"endereço\" label=\"endereço\"></md-tab><md-tab id=\"contacts\" label=\"contatos\"></md-tab></md-tabs></div></md-toolbar><md-dialog-content class=\"md-padding md-inline-form new-material-inputs\" flex=\"\"><md-tabs md-dynamic-height=\"\" class=\"noTabPanel\" md-selected=\"currentTab\"><md-tab label=\"Empresa\"><form ng-cloak=\"\" name=\"formLead\"><div layout=\"row\" flex=\"\"><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">CNPJ</label> <input ui-br-cnpj-mask=\"\" ng-model=\"vm.lead.national_id_number\" flex=\"\"></md-input-container><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Nome fantasia</label> <input type=\"text\" ng-model=\"vm.lead.name\" required=\"\" flex=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Razão social</label> <input type=\"text\" ng-model=\"vm.lead.corporate_name\" flex=\"\"></md-input-container><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">E-mail</label> <input type=\"text\" ng-model=\"vm.lead.email\" flex=\"\"></md-input-container></div><div layout=\"row\" flex=\"\" style=\"margin-top: -13px !important;\"><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Website</label> <input type=\"text\" ng-model=\"vm.lead.website\" flex=\"\"></md-input-container><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Facebook</label> <input type=\"text\" ng-model=\"vm.lead.facebook\" flex=\"\"></md-input-container></div><div layout=\"column\" style=\"width: 100%; margin-top: -18px !important;\"><label for=\"select-sex\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Sexo</span></label><select2 ng-model=\"vm.lead.person_sex_id\" options=\"vm.options\" s2-options=\"val.id as val.name for val in vm.personSex\" id=\"select-sex\"></select2></div><div layout=\"column\" style=\"width: 100%\"><label for=\"select-sales-stage\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Estágio</span></label><select2 ng-model=\"vm.lead.sales_stage_id\" options=\"vm.options\" s2-options=\"val.id as val.name for val in vm.formInfo.salesStages\" id=\"select-sales-stage\"></select2></div><div layout=\"row\" flex=\"\" style=\"margin-bottom: -18px !important;\"><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Notas iniciais</label> <textarea ng-model=\"vm.lead.initial_notes\" rows=\"2\" flex=\"\"></textarea></md-input-container></div></form></md-tab><md-tab label=\"Endereço\"><form ng-cloak=\"\" name=\"formAddress\"><a4-address model=\"vm.lead\" is-enabled=\"true\"></a4-address></form></md-tab><md-tab label=\"Contatos\"><form ng-cloak=\"\" name=\"formContact\"><md-card class=\"md-padding\" ng-repeat=\"contact in vm.contacts\" flex=\"\"><div layout=\"row\" layout-align=\"end end\"><span><md-icon md-font-icon=\"icon-delete\" style=\"cursor: pointer\" ng-click=\"vm.contacts.splice(vm.contacts.indexOf(contact), 1)\"></md-icon></span></div><div layout=\"row\" flex=\"\"><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Nome</label> <input type=\"text\" ng-model=\"contact.name\" flex=\"\"></md-input-container><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Sexo</label><md-select ng-model=\"contact.person_sex_id\" flex=\"\"><md-option ng-repeat=\"sex in vm.personSex\" ng-value=\"sex.id\">{{sex.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\" style=\"margin-top: -15px !important;\"><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Telefone</label> <input ui-br-phone-number=\"\" ng-model=\"contact.phone_landline\" flex=\"\"></md-input-container><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Celular</label> <input ui-br-phone-number=\"\" ng-model=\"contact.phone_mobile\" flex=\"\"></md-input-container></div><div layout=\"row\" flex=\"\" style=\"margin-top: -15px !important;\"><a4email model=\"contact.email\" is-enabled=\"true\" flex=\"\"></a4email><md-input-container class=\"md-input-has-placeholder md-block\" flex=\"\"><label class=\"isEnabled\">Funções</label><md-select multiple=\"\" ng-model=\"contact.contact_roles\" required=\"\"><md-option ng-repeat=\"contactRole in vm.formInfo.contactRoles\" ng-value=\"contactRole.id\"><small>{{contactRole.name}}</small></md-option></md-select></md-input-container></div><div layout=\"row\" style=\"margin-top: -15px !important;\"><md-input-container class=\"md-input-has-placeholder md-block show-bottom\" flex=\"\"><label class=\"isEnabled\">Observações</label> <textarea ng-model=\"contact.notes\" rows=\"2\"></textarea></md-input-container></div></md-card></form><md-button class=\"md-raised\" style=\"width: 100%; padding: 5px;\" ng-click=\"vm.contacts.push({type: vm.CONTATO_DE_EMPRESA, person_sex_id: \'M\'})\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar contato</md-button></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close(false)\" ng-disabled=\"vm.loader\">Cancelar</md-button><md-button flex=\"15\" layout=\"row\" ng-disabled=\"(formLead.$invalid || formContact.$invalid) || vm.loader\" class=\"md-raised md-primary\" ng-click=\"vm.save()\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loader\" flex=\"5\" md-diameter=\"15\"></md-progress-circular><span flex=\"\">Salvar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/crm/prospects/views/prospects.html","<a4-crm-contact-grid type=\"\'prospects\'\"></a4-crm-contact-grid>");
$templateCache.put("app/crm/reports/charge-report/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.crm.reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-cash-usd\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de cobranças</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><legend>Filtro:</legend><md-dialog-content><md-input-container><md-radio-group ng-model=\"vm.option\" layout=\"row\"><md-radio-button ng-value=\"null\">Todas as cobranças</md-radio-button><md-radio-button ng-value=\"0\">Apenas as realizadas</md-radio-button><md-radio-button ng-value=\"1\">Apenas as não realizadas</md-radio-button></md-radio-group></md-input-container><md-dialog-content><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de datas do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-click=\"vm.disable = false\"></date-range-picker></md-dialog-content></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" style=\"padding: 5px;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-cash-usd\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/crm/reports/views/list.html","<md-content id=\"boards-crm\" class=\"md-accent-bg\" layout=\"column\" flex=\"\" ng-style=\"{height: (vm.windowHeight)}\"><div id=\"board-selector-crm\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1>Relatórios</h1>{{iframeHeight}}<div class=\"board-list-crm\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ng-if=\"board.policy\"><div ui-sref=\"{{board.state}}\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"{{board.icon}}\" class=\"icon s64\"></md-icon><md-tooltip md-direction=\"top\">{{board.description}}</md-tooltip><div class=\"board-name\">{{board.name}}</div></div></div></div></div></md-content>");
$templateCache.put("app/crm/reports/views/reports-page.html","<div id=\"page-material-table\" class=\"md-accent-bg page-layout simple left-sidenav inner-sidenav\" ui-view=\"reports\" style=\"background-color: whitesmoke\"></div>");
$templateCache.put("app/educational/academic-calendar/views/academic-calendar.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'ACADEMIC_CALENDAR.TITLE\' | translate }}</span></div></div></md-toolbar><md-card class=\"md-padding\" ng-if=\"!vm.checkPolicies(\'calend\')\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-paginate=\"vm.getAllCalendarEvents\" on-delete=\"vm.deleteEvent(index)\" on-click-item=\"vm.editCalendarEvent(item)\" policies=\"{show:\'calend\', cud:\'calend_alt\'}\" fields-schema=\"app/educational/academic-calendar/grid.json\"></a4-grid-dic-data></md-card></div>");
$templateCache.put("app/educational/academic-calendar/views/new-calendar-event.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"width: 700px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.form.calendar.id\">Criar evento de calendário</h2><h2 ng-if=\"vm.form.calendar.id\">Atualizar evento de calendário</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.cancel()\" policies=\"{cud:\'calend_alt\'}\" fields-schema=\"app/educational/academic-calendar/form_event.json\"></a4-form-dic-data></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/app-log/views/log-list.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"controlpanel\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Novidades neste módulo</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><a4-app-log ng-model=\"vm.scope.timeline\"></a4-app-log></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button type=\"button\" class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(true)\">Ok!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/educational/cancel-reasons/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"DISCOUNTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Motivos de cancelamento</span></div></div></md-toolbar><md-content layout-xs=\"column\" layout=\"row\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><div style=\"border: 1px solid; padding: 10px\"><crud model=\"vm.pessoa\" options=\"vm.crud_options\"></crud></div><md-table-container><md-table-pagination md-limit=\"vm.reasons.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.reasons.current_page\" md-on-paginate=\"vm.getAllReasons\" style=\"border: none\" md-total=\"{{vm.reasons.total}}\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th colspan=\"10\">Nome</th><th colspan=\"10\">Ações</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.reasons.data\" ng-click=\"vm.editReason(item)\" style=\"cursor: pointer\"><td md-cell=\"\" colspan=\"10\">{{item.name}}</td><td md-cell=\"\" colspan=\"10\" style=\"padding-top: 15px; padding-bottom: 15px;\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete(item.id); $event.stopPropagation()\" ng-if=\"item.enrolment_period_id === null\" style=\"margin-right: -500px !important;\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip>Excluir motivo</md-tooltip></md-icon></md-button><md-button class=\"md-icon-button\" disabled=\"true\" ng-if=\"item.enrolment_period_id !== null\" ng-click=\"$event.stopPropagation()\" style=\"margin-right: -500px !important;\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip>Por estar associado a um cancelamento de matrícula já existente, este motivo não pode ser excluído</md-tooltip></md-icon></md-button></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/educational/class-grouping/views/create-class.html","<md-dialog md-theme=\"educational\" style=\"min-width: 900px; !important; max-height: 100%; !important;\"><md-toolbar class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><h2>{{ \'CLASS_GROUPING.TITLE_CREATE_CLASS\' | translate }}</h2></div></div><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></md-toolbar><md-dialog-content class=\"md-padding\" layout=\"column\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submitGrouping(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/class-grouping/form_class.json\"></a4-form-dic-data></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/class-grouping/views/create.html","<md-dialog md-theme=\"educational\" style=\"min-width: 900px; !important; max-height: 100%; !important;\"><md-toolbar class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><h2>{{ \'CLASS_GROUPING.TITLE_CREATE_GRADE\' | translate }}</h2></div></div><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></md-toolbar><md-dialog-content class=\"md-padding\" layout=\"column\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submitGrouping(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/class-grouping/form_grade.json\"></a4-form-dic-data></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/class-grouping/views/edit-class.html","<md-dialog md-theme=\"educational\" style=\"min-width: 900px; !important; max-height: 100%; !important;\"><md-toolbar class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><h2>{{ \'CLASS_GROUPING.TITLE_EDIT\' | translate }}</h2></div></div><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></md-toolbar><md-dialog-content class=\"md-padding\" layout=\"column\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submitGrouping(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/class-grouping/form_class.json\"></a4-form-dic-data></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/class-grouping/views/edit.html","<md-dialog md-theme=\"educational\" style=\"min-width: 900px; !important; max-height: 100%; !important;\"><md-toolbar class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><h2>{{ \'CLASS_GROUPING.TITLE_EDIT\' | translate }}</h2></div></div><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></md-toolbar><md-dialog-content class=\"md-padding\" layout=\"column\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submitGrouping(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/class-grouping/form_edit_grade.json\"></a4-form-dic-data></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/class-grouping/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-group\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'CLASS_GROUPING.TITLE\' | translate }}</span></div></div></md-toolbar><md-card class=\"md-padding\" ng-if=\"!vm.checkPolicies(\'agrup_classe_alt\')\"><strong class=\"group-field\"><small>Selecione o tipo de lançamento</small></strong><div layout=\"row\" layout-wrap=\"\"><md-radio-group ng-model=\"vm.grouping_type\" layout=\"row\"><md-radio-button value=\"2\" flex=\"\">Para lançamento de notas</md-radio-button><md-radio-button value=\"1\" flex=\"\">Para lançamento de aulas</md-radio-button></md-radio-group><div flex=\"100\" ng-show=\"vm.grouping_type === \'2\'\" class=\"table-float-button\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-paginate=\"vm.paginate\" on-delete=\"vm.deleteGrouping(index)\" on-click-item=\"vm.editGradeGrouping(item)\" policies=\"{show:\'agrup_classe_alt\', cud:\'agrup_classe_alt\'}\" fields-schema=\"app/educational/class-grouping/grid_notes.json\"></a4-grid-dic-data></div><div flex=\"100\" ng-show=\"vm.grouping_type === \'1\'\" class=\"table-float-button\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-paginate=\"vm.paginate\" on-delete=\"vm.deleteGrouping(index)\" on-click-item=\"vm.editClassGrouping(item)\" policies=\"{show:\'agrup_classe_alt\', cud:\'agrup_classe_alt\'}\" fields-schema=\"app/educational/class-grouping/grid_class.json\"></a4-grid-dic-data></div></div></md-card></div>");
$templateCache.put("app/educational/class-release/dialog/classroom.html","<form ng-submit=\"vm.submit(vm.schoolrooms)\" novalidate=\"\"><table class=\"simple table-note-release no-border-top\" flex=\"100\"><thead><tr><th>Aula</th><th>Assuntos / Atividades</th><th>Atividades para casa</th><th>Situação</th></tr></thead><tbody><tr ng-repeat=\"rooms in vm.schoolrooms\"><td style=\"text-align: center\">{{rooms.lesson_date | date:\'dd/MM/yyyy\'}}<br>{{rooms.lesson_date | date:\'EEE\' | uppercase}}<br>{{rooms.initial_time}} até {{rooms.final_time}}</td><td><md-input-container><textarea data-ng-model=\"rooms.activity\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></td><td><md-input-container><textarea data-ng-model=\"rooms.homework\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></td><td style=\"text-align: center\"><a4-switch-button states=\"vm.buttonStates\" data-ng-model=\"rooms.lesson_status_id\"></a4-switch-button></td></tr></tbody></table><md-input-container flex=\"15\"><md-button type=\"submit\" ng-disabled=\"$root.show_loader\" class=\"md-raised md-primary\">Salvar</md-button></md-input-container></form>");
$templateCache.put("app/educational/class-release/dialog/files.html","<div layout=\"row\"><div flex=\"\" ng-repeat=\"lesson in vm.schoolrooms\" ng-init=\"vm.getLessonsArtifacts(lesson);\"><div layout=\"row\"><div flex=\"\"><h3>Links</h3><md-content><form name=\"formLinks\" ng-submit=\"vm.submitLinks(formLinks, lesson, lesson.links)\" novalidate=\"\"><div layout=\"row\"><md-chips class=\"custom-chips chip-links\" ng-model=\"lesson.links\" placeholder=\"Insira os título do link\" readonly=\"false\" md-removable=\"true\" md-transform-chip=\"vm.newChip($chip)\" md-on-select=\"vm.selectAddLink()\" ng-click=\"vm.getSelectedChipLinkIndex($event, lesson.links)\" flex=\"\"><md-chip-template><strong>{{$chip.name}}</strong></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon>close</md-icon></button></md-chips><md-input-container ng-hide=\"lesson.links[vm.selectedChipLink]\" flex=\"15\"><md-button ng-click=\"vm.saveLinks(lesson, lesson.links)\" class=\"md-raised md-primary\">Salvar</md-button></md-input-container></div><div layout=\"row\" ng-show=\"lesson.links[vm.selectedChipLink]\"><md-input-container flex=\"40\"><input ng-model=\"lesson.links[vm.selectedChipLink].name\" placeholder=\"Título\" required=\"\"></md-input-container><md-input-container flex=\"60\"><input type=\"url\" pattern=\"https?://.+\" ng-model=\"lesson.links[vm.selectedChipLink].file_reference\" placeholder=\"URL\" required=\"\"></md-input-container></div><div layout=\"row\" ng-show=\"lesson.links[vm.selectedChipLink]\"><md-input-container flex=\"\"><textarea ng-model=\"lesson.links[vm.selectedChipLink].notes\" placeholder=\"Observação\"></textarea></md-input-container><md-input-container flex=\"15\"><md-button type=\"submit\" ng-disabled=\"formLinks.$invalid || formLinks.$pristine || $root.show_loader\" class=\"md-raised md-primary\">Salvar</md-button></md-input-container></div></form></md-content></div><div flex=\"\"><h3>Arquivos</h3><md-content><form name=\"formUploads\" ng-submit=\"vm.submitFiles(formUploads, lesson, lesson.files)\" novalidate=\"\"><div layout=\"row\"><md-chips class=\"custom-chips chip-files\" ng-model=\"lesson.files\" placeholder=\"Insira o título do arquivo\" readonly=\"false\" md-removable=\"true\" md-transform-chip=\"vm.newChip($chip)\" md-on-select=\"vm.selectAddFile()\" ng-click=\"vm.getSelectedChipFileIndex($event, lesson.files)\" flex=\"\"><md-chip-template><strong>{{$chip.name}}</strong></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon>close</md-icon></button></md-chips><md-input-container flex=\"15\"><md-button ng-click=\"vm.saveFiles(lesson, lesson.files)\" class=\"md-raised md-primary\">Salvar</md-button></md-input-container></div><div layout=\"row\" ng-show=\"lesson.files[vm.selectedChipFile]\"><md-input-container flex=\"100\"><input ng-model=\"lesson.files[vm.selectedChipFile].name\" placeholder=\"Título\" required=\"\"></md-input-container></div><div layout=\"row\" ng-show=\"lesson.files[vm.selectedChipFile]\"><md-input-container flex=\"100\"><textarea ng-model=\"lesson.files[vm.selectedChipFile].notes\" placeholder=\"Observação\"></textarea></md-input-container><a4-upload-drag to=\"http://api.a4net.local/api/classes/uploadfiles\" name=\"upload\" ng-model=\"lesson.files[vm.selectedChipFile].origin\"></a4-upload-drag><md-input-container flex=\"15\"><md-button type=\"submit\" ng-disabled=\"formUploads.$invalid || formUploads.$pristine || $root.show_loader\" class=\"md-raised md-primary\">Salvar</md-button></md-input-container></div></form></md-content></div></div></div></div>");
$templateCache.put("app/educational/class-release/dialog/frequency.html","<md-content class=\"md-padding\" layout=\"row\"><md-input-container md-no-float=\"\" class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label>Classes</label><md-select ng-model=\"vm.form.lesson.group_id\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Procure pela classe..\" ng-change=\"vm.getClasses({query: vm.searchTerm})\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation();\" ng-model-options=\"{debounce: 500}\"></md-select-header><md-option ng-value=\"class\" ng-repeat=\"class in vm.classes\">{{class.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label>Data</label><md-datepicker ng-model=\"vm.form.lesson.date\" md-open-on-focus=\"\"></md-datepicker></md-input-container></md-content><table class=\"simple table-note-release no-border-top\" flex=\"100\"><thead><tr><th>Aluno</th><th ng-repeat=\"date in vm.date\">{{date.lesson_date}}</th></tr></thead><tbody><tr ng-repeat=\"(id, student) in vm.students track by $index\"><td>{{student.name}}</td><td ng-repeat=\"date in vm.date\"><a4-switch-button states=\"vm.buttonStates\" data-ng-model=\"student.lesson_status_id\"></a4-switch-button></td></tr></tbody></table>");
$templateCache.put("app/educational/class-release/dialog/more-info.html","<md-dialog aria-label=\"Mango (Fruit)\" style=\"min-width: 600px\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Mais Informações</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\" style=\"padding: 0\"><div layout=\"row\" style=\"margin-bottom: 15px\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Tipo da aula</label><md-icon md-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-select ng-model=\"vm.lesson.type\" required=\"\" placeholder=\"\"><md-option ng-repeat=\"item in vm.lesson_type\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Objetivos</label> <textarea ng-model=\"vm.lesson.objectives\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Metodologia/Procedimentos</label> <textarea ng-model=\"vm.lesson.methodology\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Recursos empregados</label> <textarea ng-model=\"vm.lesson.resources\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Avaliação</label> <textarea ng-model=\"vm.lesson.evaluation\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/class-release/views/class-release-assistant.html","<md-dialog aria-label=\"Create Subject\" style=\"max-width: 1500px;width: 1500px;\" md-theme=\"educational\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Assistente de lançamento de aulas</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0px; padding-left: 0px; padding-right: 0px;\"><md-progress-linear class=\"loader-main-body\" ng-show=\"$root.show_loader\" md-mode=\"indeterminate\"></md-progress-linear><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Lançamento de Aulas\"><md-content ng-if=\"vm.selected_tab == 0\" style=\"min-height: 400px\" class=\"md-padding\"><div ng-include=\"vm.templates.classroom\"></div></md-content></md-tab><md-tab label=\"Lançamento de Frequência\"><md-content ng-if=\"vm.selected_tab == 1\" class=\"md-padding\"><div ng-include=\"vm.templates.frequency\"></div></md-content></md-tab><md-tab label=\"Arquivos & Links\"><md-content ng-if=\"vm.selected_tab == 2\" class=\"md-padding\"><div ng-include=\"vm.templates.files\"></div></md-content></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/class-release/views/class-release-finish-option.html","<md-dialog aria-label=\"Mango (Fruit)\" md-theme=\"educational\" style=\"width: 800px\"><form ng-cloak=\"\"><md-dialog-content><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" ng-click=\"vm.answer(1)\" target=\"_blank\"><md-icon md-font-icon=\"icon-keyboard-return\"></md-icon><div>Voltar para a lista de aulas</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" ng-click=\"vm.answer(2)\" target=\"_blank\"><md-icon md-font-icon=\"icon-trending-neutral\"></md-icon><div>Realizar próxima aula</div></a></md-card></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/class-release/views/class-release-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.classes.show({ group_id: vm.form.group_id, matrix_period: vm.form.matrix_period, subject_id: vm.form.subject_id})\" policy-access=\"classe_menu\" style=\"margin-right: 10px; !important;\"><md-tooltip md-direction=\"top\">Voltar para lista de aulas</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><a4-search-field url=\"/classes\" style=\"width: 100%\" on-change=\"vm.changeClass(item)\" selected-item=\"vm.form.classe\" placeholder=\"{{vm.schoolrooms[0].group_name || vm.students[0].group_name}}\" icon=\"icon-school\"></a4-search-field></div></div></md-toolbar><md-card><md-tabs md-selected=\"vm.selected_tab\" md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Lançamento\" ng-disabled=\"vm.checkPolicies(\'aula_alt\')\"><form name=\"lesson_form\"><md-content ng-if=\"vm.selected_tab == 0\"><md-table-container><table md-table=\"\" class=\"md-padding\" flex=\"100\"><thead md-head=\"\"><tr md-row=\"\" style=\"border: none !important;\"><th md-column=\"\">Aula</th><th md-column=\"\" style=\"text-align: center\">Assuntos</th><th md-column=\"\" style=\"text-align: center\">Atividades para casa</th><th md-column=\"\" style=\"text-align: center\">Observações</th><th md-column=\"\"></th><th md-column=\"\">Anexos</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"(index, rooms) in vm.schoolrooms\"><td md-cell=\"\" style=\"padding: 20px 0 5px 0;\">{{rooms.date | date:\'dd/MM/yyyy\'}} ({{rooms.date | date:\'EEE\' | uppercase}}) | {{rooms.initial_time | date:\'HH:MM\'}} - {{rooms.final_time | date:\'HH:MM\'}}</td><td md-cell=\"\" style=\"padding: 20px 0 5px 0;text-align: center\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-book-open\"></md-icon><textarea name=\"activity\" ng-model=\"rooms.activity\" md-select-on-focus=\"\" required=\"\"></textarea><div class=\"required\" ng-if=\"lesson_form.activity.$invalid\">Campo obrigatório.</div></md-input-container></td><td md-cell=\"\" style=\"padding: 20px 0 5px 0;\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-document\"></md-icon><textarea ng-model=\"rooms.homework\" md-select-on-focus=\"\"></textarea></md-input-container></td><td md-cell=\"\" style=\"padding: 20px 0 5px 0;\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-glasses\"></md-icon><textarea ng-model=\"rooms.notes\" md-select-on-focus=\"\"></textarea></md-input-container></td><td md-cell=\"\"><md-button class=\"md-icon-button\" aria-label=\"Anexos\" ng-click=\"vm.moreLessonInfo(rooms)\"><md-icon md-font-icon=\"icon-more\"></md-icon><md-tooltip md-direction=\"top\">Mais informações</md-tooltip></md-button></td><td md-cell=\"\"><div class=\"badge-content\"><div class=\"badge-btn\" ng-if=\"rooms.artifact_qtd != null && rooms.artifact_qtd > 0\">{{rooms.artifact_qtd}}</div><md-button class=\"md-icon-button\" aria-label=\"Anexos\" ng-click=\"vm.addAttachment(rooms)\"><md-icon>attach_file</md-icon><md-tooltip md-direction=\"top\">Anexos</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container></md-content></form></md-tab><md-tab label=\"Frequência\" ng-disabled=\"vm.checkPolicies(\'aula_alt\') || vm.disable_frequency_tab\" md-on-select=\"vm.setData()\" ng-click=\"vm.setLessonsIds()\" ng-show=\"vm.releaseInEdition.length\"><md-content ng-if=\"vm.selected_tab == 1\" class=\"md-padding\"><table class=\"simple no-border-top\" flex=\"100\"><thead><tr><th><strong>Aluno</strong></th><th ng-repeat=\"(index, date) in vm.date\" style=\"text-align: center; max-width: 100px\" ng-hide=\"vm.schoolrooms[index].lesson_status_id == 4 || vm.schoolrooms[index].lesson_status_id == 0\"><strong>{{date.lesson_date | date:\'dd/MM/yyyy\'}} ({{date.lesson_date | date:\'EEE\' | uppercase}})<br>{{date.initial_time | date:\'HH:mm\'}} até {{date.final_time | date:\'HH:mm\'}}</strong></th></tr></thead><tbody><tr class=\"small\" ng-repeat=\"(id, student) in vm.students track by $index\"><td ng-if=\"student.cancel_date == null\">{{student.name}} <span ng-if=\"student.attendance_mode !== null\" class=\"badge\"><span class=\"attendance_mode_{{student.attendance_mode_id}}\">{{student.attendance_mode}}</span></span><br><small ng-if=\"student.frequency_count != \'\'\">{{student.frequency_count}}</small></td><td ng-if=\"student.cancel_date != null\" style=\"color: rgba(0,19,36,0.45);\"><div style=\"font-size: 13px; text-decoration: line-through;\">{{student.name}}</div><div style=\"font-size: 10px;\">Cancelado em {{student.cancel_date | date:\'dd/MM/yyyy\'}}</div></td><td style=\"text-align: center; max-width: 100px\" ng-if=\"student.cancel_date == null\" ng-repeat=\"(index, id) in vm.ids\" ng-init=\"class = \'class_\' + id\" ng-hide=\"(vm.schoolrooms[index].lesson_status_id == 4 || vm.schoolrooms[index].lesson_status_id == 0)\"><a4-switch-button states=\"vm.buttonStatesFrequency\" format-string=\"vm.formatStringAbsencesLatenessEarly\" data-ng-model=\"student[class]\" item=\"student\"></a4-switch-button><md-button class=\"md-icon-button\" ng-click=\"vm.insertNotes(student, notes)\" aria-label=\"delete\" ng-init=\"notes = \'notes_\' + id\"><md-icon md-font-icon=\"icon-information\"></md-icon><md-tooltip md-direction=\"bottom\" class=\"multiline\"><span ng-hide=\"student[notes]\">Adicionar observações</span> <span ng-show=\"student[notes]\">Editar observações</span></md-tooltip></md-button><div md-truncate=\"\">{{student[notes]}}<md-tooltip md-direction=\"bottom\">{{student[notes]}}</md-tooltip></div></td><td ng-if=\"student.cancel_date != null\" ng-repeat=\"id in vm.ids\"></td></tr></tbody></table></md-content><md-content layout=\"row\" layout-xs=\"column\" class=\"md-padding\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" layout-align=\"end center\"></md-content></md-tab></md-tabs></md-card></div>");
$templateCache.put("app/educational/class-release/views/class-release.html","<div ui-view=\"class-release\"></div>");
$templateCache.put("app/educational/class-release/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-book-multiple-variant\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'CLASS_RELEASE.TITLE\' | translate }} <span ng-show=\"vm.releaseInEdition.length\">{{vm.releaseInEdition}}</span></span></div></div></md-toolbar><md-card layout-padding=\"\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\" class=\"hide-first hide-last\" ng-class=\"(vm.releaseInEdition.length) ? \'tabs-show\' : \'tabs-hide\'\" ng-if=\"!vm.checkPolicies(\'aula\')\"><md-tab label=\"Selecionar aulas\" md-on-select=\"vm.setData()\"><md-content style=\"min-height: 400px\" ng-if=\"vm.selected_tab == 0\" ng-init=\"vm.releaseInEdition = null; vm.show_filter = false;\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-show=\"vm.show_filter\" layout-align=\"end center\" flex=\"\"><div flex=\"50\"><md-input-container><label>Classes</label><md-select ng-model=\"vm.classSelected\" multiple=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Procure pela classe..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation();\" ng-model-options=\"{debounce: 500}\"></md-select-header><md-button layout-fill=\"\" value=\"all\" ng-click=\"vm.selectAllClasses()\"><span ng-hide=\"vm.selectAllClass\">Selecionar todas</span> <span ng-show=\"vm.selectAllClass\">Limpar seleção</span></md-button><md-option ng-value=\"fakeID\" ng-repeat=\"(index, class) in vm.classes\" ng-init=\"fakeID = class.id + \'|\' + class.subject_id + \'|\' + class.matrix_period;\">{{class.name}}</md-option></md-select></md-input-container><md-input-container><label>Status</label><md-select ng-model=\"vm.statusSelected\" multiple=\"\"><md-button layout-fill=\"\" value=\"all\" ng-click=\"vm.selectAllStatusPossible()\"><span ng-hide=\"vm.selectAllStatus\">Selecionar todas</span> <span ng-show=\"vm.selectAllStatus\">Limpar seleção</span></md-button><md-option ng-value=\"status.id\" ng-repeat=\"(index, status) in vm.lesson_status\">{{status.name}}</md-option></md-select></md-input-container></div><div flex=\"45\"><date-range-picker ng-model=\"vm.form.date\" label=\"Datas\" selected-period=\"vm.form.selected_period\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></div><div flex=\"5\"><md-button ng-click=\"vm.paginate()\" ng-disabled=\"formArtefac.$invalid || formArtefac.$pristine || $root.show_loader\" class=\"md-fab md-mini\"><md-icon>search</md-icon></md-button></div></div></div><div class=\"float-right\"><md-button ng-click=\"vm.show_filter = !vm.show_filter\" class=\"md-fab md-mini\"><md-tooltip md-direction=\"top\"><span ng-hide=\"vm.show_filter\">Exibir</span> <span ng-show=\"vm.show_filter\">Ocultar</span> filtro</md-tooltip><md-icon>filter_list</md-icon></md-button></div><a4-form-dic-data bind=\"vm.grid\" on-paginate=\"vm.paginate\" on-click-actions=\"vm.clickActions(item, option)\" on-click-item=\"vm.editLesson(item)\" on-process-selected=\"vm.editLessons()\" policies=\"{show:\'aula_alt\', cud:\'aula_alt\'}\" fields-schema=\"app/educational/class-release/grid.json\"></a4-form-dic-data></md-content></md-tab><md-tab label=\"Lançamento\" ng-disabled=\"vm.checkPolicies(\'aula_alt\')\"><md-content style=\"min-height: 400px\" ng-if=\"vm.selected_tab == 1\"><table class=\"simple no-border-top\" flex=\"100\" ng-form=\"lesson_form\"><thead><tr><th>Aula</th><th>Assuntos</th><th>Atividades para casa</th><th>Observações</th><th>Anexos</th></tr></thead><tbody><tr ng-repeat=\"(index, rooms) in vm.schoolrooms\" ng-init=\"rooms.valid = lesson_form.$invalid; vm.formValid(lesson_form.$invalid)\"><td>{{rooms.date | date:\'dd/MM/yyyy\'}} ({{rooms.date | date:\'EEE\' | uppercase}}) | {{rooms.initial_time | date:\'HH:MM\'}} - {{rooms.final_time | date:\'HH:MM\'}}</td><td><md-input-container class=\"md-block\" ng-if=\"rooms.lesson_status_id == 1\"><textarea name=\"activity\" ng-change=\"vm.formValid(lesson_form.$invalid)\" ng-model=\"rooms.activity\" md-select-on-focus=\"\" required=\"\"></textarea><div class=\"required\" ng-if=\"lesson_form.activity.$invalid\">Campo obrigatório.</div></md-input-container><md-input-container class=\"md-block\" ng-if=\"rooms.lesson_status_id != 1\"><textarea name=\"activity\" ng-change=\"vm.formValid(lesson_form.$invalid)\" ng-model=\"rooms.activity\" md-select-on-focus=\"\"></textarea></md-input-container></td><td><md-input-container class=\"md-block\"><textarea ng-model=\"rooms.homework\" md-select-on-focus=\"\"></textarea></md-input-container></td><td><md-input-container class=\"md-block\"><textarea ng-model=\"rooms.notes\" md-select-on-focus=\"\"></textarea></md-input-container></td><td><div layout=\"row\" layout-align=\"center center\"><div class=\"badge-content\"><div class=\"badge-btn\" ng-hide=\"rooms.artifact_qtd == null || rooms.artifact_qtd == 0\">{{rooms.artifact_qtd}}</div><md-button class=\"md-fab md-mini\" aria-label=\"Anexos\" ng-click=\"vm.addAttachment(rooms)\"><md-icon>attach_file</md-icon><md-tooltip md-direction=\"top\">Anexos</md-tooltip></md-button></div></div></td></tr></tbody></table></md-content></md-tab><md-tab label=\"Frequência\" ng-disabled=\"vm.checkPolicies(\'aula_alt\')\" md-on-select=\"vm.setData()\" ng-click=\"vm.setLessonsIds()\" ng-show=\"vm.releaseInEdition.length\"><md-content ng-if=\"vm.selected_tab == 2\" class=\"md-padding\"><table class=\"simple no-border-top\" flex=\"100\"><thead><tr><th><strong>Aluno</strong></th><th ng-repeat=\"(index, date) in vm.date\" style=\"text-align: center; max-width: 100px\" ng-hide=\"vm.schoolrooms[index].lesson_status_id == 4 || vm.schoolrooms[index].lesson_status_id == 0\"><strong>{{date.lesson_date | date:\'dd/MM/yyyy\'}} ({{date.lesson_date | date:\'EEE\' | uppercase}})<br>{{date.initial_time | date:\'HH:mm\'}} até {{date.final_time | date:\'HH:mm\'}}</strong></th></tr></thead><tbody><tr class=\"small\" ng-repeat=\"(id, student) in vm.students track by $index\"><td ng-if=\"student.cancel_date == null\">{{student.name}}<br><small ng-if=\"student.frequency_count != \'\'\">{{student.frequency_count}}</small></td><td ng-if=\"student.cancel_date != null\" style=\"color: rgba(0,19,36,0.45);\"><div style=\"font-size: 13px; text-decoration: line-through;\">{{student.name}}</div><div style=\"font-size: 10px;\">Cancelado em {{student.cancel_date | date:\'dd/MM/yyyy\'}}</div></td><td style=\"text-align: center; max-width: 100px\" ng-if=\"student.cancel_date == null\" ng-repeat=\"(index, id) in vm.ids\" ng-init=\"class = \'class_\' + id\" ng-hide=\"(vm.schoolrooms[index].lesson_status_id == 4 || vm.schoolrooms[index].lesson_status_id == 0)\"><a4-switch-button states=\"vm.buttonStatesFrequency\" format-string=\"true\" data-ng-model=\"student[class]\" item=\"student\"></a4-switch-button><md-button ng-click=\"vm.insertNotes(student, notes)\" class=\"md-icon-button\" aria-label=\"delete\" ng-init=\"notes = \'notes_\' + id\"><md-icon>info</md-icon><md-tooltip md-direction=\"bottom\" class=\"multiline\"><span ng-hide=\"student[notes]\">Adicionar observações</span> <span ng-show=\"student[notes]\">Editar observações</span></md-tooltip></md-button><div md-truncate=\"\">{{student[notes]}}<md-tooltip md-direction=\"bottom\">{{student[notes]}}</md-tooltip></div></td><td ng-if=\"student.cancel_date != null\" ng-repeat=\"id in vm.ids\"></td></tr></tbody></table></md-content><md-content layout=\"row\" layout-xs=\"column\" class=\"md-padding\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" layout-align=\"end center\"></md-content></md-tab></md-tabs></md-card></div>");
$templateCache.put("app/educational/classes/views/classes-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\" ng-if=\"!vm.checkPolicies(\'classe\')\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.classes.list\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><a4-search-field url=\"/classes\" flex=\"\" on-change=\"vm.changeClass(item)\" selected-item=\"vm.form.classe\" placeholder=\"{{vm.form.classe.name}}\" icon=\"icon-school\"></a4-search-field><md-checkbox style=\"margin-left: 15px\" ng-change=\"$root.$broadcast(\'CHANGE_IS_DETAILED\', vm.is_detailed)\" ng-model=\"vm.is_detailed\" ng-if=\"vm.selected_tab == 2\" aria-label=\"Boletim detalhado\">Mostrar boletim detalhado</md-checkbox><md-button ng-click=\"$root.$broadcast(\'PRINT_NOTES\', null)\" ng-if=\"vm.selected_tab == 2\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir notas</md-tooltip></md-button></div></div></md-toolbar><div ng-if=\"!vm.checkPolicies(\'classe\')\" style=\"background-color: whitesmoke !important;padding: 0;\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Aulas\" md-on-select=\"vm.reload()\"><md-card ng-if=\"vm.selected_tab == 0\"><div ui-view=\"classrooms\"></div></md-card></md-tab><md-tab label=\"Alunos\" md-on-select=\"vm.reload()\"><md-card ng-if=\"vm.selected_tab == 1\"><div ui-view=\"students\"></div></md-card></md-tab><md-tab label=\"Notas\" md-on-select=\"vm.reload()\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 2\"><div ui-view=\"grades\"></div></md-card></md-tab><md-tab label=\"Gráfico de rendimento\" md-on-select=\"vm.reload()\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 3\"><div ui-view=\"yield-graph\"></div></md-card></md-tab><md-tab label=\"Lançamento de notas\" md-on-select=\"vm.reload()\" ng-if=\"false\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 4\"><div ui-view=\"notes-release\"></div></md-card></md-tab><md-tab label=\"Pendências de notas\" md-on-select=\"vm.reload()\"><md-content class=\"md-padding\" ng-if=\"vm.selected_tab == 4\"><div ui-view=\"notes-pending\"></div></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/educational/classes/views/classes.html","<div ui-view=\"classes\"></div>");
$templateCache.put("app/educational/classes/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" scroll=\"\"><style>\n    .hover-class-name:hover {\n      text-decoration: underline;\n    }\n  </style><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.checkPolicies(\'classe\')\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-book-multiple-variant\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'CLASSES.TITLE\' | translate }}</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.checkPolicies(\'classe\')\"><label for=\"course\"><md-icon md-font-icon=\"icon-school\"></md-icon></label><md-input-container id=\"course\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.course_id\" placeholder=\"Curso\" ng-change=\"vm.setGroups(vm.course_id); vm.paginate(undefined, undefined, undefined, vm.course_id, undefined)\" md-on-open=\"vm.loadCourses()\"><md-option ng-value=\"null\"><em>Todos</em></md-option><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course.id\">{{course.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.checkPolicies(\'classe\')\"><label for=\"group\"><md-icon md-font-icon=\"icon-chair-school\"></md-icon></label><md-input-container id=\"group\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.group_id\" placeholder=\"Turma\" ng-change=\"vm.paginate(undefined, undefined, undefined, vm.course_id, vm.group_id)\" ng-disabled=\"vm.course_id == null\"><md-option ng-value=\"null\"><em>Todos</em></md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.checkPolicies(\'classe\')\"><label for=\"subject\"><md-icon md-font-icon=\"icon-book-open\"></md-icon></label><md-input-container id=\"subject\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.subject_id\" ng-change=\"vm.filterBySubject(vm.subject_id)\" ng-disabled=\"vm.group_id == null && vm.course_id == null\"><md-option ng-value=\"null\"><em>Todos</em></md-option><md-option ng-repeat=\"subject in vm.subjects\" ng-value=\"subject.id\" ng-disabled=\"vm.group_id == null && vm.course_id == null\">{{subject.name}}</md-option></md-select></md-input-container></div></div></md-toolbar><md-content layout-padding=\"\" ng-if=\"!vm.checkPolicies(\'classe\')\" layout=\"row\" layout-wrap=\"\" style=\"background-color: whitesmoke !important;width: 90%; margin: 0 auto\"><md-card ng-if=\"vm.cards.data.length == 0 && !vm.withoutClasses\" style=\"width: 100%;\"><md-content layout=\"row\" style=\"background-color: whitesmoke\"><div style=\"background-color: rgba(3,169,244, 1); width: 100%; height: auto;text-align: center;\"><p style=\"vertical-align: baseline;\"><md-icon style=\"color: white;font-size: 30px\" md-font-icon=\"icon-emoticon-sad\"></md-icon><br><span style=\"font-size: 25px; color: #fff;\">Nenhuma classe encontrada.</span></p><p><span style=\"font-size: 18px; color: #fff;\">Utilize os filtros para modificar essa situação</span></p></div></md-content></md-card><md-card ng-if=\"vm.withoutClasses\" style=\"width: 100%;\"><md-content layout=\"row\" style=\"background-color: whitesmoke\"><div style=\"background-color: rgba(3,169,244, 1); width: 100%; height: auto;text-align: center;\"><p style=\"vertical-align: baseline;\"><md-icon style=\"color: white;font-size: 30px\" md-font-icon=\"icon-alert-octagon\"></md-icon><br><span style=\"font-size: 25px; color: #fff;\">Não existem classes no sistema.</span></p><p><span style=\"font-size: 18px; color: #fff;\">As classes são apresentadas com base na montagem das grades de horário das turmas, então não serão apresentadas classes de turmas que ainda não possuam grade de horário montada.</span></p></div></md-content></md-card><ms-widget flippable=\"true\" layout=\"column\" ng-repeat=\"item in vm.cards.data\" style=\"padding: 5px;\" class=\"ms-widget\" flex=\"33\" flex-xl=\"25\" flex-lg=\"33\" flex-md=\"50\" flex-sm=\"50\" flex-xs=\"100\"><ms-widget-front class=\"white-bg ms-widget-front\" style=\"box-shadow: 0 0 12px #ccc; cursor: pointer; border-left: 3px rgb(3,169,244) solid;\" ng-click=\"vm.editClass(item)\"><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div flex=\"\" class=\"h4 hover-class-name secondary-text text-truncate\" style=\"cursor: pointer;color: #999999;\">{{item.course_name}}<br><small>{{item.group_name}} | {{item.subject_name}}</small></div></div><div flex=\"\" layout=\"column\" style=\"padding: 2px 0;\"><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\" style=\"color: #999999;\">Prof(a):</span> <span class=\"h4 ml-8 text-truncate\" style=\"color: #999999;\">{{item.teacher_name}}</span></div></div></ms-widget-front><ms-widget-back class=\"white-bg ms-widget-back\" style=\"box-shadow: 0 0 12px #ccc\"><div class=\"p-16 grey-50-bg border-bottom\" layout=\"row\" layout-align=\"start center\"><div flex=\"\" class=\"h4 hover-class-name secondary-text text-truncate\" style=\"cursor: pointer;color: #999999;\" ng-click=\"vm.editClass(item)\">{{item.course_name}}<br><small>{{item.group_name}} | {{item.subject_name}}</small></div><div flex=\"\" class=\"flip-to-front\" style=\"margin-top: 5px !important;\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-tooltip md-direction=\"left\">Girar</md-tooltip><md-icon md-font-icon=\"icon-flip-to-front\" class=\"s16\"></md-icon></md-button></div></div><div flex=\"\" layout=\"row\" style=\"padding: 8px 0;\" layout-wrap=\"\" layout-align=\"center center\"></div></ms-widget-back></ms-widget></md-content></div>");
$templateCache.put("app/educational/collaborators/views/collaborators-page.html","<div ng-if=\"!vm.checkIdentifier()\" id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.collaborators.list\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><label class=\"new-resource\" ng-if=\"!vm.form.person.id\" ng-show=\"vm.form.person\"><md-icon>supervisor_account</md-icon><strong>NOVO COLABORADOR</strong></label><a4-search-field url=\"/collaborators\" style=\"width: 100%\" on-change=\"vm.changeCollaborator(item)\" selected-item=\"vm.form.person\" icon=\"icon-account-multiple\" placeholder=\"{{vm.form.person.name}}\" ng-if=\"vm.form.person.id\"></a4-search-field></div><md-button ng-click=\"vm.deleteCollaborator(vm.form.person.id)\" ng-show=\"!vm.checkPolicies(\'colab_alt\') && (vm.selected_tab == 0 && !vm.form.person.block_delete && vm.form.person.id)\" class=\"md-icon-button btn-edit\" aria-label=\"delete\"><md-tooltip md-direction=\"bottom\">Remover</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-click=\"vm.ableEdit()\" class=\"md-icon-button btn-edit\" ng-if=\"vm.form.person.id\" ng-show=\"!vm.checkPolicies(\'colab_alt\') && (vm.selected_tab == 0 || vm.selected_tab == 1 && vm.form.person.id)\" aria-label=\"COLLABORATORS.EDIT\" translate-attr-aria-label=\"COLLABORATORS.EDIT\"><md-tooltip><span ng-show=\"!vm.form.mode_edit\">Editar</span> <span ng-show=\"vm.form.mode_edit\">Cancelar Edição</span></md-tooltip><md-icon ng-show=\"!vm.form.mode_edit\" md-font-icon=\"icon-pencil\"></md-icon><md-icon ng-show=\"vm.form.mode_edit\" md-font-icon=\"icon-cancel\"></md-icon></md-button></div></md-toolbar><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important;\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Geral\"><a4-email-warning person-id=\"vm.person_id\"></a4-email-warning><div layout=\"row\"><md-card layout=\"row\" layout-gt-xs=\"center start\" style=\"min-width: 1000px; margin: 10px auto\"><div layout=\"column\" style=\"width: 100%\" layout-gt-xs=\"center start\"><div style=\"background-color: #1e95cb; height: 35px; padding: 8px;\"><span style=\"color: white; font-size: 15px;\">Informações pessoais</span></div><div class=\"md-padding\"><form name=\"form_collaborator\"><div layout=\"row\" layout-align=\"space-between start\" flex=\"\"><div flex=\"50\" style=\"margin-right: 4px;\"><a4-collaborator-form person=\"vm.form.person\" is-enabled=\"vm.form.mode_edit\" form-collaborator=\"form_collaborator\"></a4-collaborator-form></div><div flex=\"50\" style=\"margin-left: 4px;\"><a4-collaborator-contact-form person=\"vm.form.person\" is-enabled=\"vm.form.mode_edit\" form-collaborator-contact=\"form_collaborator\"></a4-collaborator-contact-form></div></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.submit(form_collaborator, vm.form.person)\" ng-disabled=\"!vm.form.mode_edit\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Salvar</md-button></div></form></div></div></md-card></div></md-tab><md-tab label=\"Informações funcionais\" md-on-select=\"vm.reload()\"><md-content class=\"md-padding\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(form, item)\" on-close=\"vm.close()\" fields-schema=\"app/educational/collaborators/form-info.json\"></a4-form-dic-data></md-content></md-tab><md-tab label=\"Documentos\" md-on-select=\"vm.reload()\" ng-disabled=\"vm.checkPolicies(\'colab_ocor\') || vm.person_id == undefined\"><md-content class=\"md-padding\" ng-if=\"vm.selected_tab == 2\"><div ui-view=\"documents\"></div></md-content></md-tab><md-tab label=\"Agenda\" md-on-select=\"vm.reload()\" ng-disabled=\"vm.checkPolicies(\'colab\') || vm.form.person.id == undefined\"><md-content class=\"md-padding\" ng-if=\"vm.selected_tab == 3\"><div ui-view=\"timetable\"></div></md-content></md-tab><md-tab label=\"Classes\" md-on-select=\"vm.reload()\" ng-disabled=\"vm.checkPolicies(\'colab\') || vm.form.person.id == undefined\"><md-content class=\"md-padding\" style=\"background-color: whitesmoke\" ng-if=\"vm.selected_tab == 4\"><div ui-view=\"classes\"></div></md-content></md-tab><md-tab label=\"Pendências de notas\" md-on-select=\"vm.reload()\"><md-content class=\"md-padding\" ng-if=\"vm.selected_tab == 5\"><div ui-view=\"pendencies\"></div></md-content></md-tab><md-tab label=\"Ocorrências\" md-on-select=\"vm.reload()\"><md-content class=\"md-padding\" ng-if=\"vm.selected_tab == 6\"><div ui-view=\"occurrences\"></div></md-content></md-tab></md-tabs></md-content></div><div ng-if=\"vm.checkIdentifier()\"><md-content><a4-calendar ng-model=\"vm.events_calendar\" person-id=\"vm.teacherId\" events=\"vm.getLessons(id, start, end)\"></a4-calendar></md-content></div>");
$templateCache.put("app/educational/collaborators/views/collaborators.html","<div ui-view=\"collaborators\"></div>");
$templateCache.put("app/educational/collaborators/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'COLLABORATORS.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.checkPolicies(\'colab\')\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'COLLABORATORS.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.filterCollaboratorsList(vm.search)\" translate=\"\" translate-attr-placeholder=\"COLLABORATORS.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-card layout-padding=\"\" ng-if=\"!vm.checkPolicies(\'colab\')\"><md-content layout=\"row\" class=\"table-float-button\"><md-checkbox style=\"position: absolute; top:20px; left:23px;\" ng-model=\"vm.is_inactive\" aria-label=\"Mostrar colaboradores inativos\" ng-change=\"vm.paginate()\" class=\"is_inactive\">Mostrar colaboradores inativos</md-checkbox><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editCollaborator(item)\" on-click-actions=\"vm.makeAction(item, option)\" on-delete=\"vm.deleteCollaborator(index)\" policies=\"{show:\'colab\', cud:\'colab_alt\'}\" fields-schema=\"app/educational/collaborators/grid.json\"></a4-grid-dic-data></md-content></md-card></div>");
$templateCache.put("app/educational/collaborators/views/search-collaborator-modal.html","<md-dialog aria-label=\"Create Responsible\" md-theme=\"educational\"><form name=\"form\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Criar colaborador</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 150px; min-width: 650px;\" layout=\"column\"><form novalidate=\"\" name=\"formPerson\"><md-autocomplete flex=\"\" md-input-minlength=\"3\" md-input-maxlength=\"150\" md-input-name=\"persons_selected\" md-selected-item=\"vm.selectedPerson\" md-no-cache=\"true\" md-delay=\"500\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"3\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Digite o nome do colaborador\"><md-item-template><span class=\"item-title\"><md-icon md-font-icon=\"icon-city\"></md-icon><span md-highlight-text=\"vm.searchText\">{{item.name}} - {{item.national_id_number}}</span></span></md-item-template></md-autocomplete></form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Voltar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-disabled=\"vm.searchText === \'\'\" ng-click=\"vm.submit(vm.selectedPerson);\">Continuar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/concept-criteria/views/concept-criteria.html","<div ui-view=\"concept-criteria\"></div>");
$templateCache.put("app/educational/concept-criteria/views/create-edit.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\"><form ng-cloak=\"\" ng-submit=\"vm.saveCriteria(vm.form)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.form.grade_code_rule.id === undefined\">Criar Critério de conceito</h2><h2 ng-if=\"vm.form.grade_code_rule.id !== undefined\">Atualizar Critério de conceito</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><a4-form-dic-data bind=\"vm.form\" on-submit=\"vm.saveCriteria(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/concept-criteria/form.json\"></a4-form-dic-data></div></md-dialog-content><md-dialog-actions><md-progress-linear ng-show=\"vm.show_loader\" md-mode=\"indeterminate\"></md-progress-linear></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/concept-criteria/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'CONCEPT_CRITERIA.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'CONCEPT_CRITERIA.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.filterConceptCriteriaList(vm.search)\" translate=\"\" translate-attr-placeholder=\"CONCEPT_CRITERIA.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-content><a4-form-dic-data bind=\"vm.grid\" on-submit=\"vm.submit(item, form)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editConceptCriteria(item)\" on-delete=\"vm.delete(index)\" fields-schema=\"app/educational/concept-criteria/grid.json\"></a4-form-dic-data></md-content></div>");
$templateCache.put("app/educational/coordinators/views/coordinators-grid.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-book-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Coordenadores de curso</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"Pesquisar coordenador\" type=\"text\" ng-model=\"vm.search\"></md-input-container></div></md-toolbar><md-card layout-padding=\"\"><md-card ng-if=\"vm.groupsWithoutCoordinator > 0\" align=\"left\" style=\"width: 98%; padding: 0; box-shadow: 0px 0px 0px 0px;\"><div flex=\"\" style=\"background-color: rgb(255, 99, 0); width: 100%; height: 60px; text-align: left; margin: 5px 5px 5px 5px\"><p style=\"vertical-align: baseline; margin-top: 17px;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 35px; margin-left: 5px;\"></i> <span flex=\"\" style=\"font-size: 16px; color: #fff; margin-left: 10px; margin-right: 5px; margin-bottom: 2px;\">{{vm.groupsWithoutCoordinator}} turmas não possuem coordenador.</span></p></div></md-card><md-card ng-if=\"vm.groupsWithoutCoordinator <= 0\" align=\"left\" style=\"width: 98%; padding: 0; box-shadow: 0px 0px 0px 0px;\"><div flex=\"\" style=\"background-color: rgb(3,169,244); width: 100%; height: 60px; text-align: left; margin: 5px 5px 5px 5px\"><p style=\"vertical-align: baseline; margin-top: 17px;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 35px; margin-left: 5px;\"></i> <span flex=\"\" style=\"font-size: 16px; color: #fff; margin-left: 10px; margin-right: 5px; margin-bottom: 2px;\">Todas as turmas possuem coordenador.</span></p></div></md-card><md-content layout=\"row\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-delete=\"vm.delete(item)\" on-click-item=\"vm.editCoordinator(item)\" on-click-actions=\"vm.clickActions(item, option)\" on-paginate=\"vm.paginate\" policies=\"{show: \'group_coord\', cud: \'group_coord\'}\" fields-schema=\"app/educational/coordinators/grid.json\"></a4-grid-dic-data></md-content></md-card></div>");
$templateCache.put("app/educational/coordinators/views/modal-create.html","<md-dialog aria-label=\"Create Coordinator\" md-theme=\"educational\" style=\"min-width: 550px; min-height: 450px\"><form ng-cloak=\"\" name=\"form\" ng-submit=\"vm.submit(form)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar coordenador</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\"><md-autocomplete flex=\"100\" required=\"\" md-no-cache=\"true\" md-selected-item=\"vm.selectedPerson\" md-search-text=\"searchText\" md-items=\"item in vm.getTeachersAndColaborators(searchText)\" md-item-text=\"item.string\" md-delay=\"500\" md-input-minlength=\"3\" md-min-length=\"0\" md-floating-label=\"Selecione um professor ou colaborador\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.string}}</span></md-item-template><md-not-found>Professor ou colaborador não encontrado.</md-not-found></md-autocomplete><h2 style=\"margin-left: 12px; padding-bottom: 10px;\"><md-icon md-font-icon=\"icon-book\" class=\"s24\"></md-icon>Cursos e turmas:</h2><treeview data=\"vm.coursesAndGroups\" response=\"vm.selectedCoursesAndGroups\" style=\"padding: 10px;\"></treeview></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"md-raised md-primary\" style=\"padding: 1px;\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/coordinators/views/modal-edit.html","<md-dialog aria-label=\"Create Coordinator\" md-theme=\"educational\" style=\"min-width: 550px; min-height: 450px\"><form ng-cloak=\"\" name=\"form\" ng-submit=\"vm.submit(form)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Editar coordenador</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\"><h2 style=\"margin-left: 12px; padding-bottom: 10px;\"><md-icon md-font-icon=\"icon-book\" class=\"s24\"></md-icon>Cursos e turmas:</h2><treeview data=\"vm.coursesAndGroups\" response=\"vm.selectedCoursesAndGroups\" style=\"padding: 10px;\"></treeview></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"md-raised md-primary\" style=\"padding: 1px\">Editar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/course/views/course-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start start\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.course.list\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><label class=\"new-resource\" ng-if=\"!vm.form.course.id\" ng-show=\"vm.form.course\"><md-icon>school</md-icon><strong>NOVO CURSO</strong></label><a4-search-field url=\"/course\" style=\"width: 100%\" on-change=\"vm.changeGroup(item)\" selected-item=\"vm.form.course\" placeholder=\"{{vm.form.course.name}}\" ng-if=\"vm.form.course.id\" icon=\"icon-school\"></a4-search-field></div><md-button ng-click=\"vm.delete(vm.form.course)\" ng-show=\"!vm.checkPolicies(\'curso_alt\') && (vm.selected_tab == 0 && !vm.form.course.block_delete && vm.form.course.id != undefined)\" class=\"md-icon-button btn-edit\" style=\"margin: 0 20px 0 20px;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COURSE.DELETE\"><md-tooltip md-direction=\"left\">{{vm.form.course.message_block_delete}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-click=\"vm.delete(vm.form.course)\" ng-show=\"!vm.checkPolicies(\'curso_alt\') && (vm.selected_tab == 0 && vm.form.course.block_delete && vm.form.course.id != undefined)\" class=\"md-icon-button btn-edit button-disable\" style=\"margin: 0 20px 0 20px;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COURSE.DELETE\"><md-tooltip md-direction=\"left\">{{vm.form.course.message_block_delete}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-click=\"vm.close()\" style=\"margin: 0\" class=\"md-icon-button btn-edit\" ng-show=\"!vm.checkPolicies(\'curso_alt\') && (vm.selected_tab == 0 && vm.form.course.id != undefined)\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COURSE.EDIT\"><md-tooltip><span ng-show=\"!vm.form.mode_edit\">Editar</span> <span ng-show=\"vm.form.mode_edit\">Cancelar Edição</span></md-tooltip><md-icon ng-show=\"!vm.form.mode_edit\" md-font-icon=\"icon-pencil\"></md-icon><md-icon ng-show=\"vm.form.mode_edit\" md-font-icon=\"icon-cancel\"></md-icon></md-button></div></md-toolbar><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important;\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Geral\"><md-card class=\"md-padding\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/course/form.json\"></a4-form-dic-data></md-card></md-tab><md-tab label=\"Grade Curricular\" md-on-select=\"vm.reload()\" ng-disabled=\"vm.checkPolicies(\'curso_conf\') || vm.form.course.id == undefined\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 1\"><div ui-view=\"matrix\"></div></md-card></md-tab><md-tab label=\"Turmas\" md-on-select=\"vm.reload()\" ng-disabled=\"vm.checkPolicies(\'curso_conf\') || vm.form.course.id == undefined\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 2\"><div ui-view=\"group\"></div></md-card></md-tab><md-tab label=\"Alunos\" md-on-select=\"vm.reload()\" ng-disabled=\"vm.checkPolicies(\'curso_conf\') || vm.form.course.id == undefined\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 3\"><div ui-view=\"students\"></div></md-card></md-tab><md-tab label=\"Documentos necessários\" ng-disabled=\"vm.checkPolicies(\'curso_conf\') ||vm.form.course.id == undefined\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 4\"><div ui-view=\"documents\"></div></md-card></md-tab><md-tab label=\"Material escolar\" ng-disabled=\"vm.checkPolicies(\'curso_conf\') ||vm.form.course.id == undefined\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 5\"></md-card></md-tab><md-tab label=\"Financeiro\" ng-disabled=\"vm.checkPolicies(\'curso_conf\') ||vm.form.course.id == undefined\" ng-init=\"vm.getFinanceCourseInfo()\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 6\"><form name=\"formfinancecourse\"><a4-product-group-config product-group=\"vm.course_finance\" current-form=\"formfinancecourse\" companies=\"vm.companies\" categories=\"vm.bill_categories\"></a4-product-group-config><div layout=\"row\" layout-align=\"end end\"><md-button class=\"md-primary md-raised\" ng-disabled=\"formfinancecourse.$invalid || $rootScope.show_loader\" ng-click=\"vm.saveFinanceCourseInfo()\"><md-icon md-font-icon=\"icon-check\"></md-icon>Salvar</md-button></div></form></md-card></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/course/views/course.html","<div ui-view=\"course\"></div>");
$templateCache.put("app/educational/course/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-school\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'COURSE.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'COURSE.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-change=\"vm.filterCourseList(vm.search)\" translate=\"\" translate-attr-placeholder=\"COURSE.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-card class=\"md-padding\"><md-content><md-checkbox ng-model=\"vm.only_active\" ng-change=\"vm.getAllCourse(1, 20)\">Mostrar cursos inativos</md-checkbox><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.grid.current_page\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.getAllCourse\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container class=\"table-float-button\"><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Apelido</th><th md-column=\"\">Nome</th><th md-column=\"\">Grupo de cursos</th><th md-column=\"\">Turmas</th><th md-column=\"\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" style=\"cursor: pointer\" ng-repeat=\"item in vm.grid.data\" ng-click=\"vm.editCourse(item)\"><td md-cell=\"\">{{ item.alias }}</td><td md-cell=\"\">{{ item.name }}</td><td md-cell=\"\">{{ item.group_course_name }}</td><td md-cell=\"\">{{ item.groups }}</td><td md-cell=\"\" style=\"text-align: right\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event);$event.stopPropagation()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.clickActions(item, \'duplicate\')\"><md-icon>content_copy</md-icon>Duplicar</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-content></md-card></div>");
$templateCache.put("app/educational/course-group/views/course-group.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-book-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'COURSE_GROUP.TITLE\' | translate }}</span></div></div></md-toolbar><md-card layout-padding=\"\"><md-content layout=\"row\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editCourse(item)\" on-delete=\"vm.deleteCourse(index)\" policies=\"{show:\'curso\', cud:\'curso_alt\'}\" fields-schema=\"app/educational/course-group/grid.json\"></a4-grid-dic-data></md-content></md-card></div>");
$templateCache.put("app/educational/documents/views/create-edit.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.documents.list\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-message-text\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" ng-if=\"!vm.form.document.id\">{{ \'DOCUMENTS.CREATE_NEW_FOR\' | translate }} {{vm.profile}}</span> <span class=\"logo-text\" ng-if=\"vm.form.document.id\">{{ \'DOCUMENTS.EDIT\' | translate }} {{vm.profile}}</span></div></div><md-checkbox ng-change=\"$root.$broadcast(\'CHANGE_IS_DETAILED\', vm.is_detailed)\" ng-model=\"vm.is_wysiwyg\" aria-label=\"Editor avançado\">Mostrar editor avançado</md-checkbox></md-toolbar><md-content style=\"background-color: whitesmoke !important;width: 80%; margin: 5px auto\"><md-card class=\"md-padding\" style=\"min-height: 500px;\"><form name=\"formInformativeReport\" ng-submit=\"vm.submit(formInformativeReport, vm.form.document)\" novalidate=\"\"><div layout=\"row\" ng-if=\"!vm.is_wysiwyg\"><div flex=\"60\"><strong class=\"group-field\"><small>Editor de conteúdo:</small></strong><div layout=\"row\" style=\"margin-top: 15px\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"title\" ng-model=\"vm.form.document.title\" placeholder=\"Título\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" ng-disabled=\"vm.form.document.type === \'4\'\"><textarea name=\"content\" placeholder=\"Conteúdo\" ng-model=\"vm.form.document.content\" rows=\"6\" ng-disabled=\"vm.form.document.type === \'4\'\"></textarea></md-input-container></div></div></div><md-card-content layout=\"column\" ng-if=\"vm.is_wysiwyg\" flex=\"\"><div flex=\"\"><div layout=\"row\"><md-input-container flex=\"\" style=\"margin-top: 25px\" class=\"md-input-has-placeholder\" ng-disabled=\"vm.form.document.type === \'4\'\"><input type=\"text\" name=\"title\" ng-model=\"vm.form.document.title\" placeholder=\"Título\"></md-input-container></div><textarea class=\"text_area\" name=\"html_editor\" ui-tinymce=\"vm.tinymceOptions\" id=\"textarea_html\" ng-model=\"vm.form.document.content\" ng-change=\"vm.changeHandler()\" ng-click=\"vm.setVariable()\"></textarea><div flex=\"\"><div layout=\"row\" layout-align=\"space-between center\"><div><label>Recursos disponíveis:</label><md-input-container flex=\"100\"><md-select name=\"variables\" ng-model=\"variableSelected\" ng-change=\"vm.setVariable(variableSelected, formInformativeReport)\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchVariable\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"item\" ng-repeat=\"item in vm.variables | filter: searchVariable\">{{item.presentation}}</md-option></md-select></md-input-container></div><div><md-input-container><md-checkbox ng-model=\"vm.form.document.print_logo\">Imprime com a logomarca</md-checkbox></md-input-container></div></div></div></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-primary\">Salvar</md-button></md-card-actions></form></md-card></md-content></div>");
$templateCache.put("app/educational/documents/views/document-options.html","<md-dialog md-theme=\"educational\" aria-label=\"{{ \'UPLOAD_IMAGE.EDIT\' | translate }}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar marca d\'agua nos documentos</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content><div class=\"attachment\" ng-if=\"vm.card.id !== null\"><div class=\"attachment-content\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"start start\"></div><span flex=\"\"></span><div ng-if=\"vm.water_mark != null\"><table md-table=\"\"><tr md-row=\"\"><td md-cell=\"\" colspan=\"3\">Marca d\'agua já adicionada</td><td md-cell=\"\"><md-button class=\"md-secondary\" ng-click=\"vm.openUrl();\"><md-icon>visibility</md-icon><md-tooltip md-direction=\"top\">Visualizar</md-tooltip></md-button></td><td md-cell=\"\"><md-button class=\"md-secondary\" ng-click=\"vm.deleteWaterMark(item.file_reference, item.extension);\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"top\">Excluir</md-tooltip></md-button></td></tr></table></div></div></div><div flex=\"\" ng-if=\"vm.water_mark == null\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></md-content></md-dialog>");
$templateCache.put("app/educational/documents/views/documents.html","<div ui-view=\"documents\"></div>");
$templateCache.put("app/educational/documents/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-message-text\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'DOCUMENTS.TITLE\' | translate }}</span></div></div><md-button ng-click=\"vm.openModalEdit()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\">Configurações de documentos</md-tooltip></md-button></md-toolbar><md-content style=\"background-color: whitesmoke !important\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Todos\" md-on-select=\"vm.reload()\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 0\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-click-actions=\"vm.clickActions(item, option)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editDocument(item)\" on-delete=\"vm.delete(index)\" fields-schema=\"app/educational/documents/grid.json\"></a4-grid-dic-data></md-card></md-tab><md-tab label=\"Alunos\" md-on-select=\"vm.reload()\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 1\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-click-actions=\"vm.clickActions(item, option)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editDocument(item)\" on-delete=\"vm.delete(index)\" fields-schema=\"app/educational/documents/grid.json\"></a4-grid-dic-data></md-card></md-tab><md-tab label=\"Responsáveis\" md-on-select=\"vm.reload()\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 2\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-click-actions=\"vm.clickActions(item, option)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editDocument(item)\" on-delete=\"vm.delete(item)\" fields-schema=\"app/educational/documents/grid.json\"></a4-grid-dic-data></md-card></md-tab><md-tab label=\"Professores\" md-on-select=\"vm.reload()\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 3\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-click-actions=\"vm.clickActions(item, option)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editDocument(item)\" on-delete=\"vm.delete(index)\" fields-schema=\"app/educational/documents/grid.json\"></a4-grid-dic-data></md-card></md-tab><md-tab label=\"Colaboradores\" md-on-select=\"vm.reload()\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 4\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-click-actions=\"vm.clickActions(item, option)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editDocument(item)\" on-delete=\"vm.delete(index)\" fields-schema=\"app/educational/documents/grid.json\"></a4-grid-dic-data></md-card></md-tab><md-tab label=\"Contratos\" md-on-select=\"vm.reload()\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab == 5\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-click-actions=\"vm.clickActions(item, option)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editDocument(item)\" on-delete=\"vm.delete(item)\" fields-schema=\"app/educational/documents/grid.json\"></a4-grid-dic-data></md-card></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/documents/views/modal-send-activation.html","<md-dialog aria-label=\"Create Coordinator\" md-theme=\"educational\" style=\"min-width: 325px; min-height: 200px\"><form ng-cloak=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Enviar mensagem</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 10px; margin-top: 15px;\" layout=\"column\"><div layout=\"row\" layout-gt-sm=\"row\" flex=\"\"><fieldset class=\"standard without-legend group-field\"><md-radio-group ng-model=\"vm.filter.selected_option\" ng-required=\"vm.selected_tab == 0\"><md-radio-button value=\"99\">Todos</md-radio-button><md-radio-button value=\"98\">Individual</md-radio-button></md-radio-group></fieldset></div><div layout=\"row\" layout-gt-sm=\"row\" flex=\"\" ng-if=\"vm.filter.selected_option === \'98\'\"><md-autocomplete flex=\"100\" md-no-cache=\"true\" md-selected-item=\"vm.filter.selectedPerson\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPersons(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-input-minlength=\"3\" md-min-length=\"0\" md-floating-label=\"Selecione uma pessoa\" style=\"margin-top: 10px; margin-left: 8px; margin-right: 8px;\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Pessoa não encontrada.</md-not-found></md-autocomplete></div><md-card layout=\"row\" class=\"md-padding\" ng-if=\"vm.print_msg\" style=\"background-color: whitesmoke; padding: 0;\"><div style=\"background-color: rgb(3,169,244); width: 100%; height: auto;text-align: center;\"><p><div style=\"font-size: 18px; color: #fff;padding: 10px;\">{{vm.waiting_msg}}</div></p></div></md-card><div ng-if=\"vm.show_receivers\"><h3>Total de destinatários: {{vm.receivers_info.persons_total}}</h3><h3>Destinatários com e-mail: {{vm.receivers_info.persons_with_email}}</h3><h3>Destinatários sem e-mail: {{vm.receivers_info.persons_without_email}}</h3><h3>Destinatários que já receberam o e-mail: {{vm.receivers_info.persons_email_sent}}</h3></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" ng-click=\"vm.submit(form, vm.filter, \'send\')\" ng-disabled=\"form.$invalid || vm.show_circular_loader\" class=\"md-raised md-primary\" ng-if=\"!vm.checkPolicies(\'email_educ_msgs\')\"><div layout=\"row\"><md-progress-circular flex=\"15\" ng-if=\"vm.show_circular_loader\" style=\"margin-top: 13px;margin-left: 6px;\" md-mode=\"indeterminate\" md-diameter=\"10\"></md-progress-circular><span flex=\"\" ng-if=\"!vm.show_receivers && vm.selected_profile !== 4\">Preparar envio</span> <span flex=\"\" ng-if=\"vm.show_receivers || vm.selected_profile === 4\">Enviar</span></div></md-button><md-button type=\"submit\" ng-click=\"vm.submit(form, vm.filter, \'print\')\" ng-disabled=\"form.$invalid || vm.show_circular_loader\" class=\"md-raised md-primary\"><div layout=\"row\"><md-progress-circular flex=\"15\" ng-if=\"vm.show_circular_loader\" style=\"margin-top: 13px;margin-left: 6px;\" md-mode=\"indeterminate\" md-diameter=\"10\"></md-progress-circular><span flex=\"\">Imprimir</span></div></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/documents/views/modal-send-collaborators.html","<md-dialog aria-label=\"Create Coordinator\" md-theme=\"educational\" style=\"min-width: 325px; min-height: 200px\"><form ng-cloak=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Enviar mensagem</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 10px; margin-top: 15px;\" layout=\"column\"><div layout=\"row\" layout-gt-sm=\"row\" flex=\"\"><fieldset class=\"standard without-legend group-field\"><md-radio-group ng-model=\"vm.filter.selected_option\" ng-required=\"vm.selected_tab == 0\"><md-radio-button value=\"4\">Todos</md-radio-button><md-radio-button value=\"5\">Individual</md-radio-button></md-radio-group></fieldset></div><div layout=\"row\" layout-gt-sm=\"row\" flex=\"\" ng-if=\"vm.filter.selected_option === \'5\'\"><md-autocomplete flex=\"100\" md-no-cache=\"true\" md-selected-item=\"vm.filter.selectedPerson\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPersons(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-input-minlength=\"3\" md-min-length=\"0\" md-floating-label=\"Selecione uma pessoa\" style=\"margin-top: 10px; margin-left: 8px; margin-right: 8px;\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Pessoa não encontrada.</md-not-found></md-autocomplete></div><md-card layout=\"row\" class=\"md-padding\" ng-if=\"vm.print_msg\" style=\"background-color: whitesmoke; padding: 0;\"><div style=\"background-color: rgb(3,169,244); width: 100%; height: auto;text-align: center;\"><p><div style=\"font-size: 18px; color: #fff;padding: 10px\">{{vm.waiting_msg}}</div></p></div></md-card></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_circular_loader\">Cancelar</md-button><md-button type=\"submit\" ng-click=\"vm.submit(form, vm.filter, \'send\')\" ng-disabled=\"vm.show_circular_loader\" class=\"md-raised md-primary\" ng-if=\"!vm.checkPolicies(\'email_educ_msgs\')\"><div layout=\"row\"><md-progress-circular flex=\"15\" ng-if=\"vm.show_circular_loader\" style=\"margin-top: 13px;margin-left: 6px;\" md-mode=\"indeterminate\" md-diameter=\"10\"></md-progress-circular><span flex=\"\">Enviar</span></div></md-button><md-button type=\"submit\" ng-click=\"vm.submit(form, vm.filter, \'print\')\" ng-disabled=\"vm.show_circular_loader\" class=\"md-raised md-primary\"><md-progress-circular flex=\"15\" ng-if=\"vm.show_circular_loader\" style=\"margin-top: 13px;margin-left: 6px;\" md-mode=\"indeterminate\" md-diameter=\"10\"></md-progress-circular><span flex=\"\">Imprimir</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/documents/views/modal-send.html","<md-dialog aria-label=\"Criar documentos\" md-theme=\"educational\" style=\"min-width: 550px;\"><form ng-cloak=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Enviar mensagem</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 10px\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Grupo\"><div class=\"md-padding\"><div ng-if=\"vm.selected_profile == 1 || vm.selected_profile == 2 || vm.selected_profile == 5\"><div ng-if=\"vm.selected_profile == 1\"><strong class=\"group-field\"><span>Alunos com:</span></strong><md-radio-group ng-model=\"vm.filter.selected_option\" ng-required=\"vm.selected_tab == 0\" ng-change=\"vm.setShowReceiversToFalse()\"><md-radio-button value=\"0\">Matrícula ativa e confirmada</md-radio-button><md-radio-button value=\"1\">Matrícula ativa ainda NÃO confirmada</md-radio-button><md-radio-button value=\"2\">Matrícula ativa confirmada ou não</md-radio-button><md-radio-button value=\"3\">Não rematriculados</md-radio-button><md-radio-button value=\"6\">Selecionar status de matrícula</md-radio-button></md-radio-group><md-input-container ng-if=\"vm.filter.selected_option == 6\" style=\"width: 100%;\"><label>Status de matrícula</label><md-select ng-model=\"vm.filter.selected_enrolment_status\" multiple=\"\"><md-option ng-repeat=\"enrolment_status in vm.enrolment_status\" ng-value=\"enrolment_status.id\">{{enrolment_status.name}}</md-option></md-select></md-input-container></div><div ng-if=\"vm.selected_profile == 2\"><div layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.filter.is_financial_resp\" ng-change=\"vm.setShowReceiversToFalse()\">Responsável financeiro</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.filter.is_pedagogic_resp\" ng-change=\"vm.setShowReceiversToFalse()\">Responsável pedagógico</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.filter.is_father\" ng-change=\"vm.setShowReceiversToFalse()\">Pai</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.filter.is_mother\" ng-change=\"vm.setShowReceiversToFalse()\">Mãe</md-checkbox></md-input-container></div><strong class=\"group-field\"><span>Que possuem dependentes:</span></strong><md-radio-group ng-model=\"vm.filter.selected_option\" layout=\"column\" ng-change=\"vm.setShowReceiversToFalse()\"><md-radio-button value=\"1\">Com matrícula ativa</md-radio-button><md-radio-button value=\"2\">Com matrícula não confirmada</md-radio-button><md-radio-button value=\"3\">Com matrícula cancelada</md-radio-button><md-radio-button value=\"4\">Pré-Matrícula</md-radio-button></md-radio-group><strong class=\"group-field\"><span>Aluno possui contrato financeiro:</span></strong><md-radio-group ng-model=\"vm.filter.student_financial_option\" ng-change=\"vm.setShowReceiversToFalse()\"><md-radio-button value=\"0\">Todos</md-radio-button><md-radio-button value=\"1\">Ativo</md-radio-button><md-radio-button value=\"2\">Inadimplente</md-radio-button><md-radio-button value=\"3\">Inadimplente em serviço principal</md-radio-button><md-radio-button value=\"4\">Inadimplente em serviço extra</md-radio-button></md-radio-group></div><div ng-if=\"vm.selected_profile == 5\"><md-radio-group ng-model=\"vm.use_services\"><md-radio-button ng-value=\"false\" ng-click=\"vm.filter.selected_product = null\">Matrícula</md-radio-button><md-radio-button ng-value=\"true\">Outros serviços</md-radio-button></md-radio-group></div><div ng-if=\"vm.selected_profile == 5 && vm.use_services\"></div><strong class=\"group-field\"><span ng-if=\"!vm.use_services\">Pertencentes às turmas:</span> <span ng-if=\"vm.use_services\">Pertencente ao serviço:</span></strong><treeview ng-if=\"!vm.use_services\" data=\"vm.coursesAndGroups\" response=\"vm.filter.selectedCoursesAndGroups\"></treeview><md-radio-group ng-if=\"vm.use_services\" ng-repeat=\"service in vm.services\" ng-model=\"vm.filter.selected_product\"><md-radio-button ng-value=\"service.id\">{{service.name}}</md-radio-button></md-radio-group><md-input-container><md-checkbox ng-if=\"vm.selected_profile !== 5\" ng-model=\"vm.filter.only_without_signed_contract\">Apenas alunos que não assinaram o contrato de matrícula</md-checkbox></md-input-container></div><div ng-if=\"vm.selected_profile == 3\">A mensagem será enviada para todos os professores ativos.</div><div ng-if=\"vm.selected_profile == 4\"><strong class=\"group-field\"><span>Filtro para colaboradores:</span></strong><md-radio-group ng-model=\"vm.filter.selected_option\" layout=\"column\" ng-change=\"vm.setShowReceiversToFalse()\"><md-radio-button value=\"0\">Todos</md-radio-button><md-radio-button value=\"1\">Ativos</md-radio-button><md-radio-button value=\"2\">Inativos</md-radio-button></md-radio-group></div><div ng-if=\"vm.show_receivers\"><h3>Total de destinatários: {{vm.receivers_info.persons_total}}</h3><h3>Destinatários com e-mail: {{vm.receivers_info.persons_with_email}}</h3><h3>Destinatários sem e-mail: {{vm.receivers_info.persons_without_email}}</h3><h3>Destinatários que já receberam o e-mail: {{vm.receivers_info.persons_email_sent}}</h3></div></div></md-tab><md-tab label=\"Individual\" class=\"md-padding\"><md-dialog-content layout=\"column\"><md-autocomplete flex=\"100\" ng-required=\"vm.selected_tab == 1\" style=\"margin-top: 20px; margin-left: 8px; margin-right: 8px;\" md-no-cache=\"true\" md-selected-item=\"vm.filter.selectedPerson\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPersons(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-input-minlength=\"3\" md-min-length=\"0\" md-selected-item-change=\"vm.onPersonSelected(item)\" md-floating-label=\"Selecione uma pessoa\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Pessoa não encontrada</md-not-found></md-autocomplete></md-dialog-content></md-tab></md-tabs><md-input-container ng-if=\"vm.selected_profile !== 5\" layout=\"column\"><md-checkbox style=\"background-color: whitesmoke; padding: 4px; margin-bottom: 3px;margin-left: 0; margin-right: 0;\" ng-model=\"vm.print_landscape\" layout=\"row\">Modo paisagem (apenas impressão)</md-checkbox><md-checkbox style=\"background-color: whitesmoke; padding: 4px; margin-bottom: 3px;\" ng-model=\"vm.without_margin\" layout=\"row\">Sem margens (apenas impressão)</md-checkbox><md-checkbox style=\"background-color: whitesmoke; padding: 4px; margin-bottom: 3px;\" ng-model=\"vm.use_watermark\" layout=\"row\">Utiliza marca d\'agua cadastrada</md-checkbox></md-input-container><md-input-container ng-if=\"vm.was_logo_position_selected && vm.selected_profile !== 5\" layout=\"column\"><span style=\"background-color: whitesmoke; padding: 4px; margin-bottom: 3px;\">Posição da logo na impressão:</span><md-radio-group ng-model=\"vm.position_logo\" layout=\"row\"><md-radio-button ng-value=\"\'left\'\">Esquerda</md-radio-button><md-radio-button ng-value=\"\'center\'\">Centralizada</md-radio-button><md-radio-button ng-value=\"\'right\'\">Direita</md-radio-button></md-radio-group></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_circular_loader\">Cancelar</md-button><span ng-if=\"vm.selected_tab !== 1\"><md-button type=\"submit\" ng-click=\"vm.printReceivers(vm.filter)\" ng-disabled=\"form.$invalid || vm.show_circular_loader || (vm.selected_profile === 2 && vm.selected_tab !== 1 && (vm.filter.is_mother === false && vm.filter.is_father === false && vm.filter.is_financial_resp === false && vm.filter.is_pedagogic_resp === false))\" class=\"md-raised md-primary\" ng-if=\"!vm.checkPolicies(\'email_educ_msgs\')\">Imprimir lista de destinatários</md-button><md-button ng-if=\"vm.show_receivers\" type=\"submit\" ng-click=\"vm.submit(form, vm.filter, \'send\', \'send_all\')\" ng-disabled=\"form.$invalid || vm.show_circular_loader || (vm.selected_profile === 2 && vm.selected_tab !== 1 && (vm.filter.is_mother === false && vm.filter.is_father === false && vm.filter.is_financial_resp === false && vm.filter.is_pedagogic_resp === false))\" class=\"md-raised\"><span>Enviar e-mails para todos</span></md-button><md-button type=\"submit\" ng-click=\"vm.submit(form, vm.filter, \'send\', \'send_not_sent\')\" ng-disabled=\"form.$invalid || vm.show_circular_loader || (vm.selected_profile === 2 && vm.selected_tab !== 1 && (vm.filter.is_mother === false && vm.filter.is_father === false && vm.filter.is_financial_resp === false && vm.filter.is_pedagogic_resp === false))\" class=\"md-raised md-primary\" ng-if=\"!vm.checkPolicies(\'email_educ_msgs\')\"><span ng-if=\"!vm.show_receivers\">Preparar envio</span> <span ng-if=\"vm.show_receivers\">Enviar e-mails para os que não receberam</span></md-button></span> <span ng-if=\"vm.selected_tab === 1\"><md-button type=\"submit\" class=\"md-raised md-primary\" ng-if=\"!vm.checkPolicies(\'email_educ_msgs\')\" ng-disabled=\"form.$invalid || vm.show_circular_loader || (vm.selected_profile === 2 && vm.selected_tab !== 1 && (vm.filter.is_mother === false && vm.filter.is_father === false && vm.filter.is_financial_resp === false && vm.filter.is_pedagogic_resp === false)) || (vm.selected_tab == 1 && (vm.filter.selectedPerson == null || vm.filter.selectedPerson.id == null || angular.isUndefined(vm.filter.selectedPerson.id)))\" ng-click=\"vm.submit(form, vm.filter, \'send\', \'send_all\')\"><span>Enviar</span></md-button></span><md-button type=\"submit\" ng-click=\"vm.submit(form, vm.filter, \'print\')\" ng-disabled=\"form.$invalid || vm.show_circular_loader || (vm.selected_profile === 2 && vm.selected_tab !== 1 && (vm.filter.is_mother === false && vm.filter.is_father === false && vm.filter.is_financial_resp === false && vm.filter.is_pedagogic_resp === false)) || (vm.selected_tab == 1 && (vm.filter.selectedPerson == null || vm.filter.selectedPerson.id == null || angular.isUndefined(vm.filter.selectedPerson.id)))\" class=\"md-raised md-primary\">Imprimir</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/enrolment/views/enrolment-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" ng-if=\"enrolment.form.pre_enrolment == \'0\'\">Assistente de matrícula</span> <span class=\"logo-text\" ng-if=\"enrolment.form.pre_enrolment == \'1\'\">Assistente de pré-matrícula</span></div></div></md-toolbar><md-card layout-padding=\"\" class=\"with-btn-add\"><md-steppers md-busy-text=\"\'Aguarde...\'\" md-busy=\"enrolment.showBusyText\" md-dynamic-height=\"\" md-stretch-steppers=\"always\" md-selected=\"enrolment.stepSelected\"><md-step label=\"Aluno\" md-complete=\"enrolment.steps.inicio.completed\" ng-disabled=\"enrolment.steps.inicio.disabled\"><div ui-view=\"init\" ng-if=\"enrolment.stepSelected == 0\"></div></md-step><md-step label=\"Curso\" md-complete=\"enrolment.steps.course.completed\" ng-disabled=\"enrolment.steps.course.disabled\"><div ui-view=\"course\" ng-if=\"enrolment.stepSelected == 1\"></div></md-step><md-step label=\"Dados Pessoais\" md-complete=\"enrolment.steps.students.completed\" ng-disabled=\"enrolment.steps.students.disabled\"><div ui-view=\"student\" ng-if=\"enrolment.stepSelected == 2\"></div></md-step><md-step label=\"Disciplinas\" md-complete=\"enrolment.steps.subject.completed\" ng-disabled=\"enrolment.steps.subject.disabled\"><div ui-view=\"subject\" ng-if=\"enrolment.stepSelected == 3\"></div></md-step><md-step label=\"Documentos\" md-complete=\"enrolment.steps.documents.completed\" ng-disabled=\"enrolment.steps.documents.disabled\"><div ui-view=\"documents\" ng-if=\"enrolment.stepSelected == 4\"></div></md-step><md-step label=\"Dados Médicos\" md-complete=\"enrolment.steps.medical_data.completed\" ng-disabled=\"enrolment.steps.medical_data.disabled\"><div ui-view=\"medical_data\" ng-if=\"enrolment.stepSelected == 5\"></div></md-step><md-step label=\"Responsáveis\" md-complete=\"enrolment.steps.responsibles.completed\" ng-disabled=\"enrolment.steps.responsibles.disabled\"><div ui-view=\"responsibles\" ng-if=\"enrolment.stepSelected == 6\"></div></md-step><md-step label=\"Endereço\" md-complete=\"enrolment.steps.address.completed\" ng-disabled=\"enrolment.steps.address.disabled\"><div ui-view=\"address\" ng-if=\"enrolment.stepSelected == 7\"></div></md-step><md-step label=\"Conclusão\" md-complete=\"enrolment.steps.end.completed\" ng-disabled=\"enrolment.steps.end.disabled\"><div ui-view=\"end\" ng-if=\"enrolment.stepSelected == 8\"></div></md-step></md-steppers></md-card></div>");
$templateCache.put("app/educational/enrolment/views/enrolment-wizard.html","<md-dialog aria-label=\"Create Subject\" style=\"max-width: 1500px;width: 1500px;\" md-theme=\"educational\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Assistente de Matricula</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close(vm.form)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" fields=\"vm.fields\" step-selected=\"vm.stepSelected\" on-submit=\"vm.submit(item, form, wizardItem)\" on-close=\"vm.close()\" on-finish-wizard=\"vm.finish(form)\" fields-schema=\"app/educational/enrolment/form-wizard.json\"></a4-form-dic-data></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/enrolment/views/enrolment.html","<div ui-view=\"enrolment\"></div>");
$templateCache.put("app/educational/evaluation-criteria/views/alertLoading.html","<md-dialog aria-label=\"Consultando SEFAZ\" md-theme=\"finance\" style=\"width: 500px; max-width: 500px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color: #fff;\">Recalculando notas dos alunos...</h2></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><h2>Aguarde a finalização do processo de recálculo</h2></div><md-progress-linear md-mode=\"query\"></md-progress-linear></md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/evaluation-criteria/views/evaluation-criteria-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.evaluation-criteria.list\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><a4-search-field url=\"/evaluation\" style=\"width: 100%\" on-change=\"vm.changeEvaluationCriteria(item)\" selected-item=\"vm.selected\" icon=\"icon-account-multiple\" placeholder=\"{{vm.form.grade_rule.name}}\"></a4-search-field></div><md-button ng-click=\"vm.deleteEvaluationCriteria(vm.selected.id)\" ng-show=\"vm.selected_tab == 0 && !vm.selected.block_delete && vm.selected.id\" class=\"md-icon-button btn-edit\" aria-label=\"delete\"><md-tooltip md-direction=\"bottom\">Remover</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-toolbar><md-content class=\"btn-material-default\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Definições inicias\" md-on-select=\"vm.reload()\"><md-content class=\"md-padding\" style=\"background-color: whitesmoke !important;\"><div layout=\"row\" align=\"start center\"><form name=\"gradeRuleForm\" class=\"evaluation-criteria\" ng-submit=\"vm.submitGradeRule(vm.form.grade_rule, gradeRuleForm)\"><div layout=\"row\"><div flex=\"\"><br><strong class=\"group-field\"><small>Definições iniciais</small></strong><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Nome</label> <input ng-model=\"vm.form.grade_rule.name\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><label>Nota média</label> <input ng-model=\"vm.form.grade_rule.pass_grade\"></md-input-container><md-input-container flex=\"\"><label>Nota máxima</label> <input ng-model=\"vm.form.grade_rule.max_grade\"></md-input-container><md-input-container flex=\"\"><label>Decimais</label> <input ng-model=\"vm.form.grade_rule.precision\"></md-input-container><md-input-container><label>Tipo de arredondamento</label><md-select ng-model=\"vm.form.grade_rule.grade_round_rule_id\"><md-option ng-value=\"null\"><em>Nenhum</em></md-option><md-option ng-repeat=\"round_rule in vm.list.grade_round_rule_item\" ng-value=\"round_rule.id\">{{round_rule.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"40\"><label>Qtd limite de recuperações</label> <input ng-model=\"vm.form.grade_rule.max_credit_recovery\" maxlength=\"2\"></md-input-container></div><div layout=\"row\"><md-switch ng-model=\"vm.form.grade_rule.is_horizontal_print\" aria-label=\"Impressão\" flex=\"\">Imprime boletim na horizontal.</md-switch></div></div><div flex=\"\"><br><strong class=\"group-field\"><small>Sistema de dependência / Progressão Parcial</small></strong><div layout=\"row\"><md-radio-group ng-model=\"vm.form.grade_rule.dependency_system\" ng-init=\"vm.form.grade_rule.dependency_system = 1\"><md-radio-button value=\"1\" class=\"md-primary\">Não utiliza</md-radio-button><md-radio-button value=\"2\">Dependência</md-radio-button><md-radio-button value=\"3\">Progressão Parcial</md-radio-button></md-radio-group><md-input-container class=\"md-block\" ng-show=\"vm.form.grade_rule.dependency_system == 3\" flex=\"\"><label>Qtd máxima permitida</label> <input ng-model=\"vm.form.grade_rule.max_dependency_allowed\" maxlength=\"2\" pattern=\"\\d*\"></md-input-container></div><div layout=\"row\"><md-switch ng-model=\"vm.form.grade_rule.is_horizontal_sub_calc\" aria-label=\"Conselho\" flex=\"\">Calcula subdisciplinas na horizontal.</md-switch></div></div><div flex=\"\"><br><strong class=\"group-field\"><small>Lançamento de faltas</small></strong><div layout=\"row\"><md-radio-group ng-model=\"vm.form.grade_rule.attendance_type\" ng-init=\"vm.form.grade_rule.attendance_type = \'D\'\"><md-radio-button value=\"D\" class=\"md-primary\">Diário</md-radio-button><md-radio-button value=\"E\">Etapa</md-radio-button><md-radio-button value=\"U\">Unidade</md-radio-button></md-radio-group></div><br><br><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\"><md-icon ng-show=\"!$root.show_loader\">close</md-icon>Cancelar</md-button><md-button type=\"submit\" class=\"md-raised submit-button\" ng-disabled=\"gradeRuleForm.$invalid || gradeRuleForm.$pristine || $root.show_loader\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\">check</md-icon>Salvar</md-button></div></div></div></form></div></md-content></md-tab><md-tab label=\"Configurações dos critérios\" ng-disabled=\"!vm.form.grade_rule.id\"><md-content class=\"md-padding\" style=\"background-color: whitesmoke !important;\"><div layout=\"row\" align=\"start center\"><md-card flex=\"50\"><div class=\"limit-height md-padding\"><a4-ui-tree list=\"vm.list.grade_rule_items\" template=\"nodes_renderer\" actions=\"true\" actions-group=\"true\" action-add=\"vm.add(item)\" action-delete=\"vm.delete(item)\" action-select=\"vm.selectItem(item)\" insert-nodes=\"true\" drag-enable=\"true\" only-children=\"false\" have-sub-nodes=\"false\" nodrop-enable=\"false\" max-nodes=\"2\" ng-show=\"vm.list.grade_rule_items.length\"></a4-ui-tree></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" ng-click=\"vm.addStep(vm.list.grade_rule_items)\"><md-icon>playlist_add</md-icon>Adicionar etapa de critério</md-button></div></md-card><form name=\"evaluationCriteriaForm\" class=\"evaluation-criteria\" ng-submit=\"vm.submitGradeRuleItems(vm.list.grade_rule_items, evaluationCriteriaForm, $saved_by_grouping)\" ng-show=\"vm.list.grade_rule_items.length\" flex=\"50\"><div layout=\"column\"><md-list-item class=\"config\" ng-show=\"(vm.selected.nodes !== undefined && vm.selected.nodes.length == 0) || vm.selected.nodes === undefined\" ng-init=\"vm.toggle = false;\" ng-click=\"vm.toggle = !vm.toggle\"><span flex=\"95\">Configurações</span> <span flex=\"5\"><md-icon ng-show=\"!vm.toggle\">expand_more</md-icon><md-icon ng-show=\"vm.toggle\">expand_less</md-icon></span></md-list-item><div class=\"section-group\" style=\"padding: 0px;\" ng-show=\"((vm.selected.nodes !== undefined && vm.selected.nodes.length == 0) || vm.selected.nodes === undefined)\"><div ng-show=\"vm.toggle\" style=\"padding: 10px;\"><strong class=\"group-field\"><small>Configurações da regra</small></strong><md-switch ng-model=\"vm.selected.has_attendance\" aria-label=\"Frequência\">Possui controle de frequência.</md-switch><div layout=\"row\"><md-switch ng-model=\"vm.selected.show_on_grade\" ng-change=\"vm.selected.show_in_grafic = (vm.selected.show_on_grade) ? vm.selected.show_in_grafic : false\" aria-label=\"Boletim\" flex=\"\">Apresenta no boletim.</md-switch><md-input-container class=\"show-hide top-10\" ng-show=\"vm.selected.show_on_grade\" flex=\"\"><label>Título da coluna</label> <input ng-model=\"vm.selected.label\"></md-input-container></div><div layout=\"row\"><md-switch ng-model=\"vm.selected.show_on_school_records\" aria-label=\"Boletim\" flex=\"\">Apresenta no histórico.</md-switch></div><div layout=\"row\"><md-switch ng-model=\"vm.selected.show_on_chart\" aria-label=\"Boletim\" flex=\"\">Apresenta no gráfico do boletim.</md-switch></div><div layout=\"row\"><md-switch ng-model=\"vm.selected.is_final_step_event\" aria-label=\"Boletim\" flex=\"\">Evento final da etapa.</md-switch></div><br><strong class=\"group-field\"><small>Definições do critério</small></strong><div layout=\"column\"><md-input-container class=\"md-block\"><label>Critério de conceito</label><md-select ng-model=\"vm.selected.grade_code_rule_id\"><md-option ng-value=\"null\"><em>Nenhum</em></md-option><md-option ng-repeat=\"code_rule in vm.list.grade_code_rule_item\" ng-value=\"code_rule.id\">{{code_rule.name}}</md-option></md-select></md-input-container><md-switch ng-disabled=\"true\" aria-label=\"Conselho\" class=\"md-block\">Aplicável mesmo se a disciplina não for de conceito</md-switch></div></div></div><br><div><strong class=\"group-field\"><small ng-show=\"!((vm.selected.nodes !== undefined && vm.selected.nodes.length == 0) || vm.selected.nodes === undefined)\">Definições do agrupamento</small> <small ng-show=\"(vm.selected.nodes !== undefined && vm.selected.nodes.length == 0) || vm.selected.nodes === undefined\">Definições da regra</small></strong><div layout=\"row\"><md-input-container flex=\"15\"><label>Código</label> <input ng-model=\"vm.selected.name\" maxlength=\"10\" ng-keydown=\"$event.keyCode == 32 ? $event.preventDefault() : true\" ng-keyup=\"vm.selected.name = vm.selected.name.replace(vm.replaceRegex, \'\').toUpperCase()\"></md-input-container><md-input-container class=\"md-inline-table\" flex=\"85\"><label>Descrição</label> <input ng-model=\"vm.selected.description\"></md-input-container></div><span ng-show=\"(vm.selected.nodes !== undefined && vm.selected.nodes.length == 0) || vm.selected.nodes === undefined\"><strong class=\"group-field gf-separete\"><small>Tipo de Evento</small></strong><div layout=\"column\"><md-radio-group layout=\"row\" ng-model=\"vm.selected.type_event\" ng-init=\"vm.selected.type_event = (vm.selected.formula !== null) ? \'C\' : \'L\'\"><md-radio-button value=\"L\" class=\"md-primary\" flex=\"\">Evento lançado</md-radio-button><md-radio-button value=\"C\" flex=\"\">Evento calculado</md-radio-button></md-radio-group></div><strong ng-show=\"vm.selected.type_event == \'L\'\" class=\"group-field gf-separete\"><small>Se trata de um evento especial?</small></strong><div layout=\"row\" ng-if=\"vm.selected.type_event == \'L\'\"><md-radio-group ng-model=\"vm.selected.is_pf_rc\"><md-radio-button ng-value=\"null\">Não</md-radio-button><md-radio-button ng-value=\"\'P\'\">Prova final</md-radio-button><md-radio-button ng-value=\"\'R\'\">Recuperação</md-radio-button></md-radio-group></div><strong ng-show=\"vm.selected.type_event == \'L\'\" class=\"group-field gf-separete\"><small>Condicional (opcional)</small></strong><div layout=\"column\"><div class=\"md-block\" ng-show=\"vm.selected.type_event == \'L\'\" ui-ace=\"\" ng-model=\"vm.selected.conditional\"></div></div><strong ng-show=\"vm.selected.type_event == \'C\'\" class=\"group-field gf-separete\"><small>Fórmula de cálculo</small></strong><div layout=\"column\"><div class=\"md-block\" ng-show=\"vm.selected.type_event == \'C\'\" ui-ace=\"{mode: \'pascal\'}\" ng-model=\"vm.selected.formula\" ng-required=\"vm.selected.type_event == \'C\'\"></div></div><div layout=\"row\" ng-show=\"vm.selected.type_event == \'C\'\"><md-switch ng-model=\"vm.selected.has_class_council\" aria-label=\"Conselho\" flex=\"\">Possui Conselho de Classe?</md-switch></div></span></div></div><div layout=\"row\" ng-show=\"(vm.selected.nodes !== undefined && vm.selected.nodes.length == 0) || vm.selected.nodes === undefined\"><strong class=\"group-field gf-separete\"><small>Outras definições</small><br><p>Os campos abaixo só devem ser preenchidos se for diferente das definições do critério.</p></strong></div><div layout=\"row\" ng-show=\"(vm.selected.nodes !== undefined && vm.selected.nodes.length == 0) || vm.selected.nodes === undefined\"><md-input-container flex=\"\"><label>Nota média</label> <input ng-model=\"vm.selected.pass_grade\"></md-input-container><md-input-container flex=\"\"><label>Nota máxima</label> <input ng-model=\"vm.selected.max_grade\"></md-input-container><md-input-container flex=\"\"><label>Decimais</label> <input ng-model=\"vm.selected.precision\"></md-input-container><md-input-container flex=\"\"><label>Tipo de arredondamento</label><md-select ng-model=\"vm.selected.grade_round_rule_id\"><md-option><em>Nenhum</em></md-option><md-option ng-repeat=\"round_rule in vm.list.grade_round_rule_item\" ng-value=\"round_rule.id\">{{round_rule.name}}</md-option></md-select></md-input-container></div><br><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\"><md-icon ng-show=\"!$root.show_loader\">close</md-icon>Cancelar</md-button><md-button type=\"submit\" class=\"md-raised submit-button\" ng-click=\"$saved_by_grouping = false;\" ng-show=\"(vm.selected.nodes !== undefined && vm.selected.nodes.length == 0) || vm.selected.nodes === undefined\" ng-disabled=\"evaluationCriteriaForm.$invalid || $root.show_loader\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\">check</md-icon>Salvar</md-button><md-button type=\"submit\" class=\"md-raised submit-button\" ng-disabled=\"$root.show_loader\" ng-click=\"$saved_by_grouping = true;\" ng-show=\"(vm.selected.nodes !== undefined && vm.selected.nodes.length > 0)\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\">check</md-icon>Salvar</md-button></div></form></div></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/evaluation-criteria/views/evaluation-criteria.html","<div ui-view=\"evaluation-criteria\"></div>");
$templateCache.put("app/educational/evaluation-criteria/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'EVALUATION_CRITERIA.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'EVALUATION_CRITERIA.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.filterEvaluationCriteriaList(vm.search)\" translate=\"\" translate-attr-placeholder=\"EVALUATION_CRITERIA.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-content style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editEvaluationCriteria(item)\" on-delete=\"vm.delete(index)\" on-click-actions=\"vm.clickAction(item, option)\" fields-schema=\"app/educational/evaluation-criteria/grid.json\"></a4-grid-dic-data></md-card></md-content></div>");
$templateCache.put("app/educational/external-document-assign/views/document.html","<md-dialog aria-label=\"confirmar matricula\" md-theme=\"educational\" style=\"width: 1000px; min-height: 775px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Assinatura de documento</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_loader\" ng-if=\"!vm.show_sign\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-sm=\"column\" ng-if=\"vm.show_loader\" layout-align=\"space-around\"><div style=\"margin-left: 420px\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><p style=\"text-align: center;\">Carregando documento, por favor, aguarde.</p></div><div flex=\"\" layout=\"column\" layout-xs=\"column\" ng-if=\"!vm.show_loader\"><div flex=\"100\" layout=\"column\" layout-align=\"end center\" layout-wrap=\"\"><iframe src=\"{{vm.data.content}}\" type=\"application/pdf\" width=\"100%\" height=\"500px\" ng-if=\"vm.data.content != null && !vm.show_sign\"></iframe><a4-form-dic-data bind=\"vm.form\" ng-if=\"!vm.show_sign\" list=\"vm.list\" fields-schema=\"app/educational/subject/form.json\"></a4-form-dic-data><div layout=\"row\" flex=\"\" ng-if=\"!vm.show_sign\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printEnrolmentContract()\" ng-disabled=\"sign_contract.$invalid || $root.show_loader || vm.loading\" flex=\"\">Download</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.show_sign = true\" ng-disabled=\"sign_contract.$invalid || $root.show_loader || vm.form.enrolment.attendance_mode_id == null\" flex=\"\">Assinar</md-button></div></div><div ng-if=\"vm.show_sign\"><a4-digital-sign person=\"vm.person\" student=\"vm.data\"></a4-digital-sign></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/external-document-assign/views/index.html","<div class=\"progress-div-alfa fade\" ng-show=\"!vm.showAuthentication && !vm.showAssign\" md-theme=\"educational\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando, por favor aguarde...</p></md-card-content></md-card></div></div></div><md-content id=\"content\" class=\"externalFinancialStatement\" layout=\"row\" layout-align=\"center start\" md-theme=\"educational\" ng-style=\"{height: vm.windowHeight + \'px\'}\" style=\"overflow: auto;\"><div layout=\"column\" layout-align=\"start center\" class=\"statementBackground\" style=\"width: 100%; overflow: auto;\" ng-style=\"{\'height\': vm.windowHeight + \'px\', \'background\': vm.url_background}\"><md-card class=\"presentationCardExternalAssign md-whiteframe-7dp md-padding fade\" style=\"border-radius: 7px; width: 75%; text-align: center\" ng-if=\"vm.showAuthentication\" layout=\"row\" layout-align=\"center start\"><div id=\"login-v2-form\" style=\"width: 40%\" ng-style=\"{width: vm.cpfFormWidth + \'%\'}\"><div style=\"width: 115px;line-height: 74px;font-size: 50px;font-weight: 500; margin: 2px auto 32px auto;color: #FFFFFF;border-radius: 2px;display: table;\"><div style=\"display: table-cell; vertical-align: middle;\"><img align=\"middle\" ng-src=\"{{vm.screen_image}}\" alt=\"\"></div></div><span class=\"headerSpan\">{{vm.data[0].company_name.split(\'(\')[0]}}</span><form name=\"formCPF\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"vm.data[0].person_type == 1\"><input type=\"text\" name=\"CPF\" ng-model=\"vm.cpf\" placeholder=\"Digite seu CPF\" ui-br-cpf-mask=\"\" required=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"vm.data[0].person_type != 1\"><input type=\"text\" name=\"CPF\" ng-model=\"vm.cpf\" placeholder=\"Digite seu CNPJ\" ui-br-cnpj-mask=\"\" required=\"\"></md-input-container><div layout=\"column\"><md-button class=\"md-raised md-accent submit-button\" aria-label=\"Confirmar\" ng-click=\"vm.verifyCpf()\" ng-disabled=\"formCPF.$invalid || vm.loading\">Confirmar</md-button></div></form></div></md-card><div ng-repeat=\"document in vm.data track by $index\" layout=\"column\" layout-align=\"center center\"><md-card class=\"fade md-whiteframe-7dp md-padding\" style=\"width: 1700px; text-align: center;\" ng-if=\"$index == 0 && vm.showAssign\"><h1 style=\"font-size: 18px\">Bem-vindo, {{document.responsible_name}} segue abaixo os contratos assinados e disponíveis para assinatura</h1></md-card><md-card class=\"presentationCardExternalAssign fade md-whiteframe-7dp md-padding\" style=\"width: 1800px\" ng-if=\"$index == 1 && vm.showAssign\"><h1 style=\"font-size: 18px\">Outros contratos</h1></md-card><md-card class=\"presentationCardExternalAssign fade md-whiteframe-7dp md-padding\" ng-if=\"vm.showAssign\" style=\"border-radius: 7px; text-align: center; ; max-height: 55%; max-width: 55%\" ng-style=\"vm.cpf_verify === false && vm.windowWidth < 1000 && {\'width\': \'100% !important;\'}\" layout=\"column\" layout-align=\"center start\"><h1 style=\"font-size: 18px\">Clique no botão abaixo para <span ng-if=\"vm.showAssign && !document.sign_confirmed\">assinar</span><span ng-if=\"vm.showAssign && (document.sign_confirmed)\">imprimir</span> o documento {{document.document_name}} para o aluno {{document.student_name}} do curso {{document.course_name}} referente ao serviço {{document.product_name}}.</h1></md-card><md-button class=\"md-raised md-primary fade\" style=\"font-size: 15px;\" ng-if=\"vm.showAssign && !document.sign_confirmed\" ng-click=\"vm.sign(document)\"><md-icon md-font-icon=\"icon-check\"></md-icon>Ver documento</md-button><md-button class=\"md-raised md-primary fade\" style=\"font-size: 23px; padding: 15px;\" ng-if=\"vm.showAssign && (document.sign_confirmed)\" ng-disabled=\"vm.show_loader\" ng-click=\"vm.print(document)\"><md-icon md-font-icon=\"icon-printer\"></md-icon>Imprimir documento</md-button></div></div></md-content>");
$templateCache.put("app/educational/external-person-edit/views/index.html","<md-content class=\"externalPersonEditContainer new-material-inputs\" layout=\"row\" layout-align=\"center start\" ng-style=\"{height: vm.windowHeight + \'px\'}\" style=\"overflow: auto\"><md-card class=\"personEditFormCard md-whiteframe-7dp md-padding fade\" style=\"border-radius: 5px; text-align: center;\" ng-style=\"{width: vm.formWidth + \'%\'}\" ng-if=\"vm.show_form\"><div style=\"display: table-cell; vertical-align: middle;\"><img align=\"middle\" ng-src=\"{{vm.screen_image}}\" alt=\"\" width=\"250\" height=\"250\"></div><h1>Edição de Dados Pessoais</h1><form name=\"responsible_form\" md-theme=\"educational\" style=\"text-align: left !important;\"><a4-responsible-form person=\"vm.person_copy\" is-enabled=\"vm.form.mode_edit\" responsible-form=\"responsible_form\" is-external-edit=\"true\" block-form-email=\"vm.blockFormEmail\"></a4-responsible-form><a4-responsible-contact-form person=\"vm.person_copy\" responsible-form=\"responsible_form\" is-enabled=\"vm.form.mode_edit\"></a4-responsible-contact-form><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" style=\"background-color: #f8f8f8; border-radius: 3px;\"><label class=\"isEnabled\">Empresa onde trabalha</label> <input ng-model=\"vm.form.person.company_work\" type=\"text\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" style=\"background-color: #f8f8f8; border-radius: 3px;\"><label class=\"isEnabled\">Cargo</label> <input ng-model=\"vm.form.person.position_held\" type=\"text\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" style=\"background-color: #f8f8f8; border-radius: 3px;\"><label class=\"isEnabled\">Função</label> <input ng-model=\"vm.form.person.job_role\" type=\"text\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" style=\"background-color: #f8f8f8; border-radius: 3px;\"><label class=\"isEnabled\">Tempo de serviço</label> <input ng-model=\"vm.form.person.years_in_employment\" type=\"text\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" style=\"background-color: #f8f8f8; border-radius: 3px;\"><label class=\"isEnabled\">Endereço</label> <input ng-model=\"vm.form.person.work_address_street\" type=\"text\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" style=\"background-color: #f8f8f8; border-radius: 3px;\"><label class=\"isEnabled\">Telefone comercial</label> <input ng-model=\"vm.form.person.work_phone_1\" ui-br-phone-number=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" style=\"background-color: #f8f8f8; border-radius: 3px;\"><label class=\"isEnabled\">Telefone comercial 2</label> <input ng-model=\"vm.form.person.work_phone_2\" ui-br-phone-number=\"\"></md-input-container><div><p style=\"background-color: rgb(228, 225, 222);\"><b>Atenção!</b> Revise os dados e clique no botão para confirmar, mesmo que não tenha feito alterações.</p></div><div style=\"text-align: right\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"!vm.form.mode_edit || vm.blockFormEmail || responsible_form.$invalid || vm.loading\" ng-click=\"vm.submit(responsible_form, vm.person_copy)\" layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\" flex=\"15\" md-diameter=\"15\"></md-progress-circular><span flex=\"85\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Confirmar e enviar</span></md-button></div></form></md-card><md-card class=\"personEditFormCard md-whiteframe-7dp md-padding fade\" style=\"border-radius: 5px; text-align: center; margin-top: 20%\" ng-style=\"{width: vm.formWidth + \'%\'}\" ng-if=\"vm.show_success_message\"><h1>Obrigado pela atualização das suas informações!</h1></md-card></md-content>");
$templateCache.put("app/educational/external-pre-enrolment/views/confirmation.html","<md-content class=\"externalPreEnrolmentContainer new-material-inputs\" layout=\"row\" layout-align=\"center start\" ng-style=\"{height: vm.windowHeight + \'px\'}\" style=\"overflow: auto\"><md-card class=\"fade md-whiteframe-7dp md-padding\" style=\"border-radius: 5px; text-align: center;\" ng-if=\"vm.showResponsible\" ng-style=\"{width: vm.formWidth + \'%\'}\"><div style=\"display: table-cell; vertical-align: middle;\"><img align=\"middle\" ng-src=\"{{vm.screen_image}}\" alt=\"\" width=\"250\" height=\"250\"></div><form name=\"pre_enrolment_confirm_form\" style=\"text-align: left\" md-theme=\"educational\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244); margin-top: 5px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Informações do responsável</b> <small>Informe abaixo dados sobre o responsável pelos alunos a serem pré-matriculados</small></div></div><div ng-if=\"vm.isHiddenInformation == true\"><div layout=\"row\" style=\"border-left: solid 4px rgb(0, 0, 0); margin-top: 5px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Caro usuário.</b> <small>Por motivos de segurança as informações do responsável {{vm.responsible.name}} estão ocultas para essa pagina.</small></div></div></div><div ng-if=\"vm.isHiddenInformation == false\"><md-input-container layout=\"column\" flex-gt-xs=\"\" style=\"text-align: left\"><span><small>Sexo *</small></span><md-radio-group ng-model=\"vm.responsible.person_sex_id\" layout=\"row\" style=\"margin: 0;\" md-theme=\"educational\"><md-radio-button ng-repeat=\"sex in vm.sexs\" class=\"md-primary\" ng-value=\"sex.id\">{{sex.name}}</md-radio-button></md-radio-group></md-input-container><div layout-gt-xs=\"row\"><date-picker ng-model=\"vm.responsible.dob\" ng-required=\"true\" placeholder=\"Data de nascimento *\" without-icon=\"true\" ng-if=\"vm.company != 684\" flex-gt-xs=\"\"></date-picker></div><a4-address model=\"vm.responsible\" is-enabled=\"true\" has-owner=\"false\" show-phone=\"false\"></a4-address></div><div layout=\"row\" layout-align=\"end end\"><md-button md-theme=\"educational\" class=\"md-raised md-primary\" ng-disabled=\"pre_enrolment_confirm_form.$invalid\" ng-click=\"vm.goToDependents()\">Incluir aluno(s)<md-icon>arrow_forward</md-icon></md-button></div></form></md-card><md-card class=\"fade md-whiteframe-7dp md-padding\" style=\"border-radius: 5px; text-align: center;\" ng-if=\"vm.showDependents\" ng-style=\"{width: vm.formWidth + \'%\'}\"><div style=\"display: table-cell; vertical-align: middle;\"><img align=\"middle\" ng-src=\"{{vm.screen_image}}\" alt=\"\" width=\"250\" height=\"250\"></div><form name=\"pre_enrolment_dependents_form\" style=\"text-align: left\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244); margin-top: 5px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Dependentes</b> <small>Cadastre abaixo os alunos dependentes</small></div></div><md-card style=\"width: 95%;\" class=\"md-padding fade\" ng-repeat=\"dependent in vm.dependents track by $index\"><div layout=\"row\" layout-align=\"end end\" ng-if=\"vm.dependents.length > 1\" style=\"margin-bottom: 0;\"><md-button class=\"md-icon-button\" ng-click=\"vm.dependents.splice($index, 1)\"><md-icon md-icon=\"\" md-font-icon=\"icon-delete\"></md-icon></md-button></div><div layout-gt-xs=\"row\"><div layout=\"column\" style=\"width: 75%\"><label for=\"select-company\"><span style=\"line-height: 20px; font-size: 11.5px; color: #969696 !important\">Unidade</span></label><select2 ng-model=\"dependent.company_id\" s2-options=\"val.id as val.name for val in vm.companies\" ng-change=\"vm.filterCoursesByCompany($index)\" id=\"select-company\" required=\"\"></select2></div><div style=\"width: 10%; margin-left: 15px;\"><md-checkbox flex=\"\" ng-model=\"dependent.is_responsible\" ng-change=\"vm.getResponsibleData(dependent.is_responsible, $index)\">É o proprio responsável</md-checkbox></div></div><div layout-gt-xs=\"row\" style=\"margin-bottom: 20px;\"><div layout=\"column\" style=\"width: 50%\"><label for=\"select-course\"><span style=\"line-height: 20px; font-size: 11.5px; color: #969696 !important\">Curso *</span></label><select2 ng-model=\"dependent.course_id\" s2-options=\"val.id as val.name for val in dependent.courses\" ng-change=\"vm.getGroupShifts(dependent.course_id)\" id=\"select-course\" name=\"selectCourse\" ng-required=\"true\" required=\"\"></select2><div ng-messages=\"pre_enrolment_dependents_form.selectCourse.$error\" ng-if=\"pre_enrolment_dependents_form.selectCourse.$error\"><div ng-message=\"required\" style=\"color: red;\">Você precisa primeiro selecionar qual unidade deseja realizar a matrícula.</div></div></div><div layout=\"column\" style=\"width: 50%; margin-left: 5px;\"><label for=\"select-turn\"><span style=\"line-height: 20px; font-size: 11.5px; color: #969696 !important\">Turno *</span></label><select2 ng-model=\"dependent.group_shift_id\" s2-options=\"val.id as val.name for val in vm.group_shifts\" id=\"select-turn\" required=\"\"></select2></div></div><md-input-container flex-gt-xs=\"\" class=\"md-input-has-placeholder\" style=\"margin-bottom: 0; margin-top: 1px;\" md-theme=\"educational\"><label class=\"isEnabled\">Nome</label> <input ng-model=\"dependent.name\" type=\"text\" required=\"\"></md-input-container><md-input-container layout=\"column\" flex-gt-xs=\"\" style=\"text-align: left; margin-top: 1px; margin-bottom: 0\"><span><small>Sexo *</small></span><md-radio-group ng-model=\"dependent.person_sex_id\" layout=\"row\" style=\"margin: 0; margin-top: 1px;\" md-theme=\"educational\"><md-radio-button ng-repeat=\"sex in vm.sexs\" class=\"md-primary\" ng-value=\"sex.id\">{{sex.name}}</md-radio-button></md-radio-group></md-input-container><div layout-gt-xs=\"row\"><date-picker ng-model=\"dependent.dob\" ng-required=\"true\" placeholder=\"Data de nascimento *\" without-icon=\"true\" flex-gt-xs=\"\"></date-picker></div><a4cpf model=\"dependent.national_id_number\" classes=\"show_bottom\" is-enabled=\"true\" is-required=\"false\" show-owner=\"false\"></a4cpf><div layout-gt-xs=\"row\" style=\"margin-bottom: 0px !important; margin-top: -35px !important;\"><md-input-container flex-gt-xs=\"\"><label for=\"select-schools\" style=\"margin-bottom: 7px;\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Escola de origem</span></label><div layout=\"row\" style=\"margin-top: 20px\"><select2 ng-model=\"dependent.school_origin_id\" s2-options=\"val.id as val.name for val in vm.school_origins\" style=\"width: 100%\" options=\"{ language: \'pt-BR\', locale: \'pt-BR\', locales: \'pt-BR\' }\" id=\"select-schools\" ng-disabled=\"false\"></select2></div></md-input-container></div></md-card><div layout=\"row\" layout-align=\"end end\"><md-button md-theme=\"educational\" class=\"md-raised md-primary\" ng-click=\"vm.addDependent()\">Incluir aluno<md-icon>add_circle_outline</md-icon></md-button><md-button md-theme=\"educational\" class=\"md-raised md-primary\" ng-disabled=\"pre_enrolment_dependents_form.$invalid || vm.loading\" ng-click=\"vm.finish()\" layout=\"row\"><span flex=\"80\">Concluir</span> <span flex=\"20\"><md-icon ng-if=\"!vm.loading\">check</md-icon></span><md-progress-circular md-mode=\"indeterminate\" flex=\"20\" ng-if=\"vm.loading\" md-diameter=\"15\"></md-progress-circular></md-button></div></form></md-card><md-card class=\"preEnrolmentFormCard md-whiteframe-7dp md-padding fade\" style=\"border-radius: 5px; text-align: center; margin-top: 20%\" ng-style=\"{width: vm.formWidth + \'%\'}\" ng-if=\"vm.finished\"><h1 ng-if=\"vm.company != 684\">Processo de pré-matrícula concluído! Caso uma senha não tenha sido requisitada para o responsável durante o cadastro, seu login e senha são, respectivamente seu cpf e data de nascimento. Caso uma senha tenha sido requisitada, Uma mensagem de confirmação será enviada para seu email.</h1><h1 ng-if=\"vm.company == 684\">Processo de pré-matrícula concluído! Seu login e senha são, respectivamente seu cpf e data da nascimento</h1><md-button class=\"md-raised md-primary fade\" ng-click=\"vm.exit()\" ng-if=\"vm.company == 684\">Ir para tela de login</md-button></md-card></md-content>");
$templateCache.put("app/educational/external-pre-enrolment/views/index.html","<md-content class=\"externalPreEnrolmentContainer new-material-inputs\" layout=\"row\" layout-align=\"center start\" ng-style=\"{height: vm.windowHeight + \'px\'}\" style=\"overflow: auto\"><md-card class=\"preEnrolmentFormCard md-whiteframe-7dp md-padding fade\" style=\"border-radius: 5px; text-align: center;\" ng-style=\"{width: vm.formWidth + \'%\'}\" ng-if=\"vm.show_form\"><div style=\"display: table-cell; vertical-align: middle;\"><img align=\"middle\" ng-src=\"{{vm.screen_image}}\" alt=\"\" width=\"250\" height=\"250\"></div><h1>Inscrição para pré-matrícula online</h1><form name=\"pre_enrolment_form\" md-theme=\"educational\" style=\"text-align: left !important;\"><a4cpf model=\"vm.responsible.national_id_number\" classes=\"show_bottom\" is-enabled=\"true\" is-required=\"true\" show-owner=\"false\" is-pre-enrolment=\"true\"></a4cpf><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\"><label class=\"isEnabled\">Nome do responsável</label> <input ng-model=\"vm.responsible.name\" required=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\"><label class=\"isEnabled\">Telefone</label> <input ng-model=\"vm.responsible.phone_landline\" ui-br-phone-number=\"\" required=\"\"></md-input-container><a4email model=\"vm.responsible.email\" classes=\"show_bottom\" is-enabled=\"true\" is-required=\"vm.type_user_login != \'enrolment_number\'\" show-owner=\"false\"></a4email><a4email model=\"vm.responsible.email_confirmation\" classes=\"show_bottom\" is-enabled=\"true\" is-required=\"vm.type_user_login != \'enrolment_number\'\" show-owner=\"false\" label-custom=\"\'Email (confirmação)\'\"></a4email><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" ng-if=\"vm.type_user_login == \'enrolment_number\'\" flex-gt-xs=\"\"><label class=\"isEnabled\">Data de nascimento</label> <input type=\"text\" name=\"dob\" ng-model=\"vm.responsible.dob\" ng-required=\"true\" ui-date-mask=\"\"></md-input-container><md-input-container ng-if=\"vm.type_user_login != \'enrolment_number\'\" class=\"md-block md-input-has-placeholder show_bottom\" flex-gt-xs=\"\"><label class=\"isEnabled\">Senha</label> <input ng-model=\"vm.responsible.password\" type=\"password\" required=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder show_bottom\" ng-if=\"vm.type_user_login != \'enrolment_number\'\" flex-gt-xs=\"\"><label class=\"isEnabled\">Senha (confirmação)</label> <input ng-model=\"vm.responsible.password_confirm\" type=\"password\" required=\"\"></md-input-container><div ng-if=\"vm.responsible.national_id_number == null\"><div layout=\"row\" style=\"border-left: solid 1px rgb(226, 18, 18); margin-top: 5px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Caro usuário.</b> <small>Por favor informe o cpf do responsável e as demais informações obrigatórias para continuar.</small></div></div></div><div style=\"text-align: right\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"pre_enrolment_form.$invalid || vm.loading || vm.responsible.national_id_number == null\" ng-click=\"vm.submit()\" layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\" flex=\"15\" md-diameter=\"15\"></md-progress-circular><span flex=\"85\">CONCLUIR</span></md-button></div></form></md-card><md-card class=\"preEnrolmentFormCard md-whiteframe-7dp md-padding fade\" style=\"border-radius: 5px; text-align: center; margin-top: 20%\" ng-style=\"{width: vm.formWidth + \'%\'}\" ng-if=\"vm.show_mail_sent\"><h1>Foi enviado um link de confirmação para seu e-mail {{vm.responsible.email}}!</h1></md-card></md-content>");
$templateCache.put("app/educational/finance-enrolment/views/finance-enrolment-grid.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cash-usd\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Matrícula financeira</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"Pesquisar aluno\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.paginate()\" ng-model=\"vm.search\"></md-input-container></div></md-toolbar><md-card layout-padding=\"\"><md-content layout=\"row\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-click-actions=\"vm.clickActions(item, option)\" on-click-item=\"vm.doFinanceEnrolment(item)\" on-paginate=\"vm.paginate\" on-delete=\"vm.delete(item)\" fields-schema=\"app/educational/finance-enrolment/grid.json\"></a4-grid-dic-data></md-content></md-card></div>");
$templateCache.put("app/educational/groups/views/groups-environment.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" style=\"width: 100%\"><a4-search-field url=\"groups/getall\" style=\"width: 100%\" placeholder=\"{{ \'GROUPS.TITLE\' | translate }}\"></a4-search-field></div></md-toolbar><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" ng-if=\"vm.show_tabs\"><md-tab label=\"Horários\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex=\"\" md-truncate=\"\">{{ vm.selected_group.group_name }}</h2><md-button aria-label=\"comment\" class=\"md-icon-button\"><md-icon>add</md-icon><md-tooltip md-direction=\"left\">Criar nova grade</md-tooltip></md-button><md-button aria-label=\"label\" class=\"md-icon-button\"><md-icon md-svg-src=\"img/icons/ic_label_24px.svg\"></md-icon></md-button><md-button aria-label=\"photo\" class=\"md-icon-button\"><md-icon md-svg-src=\"img/icons/ic_photo_24px.svg\"></md-icon></md-button></div></md-toolbar><md-content class=\"md-padding\"><h1 class=\"md-display-2\">Tab One</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla venenatis ante augue. Phasellus volutpat neque ac dui mattis vulputate. Etiam consequat aliquam cursus. In sodales pretium ultrices. Maecenas lectus est, sollicitudin consectetur felis nec, feugiat ultricies mi.</p></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/groups/views/groups-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\" ng-if=\"!vm.checkPolicies(\'turma\')\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.groups.list\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><a4-search-field url=\"groups/getall\" style=\"width: 100%\" on-change=\"vm.changeGroup(item)\" ng-if=\"vm.form.school_period_id !== vm.school_period_free\" selected-item=\"vm.form\" placeholder=\"{{vm.form.group_full_name}}\"></a4-search-field><a4-search-field predefined-list-data=\"vm.group_modules\" style=\"width: 100%\" on-change=\"vm.changeGroup(item)\" ng-if=\"vm.form.school_period_id === vm.school_period_free\" predefined-list=\"true\" selected-item=\"vm.form\" placeholder=\"{{vm.form.group_full_name}}\"></a4-search-field></div><md-button ng-click=\"vm.delete(vm.form.group)\" ng-if=\"!vm.checkPolicies(\'turma_hor_alt\')\" ng-show=\"vm.selected_tab == 0 && !vm.form.group.block_delete && vm.form.group.id != undefined\" class=\"md-icon-button btn-edit\" style=\"margin: 0 20px 0 20px;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"GROUPS.DELETE\"><md-tooltip md-direction=\"bottom\">Excluir</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-click=\"vm.delete(vm.form.group)\" ng-if=\"!vm.checkPolicies(\'turma_hor_alt\')\" ng-show=\"vm.selected_tab == 0 && vm.form.group.block_delete && vm.form.group.id != undefined\" class=\"md-icon-button btn-edit button-disable\" style=\"margin: 0 20px 0 0;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"GROUPS.DELETE\"><md-tooltip md-direction=\"left\">{{vm.form.group.message_block_delete}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-click=\"vm.close()\" style=\"margin: 0\" class=\"md-icon-button btn-edit\" ng-if=\"!vm.checkPolicies(\'turma_hor_alt\')\" ng-show=\"vm.selected_tab == 0 && vm.form.group.id != undefined\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"GROUPS.EDIT\"><md-tooltip><span ng-show=\"!vm.form.mode_edit\">Editar</span> <span ng-show=\"vm.form.mode_edit\">Cancelar Edição</span></md-tooltip><md-icon ng-show=\"!vm.form.mode_edit\" md-font-icon=\"icon-pencil\"></md-icon><md-icon ng-show=\"vm.form.mode_edit\" md-font-icon=\"icon-cancel\"></md-icon></md-button></div></md-toolbar><md-content class=\"btn-material-default\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\" ng-if=\"!vm.checkPolicies(\'turma\')\" style=\"background-color: whitesmoke\"><md-tab label=\"Geral\"><md-card class=\"md-padding\" ng-if=\"vm.selected_tab === 0\"><form name=\"groupform\" ng-submit=\"vm.save(vm.form)\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244); margin-bottom: 10px\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Informações da turma</b></div></div><div layout=\"row\" layout-wrap=\"\" class=\"md-padding\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex=\"25\"><label>Nome</label><md-icon md-font-icon=\"icon-chair-school\"></md-icon><input name=\"phone\" type=\"text\" ng-model=\"vm.form.name\" ng-disabled=\"vm.can_edit\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex=\"25\"><label>Capacidade</label><md-icon md-font-icon=\"icon-numeric-9-plus-box\"></md-icon><input name=\"phone\" type=\"number\" ng-model=\"vm.form.capacity\" ng-disabled=\"vm.can_edit\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex=\"25\"><label>Grade Curricular</label><md-icon md-font-icon=\"icon-grid\"></md-icon><md-tooltip>Não é possível editar a grade curricular</md-tooltip><input name=\"phone\" ng-value=\"vm.form.matrix_name\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"25\"><label>Turno</label><md-icon md-font-icon=\"icon-rotate-right\"></md-icon><md-select ng-model=\"vm.form.group_shift_id\" name=\"course\" aria-label=\"Curso\" ng-change=\"vm.paginate(1, 20, vm.course_id)\" ng-disabled=\"vm.can_edit\"><md-option ng-repeat=\"group_shift in vm.form.group_shift_list track by $index\" ng-value=\"group_shift.id\">{{group_shift.name}}</md-option></md-select><div ng-messages=\"formaddgroup.course.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar o critério de avaliação.</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"25\" style=\"padding-left: 35px;\" ng-if=\"(vm.form.course_equivalence_id >= 1 && vm.form.course_equivalence_id <= 104) || (vm.form.course_equivalence_id >= 111 && vm.form.course_equivalence_id <= 115)\"><md-icon md-font-icon=\"icon-account\"></md-icon><md-autocomplete md-input-name=\"professor\" md-selected-item=\"vm.form.person_teacher\" md-search-text=\"vm.searchTextTeacher\" md-items=\"teacher in vm.getTeachers(vm.searchTextTeacher)\" md-item-text=\"teacher.name\" md-floating-label=\"Professor\" md-min-length=\"0\" md-no-cache=\"true\" md-select-on-match=\"true\" ng-disabled=\"vm.can_edit\"><md-item-template><span md-highlight-text=\"vm.searchTextTeacher\">{{teacher.name}}</span></md-item-template><md-not-found>Nenhum professor encontrado.</md-not-found></md-autocomplete></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"25\" style=\"padding-left: 35px;\" ng-if=\"(vm.form.course_equivalence_id >= 1 && vm.form.course_equivalence_id <= 104) || (vm.form.course_equivalence_id >= 111 && vm.form.course_equivalence_id <= 115)\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><md-autocomplete md-input-name=\"professor_auxiliar\" md-selected-item=\"vm.form.person_teacher_aux\" md-search-text=\"vm.searchTextTeacherAux\" md-items=\"teacher in vm.getTeachers(vm.searchTextTeacherAux)\" md-item-text=\"teacher.name\" md-floating-label=\"Professor Auxiliar\" md-min-length=\"0\" md-no-cache=\"true\" md-select-on-match=\"true\" ng-disabled=\"vm.can_edit\"><md-item-template><span md-highlight-text=\"vm.searchTextTeacherAux\">{{teacher.name}}</span></md-item-template><md-not-found>Nenhum professor encontrado.</md-not-found></md-autocomplete></md-input-container></div><div layout=\"column\" ng-if=\"vm.form.school_period_id == vm.school_period_free\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244); margin-bottom: 10px\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Datas de Início e conclusão do período</b> <small>Datas de início e de final das aulas para este período</small></div></div><div layout=\"row\" class=\"md-padding\"><date-picker ng-model=\"vm.form.initial_date\" placeholder=\"Data inicial\" ng-disabled=\"vm.can_edit\"></date-picker><date-picker ng-model=\"vm.form.final_date\" placeholder=\"Data Final\" ng-disabled=\"vm.can_edit\"></date-picker></div><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244); margin-bottom: 10px\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Status do período</b> <small>Status deste período da turma</small></div></div><div layout=\"row\"><md-radio-group ng-model=\"vm.form.group_status_id\" layout=\"row\" class=\"md-padding\" ng-disabled=\"vm.can_edit\"><md-radio-button value=\"1\" ng-disabled=\"vm.current_status === 4 || vm.current_status === 3\"><span class=\"group_status_1\">Não iniciado</span></md-radio-button><md-radio-button value=\"2\" ng-disabled=\"vm.current_status === 4\"><span class=\"group_status_2\">Em Matrícula</span></md-radio-button><md-radio-button value=\"3\" ng-disabled=\"vm.current_status === 4 || vm.current_status === 5 || vm.current_status === 1\"><span class=\"group_status_3\">Em Andamento</span></md-radio-button><md-radio-button value=\"4\" ng-disabled=\"vm.current_status !== 3\"><span class=\"group_status_4\">Concluído</span></md-radio-button><md-radio-button value=\"5\" ng-disabled=\"vm.current_status === 3 || vm.current_status === 4\"><span class=\"group_status_5\">Descontinuado</span></md-radio-button></md-radio-group></div></div><hr><md-card-actions layout=\"row\" layout-align=\"end\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"$root.show_loader || groupform.$invalid || vm.checkPolicies(\'turma_hor_alt\')\"><md-icon md-font-icon=\"icon-check\"></md-icon>Salvar</md-button></md-card-actions></form></md-card></md-tab><md-tab label=\"Horários\" md-on-select=\"vm.reload()\"><md-content class=\"md-padding\" ng-if=\"vm.selected_tab === 1\"><div ui-view=\"timetable\"></div></md-content></md-tab><md-tab label=\"Alunos\" md-on-select=\"vm.reload()\"><md-content class=\"md-padding\" ng-if=\"vm.selected_tab === 2\"><div ui-view=\"students\"></div></md-content></md-tab><md-tab label=\"Notas pendentes\" md-on-select=\"vm.reload()\"><md-content class=\"md-padding\" ng-if=\"vm.selected_tab === 3\"><div ui-view=\"notes-pending-group\"></div></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/groups/views/groups.html","<div ui-view=\"groups\"></div>");
$templateCache.put("app/educational/groups/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-book-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'GROUPS.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.checkPolicies(\'turma\')\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'COURSE.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-change=\"vm.filterGroupsList(vm.search)\" translate=\"\" translate-attr-placeholder=\"COURSE.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-card layout-padding=\"\"><md-content ng-if=\"!vm.checkPolicies(\'turma\')\"><div layout=\"row\"><md-input-container flex=\"20\" style=\"margin-top: 10px\" ng-if=\"vm.is_without_school_period\"><md-checkbox ng-model=\"vm.show_group_completed\">Mostrar turmas concluidas</md-checkbox></md-input-container><div flex=\"\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Curso</label><md-icon md-font-icon=\"icon-school\"></md-icon><md-select ng-model=\"vm.course_id\" name=\"course\" aria-label=\"Curso\" ng-change=\"vm.paginate(1, 20, vm.course_id)\"><md-option ng-value=\"undefined\">Todos</md-option><md-option ng-value=\"course.id\" ng-repeat=\"course in vm.courses track by $index\">{{course.name}}</md-option></md-select><div ng-messages=\"formaddgroup.course.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar o critério de avaliação.</div></div></md-input-container></div></div><a4-groups show-group-completed=\"vm.show_group_completed\" is-without-school-period=\"vm.is_without_school_period\" show-course=\"true\" course-id=\"vm.course_id\" query=\"vm.search\"></a4-groups></md-content></md-card></div>");
$templateCache.put("app/educational/import-photos/views/file-batch.html","<md-dialog aria-label=\"Importar fotos em lote\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Importar imagens</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div>As imagens devem ser em formato PNG ou JPG/JPEG para serem enviadas. Enviar no máximo 1000 arquivos por vez. (Limite máximo de peso: 2MB)</div><div>Cada imagem dentro do arquivo deve conter o número de matrícula do aluno e não pode conter espaço ou caracteres especiais. EX: 2000.jpg, 2001.png</div><div>As imagens devem ter no máximo 300 pixels de largura e 400 pixels de altura.</div><div id=\"container\" ng-hide=\"true\"><canvas id=\"image\" width=\"625\" height=\"500\"></canvas><canvas id=\"overlay\" width=\"625\" height=\"500\"></canvas></div><div class=\"md-dialog-content\"><div flex=\"\" style=\"min-width: 500px\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div><md-progress-linear ng-if=\"vm.isProcessing\" md-mode=\"determinate\" value=\"{{vm.determinateValue}}\"></md-progress-linear></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/import-photos/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-toolbar-tools\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-blur-radial\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" flex=\"\">Importação de Fotos</span></div><span flex=\"\"></span></div></md-toolbar><md-content layout-xs=\"column\" layout=\"row\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\" style=\"max-height: 900px\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><md-button class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-click=\"vm.openModalImport()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar Lote</md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.filter.show && vm.selected.length <= 0\" aria-hidden=\"true\"><div class=\"md-toolbar-tools\"><md-icon class=\"material-icons\">search</md-icon><input flex=\"\" type=\"text\" ng-model=\"vm.query_filter\" ng-model-options=\"vm.filter.options\" placeholder=\"Busca por nome\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"><button class=\"md-icon-button md-primary\" type=\"button\" ng-click=\"vm.removeFilter()\" aria-label=\"close\"><md-tooltip>Cancelar</md-tooltip><md-icon class=\"material-icons\" style=\"color: black;\">close</md-icon></button></div></md-toolbar><md-table-container><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-repeat=\"column in vm.table.columns\"><span>{{column.name}}</span></th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.items.data | filter : vm.query_filter : false\" ng-click=\"vm.editReason(item)\" style=\"cursor: pointer\"><td md-cell=\"\" ng-repeat=\"column in vm.table.columns\" ng-click=\"vm.editComment($event, item, column.id)\">{{item[column.id]}}</td><td md-cell=\"\" style=\"text-align: right\"><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.delete(item.id, item[vm.table.columns[0].id]); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip>Excluir item</md-tooltip></md-icon></md-button></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/educational/informative-report/views/informative-report-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"></md-toolbar><md-card class=\"btn-material-default\"><md-content class=\"md-padding\"><form name=\"formInformativeReport\" ng-submit=\"vm.submit(formInformativeReport, vm.form.document)\" novalidate=\"\"><div layout=\"row\"><div flex=\"60\"><strong class=\"group-field\"><small>Editor de conteúdo:</small></strong><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"title\" ng-model=\"vm.form.document.title\" maxlength=\"100\" placeholder=\"Título\" rquired=\"\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><textarea class=\"text_area\" name=\"html_editor\" ui-tinymce=\"vm.tinymceOptions\" id=\"textarea_html\" ng-model=\"vm.form.document.content\" ng-change=\"vm.changeHandler()\" ng-click=\"vm.setVariable()\">\n                </textarea></md-input-container></div><strong class=\"group-field\"><small>Imagem de destaque:</small></strong><figure class=\"figure-informative\" ng-if=\"vm.form.document.id\" ng-show=\"vm.form.document.file_reference\"><img ng-src=\"{{vm.url}}{{vm.form.document.file_reference}}\" alt=\"{{vm.form.document.title}}\"></figure><md-button ng-click=\"vm.removeImage()\" ng-if=\"vm.form.document.file_reference !== null\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Remover imagem</md-button><div class=\"dropzone-container\" layout=\"row\"><div class=\"dropzone md-block\" ng-dropzone=\"\" options=\"vm.dzOptions\" callbacks=\"vm.dzCallbacks\" methods=\"vm.dzMethods\"></div></div><div layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"formInformativeReport.$dirty && formInformativeReport.$invalid\" flex=\"15\">Salvar</md-button></div></div><div flex=\"40\"><strong class=\"group-field\"><small>Período de veiculação:</small></strong><div layout=\"row\"><date-picker name=\"date\" ng-model=\"vm.form.document.date\" placeholder=\"Inicial\"></date-picker><date-picker name=\"final_date\" ng-model=\"vm.form.document.final_date\" placeholder=\"Final\"></date-picker></div><strong class=\"group-field\"><small>Selecione os perfis para a visualização:</small></strong><div layout=\"row\"><md-input-container class=\"md-block\"><md-checkbox name=\"for_student\" ng-model=\"vm.form.document.for_student\">{{ \'INFORMATIVE_REPORT.FOR_STUDENT\' | translate }}</md-checkbox><md-checkbox name=\"for_parents\" ng-model=\"vm.form.document.for_parents\">{{ \'INFORMATIVE_REPORT.FOR_PARENTS\' | translate }}</md-checkbox><md-checkbox name=\"for_teacher\" ng-model=\"vm.form.document.for_teacher\">{{ \'INFORMATIVE_REPORT.FOR_TEACHER\' | translate }}</md-checkbox><md-checkbox name=\"for_staff\" ng-model=\"vm.form.document.for_employee\">{{ \'INFORMATIVE_REPORT.FOR_EMPLOYEE\' | translate }}</md-checkbox></md-input-container></div><strong class=\"group-field\"><small>Apenas para determinadas turmas:</small></strong><div layout=\"row\"><treeview data=\"vm.coursesAndGroups\" response=\"vm.form.document.filterCoursesAndGroups\"></treeview></div></div></div></form></md-content></md-card></div>");
$templateCache.put("app/educational/informative-report/views/informative-report.html","<div ui-view=\"informative-report\"></div>");
$templateCache.put("app/educational/informative-report/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-message-draw\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'INFORMATIVE_REPORT.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'INFORMATIVE_REPORT.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-change=\"vm.filterInformativeReportsList(vm.search)\" translate=\"\" translate-attr-placeholder=\"INFORMATIVE_REPORT.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-card layout-padding=\"\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editInformativeReport(item)\" on-delete=\"vm.deleteInformativeReport(index)\" fields-schema=\"app/educational/informative-report/grid.json\"></a4-grid-dic-data></md-card></div>");
$templateCache.put("app/educational/lesson-plan/views/lesson-plan-apply-group.html","<md-dialog aria-label=\"Create Lesson Plan\" md-theme=\"educational\" style=\"min-width: 400px; min-height: 300px\"><form ng-submit=\"vm.submit(vm.group)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Aplicar plano à turma</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 100px;margin-bottom: 100px\" ng-if=\"vm.show_loader\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><div ng-if=\"!vm.show_loader\"><md-card ng-if=\"vm.has_plan\"><md-content layout=\"row\"><div style=\"background-color: rgb(3,169,244); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 60px;\"></i><br><span style=\"font-size: 20px; color: #fff;\">Já existem turmas selecionadas com plano já aplicado</span></p><p><span style=\"font-size: 16px; color: #fff; margin: 0 5px\">Reaplicando este plano, todas as aulas planejadas para esta turma e não realizadas serão substituídas a partir da última aula realizada</span></p></div></md-content></md-card><md-content class=\"md-padding md-dialog-content\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block md-input-has-placeholder\"><md-select ng-model=\"vm.group\" class=\"md-input-has-placeholder\" required=\"\" placeholder=\"Selecione uma ou mais turmas\" multiple=\"\" ng-change=\"vm.showWarningMessage(vm.group)\"><md-option ng-repeat=\"item in vm.groups\" ng-value=\"item\">{{item.course_alias}} | {{item.name}}</md-option></md-select></md-input-container></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" name=\"close\" ng-disabled=\"form.$invalid\" class=\"md-raised md-primary\">Aplicar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/lesson-plan/views/lesson-plan-item-modal.html","<md-dialog aria-label=\"Create Lesson Plan Item\" md-theme=\"educational\" style=\"min-width: 600px;min-height: 500px\"><form ng-cloak=\"\" ng-submit=\"vm.submit()\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.lesson_plan_item.id == null\">Criar aula</h2><h2 ng-if=\"vm.lesson_plan_item.id != null\">Editar aula</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Sequência</label> <input ng-model=\"vm.lesson_plan_item.lesson_sequence\" placeholder=\"Próximo\"></md-input-container><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Tipo da aula</label><md-select ng-model=\"vm.lesson_plan_item.type\" required=\"\" placeholder=\"\"><md-option ng-repeat=\"item in vm.types_list\" ng-value=\"item.id\" md-select-on-focus=\"item.vm.lesson_plan_item.type\">{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Unidade temática</label> <textarea type=\"text\" ng-model=\"vm.lesson_plan_item.activity\" rows=\"3\" required=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Objetivo de aprendizagem e desenvolvimento (Habilidades)</label> <textarea ng-model=\"vm.lesson_plan_item.objectives\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Metodologia/Procedimentos</label> <textarea ng-model=\"vm.lesson_plan_item.methodology\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Recursos empregados</label> <textarea ng-model=\"vm.lesson_plan_item.resources\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Avaliação</label> <textarea ng-model=\"vm.lesson_plan_item.evaluation\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Atividades para casa</label> <textarea ng-model=\"vm.lesson_plan_item.homework\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Observações complementares</label> <textarea ng-model=\"vm.lesson_plan_item.notes\" md-select-on-focus=\"\"></textarea></md-input-container></div><div layout=\"row\"><label>Arquivos</label></div><div layout=\"row\" class=\"form-wrapper\" style=\"padding-top: 0\" ng-if=\"vm.lesson_plan_item.files.length && vm.lesson_plan_item.id\"><md-table-container style=\"width: 100%;\"><table md-table=\"\" ng-model=\"selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Ver</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.lesson_plan_item.files\" ng-if=\"item.file_reference\"><td md-cell=\"\">{{item.name_display || item.name}}</td><td md-cell=\"\"><a target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + item.file_reference}}\">Ver arquivo</a></td></tr></tbody></table></md-table-container></div><div layout=\"row\" class=\"form-wrapper\"><div flex=\"\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\" ng-disabled=\"vm.disabled\">Cancelar</md-button><md-button type=\"submit\" name=\"close\" ng-disabled=\"form.$invalid || vm.disabled\" class=\"md-raised md-primary\" ng-if=\"vm.lesson_plan_item.id == null\">Salvar e fechar</md-button><md-button type=\"submit\" class=\"md-raised md-primary\" ng-click=\"vm.shouldDuplicate = true\" name=\"Shoud Duplicate\" ng-disabled=\"form.$invalid || vm.disabled\" ng-if=\"vm.lesson_plan_item.id == null\">Adicionar e Duplicar</md-button><md-button type=\"submit\" ng-click=\"vm.addAnother = true\" name=\"add-another\" ng-disabled=\"form.$invalid || vm.disabled\" class=\"md-raised md-primary\" ng-if=\"vm.lesson_plan_item.id == null\">Salvar e adicionar outra aula</md-button><md-button type=\"submit\" name=\"edit\" ng-click=\"vm.isEdit = true\" ng-disabled=\"form.$invalid || vm.disabled\" class=\"md-raised md-primary\" ng-if=\"vm.lesson_plan_item.id != null\">Atualizar e fechar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/lesson-plan/views/lesson-plan-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.lesson-plan.list\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-text\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{vm.lesson_plan.name}}</span></div><h5 style=\"margin: 0\">Criado por: {{vm.lesson_plan.person_name}}<br>em {{vm.lesson_plan.created_at.split(\' \')[0] | date: \'dd/MM/yyyy\'}} às {{vm.lesson_plan.created_at.split(\' \')[1] | date:\'h:mm\'}}</h5></div><div><md-button class=\"md-icon-button\" aria-label=\"Imprimir plano de aulas\" ng-click=\"vm.printLessonPlan()\"><md-tooltip md-direction=\"bottom\">Imprimir plano de aula</md-tooltip><md-icon>print</md-icon></md-button><md-button ng-click=\"vm.openModalSelectGroup()\" class=\"md-icon-button btn-edit\" aria-label=\"Aplicar plano de aulas\"><md-tooltip md-direction=\"bottom\">Aplicar plano à turmas</md-tooltip><md-icon md-font-icon=\"icon-check-all\"></md-icon></md-button><h5 style=\"margin: 0\">Editado por último em:<br>{{vm.lesson_plan.last_lesson_plan_item_update.split(\' \')[0] | date: \'dd/MM/yyyy\'}} às {{vm.lesson_plan.last_lesson_plan_item_update.split(\' \')[1] | date:\'h:mm\'}}</h5></div></md-toolbar><md-card layout-padding=\"\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-paginate=\"vm.getLessonItems\" on-click-item=\"vm.editPlanItem(item)\" on-delete=\"vm.removePlanItem(index, item)\" fields-schema=\"app/educational/lesson-plan/grid.json\"></a4-grid-dic-data></md-card></div>");
$templateCache.put("app/educational/lesson-plan/views/lesson-plan.html","<div ui-view=\"lesson-plan\"></div>");
$templateCache.put("app/educational/lesson-plan/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-book-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Planos de Aula</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"course\"><md-icon md-font-icon=\"icon-school\"></md-icon></label><md-input-container id=\"course\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.course_id\" placeholder=\"Curso\" ng-change=\"vm.paginate(undefined, undefined, vm.course_id, null); vm.subject_id = null\" md-on-open=\"vm.loadCourses()\"><md-option ng-value=\"null\"><em>Todos</em></md-option><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course.id\">{{course.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"subject\"><md-icon md-font-icon=\"icon-book-open\"></md-icon></label><md-input-container id=\"subject\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.subject_id\" ng-change=\"vm.paginate(undefined, undefined, vm.course_id, vm.subject_id)\" md-on-open=\"vm.loadSubjects()\"><md-option ng-value=\"null\"><em>Todos</em></md-option><md-option ng-repeat=\"subject in vm.subjects\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container></div></div></md-toolbar><md-card layout-padding=\"\"><md-content layout=\"row\" class=\"table-float-button\"><a4-form-dic-data bind=\"vm.grid\" on-paginate=\"vm.paginate\" on-delete=\"vm.delete(index)\" on-click-actions=\"vm.clickActions(item, option)\" on-click-item=\"vm.viewPlan(item)\" policies=\"{show:\'plano_aula\', cud:\'plano_aula\'}\" fields-schema=\"app/educational/lesson-plan/grid-list.json\"></a4-form-dic-data></md-content></md-card></div>");
$templateCache.put("app/educational/lesson-plan/views/modal-create.html","<md-dialog aria-label=\"Create Lesson Plan\" md-theme=\"educational\" style=\"min-width: 400px; min-height: 300px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Criar Novo Plano</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 100px;margin-bottom: 100px\" ng-if=\"vm.show_loader\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><div class=\"md-dialog-content\" ng-if=\"!vm.show_loader\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/lesson-plan/form-create.json\"></a4-form-dic-data></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/lesson-plan/views/modal-edit.html","<md-dialog aria-label=\"Edit Lesson Plan\" md-theme=\"educational\" style=\"min-width: 400px; min-height: 300px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Editar Plano</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 100px;margin-bottom: 100px\" ng-if=\"vm.show_loader\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><div class=\"md-dialog-content\" ng-if=\"!vm.show_loader\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/lesson-plan/form-create.json\"></a4-form-dic-data></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/note-release/views/note-release-page.html","<div ui-view=\"note-release\"></div>");
$templateCache.put("app/educational/note-release/views/note-release.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'NOTE_RELEASE.TITLE\' | translate }}</span></div></div></md-toolbar><md-card class=\"md-padding\"><div><strong class=\"group-field\"><small>Lançamento de Notas por:</small></strong><div layout=\"row\" class=\"filter-release\"><md-radio-group ng-model=\"vm.filterRelease\" ng-change=\"vm.clear()\" layout=\"row\"><md-radio-button value=\"student\" flex=\"50\" policy-access=\"nota_alt\">Aluno</md-radio-button><md-radio-button value=\"group\" flex=\"50\" policy-access=\"nota_alt\">Disciplina</md-radio-button><md-radio-button value=\"grouping\" flex=\"50\" ng-show=\"vm.show_grouping\" policy-access=\"nota_agrup_alt\">Agrupamento</md-radio-button><md-radio-button value=\"council\" flex=\"50\" policy-access=\"nota_cons_alt\">Conselho</md-radio-button></md-radio-group></div><md-divider></md-divider><br><div class=\"row-scroll\"><div ng-if=\"vm.filterRelease == \'student\'\"><div ui-view=\"students\"></div></div><div ng-if=\"vm.filterRelease == \'group\'\"><div ui-view=\"groups\"></div></div><div ng-if=\"vm.filterRelease == \'grouping\'\"><div ui-view=\"grouping\"></div></div><div ng-if=\"vm.filterRelease == \'council\'\"><div ui-view=\"council\"></div></div></div></div></md-card></div>");
$templateCache.put("app/educational/note-release/views/notes-for-group.html","<md-dialog aria-label=\"Notas em grupo\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Edição de notas em grupo</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><form name=\"formNoteReleaseGroup\" novalidate=\"\"><md-input-container class=\"md-block\"><input name=\"note\" placeholder=\"Nota do grupo\" ng-model=\"vm.new_note\" maxlength=\"{{ vm.getValue(vm.event[0], \'max_grade\').length }}\" ng-blur=\"vm.formatNote(vm.new_note, vm.getValue(vm.event[0], \'max_grade\'))\" aria-label=\"Nota\" pattern=\"^({{ vm.getValue(vm.event[0], \'max_grade\')|number}}|\\d)(\\.\\d{1,2})?$|[a-zA-Z]%?\" ng-disabled=\"vm.getValue(vm.event[0], \'conditional\')\"><div ng-messages=\"formNoteReleaseGroup.note.$error\"><div ng-message=\"pattern\">Nota máxima permitida: {{ vm.getValue(vm.event[0], \'max_grade\')|number}}</div></div></md-input-container><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.close();\" class=\"md-raised\"><md-icon md-font-icon=\"icon-close\"></md-icon>Cancelar</md-button><md-button ng-click=\"vm.submit()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Definir</md-button></div></form></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/persons/views/index.html","<a4-persons is-educational=\"true\"></a4-persons>");
$templateCache.put("app/educational/reports/locked/locked.html","<div layout=\"column\" layout-align=\"center center\"><h2>ATENÇÃO!</h2><div><md-card style=\"padding: 2%; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\"><p>\"Atenção senhores(as) responsáveis,<br>O Boletim encontra-se temporariamente fora do ar devido ao lançamento de notas. Avisaremos a todos quando o link estiver disponível novamente.\"</p></md-card></div></div>");
$templateCache.put("app/educational/reports/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Relatórios</span></div></div></md-toolbar><md-content layout=\"row\"><div id=\"board-selector\" layout=\"row\" ng-if=\"!vm.checkPolicies(\'colab\')\" flex=\"\"><div ui-view=\"reports\" flex=\"\" class=\"board-list\" ng-show=\"vm.showList\"></div><div ui-view=\"reportDetails\" flex=\"\" class=\"board-list\" ng-show=\"!vm.showList\"></div></div></md-content></div>");
$templateCache.put("app/educational/reports/views/reportDetail.html","<md-card style=\"position: fixed;\" ng-style=\"{ \'position\': \'static\' , \'width\':\'auto\' }\"><md-card-title ng-if=\"vm.report_selected != null\"><md-card-title-text><md-toolbar layout=\"row\" class=\"inner-card md-hue-3\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" data-ng-click=\"vm.changeShowList()\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span>{{vm.report_selected.name}}</span> <span flex=\"\"></span><md-checkbox ng-model=\"vm.show_inactive_groups\" ng-if=\"vm.report_selected.has_group_filter\" ng-change=\"vm.getGroups(vm.print.course_selected)\">Mostrar turmas inativas</md-checkbox></div></md-toolbar></md-card-title-text></md-card-title><div ng-include=\"vm.report_selected.template\"></div></md-card>");
$templateCache.put("app/educational/reports/views/reportList.html","<md-card><md-card-content><a4-ui-tree list=\"vm.reportList\" template=\"nodes_renderer\" insert-nodes=\"true\" drag-enable=\"true\" action-select=\"vm.selectReport(item)\" only-children=\"false\" have-sub-nodes=\"false\" nodrop-enable=\"false\" max-nodes=\"2\" ng-show=\"true\"></a4-ui-tree></md-card-content></md-card>");
$templateCache.put("app/educational/responsible-changes/views/responsible-changes.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><div ui-view=\"responsible-changes\"></div></div>");
$templateCache.put("app/educational/responsibles/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'RESPONSIBLES.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'RESPONSIBLES.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.filterResponsiblesList(vm.search)\" translate=\"\" translate-attr-placeholder=\"RESPONSIBLES.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-card layout-padding=\"\"><md-content layout=\"row\" class=\"table-float-button\"><md-checkbox style=\"position: absolute; top: 20px; left: 23px\" ng-model=\"vm.is_inactive\" aria-label=\"Mostrar responsáveis inativos\" ng-change=\"vm.paginate()\" class=\"is_inactive\">Mostrar responsáveis inativos</md-checkbox><a4-form-dic-data bind=\"vm.grid\" on-submit=\"vm.submit(item, form)\" on-paginate=\"vm.paginate\" on-click-actions=\"vm.clickActions(item, option)\" on-click-item=\"vm.editResponsible(item)\" on-delete=\"vm.deleteResponsible(index)\" policies=\"{show:\'resp\', cud:\'resp_alt\'}\" fields-schema=\"app/educational/responsibles/grid.json\"></a4-form-dic-data></md-content></md-card></div>");
$templateCache.put("app/educational/responsibles/views/responsibles-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.responsibles.list\" policy-access=\"resp_alt\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><label class=\"new-resource\" ng-if=\"!vm.form.person.id\" ng-show=\"vm.form.person\"><md-icon>person</md-icon><strong>NOVO RESPONSÁVEL</strong></label><a4-search-field url=\"/responsibles\" style=\"width: 100%\" is-disabled=\"vm.checkProfile(vm.CONFIG.profile.parent)\" on-change=\"vm.changeResponsible(item)\" icon=\"icon-account\" selected-item=\"vm.form.person\" ng-if=\"vm.form.person.id\" placeholder=\"{{vm.form.person.name}}\"></a4-search-field></div><md-button ng-click=\"vm.delete(vm.form.person)\" ng-show=\"!vm.checkPolicies(\'resp_alt\') && ((vm.selected_tab == 0 || vm.selected_tab == 1) && vm.form.person_parent == undefined)\" class=\"md-icon-button btn-edit\" style=\"margin: 0 0 0 20px;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COLLABORATORS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"left\">{{vm.form.person.message_block_delete}}</md-tooltip></md-button><md-button ng-click=\"vm.delete(vm.form.person)\" ng-show=\"!vm.checkPolicies(\'resp_alt\') && ((vm.selected_tab == 0 || vm.selected_tab == 1) && vm.form.person.block_delete && vm.form.person.id != undefined)\" class=\"md-icon-button btn-edit button-disable\" style=\"margin: 0 0 0 20px;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COLLABORATORS.DELETE\">s<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\">Remover</md-tooltip></md-button><md-button ng-click=\"vm.ableEdit()\" style=\"margin: 0 0 0 20px;\" class=\"md-icon-button btn-edit\" ng-show=\"!vm.checkPolicies(\'resp_alt\') && (vm.selected_tab == 0 || vm.selected_tab == 1 && vm.form.person.id != undefined)\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COLLABORATORS.EDIT\"><md-tooltip><span ng-show=\"!vm.form.mode_edit\">Editar</span> <span ng-show=\"vm.form.mode_edit\">Cancelar Edição</span></md-tooltip><md-icon ng-show=\"!vm.form.mode_edit\" md-font-icon=\"icon-pencil\"></md-icon><md-icon ng-show=\"vm.form.mode_edit\" md-font-icon=\"icon-cancel\"></md-icon></md-button></div></md-toolbar><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important;\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Geral\"><a4-email-warning person-id=\"vm.person_id\"></a4-email-warning><div layout=\"row\"><md-card layout=\"row\" layout-gt-xs=\"center start\" style=\"min-width: 1000px; margin: 10px auto\"><div layout=\"column\" style=\"width: 100%\" layout-gt-xs=\"center start\"><div style=\"background-color: #1e95cb; height: 35px; padding: 8px;\"><span style=\"color: white; font-size: 15px;\">Informações pessoais</span></div><div class=\"md-padding\"><form name=\"responsible_form\"><div layout=\"row\" layout-align=\"space-between start\" flex=\"\"><div flex=\"{{ vm.form.person.is_deceased ? \'100\' : \'50\' }}\" style=\"margin-right: 4px;\"><a4-responsible-form person=\"vm.person_copy\" is-enabled=\"vm.form.mode_edit\" responsible-form=\"responsible_form\" block-form-email=\"vm.blockFormEmail\"></a4-responsible-form></div><div flex=\"50\" style=\"margin-left: 4px;\" ng-if=\"!vm.form.person.is_deceased\"><a4-responsible-contact-form person=\"vm.contact_copy\" responsible-form=\"responsible_form\" is-enabled=\"vm.form.mode_edit\"></a4-responsible-contact-form></div></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.submit(responsible_form, vm.person_copy)\" ng-disabled=\"!vm.form.mode_edit || vm.blockFormEmail || responsible_form.$invalid\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Salvar</md-button></div></form></div></div></md-card></div></md-tab><md-content class=\"md-padding\"><a4-responsible-contact-form person=\"vm.form.person\" is-enabled=\"vm.form.mode_edit\"></a4-responsible-contact-form><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.submit(vm.form.person)\" ng-disabled=\"!vm.form.mode_edit\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Salvar</md-button></div></md-content><md-tab label=\"Informações funcionais\" md-on-select=\"vm.reload()\" ng-disabled=\"vm.form.person.id == undefined\"><md-content class=\"md-padding\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(form, item)\" on-close=\"vm.close()\" fields-schema=\"app/educational/responsibles/form_info.json\"></a4-form-dic-data></md-content></md-tab><md-tab label=\"Dependentes\" md-on-select=\"vm.reload()\" ng-disabled=\"vm.form.person.id == undefined\"><md-content class=\"md-padding\"><div ui-view=\"dependents\"></div></md-content></md-tab><md-tab label=\"Ficha financeira\" md-on-select=\"vm.reload()\" ng-disabled=\"vm.form.person.id == undefined\" ng-if=\"vm.has_app_finance && !vm.checkPolicies(\'resp_financial\')\"><md-content class=\"md-padding\"><div ui-view=\"financial\"></div></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/responsibles/views/responsibles-wizard.html","<md-dialog aria-label=\"Create Subject\" style=\"max-width: 1500px;width: 1500px;\" md-theme=\"educational\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Assistente de Cadastro de Responsáveis</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" fields=\"vm.fields\" step-selected=\"vm.stepSelected\" on-submit=\"vm.submit(item, form, wizardItem)\" on-close=\"vm.close()\" on-finish-wizard=\"vm.finish(form)\" fields-schema=\"app/educational/responsibles/form-wizard.json\"></a4-form-dic-data></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/responsibles/views/responsibles.html","<div ui-view=\"responsibles\"></div>");
$templateCache.put("app/educational/rounding-criteria/views/dialog-rounding-criteria.html","<md-dialog aria-label=\"Mango (Fruit)\" md-theme=\"educational\"><md-toolbar><div class=\"md-toolbar-tools\"><h2></h2><span ng-if=\"vm.form.grade_round_rule.id == undefined\" flex=\"\">Novo critério de arredondamento</span> <span ng-if=\"vm.form.grade_round_rule.id != undefined\" flex=\"\">Atualizar critério de arredondamento</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><a4-form-dic-data bind=\"vm.form\" on-submit=\"vm.submitRoundingCriteria(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/rounding-criteria/form.json\"></a4-form-dic-data></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/rounding-criteria/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'ROUNDING_CRITERIA.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'ROUNDING_CRITERIA.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.filterEvaluationCriteriaList(vm.search)\" translate=\"\" translate-attr-placeholder=\"ROUNDING_CRITERIA.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-content><a4-form-dic-data bind=\"vm.grid\" on-submit=\"vm.submit(item, form)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editRoundingCriteria(item)\" on-delete=\"vm.delete(index)\" fields-schema=\"app/educational/rounding-criteria/grid.json\"></a4-form-dic-data></md-content></div>");
$templateCache.put("app/educational/rounding-criteria/views/rounding-criteria-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><a4-search-field url=\"/evaluation\" style=\"width: 100%\" on-change=\"vm.changeEvaluationCriteria(item)\" selected-item=\"vm.selected\" icon=\"icon-account-multiple\" placeholder=\"{{vm.form.grade_rule.name}}\"></a4-search-field></div><md-button ng-click=\"vm.deleteEvaluationCriteria(vm.selected.id)\" ng-show=\"vm.selected_tab == 0 && !vm.selected.block_delete && vm.selected.id\" class=\"md-icon-button btn-edit\" aria-label=\"delete\"><md-tooltip md-direction=\"bottom\">Remover</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-click=\"vm.ableEdit()\" class=\"md-icon-button btn-edit\" ng-show=\"vm.selected_tab == 0 || vm.selected_tab == 1 && vm.selected.id\" aria-label=\"EVALUATION_CRITERIA.EDIT\" translate-attr-aria-label=\"EVALUATION_CRITERIA.EDIT\"><md-tooltip><span ng-show=\"!vm.form.mode_edit\">Editar</span> <span ng-show=\"vm.form.mode_edit\">Cancelar Edição</span></md-tooltip><md-icon ng-show=\"!vm.form.mode_edit\" md-font-icon=\"icon-pencil\"></md-icon><md-icon ng-show=\"vm.form.mode_edit\" md-font-icon=\"icon-cancel\"></md-icon></md-button></div></md-toolbar><md-content class=\"btn-material-default md-padding\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Definições inicias\" md-on-select=\"vm.reload()\"><md-content class=\"md-padding\"><div layout=\"row\" align=\"start center\"><form name=\"gradeRuleForm\" class=\"evaluation-criteria\" ng-submit=\"vm.submitGradeRule(vm.form.grade_rule, gradeRuleForm)\"><div layout=\"row\"><div flex=\"\"><br><strong class=\"group-field\"><small>Definições iniciais</small></strong><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Nome</label> <input ng-model=\"vm.form.grade_rule.name\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><label>Nota média</label> <input ng-model=\"vm.form.grade_rule.pass_grade\"></md-input-container><md-input-container flex=\"\"><label>Nota máxima</label> <input ng-model=\"vm.form.grade_rule.max_grade\"></md-input-container><md-input-container flex=\"\"><label>Decimais</label> <input ng-model=\"vm.form.grade_rule.precision\"></md-input-container><md-input-container><label>Tipo de arredondamento</label><md-select ng-model=\"vm.form.grade_rule.grade_round_rule_id\"><md-option><em>Nenhum</em></md-option><md-option ng-repeat=\"round_rule in vm.list.grade_round_rule_item\" ng-value=\"round_rule.id\">{{round_rule.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"40\"><label>Qtd limite de recuperações</label> <input ng-model=\"vm.form.grade_rule.max_dependency_allowed\" maxlength=\"2\" pattern=\"\\d*\"></md-input-container></div></div><div flex=\"\"><br><strong class=\"group-field\"><small>Sistema de dependência / Progressão Parcial</small></strong><div layout=\"row\"><md-radio-group ng-model=\"vm.form.grade_rule.dependency_system\" ng-init=\"vm.form.grade_rule.dependency_system = 1\"><md-radio-button value=\"1\" class=\"md-primary\">Não utiliza</md-radio-button><md-radio-button value=\"2\">Dependência</md-radio-button><md-radio-button value=\"3\">Progressão Parcial</md-radio-button></md-radio-group><md-input-container class=\"md-block\" ng-show=\"vm.form.grade_rule.dependency_system == 3\" flex=\"\"><label>Qtd máxima permitida</label> <input ng-model=\"vm.form.grade_rule.max_dependency_allowed\" maxlength=\"2\" pattern=\"\\d*\"></md-input-container></div><div layout=\"row\"><md-switch ng-model=\"vm.form.grade_rule.is_horizontal_sub_calc\" aria-label=\"Conselho\" flex=\"\">Calcula subdisciplinas na horizontal.</md-switch></div><br><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\"><md-icon ng-show=\"!$root.show_loader\">close</md-icon>Cancelar</md-button><md-button type=\"submit\" class=\"md-raised submit-button\" ng-disabled=\"gradeRuleForm.$pristine || gradeRuleForm.$invalid || $root.show_loader\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\">check</md-icon>Salvar</md-button></div></div></div></form></div></md-content></md-tab><md-tab label=\"Configurações dos critérios\" ng-disabled=\"!vm.form.grade_rule.id\"><md-content class=\"md-padding\"><div layout=\"row\" align=\"start center\"><div flex=\"50\"><a4-ui-tree list=\"vm.list.grade_rule_items\" template=\"nodes_renderer\" actions=\"true\" actions-group=\"true\" action-add=\"vm.add(item)\" action-delete=\"vm.delete(item)\" action-select=\"vm.selectItem(item)\" insert-nodes=\"true\" only-children=\"true\" have-sub-nodes=\"false\" nodrop-enable=\"false\" max-nodes=\"2\" ng-show=\"vm.list.grade_rule_items.length\"></a4-ui-tree><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" ng-click=\"vm.addStep(vm.list.grade_rule_items)\"><md-icon>playlist_add</md-icon>Adicionar etapa de critério</md-button></div></div><form name=\"evaluationCriteriaForm\" class=\"evaluation-criteria\" ng-submit=\"vm.submitGradeRuleItem(vm.selected, evaluationCriteriaForm)\" flex=\"50\"><div layout=\"column\"><md-list-item class=\"config\" ng-init=\"vm.toggle = false;\" ng-click=\"vm.toggle = !vm.toggle\"><span flex=\"95\">Configurações</span> <span flex=\"5\"><md-icon ng-show=\"!vm.toggle\">expand_more</md-icon><md-icon ng-show=\"vm.toggle\">expand_less</md-icon></span></md-list-item><div class=\"section-group\" ng-show=\"vm.toggle\"><strong class=\"group-field\"><small>Configurações da regra</small></strong><md-switch ng-model=\"vm.selected.has_frequency\" aria-label=\"Frequência\">Possui controle de frequência.</md-switch><div layout=\"row\"><md-switch ng-model=\"vm.selected.show_on_grade\" ng-change=\"vm.selected.show_in_grafic = (vm.selected.show_on_grade) ? vm.selected.show_in_grafic : false\" aria-label=\"Boletim\" flex=\"\">Apresenta no boletim.</md-switch><md-input-container class=\"show-hide top-10\" ng-show=\"vm.selected.show_on_grade\" flex=\"\"><label>Título da coluna</label> <input ng-model=\"vm.selected.label\"></md-input-container></div><div layout=\"row\"><md-switch ng-model=\"vm.selected.show_on_school_records\" aria-label=\"Boletim\" flex=\"\">Apresenta no histórico.</md-switch></div><br><strong class=\"group-field\"><small>Definições do critério</small></strong><div layout=\"column\"><md-input-container class=\"md-block\"><label>Critério de conceito</label><md-select ng-model=\"vm.selected.grade_code_rule_id\"><md-option><em>Nenhum</em></md-option><md-option ng-repeat=\"code_rule in vm.list.grade_code_rule_item\" ng-value=\"code_rule.id\">{{code_rule.name}}</md-option></md-select></md-input-container><md-switch ng-disabled=\"true\" aria-label=\"Conselho\" class=\"md-block\">Aplicável mesmo se a disciplina não for de conceito</md-switch></div><br><strong class=\"group-field\"><small>Conselho de classe</small></strong><div layout=\"row\"><md-switch ng-model=\"vm.selected.has_class_council\" aria-label=\"Conselho\" flex=\"\">Possui conselho de classe.</md-switch></div></div><br><div><strong class=\"group-field\"><small>Definições da regra</small></strong><div layout=\"row\"><md-input-container flex=\"15\"><label>Código</label> <input ng-model=\"vm.selected.name\"></md-input-container><md-input-container class=\"md-inline-table\" flex=\"85\"><label>Descrição</label> <input ng-model=\"vm.selected.description\"></md-input-container></div><strong class=\"group-field gf-separete\"><small>Tipo de Evento</small></strong><div layout=\"column\"><md-radio-group ng-model=\"vm.type_event\" ng-init=\"vm.type_event = (vm.selected.conditional) ? \'L\' : \'C\'\"><md-radio-button value=\"L\" class=\"md-primary\">Evento lançado</md-radio-button><md-radio-button value=\"C\">Evento calculado</md-radio-button></md-radio-group></div><strong ng-show=\"vm.type_event == \'L\'\" class=\"group-field gf-separete\"><small>Fórmula condicional</small></strong><div layout=\"column\"><div class=\"md-block\" ng-show=\"vm.type_event == \'L\'\" ui-ace=\"\" ng-model=\"vm.selected.conditional\"></div></div><strong ng-show=\"vm.type_event == \'C\'\" class=\"group-field gf-separete\"><small>Fórmula do critério</small></strong><div layout=\"column\"><div class=\"md-block\" ng-show=\"vm.type_event == \'C\'\" ui-ace=\"{mode: \'pascal\'}\" ng-model=\"vm.selected.formula\"></div></div></div></div><div layout=\"row\"><strong class=\"group-field gf-separete\"><small>Outras definições</small><br><p>Os campos abaixo só devem ser preenchidos se for diferente das definições do critério.</p></strong></div><div layout=\"row\"><md-input-container flex=\"\"><label>Nota média</label> <input ng-model=\"vm.selected.pass_grade\"></md-input-container><md-input-container flex=\"\"><label>Nota máxima</label> <input ng-model=\"vm.selected.max_grade\"></md-input-container><md-input-container flex=\"\"><label>Decimais</label> <input ng-model=\"vm.selected.precision\"></md-input-container><md-input-container flex=\"\"><label>Tipo de arredondamento</label><md-select ng-model=\"vm.selected.grade_round_rule_id\"><md-option><em>Nenhum</em></md-option><md-option ng-repeat=\"round_rule in vm.list.grade_round_rule_item\" ng-value=\"round_rule.id\">{{round_rule.name}}</md-option></md-select></md-input-container></div><br><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\"><md-icon ng-show=\"!$root.show_loader\">close</md-icon>Cancelar</md-button><md-button type=\"submit\" class=\"md-raised submit-button\" ng-disabled=\"evaluationCriteriaForm.$pristine || evaluationCriteriaForm.$invalid || $root.show_loader\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\">check</md-icon>Salvar</md-button></div></form></div></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/rounding-criteria/views/rounding-criteria.html","<div ui-view=\"rounding-criteria\"></div>");
$templateCache.put("app/educational/school-period/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-check-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'SCHOOL_PERIOD.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'SCHOOL_PERIOD.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-change=\"vm.filterCourseList(vm.search)\" translate=\"\" translate-attr-placeholder=\"COURSE.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-card class=\"md-padding\" ng-if=\"!vm.checkPolicies(\'per_let_conf\')\"><div><strong class=\"group-field\"><small>Selecione por tipo de período</small></strong><div layout=\"row\" class=\"filter-release\"><md-radio-group ng-model=\"vm.school_period_serie\" layout=\"row\"><md-radio-button ng-if=\"item.is_selected\" ng-repeat=\"item in vm.school_period_series\" ng-value=\"item.id\" flex=\"50\">{{ item.matrix_period_name }}</md-radio-button></md-radio-group></div><md-divider></md-divider><br></div><a4-grid-dic-data bind=\"vm.grid\" on-submit=\"vm.submit(item, form)\" on-paginate=\"vm.getAllSchoolPeriod\" on-click-actions=\"vm.clickActions(item, option)\" on-click-item=\"vm.editSchoolPeriod(item)\" fields-schema=\"app/educational/school-period/grid.json\"></a4-grid-dic-data></md-card></div>");
$templateCache.put("app/educational/school-period/views/modal.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Criar Período Letivo</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editSchoolPeriod(item)\" fields-schema=\"app/educational/school-period/form.json\"></a4-form-dic-data></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/school-period/views/school-period.html","<div ui-view=\"school-period\"></div>");
$templateCache.put("app/educational/school-period-config/views/config.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-check-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">&nbsp;{{ \'SCHOOL_PERIOD_CONFIG.TITLE\' | translate }}</span></div></div></md-toolbar><md-content class=\"btn-material-default md-padding period-config\" ng-if=\"!vm.checkPolicies(\'per_let_conf\')\"><strong class=\"group-field\"><small>Defina os períodos letivos disponíveis para os cursos</small></strong><div layout=\"row\" layout-wrap=\"\" flex=\"\"><div flex=\"15\" layout=\"column\"><md-checkbox ng-repeat=\"item in vm.items\" ng-model=\"item.is_selected\" ng-change=\"vm.blockItems(item, item.id)\" ng-disabled=\"item.disabled\">{{ item.name }}</md-checkbox></div><div flex=\"15\"><md-input-container class=\"input-labels\" ng-repeat=\"item in vm.items\" md-no-float=\"\"><input ng-blur=\"vm.savePeriodConfig(vm.items)\" id=\"{{item.id}}\" ng-disabled=\"!item.is_selected\" ng-model=\"item.matrix_period_name\" placeholder=\"Título\"></md-input-container></div></div><br><br><div ng-show=\"vm.saving\"><md-button class=\"md-fab md-mini\"><md-icon>save</md-icon></md-button><span>Salvando...</span></div></md-content></div>");
$templateCache.put("app/educational/school-period-config/views/school-period-config.html","<div ui-view=\"school-period-config\"></div>");
$templateCache.put("app/educational/school-records-config/views/config-modal.html","<md-dialog aria-label=\"Configuração de histórico\" md-theme=\"educational\" style=\"width: 980px;\" id=\"modalConfig\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Configuração de histórico</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form ng-cloak=\"\" name=\"formConfig\" ng-submit=\"vm.submit()\"><md-tabs md-dynamic-height=\"\" md-selected=\"currentTab\"><md-tab id=\"header_config\" label=\"Cabeçalho e rodapé\"><md-dialog-content><md-input-container style=\"margin: 0 0 0 -9px; padding-top: 5px;\"><md-checkbox ng-model=\"vm.config.sr_has_header\">Imprime cabeçalho</md-checkbox></md-input-container><div ng-if=\"vm.config.sr_has_header\"><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><textarea type=\"text\" ng-model=\"vm.config.sr_header\" rows=\"4\" placeholder=\"Texto do cabeçalho\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\" style=\"margin-left: 10px; margin-top: -5px;\"><label>Recursos disponíveis:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_certificate\" ng-change=\"vm.setVariable(\'sr_header\',vm.variable_certificate)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.header_footer_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><textarea type=\"text\" ng-model=\"vm.config.sr_footer\" rows=\"4\" placeholder=\"Texto do rodapé (cada linha é uma assinatura)\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\" style=\"margin-left: 10px;\"><label>Recursos disponíveis:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_certificate\" ng-change=\"vm.setVariable(\'sr_footer\',vm.variable_certificate)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.header_footer_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div></div><div ng-if=\"!vm.config.sr_has_header\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%;\"><label>Margem superior (em cm)</label> <input ng-model=\"vm.config.sr_header_space\" type=\"number\"></md-input-container></div></md-dialog-content></md-tab><md-tab id=\"observations_config\" label=\"Observações gerais\"><md-dialog-content><md-input-container style=\"margin: 0 0 0 -9px; padding-top: 5px;\"><md-checkbox ng-model=\"vm.config.sr_has_general_notes\">Imprime observação geral para todos os alunos</md-checkbox></md-input-container><div ng-if=\"vm.config.sr_has_general_notes\"><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><textarea type=\"text\" ng-model=\"vm.config.sr_general_notes\" rows=\"4\" placeholder=\"Observação geral\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\" style=\"margin-left: 10px;\"><label>Recursos disponíveis:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_observation\" ng-change=\"vm.setVariable(\'sr_general_notes\',vm.variable_observation)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.general_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div></div></md-dialog-content></md-tab><md-tab id=\"certificate_config\" label=\"Certificado\"><md-dialog-content><md-input-container><md-radio-group ng-model=\"vm.config.sr_certificate_option\" layout=\"row\"><md-radio-button ng-value=\"0\">Nunca imprime certificado</md-radio-button><md-radio-button ng-value=\"1\">Sempre imprime certificado</md-radio-button><md-radio-button ng-value=\"2\">Pergunta ao usuário no momento da impressão</md-radio-button></md-radio-group></md-input-container><div ng-if=\"vm.config.sr_certificate_option !== 0\"><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><textarea type=\"text\" ng-model=\"vm.config.sr_certificate\" rows=\"4\" placeholder=\"Certificado\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\" style=\"margin-left: 10px;\"><label>Recursos disponíveis:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_certificate\" ng-change=\"vm.setVariable(\'sr_certificate\',vm.variable_certificate)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.general_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div></div></md-dialog-content></md-tab><md-tab id=\"message_config\" label=\"Mensagem de reprovação\"><md-dialog-content><md-input-container style=\"margin: 0 0 0 -9px; padding-top: 5px;\"><md-checkbox ng-model=\"vm.config.sr_has_fail_message\">Imprime mensagem de reprovação nas observações</md-checkbox></md-input-container><div ng-if=\"vm.config.sr_has_fail_message\"><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><textarea type=\"text\" ng-model=\"vm.config.sr_fail_message\" rows=\"4\" placeholder=\"Mensagem de reprovação\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\" style=\"margin-left: 10px;\"><label>Recursos disponíveis:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_repprovation\" ng-change=\"vm.setVariable(\'sr_fail_message\',vm.variable_repprovation)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.general_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div></div></md-dialog-content></md-tab><md-tab id=\"code_config\" label=\"Código de segurança\"><md-dialog-content><md-input-container style=\"margin: 0 0 0 -9px; padding-top: 5px;\"><md-checkbox ng-model=\"vm.config.sr_has_security_code\">Imprime código de segurança</md-checkbox></md-input-container><div ng-if=\"vm.config.sr_has_security_code\" layout=\"column\"><md-input-container class=\"md-input-has-placeholder\"><input ng-model=\"vm.config.sr_security_code_act\" placeholder=\"Número do ato que autorizou o funcionamento da escola\"></md-input-container><md-input-container class=\"md-input-has-placeholder\"><input ng-model=\"vm.config.sr_security_code_act_year\" placeholder=\"Ano do ato\"></md-input-container></div></md-dialog-content></md-tab></md-tabs><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" class=\"send-button md-accent md-raised\" layout=\"row\" ng-disabled=\"vm.show_loading\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/school-records-config/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-book-open\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'SCHOOL_RECORDS_CONFIG.TITLE\' | translate }}</span></div></div></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-selected=\"vm.currentTab\" flex=\"100\"><md-tab id=\"general\" label=\"Configurações gerais\"><form ng-cloak=\"\" name=\"formConfig\" ng-submit=\"vm.submit()\"><md-card class=\"md-padding\" style=\"position: sticky\"><div flex=\"\"><md-button type=\"submit\" class=\"md-raised md-primary\">Salvar configuração gerais do histórico</md-button></div></md-card><md-card class=\"md-padding\"><div style=\"background-color: whitesmoke; border-left: solid 4px rgb(3,169,244);\"><h2 style=\"margin-left: 3px; padding: 3px;\">Cabeçalho e rodapé</h2></div><md-input-container><md-checkbox ng-model=\"vm.config.sr_has_header\">Imprime cabeçalho</md-checkbox><md-checkbox ng-model=\"vm.config.sr_has_footer\">Imprime rodapé</md-checkbox></md-input-container><div ng-if=\"vm.config.sr_has_header\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%\"><textarea type=\"text\" ng-model=\"vm.config.sr_header\" rows=\"4\" name=\"sr_header\" placeholder=\"Texto do cabeçalho\" class=\"textareaheader\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\"><label>Variáveis de texto:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_certificate\" ng-change=\"vm.setVariable(\'sr_header\',vm.variable_certificate)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.header_footer_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div></div><div ng-if=\"vm.config.sr_has_footer\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%\"><textarea type=\"text\" ng-model=\"vm.config.sr_footer\" rows=\"2\" name=\"sr_footer\" placeholder=\"Texto do rodapé <br> Cada linha é uma assinatura, coloque | caso queira colocar diferentes nomes embaixo da mesma linha. Para não exibir rodapé, preencha com _\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\"><label>Variáveis de texto:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_certificate\" ng-change=\"vm.setVariable(\'sr_footer\',vm.variable_certificate)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.header_footer_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div></div><div ng-if=\"!vm.config.sr_has_header\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%\"><label>Margem superior (em cm)</label> <input ng-model=\"vm.config.sr_header_space\" type=\"number\" step=\"0.1\"></md-input-container></div></md-card><md-divider></md-divider><md-card class=\"md-padding\"><div style=\"background-color: whitesmoke; border-left: solid 4px rgb(3,169,244);\"><h2 style=\"margin-left: 3px; padding: 3px;\">Observações gerais</h2></div><md-input-container><md-checkbox ng-model=\"vm.config.sr_has_general_notes\">Imprime observação geral para todos os alunos</md-checkbox></md-input-container><div ng-if=\"vm.config.sr_has_general_notes\"><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><textarea type=\"text\" ng-model=\"vm.config.sr_general_notes\" rows=\"2\" name=\"sr_general_notes\" placeholder=\"Observação geral\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\"><label>Variáveis de texto:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_observation\" ng-change=\"vm.setVariable(\'sr_general_notes\',vm.variable_observation)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.general_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div></div></md-card><md-divider></md-divider><md-card class=\"md-padding\"><div style=\"background-color: whitesmoke; border-left: solid 4px rgb(3,169,244);\"><h2 style=\"margin-left: 3px; padding: 3px;\">Certificado</h2></div><md-input-container><md-radio-group ng-model=\"vm.config.sr_certificate_option\" layout=\"row\"><md-radio-button ng-value=\"0\">Nunca imprime certificado</md-radio-button><md-radio-button ng-value=\"1\">Sempre imprime certificado</md-radio-button><md-radio-button ng-value=\"2\">Pergunta ao usuário no momento da impressão</md-radio-button></md-radio-group></md-input-container><div ng-if=\"vm.config.sr_certificate_option !== 0\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%\"><textarea type=\"text\" ng-model=\"vm.config.sr_certificate\" rows=\"2\" name=\"sr_certificate\" placeholder=\"Certificado\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\"><label>Variáveis de texto:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_certificate\" ng-change=\"vm.setVariable(\'sr_certificate\',vm.variable_certificate)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.general_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div></div></md-card><md-divider></md-divider><md-card class=\"md-padding\"><div style=\"background-color: whitesmoke; border-left: solid 4px rgb(3,169,244);\"><h2 style=\"margin-left: 3px; padding: 3px;\">Mensagem de reprovação</h2></div><md-input-container><md-checkbox ng-model=\"vm.config.sr_has_fail_message\">Imprime mensagem de reprovação nas observações</md-checkbox></md-input-container><div ng-if=\"vm.config.sr_has_fail_message\"><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%\"><textarea type=\"text\" ng-model=\"vm.config.sr_fail_message\" rows=\"2\" name=\"sr_fail_message\" placeholder=\"Mensagem de reprovação\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\"><label>Variáveis de texto:</label><md-input-container flex=\"30\"><md-select name=\"variables\" ng-model=\"vm.variable_repprovation\" ng-change=\"vm.setVariable(\'sr_fail_message\',vm.variable_repprovation)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.general_variables\">{{item.presentation}}</md-option></md-select></md-input-container></div></div></md-card><md-divider></md-divider><md-card class=\"md-padding\"><div style=\"background-color: whitesmoke; border-left: solid 4px rgb(3,169,244);\"><h2 style=\"margin-left: 3px; padding: 3px;\">Código de segurança</h2></div><md-input-container><md-checkbox ng-model=\"vm.config.sr_has_security_code\">Imprime código de segurança</md-checkbox></md-input-container><div ng-if=\"vm.config.sr_has_security_code\" layout=\"column\"><md-input-container class=\"md-input-has-placeholder\"><input ng-model=\"vm.config.sr_security_code_act\" placeholder=\"Número do ato que autorizou o funcionamento da escola\" ng-change=\"vm.limitInputSize(vm.config.sr_security_code_act, \'sr_security_code_act\', 5)\"></md-input-container><md-input-container class=\"md-input-has-placeholder\"><input ng-model=\"vm.config.sr_security_code_act_year\" placeholder=\"Ano do ato\" type=\"number\" ng-change=\"vm.limitInputSize(vm.config.sr_security_code_act_year, \'sr_security_code_act_year\', 4)\"></md-input-container></div></md-card></form></md-tab><md-tab id=\"order\" label=\"Configuração de ordem das disciplinas\"><div layout=\"row\" layout-align=\"start center\" layout-padding=\"\"><md-input-container flex=\"30\"><label>Selecione os históricos para configuração de disciplinas</label><md-select ng-model=\"vm.school_records_selected\" ng-change=\"vm.selectSubjectSchoolRecords(vm.school_records_selected.type)\"><md-option ng-repeat=\"option in vm.school_records.types track by $index\" ng-value=\"option\">{{option.name}}</md-option></md-select></md-input-container><div flex=\"\"><md-button ng-disabled=\"vm.school_records_selected.length == 0\" ng-click=\"vm.updateSchoolRecordsSubjectConfig(vm.classification)\" class=\"md-raised\">Salvar configuração de disciplinas do histórico</md-button></div></div><div class=\"group-table-school-records\" layout-padding=\"\"><div ng-if=\"vm.school_records_selected.type\"><div layout=\"row\" layout-align=\"space-between center\"><div><h3>Configurar disciplinas do histórico do {{vm.school_records_selected.name}}</h3></div><div></div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"trees\"><a4-ui-tree list=\"vm.classification\" template=\"nodes_renderer\" actions=\"false\" actions-group=\"false\" insert-nodes=\"true\" clone-enable=\"true\" only-children=\"true\" only-group=\"\'subject_classification_id\'\" max-nodes=\"3\"></a4-ui-tree></div></div></div></div></md-tab></md-tabs></div>");
$templateCache.put("app/educational/settings/views/change-teacher-modal.html","<md-dialog aria-label=\"Troca de professor\" md-theme=\"educational\" style=\"width: 700px;\"><form ng-cloak=\"\" name=\"formChangeTeacher\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><md-icon md-font-icon=\"icon-account-switch\" class=\"icon-64\"></md-icon>Troca de professor</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><date-picker placeholder=\"Data da troca\" ng-model=\"vm.form.dateChange\"></date-picker><div layout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 15px;\"><div layout=\"column\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244);\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Professor(a) antigo</b> <small>Selecione o professor(a) que será substituído</small></div></div><md-autocomplete flex=\"\" md-input-name=\"oldteacher\" md-input-minlength=\"2\" md-no-cache=\"false\" md-delay=\"1000\" md-selected-item=\"vm.form.oldTeacher\" md-search-text=\"searchTextOld\" md-items=\"item in vm.getTeachers(searchTextOld)\" md-selected-item-change=\"vm.getClassesFromTeacher(vm.form.oldTeacher)\" md-item-text=\"item.name\" md-floating-label=\"Professor(a) antigo\" required=\"\"><md-item-template><span md-highlight-text=\"searchTextCharger\">{{item.name}}</span></md-item-template></md-autocomplete></div><div layout=\"column\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Professor(a) novo</b> <small>Selecione o novo professor(a) das classes selecionadas</small></div></div><md-autocomplete flex=\"\" md-input-name=\"newteacher\" md-input-minlength=\"2\" md-no-cache=\"false\" md-delay=\"1000\" md-selected-item=\"vm.form.newTeacher\" md-search-text=\"searchTextNew\" md-items=\"item in vm.getTeachers(searchTextNew)\" md-item-text=\"item.name\" md-floating-label=\"Professor(a) novo\" required=\"\"><md-item-template><span md-highlight-text=\"searchTextCharger\">{{item.name}}</span></md-item-template></md-autocomplete></div></div><md-progress-circular style=\"margin-left: 45%\" ng-if=\"vm.showLoaderClasses\" md-diameter=\"50px\"></md-progress-circular><div ng-if=\"vm.classes !== null\"><div ng-if=\"vm.classes.length > 0\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Classes do professor(a) {{vm.form.oldTeacher.name}}</b> <small>Selecione abaixo as classes que terão o professor(a) trocado</small></div></div><md-list><md-list-item><p>SELECIONAR TODOS</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.toggleAll\" ng-click=\"vm.manageToggleAll(vm.toggleAll);\"></md-checkbox></md-list-item><md-divider></md-divider><md-list-item ng-repeat=\"classItem in vm.classes\"><p>Curso: <strong>{{ classItem.course_name }}</strong> Turma: <strong>{{ classItem.group_name }}</strong> <span ng-if=\"classItem.matrix_period > 1\">[{{classItem.matrix_period}}]</span> Disciplina: <strong>{{ classItem.subject_name }}</strong></p><md-checkbox class=\"md-secondary\" ng-model=\"classItem.selected\" ng-checked=\"vm.isClassSelected(classItem)\" ng-click=\"vm.addOrRemoveSelectedClass(classItem)\"></md-checkbox><md-divider></md-divider></md-list-item></md-list></div><md-card class=\"md-padding\" style=\"width: 100%; background-color: rgba(59,132,209,0.92); color: white\" ng-if=\"vm.classes.length === 0\">O professor selecionado não possui classes no período letivo corrente.</md-card></div><md-card class=\"md-padding\" style=\"width: 100%; background-color: rgba(59,132,209,0.92); color: white\" ng-if=\"vm.form.oldTeacher === null\">Selecione o professor antigo para selecionar as classes que serão alteradas</md-card></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" ng-click=\"vm.submit()\" layout=\"row\" class=\"send-button md-accent md-raised\" ng-disabled=\"formChangeTeacher.$invalid || vm.showLoaderSubmit || vm.form.selectedClasses.length === 0 || vm.form.oldTeacher.id === vm.form.newTeacher.id\" aria-label=\"Add Task\"><md-progress-circular ng-disabled=\"!vm.showLoaderSubmit\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"92\">Realizar troca</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/settings/views/data-export-set.html","<md-dialog aria-label=\"Exportação de dados SET\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Exportação de dados SET</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\" ng-disabled=\"vm.isProcessing\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div>Esta ação irá exportar um arquivo TXT com a lista de todos os alunos <b>MATRICULADOS</b> da escola na empresa selecionada.</div><h2 style=\"text-align: center\">Atenção, essa ação será executada apenas para alunos matriculados!</h2><div layout=\"row\" layout-align=\"center center\"><md-input-container><label>Código da escola</label> <input type=\"number\" ng-model=\"vm.institution_number\"></md-input-container><md-input-container><label>Sequencial do arquivo</label> <input type=\"number\" ng-model=\"vm.file_sequence\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.course_id\" ng-change=\"vm.getGroups(vm.course_id)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course.id\">{{course.name}}</md-option><md-option ng-value=\"0\">Todos os cursos</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_id\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option><md-option ng-if=\"((vm.groups.length === 0 || vm.groups === null) && vm.print.course_selected !== null)\" value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.only_with_cpf\">Apenas alunos com CPF</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.with_primary\">Inserir ensino infantil</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.only_after_date\">Matrículas à partir de:</md-checkbox></md-input-container><date-picker ng-model=\"vm.enrolment_date_after\" ng-if=\"vm.only_after_date\"></date-picker></div><div class=\"md-dialog-content\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-warm\" type=\"button\" ng-click=\"vm.generateTXT()\" ng-disabled=\"vm.isProcessing || vm.institution_number === null || vm.file_sequence === null || (vm.only_after_date && vm.enrolment_date_after === null)\">Exportar para arquivo TXT</md-button><md-button class=\"md-raised md-warm\" type=\"button\" ng-click=\"vm.printReport()\" ng-disabled=\"vm.isProcessing || vm.institution_number === null || vm.file_sequence === null || (vm.only_after_date && vm.enrolment_date_after === null)\">Gerar relatório dos alunos</md-button></div><md-progress-linear ng-if=\"vm.isProcessing\" md-mode=\"indeterminate\"></md-progress-linear></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/settings/views/email-config.html","<md-dialog md-theme=\"{{vm.scope.theme}}\" style=\"width: 500px;\"><form name=\"roleForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-toolbar-tools\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Configuração de e-mail</span></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"\"><div layout=\"column\" ng-if=\"vm.scope.theme === \'educational\'\"><md-input-container class=\"md-icon-float md-block\" flex=\"\"><label>Nome do remetente</label> <input aria-label=\"Nome do remetente\" ng-model=\"vm.scope.company.email_academic_sender_name\" type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\" flex=\"\"><label>E-mail de retorno</label> <input aria-label=\"E-mail de retorno\" ng-model=\"vm.scope.company.email_academic_reply\" type=\"email\"></md-input-container></div><div layout=\"column\" ng-if=\"vm.scope.theme === \'finance\'\"><md-input-container class=\"md-icon-float md-block\" flex=\"\"><label>Nome do remetente</label> <input aria-label=\"Nome do remetente\" ng-model=\"vm.scope.company.email_finance_sender_name\" type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\" flex=\"\"><label>E-mail de retorno</label> <input aria-label=\"E-mail de retorno\" ng-model=\"vm.scope.company.email_finance_reply\" type=\"email\"></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button><md-button type=\"submit\" ng-click=\"vm.answer(vm.scope.company)\" class=\"send-button md-accent md-raised\" ng-disabled=\"!roleForm.$valid\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/settings/views/enrolment-configuration.html","<md-dialog aria-label=\"Configuração de matrícula\" md-theme=\"educational\" style=\"width: 600px;\"><form ng-cloak=\"\" name=\"enrolment_config_form\" novalidate=\"\" ng-submit=\"vm.saveConfig(enrolment_config_form, vm.enrolment_config)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-cog\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Configuração de matrícula</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_loading || vm.show_saving\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" style=\"color: white\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 15px;\"><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 100px;margin-bottom: 100px\" ng-if=\"vm.show_loading\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><md-content style=\"height: 500px; margin: 15px;\" ng-if=\"!vm.show_loading\"><div><b>Configuração de matrícula</b></div><small>Esta configuração abaixo se refere ao ato da matrícula</small><hr><md-input-container style=\"margin-top: 0 !important;\"><md-checkbox ng-model=\"vm.enrolment_config.enrolment_block_by_payment_default\">Bloqueia matrícula de aluno inadimplente (essa configuração não se aplica à matrícula online)</md-checkbox><md-checkbox ng-model=\"vm.enrolment_config.is_capacity_limit\">Bloqueia matrícula em turmas além da capacidade de vagas</md-checkbox></md-input-container><hr><div><b>Configuração de boletos gerados na matrícula</b></div><small>Esta configuração abaixo se refere a impressão de boletos ao termino da matrícula</small><hr><div layout=\"column\"><md-radio-group ng-model=\"vm.enrolment_config.enrolment_bank_slip_type\"><md-radio-button value=\"0\">Não gera boleto na matrícula</md-radio-button><md-radio-button value=\"1\">Apenas uma parcela</md-radio-button><md-radio-button value=\"2\">Uma faixa de parcelas</md-radio-button><md-radio-button value=\"3\">De uma parcela para frente</md-radio-button><md-radio-button value=\"4\">Gera carnê</md-radio-button></md-radio-group><div layout=\"row\" ng-if=\"vm.enrolment_config.enrolment_bank_slip_type == 1\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Apenas a parcela?</label> <input ng-model=\"vm.enrolment_config.enrolment_bank_slip_number_initial\" ng-required=\"vm.enrolment_config.enrolment_bank_slip_type == 1\" ui-hide-group-sep=\"\" ui-number-mask=\"0\" max=\"99\" name=\"onlyone\"><div ng-messages=\"enrolment_config_form.onlyone.$error\"><div ng-message=\"max\">Por favor, um valor até no maximo 99.</div><div ng-message=\"required\">Por favor, este campo é obrigatório.</div></div></md-input-container></div><div layout=\"row\" ng-if=\"vm.enrolment_config.enrolment_bank_slip_type == 2\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Da parcela?</label> <input ng-model=\"vm.enrolment_config.enrolment_bank_slip_number_initial\" ng-required=\"vm.enrolment_config.enrolment_bank_slip_type == 2\" ui-hide-group-sep=\"\" ui-number-mask=\"0\" max=\"99\" name=\"from\"><div ng-messages=\"enrolment_config_form.from.$error\"><div ng-message=\"max\">Por favor, um valor até no maximo 99.</div><div ng-message=\"required\">Por favor, este campo é obrigatório.</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Até a parcela?</label> <input ng-model=\"vm.enrolment_config.enrolment_bank_slip_number_final\" ng-required=\"vm.enrolment_config.enrolment_bank_slip_type == 2\" ui-hide-group-sep=\"\" ui-number-mask=\"0\" max=\"99\" name=\"until\"><div ng-messages=\"enrolment_config_form.until.$error\"><div ng-message=\"max\">Por favor, um valor até no maximo 99.</div><div ng-message=\"required\">Por favor, este campo é obrigatório.</div></div></md-input-container></div><div layout=\"row\" ng-if=\"vm.enrolment_config.enrolment_bank_slip_type == 3\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>A partir da?</label> <input ng-model=\"vm.enrolment_config.enrolment_bank_slip_number_initial\" ng-required=\"vm.enrolment_config.enrolment_bank_slip_type == 3\" ui-hide-group-sep=\"\" ui-number-mask=\"0\" max=\"99\" name=\"fromof\"><div ng-messages=\"enrolment_config_form.fromof.$error\"><div ng-message=\"max\">Por favor, um valor até no maximo 99.</div><div ng-message=\"required\">Por favor, este campo é obrigatório.</div></div></md-input-container></div><hr ng-if=\"vm.enrolment_config.enrolment_bank_slip_type == 0\"></div><div><b>Periodo da Matrícula Online</b></div><small>Defina abaixo a faixa de datas para permitir a matricula online</small><hr><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><date-picker ng-model=\"vm.enrolment_config.enrolment_online_initial_date\" flex=\"\" name=\"initial_date\" placeholder=\"Data inicial\"></date-picker><div ng-messages=\"enrolment_config_form.initial_date.$error\"><div ng-message=\"date\">Por favor, insira uma data válida.</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><date-picker ng-model=\"vm.enrolment_config.enrolment_online_final_date\" placeholder=\"Data final\" flex=\"\" name=\"final_date\"></date-picker><div ng-messages=\"enrolment_config_form.final_date.$error\"><div ng-message=\"date\">Por favor, insira uma data válida.</div></div></md-input-container></div><br><md-input-container><md-checkbox ng-model=\"vm.enrolment_config.enrolment_online_is_electronic_signature\">Assinatura eletrônica de contrato</md-checkbox></md-input-container><hr><div><b>Boleto na matrícula online</b></div><hr><md-radio-group ng-model=\"vm.enrolment_config.enrolment_online_bank_slip_type\"><md-radio-button ng-value=\"0\">Não gera boleto na matrícula online</md-radio-button><md-radio-button ng-value=\"1\">Gera boleto da primeira parcela</md-radio-button></md-radio-group><hr><div><b>Ficha de matrícula na matrícula online</b></div><hr><md-radio-group ng-model=\"vm.enrolment_config.enrolment_online_enrolment_form_type\"><md-radio-button ng-value=\"0\">Não permite a impressão</md-radio-button><md-radio-button ng-value=\"1\">Permite a impressão da ficha de matrícula</md-radio-button></md-radio-group></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"submit\" ng-disabled=\"vm.show_loading || vm.show_saving || enrolment_config_form.$invalid\" layout=\"row\"><md-progress-circular ng-if=\"vm.show_saving\" flex=\"15\" class=\"md-hue-2\" md-mode=\"indeterminate\" md-diameter=\"15\" style=\"margin-right: 8px;\"></md-progress-circular><span flex=\"\">Salvar configurações</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/settings/views/file-batch.html","<md-dialog aria-label=\"Importar fotos em lote\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Importar imagens</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div>As imagens devem ser comprimidas em um arquivo ZIP para serem enviadas</div><div>Cada imagem dentro do arquivo deve conter o número de matrícula do aluno. EX: 2000.jpg, 2001.png</div><div class=\"md-dialog-content\"><div flex=\"\" style=\"min-width: 500px\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div><md-progress-linear ng-if=\"vm.isProcessing\" md-mode=\"determinate\" value=\"{{vm.determinateValue}}\"></md-progress-linear></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/settings/views/grade-report-configuration.html","<md-dialog aria-label=\"Boletim escolar\" md-theme=\"educational\" style=\"width: 600px;\"><form ng-cloak=\"\" name=\"grade_report_config_form\" novalidate=\"\" ng-submit=\"vm.saveConfig(grade_report_config_form, vm.grade_report_config)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-library-books\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Boletim escolar</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_loading || vm.show_saving\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" style=\"color: white\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 15px;\"><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 100px;margin-bottom: 100px\" ng-if=\"vm.show_loading\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><md-content style=\"height: 200px; margin: 15px;\" ng-if=\"!vm.show_loading\"><div><b>Configuração de boletim escolar</b></div><small>Esta configuração abaixo se refere ao acesso ao link de boletim externo</small><hr><md-input-container style=\"margin-top: 0 !important;\"><md-checkbox ng-model=\"vm.grade_report_config.block_external_grade_report_link\">Bloqueia o acesso ao link de boletim externo</md-checkbox></md-input-container></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"submit\" ng-disabled=\"vm.show_loading || vm.show_saving || grade_report_config_form.$invalid\" layout=\"row\"><md-progress-circular ng-if=\"vm.show_saving\" flex=\"15\" class=\"md-hue-2\" md-mode=\"indeterminate\" md-diameter=\"15\" style=\"margin-right: 8px;\"></md-progress-circular><span flex=\"\">Salvar configurações</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/settings/views/index.html","<md-content id=\"boards\" class=\"md-accent-bg educational\" layout=\"column\" flex=\"\"><div id=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1 translate=\"SETTINGS.TITLE\">Configurações</h1><div class=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-click=\"vm.openGradeReportConfiguration()\" policy-access=\"aluno_boletim\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-library-books\" class=\"icon s64\"></md-icon><div class=\"board-name\">Boletim escolar</div></div><div class=\"board-list-item\" ui-sref=\"private.educational.students-records-messages\" policy-access=\"msg_boletim\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"icon s64\"></md-icon><div class=\"board-name\">Mensagens dos boletins</div></div><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ui-sref=\"{{board.state}}\" ng-if=\"board.policy\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"{{board.icon}}\" class=\"icon s64\"></md-icon><div class=\"board-name\">{{board.name}}</div></div><div class=\"board-list-item\" ng-click=\"vm.openEnrolmentConfiguration()\" policy-access=\"enrolment_config\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-cog\" class=\"icon s64\"></md-icon><div class=\"board-name\">Configuração de Matrícula</div></div><div class=\"board-list-item\" ng-click=\"vm.openEmailConfig()\" policy-access=\"email_config\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-email\" class=\"icon s64\"></md-icon><div class=\"board-name\">Configuração de e-mail</div></div></div><h1>Ferramentas</h1><div class=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-click=\"vm.openConfigurationForFileBatch()\" policy-access=\"import_img\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-image\" class=\"icon s64\"></md-icon><div class=\"board-name\">Importação de imagem em lote</div></div><div class=\"board-list-item\" ng-click=\"vm.renumberStudents()\" policy-access=\"turma_hor_alt\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-repeat-once\" class=\"icon s64\"></md-icon><div class=\"board-name\">Reordenar alunos</div></div><div class=\"board-list-item\" ng-click=\"vm.openChangeTeacher()\" policy-access=\"turma_hor_alt\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-account-switch\" class=\"icon s64\"></md-icon><div class=\"board-name\">Troca de professor</div></div><div class=\"board-list-item\" ng-click=\"vm.openDataExportForSET()\" policy-access=\"export_set\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-export\" class=\"icon s64\"></md-icon><div class=\"board-name\">Exportar arquivo de dados [SET]</div></div><div class=\"board-list-item\" ng-click=\"vm.createOrUpdateAgendaEdu()\" ng-if=\"vm.show_agendaedu_sync\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-sync\" class=\"icon s64\"></md-icon><div class=\"board-name\">Sincronização AgendaEdu</div></div></div></div></md-content>");
$templateCache.put("app/educational/settings/views/renumber-students.html","<md-dialog aria-label=\"Importar fotos em lote\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Reordenar estudantes</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\" ng-disabled=\"vm.isProcessing\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div>Esta ação irá gerar novos números para os alunos dentro de suas respectivas turmas de acordo com ordenação alfabética.</div><h2 style=\"text-align: center\">Atenção, essa ação será executada em todas as turmas!</h2><div class=\"md-dialog-content\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-warm\" type=\"button\" ng-click=\"vm.submit()\" ng-disabled=\"vm.isProcessing\">Reordenar</md-button></div><md-progress-linear ng-if=\"vm.isProcessing\" md-mode=\"indeterminate\"></md-progress-linear></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/students/views/cancel-reason-edit.html","<md-dialog aria-label=\"Edição de cancelamento\" md-theme=\"educational\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-account-box\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Edição do cancelamento de matrícula</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Informações do cancelamento</b> <small>Detalhes do cancelamento da matrícula</small></div></div><hr><div layout=\"row\"><date-picker ng-model=\"vm.scope.student.cancel_date\" flex=\"\" placeholder=\"Data do cancelamento\" required=\"\"></date-picker><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Razão do cancelamento</label><md-select name=\"cancel_reasons\" ng-model=\"vm.scope.student.enrolment_cancel_reason_id\" required=\"\"><md-option ng-repeat=\"reason in vm.scope.cancelReasons\" ng-value=\"reason.id\">{{reason.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label><md-icon md-font-icon=\"icon-pencil\"></md-icon>Observações</label> <textarea type=\"text\" name=\"observations\" ng-model=\"vm.scope.student.notes\" rows=\"2\"></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-raised\" ng-click=\"vm.closeModal()\">Fechar</md-button><md-button ng-click=\"vm.answer(vm.scope.student)\" class=\"md-primary md-raised\" layout=\"row\" ng-disabled=\"form.$invalid || vm.disableButton\"><md-progress-circular ng-disabled=\"!vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"95\">Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/views/edit-image.html","<md-dialog md-theme=\"educational\" class=\"edit-image-dialog\" aria-label=\"{{ \'UPLOAD_IMAGE.EDIT\' | translate }}\"><md-toolbar class=\"md-accent md-tall _md layout-column _md-toolbar-transitions\" layout=\"column\"><div class=\"md-toolbar-tools\"><h1>{{ \'UPLOAD_IMAGE.EDIT\' | translate }}</h1><span flex=\"\"></span><md-button class=\"md-icon-button md-button ng-scope md-ink-ripple md-default-theme\" ng-click=\"vm.closeModal();\"><md-icon aria-label=\"Close dialog\"><i class=\"material-icons\">close</i></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle layout-align-center-center layout-column flex\" flex=\"\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" class=\"layout-align-center-center layout-column\" flex=\"100\"><img class=\"md-avatar avatar contact-avatar huge\" src=\"{{ vm.last_photo }}\" ng-src=\"{{ vm.myCroppedImage }}\"></div><div layout=\"row\" policy-access=\"aluno_alt\"><div layout=\"row\" layout-align=\"center center\" class=\"layout-align-center-center layout-column\" flex=\"\"><input id=\"file-avatar\" type=\"file\" class=\"inputfile\" custom-on-change=\"vm.selectImage\"> <label for=\"file-avatar\"><md-button class=\"md-fab md-mini md-hue-2 no-events\" aria-label=\"{{ \'UPLOAD_IMAGE.SELECT\' | translate }}\"><md-icon><i class=\"material-icons\">file_upload</i></md-icon><md-tooltip md-direction=\"top\">Enviar do pc</md-tooltip></md-button></label><md-button class=\"md-fab md-mini md-hue-2\" style=\"position: relative; top: 10px;\" ng-click=\"vm.deleteImage()\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></md-toolbar><md-dialog-content ng-show=\"vm.myCroppedImage\"><div class=\"cropArea\"><ui-cropper image=\"vm.myImage\" area-type=\"square\" chargement=\"\'Loading\'\" result-image=\"vm.myCroppedImage\" result-image-format=\"vm.imageFormat\" result-image-size=\"{w:300,h:300}\" canvas-scalemode=\"true\"></ui-cropper></div></md-dialog-content><md-dialog-actions layout=\"row\" policy-access=\"aluno_alt\"><span flex=\"\"></span><md-button ng-click=\"vm.submit(vm.myCroppedImage)\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/educational/students/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"max-height: 100%; overflow: auto;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'STUDENTS.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'STUDENTS.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.paginate(vm.currentTab === 1, 1, vm.search)\" translate=\"\" translate-attr-placeholder=\"STUDENTS.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar></div><md-tabs md-dynamic-height=\"\" md-selected=\"vm.currentTab\" flex=\"100\"><md-tab id=\"enrolment\" label=\"Matrículas\" md-on-select=\"vm.getEnrolment()\"><md-card layout-padding=\"\" ng-show=\"!vm.checkPolicies(\'aluno\')\"><md-checkbox style=\"position: absolute; top:20px; left:23px;\" ng-model=\"vm.show_inactive\" aria-label=\"Mostrar matrículas em turmas concluídas\" ng-change=\"vm.paginate(false, 1)\" class=\"is_inactive\" ng-show=\"vm.conf.current_school_period_id == 0\">Mostrar matrículas em turmas concluídas</md-checkbox><div><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.createOrUpdateGates()\" ng-show=\"!vm.checkPolicies(\'aluno_alt\')\" ng-if=\"vm.show_gate_sync\"><md-icon>autorenew</md-icon>Sincronizar com catracas</md-button><md-input-container id=\"enrolment_status\" md-no-float=\"\" class=\"m-0\" flex=\"20\"><md-select ng-model=\"vm.enrolment_status_id\" placeholder=\"Status de matrícula\" ng-change=\"vm.getAll(vm.enrolment_status_id)\"><md-option ng-value=\"null\"><em>Todos</em></md-option><md-option ng-value=\"100\">Em matrícula</md-option><md-option ng-repeat=\"enrolment_status in vm.enrolment_status\" ng-value=\"enrolment_status.id\">{{enrolment_status.name}}</md-option></md-select></md-input-container><md-button ng-click=\"vm.doEnrolment(0)\" ng-show=\"!vm.checkPolicies(\'confirm_enrolment\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar nova matrícula</md-button></div><div style=\"overflow: auto;\" ng-style=\"{height: vm.windowHeight}\"><table md-table=\"\" md-progress=\"vm.grid.promise\"><thead md-head=\"\" fix-head=\"\" md-order=\"vm.grid.order\" md-on-reorder=\"vm.reorder\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"number\"><span>Matrícula</span></th><th md-column=\"\" md-order-by=\"name\"><span>Nome</span></th><th md-column=\"\" md-order-by=\"course_alias\"><span>Curso</span></th><th md-column=\"\" md-order-by=\"group_name\"><span>Turma</span></th><th md-column=\"\" md-order-by=\"group_shift\"><span>Turno</span></th><th><span>Status</span></th><th md-column=\"\" style=\"text-align: right\"><span>Ações</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"student in vm.grid.rows\" ng-click=\"vm.editStudents(student)\" style=\"cursor: pointer;\"><td md-cell=\"\" flex=\"\"><img style=\"max-width: 39px; object-fit: contain;\" id=\"{{student.id}}\" ng-src=\"{{ vm.api_uri + student.photo}}\" ng-show=\"student.photo\" ng-mouseover=\"vm.expandImage(student.id)\" ng-mouseleave=\"vm.unexpandImage(student.id)\" class=\"avatar md-avatar\" alt=\"photo\"></td><td md-cell=\"\" style=\"{{student.enrolment_status == \'Cancelado\' ? \'color: indianred !important\' : \'\'}}\"><span>{{student.number}}<md-tooltip md-direction=\"top\">Data da matrícula: {{student.enrolment_date | date: \"dd/MM/yyyy\"}}</md-tooltip></span></td><td md-cell=\"\" style=\"{{student.enrolment_status == \'Cancelado\' ? \'color: indianred !important\' : \'\'}}\"><span>{{student.name}}</span></td><td md-cell=\"\" style=\"{{student.enrolment_status == \'Cancelado\' ? \'color: indianred !important\' : \'\'}}\"><span>{{student.course_alias}}</span></td><td md-cell=\"\" style=\"{{student.enrolment_status == \'Cancelado\' ? \'color: indianred !important\' : \'\'}}\"><span>{{student.group_name}}</span></td><td md-cell=\"\" style=\"{{student.enrolment_status == \'Cancelado\' ? \'color: indianred !important\' : \'\'}}\"><span>{{student.group_shift}}</span></td><td md-cell=\"\"><span class=\"badge\" ng-click=\"vm.openCancelDetail(student);$event.stopPropagation()\"><span class=\"enrolment_status enrolment_status {{student.enrolment_status}}\"><md-tooltip md-direction=\"top\" ng-if=\"student.enrolment_status == \'Cancelado\'\">{{student.enrolment_cancel_reason_name}} | {{student.cancel_date | date:\"dd/MM/yyyy\"}}</md-tooltip><md-tooltip md-direction=\"top\" ng-if=\"student.enrolment_status == \'Concluído\'\">Conclusão em {{student.conclusion_date | date:\"dd/MM/yyyy\"}}</md-tooltip>{{student.enrolment_status.replace(\'_\', \' \')}}</span></span> <span ng-if=\"student.api !== null\" class=\"badge\" style=\"background-color: #4A148C !important; margin-left: 1px !important;\"><span class=\"badge\">{{student.api == \'agendaedu\' ? \'AE\' : atudent.api}}</span></span> <span ng-if=\"student.attendance_mode !== null\" class=\"badge\" style=\"margin-left: 1px !important;\"><span class=\"attendance_mode_{{student.attendance_mode_id}}\">{{student.attendance_mode}}</span></span></td><td md-cell=\"\" style=\"text-align: right\"><md-menu ng-if=\"student.enrolment_status_id !== null\"><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event);$event.stopPropagation()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"6\"><md-menu-item ng-show=\"!vm.checkPolicies(\'change_group_enrolment\')\"><md-button ng-click=\"vm.clickActions(student, \'change-group\')\" ng-disabled=\"student.conclusion_date !== null || student.graduate_date !== null\"><md-icon>swap_horiz</md-icon>Trocar aluno de turma</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(\'change_course_enrolment\')\" ng-if=\"student.course_equivalence_id < 300 || student.course_equivalence_id === 999\"><md-button ng-click=\"vm.clickActions(student, \'change-course\')\" ng-disabled=\"student.conclusion_date !== null || student.graduate_date !== null\"><md-icon>swap_horiz</md-icon>Trocar aluno de curso</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(\'confirm_enrolment\')\"><md-button ng-disabled=\"(student.enrolment_status !== \'Aguardando pagamento\' && student.enrolment_status !== \'Matrícula condicional\' && student.enrolment_status !== \'Confirmada Online\' && student.enrolment_status !== \'Aguardando assinatura online\') || student.conclusion_date !== null || student.graduate_date !== null\" ng-click=\"vm.clickActions(student, \'confirm-enrolment\')\"><md-icon>done</md-icon>Confirmar matrícula</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(\'cancel_enrolment\')\"><md-button ng-disabled=\"(student.enrolment_status !== \'Matriculado\' && student.enrolment_status !== \'Aguardando assinatura online\' && student.enrolment_status !== \'Turma_encerrada\') || student.conclusion_date !== null || student.graduate_date !== null\" ng-click=\"vm.clickActions(student, \'cancel-enrolment\')\"><md-icon>clear</md-icon>Cancelar matrícula</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(\'change_date_enrolment\')\"><md-button ng-disabled=\"student.enrolment_status !== \'Matriculado\'\" ng-click=\"vm.clickActions(student, \'edit-enrolment-date\')\"><md-icon>create</md-icon>Editar data da matrícula</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(\'cancel_enrolment\')\" ng-if=\"student.enrolment_status === \'Cancelado\'\"><md-button ng-click=\"vm.clickActions(student, \'undo-cancel-enrolment\')\"><md-icon>swap_horiz</md-icon>Desfazer cancelamento de matrícula</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(\'delete_enrolment\')\"><md-button ng-click=\"vm.clickActions(student, \'delete-enrolment\')\"><md-icon>delete</md-icon>Excluir matrícula</md-button></md-menu-item><md-menu-item ng-show=\"vm.school_period_id == 0 || vm.school_period_id.toString().length > 4\"><md-button ng-click=\"vm.clickActions(student, \'go-to-external-statement\')\"><md-icon>assignment</md-icon>Ir para ficha financeira externa</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(\'link_student_access_card_number\')\"><md-button ng-click=\"vm.clickActions(student, \'student-access-card-number-link\')\"><md-icon>credit_card</md-icon>Associar cartão de acesso (catraca)</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-if=\"student.enrolment_status_id === null\" ng-show=\"!vm.checkPolicies(\'delete_enrolment\')\" ng-click=\"vm.clickActions(student, \'delete-enrolment\');$event.stopPropagation()\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"left\">Excluir matrícula</md-tooltip></md-button></td></tr></tbody></table><md-button style=\"width: 98%\" ng-click=\"vm.paginate()\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon>Carregar mais</md-button></div></div></md-card></md-tab><md-tab id=\"pre_enrolment\" label=\"Pré-matrículas\" md-on-select=\"vm.getPreEnrolment()\"><md-card layout-padding=\"\" ng-show=\"!vm.checkPolicies(\'aluno\')\"><div><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.doEnrolment(1)\" ng-show=\"!vm.checkPolicies(\'aluno_alt\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar nova pré-matrícula</md-button></div><div style=\"overflow: auto;\" ng-style=\"{height: vm.windowHeight}\"><table md-table=\"\" md-progress=\"vm.grid.promise\"><thead md-head=\"\" fix-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"><span>Matrícula</span></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Curso</span></th><th md-column=\"\"><span>Turma</span></th><th md-column=\"\"><span>Turno</span></th><th md-column=\"\"><span>Status</span></th><th md-column=\"\" style=\"text-align: right\"><span>Ações</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"student in vm.grid.rows\" ng-click=\"vm.editStudents(student)\" style=\"cursor: pointer\"><td md-cell=\"\" flex=\"\"><img style=\"max-width: 39px;\" ng-src=\"{{CONFIG.webApiUri + student.photo}}\" ng-show=\"student.photo\" class=\"avatar md-avatar\" alt=\"photo\"></td><td md-cell=\"\"><span>{{student.number}}</span></td><td md-cell=\"\"><span>{{student.name}}<md-tooltip md-direction=\"top\">Data da matrícula: {{student.enrolment_date | date: \"dd/MM/yyyy\"}}</md-tooltip></span></td><td md-cell=\"\"><span>{{student.course_alias}}</span></td><td md-cell=\"\"><span>{{student.group_name}}</span></td><td md-cell=\"\"><span>{{student.group_shift}}</span></td><td md-cell=\"\"><span class=\"badge\"><span class=\"enrolment_status enrolment_status {{student.pre_enrol_status}}\" ng-if=\"student.pre_enrol_status !== null\">{{student.pre_enrol_status}}</span> <span class=\"enrolment_status enrolment_status\" ng-if=\"student.pre_enrol_status === null\">{{student.enrolment_status}}</span></span></td><td md-cell=\"\" style=\"text-align: right\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event);$event.stopPropagation()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"6\"><md-menu-item ng-show=\"!vm.checkPolicies(cud)\"><md-button ng-click=\"vm.clickActions(student, \'change-group\')\"><md-icon>swap_horiz</md-icon>Trocar aluno de turma</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(cud)\"><md-button ng-click=\"vm.clickActions(student, \'change-course\')\"><md-icon>swap_horiz</md-icon>Trocar aluno de curso</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(cud)\"><md-button ng-disabled=\"student.pre_enrol_status === \'Aprovado\'\" ng-click=\"vm.clickActions(student, \'approve-pre-enrolment\')\"><md-icon>done</md-icon>Aprovar</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(cud)\"><md-button ng-click=\"vm.clickActions(student, \'disapprove-pre-enrolment\')\" ng-disabled=\"student.pre_enrol_status === \'Reprovado\'\"><md-icon>block</md-icon>Reprovar</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(cud)\" ng-if=\"student.pre_enrol_status !== null\"><md-button ng-click=\"vm.clickActions(student, \'ausent\')\" ng-disabled=\"student.pre_enrol_status === \'Ausente\'\"><md-icon>clear</md-icon>Ausente</md-button></md-menu-item><md-menu-item ng-show=\"!vm.checkPolicies(\'delete_enrolment\')\"><md-button ng-click=\"vm.clickActions(student, \'delete-enrolment\')\"><md-icon>delete</md-icon>Excluir matrícula</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><md-button style=\"width: 98%\" ng-click=\"vm.paginate(1)\" ng-if=\"vm.grid.rows.length > 29\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon>Carregar mais</md-button></div></div></md-card></md-tab></md-tabs>");
$templateCache.put("app/educational/students/views/student-delete-modal.html","<md-dialog aria-label=\"Exclusão de matrícula\" md-theme=\"educational\"><form ng-cloak=\"\" novalidate=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-delete\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Exclusão de matrícula</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\" flex=\"\"><div layout=\"row\" flex=\"\"><md-icon md-font-icon=\"icon-close\" style=\"color: red; margin-left: 0; margin-right: 0;\"></md-icon><h3 style=\"margin-left: 3px;\">{{vm.scope.text}}</h3></div><div><md-input-container flex=\"\"><md-radio-group ng-model=\"vm.scope.option\" name=\"radio\"><md-radio-button ng-value=\"0\" ng-if=\"(vm.scope.alerts.enrolments === false && vm.scope.alerts.employee === 0 && vm.scope.alerts.responsible === 0 && vm.scope.alerts.resp_dep === 0 && vm.scope.alerts.resp_employee === 0 && vm.scope.alerts.resp_enrolment === 0)\">Exclui a matrícula, o aluno e os responsáveis</md-radio-button><md-radio-button ng-value=\"1\" ng-if=\"(vm.scope.alerts.enrolments === false && vm.scope.alerts.employee === 0 && vm.scope.alerts.responsible === 0)\">Exclui a matrícula e o aluno (mantém os responsáveis)</md-radio-button><md-radio-button ng-value=\"2\">Exclui apenas a matrícula (mantém o aluno e os responsáveis)</md-radio-button></md-radio-group></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button ng-click=\"vm.answer(vm.scope.option)\" ng-disabled=\"vm.scope.option === null\" class=\"md-primary md-raised\" layout=\"row\"><span flex=\"95\">Confirmar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/views/students-access-card-number-link.html","<md-dialog aria-label=\"Access card number\" md-theme=\"educational\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.answer({card_number: vm.scope.card_number, enrolment_period_id: vm.scope.enrolment_period_id, person_id: vm.scope.id})\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-credit-card\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Associar cartão de acesso ao aluno</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Aluno: {{vm.scope.name}} - {{vm.scope.course_alias}} ({{vm.scope.group_name}})</b></div></div><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Número do cartão</b> <small>Digite o novo número do cartão ou leia o código de barras com leitor ótico</small></div></div><md-input-container class=\"md-input-has-placeholder\" flex=\"\" style=\"width: 100%; margin-top: 15px;\"><input ng-model=\"vm.scope.card_number\" type=\"text\" md-autofocus=\"true\" required=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.closeModal()\">Voltar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" layout=\"row\" ng-disabled=\"form.$invalid\"><span flex=\"95\">Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/views/students-cancel-enrolment.html","<md-dialog aria-label=\"Cancelamento de matrícula\" md-theme=\"educational\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submit()\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-account-box\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Cancelamento de matrícula</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Informações para o cancelamento</b> <small>Informe abaixo alguns dados, para poder realizar o cancelamento da matrícula</small></div></div><hr><div layout=\"row\"><date-picker ng-model=\"vm.form.cancelDate\" flex=\"\" placeholder=\"Data do cancelamento\" required=\"\"></date-picker><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Razão do cancelamento</label><md-select name=\"cancel_reasons\" ng-model=\"vm.form.cancelReason\" required=\"\"><md-option ng-repeat=\"reason in vm.cancelReasons\" ng-value=\"reason.id\">{{reason.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label><md-icon md-font-icon=\"icon-pencil\"></md-icon>Observações</label> <textarea type=\"text\" name=\"observations\" ng-model=\"vm.form.observations\" rows=\"2\"></textarea></md-input-container></div><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Contratos do aluno</b> <small>Selecione os contratos que deseja cancelar</small></div></div><hr><md-checkbox ng-checked=\"vm.isItemChecked(contract)\" ng-repeat=\"contract in vm.studentContracts track by $index\" layout=\"row\" ng-click=\"vm.manipulateListOfContracts(contract)\" ng-disabled=\"contract.external_id\"><md-icon md-font-icon=\"icon-file-document\"></md-icon>{{contract.description}} | R${{contract.amount}}<br></md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.close()\">Voltar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" layout=\"row\" ng-disabled=\"form.$invalid || vm.disableButton\"><md-progress-circular ng-disabled=\"!vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"95\">Confirmar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/views/students-change-course.html","<md-dialog aria-label=\"Cancelamento de matrícula\" md-theme=\"educational\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submit()\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-swap-horizontal\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2 ng-if=\"!vm.isChangeGroup\">Trocar aluno de curso</h2><h2 ng-if=\"vm.isChangeGroup\">Trocar aluno de turma</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Aluno: {{vm.form.person.name}} - {{vm.form.person.course_alias}} ({{vm.form.person.group_name}})</b> <small>Informe abaixo o curso e/ou turma de destino e a data da troca</small></div></div><br><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Curso destino</label> <label ng-if=\"vm.isChangeGroup\">{{vm.form.person.course_alias}}</label><md-select name=\"groups\" ng-model=\"vm.course_id\" ng-change=\"vm.setGroups(vm.course_id)\" ng-disabled=\"vm.isChangeGroup\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Turma destino</label><md-select name=\"groups\" ng-model=\"vm.new_group_id\" ng-change=\"vm.getPaymentPlansForGroup(vm.new_group_id)\" required=\"\"><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.id_matrix_period\">{{group.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><date-picker ng-model=\"vm.form.changeDate\" flex=\"\" placeholder=\"Data da troca\" required=\"\" ng-change=\"vm.changeDate()\"></date-picker></div><br><div ng-if=\"vm.has_finance && vm.new_group_id !== undefined\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Alteração do contrato</b> <small>Defina como a alteração do curso/turma afetará o contrato financeiro</small></div></div><div layout=\"row\" style=\"margin-bottom: -20px;\"><md-input-container><md-radio-group ng-model=\"vm.form.change_plan_option\" style=\"vert-align: top !important;\"><md-radio-button style=\"vertical-align: top !important;\" ng-value=\"0\"><strong>Manter o mesmo contrato:</strong> O contrato financeiro se mantém o mesmo, apenas o produto (curso/turma) é alterado.</md-radio-button><md-radio-button style=\"vertical-align: top\" ng-value=\"1\"><strong>Substituir o contrato integralmente:</strong> O contrato anterior será eliminado e um novo contrato será criado. Caso exista uma ou mais parcelas pagas, o contrato anterior será cancelado e as parcelas pagas serão mantidas no histórico.</md-radio-button><md-radio-button style=\"vert-align: top\" ng-value=\"2\"><strong>Substituir o contrato a partir de ... :</strong> O contrato anterior será cancelado na data especificada abaixo e um novo contrato será criado nesta mesma data.</md-radio-button></md-radio-group></md-input-container></div><div><date-picker ng-model=\"vm.form.change_plan_date\" ng-value=\"vm.form.change_plan_date\" ng-if=\"vm.form.change_plan_option === 2\" flex=\"\" placeholder=\"Data da substituição do contrato\"></date-picker></div><md-card ng-show=\"vm.payment_plans.length == 0 && vm.form.change_plan_option != 0\"><md-card-title style=\"padding: 0 16px 12px !important;background-color: #fb8787; color: black;\"><md-card-title-text><span class=\"md-subhead\">Este curso/turma não possui plano de pagamento. Impossível continuar com esta opção.</span></md-card-title-text></md-card-title></md-card><div layout=\"row\" style=\"margin-bottom: -20px;\" ng-if=\"vm.payment_plans.length > 0 && vm.form.change_plan_option != 0\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Plano de pagamento</label><md-icon md-font-icon=\"icon-view-carousel\"></md-icon><md-select ng-model=\"vm.new_payment_plan\" ng-required=\"vm.has_finance\" name=\"paymentplan\" aria-label=\"plano de pagamento\" ng-change=\"vm.setPaymentPlan(vm.new_payment_plan)\"><md-option ng-value=\"payment.payment_plan_id\" ng-repeat=\"payment in vm.payment_plans\">{{payment.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"vm.new_payment_plan != null\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"100\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" ng-if=\"vm.block_fields.date\" flex\"=\"\"><label>Data de início</label><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><input ng-value=\"vm.contract.date_first | date:\'dd/MM/yyyy\'\" required=\"\" ng-disabled=\"true\"></md-input-container><date-picker flex=\"30\" required=\"\" ng-if=\"!vm.block_fields.date\" ng-change=\"vm.setFirstInstallmentDate(vm.contract.date_first)\" placeholder=\"Data de início\" ng-model=\"vm.contract.date_first\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"30\" ng-if=\"vm.contract.first_installment_date_type === 2\"><label>Venc. 1ª parcela</label><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><input type=\"text\" ng-value=\"vm.contract.first_installment_date | date:\'dd/MM/yyyy\'\" required=\"\" ng-disabled=\"true\"></md-input-container><date-picker flex=\"25\" required=\"\" ng-if=\"vm.contract.first_installment_date_type == 1\" placeholder=\"Venc. 1ª parcela\" ng-model=\"vm.contract.first_installment_date\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\" ng-if=\"vm.contract.date_end == null\"><label>Qtd parcelas</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"vm.contract.quantity\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" ng-if=\"vm.contract.date_end != null\" flex=\"25\"><label>Data final</label><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><input ng-value=\"vm.contract.date_end | date:\'dd/MM/yyyy\'\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label>Valor</label><md-icon md-font-icon=\"icon-coin\"></md-icon><input ng-model=\"vm.contract.amount\" required=\"\" ui-money-mask=\"\" ng-disabled=\"vm.block_fields.amount\"></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.close()\">Voltar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" layout=\"row\" ng-disabled=\"form.$invalid || vm.disableButton\"><md-progress-circular ng-disabled=\"!vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"95\">Realizar troca</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/views/students-change-enrolment-date.html","<md-dialog aria-label=\"Edit Enrolment Date\" md-theme=\"educational\" style=\"min-width: 350px; min-height: 150px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Editar data da matrícula</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div style=\"padding: 40px; width: 90%;\"><date-picker ng-model=\"vm.scope.date\" placeholder=\"Data da matrícula\"></date-picker></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.answer(vm.scope.date)\" style=\"padding: 1px;\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/educational/students/views/students-change-group.html","<md-dialog aria-label=\"Cancelamento de matrícula\" md-theme=\"educational\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submit()\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-swap-horizontal\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Trocar aluno de turma</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Aluno: {{vm.form.person.name}} - {{vm.form.person.course_alias}} ({{vm.form.person.group_name}})</b> <b>Selecione a turma e a data</b> <small>Informe abaixo a turma destino e a data da troca</small></div></div><hr><div layout=\"row\"><date-picker ng-model=\"vm.form.changeDate\" flex=\"\" placeholder=\"Data da troca\" required=\"\"></date-picker><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Turma destino</label><md-select name=\"groups\" ng-model=\"vm.new_group_id\" ng-change=\"vm.getPaymentPlansForGroup(vm.new_group_id)\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchGroup\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"group in vm.list.person.new_group_id | filter: searchGroup\" ng-value=\"group.id_matrix_period\">{{group.group_name}} ({{group.matrix_period}})</md-option></md-select></md-input-container></div><div ng-if=\"vm.has_lessons\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Aluno possui registro de aulas até {{vm.last_lesson_date}}</b> <small>Informe abaixo como lidar com esses registros</small></div></div><hr><div layout=\"row\" style=\"margin-bottom: -10px;\"><md-input-container><md-radio-group ng-model=\"vm.form.lesson_option\"><md-radio-button ng-value=\"0\">Desconsiderar as aulas registradas na turma anterior</md-radio-button><md-radio-button ng-value=\"1\">Mantém o aluno na turma anterior até</md-radio-button><date-picker ng-model=\"vm.form.lesson_date\" ng-if=\"vm.form.lesson_option === 1\" placeholder=\"Data\"></date-picker></md-radio-group></md-input-container></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\" ng-if=\"vm.has_finance\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Alteração do contrato</b> <small>Selecione o novo plano de pagamento e como substituir o contrato</small></div></div><hr><div layout=\"row\" style=\"margin-bottom: -20px;\" ng-if=\"vm.has_finance\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Plano de pagamento</label><md-icon md-font-icon=\"icon-view-carousel\"></md-icon><md-select ng-model=\"vm.new_payment_plan\" ng-required=\"vm.has_finance\" name=\"paymentplan\" aria-label=\"plano de pagamento\" ng-change=\"vm.setPaymentPlan(vm.new_payment_plan)\"><md-option ng-value=\"payment.payment_plan_id\" ng-repeat=\"payment in vm.payment_plans\">{{payment.name}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.show_amount_contract\"><label>Valor do contrato</label> <input ui-money-mask=\"\" ng-model=\"vm.contract.amount\" required=\"\"></md-input-container></div><div layout=\"row\" style=\"margin-bottom: -20px;\" ng-if=\"vm.has_finance && vm.new_group_id !== undefined\"><md-input-container><md-radio-group ng-model=\"vm.form.change_plan_option\"><md-radio-button ng-value=\"0\">Substituir o contrato integralmente</md-radio-button><md-radio-button ng-value=\"1\">Substituir o contrato a partir de</md-radio-button></md-radio-group></md-input-container></div><date-picker ng-model=\"vm.form.change_plan_date\" ng-value=\"vm.form.change_plan_date\" ng-if=\"vm.form.change_plan_option === 1 && vm.new_group_id !== undefined\"></date-picker></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.close()\">Voltar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" layout=\"row\" ng-disabled=\"form.$invalid || vm.disableButton\"><md-progress-circular ng-disabled=\"!vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"95\">Realizar troca</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/views/students-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.students.list\" policy-access=\"aluno_alt\" style=\"margin-right: 10px; !important;\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"edit-image\" layout=\"row\" layout-align=\"start start\"><img style=\"object-fit: contain; width: 70px !important; height: 50px !important; border-radius: 50%; overflow: visible; cursor: pointer; margin-right: -10px;\" ng-if=\"vm.checkProfile(vm.CONFIG.profile.student)\" ng-src=\"{{ vm.form.person.profile_image.new_photo ? vm.form.person.profile_image.new_photo : \'/assets/images/avatars/profile.jpg\'}}\" ng-click=\"vm.editImage()\"> <img style=\"object-fit: contain; width: 70px !important; height: 50px !important; border-radius: 50%; overflow: visible; cursor: pointer; margin-right: -10px;\" ng-if=\"!vm.checkProfile(vm.CONFIG.profile.student)\" ng-src=\"{{ vm.form.person.profile_image.new_photo ? vm.form.person.profile_image.new_photo : \'/assets/images/avatars/profile.jpg\'}}\" ng-click=\"vm.editImage()\"></div><a4-search-field url=\"students\" style=\"width: 100%\" is-disabled=\"vm.checkProfile(vm.CONFIG.profile.student) || vm.checkProfile(vm.CONFIG.profile.parent)\" on-change=\"vm.changeStudent(item)\" selected-item=\"vm.form.person\" predefined-list=\"vm.checkProfile(vm.CONFIG.profile.is_parent)\" predefined-list-data=\"vm.students\" predefined-list-selected=\"vm.student_id\" student-page=\"true\" placeholder=\"{{vm.form.person.name}}\"></a4-search-field></div><md-button ng-click=\"vm.deleteStudent(vm.form.person)\" ng-show=\"vm.checkPolicies(\'aluno_alt\') && (vm.selected_tab == 0 && !vm.form.person.block_delete && vm.form.person.id)\" class=\"md-icon-button btn-edit\" aria-label=\"delete\"><md-tooltip md-direction=\"bottom\">Remover</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-click=\"vm.ableEdit()\" class=\"md-icon-button btn-edit\" ng-show=\"vm.checkPolicies(\'aluno_alt\') && (vm.selected_tab == 0 || vm.selected_tab == 1 && vm.form.person.id)\" aria-label=\"delete\" translate-attr-aria-label=\"STUDENTS.EDIT\"><md-tooltip><span ng-show=\"!vm.form.mode_edit\">Editar</span> <span ng-show=\"vm.form.mode_edit\">Cancelar Edição</span></md-tooltip><md-icon ng-show=\"!vm.form.mode_edit\" md-font-icon=\"icon-pencil\"></md-icon><md-icon ng-show=\"vm.form.mode_edit\" md-font-icon=\"icon-cancel\"></md-icon></md-button></div></md-toolbar><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important;\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Dados\" ng-if=\"!vm.checkProfile(vm.CONFIG.profile.teacher) && !vm.checkProfile(vm.CONFIG.profile.student)\"><a4-email-warning person=\"vm.person_copy\"></a4-email-warning><div layout=\"column\"><md-card layout=\"row\" layout-gt-xs=\"center start\" style=\"min-width: 1000px; margin: 10px auto\"><div layout=\"column\" style=\"width: 100%\" layout-gt-xs=\"center start\"><div style=\"background-color: #1e95cb; height: 35px; padding: 8px;\"><span style=\"color: white; font-size: 15px;\">Informações pessoais</span></div><div class=\"md-padding\"><form name=\"student_form\"><div layout=\"row\" layout-align=\"space-between start\" flex=\"\" ng-if=\"vm.person_copy.show_form\"><div flex=\"50\" style=\"margin-right: 4px;\"><a4-student-form student=\"vm.person_copy\" is-enabled=\"vm.form.mode_edit\" student-form=\"student_form\" is-enrolment=\"false\" block-form-email=\"vm.blockFormEmail\"></a4-student-form></div><div flex=\"50\" style=\"margin-left: 4px;\"><a4-student-contact-form student=\"vm.person_copy\" is-enabled=\"vm.form.mode_edit\" student-contact-form=\"student_form\"></a4-student-contact-form></div></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.submit(student_form, vm.person_copy)\" ng-disabled=\"$rootScope.show_loader || vm.blockFormEmail\" ng-if=\"vm.form.mode_edit\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Salvar</md-button></div></form></div></div></md-card><md-card layout=\"row\" layout-gt-xs=\"center start\" style=\"min-width: 1000px; margin: 10px auto\"><div layout=\"column\" style=\"width: 100%\" layout-gt-xs=\"center start\"><div style=\"background-color: #1e95cb; height: 35px; padding: 8px;\"><span style=\"color: white; font-size: 15px;\">Informações da matrícula {{vm.current_school_period !== 0 ? vm.current_school_period : \'\'}}</span></div><div class=\"md-padding\"><div class=\"md-inline-form new-material-inputs\" style=\"padding: 5px\"><form name=\"more_info_form\"><div layout=\"row\" layout-align=\"space-between start\" flex=\"\" ng-if=\"vm.person_copy.show_form\"><div flex=\"50\" style=\"margin-right: 4px;\"><date-picker ng-model=\"vm.person_copy.enrolment_date\" placeholder=\"Data de matrícula\" disabled=\"!vm.form.mode_edit\" ng-class=\"{show_bottom: true}\" flex-gt-xs=\"\" without-icon=\"true\" drops=\"\'up\'\" style=\"margin-top: 0px; margin-bottom: -15px !important;\"></date-picker><div><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: !vm.form.mode_edit}\" flex-gt-xs=\"\" style=\"margin-bottom: 2px;\" ng-if=\"vm.person_copy.course_equivalence_id >= 300\"><label class=\"vm.form.mode_edit\">Ano de conclusão EM</label> <input ng-model=\"vm.person_copy.school_origin_year\" ng-disabled=\"!vm.form.mode_edit\"></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"vm.person_copy.course_equivalence_id >= 300\" style=\"margin-bottom: 0px !important;\"><div layout=\"column\" flex-gt-xs=\"\"><label for=\"select-enrmode\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Forma de ingresso</span></label><select2 ng-model=\"vm.person_copy.enrolment_mode_id\" s2-options=\"val.id as val.name for val in vm.list.person.enrolment_mode\" id=\"select-enrmode\" ng-disabled=\"!vm.form.mode_edit\" flex-gt-xs=\"\"></select2></div><md-input-container class=\"md-block md-input-has-placeholder\" ng-class=\"{show_bottom: true}\" flex-gt-xs=\"\" style=\"margin-bottom: 2px;margin-left: 2px;\"><label class=\"vm.form.mode_edit\">Período de ingresso</label> <input ng-model=\"vm.person_copy.enrolment_school_period\" ng-disabled=\"true\"></md-input-container></div></div><div flex=\"50\" style=\"margin-left: 4px;\"><md-input-container class=\"md-block\" flex-gt-xs=\"100\"><label style=\"color: #969696 !important\">Modalidade de frequência</label><md-select ng-model=\"vm.person_copy.attendance_mode_id\" ng-disabled=\"!vm.form.mode_edit\"><md-option ng-repeat=\"attendance in vm.list.person.attendance_mode\" ng-value=\"attendance.id\">{{attendance.name}}</md-option></md-select></md-input-container><date-picker ng-model=\"vm.person_copy.entrance_exame_date\" placeholder=\"Data do vestibular\" ng-if=\"vm.person_copy.course_equivalence_id >= 300\" disabled=\"!vm.form.mode_edit\" ng-class=\"{show_bottom: true}\" flex-gt-xs=\"\" without-icon=\"true\"></date-picker><div layout-gt-xs=\"row\" ng-if=\"vm.person_copy.course_equivalence_id >= 300\" style=\"margin-bottom: 0px !important;\"><date-picker ng-model=\"vm.person_copy.conclusion_date\" placeholder=\"Data de conclusão\" disabled=\"!vm.form.mode_edit\" ng-class=\"{show_bottom: true}\" flex-gt-xs=\"\" without-icon=\"true\"></date-picker><date-picker ng-model=\"vm.person_copy.graduate_date\" placeholder=\"Data da colação de grau\" disabled=\"!vm.form.mode_edit\" ng-class=\"{show_bottom: true}\" flex-gt-xs=\"\" without-icon=\"true\"></date-picker><date-picker ng-model=\"vm.person_copy.certificate_issue_date\" placeholder=\"Data de exp. do diploma\" disabled=\"!vm.form.mode_edit\" ng-class=\"{show_bottom: true}\" flex-gt-xs=\"\" without-icon=\"true\"></date-picker></div></div></div><div style=\"padding-top: 150px\" ng-if=\"vm.form.mode_edit\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.submit(more_info_form, vm.person_copy)\" ng-disabled=\"$rootScope.show_loader || vm.blockFormEmail\" ng-if=\"vm.form.mode_edit\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Salvar</md-button></div></form></div></div></div></md-card></div></md-tab><md-tab ng-repeat=\"tab in vm.tabs\" md-on-select=\"vm.reload()\" label=\"{{tab.label}}\" ng-if=\"(!vm.checkProfile(vm.CONFIG.profile.student)) && (vm.checkProfile(vm.CONFIG.profile.teacher) || vm.checkProfile(vm.CONFIG.profile.parent))\"><md-card><div ui-view=\"{{tab.uiView}}\"></div></md-card></md-tab><md-tab ng-repeat=\"tab in vm.tabs\" md-on-select=\"vm.reload()\" label=\"{{tab.label}}\" ng-if=\"vm.checkProfile(vm.CONFIG.profile.student)\"><div ui-view=\"{{tab.uiView}}\" ng-if=\"(vm.selected_tab) == tab.id - 1\"></div></md-tab><md-tab ng-repeat=\"tab in vm.tabs\" md-on-select=\"vm.reload()\" label=\"{{tab.label}}\" ng-if=\"!vm.checkProfile(vm.CONFIG.profile.student) && !vm.checkProfile(vm.CONFIG.profile.teacher) && !vm.checkProfile(vm.CONFIG.profile.parent)\"><md-card ng-if=\"(vm.selected_tab) == tab.id\"><div ui-view=\"{{tab.uiView}}\"></div></md-card></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/students/views/students-undo-cancel-enrolment.html","<md-dialog aria-label=\"Cancelamento de matrícula\" md-theme=\"educational\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submit()\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-account-box\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Desfazer cancelamento de matrícula</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Contrato principal do aluno</b> <small>Este é o contrato da matrícula do aluno, que se tornará ativo novamente.</small></div></div><hr><md-checkbox ng-checked=\"true\" ng-repeat=\"contract in vm.studentContracts track by $index\" layout=\"row\" ng-disabled=\"contract.external_id\" ng-if=\"contract.external_id\"><md-icon md-font-icon=\"icon-file-document\"></md-icon>{{contract.description}} | R${{contract.amount}}<br></md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.close()\">Voltar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" layout=\"row\" ng-disabled=\"form.$invalid || vm.disableButton\"><md-progress-circular ng-disabled=\"!vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"95\">Confirmar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/views/students.html","<div ui-view=\"students\"></div>");
$templateCache.put("app/educational/students-records-messages/views/modal-create.html","<md-dialog aria-label=\"Criar Mensagem para turma\" md-theme=\"educational\" style=\"max-width: 560px; max-height: 660px; min-width: 560px; min-height: 660px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Criar mensagem para turma</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close(false)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div style=\"padding: 40px; width: 90%;\"><div style=\"margin-bottom: 10px; margin-right: 0; background-color: rgb(209, 205, 201);\" ng-if=\"vm.course_selected == 0 && vm.group_selected == 0\"><b>Atenção:</b> Caso não seja informado um curso e/ou uma turma especifico, só serão listados os eventos compartilhados por todos os critérios de avaliação das turmas contempladas na filtragem.</div><md-input-container style=\"width: 100%\" required=\"\"><md-icon md-font-icon=\"icon-school\"></md-icon><label>Curso</label><md-select ng-model=\"vm.course_selected\" ng-change=\"vm.setGroups(vm.course_selected)\"><md-option ng-value=\"null\"><em>Selecione o curso</em></md-option><md-option ng-value=\"0\"><em>Todos os cursos</em></md-option><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container style=\"width: 100%\" required=\"\"><md-icon md-font-icon=\"icon-book-open\"></md-icon><label>Turma</label><md-select ng-model=\"vm.group_selected\" ng-change=\"vm.getGradeRuleItems(vm.group_selected)\" ng-disabled=\"vm.course_selected == null\"><md-option ng-value=\"null\"><em>Selecione a turma</em></md-option><md-option ng-value=\"0\"><em>Todas as turmas</em></md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container><md-input-container style=\"width: 100%\" required=\"\"><md-icon md-font-icon=\"icon-calendar-text\" class=\"s24\"></md-icon><label>Evento do boletim</label><md-select ng-model=\"vm.grade_selected\" ng-disabled=\"vm.group_selected == null\"><md-option ng-repeat=\"grade_rule in vm.grade_rule_items\" ng-value=\"grade_rule.id\">{{grade_rule.description}}</md-option></md-select></md-input-container><md-input-container style=\"width: 100%;\" required=\"\"><md-autocomplete flex=\"\" md-input-name=\"message_filter\" md-input-minlength=\"2\" md-no-cache=\"false\" md-delay=\"1000\" md-selected-item=\"vm.message\" md-search-text=\"searchText\" md-items=\"item in vm.getReportMessages(searchText)\" md-item-text=\"item.message\" md-floating-label=\"Observações do boletim\" input-aria-describedby=\"Observações do boletim\"><md-item-template><span md-highlight-text=\"searchText\">{{item.message}}</span></md-item-template></md-autocomplete></md-input-container><md-input-container style=\"width: 100%;\"><label>Mensagem do boletim</label> <input ng-model=\"vm.custom_message\"></md-input-container></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; margin-top: 55px;\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close(false)\" ng-disabled=\"vm.loader\">Cancelar</md-button><md-button flex=\"20\" layout=\"row\" class=\"md-raised md-primary\" ng-click=\"vm.save()\" ng-disabled=\"(vm.group_selected != 0) || !vm.grade_selected || (!vm.message && !vm.custom_message) || vm.loader\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loader\" flex=\"10\" md-diameter=\"15\"></md-progress-circular><span flex=\"\">Salvar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/educational/students-records-messages/views/modal-message.html","<md-dialog aria-label=\"Criar Mensagem para turma\" md-theme=\"educational\" style=\"width: 550px; height: 375px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Criar observação</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><div layout=\"row\"><md-input-container flex=\"\" style=\"padding: 20px; width: 99%\" required=\"\"><label style=\"margin-left: 10px;\">Texto da observação</label> <textarea type=\"text\" ng-model=\"vm.message\" rows=\"4\"></textarea></md-input-container></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; margin-top: 55px;\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(vm.message)\" ng-disabled=\"form.$invalid\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students-records-messages/views/students-records-messages-grid.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Mensagens dos boletins</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end end\"><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"course\"><md-icon md-font-icon=\"icon-school\"></md-icon></label><md-input-container id=\"course\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.course_id\" placeholder=\"Curso\" ng-change=\"vm.setGroups(vm.course_id); vm.getAll()\" md-on-open=\"vm.loadCourses()\"><md-option ng-value=\"null\"><em>Selecione o curso</em></md-option><md-option ng-value=\"0\"><em>Todos os cursos</em></md-option><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course.id\">{{course.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"subject\"><md-icon md-font-icon=\"icon-book-open\"></md-icon></label><md-input-container id=\"group\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.group_id\" ng-change=\"vm.getGradeRuleItems(vm.group_id); vm.getAll();\" placeholder=\"Turma\"><md-option ng-value=\"null\"><em>Selecione a turma</em></md-option><md-option ng-value=\"0\"><em>Todas as turmas</em></md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"group\"><md-icon md-font-icon=\"icon-calendar-text\"></md-icon></label><md-input-container id=\"event\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.grade_rule_item_id\" ng-change=\"vm.getAll()\" placeholder=\"Evento\" md-on-open=\"vm.loadSubjects()\"><md-option ng-value=\"null\"><em>Selecione o evento</em></md-option><md-option ng-repeat=\"grade_rule_item in vm.grade_rule_items\" ng-value=\"grade_rule_item.id\">{{grade_rule_item.description}}</md-option></md-select></md-input-container></div></div></md-toolbar><md-card ng-if=\"vm.grade_rule_item_id == null || vm.group_id == null || vm.course_id == null\" align=\"center\" style=\"width: 98%; padding: 0; box-shadow: 0px 0px 0px 0px;\"><div flex=\"\" style=\"background-color: rgb(98,140,255); width: 100%; height: 60px; text-align: left; margin: 5px 5px 5px 5px\"><p style=\"vertical-align: baseline; margin-top: 7px;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 35px; margin-left: 5px; margin-top: 5px !important;\"></i> <span flex=\"\" style=\"font-size: 16px; color: #fff; margin-left: 10px; margin-right: 5px; padding-bottom: 12px;\">Selecione todos os filtros para ver as mensagens!</span></p></div></md-card><md-card layout-padding=\"\"><div layout=\"column\" flex=\"\"><div layout=\"row\" flex=\"20\"><md-card flex=\"50\"><md-button ng-click=\"vm.openNewReportMessageModal()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Criar nova observação</md-button></md-card><md-card flex=\"50\"><md-button ng-click=\"vm.createMessageForGroup()\"><md-icon md-font-icon=\"icon-book-open\"></md-icon>Adicionar observação para turma</md-button></md-card></div><div layout=\"row\" ng-if=\"vm.paginate.data.length > 0\" layout-align=\"end center\"><md-button ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-content-save-all\"></md-icon>Salvar</md-button></div><div flex=\"80\"><md-table-pagination md-limit=\"vm.paginate.per_page\" md-limit-options=\"[20, 50, 75, 100]\" md-page=\"vm.paginate.current_page\" style=\"border-top: none\" md-total=\"{{vm.paginate.total}}\" md-on-paginate=\"vm.getAll\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container flex=\"\" class=\"tableContainer\"><table md-table=\"\" width=\"100%\"><thead md-head=\"\" class=\"fixedHeader\"><tr md-row=\"\"><th md-column=\"\"><span>Aluno</span></th><th md-column=\"\"><span>Curso</span></th><th md-column=\"\"><span>Turma</span></th><th md-column=\"\"><span>Observações</span></th><th md-column=\"\"><span>Mensagem</span></th><th md-column=\"\" style=\"text-align: right\"><span>Ações</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.paginate.data\" flex=\"\"><td md-cell=\"\" md-truncate=\"\" style=\"width: 20%\">{{item.person_name}}</td><td md-cell=\"\" md-truncate=\"\" style=\"width: 10%\">{{item.course_alias}}</td><td md-cell=\"\" md-truncate=\"\" style=\"width: 10%\">{{item.group_name}}</td><td md-cell=\"\" md-truncate=\"\"><md-autocomplete flex=\"\" md-input-name=\"message_filter\" md-input-minlength=\"2\" md-no-cache=\"false\" md-delay=\"1000\" md-selected-item=\"item.report_message\" md-search-text=\"searchText\" md-selected-item-change=\"vm.changeIdMessage(message.id, item); vm.addItem(item);\" md-items=\"message in vm.getReportMessages(searchText)\" md-item-text=\"message.message\" md-floating-label=\"Mensagem do boletim\" input-aria-describedby=\"Mensagem do boletim\"><md-item-template><span md-highlight-text=\"searchText\">{{message.message}}</span></md-item-template></md-autocomplete></td><td md-cell=\"\" md-truncate=\"\"><md-input-container style=\"width: 70%\"><input ng-model=\"item.report_student_message\" ng-change=\"vm.addItem(item)\"></md-input-container></td><td md-cell=\"\" style=\"text-align: right\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete(item)\" ng-if=\"item.new !== true\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip md-direction=\"top\">Excluir</md-tooltip></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div></md-card></div>");
$templateCache.put("app/educational/subject/views/form.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"min-width: 600px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.form.subject.id\">Criar Disciplina</h2><h2 ng-if=\"vm.form.subject.id\">Editar Disciplina</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" flex=\"\"><form name=\"subject\" flex=\"\"><div layout=\"row\" flex=\"\"><md-input-container flex=\"\"><label>Nome</label> <input ng-model=\"vm.form.subject.name\" placeholder=\"Ex: Matemática\" required=\"\"></md-input-container></div><div layout=\"row\" ng-if=\"1 > 2\" flex=\"\"><md-input-container flex=\"\"><label>Nome (segunda língua)</label> <input ng-model=\"vm.form.subject.name_second_language\" placeholder=\"Ex: History\" required=\"\"></md-input-container><md-input-container flex=\"\"><label>Apelido (segunda língua)</label> <input ng-model=\"vm.form.subject.alias_second_language\" placeholder=\"Ex: HIST\" required=\"\"></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container flex=\"\"><label>Apelido</label> <input ng-model=\"vm.form.subject.alias\" placeholder=\"Ex: MATA\" required=\"\"></md-input-container><md-input-container flex=\"\"><label>Nome no histórico escolar</label> <input ng-model=\"vm.form.subject.school_record_name\"></md-input-container></div><div layout=\"row\" flex=\"\" ng-if=\"vm.academic_type == 1\"><md-input-container flex=\"\"><label>Currículo nacional</label><md-select ng-model=\"vm.form.subject.subject_national_curriculum_id\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchCurriculum\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"item in vm.list.subject.subject_national_curriculum_id | filter: searchCurriculum\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Classificação</label><md-select ng-model=\"vm.form.subject.subject_classification_id\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchClassification\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"item in vm.list.subject.subject_classification_id | filter: searchClassification\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container></div><md-dialog-actions style=\"text-align: right\"><md-button class=\"md-raised\" ng-click=\"vm.submit(vm.form.subject, subject)\" ng-disabled=\"subject.$invalid || vm.disable\">Salvar</md-button></md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/subject/views/subject.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-book-open\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'SUBJECT.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.checkPolicies(\'disc\')\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'COURSE.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.paginate(1, 50, vm.search)\" translate=\"\" translate-attr-placeholder=\"COURSE.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-card class=\"md-padding\" ng-if=\"!vm.checkPolicies(\'disc\')\" layout=\"row\"><md-content style=\"width: 100%;\"><md-checkbox ng-model=\"vm.show_inactive\" ng-change=\"vm.paginate(1, 50, vm.search)\">Mostrar disciplinas inativas</md-checkbox><md-table-pagination md-limit=\"vm.grid.info.limit\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.grid.info.page\" md-total=\"{{vm.grid.info.total}}\" md-on-paginate=\"vm.paginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container class=\"table-float-button\"><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Apelido</th><th md-column=\"\">Nome</th><th md-column=\"\">Cursos</th><th md-column=\"\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" style=\"cursor: pointer\" ng-repeat=\"item in vm.grid.rows\" ng-click=\"vm.editSubject(item)\"><td md-cell=\"\">{{ item.alias }}</td><td md-cell=\"\">{{ item.name }} <span ng-if=\"item.special_type === 9\">[Disciplina criada no HE]</span></td><td md-cell=\"\">{{item.uses}}</td><td md-cell=\"\" style=\"text-align: right\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event);$event.stopPropagation()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.delete(item.id)\" ng-disabled=\"item.block_delete\"><md-icon>delete</md-icon><span ng-if=\"!item.block_delete\">Excluir</span> <span ng-if=\"item.block_delete\">{{item.message_block_delete}}</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-content></md-card></div>");
$templateCache.put("app/educational/tables/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-toolbar-tools\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-blur-radial\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" flex=\"\">Tabelas</span></div><span flex=\"\"></span><md-button class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-click=\"vm.openModalChangeTable()\"><md-icon md-font-icon=\"icon-repeat\"></md-icon>Trocar tabela</md-button></div></md-toolbar><md-content layout-xs=\"column\" layout=\"row\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\" style=\"max-height: 900px\"><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"!vm.filter.show\"><div class=\"md-toolbar-tools\"><h2 flex=\"\" style=\"color: black\">{{vm.table.name}}</h2><md-button class=\"md-fab md-mini\" type=\"button\" ng-click=\"vm.filter.show = true\" aria-label=\"filter_list\"><md-icon class=\"material-icons\">filter_list</md-icon></md-button><md-button class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-click=\"vm.openModalAddItem()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar</md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.filter.show && vm.selected.length <= 0\" aria-hidden=\"true\"><div class=\"md-toolbar-tools\"><md-icon class=\"material-icons\">search</md-icon><input flex=\"\" type=\"text\" ng-model=\"vm.query_filter\" ng-model-options=\"vm.filter.options\" placeholder=\"Busca por nome\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"><button class=\"md-icon-button md-primary\" type=\"button\" ng-click=\"vm.removeFilter()\" aria-label=\"close\"><md-tooltip>Cancelar</md-tooltip><md-icon class=\"material-icons\" style=\"color: black;\">close</md-icon></button></div></md-toolbar><md-table-container><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-repeat=\"column in vm.table.columns\"><span>{{column.name}}</span></th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.items.data | filter : vm.query_filter : false\" ng-click=\"vm.editReason(item)\" style=\"cursor: pointer\"><td md-cell=\"\" ng-repeat=\"column in vm.table.columns\" ng-click=\"vm.editComment($event, item, column.id)\">{{item[column.id]}}</td><td md-cell=\"\" style=\"text-align: right\"><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.delete(item.id, item[vm.table.columns[0].id]); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip>Excluir item</md-tooltip></md-icon></md-button></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/educational/tables/views/modal-add-item.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"min-width: 300px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar novo</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container ng-repeat=\"column in vm.scope.columns\"><input flex=\"\" type=\"text\" ng-model=\"vm.item[column.id]\" placeholder=\"{{column.name}}\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.answer(vm.item);\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/tables/views/modal-change-table.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"min-width: 300px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Selecionar tabela</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container><label>Tabelas disponíveis</label><md-select ng-model=\"vm.table\"><md-option ng-repeat=\"(key, table) in vm.scope.tables\" ng-value=\"table\">{{table.name}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.answer(vm.table);\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/timetable-template/views/form.html","<md-dialog aria-label=\"Create TimetableTemplate\" md-theme=\"educational\" style=\"width: 800px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.form.timetable_template.id\">Criar template de Grade de Horário</h2><h2 ng-if=\"vm.form.timetable_template.id\">Editar template de Grade de Horário</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><a4-form-dic-data bind=\"vm.form\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" on-paginate=\"vm.paginate\" fields-schema=\"app/educational/timetable-template/form.json\"></a4-form-dic-data></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/timetable-template/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-timetable\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{\'TIMETABLETEMPLATE.TITLE\' | translate}}</span></div></div></md-toolbar><md-content><a4-form-dic-data bind=\"vm.grid\" on-submit=\"vm.submit(item, form)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editTimetableTemplate(item)\" on-delete=\"vm.delete(index)\" fields-schema=\"app/educational/timetable-template/grid.json\"></a4-form-dic-data></md-content></div>");
$templateCache.put("app/educational/typing-date/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke !important\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'TYPING_DATE.TITLE\' | translate }}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'TYPING_DATE.SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.filterEvaluationCriteriaList(vm.search)\" translate=\"\" translate-attr-placeholder=\"TYPING_DATE.SEARCH_FOR_ANYONE\"></md-input-container></div></md-toolbar><md-content style=\"background-color: whitesmoke !important\"><md-card class=\"md-padding\"><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[15, 25, 50, 100]\" md-page=\"vm.grid.current_page\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.paginate\" md-page-select=\"\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination><md-table-container style=\"padding-left: 10px; padding-right: 10px\"><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"vm.selected_bank_slip\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Nome</span></th><th md-column=\"\">Tipo de bloqueio</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.grid.data\" ng-click=\"vm.editEvaluationCriteria(item)\" style=\"cursor: pointer;\"><td md-cell=\"\">{{item.name}}</td><td md-cell=\"\">{{item.block_type_name}}</td></tr><tr md-row=\"\" ng-if=\"vm.grid.data.length == 0\"><td md-cell=\"\">Não há configurações</td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/educational/typing-date/views/typing-date-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ui-sref=\"private.educational.typing-date.list\" policy-access=\"aluno_alt\" style=\"margin-right: 10px; !important;\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"logo-icon\"><md-icon md-font-icon=\"con-clipboard-text\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{vm.form.grade_rule.name}}</span></div></div></md-toolbar><form ng-submit=\"vm.submit(vm.form.grade_rule, typing_date_form)\" name=\"typing_date_form\"><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important\"><md-card class=\"md-padding\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244); margin-bottom: 20px;\" flex=\"\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Tipo de bloqueio</b> <small>Abaixo selecione o tipo de bloqueio para notas</small></div></div><md-radio-group ng-model=\"vm.form.grade_rule.block_type\" layout=\"row\"><md-radio-button ng-repeat=\"choice in vm.list.grade_rule.block_type\" flex=\"\" value=\"{{choice.id}}\" class=\"md-primary\">{{choice.name}}<md-tooltip md-direction=\"bottom\">{{choice.description}}</md-tooltip></md-radio-button></md-radio-group><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244); margin-bottom: 20px; margin-top: 20px;\" flex=\"\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Eventos</b> <small>Abaixo se encontram os eventos do critério de avaliação</small></div></div><md-table-container style=\"padding-left: 10px; padding-right: 10px\"><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"vm.selected_bank_slip\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">{{ \'TYPING_DATE.NAME\' | translate }}</th><th md-column=\"\">{{ \'TYPING_DATE.OPENING\' | translate }}</th><th md-column=\"\">{{ \'TYPING_DATE.CLOSURE\' | translate }}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.form.grade_rule.grade_rule_items\" ng-click=\"vm.editEvaluationCriteria(item)\" style=\"cursor: pointer;\"><td md-cell=\"\">{{item.name_event}}</td><td md-cell=\"\"><date-picker ng-model=\"item.open_typing_date\"></date-picker></td><td md-cell=\"\"><date-picker ng-model=\"item.close_typing_date\"></date-picker></td></tr><tr md-row=\"\" ng-if=\"vm.form.grade_rule.grade_rule_items.length == 0\"><td md-cell=\"\">Não há regras</td><td md-cell=\"\"></td></tr></tbody></table></md-table-container><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" type=\"submit\">Salvar</md-button></md-card-actions></md-card></md-content></form></div>");
$templateCache.put("app/educational/typing-date/views/typing-date.html","<div ui-view=\"typing-date\"></div>");
$templateCache.put("app/evaluations/device-register/views/add-device-modal.html","<md-dialog aria-label=\"Editar Dispositivo\" md-theme=\"evaluations\" style=\"width: 550px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar Dispositivo</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\"><md-input-container style=\"width: 100%!important; margin: 3px\"><label>Nome do dispositivo</label> <input type=\"text\" ng-model=\"vm.device_name\" flex=\"\"></md-input-container><span>{{item.name}}</span></md-card><div layout=\"row\" layout-align=\"space-between center\"><md-checkbox style=\"margin: 5px;\" ng-click=\"vm.is_allowed = !vm.is_allowed\" ng-checked=\"vm.is_allowed == true\">Dispositivo ativo</md-checkbox><md-button style=\"width: 85%\" ng-click=\"vm.addDevice()\">Adicionar dispositivo<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></md-dialog>");
$templateCache.put("app/evaluations/device-register/views/device-modal.html","<md-dialog aria-label=\"Editar Dispositivo\" md-theme=\"evaluations\" style=\"width: 550px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Editar Dispositivo</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.toggleDeviceStatus()\"><md-icon md-font-icon=\"icon-pen\" ng-if=\"!vm.device.is_allowed\"></md-icon><md-icon md-font-icon=\"icon-close\" ng-if=\"vm.device.is_allowed\"></md-icon><div ng-if=\"!vm.device.is_allowed\">Ativar Dispositivo</div><div ng-if=\"vm.device.is_allowed\">Desativar Dispositivo</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.deleteDevice()\"><md-icon md-font-icon=\"icon-delete\"></md-icon><div>Excluir Dispositivo</div></a></md-card></md-dialog-content></md-dialog>");
$templateCache.put("app/evaluations/device-register/views/device-register.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-group\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Registro de Dispositivos</span></div></div></md-toolbar><md-content layout=\"row\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><md-input-container layout=\"row\" layout-align=\"end center\" style=\"margin: 2px\"><md-button ng-click=\"vm.openModal(0, null)\"><md-icon md-font-icon=\"icon-plus\" class=\"icon\"></md-icon></md-button></md-input-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" colspan=\"3\">Nome</th><th md-column=\"\" colspan=\"1\">Situação</th></tr></thead><tbody md-body=\"\"><tr ng-repeat=\"device in vm.devices\"><td md-cell=\"\" colspan=\"3\">{{device.name}}</td><td md-cell=\"\" colspan=\"1\" ng-if=\"device.is_allowed\">Ativo</td><td md-cell=\"\" colspan=\"1\" ng-if=\"!device.is_allowed\">inativo</td><td md-cell=\"\" colspan=\"3\"><md-button style=\"float: right;\" ng-click=\"vm.openModal(1, device)\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon></md-button></td></tr></tbody></table></md-card></md-content></div>");
$templateCache.put("app/evaluations/question-scales/views/modal.html","<md-dialog aria-label=\"Escalas\" md-theme=\"evaluations\" style=\"width: 650px;\"><form ng-cloak=\"\" name=\"formScale\" ng-submit=\"vm.submit()\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.scope.is_edit\">Editar escala</h2><h2 ng-if=\"!vm.scope.is_edit\">Criar escala</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\"><div layout=\"column\" style=\"margin-bottom: 10px\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Escalas dos questionários</b> <small>Defina a lista de itens da escala, que serão critérios para a avaliação de questões (ex: Bom, médio, ruim).</small></div></div></div><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%\"><input ng-model=\"vm.scope.scale.name\" placeholder=\"Nome\" required=\"\"></md-input-container><div><md-subheader class=\"primary\"><div layout=\"row\" layout-align=\"space-between center\"><span>Itens da escala</span><md-button class=\"md-icon-button\" ng-click=\"vm.scope.scale.addRow(vm.scope.scale)\"><md-icon>add</md-icon></md-button></div></md-subheader><md-list flex=\"\"><md-list-item ng-repeat=\"scale_item in vm.scope.scale.question_scale_items track by $index\" flex=\"\"><md-input-container flex=\"40\" class=\"md-input-has-placeholder\"><input type=\"text\" ng-model=\"scale_item.name\" placeholder=\"Nome\" required=\"\"></md-input-container><md-input-container flex=\"40\" class=\"md-input-has-placeholder\"><input type=\"text\" ng-model=\"scale_item.alias\" placeholder=\"Apelido\" required=\"\"></md-input-container><md-button flex=\"5\" class=\"md-icon-button\" ng-click=\"vm.scope.scale.moveUp(vm.scope.scale.question_scale_items, vm.scope.scale.question_scale_items.indexOf(scale_item))\"><md-icon md-font-icon=\"icon-chevron-up\"></md-icon></md-button><md-button flex=\"5\" class=\"md-icon-button\" ng-click=\"vm.scope.scale.moveDown(vm.scope.scale.question_scale_items, vm.scope.scale.question_scale_items.indexOf(scale_item))\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></md-button><md-button flex=\"10\" class=\"md-icon-button\" ng-click=\"vm.scope.scale.question_scale_items.splice(vm.scope.scale.question_scale_items.indexOf(scale_item), 1)\"><md-icon>delete</md-icon></md-button></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button ng-click=\"vm.answer(vm.scope.scale)\" class=\"send-button md-accent md-raised\" ng-disabled=\"formScale.$invalid || vm.show_loading\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/evaluations/question-scales/views/question-scales.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-group\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Escalas de questionários</span></div></div></md-toolbar><md-content layout-xs=\"column\" layout=\"row\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"scale in vm.scales\" style=\"cursor: pointer\" ng-click=\"vm.editScale(scale)\"><td md-cell=\"\"><span style=\"padding: 4px;\">{{scale.name}}</span></td><td md-cell=\"\" style=\"text-align: right\"><md-button class=\"md-icon-button\" ng-disabled=\"!scale.can_delete\" ng-click=\"vm.deleteScale(scale);$event.stopPropagation()\"><md-icon>delete</md-icon><md-tooltip ng-if=\"!scale.can_delete\">A escala não pode ser excluída, pois existem questões utilizando-a.</md-tooltip></md-button></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/evaluations/questionnaire-events/views/modal.html","<md-dialog aria-label=\"Escalas\" md-theme=\"evaluations\" style=\"width: 650px;\"><form ng-cloak=\"\" name=\"formScale\" ng-submit=\"vm.submit()\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.scope.is_edit\">Editar etapa</h2><h2 ng-if=\"!vm.scope.is_edit\">Criar etapa</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\"><div layout=\"column\" style=\"margin-bottom: 10px\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Etapa dos questionários</b> <small>Defina o nome e a lista de itens da etapa</small></div></div></div><md-input-container class=\"md-input-has-placeholder\" style=\"width: 100%\"><input ng-model=\"vm.scope.name\" placeholder=\"Nome\" required=\"\"></md-input-container><div><md-subheader class=\"primary\"><div layout=\"row\" layout-align=\"space-between center\"><span>Itens da etapa</span><md-button class=\"md-icon-button\" ng-click=\"vm.scope.addRow(vm.scope.questionnaire_event_items)\"><md-icon>add</md-icon></md-button></div></md-subheader><md-list flex=\"\"><md-list-item ng-repeat=\"question_event in vm.scope.questionnaire_event_items track by $index\" flex=\"\"><md-input-container flex=\"40\" class=\"md-input-has-placeholder\"><input type=\"text\" ng-model=\"question_event.name\" placeholder=\"Nome\" required=\"\"></md-input-container><md-input-container flex=\"40\" class=\"md-input-has-placeholder\"><input type=\"text\" ng-model=\"question_event.alias\" placeholder=\"Apelido\" required=\"\"></md-input-container><span flex=\"20\"><a4-card-controls item=\"question_event\" array=\"vm.scope.questionnaire_event_items\" sub-item-index=\"null\" can-delete=\"vm.scope.can_delete\" type=\"\'events\'\"></a4-card-controls></span></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button ng-click=\"vm.answer(vm.scope)\" class=\"send-button md-accent md-raised\" ng-disabled=\"formScale.$invalid || vm.show_loading\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/evaluations/questionnaire-events/views/questionnaire-events.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-server\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Etapas dos questionários</span></div></div></md-toolbar><md-content layout-xs=\"column\" layout=\"row\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"event in vm.events\" style=\"cursor: pointer\" ng-click=\"vm.editEvent(event)\"><td md-cell=\"\"><span style=\"padding: 4px;\">{{event.name}}</span></td><td md-cell=\"\" style=\"text-align: right\"><md-button class=\"md-icon-button\" ng-disabled=\"!event.can_delete\" ng-click=\"vm.deleteEvent(event);$event.stopPropagation()\"><md-icon>delete</md-icon></md-button><md-tooltip ng-if=\"!event.can_delete\">A etapa não pode ser excluído, pois existem questionários utilizando-a.</md-tooltip></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/evaluations/questionnaires/correct-questionnaire/correct-questionnaire.html","<md-dialog aria-label=\"Questionário\" md-theme=\"evaluations\" style=\"min-width: 800px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"margin-left: 5px\">Corrigir questões</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><a4-grid-dic-data bind=\"vm.grid\" style=\"width: 100%;\" on-click-item=\"vm.correctQuestionnaire(item)\" fields-schema=\"app/evaluations/questionnaires/correct-questionnaire/grid.json\"></a4-grid-dic-data></md-dialog>");
$templateCache.put("app/evaluations/questionnaires/exercises-list/exercises-list.html","<questionnaires-list questionnaires-type=\"1\" label=\"\'Listas de exercícios\'\" icon=\"\'icon-library-books\'\"></questionnaires-list>");
$templateCache.put("app/evaluations/questionnaires/general-research/general-research.html","<div layout=\"row\" layout-align=\"center center\" style=\"position: relative; top: 40%; transform: translateY(-40%)\"><md-card class=\"soon_module_card\"><div><h1><md-icon md-font-icon=\"icon-clock\"></md-icon>Módulo em construção!</h1><h2>Em breve você poderá criar qualquer tipo de avaliação/pesquisa de opinião a ser respondida por qualquer grupo desejado: Alunos, pais e responsáveis, professores e/ou demais colaboradores.</h2></div></md-card></div>");
$templateCache.put("app/evaluations/questionnaires/knowledge-config/knowledge-config.html","<questionnaires-header-footer-config type=\"\'evaluation\'\"></questionnaires-header-footer-config>");
$templateCache.put("app/evaluations/questionnaires/knowledge-test/knowledge-test.html","<questionnaires-list questionnaires-type=\"2\" label=\"\'Testes e provas\'\" icon=\"\'icon-pencil-box\'\"></questionnaires-list>");
$templateCache.put("app/evaluations/questionnaires/pedagogic-evaluation/pedagogic-evaluation.html","<div layout=\"row\" layout-align=\"center center\" style=\"position: relative; top: 40%; transform: translateY(-40%)\"><md-card class=\"soon_module_card\"><div><h1><md-icon md-font-icon=\"icon-clock\"></md-icon>Módulo em construção!</h1><h2>Em breve você poderá criar questionários para que o psicopedagogo da sua instituição possa avaliar individualmente alunos que precisam de atenção especial.</h2></div></md-card></div>");
$templateCache.put("app/evaluations/questionnaires/questionnaires-config/questionnaires-config.html","<questionnaires-header-footer-config type=\"\'questionnaire\'\"></questionnaires-header-footer-config>");
$templateCache.put("app/evaluations/questionnaires/questions-repository/questions-repository.html","<questionnaires-list questionnaires-type=\"0\" label=\"\'Banco de questões\'\" icon=\"\'icon-folder-multiple\'\"></questionnaires-list>");
$templateCache.put("app/evaluations/questionnaires/students-evaluation/students-evaluation.html","<questionnaires-list questionnaires-type=\"20\" label=\"\'Avaliação de alunos\'\" icon=\"\'icon-human-child\'\"></questionnaires-list>");
$templateCache.put("app/evaluations/questionnaires/teachers-evaluation/teachers-evaluation.html","<div layout=\"row\" layout-align=\"center center\" style=\"position: relative; top: 40%; transform: translateY(-40%)\"><md-card class=\"soon_module_card\"><div><h1><md-icon md-font-icon=\"icon-clock\"></md-icon>Módulo em construção!</h1><h2>Em breve você poderá criar questionários para que os alunos possam avaliar os professores, você terá como resultado posições estatísticas dessas avaliações.</h2></div></md-card></div>");
$templateCache.put("app/evaluations/questionnaires/views/answers-log.html","<md-dialog aria-label=\"Selecionar turma ou aluno\" md-theme=\"evaluations\" style=\"min-width: 400px\"><md-toolbar><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\">Log de respostas de {{vm.questionnaire_name}}</h1><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content><div flex=\"\" layout=\"row\" layout-align=\"center center\"><md-input-container flex=\"100\" style=\"width: 80%\"><md-select ng-model=\"vm.selected_students\" multiple=\"\" flex=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Selecione um aluno para filtragem\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"student in vm.students\" ng-value=\"student.id\">{{student.name}}</md-option></md-select></md-input-container><md-button ng-click=\"vm.selected_students = null\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip md-direction=\"bottom\">Limpar filtros</md-tooltip></md-button><md-button ng-click=\"vm.getAnswerslog(vm.selected_students)\" class=\"send-button md-accent md-raised\">Filtrar</md-button></div><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Aluno</th><th md-column=\"\">questao</th><th md-column=\"\">Resposta</th><th md-column=\"\">Data de registro</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"answer_log in vm.answers_log\"><td md-cell=\"\">{{answer_log.name}}</td><td md-cell=\"\">{{answer_log.question_number}}</td><td md-cell=\"\" style=\"text-align: justify;\">{{answer_log.answer}}</td><td md-cell=\"\">{{answer_log.qlog_created_at}}</td></tr></tbody></table></md-table-container></md-content></md-dialog>");
$templateCache.put("app/evaluations/questionnaires/views/change-status-modal.html","<md-dialog aria-label=\"Edit Enrolment Date\" md-theme=\"evaluations\" style=\"min-width: 350px; min-height: 150px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Editar status do questionário</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div style=\"padding: 40px; width: 90%;\"><md-select ng-model=\"vm.scope.selectedStatus\"><md-option ng-repeat=\"status in vm.scope.questionnaireStatus\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.answer({selectedStatus: vm.scope.selectedStatus})\" style=\"padding: 1px;\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/evaluations/questionnaires/views/import-question.html","<md-dialog aria-label=\"Questionário\" md-theme=\"evaluations\" style=\"min-width: 800px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"margin-left: 5px\">Importar questões</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container flex=\"\" ng-if=\"!vm.show_search\"><input type=\"text\" ng-model=\"vm.stem\" placeholder=\"Enunciado\" required=\"\" ng-change=\"vm.searchQuestion()\" ng-model-options=\"{ debounce: 1000 }\"></md-input-container><md-chips flex=\"\" ng-model=\"vm.tags\" md-enable-chip-edit=\"true\" placeholder=\"Adicionar tag\" delete-hint=\"Pressione delete para remover\" md-require-match=\"false\" ng-change=\"vm.searchQuestion()\" md-transform-chip=\"vm.transformChip($chip)\" md-separator-keys=\"vm.customKeys\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getQuestionTags(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"420\" input-aria-describedby=\"autocompleteTitle\" placeholder=\"Etiquetas\"><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-autocomplete><md-chip-template><span><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" md-mode=\"indeterminate\" ng-if=\"vm.show_load_tag\"></md-progress-circular>{{$chip.name}}</span></md-chip-template></md-chips></div><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"padding: 15px !important;\">Questão</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"question in vm.questions\" md-select-id=\"id\" md-select=\"question\"><td md-cell=\"\" style=\"padding: 15px !important;\"><span class=\"td-first-line\">{{question.stem}}</span> <span class=\"td-second-line\">{{ question.tag_list }}</span><br><span class=\"td-second-line\">Autor: {{ question.author_name }} | Origem: {{question.questionnaire_name}}</span></td></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; width: 100%\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(vm.selected)\"><span>Importar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/evaluations/questionnaires/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"{{icon}}\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{label}}</span></div></div><div flex=\"65\" layout=\"row\" layout-align=\"end end\"><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"course\"><md-icon md-font-icon=\"icon-school\"></md-icon></label><md-input-container id=\"course\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.course_id\" placeholder=\"Curso\" ng-init=\"vm.loadCourses()\" ng-change=\"vm.setGroups(vm.course_id); vm.getSubjectsByCourse(vm.course_id); vm.getAll()\" md-on-open=\"vm.loadCourses()\"><md-option ng-value=\"null\"><em>Todos os cursos</em></md-option><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course.id\">{{course.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"group\"><md-icon md-font-icon=\"icon-chair-school\"></md-icon></label><md-input-container id=\"group\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.group_id\" placeholder=\"Turma\" ng-change=\"vm.getAll()\" ng-disabled=\"vm.course_id == null\"><md-option ng-value=\"null\"><em>Todas as turmas</em></md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"subject\"><md-icon md-font-icon=\"icon-book-open\"></md-icon></label><md-input-container id=\"subject\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.subject_id\" ng-change=\"vm.getAll()\" ng-disabled=\"vm.course_id == null\"><md-option ng-value=\"null\"><em>Todas as disciplinas</em></md-option><md-option ng-repeat=\"subject in vm.subjects\" ng-value=\"subject.id\" ng-disabled=\"vm.course_id == null\">{{subject.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"status\"><md-icon md-font-icon=\"icon-book-open\"></md-icon></label><md-input-container id=\"status\" md-no-float=\"\" class=\"m-0\" flex=\"\"><md-select ng-model=\"vm.questionnaire_id\" ng-change=\"vm.getAll()\"><md-option ng-value=\"null\"><em>Todos os status</em></md-option><md-option ng-repeat=\"status in vm.questionnaire_status\" ng-value=\"status.name\">{{status.name}}</md-option></md-select></md-input-container></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"Pesquisar\" type=\"text\" ng-model=\"vm.search\"></md-input-container></div></div></md-toolbar><md-content layout-xs=\"column\" layout=\"row\" style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" flex=\"\"><md-input-container style=\"margin-top: 10px\"><md-checkbox ng-model=\"vm.show_inactive\" ng-change=\"vm.getAll()\">Mostrar inativos</md-checkbox></md-input-container><md-table-container class=\"table-float-button\"><md-table-pagination md-limit=\"vm.questionnaires.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.questionnaires.current_page\" md-on-paginate=\"vm.getAll\" style=\"border: none\" md-total=\"{{vm.questionnaires.total}}\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.order\" md-on-reorder=\"vm.reorder\"><tr md-row=\"\"><th md-column=\"\" colspan=\"1\" md-order-by=\"name\">Nome</th><th md-column=\"\" colspan=\"3\" md-order-by=\"description\">Descrição</th><th md-column=\"\" colspan=\"3\" md-order-by=\"questionnaire_answer_type_id\">Tipo</th><th md-column=\"\" colspan=\"3\" md-order-by=\"grade_rule_item_name\">Evento</th><th md-column=\"\" colspan=\"2\" ng-if=\"questionnairesType < vm.STUDENTS_EVALUATION\" md-order-by=\"course_equivalence\">Equivalência</th><th md-column=\"\" colspan=\"2\" ng-if=\"questionnairesType < vm.STUDENTS_EVALUATION\" md-order-by=\"subject_name\">Disciplina</th><th md-column=\"\" colspan=\"2\" md-order-by=\"questionnaire_status\">Status</th><th md-column=\"\" colspan=\"1\" md-order-by=\"creation\" style=\"text-align: right\">Data de criação</th><th md-column=\"\" colspan=\"1\" md-order-by=\"application_date\" style=\"text-align: right\">Data de realização</th><th md-column=\"\" colspan=\"1\" md-order-by=\"answer_max_time_minutes\" style=\"text-align: right\">Horário de inicialização</th><th md-column=\"\" colspan=\"1\" md-order-by=\"execution_time\" style=\"text-align: right\">Horário de encerramento</th><th md-column=\"\" colspan=\"1\" style=\"text-align: right\">Ações</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.questionnaires.data | orderBy:vm.orderBy\" ng-click=\"vm.openEditModal(item)\" style=\"cursor: pointer\"><td md-cell=\"\" colspan=\"1\">{{item.name}} <span class=\"badge\" ng-if=\"item.is_inactive\"><span>Inativo</span></span></td><td md-cell=\"\" colspan=\"3\">{{item.description}}</td><td md-cell=\"\" colspan=\"3\">{{item.questionnaire_answer_type_id}}</td><td md-cell=\"\" colspan=\"3\">{{item.grade_rule_item_name}}</td><td md-cell=\"\" colspan=\"2\" ng-if=\"questionnairesType < vm.STUDENTS_EVALUATION\">{{item.course_equivalence}}</td><td md-cell=\"\" colspan=\"2\" ng-if=\"questionnairesType < vm.STUDENTS_EVALUATION\">{{item.subject_name}}</td><td md-cell=\"\" colspan=\"2\">{{ (item.questionnaire_status === \'Concluído\') || (item.application_date < currentDate || (item.application_date == currentDate && currentTime > item.execution_time)) ? \'Concluído\' : (item.questionnaire_status === \'Em andamento\' || item.questionnaire_status === \'Em andamento (especial)\') || (item.application_date == currentDate && item.answer_max_time_minutes < currentTime && item.execution_time > currentTime) ? \'Em andamento\' : ((item.questionnaire_status === \'Rascunho\' || item.questionnaire_status === \'Publicado\') && item.application_date !== null) || (item.application_date > currentDate || (item.application_date == currentDate && currentTime < item.answer_max_time_minutes)) ? \'Não realizado\' : \'\' }}</td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\">{{item.creation}}</td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\"><div ng-if=\"item.questionnaire_answer_type_id === \'Online\'\">{{item.application_date}}</div></td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\"><div ng-if=\"item.questionnaire_answer_type_id === \'Online\'\">{{item.answer_max_time_minutes}}</div></td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\"><div ng-if=\"item.questionnaire_answer_type_id === \'Online\'\">{{item.execution_time}}</div></td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event);$event.stopPropagation()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"questionnairesType === 2 || questionnairesType === 1\"><md-button ng-click=\"vm.printEvaluation(item)\" ng-disabled=\"item.questionnaire_status_id == 25 && (vm.company === 101321 || vm.company === 101224 || vm.company === 683) && (vm.current_profile == 7)\"><md-icon>print</md-icon>Imprimir</md-button></md-menu-item><md-menu-item ng-if=\"questionnairesType === vm.STUDENTS_EVALUATION\"><md-button ng-click=\"vm.selectGroupForQuestionnaire(item, 0)\"><md-icon>description</md-icon>Preencher</md-button></md-menu-item><md-menu-item ng-if=\"questionnairesType === vm.STUDENTS_EVALUATION\"><md-button ng-click=\"vm.publishQuestionnaire(item.id)\"><md-icon>done</md-icon>Publicar para os alunos</md-button></md-menu-item><md-menu-item ng-if=\"questionnairesType === vm.STUDENTS_EVALUATION\"><md-button ng-click=\"vm.selectGroupForQuestionnaire(item, 1)\"><md-icon>print</md-icon>Imprimir</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.getPrintRightAnswerSheet(item.id)\" ng-disabled=\"item.questionnaire_status_id == 25 && (vm.company === 101321 || vm.company === 101224 || vm.company === 683) && (vm.current_profile == 7)\"><md-icon>print</md-icon>Imprimir Gabarito</md-button></md-menu-item><md-menu-item ng-if=\"questionnairesType === 2\"><md-button ng-click=\"vm.printReplyCard(item.id)\"><md-icon>print</md-icon>Imprimir Cartão de resposta</md-button></md-menu-item><md-menu-item ng-if=\"(vm.company === 101321 || vm.company === 101224 || vm.company === 683) && (vm.current_profile == 0 || vm.current_profile == 3)\"><md-button ng-click=\"vm.approveOrDisapproveQuestionnaire(item.id)\"><md-icon>edit</md-icon>Aprovar/Negar questionário</md-button></md-menu-item><md-menu-item ng-if=\"item.questionnaire_answer_type_id == \'Online\'\"><md-button ng-click=\"vm.getAnswersLog(item.id, item.name)\"><md-icon>book</md-icon>Log de respostas</md-button></md-menu-item><md-menu-item ng-if=\"questionnairesType === vm.KNOWLEDGE_TEST\"><md-button ng-click=\"vm.changeStatusQuestionnaire(item)\"><md-icon>edit</md-icon>Alterar status</md-button></md-menu-item><md-menu-item policy-access=\"evaluations_questionnaire_duplicate\"><md-button ng-click=\"vm.duplicate(item)\"><md-icon>content_copy</md-icon>Duplicar</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.activateUnactivate(item)\"><span ng-if=\"!item.is_inactive\"><md-icon>block</md-icon>Inativar</span> <span ng-if=\"item.is_inactive\"><md-icon>done</md-icon>Ativar</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-card></md-content></div>");
$templateCache.put("app/evaluations/questionnaires/views/questionnaire-page.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\" style=\"position: fixed\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.backPage()\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-text\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" ng-if=\"vm.form.id != null\">Editar {{vm.title}} {{vm.form.name}}</span> <span class=\"logo-text\" ng-if=\"vm.form.id == null\">Criar {{vm.title}}</span></div></div><div layout=\"row\" layout-align=\"end center\" style=\"position:fixed; right: 0px\" ng-if=\"vm.current_tab === 2 && vm.form.questionnaire_answer_type_id == 10\"><md-button><md-tooltip>Incorporar nota ao evento</md-tooltip><md-icon md-font-icon=\"icon-pencil\" ng-click=\"vm.applyGrade(vm.grade_rule_item_selected.name)\"></md-icon></md-button></div></md-toolbar><md-content layout-xs=\"column\" layout=\"row\" style=\"background-color: whitesmoke; !important;\"><form ng-cloak=\"\" name=\"formQuest\"><md-toolbar style=\"background-color: white; position: fixed; top: 140px; !important;\"><div layout=\"row\" flex=\"\"><md-tabs md-center-tabs=\"\" md-selected=\"vm.current_tab\" flex=\"100\" ng-model=\"vm.show_question_fab\"><md-tab id=\"informations\" label=\"informações\" ng-click=\"vm.disableQuestionFab()\"></md-tab><md-tab id=\"questions\" label=\"questões\" ng-click=\"vm.enableQuestionFab()\" ng-disabled=\"vm.form.questionnaire_type_id === vm.TESTES_E_PROVAS && !vm.isInformationsTabValid()\"></md-tab><md-tab id=\"groups\" label=\"turmas\" ng-click=\"vm.disableQuestionFab()\" ng-if=\"vm.form.questionnaire_type_id >= 20\"></md-tab><md-tab id=\"students\" label=\"alunos\" ng-click=\"vm.disableQuestionFab()\" ng-if=\"(vm.form.questionnaire_type_id === vm.TESTES_E_PROVAS) && vm.form.questionnaire_answer_type_id == 10\"></md-tab></md-tabs></div></md-toolbar><md-content layout=\"column\" layout-align=\"center center\" flex=\"\" style=\"background-color: whitesmoke !important;\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-center-tabs=\"\" class=\"noTabPanel\" md-selected=\"vm.current_tab\" ng-model=\"vm.show_fab\" style=\"padding-top: 150px\"><md-tab label=\"informações\"><md-card class=\"md-padding min-width-700\"><div layout=\"column\"><div layout=\"row\" style=\"background-color: #e6e1e1; border-radius: 5px; padding-right: 10px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><p><b>Atenção!</b> Para que a aba de questões esteja disponível preencha todos os campos obrigatórios de formulário previamente.</p></div></div><br></div><div layout=\"column\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Título *</b> <small>Dê um nome para o seu questionário</small></div></div><md-input-container style=\"margin-top: -2px;\"><input ng-model=\"vm.form.name\" required=\"\"></md-input-container></div><div layout=\"column\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Descrição</b> <small>Escreva um resumo explicativo do seu questionário</small></div></div><md-input-container class=\"md-input-has-placeholder\" style=\"margin-top: -2px;\"><textarea type=\"text\" ng-model=\"vm.form.description\" rows=\"2\"></textarea></md-input-container></div><div layout=\"column\" ng-if=\"vm.form.questionnaire_type_id >= 0 && vm.form.questionnaire_type_id <= 2 && vm.academic_type === 1\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Equivalência do questionário *</b> <small>Selecione a equivalência de curso que o questionário utilizará para aplicação</small></div></div><md-input-container class=\"md-input-has-placeholder\"><md-select ng-model=\"vm.form.course_equivalence_id\" ng-change=\"vm.filterCourseEquivalence(vm.form.course_equivalence_id)\" ng-disabled=\"vm.online_questionnaire_done || vm.form.name == null\" required=\"\"><md-option ng-value=\"null\" ng-if=\"vm.form.questionnaire_answer_type_id !== 10\">Nenhuma</md-option><md-option ng-repeat=\"equivalence in vm.form_info.course_equivalences\" ng-value=\"equivalence.id\">{{equivalence.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" ng-if=\"vm.form.questionnaire_type_id >= 0 && vm.form.questionnaire_type_id <= 2\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Disciplina do questionário *</b> <small>Determine a disciplina para qual este questionário é destinado</small></div></div><md-input-container style=\"margin-top: 2px;\"><md-select ng-model=\"vm.form.subject_id\" required=\"\" ng-disabled=\"vm.online_questionnaire_done || vm.form.course_equivalence_id == null\" ng-change=\"vm.filterCourses(vm.form.subject_id)\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchSubject\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"subject in vm.form_info.subjects | filter: searchSubject\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" ng-if=\"vm.form.questionnaire_type_id >= 20\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Etapa do questionário</b> <small>Selecione a etapa que será utilizada na realização do questionário</small></div></div><md-input-container class=\"md-input-has-placeholder\"><md-select ng-model=\"vm.form.questionnaire_event_id\"><md-option ng-value=\"null\">Nenhuma</md-option><md-option ng-repeat=\"questionnaire_event in vm.form_info.questionnaire_events\" ng-value=\"questionnaire_event.id\">{{questionnaire_event.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" ng-if=\"vm.form.questionnaire_type_id == vm.TESTES_E_PROVAS\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Forma de resposta *</b> <small>De que modo os alunos responderão ao questionário</small></div></div><md-input-container class=\"md-input-has-placeholder\"><md-select ng-model=\"vm.form.questionnaire_answer_type_id\" required=\"\" ng-disabled=\"vm.online_questionnaire_done || vm.form.subject_id == null\"><md-option ng-repeat=\"questionnaire_answer_type in vm.form_info.questionnaire_answer_types\" ng-value=\"questionnaire_answer_type.id\">{{questionnaire_answer_type.name}}</md-option></md-select></md-input-container></div><div ng-repeat=\"course in vm.courses_and_groups\" layout=\"column\" ng-if=\"vm.form.questionnaire_type_id < 20\"><span style=\"color: #959595\">{{course.course_name}}</span> <span ng-repeat=\"group in course.groups\" style=\"margin-bottom: 1px !important;\" layout=\"row\"><md-input-container style=\"width: 45%\"><md-checkbox ng-value=\"group.group_id\" ng-checked=\"vm.groups.includes(group.group_id)\" ng-click=\"vm.insertOrRemoveGroup(group.group_id, group)\" style=\"width: 100%;margin-left: 0 !important; margin-right: 0 !important; margin-bottom: 0;\" flex=\"\" layout=\"row\">{{group.group_name}} <span ng-if=\"vm.school_period === 0\">{{group.matrix_period}}º período</span> <span ng-if=\"vm.groups.includes(group.group_id) && vm.form.questionnaire_type_id === 20\"><select2 ng-model=\"group.person_id_respondent\" style=\"width: 115px; margin-left: 10px; margin-right: 0px;\" id=\"select-{{group.group_id}}\" s2-options=\"val.id as val.name for val in vm.teachers\" options=\"{ placeholder: \'Professor\' }\"></select2></span></md-checkbox></md-input-container></span></div><div layout=\"column\" ng-if=\"vm.form.questionnaire_answer_type_id == 10 && vm.form.questionnaire_type_id === vm.TESTES_E_PROVAS\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Evento do questionário *</b> <small>Determine o evento no qual a nota do questionário será lançada</small></div></div><md-input-container style=\"margin-top: 2px;\"><md-select ng-model=\"vm.grade_rule_item_selected\" required=\"\" ng-disabled=\"vm.online_questionnaire_done\" ng-change=\"vm.getAvailableStudents(vm.groups)\"><md-option ng-repeat=\"gradeRuleItem in vm.gradeRuleItems track by gradeRuleItem.name\" ng-value=\"gradeRuleItem\" ng-selected=\"gradeRuleItem.name === vm.grade_rule_item_selected.name\">{{gradeRuleItem.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" ng-if=\"vm.form.questionnaire_answer_type_id == 10\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Total de pontos *</b> <small>Nota máxima do questionário</small></div></div><md-input-container class=\"md-input-has-placeholder\" style=\"margin-top: 2px;\"><input ng-model=\"vm.grade_rule_item_selected.max_grade\" ui-number-mask=\"1\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" ng-if=\"vm.form.questionnaire_answer_type_id == 10\"><div layout=\"row\"><div flex=\"60\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Data e Hora de inicio do questionario</b></div></div><div layout=\"row\"><md-input-container class=\"md-input-has-placeholder\"><md-datepicker ng-model=\"vm.selectedDate\" ng-disabled=\"vm.online_questionnaire_done\" required=\"\"></md-datepicker></md-input-container><md-input-container class=\"md-input-has-placeholder\" style=\"margin-top: 22px\"><md-icon class=\"material-icons\">access_time</md-icon><input type=\"text\" ng-model=\"vm.selectedTime\" ui-time-mask=\"HH:MM\" required=\"\" ng-disabled=\"vm.online_questionnaire_done\"></md-input-container></div></div><div flex=\"40\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Horário de termino</b></div></div><div layout=\"row\" ng-disabled=\"vm.online_questionnaire_done\"><md-input-container class=\"md-input-has-placeholder\" style=\"margin-top: 22px;\"><md-icon class=\"material-icons\">access_time</md-icon><input type=\"text\" ng-model=\"vm.execution_time\" ui-time-mask=\"HH:MM\" required=\"\" ng-disabled=\"vm.online_questionnaire_done\"></md-input-container></div></div></div></div></md-card></md-tab><md-tab label=\"questões\"><md-card class=\"md-padding min-width-700\"><div><div ng-if=\"vm.items.length === 0\"><p>Ainda não há questões feitas para esse questionário!</p></div><md-card ng-repeat=\"item in vm.items\" class=\"md-padding\"><a4-question question=\"item\" move=\"vm.move(type, item, updown, sub_item_index)\" questions=\"vm.items\" delete=\"vm.deleteQuestion(question)\" questionnaire-answer-type=\"vm.form.questionnaire_answer_type_id\" questionnaire-type=\"vm.form.questionnaire_type_id\" online-questionnaire-done=\"vm.online_questionnaire_done\" question-types=\"vm.form_info.question_types\" question-scales=\"vm.form_info.question_scales\" add-sub-question=\"vm.addOption(question)\" questionnaire=\"vm.form.id\"></a4-question></md-card></div></md-card></md-tab><md-tab label=\"turmas\" ng-if=\"vm.form.questionnaire_type_id >= 20\"><md-card class=\"md-padding min-width-700\"><div ng-repeat=\"course in vm.courses_and_groups\" layout=\"column\"><span style=\"color: #959595\">{{course.course_name}}</span> <span ng-repeat=\"group in course.groups\" style=\"margin-bottom: 1px !important;\" layout=\"column\"><div layout=\"row\" style=\"background-color: #faed77; border-left: solid 4px #f3db03; border-radius: 3px; padding: 8px 12px; margin-bottom: 16px;\" ng-if=\"vm.groups.includes(group.group_id)\"><div flex=\"\" layout=\"column\"><p style=\"margin: 0; font-size: 13px; color: #1d1c1c;\"><b>Atenção:</b> Deixe o campo \"Professor\" vazio para permitir que tanto o professor principal <span ng-if=\"group.main_teacher\"><b>\'(\' + {{group.main_teacher}} + \')\'</b></span><span ng-if=\"!group.main_teacher\">(não definido)</span> quanto o auxiliar <span ng-if=\"group.assistant_teacher\"><b>{{group.assistant_teacher}}</b></span><span ng-if=\"!group.assistant_teacher\">(não definido)</span> da turma possam responder ao questionário.</p></div></div><div layout=\"row\"><md-input-container style=\"width: 45%\"><md-checkbox ng-value=\"group.group_id\" ng-checked=\"vm.groups.includes(group.group_id)\" ng-click=\"vm.insertOrRemoveGroup(group.group_id, group)\" style=\"width: 100%;margin-left: 0 !important; margin-right: 0 !important; margin-bottom: 0;\" flex=\"\" layout=\"row\">{{group.group_name}} <span ng-if=\"vm.school_period === 0\">{{group.matrix_period}}º período</span><span ng-if=\"vm.groups.includes(group.group_id) && vm.form.questionnaire_type_id === 20\" style=\"width: 20%;\"><select2 ng-model=\"group.person_id_respondent\" style=\"margin-left: 10px; margin-right: 0px;\" id=\"select-{{group.group_id}}\" s2-options=\"val.id as val.name for val in vm.teachers\" options=\"{ placeholder: \'Professor\' }\"></select2></span></md-checkbox></md-input-container></div></span></div></md-card></md-tab><md-tab label=\"alunos\" ng-if=\"vm.form.questionnaire_answer_type_id == 10\"><md-card class=\"md-padding min-width-700\"><md-checkbox ng-model=\"vm.select_students\" ng-click=\"vm.selectStudents(vm.grid.rows)\">Selecionar alunos</md-checkbox><div ng-if=\"!vm.select_students\"><a4-grid-dic-data bind=\"vm.grid\" style=\"width: 100%;\" on-click-actions=\"vm.clickActions(item, option)\" fields-schema=\"app/evaluations/questionnaires/correct-questionnaire/grid.json\"></a4-grid-dic-data></div><table md-table=\"\" ng-if=\"vm.select_students\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Situação</span></th><th md-column=\"\"><span>Nota</span></th></tr></thead><tbody md-body=\"\"><tr ng-repeat=\"student in vm.grid.rows track by $index\" md-row=\"\"><td md-cell=\"\" md-truncate=\"\"><md-checkbox ng-click=\"vm.toggleStudent(student, $index)\" ng-if=\"vm.form.id == undefined || student.status <= 1\" ng-checked=\"student.status_name == \'Pendente\'\"></md-checkbox></td><td md-cell=\"\" md-truncate=\"\"><span>{{student.name}}</span></td><td md-cell=\"\" md-truncate=\"\"><span>{{student.status_name}}</span></td><td md-cell=\"\" md-truncate=\"\"><span>{{student.points}}</span></td></tr></tbody></table></md-card></md-tab></md-tabs><div ng-model=\"vm.show_question_fab\"><div class=\"min-width-700\" layout=\"row\" layout-align=\"end center\" style=\"background-color: whitesmoke; margin-bottom: 20px;\" ng-if=\"vm.show_question_fab == 0 || vm.show_question_fab == null\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.backPage()\">Cancelar</md-button><md-button type=\"button\" class=\"send-button md-accent md-raised\" ng-click=\"vm.submit(backpage)\" ng-disabled=\"formQuest.$invalid || vm.show_loading\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Salvar</span></md-button></div></div></md-content><div ng-model=\"vm.show_question_fab\"><div style=\"position: fixed; bottom: 10px; right: 10px;\"><button class=\"md-fab md-fab-bottom-right md-evaluations-theme md-primary md-button ng-scope md-ink-ripple md-vm.options.theme-theme\" style=\"position: absolute; bottom: 280px;\" ng-if=\"vm.show_question_fab == 1\" type=\"button\" aria-label=\"Importar questão\" ng-disabled=\"vm.online_questionnaire_done\" ng-click=\"vm.importItem()\"><md-tooltip md-direction=\"left\">Importar questão</md-tooltip><md-icon md-font-icon=\"icon-import\"></md-icon></button> <button class=\"md-fab md-fab-bottom-right md-evaluations-theme md-primary md-button ng-scope md-ink-ripple md-vm.options.theme-theme\" style=\"position: absolute; bottom: 210px;\" ng-if=\"vm.show_question_fab == 1\" type=\"button\" aria-label=\"Adicionar separador\" ng-disabled=\"vm.online_questionnaire_done\" ng-click=\"vm.addItemSeparator()\"><md-tooltip md-direction=\"left\">Adicionar separador</md-tooltip><md-icon md-font-icon=\"icon-minus\"></md-icon></button> <button class=\"md-fab md-fab-bottom-right md-evaluations-theme md-primary md-button ng-scope md-ink-ripple md-vm.options.theme-theme\" style=\"position: absolute; bottom: 140px;\" ng-if=\"vm.show_question_fab == 1\" type=\"button\" aria-label=\"Adicionar questão\" ng-disabled=\"vm.online_questionnaire_done\" ng-click=\"vm.addItem()\"><md-tooltip md-direction=\"left\">Adicionar questão</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></button> <button class=\"md-fab md-fab-bottom-right md-evaluations-theme md-primary md-button ng-scope md-ink-ripple md-vm.options.theme-theme\" style=\"position: absolute; bottom: 70px;\" ng-if=\"vm.show_question_fab == 1\" type=\"button\" ng-click=\"vm.submit(backpage)\" ng-disabled=\"formQuest.$invalid || vm.show_loading\" layout=\"row\" ng-keydown=\"vm.preventEnterSubmit($event)\"><md-tooltip md-direction=\"left\">Salvar e sair</md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon><md-icon md-font-icon=\"icon-content-save\"></md-icon></button> <button class=\"md-fab md-fab-bottom-right md-evaluations-theme md-primary md-button ng-scope md-ink-ripple md-vm.options.theme-theme\" style=\"position: absolute; bottom: 0px;\" type=\"button\" ng-click=\"vm.submit(!backpage)\" ng-disabled=\"formQuest.$invalid || vm.show_loading\" layout=\"row\" ng-keydown=\"vm.preventEnterSubmit($event)\"><md-tooltip md-direction=\"left\">Salvar</md-tooltip><md-icon md-font-icon=\"icon-content-save\"></md-icon></button></div></div></form></md-content></div>");
$templateCache.put("app/evaluations/questionnaires/views/questionnaire-realize.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-comment-processing\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Preenchimento do questionário</span></div></div></md-toolbar></div><md-subheader style=\"padding: 8px; font-size: 18px; width: 100%;\"><div layout=\"row\" layout-align=\"space-between center\"><span>Aluno selecionado: {{vm.selected_questionnaire.name}} | Número de matrícula: {{vm.selected_questionnaire.number}} | Turma: {{vm.selected_questionnaire.group_name}}</span><div ng-if=\"vm.selected_questionnaire.status == 0 && vm.selected_questionnaire.questionnaire_person_teacher == vm.user_id\"><md-button class=\"md-raised\" ng-click=\"vm.submit(false)\">Salvar e sair</md-button><md-button class=\"md-raised\" ng-click=\"vm.submit(true)\">Salvar e seguir para próximo aluno</md-button></div><div ng-if=\"vm.selected_questionnaire.status != 0 && vm.selected_questionnaire.questionnaire_person_teacher != vm.user_id\"><md-button class=\"md-raised\" ng-click=\"vm.quitOrGoToNext(false)\">Sair</md-button><md-button class=\"md-raised\" ng-click=\"vm.quitOrGoToNext(true)\">Seguir para próximo aluno</md-button></div></div><div ng-if=\"vm.selected_questionnaire.status != 0 && vm.selected_questionnaire.questionnaire_person_teacher != vm.user_id\"><span style=\"padding: 8px; font-size: 18px; background-color: rgb(252, 64, 64); color:black; margin-top: 8px; border-radius: 6px;\"><b>Atenção!</b> Você não pode responder esse questionário, pois ele já foi respondido por {{vm.selected_questionnaire.teacher_name}}</span></div></md-subheader><md-content layout-xs=\"column\" layout=\"column\" layout-align=\"center center\" style=\"background-color: rgba(243,238,89,0.46) !important;\"><md-card style=\"text-align: left; width: 50%; padding: 10px; border-top: solid 8px rgb(235,195,30); border-radius: 6px;\"><h1>{{vm.selected_questionnaire.questionnaire_info.name}}</h1><p>{{vm.selected_questionnaire.questionnaire_info.description}}</p></md-card><md-card ng-repeat=\"question in vm.selected_questionnaire.questions\" style=\"text-align: left; width: 50%; padding: 10px; border-radius: 6px;\"><h1>{{question.stem}}</h1><p ng-if=\"question.notes !== null\">{{question.notes}}</p><div ng-if=\"question.question_type_id == \'QU\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/unique-option.html\'\"></div><div ng-if=\"question.question_type_id == \'QM\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/multiple-option.html\'\"></div><div ng-if=\"question.question_type_id == \'TM\'\"><md-input-container style=\"width: 100% !important;\"><label>Escreva a resposta</label> <textarea ng-model=\"question.right_answer\" rows=\"3\" flex=\"\" style=\"width: 100% !important;\" ng-if=\"vm.questionnaire_type == 20 ||!vm.show_answers\" ng-disabled=\"vm.is_correcting || (vm.selected_questionnaire.status != 0 && vm.selected_questionnaire.questionnaire_person_teacher != vm.user_id)\"></textarea></md-input-container></div><div ng-if=\"question.question_type_id == \'TU\' || question.question_type_id == \'NU\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/unique-text.html\'\"></div><div ng-if=\"question.question_type_id == \'XU\'\"><table md-table=\"\" flex=\"\" class=\"questionnaire-table\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"width: 70%; text-align: left !important;\"></th><th md-column=\"\" ng-repeat=\"option in question.options\" style=\"white-space: nowrap;\">{{option.name}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"sub_item in question.items\"><td style=\"width: 70%; text-align: left !important;\">{{sub_item.stem}}</td><td ng-repeat=\"answer in question.options\"><md-radio-group ng-model=\"sub_item.right_answer\" layout=\"row\" ng-disabled=\"vm.selected_questionnaire.status != 0 && vm.selected_questionnaire.questionnaire_person_teacher != vm.user_id\"><md-radio-button ng-value=\"{{answer.ord}}\"></md-radio-button></md-radio-group></td></tr></tbody></table></div><div ng-if=\"question.question_type_id == \'XM\'\"><table md-table=\"\" flex=\"\" class=\"questionnaire-table\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"width: 70%; text-align: left !important;\"></th><th md-column=\"\" ng-repeat=\"option in question.options\" style=\"white-space: nowrap;\">{{option.name}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"sub_item in question.items\"><td style=\"width: 70%; text-align: left !important;\">{{sub_item.stem}}</td><td ng-repeat=\"answer in question.options\"><md-input-container><md-checkbox ng-model=\"sub_item[answer.ord]\" ng-checked=\"sub_item.right_answer && sub_item.right_answer.includes(answer.ord)\" ng-disabled=\"vm.selected_questionnaire.status != 0 && vm.selected_questionnaire.questionnaire_person_teacher != vm.user_id\"></md-checkbox></md-input-container></td></tr></tbody></table></div></md-card></md-content>");
$templateCache.put("app/evaluations/questionnaires/views/questionnaire-select-options-modal.html","<md-dialog aria-label=\"Questionário\" md-theme=\"evaluations\" style=\"width: 550px;\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon ng-if=\"vm.type === 0\">description</md-icon><md-icon ng-if=\"vm.type === 1\">print</md-icon><h2 style=\"margin-left: 5px\"><span ng-if=\"vm.type === 0\">Preenchimento</span> <span ng-if=\"vm.type === 1\">Impressão</span> do questionário</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><div style=\"padding: 6px;\"><div layout=\"row\" style=\"border-left: solid 4px #FBC02D\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px; padding-top: 5px;\"><b>Filtro para <span ng-if=\"vm.type === 0\">o preenchimento</span> <span ng-if=\"vm.type === 1\">a impressão</span> do questionário</b> <small>Selecione abaixo o tipo de filtro que será aplicado no preenchimento do questionário</small></div></div><md-input-container><md-radio-group ng-model=\"vm.filter_selected\"><div layout=\"row\"><md-radio-button class=\"md-primary\" ng-value=\"0\">Filtrar por aluno</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"1\" style=\"margin-left: 5px;\">Filtrar por turma</md-radio-button></div></md-radio-group></md-input-container></div><div style=\"padding: 6px;\" ng-if=\"vm.filter_selected === 1\"><div layout=\"row\" style=\"border-left: solid 4px #FBC02D\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Turma para <span ng-if=\"vm.type === 0\">preenchimento</span> <span ng-if=\"vm.type === 1\">impressão</span> do questionário</b> <small>Selecione abaixo a turma cujos alunos terão o questionário <span ng-if=\"vm.type === 0\">preenchido</span> <span ng-if=\"vm.type === 1\">impresso</span></small></div></div><div layout=\"column\"><md-input-container><md-select ng-model=\"vm.scope.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.scope.groups\" ng-value=\"group.group_matrix_period\">{{group.course_alias}} - {{group.group_name}} <span ng-if=\"vm.scope.school_period_id === 0\">{{group.matrix_period}}º período</span></md-option></md-select></md-input-container></div></div><div style=\"padding: 6px;\" ng-if=\"vm.filter_selected === 0\"><div layout=\"row\" style=\"border-left: solid 4px #FBC02D\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Aluno para <span ng-if=\"vm.type === 0\">preenchimento</span> <span ng-if=\"vm.type === 1\">impressão</span> do questionário</b> <small>Selecione abaixo, opcionalmente, um aluno para <span ng-if=\"vm.type === 0\">preencher</span> <span ng-if=\"vm.type === 1\">imprimir</span> o questionário.</small></div></div><div layout=\"column\"><md-autocomplete flex=\"\" md-input-name=\"student\" md-input-minlength=\"3\" md-no-cache=\"true\" md-delay=\"1000\" md-selected-item=\"vm.scope.student\" md-search-text=\"searchTextStudent\" md-items=\"item in vm.getStudentsByGroup(searchTextStudent)\" md-item-text=\"item.name\" md-floating-label=\"Nome do aluno\"><md-item-template><span md-highlight-text=\"vm.searchTextStudent\">{{item.name}}</span></md-item-template></md-autocomplete></div></div><div style=\"padding: 6px;\"><div layout=\"row\" style=\"border-left: solid 4px #FBC02D\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Etapa para o <span ng-if=\"vm.type === 0\">preenchimento</span> <span ng-if=\"vm.type === 1\">impressão</span> do questionário</b> <small>Selecione abaixo a etapa do <span ng-if=\"vm.type === 0\">preenchimento</span> <span ng-if=\"vm.type === 1\">impressão</span> do questionário</small></div></div><div layout=\"column\"><md-input-container><md-select ng-model=\"vm.scope.event_selected\"><md-option ng-repeat=\"event in vm.scope.events\" ng-value=\"event.id\">{{event.name}}</md-option><md-option ng-if=\"vm.scope.events.length === 0\" ng-value=\"null\">Etapa única</md-option></md-select></md-input-container></div></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; width: 100%\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(vm.scope)\" ng-disabled=\"vm.scope.group_selected === null || (vm.filter_selected === 0 && vm.scope.student === null)\"><span ng-if=\"vm.type === 0\">Continuar</span> <span ng-if=\"vm.type === 1\">Imprimir</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/evaluations/questionnaires/views/questionnaires-header-footer-config.html","<md-card class=\"md-padding\" flex=\"\"><form ng-cloak=\"\" name=\"form_config_quest\"><div layout=\"row\"><div layout=\"column\" style=\"margin-right: 100px;\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Exibição da logo</b></div></div><md-input-container flex=\"100\"><md-radio-group ng-model=\"vm.form.questionnaire_knowledge_show_logo\" layout=\"row\" ng-if=\"type === \'evaluation\'\"><md-radio-button ng-value=\"\'left\'\">Esquerda</md-radio-button><md-radio-button ng-value=\"\'right\'\">Direita</md-radio-button><md-radio-button ng-value=\"\'top\'\">Centralizado</md-radio-button><md-radio-button ng-value=\"null\">Sem logo</md-radio-button></md-radio-group><md-radio-group ng-model=\"vm.form.questionnaire_opinion_show_logo\" layout=\"row\" ng-if=\"type === \'questionnaire\'\"><md-radio-button ng-value=\"\'left\'\">Esquerda</md-radio-button><md-radio-button ng-value=\"\'right\'\">Direita</md-radio-button><md-radio-button ng-value=\"\'top\'\">Centralizado</md-radio-button><md-radio-button ng-value=\"null\">Sem logo</md-radio-button></md-radio-group><md-input-container flex=\"100\" ng-if=\"type === \'evaluation\'\"><md-checkbox ng-model=\"vm.form.is_mandatory_registered_device_for_exams\" class=\"md-primary\">Tornar obrigatório o cadastro de dispositivo para a realização de provas online.</md-checkbox></md-input-container></md-input-container></div><div layout=\"column\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Fontes</b></div></div><div layout=\"row\"><md-input-container flex=\"100\" style=\"margin: 15px;\"><label>Fonte</label><md-select ng-model=\"vm.form.font_family\"><md-option ng-repeat=\"font in vm.font_styles\" ng-value=\"font\">{{font}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" style=\"margin: 15px;\"><label>Tamanho da Fonte</label><md-select ng-model=\"vm.form.font_size\"><md-option ng-repeat=\"size in vm.font_sizes\" value=\"{{size}}\">{{size}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" style=\"margin: 15px;\"><label>Espaçamento das linhas</label> <input type=\"number\" ng-model=\"vm.form.line_spacing\" min=\"1\" step=\"0.1\"></md-input-container></div></div></div><div layout=\"column\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Cabeçalho</b> <small>Desenhe um cabeçalho que será apresentado na impressão <span ng-if=\"type === \'questionnaire\'\">dos questionários</span> <span ng-if=\"type === \'evaluation\'\">das avaliações de conhecimento</span></small></div></div><md-card><textarea ui-tinymce=\"vm.tinymceOptionsHeader\" ng-model=\"vm.form.header\"></textarea></md-card><div layout=\"row\" layout-align=\"start center\"><label>Variáveis de texto:</label><md-input-container flex=\"40\"><md-select name=\"variables\" ng-model=\"variableSelectedHeader\" ng-change=\"vm.setVariable(variableSelectedHeader, \'header\')\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchVariableHeader\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"item\" ng-repeat=\"item in vm.variables | filter: searchVariableHeader\">{{item.presentation}}</md-option></md-select></md-input-container></div></div><div layout=\"column\"><div layout=\"row\" style=\"border-left: solid 4px #FDD835\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Rodapé</b> <small>Desenhe um rodapé que será apresentado na impressão <span ng-if=\"type === \'questionnaire\'\">dos questionários</span> <span ng-if=\"type === \'evaluation\'\">das avaliações de conhecimento</span></small></div></div><md-card><textarea ui-tinymce=\"vm.tinymceOptionsFooter\" ng-model=\"vm.form.footer\"></textarea></md-card><div layout=\"row\" layout-align=\"start center\"><label>Variáveis de texto:</label><md-input-container flex=\"40\"><md-select name=\"variables\" ng-model=\"variableSelectedFooter\" ng-change=\"vm.setVariable(variableSelectedFooter, \'footer\')\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchVariableFooter\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"item\" ng-repeat=\"item in vm.variables | filter: searchVariableFooter\">{{item.presentation}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.saveConfig()\">Salvar</md-button></div></form></md-card>");
$templateCache.put("app/evaluations/questionnaires/views/select-group-or-student.html","<md-dialog aria-label=\"Selecionar turma ou aluno\" md-theme=\"evaluations\" style=\"min-width: 400px\"><md-toolbar><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\">Seleção de turma ou aluno para impressão</h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"form-wrapper\"><form ng-cloak=\"\"><md-input-container style=\"text-align: center\"><md-radio-group ng-model=\"vm.scope.option\" layout=\"row\"><md-radio-button ng-value=\"0\">Selecionar turma</md-radio-button><md-radio-button ng-value=\"1\">Selecionar aluno</md-radio-button></md-radio-group></md-input-container><div style=\"width: 100%\"><md-input-container flex=\"100\" ng-if=\"vm.scope.option === 0\" style=\"width: 100%\"><label>Selecione a turma</label><md-select ng-model=\"vm.scope.selected_group\" flex=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchGroup\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"group in vm.scope.data.groups | filter: searchGroup\" ng-value=\"group.group_id\">{{group.course_name}} - {{group.group_name}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.scope.option === 1\" flex=\"100\" style=\"width: 100%\"><md-select ng-model=\"vm.scope.selected_persons\" multiple=\"\" flex=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchStudent\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"student in vm.scope.data.students | filter: searchStudent\" ng-value=\"student.enrolment_period_id\">{{student.person_name}} - {{student.group_name}}</md-option></md-select></md-input-container></div><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button ng-click=\"vm.answer(vm.scope)\" class=\"md-raised md-accent submit-button\" aria-label=\"Cancelar\">Confirmar</md-button></md-dialog-actions></form></div></md-dialog>");
$templateCache.put("app/finance/a4pag/views/bank-slip-problems-modal.html","<style>\n  md-content.modal{\n    width: 1100px; max-height: 600px;\n  }\n</style><md-dialog aria-label=\"boletos com problemas\" md-theme=\"finance\"><form ng-cloak=\"\" enctype=\"multipart/form-data\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Boletos com problemas</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" style=\"color: #fff;\"></md-icon></md-button></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Sem CPF/CNPJ\" ng-if=\"vm.error_national_id_number.length > 0\"><md-content id=\"soldout\"><md-content class=\"modal\"><bankslipstable list=\"vm.error_national_id_number\"></bankslipstable></md-content></md-content></md-tab><md-tab label=\"CEP inválido\" ng-if=\"vm.error_address_postal_code_invalid.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.error_address_postal_code_invalid\"></bankslipstable></md-content></md-tab><md-tab label=\"Sem CEP\" ng-if=\"vm.error_address_postal_code.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.error_address_postal_code\"></bankslipstable></md-content></md-tab><md-tab label=\"Sem número\" ng-if=\"vm.error_address_house_number.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.error_address_house_number\"></bankslipstable></md-content></md-tab><md-tab label=\"Sem logradouro\" ng-if=\"vm.error_address_street.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.error_address_street\"></bankslipstable></md-content></md-tab><md-tab label=\"Sem Bairro\" ng-if=\"vm.error_address_district.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.error_address_district\"></bankslipstable></md-content></md-tab><md-tab label=\"Sem Cidade\" ng-if=\"vm.error_address_city.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.error_address_city\"></bankslipstable></md-content></md-tab><md-tab label=\"Sem Estado\" ng-if=\"vm.error_address_state.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.error_address_state\"></bankslipstable></md-content></md-tab><md-tab label=\"Sem Multa\" ng-if=\"vm.alert_fine_value.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.alert_fine_value\"></bankslipstable></md-content></md-tab><md-tab label=\"Sem Juros\" ng-if=\"vm.alert_interest_value.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.alert_interest_value\"></bankslipstable></md-content></md-tab><md-tab label=\"Sem Descontos\" ng-if=\"vm.alert_discounts.length > 0\"><md-content class=\"modal\"><bankslipstable list=\"vm.alert_discounts\"></bankslipstable></md-content></md-tab></md-tabs></form></md-dialog>");
$templateCache.put("app/finance/a4pag/views/bank-slips-table.html","<md-table-container><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nosso número</th><th md-column=\"\">Pessoa</th><th md-column=\"\">Descrição</th><th md-column=\"\">Vencimento Boleto</th><th md-column=\"\" md-numeric=\"\">Valor Boleto</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.data\" ng-click=\"vm.goToPerson(item.person_id)\"><td md-cell=\"\">{{item.bank_number || \'Não gerado\'}}</td><td md-cell=\"\"><b>{{item.name}}</b><br><span class=\"td-second-line\" ng-repeat=\"beneficiaries in vm.formatBeneficiaries(item.beneficiaries) | unique\">{{ beneficiaries !== \'null\' ? beneficiaries : \'\' }}<br></span></td><td md-cell=\"\">{{item.bank_slip_description}}</td><td md-cell=\"\">{{item.due_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.amount | currency:\" \"}}</td></tr></tbody></table></md-table-container>");
$templateCache.put("app/finance/additions/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"ADDITIONS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-receipt\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"ADDITIONS.TITLE\"></span></div></div><md-button class=\"md-raised md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openAside($event, \'sidenav-form\')\" aria-label=\"add\" translate=\"\"><md-tooltip md-direction=\"top\">{{ \'ADDITIONS.ADD_RULE\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-receipt\" style=\"color: green\"></md-icon></md-button></md-toolbar><a4-table items=\"vm.allRoles\" filter=\"[\'name\']\" on-delete=\"vm.delete(index)\" on-submit=\"vm.submit(form, data)\" with-list-check-box=\"false\" without-menu-options=\"true\" sidebar-template=\"app/finance/additions/views/sidenavs/sidenav.html\" include-scope=\"vm.includeScope\"></a4-table></div>");
$templateCache.put("app/finance/bank-file-receive/views/details-table.html","<div class=\"progress-div-alfa\" style=\"display: grid; height: 100%;\" ng-show=\"showLoader\"><div class=\"progress-div-beta\"><div class=\"progress-div-gama\" style=\"top: 25%;\"><md-card class=\"progress-card\"><md-progress-circular class=\"progress-circle\" md-diameter=\"60\" md-mode=\"indeterminate\"></md-progress-circular><md-card-content class=\"progress-card-content\"><p>Carregando, por favor aguarde...</p></md-card-content></md-card></div></div></div><md-table-container><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nosso número</th><th md-column=\"\" ng-if=\"soldout === true\">Situação</th><th md-column=\"\" ng-if=\"soldout !== true\">Observações</th><th md-column=\"\">Pessoa</th><th md-column=\"\">Descrição</th><th md-column=\"\">Vencimento Boleto</th><th md-column=\"\" md-numeric=\"\">Valor Boleto</th><th md-column=\"\" ng-if=\"soldout === true\">Data da ocorrência</th><th md-column=\"\" md-numeric=\"\">Tarifa bancária</th><th md-column=\"\" md-numeric=\"\" ng-if=\"soldout === true\">Valor liquidado</th><th md-column=\"\" md-numeric=\"\" ng-if=\"soldout === true\">Principal</th><th md-column=\"\" md-numeric=\"\" ng-if=\"soldout === true\">Descontos</th><th md-column=\"\" md-numeric=\"\" ng-if=\"soldout === true\">Acréscimos</th><th md-column=\"\" md-numeric=\"\" ng-if=\"soldout === true\">Crédito</th><th md-column=\"\" md-numeric=\"\" ng-if=\"soldout === true\">Diferença</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in list.data track by $index\"><td md-cell=\"\">{{item.bank_number == null ? item.bank_number_error : item.bank_number}}</td><td md-cell=\"\" ng-if=\"soldout === true\"><md-tooltip ng-if=\"item.bank_number === null\">Este nosso número não existe no sistema</md-tooltip><md-tooltip ng-if=\"item.issue_sys === 8\">Os dados do arquivo retorno não estão coerentes com os dados no sistema</md-tooltip><md-tooltip ng-if=\"item.issue_sys === 9\">Este boleto já foi liquidado em outro arquivo retorno</md-tooltip>{{item.bank_number === null ? \'Inexistente\' : (item.issue_sys === 8 ? \'Incoerente\' : (item.issue_sys === 9 ? \'Já processado\' : vm.getDetailsStatus(item.operation_sys)))}}<md-button style=\"padding: 0; margin: 0 !important;\" ng-if=\"item.issue_sys === 8\" class=\"md-icon-button md-accent\" ng-click=\"vm.doOperation(item)\"><md-tooltip md-direction=\"top\">Realizar operação</md-tooltip><md-icon md-font-icon=\"icon-check\"></md-icon></md-button><md-icon md-font-icon=\"icon-alert-circle\" style=\"color: red\" ng-if=\"(item.issue_sys === 0 && item.operation_sys === 30) || item.issue_sys === 3 || item.issue_sys === 5 || item.issue_sys === 10\"><md-tooltip ng-if=\"item.issue_sys === 0 && item.operation_sys === 30\">{{item.operation_note}}</md-tooltip><md-tooltip ng-if=\"item.issue_sys === 3\">O título deste boleto foi excluído</md-tooltip><md-tooltip ng-if=\"item.issue_sys === 5\">O título deste boleto não pôde ser liquidado</md-tooltip><md-tooltip ng-if=\"item.issue_sys === 10\">Reprocessamento de boleto, nenhuma ação realizada</md-tooltip></md-icon></td><td md-cell=\"\" ng-if=\"soldout !== true\"><span ng-if=\"item.bank_number === null\">Este nosso número não existe no sistema</span> <span ng-if=\"item.issue_sys === 8\">Os dados do arquivo retorno não estão coerentes com os dados no sistema</span> <span ng-if=\"item.issue_sys === 9\">Este boleto já foi liquidado em outro arquivo retorno</span><md-button style=\"padding: 0; margin: 0 !important;\" ng-if=\"item.issue_sys === 8\" class=\"md-icon-button md-accent\" ng-click=\"vm.doOperation(item)\"><md-tooltip md-direction=\"top\">Realizar operação</md-tooltip><md-icon md-font-icon=\"icon-check\"></md-icon></md-button><span ng-if=\"item.issue_sys === 0 && item.operation_sys === 30\">{{item.operation_note.replace(\'Entrada Rejeitada Erro:\', \'\')}}</span> <span ng-if=\"item.issue_sys === 3\">O título deste boleto foi excluído</span> <span ng-if=\"item.issue_sys === 5\">O título deste boleto não pôde ser liquidado</span> <span ng-if=\"item.issue_sys === 10\">Reprocessamento de boleto, nenhuma ação realizada</span></td><td md-cell=\"\"><b>{{item.bank_number === null ? item.content_info.person : item.person_name}}</b><br><small>{{(item.bank_number === null ? item.content_info.document : (item.corporate_name || item.beneficiary_name))}}</small></td><td md-cell=\"\">{{item.issue_sys === 8 ? (\"Incoerência no retorno:\"+ (item.content_info.person !== null ? \"Sacado \" + item.content_info.person + \" \" + item.content_info.document + \";\" : \"\") + (item.content_info.due_date !== null ? \"Vencimento \" + item.content_info.due_date + \";\" : \"\") + (item.content_info.amount !== null ? \"Valor \" + item.content_info.amount : \"\")) : item.bank_slip_description}}</td><td md-cell=\"\">{{item.bank_number === null ? item.content_info.due_date : item.due_date_slip | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.bank_number === null ? item.content_info.amount : item.amount_slip | currency:\" \"}}</td><td md-cell=\"\" ng-if=\"soldout === true\">{{item.date_operation | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-numeric=\"\">{{item.bank_tarif | currency:\" \"}}</td><td md-cell=\"\" md-numeric=\"\" ng-if=\"soldout === true\">{{item.amount_paid | currency:\" \"}}</td><td md-cell=\"\" md-numeric=\"\" ng-if=\"soldout === true\">{{item.bill_amount | currency:\" \"}}</td><td md-cell=\"\" md-numeric=\"\" ng-if=\"soldout === true\">{{item.discount | currency:\" \"}}</td><td md-cell=\"\" md-numeric=\"\" ng-if=\"soldout === true\">{{item.additionals | currency:\" \"}}</td><td md-cell=\"\" md-numeric=\"\" ng-if=\"soldout === true\" ng-style=\"item.credit > 0 && {\'color\': \'blue\'}\">{{item.credit | currency:\" \"}}</td><td md-cell=\"\" ng-if=\"soldout == true\"><md-input-container style=\"margin-right: 10px;\" ng-if=\"soldout.difference != 0\"><label style=\"color: #000;\">{{item.difference | currency:\" \"}}</label><md-select ng-model=\"item.option_difference\" ng-change=\"vm.differenceTreatment(item, vm.difference_consts[item.option_difference])\"><md-option value=\"undefined\">Diferença: {{item.difference | currency:\" \"}}</md-option><md-option value=\"a_definir\">A Decidir</md-option><md-option value=\"abonar\">Abonar</md-option><md-option value=\"manter_diferenca\">Manter diferença</md-option></md-select></md-input-container><span ng-if=\"item.difference == 0 && soldout === true\">{{item.difference | currency:\" \"}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"list.per_page\" md-limit-options=\"[15, 30, 50, 100]\" md-page=\"list.current_page\" md-total=\"{{list.total}}\" md-on-paginate=\"vm.internPaginate\" md-page-select=\"\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination>");
$templateCache.put("app/finance/bank-file-receive/views/file-receive-details.html","<md-dialog aria-label=\"Processar arquivo retorno\" style=\"min-width: 90%; min-height: 810px;max-width: 100%; max-height: 100%;\" md-theme=\"finance\"><form ng-cloak=\"\" enctype=\"multipart/form-data\" ng-submit=\"vm.uploadFile(vm.file)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Arquivo retorno ( {{ vm.item.file_name }} )</h2><md-button class=\"md-icon-button\" ng-click=\"vm.item.print_details(vm.item.id)\"><md-tooltip md-direction=\"top\">Relatório</md-tooltip><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" style=\"color: #fff;\"></md-icon></md-button></div></md-toolbar><md-input-container><md-checkbox ng-model=\"vm.show_reprocessed\" ng-change=\"vm.paginate()\" ng-if=\"vm.show_reprocesseds\">Exibir reprocessamentos</md-checkbox></md-input-container><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.current_tab\"><md-tab label=\"Liquidados\" md-on-select=\"vm.getDetailsSoldOut()\" ng-disabled=\"!vm.show_soldout\"><md-content id=\"soldout\" style=\"min-height: 700px;\"><detailstable list=\"vm.details.soldout\" paginate-function=\"vm.getDetailsSoldOut(page, qty)\" promisse=\"vm.promisse\" soldout=\"true\"></detailstable></md-content></md-tab><md-tab label=\"Aceitos\" md-on-select=\"vm.getDetailsAccept()\" ng-disabled=\"!vm.show_accept\"><md-content id=\"accept\" style=\"min-height: 700px;\"><detailstable list=\"vm.details.accept\" paginate-function=\"vm.getDetailsAccept(page, qty)\" promisse=\"vm.promisse\" soldout=\"false\"></detailstable></md-content></md-tab><md-tab label=\"Rejeitados\" md-on-select=\"vm.getDetailsRejection()\" ng-disabled=\"!vm.show_rejection\"><md-content id=\"error\" style=\"min-height: 700px;\"><detailstable list=\"vm.details.rejection\" paginate-function=\"vm.getDetailsRejection(page, qty)\" promisse=\"vm.promisse\" soldout=\"false\"></detailstable></md-content></md-tab><md-tab label=\"Baixados\" md-on-select=\"vm.getDetailsDownloaded()\" ng-disabled=\"!vm.show_downloaded\"><md-content id=\"downloaded\" style=\"min-height: 700px;\"><detailstable list=\"vm.details.downloaded\" paginate-function=\"vm.getDetailsDownloaded(page, qty)\" promisse=\"vm.promisse\" soldout=\"false\"></detailstable></md-content></md-tab><md-tab label=\"Taxas\" md-on-select=\"vm.getDetailsTax()\" ng-disabled=\"!vm.show_tax\"><md-content id=\"tax\" style=\"min-height: 700px;\"><detailstable list=\"vm.details.tax\" paginate-function=\"vm.getDetailsTax(page, qty)\" promisse=\"vm.promisse\" soldout=\"false\"></detailstable></md-content></md-tab><md-tab label=\"Outros\" md-on-select=\"vm.getDetailsOthers()\" ng-disabled=\"!vm.show_others\"><md-content id=\"others\" style=\"min-height: 700px;\"><detailstable list=\"vm.details.others\" paginate-function=\"vm.getDetailsOthers(page, qty)\" promisse=\"vm.promisse\" soldout=\"false\"></detailstable></md-content></md-tab></md-tabs></form></md-dialog>");
$templateCache.put("app/finance/bank-file-receive/views/index.html","<style>\n  .bank_file_received_pending > td {\n    color: red !important;\n    /*background-color: rgba(255, 0, 0, 0.6) !important;*/\n  }\n</style><md-card layout=\"column\"><md-content flex=\"\" layout=\"row\"><md-input-container flex=\"\" class=\"file-receive\" style=\"margin-top: 25px;margin-left: 20px;margin-bottom: 0\"><label>{{ \'BANK_SLIP.FORM_ACCOUNT\' | translate }}</label><md-select name=\"current_account\" ng-change=\"vm.get(null, null, vm.current_account_id, vm.show_only_pending)\" ng-model=\"vm.current_account_id\"><md-option ng-value=\"account.id\" ng-repeat=\"account in vm.current_account_type_bank\">{{ account.name }}</md-option></md-select><div ng-messages=\"formPerson.sex.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'BANK_SLIP.FORM_ACCOUNT_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><md-checkbox ng-model=\"vm.show_inactive\" ng-change=\"vm.getCurrentAccount()\">Mostrar contas inativas</md-checkbox></md-input-container><md-input-container flex=\"\"><md-checkbox ng-model=\"vm.show_only_pending\" ng-change=\"vm.get(null, null, vm.current_account_id, vm.show_only_pending)\">Mostrar apenas pendentes</md-checkbox></md-input-container><md-table-pagination flex=\"\" md-limit=\"vm.file_received.per_page\" md-limit-options=\"[15, 30, 50]\" md-page=\"vm.file_received.current_page\" md-total=\"{{vm.file_received.total}}\" md-on-paginate=\"vm.get\" md-page-select=\"\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination></md-content><md-content class=\"md-padding\"><div><md-table-container><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"vm.promise\" ng-style=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\">Nome</th><th md-column=\"\">Lido em</th><th md-column=\"\" style=\"text-align: right\">Seq.</th><th md-column=\"\" style=\"text-align: right\">Qtd</th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\">Liquidado (R$)</th><th md-column=\"\" class=\"text-center\">Detalhes</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"file in vm.file_received.data\" ng-disabled=\"vm.checkPolicies(\'cobanc_ret_alt\')\" ng-class=\"{ \'bank_file_received_pending\': file.id == null && !file.has_no_movement }\"><td md-cell=\"\"><span ng-if=\"file.date === file.date_final\">{{file.date | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"file.date !== file.date_final && file.date !== null\">{{file.date | date:\'dd/MM/yyyy\'}} à {{file.date_final | date:\'dd/MM/yyyy\'}}</span></td><td md-cell=\"\"><span>{{file.file_name_trunc !== null ? \'...\' + file.file_name_trunc : \'\'}}<md-tooltip md-direction=\"right\">{{file.file_name}}</md-tooltip></span></td><td md-cell=\"\"><span>{{ (file.has_no_movement ? \'Sem movimento\' : ((file.id == null) ? \"Pendente\" : file.reading_datetime)) | date:\"dd/MM/yyyy\" }}<md-tooltip ng-if=\"file.id !== null\">{{file.reading_datetime | date:\"HH:mm\" }}</md-tooltip></span></td><td md-cell=\"\" style=\"text-align: right\">{{file.sequential}}</td><td md-cell=\"\" style=\"text-align: right\"><span ng-if=\"file.qty_reprocessed !== null && file.qty_reprocessed > 0\"><md-icon style=\"color: rgba(255,194,81,0.77)\">report_problem</md-icon><md-tooltip md-direction=\"right\">{{file.qty_reprocessed}} reprocessamento(s)</md-tooltip></span> {{file.qty}}</td><td md-cell=\"\" style=\"text-align: right\"><span class=\"item-bfr-grid\"><span>{{file.qty_in_ok !== 0 ? file.qty_in_ok : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_in_ok !== 0 ? \"#0b93d5;\" : \"#dadada\"}\' md-font-icon=\"icon-checkbox-marked\"><md-tooltip md-direction=\"left\">Registrados</md-tooltip></md-icon></span> <span>{{file.qty_in_not_ok !== 0 ? file.qty_in_not_ok : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_in_not_ok !== 0 ? \"#ab0000;\" : \"#dadada\"}\' md-font-icon=\"icon-cancel\"><md-tooltip md-direction=\"left\">Rejeitados</md-tooltip></md-icon></span><span>{{file.qty_received !== 0 ? file.qty_received : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_received !== 0 ? \"#0d8520;\" : \"#dadada\"}\' md-font-icon=\"icon-coin\"><md-tooltip md-direction=\"left\">Liquidados</md-tooltip></md-icon></span> <span>{{file.qty_out !== 0 ? file.qty_out : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_out !== 0 ? \"rgba(149,55,39,0.77);\" : \"#dadada\"}\' md-font-icon=\"icon-arrow-down-bold-circle-outline\"><md-tooltip md-direction=\"left\">Baixados</md-tooltip></md-icon></span> <span>{{file.qty_other !== 0 ? file.qty_other : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_other !== 0 ? \"#aa3f2c;\" : \"#dadada\"}\' md-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"left\">Operação desconhecida</md-tooltip></md-icon></span> <span>{{file.qty_error !== 0 ? file.qty_error : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_error !== 0 ? \"#ab0000;\" : \"#dadada\"}\' md-font-icon=\"icon-alert\"><md-tooltip md-direction=\"left\">Erros</md-tooltip></md-icon></span></span></td><td md-cell=\"\" md-numeric=\"\">{{file.amount_received | currency:\" \"}}</td><td md-cell=\"\" class=\"text-center\"><md-button ng-if=\"file.id != null\" target=\"_blank\" ng-click=\"vm.receivedDetails(file)\" class=\"md-icon-button\"><md-tooltip md-direction=\"top\">Visualizar</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></td></tr><tr md-row=\"\" ng-if=\"vm.file_received.data.length == 0\"><td md-cell=\"\"></td><td md-cell=\"\">Não há arquivos retorno processados</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></div></md-content></md-card>");
$templateCache.put("app/finance/bank-file-receive/views/new-process.html","<md-dialog aria-label=\"Processar arquivo retorno\" md-theme=\"finance\" style=\"min-width: 600px;\"><form ng-cloak=\"\" enctype=\"multipart/form-data\" ng-submit=\"vm.uploadFile(vm.file)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Processar arquivo retorno</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" style=\"color: #fff;\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><md-input-container><input type=\"file\" file-read=\"\" ng-model=\"vm.file\"></md-input-container></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"$root.show_loader\"></md-progress-linear><md-content><div ng-if=\"vm.result_process != null\"><md-table-container><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Cód.</th><th md-column=\"\">Cnab</th><th md-column=\"\">Empresa</th><th md-column=\"\">Nome do banco</th><th md-column=\"\">Qtd. de títulos</th><th md-column=\"\">Total processado</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">{{vm.result_process.header.codBanco}}</td><td md-cell=\"\">{{vm.result_process.cnab}}</td><td md-cell=\"\">{{vm.result_process.header.nomeEmpresa}}</td><td md-cell=\"\">{{vm.result_process.header.nomeBanco}}</td><td md-cell=\"\">{{vm.result_process.collection_length}}</td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-disabled=\"vm.loading_return || vm.doubleclick\" aria-label=\"Add Task\"><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" ng-if=\"vm.loading_return\" md-mode=\"indeterminate\"></md-progress-circular>{{\"FMD.SEND\" | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bank-file-send/views/file-send-details-table.html","<md-table-container><table class=\"md-api-table\" md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nosso número</th><th md-column=\"\">Vencimento</th><th md-column=\"\">Pessoa</th><th md-column=\"\">Descrição</th><th md-column=\"\" md-numeric=\"\">Valor</th><th md-column=\"\" class=\"text-center\">Status do boleto</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in details.data\"><td md-cell=\"\" class=\"{{details.data[$index-1].bank_number !== item.bank_number ? \'hide-data td-date\' : \'hide-data\' }}\">{{details.data[$index-1].bank_number!== item.bank_number ? item.bank_number : \'\'}}</td><td md-cell=\"\" class=\"{{details.data[$index-1].bank_number !== item.bank_number ? \'hide-data td-date\' : \'hide-data\' }}\">{{details.data[$index-1].bank_number !== item.bank_number ? item.due_date : \'\'| date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" class=\"{{details.data[$index-1].bank_number !== item.bank_number ? \'hide-data td-date\' : \'hide-data\' }}\"><b>{{item.person_name}}</b><br><small>{{item.corporate_name || item.beneficiary_name}}</small></td><td md-cell=\"\" class=\"{{details.data[$index-1].bank_number !== item.bank_number ? \'hide-data td-date\' : \'hide-data\' }}\">{{item.product !== null ? item.product_name : item.description}}</td><td md-cell=\"\" md-numeric=\"\" style=\"padding-right: 20px !important;\" class=\"{{details.data[$index-1].bank_number !== item.bank_number ? \'hide-data td-date\' : \'hide-data\' }}\">{{item.amount | currency:\" \"}}</td><td md-cell=\"\" class=\"{{details.data[$index-1].bank_number !== item.bank_number ? \'hide-data td-date\' : \'hide-data\' }} text-center\">{{item.bank_slip_status}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"details.per_page\" md-limit-options=\"[15, 30, 45, 60]\" md-page=\"details.current_page\" md-total=\"{{details.total}}\" md-on-paginate=\"paginate\" md-page-select=\"\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination>");
$templateCache.put("app/finance/bank-file-send/views/file-send-details.html","<md-dialog aria-label=\"Processar arquivo retorno\" style=\"min-width: 90%; min-height: 400px;max-width: 100%; max-height: 100%;\" md-theme=\"finance\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Arquivo remessa ( {{ vm.item.file_name }} )</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" style=\"color: #fff;\"></md-icon></md-button></div></md-toolbar><md-content id=\"tax\" class=\"md-padding\"><md-tabs md-selected=\"vm.current_tab\" md-dynamic-height=\"\" ng-if=\"vm.item.status === \'Processado\'\"><md-tab label=\"Registrados\" md-on-select=\"vm.getDetails()\"><md-content md-padding=\"\"><bank-file-send-details details=\"vm.details\" paginate=\"vm.getDetails\"></bank-file-send-details></md-content></md-tab><md-tab label=\"Rejeitados\" md-on-select=\"vm.getDetails()\"><md-content md-padding=\"\"><bank-file-send-details details=\"vm.details\" paginate=\"vm.getDetails\"></bank-file-send-details></md-content></md-tab></md-tabs><md-content md-padding=\"\" ng-if=\"vm.item.status !== \'Processado\'\"><bank-file-send-details details=\"vm.details\" paginate=\"vm.getDetails\"></bank-file-send-details></md-content></md-content></md-dialog>");
$templateCache.put("app/finance/bank-file-send/views/index.html","<md-card class=\"content layout-column\" layout=\"column\"><md-content layout=\"column\"><md-content layout=\"row\"><md-input-container flex=\"50\" class=\"file-receive\" style=\"margin-top: 25px;margin-left: 20px;margin-bottom: 0\"><label>{{ \'BANK_SLIP.FORM_ACCOUNT\' | translate }}</label><md-select name=\"current_account\" ng-change=\"vm.getAll(null, null, vm.current_account_id)\" ng-model=\"vm.current_account_id\"><md-option ng-value=\"account.id\" ng-repeat=\"account in vm.current_account_type_bank\">{{ account.name }}</md-option></md-select><div ng-messages=\"formPerson.sex.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'BANK_SLIP.FORM_ACCOUNT_REQUIRED\' | translate }}</span></div></div></md-input-container><md-table-pagination flex=\"\" md-limit=\"vm.file_send.per_page\" md-limit-options=\"[15, 30, 50]\" md-page=\"vm.file_send.current_page\" md-total=\"{{vm.file_send.total}}\" md-on-paginate=\"vm.getAll\" md-page-select=\"\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination></md-content><table class=\"dataTable row-border hover\" md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"query.order\"><tr md-row=\"\"><th md-column=\"\"><span>Nome do arquivo</span></th><th md-column=\"\"><span>Data de criação</span></th><th md-column=\"\" style=\"text-align: right\"><span>Sequencial</span></th><th md-column=\"\">Descrição</th><th md-column=\"\" style=\"text-align: right\">Qtd</th><th md-column=\"\">Status</th><th md-column=\"\" style=\"text-align: center\">Processamento</th><th md-column=\"\" policy-access=\"cobanc_rem_alt\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"file in vm.file_send.data\" ng-disabled=\"vm.checkPolicies(\'cobanc\')\"><td md-cell=\"\">{{file.file_name}}</td><td md-cell=\"\">{{file.datetime}}</td><td md-cell=\"\" style=\"text-align: right\">{{file.sequential}}</td><td md-cell=\"\">{{file.description}}</td><td md-cell=\"\" style=\"text-align: right\">{{file.qty_total}}</td><td md-cell=\"\"><span class=\"badge\" style=\"margin-right: 1px !important;\"><span class=\"bfs_{{file.status.replace(\' \', \'_\')}}\">{{file.status}}</span></span> <span ng-if=\"file.status == \'Pendente\' && (file.days_to_due_date >= 0 && file.days_to_due_date <= 3)\"><md-icon style=\"color: #ffc251\">warning<md-tooltip>Este arquivo possui boleto(s) <span ng-if=\"file.days_to_due_date === 0\">que vencem hoje</span> <span ng-if=\"file.days_to_due_date > 0\">vencendo em {{file.days_to_due_date}} dias</span></md-tooltip></md-icon></span> <span ng-if=\"file.status == \'Pendente\' && file.days_to_due_date < 0\"><md-icon style=\"color: #ab0000\">warning<md-tooltip>Remessa inválido: este arquivo possui boletos que estão vencidos a {{-(parseInt(files.days_to_due_date))}} dias</md-tooltip></md-icon></span> <span ng-if=\"file.status == \'Pendente\' && file.qty_canceled > 0\"><md-icon style=\"color: #ffc251\">warning<md-tooltip>Este arquivo possui {{file.qty_canceled}} boleto(s) cancelados</md-tooltip></md-icon></span> <span ng-if=\"file.status == \'Enviado\' && file.days_waiting_for_answer >= 2\"><md-icon style=\"color: #ffc251\">warning<md-tooltip>Aguardando informação de retorno a {{file.days_waiting_for_answer}} dia(s)</md-tooltip></md-icon></span></td><td md-cell=\"\" style=\"text-align: right\"><span ng-if=\"file.status === \'Processado\'\" class=\"item-bfs-grid\"><span>{{file.qty_accepted !== 0 ? file.qty_accepted : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_accepted !== 0 ? \"#0b93d5;\" : \"#dadada\"}\' md-font-icon=\"icon-checkbox-marked\"><md-tooltip md-direction=\"left\">Registrados</md-tooltip></md-icon></span> <span>{{file.qty_rejected !== 0 ? file.qty_rejected : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_rejected !== 0 ? \"#ab0000;\" : \"#dadada\"}\' md-font-icon=\"icon-cancel\"><md-tooltip md-direction=\"left\">Rejeitados</md-tooltip></md-icon></span><span>{{file.qty_paid !== 0 ? file.qty_paid : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_paid !== 0 ? \"#0d8520;\" : \"#dadada\"}\' md-font-icon=\"icon-coin\"><md-tooltip md-direction=\"left\">Liquidados</md-tooltip></md-icon></span> <span>{{file.qty_expired !== 0 ? file.qty_expired : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_expired !== 0 ? \"#3f9dee;\" : \"#dadada\"}\' md-font-icon=\"icon-arrow-down-bold-circle-outline\"><md-tooltip md-direction=\"left\">Baixados</md-tooltip></md-icon></span> <span>{{file.qty_active !== 0 ? file.qty_active : \'\'}}<md-icon ng-style=\'{\"color\": file.qty_active !== 0 ? \"#AD4AB0;\" : \"#dadada\"}\' md-font-icon=\"icon-radiobox-blank\"><md-tooltip md-direction=\"left\">Em aberto</md-tooltip></md-icon></span></span></td><td md-cell=\"\" style=\"text-align: right\"><span ng-if=\"file.status !== \'Sem informação\'\"><md-button ng-class=\"mouse_hover ? \'md-icon-button\' : \'md-icon-button\'\" aria-label=\"Confirmar envio\" ng-click=\"vm.confirmSent(file, true);\" ng-show=\"!file.is_sent && file.status !== \'Cancelado\'\" ng-mouseover=\"mouse_hover = true\" ng-mouseleave=\"mouse_hover = false\"><div><md-tooltip md-direction=\"left\">Confirmar envio</md-tooltip><md-icon ng-class=\"mouse_hover ? \'md-color-green\' : \'\'\" style=\"color: #cccccc\">done</md-icon></div></md-button><md-button class=\"is_conciliated\" ng-class=\"mouse_hover ? \'md-icon-button\' : \'md-icon-button\'\" aria-label=\"Enviado\" ng-click=\"vm.confirmSent(file, false);\" ng-show=\"file.is_sent && file.status !== \'Processado\'\" ng-mouseover=\"mouse_hover = true\" ng-mouseleave=\"mouse_hover = false\"><div ng-if=\"!mouse_hover\"><md-tooltip md-direction=\"top\">Enviado</md-tooltip><md-icon ng-class=\"mouse_hover ? \'md-color-green\' : \'\'\" style=\"color: #00dc00\">done_all</md-icon></div><div ng-if=\"mouse_hover\"><md-tooltip md-direction=\"top\">Desfazer confirmação</md-tooltip><md-icon>cancel</md-icon></div></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.downloadFile(this, file.id)\" target=\"_blank\" ng-show=\"(file.status == \'Pendente\' && file.days_to_due_date >= 0) || file.status == \'Baixado\'\"><md-icon md-font-icon=\"icon-box-download\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.deleteBankFileSend(file)\" ng-show=\"file.status === \'Pendente\' || file.status === \'Baixado\'\"><md-icon>cancel</md-icon><md-tooltip md-direction=\"right\">Cancelar remessa</md-tooltip></md-button><md-button ng-disabled=\"file.block_details\" ng-click=\"vm.fileSendDetails(file)\" class=\"md-icon-button\"><md-tooltip md-direction=\"top\" ng-if=\"!file.block_details\">Visualizar</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-tooltip md-direction=\"top\" ng-if=\"file.block_details\">Arquivo migrado, não é possível ver o detalhamento</md-tooltip></span></td></tr></tbody></table></md-content></md-card>");
$templateCache.put("app/finance/bank-file-send/views/new-file.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"BANK_FILE_SEND.NEW_TITLE\"></span></div></div></md-toolbar><div class=\"content layout-column\" layout=\"column\" style=\"padding-left: 0;padding-right: 0;padding-top: 0 !important;\"><form name=\"form_file_send\" ng-submit=\"vm.submit(form_file_send, vm.filesend)\"><md-card layout=\"column\" layout-xs=\"column\"><md-content layout=\"row\" class=\"md-padding\" style=\"padding-bottom: 0\"><md-input-container flex=\"\"><label>{{ \'BANK_FILE_SEND.ACCOUNT\' | translate }}</label><md-select name=\"current_account\" ng-model=\"vm.filesend.current_account_id\" required=\"\"><md-option ng-value=\"account.id\" ng-repeat=\"account in vm.current_accounts_with_collection_config\">{{ account.name }}</md-option></md-select><div ng-messages=\"bank_file_send.account.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'BANK_FILE_SEND.ACCOUNT_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>{{ \'BANK_FILE_SEND.DESCRIPTION\' | translate }}</label> <input ng-model=\"vm.filesend.description\"></md-input-container></md-content><md-content layout=\"row\" class=\"md-padding\" style=\"padding-bottom: 0; padding-top: 0\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>{{ \'BANK_FILE_SEND.FILE_NAME\' | translate }}</label> <input ng-model=\"vm.filesend.file_name\" required=\"\"><div ng-messages=\"bank_file_send.file_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'BANK_FILE_SEND.FILE_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"40\" class=\"md-input-has-placeholder\"><label>{{ \'BANK_FILE_SEND.SEQUENTIAL\' | translate }}</label> <input ng-value=\"vm.filesend.sequential\" ng-disabled=\"true\" required=\"\"><div ng-messages=\"bank_file_send.sequential.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'BANK_FILE_SEND.SEQUENTIAL_REQUIRED\' | translate }}</span></div></div></md-input-container><div flex=\"10\" align=\"center\" style=\"padding: 10px;\"><md-button md-no-ink=\"\" class=\"md-primary md-raised\" type=\"submit\">{{ \'BANK_FILE_SEND.GENERATE_FILE\' | translate }}</md-button></div></md-content></md-card><md-card><md-content layout=\"column\" class=\"md-padding\"><md-content layout=\"row\" style=\"padding-left: 18px;overflow: hidden;\"><date-range-picker ng-model=\"vm.filter_date\" label=\"Datas\" flex=\"\"></date-range-picker><div flex=\"5\" style=\"margin: 18px 0;\"><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Buscar\" ng-click=\"vm.getAllBankSlipPaginate(1, 15, null, vm.filter_date)\"><md-tooltip md-direction=\"bottom\">Buscar</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><md-table-pagination flex=\"\" style=\"border: none\" md-limit=\"vm.bank_slip_paginate.per_page\" md-limit-options=\"[15, 25, 50, 100]\" md-page=\"vm.bank_slip_paginate.current_page\" md-on-paginate=\"vm.getAllBankSlipPaginate\" md-page-select=\"\" md-total=\"{{vm.bank_slip_paginate.total}}\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination></md-content><md-table-container style=\"padding-left: 10px; padding-right: 10px\"><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"vm.selected\" md-row-select=\"\" multiple=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Quantidade</span></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\">Títulos</th><th md-column=\"\">Vencimento</th><th md-column=\"\">Status</th><th md-column=\"\" md-numeric=\"\">Valor Original</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"bank_slip\" md-select-id=\"bank_number\" ng-repeat=\"bank_slip in vm.bank_slip_paginate.data\"><td md-cell=\"\">{{bank_slip.qtd}}</td><td md-cell=\"\">{{bank_slip.name}}</td><td md-cell=\"\">{{bank_slip.bank_slip_description}}</td><td md-cell=\"\">{{bank_slip.due_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\">{{bank_slip.status}}</td><td md-cell=\"\" md-numeric=\"\">{{bank_slip.amount | currency}}</td></tr><tr md-row=\"\" ng-if=\"vm.bank_slip_paginate.data.length == 0\"><td md-cell=\"\"></td><td md-cell=\"\">Não há boletos disponíveis para remessa</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></md-content></md-card></form></div></div>");
$templateCache.put("app/finance/bank-slip/views/bank-slip-select-modal.html","<md-dialog aria-label=\"Select Bank Slips\" md-theme=\"finance\" style=\"width: 1200px;\" xmlns=\"http://www.w3.org/1999/html\"><style>\n    .blocked-row {\n      background-color: #F49189 !important; /* Cor para indicar que a linha está bloqueada */\n      pointer-events: none; /* Evita que a linha seja clicada */\n      opacity: 0.6; /* Opacidade reduzida para dar um efeito visual de desabilitado */\n    }\n    .expired-row {\n      background-color: #f4e289 !important; /* Cor para indicar que a linha está bloqueada */\n      pointer-events: none; /* Evita que a linha seja clicada */\n      /*opacity: 0.6; !* Opacidade reduzida para dar um efeito visual de desabilitado *!*/\n    }\n    .badge {\n      padding: 5px;\n      /*border-radius: 5px;*/\n      border: none !important;\n      color: black !important;\n      font-size: 1em !important;\n    }\n    .badge-vencido {\n      background-color: #f0ad4e;\n    }\n    .badge-pendente {\n      background-color: #5cb85c;\n    }\n     .badge-aregistrar {\n      background-color: #5cb85c;\n    }\n    .badge-impedido {\n      background-color: #d9534f;\n    }\n    .badge-rejeitado {\n      background-color: #d9534f;\n    }\n    .badge-registrado {\n      background-color:  #5bc0de;\n    }\n    .badge-cancelado {\n      background-color:  #d9534f;\n    }\n    .badge-liquidado {\n      background-color: #5b66de;\n    }\n    .badge-baixado {\n      background-color: #a9a8a8;\n    }\n    .badge-emremessa {\n      background-color: #dea15b;\n    }\n\n\n    case when base.bank_slip_cancel_status_id > 0 then \'Cancelado\'\n    when base.bank_slip_status_id = 6        then \'Liquidado\'\n    when base.bank_slip_status_id = 5        then \'Baixado\'\n    when base.bank_slip_status_id = 1        then \'Em remessa\'\n  </style><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Selecionar boletos</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-table-pagination flex=\"\" style=\"border-top: none\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.bank_slip_paginate.per_page\" md-page=\"vm.bank_slip_paginate.current_page\" md-on-paginate=\"vm.getBankSlips\" md-limit-options=\"[15, 25, 50, 75, 100]\" md-total=\"{{vm.bank_slip_paginate.total}}\"></md-table-pagination><md-table-container style=\"padding-left: 10px; padding-right: 10px\"><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"vm.selected_bank_slips\" md-row-select=\"\" multiple=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Nome/Beneficiários</span></th><th md-column=\"\">Serviços</th><th md-column=\"\">Descrição</th><th md-column=\"\">Vencimento</th><th md-column=\"\">Status</th><th md-column=\"\" md-numeric=\"\">Valor Original</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"bank_slip\" md-select-id=\"bill_ids\" ng-repeat=\"bank_slip in vm.bank_slip_paginate.data\" ng-class=\"{\'blocked-row\': bank_slip.bank_slip_status_text == \'Impedido\', \'expired-row\': bank_slip.bank_slip_status_text == \'Vencido\'}\" ng-disabled=\"bank_slip.bank_slip_status_text == \'Impedido\' || bank_slip.bank_slip_status_text == \'Vencido\'\"><td md-cell=\"\"><span class=\"td-first-line\">{{ bank_slip.name }}</span> <span class=\"td-second-line\" ng-repeat=\"beneficiary in vm.formatBeneficiaries(bank_slip.beneficiaries) | unique\" ng-if=\"!((vm.formatBeneficiaries(bank_slip.beneficiaries) | unique).length === 1 && vm.formatName((vm.formatBeneficiaries(bank_slip.beneficiaries) | unique)[0]) === bank_slip.name)\">{{ beneficiary !== \'null\' ? vm.formatName(beneficiary) : \'Diferença\' }}<br></span></td><td md-cell=\"\"><span class=\"td-second-line\" ng-repeat=\"service in vm.formatServices(bank_slip.services) | unique\">{{ vm.formatName(service) }}<br></span></td><td md-cell=\"\"><span>{{bank_slip.bank_slip_description}}</span> <span class=\"td-second-line\" style=\"opacity: 100% !important;\"><br><strong>{{ bank_slip.restriction }}</strong></span></td><td md-cell=\"\">{{bank_slip.due_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\"><div><span class=\"badge\" ng-class=\"{ \'badge-cancelado\': bank_slip.bank_slip_status_text == \'Cancelado\', \'badge-liquidado\': bank_slip.bank_slip_status_text == \'Liquidado\', \'badge-baixado\': bank_slip.bank_slip_status_text == \'Baixado\', \'badge-emremessa\': bank_slip.bank_slip_status_text == \'Em remessa\', \'badge-vencido\': bank_slip.bank_slip_status_text == \'Vencido\', \'badge-pendente\': bank_slip.bank_slip_status_text == \'Pendente\', \'badge-impedido\': bank_slip.bank_slip_status_text == \'Impedido\', \'badge-rejeitado\': bank_slip.bank_slip_status_text == \'Rejeitado\', \'badge-registrado\': bank_slip.bank_slip_status_text == \'Registrado\', \'badge-aregistrar\': bank_slip.bank_slip_status_text == \'A registrar\' || bank_slip.bank_slip_status_text == \'A registrar*\' }\">{{ bank_slip.bank_slip_status_text }}</span></div></td><td md-cell=\"\" md-numeric=\"\">{{bank_slip.amount - bank_slip.discount_fixed_value | currency}}</td></tr><tr md-row=\"\" ng-if=\"vm.bank_slip_paginate.data.length == 0\"><td md-cell=\"\"></td><td md-cell=\"\">Não há boletos disponíveis para remessa</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-disabled=\"vm.loader || vm.bank_slip_paginate.data.length == 0\" ng-click=\"vm.submit();\"><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" ng-if=\"vm.loader\" md-mode=\"indeterminate\"></md-progress-circular>Gerar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bank-slip/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><style>\n    .print-and-slip {\n      color: #08cc75 !important;\n    }\n  </style><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-view-carousel\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"BANK_SLIP.TITLE\"></span></div></div></md-toolbar><md-content layout=\"column\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Boletos\" md-on-select=\"vm.createFloatButton()\" md-on-deselect=\"vm.destroyFloatButton()\"><md-content style=\"background-color: whitesmoke !important;\"><md-card ng-if=\"vm.file_send_statistics.pending > 0\" ng-click=\"vm.selected_tab = 1\" style=\"cursor: pointer\"><md-content layout=\"row\"><div style=\"background-color: rgb(113, 0, 216); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 30px;\"></i><br><span style=\"font-size: 18px; color: #fff;\">Existem {{vm.file_send_statistics.pending}} arquivos remessa aguardando confirmação de envio para o banco</span></p></div></md-content></md-card><md-card class=\"md-padding\" layout=\"column\"><md-content layout=\"column\"><md-content layout=\"row\" style=\"overflow: hidden\"><md-table-pagination flex=\"\" style=\"border-top: none\" ng-show=\"vm.status !== vm.BANK_SLIP_STATUS_NOT_GENERATED\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.bank_slip_paginate.per_page\" md-page=\"vm.bank_slip_paginate.current_page\" md-on-paginate=\"vm.getAllBankSlipPaginate\" md-limit-options=\"[15, 25, 50, 75, 100]\" md-total=\"{{vm.bank_slip_paginate.total}}\"></md-table-pagination></md-content><md-content><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-class=\"{selectedBankSlipStatus: vm.status == vm.BANK_SLIP_STATUS_NOT_GENERATED}\" ng-click=\"vm.switchStatus(vm.BANK_SLIP_STATUS_NOT_GENERATED)\"><md-icon md-font-icon=\"icon-power\"></md-icon><div>Gerar boletos</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-class=\"{selectedBankSlipStatus: vm.status == vm.BANK_SLIP_STATUS_WAITING_FILE_SEND}\" ng-click=\"vm.switchStatus(vm.BANK_SLIP_STATUS_WAITING_FILE_SEND)\"><md-icon md-font-icon=\"icon-send\"></md-icon><div>Aguardando Remessa</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-class=\"{selectedBankSlipStatus: vm.status == vm.BANK_SLIP_STATUS_TO_REGISTER + \',\' + vm.BANK_SLIP_STATUS_SENT + \',\' + vm.BANK_SLIP_STATUS_REGISTERED}\" ng-click=\"vm.switchStatus(vm.BANK_SLIP_STATUS_REGISTERED)\"><md-icon md-font-icon=\"icon-check-circle\"></md-icon><div>Registrados</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-class=\"{selectedBankSlipStatus: vm.status == vm.BANK_SLIP_STATUS_DONE}\" ng-click=\"vm.switchStatus(vm.BANK_SLIP_STATUS_DONE)\"><md-icon md-font-icon=\"icon-chevron-double-down\"></md-icon><div>Baixados</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-class=\"{selectedBankSlipStatus: vm.status == vm.BANK_SLIP_STATUS_PAID}\" ng-click=\"vm.switchStatus(vm.BANK_SLIP_STATUS_PAID)\"><md-icon>attach_money</md-icon><div>Liquidados</div></a></md-card></md-content><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"vm.status != vm.BANK_SLIP_STATUS_NOT_GENERATED\"><div class=\"md-toolbar-tools\" layout-align=\"space-between\"><div style=\"color: #08cc75; padding-top: 20px;\">Boletos selecionados {{vm.selected_bank_slip.length}}</div><div ng-if=\"vm.status == (vm.BANK_SLIP_STATUS_TO_REGISTER + \',\' + vm.BANK_SLIP_STATUS_SENT + \',\' + vm.BANK_SLIP_STATUS_REGISTERED) || vm.status == vm.BANK_SLIP_STATUS_DONE\"><md-button class=\"md-icon-button\" aria-label=\"Imprimir boletos selecionados\" ng-disabled=\"vm.selected_bank_slip.length < 1\" ng-click=\"vm.printBankSlip()\" style=\"padding-top: 20px;\" title=\"Selecione pelo menos 2 (Dois) boletos.\"><md-tooltip md-direction=\"top\">Ver boletos selecionados</md-tooltip><md-icon ng-class=\"{\'print-and-slip\': vm.selected_bank_slip.length > 1}\" md-font-icon=\"icon-printer\"></md-icon></md-button></div></div></md-toolbar><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.status != vm.BANK_SLIP_STATUS_NOT_GENERATED\" flex=\"25\"><label for=\"srch\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container flex=\"100\"><input id=\"srch\" placeholder=\"Busca por responsáveis dos boletos\" type=\"text\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.searchBankSlip(vm.search_person_bank_slips)\" ng-model=\"vm.search_person_bank_slips\" flex=\"\"></md-input-container></div><md-table-container style=\"padding-left: 10px; padding-right: 10px\" ng-if=\"vm.status != vm.BANK_SLIP_STATUS_NOT_GENERATED\"><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"vm.selected_bank_slip\" md-row-select=\"\" multiple=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Quantidade</span></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\">Títulos</th><th md-column=\"\">Vencimento</th><th md-column=\"\">Status</th><th md-column=\"\" md-numeric=\"\">Valor Original</th><th md-column=\"\" style=\"text-align: center\" policy-access=\"cobanc_bol\" ng-if=\"vm.status == vm.BANK_SLIP_STATUS_SENT\">Ações</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"bank_slip\" md-select-id=\"bill_ids\" md-on-select=\"vm.generateLink()\" md-on-deselect=\"vm.generateLink()\" ng-repeat=\"bank_slip in vm.bank_slip_paginate.data\"><td md-cell=\"\">{{bank_slip.qtd}}</td><td md-cell=\"\">{{bank_slip.name}}</td><td md-cell=\"\">{{bank_slip.bank_slip_description}}</td><td md-cell=\"\">{{bank_slip.due_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\">{{bank_slip.status}}</td><td md-cell=\"\" md-numeric=\"\">{{ bank_slip.amount | currency:\" \" }}</td><td md-cell=\"\" style=\"text-align: center\" policy-access=\"cobanc_bol\" ng-if=\"vm.status == (vm.BANK_SLIP_STATUS_TO_REGISTER + \',\' + vm.BANK_SLIP_STATUS_SENT + \',\' + vm.BANK_SLIP_STATUS_REGISTERED)\"><md-button class=\"md-icon-print md-icon-button\" aria-label=\"Imprimir\" target=\"_blank\" ng-href=\"{{vm.webLink}}/{{ bank_slip.bank_slip_id }}?connection={{vm.subdomain}}\"><md-icon><i class=\"material-icons\">print</i></md-icon></md-button></td></tr><tr md-row=\"\" ng-if=\"vm.bank_slip_paginate.data.length == 0\"><td md-cell=\"\"></td><td md-cell=\"\">Não há boletos disponíveis para remessa</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container><md-content layout=\"column\" class=\"md-padding\" flex=\"\" ng-if=\"vm.status == vm.BANK_SLIP_STATUS_NOT_GENERATED\"><style>\n                  .form {\n                    display: flex;\n                    flex-wrap: wrap;\n                  }\n\n                  .container {\n                    flex: 0 0 auto;\n                    width: 25%;\n                  }\n\n                  @media (max-width: 768px) {\n                    .container {\n                      width: 100%;\n                    }\n                  }\n                </style><form novalidate=\"\" ng-submit=\"vm.generateBankSlipsPDF(vm.bankslipgroup, bankslipform)\" name=\"bankslipform\"><div layout=\"column\"><div layout=\"column\"><div layout=\"row\" class=\"form\"><div layout=\"column\" class=\"container\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div layout=\"column\" style=\"margin-left: 5px\"><b>Regras de boleto</b> <small><b>Selecione</b> a regra de boleto e o período que deseja gerar os boletos</small></div></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" style=\"margin-top: 20px; max-width: 100%;\"><label>Selecione a regra de boleto</label><md-icon md-font-icon=\"icon-barcode\"></md-icon><md-select name=\"bank_slip_rules\" ng-disabled=\"vm.bankslipgroup.current_account_id\" ng-change=\"vm.setCurrentAccount(vm.bankslipgroup.bank_slip_rule_id)\" ng-model=\"vm.bankslipgroup.bank_slip_rule_id\" aria-label=\"Selecione a regra de boleto\"><md-option ng-repeat=\"bank_slip_rule in vm.all_bank_slip_rules\" ng-value=\"bank_slip_rule.id\">{{bank_slip_rule.name}}</md-option></md-select><div ng-messages=\"bankslipform.bank_slip_rules.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar uma regra para impressão.</div></div></md-input-container></div></div><div layout=\"column\" class=\"container\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div layout=\"column\" style=\"margin-left: 5px\"><b>Conta corrente</b> <small><b>Selecione</b> a uma conta corrente para geração de boletos</small></div></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" style=\"margin-top: 20px; width: 100%\"><label>Selecione a conta corrente</label><md-icon md-font-icon=\"icon-cash-multiple\"></md-icon><md-select name=\"bank_slip_rules\" ng-disabled=\"vm.bankslipgroup.bank_slip_rule_id\" ng-change=\"vm.setBankSlipRule(vm.bankslipgroup.current_account_id)\" ng-model=\"vm.bankslipgroup.current_account_id\" aria-label=\"Selecione a regra de boleto\"><md-option ng-repeat=\"current_account in vm.all_current_accounts\" ng-value=\"current_account.id\">{{current_account.name}}</md-option></md-select><div ng-messages=\"bankslipform.bank_slip_rules.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar uma regra para impressão.</div></div></md-input-container></div></div><div layout=\"column\" class=\"container\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div layout=\"column\" style=\"margin-left: 5px\"><b>Filtro por mês</b> <small><b>Selecione</b> abaixo o mês (de acordo com a data de vencimento)</small></div></div><md-input-container class=\"md-block md-input-has-placeholder\"><label>Mês</label><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-select name=\"month_list\" ng-model=\"vm.bankslipgroup.month\" multiple=\"\" ng-change=\"vm.getAllBankSlipRule()\" required=\"\" aria-label=\"mês\"><md-option ng-value=\"null\" ng-show=\"vm.person !== \'\' && vm.person !== null\">Todos em Aberto</md-option><md-option ng-repeat=\"month in vm.months\" ng-value=\"month.id\">{{month.name}}</md-option></md-select><div ng-messages=\"bankslipform.month_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um mês para impressão.</div></div></md-input-container></div><div layout=\"column\" class=\"container\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div layout=\"column\" style=\"margin-left: 5px\"><b>Filtro por ano</b> <small><b>Selecione</b> abaixo o ano (de acordo com a data de vencimento)</small></div></div><md-input-container class=\"md-block md-input-has-placeholder\"><label>Ano</label><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-select name=\"month_list\" ng-model=\"vm.bankslipgroup.year\" ng-change=\"vm.getAllBankSlipRule(); vm.setMonthsForYear()\" required=\"\" aria-label=\"mês\"><md-option ng-repeat=\"year in vm.years\" ng-value=\"year.id\">{{year.name}}</md-option></md-select><div ng-messages=\"bankslipform.month_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um ano para impressão.</div></div></md-input-container></div></div><div style=\"background-color: #FFF4E5; border-left: 4px solid #FF9F1C; padding: 16px; margin-bottom: 16px; border-radius: 4px;\" ng-if=\"vm.getSelectedBankSlipRuleIsApi() == 1 || vm.getSelectedCurrentAccountIsApi() == 1\"><p style=\"margin: 0; color: #5C3B00; font-family: Arial, sans-serif; font-size: 14px; line-height: 1.5;\"><strong style=\"display: block; margin-bottom: 4px;\">Caro usuário, o seu certificado digital VENCERÁ HOJE.</strong> Providencie a atualização do seu certificado imediatamente para evitar que o registro de boletos por esta conta seja interrompida.</p></div><div style=\"background-color: #FFF4E5; border-left: 4px solid #FF9F1C; padding: 16px; margin-bottom: 16px; border-radius: 4px;\" ng-if=\"vm.getSelectedBankSlipRuleIsApi() == 2 || vm.getSelectedCurrentAccountIsApi() == 2\"><p style=\"margin: 0; color: #5C3B00; font-family: Arial, sans-serif; font-size: 14px; line-height: 1.5;\"><strong style=\"display: block; margin-bottom: 4px;\">Caro usuário, o seu certificado digital está para vencer em {{vm.days_to_expire}} {{vm.days_to_expire == 1 ? \'dia\' : \'dias\'}}.</strong> Providencie a atualização do seu certificado antes para evitar que o registro de boletos por esta conta seja interrompida.</p></div><div style=\"background-color: #FFF1F0; border-left: 4px solid #FF4D4F; padding: 16px; margin-bottom: 16px; border-radius: 4px;\" ng-if=\"vm.getSelectedBankSlipRuleIsApi() == 3 || vm.getSelectedCurrentAccountIsApi() == 3\"><p style=\"margin: 0; color: #820014; font-family: Arial, sans-serif; font-size: 14px; line-height: 1.5;\"><strong style=\"display: block; margin-bottom: 4px;\">O seu certificado digital está vencido.</strong> Não será possível registrar boletos por esta conta até que o certificado seja renovado.</p></div></div><div ng-if=\"vm.getSelectedBankSlipRuleIsApi() != 3 && vm.getSelectedCurrentAccountIsApi() != 3\"><md-input-container ng-if=\"!vm.bankslipgroup.current_account_id\"><md-checkbox ng-model=\"vm.bankslipgroup.force_bank_slip_rule\">Forçar trazer boletos de outras regras de boleto para a regra selecionada<br><small>Esta opção faz com que os boletos de outras regras de boleto, e ainda não gerados, estejam disponíveis para esta regra de boleto selecionada</small></md-checkbox></md-input-container><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Geração por pessoa (Opcional)</b> <small>Abaixo você pode escolher qual o pessoa deseja imprimir os boletos</small></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\" style=\"margin-top: 7px;\"><md-autocomplete flex=\"50\" md-no-cache=\"true\" md-selected-item=\"vm.person\" md-min-length=\"0\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-search-text=\"searchText\" md-items=\"item in vm.getBankSlipPerson(searchText)\" md-item-text=\"item.name\" md-floating-label=\"Digite o nome da pessoa\" md-delay=\"500\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Pessoa não encontrada.</md-not-found></md-autocomplete></div></div></div></div><div ng-if=\"vm.getSelectedBankSlipRuleIsApi() != 3 && vm.getSelectedCurrentAccountIsApi() != 3\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Forma da geração</b> <small>Defina se deseja apenas registrar, apenas imprimir ou ambos</small></div></div><div flex=\"\" layout=\"row\" class=\"md-padding\" layout-wrap=\"\"><md-radio-group layout=\"column\" style=\"margin-top: 20px;\" flex=\"35\" ng-model=\"vm.bankslipgroup.type\" ng-change=\"vm.setType(vm.type)\" layout-align=\"space-between\"><div><md-radio-button flex=\"\" value=\"3\" policy-access=\"cobanc_bol\"><span>Apenas imprimir boletos</span><br><span ng-if=\"vm.bankslipgroup.is_api\"><small>Retorna apenas boletos registrados</small></span> <span ng-if=\"!vm.bankslipgroup.is_api\"><small>Retorna apenas boletos registrados ou que estejam em arquivo remessa</small></span></md-radio-button><md-radio-button flex=\"\" value=\"2\" policy-access=\"cobanc_rem_alt\"><span ng-if=\"vm.bankslipgroup.is_api\">Apenas registrar boletos</span> <span ng-if=\"!vm.bankslipgroup.is_api\">Apenas gerar remessa</span><br><span ng-if=\"vm.bankslipgroup.is_api\"><small>Retorna boletos ainda não registrados</small></span> <span ng-if=\"!vm.bankslipgroup.is_api\"><small>Retorna boletos ainda não registrados nem em arquivo remessa</small></span></md-radio-button><md-radio-button flex=\"\" value=\"0\" policy-access=\"cobanc_rem_alt_pdf\"><span ng-if=\"vm.bankslipgroup.is_api\">Registrar e imprimir boletos</span> <span ng-if=\"!vm.bankslipgroup.is_api\">Gerar remessa e imprimir boletos</span><br><span ng-if=\"vm.bankslipgroup.is_api\"><small>Retorna boletos ainda não registrados</small></span> <span ng-if=\"!vm.bankslipgroup.is_api\"><small>Retorna boletos ainda não registrados nem em arquivo remessa</small></span></md-radio-button></div></md-radio-group><div layout=\"column\" flex=\"50\"><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\" style=\"margin-bottom: 0;\" ng-if=\"!vm.bankslipgroup.is_api && vm.bankslipgroup.type != 3\"><label>Descrição do arquivo remessa</label><md-icon md-font-icon=\"icon-note-text\"></md-icon><input ng-model=\"vm.bankslipgroup.description\" type=\"text\" ng-disabled=\"vm.bankslipgroup.type == 3\"></md-input-container><md-radio-group ng-if=\"vm.bankslipgroup.type != 2\" layout=\"column\" flex=\"\" ng-model=\"vm.bankslipgroup.carne\" ng-style=\"vm.bankslipgroup.is_api || vm.bankslipgroup.type == 3 ? {\'margin-top\' : \'60px\'} : {}\" style=\"margin-top: -50px;\" layout-align=\"space-between\"><md-radio-button flex=\"\" value=\"0\"><span>1 boleto por página</span><br><small>Modelo convencional</small></md-radio-button><md-radio-button flex=\"\" value=\"1\"><span>3 boletos por página</span><br><small>Modelo tipo carnê de boletos</small></md-radio-button></md-radio-group></div></div><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Curso e Turma</b> <small>Abaixo se encontra cursos e turmas.<br><br><b>ATENÇÃO</b> o periodo letívo selecionado no educacional interfere na busca de boletos utilizando as opções abaixo. Período letivo selecionado: <b>{{vm.school_period.name}}</b></small></div></div><div flex=\"\" layout=\"row\" class=\"md-padding\"><md-input-container flex=\"30\" class=\"md-block md-input-has-placeholder\" ng-required=\"vm.bankslipgroup.bank_slip_rule_id === null\"><label>Curso</label><md-icon md-font-icon=\"icon-group\"></md-icon><md-select name=\"group_service_list\" ng-model=\"vm.bankslipgroup.product_group_id\" aria-label=\"Curso\" md-on-open=\"vm.allProductGroups()\" ng-change=\"vm.getProductsByGroup(vm.bankslipgroup.product_group_id)\"><md-optgroup label=\"Curso\"><md-option ng-repeat=\"product_group in vm.product_groups track by $index\" ng-value=\"product_group.id\">{{product_group.name}}</md-option></md-optgroup></md-select><div ng-messages=\"bankslipform.group_service_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um grupo de serviço.</div></div></md-input-container><md-input-container flex=\"50\" class=\"md-block md-input-has-placeholder\" ng-required=\"vm.bankslipgroup.bank_slip_rule_id === null\"><label>Turma</label><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><md-select name=\"service_list\" ng-model=\"vm.bankslipgroup.product_ids\" multiple=\"\" ng-required=\"vm.bankslipgroup.product_group_id !== undefined\" ng-disabled=\"vm.bankslipgroup.product_group_id == null\" ng-change=\"vm.setProducts(vm.bankslipgroup.product_ids)\" aria-label=\"turmas\"><md-optgroup label=\"Turmas\"><md-option ng-repeat=\"product in vm.products track by $index\" ng-value=\"product.product_id\">{{product.product_name}}</md-option></md-optgroup></md-select><div ng-messages=\"bankslipform.service_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um ou mais turmas.</div></div></md-input-container></div><md-input-container><md-checkbox ng-model=\"vm.bankslipgroup.get_conditional_enrolment\">Trazer alunos em matrícula condicional</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.bankslipgroup.order_by_student\" ng-change=\"vm.setOrderBy()\">Ordenar pelo aluno</md-checkbox></md-input-container><hr><div layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"$root.show_loader || bankslipform.$invalid\" style=\"margin-left: 0;\">Gerar todos</md-button><md-button ng-click=\"vm.selectBankSlips()\" class=\"md-raised md-primary\" ng-disabled=\"$root.show_loader || bankslipform.$invalid\" style=\"margin-left: 0;\">Selecionar boletos</md-button></div></div></form></md-content></md-content></md-card></md-content></md-tab><md-tab label=\"Arquivos remessa\"><md-content ng-if=\"vm.selected_tab == 1\" ui-view=\"bank-file-send\"></md-content></md-tab><md-tab label=\"Arquivos retorno\" ng-if=\"!vm.checkPolicies(\'cobanc_ret_alt\')\"><md-content ng-if=\"vm.selected_tab == 2\" ui-view=\"bank-file-receive\"></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/finance/bank-slip/views/modal.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Gerar arquivo remessa</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 200px; min-width: 400px;\" layout=\"column\" ng-if=\"vm.status == 5\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\" style=\"margin: 0\"><md-icon md-font-icon=\"icon-note-text\"></md-icon><label>{{ \'BANK_FILE_SEND.DESCRIPTION\' | translate }}</label> <input ng-model=\"vm.filesend.description\"></md-input-container><date-picker placeholder=\"Nova data de venc.\" ng-model=\"vm.filesend.new_due_date\"></date-picker></md-dialog-content><md-dialog-content style=\"min-height: 100px; min-width: 400px;\" layout=\"column\" ng-if=\"vm.status != 5\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><md-icon md-font-icon=\"icon-note-text\"></md-icon><label>{{ \'BANK_FILE_SEND.DESCRIPTION\' | translate }}</label> <input ng-model=\"vm.filesend.description\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-disabled=\"vm.loading_remessa\" ng-click=\"vm.submit(vm.filesend);\"><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" ng-if=\"vm.loading_remessa\" md-mode=\"indeterminate\"></md-progress-circular>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bank-slip-rule/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"ADDITIONS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-receipt\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"BANKSLIPRULE.TITLE\"></span></div></div></md-toolbar><md-card class=\"md-padding\"><md-input-container flex=\"20\" style=\"margin-top: 10px\"><md-checkbox ng-model=\"vm.show_inactive_rules\" ng-change=\"vm.getAllBankSlipRules()\">Mostrar regras inativas</md-checkbox></md-input-container><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\" style=\"text-align: right\">Ações</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.allRules\" ng-click=\"vm.openAside(item)\" style=\"cursor: pointer\"><td md-cell=\"\">{{item.name || item.name}} <span class=\"badge\" ng-if=\"item.is_inactive\"><span class=\"Inativo\">Inativa</span></span></td><td md-cell=\"\" style=\"text-align: right\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event);$event.stopPropagation()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"5\"><md-menu-item ng-if=\"!item.is_inactive\"><md-button ng-click=\"vm.setIsInactive(item, true)\"><md-icon>block</md-icon>Desativar regra</md-button></md-menu-item><md-menu-item ng-if=\"item.is_inactive\"><md-button ng-click=\"vm.setIsInactive(item, false)\"><md-icon>done</md-icon>Ativar regra</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.bill_list.per_page\" md-limit-options=\"[5, 10, 15, 25, 50, 75, 100]\" md-page=\"vm.bill_list.current_page\" md-total=\"{{vm.bill_list.total}}\" md-on-paginate=\"vm.paginateRequest\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></md-card></div>");
$templateCache.put("app/finance/bill-category/views/index.html","<link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css\" integrity=\"sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u\" crossorigin=\"anonymous\"><link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap-theme.min.css\" integrity=\"sha384-rHyoN1iRsVXV4nD0JutlnGaslCJuC7uwjduW9SVrLvRYooPp2bWYgmgJQIXwl/Sp\" crossorigin=\"anonymous\"><div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{\'CATEGORIES_PLAIN\' | translate}}</span></div></div></md-toolbar><div class=\"portlet light bordered\"><div class=\"row\"><div class=\"col-md-12\"><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs=\"\" flex-gt-xs=\"30\" layout=\"column\"><md-card><md-card-content><div class=\"actions padding0\"><div class=\"alert alert-default padding0\" role=\"alert\"><i class=\"glyphicon glyphicon-ban-circle style-subtitle-icon\"></i> <span class=\"style-subtitle\">{{\'CANT_BE_ADD_REMOVE\' | translate}}</span><br><i class=\"glyphicon glyphicon-remove-circle style-subtitle-icon\"></i> <span class=\"style-subtitle\">{{\'CANT_BE_MOVE\' | translate}}</span></div></div></md-card-content></md-card></div></md-content><div class=\"col-md-8\" style=\"float:right\"><a class=\"col-md-4 text-decoration-none\" style=\"float:right\" ng-click=\"vm.expandAll(); vm.changeCollapse();\" ng-if=\"!vm.CollapseClose\"><div class=\"padding10\" style=\"width: 200px;\"><i class=\"glyphicon glyphicon-chevron-down\" style=\"font-size:15px\"></i> <span>{{\'OPEN_CATEGORIES\' | translate}}</span></div></a> <a class=\"col-md-4 text-decoration-none\" style=\"float:right\" ng-if=\"vm.CollapseClose\" ng-click=\"vm.collapseAll(); vm.changeCollapse();\"><div class=\"padding10\" style=\"width: 200px;\"><i class=\"glyphicon glyphicon-chevron-up\" style=\"font-size:15px\"></i> <span>{{\'CLOSE_CATEGORIES\' | translate}}</span></div></a></div><div class=\"category-plan\"><ul class=\"nav nav-tabs\" style=\"margin-top:10px\"><li ng-repeat=\"item in vm.tabs\" ng-class=\"{\'active\' : vm.curr_tab == $index}\"><a ng-click=\"vm.changeForm($index);\" class=\"color-nested-menu-{{item.debit_credit}}\">{{item.name}}</a></li></ul></div></div><div class=\"tab-content\"><div role=\"tabpanel\" class=\"tab-pane\" ng-class=\"{\'active\' : vm.curr_tab == 1}\" id=\"t1\"><nested-list name=\"despesas\" parent=\"vm.parent\" nodes=\"vm.list\" tree-options=\"vm.treeOptions\"></nested-list></div><div role=\"tabpanel\" class=\"tab-pane\" ng-class=\"{\'active\' : vm.curr_tab == 0}\" id=\"t2\"><nested-list name=\"receitas\" parent=\"vm.parent\" nodes=\"vm.list\" tree-options=\"vm.treeOptions\"></nested-list></div></div></div></div></div>");
$templateCache.put("app/finance/bill-chargeback/views/chargeback-index.html","<div layout=\"row\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\" md-theme=\"finance\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Realizar estorno</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" translate=\"\" translate-attr-aria-label=\"BILL_CHARGEBACK.CLOSE_SIDENAV\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"content\"><div class=\"sidenav-form top-small\"><div layout=\"column\" layout-sm=\"column\" ng-if=\"vm.show_loader\" style=\"margin-top: 200px;\" layout-align=\"space-around\"><div style=\"margin-left: 295px\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div></div><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\" ng-if=\"!vm.show_loader\" md-theme=\"finance\"><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 300px\" ng-if=\"!vm.show_form\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><form name=\"formReverse\" ng-submit=\"vm.changeBackConfimation()\" ng-if=\"vm.show_form\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.bill.id\"><div id=\"bill-payment-toggle\" class=\"simple-table-container\"><md-list-item class=\"show-in-bg-white\" ng-click=\"vm.toggle.list = !vm.toggle.list\"><span flex=\"90\">Selecionados</span> <span flex=\"10\"><md-icon ng-show=\"!vm.toggle.list\">expand_more</md-icon><md-icon ng-show=\"vm.toggle.list\">expand_less</md-icon></span></md-list-item><div ng-show=\"vm.toggle.list\" class=\"ms-responsive-table-wrapper\"><table md-table=\"\" class=\"simple\" ms-responsive-table=\"\" id=\"bill-negotiate-list\"><thead><tr><th>Vencimento</th><th>Pessoa</th><th>Descrição</th><th>Valor</th><th ng-if=\"vm.billList.length > 1\">Remover</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-if=\"item\" class=\"{{ item.status_name }}\" ng-repeat=\"item in vm.action.billsSelected\"><td md-cell=\"\">{{item.date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\"><span class=\"td-first-line\">{{ item.person_name }}</span> <span class=\"td-second-line\">{{ item.beneficiary_name }}</span></td><td md-cell=\"\">{{item.instalment_name}}</td><td md-cell=\"\">{{item.amount | currency}}</td><td md-cell=\"\" ng-if=\"vm.billList.length > 1\"><md-button class=\"md-icon-button\" aria-label=\"Remover\" ng-click=\"vm.removeItem(item)\"><md-icon class=\"material-icons\">remove_circle</md-icon></md-button></td></tr></tbody></table></div></div><date-picker placeholder=\"Data do estorno\" flex=\"\" name=\"changeback date\" ng-model=\"vm.changebackdate\"></date-picker><md-input-container class=\"md-input-has-placeholder\" flex=\"\" style=\"width: 100%;\"><label>Motivo do estorno</label> <input ng-model=\"vm.notes\" type=\"text\"></md-input-container><a4-table-advanced templatename=\"payment_form\" list=\"vm.payments\" bill=\"vm.action.billsSelected\" type=\"vm.action.billsSelected[0].debit_credit\" totalcurrency=\"vm.totalAmount\" data-waspaid=\"0\" readonly=\"true\" block=\"true\"></a4-table-advanced><div layout=\"row\"><md-input-container><strong class=\"group-field\"><small>O que fazer com o valor estornado?</small></strong><md-radio-group ng-model=\"vm.charge_back_option\"><md-radio-button ng-value=\"\'CREDIT\'\">Manter o valor como crédito para uso futuro</md-radio-button><md-radio-button ng-value=\"\'CHARGE_BACK\'\">Reembolsar o valor imediatamente</md-radio-button></md-radio-group></md-input-container></div><a4-options-movement ng-if=\"vm.charge_back_option == \'CHARGE_BACK\'\" movement-type=\"vm.movement_type\" current-account=\"vm.current_account\"></a4-options-movement><div layout=\"row\"><md-input-container><strong class=\"group-field\"><small>O que fazer com o título?</small></strong><md-radio-group ng-model=\"vm.bill_option\"><md-radio-button ng-value=\"\'OPEN\'\">Manter o título em aberto</md-radio-button><md-radio-button ng-value=\"\'CANCEL\'\">Cancelar o título</md-radio-button></md-radio-group></md-input-container></div><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\">Confirmar estorno</md-button></footer></form></div></div></div></div>");
$templateCache.put("app/finance/bill-expense/contract/contract.html","<a4-contract-grid ng-model=\"vm.allContracts\" paginate-function=\"vm.getAllContracts(page, qtd)\" debit-credit=\"D\"></a4-contract-grid>");
$templateCache.put("app/finance/bill-expense/contract/modal-edit.html","<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Editar Contrato</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-if=\"vm.currentItem.edit_expense != null\"><div layout=\"row\"><div class=\"alert alert-warning\" ng-if=\"vm.currentItem.edit_expense == 3\"><strong>ATENÇÃO!</strong> As alterações feitas irão afetar todos os títulos do contrato.</div></div></div><form novalidate=\"\" name=\"bill_form\" ng-submit=\"vm.submit(bill_form, vm.currentItem, files, $event)\"><div class=\"form-wrapper md-padding\" ng-init=\"vm.init();\"><div layout=\"row\" layout-align=\"start\" flex=\"\"><md-input-container flex=\"\"><label>{{ \'BILL_EXPENSE.PAY_TO\' | translate }}</label><md-select name=\"person_id\" ng-model=\"vm.currentItem.person_id\" ng-disabled=\"vm.currentItem.id != null\" required=\"\"><md-option><em>None</em></md-option><md-option ng-repeat=\"person in vm.persons\" ng-value=\"person.id\">{{person.name | translate}}</md-option></md-select><div ng-messages=\"formBill.person_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'BILL_EXPENSE.FORM_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><md-datepicker name=\"issue_date\" ng-model=\"vm.currentItem.issue_date\" ng-disabled=\"vm.currentItem.id != null\" placeholder=\"Na data\" required=\"\"></md-datepicker></md-input-container></div><div layout=\"row\" layout-align=\"start\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" name=\"bank_branch\" maxlength=\"150\" autocomplete=\"off\" ng-model=\"vm.currentItem.description\" placeholder=\"{{ \'BILL_EXPENSE.DESCRIPTION\' | translate }}\" required=\"\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"bank_branch\" maxlength=\"20\" autocomplete=\"off\" ng-model=\"vm.currentItem.document_reference\" placeholder=\"{{ \'BILL_EXPENSE.REFERENCE\' | translate }}\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"bill-detail\" flex=\"\"><a4-detail-grid debit-credit=\"D\" edit=\"vm.currentItem.edit_expense\" current-item=\"vm.currentItem\" list=\"vm.currentItem.bill_details\" categories=\"vm.categories\"></a4-detail-grid></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentItem.was_paid == 2\"><div class=\"recurrence\" flex=\"\"><div layout=\"column\"><div flex=\"\"><div layout=\"row\"><div class=\"title\" flex=\"\"><h3>Período da recorrência</h3></div></div></div><div flex=\"\"><div layout=\"row\"><div flex=\"\"><md-input-container flex=\"\" style=\"width: 50%\"><md-datepicker name=\"date_first\" ng-model=\"vm.currentItem.date_first\" placeholder=\"Data inicial\" required=\"\" flex=\"\"></md-datepicker></md-input-container></div></div></div><div class=\"title\" flex=\"\"><h3>Frequência da recorrência</h3><div class=\"helper-tip\"><div class=\"flag\"><p>Nesta opção os lançamento de cada parcela são feitos no momento que acontece a demanda.</p></div></div></div><div flex=\"\"><div layout=\"row\"><div class=\"pt-10\" flex=\"\"><md-input-container flex=\"\"><md-radio-group ng-model=\"vm.currentItem.frequency_type\"><md-radio-button ng-checked=\"vm.currentItem.frequency_type == 0\" ng-click=\"vm.checkVariabilites()\" value=\"0\" class=\"md-primary\">A cada</md-radio-button></md-radio-group></md-input-container></div><div flex=\"\"><md-input-container flex=\"\"><input type=\"text\" number-only=\"\" maxlength=\"2\" name=\"frequency_qty\" ng-model=\"vm.currentItem.frequency_qty\" placeholder=\"{{ \'BILL_EXPENSE.FREQUENCY_QTY\' | translate }}\"></md-input-container></div><div flex=\"\"><md-select name=\"frequency\" ng-model=\"vm.currentItem.frequency\" ng-selected=\"vm.currentItem.frequency == item.id\" placeholder=\"{{ \'BILL_EXPENSE.FREQUENCY_OPTIONS\' | translate }}\" required=\"\"><md-option><em>None</em></md-option><md-option ng-repeat=\"item in vm.frequency_options\" ng-value=\"item.id\">{{item.name | translate}}</md-option></md-select></div></div></div><div flex=\"\"><div layout=\"row\"><div class=\"recurrence title\" flex=\"\"><h3>Fim da recorrência</h3></div></div></div><div flex=\"\"><div layout=\"row\"><div class=\"on-demand\" flex=\"35\"><md-input-container flex=\"\"><md-radio-group ng-model=\"vm.currentItem.frequency_type\"><md-radio-button value=\"2\" class=\"md-primary\" ng-click=\"vm.checkVariabilites()\">Sob Demanda</md-radio-button></md-radio-group><div class=\"helper-tip\" ng-if=\"vm.currentItem.end_of_recurrence == 1\"><div class=\"flag\"><p>Se for por tempo indeterminado deixe a data em branco e só preencha quando esta despesa deixar de existir.</p></div></div></md-input-container></div><div layout=\"column\" flex=\"\"><div flex=\"\" ng-show=\"!vm.onDemand\"><md-input-container flex=\"\"><md-radio-group ng-model=\"vm.currentItem.end_of_recurrence\"><md-radio-button value=\"0\" class=\"md-primary\">Qt. fixa de parcelas:</md-radio-button></md-radio-group></md-input-container><md-input-container flex=\"\"><input type=\"text\" class=\"ml-20 pl-20\" name=\"quantity\" autocomplete=\"off\" ng-model=\"vm.currentItem.quantity\" placeholder=\"\"></md-input-container></div><div class=\"w-300\" flex=\"\"><md-input-container flex=\"\" class=\"h-20 w-350\"><div class=\"pr-15\" style=\"float: left;\"><md-radio-group ng-model=\"vm.currentItem.end_of_recurrence\"><md-radio-button name=\"endofrecurrence\" value=\"1\" ng-checked=\"vm.currentItem.end_of_recurrence == 1\" class=\"md-primary\">Até a data:</md-radio-button></md-radio-group></div><div class=\"final-date\"><md-datepicker name=\"date_end\" ng-model=\"vm.currentItem.date_end\" placeholder=\"\" flex=\"\"></md-datepicker></div></md-input-container></div></div></div></div></div></div></div><div flex=\"\"><div layout=\"row\"><div class=\"title\" flex=\"\"><md-subheader class=\"md-primary\">{{ \'ACCRUAL\' | translate}}</md-subheader></div></div></div><div layout=\"row\" layout-align=\"start\"><div label=\"Mais detalhes\" style=\"min-width: 100%\"><md-content class=\"md-padding\"><div layout=\"row\"><md-input-container flex=\"\"><label>{{ \'MONTH\' | translate}}</label><md-select ng-model=\"vm.currentItem.accrual_month\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.months\">{{ item.label }}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label for=\"accrual_year\">{{ \'YEAR\' | translate}}</label><md-select class=\"form_group\" id=\"accrual_year\" ng-model=\"vm.currentItem.accrual_year\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.years\">{{ item.label }}</md-option></md-select></md-input-container></div><div class=\"more-details\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><md-chips ng-model=\"vm.currentItem.tags\" readonly=\"vm.readonly\" md-removable=\"vm.removable\" placeholder=\"Marcadores\" delete-button-label=\"Remover Tag\"></md-chips></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"notes\" maxlength=\"50\" autocomplete=\"off\" ng-model=\"vm.currentItem.notes\" placeholder=\"Notas complementares\"></md-input-container></div></md-content></div></div><div layout=\"row\" ng-if=\"vm.currentItem.was_paid == 3 && vm.currentItem.frequency_type == 1 && vm.currentItem.was_paid == 2 || vm.currentItem.was_paid == 3\"><div class=\"installments\" flex=\"\"><div layout=\"column\"><div flex=\"\"><div layout=\"row\"><div class=\"title\" flex=\"\"><h3>{{ \'INSTALLMENT\' | translate}}</h3></div></div></div><div flex=\"\"><div layout=\"row\"><div flex=\"\"><a4-table-installments list=\"vm.currentItem.payment_installments\" current-item=\"vm.currentItem\"></a4-table-installments></div></div></div></div></div></div><div layout=\"row\" layout-align=\"start\" flex=\"\"><div flex=\"50\"><upload-files files=\"vm.currentItem.files\"></upload-files></div><div flex=\"20\"><md-button type=\"submit\" class=\"md-raized md-primary fileinput-upload fileinput-upload-button\">Salvar</md-button></div><div flex=\"20\"><md-button type=\"button\" class=\"btn md-primary md-raized default bt-cancel\">Cancelar</md-button></div></div><div class=\"md-api-table\" ng-if=\"vm.currentItem.files.length > 0\"><table class=\"table\"><thead><tr ng-if=\"vm.artifact!=0\"><th>Nome</th><th>Ações</th></tr></thead><tbody><tr ng-repeat=\"file in vm.currentItem.files\" ng-if=\"file.origin == 2 && (vm.currentItem.edit_expense == 3)\" ng-init=\"vm.artifact = 1\"><td>{{file.name}}.{{file.extension}}</td><td><a type=\"button\" class=\"btn btn-default btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Visualizar\" placement=\"top\" href=\"{{file.file_reference{{\" target=\"_blank\"><i class=\"fa fa-eye\"></i></a> <a type=\"button\" class=\"btn btn-info btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Baixar\" placement=\"top\" href=\"{{file.file_reference{{\" download=\"\"><i class=\"fa fa-download\"></i></a> <span ng-if=\"vm.currentItem.edit_expense != \'undefined\'\"><a type=\"button\" class=\"btn btn-danger btn-circle\" data-toggle=\"tooltip\" ng-if=\"file.origin == 2 && (vm.currentItem.edit_expense == 3)\" tooltip-hint=\"Apagar\" placement=\"top\" ng-click=\"vm.deleteArtifact(file)\"><i class=\"fa fa-trash\"></i></a></span></td></tr><tr ng-repeat=\"file in vm.currentItem.files\" ng-if=\"(vm.currentItem.edit_expense == 1)\" ng-init=\"vm.artifact = 2\"><td>{{file.name}}.{{file.extension}}</td><td><a type=\"button\" class=\"btn btn-default btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Visualizar\" placement=\"top\" href=\"{{file.file_reference{{\" target=\"_blank\"><i class=\"fa fa-eye\"></i></a> <a type=\"button\" class=\"btn btn-info btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Baixar\" placement=\"top\" href=\"{{file.file_reference{{\" download=\"\"><i class=\"fa fa-download\"></i></a> <span ng-if=\"vm.currentItem.edit_expense !=\'undefined\'\"><a type=\"button\" class=\"btn btn-danger btn-circle\" data-toggle=\"tooltip\" ng-if=\"file.origin == 2 && (vm.currentItem.edit_expense == 3)\" tooltip-hint=\"Apagar\" placement=\"top\" ng-click=\"vm.deleteArtifact(file)\"><i class=\"fa fa-trash\"></i></a> <a type=\"button\" class=\"btn btn-danger btn-circle\" data-toggle=\"tooltip\" ng-if=\"file.origin == 1 && (vm.currentItem.edit_expense == 1)\" tooltip-hint=\"Apagar\" placement=\"top\" ng-click=\"vm.deleteArtifact(file)\"><i class=\"fa fa-trash\"></i></a></span></td></tr><tr ng-repeat=\"file in vm.currentItem.files\" ng-if=\"(vm.currentItem.edit_expense == 4)\" ng-init=\"vm.artifact = 2\"><td>{{file.name}}.{{file.extension}}</td><td><md-button class=\"md-raised\" href=\"{{file.file_reference}}\"><i class=\"fa fa-eye\"></i></md-button><a type=\"button\" class=\"btn btn-default btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Visualizar\" placement=\"top\" href=\"{{file.file_reference}}\" target=\"_blank\"><i class=\"fa fa-eye\"></i></a> <a type=\"button\" class=\"btn btn-info btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Baixar\" placement=\"top\" href=\"{{file.file_reference}}\" download=\"\"><i class=\"fa fa-download\"></i></a> <span ng-if=\"vm.currentItem.edit_expense !=\'undefined\'\"><a type=\"button\" class=\"btn btn-danger btn-circle\" data-toggle=\"tooltip\" tooltip-hint=\"Apagar\" placement=\"top\" ng-click=\"vm.deleteArtifact(file)\"><i class=\"fa fa-trash\"></i></a></span></td></tr></tbody></table></div></div></form>");
$templateCache.put("app/finance/bill-expense/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke !important;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cash-usd\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{\'BILL_EXPENSE.TITLE\' | translate}}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"Pesquisar por pessoa\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.getAll(1)\"></md-input-container></div></md-toolbar><md-content style=\"background-color: whitesmoke !important;\"><a4-bill-grid ng-model=\"vm.bills\" show-create-button=\"true\" show-button-more=\"vm.show_button_more\" paginate-function=\"vm.getAll(page, qtd, date, person_id, status, flag, order)\" debit-credit=\"D\"></a4-bill-grid></md-content></div>");
$templateCache.put("app/finance/bill-expense/views/new-form.html","<div layout=\"row\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.currentItem.id == null\">{{\'BILL_EXPENSE.FORM_CREATE\' | translate }}</span> <span class=\"title\" ng-show=\"vm.currentItem.id != null\">{{\'BILL_EXPENSE.FORM_EDIT\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeSideBar();\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar></div><div layout=\"row\"><div class=\"bill-container form\" style=\"padding-top: 0 !important;\"><div layout=\"row\" ng-show=\"vm.currentItem.edit_expense != null\"><div class=\"alert alert-warning\" ng-if=\"vm.currentItem.edit_expense == 3\"><strong>ATENÇÃO!</strong> Série de parcelas recorrentes. As alterações feitas irão afetar todas as parcelas do série.</div></div><div layout=\"row\" ng-show=\"vm.currentItem.edit_expense != null\"><div class=\"alert alert-warning\" ng-if=\"vm.currentItem.edit_expense == 2\"><strong>ATENÇÃO!</strong> Série de parcelas recorrentes. Alterações feitas afetarão parcelas da série a partir da {{vm.currentItem.instalment_name}}, mas as parcelas anteriores não serão afetadas.</div></div><div layout=\"row\" ng-show=\"vm.currentItem.edit_expense != null\"><div class=\"alert alert-warning\" ng-if=\"vm.currentItem.edit_expense == 1 && vm.currentItem.was_paid != 1\"><strong>ATENÇÃO!</strong> Parcela {{vm.currentItem.instalment_name}}. Qualquer alteração afetará apenas esta parcela.</div></div><div layout=\"row\" ng-show=\"vm.currentItem.edit_expense != null\"><div class=\"alert alert-warning\" ng-if=\"vm.currentItem.edit_expense == 4\"><strong>ATENÇÃO!</strong> Você está editando uma parcela. As alterações feitas irão afetar todas as parcelas da despesa.</div></div><form name=\"formBill\" ng-submit=\"vm.submit(vm.currentItem)\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selectedTab\"><md-tab label=\"DADOS DA SAÍDA\"><md-content class=\"md-padding\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"input-a4 md-input-has-placeholder\" flex=\"70\" ng-init=\"vm.listAllPersons()\"><md-autocomplete flex=\"\" required=\"\" md-input-name=\"autocompleteField\" md-no-cache=\"true\" md-selected-item=\"vm.currentItem.person_id\" md-search-text=\"vm.searchText\" md-items=\"item in vm.listAllPersons(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-require-match=\"\" md-floating-label=\"Pessoa\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><div ng-messages=\"bill_form.autocompleteField.$error\" ng-if=\"bill_form.autocompleteField.$touched\"><div ng-message=\"required\">{{ \'BILL_RECEIPT.FORM_REQUIRED\' | translate }}</div></div><md-not-found>Nenhum registro encontrado para \"{{vm.searchText}}\".</md-not-found></md-autocomplete></md-input-container><md-input-container class=\"input-a4 md-input-has-placeholder\" flex=\"30\"><date-picker placeholder=\"Data\" flex=\"\" name=\"due_date\" ng-disabled=\"vm.currentItem.id != null\" ng-model=\"vm.currentItem.due_date\"></date-picker></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"input-a4 md-input-has-placeholder\" flex=\"70\"><input type=\"text\" name=\"bank_branch\" maxlength=\"150\" autocomplete=\"off\" ng-model=\"vm.currentItem.description\" placeholder=\"{{ \'BILL_EXPENSE.DESCRIPTION\' | translate }}\" required=\"\"></md-input-container><md-input-container class=\"input-a4 md-input-has-placeholder\" flex=\"30\"><md-icon md-font-icon=\"icon-content-duplicate\" class=\"s20\"></md-icon><input type=\"text\" name=\"bank_branch\" maxlength=\"20\" autocomplete=\"off\" ng-model=\"vm.currentItem.document_reference\" placeholder=\"{{ \'BILL_EXPENSE.REFERENCE\' | translate }}\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" style=\"margin-bottom: 25px\"><a4-detail-grid debit-credit=\"D\" edit=\"vm.currentItem.edit_expense\" current-item=\"vm.currentItem\" list=\"vm.currentItem.bill_details\" categories=\"vm.categories\"></a4-detail-grid></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"input-a4\" flex=\"100\"><label>{{ \'Forma de cobrança\' | translate }}</label><md-select name=\"payment_type\" ng-model=\"vm.currentItem.payment\"><md-option ng-repeat=\"payment in vm.payment_method\" ng-value=\"payment.id\">{{payment.name | translate}}</md-option></md-select><div ng-messages=\"formBill.payment_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'BILL_EXPENSE.FORM_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"vm.currentItem.id == null\"><fieldset class=\"standard without-legend group-field\"><md-radio-group name=\"expenses\" ng-model=\"vm.currentItem.was_paid\" ng-click=\"vm.changeWasPaid();\" ng-disabled=\"vm.currentItem.person_id == null || vm.currentItem.issue_date == null || vm.currentItem.bill_details[0].bill_category_id == null || vm.currentItem.bill_details[0].amount == 0\" ng-change=\"vm.tabChange(vm.currentItem.was_paid)\" required=\"\"><md-radio-button value=\"1\" flex=\"\">Pagamento único</md-radio-button><md-radio-button value=\"2\" flex=\"\">Pagamento recorrente</md-radio-button></md-radio-group></fieldset></div></md-content></md-tab><md-tab label=\"MAIS INFORMAÇÕES\"><md-content class=\"md-padding\"><strong class=\"group-field md-block\"><small>{{\'Competência do pagamento\' | translate }}</small></strong><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"input-a4\" flex=\"\"><label>Mês</label><md-select name=\"accrual_month\" ng-model=\"vm.currentItem.accrual_month\" ng-selected=\"vm.currentItem.accrual_month == item.value\"><md-option ng-repeat=\"item in vm.range_of_months\" ng-value=\"item.value\">{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"input-a4\" flex=\"\"><label>Ano</label><md-select name=\"accrual_year\" ng-model=\"vm.currentItem.accrual_year\" ng-selected=\"vm.currentItem.accrual_year == item\"><md-option ng-repeat=\"item in vm.range_of_year\" ng-value=\"item\">{{item}}</md-option></md-select></md-input-container></div></md-content></md-tab><md-tab label=\"DETALHES DA RECORRÊNCIA\" ng-disabled=\"vm.currentItem.was_paid != 2 || vm.currentItem.bill_details[0].bill_category_id == null || vm.currentItem.bill_details[0].amount == 0\"><md-content class=\"md-padding\"><div layout=\"row\" layout-align=\"start center\"><strong class=\"group-field\" flex=\"70\"><small>{{\'Tipo da recorrência\' | translate }}</small></strong><div></div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><fieldset class=\"standard without-legend group-field\"><md-radio-group name=\"endofrecurrence\" ng-model=\"vm.currentItem.end_of_recurrence\"><md-radio-button value=\"0\" class=\"md-primary\">Quantidade fixa de parcelas</md-radio-button><md-radio-button value=\"1\" class=\"md-primary\">Contínua</md-radio-button></md-radio-group></fieldset></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"md-input-has-placeholder\" ng-show=\"vm.currentItem.end_of_recurrence == 0 || vm.currentItem.end_of_recurrence == 1\" flex=\"\"><input type=\"text\" name=\"frequencyqty\" placeholder=\"Quantidade do período\" ng-model=\"vm.currentItem.frequency_qty\" maxlength=\"2\"> <span class=\"input-group-btn btn-left\"><i class=\"material-icons\">date_range</i></span></md-input-container><md-input-container class=\"md-input-has-placeholder\" ng-hide=\"vm.currentItem.end_of_recurrence == 2\" flex=\"\"><label>{{ \'Frequência a cada \' | translate }} {{ vm.currentItem.frequency_qty }}</label><md-select name=\"frequency\" ng-model=\"vm.currentItem.frequency\" ng-selected=\"vm.currentItem.frequency == item.id\"><md-option ng-repeat=\"item in vm.frequency_options\" ng-value=\"item.id\">{{item.name | translate}}</md-option></md-select></md-input-container><date-picker flex=\"\" ng-show=\"vm.currentItem.end_of_recurrence == 1\" placeholder=\"Data de encerramento:\" ng-model=\"vm.currentItem.date_end\"></date-picker></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><a4-table-installments ng-show=\"vm.currentItem.end_of_recurrence == 0\" frequency-qty=\"vm.currentItem.frequency_qty\" frequency=\"vm.currentItem.frequency\" current-item=\"vm.currentItem\" initial-qty=\"1\" total-amount=\"vm.currentItem.amount\" list=\"vm.currentItem.payment_installments\" disabled=\"vm.currentItem.recurrency_on_value != 1\" is-recurrence=\"vm.currentItem.recurrency_on_value == 0\"></a4-table-installments></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><strong class=\"group-field md-block\"><small>{{\'Valor na recorrência\' | translate }}</small></strong><md-radio-group ng-model=\"vm.currentItem.recurrency_on_value\" class=\"md-padding\"><div ng-if=\"vm.currentItem.frequency_type != 1\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"0\" ng-checked=\"vm.currentItem.end_of_recurrence == 0\">Parcelas com o mesmo valor de {{vm.currentItem.amount | currency}}</md-radio-button></div><div ng-if=\"vm.currentItem.frequency_type != 1\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"1\" ng-checked=\"vm.currentItem.end_of_recurrence == 1\">O valor pode variar a cada parcela</md-radio-button></div><div ng-if=\"vm.currentItem.end_of_recurrence == 0\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"2\" ng-checked=\"vm.currentItem.end_of_recurrence == 0\">Divide o valor do título de {{vm.currentItem.amount | currency}} nas parcelas</md-radio-button></div></md-radio-group></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"vm.currentItem.recurrency_value == 0\"><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'Indice de correção\' | translate}}</label><md-select ng-model=\"vm.currentItem.index_id\"><md-option ng-value=\"item.id\" ng-repeat=\"i in vm.indexCorrection\">{{ i.name | translate}}</md-option></md-select></md-input-container><md-input-container class=\"input-a4\" flex=\"\"><date-picker ng-model=\"vm.currentItem.next_adjustment_date\" placeholder=\"{{ \'Próxima data de reajuste\' | translate}}\"></date-picker></md-input-container></div></md-content></md-tab></md-tabs></md-content><md-content class=\"md-padding\"><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeSideBar();\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'CURRENT_ACCOUNT.FORM_SUBMIT\' | translate }}\" ng-disabled=\"formBill.$invalid || vm.currentItem.bill_details[0].bill_category_id == null || vm.currentItem.bill_details[0].amount == 0\"><span ng-hide=\"vm.currentItem.id == null\" translate=\"BILL_EXPENSE.FORM_EDIT\"></span> <span ng-show=\"vm.currentItem.id == null\" translate=\"BILL_EXPENSE.FORM_CREATE\"></span></md-button></footer></md-content></form></div></div>");
$templateCache.put("app/finance/bill-negotiate/views/form-negotiate.html","<div layout=\"row\" ng-if=\"vm.currentItem\" ng-init=\"vm.toggle.list1 = true\" md-theme=\"finance\" style=\"overflow: auto\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{ \'BILL_NEGOTIATE.TITLE\' | translate }}</span><div layout=\"row\" layout-align=\"end center\"><a4-guide-button guide=\"\'negotiation\'\" button-theme=\"\'financeButton\'\"></a4-guide-button><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" translate=\"\" translate-attr-aria-label=\"BILL_NEGOTIATE.CLOSE_SIDENAV\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><div class=\"content\"><div class=\"sidenav-form top-small\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><form name=\"formNegotiate\"><a4-bills-operation bills=\"vm.currentItem.currentItemList\" current-item=\"vm.currentItem\" ng-if=\"vm.show_list\" update-bills=\"vm.setnegotiate()\" type=\"\'negotiate\'\"></a4-bills-operation><div layout=\"row\" ng-if=\"vm.show_table\"><a4-table-installments is-negotiation=\"true\" total-amount=\"vm.currentItem.totalAmount\" list=\"vm.payment_installments\" current-item=\"vm.currentItem\" interest-value=\"vm.currentItem.interest_value\" invoke=\"vm.calculateInstalmentValue\" mode-receipt=\"true\"></a4-table-installments></div><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\" ng-if=\"!vm.undonegotiate\" style=\"margin-top: 20px;\"><label>Selecione a regra de boleto</label><md-icon md-font-icon=\"icon-barcode\"></md-icon><md-select name=\"bank_slip_rules\" ng-required=\"!vm.undonegotiate\" ng-model=\"vm.bank_slip_rule_id\" ng-change=\"vm.cashier_payment = false\" aria-label=\"Selecione a regra de boleto\"><md-option ng-value=\"null\">Nenhuma</md-option><md-option ng-repeat=\"bank_slip_rule in vm.bank_slip_rules\" ng-value=\"bank_slip_rule.id\">{{bank_slip_rule.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\" ng-if=\"!vm.undonegotiate\" style=\"margin-top: 20px;\"><label>Selecione a regra de acréscimos</label><md-icon md-font-icon=\"icon-elevation-decline\"></md-icon><md-select name=\"fines_rules\" ng-required=\"!vm.undonegotiate\" ng-model=\"vm.fines_rule_id\" ng-change=\"vm.cashier_payment = false\" aria-label=\"Selecione a regra de acréscimos\"><md-option ng-value=\"null\">Nenhuma</md-option><md-option ng-repeat=\"fines_rule in vm.finesRules\" ng-value=\"fines_rule.id\">{{fines_rule.name}}</md-option></md-select></md-input-container><hr><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.close();\" ng-disabled=\"vm.disabledSubmit\">Cancelar</md-button><md-button class=\"md-raised md-accent submit-button\" ng-disabled=\"vm.disabledSubmit\" aria-label=\"{{ \'DISCOUNTS.FORM_SUBMIT\' | translate }}\" ng-if=\"vm.bill_undo.is_undoable\" ng-click=\"vm.undoNegociation($event)\">Desfazer Negociação</md-button><md-button class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'DISCOUNTS.FORM_SUBMIT\' | translate }}\" ng-disabled=\"vm.payment_installments.length <= 0 || formNegotiate.$invalid || vm.disabledSubmit\" ng-if=\"!vm.bill_undo.is_undoable\" ng-click=\"vm.createInstallmentsNegociation(4)\"><span>Concluir</span></md-button></footer></form></div></div></div></div>");
$templateCache.put("app/finance/bill-payment/modals/BankPayment.html","<md-dialog aria-label=\"Cheque\" md-theme=\"finance\"><form ng-cloa=\"\" name=\"receivedBank\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-show=\"vm.scope.debitcredit.toLowerCase() == \'d\'\">{{ \'BILL_PAYMENT.BANK_PAYMENT\' | translate}}</h2><h2 ng-show=\"vm.scope.debitcredit.toLowerCase() == \'c\'\">{{ \'BILL_PAYMENT.BANK_RECEIVEMENT\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><strong class=\"group-field\"><small>Movimentações</small></strong><md-radio-group name=\"movement_type_id\" ng-model=\"vm.scope.bank.movement_type_id\" required=\"\"><div layout=\"row\"><md-radio-button ng-value=\"10\" flex=\"\">Boleto</md-radio-button><md-radio-button ng-value=\"11\" flex=\"\">Depósito</md-radio-button></div><div layout=\"row\"><md-radio-button ng-value=\"13\" flex=\"\">DOC</md-radio-button><md-radio-button ng-value=\"14\" flex=\"\">TED</md-radio-button></div><div layout=\"row\"><md-radio-button ng-value=\"15\" flex=\"\">Pix</md-radio-button></div><div layout=\"row\"><md-radio-button ng-value=\"12\" flex=\"\">Transferência</md-radio-button><md-radio-button ng-value=\"22\" flex=\"\">Débito automático</md-radio-button></div></md-radio-group><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label>Conta Banco</label><md-select ng-model=\"vm.scope.bank.current_account_id\" name=\"current_account_id\" required=\"\"><md-option ng-repeat=\"bAccountList in vm.scope.bankAccountList\" ng-value=\"bAccountList.id\" required=\"\">{{ bAccountList.name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label>Valor</label> <input ng-model=\"vm.scope.bank.amount\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" ng-disabled=\"vm.scope.checkPolicies(\'pagamento_parcial\')\" name=\"amount\" required=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-disabled=\"receivedBank.$invalid\" ng-if=\"vm.scope.obj.idx == null\" name=\"addCheck\" ng-click=\"vm.scope.addPaymentList(vm.scope.bank);\">Incluir</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"receivedBank.$invalid\" ng-if=\"vm.scope.obj.idx != null\" ng-click=\"vm.scope.updatePaymentList(vm.scope.bank);\">Atualizar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/CheckPayment.html","<md-dialog no-limit=\"\" aria-label=\"Pagamento com cheque\" style=\"max-width: 500px; width: 500px;\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"receivedCheck\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Pagamento com cheque</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-padding\"><md-radio-group layout=\"row\" ng-model=\"vm.check.is_third_party_check\" ng-change=\"vm.modifyType(vm.check.is_third_party_check)\"><md-radio-button ng-value=\"false\" flex=\"\">{{\'BILL_PAYMENT.OWN\' | translate}}</md-radio-button><md-radio-button ng-value=\"true\" flex=\"\">{{\'BILL_PAYMENT.FROM_THIRD_PARTY\' | translate}}</md-radio-button></md-radio-group></div><div layout=\"row\"><md-input-container flex=\"\"><label>{{\'BILL_PAYMENT.ACCOUNT\' | translate}}</label><md-select name=\"account\" ng-model=\"vm.check.current_account\" required=\"\"><md-option ng-repeat=\"item in vm.check.bankAccounts\" ng-value=\"item\">{{ item.name }}</md-option></md-select><div class=\"errors\" ng-messages=\"received.account.$error\"><div ng-message=\"required\">Você <b>deve</b> escolher uma conta.</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><label>{{\'BILL_PAYMENT.CHECK_NUMBER\' | translate}}</label> <input type=\"text\" autocomplete=\"off\" autofocus=\"\" ng-change=\"vm.check.blocked = false\" ng-blur=\"vm.scope.verifyDuplicateCheck(vm.check,true)\" ng-disabled=\"vm.check.readed\" ng-model=\"vm.check.document\" maxlength=\"15\" name=\"document\" required=\"\"></md-input-container><md-input-container flex=\"\"><md-datepicker md-placeholder=\"Data\" ng-model=\"vm.check.date\" name=\"date\" required=\"\"></md-datepicker></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><label>{{\'BILL_PAYMENT.AMOUNT\' | translate}}</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.check.amount\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" ng-disabled=\"vm.check.movement_type_id == 5\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-if=\"vm.check.idx == null\" name=\"addCheck\" ng-click=\"vm.check.addPaymentList(vm.check);\" ng-disabled=\"receivedCheck.$invalid\">Incluir</md-button><md-button class=\"md-raised md-primary\" ng-if=\"vm.check.idx != null\" ng-click=\"vm.check.updatePaymentList(vm.check);\" ng-disabled=\"receivedCheck.$invalid\">Atualizar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/CheckReceiving.html","<md-dialog no-limit=\"\" aria-label=\"Recebimento com cheque\" style=\"max-width: 500px; width: 500px;\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"receivedCheck\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Recebimento com cheque</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-padding\"><md-radio-group layout=\"row\" ng-model=\"vm.check.is_third_party_check\" ng-change=\"vm.modifyType(vm.check.is_third_party_check)\"><md-radio-button ng-value=\"false\" flex=\"\">{{\'BILL_PAYMENT.OWN\' | translate}}</md-radio-button><md-radio-button ng-value=\"true\" flex=\"\">{{\'BILL_PAYMENT.FROM_THIRD_PARTY\' | translate}}</md-radio-button></md-radio-group></div><div layout=\"row\"><md-input-container flex=\"\"><label>{{\'BILL_PAYMENT.ACCOUNT_CASHIER\' | translate}}</label><md-select name=\"account\" ng-model=\"vm.check.current_account_id\" required=\"\" md-autofocus=\"\"><md-option ng-repeat=\"item in vm.check.bankAccounts\" ng-value=\"item.id\">{{ item.name }}</md-option></md-select><div class=\"errors\" ng-messages=\"receivedCheck.account.$error\"><div ng-message=\"required\">Você <b>deve</b> escolher uma conta.</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><md-autocomplete flex=\"\" ng-disabled=\"vm.check.readed\" md-input-name=\"bank\" md-selected-item=\"vm.check.bank\" md-no-cache=\"false\" md-search-text=\"searchText\" md-selected-item-change=\"vm.verifyCheckByBank(vm.check.bank)\" md-items=\"item in vm.querySearch(searchText, vm.check.banks)\" md-item-text=\"item.number_bank +\' - \'+ item.name\" md-require-match=\"\" md-floating-label=\"{{\'BILL_PAYMENT.BANK\' | translate}}\" required=\"\"><md-item-template><span>{{ item.number_bank +\' - \'+ item.name}}</span></md-item-template><div ng-messages=\"receivedCheck.bank.$error\" ng-if=\"receivedCheck.bank.$touched\"><div ng-message=\"required\">Você <b>deve</b> escolher um banco.</div></div><md-not-found>Não encontramos um banco para este nome: \"{{searchText}}\" .</md-not-found></md-autocomplete></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><label>{{\'BILL_PAYMENT.BRANCH\' | translate}}</label> <input type=\"text\" ng-blur=\"vm.checkByBranch(vm.scope.branch,vm.scope.bank)\" ng-change=\"vm.clearAccountAndCheck()\" ng-disabled=\"vm.check.readed\" md-autofocus=\"\" number-only=\"\" ng-model=\"vm.check.branch\" maxlength=\"10\" required=\"\"></md-input-container><md-input-container flex=\"\"><label>{{\'BILL_PAYMENT.CURRENT_ACCOUNT\' | translate}}</label> <input type=\"text\" ng-disabled=\"vm.check.readed\" md-autofocus=\"\" number-only=\"\" autocomplete=\"off\" ng-blur=\"vm.checkByAccount(vm.check.branch,vm.check.bank,vm.check.account)\" ng-change=\"(vm.check.number = null)\" ng-model=\"vm.check.account\" maxlength=\"10\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" ng-if=\"vm.load_check\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular></md-input-container><md-input-container flex=\"\" ng-if=\"!vm.load_check\"><label>{{\'BILL_PAYMENT.CHECK_NUMBER\' | translate}}</label> <input type=\"text\" autocomplete=\"off\" md-autofocus=\"\" ng-change=\"vm.check.blocked = false\" ng-blur=\"vm.scope.verifyDuplicateCheck(vm.check,true)\" ng-disabled=\"vm.check.readed\" ng-model=\"vm.check.number\" maxlength=\"15\" required=\"\"></md-input-container><date-picker md-placeholder=\"Data\" ng-model=\"vm.check.date\" required=\"\"></date-picker></div><div layout=\"row\"><md-input-container flex=\"\"><label>{{\'BILL_PAYMENT.AMOUNT\' | translate}}</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.check.amount\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" ng-disabled=\"vm.checkPolicies(\'pagamento_parcial\')\" required=\"\"></md-input-container></div><div layout=\"row\" ng-if=\"vm.check.interest_decision != 0\"><md-input-container flex=\"\"><label>Juros</label> <input type=\"text\" autocomplete=\"off\" ng-disabled=\"true\" md-autofocus=\"\" number-only=\"\" ng-model=\"vm.check.interest_value\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\"></md-input-container><md-input-container ng-if=\"vm.check.interest_decision == 1\" flex=\"\"><label>Valor do Cheque</label> <input type=\"text\" autocomplete=\"off\" disabled=\"\" md-autofocus=\"\" number-only=\"\" ng-model=\"vm.check.amount\" ng-value=\"vm.check.interest_value*1 + vm.check.amount*1\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\"></md-input-container><md-input-container ng-if=\"vm.check.interest_decision == 2\" flex=\"\"><label>Valor do Cheque</label> <input type=\"text\" autocomplete=\"off\" ng-disabled=\"true\" md-autofocus=\"\" number-only=\"\" ng-model=\"vm.check.amount\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\"></md-input-container></div><div layout=\"row\" ng-if=\"!vm.check.is_third_party_check && vm.check.checkinterest != null\"><md-radio-group ng-model=\"vm.check.interest_decision\"><div layout=\"row\"><md-radio-button ng-value=\"1\">Acrescenta os juros no valor do cheque</md-radio-button></div><div layout=\"row\"><md-radio-button ng-value=\"2\">Debita os juros do valor do cheque</md-radio-button></div><div layout=\"row\"><md-radio-button ng-value=\"0\">Dispensa os juros do cheque</md-radio-button></div></md-radio-group></div><div layout=\"column\" ng-if=\"vm.check.is_third_party_check\"><md-input-container flex=\"\"><label>Nome do Emitente</label> <input type=\"text\" ng-model=\"vm.check.issuer_name\" maxlength=\"20\"></md-input-container><md-input-container flex=\"\"><label for=\"cpf\">CPF do Emitente</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.check.issuer_document\" id=\"cpf\" ng-cpf=\"\" ui-mask=\"999.999.999-99\"></md-input-container><md-input-container flex=\"\"><label>Endereço do Emitente</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.check.issuer_contact\" maxlength=\"300\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button ng-disabled=\"receivedCheck.$invalid\" class=\"md-raised md-primary\" ng-if=\"vm.check.idx == null\" name=\"addCheck\" ng-click=\"vm.check.addPaymentList(vm.check);\">Incluir</md-button><md-button ng-disabled=\"receivedCheck.$invalid\" class=\"md-raised md-primary\" ng-if=\"vm.check.idx != null\" ng-click=\"vm.check.updatePaymentList(vm.check);\">Atualizar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/CreditCardPayment.html","<md-dialog no-limit=\"\" aria-label=\"Cartão de crédito\" md-theme=\"finance\"><form name=\"receivedCredit\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.scope.obj.type != null && vm.scope.obj.type == \'c\'\">Recebimento com cartão de crédito</h2><h2 ng-if=\"vm.scope.obj.type != null && vm.scope.obj.type == \'d\'\">Pagamento com cartão de crédito</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label ng-if=\"vm.scope.obj.type == \'c\'\" class=\"control-label\">Bandeira:</label> <label ng-if=\"vm.scope.obj.type == \'d\'\" class=\"control-label\">Cartão:</label><md-select ng-model=\"vm.scope.obj.creditCard\" ng-change=\"vm.scope.getAccountIdByCard(vm.scope.obj.creditCard)\" name=\"creditCard\" required=\"\"><md-option ng-repeat=\"card in vm.scope.obj.listAllCards\" ng-value=\"card\">{{ card.name }}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.scope.obj.type == \'c\'\" flex=\"40\"><label>4 últimos digitos (opcional)</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.card_number\" maxlength=\"4\" numbers-only=\"\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label>Valor</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.amount\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" ng-disabled=\"vm.scope.checkPolicies(\'pagamento_parcial\')\" name=\"amount\" required=\"\"></md-input-container><md-input-container ng-if=\"vm.scope.obj.type == \'c\'\" flex=\"50\"><label>Cod. Autorização (opcional)</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.document\" maxlength=\"6\" numbers-only=\"\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label>Pré-datado para (opcional):</label><date-picker ng-model=\"vm.scope.obj.suggested_date\" ng-change=\"vm.scope.setPaymentSuggestedDate(vm.scope.obj.suggested_date)\"></date-picker></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-if=\"vm.scope.obj.idx == null\" ng-click=\"vm.scope.addPaymentList(vm.scope.obj);\" ng-disabled=\"receivedCredit.$invalid\">Ok</md-button><md-button class=\"md-raised md-primary\" ng-if=\"vm.scope.obj.idx != null\" ng-click=\"vm.scope.updatePaymentList(vm.scope.obj);\" ng-disabled=\"receivedCredit.$invalid\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/CreditCardReceiving.html","<md-dialog no-limit=\"\" aria-label=\"Cartão de crédito\" md-theme=\"finance\"><form name=\"receivedCredit\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Recebimento com cartão de crédito</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label class=\"control-label\">Conta de recebimento</label><md-select ng-model=\"vm.scope.obj.current_account\" name=\"creditCard\" required=\"\" ng-change=\"vm.scope.setTax(vm.scope.obj)\"><md-option ng-repeat=\"account in vm.scope.obj.currentAccountlist\" ng-value=\"account\">{{ account.name }}</md-option></md-select></md-input-container><md-input-container flex=\"40\"><label>4 últimos digitos</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.card_number\" maxlength=\"4\" numbers-only=\"\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label>Valor</label> <input type=\"text\" ng-change=\"vm.scope.setTax(vm.scope.obj)\" autocomplete=\"off\" ng-model=\"vm.scope.obj.amount\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" ng-disabled=\"vm.scope.checkPolicies(\'pagamento_parcial\')\" name=\"amount\" required=\"\"></md-input-container><md-input-container flex=\"\"><label>Taxa</label> <input type=\"text\" ng-init=\"vm.scope.setTax(vm.scope.obj)\" autocomplete=\"off\" disabled=\"\" ng-model=\"vm.scope.obj.paymentTax\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" name=\"paymentTax\"></md-input-container><md-input-container flex=\"\"><label>Cod. Autorização</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.document\" maxlength=\"6\" numbers-only=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-if=\"vm.scope.obj.idx == null\" ng-click=\"vm.scope.addPaymentList(vm.scope.obj);\" ng-disabled=\"receivedCredit.$invalid\">Ok</md-button><md-button class=\"md-raised md-primary\" ng-if=\"vm.scope.obj.idx != null\" ng-click=\"vm.scope.updatePaymentList(vm.scope.obj);\" ng-disabled=\"receivedCredit.$invalid\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/CreditPayment.html","<md-dialog aria-label=\"Recebimento com crédito\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"receivedMoney\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-show=\"vm.scope.debitcredit.toLowerCase() == \'d\'\">{{ \'BILL_PAYMENT.CREDIT_PAYMENT\' | translate}}</h2><h2 ng-show=\"vm.scope.debitcredit.toLowerCase() == \'c\'\">{{ \'BILL_PAYMENT.CREDIT_RECEIVEMENT\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" name=\"movement_type_id\" value=\"1\" ng-model=\"vm.scope.obj.movement_type_id\"><div layout=\"row\"><md-input-container flex=\"100\"><label>Valor</label> <input ng-model=\"vm.scope.obj.amount\" maxlength=\"20\" ui-money-mask=\"2\" name=\"amount\" max=\"{{vm.scope.obj.balance}}\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\" required=\"\"><div ng-messages=\"receivedMoney.amount.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"max\"><span>Valor máximo {{vm.scope.obj.balance | currency}}</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-disabled=\"receivedMoney.$invalid\" ng-if=\"vm.scope.obj.idx == null\" name=\"addCheck\" ng-click=\"vm.scope.addPaymentList(vm.scope.obj);\">Ok</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"receivedMoney.$invalid\" ng-if=\"vm.scope.obj.idx != null\" ng-click=\"vm.scope.updatePaymentList(vm.scope.obj);\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/DebitCardPayment.html","<md-dialog no-limit=\"\" aria-label=\"Recebimento com Dinheiro\" md-theme=\"finance\"><form name=\"receivedDebit\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.scope.obj.type != null && vm.scope.obj.type == \'c\'\">Recebimento com cartão de débito</h2><h2 ng-if=\"vm.scope.obj.type != null && vm.scope.obj.type == \'d\'\">Pagamento com cartão de débito</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" name=\"movement_type_id\" value=\"20\" ng-model=\"vm.scope.obj.movement_type_id\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label>Cartão</label><md-select ng-model=\"vm.scope.obj.debitCard\" ng-change=\"vm.scope.getAccountIdByCard(vm.scope.obj.debitCard)\"><md-option ng-repeat=\"card in vm.scope.obj.listAllCards\" ng-value=\"card\">{{ card.name }}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.scope.obj.type == \'c\'\" flex=\"40\"><label>4 últimos digitos (opcional)</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.card_number\" maxlength=\"4\" numbers-only=\"\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label>Valor</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.amount\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" name=\"amount\" ng-disabled=\"vm.scope.checkPolicies(\'pagamento_parcial\')\" required=\"\"></md-input-container><md-input-container ng-if=\"vm.scope.obj.type == \'c\'\" flex=\"50\"><label>Cod. Autorização (opcional)</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.document\" maxlength=\"6\" numbers-only=\"\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label>Pré-datado para (opcional):</label><md-datepicker ng-model=\"vm.scope.suggestedDate\" ng-change=\"vm.scope.setPaymentSuggestedDate(vm.scope.suggestedDate)\"></md-datepicker></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-if=\"vm.scope.obj.idx == null\" ng-click=\"vm.scope.addPaymentList(vm.scope.obj);\" ng-disabled=\"receivedDebit.$invalid\">Ok</md-button><md-button class=\"md-raised md-primary\" ng-if=\"vm.scope.obj.idx != null\" ng-click=\"vm.scope.updatePaymentList(vm.scope.obj);\" ng-disabled=\"receivedDebit.$invalid\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/DebitCardReceiving.html","<md-dialog no-limit=\"\" aria-label=\"Cartão de crédito\" md-theme=\"finance\"><form name=\"receivedCredit\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Recebimento com cartão de crédito</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label class=\"control-label\">Conta de recebimento</label><md-select ng-model=\"vm.scope.obj.current_account_id\" name=\"creditCard\" required=\"\"><md-option ng-repeat=\"account in vm.scope.obj.currentAccountlist\" ng-value=\"account.id\">{{ account.name }}</md-option></md-select></md-input-container><md-input-container flex=\"40\"><label>4 últimos digitos</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.card_number\" maxlength=\"4\" numbers-only=\"\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><label>Valor</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.amount\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" name=\"amount\" ng-disabled=\"vm.scope.checkPolicies(\'pagamento_parcial\')\" required=\"\"></md-input-container><md-input-container flex=\"40\"><label>Cod. Autorização</label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm.scope.obj.document\" maxlength=\"6\" numbers-only=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-if=\"vm.scope.obj.idx == null\" ng-click=\"vm.scope.addPaymentList(vm.scope.obj);\" ng-disabled=\"receivedCredit.$invalid\">Ok</md-button><md-button class=\"md-raised md-primary\" ng-if=\"vm.scope.obj.idx != null\" ng-click=\"vm.scope.updatePaymentList(vm.scope.obj);\" ng-disabled=\"receivedCredit.$invalid\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/EditBillValues.html","<md-dialog aria-label=\"Recebimento com Dinheiro\" md-theme=\"finance\" style=\"max-width: 800px;\"><form ng-cloak=\"\" name=\"receivedMoney\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'BILL_PAYMENT.EDIT_VALUES\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 210px;\"><div layout=\"row\"><md-checkbox ng-model=\"vm.item.is_partial_payment\" ng-change=\"vm.changeFinalValue()\">Pagamento parcial</md-checkbox></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Valor</label> <input ng-model=\"vm.item.final_value\" maxlength=\"20\" ng-change=\"vm.changeFinalValue()\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\" required=\"\"></md-input-container><md-input-container flex=\"100\" ng-init=\"vm.item.calc_discount_cond_value = vm.item.calc_discount_cond_value == null ? 0 : vm.item.calc_discount_cond_value\"><label>(-) Desconto</label> <input ng-model=\"vm.item.calc_discount_cond_value\" maxlength=\"20\" ng-change=\"vm.changeFinalValue()\" ng-disabled=\"vm.item.is_partial_payment\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\"></md-input-container><md-input-container flex=\"100\" ng-init=\"vm.item.calc_fine_value = vm.item.calc_fine_value == null ? 0 : vm.item.calc_fine_value\"><label>(+) Multa</label> <input ng-model=\"vm.item.calc_fine_value\" maxlength=\"20\" ng-change=\"vm.changeFinalValue()\" ng-disabled=\"vm.item.is_partial_payment\" ui-money-mask=\"2\" placeholder=\"\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\"></md-input-container><md-input-container flex=\"100\" ng-init=\"vm.item.calc_interest_value = vm.item.calc_interest_value == null ? 0 : vm.item.calc_interest_value\"><label>(+) Juros</label> <input ng-model=\"vm.item.calc_interest_value\" maxlength=\"20\" ng-change=\"vm.changeFinalValue()\" ng-disabled=\"vm.item.is_partial_payment\" ui-money-mask=\"2\" placeholder=\"\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\"></md-input-container><md-input-container flex=\"100\"><label>Valor a pagar</label> <input ng-model=\"vm.item.value_paid\" maxlength=\"20\" ng-disabled=\"!vm.item.is_partial_payment\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\" required=\"\"></md-input-container><div layout=\"row\"><div ng-if=\"vm.alert_fine_interest\">Valor a liquidar deve ser superior ou igual à soma dos juros e multa.</div><md-radio-group layout=\"row\" ng-change=\"vm.changeAllowanceDifference()\" flex=\"\" ng-if=\"((vm.item.showDifference !== 0 || vm.is_credit) || vm.item.allowance_difference) && !vm.alert_fine_interest\" ng-model=\"vm.item.is_partial_payment\" layout-align=\"space-between\"><md-radio-button flex=\"\" value=\"1\">{{vm.is_credit ? \'Mantém o crédito\' : \'Liquidação parcial\'}}</md-radio-button><md-radio-button flex=\"\" value=\"0\" policy-access=\"allowance\">{{vm.is_credit ? \'Dispensa o crédito\' : \'Abona o valor residual\'}}</md-radio-button></md-radio-group></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.alert_fine_interest\" ng-click=\"vm.answer(vm.item)\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/MoneyPayment.html","<md-dialog aria-label=\"Recebimento com Dinheiro\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"receivedMoney\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-show=\"vm.scope.debitcredit.toLowerCase() == \'d\'\">{{ \'BILL_PAYMENT.MONEY_PAYMENT\' | translate}}</h2><h2 ng-show=\"vm.scope.debitcredit.toLowerCase() == \'c\'\">{{ \'BILL_PAYMENT.MONEY_RECEIVEMENT\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" name=\"movement_type_id\" value=\"1\" ng-model=\"vm.scope.money.movement_type_id\"><div layout=\"row\"><md-input-container flex=\"100\"><label>Conta Corrente</label><md-select ng-model=\"vm.scope.money.current_account_id\" required=\"\"><md-option ng-repeat=\"mAccountList in vm.scope.moneyAccountList\" ng-value=\"mAccountList.id\">{{ mAccountList.name }}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Valor</label> <input ng-model=\"vm.scope.money.amount\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\" ng-disabled=\"vm.scope.checkPolicies(\'pagamento_parcial\')\" required=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-disabled=\"receivedMoney.$invalid\" ng-if=\"vm.scope.obj.idx == null\" name=\"addCheck\" ng-click=\"vm.scope.addPaymentList(vm.scope.money);\">Ok</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"receivedMoney.$invalid\" ng-if=\"vm.scope.obj.idx != null\" ng-click=\"vm.scope.updatePaymentList(vm.scope.money);\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/PaymentTax.html","<md-dialog aria-label=\"Recebimento com Dinheiro\" md-theme=\"finance\"><form ng-cloak=\"\" name=\"receivedMoney\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar taxa</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" name=\"movement_type_id\" value=\"1\" ng-model=\"vm.scope.obj.movement_type_id\"><div layout=\"row\"><md-input-container flex=\"100\"><label>Valor da taxa</label> <input ng-model=\"vm.scope.obj.amount\" maxlength=\"20\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\" required=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-disabled=\"receivedMoney.$invalid\" ng-if=\"vm.scope.obj.idx == null\" name=\"addCheck\" ng-click=\"vm.scope.addPaymentList(vm.scope.obj);\">Ok</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"receivedMoney.$invalid\" ng-if=\"vm.scope.obj.idx != null\" ng-click=\"vm.scope.updatePaymentList(vm.scope.obj);\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/stockout-message-modal.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\" style=\"min-width: 300px;\" xmlns=\"http://www.w3.org/1999/html\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Produtos sem estoque</h2><span flex=\"\"></span><md-icon md-font-icon=\"icon-close\"></md-icon></div></md-toolbar><md-dialog-content><p style=\"color: red\">Não foi possível concluir a transação devido<br>aos seguintes itens sem estoque suficiente:</p><div class=\"md-dialog-content\" style=\"padding-left: 0; text-align: left\"><table style=\"border: 1px\"><tr><th>Nome</th><th style=\"text-align: right\">Estoque</th></tr><tr ng-repeat=\"product in vm.scope.products\"><td>{{product.nome}}</td><td style=\"text-align: right\">{{product.quantidade}}</td></tr></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">OK</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/modals/waitread.html","<md-dialog aria-label=\"Leitura de cheque\" style=\"max-width: 400px; width: 400px;\" md-theme=\"finance\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'Aguardando leitura do cheque...\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-svg-src=\"img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"row\" ng-init=\"vm.scope.setFocusOnCheckField()\"><md-input-container flex=\"\"><label>Ou digite o número do cheque</label> <input ng-model=\"barcode\" name=\"barcodeField\" id=\"barcodeField\" ng-keypress=\"event=$event\" ng-change=\"vm.scope.readCheckNumber(barcode, event)\" ng-blur=\"vm.scope.setFocusOnCheckField()\" maxlength=\"30\" ng-maxlength=\"30\" number-only=\"\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bill-payment/views/form-payment.html","<div layout=\"row\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{ vm.title }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" translate=\"\" translate-attr-aria-label=\"BILL_PAYMENT.CLOSE_SIDENAV\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"content\"><div class=\"sidenav-form top-small\"><div layout=\"column\" layout-sm=\"column\" ng-if=\"vm.show_loader\" style=\"margin-top: 200px;\" layout-align=\"space-around\"><div style=\"margin-left: 295px\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div></div><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\" ng-if=\"!vm.show_loader\"><form name=\"formPayment\" ng-submit=\"vm.verifyAndSubmit();\"><a4-bills-operation bills=\"vm.currentItem.currentItemList\" current-item=\"vm.action\" show-edit=\"true\" update-bills=\"vm.setPaymentDate()\" ng-if=\"vm.show_list\" show-description=\"false\" disable-final-value=\"true\" future-discounts=\"false\" type=\"\'payment\'\"></a4-bills-operation><a4-payments-grid currentaccountlist=\"vm.currentaccount_list\" debitcredit=\"vm.action.billsSelected[0].debit_credit\" billsselected=\"vm.action.billsSelected\" amount=\"vm.action.totalAmount\" amount-calc=\"vm.action.totalAmountCalc\" checklist=\"vm.checkList\" paymentslist=\"vm.action.payments\" movementtypes=\"vm.movementTypes\" banks=\"vm.banks\" date=\"vm.action.issue_date\" suggested-date=\"vm.action.issue_date\" ispartialpayment=\"vm.action.is_partial_payment\" paymentwithdifference=\"vm.action.payment_with_difference\" haslessdifference=\"vm.action.haslessdifference\" hasmoredifference=\"vm.action.hasmoredifference\" datedifference=\"vm.action.diff_date\" checkinterest=\"vm.checkInterest\" check-pad=\"vm.action.check_pad\" difference=\"vm.action.difference\" credit-amount=\"vm.action.creditAmount\" credit-person=\"vm.action.creditPerson\" payment-tax=\"vm.action.paymentTax\" total-fine=\"vm.action.totalMulta\" total-interest=\"vm.action.totalJuros\"></a4-payments-grid><md-content class=\"md-padding\"><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.close();\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'CURRENT_ACCOUNT.FORM_SUBMIT\' | translate }}\" ng-disabled=\"formBill.$invalid || vm.action.haslessdifference\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"$root.show_loader\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span ng-show=\"vm.action.billsSelected[0].debit_credit == \'C\'\">Receber</span> <span ng-show=\"vm.action.billsSelected[0].debit_credit == \'D\'\">Pagar</span></md-button></footer></md-content></form></div></div></div></div>");
$templateCache.put("app/finance/bill-receipt/views/bill-receipt-index.html","<div id=\"page-material-table\" class=\"bill-receipt page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke !important;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cash-usd\" class=\"s24\"></md-icon></span> <span class=\"logo-text md-primary md-hue-1\">{{\'BILL_RECEIPT.TITLE\' | translate}}</span></div></div></md-toolbar><md-content style=\"background-color: whitesmoke !important;\"><md-content style=\"background-color: whitesmoke !important;\"><a4-bill-grid ng-model=\"vm.bills\" debit-credit=\"C\" show-create-button=\"true\" show-loader=\"vm.show_loader\" show-button-more=\"vm.show_button_more\" height-grid=\"vm.windowHeight\" paginate-function=\"vm.getAll(page, qtd, date, person_id, status, flag, order)\"></a4-bill-grid></md-content></md-content></div>");
$templateCache.put("app/finance/bill-receipt/views/form-edit.html","<div class=\"create-form\" md-theme=\"finance\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.bill.id == null\">Nova entrada financeira</span> <span class=\"title\" ng-show=\"vm.bill.id != null\">Editar entrada financeira</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeSideBar()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"content\"><md-card md-theme-watch=\"\" ng-if=\"vm.bill.edit_expense == 3\"><md-card-title><md-card-title-text><span class=\"md-headline\"><strong>ATENÇÃO!</strong></span> <span class=\"md-subhead\">Série de parcelas recorrentes. As alterações feitas irão afetar todas as parcelas do série.</span></md-card-title-text></md-card-title></md-card><md-card md-theme-watch=\"\" ng-if=\"vm.bill.edit_expense == 2\"><md-card-title><md-card-title-text><span class=\"md-headline\"><strong>ATENÇÃO!</strong></span> <span class=\"md-subhead\">Série de parcelas recorrentes. Alterações feitas afetarão parcelas da série a partir da {{vm.bill.instalment_name}}, mas as parcelas anteriores não serão afetadas.</span></md-card-title-text></md-card-title></md-card><md-card md-theme-watch=\"\" ng-if=\"vm.bill.edit_expense == 1\"><md-card-title><md-card-title-text><span class=\"md-headline\"><strong>ATENÇÃO!</strong></span> <span class=\"md-subhead\">Parcela {{vm.bill.instalment_name}}. Qualquer alteração afetará apenas esta parcela.</span></md-card-title-text></md-card-title></md-card></div><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 300px\" ng-if=\"!vm.show_form\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><form novalidate=\"\" name=\"bill_form\" ng-if=\"vm.show_form\" ng-submit=\"vm.submit(vm.bill)\"><div class=\"content\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"DADOS DA ENTRADA\"><md-content class=\"md-padding\" id=\"content\" ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"input-a4\" flex=\"\"><label for=\"selectProductAndServices\">{{ \'BILL_RECEIPT.PRODUCT_SERVICES\' | translate}}</label><md-select disabled=\"\" id=\"selectProductAndServices\" placeholder=\"{{ \'BILL_RECEIPT.PRODUCT_SERVICES\' | translate}}\" ng-change=\"vm.changeProduct(vm.bill.product_id)\" ng-model=\"vm.bill.product_id\"><md-option ng-repeat=\"item in vm.products\" ng-value=\"item.id\">{{ item.name | translate}}</md-option></md-select></md-input-container><md-input-container class=\"input-a4\" flex=\"\" ng-if=\"vm.payment_plans.length > 0\"><label for=\"selectProductAndServices\">{{ \'BILL_RECEIPT.PAYMENT_PLAN\' | translate}}</label><md-select disabled=\"\" class=\"select2 select2-hidden-accessible\" id=\"repeatSelectPayment\" ng-model=\"vm.bill.payment_plan_id\" ng-disabled=\"vm.bill.edit_expense != null\" ng-change=\"vm.getFromPaymentPlan(vm.bill.payment_plan_id)\"><md-option ng-repeat=\"item in vm.payment_plans\" ng-value=\"item.id\">{{ item.name | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"input-a4\"><md-autocomplete required=\"\" disabled=\"\" flex=\"40\" md-input-name=\"autocompleteField\" md-no-cache=\"false\" md-selected-item=\"vm.bill.person_id\" md-search-text=\"vm.searchText\" md-items=\"item in vm.listAllPersons(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"3\" md-delay=\"500\" md-require-match=\"\" md-floating-label=\"Pessoa\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><div ng-messages=\"bill_form.autocompleteField.$error\" ng-if=\"bill_form.autocompleteField.$touched\"><div ng-message=\"required\">{{ \'BILL_RECEIPT.FORM_REQUIRED\' | translate }}</div></div><md-not-found>Nenhum registro encontrado para \"{{vm.searchText}}\".</md-not-found></md-autocomplete></md-input-container><md-input-container class=\"input-a4\" flex=\"\" ng-if=\"vm.bill.edit_expense == null || vm.bill.edit_expense == \'undefined\' || vm.bill.edit_expense == 1\"><date-picker ng-if=\"vm.bill.edit_expense == null ||vm.bill.edit_expense == 1 || vm.bill.edit_expense == null\" disabled=\"vm.bill.edit !== null\" placeholder=\"{{ \'ISSUE_DATE\' | translate}}\" ng-model=\"vm.bill.due_date\"></date-picker><input ng-if=\"vm.bill.edit_expense == \'undefined\' && vm.bill.edit_expense != 1\" value=\"{{vm.bill.due_date}}\" ng-disabled=\"true\" readonly=\"\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>{{ \'BILL_RECEIPT.REFERENCE\' | translate}}</label><md-icon md-font-icon=\"icon-alert-circle\"></md-icon><input type=\"text\" ng-model=\"vm.bill.document_reference\" maxlength=\"20\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" ng-if=\"vm.currentItem.payment_plan_id === null && vm.currentItem.external_id === null\" layout-wrap=\"\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Descrição</label> <input type=\"text\" ng-model=\"vm.bill.description\" maxlength=\"20\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><a4-detail-grid debit-credit=\"C\" flex=\"100\" has-block=\"vm.hasProduct || vm.hasPaymentPlan\" edit=\"vm.bill.edit_expense\" current-item=\"vm.bill\" list=\"vm.bill.bill_details\" total-amount=\"vm.bill.amount\" categories=\"vm.categories\"></a4-detail-grid></div><div ng-if=\"vm.currentItem.payment_plan_id === null && vm.currentItem.external_id === null\"><div layout=\"row\" layout-align=\"start\"><md-input-container class=\"input-a4\" flex=\"100\"><label for=\"collectiontype\">{{ \'Forma de Cobrança\' | translate}}</label><md-select name=\"collectiontype\" ng-disabled=\"vm.hasProduct || vm.hasPaymentPlan\" id=\"collectiontype\" ng-model=\"vm.currentItem.collection_type\"><md-option ng-value=\"i.id\" ng-repeat=\"i in vm.colletion_types\">{{ i.name | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"((vm.bill.debit_credit| lowercase) == \'c\' && vm.bill.was_paid == 2) || vm.bill.edit_expense != 3\"><md-input-container class=\"input-a4\" flex=\"\" ng-show=\"vm.bill.collection_type == 9\"><label for=\"bankslipruleid\">{{ \'Regras de Boleto\' | translate}}</label><md-select name=\"bankslipruleid\" ng-disabled=\"(vm.hasProduct || vm.hasPaymentPlan) && vm.bill.bank_slip_rule_id != null\" id=\"bankslipruleid\" type=\"text\" ng-model=\"vm.bill.bank_slip_rule_id\"><md-option ng-value=\"i.id\" ng-repeat=\"i in vm.allBankSlipRules\">{{ i.name | translate}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-gt-sm=\"row\"><fieldset class=\"standard without-legend group-field\"><md-radio-group name=\"receipt\" ng-model=\"vm.bill.was_paid\" ng-click=\"vm.changeWasPaid();\" disabled=\"\" ng-change=\"vm.tabChange(vm.bill.was_paid)\" required=\"\"><md-radio-button ng-value=\"1\" flex=\"\">Receita única</md-radio-button><md-radio-button ng-value=\"2\" flex=\"\">Receita recorrente</md-radio-button></md-radio-group></fieldset></div></md-content></md-tab><md-tab label=\"MAIS INFORMAÇÕES\"><md-content class=\"md-padding\" ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><div label=\"Mais detalhes\"><strong class=\"group-field md-block\"><small>{{ \'ACCRUAL\' | translate}}</small></strong><div layout=\"row\"><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'MONTH\' | translate}}</label><md-select ng-model=\"vm.bill.accrual_month\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.months\">{{ item.label }}</md-option></md-select></md-input-container><md-input-container class=\"input-a4\" flex=\"\"><label for=\"accrual_year\">{{ \'YEAR\' | translate}}</label><md-select class=\"form_group\" id=\"accrual_year\" ng-model=\"vm.bill.accrual_year\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.years\">{{ item.label }}</md-option></md-select></md-input-container></div><div layout=\"low\"><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'COMPLEMENTS_NOTES\' | translate}}</label> <textarea rows=\"2\" ng-model=\"vm.bill.notes\"></textarea></md-input-container><md-input-container class=\"input-a4\" flex=\"\"><label for=\"accrual_year\">{{ \'TAGS\' | translate}}</label><tags-input add-on-paste=\"true\" text=\"name\" placeholder=\"Adicionar marcadores\" ng-model=\"vm.bill.tags\"><auto-complete source=\"vm.loadTags($query)\"></auto-complete></tags-input></md-input-container></div></div></md-content></md-tab><md-tab label=\"DETALHES DA RECORRÊNCIA\" ng-disabled=\"vm.bill.was_paid != 2\" ng-if=\"vm.bill.was_paid == 2 && vm.bill.edit_expense == 2 || (angular.isDefined(vm.bill.edit_expense) || vm.bill.edit_expense == 0 || vm.bill.edit_expense == null)\" md-active=\"vm.activate_recurrence\"><md-content class=\"md-padding\" ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><div layout=\"row\" layout-align=\"start center\"><strong class=\"group-field\" flex=\"70\"><small>{{\'Tipo da recorrência\' | translate }}</small></strong><div></div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><fieldset class=\"standard without-legend group-field\"><md-radio-group name=\"endofrecurrence\" ng-model=\"vm.bill.end_of_recurrence\" ng-disabled=\"(vm.hasProduct || vm.hasPaymentPlan)\"><md-radio-button value=\"0\" class=\"md-primary\">Quantidade fixa de parcelas</md-radio-button><md-radio-button value=\"1\" class=\"md-primary\">Contínua</md-radio-button></md-radio-group></fieldset></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"md-input-has-placeholder\" ng-show=\"vm.bill.end_of_recurrence == 0 || vm.bill.end_of_recurrence == 1\" flex=\"\"><input type=\"text\" name=\"frequencyqty\" placeholder=\"Quantidade do período\" ng-disabled=\"(vm.hasProduct || vm.hasPaymentPlan) && vm.bill.frequency_qty != null\" ng-model=\"vm.bill.frequency_qty\" maxlength=\"2\"> <span class=\"input-group-btn btn-left\"><i class=\"material-icons\">date_range</i></span></md-input-container><md-input-container class=\"md-input-has-placeholder\" ng-hide=\"vm.bill.end_of_recurrence == 2\" flex=\"\"><label>{{ \'Frequência a cada \' | translate }} {{ vm.bill.frequency_qty }}</label><md-select name=\"frequency\" ng-disabled=\"vm.hasProduct || vm.hasPaymentPlan\" ng-model=\"vm.bill.frequency\" ng-selected=\"vm.bill.frequency == item.id\"><md-option ng-repeat=\"item in vm.frequency_options\" ng-value=\"item.id\">{{item.name | translate}}</md-option></md-select></md-input-container><date-picker flex=\"\" ng-show=\"vm.bill.end_of_recurrence == 1\" disabled=\"vm.hasProduct || vm.hasPaymentPlan\" placeholder=\"Data de encerramento:\" ng-model=\"vm.bill.date_end\"></date-picker></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><a4-table-installments ng-if=\"vm.bill.end_of_recurrence == 0\" frequency-qty=\"vm.bill.frequency_qty\" frequency=\"vm.bill.frequency\" current-item=\"vm.bill\" quantity=\"vm.bill.quantity\" total-amount=\"vm.bill.amount\" initial-qty=\"vm.bill.quantity\" list=\"vm.bill.payment_installments\" disabled=\"vm.bill.recurrency_on_value != 1\" is-recurrence=\"vm.bill.recurrency_on_value == 0\"></a4-table-installments></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><strong class=\"group-field md-block\"><small>{{\'Valor na recorrência\' | translate }}</small></strong><md-radio-group ng-model=\"vm.bill.recurrency_on_value\" class=\"md-padding\"><div ng-if=\"vm.bill.frequency_type != 1\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"0\" ng-checked=\"vm.bill.end_of_recurrence == 0\">Parcelas com o mesmo valor de {{vm.bill.amount | currency}}</md-radio-button></div><div ng-if=\"vm.bill.frequency_type != 1\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"1\" ng-checked=\"vm.bill.end_of_recurrence == 1\">O valor pode variar a cada parcela</md-radio-button></div><div ng-if=\"vm.bill.end_of_recurrence == 0\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"2\" ng-checked=\"vm.bill.end_of_recurrence == 0\">Divide o valor do título de {{vm.bill.amount | currency}} nas parcelas</md-radio-button></div></md-radio-group></div><strong class=\"group-field md-block\"><small>{{\'Indices\' | translate }}</small></strong><div layout=\"row\" ng-if=\"vm.bill.recurrency_on_value == 0\"><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'Indice de correção\' | translate}}</label><md-select ng-model=\"vm.bill.index_id\" style=\"margin-top: 5px\" ng-disabled=\"(vm.hasProduct || vm.hasPaymentPlan) && vm.bill.fines_rule_id != null\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.indexCorrection\">{{ item.name | translate}}</md-option></md-select></md-input-container><date-picker ng-model=\"vm.bill.next_adjustment_date\" placeholder=\"{{ \'Próximo reajuste em\' | translate}}\"></date-picker></div><strong class=\"group-field md-block\" ng-if=\"vm.bill.was_paid != 1 && (vm.bill.edit_expense == 2 || angular.isUndefined(vm.bill.edit_expense) || vm.bill.edit_expense == null)\"><small>{{\'Regras\' | translate }} (Opcional)</small></strong><md-content ng-if=\"(angular.isUndefined(vm.bill.edit_expense) || vm.bill.edit_expense == 2 || vm.bill.edit_expense == null)\"><div layout=\"row\" ng-if=\"vm.bill.was_paid != 1\"><div flex=\"\"><select-rules list=\"vm.bill.discounts_rules\" templatename=\"discount\" title-first-field=\"Regra de Descontos\" allrules=\"includeScope.allDiscountRules\"></select-rules></div></div><div layout=\"row\" ng-if=\"vm.bill.was_paid != 1\"><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'Regra de Acréscimos\' | translate}}</label><md-select name=\"finesrule\" id=\"fines_rule_id\" ng-disabled=\"(vm.hasProduct || vm.hasPaymentPlan) && vm.bill.fines_rule_id != null\" ng-model=\"vm.bill.fines_rule_id\"><md-option ng-value=\"i.id\" ng-repeat=\"i in vm.allAdditionRules\">{{ i.name | translate}}</md-option></md-select></md-input-container></div></md-content></md-content></md-tab><md-tab label=\"DESCONTOS INDIVIDUAIS\" ng-disabled=\"vm.bill.was_paid != 2\" ng-if=\"vm.bill.was_paid == 2 && vm.bill.edit_expense == 2 || (angular.isDefined(vm.bill.edit_expense) || vm.bill.edit_expense == 0 || vm.bill.edit_expense == null)\"><md-content ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><md-table-container><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Razão</th><th md-column=\"\">Desconto</th><th md-column=\"\">F/C</th><th md-column=\"\">De</th><th md-column=\"\">Até</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.bill.individual_discounts\"><td md-cell=\"\">{{ item.discount_reason.name }}</td><td md-cell=\"\">{{ item.value_type == 1 ? \"% \" + item.amount : \"R$ \" + item.amount }}</td><td md-cell=\"\">{{ item.is_fixed ? \'F\' : \'C\' }}</td><td md-cell=\"\">{{ item.start_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\">{{ item.end_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeItemDesconto($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-button class=\"md-primary\" aria-label=\"Novo Desconto\" style=\"margin-left: 15px\" ng-click=\"vm.createNewIndivialDiscount()\">Adicionar desconto<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-content></md-tab></md-tabs></md-content></div><md-content class=\"md-padding\"><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeSideBar();\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'BILL_RECEIPT.FORM_SUBMIT\' | translate }}\" ng-disabled=\"formBill.$invalid || vm.bill.bill_details[0].bill_category_id == null || vm.bill.bill_details[0].amount == 0 || vm.show_progress\"><md-progress-circular style=\"float: left; top: 8px;color: white\" ng-show=\"vm.show_progress\" md-diameter=\"20px\"></md-progress-circular><span ng-show=\"vm.bill.id == null\" translate=\"BILL_RECEIPT.FORM_CREATE\"></span> <span ng-show=\"vm.bill.id != null\" translate=\"BILL_RECEIPT.FORM_EDIT\"></span></md-button></footer></md-content></form></div>");
$templateCache.put("app/finance/bill-receipt/views/form.html","<div class=\"create-form\" md-theme=\"finance\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.bill.id == null\">Nova entrada financeira</span> <span class=\"title\" ng-show=\"vm.bill.id != null\">Editar entrada financeira</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"content\"></div><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 300px\" ng-if=\"!vm.show_form\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><form novalidate=\"\" name=\"bill_form\" ng-if=\"vm.show_form\" ng-submit=\"vm.submit(bill_form, vm.bill, $flow.files, $event)\"><div class=\"content\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"GERAL\"><md-content class=\"md-padding\" id=\"content\" ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Dados de entrada</b> <small>Abaixo adicione os dados para criação do titulo</small></div></div><hr><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-autocomplete flex=\"\" md-input-name=\"autocompleteField\" md-no-cache=\"false\" md-selected-item=\"vm.bill.product\" md-selected-item-change=\"vm.changeProduct(vm.bill.product)\" md-search-text=\"vm.searchProduct\" md-items=\"item in vm.getOnlyProducts(vm.searchProduct)\" md-item-text=\"item.name\" md-min-length=\"3\" md-delay=\"500\" md-require-match=\"\" md-floating-label=\"{{ \'BILL_RECEIPT.PRODUCT_SERVICES\' | translate}}\"><md-item-template><span md-highlight-text=\"vm.searchProduct\">{{item.name}}</span></md-item-template><md-not-found>Nenhum registro encontrado para \"{{vm.searchProduct}}\".</md-not-found></md-autocomplete></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-autocomplete required=\"\" flex=\"70\" md-input-name=\"autocompleteField\" md-no-cache=\"false\" md-selected-item=\"vm.bill.person_id\" md-search-text=\"vm.searchText\" md-items=\"item in vm.listAllPersons(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"3\" md-delay=\"500\" md-require-match=\"\" md-floating-label=\"Pessoa\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><div ng-messages=\"bill_form.autocompleteField.$error\"><div ng-message=\"required\">{{ \'BILL_RECEIPT.FORM_REQUIRED\' | translate }}</div></div><md-not-found>Nenhum registro encontrado para \"{{vm.searchText}}\".</md-not-found></md-autocomplete><md-input-container class=\"input-a4\" flex=\"30\" ng-if=\"vm.bill.edit_expense == null || vm.bill.edit_expense == \'undefined\' || vm.bill.edit_expense == 1\"><date-picker ng-if=\"vm.bill.edit_expense == null ||vm.bill.edit_expense == 1 || vm.bill.edit_expense == null\" placeholder=\"{{ \'ISSUE_DATE\' | translate}}:\" ng-model=\"vm.bill.due_date\"></date-picker><input ng-if=\"vm.bill.edit_expense == \'undefined\' && vm.bill.edit_expense != 1\" value=\"{{vm.bill.issue_date}}\" ng-disabled=\"true\" readonly=\"true\"></md-input-container><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'BILL_RECEIPT.REFERENCE\' | translate}}</label><md-icon style=\"color: #757575;\" class=\"md-icon-button\" md-font-icon=\"icon-alert-circle\"></md-icon><input type=\"text\" ng-model=\"vm.bill.document_reference\" maxlength=\"20\"></md-input-container><md-input-container class=\"input-a4\" flex=\"\"><label>Observações</label><md-icon style=\"color: #757575;\" class=\"md-icon-button\" md-font-icon=\"icon-alert-circle\"></md-icon><input type=\"text\" ng-model=\"vm.bill.notes\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" ng-if=\"vm.is_create\" layout-wrap=\"\"><md-input-container class=\"md-input-has-placeholder\"><label>Descrição</label><md-icon md-font-icon=\"icon-alert-circle\"></md-icon><input type=\"text\" ng-model=\"vm.bill.description\" maxlength=\"20\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><a4-detail-grid debit-credit=\"C\" flex=\"100\" edit=\"vm.bill.edit_expense\" current-item=\"vm.bill\" list=\"vm.bill.bill_details\" total-amount=\"vm.bill.amount\" categories=\"vm.categories\"></a4-detail-grid></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103);margin-bottom: 10px\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Forma de cobrança</b> <small>Abaixo defina como este título será cobrado ao cliente</small></div></div><hr><div layout=\"row\" layout-align=\"start\" ng-if=\"vm.bill.edit_expense == null || vm.bill.edit_expense == \'undefined\'\"><md-input-container class=\"input-a4\" flex=\"100\"><label for=\"collectiontype\">{{ \'Forma de Cobrança\' | translate}}</label><md-select name=\"collectiontype\" required=\"\" id=\"collectiontype\" ng-model=\"vm.bill.collection_type\"><md-option ng-value=\"i.id\" ng-repeat=\"i in vm.colletion_types\">{{ i.name | translate}}</md-option></md-select><div ng-messages=\"bill_form.collectiontype.$error\"><div ng-message=\"required\">Forma de cobrança <b>deve</b> ser informada</div></div></md-input-container></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103);margin-bottom: 10px\" ng-show=\"vm.bill.collection_type == 9\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Regra de boleto</b> <small>Ao definir a forma de cobrança boleto, <b>deve-se</b> adicionar uma regra de boleto ao titulo</small></div></div><hr><div layout=\"row\" style=\"margin-bottom: 10px\" ng-if=\"((vm.bill.debit_credit| lowercase) == \'c\' && vm.bill.was_paid == 2) || vm.bill.edit_expense == 2 || vm.bill.edit_expense == null\"><md-input-container class=\"input-a4\" flex=\"\" ng-show=\"vm.bill.collection_type == 9\"><label for=\"bankslipruleid\">{{ \'Regras de Boleto\' | translate}}</label><md-select name=\"bankslipruleid\" ng-required=\"vm.bill.collection_type == 9\" id=\"bankslipruleid\" type=\"text\" ng-model=\"vm.bill.bank_slip_rule_id\"><md-option ng-value=\"i.id\" ng-repeat=\"i in vm.allBankSlipRules\">{{ i.name | translate}}</md-option></md-select><div ng-messages=\"bill_form.bankslipruleid.$error\"><div ng-message=\"required\">Regra de boleto <b>deve</b> ser informada</div></div></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\" ng-if=\"vm.bill.id == null && (vm.bill.edit_expense == null || vm.bill.edit_expense == \'undefined\')\"><fieldset class=\"standard without-legend group-field\"><md-radio-group name=\"receipt\" ng-model=\"vm.bill.was_paid\" ng-click=\"vm.changeWasPaid();\" ng-disabled=\"vm.bill.person_id == null || vm.bill.issue_date == null || vm.bill.bill_details[0].bill_category_id == null || vm.bill.bill_details[0].amount == 0\" ng-change=\"vm.tabChange(vm.bill.was_paid)\" required=\"\"><md-radio-button ng-value=\"1\" flex=\"\">Receita única</md-radio-button><md-radio-button ng-value=\"2\" flex=\"\">Receita recorrente</md-radio-button></md-radio-group></fieldset></div></md-content></md-tab><md-tab label=\"MAIS INFORMAÇÕES\"><md-content class=\"md-padding\" ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><div label=\"Mais detalhes\"><strong class=\"group-field md-block\"><small>{{ \'ACCRUAL\' | translate}}</small></strong><div layout=\"row\"><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'MONTH\' | translate}}</label><md-select ng-model=\"vm.bill.accrual_month\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.months\">{{ item.label }}</md-option></md-select></md-input-container><md-input-container class=\"input-a4\" flex=\"\"><label for=\"accrual_year\">{{ \'YEAR\' | translate}}</label><md-select class=\"form_group\" id=\"accrual_year\" ng-model=\"vm.bill.accrual_year\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.years\">{{ item.label }}</md-option></md-select></md-input-container></div><div layout=\"low\"><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'COMPLEMENTS_NOTES\' | translate}}</label> <textarea rows=\"2\" ng-model=\"vm.bill.notes\"></textarea></md-input-container><md-input-container class=\"input-a4\" flex=\"\"><label for=\"accrual_year\">{{ \'TAGS\' | translate}}</label><tags-input add-on-paste=\"true\" text=\"name\" placeholder=\"Adicionar marcadores\" ng-model=\"vm.bill.tags\"><auto-complete source=\"vm.loadTags($query)\"></auto-complete></tags-input></md-input-container></div></div></md-content></md-tab><md-tab label=\"DETALHES DA RECORRÊNCIA\" ng-disabled=\"vm.bill.was_paid != 2\" ng-if=\"vm.bill.was_paid == 2 && vm.bill.edit_expense == 2 || (angular.isDefined(vm.bill.edit_expense) || vm.bill.edit_expense == 0 || vm.bill.edit_expense == null)\" md-active=\"vm.activate_recurrence\"><md-content class=\"md-padding\" ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><div layout=\"row\" layout-align=\"start center\"><strong class=\"group-field\" flex=\"70\"><small>{{\'Tipo da recorrência\' | translate }}</small></strong><div></div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><fieldset class=\"standard without-legend group-field\"><md-radio-group name=\"endofrecurrence\" ng-model=\"vm.bill.end_of_recurrence\"><md-radio-button value=\"0\" class=\"md-primary\">Quantidade fixa de parcelas</md-radio-button><md-radio-button value=\"1\" class=\"md-primary\">Até uma determinada data</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Sem prazo determinado</md-radio-button></md-radio-group></fieldset></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"md-input-has-placeholder\" ng-show=\"vm.bill.end_of_recurrence == 0\" flex=\"\"><input type=\"text\" name=\"frequencyqty\" placeholder=\"Quantidade do período\" ng-model=\"vm.bill.frequency_qty\" maxlength=\"2\"> <span class=\"input-group-btn btn-left\"><i class=\"material-icons\">date_range</i></span></md-input-container><md-input-container class=\"md-input-has-placeholder\" ng-show=\"vm.bill.end_of_recurrence == 0\" flex=\"\"><label>{{ \'Frequência a cada \' | translate }} {{ vm.bill.frequency_qty }}</label><md-select name=\"frequency\" ng-model=\"vm.bill.frequency\" ng-selected=\"vm.bill.frequency == item.id\"><md-option ng-repeat=\"item in vm.frequency_options\" ng-value=\"item.id\">{{item.name | translate}}</md-option></md-select></md-input-container><div flex=\"\" ng-show=\"vm.bill.end_of_recurrence == 1\"><date-picker ng-model=\"vm.bill.date_end\" flex=\"\" placeholder=\"Data final da recorrência\"></date-picker></div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><strong class=\"group-field md-block\"><small>{{\'Valor na recorrência\' | translate }}</small></strong><md-radio-group ng-model=\"vm.bill.recurrency_on_value\" class=\"md-padding\"><div ng-if=\"vm.bill.frequency_type != 1\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"0\" ng-checked=\"vm.bill.end_of_recurrence == 0\">Parcelas com o mesmo valor de {{vm.bill.amount | currency}}</md-radio-button></div><div ng-if=\"vm.bill.frequency_type != 1\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"1\" ng-checked=\"vm.bill.end_of_recurrence == 1\">O valor pode variar a cada parcela</md-radio-button></div><div ng-if=\"vm.bill.end_of_recurrence == 0\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"2\" ng-checked=\"vm.bill.end_of_recurrence == 0\">Divide o valor do título de {{vm.bill.amount | currency}} nas parcelas</md-radio-button></div></md-radio-group></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><a4-table-installments ng-show=\"vm.bill.end_of_recurrence == 0\" frequency-qty=\"vm.bill.frequency_qty\" frequency=\"vm.bill.frequency\" current-item=\"vm.bill\" total-amount=\"vm.bill.amount\" quantity=\"vm.bill.quantity\" initial-qty=\"vm.bill.quantity\" list=\"vm.bill.payment_installments\" disabled=\"vm.bill.recurrency_on_value != 1\" is-recurrence=\"vm.bill.recurrency_on_value == 0\"></a4-table-installments></div><strong class=\"group-field md-block\" ng-if=\"vm.bill.recurrency_on_value == 0\"><small>{{\'Indices\' | translate }}</small></strong><div layout=\"row\" ng-if=\"vm.bill.recurrency_on_value == 0\"><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'Indice de correção\' | translate}}</label><md-select ng-model=\"vm.bill.index_id\" style=\"margin-top: 5px\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.indexCorrection\">{{ item.name | translate}}</md-option></md-select></md-input-container><date-picker ng-model=\"vm.bill.next_adjustment_date\" placeholder=\"{{ \'Próximo reajuste em\' | translate}}\"></date-picker></div><strong class=\"group-field md-block\" ng-if=\"vm.bill.was_paid != 1 && (vm.bill.edit_expense == 2 || angular.isUndefined(vm.bill.edit_expense) || vm.bill.edit_expense == null)\"><small>{{\'Regras\' | translate }} (Opcional)</small></strong><md-content ng-if=\"(angular.isUndefined(vm.bill.edit_expense) || vm.bill.edit_expense == 2 || vm.bill.edit_expense == null)\"><div layout=\"row\" ng-if=\"vm.bill.was_paid != 1\"><div flex=\"\"><select-rules list=\"vm.bill.discounts_rules\" templatename=\"discount\" title-first-field=\"Regra de Descontos\" allrules=\"includeScope.allDiscountRules\"></select-rules></div></div><div layout=\"row\" ng-if=\"vm.bill.was_paid != 1\"><md-input-container class=\"input-a4\" flex=\"\"><label>{{ \'Regra de Acréscimos\' | translate}}</label><md-select name=\"finesrule\" id=\"fines_rule_id\" ng-model=\"vm.bill.fines_rule_id\"><md-option ng-value=\"i.id\" ng-repeat=\"i in vm.allAdditionRules\">{{ i.name | translate}}</md-option></md-select></md-input-container></div></md-content></md-content></md-tab><md-tab label=\"DESCONTOS INDIVIDUAIS\" ng-disabled=\"vm.bill.was_paid != 2\" ng-if=\"vm.bill.was_paid == 2 && vm.bill.edit_expense == 2 || (angular.isDefined(vm.bill.edit_expense) || vm.bill.edit_expense == 0 || vm.bill.edit_expense == null)\"><md-content ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><md-table-container><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Razão</th><th md-column=\"\">Desconto</th><th md-column=\"\">F/C</th><th md-column=\"\">De</th><th md-column=\"\">Até</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.bill.individual_discounts\"><td md-cell=\"\">{{ item.discount_reason.name }}</td><td md-cell=\"\">{{ item.value_type == 1 ? \"% \" + item.amount : \"R$ \" + item.amount }}</td><td md-cell=\"\">{{ item.is_fixed ? \'F\' : \'C\' }}</td><td md-cell=\"\">{{ item.start_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\">{{ item.end_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeItemDesconto($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-button class=\"md-primary\" aria-label=\"Novo Desconto\" style=\"margin-left: 15px\" ng-click=\"vm.createNewIndivialDiscount()\">Adicionar desconto<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-content></md-tab></md-tabs></md-content></div><md-content class=\"md-padding\"><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.close();\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'BILL_RECEIPT.FORM_SUBMIT\' | translate }}\" ng-disabled=\"(formBill.$invalid || vm.bill.bill_details[0].bill_category_id == null || vm.bill.bill_details[0].amount == 0) || vm.show_progress\"><md-progress-circular style=\"float: left; top: 8px;color: white\" ng-show=\"vm.show_progress\" md-diameter=\"20px\"></md-progress-circular><span ng-show=\"vm.bill.id == null\" translate=\"BILL_RECEIPT.FORM_CREATE\"></span> <span ng-show=\"vm.bill.id != null\" translate=\"BILL_RECEIPT.FORM_EDIT\"></span></md-button></footer></md-content></form></div>");
$templateCache.put("app/finance/bill-reverse/views/form-reverse.html","<div layout=\"row\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\" md-theme=\"finance\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{ \'BILL_REVERSE.TITLE\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" translate=\"\" translate-attr-aria-label=\"BILL_PAYMENT.CLOSE_SIDENAV\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"content\"><div class=\"sidenav-form top-small\"><div layout=\"column\" layout-sm=\"column\" ng-if=\"vm.show_loader\" style=\"margin-top: 200px;\" layout-align=\"space-around\"><div style=\"margin-left: 295px\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div></div><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\" ng-if=\"!vm.show_loader\"><form name=\"formReverse\" ng-submit=\"vm.reversalConfimation($event)\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.bill.id\"><div id=\"bill-payment-toggle\" class=\"simple-table-container\"><md-list-item class=\"show-in-bg-white\" ng-click=\"vm.toggle.list = !vm.toggle.list\"><span flex=\"90\">Selecionados</span> <span flex=\"10\"><md-icon ng-show=\"!vm.toggle.list\">expand_more</md-icon><md-icon ng-show=\"vm.toggle.list\">expand_less</md-icon></span></md-list-item><div ng-show=\"vm.toggle.list\" class=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\" id=\"bill-negotiate-list\" md-table=\"\"><thead><tr><th>Vencimento</th><th>Pessoa</th><th>Descrição</th><th>Valor</th><th ng-if=\"vm.is_partial_payment\">Valor parcialmente pago</th><th ng-if=\"vm.billList.length > 1\">Remover</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-if=\"item\" class=\"{{ item.status_name }}\" ng-repeat=\"item in vm.action.billsSelected\"><td md-cell=\"\">{{item.date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\"><span class=\"td-first-line\">{{ item.person_name }}</span> <span class=\"td-second-line\">{{ item.beneficiary_name }}</span></td><td md-cell=\"\">{{item.description}}</td><td md-cell=\"\">{{item.amount | currency}}</td><td md-cell=\"\" ng-if=\"vm.is_partial_payment\">{{item.amount_paid | currency}}</td><td md-cell=\"\" ng-if=\"vm.billList.length > 1\"><md-button class=\"md-icon-button\" aria-label=\"Remover\" ng-click=\"vm.removeItem(item)\"><md-icon class=\"material-icons\">remove_circle</md-icon></md-button></td></tr></tbody></table></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\" ng-if=\"vm.hasBillDifference && !vm.hasBillDifferenceBlockAction\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\">Títulos posuem um título de diferença/crédito associado em aberto. <b>Ao desfazer a ação de pagamento, este título será excluído.</b></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\" ng-if=\"vm.hasBillDifference && vm.hasBillDifferenceBlockAction\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\">Títulos posuem um título de diferença/crédito associado resolvido. <b>Não é possível desfazer a ação de pagamento.</b></div></div><md-input-container class=\"md-input-has-placeholder\" flex=\"\" style=\"width: 100%;\"><label>Motivo do desfazer</label> <input ng-model=\"vm.notes\" type=\"text\"></md-input-container><a4-table-advanced templatename=\"payment_form\" list=\"vm.payments\" bill=\"vm.action.billsSelected\" type=\"vm.action.billsSelected[0].debit_credit\" totalcurrency=\"vm.totalAmount\" data-waspaid=\"0\" readonly=\"true\" block=\"true\"></a4-table-advanced><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" ng-disabled=\"vm.hasBillDifference && vm.hasBillDifferenceBlockAction\">Confirmar desfazer</md-button></footer></form></div></div></div></div>");
$templateCache.put("app/finance/cashier-management/view/configuration.html","<md-dialog aria-label=\"Configuração de caixa\" md-theme=\"finance\"><form name=\"cashier_config_form\" ng-cloak=\"\" ng-submit=\"vm.saveCompanyConfig(vm.cashier_configuration, cashier_config_form);\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Configuração de caixa</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 150px; min-width: 400px;\" layout=\"column\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 10px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Configuração de recibo de caixa</b> <small>Abaixo defina configurações de recibo de caixa</small></div></div><md-content layout=\"column\"><div style=\"margin-left: 20px\"><md-checkbox flex=\"100\" ng-model=\"vm.cashier_configuration.is_twofold_receipt\" aria-label=\"Impressão de recibo em duas vias\">Imprime recebido em duas vias?</md-checkbox></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" ng-disabled=\"vm.show_loader\" aria-label=\"{{ \'Salvar configurações\' | translate }}\"><md-progress-circular ng-if=\"vm.show_loader\" style=\"float: left; top: 8px;\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/cashier-management/view/index.html","<style>\n  .red-back {\n    background-color: #8b0011;\n    padding: 2px 5px;\n    color: #fff;\n    border-radius: 3px;\n  }\n\n  .green-back {\n    background-color: green;\n    padding: 2px 5px;\n    color: #fff;\n    border-radius: 3px;\n  }\n\n  .blue-back {\n    background-color: #004280;\n    padding: 2px 5px;\n    color: #fff;\n    border-radius: 3px;\n  }\n</style><div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cash-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"CASHIER_MANAGEMENT.NAME\"></span></div></div></md-toolbar><md-card layout-padding=\"\"><div layout=\"row\" layout-align=\"space-between\"><md-button ng-click=\"vm.openCashierConfiguration()\"><md-icon md-font-icon=\"icon-cog\"></md-icon>{{ \"CASHIER_MANAGEMENT.CONFIG\" | translate }}</md-button><md-table-pagination md-limit=\"vm.cashier_sessions.per_page\" md-limit-options=\"[50, 75, 100]\" style=\"border: none\" md-page=\"vm.cashier_sessions.current_page\" md-total=\"{{vm.cashier_sessions.total}}\" md-on-paginate=\"vm.getAllCashierSession\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data/Hora de abertura</th><th md-column=\"\">Data/Hora de encerramento</th><th md-column=\"\">Sessão</th><th md-column=\"\">Caixa</th><th md-column=\"\">Situação</th><th md-column=\"\">Usuário</th><th md-column=\"\" md-numeric=\"\">Valor Total Recebido</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.cashier_sessions.data\"><td md-cell=\"\">{{item.open_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{item.close_date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\">{{item.id}}</td><td md-cell=\"\">{{item.current_account_name}}</td><td md-cell=\"\"><span ng-class=\"{\'red-back\': item.status == \'Encerrada\', \'green-back\': item.status == \'Ativa\', \'blue-back\': item.status == \'Conferida\'}\">{{item.status}}</span> <span ng-if=\"item.reopening_log !== null\"><md-icon style=\"color: #b7af2d\">announcement</md-icon><md-tooltip><span ng-repeat=\"log in item.reopening_log\">Sessão reaberta em {{log.date}} pelo usuário {{log.person_name}} pela razão: {{log.reason}}<hr></span></md-tooltip></span></td><td md-cell=\"\">{{item.name}}</td><td md-cell=\"\" md-numeric=\"\">{{item.total_amount | currency:\' \'}}</td><td md-cell=\"\"><md-menu aria-label=\"menu\"><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event); $event.stopPropagation()\"><md-icon md-menu-origin=\"\">more_vert</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item policy-access=\"caixa_conf\"><md-button ng-disabled=\"item.status == \'Ativa\' || item.status == \'Conferida\'\" ng-click=\"vm.cashierSessionAction(item, \'verify\'); $event.stopPropagation()\"><md-icon>check</md-icon>Conferir Sessão de Caixa</md-button></md-menu-item><md-menu-item policy-access=\"reopen_cashier_session\"><md-button ng-disabled=\"item.status == \'Ativa\'\" ng-click=\"vm.cashierSessionAction(item, \'reopen\'); $event.stopPropagation()\"><md-icon>open_in_new</md-icon>Reabrir Sessão de Caixa</md-button></md-menu-item><md-menu-item policy-access=\"caixa_alt\"><md-button ng-disabled=\"item.status !== \'Ativa\' || item.reopening_log === null\" ng-click=\"vm.cashierSessionAction(item, \'close\'); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>Encerrar Sessão de Caixa</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.cashierSessionAction(item, \'report\'); $event.stopPropagation()\"><md-icon>description</md-icon>Relatório da sessão de caixa</md-button></md-menu-item><md-menu-item policy-access=\"mov_retroativo\"><md-button ng-disabled=\"item.status == \'Ativa\'\" ng-click=\"vm.cashierSessionAction(item, \'input\'); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon>Entrada retroativa</md-button></md-menu-item><md-menu-item policy-access=\"mov_retroativo\"><md-button ng-disabled=\"item.status == \'Ativa\'\" ng-click=\"vm.cashierSessionAction(item, \'output\'); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-arrow-up\"></md-icon>Saída retroativa</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item policy-access=\"delete_session\"><md-button ng-click=\"vm.delete(item.id); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-trash\"></md-icon>Excluir</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-card></div>");
$templateCache.put("app/finance/cashier-session/view/cashier-session-print.html","<md-dialog aria-label=\"Mango (Fruit)\" md-theme=\"finance\" style=\"width: 800px\"><form ng-cloak=\"\" ng-submit=\"vm.transferTo(vm.transfer)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Recibo de pagamento</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\" ng-if=\"vm.is_guest_check_pad\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Pagamento da comanda realizado com sucesso</b> <small>Abaixo você pode realizar a impressão em PDF ou no formato adequado para a impressora não-fiscal</small></div></div><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\" ng-if=\"!vm.disable_buttons\"><a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.downloadFile(0)\" target=\"_blank\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><div>Imprimir recibo em PDF</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.downloadFile(1)\" target=\"_blank\"><md-icon md-font-icon=\"icon-printer\"></md-icon><div>Imprimir recibo na impressora não-fiscal</div></a></md-card></md-dialog-content></form></md-dialog>");
$templateCache.put("app/finance/cashier-session/view/cashier-session-report.html","<md-dialog aria-label=\"Mango (Fruit)\" md-theme=\"finance\" style=\"width: 800px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Movimentação da sessão de caixa</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr><th md-column=\"\">Data</th><th md-column=\"\">Tipo</th><th md-column=\"\">Descrição</th><th md-column=\"\" md-numeric=\"\">Entrada/Saida (R$)</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"record in vm.records\"><td md-cell=\"\">{{record.date | date:\'dd/MM/yyyy H:mm:ss\'}}</td><td md-cell=\"\">{{record.movement_type_name}}</td><td md-cell=\"\">{{record.notes}}</td><td md-cell=\"\" md-numeric=\"\" ng-if=\"record.debit_credit == \'C\'\">{{record.amount | currency:\' \'}}</td><td md-cell=\"\" md-numeric=\"\" style=\"color: red\" ng-if=\"record.debit_credit == \'D\'\">{{record.amount|currency:\' \'}}</td><td md-cell=\"\"><span ng-if=\"record.movement_type_name == \'Entrada/Saída de sessão de caixa\'\"><md-button class=\"md-icon-button\" ng-click=\"vm.printSingleMovement(record)\" ng-if=\"!vm.show_loading\"><md-icon md-font-icon=\"icon-printer\"><md-tooltip md-direction=\"right\">Imprimir recibo de entrada/saída</md-tooltip></md-icon></md-button><md-progress-circular ng-if=\"vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular></span> <span ng-if=\"record.movement_type_name == \'Entrada/Saída de sessão de caixa\'\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSingleMovement(record)\" ng-if=\"!vm.show_loading\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip md-direction=\"right\">Excluir entrada/saída</md-tooltip></md-icon></md-button></span></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\" md-numeric=\"\"><b>Total:</b></td><td md-cell=\"\" md-numeric=\"\"><b>{{vm.getTotal() | currency:\' \'}}</b></td><td></td></tr><tr md-row=\"\" ng-if=\"vm.records.length == 0\"><td md-cell=\"\"></td><td md-cell=\"\">Sem movimentações nesta sessão</td><td md-cell=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-numeric=\"\"></td><td></td></tr><tr md-row=\"\" ng-if=\"vm.records.length !== 0\"><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\" style=\"margin: 0; padding: 0;\"><md-button ng-click=\"vm.printCashierSession()\"><md-icon>print</md-icon></md-button></td><td></td></tr></tbody></table></md-table-container></md-dialog-content></form></md-dialog>");
$templateCache.put("app/finance/cashier-session/view/cashier-session-transfer.html","<md-dialog aria-label=\"Mango (Fruit)\" md-theme=\"finance\" style=\"width: 800px\"><form ng-cloak=\"\" ng-submit=\"vm.transferTo(vm.transfer)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Transferência entre sessões</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container flex=\"\"><md-icon md-font-icon=\"icon-repeat\"></md-icon><md-select placeholder=\"Transferir para\" ng-model=\"vm.transfer.to\" md-on-open=\"vm.getSessions()\" required=\"\"><md-option ng-value=\"session.id\" ng-repeat=\"session in vm.sessions\">{{session.person_name}} [{{session.id}}]</md-option></md-select></md-input-container><div layout=\"row\"><md-input-container flex=\"30\" class=\"md-input-has-placeholder\"><label>Valor</label><md-icon md-font-icon=\"icon-currency-usd\"></md-icon><input ng-model=\"vm.transfer.amount\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\" required=\"\"></md-input-container><md-input-container flex=\"70\" class=\"md-input-has-placeholder\"><label>Motivo</label><md-icon md-font-icon=\"icon-message-text-outline\"></md-icon><input ng-model=\"vm.transfer.notes\" required=\"\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-primary md-raised\" type=\"submit\" ng-disabled=\"form.$invalid\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/cashier-session/view/confirmTransaction.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\"><form name=\"form\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Informar valor e motivo para {{vm.scope.debit_credit == \'C\' ? \'entrada\' : \'saída\'}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 150px; min-width: 650px;\" layout=\"column\"><form novalidate=\"\" name=\"formPerson\"><div layout=\"row\"><date-picker ng-model=\"vm.scope.date\" placeholder=\"Data\" flex=\"30\" disabled=\"vm.disable_mov_retroativo\" max-date=\"vm.scope.max_date\" min-date=\"vm.scope.min_date\"></date-picker><md-input-container flex=\"30\" class=\"md-input-has-placeholder\"><label>Valor</label><md-icon md-font-icon=\"icon-currency-usd\"></md-icon><input ng-model=\"vm.scope.amount\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" autocomplete=\"off\" required=\"\"></md-input-container><md-input-container flex=\"40\" class=\"md-input-has-placeholder\"><label>Motivo</label><md-icon md-font-icon=\"icon-message-text-outline\"></md-icon><input ng-model=\"vm.scope.notes\" required=\"\"></md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-disabled=\"form.$invalid\" ng-click=\"vm.answer(vm.scope)\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/cashier-session/view/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-view-carousel\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"CASHIER_SESSION.CASHIER\"></span></div><div layout-align=\"end end\"><md-button flex=\"\" type=\"button\" ng-click=\"vm.closeSession()\" ng-if=\"vm.session_opened\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>{{ \'CASHIER_SESSION.CLOSE\' | translate }}</md-button></div></div></md-toolbar><md-card class=\"content\" layout=\"column\" style=\"width: 600px; margin: 18px auto; padding: 0;\" ng-if=\"!vm.session_opened && vm.show_guest_pad_cashier_session && (!vm.checkPolicies(\'adicionar_titulos_comanda\') || !vm.checkPolicies(\'resgatar_cheques\') || !vm.checkPolicies(\'adicionar_produtos_comanda\'))\"><md-subheader ng-if=\"!vm.session_opened\"><md-icon md-font-icon=\"icon-login\"></md-icon>Iniciar uma sessão de caixa:</md-subheader><form novalidate=\"\" name=\"sessionform\" ng-submit=\"vm.openSession(vm.cashier_session, sessionform)\" layout-padding=\"\"><div layout=\"column\"><md-button flex=\"\" type=\"submit\" class=\"md-raised\" style=\"background-color: rgb(8,204,117); color: #fff;\" ng-if=\"!vm.session_opened\">{{ \'CASHIER_SESSION.OPEN\' | translate }}</md-button></div></form></md-card><div class=\"content\" layout=\"column\" ng-if=\"vm.session_opened && (!vm.checkPolicies(\'adicionar_titulos_comanda\') || !vm.checkPolicies(\'resgatar_cheques\') || !vm.checkPolicies(\'adicionar_produtos_comanda\'))\"><md-content layout=\"row\" layout-align=\"center center\" layout-wrap=\"\" style=\"background-color: whitesmoke !important;\"><md-card layout=\"column\" class=\"btn-check\" style=\"padding: 0;height: 180px;\" layout-align=\"center\" ng-repeat=\"operation in vm.operations\" flex=\"{{operation.flex}}\" ng-click=\"vm.executeAction(operation.action)\"><a class=\"text-center md-ink-ripple\"><br><md-icon class=\"font-size-54\" md-font-icon=\"{{operation.icon}}\"></md-icon><div class=\"font-size-18\">{{operation.title}}</div></a></md-card></md-content></div></div>");
$templateCache.put("app/finance/cashier-session/view/searchClient.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\"><form name=\"form\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Selecionar cliente</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 150px; min-width: 650px;\" layout=\"column\"><form novalidate=\"\" name=\"formPerson\"><md-input-container flex=\"30\"><md-autocomplete flex=\"\" required=\"\" md-input-minlength=\"3\" md-input-maxlength=\"150\" md-input-name=\"persons_selected\" md-selected-item=\"vm.selectedPerson\" md-no-cache=\"true\" md-delay=\"500\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"3\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"{{ \'GUEST_CHECK_PAD.SELECT_PERSON\' | translate }}\"><md-item-template><span class=\"item-title\"><md-icon md-font-icon=\"icon-city\"></md-icon><span md-highlight-text=\"vm.searchText\">{{item.name}} - {{item.national_id_number}}</span> <span class=\"badge person_badge\" style=\"background-color: #0c856f;\" ng-if=\"item.is_employee === 1 || item.roles_id !== null\">Colaborador</span> <span class=\"badge person_badge\" style=\"background-color: #bead33;\" ng-if=\"item.is_supplier === 1\">Fornecedor</span> <span class=\"badge person_badge\" style=\"background-color: #0c856f;\" ng-if=\"item.is_employee === -1\">Ex-colaborador</span> <span class=\"badge person_badge\" style=\"background-color: #607abf;\" ng-if=\"item.is_student !== null && item.enrolment_status_id !== 1 && item.last_student !== 0\">Aluno <b ng-if=\"item.last_student !== null && item.last_student != vm.current_school_period\">em {{item.last_student}}</b></span> <span class=\"badge person_badge\" style=\"background-color: #667474;\" ng-if=\"item.is_student !== null && item.enrolment_status_id == 1 && item.last_student !== 0\">Pendente <b ng-if=\"item.last_student !== null && item.last_student != vm.current_school_period\">em {{item.last_student}}</b></span> <span class=\"badge person_badge\" style=\"background-color: #607abf;\" ng-if=\"item.is_student !== null && item.last_student == 0\">Em período letivo avulso</span> <span class=\"badge person_badge\" style=\"background-color: #bf391a;\" ng-if=\"item.is_employee === 2 || item.is_employee === 3\">Professor</span> <span class=\"badge person_badge\" style=\"background-color: #bf391a;\" ng-if=\"item.is_employee === -2 || item.is_employee === -3\">Ex-professor</span> <span class=\"badge person_badge\" style=\"background-color: #29a456;\" ng-if=\"item.is_responsible === 1 || item.is_payee === 1\">Responsável <b ng-if=\"(item.last_payee !== null && item.last_payee != vm.current_school_period) || (item.last_responsible !== null && item.last_responsible != vm.current_school_period)\">em {{item.last_responsible !== null ? item.last_responsible : item.last_payee}}</b></span></span> <span class=\"item-metadata\"><span><strong md-highlight-text=\"vm.searchText\">{{item.corporate_name}}</strong></span></span></md-item-template><div ng-messages=\"formPerson.persons_selected.$error\"><div ng-message=\"md-require-match\">Digite um clienete existente.</div><div ng-message=\"minlength\">Entre com no minimo 3 letras.</div><div ng-message=\"maxlength\">Minimo 50 letras.</div></div></md-autocomplete></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Voltar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-disabled=\"form.$invalid\" ng-click=\"vm.submit(vm.selectedPerson);\">Iniciar Comanda</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/bordero/bordero.html","<md-tab label=\"Lotes\" ng-disabled=\"vm.checkBatch.data.length == 0\" md-on-select=\"vm.getBatch()\"><md-content class=\"md-padding\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Operação</th><th md-column=\"\">Quantidade de cheques</th><th md-column=\"\">Valor</th><th md-column=\"\">Status</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.checkBatch.data\"><td md-cell=\"\">{{vm.getDate(item.date)}}</td><td md-cell=\"\">{{item.action_name}}</td><td md-cell=\"\">{{item.checks.length}}</td><td md-cell=\"\">{{item.totalAmount | currency}}</td><td md-cell=\"\">{{vm.checkStatus(item.is_done)}}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.confirmBordero(item)\" ng-if=\"!item.is_done\"><md-tooltip md-direction=\"top\">Confirmar</md-tooltip><md-icon>done_all</md-icon></md-button><md-button target=\"_blank\" class=\"md-icon-button\" href=\"http://api.a4net.com.br/api/bordero/report/{{item.id}}?token={{item.token}}&company={{item.company}}&connection={{item.alias}}\"><md-tooltip md-direction=\"top\">Relatório em PDF</md-tooltip><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.deleteBordero(item.id)\" ng-if=\"!item.is_done\"><md-tooltip md-direction=\"top\">Excluir</md-tooltip><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.checkBatch.per_page\" md-limit-options=\"[15]\" md-page=\"vm.checkBatch.current_page\" md-total=\"{{vm.checkBatch.total}}\" md-on-paginate=\"vm.getAllInvoices\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></md-content></md-tab>");
$templateCache.put("app/finance/check-received/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-check\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{\'CHECK-RECEIVED.TITLE\' | translate}}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\"></md-input-container></div></md-toolbar><md-card layout=\"row\"><div class=\"md-padding\" layout=\"row\" flex=\"\" flex-sm=\"50\" flex-md=\"50\" flex-xs=\"100\"><md-input-container flex=\"\"><select-dropdown title=\"Filtro por status\" selected-items=\"vm.selected_status\" ng-model=\"vm.status\"></select-dropdown></md-input-container><md-input-container flex=\"\"><select-dropdown title=\"Filtro por conta\" selected-items=\"vm.selected_account\" ng-model=\"vm.accounts\"></select-dropdown></md-input-container><div flex=\"\" flex-sm=\"50\" flex-md=\"50\" flex-xs=\"100\"><date-range-picker ng-model=\"vm.filter_date\" label=\"Datas\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></div></div></md-card><md-card layout=\"row\" policy-access=\"cheq_alt\"><a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.accountDeposite()\"><md-icon>attach_money</md-icon><div>Deposito em conta</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.sendToBank()\"><md-icon md-font-icon=\"icon-bank\"></md-icon><div>Custódia</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.bankDiscount()\"><md-icon md-font-icon=\"icon-chevron-double-down\"></md-icon><div>Descontar</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.checkTransfer()\"><md-icon md-font-icon=\"icon-transfer\"></md-icon><div>Transferência</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.withdrawCheck()\"><md-icon md-font-icon=\"icon-cash\"></md-icon><div style=\"\">Saque</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.bankDevolution()\"><md-icon md-font-icon=\"icon-backup-restore\"></md-icon><div style=\"\">Devolução Bancária</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" ng-click=\"vm.retrieveCheck()\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><div style=\"\">Extravio</div></a></md-card><md-card><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Cheques\" md-on-select=\"vm.init()\"><md-content class=\"md-padding\"><a4-table-check items=\"vm.checks\" add-check-description=\"vm.addCheckDescription(id)\" change-due-date=\"vm.changeCheckDueDate(id)\" get-operation-origin=\"vm.getCheckOperationOrigin(id)\" include-scope=\"vm.includeScope\" selected=\"vm.check_selected\" with-list-check-box=\"false\" sidebar-template=\"app/finance/check-received/views/sidenavs/sidenav.html\"></a4-table-check></md-content></md-tab><div ui-view=\"bordero\"></div></md-tabs></md-content></md-card></div>");
$templateCache.put("app/finance/communication/views/communication.html","<div ui-view=\"communication\"></div>");
$templateCache.put("app/finance/communication/views/create-edit.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ui-sref=\"private.finance.communication.list\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-message-text\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" ng-if=\"!vm.form.document.id\">Criar novo comunicado</span> <span class=\"logo-text\" ng-if=\"vm.form.document.id\">Edição de comunicado</span></div></div><md-checkbox ng-change=\"$root.$broadcast(\'CHANGE_IS_DETAILED\', vm.is_detailed)\" ng-model=\"vm.is_wysiwyg\" aria-label=\"Editor avançado\">Mostrar editor avançado</md-checkbox></md-toolbar><md-content style=\"background-color: whitesmoke !important;width: 80%; margin: 5px auto\"><md-card class=\"md-padding\" style=\"min-height: 500px;\"><form name=\"formInformativeReport\" ng-submit=\"vm.submit(formInformativeReport, vm.form.document)\" novalidate=\"\"><div layout=\"row\" ng-if=\"!vm.is_wysiwyg\"><div flex=\"60\"><strong class=\"group-field\"><small>Editor de conteúdo:</small></strong><div layout=\"row\" style=\"margin-top: 15px\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"title\" ng-model=\"vm.form.document.title\" placeholder=\"Título\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><textarea name=\"content\" placeholder=\"Conteúdo\" ng-model=\"vm.form.document.content\" rows=\"6\"></textarea></md-input-container></div></div><div flex=\"40\"><strong class=\"group-field\"><small>Imagem de destaque:</small></strong><figure class=\"figure-informative\" ng-if=\"vm.form.document.id\" ng-show=\"vm.form.document.file_reference\"><img ng-src=\"{{vm.url}}{{vm.form.document.file_reference}}\" alt=\"{{vm.form.document.title}}\"></figure><div class=\"dropzone-container\" layout=\"row\"><div class=\"dropzone md-block\" ng-dropzone=\"\" options=\"vm.dzOptions\" callbacks=\"vm.dzCallbacks\" methods=\"vm.dzMethods\"></div></div></div></div><md-card-content layout=\"column\" ng-if=\"vm.is_wysiwyg\" flex=\"\"><div flex=\"\"><div layout=\"row\"><md-input-container flex=\"\" style=\"margin-top: 25px\" class=\"md-input-has-placeholder\" ng-disabled=\"vm.form.document.type === \'4\'\"><input type=\"text\" name=\"title\" ng-model=\"vm.form.document.title\" placeholder=\"Título\"></md-input-container></div><textarea class=\"text_area\" id=\"html_editor\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.form.document.content\" ng-change=\"vm.changeHandler()\"></textarea><div flex=\"\"><div layout=\"row\" layout-align=\"space-between center\"><div><label>Recursos disponíveis:</label><md-input-container flex=\"100\"><md-select name=\"variables\" ng-model=\"variableSelected\" ng-change=\"vm.setVariable(variableSelected)\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.variables\">{{item.presentation}}</md-option></md-select></md-input-container></div><div><md-input-container><md-checkbox ng-model=\"vm.form.document.print_logo\">Imprime com a logomarca</md-checkbox></md-input-container></div></div></div></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-primary\">Salvar</md-button></md-card-actions></form></md-card></md-content></div>");
$templateCache.put("app/finance/communication/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-gmail\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Comunicação</span></div></div></md-toolbar><md-content style=\"background-color: whitesmoke !important\"><a4-grid-dic-data style=\"width: 100%;\" bind=\"vm.grid\" on-click-actions=\"vm.clickActions(item, option)\" on-paginate=\"vm.paginate\" on-click-item=\"vm.editDocument(item)\" on-delete=\"vm.delete(index)\" fields-schema=\"app/finance/communication/grid.json\"></a4-grid-dic-data></md-content></div>");
$templateCache.put("app/finance/communication/views/modal-individual-send.html","<md-dialog aria-label=\"Criar documentos\" md-theme=\"finance\" style=\"min-width: 550px;\"><form ng-cloak=\"\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Enviar mensagem</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 10px\"><md-dialog-content layout=\"column\"><md-autocomplete flex=\"100\" ng-required=\"vm.selected_tab == 1\" style=\"margin-top: 20px; margin-left: 8px; margin-right: 8px;\" md-no-cache=\"true\" md-selected-item=\"vm.filter.selectedPerson\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPersons(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-input-minlength=\"3\" md-min-length=\"0\" md-floating-label=\"Selecione uma pessoa\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Responsável financeiro não encontrado</md-not-found></md-autocomplete></md-dialog-content></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_circular_loader\">Cancelar</md-button><md-button type=\"submit\" ng-click=\"vm.submit(\'print\')\" ng-disabled=\"vm.filter.selectedPerson === null\" class=\"md-raised md-primary\"><md-icon class=\"material-icons\">print</md-icon>Imprimir</md-button><md-button type=\"submit\" ng-click=\"vm.submit(\'send\')\" ng-disabled=\"vm.filter.selectedPerson === null\" class=\"md-raised md-primary\"><md-icon class=\"material-icons\">email</md-icon>Enviar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/communication/views/modal-send-email.html","<md-dialog aria-label=\"Criar Mensagem para turma\" md-theme=\"finance\" style=\"min-width: 560px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Envio de e-mail para responsáveis financeiros</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div style=\"padding: 10px; margin: 10px;\"><h3>Este documento será enviado por e-mail para os responsáveis financeiros do sistema com títulos que vencem no presente mês.</h3><h3>Responsáveis sem e-mail não receberão o documento.</h3><h3>Total de destinatários: {{vm.scope.persons_total}}</h3><h3>Destinatários com e-mail: {{vm.scope.persons_with_email}}</h3><h3>Destinatários sem e-mail: {{vm.scope.persons_without_email}}</h3><h3>Destinatários que já receberam o e-mail: {{vm.scope.persons_email_sent}}</h3></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised\" ng-disabled=\"vm.disabled\" ng-click=\"vm.answer(\'send_all\')\"><md-icon class=\"material-icons\">email</md-icon>Enviar e-mails para todos</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.disabled\" ng-click=\"vm.answer(\'report\')\"><md-icon class=\"material-icons\">print</md-icon>Imprimir relatório de destinatórios</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.disabled\" ng-click=\"vm.answer(\'send_not_sent\')\"><md-icon class=\"material-icons\">email</md-icon>Enviar e-mails para os que não receberam</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/finance/contract/views/index.html","<div id=\"page-material-table\" class=\"bill-receipt page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke !important;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cash-usd\" class=\"s24\"></md-icon></span> <span class=\"logo-text md-primary md-hue-1\">{{\'CONTRACT.TITLE\' | translate}}</span></div></div></md-toolbar><span layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.openCreateModal()\" class=\"md-primary\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Novo contrato</md-button></span><a4-contract-grid ng-model=\"vm.allContracts\" paginate-function=\"vm.getAllContracts(page, qtd, search_name)\" debit-credit=\"C\"></a4-contract-grid></div>");
$templateCache.put("app/finance/correction-index/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cube\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{\'Indices de correção\' | translate}}</span></div></div><md-button class=\"md-raised md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.indexCreate($event, \'sidenav-form\')\" aria-label=\"add\" translate=\"\"><md-icon md-font-icon=\"icon-receipt\" style=\"color: green\"></md-icon></md-button></md-toolbar><a4-table items=\"vm.allRoles\" filter=\"[\'name\']\" with-list-check-box=\"false\" on-delete=\"vm.delete(index)\" on-submit=\"vm.submit(form, data)\" include-scope=\"vm.includeScope\" sidebar-template=\"app/finance/correction-index/views/show.html\"></a4-table></div>");
$templateCache.put("app/finance/correction-index/views/show.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-hide=\"includeScope.formCreate\">Alterar Indice de Correção</span><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'sidenav-form\')\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content class=\"form-wrapper\"><div layout=\"row\"><md-input-container flex=\"90\"><label>Nome do indice</label> <input type=\"text\" ng-disabled=\"true\" placeholder=\"Nome\" ng-model=\"vm.currentItem.name\"></md-input-container><md-input-container flex=\"10\"><md-button class=\"md-icon-print md-icon-button\" ng-click=\"includeScope.indexEdit(vm.currentItem)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></md-input-container></div><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><span class=\"title\">Indices mês a mês</span><md-button class=\"md-icon-button\" ng-click=\"includeScope.addDetails(vm.currentItem.id, includeScope.roles.detail)\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></md-toolbar><table class=\"md-api-table\"><thead><tr><th>Mês</th><th>Ano</th><th>Valor</th><th>Ações</th></tr></thead><tbody><tr ng-repeat=\"item in includeScope.roles.detail\"><td>{{ item.month.name }}</td><td>{{ item.year }}</td><td>{{ item.percent }}%</td><td class=\"th-center\"><md-button class=\"md-icon-print md-icon-button\" ng-click=\"includeScope.editDetail(item.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></md-content></div>");
$templateCache.put("app/finance/credits/views/index.html","<div id=\"page-material-table\" class=\"bill-receipt page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke !important;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-poll\" class=\"s24\"></md-icon></span> <span class=\"logo-text md-primary md-hue-1\">Créditos</span></div></div></md-toolbar><md-card class=\"md-padding\" flex=\"\"><md-input-container style=\"padding: 0 !important;\"><md-checkbox ng-model=\"vm.show_inactives\" ng-change=\"vm.paginate(1, 20)\">Mostrar créditos que já foram zerados</md-checkbox></md-input-container><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 30, 50]\" md-page=\"vm.grid.current_page\" flex=\"\" style=\"border: none\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.paginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\" style=\"text-align: right\">Saldo</th><th md-column=\"\">Último movimento</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.grid.data\" ng-click=\"vm.showMovements(item)\" style=\"cursor: pointer\"><td md-cell=\"\">{{item.person_name}}</td><td md-cell=\"\" style=\"text-align: right\">{{item.balance | currency: \"\"}}</td><td md-cell=\"\">{{item.date | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></md-table-container></md-card></div>");
$templateCache.put("app/finance/credits/views/modal.html","<md-dialog aria-label=\"Histório de movimentações de crédito\" md-theme=\"finance\" style=\"min-width: 700px\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">Movimentações de crédito de {{vm.scope.person_name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><a4-credits-person person-id=\"vm.scope.person_id\"></a4-credits-person></md-dialog-content></md-dialog>");
$templateCache.put("app/finance/current-account/views/current-account-details.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background: whitesmoke;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div class=\"header md-accent-bg layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.current-account\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div></div><div class=\"data\" flex=\"\"><h3>Extrato: {{vm.selected_account.name}}</h3></div><div flex=\"\" flex-sm=\"70\" flex-md=\"70\" flex-xs=\"100\"><date-range-picker ng-model=\"vm.filter_date\" label=\"Datas\" ng-change=\"vm.getAllMovements(vm.current_account_id, vm.filter_date.startDate, vm.filter_date.endDate);\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></div><div><md-button class=\"md-icon-button\" aria-label=\"Imprimir\" ng-click=\"vm.printMovementAccount()\" style=\"text-align: right;\"><md-tooltip md-direction=\"top\">Imprimir extrato</md-tooltip><md-icon ng-class=\"{\'print-and-slip\': vm.selected_bank_slip.length > 1}\" md-font-icon=\"icon-printer\"></md-icon></md-button></div></div></md-toolbar><div layout=\"row\"><div layout=\"column\" flex=\"\" ng-if=\"vm.selected_account.current_account_type_id !== vm.current_account_types.CONTA_A4PAG\"><div flex=\"\"><md-card flex=\"\" id=\"detailed_balance_title\" ng-click=\"vm.toggle(\'#detailed_balance\'); icon = !icon\" style=\"cursor: pointer;padding-bottom: 0\"><md-card-content layout=\"row\" style=\"padding-top: 2px; padding-bottom: 2px\"><div flex=\"5\" style=\"padding-top: 8px; padding-bottom: 8px\"><md-icon ng-show=\"!icon\" md-font-icon=\"icon-arrow-down\"></md-icon><md-icon ng-show=\"icon\" md-font-icon=\"icon-arrow-up\"></md-icon></div><div flex=\"\" style=\"color: #000;font-size: 18px;padding:5px;margin-top: 5px\">Saldo Detalhado</div></md-card-content></md-card><md-card id=\"detailed_balance\" flex=\"\" style=\"margin-top: 0;margin-bottom: 0;display: none\"><md-card-content style=\"min-height: 431px;\"><div layout=\"row\"><div flex=\"\"><div ng-include=\"\'app/finance/current-account/views/dialogs/account_balance.html\'\"></div></div></div></md-card-content></md-card></div></div><div layout=\"column\" flex=\"\"><div flex=\"\"><md-card id=\"chart_title\" flex=\"\" style=\"cursor: pointer;padding-bottom: 0\" ng-click=\"vm.toggle(\'#chart\'); icon2 = !icon2\"><md-card-content layout=\"row\" style=\"padding-top: 2px; padding-bottom: 2px\"><div flex=\"5\" style=\"padding-top: 8px; padding-bottom: 8px\"><md-icon ng-show=\"!icon2\" md-font-icon=\"icon-arrow-down\"></md-icon><md-icon ng-show=\"icon2\" md-font-icon=\"icon-arrow-up\"></md-icon></div><div flex=\"\" style=\"color: #000;font-size: 18px;padding:5px;margin-top: 5px\">Evolução do Saldo</div></md-card-content></md-card><md-card flex=\"\" id=\"chart\" style=\"margin-top: 0;margin-bottom: 0;display: none\"><md-card-content><div layout=\"row\"><a4-charts flex=\"\" filter-date=\"vm.filter_date\" selected-account=\"vm.selected_account\" all-movements=\"vm.all_movements\"></a4-charts></div></md-card-content></md-card></div></div></div><div layout=\"row\" flex=\"\" policy-access=\"conta_extr_mov\" ng-if=\"vm.show_buttons\"><md-card layout=\"row\" style=\"padding: 0;\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check md-ink-ripple\" style=\"padding: 5px 0;\" ng-click=\"vm.createPayment(vm.selected_account)\"><md-icon>remove_circle</md-icon><div>Saída de conta</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" style=\"padding: 5px 0;\" ng-click=\"vm.createReceipt(vm.selected_account)\"><md-icon>add_circle</md-icon><div>Entrada em conta</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" style=\"padding: 5px 0;\" ng-if=\"vm.selected_account.current_account_type_id !== 4 && vm.selected_account.current_account_type_id !== 5 && vm.selected_account.current_account_type_id !== 6 && vm.selected_account.current_account_type_id !== 7\" ng-click=\"vm.createTransference(vm.selected_account)\"><md-icon>swap_horiz</md-icon><div>Nova Transferência</div></a> <a flex=\"\" class=\"text-center btn-check md-ink-ripple\" style=\"padding: 5px 0;\" ng-click=\"vm.compensationCredit(vm.selected_account)\"><md-icon>play_for_work</md-icon><div>Crédito de compensação</div></a></md-card></div><div layout-gt-lg=\"row\" layout-lg=\"column\"><div class=\"extract\" id=\"extract\" flex=\"\"><div><md-card class=\"md-padding\"><md-table-container class=\"table-float-button\"><table md-table=\"\" class=\"md-api-table\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.all_movements.movements.order\" md-on-reorder=\"vm.reorder\"><tr style=\"height: 50px;\" md-row=\"\"><th style=\"width: 50px\" md-column=\"\" md-order-by=\"date\">Data</th><th class=\"hide-data\" style=\"width: 250px\">Pessoa</th><th class=\"hide-data\" style=\"width: 210px\">Descrição</th><th class=\"text-right\" style=\"width: 120px\">Entrada/Saida (R$)</th><th class=\"text-right hide-data\" style=\"width: 120px\">Saldo (R$)</th><th ng-if=\"vm.showReconcileMovement\" class=\"text-right\" style=\"width: 50px\" policy-access=\"conta_extr_mov\">Conciliação</th><th style=\"width: 30px\"></th></tr></thead><tbody><tr><td></td><td></td><td style=\"padding: 10px 0 10px 0\"><strong>Saldo Anterior</strong></td><td class=\"text-right hide-data\"></td><td class=\"text-right hide-data\" ng-class=\"{\'negativeValue\' : vm.all_movements.last_balance < 0}\">{{vm.applyMask(vm.all_movements.last_balance)}}</td><td></td><td policy-access=\"conta_extr_mov\"></td></tr><tr ng-repeat=\"movement in vm.all_movements.movements\"><td class=\"{{vm.all_movements.movements[$index-1].date!== movement.date ? \'hide-data td-date\' : \'hide-data\' }}\">{{vm.all_movements.movements[$index - 1].date !== movement.date ? movement.date : \'\' | date:\'dd/MM/yyyy\'}}</td><td class=\"{{vm.all_movements.movements[$index-1].date!== movement.date ? \'hide-data td-date\' : \'hide-data\' }}\">{{vm.selected_account.current_account_type_id === 8 ? \'A4Pag\' : (movement.person_name)}}</td><td class=\"{{vm.all_movements.movements[$index-1].date!== movement.date ? \'hide-data td-date\' : \'hide-data\' }}\"><span ng-if=\"movement.description != \'\'\" ng-bind-html=\"vm.formatDescription(movement.description)\"></span> <span ng-if=\"movement.transf_account == null && (movement.description == \'\' && movement.notes == \'\') && movement.movement_type_id != 102\">{{\'NO_DESCRIPTION\' | translate}}</span> <span ng-if=\"movement.transf_account == null && (movement.description == \'\') && movement.movement_type_id == 102\">{{\'CHECK_COMPENSATION\' | translate}}</span> <span ng-if=\"(movement.movement_type_id == 2|| movement.movement_type_id == 5 || movement.movement_type_id == 20 || movement.movement_type_id == 21)\"></span> <span ng-if=\"(movement.movement_type_id == 98 || movement.description == null)\">{{movement.notes}}</span></td><td class=\"{{vm.all_movements.movements[$index-1].date !== movement.date ? \'text-right positiveValue td-date\' : \'text-right positiveValue\' }}\" ng-if=\"movement.debit_credit == \'C\'\">{{vm.applyMask(movement.amount, movement.debit_credit)}}<md-button class=\"md-icon-button\" aria-label=\"Anexos\" ng-click=\"vm.addFile(movement)\"><md-icon style=\"color:{{movement.artifacts_qtd > 0 ? \'#0288D1\' : \'rgb(204, 204, 204)\'}}\">attach_file</md-icon><md-tooltip md-direction=\"top\">Anexos</md-tooltip></md-button></td><td class=\"{{vm.all_movements.movements[$index-1].date!== movement.date ? \'text-right negativeValue td-date\' : \'text-right negativeValue\' }}\" ng-if=\"movement.debit_credit == \'D\'\">{{vm.applyMask(movement.amount, movement.debit_credit)}}<md-button class=\"md-icon-button\" aria-label=\"Anexos\" ng-click=\"vm.addFile(movement)\"><md-icon style=\"color:{{movement.artifacts_qtd > 0 ? \'#0288D1\' : \'rgb(204, 204, 204)\'}}\">attach_file</md-icon><md-tooltip md-direction=\"top\">Anexos</md-tooltip></md-button></td><td ng-class=\"{\'negativeValue\' : movement.saldo < 0}\" class=\"{{vm.all_movements.movements[$index-1].date!== movement.date ? \'text-right hide-data td-date\' : \'text-right hide-data\' }}\">{{vm.all_movements.movements[$index + 1].date != movement.date ? vm.applyMask(movement.saldo) : \'\'}}</td><td ng-if=\"vm.showReconcileMovement\" policy-access=\"conta_extr_mov\" class=\"{{vm.all_movements.movements[$index-1].date!== movement.date ? \'text-right td-date\' : \'text-right\' }}\"><div class=\"is_conciliated_hover\" ng-init=\"mouse_hover = false\"><md-button ng-class=\"mouse_hover ? \'md-icon-button\' : \'md-icon-button\'\" aria-label=\"Conciliar\" ng-click=\"vm.reconcileMovement($event, movement);\" ng-show=\"!movement.is_conciliated\" ng-mouseover=\"mouse_hover = true\" ng-mouseleave=\"mouse_hover = false\"><div><md-tooltip md-direction=\"left\">Conciliar</md-tooltip><md-icon ng-class=\"mouse_hover ? \'md-color-green\' : \'\'\" style=\"color: #cccccc\">done</md-icon></div></md-button><md-button class=\"is_conciliated\" ng-class=\"mouse_hover ? \'md-icon-button\' : \'md-icon-button\'\" aria-label=\"Conciliar\" ng-click=\"vm.reconcileMovement($event, movement);\" ng-show=\"movement.is_conciliated\" ng-mouseover=\"mouse_hover = true\" ng-mouseleave=\"mouse_hover = false\"><div ng-if=\"!mouse_hover\"><md-tooltip md-direction=\"top\">Conciliado</md-tooltip><md-icon ng-class=\"mouse_hover ? \'md-color-green\' : \'\'\" style=\"color: #00dc00\">done_all</md-icon></div><div ng-if=\"mouse_hover\"><md-tooltip md-direction=\"top\">Cancelar</md-tooltip><md-icon>cancel</md-icon></div></md-button></div></td><td class=\"{{vm.all_movements.movements[$index-1].date!== movement.date ? \'hide-data td-date\' : \'hide-data\' }}\"><md-menu ng-if=\"(movement.movement_type_id != 110 && movement.movement_type_id != 98 && vm.selected_account.current_account_type_id !== vm.current_account_types.CONTA_A4PAG && movement.current_account_type_id_transf_origin !== vm.current_account_types.CONTA_A4PAG)\"><md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"TABLE.EDIT\"><md-icon>more_vert</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"movement.movement_type_id == 102\"><md-button ng-click=\"vm.compensationCreditEdit(movement);\"><md-icon>edit</md-icon>Editar compensação</md-button></md-menu-item><md-menu-item ng-if=\"!checkPolicies(\'alterarMovimentos\') && movement.movement_id_transf == null\"><md-button ng-click=\"vm.removeCompensationCreditEdit(movement);\"><md-icon>delete</md-icon>Desfazer movimento</md-button></md-menu-item><md-menu-divider ng-if=\"movement.movement_id_transf != null\"></md-menu-divider><md-menu-item ng-if=\"movement.movement_id_transf != null\"><md-button ng-click=\"vm.removeTransference($event, movement);\"><md-icon>undo</md-icon>Desfazer transferência</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-click=\"vm.editReceipt(movement.bill_id)\" class=\"md-icon-button\" ng-if=\"movement.bill_type == 6 && movement.debit_credit == \'C\' && (vm.selected_account.current_account_type_id !== vm.current_account_types.CONTA_A4PAG)\"><div><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon style=\"color: #cccccc\">edit</md-icon></div></md-button><md-button ng-click=\"vm.chargeback(movement)\" class=\"md-icon-button\" ng-if=\"movement.bill_id && movement.action_type != 1 && (vm.selected_account.current_account_type_id !== vm.current_account_types.CONTA_A4PAG)\"><div><md-tooltip md-direction=\"top\">Estornar</md-tooltip><md-icon style=\"color: #cccccc\" md-font-icon=\"icon-backup-restore\"></md-icon></div></md-button><md-button ng-click=\"vm.editPayment(movement.bill_id)\" class=\"md-icon-button\" ng-if=\"movement.bill_type == 6 && movement.debit_credit == \'D\' && (vm.selected_account.current_account_type_id !== vm.current_account_types.CONTA_A4PAG)\"><div><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon style=\"color: #cccccc\">edit</md-icon></div></md-button></td></tr></tbody></table></md-table-container></md-card></div></div></div></div>");
$templateCache.put("app/finance/current-account/views/current-account.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background: whitesmoke;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cash-multiple\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{ \'CURRENT_ACCOUNT.TITLE\' | translate }}</span></div></div></md-toolbar><md-card><md-content class=\"md-padding\"><md-input-container><md-checkbox ng-model=\"vm.show_inactive\" ng-change=\"vm.listAllAccounts()\">Mostrar contas inativas</md-checkbox></md-input-container><md-table-container class=\"table-float-button\"><table md-table=\"\" md-row-select=\"\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Conta</th><th md-column=\"\">Tipo da conta</th><th md-column=\"\" md-numeric=\"\" policy-access=\"conta\">Saldo (R$)</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" ng-model=\"teste\" md-select-id=\"id\" md-auto-select=\"\" ng-repeat=\"item in vm.items\" ng-click=\"vm.openExtract(item)\" class=\"row-hover md-ink-ripple\"><td md-cell=\"\" style=\"{{item.is_inactive ? \'color: grey\' : \'\'}}\">{{item.name}} <small ng-if=\"item.is_main\"><span class=\"md-green-800-bg\" style=\"padding: 3px;color:white;border-radius: 2px;margin-left: 15px\">Principal</span></small> <small ng-if=\"item.is_inactive\"><span class=\"md-grey-500-bg\" style=\"padding: 3px;color:white;border-radius: 2px;margin-left: 15px\">Conta inativa</span></small></td><td md-cell=\"\" style=\"{{item.is_inactive ? \'color: grey\' : \'\'}}\">{{item.type_name | translate}}</td><td md-cell=\"\" md-numeric=\"\" ng-class=\"{ \'red\': item.balance < 0 }\" policy-access=\"conta\">{{ item.balance | currency:\" \" }}</td><td md-cell=\"\"><div class=\"actions\" layout=\"row\" layout-align=\"end center\" ng-if=\"item.current_account_type_id !== vm.current_account_types.CONTA_A4PAG\"><md-menu policy-access=\"conta_alt\"><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.getAccountById(item.id)\">{{ \'TABLE.EDIT\' | translate }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.delete(item)\">{{ \'TABLE.DELETE_ITEM\' | translate }}</md-button></md-menu-item><md-menu-item ng-if=\"!item.is_inactive\"><md-button ng-click=\"vm.inactivateAccount(item)\" ng-disabled=\"item.is_main\">Desativar conta</md-button></md-menu-item><md-menu-item ng-if=\"item.is_inactive\"><md-button ng-click=\"vm.activateAccount(item)\">Reativar a conta</md-button></md-menu-item><md-menu-item ng-if=\"item.current_account_type_id == 1 || item.current_account_type_id == 2\"><md-button ng-click=\"vm.setMainAccount(item)\" ng-disabled=\"item.is_main || item.is_inactive\">Definir como principal</md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content></md-card></div>");
$templateCache.put("app/finance/daily-balance/views/index.html","<div id=\"page-material-table\" class=\"doc-page material-docs doc-template page-layout simple tabbed ng-scope layout-column\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calculator\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"DAILY-BALANCE.DAILY_BALANCE\"></span></div></div></md-toolbar><div class=\"content\" style=\"margin-top: 10px\"><div layout=\"row\"><div flex=\"\"><div><md-toolbar md-scroll-shrink=\"\"><div class=\"md-toolbar-tools\"><h3><span>{{\"DAILY-BALANCE.CLOSING_DAY\" | translate}}</span></h3></div></md-toolbar><md-content layout=\"column\"><div ng-if=\"vm.last_date == null && vm.is_daily_balance != null\"><div class=\"alert alert-warning\"><strong>Todos os movimentos diários já foram encerrados.</strong></div></div><div flex=\"\" ng-if=\"vm.last_date != null\"><div ng-show=\"vm.is_daily_balance\"><div class=\"alert alert-warning\"><strong>Último dia encerrado: {{vm.last_date}}</strong></div></div><div layout=\"row\" policy-access=\"saldo_enc\"><div flex=\"\"><div class=\"form-group form-md-line-input form-md-floating-label\"><div class=\"input-group input-date-picker left-addon right-addon\"><date-picker ng-model=\"vm.closing_day\" min-date=\"vm.minDateClose\" max-date=\"vm.maxDateClose\"></date-picker></div></div></div><div flex=\"\"><md-button type=\"submit\" ng-click=\"vm.closingDayByDate(vm.closing_day, $event)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">{{\"DAILY-BALANCE.CLOSE\" | translate}}</md-button></div></div></div></md-content></div></div><md-divider class=\"divider\"></md-divider><div flex=\"\"><div><md-toolbar md-scroll-shrink=\"\"><div class=\"md-toolbar-tools\"><h3><span>{{\"DAILY-BALANCE.REOPENING_DAY\" | translate}}</span></h3></div></md-toolbar><md-content layout=\"column\"><div ng-show=\"vm.reopen_date\"><div class=\"alert alert-warning\"><strong>Sem datas de fechamento não é possivel realizar reabertura!</strong></div></div><div flex=\"\" ng-if=\"!vm.reopen_date\"><div layout=\"row\" policy-access=\"saldo_abre\"><div flex=\"\"><div class=\"form-group form-md-line-input form-md-floating-label\"><div class=\"input-group input-date-picker left-addon right-addon\"><date-picker ng-model=\"vm.init_date\" min-date=\"vm.first_date\" max-date=\"vm.init_date\"></date-picker></div></div></div><div flex=\"\"><md-button type=\"submit\" ng-click=\"vm.reopening(vm.init_date, $event)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">{{\"DAILY-BALANCE.REOPEN\" | translate}}</md-button></div></div></div></md-content></div></div></div></div></div>");
$templateCache.put("app/finance/difference-analysis/views/confirm-modal.html","<md-dialog aria-label=\"difference confirm modal\" md-theme=\"finance\" style=\"min-width: 600px;min-height: 300px; max-width: 600px;max-height: 780px;\"><form ng-cloak=\"\" ng-submit=\"vm.submit()\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Confirmar criação da diferença</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 17px 14px 14px 24px;\"><div class=\"md-dialog-content\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117); margin-top: -20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Decisão sobre o título de diferença</b> <small>Atenção! Caso deseje que o título seja recebido apenas pelo caixa, selecione o checkbox.</small></div></div><div style=\"margin-top: 10px;\"><md-radio-group ng-model=\"vm.associate_to_bank_slip\"><md-radio-button value=\"0\" ng-disabled=\"!vm.canAssociateToBankSlip\">Vincular título ao próximo boleto do responsável <span ng-if=\"vm.canAssociateToBankSlip\">em {{vm.formated_due_date}}</span></md-radio-button><div layout=\"row\" style=\"border-left: solid 4px rgb(204,15,18); margin-bottom: 10px;\" ng-if=\"!vm.canAssociateToBankSlip\"><b style=\"margin-left: 5px;\">AVISO: Não é possível agrupar esta diferença. Todos os títulos desta pessoa já possuem boletos gerados ou não estão associados a regras de boleto. Você deverá definir uma data de vencimento para este título e gerar um boleto exclusivamente para essa diferença ou recebê-la via caixa</b></div><md-radio-button value=\"1\">Criar título para cobrança avulsa</md-radio-button></md-radio-group><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\" style=\"margin-top: 20px;\"><label>Selecione a regra de boleto</label><md-icon md-font-icon=\"icon-barcode\"></md-icon><md-select name=\"bank_slip_rules\" ng-required=\"!vm.cashier_payment\" ng-model=\"vm.bank_slip_rule_id\" ng-change=\"vm.cashier_payment = false\" aria-label=\"Selecione a regra de boleto\"><md-option ng-value=\"null\">Nenhuma</md-option><md-option ng-repeat=\"bank_slip_rule in vm.bank_slip_rules\" ng-value=\"bank_slip_rule.id\">{{bank_slip_rule.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\" style=\"margin-top: 20px;\"><label>Selecione a regra de acréscimo</label><md-icon md-font-icon=\"icon-arrow-up\"></md-icon><md-select name=\"bank_slip_rules\" ng-model=\"vm.fines_rule_id\" aria-label=\"Selecione a regra de boleto\"><md-option ng-value=\"null\">Nenhuma</md-option><md-option ng-repeat=\"fines_rule in vm.fines_rules\" ng-value=\"fines_rule.id\">{{fines_rule.name}}</md-option></md-select></md-input-container><md-input-container><md-checkbox ng-model=\"vm.cashier_payment\" ng-required=\"vm.bank_slip_rule_id === null\" ng-change=\"vm.clearBankSlipRule(vm.cashier_payment)\">Desejo receber este título de diferença apenas no caixa</md-checkbox></md-input-container><div ng-if=\"vm.associate_to_bank_slip == 1\" style=\"padding-top: 20px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117); margin-top: -20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Data de vencimento</b> <small>Defina qual a data de vencimento para o título de diferença</small></div></div><div layout=\"row\"><date-picker ng-model=\"vm.difference_due_date\" required=\"\" ng-change=\"vm.refreshAmount(vm.difference_due_date)\"></date-picker></div></div></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117);\"><b style=\"margin-left: 5px;\">Valor do título de diferença: R$ {{-(vm.value) | currency:\"\"}}</b></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" name=\"close\" ng-disabled=\"form.$invalid || vm.unable_button\" class=\"md-raised md-primary\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/difference-analysis/views/index.html","<div id=\"page-material-table\" class=\"bill-receipt page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke !important;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cash-usd\" class=\"s24\"></md-icon></span> <span class=\"logo-text md-primary md-hue-1\">{{\'DIFFERENCE_ANALYSIS.TITLE\' | translate}}</span></div></div></md-toolbar><md-card layout=\"column\"><div layout=\"row\" flex=\"100\"><div flex=\"\" layout=\"column\"><div layout=\"row\" flex=\"\"><date-range-picker flex=\"\" ng-model=\"vm.filter_due_date\" label=\"Data de vencimento\" style=\"padding: 5px 18px;\" disabled=\"vm.filter_settlement_date.startDate !== null\"></date-range-picker><date-range-picker flex=\"\" ng-model=\"vm.filter_settlement_date\" label=\"Data de pagamento\" style=\"padding: 5px 18px;\" disabled=\"vm.filter_due_date.startDate !== null\"></date-range-picker><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\" style=\"margin-top: 20px;\"><label>Status</label><md-icon md-font-icon=\"icon-radiobox-blank\"></md-icon><md-select name=\"bank_slip_rules\" ng-model=\"vm.filter_status\" aria-label=\"Status\" ng-change=\"vm.getAllDifferences(1, 10)\"><md-option ng-repeat=\"status in vm.all_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container></div><div flex=\"\" layout=\"row\"><md-autocomplete flex=\"\" style=\"margin-left: 20px;\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.filter_person\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPersons(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" md-floating-label=\"Filtro por pessoa\"><md-item-template><span>{{item.name}}</span></md-item-template><md-not-found>Nenhuma pessoa encontrada</md-not-found></md-autocomplete></div></div><div flex=\"10\" style=\"margin: 18px 0;\"><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Buscar\" ng-click=\"vm.getAllDifferences(1, 10)\"><md-tooltip md-direction=\"bottom\">Buscar</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Buscar\" ng-click=\"vm.clearFilters()\"><md-tooltip md-direction=\"bottom\">Limpar</md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-table-pagination flex=\"\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.allDifferences.per_page\" md-page=\"vm.allDifferences.current_page\" md-limit-options=\"[10, 25, 50]\" style=\"border-top: none\" md-total=\"{{vm.allDifferences.total}}\" md-on-paginate=\"vm.getAllDifferences\" md-page-select=\"\"></md-table-pagination></div></md-card><md-card ng-repeat=\"clientdifferences in vm.allDifferences.data\" style=\"margin-top: 20px; margin-bottom: 20px;padding-right: 8px;\"><div layout=\"column\" flex=\"\" layout-padding=\"\"><md-table-container style=\"margin-top: 0; padding-top:0\"><table md-table=\"\"><thead md-head=\"\" ng-if=\"true\" md-promise=\"vm.promise\" style=\"height: 0px;position: absolute;\"><tr md-row=\"\"><th md-column=\"\" width=\"35%\"></th><th md-column=\"\" width=\"10%\"></th><th md-column=\"\" width=\"10%\"></th><th md-column=\"\" md-numeric=\"\" width=\"10%\"></th><th md-column=\"\" md-numeric=\"\" width=\"10%\"></th><th md-column=\"\" md-numeric=\"\" width=\"10%\"></th><th md-column=\"\" md-numeric=\"\" width=\"10%\"></th><th md-column=\"\" width=\"5%\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat-start=\"item in clientdifferences\" ng-if=\"item.level == 1\" style=\"background-color: rgba(200,194,199,0.22);\"><td md-cell=\"\" flex=\"10\" align=\"left\" width=\"35%\"><b>{{item.person_name}}</b></td><td md-cell=\"\" align=\"left\" width=\"10%\"></td><td md-cell=\"\" align=\"left\" width=\"10%\"><b></b></td><td md-cell=\"\" md-numeric=\"\" width=\"10%\"><b></b></td><td md-cell=\"\" md-numeric=\"\" width=\"10%\"><b></b></td><td class=\"{{item.difference < 0 ? \'md-cell md-numeric negativeValue\' : \'md-cell md-numeric positiveValue\' }}\"><b>{{(vm.filter_status == \'Pendente\' || vm.filter_status == \'Todos\') ? item.difference : null | currency:\"\"}}</b></td><td class=\"{{item.final_difference_value < 0 ? \'md-cell md-numeric negativeValue\' : \'md-cell md-numeric positiveValue\' }}\" width=\"10%\"><b>{{(vm.filter_status == \'Pendente\' || vm.filter_status == \'Todos\') ? item.final_difference_value : null | currency:\"\"}}</b></td><td md-cell=\"\" align=\"left\" width=\"10%\"><b></b></td><td md-cell=\"\" style=\"text-align: center\" width=\"5%\"><md-button class=\"md-icon-print md-icon-button\" policy-access=\"difer_alt\" ng-click=\"vm.createOneDifference(item, vm.filter_due_date.startDate, vm.filter_due_date.endDate, vm.filter_settlement_date.startDate, vm.filter_settlement_date.endDate)\" aria-label=\"Gerar título\" ng-if=\"vm.filter_status == \'Pendente\' || vm.filter_status == \'Todos\'\"><md-tooltip md-direction=\"bottom\">Gerar título</md-tooltip><md-icon md-font-icon=\"icon-gamepad\"></md-icon></md-button></td></tr><tr md-row=\"\" ng-if=\"item.level == 2 && item.person_id_beneficiary !== null\" style=\"background-color: rgba(180,180,180,0.22);\"><td md-cell=\"\" flex=\"10\" align=\"left\" width=\"35%\"><b>{{item.person_beneficiary_name}}</b></td><td md-cell=\"\" align=\"left\" width=\"10%\"></td><td md-cell=\"\" align=\"left\" width=\"10%\"><b></b></td><td md-cell=\"\" md-numeric=\"\" width=\"10%\"><b></b></td><td md-cell=\"\" md-numeric=\"\" width=\"10%\"><b></b></td><td class=\"{{item.difference < 0 ? \'md-cell md-numeric negativeValue\' : \'md-cell md-numeric positiveValue\' }}\" width=\"10%\"><b>{{(vm.filter_status == \'Pendente\' || vm.filter_status == \'Todos\') ? item.difference : null | currency:\" \"}}</b></td><td class=\"{{item.final_difference_value < 0 ? \'md-cell md-numeric negativeValue\' : \'md-cell md-numeric positiveValue\' }}\" width=\"10%\"><b>{{(vm.filter_status == \'Pendente\' || vm.filter_status == \'Todos\') ? item.final_difference_value : null | currency:\" \"}}</b></td><td md-cell=\"\" align=\"left\" width=\"10%\"><b></b></td><td md-cell=\"\" align=\"left\" width=\"5%\"><b></b></td></tr><tr md-row=\"\" ng-if=\"item.level == 2 && item.person_id != item.person_id_beneficiary\"><td md-cell=\"\" flex=\"10\" align=\"left\" width=\"35%\"><b>Descrição</b></td><td md-cell=\"\" align=\"left\" width=\"10%\"><b>Vencimento</b></td><td md-cell=\"\" align=\"left\" width=\"10%\"><b>Data pagto.</b></td><td md-cell=\"\" md-numeric=\"\" align=\"right\" width=\"10%\"><b>Valor esperado</b></td><td md-cell=\"\" md-numeric=\"\" align=\"right\" width=\"10%\"><b>Valor pago</b></td><td md-cell=\"\" md-numeric=\"\" align=\"right\" width=\"10%\"><b>Diferença</b></td><td md-cell=\"\" md-numeric=\"\" align=\"right\" width=\"10%\"><b>Diferença atual.</b></td><td md-cell=\"\" align=\"left\" width=\"10%\"><b>Status</b></td><td md-cell=\"\" align=\"left\" width=\"5%\"><b></b></td></tr><tr md-row=\"\" ng-repeat-end=\"\" ng-if=\"item.level == 3\" ng-click=\"vm.getDetailsFromBill(item.bill_id)\" style=\"cursor: pointer\"><td md-cell=\"\" align=\"left\" width=\"35%\">{{item.product_name}} {{item.instalment_name !== null ? \' | \' + item.instalment_name : \'\'}}</td><td md-cell=\"\" align=\"left\" width=\"10%\">{{item.due_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\" align=\"left\" width=\"10%\">{{item.settlement_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\" md-numeric=\"\" align=\"right\" width=\"10%\">{{item.expected_value | currency:\" \"}}</td><td md-cell=\"\" md-numeric=\"\" align=\"right\" width=\"10%\">{{item.amount_paid | currency:\" \"}}</td><td class=\"{{item.difference < 0 ? \'md-cell md-numeric negativeValue\' : \'md-cell md-numeric positiveValue\' }}\" width=\"10%\">{{item.difference | currency:\" \"}}</td><td class=\"{{item.final_difference_value < 0 ? \'md-cell md-numeric negativeValue\' : \'md-cell md-numeric positiveValue\' }}\" width=\"10%\">{{item.final_difference_value | currency:\" \"}}</td><td md-cell=\"\" align=\"left\" width=\"10%\"><span class=\"badge\" style=\"padding: 0;margin-left: 0;\"><span class=\"{{item.status}}\">{{item.status}}</span></span></td><td md-cell=\"\" style=\"text-align: center\" width=\"5%\"><md-button class=\"md-icon-print md-icon-button\" policy-access=\"difer_alt\" ng-click=\"vm.dismissDifference(item, clientdifferences);$event.stopPropagation();$event.preventDefault();\" aria-label=\"Dispensar\"><md-tooltip md-direction=\"bottom\" ng-if=\"item.is_difference_exempted == false && item.status == \'Pendente\'\">Dispensar</md-tooltip><md-icon md-font-icon=\"icon-chevron-double-up\" ng-if=\"item.is_difference_exempted == false && item.status == \'Pendente\'\"></md-icon><md-tooltip md-direction=\"bottom\" ng-if=\"item.is_difference_exempted == true && item.status == \'Dispensada\'\">Desfazer dispensa</md-tooltip><md-icon md-font-icon=\"icon-undo\" ng-if=\"item.is_difference_exempted == true && item.status == \'Dispensada\'\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></md-card></div>");
$templateCache.put("app/finance/discounts/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"DISCOUNTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-receipt\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"DISCOUNTS.TITLE\"></span></div></div><md-button class=\"md-raised md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openAside($event, \'sidenav-form\')\" aria-label=\"add\" translate=\"\"><md-tooltip md-direction=\"top\">{{ \'DISCOUNTS.ADD_RULE\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-plus\" style=\"color: green\"></md-icon></md-button></md-toolbar><a4-table items=\"vm.items\" groups=\"vm.user\" filter=\"[\'name\']\" include-scope=\"vm.includeScope\"></a4-table></div>");
$templateCache.put("app/finance/discounts-reason/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"DISCOUNTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-receipt\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Motivos de descontos</span></div></div></md-toolbar><md-card><div class=\"table-float-button\"><a4-grid-dic-data bind=\"vm.grid\" on-click-item=\"vm.editReason(item)\" on-delete=\"vm.delete(index)\" policies=\"{show:\'config_fin\', cud:\'config_fin\'}\" fields-schema=\"app/finance/discounts-reason/grid.json\"></a4-grid-dic-data></div></md-card></div>");
$templateCache.put("app/finance/external-financial-statement/views/index.html","<md-content id=\"content\" class=\"externalFinancialStatement\" layout=\"row\" layout-align=\"center start\" md-theme=\"finance\" ng-style=\"{height: vm.windowHeight + \'px\'}\" style=\"overflow: auto;\"><div layout=\"column\" layout-align=\"start center\" class=\"statementBackground\" style=\"width: 100%; overflow: auto\" ng-style=\"{\'height\': vm.windowHeight + \'px\', \'background\': vm.url_background}\"><md-card class=\"presentationCard md-whiteframe-7dp md-padding\" style=\"border-radius: 7px; width: 75%; text-align: center\" ng-style=\"vm.cpf_verify === false && vm.windowWidth < 1000 && {\'margin-top\': \'50%\'}\" layout=\"row\" layout-align=\"center start\"><div id=\"login-v2-form\" style=\"width: 40%\" ng-style=\"{width: vm.cpfFormWidth + \'%\'}\"><div style=\"width: 115px;line-height: 74px;font-size: 50px;font-weight: 500; margin: 2px auto 32px auto;color: #FFFFFF;border-radius: 2px;display: table;\"><div style=\"display: table-cell; vertical-align: middle;\"><img align=\"middle\" ng-src=\"{{vm.screen_image}}\" alt=\"\"></div></div><span class=\"headerSpan\">{{vm.data.company_name.split(\'(\')[0]}}</span><form name=\"formCPF\" novalidate=\"\" ng-if=\"!vm.cpf_verify\"><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"vm.data.person_type != 2\"><input type=\"text\" name=\"CPF\" ng-model=\"vm.cpf\" placeholder=\"Digite seu CPF\" ui-br-cpf-mask=\"\" required=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"vm.data.person_type == 2\"><input type=\"text\" name=\"CPF\" ng-model=\"vm.cpf\" placeholder=\"Digite seu CNPJ\" ui-br-cnpj-mask=\"\" required=\"\"></md-input-container><div layout=\"column\"><md-button class=\"md-raised md-accent submit-button\" aria-label=\"Confirmar\" ng-click=\"vm.verifyCpf()\" ng-disabled=\"formCPF.$invalid || vm.loading\">Confirmar</md-button></div></form></div></md-card><md-card class=\"presentationCard md-whiteframe-7dp md-padding\" style=\"border-radius: 7px; width: 75%;\" ng-style=\"vm.windowWidth < 1000 && {\'height\' : \'85%\'}\" layout=\"column\" layout-align=\"center start\" ng-if=\"vm.cpf_verify\"><div ng-if=\"vm.subdomain == \'a4tecnologia\' && vm.data.texto_reajuste && false\" style=\"font-size: larger\">Prezado cliente <span class=\"headerSpan\">(IMPORTANTE!!!)</span>,<br><br>Estamos em processo de <strong>atualização dos contratos</strong> com nossos clientes. É importante destacar que desde o início da pandemia nós decidimos adiar temporariamente os reajustes anuais como um sinal de nossa parceria naquele momento delicado para todos.<br><br>Pelo nosso acordo, aplicamos o IGP-M para corrigir o valor do contrato anualmente afim de reduzir a defasagem financeira causada pela inflação. Como adiamos a correção nesses últimos anos, estamos aplicando o IGP-M a partir do último reajuste do seu contrato para este mês, ou seja, a defasagem financeira do nosso contrato nesse período:<br><br><strong>{{vm.data.texto_reajuste}}</strong><br><br>Essa decisão causou um impacto financeiro negativo para a nossa empresa, mas esperamos que tenha sido positivo para sua instituição de ensino nos momentos mais críticos da pandemia. Acreditamos firmemente na importância de cultivar um relacionamento de confiança e parceria duradoura com os nossos clientes.<br><br>Caso exista alguma dúvida ou questionamento quanto aos cálculos do reajuste, por favor nos contate para esclarecermos.<br><br>Atenciosamente,<br>Rose Santos<br>financeiro@simetrianet.com.br<br>A4 / Simetria<br><br></div><span class=\"headerSpan\">Bem-vindo, {{vm.data.person_name}}!</span> <span class=\"contentSpan\">Essa é sua ficha financeira, abaixo você pode visualizar os seus boletos disponíveis para pagamento.</span><div layout=\"column\"><md-button class=\"md-raised\" ng-if=\"vm.data.bills_paid_on_last_year > 0 && !(vm.subdomain == \'a4tecnologia\')\" ng-click=\"vm.generateIncomeTaxReport()\"><small>Imprimir relatório do imposto de renda [{{vm.last_year}}]</small><md-icon md-font-icon=\"icon-cash-multiple\"></md-icon></md-button><md-checkbox ng-model=\"vm.show_paids\" ng-change=\"vm.reload()\" ng-disabled=\"vm.loading == true\">Exibir boletos pagos</md-checkbox></div></md-card><md-card class=\"_{{bank_slip.status_name}} md-whiteframe-7dp md-padding\" style=\"border-radius: 7px; width: 90% !important; height: 50% !important;\" ng-if=\"vm.cpf_verify && vm.windowWidth < 1000\" ng-repeat=\"bank_slip in vm.bank_slips\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between start\"><span ng-repeat=\"service in vm.formatServices(bank_slip.services) | unique\" ng-if=\"service !== null\"><small>{{ vm.formatName(service) }}</small></span> <span>{{(bank_slip.amount - bank_slip.discount_fixed_value) | currency}}</span></div><div layout=\"row\" layout-align=\"space-between start\"><span ng-repeat=\"beneficiaries in vm.formatBeneficiaries(bank_slip.beneficiaries) | unique\"><small><b>{{bank_slip.name}}</b></small><br><small>{{ vm.formatName(beneficiaries) }}</small></span> <span ng-if=\"bank_slip.due_date_original !== null\">{{ bank_slip.due_date_original | date:\"dd/MM/yyyy\"}} <span ng-if=\"bank_slip.bank_slip_status_id === 3 && (bank_slip.due_date_original !== bank_slip.due_date || bank_slip.current_account_type_id == 8)\"><small class=\"td-second-line\">Gerado para {{ bank_slip.due_date | date:\"dd/MM/yyyy\" }}</small></span></span> <span ng-if=\"bank_slip.due_date_original === null\">{{ bank_slip.due_date | date:\"dd/MM/yyyy\"}} <span ng-if=\"bank_slip.bank_slip_status_id === 3 && (bank_slip.due_date_original !== bank_slip.due_date || bank_slip.current_account_type_id == 8)\"><small class=\"td-second-line\">Gerado para {{ bank_slip.due_date | date:\"dd/MM/yyyy\" }}</small></span></span></div><div layout=\"row\" layout-align=\"space-between start\" ng-if=\"bank_slip.status_name_original !== null && bank_slip.bank_slip_status_id === null\"><span>&nbsp;</span> <span class=\"badge\"><span class=\"{{bank_slip.status_name_original}}\" ng-if=\"!((bank_slip.status_name_original === \'VENCIDO\' || bank_slip.status_name_original === \'A_VENCER\') && bank_slip.paid_bill_id !== null)\">{{(bank_slip.status_name_original).replace(\'_\', \' \')}}</span> <span class=\"PAGO\" ng-if=\"((bank_slip.status_name_original === \'VENCIDO\' || bank_slip.status_name_original === \'A_VENCER\') && bank_slip.paid_bill_id !== null)\">APENAS TÍTULO PAGO<md-tooltip>O título deste boleto está pago, mas o pagamento não foi realizado através do boleto</md-tooltip></span> <span class=\"PP\" style=\"margin-left: 2px\" ng-if=\"(bank_slip.status_name_original === \'VENCIDO\' || bank_slip.status_name_original === \'A_VENCER\') && bank_slip.partial_paid_msg !== null\">PP<md-tooltip md-direction=\"right\">{{bank_slip.partial_paid_msg}}</md-tooltip></span></span></div><div layout=\"row\" layout-align=\"space-between start\" ng-if=\"bank_slip.status_name_original === null || bank_slip.bank_slip_status_id != null\"><span>&nbsp;</span> <span class=\"badge\"><span class=\"{{bank_slip.status_name}}\" ng-if=\"!((bank_slip.status_name === \'VENCIDO\' || bank_slip.status_name === \'A_VENCER\') && bank_slip.paid_bill_id !== null)\">{{(bank_slip.status_name).replace(\'_\', \' \')}}</span> <span class=\"PAGO\" ng-if=\"((bank_slip.status_name === \'VENCIDO\' || bank_slip.status_name === \'A_VENCER\') && bank_slip.paid_bill_id !== null)\">APENAS TÍTULO PAGO [PAG. NÃO REALIZADO ATRAVÉS DO BOLETO]</span> <span class=\"PP\" style=\"margin-left: 2px\" ng-if=\"(bank_slip.status_name === \'VENCIDO\' || bank_slip.status_name === \'A_VENCER\') && bank_slip.partial_paid_msg !== null\">PP<md-tooltip md-direction=\"right\">{{bank_slip.partial_paid_msg}}</md-tooltip></span></span></div><div layout=\"row\" layout-align=\"space-between start\"><span><md-button ng-if=\"vm.allowGenerateBankSlip(bank_slip)\" aria-label=\"Boleto PDF\" ng-click=\"vm.getBankSlipA4Pag(\'pdf\',bank_slip.due_date_original, bank_slip.bill_ids_array, bank_slip.bank_slip_id, bank_slip.person_id)\" ng-disabled=\"vm.loading\"><span><small>Boleto PDF</small><md-icon md-font-icon=\"icon-file-pdf\"></md-icon></span></md-button></span> <span><md-button ng-if=\"vm.allowGenerateBankSlip(bank_slip)\" aria-label=\"Linha digitável\" ng-click=\"vm.getBankSlipA4Pag(\'barcode_number\',bank_slip.due_date_original, bank_slip.bill_ids_array, bank_slip.bank_slip_id, bank_slip.person_id)\" ng-disabled=\"vm.loading\"><span><small>Linha digitável</small><md-icon md-font-icon=\"icon-barcode\"></md-icon></span></md-button></span><span></span></div></md-card><md-card class=\"md-whiteframe-7dp md-padding\" style=\"cursor: pointer\" ng-click=\"vm.getBankSlips()\" ng-if=\"vm.cpf_verify && vm.windowWidth < 1000 && vm.show_button\" layout=\"row\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span class=\"headerSpan\">Carregar mais</span></md-card><md-card class=\"presentationCard md-whiteframe-7dp md-padding\" style=\"width: 75%; border-radius: 7px;\" ng-if=\"vm.cpf_verify && vm.windowWidth > 1000\"><table md-table=\"\" class=\"row-border hover\"><thead md-head=\"\" style=\"position: sticky\"><tr md-row=\"\"><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Descrição</span></th><th md-column=\"\">Vencimento</th><th md-column=\"\" style=\"text-align: center\">Status</th><th md-column=\"\" md-numeric=\"\">Valor Original</th><th md-column=\"\" style=\"text-align: right\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"bank_slip in vm.bank_slips\"><td md-cell=\"\"><b>{{bank_slip.name}}</b><br><small class=\"td-second-line\" ng-repeat=\"beneficiaries in vm.formatBeneficiaries(bank_slip.beneficiaries) | unique\">{{ vm.formatName(beneficiaries) }}<br></small></td><td md-cell=\"\"><span class=\"td-second-line\" ng-repeat=\"service in vm.formatServices(bank_slip.services) | unique\">{{ vm.formatName(service) }}<br></span></td><td md-cell=\"\" ng-if=\"bank_slip.due_date_original !== null\">{{ bank_slip.due_date_original | date:\"dd/MM/yyyy\"}} <span ng-if=\"bank_slip.bank_slip_status_id < 3 && (bank_slip.due_date_original !== bank_slip.due_date)\"><br><small class=\"td-second-line\">Reprogramado para {{ bank_slip.due_date | date:\"dd/MM/yyyy\" }}</small></span> <span ng-if=\"bank_slip.bank_slip_status_id === 3 && (bank_slip.due_date_original !== bank_slip.due_date || bank_slip.current_account_type_id == 8)\"><br><small class=\"td-second-line\">Gerado para {{ bank_slip.due_date | date:\"dd/MM/yyyy\" }}</small></span></td><td md-cell=\"\" ng-if=\"bank_slip.due_date_original === null\">{{ bank_slip.due_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\" style=\"text-align: center\" ng-if=\"bank_slip.status_name_original !== null\"><span class=\"badge\"><span class=\"{{bank_slip.status_name_original}}\" ng-if=\"!((bank_slip.status_name_original === \'VENCIDO\' || bank_slip.status_name_original === \'A_VENCER\') && bank_slip.paid_bill_id !== null)\">{{(bank_slip.status_name_original).replace(\'_\', \' \')}}</span> <span class=\"PAGO\" ng-if=\"((bank_slip.status_name_original === \'VENCIDO\' || bank_slip.status_name_original === \'A_VENCER\') && bank_slip.paid_bill_id !== null)\">APENAS TÍTULO PAGO [PAG. NÃO REALIZADO ATRAVÉS DO BOLETO]</span> <span class=\"PP\" style=\"margin-left: 2px\" ng-if=\"(bank_slip.status_name_original === \'VENCIDO\' || bank_slip.status_name_original === \'A_VENCER\') && bank_slip.partial_paid_msg !== null\">PP<md-tooltip md-direction=\"right\">{{bank_slip.partial_paid_msg}}</md-tooltip></span></span></td><td md-cell=\"\" style=\"text-align: center\" ng-if=\"bank_slip.status_name_original == null\"><span class=\"badge\"><span class=\"{{bank_slip.status_name}}\" ng-if=\"!((bank_slip.status_name === \'VENCIDO\' || bank_slip.status_name === \'A_VENCER\') && bank_slip.paid_bill_id !== null)\">{{(bank_slip.status_name).replace(\'_\', \' \')}}</span> <span class=\"PAGO\" ng-if=\"((bank_slip.status_name === \'VENCIDO\' || bank_slip.status_name === \'A_VENCER\') && bank_slip.paid_bill_id !== null)\">APENAS TÍTULO PAGO<md-tooltip>O título deste boleto está pago, mas o pagamento não foi realizado através do boleto</md-tooltip></span> <span class=\"PP\" style=\"margin-left: 2px\" ng-if=\"(bank_slip.status_name === \'VENCIDO\' || bank_slip.status_name === \'A_VENCER\') && bank_slip.partial_paid_msg !== null\">PP<md-tooltip md-direction=\"right\">{{bank_slip.partial_paid_msg}}</md-tooltip></span></span></td><td md-cell=\"\" md-numeric=\"\">{{ (bank_slip.amount - bank_slip.discount_fixed_value) | currency }}</td><td md-cell=\"\" style=\"text-align: right\"><div><md-button class=\"md-icon-print md-icon-button\" ng-if=\"vm.allowGenerateBankSlip(bank_slip)\" aria-label=\"Boleto PDF\" ng-click=\"vm.getBankSlipA4Pag(\'pdf\',bank_slip.due_date, bank_slip.bill_ids_array, bank_slip.bank_slip_id, bank_slip.person_id)\" ng-disabled=\"vm.loading\"><md-tooltip md-direction=\"left\">Boleto PDF</md-tooltip><md-icon md-font-icon=\"icon-file-pdf\"></md-icon></md-button><md-button class=\"md-icon-print md-icon-button\" ng-if=\"vm.allowGenerateBankSlip(bank_slip) && bank_slip.qrcode_emv !== null && bank_slip.qrcode_emv.length > 1\" aria-label=\"Código PIX\" ng-click=\"vm.getBankSlipA4Pag(\'qrcode\',bank_slip.due_date, bank_slip.bill_ids_array, bank_slip.bank_slip_id, bank_slip.person_id)\" ng-disabled=\"vm.loading\"><md-tooltip md-direction=\"left\">Código PIX</md-tooltip><md-icon md-font-icon=\"icon-qrcode\"></md-icon></md-button><md-button class=\"md-icon-print md-icon-button\" ng-if=\"vm.allowGenerateBankSlip(bank_slip)\" aria-label=\"Linha digitável\" ng-click=\"vm.getBankSlipA4Pag(\'barcode_number\',bank_slip.due_date, bank_slip.bill_ids_array, bank_slip.bank_slip_id, bank_slip.person_id)\" ng-disabled=\"vm.loading\"><md-tooltip md-direction=\"left\">Linha digitável</md-tooltip><md-icon md-font-icon=\"icon-barcode\"></md-icon></md-button><md-button class=\"md-icon-print md-icon-button\" ng-if=\"(vm.subdomain == \'a4tecnologia\' || bank_slip.invoices.length > 1)\" ng-disabled=\"(bank_slip.invoices.length === 0)\" aria-label=\"Nota fiscal\" href=\"https://nfse.salvador.ba.gov.br/site/contribuinte/nota/notaprint.aspx?nf={{bank_slip.invoices[0].nf_number}}&inscricao={{bank_slip.municipal_registration_number}}&verificacao={{bank_slip.invoices[0].nf_code}}\" target=\"_blank\"><md-tooltip md-direction=\"left\">Nota fiscal</md-tooltip><md-icon md-font-icon=\"icon-file-document\"></md-icon></md-button></div></td></tr><tr md-row=\"\" ng-if=\"vm.bank_slips.length == 0\"><td md-cell=\"\"></td><td md-cell=\"\">Não há boletos</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table><md-button style=\"width: 98%\" ng-click=\"vm.getBankSlips()\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.show_button\" ng-disabled=\"vm.loading\"><span><md-icon md-font-icon=\"icon-plus-circle-outline\" ng-if=\"!vm.loading\"></md-icon><md-progress-circular ng-show=\"vm.loading\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\" style=\"margin-right: 5px\"></md-progress-circular>Carregar mais</span></md-button></md-card></div></md-content>");
$templateCache.put("app/finance/individual-discounts/views/individual-discounts.html","<md-dialog aria-label=\"Mango (Fruit)\" md-theme=\"vm.theme\"><form ng-cloak=\"\" name=\"newDiscount\" ng-submit=\"vm.submit(newDiscount)\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Criar desconto individual</h2></div></md-toolbar><md-dialog-content style=\"padding-top: 0;padding-bottom: 0;\"><div class=\"md-dialog-content\" layout=\"column\"><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\" ng-if=\"vm.data.value_type == 1\"><label>Valor</label><md-icon md-font-icon=\"icon-percent\"></md-icon><input ng-model=\"vm.data.amount\" name=\"percent_amount\" ui-percentage-mask=\"3\" ui-percentage-value=\"\" min=\"0.001\" max=\"100.0\"><div ng-messages=\"newDiscount.percent_amount.$error\"><div ng-message=\"min\">A porcentagem minima é 0.01% .</div><div ng-message=\"max\">A porcentagem máxima é 100.00% .</div></div></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\" ng-if=\"vm.data.value_type == 2\"><label>Valor</label><md-icon md-font-icon=\"icon-cash\"></md-icon><input ng-model=\"vm.data.amount\" name=\"amount\" ui-money-mask=\"2\"></md-input-container><md-input-container flex=\"\"><md-radio-group flex=\"\" ng-model=\"vm.data.value_type\" layout=\"row\" style=\"display: table\" layout-align=\"space-between\"><md-radio-button value=\"1\" flex=\"\" style=\"display: table-cell; vertical-align: middle;padding-right: 50px;\">Percentual</md-radio-button><md-radio-button value=\"2\" flex=\"\" style=\"display: table-cell; vertical-align: middle;\">Valor</md-radio-button></md-radio-group></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-input-has-placeholder\" flex=\"\"><label>Razão</label><md-icon md-font-icon=\"icon-note-text\"></md-icon><md-select name=\"discount_reason\" ng-model=\"vm.data.discount_reason\" flex=\"90\" required=\"\"><md-option ng-repeat=\"reason in vm.reasons\" ng-value=\"reason\">{{reason.name}}</md-option></md-select><div ng-messages=\"newDiscount.discount_reason.$error\"><div ng-message=\"required\">A razao é obrigatória.</div></div></md-input-container></div><div layout=\"row\"><md-card flex=\"50\" style=\"margin: 0 8px; padding: 20px;\"><span style=\"font-size: 15px; margin-bottom: 10px;\"><b>Validade do desconto</b></span><md-radio-group ng-model=\"vm.data.is_fixed\" ng-checked=\"true\"><md-radio-button ng-value=\"1\" class=\"md-primary\" style=\"margin-bottom: -1px;\"><span style=\"font-size: 14px;\">Fixo</span></md-radio-button><md-content style=\"margin-bottom: 5px\"><small>Desconto fixo abate diretamente do valor principal. O desconto é válido independente do dia que o título for liquidado.</small></md-content><md-radio-button ng-value=\"0\" class=\"md-primary\" style=\"margin-bottom: -1px;\"><span style=\"font-size: 14px;\">Condicional</span></md-radio-button><md-content><small>Desconto condicional é válido apenas para o pagamento até a data de vencimento.</small></md-content></md-radio-group></md-card><md-card flex=\"50\" style=\"margin: 0 8px; padding: 5px;\"><md-card-content><span style=\"font-size: 15px;\"><b>Vigência do desconto (OPCIONAL)</b></span><md-content><small>Ao informar uma data inicial, apenas as parcelas com vencimento a partir desta data sofrerão o desconto. Ao informar uma data final, apenas as parcelas com vencimento anterior à esta data sofrerão o desconto.</small></md-content><date-picker flex=\"\" ng-model=\"vm.data.start_date\" placeholder=\"{{ \'Data inicial\' | translate}}\"></date-picker><date-picker flex=\"\" ng-model=\"vm.data.end_date\" placeholder=\"{{ \'Data Final\' | translate}}\"></date-picker></md-card-content></md-card></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\">Criar</md-button><md-button ng-click=\"vm.close(\'canceled\')\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/negotiation/views/index.html","<div id=\"page-material-table\" class=\"bill-receipt page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke !important;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cash-usd\" class=\"s24\"></md-icon></span> <span class=\"logo-text md-primary md-hue-1\">Negociações</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"Buscar pessoa\" type=\"text\" ng-model-options=\"{debounce: 1000}\" ng-model=\"vm.search\" translate=\"\" translate-attr-placeholder=\"Pesquisar\"></md-input-container></div></md-toolbar><a4-negotiation search=\"vm.search\"></a4-negotiation></div>");
$templateCache.put("app/finance/payment-book/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-receipt\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Carnês</div></div></md-toolbar><md-card layout-padding=\"\"><div class=\"md-dialog-content\" layout=\"column\"><div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"30\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Filtro por mês</b> <small><b>Selecione</b> o mês (de acordo com a data de vencimento)</small></div></div><div flex=\"\" layout=\"row\" class=\"md-padding\"><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Mês</label><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-select name=\"month_list\" ng-model=\"vm.filter_month\" multiple=\"\" ng-change=\"vm.getAllBankSlipRule()\" required=\"\" aria-label=\"mês\"><md-option ng-value=\"null\" ng-show=\"vm.person !== \'\' && vm.person !== null\">Todos em Aberto</md-option><md-option ng-repeat=\"month in vm.months\" ng-value=\"month.id\">{{month.name}}</md-option></md-select><div ng-messages=\"bankslipform.month_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um mês para impressão.</div></div></md-input-container></div></div><div layout=\"column\" flex=\"30\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Filtro por ano</b> <small><b>Selecione</b> o ano (de acordo com a data de vencimento)</small></div></div><div flex=\"\" layout=\"row\" class=\"md-padding\"><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Ano</label><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-select name=\"year_list\" ng-model=\"vm.filter_year\" required=\"\" aria-label=\"ano\"><md-option ng-repeat=\"year in vm.years\" ng-value=\"year.id\">{{year.name}}</md-option></md-select></md-input-container></div></div><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Geração por serviço</b> <small>Selecionando irá imprimir o carnê de todas as pessoas inscritas no serviço</small></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\" style=\"margin-top: 15px;\"><md-autocomplete flex=\"\" ng-disabled=\"vm.product_group_id !== null || vm.product_ids.length > 0\" md-no-cache=\"true\" md-selected-item=\"vm.filter_service\" md-min-length=\"0\" md-selected-item-change=\"vm.selectedServiceChange(item)\" md-search-text=\"searchService\" md-items=\"item in vm.getAllServices(searchService)\" md-item-text=\"item.name\" md-floating-label=\"Digite o nome do serviço\" md-delay=\"500\"><md-item-template><span md-highlight-text=\"searchService\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Serviço não encontrado.</md-not-found></md-autocomplete></div></div></div><div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"50\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Geração por pessoa (Opcional)</b> <small><br>Abaixo você pode escolher qual o pessoa deseja imprimir o carnê</small></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\" style=\"margin-top: 16px;\"><md-autocomplete flex=\"\" md-no-cache=\"true\" md-selected-item=\"vm.person\" md-min-length=\"0\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-search-text=\"searchText\" md-items=\"item in vm.getBankSlipPerson(searchText)\" md-item-text=\"item.name\" md-floating-label=\"Digite o nome da pessoa\" md-delay=\"500\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Pessoa não encontrada.</md-not-found></md-autocomplete></div></div><div layout=\"column\" flex=\"50\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Curso e Turma</b> <small><b>ATENÇÃO</b> o periodo letívo selecionado no educacional interfere na busca de títulos utilizando as opções abaixo. Período letivo selecionado: <b>{{vm.school_period.selected.name}}</b>. Essa opção irá imprimir o carnê de todas as pessoas matriculadas no curso/turma</small></div></div><div flex=\"\" layout=\"row\" class=\"md-padding\"><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Curso</label><md-icon md-font-icon=\"icon-group\"></md-icon><md-select name=\"group_service_list\" ng-model=\"vm.product_group_id\" ng-disabled=\"vm.filter_service_id !== null\" aria-label=\"Curso\" md-on-open=\"vm.allProductGroups()\" placeholder=\"Curso\" ng-change=\"vm.getProductsByGroup(vm.product_group_id)\"><md-optgroup label=\"Curso\"><md-option ng-repeat=\"product_group in vm.product_groups track by $index\" ng-value=\"product_group.id\">{{product_group.name}}</md-option></md-optgroup></md-select><div ng-messages=\"bankslipform.group_service_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um grupo de serviço.</div></div></md-input-container><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Turma</label><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><md-select name=\"service_list\" ng-model=\"vm.product_ids\" ng-disabled=\"vm.filter_service_id !== null\" multiple=\"\" aria-label=\"turmas\"><md-optgroup label=\"Turmas\"><md-option ng-repeat=\"product in vm.products track by $index\" ng-value=\"product.id\">{{product.name}}</md-option></md-optgroup></md-select><div ng-messages=\"bankslipform.service_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um ou mais turmas.</div></div></md-input-container></div></div></div><md-input-container><md-checkbox ng-model=\"vm.without_isented\">Não imprimir carnês isentos</md-checkbox></md-input-container></div><md-dialog-actions layout=\"row\" layout-align=\"center center\" style=\"background-color: whitesmoke; margin-top: 20px;\"><md-button class=\"md-raised md-primary\" style=\"padding: 5px;\" ng-disabled=\"vm.filter_service_id === null && vm.product_ids.length <= 0 && vm.person === null\" ng-click=\"vm.generatePaymentBooks()\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>Gerar Carnês</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/payment-plan/edit-document/edit-document.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ui-sref=\"private.finance.product\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-message-text\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" ng-if=\"!vm.form.document.id\">{{vm.service.name}}</span></div></div></md-toolbar><md-content style=\"background-color: whitesmoke !important;width: 80%; margin: 5px auto\"><md-card class=\"md-padding\" style=\"min-height: 500px;\"><form name=\"formInformativeReport\" ng-submit=\"vm.submit(formInformativeReport, vm.form.document)\" novalidate=\"\"><div layout=\"row\" ng-if=\"!vm.is_wysiwyg\"><div flex=\"60\"><strong class=\"group-field\"><small>Editor de conteúdo:</small></strong><div layout=\"row\" style=\"margin-top: 15px\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"title\" ng-model=\"vm.form.document.title\" placeholder=\"Título\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" ng-disabled=\"vm.form.document.type === \'4\'\"><textarea name=\"content\" placeholder=\"Conteúdo\" ng-model=\"vm.form.document.content\" rows=\"6\" ng-disabled=\"vm.form.document.type === \'4\'\"></textarea></md-input-container></div></div></div><md-card-content layout=\"column\" ng-if=\"vm.is_wysiwyg\" flex=\"\"><div flex=\"\"><div layout=\"row\"><md-input-container flex=\"\" style=\"margin-top: 25px\" class=\"md-input-has-placeholder\" ng-disabled=\"vm.form.document.type === \'4\'\"><input type=\"text\" name=\"title\" ng-model=\"vm.form.document.title\" placeholder=\"Título\"></md-input-container></div><textarea class=\"text_area\" name=\"html_editor\" ui-tinymce=\"vm.tinymceOptions\" id=\"textarea_html\" ng-model=\"vm.form.document.content\" ng-change=\"vm.changeHandler()\" ng-click=\"vm.setVariable()\"></textarea><div flex=\"\"><div layout=\"row\" layout-align=\"space-between center\"><div><label>Recursos disponíveis:</label><md-input-container flex=\"100\"><md-select name=\"variables\" ng-model=\"variableSelected\" ng-change=\"vm.setVariable(variableSelected, formInformativeReport)\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchVariable\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"item\" ng-repeat=\"item in vm.variables | filter: searchVariable\">{{item.presentation}}</md-option></md-select></md-input-container></div><div><md-input-container><md-checkbox ng-model=\"vm.form.document.print_logo\">Imprime com a logomarca</md-checkbox></md-input-container></div></div></div></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-primary\">Salvar</md-button></md-card-actions></form></md-card></md-content></div>");
$templateCache.put("app/finance/payment-plan/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-view-carousel\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"PAYMENT_PLAN.TITLE\"></span></div></div></md-toolbar><md-card class=\"md-padding\"><div class=\"table-float-button\"><md-input-container style=\"margin-top: 10px\"><md-checkbox ng-model=\"vm.show_inactive\" ng-change=\"vm.getAllPaymentPlan()\">Mostrar inativos</md-checkbox></md-input-container><a4-grid-dic-data bind=\"vm.grid\" on-paginate=\"vm.getAllPaymentPlan\" on-click-item=\"vm.openSideEdit(item)\" on-delete=\"vm.delete(index)\" policies=\"{show:\'config_fin\', cud:\'config_fin\'}\" on-click-actions=\"vm.clickOption(item, option)\" fields-schema=\"app/finance/payment-plan/grid.json\"></a4-grid-dic-data></div></md-card></div>");
$templateCache.put("app/finance/payment-plan/views/payment-plan-associate-modal.html","<md-dialog aria-label=\"Associação de plano de pagamento\" md-theme=\"finance\" style=\"width: 1400px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submit()\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-swap-horizontal\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Associação de plano de pagamento</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b ng-if=\"vm.type == 0\">Associação com turmas</b> <b ng-if=\"vm.type !== 0\">Associação com serviços</b> <small ng-if=\"vm.type == 0\">Selecione as turmas que deseja associar e preencha os dados da associação <b>(O período letivo selecionado no sistema pedagógico influencia na busca das turmas)</b></small> <small ng-if=\"vm.type !== 0\">Selecione os serviços que deseja associar e preencha os dados da associação</small></div></div><div layout=\"row\" ng-if=\"vm.type === 0\" style=\"width: 100%;\"></div><md-table-container><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"vm.selected_products\" md-progress=\"vm.promise\" md-row-select=\"\" multiple=\"\"><thead md-head=\"\"><tr><th colspan=\"3\">Selecionar todos da página</th><th>Associar documento</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"product\" md-select-id=\"id\" ng-repeat=\"product in vm.products.data\"><td>{{ product.name }}</td><td><date-picker ng-model=\"product.date_first\" placeholder=\"Data de início\" ng-click=\"vm.add(product)\"></date-picker></td><td><md-input-container><label>Valor</label><input ui-money-mask=\"2\" ng-model=\"product.value\" ng-change=\"vm.add(product)\"></md-input-container></td><td><div layout=\"row\" style=\"width: 100%;\"><md-input-container style=\"width: 100%;\"><md-select ng-model=\"product.document_id\"><md-option ng-repeat=\"document in vm.documents\" ng-value=\"document.id\">{{document.title}}</md-option><p ng-if=\"vm.documents == null\">Sem serviços vinculados</p></md-select></md-input-container></div></td></tr></tbody></table></md-table-container></div><md-table-pagination flex=\"\" style=\"border-top: none\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.products.per_page\" md-page=\"vm.products.current_page\" md-on-paginate=\"vm.paginate\" md-limit-options=\"[5, 10]\" md-page-select=\"\" md-total=\"{{vm.products.total}}\"></md-table-pagination></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"submit\" class=\"md-primary md-raised\" layout=\"row\" ng-disabled=\"form.$invalid || vm.show_loading\"><md-progress-circular ng-disabled=\"!vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"95\">Associar</span></md-button><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.close()\">Voltar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/payment-plan/views/payment-plan-discounts.html","<md-dialog aria-label=\"Descontos Individuais\" md-theme=\"{{vm.theme}}\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submitDiscounts(vm.discounts, paymentplandiscounts)\" name=\"paymentplandiscountsformfinance\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Descontos em grupo <span>{{vm.payment_plan_name}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-if=\"!vm.is_first\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><md-table-container><a4-discounts-grid discounts=\"vm.discounts\" delete-function=\"vm.removeItem(discount_id)\" show-delete=\"true\"></a4-discounts-grid></md-table-container><md-button class=\"md-primary\" aria-label=\"Novo Desconto\" style=\"margin-left: 15px\" ng-click=\"vm.createNewIndivialDiscount()\">Adicionar desconto ao plano<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-dialog-content></form></md-dialog>");
$templateCache.put("app/finance/person/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"PERSON.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"PERSON.TITLE_PERSON\"></span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'PERSON.SEARCH\' | translate }}\" type=\"text\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.listAll(vm.search)\" ng-model=\"vm.search\" translate=\"\" translate-attr-placeholder=\"Pesquisar\"></md-input-container></div></md-toolbar><md-content style=\"background-color: whitesmoke !important\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Todos\"><div ng-if=\"vm.selected_tab == 0\"><a4-persons is-educational=\"false\"></a4-persons></div></md-tab><md-tab label=\"Fornecedores\" md-on-select=\"vm.getAllPersons()\"><div ng-if=\"vm.selected_tab == 1\"><a4-persons is-educational=\"false\" role=\"1\"></a4-persons></div></md-tab><md-tab label=\"Colaboradores\" md-on-select=\"vm.getAllPersons()\"><div ng-if=\"vm.selected_tab == 2\"><a4-persons is-educational=\"false\" role=\"2\"></a4-persons></div></md-tab><md-tab label=\"Alunos\" md-on-select=\"vm.getAllPersons()\"><div ng-if=\"vm.selected_tab == 3\"><a4-persons is-educational=\"false\" role=\"3\"></a4-persons></div></md-tab><md-tab label=\"Clientes\" md-on-select=\"vm.getAllPersons()\"><md-card ng-if=\"vm.selected_tab == 4\"><a4-persons is-educational=\"false\" role=\"4\"></a4-persons></md-card></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/finance/person/views/select-type.html","<md-toolbar md-theme=\"finance\"><div class=\"md-toolbar-tools\"><h2 translate=\"PERSON.SELECT_TYPE_PERSON\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.openAsideSelectType($event, \'sidenav-select\')\"><md-icon translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><i class=\"material-icons\">close</i></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-align=\"center center\" md-theme=\"finance\"><md-list flex=\"\" layout=\"row\" layout-align=\"center center\"><md-list-item ng-repeat=\"type in vm.scope.types\"><div><md-button style=\"padding: 40px; box-shadow: 1px 3px 15px #ccc; min-width:145px;\" class=\"md-grid-item-content\" ng-click=\"vm.answer(type.value)\"><md-icon><i class=\"material-icons\">{{ type.icon }}</i></md-icon><div class=\"md-grid-text\">{{ type.name }}</div></md-button></div></md-list-item></md-list></div>");
$templateCache.put("app/finance/products/views/course-product.html","<md-card layout-padding=\"\"><md-table-container style=\"padding-bottom: 0;\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.tableItemsSelected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Nome</span></th><th md-column=\"\" style=\"text-align: right\"><span>Ações</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"group in vm.product_group.data\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\">{{group.name}}</td><td md-cell=\"\" flex=\"\" style=\"text-align: right\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.editProductGroup(group)\" ng-disabled=\"group.disabled\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>{{group.messageEdit}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.removeGroup(group)\" ng-disabled=\"group.disabled\"><md-icon md-font-icon=\"icon-trash\"></md-icon>{{group.messageRemove}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.product_group.per_page\" md-page=\"vm.product_group.current_page\" md-limit-options=\"[15, 25, 50]\" md-total=\"{{vm.product_group.total}}\" md-on-paginate=\"vm.all\" md-page-select=\"\"></md-table-pagination></md-card>");
$templateCache.put("app/finance/products/views/form.html","<md-toolbar><div layout=\"row\"><h1 class=\"md-toolbar-tools\" ng-show=\"vm.currentItem.id != null\">{{vm.currentItem.name}}</h1><h1 class=\"md-toolbar-tools\" ng-show=\"vm.currentItem.id == null\">Criar novo</h1><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Close dialog\" translate=\"\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"form-wrapper\" flex=\"\" style=\"width: 700px\"><form action=\"javascript:;\" name=\"formProduct\" class=\"form-horizontal product-form\" novalidate=\"\" ng-submit=\"vm.submit(formProduct, vm.currentItem)\"><input type=\"hidden\" name=\"_token\" value=\"{{ csrf_token()}}\"><md-toolbar ng-show=\"vm.locked\" style=\"margin-bottom: 10px;\"><h5 class=\"md-toolbar-tools\">Atenção! Você não pode utilizar dois planos de pagamento iguais.</h5></md-toolbar><md-content layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input ng-disabled=\"vm.product.disabled\" placeholder=\"Nome\" ng-model=\"vm.currentItem.name\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input ng-model=\"vm.currentItem.price\" ui-money-mask=\"2\" placeholder=\"Digite um valor\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.currentItem.type\" placeholder=\"Tipo de serviço\" required=\"\" ng-disabled=\"vm.currentItem.type === 2\"><md-option ng-value=\"type.id\" ng-repeat=\"type in vm.product_types\" ng-if=\"vm.currentItem.type !== 2\">{{ type.name }}</md-option><md-option ng-value=\"2\" ng-if=\"vm.currentItem.type === 2 || vm.currentItem.type === null || vm.currentItem.type === undefined\">Taxa de pré-matrícula</md-option></md-select></md-input-container></md-content><md-content layout-gt-sm=\"row\"><md-autocomplete flex=\"\" required=\"\" md-input-name=\"autoCategories\" md-selected-item=\"vm.selectedCategory\" md-no-cache=\"true\" md-search-text-change=\"vm.searchTextChange(vm.searchCategory)\" md-search-text=\"vm.searchCategory\" md-selected-item-change=\"vm.currentItem.bill_category_id = item\" md-items=\"item in vm.querySearchCategory(vm.searchCategory)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Categoria\"><md-item-template><span class=\"item-title\"><span><strong>{{item.name}}</strong></span></span> <span class=\"item-metadata\"><span>{{item.path}}</span></span></md-item-template><div ng-messages=\"formProduct.autoCategories.$error\" ng-if=\"formProduct.autoCategories.$touched\"><div ng-message=\"required\">{{ \'CATEGORY_IS_REQUIRED\' | translate }}</div><div ng-message=\"md-require-match\">{{ \'CATEGORY_NOT_EXISTS\' | translate }}</div></div><md-not-found>{{ \'CATEGORY_NOT_FOUND\' | translate }}</md-not-found></md-autocomplete><md-input-container class=\"md-block\" style=\"margin-right: 3px;\"><md-checkbox flex=\"\" ng-model=\"vm.currentItem.is_inactive\">Inativo</md-checkbox></md-input-container><md-input-container class=\"md-block\"><md-checkbox flex=\"\" ng-model=\"vm.currentItem.is_included_tax_declaration\">Declarar imposto de renda</md-checkbox></md-input-container></md-content><md-content layout-gt-sm=\"row\"><md-autocomplete ng-disabled=\"vm.product.disabled\" flex=\"\" required=\"\" md-input-name=\"productgroups\" md-selected-item=\"vm.selectedGroup\" md-no-cache=\"true\" md-search-text-change=\"vm.searchTextChange(vm.searchProductGroup)\" md-search-text=\"vm.searchProductGroup\" md-selected-item-change=\"vm.currentItem.product_group_id = item\" md-items=\"item in vm.querySearchProductGroups(vm.searchProductGroup)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Agrupamento\"><md-item-template><span class=\"item-title\"><span><strong>{{item.name}}</strong></span></span></md-item-template><div ng-messages=\"formProduct.productgroups.$error\" ng-if=\"formProduct.productgroups.$touched\"><div ng-message=\"required\">{{ \'PRODUCT_GROUP_IS_REQUIRED\' | translate }}</div><div ng-message=\"md-require-match\">{{ \'PRODUCT_GROUP_NOT_EXISTS\' | translate }}</div></div><md-not-found>{{ \'PRODUCT_GROUP_NOT_FOUND\' | translate }}</md-not-found></md-autocomplete></md-content><md-input-container class=\"md-block\" ng-if=\"vm.currentItem.external_id == null\"><md-checkbox ng-model=\"vm.currentItem.withoutCompany\">Serviço para todas as empresas</md-checkbox></md-input-container><selectgrid list=\"vm.selectedPaymentPlans\" paymentplans=\"vm.allPaymentPlans\" documents=\"vm.documents\"></selectgrid><md-divider></md-divider><div class=\"row\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"vm.locked || (formProduct.$dirty && formProduct.$invalid)\">Salvar</md-button></div></form></div>");
$templateCache.put("app/finance/products/views/grouped.html","<md-card layout-padding=\"\"><md-table-container style=\"padding-bottom: 0;\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.tableItemsSelected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Nome</span></th><th md-column=\"\" style=\"text-align: right\"><span>Ações</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"group in vm.product_group.data\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\">{{group.name}}</td><td md-cell=\"\" flex=\"\" style=\"text-align: right\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.editProductGroup(group)\" ng-disabled=\"group.disabled\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>{{group.messageEdit}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.removeGroup(group)\" ng-disabled=\"group.disabled\"><md-icon md-font-icon=\"icon-trash\"></md-icon>{{group.messageRemove}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.product_group.per_page\" md-page=\"vm.product_group.current_page\" md-limit-options=\"[15, 25, 50]\" md-total=\"{{vm.product_group.total}}\" md-on-paginate=\"vm.all\" md-page-select=\"\"></md-table-pagination></md-card>");
$templateCache.put("app/finance/products/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cube\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{\'TITLE\' | translate}}</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.getAllProducts(vm.search)\"></md-input-container></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected\"><md-tab label=\"Serviços\" md-on-select=\"vm.init()\"><md-content ng-if=\"vm.selected == 0\" style=\"background-color: whitesmoke !important;\"><md-card layout-padding=\"\"><div layout=\"row\" flex=\"\" style=\"margin-bottom: -70px;\"><md-input-container flex=\"20\"><md-checkbox ng-model=\"vm.show_inactive_products\" ng-change=\"vm.getAllProducts()\">Mostrar serviços inativos</md-checkbox></md-input-container></div><div style=\"margin-top: 45px\" class=\"table-float-button\"><a4-tree-grid tree-data=\"vm.allProducts\" col-defs=\"vm.col_defs_services\" expand-on=\"vm.expanding_property\" expand-level=\"1\" icon-leaf=\'row.branch.children.length <= 0 && row.level == 2 ? \"no-icon\" : \"no-icon\"\' icon-expand=\'row.branch.children.length > 0 && !row.branch.expanded ? \"icon-chevron-right\" : \"icon-chevron-down\"\' icon-collapse=\'row.branch.children.length > 0 && row.branch.expanded ? \"icon-chevron-down\" : \"icon-chevron-right\"\'></a4-tree-grid></div></md-card></md-content></md-tab><md-tab label=\"Agrupamentos\"><md-content ng-if=\"vm.selected == 1\" ui-view=\"grouped\" style=\"background-color: whitesmoke !important;\" class=\"table-float-button\"></md-content></md-tab><md-tab label=\"Turmas\" md-on-select=\"vm.getAllProducts()\"><md-content ng-if=\"vm.selected == 2\"><md-card layout-padding=\"\"><div layout=\"row\" flex=\"\" style=\"margin-bottom: -70px;\"><md-input-container flex=\"20\"><md-checkbox ng-model=\"vm.show_inactive_products\" ng-change=\"vm.getAllProducts()\">Mostrar turmas inativas</md-checkbox></md-input-container></div><div style=\"margin-top: 45px\"><a4-tree-grid tree-data=\"vm.allProducts\" col-defs=\"vm.col_defs_groups\" expand-on=\"vm.expanding_property\" expand-level=\"1\" class-style=\"\'products\'\" icon-leaf=\'row.branch.children.length <= 0 && row.level == 2 ? \"no-icon\" : \"no-icon\"\' icon-expand=\'row.branch.children.length > 0 && !row.branch.expanded ? \"icon-chevron-right\" : \"icon-chevron-down\"\' icon-collapse=\'row.branch.children.length > 0 && row.branch.expanded ? \"icon-chevron-down\" : \"icon-chevron-right\"\'></a4-tree-grid></div></md-card></md-content></md-tab></md-tabs></div>");
$templateCache.put("app/finance/products/views/vinculate-service-modal.html","<md-dialog aria-label=\"Vinculação de serviço\" md-theme=\"finance\" style=\"width: 1400px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submit()\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-arrow-all\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Vinculação de serviço - {{vm.item_name}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\" layout-align=\"start center\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b ng-if=\"vm.option == 1\">Vincular este serviço a turmas</b> <b ng-if=\"vm.option !== 1\">Vincular serviço</b> <small ng-if=\"vm.option == 1\">Selecione as turmas para quais este serviço será vinculado</small> <small ng-if=\"vm.option !== 1\">Os serviços selecionados serão vinculados a turma</small></div><div><md-icon md-font-icon=\"icon-help\"><md-tooltip md-direction=\"left\">ATENÇÃO: Se definir uma vinculação como opcional, no momento da matrícula o usuário irá decidir se o contrato vinculado será criado ou não.</md-tooltip></md-icon></div></div><md-table-container><table md-table=\"\" ng-model=\"vm.selected_products\" md-progress=\"vm.promise\" md-row-select=\"\" multiple=\"\" style=\"margin-top: 5px;\"><thead md-head=\"\"><tr><th md-column=\"\">Nome</th><th md-column=\"\">Data de início</th><th md-column=\"\" style=\"text-align: right\">Valor</th><th md-column=\"\" style=\"text-align: right\">Opcional?</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"product\" md-select-id=\"id\" ng-repeat=\"product in vm.products.data track by product.id\"><td class=\"md-cell\">{{ product.product_name }} - {{ product.payment_plan_name }}</td><td class=\"md-cell\">{{product.date_first}}</td><td class=\"md-cell\" style=\"text-align: right\">{{product.price | currency}}</td><td class=\"md-cell\"><md-switch ng-model=\"product.is_mandatory\" style=\"margin-left: 50%\" ng-change=\"vm.addItem(product)\"></md-switch></td></tr></tbody></table></md-table-container></div><md-table-pagination flex=\"\" style=\"border-top: none\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.products.per_page\" md-page=\"vm.products.current_page\" md-on-paginate=\"vm.paginate\" md-limit-options=\"[5, 10, 15, 20]\" md-total=\"{{vm.products.total}}\"></md-table-pagination></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-raised\" ng-click=\"vm.close()\">Voltar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" layout=\"row\" ng-disabled=\"form.$invalid || vm.show_loading\"><md-progress-circular ng-disabled=\"!vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"95\">Vincular</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/reports/views/index.html","<md-content id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex=\"\" ng-style=\"{height: (vm.windowHeight)}\"><div id=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1>Relatórios</h1>{{iframeHeight}}<div class=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ng-if=\"board.policy\"><div ui-sref=\"{{board.state}}({ school_period_id: {{vm.school_period.id}} })\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"{{board.icon}}\" class=\"icon s64\"></md-icon><md-tooltip md-direction=\"top\">{{board.description}}</md-tooltip><div class=\"board-name\">{{board.name}}</div></div></div></div></div></md-content>");
$templateCache.put("app/finance/reports/views/report-page.html","<div id=\"page-material-table\" class=\"md-accent-bg page-layout simple left-sidenav inner-sidenav\" ui-view=\"reports\" style=\"background-color: whitesmoke\"></div>");
$templateCache.put("app/finance/settings/views/company-configuration.html","<md-dialog class=\"dialog-nfse\" aria-label=\"New Task\" md-theme=\"finance\"><form name=\"roleForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Configurações</span></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\"><div flex=\"\"><div layout=\"row\"><md-input-container class=\"md-icon-float md-block\" flex=\"\"><label>Razão social</label> <input aria-label=\"Nome\" ng-value=\"vm.company.name\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" flex=\"\"><label>CNPJ</label> <input aria-label=\"CNPJ\" ng-model=\"vm.company.national_id_number\" type=\"text\" ui-br-cnpj-mask=\"\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-icon-float md-block\" flex=\"50\"><label>Inscrição municipal</label> <input aria-label=\"Inscrição municipal\" ng-value=\"vm.company.municipal_registration_number\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" flex=\"10\"><label>DDD</label> <input aria-label=\"DDD\" ng-value=\"vm.company.telephone_area_code\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" flex=\"40\"><label>Telefone</label> <input aria-label=\"Telefone\" ng-value=\"vm.company.telephone_number\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\"><div flex=\"\"><md-checkbox ng-model=\"vm.company.nfse_is_optante_simples\">Optante do Simples Nacional?</md-checkbox></div><div flex=\"\"><md-checkbox ng-model=\"vm.company.nfse_is_incentivador_cultural\">Incentivador Cultural?</md-checkbox></div></div><div layout=\"row\"><md-input-container flex=\"\"><label>Operação</label><md-select ng-model=\"vm.company.nfse_operacao\"><md-option ng-repeat=\"op in vm.operacao\" ng-value=\"op.id\">{{op.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Tributação</label><md-select ng-model=\"vm.company.nfse_tributacao\"><md-option ng-repeat=\"tr in vm.tributacao\" ng-value=\"tr.id\">{{tr.name}}</md-option></md-select></md-input-container></div><hr><div layout=\"column\"><div>Como os descontos afetam o valor da nota fiscal?</div><hr><div><md-radio-group ng-model=\"vm.company.nfse_comportamento_desconto\"><md-radio-button value=\"0\" class=\"md-primary\">Não abate os descontos do valor da nota fiscal</md-radio-button><br><md-radio-button value=\"1\">Abate apenas o desconto fixo</md-radio-button><br><md-radio-button value=\"2\">Abate o desconto fixo, condicional e promocional</md-radio-button></md-radio-group></div></div><hr><div layout=\"column\"><div>Qual a data a considerar para a emissão da nota?</div><hr><div><md-radio-group ng-model=\"vm.company.nfse_fato_competencia\"><md-radio-button value=\"V\" class=\"md-primary\">Data de vencimento (Regime de competência)</md-radio-button><br><md-radio-button value=\"P\">Data de pagamento (Regime de caixa)</md-radio-button><br></md-radio-group></div></div><hr><div layout=\"row\"><date-picker ng-model=\"vm.company.external_statement_initial_date\" placeholder=\"Data inicial de exibição dos boletos na ficha financeira externa\" style=\"width: 100%;\"></date-picker></div><hr><div layout=\"row\"><div flex=\"\" ng-if=\"vm.company.nfse_certificado_a1 != null\"><div>Certificado A1</div><md-input-container class=\"md-icon-float md-block\" flex=\"\" style=\"margin: 0\"><input type=\"text\" aria-label=\"Certificado A1\" ng-disabled=\"true\" ng-value=\"vm.company.nfse_certificado_a1.split(\'/\')[3]\"></md-input-container></div><div flex=\"\"><div>Importar certificado A1</div><md-input-container class=\"md-icon-float md-block\" flex=\"\" style=\"margin: 0\"><input name=\"myFile\" type=\"file\" accept=\".pfx\" aria-label=\"Importar certificado A1\" ng-model=\"vm.company.nfse_certificado_a1\" base-sixty-four-input=\"\"></md-input-container></div></div><hr><div layout=\"row\"><div flex=\"\"><div>Senha do certificado A1</div><md-input-container class=\"md-icon-float md-block\" flex=\"\" style=\"margin: 0\"><input type=\"password\" aria-label=\"Senha do certificado A1\" ng-model=\"vm.company.nfse_certificado_senha\"></md-input-container></div><div flex=\"\" ng-if=\"vm.company.nfse_certificado_validade != null\"><div>Data de validade</div><md-input-container class=\"md-icon-float md-block\" flex=\"\" style=\"margin: 0\"><input type=\"text\" ng-value=\"vm.company.nfse_certificado_validade | date:\'dd/MM/yyyy\'\" aria-label=\"Certificado A1 Validade\" ng-disabled=\"true\"></md-input-container></div></div><hr></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveCompanyConfig(vm.company)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/settings/views/index.html","<md-content id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex=\"\"><div id=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1 translate=\"SETTINGS.TITLE\">Configurações</h1><div class=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ng-if=\"board.policy\"><div ui-sref=\"{{board.state}}\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"{{board.icon}}\" class=\"icon s64\"></md-icon><div class=\"board-name\">{{board.name}}</div></div></div><div class=\"board-list-item\" policy-access=\"config_fin\"><div ng-click=\"vm.openConfigurationForCompany(event)\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-cog-box\" class=\"icon s64\"></md-icon><div class=\"board-name\">Configuração de Empresa</div></div></div><div class=\"board-list-item\" policy-access=\"config_fin\"><div ng-click=\"vm.openEmailConfig()\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-email\" class=\"icon s64\"></md-icon><div class=\"board-name\">Configuração de e-mail</div></div></div><div class=\"board-list-item\" policy-access=\"config_fin\"><div ng-click=\"vm.openRateSettings(event)\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-cog-box\" class=\"icon s64\"></md-icon><div class=\"board-name\">Configuração de Aliquota</div></div></div></div></div></md-content>");
$templateCache.put("app/finance/settings/views/rate_settings.html","<md-dialog class=\"dialog-nfse-rate\" aria-label=\"New Task\" md-theme=\"finance\" style=\"width: 1200px; max-width: 1200px; margin-left: 80px;\"><form name=\"roleForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Configurações de aliquota</span></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\"><md-table-container><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th>Serviço</th><th>Aliquota</th><th>CNAE</th><th>CTISS</th><th>Item</th><th>Class.Trib.</th><th>NBS</th><th>Ind.Op.</th><th>Descrição</th></tr></thead><tbody><tr ng-repeat=\"item in vm.products\"><td>{{item.name}}</td><td><md-input-container class=\"md-icon-float md-block\" flex=\"\"><input aria-label=\"Aliquota\" ui-percentage-mask=\"\" ui-percentage-value=\"\" ng-model=\"item.nfse_aliquota\" type=\"text\"></md-input-container></td><td><md-input-container class=\"md-icon-float md-block\" flex=\"\"><input aria-label=\"Cnae\" ng-model=\"item.nfse_cnae\" type=\"text\"></md-input-container></td><td><md-input-container class=\"md-icon-float md-block\" flex=\"\"><input aria-label=\"Cnae\" ng-model=\"item.nfse_ctiss\" type=\"text\"></md-input-container></td><td><md-input-container class=\"md-icon-float md-block\" flex=\"\"><input aria-label=\"Codigo Item\" ng-model=\"item.nfse_codigo_item\" maxlength=\"5\" type=\"text\"></md-input-container></td><td><md-input-container class=\"md-icon-float md-block\" flex=\"\"><input aria-label=\"Classificação Tributária\" ng-model=\"item.nfse_classificacao_tributaria\" maxlength=\"6\" type=\"text\"></md-input-container></td><td><md-input-container class=\"md-icon-float md-block\" flex=\"\"><input aria-label=\"Nome.Bras.Serviços (NBS)\" ng-model=\"item.nfse_nbs\" maxlength=\"9\" type=\"text\"></md-input-container></td><td><md-input-container class=\"md-icon-float md-block\" flex=\"\"><input aria-label=\"Indicador da Operação\" ng-model=\"item.nfse_indop\" maxlength=\"6\" type=\"text\"></md-input-container></td><td><md-input-container class=\"md-icon-float md-block\" flex=\"\"><textarea aria-label=\"Descrição\" ng-model=\"item.nfse_descricao\" type=\"text\"></textarea></md-input-container></td></tr></tbody></table></md-table-container></div><md-button style=\"width: 100%; padding: 5px; background-color: whitesmoke; text-align: center;\" ng-click=\"vm.paginate()\" layout=\"row\" layout-align=\"center center\"><div><md-icon md-font-icon=\"icon-plus\" ng-if=\"!vm.show_loader\"></md-icon><md-progress-circular md-diameter=\"15px\" ng-if=\"vm.show_loader\"></md-progress-circular></div>Carregar mais serviços</md-button></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveAliquotConfig(vm.products)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\" style=\"display: inline-block; width: auto; min-width: 96px;\">{{\"ROLES.SAVE\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\" style=\"display: inline-block; margin-left: 8px;\">{{\"ROLES.CANCEL\" | translate}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/process/location/views/location.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Gerenciamento de locais</span></div></div></md-toolbar><a4-crud-table items=\"vm.locations\" columns=\"vm.columns\" create-item=\"vm.createLocation(item)\" theme=\"\'process\'\" save-item=\"vm.editLocation(item)\"></a4-crud-table></div>");
$templateCache.put("app/process/process-crud/card/card-dialog.html","<md-dialog class=\"card-dialog\" aria-label=\"Card Dialog\" ng-cloak=\"\" md-theme=\"process\"><form name=\"process_form\"><md-toolbar><div class=\"md-toolbar-tools\">{{vm.card.id !== null ? \'Editar solicitação\' : \'Nova solicitação\'}} <span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-if=\"((vm.card.process_type_id == 4) || (vm.card.process_type_id == 6))\" ng-hide=\"vm.card.id == null || vm.checkPolicies(\'process_to_solve\')\" ng-click=\"vm.printList()\"><md-icon>print</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate=\"\" translate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 100px;margin-bottom: 100px\" ng-if=\"vm.show_loader\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><div ng-if=\"!vm.show_loader\"><div class=\"sections\" layout=\"row\" flex=\"\"><div class=\"section\" flex=\"\"><div layout=\"column\" flex=\"\"><div layout=\"row\" layout-align=\"start center\"><div class=\"description\" flex=\"\"><div class=\"select2-padding\" layout=\"column\" flex=\"\"><label for=\"select-process-type\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Tipo de solicitação *</span></label><select2 ng-model=\"vm.card.process_type_id\" ng-disabled=\"vm.card.id !== null\" ng-change=\"vm.getProcessTypeTypes(vm.card.process_type_id)\" s2-options=\"val.id as val.name for val in vm.process_types\" required=\"\" id=\"select-process-type\"></select2></div></div></div></div><div class=\"description\" layout=\"column\" flex=\"\"><div layout=\"column\" flex=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label>Descrição</label> <textarea ng-model=\"vm.card.description\" columns=\"1\" required=\"\" ng-disabled=\"!vm.do_edit\"></textarea></md-input-container></div></div><div class=\"description\" style=\"font-size: 15px; color: rgba(0,0,0,0.38)\">Atenção: caso a descrição comece com um hifen(-) ela será considerada uma lista e aparecerá na lista de itens quando impressa</div><div class=\"description\" layout=\"column\" flex=\"\" ng-if=\"(vm.card.process_type_id == 2 || vm.card.process_type_id == 3) || (vm.process_type.include_qty || vm.process_type.include_color)\"><div layout=\"row\" flex=\"\"><div class=\"select2-padding\" layout=\"column\" flex=\"\" ng-if=\"vm.card.process_type_id == 2 || vm.card.process_type_id == 3\"><label for=\"select-process-type-types\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Tipo *</span></label><select2 ng-model=\"vm.card.process_type_types_id\" required=\"\" ng-disabled=\"!vm.do_edit\" s2-options=\"val.id as val.name for val in vm.process_type_types\" id=\"select-process-type-types\"></select2></div><div flex=\"50\" ng-if=\"vm.process_type.include_qty || vm.process_type.include_color\" layout=\"row\"><md-input-container class=\"md-input-has-placeholder\" flex=\"30\" ng-if=\"vm.process_type.include_qty\"><input type=\"number\" ng-model=\"vm.card.qty\" placeholder=\"Quantidade\" required=\"\" ng-disabled=\"!vm.do_edit\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\" style=\"margin-bottom: 5px;\" ng-if=\"vm.process_type.include_color\"><md-radio-group ng-model=\"vm.card.color\" layout=\"row\" ng-disabled=\"!vm.do_edit\" ng-required=\"vm.process_type.include_color\"><md-radio-button class=\"md-primary\" ng-value=\"\'Preto e branco\'\">Preto e branco</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"\'Colorido\'\">Colorido</md-radio-button></md-radio-group></md-input-container></div></div></div><div class=\"description\" layout=\"column\" flex=\"\" ng-if=\"vm.process_type.include_group && vm.profile === 7\"><div class=\"select2-padding\" layout=\"column\" flex=\"50\" ng-if=\"vm.card_type == \'crud\'\"><label for=\"select-group\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Turma</span></label><select2 ng-model=\"vm.card.group\" ng-disabled=\"!vm.do_edit\" s2-options=\"val.group as val.group_name for val in vm.groups\" id=\"select-group\"></select2></div><md-input-container class=\"md-input-has-placeholder\" flex=\"30\" ng-if=\"vm.card_type == \'to_solve\'\"><input ng-model=\"vm.card.group_name\" placeholder=\"Turma\" ng-disabled=\"true\"></md-input-container></div><div class=\"description\" layout=\"row\" flex=\"\" ng-if=\"vm.process_type.include_location\"><div layout=\"column\" flex=\"\"><div class=\"select2-padding\" layout=\"column\" flex=\"\"><label for=\"select-location\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Local</span></label><select2 ng-model=\"vm.card.location_id\" ng-disabled=\"!vm.do_edit\" s2-options=\"val.id as val.name for val in vm.locations\" id=\"select-location\"></select2></div></div></div><div class=\"description\" layout=\"row\" flex=\"\"><div layout=\"row\" flex=\"\"><date-picker placeholder=\"Data\" flex=\"\" name=\"second_due_date\" disabled=\"!vm.do_edit\" min-date=\"vm.date_limit\" ng-change=\"vm.getHoursUnavailable()\" required=\"true\" ng-model=\"vm.card.date\" ng-if=\"vm.process_type !== null;\"></date-picker><div ng-if=\"vm.process_type.include_time_range\" layout=\"row\" flex=\"40\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><md-select ng-model=\"vm.card.time\" placeholder=\"Hora\" ng-disabled=\"vm.card.date == null\" required=\"\"><md-option ng-value=\"item.hour\" ng-disabled=\"!item.is_available\" ng-repeat=\"item in vm.hours\">{{ item.hour }}</md-option></md-select></md-input-container></div></div></div></div></div><div class=\"sections\"><div class=\"section\" ng-if=\"vm.card.process_type_id === 6 || vm.card.process_type_id === 8 || vm.card.process_type_id === 4\"><div class=\"checklist\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked s18\"></i> <span flex=\"\" class=\"section-title\">Itens</span></div><div class=\"section-content\"><div class=\"check-items\"><md-table-container><table md-table=\"\" md-progress=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"width: 100%;\">Nome</th><th md-column=\"\">Quantidade</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"product in vm.card.products\" ng-if=\"product.to_delete != true\"><td md-cell=\"\">{{product.product_name}}</td><td md-cell=\"\"><input ng-model=\"product.qty\" style=\"text-align: center; width: 50px; height: 30px;\"></td><td md-cell=\"\" style=\"text-align: right\"><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-if=\"vm.card.id == null || vm.card.process_flow_item_id <= 2\" ng-click=\"vm.removeProduct(product); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip>Remover</md-tooltip></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div><div layout=\"row\" flex=\"\" style=\"margin-top: 15px\" ng-if=\"(vm.card.id == null || vm.card.process_flow_item_id <= 2) && vm.do_edit\"><md-input-container class=\"md-input-has-placeholder\" flex=\"\" ng-if=\"vm.card.process_type_id == 4\"><input autocomplete=\"off\" ng-model=\"vm.product_name\" placeholder=\"+ Adicionar item\"></md-input-container><div class=\"select2-padding\" layout=\"column\" flex=\"\" ng-if=\"vm.card.process_type_id != 4\"><label for=\"select-product\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">+ Adicionar item</span></label><select2 ng-model=\"vm.product_id\" ng-disabled=\"!vm.do_edit\" s2-options=\"val.id as val.name for val in vm.products\" id=\"select-product\"></select2></div><md-input-container class=\"md-input-has-placeholder\" flex=\"20\"><input type=\"number\" autocomplete=\"off\" ng-model=\"vm.product_qty\" placeholder=\"Quantidade\"></md-input-container><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Salvar\" flex=\"5\" ng-click=\"vm.addProduct(vm.product_id, vm.product_qty, vm.product_name)\"><md-tooltip md-direction=\"top\">Salvar</md-tooltip><md-icon md-font-icon=\"icon-check\"></md-icon></md-button></div></div></div><md-input-container><md-checkbox ng-model=\"vm.save_process\">criar mais uma solicitação.</md-checkbox></md-input-container><div class=\"section\"><div class=\"attachments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"section-title\">Anexos</span></div><div class=\"section-content\"><div class=\"attachment\" ng-repeat=\"item in vm.card.artifacts\" ng-switch=\"item.type\" ng-if=\"vm.card.id !== null\"><div class=\"attachment-content\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"start start\"><a class=\"attachment-name\" target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + item.file_reference}}\" download=\"\">{{item.name}}</a> <span class=\"attachment-time\">{{vm.getTimeSinceComment(item)}}</span></div><span flex=\"\"></span><md-button class=\"md-icon-button\" href=\"{{vm.CONFIG.webApiUri + item.file_reference}}\" target=\"_blank\" download=\"\"><md-icon>file_download</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.deleteFile(item)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div><div flex=\"\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div></div></div><div class=\"section\" ng-if=\"vm.card.id != null\"><div class=\"comments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"section-title\">Comentários</span></div><div class=\"section-content\"><div name=\"cardCommentForm\" class=\"comment new-comment\" layout=\"column\" layout-align=\"start\" no-validate=\"\"><div layout=\"row\"><img class=\"comment-member-avatar\" src=\"assets/images/avatars/profile.jpg\"><md-input-container flex=\"\" md-no-float=\"\"><textarea placeholder=\"Escreva um comentário...\" ng-disabled=\"vm.disabled_comment\" ng-model=\"vm.newCommentText\" translate=\"\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.addNewComment(vm.newCommentText)\" ng-disabled=\"vm.newCommentText == null || vm.disabled_comment\" aria-label=\"Add\"><md-progress-circular style=\"float: left;margin-top: 7px;\" md-diameter=\"20px\" ng-if=\"vm.disabled_comment\" md-mode=\"indeterminate\"></md-progress-circular><span>Salvar</span></md-button></div></div><div class=\"comment\" layout=\"row\" ng-repeat=\"comment in vm.card.comments\"><img class=\"comment-member-avatar\" src=\"assets/images/avatars/profile.jpg\"><div layout=\"column\"><div class=\"comment-member-name\">{{comment.person_name}}</div><div class=\"comment-bubble\">{{comment.notes_done}}</div><div class=\"comment-time secondary-text\">{{vm.getTimeSinceComment(comment)}}</div></div></div></div></div></div><div class=\"section\" layout=\"row\"><div flex=\"\" class=\"members\" ng-if=\"vm.card.id !== null\" layout=\"column\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-account s18\"></i> <span class=\"section-title\">Solicitado por {{vm.card.person_owner_name}}, em {{vm.card.date_time}}</span></div><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span class=\"section-title\">Atribuído a {{vm.card.person_responsible_name}}</span></div></div></div><div ng-if=\"vm.card.activities[0]\" class=\"section\"><div class=\"activities\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\">Atividades</span></div><div class=\"section-content\"><div class=\"activity\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"activity in vm.card.activities\"><div class=\"activity-member-name\">nome</div><div class=\"activity-message\">{{activity.message}}</div><div class=\"activity-time secondary-text\">{{activity.time}}</div></div></div></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; width: 100%;justify-content: space-between !important;\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.justifyChangeStatus({process_flow_item_id_target: 5})\" ng-disabled=\"vm.show_loader\" ng-hide=\"vm.do_edit\" ng-if=\"( ( vm.card_type == \'to_solve\' && vm.card.process_flow_item_id == 1 ) || ( vm.card.process_flow_item_id <= 2 && vm.card_type == \'crud\' && vm.card.person_id_owner == vm.user_id ) || ( vm.card.process_type_id == 2 && vm.card.process_flow_item_id == 2 ) || ( vm.card.process_type_id == 1 && vm.card.process_flow_item_id <= 2 ) || ( vm.card.process_type_id == 4 && vm.card.process_flow_item_id <= 2 ) || ( vm.card.process_type_id == 3 && vm.card.process_flow_item_id <= 2 ) )\" style=\"background-color: #ae0000;color: rgba(255,255,255,0.87);\">Cancelar solicitação</md-button><div layout=\"row\" ng-if=\"vm.card.id !== null && vm.card_type == \'to_solve\'\" layout-align=\"start\" ng-hide=\"vm.do_edit\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.changeStatus({process_flow_item_id_target: 2})\" ng-if=\"vm.card.process_flow_item_id == 1\" ng-disabled=\"vm.show_loader\" style=\"background-color: #08cc75;color: rgba(255,255,255,0.87);\">Aprovar</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.changeStatus({process_flow_item_id_target: 5})\" ng-if=\"vm.card.process_flow_item_id == 1\" ng-disabled=\"vm.show_loader\" style=\"background-color: #ae0000;color: rgba(255,255,255,0.87);\">Reprovar</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.changeStatus({process_flow_item_id_target: 3})\" ng-if=\"vm.card.process_flow_item_id == 2\" ng-disabled=\"vm.show_loader\" style=\"background-color: #0288D1;color: rgba(255,255,255,0.87);\">Iniciar</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.changeStatus({process_flow_item_id_target: 4})\" ng-if=\"vm.card.process_flow_item_id == 3\" ng-disabled=\"vm.show_loader\" style=\"background-color: #046a3d;color: rgba(255,255,255,0.87);\">Concluir</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.changeStatus({process_flow_item_id_target: 2})\" ng-if=\"vm.card.process_flow_item_id == 3\" ng-disabled=\"vm.show_loader\" style=\"background-color: #F57F17;color: rgba(255,255,255,0.87);\">Interromper</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.changeStatus({process_flow_item_id_target: 3})\" ng-if=\"vm.card.process_flow_item_id == 4\" ng-disabled=\"vm.show_loader\" style=\"background-color: #0288D1;color: rgba(255,255,255,0.87);\">Reiniciar</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.changeStatus({process_flow_item_id_target: 1})\" ng-if=\"vm.card.process_flow_item_id == 5\" ng-disabled=\"vm.show_loader\" style=\"background-color: #0288D1;color: rgba(255,255,255,0.87);\">Reativar</md-button></div><div layout=\"row\" flex=\"\"><span flex=\"\"></span><div ng-if=\"vm.card.id != null && !vm.do_edit\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.do_edit = true\" ng-disabled=\"vm.show_loader || vm.calculateTimeRamaining()\" ng-if=\"vm.can_edit\">Editar<md-tooltip md-direction=\"top\" ng-if=\"vm.calculateTimeRamaining()\">*Só é possível editar uma solicitação com pelo menos 24 horas de antecedência</md-tooltip></md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeDialog()\" ng-disabled=\"vm.show_loader\">Fechar</md-button></div><div ng-if=\"vm.card.id == null || ((((vm.card.process_flow_item_id === 2 && vm.card.process_type_id !== 6) && vm.card.person_id_owner === vm.user_id && vm.card_type === \'crud\') || vm.card.process_flow_item_id === 1) && vm.do_edit)\"><md-button class=\"md-raised md-primary\" ng-disabled=\"process_form.$invalid || vm.show_loader\" ng-click=\"vm.submit(vm.card)\">Salvar {{vm.card.id !== null ? \' edição\' : \'\'}}</md-button><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeDialog()\" ng-disabled=\"vm.show_loader\">Cancelar {{vm.card.id !== null ? \' edição\' : \'\'}}</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/process/process-crud/views/process.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><a4-process-filter filter-person=\"vm.filter_person\" filter-process-type=\"vm.filter_process_type\" filter-date=\"vm.filter_date\" filter-status=\"vm.filter_status\" view-grid=\"vm.view_grid\" filter-function=\"vm.getProcess(vm.process_owner.current_page, vm.process_owner.per_page, person, process_type, status, date, null, null, view_grid)\" change-view=\"vm.changeView()\" title=\"\'Minhas Solicitações\'\"></a4-process-filter><div class=\"content-card\" layout=\"column\" flex=\"\" ng-if=\"vm.view_grid && vm.process_owner.data.length > 0\"><a4-process-list ng-model=\"vm.process_owner.data\" edit-modal=\"vm.openCardDialog(card)\" order-by=\"vm.order_by\" reorder-function=\"vm.getProcess(vm.process_owner.current_page, vm.process_owner.per_page, person, process_type, status, date, order_by, direction)\" filter-process=\"vm.filter_process\"></a4-process-list><md-table-pagination md-limit=\"vm.process_owner.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.process_owner.current_page\" md-total=\"{{vm.process_owner.total}}\" md-on-paginate=\"vm.getProcess\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination></div><md-card layout-padding=\"\" ng-if=\"!vm.view_grid\"><div id=\"board\" layout=\"row\"><a4-board-list board-name=\"\'Em análise\'\" board-cards=\"vm.process_owner[\'Em análise\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list><a4-board-list board-name=\"\'Pendente\'\" board-cards=\"vm.process_owner[\'Pendente\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list><a4-board-list board-name=\"\'Em andamento\'\" board-cards=\"vm.process_owner[\'Em andamento\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list><a4-board-list board-name=\"\'Finalizado\'\" board-cards=\"vm.process_owner[\'Finalizado\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list><a4-board-list board-name=\"\'Cancelado\'\" board-cards=\"vm.process_owner[\'Cancelado\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list></div></md-card></div>");
$templateCache.put("app/process/process-person/views/date-block-modal.html","<md-dialog aria-label=\"Datas de bloqueio de solicitação\" md-theme=\"process\" style=\"width: 550px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Datas de bloqueio de solicitação</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-align=\"space-between\"><date-picker style=\"width: 70%; padding-left: 5px\" ng-model=\"vm.date\"></date-picker><md-button ng-click=\"vm.addBlockDate()\" ng-disabled=\"vm.date === null\"><md-icon md-font-icon=\"icon-plus\" style=\"width: 10%\"></md-icon></md-button></div><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Tipo de solicitação</span></th><th md-column=\"\"><span>Data de bloqueio</span></th><th md-column=\"\"><span style=\"margin-left: 30px\">Excluir</span></th></tr></thead><tbody md-body=\"\"><tr ng-repeat=\"processBlock in vm.process\"><td md-cell=\"\">{{processBlock.name}}</td><td md-cell=\"\">{{processBlock.date}}</td><td md-cell=\"\"><md-button><md-icon md-font-icon=\"icon-trash\" ng-click=\"vm.deleteDate(processBlock.id)\"></md-icon></md-button></td></tr></tbody></table></md-dialog>");
$templateCache.put("app/process/process-person/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Gerenciamento de permissões</span></div></div></md-toolbar><md-card layout-padding=\"\"><md-table-container style=\"padding-bottom: 0;\" class=\"table-float-button\"><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Solicitação</span></th><th md-column=\"\"><span></span></th><th md-column=\"\"><span>Opções</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"process_type in vm.process_types\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\" ng-click=\"vm.openModal(process_type)\">{{process_type.name}}</td><td md-cell=\"\" flex=\"\" ng-click=\"vm.openModal(process_type)\"><span class=\"item-bfr-grid\" style=\"text-align: right\"><span>{{process_type.to_authorise !== 0 ? process_type.to_authorise : \'\'}}<md-icon ng-style=\'{\"color\": process_type.to_authorise !== 0 ? \"#0b93d5;\" : \"#dadada\"}\' md-font-icon=\"icon-account-check\"><md-tooltip md-direction=\"top\">Autorizar</md-tooltip></md-icon></span> <span>{{process_type.to_resolve !== 0 ? process_type.to_resolve : \'\'}}<md-icon ng-style=\'{\"color\": process_type.to_resolve !== 0 ? \"#0d8520;\" : \"#dadada\"}\' md-font-icon=\"icon-account-network\"><md-tooltip md-direction=\"top\">Resolver</md-tooltip></md-icon></span></span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\"><md-button ng-click=\"vm.openOptions()\"><md-icon>more_vert</md-icon><md-tooltip>Bloquear Data de solicitação</md-tooltip></md-button></td></tr></tbody></table></md-table-container></md-card></div>");
$templateCache.put("app/process/process-person/views/process-options-modal.html","<md-dialog aria-label=\"Questionário\" md-theme=\"process\" style=\"min-width: 800px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"margin-left: 5px\">Bloquear Datas</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-card><md-table-container style=\"padding-bottom: 0;\" class=\"table-float-button\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Solicitação</span></th><th md-column=\"\"><span>Tipo</span></th><th md-column=\"\"><span>Data</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td>Teste</td><td>Foto e Video</td><td>09/08/2023</td></tr></tbody></table></md-table-container></md-card></md-dialog>");
$templateCache.put("app/process/process-person/views/select-person-modal.html","<md-dialog aria-label=\"Troca de professor\" md-theme=\"process\" style=\"width: 700px;\"><form ng-cloak=\"\" name=\"formChangeTeacher\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><md-icon md-font-icon=\"icon-account-switch\" class=\"icon-64\"></md-icon>Selecionar pessoas para {{vm.process.name}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 100px;margin-bottom: 100px\" ng-if=\"vm.show_loader\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><div layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.show_loader\"><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px #009688;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><small>Selecione abaixo as pessoas que terão permissão para resolver ou aprovar a solicitação</small></div></div><div flex=\"\" layout=\"row\"><md-autocomplete flex=\"90\" md-input-name=\"to_resolve\" md-no-cache=\"false\" md-min-length=\"0\" md-delay=\"100\" md-selected-item=\"vm.person\" md-search-text=\"searchTextresolve\" md-items=\"item in vm.getCollaborators(searchTextresolve)\" md-item-text=\"item.name\" md-floating-label=\"Selecione um colaborador\"><md-item-template><span md-highlight-text=\"searchTextCharger\">{{item.name}}</span></md-item-template></md-autocomplete><md-button class=\"md-icon-button md-secondary\" ng-click=\"vm.addPerson(vm.person)\" flex=\"\" style=\"padding-top: 20px;\"><md-icon>add</md-icon><md-tooltip md-direction=\"top\">Adicionar</md-tooltip></md-button></div><md-table-container style=\"padding-bottom: 0;\"><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"width: 60%\"><span>Nome</span></th><th md-column=\"\"><span>Resolver</span></th><th md-column=\"\"><span>Aprovar</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"person in vm.process.persons track by $index\"><td md-cell=\"\" flex=\"\">{{person.name}}</td><td md-cell=\"\" flex=\"\"><md-checkbox ng-model=\"person.to_resolve\"></md-checkbox></td><td md-cell=\"\" flex=\"\"><md-checkbox ng-model=\"person.to_authorise\"></md-checkbox></td><td md-cell=\"\" flex=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removePerson($index)\" flex=\"\"><md-icon>delete</md-icon><md-tooltip md-direction=\"top\">Remover</md-tooltip></md-button></td></tr></tbody></table></md-table-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" ng-click=\"vm.submit()\" class=\"md-raised md-primary\" aria-label=\"Add Task\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/process/process-to-solve/views/process-to-solve.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><a4-process-filter filter-person=\"vm.filter_person\" filter-process-type=\"vm.filter_process_type\" filter-date=\"vm.filter_date\" filter-status=\"vm.filter_status\" view-grid=\"vm.view_grid\" filter-function=\"vm.getProcess(vm.process_owner.current_page, vm.process_owner.per_page, person, process_type, status, date, null, null, view_grid, person_responsible)\" change-view=\"vm.changeView()\" title=\"\'Administrar Solicitações\'\" filter-person-responsible=\"vm.filter_person_responsible\"></a4-process-filter><div class=\"content-card\" layout=\"column\" flex=\"\" ng-if=\"vm.view_grid && vm.process_owner.data.length > 0\"><a4-process-list ng-model=\"vm.process_owner.data\" edit-modal=\"vm.openCardDialog(card)\" order-by=\"vm.order_by\" reorder-function=\"vm.getProcess(vm.process_owner.current_page, vm.process_owner.per_page, person, process_type, status, date, order_by, direction)\" filter-process=\"vm.filter_process\"></a4-process-list><md-table-pagination md-limit=\"vm.process_owner.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.process_owner.current_page\" md-total=\"{{vm.process_owner.total}}\" md-on-paginate=\"vm.getProcess\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination></div><md-card layout-padding=\"\" ng-if=\"!vm.view_grid\"><div id=\"board\" layout=\"row\"><a4-board-list board-name=\"\'Em análise\'\" board-cards=\"vm.process_owner[\'Em análise\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list><a4-board-list board-name=\"\'Pendente\'\" board-cards=\"vm.process_owner[\'Pendente\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list><a4-board-list board-name=\"\'Em andamento\'\" board-cards=\"vm.process_owner[\'Em andamento\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list><a4-board-list board-name=\"\'Finalizado\'\" board-cards=\"vm.process_owner[\'Finalizado\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list><a4-board-list board-name=\"\'Cancelado\'\" board-cards=\"vm.process_owner[\'Cancelado\']\" edit-modal=\"vm.openCardDialog(card)\"></a4-board-list></div></md-card></div>");
$templateCache.put("app/process/stock/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{vm.name}}</span></div></div></md-toolbar><a4-crud-table items=\"vm.data\" columns=\"vm.columns\" create-item=\"vm.createProduct(item)\" theme=\"\'process\'\" save-item=\"vm.editProduct(item)\"></a4-crud-table></div>");
$templateCache.put("app/stock/stock-list/views/adjust-stock.html","<md-dialog aria-label=\"Ajuste de estoque\" md-theme=\"stock\" style=\"min-width: 700px\"><form ng-cloak=\"\" name=\"detailment\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">Ajuste de estoque</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"\"><md-input-container flex=\"\"><label>Nome do produto</label> <input type=\"text\" ng-disabled=\"true\" ng-model=\"vm.scope.product.name\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"\"><md-input-container class=\"input-a4 md-input-has-placeholder\" flex=\"\"><label>Observações</label> <input type=\"text\" ng-model=\"vm.scope.product.notes\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"\"><date-picker label=\"Data\" placeholder=\"Data\" ng-model=\"vm.scope.product.date\" max-date=\"vm.today\" flex=\"\"></date-picker></div><md-input-container flex=\"20\"><input ng-model=\"vm.scope.product.last_balance\" ng-disabled=\"true\" placeholder=\"Estoque atual\"></md-input-container><md-input-container flex=\"20\"><input ng-model=\"vm.scope.product.quantity\" type=\"number\" placeholder=\"Quantidade\" required=\"\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-primary\" ng-click=\"vm.answer(vm.scope.product)\">Criar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/stock/stock-list/views/form.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"stock\" style=\"min-width: 700px; min-height: 400px;\"><md-toolbar><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\" ng-show=\"vm.currentItem.id != null\">{{vm.currentItem.name}}</h1><h1 class=\"md-toolbar-tools\" ng-show=\"vm.currentItem.id == null\">Nome do produto</h1><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"form-wrapper\" flex=\"\" style=\"width: 700px\"><form name=\"formStock\" class=\"form-horizontal product-form\" novalidate=\"\" ng-submit=\"vm.submit(formStock, vm.currentItem)\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.currentItem.name\" placeholder=\"Nome do produto\" required=\"\"><div ng-messages=\"formStock.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>O nome é requerido.</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-input-container flex=\"20\"><input type=\"text\" name=\"price\" ng-model=\"vm.currentItem.cost\" placeholder=\"Custo\" ui-money-mask=\"2\"></md-input-container><md-input-container flex=\"20\"><input type=\"text\" name=\"price\" ng-model=\"vm.currentItem.price\" placeholder=\"Valor\" ui-money-mask=\"2\" required=\"\"><div ng-messages=\"formStock.price.$error\" role=\"alert\"><div ng-message=\"required\"><span>O valor é requerido</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"unit\" ng-model=\"vm.currentItem.unit\" placeholder=\"Unidade de medida\" ng-maxlength=\"20\"><div ng-messages=\"formStock.unit.$error\" role=\"alert\"><div ng-message=\"required\"><span>A unidade é requerido.</span></div><div ng-message=\"maxlength\"><span>Máximo de 20 caracteres.</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-input-container flex=\"30\" ng-if=\"angular.isUndefined(vm.currentItem.id) || vm.currentItem.id === null\"><input type=\"text\" name=\"initial_stock\" ng-model=\"vm.currentItem.initial_stock\" placeholder=\"Estoque inicial\" ui-number-mask=\"0\"><div ng-messages=\"formStock.initial_stock.$error\" role=\"alert\"><div ng-message=\"required\"><span>Estoque inicial é requerido</span></div></div></md-input-container><md-input-container flex=\"50\"><input type=\"text\" name=\"minimum_stock\" ng-model=\"vm.currentItem.minimum_stock\" placeholder=\"Estoque mínimo\" ui-number-mask=\"0\"><div ng-messages=\"formStock.minimum_stock.$error\" role=\"alert\"></div></md-input-container><md-input-container flex=\"50\"><input type=\"text\" name=\"maximum_stock\" ng-model=\"vm.currentItem.maximum_stock\" placeholder=\"Estoque máximo\" ui-number-mask=\"0\"><div ng-messages=\"formStock.maximum_stock.$error\" role=\"alert\"></div></md-input-container></div><div class=\"group-field\"><div layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-autocomplete flex=\"\" required=\"\" md-input-name=\"autoCategories\" md-selected-item=\"vm.selectedCategory\" md-no-cache=\"true\" md-search-text-change=\"vm.searchTextChange(vm.searchCategory)\" md-search-text=\"vm.searchCategory\" md-selected-item-change=\"vm.currentItem.bill_category_id = item\" md-items=\"item in vm.querySearchCategory(vm.searchCategory)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Categoria\"><md-item-template><span class=\"item-title\"><span><strong>{{item.name}}</strong></span></span> <span class=\"item-metadata\"><span>{{item.path}}</span></span></md-item-template><div ng-messages=\"formProduct.autoCategories.$error\" ng-if=\"formProduct.autoCategories.$touched\"><div ng-message=\"required\">Categoria é requerida</div><div ng-message=\"md-require-match\">Categoria não existe</div></div><md-not-found>Categoria não encontrada.</md-not-found></md-autocomplete></div></div><div layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-input-container flex=\"\" ng-if=\"vm.companies_number > 1\"><md-checkbox ng-model=\"vm.currentItem.withoutCompany\">Produto para todas as empresas</md-checkbox></md-input-container></div><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Cancelar\" ng-disabled=\"formStock.$invalid || formStock.$pristine\"><span class=\"title\" ng-show=\"vm.currentItem.id == null\">Criar</span> <span class=\"title\" ng-show=\"vm.currentItem.id != null\">Atualizar</span></md-button></md-dialog-actions></form></div></md-dialog>");
$templateCache.put("app/stock/stock-list/views/history.html","<md-dialog aria-label=\"Histório de movimentações do produto\" md-theme=\"stock\" style=\"min-width: 700px\"><form ng-cloak=\"\" name=\"detailment\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">Histórico de movimentações</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Tipo de transação</th><th md-column=\"\">Quantidade</th><th md-column=\"\">Valor</th><th md-column=\"\">Saldo</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"movement in vm.scope.movements\"><td md-cell=\"\">{{movement.date}}</td><td md-cell=\"\">{{movement.stock_transaction_type}}</td><td md-cell=\"\">{{movement.quantity}}</td><td md-cell=\"\">{{movement.total_movement | currency: \"\"}}</td><td md-cell=\"\">{{movement.balance}}</td></tr></tbody></table></md-table-container></md-dialog-content></form></md-dialog>");
$templateCache.put("app/stock/stock-list/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Estoque</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.getAllProducts(vm.search)\"></md-input-container></div></md-toolbar><md-card layout-padding=\"\"><div layout=\"row\"><md-input-container flex=\"\" style=\"max-width: 15%; margin-right: 1%\"><md-icon>search</md-icon><label>Filtrar por categoria</label><md-select ng-model=\"vm.selected_category\" ng-change=\"vm.filterProductsByCategory()\"><md-option ng-value=\"null\">Todas as categorias</md-option><md-option ng-repeat=\"category in vm.allCategories | orderBy:\'id\'\" ng-value=\"category.id\">{{category.name}}</md-option></md-select></md-input-container><md-input-container><md-checkbox ng-model=\"vm.show_inactive\" ng-change=\"vm.getAllProducts()\">Mostrar produtos inativos</md-checkbox></md-input-container><div style=\"margin-right: auto; margin-top: 15px\"><button class=\"md-stock-theme md-primary md-button ng-scope md-ink-ripple md-vm.options.theme-theme\" ng-click=\"vm.printProducts()\">Imprimir relatório</button></div></div><md-table-container style=\"padding-bottom: 0;\" class=\"table-float-button\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Nome</span></th><th md-column=\"\" style=\"text-align: right\"><span>Qtd. atual.</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Preço (R$)</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Custo (R$)</span></th><th md-column=\"\" style=\"text-align: right\"><span>Qtd. min.</span></th><th md-column=\"\" style=\"text-align: right\"><span>Qtd. max.</span></th><th md-column=\"\" md-numeric=\"\"><span style=\"padding-right: 12px;\">Ações</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"product in vm.products\" ng-click=\"vm.editItem(product)\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\">{{product.name}} <span ng-if=\"product.is_inactive || product.inactivity_date !== null\" style=\"color: #8c0c0d\"><small>[Inativo]</small></span></td><td md-cell=\"\" md-numeric=\"\" style=\"text-align: right\"><span ng-if=\"product.last_balance !== null\"><span ng-style=\'{ \"color\" : (product.last_balance > product.maximum_stock && product.maximum_stock !== 0) || (product.last_balance < product.minimum_stock && product.minimum_stock !== null) || (product.last_balance < 0) ? \"red\" : \"black\"}\'><b>{{product.last_balance}}</b></span></span></td><td md-cell=\"\" md-truncate=\"\" md-numeric=\"\" flex=\"\" class=\"md-table-menu\">{{product.price | currency: \"\"}}</td><td md-cell=\"\" md-truncate=\"\" md-numeric=\"\" flex=\"\" class=\"md-table-menu\">{{product.cost | currency: \"\"}}</td><td md-cell=\"\" md-numeric=\"\" style=\"text-align: right\">{{product.minimum_stock !== null && product.minimum_stock > 0 ? product.minimum_stock : \'\'}}</td><td md-cell=\"\" md-numeric=\"\" style=\"text-align: right\">{{product.maximum_stock !== null && product.maximum_stock > 0 ? product.maximum_stock : \'\'}}</td><td md-cell=\"\" flex=\"\" md-numeric=\"\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\" ng-disabled=\"vm.estoque_alt\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.delete(product)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>Excluir</md-button></md-menu-item><md-menu-item ng-if=\"!product.is_inactive\"><md-button ng-click=\"vm.inactivate(product)\"><md-icon>block</md-icon>Desativar</md-button></md-menu-item><md-menu-item ng-if=\"product.is_inactive\"><md-button ng-click=\"vm.inactivate(product)\"><md-icon>done</md-icon>Ativar</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.showHistory(product)\"><md-icon md-font-icon=\"icon-chart-areaspline\"></md-icon>Histórico de transações</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.adjustStock(product)\"><md-icon md-font-icon=\"icon-chart-areaspline\"></md-icon>Realizar correção de estoque</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-card></div>");
$templateCache.put("app/stock/transactions/views/form.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"stock\" style=\"min-width: 700px;\"><md-toolbar><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\" ng-show=\"vm.currentItem.id !== null\">Edição de transação</h1><h1 class=\"md-toolbar-tools\" ng-show=\"vm.currentItem.id == null\"><span ng-if=\"vm.is_buy\">Nova compra</span> <span ng-if=\"!vm.is_buy\">Nova transação</span></h1><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"form-wrapper\" flex=\"\" style=\"width: 700px\"><form name=\"formTransaction\" class=\"form-horizontal product-form\" novalidate=\"\" ng-submit=\"vm.submit(formTransaction, vm.currentItem)\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"\"><date-picker label=\"Data\" placeholder=\"Data\" ng-model=\"vm.currentItem.date\" max-date=\"vm.today\" flex=\"\" disabled=\"vm.currentItem.id !== null\"></date-picker></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"!vm.is_buy\" flex=\"\"><md-input-container flex=\"\"><label>Tipo de transação</label><md-select ng-model=\"vm.currentItem.stock_transaction_type_id\" flex=\"\" ng-disabled=\"vm.currentItem.id !== null\"><md-option ng-value=\"transaction_type.id\" ng-repeat=\"transaction_type in vm.stock_transaction_types\" ng-if=\"(transaction_type.id !== 10 && transaction_type.id !== 11 && transaction_type.id !== 32 && transaction_type.id !== 33) || vm.currentItem.id !== null\">{{transaction_type.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"!vm.is_buy\" flex=\"\"><md-input-container flex=\"\" class=\"input-a4 md-input-has-placeholder\" ng-init=\"vm.listAllPersons()\"><md-autocomplete flex=\"\" md-input-name=\"autocompleteField\" md-no-cache=\"true\" md-selected-item=\"vm.currentItem.person_id\" md-search-text=\"vm.searchText\" md-items=\"item in vm.listAllPersons(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-selected-item-change=\"vm.personSelected(item)\" md-require-match=\"\" md-floating-label=\"Solicitante\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"\"><md-input-container class=\"input-a4 md-input-has-placeholder\" flex=\"\"><label>Observações</label> <input type=\"text\" ng-model=\"vm.currentItem.notes\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"vm.currentItem.id !== null && vm.currentItem.person_supplier !== null\" flex=\"\"><md-input-container flex=\"\"><input ng-disabled=\"true\" ng-model=\"vm.currentItem.person_supplier\" placeholder=\"Fornecedor\"></md-input-container></div><md-autocomplete flex=\"\" md-input-name=\"supplier\" ng-if=\"vm.is_buy\" md-input-minlength=\"2\" md-no-cache=\"false\" md-delay=\"1000\" md-selected-item=\"vm.supplier\" md-search-text=\"searchTextSuppliers\" md-items=\"item in vm.getSuppliers(searchTextSuppliers)\" md-item-text=\"item.name\" md-floating-label=\"Fornecedor\" required=\"\"><md-item-template><span md-highlight-text=\"searchTextCharger\">{{item.name}}</span></md-item-template></md-autocomplete><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"vm.is_buy\" flex=\"\"><md-input-container flex=\"\"><input ng-model=\"vm.currentItem.extra_amount\" ui-money-mask=\"\" placeholder=\"Frete/outros\" ng-disabled=\"vm.currentItem.id !== null\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-repeat=\"item in vm.currentItem.products track by $index\" flex=\"\"><md-input-container flex=\"35\"><label>Produto</label><md-select ng-model=\"item.product_id\" flex=\"\" ng-change=\"vm.productChange(item, product.id)\" required=\"\" ng-disabled=\"vm.currentItem.id !== null\"><md-select-header><input ng-model=\"searchProduct\" type=\"search\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option ng-value=\"product.id\" ng-repeat=\"product in vm.products | filter: searchProduct\">{{product.name}}</md-option></md-select></md-input-container><md-input-container flex=\"20\"><input ng-model=\"item.balance_product_selected\" ng-disabled=\"true\" placeholder=\"Estoque atual\"></md-input-container><md-input-container ng-if=\"vm.is_buy\" flex=\"20\"><input ng-model=\"item.unit_price\" ui-money-mask=\"\" placeholder=\"Preço\" ng-disabled=\"vm.currentItem.id !== null\"></md-input-container><md-input-container flex=\"20\"><input ng-model=\"item.quantity\" type=\"number\" placeholder=\"Quantidade\" required=\"\" ng-disabled=\"vm.currentItem.id !== null\"></md-input-container><md-icon style=\"cursor: pointer\" ng-click=\"vm.deleteProduct($index, item)\" ng-if=\"vm.currentItem.id === null\">delete</md-icon></div><div style=\"text-align: right\" ng-if=\"vm.currentItem.id === null\"><md-button class=\"md-primary\" ng-click=\"vm.addProduct()\" flex=\"\"><md-icon>add</md-icon>Adicionar produto</md-button></div><hr><small class=\"required-fields\" ng-if=\"vm.currentItem.id === null\"><strong>*</strong> Campos necessários</small><md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentItem.id === null\"><md-button ng-click=\"vm.cancel()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Cancelar\" ng-disabled=\"formTransaction.$invalid || vm.currentItem.products.length === 0 || vm.disable\"><span class=\"title\" ng-show=\"vm.currentItem.id == null\">Criar</span> <span class=\"title\" ng-show=\"vm.currentItem.id != null\">Atualizar</span></md-button></md-dialog-actions></form></div></md-dialog>");
$templateCache.put("app/stock/transactions/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-swap-horizontal\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Transações de estoque</span></div></div></md-toolbar><md-card layout-padding=\"\"><a4-stock-transactions type=\"\'stock\'\"></a4-stock-transactions></md-card></div>");
$templateCache.put("app/stock/warehouse-list/views/form.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"stock\" style=\"min-width: 700px; min-height: 400px;\"><md-toolbar><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\" ng-show=\"vm.currentItem.id != null\">{{vm.currentItem.name}}</h1><h1 class=\"md-toolbar-tools\" ng-show=\"vm.currentItem.id == null\">Nome do produto</h1><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"form-wrapper\" flex=\"\" style=\"width: 700px\"><form name=\"formStock\" class=\"form-horizontal product-form\" novalidate=\"\" ng-submit=\"vm.submit(formStock, vm.currentItem)\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.currentItem.name\" placeholder=\"Nome do produto\" required=\"\"><div ng-messages=\"formStock.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>O nome é requerido.</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"unit\" ng-model=\"vm.currentItem.unit\" placeholder=\"Unidade de medida\" ng-maxlength=\"20\"><div ng-messages=\"formStock.unit.$error\" role=\"alert\"><div ng-message=\"required\"><span>A unidade é requerido.</span></div><div ng-message=\"maxlength\"><span>Máximo de 20 caracteres.</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-input-container flex=\"30\" ng-if=\"angular.isUndefined(vm.currentItem.id) || vm.currentItem.id === null\"><input type=\"text\" name=\"initial_stock\" ng-model=\"vm.currentItem.initial_stock\" placeholder=\"Estoque inicial\" ui-number-mask=\"0\"><div ng-messages=\"formStock.initial_stock.$error\" role=\"alert\"><div ng-message=\"required\"><span>Estoque inicial é requerido</span></div></div></md-input-container><md-input-container flex=\"50\"><input type=\"text\" name=\"minimum_stock\" ng-model=\"vm.currentItem.minimum_stock\" placeholder=\"Estoque mínimo\" ui-number-mask=\"0\"><div ng-messages=\"formStock.minimum_stock.$error\" role=\"alert\"></div></md-input-container><md-input-container flex=\"50\"><input type=\"text\" name=\"maximum_stock\" ng-model=\"vm.currentItem.maximum_stock\" placeholder=\"Estoque máximo\" ui-number-mask=\"0\"><div ng-messages=\"formStock.maximum_stock.$error\" role=\"alert\"></div></md-input-container></div><div class=\"group-field\"><div layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-autocomplete flex=\"\" required=\"\" md-input-name=\"autoCategories\" md-selected-item=\"vm.selectedCategory\" md-no-cache=\"true\" md-search-text-change=\"vm.searchTextChange(vm.searchCategory)\" md-search-text=\"vm.searchCategory\" md-selected-item-change=\"vm.currentItem.bill_category_id = item\" md-items=\"item in vm.querySearchCategory(vm.searchCategory)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Categoria\"><md-item-template><span class=\"item-title\"><span><strong>{{item.name}}</strong></span></span> <span class=\"item-metadata\"><span>{{item.path}}</span></span></md-item-template><div ng-messages=\"formProduct.autoCategories.$error\" ng-if=\"formProduct.autoCategories.$touched\"><div ng-message=\"required\">Categoria é requerida</div><div ng-message=\"md-require-match\">Categoria não existe</div></div><md-not-found>Categoria não encontrada.</md-not-found></md-autocomplete></div></div><div layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-input-container flex=\"\" ng-if=\"vm.companies_number > 1\"><md-checkbox ng-model=\"vm.currentItem.withoutCompany\">Produto para todas as empresas</md-checkbox></md-input-container></div><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Cancelar\" ng-disabled=\"formStock.$invalid || formStock.$pristine\"><span class=\"title\" ng-show=\"vm.currentItem.id == null\">Criar</span> <span class=\"title\" ng-show=\"vm.currentItem.id != null\">Atualizar</span></md-button></md-dialog-actions></form></div></md-dialog>");
$templateCache.put("app/stock/warehouse-list/views/history.html","<md-dialog aria-label=\"Histório de movimentações do produto\" md-theme=\"stock\" style=\"min-width: 700px\"><form ng-cloak=\"\" name=\"detailment\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">Histórico de movimentações</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon class=\"material-icons\" aria-label=\"Close\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Tipo de transação</th><th md-column=\"\">Quantidade</th><th md-column=\"\">Valor</th><th md-column=\"\">Saldo</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"movement in vm.scope.movements\"><td md-cell=\"\">{{movement.date}}</td><td md-cell=\"\">{{movement.stock_transaction_type}}</td><td md-cell=\"\">{{movement.quantity}}</td><td md-cell=\"\">{{movement.total_movement | currency: \"\"}}</td><td md-cell=\"\">{{movement.balance}}</td></tr></tbody></table></md-table-container></md-dialog-content></form></md-dialog>");
$templateCache.put("app/stock/warehouse-list/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Almoxarifado</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float=\"\" class=\"m-0\"><input id=\"search\" placeholder=\"{{ \'SEARCH_FOR_ANYONE\' | translate }}\" type=\"text\" ng-model=\"vm.search\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.getAllProducts(vm.search)\"></md-input-container></div></md-toolbar><md-card layout-padding=\"\"><div layout=\"row\"><md-input-container flex=\"\" style=\"max-width: 15%; margin-right: 1%\"><md-icon>search</md-icon><label>Filtrar por categoria</label><md-select ng-model=\"vm.selected_category\" ng-change=\"vm.filterProductsByCategory()\"><md-option ng-value=\"null\">Todas as categorias</md-option><md-option ng-repeat=\"category in vm.allCategories | orderBy:\'id\'\" ng-value=\"category.id\">{{category.name}}</md-option></md-select></md-input-container><md-input-container><md-checkbox ng-model=\"vm.show_inactive\" ng-change=\"vm.getAllProducts()\">Mostrar produtos inativos</md-checkbox></md-input-container><div style=\"margin-right: auto; margin-top: 15px\"><button class=\"md-stock-theme md-primary md-button ng-scope md-ink-ripple md-vm.options.theme-theme\" ng-click=\"vm.printProducts()\">Imprimir relatório</button></div></div><md-table-container style=\"padding-bottom: 0;\" class=\"table-float-button\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Nome</span></th><th md-column=\"\" style=\"text-align: right\"><span>Qtd. atual.</span></th><th md-column=\"\" style=\"text-align: right\"><span>Qtd. min.</span></th><th md-column=\"\" style=\"text-align: right\"><span>Qtd. max.</span></th><th md-column=\"\" md-numeric=\"\"><span style=\"padding-right: 12px;\">Ações</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"product in vm.products\" ng-click=\"vm.editItem(product)\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\">{{product.name}} <span ng-if=\"product.is_inactive || product.inactivity_date !== null\" style=\"color: #8c0c0d\"><small>[Inativo]</small></span></td><td md-cell=\"\" md-numeric=\"\" style=\"text-align: right\"><span ng-if=\"product.last_balance !== null\"><span ng-style=\'{ \"color\" : (product.last_balance > product.maximum_stock && product.maximum_stock !== 0) || (product.last_balance < product.minimum_stock && product.minimum_stock !== null) || (product.last_balance < 0) ? \"red\" : \"black\"}\'><b>{{product.last_balance}}</b></span></span></td><td md-cell=\"\" md-numeric=\"\" style=\"text-align: right\">{{product.minimum_stock !== null && product.minimum_stock > 0 ? product.minimum_stock : \'\'}}</td><td md-cell=\"\" md-numeric=\"\" style=\"text-align: right\">{{product.maximum_stock !== null && product.maximum_stock > 0 ? product.maximum_stock : \'\'}}</td><td md-cell=\"\" flex=\"\" md-numeric=\"\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\" ng-disabled=\"vm.estoque_alt\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.delete(product)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>Excluir</md-button></md-menu-item><md-menu-item ng-if=\"!product.is_inactive\"><md-button ng-click=\"vm.inactivate(product)\"><md-icon>block</md-icon>Desativar</md-button></md-menu-item><md-menu-item ng-if=\"product.is_inactive\"><md-button ng-click=\"vm.inactivate(product)\"><md-icon>done</md-icon>Ativar</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.showHistory(product)\"><md-icon md-font-icon=\"icon-chart-areaspline\"></md-icon>Histórico de transações</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.adjustStock(product)\"><md-icon md-font-icon=\"icon-chart-areaspline\"></md-icon>Realizar correção de estoque</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-card></div>");
$templateCache.put("app/stock/warehouse-transactions/views/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-chart-histogram\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Transações de almoxarifado</span></div></div></md-toolbar><md-card layout-padding=\"\"><a4-stock-transactions type=\"\'warehouse\'\"></a4-stock-transactions></md-card></div>");
$templateCache.put("app/components/a4-upload-image/view/modals/edit-image.html","<md-dialog md-theme=\"educational\" class=\"edit-image-dialog\" aria-label=\"{{ \'UPLOAD_IMAGE.EDIT\' | translate }}\"><md-toolbar class=\"md-accent md-tall _md layout-column _md-toolbar-transitions\" layout=\"column\"><div class=\"md-toolbar-tools\"><h1>{{ \'UPLOAD_IMAGE.EDIT\' | translate }}</h1><span flex=\"\"></span><md-button class=\"md-icon-button md-button ng-scope md-ink-ripple md-default-theme\" ng-click=\"vm.closeModal();\"><md-icon aria-label=\"Close dialog\"><i class=\"material-icons\">close</i></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle layout-align-center-center layout-column flex\" flex=\"\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" class=\"layout-align-center-center layout-column\" flex=\"100\"><img class=\"md-avatar avatar contact-avatar huge\" src=\"{{ vm.last_photo }}\" ng-src=\"{{ vm.myCroppedImage }}\"></div><div layout=\"row\"><div layout=\"row\" layout-align=\"center center\" class=\"layout-align-center-center layout-column\" flex=\"50\"><input id=\"file-avatar\" type=\"file\" class=\"inputfile\" custom-on-change=\"vm.selectImage\"> <label for=\"file-avatar\"><md-button class=\"md-fab md-mini md-hue-2 no-events\" aria-label=\"{{ \'UPLOAD_IMAGE.SELECT\' | translate }}\"><md-icon><i class=\"material-icons\">file_upload</i></md-icon><md-tooltip md-direction=\"top\">Enviar do pc</md-tooltip></md-button></label></div></div></div></md-toolbar><md-dialog-content ng-show=\"vm.myCroppedImage\"><div class=\"cropArea\"><ui-cropper image=\"vm.myImage\" area-type=\"square\" chargement=\"\'Loading\'\" result-image=\"vm.myCroppedImage\" result-image-format=\"vm.imageFormat\" result-image-size=\"{w:300,h:300}\" canvas-scalemode=\"true\"></ui-cropper></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.submit(vm.myCroppedImage)\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/modal/Templates/correction-index/details.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"indexForm\" class=\"md-inline-form\" novalidate=\"\" ng-submit=\"vm.answer(item)\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Lançamento</span></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container flex=\"\" class=\"md-block\"><label>Mês</label><md-select name=\"month\" required=\"\" ng-model=\"item.month\"><md-option ng-value=\"month.id\" ng-repeat=\"month in vm.scope.month\">{{ month.name }}</md-option></md-select><div ng-messages=\"indexForm.month.$error\" role=\"alert\"><div class=\"errors\" ng-message=\"required\">Por favor, selecione um mês.</div></div></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Ano</label><md-select name=\"year\" required=\"\" ng-model=\"item.year\"><md-option ng-value=\"year.id\" ng-repeat=\"year in vm.scope.year\">{{ year.name }}</md-option></md-select><div ng-messages=\"indexForm.year.$error\" role=\"alert\"><div ng-message=\"required\">Por favor, selecione um ano.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Porcentagem</label> <input required=\"\" name=\"percent\" ui-percentage-mask=\"\" ng-model=\"item.percent\" type=\"text\"><div ng-messages=\"indexForm.percent.$error\"><div ng-message=\"required\">Por favor, digite o percentual.</div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-disabled=\"!indexForm.$valid\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/modal/Templates/dailybalance/confirm.html","<div class=\"modal-a4\"><div class=\"modal-header\"><h4 class=\"modal-title\">Confirmação para fechamento</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12 grid-edit\"><p class=\"text-center\" style=\"padding-bottom: 10px;\" ng-show=\"db.getMinDate() != db.closing_day\">Todas as movimentações, do dia @db.getMinDate()@ até o dia @db.closing_day@,<br>serão fechadas. Deseja confirmar essa ação?</p><p class=\"text-center\" style=\"padding-bottom: 10px;\" ng-show=\"db.getMinDate() == db.closing_day\">Todas as movimentações do dia @db.closing_day@, serão fechadas.<br>Deseja confirmar essa ação?</p></div></div></div><div class=\"modal-footer\"><div class=\"btn btn-success-a4\" ng-click=\"db.closingDayByDate(db.closing_day, true)\"><i class=\"fa fa-floppy-o\"></i> Confirmar</div><div class=\"btn btn-cancel-a4\" data-dismiss=\"modal\" ng-click=\"db.closeModal()\"><i class=\"fa fa-times\"></i> Cancelar</div></div></div>");
$templateCache.put("app/components/modal/Templates/dailybalance/totalization.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><div class=\"modal-header\"><h4 class=\"modal-title\">Fechamento</h4></div><md-dialog-content ms-scroll=\"\"><div class=\"row\"><div class=\"col-md-12 grid-edit\"><p class=\"text-center\" style=\"padding-bottom: 10px;\"><span>Saldo anterior:</span> {{vm.scope.totalization.previous_balance | currency}}<br><span>Total de entradas:</span> {{vm.scope.totalization.total_entries | currency}}<br><span>Total de saídas:</span> {{vm.scope.totalization.total_outputs | currency}}<br><span>Resultado:</span> {{vm.scope.totalization.result | currency}}<br><span>Saldo final em</span> {{vm.scope.totalization.closing_balance_date}}: {{vm.scope.totalization.closing_balance_result | currency}}</p></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">Ok</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/modal/Templates/electronicInvoice/invoices.html","<div class=\"modal-a4\"><div class=\"modal-header\"><h4 class=\"modal-title\">Lote de notas fiscais</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12 grid-edit\"><table class=\"table table-striped table-responsive\"><thead><tr><th>Tomador</th><th>Numero da Nota</th><th>Codigo de Verificação</th><th>Valor da Nota</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in nf.invoices\"><td>@item.name@</td><td>@item.nf_number@</td><td>@item.nf_code@</td><td>@item.net_value | currency@</td><td><a class=\"btn btn-primary btn-green pull-right\" target=\"_blank\" ng-href=\"https://notahml.salvador.ba.gov.br/site/contribuinte/nota/notaprint.aspx?nf=@item.nf_number@&inscricao=@nf.inscricaoMunicipal@&verificacao=@item.nf_code@\">Ver nota</a></td></tr></tbody></table></div></div></div><div class=\"modal-footer\"><div class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"nf.closeModal()\">Fechar</div></div></div>");
$templateCache.put("app/components/modal/Templates/filesend/filesent.html","<div class=\"modal-header\"><h4 class=\"modal-title\">Arquivo Remessa</h4></div><form class=\"form-horizontal\" name=\"form_file_send\" \u2028=\"\" ng-submit=\"ctrl.submit(form_file_send, ctrl.filesend)\"><div class=\"modal-body\"><div><div class=\"row\"><div class=\"col-md-6\"><label class=\"control-label\">@ \'CURRENT_ACCOUNT\' | translate @</label><select required\u2028=\"\" ng-model=\"ctrl.filesend.current_account_id\" \u2028=\"\" ng-options=\"item.id as item.name for item in ctrl.current_accounts_with_collection_config\"></select></div><div class=\"col-md-6\"><label class=\"control-label\">@ \'DESCRIPTION\' | translate @</label> <input type=\"text\" ng-model=\"ctrl.filesend.description\" \u2028=\"\" required\u2028=\"\" placeholder=\"Digite a referência do arquivo\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label class=\"control-label\">@ \'FILE_NAME\' | translate @</label> <input type=\"text\" required\u2028=\"\" ng-model=\"ctrl.filesend.file_name\" placeholder=\"Enter text\"></div><div class=\"col-md-6\"><label class=\"control-label\">@ \'SEQUENTIAL\' | translate @</label> <input type=\"text\" \u2028=\"\" numbers-only\u2028=\"\" required\u2028=\"\" ng-model=\"ctrl.filesend.sequential\" placeholder=\"Enter text\"></div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" \u2028=\"\" ng-disabled=\"form_file_send.$error.required\" class=\"btn btn-green\">Gerar Arquivo</button></div></div></div></form>");
$templateCache.put("app/components/modal/Templates/readcheck/waitread.html","<div class=\"modal-a4\"><div class=\"modal-header\"><h4 class=\"modal-title\">@ \'Aguardando leitura do cheque...\' | translate @</h4></div><div class=\"modal-body\"><input onfocus=\"true\" ng-model=\"barcode\" name=\"barcodeField\" id=\"barcodeField\" ng-keypress=\"event=$event\" ng-change=\"readCheckNumber(barcode, event)\" ng-blur=\"setFocusOnCheckField()\" maxlength=\"30\" placeholder=\"Ou digite o número do cheque\" numbers-only=\"\"></div></div><div class=\"modal-footer\"><div class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal();\">Cancelar</div></div>");
$templateCache.put("app/components/modal/Templates/roles/editRole.html","<md-dialog class=\"contact-dialog\" md-theme=\"controlpanel\" aria-label=\"New Task\"><form name=\"roleForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"more secondary-text switch-edit-form\" style=\"top: 20px;\" ng-show=\"vm.scope.role.sys_user_role_id != 6\"><md-switch ng-model=\"vm.editable\" aria-label=\"\"></md-switch><md-button class=\"md-fab md-primary switch-edit-button\" aria-label=\"\"><md-icon ng-hide=\"!vm.editable\"><i class=\"material-icons\" aria-hidden=\"true\">close</i></md-icon><md-icon ng-show=\"!vm.editable\"><i class=\"material-icons\" aria-hidden=\"true\">mode_edit</i></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\"ROLES.EDIT_ROLE\" | translate}}</span></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.NAME\" | translate}}</label> <input ng-model=\"vm.scope.role.name\" name=\"name\" type=\"text\" ng-required=\"\" md-autofocus=\"\" ng-disabled=\"!vm.editable\"><div ng-messages=\"roleForm.name.$error\"><div ng-message=\"required\">Campo requerido.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.DESCRIPTION\" | translate}}</label> <input ng-model=\"vm.scope.role.description\" type=\"text\" ng-disabled=\"!vm.editable\"></md-input-container><treeview data=\"vm.scope.resources\" response=\"vm.scope.role.resources\" plugins=\'\"checkbox,types,changed\"\'></treeview></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.answer(vm.scope.role)\" ng-show=\"vm.editable\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">FECHAR</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/modal/Templates/roles/newRole.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" md-theme=\"controlpanel\"><form name=\"roleForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\"ROLES.NEW_ROLE\" | translate}}</span></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.NAME\" | translate}}</label> <input required=\"\" name=\"name\" ng-model=\"vm.scope.role.name\" type=\"text\" md-autofocus=\"\"><div ng-messages=\"roleForm.name.$error\"><div ng-message=\"required\">Campo requerido.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{\"ROLES.DESCRIPTION\" | translate}}</label> <input ng-model=\"vm.scope.role.description\" type=\"text\"></md-input-container><treeview data=\"vm.scope.resources\" response=\"vm.scope.role.resources\"></treeview></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.answer(vm.scope.role)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">{{\"ROLES.SAVE\" | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-raised md-button md-ink-ripple\" aria-label=\"Add Task\">{{\"ROLES.CANCEL\" | translate}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/modal/Templates/validate-cnpj/validate-cnpj.html","<md-dialog aria-label=\"Pesquisar por CNPJ\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Pesquisar por CNPJ</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal();\"><md-icon><i class=\"material-icons\">close</i></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-sm=\"row\"><div class=\"captcha-img\"><img ng-src=\"{{ vm.scope.cnpjParams.captchaBase64 }}\"></div><md-button class=\"md-icon-button\" aria-label=\"Atualizar\" ng-click=\"vm.scope.getCnpjCaptcha(null, vm.scope.cnpj, vm.scope.person);\" ng-show=\"vm.scope.cnpjParams.captchaBase64\"><md-icon><i class=\"material-icons\">autorenew</i></md-icon></md-button></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" placeholder=\"Captcha\" ng-model=\"vm.currentItem.captcha\" autocomplete=\"off\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.scope.postCnpjInfo(vm.scope.cnpj, vm.currentItem.captcha, vm.scope.cnpjParams, vm.scope.person);\">Pesquisar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/controlpanel/central-reports/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\" ng-show=\"vm.selected !== null\"></div><div layout=\"row\" ng-show=\"vm.selected !== null\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\" style=\"margin-right: 10px\"><i class=\"icon-folder s48\" ng-if=\"vm.selected.type == 1\"></i> <i class=\"icon-file-document s48\" ng-if=\"vm.selected.type == 2\"></i> <i class=\"icon-file-word s48\" ng-if=\"vm.selected.type == 3\"></i> <i class=\"icon-file-excel s48\" ng-if=\"vm.selected.type == 4\"></i></div><div layout=\"column\"><div class=\"title\"><input type=\"text\" ng-model=\"::vm.selected.name\"></div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.updated_at}}</div></div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\" ng-style=\"{height: vm.windowHeight}\"><div layout=\"row\" class=\"md-padding\"><input type=\"file\" name=\"template_file\" file-read=\"\" ng-model=\"vm.file\" accept=\".doc,.docx\" ng-if=\"vm.selected.type == 3\"> <input type=\"file\" name=\"template_file\" file-read=\"\" ng-model=\"vm.file\" accept=\".xlsm,.xlsx\" ng-if=\"vm.selected.type == 4\"></div><div layout=\"row\" class=\"md-padding\" style=\"padding-left: 0; padding-right: 0\"><div flex=\"\" ng-if=\"vm.selected.type == 3\">Modelo Word: <b>{{vm.selected.file.template}}</b></div></div><div ng-show=\"vm.selected !== null\"><div class=\"file-details\"><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type == 1 ? \'Pasta\' : \'Relatório\'}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.updated_at | date:\"DD/MM/YYYY\"}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created_at | date:\"DD/MM/YYYY\"}}</td></tr></table></div></div></md-content>");
$templateCache.put("app/controlpanel/central-reports/sidenavs/main/htmleditor.html","<div><a4-summernote></a4-summernote></div>");
$templateCache.put("app/controlpanel/central-reports/sidenavs/main/main-sidenav.html","<div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"></div></div>");
$templateCache.put("app/controlpanel/profile/views/tabs/form.html","<div layout=\"row\">{{vm.editable | json}}<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><form name=\"formProfile\" ng-submit=\"vm.submitProfile();\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"form-title\" translate=\"PROFILE.FORM\"></div><div class=\"more secondary-text\"><md-switch ng-model=\"vm.editable\" aria-label=\"Switch 1\"><span translate=\"PROFILE.EDITABLE\"></span></md-switch></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><label>{{ \'PROFILE.FORM_CATEGORY\' | translate }}</label><md-select name=\"category\" ng-model=\"vm.profile.category\" ng-disabled=\"!vm.editable\"><md-option><em>None</em></md-option></md-select><div ng-messages=\"formProfile.category.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_CATEGORY_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.profile.name\" placeholder=\"{{ \'PROFILE.FORM_NAME\' | translate }}\" ng-disabled=\"!vm.editable\" required=\"\"><div ng-messages=\"formProfile.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"national_id_number\" ng-model=\"vm.profile.national_id_number\" placeholder=\"{{ \'PROFILE.FORM_NATIONAL_ID\' | translate }}\" ng-disabled=\"!vm.editable\" required=\"\"><div ng-messages=\"formProfile.national_id_number.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_NATIONAL_ID_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><md-datepicker name=\"dob\" ng-model=\"vm.profile.dob\" placeholder=\"{{ \'PROFILE.FORM_DOB\' | translate }}\" ng-disabled=\"!vm.editable\"></md-datepicker><div ng-messages=\"formProfile.dob.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_DOB_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><label>{{ \'PROFILE.FORM_SEX\' | translate }}</label><md-select name=\"sex\" ng-model=\"vm.profile.sex\" ng-disabled=\"!vm.editable\"><md-option><em>None</em></md-option></md-select><div ng-messages=\"formProfile.sex.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_SEX_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"email\" ng-model=\"vm.profile.email\" placeholder=\"{{ \'PROFILE.FORM_EMAIL\' | translate }}\" ng-disabled=\"!vm.editable\" required=\"\"><div ng-messages=\"formProfile.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_EMAIL_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"phone_landline\" ng-model=\"vm.profile.phone_landline\" placeholder=\"{{ \'PROFILE.FORM_PHONE_LANDLINE\' | translate }}\" ng-disabled=\"!vm.editable\"><div ng-messages=\"formProfile.phone_landline.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_PHONE_LANDLINE_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"phone_mobile\" ng-model=\"vm.profile.phone_mobile\" placeholder=\"{{ \'PROFILE.FORM_PHONE_MOBILE\' | translate }}\" ng-disabled=\"!vm.editable\"><div ng-messages=\"formProfile.phone_mobile.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_PHONE_MOBILE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_street\" ng-model=\"vm.profile.address_street\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_STREET\' | translate }}\" ng-disabled=\"!vm.editable\"><div ng-messages=\"formProfile.address_street.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_STREET_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_line2\" ng-model=\"vm.profile.address_line2\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_LINE2\' | translate }}\" ng-disabled=\"!vm.editable\"><div ng-messages=\"formProfile.address_line2.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_LINE2_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_house_number\" ng-model=\"vm.profile.address_house_number\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_HOUSE_NUMBER\' | translate }}\" ng-disabled=\"!vm.editable\" required=\"\"><div ng-messages=\"formProfile.address_house_number.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_HOUSE_NUMBER_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_postal_code\" ng-model=\"vm.profile.address_postal_code\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_POSTAL_CODE\' | translate }}\" ng-disabled=\"!vm.editable\" required=\"\"><div ng-messages=\"formProfile.address_postal_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_POSTAL_CODE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_district\" ng-model=\"vm.profile.address_district\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_DISTRICT\' | translate }}\" ng-disabled=\"!vm.editable\" required=\"\"><div ng-messages=\"formProfile.address_district.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_DISTRICT_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_city\" ng-model=\"vm.profile.address_city\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_CITY\' | translate }}\" ng-disabled=\"!vm.editable\" required=\"\"><div ng-messages=\"formProfile.address_city.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_CITY_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_state\" ng-model=\"vm.profile.address_state\" placeholder=\"{{ \'PROFILE.FORM_ADDRESS_STATE\' | translate }}\" ng-disabled=\"!vm.editable\" required=\"\"><div ng-messages=\"formProfile.address_state.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PROFILE.FORM_ADDRESS_STATE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><footer layout=\"row\" layout-align=\"space-between center\" class=\"layout-align-space-between-center layout-row\"><div layout=\"row\" layout-align=\"start center\" class=\"layout-align-start-center layout-row\"></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'PROFILE.FORM_SUBMIT\' | translate }}\" ng-disabled=\"formProfile.$invalid || formProfile.$pristine\"><md-progress-circular style=\"float: left; top: 8px;left: 100px;\" ng-show=\"vm.loginProcess\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'PROFILE.FORM_SUBMIT\' | translate }}</md-button></footer></form></div></div>");
$templateCache.put("app/controlpanel/roles/views/dialogs/new-role-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"roleForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Novo privilegio</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-icon-float md-block\"><label translate=\"ROLE.NAME\">Name (required)</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.role.name\" type=\"text\" ng-required=\"\" md-autofocus=\"\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"ROLE.DESCRIPTION\">Last name</label><md-icon></md-icon><input ng-model=\"vm.role.description\" type=\"text\"></md-input-container><treeview data=\"CreateResources\" response=\"vm.resources\"></treeview></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.addNewRole()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\" translate=\"CONTACTS.ADD_CONTACT\" translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\">ADD CONTACT</md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm($event)\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/controlpanel/roles/views/tabs/roles.html","<a4-table items=\"vm.roles\" groups=\"vm.user\" sidebar-template=\"app/finance/person/views/sidenavs/sidenav.html\"></a4-table>");
$templateCache.put("app/crm/leads/lead/views/empresa-badges-educacionais.html","<span ng-if=\"empresa.tem_edu_creche\" class=\"badge\" style=\"margin-left: 0px !important; line-height: 26px !important;\"><span class=\"creche\">CRECHE</span></span> <span ng-if=\"empresa.tem_edu_infantil\" class=\"badge\" style=\"margin-left: 0px !important; line-height: 26px !important;\"><span class=\"infantil\">INFANTIL</span></span> <span ng-if=\"empresa.tem_edu_fundamental\" class=\"badge\" style=\"margin-left: 0px !important; line-height: 26px !important;\"><span class=\"fundamental\">FUNDAMENTAL</span></span> <span ng-if=\"empresa.tem_edu_superior\" class=\"badge\" style=\"margin-left: 0px !important; line-height: 26px !important;\"><span class=\"superior\">SUPERIOR</span></span> <span ng-if=\"empresa.tem_edu_tecnico\" class=\"badge\" style=\"margin-left: 0px !important; line-height: 26px !important;\"><span class=\"tecnico\">TECNICO</span></span>");
$templateCache.put("app/crm/leads/lead/views/empresa-endereco.html","<div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Cidade</label> <input readonly=\"\" ng-model=\"empresa.municipio\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Estado</label> <input readonly=\"\" ng-model=\"empresa.uf\" flex=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Endereço</label> <input readonly=\"\" ng-model=\"empresa.endereco\" flex=\"\"></md-input-container></div>");
$templateCache.put("app/crm/leads/lead/views/lead.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.backPage()\" style=\"margin-right: 10px; !important;\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\" translate=\"\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-network\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{vm.lead.name}}</span></div></div><div><md-button ng-click=\"vm.editLead()\">Editar lead<md-icon md-font-icon=\"icon-pen\"></md-icon></md-button><md-button ng-click=\"vm.createEvent()\">Adicionar evento<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></md-toolbar><md-content style=\"background-color: whitesmoke !important;\"><div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"60\"><md-card layout=\"column\"><form><div style=\"background-color: whitesmoke; height: 37px; padding: 8px;\"><span style=\"font-size: 16px; padding: 7px; color: #7b7b7b\">Empresa</span></div><md-divider></md-divider><div class=\"md-padding\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Nome</label> <input readonly=\"\" ng-model=\"vm.lead.name\" flex=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Cidade</label> <input readonly=\"\" ng-model=\"vm.lead.address_city\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Estado</label> <input readonly=\"\" ng-model=\"vm.lead.address_state\" flex=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"40\"><label>Rua</label> <input readonly=\"\" ng-model=\"vm.lead.address_street\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"40\"><label>Bairro</label> <input readonly=\"\" ng-model=\"vm.lead.address_district\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"20\"><label>Número</label> <input readonly=\"\" ng-model=\"vm.lead.address_house_number\" flex=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"33\"><label>Telefone 1</label> <input readonly=\"\" ng-model=\"vm.lead.phone_landline\" ui-br-phone-number=\"\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"33\"><label>Telefone 2</label> <input readonly=\"\" ng-model=\"vm.lead.phone_landline_2\" ui-br-phone-number=\"\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"33\"><label>Celular</label> <input readonly=\"\" ng-model=\"vm.lead.phone_mobile\" ui-br-phone-number=\"\" flex=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Email</label> <input readonly=\"\" ng-model=\"vm.lead.email\" flex=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Website</label> <input readonly=\"\" ng-model=\"vm.lead.website\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Facebook</label> <input readonly=\"\" ng-model=\"vm.lead.facebook\" flex=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"100\"><label>Notas iniciais</label> <input readonly=\"\" ng-model=\"vm.lead.initial_notes\" flex=\"\"></md-input-container></div></div></form></md-card><md-card><form><div style=\"background-color: whitesmoke; height: 37px; padding: 8px;\"><span style=\"font-size: 16px; padding: 7px; color: #7b7b7b\">Contatos</span></div><md-divider></md-divider><div ng-repeat=\"contact in vm.contacts track by $index\"><div class=\"md-padding\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Nome</label> {{contact.name}} <span ng-if=\"contact.socios > 0\" class=\"badge\" style=\"margin-left: 0px !important; line-height: 26px !important;\"><span class=\"Socio\">SÓCIO</span></span><md-divider></md-divider></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Funções</label> <input readonly=\"\" ng-model=\"contact.roles_names\" flex=\"\"></md-input-container></div><div layout=\"row\" ng-if=\"contact.phone_landline !== null || contact.phone_mobile !== null\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Telefone</label> <input readonly=\"\" ng-model=\"contact.phone_landline\" ui-br-phone-number=\"\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Celular</label> <input readonly=\"\" ng-model=\"contact.phone_mobile\" ui-br-phone-number=\"\" flex=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Email</label> <input readonly=\"\" ng-model=\"contact.email\" flex=\"\"></md-input-container></div><div layout=\"row\" ng-if=\"contact.socios > 0 && (contact.cnpj !== null || contact.empresa !== null)\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>CNPJ</label> <input readonly=\"\" ng-model=\"contact.cnpj\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Empresa</label> <input readonly=\"\" ng-model=\"contact.empresa\" flex=\"\"></md-input-container></div><div layout=\"row\" ng-if=\"contact.socios > 0\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Qualificação de sócio</label> <input readonly=\"\" ng-model=\"contact.qualificacao\" flex=\"\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"50\"><label>Data de entrada na sociedade</label><date-picker readonly=\"\" without-icon=\"true\" read-only=\"true\" ng-model=\"contact.data_entrada_sociedade\" flex=\"\" style=\"margin-top: -20px !important;\"></date-picker></md-input-container></div></div><md-divider style=\"border: 2px dashed #90A4AE\" ng-if=\"$index !== (vm.contacts.length - 1)\"></md-divider></div></form></md-card><md-card flex=\"\" ng-if=\"vm.matrizFiliais.length > 0\"><form><div style=\"background-color: whitesmoke; height: 37px; padding: 8px;\"><span style=\"font-size: 16px; padding: 7px; color: #7b7b7b\">Matriz/Filiais</span></div><md-divider></md-divider><div ng-repeat=\"empresa in vm.matrizFiliais track by $index\"><div class=\"md-padding\"><div layout=\"row\"><md-input-container class=\"md-input-has-placeholder md-block\" flex=\"\"><label>Razão social</label> {{empresa.razao_social}} <span class=\"badge\" ng-if=\"empresa.cnpj_ordem === \'0001\'\" style=\"margin-left: 0px !important; line-height: 26px !important;\"><span class=\"fundamental\">MATRIZ</span></span> <span class=\"badge\" ng-if=\"empresa.cnpj_ordem !== \'0001\'\" style=\"margin-left: 0px !important; line-height: 26px !important;\"><span class=\"tecnico\">FILIAL</span></span><md-divider></md-divider></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-input-has-placeholder md-block\" flex=\"\"><label>Nome fantasia</label> {{empresa.nome_fantasia}} <span ng-include=\"\'app/crm/leads/lead/views/empresa-badges-educacionais.html\'\"></span><md-divider></md-divider></md-input-container></div><div ng-include=\"\'app/crm/leads/lead/views/empresa-endereco.html\'\"></div></div><md-divider style=\"border: 2px dashed #90A4AE\" ng-if=\"$index !== (vm.matrizFiliais.length - 1)\"></md-divider></div></form></md-card><md-card ng-if=\"vm.outrasEmpresasSocios.length > 0\"><form><div style=\"background-color: whitesmoke; height: 37px; padding: 8px;\"><span style=\"font-size: 16px; padding: 7px; color: #7b7b7b\">Outras empresas dos sócios</span></div><md-divider></md-divider><div ng-repeat=\"empresa in vm.outrasEmpresasSocios track by $index\"><div class=\"md-padding\"><div layout=\"row\"><md-input-container class=\"md-input-has-placeholder md-block\" flex=\"\"><label>Nome da escola/empresa</label> {{empresa.nome_fantasia}} <span ng-include=\"\'app/crm/leads/lead/views/empresa-badges-educacionais.html\'\"></span><md-divider></md-divider></md-input-container></div><div ng-include=\"\'app/crm/leads/lead/views/empresa-endereco.html\'\"></div></div><md-divider style=\"border: 2px dashed #90A4AE\" ng-if=\"$index !== (vm.outrasEmpresasSocios.length - 1)\"></md-divider></div></form></md-card></div><div flex=\"40\"><h2>Próximas ações:</h2><hr><div flex=\"\" layout=\"row\"><div id=\"timeline-event\" class=\"timeline-right\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\" flex=\"100\" style=\"cursor: pointer\"><div ms-timeline-item=\"\" layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"event in vm.events\" ng-click=\"vm.editEvent(event)\" ng-if=\"event.date_done === null\" ng-include=\"\'app/crm/leads/lead/views/timeline-lead-template.html\'\"></div></div></div><h2>Histórico:</h2><hr><div flex=\"\" layout=\"row\"><div id=\"timeline-event\" class=\"timeline-right\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\" flex=\"100\" style=\"cursor: pointer\"><div ms-timeline-item=\"\" layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"event in vm.events\" ng-click=\"vm.editEvent(event)\" ng-if=\"event.date_done !== null\" ng-include=\"\'app/crm/leads/lead/views/timeline-lead-template.html\'\" flex=\"\"></div></div></div></div></div></md-content></div>");
$templateCache.put("app/crm/leads/lead/views/timeline-lead-template.html","<div class=\"timeline-point md-whiteframe-6dp\" style=\"background-color: rgba(105,58,195,0.49) !important;\"><md-icon md-font-icon=\"{{event.icons[event.event_format_id]}}\" style=\"border-radius: 50%;\"></md-icon></div><div class=\"timeline-detail\"><div class=\"time\">{{event.date_operation | date: \"dd/MM/yyyy\"}}<br>{{event.time_operation}}<br><span class=\"badge\" style=\"padding: 0 !important; margin: 0 !important;\"><span class=\"EventoResp\">{{event.person_event}}</span></span></div></div><div class=\"timeline-card\" layout=\"row\" style=\"min-width: 300px !important;\"><ms-card template=\"\'app/controlpanel/app-log/templates/template-5.html\'\" ng-model=\"event\"></ms-card></div>");
$templateCache.put("app/educational/classes/classrooms/dialog/lesson-artefact-dialog.html","<md-dialog aria-label=\"Upload\" style=\"width: 700px;\" md-theme=\"educational\"><form name=\"formArtefac\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span ng-show=\"vm.can_edit\">Anexar arquivos e links</span> <span ng-hide=\"vm.can_edit\">Arquivos e links disponíveis</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload><md-button class=\"md-raised\" ng-click=\"vm.addNewLink()\" aria-label=\"link\"><md-icon>link</md-icon>Adicionar links</md-button><md-list><md-list-item class=\"md-2-line artefact\" ng-repeat=\"artefact in vm.artefacts track by $index\" ng-click=\"vm.selectItem(artefact)\" ng-class=\"(artefact.form_view) ? \'artefact-selected\' : \'\'\" ng-init=\"artefact.form_view = (artefact.form_view) ? true : false\"><md-icon class=\"md-avatar-icon\" ng-show=\"artefact.type != \'link\' && !artefact.form_view\" ng-href=\"artefact.file_reference\">attach_file</md-icon><md-icon class=\"md-avatar-icon\" ng-show=\"artefact.type == \'link\' && !artefact.form_view\">link</md-icon><div class=\"md-list-item-text md-offset md-truncate\" ng-show=\"!artefact.form_view\"><h3 class=\"md-truncate\">{{ artefact.name }}</h3><p class=\"\">{{ artefact.notes }}</p></div><md-button class=\"md-secondary\" ng-show=\"!artefact.form_view\" ng-click=\"$event.preventDefault(); vm.openUrl(artefact.file_reference, artefact.extension);\"><md-icon>visibility</md-icon><md-tooltip md-direction=\"top\">Visualizar</md-tooltip></md-button><md-button class=\"md-secondary md-icon-button\" ng-show=\"!artefact.form_view\" ng-if=\"vm.can_edit\" ng-click=\"$event.preventDefault(); vm.removeItem($event, artefact)\" aria-label=\"delete\"><md-icon>delete</md-icon></md-button><div ng-show=\"artefact.form_view\" class=\"full-width\"><md-button class=\"md-icon-button close-form\" ng-click=\"vm.closeArtefact(artefact)\" aria-label=\"close\"><md-icon>close</md-icon></md-button><div layout=\"row\" ng-if=\"artefact.form_view\"><md-input-container flex=\"\"><input ng-model=\"artefact.name\" placeholder=\"Título\" class=\"autofocus\" required=\"\"></md-input-container><md-input-container ng-if=\"artefact.type == \'link\' || (artefact.extension == null && artefact.form_view)\" flex=\"60\"><input ng-model=\"artefact.file_reference\" placeholder=\"URL\" required=\"\"></md-input-container></div><div layout=\"row\" ng-if=\"artefact.form_view\"><md-input-container flex=\"100\"><textarea ng-model=\"artefact.notes\" placeholder=\"Observação\"></textarea></md-input-container><md-input-container flex=\"15\"><md-button ng-click=\"vm.submitOnlyLink($index, artefact)\" ng-disabled=\"formArtefac.$invalid || formArtefac.$pristine || $root.show_loader\" class=\"md-raised md-primary\">Salvar</md-button></md-input-container></div></div><md-divider></md-divider></md-list-item></md-list><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.close()\" ng-disabled=\"vm.disabled\">Fechar</md-button></md-dialog-actions></md-content></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/classes/classrooms/views/add-extra-lesson-modal.html","<md-dialog aria-label=\"Create Lesson Plan Item\" md-theme=\"educational\" style=\"min-width: 400px;min-height: 400px\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.form.lesson.lesson_id\">Adicionar aula extra</h2><h2 ng-if=\"vm.form.lesson.lesson_id\">Editar aula extra</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.closeModal()\" fields-schema=\"app/educational/classes/classrooms/form-create-extra-lesson.json\"></a4-form-dic-data></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/educational/classes/classrooms/views/classrooms.html","<md-card ng-init=\"vm.show_filter = false;\" style=\"box-shadow: none\"><div layout=\"row\" layout-align=\"end center\" flex=\"\" ng-show=\"vm.show_filter\"><div flex=\"50\"></div><div flex=\"45\"><date-range-picker ng-model=\"vm.form.lesson.date\" label=\"Datas\" selected-period=\"6\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></div><div flex=\"5\"><md-button flex=\"15\" ng-click=\"vm.paginate()\" ng-disabled=\"formArtefac.$invalid || formArtefac.$pristine || $root.show_loader\" class=\"md-fab md-mini\"><md-icon>search</md-icon></md-button></div></div><md-table-container class=\"vertical-container\" md-virtual-repeat-container=\"\" ng-style=\'{height: vm.windowHeight, \"min-height\": \"500px\" }\'><div layout=\"row\" layout-align=\"space-between center\" flex=\"\"><div flex=\"50\"><span style=\"padding: 4px; font-size: 12px !important;\" class=\"badge\" ng-if=\"vm.statistics.course_load !== null\"><md-tooltip>Carga horária definida na grade curricular</md-tooltip><span class=\"attendance_mode_1\">Carga horária: {{vm.statistics.course_load}}</span></span> <span style=\"padding: 4px; font-size: 12px !important;\" class=\"badge\"><md-tooltip>Quantidade de aulas previstas do início ao final do período letivo incluindo aulas extras</md-tooltip><span class=\"attendance_mode_1\">Previstas: {{vm.statistics.lessons_estimated_total}}</span></span><span style=\"padding: 4px; font-size: 12px !important;\" class=\"badge\" ng-if=\"vm.statistics.extra_lessons_total > 0\"><md-tooltip>Quantidade de aulas fora da grade de horário</md-tooltip><span class=\"attendance_mode_1\">Extras: {{vm.statistics.extra_lessons_total}}</span></span> <span style=\"padding: 4px; font-size: 12px !important;\" class=\"badge\" ng-if=\"vm.statistics.lessons_estimated_up_to_today > 0\"><md-tooltip>Quantidade de aulas que já ocorreram até hoje, independente de registradas como realizadas, incluindo aulas extras</md-tooltip><span class=\"attendance_mode_1\">Até hoje: {{vm.statistics.lessons_estimated_up_to_today}}</span></span><span style=\"padding: 4px; font-size: 12px !important;\" class=\"badge\" ng-if=\"vm.statistics.lessons_done > 0\"><md-tooltip>Quantidade de aulas que foram registradas como realizadas</md-tooltip><span class=\"Realizada\">Realizadas: {{vm.statistics.lessons_done}}</span></span><span style=\"padding: 4px; font-size: 12px !important;\" class=\"badge\" ng-if=\"vm.statistics.pending > 0\"><md-tooltip>Quantidade de aulas que já deveriam ter sido realizadas mas ainda estão pendentes</md-tooltip><span class=\"Pendente\">Pendentes: {{vm.statistics.pending}}</span></span><span style=\"padding: 4px; font-size: 12px !important;\" class=\"badge\" ng-if=\"vm.statistics.to_plan > 0\"><md-tooltip>Quantidade de aulas que já deveriam ter sido realizadas mas ainda estão pendentes</md-tooltip><span class=\"Planejar\">A planejar: {{vm.statistics.to_plan}}</span></span><span style=\"padding: 4px; font-size: 12px !important;\" class=\"badge\" ng-if=\"vm.statistics.excess > 0\"><md-tooltip>Aulas que vão além do período previsto pelo calendário escolar e não poderão ser realizadas</md-tooltip><span class=\"Excedida\">Excedidas: {{vm.statistics.excess}}</span></span></div><div layout=\"row\" layout-align=\"end center\" flex=\"70\"><span flex=\"30\"><date-range-picker ng-model=\"vm.filter_date_lesson\" label=\"Filtro para impressão\" flex=\"\"></date-range-picker></span><md-button ng-click=\"vm.printLessons(false)\" ng-disabled=\"vm.filter_date_lesson.startDate == null\"><md-icon md-font-icon=\"icon-printer\"></md-icon>Imprimir aulas</md-button><md-button ng-click=\"vm.printLessons(true)\" ng-disabled=\"vm.filter_date_lesson.startDate == null\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon>Impressão detalhada</md-button></div></div><table md-table=\"\" class=\"md-padding\" ng-style=\'{display: \"table\"}\'><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">#</th><th md-column=\"\">Data / Hora</th><th md-column=\"\" style=\"width: 10%\">Status</th><th md-column=\"\" style=\"width: 20%\">Tipo de aula</th><th md-column=\"\" style=\"width: 10%\">Anexos</th><th md-column=\"\" style=\"width: 20%\">Unidade temática</th><th md-column=\"\" style=\"width: 10%\">Ações</th></tr></thead><tbody md-body=\"\" style=\"width: 100%;\"><tr md-row=\"\" md-virtual-repeat=\"item in vm.grid.rows\" ng-disabled=\"item.has_no_lesson || item.lesson_status_name === \'Sem Aula\'\"><td md-cell=\"\">{{item.lesson_sequence}}</td><td md-cell=\"\"><span ng-if=\"item.lesson_date!=null\">{{item.date_hour}}</span> <span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"item.is_extra\"><span class=\"Extra\">Extra</span></span> <span class=\"badge\" style=\"padding: 0;margin-left: 0;\" ng-if=\"!item.is_extra && item.timetable_item_id===null && item.lesson_date!=null\"><span class=\"Extra\">Extra*</span></span></td><td md-cell=\"\"><span class=\"badge\" style=\"padding: 0;margin-left: 0;\"><span class=\"{{item.lesson_status_name}}\">{{item.lesson_status_name}}</span></span></td><td md-cell=\"\">{{item.lesson_type_name}}</td><td md-cell=\"\"><span ng-if=\"item.artifact_qty > 0\"><md-tooltip md-direction=\"left\">{{item.artifact_qty}} arquivo(s)</md-tooltip>{{item.artifact_qty}}<md-icon md-font-icon=\"icon-attachment\"></md-icon></span></td><td md-cell=\"\" ng-if=\"!item.has_no_lesson\">{{item.activity_homework}}</td><td md-cell=\"\" ng-if=\"item.has_no_lesson\">{{item.event}}</td><td md-cell=\"\" align=\"center\"><div layout=\"row\"><md-button ng-if=\"(item.insert_button || item.insert_above_button) && item.activity === null\" class=\"md-icon-button\" ng-click=\"vm.createNewPlan(item)\"><md-tooltip md-direction=\"left\">Adicionar planejamento de aula</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-if=\"item.undo_cancel_button\" ng-click=\"vm.undoCancelLesson(item)\"><md-tooltip md-direction=\"left\">Desfazer cancelamento</md-tooltip><md-icon>undo</md-icon></md-button><div class=\"actions\" layout=\"row\"><md-menu ng-if=\"!item.undo_cancel_button\"><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TABLE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"item.realize_button\"><md-button class=\"realize_lesson\" ng-click=\"vm.accomplishLesson(item)\"><md-icon>done</md-icon>Realizar aula</md-button></md-menu-item><md-menu-item ng-if=\"item.edit_button\"><md-button class=\"editar_lesson\" ng-click=\"vm.editLesson(item)\"><md-icon>edit</md-icon>Editar aula</md-button></md-menu-item><md-menu-item ng-if=\"item.edit_extra_button && item.is_extra\"><md-button class=\"editar_lesson\" ng-click=\"vm.editExtraLesson(item)\"><md-icon>edit</md-icon>Editar aula extra</md-button></md-menu-item><md-menu-item ng-if=\"item.delete_button && !item.is_extra && item.lesson_id\"><md-button class=\"delete_lesson\" ng-click=\"vm.deleteLesson(item.lesson_id, item)\"><md-icon>delete</md-icon>Excluir aula</md-button></md-menu-item><md-menu-item ng-if=\"item.delete_button && item.is_extra\"><md-button class=\"delete_lesson\" ng-click=\"vm.deleteExtraLesson(item)\"><md-icon>delete</md-icon>Excluir aula extra</md-button></md-menu-item><md-menu-item ng-if=\"item.undo_button\"><md-button class=\"undo_lesson\" ng-click=\"vm.undoLessonPerformed(item)\"><md-icon>undo</md-icon>Desfazer aula</md-button></md-menu-item><md-menu-item ng-if=\"item.cancel_button\" ng-click=\"vm.cancelLesson(item)\"><md-button class=\"cancel_lesson\"><md-icon>clear</md-icon>Cancelar aula</md-button></md-menu-item><md-menu-item ng-if=\"item.lesson_status_id === 1\" ng-click=\"vm.accomplishLesson(item)\"><md-button class=\"cancel_lesson\"><md-icon>autorenew</md-icon>Editar realização da aula</md-button></md-menu-item></md-menu-content></md-menu></div></div></td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/educational/classes/classrooms/views/lesson-plan-item-modal.html","<md-dialog aria-label=\"Create Lesson Plan Item\" md-theme=\"educational\" style=\"min-width: 500px;min-height: 500px\"><form ng-cloak=\"\" ng-submit=\"vm.submit(vm.lesson)\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.isEdit === false\">Adicionar plano para a aula do dia {{vm.lesson.date_hour}}</h2><h2 ng-if=\"vm.isEdit === true\">Editar o plano da aula do dia {{vm.lesson.date_hour}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Sequência</label> <input ng-model=\"vm.lesson.lesson_sequence\" placeholder=\"Próximo\" ng-disabled=\"vm.lesson.undo_button\"></md-input-container><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Tipo da aula</label><md-select ng-model=\"vm.lesson.lesson_type_id\" required=\"\" placeholder=\"\"><md-option ng-repeat=\"item in vm.types_list\" ng-value=\"item.id\" md-select-on-focus=\"item.vm.lesson.type\">{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Unidade temática</label> <textarea type=\"text\" ng-model=\"vm.lesson.activity\" rows=\"3\" required=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Objetivo de aprendizagem e desenvolvimento (Habilidades)</label> <textarea ng-model=\"vm.lesson.objectives\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Metodologia/Procedimentos</label> <textarea ng-model=\"vm.lesson.methodology\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Recursos empregados</label> <textarea ng-model=\"vm.lesson.resources\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Avaliação</label> <textarea ng-model=\"vm.lesson.evaluation\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Atividades para casa</label> <textarea ng-model=\"vm.lesson.homework\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Observações complementares</label> <textarea ng-model=\"vm.lesson.notes\" md-select-on-focus=\"\"></textarea></md-input-container></div><div layout=\"row\"><label>Arquivos</label></div><div layout=\"row\" class=\"form-wrapper\" style=\"padding-top: 0\" ng-if=\"vm.lesson.files.length\"><md-table-container style=\"width: 100%;\"><table md-table=\"\" ng-model=\"selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Ver</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.lesson.files\" ng-if=\"item.file_reference\"><td md-cell=\"\">{{item.name_display || item.name}}</td><td md-cell=\"\"><md-button class=\"md-secondary\" ng-click=\"vm.openUrl(item.file_reference, item.extension);\"><md-icon>visibility</md-icon><md-tooltip md-direction=\"top\">Visualizar</md-tooltip></md-button></td></tr></tbody></table></md-table-container></div><div layout=\"row\" class=\"form-wrapper\"><div flex=\"\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload><md-button class=\"md-raised\" ng-click=\"vm.addNewLink()\" aria-label=\"link\"><md-icon>link</md-icon>Adicionar links</md-button></div></div><div layout=\"row\" class=\"form-wrapper\" style=\"padding-top: 0\" ng-if=\"vm.adicionarNovoLink\"><md-table-container><table><tr md-row=\"\"><td><md-input-container flex=\"60\"><input ng-model=\"vm.novoLink.name\" placeholder=\"Título\" required=\"\"></md-input-container></td><td><md-input-container flex=\"60\"><input ng-model=\"vm.novoLink.file_reference\" placeholder=\"URL\" required=\"\"></md-input-container></td><td><md-input-container flex=\"60\"><input ng-model=\"vm.novoLink.notes\" placeholder=\"Observações\" required=\"\"></md-input-container></td><td><md-input-container flex=\"15\"><md-button ng-click=\"vm.salvarLink()\" class=\"md-raised md-primary\">Salvar</md-button></md-input-container></td></tr></table></md-table-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" name=\"close\" ng-disabled=\"form.$invalid || vm.disable\" class=\"md-raised md-primary\" ng-if=\"vm.isEdit === false\">Salvar e fechar</md-button><md-button type=\"submit\" ng-click=\"vm.addAnother = true\" name=\"add-another\" ng-disabled=\"form.$invalid || vm.disable\" class=\"md-raised md-primary\" ng-if=\"vm.isEdit === false\">Salvar e adicionar outra aula</md-button><md-button type=\"submit\" name=\"edit\" ng-click=\"vm.isEdit = true\" ng-disabled=\"form.$invalid || vm.disable\" class=\"md-raised md-primary\" ng-if=\"vm.isEdit === true\">Atualizar e fechar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/classes/classrooms/views/notes.html","<md-dialog md-theme=\"educational\"><md-toolbar class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><h2>Inserir uma observação</h2></div></div></md-toolbar><md-dialog-content><md-input-container class=\"md-icon-float md-block\" flex=\"\"><textarea ng-model=\"vm.scope\" placeholder=\"Observação\" rows=\"3\"></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.answer(vm.scope);\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/educational/classes/grades/views/grades.html","<div layout=\"row\" align=\"start center\"><div><form name=\"formNoteRelease\" novalidate=\"\"><table class=\"simple table-note-release no-border-top school-report fixed_headers a4-table-fixed\" style=\"overflow-y: scroll !important;\"><thead><tr ng-show=\"vm.is_detailed\"><th></th><th ng-repeat=\"grade in ::vm.grid.steps\" colspan=\"{{grade.siblingsqtd}}\" ng-show=\"vm.is_detailed\"><b>{{grade.name}}</b><md-tooltip md-direction=\"top\">{{grade.description}}</md-tooltip></th><th ng-show=\"vm.is_detailed\"></th></tr><tr><th class=\"text-align-left\">Alunos</th><th ng-repeat=\"grade in vm.grid.grades\" ng-if=\"vm.isNumber(grade.precision) && grade.pass_grade.length\" ng-show=\"(!vm.is_detailed) ? grade.show_on_grade : true\" class=\"hoverSubjectEvent\" ng-init=\"calculed = (grade.conditional != \'\') ? true : false; grade.oficial_name = (grade.label) ? grade.label : grade.name;\"><md-tooltip md-direction=\"top\">{{ grade.description}}</md-tooltip><strong class=\"strong\" ng-show=\"calculed\">{{grade.oficial_name}}</strong> <span ng-hide=\"calculed\">{{grade.oficial_name}}</span></th><th class=\"text-align-center\">Situação</th></tr></thead><tbody ng-style=\"{height: vm.windowHeight + \'px\'}\"><tr ng-repeat=\"(index, student) in vm.grid.students\"><td><span>{{ student.name }}</span></td><td ng-repeat=\"grade in vm.grid.grades\" ng-if=\"vm.isNumber(grade.precision) && grade.pass_grade.length\" ng-show=\"(!vm.is_detailed) ? grade.show_on_grade : true\" class=\"align-center\"><span ng-init=\"thisName = \'P_\'+id+\'-\'+student.person_id;\"><span ng-class=\"{ \'note-release-disapproved\': student.grade_json[grade.name].value < vm.getValue(grade.name, \'pass_grade\'), \'note-release-approved\' : student.grade_json[grade.name].value >= vm.getValue(grade.name, \'pass_grade\'), \'note-release-council\' : student.grade_json[grade.name].valueCouncil.length && student.grade_json[grade.name].valueCouncil !== null }\">{{ student.grade_json[grade.name].value | number:grade.precision}}<md-tooltip md-direction=\"top\" ng-if=\"student.grade_json[grade.name].value\"><span ng-if=\"student.grade_json[grade.name].value < vm.getValue(grade.name, \'pass_grade\')\">Reprovada</span> <span ng-if=\"student.grade_json[grade.name].value >= vm.getValue(grade.name, \'pass_grade\')\">Aprovada</span> <span ng-if=\"student.grade_json[grade.name].valueCouncil.length && student.grade_json[grade.name].valueCouncil !== null\">- Nota atibuída por conselho de classe</span></md-tooltip><md-tooltip md-direction=\"left\" ng-if=\"student.grade_json[grade.name].value\">Média: {{grade.pass_grade}}</md-tooltip><md-tooltip md-direction=\"right\" ng-if=\"student.grade_json[grade.name].value\">Máx: {{grade.max_grade}}</md-tooltip><md-tooltip md-direction=\"bottom\" ng-if=\"student.grade_json[grade.name].value\" ng-init=\"percent = student.grade_json[grade.name].value / grade.max_grade * 100;\">Alcançou: {{ percent | number:0}}%</md-tooltip></span></span></td><td class=\"align-center\"><md-tooltip md-direction=\"top\">{{student.academic_status_name}}</md-tooltip><span>{{student.academic_status_code}}</span></td></tr></tbody></table></form></div></div>");
$templateCache.put("app/educational/classes/notes-pending/views/notes-pending.html","<md-content layout-padding=\"\"><md-content layout-row=\"\"><form><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Pendências de notas</b> <small>O grid abaixo detalha as notas pendentes de lançamento pelo professor</small></div></div></form><a4-pendent-grades pendent-grades=\"vm.pendentGrades\" for=\"\'class\'\"></a4-pendent-grades></md-content></md-content>");
$templateCache.put("app/educational/classes/notes-release/views/notes-release.html","<h2>Lançamento de notas</h2>");
$templateCache.put("app/educational/classes/students/views/students.html","<md-content class=\"md-padding\"><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">#</th><th md-column=\"\">Aluno</th><th md-column=\"\">Frequência</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-select-id=\"bill_id\" md-auto-select=\"\" style=\"cursor: pointer\" ng-repeat=\"item in vm.students\"><td md-cell=\"\">{{item.number}}</td><td md-cell=\"\">{{item.name_display || item.name}}<br><small ng-if=\"item.name_display != null\">{{item.name}}</small></td><td md-cell=\"\">{{item.frequency_count}}</td><td md-cell=\"\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" style=\"width: 20px !important; padding: 0 !important; margin: 0 !important;\" ng-click=\"$mdMenu.open(event);$event.stopPropagation();$event.preventDefault();\"><md-icon md-menu-origin=\"\">more_vert</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item class=\"md-in-menu-bar\"><md-button class=\"md-button\" ng-click=\"vm.createOccurrence(item.person_id);\"><md-icon md-menu-origin=\"\">mode_edit</md-icon>Adicionar ocorrência</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></md-content>");
$templateCache.put("app/educational/classes/yield-graph/views/yield-graph.html","<a4-charts flex=\"\" educational=\"true\" with-printer=\"true\" labels=\"vm.chart.labels\" series=\"vm.chart.series\" data=\"vm.chart.data\" filter-date=\"filterDate\" selected-account=\"selectedAccount\" colors=\"vm.chart.colors\" all-movements=\"allMovements\"></a4-charts>");
$templateCache.put("app/educational/collaborators/classes/views/classes.html","<md-content layout-padding=\"\" ng-if=\"!vm.checkPolicies(\'colab\')\"><div layout=\"row\" layout-align=\"end center\"><span flex=\"20\"><date-range-picker ng-model=\"vm.filter_date_lesson\" label=\"Filtro para impressão\" flex=\"\"></date-range-picker></span><md-button ng-click=\"vm.printHoursLessons(false)\" ng-disabled=\"vm.filter_date_lesson.startDate == null\"><md-icon md-font-icon=\"icon-printer\"></md-icon>Imprimir horas/aulas</md-button><md-button ng-click=\"vm.printLessons(false)\" ng-disabled=\"vm.filter_date_lesson.startDate == null\"><md-icon md-font-icon=\"icon-printer\"></md-icon>Imprimir aulas</md-button><md-button ng-click=\"vm.printLessons(true)\" ng-disabled=\"vm.filter_date_lesson.startDate == null\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon>Impressão detalhada</md-button></div><md-content layout=\"row\"><a4-form-dic-data bind=\"vm.grid\" on-click-item=\"vm.viewClass(item)\" policies=\"{show:\'colab\'}\" fields-schema=\"app/educational/collaborators/classes/grid.json\"></a4-form-dic-data></md-content></md-content>");
$templateCache.put("app/educational/collaborators/documents/views/documents.html","<md-content layout=\"row\"><div flex=\"\"><a4-person-documents person-id=\"vm.person_id\"></a4-person-documents></div></md-content>");
$templateCache.put("app/educational/collaborators/occurrences/views/create.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"width: 700px;\"><form ng-cloak=\"\" ng-submit=\"vm.submit(vm.form.event, form_occurrences)\" name=\"form_occurrences\" novalidate=\"\"><md-toolbar layout=\"row\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><h2 style=\"margin-left: 15px\" ng-if=\"!vm.form.occurrence.id\">Adicionar ocorrência</h2><h2 style=\"margin-left: 15px\" ng-if=\"vm.form.occurrence.id\">Editar ocorrência</h2></div><div layout=\"row\" layout-align=\"end center\" class=\"layout-align-center\" flex=\"\"><md-button style=\"margin-top: -500px\" class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div layout=\"row\" flex=\"\"><div flex=\"\"><date-picker ng-model=\"vm.form.event.date_done\" flex=\"\" placeholder=\"Data da Ocorrência\" max-date=\"vm.today\" tabindex=\"0\" ng-change=\"m.verifyDate()\"></date-picker></div><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Tipo da Ocorrência</label><md-icon md-font-icon=\"icon-format-list-numbers\"></md-icon><md-select ng-model=\"vm.form.event.event_type_id\" required=\"\" name=\"event_type_id\"><md-option ng-repeat=\"item in vm.list.event.event_type_id\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div ng-messages=\"form_occurrences.event_type_id.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar o tipo da ocorrência.</div></div></md-input-container></div><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Ocorrido</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.form.event.notes_done\" required=\"\" name=\"notes_done\"><div ng-messages=\"form_occurrences.notes_done.$error\"><div ng-message=\"required\">Você <b>deve</b> descrever o ocorrido.</div></div></md-input-container><div flex=\"\" layout=\"row\"><div flex=\"50\"><md-checkbox ng-model=\"vm.form.event.is_to_publish\" tabindex=\"-1\" ng-disabled=\"vm.form.event.is_confidencial\"><span>Publicar?</span></md-checkbox></div><div flex=\"50\"><md-checkbox ng-model=\"vm.form.event.is_confidencial\" tabindex=\"-1\" ng-change=\"vm.disableToPublish()\"><span>É Confidencial?</span></md-checkbox></div></div></div></md-dialog-content><md-dialog-actions><md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"vm.loading\"><md-progress-circular ng-show=\"vm.loading\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!vm.loading\" md-font-icon=\"icon-check\"></md-icon><span ng-if=\"!vm.form.occurrence.id\">Adicionar</span> <span ng-if=\"vm.form.occurrence.id\">Editar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/collaborators/occurrences/views/occurrences.html","<md-content layout=\"column\" ng-if=\"!vm.checkPolicies(\'colab_ocor\')\"><div flex=\"\" style=\"text-align: center\"><md-input-container flex=\"15\" style=\"width: 15%\"><label>Tipo de ocorrência</label><md-select ng-model=\"vm.occurrence_type\" ng-change=\"vm.getCollaboratorOccurrences()\"><md-option ng-value=\"null\">Todos os tipos</md-option><md-option ng-repeat=\"type in vm.occurrence_types\" ng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container></div><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.grid.current_page\" md-page-select=\"\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.getCollaboratorOccurrences\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination><md-table-container class=\"table-float-button\"><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Ocorrido</th><th md-column=\"\">Tipo</th><th md-column=\"\">Criado por</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.grid.data\" style=\"cursor: pointer;\"><td md-cell=\"\">{{item.occurrence_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\">{{item.is_confidencial ? \'*********\' : item.occurrence_name}}</td><td md-cell=\"\">{{item.occurrence_type}}</td><td md-cell=\"\">{{item.person_responsible_occurrence}}</td><td md-cell=\"\" ng-if=\"!vm.checkProfile(1) && !vm.checkProfile(2)\"><md-button ng-click=\"vm.delete(item);$event.stopPropagation()\" class=\"md-icon-button\" ng-if=\"vm.grid.name === item.person_responsible_occurrence\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Excluir</md-tooltip></md-button></td><td md-cell=\"\" ng-if=\"!vm.checkProfile(1) && !vm.checkProfile(2)\"><md-button ng-click=\"vm.editOccurrence(item)\" class=\"md-icon-button\" ng-if=\"vm.grid.name === item.person_responsible_occurrence\"><md-tooltip>Editar</md-tooltip><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.grid.current_page\" md-page-select=\"\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.getCollaboratorOccurrences\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination></md-content>");
$templateCache.put("app/educational/collaborators/pendencies/views/pendencies.html","<md-content layout-padding=\"\"><md-content layout-row=\"\"><form><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Pendências de notas</b> <small>O grid abaixo detalha as notas pendentes de lançamento pelo professor</small></div></div></form><a4-pendent-grades pendent-grades=\"vm.pendentGrades\" for=\"\'teacher\'\"></a4-pendent-grades></md-content></md-content>");
$templateCache.put("app/educational/collaborators/timetable/views/timetable.html","<a4-calendar ng-model=\"vm.events_calendar\" person-id=\"vm.teacherId\" events=\"vm.getLessons(id, start, end)\"></a4-calendar>");
$templateCache.put("app/educational/course/documents/views/documents.html","<md-content layout=\"row\"><div flex=\"\"><md-table-container><table md-table=\"\" class=\"dataTable row-border hover\" ng-model=\"vm.selected_documents\" md-row-select=\"\" multiple=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\">Exigido</th><th md-column=\"\">Ações</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-select-id=\"id\" md-on-select=\"vm.format_selected()\" ng-repeat=\"item in vm.grid.rows track by $index\"><td md-cell=\"\">{{ item.name }}</td><td md-cell=\"\"><a4-switch-button ng-if=\"item.enrolment_item_course\" states=\"vm.buttonIsMandatory\" format-string=\"false\" data-ng-model=\"item.is_mandatory\"></a4-switch-button></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete(item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr><tr><md-button ng-click=\"vm.create()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar novo documento</md-button></tr></tbody></table></md-table-container></div></md-content>");
$templateCache.put("app/educational/course/documents/views/modal_create_document.html","<md-dialog aria-label=\"Create Coordinator\" md-theme=\"educational\" style=\"min-width: 350px; min-height: 300px\"><form ng-cloak=\"\" name=\"form\" ng-submit=\"vm.submit(vm.form)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Criar documento</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close(false)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div style=\"padding-top: 30px; padding-left: 10px;\"><md-input-container style=\"width: 330px;\" required=\"\"><label>Nome do documento</label> <input ng-model=\"vm.form.name\" style=\"height: 100%\"></md-input-container></div><div style=\"padding-top: 2px; padding-left: 10px; padding-bottom: 5px;\"><md-input-container><md-checkbox ng-model=\"vm.form.is_mandatory\" flex=\"\">É exigido?</md-checkbox></md-input-container></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close(false)\">Cancelar</md-button><md-button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"md-raised md-primary\" style=\"padding: 1px;\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/course/documents/views/modal_select_document.html","<md-dialog aria-label=\"Create Coordinator\" md-theme=\"educational\" style=\"min-width: 500px; min-height: 150px\"><form ng-cloak=\"\" name=\"form\" ng-submit=\"vm.importDocumentsFromCourse(form)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Importar documentos de outro curso</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-input-container style=\"padding-bottom: 50px; padding-top: 20px;\"><md-autocomplete flex=\"\" required=\"\" md-selected-item=\"vm.selectedCourse\" md-no-cache=\"true\" md-delay=\"500\" md-search-text=\"vm.searchCourse\" md-items=\"item in vm.queryDocumentsCourse(vm.searchCourse)\" md-item-text=\"item.name\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Selecione o curso que deseja importar os documentos\"><md-item-template><span class=\"item-title\"><md-icon md-font-icon=\"icon-city\"></md-icon><span md-highlight-text=\"vm.searchCourse\">{{item.name}}</span></span></md-item-template><md-not-found>Nenhum curso encontrado</md-not-found></md-autocomplete></md-input-container><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close(false)\">Cancelar</md-button><md-button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"md-raised md-primary\" style=\"padding: 1px;\">Importar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/course/group/views/add-group.html","<div style=\"width: 700px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submit(vm.form.group, formaddgroup)\" name=\"formaddgroup\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Criar Turma</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Dados gerais da turma</b> <small>Preencha as informações para a criação da turma</small></div></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\" ng-if=\"!vm.contract.date_end\"><label>Nome da turma</label><md-icon md-font-icon=\"icon-alphabetical\"></md-icon><input ng-model=\"vm.form.group.name\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\" ng-if=\"!vm.contract.date_end\"><label>Capacidade de alunos</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"vm.form.group.capacity\" required=\"\" type=\"number\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Critério de avaliação</label><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><md-select ng-model=\"vm.form.group.grade_rule_id\" required=\"\" name=\"grade_rule\" aria-label=\"Critério de avaliação\"><md-option ng-value=\"grade_rule.id\" ng-repeat=\"grade_rule in vm.list.group.grade_rule_id track by $index\">{{grade_rule.name}}</md-option></md-select><div ng-messages=\"formaddgroup.grade_rule.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar o critério de avaliação.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Grade Curricular</label><md-icon md-font-icon=\"icon-grid\"></md-icon><md-progress-circular ng-show=\"show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"20px\"></md-progress-circular><md-select ng-model=\"vm.form.group.matrix\" required=\"\" name=\"matrix\" aria-label=\"Grade Curricular\" ng-change=\"vm.getGroupSchedules(vm.form.group.matrix)\"><md-option ng-value=\"matrix\" ng-repeat=\"matrix in vm.list.group.matrix_id track by $index\">{{matrix.name}}</md-option></md-select><div ng-messages=\"formaddgroup.matrix.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar a grade curricular.</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex=\"\"><label>Turno</label><md-icon md-font-icon=\"icon-clock\"></md-icon><md-select ng-model=\"vm.form.group.group_shift_id\" required=\"\" name=\"group_shift\" placeholder=\"\" aria-label=\"Turno\"><md-option ng-value=\"group_shift.id\" ng-repeat=\"group_shift in vm.list.group.group_shift_id track by $index\">{{group_shift.name}}</md-option></md-select><div ng-messages=\"formaddgroup.group_shift.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar o turno.</div></div></md-input-container></div><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Datas</b> <small>Preencha as datas de início e fim dos períodos da turma</small></div></div><div layout=\"column\"><div flex=\"\" layout=\"row\" ng-repeat=\"period in vm.form.group.group_period track by $index\"><date-picker flex=\"50\" ng-required=\"vm.form.group.is_without_school_period\" placeholder=\"Data inicial no periodo\" ng-model=\"period.initial_date\"></date-picker><date-picker flex=\"50\" placeholder=\"Data final no periodo\" ng-model=\"period.final_date\"></date-picker></div></div><div layout=\"collumn\" layout-align=\"end center\"><md-button type=\"button\" class=\"md-raised\" ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"show_loader || formaddgroup.$invalid\" layout=\"row\"><md-progress-circular ng-disabled=\"!show_loader\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Salvar turma</span></md-button></div></md-content></form></div>");
$templateCache.put("app/educational/course/group/views/change-matrix.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\"><form ng-cloak=\"\" ng-submit=\"vm.submit()\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Selecionar grade curricular</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><h2 style=\"text-align: center\">Atenção, essa ação será executada em todos os alunos matriculados!</h2><div class=\"md-dialog-content\"><md-input-container class=\"title-select\" ng-show=\"vm.matrix.length\" required=\"\"><label>Grade curricular</label><md-select ng-model=\"vm.selected_matrix\" required=\"true\"><md-option ng-repeat=\"matrix in vm.matrix\" ng-value=\"matrix.id\">{{matrix.name}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" ng-disabled=\"(angular.isDefined(vm.selected_matrix) || vm.selected_matrix == null)\" class=\"md-raised md-primary\" style=\"padding: 1px;\">Salvar<md-progress-circular ng-show=\"vm.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/course/group/views/group.html","<md-input-container flex=\"20\" style=\"margin-top: 10px\" ng-if=\"vm.is_without_school_period\"><md-checkbox ng-model=\"vm.show_group_completed\" ng-change=\"vm.getAllGroup(1, 20, vm.show_group_completed)\">Mostrar turmas concluidas</md-checkbox></md-input-container><a4-groups show-group-completed=\"vm.show_group_completed\" is-without-school-period=\"vm.is_without_school_period\" show-course=\"false\" course-id=\"vm.course_id\"></a4-groups>");
$templateCache.put("app/educational/course/matrix/views/matrix.html","<md-content layout-padding=\"\" class=\"with-btn-add\"><div class=\"there-are-no\" layout-align=\"center center\" layout=\"column\" flex=\"\" ng-show=\"!vm.matrix.length\"><div><md-icon>info_outline</md-icon></div><div class=\"preview-scale\"><strong>Não há registros ;(</strong></div></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"title-select\" ng-show=\"vm.matrix.length\"><label>Grade curricular</label><md-select ng-model=\"vm.selected_matrix\" ng-change=\"vm.changeMatrix(vm.selected_matrix)\"><md-option ng-repeat=\"(index,matrix) in vm.matrix\" ng-value=\"matrix\" ng-selected=\"index === vm.matrix.length-1\">{{matrix.name}}</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" aria-label=\"Alterar grade\" ng-show=\"vm.selected_matrix.matrix_period\" ng-click=\"vm.form.mode_edit = !vm.form.mode_edit; vm.editMatrixPeriod();\"><md-tooltip>Alterar</md-tooltip><md-icon>mode_edit</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Excluir grade\" ng-show=\"vm.selected_matrix.matrix_period\" ng-click=\"vm.deleteMatrix(vm.selected_matrix.id)\"><md-tooltip>Excluir</md-tooltip><md-icon>remove_circle</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Excluir grade\" ng-show=\"vm.selected_matrix.matrix_period\" ng-click=\"vm.printMatrix(vm.selected_matrix.id)\"><md-tooltip>Imprimir</md-tooltip><md-icon>print</md-icon></md-button></div><md-button class=\"md-fab md-fab-top-right\" aria-label=\"Criar nova grade\" ng-click=\"vm.createMatrixPeriod(\'create\')\"><md-tooltip md-direction=\"left\">Criar grade</md-tooltip><md-icon>add</md-icon></md-button><table class=\"simple\" ng-show=\"vm.selected_matrix.matrix_period\"><thead><tr><th colspan=\"2\">Nome</th><th>Apelido</th><th style=\"text-align: center !important;\">CH (Peso)</th><th style=\"text-align: center !important;\">Obrigatoriedade</th><th style=\"text-align: right !important; max-width: 5px\"></th><th style=\"text-align: right !important; max-width: 5px\"></th></tr></thead><tfoot></tfoot><tbody><tr ng-repeat-start=\"item in vm.selected_matrix.matrix_period track by $index\" class=\"group-table\"><td><strong>{{vm.selected_matrix.matrix_period.length > 1 ? item.matrix_period + \'º Periodo\' : \'2 da grade\'}}</strong></td><td></td><td></td><td></td><td></td><td style=\"padding: 0; text-align: right !important; max-width: 5px\"><md-button class=\"md-icon-button\" ng-click=\"vm.addSubject(item);\" aria-label=\"Close dialog\"><md-tooltip md-direction=\"left\">Adicionar disciplina</md-tooltip><md-icon>add</md-icon></md-button></td><td style=\"padding: 0; text-align: right !important; max-width: 5px\"><md-button class=\"md-icon-button\" ng-show=\"vm.form.course.course_equivalence_id >= 300\" ng-click=\"vm.editPeriod(item);\" aria-label=\"Close dialog\"><md-tooltip md-direction=\"left\">Editar período</md-tooltip><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr><tr ng-repeat-start=\"subject_item in item.subjects track by $index\" style=\"{{subject_item.special_type > 0 ? \'height: 45.56px; background-color: #fcfcd7\' : \'cursor: pointer\'}}\" ng-click=\"subject_item.special_type > 0 ? \'\' : vm.editSubject(item, subject_item, null)\"><td colspan=\"2\">{{ subject_item.name }} <span><small><br>{{subject_item.special_type == 1 ? \'Agrupamento de lançamento de aulas\' : subject_item.special_type == 2 ? \'Agrupamento de lançamento de notas\' : \'\'}}</small></span></td><td>{{ subject_item.alias }}</td><td align=\"center\">{{ subject_item.special_type != 0 ? \'\' : subject_item.course_load }} {{ subject_item.special_type != 0 || subject_item.weight == null ? \'\' : \' (\' + subject_item.weight + \')\' }}</td><td align=\"center\">{{ subject_item.special_type != 0 ? \'\' : vm.how_required_text(subject_item.how_required); }}</td><td style=\"padding: 0; text-align: right !important; max-width: 5px\"><md-button class=\"md-icon-button\" ng-if=\"subject_item.subject_id_parent == null && subject_item.special_type == 0\" ng-click=\"vm.addSubject(item, subject_item.id); $event.stopPropagation();\" aria-label=\"Close dialog\"><md-tooltip md-direction=\"left\">Adicionar sub-disciplina</md-tooltip><md-icon>add</md-icon></md-button></td><td style=\"padding: 0; text-align: right !important; max-width: 5px\"><md-button ng-click=\"vm.deleteSubject(item, subject_item, null, $event)\" ng-show=\"!subject_item.block_delete && subject_item.special_type == 0\" class=\"md-icon-button\" style=\"margin: 0 20px 0 0;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COURSE.DELETE\"><md-tooltip md-direction=\"left\">{{subject_item.message_block_delete}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-show=\"subject_item.block_delete && subject_item.special_type == 0\" class=\"md-icon-button button-disable\" style=\"margin: 0 20px 0 0;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COURSE.DELETE\"><md-tooltip md-direction=\"left\">{{subject_item.message_block_delete}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr><tr ng-repeat-end=\"\" ng-repeat=\"sub_subjects in subject_item.subjects track by $index\" ng-click=\"vm.editSubject(item, sub_subjects, sub_subjects.subject_id_parent)\" style=\"cursor: pointer\"><td style=\"font-style: italic\">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{ sub_subjects.name }}</td><td></td><td>{{ sub_subjects.alias }}</td><td align=\"center\">{{ sub_subjects.course_load !== null ? sub_subjects.course_load : \'--\' }} {{ sub_subjects.weight !== null ? \' (\' + sub_subjects.weight + \')\' : \'\' }}</td><td align=\"center\">{{ vm.how_required_text(sub_subjects.how_required); }}</td><td style=\"padding: 0; text-align: right !important; max-width: 5px\"><md-button class=\"md-icon-button\" ng-if=\"subject_item.subject_id_parent == null\" ng-click=\"vm.addSubject(item, subject_item.id);\" aria-label=\"Close dialog\"></md-button></td><td style=\"padding: 0; text-align: right !important; max-width: 5px\"><md-button ng-click=\"vm.deleteSubject(item, sub_subjects, subject_item, $event)\" ng-show=\"!sub_subjects.block_delete\" class=\"md-icon-button\" style=\"margin: 0 20px 0 0;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COURSE.DELETE\"><md-tooltip md-direction=\"left\">{{sub_subjects.message_block_delete}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-show=\"sub_subjects.block_delete\" class=\"md-icon-button button-disable\" style=\"margin: 0 20px 0 0;\" aria-label=\"delete\" translate=\"\" translate-attr-aria-label=\"COURSE.DELETE\"><md-tooltip md-direction=\"left\">{{sub_subjects.message_block_delete}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr><tr ng-repeat-end=\"\" ng-hide=\"true\"></tr></tbody></table></md-content>");
$templateCache.put("app/educational/course/students/views/change-group-modal.html","<md-dialog aria-label=\"Change Group\" md-theme=\"educational\" style=\"min-width: 350px; min-height: 150px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Mudança de turma</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div style=\"padding: 40px; width: 90%;\"><md-select ng-model=\"vm.scope.selected_group\"><md-option ng-repeat=\"group in vm.scope.groups\" ng-value=\"group\" ng-if=\"group.id !== vm.scope.group_id_selected\">{{group.name}}</md-option></md-select></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.answer(vm.scope.selected_group)\" style=\"padding: 1px;\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/educational/course/students/views/students.html","<md-content layout-padding=\"\"><div layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"20\" style=\"margin-top: 10px\"><md-select ng-model=\"vm.group_selected\" ng-change=\"vm.getStudents(null, null, null)\" multiple=\"\"><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"vm.changeGroup()\"><md-icon>swap_horiz</md-icon>Trocar de turma</md-button></div><md-card class=\"md-padding\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\">Matrícula</th><th md-column=\"\">Turma</th><th md-column=\"\">#</th><th md-column=\"\">Nome</th><th md-column=\"\">Status</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"student in vm.students\" ng-click=\"vm.goToStudent(student)\"><td md-cell=\"\"><md-checkbox ng-click=\"vm.selectStudent(student); $event.stopPropagation();\" ng-checked=\"vm.isChecked(student.person_id)\" ng-if=\"vm.selected_students.length === 0 || vm.selected_students[0].group_id === student.group_id\" aria-label=\"checkbox\"></md-checkbox></td><td md-cell=\"\">{{student.number}}</td><td md-cell=\"\">{{student.group_name}}</td><td md-cell=\"\">{{student.group_sequence}}</td><td md-cell=\"\">{{student.name}}</td><td md-cell=\"\"><span class=\"badge\"><span class=\"enrolment_status enrolment_status {{student.enrolment_status}}\">{{student.enrolment_status}}</span></span></td></tr></tbody></table></md-table-container></md-card></md-content>");
$templateCache.put("app/educational/course/views/forms/form-course.html","<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.course.id == null\">{{\'COURSE.FORM_CREATE\' | translate }}</span> <span class=\"title\" ng-show=\"vm.course.id != null\">{{\'COURSE.FORM_EDIT\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-if=\"vm.objectName\" ng-init=\"vm.form = vm.objectName\"></div><md-content class=\"md-padding\"><a4-form-dic-data bind=\"vm.form\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/course/form.json\"></a4-form-dic-data></md-content>");
$templateCache.put("app/educational/course-group/views/forms/form-course-group.html","<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.course.id == null\">{{\'COURSE.FORM_CREATE\' | translate }}</span> <span class=\"title\" ng-show=\"vm.course.id != null\">{{\'COURSE.FORM_EDIT\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-if=\"vm.objectName\" ng-init=\"vm.form = vm.objectName\"></div><md-content class=\"md-padding\"><a4-form-dic-data bind=\"vm.form\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" policies=\"{cud:\'curso_alt\'}\" fields-schema=\"app/educational/course/form.json\"></a4-form-dic-data></md-content>");
$templateCache.put("app/educational/enrolment/enrolment-steps/address/address.html","<hr><form name=\"form_wizard_address\" novalidate=\"\" autocomplete=\"off\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.address, false, form_wizard_address)\"><md-content class=\"md-padding\"><a4-student-contact-form student=\"enrolment.form.student\" is-enabled=\"true\"></a4-student-contact-form></md-content><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"enrolment.stepSelected < 9\" class=\"md-primary md-raised\" ng-click=\"vm.enableNextStep()\" ng-disabled=\"$root.show_loader\">Próximo<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/enrolment/enrolment-steps/address/modal-select-home.html","<md-dialog aria-label=\"Moradia\" md-theme=\"educational\" style=\"width: 450px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Seleção de moradia do aluno</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><div style=\"padding: 10px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Seleção de moradia do aluno</b> <small>Selecione abaixo com qual dos responsáveis o aluno mora</small></div></div><div layout=\"row\" style=\"margin-top: 15px;\"><md-input-container style=\"width: 100%;\"><md-select ng-model=\"vm.scope.responsible_selected\"><md-option ng-repeat=\"responsible in vm.scope.responsibles\" ng-value=\"responsible\">{{responsible.name}}</md-option><md-option ng-value=\"null\">Nenhum</md-option></md-select></md-input-container></div></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; width: 100%\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(vm.scope.responsible_selected)\" ng-disabled=\"form.$invalid\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/enrolment/enrolment-steps/course/course.html","<hr><form name=\"form_wizard_course\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.course, false, form_wizard_course)\"><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"50\"><label>Curso</label><md-icon md-font-icon=\"icon-school\"></md-icon><md-select name=\"course\" ng-change=\"vm.setGroups(enrolment.form.timetable.course_id); enrolment.form.timetable.group_id = null;\" ng-model=\"enrolment.form.timetable.course_id\" required=\"\"><md-optgroup label=\"Cursos\"><md-option ng-repeat=\"item in vm.courses\" ng-value=\"item.course_id\" ng-if=\"item.course_equivalence_id >= 300 || vm.has_student_selected || item.course_equivalence_id > enrolment.form.course_equivalence_id || (item.course_equivalence_id >= enrolment.form.course_equivalence_id && (enrolment.form.enrolment_status_id === vm.CANCELED || enrolment.form.enrolment_status_id === vm.PRE_ENROLMENT || enrolment.form.academic_status_id >= 20 || enrolment.form.academic_status_id === vm.IN_COURSE || enrolment.form.enrolment_status_id === vm.PRE_ENROLMENT_ONLINE))\">{{item.course_name}}</md-option></md-optgroup></md-select><div class=\"errors\" ng-messages=\"form_wizard_course.course.$error\"><div ng-message=\"required\">Escolher um curso é obrigátório</div></div></md-input-container><md-input-container flex=\"50\"><label>Turma</label><md-icon md-font-icon=\"icon-school\"></md-icon><md-select name=\"turma\" ng-disabled=\"enrolment.form.timetable.course_id == null\" ng-model=\"vm.group\" ng-change=\"vm.defineGroupAndMatrix()\" required=\"\"><md-optgroup label=\"Turmas\"><md-option ng-repeat=\"item in vm.groups\" ng-value=\"item\">{{item.group_name}} <span ng-if=\"item.vagas !== null\">[{{item.vagas}} vagas]</span> <span ng-if=\"vm.school_period_course == 0 || item.school_period_id.toString().length > 4\">| Período {{item.matrix_period}}</span></md-option></md-optgroup></md-select><div class=\"errors\" ng-messages=\"form_wizard_course.turma.$error\"><div ng-message=\"required\">Escolher uma turma é obrigátório</div></div></md-input-container></md-content><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Cancelar</md-button><md-button type=\"submit\" ng-show=\"enrolment.stepSelected < 9\" class=\"md-primary md-raised\" ng-click=\"vm.enableNextStep()\" ng-disabled=\"$root.show_loader || form_wizard_course.$invalid || enrolment.showBusyText\">Próximo<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/enrolment/enrolment-steps/documents/documents.html","<hr><form name=\"form_wizard_document\" novalidate=\"\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.documents, false, form_wizard_document)\"><md-content class=\"md-padding\"><div layout-align=\"center center\"><md-card layout=\"column\" style=\"padding: 15px; border-radius: 5px\"><a4-student-documents selected-documents=\"enrolment.student.idOfDocuments\" student=\"vm.person_student\" documents-list=\"vm.documentsForCourse\"></a4-student-documents></md-card></div></md-content><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"enrolment.stepSelected < 9\" class=\"md-primary md-raised\" ng-click=\"vm.enableNextStep()\" ng-disabled=\"$root.show_loader\">Próximo<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/enrolment/enrolment-steps/end/end.html","<hr><form name=\"form_wizard\"><md-content layout=\"row\"><md-content><md-card layout=\"row\" style=\"padding: 0px; height: 180px; width: 2000px;\" layout-align=\"center\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" target=\"_blank\" ng-click=\"vm.impressRegistrationForm()\" style=\"margin-right: 3px; margin-left: 3px;\"><br><br><md-icon>assignment_ind</md-icon><div>Imprimir ficha de matrícula</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" target=\"_blank\" ng-click=\"vm.impressEnrolmentCertificate()\" style=\"margin-right: 3px; margin-left: 3px;\" ng-if=\"vm.school_period_id === 0 || vm.school_period_id.toString().length > 4\"><br><br><md-icon>assignment</md-icon><div>Imprimir comprovante de matrícula</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" style=\"margin-right: 3px; margin-left: 3px;\" ng-click=\"vm.goToFinanceEnrolment()\" policy-access=\"matricula_fin\" ng-if=\"vm.selected_student.is_pre_enrolment !== \'1\' && vm.has_finance\"><br><br><md-icon>attach_money</md-icon><div>Finalizar e ir para matrícula financeira</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" ng-click=\"vm.end()\" ng-if=\"vm.selected_student.is_pre_enrolment !== \'1\'\"><br><br><md-icon md-font-icon=\"icon-check-circle\"></md-icon><div>Finalizar matrícula acadêmica</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" ng-click=\"vm.end()\" ng-if=\"vm.selected_student.is_pre_enrolment == \'1\'\"><br><br><md-icon md-font-icon=\"icon-check-circle\"></md-icon><div>Finalizar pré-matrícula</div></a></md-card></md-content></md-content><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button></form>");
$templateCache.put("app/educational/enrolment/enrolment-steps/finance/finance.html","<hr><form name=\"form_wizard_finance\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.finance, false, form_wizard_finance)\"><div layout=\"row\"><md-card ng-if=\"!vm.hasPaymentPlan\" flex=\"\" layout=\"row\"><div flex=\"\" style=\"background-color: rgb(3,169,244); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 60px;\"></i><br><span style=\"font-size: 25px; color: #fff;\">Sem planos de pagamento para esta turma</span></p><p><span style=\"font-size: 18px; color: #fff;\">Para criar um novo Plano de Pagamento para esta turma, consulte a área financeira.</span></p></div></md-card><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-show=\"vm.hasPaymentPlan\" flex=\"60\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-if=\"vm.hasPaymentPlan\" flex=\"\"><label>Plano de pagamento</label><md-icon md-font-icon=\"icon-view-carousel\"></md-icon><md-select ng-model=\"payment_plan_id\" required=\"\" aria-label=\"plano de pagamento\" ng-change=\"vm.setPaymentPlan(payment_plan_id)\"><md-option ng-value=\"payment.payment_plan_id\" ng-repeat=\"payment in vm.payment_plans track by $index\">{{payment.name}}</md-option></md-select></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"100\"><date-picker flex=\"30\" disabled=\"vm.hasPaymentPlan\" required=\"\" placeholder=\"Data de início\" ng-model=\"enrolment.form.contract.date_first\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"30\"><label>Quantidade de parcelas</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"enrolment.form.contract.quantity\" required=\"\" ng-disabled=\"vm.hasPaymentPlan\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"30\"><label>Valor</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"enrolment.form.contract.amount\" required=\"\" ui-money-mask=\"\" ng-disabled=\"vm.hasPaymentPlan\"></md-input-container></div></md-content><md-content class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" ng-show=\"vm.hasPaymentPlan && enrolment.form.contract.frequency > 0\" flex=\"40\"><md-button class=\"md-primary\" aria-label=\"Novo Desconto\" style=\"margin-left: 15px\" ng-click=\"vm.createNewIndivialDiscount()\">Adicionar desconto<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-table-container ng-if=\"enrolment.form.contract.individual_discounts.length > 0\"><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Razão</th><th md-column=\"\">Desconto</th><th md-column=\"\">F/C</th><th md-column=\"\">De</th><th md-column=\"\">Até</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in enrolment.form.contract.individual_discounts\"><td md-cell=\"\">{{ item.discount_reason.name }}</td><td md-cell=\"\">{{ item.value_type == 1 ? \"% \" + item.amount : \"R$ \" + item.amount }}</td><td md-cell=\"\">{{ item.is_fixed ? \'F\' : \'C\' }}</td><td md-cell=\"\">{{ item.start_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\">{{ item.end_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeItemDesconto($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></md-table-container></md-content></div><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"enrolment.stepSelected < 9\" class=\"md-primary md-raised\" ng-disabled=\"$root.show_loader || form_wizard_finance.$invalid || !vm.hasPaymentPlan\">Próximo<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/enrolment/enrolment-steps/init/init.html","<hr><form name=\"form_wizard_init\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.inicio, false, form_wizard_init)\"><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"100\"><md-autocomplete md-no-cache=\"true\" md-selected-item=\"enrolment.form.student\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.getEnrolmentProgress(item);vm.getPaymentPendences(item)\" md-items=\"item in vm.getStudents(vm.searchText)\" md-item-text=\"item.name_display\" md-input-minlength=\"3\" md-delay=\"1000\" md-min-length=\"0\" placeholder=\"Digite o nome do aluno\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name_display}}</span></md-item-template><md-not-found>Pessoa não encontrado, continue o processo para uma nova matricula.</md-not-found></md-autocomplete></md-input-container><md-card flex=\"\" layout=\"row\" ng-if=\"vm.has_pendences\"><div flex=\"\" style=\"background-color: #f57c00; width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><md-icon md-font-icon=\"icon-alert\" style=\"color: #fff;font-size: 60px;line-height: normal;\"></md-icon><br><span style=\"font-size: 25px; color: #fff;\">Atenção</span></p><p><span style=\"font-size: 18px; color: #fff;\">{{vm.current_choice.name}}, tem {{vm.has_pendences}} pendências financeiras</span></p><md-button class=\"md-warn md-raised md-hue-1\" target=\"_blank\" ng-click=\"vm.goToStudent(vm.person_info)\">Ir para ficha do aluno</md-button></div></md-card><md-card flex=\"\" layout=\"row\" ng-if=\"vm.different_course\"><div flex=\"\" style=\"background-color: #4a4ccb; width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><md-icon md-font-icon=\"icon-alert\" style=\"color: #fff;font-size: 60px;line-height: normal;\"></md-icon><br><span style=\"font-size: 25px; color: #fff;\">Atenção</span></p><p><span style=\"font-size: 18px; color: #fff;\">Matrícula em curso diferente, deseja continuar?</span></p></div></md-card></md-content><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected == 0\" ui-sref=\"private.educational.students.list\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"enrolment.stepSelected < 9\" ng-click=\"vm.enableNextStep()\" class=\"md-primary md-raised\" ng-disabled=\"$root.show_loader || vm.block_next_button || vm.isLoading || vm.searchText == \'\'\">Próximo<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/enrolment/enrolment-steps/medical_data/medical_data.html","<hr><form name=\"form_wizard_dadosmedicos\" novalidate=\"\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.medical_data, false, form_wizard_dadosmedicos)\"><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(50,112,198)\" flex=\"25\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Questões de saúde</b> <small>Preencha abaixo informações relacionadas à saúde do aluno</small></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(50,112,198)\" flex=\"25\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Medicamentos</b> <small>Preencha abaixo informações relacionadas aos medicamentos do aluno</small></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(50,112,198)\" flex=\"25\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>A quem avisar em casos de emergência</b> <small>Preencha abaixo informações acerca da pessoa a ser avisada em casos de emergência</small></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(50,112,198)\" flex=\"25\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Outras informações</b> <small>Preencha putras informações sobre questões médicas do aluno</small></div></div><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"enrolment.form.person_medical_data.has_hearing_problem\">Tem problema de audição</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para febre</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.medication_fever\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Nome do médico</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.doctor_name\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Plano de saúde</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.health_insurance\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"enrolment.form.person_medical_data.has_sight_problem\">Tem problema de visão</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para diarréia</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.medication_diarrhea\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Em caso de acidente avisar a</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.accident_notify_person_1\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Outras observações</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.notes\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"enrolment.form.person_medical_data.has_breathing_problem\">Tem problema respiratório</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para dor de cabeça</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.medication_headache\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Celular</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.notify_person_1_mobile\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Tipo sanguíneo</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.blood_type_id\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"enrolment.form.person_medical_data.has_diabetes\">Tem diabetes</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para vômito</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.medication_vomiting\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Grau de parentesco</label><md-icon md-font-icon=\"icon-document\"></md-icon><md-select ng-model=\"enrolment.form.person_medical_data.notify_person_1_relation\"><md-option ng-repeat=\"item in vm.list.person_relation.person_relation_type_id\" value=\"{{item.id}}\">{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Tratamentos</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.treatments\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"enrolment.form.person_medical_data.has_heart_problem\">Tem problema cardíaco</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para dor de dente</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.medication_toothache\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Em caso de acidente avisar a (2)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.accident_notify_person_2\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Telefone fixo 1</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.notify_person_1_phone_1\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"enrolment.form.person_medical_data.has_nervous_problem\">Tem problema nervoso</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Outras medicações</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.medication_other\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Celular (2)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.notify_person_2_mobile\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Celular (médico)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.doctor_mobile\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Alergias</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.allergies\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Observações médicas</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.medical_notes\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Grau de parentesco (2)</label><md-icon md-font-icon=\"icon-document\"></md-icon><md-select ng-model=\"enrolment.form.person_medical_data.notify_person_2_relation\"><md-option ng-repeat=\"item in vm.list.person_relation.person_relation_type_id\" value=\"{{item.id}}\">{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Em caso de emergência levar para</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.emergency_take_to\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Cirurgias</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.surgeries\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Outras doenças</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"enrolment.form.person_medical_data.others_diseases\"></md-input-container></md-content><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"enrolment.stepSelected < 9\" class=\"md-primary md-raised\" ng-click=\"vm.enableNextStep()\" ng-disabled=\"$root.show_loader\">Próximo<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/enrolment/enrolment-steps/responsibles/responsible-cpf.html","<md-dialog aria-label=\"Cadastro de CPF do responsável financeiro\" md-theme=\"educational\" style=\"width: 465px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Campos obrigatórios para o responsável financeiro</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><div style=\"padding: 10px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Para selecionar uma pessoa como responsável financeira, é necessário que os campos obrigatórios sejam preenchidos</b> Clique no botão abaixo para abrir o cadastro do responsável e completá-lo.</div></div></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; width: 100%\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.openForm()\">Abrir cadastro</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.submit(vm.object)\">Verificar e salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/enrolment/enrolment-steps/responsibles/responsibles.html","<hr><form name=\"form_wizard_responsibles\" novalidate=\"\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.responsibles, false, form_wizard_responsibles)\"><a4-student-responsibles-form person-id=\"vm.person_id\" group-id=\"vm.group_id\" student=\"enrolment.form.student\" matrix-period=\"vm.matrix_period\" is-enrolment=\"true\" has-payee=\"vm.hasPayee\" has-responsible=\"vm.hasResponsible\"></a4-student-responsibles-form><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"enrolment.stepSelected < 9\" class=\"md-primary md-raised\" ng-click=\"vm.enableNextStep()\" ng-disabled=\"$root.show_loader || !vm.hasPayee || !vm.hasResponsible\">Próximo<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/enrolment/enrolment-steps/student/student.html","<hr><form name=\"form_wizard_student\" novalidate=\"\" autocomplete=\"off\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.students, false, form_wizard_student)\"><md-content style=\"padding: 16px !important; background-color: whitesmoke !important;\"><div class=\"md-dialog-content\"><div layout=\"row\" layout-align=\"center start\"><md-card class=\"md-padding\" style=\"min-width: 800px;\"><a4-student-form student=\"enrolment.form.student\" is-enabled=\"true\" is-enrolment=\"true\" block-form-email=\"vm.blockFormEmail\"></a4-student-form></md-card></div></div></md-content><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-disabled=\"form_wizard_student.$invalid || (enrolment.form.student.name === \'defined\' || enrolment.form.student.name === \'undefined\') || vm.blockFormEmail || enrolment.showBusyText || (enrolment.form.student.cpf_error == true || enrolment.form.student.cpf_error == \'true\')\" ng-show=\"enrolment.stepSelected < 9\" ng-click=\"vm.enableNextStep()\" class=\"md-primary md-raised\">Próximo<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/enrolment/enrolment-steps/subject/subject.html","<hr><form name=\"form_wizard\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.subject, false, form_wizard)\"><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><div ng-if=\"vm.show_grid\" flex=\"\"><a4-subject-grid person-id=\"vm.person_id\" course-id=\"vm.course_id\" group-id=\"vm.group_id\" course-equivalence-id=\"vm.course_equivalence_id\" course-enrolment-system-id=\"vm.course_enrolment_system_id\" enrolment-period-id=\"vm.enrolment_period_id\" matrix-period=\"vm.matrix_period\" is-enrolment=\"true\" flex=\"\"></a4-subject-grid></div></md-content><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"enrolment.stepSelected < 9\" ng-click=\"vm.enableNextStep()\" class=\"md-primary md-raised\">Próximo<md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/finance-enrolment/finance-enrolment-steps/discounts/finance-enrolment-discounts.html","<form name=\"form_wizard_discounts\" novalidate=\"\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.discounts, false, form_wizard_discounts)\"><md-content class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrapflex=\"100\"><md-button class=\"md-primary\" aria-label=\"Novo Desconto\" style=\"margin-left: 15px\" ng-click=\"vm.createNewIndivialDiscount()\">Adicionar desconto<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-table-container ng-if=\"enrolment.contract.individual_discounts.length > 0\"><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Razão</th><th md-column=\"\">Desconto</th><th md-column=\"\">F/C</th><th md-column=\"\">De</th><th md-column=\"\">Até</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in enrolment.contract.individual_discounts\"><td md-cell=\"\">{{ item.discount_reason.name }}</td><td md-cell=\"\">{{ item.value_type == 1 ? \"% \" + item.amount : \"R$ \" + item.amount }}</td><td md-cell=\"\">{{ item.is_fixed ? \'F\' : \'C\' }}</td><td md-cell=\"\">{{ item.start_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\">{{ item.end_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeItemDesconto($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></md-table-container></md-content><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"$rootScope.show_loader\">Próximo<md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/finance-enrolment/finance-enrolment-steps/end/finance-enrolment-end.html","<hr><form name=\"form_wizard\"><md-content layout=\"row\"><md-content><md-card layout=\"row\" style=\"padding: 0px; height: 180px; width: 2000px;\" layout-align=\"center\" flex=\"100\"><a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" target=\"_blank\" style=\"margin-right: 3px; margin-left: 3px;\" ng-click=\"vm.printContract()\"><br><br><md-icon>assignment</md-icon><div>Imprimir contrato</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" style=\"margin-right: 3px; margin-left: 3px;\" ng-click=\"vm.printBankSlip()\" ng-if=\"vm.enrolment_config.enrolment_bank_slip_type !== 4\"><br><br><md-icon md-font-icon=\"icon-barcode\"></md-icon><div>Imprimir boletos</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" style=\"margin-right: 3px; margin-left: 3px;\" ng-click=\"vm.printPaymentBook()\" ng-if=\"vm.enrolment_config.enrolment_bank_slip_type === 4\"><br><br><md-icon md-font-icon=\"icon-barcode\"></md-icon><div>Imprimir carnê</div></a> <a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" ng-click=\"vm.finishOnline()\"><br><br><md-icon md-font-icon=\"icon-cloud\"></md-icon><div>Assinar contrato online</div></a><a flex=\"\" class=\"text-center btn-check-educational md-ink-ripple\" ng-click=\"vm.finishFinanceEnrolment()\"><br><br><md-icon md-font-icon=\"icon-check-circle\"></md-icon><div>Finalizar matrícula financeira</div></a></md-card></md-content></md-content><md-button type=\"button\" ng-show=\"enrolment.stepSelected > 0\" ng-click=\"enrolment.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button></form>");
$templateCache.put("app/educational/finance-enrolment/finance-enrolment-steps/payment-plan/contract-modal.html","<md-dialog aria-label=\"Contrato\" md-theme=\"educational\" style=\"width: 800px;\"><form ng-cloak=\"\" novalidate=\"\" ng-submit=\"vm.submitContract(vm.contract)\" name=\"contractformfinance\"><md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-file-document\" aria-label=\"Close dialog\" style=\"color: white; padding-right: 15px;\"></md-icon><h2>Contrato</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" ng-if=\"!vm.is_first\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 0; padding-left: 0\"><div class=\"md-padding\"><md-card style=\"margin: 0 0 30px;\"><md-card-title style=\"padding: 0 16px 12px !important;background-color: rgb(3,169,244); color: white;\"><md-card-title-text><span class=\"md-subhead\">Ao finalizar este contrato, o aluno já vai esta matriculado no curso.</span></md-card-title-text></md-card-title></md-card><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Serviço contratado</b> <small>Abaixo se encontra o serviço contratado</small></div></div><hr><md-content layout=\"row\" class=\"md-padding\"><md-icon md-font-icon=\"icon-school\"></md-icon><md-autocomplete flex=\"\" class=\"md-input-has-placeholder\" md-input-name=\"autocompleteField\" md-selected-item=\"vm.selectedCourse\" md-selected-item-change=\"vm.setItem(vm.selectedCourse)\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getCourseAndGroup(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" ng-disabled=\"vm.is_first\" md-floating-label=\"Curso\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template></md-autocomplete><md-input-container flex=\"50\" class=\"md-block md-input-has-placeholder\" ng-if=\"vm.hasPaymentPlan && vm.groups.length > 0\"><label>Turma</label><md-icon md-font-icon=\"icon-chair-school\"></md-icon><md-select name=\"grouplist\" ng-model=\"vm.contract.group_id\" ng-change=\"vm.getPaymentPlansForGroup(vm.contract.group_id)\" required=\"\" ng-disabled=\"vm.is_first\" aria-label=\"turmas\"><md-option ng-repeat=\"group in vm.groups track by $index\" ng-value=\"group.id\">{{group.name}}</md-option></md-select><div ng-messages=\"contractformfinance.grouplist.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar a turma.</div></div></md-input-container></md-content><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Definição de contrato</b> <small>Abaixo preencha as informações para a formulação do contrato</small></div></div><hr><md-card ng-show=\"vm.payment_plans.length == 0\"><md-card-title style=\"padding: 0 16px 12px !important;background-color: rgb(3,169,244); color: white;\"><md-card-title-text><span class=\"md-subhead\">Sem plano de pagamento, não é possível continuar com o contrato</span></md-card-title-text></md-card-title></md-card><md-content ng-show=\"vm.payment_plans.length > 0\" class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\" flex=\"100\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-placeholder\" ng-if=\"vm.hasPaymentPlan\" flex=\"\"><label>Plano de pagamento</label><md-icon md-font-icon=\"icon-view-carousel\"></md-icon><md-select ng-model=\"vm.contract.payment_plan_id\" required=\"\" name=\"paymentplan\" aria-label=\"plano de pagamento\" ng-change=\"vm.setPaymentPlan(vm.contract.payment_plan_id)\"><md-option ng-value=\"payment.payment_plan_id\" ng-repeat=\"payment in vm.payment_plans track by $index\">{{payment.name}}</md-option></md-select><div ng-messages=\"contractformfinance.paymentplan.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar o plano de pagamento.</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" ng-if=\"vm.hasPaymentPlan\" flex=\"\"><label>Dia diferenciado de vencimento</label><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-select ng-model=\"vm.contract.preferential_due_day\" aria-label=\"dia diferenciado de pagamento\" ng-change=\"\"><md-option ng-value=\"day.id\" ng-repeat=\"day in vm.preferencial_due_day_list track by $index\">{{day.id}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" flex=\"100\"><date-picker flex=\"25\" disabled=\"vm.hasPaymentPlan\" required=\"\" placeholder=\"Data de início\" ng-model=\"vm.contract.date_first\"></date-picker><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Quantidade de parcelas</label><md-icon md-font-icon=\"icon-numeric\"></md-icon><input ng-model=\"vm.contract.quantity\" required=\"\" ng-disabled=\"vm.hasPaymentPlan\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Valor</label><md-icon md-font-icon=\"icon-coin\"></md-icon><input ng-model=\"vm.contract.amount\" required=\"\" ui-money-mask=\"\" ng-disabled=\"vm.hasPaymentPlan\"></md-input-container></div></div></md-content><hr><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Descontos Individuais</b> <small>Abaixo se encontram os descontos individuais do contrato</small></div><div flex=\"10\"><md-button class=\"md-icon-button\" ng-click=\"vm.createNewIndividualDiscount()\"><md-tooltip md-direction=\"left\">Novo desconto individual</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><hr><md-content><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Razão</th><th md-column=\"\">Desconto</th><th md-column=\"\">F/C</th><th md-column=\"\">De</th><th md-column=\"\">Até</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.contract.individual_discounts\"><td md-cell=\"\">{{ item.discount_reason.name }}</td><td md-cell=\"\">{{ item.value_type==1? \"% \" :\"R$ \"}} {{ (item.value_type == 1 ? (item.amount | number : 3) : (item.amount | number : 2) ) }}</td><td md-cell=\"\">{{ item.is_fixed ? \'F\' : \'C\' }}</td><td md-cell=\"\">{{ item.start_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\">{{ item.end_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeItemDesconto($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.goBack()\" ng-show=\"vm.is_first\">Cancelar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\">Salvar Contrato</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/finance-enrolment/finance-enrolment-steps/payment-plan/finance-enrolment-payment_plan.html","<form name=\"form_wizard_payment_plan\" novalidate=\"\" ng-submit=\"enrolment.submitCurrentStep(enrolment.steps.payment_plan, false, form_wizard_payment_plan)\"><a4-contract course-id=\"vm.course_id\" person-id=\"vm.person_id\" group-id=\"vm.group_id\" matrix-period=\"vm.matrix_period\" contract-type=\"vm.contract_type\" in-flow=\"true\" is-finance-enrolment=\"true\"></a4-contract><md-step-actions layout=\"row\"><div flex=\"\" layout=\"row\" layout-align=\"space-between top\"><md-button type=\"button\" ng-click=\"vm.backToList()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Voltar para a lista</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"$rootScope.show_loader || form_wizard_payment_plan.$invalid || !vm.hasPaymentPlan\">Próximo<md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form>");
$templateCache.put("app/educational/groups/notes-pending/views/notes-pending.html","<md-content layout-padding=\"\"><md-content layout-row=\"\"><form><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Pendências de notas</b> <small>O grid abaixo detalha as notas pendentes de lançamento nesta turma</small></div></div></form><md-table-pagination md-limit=\"vm.pendentGrades.per_page\" md-limit-options=\"[15, 30, 60]\" md-page=\"vm.pendentGrades.current_page\" style=\"border: none;\" flex=\"\" md-total=\"{{vm.pendentGrades.total}}\" md-on-paginate=\"vm.paginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination><a4-pendent-grades pendent-grades=\"vm.pendentGrades.data\" for=\"\'group\'\"></a4-pendent-grades></md-content></md-content>");
$templateCache.put("app/educational/groups/students/views/students.html","<div layout=\"row\" style=\"margin-bottom: 5px;\" ng-if=\"vm.attendance_type === \'U\'\"><md-button class=\"md-raised md-primary\" flex=\"10\" ng-click=\"vm.getFrequency()\" ng-if=\"!vm.show_absences\">Lançar faltas</md-button><md-button class=\"md-raised\" flex=\"5\" ng-click=\"vm.show_absences = false\" ng-if=\"vm.show_absences\">Cancelar</md-button><md-button class=\"md-raised md-primary\" flex=\"10\" ng-click=\"vm.saveFrequency()\" ng-if=\"vm.show_absences\">Salvar faltas</md-button></div><md-card layout-padding=\"\" layout=\"column\" style=\"margin-top: -5px;\"><md-card layout=\"row\" style=\"padding: 0;background: none;box-shadow: none\" ng-show=\"vm.tableItemsSelected.length >= 2\" ng-click=\"vm.confirmStudentsInGroup()\"><md-card flex=\"\" class=\"text-center btn-check-edu md-ink-ripple\" style=\"margin-left: 0;\" ng-if=\"!vm.checkPolicies(\'turma_hor_alt\')\"><md-icon>assignment_turned_in</md-icon><div>Confirmar matrículas condicionais</div></md-card></md-card><table md-table=\"\" md-row-select=\"!vm.checkPolicies(\'turma_hor_alt\')\" md-progress=\"vm.promise\" multiple=\"true\" ng-model=\"vm.tableItemsSelected\" md-on-select=\"vm.verifyDisableButton()\" md-on-deselect=\"vm.verifyDisableButton()\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\">Matrícula</th><th md-column=\"\">#</th><th md-column=\"\">Nome</th><th md-column=\"\">Status</th><th md-column=\"\" ng-if=\"vm.show_absences\" ng-repeat=\"grade in vm.grades\">{{grade}}</th><th md-column=\"\" ng-if=\"vm.tableItemsSelected.length < 2\"></th></tr></thead><tbody md-body=\"\"><tr ng-repeat=\"student in vm.grid.rows track by $index\" md-row=\"\" md-select=\"student\" md-select-id=\"id\" class=\"a4-grid-tr-hover-ripple\" ng-click=\"vm.goToStudent(student)\"><td md-cell=\"\" flex=\"\"><img style=\"max-width: 39px; object-fit: contain;\" id=\"{{student.id}}\" ng-src=\"{{ \'http://api.a4net.com.br/\' + student.photo}}\" ng-show=\"student.photo\" class=\"avatar md-avatar\" alt=\"photo\"></td><td md-cell=\"\"><span>{{student.number}}</span></td><td md-cell=\"\"><span>{{student.group_sequence}}</span></td><td md-cell=\"\"><span>{{student.name}}</span></td><td md-cell=\"\"><span class=\"badge\"><span class=\"enrolment_status enrolment_status {{student.enrolment_status}}\">{{student.enrolment_status.replace(\'_\', \' \')}}</span></span></td><td md-cell=\"\" ng-if=\"vm.show_absences\" ng-repeat=\"grade in vm.grades track by $index\" ng-click=\"$event.preventDefault();\"><md-input-container ng-click=\"$event.preventDefault();\"><input ng-model=\"student[grade]\" type=\"number\" ng-click=\"$event.preventDefault();\"></md-input-container></td><td md-cell=\"\" ng-if=\"vm.tableItemsSelected.length < 2\"><md-button flex=\"\" class=\"md-icon-button\" ng-if=\"student.enrolment_status_id === 1\" ng-click=\"vm.confirmConditional(student);$event.stopPropagation();$event.preventDefault();\"><md-icon>assignment_turned_in</md-icon><md-tooltip md-direction=\"left\">Confirmar matrícula condicional</md-tooltip></md-button></td></tr></tbody></table></md-card>");
$templateCache.put("app/educational/groups/timetable/views/timetable.html","<md-content ng-init=\"vm.init()\" layout-padding=\"\" class=\"with-btn-add\"><div class=\"there-are-no\" layout-align=\"center center\" layout=\"column\" flex=\"\" ng-show=\"vm.timetable.length == 0\"><div><md-icon>info_outline</md-icon></div><div class=\"preview-scale\"><strong>Não há registros ;(</strong></div></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.checkPolicies(\'turma\')\"><md-input-container class=\"title-select\" ng-show=\"vm.timetable.length\" style=\"width: 390px;\"><label>Grade de horários</label><md-select ng-model=\"vm.selected_timetable\" ng-change=\"vm.changeTimetable(vm.selected_timetable)\"><md-option ng-repeat=\"(index,timetable) in vm.timetable\" ng-value=\"timetable\" ng-selected=\"index === vm.timetable.length-1\">{{ timetable.initial_date_formated }}</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" aria-label=\"Editar horário da grade\" ng-click=\"vm.createOrUpdateTimetable(true)\" ng-if=\"!vm.checkPolicies(\'turma_hor_alt\')\"><md-tooltip>Editar data inicial</md-tooltip><md-icon>edit</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Excluir grade\" ng-click=\"vm.deleteTimetable(vm.selected_timetable)\" ng-if=\"!vm.checkPolicies(\'turma_hor_alt\')\"><md-tooltip>Excluir</md-tooltip><md-icon>remove_circle</md-icon></md-button></div><md-button class=\"md-fab md-fab-top-right\" aria-label=\"Criar horário\" ng-if=\"!vm.checkPolicies(\'turma_hor_alt\')\" ng-click=\"vm.createOrUpdateTimetable(false)\"><md-tooltip>Criar horário</md-tooltip><md-icon>add</md-icon></md-button><div class=\"group-table-timetable\" ng-if=\"!vm.checkPolicies(\'turma\')\" ng-show=\"vm.timetableGrid.timetable_tracks.length && !$root.show_loader\"><div layout=\"row\"><div layout=\"row\" layout-align=\"start center\" flex=\"50\"><md-input-container ng-show=\"vm.initial_date_view && vm.form.mode_edit\"><label>Data inicial</label><md-datepicker ng-model=\"vm.initial_date_view\"></md-datepicker></md-input-container></div><div layout=\"row\" layout-align=\"end center\" flex=\"50\" ng-if=\"!vm.checkPolicies(\'turma_hor_alt\')\"><md-button ng-click=\"vm.printTimetable()\"><md-icon>print</md-icon>Imprimir</md-button><md-button ng-click=\"vm.duplicateTimetable()\"><md-icon>content_copy</md-icon>Duplicar horário</md-button></div></div><div class=\"table-timetable\" ng-show=\"vm.timetableGrid.timetable_tracks.length\"><table class=\"simple timetable\" ng-class=\"vm.form.mode_edit ? \'edit-enabled\' : \'\'\"><md-button class=\"md-fab md-mini edit-table\" aria-label=\"Criar horário\" ng-class=\"vm.form.mode_edit ? \'cancel\' : \'\'\" ng-if=\"!vm.checkPolicies(\'turma_hor_alt\')\" ng-click=\"vm.editTimetableCurrent(vm.form.mode_edit)\"><md-tooltip><span ng-show=\"!vm.form.mode_edit\">Editar</span> <span ng-show=\"vm.form.mode_edit\">Cancelar Edição</span></md-tooltip><md-icon ng-show=\"!vm.form.mode_edit\" md-font-icon=\"icon-pencil\"></md-icon><md-icon ng-show=\"vm.form.mode_edit\" md-font-icon=\"icon-cancel\"></md-icon></md-button><thead><tr><th>Horário</th><th ng-show=\"vm.has_sunday || vm.form.mode_edit\">Dom</th><th>Seg</th><th>Ter</th><th>Qua</th><th>Qui</th><th>Sex</th><th ng-show=\"vm.has_saturday || vm.form.mode_edit\">Sáb</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"value in vm.timetableGrid.timetable_items | orderBy: [\'initial_time\', \'-final_time\'] | groupBy:\'[initial_time,final_time]\' track by $index\"><td ng-repeat=\"(key, time) in vm.timetableGrid.timetable_tracks\" ng-show=\"$parent.$index == key\">{{ time.initial_time | date:\"h:mm\" }} às {{ time.final_time | date:\"h:mm\" }}</td><td ng-repeat=\"item in value | orderBy: \'initial_time\' track by $index\" ng-if=\"(item.day_of_week !== 7 || (vm.has_saturday || vm.form.mode_edit)) && (item.day_of_week !== 1 || (vm.has_sunday || vm.form.mode_edit))\"><md-button class=\"md-icon-button\" aria-label=\"Edit\" ng-show=\"vm.form.mode_edit\" ng-click=\"vm.editItem(item)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button icon-remove\" aria-label=\"Delete\" ng-show=\"vm.form.mode_edit && item.subject_name\" ng-click=\"vm.deleteItem({timetable_item:item})\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><md-icon md-font-icon=\"icon-alert\" ng-if=\"item.has_shock\" class=\"md-warn\"><md-tooltip>Choque de horário com a turma: {{item.has_shock}}</md-tooltip></md-icon><span ng-if=\"item.subject_name !== null\"><strong>{{item.subject_name}}</strong><br>{{item.person_name}}<br>{{item.location_name}}<br></span></td></tr></tbody><md-button class=\"md-fab md-mini conclude-table\" aria-label=\"Concluir\" ng-click=\"vm.refreshView()\" ng-class=\"vm.form.mode_edit ? \'confirm\' : \'\'\" ng-show=\"vm.form.mode_edit\"><md-tooltip>Concluir Edição</md-tooltip><md-icon>verified_user</md-icon></md-button></table></div><div ng-if=\"vm.group.course_equivalence_id >= 300 && vm.timetableGrid.exceptions.length > 0\"><br><br><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b style=\"font-size: 16px;\">Disciplinas da grade</b> <span>Aparecem como inclusão disciplinas de períodos da grade curricular diferente do atual da turma e que estejam na atual grade de horário.<br>Aparecem como exclusão disciplinas do período da grade curricular corrente da turma que não estejam na atual grade de horário.</span> <small>Legenda: N - normal (A disciplina prevista na grade está sendo oferecida na turma), E - exclusão (A disciplina prevista na grade na turma/período não está sendo oferecida), I - inclusão (A disciplina oferecida não está prevista na grade da turma/período)</small></div></div><br><a4-tree-grid tree-data=\"vm.timetableGrid.exceptions\" col-defs=\"vm.col_defs_services\" expand-on=\"vm.expanding_property\" expand-level=\"1\" icon-leaf=\'row.branch.children.length <= 0 && row.level == 2 ? \"no-icon\" : \"no-icon\"\' icon-expand=\'row.branch.children.length > 0 && !row.branch.expanded ? \"icon-chevron-right\" : \"icon-chevron-down\"\' icon-collapse=\'row.branch.children.length > 0 && row.branch.expanded ? \"icon-chevron-down\" : \"icon-chevron-right\"\'></a4-tree-grid></div></div></md-content>");
$templateCache.put("app/educational/groups/views/forms/conditional-group-enrollment-dialog.html","<md-dialog aria-label=\"Edit Cell\" md-theme=\"educational\" style=\"width: 700px\"><form name=\"enrollmentForm\" ng-submit=\"vm.submit(vm.form.selected_group, enrollmentForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Realizar matrícula em grupo condicional</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div><strong class=\"group-field\"><small>Turma de destino:</small></strong><div layout=\"row\"><md-input-container flex=\"50\"><input type=\"text\" ng-model=\"vm.form.group.course_name\" placeholder=\"Curso\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" ng-model=\"vm.form.group.name\" placeholder=\"Turma\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" ng-model=\"vm.form.group.vacancy\" placeholder=\"Qtd de vagas\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" ng-if=\"vm.has_finance && (vm.form.group.contract_type !== \'U\' || vm.form.group.course_equivalence_id < 300)\"><md-checkbox ng-model=\"vm.do_finance_enrolment\">Realizar matrícula financeira</md-checkbox></div><div><strong class=\"group-field\"><small>Turma de origem</small></strong><div layout=\"row\"><div flex=\"\"><md-input-container class=\"md-input-has-placeholder\" ng-show=\"vm.form.origin_group\" flex=\"50\"><label>Selecione a turma de origem</label><md-select ng-model=\"vm.form.selected_group\" required=\"\" flex=\"\"><md-option ng-if=\"!vm.form.origin_group.length\">Não há turmas disponíveis para matrícula</md-option><md-option ng-value=\"group\" ng-repeat=\"group in vm.form.origin_group\">{{ group.group_name }}</md-option></md-select></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"50\" ng-if=\"vm.has_finance && vm.do_finance_enrolment && (vm.form.group.contract_type !== \'U\' || vm.form.group.course_equivalence_id < 300)\"><label>Plano de pagamento</label><md-select ng-model=\"vm.form.group.payment_plan_id\" required=\"\" name=\"paymentplan\" ng-change=\"vm.verifyPaymentPlan(vm.form.group.payment_plan_id)\" aria-label=\"plano de pagamento\" flex=\"\"><md-option ng-value=\"payment.id\" ng-repeat=\"payment in vm.form.group.payment_plans track by $index\">{{payment.name}}</md-option><md-option ng-value=\"null\" ng-if=\"vm.form.group.payment_plans.length <= 0\">Turma não possui plano</md-option></md-select></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"\" ng-if=\"vm.do_finance_enrolment && !vm.payment_plan_has_price && (vm.form.group.course_equivalence_id < 300 || vm.form.group.matrix.contract_type === \'M\')\" required=\"\"><label>Valor do plano</label> <input ng-model=\"vm.form.group.amount\" ui-money-mask=\"\"></md-input-container></div></div></div><div><strong class=\"group-field\"><small>Quantidade de alunos da turma {{vm.form.selected_group.name}}:</small><p ng-show=\"vm.form.selected_group.enrollment_count\"></p></strong><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" ng-value=\"vm.form.selected_group.em_curso\" placeholder=\"Em curso\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" ng-value=\"vm.form.selected_group.reprovados\" placeholder=\"Reprovados\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" ng-value=\"vm.form.selected_group.aprovados\" placeholder=\"Aprovados\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" ng-value=\"vm.form.selected_group.enrollment_count\" placeholder=\"Total\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" ng-value=\"vm.form.selected_group.rematriculados\" placeholder=\"Rematriculados\" ng-disabled=\"true\"></md-input-container></div><br><strong ng-if=\"(vm.form.selected_group.aprovados + vm.form.selected_group.em_curso) == vm.form.selected_group.rematriculados\" class=\"group-field\"><small>Todos os alunos aprovados da turma selecionada já foram matriculados.</small></strong></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised\" ng-click=\"vm.close()\" ng-disabled=\"vm.show_loading\">Cancelar</md-button><md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"enrollmentForm.$invalid || vm.show_loading || vm.form.selected_group === null\" layout=\"row\"><md-progress-circular ng-disabled=\"!vm.show_loading\" flex=\"\" class=\"md-hue-2\" md-diameter=\"15px\"></md-progress-circular><span flex=\"90\">Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/groups/views/forms/form-groups.html","<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.group.id == null\">{{\'GROUPS.FORM_CREATE\' | translate }}</span> <span class=\"title\" ng-show=\"vm.group.id != null\">{{\'GROUPS.FORM_EDIT\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-if=\"vm.objectName\" ng-init=\"vm.form = vm.objectName\"></div><md-content class=\"md-padding\"><a4-form-dic-data bind=\"vm.form\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/groups/form.json\"></a4-form-dic-data></md-content>");
$templateCache.put("app/educational/informative-report/views/forms/form-informative-report.html","<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.group.id == null\">{{\'GROUPS.FORM_CREATE\' | translate }}</span> <span class=\"title\" ng-show=\"vm.group.id != null\">{{\'GROUPS.FORM_EDIT\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content class=\"md-padding\"><a4-form-dic-data bind=\"vm.form\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/groups/form.json\"></a4-form-dic-data></md-content>");
$templateCache.put("app/educational/note-release/council/views/note-release-council.html","<div layout=\"row\" align=\"start center\"><div flex=\"\" class=\"division\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Aluno(a)</strong></md-subheader><md-input-container class=\"md-block select-margin-especific\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-delay=\"500\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.getStudentsSubjects(item)\" md-items=\"item in vm.filterStudentsList(vm.searchText)\" md-item-text=\"item.name + \' | \' + item.course_name + \' | \' + item.group_name\" md-min-length=\"0\" md-floating-label=\"Pesquise pelo aluno\" id=\"selectCouncil\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.name}} | {{item.course_name}} | {{item.group_name}}</span></md-item-template><md-not-found>No states matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div></div><div layout=\"row\" align=\"start center\"><div flex=\"\"><md-subheader class=\"md-no-sticky\" ng-if=\"vm.subjects.length > 0\"><strong class=\"md-block\">Notas</strong></md-subheader><md-subheader class=\"md-no-sticky\"><strong>Notas especiais possíveis:</strong><i>SR = sem rendimento | DP = dispensado | FN = faltam notas</i></md-subheader><form name=\"formNoteRelease\" novalidate=\"\"><table class=\"simple table-note-release no-border-top a4-table-fixed table-float-button\"><thead><tr ng-if=\"vm.subjects.length > 0\"><th></th><th ng-repeat=\"(index, grade) in ::vm.grid.steps track by index\" colspan=\"{{grade.siblingsqtd}}\"><b>{{grade.name}}</b></th></tr><tr ng-if=\"vm.subjects.length > 0\"><th>Disciplinas</th><th ng-repeat=\"(index, grade) in ::vm.grid.grade_json track by index\" ng-if=\"grade.pass_grade.length\" class=\"hoverSubjectEvent\"><md-tooltip md-direction=\"top\">Média: {{grade.pass_grade}}; Máx: {{grade.max_grade}}</md-tooltip><b ng-if=\"grade.has_class_council && (grade.label == \'\' || grade.label == null)\">{{::grade.name}}</b> <b ng-if=\"grade.has_class_council && grade.label\">{{::grade.label}}</b> <span ng-if=\"!grade.has_class_council && (grade.label == \'\' || grade.label == null)\">{{::grade.name}}</span> <span ng-if=\"!grade.has_class_council && grade.label\">{{::grade.label}}</span></th></tr></thead><tbody><tr ng-repeat=\"(index, subject) in vm.subjects track by index\"><td>{{subject.subject_name}}</td><td ng-repeat=\"(index, grade) in ::vm.grid.grade_json track by index\" ng-if=\"grade.pass_grade.length\" ng-class=\"{\'has-council\': vm.hasClassCouncil(grade.name)}\"><span ng-repeat=\"(alias, note) in subject.grade_json track by alias\" ng-if=\"grade.name == alias\" ng-init=\"thisName = \'P_\'+alias+\'-\'+subject.id; vm.goToFirstField()\"><md-input-container><input name=\"{{ thisName }}\" ng-if=\"(vm.hasClassCouncil(alias) && (vm.convertGradeValue(note.value, grade.precision) <= vm.convertGradeValue(vm.getValue(alias, \'pass_grade\'), grade.precision))) && (subject.codes.length > 0 || grade.codes.length > 0)\" ng-value=\"note.valueConcept\" ng-model=\"note.valueConcept\" tabindex=\"$index\" ng-class=\"{ \'note-release-disapproved\': note.value < vm.getValue(id, \'pass_grade\'), \'note-release-approved\' : note.value >= vm.getValue(id, \'pass_grade\'), \'note-release-council\' : note.valueCouncil.length && note.valueCouncil !== null }\" note-release-item=\"note\" note-release-mask=\"\" note-release-codes=\"grade.codes.length > 0 ? grade.codes : subject.codes\" has-code-rule=\"true\" maxlength=\"{{ vm.getValue(id, \'max_grade\').length }}\" ng-blur=\"vm.formatNote(note.value, vm.getValue(id, \'max_grade\'))\" aria-label=\"Nota\" ng-disabled=\"vm.getValue(id, \'conditional\') || ((vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4))\"> <input name=\"{{ thisName }}\" ng-if=\"(vm.hasClassCouncil(alias) && (note.value < vm.getValue(alias, \'pass_grade\') || note.valueCouncil !== null)) && (subject.codes.length <= 0 && grade.codes.length <= 0)\" ng-value=\"note.valueCouncil !== null ? note.valueCouncil : note.value\" ng-model=\"note.valueCouncil\" note-release-mask=\"\" note-release-item=\"note\" note-release-has-council=\"true\" note-release-mask-max-number=\"vm.getValue(alias, \'max_grade\')\" note-release-mask-precision=\"grade.precision\" note-release-codes=\"grade.codes.length > 0 ? grade.codes : subject.codes\" has-code-rule=\"subject.codes.length > 0 || grade.codes.length > 0 ? true : false\" ng-class=\"{ \'note-release-disapproved\': note.value < vm.getValue(alias, \'pass_grade\'), \'note-release-approved\' : note.value >= vm.getValue(alias, \'pass_grade\'), \'note-release-council\' : note.valueCouncil !== null }\" ng-blur=\"vm.addLog(note.valueCouncil, note.value, subject, grade)\" ng-disabled=\"((vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4))\" maxlength=\"{{vm.getValue(alias, \'max_grade\').length }}\" aria-label=\"Nota\"> <span ng-if=\"!vm.hasClassCouncil(alias)\" ng-class=\"{\'note-release-disapproved\': note.value < vm.getValue(alias, \'pass_grade\'), \'note-release-approved\' : note.value >= vm.getValue(alias, \'pass_grade\'), \'note-release-council\' : note.valueCouncil.length && note.valueCouncil !== null}\">{{note.value}}</span><md-tooltip ng-if=\"((vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4))\" md-direction=\"top\">{{ vm.getBlocks(note.blockReason) }}</md-tooltip></md-input-container></span></td></tr></tbody></table></form></div></div>");
$templateCache.put("app/educational/note-release/grouping/views/note-release-grouping.html","<div layout=\"row\" align=\"start center\"><div flex=\"\" class=\"division\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Turma</strong></md-subheader><md-input-container class=\"md-block select-margin\"><label>Selecione a turma</label><md-select ng-model=\"vm.group_selected\" md-on-close=\"searchGroup = \'\'\" ng-change=\"vm.getAllGroupingByGroup(vm.group_selected); vm.event_selected = false; vm.grouping_selected = false; vm.selectAllEvent = false\" id=\"selectGroup\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-change=\"vm.filterGroupsList(searchGroup); vm.subject_selected = null\" ng-keydown=\"$event.stopPropagation()\" ng-model-options=\"{ debounce: 1000 }\" ng-model=\"searchGroup\" placeholder=\"Pesquise a turma\" class=\"demo-header-searchbox md-text\" id=\"groupInput\"></md-select-header><md-option ng-value=\"group\" ng-repeat=\"group in vm.groups | filter:searchGroup\">{{group.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"division\" ng-if=\"vm.group_selected\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Agrupamentos</strong></md-subheader><md-input-container class=\"md-block select-margin\"><label>Selecione o agrupamento</label><md-select ng-model=\"vm.grouping_selected\" md-on-close=\"searchGrouping = \'\'\" ng-change=\"vm.getEventsByGrouping(vm.group_selected, vm.grouping_selected); vm.event_selected = false; vm.selectAllEvent = false\" id=\"selectGrouping\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-change=\"vm.filterGroupingList(searchGrouping)\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchGrouping\" ng-model-options=\"{ debounce: 1000 }\" placeholder=\"Pesquise o agrupamento\" class=\"demo-header-searchbox md-text\" id=\"groupingInput\"><div class=\"loading-search-select\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"20px\"></md-progress-circular></div></md-select-header><md-option ng-value=\"grouping\" ng-repeat=\"grouping in vm.groupings | filter:searchGrouping\">{{grouping.grouping_name}}</md-option></md-select></md-input-container></div><div flex=\"\" ng-if=\"vm.grouping_selected\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Eventos</strong></md-subheader><md-input-container class=\"md-block select-margin\"><label>Selecione o evento</label><md-select ng-model=\"vm.event_selected\" md-on-close=\"searchEvent = \'\'\" ng-change=\"vm.selectEvent(vm.event_selected); vm.goToFirstField();\" multiple=\"\" id=\"selectEvent\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchEvent\" placeholder=\"Pesquise o evento\" class=\"demo-header-searchbox md-text\" id=\"eventInput\"></md-select-header><md-button layout-fill=\"\" value=\"all\" ng-click=\"vm.selectAllEvents(); vm.goToFirstField()\"><span ng-hide=\"vm.selectAllEvent\">Selecionar todos</span> <span ng-show=\"vm.selectAllEvent\">Limpar seleção</span></md-button><md-option ng-value=\"event.name\" ng-repeat=\"event in vm.grid.grades | filter:searchEvent\" ng-if=\"(event.siblingsqtd == 0 || event.has_attendance == true) && event.pass_grade.length\">{{event.name}}</md-option></md-select></md-input-container></div></div><div layout=\"row\"><div flex=\"100\" ng-if=\"vm.group_selected && vm.grouping_selected && vm.event_selected.length\" ng-init=\"vm.showSubmitForStudents()\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Notas para <span ng-repeat=\"subject in vm.subjects\">{{subject.name}},</span></strong></md-subheader><md-subheader class=\"md-no-sticky\"><strong>Notas especiais possíveis:</strong><i>SR = sem rendimento | DP = dispensado | FN = faltam notas</i></md-subheader><form name=\"formNoteRelease\" novalidate=\"\"><table class=\"simple table-note-release no-border-top fixed_headers a4-table-fixed table-float-button\"><thead><tr><th ng-show=\"vm.buttons.allowGroup\"></th><th></th><th ng-repeat=\"grade in ::vm.grid.steps\" colspan=\"{{grade.siblingsqtd}}\" ng-show=\"grade.show\"><b>{{::grade.name}}</b></th></tr><tr><th class=\"select-all\" ng-show=\"vm.buttons.allowGroup\"><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked();\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll();\"></md-checkbox></th><th class=\"text-align-left\">Alunos</th><th ng-repeat=\"grade in vm.filterEvents(vm.grid.grades)\">{{ grade.name.substring(0, grade.name.indexOf(\'|\')) }}<md-tooltip md-direction=\"top\">{{ grade.description }}</md-tooltip></th></tr></thead><tbody><tr ng-repeat=\"(index, student) in vm.grid.students\" ng-init=\"vm.addListStudent(student.person_id);\" ng-hide=\"vm.event_selected.length == 1 && student.grade_json[vm.event_selected[0]].status == false\"><td class=\"select-all\" ng-show=\"vm.buttons.allowGroup\"><md-checkbox aria-label=\"Add student at the list\" ng-checked=\"vm.exists(student.person_id, vm.listStudentsSelected);\" ng-click=\"vm.toggle(student.person_id, vm.listStudentsSelected)\"></md-checkbox></td><td><span></span>{{ student.name }}</td><td ng-repeat=\"(index_grade, grade) in vm.filterEvents(vm.grid.grades)\" ng-init=\"new_index = (index != 0) ? index : null; thisName = \'P_\'+$index; id = grade.name;\"><md-input-container flex=\"\" ng-if=\"grade.formula == null\"><input name=\"{{ thisName }}\" ng-if=\"!(grade.codes.length > 0)\" ng-model=\"student.grade_json[grade.name.split(\' |\')[0]].valueGrouping\" ng-value=\"student.grade_json[grade.name.split(\' |\')[0]].valueGrouping\" tabindex=\"{{new_index + 1}}{{index_grade}}\" class=\"autofocus\" ng-class=\"{ \'note-release-disapproved\': student.grade_json[grade.name.split(\' |\')[0]].valueGrouping < vm.getValue(id, \'pass_grade\'), \'note-release-approved\' : student.grade_json[grade.name.split(\' |\')[0]].valueGrouping >= vm.getValue(id, \'pass_grade\')}\" note-release-mask=\"\" note-release-mask-max-number=\"vm.getValue(id, \'max_grade\')\" note-release-mask-precision=\"grade.precision\" maxlength=\"{{ vm.getValue(id, \'max_grade\').length }}\" ng-blur=\"vm.formatNote(student.grade_json[grade.name.split(\' |\')[0]].valueGrouping, vm.getValue(id, \'max_grade\'), thisName)\" aria-label=\"Nota\" ng-disabled=\"(note.blockReason > 0 && (vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4))\"><md-tooltip ng-if=\"(note.blockReason > 0 && (vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4))\" md-direction=\"top\">{{ vm.getBlocks(note.blockReason) }}</md-tooltip></md-input-container><md-input-container ng-if=\"grade.has_attendance && grade.attendance_type === \'E\'\" flex=\"\"><md-tooltip md-direction=\"top\">Faltas</md-tooltip><input ng-value=\"note.absence\" style=\"background-color: #a9a9a97a;\" ng-model=\"note.absence\" type=\"number\" note-release-mask=\"\" aria-label=\"Falta\"></md-input-container></td></tr></tbody></table></form></div></div>");
$templateCache.put("app/educational/note-release/groups/views/note-release-groups.html","<div layout=\"row\" align=\"start center\"><div flex=\"\" class=\"division\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Turma</strong></md-subheader><md-input-container class=\"md-block select-margin\"><label>Selecione a turma</label><md-select ng-model=\"vm.group_selected\" md-on-close=\"searchGroup = \'\'\" ng-change=\"vm.getAllEnrolmentSubjectsByGroup(vm.group_selected); vm.event_selected = false; vm.selectAllEvent = []; vm.grid.grades = [];\" id=\"selectGroup\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-change=\"vm.filterGroupsList(searchGroup); vm.subject_selected = null\" ng-keydown=\"$event.stopPropagation()\" ng-model-options=\"{ debounce: 1000 }\" ng-model=\"searchGroup\" placeholder=\"Pesquise a turma\" class=\"demo-header-searchbox md-text\" id=\"groupInput\"></md-select-header><md-option ng-value=\"group\" ng-repeat=\"group in vm.groups | filter:searchGroup\">{{group.name}}</md-option></md-select></md-input-container></div><div flex=\"\" class=\"division\" ng-if=\"vm.group_selected\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Disciplinas</strong></md-subheader><md-input-container class=\"md-block select-margin\"><label>Selecione a disciplina</label><md-select ng-model=\"vm.subject_selected\" md-on-close=\"searchSubject = \'\'\" ng-change=\"vm.getStudentsBySubjectGroup(vm.subject_selected, vm.group_selected); vm.event_selected = false; vm.selectAllEvent = []; vm.grid.grades = [];\" id=\"selectSubject\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-change=\"vm.filterSubjectsList(searchSubject)\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchSubject\" id=\"subjectInput\" ng-model-options=\"{ debounce: 1000 }\" placeholder=\"Pesquise a disciplina\" class=\"demo-header-searchbox md-text\"><div class=\"loading-search-select\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"20px\"></md-progress-circular></div></md-select-header><md-option ng-value=\"subject\" ng-repeat=\"subject in vm.subjects | filter:searchSubject\">{{subject.name}}</md-option></md-select></md-input-container></div><div flex=\"\" ng-if=\"vm.subject_selected\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Eventos</strong></md-subheader><md-input-container class=\"md-block select-margin\"><label>Selecione o evento</label><md-select ng-model=\"vm.event_selected\" md-on-close=\"searchEvent = \'\'\" ng-change=\"vm.selectEvent(vm.event_selected); vm.goToFirstField()\" multiple=\"\" id=\"selectEvent\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchEvent\" placeholder=\"Pesquise o evento\" class=\"demo-header-searchbox md-text\" id=\"eventInput\"></md-select-header><md-button layout-fill=\"\" value=\"all\" ng-click=\"vm.selectAllEvents(); vm.goToFirstField()\"><span ng-hide=\"vm.selectAllEvent\">Selecionar todos</span> <span ng-show=\"vm.selectAllEvent\">Limpar seleção</span></md-button><md-option ng-value=\"event.name\" ng-repeat=\"event in vm.grid.grades | filter:searchEvent\" ng-if=\"(event.siblingsqtd == 0 || event.has_attendance == true) && event.pass_grade.length\" ng-disabled=\"event.badge\">{{event.name}} | {{event.description}} <span ng-show=\"event.badge\" class=\"option-badge\">{{event.badge}}</span></md-option></md-select></md-input-container></div></div><div layout=\"row\"><div flex=\"100\" ng-if=\"vm.subject_selected && vm.group_selected && vm.event_selected.length\" ng-init=\"vm.showSubmitForStudents()\"><md-subheader class=\"md-no-sticky\"><div layout=\"row\" layout-align=\"start center\"><strong class=\"md-block\">Notas</strong></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.printNotes()\"><md-icon md-font-icon=\"icon-printer\"><md-tooltip md-direction=\"left\">Imprimir notas</md-tooltip></md-icon></md-button></div></md-subheader><md-subheader class=\"md-no-sticky\"><strong>Notas especiais possíveis:</strong><i>SR = sem rendimento | DP = dispensado | FN = faltam notas</i></md-subheader><form name=\"formNoteRelease\" novalidate=\"\"><table class=\"simple table-note-release no-border-top fixed_headers a4-table-fixed table-float-button\"><thead><tr><th ng-show=\"vm.buttons.allowGroup\"></th><th></th><th ng-repeat=\"(index, grade) in ::vm.grid.steps track by index\" colspan=\"{{grade.siblingsqtd}}\" ng-show=\"grade.show\"><b>{{::grade.name}}</b></th></tr><tr><th class=\"select-all\" ng-show=\"vm.buttons.allowGroup\"><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked();\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll();\"></md-checkbox></th><th class=\"text-align-left\">Alunos</th><th ng-repeat=\"grade in vm.filterEvents(vm.grid.grades)\" ng-if=\"grade.pass_grade.length\">{{ grade.name }}<md-tooltip md-direction=\"top\">{{ grade.description }}</md-tooltip></th></tr></thead><tbody><tr ng-repeat=\"(index, student) in vm.grid.students\" ng-init=\"vm.addListStudent(student.person_id);\" ng-hide=\"vm.event_selected.length == 1 && student.grade_json[vm.event_selected[0]].status == false\"><td class=\"select-all\" ng-show=\"vm.buttons.allowGroup\"><md-checkbox aria-label=\"Add student at the list\" ng-checked=\"vm.exists(student.person_id, vm.listStudentsSelected);\" ng-click=\"vm.toggle(student.person_id, vm.listStudentsSelected)\"></md-checkbox></td><td><span></span>{{ student.name }}</td><td ng-repeat=\"grade in vm.filterEvents(vm.grid.grades)\"><span ng-repeat=\"(id, note) in student.grade_json\" ng-if=\"grade.name == id\" layout=\"row\" ng-init=\"thisName = \'P_\'+id+\'-\'+student.person_id;\"><md-input-container flex=\"\"><input name=\"{{ thisName }}\" ng-if=\"student.codes.length > 0 || grade.codes.length > 0\" ng-value=\"note.valueConcept\" ng-model=\"note.valueConcept\" tabindex=\"$index\" ng-class=\"{ \'note-release-disapproved\': note.value < vm.getValue(id, \'pass_grade\'), \'note-release-approved\' : note.value >= vm.getValue(id, \'pass_grade\'), \'note-release-council\' : note.valueCouncil.length && note.valueCouncil !== null }\" note-release-has-council=\"false\" note-release-item=\"note\" note-release-mask=\"\" note-release-codes=\"grade.codes.length > 0 ? grade.codes : student.codes\" has-code-rule=\"true\" maxlength=\"{{ vm.getValue(id, \'max_grade\').length }}\" ng-blur=\"vm.formatNote(note.value, vm.getValue(id, \'max_grade\'))\" aria-label=\"Nota\" ng-disabled=\"vm.getValue(id, \'conditional\') || ( note.status == false ) || (note.blockReason > 0 && (vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4)) || grade.formula !== null\"> <input name=\"{{ thisName }}\" ng-if=\"!(student.codes.length > 0 || grade.codes.length > 0)\" ng-model=\"note.valueTeacher\" ng-value=\"note.value\" tabindex=\"{{$index}}\" ng-class=\"{\'note-release-disapproved\': note.value < vm.getValue(id, \'pass_grade\'), \'note-release-approved\' : note.value >= vm.getValue(id, \'pass_grade\')}\" note-release-mask=\"\" note-release-mask-max-number=\"vm.getValue(id, \'max_grade\')\" note-release-mask-precision=\"grade.precision\" maxlength=\"{{ vm.getValue(id, \'max_grade\').length }}\" ng-blur=\"vm.formatNote(note.value, vm.getValue(id, \'max_grade\'), thisName);vm.addLog(note.valueTeacher, note.value, student, grade)\" aria-label=\"Nota\" ng-disabled=\"vm.getValue(id, \'conditional\') || ( note.status == false ) || (note.blockReason > 0 && (vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4)) || grade.formula !== null\"><md-tooltip ng-if=\"(note.blockReason > 0 && (vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4))\" md-direction=\"top\">{{vm.getBlocks(note.blockReason) }}</md-tooltip></md-input-container><md-input-container ng-if=\"grade.has_attendance && grade.attendance_type === \'E\'\" flex=\"\"><md-tooltip md-direction=\"top\">Faltas</md-tooltip><input ng-value=\"note.absence\" style=\"background-color: #a9a9a97a;\" ng-model=\"note.absence\" type=\"number\" note-release-mask=\"\" aria-label=\"Falta\"></md-input-container></span></td></tr></tbody></table></form></div></div>");
$templateCache.put("app/educational/note-release/students/views/note-release-student.html","<div layout=\"row\" align=\"start center\"><div flex=\"\" class=\"division\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Alunos</strong></md-subheader><md-input-container class=\"md-block select-margin-especific\"><label>Selecione o aluno</label><md-select ng-model=\"vm.student_selected\" md-on-close=\"searchStudent[vm.search_student] = \'\'\" ng-change=\"vm.getStudentsSubjects(vm.student_selected)\" id=\"selectStudent\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-change=\"vm.filterStudentsList(vm.search_student)\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.search_student\" ng-model-options=\"{ debounce: 1000 }\" translate=\"\" translate-attr-placeholder=\"STUDENTS.SEARCH_FOR_ANYONE\" class=\"demo-header-searchbox md-text\" id=\"studentInput\"><div class=\"loading-search-select\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"20px\"></md-progress-circular></div></md-select-header><md-option ng-value=\"student\" ng-repeat=\"(index, student) in vm.students | filter:searchStudent[vm.search_student]\">{{student.name}} | {{student.course_alias}} | {{student.group_name}}</md-option></md-select></md-input-container></div><div flex=\"\" ng-if=\"vm.student_selected\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Eventos</strong></md-subheader><md-input-container class=\"md-block select-margin\"><label>Selecione o evento</label><md-select ng-model=\"vm.event_selected\" md-on-close=\"searchEvent = \'\'\" ng-change=\"vm.goToFirstField();\" multiple=\"\" id=\"selectEvent\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchEvent\" placeholder=\"Pesquise o evento\" id=\"eventInput\" class=\"demo-header-searchbox md-text\"></md-select-header><md-button layout-fill=\"\" value=\"all\" ng-click=\"vm.selectAllEvents(); vm.goToFirstField()\"><span ng-hide=\"vm.selectAllEvent\">Selecionar todos</span> <span ng-show=\"vm.selectAllEvent\">Limpar seleção</span></md-button><md-option ng-value=\"event.name\" ng-repeat=\"(index, event) in vm.grid.grade_json | filter:searchEvent\" ng-if=\"(event.siblingsqtd == 0 || event.has_attendance == true) && event.pass_grade.length\">{{event.name}} | {{event.description}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" align=\"start center\"><div flex=\"100\" ng-if=\"vm.student_selected\"><md-subheader class=\"md-no-sticky\"><strong class=\"md-block\">Notas</strong></md-subheader><md-subheader class=\"md-no-sticky\"><strong>Notas especiais possíveis:</strong><i>SR = sem rendimento | DP = dispensado | FN = faltam notas</i></md-subheader><form name=\"formNoteRelease\" novalidate=\"\"><table class=\"simple table-note-release no-border-top a4-table-fixed table-float-button\"><thead><tr ng-if=\"vm.subjects.length > 0\"><th></th><th ng-repeat=\"(index, grade) in ::vm.grid.steps track by index\" colspan=\"{{grade.siblingsqtd}}\" ng-show=\"grade.show\"><b>{{grade.name}}</b></th></tr><tr><th>Disciplinas</th><th ng-repeat=\"grade in vm.filterEvents(vm.grid.grade_json)\" class=\"hoverSubjectEvent\" ng-if=\"grade.pass_grade.length\"><md-tooltip md-direction=\"top\">Média: {{grade.pass_grade}}; Máx: {{grade.max_grade}}</md-tooltip>{{grade.name}}</th></tr></thead><tbody><div class=\"tbody\"><tr ng-repeat=\"(index_tab, subject) in vm.subjects track by index_tab\"><td ng-class=\"{\'is_child\': subject.is_child}\">{{subject.subject_name}} {{subject.dependency_year !== null ? \' (DEP)\' : \'\'}}</td><td ng-repeat=\"grade in vm.filterEvents(vm.grid.grade_json)\" ng-if=\"grade.pass_grade.length\"><span ng-repeat=\"(id, note) in subject.grade_json track by id\" ng-if=\"grade.name == id\" ng-init=\"thisName = \'P_\'+id+\'-\'+subject.id;\" layout=\"row\"><md-tooltip ng-show=\"vm.getValue(id, \'badge\')\" md-direction=\"note.badge\">Exclusivo para<br>agrupamento</md-tooltip><md-input-container flex=\"\"><input name=\"{{ thisName }}\" ng-if=\"subject.codes.length > 0 || grade.codes.length > 0\" ng-value=\"note.valueConcept == null && note.value !== null && (note.value == \'FN\' || note.value == \'DP\' || note.value == \'SR\') ? note.value : note.valueConcept\" ng-model=\"note.valueConcept\" tabindex=\"index_tab\" ng-class=\"{ \'note-release-disapproved\': note.value < vm.getValue(id, \'pass_grade\'), \'note-release-approved\' : note.value >= vm.getValue(id, \'pass_grade\'), \'note-release-council\' : note.valueCouncil.length && note.valueCouncil !== null }\" note-release-has-council=\"false\" note-release-item=\"note\" note-release-mask=\"\" note-release-codes=\"grade.codes.length > 0 ? grade.codes : subject.codes\" has-code-rule=\"true\" maxlength=\"{{ vm.getValue(id, \'max_grade\').length }}\" ng-blur=\"vm.formatNote(note.value, vm.getValue(id, \'max_grade\'))\" aria-label=\"Nota\" ng-disabled=\"vm.getValue(id, \'conditional\') || vm.getValue(id, \'badge\') || ( note.status == false ) || (note.blockReason > 0 && (vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4)) || grade.formula !== null\"> <input name=\"{{ thisName }}\" ng-if=\"!(subject.codes.length > 0 || grade.codes.length > 0)\" ng-value=\"note.value\" ng-model=\"note.valueTeacher\" tabindex=\"$index\" ng-class=\"{ \'note-release-disapproved\': note.value < vm.getValue(id, \'pass_grade\'), \'note-release-approved\' : note.value >= vm.getValue(id, \'pass_grade\'), \'note-release-council\' : note.valueCouncil.length && note.valueCouncil !== null }\" note-release-mask=\"\" has-code-rule=\"false\" note-release-mask-max-number=\"vm.getValue(id, \'max_grade\')\" note-release-mask-precision=\"grade.precision\" maxlength=\"{{ vm.getValue(id, \'max_grade\').length }}\" ng-blur=\"vm.formatNote(note.value, vm.getValue(id, \'max_grade\')); vm.addLog(note.valueTeacher, note.value, subject, grade)\" aria-label=\"Nota\" ng-disabled=\"vm.getValue(id, \'conditional\') || vm.getValue(id, \'badge\') || (note.blockReason > 0 && (vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4)) || grade.formula !== null\"><md-tooltip ng-if=\"(note.blockReason > 0 && (vm.current_profile !== 0 && vm.current_profile !== 5 && vm.current_profile !== 4))\" md-direction=\"top\">{{ vm.getBlocks(note.blockReason) || \'\' }}</md-tooltip></md-input-container><md-input-container ng-if=\"grade.has_attendance && grade.attendance_type === \'E\'\" flex=\"\"><md-tooltip md-direction=\"top\">Faltas</md-tooltip><input ng-value=\"note.absence\" style=\"background-color: #a9a9a97a;\" ng-model=\"note.absence\" type=\"number\" note-release-mask=\"\" aria-label=\"Falta\"></md-input-container></span></td></tr></div></tbody></table></form></div></div>");
$templateCache.put("app/educational/note-release/subjects/views/note-release-subjects.html","<h1>Disciplinas</h1>");
$templateCache.put("app/educational/reports/views/reports-temp/absence-map.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses(); vm.group_selected_report = null\" ng-if=\"vm.recordsCheckbox == 1\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroupsForResponsibles(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" ng-change=\"vm.getGradeRuleItems(vm.group_selected_report, null)\" required=\"\"><md-option ng-repeat=\"group in vm.groupsForResponsibles | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printAbsencesMap()\" ng-disabled=\"vm.group_selected_report == null\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/annual-frequency-diary.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses(false)\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected); vm.getSubjectsByCourse(vm.print.course_selected.id);\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><div layout=\"column\" flex-gt-xs=\"\" class=\"md-block\"><label for=\"select-color\"><span><small>Turma</small></span></label><select2 ng-model=\"vm.group_selected_report\" s2-options=\"val.group_id_period as val.result for val in vm.groups\" id=\"select-color\" flex-gt-xs=\"\"></select2></div></div><div layout-padding=\"\" flex=\"\" layout=\"row\"><md-input-container flex=\"\"><label>Disciplinas</label><md-select ng-model=\"vm.subject_selected_report\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchSubject\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"0\">Todas as disciplinas</md-option><md-option ng-repeat=\"subject in vm.subjects_course | filter: searchSubject\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printAnnualFrequencyDiary()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/avaliations-result.html","<div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turmas</label><md-select ng-model=\"vm.group_selected_report\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchGroup\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"group in vm.groups | filter: searchGroup\" ng-value=\"group\">{{group.name}}</md-option></md-select></md-input-container><md-input-container><md-checkbox ng-model=\"vm.hide_defaulters\">Ocultar alunos inadimplentes</md-checkbox></md-input-container></div><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printavaliationsresult()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/birthday-list.html","<md-card-content><div layout-padding=\"\" layout=\"column\"><md-select ng-model=\"vm.selectedMonth\" placeholder=\"Mês dos aniversários\" style=\"width: 95%\" required=\"\"><md-option ng-value=\"month\" ng-repeat=\"month in vm.months\">{{ month.name }}</md-option></md-select><p style=\"margin-bottom: -5px;\">Ordenação:</p><md-radio-group layout=\"row\" ng-model=\"vm.orderByBirthday\" required=\"\"><md-radio-button value=\"1\" class=\"md-primary\">Por data</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Por nome</md-radio-button></md-radio-group><p style=\"margin-bottom: -5px;\">Filtro:</p><md-radio-group layout=\"row\" ng-model=\"vm.optionBirthday\" required=\"\"><md-radio-button value=\"1\" class=\"md-primary\" ng-click=\"vm.optioBirthday = 1\">Selecionar curso e turma</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\" ng-click=\"vm.optioBirthday = 2\">Sem filtro</md-radio-button></md-radio-group><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\" ng-if=\"vm.optionBirthday == 1\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.course_selected\" ng-change=\"vm.getGroups(vm.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\" ng-if=\"vm.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div><div ng-if=\"vm.optionBirthday == 2\"><md-checkbox ng-model=\"vm.printWithGroupsPerPage\">Imprime uma turma por página?</md-checkbox></div><md-checkbox ng-model=\"vm.breakForMonth\">Imprime um mês por página?</md-checkbox></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.selectedMonth === null || vm.orderByBirthday === null || (vm.optionBirthday === 1 && vm.group_selected === null)\" ng-click=\"vm.printstudentsbirthdays()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/blank-subjects.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses();\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected);\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.course_selected === null\" ng-repeat=\"button in vm.buttonsBlankSubjects\" ng-click=\"vm.getBlankSubjects(button.isCSV)\"><md-icon md-font-icon=\"{{button.icon}}\"></md-icon>{{button.label}}</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/class-records.html","<md-card-content><md-input-container><md-radio-group ng-model=\"vm.optionRecords\" layout=\"row\"><md-radio-button ng-value=\"1\">Por classe</md-radio-button><md-radio-button ng-value=\"2\">Por turma <b>(imprime relatório em branco)</b></md-radio-button></md-radio-group></md-input-container><form name=\"formRecords\"><div ng-if=\"vm.optionRecords === 1\"><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getClasses()\"><md-autocomplete flex=\"\" required=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_class\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getClasses(vm.searchText)\" md-item-text=\"item.alias + \' | \' + item.group_name + \' | \' + item.subject_name\" md-min-length=\"0\" placeholder=\"Selecione ou procure uma classe\"><md-item-template><span>{{item.alias + \' | \' + item.group_name + \' | \' + item.subject_name}}</span></md-item-template><md-not-found>Nenhuma classe encontrada</md-not-found></md-autocomplete></div><div layout-padding=\"\" layout=\"row\"><date-range-picker ng-model=\"vm.filter_date\" label=\"Datas\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></div></div><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\" ng-if=\"vm.optionRecords === 2\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getSubjectsByCourse(vm.print.course_selected.id); vm.getGroupsForResponsibles(vm.print.course_selected);\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-if=\"course.id !== 0\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Disciplinas</label><md-select ng-model=\"vm.subject_selected\" required=\"\"><md-option ng-repeat=\"subject in vm.subjects_course\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" required=\"\"><md-option ng-repeat=\"group in vm.groupsForResponsibles | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div></form></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.classRecords()\" ng-disabled=\"(formRecords.$pristine || formRecords.$invalid)\"><md-icon>print</md-icon>Gerar Relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/compliant-defaulting.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turmas</label><md-select ng-model=\"vm.group_selected_report\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchGroup\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"group in vm.groups | filter: searchGroup | orderBy: \'id\'\" ng-value=\"group.group_id_period\">{{group.name}}</md-option></md-select></md-input-container></div><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Ano</label><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-select name=\"month_list\" ng-model=\"vm.current_year\" required=\"\" aria-label=\"mês\"><md-option ng-repeat=\"year in vm.school_periods\" ng-value=\"year.id\">{{year.name}}</md-option></md-select></md-input-container><md-autocomplete flex=\"\" ng-if=\"vm.compliant_type == 2\" md-no-cache=\"true\" md-selected-item=\"vm.filter_service\" md-min-length=\"0\" md-selected-item-change=\"vm.selectedServiceChange(item)\" md-search-text=\"searchService\" md-items=\"item in vm.getAllServices(searchService)\" md-item-text=\"item.name\" md-floating-label=\"Digite o nome do serviço\" md-delay=\"500\"><md-item-template><span md-highlight-text=\"searchService\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Serviço não encontrado.</md-not-found></md-autocomplete><md-input-container><md-radio-group ng-model=\"vm.compliant_type\" layout=\"row\"><md-radio-button ng-value=\"1\">Inadimplência por turma</md-radio-button><md-radio-button ng-value=\"2\">Inadimplência por serviço</md-radio-button></md-radio-group></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"(vm.compliant_type === 2 && (vm.filter_service_id === null || vm.group_selected_report === null)) || (vm.compliant_type === 1 && vm.group_selected_report === null)\" target=\"_blank\" ng-click=\"vm.compliantDefaulting()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/defaults-report.html","<form name=\"formdefaults\"><md-card-content><div layout-padding=\"\" layout=\"column\"><fieldset class=\"standard without-legend group-field\" title=\"Filtro por:\"><legend>Filtro por:</legend><md-input-container class=\"md-input-has-placeholder\"><label></label><md-radio-group ng-model=\"vm.print.selected_filter\"><md-radio-button value=\"0\">Curso</md-radio-button><md-radio-button value=\"1\">Curso e turma</md-radio-button></md-radio-group></md-input-container></fieldset></div><div layout=\"row\"><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.date_range\" label=\"Datas de vencimento\" ng-value=\"vm.date_range\"></date-range-picker></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.date_range.startDate === null || vm.date_range.endDate === null || vm.print.selected_filter === null\" target=\"_blank\" href=\"{{vm.WEB_CONST}}api/reports/defaultsreportbycoursegroup?token={{vm.conf.token}}&company={{vm.conf.current_company}} &connection={{vm.conf.current_connection}}&filter_by={{vm.print.selected_filter}}&filter_date={{vm.date_range}}&user_id={{vm.conf.user_id}}&current_school_period={{vm.school_period}}\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions></form>");
$templateCache.put("app/educational/reports/views/reports-temp/enrolment-certificate.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getStudents()\"><md-autocomplete flex=\"\" md-selected-item=\"vm.selected_student_report\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getStudents(vm.searchText)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.checkSuperiorCourse(vm.selected_student_report.course_equivalence_id)\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\"><md-item-template><span>{{item.name}} - {{item.group_name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div><md-input-container ng-if=\"vm.conf.current_connection === \'led\' || vm.conf.current_connection === \'a4simetria\'\"><md-checkbox ng-model=\"vm.showWarningLED\">Exibir avisos</md-checkbox></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-disabled=\"(vm.group_selected_report == null && vm.selected_student_report == null)\" ng-click=\"vm.printEnrolmentCertificate()\">Gerar certificado<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/enrolment-form.html","<md-card-content><md-radio-group layout=\"row\" ng-model=\"vm.enrolment_form_option\"><md-radio-button value=\"1\" class=\"md-primary\">Por aluno</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Por turma</md-radio-button></md-radio-group><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getStudents(); vm.getAllEnrolmentStatus()\" ng-if=\"vm.enrolment_form_option == 1\"><md-input-container flex=\"\"><label>Status de matrícula</label><md-select ng-model=\"vm.print.enrolment_status_selected\" required=\"\"><md-option ng-value=\"null\">Selecione um Status de Matrícula</md-option><md-option ng-repeat=\"status in vm.enrolment_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_student\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getStudents(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\" md-disabled=\"vm.test\"><md-item-template><span>{{item.name + \' - \' + item.group_name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses(); vm.getAllEnrolmentStatus()\" ng-if=\"vm.enrolment_form_option == 2\"><md-input-container flex=\"\"><label>Status de matrícula</label><md-select ng-model=\"vm.print.enrolment_status_selected\" required=\"\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-repeat=\"status in vm.enrolment_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected);\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.selected_student == null && vm.enrolment_form_option === 1) || vm.group_selected_report === null && vm.enrolment_form_option === 2) || (formFinalResult.$pristine || formFinalResult.$invalid)\" target=\"_blank\" ng-click=\"vm.printEnrolmentForm()\"><md-icon>print</md-icon>Gerar Relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/enrolment-statistics.html","<md-card-content></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-checkbox ng-click=\"vm.blank_filter_date()\" ng-model=\"vm.filter_statistics_date\">Filtrar por faixa de data</md-checkbox><div layout-padding=\"\" layout=\"row\" style=\"width: 100%\"><date-range-picker ng-if=\"vm.filter_statistics_date\" style=\"width: 300px\" ng-model=\"vm.filter_date\" label=\"Datas\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.printEnrolmentStatistics()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/final-result-whiteout-period.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\"><date-picker ng-model=\"vm.date_selected\" placeholder=\"Data da emissão\"></date-picker><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><div><md-input-container><md-checkbox ng-model=\"vm.print_dependency\">Imprimir dependências em página(s) separada(s)</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.alias_subject\">Imprimir códigos das disciplinas ao invés dos nomes</md-checkbox></md-input-container></div><div><md-input-container style=\"width: 100%\"><label for=\"secretary\">Nome da secretária</label> <input ng-model=\"vm.secretary_name\" name=\"secretary\"></md-input-container><md-input-container style=\"width: 100%\"><label for=\"school_days\">Dias letivos</label> <input ng-model=\"vm.school_days\" name=\"school_days\"></md-input-container></div><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><label>Cabeçalho - Use %% para quebra de linhas</label> <textarea type=\"text\" ng-model=\"vm.header_final_results\" rows=\"4\" placeholder=\"Texto do cabeçalho\"></textarea></md-input-container><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><input type=\"text\" ng-model=\"vm.observations_final_results\" placeholder=\"Observações\"></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.course_selected == null || vm.groups.length == 0\" ng-click=\"vm.printFinalResult(0)\">Gerar Relatório<md-icon>print</md-icon>æ</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/final-result.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses(false)\"><date-picker ng-model=\"vm.date_selected\" placeholder=\"Data da emissão\"></date-picker><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><div><md-input-container><md-checkbox ng-model=\"vm.print_dependency\">Imprimir dependências em página(s) separada(s)</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.alias_subject\">Imprimir códigos das disciplinas ao invés dos nomes</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.print_caption\">Imprimir com legendas</md-checkbox></md-input-container><p><strong>Atenção:</strong> Em caso de nomes muito longos ou de grande número de disciplinas a ata será impressa com os códigos das disciplinas.</p></div><md-input-container style=\"width: 100%\"><label for=\"secretary\">Nome da secretária</label> <input ng-model=\"vm.secretary_name\" name=\"secretary\"></md-input-container><md-input-container style=\"width: 100%\"><label for=\"school_days\">Dias letivos</label> <input ng-model=\"vm.school_days\" name=\"school_days\"></md-input-container><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><label>Cabeçalho - Use %% para quebra de linhas</label> <textarea type=\"text\" ng-model=\"vm.header_final_results\" rows=\"4\" placeholder=\"Texto do cabeçalho\"></textarea></md-input-container><md-input-container style=\"width: 100%;\" class=\"md-input-has-placeholder\"><input type=\"text\" ng-model=\"vm.observations_final_results\" placeholder=\"Observações\"></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.course_selected == null || vm.groups.length == 0\" ng-click=\"vm.printFinalResult()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/frequency-diary.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected); vm.getSubjectsByCourse(vm.print.course_selected.id);\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><div layout=\"column\" flex-gt-xs=\"\" class=\"md-block\"><label for=\"select-color\"><span><small>Turma</small></span></label><select2 ng-model=\"vm.group_selected_report\" s2-options=\"val.group_id_period as val.result for val in vm.groups\" id=\"select-color\" flex-gt-xs=\"\"></select2></div></div><div layout-padding=\"\" flex=\"\" layout=\"row\"><md-input-container flex=\"\"><label>Disciplinas</label><md-select ng-model=\"vm.subject_selected_report\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchSubject\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"0\">Todas as disciplinas</md-option><md-option ng-repeat=\"subject in vm.subjects_course | filter: searchSubject\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Mês</label><md-select ng-model=\"vm.selectedMonth\"><md-option ng-value=\"null\">Não especificado</md-option><md-option ng-value=\"999\">Primeiro semestre</md-option><md-option ng-value=\"888\">segundo semestre</md-option><md-option ng-repeat=\"month in vm.months\" ng-value=\"month.value\">{{month.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><md-checkbox ng-model=\"vm.dont_print_days\">Não imprimir dias</md-checkbox></md-input-container></div><div layout-padding=\"\" flex=\"\" layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.hide_defaulters\">Ocultar alunos inadimplentes</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.show_month_days\">Exibir colunas de dia, mês e média</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.show_non_regular_student\">Incluir alunos não frequentes</md-checkbox></md-input-container><md-input-container ng-hide=\"vm.conf.current_company !== 101167\"><md-checkbox ng-model=\"vm.hide_disciplines\">Ocultar o nome de disciplina</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.hide_teacher_and_subject\">Ocultar nome de professor e de disciplina</md-checkbox></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printFrequencyDiary()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/frequency-map.html","<form name=\"freqMap\"><md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\"><md-input-container flex=\"\" ng-if=\"vm.frequency_map_config.option != 4\"><label>Curso</label><md-select ng-model=\"vm.frequency_map_config.course_selected\" ng-change=\"vm.getGroups(vm.frequency_map_config.course_selected); vm.getSubjectsByCourse(vm.frequency_map_config.course_selected.id); vm.frequency_map_config.course_id = vm.frequency_map_config.course_selected.id;\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-if=\"course.id !== 0\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"vm.frequency_map_config.option != 4\"><label>Turmas</label><md-select ng-model=\"vm.frequency_map_config.group_selected\" ng-change=\"vm.frequency_map_config.group_id = vm.frequency_map_config.group_selected.id;\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchGroup\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"group in vm.groups | filter: searchGroup\" ng-value=\"group\" ng-if=\"group.id !== 0\">{{group.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"(vm.frequency_map_config.option != 3)&&(vm.frequency_map_config.option != 4)\"><label>Disciplinas</label><md-select ng-model=\"vm.frequency_map_config.subject_id\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchSubject\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"subject in vm.subjects_course | filter: searchSubject\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container></div><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getStudents();vm.selected_student_report=null;vm.searchText=null\" ng-if=\"vm.frequency_map_config.option == 4\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_student_report\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getRegularStudents(vm.searchText)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.getGradeRuleItems(null, vm.selected_student_report.id, vm.selected_student_report.matrix_period)\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\"><md-item-template><span>{{item.name}} - {{item.group_name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div><div style=\"width: 100%\"><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.frequency_map_config.date_range\" required=\"\"></date-range-picker></div><md-input-container style=\"width: 100%\"><md-radio-group ng-model=\"vm.frequency_map_config.option\"><fieldset class=\"standard without-legend group-field\" style=\"text-align: left !important;\"><legend>Imprimir:</legend></fieldset><md-radio-button value=\"1\">Por disciplina/aulas realizadas [detalhado]</md-radio-button><md-radio-button value=\"2\">Por disciplina/aulas realizadas [resumido]</md-radio-button><md-radio-button value=\"3\">Por turma/horário/aulas realizadas</md-radio-button><md-radio-button value=\"4\">Por aluno</md-radio-button></md-radio-group></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printFrequencyMap()\" target=\"_blank\" ng-disabled=\"freqMap.$invalid\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions></form>");
$templateCache.put("app/educational/reports/views/reports-temp/grade-rule-diary.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses(false)\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected); vm.getSubjectsByCourse(vm.print.course_selected.id);\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turmas</label><md-select ng-model=\"vm.group_selected_report\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchGroup\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"group in vm.groups | filter: searchGroup\" ng-value=\"group\">{{group.result}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Disciplinas</label><md-select ng-model=\"vm.subject_selected_report\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchSubject\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"0\">Todas as disciplinas</md-option><md-option ng-repeat=\"subject in vm.subjects_course | filter: searchSubject\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container></div><md-input-container style=\"width: 100%\"><md-radio-group ng-model=\"vm.gradeRuleDiaryOption\"><fieldset class=\"standard without-legend group-field\"><legend>Imprimir:</legend><md-radio-button value=\"1\">De acordo com critérios de avaliação</md-radio-button><md-radio-button value=\"2\">Modelo padronizado</md-radio-button></fieldset></md-radio-group></md-input-container><div layout-padding=\"\" flex=\"\" layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.hide_defaulters\">Ocultar alunos inadimplentes</md-checkbox></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-disabled=\"(vm.group_selected_report === null && vm.print.course_selected.id !== 0)\" ng-click=\"vm.printGradeRuleDiary()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/hours-lessons.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses(); vm.print.group_selected.id = 0;\"><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-init=\"vm.print.course_selected.id = 0\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\" ng-selected=\"vm.print.group_selected.id == group.id || vm.print.group_selected == group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printHoursLessons()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/individual-form.html","<md-card-content><md-radio-group layout=\"row\" ng-model=\"vm.recordsCheckbox\" required=\"\"><md-radio-button value=\"1\" class=\"md-primary\">Por turma</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Por aluno</md-radio-button></md-radio-group><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses(); vm.getAllEnrolmentStatus()\" ng-if=\"vm.recordsCheckbox == 1\"><md-input-container flex=\"\"><label>Status de matrícula</label><md-select ng-model=\"vm.print.enrolment_status_selected\" required=\"\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-repeat=\"status in vm.enrolment_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" ng-change=\"vm.getGradeRuleItems(vm.group_selected_report, null)\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><p></p><div ng-if=\"vm.recordsCheckbox == 1\"><p>Ordenação:</p><md-radio-group layout=\"row\" ng-model=\"vm.registration_numbr\"><md-radio-button value=\"1\" class=\"md-primary\">Número de matrícula</md-radio-button><md-radio-button value=\"0\" class=\"md-primary\">Ordem alfabética</md-radio-button></md-radio-group></div><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getStudents()\" ng-if=\"vm.recordsCheckbox == 2\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_student_report\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getRegularStudents(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\"><md-item-template><span>{{item.name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-disabled=\"(vm.group_selected_report == null && vm.selected_student_report == null)\" ng-click=\"vm.generateIndividualStudentForm()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/new-students.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getAllEnrolmentStatus()\"><div layout=\"row\"><md-input-container flex=\"\"><label>Status de matricula</label><md-select ng-model=\"vm.print.enrolment_status_selected\" required=\"\" style=\"width: 25%;\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-repeat=\"status in vm.enrolment_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printNewStudents()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/notes-map.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\" ng-if=\"vm.recordsCheckbox == 1\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.group_selected_report = null; vm.getGroupsForResponsibles(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-if=\"course.id !== 0\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" ng-change=\"vm.getGradeRuleItems(vm.group_selected_report, null)\" required=\"\"><md-option ng-repeat=\"group in vm.groupsForResponsibles | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><md-input-container flex=\"\" style=\"padding-left: 15px; width: 100%\"><label>Evento</label><md-select name=\"course_selected\" ng-model=\"vm.grade_rule_item\" required=\"\"><md-option ng-repeat=\"grade_rule_item in vm.grade_rule_items\" ng-value=\"grade_rule_item.id\">{{grade_rule_item.description}}</md-option></md-select></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-disabled=\"vm.grade_rule_item == null\" href=\"{{vm.WEB_CONST}}api/reports/notesmap?token={{vm.conf.token}}&company={{vm.conf.current_company}} &connection={{vm.conf.current_connection}}&course_id={{vm.print.course_selected.id}} &group_id={{vm.group_selected_report}}&user_id={{vm.conf.user_id}} &grade_rule_item={{vm.grade_rule_item}}&current_school_period={{vm.school_period}}\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/pending-documents.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses(); vm.getDocuments()\"><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-init=\"vm.print.course_selected.id = 0\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Documento</label><md-select ng-model=\"vm.print.enrolment_item_selected\" ng-init=\"vm.print.enrolment_item_selected = null\"><md-option ng-repeat=\"enrolment_item in vm.enrolment_items\" ng-value=\"enrolment_item\">{{enrolment_item.name}}</md-option></md-select></md-input-container></div><md-checkbox ng-model=\"vm.only_enrolment_item_handed\">Apenas com documento entregue</md-checkbox></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.course_selected === null\" target=\"_blank\" ng-click=\"vm.studentsprintPendingDocuments()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/pending-notes.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\" ng-if=\"vm.recordsCheckbox == 1\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroupsForResponsibles(vm.print.course_selected); vm.getSubjectsByCourse(vm.print.course_selected.id);\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-if=\"course.id !== 0 || vm.pending_notes_option === 2\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" ng-change=\"vm.getGradeRuleItems(vm.group_selected_report, null, false, 1, true)\" required=\"\"><md-option ng-value=\"0\" ng-if=\"vm.pending_notes_option === 2\">Todas as turmas</md-option><md-option ng-repeat=\"group in vm.groupsForResponsibles | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><md-input-container style=\"text-align: center\"><md-radio-group ng-model=\"vm.pending_notes_option\" layout=\"row\"><md-radio-button ng-value=\"1\">Por avaliações</md-radio-button><md-radio-button ng-value=\"2\">Por disciplinas</md-radio-button></md-radio-group></md-input-container><md-input-container flex=\"\" style=\"padding-left: 15px; width: 100%\" ng-if=\"vm.pending_notes_option === 1\"><label>Eventos</label><md-select name=\"course_selected\" ng-model=\"vm.grade_rule_item\" required=\"\"><md-option ng-repeat=\"grade_rule_item in vm.grade_rule_items\" ng-value=\"grade_rule_item.id\" ng-if=\"grade_rule_item.type === \'E\'\">{{grade_rule_item.description}}</md-option></md-select></md-input-container><md-input-container flex=\"\" style=\"padding-left: 15px; width: 100%\" ng-if=\"vm.pending_notes_option === 2\"><label>Disciplinas</label><md-select ng-model=\"vm.selected_subject\" required=\"\"><md-option ng-value=\"0\">Todas as disciplinas</md-option><md-option ng-repeat=\"subject in vm.subjects_course\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-disabled=\"(vm.grade_rule_item === null && vm.pending_notes_option === 1) || (vm.selected_subject === null && vm.pending_notes_option === 2)\" ng-click=\"vm.generatePendingNotes()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/pending-subjects.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroupsForResponsibles(vm.print.course_selected); vm.getSubjectsByCourse(vm.print.course_selected.id);\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" ng-change=\"vm.getGradeRuleItems(vm.group_selected_report, null, false, 1, true)\" required=\"\"><md-option ng-value=\"0\">Todas as turmas</md-option><md-option ng-repeat=\"group in vm.groupsForResponsibles | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.print.date_range\"></date-range-picker></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printPendingSubjects()\" ng-disabled=\"(vm.print.course_selected === null) || (vm.group_selected_report === null)\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/receive-protocol.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCoursesForResponsibles()\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\">{{group.name}}</md-option></md-select></md-input-container><br><md-input-container flex=\"\"><label>Título do documento</label> <input type=\"text\" ng-model=\"vm.documentTitle\" required=\"\"></md-input-container></div><div layout-padding=\"\" layout=\"row\"><md-input-container flex=\"\"><label>Status dos alunos</label><md-select ng-model=\"vm.enrolment_status_selected\" ng-init=\"vm.getAllEnrolmentStatus()\"><md-option ng-value=\"\'null\'\">Todos os status</md-option><md-option ng-repeat=\"status in vm.enrolment_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.group_selected === 0 || vm.print.group_selected === null || !vm.documentTitle\" ng-click=\"vm.printreceiveprotocol()\"><md-icon>print</md-icon>Gerar documento</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/registration-book.html","<form name=\"formRegistratioBook\"><md-card-content layout-padding=\"\" ng-init=\"vm.getCourses(false)\"><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select name=\"course_selected\" ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select name=\"group_selected\" ng-model=\"vm.print.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\">{{group.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.print.date_range\"></date-range-picker><md-checkbox ng-model=\"vm.orderByEnrolmentNumber\">Ordenar por matrícula</md-checkbox></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"formRegistratioBook.$pristine || formRegistratioBook.$invalid\" ng-click=\"vm.printRegistrationBook()\"><md-icon>print</md-icon>Gerar Relatório</md-button></md-card-actions></form>");
$templateCache.put("app/educational/reports/views/reports-temp/registration-by-user.html","<md-card-content><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\"><md-radio-group layout=\"row\" ng-model=\"vm.recordsCheckbox\" required=\"\" ng-change=\"\"><md-radio-button value=\"1\" class=\"md-primary\">Por periodo</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Por usuário/periodo</md-radio-button></md-radio-group><div layout=\"row\"><date-range-picker style=\"width: 50%\" flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.print.date_range\"></date-range-picker><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getAllLogUsers();vm.users_filter.name = null;vm.searchText = null\" style=\"width: 50%\" ng-if=\"vm.recordsCheckbox == 2\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-search-text=\"vm.searchText\" md-items=\"user in vm.users_filter\" md-item-text=\"user.name\" md-selected-item=\"vm.users_filter.name\" md-selected-item-change=\"\" md-min-length=\"0\" placeholder=\"Selecione ou procure um usuário\"><md-item-template><span>{{user.name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div></div></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"\" target=\"_blank\" ng-click=\"vm.registrationByUser()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/responsibles-and-dependents.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getPersonRelationLegal()\"><p style=\"margin-bottom: -5px;\">Tipo de responsável:</p><md-radio-group layout=\"row\" ng-model=\"vm.financeOrPedagogic\" required=\"\"><md-radio-button value=\"1\" class=\"md-primary\">Responsável financeiro</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Responsável pedagógico</md-radio-button></md-radio-group><div layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.print_enrolled\">Imprime apenas alunos matriculados</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.without_company\">Imprime de todas as empresas</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.only_more_than_two\">Apenas responsáveis com mais de 1 dependente</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.only_new_students\">Apenas alunos novos</md-checkbox></md-input-container></div><div layout=\"column\" flex-gt-xs=\"\" class=\"md-block\"><label for=\"select-color\"><span><small>Grau de parentesco</small></span></label><select2 ng-model=\"vm.person_relation_type_id\" s2-options=\"val.id as val.name for val in vm.person_relation_types\" id=\"select-color\" flex-gt-xs=\"\"></select2></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" href=\"{{vm.WEB_CONST}}api/reports/responsiblesanddependents?token={{vm.conf.token}}&company={{vm.conf.current_company}} &connection={{vm.conf.current_connection}} &school_period={{vm.school_period}} &finance_or_pedagogic={{vm.financeOrPedagogic}} &user_id={{vm.conf.user_id}} &without_company={{vm.without_company}} &person_relation_type_id={{vm.person_relation_type_id}} &only_more_than_two={{vm.only_more_than_two}} &only_new_students={{vm.only_new_students}} &only_enrolled={{vm.print_enrolled}}&current_school_period={{vm.school_period}}\"><md-icon>print</md-icon>Gerar Relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/school-records.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getStudents()\"><md-autocomplete flex=\"\" md-selected-item=\"vm.selected_student_report\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getRegularStudents(vm.searchText)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.checkSuperiorCourse(vm.selected_student_report.course_equivalence_id)\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\"><md-item-template><span>{{item.name}} - {{item.group_name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete><div layout-padding=\"\" ng-if=\"vm.is_superior_course || vm.selected_student_report.course_equivalence_id === 400\"><a4-school-record-config config=\"vm.school_record_config\"></a4-school-record-config></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-disabled=\"(vm.group_selected_report == null && vm.selected_student_report == null)\" ng-click=\"vm.checkConfigOfSchoolRecordsBeforePrint()\">Gerar Histórico<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/student-notebook.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getStudents()\"><md-radio-group layout=\"row\" ng-model=\"vm.notebook_config\" ng-change=\"vm.clearSelectionsOfNotebook()\"><md-radio-button value=\"1\" class=\"md-primary\">Por turma</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Por aluno</md-radio-button></md-radio-group><div><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses(false)\" ng-if=\"vm.notebook_config == 1\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected); vm.getSubjectsByCourse(vm.print.course_selected.id)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\" required=\"\" ng-disabled=\"vm.print.course_selected === null\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><div ng-if=\"vm.notebook_config == 2\"><label>Alunos</label><md-autocomplete flex=\"\" md-selected-item=\"vm.selected_student_report\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getRegularStudents(vm.searchText)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.checkSuperiorCourse(vm.selected_student_report.course_equivalence_id); vm.getSubjectsByCourse(vm.selected_student_report.course_id)\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\"><md-item-template><span>{{item.name}} - {{item.group_name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div></div><div layout-padding=\"\" flex=\"\" layout=\"row\"><md-input-container flex=\"\"><label>Disciplinas*</label><md-select ng-model=\"vm.subject_selected_report\" ng-disabled=\"vm.print.group_selected === null && vm.selected_student_report === null\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchSubject\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"subject in vm.subjects_course | filter: searchSubject\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printStudentNotebook()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/student-occurrences.html","<md-card-content><md-radio-group layout=\"row\" ng-model=\"vm.occurrencesCheckbox\" required=\"\"><md-radio-button ng-value=\"\'group\'\" class=\"md-primary\">Por turma</md-radio-button><md-radio-button ng-value=\"\'student\'\" class=\"md-primary\">Por aluno</md-radio-button><md-radio-button ng-value=\"\'collaborator\'\" class=\"md-primary\">Por colaborador ou professor</md-radio-button></md-radio-group><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses()\" ng-if=\"vm.occurrencesCheckbox === \'group\'\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turmas</label><md-select ng-model=\"vm.group_selected_report\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchGroup\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"group in vm.groups | filter: searchGroup\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><div layout-padding=\"\" layout=\"row\" ng-if=\"vm.occurrencesCheckbox === \'student\'\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_student\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getStudents(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\"><md-item-template><span>{{item.name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div><div layout-padding=\"\" layout=\"row\" ng-if=\"vm.occurrencesCheckbox === \'collaborator\'\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_collaborator\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getCollaborators(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" placeholder=\"Selecione ou procure um colaborador ou professor\"><md-item-template><span>{{item.name}}</span></md-item-template><md-not-found>Nenhum colaborador ou professor encontrado</md-not-found></md-autocomplete></div><div layout=\"row\"><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.print.date_range\"></date-range-picker></div><md-input-container><md-checkbox ng-model=\"vm.show_all_occurrences\">incluir ocorrencias de outros periodos letivos</md-checkbox></md-input-container><p style=\"font-size: 16px; color: #030303ef;\" ng-if=\"vm.show_all_occurrences == true\"><b>Atenção!</b> A opção marcada acima inclui ocorrências de outros periodos letivos, porém essas ocorrências ainda serão submetidas aos demais filtros.</p></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"(vm.selected_student == null && vm.group_selected_report === null && vm.selected_collaborator == null) || (formFinalResult.$pristine || formFinalResult.$invalid))\" target=\"_blank\" ng-click=\"vm.generateStudentOccurrences()\"><md-icon>print</md-icon>Gerar Relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/student-wallet.html","<md-card-content><md-radio-group layout=\"row\" ng-model=\"vm.wallet_config\"><md-radio-button value=\"1\" class=\"md-primary\">Por turma</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Por aluno</md-radio-button></md-radio-group><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\" ng-if=\"vm.wallet_config == 1\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getStudents()\" ng-if=\"vm.wallet_config == 2\"><md-autocomplete flex=\"\" md-selected-item=\"vm.selected_student_report\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getStudents(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\"><md-item-template><span>{{item.name}} - {{item.group_name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div><fieldset class=\"standard without-legend group-field\"><legend>Título da carteirinha</legend><md-input-container><md-radio-group ng-model=\"vm.wallet_orientation.title\"><md-radio-button ng-value=\"1\">Cartão de identificação do portador</md-radio-button><md-radio-button ng-value=\"2\">Cartão de autorização de saída</md-radio-button></md-radio-group></md-input-container></fieldset><div layout-padding=\"\"><fieldset class=\"standard without-legend group-field\"><legend>Orientações da carteirinha</legend><md-input-container><md-checkbox ng-model=\"vm.wallet_orientation.one\">Orientação 1</md-checkbox><md-checkbox ng-model=\"vm.wallet_orientation.two\">Orientação 2</md-checkbox><md-checkbox ng-model=\"vm.wallet_orientation.three\">Orientação 3</md-checkbox></md-input-container></fieldset><fieldset class=\"standard without-legend group-field\"><legend>Informações da carteirinha</legend><md-input-container><md-checkbox ng-model=\"vm.wallet_orientation.photo\">Foto do aluno</md-checkbox><md-checkbox ng-model=\"vm.wallet_orientation.carrier\">Portador(es)</md-checkbox><md-checkbox ng-model=\"vm.wallet_orientation.transport\">Transporte</md-checkbox><md-checkbox ng-model=\"vm.wallet_orientation.authorization\">Autorização</md-checkbox><md-checkbox ng-model=\"vm.wallet_orientation.responsible_sign\">Assinatura do responsável</md-checkbox></md-input-container></fieldset></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"(vm.print.group_selected === 0 && vm.selected_student_report === null) || (formFinalResult.$pristine || formFinalResult.$invalid)\" target=\"_blank\" ng-click=\"vm.generateWallets()\"><md-icon>print</md-icon>Gerar Carteirinhas</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-approved-disapproved-by-group.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses()\"><md-input-container style=\"text-align: center\"><md-radio-group layout=\"row\" ng-model=\"vm.approvedDisapproved\" required=\"\"><md-radio-button value=\"1\" class=\"md-primary\">Aprovados</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Reprovados</md-radio-button></md-radio-group></md-input-container><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-init=\"vm.print.course_selected.id = 0\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\" ng-selected=\"vm.print.group_selected.id == group.id || vm.print.group_selected == group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.group_selected === null || vm.print.course_selected === null\" ng-click=\"vm.printApprovedOrDisapprovedByGroup()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-approved-disapproved.html","<md-card-content><md-radio-group layout=\"row\" ng-model=\"vm.approvedDisapproved\" required=\"\"><md-radio-button value=\"1\" class=\"md-primary\">Aprovados</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Reprovados</md-radio-button></md-radio-group><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses(false)\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" ng-change=\"vm.getGradeRuleItems(vm.group_selected_report, null)\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><md-input-container flex=\"\" style=\"padding-left: 15px; width: 100%\"><label>Etapa</label><md-select name=\"course_selected\" ng-model=\"vm.grade_rule_item\" required=\"\"><md-option ng-repeat=\"grade_rule_item in vm.grade_rule_items\" ng-value=\"grade_rule_item.id\">{{grade_rule_item.description}}</md-option></md-select></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printApprovedOrDisapproved()\" ng-disabled=\"vm.grade_rule_item == null\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-canceled.html","<form name=\"formFinalResult\"><md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turmas</label><md-select ng-model=\"vm.group_selected_report\" required=\"\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchGroup\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"group in vm.groups | filter: searchGroup\" ng-value=\"group\">{{group.name}}</md-option></md-select></md-input-container><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.print.date_range\"></date-range-picker></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"(formFinalResult.$pristine || formFinalResult.$invalid)\" target=\"_blank\" ng-click=\"vm.printStudentsCanceled()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions></form>");
$templateCache.put("app/educational/reports/views/reports-temp/students-classification.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\" ng-if=\"vm.recordsCheckbox == 1\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroupsForResponsibles(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" ng-change=\"vm.getGradeRuleItems(vm.group_selected_report, null)\" required=\"\"><md-option ng-repeat=\"group in vm.groupsForResponsibles | orderBy:\'id\'\" ng-value=\"group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div><md-input-container flex=\"\" style=\"padding-left: 15px; width: 100%\"><label>Evento</label><md-select name=\"course_selected\" ng-model=\"vm.grade_rule_item\" required=\"\"><md-option ng-repeat=\"grade_rule_item in vm.grade_rule_items\" ng-value=\"grade_rule_item.id\">{{grade_rule_item.description}}</md-option></md-select></md-input-container><md-input-container><md-radio-group ng-model=\"vm.classification_option\" layout=\"row\"><md-radio-button ng-value=\"1\">Dividir pelas disciplinas com nota</md-radio-button><md-radio-button ng-value=\"2\">Dividir por todas as disciplinas</md-radio-button></md-radio-group></md-input-container><md-input-container><md-checkbox ng-model=\"vm.combineCourseGroup\">Agregar alunos de cursos e turmas diferentes</md-checkbox></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-disabled=\"vm.grade_rule_item == null\" ng-click=\"vm.printStudentsClassification()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-conditional-step.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\" ng-if=\"vm.recordsCheckbox == 1\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroupsForResponsibles(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" ng-change=\"vm.getGradeRuleItems(vm.group_selected_report, null, true, null, true)\" required=\"\"><md-option ng-show=\"vm.print.course_selected.id!==0\" ng-repeat=\"group in vm.groupsForResponsibles | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option><md-option ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div><md-input-container flex=\"\" style=\"padding-left: 15px; width: 100%\"><label>Evento</label><md-select name=\"course_selected\" ng-model=\"vm.grade_rule_item\" required=\"\"><md-option ng-repeat=\"grade_rule_item in vm.grade_rule_items\" ng-value=\"grade_rule_item.id\">{{grade_rule_item.description}}</md-option></md-select></md-input-container><md-input-container flex=\"\" style=\"padding-left: 15px; width: 50%\"><md-checkbox ng-model=\"vm.exclude_event_done\">Não inclui eventos com notas já lançadas</md-checkbox></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-disabled=\"vm.grade_rule_item == null\" ng-click=\"vm.generateStudentsConditionalStep()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-contacts.html","<md-card-content><div layout-padding=\"\" ng-init=\"vm.getCourses(); vm.getAllEnrolmentStatus()\"><div layout=\"column\"><div><md-input-container><md-checkbox ng-model=\"vm.only_new\">Imprimir apenas alunos novos</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.printInstagram\">Imprimir Instagram</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option><md-option ng-if=\"((vm.groups.length === 0 || vm.groups === null) && vm.print.course_selected !== null)\" value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div><div style=\"width: 100% !important;\" flex=\"\"><md-input-container flex=\"\" style=\"width: 100% !important;\"><label>Status de matrícula</label><md-select ng-model=\"vm.print.enrolment_status_selected\" required=\"\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-repeat=\"status in vm.enrolment_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container></div></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printStudentsContacts()\" ng-disabled=\"vm.print.group_selected === null\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-dependencies.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses()\"><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-init=\"vm.print.course_selected.id = 0\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\" ng-selected=\"vm.print.group_selected.id == group.id || vm.print.group_selected == group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.group_selected === null || vm.print.course_selected === null\" ng-click=\"vm.printStudentsDependenciesReport()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-discounts.html","<md-card-content layout-padding=\"\" ng-init=\"vm.getCourses()\" style=\"max-height: 600px; overflow-y: auto;\"><div layout=\"row\" flex=\"100\" style=\"padding: 0;\"><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Agrupamento</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\" style=\"margin-top: 15px;\"><md-input-container><md-radio-group ng-model=\"vm.discount_option\" layout=\"row\"><md-radio-button value=\"0\">Alunos e descontos</md-radio-button><md-radio-button value=\"1\">Alunos e descontos por curso e turma</md-radio-button><md-radio-button value=\"2\">Alunos e descontos por curso e turma com detalhamento</md-radio-button><md-radio-button value=\"3\">Descontos por curso e turma</md-radio-button><md-radio-button value=\"4\">Alunos sem desconto</md-radio-button></md-radio-group></md-input-container></div></div></div><div ng-controller=\"ReportDetailController\" ng-style=\"vm.filterBoxColor()\" style=\"border-radius: 5px\"><div name=\"warning\" ng-if=\"vm.discount_option == 4\"><strong name=\"warning-title\" style=\"font-weight: bold; mso-font-width: 75%;\">AVISO!</strong><div name=\"warning-text\" style=\"font-style: italic; font-weight: 100; mso-font-width: 150%\"><small>Caso você deseje ver os alunos que <b>não possuem desconto algum</b>, deixe esses filtros abaixo sem alteração.</small> <small>Caso você deseje ver os alunos que não possuem um tipo de desconto específico ou alguma outra condição de desconto, selecione abaixo o filtro para os alunos que <b>NÃO</b> atendem a condição. Nesse caso serão apresentados os alunos que não possuem desconto algum e os que possuem algum desconto que não seja os do filtro.</small></div><br></div><div layout=\"row\" flex=\"100\" style=\"padding: 0;\"><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Definido como</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\" style=\"margin-top: 15px;\"><md-input-container><md-radio-group ng-model=\"vm.discount_type\" layout=\"row\"><md-radio-button value=\"0\">Valor</md-radio-button><md-radio-button value=\"1\">Percentual</md-radio-button><md-radio-button value=\"2\">Ambos</md-radio-button></md-radio-group></md-input-container></div></div><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Período de vigência</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\"><date-range-picker label=\"\" flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.date_range\" style=\"margin-top: 3px;\"></date-range-picker></div></div><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Valor/percentual entre</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\"><md-input-container><label>Inicial</label> <input ng-model=\"vm.initial_value\" name=\"secretary\" type=\"number\"></md-input-container><md-input-container><label>Final</label> <input ng-model=\"vm.end_value\" name=\"secretary\" type=\"number\"></md-input-container></div></div></div><div layout=\"row\" flex=\"100\" style=\"padding: 0;\"><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Tipo de serviço</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\" style=\"margin-top: 15px;\"><md-input-container><md-radio-group ng-model=\"vm.service_type\" layout=\"row\"><md-radio-button value=\"0\">Principal</md-radio-button><md-radio-button value=\"1\">Extra</md-radio-button><md-radio-button value=\"2\">Ambos</md-radio-button></md-radio-group></md-input-container></div></div><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Razão do desconto</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\"><md-autocomplete flex=\"\" md-no-cache=\"true\" md-selected-item=\"vm.filter_reason\" md-min-length=\"0\" md-search-text=\"searchReason\" md-items=\"item in vm.getDiscountsReasons(searchReason)\" md-item-text=\"item.name\" md-floating-label=\"Digite a razão\" md-delay=\"500\"><md-item-template><span md-highlight-text=\"searchReason\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Razão não encontrada.</md-not-found></md-autocomplete></div></div><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Serviço</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_service\" md-search-text=\"vm.searchService\" md-items=\"item in vm.getServices(vm.searchService)\" md-item-text=\"item.name\" md-min-length=\"0\" md-delay=\"500\" md-floating-label=\"Procure um serviço\"><md-item-template><span>{{item.name}}</span></md-item-template><md-not-found>Nenhum serviço encontrado</md-not-found></md-autocomplete></div></div></div><div layout=\"row\" flex=\"100\" style=\"padding: 0;\"><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Tipo de desconto</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\" style=\"margin-top: 15px;\"><md-input-container><md-radio-group ng-model=\"vm.payment_plan_discount\" layout=\"row\"><md-radio-button value=\"0\">Plano</md-radio-button><md-radio-button value=\"1\">Individual</md-radio-button><md-radio-button value=\"2\">Ambos</md-radio-button></md-radio-group></md-input-container></div></div><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Data de inclusão</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\"><date-range-picker label=\"\" flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.date_range_entered\" style=\"margin-top: 3px;\"></date-range-picker></div></div><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Pessoa que incluiu</b></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_person\" md-search-text=\"vm.searchPerson\" md-items=\"item in vm.getUsersEnteredDiscount(vm.searchPerson)\" md-item-text=\"item.name\" md-min-length=\"0\" md-delay=\"500\" md-floating-label=\"Procure uma pessoa\"><md-item-template><span>{{item.name}}</span></md-item-template><md-not-found>Nenhuma pessoa encontrada</md-not-found></md-autocomplete></div></div></div></div><br><div layout=\"row\" flex=\"100\" style=\"padding: 0;\"><div layout=\"column\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Filtro por curso e turma</b></div></div><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-init=\"vm.print.course_selected.id = 0\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\" ng-selected=\"vm.print.group_selected.id == group.id || vm.print.group_selected == group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-click=\"vm.printStudentsDiscounts({discount_option:vm.discount_option,discount_type:vm.discount_type, start_date:vm.date_range.startDate,end_date:vm.date_range.endDate,start_date_entered:vm.date_range_entered.startDate, end_date_entered:vm.date_range_entered.endDate,initial_value:vm.initial_value,end_value:vm.end_value, reason_id:vm.filter_reason.id,service_id:vm.selected_service.id, person_id: vm.selected_person.id, payment_plan_discount: vm.payment_plan_discount, service_type: vm.service_type, course: vm.print.course_selected.id, groups: vm.print.group_selected})\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-enrolled.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses()\"><fieldset class=\"standard without-legend group-field\" title=\"Filtro por:\"><legend>Filtro por:</legend><md-input-container class=\"md-input-has-placeholder\"><label></label><md-radio-group ng-model=\"vm.print.selected_filter\"><md-radio-button value=\"0\">Curso e turma</md-radio-button><md-radio-button value=\"1\">Data de matrícula</md-radio-button><md-radio-button value=\"2\">Até uma data</md-radio-button></md-radio-group></md-input-container></fieldset><fieldset class=\"standard without-legend group-field\" title=\"Filtro por:\"><legend>Ordenar por por:</legend><md-input-container class=\"md-input-has-placeholder\"><label></label><md-radio-group ng-model=\"vm.print.selected_order\"><md-radio-button value=\"0\">Data de matrícula</md-radio-button><md-radio-button value=\"1\">Número na caderneta</md-radio-button><md-radio-button value=\"2\">Ordem alfabética</md-radio-button></md-radio-group></md-input-container></fieldset><md-input-container ng-if=\"vm.academic_type !== 1 || vm.school_period === 0\" ng-init=\"vm.print.show_concluded_groups = false\"><md-checkbox ng-model=\"vm.print.show_concluded_groups\">Trazer turmas e matrículas concluídas</md-checkbox></md-input-container><div layout=\"row\" ng-if=\"vm.print.selected_filter == 0\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-init=\"vm.print.course_selected.id = 0\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\" ng-selected=\"vm.print.group_selected.id == group.id || vm.print.group_selected == group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.print.date_range\" ng-if=\"vm.print.selected_filter == 1\"></date-range-picker><date-picker flex=\"\" label=\"Data limite\" ng-model=\"vm.print.date_limit\" ng-if=\"vm.print.selected_filter == 2\"></date-picker><md-input-container><md-select ng-model=\"vm.enrolment_status_selected\" ng-init=\"vm.getAllEnrolmentStatus()\"><md-option ng-value=\"\'null\'\">Todos os alunos</md-option><md-option ng-repeat=\"status in vm.enrolment_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"(formFinalResult.$pristine || formFinalResult.$invalid)\" target=\"_blank\" ng-click=\"vm.printStudentEnrolled()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-list-per-group.html","<md-card-content><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses()\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option><md-option ng-if=\"((vm.groups.length === 0 || vm.groups === null) && vm.print.course_selected !== null)\" value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.group_selected === null\" target=\"_blank\" href=\"{{vm.WEB_CONST}}api/reports/studentslistpergroup?token={{vm.conf.token}}&company={{vm.conf.current_company}} &connection={{vm.conf.current_connection}}&group_id={{vm.print.group_selected}} &course_id={{vm.print.course_selected.id}}&user_id={{vm.conf.user_id}}&current_school_period={{vm.school_period}}\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-online-enrolment.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses()\"><fieldset class=\"standard without-legend group-field\" title=\"Filtro por:\"><legend>Filtro por:</legend><md-input-container class=\"md-input-has-placeholder\"><label></label><md-radio-group ng-model=\"vm.print.selected_filter\"><md-radio-button value=\"0\">Curso e turma</md-radio-button><md-radio-button value=\"1\">Data de matrícula</md-radio-button><md-radio-button value=\"2\">Até uma data</md-radio-button></md-radio-group></md-input-container></fieldset><div layout=\"row\" ng-if=\"vm.print.selected_filter == 0\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-init=\"vm.print.course_selected.id = 0\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\" ng-selected=\"vm.print.group_selected.id == group.id || vm.print.group_selected == group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.print.date_range\" ng-if=\"vm.print.selected_filter == 1\"></date-range-picker><date-picker flex=\"\" label=\"Data limite\" ng-model=\"vm.print.date_limit\" ng-if=\"vm.print.selected_filter == 2\"></date-picker></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printStudentsOnlineEnrolmentReport()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-payment-plans.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses(); vm.getAllEnrolmentStatus(); vm.getPaymentPlans()\"><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-init=\"vm.print.course_selected.id = 0\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\" ng-selected=\"vm.print.group_selected.id == group.id || vm.print.group_selected == group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></div><div style=\"width: 100% !important;\" flex=\"\"><md-input-container flex=\"\" style=\"width: 100% !important;\"><label>Status de matrícula</label><md-select ng-model=\"vm.print.enrolment_status_selected\" required=\"\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-repeat=\"status in vm.enrolment_status\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><label>Plano de pagamento</label><md-select ng-model=\"vm.print.payment_plan_selected\" required=\"\" style=\"width: 25%;\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-repeat=\"payment_plan in vm.paymentPlans\" ng-value=\"payment_plan.id\">{{payment_plan.name}}</md-option></md-select></md-input-container></div><div layout-padding=\"\" layout=\"column\"><md-checkbox ng-model=\"vm.only_active_contracts\">Somente contratos ativos</md-checkbox></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.group_selected === null || vm.print.course_selected === null\" ng-click=\"vm.printStudentsPaymentPlans()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-school-periods.html","<md-card-content></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printStudentsSchoolPeriods()\"><md-icon>print</md-icon>Gerar Relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-services.html","<md-card-content><div layout-padding=\"\" layout=\"column\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_service\" md-search-text=\"vm.searchService\" md-items=\"item in vm.getServices(vm.searchService)\" md-item-text=\"item.name\" md-min-length=\"3\" md-delay=\"500\" md-floating-label=\"Procure um serviço\"><md-item-template><span>{{item.name}}</span></md-item-template><md-not-found>Nenhum serviço encontrado</md-not-found></md-autocomplete><div layout=\"row\"><md-input-container flex=\"20\"><date-range-picker ng-model=\"vm.service_date\" label=\"Faixa de datas do contrato\" placeholder=\"{{vm.service_date}}\"></date-range-picker></md-input-container><md-input-container><md-checkbox ng-model=\"vm.active_contracts\">Somente contratos ativos</md-checkbox></md-input-container></div><md-input-container style=\"text-align: left\"><md-radio-group layout=\"column\" ng-model=\"vm.where_option\" required=\"\"><md-radio-button value=\"1\" class=\"md-primary\">Todos inscritos no serviço</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Inscritos no serviço / matriculados em curso</md-radio-button><md-radio-button value=\"3\" class=\"md-primary\">Inscritos no serviço / aluno novo</md-radio-button><md-radio-button value=\"4\" class=\"md-primary\">Inscritos no serviço / aluno da casa</md-radio-button><md-radio-button value=\"5\" class=\"md-primary\">Inscritos no serviço / não matriculados em curso</md-radio-button><md-radio-button value=\"6\" class=\"md-primary\">Não inscritos no serviço</md-radio-button></md-radio-group></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.selected_service === null\" ng-click=\"vm.printServiceStudents()\"><md-icon>print</md-icon>Gerar Relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-tags.html","<div style=\"float: right\"><md-button><md-icon md-font-icon=\"icon-cog\" ng-click=\"vm.spec_config()\"></md-icon></md-button></div><md-card-content ng-if=\"vm.advanced_options\"><div layout=\"row\"><fieldset class=\"standard without-legend group-field\"><legend>configurações avançadas</legend></fieldset></div><div layout=\"row\" layout-align=\"start\" flex=\"50\"><fieldset class=\"standard without-legend group-field\"><legend>Carta:</legend></fieldset><fieldset class=\"standard without-legend group-field\" style=\"text-align: right\"><legend>A4:</legend></fieldset></div><form ng-cloak=\"\"><md-dialog-content><div layout=\"row space-around\" layout-align=\"center\"><div layout=\"column\" flex=\"35\"><md-input-container><label>Margem vertical</label> <input type=\"number\" name=\"vertical_margin\" ng-model=\"vm.lable.letter.margin_top\"></md-input-container><md-input-container><label>Margem horizontal</label> <input type=\"number\" name=\"horizontal_margin\" ng-model=\"vm.lable.letter.margin_left\"></md-input-container><md-input-container><label>Margem horizontal entre as etiquetas</label> <input type=\"number\" name=\"lable_space_between\" ng-model=\"vm.lable.letter.margin_horizontal\"></md-input-container><md-input-container><label>Margem vertical entre as etiquetas</label> <input type=\"number\" name=\"lable_space_between\" ng-model=\"vm.lable.letter.margin_vertical\"></md-input-container></div><div layout=\"column\" flex=\"35\"><md-input-container><label>Margem vertical</label> <input type=\"number\" name=\"vertical_margin\" ng-model=\"vm.lable.a4.margin_top\"></md-input-container><md-input-container><label>Margem horizontal</label> <input type=\"number\" name=\"horizontal_margin\" ng-model=\"vm.lable.a4.margin_left\"></md-input-container><md-input-container><label>Margem horizontal entre as etiquetas</label> <input type=\"number\" name=\"lable_space_between\" ng-model=\"vm.lable.a4.margin_horizontal\"></md-input-container><md-input-container><label>Margem vertical entre as etiquetas</label> <input type=\"number\" name=\"lable_space_between\" ng-model=\"vm.lable.a4.margin_vertical\"></md-input-container></div><div layout=\"column\" flex=\"25\"><p style=\"color: lightgrey;\">Atenção: o valor de espaçamento dos são na medida de pixels(px)</p></div></div></md-dialog-content></form></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\" ng-if=\"vm.advanced_options\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.updateLablesConfig()\">Atualizar configurações</md-button></md-card-actions><md-card-content ng-if=\"!vm.advanced_options\"><div layout=\"row\"><fieldset class=\"standard without-legend group-field\" title=\"Filtro por:\"><legend>Filtra por:</legend><md-input-container class=\"md-input-has-placeholder\"><label></label><md-radio-group ng-model=\"vm.filterTag\"><md-radio-button value=\"0\">Por curso e turma</md-radio-button><md-radio-button value=\"1\">Por aluno</md-radio-button></md-radio-group></md-input-container></fieldset></div><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses()\" ng-if=\"vm.filterTag == 0\"><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-init=\"vm.print.course_selected.id = 0\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\" ng-selected=\"vm.print.group_selected.id == group.id || vm.print.group_selected == group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></div><div layout-padding=\"\" ng-if=\"vm.filterTag == 1\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_student_report\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getStudents(vm.searchText)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.getGradeRuleItems(null, vm.selected_student_report.id, vm.selected_student_report.matrix_period)\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\"><md-item-template><span>{{item.name}} - {{item.group_name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div><md-input-container style=\"width: 100%\"><md-radio-group ng-model=\"vm.tagOption\"><fieldset class=\"standard without-legend group-field\"><legend></legend><md-radio-button value=\"2\">Folha de carta</md-radio-button><md-radio-button value=\"1\">Folha A4</md-radio-button></fieldset></md-radio-group></md-input-container><md-input-container><md-checkbox ng-model=\"vm.tagWithPicture\">Imprimir etiquetas com fotos</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.tagWithCpfAndEmail\">Imprimir etiquetas com CPF e Email</md-checkbox></md-input-container><md-input-container style=\"margin-left: 2%; min-width: 16%\"><label>QTD de etiquetas</label><md-select ng-model=\"vm.number_of_tags\" ng-change=\"vm.getNumberOfTags(vm.number_of_tags)\"><md-option ng-repeat=\"i in vm.getNumbers()\" ng-value=\"i\">{{i}}</md-option></md-select></md-input-container></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\" ng-if=\"!vm.advanced_options\"><md-button class=\"md-raised md-primary\" ng-disabled=\"(vm.filterTag == 0 && (vm.print.group_selected === null || vm.print.course_selected === null)) || (vm.filterTag == 1 && vm.selected_student_report === null)\" ng-click=\"vm.printLables()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-up-to-dates.html","<form name=\"formRegistratioBook\"><md-card-content layout-padding=\"\"><div layout=\"row\"><fieldset class=\"standard without-legend group-field\" title=\"Filtro por:\"><legend>Agrupamento:</legend><md-input-container class=\"md-input-has-placeholder\"><label></label><md-radio-group ng-model=\"vm.filter_up_to_date\"><md-radio-button value=\"0\">Por alunos</md-radio-button><md-radio-button value=\"1\">Por curso e turma</md-radio-button></md-radio-group></md-input-container></fieldset></div><div layout=\"row\"><date-range-picker flex=\"\" ranges=\"vm.ranges\" ng-model=\"vm.date_up_to_date\" ng-value=\"vm.date_up_to_date\" ng-click=\"vm.unblock_button()\"></date-range-picker></div><div layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.include_responsibles\">Incluir responsáveis</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.only_mensality\">Considerar apenas mensalidades</md-checkbox></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.block_button\" ng-click=\"vm.printStudentsUpToDate()\"><md-icon>print</md-icon>Gerar Relatório</md-button></md-card-actions></form>");
$templateCache.put("app/educational/reports/views/reports-temp/students-who-changed-course-per-period.html","<md-card-content></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.printStudentsWhoChangedCoursePerPeriods()\"><md-icon>print</md-icon>Gerar Relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-with-pictures.html","<md-card-content><div layout-padding=\"\" layout=\"column\" ng-init=\"vm.getCourses()\"><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\" ng-selected=\"vm.print.course_selected.id == course.id\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.print.group_selected\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group\" ng-selected=\"vm.print.group_selected.id == group.id || vm.print.group_selected == group.id\" ng-if=\"vm.print.course_selected.id !== 0\">{{group.name}}</md-option><md-option ng-if=\"vm.print.course_selected.id === 0\" ng-value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.print.group_selected === null || vm.print.course_selected === null\" ng-click=\"vm.studentsPictures()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-without-discounts.html","<md-card-content></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><div name=\"warning\" ng-controller=\"ReportDetailController\" style=\"background-color: #bbbbbb; border-radius: 5px; font-style: italic; padding: 5px\"><strong name=\"warning-title\" style=\"font-weight: bold\">AVISO!</strong> <small name=\"warning-text\">Esse relatório passou a fazer parte do relatório <b>Alunos e Descontos</b>.</small></div><br><md-button class=\"md-raised md-primary\" target=\"_blank\" href=\"{{vm.WEB_CONST}}api/reports/studentswithoutdiscounts?token={{vm.conf.token}}&company={{vm.conf.current_company}} &connection={{vm.conf.current_connection}}&user_id={{vm.conf.user_id}}&current_school_period={{vm.school_period}}\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students-without-renovation.html","<md-card-content><div layout-padding=\"\" ng-init=\"vm.getCoursesForResponsibles()\"><div layout=\"column\"><div layout=\"row\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.selected_course\" ng-change=\"vm.getGroupsForResponsibles(vm.selected_course)\" required=\"\"><md-option ng-value=\"null\">Todos os cursos</md-option><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.selected_group\" required=\"\"><md-option ng-value=\"null\">Todas as turmas</md-option><md-option ng-repeat=\"group in vm.groupsForResponsibles | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><md-select ng-model=\"vm.selectedSchoolPeriod\" placeholder=\"Período letivo a ser comparado\" style=\"width: 100%\" required=\"\"><md-option ng-value=\"$index\" ng-repeat=\"school_period in vm.school_periods track by $index\" ng-if=\"$index < vm.school_periods.length - 1\">de {{ school_period.id }} para {{vm.school_periods[$index+1].id}}</md-option></md-select><div layout=\"row\" layout-align=\"space-between center\"><md-input-container><md-checkbox ng-model=\"vm.separe_groups\">Separar por turma</md-checkbox></md-input-container><md-input-container><md-checkbox ng-model=\"vm.showFinanceResponsible\">Exibir responsável financeiro</md-checkbox></md-input-container></div></div></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"angular.isUndefined(vm.selectedSchoolPeriod) || vm.selectedSchoolPeriod === null\" target=\"_blank\" ng-click=\"vm.printStudentsWithoutRenovation()\"><md-icon>print</md-icon>Gerar relatório</md-button></md-card-actions>");
$templateCache.put("app/educational/reports/views/reports-temp/students_records.html","<md-card-content><md-radio-group layout=\"row\" ng-model=\"vm.recordsCheckbox\" required=\"\" ng-change=\"vm.print.course_selected=null;vm.group_selected_report=null;vm.selected_student_report=null;vm.searchText=null\"><md-radio-button value=\"1\" class=\"md-primary\">Por turma</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Por aluno</md-radio-button></md-radio-group><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getCourses(false)\" ng-if=\"vm.recordsCheckbox == 1\"><md-input-container flex=\"\"><label>Curso</label><md-select ng-model=\"vm.print.course_selected\" ng-change=\"vm.getGroups(vm.print.course_selected)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course\">{{course.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Turma</label><md-select ng-model=\"vm.group_selected_report\" ng-change=\"vm.getGradeRuleItems(vm.group_selected_report, null)\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option></md-select></md-input-container></div><div layout-padding=\"\" layout=\"row\" ng-init=\"vm.getStudents();vm.selected_student_report=null;vm.searchText=null\" ng-if=\"vm.recordsCheckbox == 2\"><md-autocomplete flex=\"\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selected_student_report\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getRegularStudents(vm.searchText)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.getGradeRuleItems(null, vm.selected_student_report.id, vm.selected_student_report.matrix_period)\" md-min-length=\"0\" placeholder=\"Selecione ou procure um aluno\"><md-item-template><span>{{item.name}} - {{item.group_name}}</span></md-item-template><md-not-found>Nenhum aluno encontrado</md-not-found></md-autocomplete></div><md-input-container flex=\"\" style=\"padding-left: 15px; width: 100%\"><label>Evento do boletim</label><md-select name=\"course_selected\" ng-model=\"vm.grade_rule_item\" ng-required=\"vm.group_selected_report !== 0\"><md-option ng-repeat=\"grade_rule_item in vm.grade_rule_items\" ng-value=\"grade_rule_item.id\">{{grade_rule_item.description}}</md-option></md-select></md-input-container><div layout=\"column\"><md-input-container><md-checkbox ng-model=\"vm.print_photo\">Imprimir foto do aluno</md-checkbox><md-checkbox ng-model=\"vm.print_graphic\">Imprimir gráfico das notas</md-checkbox><md-checkbox ng-model=\"vm.not_print_footer\">Não imprimir rodapé</md-checkbox></md-input-container><md-input-container style=\"margin-left: 140px;\"><md-checkbox ng-model=\"vm.flag_logo\">Imprimir Logo do Estado e da Ordem Federativa</md-checkbox></md-input-container><md-input-container><md-radio-group ng-model=\"vm.side_school_report\" layout=\"column\"><strong class=\"group-field\"><small flex=\"100\">Posição das informações do aluno</small></strong><md-radio-button ng-value=\"1\">Centralizadas</md-radio-button><md-radio-button ng-value=\"2\">À esquerda</md-radio-button></md-radio-group></md-input-container></div></md-card-content><md-card-actions layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" target=\"_blank\" ng-disabled=\"(vm.group_selected_report == null && vm.selected_student_report == null) || (vm.grade_rule_item == null && vm.group_selected_report !== 0)\" ng-click=\"vm.generateSchoolRecord()\">Gerar Relatório<md-icon>print</md-icon></md-button></md-card-actions>");
$templateCache.put("app/educational/responsible-changes/detail/views/detail-modal.html","<md-dialog aria-label=\"Detalhes da alteração\" style=\"width: 600px;\" class=\"responsible-changes-detail\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Detalhes da alteração</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><div layout=\"column\" layout-padding=\"\"><div layout=\"row\" layout-align=\"start center\"><strong>Nome:</strong> <span style=\"margin-left: 10px;\">{{vm.responsible.name}}</span></div><div ng-if=\"vm.hasChanges()\" style=\"margin-top: 20px;\"><div class=\"section-header\"><h4><md-icon>edit</md-icon>Informações Alteradas</h4></div><md-card><md-card-content><div layout=\"row\" style=\"margin-bottom: 10px; padding: 8px; background-color: #f0f0f0; border-radius: 4px; font-weight: 500;\"><div flex=\"30\"><div class=\"field-name\">Campo</div></div><div flex=\"35\" style=\"text-align: center;\"><div class=\"field-label\">Valor Original</div></div><div flex=\"35\" style=\"text-align: center;\"><div class=\"field-label\">Novo Valor</div></div></div><div ng-repeat=\"(fieldName, newValue) in vm.properties.changes\" ng-if=\"vm.properties.origin && vm.valuesAreDifferent(vm.getFieldValues(fieldName).original, vm.getFieldValues(fieldName).new)\" class=\"field-change\" style=\"margin-bottom: 12px; padding: 8px; border-radius: 4px; background-color: #f5f5f5;\"><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"30\"><div class=\"field-name\">{{vm.getFieldDisplayName(fieldName)}}</div></div><div flex=\"35\" style=\"text-align: center;\"><div class=\"old-value\">{{vm.formatValue(vm.getFieldValues(fieldName).original)}}</div></div><div flex=\"35\" style=\"text-align: center;\"><div class=\"new-value\">{{vm.formatValue(vm.getFieldValues(fieldName).new)}}</div></div></div></div><div ng-repeat=\"(fieldName, newValue) in vm.properties.changes\" ng-if=\"!vm.properties.origin || !vm.valuesAreDifferent(vm.getFieldValues(fieldName).original, vm.getFieldValues(fieldName).new)\" class=\"field-change\" style=\"margin-bottom: 12px; padding: 8px; border-radius: 4px; background-color: #f5f5f5;\"><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"30\"><div class=\"field-name\">{{vm.getFieldDisplayName(fieldName)}}</div></div><div flex=\"35\" style=\"text-align: center;\"><div class=\"old-value\">Não informado</div></div><div flex=\"35\" style=\"text-align: center;\"><div class=\"new-value\">{{vm.formatValue(vm.getFieldValues(fieldName).new)}}</div></div></div></div></md-card-content></md-card></div><div ng-if=\"!vm.hasChanges()\" style=\"margin-top: 20px;\"><div class=\"no-changes-message\"><md-icon style=\"font-size: 48px; color: #ccc; margin-bottom: 10px;\">info</md-icon><p>Nenhuma alteração encontrada para exibir.</p></div></div><div layout=\"row\" layout-align=\"start center\" style=\"margin-top: 15px;\"><strong>Status:</strong> <span style=\"margin-left: 10px;\"><span class=\"badge\"><span class=\"responsible_status_{{vm.getStatusClass(vm.status_id)}}\">{{vm.getStatusText(vm.status_id)}}</span></span></span></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"vm.showAcceptButton()\" class=\"md-raised md-primary\" ng-click=\"vm.accept()\"><md-icon>check</md-icon>Aceitar</md-button><md-button ng-if=\"vm.showRejectButton()\" class=\"md-raised md-warn\" ng-click=\"vm.reject()\"><md-icon>close</md-icon>Recusar</md-button><md-button class=\"md-raised\" ng-click=\"vm.close()\"><md-icon>close</md-icon>Fechar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/educational/responsible-changes/list/views/list.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-edit\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Alterações pelo responsável</span></div></div></md-toolbar><md-card layout-padding=\"\"><div layout=\"row\" layout-align=\"end center\" style=\"margin-bottom: 20px;\"><md-input-container md-no-float=\"\" class=\"m-0\" flex=\"20\"><md-select ng-model=\"vm.sys_log_status_id\" placeholder=\"Status\" ng-change=\"vm.filterByStatus()\"><md-option ng-repeat=\"status in vm.status_options\" ng-value=\"status.id\">{{status.name}}</md-option></md-select></md-input-container></div><div style=\"overflow: auto;\"><table md-table=\"\" md-progress=\"vm.grid.promise\"><thead md-head=\"\" fix-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\">Status</th><th md-column=\"\" style=\"text-align: right\">Ação</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"responsible in vm.grid.rows\" style=\"cursor: pointer\"><td md-cell=\"\"><span>{{responsible.name}}</span></td><td md-cell=\"\"><span class=\"badge\"><span class=\"responsible_status_{{vm.getStatusClass(responsible.sys_log_status_id)}}\">{{vm.getStatusText(responsible.sys_log_status_id)}}</span></span></td><td md-cell=\"\" style=\"text-align: right\"><md-button class=\"md-icon-button\" ng-click=\"vm.viewDetails(responsible)\"><md-icon>visibility</md-icon><md-tooltip md-direction=\"top\">Ver</md-tooltip></md-button></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.grid.info.total > 0\"><md-pagination md-limit=\"vm.grid.info.limit\" md-page=\"vm.grid.info.page\" md-total=\"{{vm.grid.info.total}}\" md-on-paginate=\"vm.paginate\" md-limit-options=\"vm.grid.info.limit_options\"></md-pagination></div></md-card></div>");
$templateCache.put("app/educational/responsibles/dependents/views/dependents.html","<md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><a4-form-dic-data bind=\"vm.grid\" on-paginate=\"vm.getStudents\" on-click-item=\"vm.goToDependent(item)\" fields-schema=\"app/educational/responsibles/dependents/grid_students.json\"></a4-form-dic-data></md-content>");
$templateCache.put("app/educational/responsibles/financial-situation/views/financial-situation.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.tabSelected\"><md-tab label=\"Títulos\"><md-content class=\"btn-material-default\"><a4-bill-grid debit-credit=\"C\" ng-model=\"vm.bills\" with-filter=\"false\" show-loader=\"vm.show_loader\" height-grid=\"vm.windowHeight\" show-button-more=\"vm.show_button_more\" person-id=\"vm.person_id\" paginate-function=\"vm.getPendencies(page, qtd, date, person_id, status, flag, order)\"></a4-bill-grid></md-content></md-tab><md-tab label=\"Contratos\"><span layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-if=\"!vm.checkPolicies(\'contrato_alt\')\" ng-click=\"vm.openContractModal({enrolment: vm, is_first: false})\" class=\"md-primary\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Novo contrato</md-button></span><a4-contract-grid ng-model=\"vm.allContracts\" paginate-function=\"vm.getAllContracts(page, qtd, search_name)\" debit-credit=\"C\" is-educational=\"true\"></a4-contract-grid></md-tab><md-tab label=\"Negociações\"><a4-negotiation course-id=\"vm.course_id\" ng-if=\"vm.tabSelected == 2\" person-id=\"vm.person_id\"></a4-negotiation></md-tab><md-tab label=\"Boletos\"><a4-bank-slip person-id=\"vm.person_id\" ng-if=\"vm.tabSelected == 3\" can-edit=\"false\"></a4-bank-slip></md-tab></md-tabs></div>");
$templateCache.put("app/educational/responsibles/school-reports/views/school-reports.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.tabSelected\"><md-tab ng-repeat=\"student in vm.students\" label=\"{{student.name}}\" md-on-select=\"vm.getStudentReport()\"><md-content class=\"btn-material-default\"><div layout-align=\"start center\" layout=\"row\" flex=\"\"><md-button ng-click=\"vm.printNotes()\"><md-icon md-font-icon=\"icon-printer\"></md-icon>Imprimir boletim</md-button><md-checkbox ng-model=\"vm.is_detailed\" aria-label=\"Boletim detalhado\">Mostrar boletim detalhado</md-checkbox></div><form name=\"formNoteRelease\" novalidate=\"\"><table class=\"simple table-note-release no-border-top school-report a4-table-fixed\"><thead><tr ng-if=\"vm.subjects.length > 0\"><th></th><th ng-repeat=\"grade in ::vm.grid.steps\" colspan=\"{{grade.siblingsqtd}}\" ng-show=\"vm.is_detailed\"><b>{{grade.name}}</b><md-tooltip md-direction=\"top\">{{grade.description}}</md-tooltip></th><th ng-if=\"vm.is_detailed\"></th></tr><tr><th>Disciplinas</th><th ng-repeat=\"grade in vm.grid.grade_json\" ng-if=\"vm.isNumber(grade.precision) && grade.pass_grade.length\" ng-show=\"(!vm.is_detailed) ? grade.show_on_grade : true\" ng-init=\"calculed = (grade.conditional != \'\') ? true : false; grade.oficial_name = (grade.label) ? grade.label : grade.name;\" class=\"hoverSubjectEvent\"><md-tooltip md-direction=\"top\">{{ grade.description}}</md-tooltip><strong class=\"strong\" ng-show=\"calculed\">{{grade.oficial_name}}</strong> <span ng-hide=\"calculed\">{{grade.oficial_name}}</span></th><th class=\"text-align-center\">Situação</th></tr></thead><tbody><div class=\"tbody\"><tr ng-repeat=\"subject in vm.subjects\" ng-if=\"vm.is_detailed || subject.show_on_report\"><td ng-class=\"{\'is_child\': subject.is_child}\">{{subject.subject_name}} <span ng-if=\"subject.dependency_year !== null\">(DEP)</span></td><td ng-repeat=\"grade in vm.grid.grade_json track by grade.name\" ng-if=\"vm.isNumber(grade.precision) && grade.pass_grade.length\" ng-show=\"(!vm.is_detailed) ? grade.show_on_grade : true\" class=\"align-center\"><span ng-repeat=\"(id, note) in subject.grade_json track by id\" ng-if=\"grade.name == id\"><span ng-class=\"{ \'note-release-disapproved\': note.value < vm.getValue(id, \'pass_grade\'), \'note-release-approved\' : note.value >= vm.getValue(id, \'pass_grade\'), \'note-release-council\' : note.valueCouncil.length && note.valueCouncil !== null }\"><span ng-if=\"$.type(note.value) !== \'string\' && !vm.special_characters.includes(note.value)\">{{ note.valueConcept !== null && note.valueConcept !== undefined ? vm.formatValue(note.valueConcept) : (note.value >= 0 ? (note.value | number:grade.precision) : vm.formatValue(note.value))}}</span> <span ng-if=\"vm.special_characters.includes(note.value)\">{{note.value}}</span><md-tooltip md-direction=\"top\" ng-if=\"note.value\"><span ng-if=\"note.value < vm.getValue(id, \'pass_grade\')\">Reprovada</span> <span ng-if=\"note.value >= vm.getValue(id, \'pass_grade\')\">Aprovada</span> <span ng-if=\"note.valueCouncil.length && note.valueCouncil !== null\">- Nota atibuída por conselho de classe</span></md-tooltip><md-tooltip md-direction=\"left\" ng-if=\"note.value\">Média: {{grade.pass_grade}}</md-tooltip><md-tooltip md-direction=\"right\" ng-if=\"note.value\">Máx: {{grade.max_grade}}</md-tooltip><md-tooltip md-direction=\"bottom\" ng-if=\"note.value\" ng-init=\"percent = note.value / grade.max_grade * 100;\">Alcançou: {{ percent | number:0}}%</md-tooltip></span></span></td><td class=\"align-center\"><md-tooltip md-direction=\"top\">{{subject.academic_status_name}}</md-tooltip><span>{{subject.academic_status_code}}</span></td></tr></div></tbody></table></form></md-content></md-tab></md-tabs></div>");
$templateCache.put("app/educational/students/classes/views/classes.html","<md-content layout=\"row\"><a4-form-dic-data bind=\"vm.grid\" on-paginate=\"vm.paginate\" on-click-item=\"\" policies=\"{show:\'aluno\'}\" fields-schema=\"app/educational/students/classes/grid-classes.json\"></a4-form-dic-data></md-content>");
$templateCache.put("app/educational/students/classrooms/views/attachments-modal.html","<md-dialog aria-label=\"Upload\" style=\"width: 700px;\" md-theme=\"educational\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span>Arquivos e links da aula</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content><md-table-container style=\"width: 100%;\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Ver</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.files\"><td md-cell=\"\">{{item.name}}</td><td md-cell=\"\"><a ng-if=\"item.extension != null\" target=\"_blank\" href=\"{{vm.uri + item.path}}\">Ver arquivo</a> <a ng-if=\"item.extension == null\" target=\"_blank\" href=\"{{item.path}}\">Ver Links</a></td></tr></tbody></table></md-table-container></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/educational/students/classrooms/views/classrooms.html","<md-content style=\"min-height: 400px\" ng-init=\"vm.show_filter = false;\"><div layout=\"row\" layout-align=\"end center\" flex=\"\" class=\"md-padding\"><div flex=\"50\" layout=\"row\"><md-input-container flex=\"\"><label>Selecione por disciplina</label><md-select ng-model=\"vm.form.subject\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Procure pela disciplina..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation();\" ng-model-options=\"{debounce: 500}\"></md-select-header><md-option ng-value=\"subject.subject_id\" ng-repeat=\"subject in vm.subjects\">{{subject.subject_name}}</md-option></md-select></md-input-container><date-range-picker ng-model=\"vm.form.date\" label=\"Filtre por data da aula\" flex=\"\" selected-period=\"7\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker><md-input-container flex=\"\" class=\"md-block\"><md-radio-group layout=\"row\" ng-model=\"vm.filter_lesson_status\"><md-radio-button value=\"0\" class=\"md-primary\">Aulas realizadas</md-radio-button><md-radio-button value=\"1\" class=\"md-primary\">Aulas futuras</md-radio-button></md-radio-group></md-input-container><md-button flex=\"\" ng-click=\"vm.has_date = true; vm.paginate()\" ng-disabled=\"formArtefac.$invalid || formArtefac.$pristine || $root.show_loader\" class=\"md-fab md-mini\"><md-icon>search</md-icon></md-button></div><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.grid.current_page\" flex=\"\" style=\"border: none\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.paginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div><md-content class=\"md-padding\" layout=\"column\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-lg=\"column\" layout-xl=\"column\" layout-wrap=\"\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\" ng-init=\"init_limit_date = vm.grid.data[0].date\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data / Hora</th><th md-column=\"\">Classe</th><th md-column=\"\">Assuntos / Atividades</th><th md-column=\"\">Atividades para casa</th><th md-column=\"\">Anexos</th><th md-column=\"\" ng-if=\"vm.filter_lesson_status_pressed == 0\">Presença</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.grid.data track by $index\" ng-click=\"vm.editOccurrence(item)\" style=\"cursor: pointer;\" class=\"table-striped\"><td md-cell=\"\" ng-class=\"{\'last-line\': vm.grid.data[$index-1].date !== vm.grid.data[$index].date && $index > 0}\">{{item.date_hour}}</td><td md-cell=\"\" ng-class=\"{\'last-line\': vm.grid.data[$index-1].date !== vm.grid.data[$index].date && $index > 0}\">{{item.class}}</td><td md-cell=\"\" ng-class=\"{\'last-line\': vm.grid.data[$index-1].date !== vm.grid.data[$index].date && $index > 0}\">{{item.activity}}</td><td md-cell=\"\" ng-class=\"{\'last-line\': vm.grid.data[$index-1].date !== vm.grid.data[$index].date && $index > 0}\">{{item.homework}}</td><td md-cell=\"\" ng-class=\"{\'last-line\': vm.grid.data[$index-1].date !== vm.grid.data[$index].date && $index > 0}\"><span ng-if=\"item.files_qty > 0\" ng-click=\"vm.openAttachments(item)\" style=\"cursor: pointer;\">{{item.files_qty}}<md-tooltip md-direction=\"left\">Clique para exibir os anexos da aula</md-tooltip><md-icon md-font-icon=\"icon-attachment\"></md-icon></span></td><td md-cell=\"\" ng-class=\"{\'last-line\': vm.grid.data[$index-1].date !== vm.grid.data[$index].date && $index > 0}\" ng-if=\"vm.filter_lesson_status_pressed == 0\"><span class=\"badge\" style=\"padding: 0;margin-left: 0;\"><span class=\"{{item.attendance_name}}\">{{item.attendance_name}}</span><md-icon ng-if=\"item.teacher_notes !== null && item.teacher_notes !== \'\'\"><md-tooltip>Observação: {{item.teacher_notes}}</md-tooltip>error</md-icon></span></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.grid.current_page\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.paginate\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></md-content>");
$templateCache.put("app/educational/students/complementary-activities/views/complementary-activities.html","<md-card layout-padding=\"\"><md-toolbar class=\"md-table-toolbar md-default\" style=\"min-height: 50px; padding: 0\"><div class=\"md-toolbar-tools\" style=\"height: 50px\"><span flex=\"\"></span><md-button class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-click=\"vm.addItem()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar</md-button></div></md-toolbar><md-table-container style=\"padding-top: 0\"><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Descrição</th><th md-column=\"\">Local da Atividade</th><th md-column=\"\">Carga Horária</th><th md-column=\"\">Período Letivo</th><th md-column=\"\">Instituição</th><th md-column=\"\">Período</th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.items.data | filter : vm.query_filter : false\" ng-click=\"vm.editItem(item)\" style=\"cursor: pointer\"><td md-cell=\"\">{{item.name}}</td><td md-cell=\"\">{{item.location}}</td><td md-cell=\"\">{{item.work_load}}</td><td md-cell=\"\">{{item.school_period}}</td><td md-cell=\"\">{{item.institution}}</td><td md-cell=\"\">{{item.period}}</td><td md-cell=\"\" style=\"text-align: right\"><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.delete(item.id, item.name); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip>Excluir atividade</md-tooltip></md-icon></md-button></td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/educational/students/complementary-activities/views/modal-edit-item.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"min-width: 800px;\"><form ng-cloak=\"\" name=\"extra_grade_form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.scope.id !== undefined && vm.scope.id !== null\">Editar atividade</h2><h2 ng-if=\"vm.scope.id === undefined || vm.scope.id === null\">Adicionar nova atividade</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\" flex=\"\"><div layout=\"row\" flex=\"100\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.name\" placeholder=\"Descrição\" required=\"\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.location\" placeholder=\"Local da Atividade\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.work_load\" placeholder=\"Carga Horária\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.school_period\" placeholder=\"Período Letivo\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.institution\" placeholder=\"Instituição\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.period\" placeholder=\"Período\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.answer(vm.scope);\" ng-disabled=\"extra_grade_form.$invalid\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/documents/views/documents_student.html","<md-content layout=\"row\"><div flex=\"\"><a4-student-documents selected-documents=\"vm.selected_documents\" documents-list=\"vm.grid.rows\" student=\"vm.student\"></a4-student-documents></div></md-content>");
$templateCache.put("app/educational/students/enrolments-student/views/enrolments-student.html","<md-content layout=\"column\" layout-align=\"center center\"><md-card flex=\"100\" layout=\"row\" style=\"width: 80%\"><table class=\"simple\" ng-if=\"vm.course_equivalence_id < 300\"><thead><tr><th style=\"text-align: center\">Período letivo</th><th style=\"text-align: center\">Curso</th><th style=\"text-align: center\">Turma</th><th style=\"text-align: center\">Status de matrícula</th><th style=\"text-align: center\">Status pedagógico</th><th style=\"text-align: right\"></th></tr></thead><tbody><tr ng-repeat=\"enrolment in vm.enrolments track by enrolment.enrolment_period_id\" class=\"group-table\"><td style=\"text-align: center\">{{enrolment.school_period_id !== null ? enrolment.school_period_id : enrolment.name}}</td><td style=\"text-align: center\">{{enrolment.course_name}}</td><td style=\"text-align: center\">{{enrolment.group_name}} <span ng-if=\"enrolment.enrolment_period_changes !== null && enrolment.enrolment_period_changes !== \'{}\'\"><md-icon>error</md-icon><md-tooltip><span ng-repeat=\"change in enrolment.enrolment_period_changes track by $index\">{{change}}<br></span></md-tooltip></span></td><td style=\"text-align: center\"><span class=\"badge\" ng-if=\"enrolment.enrolment_status !== null\"><span class=\"enrolment_status enrolment_status {{enrolment.enrolment_status}}\">{{enrolment.enrolment_status.replace(\'_\', \' \')}}</span></span></td><td style=\"text-align: center\">{{enrolment.academic_status}}</td><td style=\"text-align: right\"><md-button class=\"md-icon-button\" ng-disabled=\"!(enrolment.school_period_id != vm.current_school_period_id) || enrolment.school_period_id === null\" ng-click=\"vm.goToStudent(enrolment)\"><md-icon>forward</md-icon><md-tooltip md-direction=\"right\">Ir para perfil do aluno no período</md-tooltip></md-button></td></tr></tbody></table><table class=\"simple\" ng-if=\"vm.course_equivalence_id >= 300\"><thead><tr><th style=\"text-align: left !important;\">Curso</th><th style=\"text-align: center !important;\">Período letivo</th><th style=\"text-align: center !important;\">Turma</th><th style=\"text-align: center !important;\">Status de matrícula</th><th style=\"text-align: center !important;\">Status pedagógico</th><th style=\"text-align: right\"></th></tr></thead><tfoot></tfoot><tbody><tr ng-repeat-start=\"enrolment in vm.enrolments\" style=\"background-color: rgb(225, 225, 225) !important;\" class=\"group-table\"><td><strong>{{enrolment[0].course_name}}</strong></td><td></td><td></td><td></td><td></td><td></td></tr><tr ng-repeat=\"enrolment_item in enrolment\" ng-if=\"enrolment_item.sequence == 2\"><td></td><td style=\"text-align: center !important;\">{{enrolment_item.school_period_id}}</td><td style=\"text-align: center !important;\">{{enrolment_item.group_name}} <span ng-if=\"enrolment_item.enrolment_period_changes !== \'{}\'\"><md-icon>error</md-icon><md-tooltip><span ng-repeat=\"change in enrolment_item.enrolment_period_changes track by $index\">{{change}}</span></md-tooltip></span></td><td style=\"text-align: center !important;\"><span class=\"badge\"><span class=\"enrolment_status enrolment_status {{enrolment_item.enrolment_status}}\">{{enrolment_item.enrolment_status.replace(\'_\', \' \')}}</span></span></td><td style=\"text-align: center !important;\">{{enrolment_item.academic_status}}</td><td style=\"text-align: right\"><md-button class=\"md-icon-button\" ng-disabled=\"!(enrolment.school_period_id != vm.current_school_period_id)\" ng-click=\"vm.goToStudent(enrolment_item)\"><md-icon>forward</md-icon><md-tooltip md-direction=\"right\">Ir para perfil do aluno no período</md-tooltip></md-button></td></tr><tr ng-repeat-end=\"\"></tr></tbody></table></md-card></md-content>");
$templateCache.put("app/educational/students/evaluations-student/views/evaluations-student.html","<md-tabs md-dynamic-height=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Não realizadas\"><div ng-if=\"vm.selected_tab === 0\"><widget-component action-status=\"[0, 1, 12, 13, 14]\" questionnaire=\"vm.student_evaluations\" obj=\"vm.obj\"></widget-component></div></md-tab><md-tab label=\"Realizadas\"><div ng-if=\"vm.selected_tab === 1\"><widget-component action-status=\"[10, 11]\" questionnaire=\"vm.student_evaluations\" obj=\"vm.obj\"></widget-component></div></md-tab><md-tab label=\"Concluídas\"><div ng-if=\"vm.selected_tab === 2\"><widget-component action-status=\"[20]\" questionnaire=\"vm.student_evaluations\" obj=\"vm.obj\"></widget-component></div></md-tab></md-tabs>");
$templateCache.put("app/educational/students/extra-subjects/views/extra-subjects.html","<md-card layout-padding=\"\"><md-toolbar class=\"md-table-toolbar md-default\" style=\"min-height: 50px; padding: 0\"><div class=\"md-toolbar-tools\" style=\"height: 50px\"><span flex=\"\"></span><md-button class=\"md-raised md-accent md-hue-3\" aria-label=\"Learn More\" ng-click=\"vm.addItem()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Adicionar</md-button></div></md-toolbar><md-table-container style=\"padding-top: 0\"><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.selected\" md-progress=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Disciplina</th><th md-column=\"\">Período Letivo</th><th md-column=\"\">Instituição</th><th md-column=\"\">Local da Atividade</th><th md-column=\"\">Carga Horária</th><th md-column=\"\">Nota</th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.items.data | filter : vm.query_filter : false\" ng-click=\"vm.editItem(item)\" style=\"cursor: pointer\"><td md-cell=\"\">{{item.name}}</td><td md-cell=\"\">{{item.school_period}}</td><td md-cell=\"\">{{item.institution}}</td><td md-cell=\"\">{{item.location}}</td><td md-cell=\"\">{{item.work_load}}</td><td md-cell=\"\">{{item.grade}}</td><td md-cell=\"\" style=\"text-align: right\"><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.delete(item.id, item.name); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip>Excluir disciplina</md-tooltip></md-icon></md-button></td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/educational/students/extra-subjects/views/modal-edit-item.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"min-width: 800px;\"><form ng-cloak=\"\" name=\"extra_grade_form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.scope.id !== undefined && vm.scope.id !== null\">Editar disciplina extra</h2><h2 ng-if=\"vm.scope.id === undefined || vm.scope.id === null\">Adicionar disciplina extra</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\" flex=\"\"><div layout=\"row\" flex=\"100\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.name\" placeholder=\"Disciplina\" required=\"\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.school_period\" placeholder=\"Período Letivo\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.institution\" placeholder=\"Instituição\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.location\" placeholder=\"Local da Atividade\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.work_load\" placeholder=\"Carga Horária\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" ng-model=\"vm.scope.grade\" placeholder=\"Nota\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.answer(vm.scope);\" ng-disabled=\"extra_grade_form.$invalid\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/financial/views/financial.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"margin: 0 !important;\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.tabSelected\"><md-tab label=\"Títulos\"><md-content class=\"btn-material-default\"><a4-bill-grid debit-credit=\"C\" ng-model=\"vm.bills\" with-filter=\"false\" show-loader=\"vm.show_loader\" paginate-function=\"vm.getPendencies(page, qtd, date, person_id, status, flag, order, show_only_student)\" on-print-grid=\"vm.printBillsStudent(date, status, all_bills)\" show-button-more=\"vm.show_button_more\" show-printer=\"true\" is-student=\"true\" height-grid=\"vm.windowHeight\" person-id=\"vm.person_id\" person-id-payee=\"vm.payee\"></a4-bill-grid></md-content></md-tab><md-tab label=\"Boletos\"><a4-bank-slip person-id=\"vm.person_id\" ng-if=\"vm.tabSelected == 1\"></a4-bank-slip></md-tab><md-tab label=\"Contratos\" ng-if=\"!vm.checkPolicies(\'contrato\')\"><span layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-if=\"!vm.checkPolicies(\'contrato_alt\')\" ng-click=\"vm.openContractModal({enrolment: vm, is_first: false})\" class=\"md-primary\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Novo contrato</md-button></span><a4-contract-grid ng-model=\"vm.allContracts\" paginate-function=\"vm.getAllContracts(page, qtd, search_name)\" debit-credit=\"C\" student-data=\"vm.student\" is-educational=\"true\"></a4-contract-grid></md-tab><md-tab label=\"Negociações\"><a4-negotiation ng-if=\"vm.tabSelected == 3\" person-id=\"vm.person_id\"></a4-negotiation></md-tab><md-tab ng-if=\"vm.history > 0\"><md-tab-label>Créditos <span class=\"badge\" style=\"margin-left: -4px;\" ng-if=\"vm.credit_balance > 0\"><span class=\"Ativo\">R$ {{vm.credit_balance}}</span></span></md-tab-label><md-tab-body><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important\"><md-card layout-padding=\"\"><a4-credits-person person-id=\"vm.person_id\" balance=\"vm.credit_balance\"></a4-credits-person></md-card></md-content></md-tab-body></md-tab></md-tabs></div>");
$templateCache.put("app/educational/students/medical-records/views/medical-records.html","<md-card layout-padding=\"\"><form><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(50,112,198)\" flex=\"25\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Questões de saúde</b> <small>Abaixo estão as informações relacionadas à saúde do aluno</small></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(50,112,198)\" flex=\"25\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Medicamentos</b> <small>Abaixo estão as informações relacionadas aos medicamentos do aluno</small></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(50,112,198)\" flex=\"25\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>A quem avisar em casos de emergência</b> <small>Abaixo estão as informações acerca da pessoa a ser avisada em casos de emergência</small></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(50,112,198)\" flex=\"25\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Outras informações</b> <small>Abaixo estão as outras informações sobre questões médicas do aluno</small></div></div><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"vm.medical_data.has_hearing_problem\">Tem problema de audição</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para febre</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.medication_fever\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Em caso de acidente avisar a</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.accident_notify_person_1\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Telefone fixo 2</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_1_phone_2\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"vm.medical_data.has_sight_problem\">Tem problema de visão</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para diarréia</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.medication_diarrhea\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Celular</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_1_mobile\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Plano de saúde</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.health_insurance\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"vm.medical_data.has_breathing_problem\">Tem problema respiratório</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para dor de cabeça</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.medication_headache\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Telefone fixo 1</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_1_phone_1\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Outras observações</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notes\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"vm.medical_data.has_hypertension\">Tem hipertensão</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Nome do médico</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.doctor_name\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Grau de parentesco</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_1_relation\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Ramal</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_1_extension\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"vm.medical_data.has_nervous_problem\">Tem problema nervoso</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Celular (médico)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.doctor_mobile\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Em caso de acidente avisar a (2)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.accident_notify_person_2\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Tratamentos</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.treatments\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"vm.medical_data.has_heart_problem\">Tem problema cardíaco</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para dor de dente</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.medication_toothache\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Celular (2)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_2_mobile\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Ramal (médico)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.doctor_extension\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"vm.medical_data.has_asthma\">Tem asma</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Medicação para vômito</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.medication_vomiting\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Telefone fixo 2 (médico)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.doctor_phone_2\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Tipo sanguíneo</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.blood_type_id\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"vm.medical_data.has_epilepsy\">Tem epilepsia</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Outras medicações</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.medication_other\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Grau de parentesco (2)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_2_relation\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Telefone fixo 2 (2)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_2_phone_2\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><md-checkbox ng-model=\"vm.medical_data.has_diabetes\">Tem diabetes</md-checkbox></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Observações médicas</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.medical_notes\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Telefone fixo 1 (2)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_2_phone_1\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Ramal (2)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.notify_person_2_extension\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Alergias</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.allergies\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Telefone fixo 1 (médico)</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.doctor_phone_1\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Em caso de emergência levar para</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.emergency_take_to\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Cirurgias</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.surgeries\"></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"25\"><label>Outras doenças</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.medical_data.others_diseases\"></md-input-container></md-content></form></md-card>");
$templateCache.put("app/educational/students/occurrences/views/create.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"width: 700px;\"><form ng-cloak=\"\" ng-submit=\"vm.submit(vm.form.event, form_occurrences)\" name=\"form_occurrences\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.form.occurrence.id\">Adicionar ocorrência</h2><h2 ng-if=\"vm.form.occurrence.id\">Editar ocorrência</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div layout=\"row\" flex=\"\"><div flex=\"\" ng-if=\"!vm.is_lesson_student\"><date-picker ng-model=\"vm.form.event.date_done\" flex=\"\" placeholder=\"Data da Ocorrencia\" max-date=\"vm.today\" tabindex=\"0\" ng-change=\"vm.verifyDate()\"></date-picker></div><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block md-input-has-placeholder\" ng-if=\"!vm.is_lesson_student\"><label>Tipo da Ocorrência</label><md-icon md-font-icon=\"icon-format-list-numbers\"></md-icon><md-select ng-model=\"vm.form.event.event_type_id\" required=\"\" name=\"event_type_id\"><md-option ng-repeat=\"item in vm.list.event.event_type_id\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div ng-messages=\"form_occurrences.event_type_id.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar tipo da ocorrência.</div></div></md-input-container></div><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><label>Ocorrido</label><md-icon md-font-icon=\"icon-document\"></md-icon><input ng-model=\"vm.form.event.notes_done\" required=\"\" name=\"notes_done\"><div ng-messages=\"form_occurrences.notes_done.$error\"><div ng-message=\"required\">Você <b>deve</b> descrever o ocorrido.</div></div></md-input-container><div flex=\"\" layout=\"row\" ng-if=\"!vm.is_lesson_student\"><div flex=\"50\"><md-checkbox ng-model=\"vm.form.event.is_to_publish\" tabindex=\"-1\" ng-disabled=\"vm.form.event.is_confidencial\"><span>Publicar?</span></md-checkbox></div><div flex=\"50\"><md-checkbox ng-model=\"vm.form.event.is_confidencial\" tabindex=\"-1\" ng-change=\"vm.disableToPublish()\"><span>É Confidêncial?</span></md-checkbox></div></div></div></md-dialog-content><md-dialog-actions><md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"vm.loading\"><md-progress-circular ng-show=\"vm.loading\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!vm.loading\" md-font-icon=\"icon-check\"></md-icon><span ng-if=\"!vm.form.occurrence.id\">Adicionar</span> <span ng-if=\"vm.form.occurrence.id\">Editar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/occurrences/views/occurrences.html","<md-content layout=\"column\" ng-if=\"!vm.checkPolicies(\'aluno_ocor\')\"><div flex=\"\" style=\"text-align: center\"><md-input-container flex=\"15\" style=\"width: 15%\"><label>Tipo de ocorrência</label><md-select ng-model=\"vm.occurrence_type\" ng-change=\"vm.getStudentOccurrences()\"><md-option ng-value=\"null\">Todos os tipos</md-option><md-option ng-repeat=\"type in vm.occurrence_types\" ng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container></div><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.grid.current_page\" md-page-select=\"\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.getStudentOccurrences\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination><md-table-container class=\"table-float-button\"><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Ocorrido</th><th md-column=\"\">Tipo</th><th md-column=\"\">Criado por</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.grid.data\" style=\"cursor: pointer;\"><td md-cell=\"\">{{item.occurrence_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\">{{item.is_confidencial ? \'*********\' : item.occurrence}}</td><td md-cell=\"\">{{item.occurrence_type}}</td><td md-cell=\"\">{{item.person_responsible_occurrence}}</td><td md-cell=\"\" ng-if=\"!vm.checkProfile(1) && !vm.checkProfile(2)\"><md-button ng-click=\"vm.delete(item);$event.stopPropagation()\" class=\"md-icon-button\" ng-if=\"vm.grid.name === item.person_responsible_occurrence\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Excluir</md-tooltip></md-button></td><td md-cell=\"\" ng-if=\"!vm.checkProfile(1) && !vm.checkProfile(2)\"><md-button ng-click=\"vm.editOccurrence(item)\" class=\"md-icon-button\" ng-if=\"vm.grid.name === item.person_responsible_occurrence\"><md-tooltip>Editar</md-tooltip><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.grid.per_page\" md-limit-options=\"[20, 50, 100]\" md-page=\"vm.grid.current_page\" md-page-select=\"\" md-total=\"{{vm.grid.total}}\" md-on-paginate=\"vm.getStudentOccurrences\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\"></md-table-pagination></md-content>");
$templateCache.put("app/educational/students/parents/views/modal-change-payee.html","<md-dialog aria-label=\"Alteração de responsável financeiro\" md-theme=\"educational\" style=\"width: 550px;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Alteração de responsável financeiro</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"form\" ng-cloak=\"\"><div style=\"padding: 15px;\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Alteração do responsável pelos títulos</b> <small>Alterar o responsável financeiro para todos os títulos, ou para os títulos que vencem a partir de uma data específica?</small></div></div><div layout=\"column\"><md-input-container><md-radio-group ng-model=\"vm.object.option\"><md-radio-button ng-value=\"1\" class=\"md-primary\">Todos os títulos</md-radio-button><md-radio-button ng-value=\"2\">Apenas os títulos que vencem a partir de</md-radio-button></md-radio-group></md-input-container><date-picker ng-model=\"vm.object.date\" style=\"width: 50%;\"></date-picker></div><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Títulos que tenham nota fiscal emitida por este sistema<u>NÃO</u>terão o responsável financeiro alterado</b></div></div></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; width: 100%\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 1px;\" ng-click=\"vm.answer(vm.object)\" ng-disabled=\"angular.isUndefined(vm.object.option) || vm.object.option == null || vm.object.option == 2 && (vm.object.date === \'\')\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/parents/views/modal_change_relationship.html","<md-dialog aria-label=\"Create Coordinator\" md-theme=\"educational\" style=\"min-width: 350px; min-height: 150px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Editar relacionamento</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close(false)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div style=\"padding: 40px; width: 90%;\"><md-select ng-model=\"vm.responsible.prt_id\" placeholder=\"Parentesco\"><md-option ng-value=\"relation.id\" ng-repeat=\"relation in vm.person_relations\">{{ relation.name }}</md-option></md-select></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-warm\" ng-click=\"vm.close(false)\">Cancelar</md-button><md-button ng-disabled=\"vm.previous_relation == vm.responsible.prt_id\" class=\"md-raised md-primary\" ng-click=\"vm.saveRelationship()\" style=\"padding: 1px;\">Salvar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/educational/students/parents/views/parents.html","<a4-student-responsibles-form student=\"vm.student\" is-enrolment=\"false\" matrix-period=\"vm.matrix_period\" group-id=\"vm.group_id\"></a4-student-responsibles-form>");
$templateCache.put("app/educational/students/parents/views/responsibles-wizard.html","<md-dialog aria-label=\"Create Subject\" style=\"max-width: 1000px; width: 1000px;\" md-theme=\"educational\"><div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Assistente de Cadastro de Responsáveis</span></div><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal(false)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-card layout-padding=\"\" class=\"with-btn-add\"><form name=\"form_wizard\" ng-submit=\"vm.submit(vm.form, vm.step_selected)\"><md-content class=\"md-dialog-content\" style=\"overflow: auto;\" ng-style=\"{height: vm.size[vm.step_selected]}\"><md-steppers ng-class=\"{\'md-dynamic-height\': vm.windowSize > 350}\" md-busy-text=\"\'Aguarde...\'\" md-busy=\"vm.showBusyText\" md-stretch-steppers=\"always\" md-selected=\"vm.step_selected\"><md-step label=\"Início\" md-complete=\"vm.steps.search.completed\" ng-disabled=\"vm.step_selected !== 0\"><div ng-if=\"vm.step_selected == 0\"><md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.form.responsible_selected\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPerson(vm.searchText)\" md-item-text=\"item.name\" md-input-minlength=\"3\" md-delay=\"1000\" md-min-length=\"0\" placeholder=\"Digite o nome do responsável\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Responsável não encontrado, prossiga para criar um novo</md-not-found></md-autocomplete><div layout=\"row\" layout-align=\"end end\" ng-if=\"vm.windowSize <= 350\" style=\"margin-top: 0\"><md-button type=\"button\" ng-show=\"vm.step_selected > 1\" ng-click=\"vm.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"vm.step_selected < 4 && vm.is_edit !== 1 || vm.step_selected < 3 && vm.is_edit === 1\" class=\"md-primary md-raised\" ng-disabled=\"vm.disable || form_wizard.$invalid || vm.blockFormEmail\">Próximo<md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.save()\" ng-if=\"vm.step_selected === 4 && vm.is_edit !== 1 || vm.step_selected === 3 && vm.is_edit === 1\" ng-disabled=\"vm.disable || form_wizard.$invalid\"><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-check\"></md-icon>Finalizar<md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></div></md-step><md-step label=\"Dados Principais\" ng-disabled=\"vm.step_selected !== 1\"><div ng-if=\"vm.step_selected === 1\"><md-content style=\"height: 100%\"><a4-responsible-form person=\"vm.form.person\" is-enabled=\"true\" block-form-email=\"vm.blockFormEmail\"></a4-responsible-form><div layout=\"row\" layout-align=\"end end\" ng-if=\"vm.windowSize <= 350\" style=\"margin-top: 0\"><md-button type=\"button\" ng-show=\"vm.step_selected > 1\" ng-click=\"vm.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"vm.step_selected < 4 && vm.is_edit !== 1 || vm.step_selected < 3 && vm.is_edit === 1\" class=\"md-primary md-raised\" ng-disabled=\"vm.disable || form_wizard.$invalid || vm.blockFormEmail\">Próximo<md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.save()\" ng-if=\"vm.step_selected === 4 && vm.is_edit !== 1 || vm.step_selected === 3 && vm.is_edit === 1\" ng-disabled=\"vm.disable || form_wizard.$invalid\"><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-check\"></md-icon>Finalizar<md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-content></div></md-step><md-step label=\"Contato\" ng-disabled=\"vm.step_selected !== 2\"><div ng-if=\"vm.step_selected === 2\"><a4-responsible-contact-form person=\"vm.form.person\" is-enabled=\"true\" has-owner=\"false\"></a4-responsible-contact-form><div layout=\"row\" layout-align=\"end end\" ng-if=\"vm.windowSize <= 350\" style=\"margin-top: 0\"><md-button type=\"button\" ng-show=\"vm.step_selected > 1\" ng-click=\"vm.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"vm.step_selected < 4 && vm.is_edit !== 1 || vm.step_selected < 3 && vm.is_edit === 1\" class=\"md-primary md-raised\" ng-disabled=\"vm.disable || form_wizard.$invalid || vm.blockFormEmail\">Próximo<md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.save()\" ng-if=\"vm.step_selected === 4 && vm.is_edit !== 1 || vm.step_selected === 3 && vm.is_edit === 1\" ng-disabled=\"vm.disable || form_wizard.$invalid\"><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-check\"></md-icon>Finalizar<md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></div></md-step><md-step label=\"Inf. funcionais\" ng-disabled=\"vm.step_selected !== 3\"><div ng-if=\"vm.step_selected === 3\"><div class=\"md-dialog-content new-material-inputs\"><div layout-gt-xs=\"row\"><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\"><label class=\"isEnabled\">Empresa onde trabalha</label> <input ng-model=\"vm.form.person.company_work\" type=\"text\"></md-input-container><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\"><label class=\"isEnabled\">Cargo</label> <input ng-model=\"vm.form.person.position_held\" type=\"text\"></md-input-container><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\"><label class=\"isEnabled\">Função</label> <input ng-model=\"vm.form.person.job_role\" type=\"text\"></md-input-container><md-input-container flex-gt-xs=\"\" class=\"md-block md-input-has-placeholder show_bottom\"><label class=\"isEnabled\">Telefone comercial</label> <input ng-model=\"vm.form.person.work_phone_1\" ui-br-phone-number=\"\"></md-input-container></div></div><div layout=\"row\" layout-align=\"end end\" ng-if=\"vm.windowSize <= 350\" style=\"margin-top: 0\"><md-button type=\"button\" ng-show=\"vm.step_selected > 1\" ng-click=\"vm.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"vm.step_selected < 4 && vm.is_edit !== 1 || vm.step_selected < 3 && vm.is_edit === 1\" class=\"md-primary md-raised\" ng-disabled=\"vm.disable || form_wizard.$invalid || vm.blockFormEmail\">Próximo<md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.save()\" ng-if=\"vm.step_selected === 4 && vm.is_edit !== 1 || vm.step_selected === 3 && vm.is_edit === 1\" ng-disabled=\"vm.disable || form_wizard.$invalid\"><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-check\"></md-icon>Finalizar<md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></div></md-step><md-step label=\"Final\" md-complete=\"vm.steps.end.completed\" ng-disabled=\"vm.step_selected !== 4\"><div ng-if=\"vm.step_selected === 4\"><div layout=\"column\"><md-input-container><label>Grau de parentesco</label><md-select ng-model=\"vm.relationship\"><md-option ng-repeat=\"relation in vm.list.person.person_relation_id\" ng-value=\"relation.id\">{{relation.name}}</md-option></md-select></md-input-container><md-input-container><md-checkbox ng-model=\"vm.is_pedagogic\">Tornar responsável pedagógico?</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"end end\" ng-if=\"vm.windowSize <= 350\" style=\"margin-top: 0\"><md-button type=\"button\" ng-show=\"vm.step_selected > 1\" ng-click=\"vm.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"vm.step_selected < 4 && vm.is_edit !== 1 || vm.step_selected < 3 && vm.is_edit === 1\" class=\"md-primary md-raised\" ng-disabled=\"vm.disable || form_wizard.$invalid || vm.blockFormEmail\">Próximo<md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.save()\" ng-if=\"vm.step_selected === 4 && vm.is_edit !== 1 || vm.step_selected === 3 && vm.is_edit === 1\" ng-disabled=\"vm.disable || form_wizard.$invalid\"><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-check\"></md-icon>Finalizar<md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></div></md-step></md-steppers></md-content><md-step-actions layout=\"row\" layout-align=\"end end\" ng-if=\"vm.windowSize > 350\"><div><md-button type=\"button\" ng-show=\"vm.step_selected > 1\" ng-click=\"vm.moveToPreviousStep()\" class=\"md-primary md-raised\"><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-left\"></md-icon>Anterior</md-button><md-button type=\"submit\" ng-show=\"vm.step_selected < 4 && vm.is_edit !== 1 || vm.step_selected < 3 && vm.is_edit === 1\" class=\"md-primary md-raised\" ng-disabled=\"vm.disable || form_wizard.$invalid || vm.blockFormEmail\">Próximo<md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-arrow-right\"></md-icon><md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"vm.save()\" ng-if=\"vm.step_selected === 4 && vm.is_edit !== 1 || vm.step_selected === 3 && vm.is_edit === 1\" ng-disabled=\"vm.disable || form_wizard.$invalid\"><md-icon ng-show=\"!$rootScope.show_loader\" md-font-icon=\"icon-check\"></md-icon>Finalizar<md-progress-circular ng-show=\"$rootScope.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular></md-button></div></md-step-actions></form></md-card></div></md-dialog>");
$templateCache.put("app/educational/students/questionnaires/views/questionnaires.html","<md-content layout=\"row\" layout-align=\"center center\"><md-input-container flex=\"25\"><label>Questionários sobre o aluno</label><md-select ng-model=\"vm.questionnaire_selected\"><md-option ng-repeat=\"questionnaire in vm.student_questionnaires\" ng-value=\"questionnaire\">{{questionnaire.data.questionnaire_info.name}} {{questionnaire.questionnaire_event_item_name}}</md-option></md-select></md-input-container><md-button ng-click=\"vm.printQuestionnaire(vm.questionnaire_selected)\" ng-if=\"vm.students.attendance_mode_id == 1 || vm.students.attendance_mode_id == 2 || vm.students.attendance_mode_id == 3 || vm.students.attendance_mode_id == null\" ng-disabled=\"item.questionnaire_status_id == 25 && (vm.company === 101321 || vm.company === 101224 || vm.company === 683) && (vm.current_profile == 7)\"><md-icon>print</md-icon>Imprimir</md-button></md-content><md-card layout=\"column\" md-padding=\"\"><md-card-content><md-card ng-repeat=\"question in vm.questionnaire_selected.data.questions\" class=\"md-padding\"><h3><b>Questão: {{question.stem}}</b></h3><table md-table=\"\" ng-if=\"question.question_type_id === \'XM\' || question.question_type_id === \'XU\'\" style=\"table-layout: fixed\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Questão</th><th md-column=\"\" style=\"text-align: right\">Resposta</th></tr></thead><tr ng-repeat=\"sub_item in question.items\"><td>{{sub_item.stem}}</td><td style=\"text-align: right\"><span ng-if=\"sub_item.right_answer !== null\">{{vm.getAnswer(question.options, sub_item.right_answer)}}</span></td></tr></table><md-input-container ng-if=\"question.question_type_id !== \'XM\' && question.question_type_id !== \'XU\'\" flex=\"\"><textarea rows=\"3\" ng-model=\"question.answer\" disabled=\"\"></textarea></md-input-container></md-card></md-card-content></md-card>");
$templateCache.put("app/educational/students/school-reports/views/school-reports.html","<div layout=\"row\" align=\"start center\"><div flex=\"100\"><md-subheader class=\"md-no-sticky\"><div layout=\"row\" flex=\"\"><div flex=\"\"><span class=\"md-block\">Status do boletim: <strong class=\"uppercase\">{{ vm.students.attendance_mode_id == 1 || vm.students.attendance_mode_id == 2 || vm.students.attendance_mode_id == 3 || vm.students.attendance_mode_id == null ? vm.grid.academic_status.name : vm.students.attendance_mode }}</strong></span></div><md-input-container flex=\"\" class=\"md-input-has-placeholder\" style=\"margin: 0px !important;\" ng-if=\"vm.show_school_periods\"><label>Período</label><md-select name=\"groups\" ng-model=\"vm.school_period_id\" ng-change=\"vm.setSchoolPeriod(vm.school_period_id)\"><md-option ng-repeat=\"school_period in vm.school_periods\" ng-value=\"school_period.id\">{{school_period.name}}</md-option></md-select></md-input-container><div layout-align=\"end center\" layout=\"row\" flex=\"\" ng-if=\"vm.students.attendance_mode_id == 1 || vm.students.attendance_mode_id == 2 || vm.students.attendance_mode_id == 3 || vm.students.attendance_mode_id == null\"><md-button ng-click=\"vm.printNotes()\"><md-icon md-font-icon=\"icon-printer\"></md-icon>Imprimir boletim</md-button><md-checkbox ng-model=\"vm.is_detailed\" aria-label=\"Boletim detalhado\">Mostrar boletim detalhado</md-checkbox><md-checkbox ng-model=\"vm.dont_print_footer\" aria-label=\"Boletim detalhado\">Não imprimir rodapé</md-checkbox></div></div></md-subheader><form name=\"formNoteRelease\" novalidate=\"\"><table class=\"simple table-note-release no-border-top school-report a4-table-fixed\"><thead><tr ng-if=\"vm.subjects.length > 0\"><th></th><th ng-repeat=\"grade in ::vm.grid.steps\" colspan=\"{{grade.siblingsqtd}}\" ng-show=\"vm.is_detailed\"><b>{{grade.name}}</b><md-tooltip md-direction=\"top\">{{grade.description}}</md-tooltip></th><th ng-if=\"vm.is_detailed\"></th></tr><tr><th>Disciplinas</th><th ng-repeat=\"grade in vm.grid.grade_json\" ng-if=\"vm.isNumber(grade.precision) && grade.pass_grade.length\" ng-show=\"(!vm.is_detailed) ? grade.show_on_grade : true\" ng-init=\"calculed = (grade.conditional != \'\') ? true : false; grade.oficial_name = (grade.label) ? grade.label : grade.name;\" class=\"hoverSubjectEvent\"><md-tooltip md-direction=\"top\">{{ grade.description}}</md-tooltip><strong class=\"strong\" ng-show=\"calculed\">{{grade.oficial_name}}</strong> <span ng-hide=\"calculed\">{{grade.oficial_name}}</span></th><th class=\"text-align-center\">Situação</th></tr></thead><tbody><div class=\"tbody\"><tr ng-repeat=\"subject in vm.subjects\" ng-if=\"vm.is_detailed || subject.show_on_report\"><td ng-class=\"{\'is_child\': subject.is_child}\">{{subject.subject_name}}<span ng-if=\"subject.dependency_year !== null\">(DEP)</span></td><td ng-repeat=\"grade in vm.grid.grade_json track by grade.name\" ng-if=\"vm.isNumber(grade.precision) && grade.pass_grade.length\" ng-show=\"(!vm.is_detailed) ? grade.show_on_grade : true\" class=\"align-center\"><span ng-repeat=\"(id, note) in subject.grade_json track by id\" ng-if=\"grade.name == id\"><span ng-class=\"{ \'note-release-approved\' : note.value >= vm.getValue(id, \'pass_grade\') || ( id == \'MEDIA\' && subject.academic_status_id >= 10 && subject.academic_status_id <= 19 ), \'note-release-disapproved\': note.value < vm.getValue(id, \'pass_grade\') || ( id == \'MEDIA\' && subject.academic_status_id >= 20 && subject.academic_status_id <= 29 ), \'note-release-council\' : note.valueCouncil.length && note.valueCouncil !== null }\"><span ng-if=\"$.type(note.value) !== \'string\' && !vm.special_characters.includes(note.value)\">{{ note.valueConcept !== null && note.valueConcept !== undefined ? vm.formatValue(note.valueConcept) : (note.value >= 0 ? (note.value | number:grade.precision) : vm.formatValue(note.value))}}</span> <span ng-if=\"vm.special_characters.includes(note.value)\">{{note.value}}</span><md-tooltip md-direction=\"top\" ng-if=\"note.value\"><span ng-if=\"note.value < vm.getValue(id, \'pass_grade\')\">Reprovada</span> <span ng-if=\"note.value >= vm.getValue(id, \'pass_grade\')\">Aprovada</span> <span ng-if=\"note.valueCouncil.length && note.valueCouncil !== null\">- Nota atribuída por conselho de classe</span></md-tooltip><md-tooltip md-direction=\"left\" ng-if=\"note.value\">Média: {{grade.pass_grade}}</md-tooltip><md-tooltip md-direction=\"right\" ng-if=\"note.value\">Máx: {{grade.max_grade}}</md-tooltip><md-tooltip md-direction=\"bottom\" ng-if=\"note.value\" ng-init=\"percent = note.value / grade.max_grade * 100;\">Alcançou: {{ percent | number:0}}%</md-tooltip></span></span></td><td class=\"align-center\"><md-tooltip md-direction=\"top\">{{subject.academic_status_name}}</md-tooltip><span>{{subject.academic_status_code}}</span></td></tr></div></tbody></table></form></div></div>");
$templateCache.put("app/educational/students/schoolrecords/views/schoolrecords.html","<md-content layout-padding=\"\" class=\"with-btn-add\"><div class=\"there-are-no\" layout-align=\"end center\" layout=\"column\" flex=\"\" ng-show=\"vm.school_records.length == 0\"><div><md-icon>info_outline</md-icon></div><div class=\"preview-scale\"><strong>Não há registros ;(</strong></div></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"20\"><label>Selecione os históricos para exibição</label><md-select ng-model=\"vm.school_records_selected\" ng-change=\"vm.getSchoolRecordsType(vm.school_records_selected)\"><md-option ng-disabled=\"!vm.school_records.definitions.pre && !vm.school_records.definitions.primary && !vm.school_records.definitions.high\" ng-value=\"\'pre\'\">Ensino Infantil</md-option><md-option ng-disabled=\"!vm.school_records.definitions.primary && !vm.school_records.definitions.high\" ng-value=\"\'primary\'\">Ensino Fundamental</md-option><md-option ng-disabled=\"!vm.school_records.definitions.high\" ng-value=\"\'high\'\">Ensino Médio</md-option></md-select></md-input-container><div ng-if=\"vm.school_records_selected == \'primary\'\"><md-input-container><md-radio-group ng-model=\"vm.primary_type\" layout=\"row\" ng-change=\"vm.changePrimaryType()\"><md-radio-button ng-value=\"9\">Novo fundamental (9 anos)</md-radio-button><md-radio-button ng-value=\"8\">Antigo fundamental (8 anos)</md-radio-button></md-radio-group></md-input-container></div></div><div class=\"group-table-school-records\" ng-if=\"vm.school_records_selected != null\"><div class=\"table-school-records\"><div><div layout=\"row\" layout-align=\"space-between center\"><div><h3 ng-if=\"vm.school_records_selected == \'pre\'\">Histórico Infantil</h3><h3 ng-if=\"vm.school_records_selected == \'primary\'\">Histórico Fundamental</h3><h3 ng-if=\"vm.school_records_selected == \'high\'\">Histórico Médio</h3></div><div><div layout=\"row\"><date-picker placeholder=\"Data de emissão\" style=\"margin-right: 10px; margin-top: 5px;\" ng-model=\"vm.print_date\" ng-change=\"vm.checkCompany()\" ng-disabled=\"vm.company != 18 && vm.company != 20\"></date-picker><md-input-container><md-checkbox ng-model=\"vm.printTotalCourseLoadBySubject\" ng-if=\"vm.student.attendance_mode_id == 1 || vm.student.attendance_mode_id == 2 || vm.student.attendance_mode_id == 3 || vm.student.attendance_mode_id == null\">Na impressão exibir total de CH por disciplina</md-checkbox></md-input-container><md-button ng-if=\"vm.school_records_selected == \'pre\' && (vm.student.attendance_mode_id == 1 || vm.student.attendance_mode_id == 2 || vm.student.attendance_mode_id == 3 || vm.student.attendance_mode_id == null)\" target=\"_blank\" ng-click=\"vm.print_school_record(\'any\')\"><md-tooltip md-direction=\"top\" ng-if=\"vm.school_records_selected == \'pre\'\">Histórico do ensino infantil em PDF</md-tooltip>Ens.Inf<md-icon class=\"material-icons\">print</md-icon></md-button><md-button ng-if=\"vm.school_records_selected == \'primary\' && (vm.student.attendance_mode_id == 1 || vm.student.attendance_mode_id == 2 || vm.student.attendance_mode_id == 3 || vm.student.attendance_mode_id == null)\" target=\"_blank\" ng-click=\"vm.print_school_record(\'any\')\"><md-tooltip md-direction=\"top\" ng-if=\"vm.school_records_selected == \'primary\'\">Histórico do ensino fundamental em PDF</md-tooltip>Ens.Fun<md-icon class=\"material-icons\">print</md-icon></md-button><md-button ng-if=\"vm.school_records_selected == \'high\' && (vm.student.attendance_mode_id == 1 || vm.student.attendance_mode_id == 2 || vm.student.attendance_mode_id == 3 || vm.student.attendance_mode_id == null)\" target=\"_blank\" ng-click=\"vm.print_school_record(\'any\')\"><md-tooltip md-direction=\"top\" ng-if=\"vm.school_records_selected == \'high\'\">Histórico do ensino médio em PDF</md-tooltip>Ens.Med<md-icon class=\"material-icons\">print</md-icon></md-button><md-button target=\"_blank\" ng-click=\"vm.print_school_record(\'all\')\" ng-if=\"vm.school_records_selected === \'high\' && (vm.student.attendance_mode_id == 1 || vm.student.attendance_mode_id == 2 || vm.student.attendance_mode_id == 3 || vm.student.attendance_mode_id == null)\"><md-tooltip md-direction=\"top\">Histórico completo em PDF</md-tooltip><md-icon class=\"material-icons\">print</md-icon>Ens. Fun+Médio</md-button></div></div></div><div class=\"table-overflow\"><table class=\"simple school-records only-records\" ng-class=\"vm.form.mode_edit ? \'edit-enabled\' : \'\'\"><thead><tr><th>Disciplinas</th><th ng-repeat=\"item in vm.NUMBERS[vm.school_records_selected]\">{{ item }} <span ng-if=\"(vm.primary_type === 9 && vm.school_records_selected !== \'high\') || (vm.primary_type === 8 && vm.school_records_selected == \'high\')\">º Ano</span> <span ng-if=\"(vm.primary_type === 9 && vm.school_records_selected == \'high\') || (vm.primary_type === 8 && vm.school_records_selected !== \'high\')\">ª Série</span><br><div layout=\"row\"><strong flex=\"50\">Nota</strong> <strong flex=\"50\">CH</strong></div></th></tr></thead><tbody><tr ng-repeat=\"(id, row) in vm.form.school_records[vm.school_records_selected] | filter:{\'subject_id\': \'\'} track by $index\"><td><div layout=\"row\"><span flex=\"\"><div class=\"select-static\" flex=\"100\"><div class=\"select-option\"><p class=\"select-name\" ng-show=\"row.subject_name\">{{ row.subject_name }}</p><p class=\"select-name\" ng-hide=\"row.subject_name\" ng-bind=\"row[0].subject_name != null ? row[0].subject_name : \'Infome a disciplina\'\"></p><button class=\"md-icon-button edit\" ng-hide=\"row.block_edit\"><md-icon class=\"material-icons\">mode_edit</md-icon></button></div><md-input-container class=\"select-mask\"><label>Busque ou adicione</label><md-select ng-model=\"row[$index].subject\" ng-hide=\"row.block_edit\" ng-change=\"row.subject_name = row[$index].subject.name; row.subject_id = row[$index].subject.id;\" md-on-close=\"searchTerm[$index] = \'\'\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm[$index]\" type=\"search\" placeholder=\"Busque ou adicione\" ng-keydown=\"$event.stopPropagation()\" ng-change=\"$emit(\'search_subject_for_school_records\',searchTerm[$index], row);\" ng-model-options=\"{ debounce: 250 }\" class=\"demo-header-searchbox md-text\"> <span ng-click=\"$emit(\'add_new_subject_in_school_records\', searchTerm[$index], id, vm.school_records_selected)\" class=\"search-event\"><md-icon>add_circle</md-icon></span></md-select-header><md-option ng-value=\"subject\" ng-repeat=\"subject in row.searchSubject | filter:searchTerm[$index]\">{{subject.name}}</md-option></md-select></md-input-container></div></span> <button class=\"md-icon-button delete\" ng-click=\"vm.removeRow(row, id, vm.school_records_selected)\"><md-icon class=\"material-icons\">delete</md-icon></button><md-button class=\"show-last md-icon-button add-row\" ng-click=\"vm.addNewRow(\'\', vm.school_records_selected, id)\"><md-icon aria-label=\"Add\">add_circle</md-icon></md-button></div></td><td ng-repeat=\"item in vm.EQUIVALENCES[vm.school_records_selected]\" ng-init=\"grade = \'grade_\'+item; course_load = \'course_load_\'+item\"><div layout=\"row\"><span flex=\"50\"><md-input-container><input ng-model=\"row[grade]\" ng-readonly=\"row.readonly\" ng-disabled=\"row.readonly\" on-focus=\"!row.readonly\" aria-label=\"nota {{grade}}\" maxlength=\"15\"></md-input-container></span> <span flex=\"50\" class=\"column-bg\"><md-input-container><input ng-model=\"row[course_load]\" ng-change=\"vm.calculateCourseLoad(row[course_load], vm.school_records_selected, $parent.$index, item)\" ng-disabled=\"vm.verifyCourseLoad(course_load)\" ng-value=\"0\" aria-label=\"carga horaria {{course_load}}\" maxlength=\"8\"></md-input-container></span></div></td></tr><tr ng-if=\"vm.form.school_records[vm.school_records_selected].length <= 1\"><td><md-button class=\"md-icon-button add-row\" ng-click=\"vm.addNewRow(\'\', vm.school_records_selected, id)\"><md-icon aria-label=\"Add\">add_circle</md-icon></md-button></td></tr></tbody><tfoot><tr><td><div layout=\"row\"><span flex=\"10\"></span> <span flex=\"75\">Total CH</span></div></td><td ng-repeat=\"item in vm.ch_equivalences track by $index\"><div layout=\"row\"><span flex=\"50\"></span> <span flex=\"50\" class=\"column-bg\"><md-input-container><input ng-change=\"vm.calculateCourseLoad(vm.form.school_records[vm.school_records_selected][vm.length][item], vm.school_records_selected, vm.length, item)\" maxlength=\"7\" ng-disabled=\"vm.verifySubjectsLoad(item)\" ng-model=\"vm.form.school_records[vm.school_records_selected][vm.length][item]\"></md-input-container></span></div></td></tr></tfoot></table></div><h3>Histórico de Escolas</h3><table class=\"simple school-records\" ng-class=\"vm.form.mode_edit ? \'edit-enabled\' : \'\'\"><thead><tr><th>Série/Ano</th><th>Escola</th><th>Cidade</th><th>Estado</th><th>Ano</th></tr></thead><tbody><tr ng-repeat=\"(id, item) in vm.form.school_records_school[vm.school_records_selected] track by $index\"><td><div layout=\"row\"><span flex=\"100\"><md-input-container><p class=\"select-name\">{{$index + 1}} º</p></md-input-container></span> <button class=\"md-icon-button clear\" ng-click=\"vm.clearSchool($index, vm.school_records_selected)\"><md-icon class=\"material-icons\">clear</md-icon></button></div></td><td><div layout=\"row\"><span flex=\"100\"><md-autocomplete flex=\"\" md-delay=\"500\" ng-init=\"item.search_school_name = item.name\" md-input-name=\"autocompleteField\" md-no-cache=\"true\" md-selected-item=\"item.school_origin\" md-search-text=\"item.search_school_name\" md-items=\"item in vm.querySearchSchool(item.search_school_name)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.autoCompleteField(item, vm.form.school_records_school[vm.school_records_selected][$index])\" md-floating-label=\"Escola\"><md-item-template><span md-highlight-text=\"item.search_school_name\">{{item.name}} - ({{item.city}}/{{item.state_id}})</span></md-item-template></md-autocomplete></span></div></td><td><div layout=\"row\" layout-align=\"center center\"><span><md-input-container class=\"md-input-has-placeholder\"><input ng-model=\"item.city\"></md-input-container></span></div></td><td><div layout=\"row\" layout-align=\"center center\"><span><md-input-container class=\"md-input-has-placeholder\"><md-select ng-model=\"item.state_id\"><md-option ng-repeat=\"(index, option) in vm.states track by $index\" ng-value=\"option.id\">{{option.name}}</md-option></md-select></md-input-container></span></div></td><td><div layout=\"row\" layout-align=\"center center\"><span flex=\"100\"><md-input-container><input ng-model=\"item.year\"></md-input-container></span></div></td></tr></tbody></table><h3>Observações</h3><div layout=\"row\"><md-input-container flex=\"100\"><textarea ng-model=\"vm.form.school_records_notes[\'school_records_\' + vm.school_records_selected + \'_notes\']\"></textarea></md-input-container></div></div></div></div></md-content>");
$templateCache.put("app/educational/students/subjects/views/add-dependency.html","<md-dialog aria-label=\"Create Subject\" style=\"max-width: 1000px;width: 1000px;\" md-theme=\"educational\"><div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-toolbar-tools\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">Matrícula em Dependência</span></div><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal(false)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-card style=\"height: 630px;\" ng-if=\"vm.show_loader\"><div style=\"margin: 25% auto 0px 45%\" ng-if=\"true\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"70\"></md-progress-circular></div></md-card><md-card layout-padding=\"\" class=\"with-btn-add\" ng-if=\"!vm.show_loader\"><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-content ng-cloak=\"\" style=\"height: 540px;\" flex=\"40\"><md-subheader class=\"md-primary\">Turmas disponíveis</md-subheader><a4-tree-grid tree-data=\"vm.coursesAndGroups\" col-defs=\"vm.col_defs_services\" expand-on=\"vm.expanding_property\" expand-level=\"1\" on-click=\"vm.selectGroup(branch)\" icon-leaf=\'row.branch.children.length <= 0 && row.level == 2 ? \"no-icon\" : \"no-icon\"\' icon-expand=\'row.branch.children.length > 0 && !row.branch.expanded ? \"icon-chevron-right\" : \"icon-chevron-down\"\' icon-collapse=\'row.branch.children.length > 0 && row.branch.expanded ? \"icon-chevron-down\" : \"icon-chevron-right\"\'></a4-tree-grid></md-content><md-content ng-cloak=\"\" flex=\"60\" style=\"height: 540px;padding-left: 5px;\"><md-subheader class=\"md-primary\">Disciplinas | Turma: {{vm.group.text}}</md-subheader><form><div layout=\"column\" flex-gt-xs=\"\" class=\"md-block\"><label for=\"select-year\"><span style=\"line-height: 20px; font-size: 12px; color: #969696 !important\">Ano</span></label><select2 ng-model=\"vm.dependency_year\" s2-options=\"year.id as year.name for year in vm.years\" id=\"select-year\" ng-disabled=\"false\" flex-gt-xs=\"\"></select2></div></form><md-table-container><table md-table=\"\" md-progress=\"vm.promise\" multiple=\"\" ng-model=\"vm.selected_subjects\" md-row-select=\"\"><thead md-head=\"\"><tr md-row=\"\" style=\"height: 28px !important;\"><th md-column=\"\" style=\"padding-left: 10px !important;\">Nome</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" style=\"cursor: pointer; height: 28px !important;\" md-auto-select=\"\" ng-repeat=\"item in vm.subjects_list\" md-select=\"item\" md-select-id=\"id\"><td md-cell=\"\" style=\"padding-left: 10px !important;\">{{ item.name }}</td></tr></tbody></table></md-table-container></md-content></md-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.selected_subjects.length <= 0 || vm.dependency_year == null\" ng-click=\"vm.enrolmentDependency()\">Matricular</md-button></md-dialog-actions></md-card></div></md-dialog>");
$templateCache.put("app/educational/students/subjects/views/modal-details-item.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"educational\" style=\"min-width: 500px;\"><form ng-cloak=\"\" name=\"extra_grade_form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.scope.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\" flex=\"\"><div layout=\"column\" flex=\"100\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"number\" step=\"0.1\" ng-model=\"vm.scope.item.final_grade\" placeholder=\"Nota\" required=\"\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input flex=\"\" type=\"text\" maxlength=\"10\" ng-model=\"vm.scope.item.external_school_period\" placeholder=\"Período Letivo\" required=\"\" class=\"ng-pristine ng-untouched ng-valid\" aria-invalid=\"false\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-click=\"vm.answer(vm.scope);\" ng-disabled=\"extra_grade_form.$invalid\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/students/subjects/views/select-group-enrolment.html","<md-dialog md-theme=\"educational\" aria-label=\"{{vm.subject_name}}\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\"><h1>{{vm.subject_name}}</h1><span flex=\"\"></span><md-button class=\"md-icon-button md-button ng-scope md-ink-ripple md-default-theme\" ng-click=\"vm.closeModal();\"><md-icon aria-label=\"Close dialog\"><i class=\"material-icons\">close</i></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" style=\"border-left: solid 4px #1c82cc\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Turmas disponíveis</b> <small>Selecione a turma desejada para matrícula</small></div></div><br><md-radio-group ng-model=\"vm.group_id\" layout=\"column\"><md-radio-button ng-repeat=\"group in vm.groups\" flex=\"\" value=\"{{group.subj_group_id}}\" class=\"md-primary\">{{group.course_name}} | {{group.group_name}} | {{group.matrix_period}}<md-icon md-font-icon=\"icon-alert\" ng-if=\"group.clash.length > 0\" class=\"md-warn\"><md-tooltip md-direction=\"top\"><span>CHOQUE DE HORÁRIO<br></span> <span ng-repeat=\"item in group.clash\" ng-if=\"item.day_of_week != null\">{{item.subject_alias}} ({{item.day_of_week == null ? \'\' : item.day_of_week | dayOfWeek}} {{item.initial_time.slice(0,-3)}} - {{item.final_time.slice(0,-3)}})<br></span></md-tooltip></md-icon><span ng-if=\"group.timetable.length > 0 && group.timetable[0].day_of_week != null\" ng-repeat=\"item in group.timetable track by $index\">({{item.day_of_week == null ? \'\' : item.day_of_week | dayOfWeek}} {{item.initial_time.slice(0,-3)}} - {{item.final_time.slice(0,-3)}})</span> <small ng-if=\"group.subject_name !== vm.subject_name\"><br>{{group.subject_name}}</small></md-radio-button></md-radio-group></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-primary\" ng-click=\"vm.submit(vm.group_id)\">Matricular</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/educational/students/subjects/views/subjects.html","<a4-subject-grid person-id=\"vm.person_id\" course-id=\"vm.course_id\" group-id=\"vm.group_id\" course-equivalence-id=\"vm.course_equivalence_id\" course-enrolment-system-id=\"vm.course_enrolment_system_id\" enrolment-period-id=\"vm.enrolment_period_id\" matrix-period=\"vm.matrix_period\" is-enrolment=\"false\" flex=\"\"></a4-subject-grid>");
$templateCache.put("app/educational/students/timetable/views/timetable.html","<a4-calendar ng-model=\"vm.events_calendar\" person-id=\"vm.studentId\" events=\"vm.getLessons(id, start, end)\"></a4-calendar>");
$templateCache.put("app/educational/students/wall/views/wall.html","<md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs=\"\" flex-gt-xs=\"50\" layout=\"column\"><md-card ng-if=\"vm.allow_enrolment && vm.student.id == vm.student.person_id_payee && (vm.student.enrolment_status_id == vm.MATRICULA_CONDICIONAL || vm.student.enrolment_status_id == vm.AGUARDANDO_ASSINATURA_ONLINE)\"><md-card-title><md-card-title-text><span class=\"md-headline\">Matrícula Online</span></md-card-title-text></md-card-title><md-card-content><div style=\"background-color: #00B0FF; width: 100%; height: auto;text-align: center;\" ng-if=\"vm.has_pendences > 0\"><i class=\"icon-alert\" style=\"color: #fff;font-size: 60px;\"></i><br><h1 style=\"color: #fff;\">Prezado Aluno,</h1><span style=\"font-size: 25px; color: #fff;\">Identificamos a ocorrência de pendência financeira em nossos registros.<br>O processo de matrícula pela web não estará disponível até a regularização de possíveis débitos. Favor entrar em contato com a secretaria.</span></div><div ng-if=\"vm.has_pendences == 0\">Para realizar a matrícula online clique no botão ao lado e siga os passos.<md-button class=\"md-icon-button\" ng-click=\"vm.confirmEnrolment(student)\"><md-tooltip md-direction=\"top\">Confirmar matrícula</md-tooltip><md-icon md-font-icon=\"icon-check-circle\"></md-icon></md-button></div><div ng-if=\"vm.has_pendences == 0 && vm.student.enrolment_status_id == vm.CONFIRMADA_ONLINE\">Matrícula online realizada, aguardando pagamento para confirmação.</div></md-card-content></md-card><md-card ng-repeat=\"document in vm.documents\"><img ng-if=\"document.file_reference !== null\" ng-src=\"{{vm.url}}{{document.file_reference}}\" class=\"md-card-image\"><md-card-title><md-card-title-text><span class=\"md-headline\">{{document.title}}</span> <span class=\"a4-subhead\">{{document.date | date:\'dd/MM/yyyy\'}}</span></md-card-title-text></md-card-title><md-card-content><pre style=\"font-family: inherit;\">{{document.content}}</pre></md-card-content></md-card></div></md-content>");
$templateCache.put("app/evaluations/questionnaires/answer-questionnaire/templates/multiline-text.html","<div layout=\"row\"><p ng-if=\"vm.status > 1\" style=\"margin: 0;\">Nota:</p><span ng-if=\"!vm.selected_question.is_canceled && !vm.selected_question.is_answer_invalid && vm.is_correcting\"><b>{{vm.selected_question.points}}</b></span> <span ng-if=\"vm.selected_question.is_canceled\"><b>Questão Anulada</b></span> <span ng-if=\"vm.selected_question.is_answer_invalid\"><b>Questão Inválidada</b></span><span><b>{{question.points}}</b></span></div><p>Nota máxima: <b ng-if=\"vm.answering && !vm.finished || vm.is_correcting\">{{vm.selected_question.max_points}}</b> <b ng-if=\"vm.finished && vm.show_answers && !vm.is_correcting\">{{question.max_points}}</b></p><md-input-container style=\"width: 100% !important;\"><label>Escreva a resposta</label> <textarea ng-model=\"vm.selected_question.right_answer\" rows=\"3\" flex=\"\" ng-if=\"vm.status !== 20 || vm.is_correcting\" style=\"color:black; font-size:16px; width: 100% !important;\" ng-disabled=\"(vm.is_correcting || vm.finished) || vm.selected_question.is_canceled\" ng-bind-html=\"question.right_answer\"></textarea> <textarea ng-model=\"question.right_answer\" rows=\"3\" flex=\"\" ng-if=\"vm.status === 20 && !vm.is_correcting\" style=\"color:black; font-size:16px; width: 100% !important;\" ng-disabled=\"vm.is_correcting || vm.finished\" ng-bind-html=\"question.right_answer\"></textarea></md-input-container><div ng-if=\"vm.status >= 10\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.status === 10 || vm.is_correcting\"><label>Nota</label> <input ng-model=\"vm.selected_question.points\" style=\"width: 30% !important; height: 50px; border: none; text-align: center; background-color: whitesmoke; border-radius: 5px\" ng-maxlength=\"5\" note-release-mask=\"\" ng-value=\"vm.selected_question.points\" ng-disabled=\"vm.selected_question.is_canceled\" ng-change=\"vm.validatePoints()\" ng-if=\"vm.status == 10 || vm.is_correcting\"></div><div layout=\"column\" style=\"margin-left: 50px; margin-top: 15px\"><div><p ng-if=\"vm.status === 20 && !vm.is_correcting\">Nota</p></div><div><p ng-if=\"vm.status === 20 && !vm.is_correcting\" style=\"border: none; text-align: center;\">{{question.points}}</p></div></div><md-input-container style=\"width: 86% !important;\" ng-if=\"vm.status >= 10\"><label>Observação</label> <textarea ng-model=\"vm.selected_question.teacher_notes\" rows=\"3\" flex=\"\" style=\"width: 100% !important;\" ng-if=\"vm.status === 10 || vm.is_correcting\"></textarea><p style=\"margin-top: 50px\" ng-if=\"vm.status === 20 && !vm.is_correcting\">{{question.teacher_notes}}</p></md-input-container></div></div>");
$templateCache.put("app/evaluations/questionnaires/answer-questionnaire/templates/multiple-option.html","<div layout=\"row\"><p ng-if=\"vm.status > 1\" style=\"margin: 0;\">Nota:</p><span ng-if=\"!vm.selected_question.is_canceled && !vm.selected_question.is_answer_invalid && vm.is_correcting\"><b>{{vm.selected_question.points}}</b></span> <span ng-if=\"vm.selected_question.is_canceled\"><b>Questão Anulada</b></span> <span ng-if=\"vm.selected_question.is_answer_invalid\"><b>Questão Inválidada</b></span><span><b>{{question.points}}</b></span></div><p>Nota máxima: <b ng-if=\"vm.answering && !vm.finished || vm.is_correcting\">{{vm.selected_question.max_points}}</b> <b ng-if=\"vm.finished && vm.show_answers && !vm.is_correcting\">{{question.max_points}}</b></p><md-input-container style=\"font-size: 16px;\" ng-if=\"vm.status === 20 && !vm.is_correcting\" ng-repeat=\"option in question.items\" layout=\"column\"><md-checkbox ng-disabled=\"vm.status >= 10\" ng-model=\"option.answer\"><div style=\"color: black !important;\">{{option.name}}</div></md-checkbox><div ng-if=\"vm.status >= 10 && option.is_right_answer\" style=\"color: lightgreen;\"><b>V</b></div><div ng-if=\"vm.status >= 10 && !option.is_right_answer\" style=\"color: crimson;\"><b>X</b></div></md-input-container><md-input-container style=\"font-size: 16px\" ng-if=\"vm.status !== 20 || vm.is_correcting\" ng-repeat=\"option in vm.selected_question.items\" layout=\"column\"><md-checkbox ng-disabled=\"(vm.status >= 10) || vm.selected_question.is_canceled\" ng-model=\"option.answer\"><div style=\"color: black !important;\">{{option.name}}</div></md-checkbox><div ng-if=\"vm.status >= 10 && option.is_right_answer\" style=\"color: lightgreen;\"><b>V</b></div><div ng-if=\"vm.status >= 10 && !option.is_right_answer\" style=\"color: crimson;\"><b>X</b></div></md-input-container>");
$templateCache.put("app/evaluations/questionnaires/answer-questionnaire/templates/unique-option.html","<div layout=\"row\"><p ng-if=\"vm.status > 1\" style=\"margin: 0;\">Nota:</p><span ng-if=\"!vm.selected_question.is_canceled && !vm.selected_question.is_answer_invalid && vm.is_correcting\"><b>{{vm.selected_question.points}}</b></span> <span ng-if=\"vm.selected_question.is_canceled\"><b>Questão Anulada</b></span> <span ng-if=\"vm.selected_question.is_answer_invalid\"><b>Questão Inválidada</b></span><span><b>{{question.points}}</b></span></div><p>Nota máxima: <b ng-if=\"vm.answering && !vm.finished || vm.is_correcting\">{{vm.selected_question.max_points}}</b> <b ng-if=\"vm.finished && vm.show_answers && !vm.is_correcting\">{{question.max_points}}</b></p><md-radio-group ng-model=\"vm.selected_question.right_answer\" ng-if=\"vm.status !== 20 || vm.is_correcting\"><md-radio-button style=\"color:black; font-size:16px;\" ng-repeat=\"option in vm.selected_question.items track by $index\" ng-value=\"option.ord\" ng-disabled=\"vm.status >= 10 || vm.selected_question.is_canceled\"><div layout=\"row\"><b>{{option.chr}}) &nbsp;</b>{{option.name}}<div ng-if=\"(vm.selected_question.answer == $index) && vm.status >= 10\" style=\"color: lightgreen;\"><b>V</b></div><div ng-if=\"(vm.selected_question.answer != $index) && vm.status >= 10\" style=\"color: crimson;\"><b>X</b></div></div></md-radio-button></md-radio-group><md-radio-group ng-model=\"question.right_answer\" ng-if=\"vm.status === 20\" ng-disabled=\"true\"><md-radio-button style=\"color:black; font-size:16px;\" ng-repeat=\"opt in question.items\" ng-value=\"opt.ord\"><div layout=\"row\"><b>{{opt.chr}}) &nbsp;</b>{{opt.name}}<div ng-if=\"(question.answer == opt.ord - 1) && vm.status >= 10\" style=\"color: lightgreen;\"><b>V</b></div><div ng-if=\"(question.answer != opt.ord - 1) && vm.status >= 10\" style=\"color: crimson;\"><b>X</b></div></div></md-radio-button></md-radio-group>");
$templateCache.put("app/evaluations/questionnaires/answer-questionnaire/templates/unique-text.html","<div layout=\"row\"><p ng-if=\"vm.status > 1\" style=\"margin: 0;\">Nota:</p><span ng-if=\"!vm.selected_question.is_canceled && !vm.selected_question.is_answer_invalid && vm.is_correcting\"><b>{{vm.selected_question.points}}</b></span> <span ng-if=\"vm.selected_question.is_canceled\"><b>Questão Anulada</b></span> <span ng-if=\"vm.selected_question.is_answer_invalid\"><b>Questão Inválidada</b></span><span><b>{{question.points}}</b></span></div><p>Nota máxima: <b ng-if=\"vm.answering && !vm.finished || vm.is_correcting\">{{vm.selected_question.max_points}}</b> <b ng-if=\"vm.finished && vm.show_answers && !vm.is_correcting\">{{question.max_points}}</b></p><md-input-container style=\"width: 100% !important;\"><label>Escreva a resposta</label> <input type=\"text\" ng-model=\"vm.selected_question.right_answer\" flex=\"\" ng-disabled=\"(vm.is_correcting || vm.finished) || vm.selected_question.is_canceled\" style=\"color:black; font-size:16px; width: 100% !important;\" ng-if=\"vm.status !== 20 || vm.is_correcting\"> <input type=\"text\" ng-model=\"question.right_answer\" flex=\"\" ng-disabled=\"vm.is_correcting || vm.finished\" style=\"color:black; font-size:16px; width: 100% !important;\" ng-if=\"vm.status === 20 && !vm.is_correcting\"></md-input-container><div ng-if=\"vm.status >= 10\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.status >= 10\"><label>Nota</label> <input ng-model=\"vm.selected_question.points\" style=\"width: 30% !important; height: 50px; border: none; text-align: center; background-color: whitesmoke; border-radius: 5px\" ng-maxlength=\"5\" note-release-mask=\"\" ng-value=\"vm.selected_question.points\" ng-disabled=\"vm.selected_question.is_canceled\" ng-change=\"vm.validatePoints()\" ng-if=\"vm.status == 10 || vm.is_correcting\"><p ng-if=\"vm.status === 20 && !vm.is_correcting\">{{question.points}}</p></div><md-input-container style=\"width: 86% !important;\"><label>Observação</label> <input type=\"text\" ng-model=\"vm.selected_question.teacher_notes\" flex=\"\" ng-if=\"vm.status == 10 || vm.is_correcting\" style=\"width: 100% !important;\"><p style=\"margin-top: 50px\" ng-if=\"vm.status === 20 && !vm.is_correcting\">{{question.teacher_notes}}</p></md-input-container></div></div>");
$templateCache.put("app/evaluations/questionnaires/answer-questionnaire/views/answer-questionnaire.html","<md-content id=\"content\" class=\"answerQuestionnaire\" layout=\"row\" layout-align=\"center start\" md-theme=\"educational\" ng-style=\"{height: vm.windowHeight + \'px\'}\" style=\"overflow: auto;\"><div layout=\"column\" layout-align=\"start center\" class=\"statementBackground\" style=\"width: 100%; overflow: auto; background-color: rgba(67,150,237,0.47); text-align: center !important;\" ng-style=\"{\'height\': vm.windowHeight + \'px\'}\"><md-card class=\"presentationCardExternalAssign md-whiteframe-7dp md-padding fade\" style=\"border-radius: 7px; width: 45%; text-align: left\" ng-style=\"vm.windowWidth < 1000 && {\'width\' : \'95%\'}\" layout=\"column\" ng-if=\"!vm.answering && !vm.finished && !vm.is_correcting\"><div style=\"width: 115px;line-height: 74px;font-size: 50px;font-weight: 500; margin: 2px auto 32px auto;color: #FFFFFF;border-radius: 2px;display: table;\"><div style=\"display: table-cell; vertical-align: middle;\"><img align=\"middle\" ng-src=\"{{vm.screen_image}}\" alt=\"\"></div></div><h1>Bem-vindo, <strong>{{vm.person.name}}</strong>!</h1><h2><strong>Curso</strong>: {{vm.course}}</h2><h2><strong>Turma</strong>: {{vm.group}}</h2><h2><strong>Disciplina</strong>: {{vm.subject}}</h2><h2 ng-if=\"!vm.finished\">Nesta tela você poderá responder a avaliação <strong>{{vm.questionnaire.name}}</strong></h2></md-card><md-card class=\"presentationCardExternalAssign md-whiteframe-7dp md-padding fade\" style=\"border-radius: 7px; width: 45%;\" ng-style=\"vm.windowWidth < 1000 && {\'width\' : \'95%\'}\"><h3>Aluno: <strong>{{vm.person.name}}</strong></h3><h3>Curso: <strong>{{vm.course}}</strong> - Turma: <strong>{{vm.group}}</strong> - Disciplina: <strong>{{vm.subject}}</strong></h3><h3>Avaliação em andamento: <strong>{{vm.questionnaire.name}}</strong></h3><div class=\"onProgressEvaluation__index\" layout=\"row\" layout-align=\"center center\"><span ng-repeat=\"question in vm.questions track by $index\" ng-click=\"vm.selectQuestion($index)\" ng-class=\"{\'selected\': vm.index == $index}\" ng-style=\"{\'background-color\': question.bookmark ? \'#03A9F4 !important\' : question.color}\">{{question.question_number}}</span></div></md-card><md-card ng-if=\"(vm.answering && !vm.finished || (vm.is_correcting && vm.profile == 1))\" class=\"presentationCardExternalAssign md-whiteframe-7dp md-padding fade\" style=\"border-radius: 7px; width: 45%; text-align: center !important;\" ng-style=\"vm.windowWidth < 1000 && {\'width\' : \'95%\'}\" layout=\"column\" layout-align=\"center start\"><div style=\"width: 100%\"><h3><strong>Prova concluída e aguardando correção.</strong></h3></div></md-card><md-card class=\"presentationCardExternalAssign md-whiteframe-7dp md-padding fade\" style=\"border-radius: 7px; width: 45%; text-align: center !important;\" ng-style=\"vm.windowWidth < 1000 && {\'width\' : \'95%\'}\" layout=\"column\" layout-align=\"center start\" ng-if=\"(vm.answering && !vm.finished || (vm.is_correcting && vm.profile != 1))\"><div layout=\"row\" layout-align=\"space-between\" ng-if=\"!vm.is_correcting\" style=\"width: 100%\"><h2>Questão {{vm.index + 1}} de {{vm.questions.length}}:</h2><md-button ng-click=\"vm.setBookmark(vm.index)\"><md-icon ng-style=\"{\'color\': vm.selected_question.bookmark ? \'#D3D3D3\' : \'#778291\'}\">bookmark</md-icon></md-button></div><div style=\"width: 100%\"><h2 ng-if=\"vm.is_correcting\">Questão {{vm.selected_question.question_number}}:</h2><h2 style=\"margin-top: 0; text-align: justify; text-justify: inter-word; word-wrap: break-word; white-space: pre-line;\"><strong>{{vm.selected_question.stem}}</strong></h2></div><p>{{vm.selected_question.notes}}</p><div layout=\"row\" layout_align=\"space-between\" style=\"width: 100%;\"><div style=\"width: 100% !important; text-align: left\" ng-style=\"vm.windowWidth < 1000 && {\'margin-bottom\' : \'50px\'}\"><div ng-if=\"vm.selected_question.question_type_id == \'QU\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/unique-option.html\'\"></div><div ng-if=\"vm.selected_question.question_type_id == \'QM\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/multiple-option.html\'\"></div><div ng-if=\"vm.selected_question.question_type_id == \'TM\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/multiline-text.html\'\"></div><div ng-if=\"vm.selected_question.question_type_id == \'TU\' || vm.selected_question.question_type_id == \'NU\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/unique-text.html\'\"></div></div><div><h2 style=\"text-align: center;\" ng-if=\"vm.selected_question.file_reference\"><img ng-src=\"{{ vm.url + vm.selected_question.file_reference }}\" ng-style=\"{ \'max-width\': vm.selected_question.image_size + \'px\', \'object-fit\': \'contain\', }\"></h2></div></div><div flex=\"\" style=\"width: 100%\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.answering && vm.index !== 0 && vm.index !== vm.questions.length && !vm.is_correcting\"><md-button class=\"md-raised md-primary fade\" style=\"font-size: 11px; padding: 4px;\" ng-click=\"vm.previousQuestion()\" ng-disabled=\"vm.loading\" ng-show=\"vm.index !== 0\"><md-icon md-font-icon=\"icon-arrow-left-bold\"></md-icon>Anterior</md-button><md-button class=\"md-raised md-primary fade\" style=\"font-size: 11px; padding: 4px;\" ng-click=\"vm.nextQuestion()\" ng-disabled=\"vm.loading\" ng-show=\"vm.index < vm.questions.length - 1\">Próxima<md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon></md-button><md-button class=\"md-raised md-primary fade\" style=\"font-size: 11px; padding: 4px;\" ng-disabled=\"vm.loading\" ng-click=\"vm.finishQuestionnaire(vm.index)\" ng-show=\"vm.index == vm.questions.length - 1\">Concluir<md-icon md-font-icon=\"icon-check\"></md-icon></md-button></div><div flex=\"\" style=\"width: 100%\" layout=\"row\"><md-button class=\"md-raised md-primary fade\" style=\"font-size: 11px; padding: 4px; margin-left: 90%\" ng-style=\"vm.windowWidth < 1000 && {\'margin-left\' : \'85%\'}\" ng-click=\"vm.nextQuestion()\" ng-disabled=\"vm.loading\" ng-show=\"vm.index == 0 && vm.questions.length !== 1 && !vm.is_correcting\">Próxima<md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon></md-button><md-button class=\"md-raised md-primary fade\" style=\"font-size: 11px; padding: 4px; margin-left: 90%\" ng-style=\"vm.windowWidth < 1000 && {\'margin-left\' : \'85%\'}\" ng-click=\"vm.finishQuestionnaire(vm.index)\" ng-disabled=\"vm.loading\" ng-show=\"vm.index == 0 && vm.questions.length === 1 && !vm.is_correcting\">Concluir<md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon></md-button></div><div flex=\"\" style=\"width: 100%\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.is_correcting\"><md-button class=\"md-raised md-primary fade\" style=\"font-size: 11px; padding: 4px; margin-right: -15%;\" ng-click=\"vm.previousQuestion()\" ng-disabled=\"vm.loading\" ng-show=\"vm.index !== 0\"><md-icon md-font-icon=\"icon-arrow-left-bold\"></md-icon>Anterior</md-button><md-checkbox style=\"margin-left: 75%\" ng-if=\"(vm.selected_question.question_type_id == \'QU\' || vm.selected_question.question_type_id == \'QM\') && !vm.selected_question.is_canceled\" ng-checked=\"vm.selected_question.is_answer_invalid\" ng-model=\"vm.selected_question.is_answer_invalid\">Invalidar Questão</md-checkbox><md-button class=\"md-raised md-primary fade\" style=\"font-size: 11px; padding: 4px;\" ng-style=\"vm.selected_question.question_type_id == \'QU\' && {\'margin-left\' : \'10%\'}\" ng-click=\"vm.correctQuestion(vm.index)\" ng-disabled=\"vm.selected_question.points === null && !vm.selected_question.is_canceled\">Corrigir<md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon></md-button></div></md-card><md-card class=\"presentationCardExternalAssign md-whiteframe-7dp md-padding fade\" style=\"border-radius: 7px; width: 45%; text-align: center !important;\" ng-style=\"vm.windowWidth < 1000 && {\'width\' : \'95%\'}\" layout=\"column\" layout-align=\"center start\" ng-if=\"vm.finished && !vm.show_answers\"><h1>Avaliação <strong>{{vm.questionnaire.name}}</strong> respondida com sucesso!</h1></md-card><md-card class=\"presentationCardExternalAssign md-whiteframe-7dp md-padding fade\" style=\"border-radius: 7px; width: 45%; text-align: center !important;\" ng-style=\"vm.windowWidth < 1000 && {\'width\' : \'95%\'}\" layout=\"column\" layout-align=\"center start\" ng-if=\"vm.finished && vm.show_answers && !vm.is_correcting\" <h1=\"\">Suas respostas para a avaliação <strong>{{vm.questionnaire.name}}</strong></md-card><md-card class=\"presentationCardExternalAssign md-whiteframe-7dp md-padding fade\" style=\"border-radius: 7px; width: 45%; text-align: center !important;\" ng-style=\"vm.windowWidth < 1000 && {\'width\' : \'95%\'}\" layout=\"column\" layout-align=\"center start\" ng-if=\"vm.finished && vm.show_answers && !vm.is_correcting\" ng-repeat=\"question in vm.questions\"><h2>Questão {{question.ord}} de {{vm.questions.length}}:</h2><div style=\"width: 100%\"><h2 style=\"text-align: justify;\"><strong>{{question.stem}}</strong></h2><p>{{question.notes}}</p></div><div style=\"width: 100% !important; text-align: left\"><div ng-if=\"question.question_type_id == \'QU\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/unique-option.html\'\"></div><div ng-if=\"question.question_type_id == \'QM\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/multiple-option.html\'\"></div><div ng-if=\"question.question_type_id == \'TM\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/multiline-text.html\'\"></div><div ng-if=\"question.question_type_id == \'TU\' || question.question_type_id == \'NU\'\" ng-include=\"\'app/evaluations/questionnaires/answer-questionnaire/templates/unique-text.html\'\"></div></div></md-card><div layout=\"row\"><md-button class=\"md-raised md-primary\" style=\"font-size: 23px; padding: 15px;\" ng-disabled=\"vm.loading\" ng-click=\"vm.exit()\"><md-icon md-font-icon=\"icon-check\"></md-icon>Sair</md-button><md-button class=\"md-raised md-primary fade\" style=\"font-size: 23px; padding: 15px;\" ng-if=\"!vm.answering && !vm.finished && !vm.is_correcting\" ng-disabled=\"vm.loading\" ng-click=\"vm.startAnswers()\"><md-icon md-font-icon=\"icon-check\"></md-icon>Responder</md-button></div></div></md-content>");
$templateCache.put("app/finance/additions/views/forms/form-additions.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><form name=\"formAdditions\" ng-submit=\"includeScope.submit(vm.currentItem)\"><div layout=\"row\" layout-align=\"space-between center\" ng-hide=\"vm.currentItem.id == null\"><div class=\"more secondary-text switch-edit-form\"><md-switch ng-model=\"includeScope.editable\" aria-label=\"\"></md-switch><md-button class=\"md-fab md-primary switch-edit-button\" aria-label=\"\"><md-icon ng-hide=\"!includeScope.editable\"><i class=\"material-icons\" aria-hidden=\"true\">close</i></md-icon><md-icon ng-show=\"!includeScope.editable\"><i class=\"material-icons\" aria-hidden=\"true\">mode_edit</i></md-icon></md-button></div></div><input type=\"hidden\" name=\"id\" ng-model=\"vm.currentItem.id\"><div layout=\"column\"><md-input-container flex=\"\"><input type=\"text\" required=\"\" name=\"name\" ng-model=\"vm.currentItem.name\" ng-disabled=\"!includeScope.editable\" placeholder=\"{{ \'ADDITIONS.FORM_NAME\' | translate }}\"><div ng-messages=\"formAdditions.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'ADDITIONS.FORM_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><md-switch class=\"md-primary\" md-no-ink=\"\" md-invert=\"true\" name=\"is_inactive\" ng-model=\"vm.currentItem.is_inactive\" required=\"\" ng-disabled=\"!includeScope.editable\"><div ng-if=\"!vm.currentItem.is_inactive\">Regra ativa</div><div ng-if=\"vm.currentItem.is_inactive\">Regra inativa</div></md-switch><div class=\"help-tip\"><p>A quantidade de dias de tolerância faz com que os juros só sejam cobrados no caso do pagamento ser feito após a data da tolerância, mas ao passar da data de tolerância, os juros são calculados sobre a data de vencimento, e não sobre a data da tolerância. A forma de cálculo dos juros e multa é a multiplicação do percentual diário pelo quantidade de dias, mas não permitindo que seja mais que o percentual total estabelecido, ou seja o percentual total estabelece um teto para o juro máximo ou multa máxima que pode ser cobrado. Caso seja especificado o percentual diário e não seja especificado o percentual total, então não terá teto máximo para o cálculo de juros e multa. Caso seja especificado o percentual total, então terá teto maxímo para o cálculo de juros e multa. Caso seja especificado o percentual diário, então será cobrado apenas aquele percentual não importando a quantidade de dias de atraso no pagamento. Normalmente para multa é informado apenas o percentual total e para juros é informado apenas o percentual diário.</p></div><div><p>Multa</p><div layout-gt-sm=\"row\"><md-input-container class=\"md-block input-container\" flex-gt-sm=\"\"><label>Quantidade de dias de tolerância</label> <input type=\"number\" name=\"fine_allowance_days\" ng-model=\"vm.currentItem.fine_allowance_days\" ng-disabled=\"!includeScope.editable\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Percentual total da multa</label> <input type=\"text\" ui-percentage-mask=\"5\" ng-disabled=\"!includeScope.editable\" ui-percentage-value=\"\" name=\"fine_percent_total\" ng-model=\"vm.currentItem.fine_percent_total\"></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete flex=\"\" ng-disabled=\"!includeScope.editable\" md-input-name=\"autoCategories\" md-selected-item=\"includeScope.bill_category_fine\" md-no-cache=\"true\" md-search-text-change=\"includeScope.searchTextChange(includeScope.searchText)\" md-search-text=\"includeScope.searchText\" md-selected-item-change=\"vm.currentItem.bill_category_id_fine = item.id\" md-items=\"item in includeScope.querySearch(includeScope.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Categoria da multa\"><md-item-template><span class=\"item-title\"><span><strong>{{item.name}}</strong></span></span> <span class=\"item-metadata\"><span>{{item.path}}</span></span></md-item-template><div ng-messages=\"formAdditions.autoCategories.$error\" ng-if=\"formAdditions.autoCategories.$touched\"><div ng-message=\"required\">{{ \'CATEGORY_IS_REQUIRED\' | translate }}</div><div ng-message=\"md-require-match\">{{ \'CATEGORY_NOT_EXISTS\' | translate }}</div></div><md-not-found>{{ \'CATEGORY_NOT_FOUND\' | translate }}</md-not-found></md-autocomplete></div></div><div><p>Juros</p><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input type=\"number\" name=\"interest_allowance_days\" ng-disabled=\"!includeScope.editable\" ng-model=\"vm.currentItem.interest_allowance_days\" placeholder=\"Quantidade de dias de tolerância\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input type=\"text\" ui-percentage-mask=\"5\" ui-percentage-value=\"\" ng-disabled=\"!includeScope.editable\" name=\"interest_percent_by_day\" ng-model=\"vm.currentItem.interest_percent_by_day\" placeholder=\"Percentual diário de juros\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input type=\"text\" ui-percentage-mask=\"5\" ui-percentage-value=\"\" ng-disabled=\"!includeScope.editable\" name=\"interest_percent_total\" ng-model=\"vm.currentItem.interest_percent_total\" placeholder=\"Percentual máximo de juros\"></md-input-container></div><md-content layout-gt-sm=\"row\"><md-autocomplete flex=\"\" ng-disabled=\"!includeScope.editable\" md-input-name=\"autoCategories\" md-selected-item=\"includeScope.bill_category_interest\" md-no-cache=\"true\" md-search-text-change=\"includeScope.searchTextChange(includeScope.searchText)\" md-search-text=\"includeScope.searchCategory\" md-selected-item-change=\"vm.currentItem.bill_category_id_interest = item.id\" md-items=\"item in includeScope.querySearch(includeScope.searchCategory)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Categoria dos juros\"><md-item-template><span class=\"item-title\"><span><strong>{{item.name}}</strong></span></span> <span class=\"item-metadata\"><span>{{item.path}}</span></span></md-item-template><div ng-messages=\"formAdditions.autoCategories.$error\" ng-if=\"formAdditions.autoCategories.$touched\"><div ng-message=\"required\">{{ \'CATEGORY_IS_REQUIRED\' | translate }}</div><div ng-message=\"md-require-match\">{{ \'CATEGORY_NOT_EXISTS\' | translate }}</div></div><md-not-found>{{ \'CATEGORY_NOT_FOUND\' | translate }}</md-not-found></md-autocomplete></md-content></div><footer layout=\"row\" layout-align=\"space-between center\" class=\"layout-align-space-between-center layout-row\"><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'ADDITIONS.FORM_SUBMIT\' | translate }}\"><md-progress-circular style=\"float: left; top: 8px;left: 100px;\" ng-show=\"vmForm.loginProcess\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span ng-hide=\"vm.currentItem.id == null || !includeScope.editable\" translate=\"ADDITIONS.FORM_UPDATE_SUBMIT\"></span> <span ng-show=\"vm.currentItem.id == null\" translate=\"ADDITIONS.FORM_CREATE_SUBMIT\"></span></md-button></footer></form></div>");
$templateCache.put("app/finance/additions/views/sidenavs/sidenav.html","<div layout=\"row\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"includeScope.formCreate\">{{ \'ADDITIONS.TITLE_CREATE\' | translate }}</span> <span class=\"title\" ng-hide=\"includeScope.formCreate\">{{ \'ADDITIONS.TITLE_EDIT\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'sidenav-form\')\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"content\"><div class=\"sidenav-form\" ng-class=\"includeScope.topSmall ? \'top-small\' : \'\'\" ng-include=\"\'app/finance/additions/views/forms/form-additions.html\'\"></div></div></div>");
$templateCache.put("app/finance/bank-file-receive/views/dialogs/bills_received.html","<md-dialog class=\"check-received\" aria-label=\"Deposito em conta\" style=\"max-width: 80%; width: 1200px\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Títulos do retorno</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><h3>Títulos disponíveis</h3><md-divider></md-divider><div class=\"content layout-column\"><div layout=\"column\"><md-table-container class=\"overflow-table-a4\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Nosso número</th><th md-column=\"\">Pessoa</th><th md-column=\"\">Valor do boleto</th><th md-column=\"\">Data da ocorrência</th><th md-column=\"\">Tarifa bancária</th><th md-column=\"\">Valor liquidado</th><th md-column=\"\">Principal</th><th md-column=\"\">Descontos</th><th md-column=\"\">Acréscimos</th><th md-column=\"\">Diferença</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-auto-select=\"\" md-select-id=\"item\" ng-repeat=\"item in vm.data.billsReceived\"><td md-cell=\"\">{{vm.convertDate(item.date)}}</td><td md-cell=\"\">{{item.amount | currency}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"[1000]\" md-page=\"vm.query.page\" md-total=\"{{vm.data.billsReceived.length}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Fechar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/bank-slip-rule/views/sidenavs/sidenav.html","<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.bank_slip_rule.id == null\">Criar nova regra de boleto</span> <span class=\"title\" ng-show=\"vm.bank_slip_rule.id != null\">Atualizar regra de boleto</span><md-button class=\"md-icon-button\" aria-label=\"Close dialog\" translate=\"\" ng-click=\"vm.close()\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content class=\"content\"><form name=\"formAdditions\" novalidate=\"\" ng-submit=\"vm.submit(vm.bank_slip_rule, formAdditions)\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Dados gerais</b> <small>Abaixo se encontra os dados gerais da regra de boleto</small></div><div layout=\"row\" layout-align=\"space-between center\" ng-hide=\"vm.bank_slip_rule.id == null\"><div class=\"more secondary-text switch-edit-form\"><md-button class=\"md-fab md-primary switch-edit-button\" ng-click=\"vm.isEditable()\" aria-label=\"\" style=\"position: relative;top: 50px;\"><md-icon ng-hide=\"!vm.editable\"><i class=\"material-icons\" aria-hidden=\"true\">close</i></md-icon><md-icon ng-show=\"!vm.editable\"><i class=\"material-icons\" aria-hidden=\"true\">mode_edit</i></md-icon></md-button></div></div></div><md-content><input type=\"hidden\" name=\"id\" ng-model=\"vm.bank_slip_rule.id\"><div layout=\"row\"><md-checkbox flex=\"100\" ng-model=\"vm.bank_slip_rule.is_inactive\" aria-label=\"Detalha títulos\" ng-disabled=\"!vm.editable\">Regra inativa</md-checkbox></div><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" required=\"\" name=\"name\" ng-model=\"vm.bank_slip_rule.name\" ng-disabled=\"!vm.editable\" placeholder=\"{{ \'BANKSLIPRULE.FORM_NAME\' | translate }}\"><div ng-messages=\"formAdditions.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'BANKSLIPRULE.FORM_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'BANKSLIPRULE.CURRENT_ACCOUNT\' | translate }}</label><md-select ng-model=\"vm.bank_slip_rule.current_account_id\" ng-disabled=\"!vm.editable\" ng-required=\"vm.editable\" name=\"currentAccount\"><md-option ng-repeat=\"account in vm.accounts\" value=\"{{account.id}}\">{{account.name}}</md-option></md-select><div ng-messages=\"formAdditions.currentAccount.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar uma conta corrente.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block input-container\" flex=\"\"><label>{{ \'BANKSLIPRULE.BILLING_INSTRUCTIONS\' | translate }}</label> <input type=\"text\" name=\"message_to_cashier\" maxlength=\"80\" ng-model=\"vm.bank_slip_rule.message_to_cashier\" ng-disabled=\"!vm.editable\"></md-input-container><md-input-container class=\"md-block input-container\" flex=\"\"><label>{{ \'BANKSLIPRULE.MESSAGE_DRAWEE\' | translate }}</label> <input type=\"text\" name=\"message_to_payer\" maxlength=\"80\" ng-model=\"vm.bank_slip_rule.message_to_payer\" ng-disabled=\"!vm.editable\"></md-input-container></div></md-content><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 30px; margin-top: 10px\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Mensagem automática de inadimplência</b> <small>Abaixo se encontra as opções para configuração das mensagens de inadimplência</small></div></div><md-content><div layout=\"column\" style=\"margin-left: 30px;\"><md-radio-group ng-model=\"vm.bank_slip_rule.default_detail_method\" class=\"md-primary\" ng-disabled=\"!vm.editable\"><md-radio-button value=\"1\">Não apresenta informações de inadimplência no boleto</md-radio-button><md-radio-button value=\"2\">Informa apenas a quantidade de boletos em aberto</md-radio-button><md-radio-button value=\"3\">Detalha a inadimplência no boleto</md-radio-button></md-radio-group></div></md-content><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 10px; margin-top: 10px\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Permanência</b> <small>Abaixo se encontra as configurações de permanência do boleto</small></div></div><md-content layout=\"column\"><div style=\"margin-left: 20px\"><md-radio-group ng-model=\"vm.bank_slip_rule.permanence_type\" class=\"md-primary\" ng-disabled=\"!vm.editable\"><md-radio-button value=\"1\">Data limite após vencimento</md-radio-button><md-radio-button value=\"2\">Dias após vencimento</md-radio-button></md-radio-group></div><div style=\"margin-left: 20px\" ng-if=\"vm.bank_slip_rule.permanence_type == 1\"><date-picker placeholder=\"Data Limite de Permanência\" disabled=\"!vm.editable\" required=\"vm.bank_slip_rule.permanence_type == 1\" ng-model=\"vm.bank_slip_rule.permanence_limit_date\"></date-picker></div><div style=\"margin-left: 20px\" ng-if=\"vm.bank_slip_rule.permanence_type == 2\"><md-input-container class=\"md-block input-container\" flex=\"\"><label>{{ \'Dias de permanência\' | translate }}</label> <input type=\"number\" name=\"permanence_days\" maxlength=\"2\" ng-required=\"vm.bank_slip_rule.permanence_type == 2\" ng-model=\"vm.bank_slip_rule.permanence_days\" ng-disabled=\"!vm.editable\"><div ng-messages=\"formAdditions.permanence_days.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'Dias de permanencia é obrigatório\' | translate }}</span></div></div></md-input-container></div></md-content><div layout=\"row\" style=\"border-left: solid 4px rgb(7,179,103); margin-bottom: 10px; margin-top: 10px\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Agrupamento de titulos</b> <small>Abaixo se encontra as opções para configuração de agrupamento de titulos em boleto</small></div></div><md-content layout=\"column\"><div style=\"margin-left: 20px\"><md-checkbox flex=\"100\" ng-model=\"vm.bank_slip_rule.is_show_details\" aria-label=\"Detalha títulos\" ng-disabled=\"!vm.editable\">Detalha no boleto quais títulos o compõem ?</md-checkbox><md-checkbox flex=\"100\" ng-model=\"vm.bank_slip_rule.is_aggregate_bills\" aria-label=\"Faz a união de titulos de uma pessoa\" ng-disabled=\"!vm.editable\">Faz a união de titulos de uma pessoa ?<br><div style=\"width: 650px;\"><small>Condicionados a mesma data de vencimento, os titulos de uma pessoa serão agrupados em apenas um boleto</small></div></md-checkbox><md-checkbox flex=\"100\" ng-model=\"vm.bank_slip_rule.is_aggregate_beneficiaries\" style=\"margin-left: 13px\" aria-label=\"Faz a união de titulos de uma pessoa\" ng-disabled=\"!vm.editable\">Faz a união de titulos dos beneficiarios de uma pessoa ?<br><div style=\"width: 650px;\"><small>Condicionados a mesma data de vencimento, os titulos todos os beneficiarios de uma pessoa serão agrupados em apenas um boleto</small></div></md-checkbox></div></md-content><footer layout=\"row\" layout-align=\"space-between center\" class=\"layout-align-space-between-center layout-row\"><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" ng-disabled=\"$root.show_loader\" aria-label=\"{{ \'ADDITIONS.FORM_SUBMIT\' | translate }}\"><md-progress-circular ng-if=\"$root.show_loader\" style=\"float: left; top: 8px;\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span ng-hide=\"vm.bank_slip_rule.id == null || !vm.editable\" translate=\"ADDITIONS.FORM_UPDATE_SUBMIT\"></span> <span ng-show=\"vm.bank_slip_rule.id == null\" translate=\"ADDITIONS.FORM_CREATE_SUBMIT\"></span></md-button></footer></div></form></md-content>");
$templateCache.put("app/finance/cashier-session/guest-check-pad/view/checks.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\"><form name=\"form\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Lista de cheques</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 150px; min-width: 400px;\" layout=\"column\"><div style=\"margin: 0 auto; margin-left: 45%\" ng-if=\"vm.checks.length == 0\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-table-container style=\"padding-bottom: 0;\" ng-if=\"vm.checks.length > 0\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.tableItemsSelected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Status</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Número</span></th><th md-column=\"\"><span>Banco</span></th><th md-column=\"\" md-numeric=\"\"><span>Valor (R$)</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.checks track by $index\" md-select=\"item\" md-select-id=\"name\" class=\"a4-grid-tr-hover-ripple\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\"><span class=\"status label-{{item.check_status_id}}\">{{item.check_status_name}}</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\">{{item.date | date:\'dd/MM/yyyy\'}}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\"><span><b>{{item.number}}</b></span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\" class=\"md-table-menu\">{{item.bank_name}}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\" class=\"md-table-menu\">{{item.final_value | currency: \" \"}}</td></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Voltar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-disabled=\"form.$invalid\" ng-click=\"vm.submit(vm.tableItemsSelected);\">Selecionar títulos</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/cashier-session/guest-check-pad/view/financial-statement.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\"><form name=\"form\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Ficha financeira</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 150px; min-width: 400px;\" layout=\"column\"><div style=\"margin: 0 auto; margin-left: 45%\" ng-if=\"vm.bills.length == 0\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-table-pagination flex=\"\" style=\"border-top: none\" ng-if=\"vm.bills.data.length > 0\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.bills.per_page\" md-page=\"vm.bills.current_page\" md-on-paginate=\"vm.init\" md-limit-options=\"[12, 25, 50, 75, 100]\" md-total=\"{{vm.bills.total}}\"></md-table-pagination><md-table-container style=\"padding-bottom: 0;\" ng-if=\"vm.bills.data.length > 0\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.tableItemsSelected\"><thead md-head=\"\" md-order=\"vm.bills.order\" md-on-reorder=\"vm.order\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"due_date\"><span>Vencimento</span></th><th md-column=\"\"><span>Pessoa</span></th><th md-column=\"\"><span>Descrição</span></th><th md-column=\"\" md-numeric=\"\"><span>Valor (R$)</span></th><th md-column=\"\"><span>Status</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.bills.data track by $index\" md-select=\"item\" md-select-id=\"name\" class=\"a4-grid-tr-hover-ripple\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\">{{ item.due_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\"><div><b>{{ item.person_name }}</b></div><small>{{item.beneficiary_name}}</small></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-table-menu\">{{ item.product_name }} <span style=\"padding: 3px;background-color: rgb(8,204,117);color: white;border-radius: 5px;font-size: 11px;\" ng-if=\"item.instalment_name != null && item.instalment_name != \'\'\">{{item.instalment_name }} {{item.product_name}}</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\" class=\"md-table-menu\" ng-if=\"item.is_inaccurate_amount_view\">~ {{ item.final_value | currency:\"\" }}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\" class=\"md-table-menu\" ng-if=\"!item.is_inaccurate_amount_view\">{{ item.final_value | currency:\"\" }}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" class=\"md-card-list-item-avatar-wrapper md-table-menu\"><span class=\"bill-status {{ item.status_name }}\"><md-tooltip ng-if=\"item.payments\" md-direction=\"right\">{{item.payments}}</md-tooltip>{{(item.status_name).replace(\'_\', \' \')}}</span></td></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Voltar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-disabled=\"form.$invalid\" ng-click=\"vm.submit(vm.tableItemsSelected);\">Selecionar títulos</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/cashier-session/guest-check-pad/view/index.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background-color: whitesmoke\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to Caixa\" ui-sref=\"private.finance.cashier-session\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-list\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{\"GUEST_CHECK_PAD.NEW\" | translate}} {{ vm.currentPerson.name}}</span></div></div></md-toolbar><md-card layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" style=\"box-shadow: none;\"><md-content flex=\"25\" flex-sm=\"100\" flex-xs=\"100\" layout=\"column\" style=\"background-color: whitesmoke !important;\"><div ng-if=\"!vm.checkPolicies(\'adicionar_titulos_comanda\')\"><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" style=\"margin-left: 1px; height: 121px; flex: none;\" ng-click=\"vm.getLastBillOpened()\"><md-icon style=\"font-size: 30px\" md-font-icon=\"icon-numeric-1-box-multiple-outline\"></md-icon><div style=\"font-size: 16px\">Adicionar último titulo em aberto</div></md-card><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" style=\"margin-left: 1px; height: 121px; flex: none;\" ng-click=\"vm.getAllBillOpened()\"><md-icon style=\"font-size: 30px\" md-font-icon=\"icon-numeric-9-plus-box-multiple-outline\"></md-icon><div style=\"font-size: 16px\">Adicionar todos titulos em aberto</div></md-card><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" style=\"margin-left: 1px; height: 121px; flex: none;\" ng-click=\"vm.openFinancialStatement()\"><md-icon style=\"font-size: 30px\" md-font-icon=\"icon-chart-line\"></md-icon><div style=\"font-size: 16px\">Ver ficha financeira</div></md-card></div><md-card flex=\"\" class=\"text-center btn-check md-ink-ripple\" style=\"margin-left: 1px; height: 121px; flex: none;\" ng-if=\"!vm.checkPolicies(\'resgatar_cheques\')\" ng-click=\"vm.openChecksList()\"><md-icon style=\"font-size: 30px\" md-font-icon=\"icon-cash-multiple\"></md-icon><div style=\"font-size: 16px\">Resgate de cheques</div></md-card><div ng-style=\"{\'order\': !checkPolicies(\'Adicionar títulos à comanda\') ? \'5\' : \'1\'}\" ng-if=\"!vm.checkPolicies(\'adicionar_produtos_comanda\')\"><md-card class=\"text-center btn-check md-ink-ripple\" style=\"margin-left: 1px; height: 122px; flex: none;\" ng-click=\"vm.selectProductToCheckPad()\"><md-icon style=\"font-size: 30px\" md-font-icon=\"icon-cube-outline\"></md-icon><div style=\"font-size: 16px\">Adicionar produto a comanda</div></md-card></div></md-content><md-content flex=\"\" style=\"background-color: whitesmoke !important;\" flex-sm=\"100\" flex-xs=\"100\"><md-card style=\"min-height: 650px; max-height: 650px; margin-right: 1px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex=\"\" md-truncate=\"\">Comanda</h2><md-button aria-label=\"Pagar\" ng-click=\"vm.checkoutPay()\"><md-icon>shopping_cart</md-icon>Pagar comanda</md-button><md-button ng-if=\"vm.has_debit\" ng-click=\"vm.openAddDifferencesModal()\"><md-icon>add_circle_outline</md-icon><span ng-if=\"vm.has_debit\">Adicionar título de diferença</span></md-button></div></md-toolbar><md-content flex=\"100\"><md-table-container><table md-table=\"\" md-row-select=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Descrição</span></th><th md-column=\"\"><span>Pessoa</span></th><th md-column=\"\" ng-if=\"vm.currentPerson.is_responsible === 1 || vm.currentPerson.is_payee === 1\">Beneficiário</th><th md-column=\"\"><span>Vencimento</span></th><th md-column=\"\"><span>Quantidade</span></th><th md-column=\"\"><span policy-access=\"discount\">Desconto</span></th><th md-column=\"\" md-numeric=\"\"><span>Valor total (R$)</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.checkpad track by $index\"><td md-cell=\"\" md-truncate=\"\" flex=\"\" ng-if=\"item.type !== 3 && item.type !== 2\">{{ item.description || item.description_view}}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" ng-if=\"item.type === 3\">Título de crédito (-)</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" ng-if=\"item.type === 2\">Título de diferença (+)</td><td md-cell=\"\" md-truncate=\"\" flex=\"\"><span class=\"td-first-line\">{{ item.person_name }}</span> <span class=\"td-second-line\">{{ item.name_second_line }}</span></td><td md-cell=\"\" md-truncate=\"\" flex=\"\">{{item.beneficiary_name}}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\">{{ item.due_date | date:\"dd/MM/yyyy\" }}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.addProduct(item)\" ng-if=\"item.quantity !== null && item.type !== 2 && item.type !== 3\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">Adicionar um produto</md-tooltip></md-button>{{ item.quantity == null ? null : item.quantity }}<md-button class=\"md-icon-button\" ng-click=\"vm.removeProduct(item)\" ng-if=\"item.quantity !== null && item.type !== 2 && item.type !== 3\"><md-icon md-font-icon=\"icon-window-minimize\"></md-icon><md-tooltip md-direction=\"left\">Remover um produto</md-tooltip></md-button></td><td md-cell=\"\" md-truncate=\"\" flex=\"\"><md-input-container ng-if=\"item.productDiscount >= 0\" policy-access=\"discount\"><input ng-model=\"item.productDiscount\" ng-change=\"vm.changeProductFinalValue(item)\" ui-money-mask=\"2\"></md-input-container></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\">{{ (item.final_value || item.price) | currency:\" \" }}</td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeItemFromGuestPad(item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip md-direction=\"right\">Remover</md-tooltip></md-button></td></tr><tr md-row=\"\" ng-if=\"vm.checkpad.length == 0\"><td md-cell=\"\" md-truncate=\"\" flex=\"\">Não há items na comanda</td><td md-cell=\"\" md-truncate=\"\" flex=\"\"></td><td md-cell=\"\" md-truncate=\"\" flex=\"\"></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\"></td><td md-cell=\"\" md-truncate=\"\" flex=\"\" md-numeric=\"\"></td></tr></tbody></table></md-table-container></md-content><md-card-actions layout=\"row\" layout-align=\"end space-between\" style=\"height: 80px;\"><div flex=\"\" align=\"left\"></div><div flex=\"\" align=\"right\" style=\"margin-right: 22px\"><md-button ng-disabled=\"true\"><b>Total :</b> {{vm.getTotal(vm.checkpad) | currency:\" \"}}</md-button></div></md-card-actions></md-card></md-content></md-card><md-content flex=\"\" ng-if=\"vm.items.checks.length > 0\" style=\"z-index: 999999999\"><md-subheader class=\"md-primary\">Cheques</md-subheader><div class=\"check-place\"><div id=\"page-material-table3\" class=\"page-layout simple left-sidenav inner-sidenav\"><md-list class=\"contacts-list\" flex=\"\"><div class=\"main scrollable\" ms-scroll=\"\"><div class=\"md-card-list-wrapper\" id=\"bill-box2\"><div class=\"uk-width-large-8-10 uk-container-center\"><div class=\"md-card-list\"><ul hierarchical-slide=\"\"><li ng-repeat=\"item in vm.items.checks\" on-last-repeat=\"\" class=\"{{ item.status_name }}\"><div layout=\"row\"><div class=\"md-card-list-item-select\"><md-checkbox ng-model=\"vm.imp2\" aria-label=\"Checkbox 1\" ng-change=\"vm.setOnCar(item)\"></md-checkbox></div><span flex=\"15\" flex-xs=\"20\" flex-md=\"25\" class=\"md-card-list-item-avatar-wrapper\"><span class=\"status label-{{item.check_status_id}}\">{{item.check_status_name}}</span></span> <span flex=\"15\" flex-xs=\"15\" flex-md=\"15\" flex-sm=\"15\" class=\"md-card-list-item-date\">{{item.date | date:\'dd/MM/yyyy\'}}</span><div flex=\"15\" flex-xs=\"15\" flex-md=\"15\" flex-sm=\"15\" class=\"md-card-list-item-date\"><span><b>N.º {{item.number}}</b></span></div><span flex=\"25\" flex-xs=\"25\" flex-md=\"15\" flex-sm=\"20\" class=\"md-card-list-item\">{{item.bank_name}}</span><div flex=\"10\" flex-sm=\"10\" flex-xs=\"10\" class=\"md-card-list-item-avatar-wrapper md-card-list-item-amount\"><strong>{{item.final_value | currency}}</strong></div></div></li></ul></div></div></div></div></md-list></div></div></md-content></div>");
$templateCache.put("app/finance/cashier-session/guest-check-pad/view/selectProduct.html","<md-dialog aria-label=\"Create Subject\" md-theme=\"finance\"><form name=\"form\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Selecionar produto</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><label ng-if=\"vm.currentPerson.is_responsible === 1 || vm.currentPerson.is_payee === 1\" style=\"font-size: 14px; font-style: italic; padding-top: 3%; padding-left: 3%\" layout=\"row\">Selecione um beneficiário*</label><div layout-padding=\"\" layout=\"row\" ng-if=\"vm.currentPerson.is_responsible === 1 || vm.currentPerson.is_payee === 1\"><md-radio-group ng-model=\"vm.selected_student\"><div ng-repeat=\"student in vm.students\"><md-radio-button ng-value=\"student\" aria-label=\"Selecione {{student.name}}\">{{student.name}}</md-radio-button></div></md-radio-group></div><md-input-container style=\"width: 100%;\" layout=\"row\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchProduct\" placeholder=\"Pesquise pelo nome do produto\" ng-change=\"vm.filterProducts(vm.searchProduct)\"></md-input-container><md-dialog-content style=\"min-height: 150px; min-width: 400px; padding: 0;\" layout=\"column\"><md-table-container><table md-table=\"\" md-row-select=\"\" ng-model=\"vm.productSelected\" multiple=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Preço</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.products track by $index\" md-select=\"item.id\" ng-disabled=\"vm.blockOutOfStockSales && item.balance < 1\" style=\"pointer-events: visible\"><td md-cell=\"\" md-truncate=\"\" flex=\"\">{{ item.name }}<md-icon md-font-icon=\"icon-alert\" ng-disabled=\"false\" ng-if=\"vm.blockOutOfStockSales && item.balance <= 0\"><md-tooltip>Produto sem estoque</md-tooltip></md-icon></td><td md-cell=\"\" md-truncate=\"\" flex=\"\">{{ item.price | currency:\" \" }}</td></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Voltar</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warm\" ng-disabled=\"form.$invalid\" ng-click=\"vm.submit(vm.productSelected);\">Adicionar na comanda</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/account_custody.html","<md-dialog class=\"check-received\" aria-label=\"Deposito em conta\" style=\"max-width: 1000px; width: 1000px\"><form name=\"custodyForm\" ng-submit=\"vm.answer(vm.custody, custodyForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Depósito em conta</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><h3>Cheques disponíveis</h3><md-divider></md-divider><div class=\"content layout-column\"><div layout=\"column\"><md-table-container class=\"overflow-table-a4\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.custody.checkList\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Nº do Cheque</th><th md-column=\"\">Banco</th><th md-column=\"\">Conta</th><th md-column=\"\">Valor</th><th md-column=\"\">Detalhes</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-auto-select=\"\" md-select-id=\"item\" ng-repeat=\"item in vm.data.checkAvailable\"><td md-cell=\"\">{{item.date}}</td><td md-cell=\"\">{{item.number}}</td><td md-cell=\"\">{{item.bank_name}}</td><td md-cell=\"\">{{item.account}}</td><td md-cell=\"\">{{item.amount | currency}}</td><td md-cell=\"\"><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Refresh\"><md-tooltip md-direction=\"left\">Status: {{item.check_status_name}} Localização: {{item.current_account_name}}</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"[1000]\" md-page=\"vm.query.page\" md-total=\"{{vm.data.checkAvailable.length}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div></div><div layout=\"row\"><md-input-container flex=\"\"><label>Conta destino</label><md-select ng-model=\"vm.custody.current_account_destine\" name=\"account_destine\"><md-option ng-repeat=\"item in vm.current_accounts_bank\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div class=\"errors\" ng-messages=\"custodyForm.account_destine.$error\"><div ng-message=\"required\">Por favor, escolha uma conta de destino.</div></div></md-input-container><md-input-container flex=\"\"><label>Data da custódia</label><md-datepicker ng-model=\"vm.custody.date\" name=\"date\" md-open-on-focus=\"\"></md-datepicker><div class=\"errors\" ng-messages=\"discountForm.date.$error\"><div ng-message=\"required\">Por favor, selecione a data do depósito.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" style=\"margin-right:20px;\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/account_deposite.html","<md-dialog class=\"check-received\" aria-label=\"Deposito em conta\" style=\"max-width: 1000px; width: 1000px\"><form name=\"retrieveForm\" ng-submit=\"vm.answer(vm.aDeposite, retrieveForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Depósito em conta</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><h3>Cheques disponíveis</h3><md-divider></md-divider><div class=\"content layout-column\"><div layout=\"column\"><md-table-container class=\"overflow-table-a4\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.aDeposite.checkList\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Nº do Cheque</th><th md-column=\"\">Banco</th><th md-column=\"\">Conta</th><th md-column=\"\">Valor</th><th md-column=\"\">Detalhes</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-auto-select=\"\" md-select-id=\"item\" ng-repeat=\"item in vm.data.checkAvailable\"><td md-cell=\"\">{{vm.convertDate(item.date)}}</td><td md-cell=\"\">{{item.number}}</td><td md-cell=\"\">{{item.bank_name}}</td><td md-cell=\"\">{{item.account}}</td><td md-cell=\"\">{{item.amount | currency}}</td><td md-cell=\"\"><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Refresh\"><md-tooltip md-direction=\"left\"><b>Status:</b> {{item.check_status_name}} | <b>Localização:</b> {{item.current_account_name}}</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"[1000]\" md-page=\"vm.query.page\" md-total=\"{{vm.data.checkAvailable.length}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div></div><div layout=\"row\"><md-input-container flex=\"\"><label>Conta destino</label><md-select ng-model=\"vm.aDeposite.current_account_destine\" name=\"account_destine\" required=\"\"><md-option ng-repeat=\"item in vm.current_accounts_bank\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div class=\"errors\" ng-messages=\"retrieveForm.account_destine.$error\"><div ng-message=\"required\">Por favor, escolha uma conta de destino.</div></div></md-input-container><md-input-container flex=\"\"><label>Data do depósito</label><md-datepicker ng-model=\"vm.aDeposite.date\" name=\"date\" required=\"\" md-open-on-focus=\"\"></md-datepicker><div class=\"errors\" ng-messages=\"retrieveForm.date.$error\"><div ng-message=\"required\">Por favor, selecione a data do depósito.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" style=\"margin-right:20px;\">Depositar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/account_transfer.html","<md-dialog class=\"check-received\" aria-label=\"Deposito em conta\" style=\"max-width: 1000px; width: 1000px\"><form name=\"transferForm\" ng-submit=\"vm.answer(vm.aTransfer, transferForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Transferência de conta</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><h3>Cheques disponíveis</h3><md-divider></md-divider><div class=\"content layout-column\"><div layout=\"column\"><md-table-container class=\"overflow-table-a4\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.aTransfer.checkList\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Nº do Cheque</th><th md-column=\"\">Banco</th><th md-column=\"\">Conta</th><th md-column=\"\">Valor</th><th md-column=\"\">Detalhes</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-auto-select=\"\" md-select-id=\"item\" ng-repeat=\"item in vm.data.checkAvailable\"><td md-cell=\"\">{{vm.convertDate(item.date)}}</td><td md-cell=\"\">{{item.number}}</td><td md-cell=\"\">{{item.bank_name}}</td><td md-cell=\"\">{{item.account}}</td><td md-cell=\"\">{{item.amount | currency}}</td><td md-cell=\"\"><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Refresh\"><md-tooltip md-direction=\"left\"><b>Status:</b> {{item.check_status_name}} | <b>Localização:</b> {{item.current_account_name}}</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"[1000]\" md-page=\"vm.query.page\" md-total=\"{{vm.data.checkAvailable.length}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div></div><div layout=\"row\"><md-input-container flex=\"\"><label>Conta destino</label><md-select ng-model=\"vm.aTransfer.current_account_destine\" name=\"account_destine\" required=\"\"><md-option ng-repeat=\"item in vm.current_accounts_bank\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div class=\"errors\" ng-messages=\"transferForm.account_destine.$error\"><div ng-message=\"required\">Por favor, escolha uma conta de destino.</div></div></md-input-container><md-input-container flex=\"\"><label>Data da transferência</label><md-datepicker ng-model=\"vm.aTransfer.date\" name=\"date\" required=\"\" md-open-on-focus=\"\"></md-datepicker><div class=\"errors\" ng-messages=\"transferForm.date.$error\"><div ng-message=\"required\">Por favor, selecione a data da transferência.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" style=\"margin-right:20px;\">Transferir</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/bank_devolution.html","<md-dialog class=\"check-received\" aria-label=\"Deposito em conta\" style=\"max-width: 1000px; width: 1000px\"><form name=\"devolutionForm\" ng-submit=\"vm.answer(vm.devolution, devolutionForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Devolução bancária</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><h3>Cheques disponíveis</h3><md-divider></md-divider><div class=\"content layout-column\"><div layout=\"column\"><md-table-container class=\"overflow-table-a4\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.devolution.checkList\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Nº do Cheque</th><th md-column=\"\">Banco</th><th md-column=\"\">Conta</th><th md-column=\"\">Valor</th><th md-column=\"\">Detalhes</th><th md-column=\"\">Problema</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-auto-select=\"\" md-select-id=\"item\" ng-repeat=\"item in vm.data.checkAvailable\"><td md-cell=\"\">{{vm.convertDate(item.date)}}</td><td md-cell=\"\">{{item.number}}</td><td md-cell=\"\">{{item.bank_name}}</td><td md-cell=\"\">{{item.account}}</td><td md-cell=\"\">{{item.amount | currency}}</td><td md-cell=\"\"><md-input-container><label>Problema do cheque</label><md-select ng-model=\"item.check_issue_id\"><md-option ng-repeat=\"issue in vm.check_issues\" ng-value=\"issue.id\">{{issue.name}}</md-option></md-select></md-input-container></td><td md-cell=\"\"><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Refresh\"><md-tooltip md-direction=\"left\"><b>Status:</b> {{item.check_status_name}} | <b>Localização:</b> {{item.current_account_name}}</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"[1000]\" md-page=\"vm.query.page\" md-total=\"{{vm.data.checkAvailable.length}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div></div><div layout=\"row\"><md-input-container flex=\"\"><label>Conta destino</label><md-select ng-model=\"vm.devolution.current_account_destine\" name=\"account_destine\" required=\"\"><md-option ng-repeat=\"item in vm.current_accounts\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div class=\"errors\" ng-messages=\"withdrawForm.account_destine.$error\"><div ng-message=\"required\">Por favor, escolha uma conta de destino.</div></div></md-input-container><md-input-container flex=\"\"><label>Data do depósito</label><md-datepicker ng-model=\"vm.devolution.date\" name=\"date\" required=\"\" md-open-on-focus=\"\"></md-datepicker><div class=\"errors\" ng-messages=\"withdrawForm.date.$error\"><div ng-message=\"required\">Por favor, selecione a data do depósito.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" style=\"margin-right:20px;\">Sacar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/bank_discount.html","<md-dialog class=\"check-received\" aria-label=\"Desconto Bancário\" style=\"max-width: 1000px; width: 1000px\"><form name=\"discountForm\" ng-submit=\"vm.answer(vm.discount, discountForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Desconto Bancário</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><h3>Cheques disponíveis</h3><md-divider></md-divider><div class=\"content layout-column\"><div layout=\"column\"><md-table-container class=\"overflow-table-a4\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.discount.checkList\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Nº do Cheque</th><th md-column=\"\">Banco</th><th md-column=\"\">Conta</th><th md-column=\"\">Valor</th><th md-column=\"\">Detalhes</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-auto-select=\"\" md-select-id=\"item\" ng-repeat=\"item in vm.data.checkAvailable\"><td md-cell=\"\">{{vm.convertDate(item.date)}}</td><td md-cell=\"\">{{item.number}}</td><td md-cell=\"\">{{item.bank_name}}</td><td md-cell=\"\">{{item.account}}</td><td md-cell=\"\">{{item.amount | currency}}</td><td md-cell=\"\"><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Refresh\"><md-tooltip md-direction=\"left\"><b>Status:</b> {{item.check_status_name}} | <b>Localização:</b> {{item.current_account_name}}</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"[1000]\" md-page=\"vm.query.page\" md-total=\"{{vm.data.checkAvailable.length}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div></div><div layout=\"row\"><md-input-container flex=\"\"><label>Conta destino</label><md-select ng-model=\"vm.discount.current_account_destine\" required=\"\" name=\"account_destine\"><md-option ng-repeat=\"item in vm.current_accounts_bank\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div class=\"errors\" ng-messages=\"discountForm.account_destine.$error\"><div ng-message=\"required\">Por favor, escolha uma conta de destino.</div></div></md-input-container><md-input-container flex=\"\"><label>Data do desconto</label><md-datepicker ng-model=\"vm.discount.date\" name=\"date\" md-min-date=\"vm.min_date\" required=\"\" md-open-on-focus=\"\"></md-datepicker><div class=\"errors\" ng-messages=\"discountForm.date.$error\"><div ng-message=\"required\">Por favor, selecione a data do depósito.</div></div></md-input-container><md-input-container flex=\"\"><label>Taxa do desconto</label> <input ng-model=\"vm.discount.discount_tax\" name=\"discount_tax\" type=\"text\" required=\"\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\"><div class=\"errors\" ng-messages=\"discountForm.discount_tax.$error\"><div ng-message=\"required\">Por favor, adicione o valor da taxa do desconto.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" style=\"margin-right:20px;\">Descontar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/bordero_discount.html","<md-dialog class=\"check-received\" aria-label=\"Valor recebido no desconto\" style=\"max-width: 300px; width: 300px\"><form name=\"retrieveForm\" ng-submit=\"vm.answer(vm.discount, retrieveForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Valor recebido no desconto</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><div layout=\"row\"><md-input-container flex=\"\"><label>Valor</label> <input type=\"text\" name=\"amount\" ng-maxlength=\"20\" autocomplete=\"off\" ng-model=\"vm.discount.amount\" ng-change=\"vm.verifyDiscount(vm.discount.amount, vm.data.totalChecks)\" ui-money-mask=\"2\" required=\"\"><div class=\"errors\" ng-messages=\"retrieveForm.amount.$error\"><div ng-message=\"required\">Por favor, informe o valor do desconto.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" ng-disabled=\"!vm.verifyValue\" style=\"margin-right:20px;\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/change_due_date.html","<md-dialog class=\"check-received change-due-date\" aria-label=\"Reprogramar data de vencimento\"><form name=\"change_due_date\" ng-submit=\"vm.confirm(vm.current_check, vm.due_date, change_due_date)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Reprogramar data de vencimento</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><div layout=\"column\"><div flex=\"\"><md-datepicker class=\"container-date\" name=\"due_date\" ng-model=\"vm.due_date\" placeholder=\"Data de vencimento\" md-min-date=\"min_date\" flex=\"100\"></md-datepicker></div><div flex=\"\"></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.cancel()\">Cancelar</md-button><md-button type=\"submit\" ng-disabled=\"vm.process\" style=\"margin-right:20px;\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/check_description.html","<md-dialog class=\"check-received change-status\" aria-label=\"Adicionar observações\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar observações</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><div layout=\"column\"><div flex=\"\"><md-input-container class=\"container-full\" flex=\"100\"><label>Observações</label> <textarea rows=\"1\" name=\"description\" ng-model=\"current_check.notes\" flex=\"100\"></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"cancel()\">Cancelar</md-button><md-button ng-click=\"confirm(current_check.check_id, current_check.notes)\" style=\"margin-right:20px;\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/operation_origin.html","<md-dialog class=\"check-received change-due-date\" aria-label=\"Operação de origem\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Operação de origem</h2></div></md-toolbar><md-dialog-content class=\"check-dialog\"><div layout=\"column\"><div flex=\"\"></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"cancel()\">Fechar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/retrieve_check.html","<md-dialog class=\"check-received\" aria-label=\"Extravio de cheque\" style=\"max-width: 1000px; width: 1000px\"><form name=\"retrieveForm\" ng-submit=\"vm.answer(vm.obj, retrieveForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Extravio de cheque</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><h3>Cheques disponíveis</h3><md-divider></md-divider><div class=\"content layout-column\"><div layout=\"column\"><md-table-container class=\"overflow-table-a4\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.obj.checkList\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Nº do Cheque</th><th md-column=\"\">Banco</th><th md-column=\"\">Conta</th><th md-column=\"\">Valor</th><th md-column=\"\">Detalhes</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-auto-select=\"\" md-select-id=\"item\" ng-repeat=\"item in vm.data.checkAvailable\"><td md-cell=\"\">{{vm.convertDate(item.date)}}</td><td md-cell=\"\">{{item.number}}</td><td md-cell=\"\">{{item.bank_name}}</td><td md-cell=\"\">{{item.account}}</td><td md-cell=\"\">{{item.amount | currency}}</td><td md-cell=\"\"><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Refresh\"><md-tooltip md-direction=\"left\"><b>Status:</b> {{item.check_status_name}} | <b>Localização:</b> {{item.current_account_name}}</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"[1000]\" md-page=\"vm.query.page\" md-total=\"{{vm.data.checkAvailable.length}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div></div><div layout=\"row\"><md-input-container flex=\"50\"><input id=\"search\" placeholder=\"Observação\" type=\"text\" ng-model=\"vm.obj.notes\"></md-input-container><md-input-container flex=\"50\"><label>Data</label><md-datepicker ng-model=\"vm.obj.date\" name=\"date\" required=\"\" md-open-on-focus=\"\"></md-datepicker><div class=\"errors\" ng-messages=\"retrieveForm.date.$error\"><div ng-message=\"required\">Por favor, selecione a data do extravio.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" style=\"margin-right:20px;\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/dialogs/withdraw_check.html","<md-dialog class=\"check-received\" aria-label=\"Deposito em conta\" style=\"max-width: 1000px; width: 1000px\"><form name=\"withdrawForm\" ng-submit=\"vm.answer(vm.withdraw, withdrawForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Saque de cheques</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><h3>Cheques disponíveis</h3><md-divider></md-divider><div class=\"content layout-column\"><div layout=\"column\"><md-table-container class=\"overflow-table-a4\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.withdraw.checkList\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Data</th><th md-column=\"\">Nº do Cheque</th><th md-column=\"\">Banco</th><th md-column=\"\">Conta</th><th md-column=\"\">Valor</th><th md-column=\"\">Detalhes</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-auto-select=\"\" md-select-id=\"item\" ng-repeat=\"item in vm.data.checkAvailable\"><td md-cell=\"\">{{vm.convertDate(item.date)}}</td><td md-cell=\"\">{{item.number}}</td><td md-cell=\"\">{{item.bank_name}}</td><td md-cell=\"\">{{item.account}}</td><td md-cell=\"\">{{item.amount | currency}}</td><td md-cell=\"\"><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Refresh\"><md-tooltip md-direction=\"left\"><b>Status:</b> {{item.check_status_name}} | <b>Localização:</b> {{item.current_account_name}}</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"[1000]\" md-page=\"vm.query.page\" md-total=\"{{vm.data.checkAvailable.length}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div></div><div layout=\"row\"><md-input-container flex=\"\"><label>Conta destino</label><md-select ng-model=\"vm.withdraw.current_account_destine\" name=\"account_destine\" required=\"\"><md-option ng-repeat=\"item in vm.current_accounts\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div class=\"errors\" ng-messages=\"withdrawForm.account_destine.$error\"><div ng-message=\"required\">Por favor, escolha uma conta de destino.</div></div></md-input-container><md-input-container flex=\"\"><label>Data do depósito</label><md-datepicker ng-model=\"vm.withdraw.date\" name=\"date\" required=\"\" md-open-on-focus=\"\"></md-datepicker><div class=\"errors\" ng-messages=\"withdrawForm.date.$error\"><div ng-message=\"required\">Por favor, selecione a data do depósito.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" style=\"margin-right:20px;\">Sacar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/check-received/views/sidenavs/sidenav.html","test");
$templateCache.put("app/finance/current-account/views/dialogs/account_balance.html","<form><md-content class=\"check-dialog\"><table class=\"md-api-table\"><thead><tr><th class=\"hide-data\"></th><th class=\"hide-data\"></th></tr></thead><tbody><tr><td class=\"hide-data\">Saldo da conta corrente</td><td class=\"hide-data\">{{ (vm.balance.total_balance) ? vm.applyMask(vm.balance.total_balance) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Cheques emitidos e ainda não compensados</td><td class=\"hide-data\" ng-class=\"{\'negativeValue\' : vm.balance.total_checks_own_unpaid > 0}\">{{ (vm.balance.total_checks_own_unpaid) ? vm.applyMask(vm.balance.total_checks_own_unpaid) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Saldo potencial</td><td class=\"hide-data\">{{ (vm.balance.total_potential_balance) ? vm.applyMask(vm.balance.total_potential_balance) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Saldo bloqueado no dia</td><td class=\"hide-data\">{{ (vm.balance.total_check_balance.checks_locked_today) ? vm.applyMask(vm.balance.total_check_balance.checks_locked_today) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Saldo total</td><td class=\"hide-data\">{{ (vm.balance.total_potential_locked_balance) ? vm.applyMask(vm.balance.total_potential_locked_balance) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Limite de crédito</td><td class=\"hide-data\">{{ (vm.balance.credit_limit) ? vm.applyMask(vm.balance.credit_limit) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Saldo disponível</td><td class=\"hide-data\">{{ (vm.balance.total_balance_available) ? vm.applyMask(vm.balance.total_balance_available) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Saldo bloqueado</td><td class=\"hide-data\">{{ (vm.balance.total_check_balance.checks_locked_one_day + vm.balance.total_check_balance.checks_locked_two_day) ? vm.applyMask(vm.balance.total_check_balance.checks_locked_one_day + vm.balance.total_check_balance.checks_locked_two_day) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Bloqueado 1 dia</td><td class=\"hide-data\">{{ (vm.balance.total_check_balance.checks_locked_one_day) ? vm.applyMask(vm.balance.total_check_balance.checks_locked_one_day) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Bloqueado 2 dia</td><td class=\"hide-data\">{{ (vm.balance.total_check_balance.checks_locked_two_day) ? vm.applyMask(vm.balance.total_check_balance.checks_locked_two_day) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Cheques em custódia</td><td class=\"hide-data\">{{ (vm.balance.total_check_balance.check_in_custody) ? vm.applyMask(vm.balance.total_check_balance.check_in_custody) : \'0,00\' }}</td></tr><tr><td class=\"hide-data\">Cheques que já deveriam ter compensado</td><td class=\"hide-data\">{{ (vm.balance.total_check_balance.checks_not_compensated) ? vm.applyMask(vm.balance.total_check_balance.checks_not_compensated) : \'0,00\' }}</td></tr></tbody></table></md-content></form>");
$templateCache.put("app/finance/current-account/views/dialogs/check_issued.html","<md-dialog class=\"check-received\" aria-label=\"Confirma a data\"><form name=\"retrieveForm\" ng-submit=\"vm.answer(vm.check , retrieveForm)\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Confirma a data?</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><div layout=\"row\"><md-input-container flex=\"\"><label>Data da conciliação</label><md-datepicker name=\"date\" ng-model=\"vm.check.date\" required=\"\" md-open-on-focus=\"\"></md-datepicker><div class=\"errors\" ng-messages=\"retrieveForm.date.$error\"><div ng-message=\"required\">Por favor, confirme a data da conciliação.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><small class=\"required-fields\"><strong>*</strong> Necessário</small> <span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" md-no-ink=\"\" class=\"md-primary\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/current-account/views/dialogs/compensation_credit.html","<md-dialog class=\"check-received\" aria-label=\"Deposito em conta\" style=\"max-width: 1000px; width: 1000px\"><form name=\"retrieveForm\" ng-submit=\"vm.answer(vm.credit , retrieveForm)\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Crédito de Compensação</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><input type=\"hidden\" name=\"id\" ng-if=\"vm.credit.id\"><div layout=\"row\"><md-input-container flex=\"\"><label>Data da compensação</label><date-picker name=\"date\" ng-model=\"vm.credit.date\" ng-change=\"vm.changeDateCompensation(vm.credit.date)\" required=\"\" md-open-on-focus=\"\"></date-picker><div class=\"errors\" ng-messages=\"retrieveForm.date.$error\"><div ng-message=\"required\">Por favor, selecione a data da compensação.</div></div></md-input-container><md-input-container flex=\"\"><label>Valor total</label> <input type=\"text\" name=\"amount\" ng-model=\"vm.credit.amount\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" placeholder=\"R$\" ng-change=\"vm.verifyValue(credit.amount)\" required=\"\"><div class=\"errors\" ng-messages=\"retrieveForm.amount.$error\"><div ng-message=\"required\">Por favor, informe o valor da compensação.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><small class=\"required-fields\"><strong>*</strong> Campos necessários</small> <span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" md-no-ink=\"\" class=\"md-primary\" ng-disabled=\"vm.credit.amount == 0\" ng-if=\"!vm.credit.id\">Creditar</md-button><md-button type=\"submit\" md-no-ink=\"\" class=\"md-primary\" ng-disabled=\"vm.credit.amount == 0\" ng-if=\"vm.credit.id\">Atualizar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/current-account/views/dialogs/file-batch.html","<md-dialog aria-label=\"Importar fotos em lote\" md-theme=\"finance\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Adicionar documentos</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-table-container style=\"width: 100%;\" ng-if=\"vm.files.length > 0\"><table md-table=\"\" ng-model=\"selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Ver</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.files\" ng-if=\"item.file_reference\"><td md-cell=\"\">{{item.name}}</td><td md-cell=\"\"><a target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + item.file_reference}}\">Ver arquivo</a></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteFile(item)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></md-table-container><div class=\"md-dialog-content\"><div flex=\"\" style=\"min-width: 500px\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div><md-progress-linear ng-if=\"vm.isProcessing\" md-mode=\"determinate\" value=\"{{vm.determinateValue}}\"></md-progress-linear></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/finance/current-account/views/sidenavs/account_entry.html","<div style=\"width: 700px\"><form name=\"formAccountEntry\" ng-init=\"vm.currentItem.tags = []\" ng-submit=\"vm.insertNewPaymentAndReceipt(formAccountEntry, vm.currentItem, vm.categorized, \'C\')\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex=\"\" md-truncate=\"\">Entrada de conta</h2><md-checkbox ng-model=\"vm.categorized\" aria-label=\"Checkbox 1\" ng-if=\"vm.bill_id == false\">Não categorizado</md-checkbox></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Informações Gerais\"><md-content class=\"md-padding\"><div ng-if=\"!vm.categorized\" class=\"form-wrapper padding-top-0 padding-bottom-0\"><div layout=\"row\" flex=\"\"><md-autocomplete flex=\"\" ng-init=\"vm.getPersons(vm.searchText)\" md-input-name=\"autocompleteField\" md-no-cache=\"true\" md-selected-item=\"vm.currentItem.person\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPersons(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-autofocus=\"\" md-require-match=\"\" md-floating-label=\"Pessoa\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><div ng-messages=\"formAccountEntry.autocompleteField.$error\" ng-if=\"formAccountEntry.autocompleteField.$touched\"><div ng-message=\"required\">Campo necessário</div></div><md-not-found>Nenhum registro encontrado para \"{{vm.searchText}}\".</md-not-found></md-autocomplete><md-input-container class=\"md-block\" flex=\"\"><label>Valor:</label> <input ng-maxlength=\"20\" autocomplete=\"off\" ng-model=\"vm.currentItem.amount\" ui-money-mask=\"2\" placeholder=\"Adicione um valor\" required=\"\"></md-input-container><date-picker ng-model=\"vm.currentItem.date\" ng-required=\"\" required=\"\"></date-picker></div><div layout=\"row\"><div flex=\"\" class=\"form-group\"><md-autocomplete flex=\"\" required=\"\" md-input-name=\"autoCategories\" md-selected-item=\"vm.currentItem.category\" md-no-cache=\"true\" md-search-text-change=\"vm.searchTextChange(vm.searchCategory)\" md-search-text=\"vm.searchCategory\" md-selected-item-change=\"vm.currentItem.category = item\" md-items=\"item in vm.querySearchCategory(vm.searchCategory)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Categoria\"><md-item-template><span class=\"item-title\"><span><strong>{{item.name}}</strong></span></span> <span class=\"item-metadata\"><span>{{item.path}}</span></span></md-item-template><div ng-messages=\"formProduct.autoCategories.$error\" ng-if=\"formProduct.autoCategories.$touched\"><div ng-message=\"required\">{{ \'CATEGORY_IS_REQUIRED\' | translate }}</div><div ng-message=\"md-require-match\">{{ \'CATEGORY_NOT_EXISTS\' | translate }}</div></div><md-not-found>{{ \'CATEGORY_NOT_FOUND\' | translate }}</md-not-found></md-autocomplete></div><div flex=\"\"><md-input-container class=\"md-block margin-bottom-0\" flex=\"\"><label>Descrição:</label> <input ng-model=\"vm.currentItem.description\" placeholder=\"Adicione uma descrição\"></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block margin-bottom-0\" flex=\"\"><label>Referência:</label> <input ng-model=\"vm.currentItem.document_reference\" placeholder=\"Adicione uma referência\"></md-input-container></div></div></div><div ng-if=\"vm.categorized\" class=\"form-wrapper\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Valor:</label> <input ng-maxlength=\"20\" autocomplete=\"off\" ng-model=\"vm.currentItem.amount\" ui-money-mask=\"2\" placeholder=\"Adicione um valor\" required=\"\"></md-input-container><md-input-container flex=\"\"><date-picker ng-model=\"vm.currentItem.date\" required=\"\"></date-picker></md-input-container></div></div><md-subheader class=\"md-primary padding-top-0\">Informações Bancárias</md-subheader><div class=\"form-wrapper padding-top-0 padding-bottom-0\"><div layout=\"row\"><md-input-container flex=\"\"><label>Conta</label><md-select ng-model=\"vm.currentItem.current_account\" required=\"\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.currentItem.method = null\" ng-disabled=\"true\" placeholder=\"Escolha a conta corrente\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.current_accounts\">{{item.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Método</label><md-select ng-model=\"vm.currentItem.method\" placeholder=\"Escolha o método\"><md-option ng-value=\"i.id\" ng-repeat=\"i in vm.methods track by $index\" ng-show=\"vm.filterMovementTypes(i.id, vm.currentItem.current_account.current_account_type_id)\">{{i.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentItem.method == 2\"><md-input-container flex=\"\" class=\"md-icon-float md-block\"><label>Entre com o número do cheque</label> <input name=\"name\" ng-model=\"vm.check_number\" type=\"text\" md-autofocus=\"\" ng-change=\"vm.readCheckNumber(vm.check_number, \'C\')\" maxlength=\"30\" ng-maxlength=\"30\" number-only=\"\"></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentItem.method == 2\"><md-autocomplete flex=\"\" required=\"\" ng-disabled=\"vm.isDisabled\" md-input-name=\"autoBank\" md-selected-item=\"vm.currentItem.bank\" md-no-cache=\"true\" md-search-text-change=\"vm.searchTextChange(vm.searchTextbank)\" md-search-text=\"vm.searchTextbank\" md-selected-item-change=\"vm.currentItem.bank = item\" md-items=\"item in vm.querySearchBank(vm.searchTextbank)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Banco\"><md-item-template><span>{{item.number_bank}} - <b>{{item.name}}</b></span></md-item-template><div ng-messages=\"formProduct.autoBank.$error\" ng-if=\"formProduct.autoBank.$touched\"><div ng-message=\"required\">{{ \'CATEGORY_IS_REQUIRED\' | translate }}</div><div ng-message=\"md-require-match\">{{ \'CATEGORY_NOT_EXISTS\' | translate }}</div></div><md-not-found>{{ \'CATEGORY_NOT_FOUND\' | translate }}</md-not-found></md-autocomplete><md-input-container class=\"md-block\" flex=\"\"><label>Agência:</label> <input maxlength=\"10\" ng-model=\"vm.currentItem.bank_branch\" numbers-only=\"\"></md-input-container></div><div layout=\"row\" ng-show=\"vm.currentItem.method == 2\"><md-input-container class=\"md-block margin-top-0 margin-bottom-0\" flex=\"\"><label>Conta:</label> <input maxlength=\"15\" ng-model=\"vm.currentItem.bank_account\"></md-input-container><md-input-container class=\"md-block margin-top-0 margin-bottom-0\" flex=\"\"><label>Cheque nº:</label> <input maxlength=\"15\" ng-model=\"vm.currentItem.document\"></md-input-container></div></div></md-content></md-tab><md-tab label=\"Informações complementares\"><md-content class=\"md-padding\"><div layout=\"row\" ng-if=\"!vm.categorized\" class=\"form-wrapper padding-top-0 padding-bottom-0\"><md-input-container flex=\"70\"><label>{{ \'COMPLEMENTS_NOTES\' | translate }}</label> <textarea ng-model=\"vm.currentItem.notes\" md-maxlength=\"150\" md-select-on-focus=\"\"></textarea></md-input-container><md-input-container flex=\"30\"><label>Competência</label><md-datepicker ng-model=\"vm.currentItem.accrual\" name=\"dateField\" md-mode=\"month\"></md-datepicker></md-input-container></div><md-subheader ng-if=\"!vm.categorized\" class=\"md-primary\">Marcadores e Arquivos</md-subheader><div ng-if=\"!vm.categorized\" layout=\"row\" class=\"form-wrapper padding-top-0 padding-bottom-0\"><md-chips flex=\"\" ng-model=\"vm.currentItem.tags\" md-enable-chip-edit=\"true\" placeholder=\"Adicionar marcador\" delete-hint=\"Pressione delete para remover\" md-separator-keys=\"vm.customKeys\"></md-chips></div><div layout=\"row\" class=\"form-wrapper\"><div flex=\"\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div><div layout=\"row\" class=\"form-wrapper\" ng-if=\"vm.currentItem.files.length > 0\" style=\"padding-top: 0\"><md-table-container style=\"width: 100%;\"><table md-table=\"\" ng-model=\"selected\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Ver</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.currentItem.files\" ng-if=\"item.file_reference\"><td md-cell=\"\">{{item.name_display || item.name}}</td><td md-cell=\"\"><a target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + item.file_reference}}\">Ver arquivo</a></td></tr></tbody></table></md-table-container></div></md-content></md-tab></md-tabs><md-divider></md-divider><div class=\"modal-a4\"><div layout=\"row\" class=\"form-wrapper\"><small class=\"required-fields\" flex=\"25\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\" flex=\"\"><md-button type=\"button\" align=\"left\" ng-if=\"vm.bill_id != false\" ng-click=\"vm.delete(vm.currentItem)\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"$root.show_loader\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'DELETE\' | translate }}</md-button><md-button ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" ng-if=\"vm.bill_id == false\" class=\"md-raised md-accent submit-button\" ng-disabled=\"formAccountOutput.$invalid\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"$root.show_loader\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'ADD\' | translate }}</md-button><md-button type=\"button\" ng-if=\"vm.bill_id == false\" class=\"md-raised md-accent submit-button\" ng-disabled=\"formAccountOutput.$invalid\" ng-click=\"vm.insertNewPaymentAndReceipt(formAccountEntry, vm.currentItem, vm.categorized, \'C\', true)\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"$root.show_loader\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'ADD_CONTINUE\' | translate }}</md-button><md-button type=\"submit\" ng-if=\"vm.bill_id != false\" class=\"md-raised md-accent submit-button\" ng-disabled=\"formAccountOutput.$invalid\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"$root.show_loader\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'UPDATE\' | translate }}</md-button></footer></div></div></form></div>");
$templateCache.put("app/finance/current-account/views/sidenavs/account_output.html","<div style=\"width: 700px\"><form name=\"formAccountOutput\" ng-init=\"vm.currentItem.tags = []; vm.categorized = false\" ng-submit=\"vm.insertNewPaymentAndReceipt(formAccountOutput, vm.currentItem, vm.categorized, \'D\')\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex=\"\" md-truncate=\"\">Saida de conta</h2><md-checkbox ng-model=\"vm.categorized\" aria-label=\"Checkbox 1\" ng-if=\"vm.bill_id == false\">Não categorizado</md-checkbox></div></md-toolbar><div class=\"modal-a4\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Informações Gerais\"><md-content class=\"md-padding\"><div ng-if=\"!vm.categorized\" class=\"form-wrapper padding-top-0 padding-bottom-0\" layout=\"column\"><div layout=\"row\" flex=\"\"><md-autocomplete flex=\"\" class=\"md-input-has-placeholder\" ng-init=\"vm.getPersons(vm.searchText)\" md-input-name=\"autocompleteField\" md-no-cache=\"true\" md-selected-item=\"vm.currentItem.person\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPersons(vm.searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-autofocus=\"\" md-require-match=\"\" md-floating-label=\"Pessoa\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><div ng-messages=\"formAccountOutput.autocompleteField.$error\" ng-if=\"formAccountOutput.autocompleteField.$touched\"><div ng-message=\"required\">Campo necessário</div></div><md-not-found>Nenhum registro encontrado para \"{{vm.searchText}}\".</md-not-found></md-autocomplete><md-input-container class=\"md-block\" flex=\"\"><label>Valor:</label> <input ng-required=\"!vm.categorized\" ng-maxlength=\"20\" autocomplete=\"off\" ng-model=\"vm.currentItem.amount\" ui-money-mask=\"2\" placeholder=\"Adicione um valor\" required=\"\"></md-input-container><date-picker ng-model=\"vm.currentItem.date\" required=\"\"></date-picker></div><div layout=\"row\" flex=\"\"><div flex=\"\" class=\"form-group\"><md-autocomplete flex=\"\" required=\"\" class=\"md-input-has-placeholder\" md-input-name=\"autoCategories\" md-selected-item=\"vm.currentItem.category\" md-no-cache=\"true\" md-search-text-change=\"vm.searchTextChange(vm.searchCategory)\" md-search-text=\"vm.searchCategory\" md-selected-item-change=\"vm.currentItem.category = item\" md-items=\"item in vm.querySearchCategory(vm.searchCategory)\" md-item-text=\"item.name\" md-min-length=\"0\" md-require-match=\"\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Categoria\"><md-item-template><span class=\"item-title\"><span><strong>{{item.name}}</strong></span></span> <span class=\"item-metadata\"><span>{{item.path}}</span></span></md-item-template><div ng-messages=\"formProduct.autoCategories.$error\" ng-if=\"formProduct.autoCategories.$touched\"><div ng-message=\"required\">{{ \'CATEGORY_IS_REQUIRED\' | translate }}</div><div ng-message=\"md-require-match\">{{ \'CATEGORY_NOT_EXISTS\' | translate }}</div></div><md-not-found>{{ \'CATEGORY_NOT_FOUND\' | translate }}</md-not-found></md-autocomplete></div><div flex=\"\"><md-input-container class=\"md-block margin-bottom-0\" flex=\"\"><label>Descrição:</label> <input ng-model=\"vm.currentItem.description\" placeholder=\"Adicione uma descrição\"></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block margin-bottom-0\" flex=\"\"><label>Referência:</label> <input ng-model=\"vm.currentItem.document_reference\" placeholder=\"Adicione uma referência\"></md-input-container></div></div></div><div ng-if=\"vm.categorized\" class=\"form-wrapper\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Valor:</label> <input ng-required=\"vm.categorized\" ng-maxlength=\"20\" autocomplete=\"off\" ng-model=\"vm.currentItem.amount\" ui-money-mask=\"2\" placeholder=\"Adicione um valor\"></md-input-container><md-input-container flex=\"\"><date-picker ng-model=\"vm.currentItem.date\"></date-picker></md-input-container></div></div><md-subheader style=\"margin-bottom: 15px\" class=\"md-primary padding-top-0\">Informações Bancárias</md-subheader><div class=\"form-wrapper padding-top-0 padding-bottom-0\"><div layout=\"row\"><md-input-container flex=\"\"><label>Conta</label><md-select ng-model=\"vm.currentItem.current_account\" ng-disabled=\"true\" required=\"\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.currentItem.method = null\" placeholder=\"Escolha a conta corrente\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.current_accounts\">{{item.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Método</label><md-select ng-model=\"vm.currentItem.method\" ng-change=\"vm.getCheckReceived(vm.currentItem.method)\" placeholder=\"Escolha o método\"><md-option ng-value=\"i.id\" ng-repeat=\"i in vm.methods track by $index\" ng-show=\"vm.filterMovementTypes(i.id, vm.currentItem.current_account.current_account_type_id)\">{{i.name}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" ng-if=\"vm.currentItem.method == 2\" class=\"form-wrapper padding-top-0 padding-bottom-0\"><md-input-container class=\"md-block\" flex=\"\"><label>Cheque</label><md-select ng-model=\"vm.currentItem.check\" ng-required=\"vm.checks_required\" placeholder=\"Escolha um cheque\"><md-option ng-value=\"i.id\" ng-repeat=\"i in vm.checks_received\">{{i.name}}</md-option></md-select></md-input-container></div></md-content></md-tab><md-tab label=\"Informações Complementares\"><md-content class=\"md-padding\"><div layout=\"row\" ng-if=\"!vm.categorized\" class=\"form-wrapper padding-top-0 padding-bottom-0\"><md-input-container flex=\"70\"><label>{{ \'COMPLEMENTS_NOTES\' | translate }}</label> <textarea ng-model=\"vm.currentItem.notes\" md-maxlength=\"150\" md-select-on-focus=\"\"></textarea></md-input-container><md-input-container flex=\"30\"><label>Competência</label><md-datepicker ng-model=\"vm.currentItem.accrual\" name=\"dateField\" md-mode=\"month\"></md-datepicker></md-input-container></div><md-subheader ng-if=\"!vm.categorized\" style=\"margin-bottom: 15px\" class=\"md-primary\">Marcadores e Arquivos</md-subheader><div ng-if=\"!vm.categorized\" layout=\"row\" class=\"form-wrapper padding-top-0 padding-bottom-0\"><md-chips flex=\"\" ng-model=\"vm.currentItem.tags\" md-enable-chip-edit=\"true\" placeholder=\"Adicionar marcador\" delete-hint=\"Pressione delete para remover\" md-separator-keys=\"vm.customKeys\"></md-chips></div><div layout=\"row\" class=\"form-wrapper\"><div flex=\"\"><a4-file-upload options=\"vm.dzOptions\" methods=\"vm.dzMethods\" callbacks=\"vm.dzCallbacks\"></a4-file-upload></div></div><div layout=\"row\" class=\"form-wrapper\" ng-if=\"vm.currentItem.files.length > 0\" style=\"padding-top: 0\"><md-table-container style=\"width: 100%;\"><table md-table=\"\" ng-model=\"selected\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Nome do arquivo</th><th md-column=\"\">Ver</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.currentItem.files\" ng-if=\"item.file_reference\"><td md-cell=\"\">{{item.name_display || item.name}}</td><td md-cell=\"\"><a target=\"_blank\" href=\"{{vm.CONFIG.webApiUri + item.file_reference}}\">Ver arquivo</a></td></tr></tbody></table></md-table-container></div></md-content></md-tab></md-tabs><md-divider></md-divider><md-content layout=\"row\" class=\"form-wrapper\"><small class=\"required-fields\" flex=\"25\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\" flex=\"\"><md-button type=\"button\" align=\"left\" ng-if=\"vm.bill_id != false\" ng-click=\"vm.delete(vm.currentItem)\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"$root.show_loader\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'DELETE\' | translate }}</md-button><md-button ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" ng-if=\"vm.bill_id == false\" class=\"md-raised md-accent submit-button\" ng-disabled=\"formAccountOutput.$invalid\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"$root.show_loader\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'ADD\' | translate }}</md-button><md-button type=\"button\" ng-if=\"vm.bill_id == false\" class=\"md-raised md-accent submit-button\" ng-disabled=\"formAccountOutput.$invalid\" ng-click=\"vm.insertNewPaymentAndReceipt(formAccountOutput, vm.currentItem, vm.categorized, \'D\', true)\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"$root.show_loader\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'ADD_CONTINUE\' | translate }}</md-button><md-button type=\"submit\" ng-if=\"vm.bill_id != false\" class=\"md-raised md-accent submit-button\" ng-disabled=\"formAccountOutput.$invalid\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"$root.show_loader\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'UPDATE\' | translate }}</md-button></footer></md-content></div></form></div>");
$templateCache.put("app/finance/current-account/views/sidenavs/account_transference.html","<div style=\"width: 700px\"><form name=\"formAccountTransference\" ng-init=\"vm.currentItem.tags = []\" ng-submit=\"vm.insertTransference(formAccountTransference ,vm.currentItem, vm.selected_account)\" novalidate=\"\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2 flex=\"\" md-truncate=\"\">Transferência - Conta: {{vm.selected_account.name}}</h2></div></md-toolbar><div class=\"modal-a4\"><md-subheader class=\"md-primary padding-top-0\">Informações Gerais</md-subheader><div class=\"form-wrapper padding-top-0 padding-bottom-0\"><div layout=\"row\"><md-input-container class=\"md-block margin-bottom-0\" flex=\"\"><label>Disponível em {{vm.selected_account.name}}:</label> <input autocomplete=\"off\" ng-value=\"vm.selected_account.balance | currency\" ng-disabled=\"true\"></md-input-container></div></div><md-subheader class=\"md-primary padding-top-0\">Informações Bancárias</md-subheader><div class=\"form-wrapper padding-top-0 padding-bottom-0\"><div layout=\"row\"><md-input-container flex=\"\"><md-select ng-model=\"vm.currentItem.current_account\" ng-model-options=\"{trackBy: \'$value.id\'}\" placeholder=\"Escolha a conta destino\" required=\"\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.removeIndicated(vm.current_accounts, vm.selected_account)\">{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\"><input ng-maxlength=\"20\" autocomplete=\"off\" ng-model=\"vm.currentItem.amount\" ui-money-mask=\"2\" placeholder=\"Adicione um valor\" required=\"\"></md-input-container><md-input-container flex=\"\"><date-picker ng-model=\"vm.currentItem.date\" ng-required=\"\" required=\"\"></date-picker></md-input-container></div></div><md-subheader class=\"md-primary padding-top-0\">Arquivos</md-subheader><div class=\"form-wrapper padding-top-0 padding-bottom-0\"><div layout=\"row\" class=\"form-wrapper\"><div flex=\"\"><lf-ng-md-file-input lf-files=\"obj.files\" lf-drag-and-drop-label=\"Arraste seus arquivos aqui\" lf-browse-label=\"Procurar\" lf-remove-label=\"Remover\" drag=\"\" multiple=\"\" lf-option=\"optoin08\" lf-placeholder=\"Pick Image\" preview=\"\"></lf-ng-md-file-input></div></div></div><div layout=\"row\" class=\"form-wrapper\"><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" ng-disabled=\"formAccountTransference.$invalid\">{{ \'ADD\' | translate }}</md-button></footer></div></div></form></div>");
$templateCache.put("app/finance/current-account/views/sidenavs/form.create.edit.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.currentItem.id == null\">{{\'CURRENT_ACCOUNT.FORM_CREATE\' | translate }}</span> <span class=\"title\" ng-show=\"vm.currentItem.id != null\">{{\'CURRENT_ACCOUNT.FORM_EDIT\' | translate }}</span></div></md-toolbar><div class=\"ca-container\" style=\"min-width: 700px;\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><form name=\"formCurrentAccount\" ng-submit=\"vm.submit(vm.currentItem)\"><div layout=\"column\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-input-container flex=\"\"><label>{{ \'CURRENT_ACCOUNT.FORM_TYPE\' | translate }}</label><md-select name=\"type\" ng-model=\"vm.currentItem.current_account_type_id\" ng-disabled=\"vm.currentItem.id != null\" required=\"\"><md-option><em>None</em></md-option><md-option ng-repeat=\"t in vm.types\" ng-value=\"t.id\">{{t.name | translate}}</md-option></md-select><div ng-messages=\"formCurrentAccount.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'CURRENT_ACCOUNT.FORM_TYPE_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.currentItem.name\" placeholder=\"{{ \'CURRENT_ACCOUNT.FORM_NAME\' | translate }}\" required=\"\"><div ng-messages=\"formCurrentAccount.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'CURRENT_ACCOUNT.FORM_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\" ng-if=\"vm.companies.length > 1\"><label>Empresa</label><md-select ng-model=\"vm.currentItem.company_id_company\"><md-option ng-repeat=\"company in vm.companies\" ng-value=\"company.id\">{{company.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"credit_limit\" ng-model=\"vm.currentItem.credit_limit\" placeholder=\"{{ \'CURRENT_ACCOUNT.FORM_CREDIT_LIMIT\' | translate }}\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" required=\"\"><div ng-messages=\"formCurrentAccount.credit_limit.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'CURRENT_ACCOUNT.FORM_CREDIT_LIMIT_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"initial_balance\" ng-model=\"vm.currentItem.initial_balance\" placeholder=\"{{ \'CURRENT_ACCOUNT.FORM_INITIAL_BALANCE\' | translate }}\" ng-disabled=\"vm.currentItem.id\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" required=\"\"><div ng-messages=\"formCurrentAccount.credit_limit.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'CURRENT_ACCOUNT.FORM_INITIAL_BALANCE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"row\" ng-show=\"vm.currentItem.current_account_type_id == vm.CONTA_CARTAO_DE_CREDITO\"><md-input-container flex=\"\"><label>{{ \'CURRENT_ACCOUNT.CLOSING_DAY\' | translate }}</label><md-select name=\"type\" ng-model=\"vm.currentItem.credit_card_closing_day\" ng-selected=\"d.id == vm.currentItem.credit_card_closing_day\"><md-option><em>None</em></md-option><md-option ng-repeat=\"d in vm.days\" ng-value=\"d.id\">{{d.label | translate}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>{{ \'CURRENT_ACCOUNT.DUE_DAY\' | translate }}</label><md-select name=\"type\" ng-model=\"vm.currentItem.credit_card_due_day\" ng-selected=\"d.id == vm.currentItem.credit_card_due_day\"><md-option><em>None</em></md-option><md-option ng-repeat=\"d in vm.days\" ng-value=\"d.id\">{{d.label | translate}}</md-option></md-select></md-input-container></div><div class=\"group-field\" ng-show=\"vm.currentItem.current_account_type_id == 2 || vm.currentItem.current_account_type_id == 5\"><div layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\"><md-input-container flex=\"50\" ng-show=\"(vm.currentItem.current_account_type_id == 5)\"><label>Conta para pagamento</label><md-select name=\"banks\" ng-model=\"vm.currentItem.current_account_parent\"><md-option><em>None</em></md-option><md-option ng-repeat=\"account in vm.bank_accounts\" ng-value=\"account\" ng-selected=\"vm.currentItem.current_account_parent.id == account.id\">{{account.name | translate}}</md-option></md-select></md-input-container><md-input-container flex=\"50\" ng-show=\"(vm.currentItem.current_account_type_id == 5)\"><md-checkbox name=\"category\" ng-model=\"vm.currentItem.is_credit_card_payment_direct_debit\">Fatura paga em débito automático?</md-checkbox></md-input-container><md-input-container flex=\"50\" ng-show=\"(vm.currentItem.current_account_type_id == 2)\"><label>{{ \'CURRENT_ACCOUNT.FORM_BANKS\' | translate }}</label><md-select name=\"banks\" ng-model=\"vm.currentItem.bank\" ng-disabled=\"(vm.currentItem.collectionConfigs != null && vm.currentItem.collectionConfigs.length > 0) || vm.currentItem.id != null\"><md-option><em>None</em></md-option><md-option ng-repeat=\"bank in vm.banks\" ng-value=\"bank\" ng-selected=\"vm.currentItem.bank.id == bank.id\">{{bank.name | translate}}</md-option></md-select></md-input-container><md-input-container flex=\"50\" ng-show=\"(vm.currentItem.current_account_type_id == 2)\"><input type=\"text\" number-only=\"\" name=\"bank_branch\" ng-model=\"vm.currentItem.bank_branch\" placeholder=\"{{ \'CURRENT_ACCOUNT.AGENCY_CODE\' | translate }}\" ng-disabled=\"(vm.currentItem.collectionConfigs != null && vm.currentItem.collectionConfigs.length > 0) || vm.currentItem.id != null\"></md-input-container><md-input-container flex=\"5\" ng-show=\"(vm.currentItem.current_account_type_id == 2)\"><input type=\"text\" number-only=\"\" maxlength=\"1\" name=\"bank_branch\" ng-model=\"vm.currentItem.bank_branch_cd\" placeholder=\"{{ \'CURRENT_ACCOUNT.AGENCY_CODE_CD\' | translate }}\" ng-disabled=\"(vm.currentItem.collectionConfigs != null && vm.currentItem.collectionConfigs.length > 0) || vm.currentItem.id != null\"></md-input-container><md-input-container flex=\"15\" ng-show=\"(vm.currentItem.current_account_type_id == 2 && (vm.currentItem.bank_id == 748 || vm.currentItem.bank.id == 748))\"><input type=\"text\" number-only=\"\" name=\"bank_sub_branch\" ng-model=\"vm.currentItem.bank_sub_branch\" placeholder=\"Posto\" ng-disabled=\"(vm.currentItem.collectionConfigs != null && vm.currentItem.collectionConfigs.length > 0) || vm.currentItem.id != null\"></md-input-container><md-input-container flex=\"20\" ng-show=\"(vm.currentItem.current_account_type_id == 2)\"><input type=\"text\" number-only=\"\" name=\"bank_account_number\" ng-model=\"vm.currentItem.bank_account_number\" placeholder=\"{{ \'CURRENT_ACCOUNT.ACCOUNT\' | translate }}\" ng-disabled=\"(vm.currentItem.collectionConfigs != null && vm.currentItem.collectionConfigs.length > 0) || vm.currentItem.id != null\"></md-input-container><md-input-container flex=\"5\" ng-show=\"(vm.currentItem.current_account_type_id == 2)\"><input type=\"text\" number-only=\"\" maxlength=\"1\" name=\"bank_account_number\" ng-model=\"vm.currentItem.bank_account_number_cd\" placeholder=\"{{ \'CURRENT_ACCOUNT.ACCOUNT_CD\' | translate }}\" ng-disabled=\"(vm.currentItem.collectionConfigs != null && vm.currentItem.collectionConfigs.length > 0) || vm.currentItem.id != null\"></md-input-container></div><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Cartões\"><md-content class=\"md-padding\"><a4-edit-table class=\"a4_edit_table\" type=\"cards\" items=\"vm.currentItem.cards\" current_account=\"vm.currentItem\" template=\"app/components/a4-edit-table/templates/cards.html\"></a4-edit-table></md-content></md-tab><md-tab label=\"Configuração de cobrança\" ng-disabled=\"vm.currentItem.bank == null || vm.currentItem.bank == undefined\" ng-if=\"(vm.currentItem.current_account_type_id == 2)\"><md-content class=\"md-padding\"><a4-edit-table class=\"a4_edit_table\" type=\"collectionConfigs\" items=\"vm.currentItem.collectionConfigs\" bank-colletions=\"vm.bankColletions\" current_account=\"vm.currentItem\" template=\"app/components/a4-edit-table/templates/collection_configs.html\"></a4-edit-table></md-content></md-tab></md-tabs></div><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'CURRENT_ACCOUNT.FORM_SUBMIT\' | translate }}\" ng-disabled=\"formCurrentAccount.$invalid\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"vm.loginProcess\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>{{ \'CURRENT_ACCOUNT.FORM_SUBMIT\' | translate }}</md-button></footer></form></div></div>");
$templateCache.put("app/finance/discounts/views/forms/form-discounts.html","<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.discountRule.id == null\">{{\'DISCOUNTS.TITLE_CREATE\' | translate }}</span> <span class=\"title\" ng-show=\"vm.discountRule.id != null\">{{\'DISCOUNTS.TITLE_EDIT\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-if=\"vm.objectName\" ng-init=\"vm.discountRule = vm.objectName\"></div><md-content class=\"md-padding\"><form name=\"formDiscounts\" ng-submit=\"vm.submitDiscount(vm.discountRule);\" focus-invalid-field=\"\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.discountRule.name\" placeholder=\"{{ \'DISCOUNTS.FORM_NAME\' | translate }}\" required=\"\"><div ng-messages=\"formDiscounts.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'DISCOUNTS.FORM_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><div flex=\"35\"><strong class=\"group-field\"><small>Formato do Desconto</small></strong><md-radio-group name=\"form_discount\" ng-model=\"vm.discountRule.format\" required=\"\"><md-radio-button ng-value=\"0\">Em percentual</md-radio-button><md-radio-button ng-value=\"1\">Em valor</md-radio-button></md-radio-group></div><div flex=\"65\"><strong class=\"group-field\"><small>Validade do Desconto</small></strong><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><div flex=\"40\"><md-radio-group name=\"validate_discount\" ng-model=\"vm.discountRule.type\"><md-radio-button ng-value=\"\'f\'\" flex=\"\">Fixo</md-radio-button><md-radio-button ng-value=\"\'p\'\" flex=\"\">Promocional</md-radio-button></md-radio-group></div><div flex=\"60\"><md-radio-group name=\"validate_discount\" ng-model=\"vm.discountRule.type\"><md-radio-button ng-value=\"\'c\'\" flex=\"\">Condicional ao vencimento</md-radio-button></md-radio-group></div></div></div></div><strong class=\"group-field\" ng-if=\"vm.discountRule.type == \'p\'\"><small>Desconto Promocional</small></strong><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"vm.discountRule.type == \'p\'\"><div flex=\"\"><label>Desconto 1</label><md-input-container ng-if=\"!vm.discountRule.format\" class=\"md-block\"><input type=\"text\" tabindex=\"1\" ng-model=\"vm.discountRule.value_percent_1\" ui-percentage-mask=\"\" placeholder=\"Percentual\" required=\"\"></md-input-container><md-input-container ng-if=\"vm.discountRule.format\" class=\"md-block\"><input tabindex=\"1\" ng-model=\"vm.discountRule.value_percent_1\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" placeholder=\"Valor\" required=\"\"></md-input-container><md-input-container class=\"md-block\"><input tabindex=\"2\" ng-model=\"vm.discountRule.validity_days_1\" maxlength=\"2\" placeholder=\"Dias de Antecipação\"></md-input-container></div><div flex=\"\"><label>Desconto 2 <small>(opcional)</small></label><md-input-container ng-if=\"!vm.discountRule.format\" class=\"md-block\"><input tabindex=\"3\" max=\"vm.discountRule.value_percent_1\" ng-class=\"{\'error\': cc.validateValue(vm.discountRule.value_percent_2, vm.discountRule.value_percent_1, 0, 0)}\" ng-if=\"!vm.discountRule.format\" ng-model=\"vm.discountRule.value_percent_2\" ng-disabled=\"vm.discountRule.validity_days_1 == null || vm.discountRule.validity_days_1 == \'\'\" ui-percentage-mask=\"\" placeholder=\"Percentual\"></md-input-container><md-input-container ng-if=\"vm.discountRule.format\" class=\"md-block\"><input tabindex=\"3\" max=\"vm.discountRule.value_percent_1\" ng-class=\"{\'error\': cc.validateValue(vm.discountRule.value_percent_2, vm.discountRule.value_percent_1, 0, 0)}\" ng-if=\"vm.discountRule.format\" ng-model=\"vm.discountRule.value_percent_2\" ng-disabled=\"vm.discountRule.validity_days_1 == null || vm.discountRule.validity_days_1 == \'\'\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" placeholder=\"Valor\"></md-input-container><md-input-container class=\"md-block\"><input tabindex=\"4\" max=\"vm.discountRule.validity_days_1\" ng-model=\"vm.discountRule.validity_days_2\" ng-disabled=\"vm.discountRule.validity_days_1 == null || vm.discountRule.validity_days_1 == \'\'\" maxlength=\"2\" placeholder=\"Dias de Antecipação\"></md-input-container></div><div flex=\"\"><label>Desconto 3 <small>(opcional)</small></label><md-input-container ng-if=\"!vm.discountRule.format\" class=\"md-block\"><input tabindex=\"5\" max=\"vm.discountRule.value_percent_2\" ng-class=\"{\'error\': cc.validateValue(vm.discountRule.value_percent_3, vm.discountRule.value_percent_2, 1, 0)}\" ng-if=\"!vm.discountRule.format\" ng-model=\"vm.discountRule.value_percent_3\" ng-disabled=\"vm.discountRule.validity_days_2 == null || vm.discountRule.validity_days_2 == \'\'\" ui-percentage-mask=\"\" placeholder=\"Percentual\"></md-input-container><md-input-container ng-if=\"vm.discountRule.format\" class=\"md-block\"><input tabindex=\"5\" max=\"vm.discountRule.value_percent_2\" ng-class=\"{\'error\': cc.validateValue(vm.discountRule.value_percent_3, vm.discountRule.value_percent_2, 1, 0)}\" ng-if=\"vm.discountRule.format\" ng-model=\"vm.discountRule.value_percent_3\" ng-disabled=\"vm.discountRule.validity_days_2 == null || vm.discountRule.validity_days_2 == \'\'\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" id=\"exampleInputEmail3\" placeholder=\"Valor\"></md-input-container><md-input-container class=\"md-block\"><input tabindex=\"6\" max=\"vm.discountRule.validity_days_2\" ng-model=\"vm.discountRule.validity_days_3\" ng-disabled=\"vm.discountRule.validity_days_2 == null || vm.discountRule.validity_days_2 == \'\'\" id=\"exampleInputEmail3\" maxlength=\"2\" placeholder=\"Dias de Antecipação\"></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" ng-if=\"vm.discountRule.type == \'f\' || vm.discountRule.type == \'c\'\"><md-input-container ng-if=\"!vm.discountRule.format\" flex=\"\"><input type=\"text\" ng-model=\"vm.discountRule.value_percent_1\" name=\"role_name\" placeholder=\"Percentual\" ui-percentage-mask=\"\" required=\"\"></md-input-container><md-input-container ng-if=\"vm.discountRule.format\" flex=\"\"><input type=\"text\" ng-model=\"vm.discountRule.value_percent_1\" placeholder=\"Valor\" name=\"role_name\" ui-money-mask=\"2\" ui-money-mask-symbol=\"R$\" decimal-delimiter=\",\" thousands-delimiter=\".\" required=\"\"></md-input-container></div><strong class=\"group-field\"><small>Mais definições</small></strong><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-checkbox ng-model=\"vm.discountRule.is_excluded_first_installment\" class=\"md-block\">Não aplica este desconto sobre a primeira parcela da recorrência</md-checkbox><md-checkbox ng-model=\"vm.discountRule.is_excluded_multiple_discount\" class=\"md-block\">Não aplica este desconto para quem tiver algum outro desconto</md-checkbox><md-checkbox ng-model=\"vm.discountRule.is_over_main_value\" class=\"md-block\" style=\"margin: 13px;\" ng-hide=\"vm.discountRule.type == \'c\' && vm.discountRule.format == 1\" ng-if=\"!vm.discountRule.format\">Calcula este desconto sobre o valor principal</md-checkbox></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-switch name=\"is_inactive\" ng-model=\"vm.discountRule.is_inactive\" md-no-ink=\"\">Regra <span ng-show=\"vm.discountRule.is_inactive\">inativa</span><span ng-show=\"!vm.discountRule.is_inactive\">ativa</span></md-switch></div><footer layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" layout-align=\"end center\"><md-button ng-click=\"vm.close();\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'DISCOUNTS.FORM_SUBMIT\' | translate }}\" ng-disabled=\"formDiscounts.$invalid || formDiscounts.$pristine || vm.discountRule.validity_days_2 > vm.discountRule.validity_days_1 || vm.discountRule.validity_days_3 > vm.discountRule.validity_days_2\"><md-progress-circular style=\"float: left; top: 8px;left: 100px;\" ng-show=\"vm.loginProcess\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span ng-show=\"vm.discountRule.id != null\" translate=\"DISCOUNTS.FORM_UPDATE_SUBMIT\"></span> <span ng-show=\"vm.discountRule.id == null\" translate=\"DISCOUNTS.FORM_CREATE_SUBMIT\"></span></md-button></footer></form></md-content>");
$templateCache.put("app/finance/payment-plan/views/forms/form-paymentplan.html","<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.paymentPlan.id == null\">{{\'PAYMENT_PLAN.FORM_CREATE\' | translate }}</span> <span class=\"title\" ng-show=\"vm.paymentPlan.id != null\">{{\'PAYMENT_PLAN.FORM_EDIT\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-if=\"vm.objectName\" ng-init=\"vm.paymentPlan = vm.objectName\"></div><md-content><div layout=\"row\" layout-sm=\"column\" style=\"margin-top: 300px\" ng-if=\"!vm.show_form\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular></div><form name=\"formPaymentPlan\" ng-submit=\"vm.submitPaymentPlan(formPaymentPlan, vm.paymentPlan);\" focus-invalid-field=\"\" ng-if=\"vm.show_form\" novalidate=\"\"><div id=\"content\" layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" flex=\"100\" md-selected=\"vm.selectedTab\"><md-tab label=\"DADOS GERAIS\"><md-content class=\"md-padding\" ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"input-a4\" flex=\"80\"><input type=\"text\" name=\"name\" ng-model=\"vm.paymentPlan.name\" placeholder=\"{{ \'Nome do plano\' | translate }}\" required=\"\"><div ng-messages=\"formPaymentPlan.name.$error\"><div ng-message=\"required\">Nome do plano é obrigatório</div></div></md-input-container><md-input-container class=\"input-a4\" flex=\"20\"><md-switch style=\"margin: 0\" ng-model=\"vm.paymentPlan.is_inactive\">Inativo</md-switch></md-input-container><div layout=\"row\" layout-gt-sm=\"row\"><fieldset class=\"standard without-legend group-field\"><md-radio-group name=\"expenses\" ng-model=\"vm.paymentPlan.was_paid\" required=\"\" ng-disabled=\"(vm.paymentPlan.name == null || vm.paymentPlan.name == \'\')\"><md-radio-button ng-value=\"0\" flex=\"\">Receita única</md-radio-button><md-radio-button ng-value=\"1\" flex=\"\">Receita recorrente</md-radio-button></md-radio-group></fieldset></div><div layout=\"row\" layout-gt-sm=\"row\" ng-if=\"vm.paymentPlan.was_paid != null\"><md-input-container flex=\"25\"><label>Competência</label><md-select ng-model=\"vm.paymentPlan.accrual_date_type\" ng-init=\"vm.paymentPlan.accrual_date_type = 0\"><md-option ng-repeat=\"item in vm.accrual_date_type\" ng-value=\"item.value\">{{item.name}}</md-option></md-select></md-input-container><md-chips placeholder=\"Marcadores\" secondary-placeholder=\"Add marcadores\" md-on-remove=\"vm.addTag($chip)\" md-on-add=\"vm.addTag($chip)\" ng-model=\"vm.tags\" md-separator-keys=\"vm.customKeys\" flex=\"\"></md-chips></div></div></md-content></md-tab><md-tab ng-disabled=\"vm.paymentPlan.was_paid != 1\" label=\"Detalhes da Recorrência\" md-on-select=\"vm.setRecurrenceData()\"><md-content class=\"md-padding\" ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\" ng-if=\"vm.paymentPlan.was_paid == 1\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Tipo da recorrência</b></div></div><fieldset class=\"standard without-legend group-field\"><md-radio-group name=\"endofrecurrence\" ng-model=\"vm.paymentPlan.end_of_recurrence\"><md-radio-button value=\"0\" class=\"md-primary\">Quantidade fixa de parcelas</md-radio-button><md-radio-button value=\"1\" class=\"md-primary\">Até uma determinada data</md-radio-button><md-radio-button value=\"2\" class=\"md-primary\">Sem prazo determinado</md-radio-button></md-radio-group></fieldset></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"md-input-has-placeholder\" ng-show=\"vm.paymentPlan.end_of_recurrence == 0\" flex=\"\"><input type=\"text\" name=\"frequencyqty\" placeholder=\"Quantidade da frequência\" ng-model=\"vm.paymentPlan.frequency_qty\" maxlength=\"2\"> <span class=\"input-group-btn btn-left\"><i class=\"material-icons\">date_range</i></span></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"\" ng-show=\"vm.paymentPlan.end_of_recurrence == 0\"><label>{{ \'Frequência a cada \' | translate }} {{ vm.paymentPlan.frequency_qty }}</label><md-select name=\"frequency\" ng-model=\"vm.paymentPlan.frequency\" ng-selected=\"vm.paymentPlan.frequency == item.id\"><md-option ng-repeat=\"item in vm.frequency_options\" ng-value=\"item.id\">{{item.name | translate}}</md-option></md-select></md-input-container><div flex=\"\" ng-show=\"vm.paymentPlan.end_of_recurrence == 1\"><date-picker ng-model=\"vm.paymentPlan.date_end\" flex=\"\" placeholder=\"Data final do plano\"></date-picker></div><md-input-container class=\"md-input-has-placeholder\" ng-show=\"vm.paymentPlan.end_of_recurrence == 0\" flex=\"\"><input type=\"text\" name=\"quantity\" placeholder=\"Quantidade de parcelas\" ng-model=\"vm.paymentPlan.quantity\" maxlength=\"3\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Valor na recorrência</b></div></div><fieldset class=\"standard without-legend group-field\"><md-radio-group ng-model=\"vm.paymentPlan.recurrence_on_value\" class=\"md-padding\"><div ng-if=\"vm.paymentPlan.frequency_type != 1\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"0\" ng-checked=\"vm.bill.end_of_recurrence == 0\">Parcelas com o mesmo valor</md-radio-button></div><div ng-if=\"vm.paymentPlan.frequency_type != 1\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"1\" ng-checked=\"vm.bill.end_of_recurrence == 1\">O valor pode variar a cada parcela</md-radio-button></div><div ng-if=\"vm.paymentPlan.end_of_recurrence == 0\" layout=\"row\"><md-radio-button name=\"endofrecurrence\" value=\"2\" ng-checked=\"vm.bill.end_of_recurrence == 0\">Divide o valor do título nas parcelas</md-radio-button></div></md-radio-group></fieldset></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117)\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Forma de cálculo da data de vencimento da <i>primeira</i> parcela</b> <small>Defina como será calculado e depois de quantos dias a primeira parcela do contrato irá vencer a partir da data inicial</small></div></div><fieldset class=\"standard without-legend group-field\"><md-radio-group ng-model=\"vm.paymentPlan.first_installment_date_type\" class=\"md-padding\"><div layout=\"row\"><md-radio-button name=\"first_installment_date_type\" value=\"0\">Padrão do contrato</md-radio-button></div><div layout=\"row\"><md-radio-button name=\"first_installment_date_type\" value=\"1\">Data em aberto</md-radio-button></div><div layout=\"row\"><md-radio-button name=\"first_installment_date_type\" value=\"2\">Quantidade de dias a partir da data de início</md-radio-button></div></md-radio-group></fieldset></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"md-input-has-placeholder\" ng-if=\"vm.paymentPlan.first_installment_date_type > 0\" flex=\"\"><input type=\"number\" name=\"first_installment_date_days\" placeholder=\"Quantidade de dias\" ng-required=\"vm.paymentPlan.first_installment_date_type > 0\" ng-model=\"vm.paymentPlan.first_installment_date_days\" maxlength=\"2\"> <span class=\"input-group-btn btn-left\"><i class=\"material-icons\">date_range</i></span></md-input-container></div></md-content></md-tab><md-tab label=\"Regras de cobrança\" ng-disabled=\"vm.paymentPlan.was_paid == null\"><md-content ng-style=\"{height: (iframeHeight - 200) + \'px\', overflow: \'auto\'}\"><md-content class=\"md-padding\" flex=\"100\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"input-a4\" flex=\"100\"><label>Forma de Cobrança</label><md-select name=\"collection_type\" ng-model=\"vm.paymentPlan.collection_type\" required=\"\"><md-option ng-repeat=\"item in vm.colletion_types\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div ng-messages=\"formPaymentPlan.collection_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Informe de que modo serão cobradas as parcelas neste plano de pagamento.</span></div></div></md-input-container><md-input-container class=\"input-a4\" ng-if=\"vm.paymentPlan.collection_type == 9\" flex=\"100\"><label>Regra de Boleto</label><md-select ng-model=\"vm.paymentPlan.bank_slip_rule_id\"><md-option ng-repeat=\"item in vm.allBankSlipRules\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container></div></md-content><md-content class=\"md-padding\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container class=\"input-a4\" flex=\"50\"><label>Regra de Acréscimos</label><md-select ng-model=\"vm.paymentPlan.fines_rule_id\"><md-option ng-repeat=\"item in vm.allAdditionRules\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"input-a4\" ng-if=\"vm.paymentPlan.was_paid == 1\" flex=\"50\"><label>Indice de correção</label><md-select ng-model=\"vm.paymentPlan.index_id\"><md-option ng-repeat=\"item in vm.indexCorrection\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container></div></md-content></md-content></md-tab></md-tabs></div><footer layout=\"row\" layout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" layout-align=\"end center\" class=\"md-padding\"><md-button ng-click=\"vm.close();\">Cancelar</md-button><md-button type=\"submit\" ng-disabled=\"vm.show_progress || formPaymentPlan.$invalid\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'DISCOUNTS.FORM_SUBMIT\' | translate }}\"><md-progress-circular style=\"float: left; top: 8px;\" ng-show=\"vm.show_progress\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span ng-show=\"vm.paymentPlan.id == null\" translate=\"PAYMENT_PLAN.SUBMIT_CREATE\"></span> <span ng-show=\"vm.paymentPlan.id != null\" translate=\"PAYMENT_PLAN.SUBMIT_EDIT\"></span></md-button></footer></form></md-content>");
$templateCache.put("app/finance/person/person-check/view/history.html","<md-tab md-on-select=\"vm.init()\"><md-tab-label>Cheques<md-button ng-if=\"vm.count > 0\" class=\"md-fab md-accent md-icon-button md-mini a4-badge\" disabled=\"\" style=\"position: absolute;right: -5px;\" aria-label=\"add contact\" translate=\"\">{{vm.count}}</md-button></md-tab-label><md-tab-body class=\"md-padding\"><div class=\"content\" layout=\"row\"><md-content flex=\"\"><div><div class=\"page-layout simple left-sidenav inner-sidenav\"><md-list class=\"contacts-list\" flex=\"\"><div class=\"main scrollable\" ms-scroll=\"\"><div class=\"md-card-list-wrapper\" id=\"bill-box2\"><div class=\"uk-width-large-8-10 uk-container-center\"><div class=\"md-card-list\"><ul hierarchical-slide=\"\"><li ng-repeat=\"item in vm.items.checks\" on-last-repeat=\"\" class=\"{{ item.status_name }}\"><div layout=\"row\"><span flex=\"15\" flex-xs=\"20\" flex-md=\"25\" class=\"md-card-list-item-avatar-wrapper\"><span class=\"status label-{{item.check_status_id}}\">{{item.check_status_name}}</span></span> <span flex=\"15\" flex-xs=\"15\" flex-md=\"15\" flex-sm=\"15\" class=\"md-card-list-item-date\">{{item.date | date:\'dd/MM/yyyy\'}}</span><div flex=\"15\" flex-xs=\"15\" flex-md=\"15\" flex-sm=\"15\" class=\"md-card-list-item-date\"><span><b>N.º {{item.number}}</b></span></div><span flex=\"25\" flex-xs=\"25\" flex-md=\"15\" flex-sm=\"20\" class=\"md-card-list-item\">{{item.bank_name}}</span><div flex=\"10\" flex-sm=\"10\" flex-xs=\"10\" class=\"md-card-list-item-avatar-wrapper md-card-list-item-amount\"><strong>{{item.final_value | currency}}</strong></div></div></li></ul></div></div></div></div></md-list></div></div></md-content></div></md-tab-body></md-tab>");
$templateCache.put("app/finance/person/person-expense/view/history.html","<md-tab label=\"A Pagar\" md-theme=\"finance\"><div ng-if=\"!vm.show\" style=\"background-color: rgb(20,133,50); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-clipboard-alert\" style=\"color: #fff;font-size: 30px;\"></i><br><span style=\"font-size: 18px; color: #fff;\">Não existem títulos disponíveis pra este filtro</span></p></div><a4-bill-grid debit-credit=\"D\" ng-model=\"vm.bills.expenses\" with-filter=\"false\" paginate-function=\"vm.getListOfExpenseFromPerson(page, qtd, date, person_id, status)\" show_loader=\"vm.show_loader\" show-printer=\"true\" on-print-grid=\"vm.printBillsResponsible(date, status, all_bills)\"></a4-bill-grid></md-tab>");
$templateCache.put("app/finance/person/person-profile/view/create.html","<form name=\"formPerson\" ng-submit=\"vm.form.submitPerson(vm.currentItem);\"><md-toolbar class=\"md-accent\" layout=\"column\" md-theme=\"finance\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-if=\"vm.createTypePerson == 1\">{{ \'PERSON.TITLE_PERSON\' | translate }}</span> <span class=\"title\" ng-if=\"vm.createTypePerson == 2\">{{ \'PERSON.TITLE_COMPANY\' | translate }}</span><div class=\"contact-name\">{{ vm.currentItem.name }}</div></div></md-toolbar><div class=\"content\" md-theme=\"finance\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\" ng-init=\"vm.form = vm;\"><div layout=\"row\" layout-align=\"space-between center\" ng-hide=\"vm.currentItem.id == null\"><div class=\"more secondary-text switch-edit-form\"><md-button class=\"md-fab md-primary switch-edit-button\" aria-label=\"\"><md-icon><i class=\"material-icons\" aria-hidden=\"true\">close</i></md-icon></md-button></div></div><input type=\"hidden\" name=\"id\" ng-model=\"vm.currentItem.id\"> <input type=\"hidden\" name=\"id\" ng-model=\"vm.currentItem.type\" ng-bind=\"vm.currentItem.type = (vm.currentItem.id) ? vm.currentItem.type : vm.form.createTypePerson\"><div layout=\"column\" layout-gt-sm=\"row\"><fieldset class=\"standard without-legend group-field\"><md-input-container class=\"md-block\"><md-radio-group ng-model=\"vm.createTypePerson\" style=\"padding-top: 10px;\"><md-radio-button ng-value=\"1\">Pessoa Física</md-radio-button><md-radio-button ng-value=\"2\">Pessoa Jurídica</md-radio-button></md-radio-group></md-input-container></fieldset></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.createTypePerson == 1\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.currentItem.name\" placeholder=\"{{ \'PERSON.FORM_NAME\' | translate }}\" required=\"\" md-maxlength=\"100\"><div ng-messages=\"formPerson.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_NAME_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O nome não pode ter mais de 100 caracteres.</div></div></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\" ng-if=\"vm.createTypePerson == 2\"><md-input-container flex=\"80\" class=\"md-input-has-placeholder\" layout=\"row\"><label for=\"cnpj\" translate=\"PERSON.FORM_CNPJ\"></label><md-progress-circular ng-show=\"vm.waiting_cnpj\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><input type=\"text\" name=\"national_id_number\" ng-model=\"vm.currentItem.national_id_number\" ui-br-cnpj-mask=\"\" id=\"cnpj\" flex=\"\"></md-input-container><md-input-container flex=\"20\"><md-button ng-disabled=\"!formPerson.national_id_number.$valid\" ng-click=\"vm.form.getCnpjCaptcha($event, vm.currentItem.national_id_number, vm.currentItem)\">Pesquisar</md-button></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.createTypePerson == 2\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.currentItem.name\" required=\"\" placeholder=\"{{ \'PERSON.FORM_NAME_BUSINESS\' | translate }}\" md-maxlength=\"100\"><div ng-messages=\"formPerson.name.$error\" role=\"alert\"><div ng-message=\"required\">{{ \'PERSON.FORM_NAME_BUSINESS_REQUIRED\' | translate }}</div><div ng-message=\"md-maxlength\">O nome não pode ter mais de 100 caracteres.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\"><md-input-container flex=\"50\" ng-if=\"vm.createTypePerson == 1\"><label for=\"cpf\" translate=\"PERSON.FORM_CPF\"></label> <input type=\"text\" name=\"national_id_number\" ng-model=\"vm.currentItem.national_id_number\" ng-cpf=\"\" required=\"\" mask=\"999.999.999-99\" clean=\"true\" id=\"cpf\"></md-input-container><date-picker ng-model=\"vm.currentItem.dob\" ng-if=\"vm.createTypePerson == 1\" flex=\"30\" placeholder=\"{{ \'PERSON.FORM_DOB\' | translate }}\" required=\"true\"></date-picker><md-input-container flex=\"20\" ng-if=\"vm.createTypePerson == 1\"><label>{{ \'PERSON.FORM_SEX\' | translate }}</label><md-select name=\"sex\" ng-model=\"vm.currentItem.sex\"><md-option ng-value=\"sex.value\" ng-repeat=\"sex in vm.sex\">{{ sex.name }}</md-option></md-select><div ng-messages=\"formPerson.sex.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_SEX_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\" ng-if=\"vm.createTypePerson == 2\"><md-input-container flex=\"\"><input type=\"text\" name=\"corporate_name\" ng-model=\"vm.currentItem.corporate_name\" placeholder=\"{{ \'PERSON.FORM_CORPORATE_NAME\' | translate }}\" md-maxlength=\"100\"><div ng-messages=\"formPerson.corporate_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_CORPORATE_NAME_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">A razão não pode ter mais de 100 caracteres.</div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"state_registration_number\" ng-model=\"vm.currentItem.state_registration_number\" placeholder=\"{{ \'PERSON.FORM_STATE_REGISTRATION_NUMBER\' | translate }}\" ng-maxlength=\"30\"><div ng-messages=\"formPerson.state_registration_number.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_STATE_REGISTRATION_NUMBER_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\" ng-if=\"vm.createTypePerson == 2\"><md-input-container flex=\"\"><input type=\"text\" name=\"main_contact_name\" ng-model=\"vm.currentItem.main_contact_name\" required=\"\" placeholder=\"{{ \'PERSON.FORM_MAIN_CONTACT_NAME\' | translate }}\" md-maxlength=\"100\"><div ng-messages=\"formPerson.main_contact_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_MAIN_CONTACT_NAME_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O nome da pessoa não pode ter mais de 100 caracteres.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" name=\"email\" ng-model=\"vm.currentItem.email\" required=\"\" ng-change=\"vm.currentItem.email = vm.currentItem.email.toLowerCase();\" placeholder=\"{{ \'PERSON.FORM_EMAIL\' | translate }}\" md-maxlength=\"50\"><div ng-messages=\"formPerson.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_EMAIL_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O e-mail não pode ter mais de 50 caracteres.</div></div></md-input-container><md-input-container><input type=\"text\" name=\"phone_landline\" ng-model=\"vm.currentItem.phone_landline\" required=\"\" placeholder=\"{{ \'PERSON.FORM_PHONE_LANDLINE\' | translate }}\" ui-br-phone-number=\"\"><div ng-messages=\"formPerson.phone_landline.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_PHONE_LANDLINE_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"phone_mobile\" ng-model=\"vm.currentItem.phone_mobile\" placeholder=\"{{ \'PERSON.FORM_PHONE_MOBILE\' | translate }}\" ui-br-phone-number=\"\"><div ng-messages=\"formPerson.phone_mobile.$error\" role=\"alert\"></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\"><md-input-container><input type=\"text\" name=\"address_postal_code\" ng-model=\"vm.currentItem.address_postal_code\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_POSTAL_CODE\' | translate }}\" required=\"\" ng-blur=\"vm.form.getAddressByCep(vm.currentItem.address_postal_code, vm.currentItem)\" ui-br-cep-mask=\"\"><div ng-messages=\"formPerson.address_postal_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_POSTAL_CODE_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"address_street\" ng-model=\"vm.currentItem.address_street\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_STREET\' | translate }}\" md-maxlength=\"100\"><div ng-messages=\"formPerson.address_street.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_STREET_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O endereço não pode ter mais de 50 caracteres.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_line2\" ng-model=\"vm.currentItem.address_line2\" md-maxlength=\"100\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_LINE2\' | translate }}\"><div ng-messages=\"formPerson.address_line2.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_LINE2_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O complemento não pode ter mais de 100 caracteres.</div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_house_number\" ng-model=\"vm.currentItem.address_house_number\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_HOUSE_NUMBER\' | translate }}\" ng-maxlength=\"30\"><div ng-messages=\"formPerson.address_house_number.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_HOUSE_NUMBER_REQUIRED\' | translate }}</span></div><div ng-message=\"maxlength\">O número não pode ter mais de 30 caracteres.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_district\" md-maxlength=\"50\" ng-model=\"vm.currentItem.address_district\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_DISTRICT\' | translate }}\"><div ng-messages=\"formPerson.address_district.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_DISTRICT_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O bairro não pode ter mais de 50 caracteres.</div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_city\" ng-model=\"vm.currentItem.address_city\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_CITY\' | translate }}\" md-maxlength=\"50\"><div ng-messages=\"formPerson.address_city.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_CITY_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">A cidade não pode ter mais de 50 caracteres.</div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_state\" ng-model=\"vm.currentItem.address_state\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_STATE\' | translate }}\" md-maxlength=\"2\"><div ng-messages=\"formPerson.address_state.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_STATE_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">Inserir somente a sigla do estado.</div></div></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container class=\"md-input-has-placeholder\" ng-if=\"vm.createTypePerson == 2\"><md-autocomplete flex=\"\" md-input-name=\"company_mother\" md-input-minlength=\"3\" md-input-maxlength=\"150\" md-delay=\"500\" md-no-cache=\"true\" md-selected-item=\"vm.company_mother_selected\" md-selected-item-change=\"vm.onAutoCompleteItemChange(vm.company_mother_selected)\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPossibleMatrixCompany(vm.searchText)\" md-item-text=\"item.name\" md-require-match=\"\" md-menu-class=\"autocomplete-company_mother-template\" md-floating-label=\"Empresa Mãe\"><md-item-template><span class=\"item-title\"><md-icon md-font-icon=\"icon-city\"></md-icon><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></span> <span class=\"item-metadata\"><span><strong md-highlight-text=\"vm.searchText\">{{item.corporate_name}}</strong></span></span></md-item-template><div ng-messages=\"formPerson.company_mother.$error\" ng-if=\"formPerson.company_mother.$touched\"><div ng-message=\"md-require-match\">Digite uma empresa existente.</div><div ng-message=\"minlength\">Entre com no minimo 3 letras.</div><div ng-message=\"maxlength\">Minimo 50 letras.</div></div></md-autocomplete></md-input-container></div><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\" style=\"padding-bottom: 20px;\"><md-button ng-click=\"vm.close()\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'PERSON.FORM_SUBMIT\' | translate }}\" ng-disabled=\"formPerson.$invalid\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"vm.loginProcess\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span translate=\"PERSON.FORM_CREATE_SUBMIT\"></span></md-button></footer></div></div></form>");
$templateCache.put("app/finance/person/person-profile/view/profile.html","<div id=\"page-material-table\" class=\"page-layout simple left-sidenav inner-sidenav\" style=\"background: whitesmoke !important;\"><md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"PERSON.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ui-sref=\"private.finance.person\"><md-tooltip md-direction=\"top\">Voltar para lista</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span> <span class=\"logo-text\">{{vm.person.name}}</span></div></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Perfil\" md-on-select=\"vm.init()\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\" style=\"padding-bottom: 20px;background: whitesmoke;\"><div style=\"margin: 0 20%; background-color: #fff; border-radius: 8px; box-shadow: 4px 4px 15px #aaa\"><form name=\"formPerson\" ng-submit=\"vm.submitPerson(vm.person);\" style=\"padding: 20px;\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.person.id\"> <input type=\"hidden\" name=\"id\" ng-model=\"vm.person.type\" ng-bind=\"vm.person.type = (vm.person.id) ? vm.person.type : vm.createTypePerson\"><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.person.is_user\"><fieldset class=\"standard group-field\"><legend>{{ \'PERSON.DATA_USER\' | translate }}</legend><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"username\" ng-model=\"vm.person.username\" placeholder=\"{{ \'PERSON.FORM_USERNAME\' | translate }}\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" ng-required=\"{{ vm.person.is_user }}\"><div ng-messages=\"formPerson.username.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_USERNAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.person.password\" placeholder=\"{{ \'PERSON.FORM_PASSWORD\' | translate }}\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" ng-required=\"{{ vm.person.is_user }}\"><div ng-messages=\"formPerson.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_PASSWORD_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"password\" name=\"password_confirm\" ng-model=\"vm.person.password_confirm\" placeholder=\"{{ \'PERSON.FORM_PASSWORD_CONFIRM\' | translate }}\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" ng-required=\"{{ vm.person.is_user }}\"><div ng-messages=\"formPerson.password_confirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_PASSWORD_CONFIRM_REQUIRED\' | translate }}</span></div></div></md-input-container></div></fieldset></div><div layout=\"row\" layout-gt-sm=\"row\" ng-if=\"vm.createTypePerson == 1 || vm.person.type == 1\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.person.name\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" placeholder=\"{{ \'PERSON.FORM_NAME\' | translate }}\" md-maxlength=\"100\" required=\"\"><div ng-messages=\"formPerson.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_NAME_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O nome não pode ter mais de 100 caracteres.</div></div></md-input-container><date-picker name=\"dob\" ng-model=\"vm.person.dob\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" flex=\"\" ng-if=\"vm.createTypePerson == 1 || vm.person.type == 1\" placeholder=\"{{ \'PERSON.FORM_DOB\' | translate }}\"></date-picker><div ng-messages=\"formPerson.dob.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_DOB_REQUIRED\' | translate }}</span></div></div></div><div layout=\"row\" layout-gt-sm=\"row\" ng-if=\"vm.createTypePerson == 2 || vm.person.type == 2\"><md-input-container flex=\"80\"><label for=\"cnpj\" translate=\"PERSON.FORM_CNPJ\"></label> <input type=\"text\" name=\"national_id_number\" ng-model=\"vm.person.national_id_number\" ng-cnpj=\"\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" mask=\"99.999.999/9999-99\" clean=\"true\" id=\"cnpj\" flex=\"\"></md-input-container><md-input-container flex=\"20\"><md-button ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" ng-click=\"(formPerson.national_id_number.$valid)? vm.getCnpjCaptcha($event, vm.person.national_id_number, vm.person) : \'\'\">Pesquisar</md-button></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.createTypePerson == 2 || vm.person.type == 2\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.person.name\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" placeholder=\"{{ \'PERSON.FORM_NAME_BUSINESS\' | translate }}\" md-maxlength=\"100\"><div ng-messages=\"formPerson.name.$error\" role=\"alert\"><div ng-message=\"required\">{{ \'PERSON.FORM_NAME_BUSINESS_REQUIRED\' | translate }}</div><div ng-message=\"md-maxlength\">O nome não pode ter mais de 100 caracteres.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-input-has-placeholder\" flex=\"\" ng-if=\"vm.createTypePerson == 1 || vm.person.type == 1\"><label for=\"cpf\" translate=\"PERSON.FORM_CPF\"></label> <input type=\"text\" name=\"national_id_number\" ng-model=\"vm.person.national_id_number\" ng-cpf=\"\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" mask=\"999.999.999-99\" clean=\"true\" id=\"cpf\"></md-input-container><md-input-container class=\"md-input-has-value\" ng-if=\"vm.createTypePerson == 1 || vm.person.type == 1\" flex=\"\"><label>{{ \'PERSON.FORM_SEX\' | translate }}</label><md-select name=\"sex\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" ng-model=\"vm.person.sex\"><md-option ng-value=\"sex.value\" ng-repeat=\"sex in vm.sexList\">{{ sex.name }}</md-option></md-select><div ng-messages=\"formPerson.sex.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_SEX_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.createTypePerson == 2 || vm.person.type == 2\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"corporate_name\" ng-model=\"vm.person.corporate_name\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" md-maxlength=\"100\" placeholder=\"{{ \'PERSON.FORM_CORPORATE_NAME\' | translate }}\"><div ng-messages=\"formPerson.corporate_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_CORPORATE_NAME_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">A razão não pode ter mais de 100 caracteres.</div></div></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"state_registration_number\" ng-model=\"vm.person.state_registration_number\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" ng-maxlength=\"30\" placeholder=\"{{ \'PERSON.FORM_STATE_REGISTRATION_NUMBER\' | translate }}\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.createTypePerson == 2 || vm.person.type == 2\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"main_contact_name\" ng-model=\"vm.person.main_contact_name\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" md-maxlength=\"100\" placeholder=\"{{ \'PERSON.FORM_MAIN_CONTACT_NAME\' | translate }}\"><div ng-messages=\"formPerson.main_contact_name.$error\" role=\"alert\"><div ng-message=\"md-maxlength\">O nome da pessoa não pode ter mais de 100 caracteres.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"25\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"email\" ng-model=\"vm.person.email\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" placeholder=\"{{ \'PERSON.FORM_EMAIL\' | translate }}\" md-maxlength=\"50\"><div ng-messages=\"formPerson.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_EMAIL_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O e-mail não pode ter mais de 50 caracteres.</div></div></md-input-container><md-input-container flex=\"25\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"phone_landline\" ng-model=\"vm.person.phone_landline\" placeholder=\"{{ \'PERSON.FORM_PHONE_LANDLINE\' | translate }}\" mask=\"(99) 9?9999-9999\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" clean=\"true\"><div ng-messages=\"formPerson.phone_landline.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_PHONE_LANDLINE_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"25\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"phone_landline_22\" ng-model=\"vm.person.phone_landline_2\" placeholder=\"{{ \'PERSON.FORM_PHONE_LANDLINE_2\' | translate }}\" mask=\"(99) 9?9999-9999\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" clean=\"true\"></md-input-container><md-input-container flex=\"25\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"phone_mobile\" ng-model=\"vm.person.phone_mobile\" placeholder=\"{{ \'PERSON.FORM_PHONE_MOBILE\' | translate }}\" mask=\"(99) 9?9999-9999\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" clean=\"true\"><div ng-messages=\"formPerson.phone_mobile.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_PHONE_MOBILE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"address_postal_code\" ng-model=\"vm.person.address_postal_code\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_POSTAL_CODE\' | translate }}\" ng-blur=\"vm.getAddressByCep(vm.person.address_postal_code, vm.person)\" validate-form=\"zip_code\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" validate-zipcode=\"\" ui-br-cep-mask=\"\"><div ng-messages=\"formPerson.address_postal_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_POSTAL_CODE_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"address_street\" ng-model=\"vm.person.address_street\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" md-maxlength=\"100\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_STREET\' | translate }}\"><div ng-messages=\"formPerson.address_street.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_STREET_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O endereço não pode ter mais de 50 caracteres.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"address_line2\" ng-model=\"vm.person.address_line2\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" md-maxlength=\"100\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_LINE2\' | translate }}\"><div ng-messages=\"formPerson.address_line2.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_LINE2_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O complemento não pode ter mais de 100 caracteres.</div></div></md-input-container><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"address_house_number\" ng-model=\"vm.person.address_house_number\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" ng-maxlength=\"30\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_HOUSE_NUMBER\' | translate }}\"><div ng-messages=\"formPerson.address_house_number.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_HOUSE_NUMBER_REQUIRED\' | translate }}</span></div><div ng-message=\"maxlength\">O número não pode ter mais de 30 caracteres.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\" class=\"md-input-has-placeholder\"><input type=\"text\" name=\"address_district\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" ng-model=\"vm.person.address_district\" md-maxlength=\"50\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_DISTRICT\' | translate }}\"><div ng-messages=\"formPerson.address_district.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_DISTRICT_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">O bairro não pode ter mais de 50 caracteres.</div></div></md-input-container><md-input-container class=\"md-input-has-placeholder\"><input type=\"text\" name=\"address_city\" ng-model=\"vm.person.address_city\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" md-maxlength=\"50\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_CITY\' | translate }}\"><div ng-messages=\"formPerson.address_city.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_CITY_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">A cidade não pode ter mais de 50 caracteres.</div></div></md-input-container><md-input-container class=\"md-input-has-placeholder\"><input type=\"text\" name=\"address_state\" ng-model=\"vm.person.address_state\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" md-maxlength=\"2\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_STATE\' | translate }}\"><div ng-messages=\"formPerson.address_state.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_STATE_REQUIRED\' | translate }}</span></div><div ng-message=\"md-maxlength\">Inserir somente a sigla do estado.</div></div></md-input-container></div><md-input-container layout=\"row\" class=\"md-input-has-placeholder\" ng-if=\"vm.person.type == 2 && !vm.person.is_company_mother\"><md-autocomplete flex=\"\" ng-disabled=\"vm.checkPolicies(\'pessoa_alt\')\" md-input-name=\"company_mother\" md-input-minlength=\"3\" md-input-maxlength=\"150\" md-delay=\"500\" md-no-cache=\"true\" md-selected-item=\"vm.company_mother_selected\" md-selected-item-change=\"vm.onAutoCompleteItemChange(vm.company_mother_selected)\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getPossibleMatrixCompany(vm.searchText)\" md-item-text=\"item.name\" md-require-match=\"\" md-menu-class=\"autocomplete-company_mother-template\" md-floating-label=\"Empresa Mãe\"><md-item-template><span class=\"item-title\"><md-icon md-font-icon=\"icon-city\"></md-icon><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></span> <span class=\"item-metadata\"><span><strong md-highlight-text=\"vm.searchText\">{{item.corporate_name}}</strong></span></span></md-item-template><div ng-messages=\"formPerson.company_mother.$error\" ng-if=\"formPerson.company_mother.$touched\"><div ng-message=\"md-require-match\">Digite uma empresa existente.</div><div ng-message=\"minlength\">Entre com no minimo 3 letras.</div><div ng-message=\"maxlength\">Minimo 50 letras.</div></div></md-autocomplete></md-input-container><div layout=\"column\" flex=\"\" ng-if=\"vm.person.children.length > 0\"><h3 style=\"margin-bottom: 0;\">Empresas Filhas</h3><md-table-container style=\"margin-top: 0; padding-top:0\"><table md-table=\"\" ng-model=\"vm.selected\"><thead md-head=\"\" md-order=\"vm.query.order\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.person.children\"><td md-cell=\"\">{{item.name}}<br><small>{{item.corporate_name}}</small></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeChildCompany(item.id)\"><md-tooltip md-direction=\"left\">Remover empresa filha</md-tooltip><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\" policy-access=\"pessoa_alt\"><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'PERSON.FORM_SUBMIT\' | translate }}\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"vm.loginProcess\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span ng-hide=\"vm.person.id == null\" translate=\"PERSON.FORM_UPDATE_SUBMIT\"></span> <span ng-show=\"vm.person.id == null\" translate=\"PERSON.FORM_CREATE_SUBMIT\"></span></md-button></footer></form></div></div></md-tab><div ui-view=\"expense\" policy-access=\"pessoa_fin\"></div><div ui-view=\"receipt\" policy-access=\"pessoa_fin\"></div><div ui-view=\"check\" policy-access=\"pessoa_fin\"></div></md-tabs></div>");
$templateCache.put("app/finance/person/person-receipt/view/history.html","<md-tab label=\"A Receber\" md-theme=\"finance\"><md-card ng-if=\"vm.pendencies_message != \'\' && vm.pendencies_message != null\"><md-content layout=\"row\"><div style=\"background-color: rgb(113, 0, 216); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-alert\" style=\"color: #fff;font-size: 30px;\"></i><br><span style=\"font-size: 18px; color: #fff;\" ng-bind-html=\"vm.pendencies_message\"></span></p></div></md-content></md-card><md-card ng-if=\"vm.has_debit\"><md-content layout=\"row\"><div style=\"background-color: rgb(20,133,50); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-clipboard-alert\" style=\"color: #fff;font-size: 30px;\"></i><br><span style=\"font-size: 18px; color: #fff;\">Existe um saldo de R$ {{vm.pending_differences | currency:\"\"}} em diferenças pendentes de serem <span ng-if=\"vm.has_credit\">creditadas</span><span ng-if=\"vm.has_debit\">cobradas</span>!</span></p></div></md-content></md-card><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.tabSelected\"><md-tab label=\"Títulos\"><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important\"><div ng-if=\"!vm.show\" style=\"background-color: rgb(20,133,50); width: 100%; height: auto;text-align: center;box-shadow: 7px 7px 10px #ccc;\"><p style=\"vertical-align: baseline;\"><i class=\"icon icon-clipboard-alert\" style=\"color: #fff;font-size: 30px;\"></i><br><span style=\"font-size: 18px; color: #fff;\">Não existem títulos disponíveis pra este filtro</span></p></div><a4-bill-grid debit-credit=\"C\" ng-model=\"vm.bills.receipts\" with-filter=\"false\" show_loader=\"vm.show_loader\" paginate-function=\"vm.getListOfReceiptFromPerson(page, qtd, date, person_id, status, flag, order, show_only_student)\" on-print-grid=\"vm.printBillsResponsible(date, status, all_bills)\" show-button-more=\"vm.show_button_more\" show-printer=\"true\" is-finance=\"true\" height-grid=\"vm.windowHeight\" person-id=\"vm.person_id\"></a4-bill-grid></md-content></md-tab><md-tab label=\"Contratos\"><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important\"><span layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.openCreateModal()\" class=\"md-primary\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Novo contrato</md-button></span><a4-contract-grid person-id=\"vm.person_id\" ng-if=\"vm.tabSelected == 1\" paginate-function=\"vm.getAllContracts(page, qtd, search_name)\" ng-model=\"vm.allContracts\" debit-credit=\"C\" show-loader=\"vm.show_loader\"></a4-contract-grid></md-content></md-tab><md-tab label=\"Negociações\"><a4-negotiation ng-if=\"vm.tabSelected == 2\" person-id=\"vm.person_id\"></a4-negotiation></md-tab><md-tab label=\"Boletos\"><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important\"><a4-bank-slip person-id=\"vm.person_id\" ng-if=\"vm.tabSelected == 3\"></a4-bank-slip></md-content></md-tab><md-tab label=\"Recibos de caixa\"><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important\"><a4-guest-check-pad-report person-id=\"vm.person_id\" ng-if=\"vm.tabSelected == 4\"></a4-guest-check-pad-report></md-content><md-tab ng-if=\"vm.has_credit\"><md-tab-label>Créditos <span class=\"badge\" style=\"margin-left: -4px;\" ng-if=\"vm.credit_balance > 0\"><span class=\"Ativo\">R$ {{vm.credit_balance}}</span></span></md-tab-label><md-tab-body><md-content class=\"btn-material-default\" style=\"background-color: whitesmoke !important\"><md-card layout-padding=\"\"><a4-credits-person person-id=\"vm.person_id\" balance=\"vm.credit_balance\"></a4-credits-person></md-card></md-content></md-tab-body></md-tab></md-tab></md-tabs></md-tab>");
$templateCache.put("app/finance/person/views/forms/form-person.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\" ng-init=\"vmForm = includeScope;\"><form name=\"formPerson\" ng-submit=\"vmForm.submitPerson(vm.currentItem);\"><div layout=\"row\" layout-align=\"space-between center\" ng-hide=\"vm.currentItem.id == null\"><div class=\"more secondary-text switch-edit-form\"><md-switch ng-model=\"vmForm.editable\" aria-label=\"\"></md-switch><md-button class=\"md-fab md-primary switch-edit-button\" aria-label=\"\"><md-icon ng-hide=\"!vmForm.editable\"><i class=\"material-icons\" aria-hidden=\"true\">close</i></md-icon><md-icon ng-show=\"!vmForm.editable\"><i class=\"material-icons\" aria-hidden=\"true\">mode_edit</i></md-icon></md-button></div></div><input type=\"hidden\" name=\"id\" ng-model=\"vm.currentItem.id\"> <input type=\"hidden\" name=\"id\" ng-model=\"vm.currentItem.type\" ng-bind=\"vm.currentItem.type = (vm.currentItem.id) ? vm.currentItem.type : vmForm.createTypePerson\"><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.currentItem.is_user\"><div ng-include=\"app/finance/person/views/forms/form-user.html\"></div></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vmForm.createTypePerson == 1 || vm.currentItem.type == 1\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.currentItem.name\" placeholder=\"{{ \'PERSON.FORM_NAME\' | translate }}\" ng-disabled=\"!vmForm.editable\" required=\"\"><div ng-messages=\"formPerson.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\" ng-if=\"vmForm.createTypePerson == 2 || vm.currentItem.type == 2\"><md-input-container flex=\"80\" class=\"md-input-has-placeholder\"><label for=\"cnpj\" translate=\"PERSON.FORM_CNPJ\"></label> <input type=\"text\" name=\"national_id_number\" ng-model=\"vm.currentItem.national_id_number\" ng-cnpj=\"\" mask=\"99.999.999/9999-99\" clean=\"true\" id=\"cnpj\" ng-disabled=\"!vmForm.editable\" flex=\"\"></md-input-container><md-input-container flex=\"20\"><md-button ng-click=\"(!formPerson.national_id_number.$valid)? vmForm.getCnpjCaptcha($event, vm.currentItem.national_id_number, vm.currentItem) : \'\'\">Pesquisar</md-button></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vmForm.createTypePerson == 2 || vm.currentItem.type == 2\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.currentItem.name\" placeholder=\"{{ \'PERSON.FORM_NAME_BUSINESS\' | translate }}\" ng-disabled=\"!vmForm.editable\" md-maxlength=\"30\"><div ng-messages=\"formPerson.name.$error\" role=\"alert\"><div ng-message=\"required\">{{ \'PERSON.FORM_NAME_BUSINESS_REQUIRED\' | translate }}</div><div ng-message=\"md-maxlength\">O nome não pode ter mais de 30 caracteres.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\" ng-if=\"vmForm.createTypePerson == 1 || vm.currentItem.type == 1\"><label for=\"cpf\" translate=\"PERSON.FORM_CPF\"></label> <input type=\"text\" name=\"national_id_number\" ng-model=\"vm.currentItem.national_id_number\" ng-cpf=\"\" mask=\"999.999.999-99\" clean=\"true\" id=\"cpf\" ng-disabled=\"!vmForm.editable\"></md-input-container><md-input-container ng-if=\"vmForm.createTypePerson == 1 || vm.currentItem.type == 1\"><md-datepicker name=\"dob\" ng-model=\"vm.currentItem.dob\" placeholder=\"{{ \'PERSON.FORM_DOB\' | translate }}\" ng-disabled=\"!vmForm.editable\"></md-datepicker><div ng-messages=\"formPerson.dob.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_DOB_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container ng-if=\"vmForm.createTypePerson == 1 || vm.currentItem.type == 1\"><label>{{ \'PERSON.FORM_SEX\' | translate }}</label><md-select name=\"sex\" ng-model=\"vm.currentItem.sex\" ng-disabled=\"!vmForm.editable\"><md-option ng-value=\"sex.value\" ng-repeat=\"sex in vmForm.sexList\" ng-disabled=\"!vmForm.editable\">{{ sex.name }}</md-option></md-select><div ng-messages=\"formPerson.sex.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_SEX_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vmForm.createTypePerson == 2 || vm.currentItem.type == 2\"><md-input-container flex=\"\"><input type=\"text\" name=\"corporate_name\" ng-model=\"vm.currentItem.corporate_name\" placeholder=\"{{ \'PERSON.FORM_CORPORATE_NAME\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.corporate_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_CORPORATE_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"state_registration_number\" ng-model=\"vm.currentItem.state_registration_number\" placeholder=\"{{ \'PERSON.FORM_STATE_REGISTRATION_NUMBER\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.state_registration_number.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_STATE_REGISTRATION_NUMBER_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vmForm.createTypePerson == 2 || vm.currentItem.type == 2\"><md-input-container flex=\"\"><input type=\"text\" name=\"main_contact_name\" ng-model=\"vm.currentItem.main_contact_name\" placeholder=\"{{ \'PERSON.FORM_MAIN_CONTACT_NAME\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.main_contact_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_MAIN_CONTACT_NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"email\" ng-model=\"vm.currentItem.email\" placeholder=\"{{ \'PERSON.FORM_EMAIL\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_EMAIL_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"phone_landline\" ng-model=\"vm.currentItem.phone_landline\" placeholder=\"{{ \'PERSON.FORM_PHONE_LANDLINE\' | translate }}\" ng-disabled=\"!vmForm.editable\" mask=\"(99) 9?9999-9999\" clean=\"true\"><div ng-messages=\"formPerson.phone_landline.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_PHONE_LANDLINE_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"phone_mobile\" ng-model=\"vm.currentItem.phone_mobile\" placeholder=\"{{ \'PERSON.FORM_PHONE_MOBILE\' | translate }}\" ng-disabled=\"!vmForm.editable\" mask=\"(99) 9?9999-9999\" clean=\"true\"><div ng-messages=\"formPerson.phone_mobile.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_PHONE_MOBILE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container><input type=\"text\" name=\"address_postal_code\" ng-model=\"vm.currentItem.address_postal_code\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_POSTAL_CODE\' | translate }}\" ng-disabled=\"!vmForm.editable\" ng-blur=\"vmForm.getAddressByCep(vm.currentItem.address_postal_code, vm.currentItem)\" validate-form=\"zip_code\" validate-zipcode=\"\" ui-br-cep-mask=\"\"><div ng-messages=\"formPerson.address_postal_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_POSTAL_CODE_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"address_street\" ng-model=\"vm.currentItem.address_street\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_STREET\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.address_street.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_STREET_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_line2\" ng-model=\"vm.currentItem.address_line2\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_LINE2\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.address_line2.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_LINE2_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_house_number\" ng-model=\"vm.currentItem.address_house_number\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_HOUSE_NUMBER\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.address_house_number.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_HOUSE_NUMBER_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"address_district\" ng-model=\"vm.currentItem.address_district\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_DISTRICT\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.address_district.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_DISTRICT_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_city\" ng-model=\"vm.currentItem.address_city\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_CITY\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.address_city.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_CITY_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container><input type=\"text\" name=\"address_state\" ng-model=\"vm.currentItem.address_state\" placeholder=\"{{ \'PERSON.FORM_ADDRESS_STATE\' | translate }}\" ng-disabled=\"!vmForm.editable\"><div ng-messages=\"formPerson.address_state.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_ADDRESS_STATE_REQUIRED\' | translate }}</span></div></div></md-input-container></div><hr><small class=\"required-fields\"><strong>*</strong> Campos necessários</small><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.toggleSidenav(\'sidenav-form\')\">Cancelar</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"{{ \'PERSON.FORM_SUBMIT\' | translate }}\" ng-disabled=\"formPerson.$invalid\"><md-progress-circular style=\"float: left; top: 8px; left: 100px;\" ng-show=\"vm.loginProcess\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span ng-hide=\"vm.currentItem.id == null\" translate=\"PERSON.FORM_UPDATE_SUBMIT\"></span> <span ng-show=\"vm.currentItem.id == null\" translate=\"PERSON.FORM_CREATE_SUBMIT\"></span></md-button></footer></form></div>");
$templateCache.put("app/finance/person/views/forms/form-user.html","<fieldset class=\"standard group-field\"><legend>{{ \'PERSON.DATA_USER\' | translate }}</legend><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"username\" ng-model=\"vm.currentItem.username\" placeholder=\"{{ \'PERSON.FORM_USERNAME\' | translate }}\" ng-required=\"{{ vm.currentItem.is_user }}\"><div ng-messages=\"formPerson.username.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_USERNAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.currentItem.password\" placeholder=\"{{ \'PERSON.FORM_PASSWORD\' | translate }}\" ng-required=\"{{ vm.currentItem.is_user }}\"><div ng-messages=\"formPerson.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_PASSWORD_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"password\" name=\"password_confirm\" ng-model=\"vm.currentItem.password_confirm\" placeholder=\"{{ \'PERSON.FORM_PASSWORD_CONFIRM\' | translate }}\" ng-required=\"{{ vm.currentItem.is_user }}\"><div ng-messages=\"formPerson.password_confirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'PERSON.FORM_PASSWORD_CONFIRM_REQUIRED\' | translate }}</span></div></div></md-input-container></div></fieldset>");
$templateCache.put("app/finance/person/views/sidenavs/sidenav.html","<div layout=\"row\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-hide=\"includeScope.createTypePerson\">{{ \'PERSON.TITLE_PERSON\' | translate }}</span> <span class=\"title\" ng-show=\"includeScope.createTypePerson\">{{ \'PERSON.TITLE_COMPANY\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'sidenav-form\')\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"PERSON.CLOSE_SIDENAV_EDIT\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex=\"\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div class=\"avatar-wrapper\"><img class=\"md-avatar avatar contact-avatar huge\" src=\"assets/images/avatars/profile.jpg\"></div><div class=\"contact-name\">{{ includeScope.person.name }}</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div flex=\"\" layout=\"row\" layout-align=\"center center\"></div></div></md-toolbar><div class=\"content\"><div class=\"sidenav-form\" ng-include=\"\'app/finance/person/views/forms/form-person.html\'\"></div></div></div>");
$templateCache.put("app/finance/reports/bill-charge-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-receipt\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de status de cobranças</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 30%;\"><md-input-container style=\"width: 100%\"><md-select ng-model=\"vm.charge_selected\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-repeat=\"status in vm.bill_charge_status\" ng-value=\"status.id\">{{((status.name).replace(\'_\', \' \')).replace(\'_\', \' \')}}</md-option></md-select></md-input-container></md-dialog-content></md-card><md-dialog-actions layout=\"row\" layout-align=\"center center\" style=\"background-color: whitesmoke; margin-top: 20px;\"><md-button class=\"md-raised md-primary\" style=\"padding: 5px;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReportPDF()\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>Imprimir relatório em PDF</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 5px;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReportCSV()\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>Imprimir relatório em CSV</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/cashier-session-resume/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-cash-usd\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Resumo das sessões de caixa</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 30%;\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de datas do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-click=\"vm.disable = false\"></date-range-picker><md-input-container><label>Usuário do caixa</label><md-select ng-model=\"vm.user_report\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-repeat=\"person in vm.persons\" ng-value=\"person.id\">{{person.name}}</md-option></md-select></md-input-container></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-cash-usd\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/collaborators-protocol/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Protocolo para colaboradores</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 50%;\"><md-input-container style=\"width: 100%\"><label>Nome do protocolo</label> <input ng-model=\"vm.report_name\"></md-input-container><div layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.only_teachers\">Apenas professores</md-checkbox></md-input-container><md-input-container><md-checkbox ng-if=\"vm.companyQty>1\" ng-model=\"vm.all_companies\">Todas as empresas</md-checkbox></md-input-container></div><strong class=\"group-field\"><span ng-if=\"vm.only_teachers\">Professores das turmas:</span></strong><treeview ng-if=\"vm.only_teachers\" data=\"vm.coursesAndGroups\" response=\"vm.selectedCoursesAndGroups\"></treeview></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-disabled=\"vm.report_name === null\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon>Imprimir protocolo</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/current-account-movements/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-elevation-rise\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Detalhamento de movimentos de conta corrente</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 30%;\"><md-input-container><label>Conta corrente</label><md-select ng-model=\"vm.selectedCurrentAccount\"><md-option ng-repeat=\"currentAccount in vm.currentAccounts\" ng-value=\"currentAccount.id\">{{currentAccount.name}}</md-option></md-select></md-input-container><date-range-picker flex=\"100\" ng-model=\"vm.filterDate\" label=\"Faixa de data do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-click=\"vm.generateReport()\" ng-disabled=\"!vm.selectedCurrentAccount\"><md-icon md-font-icon=\"icon-elevation-rise\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/defaults-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-book-multiple-variant\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de Inadimplência</div></div><md-button class=\"md-raised md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.printDefaultsReport()\" aria-label=\"add\" translate=\"\"><md-tooltip md-direction=\"left\">{{ \'REPORTS.PRINT\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-printer\" style=\"color: green\"></md-icon></md-button></md-toolbar><md-card layout=\"column\"><div layout=\"column\" flex=\"100\"><div layout=\"row\"><date-range-picker flex=\"30\" ng-model=\"vm.filter_date\" label=\"Datas\" style=\"padding: 5px 18px;\"></date-range-picker><md-input-container flex=\"15\" class=\"md-input-has-placeholder\" flex-sm=\"15\" flex-md=\"15\" flex-xs=\"100\" style=\"margin-top: 24px;\"><label>Quantidade mínima de títulos vencidos</label><md-icon md-font-icon=\"icon-note-outline\"></md-icon><input ng-model=\"vm.qty_bills\"></md-input-container><div flex=\"5\" style=\"margin: 18px 0;\"><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Buscar\" ng-click=\"vm.getFinancialDefaultReport(1, 10)\"><md-tooltip md-direction=\"bottom\">Buscar</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><md-table-pagination flex=\"\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.financial_default.per_page\" md-page=\"vm.financial_default.current_page\" md-limit-options=\"[10, 25, 50]\" style=\"border-top: none\" md-total=\"{{vm.financial_default.total}}\" md-on-paginate=\"vm.getFinancialDefaultReport\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" flex=\"\"><md-input-container flex=\"15\" class=\"md-input-has-placeholder\" flex-sm=\"15\" flex-md=\"15\" flex-xs=\"100\" style=\"margin-top: 24px;margin-left: 19px;\"><label>Agrupar por:</label><md-radio-group ng-model=\"vm.group_type\" layout=\"row\" style=\"margin-top: 5px;\"><md-radio-button ng-value=\"1\">Responsável</md-radio-button><md-radio-button ng-value=\"2\">Beneficiário</md-radio-button></md-radio-group></md-input-container></div><div><md-input-container class=\"md-input-has-placeholder\" style=\"margin-top: 24px;margin-left: 19px;\"><label>Filtrar por:</label><md-radio-group ng-model=\"vm.service_filter\" layout=\"row\" style=\"margin-top: 5px;\"><md-radio-button ng-value=\"1\">Turmas e demais serviços</md-radio-button><md-radio-button ng-value=\"2\">Apenas as turmas</md-radio-button><md-radio-button ng-value=\"3\">Apenas os demais serviços</md-radio-button></md-radio-group></md-input-container><md-input-container flex=\"\" style=\"margin-left: 10px; width: 10%;\"><label>Filtro por curso</label><md-select ng-model=\"vm.course_id\" ng-change=\"vm.getGroups(vm.course_id)\" required=\"\"><md-option ng-repeat=\"course in vm.courses\" ng-value=\"course.id\">{{course.name}}</md-option><md-option ng-value=\"0\">Todos os cursos</md-option></md-select></md-input-container><md-input-container flex=\"\" style=\"margin-left: 10px; width: 10%;\"><label>Filtro por turma</label><md-select ng-model=\"vm.group_id\" required=\"\"><md-option ng-repeat=\"group in vm.groups | orderBy:\'id\'\" ng-value=\"group.id\">{{group.name}}</md-option><md-option ng-if=\"((vm.groups.length === 0 || vm.groups === null) && vm.print.course_selected !== null)\" value=\"0\">Todas as turmas</md-option></md-select></md-input-container></div><md-input-container layout=\"column\" style=\"margin-left: 10px;\"><md-checkbox ng-model=\"vm.filter_school_period\">Filtrar por período letivo. Período letivo selecionado: <b>{{vm.current_school_period_name}}</b></md-checkbox></md-input-container></div><div flex=\"100\" ng-if=\"vm.current_school_period_id !== null\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117);margin-left: 10px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Cursos, turmas, produtos e serviços</b> <small>Opcionalmente selecione abaixo cursos, turmas, produtos e serviços que deseja filtrar para o relatório.<br><br><b>ATENÇÃO</b> o periodo letívo selecionado no educacional interfere na busca das inadimplências utilizando as opções abaixo. Período letivo selecionado: <b>{{vm.current_school_period_name}}</b></small></div></div><div flex=\"\" layout=\"row\" class=\"md-padding\"><md-input-container flex=\"30\" class=\"md-block md-input-has-placeholder\" ng-required=\"vm.default_report.bank_slip_rule_id === null\"><label>Produto/serviço por Curso/Grupo</label><md-icon md-font-icon=\"icon-group\"></md-icon><md-select name=\"group_service_list\" ng-model=\"vm.default_report.product_group_id\" aria-label=\"Curso\" md-on-open=\"vm.allProductGroups()\" ng-change=\"vm.getProductsByGroup(vm.default_report.product_group_id)\"><md-optgroup label=\"Cursos grupos de produtos e de serviços\"><md-option ng-repeat=\"product_group in vm.product_groups track by $index\" ng-value=\"product_group.id\">{{product_group.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"50\" class=\"md-block md-input-has-placeholder\" ng-required=\"vm.default_report.bank_slip_rule_id === null\"><label>Produtos/serviços por turma</label><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><md-select name=\"service_list\" ng-model=\"vm.default_report.product_ids\" multiple=\"\" ng-required=\"vm.default_report.product_group_id !== undefined\" ng-disabled=\"vm.default_report.product_group_id == null\" ng-change=\"vm.setProducts(vm.default_report.product_ids)\" aria-label=\"turmas\"><md-optgroup label=\"Turmas produtos e serviços\"><md-option ng-repeat=\"product in vm.products track by $index\" ng-value=\"product.product_id\">{{product.group_name}}</md-option></md-optgroup></md-select><div ng-messages=\"bankslipform.service_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um ou mais turmas.</div></div></md-input-container></div></div></md-card><md-card ng-repeat=\"clientrecords in vm.financial_default.data\" style=\"margin-top: 20px; margin-bottom: 20px;padding-right: 8px;\"><div layout=\"column\" flex=\"\" layout-padding=\"\"><md-table-container style=\"margin-top: 0; padding-top:0\"><table md-table=\"\"><thead md-head=\"\" ng-if=\"true\" md-promise=\"vm.promise\" style=\"height: 0px;position: absolute;\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\"></th><th md-column=\"\" md-numeric=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat-start=\"item in clientrecords\" ng-if=\"item.level == 1\" style=\"background-color: rgba(200,194,199,0.22);\"><td md-cell=\"\" flex=\"10\" align=\"left\" style=\"width: 30%\"><b>{{item.person_name}} {{item.enrolment_number != null ? \'(\'+item.enrolment_number+\')\' : \'\'}}</b></td><td md-cell=\"\" align=\"left\" style=\"width: 20%\"></td><td md-cell=\"\" align=\"left\" style=\"width: 10%\"><b>{{item.qty}}</b></td><td md-cell=\"\" md-numeric=\"\" style=\"width: 20%\"><b>{{item.amount_base | currency:\" \"}}</b></td><td md-cell=\"\" md-numeric=\"\" style=\"width: 20%\"><b>{{item.final_value | currency:\" \"}}</b></td></tr><tr md-row=\"\" ng-if=\"item.level == 2 && (clientrecords[0].person_id != clientrecords[1].person_id_beneficiary || vm.group_type == 2)\" style=\"background-color: rgba(180,180,180,0.22);\"><td md-cell=\"\" flex=\"10\" align=\"left\" style=\"width: 30%\"><b>{{item.person_beneficiary_name}} {{item.enrolment_number != null ? \'(\'+item.enrolment_number+\')\' : \'\'}}</b></td><td md-cell=\"\" align=\"left\" style=\"width: 20%\"></td><td md-cell=\"\" align=\"left\" style=\"width: 10%\"><b>{{item.qty}}</b></td><td md-cell=\"\" md-numeric=\"\" style=\"width: 20%\"><b>{{item.amount_base | currency:\" \"}}</b></td><td md-cell=\"\" md-numeric=\"\" style=\"width: 20%\"><b>{{item.final_value | currency:\" \"}}</b></td></tr><tr md-row=\"\" ng-if=\"item.level == 2 && (item.person_id != item.person_id_beneficiary || vm.group_type == 2)\"><td md-cell=\"\" flex=\"10\" align=\"left\" style=\"width: 30%\"><b>Descrição</b></td><td md-cell=\"\" align=\"left\" style=\"width: 20%\"><b>Vencimento</b></td><td md-cell=\"\" align=\"left\" style=\"width: 10%\"><b>Dias</b></td><td md-cell=\"\" md-numeric=\"\" style=\"width: 20%\" align=\"right\"><b>Valor</b></td><td md-cell=\"\" md-numeric=\"\" style=\"width: 20%\" align=\"right\"><b>Valor Atualizado</b></td></tr><tr md-row=\"\" ng-repeat-end=\"\" ng-if=\"item.level == 3\"><td md-cell=\"\" align=\"left\" style=\"width: 30%\">{{item.product_name != null && item.product_name != \'\' ? item.product_name : (item.description != null ? item.description : item.bank_slip_rule_name)}} {{item.instalment_name !== null ? \' | \' + item.instalment_name : \'\'}}</td><td md-cell=\"\" align=\"left\" style=\"width: 20%\">{{item.due_date | date:\"dd/MM/yyyy\"}}</td><td md-cell=\"\" align=\"left\" style=\"width: 10%\">{{item.days}}</td><td md-cell=\"\" md-numeric=\"\" style=\"width: 20%\" align=\"right\">{{item.amount_base | currency:\" \"}}</td><td md-cell=\"\" md-numeric=\"\" style=\"width: 20%\" align=\"right\">{{item.final_value | currency:\" \"}}</td></tr></tbody></table></md-table-container></div></md-card><md-card><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-limit=\"vm.financial_default.per_page\" md-page=\"vm.financial_default.current_page\" md-limit-options=\"[10, 25, 50]\" style=\"border-top: none\" flex=\"\" md-total=\"{{vm.financial_default.total}}\" md-on-paginate=\"vm.getFinancialDefaultReport\" md-page-select=\"\"></md-table-pagination></md-card>");
$templateCache.put("app/finance/reports/deleted-bills-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Títulos excluídos</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 30%;\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa do vencimento do título\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker><md-input-container class=\"md-input-has-placeholder\"><input ng-model=\"vm.bank_number\" type=\"number\" placeholder=\"Nosso número (opcional)\"></md-input-container><md-autocomplete flex=\"80\" md-no-cache=\"true\" md-selected-item=\"vm.selectedPerson\" md-min-length=\"0\" md-search-text=\"searchText\" md-items=\"item in vm.getPersonByName(searchText)\" md-item-text=\"item.name\" md-delay=\"500\" md-floating-label=\"Selecione uma pessoa (opcional)\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Pessoa não encontrada</md-not-found></md-autocomplete></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/designed-realized-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-cash-100\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Projeção x Realizado</div></div><md-button class=\"md-icon-button\" ng-click=\"vm.printReport( )\"><md-icon>print</md-icon><md-tooltip md-direction=\"bottom\">Imprimir relatório</md-tooltip></md-button></md-toolbar><md-content class=\"md-padding\" layout-padding=\"\"><md-card layout=\"row\" layout-align=\"center center\"><div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"70\"><div layout=\"row\"><md-dialog-content layout=\"column\" flex=\"\"><label>Datas de vencimento entre</label><date-range-picker flex=\"\" ng-model=\"vm.filter_date\" label=\"\" ranges=\"vm.ranges\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></md-dialog-content><md-dialog-content layout=\"column\" flex=\"\"><label>Datas de pagamento entre</label><date-range-picker flex=\"\" ng-model=\"vm.filter_settlement_date\" label=\"\" ranges=\"vm.ranges\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></md-dialog-content></div><div layout=\"row\"><md-dialog-content layout=\"column\" flex=\"\"><label>Curso e turma</label><div layout=\"row\"><treeview data=\"vm.coursesAndGroups\" response=\"vm.selectedCoursesAndGroups\"></treeview></div></md-dialog-content></div><div><md-dialog-content layout=\"column\" flex=\"\"><label>Tipo de visão</label><md-input-container class=\"md-input-has-placeholder\" flex=\"\" placeholder=\"Tipo de visão\"><md-select ng-model=\"vm.report_vision\" ng-change=\"vm.defineReportVision()\"><label>Tipo de visão</label><md-option ng-value=\"0\">Por serviço</md-option><md-option ng-value=\"2\">Por mês</md-option></md-select></md-input-container></md-dialog-content></div></div><div layout=\"column\" flex=\"\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-disabled=\"vm.form.period === null\" ng-click=\"vm.getDesignedRealizedReport(vm.filter_date, vm.filter_settlement_date, vm.course_selected_id, vm.group_selected_id)\"><md-icon md-font-icon=\"icon-search\"></md-icon>Filtrar relatório</md-button></div></div></md-card><md-card class=\"md-padding\" style=\"background-color: #fdfcf9; border-left: 4px solid #4fb342; margin-top: 16px;\"><div layout=\"column\"><div style=\"font-weight: bold; margin-bottom: 8px; color: #050505;\"><md-icon md-font-icon=\"icon-information\" style=\"color: #4fb342; vertical-align: middle;\"></md-icon>Observações</div><ul style=\"margin: 0; padding-left: 20px; color: #070807;\"><li style=\"margin-bottom: 4px;\">Os títulos com desconto integral (100%) não estão incluídos neste relatório.</li><li>Do ponto de vista dos valores esperados, este relatório não considera reprogramações de títulos, sejam elas de datas ou de valores, mantendo sempre as informações originais.</li></ul></div></md-card><div><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selected_tab\"><md-tab label=\"Gerado\"><md-content style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" layout=\"column\"><md-content layout=\"column\"><a4-tree-grid tree-data=\"vm.tree_data\" col-defs=\"vm.col_defs_1\" expand-on=\"vm.expanding_property\" class-selected=\"\'report\'\" expand-level=\"1\" icon-leaf=\'row.branch.children.length <= 0 && row.level == 2 ? \"no-icon\" : \"icon-file\"\' icon-expand=\'row.branch.children.length > 0 && !row.branch.expanded ? \"icon-plus\" : \"icon-minus\"\' icon-collapse=\'row.branch.children.length > 0 && row.branch.expanded ? \"icon-minus\" : \"icon-plus\"\'></a4-tree-grid></md-content></md-card></md-content></md-tab><md-tab label=\"Recebidos\"><md-content style=\"background-color: whitesmoke !important;\"><md-card class=\"md-padding\" layout=\"column\"><md-content layout=\"column\"><a4-tree-grid tree-data=\"vm.tree_data\" col-defs=\"vm.col_defs_2\" expand-on=\"vm.expanding_property\" class-selected=\"\'report\'\" expand-level=\"1\" icon-leaf=\'row.branch.children.length <= 0 && row.level == 2 ? \"no-icon\" : \"icon-file\"\' icon-expand=\'row.branch.children.length > 0 && !row.branch.expanded ? \"icon-plus\" : \"icon-minus\"\' icon-collapse=\'row.branch.children.length > 0 && row.branch.expanded ? \"icon-minus\" : \"icon-plus\"\'></a4-tree-grid></md-content></md-card></md-content></md-tab><md-tab label=\"Em aberto\"><md-card class=\"md-padding\" layout=\"column\"><md-content layout=\"column\"><a4-tree-grid tree-data=\"vm.tree_data\" col-defs=\"vm.col_defs_3\" expand-on=\"vm.expanding_property\" class-selected=\"\'report\'\" expand-level=\"1\" icon-leaf=\'row.branch.children.length <= 0 && row.level == 2 ? \"no-icon\" : \"icon-file\"\' icon-expand=\'row.branch.children.length > 0 && !row.branch.expanded ? \"icon-plus\" : \"icon-minus\"\' icon-collapse=\'row.branch.children.length > 0 && row.branch.expanded ? \"icon-minus\" : \"icon-plus\"\'></a4-tree-grid></md-content></md-card></md-tab></md-tabs></div></md-content>");
$templateCache.put("app/finance/reports/differences-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-cash\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de diferenças</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><legend>Filtro:</legend><md-dialog-content><md-input-container><md-radio-group ng-model=\"vm.difference_option\" layout=\"row\"><md-radio-button value=\"0\">Títulos de diferença</md-radio-button><md-radio-button value=\"1\">Diferenças pendentes</md-radio-button><md-radio-button value=\"2\">Diferenças abonadas</md-radio-button></md-radio-group></md-input-container><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de datas do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-click=\"vm.disable = false\"></date-range-picker></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-cash\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/finance-movement-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-cash-100\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Movimento financeiro</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout=\"row\" layout-align=\"center center\"><div layout=\"column\"><div layout=\"row\"><md-dialog-content layout=\"column\"><label>Período do movimento</label><md-input-container><md-radio-group ng-model=\"vm.form.period_type\" ng-change=\"vm.verifyDate()\"><md-radio-button ng-value=\"0\"><span>Diário</span></md-radio-button><md-radio-button ng-value=\"1\">Por periodo</md-radio-button></md-radio-group></md-input-container></md-dialog-content><div layout=\"column\" layout-align=\"center center\"><date-picker ng-if=\"vm.form.period_type === 0\" ng-model=\"vm.form.period\" label=\"Dia\"></date-picker><date-range-picker ng-model=\"vm.form.period\" label=\"Período\" ng-if=\"vm.form.period_type === 1\"></date-range-picker></div></div><md-divider></md-divider><md-dialog-content layout=\"column\"><label>Filtro</label><md-input-container><md-radio-group ng-model=\"vm.form.filter\" layout=\"row\"><md-radio-button ng-value=\"0\">Caixa e banco</md-radio-button><md-radio-button ng-value=\"1\">Caixa</md-radio-button><md-radio-button ng-value=\"2\">Banco</md-radio-button></md-radio-group></md-input-container><md-input-container ng-if=\"vm.form.filter === 0\"><label>Filtro</label><md-select ng-model=\"vm.form.cashier_session\"><md-option ng-value=\"null\">Todos os caixas e bancos</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.form.filter === 1\"><label>Sessões de caixa</label><md-select ng-model=\"vm.form.cashier_session\"><md-option ng-value=\"null\">Todas/baixa manual</md-option><md-option ng-repeat=\"session in vm.cashier_sessions\" ng-value=\"session.id\">Sessão {{session.id}}</md-option></md-select></md-input-container></md-dialog-content></div><div style=\"margin-left: 75px;\"><md-dialog-content layout=\"column\"><label>Relatórios</label><md-input-container layout=\"column\"><md-checkbox ng-model=\"vm.form.finance_movement\" style=\"margin-left: 0\">Movimento financeiro</md-checkbox><md-checkbox ng-model=\"vm.form.received_bills\" style=\"margin-left: 0;\">Parcelas recebidas</md-checkbox><div style=\"padding-left: 30px;\"><md-checkbox ng-model=\"vm.form.enrolment_number\" ng-disabled=\"!vm.form.received_bills\" style=\"margin-left: 0;\">Exibir números de matrícula</md-checkbox></div><div style=\"padding-left: 30px;\"><div>Totalização da cobrança</div><md-input-container><md-radio-group ng-model=\"vm.form.totalization_type\" layout=\"column\" ng-disabled=\"!vm.form.received_bills\"><md-radio-button ng-value=\"\'C\'\" style=\"margin-left: 0;\">Por curso</md-radio-button><md-radio-button ng-value=\"\'G\'\" style=\"margin-left: 0;\">Por turma</md-radio-button></md-radio-group></md-input-container></div></md-input-container></md-dialog-content></div><md-dialog-content><md-input-container layout=\"column\"><md-checkbox ng-model=\"vm.form.detail_finance_movement\" ng-disabled=\"vm.form.filter==2\" style=\"margin-left: 0\" ng-checked=\"vm.form.filter!=2\">Entradas e saídas avulsas</md-checkbox><md-checkbox ng-model=\"vm.form.products_sold\" style=\"margin-left: 0;\">Produtos vendidos</md-checkbox><md-checkbox ng-model=\"vm.form.money_details\" style=\"margin-left: 0;\">Detalhamento dos recebimentos em dinheiro</md-checkbox><md-checkbox ng-model=\"vm.form.check_details\" style=\"margin-left: 0;\">Detalhamento dos cheques</md-checkbox><md-checkbox ng-model=\"vm.form.card_details\" style=\"margin-left: 0;\">Detalhamento dos cartões</md-checkbox><md-checkbox ng-model=\"vm.form.transference_details\">Detalhamento das transferências</md-checkbox></md-input-container></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke; margin-top: 20px;\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-disabled=\"vm.form.period === null\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-cash-100\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/income-tax-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-cash-multiple\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de Imposto de Renda</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"row\" style=\"width: 50%; height: 100px;\"><md-autocomplete flex=\"80\" md-no-cache=\"true\" md-selected-item=\"vm.selectedPerson\" md-min-length=\"0\" md-search-text=\"searchText\" md-items=\"item in vm.getPersonPayeeByName(searchText)\" md-item-text=\"item.string\" md-delay=\"500\" md-floating-label=\"Selecione um responsável financeiro\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.string}}</span></md-item-template><md-not-found>Responsável financeiro não encontrado.</md-not-found></md-autocomplete><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\"><label>Ano</label><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-select name=\"month_list\" ng-model=\"vm.year\" required=\"\" aria-label=\"ano\"><md-option ng-repeat=\"year in vm.years\" ng-value=\"year.id\">{{year.name}}</md-option></md-select></md-input-container></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-cash-multiple\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/monthly-financial-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"md-ink-ripple\" type=\"button\" aria-label=\"Go to reports\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-timetable\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de Fluxo Financeiro</div></div></md-toolbar><md-card layout-padding=\"\"><script type=\"text/ng-template\" id=\"tree_node\"><tr tt-node is-branch=\"!node.is_leaf\"> <td><span ng-bind=\"node.name\"></span></td> <td class=\"md-numeric\" ng-bind=\'column | currency:\" \" \' ng-repeat=\"column in node.columns\"></td> </tr></script><md-table-container><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout-align=\"space-between\"><md-input-container flex=\"40\" align=\"left\" style=\"font-size: 15px\"><label>Visualização</label><md-select ng-model=\"vm.visualization\"><md-option ng-value=\"2\">Regime de competência</md-option></md-select></md-input-container><div flex=\"30\" layout=\"row\" style=\"margin: 0;\" align=\"right\"><div flex=\"\" layout=\"row\" style=\"margin: 14px 0;\"><div flex=\"\" md-ink-ripple=\"\" style=\"position: relative; cursor: pointer;text-align: center;\" ng-click=\"vm.previousDate()\"><button class=\"md-icon-button\"><md-icon md-font-icon=\"icon-chevron-left\" style=\"color: black!important;\"></md-icon></button></div><div layout=\"row\" flex=\"50\" align=\"center\"><div flex=\"\" style=\"font-size: 15px;font-weight: bold;padding: 7px 20px 0 20px;\">{{vm.dateComponent.range.start_date.format(\'MMM/YY\')}}</div><div flex=\"\" style=\"font-size: 15px;font-weight: bold;padding: 7px 20px 0 20px;\">a</div><div flex=\"\" style=\"font-size: 15px;font-weight: bold;padding: 7px 20px 0 20px;\">{{vm.dateComponent.range.end_date.format(\'MMM/YY\')}}</div></div><div flex=\"\" md-ink-ripple=\"\" style=\"position: relative; cursor: pointer;text-align: center;\" ng-click=\"vm.nextDate()\"><button class=\"md-icon-button md-ink-ripple\"><md-icon md-font-icon=\"icon-chevron-right\" style=\"color: black!important;\"></md-icon></button></div></div></div><md-input-container flex=\"\" align=\"right\" style=\"margin: 11px;\"><a ng-click=\"vm.print()\" class=\"md-button md-raised md-ink-ripple\" style=\"background-color: rgb(8,204,117); color: white;\"><md-icon md-font-icon=\"icon-printer\" style=\"color: white\"></md-icon>Imprimir</a></md-input-container></div></md-toolbar><table id=\"tree-table\" tt-table=\"\" tt-params=\"dynamic_params\"><thead class=\"tree-table-head\"><tr><th>Categoria</th><th class=\"md-numeric\" ng-repeat=\"(key, column) in vm.columns\">{{column}}</th></tr></thead><tbody class=\"tree-table-body\"><tr><td>Saldo do mês</td><td class=\"md-numeric\" ng-repeat=\"(key, column) in vm.columns\" ng-class=\"{negativeValue: (vm.incomes[column]-vm.expenses[column]) < 0}\">{{(vm.incomes[column]-vm.expenses[column]) | currency:\" \" }}</td></tr><tr><td>Saldo acumulado</td><td ng-class=\"{negativeValue: item.accumulated < 0}\" class=\"md-numeric\" ng-repeat=\"item in vm.accumulated_balance track by $index\">{{item | currency:\" \"}}</td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/finance/reports/monthly-receive-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-debug-step-into\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de mensalidades</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 30%;\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de datas do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-click=\"vm.disable = false\"></date-range-picker></md-dialog-content></md-card><md-dialog-actions layout=\"row\" layout-align=\"center center\" style=\"background-color: whitesmoke; margin-top: 20px;\"><md-button class=\"md-raised md-primary\" style=\"padding: 5px;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReportPDF()\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>Imprimir relatório em PDF</md-button><md-button class=\"md-raised md-primary\" style=\"padding: 5px;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReportCSV()\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>Imprimir relatório em CSV</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/negotiations-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-briefcase\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de negociações</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 30%;\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de data das negociações\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\"></date-range-picker></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-briefcase\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/payments-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-arrow-down-bold-circle\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Títulos por tipo de baixa</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 30%;\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de datas do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-click=\"vm.disable = false\"></date-range-picker><md-input-container layout=\"column\"><span style=\"margin-bottom: 5px;\">Tipo de baixa</span><md-radio-group ng-model=\"vm.type\" layout=\"row\"><md-radio-button ng-value=\"\'manual\'\">Baixa manual</md-radio-button><md-radio-button ng-value=\"\'bank\'\">Arquivo retorno</md-radio-button><md-radio-button ng-value=\"\'cashier_session\'\">Baixa no caixa</md-radio-button><md-radio-button ng-value=\"\'all\'\">Todos os tipos</md-radio-button></md-radio-group></md-input-container><md-input-container layout=\"column\"><span style=\"margin-bottom: 5px;\">Tipo de título</span><md-radio-group ng-model=\"vm.type_bill\" layout=\"row\"><md-radio-button ng-value=\"\'receive\'\">Titulo a receber</md-radio-button><md-radio-button ng-value=\"\'pay\'\">Titulo a pagar</md-radio-button><md-radio-button ng-value=\"\'all_type\'\">Todos os tipos</md-radio-button></md-radio-group></md-input-container><md-input-container layout=\"column\"><span style=\"margin-bottom: 5px;\">Status dos títulos</span><md-radio-group ng-model=\"vm.status\" layout=\"row\"><md-radio-button ng-value=\"\'PAIDS\'\">Todos os status</md-radio-button><md-radio-button ng-value=\"\'PARTIAL_PAIDS\'\">Parcialmente pagos</md-radio-button></md-radio-group></md-input-container></md-dialog-content></md-card><md-dialog-actions layout=\"row\" layout-align=\"center center\" style=\"background-color: whitesmoke; margin-top: 20px;\"><md-button class=\"md-raised md-primary\" style=\"padding: 5px;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReportPDF()\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>Imprimir relatório em PDF</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/products-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de produtos avulsos</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 50%;\"><div layout=\"row\" flex=\"100\"><md-input-container flex=\"\"><md-select ng-model=\"vm.product_selected\"><md-option ng-value=\"null\">Todos</md-option><md-option ng-repeat=\"product in vm.products\" ng-value=\"product.id\">{{product.name}}</md-option></md-select></md-input-container><date-range-picker flex=\"\" ng-model=\"vm.filter_date\" label=\"Faixa de datas do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-click=\"vm.disable = false\"></date-range-picker></div><div flex=\"100\" ng-if=\"vm.current_school_period_id !== null\"><div layout=\"row\" style=\"border-left: solid 4px rgb(8,204,117);margin-left: 10px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Curso e Turma</b> <small>Abaixo se encontra cursos e turmas.<br><br><b>ATENÇÃO</b> o periodo letívo selecionado no educacional interfere na busca das inadimplências utilizando as opções abaixo. Período letivo selecionado: <b>{{vm.current_school_period_name}}</b></small></div></div><div flex=\"\" layout=\"row\" class=\"md-padding\"><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\" ng-required=\"vm.products_report.bank_slip_rule_id === null\"><label>Curso</label><md-icon md-font-icon=\"icon-group\"></md-icon><md-select name=\"group_service_list\" ng-model=\"vm.products_report.product_group_id\" aria-label=\"Curso\" md-on-open=\"vm.allProductGroups()\" ng-change=\"vm.getProductsByGroup(vm.products_report.product_group_id)\"><md-optgroup label=\"Curso\"><md-option ng-repeat=\"product_group in vm.product_groups track by $index\" ng-value=\"product_group.id\">{{product_group.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block md-input-has-placeholder\" ng-required=\"vm.products_report.bank_slip_rule_id === null\"><label>Turma</label><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><md-select name=\"service_list\" ng-model=\"vm.products_report.product_ids\" multiple=\"\" ng-required=\"vm.products_report.product_group_id !== undefined\" ng-disabled=\"vm.products_report.product_group_id == null\" ng-change=\"vm.setProducts(vm.products_report.product_ids)\" aria-label=\"turmas\"><md-optgroup label=\"Turmas\"><md-option ng-repeat=\"product in vm.products track by $index\" ng-value=\"product.group_id\">{{product.group_name}}</md-option></md-optgroup></md-select><div ng-messages=\"bankslipform.service_list.$error\"><div ng-message=\"required\">Você <b>deve</b> selecionar um ou mais turmas.</div></div></md-input-container></div></div></md-dialog-content></md-card><md-dialog-actions layout=\"row\" layout-align=\"center center\" style=\"background-color: whitesmoke;\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReport(false)\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>Imprimir relatório em PDF</md-button><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReport(true)\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>Imprimir em CSV</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/reverse-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-outbox\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de estornos</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 50%; height: 100px;\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de datas do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-click=\"vm.disable = false\"></date-range-picker></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-outbox\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/undo-check-pad-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-rotate-left\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de desfazimento de comandas</div></div></md-toolbar><md-card layout-padding=\"\"><md-card layout-align=\"center center\"><md-dialog-content layout=\"column\" style=\"width: 50%; height: 100px;\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de datas do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-click=\"vm.disable = false\"></date-range-picker></md-dialog-content></md-card><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-disabled=\"vm.disable\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-rotate-left\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/finance/reports/undo-movements-report/views/index.html","<md-toolbar class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><button class=\"goto-products-button md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"Go to current accounts\" ui-sref=\"private.finance.finance-reports.list\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" role=\"img\" aria-hidden=\"true\"></md-icon></button></div><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-icon md-font-icon=\"icon-rotate-left\" class=\"s24\"></md-icon></div><div class=\"logo-text\" style=\"font-size: 25px\">Relatório de desfazimento de movimentos em conta corrente</div></div></md-toolbar><md-card layout-padding=\"\"><div layout=\"row\"><md-input-container flex=\"50\" class=\"md-block md-input-has-placeholder\"><label>Conta corrente</label><md-icon md-font-icon=\"icon-chair-school\"></md-icon><md-select name=\"current_account\" ng-model=\"vm.current_account\"><md-option ng-repeat=\"account in vm.all_accounts track by $index\" ng-value=\"account.id\">{{account.name}}</md-option></md-select></md-input-container><md-dialog-content style=\"width: 15%; height: 50px;\"><date-range-picker flex=\"100\" ng-model=\"vm.filter_date\" label=\"Faixa de datas do relatório\" placeholder-start=\"Data inicial\" placeholder-end=\"Data final\" ng-click=\"vm.disable = false\"></date-range-picker></md-dialog-content></div><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"><md-button class=\"md-raised md-primary\" align=\"right\" style=\"padding: 5px; margin-left: 40%;\" ng-disabled=\"vm.current_account == null\" ng-click=\"vm.generateReport()\"><md-icon md-font-icon=\"icon-rotate-left\"></md-icon>Imprimir relatório</md-button></md-dialog-actions></md-card>");
$templateCache.put("app/controlpanel/central-reports/define-details-wizard/steps/classification/classification.html","<hr><form name=\"form_wizard_classification\" novalidate=\"\" ng-submit=\"vm.submit(\'classification\')\"><md-content style=\"padding-left: 25px;padding-bottom: 25px\"><div flex=\"\" layout=\"row\" style=\"border-left: solid 4px rgb(0,0,0); margin-bottom: 20px;margin-top: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Ordenação por colunas</b> <small>Selecione abaixo por qual coluna deseja ordenar</small></div></div><div layout=\"row\"><md-card flex=\"\" class=\"md-padding\" layout=\"column\" style=\"margin-top: 0;margin-left: 0 !important;padding-top: 0;\" ng-repeat=\"(key, list) in vm.data.lists\"><md-card-content style=\"max-height: 350px; overflow-y: auto;\"><div class=\"simpleDemo\"><ul dnd-list=\"list\"><li ng-repeat=\"item in list\" dnd-draggable=\"item\" dnd-dragstart=\"onDragstart(list, event)\" dnd-dragend=\"onDragend(list, event)\" dnd-selected=\"onItemDragSelected(list, event)\" dnd-moved=\"list.splice($index, 1)\" dnd-effect-allowed=\"move\" ng-class=\"{\'selected\': vm.data.selected === item}\"><p style=\"margin: 0;\"><a4-switch-button flex=\"\" states=\"vm.buttonStates\" ng-if=\"item.choice\" style=\"text-align: right\" data-ng-model=\"item.direction\"></a4-switch-button><span flex=\"\">{{item.presentation}}</span></p></li></ul></div></md-card-content></md-card></div></md-content></form>");
$templateCache.put("app/controlpanel/central-reports/define-details-wizard/steps/columns/columns.html","<hr><form name=\"form_wizard_columns\" novalidate=\"\" ng-submit=\"vm.submit(\'columns\')\"><md-content style=\"padding-left: 25px;padding-bottom: 25px\"><div layout=\"row\"><div flex=\"\" layout=\"row\" style=\"border-left: solid 4px rgb(0,0,0); margin-bottom: 20px;margin-top: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Colunas Disponíveis</b> <small>Abaixo selecione as colunas que deseja mostrar na visão</small></div></div><div flex=\"\" layout=\"row\" style=\"border-left: solid 4px rgb(0,0,0); margin-bottom: 20px;margin-top: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Colunas selecionadas</b> <small>Para remove-las arraste de volta para o outro lado</small></div></div></div><div layout=\"row\"><md-card flex=\"\" class=\"md-padding\" layout=\"column\" style=\"margin-top: 0;margin-left: 0 !important;padding-top: 0;\" ng-repeat=\"(key, list) in vm.data.lists\"><md-card-content style=\"max-height: 350px; overflow-y: auto;\"><div class=\"simpleDemo\"><ul dnd-list=\"list\"><li ng-repeat=\"item in list track by $index\" dnd-draggable=\"item\" dnd-dragstart=\"onDragstart(list, event)\" dnd-moved=\"list.splice($index, 1)\" dnd-effect-allowed=\"move\" dnd-selected=\"vm.data.selected = item\" ng-class=\"{\'selected\': vm.data.selected === item}\">{{item.presentation}}</li></ul></div></md-card-content></md-card></div></md-content></form>");
$templateCache.put("app/controlpanel/central-reports/define-details-wizard/steps/description/description.html","<hr><form name=\"form_wizard_description\" novalidate=\"\" ng-submit=\"vm.submit(\'description\', form_wizard_description)\"><md-content style=\"padding-left: 25px;padding-bottom: 25px\" layout=\"column\"><md-card class=\"md-padding\" style=\"margin-left: 0 !important; padding: 0\"><md-card-content><div layout=\"row\" class=\"md-primary\" style=\"border-left: solid 4px rgb(0,0,0); margin-bottom: 10px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Nome e Modelo do Relatório</b> <small>Defina abaixo o nome e modelo do relatório</small></div></div><md-input-container style=\"width: 100%;\"><input type=\"text\" required=\"\" name=\"name\" ng-model=\"vm.name\" ng-change=\"vm.setName(vm.name)\" placeholder=\"Nome\"><div ng-messages=\"form_wizard_description.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Você <b>deve</b> definir um nome para o relatório.</span></div></div></md-input-container><md-radio-group layout=\"column\" ng-disabled=\"true\" ng-model=\"vm.type\" ng-change=\"vm.setType(vm.type)\" layout-align=\"space-between\"><md-radio-button flex=\"\" value=\"0\">Sintético</md-radio-button><md-radio-button flex=\"\" value=\"1\">Detalhado</md-radio-button></md-radio-group><div layout=\"row\" style=\"border-left: solid 4px rgb(0,0,0); margin-bottom: 10px;margin-top: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Tabela Principal</b> <small>Define a partir grupo de dados será montado o relatório</small></div></div><md-input-container style=\"width: 100%;\"><md-select ng-model=\"vm.master\" ng-change=\"vm.setColumns()\" name=\"master_field\" ng-disabled=\"!details.item.is_editable\" required=\"\"><md-option ng-repeat=\"item in vm.masters\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div ng-messages=\"form_wizard_description.master_field.$error\" role=\"alert\"><div ng-message=\"required\"><span>Você <b>deve</b> definir uma tabela principal para o relatório.</span></div></div></md-input-container></md-card-content></md-card></md-content></form>");
$templateCache.put("app/controlpanel/central-reports/define-details-wizard/steps/filter/filter.html","<hr><style>\n  .icon-trash-filter {\n    font-size: 150px;\n    line-height: normal !important;\n    margin-left: 15px;\n  }\n\n  .icon-trash-filter:active {\n    color: red;\n  }\n</style><script type=\"text/ng-template\" id=\"list.html\"><ul dnd-list=\"list\" dnd-drop=\"vm.onDropFilterItem(list, item, index)\"> <li ng-repeat=\"item in list\" dnd-draggable=\"item\" dnd-selected=\"onItemDragSelected(list, event)\" dnd-selected=\"vm.models.selected = item\" dnd-effect-allowed=\"move\" dnd-moved=\"list.splice($index, 1)\" ng-class=\"{selected: vm.models.selected === item}\" ng-include=\"item.type + \'.html\'\"> </li> </ul></script><script type=\"text/ng-template\" id=\"container.html\"><div class=\"container-element box box-blue\"> <h3>{{item.label}}</h3> <div class=\"row\" ng-repeat=\"list in item.columns\" ng-include=\"\'list.html\'\"></div> <div class=\"clearfix\"></div> </div></script><script type=\"text/ng-template\" id=\"dropzone.html\"><div class=\"container-element box box-blue\"> <h3>{{item.label}}</h3> <div class=\"column\" ng-repeat=\"list in item.columns\" ng-include=\"\'list.html\'\"></div> <div class=\"clearfix\"></div> </div></script><script type=\"text/ng-template\" id=\"item.html\"><div class=\"item\"> {{item.column.presentation}} {{item.operator.value == \'between\' ? \'\' : item.operator.name}} {{ item.report_on_print ? (item.operator.value == \'between\' ? \'de ? até ?\': \' ?\') : (item.operator.value == \'between\' ? \'de \' + item.filter_value_start + \' até \' + item.filter_value_end : item.filter_value_start)}} <!--{{item.label}}--> </div></script><form name=\"form_wizard_filter\" novalidate=\"\" ng-submit=\"vm.submit(\'filter\')\"><md-content style=\"padding-left: 25px;padding-bottom: 25px\"><div layout=\"row\" style=\"border-left: solid 4px rgb(0,0,0); margin-bottom: 20px;margin-top: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Definição de Filtros</b> <small>Criação de filtros para o relatório</small></div></div><div layout=\"row\"><md-card flex=\"\" class=\"md-padding\" layout=\"column\" style=\"height: 300px;margin-top: 0;margin-left: 0 !important;padding-top: 0;\"><md-card-content style=\"max-height: 350px; overflow-y: auto;\"><div class=\"simpleDemo\"><ul dnd-list=\"vm.data.lists.available\"><li ng-repeat=\"item in vm.data.lists.available\" dnd-draggable=\"item\" dnd-moved=\"list.splice($index, 1)\" dnd-effect-allowed=\"move\" dnd-selected=\"vm.onItemSelectedFilter(event, item)\" dnd-disable-if=\"true\" ng-class=\"{\'selected\': vm.data.selected === item}\">{{item.presentation}}</li></ul></div></md-card-content></md-card><md-card flex=\"\" class=\"md-padding\" layout=\"column\" style=\"margin-left: 0 !important;margin-top: 0;padding-top: 0;\"><md-card-content layout=\"row\" layout-wrap=\"\"><md-input-container flex=\"100\"><label>Operador</label><md-select ng-model=\"vm.operator\"><md-option ng-repeat=\"operator in vm.operators\" ng-value=\"operator\">{{operator.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" ng-if=\"!vm.report_on_print && (vm.data.selected.type == \'list\' || vm.data.selected.type == \'list_name\') && (vm.operator.value !== \'=N\' && vm.operator.value !== \'=NN\')\"><label>{{vm.data.selected.presentation}}</label><md-select ng-model=\"vm.filter_value_start\" ng-init=\"vm.getDataFromRequestRoute(vm.data.selected)\"><md-option ng-repeat=\"item in vm.data.selected.data_list\" ng-value=\"item.id\" ng-if=\"vm.data.selected.type == \'list\'\">{{item.name}}</md-option><md-option ng-repeat=\"item in vm.data.selected.data_list\" ng-value=\"item.name\" ng-if=\"vm.data.selected.type == \'list_name\'\">{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"40\" ng-if=\"!vm.report_on_print && vm.data.selected.type == \'text\' && (vm.operator.value !== \'=N\' && vm.operator.value !== \'=NN\')\"><label>Valor</label> <input ng-model=\"vm.filter_value_start\" type=\"text\" ng-disabled=\"vm.report_on_print\" autocomplete=\"off\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"40\" ng-if=\"!vm.report_on_print && (vm.data.selected.type == \'integer\' || vm.data.selected.type == \'numeric\' || (vm.operator.value == \'=D\' || vm.operator.value == \'=Y\')) && (vm.operator.value !== \'=N\' && vm.operator.value !== \'=NN\')\"><label>Valor (Apenas números)</label> <input ng-model=\"vm.filter_value_start\" type=\"number\" ng-disabled=\"vm.report_on_print\" autocomplete=\"off\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"40\" ng-if=\"!vm.report_on_print && (vm.data.selected.type == \'double\') && (vm.operator.value !== \'=N\' && vm.operator.value !== \'=NN\')\"><label>Valor</label> <input ng-model=\"vm.filter_value_start\" ui-money-mask=\"2\" ng-disabled=\"vm.report_on_print\" autocomplete=\"off\"></md-input-container><div ng-if=\"!vm.report_on_print && vm.operator.value == \'between\' && vm.data.selected.type !== \'date\'\" flex=\"20\" layout-align=\"start end\" style=\"padding-top: 30px; padding-left: 30px;\">até</div><md-input-container flex=\"100\" ng-if=\"!vm.report_on_print && vm.data.selected.type == \'date\' && vm.operator.value == \'=M\' && (vm.operator.value !== \'=N\' && vm.operator.value !== \'=NN\')\"><label>Mês</label><md-select ng-model=\"vm.filter_value_start\"><md-option ng-repeat=\"month in vm.months\" ng-value=\"month.id\">{{month.name}}</md-option></md-select></md-input-container><md-input-container ng-if=\"!vm.report_on_print && vm.operator.value == \'between\' && vm.data.selected.type == \'text\' && (vm.operator.value !== \'=N\' && vm.operator.value !== \'=NN\')\" flex=\"40\" class=\"md-input-has-placeholder\"><label>Valor</label> <input ng-model=\"vm.filter_value_end\" type=\"text\" autocomplete=\"off\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"40\" ng-if=\"!vm.report_on_print && vm.operator.value == \'between\' && vm.data.selected.type == \'integer\' && (vm.operator.value !== \'=N\' && vm.operator.value !== \'=NN\')\"><label>Valor (Apenas números)</label> <input ng-model=\"vm.filter_value_end\" type=\"number\" ng-disabled=\"vm.report_on_print\" autocomplete=\"off\"></md-input-container><date-picker name=\"dob\" ng-model=\"vm.filter_value_start\" flex=\"40\" ng-if=\"vm.data.selected.type == \'date\' && (vm.operator.value !== \'=D\' && vm.operator.value !== \'=M\' && vm.operator.value !== \'=Y\')\" ng-disabled=\"vm.report_on_print\" placeholder=\"Data\"></date-picker><div ng-if=\"!vm.report_on_print && vm.operator.value == \'between\' && vm.data.selected.type == \'date\'\" flex=\"20\" layout-align=\"start end\" style=\"padding-top: 30px; padding-left: 30px;\">até</div><date-picker name=\"dob\" ng-model=\"vm.filter_value_end\" flex=\"40\" ng-if=\"vm.data.selected.type == \'date\' && (!vm.report_on_print && vm.operator.value == \'between\') && (vm.operator.value !== \'=N\' && vm.operator.value !== \'=NN\')\" ng-disabled=\"vm.report_on_print\" placeholder=\"Data\"></date-picker><div flex=\"100\" ng-if=\"vm.operator.value !== \'=N\' && vm.operator.value !== \'=NN\'\"><md-checkbox ng-model=\"vm.report_on_print\" ng-change=\"vm.filter_value_start = \'?\'; vm.filter_value_end = \'?\'\">Informar no momento da impressão</md-checkbox></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end end\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.addFilter()\" ng-disabled=\"form_wizard_filter.$invalid\">Adicionar</md-button></md-card-actions></md-card></div><div layout=\"row\" style=\"border-left: solid 4px rgb(0,0,0); margin-bottom: 20px;margin-top: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Filtros</b> <small>Abaixo de encontram filtros criados</small></div></div><div layout=\"row\"><md-card flex=\"\" layout=\"column\" style=\"margin-top: 0;margin-left: 0 !important;padding-top: 0;width: 100%\"><md-card-content><div layout=\"row\" class=\"nestedDemo\"><div flex=\"\" class=\"toolbox box box-grey box-padding\"><ul style=\"display: inline-flex;margin: 0;\"><li ng-repeat=\"item in vm.models.templates\" ng-if=\"item.id > 3\" dnd-draggable=\"item\" dnd-effect-allowed=\"copy\" dnd-copied=\"item.id = item.id + 1\"><button type=\"button\" class=\"md-button md-raised\" ng-click=\"$event.stopPropagtion()\" style=\"cursor: all-scroll;\">{{item.label}}</button></li></ul></div></div><div layout=\"row\"><div flex=\"\"><div layout=\"row\"><div ng-repeat=\"(zone, list) in vm.models.dropzones\" flex=\"\" class=\"nestedDemo\"><div class=\"dropzone box box-yellow\" style=\"padding: 0;margin: 0;height: 500px;\"><div ng-include=\"\'list.html\'\"></div></div></div></div><div view-source=\"nested\"></div></div><div flex=\"15\" class=\"nestedDemo\"><div flex=\"\" class=\"trashcan box box-grey box-padding\" style=\"padding: 0;margin: 0;\"><ul dnd-list=\"[]\" style=\"margin: 0;\" dnd-drop=\"vm.onTrashItem(list, item, index)\"><li><md-icon md-font-icon=\"icon-trash\" class=\"icon-trash-filter\"></md-icon></li></ul></div></div></div></md-card-content></md-card></div></md-content></form>");
$templateCache.put("app/controlpanel/central-reports/define-details-wizard/steps/grouping/grouping.html","<hr><form name=\"form_wizard_grouping\" novalidate=\"\" ng-submit=\"vm.submit(\'grouping\')\"><md-content style=\"padding-left: 25px;padding-bottom: 25px\"><div flex=\"\" layout=\"row\" style=\"border-left: solid 4px rgb(0,0,0); margin-bottom: 20px;margin-top: 20px;\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px;\"><b>Agrupamento por colunas (Quebra)</b> <small>Selecione abaixo por quais colunas deseja agrupar a visão</small></div></div><div layout=\"row\"><md-card flex=\"\" class=\"md-padding\" layout=\"column\" style=\"margin-top: 0;margin-left: 0 !important;padding-top: 0;\" ng-repeat=\"(key, list) in vm.data.lists\"><md-card-content style=\"max-height: 350px; overflow-y: auto;\"><div class=\"simpleDemo\"><ul dnd-list=\"list\"><li ng-repeat=\"item in list\" dnd-draggable=\"item\" dnd-dragstart=\"onDragstart(list, event)\" dnd-dragend=\"onDragend(list, event)\" dnd-selected=\"onItemDragSelected(list, event)\" dnd-moved=\"list.splice($index, 1)\" dnd-effect-allowed=\"move\" ng-class=\"{\'selected\': vm.data.selected === item}\"><p style=\"margin: 0;\"><md-checkbox ng-model=\"item.grouping\" ng-if=\"item.choice && (item.grouping || !vm.has_break)\" ng-change=\"vm.has_break = !vm.has_break\">Quebra de página? |</md-checkbox><span flex=\"\">{{item.presentation}}</span></p></li></ul></div></md-card-content></md-card></div></md-content></form>");
$templateCache.put("app/educational/course/matrix/views/dialogs/add-subject-requirement.html","<md-dialog class=\"check-received\" aria-label=\"{{ vm.data.title }}\" style=\"max-width: 1000px; width: 1000px\" md-theme=\"educational\"><form name=\"retrieveForm\" ng-submit=\"vm.answer(vm.obj, retrieveForm)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ vm.data.title }}</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"check-dialog\"><h3>Disciplinas disponíveis</h3><md-divider></md-divider><div class=\"content layout-column\"><div layout=\"column\"><md-table-container class=\"overflow-table-a4\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"vm.obj.subjectList\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getDesserts\"><tr md-row=\"\"><th md-column=\"\">Nome</th><th md-column=\"\">Apelido</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"item\" md-select-id=\"id\" md-auto-select=\"\" ng-repeat=\"item in vm.data.subjectAvailable\"><td md-cell=\"\">{{item.name}}</td><td md-cell=\"\">{{item.alias}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"[1000]\" md-page=\"vm.query.page\" md-total=\"{{vm.data.subjectAvailable.length}}\" md-on-paginate=\"vm.setDataPerPage\" md-label=\"{page: \'Página:\', rowsPerPage: \'Registros por página:\', of: \'de\'}\" md-page-select=\"\"></md-table-pagination></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button type=\"submit\" style=\"margin-right:20px;\">Confirmar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/course/matrix/views/forms/add-sub-subject.html","<div style=\"width: 700px;\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\'MATRIX.SUBJECT.INSERT_SUB\' | translate }} <span ng-if=\"vm.objperiod.period > 0\">no {{vm.objperiod.period}}º Periodo:</span></span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Geral\"><md-content class=\"md-padding\"><form name=\"form_subject\"><md-autocomplete md-selected-item=\"vm.subject\" md-selected-item-change=\"vm.setSubject()\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" placeholder=\"Selecione uma disciplina\" ng-if=\"!vm.is_edit\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template></md-autocomplete><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container md-no-float=\"\" class=\"md-block md-input-has-placeholder\" flex=\"100\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" ng-if=\"vm.is_edit\"><label>Disciplina</label> <input type=\"text\" ng-model=\"vm.form.subject_period.name\" disabled=\"\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Ordem</label> <input ng-model=\"vm.form.subject_period.ord\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Carga horária</label> <input ng-model=\"vm.form.subject_period.course_load\" type=\"number\" placeholder=\"Ex: 45\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Peso</label> <input ng-model=\"vm.form.subject_period.weight\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Material didático</label> <input ng-model=\"vm.form.subject_period.courseware\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Conteúdo programático</label> <input ng-model=\"vm.form.subject_period.syllabus\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><md-checkbox ng-model=\"vm.form.subject_period.dont_fail\">Não reprova</md-checkbox></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"50\"><md-checkbox ng-model=\"vm.form.subject_period.show_on_documents\">Mostrar em documentos?</md-checkbox></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"50\"><md-checkbox ng-model=\"vm.form.subject_period.show_on_report\">Mostrar no boletim?</md-checkbox></md-input-container></md-content></form><div layout=\"row\" layout-align=\"end center\" style=\"margin-top: -15px;\"><md-button class=\"md-raised\" ng-click=\"vm.submit(vm.form.subject_period, form_subject)\"><md-icon md-font-icon=\"icon-check\"></md-icon>Salvar</md-button></div></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/course/matrix/views/forms/add-subject.html","<div style=\"width: 700px;\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><span ng-if=\"vm.is_edit\">{{\'MATRIX.SUBJECT.EDIT\' | translate }}</span> <span ng-if=\"!vm.is_edit\">{{\'MATRIX.SUBJECT.INSERT\' | translate }}</span> <span ng-if=\"vm.objperiod.period > 0\">no {{vm.objperiod.period}}º Periodo:</span></span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Geral\"><md-content class=\"md-padding\"><form name=\"form_subject\"><md-autocomplete md-selected-item=\"vm.subject\" md-selected-item-change=\"vm.setSubject()\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" placeholder=\"Selecione uma disciplina\" ng-if=\"!vm.is_edit\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template></md-autocomplete><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container md-no-float=\"\" class=\"md-block md-input-has-placeholder\" flex=\"100\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" ng-if=\"vm.is_edit\"><label>Disciplina</label> <input type=\"text\" ng-model=\"vm.form.subject_period.name\" disabled=\"\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Ordem</label> <input ng-model=\"vm.form.subject_period.ord\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\" ng-if=\"vm.is_superior_course\"><label>Peso</label> <input ng-model=\"vm.form.subject_period.weight\"></md-input-container><md-input-container flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\" ng-if=\"vm.is_superior_course\"><label>Obrigatoriedade</label><md-select ng-model=\"vm.form.subject_period.how_required\"><md-option ng-repeat=\"item in vm.list.subject_period.how_required\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Carga horária</label> <input ng-model=\"vm.form.subject_period.course_load\" type=\"number\" placeholder=\"Ex: 45\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\" ng-if=\"vm.is_superior_course\"><label>Crédito</label> <input ng-model=\"vm.form.subject_period.credit\" type=\"number\" placeholder=\"Ex: 3\"></md-input-container><md-input-container flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Método de avaliação</label><md-select ng-model=\"vm.form.subject_period.evaluation_mode\"><md-option ng-repeat=\"item in vm.list.subject_period.evaluation_mode\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\" ng-if=\"vm.is_superior_course\"><label>Qtd de horas práticas</label> <input ng-model=\"vm.form.subject_period.practice_hours\" type=\"number\" placeholder=\"Ex: 15\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Material didático</label> <input ng-model=\"vm.form.subject_period.courseware\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"100\" ng-if=\"vm.form.subject_period.evaluation_mode === 2\"><label>Critério de conceito</label><md-select ng-model=\"vm.form.subject_period.evaluation_code_system_id\"><md-option ng-repeat=\"criteria in vm.grade_code_rules\" ng-value=\"criteria.id\">{{criteria.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\" ng-if=\"vm.is_superior_course\"><label>Carga horária de estágio</label> <input ng-model=\"vm.form.subject_period.internship_hours\" placeholder=\"Ex: 100\" type=\"number\"></md-input-container><md-input-container flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"50\"><label>Periodo</label><md-select ng-model=\"vm.form.subject_period.matrix_period\"><md-option ng-repeat=\"matrix in vm.matrix.matrix_period\" ng-value=\"matrix.matrix_period\">{{matrix.matrix_period}}</md-option></md-select></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"100\"><label>Conteúdo programático</label> <input ng-model=\"vm.form.subject_period.syllabus\"></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"50\"><md-checkbox ng-model=\"vm.form.subject_period.dont_fail\">Não reprova</md-checkbox></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"50\"><md-checkbox ng-model=\"vm.form.subject_period.dont_grade_recovery\">Tem prova final e recuperação?</md-checkbox></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"50\"><md-checkbox ng-model=\"vm.form.subject_period.dont_calc\">Não calcular médias?</md-checkbox></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"50\"><md-checkbox ng-model=\"vm.form.subject_period.show_on_documents\">Mostrar em documentos?</md-checkbox></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex=\"50\"><md-checkbox ng-model=\"vm.form.subject_period.show_on_report\">Mostrar no boletim?</md-checkbox></md-input-container></md-content></form><div layout=\"row\" layout-align=\"end center\" style=\"margin-top: -15px;\"><md-button class=\"md-raised\" ng-click=\"vm.submit(vm.form.subject_period, form_subject)\"><md-icon md-font-icon=\"icon-check\"></md-icon>Salvar</md-button><md-button class=\"md-raised\" ng-click=\"vm.onSaveAndContinue(true); vm.submit(vm.form.subject_period, form_subject)\"><md-icon md-font-icon=\"icon-check\"></md-icon>Salvar e editar</md-button><md-button class=\"md-raised\" ng-click=\"vm.onSaveAndAddMore(true); vm.submit(vm.form.subject_period, form_subject)\"><md-icon md-font-icon=\"icon-check\"></md-icon>Salvar e adicionar +</md-button></div></md-content></md-tab><md-tab label=\"Requisitos\" ng-if=\"vm.is_superior_course\"><md-content class=\"md-padding\"><table class=\"simple\" ng-if=\"vm.list.subject_requirement.length\"><thead><tr><th colspan=\"2\">Nome</th><th>Apelido</th><th>Tipo de requisito</th></tr></thead><tfoot></tfoot><tbody><tr ng-repeat=\"item in vm.list.subject_requirement\"><td colspan=\"2\">{{ item.name }}</td><td>{{ item.alias }}</td><td>{{ vm.subject_requirement_text(item.requirement_type) }}</td></tr></tbody></table><div layout=\"row\" layout-sm=\"column\" layout-align=\"end center\" layout-wrap=\"\"><md-button class=\"md-raised\" ng-click=\"vm.addPreRequisite()\"><md-icon>bookmark</md-icon>Pré-requisitos</md-button><md-button class=\"md-raised\" ng-click=\"vm.addCoRequisite()\"><md-icon>bookmark_border</md-icon>Co-requisitos</md-button></div></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/course/matrix/views/forms/create-decision.html","<md-dialog aria-label=\"Create Lesson Plan Item\" md-theme=\"educational\"><form ng-cloak=\"\" ng-submit=\"vm.submit()\" name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Criar nova grade</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><strong class=\"group-field\"><small>Escolha a opção de criação da grade</small></strong><div layout=\"row\" layout-align=\"center center\"><md-list flex=\"\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><md-list-item flex=\"50\"><div class=\"md-grid-item-content\" ng-click=\"vm.closeModal(false)\"><div class=\"md-grid-text\">Criar nova</div></div></md-list-item><md-list-item flex=\"50\"><div class=\"md-grid-item-content\" ng-click=\"vm.closeModal(true)\"><div class=\"md-grid-text\">Duplicar selecionada</div></div></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"background-color: whitesmoke\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/course/matrix/views/forms/edit-period.html","<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\'MATRIX.EDIT_PERIOD\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content class=\"md-padding\"><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.submit(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/course/matrix/form-period.json\" flex=\"40\"></a4-form-dic-data></md-content>");
$templateCache.put("app/educational/course/matrix/views/forms/edit-subject.html","<div style=\"width: 700px;\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\'MATRIX.SUBJECT.EDIT\' | translate }} <span ng-if=\"vm.objperiod.period > 0\">no {{vm.objperiod.period}}º Periodo:</span></span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Geral\"><md-content class=\"md-padding\"><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\"><md-input-container md-no-float=\"\" class=\"md-block md-input-has-placeholder\" flex=\"100\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" style=\"margin: 0; bottom: -10px;\"><label>Disciplina</label> <input type=\"text\" ng-model=\"vm.form.subject_period.name\" disabled=\"\"></md-input-container></md-content><a4-form-dic-data bind=\"vm.form\" list=\"vm.list\" on-submit=\"vm.editSubjectPeriod(item, form)\" on-close=\"vm.close()\" fields-schema=\"app/educational/course/matrix/edit-subject-form.json\" flex=\"40\"></a4-form-dic-data></md-content></md-tab><md-tab label=\"Requisitos\" ng-if=\"vm.is_superior_course\"><md-content class=\"md-padding\"><table class=\"simple\" ng-if=\"vm.list.subject_requirement.length\"><thead><tr><th colspan=\"2\">Nome</th><th>Apelido</th><th>Tipo de requisito</th></tr></thead><tfoot></tfoot><tbody><tr ng-repeat=\"item in vm.list.subject_requirement\"><td colspan=\"2\">{{ item.name }}</td><td>{{ item.alias }}</td><td>{{ vm.subject_requirement_text(item.requirement_type) }}</td></tr></tbody></table><div layout=\"row\" layout-sm=\"column\" layout-align=\"end center\" layout-wrap=\"\"><md-button class=\"md-raised\" ng-click=\"vm.addPreRequisite()\"><md-icon>bookmark</md-icon>Pré-requisitos</md-button><md-button class=\"md-raised\" ng-click=\"vm.addCoRequisite()\"><md-icon>bookmark_border</md-icon>Co-requisitos</md-button></div></md-content></md-tab><md-tab label=\"Equivalência\" ng-if=\"1 == 0\"><md-content class=\"md-padding\"><h1 class=\"md-display-2\">Tab Three</h1><p>Integer turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.</p></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/educational/course/matrix/views/forms/form-matrix.html","<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.form.matrix.id == null\">{{\'MATRIX.FORM_CREATE\' | translate }}</span> <span class=\"title\" ng-show=\"vm.form.matrix.id != null && !vm.disabled_duplicate\">{{\'MATRIX.FORM_EDIT\' | translate }}</span> <span class=\"title\" ng-show=\"vm.form.matrix.id != null && vm.disabled_duplicate\">{{\'MATRIX.FORM_DUPLICATE\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content class=\"md-padding\"><form name=\"matrixForm\" novalidate=\"\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244);\" ng-if=\"vm.form.matrix.id == null\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Criação de grade curricular</b> <small>Determine os detalhes da nova grade curricular</small></div></div><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244);\" ng-if=\"vm.form.matrix.id != null\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b ng-if=\"!vm.disabled_duplicate\">Edição de grade curricular</b> <b ng-if=\"vm.disabled_duplicate\">Duplicação de grade curricular</b> <small>Edite os detalhes da grade curricular</small></div></div><div layout=\"row\" flex=\"\" style=\"padding-top: 10px;\"><md-input-container flex=\"50\"><label>Nome</label> <input type=\"text\" ng-model=\"vm.form.matrix.name\" name=\"name\" placeholder=\"Ex: Grade 2019\" required=\"\"><div ng-messages=\"matrixForm.name.$error\"><div ng-message=\"required\">Nome da grade é obrigatório</div></div></md-input-container><date-picker ng-model=\"vm.form.matrix.creation_date\" placeholder=\"Data de criação\" flex=\"50\"></date-picker></div><div layout=\"row\" flex=\"\"><md-input-container flex=\"50\"><label>Carga horária</label> <input type=\"number\" ng-model=\"vm.form.matrix.course_load\" placeholder=\"Ex: 65\"></md-input-container><md-input-container flex=\"50\"><label>Créditos</label> <input type=\"number\" ng-model=\"vm.form.matrix.credits\"></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container flex=\"50\"><label>Horas de atividade extra</label> <input type=\"number\" ng-model=\"vm.form.matrix.extra_activity_hours\"></md-input-container><md-input-container flex=\"50\"><label>Qtd mínima de opcionais</label> <input type=\"number\" ng-model=\"vm.form.matrix.min_optional_subjects\"></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container flex=\"50\"><label>Qtd máxima de opcionais</label> <input type=\"number\" ng-model=\"vm.form.matrix.max_optional_subjects\"></md-input-container><md-input-container flex=\"50\"><label>Qtd mínima de eletivas</label> <input type=\"number\" ng-model=\"vm.form.matrix.min_elective_subjects\"></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container flex=\"50\"><label>Qtd máxima de eletivas</label> <input type=\"number\" ng-model=\"vm.form.matrix.max_elective_subjects\"></md-input-container><md-input-container flex=\"50\" required=\"\"><label>Qtd de períodos</label> <input type=\"number\" ng-model=\"vm.form.matrix.period_qty\" name=\"matrix_qty\"><div ng-messages=\"matrixForm.period_qty.$error\"><div ng-message=\"required\">Quantidade de períodos é obrigatória</div></div></md-input-container></div><div layout=\"row\" flex=\"\"><md-checkbox ng-model=\"vm.form.matrix.is_subject_enrolment\">Matrícula em disciplinas</md-checkbox></div><div ng-if=\"vm.school_period_serie_id == 0 || vm.form.matrix.course_equivalence_id >= 300\"><div layout=\"row\" style=\"border-left: solid 4px rgb(3,169,244);\"><div flex=\"\" layout=\"column\" style=\"margin-left: 5px\"><b>Configuração de contratos</b> <small>Determine a forma de criação de contratos para este curso</small></div></div><div layout=\"column\"><div flex=\"\" layout=\"row\"><md-radio-group ng-model=\"vm.has_matrix_period\" style=\"padding-top: 10px;\"><md-radio-button ng-value=\"0\">Um único contrato financeiro para todos os períodos</md-radio-button><md-radio-button ng-value=\"1\">Um contrato financeiro para cada período</md-radio-button></md-radio-group></div></div></div><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-warm\" type=\"submit\" style=\"margin-left: 80%;\" ng-click=\"vm.submit(vm.form.matrix, matrixForm)\"><md-icon md-font-icon=\"icon-check\"></md-icon>Salvar</md-button></md-dialog-actions></form></md-content>");
$templateCache.put("app/educational/groups/timetable/views/dialogs/timetable-alert.html","<md-dialog aria-label=\"Edit Cell\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'TIMETABLE.ATTENTION\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><p>Você está tentando alterar uma grade de horário em uso. Qualquer alteração feita em uma grade de horária irá afetar todo o período correspondente à sua validade, incluindo o passado. Caso a sua alteração só deva ser válida a partir de uma data específica, duplique a última grade de horário, informe a data que ela deverá ser válida e altere-a.</p></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.scope.allowEditing()\"><md-icon>mode_edit</md-icon>Alterar o horário</md-button><md-button ng-click=\"vm.scope.duplicateTimetable();\"><md-icon>content_copy</md-icon>Duplicar o horário</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/groups/timetable/views/dialogs/timetable-change-initial-date.html","<md-dialog aria-label=\"Edit Cell\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Alteração de data inicial</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><date-picker ng-model=\"vm.scope.initial_date\" required=\"\" label=\"Data inicial\"></date-picker></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.closeModal()\">Cancelar</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.answer(vm.scope.initial_date)\" ng-disabled=\"vm.scope.initial_date == vm.scope.original_date\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/groups/timetable/views/dialogs/timetable-duplicate.html","<md-dialog aria-label=\"Edit Cell\" md-theme=\"educational\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'TIMETABLE.DUPLICATE\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container flex=\"\" ng-class=\"(vm.scope.timetable_duplicate.initial_date_error) ? \'md-input-invalid\': \'\'\"><label>Data inicial</label><md-datepicker ng-model=\"vm.scope.timetable_duplicate.initial_date\" required=\"\"></md-datepicker></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\"></md-icon>Cancelar</md-button><md-button ng-click=\"vm.scope.submitDuplicateTimetable();\" ng-disabled=\"vm.scope.timetable_duplicate.initial_date_error\"><md-icon ng-show=\"!$root.show_loader\">content_copy</md-icon><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular>Duplicar o horário</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/educational/groups/timetable/views/forms/form-timetable-cell.html","<md-dialog aria-label=\"Edit Cell\" md-theme=\"educational\" style=\"min-width: 600px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.form.timetable_item.id\">{{\'TIMETABLE_ITEM.FORM_CREATE\' | translate }}</h2><h2 ng-if=\"vm.form.timetable_item.id\">{{\'TIMETABLE_ITEM.FORM_EDIT\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div class=\"md-dialog-content\" layout=\"column\"><form name=\"timetable_item\"><md-dialog-content layout=\"column\"><md-input-container><label>Disciplina</label><md-select ng-model=\"vm.form.timetable_item.subject_id\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchSubject\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"subject in vm.list.timetable_item.subject_id | filter: searchSubject\" ng-value=\"subject.id\">{{subject.name}}</md-option></md-select></md-input-container><md-input-container><label>Professor</label><md-select ng-model=\"vm.form.timetable_item.person_id_teacher\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchTeacher\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"teacher in vm.list.timetable_item.person_id_teacher | filter: searchTeacher\" ng-value=\"teacher.id\">{{teacher.name}}</md-option></md-select></md-input-container><md-input-container><label>Sala</label><md-select ng-model=\"vm.form.timetable_item.location_id\"><md-select-header class=\"demo-select-header\"><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"searchLocation\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"location in vm.list.timetable_item.location_id | filter: searchLocation\" ng-value=\"location.id\">{{location.name}}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions style=\"text-align: right\"><md-button class=\"md-raised\" ng-click=\"vm.submit(vm.form.timetable_item, timetable_item)\" ng-disabled=\"timetable_item.$invalid || vm.disable\">Salvar</md-button></md-dialog-actions></form></div></md-dialog>");
$templateCache.put("app/educational/groups/timetable/views/forms/form-timetable.html","<md-dialog aria-label=\"Create TimetableTemplate\" md-theme=\"educational\"><form ng-cloak=\"\" id=\"formtimetable\" name=\"form_dynamic\" ng-submit=\"vm.submit(vm.form.timetable, form_dynamic)\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.timetable.is_edit\">{{\'TIMETABLE.FORM_CREATE\' | translate }}</h2><h2 ng-if=\"vm.timetable.is_edit\">{{\'TIMETABLE.FORM_EDIT\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content><md-input-container md-no-float=\"\" class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\" ng-if=\"!vm.timetable.is_edit\"><label>Template</label> <label></label><md-select ng-model=\"vm.form.timetable.timetable_template_id\" ng-change=\"vm.changeTimetable(vm.selected_timetable)\" required=\"\"><md-option ng-repeat=\"timetable_template_id in vm.list.timetable.timetable_template_id\" ng-value=\"timetable_template_id.id\">{{ timetable_template_id.name }}</md-option></md-select></md-input-container><md-input-container ng-class=\"(vm.form.initial_date_error) ? \'md-input-invalid\': \'\'\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label>Data inicial</label><md-datepicker ng-model=\"vm.form.timetable.initial_date\" required=\"\"></md-datepicker></md-input-container></md-content><br><div ng-if=\"vm.timetable.academic_type > 1\"><md-checkbox ng-model=\"vm.form.open_input\">Quero informar a data de interrupção da grade de horários.</md-checkbox><br><span style=\"font-weight: bold\">ATENÇÃO: A data de interrupção da grade de horários é uma situação especial e NÃO deve ser usada para quando há substituição para uma nova grade. Este recurso deve ser utilizado apenas quando uma turma específica tiver um período sem aulas entre duas grades de horários. Na dúvida não use.</span><md-input-container ng-if=\"vm.form.open_input\" ng-class=\"(vm.form.initial_date_error) ? \'md-input-invalid\': \'\'\" flex-gt-sm=\"\" flex-xs=\"\" flex-sm=\"\" flex-md=\"\" flex=\"\"><label style=\"width: 200px\">Data de interrupção</label><md-datepicker ng-model=\"vm.form.timetable.final_date\" required=\"\"></md-datepicker></md-input-container></div><md-content layout=\"row\" layout-xs=\"column\" class=\"md-padding\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-wrap=\"\" layout-align=\"end center\"><md-button ng-click=\"vm.close()\" class=\"md-raised\"><md-icon md-font-icon=\"icon-close\"></md-icon>Cancelar</md-button><md-button type=\"submit\" class=\"md-raised submit-button\" ng-disabled=\"vm.form.initial_date_error || form_dynamic.$invalid || $root.show_loader\"><md-progress-circular ng-show=\"$root.show_loader\" class=\"md-hue-2 submit-loading\" md-diameter=\"15px\"></md-progress-circular><md-icon ng-show=\"!$root.show_loader\" md-font-icon=\"icon-check\"></md-icon>Salvar</md-button></md-content></md-dialog-content></form></md-dialog>");}]);